'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var require$$1 = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var require$$1__default = /*#__PURE__*/_interopDefaultLegacy(require$$1);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign$1.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

function __spreadArray$1(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  var f = n.default;
	if (typeof f == "function") {
		var a = function () {
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var classnames = {exports: {}};

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
} (classnames));

var cx = classnames.exports;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$F = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.typography__h1 {\n  font: 3.5rem/3.5rem \"Work Sans\", sans-serif;\n}\n.typography__h2 {\n  font: 2.5rem/2.5rem \"Work Sans\", sans-serif;\n}\n.typography__h3 {\n  font: 2rem/2rem \"Work Sans\", sans-serif;\n}\n.typography__h4 {\n  font: 1.5rem/1.5rem \"Work Sans\", sans-serif;\n}\n.typography__exercise-s {\n  font: 1.5rem/2rem \"Lexend\", sans-serif;\n}\n.typography__exercise-m {\n  font: 1.75rem/3rem \"Lexend\", sans-serif;\n}\n.typography__exercise-l {\n  font: 2.5rem/3rem \"Lexend\", sans-serif;\n}\n.typography__exercise-xl {\n  font: 3rem/3.5rem \"Lexend\", sans-serif;\n}\n.typography__body {\n  font: 1.125rem/1.8125rem \"Lexend\", sans-serif;\n}\n.typography__button-link {\n  font: 1rem/1.25rem \"Lexend\", sans-serif;\n}\n.typography__label {\n  font: 0.875rem/1rem \"Lexend\", sans-serif;\n}\n.typography--color-primary {\n  color: black;\n}\n.typography--color-secondary {\n  color: #595959;\n}";
styleInject(css_248z$F);

var TypographyMap = {
    h1: {
        element: 'h1',
        class: 'typography__h1'
    },
    h2: {
        element: 'h2',
        class: 'typography__h2'
    },
    h3: {
        element: 'h3',
        class: 'typography__h3'
    },
    h4: {
        element: 'h4',
        class: 'typography__h4'
    },
    exerciseS: {
        element: 'p',
        class: 'typography__exercise-s'
    },
    exerciseM: {
        element: 'p',
        class: 'typography__exercise-m'
    },
    exerciseL: {
        element: 'p',
        class: 'typography__exercise-l'
    },
    exerciseXL: {
        element: 'p',
        class: 'typography__exercise-xl'
    },
    body: {
        element: 'p',
        class: 'typography__body'
    },
    button: {
        element: 'span',
        class: 'typography__button-link'
    },
    label: {
        element: 'label',
        class: 'typography__label'
    }
};
var Typography = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'body' : _b, children = _a.children, component = _a.component, className = _a.className, _c = _a.color, color = _c === void 0 ? 'primary' : _c, rest = __rest(_a, ["variant", "children", "component", "className", "color"]);
    var HtmlComponent = component ? component : TypographyMap[variant].element;
    var classes = cx(TypographyMap[variant].class, "typography--color-".concat(color), className);
    return (React__default["default"].createElement(HtmlComponent, __assign$1({ className: classes }, rest), children));
};

var css_248z$E = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.button--small {\n  font: 1rem/1.25rem \"Lexend\", sans-serif;\n  padding: 9px 12px 11px 12px;\n  border-radius: 14px;\n}\n.button--small svg {\n  width: 18px;\n  height: 18px;\n}\n.button--default {\n  font: 1rem/1.25rem \"Lexend\", sans-serif;\n  padding: 18px 20px;\n  border-radius: 20px;\n}\n.button--default svg {\n  width: 25px;\n  height: 25px;\n}\n.button--color-default.button--filled {\n  color: black !important;\n  background-color: #ffdc4a;\n  transition: 150ms all;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n  box-shadow: 0 4px #caa300;\n}\n.button--color-default.button--filled > span {\n  color: black !important;\n}\n.button--color-default.button--filled:active {\n  box-shadow: 0 2px #caa300;\n  transform: translateY(2px);\n}\n.button--color-default.button--filled:disabled {\n  box-shadow: 0 4px #acacac;\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-default.button--filled:disabled span {\n  color: grey !important;\n}\n.button--color-default.button--filled:disabled svg {\n  fill: grey !important;\n}\n.button--color-default.button--filled > svg {\n  fill: black !important;\n}\n.button--color-default.button--outlined {\n  color: black;\n  background-color: white;\n  border: solid 2px #ececec;\n  transition: 150ms all;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n  box-shadow: 0 4px #ececec;\n}\n.button--color-default.button--outlined:active {\n  box-shadow: 0 2px #ececec;\n  transform: translateY(2px);\n}\n.button--color-default.button--outlined:disabled {\n  box-shadow: 0 4px #ececec;\n  border: solid 2px #ececec;\n  color: #ececec !important;\n}\n.button--color-default.button--outlined:disabled svg {\n  fill: #ececec !important;\n}\n.button--color-default.button--outlined:disabled span {\n  color: #ececec !important;\n}\n.button--color-default.button--outlined > svg {\n  fill: black !important;\n}\n.button--color-default.button--flat {\n  color: black !important;\n  background-color: #f3f7ff;\n  transition: 150ms all;\n  position: relative;\n  overflow: hidden;\n}\n.button--color-default.button--flat:hover {\n  background-color: #dae6ff;\n}\n.button--color-default.button--flat:disabled {\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-default.button--flat > svg {\n  fill: black !important;\n}\n.button--color-light-blue.button--filled {\n  color: white !important;\n  background-color: #5bcfff;\n  transition: 150ms all;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n  box-shadow: 0 4px #009bdb;\n}\n.button--color-light-blue.button--filled > span {\n  color: white !important;\n}\n.button--color-light-blue.button--filled:active {\n  box-shadow: 0 2px #009bdb;\n  transform: translateY(2px);\n}\n.button--color-light-blue.button--filled:disabled {\n  box-shadow: 0 4px #acacac;\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-light-blue.button--filled:disabled span {\n  color: grey !important;\n}\n.button--color-light-blue.button--filled:disabled svg {\n  fill: grey !important;\n}\n.button--color-light-blue.button--filled > svg {\n  fill: white !important;\n}\n.button--color-light-blue.button--flat {\n  color: white !important;\n  background-color: #5bcfff;\n  transition: 150ms all;\n  position: relative;\n  overflow: hidden;\n}\n.button--color-light-blue.button--flat:hover {\n  background-color: #42c8ff;\n}\n.button--color-light-blue.button--flat:disabled {\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-light-blue.button--flat > svg {\n  fill: white !important;\n}\n.button--color-green.button--filled {\n  color: white !important;\n  background-color: #5ddfb1;\n  transition: 150ms all;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n  box-shadow: 0 4px #1f9d71;\n}\n.button--color-green.button--filled > span {\n  color: white !important;\n}\n.button--color-green.button--filled:active {\n  box-shadow: 0 2px #1f9d71;\n  transform: translateY(2px);\n}\n.button--color-green.button--filled:disabled {\n  box-shadow: 0 4px #acacac;\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-green.button--filled:disabled span {\n  color: grey !important;\n}\n.button--color-green.button--filled:disabled svg {\n  fill: grey !important;\n}\n.button--color-green.button--filled > svg {\n  fill: white !important;\n}\n.button--color-green.button--flat {\n  color: white !important;\n  background-color: #5ddfb1;\n  transition: 150ms all;\n  position: relative;\n  overflow: hidden;\n}\n.button--color-green.button--flat:hover {\n  background-color: #48dba7;\n}\n.button--color-green.button--flat:disabled {\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-green.button--flat > svg {\n  fill: white !important;\n}\n.button--color-blue-grey.button--filled {\n  color: black !important;\n  background-color: #f3f7ff;\n  transition: 150ms all;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n  box-shadow: 0 4px #c8c8c8;\n}\n.button--color-blue-grey.button--filled > span {\n  color: black !important;\n}\n.button--color-blue-grey.button--filled:active {\n  box-shadow: 0 2px #c8c8c8;\n  transform: translateY(2px);\n}\n.button--color-blue-grey.button--filled:disabled {\n  box-shadow: 0 4px #acacac;\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-blue-grey.button--filled:disabled span {\n  color: grey !important;\n}\n.button--color-blue-grey.button--filled:disabled svg {\n  fill: grey !important;\n}\n.button--color-blue-grey.button--filled > svg {\n  fill: black !important;\n}\n.button--color-blue-grey.button--flat {\n  color: black !important;\n  background-color: #f3f7ff;\n  transition: 150ms all;\n  position: relative;\n  overflow: hidden;\n}\n.button--color-blue-grey.button--flat:hover {\n  background-color: #dae6ff;\n}\n.button--color-blue-grey.button--flat:disabled {\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-blue-grey.button--flat > svg {\n  fill: black !important;\n}\n.button--color-primary.button--filled {\n  color: black !important;\n  background-color: #ffdc4a;\n  transition: 150ms all;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n  box-shadow: 0 4px #caa300;\n}\n.button--color-primary.button--filled > span {\n  color: black !important;\n}\n.button--color-primary.button--filled:active {\n  box-shadow: 0 2px #caa300;\n  transform: translateY(2px);\n}\n.button--color-primary.button--filled:disabled {\n  box-shadow: 0 4px #acacac;\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-primary.button--filled:disabled span {\n  color: grey !important;\n}\n.button--color-primary.button--filled:disabled svg {\n  fill: grey !important;\n}\n.button--color-primary.button--filled > svg {\n  fill: black !important;\n}\n.button--color-primary.button--flat {\n  color: black !important;\n  background-color: #ffdc4a;\n  transition: 150ms all;\n  position: relative;\n  overflow: hidden;\n}\n.button--color-primary.button--flat:hover {\n  background-color: #ffd731;\n}\n.button--color-primary.button--flat:disabled {\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-primary.button--flat > svg {\n  fill: black !important;\n}\n.button--color-secondary.button--filled {\n  color: white !important;\n  background-color: #ab082d;\n  transition: 150ms all;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n  box-shadow: 0 4px #31020d;\n}\n.button--color-secondary.button--filled > span {\n  color: white !important;\n}\n.button--color-secondary.button--filled:active {\n  box-shadow: 0 2px #31020d;\n  transform: translateY(2px);\n}\n.button--color-secondary.button--filled:disabled {\n  box-shadow: 0 4px #acacac;\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-secondary.button--filled:disabled span {\n  color: grey !important;\n}\n.button--color-secondary.button--filled:disabled svg {\n  fill: grey !important;\n}\n.button--color-secondary.button--filled > svg {\n  fill: white !important;\n}\n.button--color-secondary.button--flat {\n  color: white !important;\n  background-color: #ab082d;\n  transition: 150ms all;\n  position: relative;\n  overflow: hidden;\n}\n.button--color-secondary.button--flat:hover {\n  background-color: #930727;\n}\n.button--color-secondary.button--flat:disabled {\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-secondary.button--flat > svg {\n  fill: white !important;\n}\n.button--color-action.button--filled {\n  color: white !important;\n  background-color: #001593;\n  transition: 150ms all;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n  box-shadow: 0 4px #000e60;\n}\n.button--color-action.button--filled > span {\n  color: white !important;\n}\n.button--color-action.button--filled:active {\n  box-shadow: 0 2px #000e60;\n  transform: translateY(2px);\n}\n.button--color-action.button--filled:disabled {\n  box-shadow: 0 4px #acacac;\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-action.button--filled:disabled span {\n  color: grey !important;\n}\n.button--color-action.button--filled:disabled svg {\n  fill: grey !important;\n}\n.button--color-action.button--filled > svg {\n  fill: white !important;\n}\n.button--color-action.button--flat {\n  color: white !important;\n  background-color: #001593;\n  transition: 150ms all;\n  position: relative;\n  overflow: hidden;\n}\n.button--color-action.button--flat:hover {\n  background-color: #00117a;\n}\n.button--color-action.button--flat:disabled {\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-action.button--flat > svg {\n  fill: white !important;\n}\n.button--color-black.button--filled {\n  color: white !important;\n  background-color: #181a23;\n  transition: 150ms all;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n  box-shadow: 0 4px #030405;\n}\n.button--color-black.button--filled > span {\n  color: white !important;\n}\n.button--color-black.button--filled:active {\n  box-shadow: 0 2px #030405;\n  transform: translateY(2px);\n}\n.button--color-black.button--filled:disabled {\n  box-shadow: 0 4px #acacac;\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-black.button--filled:disabled span {\n  color: grey !important;\n}\n.button--color-black.button--filled:disabled svg {\n  fill: grey !important;\n}\n.button--color-black.button--filled > svg {\n  fill: white !important;\n}\n.button--color-black.button--flat {\n  color: white !important;\n  background-color: #181a23;\n  transition: 150ms all;\n  position: relative;\n  overflow: hidden;\n}\n.button--color-black.button--flat:hover {\n  background-color: #0e0f14;\n}\n.button--color-black.button--flat:disabled {\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-black.button--flat > svg {\n  fill: white !important;\n}\n.button--color-confirm.button--filled {\n  color: white !important;\n  background-color: #26d4dd;\n  transition: 150ms all;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n  box-shadow: 0 4px #126d72;\n}\n.button--color-confirm.button--filled > span {\n  color: white !important;\n}\n.button--color-confirm.button--filled:active {\n  box-shadow: 0 2px #126d72;\n  transform: translateY(2px);\n}\n.button--color-confirm.button--filled:disabled {\n  box-shadow: 0 4px #acacac;\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-confirm.button--filled:disabled span {\n  color: grey !important;\n}\n.button--color-confirm.button--filled:disabled svg {\n  fill: grey !important;\n}\n.button--color-confirm.button--filled > svg {\n  fill: white !important;\n}\n.button--color-confirm.button--flat {\n  color: white !important;\n  background-color: #26d4dd;\n  transition: 150ms all;\n  position: relative;\n  overflow: hidden;\n}\n.button--color-confirm.button--flat:hover {\n  background-color: #20c1ca;\n}\n.button--color-confirm.button--flat:disabled {\n  background-color: #ececec;\n  color: grey !important;\n}\n.button--color-confirm.button--flat > svg {\n  fill: white !important;\n}\n.button--spacing-small > svg {\n  margin-right: 4px;\n}\n.button--spacing-default > svg {\n  margin-right: 6px;\n}";
styleInject(css_248z$E);

var Button = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'filled' : _b, _c = _a.size, size = _c === void 0 ? 'default' : _c, _d = _a.color, color = _d === void 0 ? 'default' : _d, label = _a.label, icon = _a.icon, className = _a.className, children = _a.children, rest = __rest(_a, ["variant", "size", "color", "label", "icon", "className", "children"]);
    var classNames = cx("button--".concat(size), "button--".concat(variant), "button--color-".concat(color), {
        'button--spacing-small': !!(icon && label && size === 'small'),
        'button--spacing-default': !!(icon && label && size === 'default')
    }, className);
    return (React__default["default"].createElement("button", __assign$1({ className: classNames }, rest), children ? (children) : (React__default["default"].createElement(React__default["default"].Fragment, null,
        icon,
        label && React__default["default"].createElement(Typography, { variant: "button" }, label)))));
};

var EmphasizedTypography = function (_a) {
    var delimiter = _a.delimiter, emphasisElement = _a.emphasisElement, children = _a.children, rest = __rest(_a, ["delimiter", "emphasisElement", "children"]);
    if (!children)
        return React__default["default"].createElement(Typography, __assign$1({}, rest));
    if (!['string', 'number'].includes(typeof children))
        throw new Error('Children of EmphasizedTyopgraphy must be text/number only');
    var childrenStr = children === null || children === void 0 ? void 0 : children.toString();
    var parts = childrenStr.split(delimiter);
    return (React__default["default"].createElement(Typography, __assign$1({}, rest), parts.map(function (part, i) {
        return i % 2 === 0 ? (part) : (React__default["default"].createElement(Typography, __assign$1({ key: i }, rest, { component: emphasisElement }), part));
    })));
};

var css_248z$D = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.helper-text {\n  margin: 8px 0 0;\n  padding: 0 16px;\n  font-size: 14px;\n  color: #595959;\n}\n.helper-text--error {\n  color: #e80f62;\n}";
styleInject(css_248z$D);

var HelperText = function (_a) {
    var text = _a.text, error = _a.error;
    return (React__namespace.createElement("span", { className: "helper-text ".concat(error ? 'helper-text--error' : '') }, text));
};

var css_248z$C = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.text-input {\n  position: relative;\n  width: 100%;\n  margin: 8px 4px;\n}\n.text-input label {\n  position: absolute;\n  top: 22px;\n  left: 16px;\n  color: rgba(10, 10, 10, 0.3);\n  font-size: 22px;\n  z-index: 1;\n  transition: all 150ms;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: calc(100% - 32px);\n}\n.text-input input {\n  outline: none;\n  font-size: 22px;\n  z-index: 2;\n  width: 100%;\n  color: rgba(10, 10, 10, 0.76);\n  padding: 22px 16px 18px;\n  background-color: white;\n  border-radius: 20px;\n  border: 2px solid #ececec;\n}\n.text-input input:disabled {\n  color: rgba(10, 10, 10, 0.3) !important;\n  border-color: #f4f4f4;\n}\n.text-input input:focus ~ label, .text-input input:not([value=\"\"]) ~ label, .text-input input:-webkit-autofill ~ label {\n  top: 8px;\n  font-size: 12px;\n}\n.text-input--error input {\n  border-color: #e80f62;\n}";
styleInject(css_248z$C);

var TextInput = function (_a) {
    var name = _a.name, label = _a.label, value = _a.value, onChange = _a.onChange; _a.placeholder; var id = _a.id, error = _a.error, helperText = _a.helperText, rest = __rest(_a, ["name", "label", "value", "onChange", "placeholder", "id", "error", "helperText"]);
    return (React__namespace.createElement("div", { className: cx('text-input', { 'text-input--error': error }) },
        React__namespace.createElement("input", __assign$1({ type: "text", name: name, id: id || name, value: value, onChange: onChange, "aria-invalid": error }, rest)),
        React__namespace.createElement("label", { htmlFor: id || name }, label),
        helperText ? React__namespace.createElement(HelperText, { text: helperText, error: error }) : null));
};

var _path$M;
function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$10({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$M || (_path$M = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
  })));
};

var css_248z$B = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.custom-select {\n  width: 100%;\n  color: rgba(10, 10, 10, 0.76);\n  margin: 8px 4px;\n  outline: none;\n}\n.custom-select__display, .custom-select__display--disabled, .custom-select__display--error {\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 16px 16px;\n  width: 100%;\n  border: 2px solid #ececec;\n  background-color: #f8f8f8;\n  border-radius: 20px;\n  position: relative;\n  text-align: left;\n  font-size: 22px;\n  outline: none;\n}\n.custom-select__display:focus-visible, .custom-select__display--disabled:focus-visible, .custom-select__display--error:focus-visible {\n  outline: 5px auto #015fcc;\n  outline-color: Highlight;\n  outline-color: -webkit-focus-ring-color;\n}\n.custom-select__display > div, .custom-select__display--disabled > div, .custom-select__display--error > div {\n  width: 100%;\n  height: 28px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.custom-select__display--error {\n  border-color: #e80f62;\n}\n.custom-select__display--disabled {\n  cursor: auto;\n  border-color: #f4f4f4;\n  color: rgba(10, 10, 10, 0.3);\n}\n.custom-select__display--disabled svg {\n  fill: rgba(10, 10, 10, 0.3);\n}\n.custom-select__display-label, .custom-select__display-label--up {\n  position: absolute;\n  top: 20px;\n  left: 16px;\n  font-size: 22px;\n  color: rgba(10, 10, 10, 0.3);\n  transition: 100ms all;\n}\n.custom-select__display-label--up {\n  top: 8px;\n  font-size: 12px;\n}\n.custom-select__options {\n  visibility: hidden;\n  list-style: none;\n  padding: 0;\n  position: absolute;\n  z-index: 2;\n  border: 2px solid #ececec;\n  background-color: #f8f8f8;\n  margin: 8px 0 0;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  max-height: 150px;\n}\n.custom-select__options li {\n  display: flex;\n  flex-direction: row;\n}\n.custom-select__options li input {\n  content: \"\";\n  display: none;\n}\n.custom-select__options li label {\n  width: 100%;\n  padding: 8px 16px;\n  font-size: 20px;\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  cursor: pointer;\n}\n.custom-select__options li label[data-preselected=true] {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.custom-select__options li label:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.custom-select__options--open {\n  visibility: visible;\n}\n.custom-select__options--position-top {\n  bottom: 100%;\n  margin: 0 0 8px;\n}\n.custom-select__helper-text {\n  color: #e80f62;\n  margin: 8px 0 0;\n  padding: 0 16px;\n  font-size: 14px;\n}";
styleInject(css_248z$B);

var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.optionsRef = React.createRef();
        _this.containerRef = React.createRef();
        _this.preselectedLiRef = React.createRef();
        _this.preselectedInputRef = React.createRef();
        _this.state = {
            preselectedIndex: 0,
            optionsOpen: false,
            hasFocus: false,
            search: ''
        };
        _this.getOptionsPosition = function () {
            var _a, _b;
            var optionsPosition = _this.props.optionsPosition;
            if (optionsPosition) {
                return optionsPosition;
            }
            else {
                var optionsRect = (_a = _this.optionsRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                var containerRect = (_b = _this.containerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
                var optionsHeight = optionsRect === null || optionsRect === void 0 ? void 0 : optionsRect.height;
                var fitsUnderInput = window.innerHeight - (containerRect === null || containerRect === void 0 ? void 0 : containerRect.bottom) > optionsHeight;
                var fitsAboveInput = (containerRect === null || containerRect === void 0 ? void 0 : containerRect.top) - optionsHeight >= 0;
                return !fitsUnderInput && fitsAboveInput ? 'top' : 'bottom';
            }
        };
        _this.onSelectOption = function (e) {
            _this.props.onChange(e);
            _this.setState({
                optionsOpen: false,
                search: ''
            });
        };
        _this.openOptions = function (callback) { return _this.setState({ optionsOpen: true }, callback); };
        _this.closeOptions = function (callback) { return _this.setState({ optionsOpen: false }, callback); };
        _this.onArrowClick = function (direction) {
            return _this.setState(function (prevState) {
                var preselectedIndex = prevState.preselectedIndex, optionsOpen = prevState.optionsOpen;
                var optionsLength = _this.props.options.length;
                if (optionsOpen) {
                    if (direction === 'down' && preselectedIndex + 1 < optionsLength) {
                        return __assign$1(__assign$1({}, prevState), { preselectedIndex: preselectedIndex + 1 });
                    }
                    else if (direction === 'up' && preselectedIndex - 1 >= 0) {
                        return __assign$1(__assign$1({}, prevState), { preselectedIndex: preselectedIndex - 1 });
                    }
                }
                else {
                    _this.openOptions();
                }
            });
        };
        _this.closeAndBlur = function () {
            _this.setState({
                optionsOpen: false,
                hasFocus: false,
                search: ''
            }, _this.props.onBlur);
        };
        _this.handleClickOutside = function (event) {
            var _a;
            if (!((_a = _this.containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) && _this.state.hasFocus) {
                _this.closeAndBlur();
            }
        };
        _this.handleSearch = function (event) {
            if (event.keyCode === 8) {
                // handle backspace
                _this.setState(function (_a) {
                    var search = _a.search;
                    return ({
                        search: search.substring(0, search.length - 1)
                    });
                });
                return;
            }
            var value = event.nativeEvent.key;
            if (/^[a-zA-Z0-9]{1}$/gim.test(value)) {
                _this.setState(function (_a) {
                    var search = _a.search;
                    return ({
                        search: search + value,
                        optionsOpen: true
                    });
                });
            }
        };
        _this.findBestMatch = function () {
            var lowerCaseSearch = _this.state.search.toLowerCase();
            var match = _this.props.options.find(function (opt) {
                if (typeof opt.label === 'string') {
                    return opt.label.toLowerCase().startsWith(lowerCaseSearch);
                }
            });
            if (!match) {
                match = _this.props.options.find(function (opt) {
                    if (typeof opt.label === 'string') {
                        return opt.label.toLowerCase().includes(lowerCaseSearch);
                    }
                });
            }
            if (match) {
                _this.setState({ preselectedIndex: _this.props.options.findIndex(function (opt) { return opt.value === match.value; }) });
            }
        };
        _this.handleKeyDown = function (e) {
            var _a;
            switch (e.keyCode) {
                case 32: // space
                    e.preventDefault();
                    _this.state.optionsOpen ? _this.closeOptions() : _this.openOptions();
                    return;
                case 27: // esc
                    _this.closeOptions();
                    return;
                case 40: // arrow down
                    _this.onArrowClick('down');
                    return;
                case 38: // arrow up
                    _this.onArrowClick('up');
                    return;
                case 13: {
                    // enter
                    if (_this.preselectedInputRef.current) {
                        (_a = _this.preselectedInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    }
                    else {
                        _this.state.optionsOpen ? _this.closeOptions() : _this.openOptions();
                    }
                    return;
                }
                case 9: // tab
                    _this.closeAndBlur();
                    return;
                default:
                    _this.handleSearch(e);
                    return;
            }
        };
        return _this;
    }
    Select.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleClickOutside);
    };
    Select.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleClickOutside);
    };
    Select.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a;
        if (prevState.preselectedIndex !== this.state.preselectedIndex) {
            (_a = this.preselectedLiRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'center', inline: 'center' });
        }
        if (prevState.search !== this.state.search && this.state.search !== '') {
            this.findBestMatch();
        }
    };
    Select.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, name = _b.name, className = _b.className, style = _b.style, disabled = _b.disabled, error = _b.error, label = _b.label, options = _b.options, value = _b.value, helperText = _b.helperText, testId = _b.testId;
        var _c = this.state, optionsOpen = _c.optionsOpen, preselectedIndex = _c.preselectedIndex, search = _c.search;
        var selectedOptionLabel = (_a = options.find(function (option) { return option.value === value; })) === null || _a === void 0 ? void 0 : _a.label;
        return (React__default["default"].createElement("div", { className: "custom-select ".concat(className ? className : ''), ref: this.containerRef, tabIndex: -1 },
            React__default["default"].createElement("div", { tabIndex: 0, "data-testid": testId, className: "custom-select__display".concat(disabled ? '--disabled' : error ? '--error' : ''), onFocus: function () { return _this.setState({ hasFocus: true }); }, onKeyDown: this.handleKeyDown, onClick: function () { return (optionsOpen ? _this.closeOptions() : _this.openOptions()); } },
                React__default["default"].createElement("div", null,
                    React__default["default"].createElement("span", { className: "custom-select__display-label".concat(selectedOptionLabel || search ? '--up' : '') }, label),
                    selectedOptionLabel || search || ''),
                React__default["default"].createElement(SvgChevronDown, { style: {
                        transition: '230ms all',
                        transform: optionsOpen ? 'rotate(180deg)' : ''
                    } })),
            helperText && React__default["default"].createElement("span", { className: "custom-select__helper-text" }, helperText),
            optionsOpen && (React__default["default"].createElement("ul", { style: style, ref: this.optionsRef, className: "custom-select__options ".concat(optionsOpen ? 'custom-select__options--open' : '', " custom-select__options--position-").concat(this.getOptionsPosition()) }, options.map(function (option, i) { return (React__default["default"].createElement("li", { key: option.value, ref: option.value === options[preselectedIndex].value ? _this.preselectedLiRef : null },
                React__default["default"].createElement("input", { id: "".concat(name).concat(i), type: "radio", name: name, value: option.value, checked: option.value === value, onChange: _this.onSelectOption, ref: option.value === options[preselectedIndex].value ? _this.preselectedInputRef : null }),
                React__default["default"].createElement("label", { htmlFor: "".concat(name).concat(i), "data-preselected": option.value === options[preselectedIndex].value }, option.label))); })))));
    };
    return Select;
}(React.Component));

var css_248z$A = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.toggle-switch {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  background-color: #f8f8f8;\n  border-radius: 16px;\n  height: fit-content;\n  width: fit-content;\n}\n.toggle-switch:has(input:focus-visible) {\n  outline: 5px auto #015fcc;\n  outline-color: Highlight;\n  outline-color: -webkit-focus-ring-color;\n}\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n  margin: 0;\n}\n.toggle-switch label {\n  cursor: pointer;\n  padding: 16px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: fit-content;\n  border: solid 2px #f8f8f8;\n  transition: 150ms all;\n}\n.toggle-switch input:checked + label {\n  background-color: white;\n  border: solid 2px #ececec;\n  box-shadow: inset 0 -4px 0 0 #ececec;\n}";
styleInject(css_248z$A);

var ToggleSwitch = function (_a) {
    var name = _a.name, value = _a.value, trueLabel = _a.trueLabel, falseLabel = _a.falseLabel, onChange = _a.onChange, className = _a.className, style = _a.style;
    var handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            onChange();
            e.preventDefault();
        }
    };
    var handleKeyUp = function (e) {
        if (e.key === 'Spacebar' || e.key === ' ') {
            onChange();
            e.preventDefault();
        }
    };
    return (React__default["default"].createElement("div", { className: "toggle-switch ".concat(className ? className : ''), style: style },
        React__default["default"].createElement("input", { type: "radio", name: name, id: falseLabel, checked: !value, onChange: onChange, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp }),
        React__default["default"].createElement("label", { htmlFor: falseLabel }, falseLabel),
        React__default["default"].createElement("input", { type: "radio", name: name, id: trueLabel, checked: value, onChange: onChange, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp }),
        React__default["default"].createElement("label", { htmlFor: trueLabel }, trueLabel)));
};

var _path$L;
function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$$({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$L || (_path$L = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
  })));
};

var css_248z$z = ".avatar-upload {\n  display: flex;\n  position: relative;\n  height: fit-content;\n  width: fit-content;\n}\n.avatar-upload input {\n  width: 0;\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n.avatar-upload label {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 100px;\n  border-radius: 100px;\n  font-size: 12px;\n  border: 1px solid lightgrey;\n  box-shadow: 0 3px lightgray;\n  transition: 230ms all;\n  margin: 0;\n  background-color: white;\n}\n.avatar-upload label:active {\n  transform: translateY(2px);\n  box-shadow: 0 1px lightgray;\n}\n.avatar-upload input:focus + label {\n  outline: 5px auto #015fcc;\n  outline-color: Highlight;\n  outline-color: -webkit-focus-ring-color;\n}\n.avatar-upload span {\n  position: absolute;\n  text-align: center;\n  color: red;\n  font-size: 11px;\n  bottom: 0;\n  transform: translate(-50%, 105%);\n  left: 50%;\n  width: 100%;\n}\n.avatar-display > div {\n  position: relative;\n  display: flex;\n}\n.avatar-display img {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n  margin: 0;\n  border-radius: 100px;\n  box-shadow: inset 0 -4px 0 0 rgba(0, 0, 0, 0.25);\n}\n.avatar-display__overlay {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 100px;\n  opacity: 0;\n  z-index: 2;\n  cursor: pointer;\n  transition: 150ms all;\n}\n.avatar-display__overlay svg {\n  fill: white;\n  width: 40px;\n  height: 40px;\n}\n.avatar-display__overlay:hover, .avatar-display__overlay:focus {\n  opacity: 1;\n  background-color: rgba(0, 0, 0, 0.5);\n}";
styleInject(css_248z$z);

var AVATAR_SIZE_LIMIT_MB = 5; // [MB]
var AvatarUpload = function (_a) {
    var file = _a.file, uploadImage = _a.uploadImage, removeImage = _a.removeImage, style = _a.style, className = _a.className;
    var _b = React.useState(false), error = _b[0], setError = _b[1];
    var checkImageAndUpload = function (e) {
        var _a;
        var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
        var image = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a.item(0);
        var fileName = e.target.value;
        if (image) {
            if (image.size > AVATAR_SIZE_LIMIT_MB * 1000000) {
                setError('size');
                return;
            }
            if (!allowedExtensions.exec(fileName)) {
                setError('format');
                return;
            }
            setError(false);
            uploadImage(image);
        }
    };
    return file ? (React__default["default"].createElement("div", { className: "avatar-display ".concat(className ? className : ''), style: style },
        React__default["default"].createElement("div", null,
            React__default["default"].createElement("img", { srcSet: typeof file === 'string' ? file : URL.createObjectURL(file), alt: "Avatar" }),
            React__default["default"].createElement("button", { className: "avatar-display__overlay", onClick: removeImage, "aria-label": "Delete avatar" },
                React__default["default"].createElement(SvgClose, null))))) : (React__default["default"].createElement("div", { className: "avatar-upload ".concat(className ? className : ''), style: style },
        React__default["default"].createElement("input", { type: "file", name: "avatar", id: "avatarUpload", accept: ".jpg,.jpeg,.png,.gif", onChange: checkImageAndUpload }),
        React__default["default"].createElement("label", { htmlFor: "avatarUpload" }, "+ Add avatar"),
        !!error && (React__default["default"].createElement("span", null, error === 'size'
            ? "File too large. Limit is ".concat(AVATAR_SIZE_LIMIT_MB, "MB.")
            : 'Please use a jpg, gif, or png image for your avatar.'))));
};

var css_248z$y = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.GoogleButton {\n  padding: 17px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  font-size: medium;\n}\n.GoogleButton svg {\n  width: 24px;\n  height: 24px;\n  fill: white;\n  margin-right: 10px;\n}\n.GoogleButton--primary {\n  background-color: #001593;\n  color: white;\n}\n.GoogleButton--secondary {\n  background-color: white;\n  border: 2px solid #ececec;\n}";
styleInject(css_248z$y);

var _path$K, _path2$j, _path3$g, _path4$f;
function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }
var SvgGoogleColor = function SvgGoogleColor(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$_({
    viewBox: "0 0 533.5 544.3",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$K || (_path$K = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z",
    fill: "#4285f4"
  })), _path2$j || (_path2$j = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z",
    fill: "#34a853"
  })), _path3$g || (_path3$g = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z",
    fill: "#fbbc04"
  })), _path4$f || (_path4$f = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z",
    fill: "#ea4335"
  })));
};

var GoogleButton = function (_a) {
    var children = _a.children, onClick = _a.onClick, _b = _a.color, color = _b === void 0 ? 'primary' : _b;
    return (React__namespace.createElement("button", { className: cx("GoogleButton", "GoogleButton--".concat(color)), onClick: onClick },
        React__namespace.createElement(SvgGoogleColor, null),
        children || 'Sign in with Google'));
};

var _path$J;
function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }
var SvgSpeaker = function SvgSpeaker(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$Z({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$J || (_path$J = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 8.6147L0 13.948C0 14.6814 0.6 15.2814 1.33333 15.2814L5.33333 15.2814L9.72 19.668C10.56 20.508 12 19.908 12 18.7214L12 3.82803C12 2.64136 10.56 2.04136 9.72 2.88136L5.33333 7.28136L1.33333 7.28136C0.6 7.28136 0 7.88136 0 8.6147ZM18 11.2814C18 8.92136 16.64 6.8947 14.6667 5.90803L14.6667 16.6414C16.64 15.668 18 13.6414 18 11.2814ZM14.6667 1.2147L14.6667 1.48136C14.6667 1.98803 15 2.42803 15.4667 2.6147C18.9067 3.98803 21.3333 7.36136 21.3333 11.2814C21.3333 15.2014 18.9067 18.5747 15.4667 19.948C14.9867 20.1347 14.6667 20.5747 14.6667 21.0814L14.6667 21.348C14.6667 22.188 15.5067 22.7747 16.28 22.4814C20.8 20.7614 24 16.4014 24 11.2814C24 6.16136 20.8 1.80136 16.28 0.0813633C15.5067 -0.225303 14.6667 0.374697 14.6667 1.2147Z",
    stroke: "none"
  })));
};

// ES6 Map
var map;
try {
  map = Map;
} catch (_) { }
var set$2;

// ES6 Set
try {
  set$2 = Set;
} catch (_) { }

function baseClone$1 (src, circulars, clones) {
  // Null/undefined/functions/etc
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src
  }

  // DOM Node
  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true)
  }

  // Date
  if (src instanceof Date) {
    return new Date(src.getTime())
  }

  // RegExp
  if (src instanceof RegExp) {
    return new RegExp(src)
  }

  // Arrays
  if (Array.isArray(src)) {
    return src.map(clone$1)
  }

  // ES6 Maps
  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()))
  }

  // ES6 Sets
  if (set$2 && src instanceof set$2) {
    return new Set(Array.from(src.values()))
  }

  // Object
  if (src instanceof Object) {
    circulars.push(src);
    var obj = Object.create(src);
    clones.push(obj);
    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key]
      });
      obj[key] = idx > -1 ? clones[idx] : baseClone$1(src[key], circulars, clones);
    }
    return obj
  }

  // ???
  return src
}

function clone$1 (src) {
  return baseClone$1(src, [], [])
}

const toString$7 = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString$2 = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString$2.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString$7.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
});

/** Used for built-in method references. */

var objectProto$r = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$k = objectProto$r.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas$1(object, key) {
  return object != null && hasOwnProperty$k.call(object, key);
}

var _baseHas = baseHas$1;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$a = Array.isArray;

var isArray_1 = isArray$a;

/** Detect free variable `global` from Node.js. */

var freeGlobal$3 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$3;

var freeGlobal$2 = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf$2 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$b = freeGlobal$2 || freeSelf$2 || Function('return this')();

var _root = root$b;

var root$a = _root;

/** Built-in value references. */
var Symbol$6 = root$a.Symbol;

var _Symbol = Symbol$6;

var Symbol$5 = _Symbol;

/** Used for built-in method references. */
var objectProto$q = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$j = objectProto$q.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$3 = objectProto$q.toString;

/** Built-in value references. */
var symToStringTag$3 = Symbol$5 ? Symbol$5.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$2(value) {
  var isOwn = hasOwnProperty$j.call(value, symToStringTag$3),
      tag = value[symToStringTag$3];

  try {
    value[symToStringTag$3] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$3.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag;
    } else {
      delete value[symToStringTag$3];
    }
  }
  return result;
}

var _getRawTag = getRawTag$2;

/** Used for built-in method references. */

var objectProto$p = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$p.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$3(value) {
  return nativeObjectToString$2.call(value);
}

var _objectToString = objectToString$3;

var Symbol$4 = _Symbol,
    getRawTag$1 = _getRawTag,
    objectToString$2 = _objectToString;

/** `Object#toString` result references. */
var nullTag$1 = '[object Null]',
    undefinedTag$1 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$2 = Symbol$4 ? Symbol$4.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$6(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return (symToStringTag$2 && symToStringTag$2 in Object(value))
    ? getRawTag$1(value)
    : objectToString$2(value);
}

var _baseGetTag = baseGetTag$6;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$7(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$7;

var baseGetTag$5 = _baseGetTag,
    isObjectLike$6 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$5 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$5(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$6(value) && baseGetTag$5(value) == symbolTag$5);
}

var isSymbol_1 = isSymbol$5;

var isArray$9 = isArray_1,
    isSymbol$4 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$9(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$4(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$7(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$7;

var baseGetTag$4 = _baseGetTag,
    isObject$6 = isObject_1;

/** `Object#toString` result references. */
var asyncTag$1 = '[object AsyncFunction]',
    funcTag$4 = '[object Function]',
    genTag$2 = '[object GeneratorFunction]',
    proxyTag$1 = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$4(value) {
  if (!isObject$6(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$4(value);
  return tag == funcTag$4 || tag == genTag$2 || tag == asyncTag$1 || tag == proxyTag$1;
}

var isFunction_1 = isFunction$4;

var root$9 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$2 = root$9['__core-js_shared__'];

var _coreJsData = coreJsData$2;

var coreJsData$1 = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = (function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$2(func) {
  return !!maskSrcKey$1 && (maskSrcKey$1 in func);
}

var _isMasked = isMasked$2;

/** Used for built-in method references. */

var funcProto$4 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$4 = funcProto$4.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$3(func) {
  if (func != null) {
    try {
      return funcToString$4.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$3;

var isFunction$3 = isFunction_1,
    isMasked$1 = _isMasked,
    isObject$5 = isObject_1,
    toSource$2 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$3 = Function.prototype,
    objectProto$o = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$3 = funcProto$3.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$i = objectProto$o.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' +
  funcToString$3.call(hasOwnProperty$i).replace(reRegExpChar$1, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$2(value) {
  if (!isObject$5(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$3(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$2(value));
}

var _baseIsNative = baseIsNative$2;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$3(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$3;

var baseIsNative$1 = _baseIsNative,
    getValue$2 = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$8(object, key) {
  var value = getValue$2(object, key);
  return baseIsNative$1(value) ? value : undefined;
}

var _getNative = getNative$8;

var getNative$7 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$5 = getNative$7(Object, 'create');

var _nativeCreate = nativeCreate$5;

var nativeCreate$4 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$2() {
  this.__data__ = nativeCreate$4 ? nativeCreate$4(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$2;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$2(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$2;

var nativeCreate$3 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$4 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$n = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$h = objectProto$n.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$2(key) {
  var data = this.__data__;
  if (nativeCreate$3) {
    var result = data[key];
    return result === HASH_UNDEFINED$4 ? undefined : result;
  }
  return hasOwnProperty$h.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$2;

var nativeCreate$2 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$m = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$g = objectProto$m.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$2(key) {
  var data = this.__data__;
  return nativeCreate$2 ? (data[key] !== undefined) : hasOwnProperty$g.call(data, key);
}

var _hashHas = hashHas$2;

var nativeCreate$1 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$2(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED$3 : value;
  return this;
}

var _hashSet = hashSet$2;

var hashClear$1 = _hashClear,
    hashDelete$1 = _hashDelete,
    hashGet$1 = _hashGet,
    hashHas$1 = _hashHas,
    hashSet$1 = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$2(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$2.prototype.clear = hashClear$1;
Hash$2.prototype['delete'] = hashDelete$1;
Hash$2.prototype.get = hashGet$1;
Hash$2.prototype.has = hashHas$1;
Hash$2.prototype.set = hashSet$1;

var _Hash = Hash$2;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$2() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$2;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$3(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$3;

var eq$2 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$5(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$5;

var assocIndexOf$4 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$2(key) {
  var data = this.__data__,
      index = assocIndexOf$4(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$2;

var assocIndexOf$3 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$2(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$2;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$2(key) {
  return assocIndexOf$2(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$2;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$2(key, value) {
  var data = this.__data__,
      index = assocIndexOf$1(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$2;

var listCacheClear$1 = _listCacheClear,
    listCacheDelete$1 = _listCacheDelete,
    listCacheGet$1 = _listCacheGet,
    listCacheHas$1 = _listCacheHas,
    listCacheSet$1 = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$5(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$5.prototype.clear = listCacheClear$1;
ListCache$5.prototype['delete'] = listCacheDelete$1;
ListCache$5.prototype.get = listCacheGet$1;
ListCache$5.prototype.has = listCacheHas$1;
ListCache$5.prototype.set = listCacheSet$1;

var _ListCache = ListCache$5;

var getNative$6 = _getNative,
    root$8 = _root;

/* Built-in method references that are verified to be native. */
var Map$5 = getNative$6(root$8, 'Map');

var _Map = Map$5;

var Hash$1 = _Hash,
    ListCache$4 = _ListCache,
    Map$4 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$2() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$1,
    'map': new (Map$4 || ListCache$4),
    'string': new Hash$1
  };
}

var _mapCacheClear = mapCacheClear$2;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$2(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$2;

var isKeyable$1 = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$5(map, key) {
  var data = map.__data__;
  return isKeyable$1(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$5;

var getMapData$4 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$2(key) {
  var result = getMapData$4(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$2;

var getMapData$3 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$2(key) {
  return getMapData$3(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$2;

var getMapData$2 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$2(key) {
  return getMapData$2(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$2;

var getMapData$1 = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$2(key, value) {
  var data = getMapData$1(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$2;

var mapCacheClear$1 = _mapCacheClear,
    mapCacheDelete$1 = _mapCacheDelete,
    mapCacheGet$1 = _mapCacheGet,
    mapCacheHas$1 = _mapCacheHas,
    mapCacheSet$1 = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$4.prototype.clear = mapCacheClear$1;
MapCache$4.prototype['delete'] = mapCacheDelete$1;
MapCache$4.prototype.get = mapCacheGet$1;
MapCache$4.prototype.has = mapCacheHas$1;
MapCache$4.prototype.set = mapCacheSet$1;

var _MapCache = MapCache$4;

var MapCache$3 = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$2(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache$3);
  return memoized;
}

// Expose `MapCache`.
memoize$2.Cache = MapCache$3;

var memoize_1 = memoize$2;

var memoize$1 = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE$1 = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$2(func) {
  var result = memoize$1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE$1) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$2;

var memoizeCapped$1 = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoizeCapped$1(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$2;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$2;

var Symbol$3 = _Symbol,
    arrayMap$1 = _arrayMap,
    isArray$8 = isArray_1,
    isSymbol$3 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$3 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolToString$1 = symbolProto$3 ? symbolProto$3.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$2(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$8(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$1(value, baseToString$2) + '';
  }
  if (isSymbol$3(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$3) ? '-0' : result;
}

var _baseToString = baseToString$2;

var baseToString$1 = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$6(value) {
  return value == null ? '' : baseToString$1(value);
}

var toString_1 = toString$6;

var isArray$7 = isArray_1,
    isKey$2 = _isKey,
    stringToPath$1 = _stringToPath,
    toString$5 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$2(value, object) {
  if (isArray$7(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath$1(toString$5(value));
}

var _castPath = castPath$2;

var baseGetTag$3 = _baseGetTag,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$5 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$2(value) {
  return isObjectLike$5(value) && baseGetTag$3(value) == argsTag$5;
}

var _baseIsArguments = baseIsArguments$2;

var baseIsArguments$1 = _baseIsArguments,
    isObjectLike$4 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$l = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$l.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$3 = objectProto$l.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$3 = baseIsArguments$1(function() { return arguments; }()) ? baseIsArguments$1 : function(value) {
  return isObjectLike$4(value) && hasOwnProperty$f.call(value, 'callee') &&
    !propertyIsEnumerable$3.call(value, 'callee');
};

var isArguments_1 = isArguments$3;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$3 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$3 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint$1.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$3;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$2 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$4(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

var isLength_1 = isLength$4;

var isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$2(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _toKey = toKey$5;

var castPath$1 = _castPath,
    isArguments$2 = isArguments_1,
    isArray$6 = isArray_1,
    isIndex$2 = _isIndex,
    isLength$3 = isLength_1,
    toKey$4 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$2(object, path, hasFunc) {
  path = castPath$1(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$4(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$3(length) && isIndex$2(key, length) &&
    (isArray$6(object) || isArguments$2(object));
}

var _hasPath = hasPath$2;

var baseHas = _baseHas,
    hasPath$1 = _hasPath;

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath$1(object, path, baseHas);
}

var has_1 = has;

const isSchema = obj => obj && obj.__isYupSchema__;

class Condition {
  constructor(refs, options) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!has_1(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);

    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }

}

function toArray$2(value) {
  return value == null ? [] : [].concat(value);
}

function _extends$Y() { _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }
let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends$Y({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }

  static isError(err) {
    return err && err.name === 'ValidationError';
  }

  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray$2(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

}

const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};

function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}

var getNative$5 = _getNative;

var defineProperty$3 = (function() {
  try {
    var func = getNative$5(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$9 = defineProperty$3;

var defineProperty$2 = _defineProperty$9;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$3(object, key, value) {
  if (key == '__proto__' && defineProperty$2) {
    defineProperty$2(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$3;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$1 = createBaseFor();

var _baseFor = baseFor$1;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$2(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$2;

var isBuffer$3 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse$1() {
  return false;
}

var stubFalse_1 = stubFalse$1;

(function (module, exports) {
	var root = _root,
	    stubFalse = stubFalse_1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer;
} (isBuffer$3, isBuffer$3.exports));

var baseGetTag$2 = _baseGetTag,
    isLength$2 = isLength_1,
    isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$4 = '[object Arguments]',
    arrayTag$3 = '[object Array]',
    boolTag$4 = '[object Boolean]',
    dateTag$4 = '[object Date]',
    errorTag$3 = '[object Error]',
    funcTag$3 = '[object Function]',
    mapTag$7 = '[object Map]',
    numberTag$4 = '[object Number]',
    objectTag$6 = '[object Object]',
    regexpTag$4 = '[object RegExp]',
    setTag$7 = '[object Set]',
    stringTag$4 = '[object String]',
    weakMapTag$4 = '[object WeakMap]';

var arrayBufferTag$4 = '[object ArrayBuffer]',
    dataViewTag$6 = '[object DataView]',
    float32Tag$3 = '[object Float32Array]',
    float64Tag$3 = '[object Float64Array]',
    int8Tag$3 = '[object Int8Array]',
    int16Tag$3 = '[object Int16Array]',
    int32Tag$3 = '[object Int32Array]',
    uint8Tag$3 = '[object Uint8Array]',
    uint8ClampedTag$3 = '[object Uint8ClampedArray]',
    uint16Tag$3 = '[object Uint16Array]',
    uint32Tag$3 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] =
typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] =
typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] =
typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] =
typedArrayTags$1[uint32Tag$3] = true;
typedArrayTags$1[argsTag$4] = typedArrayTags$1[arrayTag$3] =
typedArrayTags$1[arrayBufferTag$4] = typedArrayTags$1[boolTag$4] =
typedArrayTags$1[dataViewTag$6] = typedArrayTags$1[dateTag$4] =
typedArrayTags$1[errorTag$3] = typedArrayTags$1[funcTag$3] =
typedArrayTags$1[mapTag$7] = typedArrayTags$1[numberTag$4] =
typedArrayTags$1[objectTag$6] = typedArrayTags$1[regexpTag$4] =
typedArrayTags$1[setTag$7] = typedArrayTags$1[stringTag$4] =
typedArrayTags$1[weakMapTag$4] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$2(value) {
  return isObjectLike$3(value) &&
    isLength$2(value.length) && !!typedArrayTags$1[baseGetTag$2(value)];
}

var _baseIsTypedArray = baseIsTypedArray$2;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$2(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$2;

var _nodeUtil = {exports: {}};

(function (module, exports) {
	var freeGlobal = _freeGlobal;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil;
} (_nodeUtil, _nodeUtil.exports));

var baseIsTypedArray$1 = _baseIsTypedArray,
    baseUnary$1 = _baseUnary,
    nodeUtil$1 = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsTypedArray$1 = nodeUtil$1 && nodeUtil$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$3 = nodeIsTypedArray$1 ? baseUnary$1(nodeIsTypedArray$1) : baseIsTypedArray$1;

var isTypedArray_1 = isTypedArray$3;

var baseTimes$1 = _baseTimes,
    isArguments$1 = isArguments_1,
    isArray$5 = isArray_1,
    isBuffer$2 = isBuffer$3.exports,
    isIndex$1 = _isIndex,
    isTypedArray$2 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$k = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$k.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$5(value),
      isArg = !isArr && isArguments$1(value),
      isBuff = !isArr && !isArg && isBuffer$2(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$2(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes$1(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$e.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$1(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/** Used for built-in method references. */

var objectProto$j = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$2(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$j;

  return value === proto;
}

var _isPrototype = isPrototype$2;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$2 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$2;

var isPrototype$1 = _isPrototype,
    nativeKeys$1 = _nativeKeys;

/** Used for built-in method references. */
var objectProto$i = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$i.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$2(object) {
  if (!isPrototype$1(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$d.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$2;

var isFunction$2 = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$2(value) {
  return value != null && isLength$1(value.length) && !isFunction$2(value);
}

var isArrayLike_1 = isArrayLike$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys$1 = _baseKeys,
    isArrayLike$1 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$4(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}

var keys_1 = keys$4;

var baseFor = _baseFor,
    keys$3 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$2(object, iteratee) {
  return object && baseFor(object, iteratee, keys$3);
}

var _baseForOwn = baseForOwn$2;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$2() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$2;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$2(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$2;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$2(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$2;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$2(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$2;

var ListCache$2 = _ListCache,
    Map$3 = _Map,
    MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$2(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$2) {
    var pairs = data.__data__;
    if (!Map$3 || (pairs.length < LARGE_ARRAY_SIZE$1 - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$2;

var ListCache$1 = _ListCache,
    stackClear$1 = _stackClear,
    stackDelete$1 = _stackDelete,
    stackGet$1 = _stackGet,
    stackHas$1 = _stackHas,
    stackSet$1 = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$3(entries) {
  var data = this.__data__ = new ListCache$1(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$3.prototype.clear = stackClear$1;
Stack$3.prototype['delete'] = stackDelete$1;
Stack$3.prototype.get = stackGet$1;
Stack$3.prototype.has = stackHas$1;
Stack$3.prototype.set = stackSet$1;

var _Stack = Stack$3;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache$1 = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$1;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;

var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root$7 = _root;

/** Built-in value references. */
var Uint8Array$3 = root$7.Uint8Array;

var _Uint8Array = Uint8Array$3;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var Symbol$2 = _Symbol,
    Uint8Array$2 = _Uint8Array,
    eq$1 = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    mapTag$6 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$6 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$4 = '[object Symbol]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$5 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$5:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$3:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;

    case boolTag$3:
    case dateTag$3:
    case numberTag$3:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$1(+object, +other);

    case errorTag$2:
      return object.name == other.name && object.message == other.message;

    case regexpTag$3:
    case stringTag$3:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$6:
      var convert = mapToArray;

    case setTag$6:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$4:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$2(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$2;

var arrayPush$1 = _arrayPush,
    isArray$4 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$4(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$2;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter$1 = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$2 = objectProto$h.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$2 = !nativeGetSymbols$2 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$2(object), function(symbol) {
    return propertyIsEnumerable$2.call(object, symbol);
  });
};

var _getSymbols = getSymbols$2;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols$1 = _getSymbols,
    keys$2 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$2, getSymbols$1);
}

var _getAllKeys = getAllKeys$2;

var getAllKeys$1 = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$g.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys$1(object),
      objLength = objProps.length,
      othProps = getAllKeys$1(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$c.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$4 = _getNative,
    root$6 = _root;

/* Built-in method references that are verified to be native. */
var DataView$3 = getNative$4(root$6, 'DataView');

var _DataView = DataView$3;

var getNative$3 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var Promise$3 = getNative$3(root$5, 'Promise');

var _Promise = Promise$3;

var getNative$2 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$2(root$4, 'Set');

var _Set = Set$3;

var getNative$1 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$3 = getNative$1(root$3, 'WeakMap');

var _WeakMap = WeakMap$3;

var DataView$2 = _DataView,
    Map$2 = _Map,
    Promise$2 = _Promise,
    Set$2 = _Set,
    WeakMap$2 = _WeakMap,
    baseGetTag$1 = _baseGetTag,
    toSource$1 = _toSource;

/** `Object#toString` result references. */
var mapTag$5 = '[object Map]',
    objectTag$5 = '[object Object]',
    promiseTag$1 = '[object Promise]',
    setTag$5 = '[object Set]',
    weakMapTag$3 = '[object WeakMap]';

var dataViewTag$4 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString$1 = toSource$1(DataView$2),
    mapCtorString$1 = toSource$1(Map$2),
    promiseCtorString$1 = toSource$1(Promise$2),
    setCtorString$1 = toSource$1(Set$2),
    weakMapCtorString$1 = toSource$1(WeakMap$2);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$3 = baseGetTag$1;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$2 && getTag$3(new DataView$2(new ArrayBuffer(1))) != dataViewTag$4) ||
    (Map$2 && getTag$3(new Map$2) != mapTag$5) ||
    (Promise$2 && getTag$3(Promise$2.resolve()) != promiseTag$1) ||
    (Set$2 && getTag$3(new Set$2) != setTag$5) ||
    (WeakMap$2 && getTag$3(new WeakMap$2) != weakMapTag$3)) {
  getTag$3 = function(value) {
    var result = baseGetTag$1(value),
        Ctor = result == objectTag$5 ? value.constructor : undefined,
        ctorString = Ctor ? toSource$1(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1: return dataViewTag$4;
        case mapCtorString$1: return mapTag$5;
        case promiseCtorString$1: return promiseTag$1;
        case setCtorString$1: return setTag$5;
        case weakMapCtorString$1: return weakMapTag$3;
      }
    }
    return result;
  };
}

var _getTag = getTag$3;

var Stack$2 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag$2 = _getTag,
    isArray$3 = isArray_1,
    isBuffer$1 = isBuffer$3.exports,
    isTypedArray$1 = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    objectTag$4 = '[object Object]';

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$f.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$3(object),
      othIsArr = isArray$3(other),
      objTag = objIsArr ? arrayTag$2 : getTag$2(object),
      othTag = othIsArr ? arrayTag$2 : getTag$2(other);

  objTag = objTag == argsTag$3 ? objectTag$4 : objTag;
  othTag = othTag == argsTag$3 ? objectTag$4 : othTag;

  var objIsObj = objTag == objectTag$4,
      othIsObj = othTag == objectTag$4,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$2);
    return (objIsArr || isTypedArray$1(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$b.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$b.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$2);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$2);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$2 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$2(value) && !isObjectLike$2(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}

var _baseIsEqual = baseIsEqual$2;

var Stack$1 = _Stack,
    baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$1;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$4 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$4(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$1 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var castPath = _castPath,
    toKey$3 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$2(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$3(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$2;

var baseGet$1 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$2(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$1(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$2;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$1;

var baseIsEqual = _baseIsEqual,
    get$1 = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$2 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$2(path), srcValue);
  }
  return function(object) {
    var objValue = get$1(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$1(value) {
  return value;
}

var identity_1 = identity$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey$1 = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity = identity_1,
    isArray$2 = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$2(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray$2(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$2;

var baseAssignValue$2 = _baseAssignValue,
    baseForOwn$1 = _baseForOwn,
    baseIteratee$1 = _baseIteratee;

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee$1(iteratee);

  baseForOwn$1(object, function(value, key, object) {
    baseAssignValue$2(result, key, iteratee(value, key, object));
  });
  return result;
}

var mapValues_1 = mapValues;

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function () {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function (key) {
  return this._values[key]
};
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values)) this._size++;

  return (this._values[key] = value)
};

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512;

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE);

var propertyExpr = {
  Cache: Cache,

  split: split,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path);

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0;
        var len = parts.length;
        var data = obj;

        while (index < len - 1) {
          var part = parts[index];
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]];
        }
        data[parts[index]] = value;
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path);
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length;
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]];
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
  },
};

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split(path) {
  return path.match(SPLIT_REGEX) || ['']
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;

  for (idx = 0; idx < len; idx++) {
    part = parts[idx];

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }

      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);

      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}

const prefixes$1 = {
  context: '$',
  value: '.'
};
function create$4(key, options) {
  return new Reference(key, options);
}
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes$1.context;
    this.isValue = this.key[0] === prefixes$1.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes$1.context : this.isValue ? prefixes$1.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }

  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */


  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }

  resolve() {
    return this;
  }

  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }

  toString() {
    return `Ref(${this.key})`;
  }

  static isRef(value) {
    return value && value.__isYupRef;
  }

} // @ts-ignore

Reference.prototype.__isYupRef = true;

function _extends$X() { _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose$5(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError(overrides = {}) {
      const nextParams = mapValues_1(_extends$X({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    let ctx = _extends$X({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }

      return;
    }

    let result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}

let trim$1 = part => part.substr(0, part.length - 1).substr(1);

function getIn$1(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExpr.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim$1(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });

    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

class ReferenceSet {
  constructor() {
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }

  get size() {
    return this.list.size + this.refs.size;
  }

  describe() {
    const description = [];

    for (const item of this.list) description.push(item);

    for (const [, ref] of this.refs) description.push(ref.describe());

    return description;
  }

  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }

  resolveAll(resolve) {
    return this.toArray().reduce((acc, e) => acc.concat(Reference.isRef(e) ? resolve(e) : e), []);
  }

  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }

  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }

  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }

  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }

}

function _extends$W() { _extends$W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = _extends$W({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  get _type() {
    return this.type;
  }

  _typeCheck(_value) {
    return true;
  }

  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    } // if the nested value is a schema we can skip cloning, since
    // they are already immutable


    const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = _extends$W({}, this.exclusiveTests); // @ts-expect-error this is readonly

    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone$1(_extends$W({}, this.spec, spec));
    return next;
  }

  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }

  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  } // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }


  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }

  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();

    const mergedSpec = _extends$W({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
    //   mergedSpec.nullable = base.spec.nullable;
    // if (combined.spec.presence === UNSET)
    //   mergedSpec.presence = base.spec.presence;


    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
    // the deduping logic is consistent

    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }

  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }

  resolve(options) {
    let schema = this;

    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }

    return schema;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */


  cast(value, options = {}) {
    let resolvedSchema = this.resolve(_extends$W({
      value
    }, options));

    let result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }

    return result;
  }

  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);

    if (value === undefined) {
      value = this.getDefault();
    }

    return value;
  }

  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;

    if (!strict) {
      // this._validating = true;
      value = this._cast(value, _extends$W({
        assert: false
      }, options)); // this._validating = false;
    } // value is cast, we can check if it meets type requirements


    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    let finalTests = [];
    if (this._whitelistError) finalTests.push(this._whitelistError);
    if (this._blacklistError) finalTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests.concat(finalTests),
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }

  validate(value, options, maybeCb) {
    let schema = this.resolve(_extends$W({}, options, {
      value
    })); // callback case is for nested validations

    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }

  validateSync(value, options) {
    let schema = this.resolve(_extends$W({}, options, {
      value
    }));
    let result;

    schema._validate(value, _extends$W({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });

    return result;
  }

  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }

  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }

  _getDefault() {
    let defaultValue = this.spec.default;

    if (defaultValue == null) {
      return defaultValue;
    }

    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone$1(defaultValue);
  }

  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }

  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }

    let next = this.clone({
      default: def
    });
    return next;
  }

  strict(isStrict = true) {
    let next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }

  _isPresent(value) {
    return value != null;
  }

  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,

      test(value) {
        return value !== undefined;
      }

    });
  }

  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,

      test(value) {
        return this.schema._isPresent(value);
      }

    }));
  }

  notRequired() {
    let next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }

  nullable(isNullable = true) {
    let next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }

  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */


  test(...args) {
    let opts;

    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }

    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  }

  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }

    let next = this.clone();
    let deps = toArray$2(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new Condition(deps, options));
    return next;
  }

  typeError(message) {
    let next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',

      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }

    });
    return next;
  }

  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',

      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: valids.toArray().join(', '),
            resolved
          }
        });
      }

    });
    return next;
  }

  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',

      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: invalids.toArray().join(', '),
            resolved
          }
        });
        return true;
      }

    });
    return next;
  }

  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars

// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;

for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn$1(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], _extends$W({}, options, {
    parent,
    path
  }));
};

for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;

for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;

const Mixed = BaseSchema;

Mixed.prototype;

const isAbsent = value => value == null;

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

let isTrimmed = value => isAbsent(value) || value === value.trim();

let objStringTag = {}.toString();
function create$3() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }

  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }

  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;

    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }

  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }

  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }

  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  } //-- transforms --


  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }

  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }

  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }

  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }

}
create$3.prototype = StringSchema.prototype; //
// String Interfaces
//

let isNaN$1 = value => value != +value;

function create$2() {
  return new NumberSchema();
}
class NumberSchema extends BaseSchema {
  constructor() {
    super({
      type: 'number'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        let parsed = value;

        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

          parsed = +parsed;
        }

        if (this.isType(parsed)) return parsed;
        return parseFloat(parsed);
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !isNaN$1(value);
  }

  min(min, message = number.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value >= this.resolve(min);
      }

    });
  }

  max(max, message = number.max) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value <= this.resolve(max);
      }

    });
  }

  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        less
      },

      test(value) {
        return isAbsent(value) || value < this.resolve(less);
      }

    });
  }

  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        more
      },

      test(value) {
        return isAbsent(value) || value > this.resolve(more);
      }

    });
  }

  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }

  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }

  integer(message = number.integer) {
    return this.test({
      name: 'integer',
      message,
      test: val => isAbsent(val) || Number.isInteger(val)
    });
  }

  truncate() {
    return this.transform(value => !isAbsent(value) ? value | 0 : value);
  }

  round(method) {
    var _method;

    let avail = ['ceil', 'floor', 'round', 'trunc'];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(value => !isAbsent(value) ? Math[method](value) : value);
  }

}
create$2.prototype = NumberSchema.prototype; //
// Number Interfaces
//

/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) struct[k] = +struct[k] || 0; // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}

// @ts-ignore
let invalidDate = new Date('');

let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
class DateSchema extends BaseSchema {
  constructor() {
    super({
      type: 'date'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        value = parseIsoDate(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
  }

  _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  }

  prepareParam(ref, name) {
    let param;

    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }

    return param;
  }

  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value >= this.resolve(limit);
      }

    });
  }

  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value <= this.resolve(limit);
      }

    });
  }

}
DateSchema.INVALID_DATE = invalidDate;
DateSchema.prototype;

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce = arrayReduce$1;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyOf$1(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf$1;

var basePropertyOf = _basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter$1 = basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter$1;

var deburrLetter = _deburrLetter,
    toString$4 = toString_1;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$3 = '\\u0300-\\u036f',
    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3;

/** Used to compose unicode capture groups. */
var rsCombo$2 = '[' + rsComboRange$3 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$2, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr$1(string) {
  string = toString$4(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr$1;

/** Used to match words composed of alphanumeric characters. */

var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords$1;

/** Used to detect strings that need a more robust regexp to match words. */

var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord$1;

/** Used to compose unicode character classes. */

var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$2 = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboRange$2 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$2 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords$1;

var asciiWords = _asciiWords,
    hasUnicodeWord = _hasUnicodeWord,
    toString$3 = toString_1,
    unicodeWords = _unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words$1(string, pattern, guard) {
  string = toString$3(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

var words_1 = words$1;

var arrayReduce = _arrayReduce,
    deburr = deburr_1,
    words = words_1;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder$2(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

var _createCompounder = createCompounder$2;

var createCompounder$1 = _createCompounder;

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder$1(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

var snakeCase_1 = snakeCase;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$1;

var baseSlice = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

var _castSlice = castSlice$1;

/** Used to compose unicode character classes. */

var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$1 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboRange$1 + rsVarRange$1 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$2;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray$1;

/** Used to compose unicode character classes. */

var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray$1;

var asciiToArray = _asciiToArray,
    hasUnicode$1 = _hasUnicode,
    unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

var _stringToArray = stringToArray$1;

var castSlice = _castSlice,
    hasUnicode = _hasUnicode,
    stringToArray = _stringToArray,
    toString$2 = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$2(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;

var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst$1 = createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst$1;

var toString$1 = toString_1,
    upperFirst = upperFirst_1;

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize$1(string) {
  return upperFirst(toString$1(string).toLowerCase());
}

var capitalize_1 = capitalize$1;

var capitalize = capitalize_1,
    createCompounder = _createCompounder;

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

var camelCase_1 = camelCase;

var baseAssignValue$1 = _baseAssignValue,
    baseForOwn = _baseForOwn,
    baseIteratee = _baseIteratee;

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys$1(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue$1(result, iteratee(value, key, object), value);
  });
  return result;
}

var mapKeys_1 = mapKeys$1;

var toposort$1 = {exports: {}};

/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

toposort$1.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
};

toposort$1.exports.array = toposort;

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes);

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  });

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch(e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true;

    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);

    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i)
      predecessors.delete(node);
    }

    sorted[--cursor] = node;
  }
}

function uniqueNodes(arr){
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res
}

function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));

  function addNode(depPath, key) {
    let node = propertyExpr.split(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }

  for (const key in fields) if (has_1(fields, key)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }

  return toposort$1.exports.array(Array.from(nodes), edges).reverse();
}

function findIndex$1(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;

    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex$1(keys, a) - findIndex$1(keys, b);
  };
}

function _extends$V() { _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

let isObject$3 = obj => Object.prototype.toString.call(obj) === '[object Object]';

function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}

const defaultSort = sortByKeyOrder([]);
class ObjectSchema extends BaseSchema {
  constructor(spec) {
    super({
      type: 'object'
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      this.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }

        if (this.isType(value)) return value;
        return null;
      });

      if (spec) {
        this.shape(spec);
      }
    });
  }

  _typeCheck(value) {
    return isObject$3(value) || typeof value === 'function';
  }

  _cast(_value, options = {}) {
    var _options$stripUnknown;

    let value = super._cast(_value, options); //should ignore nulls here


    if (value === undefined) return this.getDefault();
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;

    let props = this._nodes.concat(Object.keys(value).filter(v => this._nodes.indexOf(v) === -1));

    let intermediateValue = {}; // is filled during the transform below

    let innerOptions = _extends$V({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });

    let isChanged = false;

    for (const prop of props) {
      let field = fields[prop];
      let exists = has_1(value, prop);

      if (field) {
        let fieldValue;
        let inputValue = value[prop]; // safe to mutate since this is fired in sequence

        innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];

        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = 'spec' in field ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;

        if (fieldSpec == null ? void 0 : fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }

        fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];

        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }

      if (intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }

    return isChanged ? intermediateValue : value;
  }

  _validate(_value, opts = {}, callback) {
    let errors = [];
    let {
      sync,
      from = [],
      originalValue = _value,
      abortEarly = this.spec.abortEarly,
      recursive = this.spec.recursive
    } = opts;
    from = [{
      schema: this,
      value: originalValue
    }, ...from]; // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating

    opts.__validating = true;
    opts.originalValue = originalValue;
    opts.from = from;

    super._validate(_value, opts, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || abortEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !isObject$3(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value;

      let tests = this._nodes.map(key => (_, cb) => {
        let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
        let field = this.fields[key];

        if (field && 'validate' in field) {
          field.validate(value[key], _extends$V({}, opts, {
            // @ts-ignore
            path,
            from,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: true,
            parent: value,
            originalValue: originalValue[key]
          }), cb);
          return;
        }

        cb(null);
      });

      runTests({
        sync,
        tests,
        value,
        errors,
        endEarly: abortEarly,
        sort: this._sortErrors,
        path: opts.path
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.fields = _extends$V({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;

    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];

      if (target === undefined) {
        nextFields[field] = schemaOrRef;
      } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
        nextFields[field] = schemaOrRef.concat(target);
      }
    }

    return next.withMutation(() => next.shape(nextFields, this._excludedEdges));
  }

  getDefaultFromShape() {
    let dft = {};

    this._nodes.forEach(key => {
      const field = this.fields[key];
      dft[key] = 'default' in field ? field.getDefault() : undefined;
    });

    return dft;
  }

  _getDefault() {
    if ('default' in this.spec) {
      return super._getDefault();
    } // if there is no default set invent one


    if (!this._nodes.length) {
      return undefined;
    }

    return this.getDefaultFromShape();
  }

  shape(additions, excludes = []) {
    let next = this.clone();
    let fields = Object.assign(next.fields, additions);
    next.fields = fields;
    next._sortErrors = sortByKeyOrder(Object.keys(fields));

    if (excludes.length) {
      // this is a convenience for when users only supply a single pair
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      next._excludedEdges = [...next._excludedEdges, ...excludes];
    }

    next._nodes = sortFields(fields, next._excludedEdges);
    return next;
  }

  pick(keys) {
    const picked = {};

    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }

    return this.clone().withMutation(next => {
      next.fields = {};
      return next.shape(picked);
    });
  }

  omit(keys) {
    const next = this.clone();
    const fields = next.fields;
    next.fields = {};

    for (const key of keys) {
      delete fields[key];
    }

    return next.withMutation(() => next.shape(fields));
  }

  from(from, to, alias) {
    let fromGetter = propertyExpr.getter(from, true);
    return this.transform(obj => {
      if (obj == null) return obj;
      let newObj = obj;

      if (has_1(obj, from)) {
        newObj = _extends$V({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  }

  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,

      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }

    });
    next.spec.noUnknown = noAllow;
    return next;
  }

  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }

  transformKeys(fn) {
    return this.transform(obj => obj && mapKeys_1(obj, (_, key) => fn(key)));
  }

  camelCase() {
    return this.transformKeys(camelCase_1);
  }

  snakeCase() {
    return this.transformKeys(snakeCase_1);
  }

  constantCase() {
    return this.transformKeys(key => snakeCase_1(key).toUpperCase());
  }

  describe() {
    let base = super.describe();
    base.fields = mapValues_1(this.fields, value => value.describe());
    return base;
  }

}
function create$1(spec) {
  return new ObjectSchema(spec);
}
create$1.prototype = ObjectSchema.prototype;

function addMethod(schemaType, name, fn) {
  if (!schemaType || !isSchema(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}

var dist = {};

var passwordValidator$1 = {};

var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(passwordValidator$1, "__esModule", { value: true });
passwordValidator$1.PasswordValidatorBuilder = passwordValidator$1.DefaultPasswordTestId = passwordValidator$1.PasswordValidator = void 0;
var PasswordValidator = /** @class */ (function () {
    function PasswordValidator(tests) {
        this.tests = tests;
    }
    PasswordValidator.prototype.validate = function (password) {
        var result = this.tests.reduce(function (prev, current) {
            var passed = current.test(password);
            return passed
                ? __assign(__assign({}, prev), { passedTests: __spreadArray(__spreadArray([], prev.passedTests, true), [current.testId], false) }) : __assign(__assign({}, prev), { failedTests: __spreadArray(__spreadArray([], prev.failedTests, true), [current.testId], false), errors: __spreadArray(__spreadArray([], prev.errors, true), [current.error], false) });
        }, {
            passedTests: [],
            failedTests: [],
            errors: [],
        });
        return {
            success: result.passedTests.length === this.tests.length,
            passedTests: result.passedTests,
            failedTests: result.failedTests,
            errors: result.errors,
        };
    };
    return PasswordValidator;
}());
passwordValidator$1.PasswordValidator = PasswordValidator;
var DefaultPasswordTestId;
(function (DefaultPasswordTestId) {
    DefaultPasswordTestId["HasLowercase"] = "HasLowercase";
    DefaultPasswordTestId["HasUppercase"] = "HasUppercase";
    DefaultPasswordTestId["HasNumbers"] = "HasNumbers";
    DefaultPasswordTestId["HasSymbols"] = "HasSymbols";
    DefaultPasswordTestId["HasLengthPrefix"] = "HasLength";
})(DefaultPasswordTestId || (passwordValidator$1.DefaultPasswordTestId = DefaultPasswordTestId = {}));
var PasswordValidatorBuilder = /** @class */ (function () {
    function PasswordValidatorBuilder() {
        this.tests = [];
    }
    PasswordValidatorBuilder.prototype.build = function () {
        return new PasswordValidator(this.tests);
    };
    PasswordValidatorBuilder.prototype.hasRegex = function (regex, testId, error) {
        this.tests.push({
            testId: testId,
            test: function (password) { return regex.test(password); },
            error: error,
        });
        return this;
    };
    PasswordValidatorBuilder.prototype.hasLowercase = function (error) {
        return this.hasRegex(/^(?=.*[\p{Ll}])/u, DefaultPasswordTestId.HasLowercase, error !== null && error !== void 0 ? error : "The password must contain at least one lowercase letter.");
    };
    PasswordValidatorBuilder.prototype.hasUppercase = function (error) {
        return this.hasRegex(/^(?=.*[\p{Lu}])/u, DefaultPasswordTestId.HasUppercase, error !== null && error !== void 0 ? error : "The password must contain at least one uppercase letter.");
    };
    PasswordValidatorBuilder.prototype.hasNumbers = function (error) {
        return this.hasRegex(/^(?=.*[\p{N}])/u, DefaultPasswordTestId.HasNumbers, error !== null && error !== void 0 ? error : "The password must contain at least one number.");
    };
    PasswordValidatorBuilder.prototype.hasSymbols = function (error) {
        return this.hasRegex(/^(?=.*[^a-zA-Z0-9])/, // considered non-latin letter, number are also symbols, e.g in VN: á,ô
        DefaultPasswordTestId.HasSymbols, error !== null && error !== void 0 ? error : "The password must contain at least one special symbol.");
    };
    PasswordValidatorBuilder.prototype.hasLength = function (length, error) {
        return this.hasRegex(RegExp("^(?=.{".concat(length, ",})")), "".concat(DefaultPasswordTestId.HasLengthPrefix).concat(length), error !== null && error !== void 0 ? error : "The password must be at least ".concat(length, " characters long."));
    };
    return PasswordValidatorBuilder;
}());
passwordValidator$1.PasswordValidatorBuilder = PasswordValidatorBuilder;

var astridPasswordValidator = {};

(function (exports) {
	var _a;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AstridPasswordValidator = exports.PasswordStrengthLevelValue = exports.PasswordStrengthLevel = void 0;
	var passwordValidator_1 = passwordValidator$1;
	var PasswordStrengthLevel;
	(function (PasswordStrengthLevel) {
	    PasswordStrengthLevel["Weak"] = "Weak";
	    PasswordStrengthLevel["Medium"] = "Medium";
	    PasswordStrengthLevel["Strong"] = "Strong";
	})(PasswordStrengthLevel || (exports.PasswordStrengthLevel = PasswordStrengthLevel = {}));
	exports.PasswordStrengthLevelValue = (_a = {},
	    _a[PasswordStrengthLevel.Weak] = 0,
	    _a[PasswordStrengthLevel.Medium] = 1,
	    _a[PasswordStrengthLevel.Strong] = 2,
	    _a);
	var AstridPasswordValidator = /** @class */ (function () {
	    /**
	     * Default password strength policy for Astrid users
	     * @param targetLevel minimum level the passwod strength should have
	     */
	    function AstridPasswordValidator(targetLevel) {
	        if (targetLevel === void 0) { targetLevel = PasswordStrengthLevel.Medium; }
	        this.targetLevel = targetLevel;
	        this.mediumPasswordValidator = new passwordValidator_1.PasswordValidatorBuilder()
	            .hasLowercase()
	            .hasUppercase()
	            .hasNumbers()
	            .hasSymbols()
	            .hasLength(8)
	            .build();
	        this.strongPasswordValidator = new passwordValidator_1.PasswordValidatorBuilder()
	            .hasLowercase()
	            .hasUppercase()
	            .hasNumbers()
	            .hasSymbols()
	            .hasLength(12)
	            .build();
	        // The level medium is minimum requirement from the pen test
	    }
	    AstridPasswordValidator.prototype.validate = function (password) {
	        var _this = this;
	        var mediumTest = this.mediumPasswordValidator.validate(password);
	        var strongTest = this.strongPasswordValidator.validate(password);
	        var level = strongTest.success
	            ? PasswordStrengthLevel.Strong
	            : mediumTest.success
	                ? PasswordStrengthLevel.Medium
	                : PasswordStrengthLevel.Weak;
	        var targetTestResult = (function () {
	            switch (_this.targetLevel) {
	                case PasswordStrengthLevel.Weak:
	                    return {
	                        passedTests: [],
	                        failedTests: [],
	                        errors: [],
	                    };
	                case PasswordStrengthLevel.Medium:
	                    return mediumTest;
	                case PasswordStrengthLevel.Strong:
	                    return strongTest;
	            }
	        })();
	        return {
	            success: exports.PasswordStrengthLevelValue[level] >= exports.PasswordStrengthLevelValue[this.targetLevel],
	            level: level,
	            passedTests: targetTestResult.passedTests,
	            failedTests: targetTestResult.failedTests,
	            errors: targetTestResult.errors,
	        };
	    };
	    return AstridPasswordValidator;
	}());
	exports.AstridPasswordValidator = AstridPasswordValidator;
	
} (astridPasswordValidator));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(passwordValidator$1, exports);
	__exportStar(astridPasswordValidator, exports);
	
} (dist));

var onRightOrLeftKeyboardArrows = function (onRightCallback, onLeftCallback) {
    var onEventFired = function (event) {
        if (event.code === 'ArrowRight' || event.keyCode === 39) {
            onRightCallback();
        }
        else if (event.code === 'ArrowLeft' || event.keyCode === 37) {
            onLeftCallback();
        }
    };
    document.addEventListener('keyup', onEventFired);
    return onEventFired; // return event function to be able to cleanup it in onWillUnmounted hook if need
};
var passwordValidator = new dist.AstridPasswordValidator();
addMethod(create$3, 'astridPassword', function (message) {
    return this.test('astridPassword', message, function (value) {
        if (value) {
            var result = passwordValidator.validate(value);
            if (!result.success) {
                var errorMessage = result.failedTests
                    .map(function (testId) {
                    if (testId.startsWith(dist.DefaultPasswordTestId.HasLengthPrefix)) {
                        return 'at least 8 characters long';
                    }
                    switch (testId) {
                        case dist.DefaultPasswordTestId.HasLowercase:
                            return 'lowercase letter';
                        case dist.DefaultPasswordTestId.HasUppercase:
                            return 'uppercase letter';
                        case dist.DefaultPasswordTestId.HasNumbers:
                            return 'numbers';
                        case dist.DefaultPasswordTestId.HasSymbols:
                            return 'symbols';
                    }
                })
                    .join(', ');
                throw this.createError({
                    message: "The password must contains: ".concat(errorMessage)
                });
            }
        }
        return true;
    });
});
var ValidationRules = {
    required: create$3().required('Required'),
    requiredNum: create$2().required('Required'),
    name: create$3()
        .max(50, 'Must be at most 50 chars.')
        .matches(/^[a-zA-Z\u00c0-\u017e ,.'-]+$/i, 'Only letters allowed'),
    email: create$3()
        .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i, 'Email format is not valid.')
        .required('Required'),
    emailNotRequired: create$3().matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i, 'Email format is not valid.'),
    studentPassword: create$3()
        .required('Required')
        .max(128, 'Password must be at most 128 chars.')
        .matches(/^(?=.*\d)(?=.*[a-zA-Z])[0-9a-zA-Z\u00c0-\u017e !?@#$%^&*_\-\=\+\(\)\\\{\}\[\]:;\"\'\<\>,.\/\`\~]{5,}$/, 'Required at least 5 characters including number and upper or lower case.'),
    password: create$3().required('Required')
        // custom validation
        .astridPassword()
};
var buildSanaVoiceSentenceURL = function (_a) {
    var sentence = _a.sentence, _b = _a.country, country = _b === void 0 ? 'US' : _b, _c = _a.sanaApiUrl, sanaApiUrl = _c === void 0 ? '' : _c;
    return "".concat(sanaApiUrl, "/google/textToSpeech?text=").concat(encodeURIComponent(sentence), "&country=").concat(encodeURIComponent(country));
};
var sortBooksByCEFR = function (books) {
    var booksToReturn = [];
    var booksWithCEFR = books.filter(function (b) { return !!b.cefrLevel; });
    var booksWithoutCEFR = books.filter(function (b) { return !b.cefrLevel; });
    booksToReturn.push.apply(booksToReturn, booksWithCEFR.sort(function (a, b) { return a.cefrLevel.localeCompare(b.cefrLevel); }));
    booksToReturn.push.apply(booksToReturn, booksWithoutCEFR);
    return booksToReturn;
};

var css_248z$x = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.listen-sentence, .listen-sentence--no-text, .listen-sentence--jump, .listen-sentence--playing {\n  border-radius: 14px;\n  width: fit-content;\n  margin-bottom: 2px;\n}\n.listen-sentence svg, .listen-sentence--no-text svg, .listen-sentence--jump svg, .listen-sentence--playing svg {\n  margin-right: 6px;\n}\n.listen-sentence--playing {\n  padding-bottom: 1px;\n  animation: play-pulse 1s infinite;\n}\n.listen-sentence--jump {\n  animation: jump 1s 2;\n}\n.listen-sentence--no-text svg {\n  margin: 0;\n}\n@keyframes jump {\n  0% {\n    transform: scale(1);\n  }\n  25% {\n    transform: scale(1.3);\n  }\n  50% {\n    transform: scale(1);\n  }\n  75% {\n    transform: scale(1.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes play-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);\n  }\n}";
styleInject(css_248z$x);

var ListenSentence = /** @class */ (function (_super) {
    __extends(ListenSentence, _super);
    function ListenSentence(props) {
        var _this = _super.call(this, props) || this;
        _this.audioSentence = new Audio(_this.props.recordingUrl
            ? _this.props.recordingUrl
            : buildSanaVoiceSentenceURL({
                sentence: _this.props.sentence,
                country: _this.props.country,
                sanaApiUrl: _this.props.sanaApiUrl
            }));
        _this.state = {
            playing: false
        };
        _this.onClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!this.state.playing) return [3 /*break*/, 1];
                        this.audioSentence.pause();
                        (_b = (_a = this.props).onPause) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [3 /*break*/, 5];
                    case 1:
                        this.audioSentence.currentTime = 0;
                        _e.label = 2;
                    case 2:
                        _e.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.audioSentence.play()];
                    case 3:
                        _e.sent();
                        (_d = (_c = this.props).onPlay) === null || _d === void 0 ? void 0 : _d.call(_c);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _e.sent();
                        this.props.onPlayError && this.props.onPlayError(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.stopPlaying = function () {
            if (_this.state.playing) {
                _this.audioSentence.pause();
            }
        };
        _this.audioSentence.onplay = function () { return _this.setState({ playing: true }); };
        _this.audioSentence.onended = function () { return _this.setState({ playing: false }); };
        _this.audioSentence.onpause = function () { return _this.setState({ playing: false }); };
        return _this;
    }
    ListenSentence.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.sentence !== this.props.sentence) {
            this.audioSentence.pause();
            this.audioSentence = new Audio(buildSanaVoiceSentenceURL({
                sentence: this.props.sentence,
                country: this.props.country,
                sanaApiUrl: this.props.sanaApiUrl
            }));
        }
    };
    ListenSentence.prototype.componentWillUnmount = function () {
        this.audioSentence.pause();
    };
    ListenSentence.prototype.render = function () {
        var className = cx({
            'listen-sentence': !this.state.playing && !this.props.jump,
            'listen-sentence--playing': this.state.playing,
            'listen-sentence--jump': this.props.jump,
            'listen-sentence--no-text': this.props.hideText
        });
        return (React__default["default"].createElement("div", { className: className },
            React__default["default"].createElement(Button, { variant: "outlined", size: "small", onClick: this.onClick },
                React__default["default"].createElement(SvgSpeaker, { "aria-hidden": "true", focusable: "false" }),
                " ",
                this.props.hideText ? '' : 'Listen')));
    };
    return ListenSentence;
}(React.Component));

// Copied from https://github.com/chris-rudmin/Recorderjs

var waveEncoder = () => {
  let BYTES_PER_SAMPLE = 2;

  let recorded = [];

  function encode (buffer) {
    let length = buffer.length;
    let data = new Uint8Array(length * BYTES_PER_SAMPLE);
    for (let i = 0; i < length; i++) {
      let index = i * BYTES_PER_SAMPLE;
      let sample = buffer[i];
      if (sample > 1) {
        sample = 1;
      } else if (sample < -1) {
        sample = -1;
      }
      sample = sample * 32768;
      data[index] = sample;
      data[index + 1] = sample >> 8;
    }
    recorded.push(data);
  }

  function dump (sampleRate) {
    let bufferLength = recorded.length ? recorded[0].length : 0;
    let length = recorded.length * bufferLength;
    let wav = new Uint8Array(44 + length);
    let view = new DataView(wav.buffer);

    // RIFF identifier 'RIFF'
    view.setUint32(0, 1380533830, false);
    // file length minus RIFF identifier length and file description length
    view.setUint32(4, 36 + length, true);
    // RIFF type 'WAVE'
    view.setUint32(8, 1463899717, false);
    // format chunk identifier 'fmt '
    view.setUint32(12, 1718449184, false);
    // format chunk length
    view.setUint32(16, 16, true);
    // sample format (raw)
    view.setUint16(20, 1, true);
    // channel count
    view.setUint16(22, 1, true);
    // sample rate
    view.setUint32(24, sampleRate, true);
    // byte rate (sample rate * block align)
    view.setUint32(28, sampleRate * BYTES_PER_SAMPLE, true);
    // block align (channel count * bytes per sample)
    view.setUint16(32, BYTES_PER_SAMPLE, true);
    // bits per sample
    view.setUint16(34, 8 * BYTES_PER_SAMPLE, true);
    // data chunk identifier 'data'
    view.setUint32(36, 1684108385, false);
    // data chunk length
    view.setUint32(40, length, true);

    // eslint-disable-next-line unicorn/no-for-loop
    for (let i = 0; i < recorded.length; i++) {
      wav.set(recorded[i], i * bufferLength + 44);
    }

    recorded = [];
    postMessage(wav.buffer, [wav.buffer]);
  }

  onmessage = e => {
    if (e.data[0] === 'encode') {
      encode(e.data[1]);
    } else if (e.data[0] === 'dump') {
      dump(e.data[1]);
    }
  };
};

let AudioContext$1 = window.AudioContext || window.webkitAudioContext;

function createWorker (fn) {
  let js = fn
    .toString()
    .replace(/^(\(\)\s*=>|function\s*\(\))\s*{/, '')
    .replace(/}$/, '');
  let blob = new Blob([js]);
  return new Worker(URL.createObjectURL(blob))
}

function error$1 (method) {
  let event = new Event('error');
  event.data = new Error('Wrong state for ' + method);
  return event
}

let context, processor;

/**
 * Audio Recorder with MediaRecorder API.
 *
 * @example
 * navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
 *   let recorder = new MediaRecorder(stream)
 * })
 */
class MediaRecorder {
  /**
   * @param {MediaStream} stream The audio stream to record.
   */
  constructor (stream) {
    /**
     * The `MediaStream` passed into the constructor.
     * @type {MediaStream}
     */
    this.stream = stream;

    /**
     * The current state of recording process.
     * @type {"inactive"|"recording"|"paused"}
     */
    this.state = 'inactive';

    this.em = document.createDocumentFragment();
    this.encoder = createWorker(MediaRecorder.encoder);

    let recorder = this;
    this.encoder.addEventListener('message', e => {
      let event = new Event('dataavailable');
      event.data = new Blob([e.data], { type: recorder.mimeType });
      recorder.em.dispatchEvent(event);
      if (recorder.state === 'inactive') {
        recorder.em.dispatchEvent(new Event('stop'));
      }
    });
  }

  /**
   * Begins recording media.
   *
   * @param {number} [timeslice] The milliseconds to record into each `Blob`.
   *                             If this parameter isn’t included, single `Blob`
   *                             will be recorded.
   *
   * @return {undefined}
   *
   * @example
   * recordButton.addEventListener('click', () => {
   *   recorder.start()
   * })
   */
  start (timeslice) {
    if (this.state !== 'inactive') {
      return this.em.dispatchEvent(error$1('start'))
    }

    this.state = 'recording';

    if (!context) {
      context = new AudioContext$1();
    }
    this.clone = this.stream.clone();
    this.input = context.createMediaStreamSource(this.clone);

    if (!processor) {
      processor = context.createScriptProcessor(2048, 1, 1);
    }

    let recorder = this;

    recorder.encoder.postMessage(['init', context.sampleRate]);

    processor.onaudioprocess = function (e) {
      if (recorder.state === 'recording') {
        recorder.encoder.postMessage([
          'encode', e.inputBuffer.getChannelData(0)
        ]);
      }
    };

    this.input.connect(processor);
    processor.connect(context.destination);

    this.em.dispatchEvent(new Event('start'));

    if (timeslice) {
      this.slicing = setInterval(() => {
        if (recorder.state === 'recording') recorder.requestData();
      }, timeslice);
    }

    return undefined
  }

  /**
   * Stop media capture and raise `dataavailable` event with recorded data.
   *
   * @return {undefined}
   *
   * @example
   * finishButton.addEventListener('click', () => {
   *   recorder.stop()
   * })
   */
  stop () {
    if (this.state === 'inactive') {
      return this.em.dispatchEvent(error$1('stop'))
    }

    this.requestData();
    this.state = 'inactive';
    this.clone.getTracks().forEach(track => {
      track.stop();
    });
    this.input.disconnect();
    return clearInterval(this.slicing)
  }

  /**
   * Pauses recording of media streams.
   *
   * @return {undefined}
   *
   * @example
   * pauseButton.addEventListener('click', () => {
   *   recorder.pause()
   * })
   */
  pause () {
    if (this.state !== 'recording') {
      return this.em.dispatchEvent(error$1('pause'))
    }

    this.state = 'paused';
    return this.em.dispatchEvent(new Event('pause'))
  }

  /**
   * Resumes media recording when it has been previously paused.
   *
   * @return {undefined}
   *
   * @example
   * resumeButton.addEventListener('click', () => {
   *   recorder.resume()
   * })
   */
  resume () {
    if (this.state !== 'paused') {
      return this.em.dispatchEvent(error$1('resume'))
    }

    this.state = 'recording';
    return this.em.dispatchEvent(new Event('resume'))
  }

  /**
   * Raise a `dataavailable` event containing the captured media.
   *
   * @return {undefined}
   *
   * @example
   * this.on('nextData', () => {
   *   recorder.requestData()
   * })
   */
  requestData () {
    if (this.state === 'inactive') {
      return this.em.dispatchEvent(error$1('requestData'))
    }

    return this.encoder.postMessage(['dump', context.sampleRate])
  }

  /**
   * Add listener for specified event type.
   *
   * @param {"start"|"stop"|"pause"|"resume"|"dataavailable"|"error"}
   * type Event type.
   * @param {function} listener The listener function.
   *
   * @return {undefined}
   *
   * @example
   * recorder.addEventListener('dataavailable', e => {
   *   audio.src = URL.createObjectURL(e.data)
   * })
   */
  addEventListener (...args) {
    this.em.addEventListener(...args);
  }

  /**
   * Remove event listener.
   *
   * @param {"start"|"stop"|"pause"|"resume"|"dataavailable"|"error"}
   * type Event type.
   * @param {function} listener The same function used in `addEventListener`.
   *
   * @return {undefined}
   */
  removeEventListener (...args) {
    this.em.removeEventListener(...args);
  }

  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {Event} event The event object.
   *
   * @return {boolean} Is event was no canceled by any listener.
   */
  dispatchEvent (...args) {
    this.em.dispatchEvent(...args);
  }
}

/**
 * The MIME type that is being used for recording.
 * @type {string}
 */
MediaRecorder.prototype.mimeType = 'audio/wav';

/**
 * Returns `true` if the MIME type specified is one the polyfill can record.
 *
 * This polyfill supports `audio/wav` and `audio/mpeg`.
 *
 * @param {string} mimeType The mimeType to check.
 *
 * @return {boolean} `true` on `audio/wav` and `audio/mpeg` MIME type.
 */
MediaRecorder.isTypeSupported = mimeType => {
  return MediaRecorder.prototype.mimeType === mimeType
};

/**
 * `true` if MediaRecorder can not be polyfilled in the current browser.
 * @type {boolean}
 *
 * @example
 * if (MediaRecorder.notSupported) {
 *   showWarning('Audio recording is not supported in this browser')
 * }
 */
MediaRecorder.notSupported = !navigator.mediaDevices || !AudioContext$1;

/**
 * Converts RAW audio buffer to compressed audio files.
 * It will be loaded to Web Worker.
 * By default, WAVE encoder will be used.
 * @type {function}
 *
 * @example
 * MediaRecorder.prototype.mimeType = 'audio/ogg'
 * MediaRecorder.encoder = oggEncoder
 */
MediaRecorder.encoder = waveEncoder;

var _path$I;
function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }
var SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$U({
    width: "22px",
    height: "30px",
    viewBox: "0 0 22 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _path$I || (_path$I = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11,18.8571429 C13.6085714,18.8571429 15.6985714,16.7514286 15.6985714,14.1428571 L15.7142857,4.71428571 C15.7142857,2.10571429 13.6085714,0 11,0 C8.39142857,0 6.28571429,2.10571429 6.28571429,4.71428571 L6.28571429,14.1428571 C6.28571429,16.7514286 8.39142857,18.8571429 11,18.8571429 Z M20.5542857,14.1428571 C19.8942857,14.1428571 19.3442857,14.6142857 19.25,15.2585714 C18.6685714,19.36 14.9757143,22.1571429 11,22.1571429 C7.02428571,22.1571429 3.33142857,19.3757143 2.75,15.2585714 C2.65571429,14.6142857 2.09,14.1428571 1.44571429,14.1428571 C0.628571429,14.1428571 5.41233725e-16,14.8657143 0.11,15.6671429 C0.832857143,20.3342857 4.76142857,23.9957143 9.42857143,24.7028571 L9.42857143,28.2857143 C9.42857143,29.15 10.1357143,29.8571429 11,29.8571429 C11.8642857,29.8571429 12.5714286,29.15 12.5714286,28.2857143 L12.5714286,24.7028571 C17.2228571,24.0271429 21.1671429,20.3342857 21.89,15.6671429 C22,14.8657143 21.3714286,14.1428571 20.5542857,14.1428571 Z"
  })));
};

var _path$H;
function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }
var SvgTwistedArrow = function SvgTwistedArrow(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$T({
    width: 96,
    height: 66,
    viewBox: "0 0 96 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$H || (_path$H = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.4966 32.7193C21.6753 32.9444 21.8678 33.1732 22.0465 33.3984C22.1015 33.4722 22.1739 33.5358 22.2288 33.6096C22.3988 33.8398 22.5723 34.0562 22.7423 34.2864C23.3857 35.2052 23.9855 36.1494 24.6587 37.039C25.8043 38.5352 26.9586 40.0263 28.1725 41.4589C29.2488 42.7366 30.4057 43.9318 31.5291 45.17C31.8526 45.5224 32.1499 45.89 32.4806 46.2146C32.9956 46.7139 33.5404 47.184 34.0729 47.673C34.4847 48.0561 34.8914 48.4304 35.3032 48.8134C35.4582 48.9582 35.5589 49.1701 35.7371 49.2542C36.0277 49.3903 36.2289 49.6139 36.4723 49.7894C36.6156 49.894 36.7501 50.0036 36.8759 50.1184C37.2225 50.4101 37.5444 50.7398 37.9121 51.0074C38.347 51.3298 38.8188 51.5953 39.266 51.8987C39.7513 52.227 40.2067 52.5845 40.6919 52.9128C41.1201 53.2038 41.5571 53.4897 41.9925 53.753C42.9152 54.308 43.8168 54.8871 44.7677 55.3903C46.6505 56.3841 48.5703 57.3211 50.5629 58.0622C51.4476 58.3921 52.325 58.7499 53.2204 59.0382C54.0882 59.3192 54.9666 59.5585 55.8507 59.7475C57.1076 60.0126 58.3681 60.2639 59.6326 60.442C62.9355 60.8989 66.1982 60.7668 69.3956 59.7426C71.2382 59.1466 72.9339 58.2597 74.4175 56.9906C74.8759 56.5926 75.3138 56.1596 75.743 55.7316C75.9339 55.5374 76.0956 55.3132 76.2866 55.1189C76.3374 55.0656 76.4175 55.0422 76.4925 55.0101C76.5263 54.9079 76.5448 54.7793 76.6151 54.6792C76.9231 54.2045 77.283 53.7582 77.5304 53.26C77.8589 52.6202 78.094 51.9408 78.3988 51.2205C77.888 51.2488 77.4362 51.2778 76.9844 51.3068C74.9739 51.4358 72.9598 51.3786 70.9554 51.1978C68.7184 51.0001 66.523 50.6133 64.3681 49.9554C62.3709 49.3465 60.4676 48.5177 58.6972 47.3756C57.8146 46.8089 56.9915 46.1837 56.2895 45.4053C55.7992 44.868 55.3473 44.2964 54.9216 43.7095C54.7018 43.4142 54.5467 43.0693 54.3881 42.7382C54.1559 42.2617 53.8925 41.7918 53.7492 41.2868C53.3691 40.0373 53.3854 38.744 53.5701 37.4582C53.7799 36.0752 54.2079 34.7647 54.9579 33.5836C55.9896 31.9431 57.425 30.8318 59.2748 30.208C60.5167 29.7871 61.7817 29.7059 63.075 29.773C65.0419 29.8697 66.9169 30.3499 68.7078 31.1268C71.177 32.2013 73.4295 33.6265 75.2549 35.6432C75.5645 35.9919 75.8182 36.3851 76.1016 36.7491C76.2203 36.8916 76.3825 37.0086 76.4924 37.1562C76.9268 37.738 77.3926 38.3133 77.7659 38.9309C78.2147 39.6574 78.5849 40.4298 78.9763 41.1782C79.1796 41.5655 79.3881 41.9616 79.5514 42.3607C79.7861 42.9416 79.991 43.5518 80.1857 44.1445C80.3567 44.6567 80.5052 45.1704 80.6449 45.6893C80.7676 46.1591 80.9043 46.6326 80.9783 47.1193C81.0173 47.4262 81.1734 47.4526 81.4065 47.4103C82.443 47.2391 83.4811 47.0906 84.5126 46.9106C86.9214 46.5012 89.2374 45.7929 91.4074 44.6754C92.3634 44.1864 93.2731 43.6184 94.2084 43.0942C94.4092 42.9767 94.6494 42.7065 94.786 43.18C94.8045 43.2516 94.9832 43.2766 95.1095 43.3322C95.1999 43.3264 95.3287 43.2862 95.4309 43.3206C95.4915 43.344 95.4884 43.4989 95.529 43.6283C95.7128 43.662 95.7411 43.8103 95.6733 44.0148C95.5142 44.5438 95.1461 44.9359 94.7627 45.3018C93.833 46.1759 92.797 46.8885 91.6973 47.5323C89.7599 48.6668 87.6729 49.4059 85.4976 49.914C84.2829 50.2013 83.0616 50.4572 81.8402 50.713C81.6348 50.7626 81.4228 50.7807 81.2749 50.8084C81.1077 51.6837 80.9979 52.537 80.7772 53.361C80.2984 55.1253 79.6101 56.812 78.5465 58.318C77.1646 60.2813 75.4007 61.8323 73.3205 63.0032C71.8564 63.8252 70.2921 64.376 68.6651 64.7398C67.5166 65.0001 66.3445 65.1799 65.1694 65.3145C64.3089 65.4061 63.432 65.3896 62.5551 65.3731C61.6191 65.3558 60.6867 65.3247 59.7636 65.2292C57.598 65.0133 55.4545 64.655 53.3602 64.0205C52.8596 63.8661 52.3698 63.67 51.864 63.5068C51.3357 63.3451 50.7966 63.225 50.2806 63.0443C49.2573 62.6777 48.2464 62.2921 47.239 61.8927C46.5484 61.614 45.8702 61.3163 45.1991 60.9908C44.3689 60.5937 43.5597 60.1724 42.7454 59.7424C41.9829 59.3409 41.224 58.9255 40.4862 58.486C39.7396 58.0517 39.0177 57.5793 38.2871 57.1121C37.7413 56.7603 37.1955 56.4086 36.6481 56.0343C34.906 54.8403 33.1885 53.6083 31.6167 52.1849C30.3208 51.0123 29.0073 49.85 27.757 48.6153C24.7948 45.6978 22.0759 42.5555 19.7138 39.1217C18.4649 37.3091 17.2844 35.433 16.149 33.554C14.9212 31.517 13.8453 29.3794 12.8583 27.2133C11.8404 24.9945 10.9324 22.7233 10.1307 20.4133C9.50004 18.6156 8.87807 16.8128 8.26484 15.0049C7.99213 14.1989 7.76459 13.39 7.50932 12.5737C7.4857 12.4933 7.45848 12.4268 7.37222 12.3596C7.30401 13.0237 7.24967 13.6915 7.1676 14.3519C6.88702 16.4947 6.59772 18.6427 6.29455 20.7869C6.10833 22.0501 5.88565 23.3111 5.67684 24.5757C5.57988 25.1507 5.50191 25.7381 5.39622 26.3182C5.30849 26.8288 5.21562 27.3307 5.0863 27.8304C4.98417 28.1964 4.90258 28.5975 4.49753 28.8465C4.29824 28.1859 4.33514 27.5283 4.30939 26.8839C4.36843 26.8846 4.40488 26.8868 4.45519 26.8927C4.44184 26.8299 4.42849 26.767 4.3915 26.6238C4.46904 26.6962 4.5173 26.7386 4.57943 26.7846C4.58661 26.7569 4.59894 26.7379 4.61485 26.705C4.59071 26.6838 4.56504 26.64 4.52858 26.6378C4.34633 26.6267 4.3381 26.5726 4.37966 26.3834C4.44637 26.097 4.43504 25.7975 4.47402 25.5038C4.55045 24.8937 4.64074 24.2873 4.71717 23.6773C4.79051 23.0219 4.84998 22.3629 4.93718 21.7113C5.02644 21.023 5.07769 20.31 5.25884 19.6386C5.40408 19.106 5.38092 18.5661 5.49843 18.0262C5.68264 17.1999 5.68306 16.34 5.77537 15.4969C5.8205 15.0936 5.89848 14.7064 5.94361 14.3031C5.95644 14.2249 5.8825 14.1387 5.85374 14.0495C5.91483 14.0137 6.00365 13.9853 6.01443 13.9436C6.076 13.6485 6.09599 13.3424 6.15757 13.0472C6.17399 12.9552 6.26844 12.8763 6.33004 12.7813C6.27664 12.7302 6.19038 12.6629 6.06971 12.5569C5.99225 13.0851 5.92556 13.5717 5.85374 14.0495C5.6706 15.358 5.47875 16.6716 5.30435 17.9749C5.08018 19.6137 4.86114 21.2611 4.63698 22.8999C4.51438 23.8314 4.3918 24.7629 4.21888 25.6885C4.15885 26.0063 4.08496 26.3204 4.04752 26.6368C4.03624 26.7376 3.91046 26.823 3.81909 26.9472C3.97319 27.6107 3.85775 28.3142 3.75104 29.0127C3.71052 29.2837 3.40349 29.2397 3.14628 29.2608C3.10461 28.6492 3.0645 28.0603 3.01925 27.4626C3.04847 27.0922 3.08128 26.7079 3.11051 26.3375C3.07405 26.3353 3.05146 26.3367 3.01501 26.3345C2.82252 26.7063 2.82103 27.084 3.01925 27.4626C2.99461 27.5006 2.95251 27.5488 2.94173 27.5904C2.88223 28.0493 2.81401 28.5132 2.77351 28.9844C2.7448 29.2956 2.6606 29.392 2.35717 29.3342C2.18723 29.3041 2.02242 29.2829 1.80216 29.247C1.75281 28.7223 1.69679 28.1663 1.64075 27.6102C1.61817 27.6117 1.58172 27.6095 1.55913 27.6109C1.55558 28.0252 1.56589 28.4431 1.54849 28.8537C1.53875 28.9772 1.67227 29.2052 1.44636 29.2197C1.23433 29.2379 1.24661 29.0187 1.21681 28.8477C1.00463 27.6647 1.06867 26.4731 1.16043 25.2888C1.20708 24.7079 1.19983 24.1351 1.26907 23.5528C1.3419 22.9567 1.3557 22.3597 1.4198 21.7687C1.51672 20.7933 1.63623 19.8165 1.73315 18.8412C1.74443 18.7403 1.74698 18.6446 1.74954 18.5489C1.72695 18.5504 1.69922 18.543 1.67663 18.5445C1.49664 20.2987 1.32177 22.0616 1.11919 23.8172C0.920189 25.559 0.835683 27.3161 0.877993 29.0697C0.855403 29.0711 0.829222 29.0865 0.806627 29.0879C0.766053 28.9586 0.694167 28.8358 0.684912 28.6999C0.657621 28.0328 0.63546 27.3745 0.644623 26.7096C0.653278 26.1039 0.698392 25.5004 0.743502 24.8969C0.85474 23.4657 0.974704 22.0293 1.10853 20.5966C1.21314 19.5343 1.33162 18.4756 1.46395 17.4207C1.5296 16.8523 1.60398 16.2787 1.75281 15.7323C1.8693 15.3108 1.89902 14.8812 1.9842 14.4662C2.03859 14.1988 2.08425 13.9366 2.14378 13.6779C2.23922 13.2805 2.26176 12.8787 2.35721 12.4813C2.59584 11.5878 2.79289 10.6834 3.01766 9.78627C3.23165 8.9308 3.43177 8.07167 3.66476 7.22863C3.82796 6.62666 4.01888 6.03201 4.23752 5.44469C4.53418 4.67036 4.87756 3.91578 5.17936 3.15022C5.26456 2.93545 5.27531 2.69362 5.33124 2.44889C5.37283 2.45987 5.43342 2.48328 5.50787 2.51035C5.47962 2.36201 5.46676 2.23999 5.45854 2.18592C5.64336 2.10126 5.78967 2.05092 5.92572 1.98304C5.96063 1.9626 5.99759 1.90563 5.99091 1.87421C5.93131 1.53224 6.19109 1.41546 6.39747 1.24751C6.44469 1.20808 6.51092 1.18109 6.53915 1.12923C6.7111 0.722351 7.05558 0.650185 7.43602 0.639417C7.50379 0.635067 7.5957 0.651918 7.64806 0.621258C7.96943 0.409534 8.32318 0.473273 8.62611 0.590328C9.15751 0.797365 9.69406 1.01318 10.1726 1.31006C11.983 2.44053 13.6194 3.81421 15.2014 5.2551C16.6628 6.58997 18.1118 7.94384 19.5397 9.32181C21.7549 11.4637 23.9489 13.6297 26.1482 15.8044C26.5322 16.1802 26.8619 16.6231 27.1951 17.0521C27.4632 17.3898 27.5325 17.8085 27.4977 18.2294C27.4746 18.4902 27.3653 18.6838 27.125 18.7538C26.8708 18.4197 26.6269 18.1033 26.3969 17.7904C26.362 17.8109 26.3271 17.8313 26.2921 17.8517C26.3327 17.9811 26.3594 18.1068 26.4175 18.2259C26.4924 18.394 26.5762 18.557 26.6511 18.725C26.7703 19.0086 26.7061 19.1993 26.4089 19.232C26.2785 19.2495 26.1095 19.101 25.9889 18.995C25.8975 18.919 25.8518 18.7809 25.7552 18.6961C25.8112 18.8517 25.8585 19.0125 25.9319 19.158C26.0325 19.3699 25.9535 19.4751 25.7517 19.5108C25.4873 19.5596 25.1978 19.7056 25.0186 19.3394C25.0335 19.4249 25.0571 19.5053 25.0822 19.6083C24.7403 19.785 24.7305 19.3079 24.463 19.3114C24.4743 19.4108 24.4857 19.5101 24.5155 19.6811C24.3034 19.4991 24.1483 19.3543 23.9845 19.2147C22.7168 18.1904 21.4439 17.1574 20.1726 16.147C18.853 15.0942 17.5123 14.0656 16.2102 13.0026C14.9373 11.9695 13.6855 10.9124 12.4337 9.85527C12.0147 9.49997 11.629 9.10158 11.2224 8.72729C11.1259 8.64249 11.0293 8.55769 10.8666 8.49989C10.9359 8.71838 11.0016 8.95076 11.071 9.16925C11.2014 9.55217 11.337 9.94386 11.4762 10.3217C11.7443 11.0598 12.0037 11.8029 12.2769 12.5498C12.489 13.1322 12.715 13.7183 12.9497 14.2993C13.1792 14.8715 13.4226 15.4473 13.6609 16.0144C14.0708 17.0346 14.4719 18.0599 14.8955 19.0838C15.1354 19.6735 15.4014 20.2479 15.6587 20.8274C15.9447 21.4961 16.2046 22.1801 16.5168 22.8335C17.1619 24.1752 17.8294 25.5156 18.5006 26.842C18.9192 27.6569 19.3777 28.4601 19.7963 29.275C20.1208 29.9093 20.4664 30.5196 20.7997 31.1488C20.9774 31.4923 21.2387 31.7986 21.4251 32.137C21.4858 32.3606 21.4719 32.5571 21.4966 32.7193C21.3831 32.5855 21.2434 32.4671 21.151 32.3092C20.639 31.4549 20.1322 30.6093 19.6377 29.7447C19.1637 28.9152 18.6933 28.0718 18.2455 27.2269C17.7756 26.3244 17.3232 25.4116 16.8656 24.49C17.2144 25.3458 17.6031 26.1898 18.0355 27.0084C18.7873 28.4525 19.5566 29.8864 20.331 31.3291C20.5343 31.7164 20.7603 32.1023 20.9636 32.4896C21.0987 32.7403 21.1814 33.0216 21.3339 33.2621C21.5912 33.6414 21.9008 33.9901 22.1581 34.3694C22.7722 35.2582 23.3602 36.1623 23.9831 37.0459C25.39 39.0486 26.9141 40.9709 28.5536 42.7903C29.6823 44.0373 30.8458 45.2639 32.0217 46.4715C32.607 47.071 33.2345 47.6222 33.8532 48.1785C34.4098 48.6888 34.9577 49.2042 35.5441 49.6852C36.2218 50.2423 36.9119 50.7804 37.6143 51.2995C38.5031 51.9568 39.3832 52.6192 40.3002 53.2246C41.4452 53.9792 42.599 54.7287 43.7881 55.3985C45.0014 56.0896 46.2763 56.6857 47.5214 57.311C47.9485 57.5202 48.3916 57.6965 48.8311 57.8867C48.8522 57.8626 48.8594 57.8348 48.8804 57.8107C48.7752 57.731 48.6786 57.6462 48.5523 57.5906C48.4122 57.5314 48.2525 57.5189 48.1175 57.4684C47.8561 57.3623 47.5984 57.2424 47.3493 57.1173C46.9879 56.9403 46.6228 56.7772 46.2737 56.5812C46.1232 56.5044 45.9959 56.367 45.8665 56.2661C45.8075 56.2654 45.7274 56.2887 45.6755 56.2602C45.5857 56.2068 45.5153 56.1067 45.4306 56.062C45.0501 55.8726 44.6538 55.7161 44.2856 55.5076C43.8985 55.2868 43.5447 55.0229 43.1612 54.7881C42.7119 54.5212 42.2431 54.3011 41.8026 54.0291C41.476 53.8316 41.1916 53.586 40.8809 53.3557C40.7377 53.2511 40.6067 53.1276 40.4599 53.0369C40.256 52.9089 40.0311 52.8051 39.8273 52.6771C39.5665 52.5119 39.3231 52.3364 39.0746 52.1521C38.9503 52.06 38.842 51.935 38.711 51.8115C38.4508 51.9874 38.615 51.6675 38.5144 51.6558C38.3742 51.5965 38.2202 51.5336 38.1267 51.4941C38.1468 51.3882 38.1524 51.3378 38.158 51.2873C38.0903 51.2917 38.0261 51.2822 37.9357 51.288C37.8982 51.2039 37.8453 51.0936 37.8387 51.0621C37.624 50.9758 37.449 50.937 37.316 50.85C37.1691 50.7593 36.9602 50.6226 36.956 50.4955C36.9391 50.2463 36.8189 50.2813 36.6593 50.2688C36.5725 50.2607 36.4862 50.1935 36.3738 50.1415C36.4631 50.0539 36.5278 50.0042 36.5699 49.956C36.4436 49.9005 36.3101 49.8726 36.2187 49.7966C36.022 49.6409 35.8675 49.4369 35.6549 49.3141C35.3284 49.1167 35.0824 48.8367 34.8662 48.5275C34.8559 48.51 34.8179 48.4851 34.7954 48.4866C34.4894 48.5244 34.2768 48.4016 34.1664 48.1129C34.1561 48.0954 34.1145 48.0844 34.1043 48.0668C34.0319 48.0032 33.9682 47.9345 33.8511 47.8146C33.5482 47.8978 33.5312 47.4484 33.2457 47.3212C32.9515 47.199 32.7266 46.8949 32.4925 46.6552C32.3805 46.5441 32.3369 46.3694 32.2301 46.2671C32.075 46.1223 31.8604 46.036 31.7141 45.8862C31.2714 45.4505 30.8201 45.0199 30.4021 44.5462C29.2617 43.259 28.0899 41.9783 27.0142 40.6415C25.7736 39.0831 24.6013 37.4612 23.4341 35.8481C22.9036 35.1224 22.4553 34.3367 21.9721 33.5715C21.7816 33.3062 21.6435 33.0102 21.4966 32.7193ZM1.6657 25.9115C1.66368 26.1482 1.66166 26.385 1.65759 26.6582C1.89834 26.3288 1.89009 26.0746 1.6657 25.9115C1.71602 25.9174 1.7802 25.9269 1.86184 25.9262C1.82434 25.8422 1.80226 25.7845 1.78018 25.7267C1.85513 25.6946 1.90749 25.664 1.96499 25.6421C1.97063 25.5917 1.97628 25.5412 1.98192 25.4908C1.89156 25.4966 1.77707 25.4812 1.70211 25.5133C1.66721 25.5338 1.68518 25.6646 1.67749 25.7515C1.68572 25.8056 1.66621 25.8523 1.6657 25.9115ZM36.4732 52.7332C36.5266 52.7843 36.5713 52.8406 36.6247 52.8918C37.3029 53.3897 37.9725 53.8927 38.6631 54.3716C39.1827 54.7387 39.727 55.0677 40.2538 55.407C39.6674 54.926 39.0528 54.4968 38.4382 54.0676C38.086 53.8263 37.7337 53.585 37.3815 53.3437C37.0775 53.1448 36.7736 52.9459 36.4732 52.7332C36.2103 52.4042 35.8524 52.2134 35.5315 51.9655C35.5104 51.9896 35.4945 52.0225 35.4735 52.0466C35.8016 52.2667 36.1348 52.4955 36.4732 52.7332ZM29.328 48.4963C29.2782 48.4312 29.2371 48.3611 29.1786 48.3011C28.4453 47.5292 27.6685 46.7828 26.965 45.9817C25.8436 44.7069 24.7396 43.4219 23.6741 42.1025C22.0894 40.1568 20.6552 38.0876 19.3345 35.952C18.6407 34.8272 17.9557 33.6973 17.3107 32.5557C16.544 31.2263 15.8035 29.8816 15.0856 28.5354C14.607 27.6379 14.1633 26.72 13.7109 25.8072C13.771 26.09 13.8537 26.3714 13.9851 26.6359C14.5824 27.8761 15.1673 29.1353 15.8133 30.3587C16.7587 32.1134 17.6954 33.8733 18.7455 35.5667C19.7597 37.1987 20.8925 38.7731 22.015 40.3299C22.6913 41.2647 23.4287 42.1638 24.1958 43.0336C25.6202 44.6257 27.0744 46.1885 28.5286 47.7513C28.7555 48.0189 29.0523 48.2455 29.328 48.4963C29.65 48.8259 29.9632 49.1607 30.2764 49.4955C30.3062 49.4663 30.3272 49.4422 30.357 49.413C30.0053 49.1125 29.6623 48.807 29.328 48.4963ZM78.3681 47.7054C78.081 46.9549 77.8474 46.2556 77.5562 45.5781C76.6133 43.3273 75.3228 41.3035 73.5765 39.582C70.8674 36.9167 67.7574 35.0279 63.934 34.5226C61.9876 34.2608 60.0798 34.365 58.2681 35.2138C57.4415 35.6036 56.7197 36.1322 56.1956 36.8984C55.7208 37.5886 55.4955 38.3447 55.8375 39.169C56.0876 39.7763 56.3465 40.3785 56.7675 40.8975C56.9755 41.1526 57.1501 41.4508 57.3914 41.6628C57.6137 41.8623 57.6179 42.1897 57.9727 42.3352C58.3362 42.4757 58.6058 42.836 58.9231 43.0978C60.0301 44.0277 61.2798 44.721 62.5948 45.3054C64.228 46.0332 65.9377 46.5514 67.687 46.9168C70.688 47.5386 73.7177 47.8492 76.7837 47.7616C77.2997 47.7421 77.7931 47.7241 78.3681 47.7054ZM48.3604 58.3037C48.3727 58.2847 48.385 58.2657 48.3974 58.2467C48.3265 58.2057 48.2556 58.1648 48.1899 58.1326C47.6277 57.8729 47.0583 57.641 46.512 57.3485C45.0995 56.5974 43.6906 55.8325 42.3064 55.0296C41.4371 54.5257 40.6032 53.9422 39.7658 53.3727C38.8041 52.7109 37.8634 52.0251 36.9264 51.3254C36.3862 50.9233 35.8917 50.4591 35.3675 50.0241C34.7174 49.4744 34.0463 48.9487 33.4173 48.3748C32.7555 47.7849 32.1111 47.1847 31.5052 46.5502C30.0818 45.04 28.6672 43.5247 27.2772 41.9714C25.5519 40.0255 23.977 37.9563 22.4791 35.8184C22.1222 35.309 21.7864 34.7755 21.4593 34.2368C21.3412 34.0351 21.2616 33.7991 21.1799 33.5996C21.0937 33.5323 20.917 33.4708 20.9109 33.3802C20.8831 33.1727 20.7306 33.1325 20.5802 33.0557C22.4658 36.156 24.5681 39.1059 26.9429 41.8609C29.3178 44.6158 31.8277 47.2211 34.5978 49.6504C34.5126 49.665 34.4813 49.6715 34.45 49.6781C34.4654 49.7044 34.4859 49.7395 34.5013 49.7658C34.7755 49.5935 34.8371 49.8989 34.9752 49.9947C35.4913 50.3756 35.9862 50.7807 36.4884 51.1579C37.4496 51.8788 38.4036 52.6274 39.3982 53.3052C40.6484 54.1395 41.9197 54.9497 43.228 55.7029C44.334 56.3508 45.479 56.9052 46.6255 57.4823C47.1959 57.796 47.7843 58.0403 48.3604 58.3037ZM62.761 48.4114C62.7938 48.4275 62.818 48.4487 62.8508 48.4648C63.9747 48.8431 65.0879 49.2631 66.2297 49.572C68.2311 50.1078 70.2955 50.3711 72.3559 50.5073C74.3521 50.634 76.339 50.6248 78.3238 50.4519C78.4003 50.4424 78.484 50.4052 78.5641 50.3818C78.5574 50.3504 78.5558 50.3278 78.5492 50.2964C73.1656 50.6692 67.8974 50.1383 62.761 48.4114ZM21.17 36.3848C24.5535 41.6229 28.7281 46.1506 33.3873 50.265C33.243 50.0786 33.1387 49.8805 32.9246 49.735C32.5205 49.4652 32.1606 49.1107 31.8109 48.7737C31.072 48.0522 30.3367 47.3168 29.6102 46.5763C28.9955 45.9469 28.386 45.3263 27.8099 44.6626C26.7763 43.4777 25.7462 42.2789 24.7511 41.0597C24.0189 40.1694 23.3303 39.2536 22.6278 38.3341C22.1261 37.6975 21.6455 37.0367 21.17 36.3848ZM64.7215 46.4156C69.1668 47.9229 73.7413 48.33 78.4031 48.0854C78.4087 48.035 78.4092 47.9758 78.4149 47.9254C76.1194 48.0681 73.8327 48.0056 71.5474 47.7656C69.2222 47.5372 66.9456 47.0918 64.7215 46.4156ZM91.9719 46.7003C91.9565 46.674 91.9498 46.6426 91.9344 46.6162C91.6202 46.8002 91.3076 47.0068 90.9831 47.1732C89.3819 47.9813 87.6944 48.5218 85.9591 48.9608C84.4867 49.3283 82.9855 49.6067 81.5012 49.934C81.4073 49.9537 81.3287 49.9996 81.2451 50.0369C81.2569 50.0771 81.2774 50.1121 81.2841 50.1436C84.9893 49.4462 88.6997 48.7576 91.9719 46.7003ZM81.1205 47.7426C81.7202 47.8861 85.7894 47.0698 87.9657 46.4433C90.3109 45.765 93.6191 43.9693 94.1469 43.3894C93.8239 43.5785 93.4487 43.7982 93.0734 44.0179C91.1359 45.1524 89.1049 46.0471 86.9292 46.6145C85.1189 47.0856 83.2943 47.412 81.4409 47.6492C81.3244 47.6704 81.2232 47.7178 81.1205 47.7426ZM63.0148 33.3531C64.3795 33.6022 65.7529 33.8462 67.0622 34.0806C66.3351 33.5995 64.1659 33.1973 63.0148 33.3531ZM72.4152 48.447C74.4211 48.6503 76.4568 48.6243 78.4955 48.4434C76.4583 48.4468 74.4211 48.4502 72.4152 48.447ZM62.7829 30.2149C64.1861 30.4297 65.6119 30.643 66.9422 30.8534C65.904 30.4013 64.0552 30.1059 62.7829 30.2149ZM88.2954 46.686C90.333 46.0229 92.2084 45.0426 93.9626 43.8153C92.1761 44.9673 90.2904 45.9301 88.2954 46.686ZM78.5845 49.4159C78.5865 49.3794 78.5886 49.3429 78.5819 49.3115C77.3328 49.3598 76.0975 49.4118 74.8484 49.4601C74.8551 49.4915 74.8479 49.5193 74.8545 49.5507C76.1037 49.5024 77.3441 49.4592 78.5845 49.4159ZM65.309 31.1265C64.4557 30.79 63.5675 30.6741 62.6654 30.7548C63.55 30.8845 64.4295 31.0055 65.309 31.1265ZM33.5552 50.3316C33.5341 50.3557 33.5095 50.3936 33.4884 50.4177C34.1128 50.9237 34.7336 51.4434 35.358 51.9494C35.379 51.9253 35.4001 51.9012 35.416 51.8683C34.7916 51.3624 34.1708 50.8426 33.5552 50.3316ZM91.9528 45.8871C91.9426 45.8695 91.9272 45.8432 91.9256 45.8206C90.9682 46.287 90.0194 46.7483 89.0568 47.2059C89.0671 47.2234 89.0825 47.2497 89.084 47.2724C90.0466 46.8148 91.0041 46.3484 91.9528 45.8871ZM63.1728 31.9416C63.1708 31.9781 63.1687 32.0146 63.1615 32.0424C63.734 32.1194 64.3116 32.2052 64.8841 32.2822C64.8861 32.2457 64.8933 32.2179 64.8953 32.1814C64.3229 32.1044 63.7453 32.0186 63.1728 31.9416ZM81.2125 48.1598C81.2192 48.1913 81.2207 48.2139 81.2274 48.2453C81.7716 48.174 82.3107 48.0939 82.8636 48.0175C82.8621 47.9948 82.8554 47.9634 82.8538 47.9407C82.3096 48.0121 81.7654 48.0834 81.2125 48.1598ZM6.26114 11.9031C6.22469 11.9009 6.17951 11.9038 6.14306 11.9016C6.22112 12.115 5.9208 12.3026 6.13954 12.516C6.17599 12.5182 6.21243 12.5205 6.24888 12.5227C6.25245 12.3086 6.25244 12.1084 6.26114 11.9031ZM37.5399 55.3355C37.5522 55.3165 37.5594 55.2888 37.5717 55.2698C37.2713 55.057 36.9709 54.8442 36.6706 54.6315C36.6495 54.6556 36.6372 54.6746 36.6213 54.7074C36.9391 54.91 37.2395 55.1227 37.5399 55.3355ZM2.63463 13.9558C2.57918 13.9412 2.53759 13.9302 2.48214 13.9156C2.27683 14.3655 2.28197 14.3743 2.29687 14.4598C2.41648 14.2838 2.51862 14.118 2.63463 13.9558Z",
    fill: "black"
  })));
};

var css_248z$w = ".permissions-popup {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3000;\n}\n.permissions-popup > button {\n  margin-top: 24px;\n}\n.permissions-popup__content {\n  padding: 32px 36px;\n  background-color: #ffdc4a;\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 600px;\n}\n.permissions-popup__content > p {\n  margin: 0;\n  text-align: center;\n}\n.permissions-popup__content > h4 > span {\n  color: #8ab4f8;\n  font-family: sans-serif;\n  font-weight: bold;\n}\n.permissions-popup__content > svg {\n  width: 30px;\n  height: 30px;\n  float: right;\n  margin-left: auto;\n}\n.permissions-popup__icons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  position: relative;\n}\n.permissions-popup__icons svg:first-of-type {\n  margin-right: 10px;\n  position: absolute;\n  transform: translate(-105%, -25%);\n}\n.permissions-popup__icons svg:last-of-type {\n  padding: 22px;\n  width: 76px;\n  height: 76px;\n  border-radius: 100%;\n  border: 1px solid black;\n}";
styleInject(css_248z$w);

var PermissionsPopup = function (_a) {
    var onClose = _a.onClose, open = _a.open;
    if (!open)
        return null;
    return (React__default["default"].createElement("div", { className: "permissions-popup" },
        React__default["default"].createElement("div", { className: "permissions-popup__content" },
            React__default["default"].createElement(SvgClose, { onClick: onClose }),
            React__default["default"].createElement("div", { className: "permissions-popup__icons" },
                React__default["default"].createElement(SvgTwistedArrow, null),
                React__default["default"].createElement(SvgMicrophone, null)),
            React__default["default"].createElement(Typography, { variant: "h4" },
                "Please ",
                React__default["default"].createElement("span", null, "Allow"),
                " Astrid to use your microphone."),
            React__default["default"].createElement(Typography, { variant: "body", color: "secondary" }, "Astrid works by listening to students read out loud, and giving them feedback."))));
};

var css_248z$v = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.audio-recorder, .audio-recorder--recording {\n  border-radius: 100%;\n  animation: pulse-maize 2s infinite;\n}\n.audio-recorder button, .audio-recorder--recording button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffdc4a;\n  border-radius: 100%;\n  padding: 30px;\n  transition: 230ms all;\n  -ms-touch-action: none;\n  touch-action: none;\n  user-select: none;\n  box-shadow: 0 4px #b08e00;\n}\n.audio-recorder button svg, .audio-recorder--recording button svg {\n  width: 32px;\n  height: 32px;\n}\n.audio-recorder button:active, .audio-recorder--recording button:active {\n  box-shadow: 0 1px #ff4c0f;\n  transform: translateY(3px);\n}\n.audio-recorder--recording {\n  animation: pulse-salmon 1.2s infinite;\n}\n.audio-recorder--recording button {\n  animation: none;\n  background-color: #ffbea8;\n}\n@keyframes pulse-maize {\n  0% {\n    box-shadow: 0 5px 0 0 rgba(255, 220, 74, 0.7);\n  }\n  90% {\n    box-shadow: 0 5px 0 20px rgba(255, 220, 74, 0);\n  }\n  100% {\n    box-shadow: 0 5px 0 0 rgba(255, 220, 74, 0);\n  }\n}\n@keyframes pulse-salmon {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 5px 0 0 rgba(255, 190, 168, 0.7);\n  }\n  70% {\n    transform: scale(1);\n    box-shadow: 0 5px 0 40px rgba(255, 190, 168, 0);\n  }\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 5px 0 0 rgba(255, 190, 168, 0);\n  }\n}";
styleInject(css_248z$v);

var createMediaRecorder = function (stream) {
    return new MediaRecorder(stream);
    /** TODO: This could be changed in the future to use built in MediaRecorder when available. */
    // return new MediaRecorder(stream)
};
var AudioRecorder = /** @class */ (function (_super) {
    __extends(AudioRecorder, _super);
    function AudioRecorder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isRecording: false,
            recordingIndex: 0,
            permissionsPopupOpen: false
        };
        _this.mediaRecorder = null;
        _this.recordBlob = null;
        _this.stream = null;
        _this.buttonRef = React__default["default"].createRef();
        _this.permissionPopupDelayer = null;
        _this.initMediaRecorder = function () { return __awaiter(_this, void 0, void 0, function () {
            var constraints, _a, error_1;
            var _this = this;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        constraints = { audio: true, video: false };
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        this.permissionPopupDelayer = setTimeout(function () { return _this.setState({ permissionsPopupOpen: true }); }, 600);
                        _a = this;
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia(constraints)];
                    case 2:
                        _a.stream = _c.sent();
                        clearTimeout(this.permissionPopupDelayer);
                        this.permissionPopupDelayer = null;
                        this.setState({ permissionsPopupOpen: false });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        this.setState({ permissionsPopupOpen: false });
                        console.log(error_1);
                        return [2 /*return*/];
                    case 4:
                        this.mediaRecorder = createMediaRecorder(this.stream);
                        this.mediaRecorder.addEventListener('start', function () {
                            if (_this.props.onStartRecording) {
                                _this.props.onStartRecording();
                            }
                        });
                        this.mediaRecorder.addEventListener('stop', function () {
                            var _a = _this.props, onStopRecording = _a.onStopRecording, onStopWordRecording = _a.onStopWordRecording, wordsToRecord = _a.wordsToRecord;
                            if (_this.recordBlob) {
                                if (onStopRecording)
                                    onStopRecording(_this.recordBlob);
                                if (onStopWordRecording && (wordsToRecord === null || wordsToRecord === void 0 ? void 0 : wordsToRecord.length)) {
                                    onStopWordRecording(_this.recordBlob, wordsToRecord[_this.state.recordingIndex]);
                                    _this.setState(_this.incrementRecordingIndex, _this.recordOneWord);
                                }
                            }
                        });
                        this.mediaRecorder.addEventListener('dataavailable', function (event) {
                            _this.recordBlob = event.data;
                        });
                        if (this.props.autoRecorder && ((_b = this.props.wordsToRecord) === null || _b === void 0 ? void 0 : _b.length)) {
                            this.recordOneWord();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.incrementRecordingIndex = function (state) { return (__assign$1(__assign$1({}, state), { recordingIndex: state.recordingIndex + 1 })); };
        _this.recordOneWord = function () {
            if (_this.state.recordingIndex < _this.props.wordsToRecord.length) {
                _this.start();
                setTimeout(function () {
                    _this.stop();
                }, 2000);
            }
        };
        _this.start = function () {
            if (_this.mediaRecorder) {
                var recordingState = _this.mediaRecorder.state;
                if (recordingState !== 'recording') {
                    _this.mediaRecorder.start();
                    document.addEventListener('mouseup', _this.turnOffRecording);
                }
            }
        };
        _this.stop = function () {
            if (_this.mediaRecorder) {
                var recordingState = _this.mediaRecorder.state;
                if (recordingState !== 'inactive') {
                    _this.mediaRecorder.stop();
                    document.removeEventListener('mouseup', _this.turnOffRecording);
                }
            }
        };
        _this.toggleRecording = function (isRecording) {
            _this.setState(function (state) { return ({
                isRecording: isRecording !== undefined ? isRecording : !state.isRecording
            }); }, function () {
                var isRecording = _this.state.isRecording;
                if (isRecording) {
                    _this.start();
                }
                else {
                    _this.stop();
                }
            });
        };
        _this.turnOffRecording = function () { return _this.toggleRecording(false); };
        _this.handleKeyDown = function (e) {
            if (['Enter', 'Spacebar', ' '].includes(e.key)) {
                _this.toggleRecording(true);
                e.preventDefault();
            }
        };
        _this.handleKeyUp = function (e) {
            if (['Enter', 'Spacebar', ' '].includes(e.key)) {
                _this.toggleRecording(false);
                e.preventDefault();
            }
        };
        return _this;
    }
    AudioRecorder.prototype.componentDidMount = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.initMediaRecorder()];
                    case 1:
                        _b.sent();
                        (_a = this.buttonRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('touchstart', function (event) {
                            event.preventDefault();
                            if (!_this.state.isRecording)
                                _this.toggleRecording(true);
                        }, {
                            passive: false,
                            capture: true
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AudioRecorder.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.stream) === null || _a === void 0 ? void 0 : _a.getTracks().forEach(function (track) { return track.stop(); });
    };
    AudioRecorder.prototype.render = function () {
        var _this = this;
        if (this.props.autoRecorder) {
            return (React__default["default"].createElement(PermissionsPopup, { open: this.state.permissionsPopupOpen, onClose: function () { return _this.setState({ permissionsPopupOpen: false }); } }));
        }
        var isRecording = this.state.isRecording;
        var className = "audio-recorder".concat(isRecording ? '--recording' : '');
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement("div", { className: className },
                React__default["default"].createElement("button", { "aria-label": "Record", ref: this.buttonRef, onTouchEnd: this.turnOffRecording, onTouchCancel: this.turnOffRecording, onMouseDown: function () { return _this.toggleRecording(true); }, onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp },
                    React__default["default"].createElement(SvgMicrophone, null))),
            React__default["default"].createElement(PermissionsPopup, { open: this.state.permissionsPopupOpen, onClose: function () { return _this.setState({ permissionsPopupOpen: false }); } })));
    };
    return AudioRecorder;
}(React.Component));

var css_248z$u = "/* Slider */\n.slick-slider\n{\n    position: relative;\n\n    display: block;\n    box-sizing: border-box;\n\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-touch-action: pan-y;\n        touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n.slick-list\n{\n    position: relative;\n\n    display: block;\n    overflow: hidden;\n\n    margin: 0;\n    padding: 0;\n}\n.slick-list:focus\n{\n    outline: none;\n}\n.slick-list.dragging\n{\n    cursor: pointer;\n    cursor: hand;\n}\n.slick-slider .slick-track,\n.slick-slider .slick-list\n{\n    -webkit-transform: translate3d(0, 0, 0);\n       -moz-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n         -o-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n.slick-track\n{\n    position: relative;\n    top: 0;\n    left: 0;\n\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n.slick-track:before,\n.slick-track:after\n{\n    display: table;\n\n    content: '';\n}\n.slick-track:after\n{\n    clear: both;\n}\n.slick-loading .slick-track\n{\n    visibility: hidden;\n}\n.slick-slide\n{\n    display: none;\n    float: left;\n\n    height: 100%;\n    min-height: 1px;\n}\n[dir='rtl'] .slick-slide\n{\n    float: right;\n}\n.slick-slide img\n{\n    display: block;\n}\n.slick-slide.slick-loading img\n{\n    display: none;\n}\n.slick-slide.dragging img\n{\n    pointer-events: none;\n}\n.slick-initialized .slick-slide\n{\n    display: block;\n}\n.slick-loading .slick-slide\n{\n    visibility: hidden;\n}\n.slick-vertical .slick-slide\n{\n    display: block;\n\n    height: auto;\n\n    border: 1px solid transparent;\n}\n.slick-arrow.slick-hidden {\n    display: none;\n}\n";
styleInject(css_248z$u);

var css_248z$t = "@charset 'UTF-8';\n/* Slider */\n.slick-loading .slick-list\n{\n    background: #fff url('./ajax-loader.gif') center center no-repeat;\n}\n/* Icons */\n@font-face\n{\n    font-family: 'slick';\n    font-weight: normal;\n    font-style: normal;\n\n    src: url('./fonts/slick.eot');\n    src: url('./fonts/slick.eot?#iefix') format('embedded-opentype'), url('./fonts/slick.woff') format('woff'), url('./fonts/slick.ttf') format('truetype'), url('./fonts/slick.svg#slick') format('svg');\n}\n/* Arrows */\n.slick-prev,\n.slick-next\n{\n    font-size: 0;\n    line-height: 0;\n\n    position: absolute;\n    top: 50%;\n\n    display: block;\n\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n\n    cursor: pointer;\n\n    color: transparent;\n    border: none;\n    outline: none;\n    background: transparent;\n}\n.slick-prev:hover,\n.slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus\n{\n    color: transparent;\n    outline: none;\n    background: transparent;\n}\n.slick-prev:hover:before,\n.slick-prev:focus:before,\n.slick-next:hover:before,\n.slick-next:focus:before\n{\n    opacity: 1;\n}\n.slick-prev.slick-disabled:before,\n.slick-next.slick-disabled:before\n{\n    opacity: .25;\n}\n.slick-prev:before,\n.slick-next:before\n{\n    font-family: 'slick';\n    font-size: 20px;\n    line-height: 1;\n\n    opacity: .75;\n    color: white;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.slick-prev\n{\n    left: -25px;\n}\n[dir='rtl'] .slick-prev\n{\n    right: -25px;\n    left: auto;\n}\n.slick-prev:before\n{\n    content: '←';\n}\n[dir='rtl'] .slick-prev:before\n{\n    content: '→';\n}\n.slick-next\n{\n    right: -25px;\n}\n[dir='rtl'] .slick-next\n{\n    right: auto;\n    left: -25px;\n}\n.slick-next:before\n{\n    content: '→';\n}\n[dir='rtl'] .slick-next:before\n{\n    content: '←';\n}\n/* Dots */\n.slick-dotted.slick-slider\n{\n    margin-bottom: 30px;\n}\n.slick-dots\n{\n    position: absolute;\n    bottom: -25px;\n\n    display: block;\n\n    width: 100%;\n    padding: 0;\n    margin: 0;\n\n    list-style: none;\n\n    text-align: center;\n}\n.slick-dots li\n{\n    position: relative;\n\n    display: inline-block;\n\n    width: 20px;\n    height: 20px;\n    margin: 0 5px;\n    padding: 0;\n\n    cursor: pointer;\n}\n.slick-dots li button\n{\n    font-size: 0;\n    line-height: 0;\n\n    display: block;\n\n    width: 20px;\n    height: 20px;\n    padding: 5px;\n\n    cursor: pointer;\n\n    color: transparent;\n    border: 0;\n    outline: none;\n    background: transparent;\n}\n.slick-dots li button:hover,\n.slick-dots li button:focus\n{\n    outline: none;\n}\n.slick-dots li button:hover:before,\n.slick-dots li button:focus:before\n{\n    opacity: 1;\n}\n.slick-dots li button:before\n{\n    font-family: 'slick';\n    font-size: 6px;\n    line-height: 20px;\n\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 20px;\n    height: 20px;\n\n    content: '•';\n    text-align: center;\n\n    opacity: .25;\n    color: black;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.slick-dots li.slick-active button:before\n{\n    opacity: .75;\n    color: black;\n}\n";
styleInject(css_248z$t);

var lib = {};

var slider = {};

var innerSlider = {};

var initialState = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0
	};
	var _default = initialState;
	exports["default"] = _default;
} (initialState));

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$3 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$e.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root$2.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject$2(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$3);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$2(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

var innerSliderUtils = {};

Object.defineProperty(innerSliderUtils, "__esModule", {
  value: true
});
innerSliderUtils.canUseDOM = innerSliderUtils.slidesOnLeft = innerSliderUtils.slidesOnRight = innerSliderUtils.siblingDirection = innerSliderUtils.getTotalSlides = innerSliderUtils.getPostClones = innerSliderUtils.getPreClones = innerSliderUtils.getTrackLeft = innerSliderUtils.getTrackAnimateCSS = innerSliderUtils.getTrackCSS = innerSliderUtils.checkSpecKeys = innerSliderUtils.getSlideCount = innerSliderUtils.checkNavigable = innerSliderUtils.getNavigableIndexes = innerSliderUtils.swipeEnd = innerSliderUtils.swipeMove = innerSliderUtils.swipeStart = innerSliderUtils.keyHandler = innerSliderUtils.changeSlide = innerSliderUtils.slideHandler = innerSliderUtils.initializedState = innerSliderUtils.extractObject = innerSliderUtils.canGoNext = innerSliderUtils.getSwipeDirection = innerSliderUtils.getHeight = innerSliderUtils.getWidth = innerSliderUtils.lazySlidesOnRight = innerSliderUtils.lazySlidesOnLeft = innerSliderUtils.lazyEndIndex = innerSliderUtils.lazyStartIndex = innerSliderUtils.getRequiredLazySlides = innerSliderUtils.getOnDemandLazySlides = void 0;

var _react$4 = _interopRequireDefault$4(React__default["default"]);

var _reactDom$1 = _interopRequireDefault$4(require$$1__default["default"]);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(source, true).forEach(function (key) { _defineProperty$8(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


innerSliderUtils.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


innerSliderUtils.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

innerSliderUtils.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

innerSliderUtils.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

innerSliderUtils.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


innerSliderUtils.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

innerSliderUtils.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

innerSliderUtils.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


innerSliderUtils.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


innerSliderUtils.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


innerSliderUtils.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react$4["default"].Children.count(spec.children);

  var listWidth = Math.ceil(getWidth(_reactDom$1["default"].findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom$1["default"].findDOMNode(spec.trackRef)));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = _reactDom$1["default"].findDOMNode(spec.listRef) && getHeight(_reactDom$1["default"].findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  });
  lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

innerSliderUtils.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = {
      animating: false
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    animationLeft = getTrackLeft(_objectSpread$7({}, spec, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread$7({}, spec, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread$7({}, spec, {
      currentSlide: animationSlide
    })));

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread$7({}, spec, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread$7({}, spec, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread$7({}, spec, {
          left: finalLeft
        })),
        swipeLeft: null
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

innerSliderUtils.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;

    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (targetSlide === options.currentSlide) {
      return null;
    }

    if (infinite) {
      var direction = siblingDirection(_objectSpread$7({}, spec, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);

    if (targetSlide === options.currentSlide) {
      return null;
    }
  }

  return targetSlide;
};

innerSliderUtils.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

innerSliderUtils.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

innerSliderUtils.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread$7({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread$7({}, spec, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }

  return state;
};

innerSliderUtils.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = currentSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread$7({}, spec, {
      left: currentLeft
    }));
  }

  return state;
};

innerSliderUtils.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

innerSliderUtils.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

innerSliderUtils.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;

    var slickList = _reactDom$1["default"].findDOMNode(spec.listRef);

    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

innerSliderUtils.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

innerSliderUtils.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread$7({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

innerSliderUtils.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

innerSliderUtils.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;

    var trackElem = _reactDom$1["default"].findDOMNode(trackRef);

    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

innerSliderUtils.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

innerSliderUtils.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

innerSliderUtils.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

innerSliderUtils.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

innerSliderUtils.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

innerSliderUtils.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

innerSliderUtils.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

innerSliderUtils.canUseDOM = canUseDOM;

var track = {};

Object.defineProperty(track, "__esModule", {
  value: true
});
track.Track = void 0;

var _react$3 = _interopRequireDefault$3(React__default["default"]);

var _classnames$3 = _interopRequireDefault$3(classnames.exports);

var _innerSliderUtils$2 = innerSliderUtils;

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof$5(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }

function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$4(self, call) { if (call && (_typeof$5(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$5(self); }

function _assertThisInitialized$5(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf$4(o) { _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$4(o); }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$4(subClass, superClass); }

function _setPrototypeOf$4(o, p) { _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$4(o, p); }

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(source, true).forEach(function (key) { _defineProperty$7(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react$3["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils$2.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils$2.lazyEndIndex)(spec);

  _react$3["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react$3["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread$6({}, spec, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread$6({}, spec, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push(_react$3["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames$3["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread$6({
        outline: "none"
      }, child.props.style || {}, {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils$2.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread$6({}, spec, {
          index: key
        }));
        preCloneSlides.push(_react$3["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames$3["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread$6({}, child.props.style || {}, {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread$6({}, spec, {
          index: key
        }));
        postCloneSlides.push(_react$3["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames$3["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread$6({}, child.props.style || {}, {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits$4(Track, _React$PureComponent);

  function Track() {
    _classCallCheck$4(this, Track);

    return _possibleConstructorReturn$4(this, _getPrototypeOf$4(Track).apply(this, arguments));
  }

  _createClass$3(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return _react$3["default"].createElement("div", _extends$S({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react$3["default"].PureComponent);

track.Track = Track;

var dots = {};

Object.defineProperty(dots, "__esModule", {
  value: true
});
dots.Dots = void 0;

var _react$2 = _interopRequireDefault$2(React__default["default"]);

var _classnames$2 = _interopRequireDefault$2(classnames.exports);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof$4(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(source, true).forEach(function (key) { _defineProperty$6(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$3(self, call) { if (call && (_typeof$4(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$4(self); }

function _assertThisInitialized$4(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$3(subClass, superClass); }

function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits$3(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck$3(this, Dots);

    return _possibleConstructorReturn$3(this, _getPrototypeOf$3(Dots).apply(this, arguments));
  }

  _createClass$2(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var dotCount = getDotCount({
        slideCount: this.props.slideCount,
        slidesToScroll: this.props.slidesToScroll,
        slidesToShow: this.props.slidesToShow,
        infinite: this.props.infinite
      }); // Apply join & split to Array to pre-fill it for IE8
      //
      // Credit: http://stackoverflow.com/a/13735425/1849458

      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
        var leftBound = i * _this.props.slidesToScroll;
        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
        var className = (0, _classnames$2["default"])({
          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: _this.props.slidesToScroll,
          currentSlide: _this.props.currentSlide
        };

        var onClick = _this.clickHandler.bind(_this, dotOptions);

        return _react$2["default"].createElement("li", {
          key: i,
          className: className
        }, _react$2["default"].cloneElement(_this.props.customPaging(i), {
          onClick: onClick
        }));
      });
      return _react$2["default"].cloneElement(this.props.appendDots(dots), _objectSpread$5({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react$2["default"].PureComponent);

dots.Dots = Dots;

var arrows = {};

Object.defineProperty(arrows, "__esModule", {
  value: true
});
arrows.NextArrow = arrows.PrevArrow = void 0;

var _react$1 = _interopRequireDefault$1(React__default["default"]);

var _classnames$1 = _interopRequireDefault$1(classnames.exports);

var _innerSliderUtils$1 = innerSliderUtils;

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof$3(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(source, true).forEach(function (key) { _defineProperty$5(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$2(self, call) { if (call && (_typeof$3(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$3(self); }

function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$2(subClass, superClass); }

function _setPrototypeOf$2(o, p) { _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$2(o, p); }

var PrevArrow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits$2(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck$2(this, PrevArrow);

    return _possibleConstructorReturn$2(this, _getPrototypeOf$2(PrevArrow).apply(this, arguments));
  }

  _createClass$1(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames$1["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = _react$1["default"].cloneElement(this.props.prevArrow, _objectSpread$4({}, prevArrowProps, {}, customProps));
      } else {
        prevArrow = _react$1["default"].createElement("button", _extends$R({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react$1["default"].PureComponent);

arrows.PrevArrow = PrevArrow;

var NextArrow =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits$2(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck$2(this, NextArrow);

    return _possibleConstructorReturn$2(this, _getPrototypeOf$2(NextArrow).apply(this, arguments));
  }

  _createClass$1(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils$1.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames$1["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = _react$1["default"].cloneElement(this.props.nextArrow, _objectSpread$4({}, nextArrowProps, {}, customProps));
      } else {
        nextArrow = _react$1["default"].createElement("button", _extends$R({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react$1["default"].PureComponent);

arrows.NextArrow = NextArrow;

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

var ResizeObserver_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': index
});

var require$$9 = /*@__PURE__*/getAugmentedNamespace(ResizeObserver_es);

Object.defineProperty(innerSlider, "__esModule", {
  value: true
});
innerSlider.InnerSlider = void 0;

var _react = _interopRequireDefault(React__default["default"]);

var _reactDom = _interopRequireDefault(require$$1__default["default"]);

var _initialState = _interopRequireDefault(initialState);

var _lodash = _interopRequireDefault(lodash_debounce);

var _classnames = _interopRequireDefault(classnames.exports);

var _innerSliderUtils = innerSliderUtils;

var _track = track;

var _dots = dots;

var _arrows = arrows;

var _resizeObserverPolyfill = _interopRequireDefault(require$$9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof$2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(source, true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (call && (_typeof$2(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$2(self); }

function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }

function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$1(subClass, superClass); }

function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider =
/*#__PURE__*/
function (_React$Component) {
  _inherits$1(InnerSlider, _React$Component);

  function InnerSlider(props) {
    var _this;

    _classCallCheck$1(this, InnerSlider);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(InnerSlider).call(this, props));

    _defineProperty$4(_assertThisInitialized$2(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "UNSAFE_componentWillMount", function () {
      _this.ssrInit();

      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread$3({}, _this.props, {}, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "componentDidMount", function () {
      var spec = _objectSpread$3({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var spec = _objectSpread$3({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, {}, _this.state);

      var setTrackStyle = false;

      for (var _i = 0, _Object$keys = Object.keys(_this.props); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof$2(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }

        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "componentDidUpdate", function () {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread$3({}, _this.props, {}, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!_reactDom["default"].findDOMNode(_this.track)) return;

      var spec = _objectSpread$3({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, {}, _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread$3({}, spec, {}, updatedState, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread$3({}, spec, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread$3({}, _this.props, {}, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread$3({}, _this.props, {}, _this.state, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }

        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        _this.setState({
          trackStyle: _trackStyle
        });

        return;
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread$3({}, _this.props, {}, _this.state, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };

      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "checkImagesLoad", function () {
      var images = _this.list.querySelectorAll(".slick-slide img");

      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread$3({}, _this.props, {}, _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread$3({
        index: index
      }, _this.props, {}, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties$2(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread$3({}, _this.props, {}, _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread$3({}, _this.props, {}, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread$3({}, _this.props, {}, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread$3({}, _this.props, {}, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty$4(_assertThisInitialized$2(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread$3({}, _this.props, {}, _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread$3({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread$3({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread$3({}, verticalHeightStyle, {}, centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return _react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react["default"].createElement("div", _extends$Q({
        ref: _this.listRefHandler
      }, listProps), _react["default"].createElement(_track.Track, _extends$Q({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread$3({}, _initialState["default"], {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react["default"].Component);

innerSlider.InnerSlider = InnerSlider;

var camel2hyphen$1 = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

var camel2hyphen_1 = camel2hyphen$1;

var camel2hyphen = camel2hyphen_1;

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and ';
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

var json2mq_1 = json2mq;

var defaultProps$1 = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	var _react = _interopRequireDefault(React__default["default"]);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports["default"] = _default;
} (defaultProps$1));

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */

var QueryHandler_1;
var hasRequiredQueryHandler;

function requireQueryHandler () {
	if (hasRequiredQueryHandler) return QueryHandler_1;
	hasRequiredQueryHandler = 1;
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}

	QueryHandler.prototype = {

	    constructor : QueryHandler,

	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },

	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },

	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },

	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },

	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }

	};

	QueryHandler_1 = QueryHandler;
	return QueryHandler_1;
}

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */

var Util;
var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return Util;
	hasRequiredUtil = 1;
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;

	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}

	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}

	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}

	Util = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};
	return Util;
}

var MediaQuery_1;
var hasRequiredMediaQuery;

function requireMediaQuery () {
	if (hasRequiredMediaQuery) return MediaQuery_1;
	hasRequiredMediaQuery = 1;
	var QueryHandler = requireQueryHandler();
	var each = requireUtil().each;

	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);

	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}

	MediaQuery.prototype = {

	    constuctor : MediaQuery,

	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);

	        this.matches() && qh.on();
	    },

	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },

	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },

	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },

	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';

	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};

	MediaQuery_1 = MediaQuery;
	return MediaQuery_1;
}

var MediaQueryDispatch_1;
var hasRequiredMediaQueryDispatch;

function requireMediaQueryDispatch () {
	if (hasRequiredMediaQueryDispatch) return MediaQueryDispatch_1;
	hasRequiredMediaQueryDispatch = 1;
	var MediaQuery = requireMediaQuery();
	var Util = requireUtil();
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;

	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }

	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}

	MediaQueryDispatch.prototype = {

	    constructor : MediaQueryDispatch,

	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;

	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }

	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });

	        return this;
	    },

	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];

	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }

	        return this;
	    }
	};

	MediaQueryDispatch_1 = MediaQueryDispatch;
	return MediaQueryDispatch_1;
}

var src;
var hasRequiredSrc;

function requireSrc () {
	if (hasRequiredSrc) return src;
	hasRequiredSrc = 1;
	var MediaQueryDispatch = requireMediaQueryDispatch();
	src = new MediaQueryDispatch();
	return src;
}

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	var _react = _interopRequireDefault(React__default["default"]);

	var _innerSlider = innerSlider;

	var _json2mq = _interopRequireDefault(json2mq_1);

	var _defaultProps = _interopRequireDefault(defaultProps$1);

	var _innerSliderUtils = innerSliderUtils;

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var enquire = (0, _innerSliderUtils.canUseDOM)() && requireSrc();

	var Slider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Slider, _React$Component);

	  function Slider(props) {
	    var _this;

	    _classCallCheck(this, Slider);

	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));

	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });

	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });

	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });

	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });

	    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });

	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });

	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }

	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);

	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints

	  }, {
	    key: "UNSAFE_componentWillMount",
	    value: function UNSAFE_componentWillMount() {
	      var _this2 = this;

	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value

	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;

	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering


	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string

	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;

	      var settings;
	      var newProps;

	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps["default"], {}, this.props, {}, newProps[0].settings);
	      } else {
	        settings = _objectSpread({}, _defaultProps["default"], {}, this.props);
	      } // force scrolling by one if centerMode is on


	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }

	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on


	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && process.env.NODE_ENV !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }

	        if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }

	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child


	      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }

	        return !!child;
	      }); // rows and slidesPerRow logic is handled here

	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }

	      var newChildren = [];
	      var currentWidth = null;

	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];

	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];

	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }

	            if (k >= children.length) break;
	            row.push(_react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }

	          newSlide.push(_react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }

	        if (settings.variableWidth) {
	          newChildren.push(_react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push(_react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }

	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return _react["default"].createElement("div", {
	          className: className
	        }, children);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }

	      return _react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);

	  return Slider;
	}(_react["default"].Component);

	exports["default"] = Slider;
} (slider));

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	var _slider = _interopRequireDefault(slider);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	var _default = _slider["default"];
	exports["default"] = _default;
} (lib));

var Slider = /*@__PURE__*/getDefaultExportFromCjs(lib);

var _path$G;
function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$P({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$G || (_path$G = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
  })));
};

var css_248z$s = ".skeleton-loader {\n  height: 100%;\n  width: 100%;\n  animation: shimmer 1s linear infinite forwards;\n  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);\n  background-size: 800px 104px;\n  position: relative;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -468px 0;\n  }\n  100% {\n    background-position: 468px 0;\n  }\n}";
styleInject(css_248z$s);

var SkeletonLoader = function (_a) {
    var display = _a.display, className = _a.className, style = _a.style, children = _a.children;
    return (React__default["default"].createElement("div", { className: "".concat(className ? className : '', " skeleton-loader"), style: __assign$1({ display: display ? 'block' : 'none' }, style) }, children));
};

var _path$F;
function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$O({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$F || (_path$F = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12 19.027l5.533 3.346c1.014.614 2.254-.293 1.987-1.44l-1.467-6.293 4.894-4.24c.893-.773.413-2.24-.76-2.333l-6.44-.547-2.52-5.947c-.454-1.08-2-1.08-2.454 0l-2.52 5.934-6.44.546c-1.173.094-1.653 1.56-.76 2.334l4.894 4.24L4.48 20.92c-.267 1.147.973 2.053 1.987 1.44L12 19.027z"
  })));
};

var Doodle1 = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%22256px%22%20height%3D%22280px%22%20viewBox%3D%220%200%20256%20280%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3ECard%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Crect%20id%3D%22path-1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%22256%22%20height%3D%22280%22%20rx%3D%2216%22%3E%3C%2Frect%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Design%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22home%22%20transform%3D%22translate%28-32.000000%2C%20-352.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Cards%22%20transform%3D%22translate%2832.000000%2C%20352.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Card%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Base%22%20fill%3D%22%23FF7502%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M45.5%2C124%20C7.66745%2C124%20-23%2C93.3314083%20-23%2C55.5%20C-23%2C17.6685917%207.66745%2C-13%2045.5%2C-13%20C83.33255%2C-13%20114%2C17.6685917%20114%2C55.5%20C114%2C93.3314083%2083.33255%2C124%2045.5%2C124%20M46%2C-59%20C-16.96106%2C-59%20-68%2C-7.96106%20-68%2C55%20C-68%2C117.96106%20-16.96106%2C169%2046%2C169%20C108.96106%2C169%20160%2C117.96106%20160%2C55%20C160%2C-7.96106%20108.96106%2C-59%2046%2C-59%22%20id%3D%22Fill-1%22%20fill%3D%22%235BCFFF%22%20mask%3D%22url%28%23mask-2%29%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M160.372046%2C150.541002%20L129.872046%2C150.541002%20L129.872046%2C89.5410025%20L160.372046%2C89.5410025%20C177.216688%2C89.5410025%20190.872046%2C103.195852%20190.872046%2C120.041002%20C190.872046%2C136.886152%20177.216688%2C150.541002%20160.372046%2C150.541002%20M160%2C69%20L129.4%2C69%20L109%2C69%20L109%2C211%20L129.4%2C211%20L129.4%2C170.428571%20L160%2C170.428571%20C188.16679%2C170.428571%20211%2C147.723279%20211%2C119.714286%20C211%2C91.7052929%20188.16679%2C69%20160%2C69%22%20id%3D%22Fill-15%22%20fill%3D%22%23FFD322%22%20mask%3D%22url%28%23mask-2%29%22%20transform%3D%22translate%28160.000000%2C%20140.000000%29%20rotate%2821.000000%29%20translate%28-160.000000%2C%20-140.000000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var Doodle2 = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%22256px%22%20height%3D%22280px%22%20viewBox%3D%220%200%20256%20280%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3ECard%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Crect%20id%3D%22path-1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%22256%22%20height%3D%22280%22%20rx%3D%2216%22%3E%3C%2Frect%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Design%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22home%22%20transform%3D%22translate%28-312.000000%2C%20-352.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Cards%22%20transform%3D%22translate%2832.000000%2C%20352.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Card%22%20transform%3D%22translate%28280.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Base%22%20fill%3D%22%23FF9CDE%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M104.682539%2C216.561279%20L104.682539%2C139.561279%20C104.682539%2C114.045789%20125.366279%2C93.3612793%20150.882539%2C93.3612793%20C176.398799%2C93.3612793%20197.082539%2C114.045789%20197.082539%2C139.561279%20L197.082539%2C216.561279%20L227.882539%2C216.561279%20L227.882539%2C139.561279%20C227.882539%2C97.0349493%20193.408869%2C62.5612793%20150.882539%2C62.5612793%20C108.356209%2C62.5612793%2073.8825389%2C97.0349493%2073.8825389%2C139.561279%20L73.8825389%2C216.561279%20L104.682539%2C216.561279%20Z%22%20id%3D%22Fill-11%22%20fill%3D%22%233C00BA%22%20mask%3D%22url%28%23mask-2%29%22%20transform%3D%22translate%28150.882539%2C%20139.561279%29%20rotate%28-24.000000%29%20translate%28-150.882539%2C%20-139.561279%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-5%22%20fill%3D%22%2343C942%22%20mask%3D%22url%28%23mask-2%29%22%20transform%3D%22translate%2881.500000%2C%20-1.500000%29%20rotate%28-96.000000%29%20translate%28-81.500000%2C%201.500000%29%20%22%20points%3D%22113%20-54%20113%20-12%2050%20-12%2050%20-54%2029%20-54%2029%2051%2050%2051%2050%209%20113%209%20113%2051%20134%2051%20134%20-54%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var Doodle3 = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%22256px%22%20height%3D%22280px%22%20viewBox%3D%220%200%20256%20280%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3ECard%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Crect%20id%3D%22path-1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%22256%22%20height%3D%22280%22%20rx%3D%2216%22%3E%3C%2Frect%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Design%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22home%22%20transform%3D%22translate%28-592.000000%2C%20-352.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Cards%22%20transform%3D%22translate%2832.000000%2C%20352.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Card%22%20transform%3D%22translate%28560.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Base%22%20fill%3D%22%235BCFFF%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-5%22%20fill%3D%22%23FFD322%22%20mask%3D%22url%28%23mask-2%29%22%20transform%3D%22translate%2831.000000%2C%2014.000000%29%20rotate%2828.000000%29%20translate%28-31.000000%2C%20-14.000000%29%20%22%20points%3D%2291%20-86%2091%20-6%20-29%20-6%20-29%20-86%20-69%20-86%20-69%20114%20-29%20114%20-29%2034%2091%2034%2091%20114%20131%20114%20131%20-86%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M203%2C149%20C203%2C129.11756%20186.832694%2C113%20166.888889%2C113%20C155.075861%2C113%20144.588111%2C118.65524%20138%2C127.39784%20C131.411889%2C118.65524%20120.924139%2C113%20109.111111%2C113%20C100.981417%2C113%2093.4796944%2C115.67876%2087.4444444%2C120.19856%20L87.4444444%2C113%20L73%2C113%20L73%2C185%20L87.4444444%2C185%20L87.4444444%2C149%20C87.4444444%2C137.07068%2097.1446111%2C127.4%20109.111111%2C127.4%20C121.07725%2C127.4%20130.777778%2C137.07032%20130.777778%2C148.99964%20L130.777778%2C185%20L145.222222%2C185%20L145.222222%2C149%20C145.222222%2C137.07068%20154.922389%2C127.4%20166.888889%2C127.4%20C178.855028%2C127.4%20188.555556%2C137.07032%20188.555556%2C148.99964%20L188.555556%2C185%20L203%2C185%20L203%2C149%20Z%22%20id%3D%22Fill-7%22%20fill%3D%22%238B1ABB%22%20mask%3D%22url%28%23mask-2%29%22%20transform%3D%22translate%28138.000000%2C%20149.000000%29%20rotate%28-53.000000%29%20translate%28-138.000000%2C%20-149.000000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

exports.BookType = void 0;
(function (BookType) {
    BookType["Reading"] = "Reading";
    BookType["Listening"] = "Listening";
    BookType["Mix"] = "Mix";
})(exports.BookType || (exports.BookType = {}));
exports.BookBranding = void 0;
(function (BookBranding) {
    BookBranding["NONE"] = "None";
    BookBranding["ASTRID_CLASSIC"] = "Astrid Classic";
    BookBranding["WATERBEAR"] = "Waterbear";
})(exports.BookBranding || (exports.BookBranding = {}));
exports.CEFRLevels = void 0;
(function (CEFRLevels) {
    CEFRLevels["A11"] = "A1.1";
    CEFRLevels["A12"] = "A1.2";
    CEFRLevels["A13"] = "A1.3";
    CEFRLevels["A21"] = "A2.1";
    CEFRLevels["A22"] = "A2.2";
    CEFRLevels["A23"] = "A2.3";
    CEFRLevels["B11"] = "B1.1";
    CEFRLevels["B12"] = "B1.2";
    CEFRLevels["B13"] = "B1.3";
    CEFRLevels["B21"] = "B2.1";
    CEFRLevels["B22"] = "B2.2";
    CEFRLevels["B23"] = "B2.3";
    CEFRLevels["C1plus"] = "C1+";
})(exports.CEFRLevels || (exports.CEFRLevels = {}));
exports.GESELevels = void 0;
(function (GESELevels) {
    GESELevels["ONE"] = "1";
    GESELevels["TWO"] = "2";
    GESELevels["THREE"] = "3";
    GESELevels["FOUR"] = "4";
    GESELevels["FIVE"] = "5";
    GESELevels["SIX"] = "6";
    GESELevels["SEVEN"] = "7";
    GESELevels["EIGHT"] = "8";
    GESELevels["NINE"] = "9";
    GESELevels["TEN"] = "10";
    GESELevels["ELEVEN"] = "11";
    GESELevels["TWELVE"] = "12";
})(exports.GESELevels || (exports.GESELevels = {}));
exports.BookRate = void 0;
(function (BookRate) {
    BookRate["GOOD"] = "good";
    BookRate["BAD"] = "bad";
})(exports.BookRate || (exports.BookRate = {}));

exports.ExerciseType = void 0;
(function (ExerciseType) {
    ExerciseType["ReadWordRace"] = "ReadWordRace";
    ExerciseType["ReadSentence"] = "ReadSentence";
    ExerciseType["WordBuilder"] = "WordBuilder";
    ExerciseType["SentenceBuilder"] = "SentenceBuilder";
    ExerciseType["MultiChoiseQuestion"] = "MultiChoiseQuestion";
    ExerciseType["WordPractice"] = "WordPractice";
    ExerciseType["Conversation"] = "Conversation";
})(exports.ExerciseType || (exports.ExerciseType = {}));

exports.UserRegion = void 0;
(function (UserRegion) {
    UserRegion["UK"] = "UK";
    UserRegion["US"] = "US";
    UserRegion["ELT"] = "ELT";
})(exports.UserRegion || (exports.UserRegion = {}));

exports.StudySetComponentType = void 0;
(function (StudySetComponentType) {
    StudySetComponentType["Book"] = "book";
    StudySetComponentType["Exercise"] = "exercise";
    StudySetComponentType["SpeakingChallenge"] = "speaking-challenge";
    StudySetComponentType["Video"] = "video";
})(exports.StudySetComponentType || (exports.StudySetComponentType = {}));

var _path$E, _path2$i;
function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
var SvgReadingExercise = function SvgReadingExercise(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$N({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$E || (_path$E = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.7333 7.27575L18.637 2.34176C18.4607 1.55163 17.7727 1.00004 16.964 1.00004C16.0193 1.00004 15.25 1.76891 15.25 2.71364V2.97919C15.25 3.19799 15.427 3.37504 15.6458 3.37504C15.8646 3.37504 16.0417 3.19799 16.0417 2.97919V2.71364C16.0417 2.20531 16.4553 1.79169 16.964 1.79169C17.3993 1.79169 17.7696 2.08894 17.8639 2.51377L18.9602 7.44738C19.0963 8.06047 19.1767 8.68591 19.2006 9.3125H19.1683C18.9664 7.31787 17.297 5.75 15.25 5.75C13.4603 5.75 11.9616 6.95179 11.4738 8.58508C11.2316 8.32973 10.9124 8.125 10.5 8.125C10.0876 8.125 9.76839 8.32973 9.52618 8.58508C9.03837 6.95179 7.53971 5.75 5.75 5.75C3.70305 5.75 2.03361 7.31787 1.83166 9.3125H1.79937C1.82335 8.68591 1.90376 8.06043 2.0398 7.44738L3.13609 2.51414C3.23042 2.08894 3.60074 1.79165 4.03599 1.79165C4.54469 1.79165 4.95831 2.20528 4.95831 2.7136V2.97915C4.95831 3.19795 5.13536 3.375 5.35415 3.375C5.57295 3.375 5.75 3.19795 5.75 2.97915V2.7136C5.75 1.76887 4.98076 1 4.03599 1C3.2273 1 2.53926 1.55163 2.36299 2.34213L1.26674 7.27575C1.08969 8.07438 1 8.89272 1 9.70835C1 9.92714 1.17705 10.1042 1.39585 10.1042H1.8317C2.03361 12.0988 3.70305 13.6667 5.75004 13.6667C7.89882 13.6667 9.6447 11.9429 9.6984 9.80687C9.77793 9.58555 10.0942 8.91669 10.5 8.91669C10.8954 8.91669 11.2077 9.54829 11.3016 9.80568C11.3546 11.9423 13.1009 13.6667 15.25 13.6667C17.297 13.6667 18.9664 12.0988 19.1684 10.1042H19.6042C19.823 10.1042 20.0001 9.92714 20.0001 9.70835C20 8.89272 19.9103 8.07438 19.7333 7.27575ZM5.75 12.875C4.00352 12.875 2.58335 11.4544 2.58335 9.70835C2.58335 7.96228 4.00356 6.54169 5.75 6.54169C7.49644 6.54169 8.91665 7.96228 8.91665 9.70835C8.91665 11.4544 7.49648 12.875 5.75 12.875ZM15.25 12.875C13.5035 12.875 12.0833 11.4544 12.0833 9.70835C12.0833 7.96228 13.5036 6.54169 15.25 6.54169C16.9964 6.54169 18.4167 7.96228 18.4167 9.70835C18.4167 11.4544 16.9965 12.875 15.25 12.875Z",
    fill: "#0A0A0A",
    fillOpacity: 0.76
  })), _path2$i || (_path2$i = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.8309 7.25411L19.8309 7.25406L18.7346 2.32007L18.7346 2.31999C18.5482 1.48418 17.8195 0.900037 16.964 0.900037C15.9641 0.900037 15.15 1.71365 15.15 2.71364V2.97919C15.15 3.25322 15.3718 3.47504 15.6458 3.47504C15.9199 3.47504 16.1417 3.25322 16.1417 2.97919V2.71364C16.1417 2.26057 16.5105 1.89169 16.964 1.89169C17.3524 1.89169 17.6821 2.15636 17.7663 2.53544L17.7663 2.53546L18.8626 7.46905C18.9162 7.71061 18.9611 7.95411 18.9972 8.19885C18.4008 6.70812 16.9532 5.65 15.25 5.65C13.4713 5.65 11.9741 6.80711 11.4278 8.40102C11.1887 8.18751 10.8826 8.025 10.5 8.025C10.1174 8.025 9.81128 8.18751 9.57217 8.40102C9.02595 6.80711 7.52872 5.65 5.75 5.65C4.04682 5.65 2.59927 6.70813 2.00283 8.19886C2.03894 7.95412 2.08382 7.71062 2.13742 7.46908C2.13743 7.46907 2.13743 7.46906 2.13743 7.46905L3.23371 2.53583L3.23372 2.5358C3.3179 2.15633 3.64766 1.89165 4.03599 1.89165C4.48949 1.89165 4.85831 2.26053 4.85831 2.7136V2.97915C4.85831 3.25318 5.08013 3.475 5.35415 3.475C5.62818 3.475 5.85 3.25318 5.85 2.97915V2.7136C5.85 1.71361 5.03596 0.9 4.03599 0.9C3.18041 0.9 2.45184 1.4842 2.26539 2.32037L2.26537 2.32044L1.16912 7.25406L1.16911 7.25411C0.990492 8.05983 0.9 8.88542 0.9 9.70835C0.9 9.98237 1.12182 10.2042 1.39585 10.2042H1.74231C1.98957 12.2055 3.68121 13.7667 5.75004 13.7667C7.94802 13.7667 9.73428 12.0081 9.79792 9.82595C9.83863 9.71719 9.93106 9.51427 10.0581 9.33706C10.1246 9.24441 10.1978 9.16252 10.2749 9.10458C10.3518 9.04671 10.427 9.01669 10.5 9.01669C10.6455 9.01669 10.7962 9.1367 10.9332 9.32376C11.0602 9.4971 11.1552 9.70061 11.202 9.82493C11.2651 12.0075 13.0517 13.7667 15.25 13.7667C17.3188 13.7667 19.0105 12.2055 19.2578 10.2042H19.6042C19.8783 10.2042 20.1001 9.98237 20.1001 9.70835C20.1 8.88542 20.0095 8.05983 19.8309 7.25411ZM5.75 12.775C4.05876 12.775 2.68335 11.3992 2.68335 9.70835C2.68335 8.0175 4.05879 6.64169 5.75 6.64169C7.44121 6.64169 8.81665 8.0175 8.81665 9.70835C8.81665 11.3992 7.44124 12.775 5.75 12.775ZM15.25 12.775C13.5588 12.775 12.1833 11.3992 12.1833 9.70835C12.1833 8.0175 13.5588 6.64169 15.25 6.64169C16.9412 6.64169 18.3167 8.0175 18.3167 9.70835C18.3167 11.3992 16.9412 12.775 15.25 12.775Z",
    stroke: "#0A0A0A",
    strokeOpacity: 0.76,
    strokeWidth: 0.2
  })));
};

var _path$D, _path2$h, _path3$f, _path4$e, _path5$e;
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
var SvgListeningExercise = function SvgListeningExercise(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$M({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$D || (_path$D = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6.60986 13.2891V9.21757",
    stroke: "#0A0A0A",
    strokeOpacity: 0.76,
    strokeWidth: 1.5
  })), _path2$h || (_path2$h = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.35449 14.0195L5.01602 14.0384C3.90518 14.0474 2.99988 13.1494 2.99988 12.0385V10.4685C2.99988 9.36391 3.89531 8.46848 4.99988 8.46848H7.35449",
    stroke: "#0A0A0A",
    strokeOpacity: 0.76,
    strokeWidth: 1.5
  })), _path3$f || (_path3$f = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.348 12.1724V8.67399C16.348 4.43577 12.9122 1 8.67399 1V1C4.43576 1 1 4.43576 1 8.67399V12.1724",
    stroke: "#0A0A0A",
    strokeOpacity: 0.76,
    strokeWidth: 1.5
  })), _path4$e || (_path4$e = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.7446 13.2891V9.21617",
    stroke: "#0A0A0A",
    strokeOpacity: 0.76,
    strokeWidth: 1.5
  })), _path5$e || (_path5$e = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10 14.0195L12.3385 14.0384C13.4493 14.0474 14.3546 13.1494 14.3546 12.0385V10.4685C14.3546 9.36391 13.4592 8.46848 12.3546 8.46848H10",
    stroke: "#0A0A0A",
    strokeOpacity: 0.76,
    strokeWidth: 1.5
  })));
};

var _path$C, _path2$g, _path3$e, _path4$d, _path5$d, _path6$d, _path7$d, _path8$c, _path9$c, _path10$c, _path11$c, _path12$b, _path13$b;
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
var SvgA11 = function SvgA11(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$L({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$C || (_path$C = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.3239 21V14.312C14.3239 14.0667 14.3239 13.816 14.3239 13.56C14.3345 13.2933 14.3452 13.0213 14.3559 12.744C13.9932 13.0747 13.5879 13.3627 13.1399 13.608C12.6919 13.8533 12.2332 14.024 11.7639 14.12L11.4759 12.264C11.7212 12.2427 11.9932 12.1733 12.2919 12.056C12.6012 11.928 12.9105 11.7787 13.2199 11.608C13.5399 11.4267 13.8279 11.24 14.0839 11.048C14.3505 10.8453 14.5532 10.6427 14.6919 10.44H16.4839V21H14.3239Z",
    fill: "black"
  })), _path2$g || (_path2$g = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.51253 4.66416C9.62224 4.85074 9.86018 4.91555 10.053 4.81727C11.5262 4.06643 13.0997 3.63842 14.6808 3.53324C14.8978 3.51881 15.0696 3.34015 15.0674 3.12276L15.0394 0.419543C15.0371 0.195589 14.8513 0.0166514 14.6277 0.0291876C12.4647 0.150451 10.3017 0.72432 8.29251 1.78495C8.09445 1.8895 8.02753 2.13864 8.14105 2.3317L9.51253 4.66416Z",
    fill: "#DDDDDD"
  })), _path3$e || (_path3$e = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M28.2227 6.65384C27.086 5.02196 25.6871 3.67327 24.1335 2.6273C23.9472 2.50182 23.6952 2.56149 23.5793 2.75395L22.1808 5.07545C22.0687 5.26149 22.126 5.50236 22.3053 5.62493C23.4647 6.4176 24.4976 7.43188 25.3485 8.65851C25.4545 8.8139 25.5563 8.96929 25.654 9.12467C25.7689 9.30753 26.0061 9.37298 26.1955 9.26903L28.576 7.96204C28.773 7.85391 28.8427 7.60458 28.7243 7.41362C28.5654 7.15727 28.3969 6.9027 28.2227 6.65384Z",
    fill: "#DDDDDD"
  })), _path4$d || (_path4$d = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.7207 3.12411C15.7222 3.34112 15.8965 3.51664 16.1132 3.52763C17.8423 3.61529 19.5355 4.07602 21.0816 4.88596C21.2735 4.98648 21.5124 4.92428 21.6242 4.73872L23.0243 2.41448C23.1399 2.22262 23.0756 1.97275 22.8786 1.86613C20.7833 0.732119 18.4652 0.105006 16.1074 0.0109482C15.8835 0.0020138 15.7005 0.184191 15.702 0.40833L15.7207 3.12411Z",
    fill: "#26D4DD"
  })), _path5$d || (_path5$d = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.12714 15.056C3.34293 15.0574 3.52031 14.8874 3.53557 14.6721C3.64618 13.1117 4.05045 11.585 4.7484 10.1759C4.84464 9.98154 4.77705 9.74381 4.58878 9.63622L2.23899 8.29348C2.04417 8.18216 1.79542 8.25262 1.69372 8.45264C0.716999 10.3735 0.150579 12.4839 0.0197525 14.6235C0.00600118 14.8484 0.186083 15.0357 0.411396 15.0373L3.12714 15.056Z",
    fill: "#DDDDDD"
  })), _path6$d || (_path6$d = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408248 15.6913C0.184143 15.689 0.00133779 15.8713 0.00959264 16.0953C0.0874728 18.2083 0.603834 20.3221 1.56713 22.3014C1.66539 22.5033 1.91311 22.5783 2.10995 22.4702L4.4892 21.1639C4.67917 21.0596 4.75086 20.8233 4.65799 20.6275C3.97283 19.1827 3.59804 17.6477 3.52601 16.1137C3.51582 15.8968 3.34083 15.7216 3.12364 15.7193L0.408248 15.6913Z",
    fill: "#DDDDDD"
  })), _path7$d || (_path7$d = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4.92793 9.0702C5.11595 9.17722 5.35439 9.11495 5.47279 8.93388C6.29325 7.67916 7.35844 6.56394 8.65895 5.66359C8.71605 5.62406 8.77476 5.58452 8.83389 5.54499C9.00801 5.42859 9.05989 5.19789 8.95373 5.01734L7.57134 2.66633C7.45866 2.4747 7.21073 2.41081 7.02474 2.53258C6.89909 2.61485 6.77501 2.70046 6.65428 2.78942C4.9147 3.9981 3.50267 5.50262 2.42807 7.17451C2.30627 7.36402 2.37188 7.61537 2.56766 7.72681L4.92793 9.0702Z",
    fill: "#DDDDDD"
  })), _path8$c || (_path8$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M30.5896 15.2721C30.8145 15.2744 30.9976 15.0909 30.9883 14.8661C30.9016 12.7655 30.3944 10.6642 29.4331 8.69707C29.3347 8.49564 29.0873 8.42112 28.8908 8.52902L26.5118 9.83517C26.3214 9.93969 26.2499 10.1768 26.3433 10.3728C27.0262 11.8063 27.3922 13.33 27.4717 14.8525C27.483 15.0683 27.6575 15.2419 27.8736 15.2441L30.5896 15.2721Z",
    fill: "#DDDDDD"
  })), _path9$c || (_path9$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M26.2818 20.777C26.1883 20.9706 26.2566 21.2056 26.4433 21.3123L28.7955 22.6564C28.9909 22.768 29.2404 22.6967 29.3415 22.4957C30.3069 20.5762 30.8622 18.4765 30.9822 16.348C30.9948 16.1244 30.8158 15.9385 30.5918 15.9362L27.886 15.9082C27.6697 15.906 27.4915 16.0761 27.476 16.2919C27.3651 17.8429 26.962 19.3684 26.2818 20.777Z",
    fill: "#DDDDDD"
  })), _path10$c || (_path10$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.4994 28.3063C23.6127 28.4991 23.862 28.5613 24.049 28.4389C24.1519 28.3716 24.2549 28.303 24.3578 28.2344C26.1115 27.0124 27.5367 25.4935 28.6133 23.7871C28.7327 23.598 28.6668 23.3491 28.4726 23.2381L26.1219 21.8949C25.9333 21.7871 25.6938 21.8499 25.5756 22.0322C24.7533 23.2999 23.676 24.4375 22.3531 25.3602C22.3238 25.3797 22.295 25.3993 22.2665 25.4187C22.0835 25.5434 22.0216 25.7931 22.1339 25.984L23.4994 28.3063Z",
    fill: "#DDDDDD"
  })), _path11$c || (_path11$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.5605 26.3005C21.4503 26.1132 21.2111 26.0487 21.018 26.1484C19.5443 26.9098 17.9701 27.3482 16.3884 27.4634C16.1726 27.4792 16.0023 27.6574 16.0045 27.8737L16.0325 30.5775C16.0348 30.8022 16.2218 30.9815 16.4461 30.9678C18.6183 30.8357 20.7729 30.2507 22.7817 29.1786C22.9787 29.0735 23.0449 28.8251 22.9317 28.6326L21.5605 26.3005Z",
    fill: "#DDDDDD"
  })), _path12$b || (_path12$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.85754 25.9593C8.96863 25.7737 8.91156 25.5339 8.73303 25.4117C7.56055 24.6092 6.51571 23.5928 5.66356 22.3533C5.55762 22.1979 5.4558 22.0425 5.35812 21.8871C5.24316 21.7043 5.00597 21.6388 4.81664 21.7428L2.43604 23.0498C2.2391 23.1579 2.16943 23.4072 2.2878 23.5982C2.44669 23.8545 2.6152 24.1091 2.7894 24.358C3.93824 26.0024 5.33919 27.3527 6.91388 28.4088C7.10068 28.5341 7.35287 28.4738 7.46837 28.2808L8.85754 25.9593Z",
    fill: "#DDDDDD"
  })), _path13$b || (_path13$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.9665 26.1378C9.77454 26.0374 9.53566 26.0996 9.42387 26.2852L8.02504 28.6073C7.90896 28.8 7.97436 29.051 8.17283 29.1569C10.2792 30.2809 12.6084 30.9068 14.9773 30.9907C15.2011 30.9986 15.3832 30.8159 15.3809 30.5919L15.3529 27.8887C15.3506 27.6713 15.1751 27.4963 14.9579 27.4864C13.2265 27.4078 11.515 26.9477 9.9665 26.1378Z",
    fill: "#DDDDDD"
  })));
};

var _path$B, _path2$f, _path3$d, _path4$c, _path5$c, _path6$c, _path7$c, _path8$b, _path9$b, _path10$b, _path11$b, _path12$a, _path13$a;
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
var SvgA12 = function SvgA12(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$K({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$B || (_path$B = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.3134 19.496C13.6041 18.632 14.6281 17.8747 15.3854 17.224C16.1428 16.5733 16.6921 15.9707 17.0334 15.416C17.3748 14.8613 17.5454 14.312 17.5454 13.768C17.5454 13.2667 17.3908 12.8613 17.0814 12.552C16.7828 12.2427 16.3668 12.088 15.8334 12.088C15.2468 12.088 14.7828 12.2907 14.4414 12.696C14.1001 13.1013 13.9134 13.6773 13.8814 14.424L11.9774 13.704C12.0521 12.6373 12.4468 11.8 13.1614 11.192C13.8761 10.584 14.8094 10.28 15.9614 10.28C16.7828 10.28 17.4761 10.4347 18.0414 10.744C18.6174 11.0533 19.0494 11.464 19.3374 11.976C19.6254 12.4773 19.7694 13.032 19.7694 13.64C19.7694 14.632 19.3961 15.5707 18.6494 16.456C17.9028 17.3307 16.7134 18.2693 15.0814 19.272V19.288C15.7001 19.2453 16.3454 19.224 17.0174 19.224H19.9294V21H12.3134V19.496Z",
    fill: "black"
  })), _path2$f || (_path2$f = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.51253 4.66416C9.62224 4.85074 9.86018 4.91555 10.053 4.81727C11.5262 4.06643 13.0997 3.63842 14.6808 3.53324C14.8978 3.51881 15.0696 3.34015 15.0674 3.12276L15.0394 0.419543C15.0371 0.195589 14.8513 0.0166514 14.6277 0.0291876C12.4647 0.150451 10.3017 0.72432 8.29251 1.78495C8.09445 1.8895 8.02753 2.13864 8.14105 2.3317L9.51253 4.66416Z",
    fill: "#DDDDDD"
  })), _path3$d || (_path3$d = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M28.2227 6.65384C27.086 5.02196 25.6871 3.67327 24.1335 2.6273C23.9472 2.50182 23.6952 2.56149 23.5793 2.75395L22.1808 5.07545C22.0687 5.26149 22.126 5.50236 22.3053 5.62493C23.4647 6.4176 24.4976 7.43188 25.3485 8.65851C25.4545 8.8139 25.5563 8.96929 25.654 9.12467C25.7689 9.30753 26.0061 9.37298 26.1955 9.26903L28.576 7.96204C28.773 7.85391 28.8427 7.60458 28.7243 7.41362C28.5654 7.15727 28.3969 6.9027 28.2227 6.65384Z",
    fill: "#26D4DD"
  })), _path4$c || (_path4$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.7207 3.12411C15.7222 3.34112 15.8965 3.51664 16.1132 3.52763C17.8423 3.61529 19.5355 4.07602 21.0816 4.88596C21.2735 4.98648 21.5124 4.92428 21.6242 4.73872L23.0243 2.41448C23.1399 2.22262 23.0756 1.97275 22.8786 1.86613C20.7833 0.732119 18.4652 0.105006 16.1074 0.0109482C15.8835 0.0020138 15.7005 0.184191 15.702 0.40833L15.7207 3.12411Z",
    fill: "#26D4DD"
  })), _path5$c || (_path5$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.12714 15.056C3.34293 15.0574 3.52031 14.8874 3.53557 14.6721C3.64618 13.1117 4.05045 11.585 4.7484 10.1759C4.84464 9.98154 4.77705 9.74381 4.58878 9.63622L2.23899 8.29348C2.04417 8.18216 1.79542 8.25262 1.69372 8.45264C0.716999 10.3735 0.150579 12.4839 0.0197525 14.6235C0.00600118 14.8484 0.186083 15.0357 0.411396 15.0373L3.12714 15.056Z",
    fill: "#DDDDDD"
  })), _path6$c || (_path6$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408248 15.6913C0.184143 15.689 0.00133779 15.8713 0.00959264 16.0953C0.0874728 18.2083 0.603834 20.3221 1.56713 22.3014C1.66539 22.5033 1.91311 22.5783 2.10995 22.4702L4.4892 21.1639C4.67917 21.0596 4.75086 20.8233 4.65799 20.6275C3.97283 19.1827 3.59804 17.6477 3.52601 16.1137C3.51582 15.8968 3.34083 15.7216 3.12364 15.7193L0.408248 15.6913Z",
    fill: "#DDDDDD"
  })), _path7$c || (_path7$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4.92793 9.0702C5.11595 9.17722 5.35439 9.11495 5.47279 8.93388C6.29325 7.67916 7.35844 6.56394 8.65895 5.66359C8.71605 5.62406 8.77476 5.58452 8.83389 5.54499C9.00801 5.42859 9.05989 5.19789 8.95373 5.01734L7.57134 2.66633C7.45866 2.4747 7.21073 2.41081 7.02474 2.53258C6.89909 2.61485 6.77501 2.70046 6.65428 2.78942C4.9147 3.9981 3.50267 5.50262 2.42807 7.17451C2.30627 7.36402 2.37188 7.61537 2.56766 7.72681L4.92793 9.0702Z",
    fill: "#DDDDDD"
  })), _path8$b || (_path8$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M30.5896 15.2721C30.8145 15.2744 30.9976 15.0909 30.9883 14.8661C30.9016 12.7655 30.3944 10.6642 29.4331 8.69707C29.3347 8.49564 29.0873 8.42112 28.8908 8.52902L26.5118 9.83517C26.3214 9.93969 26.2499 10.1768 26.3433 10.3728C27.0262 11.8063 27.3922 13.33 27.4717 14.8525C27.483 15.0683 27.6575 15.2419 27.8736 15.2441L30.5896 15.2721Z",
    fill: "#DDDDDD"
  })), _path9$b || (_path9$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M26.2818 20.777C26.1883 20.9706 26.2566 21.2056 26.4433 21.3123L28.7955 22.6564C28.9909 22.768 29.2404 22.6967 29.3415 22.4957C30.3069 20.5762 30.8622 18.4765 30.9822 16.348C30.9948 16.1244 30.8158 15.9385 30.5918 15.9362L27.886 15.9082C27.6697 15.906 27.4915 16.0761 27.476 16.2919C27.3651 17.8429 26.962 19.3684 26.2818 20.777Z",
    fill: "#DDDDDD"
  })), _path10$b || (_path10$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.4994 28.3063C23.6127 28.4991 23.862 28.5613 24.049 28.4389C24.1519 28.3716 24.2549 28.303 24.3578 28.2344C26.1115 27.0124 27.5367 25.4935 28.6133 23.7871C28.7327 23.598 28.6668 23.3491 28.4726 23.2381L26.1219 21.8949C25.9333 21.7871 25.6938 21.8499 25.5756 22.0322C24.7533 23.2999 23.676 24.4375 22.3531 25.3602C22.3238 25.3797 22.295 25.3993 22.2665 25.4187C22.0835 25.5434 22.0216 25.7931 22.1339 25.984L23.4994 28.3063Z",
    fill: "#DDDDDD"
  })), _path11$b || (_path11$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.5605 26.3005C21.4503 26.1132 21.2111 26.0487 21.018 26.1484C19.5443 26.9098 17.9701 27.3482 16.3884 27.4634C16.1726 27.4792 16.0023 27.6574 16.0045 27.8737L16.0325 30.5775C16.0348 30.8022 16.2218 30.9815 16.4461 30.9678C18.6183 30.8357 20.7729 30.2507 22.7817 29.1786C22.9787 29.0735 23.0449 28.8251 22.9317 28.6326L21.5605 26.3005Z",
    fill: "#DDDDDD"
  })), _path12$a || (_path12$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.85754 25.9593C8.96863 25.7737 8.91156 25.5339 8.73303 25.4117C7.56055 24.6092 6.51571 23.5928 5.66356 22.3533C5.55762 22.1979 5.4558 22.0425 5.35812 21.8871C5.24316 21.7043 5.00597 21.6388 4.81664 21.7428L2.43604 23.0498C2.2391 23.1579 2.16943 23.4072 2.2878 23.5982C2.44669 23.8545 2.6152 24.1091 2.7894 24.358C3.93824 26.0024 5.33919 27.3527 6.91388 28.4088C7.10068 28.5341 7.35287 28.4738 7.46837 28.2808L8.85754 25.9593Z",
    fill: "#DDDDDD"
  })), _path13$a || (_path13$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.9665 26.1378C9.77454 26.0374 9.53566 26.0996 9.42387 26.2852L8.02504 28.6073C7.90896 28.8 7.97436 29.051 8.17283 29.1569C10.2792 30.2809 12.6084 30.9068 14.9773 30.9907C15.2011 30.9986 15.3832 30.8159 15.3809 30.5919L15.3529 27.8887C15.3506 27.6713 15.1751 27.4963 14.9579 27.4864C13.2265 27.4078 11.515 26.9477 9.9665 26.1378Z",
    fill: "#DDDDDD"
  })));
};

var _path$A, _path2$e, _path3$c, _path4$b, _path5$b, _path6$b, _path7$b, _path8$a, _path9$a, _path10$a, _path11$a, _path12$9, _path13$9;
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
var SvgA13 = function SvgA13(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$J({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$A || (_path$A = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.0411 21.16C14.9851 21.16 14.0837 20.9413 13.3371 20.504C12.6011 20.056 12.0944 19.416 11.8171 18.584L13.8971 17.672C13.9717 18.056 14.0944 18.376 14.2651 18.632C14.4357 18.8773 14.6651 19.064 14.9531 19.192C15.2517 19.32 15.6037 19.384 16.0091 19.384C16.3717 19.384 16.6757 19.32 16.9211 19.192C17.1771 19.0533 17.3744 18.872 17.5131 18.648C17.6517 18.4133 17.7211 18.1413 17.7211 17.832C17.7211 17.5227 17.6571 17.2667 17.5291 17.064C17.4011 16.8613 17.2144 16.7173 16.9691 16.632C16.7344 16.536 16.4304 16.488 16.0571 16.488C15.9184 16.488 15.7851 16.4933 15.6571 16.504C15.5397 16.504 15.4064 16.5147 15.2571 16.536V14.92C15.3424 14.9307 15.4277 14.9413 15.5131 14.952C15.6091 14.952 15.7051 14.952 15.8011 14.952C16.3984 14.952 16.8251 14.8347 17.0811 14.6C17.3477 14.3547 17.4811 13.9653 17.4811 13.432C17.4811 12.9947 17.3477 12.6587 17.0811 12.424C16.8251 12.1787 16.4571 12.056 15.9771 12.056C15.4651 12.056 15.0597 12.184 14.7611 12.44C14.4624 12.6853 14.2544 13.064 14.1371 13.576L12.1691 12.84C12.2971 12.3067 12.5424 11.848 12.9051 11.464C13.2784 11.08 13.7371 10.7867 14.2811 10.584C14.8251 10.3707 15.4277 10.264 16.0891 10.264C16.8784 10.264 17.5344 10.3867 18.0571 10.632C18.5904 10.8773 18.9904 11.2133 19.2571 11.64C19.5344 12.0667 19.6731 12.5573 19.6731 13.112C19.6731 13.5493 19.6037 13.9227 19.4651 14.232C19.3371 14.5307 19.1664 14.7867 18.9531 15C18.7504 15.2027 18.5371 15.3573 18.3131 15.464C18.0891 15.5707 17.8811 15.6347 17.6891 15.656V15.704C17.9344 15.7147 18.1851 15.768 18.4411 15.864C18.6971 15.9493 18.9317 16.0827 19.1451 16.264C19.3691 16.4453 19.5504 16.68 19.6891 16.968C19.8277 17.2453 19.8971 17.576 19.8971 17.96C19.8971 18.6 19.7264 19.1653 19.3851 19.656C19.0544 20.136 18.6011 20.5093 18.0251 20.776C17.4491 21.032 16.7877 21.16 16.0411 21.16Z",
    fill: "black"
  })), _path2$e || (_path2$e = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.51253 4.66416C9.62224 4.85074 9.86018 4.91555 10.053 4.81727C11.5262 4.06643 13.0997 3.63842 14.6808 3.53324C14.8978 3.51881 15.0696 3.34015 15.0674 3.12276L15.0394 0.419543C15.0371 0.195589 14.8513 0.0166514 14.6277 0.0291876C12.4647 0.150451 10.3017 0.72432 8.29251 1.78495C8.09445 1.8895 8.02753 2.13864 8.14105 2.3317L9.51253 4.66416Z",
    fill: "#DDDDDD"
  })), _path3$c || (_path3$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M28.2227 6.65384C27.086 5.02196 25.6871 3.67327 24.1335 2.6273C23.9472 2.50182 23.6952 2.56149 23.5793 2.75395L22.1808 5.07545C22.0687 5.26149 22.126 5.50236 22.3053 5.62493C23.4647 6.4176 24.4976 7.43188 25.3485 8.65851C25.4545 8.8139 25.5563 8.96929 25.654 9.12467C25.7689 9.30753 26.0061 9.37298 26.1955 9.26903L28.576 7.96204C28.773 7.85391 28.8427 7.60458 28.7243 7.41362C28.5654 7.15727 28.3969 6.9027 28.2227 6.65384Z",
    fill: "#26D4DD"
  })), _path4$b || (_path4$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.7207 3.12411C15.7222 3.34112 15.8965 3.51664 16.1132 3.52763C17.8423 3.61529 19.5355 4.07602 21.0816 4.88596C21.2735 4.98648 21.5124 4.92428 21.6242 4.73872L23.0243 2.41448C23.1399 2.22262 23.0756 1.97275 22.8786 1.86613C20.7833 0.732119 18.4652 0.105006 16.1074 0.0109482C15.8835 0.0020138 15.7005 0.184191 15.702 0.40833L15.7207 3.12411Z",
    fill: "#26D4DD"
  })), _path5$b || (_path5$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.12714 15.056C3.34293 15.0574 3.52031 14.8874 3.53557 14.6721C3.64618 13.1117 4.05045 11.585 4.7484 10.1759C4.84464 9.98154 4.77705 9.7438 4.58878 9.63622L2.23899 8.29348C2.04417 8.18215 1.79542 8.25262 1.69372 8.45263C0.716999 10.3735 0.150579 12.4839 0.0197525 14.6235C0.00600118 14.8484 0.186083 15.0357 0.411396 15.0373L3.12714 15.056Z",
    fill: "#DDDDDD"
  })), _path6$b || (_path6$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408248 15.6913C0.184143 15.689 0.00133779 15.8713 0.00959264 16.0953C0.0874728 18.2083 0.603834 20.3221 1.56713 22.3014C1.66539 22.5033 1.91311 22.5783 2.10995 22.4702L4.4892 21.1639C4.67917 21.0597 4.75086 20.8233 4.65799 20.6275C3.97283 19.1827 3.59804 17.6477 3.52601 16.1137C3.51582 15.8968 3.34083 15.7216 3.12364 15.7193L0.408248 15.6913Z",
    fill: "#DDDDDD"
  })), _path7$b || (_path7$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4.92793 9.07021C5.11595 9.17723 5.35439 9.11495 5.47279 8.93388C6.29325 7.67916 7.35844 6.56395 8.65895 5.66359C8.71605 5.62406 8.77476 5.58453 8.83389 5.545C9.00801 5.4286 9.05989 5.19789 8.95373 5.01735L7.57134 2.66634C7.45866 2.47471 7.21073 2.41081 7.02474 2.53258C6.89909 2.61485 6.77501 2.70047 6.65428 2.78943C4.9147 3.9981 3.50267 5.50262 2.42807 7.17452C2.30627 7.36402 2.37188 7.61537 2.56766 7.72681L4.92793 9.07021Z",
    fill: "#DDDDDD"
  })), _path8$a || (_path8$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M30.5896 15.2721C30.8145 15.2744 30.9976 15.0909 30.9883 14.8661C30.9016 12.7655 30.3944 10.6642 29.4331 8.69707C29.3347 8.49563 29.0873 8.42112 28.8908 8.52902L26.5118 9.83516C26.3214 9.93968 26.2499 10.1768 26.3433 10.3728C27.0262 11.8063 27.3922 13.33 27.4717 14.8525C27.483 15.0683 27.6575 15.2419 27.8736 15.2441L30.5896 15.2721Z",
    fill: "#26D4DD"
  })), _path9$a || (_path9$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M26.2818 20.777C26.1883 20.9706 26.2566 21.2056 26.4433 21.3123L28.7955 22.6563C28.9909 22.768 29.2404 22.6967 29.3415 22.4957C30.3069 20.5762 30.8622 18.4765 30.9822 16.348C30.9948 16.1244 30.8158 15.9385 30.5918 15.9362L27.886 15.9082C27.6697 15.906 27.4915 16.0761 27.476 16.2919C27.3651 17.8429 26.962 19.3684 26.2818 20.777Z",
    fill: "#DDDDDD"
  })), _path10$a || (_path10$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.4994 28.3063C23.6127 28.4991 23.862 28.5613 24.049 28.4389C24.1519 28.3716 24.2549 28.303 24.3578 28.2344C26.1115 27.0124 27.5367 25.4935 28.6133 23.7871C28.7327 23.598 28.6668 23.3491 28.4726 23.2381L26.1219 21.8949C25.9333 21.7871 25.6938 21.8499 25.5756 22.0322C24.7533 23.2999 23.676 24.4375 22.3531 25.3602C22.3238 25.3797 22.295 25.3993 22.2665 25.4187C22.0835 25.5434 22.0216 25.7931 22.1339 25.984L23.4994 28.3063Z",
    fill: "#DDDDDD"
  })), _path11$a || (_path11$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.5605 26.3005C21.4503 26.1132 21.2111 26.0487 21.018 26.1484C19.5443 26.9098 17.9701 27.3482 16.3884 27.4634C16.1726 27.4792 16.0023 27.6574 16.0045 27.8737L16.0325 30.5775C16.0348 30.8022 16.2218 30.9815 16.4461 30.9678C18.6183 30.8357 20.7729 30.2507 22.7817 29.1786C22.9787 29.0735 23.0449 28.8251 22.9317 28.6326L21.5605 26.3005Z",
    fill: "#DDDDDD"
  })), _path12$9 || (_path12$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.85754 25.9593C8.96863 25.7737 8.91156 25.5339 8.73303 25.4117C7.56055 24.6092 6.51571 23.5928 5.66356 22.3533C5.55762 22.1979 5.4558 22.0425 5.35812 21.8871C5.24316 21.7043 5.00597 21.6388 4.81664 21.7428L2.43604 23.0498C2.2391 23.1579 2.16943 23.4072 2.2878 23.5982C2.44669 23.8545 2.6152 24.1091 2.7894 24.358C3.93824 26.0024 5.33919 27.3527 6.91388 28.4088C7.10068 28.5341 7.35287 28.4738 7.46837 28.2808L8.85754 25.9593Z",
    fill: "#DDDDDD"
  })), _path13$9 || (_path13$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.9665 26.1378C9.77454 26.0375 9.53566 26.0997 9.42387 26.2852L8.02504 28.6073C7.90896 28.8 7.97436 29.051 8.17283 29.1569C10.2792 30.2809 12.6084 30.9068 14.9773 30.9907C15.2011 30.9986 15.3832 30.8159 15.3809 30.5919L15.3529 27.8887C15.3506 27.6713 15.1751 27.4963 14.9579 27.4864C13.2265 27.4078 11.515 26.9477 9.9665 26.1378Z",
    fill: "#DDDDDD"
  })));
};

var _path$z, _path2$d, _path3$b, _path4$a, _path5$a, _path6$a, _path7$a, _path8$9, _path9$9, _path10$9, _path11$9, _path12$8, _path13$8;
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
var SvgA21 = function SvgA21(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$I({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$z || (_path$z = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.0055 18.52H18.2935V21H16.2935V18.52H11.0295V17.352L15.6535 10.44H18.2935V16.92H20.0055V18.52ZM13.1575 16.92H16.2935V13.688L16.3415 11.96H16.3095C16.0748 12.504 15.7548 13.0853 15.3495 13.704L13.1575 16.92Z",
    fill: "black"
  })), _path2$d || (_path2$d = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.82565 4.82543C9.93536 5.01201 10.1733 5.07685 10.3661 4.97837C11.8938 4.19778 13.5265 3.75378 15.1669 3.64638C15.3838 3.63218 15.5557 3.4535 15.5535 3.23611L15.5243 0.419923C15.522 0.19597 15.3362 0.0170491 15.1126 0.0294023C12.8713 0.153217 10.6297 0.747754 8.54829 1.84868C8.35033 1.95339 8.28339 2.20252 8.39691 2.39558L9.82565 4.82543Z",
    fill: "#DDDDDD"
  })), _path3$b || (_path3$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.1331 6.86848C27.957 5.18012 26.5091 3.78542 24.9011 2.70468C24.7146 2.57935 24.4626 2.63901 24.3467 2.83147L22.8898 5.24996C22.7777 5.436 22.8349 5.67689 23.0144 5.79927C24.2154 6.61855 25.2853 7.66794 26.1662 8.93782C26.278 9.10175 26.3853 9.26567 26.4881 9.4296C26.6029 9.61256 26.8402 9.678 27.0295 9.57405L29.5094 8.21251C29.7064 8.10439 29.776 7.85507 29.6578 7.66401C29.4918 7.39559 29.3154 7.12901 29.1331 6.86848Z",
    fill: "#26D4DD"
  })), _path4$a || (_path4$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.2278 3.23747C16.2293 3.45448 16.4036 3.63002 16.6204 3.64079C18.4137 3.72988 20.17 4.20775 21.7727 5.04941C21.9645 5.15012 22.2034 5.08789 22.3152 4.90233L23.7738 2.4811C23.8893 2.28923 23.825 2.03938 23.6281 1.9326C21.4583 0.755933 19.0565 0.106231 16.6138 0.0107818C16.3898 0.00203011 16.2068 0.184191 16.2084 0.40833L16.2278 3.23747Z",
    fill: "#26D4DD"
  })), _path5$a || (_path5$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.2405 15.5417C3.45629 15.5432 3.63369 15.3732 3.64874 15.1579C3.76194 13.5387 4.18141 11.9543 4.90716 10.4928C5.0036 10.2986 4.93599 10.0609 4.74772 9.9533L2.29976 8.55447C2.10494 8.44314 1.8562 8.51361 1.75433 8.71354C0.740423 10.7035 0.153364 12.891 0.0195852 15.1085C0.006017 15.3334 0.186083 15.5207 0.411396 15.5223L3.2405 15.5417Z",
    fill: "#DDDDDD"
  })), _path6$a || (_path6$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408249 16.1974C0.184143 16.1951 0.00135428 16.3773 0.0094224 16.6013C0.0883039 18.7911 0.623374 20.9819 1.62346 23.0327C1.72189 23.2345 1.96959 23.3095 2.16643 23.2014L4.64502 21.8406C4.835 21.7363 4.9067 21.4999 4.81364 21.3042C4.10108 19.8056 3.71225 18.2126 3.63916 16.6209C3.6292 16.404 3.45419 16.2288 3.237 16.2265L0.408249 16.1974Z",
    fill: "#DDDDDD"
  })), _path7$a || (_path7$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.09777 9.36899C5.2858 9.47601 5.52425 9.41375 5.64247 9.23256C6.49032 7.93309 7.59218 6.7782 8.93826 5.84629C9.00041 5.80326 9.0644 5.76023 9.12881 5.71721C9.30297 5.60087 9.35478 5.37007 9.24862 5.18952L7.80897 2.74112C7.69629 2.5495 7.44839 2.48564 7.26224 2.60715C7.1288 2.69426 6.99704 2.78501 6.86893 2.87941C5.06937 4.12976 3.60938 5.68682 2.49923 7.41711C2.37757 7.60671 2.44317 7.85806 2.63895 7.9695L5.09777 9.36899Z",
    fill: "#DDDDDD"
  })), _path8$9 || (_path8$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.5897 15.7649C31.8146 15.7672 31.9977 15.5836 31.9886 15.3589C31.9005 13.1819 31.375 11.0039 30.3768 8.96579C30.2782 8.76443 30.0309 8.6899 29.8344 8.7978L27.356 10.1585C27.1656 10.263 27.0941 10.5001 27.1877 10.6961C27.898 12.183 28.2777 13.7643 28.3586 15.3441C28.3696 15.5599 28.5442 15.7335 28.7603 15.7357L31.5897 15.7649Z",
    fill: "#26D4DD"
  })), _path9$9 || (_path9$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.1243 21.4584C27.0306 21.6519 27.0989 21.8869 27.2856 21.9936L29.7359 23.3938C29.9313 23.5054 30.1808 23.4341 30.2821 23.2332C31.2844 21.2447 31.8599 19.0682 31.9824 16.8622C31.9948 16.6386 31.8159 16.4527 31.5919 16.4504L28.773 16.4212C28.5568 16.419 28.3785 16.5892 28.3633 16.8049C28.2498 18.4144 27.8314 19.9975 27.1243 21.4584Z",
    fill: "#26D4DD"
  })), _path10$9 || (_path10$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.2642 29.2307C24.3775 29.4235 24.6268 29.4858 24.8139 29.3635C24.9238 29.2917 25.0337 29.2184 25.1436 29.1452C26.9577 27.8811 28.4312 26.3093 29.5434 24.5434C29.6626 24.3541 29.5967 24.1052 29.4025 23.9943L26.9537 22.5949C26.7651 22.4872 26.5255 22.55 26.4075 22.7323C25.5579 24.0452 24.4435 25.2233 23.0742 26.1783C23.0403 26.2009 23.0071 26.2235 22.9742 26.2459C22.7912 26.3708 22.7291 26.6201 22.8414 26.811L24.2642 29.2307Z",
    fill: "#DDDDDD"
  })), _path11$9 || (_path11$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.2495 27.138C22.1394 26.9507 21.9001 26.8862 21.7072 26.9861C20.1788 27.7777 18.5455 28.2324 16.9045 28.3503C16.6887 28.3658 16.5184 28.544 16.5206 28.7603L16.5498 31.5771C16.5521 31.8018 16.7391 31.981 16.9634 31.9676C19.2143 31.8326 21.4472 31.2265 23.5281 30.1137C23.725 30.0084 23.7912 29.76 23.678 29.5675L22.2495 27.138Z",
    fill: "#DDDDDD"
  })), _path12$8 || (_path12$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.14984 26.786C9.26093 26.6003 9.20388 26.3605 9.02522 26.2385C7.81073 25.409 6.72854 24.3575 5.8464 23.0744C5.73463 22.9104 5.62732 22.7465 5.52445 22.5826C5.40965 22.3996 5.17245 22.3342 4.98312 22.4381L2.50318 23.7997C2.30624 23.9078 2.23658 24.1571 2.35478 24.3482C2.52083 24.6166 2.69716 24.8832 2.87953 25.1437C4.0681 26.845 5.51809 28.2413 7.14804 29.3326C7.33495 29.4578 7.58713 29.3975 7.70263 29.2045L9.14984 26.786Z",
    fill: "#DDDDDD"
  })), _path13$8 || (_path13$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.277 26.9752C10.0852 26.8746 9.84629 26.9368 9.7345 27.1224L8.27724 29.5414C8.16116 29.7341 8.22657 29.9851 8.42495 30.0912C10.6063 31.2575 13.0195 31.9059 15.4737 31.9909C15.6976 31.9986 15.8796 31.8159 15.8773 31.5919L15.8482 28.7758C15.8459 28.5584 15.6704 28.3833 15.4532 28.3736C13.6575 28.294 11.8821 27.8167 10.277 26.9752Z",
    fill: "#DDDDDD"
  })));
};

var _path$y, _path2$c, _path3$a, _path4$9, _path5$9, _path6$9, _path7$9, _path8$8, _path9$8, _path10$8, _path11$8, _path12$7, _path13$7;
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
var SvgA22 = function SvgA22(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$H({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$y || (_path$y = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.9198 21.16C14.9918 21.16 14.2078 20.968 13.5678 20.584C12.9384 20.2 12.4211 19.6133 12.0158 18.824L13.9998 17.832C14.1384 18.3013 14.3571 18.68 14.6558 18.968C14.9544 19.256 15.3918 19.4 15.9678 19.4C16.3624 19.4 16.6984 19.3307 16.9758 19.192C17.2531 19.0533 17.4664 18.8507 17.6158 18.584C17.7758 18.3173 17.8558 17.992 17.8558 17.608C17.8558 17.224 17.7811 16.904 17.6318 16.648C17.4931 16.3813 17.2904 16.184 17.0238 16.056C16.7571 15.9173 16.4211 15.848 16.0158 15.848C15.7384 15.848 15.4771 15.8747 15.2318 15.928C14.9971 15.9813 14.7838 16.0667 14.5918 16.184C14.3998 16.2907 14.2291 16.4347 14.0798 16.616L12.3518 16.296L13.0078 10.44H19.3918V12.216H14.6718L14.3518 14.792L14.3038 15H14.3358C14.5598 14.744 14.8638 14.5467 15.2478 14.408C15.6424 14.2693 16.0904 14.2 16.5918 14.2C17.2851 14.2 17.8771 14.3387 18.3678 14.616C18.8584 14.8933 19.2371 15.2827 19.5038 15.784C19.7704 16.2747 19.9038 16.84 19.9038 17.48C19.9038 18.088 19.8024 18.6267 19.5998 19.096C19.3971 19.5547 19.1091 19.9387 18.7358 20.248C18.3731 20.5467 17.9518 20.776 17.4718 20.936C16.9918 21.0853 16.4744 21.16 15.9198 21.16Z",
    fill: "black"
  })), _path2$c || (_path2$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.82565 4.82543C9.93536 5.01201 10.1733 5.07685 10.3661 4.97837C11.8938 4.19778 13.5265 3.75378 15.1669 3.64638C15.3838 3.63218 15.5557 3.4535 15.5535 3.23611L15.5243 0.419923C15.522 0.19597 15.3362 0.0170491 15.1126 0.0294023C12.8713 0.153217 10.6297 0.747754 8.54829 1.84868C8.35033 1.95339 8.28339 2.20252 8.39691 2.39558L9.82565 4.82543Z",
    fill: "#DDDDDD"
  })), _path3$a || (_path3$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.1331 6.86848C27.957 5.18012 26.5091 3.78542 24.9011 2.70468C24.7146 2.57935 24.4626 2.63901 24.3467 2.83147L22.8898 5.24996C22.7777 5.436 22.8349 5.67689 23.0144 5.79927C24.2154 6.61855 25.2853 7.66794 26.1662 8.93782C26.278 9.10175 26.3853 9.26568 26.4881 9.4296C26.6029 9.61256 26.8402 9.678 27.0295 9.57405L29.5094 8.21251C29.7064 8.10439 29.776 7.85507 29.6578 7.66401C29.4918 7.39559 29.3154 7.12901 29.1331 6.86848Z",
    fill: "#26D4DD"
  })), _path4$9 || (_path4$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.2278 3.23747C16.2293 3.45448 16.4036 3.63002 16.6204 3.64079C18.4137 3.72988 20.17 4.20775 21.7727 5.04941C21.9645 5.15012 22.2034 5.08789 22.3152 4.90233L23.7738 2.4811C23.8893 2.28923 23.825 2.03938 23.6281 1.9326C21.4583 0.755933 19.0565 0.106231 16.6138 0.0107818C16.3898 0.00203011 16.2068 0.184191 16.2084 0.40833L16.2278 3.23747Z",
    fill: "#26D4DD"
  })), _path5$9 || (_path5$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.2405 15.5417C3.45629 15.5432 3.63369 15.3732 3.64874 15.1579C3.76194 13.5387 4.18141 11.9543 4.90716 10.4928C5.0036 10.2986 4.93599 10.0609 4.74772 9.9533L2.29976 8.55447C2.10494 8.44314 1.8562 8.51361 1.75433 8.71354C0.740423 10.7035 0.153364 12.891 0.0195852 15.1085C0.006017 15.3334 0.186083 15.5207 0.411396 15.5223L3.2405 15.5417Z",
    fill: "#DDDDDD"
  })), _path6$9 || (_path6$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408249 16.1974C0.184143 16.1951 0.00135428 16.3773 0.0094224 16.6013C0.0883039 18.7911 0.623374 20.9819 1.62346 23.0327C1.72189 23.2345 1.96959 23.3095 2.16643 23.2014L4.64502 21.8406C4.835 21.7363 4.9067 21.4999 4.81364 21.3042C4.10108 19.8056 3.71225 18.2126 3.63916 16.6209C3.6292 16.404 3.45419 16.2288 3.237 16.2265L0.408249 16.1974Z",
    fill: "#DDDDDD"
  })), _path7$9 || (_path7$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.09777 9.36899C5.2858 9.47601 5.52425 9.41375 5.64247 9.23256C6.49032 7.93309 7.59218 6.7782 8.93826 5.84629C9.00041 5.80326 9.0644 5.76023 9.12881 5.71721C9.30297 5.60087 9.35478 5.37007 9.24862 5.18952L7.80897 2.74112C7.69629 2.5495 7.44839 2.48564 7.26224 2.60715C7.1288 2.69426 6.99704 2.78501 6.86893 2.87941C5.06937 4.12976 3.60938 5.68682 2.49923 7.41711C2.37757 7.60671 2.44317 7.85806 2.63895 7.9695L5.09777 9.36899Z",
    fill: "#DDDDDD"
  })), _path8$8 || (_path8$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.5897 15.7649C31.8146 15.7672 31.9977 15.5836 31.9886 15.3589C31.9005 13.1819 31.375 11.0039 30.3768 8.96579C30.2782 8.76444 30.0309 8.6899 29.8344 8.7978L27.356 10.1585C27.1656 10.263 27.0941 10.5001 27.1877 10.6961C27.898 12.183 28.2777 13.7643 28.3586 15.3441C28.3696 15.5599 28.5442 15.7335 28.7603 15.7357L31.5897 15.7649Z",
    fill: "#26D4DD"
  })), _path9$8 || (_path9$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.1243 21.4584C27.0306 21.6519 27.0989 21.8869 27.2856 21.9936L29.7359 23.3938C29.9313 23.5054 30.1808 23.4341 30.2821 23.2332C31.2844 21.2447 31.8599 19.0682 31.9824 16.8622C31.9948 16.6386 31.8159 16.4527 31.5919 16.4504L28.773 16.4212C28.5568 16.419 28.3785 16.5892 28.3633 16.8049C28.2498 18.4144 27.8314 19.9975 27.1243 21.4584Z",
    fill: "#26D4DD"
  })), _path10$8 || (_path10$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.2642 29.2307C24.3775 29.4235 24.6268 29.4858 24.8139 29.3635C24.9238 29.2917 25.0337 29.2184 25.1436 29.1452C26.9577 27.8811 28.4312 26.3093 29.5434 24.5434C29.6626 24.3541 29.5967 24.1052 29.4025 23.9943L26.9537 22.5949C26.7651 22.4872 26.5255 22.55 26.4075 22.7323C25.5579 24.0452 24.4435 25.2233 23.0742 26.1783C23.0403 26.2009 23.0071 26.2235 22.9742 26.2459C22.7912 26.3708 22.7291 26.6201 22.8414 26.811L24.2642 29.2307Z",
    fill: "#26D4DD"
  })), _path11$8 || (_path11$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.2495 27.138C22.1394 26.9507 21.9001 26.8862 21.7072 26.9861C20.1788 27.7777 18.5455 28.2324 16.9045 28.3503C16.6887 28.3658 16.5184 28.544 16.5206 28.7603L16.5498 31.5771C16.5521 31.8018 16.7391 31.981 16.9634 31.9676C19.2143 31.8326 21.4472 31.2265 23.5281 30.1137C23.725 30.0084 23.7912 29.76 23.678 29.5675L22.2495 27.138Z",
    fill: "#DDDDDD"
  })), _path12$7 || (_path12$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.14984 26.786C9.26093 26.6003 9.20388 26.3605 9.02522 26.2385C7.81073 25.409 6.72854 24.3575 5.8464 23.0744C5.73463 22.9104 5.62732 22.7465 5.52445 22.5826C5.40965 22.3996 5.17245 22.3342 4.98312 22.4381L2.50318 23.7997C2.30624 23.9078 2.23658 24.1571 2.35478 24.3482C2.52083 24.6166 2.69716 24.8832 2.87953 25.1437C4.0681 26.845 5.51809 28.2413 7.14804 29.3326C7.33495 29.4578 7.58713 29.3975 7.70263 29.2045L9.14984 26.786Z",
    fill: "#DDDDDD"
  })), _path13$7 || (_path13$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.277 26.9752C10.0852 26.8746 9.84629 26.9368 9.7345 27.1224L8.27724 29.5414C8.16116 29.7341 8.22657 29.9851 8.42495 30.0912C10.6063 31.2575 13.0195 31.9059 15.4737 31.9909C15.6976 31.9986 15.8796 31.8159 15.8773 31.5919L15.8482 28.7758C15.8459 28.5584 15.6704 28.3833 15.4532 28.3736C13.6575 28.294 11.8821 27.8167 10.277 26.9752Z",
    fill: "#DDDDDD"
  })));
};

var _path$x, _path2$b, _path3$9, _path4$8, _path5$8, _path6$8, _path7$8, _path8$7, _path9$7, _path10$7, _path11$7, _path12$6, _path13$6;
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var SvgA23 = function SvgA23(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$G({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$x || (_path$x = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.4538 10.28C17.0191 10.28 17.5311 10.36 17.9898 10.52C18.4484 10.6693 18.8484 10.9147 19.1898 11.256C19.5418 11.5867 19.8138 12.0293 20.0058 12.584L18.1498 13.448C18.0218 13.032 17.8084 12.7067 17.5098 12.472C17.2218 12.2267 16.8218 12.104 16.3098 12.104C15.9471 12.104 15.6218 12.1947 15.3338 12.376C15.0564 12.5467 14.8164 12.792 14.6138 13.112C14.4111 13.4213 14.2564 13.8 14.1498 14.248C14.0431 14.6853 13.9898 15.1707 13.9898 15.704C13.9898 15.736 13.9898 15.7733 13.9898 15.816C13.9898 15.848 13.9898 15.9013 13.9898 15.976L14.0378 16.04C14.1551 15.6667 14.3578 15.3573 14.6458 15.112C14.9444 14.8667 15.2751 14.6853 15.6378 14.568C16.0111 14.4507 16.3791 14.392 16.7418 14.392C17.4138 14.392 18.0058 14.5253 18.5178 14.792C19.0404 15.048 19.4458 15.4213 19.7338 15.912C20.0324 16.4027 20.1818 16.9893 20.1818 17.672C20.1818 18.376 20.0218 18.9947 19.7018 19.528C19.3924 20.0507 18.9498 20.456 18.3738 20.744C17.8084 21.0213 17.1311 21.16 16.3418 21.16C15.4458 21.16 14.6671 20.9467 14.0058 20.52C13.3551 20.0933 12.8484 19.48 12.4858 18.68C12.1338 17.88 11.9578 16.9147 11.9578 15.784C11.9578 14.5573 12.1551 13.5387 12.5498 12.728C12.9444 11.9067 13.4831 11.2933 14.1658 10.888C14.8484 10.4827 15.6111 10.28 16.4538 10.28ZM16.3098 16.008C15.9578 16.008 15.6484 16.0827 15.3818 16.232C15.1151 16.3707 14.9018 16.568 14.7418 16.824C14.5818 17.0693 14.5018 17.3573 14.5018 17.688C14.5018 18.0187 14.5818 18.312 14.7418 18.568C14.9124 18.824 15.1311 19.0267 15.3978 19.176C15.6751 19.3253 15.9791 19.4 16.3098 19.4C16.8751 19.4 17.3124 19.2507 17.6218 18.952C17.9418 18.6533 18.1018 18.232 18.1018 17.688C18.1018 17.3467 18.0324 17.048 17.8938 16.792C17.7551 16.536 17.5524 16.344 17.2858 16.216C17.0191 16.0773 16.6938 16.008 16.3098 16.008Z",
    fill: "black"
  })), _path2$b || (_path2$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.82565 4.82543C9.93536 5.01201 10.1733 5.07685 10.3661 4.97837C11.8938 4.19778 13.5265 3.75378 15.1669 3.64638C15.3838 3.63218 15.5557 3.4535 15.5535 3.23611L15.5243 0.419923C15.522 0.19597 15.3362 0.0170491 15.1126 0.0294023C12.8713 0.153217 10.6297 0.747754 8.54829 1.84868C8.35033 1.95339 8.28339 2.20252 8.39691 2.39558L9.82565 4.82543Z",
    fill: "#DDDDDD"
  })), _path3$9 || (_path3$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.1331 6.86848C27.957 5.18012 26.5091 3.78542 24.9011 2.70468C24.7146 2.57935 24.4626 2.63901 24.3467 2.83147L22.8898 5.24996C22.7777 5.436 22.8349 5.67689 23.0144 5.79927C24.2154 6.61855 25.2853 7.66794 26.1662 8.93782C26.278 9.10175 26.3853 9.26568 26.4881 9.4296C26.6029 9.61256 26.8402 9.678 27.0295 9.57405L29.5094 8.21251C29.7064 8.10439 29.776 7.85507 29.6578 7.66401C29.4918 7.39559 29.3154 7.12901 29.1331 6.86848Z",
    fill: "#26D4DD"
  })), _path4$8 || (_path4$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.2278 3.23747C16.2293 3.45448 16.4036 3.63002 16.6204 3.64079C18.4137 3.72988 20.17 4.20775 21.7727 5.04941C21.9645 5.15012 22.2034 5.08789 22.3152 4.90233L23.7738 2.4811C23.8893 2.28923 23.825 2.03938 23.6281 1.9326C21.4583 0.755933 19.0565 0.106231 16.6138 0.0107818C16.3898 0.00203011 16.2068 0.184191 16.2084 0.40833L16.2278 3.23747Z",
    fill: "#26D4DD"
  })), _path5$8 || (_path5$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.2405 15.5417C3.45629 15.5432 3.63369 15.3732 3.64874 15.1579C3.76194 13.5387 4.18141 11.9543 4.90716 10.4928C5.0036 10.2986 4.93599 10.0609 4.74772 9.9533L2.29976 8.55447C2.10494 8.44314 1.8562 8.51362 1.75433 8.71355C0.740423 10.7035 0.153364 12.891 0.0195852 15.1085C0.006017 15.3334 0.186083 15.5207 0.411396 15.5223L3.2405 15.5417Z",
    fill: "#DDDDDD"
  })), _path6$8 || (_path6$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408249 16.1974C0.184143 16.1951 0.00135428 16.3773 0.0094224 16.6013C0.0883039 18.7911 0.623374 20.982 1.62346 23.0327C1.72189 23.2345 1.96959 23.3095 2.16643 23.2014L4.64502 21.8406C4.835 21.7363 4.9067 21.4999 4.81364 21.3042C4.10108 19.8056 3.71225 18.2126 3.63916 16.6209C3.6292 16.404 3.45419 16.2288 3.237 16.2265L0.408249 16.1974Z",
    fill: "#DDDDDD"
  })), _path7$8 || (_path7$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.09777 9.36899C5.2858 9.47601 5.52425 9.41375 5.64247 9.23256C6.49032 7.93309 7.59218 6.7782 8.93826 5.84629C9.00041 5.80326 9.0644 5.76023 9.12881 5.71721C9.30297 5.60087 9.35478 5.37007 9.24862 5.18952L7.80897 2.74112C7.69629 2.5495 7.44839 2.48564 7.26224 2.60715C7.1288 2.69426 6.99704 2.78501 6.86893 2.87941C5.06937 4.12976 3.60938 5.68682 2.49923 7.41711C2.37757 7.60671 2.44317 7.85806 2.63895 7.9695L5.09777 9.36899Z",
    fill: "#DDDDDD"
  })), _path8$7 || (_path8$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.5897 15.7649C31.8146 15.7672 31.9977 15.5836 31.9886 15.3589C31.9005 13.1819 31.375 11.0039 30.3768 8.96579C30.2782 8.76444 30.0309 8.6899 29.8344 8.7978L27.356 10.1585C27.1656 10.263 27.0941 10.5001 27.1877 10.6961C27.898 12.183 28.2777 13.7643 28.3586 15.3441C28.3696 15.5599 28.5442 15.7335 28.7603 15.7357L31.5897 15.7649Z",
    fill: "#26D4DD"
  })), _path9$7 || (_path9$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.1243 21.4584C27.0306 21.6519 27.0989 21.8869 27.2856 21.9936L29.7359 23.3938C29.9313 23.5054 30.1808 23.4341 30.2821 23.2332C31.2844 21.2447 31.8599 19.0682 31.9824 16.8622C31.9948 16.6386 31.8159 16.4527 31.5919 16.4504L28.773 16.4212C28.5568 16.419 28.3785 16.5892 28.3633 16.8049C28.2498 18.4144 27.8314 19.9975 27.1243 21.4584Z",
    fill: "#26D4DD"
  })), _path10$7 || (_path10$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.2642 29.2307C24.3775 29.4235 24.6268 29.4858 24.8139 29.3635C24.9238 29.2917 25.0337 29.2184 25.1436 29.1452C26.9577 27.8811 28.4312 26.3093 29.5434 24.5434C29.6626 24.3541 29.5967 24.1052 29.4025 23.9943L26.9537 22.5949C26.7651 22.4872 26.5255 22.55 26.4075 22.7323C25.5579 24.0452 24.4435 25.2233 23.0742 26.1783C23.0403 26.2009 23.0071 26.2235 22.9742 26.2459C22.7912 26.3708 22.7291 26.6201 22.8414 26.811L24.2642 29.2307Z",
    fill: "#26D4DD"
  })), _path11$7 || (_path11$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.2495 27.138C22.1394 26.9507 21.9001 26.8862 21.7072 26.9861C20.1788 27.7777 18.5455 28.2324 16.9045 28.3503C16.6887 28.3658 16.5184 28.544 16.5206 28.7603L16.5498 31.5771C16.5521 31.8018 16.7391 31.981 16.9634 31.9676C19.2143 31.8326 21.4472 31.2265 23.5281 30.1137C23.725 30.0084 23.7912 29.76 23.678 29.5675L22.2495 27.138Z",
    fill: "#26D4DD"
  })), _path12$6 || (_path12$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.14984 26.786C9.26093 26.6003 9.20388 26.3605 9.02522 26.2385C7.81073 25.409 6.72854 24.3575 5.8464 23.0744C5.73463 22.9104 5.62732 22.7465 5.52445 22.5826C5.40965 22.3996 5.17245 22.3342 4.98312 22.4381L2.50318 23.7997C2.30624 23.9078 2.23658 24.1571 2.35478 24.3482C2.52083 24.6166 2.69716 24.8832 2.87953 25.1437C4.0681 26.845 5.51809 28.2413 7.14804 29.3326C7.33495 29.4578 7.58713 29.3975 7.70263 29.2045L9.14984 26.786Z",
    fill: "#DDDDDD"
  })), _path13$6 || (_path13$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.277 26.9752C10.0852 26.8746 9.84629 26.9368 9.7345 27.1224L8.27724 29.5414C8.16116 29.7341 8.22657 29.9851 8.42495 30.0912C10.6063 31.2575 13.0195 31.9059 15.4737 31.9909C15.6976 31.9986 15.8796 31.8159 15.8773 31.5919L15.8482 28.7758C15.8459 28.5584 15.6704 28.3833 15.4532 28.3736C13.6575 28.294 11.8821 27.8167 10.277 26.9752Z",
    fill: "#DDDDDD"
  })));
};

var _path$w, _path2$a, _path3$8, _path4$7, _path5$7, _path6$7, _path7$7, _path8$6, _path9$6, _path10$6, _path11$6, _path12$5, _path13$5;
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
var SvgB11 = function SvgB11(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$F({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$w || (_path$w = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.82565 4.82543C9.93536 5.01201 10.1733 5.07685 10.3661 4.97837C11.8938 4.19778 13.5265 3.75378 15.1669 3.64638C15.3838 3.63218 15.5557 3.4535 15.5535 3.23611L15.5243 0.419923C15.522 0.19597 15.3362 0.0170491 15.1126 0.0294023C12.8713 0.153217 10.6297 0.747754 8.54829 1.84868C8.35033 1.95339 8.28339 2.20252 8.39691 2.39558L9.82565 4.82543Z",
    fill: "#DDDDDD"
  })), _path2$a || (_path2$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.1331 6.86848C27.957 5.18012 26.5091 3.78542 24.9011 2.70468C24.7146 2.57935 24.4626 2.63901 24.3467 2.83147L22.8898 5.24996C22.7777 5.436 22.8349 5.67689 23.0144 5.79927C24.2154 6.61855 25.2853 7.66794 26.1662 8.93782C26.278 9.10175 26.3853 9.26568 26.4881 9.4296C26.6029 9.61256 26.8402 9.678 27.0295 9.57405L29.5094 8.21251C29.7064 8.10439 29.776 7.85507 29.6578 7.66401C29.4918 7.39559 29.3154 7.12901 29.1331 6.86848Z",
    fill: "#26D4DD"
  })), _path3$8 || (_path3$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.2278 3.23747C16.2293 3.45448 16.4036 3.63002 16.6204 3.64079C18.4137 3.72988 20.17 4.20775 21.7727 5.04941C21.9645 5.15012 22.2034 5.08789 22.3152 4.90233L23.7738 2.4811C23.8893 2.28923 23.825 2.03938 23.6281 1.9326C21.4583 0.755933 19.0565 0.106231 16.6138 0.0107818C16.3898 0.00203011 16.2068 0.184191 16.2084 0.40833L16.2278 3.23747Z",
    fill: "#26D4DD"
  })), _path4$7 || (_path4$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.2405 15.5417C3.45629 15.5432 3.63369 15.3732 3.64874 15.1579C3.76194 13.5387 4.18141 11.9543 4.90716 10.4928C5.0036 10.2986 4.93599 10.0609 4.74772 9.9533L2.29976 8.55447C2.10494 8.44314 1.8562 8.51362 1.75433 8.71355C0.740423 10.7035 0.153364 12.891 0.0195852 15.1085C0.006017 15.3334 0.186083 15.5207 0.411396 15.5223L3.2405 15.5417Z",
    fill: "#DDDDDD"
  })), _path5$7 || (_path5$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408249 16.1974C0.184143 16.1951 0.00135428 16.3773 0.0094224 16.6013C0.0883039 18.7911 0.623374 20.982 1.62346 23.0327C1.72189 23.2345 1.96959 23.3095 2.16643 23.2014L4.64502 21.8406C4.835 21.7363 4.9067 21.4999 4.81364 21.3042C4.10108 19.8056 3.71225 18.2126 3.63916 16.6209C3.6292 16.404 3.45419 16.2288 3.237 16.2265L0.408249 16.1974Z",
    fill: "#DDDDDD"
  })), _path6$7 || (_path6$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.09777 9.36899C5.2858 9.47601 5.52425 9.41375 5.64247 9.23256C6.49032 7.93309 7.59218 6.7782 8.93826 5.84629C9.00041 5.80326 9.0644 5.76023 9.12881 5.71721C9.30297 5.60087 9.35478 5.37007 9.24862 5.18952L7.80897 2.74112C7.69629 2.5495 7.44839 2.48564 7.26224 2.60715C7.1288 2.69426 6.99704 2.78501 6.86893 2.87941C5.06937 4.12976 3.60938 5.68682 2.49923 7.41711C2.37757 7.60671 2.44317 7.85806 2.63895 7.9695L5.09777 9.36899Z",
    fill: "#DDDDDD"
  })), _path7$7 || (_path7$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.5897 15.7649C31.8146 15.7672 31.9977 15.5836 31.9886 15.3589C31.9005 13.1819 31.375 11.0039 30.3768 8.96579C30.2782 8.76444 30.0309 8.6899 29.8344 8.7978L27.356 10.1585C27.1656 10.263 27.0941 10.5001 27.1877 10.6961C27.898 12.183 28.2777 13.7643 28.3586 15.3441C28.3696 15.5599 28.5442 15.7335 28.7603 15.7357L31.5897 15.7649Z",
    fill: "#26D4DD"
  })), _path8$6 || (_path8$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.1243 21.4584C27.0306 21.6519 27.0989 21.8869 27.2856 21.9936L29.7359 23.3938C29.9313 23.5054 30.1808 23.4341 30.2821 23.2332C31.2844 21.2447 31.8599 19.0682 31.9824 16.8622C31.9948 16.6386 31.8159 16.4527 31.5919 16.4504L28.773 16.4212C28.5568 16.419 28.3785 16.5892 28.3633 16.8049C28.2498 18.4144 27.8314 19.9975 27.1243 21.4584Z",
    fill: "#26D4DD"
  })), _path9$6 || (_path9$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.2642 29.2307C24.3775 29.4235 24.6268 29.4857 24.8139 29.3635C24.9238 29.2917 25.0337 29.2184 25.1436 29.1452C26.9577 27.8811 28.4312 26.3093 29.5434 24.5433C29.6626 24.3541 29.5967 24.1052 29.4025 23.9943L26.9537 22.5949C26.7651 22.4871 26.5255 22.5499 26.4075 22.7323C25.5579 24.0452 24.4435 25.2232 23.0742 26.1783C23.0403 26.2009 23.0071 26.2235 22.9742 26.2459C22.7912 26.3708 22.7291 26.6201 22.8414 26.811L24.2642 29.2307Z",
    fill: "#26D4DD"
  })), _path10$6 || (_path10$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.2495 27.138C22.1394 26.9507 21.9001 26.8862 21.7072 26.9861C20.1788 27.7777 18.5455 28.2324 16.9045 28.3503C16.6887 28.3658 16.5184 28.544 16.5206 28.7603L16.5498 31.5771C16.5521 31.8018 16.7391 31.981 16.9634 31.9676C19.2143 31.8326 21.4472 31.2265 23.5281 30.1137C23.725 30.0084 23.7912 29.76 23.678 29.5675L22.2495 27.138Z",
    fill: "#26D4DD"
  })), _path11$6 || (_path11$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.14984 26.786C9.26093 26.6003 9.20388 26.3605 9.02522 26.2385C7.81073 25.409 6.72854 24.3575 5.8464 23.0744C5.73463 22.9104 5.62732 22.7465 5.52445 22.5826C5.40965 22.3996 5.17245 22.3342 4.98312 22.4381L2.50318 23.7997C2.30624 23.9078 2.23658 24.1571 2.35478 24.3482C2.52083 24.6166 2.69716 24.8832 2.87953 25.1437C4.0681 26.845 5.51809 28.2413 7.14804 29.3326C7.33495 29.4578 7.58713 29.3975 7.70263 29.2045L9.14984 26.786Z",
    fill: "#DDDDDD"
  })), _path12$5 || (_path12$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.277 26.9752C10.0852 26.8746 9.84629 26.9368 9.7345 27.1224L8.27724 29.5414C8.16116 29.7341 8.22657 29.9851 8.42495 30.0912C10.6063 31.2575 13.0195 31.9059 15.4737 31.9909C15.6976 31.9986 15.8796 31.8159 15.8773 31.5919L15.8482 28.7758C15.8459 28.5584 15.6704 28.3833 15.4532 28.3736C13.6575 28.294 11.8821 27.8167 10.277 26.9752Z",
    fill: "#26D4DD"
  })), _path13$5 || (_path13$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.8334 10.44H20.2014V12.12C19.3161 13.0053 18.6121 13.9173 18.0894 14.856C17.5668 15.7947 17.1881 16.7707 16.9534 17.784C16.7294 18.7973 16.6174 19.8693 16.6174 21H14.4254C14.4254 19.8267 14.5694 18.7013 14.8574 17.624C15.1561 16.536 15.6094 15.5013 16.2174 14.52C16.8361 13.528 17.6201 12.5787 18.5694 11.672L19.0174 12.248H11.8334V10.44Z",
    fill: "black"
  })));
};

var _path$v, _path2$9, _path3$7, _path4$6, _path5$6, _path6$6, _path7$6, _path8$5, _path9$5, _path10$5, _path11$5, _path12$4, _path13$4;
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
var SvgB12 = function SvgB12(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$E({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$v || (_path$v = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.82565 4.82543C9.93536 5.01201 10.1733 5.07685 10.3661 4.97837C11.8938 4.19778 13.5265 3.75378 15.1669 3.64638C15.3838 3.63218 15.5557 3.4535 15.5535 3.23611L15.5243 0.419923C15.522 0.19597 15.3362 0.0170491 15.1126 0.0294023C12.8713 0.153217 10.6297 0.747754 8.54829 1.84868C8.35033 1.95339 8.28339 2.20252 8.39691 2.39558L9.82565 4.82543Z",
    fill: "#DDDDDD"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.1331 6.86848C27.957 5.18012 26.5091 3.78542 24.9011 2.70468C24.7146 2.57935 24.4626 2.63901 24.3467 2.83147L22.8898 5.24996C22.7777 5.436 22.8349 5.67689 23.0144 5.79927C24.2154 6.61855 25.2853 7.66794 26.1662 8.93782C26.278 9.10175 26.3853 9.26568 26.4881 9.4296C26.6029 9.61256 26.8402 9.678 27.0295 9.57405L29.5094 8.21251C29.7064 8.10439 29.776 7.85507 29.6578 7.66401C29.4918 7.39559 29.3154 7.12901 29.1331 6.86848Z",
    fill: "#26D4DD"
  })), _path3$7 || (_path3$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.2278 3.23747C16.2293 3.45448 16.4036 3.63002 16.6204 3.64079C18.4137 3.72988 20.17 4.20775 21.7727 5.04941C21.9645 5.15012 22.2034 5.08789 22.3152 4.90233L23.7738 2.4811C23.8893 2.28923 23.825 2.03938 23.6281 1.9326C21.4583 0.755933 19.0565 0.106231 16.6138 0.0107818C16.3898 0.00203011 16.2068 0.184191 16.2084 0.40833L16.2278 3.23747Z",
    fill: "#26D4DD"
  })), _path4$6 || (_path4$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.2405 15.5417C3.45629 15.5432 3.63369 15.3732 3.64874 15.1579C3.76194 13.5387 4.18141 11.9543 4.90716 10.4928C5.0036 10.2986 4.93599 10.0609 4.74772 9.9533L2.29976 8.55447C2.10494 8.44314 1.8562 8.51362 1.75433 8.71355C0.740423 10.7035 0.153364 12.891 0.0195852 15.1085C0.006017 15.3334 0.186083 15.5207 0.411396 15.5223L3.2405 15.5417Z",
    fill: "#DDDDDD"
  })), _path5$6 || (_path5$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408249 16.1974C0.184143 16.1951 0.00135428 16.3773 0.0094224 16.6013C0.0883039 18.7911 0.623374 20.982 1.62346 23.0327C1.72189 23.2345 1.96959 23.3095 2.16643 23.2014L4.64502 21.8406C4.835 21.7363 4.9067 21.4999 4.81364 21.3042C4.10108 19.8056 3.71225 18.2126 3.63916 16.6209C3.6292 16.404 3.45419 16.2288 3.237 16.2265L0.408249 16.1974Z",
    fill: "#DDDDDD"
  })), _path6$6 || (_path6$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.09777 9.369C5.2858 9.47602 5.52425 9.41376 5.64247 9.23257C6.49032 7.9331 7.59218 6.7782 8.93826 5.8463C9.00041 5.80327 9.0644 5.76024 9.12881 5.71721C9.30297 5.60088 9.35478 5.37007 9.24862 5.18953L7.80897 2.74113C7.69629 2.5495 7.44839 2.48565 7.26224 2.60716C7.1288 2.69427 6.99704 2.78502 6.86893 2.87942C5.06937 4.12976 3.60938 5.68683 2.49923 7.41711C2.37757 7.60672 2.44317 7.85807 2.63895 7.9695L5.09777 9.369Z",
    fill: "#DDDDDD"
  })), _path7$6 || (_path7$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.5897 15.7649C31.8146 15.7672 31.9977 15.5836 31.9886 15.3589C31.9005 13.1819 31.375 11.0039 30.3768 8.96579C30.2782 8.76444 30.0309 8.6899 29.8344 8.7978L27.356 10.1585C27.1656 10.263 27.0941 10.5001 27.1877 10.6961C27.898 12.183 28.2777 13.7643 28.3586 15.3441C28.3696 15.5599 28.5442 15.7335 28.7603 15.7357L31.5897 15.7649Z",
    fill: "#26D4DD"
  })), _path8$5 || (_path8$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.1243 21.4584C27.0306 21.6519 27.0989 21.8869 27.2856 21.9936L29.7359 23.3938C29.9313 23.5054 30.1808 23.4341 30.2821 23.2332C31.2844 21.2447 31.8599 19.0682 31.9824 16.8622C31.9948 16.6386 31.8159 16.4527 31.5919 16.4504L28.773 16.4212C28.5568 16.419 28.3785 16.5892 28.3633 16.8049C28.2498 18.4144 27.8314 19.9975 27.1243 21.4584Z",
    fill: "#26D4DD"
  })), _path9$5 || (_path9$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.2642 29.2307C24.3775 29.4235 24.6268 29.4857 24.8139 29.3635C24.9238 29.2917 25.0337 29.2184 25.1436 29.1452C26.9577 27.8811 28.4312 26.3093 29.5434 24.5433C29.6626 24.3541 29.5967 24.1052 29.4025 23.9943L26.9537 22.5949C26.7651 22.4871 26.5255 22.5499 26.4075 22.7323C25.5579 24.0452 24.4435 25.2232 23.0742 26.1783C23.0403 26.2009 23.0071 26.2235 22.9742 26.2459C22.7912 26.3708 22.7291 26.6201 22.8414 26.811L24.2642 29.2307Z",
    fill: "#26D4DD"
  })), _path10$5 || (_path10$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.2495 27.138C22.1394 26.9507 21.9001 26.8862 21.7072 26.9861C20.1788 27.7777 18.5455 28.2324 16.9045 28.3503C16.6887 28.3658 16.5184 28.544 16.5206 28.7603L16.5498 31.5771C16.5521 31.8018 16.7391 31.981 16.9634 31.9676C19.2143 31.8326 21.4472 31.2265 23.5281 30.1137C23.725 30.0084 23.7912 29.76 23.678 29.5675L22.2495 27.138Z",
    fill: "#26D4DD"
  })), _path11$5 || (_path11$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.14984 26.786C9.26093 26.6003 9.20388 26.3605 9.02522 26.2385C7.81073 25.409 6.72854 24.3575 5.8464 23.0744C5.73463 22.9104 5.62732 22.7465 5.52445 22.5826C5.40965 22.3996 5.17245 22.3342 4.98312 22.4381L2.50318 23.7997C2.30624 23.9078 2.23658 24.1571 2.35478 24.3482C2.52083 24.6166 2.69716 24.8832 2.87953 25.1437C4.0681 26.845 5.51809 28.2413 7.14804 29.3326C7.33495 29.4578 7.58713 29.3975 7.70263 29.2045L9.14984 26.786Z",
    fill: "#26D4DD"
  })), _path12$4 || (_path12$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.277 26.9752C10.0852 26.8746 9.84629 26.9368 9.7345 27.1224L8.27724 29.5414C8.16116 29.7341 8.22657 29.9851 8.42495 30.0912C10.6063 31.2575 13.0195 31.9059 15.4737 31.9909C15.6976 31.9986 15.8796 31.8159 15.8773 31.5919L15.8482 28.7758C15.8459 28.5584 15.6704 28.3833 15.4532 28.3736C13.6575 28.294 11.8821 27.8167 10.277 26.9752Z",
    fill: "#26D4DD"
  })), _path13$4 || (_path13$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.9916 10.312C16.749 10.312 17.405 10.4293 17.9596 10.664C18.525 10.888 18.957 11.2133 19.2556 11.64C19.565 12.056 19.7196 12.5627 19.7196 13.16C19.7196 13.7147 19.581 14.1947 19.3036 14.6C19.037 15.0053 18.6476 15.3147 18.1356 15.528V15.544C18.7543 15.768 19.2396 16.0933 19.5916 16.52C19.9436 16.9467 20.1196 17.4853 20.1196 18.136C20.1196 18.7547 19.949 19.288 19.6076 19.736C19.277 20.184 18.8023 20.536 18.1836 20.792C17.5756 21.0373 16.845 21.16 15.9916 21.16C15.149 21.16 14.4183 21.0373 13.7996 20.792C13.1916 20.536 12.717 20.184 12.3756 19.736C12.045 19.288 11.8796 18.7547 11.8796 18.136C11.8796 17.496 12.0556 16.9627 12.4076 16.536C12.7596 16.0987 13.2503 15.768 13.8796 15.544V15.528C13.3676 15.3253 12.973 15.0213 12.6956 14.616C12.4183 14.2 12.2796 13.7147 12.2796 13.16C12.2796 12.5627 12.429 12.056 12.7276 11.64C13.037 11.2133 13.4743 10.888 14.0396 10.664C14.605 10.4293 15.2556 10.312 15.9916 10.312ZM16.0076 12.008C15.5063 12.008 15.1063 12.1307 14.8076 12.376C14.5196 12.6213 14.3756 12.9627 14.3756 13.4C14.3756 13.8373 14.5196 14.1787 14.8076 14.424C15.1063 14.6693 15.5063 14.792 16.0076 14.792C16.4983 14.792 16.8876 14.6693 17.1756 14.424C17.4743 14.1787 17.6236 13.8373 17.6236 13.4C17.6236 12.9627 17.4796 12.6213 17.1916 12.376C16.9036 12.1307 16.509 12.008 16.0076 12.008ZM16.0076 19.448C16.413 19.448 16.7596 19.3893 17.0476 19.272C17.3356 19.1547 17.5543 18.9787 17.7036 18.744C17.8636 18.5093 17.9436 18.232 17.9436 17.912C17.9436 17.592 17.8636 17.3147 17.7036 17.08C17.5543 16.8453 17.3303 16.6693 17.0316 16.552C16.7436 16.424 16.4023 16.36 16.0076 16.36C15.613 16.36 15.2663 16.424 14.9676 16.552C14.669 16.6693 14.4396 16.8453 14.2796 17.08C14.1196 17.3147 14.0396 17.592 14.0396 17.912C14.0396 18.232 14.1196 18.5093 14.2796 18.744C14.4396 18.9787 14.6636 19.1547 14.9516 19.272C15.2503 19.3893 15.6023 19.448 16.0076 19.448Z",
    fill: "black"
  })));
};

var _path$u, _path2$8, _path3$6, _path4$5, _path5$5, _path6$5, _path7$5, _path8$4, _path9$4, _path10$4, _path11$4, _path12$3, _path13$3;
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
var SvgB13 = function SvgB13(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$D({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$u || (_path$u = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.82565 4.82543C9.93536 5.01201 10.1733 5.07685 10.3661 4.97837C11.8938 4.19778 13.5265 3.75378 15.1669 3.64638C15.3838 3.63218 15.5557 3.4535 15.5535 3.23611L15.5243 0.419923C15.522 0.19597 15.3362 0.0170491 15.1126 0.0294023C12.8713 0.153217 10.6297 0.747754 8.54829 1.84868C8.35033 1.95339 8.28339 2.20252 8.39691 2.39558L9.82565 4.82543Z",
    fill: "#DDDDDD"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.1331 6.86848C27.957 5.18012 26.5091 3.78542 24.9011 2.70468C24.7146 2.57935 24.4626 2.63901 24.3467 2.83147L22.8898 5.24996C22.7777 5.436 22.8349 5.67689 23.0144 5.79927C24.2154 6.61855 25.2853 7.66794 26.1662 8.93782C26.278 9.10175 26.3853 9.26568 26.4881 9.4296C26.6029 9.61256 26.8402 9.678 27.0295 9.57405L29.5094 8.21251C29.7064 8.10439 29.776 7.85507 29.6578 7.66401C29.4918 7.39559 29.3154 7.12901 29.1331 6.86848Z",
    fill: "#26D4DD"
  })), _path3$6 || (_path3$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.2278 3.23747C16.2293 3.45448 16.4036 3.63002 16.6204 3.64079C18.4137 3.72988 20.17 4.20775 21.7727 5.04941C21.9645 5.15012 22.2034 5.08789 22.3152 4.90233L23.7738 2.4811C23.8893 2.28923 23.825 2.03938 23.6281 1.9326C21.4583 0.755933 19.0565 0.106231 16.6138 0.0107818C16.3898 0.00203011 16.2068 0.184191 16.2084 0.40833L16.2278 3.23747Z",
    fill: "#26D4DD"
  })), _path4$5 || (_path4$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.2405 15.5417C3.45629 15.5432 3.63369 15.3732 3.64874 15.1579C3.76194 13.5387 4.18141 11.9543 4.90716 10.4928C5.0036 10.2986 4.93599 10.0609 4.74772 9.9533L2.29976 8.55447C2.10494 8.44314 1.8562 8.51362 1.75433 8.71355C0.740423 10.7035 0.153364 12.891 0.0195852 15.1085C0.006017 15.3334 0.186083 15.5207 0.411396 15.5223L3.2405 15.5417Z",
    fill: "#DDDDDD"
  })), _path5$5 || (_path5$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408249 16.1974C0.184143 16.1951 0.00135428 16.3773 0.0094224 16.6013C0.0883039 18.7911 0.623374 20.982 1.62346 23.0327C1.72189 23.2345 1.96959 23.3095 2.16643 23.2014L4.64502 21.8406C4.835 21.7363 4.9067 21.4999 4.81364 21.3042C4.10108 19.8056 3.71225 18.2126 3.63916 16.6209C3.6292 16.404 3.45419 16.2288 3.237 16.2265L0.408249 16.1974Z",
    fill: "#26D4DD"
  })), _path6$5 || (_path6$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.09777 9.369C5.2858 9.47602 5.52425 9.41376 5.64247 9.23257C6.49032 7.9331 7.59218 6.7782 8.93826 5.8463C9.00041 5.80327 9.0644 5.76024 9.12881 5.71721C9.30297 5.60088 9.35478 5.37007 9.24862 5.18953L7.80897 2.74113C7.69629 2.5495 7.44839 2.48565 7.26224 2.60716C7.1288 2.69427 6.99704 2.78502 6.86893 2.87942C5.06937 4.12976 3.60938 5.68683 2.49923 7.41711C2.37757 7.60672 2.44317 7.85807 2.63895 7.9695L5.09777 9.369Z",
    fill: "#DDDDDD"
  })), _path7$5 || (_path7$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.5897 15.7649C31.8146 15.7672 31.9977 15.5836 31.9886 15.3589C31.9005 13.1819 31.375 11.0039 30.3768 8.96579C30.2782 8.76444 30.0309 8.6899 29.8344 8.7978L27.356 10.1585C27.1656 10.263 27.0941 10.5001 27.1877 10.6961C27.898 12.183 28.2777 13.7643 28.3586 15.3441C28.3696 15.5599 28.5442 15.7335 28.7603 15.7357L31.5897 15.7649Z",
    fill: "#26D4DD"
  })), _path8$4 || (_path8$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.1243 21.4584C27.0306 21.6519 27.0989 21.8869 27.2856 21.9936L29.7359 23.3938C29.9313 23.5054 30.1808 23.4341 30.2821 23.2332C31.2844 21.2447 31.8599 19.0682 31.9824 16.8622C31.9948 16.6386 31.8159 16.4527 31.5919 16.4504L28.773 16.4212C28.5568 16.419 28.3785 16.5892 28.3633 16.8049C28.2498 18.4144 27.8314 19.9975 27.1243 21.4584Z",
    fill: "#26D4DD"
  })), _path9$4 || (_path9$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.2642 29.2307C24.3775 29.4235 24.6268 29.4857 24.8139 29.3635C24.9238 29.2917 25.0337 29.2184 25.1436 29.1452C26.9577 27.8811 28.4312 26.3093 29.5434 24.5433C29.6626 24.3541 29.5967 24.1052 29.4025 23.9943L26.9537 22.5949C26.7651 22.4871 26.5255 22.5499 26.4075 22.7323C25.5579 24.0452 24.4435 25.2232 23.0742 26.1783C23.0403 26.2009 23.0071 26.2235 22.9742 26.2459C22.7912 26.3708 22.7291 26.6201 22.8414 26.811L24.2642 29.2307Z",
    fill: "#26D4DD"
  })), _path10$4 || (_path10$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.2495 27.138C22.1394 26.9507 21.9001 26.8862 21.7072 26.9861C20.1788 27.7777 18.5455 28.2324 16.9045 28.3503C16.6887 28.3658 16.5184 28.544 16.5206 28.7603L16.5498 31.5771C16.5521 31.8018 16.7391 31.981 16.9634 31.9676C19.2143 31.8326 21.4472 31.2265 23.5281 30.1137C23.725 30.0084 23.7912 29.76 23.678 29.5675L22.2495 27.138Z",
    fill: "#26D4DD"
  })), _path11$4 || (_path11$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.14984 26.786C9.26093 26.6003 9.20388 26.3605 9.02522 26.2385C7.81073 25.409 6.72854 24.3575 5.8464 23.0744C5.73463 22.9104 5.62732 22.7465 5.52445 22.5826C5.40965 22.3996 5.17245 22.3342 4.98312 22.4381L2.50318 23.7997C2.30624 23.9078 2.23658 24.1571 2.35478 24.3482C2.52083 24.6166 2.69716 24.8832 2.87953 25.1437C4.0681 26.845 5.51809 28.2413 7.14804 29.3326C7.33495 29.4578 7.58713 29.3975 7.70263 29.2045L9.14984 26.786Z",
    fill: "#26D4DD"
  })), _path12$3 || (_path12$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.277 26.9752C10.0852 26.8746 9.84629 26.9368 9.7345 27.1224L8.27724 29.5414C8.16116 29.7341 8.22657 29.9851 8.42495 30.0912C10.6063 31.2575 13.0195 31.9059 15.4737 31.9909C15.6976 31.9986 15.8796 31.8159 15.8773 31.5919L15.8482 28.7758C15.8459 28.5584 15.6704 28.3833 15.4532 28.3736C13.6575 28.294 11.8821 27.8167 10.277 26.9752Z",
    fill: "#26D4DD"
  })), _path13$3 || (_path13$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.7665 11.28C16.7052 11.28 17.4945 11.4987 18.1345 11.936C18.7745 12.3627 19.2545 12.9813 19.5745 13.792C19.9052 14.592 20.0705 15.5573 20.0705 16.688C20.0705 17.936 19.8945 18.9653 19.5425 19.776C19.1905 20.576 18.6892 21.1733 18.0385 21.568C17.3985 21.9627 16.6465 22.16 15.7825 22.16C14.8758 22.16 14.0918 21.968 13.4305 21.584C12.7798 21.2 12.2892 20.6133 11.9585 19.824L13.9905 18.96C14.1078 19.3973 14.3105 19.7493 14.5985 20.016C14.8972 20.272 15.3078 20.4 15.8305 20.4C16.2465 20.4 16.5985 20.32 16.8865 20.16C17.1745 19.9893 17.4038 19.7493 17.5745 19.44C17.7558 19.1307 17.8838 18.752 17.9585 18.304C18.0438 17.856 18.0865 17.3547 18.0865 16.8C18.0865 16.7573 18.0865 16.72 18.0865 16.688C18.0865 16.656 18.0865 16.6187 18.0865 16.576H18.0225C17.9052 16.9493 17.7025 17.2587 17.4145 17.504C17.1372 17.7387 16.8172 17.9147 16.4545 18.032C16.0918 18.1387 15.7185 18.192 15.3345 18.192C14.6625 18.192 14.0652 18.0587 13.5425 17.792C13.0305 17.5147 12.6252 17.1307 12.3265 16.64C12.0278 16.1387 11.8785 15.5573 11.8785 14.896C11.8785 14.1493 12.0385 13.5093 12.3585 12.976C12.6785 12.432 13.1265 12.016 13.7025 11.728C14.2892 11.4293 14.9772 11.28 15.7665 11.28ZM15.7825 13.072C15.2172 13.072 14.7745 13.232 14.4545 13.552C14.1452 13.8613 13.9905 14.2987 13.9905 14.864C13.9905 15.3653 14.1505 15.76 14.4705 16.048C14.8012 16.3253 15.2385 16.464 15.7825 16.464C16.1345 16.464 16.4438 16.3947 16.7105 16.256C16.9878 16.1173 17.2012 15.92 17.3505 15.664C17.4998 15.408 17.5745 15.1147 17.5745 14.784C17.5745 14.432 17.4998 14.128 17.3505 13.872C17.2012 13.616 16.9878 13.4187 16.7105 13.28C16.4438 13.1413 16.1345 13.072 15.7825 13.072Z",
    fill: "black"
  })));
};

var _path$t, _path2$7, _path3$5, _path4$4, _path5$4, _path6$4, _path7$4, _path8$3, _path9$3, _path10$3, _path11$3, _path12$2, _path13$2;
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
var SvgB21 = function SvgB21(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$C({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$t || (_path$t = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.2379 21V14.312C11.2379 14.0667 11.2379 13.816 11.2379 13.56C11.2486 13.2933 11.2593 13.0213 11.2699 12.744C10.9073 13.0747 10.5019 13.3627 10.0539 13.608C9.60594 13.8533 9.14727 14.024 8.67794 14.12L8.38994 12.264C8.63527 12.2427 8.90727 12.1733 9.20594 12.056C9.51527 11.928 9.8246 11.7787 10.1339 11.608C10.4539 11.4267 10.7419 11.24 10.9979 11.048C11.2646 10.8453 11.4673 10.6427 11.6059 10.44H13.3979V21H11.2379ZM19.8302 21.16C18.4755 21.16 17.4302 20.7013 16.6942 19.784C15.9689 18.8667 15.6062 17.512 15.6062 15.72C15.6062 13.928 15.9689 12.5733 16.6942 11.656C17.4302 10.7387 18.4755 10.28 19.8302 10.28C21.1849 10.28 22.2249 10.7387 22.9502 11.656C23.6862 12.5733 24.0542 13.928 24.0542 15.72C24.0542 17.512 23.6862 18.8667 22.9502 19.784C22.2249 20.7013 21.1849 21.16 19.8302 21.16ZM19.8302 19.384C20.2889 19.384 20.6622 19.256 20.9502 19C21.2489 18.7333 21.4729 18.3333 21.6222 17.8C21.7715 17.256 21.8462 16.5627 21.8462 15.72C21.8462 14.8773 21.7715 14.1893 21.6222 13.656C21.4729 13.112 21.2489 12.712 20.9502 12.456C20.6622 12.1893 20.2889 12.056 19.8302 12.056C19.3715 12.056 18.9929 12.1893 18.6942 12.456C18.3955 12.712 18.1715 13.112 18.0222 13.656C17.8835 14.1893 17.8142 14.8773 17.8142 15.72C17.8142 16.5627 17.8835 17.256 18.0222 17.8C18.1715 18.3333 18.3955 18.7333 18.6942 19C18.9929 19.256 19.3715 19.384 19.8302 19.384Z",
    fill: "black"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.82565 4.82543C9.93536 5.01201 10.1733 5.07685 10.3661 4.97837C11.8938 4.19778 13.5265 3.75378 15.1669 3.64638C15.3838 3.63218 15.5557 3.4535 15.5535 3.23611L15.5243 0.419923C15.522 0.19597 15.3362 0.0170491 15.1126 0.0294023C12.8713 0.153217 10.6297 0.747754 8.54829 1.84868C8.35033 1.95339 8.28339 2.20252 8.39691 2.39558L9.82565 4.82543Z",
    fill: "#DDDDDD"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.1331 6.86848C27.957 5.18012 26.5091 3.78542 24.9011 2.70468C24.7146 2.57935 24.4626 2.63901 24.3467 2.83147L22.8898 5.24996C22.7777 5.436 22.8349 5.67689 23.0144 5.79927C24.2154 6.61855 25.2853 7.66794 26.1662 8.93782C26.278 9.10175 26.3853 9.26568 26.4881 9.4296C26.6029 9.61256 26.8402 9.678 27.0295 9.57405L29.5094 8.21251C29.7064 8.10439 29.776 7.85507 29.6578 7.66401C29.4918 7.39559 29.3154 7.12901 29.1331 6.86848Z",
    fill: "#26D4DD"
  })), _path4$4 || (_path4$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.2271 3.13995C16.229 3.41121 16.447 3.63042 16.7178 3.64601C18.4451 3.74546 20.1362 4.20575 21.6864 5.00449C21.9271 5.12852 22.2257 5.05095 22.3654 4.819L23.7211 2.56846C23.8656 2.32862 23.7853 2.01618 23.5384 1.88428C21.4225 0.75432 19.0897 0.122893 16.7158 0.0150896C16.4359 0.00237948 16.2071 0.230239 16.2091 0.510413L16.2271 3.13995Z",
    fill: "#26D4DD"
  })), _path5$4 || (_path5$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.2405 15.5417C3.45629 15.5432 3.63369 15.3732 3.64874 15.1579C3.76194 13.5387 4.18141 11.9543 4.90716 10.4928C5.0036 10.2986 4.93599 10.0609 4.74772 9.9533L2.29976 8.55447C2.10494 8.44314 1.8562 8.51362 1.75433 8.71355C0.740423 10.7035 0.153364 12.891 0.0195852 15.1085C0.006017 15.3334 0.186083 15.5207 0.411396 15.5223L3.2405 15.5417Z",
    fill: "#26D4DD"
  })), _path6$4 || (_path6$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408249 16.1974C0.184143 16.1951 0.00135428 16.3773 0.0094224 16.6013C0.0883039 18.7911 0.623374 20.982 1.62346 23.0327C1.72189 23.2345 1.96959 23.3095 2.16643 23.2014L4.64502 21.8406C4.835 21.7363 4.9067 21.4999 4.81364 21.3042C4.10108 19.8056 3.71225 18.2126 3.63916 16.6209C3.6292 16.404 3.45419 16.2288 3.237 16.2265L0.408249 16.1974Z",
    fill: "#26D4DD"
  })), _path7$4 || (_path7$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.09777 9.369C5.2858 9.47602 5.52425 9.41376 5.64247 9.23257C6.49032 7.9331 7.59218 6.7782 8.93826 5.8463C9.00041 5.80327 9.0644 5.76024 9.12881 5.71721C9.30297 5.60088 9.35478 5.37007 9.24862 5.18953L7.80897 2.74113C7.69629 2.5495 7.44839 2.48565 7.26224 2.60716C7.1288 2.69427 6.99704 2.78502 6.86893 2.87942C5.06937 4.12976 3.60938 5.68683 2.49923 7.41711C2.37757 7.60672 2.44317 7.85807 2.63895 7.9695L5.09777 9.369Z",
    fill: "#DDDDDD"
  })), _path8$3 || (_path8$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.5897 15.7649C31.8146 15.7672 31.9977 15.5836 31.9886 15.3589C31.9005 13.1819 31.375 11.0039 30.3768 8.96579C30.2782 8.76444 30.0309 8.6899 29.8344 8.7978L27.356 10.1585C27.1656 10.263 27.0941 10.5001 27.1877 10.6961C27.898 12.183 28.2777 13.7643 28.3586 15.3441C28.3696 15.5599 28.5442 15.7335 28.7603 15.7357L31.5897 15.7649Z",
    fill: "#26D4DD"
  })), _path9$3 || (_path9$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.1243 21.4584C27.0306 21.6519 27.0989 21.8869 27.2856 21.9936L29.7359 23.3938C29.9313 23.5054 30.1808 23.4341 30.2821 23.2332C31.2844 21.2447 31.8599 19.0682 31.9824 16.8622C31.9948 16.6386 31.8159 16.4527 31.5919 16.4504L28.773 16.4212C28.5568 16.419 28.3785 16.5892 28.3633 16.8049C28.2498 18.4144 27.8314 19.9975 27.1243 21.4584Z",
    fill: "#26D4DD"
  })), _path10$3 || (_path10$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.2642 29.2307C24.3775 29.4235 24.6268 29.4857 24.8139 29.3635C24.9238 29.2917 25.0337 29.2184 25.1436 29.1452C26.9577 27.8811 28.4312 26.3093 29.5434 24.5433C29.6626 24.3541 29.5967 24.1052 29.4025 23.9943L26.9537 22.5949C26.7651 22.4871 26.5255 22.5499 26.4075 22.7323C25.5579 24.0452 24.4435 25.2232 23.0742 26.1783C23.0403 26.2009 23.0071 26.2235 22.9742 26.2459C22.7912 26.3708 22.7291 26.6201 22.8414 26.811L24.2642 29.2307Z",
    fill: "#26D4DD"
  })), _path11$3 || (_path11$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.2495 27.138C22.1394 26.9507 21.9001 26.8862 21.7072 26.9861C20.1788 27.7777 18.5455 28.2324 16.9045 28.3503C16.6887 28.3658 16.5184 28.544 16.5206 28.7603L16.5498 31.5771C16.5521 31.8018 16.7391 31.981 16.9634 31.9676C19.2143 31.8326 21.4472 31.2265 23.5281 30.1137C23.725 30.0084 23.7912 29.76 23.678 29.5675L22.2495 27.138Z",
    fill: "#26D4DD"
  })), _path12$2 || (_path12$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.14984 26.786C9.26093 26.6003 9.20388 26.3605 9.02522 26.2385C7.81073 25.409 6.72854 24.3575 5.8464 23.0744C5.73463 22.9104 5.62732 22.7465 5.52445 22.5826C5.40965 22.3996 5.17245 22.3342 4.98312 22.4381L2.50318 23.7997C2.30624 23.9078 2.23658 24.1571 2.35478 24.3482C2.52083 24.6166 2.69716 24.8832 2.87953 25.1437C4.0681 26.845 5.51809 28.2413 7.14804 29.3326C7.33495 29.4578 7.58713 29.3975 7.70263 29.2045L9.14984 26.786Z",
    fill: "#26D4DD"
  })), _path13$2 || (_path13$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.277 26.9752C10.0852 26.8746 9.84629 26.9368 9.7345 27.1224L8.27724 29.5414C8.16116 29.7341 8.22657 29.9851 8.42495 30.0912C10.6063 31.2575 13.0195 31.9059 15.4737 31.9909C15.6976 31.9986 15.8796 31.8159 15.8773 31.5919L15.8482 28.7758C15.8459 28.5584 15.6704 28.3833 15.4532 28.3736C13.6575 28.294 11.8821 27.8167 10.277 26.9752Z",
    fill: "#26D4DD"
  })));
};

var _path$s, _path2$6, _path3$4, _path4$3, _path5$3, _path6$3, _path7$3, _path8$2, _path9$2, _path10$2, _path11$2, _path12$1, _path13$1;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
var SvgB22 = function SvgB22(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$B({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$s || (_path$s = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.82565 4.82541C9.93536 5.01199 10.1733 5.07683 10.3661 4.97836C11.8938 4.19776 13.5265 3.75377 15.1669 3.64637C15.3838 3.63217 15.5557 3.45349 15.5535 3.2361L15.5243 0.419908C15.522 0.195954 15.3362 0.0170339 15.1126 0.0293871C12.8713 0.153201 10.6297 0.747739 8.54829 1.84866C8.35033 1.95338 8.28339 2.20251 8.39691 2.39556L9.82565 4.82541Z",
    fill: "#DDDDDD"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.1331 6.86846C27.957 5.18011 26.5091 3.7854 24.9011 2.70467C24.7146 2.57934 24.4626 2.63899 24.3467 2.83145L22.8898 5.24995C22.7777 5.43598 22.8349 5.67687 23.0144 5.79926C24.2154 6.61854 25.2853 7.66793 26.1662 8.9378C26.278 9.10173 26.3853 9.26566 26.4881 9.42959C26.6029 9.61254 26.8402 9.67798 27.0295 9.57404L29.5094 8.2125C29.7064 8.10438 29.776 7.85505 29.6578 7.66399C29.4918 7.39557 29.3154 7.12899 29.1331 6.86846Z",
    fill: "#26D4DD"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.2278 3.23747C16.2293 3.45448 16.4036 3.63002 16.6204 3.64079C18.4137 3.72988 20.17 4.20775 21.7727 5.04941C21.9645 5.15012 22.2034 5.08789 22.3152 4.90233L23.7738 2.4811C23.8893 2.28923 23.825 2.03938 23.6281 1.9326C21.4583 0.755933 19.0565 0.106231 16.6138 0.0107818C16.3898 0.00203011 16.2068 0.184191 16.2084 0.40833L16.2278 3.23747Z",
    fill: "#26D4DD"
  })), _path4$3 || (_path4$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.2405 15.5417C3.45629 15.5432 3.63369 15.3732 3.64874 15.1579C3.76194 13.5387 4.18141 11.9543 4.90716 10.4928C5.0036 10.2986 4.93599 10.0609 4.74772 9.9533L2.29976 8.55447C2.10494 8.44314 1.8562 8.51362 1.75433 8.71355C0.740423 10.7035 0.153364 12.891 0.0195852 15.1085C0.006017 15.3334 0.186083 15.5207 0.411396 15.5223L3.2405 15.5417Z",
    fill: "#26D4DD"
  })), _path5$3 || (_path5$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408249 16.1974C0.184143 16.195 0.00135428 16.3773 0.0094224 16.6013C0.0883039 18.791 0.623374 20.9819 1.62346 23.0327C1.72189 23.2345 1.96959 23.3095 2.16643 23.2014L4.64502 21.8406C4.835 21.7363 4.9067 21.4999 4.81364 21.3042C4.10108 19.8056 3.71225 18.2126 3.63916 16.6209C3.6292 16.404 3.45419 16.2288 3.237 16.2265L0.408249 16.1974Z",
    fill: "#26D4DD"
  })), _path6$3 || (_path6$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.09777 9.369C5.2858 9.47602 5.52425 9.41376 5.64247 9.23257C6.49032 7.9331 7.59218 6.7782 8.93826 5.8463C9.00041 5.80327 9.0644 5.76024 9.12881 5.71721C9.30297 5.60088 9.35478 5.37007 9.24862 5.18953L7.80897 2.74113C7.69629 2.5495 7.44839 2.48565 7.26224 2.60716C7.1288 2.69427 6.99704 2.78502 6.86893 2.87942C5.06937 4.12976 3.60938 5.68683 2.49923 7.41711C2.37757 7.60672 2.44317 7.85807 2.63895 7.9695L5.09777 9.369Z",
    fill: "#26D4DD"
  })), _path7$3 || (_path7$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.5897 15.7649C31.8146 15.7672 31.9977 15.5836 31.9886 15.3589C31.9005 13.1819 31.375 11.0039 30.3768 8.96578C30.2782 8.76442 30.0309 8.68989 29.8344 8.79779L27.356 10.1585C27.1656 10.263 27.0941 10.5001 27.1877 10.696C27.898 12.183 28.2777 13.7643 28.3586 15.3441C28.3696 15.5599 28.5442 15.7335 28.7603 15.7357L31.5897 15.7649Z",
    fill: "#26D4DD"
  })), _path8$2 || (_path8$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.1243 21.4584C27.0306 21.652 27.0989 21.8869 27.2856 21.9936L29.7359 23.3938C29.9313 23.5055 30.1808 23.4342 30.2821 23.2332C31.2844 21.2447 31.8599 19.0682 31.9824 16.8623C31.9948 16.6386 31.8159 16.4527 31.5919 16.4504L28.773 16.4213C28.5568 16.419 28.3785 16.5892 28.3633 16.805C28.2498 18.4144 27.8314 19.9975 27.1243 21.4584Z",
    fill: "#26D4DD"
  })), _path9$2 || (_path9$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.2642 29.2307C24.3775 29.4235 24.6268 29.4857 24.8139 29.3635C24.9238 29.2917 25.0337 29.2184 25.1436 29.1452C26.9577 27.8811 28.4312 26.3093 29.5434 24.5433C29.6626 24.3541 29.5967 24.1052 29.4025 23.9943L26.9537 22.5949C26.7651 22.4871 26.5255 22.5499 26.4075 22.7323C25.5579 24.0452 24.4435 25.2232 23.0742 26.1783C23.0403 26.2009 23.0071 26.2235 22.9742 26.2459C22.7912 26.3708 22.7291 26.6201 22.8414 26.811L24.2642 29.2307Z",
    fill: "#26D4DD"
  })), _path10$2 || (_path10$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.2495 27.138C22.1394 26.9507 21.9001 26.8862 21.7072 26.9861C20.1788 27.7777 18.5455 28.2324 16.9045 28.3503C16.6887 28.3658 16.5184 28.544 16.5206 28.7603L16.5498 31.5771C16.5521 31.8018 16.7391 31.981 16.9634 31.9676C19.2143 31.8326 21.4472 31.2265 23.5281 30.1137C23.725 30.0084 23.7912 29.76 23.678 29.5675L22.2495 27.138Z",
    fill: "#26D4DD"
  })), _path11$2 || (_path11$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.14984 26.786C9.26093 26.6003 9.20388 26.3605 9.02522 26.2385C7.81073 25.409 6.72854 24.3575 5.8464 23.0744C5.73463 22.9104 5.62732 22.7465 5.52445 22.5826C5.40965 22.3996 5.17245 22.3342 4.98312 22.4381L2.50318 23.7997C2.30624 23.9078 2.23658 24.1571 2.35478 24.3482C2.52083 24.6166 2.69716 24.8832 2.87953 25.1437C4.0681 26.845 5.51809 28.2413 7.14804 29.3326C7.33495 29.4578 7.58713 29.3975 7.70263 29.2045L9.14984 26.786Z",
    fill: "#26D4DD"
  })), _path12$1 || (_path12$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.277 26.9752C10.0852 26.8746 9.84629 26.9368 9.7345 27.1224L8.27724 29.5414C8.16116 29.7341 8.22657 29.9851 8.42495 30.0912C10.6063 31.2575 13.0195 31.9059 15.4737 31.9909C15.6976 31.9986 15.8796 31.8159 15.8773 31.5919L15.8482 28.7758C15.8459 28.5584 15.6704 28.3833 15.4532 28.3736C13.6575 28.294 11.8821 27.8167 10.277 26.9752Z",
    fill: "#26D4DD"
  })), _path13$1 || (_path13$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.4958 21V14.312C12.4958 14.0667 12.4958 13.816 12.4958 13.56C12.5064 13.2933 12.5171 13.0213 12.5278 12.744C12.1651 13.0747 11.7598 13.3627 11.3118 13.608C10.8638 13.8533 10.4051 14.024 9.93575 14.12L9.64775 12.264C9.89308 12.2427 10.1651 12.1733 10.4638 12.056C10.7731 11.928 11.0824 11.7787 11.3918 11.608C11.7118 11.4267 11.9998 11.24 12.2558 11.048C12.5224 10.8453 12.7251 10.6427 12.8638 10.44H14.6558V21H12.4958ZM19.152 21V14.312C19.152 14.0667 19.152 13.816 19.152 13.56C19.1627 13.2933 19.1733 13.0213 19.184 12.744C18.8213 13.0747 18.416 13.3627 17.968 13.608C17.52 13.8533 17.0613 14.024 16.592 14.12L16.304 12.264C16.5493 12.2427 16.8213 12.1733 17.12 12.056C17.4293 11.928 17.7387 11.7787 18.048 11.608C18.368 11.4267 18.656 11.24 18.912 11.048C19.1787 10.8453 19.3813 10.6427 19.52 10.44H21.312V21H19.152Z",
    fill: "black"
  })));
};

var _path$r, _path2$5, _path3$3, _path4$2, _path5$2, _path6$2, _path7$2, _path8$1, _path9$1, _path10$1, _path11$1, _path12, _path13;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
var SvgB23 = function SvgB23(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$A({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$r || (_path$r = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.5973 21V14.312C10.5973 14.0667 10.5973 13.816 10.5973 13.56C10.608 13.2933 10.6186 13.0213 10.6293 12.744C10.2666 13.0747 9.86131 13.3627 9.41331 13.608C8.96531 13.8533 8.50665 14.024 8.03731 14.12L7.74931 12.264C7.99465 12.2427 8.26665 12.1733 8.56531 12.056C8.87465 11.928 9.18398 11.7787 9.49331 11.608C9.81331 11.4267 10.1013 11.24 10.3573 11.048C10.624 10.8453 10.8266 10.6427 10.9653 10.44H12.7573V21H10.5973ZM15.1416 21V19.496C16.1016 18.856 16.9122 18.2747 17.5736 17.752C18.2456 17.2187 18.7842 16.728 19.1896 16.28C19.6056 15.8213 19.9042 15.3893 20.0856 14.984C20.2776 14.5787 20.3736 14.1733 20.3736 13.768C20.3736 13.2773 20.2242 12.8773 19.9256 12.568C19.6269 12.248 19.2056 12.088 18.6616 12.088C18.0642 12.088 17.5949 12.2907 17.2536 12.696C16.9229 13.1013 16.7416 13.6773 16.7096 14.424L14.8056 13.704C14.8589 12.9787 15.0509 12.3653 15.3816 11.864C15.7229 11.352 16.1816 10.9627 16.7576 10.696C17.3442 10.4187 18.0216 10.28 18.7896 10.28C19.4296 10.28 19.9842 10.3707 20.4536 10.552C20.9336 10.7333 21.3336 10.984 21.6536 11.304C21.9736 11.6133 22.2082 11.9707 22.3576 12.376C22.5176 12.7813 22.5976 13.2027 22.5976 13.64C22.5976 14.3227 22.4269 14.968 22.0856 15.576C21.7549 16.184 21.2429 16.7867 20.5496 17.384C19.8562 17.9813 18.9762 18.6107 17.9096 19.272V19.288C18.0696 19.2773 18.2616 19.2667 18.4856 19.256C18.7202 19.2453 18.9602 19.24 19.2056 19.24C19.4509 19.2293 19.6642 19.224 19.8456 19.224H22.7576V21H15.1416Z",
    fill: "black"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.82565 4.82541C9.93536 5.01199 10.1733 5.07683 10.3661 4.97836C11.8938 4.19776 13.5265 3.75377 15.1669 3.64637C15.3838 3.63217 15.5557 3.45349 15.5535 3.2361L15.5243 0.419908C15.522 0.195954 15.3362 0.0170339 15.1126 0.0293871C12.8713 0.153201 10.6297 0.747739 8.54829 1.84866C8.35033 1.95338 8.28339 2.20251 8.39691 2.39556L9.82565 4.82541Z",
    fill: "#26D4DD"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.1331 6.86846C27.957 5.18011 26.5091 3.7854 24.9011 2.70467C24.7146 2.57934 24.4626 2.63899 24.3467 2.83145L22.8898 5.24995C22.7777 5.43598 22.8349 5.67687 23.0144 5.79926C24.2154 6.61854 25.2853 7.66793 26.1662 8.9378C26.278 9.10173 26.3853 9.26566 26.4881 9.42959C26.6029 9.61254 26.8402 9.67798 27.0295 9.57404L29.5094 8.2125C29.7064 8.10438 29.776 7.85505 29.6578 7.66399C29.4918 7.39557 29.3154 7.12899 29.1331 6.86846Z",
    fill: "#26D4DD"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.2278 3.23747C16.2293 3.45448 16.4036 3.63002 16.6204 3.64079C18.4137 3.72988 20.17 4.20775 21.7727 5.04941C21.9645 5.15012 22.2034 5.08789 22.3152 4.90233L23.7738 2.4811C23.8893 2.28923 23.825 2.03938 23.6281 1.9326C21.4583 0.755933 19.0565 0.106231 16.6138 0.0107818C16.3898 0.00203011 16.2068 0.184191 16.2084 0.40833L16.2278 3.23747Z",
    fill: "#26D4DD"
  })), _path5$2 || (_path5$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3.2405 15.5417C3.45629 15.5432 3.63369 15.3732 3.64874 15.1579C3.76194 13.5387 4.18141 11.9543 4.90716 10.4928C5.0036 10.2986 4.93599 10.0609 4.74772 9.9533L2.29976 8.55447C2.10494 8.44314 1.8562 8.51362 1.75433 8.71355C0.740423 10.7035 0.153364 12.891 0.0195852 15.1085C0.006017 15.3334 0.186083 15.5207 0.411396 15.5223L3.2405 15.5417Z",
    fill: "#26D4DD"
  })), _path6$2 || (_path6$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.408249 16.1974C0.184143 16.195 0.00135428 16.3773 0.0094224 16.6013C0.0883039 18.791 0.623374 20.9819 1.62346 23.0327C1.72189 23.2345 1.96959 23.3095 2.16643 23.2014L4.64502 21.8406C4.835 21.7363 4.9067 21.4999 4.81364 21.3042C4.10108 19.8056 3.71225 18.2126 3.63916 16.6209C3.6292 16.404 3.45419 16.2288 3.237 16.2265L0.408249 16.1974Z",
    fill: "#26D4DD"
  })), _path7$2 || (_path7$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.09777 9.369C5.2858 9.47602 5.52425 9.41376 5.64247 9.23257C6.49032 7.9331 7.59218 6.7782 8.93826 5.8463C9.00041 5.80327 9.0644 5.76024 9.12881 5.71721C9.30297 5.60088 9.35478 5.37007 9.24862 5.18953L7.80897 2.74113C7.69629 2.5495 7.44839 2.48565 7.26224 2.60716C7.1288 2.69427 6.99704 2.78502 6.86893 2.87942C5.06937 4.12976 3.60938 5.68683 2.49923 7.41711C2.37757 7.60672 2.44317 7.85807 2.63895 7.9695L5.09777 9.369Z",
    fill: "#26D4DD"
  })), _path8$1 || (_path8$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.5897 15.7649C31.8146 15.7672 31.9977 15.5836 31.9886 15.3589C31.9005 13.1819 31.375 11.0039 30.3768 8.96578C30.2782 8.76442 30.0309 8.68989 29.8344 8.79779L27.356 10.1585C27.1656 10.263 27.0941 10.5001 27.1877 10.696C27.898 12.183 28.2777 13.7643 28.3586 15.3441C28.3696 15.5599 28.5442 15.7335 28.7603 15.7357L31.5897 15.7649Z",
    fill: "#26D4DD"
  })), _path9$1 || (_path9$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.1243 21.4584C27.0306 21.652 27.0989 21.8869 27.2856 21.9936L29.7359 23.3938C29.9313 23.5055 30.1808 23.4342 30.2821 23.2332C31.2844 21.2447 31.8599 19.0682 31.9824 16.8623C31.9948 16.6386 31.8159 16.4527 31.5919 16.4504L28.773 16.4213C28.5568 16.419 28.3785 16.5892 28.3633 16.805C28.2498 18.4144 27.8314 19.9975 27.1243 21.4584Z",
    fill: "#26D4DD"
  })), _path10$1 || (_path10$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.2642 29.2307C24.3775 29.4235 24.6268 29.4857 24.8139 29.3635C24.9238 29.2917 25.0337 29.2184 25.1436 29.1452C26.9577 27.8811 28.4312 26.3093 29.5434 24.5433C29.6626 24.3541 29.5967 24.1052 29.4025 23.9943L26.9537 22.5949C26.7651 22.4871 26.5255 22.5499 26.4075 22.7323C25.5579 24.0452 24.4435 25.2232 23.0742 26.1783C23.0403 26.2009 23.0071 26.2235 22.9742 26.2459C22.7912 26.3708 22.7291 26.6201 22.8414 26.811L24.2642 29.2307Z",
    fill: "#26D4DD"
  })), _path11$1 || (_path11$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.2495 27.138C22.1394 26.9507 21.9001 26.8862 21.7072 26.9861C20.1788 27.7777 18.5455 28.2324 16.9045 28.3503C16.6887 28.3658 16.5184 28.544 16.5206 28.7603L16.5498 31.5771C16.5521 31.8018 16.7391 31.981 16.9634 31.9676C19.2143 31.8326 21.4472 31.2265 23.5281 30.1137C23.725 30.0084 23.7912 29.76 23.678 29.5675L22.2495 27.138Z",
    fill: "#26D4DD"
  })), _path12 || (_path12 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.14984 26.786C9.26093 26.6003 9.20388 26.3605 9.02522 26.2385C7.81073 25.409 6.72854 24.3575 5.8464 23.0744C5.73463 22.9104 5.62732 22.7465 5.52445 22.5826C5.40965 22.3996 5.17245 22.3342 4.98312 22.4381L2.50318 23.7997C2.30624 23.9078 2.23658 24.1571 2.35478 24.3482C2.52083 24.6166 2.69716 24.8832 2.87953 25.1437C4.0681 26.845 5.51809 28.2413 7.14804 29.3326C7.33495 29.4578 7.58713 29.3975 7.70263 29.2045L9.14984 26.786Z",
    fill: "#26D4DD"
  })), _path13 || (_path13 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.277 26.9752C10.0852 26.8746 9.84629 26.9368 9.7345 27.1224L8.27724 29.5414C8.16116 29.7341 8.22657 29.9851 8.42495 30.0912C10.6063 31.2575 13.0195 31.9059 15.4737 31.9909C15.6976 31.9986 15.8796 31.8159 15.8773 31.5919L15.8482 28.7758C15.8459 28.5584 15.6704 28.3833 15.4532 28.3736C13.6575 28.294 11.8821 27.8167 10.277 26.9752Z",
    fill: "#26D4DD"
  })));
};

var _path$q, _circle$4;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
var SvgC1 = function SvgC1(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$z({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$q || (_path$q = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.6129 21V14.312C10.6129 14.0667 10.6129 13.816 10.6129 13.56C10.6236 13.2933 10.6343 13.0213 10.6449 12.744C10.2823 13.0747 9.87694 13.3627 9.42894 13.608C8.98094 13.8533 8.52227 14.024 8.05294 14.12L7.76494 12.264C8.01027 12.2427 8.28227 12.1733 8.58094 12.056C8.89027 11.928 9.1996 11.7787 9.50894 11.608C9.82894 11.4267 10.1169 11.24 10.3729 11.048C10.6396 10.8453 10.8423 10.6427 10.9809 10.44H12.7729V21H10.6129ZM18.8692 21.16C17.8132 21.16 16.9119 20.9413 16.1652 20.504C15.4292 20.056 14.9225 19.416 14.6452 18.584L16.7252 17.672C16.7999 18.056 16.9225 18.376 17.0932 18.632C17.2639 18.8773 17.4932 19.064 17.7812 19.192C18.0799 19.32 18.4319 19.384 18.8372 19.384C19.1999 19.384 19.5039 19.32 19.7492 19.192C20.0052 19.0533 20.2025 18.872 20.3412 18.648C20.4799 18.4133 20.5492 18.1413 20.5492 17.832C20.5492 17.5227 20.4852 17.2667 20.3572 17.064C20.2292 16.8613 20.0425 16.7173 19.7972 16.632C19.5625 16.536 19.2585 16.488 18.8852 16.488C18.7465 16.488 18.6132 16.4933 18.4852 16.504C18.3679 16.504 18.2345 16.5147 18.0852 16.536V14.92C18.1705 14.9307 18.2559 14.9413 18.3412 14.952C18.4372 14.952 18.5332 14.952 18.6292 14.952C19.2265 14.952 19.6532 14.8347 19.9092 14.6C20.1759 14.3547 20.3092 13.9653 20.3092 13.432C20.3092 12.9947 20.1759 12.6587 19.9092 12.424C19.6532 12.1787 19.2852 12.056 18.8052 12.056C18.2932 12.056 17.8879 12.184 17.5892 12.44C17.2905 12.6853 17.0825 13.064 16.9652 13.576L14.9972 12.84C15.1252 12.3067 15.3705 11.848 15.7332 11.464C16.1065 11.08 16.5652 10.7867 17.1092 10.584C17.6532 10.3707 18.2559 10.264 18.9172 10.264C19.7065 10.264 20.3625 10.3867 20.8852 10.632C21.4185 10.8773 21.8185 11.2133 22.0852 11.64C22.3625 12.0667 22.5012 12.5573 22.5012 13.112C22.5012 13.5493 22.4319 13.9227 22.2932 14.232C22.1652 14.5307 21.9945 14.7867 21.7812 15C21.5785 15.2027 21.3652 15.3573 21.1412 15.464C20.9172 15.5707 20.7092 15.6347 20.5172 15.656V15.704C20.7625 15.7147 21.0132 15.768 21.2692 15.864C21.5252 15.9493 21.7599 16.0827 21.9732 16.264C22.1972 16.4453 22.3785 16.68 22.5172 16.968C22.6559 17.2453 22.7252 17.576 22.7252 17.96C22.7252 18.6 22.5545 19.1653 22.2132 19.656C21.8825 20.136 21.4292 20.5093 20.8532 20.776C20.2772 21.032 19.6159 21.16 18.8692 21.16Z",
    fill: "black"
  })), _circle$4 || (_circle$4 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.5,
    stroke: "black",
    strokeWidth: 3
  })));
};

var css_248z$r = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.book-carousel-item {\n  height: 250px;\n  margin: 0 0.5rem;\n  background: #eee no-repeat;\n  background-size: cover;\n  border-radius: 10px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  transition: 230ms all;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-direction: column;\n  cursor: pointer;\n}\n.book-carousel-item:hover {\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25), 0 7px 7px rgba(0, 0, 0, 0.22);\n}\n.book-carousel-item__cover {\n  width: 100%;\n  flex: 1 0 auto;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n.book-carousel-item__status {\n  width: 100%;\n  flex: 1 0 auto;\n  padding: 0.25rem 0.5rem;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.book-carousel-item__status--left {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex: 1 0 auto;\n}\n.book-carousel-item__status--right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex: 1 0 auto;\n  padding: 4px 0 0 0;\n}\n.book-carousel-item__badge, .book-carousel-item__badge--cefr, .book-carousel-item__badge--stars, .book-carousel-item__badge--recommended, .book-carousel-item__badge--read, .book-carousel-item__badge--jumpBack {\n  font-size: 15px;\n  font-weight: bold;\n  padding: 4px 8px;\n  border-radius: 10px;\n  height: fit-content;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n}\n.book-carousel-item__badge--jumpBack {\n  background-color: #ffdc4a;\n  color: black;\n  margin: 4px 4px 0 0;\n}\n.book-carousel-item__badge--jumpBack::before {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-left: 10px solid black;\n  margin-right: 4px;\n}\n.book-carousel-item__badge--read {\n  background-color: #26d4dd;\n  color: white;\n  margin: 4px 4px 0 0;\n}\n.book-carousel-item__badge--recommended {\n  background-color: #5bcfff;\n  color: white;\n  margin: 4px 4px 0 0;\n}\n.book-carousel-item__badge--recommended::before {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-left: 10px solid white;\n  margin-right: 4px;\n}\n.book-carousel-item__badge--stars {\n  background-color: white;\n  color: black;\n  font-weight: bold;\n  margin-bottom: 4px;\n}\n.book-carousel-item__badge--stars svg {\n  width: 15px;\n  height: 15px;\n  margin-right: 2px;\n  fill: #ffdc4a;\n}\n.book-carousel-item__badge--cefr {\n  background-color: white;\n  margin-bottom: 4px;\n}\n.book-carousel-item__badge--cefr svg {\n  width: 16px;\n  height: 16px;\n}\n.book-carousel-item__title {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  padding: 12px 14px;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: white;\n}\n.book-carousel-item__title-text {\n  font-size: 1.2rem;\n  flex: 1 0 0;\n  text-align: center;\n  color: black;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.book-carousel-item__title-info {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  height: 1.4rem;\n}\n.book-carousel-item__title-info svg {\n  width: 1.5rem;\n  height: 1.5rem;\n  margin-right: 8px;\n}\n.book-carousel-item__title-info svg[data-role=type] {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n  padding: 1px;\n  border-radius: 100%;\n}";
styleInject(css_248z$r);

var CEFRIcon = function (_a) {
    var lvl = _a.lvl;
    switch (lvl) {
        case exports.CEFRLevels.A11:
            return React__default["default"].createElement(SvgA11, null);
        case exports.CEFRLevels.A12:
            return React__default["default"].createElement(SvgA12, null);
        case exports.CEFRLevels.A13:
            return React__default["default"].createElement(SvgA13, null);
        case exports.CEFRLevels.A21:
            return React__default["default"].createElement(SvgA21, null);
        case exports.CEFRLevels.A22:
            return React__default["default"].createElement(SvgA22, null);
        case exports.CEFRLevels.A23:
            return React__default["default"].createElement(SvgA23, null);
        case exports.CEFRLevels.B11:
            return React__default["default"].createElement(SvgB11, null);
        case exports.CEFRLevels.B12:
            return React__default["default"].createElement(SvgB12, null);
        case exports.CEFRLevels.B13:
            return React__default["default"].createElement(SvgB13, null);
        case exports.CEFRLevels.B21:
            return React__default["default"].createElement(SvgB21, null);
        case exports.CEFRLevels.B22:
            return React__default["default"].createElement(SvgB22, null);
        case exports.CEFRLevels.B23:
            return React__default["default"].createElement(SvgB23, null);
        case exports.CEFRLevels.C1plus:
            return React__default["default"].createElement(SvgC1, null);
        default:
            return null;
    }
};
var PLACEHOLDER_IMAGES = [Doodle1, Doodle2, Doodle3];
var BookCarouselItem = function (_a) {
    var book = _a.book, progress = _a.progress, onClick = _a.onClick, displayTypeIcon = _a.displayTypeIcon;
    var insideShadow = 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 41%, rgba(0, 0, 0, 0.6) 108%)';
    var imageUrl = book.imageUrl || PLACEHOLDER_IMAGES[Math.floor(Math.random() * PLACEHOLDER_IMAGES.length)];
    var isBookReadingOrMix = book.bookType === exports.BookType.Reading || book.bookType === exports.BookType.Mix;
    var isBookListeningOrMix = book.bookType === exports.BookType.Listening || book.bookType === exports.BookType.Mix;
    return (React__default["default"].createElement("div", { className: "book-carousel-item", "data-testid": "BookCarouselItem", onClick: function () { return onClick(book._id, book.title, book.bookType); } },
        React__default["default"].createElement("div", { className: "book-carousel-item__cover", style: { backgroundImage: "".concat(insideShadow, ", url(").concat(imageUrl, ")") } },
            React__default["default"].createElement("div", { className: "book-carousel-item__status" },
                React__default["default"].createElement("div", { className: "book-carousel-item__status--left" },
                    (progress === null || progress === void 0 ? void 0 : progress.index) !== undefined && !progress.isCompleted && isBookReadingOrMix && (React__default["default"].createElement("span", { className: "book-carousel-item__badge--jumpBack" }, "Jump back in")),
                    isBookReadingOrMix && (progress === null || progress === void 0 ? void 0 : progress.isCompleted) && (React__default["default"].createElement("span", { className: "book-carousel-item__badge--read" }, "\u2714 Read")),
                    isBookListeningOrMix && (progress === null || progress === void 0 ? void 0 : progress.isCompletedListening) && (React__default["default"].createElement("span", { className: "book-carousel-item__badge--read" }, "\u2714 Listened")),
                    book.recommended && React__default["default"].createElement("span", { className: "book-carousel-item__badge--recommended" }, "Recommended")),
                React__default["default"].createElement("div", { className: "book-carousel-item__status--right" },
                    React__default["default"].createElement("span", { className: "book-carousel-item__badge--stars" },
                        React__default["default"].createElement(SvgStar, null),
                        book.totalPoints)))),
        React__default["default"].createElement("div", { className: "book-carousel-item__title" },
            React__default["default"].createElement("div", { className: "book-carousel-item__title-info" },
                book.cefrLevel && React__default["default"].createElement(CEFRIcon, { lvl: book.cefrLevel }),
                displayTypeIcon && isBookReadingOrMix && React__default["default"].createElement(SvgReadingExercise, { "data-role": "type" }),
                displayTypeIcon && isBookListeningOrMix && React__default["default"].createElement(SvgListeningExercise, { "data-role": "type" })),
            React__default["default"].createElement("span", { className: "book-carousel-item__title-text" }, book.title))));
};

var css_248z$q = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.slick-track {\n  padding: 8px 0 11px 0;\n}\n.book-carousel {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: 0.5rem 0;\n}\n.book-carousel__padding {\n  padding: 10px 0;\n}\n.book-carousel__loading {\n  height: 240px !important;\n  width: auto !important;\n  display: flex !important;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin: 0 0.5rem;\n  padding: 0.5rem;\n  border-radius: 10px;\n  outline: none;\n}\n.book-carousel__loading > div:first-of-type {\n  height: 27px;\n  width: 50px;\n  border-radius: 10px;\n  background-color: white;\n  animation: small-pulse 500ms linear infinite;\n}\n.book-carousel__loading > div:last-of-type {\n  height: 24px;\n  width: 50%;\n  border-radius: 10px;\n  background-color: white;\n  animation: small-pulse 500ms linear infinite;\n}\n.book-carousel:hover button {\n  display: block;\n}\n@media (max-width: 600px) {\n  .book-carousel:hover button {\n    display: none;\n  }\n}\n.book-carousel > button {\n  position: absolute;\n  display: none;\n  background: none;\n  width: 35px;\n  padding: 0;\n  z-index: 10;\n  top: 50%;\n  transform: translate(0, -50%);\n}\n.book-carousel > button svg {\n  width: 45px;\n  height: 45px;\n  fill: #001593;\n}\n.book-carousel > button[class=right] {\n  right: -35px;\n}\n.book-carousel > button[class=left] {\n  left: -35px;\n}\n.book-carousel > button[class=left] > svg {\n  transform: rotate(180deg);\n}\n.book-carousel__fixer {\n  min-height: 0;\n  min-width: 0;\n}\n@keyframes small-pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.04);\n  }\n}";
styleInject(css_248z$q);

var loadingItems = function () {
    var items = [];
    for (var i = 0; i < 4; i++) {
        items.push(React__default["default"].createElement(SkeletonLoader, { key: "loading".concat(i), className: "book-carousel__loading", display: true },
            React__default["default"].createElement("div", null),
            React__default["default"].createElement("div", null)));
    }
    return items;
};
var BookCarousel = function (_a) {
    var books = _a.books, onItemClick = _a.onItemClick, loading = _a.loading, booksProgress = _a.booksProgress, displayTypeIcon = _a.displayTypeIcon;
    var slider = React.createRef();
    var settings = {
        infinite: books.length > 4,
        slidesToShow: 4,
        slidesToScroll: 4,
        speed: 500,
        nextArrow: undefined,
        prevArrow: undefined,
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    var mapBooksToCarouselItems = React.useCallback(function (books_) {
        return books_.map(function (book) {
            var progress = booksProgress ? booksProgress.find(function (prog) { return prog.bookId === book._id; }) : undefined;
            return (React__default["default"].createElement(BookCarouselItem, { key: book._id, book: book, progress: progress, onClick: onItemClick, displayTypeIcon: displayTypeIcon }));
        });
    }, [booksProgress]);
    var booksToRender = React.useMemo(function () {
        return mapBooksToCarouselItems(books);
    }, [books, booksProgress]);
    React.useEffect(function () {
        if (booksToRender.length > 0 && slider.current) {
            var recommendedBookIndex = books.findIndex(function (b) { return b.recommended; });
            if (recommendedBookIndex !== -1) {
                slider.current.slickGoTo(recommendedBookIndex, true);
            }
        }
    }, [booksToRender]);
    return (React__default["default"].createElement("div", { className: "book-carousel", "data-testid": "BookCarousel" },
        React__default["default"].createElement("button", { onClick: function () { var _a; return (_a = slider.current) === null || _a === void 0 ? void 0 : _a.slickPrev(); }, className: "left" },
            React__default["default"].createElement(SvgChevronRight, null)),
        React__default["default"].createElement(Slider, __assign$1({}, settings, { ref: slider, className: "book-carousel__fixer" }), loading ? loadingItems() : booksToRender),
        React__default["default"].createElement("button", { onClick: function () { var _a; return (_a = slider.current) === null || _a === void 0 ? void 0 : _a.slickNext(); }, className: "right" },
            React__default["default"].createElement(SvgChevronRight, null))));
};

var css_248z$p = ".circular-progress {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.circular-progress__children {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}";
styleInject(css_248z$p);

var CircularProgressBar = /** @class */ (function (_super) {
    __extends(CircularProgressBar, _super);
    function CircularProgressBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            progress: 0
        };
        _this.setupInterval = function () {
            return setInterval(function () {
                _this.setState(function (_a) {
                    var progress = _a.progress;
                    var newProgress = progress + 1;
                    var _b = _this.props, percentage = _b.percentage, onAnimationEnd = _b.onAnimationEnd, justForShow = _b.justForShow;
                    percentage = percentage > 100 ? 100 : percentage;
                    if (percentage === 0) {
                        _this.stopInterval();
                        if (onAnimationEnd)
                            onAnimationEnd();
                        return { progress: 0 };
                    }
                    if (justForShow) {
                        if (newProgress < percentage) {
                            return { progress: newProgress };
                        }
                        else {
                            _this.stopInterval();
                            if (onAnimationEnd)
                                onAnimationEnd();
                            return { progress: percentage };
                        }
                    }
                    if (progress > percentage) {
                        return newProgress === 100 ? { progress: 0 } : { progress: newProgress };
                    }
                    else if (newProgress < percentage) {
                        return { progress: newProgress };
                    }
                    else {
                        _this.stopInterval();
                        if (onAnimationEnd)
                            onAnimationEnd();
                        return { progress: percentage };
                    }
                });
            }, 20);
        };
        _this.stopInterval = function () { return clearInterval(_this.circularProgressInterval); };
        return _this;
    }
    CircularProgressBar.prototype.componentDidMount = function () {
        this.setupInterval();
    };
    CircularProgressBar.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.percentage !== prevProps.percentage) {
            this.setupInterval();
        }
    };
    CircularProgressBar.prototype.componentWillUnmount = function () {
        clearInterval(this.circularProgressInterval);
    };
    CircularProgressBar.prototype.render = function () {
        var _a = this.props, size = _a.size, showPercentage = _a.showPercentage, _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 20 : _b, _c = _a.progressColor, progressColor = _c === void 0 ? 'black' : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? '#ddd' : _d, children = _a.children;
        var progress = this.state.progress;
        var radius = (size - strokeWidth) / 2;
        var viewBox = "0 0 ".concat(size, " ").concat(size);
        var dashArray = radius * Math.PI * 2; // Arc length at 100% coverage is the circle circumference
        var dashOffset = dashArray - (dashArray * progress) / 100; // Scale 100% coverage overlay with the actual percent
        return (React__default["default"].createElement("div", { className: "circular-progress" },
            React__default["default"].createElement("svg", { width: size, height: size, viewBox: viewBox },
                React__default["default"].createElement("circle", { cx: size / 2, cy: size / 2, r: radius, style: {
                        fill: 'none',
                        stroke: backgroundColor,
                        strokeWidth: "".concat(strokeWidth, "px")
                    } }),
                React__default["default"].createElement("circle", { cx: size / 2, cy: size / 2, r: radius, transform: "rotate(-90 ".concat(size / 2, " ").concat(size / 2, ")"), style: {
                        fill: 'none',
                        stroke: progressColor,
                        strokeWidth: "".concat(strokeWidth, "px"),
                        strokeDasharray: dashArray.toFixed(2),
                        strokeDashoffset: dashOffset.toFixed(2),
                        strokeLinecap: progress === 100 ? 'butt' : 'round'
                    } }),
                showPercentage && !children && (React__default["default"].createElement("text", { className: "circle__text", x: "50%", y: "50%", dy: ".3em", textAnchor: "middle" }, "".concat(progress, "%")))),
            React__default["default"].createElement("div", { className: "circular-progress__children" }, children)));
    };
    return CircularProgressBar;
}(React__default["default"].Component));

var countdownInterval;
var Countdown = function (_a) {
    var seconds = _a.seconds, className = _a.className, restartCountdown = _a.restartCountdown, delayCountdown = _a.delayCountdown, children = _a.children;
    var _b = React.useState(seconds), count = _b[0], setCount = _b[1];
    var start = function () {
        setCount(seconds);
        setTimeout(function () {
            countdownInterval = setInterval(function () {
                setCount(function (prevCount) {
                    var newCount = prevCount - 1;
                    if (newCount <= 0) {
                        clearInterval(countdownInterval);
                        return 0;
                    }
                    else {
                        return newCount;
                    }
                });
            }, 1000);
        }, delayCountdown ? delayCountdown : 0);
    };
    React.useEffect(start, [restartCountdown]);
    React.useEffect(function () {
        return clearInterval(countdownInterval);
    }, []);
    if (count > 0) {
        return (React__default["default"].createElement(Typography, { className: className, variant: "exerciseXL" }, count));
    }
    else
        return React__default["default"].createElement(React__default["default"].Fragment, null, children);
};

function _extends$y() {
  _extends$y = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$y.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const is$1 = {
  arr: Array.isArray,
  obj: a => Object.prototype.toString.call(a) === '[object Object]',
  fun: a => typeof a === 'function',
  str: a => typeof a === 'string',
  num: a => typeof a === 'number',
  und: a => a === void 0,
  nul: a => a === null,
  set: a => a instanceof Set,
  map: a => a instanceof Map,

  equ(a, b) {
    if (typeof a !== typeof b) return false;
    if (is$1.str(a) || is$1.num(a)) return a === b;
    if (is$1.obj(a) && is$1.obj(b) && Object.keys(a).length + Object.keys(b).length === 0) return true;
    let i;

    for (i in a) if (!(i in b)) return false;

    for (i in b) if (a[i] !== b[i]) return false;

    return is$1.und(i) ? a === b : true;
  }

};
function merge(target, lowercase) {
  if (lowercase === void 0) {
    lowercase = true;
  }

  return object => (is$1.arr(object) ? object : Object.keys(object)).reduce((acc, element) => {
    const key = lowercase ? element[0].toLowerCase() + element.substring(1) : element;
    acc[key] = target(key);
    return acc;
  }, target);
}
function useForceUpdate() {
  const _useState = React.useState(false),
        f = _useState[1];

  const forceUpdate = React.useCallback(() => f(v => !v), []);
  return forceUpdate;
}
function withDefault(value, defaultValue) {
  return is$1.und(value) || is$1.nul(value) ? defaultValue : value;
}
function toArray$1(a) {
  return !is$1.und(a) ? is$1.arr(a) ? a : [a] : [];
}
function callProp(obj) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return is$1.fun(obj) ? obj(...args) : obj;
}

function getForwardProps(props) {
  props.to;
        props.from;
        props.config;
        props.onStart;
        props.onRest;
        props.onFrame;
        props.children;
        props.reset;
        props.reverse;
        props.force;
        props.immediate;
        props.delay;
        props.attach;
        props.destroyed;
        props.interpolateTo;
        props.ref;
        props.lazy;
        const forward = _objectWithoutPropertiesLoose$3(props, ["to", "from", "config", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "delay", "attach", "destroyed", "interpolateTo", "ref", "lazy"]);

  return forward;
}

function interpolateTo(props) {
  const forward = getForwardProps(props);
  if (is$1.und(forward)) return _extends$y({
    to: forward
  }, props);
  const rest = Object.keys(props).reduce((a, k) => !is$1.und(forward[k]) ? a : _extends$y({}, a, {
    [k]: props[k]
  }), {});
  return _extends$y({
    to: forward
  }, rest);
}
function handleRef(ref, forward) {
  if (forward) {
    // If it's a function, assume it's a ref callback
    if (is$1.fun(forward)) forward(ref);else if (is$1.obj(forward)) {
      forward.current = ref;
    }
  }

  return ref;
}

class Animated {
  constructor() {
    this.payload = void 0;
    this.children = [];
  }

  getAnimatedValue() {
    return this.getValue();
  }

  getPayload() {
    return this.payload || this;
  }

  attach() {}

  detach() {}

  getChildren() {
    return this.children;
  }

  addChild(child) {
    if (this.children.length === 0) this.attach();
    this.children.push(child);
  }

  removeChild(child) {
    const index = this.children.indexOf(child);
    this.children.splice(index, 1);
    if (this.children.length === 0) this.detach();
  }

}
class AnimatedArray extends Animated {
  constructor() {
    super(...arguments);
    this.payload = [];

    this.attach = () => this.payload.forEach(p => p instanceof Animated && p.addChild(this));

    this.detach = () => this.payload.forEach(p => p instanceof Animated && p.removeChild(this));
  }

}
class AnimatedObject extends Animated {
  constructor() {
    super(...arguments);
    this.payload = {};

    this.attach = () => Object.values(this.payload).forEach(s => s instanceof Animated && s.addChild(this));

    this.detach = () => Object.values(this.payload).forEach(s => s instanceof Animated && s.removeChild(this));
  }

  getValue(animated) {
    if (animated === void 0) {
      animated = false;
    }

    const payload = {};

    for (const key in this.payload) {
      const value = this.payload[key];
      if (animated && !(value instanceof Animated)) continue;
      payload[key] = value instanceof Animated ? value[animated ? 'getAnimatedValue' : 'getValue']() : value;
    }

    return payload;
  }

  getAnimatedValue() {
    return this.getValue(true);
  }

}

let applyAnimatedValues;
function injectApplyAnimatedValues(fn, transform) {
  applyAnimatedValues = {
    fn,
    transform
  };
}
let colorNames;
function injectColorNames(names) {
  colorNames = names;
}
let requestFrame = cb => typeof window !== 'undefined' ? window.requestAnimationFrame(cb) : -1;
let interpolation;
function injectStringInterpolator(fn) {
  interpolation = fn;
}
let now = () => Date.now();
let animatedApi = node => node.current;
let createAnimatedStyle;
function injectCreateAnimatedStyle(factory) {
  createAnimatedStyle = factory;
}

/**
 * Wraps the `style` property with `AnimatedStyle`.
 */

class AnimatedProps extends AnimatedObject {
  constructor(props, callback) {
    super();
    this.update = void 0;
    this.payload = !props.style ? props : _extends$y({}, props, {
      style: createAnimatedStyle(props.style)
    });
    this.update = callback;
    this.attach();
  }

}

const isFunctionComponent = val => is$1.fun(val) && !(val.prototype instanceof React__default["default"].Component);

const createAnimatedComponent = Component => {
  const AnimatedComponent = React.forwardRef((props, ref) => {
    const forceUpdate = useForceUpdate();
    const mounted = React.useRef(true);
    const propsAnimated = React.useRef(null);
    const node = React.useRef(null);
    const attachProps = React.useCallback(props => {
      const oldPropsAnimated = propsAnimated.current;

      const callback = () => {
        let didUpdate = false;

        if (node.current) {
          didUpdate = applyAnimatedValues.fn(node.current, propsAnimated.current.getAnimatedValue());
        }

        if (!node.current || didUpdate === false) {
          // If no referenced node has been found, or the update target didn't have a
          // native-responder, then forceUpdate the animation ...
          forceUpdate();
        }
      };

      propsAnimated.current = new AnimatedProps(props, callback);
      oldPropsAnimated && oldPropsAnimated.detach();
    }, []);
    React.useEffect(() => () => {
      mounted.current = false;
      propsAnimated.current && propsAnimated.current.detach();
    }, []);
    React.useImperativeHandle(ref, () => animatedApi(node));
    attachProps(props);

    const _getValue = propsAnimated.current.getValue();
          _getValue.scrollTop;
          _getValue.scrollLeft;
          const animatedProps = _objectWithoutPropertiesLoose$3(_getValue, ["scrollTop", "scrollLeft"]); // Functions cannot have refs, see:
    // See: https://github.com/react-spring/react-spring/issues/569


    const refFn = isFunctionComponent(Component) ? undefined : childRef => node.current = handleRef(childRef, ref);
    return React__default["default"].createElement(Component, _extends$y({}, animatedProps, {
      ref: refFn
    }));
  });
  return AnimatedComponent;
};

let active = false;
const controllers = new Set();

const update$1 = () => {
  if (!active) return false;
  let time = now();

  for (let controller of controllers) {
    let isActive = false;

    for (let configIdx = 0; configIdx < controller.configs.length; configIdx++) {
      let config = controller.configs[configIdx];
      let endOfAnimation, lastTime;

      for (let valIdx = 0; valIdx < config.animatedValues.length; valIdx++) {
        let animation = config.animatedValues[valIdx]; // If an animation is done, skip, until all of them conclude

        if (animation.done) continue;
        let from = config.fromValues[valIdx];
        let to = config.toValues[valIdx];
        let position = animation.lastPosition;
        let isAnimated = to instanceof Animated;
        let velocity = Array.isArray(config.initialVelocity) ? config.initialVelocity[valIdx] : config.initialVelocity;
        if (isAnimated) to = to.getValue(); // Conclude animation if it's either immediate, or from-values match end-state

        if (config.immediate) {
          animation.setValue(to);
          animation.done = true;
          continue;
        } // Break animation when string values are involved


        if (typeof from === 'string' || typeof to === 'string') {
          animation.setValue(to);
          animation.done = true;
          continue;
        }

        if (config.duration !== void 0) {
          /** Duration easing */
          position = from + config.easing((time - animation.startTime) / config.duration) * (to - from);
          endOfAnimation = time >= animation.startTime + config.duration;
        } else if (config.decay) {
          /** Decay easing */
          position = from + velocity / (1 - 0.998) * (1 - Math.exp(-(1 - 0.998) * (time - animation.startTime)));
          endOfAnimation = Math.abs(animation.lastPosition - position) < 0.1;
          if (endOfAnimation) to = position;
        } else {
          /** Spring easing */
          lastTime = animation.lastTime !== void 0 ? animation.lastTime : time;
          velocity = animation.lastVelocity !== void 0 ? animation.lastVelocity : config.initialVelocity; // If we lost a lot of frames just jump to the end.

          if (time > lastTime + 64) lastTime = time; // http://gafferongames.com/game-physics/fix-your-timestep/

          let numSteps = Math.floor(time - lastTime);

          for (let i = 0; i < numSteps; ++i) {
            let force = -config.tension * (position - to);
            let damping = -config.friction * velocity;
            let acceleration = (force + damping) / config.mass;
            velocity = velocity + acceleration * 1 / 1000;
            position = position + velocity * 1 / 1000;
          } // Conditions for stopping the spring animation


          let isOvershooting = config.clamp && config.tension !== 0 ? from < to ? position > to : position < to : false;
          let isVelocity = Math.abs(velocity) <= config.precision;
          let isDisplacement = config.tension !== 0 ? Math.abs(to - position) <= config.precision : true;
          endOfAnimation = isOvershooting || isVelocity && isDisplacement;
          animation.lastVelocity = velocity;
          animation.lastTime = time;
        } // Trails aren't done until their parents conclude


        if (isAnimated && !config.toValues[valIdx].done) endOfAnimation = false;

        if (endOfAnimation) {
          // Ensure that we end up with a round value
          if (animation.value !== to) position = to;
          animation.done = true;
        } else isActive = true;

        animation.setValue(position);
        animation.lastPosition = position;
      } // Keep track of updated values only when necessary


      if (controller.props.onFrame) controller.values[config.name] = config.interpolation.getValue();
    } // Update callbacks in the end of the frame


    if (controller.props.onFrame) controller.props.onFrame(controller.values); // Either call onEnd or next frame

    if (!isActive) {
      controllers.delete(controller);
      controller.stop(true);
    }
  } // Loop over as long as there are controllers ...


  if (controllers.size) {
    requestFrame(update$1);
  } else {
    active = false;
  }

  return active;
};

const start$1 = controller => {
  if (!controllers.has(controller)) controllers.add(controller);

  if (!active) {
    active = true;
    requestFrame(update$1);
  }
};

const stop = controller => {
  if (controllers.has(controller)) controllers.delete(controller);
};

function createInterpolator(range, output, extrapolate) {
  if (typeof range === 'function') {
    return range;
  }

  if (Array.isArray(range)) {
    return createInterpolator({
      range,
      output: output,
      extrapolate
    });
  }

  if (interpolation && typeof range.output[0] === 'string') {
    return interpolation(range);
  }

  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
  const extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';

  const easing = config.easing || (t => t);

  return input => {
    const range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
}

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input; // Extrapolate

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
  }

  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax; // Input Range

  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin); // Easing

  result = easing(result); // Output Range

  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;

  return i - 1;
}

class AnimatedInterpolation extends AnimatedArray {
  constructor(parents, range, output, extrapolate) {
    super();
    this.calc = void 0;
    this.payload = parents instanceof AnimatedArray && !(parents instanceof AnimatedInterpolation) ? parents.getPayload() : Array.isArray(parents) ? parents : [parents];
    this.calc = createInterpolator(range, output, extrapolate);
  }

  getValue() {
    return this.calc(...this.payload.map(value => value.getValue()));
  }

  updateConfig(range, output, extrapolate) {
    this.calc = createInterpolator(range, output, extrapolate);
  }

  interpolate(range, output, extrapolate) {
    return new AnimatedInterpolation(this, range, output, extrapolate);
  }

}

/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an AnimatedValue is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */
function addAnimatedStyles(node, styles) {
  if ('update' in node) {
    styles.add(node);
  } else {
    node.getChildren().forEach(child => addAnimatedStyles(child, styles));
  }
}

class AnimatedValue extends Animated {
  constructor(_value) {
    var _this;

    super();
    _this = this;
    this.animatedStyles = new Set();
    this.value = void 0;
    this.startPosition = void 0;
    this.lastPosition = void 0;
    this.lastVelocity = void 0;
    this.startTime = void 0;
    this.lastTime = void 0;
    this.done = false;

    this.setValue = function (value, flush) {
      if (flush === void 0) {
        flush = true;
      }

      _this.value = value;
      if (flush) _this.flush();
    };

    this.value = _value;
    this.startPosition = _value;
    this.lastPosition = _value;
  }

  flush() {
    if (this.animatedStyles.size === 0) {
      addAnimatedStyles(this, this.animatedStyles);
    }

    this.animatedStyles.forEach(animatedStyle => animatedStyle.update());
  }

  clearStyles() {
    this.animatedStyles.clear();
  }

  getValue() {
    return this.value;
  }

  interpolate(range, output, extrapolate) {
    return new AnimatedInterpolation(this, range, output, extrapolate);
  }

}

class AnimatedValueArray extends AnimatedArray {
  constructor(values) {
    super();
    this.payload = values.map(n => new AnimatedValue(n));
  }

  setValue(value, flush) {
    if (flush === void 0) {
      flush = true;
    }

    if (Array.isArray(value)) {
      if (value.length === this.payload.length) {
        value.forEach((v, i) => this.payload[i].setValue(v, flush));
      }
    } else {
      this.payload.forEach(p => p.setValue(value, flush));
    }
  }

  getValue() {
    return this.payload.map(v => v.getValue());
  }

  interpolate(range, output) {
    return new AnimatedInterpolation(this, range, output);
  }

}

let G = 0;

class Controller {
  constructor() {
    this.id = void 0;
    this.idle = true;
    this.hasChanged = false;
    this.guid = 0;
    this.local = 0;
    this.props = {};
    this.merged = {};
    this.animations = {};
    this.interpolations = {};
    this.values = {};
    this.configs = [];
    this.listeners = [];
    this.queue = [];
    this.localQueue = void 0;

    this.getValues = () => this.interpolations;

    this.id = G++;
  }
  /** update(props)
   *  This function filters input props and creates an array of tasks which are executed in .start()
   *  Each task is allowed to carry a delay, which means it can execute asnychroneously */


  update(args) {
    //this._id = n + this.id
    if (!args) return this; // Extract delay and the to-prop from props

    const _ref = interpolateTo(args),
          _ref$delay = _ref.delay,
          delay = _ref$delay === void 0 ? 0 : _ref$delay,
          to = _ref.to,
          props = _objectWithoutPropertiesLoose$3(_ref, ["delay", "to"]);

    if (is$1.arr(to) || is$1.fun(to)) {
      // If config is either a function or an array queue it up as is
      this.queue.push(_extends$y({}, props, {
        delay,
        to
      }));
    } else if (to) {
      // Otherwise go through each key since it could be delayed individually
      let ops = {};
      Object.entries(to).forEach((_ref2) => {
        let k = _ref2[0],
            v = _ref2[1];

        // Fetch delay and create an entry, consisting of the to-props, the delay, and basic props
        const entry = _extends$y({
          to: {
            [k]: v
          },
          delay: callProp(delay, k)
        }, props);

        const previous = ops[entry.delay] && ops[entry.delay].to;
        ops[entry.delay] = _extends$y({}, ops[entry.delay], entry, {
          to: _extends$y({}, previous, entry.to)
        });
      });
      this.queue = Object.values(ops);
    } // Sort queue, so that async calls go last


    this.queue = this.queue.sort((a, b) => a.delay - b.delay); // Diff the reduced props immediately (they'll contain the from-prop and some config)

    this.diff(props);
    return this;
  }
  /** start(onEnd)
   *  This function either executes a queue, if present, or starts the frameloop, which animates */


  start(onEnd) {
    // If a queue is present we must excecute it
    if (this.queue.length) {
      this.idle = false; // Updates can interrupt trailing queues, in that case we just merge values

      if (this.localQueue) {
        this.localQueue.forEach((_ref3) => {
          let _ref3$from = _ref3.from,
              from = _ref3$from === void 0 ? {} : _ref3$from,
              _ref3$to = _ref3.to,
              to = _ref3$to === void 0 ? {} : _ref3$to;
          if (is$1.obj(from)) this.merged = _extends$y({}, from, this.merged);
          if (is$1.obj(to)) this.merged = _extends$y({}, this.merged, to);
        });
      } // The guid helps us tracking frames, a new queue over an old one means an override
      // We discard async calls in that caseÍ


      const local = this.local = ++this.guid;
      const queue = this.localQueue = this.queue;
      this.queue = []; // Go through each entry and execute it

      queue.forEach((_ref4, index) => {
        let delay = _ref4.delay,
            props = _objectWithoutPropertiesLoose$3(_ref4, ["delay"]);

        const cb = finished => {
          if (index === queue.length - 1 && local === this.guid && finished) {
            this.idle = true;
            if (this.props.onRest) this.props.onRest(this.merged);
          }

          if (onEnd) onEnd();
        }; // Entries can be delayed, ansyc or immediate


        let async = is$1.arr(props.to) || is$1.fun(props.to);

        if (delay) {
          setTimeout(() => {
            if (local === this.guid) {
              if (async) this.runAsync(props, cb);else this.diff(props).start(cb);
            }
          }, delay);
        } else if (async) this.runAsync(props, cb);else this.diff(props).start(cb);
      });
    } // Otherwise we kick of the frameloop
    else {
        if (is$1.fun(onEnd)) this.listeners.push(onEnd);
        if (this.props.onStart) this.props.onStart();
        start$1(this);
      }

    return this;
  }

  stop(finished) {
    this.listeners.forEach(onEnd => onEnd(finished));
    this.listeners = [];
    return this;
  }
  /** Pause sets onEnd listeners free, but also removes the controller from the frameloop */


  pause(finished) {
    this.stop(true);
    if (finished) stop(this);
    return this;
  }

  runAsync(_ref5, onEnd) {
    var _this = this;

    _ref5.delay;
        let props = _objectWithoutPropertiesLoose$3(_ref5, ["delay"]);

    const local = this.local; // If "to" is either a function or an array it will be processed async, therefor "to" should be empty right now
    // If the view relies on certain values "from" has to be present

    let queue = Promise.resolve(undefined);

    if (is$1.arr(props.to)) {
      for (let i = 0; i < props.to.length; i++) {
        const index = i;

        const fresh = _extends$y({}, props, interpolateTo(props.to[index]));

        if (is$1.arr(fresh.config)) fresh.config = fresh.config[index];
        queue = queue.then(() => {
          //this.stop()
          if (local === this.guid) return new Promise(r => this.diff(fresh).start(r));
        });
      }
    } else if (is$1.fun(props.to)) {
      let index = 0;
      let last;
      queue = queue.then(() => props.to( // next(props)
      p => {
        const fresh = _extends$y({}, props, interpolateTo(p));

        if (is$1.arr(fresh.config)) fresh.config = fresh.config[index];
        index++; //this.stop()

        if (local === this.guid) return last = new Promise(r => this.diff(fresh).start(r));
        return;
      }, // cancel()
      function (finished) {
        if (finished === void 0) {
          finished = true;
        }

        return _this.stop(finished);
      }).then(() => last));
    }

    queue.then(onEnd);
  }

  diff(props) {
    this.props = _extends$y({}, this.props, props);
    let _this$props = this.props,
        _this$props$from = _this$props.from,
        from = _this$props$from === void 0 ? {} : _this$props$from,
        _this$props$to = _this$props.to,
        to = _this$props$to === void 0 ? {} : _this$props$to,
        _this$props$config = _this$props.config,
        config = _this$props$config === void 0 ? {} : _this$props$config,
        reverse = _this$props.reverse,
        attach = _this$props.attach,
        reset = _this$props.reset,
        immediate = _this$props.immediate; // Reverse values when requested

    if (reverse) {
      var _ref6 = [to, from];
      from = _ref6[0];
      to = _ref6[1];
    } // This will collect all props that were ever set, reset merged props when necessary


    this.merged = _extends$y({}, from, this.merged, to);
    this.hasChanged = false; // Attachment handling, trailed springs can "attach" themselves to a previous spring

    let target = attach && attach(this); // Reduces input { name: value } pairs into animated values

    this.animations = Object.entries(this.merged).reduce((acc, _ref7) => {
      let name = _ref7[0],
          value = _ref7[1];
      // Issue cached entries, except on reset
      let entry = acc[name] || {}; // Figure out what the value is supposed to be

      const isNumber = is$1.num(value);
      const isString = is$1.str(value) && !value.startsWith('#') && !/\d/.test(value) && !colorNames[value];
      const isArray = is$1.arr(value);
      const isInterpolation = !isNumber && !isArray && !isString;
      let fromValue = !is$1.und(from[name]) ? from[name] : value;
      let toValue = isNumber || isArray ? value : isString ? value : 1;
      let toConfig = callProp(config, name);
      if (target) toValue = target.animations[name].parent;
      let parent = entry.parent,
          interpolation$$1 = entry.interpolation,
          toValues = toArray$1(target ? toValue.getPayload() : toValue),
          animatedValues;
      let newValue = value;
      if (isInterpolation) newValue = interpolation({
        range: [0, 1],
        output: [value, value]
      })(1);
      let currentValue = interpolation$$1 && interpolation$$1.getValue(); // Change detection flags

      const isFirst = is$1.und(parent);
      const isActive = !isFirst && entry.animatedValues.some(v => !v.done);
      const currentValueDiffersFromGoal = !is$1.equ(newValue, currentValue);
      const hasNewGoal = !is$1.equ(newValue, entry.previous);
      const hasNewConfig = !is$1.equ(toConfig, entry.config); // Change animation props when props indicate a new goal (new value differs from previous one)
      // and current values differ from it. Config changes trigger a new update as well (though probably shouldn't?)

      if (reset || hasNewGoal && currentValueDiffersFromGoal || hasNewConfig) {
        // Convert regular values into animated values, ALWAYS re-use if possible
        if (isNumber || isString) parent = interpolation$$1 = entry.parent || new AnimatedValue(fromValue);else if (isArray) parent = interpolation$$1 = entry.parent || new AnimatedValueArray(fromValue);else if (isInterpolation) {
          let prev = entry.interpolation && entry.interpolation.calc(entry.parent.value);
          prev = prev !== void 0 && !reset ? prev : fromValue;

          if (entry.parent) {
            parent = entry.parent;
            parent.setValue(0, false);
          } else parent = new AnimatedValue(0);

          const range = {
            output: [prev, value]
          };

          if (entry.interpolation) {
            interpolation$$1 = entry.interpolation;
            entry.interpolation.updateConfig(range);
          } else interpolation$$1 = parent.interpolate(range);
        }
        toValues = toArray$1(target ? toValue.getPayload() : toValue);
        animatedValues = toArray$1(parent.getPayload());
        if (reset && !isInterpolation) parent.setValue(fromValue, false);
        this.hasChanged = true; // Reset animated values

        animatedValues.forEach(value => {
          value.startPosition = value.value;
          value.lastPosition = value.value;
          value.lastVelocity = isActive ? value.lastVelocity : undefined;
          value.lastTime = isActive ? value.lastTime : undefined;
          value.startTime = now();
          value.done = false;
          value.animatedStyles.clear();
        }); // Set immediate values

        if (callProp(immediate, name)) {
          parent.setValue(isInterpolation ? toValue : value, false);
        }

        return _extends$y({}, acc, {
          [name]: _extends$y({}, entry, {
            name,
            parent,
            interpolation: interpolation$$1,
            animatedValues,
            toValues,
            previous: newValue,
            config: toConfig,
            fromValues: toArray$1(parent.getValue()),
            immediate: callProp(immediate, name),
            initialVelocity: withDefault(toConfig.velocity, 0),
            clamp: withDefault(toConfig.clamp, false),
            precision: withDefault(toConfig.precision, 0.01),
            tension: withDefault(toConfig.tension, 170),
            friction: withDefault(toConfig.friction, 26),
            mass: withDefault(toConfig.mass, 1),
            duration: toConfig.duration,
            easing: withDefault(toConfig.easing, t => t),
            decay: toConfig.decay
          })
        });
      } else {
        if (!currentValueDiffersFromGoal) {
          // So ... the current target value (newValue) appears to be different from the previous value,
          // which normally constitutes an update, but the actual value (currentValue) matches the target!
          // In order to resolve this without causing an animation update we silently flag the animation as done,
          // which it technically is. Interpolations also needs a config update with their target set to 1.
          if (isInterpolation) {
            parent.setValue(1, false);
            interpolation$$1.updateConfig({
              output: [newValue, newValue]
            });
          }

          parent.done = true;
          this.hasChanged = true;
          return _extends$y({}, acc, {
            [name]: _extends$y({}, acc[name], {
              previous: newValue
            })
          });
        }

        return acc;
      }
    }, this.animations);

    if (this.hasChanged) {
      // Make animations available to frameloop
      this.configs = Object.values(this.animations);
      this.values = {};
      this.interpolations = {};

      for (let key in this.animations) {
        this.interpolations[key] = this.animations[key].interpolation;
        this.values[key] = this.animations[key].interpolation.getValue();
      }
    }

    return this;
  }

  destroy() {
    this.stop();
    this.props = {};
    this.merged = {};
    this.animations = {};
    this.interpolations = {};
    this.values = {};
    this.configs = [];
    this.local = 0;
  }

}

/** API
 * const props = useSprings(number, [{ ... }, { ... }, ...])
 * const [props, set] = useSprings(number, (i, controller) => ({ ... }))
 */

const useSprings = (length, props) => {
  const mounted = React.useRef(false);
  const ctrl = React.useRef();
  const isFn = is$1.fun(props); // The controller maintains the animation values, starts and stops animations

  const _useMemo = React.useMemo(() => {
    // Remove old controllers
    if (ctrl.current) {
      ctrl.current.map(c => c.destroy());
      ctrl.current = undefined;
    }

    let ref;
    return [new Array(length).fill().map((_, i) => {
      const ctrl = new Controller();
      const newProps = isFn ? callProp(props, i, ctrl) : props[i];
      if (i === 0) ref = newProps.ref;
      ctrl.update(newProps);
      if (!ref) ctrl.start();
      return ctrl;
    }), ref];
  }, [length]),
        controllers = _useMemo[0],
        ref = _useMemo[1];

  ctrl.current = controllers; // The hooks reference api gets defined here ...

  React.useImperativeHandle(ref, () => ({
    start: () => Promise.all(ctrl.current.map(c => new Promise(r => c.start(r)))),
    stop: finished => ctrl.current.forEach(c => c.stop(finished)),

    get controllers() {
      return ctrl.current;
    }

  })); // This function updates the controllers

  const updateCtrl = React.useMemo(() => updateProps => ctrl.current.map((c, i) => {
    c.update(isFn ? callProp(updateProps, i, c) : updateProps[i]);
    if (!ref) c.start();
  }), [length]); // Update controller if props aren't functional

  React.useEffect(() => {
    if (mounted.current) {
      if (!isFn) updateCtrl(props);
    } else if (!ref) ctrl.current.forEach(c => c.start());
  }); // Update mounted flag and destroy controller on unmount

  React.useEffect(() => (mounted.current = true, () => ctrl.current.forEach(c => c.destroy())), []); // Return animated props, or, anim-props + the update-setter above

  const propValues = ctrl.current.map(c => c.getValues());
  return isFn ? [propValues, updateCtrl, finished => ctrl.current.forEach(c => c.pause(finished))] : propValues;
};

/** API
 * const props = useSpring({ ... })
 * const [props, set] = useSpring(() => ({ ... }))
 */

const useSpring = props => {
  const isFn = is$1.fun(props);

  const _useSprings = useSprings(1, isFn ? props : [props]),
        result = _useSprings[0],
        set = _useSprings[1],
        pause = _useSprings[2];

  return isFn ? [result[0], set, pause] : result;
};

/** API
 * const transitions = useTransition(items, itemKeys, { ... })
 * const [transitions, update] = useTransition(items, itemKeys, () => ({ ... }))
 */

let guid = 0;
const ENTER = 'enter';
const LEAVE = 'leave';
const UPDATE = 'update';

const mapKeys = (items, keys) => (typeof keys === 'function' ? items.map(keys) : toArray$1(keys)).map(String);

const get = props => {
  let items = props.items,
      _props$keys = props.keys,
      keys = _props$keys === void 0 ? item => item : _props$keys,
      rest = _objectWithoutPropertiesLoose$3(props, ["items", "keys"]);

  items = toArray$1(items !== void 0 ? items : null);
  return _extends$y({
    items,
    keys: mapKeys(items, keys)
  }, rest);
};

function useTransition(input, keyTransform, config) {
  const props = _extends$y({
    items: input,
    keys: keyTransform || (i => i)
  }, config);

  const _get = get(props),
        _get$lazy = _get.lazy,
        lazy = _get$lazy === void 0 ? false : _get$lazy;
        _get.unique;
        const _get$reset = _get.reset,
        reset = _get$reset === void 0 ? false : _get$reset;
        _get.enter;
        _get.leave;
        _get.update;
        const onDestroyed = _get.onDestroyed;
        _get.keys;
        _get.items;
        const onFrame = _get.onFrame,
        _onRest = _get.onRest,
        onStart = _get.onStart,
        ref = _get.ref,
        extra = _objectWithoutPropertiesLoose$3(_get, ["lazy", "unique", "reset", "enter", "leave", "update", "onDestroyed", "keys", "items", "onFrame", "onRest", "onStart", "ref"]);

  const forceUpdate = useForceUpdate();
  const mounted = React.useRef(false);
  const state = React.useRef({
    mounted: false,
    first: true,
    deleted: [],
    current: {},
    transitions: [],
    prevProps: {},
    paused: !!props.ref,
    instances: !mounted.current && new Map(),
    forceUpdate
  });
  React.useImperativeHandle(props.ref, () => ({
    start: () => Promise.all(Array.from(state.current.instances).map((_ref) => {
      let c = _ref[1];
      return new Promise(r => c.start(r));
    })),
    stop: finished => Array.from(state.current.instances).forEach((_ref2) => {
      let c = _ref2[1];
      return c.stop(finished);
    }),

    get controllers() {
      return Array.from(state.current.instances).map((_ref3) => {
        let c = _ref3[1];
        return c;
      });
    }

  })); // Update state

  state.current = diffItems(state.current, props);

  if (state.current.changed) {
    // Update state
    state.current.transitions.forEach(transition => {
      const slot = transition.slot,
            from = transition.from,
            to = transition.to,
            config = transition.config,
            trail = transition.trail,
            key = transition.key,
            item = transition.item;
      if (!state.current.instances.has(key)) state.current.instances.set(key, new Controller()); // update the map object

      const ctrl = state.current.instances.get(key);

      const newProps = _extends$y({}, extra, {
        to,
        from,
        config,
        ref,
        onRest: values => {
          if (state.current.mounted) {
            if (transition.destroyed) {
              // If no ref is given delete destroyed items immediately
              if (!ref && !lazy) cleanUp(state, key);
              if (onDestroyed) onDestroyed(item);
            } // A transition comes to rest once all its springs conclude


            const curInstances = Array.from(state.current.instances);
            const active = curInstances.some((_ref4) => {
              let c = _ref4[1];
              return !c.idle;
            });
            if (!active && (ref || lazy) && state.current.deleted.length > 0) cleanUp(state);
            if (_onRest) _onRest(item, slot, values);
          }
        },
        onStart: onStart && (() => onStart(item, slot)),
        onFrame: onFrame && (values => onFrame(item, slot, values)),
        delay: trail,
        reset: reset && slot === ENTER // Update controller

      });

      ctrl.update(newProps);
      if (!state.current.paused) ctrl.start();
    });
  }

  React.useEffect(() => {
    state.current.mounted = mounted.current = true;
    return () => {
      state.current.mounted = mounted.current = false;
      Array.from(state.current.instances).map((_ref5) => {
        let c = _ref5[1];
        return c.destroy();
      });
      state.current.instances.clear();
    };
  }, []);
  return state.current.transitions.map((_ref6) => {
    let item = _ref6.item,
        slot = _ref6.slot,
        key = _ref6.key;
    return {
      item,
      key,
      state: slot,
      props: state.current.instances.get(key).getValues()
    };
  });
}

function cleanUp(state, filterKey) {
  const deleted = state.current.deleted;

  for (let _ref7 of deleted) {
    let key = _ref7.key;

    const filter = t => t.key !== key;

    if (is$1.und(filterKey) || filterKey === key) {
      state.current.instances.delete(key);
      state.current.transitions = state.current.transitions.filter(filter);
      state.current.deleted = state.current.deleted.filter(filter);
    }
  }

  state.current.forceUpdate();
}

function diffItems(_ref8, props) {
  let first = _ref8.first,
      prevProps = _ref8.prevProps,
      state = _objectWithoutPropertiesLoose$3(_ref8, ["first", "prevProps"]);

  let _get2 = get(props),
      items = _get2.items,
      keys = _get2.keys,
      initial = _get2.initial,
      from = _get2.from,
      enter = _get2.enter,
      leave = _get2.leave,
      update = _get2.update,
      _get2$trail = _get2.trail,
      trail = _get2$trail === void 0 ? 0 : _get2$trail,
      unique = _get2.unique,
      config = _get2.config,
      _get2$order = _get2.order,
      order = _get2$order === void 0 ? [ENTER, LEAVE, UPDATE] : _get2$order;

  let _get3 = get(prevProps),
      _keys = _get3.keys,
      _items = _get3.items;

  let current = _extends$y({}, state.current);

  let deleted = [...state.deleted]; // Compare next keys with current keys

  let currentKeys = Object.keys(current);
  let currentSet = new Set(currentKeys);
  let nextSet = new Set(keys);
  let added = keys.filter(item => !currentSet.has(item));
  let removed = state.transitions.filter(item => !item.destroyed && !nextSet.has(item.originalKey)).map(i => i.originalKey);
  let updated = keys.filter(item => currentSet.has(item));
  let delay = -trail;

  while (order.length) {
    const changeType = order.shift();

    switch (changeType) {
      case ENTER:
        {
          added.forEach((key, index) => {
            // In unique mode, remove fading out transitions if their key comes in again
            if (unique && deleted.find(d => d.originalKey === key)) deleted = deleted.filter(t => t.originalKey !== key);
            const keyIndex = keys.indexOf(key);
            const item = items[keyIndex];
            const slot = first && initial !== void 0 ? 'initial' : ENTER;
            current[key] = {
              slot,
              originalKey: key,
              key: unique ? String(key) : guid++,
              item,
              trail: delay = delay + trail,
              config: callProp(config, item, slot),
              from: callProp(first ? initial !== void 0 ? initial || {} : from : from, item),
              to: callProp(enter, item)
            };
          });
          break;
        }

      case LEAVE:
        {
          removed.forEach(key => {
            const keyIndex = _keys.indexOf(key);

            const item = _items[keyIndex];
            const slot = LEAVE;
            deleted.unshift(_extends$y({}, current[key], {
              slot,
              destroyed: true,
              left: _keys[Math.max(0, keyIndex - 1)],
              right: _keys[Math.min(_keys.length, keyIndex + 1)],
              trail: delay = delay + trail,
              config: callProp(config, item, slot),
              to: callProp(leave, item)
            }));
            delete current[key];
          });
          break;
        }

      case UPDATE:
        {
          updated.forEach(key => {
            const keyIndex = keys.indexOf(key);
            const item = items[keyIndex];
            const slot = UPDATE;
            current[key] = _extends$y({}, current[key], {
              item,
              slot,
              trail: delay = delay + trail,
              config: callProp(config, item, slot),
              to: callProp(update, item)
            });
          });
          break;
        }
    }
  }

  let out = keys.map(key => current[key]); // This tries to restore order for deleted items by finding their last known siblings
  // only using the left sibling to keep order placement consistent for all deleted items

  deleted.forEach((_ref9) => {
    let left = _ref9.left;
        _ref9.right;
        let item = _objectWithoutPropertiesLoose$3(_ref9, ["left", "right"]);

    let pos; // Was it the element on the left, if yes, move there ...

    if ((pos = out.findIndex(t => t.originalKey === left)) !== -1) pos += 1; // And if nothing else helps, move it to the start ¯\_(ツ)_/¯

    pos = Math.max(0, pos);
    out = [...out.slice(0, pos), item, ...out.slice(pos)];
  });
  return _extends$y({}, state, {
    changed: added.length || removed.length || updated.length,
    first: first && added.length === 0,
    transitions: out,
    current,
    deleted,
    prevProps: props
  });
}

class AnimatedStyle extends AnimatedObject {
  constructor(style) {
    if (style === void 0) {
      style = {};
    }

    super();

    if (style.transform && !(style.transform instanceof Animated)) {
      style = applyAnimatedValues.transform(style);
    }

    this.payload = style;
  }

}

// http://www.w3.org/TR/css3-color/#svg-color
const colors = {
  transparent: 0x00000000,
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff
};

// const INTEGER = '[-+]?\\d+';
const NUMBER = '[-+]?\\d*\\.?\\d+';
const PERCENTAGE = NUMBER + '%';

function call() {
  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
}

const rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
const rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
const hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
const hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
const hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex6 = /^#([0-9a-fA-F]{6})$/;
const hex8 = /^#([0-9a-fA-F]{8})$/;

/*
https://github.com/react-community/normalize-css-color

BSD 3-Clause License

Copyright (c) 2016, React Community
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

* Neither the name of the copyright holder nor the names of its
  contributors may be used to endorse or promote products derived from
  this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
function normalizeColor(color) {
  let match;

  if (typeof color === 'number') {
    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
  } // Ordered based on occurrences on Facebook codebase


  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
  if (colors.hasOwnProperty(color)) return colors[color];

  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    0x000000ff) >>> // a
    0;
  }

  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }

  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    'ff', // a
    16) >>> 0;
  } // https://drafts.csswg.org/css-color-4/#hex-notation


  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
  }

  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | 0x000000ff) >>> // a
    0;
  }

  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | parse1(match[4])) >>> // a
    0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0) return 0;
  if (int > 255) return 255;
  return int;
}

function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}

function parse1(str) {
  const num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  const int = parseFloat(str);
  if (int < 0) return 0;
  if (int > 100) return 1;
  return int / 100;
}

function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  let r = (int32Color & 0xff000000) >>> 24;
  let g = (int32Color & 0x00ff0000) >>> 16;
  let b = (int32Color & 0x0000ff00) >>> 8;
  let a = (int32Color & 0x000000ff) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
} // Problem: https://github.com/animatedjs/animated/pull/102
// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662


const stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g; // Covers rgb, rgba, hsl, hsla
// Taken from https://gist.github.com/olmokramer/82ccce673f86db7cda5e

const colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi; // Covers color names (transparent, blue, etc.)

const colorNamesRegex = new RegExp(`(${Object.keys(colors).join('|')})`, 'g');
/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *   rgba(123, 42, 99, 0.36)           // colors
 *   -45deg                            // values with units
 *   0 2px 2px 0px rgba(0, 0, 0, 0.12) // box shadows
 */

const createStringInterpolator = config => {
  // Replace colors with rgba
  const outputRange = config.output.map(rangeValue => rangeValue.replace(colorRegex, colorToRgba)).map(rangeValue => rangeValue.replace(colorNamesRegex, colorToRgba));
  const outputRanges = outputRange[0].match(stringShapeRegex).map(() => []);
  outputRange.forEach(value => {
    value.match(stringShapeRegex).forEach((number, i) => outputRanges[i].push(+number));
  });
  const interpolations = outputRange[0].match(stringShapeRegex).map((_value, i) => createInterpolator(_extends$y({}, config, {
    output: outputRanges[i]
  })));
  return input => {
    let i = 0;
    return outputRange[0] // 'rgba(0, 100, 200, 0)'
    // ->
    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
    .replace(stringShapeRegex, () => interpolations[i++](input)) // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
    // round the opacity (4th column).
    .replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`);
  };
};

let isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

const prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);

const prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach(prefix => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

function dangerousStyleValue(name, value, isCustomProperty) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers

  return ('' + value).trim();
}

const attributeCache = {};
injectCreateAnimatedStyle(style => new AnimatedStyle(style));
injectStringInterpolator(createStringInterpolator);
injectColorNames(colors);
injectApplyAnimatedValues((instance, props) => {
  if (instance.nodeType && instance.setAttribute !== undefined) {
    const style = props.style,
          children = props.children,
          scrollTop = props.scrollTop,
          scrollLeft = props.scrollLeft,
          attributes = _objectWithoutPropertiesLoose$3(props, ["style", "children", "scrollTop", "scrollLeft"]);

    const filter = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft; // Set textContent, if children is an animatable value

    if (children !== void 0) instance.textContent = children; // Set styles ...

    for (let styleName in style) {
      if (!style.hasOwnProperty(styleName)) continue;
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = dangerousStyleValue(styleName, style[styleName], isCustomProperty);
      if (styleName === 'float') styleName = 'cssFloat';
      if (isCustomProperty) instance.style.setProperty(styleName, styleValue);else instance.style[styleName] = styleValue;
    } // Set attributes ...


    for (let name in attributes) {
      // Attributes are written in dash case
      const dashCase = filter ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, n => '-' + n.toLowerCase()));
      if (typeof instance.getAttribute(dashCase) !== 'undefined') instance.setAttribute(dashCase, attributes[name]);
    }

    return;
  } else return false;
}, style => style);

const domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
// Extend animated with all the available THREE elements
const apply$1 = merge(createAnimatedComponent, false);
const extendedAnimated = apply$1(domElements);

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

var exponent = 3;

((function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
}))(exponent);

((function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
}))(exponent);

((function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
}))(exponent);

var overshoot = 1.70158;

((function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
}))(overshoot);

((function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
}))(overshoot);

((function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
}))(overshoot);

var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

((function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
}))(amplitude, period);

((function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
}))(amplitude, period);

((function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
}))(amplitude, period);

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
}

/* global window */

var root$1;

if (typeof self !== 'undefined') {
  root$1 = self;
} else if (typeof window !== 'undefined') {
  root$1 = window;
} else if (typeof global !== 'undefined') {
  root$1 = global;
} else if (typeof module !== 'undefined') {
  root$1 = module;
} else {
  root$1 = Function('return this')();
}

var result = symbolObservablePonyfill(root$1);

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject$2(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore$1(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore$1)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject$2(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[result] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[result] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning$3(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(source, true).forEach(function (key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning$3('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}

var propTypes = {exports: {}};

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

(function (module) {

	if (process.env.NODE_ENV === 'production') {
	  module.exports = requireReactIs_production_min();
	} else {
	  module.exports = requireReactIs_development();
	}
} (reactIs$1));

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = reactIs$1.exports;
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var checkPropTypes = requireCheckPropTypes();

	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }

	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$1.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var ReactReduxContext =
/*#__PURE__*/
React__default["default"].createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();

function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = React.useMemo(function () {
    var subscription = new Subscription(store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = React.useMemo(function () {
    return store.getState();
  }, [store]);
  React.useEffect(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return React__default["default"].createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (process.env.NODE_ENV !== 'production') {
  Provider.propTypes = {
    store: propTypes.exports.shape({
      subscribe: propTypes.exports.func.isRequired,
      dispatch: propTypes.exports.func.isRequired,
      getState: propTypes.exports.func.isRequired
    }),
    context: propTypes.exports.object,
    children: propTypes.exports.any
  };
}

var reactIs = reactIs$1.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect$2 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect$2(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose$3(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  if (process.env.NODE_ENV !== 'production') {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (process.env.NODE_ENV !== 'production' && !reactIs$1.exports.isValidElementType(WrappedComponent)) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends$y({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? React.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = React.useMemo(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var forwardedRef = props.forwardedRef,
            wrapperProps = _objectWithoutPropertiesLoose$3(props, ["forwardedRef"]);

        return [props.context, forwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          forwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = React.useMemo(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && reactIs$1.exports.isContextConsumer(React__default["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = React.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (process.env.NODE_ENV !== 'production' && !didStoreComeFromProps && !didStoreComeFromContext) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = React.useMemo(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = React.useMemo(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new Subscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = React.useMemo(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends$y({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = React.useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = React.useRef();
      var lastWrapperProps = React.useRef(wrapperProps);
      var childPropsFromStoreUpdate = React.useRef();
      var renderIsScheduled = React.useRef(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = React.useMemo(function () {
        return React__default["default"].createElement(WrappedComponent, _extends$y({}, actualChildProps, {
          ref: forwardedRef
        }));
      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = React.useMemo(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return React__default["default"].createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? React__default["default"].memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = React__default["default"].forwardRef(function forwardConnectRef(props, ref) {
        return React__default["default"].createElement(Connect, _extends$y({}, props, {
          forwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistNonReactStatics_cjs(forwarded, WrappedComponent);
    }

    return hoistNonReactStatics_cjs(Connect, WrappedComponent);
  };
}

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject$1(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning$2(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

function verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject$1(value)) {
    warning$2(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (process.env.NODE_ENV !== 'production') verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends$y({}, ownProps, {}, stateProps, {}, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== 'production') verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      warning$2("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose$3(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (process.env.NODE_ENV !== 'production') {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose$3(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends$y({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
var connect = /*#__PURE__*/
createConnect();

setBatch(require$$1.unstable_batchedUpdates);

function areInputsEqual$1(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = React.useState(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var committed = React.useRef(initial);
  var isInputMatch = Boolean(inputs && committed.current.inputs && areInputsEqual$1(inputs, committed.current.inputs));
  var cache = isInputMatch ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  React.useEffect(function () {
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;

var isProduction$2 = process.env.NODE_ENV === 'production';
var prefix$2 = 'Invariant failed';
function invariant$1(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction$2) {
        throw new Error(prefix$2);
    }
    throw new Error(prefix$2 + ": " + (message || ''));
}

var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing$1 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing$1 : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing$1 : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing$1 : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Could not parse value [raw: " + raw + ", without suffix: " + value + "]") : invariant$1(false) : void 0;
  return result;
};

var getWindowScroll$1 = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll$1();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse(styles.marginTop),
    right: parse(styles.marginRight),
    bottom: parse(styles.marginBottom),
    left: parse(styles.marginLeft)
  };
  var padding = {
    top: parse(styles.paddingTop),
    right: parse(styles.paddingRight),
    bottom: parse(styles.paddingBottom),
    left: parse(styles.paddingLeft)
  };
  var border = {
    top: parse(styles.borderTopWidth),
    right: parse(styles.borderRightWidth),
    bottom: parse(styles.borderBottomWidth),
    left: parse(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};

function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

var isProduction$1 = process.env.NODE_ENV === 'production';
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;

var clean = function clean(value) {
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
};

var getDevMessage = function getDevMessage(message) {
  return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};

var getFormattedMessage = function getFormattedMessage(message) {
  return [getDevMessage(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
};
var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function log$1(type, message) {
  var _console;

  if (isProduction$1) {
    return;
  }

  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
    return;
  }

  (_console = console)[type].apply(_console, getFormattedMessage(message));
}
var warning$1 = log$1.bind(null, 'warn');
var error = log$1.bind(null, 'error');

function noop() {}

function getOptions(shared, fromBinding) {
  return _extends$y({}, shared, {}, fromBinding);
}

function bindEvents(el, bindings, sharedOptions) {
  var unbindings = bindings.map(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
    return function unbind() {
      el.removeEventListener(binding.eventName, binding.fn, options);
    };
  });
  return function unbindAll() {
    unbindings.forEach(function (unbind) {
      unbind();
    });
  };
}

var isProduction$1$1 = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function RbdInvariant(message) {
  this.message = message;
}

RbdInvariant.prototype.toString = function toString() {
  return this.message;
};

function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction$1$1) {
    throw new RbdInvariant(prefix);
  } else {
    throw new RbdInvariant(prefix + ": " + (message || ''));
  }
}

var ErrorBoundary = function (_React$Component) {
  _inheritsLoose$1(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.callbacks = null;
    _this.unbind = noop;

    _this.onWindowError = function (event) {
      var callbacks = _this.getCallbacks();

      if (callbacks.isDragging()) {
        callbacks.tryAbort();
        process.env.NODE_ENV !== "production" ? warning$1("\n        An error was caught by our window 'error' event listener while a drag was occurring.\n        The active drag has been aborted.\n      ") : void 0;
      }

      var err = event.error;

      if (err instanceof RbdInvariant) {
        event.preventDefault();

        if (process.env.NODE_ENV !== 'production') {
          error(err.message);
        }
      }
    };

    _this.getCallbacks = function () {
      if (!_this.callbacks) {
        throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
      }

      return _this.callbacks;
    };

    _this.setCallbacks = function (callbacks) {
      _this.callbacks = callbacks;
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.unbind = bindEvents(window, [{
      eventName: 'error',
      fn: this.onWindowError
    }]);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unbind();
  };

  _proto.componentDidCatch = function componentDidCatch(err) {
    if (err instanceof RbdInvariant) {
      if (process.env.NODE_ENV !== 'production') {
        error(err.message);
      }

      this.setState({});
      return;
    }

    throw err;
  };

  _proto.render = function render() {
    return this.props.children(this.setCallbacks);
  };

  return ErrorBoundary;
}(React__default["default"].Component);

var dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + "\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  dragHandleUsageInstructions: dragHandleUsageInstructions,
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};

var origin = {
  x: 0,
  y: 0
};
var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};
var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};
var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = (function (frame, subject) {
  var result = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
});

var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};
var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return _extends$y({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return getRect(target);
};

var getSubject = (function (_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
});

var scrollDroppable = (function (droppable, newScroll) {
  !droppable.frame ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = _extends$y({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = _extends$y({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
});

function isInteger$1(value) {
  if (Number.isInteger) {
    return Number.isInteger(value);
  }

  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function values(map) {
  if (Object.values) {
    return Object.values(map);
  }

  return Object.keys(map).map(function (key) {
    return map[key];
  });
}
function findIndex(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}
function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}
function toArray(list) {
  return Array.prototype.slice.call(list);
}

var toDroppableMap = memoizeOne(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = memoizeOne(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = memoizeOne(function (droppables) {
  return values(droppables);
});
var toDraggableList = memoizeOne(function (draggables) {
  return values(draggables);
});

var getDraggablesInsideDroppable = memoizeOne(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

function tryGetDestination(impact) {
  if (impact.at && impact.at.type === 'REORDER') {
    return impact.at.destination;
  }

  return null;
}
function tryGetCombine(impact) {
  if (impact.at && impact.at.type === 'COMBINE') {
    return impact.at.combine;
  }

  return null;
}

var removeDraggableFromList = memoizeOne(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var moveToNextCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var location = tryGetDestination(previousImpact);

  if (!location) {
    return null;
  }

  function getImpact(target) {
    var at = {
      type: 'COMBINE',
      combine: {
        draggableId: target,
        droppableId: destination.descriptor.id
      }
    };
    return _extends$y({}, previousImpact, {
      at: at
    });
  }

  var all = previousImpact.displaced.all;
  var closestId = all.length ? all[0] : null;

  if (isMovingForward) {
    return closestId ? getImpact(closestId) : null;
  }

  var withoutDraggable = removeDraggableFromList(draggable, insideDestination);

  if (!closestId) {
    if (!withoutDraggable.length) {
      return null;
    }

    var last = withoutDraggable[withoutDraggable.length - 1];
    return getImpact(last.descriptor.id);
  }

  var indexOfClosest = findIndex(withoutDraggable, function (d) {
    return d.descriptor.id === closestId;
  });
  !(indexOfClosest !== -1) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find displaced item in set') : invariant(false) : void 0;
  var proposedIndex = indexOfClosest - 1;

  if (proposedIndex < 0) {
    return null;
  }

  var before = withoutDraggable[proposedIndex];
  return getImpact(before.descriptor.id);
});

var isHomeOf = (function (draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
});

var noDisplacedBy = {
  point: origin,
  value: 0
};
var emptyGroups = {
  invisible: {},
  visible: {},
  all: []
};
var noImpact = {
  displaced: emptyGroups,
  displacedBy: noDisplacedBy,
  at: null
};

var isWithin = (function (lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
});

var isPartiallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
});

var isTotallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
});

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isTotallyVisibleThroughFrameOnAxis = (function (axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
});

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible(_extends$y({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};
var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible(_extends$y({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};
var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible(_extends$y({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!last) {
    return true;
  }

  var invisible = last.invisible,
      visible = last.visible;

  if (invisible[id]) {
    return false;
  }

  var previous = visible[id];
  return previous ? previous.shouldAnimate : true;
};

function getTarget(draggable, displacedBy) {
  var marginBox = draggable.page.marginBox;
  var expandBy = {
    top: displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: displacedBy.point.x
  };
  return getRect(expand(marginBox, expandBy));
}

function getDisplacementGroups(_ref) {
  var afterDragging = _ref.afterDragging,
      destination = _ref.destination,
      displacedBy = _ref.displacedBy,
      viewport = _ref.viewport,
      forceShouldAnimate = _ref.forceShouldAnimate,
      last = _ref.last;
  return afterDragging.reduce(function process(groups, draggable) {
    var target = getTarget(draggable, displacedBy);
    var id = draggable.descriptor.id;
    groups.all.push(id);
    var isVisible = isPartiallyVisible({
      target: target,
      destination: destination,
      viewport: viewport,
      withDroppableDisplacement: true
    });

    if (!isVisible) {
      groups.invisible[draggable.descriptor.id] = true;
      return groups;
    }

    var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
    var displacement = {
      draggableId: id,
      shouldAnimate: shouldAnimate
    };
    groups.visible[id] = displacement;
    return groups;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}

function getIndexOfLastItem(draggables, options) {
  if (!draggables.length) {
    return 0;
  }

  var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}

function goAtEnd(_ref) {
  var insideDestination = _ref.insideDestination,
      inHomeList = _ref.inHomeList,
      displacedBy = _ref.displacedBy,
      destination = _ref.destination;
  var newIndex = getIndexOfLastItem(insideDestination, {
    inHomeList: inHomeList
  });
  return {
    displaced: emptyGroups,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: newIndex
      }
    }
  };
}

function calculateReorderImpact(_ref2) {
  var draggable = _ref2.draggable,
      insideDestination = _ref2.insideDestination,
      destination = _ref2.destination,
      viewport = _ref2.viewport,
      displacedBy = _ref2.displacedBy,
      last = _ref2.last,
      index = _ref2.index,
      forceShouldAnimate = _ref2.forceShouldAnimate;
  var inHomeList = isHomeOf(draggable, destination);

  if (index == null) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var match = find(insideDestination, function (item) {
    return item.descriptor.index === index;
  });

  if (!match) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var sliceFrom = insideDestination.indexOf(match);
  var impacted = withoutDragging.slice(sliceFrom);
  var displaced = getDisplacementGroups({
    afterDragging: impacted,
    destination: destination,
    displacedBy: displacedBy,
    last: last,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate
  });
  return {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: index
      }
    }
  };
}

function didStartAfterCritical(draggableId, afterCritical) {
  return Boolean(afterCritical.effected[draggableId]);
}

var fromCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      draggables = _ref.draggables,
      combine = _ref.combine,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var combineId = combine.draggableId;
  var combineWith = draggables[combineId];
  var combineWithIndex = combineWith.descriptor.index;
  var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);

  if (didCombineWithStartAfterCritical) {
    if (isMovingForward) {
      return combineWithIndex;
    }

    return combineWithIndex - 1;
  }

  if (isMovingForward) {
    return combineWithIndex + 1;
  }

  return combineWithIndex;
});

var fromReorder = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      insideDestination = _ref.insideDestination,
      location = _ref.location;

  if (!insideDestination.length) {
    return null;
  }

  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var firstIndex = insideDestination[0].descriptor.index;
  var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
  var upperBound = isInHomeList ? lastIndex : lastIndex + 1;

  if (proposedIndex < firstIndex) {
    return null;
  }

  if (proposedIndex > upperBound) {
    return null;
  }

  return proposedIndex;
});

var moveToNextIndex = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var wasAt = previousImpact.at;
  !wasAt ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot move in direction without previous impact location') : invariant(false) : void 0;

  if (wasAt.type === 'REORDER') {
    var _newIndex = fromReorder({
      isMovingForward: isMovingForward,
      isInHomeList: isInHomeList,
      location: wasAt.destination,
      insideDestination: insideDestination
    });

    if (_newIndex == null) {
      return null;
    }

    return calculateReorderImpact({
      draggable: draggable,
      insideDestination: insideDestination,
      destination: destination,
      viewport: viewport,
      last: previousImpact.displaced,
      displacedBy: previousImpact.displacedBy,
      index: _newIndex
    });
  }

  var newIndex = fromCombine({
    isMovingForward: isMovingForward,
    destination: destination,
    displaced: previousImpact.displaced,
    draggables: draggables,
    combine: wasAt.combine,
    afterCritical: afterCritical
  });

  if (newIndex == null) {
    return null;
  }

  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: previousImpact.displaced,
    displacedBy: previousImpact.displacedBy,
    index: newIndex
  });
});

var getCombinedItemDisplacement = (function (_ref) {
  var displaced = _ref.displaced,
      afterCritical = _ref.afterCritical,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);

  if (didStartAfterCritical(combineWith, afterCritical)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
});

var whenCombining = (function (_ref) {
  var afterCritical = _ref.afterCritical,
      impact = _ref.impact,
      draggables = _ref.draggables;
  var combine = tryGetCombine(impact);
  !combine ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: impact.displaced,
    afterCritical: afterCritical,
    combineWith: combineWith,
    displacedBy: impact.displacedBy
  });
  return add(center, displaceBy);
});

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      afterCritical = _ref.afterCritical;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = impact.displaced,
      displacedBy = impact.displacedBy;
  var closestAfter = displaced.all[0];

  if (closestAfter) {
    var closest = draggables[closestAfter];

    if (didStartAfterCritical(closestAfter, afterCritical)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closest.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = offset(closest.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
    var page = offset(last.page, negate(afterCritical.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
});

var withDroppableDisplacement = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
});

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      afterCritical = _ref.afterCritical;
  var original = draggable.page.borderBox.center;
  var at = impact.at;

  if (!droppable) {
    return original;
  }

  if (!at) {
    return original;
  }

  if (at.type === 'REORDER') {
    return whenReordering({
      impact: impact,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      afterCritical: afterCritical
    });
  }

  return whenCombining({
    impact: impact,
    draggables: draggables,
    afterCritical: afterCritical
  });
};

var getPageBorderBoxCenterFromImpact = (function (args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
});

var scrollViewport = (function (viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
});

function getDraggables(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

function tryGetVisible(id, groups) {
  for (var i = 0; i < groups.length; i++) {
    var displacement = groups[i].visible[id];

    if (displacement) {
      return displacement;
    }
  }

  return null;
}

var speculativelyIncrease = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var last = impact.displaced;
  var withViewportScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: scrolledViewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var withDroppableScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: scrolledDroppable,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var invisible = {};
  var visible = {};
  var groups = [last, withViewportScroll, withDroppableScroll];
  last.all.forEach(function (id) {
    var displacement = tryGetVisible(id, groups);

    if (displacement) {
      visible[id] = displacement;
      return;
    }

    invisible[id] = true;
  });

  var newImpact = _extends$y({}, impact, {
    displaced: {
      all: last.all,
      invisible: invisible,
      visible: visible
    }
  });

  return newImpact;
});

var withViewportDisplacement = (function (viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
});

var getClientFromPageBorderBoxCenter = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
});

var isTotallyVisibleInNewLocation = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
});

var moveToNextPlace = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      afterCritical = _ref.afterCritical;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
});

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot get clipped area from droppable') : invariant(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
});

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
  var original = draggable.page.borderBox.center;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
  var original = draggable.page.borderBox;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};

var getClosestDraggable = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, afterCritical),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
});

var getDisplacedBy = memoizeOne(function getDisplacedBy(axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;

  if (droppable.descriptor.mode === 'virtual') {
    return patch(axis.line, placeholderSize[axis.line]);
  }

  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return _extends$y({}, frame, {
    scroll: _extends$y({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should not add placeholder space to home list') : invariant(false) : void 0;
  !!droppable.subject.withPlaceholder ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot add placeholder size to a subject when it already has one') : invariant(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return _extends$y({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return _extends$y({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};
var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot remove placeholder form subject when there was none') : invariant(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return _extends$y({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected droppable with frame to have old max frame scroll when removing placeholder') : invariant(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return _extends$y({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var moveToNewDroppable = (function (_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      displaced: emptyGroups,
      displacedBy: noDisplacedBy,
      at: {
        type: 'REORDER',
        destination: {
          droppableId: destination.descriptor.id,
          index: 0
        }
      }
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      afterCritical: afterCritical
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);

  var proposedIndex = function () {
    var relativeTo = moveRelativeTo.descriptor.index;

    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return relativeTo;
    }

    if (isGoingBeforeTarget) {
      return relativeTo;
    }

    return relativeTo + 1;
  }();

  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    displacedBy: displacedBy,
    last: emptyGroups,
    index: proposedIndex
  });
});

var moveCrossAxis = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
});

var whatIsDraggedOver = (function (impact) {
  var at = impact.at;

  if (!at) {
    return null;
  }

  if (at.type === 'REORDER') {
    return at.destination.droppableId;
  }

  return at.combine.droppableId;
});

var getDroppableOver = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = (function (_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    afterCritical: state.afterCritical
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    viewport: state.viewport,
    afterCritical: state.afterCritical
  });
});

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

function isPositionInFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function run(point) {
    return isWithinVertical(point.y) && isWithinHorizontal(point.x);
  };
}

function getHasOverlap(first, second) {
  return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}

function getFurthestAway(_ref) {
  var pageBorderBox = _ref.pageBorderBox,
      draggable = _ref.draggable,
      candidates = _ref.candidates;
  var startCenter = draggable.page.borderBox.center;
  var sorted = candidates.map(function (candidate) {
    var axis = candidate.axis;
    var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
    return {
      id: candidate.descriptor.id,
      distance: distance(startCenter, target)
    };
  }).sort(function (a, b) {
    return b.distance - a.distance;
  });
  return sorted[0] ? sorted[0].id : null;
}

function getDroppableOver$1(_ref2) {
  var pageBorderBox = _ref2.pageBorderBox,
      draggable = _ref2.draggable,
      droppables = _ref2.droppables;
  var candidates = toDroppableList(droppables).filter(function (item) {
    if (!item.isEnabled) {
      return false;
    }

    var active = item.subject.active;

    if (!active) {
      return false;
    }

    if (!getHasOverlap(pageBorderBox, active)) {
      return false;
    }

    if (isPositionInFrame(active)(pageBorderBox.center)) {
      return true;
    }

    var axis = item.axis;
    var childCenter = active.center[axis.crossAxisLine];
    var crossAxisStart = pageBorderBox[axis.crossAxisStart];
    var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
    var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
    var isStartContained = isContained(crossAxisStart);
    var isEndContained = isContained(crossAxisEnd);

    if (!isStartContained && !isEndContained) {
      return true;
    }

    if (isStartContained) {
      return crossAxisStart < childCenter;
    }

    return crossAxisEnd > childCenter;
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0].descriptor.id;
  }

  return getFurthestAway({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    candidates: candidates
  });
}

var offsetRectByPosition = function offsetRectByPosition(rect, point) {
  return getRect(offsetByPosition(rect, point));
};

var withDroppableScroll = (function (droppable, area) {
  var frame = droppable.frame;

  if (!frame) {
    return area;
  }

  return offsetRectByPosition(area, frame.scroll.diff.value);
});

function getIsDisplaced(_ref) {
  var displaced = _ref.displaced,
      id = _ref.id;
  return Boolean(displaced.visible[id] || displaced.invisible[id]);
}

function atIndex(_ref) {
  var draggable = _ref.draggable,
      closest = _ref.closest,
      inHomeList = _ref.inHomeList;

  if (!closest) {
    return null;
  }

  if (!inHomeList) {
    return closest.descriptor.index;
  }

  if (closest.descriptor.index > draggable.descriptor.index) {
    return closest.descriptor.index - 1;
  }

  return closest.descriptor.index;
}

var getReorderImpact = (function (_ref2) {
  var targetRect = _ref2.pageBorderBoxWithDroppableScroll,
      draggable = _ref2.draggable,
      destination = _ref2.destination,
      insideDestination = _ref2.insideDestination,
      last = _ref2.last,
      viewport = _ref2.viewport,
      afterCritical = _ref2.afterCritical;
  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var closest = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childCenter = child.page.borderBox.center[axis.line];
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: last,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd <= childCenter;
      }

      return targetStart < childCenter - displacement;
    }

    if (isDisplaced) {
      return targetEnd <= childCenter + displacement;
    }

    return targetStart < childCenter;
  });
  var newIndex = atIndex({
    draggable: draggable,
    closest: closest,
    inHomeList: isHomeOf(draggable, destination)
  });
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: last,
    displacedBy: displacedBy,
    index: newIndex
  });
});

var combineThresholdDivisor = 4;
var getCombineImpact = (function (_ref) {
  var draggable = _ref.draggable,
      targetRect = _ref.pageBorderBoxWithDroppableScroll,
      previousImpact = _ref.previousImpact,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var combineWith = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childRect = child.page.borderBox;
    var childSize = childRect[axis.size];
    var threshold = childSize / combineThresholdDivisor;
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: previousImpact.displaced,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
      }

      return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
    }

    if (isDisplaced) {
      return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
    }

    return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
  });

  if (!combineWith) {
    return null;
  }

  var impact = {
    displacedBy: displacedBy,
    displaced: previousImpact.displaced,
    at: {
      type: 'COMBINE',
      combine: {
        draggableId: combineWith.descriptor.id,
        droppableId: destination.descriptor.id
      }
    }
  };
  return impact;
});

var getDragImpact = (function (_ref) {
  var pageOffset = _ref.pageOffset,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
  var destinationId = getDroppableOver$1({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
  return getCombineImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    previousImpact: previousImpact,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  }) || getReorderImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    last: previousImpact.displaced,
    viewport: viewport,
    afterCritical: afterCritical
  });
});

var patchDroppableMap = (function (droppables, updated) {
  var _extends2;

  return _extends$y({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
});

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = (function (_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
});

var update = (function (_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, viewport.scroll.current),
    borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
    offset: add(client.offset, viewport.scroll.diff.value)
  };
  var current = {
    client: client,
    page: page
  };

  if (state.phase === 'COLLECTING') {
    return _extends$y({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageOffset: page.offset,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = _extends$y({}, state, {
    current: current,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
});

function getDraggables$1(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

var recompute = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      destination = _ref.destination,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var last = impact.displaced;
  var afterDragging = getDraggables$1(last.all, draggables);
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate,
    last: last
  });
  return _extends$y({}, impact, {
    displaced: displaced
  });
});

var getClientBorderBoxCenter = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    afterCritical: afterCritical
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
});

var refreshSnap = (function (_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ? process.env.NODE_ENV !== "production" ? invariant(false, 'Must be over a destination in SNAP movement mode') : invariant(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  return update({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
});

var getHomeLocation = (function (descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
});

var getLiftEffect = (function (_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var rawIndex = insideHome.indexOf(draggable);
  !(rawIndex !== -1) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected draggable to be inside home list') : invariant(false) : void 0;
  var afterDragging = insideHome.slice(rawIndex + 1);
  var effected = afterDragging.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var afterCritical = {
    inVirtualList: home.descriptor.mode === 'virtual',
    displacedBy: displacedBy,
    effected: effected
  };
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: home,
    displacedBy: displacedBy,
    last: null,
    viewport: viewport.frame,
    forceShouldAnimate: false
  });
  var impact = {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: getHomeLocation(draggable.descriptor)
    }
  };
  return {
    impact: impact,
    afterCritical: afterCritical
  };
});

var patchDimensionMap = (function (dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
});

var start = function start(key) {
  if (process.env.NODE_ENV !== 'production') {
    {
      return;
    }
  }
};
var finish = function finish(key) {
  if (process.env.NODE_ENV !== 'production') {
    {
      return;
    }
  }
};

var offsetDraggable = (function (_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = offset(draggable.client, offset$1);
  var page = withScroll(client, initialWindowScroll);

  var moved = _extends$y({}, draggable, {
    placeholder: _extends$y({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
});

var getFrame = (function (droppable) {
  var frame = droppable.frame;
  !frame ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected Droppable to have a frame') : invariant(false) : void 0;
  return frame;
});

var adjustAdditionsForScrollChanges = (function (_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = getFrame(modified);
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
});

var publishWhileDraggingInVirtual = (function (_ref) {
  var state = _ref.state,
      published = _ref.published;
  start();
  var withScrollChange = published.modified.map(function (update) {
    var existing = state.dimensions.droppables[update.droppableId];
    var scrolled = scrollDroppable(existing, update.scroll);
    return scrolled;
  });

  var droppables = _extends$y({}, state.dimensions.droppables, {}, toDroppableMap(withScrollChange));

  var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
    additions: published.additions,
    updatedDroppables: droppables,
    viewport: state.viewport
  }));

  var draggables = _extends$y({}, state.dimensions.draggables, {}, updatedAdditions);

  published.removals.forEach(function (id) {
    delete draggables[id];
  });
  var dimensions = {
    droppables: droppables,
    draggables: draggables
  };
  var wasOverId = whatIsDraggedOver(state.impact);
  var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
  var draggable = dimensions.draggables[state.critical.draggable.id];
  var home = dimensions.droppables[state.critical.droppable.id];

  var _getLiftEffect = getLiftEffect({
    draggable: draggable,
    home: home,
    draggables: draggables,
    viewport: state.viewport
  }),
      onLiftImpact = _getLiftEffect.impact,
      afterCritical = _getLiftEffect.afterCritical;

  var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
  var impact = getDragImpact({
    pageOffset: state.current.page.offset,
    draggable: dimensions.draggables[state.critical.draggable.id],
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: previousImpact,
    viewport: state.viewport,
    afterCritical: afterCritical
  });
  finish();

  var draggingState = _extends$y({
    phase: 'DRAGGING'
  }, state, {
    phase: 'DRAGGING',
    impact: impact,
    onLiftImpact: onLiftImpact,
    dimensions: dimensions,
    afterCritical: afterCritical,
    forceShouldAnimate: false
  });

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = _extends$y({
    phase: 'DROP_PENDING'
  }, draggingState, {
    phase: 'DROP_PENDING',
    reason: state.reason,
    isWaiting: false
  });

  return dropPending;
});

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

function removeScrollJumpRequest(state) {
  if (state.isDragging && state.movementMode === 'SNAP') {
    return _extends$y({
      phase: 'DRAGGING'
    }, state, {
      scrollJumpRequest: null
    });
  }

  return state;
}

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};
var reducer = (function (state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'FLUSH') {
    return _extends$y({}, idle, {
      shouldFlush: true
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'INITIAL_PUBLISH must come after a IDLE phase') : invariant(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial),
        offset: add(client.selection, viewport.scroll.diff.value)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getLiftEffect = getLiftEffect({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getLiftEffect.impact,
        afterCritical = _getLiftEffect.afterCritical;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      afterCritical: afterCritical,
      onLiftImpact: impact,
      viewport: viewport,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Collection cannot start from phase " + state.phase) : invariant(false) : void 0;

    var _result = _extends$y({
      phase: 'COLLECTING'
    }, state, {
      phase: 'COLLECTING'
    });

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Unexpected " + action.type + " received in phase " + state.phase) : invariant(false) : void 0;
    return publishWhileDraggingInVirtual({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, action.type + " not permitted in phase " + state.phase) : invariant(false) : void 0;
    var _clientSelection = action.payload.client;

    if (isEqual(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return removeScrollJumpRequest(state);
    }

    if (state.phase === 'COLLECTING') {
      return removeScrollJumpRequest(state);
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, action.type + " not permitted in phase " + state.phase) : invariant(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        newScroll = _action$payload2.newScroll;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, newScroll);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : invariant(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : invariant(false) : void 0;
    !(_target.isEnabled !== isEnabled) ? process.env.NODE_ENV !== "production" ? invariant(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : invariant(false) : void 0;

    var updated = _extends$y({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : invariant(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot find Droppable[id: " + _id2 + "] to toggle its isCombineEnabled state") : invariant(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant(false, "Trying to set droppable isCombineEnabled to " + String(isCombineEnabled) + "\n      but it is already " + String(_target2.isCombineEnabled)) : invariant(false) : void 0;

    var _updated = _extends$y({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot move by window in phase " + state.phase) : invariant(false) : void 0;
    !state.isWindowScrollAllowed ? process.env.NODE_ENV !== "production" ? invariant(false, 'Window scrolling is currently not supported for fixed lists') : invariant(false) : void 0;
    var _newScroll = action.payload.newScroll;

    if (isEqual(state.viewport.scroll.current, _newScroll)) {
      return removeScrollJumpRequest(state);
    }

    var _viewport = scrollViewport(state.viewport, _newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (isEqual(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = _extends$y({}, state.viewport, {
      scroll: _extends$y({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return _extends$y({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant(false, action.type + " received while not in DRAGGING phase") : invariant(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only move into the DROP_PENDING phase from the COLLECTING phase') : invariant(false) : void 0;

    var newState = _extends$y({
      phase: 'DROP_PENDING'
    }, state, {
      phase: 'DROP_PENDING',
      isWaiting: true,
      reason: reason
    });

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot animate drop from phase " + state.phase) : invariant(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset,
      dimensions: state.dimensions
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _completed = action.payload.completed;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: false
    };
  }

  return state;
});

var beforeInitialCapture = function beforeInitialCapture(args) {
  return {
    type: 'BEFORE_INITIAL_CAPTURE',
    payload: args
  };
};
var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};
var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};
var publishWhileDragging = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};
var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};
var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};
var move$1 = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};
var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};
var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};
var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};
var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};
var flush = function flush() {
  return {
    type: 'FLUSH',
    payload: null
  };
};
var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};
var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};
var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};
var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};
var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

function checkIndexes(insideDestination) {
  if (insideDestination.length <= 1) {
    return;
  }

  var indexes = insideDestination.map(function (d) {
    return d.descriptor.index;
  });
  var errors = {};

  for (var i = 1; i < indexes.length; i++) {
    var current = indexes[i];
    var previous = indexes[i - 1];

    if (current !== previous + 1) {
      errors[current] = true;
    }
  }

  if (!Object.keys(errors).length) {
    return;
  }

  var formatted = indexes.map(function (index) {
    var hasError = Boolean(errors[index]);
    return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
  }).join(', ');
  process.env.NODE_ENV !== "production" ? warning$1("\n    Detected non-consecutive <Draggable /> indexes.\n\n    (This can cause unexpected bugs)\n\n    " + formatted + "\n  ") : void 0;
}

function validateDimensions(critical, dimensions) {
  if (process.env.NODE_ENV !== 'production') {
    var insideDestination = getDraggablesInsideDroppable(critical.droppable.id, dimensions.draggables);
    checkIndexes(insideDestination);
  }
}

var lift$1 = (function (marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed
          }));
        }

        !(getState().phase === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Unexpected phase to start a drag') : invariant(false) : void 0;
        dispatch(flush());
        dispatch(beforeInitialCapture({
          draggableId: id,
          movementMode: movementMode
        }));
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;

        validateDimensions(critical, dimensions);
        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
});

var style = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
});

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine.scale.drop + ")";
  }
};

var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = (function (_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
});

var getNewHomeClientOffset = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    afterCritical: afterCritical,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  return offset;
});

var getDropImpact = (function (_ref) {
  var draggables = _ref.draggables,
      reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      onLiftImpact = _ref.onLiftImpact;

  if (!lastImpact.at || reason !== 'DROP') {
    var recomputedHomeImpact = recompute({
      draggables: draggables,
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      forceShouldAnimate: true
    });
    return {
      impact: recomputedHomeImpact,
      didDropInsideDroppable: false
    };
  }

  if (lastImpact.at.type === 'REORDER') {
    return {
      impact: lastImpact,
      didDropInsideDroppable: true
    };
  }

  var withoutMovement = _extends$y({}, lastImpact, {
    displaced: emptyGroups
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: true
  };
});

var drop$1 = (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ? process.env.NODE_ENV !== "production" ? invariant(false, 'A DROP action occurred while DROP_PENDING and still waiting') : invariant(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot drop in phase: " + state.phase) : invariant(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var draggable = dimensions.draggables[state.critical.draggable.id];

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        afterCritical: state.afterCritical,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
      var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        afterCritical: state.afterCritical
      });
      var completed = {
        critical: state.critical,
        afterCritical: state.afterCritical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
});

var getWindowScroll = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

function getWindowScrollBinding(update) {
  return {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn(event) {
      if (event.target !== window && event.target !== window.document) {
        return;
      }

      update();
    }
  };
}

function getScrollListener(_ref) {
  var onWindowScroll = _ref.onWindowScroll;

  function updateScroll() {
    onWindowScroll(getWindowScroll());
  }

  var scheduled = rafSchd(updateScroll);
  var binding = getWindowScrollBinding(scheduled);
  var unbind = noop;

  function isActive() {
    return unbind !== noop;
  }

  function start() {
    !!isActive() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start scroll listener when already active') : invariant(false) : void 0;
    unbind = bindEvents(window, [binding]);
  }

  function stop() {
    !isActive() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot stop scroll listener when not active') : invariant(false) : void 0;
    scheduled.cancel();
    unbind();
    unbind = noop;
  }

  return {
    start: start,
    stop: stop,
    isActive: isActive
  };
}

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var scrollListener = (function (store) {
  var listener = getScrollListener({
    onWindowScroll: function onWindowScroll(newScroll) {
      store.dispatch(moveByWindowScroll({
        newScroll: newScroll
      }));
    }
  });
  return function (next) {
    return function (action) {
      if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') {
        listener.start();
      }

      if (listener.isActive() && shouldEnd(action)) {
        listener.stop();
      }

      next(action);
    };
  };
});

var getExpiringAnnounce = (function (announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
      process.env.NODE_ENV !== "production" ? warning$1('Announcement already made. Not making a second announcement') : void 0;
      return;
    }

    if (isExpired) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ") : void 0;
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
});

var getAsyncMarshal = (function () {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find timer') : invariant(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
});

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  start();
  fn();
  finish();
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = (function (getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeCapture = function beforeCapture(draggableId, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onBeforeCapture as a drag start has already been published') : invariant(false) : void 0;
    withTimings('onBeforeCapture', function () {
      var fn = getResponders().onBeforeCapture;

      if (fn) {
        var before = {
          draggableId: draggableId,
          mode: mode
        };
        fn(before);
      }
    });
  };

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = tryGetDestination(impact);
    var combine = tryGetCombine(impact);
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onDragMove when onDragStart has not been called') : invariant(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = _extends$y({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only flush responders while dragging') : invariant(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onDragEnd when there is no matching onDragStart') : invariant(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = _extends$y({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeCapture: beforeCapture,
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
});

var responders = (function (getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'BEFORE_INITIAL_CAPTURE') {
          publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'FLUSH') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
});

var dropAnimationFinish = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot finish a drop animating when no drop is occurring') : invariant(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed
      }));
    };
  };
});

var dropAnimationFlushOnScroll = (function (store) {
  var unbind = null;
  var frameId = null;

  function clear() {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }

    if (unbind) {
      unbind();
      unbind = null;
    }
  }

  return function (next) {
    return function (action) {
      if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') {
        clear();
      }

      next(action);

      if (action.type !== 'DROP_ANIMATE') {
        return;
      }

      var binding = {
        eventName: 'scroll',
        options: {
          capture: true,
          passive: false,
          once: true
        },
        fn: function flushDropAnimation() {
          var state = store.getState();

          if (state.phase === 'DROP_ANIMATING') {
            store.dispatch(dropAnimationFinished());
          }
        }
      };
      frameId = requestAnimationFrame(function () {
        frameId = null;
        unbind = bindEvents(window, [binding]);
      });
    };
  };
});

var dimensionMarshalStopper = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
});

var focus = (function (marshal) {
  var isWatching = false;
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          isWatching = true;
          marshal.tryRecordFocus(action.payload.critical.draggable.id);
          next(action);
          marshal.tryRestoreFocusRecorded();
          return;
        }

        next(action);

        if (!isWatching) {
          return;
        }

        if (action.type === 'FLUSH') {
          isWatching = false;
          marshal.tryRestoreFocusRecorded();
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          isWatching = false;
          var result = action.payload.completed.result;

          if (result.combine) {
            marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
          }

          marshal.tryRestoreFocusRecorded();
        }
      };
    };
  };
});

var shouldStop = function shouldStop(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var autoScroll = (function (autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldStop(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected phase to be DRAGGING after INITIAL_PUBLISH') : invariant(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
});

var pendingDrop = (function (store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
});

var composeEnhancers = process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
var createStore = (function (_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      focusMarshal = _ref.focusMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return createStore$1(reducer, composeEnhancers(applyMiddleware(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop, autoScroll(autoScroller), scrollListener, focus(focusMarshal), responders(getResponders, announce))));
});

var clean$1 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function createPublisher(_ref) {
  var registry = _ref.registry,
      callbacks = _ref.callbacks;
  var staging = clean$1();
  var frameId = null;

  var collect = function collect() {
    if (frameId) {
      return;
    }

    callbacks.collectionStarting();
    frameId = requestAnimationFrame(function () {
      frameId = null;
      start();
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;
      var added = Object.keys(additions).map(function (id) {
        return registry.draggable.getById(id).getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });
      var updated = Object.keys(modified).map(function (id) {
        var entry = registry.droppable.getById(id);
        var scroll = entry.callbacks.getScrollWhileDragging();
        return {
          droppableId: id,
          scroll: scroll
        };
      });
      var result = {
        additions: added,
        removals: Object.keys(removals),
        modified: updated
      };
      staging = clean$1();
      finish();
      callbacks.publish(result);
    });
  };

  var add = function add(entry) {
    var id = entry.descriptor.id;
    staging.additions[id] = entry;
    staging.modified[entry.descriptor.droppableId] = true;

    if (staging.removals[id]) {
      delete staging.removals[id];
    }

    collect();
  };

  var remove = function remove(entry) {
    var descriptor = entry.descriptor;
    staging.removals[descriptor.id] = true;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$1();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
}

var getMaxScroll = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});

var getDocumentElement = (function () {
  var doc = document.documentElement;
  !doc ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find document.documentElement') : invariant(false) : void 0;
  return doc;
});

var getMaxWindowScroll = (function () {
  var doc = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
});

var getViewport = (function () {
  var scroll = getWindowScroll();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = getRect({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
});

var getInitialPublish = (function (_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      registry = _ref.registry;
  start();
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = registry.droppable.getAllByType(home.type).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish();
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
});

function shouldPublishUpdate(registry, dragging, entry) {
  if (entry.descriptor.id === dragging.id) {
    return false;
  }

  if (entry.descriptor.type !== dragging.type) {
    return false;
  }

  var home = registry.droppable.getById(entry.descriptor.droppableId);

  if (home.descriptor.mode !== 'virtual') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      You are attempting to add or remove a Draggable [id: " + entry.descriptor.id + "]\n      while a drag is occurring. This is only supported for virtual lists.\n\n      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md\n    ") : void 0;
    return false;
  }

  return true;
}

var createDimensionMarshal = (function (registry, callbacks) {
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting
    },
    registry: registry
  });

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot update is enabled flag of Droppable " + id + " as it is not registered") : invariant(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot update isCombineEnabled flag of Droppable " + id + " as it is not registered") : invariant(false) : void 0;
    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : invariant(false) : void 0;
    callbacks.updateDroppableScroll({
      id: id,
      newScroll: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    if (!collection) {
      return;
    }

    registry.droppable.getById(id).callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    registry.droppable.getAllByType(home.type).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection.unsubscribe();
    collection = null;
  };

  var subscriber = function subscriber(event) {
    !collection ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should only be subscribed when a collection is occurring') : invariant(false) : void 0;
    var dragging = collection.critical.draggable;

    if (event.type === 'ADDITION') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.add(event.value);
      }
    }

    if (event.type === 'REMOVAL') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.remove(event.value);
      }
    }
  };

  var startPublishing = function startPublishing(request) {
    !!collection ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start capturing critical dimensions as there is already a collection') : invariant(false) : void 0;
    var entry = registry.draggable.getById(request.draggableId);
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    var unsubscribe = registry.subscribe(subscriber);
    collection = {
      critical: critical,
      unsubscribe: unsubscribe
    };
    return getInitialPublish({
      critical: critical,
      registry: registry,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
});

var canStartDrag = (function (state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
});

var scrollWindow = (function (change) {
  window.scrollBy(change.x, change.y);
});

var getScrollableDroppables = memoizeOne(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ? process.env.NODE_ENV !== "production" ? invariant(false, 'Invalid result') : invariant(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
});

var config = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = (function (container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
});

var getPercentage = (function (_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Detected distance range of 0 in the fluid auto scroller\n      This is unexpected and would cause a divide by 0 issue.\n      Not allowing an auto scroll\n    ") : void 0;
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
});

var minScroll = 1;

var getValueFromDistance = (function (distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
});

var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;
var dampenValueByTime = (function (proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;
  var now = Date.now();
  var runTime = now - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
});

var getValue$1 = (function (_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
});

var getScrollOnAxis = (function (_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue$1({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue$1({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
});

var adjustForSizeLimits = (function (_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
});

var clean$2 = apply(function (value) {
  return value === 0 ? 0 : value;
});
var getScroll = (function (_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$2({
    x: x,
    y: y
  });

  if (isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual(limited, origin) ? null : limited;
});

var smallestSigned = apply(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});
var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = (function (_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
});

var getDroppableScrollChange = (function (_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
});

var scroll$1 = (function (_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
});

var createFluidScroller = (function (_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = rafSchd(scrollWindow);
  var scheduleDroppableScroll = rafSchd(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fluid scroll if not dragging') : invariant(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var start$1 = function start$1(state) {
    start();
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start auto scrolling when already started') : invariant(false) : void 0;
    var dragStartTime = Date.now();
    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish();

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
    dragging = null;
  };

  return {
    start: start$1,
    stop: stop,
    scroll: tryScroll
  };
});

var createJumpScroller = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot perform a jump scroll when there is no destination') : invariant(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

var createAutoScroller = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
});

var prefix$1 = 'data-rbd';
var dragHandle = function () {
  var base = prefix$1 + "-drag-handle";
  return {
    base: base,
    draggableId: base + "-draggable-id",
    contextId: base + "-context-id"
  };
}();
var draggable = function () {
  var base = prefix$1 + "-draggable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var droppable = function () {
  var base = prefix$1 + "-droppable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var scrollContainer = {
  contextId: prefix$1 + "-scroll-container-context-id"
};

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';
var getStyles$1 = (function (contextId) {
  var getSelector = makeGetSelector(contextId);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle.contextId),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable.contextId),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
});

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find the head to append a style to') : invariant(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl(nonce) {
  var el = document.createElement('style');

  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  el.type = 'text/css';
  return el;
};

function useStyleMarshal(contextId, nonce) {
  var styles = useMemo(function () {
    return getStyles$1(contextId);
  }, [contextId]);
  var alwaysRef = React.useRef(null);
  var dynamicRef = React.useRef(null);
  var setDynamicStyle = useCallback(memoizeOne(function (proposed) {
    var el = dynamicRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot set dynamic style element if it is not set') : invariant(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = useCallback(function (proposed) {
    var el = alwaysRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot set dynamic style element if it is not set') : invariant(false) : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect$1(function () {
    !(!alwaysRef.current && !dynamicRef.current) ? process.env.NODE_ENV !== "production" ? invariant(false, 'style elements already mounted') : invariant(false) : void 0;
    var always = createStyleEl(nonce);
    var dynamic = createStyleEl(nonce);
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix$1 + "-always", contextId);
    dynamic.setAttribute(prefix$1 + "-dynamic", contextId);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot unmount ref as it is not set') : invariant(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [nonce, setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, contextId]);
  var dragging = useCallback(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = useCallback(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = useCallback(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = useMemo(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting
    };
  }, [dragging, dropping, resting]);
  return marshal;
}

var getWindowFromEl = (function (el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
});

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function findDragHandle(contextId, draggableId) {
  var selector = "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));

  if (!possible.length) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find any drag handles in the context \"" + contextId + "\"") : void 0;
    return null;
  }

  var handle = find(possible, function (el) {
    return el.getAttribute(dragHandle.draggableId) === draggableId;
  });

  if (!handle) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find drag handle with id \"" + draggableId + "\" as no handle with a matching id was found") : void 0;
    return null;
  }

  if (!isHtmlElement(handle)) {
    process.env.NODE_ENV !== "production" ? warning$1('drag handle needs to be a HTMLElement') : void 0;
    return null;
  }

  return handle;
}

function useFocusMarshal(contextId) {
  var entriesRef = React.useRef({});
  var recordRef = React.useRef(null);
  var restoreFocusFrameRef = React.useRef(null);
  var isMountedRef = React.useRef(false);
  var register = useCallback(function register(id, focus) {
    var entry = {
      id: id,
      focus: focus
    };
    entriesRef.current[id] = entry;
    return function unregister() {
      var entries = entriesRef.current;
      var current = entries[id];

      if (current !== entry) {
        delete entries[id];
      }
    };
  }, []);
  var tryGiveFocus = useCallback(function tryGiveFocus(tryGiveFocusTo) {
    var handle = findDragHandle(contextId, tryGiveFocusTo);

    if (handle && handle !== document.activeElement) {
      handle.focus();
    }
  }, [contextId]);
  var tryShiftRecord = useCallback(function tryShiftRecord(previous, redirectTo) {
    if (recordRef.current === previous) {
      recordRef.current = redirectTo;
    }
  }, []);
  var tryRestoreFocusRecorded = useCallback(function tryRestoreFocusRecorded() {
    if (restoreFocusFrameRef.current) {
      return;
    }

    if (!isMountedRef.current) {
      return;
    }

    restoreFocusFrameRef.current = requestAnimationFrame(function () {
      restoreFocusFrameRef.current = null;
      var record = recordRef.current;

      if (record) {
        tryGiveFocus(record);
      }
    });
  }, [tryGiveFocus]);
  var tryRecordFocus = useCallback(function tryRecordFocus(id) {
    recordRef.current = null;
    var focused = document.activeElement;

    if (!focused) {
      return;
    }

    if (focused.getAttribute(dragHandle.draggableId) !== id) {
      return;
    }

    recordRef.current = id;
  }, []);
  useIsomorphicLayoutEffect$1(function () {
    isMountedRef.current = true;
    return function clearFrameOnUnmount() {
      isMountedRef.current = false;
      var frameId = restoreFocusFrameRef.current;

      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  }, []);
  var marshal = useMemo(function () {
    return {
      register: register,
      tryRecordFocus: tryRecordFocus,
      tryRestoreFocusRecorded: tryRestoreFocusRecorded,
      tryShiftRecord: tryShiftRecord
    };
  }, [register, tryRecordFocus, tryRestoreFocusRecorded, tryShiftRecord]);
  return marshal;
}

function createRegistry() {
  var entries = {
    draggables: {},
    droppables: {}
  };
  var subscribers = [];

  function subscribe(cb) {
    subscribers.push(cb);
    return function unsubscribe() {
      var index = subscribers.indexOf(cb);

      if (index === -1) {
        return;
      }

      subscribers.splice(index, 1);
    };
  }

  function notify(event) {
    if (subscribers.length) {
      subscribers.forEach(function (cb) {
        return cb(event);
      });
    }
  }

  function findDraggableById(id) {
    return entries.draggables[id] || null;
  }

  function getDraggableById(id) {
    var entry = findDraggableById(id);
    !entry ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot find draggable entry with id [" + id + "]") : invariant(false) : void 0;
    return entry;
  }

  var draggableAPI = {
    register: function register(entry) {
      entries.draggables[entry.descriptor.id] = entry;
      notify({
        type: 'ADDITION',
        value: entry
      });
    },
    update: function update(entry, last) {
      var current = entries.draggables[last.descriptor.id];

      if (!current) {
        return;
      }

      if (current.uniqueId !== entry.uniqueId) {
        return;
      }

      delete entries.draggables[last.descriptor.id];
      entries.draggables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var draggableId = entry.descriptor.id;
      var current = findDraggableById(draggableId);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.draggables[draggableId];
      notify({
        type: 'REMOVAL',
        value: entry
      });
    },
    getById: getDraggableById,
    findById: findDraggableById,
    exists: function exists(id) {
      return Boolean(findDraggableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.draggables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function findDroppableById(id) {
    return entries.droppables[id] || null;
  }

  function getDroppableById(id) {
    var entry = findDroppableById(id);
    !entry ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot find droppable entry with id [" + id + "]") : invariant(false) : void 0;
    return entry;
  }

  var droppableAPI = {
    register: function register(entry) {
      entries.droppables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var current = findDroppableById(entry.descriptor.id);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.droppables[entry.descriptor.id];
    },
    getById: getDroppableById,
    findById: findDroppableById,
    exists: function exists(id) {
      return Boolean(findDroppableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.droppables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function clean() {
    entries.draggables = {};
    entries.droppables = {};
    subscribers.length = 0;
  }

  return {
    draggable: draggableAPI,
    droppable: droppableAPI,
    subscribe: subscribe,
    clean: clean
  };
}

function useRegistry() {
  var registry = useMemo(createRegistry, []);
  React.useEffect(function () {
    return function unmount() {
      requestAnimationFrame(registry.clean);
    };
  }, [registry]);
  return registry;
}

var StoreContext = React__default["default"].createContext(null);

var getBodyElement = (function () {
  var body = document.body;
  !body ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find document.body') : invariant(false) : void 0;
  return body;
});

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};

var getId = function getId(contextId) {
  return "rbd-announcement-" + contextId;
};
function useAnnouncer(contextId) {
  var id = useMemo(function () {
    return getId(contextId);
  }, [contextId]);
  var ref = React.useRef(null);
  React.useEffect(function setup() {
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('aria-atomic', 'true');

    _extends$y(el.style, visuallyHidden);

    getBodyElement().appendChild(el);
    return function cleanup() {
      setTimeout(function remove() {
        var body = getBodyElement();

        if (body.contains(el)) {
          body.removeChild(el);
        }

        if (el === ref.current) {
          ref.current = null;
        }
      });
    };
  }, [id]);
  var announce = useCallback(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }

    process.env.NODE_ENV !== "production" ? warning$1("\n      A screen reader message was trying to be announced but it was unable to do so.\n      This can occur if you unmount your <DragDropContext /> in your onDragEnd.\n      Consider calling provided.announce() before the unmount so that the instruction will\n      not be lost for users relying on a screen reader.\n\n      Message not passed to screen reader:\n\n      \"" + message + "\"\n    ") : void 0;
  }, []);
  return announce;
}

var count = 0;
var defaults = {
  separator: '::'
};
function useUniqueId(prefix, options) {
  if (options === void 0) {
    options = defaults;
  }

  return useMemo(function () {
    return "" + prefix + options.separator + count++;
  }, [options.separator, prefix]);
}

function getElementId(_ref) {
  var contextId = _ref.contextId,
      uniqueId = _ref.uniqueId;
  return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function useHiddenTextElement(_ref2) {
  var contextId = _ref2.contextId,
      text = _ref2.text;
  var uniqueId = useUniqueId('hidden-text', {
    separator: '-'
  });
  var id = useMemo(function () {
    return getElementId({
      contextId: contextId,
      uniqueId: uniqueId
    });
  }, [uniqueId, contextId]);
  React.useEffect(function mount() {
    var el = document.createElement('div');
    el.id = id;
    el.textContent = text;
    el.style.display = 'none';
    getBodyElement().appendChild(el);
    return function unmount() {
      var body = getBodyElement();

      if (body.contains(el)) {
        body.removeChild(el);
      }
    };
  }, [id, text]);
  return id;
}

var AppContext = React__default["default"].createContext(null);

var peerDependencies = {
	react: "^16.8.5",
	"react-dom": "^16.8.5"
};

var semver = /(\d+)\.(\d+)\.(\d+)/;

var getVersion = function getVersion(value) {
  var result = semver.exec(value);
  !(result != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Unable to parse React version " + value) : invariant(false) : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch = Number(result[3]);
  return {
    major: major,
    minor: minor,
    patch: patch,
    raw: value
  };
};

var isSatisfied = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }

  if (actual.major < expected.major) {
    return false;
  }

  if (actual.minor > expected.minor) {
    return true;
  }

  if (actual.minor < expected.minor) {
    return false;
  }

  return actual.patch >= expected.patch;
};

var checkReactVersion = (function (peerDepValue, actualValue) {
  var peerDep = getVersion(peerDepValue);
  var actual = getVersion(actualValue);

  if (isSatisfied(peerDep, actual)) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    React version: [" + actual.raw + "]\n    does not satisfy expected peer dependency version: [" + peerDep.raw + "]\n\n    This can result in run time bugs, and even fatal crashes\n  ") : void 0;
});

var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = (function (doc) {
  var doctype = doc.doctype;

  if (!doctype) {
    process.env.NODE_ENV !== "production" ? warning$1("\n      No <!doctype html> found.\n\n      " + suffix + "\n    ") : void 0;
    return;
  }

  if (doctype.name.toLowerCase() !== 'html') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Unexpected <!doctype> found: (" + doctype.name + ")\n\n      " + suffix + "\n    ") : void 0;
  }

  if (doctype.publicId !== '') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Unexpected <!doctype> publicId found: (" + doctype.publicId + ")\n      A html5 doctype does not have a publicId\n\n      " + suffix + "\n    ") : void 0;
  }
});

function useDev(useHook) {
  if (process.env.NODE_ENV !== 'production') {
    useHook();
  }
}

function useDevSetupWarning(fn, inputs) {
  useDev(function () {
    React.useEffect(function () {
      try {
        fn();
      } catch (e) {
        error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
      }
    }, inputs);
  });
}

function useStartupValidation() {
  useDevSetupWarning(function () {
    checkReactVersion(peerDependencies.react, React__default["default"].version);
    checkDoctype(document);
  }, []);
}

function usePrevious(current) {
  var ref = React.useRef(current);
  React.useEffect(function () {
    ref.current = current;
  });
  return ref;
}

function create() {
  var lock = null;

  function isClaimed() {
    return Boolean(lock);
  }

  function isActive(value) {
    return value === lock;
  }

  function claim(abandon) {
    !!lock ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot claim lock as it is already claimed') : invariant(false) : void 0;
    var newLock = {
      abandon: abandon
    };
    lock = newLock;
    return newLock;
  }

  function release() {
    !lock ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot release lock when there is no lock') : invariant(false) : void 0;
    lock = null;
  }

  function tryAbandon() {
    if (lock) {
      lock.abandon();
      release();
    }
  }

  return {
    isClaimed: isClaimed,
    isActive: isActive,
    claim: claim,
    release: release,
    tryAbandon: tryAbandon
  };
}

var tab = 9;
var enter = 13;
var escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var primaryButton = 0;
var sloppyClickThreshold = 5;

function isSloppyClickThresholdExceeded(original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}

var idle$1 = {
  type: 'IDLE'
};

function getCaptureBindings(_ref) {
  var cancel = _ref.cancel,
      completed = _ref.completed,
      getPhase = _ref.getPhase,
      setPhase = _ref.setPhase;
  return [{
    eventName: 'mousemove',
    fn: function fn(event) {
      var button = event.button,
          clientX = event.clientX,
          clientY = event.clientY;

      if (button !== primaryButton) {
        return;
      }

      var point = {
        x: clientX,
        y: clientY
      };
      var phase = getPhase();

      if (phase.type === 'DRAGGING') {
        event.preventDefault();
        phase.actions.move(point);
        return;
      }

      !(phase.type === 'PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot be IDLE') : invariant(false) : void 0;
      var pending = phase.point;

      if (!isSloppyClickThresholdExceeded(pending, point)) {
        return;
      }

      event.preventDefault();
      var actions = phase.actions.fluidLift(point);
      setPhase({
        type: 'DRAGGING',
        actions: actions
      });
    }
  }, {
    eventName: 'mouseup',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'mousedown',
    fn: function fn(event) {
      if (getPhase().type === 'DRAGGING') {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        cancel();
        return;
      }

      if (event.keyCode === escape) {
        event.preventDefault();
        cancel();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn() {
      if (getPhase().type === 'PENDING') {
        cancel();
      }
    }
  }, {
    eventName: 'webkitmouseforcedown',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Unexpected phase') : invariant(false) : void 0;

      if (phase.actions.shouldRespectForcePress()) {
        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor(api) {
  var phaseRef = React.useRef(idle$1);
  var unbindEventsRef = React.useRef(noop);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'mousedown',
      fn: function onMouseDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.button !== primaryButton) {
          return;
        }

        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        event.preventDefault();
        var point = {
          x: event.clientX,
          y: event.clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var preventForcePressBinding = useMemo(function () {
    return {
      eventName: 'webkitmouseforcewillbegin',
      fn: function fn(event) {
        if (event.defaultPrevented) {
          return;
        }

        var id = api.findClosestDraggableId(event);

        if (!id) {
          return;
        }

        var options = api.findOptionsForDraggable(id);

        if (!options) {
          return;
        }

        if (options.shouldRespectForcePress) {
          return;
        }

        if (!api.canGetLock(id)) {
          return;
        }

        event.preventDefault();
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [preventForcePressBinding, startCaptureBinding], options);
  }, [preventForcePressBinding, startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    phaseRef.current = idle$1;
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var bindings = getCaptureBindings({
      cancel: cancel,
      completed: stop,
      getPhase: function getPhase() {
        return phaseRef.current;
      },
      setPhase: function setPhase(phase) {
        phaseRef.current = phase;
      }
    });
    unbindEventsRef.current = bindEvents(window, bindings, options);
  }, [cancel, stop]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(phaseRef.current.type === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected to move from IDLE to PENDING drag') : invariant(false) : void 0;
    phaseRef.current = {
      type: 'PENDING',
      point: point,
      actions: actions
    };
    bindCapturingEvents();
  }, [bindCapturingEvents]);
  useIsomorphicLayoutEffect$1(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var _scrollJumpKeys;

function noop$1() {}

var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

function getDraggingBindings(actions, stop) {
  function cancel() {
    stop();
    actions.cancel();
  }

  function drop() {
    stop();
    actions.drop();
  }

  return [{
    eventName: 'keydown',
    fn: function fn(event) {
      if (event.keyCode === escape) {
        event.preventDefault();
        cancel();
        return;
      }

      if (event.keyCode === space) {
        event.preventDefault();
        drop();
        return;
      }

      if (event.keyCode === arrowDown) {
        event.preventDefault();
        actions.moveDown();
        return;
      }

      if (event.keyCode === arrowUp) {
        event.preventDefault();
        actions.moveUp();
        return;
      }

      if (event.keyCode === arrowRight) {
        event.preventDefault();
        actions.moveRight();
        return;
      }

      if (event.keyCode === arrowLeft) {
        event.preventDefault();
        actions.moveLeft();
        return;
      }

      if (scrollJumpKeys[event.keyCode]) {
        event.preventDefault();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'mousedown',
    fn: cancel
  }, {
    eventName: 'mouseup',
    fn: cancel
  }, {
    eventName: 'click',
    fn: cancel
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'wheel',
    fn: cancel,
    options: {
      passive: true
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useKeyboardSensor(api) {
  var unbindEventsRef = React.useRef(noop$1);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'keydown',
      fn: function onKeyDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.keyCode !== space) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var preDrag = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!preDrag) {
          return;
        }

        event.preventDefault();
        var isCapturing = true;
        var actions = preDrag.snapLift();
        unbindEventsRef.current();

        function stop() {
          !isCapturing ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot stop capturing a keyboard drag when not capturing') : invariant(false) : void 0;
          isCapturing = false;
          unbindEventsRef.current();
          listenForCapture();
        }

        unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
          capture: true,
          passive: false
        });
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function tryStartCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  useIsomorphicLayoutEffect$1(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var idle$2 = {
  type: 'IDLE'
};
var timeForLongPress = 120;
var forcePressThreshold = 0.15;

function getWindowBindings(_ref) {
  var cancel = _ref.cancel,
      getPhase = _ref.getPhase;
  return [{
    eventName: 'orientationchange',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'contextmenu',
    fn: function fn(event) {
      event.preventDefault();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      if (event.keyCode === escape) {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function getHandleBindings(_ref2) {
  var cancel = _ref2.cancel,
      completed = _ref2.completed,
      getPhase = _ref2.getPhase;
  return [{
    eventName: 'touchmove',
    options: {
      capture: false
    },
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      phase.hasMoved = true;
      var _event$touches$ = event.touches[0],
          clientX = _event$touches$.clientX,
          clientY = _event$touches$.clientY;
      var point = {
        x: clientX,
        y: clientY
      };
      event.preventDefault();
      phase.actions.move(point);
    }
  }, {
    eventName: 'touchend',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'touchcancel',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      cancel();
    }
  }, {
    eventName: 'touchforcechange',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
      var touch = event.touches[0];

      if (!touch) {
        return;
      }

      var isForcePress = touch.force >= forcePressThreshold;

      if (!isForcePress) {
        return;
      }

      var shouldRespect = phase.actions.shouldRespectForcePress();

      if (phase.type === 'PENDING') {
        if (shouldRespect) {
          cancel();
        }

        return;
      }

      if (shouldRespect) {
        if (phase.hasMoved) {
          event.preventDefault();
          return;
        }

        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor$1(api) {
  var phaseRef = React.useRef(idle$2);
  var unbindEventsRef = React.useRef(noop);
  var getPhase = useCallback(function getPhase() {
    return phaseRef.current;
  }, []);
  var setPhase = useCallback(function setPhase(phase) {
    phaseRef.current = phase;
  }, []);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'touchstart',
      fn: function onTouchStart(event) {
        if (event.defaultPrevented) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        var touch = event.touches[0];
        var clientX = touch.clientX,
            clientY = touch.clientY;
        var point = {
          x: clientX,
          y: clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      capture: true,
      passive: false
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    if (current.type === 'PENDING') {
      clearTimeout(current.longPressTimerId);
    }

    setPhase(idle$2);
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture, setPhase]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var args = {
      cancel: cancel,
      completed: stop,
      getPhase: getPhase
    };
    var unbindTarget = bindEvents(window, getHandleBindings(args), options);
    var unbindWindow = bindEvents(window, getWindowBindings(args), options);

    unbindEventsRef.current = function unbindAll() {
      unbindTarget();
      unbindWindow();
    };
  }, [cancel, getPhase, stop]);
  var startDragging = useCallback(function startDragging() {
    var phase = getPhase();
    !(phase.type === 'PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot start dragging from phase " + phase.type) : invariant(false) : void 0;
    var actions = phase.actions.fluidLift(phase.point);
    setPhase({
      type: 'DRAGGING',
      actions: actions,
      hasMoved: false
    });
  }, [getPhase, setPhase]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(getPhase().type === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected to move from IDLE to PENDING drag') : invariant(false) : void 0;
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    setPhase({
      type: 'PENDING',
      point: point,
      actions: actions,
      longPressTimerId: longPressTimerId
    });
    bindCapturingEvents();
  }, [bindCapturingEvents, getPhase, setPhase, startDragging]);
  useIsomorphicLayoutEffect$1(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        clearTimeout(phase.longPressTimerId);
        setPhase(idle$2);
      }
    };
  }, [getPhase, listenForCapture, setPhase]);
  useIsomorphicLayoutEffect$1(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: 'touchmove',
      fn: function fn() {},
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
}

function useValidateSensorHooks(sensorHooks) {
  useDev(function () {
    var previousRef = usePrevious(sensorHooks);
    useDevSetupWarning(function () {
      !(previousRef.current.length === sensorHooks.length) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot change the amount of sensor hooks after mounting') : invariant(false) : void 0;
    });
  });
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
}

function isEventInInteractiveElement(draggable, event) {
  var target = event.target;

  if (!isHtmlElement(target)) {
    return false;
  }

  return isAnInteractiveElement(draggable, target);
}

var getBorderBoxCenterPosition = (function (el) {
  return getRect(el.getBoundingClientRect()).center;
});

function isElement(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var supportedMatchesName = function () {
  var base = 'matches';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, 'msMatchesSelector', 'webkitMatchesSelector'];
  var value = find(candidates, function (name) {
    return name in Element.prototype;
  });
  return value || base;
}();

function closestPonyfill(el, selector) {
  if (el == null) {
    return null;
  }

  if (el[supportedMatchesName](selector)) {
    return el;
  }

  return closestPonyfill(el.parentElement, selector);
}

function closest$1(el, selector) {
  if (el.closest) {
    return el.closest(selector);
  }

  return closestPonyfill(el, selector);
}

function getSelector(contextId) {
  return "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
}

function findClosestDragHandleFromEvent(contextId, event) {
  var target = event.target;

  if (!isElement(target)) {
    process.env.NODE_ENV !== "production" ? warning$1('event.target must be a Element') : void 0;
    return null;
  }

  var selector = getSelector(contextId);
  var handle = closest$1(target, selector);

  if (!handle) {
    return null;
  }

  if (!isHtmlElement(handle)) {
    process.env.NODE_ENV !== "production" ? warning$1('drag handle must be a HTMLElement') : void 0;
    return null;
  }

  return handle;
}

function tryGetClosestDraggableIdFromEvent(contextId, event) {
  var handle = findClosestDragHandleFromEvent(contextId, event);

  if (!handle) {
    return null;
  }

  return handle.getAttribute(dragHandle.draggableId);
}

function findDraggable(contextId, draggableId) {
  var selector = "[" + draggable.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));
  var draggable$1 = find(possible, function (el) {
    return el.getAttribute(draggable.id) === draggableId;
  });

  if (!draggable$1) {
    return null;
  }

  if (!isHtmlElement(draggable$1)) {
    process.env.NODE_ENV !== "production" ? warning$1('Draggable element is not a HTMLElement') : void 0;
    return null;
  }

  return draggable$1;
}

function preventDefault(event) {
  event.preventDefault();
}

function _isActive(_ref) {
  var expected = _ref.expected,
      phase = _ref.phase,
      isLockActive = _ref.isLockActive,
      shouldWarn = _ref.shouldWarn;

  if (!isLockActive()) {
    if (shouldWarn) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Cannot perform action.\n        The sensor no longer has an action lock.\n\n        Tips:\n\n        - Throw away your action handlers when forceStop() is called\n        - Check actions.isActive() if you really need to\n      ") : void 0;
    }

    return false;
  }

  if (expected !== phase) {
    if (shouldWarn) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Cannot perform action.\n        The actions you used belong to an outdated phase\n\n        Current phase: " + expected + "\n        You called an action from outdated phase: " + phase + "\n\n        Tips:\n\n        - Do not use preDragActions actions after calling preDragActions.lift()\n      ") : void 0;
    }

    return false;
  }

  return true;
}

function canStart(_ref2) {
  var lockAPI = _ref2.lockAPI,
      store = _ref2.store,
      registry = _ref2.registry,
      draggableId = _ref2.draggableId;

  if (lockAPI.isClaimed()) {
    return false;
  }

  var entry = registry.draggable.findById(draggableId);

  if (!entry) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find draggable with id: " + draggableId) : void 0;
    return false;
  }

  if (!entry.options.isEnabled) {
    return false;
  }

  if (!canStartDrag(store.getState(), draggableId)) {
    return false;
  }

  return true;
}

function tryStart(_ref3) {
  var lockAPI = _ref3.lockAPI,
      contextId = _ref3.contextId,
      store = _ref3.store,
      registry = _ref3.registry,
      draggableId = _ref3.draggableId,
      forceSensorStop = _ref3.forceSensorStop,
      sourceEvent = _ref3.sourceEvent;
  var shouldStart = canStart({
    lockAPI: lockAPI,
    store: store,
    registry: registry,
    draggableId: draggableId
  });

  if (!shouldStart) {
    return null;
  }

  var entry = registry.draggable.getById(draggableId);
  var el = findDraggable(contextId, entry.descriptor.id);

  if (!el) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find draggable element with id: " + draggableId) : void 0;
    return null;
  }

  if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) {
    return null;
  }

  var lock = lockAPI.claim(forceSensorStop || noop);
  var phase = 'PRE_DRAG';

  function getShouldRespectForcePress() {
    return entry.options.shouldRespectForcePress;
  }

  function isLockActive() {
    return lockAPI.isActive(lock);
  }

  function tryDispatch(expected, getAction) {
    if (_isActive({
      expected: expected,
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    })) {
      store.dispatch(getAction());
    }
  }

  var tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');

  function lift$1(args) {
    function completed() {
      lockAPI.release();
      phase = 'COMPLETED';
    }

    if (phase !== 'PRE_DRAG') {
      completed();
      !(phase === 'PRE_DRAG') ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot lift in phase " + phase) : invariant(false) : void 0;
    }

    store.dispatch(lift(args.liftActionArgs));
    phase = 'DRAGGING';

    function finish(reason, options) {
      if (options === void 0) {
        options = {
          shouldBlockNextClick: false
        };
      }

      args.cleanup();

      if (options.shouldBlockNextClick) {
        var unbind = bindEvents(window, [{
          eventName: 'click',
          fn: preventDefault,
          options: {
            once: true,
            passive: false,
            capture: true
          }
        }]);
        setTimeout(unbind);
      }

      completed();
      store.dispatch(drop({
        reason: reason
      }));
    }

    return _extends$y({
      isActive: function isActive() {
        return _isActive({
          expected: 'DRAGGING',
          phase: phase,
          isLockActive: isLockActive,
          shouldWarn: false
        });
      },
      shouldRespectForcePress: getShouldRespectForcePress,
      drop: function drop(options) {
        return finish('DROP', options);
      },
      cancel: function cancel(options) {
        return finish('CANCEL', options);
      }
    }, args.actions);
  }

  function fluidLift(clientSelection) {
    var move$1$1 = rafSchd(function (client) {
      tryDispatchWhenDragging(function () {
        return move$1({
          client: client
        });
      });
    });
    var api = lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: clientSelection,
        movementMode: 'FLUID'
      },
      cleanup: function cleanup() {
        return move$1$1.cancel();
      },
      actions: {
        move: move$1$1
      }
    });
    return _extends$y({}, api, {
      move: move$1$1
    });
  }

  function snapLift() {
    var actions = {
      moveUp: function moveUp$1() {
        return tryDispatchWhenDragging(moveUp);
      },
      moveRight: function moveRight$1() {
        return tryDispatchWhenDragging(moveRight);
      },
      moveDown: function moveDown$1() {
        return tryDispatchWhenDragging(moveDown);
      },
      moveLeft: function moveLeft$1() {
        return tryDispatchWhenDragging(moveLeft);
      }
    };
    return lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: getBorderBoxCenterPosition(el),
        movementMode: 'SNAP'
      },
      cleanup: noop,
      actions: actions
    });
  }

  function abortPreDrag() {
    var shouldRelease = _isActive({
      expected: 'PRE_DRAG',
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    });

    if (shouldRelease) {
      lockAPI.release();
    }
  }

  var preDrag = {
    isActive: function isActive() {
      return _isActive({
        expected: 'PRE_DRAG',
        phase: phase,
        isLockActive: isLockActive,
        shouldWarn: false
      });
    },
    shouldRespectForcePress: getShouldRespectForcePress,
    fluidLift: fluidLift,
    snapLift: snapLift,
    abort: abortPreDrag
  };
  return preDrag;
}

var defaultSensors = [useMouseSensor, useKeyboardSensor, useMouseSensor$1];
function useSensorMarshal(_ref4) {
  var contextId = _ref4.contextId,
      store = _ref4.store,
      registry = _ref4.registry,
      customSensors = _ref4.customSensors,
      enableDefaultSensors = _ref4.enableDefaultSensors;
  var useSensors = [].concat(enableDefaultSensors ? defaultSensors : [], customSensors || []);
  var lockAPI = React.useState(function () {
    return create();
  })[0];
  var tryAbandonLock = useCallback(function tryAbandonLock(previous, current) {
    if (previous.isDragging && !current.isDragging) {
      lockAPI.tryAbandon();
    }
  }, [lockAPI]);
  useIsomorphicLayoutEffect$1(function listenToStore() {
    var previous = store.getState();
    var unsubscribe = store.subscribe(function () {
      var current = store.getState();
      tryAbandonLock(previous, current);
      previous = current;
    });
    return unsubscribe;
  }, [lockAPI, store, tryAbandonLock]);
  useIsomorphicLayoutEffect$1(function () {
    return lockAPI.tryAbandon;
  }, [lockAPI.tryAbandon]);
  var canGetLock = useCallback(function (draggableId) {
    return canStart({
      lockAPI: lockAPI,
      registry: registry,
      store: store,
      draggableId: draggableId
    });
  }, [lockAPI, registry, store]);
  var tryGetLock = useCallback(function (draggableId, forceStop, options) {
    return tryStart({
      lockAPI: lockAPI,
      registry: registry,
      contextId: contextId,
      store: store,
      draggableId: draggableId,
      forceSensorStop: forceStop,
      sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
    });
  }, [contextId, lockAPI, registry, store]);
  var findClosestDraggableId = useCallback(function (event) {
    return tryGetClosestDraggableIdFromEvent(contextId, event);
  }, [contextId]);
  var findOptionsForDraggable = useCallback(function (id) {
    var entry = registry.draggable.findById(id);
    return entry ? entry.options : null;
  }, [registry.draggable]);
  var tryReleaseLock = useCallback(function tryReleaseLock() {
    if (!lockAPI.isClaimed()) {
      return;
    }

    lockAPI.tryAbandon();

    if (store.getState().phase !== 'IDLE') {
      store.dispatch(flush());
    }
  }, [lockAPI, store]);
  var isLockClaimed = useCallback(lockAPI.isClaimed, [lockAPI]);
  var api = useMemo(function () {
    return {
      canGetLock: canGetLock,
      tryGetLock: tryGetLock,
      findClosestDraggableId: findClosestDraggableId,
      findOptionsForDraggable: findOptionsForDraggable,
      tryReleaseLock: tryReleaseLock,
      isLockClaimed: isLockClaimed
    };
  }, [canGetLock, tryGetLock, findClosestDraggableId, findOptionsForDraggable, tryReleaseLock, isLockClaimed]);
  useValidateSensorHooks(useSensors);

  for (var i = 0; i < useSensors.length; i++) {
    useSensors[i](api);
  }
}

var createResponders = function createResponders(props) {
  return {
    onBeforeCapture: props.onBeforeCapture,
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find store from lazy ref') : invariant(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var contextId = props.contextId,
      setCallbacks = props.setCallbacks,
      sensors = props.sensors,
      nonce = props.nonce,
      dragHandleUsageInstructions = props.dragHandleUsageInstructions;
  var lazyStoreRef = React.useRef(null);
  useStartupValidation();
  var lastPropsRef = usePrevious(props);
  var getResponders = useCallback(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(contextId);
  var dragHandleUsageInstructionsId = useHiddenTextElement({
    contextId: contextId,
    text: dragHandleUsageInstructions
  });
  var styleMarshal = useStyleMarshal(contextId, nonce);
  var lazyDispatch = useCallback(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var marshalCallbacks = useMemo(function () {
    return bindActionCreators({
      publishWhileDragging: publishWhileDragging,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var registry = useRegistry();
  var dimensionMarshal = useMemo(function () {
    return createDimensionMarshal(registry, marshalCallbacks);
  }, [registry, marshalCallbacks]);
  var autoScroller = useMemo(function () {
    return createAutoScroller(_extends$y({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, bindActionCreators({
      move: move$1
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var focusMarshal = useFocusMarshal(contextId);
  var store = useMemo(function () {
    return createStore({
      announce: announce,
      autoScroller: autoScroller,
      dimensionMarshal: dimensionMarshal,
      focusMarshal: focusMarshal,
      getResponders: getResponders,
      styleMarshal: styleMarshal
    });
  }, [announce, autoScroller, dimensionMarshal, focusMarshal, getResponders, styleMarshal]);

  if (process.env.NODE_ENV !== 'production') {
    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
      process.env.NODE_ENV !== "production" ? warning$1('unexpected store change') : void 0;
    }
  }

  lazyStoreRef.current = store;
  var tryResetStore = useCallback(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(flush());
    }
  }, []);
  var isDragging = useCallback(function () {
    var state = getStore(lazyStoreRef).getState();
    return state.isDragging || state.phase === 'DROP_ANIMATING';
  }, []);
  var appCallbacks = useMemo(function () {
    return {
      isDragging: isDragging,
      tryAbort: tryResetStore
    };
  }, [isDragging, tryResetStore]);
  setCallbacks(appCallbacks);
  var getCanLift = useCallback(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = useCallback(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = useMemo(function () {
    return {
      marshal: dimensionMarshal,
      focus: focusMarshal,
      contextId: contextId,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed,
      dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
      registry: registry
    };
  }, [contextId, dimensionMarshal, dragHandleUsageInstructionsId, focusMarshal, getCanLift, getIsMovementAllowed, registry]);
  useSensorMarshal({
    contextId: contextId,
    store: store,
    registry: registry,
    customSensors: sensors,
    enableDefaultSensors: props.enableDefaultSensors !== false
  });
  React.useEffect(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return React__default["default"].createElement(AppContext.Provider, {
    value: appContext
  }, React__default["default"].createElement(Provider, {
    context: StoreContext,
    store: store
  }, props.children));
}

var count$1 = 0;
function useInstanceCount() {
  return useMemo(function () {
    return "" + count$1++;
  }, []);
}
function DragDropContext(props) {
  var contextId = useInstanceCount();
  var dragHandleUsageInstructions = props.dragHandleUsageInstructions || preset.dragHandleUsageInstructions;
  return React__default["default"].createElement(ErrorBoundary, null, function (setCallbacks) {
    return React__default["default"].createElement(App, {
      nonce: props.nonce,
      contextId: contextId,
      setCallbacks: setCallbacks,
      dragHandleUsageInstructions: dragHandleUsageInstructions,
      enableDefaultSensors: props.enableDefaultSensors,
      sensors: props.sensors,
      onBeforeCapture: props.onBeforeCapture,
      onBeforeDragStart: props.onBeforeDragStart,
      onDragStart: props.onDragStart,
      onDragUpdate: props.onDragUpdate,
      onDragEnd: props.onDragEnd
    }, props.children);
  });
}

var isEqual$1 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$1('scroll');
var isAuto = isEqual$1('auto');
var isVisible$1 = isEqual$1('visible');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isBoth = function isBoth(overflow, fn) {
  return fn(overflow.overflowX) && fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  if (process.env.NODE_ENV === 'production') {
    return false;
  }

  var body = getBodyElement();
  var html = document.documentElement;
  !html ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;

  if (!isElementScrollable(body)) {
    return false;
  }

  var htmlStyle = window.getComputedStyle(html);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };

  if (isBoth(htmlOverflow, isVisible$1)) {
    return false;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    We have detected that your <body> element might be a scroll container.\n    We have found no reliable way of detecting whether the <body> element is a scroll container.\n    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)\n\n    Because we cannot determine if the <body> is a scroll container, and generally it is not one,\n    we will be treating the <body> as *not* a scroll container\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md\n  ") : void 0;
  return false;
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var checkForNestedScrollContainers = (function (scrollable) {
  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ") : void 0;
});

var getScroll$1 = (function (el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
});

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = (function (start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
});

var getDroppableDimension = (function (_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
});

var getClient = function getClient(targetRef, closestScrollable) {
  var base = getBox(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = expand(paddingBox, base.border);
  var client = createBox({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = (function (_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = withScroll(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = getBox(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
});

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};
var getListenerOptions = (function (options) {
  return options.shouldPublishImmediately ? immediate : delayed;
});

function useRequiredContext(Context) {
  var result = React.useContext(Context);
  !result ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find required context') : invariant(false) : void 0;
  return result;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppablePublisher(args) {
  var whileDraggingRef = React.useRef(null);
  var appContext = useRequiredContext(AppContext);
  var uniqueId = useUniqueId('droppable');
  var registry = appContext.registry,
      marshal = appContext.marshal;
  var previousRef = usePrevious(args);
  var descriptor = useMemo(function () {
    return {
      id: args.droppableId,
      type: args.type,
      mode: args.mode
    };
  }, [args.droppableId, args.mode, args.type]);
  var publishedDescriptorRef = React.useRef(descriptor);
  var memoizedUpdateScroll = useMemo(function () {
    return memoizeOne(function (x, y) {
      !whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only update scroll when dragging') : invariant(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = useCallback(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = useMemo(function () {
    return rafSchd(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find scroll options while scrolling') : invariant(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = useCallback(function (windowScroll, options) {
    !!whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot collect a droppable while a drag is occurring') : invariant(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot collect without a droppable ref') : invariant(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });
    var scrollable = env.closestScrollable;

    if (scrollable) {
      scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
      scrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));

      if (process.env.NODE_ENV !== 'production') {
        checkForNestedScrollContainers(scrollable);
      }
    }

    return dimension;
  }, [appContext.contextId, descriptor, onClosestScroll, previousRef]);
  var getScrollWhileDragging = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only recollect Droppable client for Droppables that have a scroll container') : invariant(false) : void 0;
    return getScroll$1(closest);
  }, []);
  var dragStopped = useCallback(function () {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot stop drag when no active drag') : invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeAttribute(scrollContainer.contextId);
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = useCallback(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot scroll when there is no drag') : invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot scroll a droppable with no closest scrollable') : invariant(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = useMemo(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      getScrollWhileDragging: getScrollWhileDragging,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, getScrollWhileDragging, scroll]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      callbacks: callbacks
    };
  }, [callbacks, descriptor, uniqueId]);
  useIsomorphicLayoutEffect$1(function () {
    publishedDescriptorRef.current = entry.descriptor;
    registry.droppable.register(entry);
    return function () {
      if (whileDraggingRef.current) {
        process.env.NODE_ENV !== "production" ? warning$1('Unsupported: changing the droppableId or type of a Droppable during a drag') : void 0;
        dragStopped();
      }

      registry.droppable.unregister(entry);
    };
  }, [callbacks, descriptor, dragStopped, entry, marshal, registry.droppable]);
  useIsomorphicLayoutEffect$1(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect$1(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop$2() {}

var empty = {
  width: 0,
  height: 0,
  margin: noSpacing
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty;
  }

  if (animate === 'close') {
    return empty;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: animate !== 'none' ? transitions.placeholder : null
  };
};

function Placeholder(props) {
  var animateOpenTimerRef = React.useRef(null);
  var tryClearAnimateOpenTimer = useCallback(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      contextId = props.contextId;

  var _useState = React.useState(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  React.useEffect(function () {
    if (!isAnimatingOpenOnMount) {
      return noop$2;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop$2;
    }

    if (animateOpenTimerRef.current) {
      return noop$2;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = useCallback(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return React__default["default"].createElement(props.placeholder.tagName, {
    style: style,
    'data-rbd-placeholder-context-id': contextId,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1 = React__default["default"].memo(Placeholder);

var DroppableContext = React__default["default"].createContext(null);

function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ? process.env.NODE_ENV !== "production" ? invariant(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : invariant(false) : void 0;
}

function isBoolean(value) {
  return typeof value === 'boolean';
}

function runChecks(args, checks) {
  checks.forEach(function (check) {
    return check(args);
  });
}

var shared = [function required(_ref) {
  var props = _ref.props;
  !props.droppableId ? process.env.NODE_ENV !== "production" ? invariant(false, 'A Droppable requires a droppableId prop') : invariant(false) : void 0;
  !(typeof props.droppableId === 'string') ? process.env.NODE_ENV !== "production" ? invariant(false, "A Droppable requires a [string] droppableId. Provided: [" + typeof props.droppableId + "]") : invariant(false) : void 0;
}, function _boolean(_ref2) {
  var props = _ref2.props;
  !isBoolean(props.isDropDisabled) ? process.env.NODE_ENV !== "production" ? invariant(false, 'isDropDisabled must be a boolean') : invariant(false) : void 0;
  !isBoolean(props.isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant(false, 'isCombineEnabled must be a boolean') : invariant(false) : void 0;
  !isBoolean(props.ignoreContainerClipping) ? process.env.NODE_ENV !== "production" ? invariant(false, 'ignoreContainerClipping must be a boolean') : invariant(false) : void 0;
}, function ref(_ref3) {
  var getDroppableRef = _ref3.getDroppableRef;
  checkIsValidInnerRef(getDroppableRef());
}];
var standard = [function placeholder(_ref4) {
  var props = _ref4.props,
      getPlaceholderRef = _ref4.getPlaceholderRef;

  if (!props.placeholder) {
    return;
  }

  var ref = getPlaceholderRef();

  if (ref) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n      Droppable setup issue [droppableId: \"" + props.droppableId + "\"]:\n      DroppableProvided > placeholder could not be found.\n\n      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.\n      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md\n    ") : void 0;
}];
var virtual = [function hasClone(_ref5) {
  var props = _ref5.props;
  !props.renderClone ? process.env.NODE_ENV !== "production" ? invariant(false, 'Must provide a clone render function (renderClone) for virtual lists') : invariant(false) : void 0;
}, function hasNoPlaceholder(_ref6) {
  var getPlaceholderRef = _ref6.getPlaceholderRef;
  !!getPlaceholderRef() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected virtual list to not have a placeholder') : invariant(false) : void 0;
}];
function useValidation(args) {
  useDevSetupWarning(function () {
    runChecks(args, shared);

    if (args.props.mode === 'standard') {
      runChecks(args, standard);
    }

    if (args.props.mode === 'virtual') {
      runChecks(args, virtual);
    }
  });
}

var AnimateInOut = function (_React$PureComponent) {
  _inheritsLoose$1(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(React__default["default"].PureComponent);

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = calculateBox(borderBox, computedStyles);
  var page = withScroll(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggablePublisher(args) {
  var uniqueId = useUniqueId('draggable');
  var descriptor = args.descriptor,
      registry = args.registry,
      getDraggableRef = args.getDraggableRef,
      canDragInteractiveElements = args.canDragInteractiveElements,
      shouldRespectForcePress = args.shouldRespectForcePress,
      isEnabled = args.isEnabled;
  var options = useMemo(function () {
    return {
      canDragInteractiveElements: canDragInteractiveElements,
      shouldRespectForcePress: shouldRespectForcePress,
      isEnabled: isEnabled
    };
  }, [canDragInteractiveElements, isEnabled, shouldRespectForcePress]);
  var getDimension = useCallback(function (windowScroll) {
    var el = getDraggableRef();
    !el ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot get dimension when no ref is set') : invariant(false) : void 0;
    return getDimension$1(descriptor, el, windowScroll);
  }, [descriptor, getDraggableRef]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      options: options,
      getDimension: getDimension
    };
  }, [descriptor, getDimension, options, uniqueId]);
  var publishedRef = React.useRef(entry);
  var isFirstPublishRef = React.useRef(true);
  useIsomorphicLayoutEffect$1(function () {
    registry.draggable.register(publishedRef.current);
    return function () {
      return registry.draggable.unregister(publishedRef.current);
    };
  }, [registry.draggable]);
  useIsomorphicLayoutEffect$1(function () {
    if (isFirstPublishRef.current) {
      isFirstPublishRef.current = false;
      return;
    }

    var last = publishedRef.current;
    publishedRef.current = entry;
    registry.draggable.update(entry, last);
  }, [entry, registry.draggable]);
}

function useValidation$1(props, contextId, getRef) {
  useDevSetupWarning(function () {
    function prefix(id) {
      return "Draggable[id: " + id + "]: ";
    }

    var id = props.draggableId;
    !id ? process.env.NODE_ENV !== "production" ? invariant(false, 'Draggable requires a draggableId') : invariant(false) : void 0;
    !(typeof id === 'string') ? process.env.NODE_ENV !== "production" ? invariant(false, "Draggable requires a [string] draggableId.\n      Provided: [type: " + typeof id + "] (value: " + id + ")") : invariant(false) : void 0;
    !isInteger$1(props.index) ? process.env.NODE_ENV !== "production" ? invariant(false, prefix(id) + " requires an integer index prop") : invariant(false) : void 0;

    if (props.mapped.type === 'DRAGGING') {
      return;
    }

    checkIsValidInnerRef(getRef());

    if (props.isEnabled) {
      !findDragHandle(contextId, id) ? process.env.NODE_ENV !== "production" ? invariant(false, prefix(id) + " Unable to find drag handle") : invariant(false) : void 0;
    }
  });
}
function useClonePropValidation(isClone) {
  useDev(function () {
    var initialRef = React.useRef(isClone);
    useDevSetupWarning(function () {
      !(isClone === initialRef.current) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Draggable isClone prop value changed during component life') : invariant(false) : void 0;
    }, [isClone]);
  });
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function Draggable(props) {
  var ref = React.useRef(null);
  var setRef = useCallback(function (el) {
    ref.current = el;
  }, []);
  var getRef = useCallback(function () {
    return ref.current;
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      contextId = _useRequiredContext.contextId,
      dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId,
      registry = _useRequiredContext.registry;

  var _useRequiredContext2 = useRequiredContext(DroppableContext),
      type = _useRequiredContext2.type,
      droppableId = _useRequiredContext2.droppableId;

  var descriptor = useMemo(function () {
    return {
      id: props.draggableId,
      index: props.index,
      type: type,
      droppableId: droppableId
    };
  }, [props.draggableId, props.index, type, droppableId]);
  var children = props.children,
      draggableId = props.draggableId,
      isEnabled = props.isEnabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.canDragInteractiveElements,
      isClone = props.isClone,
      mapped = props.mapped,
      dropAnimationFinishedAction = props.dropAnimationFinished;
  useValidation$1(props, contextId, getRef);
  useClonePropValidation(isClone);

  if (!isClone) {
    var forPublisher = useMemo(function () {
      return {
        descriptor: descriptor,
        registry: registry,
        getDraggableRef: getRef,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress,
        isEnabled: isEnabled
      };
    }, [descriptor, registry, getRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled]);
    useDraggablePublisher(forPublisher);
  }

  var dragHandleProps = useMemo(function () {
    return isEnabled ? {
      tabIndex: 0,
      role: 'button',
      'aria-describedby': dragHandleUsageInstructionsId,
      'data-rbd-drag-handle-draggable-id': draggableId,
      'data-rbd-drag-handle-context-id': contextId,
      draggable: false,
      onDragStart: preventHtml5Dnd
    } : null;
  }, [contextId, dragHandleUsageInstructionsId, draggableId, isEnabled]);
  var onMoveEnd = useCallback(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = useMemo(function () {
    var style = getStyle$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-rbd-draggable-context-id': contextId,
        'data-rbd-draggable-id': draggableId,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [contextId, dragHandleProps, draggableId, mapped, onMoveEnd, setRef]);
  var rubric = useMemo(function () {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  }, [descriptor.droppableId, descriptor.id, descriptor.index, descriptor.type]);
  return children(provided, mapped.snapshot, rubric);
}

var isStrictEqual = (function (a, b) {
  return a === b;
});

var whatIsDraggedOverFromResult = (function (result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
});

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};

function getDraggableSelector() {
  var memoizedOffset = memoizeOne(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoizeOne(function (mode, isClone, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isClone: isClone,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getMemoizedProps = memoizeOne(function (offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
      }
    };
  });

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var isClone = ownProps.isClone;
      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine.opacity.drop : null,
        scale: _combineWith ? combine.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: mode,
          forceShouldAnimate: null,
          snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  return selector;
}

function getSecondarySnapshot(combineTargetFor) {
  return {
    isDragging: false,
    isDropAnimating: false,
    isClone: false,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: combineTargetFor,
    combineWith: null
  };
}

var atRest = {
  mapped: {
    type: 'SECONDARY',
    offset: origin,
    combineTargetFor: null,
    shouldAnimateDisplacement: true,
    snapshot: getSecondarySnapshot(null)
  }
};

function getSecondarySelector() {
  var memoizedOffset = memoizeOne(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoizeOne(getSecondarySnapshot);
  var getMemoizedProps = memoizeOne(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getMemoizedSnapshot(combineTargetFor)
      }
    };
  });

  var getFallback = function getFallback(combineTargetFor) {
    return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
  };

  var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
    var visualDisplacement = impact.displaced.visible[ownId];
    var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
    var combine = tryGetCombine(impact);
    var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;

    if (!visualDisplacement) {
      if (!isAfterCriticalInVirtualList) {
        return getFallback(combineTargetFor);
      }

      if (impact.displaced.invisible[ownId]) {
        return null;
      }

      var change = negate(afterCritical.displacedBy.point);

      var _offset = memoizedOffset(change.x, change.y);

      return getMemoizedProps(_offset, combineTargetFor, true);
    }

    if (isAfterCriticalInVirtualList) {
      return getFallback(combineTargetFor);
    }

    var displaceBy = impact.displacedBy.point;
    var offset = memoizedOffset(displaceBy.x, displaceBy.y);
    return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
  };

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
    }

    return null;
  };

  return selector;
}

var makeMapStateToProps = function makeMapStateToProps() {
  var draggingSelector = getDraggableSelector();
  var secondarySelector = getSecondarySelector();

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
  };

  return selector;
};
var mapDispatchToProps = {
  dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = connect(makeMapStateToProps, mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);

function PrivateDraggable(props) {
  var droppableContext = useRequiredContext(DroppableContext);
  var isUsingCloneFor = droppableContext.isUsingCloneFor;

  if (isUsingCloneFor === props.draggableId && !props.isClone) {
    return null;
  }

  return React__default["default"].createElement(ConnectedDraggable, props);
}
function PublicDraggable(props) {
  var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
  var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
  var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
  return React__default["default"].createElement(PrivateDraggable, _extends$y({}, props, {
    isClone: false,
    isEnabled: isEnabled,
    canDragInteractiveElements: canDragInteractiveElements,
    shouldRespectForcePress: shouldRespectForcePress
  }));
}

function Droppable(props) {
  var appContext = React.useContext(AppContext);
  !appContext ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find app context') : invariant(false) : void 0;
  var contextId = appContext.contextId,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = React.useRef(null);
  var placeholderRef = React.useRef(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      mode = props.mode,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      useClone = props.useClone,
      updateViewportMaxScroll = props.updateViewportMaxScroll,
      getContainerForClone = props.getContainerForClone;
  var getDroppableRef = useCallback(function () {
    return droppableRef.current;
  }, []);
  var setDroppableRef = useCallback(function (value) {
    droppableRef.current = value;
  }, []);
  var getPlaceholderRef = useCallback(function () {
    return placeholderRef.current;
  }, []);
  var setPlaceholderRef = useCallback(function (value) {
    placeholderRef.current = value;
  }, []);
  useValidation({
    props: props,
    getDroppableRef: getDroppableRef,
    getPlaceholderRef: getPlaceholderRef
  });
  var onPlaceholderTransitionEnd = useCallback(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppablePublisher({
    droppableId: droppableId,
    type: type,
    mode: mode,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef
  });
  var placeholder = React__default["default"].createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return React__default["default"].createElement(Placeholder$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      contextId: contextId,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = useMemo(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-rbd-droppable-id': droppableId,
        'data-rbd-droppable-context-id': contextId
      }
    };
  }, [contextId, droppableId, placeholder, setDroppableRef]);
  var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
  var droppableContext = useMemo(function () {
    return {
      droppableId: droppableId,
      type: type,
      isUsingCloneFor: isUsingCloneFor
    };
  }, [droppableId, isUsingCloneFor, type]);

  function getClone() {
    if (!useClone) {
      return null;
    }

    var dragging = useClone.dragging,
        render = useClone.render;
    var node = React__default["default"].createElement(PrivateDraggable, {
      draggableId: dragging.draggableId,
      index: dragging.source.index,
      isClone: true,
      isEnabled: true,
      shouldRespectForcePress: false,
      canDragInteractiveElements: true
    }, function (draggableProvided, draggableSnapshot) {
      return render(draggableProvided, draggableSnapshot, dragging);
    });
    return require$$1__default["default"].createPortal(node, getContainerForClone());
  }

  return React__default["default"].createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot), getClone());
}

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var idleWithAnimation = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: false
    },
    useClone: null
  };

  var idleWithoutAnimation = _extends$y({}, idleWithAnimation, {
    shouldAnimatePlaceholder: false
  });

  var getDraggableRubric = memoizeOne(function (descriptor) {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  });
  var getMapProps = memoizeOne(function (id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      var useClone = renderClone ? {
        render: renderClone,
        dragging: getDraggableRubric(dragging.descriptor)
      } : null;
      var _snapshot = {
        isDraggingOver: isDraggingOverForConsumer,
        draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
        draggingFromThisWith: draggableId,
        isUsingPlaceholder: true
      };
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: _snapshot,
        useClone: useClone
      };
    }

    if (!isEnabled) {
      return idleWithoutAnimation;
    }

    if (!isDraggingOverForImpact) {
      return idleWithAnimation;
    }

    var snapshot = {
      isDraggingOver: isDraggingOverForConsumer,
      draggingOverWith: draggableId,
      draggingFromThisWith: null,
      isUsingPlaceholder: true
    };
    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot,
      useClone: null
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;
    var isEnabled = !ownProps.isDropDisabled;
    var renderClone = ownProps.renderClone;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idleWithoutAnimation;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idleWithoutAnimation;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
    }

    if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idleWithoutAnimation;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
      var isHome = _completed.critical.droppable.id === id;

      if (wasOver) {
        return wasCombining ? idleWithAnimation : idleWithoutAnimation;
      }

      if (isHome) {
        return idleWithAnimation;
      }

      return idleWithoutAnimation;
    }

    return idleWithoutAnimation;
  };

  return selector;
};
var mapDispatchToProps$1 = {
  updateViewportMaxScroll: updateViewportMaxScroll
};

function getBody() {
  !document.body ? process.env.NODE_ENV !== "production" ? invariant(false, 'document.body is not ready') : invariant(false) : void 0;
  return document.body;
}

var defaultProps = {
  mode: 'standard',
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false,
  renderClone: null,
  getContainerForClone: getBody
};
var ConnectedDroppable = connect(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;

var lottie$1 = {exports: {}};

(function (module) {
	(typeof navigator !== "undefined") && (function(root, factory) {
	    if (module.exports) {
	        module.exports = factory(root);
	    } else {
	        root.lottie = factory(root);
	        root.bodymovin = root.lottie;
	    }
	}((window || {}), function(window) {
	var svgNS = "http://www.w3.org/2000/svg";

	var locationHref = '';

	var initialDefaultFrame = -999999;

	var subframeEnabled = true;
	var expressionsPlugin;
	/^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	var bm_pow = Math.pow;
	var bm_sqrt = Math.sqrt;
	var bm_floor = Math.floor;
	var bm_max = Math.max;
	var bm_min = Math.min;

	var BMMath = {};
	(function(){
	    var propertyNames = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"];
	    var i, len = propertyNames.length;
	    for(i=0;i<len;i+=1){
	        BMMath[propertyNames[i]] = Math[propertyNames[i]];
	    }
	}());

	function ProjectInterface(){return {};}

	BMMath.random = Math.random;
	BMMath.abs = function(val){
	    var tOfVal = typeof val;
	    if(tOfVal === 'object' && val.length){
	        var absArr = createSizedArray(val.length);
	        var i, len = val.length;
	        for(i=0;i<len;i+=1){
	            absArr[i] = Math.abs(val[i]);
	        }
	        return absArr;
	    }
	    return Math.abs(val);

	};
	var defaultCurveSegments = 150;
	var degToRads = Math.PI/180;
	var roundCorner = 0.5519;

	function styleDiv(element){
	    element.style.position = 'absolute';
	    element.style.top = 0;
	    element.style.left = 0;
	    element.style.display = 'block';
	    element.style.transformOrigin = element.style.webkitTransformOrigin = '0 0';
	    element.style.backfaceVisibility  = element.style.webkitBackfaceVisibility = 'visible';
	    element.style.transformStyle = element.style.webkitTransformStyle = element.style.mozTransformStyle = "preserve-3d";
	}

	function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier){
	    this.type = type;
	    this.currentTime = currentTime;
	    this.totalTime = totalTime;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	}

	function BMCompleteEvent(type, frameMultiplier){
	    this.type = type;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	}

	function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier){
	    this.type = type;
	    this.currentLoop = currentLoop;
	    this.totalLoops = totalLoops;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	}

	function BMSegmentStartEvent(type, firstFrame, totalFrames){
	    this.type = type;
	    this.firstFrame = firstFrame;
	    this.totalFrames = totalFrames;
	}

	function BMDestroyEvent(type, target){
	    this.type = type;
	    this.target = target;
	}

	function BMRenderFrameErrorEvent(nativeError, currentTime) {
	    this.type = 'renderFrameError';
	    this.nativeError = nativeError;
	    this.currentTime = currentTime;
	}

	function BMConfigErrorEvent(nativeError) {
	    this.type = 'configError';
	    this.nativeError = nativeError;
	}

	var createElementID = (function(){
	    var _count = 0;
	    return function createID() {
	        return '__lottie_element_' + ++_count
	    }
	}());

	function HSVtoRGB(h, s, v) {
	    var r, g, b, i, f, p, q, t;
	    i = Math.floor(h * 6);
	    f = h * 6 - i;
	    p = v * (1 - s);
	    q = v * (1 - f * s);
	    t = v * (1 - (1 - f) * s);
	    switch (i % 6) {
	        case 0: r = v; g = t; b = p; break;
	        case 1: r = q; g = v; b = p; break;
	        case 2: r = p; g = v; b = t; break;
	        case 3: r = p; g = q; b = v; break;
	        case 4: r = t; g = p; b = v; break;
	        case 5: r = v; g = p; b = q; break;
	    }
	    return [ r,
	        g,
	         b ];
	}

	function RGBtoHSV(r, g, b) {
	    var max = Math.max(r, g, b), min = Math.min(r, g, b),
	        d = max - min,
	        h,
	        s = (max === 0 ? 0 : d / max),
	        v = max / 255;

	    switch (max) {
	        case min: h = 0; break;
	        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
	        case g: h = (b - r) + d * 2; h /= 6 * d; break;
	        case b: h = (r - g) + d * 4; h /= 6 * d; break;
	    }

	    return [
	         h,
	         s,
	         v
	    ];
	}

	function addSaturationToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[1] += offset;
	    if (hsv[1] > 1) {
	        hsv[1] = 1;
	    }
	    else if (hsv[1] <= 0) {
	        hsv[1] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}

	function addBrightnessToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[2] += offset;
	    if (hsv[2] > 1) {
	        hsv[2] = 1;
	    }
	    else if (hsv[2] < 0) {
	        hsv[2] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}

	function addHueToRGB(color,offset) {
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[0] += offset/360;
	    if (hsv[0] > 1) {
	        hsv[0] -= 1;
	    }
	    else if (hsv[0] < 0) {
	        hsv[0] += 1;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}

	var rgbToHex = (function(){
	    var colorMap = [];
	    var i;
	    var hex;
	    for(i=0;i<256;i+=1){
	        hex = i.toString(16);
	        colorMap[i] = hex.length == 1 ? '0' + hex : hex;
	    }

	    return function(r, g, b) {
	        if(r<0){
	            r = 0;
	        }
	        if(g<0){
	            g = 0;
	        }
	        if(b<0){
	            b = 0;
	        }
	        return '#' + colorMap[r] + colorMap[g] + colorMap[b];
	    };
	}());
	function BaseEvent(){}
	BaseEvent.prototype = {
		triggerEvent: function (eventName, args) {
		    if (this._cbs[eventName]) {
		        var len = this._cbs[eventName].length;
		        for (var i = 0; i < len; i++){
		            this._cbs[eventName][i](args);
		        }
		    }
		},
		addEventListener: function (eventName, callback) {
		    if (!this._cbs[eventName]){
		        this._cbs[eventName] = [];
		    }
		    this._cbs[eventName].push(callback);

			return function() {
				this.removeEventListener(eventName, callback);
			}.bind(this);
		},
		removeEventListener: function (eventName,callback){
		    if (!callback){
		        this._cbs[eventName] = null;
		    }else if(this._cbs[eventName]){
		        var i = 0, len = this._cbs[eventName].length;
		        while(i<len){
		            if(this._cbs[eventName][i] === callback){
		                this._cbs[eventName].splice(i,1);
		                i -=1;
		                len -= 1;
		            }
		            i += 1;
		        }
		        if(!this._cbs[eventName].length){
		            this._cbs[eventName] = null;
		        }
		    }
		}
	};
	var createTypedArray = (function(){
		function createRegularArray(type, len){
			var i = 0, arr = [], value;
			switch(type) {
				case 'int16':
				case 'uint8c':
					value = 1;
					break;
				default:
					value = 1.1;
					break;
			}
			for(i = 0; i < len; i += 1) {
				arr.push(value);
			}
			return arr;
		}
		function createTypedArray(type, len){
			if(type === 'float32') {
				return new Float32Array(len);
			} else if(type === 'int16') {
				return new Int16Array(len);
			} else if(type === 'uint8c') {
				return new Uint8ClampedArray(len);
			}
		}
		if(typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
			return createTypedArray;
		} else {
			return createRegularArray;
		}
	}());

	function createSizedArray(len) {
		return Array.apply(null,{length:len});
	}
	function createNS(type) {
		//return {appendChild:function(){},setAttribute:function(){},style:{}}
		return document.createElementNS(svgNS, type);
	}
	function createTag(type) {
		//return {appendChild:function(){},setAttribute:function(){},style:{}}
		return document.createElement(type);
	}
	function DynamicPropertyContainer(){}	DynamicPropertyContainer.prototype = {
		addDynamicProperty: function(prop) {
			if(this.dynamicProperties.indexOf(prop) === -1) {
		        this.dynamicProperties.push(prop);
		        this.container.addDynamicProperty(this);
		    	this._isAnimated = true;
		    }
		},
		iterateDynamicProperties: function(){
		    this._mdf = false;
		    var i, len = this.dynamicProperties.length;
		    for(i=0;i<len;i+=1){
		        this.dynamicProperties[i].getValue();
		        if(this.dynamicProperties[i]._mdf) {
		            this._mdf = true;
		        }
		    }
		},
		initDynamicPropertyContainer: function(container){
		    this.container = container;
		    this.dynamicProperties = [];
		    this._mdf = false;
		    this._isAnimated = false;
		}
	};
	var getBlendMode = (function() {

		var blendModeEnums = {
	        0:'source-over',
	        1:'multiply',
	        2:'screen',
	        3:'overlay',
	        4:'darken',
	        5:'lighten',
	        6:'color-dodge',
	        7:'color-burn',
	        8:'hard-light',
	        9:'soft-light',
	        10:'difference',
	        11:'exclusion',
	        12:'hue',
	        13:'saturation',
	        14:'color',
	        15:'luminosity'
	    };

		return function(mode) {
			return blendModeEnums[mode] || '';
		}
	}());
	/*!
	 Transformation Matrix v2.0
	 (c) Epistemex 2014-2015
	 www.epistemex.com
	 By Ken Fyrstenberg
	 Contributions by leeoniya.
	 License: MIT, header required.
	 */

	/**
	 * 2D transformation matrix object initialized with identity matrix.
	 *
	 * The matrix can synchronize a canvas context by supplying the context
	 * as an argument, or later apply current absolute transform to an
	 * existing context.
	 *
	 * All values are handled as floating point values.
	 *
	 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	 * @prop {number} a - scale x
	 * @prop {number} b - shear y
	 * @prop {number} c - shear x
	 * @prop {number} d - scale y
	 * @prop {number} e - translate x
	 * @prop {number} f - translate y
	 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	 * @constructor
	 */

	var Matrix = (function(){

	    var _cos = Math.cos;
	    var _sin = Math.sin;
	    var _tan = Math.tan;
	    var _rnd = Math.round;

	    function reset(){
	        this.props[0] = 1;
	        this.props[1] = 0;
	        this.props[2] = 0;
	        this.props[3] = 0;
	        this.props[4] = 0;
	        this.props[5] = 1;
	        this.props[6] = 0;
	        this.props[7] = 0;
	        this.props[8] = 0;
	        this.props[9] = 0;
	        this.props[10] = 1;
	        this.props[11] = 0;
	        this.props[12] = 0;
	        this.props[13] = 0;
	        this.props[14] = 0;
	        this.props[15] = 1;
	        return this;
	    }

	    function rotate(angle) {
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	    }

	    function rotateX(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin,  mCos, 0, 0, 0, 0, 1);
	    }

	    function rotateY(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos,  0,  mSin, 0, 0, 1, 0, 0, -mSin,  0,  mCos, 0, 0, 0, 0, 1);
	    }

	    function rotateZ(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	    }

	    function shear(sx,sy){
	        return this._t(1, sy, sx, 1, 0, 0);
	    }

	    function skew(ax, ay){
	        return this.shear(_tan(ax), _tan(ay));
	    }

	    function skewFromAxis(ax, angle){
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, mSin,  0, 0, -mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1)
	            ._t(1, 0,  0, 0, _tan(ax),  1, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1)
	            ._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	        //return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	    }

	    function scale(sx, sy, sz) {
	        if(!sz && sz !== 0) {
	            sz = 1;
	        }
	        if(sx === 1 && sy === 1 && sz === 1){
	            return this;
	        }
	        return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
	    }

	    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
	        this.props[0] = a;
	        this.props[1] = b;
	        this.props[2] = c;
	        this.props[3] = d;
	        this.props[4] = e;
	        this.props[5] = f;
	        this.props[6] = g;
	        this.props[7] = h;
	        this.props[8] = i;
	        this.props[9] = j;
	        this.props[10] = k;
	        this.props[11] = l;
	        this.props[12] = m;
	        this.props[13] = n;
	        this.props[14] = o;
	        this.props[15] = p;
	        return this;
	    }

	    function translate(tx, ty, tz) {
	        tz = tz || 0;
	        if(tx !== 0 || ty !== 0 || tz !== 0){
	            return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);
	        }
	        return this;
	    }

	    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {

	        var _p = this.props;

	        if(a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0){
	            //NOTE: commenting this condition because TurboFan deoptimizes code when present
	            //if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	                _p[12] = _p[12] * a2 + _p[15] * m2;
	                _p[13] = _p[13] * f2 + _p[15] * n2;
	                _p[14] = _p[14] * k2 + _p[15] * o2;
	                _p[15] = _p[15] * p2;
	            //}
	            this._identityCalculated = false;
	            return this;
	        }

	        var a1 = _p[0];
	        var b1 = _p[1];
	        var c1 = _p[2];
	        var d1 = _p[3];
	        var e1 = _p[4];
	        var f1 = _p[5];
	        var g1 = _p[6];
	        var h1 = _p[7];
	        var i1 = _p[8];
	        var j1 = _p[9];
	        var k1 = _p[10];
	        var l1 = _p[11];
	        var m1 = _p[12];
	        var n1 = _p[13];
	        var o1 = _p[14];
	        var p1 = _p[15];

	        /* matrix order (canvas compatible):
	         * ace
	         * bdf
	         * 001
	         */
	        _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
	        _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2 ;
	        _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2 ;
	        _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2 ;

	        _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2 ;
	        _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2 ;
	        _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2 ;
	        _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2 ;

	        _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2 ;
	        _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2 ;
	        _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2 ;
	        _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2 ;

	        _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2 ;
	        _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2 ;
	        _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2 ;
	        _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2 ;

	        this._identityCalculated = false;
	        return this;
	    }

	    function isIdentity() {
	        if(!this._identityCalculated){
	            this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
	            this._identityCalculated = true;
	        }
	        return this._identity;
	    }

	    function equals(matr){
	        var i = 0;
	        while (i < 16) {
	            if(matr.props[i] !== this.props[i]) {
	                return false;
	            }
	            i+=1;
	        }
	        return true;
	    }

	    function clone(matr){
	        var i;
	        for(i=0;i<16;i+=1){
	            matr.props[i] = this.props[i];
	        }
	    }

	    function cloneFromProps(props){
	        var i;
	        for(i=0;i<16;i+=1){
	            this.props[i] = props[i];
	        }
	    }

	    function applyToPoint(x, y, z) {

	        return {
	            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
	            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
	            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
	        };
	        /*return {
	         x: x * me.a + y * me.c + me.e,
	         y: x * me.b + y * me.d + me.f
	         };*/
	    }
	    function applyToX(x, y, z) {
	        return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
	    }
	    function applyToY(x, y, z) {
	        return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
	    }
	    function applyToZ(x, y, z) {
	        return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
	    }

	    function getInverseMatrix() {
	        var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
	        var a = this.props[5]/determinant;
	        var b = - this.props[1]/determinant;
	        var c = - this.props[4]/determinant;
	        var d = this.props[0]/determinant;
	        var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12])/determinant;
	        var f = - (this.props[0] * this.props[13] - this.props[1] * this.props[12])/determinant;
	        var inverseMatrix = new Matrix();
	        inverseMatrix.props[0] = a;
	        inverseMatrix.props[1] = b;
	        inverseMatrix.props[4] = c;
	        inverseMatrix.props[5] = d;
	        inverseMatrix.props[12] = e;
	        inverseMatrix.props[13] = f;
	        return inverseMatrix;
	    }

	    function inversePoint(pt) {
	        var inverseMatrix = this.getInverseMatrix();
	        return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0)
	    }

	    function inversePoints(pts){
	        var i, len = pts.length, retPts = [];
	        for(i=0;i<len;i+=1){
	            retPts[i] = inversePoint(pts[i]);
	        }
	        return retPts;
	    }

	    function applyToTriplePoints(pt1, pt2, pt3) {
	        var arr = createTypedArray('float32', 6);
	        if(this.isIdentity()) {
	            arr[0] = pt1[0];
	            arr[1] = pt1[1];
	            arr[2] = pt2[0];
	            arr[3] = pt2[1];
	            arr[4] = pt3[0];
	            arr[5] = pt3[1];
	        } else {
	            var p0 = this.props[0], p1 = this.props[1], p4 = this.props[4], p5 = this.props[5], p12 = this.props[12], p13 = this.props[13];
	            arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
	            arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
	            arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
	            arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
	            arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
	            arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
	        }
	        return arr;
	    }

	    function applyToPointArray(x,y,z){
	        var arr;
	        if(this.isIdentity()) {
	            arr = [x,y,z];
	        } else {
	            arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
	        }
	        return arr;
	    }

	    function applyToPointStringified(x, y) {
	        if(this.isIdentity()) {
	            return x + ',' + y;
	        }
	        var _p = this.props;
	        return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100+','+ Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
	    }

	    function toCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            return '';
	        }*/
	        var i = 0;
	        var props = this.props;
	        var cssValue = 'matrix3d(';
	        var v = 10000;
	        while(i<16){
	            cssValue += _rnd(props[i]*v)/v;
	            cssValue += i === 15 ? ')':',';
	            i += 1;
	        }
	        return cssValue;
	    }

	    function roundMatrixProperty(val) {
	        var v = 10000;
	        if((val < 0.000001 && val > 0) || (val > -0.000001 && val < 0)) {
	            return _rnd(val * v) / v;
	        }
	        return val;
	    }

	    function to2dCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            return '';
	        }*/
	        var props = this.props;
	        var _a = roundMatrixProperty(props[0]);
	        var _b = roundMatrixProperty(props[1]);
	        var _c = roundMatrixProperty(props[4]);
	        var _d = roundMatrixProperty(props[5]);
	        var _e = roundMatrixProperty(props[12]);
	        var _f = roundMatrixProperty(props[13]);
	        return "matrix(" + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ")";
	    }

	    return function(){
	        this.reset = reset;
	        this.rotate = rotate;
	        this.rotateX = rotateX;
	        this.rotateY = rotateY;
	        this.rotateZ = rotateZ;
	        this.skew = skew;
	        this.skewFromAxis = skewFromAxis;
	        this.shear = shear;
	        this.scale = scale;
	        this.setTransform = setTransform;
	        this.translate = translate;
	        this.transform = transform;
	        this.applyToPoint = applyToPoint;
	        this.applyToX = applyToX;
	        this.applyToY = applyToY;
	        this.applyToZ = applyToZ;
	        this.applyToPointArray = applyToPointArray;
	        this.applyToTriplePoints = applyToTriplePoints;
	        this.applyToPointStringified = applyToPointStringified;
	        this.toCSS = toCSS;
	        this.to2dCSS = to2dCSS;
	        this.clone = clone;
	        this.cloneFromProps = cloneFromProps;
	        this.equals = equals;
	        this.inversePoints = inversePoints;
	        this.inversePoint = inversePoint;
	        this.getInverseMatrix = getInverseMatrix;
	        this._t = this.transform;
	        this.isIdentity = isIdentity;
	        this._identity = true;
	        this._identityCalculated = false;

	        this.props = createTypedArray('float32', 16);
	        this.reset();
	    };
	}());

	/*
	 Copyright 2014 David Bau.

	 Permission is hereby granted, free of charge, to any person obtaining
	 a copy of this software and associated documentation files (the
	 "Software"), to deal in the Software without restriction, including
	 without limitation the rights to use, copy, modify, merge, publish,
	 distribute, sublicense, and/or sell copies of the Software, and to
	 permit persons to whom the Software is furnished to do so, subject to
	 the following conditions:

	 The above copyright notice and this permission notice shall be
	 included in all copies or substantial portions of the Software.

	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	 */

	(function (pool, math) {
	//
	// The following constants are related to IEEE 754 limits.
	//
	    var global = this,
	        width = 256,        // each RC4 output is 0 <= x < 256
	        chunks = 6,         // at least six RC4 outputs for each double
	        digits = 52,        // there are 52 significant digits in a double
	        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
	        startdenom = math.pow(width, chunks),
	        significance = math.pow(2, digits),
	        overflow = significance * 2,
	        mask = width - 1,
	        nodecrypto;         // node.js crypto module, initialized at the bottom.

	//
	// seedrandom()
	// This is the seedrandom function described above.
	//
	    function seedrandom(seed, options, callback) {
	        var key = [];
	        options = (options === true) ? { entropy: true } : (options || {});

	        // Flatten the seed string or build one from local entropy if needed.
	        var shortseed = mixkey(flatten(
	            options.entropy ? [seed, tostring(pool)] :
	                (seed === null) ? autoseed() : seed, 3), key);

	        // Use the seed to initialize an ARC4 generator.
	        var arc4 = new ARC4(key);

	        // This function returns a random double in [0, 1) that contains
	        // randomness in every bit of the mantissa of the IEEE 754 value.
	        var prng = function() {
	            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
	                d = startdenom,                 //   and denominator d = 2 ^ 48.
	                x = 0;                          //   and no 'extra last byte'.
	            while (n < significance) {          // Fill up all significant digits by
	                n = (n + x) * width;              //   shifting numerator and
	                d *= width;                       //   denominator and generating a
	                x = arc4.g(1);                    //   new least-significant-byte.
	            }
	            while (n >= overflow) {             // To avoid rounding up, before adding
	                n /= 2;                           //   last byte, shift everything
	                d /= 2;                           //   right using integer math until
	                x >>>= 1;                         //   we have exactly the desired bits.
	            }
	            return (n + x) / d;                 // Form the number within [0, 1).
	        };

	        prng.int32 = function() { return arc4.g(4) | 0; };
	        prng.quick = function() { return arc4.g(4) / 0x100000000; };
	        prng.double = prng;

	        // Mix the randomness into accumulated entropy.
	        mixkey(tostring(arc4.S), pool);

	        // Calling convention: what to return as a function of prng, seed, is_math.
	        return (options.pass || callback ||
	        function(prng, seed, is_math_call, state) {
	            if (state) {
	                // Load the arc4 state from the given state if it has an S array.
	                if (state.S) { copy(state, arc4); }
	                // Only provide the .state method if requested via options.state.
	                prng.state = function() { return copy(arc4, {}); };
	            }

	            // If called as a method of Math (Math.seedrandom()), mutate
	            // Math.random because that is how seedrandom.js has worked since v1.0.
	            if (is_math_call) { math[rngname] = prng; return seed; }

	            // Otherwise, it is a newer calling convention, so return the
	            // prng directly.
	            else return prng;
	        })(
	            prng,
	            shortseed,
	            'global' in options ? options.global : (this == math),
	            options.state);
	    }
	    math['seed' + rngname] = seedrandom;

	//
	// ARC4
	//
	// An ARC4 implementation.  The constructor takes a key in the form of
	// an array of at most (width) integers that should be 0 <= x < (width).
	//
	// The g(count) method returns a pseudorandom integer that concatenates
	// the next (count) outputs from ARC4.  Its return value is a number x
	// that is in the range 0 <= x < (width ^ count).
	//
	    function ARC4(key) {
	        var t, keylen = key.length,
	            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

	        // The empty key [] is treated as [0].
	        if (!keylen) { key = [keylen++]; }

	        // Set up S using the standard key scheduling algorithm.
	        while (i < width) {
	            s[i] = i++;
	        }
	        for (i = 0; i < width; i++) {
	            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
	            s[j] = t;
	        }

	        // The "g" method returns the next (count) outputs as one number.
	        me.g = function(count) {
	            // Using instance members instead of closure state nearly doubles speed.
	            var t, r = 0,
	                i = me.i, j = me.j, s = me.S;
	            while (count--) {
	                t = s[i = mask & (i + 1)];
	                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
	            }
	            me.i = i; me.j = j;
	            return r;
	            // For robust unpredictability, the function call below automatically
	            // discards an initial batch of values.  This is called RC4-drop[256].
	            // See http://google.com/search?q=rsa+fluhrer+response&btnI
	        };
	    }

	//
	// copy()
	// Copies internal state of ARC4 to or from a plain object.
	//
	    function copy(f, t) {
	        t.i = f.i;
	        t.j = f.j;
	        t.S = f.S.slice();
	        return t;
	    }

	//
	// flatten()
	// Converts an object tree to nested arrays of strings.
	//
	    function flatten(obj, depth) {
	        var result = [], typ = (typeof obj), prop;
	        if (depth && typ == 'object') {
	            for (prop in obj) {
	                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
	            }
	        }
	        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
	    }

	//
	// mixkey()
	// Mixes a string seed into a key that is an array of integers, and
	// returns a shortened string seed that is equivalent to the result key.
	//
	    function mixkey(seed, key) {
	        var stringseed = seed + '', smear, j = 0;
	        while (j < stringseed.length) {
	            key[mask & j] =
	                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
	        }
	        return tostring(key);
	    }

	//
	// autoseed()
	// Returns an object for autoseeding, using window.crypto and Node crypto
	// module if available.
	//
	    function autoseed() {
	        try {
	            if (nodecrypto) ;
	            var out = new Uint8Array(width);
	            (global.crypto || global.msCrypto).getRandomValues(out);
	            return tostring(out);
	        } catch (e) {
	            var browser = global.navigator,
	                plugins = browser && browser.plugins;
	            return [+new Date(), global, plugins, global.screen, tostring(pool)];
	        }
	    }

	//
	// tostring()
	// Converts an array of charcodes to a string
	//
	    function tostring(a) {
	        return String.fromCharCode.apply(0, a);
	    }

	//
	// When seedrandom.js is loaded, we immediately mix a few bits
	// from the built-in RNG into the entropy pool.  Because we do
	// not want to interfere with deterministic PRNG state later,
	// seedrandom will not call math.random on its own again after
	// initialization.
	//
	    mixkey(math.random(), pool);

	//
	// Nodejs and AMD support: export the implementation as a module using
	// either convention.
	//

	// End anonymous scope, and pass initial values.
	})(
	    [],     // pool: entropy pool starts empty
	    BMMath    // math: package containing random, pow, and seedrandom
	);
	var BezierFactory = (function(){
	    /**
	     * BezierEasing - use bezier curve for transition easing function
	     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	     *
	     * Credits: is based on Firefox's nsSMILKeySpline.cpp
	     * Usage:
	     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	     * spline.get(x) => returns the easing value | x must be in [0, 1] range
	     *
	     */

	        var ob = {};
	    ob.getBezierEasing = getBezierEasing;
	    var beziers = {};

	    function getBezierEasing(a,b,c,d,nm){
	        var str = nm || ('bez_' + a+'_'+b+'_'+c+'_'+d).replace(/\./g, 'p');
	        if(beziers[str]){
	            return beziers[str];
	        }
	        var bezEasing = new BezierEasing([a,b,c,d]);
	        beziers[str] = bezEasing;
	        return bezEasing;
	    }

	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	    var NEWTON_ITERATIONS = 4;
	    var NEWTON_MIN_SLOPE = 0.001;
	    var SUBDIVISION_PRECISION = 0.0000001;
	    var SUBDIVISION_MAX_ITERATIONS = 10;

	    var kSplineTableSize = 11;
	    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

	    var float32ArraySupported = typeof Float32Array === "function";

	    function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	    function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	    function C (aA1)      { return 3.0 * aA1; }

	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	    function calcBezier (aT, aA1, aA2) {
	        return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
	    }

	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	    function getSlope (aT, aA1, aA2) {
	        return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	    }

	    function binarySubdivide (aX, aA, aB, mX1, mX2) {
	        var currentX, currentT, i = 0;
	        do {
	            currentT = aA + (aB - aA) / 2.0;
	            currentX = calcBezier(currentT, mX1, mX2) - aX;
	            if (currentX > 0.0) {
	                aB = currentT;
	            } else {
	                aA = currentT;
	            }
	        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	        return currentT;
	    }

	    function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	            var currentSlope = getSlope(aGuessT, mX1, mX2);
	            if (currentSlope === 0.0) return aGuessT;
	            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	            aGuessT -= currentX / currentSlope;
	        }
	        return aGuessT;
	    }

	    /**
	     * points is an array of [ mX1, mY1, mX2, mY2 ]
	     */
	    function BezierEasing (points) {
	        this._p = points;
	        this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	        this._precomputed = false;

	        this.get = this.get.bind(this);
	    }

	    BezierEasing.prototype = {

	        get: function (x) {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            if (!this._precomputed) this._precompute();
	            if (mX1 === mY1 && mX2 === mY2) return x; // linear
	            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	            if (x === 0) return 0;
	            if (x === 1) return 1;
	            return calcBezier(this._getTForX(x), mY1, mY2);
	        },

	        // Private part

	        _precompute: function () {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            this._precomputed = true;
	            if (mX1 !== mY1 || mX2 !== mY2)
	                this._calcSampleValues();
	        },

	        _calcSampleValues: function () {
	            var mX1 = this._p[0],
	                mX2 = this._p[2];
	            for (var i = 0; i < kSplineTableSize; ++i) {
	                this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	            }
	        },

	        /**
	         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	         */
	        _getTForX: function (aX) {
	            var mX1 = this._p[0],
	                mX2 = this._p[2],
	                mSampleValues = this._mSampleValues;

	            var intervalStart = 0.0;
	            var currentSample = 1;
	            var lastSample = kSplineTableSize - 1;

	            for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	                intervalStart += kSampleStepSize;
	            }
	            --currentSample;

	            // Interpolate to provide an initial guess for t
	            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]);
	            var guessForT = intervalStart + dist * kSampleStepSize;

	            var initialSlope = getSlope(guessForT, mX1, mX2);
	            if (initialSlope >= NEWTON_MIN_SLOPE) {
	                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	            } else if (initialSlope === 0.0) {
	                return guessForT;
	            } else {
	                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	            }
	        }
	    };

	    return ob;

	}());
	(function () {
	    var lastTime = 0;
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	    }
	    if(!window.requestAnimationFrame)
	        window.requestAnimationFrame = function (callback, element) {
	            var currTime = new Date().getTime();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = setTimeout(function () {
	                    callback(currTime + timeToCall);
	                },
	                timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	    if(!window.cancelAnimationFrame)
	        window.cancelAnimationFrame = function (id) {
	            clearTimeout(id);
	        };
	}());

	function extendPrototype(sources,destination){
	    var i, len = sources.length, sourcePrototype;
	    for (i = 0;i < len;i += 1) {
	        sourcePrototype = sources[i].prototype;
	        for (var attr in sourcePrototype) {
	            if (sourcePrototype.hasOwnProperty(attr)) destination.prototype[attr] = sourcePrototype[attr];
	        }
	    }
	}

	function getDescriptor(object, prop) {
	    return Object.getOwnPropertyDescriptor(object, prop);
	}

	function createProxyFunction(prototype) {
		function ProxyFunction(){}
		ProxyFunction.prototype = prototype;
		return ProxyFunction;
	}
	function bezFunction(){

	    function pointOnLine2D(x1,y1, x2,y2, x3,y3){
	        var det1 = (x1*y2) + (y1*x3) + (x2*y3) - (x3*y2) - (y3*x1) - (x2*y1);
	        return det1 > -0.001 && det1 < 0.001;
	    }

	    function pointOnLine3D(x1,y1,z1, x2,y2,z2, x3,y3,z3){
	        if(z1 === 0 && z2 === 0 && z3 === 0) {
	            return pointOnLine2D(x1,y1, x2,y2, x3,y3);
	        }
	        var dist1 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2) + Math.pow(z2 - z1, 2));
	        var dist2 = Math.sqrt(Math.pow(x3 - x1, 2) + Math.pow(y3 - y1, 2) + Math.pow(z3 - z1, 2));
	        var dist3 = Math.sqrt(Math.pow(x3 - x2, 2) + Math.pow(y3 - y2, 2) + Math.pow(z3 - z2, 2));
	        var diffDist;
	        if(dist1 > dist2){
	            if(dist1 > dist3){
	                diffDist = dist1 - dist2 - dist3;
	            } else {
	                diffDist = dist3 - dist2 - dist1;
	            }
	        } else if(dist3 > dist2){
	            diffDist = dist3 - dist2 - dist1;
	        } else {
	            diffDist = dist2 - dist1 - dist3;
	        }
	        return diffDist > -0.0001 && diffDist < 0.0001;
	    }

	    var getBezierLength = (function(){

	        return function(pt1,pt2,pt3,pt4){
	            var curveSegments = defaultCurveSegments;
	            var k;
	            var i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point = [],lastPoint = [];
	            var lengthData = bezier_length_pool.newElement();
	            len = pt3.length;
	            for(k=0;k<curveSegments;k+=1){
	                perc = k/(curveSegments-1);
	                ptDistance = 0;
	                for(i=0;i<len;i+=1){
	                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bm_pow(perc,2)*pt4[i]+bm_pow(perc,3)*pt2[i];
	                    point[i] = ptCoord;
	                    if(lastPoint[i] !== null){
	                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                    lastPoint[i] = point[i];
	                }
	                if(ptDistance){
	                    ptDistance = bm_sqrt(ptDistance);
	                    addedLength += ptDistance;
	                }
	                lengthData.percents[k] = perc;
	                lengthData.lengths[k] = addedLength;
	            }
	            lengthData.addedLength = addedLength;
	            return lengthData;
	        };
	    }());

	    function getSegmentsLength(shapeData) {
	        var segmentsLength = segments_length_pool.newElement();
	        var closed = shapeData.c;
	        var pathV = shapeData.v;
	        var pathO = shapeData.o;
	        var pathI = shapeData.i;
	        var i, len = shapeData._length;
	        var lengths = segmentsLength.lengths;
	        var totalLength = 0;
	        for(i=0;i<len-1;i+=1){
	            lengths[i] = getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);
	            totalLength += lengths[i].addedLength;
	        }
	        if(closed && len){
	            lengths[i] = getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);
	            totalLength += lengths[i].addedLength;
	        }
	        segmentsLength.totalLength = totalLength;
	        return segmentsLength;
	    }

	    function BezierData(length){
	        this.segmentLength = 0;
	        this.points = new Array(length);
	    }

	    function PointData(partial,point){
	        this.partialLength = partial;
	        this.point = point;
	    }

	    var buildBezierData = (function(){

	        var storedData = {};

	        return function (pt1, pt2, pt3, pt4){
	            var bezierName = (pt1[0]+'_'+pt1[1]+'_'+pt2[0]+'_'+pt2[1]+'_'+pt3[0]+'_'+pt3[1]+'_'+pt4[0]+'_'+pt4[1]).replace(/\./g, 'p');
	            if(!storedData[bezierName]){
	                var curveSegments = defaultCurveSegments;
	                var k, i, len;
	                var ptCoord,perc,addedLength = 0;
	                var ptDistance;
	                var point,lastPoint = null;
	                if (pt1.length === 2 && (pt1[0] != pt2[0] || pt1[1] != pt2[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){
	                    curveSegments = 2;
	                }
	                var bezierData = new BezierData(curveSegments);
	                len = pt3.length;
	                for (k = 0; k < curveSegments; k += 1) {
	                    point = createSizedArray(len);
	                    perc = k / (curveSegments - 1);
	                    ptDistance = 0;
	                    for (i = 0; i < len; i += 1){
	                        ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*(pt1[i] + pt3[i])+3*(1-perc)*bm_pow(perc,2)*(pt2[i] + pt4[i])+bm_pow(perc,3)*pt2[i];
	                        point[i] = ptCoord;
	                        if(lastPoint !== null){
	                            ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                        }
	                    }
	                    ptDistance = bm_sqrt(ptDistance);
	                    addedLength += ptDistance;
	                    bezierData.points[k] = new PointData(ptDistance, point);
	                    lastPoint = point;
	                }
	                bezierData.segmentLength = addedLength;
	                storedData[bezierName] = bezierData;
	            }
	            return storedData[bezierName];
	        };
	    }());

	    function getDistancePerc(perc,bezierData){
	        var percents = bezierData.percents;
	        var lengths = bezierData.lengths;
	        var len = percents.length;
	        var initPos = bm_floor((len-1)*perc);
	        var lengthPos = perc*bezierData.addedLength;
	        var lPerc = 0;
	        if(initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]){
	            return percents[initPos];
	        }else {
	            var dir = lengths[initPos] > lengthPos ? -1 : 1;
	            var flag = true;
	            while(flag){
	                if(lengths[initPos] <= lengthPos && lengths[initPos+1] > lengthPos){
	                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos+1] - lengths[initPos]);
	                    flag = false;
	                }else {
	                    initPos += dir;
	                }
	                if(initPos < 0 || initPos >= len - 1){
	                    //FIX for TypedArrays that don't store floating point values with enough accuracy
	                    if(initPos === len - 1) {
	                        return percents[initPos];
	                    }
	                    flag = false;
	                }
	            }
	            return percents[initPos] + (percents[initPos+1] - percents[initPos])*lPerc;
	        }
	    }

	    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
	        var t1 = getDistancePerc(percent,bezierData);
	        var u1 = 1 - t1;
	        var ptX = Math.round((u1*u1*u1* pt1[0] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[0] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[0] + t1*t1*t1* pt2[0])* 1000) / 1000;
	        var ptY = Math.round((u1*u1*u1* pt1[1] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[1] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[1] + t1*t1*t1* pt2[1])* 1000) / 1000;
	        return [ptX, ptY];
	    }

	    var bezier_segment_points = createTypedArray('float32', 8);

	    function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc, bezierData){

	        startPerc = startPerc < 0 ? 0 : startPerc > 1 ? 1 : startPerc;
	        var t0 = getDistancePerc(startPerc,bezierData);
	        endPerc = endPerc > 1 ? 1 : endPerc;
	        var t1 = getDistancePerc(endPerc,bezierData);
	        var i, len = pt1.length;
	        var u0 = 1 - t0;
	        var u1 = 1 - t1;
	        var u0u0u0 = u0*u0*u0;
	        var t0u0u0_3 = t0*u0*u0*3;
	        var t0t0u0_3 = t0*t0*u0*3;
	        var t0t0t0 = t0*t0*t0;
	        //
	        var u0u0u1 = u0*u0*u1;
	        var t0u0u1_3 = t0*u0*u1 + u0*t0*u1 + u0*u0*t1;
	        var t0t0u1_3 = t0*t0*u1 + u0*t0*t1 + t0*u0*t1;
	        var t0t0t1 = t0*t0*t1;
	        //
	        var u0u1u1 = u0*u1*u1;
	        var t0u1u1_3 = t0*u1*u1 + u0*t1*u1 + u0*u1*t1;
	        var t0t1u1_3 = t0*t1*u1 + u0*t1*t1 + t0*u1*t1;
	        var t0t1t1 = t0*t1*t1;
	        //
	        var u1u1u1 = u1*u1*u1;
	        var t1u1u1_3 = t1*u1*u1 + u1*t1*u1 + u1*u1*t1;
	        var t1t1u1_3 = t1*t1*u1 + u1*t1*t1 + t1*u1*t1;
	        var t1t1t1 = t1*t1*t1;
	        for(i=0;i<len;i+=1){
	            bezier_segment_points[i * 4] = Math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 1] = Math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 2] = Math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 3] = Math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000;
	        }

	        return bezier_segment_points;
	    }

	    return {
	        getSegmentsLength : getSegmentsLength,
	        getNewSegment : getNewSegment,
	        getPointInSegment : getPointInSegment,
	        buildBezierData : buildBezierData,
	        pointOnLine2D : pointOnLine2D,
	        pointOnLine3D : pointOnLine3D
	    };
	}

	var bez = bezFunction();
	function dataFunctionManager(){

	    //var tCanvasHelper = createTag('canvas').getContext('2d');

	    function completeLayers(layers, comps, fontManager){
	        var layerData;
	        var i, len = layers.length;
	        var j, jLen, k, kLen;
	        for(i=0;i<len;i+=1){
	            layerData = layers[i];
	            if(!('ks' in layerData) || layerData.completed){
	                continue;
	            }
	            layerData.completed = true;
	            if(layerData.tt){
	                layers[i-1].td = layerData.tt;
	            }
	            if(layerData.hasMask){
	                var maskProps = layerData.masksProperties;
	                jLen = maskProps.length;
	                for(j=0;j<jLen;j+=1){
	                    if(maskProps[j].pt.k.i){
	                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
	                    }else {
	                        kLen = maskProps[j].pt.k.length;
	                        for(k=0;k<kLen;k+=1){
	                            if(maskProps[j].pt.k[k].s){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
	                            }
	                            if(maskProps[j].pt.k[k].e){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
	                            }
	                        }
	                    }
	                }
	            }
	            if(layerData.ty===0){
	                layerData.layers = findCompLayers(layerData.refId, comps);
	                completeLayers(layerData.layers,comps);
	            }else if(layerData.ty === 4){
	                completeShapes(layerData.shapes);
	            }else if(layerData.ty == 5){
	                completeText(layerData);
	            }
	        }
	    }

	    function findCompLayers(id,comps){
	        var i = 0, len = comps.length;
	        while(i<len){
	            if(comps[i].id === id){
	                if(!comps[i].layers.__used) {
	                    comps[i].layers.__used = true;
	                    return comps[i].layers;
	                }
	                return JSON.parse(JSON.stringify(comps[i].layers));
	            }
	            i += 1;
	        }
	    }

	    function completeShapes(arr){
	        var i, len = arr.length;
	        var j, jLen;
	        for(i=len-1;i>=0;i-=1){
	            if(arr[i].ty == 'sh'){
	                if(arr[i].ks.k.i){
	                    convertPathsToAbsoluteValues(arr[i].ks.k);
	                }else {
	                    jLen = arr[i].ks.k.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(arr[i].ks.k[j].s){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
	                        }
	                        if(arr[i].ks.k[j].e){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
	                        }
	                    }
	                }
	            }else if(arr[i].ty == 'gr'){
	                completeShapes(arr[i].it);
	            }
	        }
	        /*if(hasPaths){
	            //mx: distance
	            //ss: sensitivity
	            //dc: decay
	            arr.splice(arr.length-1,0,{
	                "ty": "ms",
	                "mx":20,
	                "ss":10,
	                 "dc":0.001,
	                "maxDist":200
	            });
	        }*/
	    }

	    function convertPathsToAbsoluteValues(path){
	        var i, len = path.i.length;
	        for(i=0;i<len;i+=1){
	            path.i[i][0] += path.v[i][0];
	            path.i[i][1] += path.v[i][1];
	            path.o[i][0] += path.v[i][0];
	            path.o[i][1] += path.v[i][1];
	        }
	    }

	    function checkVersion(minimum,animVersionString){
	        var animVersion = animVersionString ? animVersionString.split('.') : [100,100,100];
	        if(minimum[0]>animVersion[0]){
	            return true;
	        } else if(animVersion[0] > minimum[0]){
	            return false;
	        }
	        if(minimum[1]>animVersion[1]){
	            return true;
	        } else if(animVersion[1] > minimum[1]){
	            return false;
	        }
	        if(minimum[2]>animVersion[2]){
	            return true;
	        } else if(animVersion[2] > minimum[2]){
	            return false;
	        }
	    }

	    var checkText = (function(){
	        var minimumVersion = [4,4,14];

	        function updateTextLayer(textLayer){
	            var documentData = textLayer.t.d;
	            textLayer.t.d = {
	                k: [
	                    {
	                        s:documentData,
	                        t:0
	                    }
	                ]
	            };
	        }

	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 5){
	                    updateTextLayer(layers[i]);
	                }
	            }
	        }

	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);

	                        }
	                    }
	                }
	            }
	        };
	    }());

	    var checkChars = (function() {
	        var minimumVersion = [4,7,99];
	        return function (animationData){
	            if(animationData.chars && !checkVersion(minimumVersion,animationData.v)){
	                var i, len = animationData.chars.length, j, jLen;
	                var pathData, paths;
	                for(i = 0; i < len; i += 1) {
	                    if(animationData.chars[i].data && animationData.chars[i].data.shapes) {
	                        paths = animationData.chars[i].data.shapes[0].it;
	                        jLen = paths.length;

	                        for(j = 0; j < jLen; j += 1) {
	                            pathData = paths[j].ks.k;
	                            if(!pathData.__converted) {
	                                convertPathsToAbsoluteValues(paths[j].ks.k);
	                                pathData.__converted = true;
	                            }
	                        }
	                    }
	                }
	            }
	        };
	    }());

	    var checkColors = (function(){
	        var minimumVersion = [4,1,9];

	        function iterateShapes(shapes){
	            var i, len = shapes.length;
	            var j, jLen;
	            for(i=0;i<len;i+=1){
	                if(shapes[i].ty === 'gr'){
	                    iterateShapes(shapes[i].it);
	                }else if(shapes[i].ty === 'fl' || shapes[i].ty === 'st'){
	                    if(shapes[i].c.k && shapes[i].c.k[0].i){
	                        jLen = shapes[i].c.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(shapes[i].c.k[j].s){
	                                shapes[i].c.k[j].s[0] /= 255;
	                                shapes[i].c.k[j].s[1] /= 255;
	                                shapes[i].c.k[j].s[2] /= 255;
	                                shapes[i].c.k[j].s[3] /= 255;
	                            }
	                            if(shapes[i].c.k[j].e){
	                                shapes[i].c.k[j].e[0] /= 255;
	                                shapes[i].c.k[j].e[1] /= 255;
	                                shapes[i].c.k[j].e[2] /= 255;
	                                shapes[i].c.k[j].e[3] /= 255;
	                            }
	                        }
	                    } else {
	                        shapes[i].c.k[0] /= 255;
	                        shapes[i].c.k[1] /= 255;
	                        shapes[i].c.k[2] /= 255;
	                        shapes[i].c.k[3] /= 255;
	                    }
	                }
	            }
	        }

	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 4){
	                    iterateShapes(layers[i].shapes);
	                }
	            }
	        }

	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);

	                        }
	                    }
	                }
	            }
	        };
	    }());

	    var checkShapes = (function(){
	        var minimumVersion = [4,4,18];



	        function completeShapes(arr){
	            var i, len = arr.length;
	            var j, jLen;
	            for(i=len-1;i>=0;i-=1){
	                if(arr[i].ty == 'sh'){
	                    if(arr[i].ks.k.i){
	                        arr[i].ks.k.c = arr[i].closed;
	                    }else {
	                        jLen = arr[i].ks.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(arr[i].ks.k[j].s){
	                                arr[i].ks.k[j].s[0].c = arr[i].closed;
	                            }
	                            if(arr[i].ks.k[j].e){
	                                arr[i].ks.k[j].e[0].c = arr[i].closed;
	                            }
	                        }
	                    }
	                }else if(arr[i].ty == 'gr'){
	                    completeShapes(arr[i].it);
	                }
	            }
	        }

	        function iterateLayers(layers){
	            var layerData;
	            var i, len = layers.length;
	            var j, jLen, k, kLen;
	            for(i=0;i<len;i+=1){
	                layerData = layers[i];
	                if(layerData.hasMask){
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(maskProps[j].pt.k.i){
	                            maskProps[j].pt.k.c = maskProps[j].cl;
	                        }else {
	                            kLen = maskProps[j].pt.k.length;
	                            for(k=0;k<kLen;k+=1){
	                                if(maskProps[j].pt.k[k].s){
	                                    maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
	                                }
	                                if(maskProps[j].pt.k[k].e){
	                                    maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
	                                }
	                            }
	                        }
	                    }
	                }
	                if(layerData.ty === 4){
	                    completeShapes(layerData.shapes);
	                }
	            }
	        }

	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);

	                        }
	                    }
	                }
	            }
	        };
	    }());

	    function completeData(animationData, fontManager){
	        if(animationData.__complete){
	            return;
	        }
	        checkColors(animationData);
	        checkText(animationData);
	        checkChars(animationData);
	        checkShapes(animationData);
	        completeLayers(animationData.layers, animationData.assets);
	        animationData.__complete = true;
	        //blitAnimation(animationData, animationData.assets, fontManager);
	    }

	    function completeText(data, fontManager){
	        if(data.t.a.length === 0 && !('m' in data.t.p)){
	            data.singleShape = true;
	        }
	    }

	    var moduleOb = {};
	    moduleOb.completeData = completeData;
	    moduleOb.checkColors = checkColors;
	    moduleOb.checkChars = checkChars;
	    moduleOb.checkShapes = checkShapes;
	    moduleOb.completeLayers = completeLayers;

	    return moduleOb;
	}

	var dataManager = dataFunctionManager();

	var FontManager = (function(){

	    var maxWaitingTime = 5000;
	    var emptyChar = {
	        w: 0,
	        size:0,
	        shapes:[]
	    };
	    var combinedCharacters = [];
	    //Hindi characters
	    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366
	    , 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379
	    , 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);

	    function trimFontOptions(font) {
	        var familyArray = font.split(',');
	        var i, len = familyArray.length;
	        var enabledFamilies = [];
	        for (i = 0; i < len; i += 1) {
	            if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
	                enabledFamilies.push(familyArray[i]);
	            }
	        }
	        return enabledFamilies.join(',');
	    }

	    function setUpNode(font, family){
	        var parentNode = createTag('span');
	        parentNode.style.fontFamily    = family;
	        var node = createTag('span');
	        // Characters that vary significantly among different fonts
	        node.innerHTML = 'giItT1WQy@!-/#';
	        // Visible - so we can measure it - but not on the screen
	        parentNode.style.position      = 'absolute';
	        parentNode.style.left          = '-10000px';
	        parentNode.style.top           = '-10000px';
	        // Large font size makes even subtle changes obvious
	        parentNode.style.fontSize      = '300px';
	        // Reset any font properties
	        parentNode.style.fontVariant   = 'normal';
	        parentNode.style.fontStyle     = 'normal';
	        parentNode.style.fontWeight    = 'normal';
	        parentNode.style.letterSpacing = '0';
	        parentNode.appendChild(node);
	        document.body.appendChild(parentNode);

	        // Remember width with no applied web font
	        var width = node.offsetWidth;
	        node.style.fontFamily = trimFontOptions(font) + ', ' + family;
	        return {node:node, w:width, parent:parentNode};
	    }

	    function checkLoadedFonts() {
	        var i, len = this.fonts.length;
	        var node, w;
	        var loadedCount = len;
	        for(i=0;i<len; i+= 1){
	            if(this.fonts[i].loaded){
	                loadedCount -= 1;
	                continue;
	            }
	            if(this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0){
	                this.fonts[i].loaded = true;
	            } else {
	                node = this.fonts[i].monoCase.node;
	                w = this.fonts[i].monoCase.w;
	                if(node.offsetWidth !== w){
	                    loadedCount -= 1;
	                    this.fonts[i].loaded = true;
	                }else {
	                    node = this.fonts[i].sansCase.node;
	                    w = this.fonts[i].sansCase.w;
	                    if(node.offsetWidth !== w){
	                        loadedCount -= 1;
	                        this.fonts[i].loaded = true;
	                    }
	                }
	                if(this.fonts[i].loaded){
	                    this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
	                    this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
	                }
	            }
	        }

	        if(loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime){
	            setTimeout(this.checkLoadedFontsBinded, 20);
	        }else {
	            setTimeout(this.setIsLoadedBinded, 10);

	        }
	    }

	    function createHelper(def, fontData){
	        var tHelper = createNS('text');
	        tHelper.style.fontSize = '100px';
	        //tHelper.style.fontFamily = fontData.fFamily;
	        tHelper.setAttribute('font-family', fontData.fFamily);
	        tHelper.setAttribute('font-style', fontData.fStyle);
	        tHelper.setAttribute('font-weight', fontData.fWeight);
	        tHelper.textContent = '1';
	        if(fontData.fClass){
	            tHelper.style.fontFamily = 'inherit';
	            tHelper.setAttribute('class', fontData.fClass);
	        } else {
	            tHelper.style.fontFamily = fontData.fFamily;
	        }
	        def.appendChild(tHelper);
	        var tCanvasHelper = createTag('canvas').getContext('2d');
	        tCanvasHelper.font = fontData.fWeight + ' ' + fontData.fStyle + ' 100px '+ fontData.fFamily;
	        //tCanvasHelper.font = ' 100px '+ fontData.fFamily;
	        return tHelper;
	    }

	    function addFonts(fontData, defs){
	        if(!fontData){
	            this.isLoaded = true;
	            return;
	        }
	        if(this.chars){
	            this.isLoaded = true;
	            this.fonts = fontData.list;
	            return;
	        }


	        var fontArr = fontData.list;
	        var i, len = fontArr.length;
	        var _pendingFonts = len;
	        for(i=0; i<len; i+= 1){
	            var shouldLoadFont = true;
	            var loadedSelector;
	            var j;
	            fontArr[i].loaded = false;
	            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily,'monospace');
	            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily,'sans-serif');
	            if(!fontArr[i].fPath) {
	                fontArr[i].loaded = true;
	                _pendingFonts -= 1;
	            }else if(fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3){
	                loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="'+ fontArr[i].fFamily +'"], style[f-origin="3"][f-family="'+ fontArr[i].fFamily +'"]');

	                if (loadedSelector.length > 0) {
	                    shouldLoadFont = false;
	                }

	                if (shouldLoadFont) {
	                    var s = createTag('style');
	                    s.setAttribute('f-forigin', fontArr[i].fOrigin);
	                    s.setAttribute('f-origin', fontArr[i].origin);
	                    s.setAttribute('f-family', fontArr[i].fFamily);
	                    s.type = "text/css";
	                    s.innerHTML = "@font-face {" + "font-family: "+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";
	                    defs.appendChild(s);
	                }
	            } else if(fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1){
	                loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');

	                for (j = 0; j < loadedSelector.length; j++) {
	                    if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
	                        // Font is already loaded
	                        shouldLoadFont = false;
	                    }
	                }

	                if (shouldLoadFont) {
	                    var l = createTag('link');
	                    l.setAttribute('f-forigin', fontArr[i].fOrigin);
	                    l.setAttribute('f-origin', fontArr[i].origin);
	                    l.type = "text/css";
	                    l.rel = "stylesheet";
	                    l.href = fontArr[i].fPath;
	                    document.body.appendChild(l);
	                }
	            } else if(fontArr[i].fOrigin === 't' || fontArr[i].origin === 2){
	                loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');

	                for (j = 0; j < loadedSelector.length; j++) {
	                    if (fontArr[i].fPath === loadedSelector[j].src) {
	                        // Font is already loaded
	                        shouldLoadFont = false;
	                    }
	                }

	                if (shouldLoadFont) {
	                    var sc = createTag('link');
	                    sc.setAttribute('f-forigin', fontArr[i].fOrigin);
	                    sc.setAttribute('f-origin', fontArr[i].origin);
	                    sc.setAttribute('rel','stylesheet');
	                    sc.setAttribute('href',fontArr[i].fPath);
	                    defs.appendChild(sc);
	                }
	            }
	            fontArr[i].helper = createHelper(defs,fontArr[i]);
	            fontArr[i].cache = {};
	            this.fonts.push(fontArr[i]);
	        }
	        if (_pendingFonts === 0) {
	            this.isLoaded = true;
	        } else {
	            //On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
	            //Adding this timeout seems to fix it
	           setTimeout(this.checkLoadedFonts.bind(this), 100);
	        }
	    }

	    function addChars(chars){
	        if(!chars){
	            return;
	        }
	        if(!this.chars){
	            this.chars = [];
	        }
	        var i, len = chars.length;
	        var j, jLen = this.chars.length, found;
	        for(i=0;i<len;i+=1){
	            j = 0;
	            found = false;
	            while(j<jLen){
	                if(this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch){
	                    found = true;
	                }
	                j += 1;
	            }
	            if(!found){
	                this.chars.push(chars[i]);
	                jLen += 1;
	            }
	        }
	    }

	    function getCharData(char, style, font){
	        var i = 0, len = this.chars.length;
	        while( i < len) {
	            if(this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font){

	                return this.chars[i];
	            }
	            i+= 1;
	        }
	        if((typeof char === 'string' && char.charCodeAt(0) !== 13 || !char) && console && console.warn) {
	            console.warn('Missing character from exported characters list: ', char, style, font);
	        }
	        return emptyChar;
	    }

	    function measureText(char, fontName, size) {
	        var fontData = this.getFontByName(fontName);
	        var index = char.charCodeAt(0);
	        if(!fontData.cache[index + 1]) {
	            var tHelper = fontData.helper;
	            //Canvas version
	            //fontData.cache[index] = tHelper.measureText(char).width / 100;
	            //SVG version
	            //console.log(tHelper.getBBox().width)
	            if (char === ' ') {
	                tHelper.textContent = '|' + char + '|';
	                var doubleSize = tHelper.getComputedTextLength();
	                tHelper.textContent = '||';
	                var singleSize = tHelper.getComputedTextLength();
	                fontData.cache[index + 1] = (doubleSize - singleSize)/100;
	            } else {
	                tHelper.textContent = char;
	                fontData.cache[index + 1] = (tHelper.getComputedTextLength())/100;
	            }
	        }
	        return fontData.cache[index + 1] * size;
	    }

	    function getFontByName(name){
	        var i = 0, len = this.fonts.length;
	        while(i<len){
	            if(this.fonts[i].fName === name) {
	                return this.fonts[i];
	            }
	            i += 1;
	        }
	        return this.fonts[0];
	    }

	    function getCombinedCharacterCodes() {
	        return combinedCharacters;
	    }

	    function setIsLoaded() {
	        this.isLoaded = true;
	    }

	    var Font = function(){
	        this.fonts = [];
	        this.chars = null;
	        this.typekitLoaded = 0;
	        this.isLoaded = false;
	        this.initTime = Date.now();
	        this.setIsLoadedBinded = this.setIsLoaded.bind(this);
	        this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
	    };
	    //TODO: for now I'm adding these methods to the Class and not the prototype. Think of a better way to implement it. 
	    Font.getCombinedCharacterCodes = getCombinedCharacterCodes;

	    var fontPrototype = {
	        addChars: addChars,
	        addFonts: addFonts,
	        getCharData: getCharData,
	        getFontByName: getFontByName,
	        measureText: measureText,
	        checkLoadedFonts: checkLoadedFonts,
	        setIsLoaded: setIsLoaded,
	    };

	    Font.prototype = fontPrototype;

	    return Font;

	}());
	var PropertyFactory = (function(){

	    var initFrame = initialDefaultFrame;
	    var math_abs = Math.abs;

	    function interpolateValue(frameNum, caching) {
	        var offsetTime = this.offsetTime;
	        var newValue;
	        if (this.propType === 'multidimensional') {
	            newValue = createTypedArray('float32', this.pv.length);
	        }
	        var iterationIndex = caching.lastIndex;
	        var i = iterationIndex;
	        var len = this.keyframes.length - 1, flag = true;
	        var keyData, nextKeyData;

	        while (flag) {
	            keyData = this.keyframes[i];
	            nextKeyData = this.keyframes[i + 1];
	            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime){
	                if(keyData.h){
	                    keyData = nextKeyData;
	                }
	                iterationIndex = 0;
	                break;
	            }
	            if ((nextKeyData.t - offsetTime) > frameNum){
	                iterationIndex = i;
	                break;
	            }
	            if (i < len - 1){
	                i += 1;
	            } else {
	                iterationIndex = 0;
	                flag = false;
	            }
	        }

	        var k, kLen, perc, jLen, j, fnc;
	        var nextKeyTime = nextKeyData.t - offsetTime;
	        var keyTime = keyData.t - offsetTime;
	        var endValue;
	        if (keyData.to) {
	            if (!keyData.bezierData) {
	                keyData.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
	            }
	            var bezierData = keyData.bezierData;
	            if (frameNum >= nextKeyTime || frameNum < keyTime) {
	                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
	                kLen = bezierData.points[ind].point.length;
	                for (k = 0; k < kLen; k += 1) {
	                    newValue[k] = bezierData.points[ind].point[k];
	                }
	                // caching._lastKeyframeIndex = -1;
	            } else {
	                if (keyData.__fnct) {
	                    fnc = keyData.__fnct;
	                } else {
	                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
	                    keyData.__fnct = fnc;
	                }
	                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
	                var distanceInLine = bezierData.segmentLength*perc;

	                var segmentPerc;
	                var addedLength =  (caching.lastFrame < frameNum && caching._lastKeyframeIndex === i) ? caching._lastAddedLength : 0;
	                j =  (caching.lastFrame < frameNum && caching._lastKeyframeIndex === i) ? caching._lastPoint : 0;
	                flag = true;
	                jLen = bezierData.points.length;
	                while (flag) {
	                    addedLength += bezierData.points[j].partialLength;
	                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
	                        kLen = bezierData.points[j].point.length;
	                        for (k = 0; k < kLen; k += 1) {
	                            newValue[k] = bezierData.points[j].point[k];
	                        }
	                        break;
	                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
	                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
	                        kLen = bezierData.points[j].point.length;
	                        for (k = 0; k < kLen; k += 1) {
	                            newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
	                        }
	                        break;
	                    }
	                    if (j < jLen - 1){
	                        j += 1;
	                    } else {
	                        flag = false;
	                    }
	                }
	                caching._lastPoint = j;
	                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
	                caching._lastKeyframeIndex = i;
	            }
	        } else {
	            var outX, outY, inX, inY, keyValue;
	            len = keyData.s.length;
	            endValue = nextKeyData.s || keyData.e;
	            if (this.sh && keyData.h !== 1) {
	                if (frameNum >= nextKeyTime) {
	                    newValue[0] = endValue[0];
	                    newValue[1] = endValue[1];
	                    newValue[2] = endValue[2];
	                } else if (frameNum <= keyTime) {
	                    newValue[0] = keyData.s[0];
	                    newValue[1] = keyData.s[1];
	                    newValue[2] = keyData.s[2];
	                } else {
	                    var quatStart = createQuaternion(keyData.s);
	                    var quatEnd = createQuaternion(endValue);
	                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
	                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
	                }
	                
	            } else {
	                for(i = 0; i < len; i += 1) {
	                    if (keyData.h !== 1) {
	                        if (frameNum >= nextKeyTime) {
	                            perc = 1;
	                        } else if(frameNum < keyTime) {
	                            perc = 0;
	                        } else {
	                            if(keyData.o.x.constructor === Array) {
	                                if (!keyData.__fnct) {
	                                    keyData.__fnct = [];
	                                }
	                                if (!keyData.__fnct[i]) {
	                                    outX = (typeof keyData.o.x[i] === 'undefined') ? keyData.o.x[0] : keyData.o.x[i];
	                                    outY = (typeof keyData.o.y[i] === 'undefined') ? keyData.o.y[0] : keyData.o.y[i];
	                                    inX = (typeof keyData.i.x[i] === 'undefined') ? keyData.i.x[0] : keyData.i.x[i];
	                                    inY = (typeof keyData.i.y[i] === 'undefined') ? keyData.i.y[0] : keyData.i.y[i];
	                                    fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                                    keyData.__fnct[i] = fnc;
	                                } else {
	                                    fnc = keyData.__fnct[i];
	                                }
	                            } else {
	                                if (!keyData.__fnct) {
	                                    outX = keyData.o.x;
	                                    outY = keyData.o.y;
	                                    inX = keyData.i.x;
	                                    inY = keyData.i.y;
	                                    fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                                    keyData.__fnct = fnc;
	                                } else {
	                                    fnc = keyData.__fnct;
	                                }
	                            }
	                            perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime ));
	                        }
	                    }

	                    endValue = nextKeyData.s || keyData.e;
	                    keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;

	                    if (this.propType === 'multidimensional') {
	                        newValue[i] = keyValue;
	                    } else {
	                        newValue = keyValue;
	                    }
	                }
	            }
	        }
	        caching.lastIndex = iterationIndex;
	        return newValue;
	    }

	    //based on @Toji's https://github.com/toji/gl-matrix/
	    function slerp(a, b, t) {
	        var out = [];
	        var ax = a[0], ay = a[1], az = a[2], aw = a[3],
	        bx = b[0], by = b[1], bz = b[2], bw = b[3];

	        var omega, cosom, sinom, scale0, scale1;

	        cosom = ax * bx + ay * by + az * bz + aw * bw;
	        if (cosom < 0.0) {
	            cosom = -cosom;
	            bx = -bx;
	            by = -by;
	            bz = -bz;
	            bw = -bw;
	        }
	        if ((1.0 - cosom) > 0.000001) {
	            omega = Math.acos(cosom);
	            sinom = Math.sin(omega);
	            scale0 = Math.sin((1.0 - t) * omega) / sinom;
	            scale1 = Math.sin(t * omega) / sinom;
	        } else {
	            scale0 = 1.0 - t;
	            scale1 = t;
	        }
	        out[0] = scale0 * ax + scale1 * bx;
	        out[1] = scale0 * ay + scale1 * by;
	        out[2] = scale0 * az + scale1 * bz;
	        out[3] = scale0 * aw + scale1 * bw;

	        return out;
	    }

	    function quaternionToEuler(out, quat) {
	        var qx = quat[0];
	        var qy = quat[1];
	        var qz = quat[2];
	        var qw = quat[3];
	        var heading = Math.atan2(2*qy*qw-2*qx*qz , 1 - 2*qy*qy - 2*qz*qz);
	        var attitude = Math.asin(2*qx*qy + 2*qz*qw); 
	        var bank = Math.atan2(2*qx*qw-2*qy*qz , 1 - 2*qx*qx - 2*qz*qz);
	        out[0] = heading/degToRads;
	        out[1] = attitude/degToRads;
	        out[2] = bank/degToRads;
	    }

	    function createQuaternion(values) {
	        var heading = values[0] * degToRads;
	        var attitude = values[1] * degToRads;
	        var bank = values[2] * degToRads;
	        var c1 = Math.cos(heading / 2);
	        var c2 = Math.cos(attitude / 2);
	        var c3 = Math.cos(bank / 2);
	        var s1 = Math.sin(heading / 2);
	        var s2 = Math.sin(attitude / 2);
	        var s3 = Math.sin(bank / 2);
	        var w = c1 * c2 * c3 - s1 * s2 * s3;
	        var x = s1 * s2 * c3 + c1 * c2 * s3;
	        var y = s1 * c2 * c3 + c1 * s2 * s3;
	        var z = c1 * s2 * c3 - s1 * c2 * s3;

	        return [x,y,z,w];
	    }

	    function getValueAtCurrentTime(){
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t - this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length- 1].t-this.offsetTime;
	        if(!(frameNum === this._caching.lastFrame || (this._caching.lastFrame !== initFrame && ((this._caching.lastFrame >= endTime && frameNum >= endTime) || (this._caching.lastFrame < initTime && frameNum < initTime))))){
	            if(this._caching.lastFrame >= frameNum) {
	                this._caching._lastKeyframeIndex = -1;
	                this._caching.lastIndex = 0;
	            }

	            var renderResult = this.interpolateValue(frameNum, this._caching);
	            this.pv = renderResult;
	        }
	        this._caching.lastFrame = frameNum;
	        return this.pv;
	    }

	    function setVValue(val) {
	        var multipliedValue;
	        if(this.propType === 'unidimensional') {
	            multipliedValue = val * this.mult;
	            if(math_abs(this.v - multipliedValue) > 0.00001) {
	                this.v = multipliedValue;
	                this._mdf = true;
	            }
	        } else {
	            var i = 0, len = this.v.length;
	            while (i < len) {
	                multipliedValue = val[i] * this.mult;
	                if (math_abs(this.v[i] - multipliedValue) > 0.00001) {
	                    this.v[i] = multipliedValue;
	                    this._mdf = true;
	                }
	                i += 1;
	            }
	        }
	    }

	    function processEffectsSequence() {
	        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
	            return;
	        }
	        if(this.lock) {
	            this.setVValue(this.pv);
	            return;
	        }
	        this.lock = true;
	        this._mdf = this._isFirstFrame;
	        var i, len = this.effectsSequence.length;
	        var finalValue = this.kf ? this.pv : this.data.k;
	        for(i = 0; i < len; i += 1) {
	            finalValue = this.effectsSequence[i](finalValue);
	        }
	        this.setVValue(finalValue);
	        this._isFirstFrame = false;
	        this.lock = false;
	        this.frameId = this.elem.globalData.frameId;
	    }

	    function addEffect(effectFunction) {
	        this.effectsSequence.push(effectFunction);
	        this.container.addDynamicProperty(this);
	    }

	    function ValueProperty(elem, data, mult, container){
	        this.propType = 'unidimensional';
	        this.mult = mult || 1;
	        this.data = data;
	        this.v = mult ? data.k * mult : data.k;
	        this.pv = data.k;
	        this._mdf = false;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.vel = 0;
	        this.effectsSequence = [];
	        this._isFirstFrame = true;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.addEffect = addEffect;
	    }

	    function MultiDimensionalProperty(elem, data, mult, container) {
	        this.propType = 'multidimensional';
	        this.mult = mult || 1;
	        this.data = data;
	        this._mdf = false;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.frameId = -1;
	        var i, len = data.k.length;
	        this.v = createTypedArray('float32', len);
	        this.pv = createTypedArray('float32', len);
	        createTypedArray('float32', len);
	        this.vel = createTypedArray('float32', len);
	        for (i = 0; i < len; i += 1) {
	            this.v[i] = data.k[i] * this.mult;
	            this.pv[i] = data.k[i];
	        }
	        this._isFirstFrame = true;
	        this.effectsSequence = [];
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.addEffect = addEffect;
	    }

	    function KeyframedValueProperty(elem, data, mult, container) {
	        this.propType = 'unidimensional';
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.frameId = -1;
	        this._caching = {lastFrame: initFrame, lastIndex: 0, value: 0, _lastKeyframeIndex: -1};
	        this.k = true;
	        this.kf = true;
	        this.data = data;
	        this.mult = mult || 1;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.v = initFrame;
	        this.pv = initFrame;
	        this._isFirstFrame = true;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.interpolateValue = interpolateValue;
	        this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	        this.addEffect = addEffect;
	    }

	    function KeyframedMultidimensionalProperty(elem, data, mult, container){
	        this.propType = 'multidimensional';
	        var i, len = data.k.length;
	        var s, e,to,ti;
	        for (i = 0; i < len - 1; i += 1) {
	            if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
	                s = data.k[i].s;
	                e = data.k[i + 1].s;
	                to = data.k[i].to;
	                ti = data.k[i].ti;
	                if((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0] + to[0],s[1] + to[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0] + ti[0],e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0] + to[0],s[1] + to[1],s[2] + to[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0] + ti[0],e[1] + ti[1],e[2] + ti[2]))){
	                    data.k[i].to = null;
	                    data.k[i].ti = null;
	                }
	                if(s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
	                    if(s.length === 2 || (s[2] === e[2] && to[2] === 0 && ti[2] === 0)) {
	                        data.k[i].to = null;
	                        data.k[i].ti = null;
	                    }
	                }
	            }
	        }
	        this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.k = true;
	        this.kf = true;
	        this._isFirstFrame = true;
	        this.mult = mult || 1;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.interpolateValue = interpolateValue;
	        this.frameId = -1;
	        var arrLen = data.k[0].s.length;
	        this.v = createTypedArray('float32', arrLen);
	        this.pv = createTypedArray('float32', arrLen);
	        for (i = 0; i < arrLen; i += 1) {
	            this.v[i] = initFrame;
	            this.pv[i] = initFrame;
	        }
	        this._caching={lastFrame:initFrame,lastIndex:0,value:createTypedArray('float32', arrLen)};
	        this.addEffect = addEffect;
	    }

	    function getProp(elem,data,type, mult, container) {
	        var p;
	        if(!data.k.length){
	            p = new ValueProperty(elem,data, mult, container);
	        }else if(typeof(data.k[0]) === 'number'){
	            p = new MultiDimensionalProperty(elem,data, mult, container);
	        }else {
	            switch(type){
	                case 0:
	                    p = new KeyframedValueProperty(elem,data,mult, container);
	                    break;
	                case 1:
	                    p = new KeyframedMultidimensionalProperty(elem,data,mult, container);
	                    break;
	            }
	        }
	        if(p.effectsSequence.length){
	            container.addDynamicProperty(p);
	        }
	        return p;
	    }

	    var ob = {
	        getProp: getProp
	    };
	    return ob;
	}());
	var TransformPropertyFactory = (function() {

	    var defaultVector = [0,0];

	    function applyToMatrix(mat) {
	        var _mdf = this._mdf;
	        this.iterateDynamicProperties();
	        this._mdf = this._mdf || _mdf;
	        if (this.a) {
	            mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        }
	        if (this.s) {
	            mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        }
	        if (this.sk) {
	            mat.skewFromAxis(-this.sk.v, this.sa.v);
	        }
	        if (this.r) {
	            mat.rotate(-this.r.v);
	        } else {
	            mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        }
	        if (this.data.p.s) {
	            if (this.data.p.z) {
	                mat.translate(this.px.v, this.py.v, -this.pz.v);
	            } else {
	                mat.translate(this.px.v, this.py.v, 0);
	            }
	        } else {
	            mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	        }
	    }
	    function processKeys(forceRender){
	        if (this.elem.globalData.frameId === this.frameId) {
	            return;
	        }
	        if(this._isDirty) {
	            this.precalculateMatrix();
	            this._isDirty = false;
	        }

	        this.iterateDynamicProperties();

	        if (this._mdf || forceRender) {
	            this.v.cloneFromProps(this.pre.props);
	            if (this.appliedTransformations < 1) {
	                this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	            }
	            if(this.appliedTransformations < 2) {
	                this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	            }
	            if (this.sk && this.appliedTransformations < 3) {
	                this.v.skewFromAxis(-this.sk.v, this.sa.v);
	            }
	            if (this.r && this.appliedTransformations < 4) {
	                this.v.rotate(-this.r.v);
	            } else if (!this.r && this.appliedTransformations < 4){
	                this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            }
	            if (this.autoOriented) {
	                var v1,v2, frameRate = this.elem.globalData.frameRate;
	                if(this.p && this.p.keyframes && this.p.getValueAtTime) {
	                    if (this.p._caching.lastFrame+this.p.offsetTime <= this.p.keyframes[0].t) {
	                        v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate,0);
	                        v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
	                    } else if(this.p._caching.lastFrame+this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
	                        v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / frameRate), 0);
	                        v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
	                    } else {
	                        v1 = this.p.pv;
	                        v2 = this.p.getValueAtTime((this.p._caching.lastFrame+this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
	                    }
	                } else if(this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
	                    v1 = [];
	                    v2 = [];
	                    var px = this.px, py = this.py, frameRate;
	                    if (px._caching.lastFrame+px.offsetTime <= px.keyframes[0].t) {
	                        v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate,0);
	                        v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate,0);
	                        v2[0] = px.getValueAtTime((px.keyframes[0].t) / frameRate,0);
	                        v2[1] = py.getValueAtTime((py.keyframes[0].t) / frameRate,0);
	                    } else if(px._caching.lastFrame+px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
	                        v1[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t / frameRate),0);
	                        v1[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t / frameRate),0);
	                        v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate,0);
	                        v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate,0);
	                    } else {
	                        v1 = [px.pv, py.pv];
	                        v2[0] = px.getValueAtTime((px._caching.lastFrame+px.offsetTime - 0.01) / frameRate,px.offsetTime);
	                        v2[1] = py.getValueAtTime((py._caching.lastFrame+py.offsetTime - 0.01) / frameRate,py.offsetTime);
	                    }
	                } else {
	                    v1 = v2 = defaultVector;
	                }
	                this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
	            }
	            if(this.data.p && this.data.p.s){
	                if(this.data.p.z) {
	                    this.v.translate(this.px.v, this.py.v, -this.pz.v);
	                } else {
	                    this.v.translate(this.px.v, this.py.v, 0);
	                }
	            }else {
	                this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	            }
	        }
	        this.frameId = this.elem.globalData.frameId;
	    }

	    function precalculateMatrix() {
	        if(!this.a.k) {
	            this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	            this.appliedTransformations = 1;
	        } else {
	            return;
	        }
	        if(!this.s.effectsSequence.length) {
	            this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	            this.appliedTransformations = 2;
	        } else {
	            return;
	        }
	        if(this.sk) {
	            if(!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
	                this.pre.skewFromAxis(-this.sk.v, this.sa.v);
	            this.appliedTransformations = 3;
	            } else {
	                return;
	            }
	        }
	        if (this.r) {
	            if(!this.r.effectsSequence.length) {
	                this.pre.rotate(-this.r.v);
	                this.appliedTransformations = 4;
	            } else {
	                return;
	            }
	        } else if(!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
	            this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            this.appliedTransformations = 4;
	        }
	    }

	    function autoOrient(){
	        //
	        //var prevP = this.getValueAtTime();
	    }

	    function addDynamicProperty(prop) {
	        this._addDynamicProperty(prop);
	        this.elem.addDynamicProperty(prop);
	        this._isDirty = true;
	    }

	    function TransformProperty(elem,data,container){
	        this.elem = elem;
	        this.frameId = -1;
	        this.propType = 'transform';
	        this.data = data;
	        this.v = new Matrix();
	        //Precalculated matrix with non animated properties
	        this.pre = new Matrix();
	        this.appliedTransformations = 0;
	        this.initDynamicPropertyContainer(container || elem);
	        if(data.p && data.p.s){
	            this.px = PropertyFactory.getProp(elem,data.p.x,0,0,this);
	            this.py = PropertyFactory.getProp(elem,data.p.y,0,0,this);
	            if(data.p.z){
	                this.pz = PropertyFactory.getProp(elem,data.p.z,0,0,this);
	            }
	        }else {
	            this.p = PropertyFactory.getProp(elem,data.p || {k:[0,0,0]},1,0,this);
	        }
	        if(data.rx) {
	            this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
	            this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
	            this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
	            if(data.or.k[0].ti) {
	                var i, len = data.or.k.length;
	                for(i=0;i<len;i+=1) {
	                    data.or.k[i].to = data.or.k[i].ti = null;
	                }
	            }
	            this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this);
	            //sh Indicates it needs to be capped between -180 and 180
	            this.or.sh = true;
	        } else {
	            this.r = PropertyFactory.getProp(elem, data.r || {k: 0}, 0, degToRads, this);
	        }
	        if(data.sk){
	            this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
	            this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
	        }
	        this.a = PropertyFactory.getProp(elem,data.a || {k:[0,0,0]},1,0,this);
	        this.s = PropertyFactory.getProp(elem,data.s || {k:[100,100,100]},1,0.01,this);
	        // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
	        if(data.o){
	            this.o = PropertyFactory.getProp(elem,data.o,0,0.01,elem);
	        } else {
	            this.o = {_mdf:false,v:1};
	        }
	        this._isDirty = true;
	        if(!this.dynamicProperties.length){
	            this.getValue(true);
	        }
	    }

	    TransformProperty.prototype = {
	        applyToMatrix: applyToMatrix,
	        getValue: processKeys,
	        precalculateMatrix: precalculateMatrix,
	        autoOrient: autoOrient
	    };

	    extendPrototype([DynamicPropertyContainer], TransformProperty);
	    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
	    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;

	    function getTransformProperty(elem,data,container){
	        return new TransformProperty(elem,data,container);
	    }

	    return {
	        getTransformProperty: getTransformProperty
	    };

	}());
	function ShapePath(){
		this.c = false;
		this._length = 0;
		this._maxLength = 8;
		this.v = createSizedArray(this._maxLength);
		this.o = createSizedArray(this._maxLength);
		this.i = createSizedArray(this._maxLength);
	}

	ShapePath.prototype.setPathData = function(closed, len) {
		this.c = closed;
		this.setLength(len);
		var i = 0;
		while(i < len){
			this.v[i] = point_pool.newElement();
			this.o[i] = point_pool.newElement();
			this.i[i] = point_pool.newElement();
			i += 1;
		}
	};

	ShapePath.prototype.setLength = function(len) {
		while(this._maxLength < len) {
			this.doubleArrayLength();
		}
		this._length = len;
	};

	ShapePath.prototype.doubleArrayLength = function() {
		this.v = this.v.concat(createSizedArray(this._maxLength));
		this.i = this.i.concat(createSizedArray(this._maxLength));
		this.o = this.o.concat(createSizedArray(this._maxLength));
		this._maxLength *= 2;
	};

	ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
		var arr;
		this._length = Math.max(this._length, pos + 1);
		if(this._length >= this._maxLength) {
			this.doubleArrayLength();
		}
		switch(type){
			case 'v':
				arr = this.v;
				break;
			case 'i':
				arr = this.i;
				break;
			case 'o':
				arr = this.o;
				break;
		}
		if(!arr[pos] || (arr[pos] && !replace)){
			arr[pos] = point_pool.newElement();
		}
		arr[pos][0] = x;
		arr[pos][1] = y;
	};

	ShapePath.prototype.setTripleAt = function(vX,vY,oX,oY,iX,iY,pos, replace) {
		this.setXYAt(vX,vY,'v',pos, replace);
		this.setXYAt(oX,oY,'o',pos, replace);
		this.setXYAt(iX,iY,'i',pos, replace);
	};

	ShapePath.prototype.reverse = function() {
		var newPath = new ShapePath();
		newPath.setPathData(this.c, this._length);
		var vertices = this.v, outPoints = this.o, inPoints = this.i;
		var init = 0;
		if (this.c) {
			newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
	        init = 1;
	    }
	    var cnt = this._length - 1;
	    var len = this._length;

	    var i;
	    for (i = init; i < len; i += 1) {
	    	newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
	        cnt -= 1;
	    }
	    return newPath;
	};
	var ShapePropertyFactory = (function(){

	    var initFrame = -999999;

	    function interpolateShape(frameNum, previousValue, caching) {
	        var iterationIndex = caching.lastIndex;
	        var keyPropS,keyPropE,isHold, j, k, jLen, kLen, perc, vertexValue;
	        var kf = this.keyframes;
	        if(frameNum < kf[0].t-this.offsetTime){
	            keyPropS = kf[0].s[0];
	            isHold = true;
	            iterationIndex = 0;
	        }else if(frameNum >= kf[kf.length - 1].t-this.offsetTime){
	            keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
	            /*if(kf[kf.length - 1].s){
	                keyPropS = kf[kf.length - 1].s[0];
	            }else{
	                keyPropS = kf[kf.length - 2].e[0];
	            }*/
	            isHold = true;
	        }else {
	            var i = iterationIndex;
	            var len = kf.length- 1,flag = true,keyData,nextKeyData;
	            while(flag){
	                keyData = kf[i];
	                nextKeyData = kf[i+1];
	                if((nextKeyData.t - this.offsetTime) > frameNum){
	                    break;
	                }
	                if(i < len - 1){
	                    i += 1;
	                }else {
	                    flag = false;
	                }
	            }
	            isHold = keyData.h === 1;
	            iterationIndex = i;
	            if(!isHold){
	                if(frameNum >= nextKeyData.t-this.offsetTime){
	                    perc = 1;
	                }else if(frameNum < keyData.t-this.offsetTime){
	                    perc = 0;
	                }else {
	                    var fnc;
	                    if(keyData.__fnct){
	                        fnc = keyData.__fnct;
	                    }else {
	                        fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;
	                        keyData.__fnct = fnc;
	                    }
	                    perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
	                }
	                keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
	            }
	            keyPropS = keyData.s[0];
	        }
	        jLen = previousValue._length;
	        kLen = keyPropS.i[0].length;
	        caching.lastIndex = iterationIndex;

	        for(j=0;j<jLen;j+=1){
	            for(k=0;k<kLen;k+=1){
	                vertexValue = isHold ? keyPropS.i[j][k] :  keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;
	                previousValue.i[j][k] = vertexValue;
	                vertexValue = isHold ? keyPropS.o[j][k] :  keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;
	                previousValue.o[j][k] = vertexValue;
	                vertexValue = isHold ? keyPropS.v[j][k] :  keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;
	                previousValue.v[j][k] = vertexValue;
	            }
	        }
	    }

	    function interpolateShapeCurrentTime(){
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t - this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	        var lastFrame = this._caching.lastFrame;
	        if(!(lastFrame !== initFrame && ((lastFrame < initTime && frameNum < initTime) || (lastFrame > endTime && frameNum > endTime)))){
	            ////
	            this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
	            this.interpolateShape(frameNum, this.pv, this._caching);
	            ////
	        }
	        this._caching.lastFrame = frameNum;
	        return this.pv;
	    }

	    function resetShape(){
	        this.paths = this.localShapeCollection;
	    }

	    function shapesEqual(shape1, shape2) {
	        if(shape1._length !== shape2._length || shape1.c !== shape2.c){
	            return false;
	        }
	        var i, len = shape1._length;
	        for(i = 0; i < len; i += 1) {
	            if(shape1.v[i][0] !== shape2.v[i][0] 
	            || shape1.v[i][1] !== shape2.v[i][1] 
	            || shape1.o[i][0] !== shape2.o[i][0] 
	            || shape1.o[i][1] !== shape2.o[i][1] 
	            || shape1.i[i][0] !== shape2.i[i][0] 
	            || shape1.i[i][1] !== shape2.i[i][1]) {
	                return false;
	            }
	        }
	        return true;
	    }

	    function setVValue(newPath) {
	        if(!shapesEqual(this.v, newPath)) {
	            this.v = shape_pool.clone(newPath);
	            this.localShapeCollection.releaseShapes();
	            this.localShapeCollection.addShape(this.v);
	            this._mdf = true;
	            this.paths = this.localShapeCollection;
	        }
	    }

	    function processEffectsSequence() {
	        if (this.elem.globalData.frameId === this.frameId) {
	            return;
	        } else if (!this.effectsSequence.length) {
	            this._mdf = false;
	            return;
	        }
	        if (this.lock) {
	            this.setVValue(this.pv);
	            return;
	        }
	        this.lock = true;
	        this._mdf = false;
	        var finalValue = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
	        var i, len = this.effectsSequence.length;
	        for(i = 0; i < len; i += 1) {
	            finalValue = this.effectsSequence[i](finalValue);
	        }
	        this.setVValue(finalValue);
	        this.lock = false;
	        this.frameId = this.elem.globalData.frameId;
	    }
	    function ShapeProperty(elem, data, type){
	        this.propType = 'shape';
	        this.comp = elem.comp;
	        this.container = elem;
	        this.elem = elem;
	        this.data = data;
	        this.k = false;
	        this.kf = false;
	        this._mdf = false;
	        var pathData = type === 3 ? data.pt.k : data.ks.k;
	        this.v = shape_pool.clone(pathData);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.reset = resetShape;
	        this.effectsSequence = [];
	    }

	    function addEffect(effectFunction) {
	        this.effectsSequence.push(effectFunction);
	        this.container.addDynamicProperty(this);
	    }

	    ShapeProperty.prototype.interpolateShape = interpolateShape;
	    ShapeProperty.prototype.getValue = processEffectsSequence;
	    ShapeProperty.prototype.setVValue = setVValue;
	    ShapeProperty.prototype.addEffect = addEffect;

	    function KeyframedShapeProperty(elem,data,type){
	        this.propType = 'shape';
	        this.comp = elem.comp;
	        this.elem = elem;
	        this.container = elem;
	        this.offsetTime = elem.data.st;
	        this.keyframes = type === 3 ? data.pt.k : data.ks.k;
	        this.k = true;
	        this.kf = true;
	        var len = this.keyframes[0].s[0].i.length;
	        this.keyframes[0].s[0].i[0].length;
	        this.v = shape_pool.newElement();
	        this.v.setPathData(this.keyframes[0].s[0].c, len);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.lastFrame = initFrame;
	        this.reset = resetShape;
	        this._caching = {lastFrame: initFrame, lastIndex: 0};
	        this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
	    }
	    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
	    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
	    KeyframedShapeProperty.prototype.setVValue = setVValue;
	    KeyframedShapeProperty.prototype.addEffect = addEffect;

	    var EllShapeProperty = (function(){

	        var cPoint = roundCorner;

	        function EllShapeProperty(elem,data) {
	            /*this.v = {
	                v: createSizedArray(4),
	                i: createSizedArray(4),
	                o: createSizedArray(4),
	                c: true
	            };*/
	            this.v = shape_pool.newElement();
	            this.v.setPathData(true, 4);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.paths = this.localShapeCollection;
	            this.localShapeCollection.addShape(this.v);
	            this.d = data.d;
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.initDynamicPropertyContainer(elem);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else {
	                this.k = false;
	                this.convertEllToPath();
	            }
	        }
	        EllShapeProperty.prototype = {
	            reset: resetShape,
	            getValue: function (){
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();

	                if(this._mdf){
	                    this.convertEllToPath();
	                }
	            },
	            convertEllToPath: function() {
	                var p0 = this.p.v[0], p1 = this.p.v[1], s0 = this.s.v[0]/2, s1 = this.s.v[1]/2;
	                var _cw = this.d !== 3;
	                var _v = this.v;
	                _v.v[0][0] = p0;
	                _v.v[0][1] = p1 - s1;
	                _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.v[1][1] = p1;
	                _v.v[2][0] = p0;
	                _v.v[2][1] = p1 + s1;
	                _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.v[3][1] = p1;
	                _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	                _v.i[0][1] = p1 - s1;
	                _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.i[1][1] = p1 - s1 * cPoint;
	                _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	                _v.i[2][1] = p1 + s1;
	                _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.i[3][1] = p1 + s1 * cPoint;
	                _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	                _v.o[0][1] = p1 - s1;
	                _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.o[1][1] = p1 + s1 * cPoint;
	                _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	                _v.o[2][1] = p1 + s1;
	                _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.o[3][1] = p1 - s1 * cPoint;
	            }
	        };

	        extendPrototype([DynamicPropertyContainer], EllShapeProperty);

	        return EllShapeProperty;
	    }());

	    var StarShapeProperty = (function() {

	        function StarShapeProperty(elem,data) {
	            this.v = shape_pool.newElement();
	            this.v.setPathData(true, 0);
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.data = data;
	            this.frameId = -1;
	            this.d = data.d;
	            this.initDynamicPropertyContainer(elem);
	            if(data.sy === 1){
	                this.ir = PropertyFactory.getProp(elem,data.ir,0,0,this);
	                this.is = PropertyFactory.getProp(elem,data.is,0,0.01,this);
	                this.convertToPath = this.convertStarToPath;
	            } else {
	                this.convertToPath = this.convertPolygonToPath;
	            }
	            this.pt = PropertyFactory.getProp(elem,data.pt,0,0,this);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.r = PropertyFactory.getProp(elem,data.r,0,degToRads,this);
	            this.or = PropertyFactory.getProp(elem,data.or,0,0,this);
	            this.os = PropertyFactory.getProp(elem,data.os,0,0.01,this);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else {
	                this.k = false;
	                this.convertToPath();
	            }
	        }
	        StarShapeProperty.prototype = {
	            reset: resetShape,
	            getValue: function() {
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();
	                if(this._mdf){
	                    this.convertToPath();
	                }
	            },
	            convertStarToPath: function() {
	                var numPts = Math.floor(this.pt.v)*2;
	                var angle = Math.PI*2/numPts;
	                /*this.v.v.length = numPts;
	                this.v.i.length = numPts;
	                this.v.o.length = numPts;*/
	                var longFlag = true;
	                var longRad = this.or.v;
	                var shortRad = this.ir.v;
	                var longRound = this.os.v;
	                var shortRound = this.is.v;
	                var longPerimSegment = 2*Math.PI*longRad/(numPts*2);
	                var shortPerimSegment = 2*Math.PI*shortRad/(numPts*2);
	                var i, rad,roundness,perimSegment, currentAng = -Math.PI/ 2;
	                currentAng += this.r.v;
	                var dir = this.data.d === 3 ? -1 : 1;
	                this.v._length = 0;
	                for(i=0;i<numPts;i+=1){
	                    rad = longFlag ? longRad : shortRad;
	                    roundness = longFlag ? longRound : shortRound;
	                    perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
	                    var x = rad * Math.cos(currentAng);
	                    var y = rad * Math.sin(currentAng);
	                    var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                    var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                    x +=  + this.p.v[0];
	                    y +=  + this.p.v[1];
	                    this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);

	                    /*this.v.v[i] = [x,y];
	                    this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                    this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                    this.v._length = numPts;*/
	                    longFlag = !longFlag;
	                    currentAng += angle*dir;
	                }
	            },
	            convertPolygonToPath: function() {
	                var numPts = Math.floor(this.pt.v);
	                var angle = Math.PI*2/numPts;
	                var rad = this.or.v;
	                var roundness = this.os.v;
	                var perimSegment = 2*Math.PI*rad/(numPts*4);
	                var i, currentAng = -Math.PI/ 2;
	                var dir = this.data.d === 3 ? -1 : 1;
	                currentAng += this.r.v;
	                this.v._length = 0;
	                for(i=0;i<numPts;i+=1){
	                    var x = rad * Math.cos(currentAng);
	                    var y = rad * Math.sin(currentAng);
	                    var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                    var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                    x +=  + this.p.v[0];
	                    y +=  + this.p.v[1];
	                    this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	                    currentAng += angle*dir;
	                }
	                this.paths.length = 0;
	                this.paths[0] = this.v;
	            }

	        };
	        extendPrototype([DynamicPropertyContainer], StarShapeProperty);

	        return StarShapeProperty;
	    }());

	    var RectShapeProperty = (function() {

	         function RectShapeProperty(elem,data) {
	            this.v = shape_pool.newElement();
	            this.v.c = true;
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.d = data.d;
	            this.initDynamicPropertyContainer(elem);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this);
	            this.r = PropertyFactory.getProp(elem,data.r,0,0,this);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else {
	                this.k = false;
	                this.convertRectToPath();
	            }
	        }
	        RectShapeProperty.prototype = {
	            convertRectToPath: function (){
	                var p0 = this.p.v[0], p1 = this.p.v[1], v0 = this.s.v[0]/2, v1 = this.s.v[1]/2;
	                var round = bm_min(v0,v1,this.r.v);
	                var cPoint = round*(1-roundCorner);
	                this.v._length = 0;

	                if(this.d === 2 || this.d === 1) {
	                    this.v.setTripleAt(p0+v0, p1-v1+round,p0+v0, p1-v1+round,p0+v0,p1-v1+cPoint,0, true);
	                    this.v.setTripleAt(p0+v0, p1+v1-round,p0+v0, p1+v1-cPoint,p0+v0, p1+v1-round,1, true);
	                    if(round!== 0){
	                        this.v.setTripleAt(p0+v0-round, p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2, true);
	                        this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3, true);
	                        this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4, true);
	                        this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5, true);
	                        this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6, true);
	                        this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7, true);
	                    } else {
	                        this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);
	                        this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);
	                    }
	                }else {
	                    this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0, true);
	                    if(round!== 0){
	                        this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1, true);
	                        this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2, true);
	                        this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3, true);
	                        this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4, true);
	                        this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5, true);
	                        this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6, true);
	                        this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7, true);
	                    } else {
	                        this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1, true);
	                        this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2, true);
	                        this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3, true);

	                    }
	                }
	            },
	            getValue: function(frameNum){
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();
	                if(this._mdf){
	                    this.convertRectToPath();
	                }

	            },
	            reset: resetShape
	        };
	        extendPrototype([DynamicPropertyContainer], RectShapeProperty);

	        return RectShapeProperty;
	    }());

	    function getShapeProp(elem,data,type){
	        var prop;
	        if(type === 3 || type === 4){
	            var dataProp = type === 3 ? data.pt : data.ks;
	            var keys = dataProp.k;
	            if(keys.length){
	                prop = new KeyframedShapeProperty(elem, data, type);
	            }else {
	                prop = new ShapeProperty(elem, data, type);
	            }
	        }else if(type === 5){
	            prop = new RectShapeProperty(elem, data);
	        }else if(type === 6){
	            prop = new EllShapeProperty(elem, data);
	        }else if(type === 7){
	            prop = new StarShapeProperty(elem, data);
	        }
	        if(prop.k){
	            elem.addDynamicProperty(prop);
	        }
	        return prop;
	    }

	    function getConstructorFunction() {
	        return ShapeProperty;
	    }

	    function getKeyframedConstructorFunction() {
	        return KeyframedShapeProperty;
	    }

	    var ob = {};
	    ob.getShapeProp = getShapeProp;
	    ob.getConstructorFunction = getConstructorFunction;
	    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
	    return ob;
	}());
	var ShapeModifiers = (function(){
	    var ob = {};
	    var modifiers = {};
	    ob.registerModifier = registerModifier;
	    ob.getModifier = getModifier;

	    function registerModifier(nm,factory){
	        if(!modifiers[nm]){
	            modifiers[nm] = factory;
	        }
	    }

	    function getModifier(nm,elem, data){
	        return new modifiers[nm](elem, data);
	    }

	    return ob;
	}());

	function ShapeModifier(){}
	ShapeModifier.prototype.initModifierProperties = function(){};
	ShapeModifier.prototype.addShapeToModifier = function(){};
	ShapeModifier.prototype.addShape = function(data){
	    if (!this.closed) {
	        // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
	        data.sh.container.addDynamicProperty(data.sh);
	        var shapeData = {shape:data.sh, data: data, localShapeCollection:shapeCollection_pool.newShapeCollection()};
	        this.shapes.push(shapeData);
	        this.addShapeToModifier(shapeData);
	        if (this._isAnimated) {
	            data.setAsAnimated();
	        }
	    }
	};
	ShapeModifier.prototype.init = function(elem,data){
	    this.shapes = [];
	    this.elem = elem;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem,data);
	    this.frameId = initialDefaultFrame;
	    this.closed = false;
	    this.k = false;
	    if(this.dynamicProperties.length){
	        this.k = true;
	    }else {
	        this.getValue(true);
	    }
	};
	ShapeModifier.prototype.processKeys = function(){
	    if(this.elem.globalData.frameId === this.frameId){
	        return;
	    }
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	};

	extendPrototype([DynamicPropertyContainer], ShapeModifier);
	function TrimModifier(){
	}
	extendPrototype([ShapeModifier], TrimModifier);
	TrimModifier.prototype.initModifierProperties = function(elem, data) {
	    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
	    this.sValue = 0;
	    this.eValue = 0;
	    this.getValue = this.processKeys;
	    this.m = data.m;
	    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
	};

	TrimModifier.prototype.addShapeToModifier = function(shapeData){
	    shapeData.pathsData = [];
	};

	TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
	    var segments = [];
	    if (e <= 1) {
	        segments.push({
	            s: s,
	            e: e
	        });
	    } else if (s >= 1) {
	        segments.push({
	            s: s - 1,
	            e: e - 1
	        });
	    } else {
	        segments.push({
	            s: s,
	            e: 1
	        });
	        segments.push({
	            s: 0,
	            e: e - 1
	        });
	    }
	    var shapeSegments = [];
	    var i, len = segments.length, segmentOb;
	    for (i = 0; i < len; i += 1) {
	        segmentOb = segments[i];
	        if (segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength) ; else {
	            var shapeS, shapeE;
	            if (segmentOb.s * totalModifierLength <= addedLength) {
	                shapeS = 0;
	            } else {
	                shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
	            }
	            if(segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
	                shapeE = 1;
	            } else {
	                shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
	            }
	            shapeSegments.push([shapeS, shapeE]);
	        }
	    }
	    if (!shapeSegments.length) {
	        shapeSegments.push([0, 0]);
	    }
	    return shapeSegments;
	};

	TrimModifier.prototype.releasePathsData = function(pathsData) {
	    var i, len = pathsData.length;
	    for (i = 0; i < len; i += 1) {
	        segments_length_pool.release(pathsData[i]);
	    }
	    pathsData.length = 0;
	    return pathsData;
	};

	TrimModifier.prototype.processShapes = function(_isFirstFrame) {
	    var s, e;
	    if (this._mdf || _isFirstFrame) {
	        var o = (this.o.v % 360) / 360;
	        if (o < 0) {
	            o += 1;
	        }
	        s = (this.s.v > 1 ? 1 : this.s.v < 0 ? 0 : this.s.v) + o;
	        e = (this.e.v > 1 ? 1 : this.e.v < 0 ? 0 : this.e.v) + o;
	        if (s > e) {
	            var _s = s;
	            s = e;
	            e = _s;
	        }
	        s = Math.round(s * 10000) * 0.0001;
	        e = Math.round(e * 10000) * 0.0001;
	        this.sValue = s;
	        this.eValue = e;
	    } else {
	        s = this.sValue;
	        e = this.eValue;
	    }
	    var shapePaths;
	    var i, len = this.shapes.length, j, jLen;
	    var pathsData, pathData, totalShapeLength, totalModifierLength = 0;

	    if (e === s) {
	        for (i = 0; i < len; i += 1) {
	            this.shapes[i].localShapeCollection.releaseShapes();
	            this.shapes[i].shape._mdf = true;
	            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
	        }
	    } else if (!((e === 1 && s === 0) || (e===0 && s === 1))){
	        var segments = [], shapeData, localShapeCollection;
	        for (i = 0; i < len; i += 1) {
	            shapeData = this.shapes[i];
	            // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
	            if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
	                shapeData.shape.paths = shapeData.localShapeCollection;
	            } else {
	                shapePaths = shapeData.shape.paths;
	                jLen = shapePaths._length;
	                totalShapeLength = 0;
	                if (!shapeData.shape._mdf && shapeData.pathsData.length) {
	                    totalShapeLength = shapeData.totalShapeLength;
	                } else {
	                    pathsData = this.releasePathsData(shapeData.pathsData);
	                    for (j = 0; j < jLen; j += 1) {
	                        pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
	                        pathsData.push(pathData);
	                        totalShapeLength += pathData.totalLength;
	                    }
	                    shapeData.totalShapeLength = totalShapeLength;
	                    shapeData.pathsData = pathsData;
	                }

	                totalModifierLength += totalShapeLength;
	                shapeData.shape._mdf = true;
	            }
	        }
	        var shapeS = s, shapeE = e, addedLength = 0, edges;
	        for (i = len - 1; i >= 0; i -= 1) {
	            shapeData = this.shapes[i];
	            if (shapeData.shape._mdf) {
	                localShapeCollection = shapeData.localShapeCollection;
	                localShapeCollection.releaseShapes();
	                //if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
	                if (this.m === 2 && len > 1) {
	                    edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
	                    addedLength += shapeData.totalShapeLength;
	                } else {
	                    edges = [[shapeS, shapeE]];
	                }
	                jLen = edges.length;
	                for (j = 0; j < jLen; j += 1) {
	                    shapeS = edges[j][0];
	                    shapeE = edges[j][1];
	                    segments.length = 0;
	                    if (shapeE <= 1) {
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength * shapeE
	                        });
	                    } else if (shapeS >= 1) {
	                        segments.push({
	                            s:shapeData.totalShapeLength * (shapeS - 1),
	                            e:shapeData.totalShapeLength * (shapeE - 1)
	                        });
	                    } else {
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength
	                        });
	                        segments.push({
	                            s:0,
	                            e:shapeData.totalShapeLength * (shapeE - 1)
	                        });
	                    }
	                    var newShapesData = this.addShapes(shapeData,segments[0]);
	                    if (segments[0].s !== segments[0].e) {
	                        if (segments.length > 1) {
	                            var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
	                            if (lastShapeInCollection.c) {
	                                var lastShape = newShapesData.pop();
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData, segments[1], lastShape);
	                            } else {
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData, segments[1]);
	                            }
	                        } 
	                        this.addPaths(newShapesData, localShapeCollection);
	                    }
	                    
	                }
	                shapeData.shape.paths = localShapeCollection;
	            }
	        }
	    } else if (this._mdf) {
	        for (i = 0; i < len; i += 1) {
	            //Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
	            //Don't remove this even if it's losing cached info.
	            this.shapes[i].pathsData.length = 0;
	            this.shapes[i].shape._mdf = true;
	        }
	    }
	};

	TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
	    var i, len = newPaths.length;
	    for (i = 0; i < len; i += 1) {
	        localShapeCollection.addShape(newPaths[i]);
	    }
	};

	TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
	    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
	    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
	    if(newShape){
	        shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
	    }
	    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
	};

	TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
	    shapePath.setXYAt(points[1], points[5], 'o', pos);
	    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
	    if(newShape){
	        shapePath.setXYAt(points[0], points[4], 'v', pos);
	    }
	    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
	};

	TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
	    var pathsData = shapeData.pathsData;
	    var shapePaths = shapeData.shape.paths.shapes;
	    var i, len = shapeData.shape.paths._length, j, jLen;
	    var addedLength = 0;
	    var currentLengthData,segmentCount;
	    var lengths;
	    var segment;
	    var shapes = [];
	    var initPos;
	    var newShape = true;
	    if (!shapePath) {
	        shapePath = shape_pool.newElement();
	        segmentCount = 0;
	        initPos = 0;
	    } else {
	        segmentCount = shapePath._length;
	        initPos = shapePath._length;
	    }
	    shapes.push(shapePath);
	    for (i = 0; i < len; i += 1) {
	        lengths = pathsData[i].lengths;
	        shapePath.c = shapePaths[i].c;
	        jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
	        for (j = 1; j < jLen; j +=1) {
	            currentLengthData = lengths[j-1];
	            if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
	                addedLength += currentLengthData.addedLength;
	                shapePath.c = false;
	            } else if(addedLength > shapeSegment.e) {
	                shapePath.c = false;
	                break;
	            } else {
	                if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
	                    this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
	                    newShape = false;
	                } else {
	                    segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength)/currentLengthData.addedLength,(shapeSegment.e - addedLength)/currentLengthData.addedLength, lengths[j-1]);
	                    this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
	                    // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	                addedLength += currentLengthData.addedLength;
	                segmentCount += 1;
	            }
	        }
	        if (shapePaths[i].c && lengths.length) {
	            currentLengthData = lengths[j - 1];
	            if (addedLength <= shapeSegment.e) {
	                var segmentLength = lengths[j - 1].addedLength;
	                if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
	                    this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
	                    newShape = false;
	                } else {
	                    segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
	                    this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
	                    // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	            } else {
	                shapePath.c = false;
	            }
	            addedLength += currentLengthData.addedLength;
	            segmentCount += 1;
	        }
	        if (shapePath._length) {
	            shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
	            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1],'o', shapePath._length - 1);
	        }
	        if (addedLength > shapeSegment.e) {
	            break;
	        }
	        if (i < len - 1) {
	            shapePath = shape_pool.newElement();
	            newShape = true;
	            shapes.push(shapePath);
	            segmentCount = 0;
	        }
	    }
	    return shapes;
	};


	ShapeModifiers.registerModifier('tm', TrimModifier);
	function RoundCornersModifier(){}
	extendPrototype([ShapeModifier],RoundCornersModifier);
	RoundCornersModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.rd = PropertyFactory.getProp(elem,data.r,0,null,this);
	    this._isAnimated = !!this.rd.effectsSequence.length;
	};

	RoundCornersModifier.prototype.processPath = function(path, round){
	    var cloned_path = shape_pool.newElement();
	    cloned_path.c = path.c;
	    var i, len = path._length;
	    var currentV,currentI,currentO,closerV, distance,newPosPerc,index = 0;
	    var vX,vY,oX,oY,iX,iY;
	    for(i=0;i<len;i+=1){
	        currentV = path.v[i];
	        currentO = path.o[i];
	        currentI = path.i[i];
	        if(currentV[0]===currentO[0] && currentV[1]===currentO[1] && currentV[0]===currentI[0] && currentV[1]===currentI[1]){
	            if((i===0 || i === len - 1) && !path.c){
	                cloned_path.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);
	                /*cloned_path.v[index] = currentV;
	                cloned_path.o[index] = currentO;
	                cloned_path.i[index] = currentI;*/
	                index += 1;
	            } else {
	                if(i===0){
	                    closerV = path.v[len-1];
	                } else {
	                    closerV = path.v[i-1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = iX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = iY = currentV[1]-(currentV[1]-closerV[1])*newPosPerc;
	                oX = vX-(vX-currentV[0])*roundCorner;
	                oY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;

	                if(i === len - 1){
	                    closerV = path.v[0];
	                } else {
	                    closerV = path.v[i+1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = oX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = oY = currentV[1]+(closerV[1]-currentV[1])*newPosPerc;
	                iX = vX-(vX-currentV[0])*roundCorner;
	                iY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;
	            }
	        } else {
	            cloned_path.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);
	            index += 1;
	        }
	    }
	    return cloned_path;
	};

	RoundCornersModifier.prototype.processShapes = function(_isFirstFrame){
	    var shapePaths;
	    var i, len = this.shapes.length;
	    var j, jLen;
	    var rd = this.rd.v;

	    if(rd !== 0){
	        var shapeData, localShapeCollection;
	        for(i=0;i<len;i+=1){
	            shapeData = this.shapes[i];
	            shapeData.shape.paths;
	            localShapeCollection = shapeData.localShapeCollection;
	            if(!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)){
	                localShapeCollection.releaseShapes();
	                shapeData.shape._mdf = true;
	                shapePaths = shapeData.shape.paths.shapes;
	                jLen = shapeData.shape.paths._length;
	                for(j=0;j<jLen;j+=1){
	                    localShapeCollection.addShape(this.processPath(shapePaths[j],rd));
	                }
	            }
	            shapeData.shape.paths = shapeData.localShapeCollection;
	        }

	    }
	    if(!this.dynamicProperties.length){
	        this._mdf = false;
	    }
	};

	ShapeModifiers.registerModifier('rd',RoundCornersModifier);
	function RepeaterModifier(){}
	extendPrototype([ShapeModifier], RepeaterModifier);

	RepeaterModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.c = PropertyFactory.getProp(elem,data.c,0,null,this);
	    this.o = PropertyFactory.getProp(elem,data.o,0,null,this);
	    this.tr = TransformPropertyFactory.getTransformProperty(elem,data.tr,this);
	    this.so = PropertyFactory.getProp(elem,data.tr.so,0,0.01,this);
	    this.eo = PropertyFactory.getProp(elem,data.tr.eo,0,0.01,this);
	    this.data = data;
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	    this._isAnimated = !!this.dynamicProperties.length;
	    this.pMatrix = new Matrix();
	    this.rMatrix = new Matrix();
	    this.sMatrix = new Matrix();
	    this.tMatrix = new Matrix();
	    this.matrix = new Matrix();
	};

	RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv){
	    var dir = inv ? -1 : 1;
	    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
	    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
	    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
	    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    rMatrix.rotate(-transform.r.v * dir * perc);
	    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    sMatrix.scale(inv ? 1/scaleX : scaleX, inv ? 1/scaleY : scaleY);
	    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	};

	RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
	    this.elem = elem;
	    this.arr = arr;
	    this.pos = pos;
	    this.elemsData = elemsData;
	    this._currentCopies = 0;
	    this._elements = [];
	    this._groups = [];
	    this.frameId = -1;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem,arr[pos]);
	    while(pos>0){
	        pos -= 1;
	        //this._elements.unshift(arr.splice(pos,1)[0]);
	        this._elements.unshift(arr[pos]);
	    }
	    if(this.dynamicProperties.length){
	        this.k = true;
	    }else {
	        this.getValue(true);
	    }
	};

	RepeaterModifier.prototype.resetElements = function(elements){
	    var i, len = elements.length;
	    for(i = 0; i < len; i += 1) {
	        elements[i]._processed = false;
	        if(elements[i].ty === 'gr'){
	            this.resetElements(elements[i].it);
	        }
	    }
	};

	RepeaterModifier.prototype.cloneElements = function(elements){
	    elements.length;
	    var newElements = JSON.parse(JSON.stringify(elements));
	    this.resetElements(newElements);
	    return newElements;
	};

	RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
	    var i, len = elements.length;
	    for(i = 0; i < len; i += 1) {
	        elements[i]._render = renderFlag;
	        if(elements[i].ty === 'gr') {
	            this.changeGroupRender(elements[i].it, renderFlag);
	        }
	    }
	};

	RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
	    var items, itemsTransform, i, dir, cont;
	    if(this._mdf || _isFirstFrame){
	        var copies = Math.ceil(this.c.v);
	        if(this._groups.length < copies){
	            while(this._groups.length < copies){
	                var group = {
	                    it:this.cloneElements(this._elements),
	                    ty:'gr'
	                };
	                group.it.push({"a":{"a":0,"ix":1,"k":[0,0]},"nm":"Transform","o":{"a":0,"ix":7,"k":100},"p":{"a":0,"ix":2,"k":[0,0]},"r":{"a":1,"ix":6,"k":[{s:0,e:0,t:0},{s:0,e:0,t:1}]},"s":{"a":0,"ix":3,"k":[100,100]},"sa":{"a":0,"ix":5,"k":0},"sk":{"a":0,"ix":4,"k":0},"ty":"tr"});
	                
	                this.arr.splice(0,0,group);
	                this._groups.splice(0,0,group);
	                this._currentCopies += 1;
	            }
	            this.elem.reloadShapes();
	        }
	        cont = 0;
	        var renderFlag;
	        for(i = 0; i  <= this._groups.length - 1; i += 1){
	            renderFlag = cont < copies;
	            this._groups[i]._render = renderFlag;
	            this.changeGroupRender(this._groups[i].it, renderFlag);
	            cont += 1;
	        }
	        
	        this._currentCopies = copies;
	        ////

	        var offset = this.o.v;
	        var offsetModulo = offset%1;
	        var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
	        this.tr.v.props;
	        var pProps = this.pMatrix.props;
	        var rProps = this.rMatrix.props;
	        var sProps = this.sMatrix.props;
	        this.pMatrix.reset();
	        this.rMatrix.reset();
	        this.sMatrix.reset();
	        this.tMatrix.reset();
	        this.matrix.reset();
	        var iteration = 0;

	        if(offset > 0) {
	            while(iteration<roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                iteration += 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
	                iteration += offsetModulo;
	            }
	        } else if(offset < 0) {
	            while(iteration>roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
	                iteration -= 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, - offsetModulo, true);
	                iteration -= offsetModulo;
	            }
	        }
	        i = this.data.m === 1 ? 0 : this._currentCopies - 1;
	        dir = this.data.m === 1 ? 1 : -1;
	        cont = this._currentCopies;
	        var j, jLen;
	        while(cont){
	            items = this.elemsData[i].it;
	            itemsTransform = items[items.length - 1].transform.mProps.v.props;
	            jLen = itemsTransform.length;
	            items[items.length - 1].transform.mProps._mdf = true;
	            items[items.length - 1].transform.op._mdf = true;
	            items[items.length - 1].transform.op.v = this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
	            if(iteration !== 0){
	                if((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)){
	                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                }
	                this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);
	                this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);
	                this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);
	                
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	                this.matrix.reset();
	            } else {
	                this.matrix.reset();
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	            }
	            iteration += 1;
	            cont -= 1;
	            i += dir;
	        }
	    } else {
	        cont = this._currentCopies;
	        i = 0;
	        dir = 1;
	        while(cont){
	            items = this.elemsData[i].it;
	            itemsTransform = items[items.length - 1].transform.mProps.v.props;
	            items[items.length - 1].transform.mProps._mdf = false;
	            items[items.length - 1].transform.op._mdf = false;
	            cont -= 1;
	            i += dir;
	        }
	    }
	};

	RepeaterModifier.prototype.addShape = function(){};

	ShapeModifiers.registerModifier('rp',RepeaterModifier);
	function ShapeCollection(){
		this._length = 0;
		this._maxLength = 4;
		this.shapes = createSizedArray(this._maxLength);
	}

	ShapeCollection.prototype.addShape = function(shapeData){
		if(this._length === this._maxLength){
			this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
			this._maxLength *= 2;
		}
		this.shapes[this._length] = shapeData;
		this._length += 1;
	};

	ShapeCollection.prototype.releaseShapes = function(){
		var i;
		for(i = 0; i < this._length; i += 1) {
			shape_pool.release(this.shapes[i]);
		}
		this._length = 0;
	};
	function DashProperty(elem, data, renderer, container) {
	    this.elem = elem;
	    this.frameId = -1;
	    this.dataProps = createSizedArray(data.length);
	    this.renderer = renderer;
	    this.k = false;
	    this.dashStr = '';
	    this.dashArray = createTypedArray('float32',  data.length ? data.length - 1 : 0);
	    this.dashoffset = createTypedArray('float32',  1);
	    this.initDynamicPropertyContainer(container);
	    var i, len = data.length || 0, prop;
	    for(i = 0; i < len; i += 1) {
	        prop = PropertyFactory.getProp(elem,data[i].v,0, 0, this);
	        this.k = prop.k || this.k;
	        this.dataProps[i] = {n:data[i].n,p:prop};
	    }
	    if(!this.k){
	        this.getValue(true);
	    }
	    this._isAnimated = this.k;
	}

	DashProperty.prototype.getValue = function(forceRender) {
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	    this._mdf = this._mdf || forceRender;
	    if (this._mdf) {
	        var i = 0, len = this.dataProps.length;
	        if(this.renderer === 'svg') {
	            this.dashStr = '';
	        }
	        for(i=0;i<len;i+=1){
	            if(this.dataProps[i].n != 'o'){
	                if(this.renderer === 'svg') {
	                    this.dashStr += ' ' + this.dataProps[i].p.v;
	                }else {
	                    this.dashArray[i] = this.dataProps[i].p.v;
	                }
	            }else {
	                this.dashoffset[0] = this.dataProps[i].p.v;
	            }
	        }
	    }
	};
	extendPrototype([DynamicPropertyContainer], DashProperty);
	function GradientProperty(elem,data,container){
	    this.data = data;
	    this.c = createTypedArray('uint8c', data.p*4);
	    var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p*4) : data.k.k.length - data.p*4;
	    this.o = createTypedArray('float32', cLength);
	    this._cmdf = false;
	    this._omdf = false;
	    this._collapsable = this.checkCollapsable();
	    this._hasOpacity = cLength;
	    this.initDynamicPropertyContainer(container);
	    this.prop = PropertyFactory.getProp(elem,data.k,1,null,this);
	    this.k = this.prop.k;
	    this.getValue(true);
	}

	GradientProperty.prototype.comparePoints = function(values, points) {
	    var i = 0, len = this.o.length/2, diff;
	    while(i < len) {
	        diff = Math.abs(values[i*4] - values[points*4 + i*2]);
	        if(diff > 0.01){
	            return false;
	        }
	        i += 1;
	    }
	    return true;
	};

	GradientProperty.prototype.checkCollapsable = function() {
	    if (this.o.length/2 !== this.c.length/4) {
	        return false;
	    }
	    if (this.data.k.k[0].s) {
	        var i = 0, len = this.data.k.k.length;
	        while (i < len) {
	            if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
	                return false;
	            }
	            i += 1;
	        }
	    } else if(!this.comparePoints(this.data.k.k, this.data.p)) {
	        return false;
	    }
	    return true;
	};

	GradientProperty.prototype.getValue = function(forceRender){
	    this.prop.getValue();
	    this._mdf = false;
	    this._cmdf = false;
	    this._omdf = false;
	    if(this.prop._mdf || forceRender){
	        var i, len = this.data.p*4;
	        var mult, val;
	        for(i=0;i<len;i+=1){
	            mult = i%4 === 0 ? 100 : 255;
	            val = Math.round(this.prop.v[i]*mult);
	            if(this.c[i] !== val){
	                this.c[i] = val;
	                this._cmdf = !forceRender;
	            }
	        }
	        if(this.o.length){
	            len = this.prop.v.length;
	            for(i=this.data.p*4;i<len;i+=1){
	                mult = i%2 === 0 ? 100 : 1;
	                val = i%2 === 0 ?  Math.round(this.prop.v[i]*100):this.prop.v[i];
	                if(this.o[i-this.data.p*4] !== val){
	                    this.o[i-this.data.p*4] = val;
	                    this._omdf = !forceRender;
	                }
	            }
	        }
	        this._mdf = !forceRender;
	    }
	};

	extendPrototype([DynamicPropertyContainer], GradientProperty);
	var buildShapeString = function(pathNodes, length, closed, mat) {
		if(length === 0) {
	            return '';
	        }
	        var _o = pathNodes.o;
	        var _i = pathNodes.i;
	        var _v = pathNodes.v;
	        var i, shapeString = " M" + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	        for(i = 1; i < length; i += 1) {
	            shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[i][0], _i[i][1]) + " " + mat.applyToPointStringified(_v[i][0], _v[i][1]);
	        }
	        if (closed && length) {
	            shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[0][0], _i[0][1]) + " " + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	            shapeString += 'z';
	        }
	        return shapeString;
	};
	var ImagePreloader = (function(){

	    var proxyImage = (function(){
	        var canvas = createTag('canvas');
	        canvas.width = 1;
	        canvas.height = 1;
	        var ctx = canvas.getContext('2d');
	        ctx.fillStyle = 'rgba(0,0,0,0)';
	        ctx.fillRect(0, 0, 1, 1);
	        return canvas;
	    }());

	    function imageLoaded(){
	        this.loadedAssets += 1;
	        if(this.loadedAssets === this.totalImages){
	            if(this.imagesLoadedCb) {
	                this.imagesLoadedCb(null);
	            }
	        }
	    }

	    function getAssetsPath(assetData, assetsPath, original_path) {
	        var path = '';
	        if (assetData.e) {
	            path = assetData.p;
	        } else if(assetsPath) {
	            var imagePath = assetData.p;
	            if (imagePath.indexOf('images/') !== -1) {
	                imagePath = imagePath.split('/')[1];
	            }
	            path = assetsPath + imagePath;
	        } else {
	            path = original_path;
	            path += assetData.u ? assetData.u : '';
	            path += assetData.p;
	        }
	        return path;
	    }

	    function createImageData(assetData) {
	        var path = getAssetsPath(assetData, this.assetsPath, this.path);
	        var img = createNS('image');
	        img.addEventListener('load', this._imageLoaded, false);
	        img.addEventListener('error', function() {
	            ob.img = proxyImage;
	            this._imageLoaded();
	        }.bind(this), false);
	        img.setAttributeNS('http://www.w3.org/1999/xlink','href', path);
	        var ob = {
	            img: img,
	            assetData: assetData
	        };
	        return ob;
	    }

	    function createImgData(assetData) {
	        var path = getAssetsPath(assetData, this.assetsPath, this.path);
	        var img = createTag('img');
	        img.crossOrigin = 'anonymous';
	        img.addEventListener('load', this._imageLoaded, false);
	        img.addEventListener('error', function() {
	            ob.img = proxyImage;
	            this._imageLoaded();
	        }.bind(this), false);
	        img.src = path;
	        var ob = {
	            img: img,
	            assetData: assetData
	        };
	        return ob;
	    }

	    function loadAssets(assets, cb){
	        this.imagesLoadedCb = cb;
	        var i, len = assets.length;
	        for (i = 0; i < len; i += 1) {
	            if(!assets[i].layers){
	                this.totalImages += 1;
	                this.images.push(this._createImageData(assets[i]));
	            }
	        }
	    }

	    function setPath(path){
	        this.path = path || '';
	    }

	    function setAssetsPath(path){
	        this.assetsPath = path || '';
	    }

	    function getImage(assetData) {
	        var i = 0, len = this.images.length;
	        while (i < len) {
	            if (this.images[i].assetData === assetData) {
	                return this.images[i].img;
	            }
	            i += 1;
	        }
	    }

	    function destroy() {
	        this.imagesLoadedCb = null;
	        this.images.length = 0;
	    }

	    function loaded() {
	        return this.totalImages === this.loadedAssets;
	    }

	    function setCacheType(type) {
	        if (type === 'svg') {
	            this._createImageData = this.createImageData.bind(this);
	        } else {
	            this._createImageData = this.createImgData.bind(this);
	        }
	    }

	    function ImagePreloader(type){
	        this._imageLoaded = imageLoaded.bind(this);
	        this.assetsPath = '';
	        this.path = '';
	        this.totalImages = 0;
	        this.loadedAssets = 0;
	        this.imagesLoadedCb = null;
	        this.images = [];
	    }
	    ImagePreloader.prototype = {
	        loadAssets: loadAssets,
	        setAssetsPath: setAssetsPath,
	        setPath: setPath,
	        loaded: loaded,
	        destroy: destroy,
	        getImage: getImage,
	        createImgData: createImgData,
	        createImageData: createImageData,
	        imageLoaded: imageLoaded,
	        setCacheType: setCacheType,
	    };

	    return ImagePreloader;
	}());
	var featureSupport = (function(){
		var ob = {
			maskType: true
		};
		if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
		   ob.maskType = false;
		}
		return ob;
	}());
	var filtersFactory = (function(){
		var ob = {};
		ob.createFilter = createFilter;
		ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

		function createFilter(filId){
	        	var fil = createNS('filter');
	        	fil.setAttribute('id',filId);
	                fil.setAttribute('filterUnits','objectBoundingBox');
	                fil.setAttribute('x','0%');
	                fil.setAttribute('y','0%');
	                fil.setAttribute('width','100%');
	                fil.setAttribute('height','100%');
	                return fil;
		}

		function createAlphaToLuminanceFilter(){
	                var feColorMatrix = createNS('feColorMatrix');
	                feColorMatrix.setAttribute('type','matrix');
	                feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	                feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
	                return feColorMatrix;
		}

		return ob;
	}());
	var assetLoader = (function(){

		function formatResponse(xhr) {
			if(xhr.response && typeof xhr.response === 'object') {
				return xhr.response;
			} else if(xhr.response && typeof xhr.response === 'string') {
				return JSON.parse(xhr.response);
			} else if(xhr.responseText) {
				return JSON.parse(xhr.responseText);
			}
		}

		function loadAsset(path, callback, errorCallback) {
			var response;
			var xhr = new XMLHttpRequest();
			xhr.open('GET', path, true);
			// set responseType after calling open or IE will break.
			try {
			    // This crashes on Android WebView prior to KitKat
			    xhr.responseType = "json";
			} catch (err) {}
		    xhr.send();
		    xhr.onreadystatechange = function () {
		        if (xhr.readyState == 4) {
		            if(xhr.status == 200){
		            	response = formatResponse(xhr);
		            	callback(response);
		            }else {
		                try{
		            		response = formatResponse(xhr);
		            		callback(response);
		                }catch(err){
		                	if(errorCallback) {
		                		errorCallback(err);
		                	}
		                }
		            }
		        }
		    };
		}
		return {
			load: loadAsset
		}
	}());

	function TextAnimatorProperty(textData, renderType, elem){
	    this._isFirstFrame = true;
		this._hasMaskedPath = false;
		this._frameId = -1;
		this._textData = textData;
		this._renderType = renderType;
	    this._elem = elem;
		this._animatorsData = createSizedArray(this._textData.a.length);
		this._pathData = {};
		this._moreOptions = {
			alignment: {}
		};
		this.renderedLetters = [];
	    this.lettersChangedFlag = false;
	    this.initDynamicPropertyContainer(elem);

	}

	TextAnimatorProperty.prototype.searchProperties = function(){
	    var i, len = this._textData.a.length, animatorProps;
	    var getProp = PropertyFactory.getProp;
	    for(i=0;i<len;i+=1){
	        animatorProps = this._textData.a[i];
	        this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
	    }
	    if(this._textData.p && 'm' in this._textData.p){
	        this._pathData = {
	            f: getProp(this._elem,this._textData.p.f,0,0,this),
	            l: getProp(this._elem,this._textData.p.l,0,0,this),
	            r: this._textData.p.r,
	            m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
	        };
	        this._hasMaskedPath = true;
	    } else {
	        this._hasMaskedPath = false;
	    }
	    this._moreOptions.alignment = getProp(this._elem,this._textData.m.a,1,0,this);
	};

	TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag){
	    this.lettersChangedFlag = lettersChangedFlag;
	    if(!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
	        return;
	    }
	    this._isFirstFrame = false;
	    var alignment = this._moreOptions.alignment.v;
	    var animators = this._animatorsData;
	    var textData = this._textData;
	    var matrixHelper = this.mHelper;
	    var renderType = this._renderType;
	    var renderedLettersCount = this.renderedLetters.length;
	    this.data;
	    var xPos,yPos;
	    var i, len;
	    var letters = documentData.l, pathInfo, currentLength, currentPoint, segmentLength, flag, pointInd, segmentInd, prevPoint, points, segments, partialLength, totalLength, perc, tanAngle, mask;
	    if(this._hasMaskedPath) {
	        mask = this._pathData.m;
	        if(!this._pathData.n || this._pathData._mdf){
	            var paths = mask.v;
	            if(this._pathData.r){
	                paths = paths.reverse();
	            }
	            // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
	            pathInfo = {
	                tLength: 0,
	                segments: []
	            };
	            len = paths._length - 1;
	            var bezierData;
	            totalLength = 0;
	            for (i = 0; i < len; i += 1) {
	                bezierData = bez.buildBezierData(paths.v[i]
	                    , paths.v[i + 1]
	                    , [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]]
	                    , [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
	                pathInfo.tLength += bezierData.segmentLength;
	                pathInfo.segments.push(bezierData);
	                totalLength += bezierData.segmentLength;
	            }
	            i = len;
	            if (mask.v.c) {
	                bezierData = bez.buildBezierData(paths.v[i]
	                    , paths.v[0]
	                    , [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]]
	                    , [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
	                pathInfo.tLength += bezierData.segmentLength;
	                pathInfo.segments.push(bezierData);
	                totalLength += bezierData.segmentLength;
	            }
	            this._pathData.pi = pathInfo;
	        }
	        pathInfo = this._pathData.pi;

	        currentLength = this._pathData.f.v;
	        segmentInd = 0;
	        pointInd = 1;
	        segmentLength = 0;
	        flag = true;
	        segments = pathInfo.segments;
	        if (currentLength < 0 && mask.v.c) {
	            if (pathInfo.tLength < Math.abs(currentLength)) {
	                currentLength = -Math.abs(currentLength) % pathInfo.tLength;
	            }
	            segmentInd = segments.length - 1;
	            points = segments[segmentInd].points;
	            pointInd = points.length - 1;
	            while (currentLength < 0) {
	                currentLength += points[pointInd].partialLength;
	                pointInd -= 1;
	                if (pointInd < 0) {
	                    segmentInd -= 1;
	                    points = segments[segmentInd].points;
	                    pointInd = points.length - 1;
	                }
	            }

	        }
	        points = segments[segmentInd].points;
	        prevPoint = points[pointInd - 1];
	        currentPoint = points[pointInd];
	        partialLength = currentPoint.partialLength;
	    }


	    len = letters.length;
	    xPos = 0;
	    yPos = 0;
	    var yOff = documentData.finalSize * 1.2 * 0.714;
	    var firstLine = true;
	    var animatorProps, animatorSelector;
	    var j, jLen;
	    var letterValue;

	    jLen = animators.length;

	    var mult, ind = -1, offf, xPathPos, yPathPos;
	    var initPathPos = currentLength,initSegmentInd = segmentInd, initPointInd = pointInd, currentLine = -1;
	    var elemOpacity;
	    var sc,sw,fc,k;
	    var lineLength = 0;
	    var letterSw, letterSc, letterFc, letterM = '', letterP = this.defaultPropsArray, letterO;

	    //
	    if(documentData.j === 2 || documentData.j === 1) {
	        var animatorJustifyOffset = 0;
	        var animatorFirstCharOffset = 0;
	        var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
	        var lastIndex = 0;
	        var isNewLine = true;

	        for (i = 0; i < len; i += 1) {
	            if (letters[i].n) {
	                if(animatorJustifyOffset) {
	                    animatorJustifyOffset += animatorFirstCharOffset;
	                }
	                while (lastIndex < i) {
	                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	                    lastIndex += 1;
	                }
	                animatorJustifyOffset = 0;
	                isNewLine = true;
	            } else {
	                for (j = 0; j < jLen; j += 1) {
	                    animatorProps = animators[j].a;
	                    if (animatorProps.t.propType) {
	                        if (isNewLine && documentData.j === 2) {
	                            animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
	                        }
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	                        if (mult.length) {
	                            animatorJustifyOffset += animatorProps.t.v*mult[0] * justifyOffsetMult;
	                        } else {
	                            animatorJustifyOffset += animatorProps.t.v*mult * justifyOffsetMult;
	                        }
	                    }
	                }
	                isNewLine = false;
	            }
	        }
	        if(animatorJustifyOffset) {
	            animatorJustifyOffset += animatorFirstCharOffset;
	        }
	        while(lastIndex < i) {
	            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	            lastIndex += 1;
	        }
	    }
	    //

	    for( i = 0; i < len; i += 1) {

	        matrixHelper.reset();
	        elemOpacity = 1;
	        if(letters[i].n) {
	            xPos = 0;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            currentLength = initPathPos ;
	            firstLine = false;
	            lineLength = 0;
	            if(this._hasMaskedPath) {
	                segmentInd = initSegmentInd;
	                pointInd = initPointInd;
	                points = segments[segmentInd].points;
	                prevPoint = points[pointInd - 1];
	                currentPoint = points[pointInd];
	                partialLength = currentPoint.partialLength;
	                segmentLength = 0;
	            }
	            letterO = letterSw = letterFc = letterM = '';
	            letterP = this.defaultPropsArray;
	        }else {
	            if(this._hasMaskedPath) {
	                if(currentLine !== letters[i].line){
	                    switch(documentData.j){
	                        case 1:
	                            currentLength += totalLength - documentData.lineWidths[letters[i].line];
	                            break;
	                        case 2:
	                            currentLength += (totalLength - documentData.lineWidths[letters[i].line])/2;
	                            break;
	                    }
	                    currentLine = letters[i].line;
	                }
	                if (ind !== letters[i].ind) {
	                    if (letters[ind]) {
	                        currentLength += letters[ind].extra;
	                    }
	                    currentLength += letters[i].an / 2;
	                    ind = letters[i].ind;
	                }
	                currentLength += alignment[0] * letters[i].an / 200;
	                var animatorOffset = 0;
	                for (j = 0; j < jLen; j += 1) {
	                    animatorProps = animators[j].a;
	                    if (animatorProps.p.propType) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.p.v[0] * mult[0];
	                        } else {
	                            animatorOffset += animatorProps.p.v[0] * mult;
	                        }

	                    }
	                    if (animatorProps.a.propType) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.a.v[0] * mult[0];
	                        } else {
	                            animatorOffset += animatorProps.a.v[0] * mult;
	                        }

	                    }
	                }
	                flag = true;
	                while (flag) {
	                    if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
	                        perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
	                        xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
	                        yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
	                        matrixHelper.translate(-alignment[0]*letters[i].an/200, -(alignment[1] * yOff / 100));
	                        flag = false;
	                    } else if (points) {
	                        segmentLength += currentPoint.partialLength;
	                        pointInd += 1;
	                        if (pointInd >= points.length) {
	                            pointInd = 0;
	                            segmentInd += 1;
	                            if (!segments[segmentInd]) {
	                                if (mask.v.c) {
	                                    pointInd = 0;
	                                    segmentInd = 0;
	                                    points = segments[segmentInd].points;
	                                } else {
	                                    segmentLength -= currentPoint.partialLength;
	                                    points = null;
	                                }
	                            } else {
	                                points = segments[segmentInd].points;
	                            }
	                        }
	                        if (points) {
	                            prevPoint = currentPoint;
	                            currentPoint = points[pointInd];
	                            partialLength = currentPoint.partialLength;
	                        }
	                    }
	                }
	                offf = letters[i].an / 2 - letters[i].add;
	                matrixHelper.translate(-offf, 0, 0);
	            } else {
	                offf = letters[i].an/2 - letters[i].add;
	                matrixHelper.translate(-offf,0,0);

	                // Grouping alignment
	                matrixHelper.translate(-alignment[0]*letters[i].an/200, -alignment[1]*yOff/100, 0);
	            }

	            lineLength += letters[i].l/2;
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.t.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    //This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
	                    if(xPos !== 0 || documentData.j !== 0) {
	                        if(this._hasMaskedPath) {
	                            if(mult.length) {
	                                currentLength += animatorProps.t.v*mult[0];
	                            } else {
	                                currentLength += animatorProps.t.v*mult;
	                            }
	                        }else {
	                            if(mult.length) {
	                                xPos += animatorProps.t.v*mult[0];
	                            } else {
	                                xPos += animatorProps.t.v*mult;
	                            }
	                        }
	                    }
	                }
	            }
	            lineLength += letters[i].l/2;
	            if(documentData.strokeWidthAnim) {
	                sw = documentData.sw || 0;
	            }
	            if(documentData.strokeColorAnim) {
	                if(documentData.sc){
	                    sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
	                }else {
	                    sc = [0,0,0];
	                }
	            }
	            if(documentData.fillColorAnim && documentData.fc) {
	                fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.a.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);

	                    if(mult.length){
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult[0], -animatorProps.a.v[1]*mult[1], animatorProps.a.v[2]*mult[2]);
	                    } else {
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult, -animatorProps.a.v[1]*mult, animatorProps.a.v[2]*mult);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.s.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(mult.length){
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult[0]),1+((animatorProps.s.v[1]-1)*mult[1]),1);
	                    } else {
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult),1+((animatorProps.s.v[1]-1)*mult),1);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1) {
	                animatorProps = animators[j].a;
	                animatorSelector = animators[j].s;
	                mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                if (animatorProps.sk.propType) {
	                    if(mult.length) {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
	                    } else {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
	                    }
	                }
	                if (animatorProps.r.propType) {
	                    if(mult.length) {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
	                    } else {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult);
	                    }
	                }
	                if (animatorProps.ry.propType) {

	                    if(mult.length) {
	                        matrixHelper.rotateY(animatorProps.ry.v*mult[1]);
	                    }else {
	                        matrixHelper.rotateY(animatorProps.ry.v*mult);
	                    }
	                }
	                if (animatorProps.rx.propType) {
	                    if(mult.length) {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult[0]);
	                    } else {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult);
	                    }
	                }
	                if (animatorProps.o.propType) {
	                    if(mult.length) {
	                        elemOpacity += ((animatorProps.o.v)*mult[0] - elemOpacity)*mult[0];
	                    } else {
	                        elemOpacity += ((animatorProps.o.v)*mult - elemOpacity)*mult;
	                    }
	                }
	                if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
	                    if(mult.length) {
	                        sw += animatorProps.sw.v*mult[0];
	                    } else {
	                        sw += animatorProps.sw.v*mult;
	                    }
	                }
	                if (documentData.strokeColorAnim && animatorProps.sc.propType) {
	                    for(k=0;k<3;k+=1){
	                        if(mult.length) {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult[0];
	                        } else {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult;
	                        }
	                    }
	                }
	                if (documentData.fillColorAnim && documentData.fc) {
	                    if(animatorProps.fc.propType){
	                        for(k=0;k<3;k+=1){
	                            if(mult.length) {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult[0];
	                            } else {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult;
	                            }
	                        }
	                    }
	                    if(animatorProps.fh.propType){
	                        if(mult.length) {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult[0]);
	                        } else {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult);
	                        }
	                    }
	                    if(animatorProps.fs.propType){
	                        if(mult.length) {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);
	                        } else {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult);
	                        }
	                    }
	                    if(animatorProps.fb.propType){
	                        if(mult.length) {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);
	                        } else {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult);
	                        }
	                    }
	                }
	            }

	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;

	                if (animatorProps.p.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(this._hasMaskedPath) {
	                        if(mult.length) {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
	                        } else {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        }
	                    }else {
	                        if(mult.length) {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
	                        } else {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        
	                        }
	                    }
	                }
	            }
	            if(documentData.strokeWidthAnim){
	                letterSw = sw < 0 ? 0 : sw;
	            }
	            if(documentData.strokeColorAnim){
	                letterSc = 'rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';
	            }
	            if(documentData.fillColorAnim && documentData.fc){
	                letterFc = 'rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';
	            }

	            if(this._hasMaskedPath) {
	                matrixHelper.translate(0,-documentData.ls);

	                matrixHelper.translate(0, alignment[1]*yOff/100 + yPos,0);
	                if (textData.p.p) {
	                    tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
	                    var rot = Math.atan(tanAngle) * 180 / Math.PI;
	                    if (currentPoint.point[0] < prevPoint.point[0]) {
	                        rot += 180;
	                    }
	                    matrixHelper.rotate(-rot * Math.PI / 180);
	                }
	                matrixHelper.translate(xPathPos, yPathPos, 0);
	                currentLength -= alignment[0]*letters[i].an/200;
	                if(letters[i+1] && ind !== letters[i+1].ind){
	                    currentLength += letters[i].an / 2;
	                    currentLength += documentData.tr/1000*documentData.finalSize;
	                }
	            }else {

	                matrixHelper.translate(xPos,yPos,0);

	                if(documentData.ps){
	                    //matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	                }
	                switch(documentData.j){
	                    case 1:
	                        matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]),0,0);
	                        break;
	                    case 2:
	                        matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line])/2,0,0);
	                        break;
	                }
	                matrixHelper.translate(0,-documentData.ls);
	                matrixHelper.translate(offf,0,0);
	                matrixHelper.translate(alignment[0]*letters[i].an/200,alignment[1]*yOff/100,0);
	                xPos += letters[i].l + documentData.tr/1000*documentData.finalSize;
	            }
	            if(renderType === 'html'){
	                letterM = matrixHelper.toCSS();
	            }else if(renderType === 'svg'){
	                letterM = matrixHelper.to2dCSS();
	            }else {
	                letterP = [matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];
	            }
	            letterO = elemOpacity;
	        }

	        if(renderedLettersCount <= i) {
	            letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);
	            this.renderedLetters.push(letterValue);
	            renderedLettersCount += 1;
	            this.lettersChangedFlag = true;
	        } else {
	            letterValue = this.renderedLetters[i];
	            this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
	        }
	    }
	};

	TextAnimatorProperty.prototype.getValue = function(){
		if(this._elem.globalData.frameId === this._frameId){
	        return;
	    }
	    this._frameId = this._elem.globalData.frameId;
	    this.iterateDynamicProperties();
	};

	TextAnimatorProperty.prototype.mHelper = new Matrix();
	TextAnimatorProperty.prototype.defaultPropsArray = [];
	extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
	function TextAnimatorDataProperty(elem, animatorProps, container) {
		var defaultData = {propType:false};
		var getProp = PropertyFactory.getProp;
		var textAnimator_animatables = animatorProps.a;
		this.a = {
			r: textAnimator_animatables.r ? getProp(elem, textAnimator_animatables.r, 0, degToRads, container) : defaultData,
			rx: textAnimator_animatables.rx ? getProp(elem, textAnimator_animatables.rx, 0, degToRads, container) : defaultData,
			ry: textAnimator_animatables.ry ? getProp(elem, textAnimator_animatables.ry, 0, degToRads, container) : defaultData,
			sk: textAnimator_animatables.sk ? getProp(elem, textAnimator_animatables.sk, 0, degToRads, container) : defaultData,
			sa: textAnimator_animatables.sa ? getProp(elem, textAnimator_animatables.sa, 0, degToRads, container) : defaultData,
			s: textAnimator_animatables.s ? getProp(elem, textAnimator_animatables.s, 1, 0.01, container) : defaultData,
			a: textAnimator_animatables.a ? getProp(elem, textAnimator_animatables.a, 1, 0, container) : defaultData,
			o: textAnimator_animatables.o ? getProp(elem, textAnimator_animatables.o, 0, 0.01, container) : defaultData,
			p: textAnimator_animatables.p ? getProp(elem,textAnimator_animatables.p, 1, 0, container) : defaultData,
			sw: textAnimator_animatables.sw ? getProp(elem, textAnimator_animatables.sw, 0, 0, container) : defaultData,
			sc: textAnimator_animatables.sc ? getProp(elem, textAnimator_animatables.sc, 1, 0, container) : defaultData,
			fc: textAnimator_animatables.fc ? getProp(elem, textAnimator_animatables.fc, 1, 0, container) : defaultData,
			fh: textAnimator_animatables.fh ? getProp(elem, textAnimator_animatables.fh, 0, 0, container) : defaultData,
			fs: textAnimator_animatables.fs ? getProp(elem, textAnimator_animatables.fs, 0, 0.01, container) : defaultData,
			fb: textAnimator_animatables.fb ? getProp(elem, textAnimator_animatables.fb, 0, 0.01, container) : defaultData,
			t: textAnimator_animatables.t ? getProp(elem, textAnimator_animatables.t, 0, 0, container) : defaultData
		};

		this.s = TextSelectorProp.getTextSelectorProp(elem,animatorProps.s, container);
	    this.s.t = animatorProps.s.t;
	}
	function LetterProps(o, sw, sc, fc, m, p){
	    this.o = o;
	    this.sw = sw;
	    this.sc = sc;
	    this.fc = fc;
	    this.m = m;
	    this.p = p;
	    this._mdf = {
	    	o: true,
	    	sw: !!sw,
	    	sc: !!sc,
	    	fc: !!fc,
	    	m: true,
	    	p: true
	    };
	}

	LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
		this._mdf.o = false;
		this._mdf.sw = false;
		this._mdf.sc = false;
		this._mdf.fc = false;
		this._mdf.m = false;
		this._mdf.p = false;
		var updated = false;

		if(this.o !== o) {
			this.o = o;
			this._mdf.o = true;
			updated = true;
		}
		if(this.sw !== sw) {
			this.sw = sw;
			this._mdf.sw = true;
			updated = true;
		}
		if(this.sc !== sc) {
			this.sc = sc;
			this._mdf.sc = true;
			updated = true;
		}
		if(this.fc !== fc) {
			this.fc = fc;
			this._mdf.fc = true;
			updated = true;
		}
		if(this.m !== m) {
			this.m = m;
			this._mdf.m = true;
			updated = true;
		}
		if(p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
			this.p = p;
			this._mdf.p = true;
			updated = true;
		}
		return updated;
	};
	function TextProperty(elem, data){
		this._frameId = initialDefaultFrame;
		this.pv = '';
		this.v = '';
		this.kf = false;
		this._isFirstFrame = true;
		this._mdf = false;
	    this.data = data;
		this.elem = elem;
	    this.comp = this.elem.comp;
		this.keysIndex = 0;
	    this.canResize = false;
	    this.minimumFontSize = 1;
	    this.effectsSequence = [];
		this.currentData = {
			ascent: 0,
	        boxWidth: this.defaultBoxWidth,
	        f: '',
	        fStyle: '',
	        fWeight: '',
	        fc: '',
	        j: '',
	        justifyOffset: '',
	        l: [],
	        lh: 0,
	        lineWidths: [],
	        ls: '',
	        of: '',
	        s: '',
	        sc: '',
	        sw: 0,
	        t: 0,
	        tr: 0,
	        sz:0,
	        ps:null,
	        fillColorAnim: false,
	        strokeColorAnim: false,
	        strokeWidthAnim: false,
	        yOffset: 0,
	        finalSize:0,
	        finalText:[],
	        finalLineHeight: 0,
	        __complete: false

		};
	    this.copyData(this.currentData, this.data.d.k[0].s);

	    if(!this.searchProperty()) {
	        this.completeTextData(this.currentData);
	    }
	}

	TextProperty.prototype.defaultBoxWidth = [0,0];

	TextProperty.prototype.copyData = function(obj, data) {
	    for(var s in data) {
	        if(data.hasOwnProperty(s)) {
	            obj[s] = data[s];
	        }
	    }
	    return obj;
	};

	TextProperty.prototype.setCurrentData = function(data){
	    if(!data.__complete) {
	        this.completeTextData(data);
	    }
	    this.currentData = data;
	    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
	    this._mdf = true;
	};

	TextProperty.prototype.searchProperty = function() {
	    return this.searchKeyframes();
	};

	TextProperty.prototype.searchKeyframes = function() {
	    this.kf = this.data.d.k.length > 1;
	    if(this.kf) {
	        this.addEffect(this.getKeyframeValue.bind(this));
	    }
	    return this.kf;
	};

	TextProperty.prototype.addEffect = function(effectFunction) {
		this.effectsSequence.push(effectFunction);
	    this.elem.addDynamicProperty(this);
	};

	TextProperty.prototype.getValue = function(_finalValue) {
	    if((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
	        return;
	    }
	    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
	    var currentValue = this.currentData;
	    var currentIndex = this.keysIndex;
	    if(this.lock) {
	        this.setCurrentData(this.currentData);
	        return;
	    }
	    this.lock = true;
	    this._mdf = false;
	    var i, len = this.effectsSequence.length;
	    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
	    for(i = 0; i < len; i += 1) {
	        //Checking if index changed to prevent creating a new object every time the expression updates.
	        if(currentIndex !== this.keysIndex) {
	            finalValue = this.effectsSequence[i](finalValue, finalValue.t);
	        } else {
	            finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
	        }
	    }
	    if(currentValue !== finalValue) {
	        this.setCurrentData(finalValue);
	    }
	    this.pv = this.v = this.currentData;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	};

	TextProperty.prototype.getKeyframeValue = function() {
	    var textKeys = this.data.d.k;
	    var frameNum = this.elem.comp.renderedFrame;
	    var i = 0, len = textKeys.length;
	    while(i <= len - 1) {
	        textKeys[i].s;
	        if(i === len - 1 || textKeys[i+1].t > frameNum){
	            break;
	        }
	        i += 1;
	    }
	    if(this.keysIndex !== i) {
	        this.keysIndex = i;
	    }
	    return this.data.d.k[this.keysIndex].s;
	};

	TextProperty.prototype.buildFinalText = function(text) {
	    var combinedCharacters = FontManager.getCombinedCharacterCodes();
	    var charactersArray = [];
	    var i = 0, len = text.length;
	    var charCode;
	    while (i < len) {
	        charCode = text.charCodeAt(i);
	        if (combinedCharacters.indexOf(charCode) !== -1) {
	            charactersArray[charactersArray.length - 1] += text.charAt(i);
	        } else {
	            if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	                charCode = text.charCodeAt(i + 1);
	                if (charCode >= 0xDC00 && charCode <= 0xDFFF) {
	                    charactersArray.push(text.substr(i, 2));
	                    ++i;
	                } else {
	                    charactersArray.push(text.charAt(i));
	                }
	            } else {
	                charactersArray.push(text.charAt(i));
	            }
	        }
	        i += 1;
	    }
	    return charactersArray;
	};

	TextProperty.prototype.completeTextData = function(documentData) {
	    documentData.__complete = true;
	    var fontManager = this.elem.globalData.fontManager;
	    var data = this.data;
	    var letters = [];
	    var i, len;
	    var newLineFlag, index = 0, val;
	    var anchorGrouping = data.m.g;
	    var currentSize = 0, currentPos = 0, currentLine = 0, lineWidths = [];
	    var lineWidth = 0;
	    var maxLineWidth = 0;
	    var j, jLen;
	    var fontData = fontManager.getFontByName(documentData.f);
	    var charData, cLength = 0;
	    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];

	    var fWeight = 'normal', fStyle = 'normal';
	    len = styles.length;
	    var styleName;
	    for(i=0;i<len;i+=1){
	        styleName = styles[i].toLowerCase();
	        switch(styleName) {
	            case 'italic':
	            fStyle = 'italic';
	            break;
	            case 'bold':
	            fWeight = '700';
	            break;
	            case 'black':
	            fWeight = '900';
	            break;
	            case 'medium':
	            fWeight = '500';
	            break;
	            case 'regular':
	            case 'normal':
	            fWeight = '400';
	            break;
	            case 'light':
	            case 'thin':
	            fWeight = '200';
	            break;
	        }
	    }
	    documentData.fWeight = fontData.fWeight || fWeight;
	    documentData.fStyle = fStyle;
	    documentData.finalSize = documentData.s;
	    documentData.finalText = this.buildFinalText(documentData.t);
	    len = documentData.finalText.length;
	    documentData.finalLineHeight = documentData.lh;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    var charCode;
	    if(documentData.sz){
	        var flag = true;
	        var boxWidth = documentData.sz[0];
	        var boxHeight = documentData.sz[1];
	        var currentHeight, finalText;
	        while(flag) {
	            finalText = this.buildFinalText(documentData.t);
	            currentHeight = 0;
	            lineWidth = 0;
	            len = finalText.length;
	            trackingOffset = documentData.tr/1000*documentData.finalSize;
	            var lastSpaceIndex = -1;
	            for(i=0;i<len;i+=1){
	                charCode = finalText[i].charCodeAt(0);
	                newLineFlag = false;
	                if(finalText[i] === ' '){
	                    lastSpaceIndex = i;
	                }else if(charCode === 13 || charCode === 3){
	                    lineWidth = 0;
	                    newLineFlag = true;
	                    currentHeight += documentData.finalLineHeight || documentData.finalSize*1.2;
	                }
	                if(fontManager.chars){
	                    charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
	                    cLength = newLineFlag ? 0 : charData.w*documentData.finalSize/100;
	                }else {
	                    //tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
	                }
	                if(lineWidth + cLength > boxWidth && finalText[i] !== ' '){
	                    if(lastSpaceIndex === -1){
	                        len += 1;
	                    } else {
	                        i = lastSpaceIndex;
	                    }
	                    currentHeight += documentData.finalLineHeight || documentData.finalSize*1.2;
	                    finalText.splice(i, lastSpaceIndex === i ? 1 : 0,"\r");
	                    //finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
	                    lastSpaceIndex = -1;
	                    lineWidth = 0;
	                }else {
	                    lineWidth += cLength;
	                    lineWidth += trackingOffset;
	                }
	            }
	            currentHeight += fontData.ascent*documentData.finalSize/100;
	            if(this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
	                documentData.finalSize -= 1;
	                documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
	            } else {
	                documentData.finalText = finalText;
	                len = documentData.finalText.length;
	                flag = false;
	            }
	        }

	    }
	    lineWidth = - trackingOffset;
	    cLength = 0;
	    var uncollapsedSpaces = 0;
	    var currentChar;
	    for (i = 0;i < len ;i += 1) {
	        newLineFlag = false;
	        currentChar = documentData.finalText[i];
	        charCode = currentChar.charCodeAt(0);
	        if (charCode === 13 || charCode === 3) {
	            uncollapsedSpaces = 0;
	            lineWidths.push(lineWidth);
	            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	            lineWidth = - 2 * trackingOffset;
	            val = '';
	            newLineFlag = true;
	            currentLine += 1;
	        }else {
	            val = currentChar;
	        }
	        if(fontManager.chars){
	            charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
	            cLength = newLineFlag ? 0 : charData.w*documentData.finalSize/100;
	        }else {
	            //var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
	            //tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
	        }

	        //
	        if(currentChar === ' '){
	            uncollapsedSpaces += cLength + trackingOffset;
	        } else {
	            lineWidth += cLength + trackingOffset + uncollapsedSpaces;
	            uncollapsedSpaces = 0;
	        }
	        letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag, anIndexes:[], val: val, line: currentLine, animatorJustifyOffset: 0});
	        if(anchorGrouping == 2){
	            currentSize += cLength;
	            if(val === '' || val === ' ' || i === len - 1){
	                if(val === '' || val === ' '){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                index += 1;
	                currentSize = 0;
	            }
	        }else if(anchorGrouping == 3){
	            currentSize += cLength;
	            if(val === '' || i === len - 1){
	                if(val === ''){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                currentSize = 0;
	                index += 1;
	            }
	        }else {
	            letters[index].ind = index;
	            letters[index].extra = 0;
	            index += 1;
	        }
	    }
	    documentData.l = letters;
	    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	    lineWidths.push(lineWidth);
	    if(documentData.sz){
	        documentData.boxWidth = documentData.sz[0];
	        documentData.justifyOffset = 0;
	    }else {
	        documentData.boxWidth = maxLineWidth;
	        switch(documentData.j){
	            case 1:
	                documentData.justifyOffset = - documentData.boxWidth;
	                break;
	            case 2:
	                documentData.justifyOffset = - documentData.boxWidth/2;
	                break;
	            default:
	                documentData.justifyOffset = 0;
	        }
	    }
	    documentData.lineWidths = lineWidths;

	    var animators = data.a, animatorData, letterData;
	    jLen = animators.length;
	    var based, ind, indexes = [];
	    for(j=0;j<jLen;j+=1){
	        animatorData = animators[j];
	        if(animatorData.a.sc){
	            documentData.strokeColorAnim = true;
	        }
	        if(animatorData.a.sw){
	            documentData.strokeWidthAnim = true;
	        }
	        if(animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb){
	            documentData.fillColorAnim = true;
	        }
	        ind = 0;
	        based = animatorData.s.b;
	        for(i=0;i<len;i+=1){
	            letterData = letters[i];
	            letterData.anIndexes[j] = ind;
	            if((based == 1 && letterData.val !== '') || (based == 2 && letterData.val !== '' && letterData.val !== ' ') || (based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1)) || (based == 4 && (letterData.n || i == len - 1))){
	                if(animatorData.s.rn === 1){
	                    indexes.push(ind);
	                }
	                ind += 1;
	            }
	        }
	        data.a[j].s.totalChars = ind;
	        var currentInd = -1, newInd;
	        if(animatorData.s.rn === 1){
	            for(i = 0; i < len; i += 1){
	                letterData = letters[i];
	                if(currentInd != letterData.anIndexes[j]){
	                    currentInd = letterData.anIndexes[j];
	                    newInd = indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];
	                }
	                letterData.anIndexes[j] = newInd;
	            }
	        }
	    }
	    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize*1.2;
	    documentData.ls = documentData.ls || 0;
	    documentData.ascent = fontData.ascent*documentData.finalSize/100;
	};

	TextProperty.prototype.updateDocumentData = function(newData, index) {
		index = index === undefined ? this.keysIndex : index;
	    var dData = this.copyData({}, this.data.d.k[index].s);
	    dData = this.copyData(dData, newData);
	    this.data.d.k[index].s = dData;
	    this.recalculate(index);
	    this.elem.addDynamicProperty(this);
	};

	TextProperty.prototype.recalculate = function(index) {
	    var dData = this.data.d.k[index].s;
	    dData.__complete = false;
	    this.keysIndex = 0;
	    this._isFirstFrame = true;
	    this.getValue(dData);
	};

	TextProperty.prototype.canResizeFont = function(_canResize) {
	    this.canResize = _canResize;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	};

	TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
	    this.minimumFontSize = Math.floor(_fontValue) || 1;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	};

	var TextSelectorProp = (function(){
	    var max = Math.max;
	    var min = Math.min;
	    var floor = Math.floor;

	    function TextSelectorProp(elem,data){
	        this._currentTextLength = -1;
	        this.k = false;
	        this.data = data;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.finalS = 0;
	        this.finalE = 0;
	        this.initDynamicPropertyContainer(elem);
	        this.s = PropertyFactory.getProp(elem,data.s || {k:0},0,0,this);
	        if('e' in data){
	            this.e = PropertyFactory.getProp(elem,data.e,0,0,this);
	        }else {
	            this.e = {v:100};
	        }
	        this.o = PropertyFactory.getProp(elem,data.o || {k:0},0,0,this);
	        this.xe = PropertyFactory.getProp(elem,data.xe || {k:0},0,0,this);
	        this.ne = PropertyFactory.getProp(elem,data.ne || {k:0},0,0,this);
	        this.a = PropertyFactory.getProp(elem,data.a,0,0.01,this);
	        if(!this.dynamicProperties.length){
	            this.getValue();
	        }
	    }

	    TextSelectorProp.prototype = {
	        getMult: function(ind) {
	            if(this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
	                this.getValue();
	            }
	            //var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
	            var x1 = 0;
	            var y1 = 0;
	            var x2 = 1;
	            var y2 = 1;
	            if(this.ne.v > 0) {
	                x1 = this.ne.v / 100.0;
	            }
	            else {
	                y1 = -this.ne.v / 100.0;
	            }
	            if(this.xe.v > 0) {
	                x2 = 1.0 - this.xe.v / 100.0;
	            }
	            else {
	                y2 = 1.0 + this.xe.v / 100.0;
	            }
	            var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;

	            var mult = 0;
	            var s = this.finalS;
	            var e = this.finalE;
	            var type = this.data.sh;
	            if (type === 2){
	                if (e === s) {
	                    mult = ind >= e ? 1 : 0;
	                } else {
	                    mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	                }
	                mult = easer(mult);
	            } else if(type === 3) {
	                if (e === s) {
	                    mult = ind >= e ? 0 : 1;
	                }else {
	                    mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s),1));
	                }

	                mult = easer(mult);
	            } else if (type === 4) {
	                if (e === s) {
	                    mult = 0;
	                } else {
	                    mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	                    if (mult < 0.5) {
	                        mult *= 2;
	                    } else {
	                        mult = 1 - 2 * (mult - 0.5);
	                    }
	                }
	                mult = easer(mult);
	            } else if (type === 5) {
	                if (e === s){
	                    mult = 0;
	                } else {
	                    var tot = e - s;
	                    /*ind += 0.5;
	                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind;*/
	                    ind = min(max(0, ind + 0.5 - s), e - s);
	                    var x = -tot/2+ind;
	                    var a = tot/2;
	                    mult = Math.sqrt(1 - (x * x) / (a * a));
	                }
	                mult = easer(mult);
	            } else if (type === 6) {
	                if (e === s){
	                    mult = 0;
	                } else {
	                    ind = min(max(0, ind + 0.5 - s), e - s);
	                    mult = (1 + (Math.cos((Math.PI + Math.PI * 2 * (ind) / (e - s))))) / 2;
	                }
	                mult = easer(mult);
	            } else {
	                if (ind >= floor(s)) {
	                    if (ind - s < 0) {
	                        mult = max(0, min(min(e, 1) - (s - ind), 1));
	                    } else {
	                        mult = max(0, min(e - ind, 1));
	                    }
	                }
	                mult = easer(mult);
	            }
	            return mult*this.a.v;
	        },
	        getValue: function(newCharsFlag) {
	            this.iterateDynamicProperties();
	            this._mdf = newCharsFlag || this._mdf;
	            this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
	            if(newCharsFlag && this.data.r === 2) {
	                this.e.v = this._currentTextLength;
	            }
	            var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
	            var o = this.o.v/divisor;
	            var s = this.s.v/divisor + o;
	            var e = (this.e.v/divisor) + o;
	            if(s>e){
	                var _s = s;
	                s = e;
	                e = _s;
	            }
	            this.finalS = s;
	            this.finalE = e;
	        }
	    };
	    extendPrototype([DynamicPropertyContainer], TextSelectorProp);

	    function getTextSelectorProp(elem, data,arr) {
	        return new TextSelectorProp(elem, data);
	    }

	    return {
	        getTextSelectorProp: getTextSelectorProp
	    };
	}());

	    
	var pool_factory = (function() {
		return function(initialLength, _create, _release, _clone) {

			var _length = 0;
			var _maxLength = initialLength;
			var pool = createSizedArray(_maxLength);

			var ob = {
				newElement: newElement,
				release: release
			};

			function newElement(){
				var element;
				if(_length){
					_length -= 1;
					element = pool[_length];
				} else {
					element = _create();
				}
				return element;
			}

			function release(element) {
				if(_length === _maxLength) {
					pool = pooling.double(pool);
					_maxLength = _maxLength*2;
				}
				if (_release) {
					_release(element);
				}
				pool[_length] = element;
				_length += 1;
			}

			return ob;
		};
	}());

	var pooling = (function(){

		function double(arr){
			return arr.concat(createSizedArray(arr.length));
		}

		return {
			double: double
		};
	}());
	var point_pool = (function(){

		function create() {
			return createTypedArray('float32', 2);
		}
		return pool_factory(8, create);
	}());
	var shape_pool = (function(){

		function create() {
			return new ShapePath();
		}

		function release(shapePath) {
			var len = shapePath._length, i;
			for(i = 0; i < len; i += 1) {
				point_pool.release(shapePath.v[i]);
				point_pool.release(shapePath.i[i]);
				point_pool.release(shapePath.o[i]);
				shapePath.v[i] = null;
				shapePath.i[i] = null;
				shapePath.o[i] = null;
			}
			shapePath._length = 0;
			shapePath.c = false;
		}

		function clone(shape) {
			var cloned = factory.newElement();
			var i, len = shape._length === undefined ? shape.v.length : shape._length;
			cloned.setLength(len);
			cloned.c = shape.c;
			
			for(i = 0; i < len; i += 1) {
				cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1], i);
			}
			return cloned;
		}

		var factory = pool_factory(4, create, release);
		factory.clone = clone;

		return factory;
	}());
	var shapeCollection_pool = (function(){
		var ob = {
			newShapeCollection: newShapeCollection,
			release: release
		};

		var _length = 0;
		var _maxLength = 4;
		var pool = createSizedArray(_maxLength);

		function newShapeCollection(){
			var shapeCollection;
			if(_length){
				_length -= 1;
				shapeCollection = pool[_length];
			} else {
				shapeCollection = new ShapeCollection();
			}
			return shapeCollection;
		}

		function release(shapeCollection) {
			var i, len = shapeCollection._length;
			for(i = 0; i < len; i += 1) {
				shape_pool.release(shapeCollection.shapes[i]);
			}
			shapeCollection._length = 0;

			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = shapeCollection;
			_length += 1;
		}

		return ob;
	}());
	var segments_length_pool = (function(){

		function create() {
			return {
				lengths: [],
				totalLength: 0
			};
		}

		function release(element) {
			var i, len = element.lengths.length;
			for(i=0;i<len;i+=1) {
				bezier_length_pool.release(element.lengths[i]);
			}
			element.lengths.length = 0;
		}

		return pool_factory(8, create, release);
	}());
	var bezier_length_pool = (function(){

		function create() {
			return {
	            addedLength: 0,
	            percents: createTypedArray('float32', defaultCurveSegments),
	            lengths: createTypedArray('float32', defaultCurveSegments),
	        };
		}
		return pool_factory(8, create);
	}());
	function BaseRenderer(){}
	BaseRenderer.prototype.checkLayers = function(num){
	    var i, len = this.layers.length, data;
	    this.completeLayers = true;
	    for (i = len - 1; i >= 0; i--) {
	        if (!this.elements[i]) {
	            data = this.layers[i];
	            if(data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st))
	            {
	                this.buildItem(i);
	            }
	        }
	        this.completeLayers = this.elements[i] ? this.completeLayers:false;
	    }
	    this.checkPendingElements();
	};

	BaseRenderer.prototype.createItem = function(layer){
	    switch(layer.ty){
	        case 2:
	            return this.createImage(layer);
	        case 0:
	            return this.createComp(layer);
	        case 1:
	            return this.createSolid(layer);
	        case 3:
	            return this.createNull(layer);
	        case 4:
	            return this.createShape(layer);
	        case 5:
	            return this.createText(layer);
	        case 13:
	            return this.createCamera(layer);
	    }
	    return this.createNull(layer);
	};

	BaseRenderer.prototype.createCamera = function(){
	    throw new Error('You\'re using a 3d camera. Try the html renderer.');
	};

	BaseRenderer.prototype.buildAllItems = function(){
	    var i, len = this.layers.length;
	    for(i=0;i<len;i+=1){
	        this.buildItem(i);
	    }
	    this.checkPendingElements();
	};

	BaseRenderer.prototype.includeLayers = function(newLayers){
	    this.completeLayers = false;
	    var i, len = newLayers.length;
	    var j, jLen = this.layers.length;
	    for(i=0;i<len;i+=1){
	        j = 0;
	        while(j<jLen){
	            if(this.layers[j].id == newLayers[i].id){
	                this.layers[j] = newLayers[i];
	                break;
	            }
	            j += 1;
	        }
	    }
	};

	BaseRenderer.prototype.setProjectInterface = function(pInterface){
	    this.globalData.projectInterface = pInterface;
	};

	BaseRenderer.prototype.initItems = function(){
	    if(!this.globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	};
	BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
	    var elements = this.elements;
	    var layers = this.layers;
	    var i=0, len = layers.length;
	    while (i < len) {
	        if (layers[i].ind == parentName) {
	            if (!elements[i] || elements[i] === true) {
	                this.buildItem(i);
	                this.addPendingElement(element);
	            } else {
	                hierarchy.push(elements[i]);
	                elements[i].setAsParent();
	                if(layers[i].parent !== undefined) {
	                    this.buildElementParenting(element, layers[i].parent, hierarchy);
	                } else {
	                    element.setHierarchy(hierarchy);
	                }
	            }
	        }
	        i += 1;
	    }
	};

	BaseRenderer.prototype.addPendingElement = function(element){
	    this.pendingElements.push(element);
	};

	BaseRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i]);
	            comp.initExpressions();
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};

	BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.imageLoader = this.animationItem.imagePreloader;
	    this.globalData.frameId = 0;
	    this.globalData.frameRate = animData.fr;
	    this.globalData.nm = animData.nm;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	};
	function SVGRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.svgElement = createNS('svg');
	    var ariaLabel = '';
	    if (config && config.title) {
	        var titleElement = createNS('title');
	        var titleId = createElementID();
	        titleElement.setAttribute('id', titleId);
	        titleElement.textContent = config.title;
	        this.svgElement.appendChild(titleElement);
	        ariaLabel += titleId;
	    }
	    if (config && config.description) {
	        var descElement = createNS('desc');
	        var descId = createElementID();
	        descElement.setAttribute('id', descId);
	        descElement.textContent = config.description;
	        this.svgElement.appendChild(descElement);
	        ariaLabel += ' ' + descId;
	    }
	    if (ariaLabel) {
	        this.svgElement.setAttribute('aria-labelledby', ariaLabel);
	    }
	    var defs = createNS( 'defs');
	    this.svgElement.appendChild(defs);
	    var maskElement = createNS('g');
	    this.svgElement.appendChild(maskElement);
	    this.layerElement = maskElement;
	    this.renderConfig = {
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true,
	        viewBoxOnly: (config && config.viewBoxOnly) || false,
	        viewBoxSize: (config && config.viewBoxSize) || false,
	        className: (config && config.className) || '',
	        id: (config && config.id) || '',
	        focusable: config && config.focusable,
	        filterSize: {
	            width: config && config.filterSize && config.filterSize.width || '100%',
	            height: config && config.filterSize && config.filterSize.height || '100%',
	            x: config && config.filterSize && config.filterSize.x || '0%',
	            y: config && config.filterSize && config.filterSize.y || '0%',
	        }
	    };

	    this.globalData = {
	        _mdf: false,
	        frameNum: -1,
	        defs: defs,
	        renderConfig: this.renderConfig
	    };
	    this.elements = [];
	    this.pendingElements = [];
	    this.destroyed = false;
	    this.rendererType = 'svg';

	}

	extendPrototype([BaseRenderer],SVGRenderer);

	SVGRenderer.prototype.createNull = function (data) {
	    return new NullElement(data,this.globalData,this);
	};

	SVGRenderer.prototype.createShape = function (data) {
	    return new SVGShapeElement(data,this.globalData,this);
	};

	SVGRenderer.prototype.createText = function (data) {
	    return new SVGTextElement(data,this.globalData,this);

	};

	SVGRenderer.prototype.createImage = function (data) {
	    return new IImageElement(data,this.globalData,this);
	};

	SVGRenderer.prototype.createComp = function (data) {
	    return new SVGCompElement(data,this.globalData,this);

	};

	SVGRenderer.prototype.createSolid = function (data) {
	    return new ISolidElement(data,this.globalData,this);
	};

	SVGRenderer.prototype.configAnimation = function(animData){
	    this.svgElement.setAttribute('xmlns','http://www.w3.org/2000/svg');
	    if(this.renderConfig.viewBoxSize) {
	        this.svgElement.setAttribute('viewBox',this.renderConfig.viewBoxSize);
	    } else {
	        this.svgElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);
	    }

	    if(!this.renderConfig.viewBoxOnly) {
	        this.svgElement.setAttribute('width',animData.w);
	        this.svgElement.setAttribute('height',animData.h);
	        this.svgElement.style.width = '100%';
	        this.svgElement.style.height = '100%';
	        this.svgElement.style.transform = 'translate3d(0,0,0)';
	    }
	    if (this.renderConfig.className) {
	        this.svgElement.setAttribute('class', this.renderConfig.className);
	    }
	    if (this.renderConfig.id) {
	        this.svgElement.setAttribute('id', this.renderConfig.id);
	    }
	    if (this.renderConfig.focusable !== undefined) {
	        this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
	    }
	    this.svgElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);
	    //this.layerElement.style.transform = 'translate3d(0,0,0)';
	    //this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
	    this.animationItem.wrapper.appendChild(this.svgElement);
	    //Mask animation
	    var defs = this.globalData.defs;

	    this.setupGlobalData(animData, defs);
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.data = animData;

	    var maskElement = createNS( 'clipPath');
	    var rect = createNS('rect');
	    rect.setAttribute('width',animData.w);
	    rect.setAttribute('height',animData.h);
	    rect.setAttribute('x',0);
	    rect.setAttribute('y',0);
	    var maskId = createElementID();
	    maskElement.setAttribute('id', maskId);
	    maskElement.appendChild(rect);
	    this.layerElement.setAttribute("clip-path", "url(" + locationHref + "#"+maskId+")");

	    defs.appendChild(maskElement);
	    this.layers = animData.layers;
	    this.elements = createSizedArray(animData.layers.length);
	};


	SVGRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.layerElement = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};

	SVGRenderer.prototype.updateContainerSize = function () {
	};

	SVGRenderer.prototype.buildItem  = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    elements[pos] = true;
	    var element = this.createItem(this.layers[pos]);

	    elements[pos] = element;
	    if(expressionsPlugin){
	        if(this.layers[pos].ty === 0){
	            this.globalData.projectInterface.registerComposition(element);
	        }
	        element.initExpressions();
	    }
	    this.appendElementInPos(element,pos);
	    if(this.layers[pos].tt){
	        if(!this.elements[pos - 1] || this.elements[pos - 1] === true){
	            this.buildItem(pos - 1);
	            this.addPendingElement(element);
	        } else {
	            element.setMatte(elements[pos - 1].layerId);
	        }
	    }
	};

	SVGRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	        if(element.data.tt){
	            var i = 0, len = this.elements.length;
	            while(i<len){
	                if(this.elements[i] === element){
	                    element.setMatte(this.elements[i - 1].layerId);
	                    break;
	                }
	                i += 1;
	            }
	        }
	    }
	};

	SVGRenderer.prototype.renderFrame = function(num){
	    if(this.renderedFrame === num || this.destroyed){
	        return;
	    }
	    if(num === null){
	        num = this.renderedFrame;
	    }else {
	        this.renderedFrame = num;
	    }
	    // console.log('-------');
	    // console.log('FRAME ',num);
	    this.globalData.frameNum = num;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    this.globalData._mdf = false;
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	    for (i = len - 1; i >= 0; i--) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    if(this.globalData._mdf) {
	        for (i = 0; i < len; i += 1) {
	            if(this.completeLayers || this.elements[i]){
	                this.elements[i].renderFrame();
	            }
	        }
	    }
	};

	SVGRenderer.prototype.appendElementInPos = function(element, pos){
	    var newElement = element.getBaseElement();
	    if(!newElement){
	        return;
	    }
	    var i = 0;
	    var nextElement;
	    while(i<pos){
	        if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement()){
	            nextElement = this.elements[i].getBaseElement();
	        }
	        i += 1;
	    }
	    if(nextElement){
	        this.layerElement.insertBefore(newElement, nextElement);
	    } else {
	        this.layerElement.appendChild(newElement);
	    }
	};

	SVGRenderer.prototype.hide = function(){
	    this.layerElement.style.display = 'none';
	};

	SVGRenderer.prototype.show = function(){
	    this.layerElement.style.display = 'block';
	};

	function CanvasRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.renderConfig = {
	        clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
	        context: (config && config.context) || null,
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
	        className: (config && config.className) || '',
	        id: (config && config.id) || '',
	    };
	    this.renderConfig.dpr = (config && config.dpr) || 1;
	    if (this.animationItem.wrapper) {
	        this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
	    }
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1,
	        _mdf: false,
	        renderConfig: this.renderConfig,
	        currentGlobalAlpha: -1
	    };
	    this.contextData = new CVContextData();
	    this.elements = [];
	    this.pendingElements = [];
	    this.transformMat = new Matrix();
	    this.completeLayers = false;
	    this.rendererType = 'canvas';
	}
	extendPrototype([BaseRenderer],CanvasRenderer);

	CanvasRenderer.prototype.createShape = function (data) {
	    return new CVShapeElement(data, this.globalData, this);
	};

	CanvasRenderer.prototype.createText = function (data) {
	    return new CVTextElement(data, this.globalData, this);
	};

	CanvasRenderer.prototype.createImage = function (data) {
	    return new CVImageElement(data, this.globalData, this);
	};

	CanvasRenderer.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	};

	CanvasRenderer.prototype.createSolid = function (data) {
	    return new CVSolidElement(data, this.globalData, this);
	};

	CanvasRenderer.prototype.createNull = SVGRenderer.prototype.createNull;

	CanvasRenderer.prototype.ctxTransform = function(props){
	    if(props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0){
	        return;
	    }
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);
	        return;
	    }
	    this.transformMat.cloneFromProps(props);
	    var cProps = this.contextData.cTr.props;
	    this.transformMat.transform(cProps[0],cProps[1],cProps[2],cProps[3],cProps[4],cProps[5],cProps[6],cProps[7],cProps[8],cProps[9],cProps[10],cProps[11],cProps[12],cProps[13],cProps[14],cProps[15]);
	    //this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	    this.contextData.cTr.cloneFromProps(this.transformMat.props);
	    var trProps = this.contextData.cTr.props;
	    this.canvasContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);
	};

	CanvasRenderer.prototype.ctxOpacity = function(op){
	    /*if(op === 1){
	        return;
	    }*/
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
	        this.globalData.currentGlobalAlpha = this.contextData.cO;
	        return;
	    }
	    this.contextData.cO *= op < 0 ? 0 : op;
	    if(this.globalData.currentGlobalAlpha !== this.contextData.cO) {
	        this.canvasContext.globalAlpha = this.contextData.cO;
	        this.globalData.currentGlobalAlpha = this.contextData.cO;
	    }
	};

	CanvasRenderer.prototype.reset = function(){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    this.contextData.reset();
	};

	CanvasRenderer.prototype.save = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.save();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.save();
	    }
	    var props = this.contextData.cTr.props;
	    if(this.contextData._length <= this.contextData.cArrPos) {
	        this.contextData.duplicate();
	    }
	    var i, arr = this.contextData.saved[this.contextData.cArrPos];
	    for (i = 0; i < 16; i += 1) {
	        arr[i] = props[i];
	    }
	    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
	    this.contextData.cArrPos += 1;
	};

	CanvasRenderer.prototype.restore = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.restore();
	        this.globalData.blendMode = 'source-over';
	    }
	    this.contextData.cArrPos -= 1;
	    var popped = this.contextData.saved[this.contextData.cArrPos];
	    var i,arr = this.contextData.cTr.props;
	    for(i=0;i<16;i+=1){
	        arr[i] = popped[i];
	    }
	    this.canvasContext.setTransform(popped[0],popped[1],popped[4],popped[5],popped[12],popped[13]);
	    popped = this.contextData.savedOp[this.contextData.cArrPos];
	    this.contextData.cO = popped;
	    if(this.globalData.currentGlobalAlpha !== popped) {
	        this.canvasContext.globalAlpha = popped;
	        this.globalData.currentGlobalAlpha = popped;
	    }
	};

	CanvasRenderer.prototype.configAnimation = function(animData){
	    if(this.animationItem.wrapper){
	        this.animationItem.container = createTag('canvas');
	        this.animationItem.container.style.width = '100%';
	        this.animationItem.container.style.height = '100%';
	        //this.animationItem.container.style.transform = 'translate3d(0,0,0)';
	        //this.animationItem.container.style.webkitTransform = 'translate3d(0,0,0)';
	        this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style['-webkit-transform'] = "0px 0px 0px";
	        this.animationItem.wrapper.appendChild(this.animationItem.container);
	        this.canvasContext = this.animationItem.container.getContext('2d');
	        if(this.renderConfig.className) {
	            this.animationItem.container.setAttribute('class', this.renderConfig.className);
	        }
	        if(this.renderConfig.id) {
	            this.animationItem.container.setAttribute('id', this.renderConfig.id);
	        }
	    }else {
	        this.canvasContext = this.renderConfig.context;
	    }
	    this.data = animData;
	    this.layers = animData.layers;
	    this.transformCanvas = {
	        w: animData.w,
	        h:animData.h,
	        sx:0,
	        sy:0,
	        tx:0,
	        ty:0
	    };
	    this.setupGlobalData(animData, document.body);
	    this.globalData.canvasContext = this.canvasContext;
	    this.globalData.renderer = this;
	    this.globalData.isDashed = false;
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.globalData.transformCanvas = this.transformCanvas;
	    this.elements = createSizedArray(animData.layers.length);

	    this.updateContainerSize();
	};

	CanvasRenderer.prototype.updateContainerSize = function () {
	    this.reset();
	    var elementWidth,elementHeight;
	    if(this.animationItem.wrapper && this.animationItem.container){
	        elementWidth = this.animationItem.wrapper.offsetWidth;
	        elementHeight = this.animationItem.wrapper.offsetHeight;
	        this.animationItem.container.setAttribute('width',elementWidth * this.renderConfig.dpr );
	        this.animationItem.container.setAttribute('height',elementHeight * this.renderConfig.dpr);
	    }else {
	        elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
	        elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
	    }
	    var elementRel,animationRel;
	    if(this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1){
	        var par = this.renderConfig.preserveAspectRatio.split(' ');
	        var fillType = par[1] || 'meet';
	        var pos = par[0] || 'xMidYMid';
	        var xPos = pos.substr(0,4);
	        var yPos = pos.substr(4);
	        elementRel = elementWidth/elementHeight;
	        animationRel = this.transformCanvas.w/this.transformCanvas.h;
	        if(animationRel>elementRel && fillType === 'meet' || animationRel<elementRel && fillType === 'slice'){
	            this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	            this.transformCanvas.sy = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        }else {
	            this.transformCanvas.sx = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	            this.transformCanvas.sy = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	        }

	        if(xPos === 'xMid' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;
	        } else if(xPos === 'xMax' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.tx = 0;
	        }
	        if(yPos === 'YMid' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2)*this.renderConfig.dpr;
	        } else if(yPos === 'YMax' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w)))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.ty = 0;
	        }

	    }else if(this.renderConfig.preserveAspectRatio == 'none'){
	        this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        this.transformCanvas.sy = elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }else {
	        this.transformCanvas.sx = this.renderConfig.dpr;
	        this.transformCanvas.sy = this.renderConfig.dpr;
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }
	    this.transformCanvas.props = [this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];
	    /*var i, len = this.elements.length;
	    for(i=0;i<len;i+=1){
	        if(this.elements[i] && this.elements[i].data.ty === 0){
	            this.elements[i].resize(this.globalData.transformCanvas);
	        }
	    }*/
	    this.ctxTransform(this.transformCanvas.props);
	    this.canvasContext.beginPath();
	    this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);
	    this.canvasContext.closePath();
	    this.canvasContext.clip();

	    this.renderFrame(this.renderedFrame, true);
	};

	CanvasRenderer.prototype.destroy = function () {
	    if(this.renderConfig.clearCanvas) {
	        this.animationItem.wrapper.innerHTML = '';
	    }
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = len - 1; i >= 0; i-=1) {
	        if(this.elements[i]) {
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.globalData.canvasContext = null;
	    this.animationItem.container = null;
	    this.destroyed = true;
	};

	CanvasRenderer.prototype.renderFrame = function(num, forceRender){
	    if((this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender) || this.destroyed || num === -1){
	        return;
	    }
	    this.renderedFrame = num;
	    this.globalData.frameNum = num - this.animationItem._isFirstFrame;
	    this.globalData.frameId += 1;
	    this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
	    this.globalData.projectInterface.currentFrame = num;

	     // console.log('--------');
	     // console.log('NEW: ',num);
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }

	    for (i = 0; i < len; i++) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    if(this.globalData._mdf) {
	        if(this.renderConfig.clearCanvas === true){
	            this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	        }else {
	            this.save();
	        }
	        for (i = len - 1; i >= 0; i-=1) {
	            if(this.completeLayers || this.elements[i]){
	                this.elements[i].renderFrame();
	            }
	        }
	        if(this.renderConfig.clearCanvas !== true){
	            this.restore();
	        }
	    }
	};

	CanvasRenderer.prototype.buildItem = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    var element = this.createItem(this.layers[pos], this,this.globalData);
	    elements[pos] = element;
	    element.initExpressions();
	    /*if(this.layers[pos].ty === 0){
	        element.resize(this.globalData.transformCanvas);
	    }*/
	};

	CanvasRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};

	CanvasRenderer.prototype.hide = function(){
	    this.animationItem.container.style.display = 'none';
	};

	CanvasRenderer.prototype.show = function(){
	    this.animationItem.container.style.display = 'block';
	};

	function HybridRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	        className: (config && config.className) || '',
	        imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
	        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true,
	        filterSize: {
	            width: config && config.filterSize && config.filterSize.width || '400%',
	            height: config && config.filterSize && config.filterSize.height || '400%',
	            x: config && config.filterSize && config.filterSize.x || '-100%',
	            y: config && config.filterSize && config.filterSize.y || '-100%',
	        }
	    };
	    this.globalData = {
	        _mdf: false,
	        frameNum: -1,
	        renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	    this.rendererType = 'html';

	}

	extendPrototype([BaseRenderer],HybridRenderer);

	HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;

	HybridRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};

	HybridRenderer.prototype.appendElementInPos = function(element, pos){
	    var newDOMElement = element.getBaseElement();
	    if(!newDOMElement){
	        return;
	    }
	    var layer = this.layers[pos];
	    if(!layer.ddd || !this.supports3d){
	        if(this.threeDElements) {
	            this.addTo3dContainer(newDOMElement,pos);
	        } else {
	            var i = 0;
	            var nextDOMElement, nextLayer, tmpDOMElement;
	            while(i<pos){
	                if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement){
	                    nextLayer = this.elements[i];
	                    tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
	                    nextDOMElement = tmpDOMElement || nextDOMElement;
	                }
	                i += 1;
	            }
	            if(nextDOMElement){
	                if(!layer.ddd || !this.supports3d){
	                    this.layerElement.insertBefore(newDOMElement, nextDOMElement);
	                }
	            } else {
	                if(!layer.ddd || !this.supports3d){
	                    this.layerElement.appendChild(newDOMElement);
	                }
	            }
	        }
	        
	    } else {
	        this.addTo3dContainer(newDOMElement,pos);
	    }
	};

	HybridRenderer.prototype.createShape = function (data) {
	    if(!this.supports3d){
	        return new SVGShapeElement(data, this.globalData, this);
	    }
	    return new HShapeElement(data, this.globalData, this);
	};

	HybridRenderer.prototype.createText = function (data) {
	    if(!this.supports3d){
	        return new SVGTextElement(data, this.globalData, this);
	    }
	    return new HTextElement(data, this.globalData, this);
	};

	HybridRenderer.prototype.createCamera = function (data) {
	    this.camera = new HCameraElement(data, this.globalData, this);
	    return this.camera;
	};

	HybridRenderer.prototype.createImage = function (data) {
	    if(!this.supports3d){
	        return new IImageElement(data, this.globalData, this);
	    }
	    return new HImageElement(data, this.globalData, this);
	};

	HybridRenderer.prototype.createComp = function (data) {
	    if(!this.supports3d){
	        return new SVGCompElement(data, this.globalData, this);
	    }
	    return new HCompElement(data, this.globalData, this);

	};

	HybridRenderer.prototype.createSolid = function (data) {
	    if(!this.supports3d){
	        return new ISolidElement(data, this.globalData, this);
	    }
	    return new HSolidElement(data, this.globalData, this);
	};

	HybridRenderer.prototype.createNull = SVGRenderer.prototype.createNull;

	HybridRenderer.prototype.getThreeDContainerByPos = function(pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len) {
	        if(this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
	            return this.threeDElements[i].perspectiveElem;
	        }
	        i += 1;
	    }
	};

	HybridRenderer.prototype.createThreeDContainer = function(pos, type){
	    var perspectiveElem = createTag('div');
	    styleDiv(perspectiveElem);
	    var container = createTag('div');
	    styleDiv(container);
	    if(type === '3d') {
	        perspectiveElem.style.width = this.globalData.compSize.w+'px';
	        perspectiveElem.style.height = this.globalData.compSize.h+'px';
	        perspectiveElem.style.transformOrigin = perspectiveElem.style.mozTransformOrigin = perspectiveElem.style.webkitTransformOrigin = "50% 50%";
	        container.style.transform = container.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	    }
	    
	    perspectiveElem.appendChild(container);
	    //this.resizerElem.appendChild(perspectiveElem);
	    var threeDContainerData = {
	        container:container,
	        perspectiveElem:perspectiveElem,
	        startPos: pos,
	        endPos: pos,
	        type: type
	    };
	    this.threeDElements.push(threeDContainerData);
	    return threeDContainerData;
	};

	HybridRenderer.prototype.build3dContainers = function(){
	    var i, len = this.layers.length;
	    var lastThreeDContainerData;
	    var currentContainer = '';
	    for(i=0;i<len;i+=1){
	        if(this.layers[i].ddd && this.layers[i].ty !== 3){
	            if(currentContainer !== '3d'){
	                currentContainer = '3d';
	                lastThreeDContainerData = this.createThreeDContainer(i,'3d');
	            }
	            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
	        } else {
	            if(currentContainer !== '2d'){
	                currentContainer = '2d';
	                lastThreeDContainerData = this.createThreeDContainer(i,'2d');
	            }
	            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
	        }
	    }
	    len = this.threeDElements.length;
	    for(i = len - 1; i >= 0; i --) {
	        this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
	    }
	};

	HybridRenderer.prototype.addTo3dContainer = function(elem,pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len){
	        if(pos <= this.threeDElements[i].endPos){
	            var j = this.threeDElements[i].startPos;
	            var nextElement;
	            while(j<pos){
	                if(this.elements[j] && this.elements[j].getBaseElement){
	                    nextElement = this.elements[j].getBaseElement();
	                }
	                j += 1;
	            }
	            if(nextElement){
	                this.threeDElements[i].container.insertBefore(elem, nextElement);
	            } else {
	                this.threeDElements[i].container.appendChild(elem);
	            }
	            break;
	        }
	        i += 1;
	    }
	};

	HybridRenderer.prototype.configAnimation = function(animData){
	    var resizerElem = createTag('div');
	    var wrapper = this.animationItem.wrapper;
	    resizerElem.style.width = animData.w+'px';
	    resizerElem.style.height = animData.h+'px';
	    this.resizerElem = resizerElem;
	    styleDiv(resizerElem);
	    resizerElem.style.transformStyle = resizerElem.style.webkitTransformStyle = resizerElem.style.mozTransformStyle = "flat";
	    if(this.renderConfig.className) {
	      resizerElem.setAttribute('class', this.renderConfig.className);
	    }
	    wrapper.appendChild(resizerElem);

	    resizerElem.style.overflow = 'hidden';
	    var svg = createNS('svg');
	    svg.setAttribute('width','1');
	    svg.setAttribute('height','1');
	    styleDiv(svg);
	    this.resizerElem.appendChild(svg);
	    var defs = createNS('defs');
	    svg.appendChild(defs);
	    this.data = animData;
	    //Mask animation
	    this.setupGlobalData(animData, svg);
	    this.globalData.defs = defs;
	    this.layers = animData.layers;
	    this.layerElement = this.resizerElem;
	    this.build3dContainers();
	    this.updateContainerSize();
	};

	HybridRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.animationItem.container = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        this.elements[i].destroy();
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};

	HybridRenderer.prototype.updateContainerSize = function () {
	    var elementWidth = this.animationItem.wrapper.offsetWidth;
	    var elementHeight = this.animationItem.wrapper.offsetHeight;
	    var elementRel = elementWidth/elementHeight;
	    var animationRel = this.globalData.compSize.w/this.globalData.compSize.h;
	    var sx,sy,tx,ty;
	    if(animationRel>elementRel){
	        sx = elementWidth/(this.globalData.compSize.w);
	        sy = elementWidth/(this.globalData.compSize.w);
	        tx = 0;
	        ty = ((elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2);
	    }else {
	        sx = elementHeight/(this.globalData.compSize.h);
	        sy = elementHeight/(this.globalData.compSize.h);
	        tx = (elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;
	        ty = 0;
	    }
	    this.resizerElem.style.transform = this.resizerElem.style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';
	};

	HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

	HybridRenderer.prototype.hide = function(){
	    this.resizerElem.style.display = 'none';
	};

	HybridRenderer.prototype.show = function(){
	    this.resizerElem.style.display = 'block';
	};

	HybridRenderer.prototype.initItems = function(){
	    this.buildAllItems();
	    if(this.camera){
	        this.camera.setup();
	    } else {
	        var cWidth = this.globalData.compSize.w;
	        var cHeight = this.globalData.compSize.h;
	        var i, len = this.threeDElements.length;
	        for(i=0;i<len;i+=1){
	            this.threeDElements[i].perspectiveElem.style.perspective = this.threeDElements[i].perspectiveElem.style.webkitPerspective = Math.sqrt(Math.pow(cWidth,2) + Math.pow(cHeight,2)) + 'px';
	        }
	    }
	};

	HybridRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = createTag('div');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
	            comp.initExpressions();
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};

	function MaskElement(data,element,globalData) {
	    this.data = data;
	    this.element = element;
	    this.globalData = globalData;
	    this.storedData = [];
	    this.masksProperties = this.data.masksProperties || [];
	    this.maskElement = null;
	    var defs = this.globalData.defs;
	    var i, len = this.masksProperties ? this.masksProperties.length : 0;
	    this.viewData = createSizedArray(len);
	    this.solidPath = '';


	    var path, properties = this.masksProperties;
	    var count = 0;
	    var currentMasks = [];
	    var j, jLen;
	    var layerId = createElementID();
	    var rect, expansor, feMorph,x;
	    var maskType = 'clipPath', maskRef = 'clip-path';
	    for (i = 0; i < len; i++) {
	        if((properties[i].mode !== 'a' && properties[i].mode !== 'n')|| properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x){
	            maskType = 'mask';
	            maskRef = 'mask';
	        }

	        if((properties[i].mode == 's' || properties[i].mode == 'i') && count === 0){
	            rect = createNS( 'rect');
	            rect.setAttribute('fill', '#ffffff');
	            rect.setAttribute('width', this.element.comp.data.w || 0);
	            rect.setAttribute('height', this.element.comp.data.h || 0);
	            currentMasks.push(rect);
	        } else {
	            rect = null;
	        }

	        path = createNS( 'path');
	        if(properties[i].mode == 'n') {
	            // TODO move this to a factory or to a constructor
	            this.viewData[i] = {
	                op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),
	                prop: ShapePropertyFactory.getShapeProp(this.element,properties[i],3),
	                elem: path,
	                lastPath: ''
	            };
	            defs.appendChild(path);
	            continue;
	        }
	        count += 1;

	        path.setAttribute('fill', properties[i].mode === 's' ? '#000000':'#ffffff');
	        path.setAttribute('clip-rule','nonzero');
	        var filterID;

	        if (properties[i].x.k !== 0) {
	            maskType = 'mask';
	            maskRef = 'mask';
	            x = PropertyFactory.getProp(this.element,properties[i].x,0,null,this.element);
	            filterID = createElementID();
	            expansor = createNS('filter');
	            expansor.setAttribute('id',filterID);
	            feMorph = createNS('feMorphology');
	            feMorph.setAttribute('operator','erode');
	            feMorph.setAttribute('in','SourceGraphic');
	            feMorph.setAttribute('radius','0');
	            expansor.appendChild(feMorph);
	            defs.appendChild(expansor);
	            path.setAttribute('stroke', properties[i].mode === 's' ? '#000000':'#ffffff');
	        } else {
	            feMorph = null;
	            x = null;
	        }

	        // TODO move this to a factory or to a constructor
	        this.storedData[i] = {
	             elem: path,
	             x: x,
	             expan: feMorph,
	            lastPath: '',
	            lastOperator:'',
	            filterId:filterID,
	            lastRadius:0
	        };
	        if(properties[i].mode == 'i'){
	            jLen = currentMasks.length;
	            var g = createNS('g');
	            for(j=0;j<jLen;j+=1){
	                g.appendChild(currentMasks[j]);
	            }
	            var mask = createNS('mask');
	            mask.setAttribute('mask-type','alpha');
	            mask.setAttribute('id',layerId+'_'+count);
	            mask.appendChild(path);
	            defs.appendChild(mask);
	            g.setAttribute('mask','url(' + locationHref + '#'+layerId+'_'+count+')');

	            currentMasks.length = 0;
	            currentMasks.push(g);
	        }else {
	            currentMasks.push(path);
	        }
	        if(properties[i].inv && !this.solidPath){
	            this.solidPath = this.createLayerSolidPath();
	        }
	        // TODO move this to a factory or to a constructor
	        this.viewData[i] = {
	            elem: path,
	            lastPath: '',
	            op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),
	            prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3),
	            invRect: rect
	        };
	        if(!this.viewData[i].prop.k){
	            this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	    }

	    this.maskElement = createNS( maskType);

	    len = currentMasks.length;
	    for(i=0;i<len;i+=1){
	        this.maskElement.appendChild(currentMasks[i]);
	    }

	    if(count > 0){
	        this.maskElement.setAttribute('id', layerId);
	        this.element.maskedElement.setAttribute(maskRef, "url(" + locationHref + "#" + layerId + ")");
	        defs.appendChild(this.maskElement);
	    }
	    if (this.viewData.length) {
	        this.element.addRenderableComponent(this);
	    }

	}

	MaskElement.prototype.getMaskProperty = function(pos){
	    return this.viewData[pos].prop;
	};

	MaskElement.prototype.renderFrame = function (isFirstFrame) {
	    var finalMat = this.element.finalTransform.mat;
	    var i, len = this.masksProperties.length;
	    for (i = 0; i < len; i++) {
	        if(this.viewData[i].prop._mdf || isFirstFrame){
	            this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	        if(this.viewData[i].op._mdf || isFirstFrame){
	            this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);
	        }
	        if(this.masksProperties[i].mode !== 'n'){
	            if(this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)){
	                this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
	            }
	            if(this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)){
	                var feMorph = this.storedData[i].expan;
	                if(this.storedData[i].x.v < 0){
	                    if(this.storedData[i].lastOperator !== 'erode'){
	                        this.storedData[i].lastOperator = 'erode';
	                        this.storedData[i].elem.setAttribute('filter','url(' + locationHref + '#'+this.storedData[i].filterId+')');
	                    }
	                    feMorph.setAttribute('radius',-this.storedData[i].x.v);
	                }else {
	                    if(this.storedData[i].lastOperator !== 'dilate'){
	                        this.storedData[i].lastOperator = 'dilate';
	                        this.storedData[i].elem.setAttribute('filter',null);
	                    }
	                    this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v*2);

	                }
	            }
	        }
	    }
	};

	MaskElement.prototype.getMaskelement = function () {
	    return this.maskElement;
	};

	MaskElement.prototype.createLayerSolidPath = function(){
	    var path = 'M0,0 ';
	    path += ' h' + this.globalData.compSize.w ;
	    path += ' v' + this.globalData.compSize.h ;
	    path += ' h-' + this.globalData.compSize.w ;
	    path += ' v-' + this.globalData.compSize.h + ' ';
	    return path;
	};

	MaskElement.prototype.drawPath = function(pathData,pathNodes,viewData){
	    var pathString = " M"+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    var i, len;
	    len = pathNodes._length;
	    for(i=1;i<len;i+=1){
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	        pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	    }
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    if(pathNodes.c && len > 1){
	        pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    }
	    //pathNodes.__renderedString = pathString;

	    if(viewData.lastPath !== pathString){
	        var pathShapeValue = '';
	        if(viewData.elem){
	            if(pathNodes.c){
	                pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
	            }
	            viewData.elem.setAttribute('d',pathShapeValue);
	        }
	        viewData.lastPath = pathString;
	    }
	};

	MaskElement.prototype.destroy = function(){
	    this.element = null;
	    this.globalData = null;
	    this.maskElement = null;
	    this.data = null;
	    this.masksProperties = null;
	};

	/**
	 * @file 
	 * Handles AE's layer parenting property.
	 *
	 */

	function HierarchyElement(){}

	HierarchyElement.prototype = {
		/**
	     * @function 
	     * Initializes hierarchy properties
	     *
	     */
		initHierarchy: function() {
			//element's parent list
		    this.hierarchy = [];
		    //if element is parent of another layer _isParent will be true
		    this._isParent = false;
		    this.checkParenting();
		},
		/**
	     * @function 
	     * Sets layer's hierarchy.
	     * @param {array} hierarch
	     * layer's parent list
	     *
	     */ 
		setHierarchy: function(hierarchy){
		    this.hierarchy = hierarchy;
		},
		/**
	     * @function 
	     * Sets layer as parent.
	     *
	     */ 
		setAsParent: function() {
		    this._isParent = true;
		},
		/**
	     * @function 
	     * Searches layer's parenting chain
	     *
	     */ 
		checkParenting: function(){
		    if (this.data.parent !== undefined){
		        this.comp.buildElementParenting(this, this.data.parent, []);
		    }
		}
	};
	/**
	 * @file 
	 * Handles element's layer frame update.
	 * Checks layer in point and out point
	 *
	 */

	function FrameElement(){}

	FrameElement.prototype = {
	    /**
	     * @function 
	     * Initializes frame related properties.
	     *
	     */
	    initFrame: function(){
	        //set to true when inpoint is rendered
	        this._isFirstFrame = false;
	        //list of animated properties
	        this.dynamicProperties = [];
	        // If layer has been modified in current tick this will be true
	        this._mdf = false;
	    },
	    /**
	     * @function 
	     * Calculates all dynamic values
	     *
	     * @param {number} num
	     * current frame number in Layer's time
	     * @param {boolean} isVisible
	     * if layers is currently in range
	     * 
	     */
	    prepareProperties: function(num, isVisible) {
	        var i, len = this.dynamicProperties.length;
	        for (i = 0;i < len; i += 1) {
	            if (isVisible || (this._isParent && this.dynamicProperties[i].propType === 'transform')) {
	                this.dynamicProperties[i].getValue();
	                if (this.dynamicProperties[i]._mdf) {
	                    this.globalData._mdf = true;
	                    this._mdf = true;
	                }
	            }
	        }
	    },
	    addDynamicProperty: function(prop) {
	        if(this.dynamicProperties.indexOf(prop) === -1) {
	            this.dynamicProperties.push(prop);
	        }
	    }
	};
	function TransformElement(){}

	TransformElement.prototype = {
	    initTransform: function() {
	        this.finalTransform = {
	            mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {o:0},
	            _matMdf: false,
	            _opMdf: false,
	            mat: new Matrix()
	        };
	        if (this.data.ao) {
	            this.finalTransform.mProp.autoOriented = true;
	        }

	        //TODO: check TYPE 11: Guided elements
	        if (this.data.ty !== 11) ;
	    },
	    renderTransform: function() {

	        this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
	        this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;

	        if (this.hierarchy) {
	            var mat;
	            var finalMat = this.finalTransform.mat;
	            var i = 0, len = this.hierarchy.length;
	            //Checking if any of the transformation matrices in the hierarchy chain has changed.
	            if (!this.finalTransform._matMdf) {
	                while (i < len) {
	                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
	                        this.finalTransform._matMdf = true;
	                        break;
	                    }
	                    i += 1;
	                }
	            }
	            
	            if (this.finalTransform._matMdf) {
	                mat = this.finalTransform.mProp.v.props;
	                finalMat.cloneFromProps(mat);
	                for (i = 0; i < len; i += 1) {
	                    mat = this.hierarchy[i].finalTransform.mProp.v.props;
	                    finalMat.transform(mat[0], mat[1], mat[2], mat[3], mat[4], mat[5], mat[6], mat[7], mat[8], mat[9], mat[10], mat[11], mat[12], mat[13], mat[14], mat[15]);
	                }
	            }
	        }
	    },
	    globalToLocal: function(pt) {
	        var transforms = [];
	        transforms.push(this.finalTransform);
	        var flag = true;
	        var comp = this.comp;
	        while (flag) {
	            if (comp.finalTransform) {
	                if (comp.data.hasMask) {
	                    transforms.splice(0, 0, comp.finalTransform);
	                }
	                comp = comp.comp;
	            } else {
	                flag = false;
	            }
	        }
	        var i, len = transforms.length,ptNew;
	        for (i = 0; i < len; i += 1) {
	            ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
	            //ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
	            pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
	        }
	        return pt;
	    },
	    mHelper: new Matrix()
	};
	function RenderableElement(){

	}

	RenderableElement.prototype = {
	    initRenderable: function() {
	        //layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
	        this.isInRange = false;
	        //layer's display state
	        this.hidden = false;
	        // If layer's transparency equals 0, it can be hidden
	        this.isTransparent = false;
	        //list of animated components
	        this.renderableComponents = [];
	    },
	    addRenderableComponent: function(component) {
	        if(this.renderableComponents.indexOf(component) === -1) {
	            this.renderableComponents.push(component);
	        }
	    },
	    removeRenderableComponent: function(component) {
	        if(this.renderableComponents.indexOf(component) !== -1) {
	            this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
	        }
	    },
	    prepareRenderableFrame: function(num) {
	        this.checkLayerLimits(num);
	    },
	    checkTransparency: function(){
	        if(this.finalTransform.mProp.o.v <= 0) {
	            if(!this.isTransparent && this.globalData.renderConfig.hideOnTransparent){
	                this.isTransparent = true;
	                this.hide();
	            }
	        } else if(this.isTransparent) {
	            this.isTransparent = false;
	            this.show();
	        }
	    },
	    /**
	     * @function 
	     * Initializes frame related properties.
	     *
	     * @param {number} num
	     * current frame number in Layer's time
	     * 
	     */
	    checkLayerLimits: function(num) {
	        if(this.data.ip - this.data.st <= num && this.data.op - this.data.st > num)
	        {
	            if(this.isInRange !== true){
	                this.globalData._mdf = true;
	                this._mdf = true;
	                this.isInRange = true;
	                this.show();
	            }
	        } else {
	            if(this.isInRange !== false){
	                this.globalData._mdf = true;
	                this.isInRange = false;
	                this.hide();
	            }
	        }
	    },
	    renderRenderable: function() {
	        var i, len = this.renderableComponents.length;
	        for(i = 0; i < len; i += 1) {
	            this.renderableComponents[i].renderFrame(this._isFirstFrame);
	        }
	        /*this.maskManager.renderFrame(this.finalTransform.mat);
	        this.renderableEffectsManager.renderFrame(this._isFirstFrame);*/
	    },
	    sourceRectAtTime: function(){
	        return {
	            top:0,
	            left:0,
	            width:100,
	            height:100
	        };
	    },
	    getLayerSize: function(){
	        if(this.data.ty === 5){
	            return {w:this.data.textData.width,h:this.data.textData.height};
	        }else {
	            return {w:this.data.width,h:this.data.height};
	        }
	    }
	};
	function RenderableDOMElement() {}

	(function(){
	    var _prototype = {
	        initElement: function(data,globalData,comp) {
	            this.initFrame();
	            this.initBaseData(data, globalData, comp);
	            this.initTransform(data, globalData, comp);
	            this.initHierarchy();
	            this.initRenderable();
	            this.initRendererElement();
	            this.createContainerElements();
	            this.createRenderableComponents();
	            this.createContent();
	            this.hide();
	        },
	        hide: function(){
	            if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	                var elem = this.baseElement || this.layerElement;
	                elem.style.display = 'none';
	                this.hidden = true;
	            }
	        },
	        show: function(){
	            if (this.isInRange && !this.isTransparent){
	                if (!this.data.hd) {
	                    var elem = this.baseElement || this.layerElement;
	                    elem.style.display = 'block';
	                }
	                this.hidden = false;
	                this._isFirstFrame = true;
	            }
	        },
	        renderFrame: function() {
	            //If it is exported as hidden (data.hd === true) no need to render
	            //If it is not visible no need to render
	            if (this.data.hd || this.hidden) {
	                return;
	            }
	            this.renderTransform();
	            this.renderRenderable();
	            this.renderElement();
	            this.renderInnerContent();
	            if (this._isFirstFrame) {
	                this._isFirstFrame = false;
	            }
	        },
	        renderInnerContent: function() {},
	        prepareFrame: function(num) {
	            this._mdf = false;
	            this.prepareRenderableFrame(num);
	            this.prepareProperties(num, this.isInRange);
	            this.checkTransparency();
	        },
	        destroy: function(){
	            this.innerElem =  null;
	            this.destroyBaseElement();
	        }
	    };
	    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
	}());
	function ProcessedElement(element, position) {
		this.elem = element;
		this.pos = position;
	}
	function SVGStyleData(data, level) {
		this.data = data;
		this.type = data.ty;
		this.d = '';
		this.lvl = level;
		this._mdf = false;
		this.closed = data.hd === true;
		this.pElem = createNS('path');
		this.msElem = null;
	}

	SVGStyleData.prototype.reset = function() {
		this.d = '';
		this._mdf = false;
	};
	function SVGShapeData(transformers, level, shape) {
	    this.caches = [];
	    this.styles = [];
	    this.transformers = transformers;
	    this.lStr = '';
	    this.sh = shape;
	    this.lvl = level;
	    //TODO find if there are some cases where _isAnimated can be false. 
	    // For now, since shapes add up with other shapes. They have to be calculated every time.
	    // One way of finding out is checking if all styles associated to this shape depend only of this shape
	    this._isAnimated = !!shape.k;
	    // TODO: commenting this for now since all shapes are animated
	    var i = 0, len = transformers.length;
	    while(i < len) {
	    	if(transformers[i].mProps.dynamicProperties.length) {
	    		this._isAnimated = true;
	    		break;
	    	}
	    	i += 1;
	    }
	}

	SVGShapeData.prototype.setAsAnimated = function() {
	    this._isAnimated = true;
	};
	function SVGTransformData(mProps, op, container) {
		this.transform = {
			mProps: mProps,
			op: op,
			container: container
		};
		this.elements = [];
	    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
	}
	function SVGStrokeStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
		this.w = PropertyFactory.getProp(elem,data.w,0,null,this);
		this.d = new DashProperty(elem,data.d||{},'svg',this);
		this.c = PropertyFactory.getProp(elem,data.c,1,255,this);
		this.style = styleOb;
	    this._isAnimated = !!this._isAnimated;
	}

	extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
	function SVGFillStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
		this.c = PropertyFactory.getProp(elem,data.c,1,255,this);
		this.style = styleOb;
	}

	extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
	function SVGGradientFillStyleData(elem, data, styleOb){
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.initGradientData(elem, data, styleOb);
	}

	SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb){
	    this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
	    this.s = PropertyFactory.getProp(elem,data.s,1,null,this);
	    this.e = PropertyFactory.getProp(elem,data.e,1,null,this);
	    this.h = PropertyFactory.getProp(elem,data.h||{k:0},0,0.01,this);
	    this.a = PropertyFactory.getProp(elem,data.a||{k:0},0,degToRads,this);
	    this.g = new GradientProperty(elem,data.g,this);
	    this.style = styleOb;
	    this.stops = [];
	    this.setGradientData(styleOb.pElem, data);
	    this.setGradientOpacity(data, styleOb);
	    this._isAnimated = !!this._isAnimated;

	};

	SVGGradientFillStyleData.prototype.setGradientData = function(pathElement,data){

	    var gradientId = createElementID();
	    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	    gfill.setAttribute('id',gradientId);
	    gfill.setAttribute('spreadMethod','pad');
	    gfill.setAttribute('gradientUnits','userSpaceOnUse');
	    var stops = [];
	    var stop, j, jLen;
	    jLen = data.g.p*4;
	    for(j=0;j<jLen;j+=4){
	        stop = createNS('stop');
	        gfill.appendChild(stop);
	        stops.push(stop);
	    }
	    pathElement.setAttribute( data.ty === 'gf' ? 'fill':'stroke','url(' + locationHref + '#'+gradientId+')');
	    
	    this.gf = gfill;
	    this.cst = stops;
	};

	SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb){
	    if(this.g._hasOpacity && !this.g._collapsable){
	        var stop, j, jLen;
	        var mask = createNS("mask");
	        var maskElement = createNS( 'path');
	        mask.appendChild(maskElement);
	        var opacityId = createElementID();
	        var maskId = createElementID();
	        mask.setAttribute('id',maskId);
	        var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	        opFill.setAttribute('id',opacityId);
	        opFill.setAttribute('spreadMethod','pad');
	        opFill.setAttribute('gradientUnits','userSpaceOnUse');
	        jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
	        var stops = this.stops;
	        for(j=data.g.p*4;j<jLen;j+=2){
	            stop = createNS('stop');
	            stop.setAttribute('stop-color','rgb(255,255,255)');
	            opFill.appendChild(stop);
	            stops.push(stop);
	        }
	        maskElement.setAttribute( data.ty === 'gf' ? 'fill':'stroke','url(' + locationHref + '#'+opacityId+')');
	        this.of = opFill;
	        this.ms = mask;
	        this.ost = stops;
	        this.maskId = maskId;
	        styleOb.msElem = maskElement;
	    }
	};

	extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
	function SVGGradientStrokeStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.w = PropertyFactory.getProp(elem,data.w,0,null,this);
		this.d = new DashProperty(elem,data.d||{},'svg',this);
	    this.initGradientData(elem, data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	}

	extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
	function ShapeGroupData() {
		this.it = [];
	    this.prevViewData = [];
	    this.gr = createNS('g');
	}
	var SVGElementsRenderer = (function() {
		var _identityMatrix = new Matrix();
		var _matrixHelper = new Matrix();

		var ob = {
			createRenderFunction: createRenderFunction
		};

		function createRenderFunction(data) {
		    data.ty;
		    switch(data.ty) {
		        case 'fl':
		        return renderFill;
		        case 'gf':
		        return renderGradient;
		        case 'gs':
		        return renderGradientStroke;
		        case 'st':
		        return renderStroke;
		        case 'sh':
		        case 'el':
		        case 'rc':
		        case 'sr':
		        return renderPath;
		        case 'tr':
		        return renderContentTransform;
		    }
		}

		function renderContentTransform(styleData, itemData, isFirstFrame) {
		    if(isFirstFrame || itemData.transform.op._mdf){
		        itemData.transform.container.setAttribute('opacity',itemData.transform.op.v);
		    }
		    if(isFirstFrame || itemData.transform.mProps._mdf){
		        itemData.transform.container.setAttribute('transform',itemData.transform.mProps.v.to2dCSS());
		    }
		}

		function renderPath(styleData, itemData, isFirstFrame) {
		    var j, jLen,pathStringTransformed,redraw,pathNodes,l, lLen = itemData.styles.length;
		    var lvl = itemData.lvl;
		    var paths, mat, props, iterations, k;
		    for(l=0;l<lLen;l+=1){
		        redraw = itemData.sh._mdf || isFirstFrame;
		        if(itemData.styles[l].lvl < lvl){
		            mat = _matrixHelper.reset();
		            iterations = lvl - itemData.styles[l].lvl;
		            k = itemData.transformers.length-1;
		            while(!redraw && iterations > 0) {
		                redraw = itemData.transformers[k].mProps._mdf || redraw;
		                iterations --;
		                k --;
		            }
		            if(redraw) {
		                iterations = lvl - itemData.styles[l].lvl;
		                k = itemData.transformers.length-1;
		                while(iterations > 0) {
		                    props = itemData.transformers[k].mProps.v.props;
		                    mat.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
		                    iterations --;
		                    k --;
		                }
		            }
		        } else {
		            mat = _identityMatrix;
		        }
		        paths = itemData.sh.paths;
		        jLen = paths._length;
		        if(redraw){
		            pathStringTransformed = '';
		            for(j=0;j<jLen;j+=1){
		                pathNodes = paths.shapes[j];
		                if(pathNodes && pathNodes._length){
		                    pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
		                }
		            }
		            itemData.caches[l] = pathStringTransformed;
		        } else {
		            pathStringTransformed = itemData.caches[l];
		        }
		        itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
		        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
		    }
		}

		function renderFill (styleData,itemData, isFirstFrame){
		    var styleElem = itemData.style;

		    if(itemData.c._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('fill','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
		    }
		    if(itemData.o._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('fill-opacity',itemData.o.v);
		    }
		}
		function renderGradientStroke (styleData, itemData, isFirstFrame) {
		    renderGradient(styleData, itemData, isFirstFrame);
		    renderStroke(styleData, itemData, isFirstFrame);
		}

		function renderGradient(styleData, itemData, isFirstFrame) {
		    var gfill = itemData.gf;
		    var hasOpacity = itemData.g._hasOpacity;
		    var pt1 = itemData.s.v, pt2 = itemData.e.v;

		    if (itemData.o._mdf || isFirstFrame) {
		        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
		        itemData.style.pElem.setAttribute(attr, itemData.o.v);
		    }
		    if (itemData.s._mdf || isFirstFrame) {
		        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
		        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
		        gfill.setAttribute(attr1, pt1[0]);
		        gfill.setAttribute(attr2, pt1[1]);
		        if (hasOpacity && !itemData.g._collapsable) {
		            itemData.of.setAttribute(attr1, pt1[0]);
		            itemData.of.setAttribute(attr2, pt1[1]);
		        }
		    }
		    var stops, i, len, stop;
		    if (itemData.g._cmdf || isFirstFrame) {
		        stops = itemData.cst;
		        var cValues = itemData.g.c;
		        len = stops.length;
		        for (i = 0; i < len; i += 1){
		            stop = stops[i];
		            stop.setAttribute('offset', cValues[i * 4] + '%');
		            stop.setAttribute('stop-color','rgb('+ cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ','+cValues[i * 4 + 3] + ')');
		        }
		    }
		    if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
		        var oValues = itemData.g.o;
		        if(itemData.g._collapsable) {
		            stops = itemData.cst;
		        } else {
		            stops = itemData.ost;
		        }
		        len = stops.length;
		        for (i = 0; i < len; i += 1) {
		            stop = stops[i];
		            if(!itemData.g._collapsable) {
		                stop.setAttribute('offset', oValues[i * 2] + '%');
		            }
		            stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
		        }
		    }
		    if (styleData.t === 1) {
		        if (itemData.e._mdf  || isFirstFrame) {
		            gfill.setAttribute('x2', pt2[0]);
		            gfill.setAttribute('y2', pt2[1]);
		            if (hasOpacity && !itemData.g._collapsable) {
		                itemData.of.setAttribute('x2', pt2[0]);
		                itemData.of.setAttribute('y2', pt2[1]);
		            }
		        }
		    } else {
		        var rad;
		        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
		            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
		            gfill.setAttribute('r', rad);
		            if(hasOpacity && !itemData.g._collapsable){
		                itemData.of.setAttribute('r', rad);
		            }
		        }
		        if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
		            if (!rad) {
		                rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
		            }
		            var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);

		            var percent = itemData.h.v >= 1 ? 0.99 : itemData.h.v <= -1 ? -0.99: itemData.h.v;
		            var dist = rad * percent;
		            var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
		            var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
		            gfill.setAttribute('fx', x);
		            gfill.setAttribute('fy', y);
		            if (hasOpacity && !itemData.g._collapsable) {
		                itemData.of.setAttribute('fx', x);
		                itemData.of.setAttribute('fy', y);
		            }
		        }
		        //gfill.setAttribute('fy','200');
		    }
		}
		function renderStroke(styleData, itemData, isFirstFrame) {
		    var styleElem = itemData.style;
		    var d = itemData.d;
		    if (d && (d._mdf || isFirstFrame) && d.dashStr) {
		        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
		        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
		    }
		    if(itemData.c && (itemData.c._mdf || isFirstFrame)){
		        styleElem.pElem.setAttribute('stroke','rgb(' + bm_floor(itemData.c.v[0]) + ',' + bm_floor(itemData.c.v[1]) + ',' + bm_floor(itemData.c.v[2]) + ')');
		    }
		    if(itemData.o._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
		    }
		    if(itemData.w._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
		        if(styleElem.msElem){
		            styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
		        }
		    }
		}
		return ob;
	}());
	function ShapeTransformManager() {
		this.sequences = {};
		this.sequenceList = [];
	    this.transform_key_count = 0;
	}

	ShapeTransformManager.prototype = {
		addTransformSequence: function(transforms) {
			var i, len = transforms.length;
			var key = '_';
			for(i = 0; i < len; i += 1) {
				key += transforms[i].transform.key + '_';
			}
			var sequence = this.sequences[key];
			if(!sequence) {
				sequence = {
					transforms: [].concat(transforms),
					finalTransform: new Matrix(),
					_mdf: false
				};
				this.sequences[key] = sequence;
				this.sequenceList.push(sequence);
			}
			return sequence;
		},
		processSequence: function(sequence, isFirstFrame) {
			var i = 0, len = sequence.transforms.length, _mdf = isFirstFrame;
			while (i < len && !isFirstFrame) {
				if (sequence.transforms[i].transform.mProps._mdf) {
					_mdf = true;
					break;
				}
				i += 1;
			}
			if (_mdf) {
				var props;
				sequence.finalTransform.reset();
				for (i = len - 1; i >= 0; i -= 1) {
			        props = sequence.transforms[i].transform.mProps.v.props;
			        sequence.finalTransform.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
				}
			}
			sequence._mdf = _mdf;
			
		},
		processSequences: function(isFirstFrame) {
			var i, len = this.sequenceList.length;
			for (i = 0; i < len; i += 1) {
				this.processSequence(this.sequenceList[i], isFirstFrame);
			}

		},
		getNewKey: function() {
			return '_' + this.transform_key_count++;
		}
	};
	function CVShapeData(element, data, styles, transformsManager) {
	    this.styledShapes = [];
	    this.tr = [0,0,0,0,0,0];
	    var ty = 4;
	    if(data.ty == 'rc'){
	        ty = 5;
	    }else if(data.ty == 'el'){
	        ty = 6;
	    }else if(data.ty == 'sr'){
	        ty = 7;
	    }
	    this.sh = ShapePropertyFactory.getShapeProp(element,data,ty,element);
	    var i , len = styles.length,styledShape;
	    for (i = 0; i < len; i += 1) {
	        if (!styles[i].closed) {
	            styledShape = {
	                transforms: transformsManager.addTransformSequence(styles[i].transforms),
	                trNodes: []
	            };
	            this.styledShapes.push(styledShape);
	            styles[i].elements.push(styledShape);
	        }
	    }
	}

	CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
	function BaseElement(){
	}

	BaseElement.prototype = {
	    checkMasks: function(){
	        if(!this.data.hasMask){
	            return false;
	        }
	        var i = 0, len = this.data.masksProperties.length;
	        while(i<len) {
	            if((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
	                return true;
	            }
	            i += 1;
	        }
	        return false;
	    },
	    initExpressions: function(){
	        this.layerInterface = LayerExpressionInterface(this);
	        if(this.data.hasMask && this.maskManager) {
	            this.layerInterface.registerMaskInterface(this.maskManager);
	        }
	        var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);
	        this.layerInterface.registerEffectsInterface(effectsInterface);

	        if(this.data.ty === 0 || this.data.xt){
	            this.compInterface = CompExpressionInterface(this);
	        } else if(this.data.ty === 4){
	            this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData,this.itemsData,this.layerInterface);
	            this.layerInterface.content = this.layerInterface.shapeInterface;
	        } else if(this.data.ty === 5){
	            this.layerInterface.textInterface = TextExpressionInterface(this);
	            this.layerInterface.text = this.layerInterface.textInterface;
	        }
	    },
	    setBlendMode: function(){
	        var blendModeValue = getBlendMode(this.data.bm);
	        var elem = this.baseElement || this.layerElement;

	        elem.style['mix-blend-mode'] = blendModeValue;
	    },
	    initBaseData: function(data, globalData, comp){
	        this.globalData = globalData;
	        this.comp = comp;
	        this.data = data;
	        this.layerId = createElementID();
	        
	        //Stretch factor for old animations missing this property.
	        if(!this.data.sr){
	            this.data.sr = 1;
	        }
	        // effects manager
	        this.effectsManager = new EffectsManager(this.data,this,this.dynamicProperties);
	        
	    },
	    getType: function(){
	        return this.type;
	    }
	    ,sourceRectAtTime: function(){}
	};
	function NullElement(data,globalData,comp){
	    this.initFrame();
		this.initBaseData(data, globalData, comp);
	    this.initFrame();
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	}

	NullElement.prototype.prepareFrame = function(num) {
	    this.prepareProperties(num, true);
	};

	NullElement.prototype.renderFrame = function() {
	};

	NullElement.prototype.getBaseElement = function() {
		return null;
	};

	NullElement.prototype.destroy = function() {
	};

	NullElement.prototype.sourceRectAtTime = function() {
	};

	NullElement.prototype.hide = function() {
	};

	extendPrototype([BaseElement,TransformElement,HierarchyElement,FrameElement], NullElement);

	function SVGBaseElement(){
	}

	SVGBaseElement.prototype = {
	    initRendererElement: function() {
	        this.layerElement = createNS('g');
	    },
	    createContainerElements: function(){
	        this.matteElement = createNS('g');
	        this.transformedElement = this.layerElement;
	        this.maskedElement = this.layerElement;
	        this._sizeChanged = false;
	        var layerElementParent = null;
	        //If this layer acts as a mask for the following layer
	        var filId, fil, gg;
	        if (this.data.td) {
	            if (this.data.td == 3 || this.data.td == 1) {
	                var masker = createNS('mask');
	                masker.setAttribute('id', this.layerId);
	                masker.setAttribute('mask-type', this.data.td == 3 ? 'luminance' : 'alpha');
	                masker.appendChild(this.layerElement);
	                layerElementParent = masker;
	                this.globalData.defs.appendChild(masker);
	                // This is only for IE and Edge when mask if of type alpha
	                if (!featureSupport.maskType && this.data.td == 1) {
	                    masker.setAttribute('mask-type', 'luminance');
	                    filId = createElementID();
	                    fil = filtersFactory.createFilter(filId);
	                    this.globalData.defs.appendChild(fil);
	                    fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                    gg = createNS('g');
	                    gg.appendChild(this.layerElement);
	                    layerElementParent = gg;
	                    masker.appendChild(gg);
	                    gg.setAttribute('filter','url(' + locationHref + '#' + filId + ')');
	                }
	            } else if(this.data.td == 2) {
	                var maskGroup = createNS('mask');
	                maskGroup.setAttribute('id', this.layerId);
	                maskGroup.setAttribute('mask-type','alpha');
	                var maskGrouper = createNS('g');
	                maskGroup.appendChild(maskGrouper);
	                filId = createElementID();
	                fil = filtersFactory.createFilter(filId);
	                ////

	                // This solution doesn't work on Android when meta tag with viewport attribute is set
	                /*var feColorMatrix = createNS('feColorMatrix');
	                feColorMatrix.setAttribute('type', 'matrix');
	                feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	                feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
	                fil.appendChild(feColorMatrix);*/
	                ////
	                var feCTr = createNS('feComponentTransfer');
	                feCTr.setAttribute('in','SourceGraphic');
	                fil.appendChild(feCTr);
	                var feFunc = createNS('feFuncA');
	                feFunc.setAttribute('type','table');
	                feFunc.setAttribute('tableValues','1.0 0.0');
	                feCTr.appendChild(feFunc);
	                ////
	                this.globalData.defs.appendChild(fil);
	                var alphaRect = createNS('rect');
	                alphaRect.setAttribute('width',  this.comp.data.w);
	                alphaRect.setAttribute('height', this.comp.data.h);
	                alphaRect.setAttribute('x','0');
	                alphaRect.setAttribute('y','0');
	                alphaRect.setAttribute('fill','#ffffff');
	                alphaRect.setAttribute('opacity','0');
	                maskGrouper.setAttribute('filter', 'url(' + locationHref + '#'+filId+')');
	                maskGrouper.appendChild(alphaRect);
	                maskGrouper.appendChild(this.layerElement);
	                layerElementParent = maskGrouper;
	                if (!featureSupport.maskType) {
	                    maskGroup.setAttribute('mask-type', 'luminance');
	                    fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                    gg = createNS('g');
	                    maskGrouper.appendChild(alphaRect);
	                    gg.appendChild(this.layerElement);
	                    layerElementParent = gg;
	                    maskGrouper.appendChild(gg);
	                }
	                this.globalData.defs.appendChild(maskGroup);
	            }
	        } else if (this.data.tt) {
	            this.matteElement.appendChild(this.layerElement);
	            layerElementParent = this.matteElement;
	            this.baseElement = this.matteElement;
	        } else {
	            this.baseElement = this.layerElement;
	        }
	        if (this.data.ln) {
	            this.layerElement.setAttribute('id', this.data.ln);
	        }
	        if (this.data.cl) {
	            this.layerElement.setAttribute('class', this.data.cl);
	        }
	        //Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
	        if (this.data.ty === 0 && !this.data.hd) {
	            var cp = createNS( 'clipPath');
	            var pt = createNS('path');
	            pt.setAttribute('d','M0,0 L' + this.data.w + ',0' + ' L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
	            var clipId = createElementID();
	            cp.setAttribute('id',clipId);
	            cp.appendChild(pt);
	            this.globalData.defs.appendChild(cp);

	            if (this.checkMasks()) {
	                var cpGroup = createNS('g');
	                cpGroup.setAttribute('clip-path','url(' + locationHref + '#'+clipId + ')');
	                cpGroup.appendChild(this.layerElement);
	                this.transformedElement = cpGroup;
	                if (layerElementParent) {
	                    layerElementParent.appendChild(this.transformedElement);
	                } else {
	                    this.baseElement = this.transformedElement;
	                }
	            } else {
	                this.layerElement.setAttribute('clip-path','url(' + locationHref + '#'+clipId+')');
	            }
	            
	        }
	        if (this.data.bm !== 0) {
	            this.setBlendMode();
	        }

	    },
	    renderElement: function() {
	        if (this.finalTransform._matMdf) {
	            this.transformedElement.setAttribute('transform', this.finalTransform.mat.to2dCSS());
	        }
	        if (this.finalTransform._opMdf) {
	            this.transformedElement.setAttribute('opacity', this.finalTransform.mProp.o.v);
	        }
	    },
	    destroyBaseElement: function() {
	        this.layerElement = null;
	        this.matteElement = null;
	        this.maskManager.destroy();
	    },
	    getBaseElement: function() {
	        if (this.data.hd) {
	            return null;
	        }
	        return this.baseElement;
	    },
	    createRenderableComponents: function() {
	        this.maskManager = new MaskElement(this.data, this, this.globalData);
	        this.renderableEffectsManager = new SVGEffects(this);
	    },
	    setMatte: function(id) {
	        if (!this.matteElement) {
	            return;
	        }
	        this.matteElement.setAttribute("mask", "url(" + locationHref + "#" + id + ")");
	    }
	};
	function IShapeElement(){
	}

	IShapeElement.prototype = {
	    addShapeToModifiers: function(data) {
	        var i, len = this.shapeModifiers.length;
	        for(i=0;i<len;i+=1){
	            this.shapeModifiers[i].addShape(data);
	        }
	    },
	    isShapeInAnimatedModifiers: function(data) {
	        var i = 0, len = this.shapeModifiers.length;
	        while(i < len) {
	            if(this.shapeModifiers[i].isAnimatedWithShape(data)) {
	                return true;
	            }
	        }
	        return false;
	    },
	    renderModifiers: function() {
	        if(!this.shapeModifiers.length){
	            return;
	        }
	        var i, len = this.shapes.length;
	        for(i=0;i<len;i+=1){
	            this.shapes[i].sh.reset();
	        }

	        len = this.shapeModifiers.length;
	        for(i=len-1;i>=0;i-=1){
	            this.shapeModifiers[i].processShapes(this._isFirstFrame);
	        }
	    },
	    lcEnum: {
	        '1': 'butt',
	        '2': 'round',
	        '3': 'square'
	    },
	    ljEnum: {
	        '1': 'miter',
	        '2': 'round',
	        '3': 'bevel'
	    },
	    searchProcessedElement: function(elem){
	        var elements = this.processedElements;
	        var i = 0, len = elements.length;
	        while (i < len) {
	            if (elements[i].elem === elem) {
	                return elements[i].pos;
	            }
	            i += 1;
	        }
	        return 0;
	    },
	    addProcessedElement: function(elem, pos){
	        var elements = this.processedElements;
	        var i = elements.length;
	        while(i) {
	            i -= 1;
	            if (elements[i].elem === elem) {
	                elements[i].pos = pos;
	                return;
	            }
	        }
	        elements.push(new ProcessedElement(elem, pos));
	    },
	    prepareFrame: function(num) {
	        this.prepareRenderableFrame(num);
	        this.prepareProperties(num, this.isInRange);
	    }
	};
	function ITextElement(){
	}

	ITextElement.prototype.initElement = function(data,globalData,comp){
	    this.lettersChangedFlag = true;
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
	    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	    this.initRenderable();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	    this.createContent();
	    this.hide();
	    this.textAnimator.searchProperties(this.dynamicProperties);
	};

	ITextElement.prototype.prepareFrame = function(num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	    if(this.textProperty._mdf || this.textProperty._isFirstFrame) {
	        this.buildNewText();
	        this.textProperty._isFirstFrame = false;
	        this.textProperty._mdf = false;
	    }
	};

	ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
	    var j,jLen = shapes.length;
	    var pathNodes;
	    var shapeStr = '';
	    for(j=0;j<jLen;j+=1){
	        pathNodes = shapes[j].ks.k;
	        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
	    }
	    return shapeStr;
	};

	ITextElement.prototype.updateDocumentData = function(newData, index) {
	    this.textProperty.updateDocumentData(newData, index);
	};

	ITextElement.prototype.canResizeFont = function(_canResize) {
	    this.textProperty.canResizeFont(_canResize);
	};

	ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
	    this.textProperty.setMinimumFontSize(_fontSize);
	};

	ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
	    if(documentData.ps){
	        matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	    }
	    matrixHelper.translate(0,-documentData.ls,0);
	    switch(documentData.j){
	        case 1:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]),0,0);
	            break;
	        case 2:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber] )/2,0,0);
	            break;
	    }
	    matrixHelper.translate(xPos, yPos, 0);
	};


	ITextElement.prototype.buildColor = function(colorData) {
	    return 'rgb(' + Math.round(colorData[0]*255) + ',' + Math.round(colorData[1]*255) + ',' + Math.round(colorData[2]*255) + ')';
	};

	ITextElement.prototype.emptyProp = new LetterProps();

	ITextElement.prototype.destroy = function(){
	    
	};
	function ICompElement(){}

	extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);

	ICompElement.prototype.initElement = function(data,globalData,comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initTransform(data, globalData, comp);
	    this.initRenderable();
	    this.initHierarchy();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	    if(this.data.xt || !globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	    this.hide();
	};

	/*ICompElement.prototype.hide = function(){
	    if(!this.hidden){
	        this.hideElement();
	        var i,len = this.elements.length;
	        for( i = 0; i < len; i+=1 ){
	            if(this.elements[i]){
	                this.elements[i].hide();
	            }
	        }
	    }
	};*/

	ICompElement.prototype.prepareFrame = function(num){
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	    if(!this.isInRange && !this.data.xt){
	        return;
	    }

	    if (!this.tm._placeholder) {
	        var timeRemapped = this.tm.v;
	        if(timeRemapped === this.data.op){
	            timeRemapped = this.data.op - 1;
	        }
	        this.renderedFrame = timeRemapped;
	    } else {
	        this.renderedFrame = num/this.data.sr;
	    }
	    var i,len = this.elements.length;
	    if(!this.completeLayers){
	        this.checkLayers(this.renderedFrame);
	    }
	    //This iteration needs to be backwards because of how expressions connect between each other
	    for( i = len - 1; i >= 0; i -= 1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
	            if(this.elements[i]._mdf) {
	                this._mdf = true;
	            }
	        }
	    }
	};

	ICompElement.prototype.renderInnerContent = function() {
	    var i,len = this.layers.length;
	    for( i = 0; i < len; i += 1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	};

	ICompElement.prototype.setElements = function(elems){
	    this.elements = elems;
	};

	ICompElement.prototype.getElements = function(){
	    return this.elements;
	};

	ICompElement.prototype.destroyElements = function(){
	    var i,len = this.layers.length;
	    for( i = 0; i < len; i+=1 ){
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	};

	ICompElement.prototype.destroy = function(){
	    this.destroyElements();
	    this.destroyBaseElement();
	};

	function IImageElement(data,globalData,comp){
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data,globalData,comp);
	    this.sourceRect = {top:0,left:0,width:this.assetData.w,height:this.assetData.h};
	}

	extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement], IImageElement);

	IImageElement.prototype.createContent = function(){

	    var assetPath = this.globalData.getAssetsPath(this.assetData);

	    this.innerElem = createNS('image');
	    this.innerElem.setAttribute('width',this.assetData.w+"px");
	    this.innerElem.setAttribute('height',this.assetData.h+"px");
	    this.innerElem.setAttribute('preserveAspectRatio',this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
	    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	    
	    this.layerElement.appendChild(this.innerElem);
	};

	IImageElement.prototype.sourceRectAtTime = function() {
		return this.sourceRect;
	};
	function ISolidElement(data,globalData,comp){
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([IImageElement], ISolidElement);

	ISolidElement.prototype.createContent = function(){

	    var rect = createNS('rect');
	    ////rect.style.width = this.data.sw;
	    ////rect.style.height = this.data.sh;
	    ////rect.style.fill = this.data.sc;
	    rect.setAttribute('width',this.data.sw);
	    rect.setAttribute('height',this.data.sh);
	    rect.setAttribute('fill',this.data.sc);
	    this.layerElement.appendChild(rect);
	};
	function SVGCompElement(data,globalData,comp){
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    //this.layerElement = createNS('g');
	    this.initElement(data,globalData,comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this) : {_placeholder:true};
	}

	extendPrototype([SVGRenderer, ICompElement, SVGBaseElement], SVGCompElement);
	function SVGTextElement(data,globalData,comp){
	    this.textSpans = [];
	    this.renderType = 'svg';
	    this.initElement(data,globalData,comp);
	}

	extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement], SVGTextElement);

	SVGTextElement.prototype.createContent = function(){

	    if (this.data.singleShape && !this.globalData.fontManager.chars) {
	        this.textContainer = createNS('text');
	    }
	};

	SVGTextElement.prototype.buildTextContents = function(textArray) {
	    var i = 0, len = textArray.length;
	    var textContents = [], currentTextContent = '';
	    while (i < len) {
	        if(textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
	            textContents.push(currentTextContent);
	            currentTextContent = '';
	        } else {
	            currentTextContent += textArray[i];
	        }
	        i += 1;
	    }
	    textContents.push(currentTextContent);
	    return textContents;
	};

	SVGTextElement.prototype.buildNewText = function(){
	    var i, len;

	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
	    if(documentData.fc) {
	        this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
	    }else {
	        this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
	    }
	    if(documentData.sc){
	        this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
	        this.layerElement.setAttribute('stroke-width', documentData.sw);
	    }
	    this.layerElement.setAttribute('font-size', documentData.finalSize);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(fontData.fClass){
	        this.layerElement.setAttribute('class',fontData.fClass);
	    } else {
	        this.layerElement.setAttribute('font-family', fontData.fFamily);
	        var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	        this.layerElement.setAttribute('font-style', fStyle);
	        this.layerElement.setAttribute('font-weight', fWeight);
	    }
	    this.layerElement.setAttribute('aria-label', documentData.t);

	    var letters = documentData.l || [];
	    var usesGlyphs = !!this.globalData.fontManager.chars;
	    len = letters.length;

	    var tSpan;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '', singleShape = this.data.singleShape;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    if(singleShape && !usesGlyphs && !documentData.sz) {
	        var tElement = this.textContainer;
	        var justify = 'start';
	        switch(documentData.j) {
	            case 1:
	                justify = 'end';
	                break;
	            case 2:
	                justify = 'middle';
	                break;
	        }
	        tElement.setAttribute('text-anchor',justify);
	        tElement.setAttribute('letter-spacing',trackingOffset);
	        var textContent = this.buildTextContents(documentData.finalText);
	        len = textContent.length;
	        yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
	        for ( i = 0; i < len; i += 1) {
	            tSpan = this.textSpans[i] || createNS('tspan');
	            tSpan.textContent = textContent[i];
	            tSpan.setAttribute('x', 0);
	            tSpan.setAttribute('y', yPos);
	            tSpan.style.display = 'inherit';
	            tElement.appendChild(tSpan);
	            this.textSpans[i] = tSpan;
	            yPos += documentData.finalLineHeight;
	        }
	        
	        this.layerElement.appendChild(tElement);
	    } else {
	        var cachedSpansLength = this.textSpans.length;
	        var shapeData, charData;
	        for (i = 0; i < len; i += 1) {
	            if(!usesGlyphs || !singleShape || i === 0){
	                tSpan = cachedSpansLength > i ? this.textSpans[i] : createNS(usesGlyphs?'path':'text');
	                if (cachedSpansLength <= i) {
	                    tSpan.setAttribute('stroke-linecap', 'butt');
	                    tSpan.setAttribute('stroke-linejoin','round');
	                    tSpan.setAttribute('stroke-miterlimit','4');
	                    this.textSpans[i] = tSpan;
	                    this.layerElement.appendChild(tSpan);
	                }
	                tSpan.style.display = 'inherit';
	            }
	            
	            matrixHelper.reset();
	            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
	            if (singleShape) {
	                if(letters[i].n) {
	                    xPos = -trackingOffset;
	                    yPos += documentData.yOffset;
	                    yPos += firstLine ? 1 : 0;
	                    firstLine = false;
	                }
	                this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	                xPos += letters[i].l || 0;
	                //xPos += letters[i].val === ' ' ? 0 : trackingOffset;
	                xPos += trackingOffset;
	            }
	            if(usesGlyphs) {
	                charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	                shapeData = charData && charData.data || {};
	                shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	                if(!singleShape){
	                    tSpan.setAttribute('d',this.createPathShape(matrixHelper,shapes));
	                } else {
	                    shapeStr += this.createPathShape(matrixHelper,shapes);
	                }
	            } else {
	                if(singleShape) {
	                    tSpan.setAttribute("transform", "translate(" + matrixHelper.props[12] + "," + matrixHelper.props[13] + ")");
	                }
	                tSpan.textContent = letters[i].val;
	                tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            }
	            //
	        }
	        if (singleShape && tSpan) {
	            tSpan.setAttribute('d',shapeStr);
	        }
	    }
	    while (i < this.textSpans.length){
	        this.textSpans[i].style.display = 'none';
	        i += 1;
	    }
	    
	    this._sizeChanged = true;
	};

	SVGTextElement.prototype.sourceRectAtTime = function(time){
	    this.prepareFrame(this.comp.renderedFrame - this.data.st);
	    this.renderInnerContent();
	    if(this._sizeChanged){
	        this._sizeChanged = false;
	        var textBox = this.layerElement.getBBox();
	        this.bbox = {
	            top: textBox.y,
	            left: textBox.x,
	            width: textBox.width,
	            height: textBox.height
	        };
	    }
	    return this.bbox;
	};

	SVGTextElement.prototype.renderInnerContent = function(){

	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	        if(this.lettersChangedFlag || this.textAnimator.lettersChangedFlag){
	            this._sizeChanged = true;
	            var  i,len;
	            var renderedLetters = this.textAnimator.renderedLetters;

	            var letters = this.textProperty.currentData.l;

	            len = letters.length;
	            var renderedLetter, textSpan;
	            for(i=0;i<len;i+=1){
	                if(letters[i].n){
	                    continue;
	                }
	                renderedLetter = renderedLetters[i];
	                textSpan = this.textSpans[i];
	                if(renderedLetter._mdf.m) {
	                    textSpan.setAttribute('transform',renderedLetter.m);
	                }
	                if(renderedLetter._mdf.o) {
	                    textSpan.setAttribute('opacity',renderedLetter.o);
	                }
	                if(renderedLetter._mdf.sw){
	                    textSpan.setAttribute('stroke-width',renderedLetter.sw);
	                }
	                if(renderedLetter._mdf.sc){
	                    textSpan.setAttribute('stroke',renderedLetter.sc);
	                }
	                if(renderedLetter._mdf.fc){
	                    textSpan.setAttribute('fill',renderedLetter.fc);
	                }
	            }
	        }
	    }
	};

	function SVGShapeElement(data,globalData,comp){
	    //List of drawable elements
	    this.shapes = [];
	    // Full shape data
	    this.shapesData = data.shapes;
	    //List of styles that will be applied to shapes
	    this.stylesList = [];
	    //List of modifiers that will be applied to shapes
	    this.shapeModifiers = [];
	    //List of items in shape tree
	    this.itemsData = [];
	    //List of items in previous shape tree
	    this.processedElements = [];
	    // List of animated components
	    this.animatedContents = [];
	    this.initElement(data,globalData,comp);
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	    this.prevViewData = [];
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	}

	extendPrototype([BaseElement,TransformElement,SVGBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableDOMElement], SVGShapeElement);

	SVGShapeElement.prototype.initSecondaryElement = function() {
	};

	SVGShapeElement.prototype.identityMatrix = new Matrix();

	SVGShapeElement.prototype.buildExpressionInterface = function(){};

	SVGShapeElement.prototype.createContent = function(){
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	};

	/*
	This method searches for multiple shapes that affect a single element and one of them is animated
	*/
	SVGShapeElement.prototype.filterUniqueShapes = function(){
	    var i, len = this.shapes.length, shape;
	    var j, jLen = this.stylesList.length;
	    var style;
	    var tempShapes = [];
	    var areAnimated = false;
	    for(j = 0; j < jLen; j += 1) {
	        style = this.stylesList[j];
	        areAnimated = false;
	        tempShapes.length = 0;
	        for(i = 0; i < len; i += 1) {
	            shape = this.shapes[i];
	            if(shape.styles.indexOf(style) !== -1) {
	                tempShapes.push(shape);
	                areAnimated = shape._isAnimated || areAnimated;
	            }
	        }
	        if(tempShapes.length > 1 && areAnimated) {
	            this.setShapesAsAnimated(tempShapes);
	        }
	    }
	};

	SVGShapeElement.prototype.setShapesAsAnimated = function(shapes){
	    var i, len = shapes.length;
	    for(i = 0; i < len; i += 1) {
	        shapes[i].setAsAnimated();
	    }
	};

	SVGShapeElement.prototype.createStyleElement = function(data, level){
	    //TODO: prevent drawing of hidden styles
	    var elementData;
	    var styleOb = new SVGStyleData(data, level);

	    var pathElement = styleOb.pElem;
	    if(data.ty === 'st') {
	        elementData = new SVGStrokeStyleData(this, data, styleOb);
	    } else if(data.ty === 'fl') {
	        elementData = new SVGFillStyleData(this, data, styleOb);
	    } else if(data.ty === 'gf' || data.ty === 'gs') {
	        var gradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
	        elementData = new gradientConstructor(this, data, styleOb);
	        this.globalData.defs.appendChild(elementData.gf);
	        if (elementData.maskId) {
	            this.globalData.defs.appendChild(elementData.ms);
	            this.globalData.defs.appendChild(elementData.of);
	            pathElement.setAttribute('mask','url(' + locationHref + '#' + elementData.maskId + ')');
	        }
	    }
	    
	    if(data.ty === 'st' || data.ty === 'gs') {
	        pathElement.setAttribute('stroke-linecap', this.lcEnum[data.lc] || 'round');
	        pathElement.setAttribute('stroke-linejoin',this.ljEnum[data.lj] || 'round');
	        pathElement.setAttribute('fill-opacity','0');
	        if(data.lj === 1) {
	            pathElement.setAttribute('stroke-miterlimit',data.ml);
	        }
	    }

	    if(data.r === 2) {
	        pathElement.setAttribute('fill-rule', 'evenodd');
	    }

	    if(data.ln){
	        pathElement.setAttribute('id',data.ln);
	    }
	    if(data.cl){
	        pathElement.setAttribute('class',data.cl);
	    }
	    if(data.bm){
	        pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }
	    this.stylesList.push(styleOb);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};

	SVGShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = new ShapeGroupData();
	    if(data.ln){
	        elementData.gr.setAttribute('id',data.ln);
	    }
	    if(data.cl){
	        elementData.gr.setAttribute('class',data.cl);
	    }
	    if(data.bm){
	        elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }
	    return elementData;
	};

	SVGShapeElement.prototype.createTransformElement = function(data, container) {
	    var transformProperty = TransformPropertyFactory.getTransformProperty(this,data,this);
	    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};

	SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
	    var ty = 4;
	    if(data.ty === 'rc'){
	        ty = 5;
	    }else if(data.ty === 'el'){
	        ty = 6;
	    }else if(data.ty === 'sr'){
	        ty = 7;
	    }
	    var shapeProperty = ShapePropertyFactory.getShapeProp(this,data,ty,this);
	    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};

	SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
	    var i = 0, len = this.animatedContents.length;
	    while(i < len) {
	        if(this.animatedContents[i].element === element) {
	            return;
	        }
	        i += 1;
	    }
	    this.animatedContents.push({
	        fn: SVGElementsRenderer.createRenderFunction(data),
	        element: element,
	        data: data
	    });
	};

	SVGShapeElement.prototype.setElementStyles = function(elementData){
	    var arr = elementData.styles;
	    var j, jLen = this.stylesList.length;
	    for (j = 0; j < jLen; j += 1) {
	        if (!this.stylesList[j].closed) {
	            arr.push(this.stylesList[j]);
	        }
	    }
	};

	SVGShapeElement.prototype.reloadShapes = function(){
	    this._isFirstFrame = true;
	    var i, len = this.itemsData.length;
	    for( i = 0; i < len; i += 1) {
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	    len = this.dynamicProperties.length;
	    for(i = 0; i < len; i += 1) {
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	};

	SVGShapeElement.prototype.searchShapes = function(arr,itemsData,prevViewData,container, level, transformers, render){
	    var ownTransformers = [].concat(transformers);
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownStyles = [], ownModifiers = [], currentTransform, modifier, processedPos;
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._render = render;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st' || arr[i].ty == 'gf' || arr[i].ty == 'gs'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], level);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].style.pElem);
	            }
	            ownStyles.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,itemsData[i].gr, level + 1, ownTransformers, render);
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].gr);
	            }
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                itemsData[i] = this.createTransformElement(arr[i], container);
	            }
	            currentTransform = itemsData[i].transform;
	            ownTransformers.push(currentTransform);
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
	            }
	            this.setElementStyles(itemsData[i]);

	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'ms'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i]);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        }else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData);
	                this.shapeModifiers.push(modifier);
	                render = false;
	            }else {
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    len = ownStyles.length;
	    for(i=0;i<len;i+=1){
	        ownStyles[i].closed = true;
	    }
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};

	SVGShapeElement.prototype.renderInnerContent = function() {
	    this.renderModifiers();
	    var i, len = this.stylesList.length;
	    for(i=0;i<len;i+=1){
	        this.stylesList[i].reset();
	    }
	    this.renderShape();

	    for (i = 0; i < len; i += 1) {
	        if (this.stylesList[i]._mdf || this._isFirstFrame) {
	            if(this.stylesList[i].msElem){
	                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
	                //Adding M0 0 fixes same mask bug on all browsers
	                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
	            }
	            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
	        }
	    }
	};

	SVGShapeElement.prototype.renderShape = function() {
	    var i, len = this.animatedContents.length;
	    var animatedContent;
	    for(i = 0; i < len; i += 1) {
	        animatedContent = this.animatedContents[i];
	        if((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
	            animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
	        }
	    }
	};

	SVGShapeElement.prototype.destroy = function(){
	    this.destroyBaseElement();
	    this.shapesData = null;
	    this.itemsData = null;
	};

	function SVGTintFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f2');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	    if(filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k){
	        var feMerge = createNS('feMerge');
	        filter.appendChild(feMerge);
	        var feMergeNode;
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','SourceGraphic');
	        feMerge.appendChild(feMergeNode);
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','f2');
	        feMerge.appendChild(feMergeNode);
	    }
	}

	SVGTintFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var colorBlack = this.filterManager.effectElements[0].p.v;
	        var colorWhite = this.filterManager.effectElements[1].p.v;
	        var opacity = this.filterManager.effectElements[2].p.v/100;
	        this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGFillFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	}
	SVGFillFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var color = this.filterManager.effectElements[2].p.v;
	        var opacity = this.filterManager.effectElements[6].p.v;
	        this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');
	    }
	};
	function SVGGaussianBlurEffect(filter, filterManager){
	    // Outset the filter region by 100% on all sides to accommodate blur expansion.
	    filter.setAttribute('x','-100%');
	    filter.setAttribute('y','-100%');
	    filter.setAttribute('width','300%');
	    filter.setAttribute('height','300%');

	    this.filterManager = filterManager;
	    var feGaussianBlur = createNS('feGaussianBlur');
	    filter.appendChild(feGaussianBlur);
	    this.feGaussianBlur = feGaussianBlur;
	}

	SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        // Empirical value, matching AE's blur appearance.
	        var kBlurrinessToSigma = 0.3;
	        var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma;

	        // Dimensions mapping:
	        //
	        //   1 -> horizontal & vertical
	        //   2 -> horizontal only
	        //   3 -> vertical only
	        //
	        var dimensions = this.filterManager.effectElements[1].p.v;
	        var sigmaX = (dimensions == 3) ? 0 : sigma;
	        var sigmaY = (dimensions == 2) ? 0 : sigma;

	        this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + " " + sigmaY);

	        // Repeat edges mapping:
	        //
	        //   0 -> off -> duplicate
	        //   1 -> on  -> wrap
	        var edgeMode = (this.filterManager.effectElements[2].p.v == 1) ? 'wrap' : 'duplicate';
	        this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
	    }
	};
	function SVGStrokeEffect(elem, filterManager){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.elem = elem;
	    this.paths = [];
	}

	SVGStrokeEffect.prototype.initialize = function(){

	    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	    var path,groupPath, i, len;
	    if(this.filterManager.effectElements[1].p.v === 1){
	        len = this.elem.maskManager.masksProperties.length;
	        i = 0;
	    } else {
	        i = this.filterManager.effectElements[0].p.v - 1;
	        len = i + 1;
	    }
	    groupPath = createNS('g'); 
	    groupPath.setAttribute('fill','none');
	    groupPath.setAttribute('stroke-linecap','round');
	    groupPath.setAttribute('stroke-dashoffset',1);
	    for(i;i<len;i+=1){
	        path = createNS('path');
	        groupPath.appendChild(path);
	        this.paths.push({p:path,m:i});
	    }
	    if(this.filterManager.effectElements[10].p.v === 3){
	        var mask = createNS('mask');
	        var id = createElementID();
	        mask.setAttribute('id',id);
	        mask.setAttribute('mask-type','alpha');
	        mask.appendChild(groupPath);
	        this.elem.globalData.defs.appendChild(mask);
	        var g = createNS('g');
	        g.setAttribute('mask','url(' + locationHref + '#'+id+')');
	        while (elemChildren[0]) {
	            g.appendChild(elemChildren[0]);
	        }
	        this.elem.layerElement.appendChild(g);
	        this.masker = mask;
	        groupPath.setAttribute('stroke','#fff');
	    } else if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(this.filterManager.effectElements[10].p.v === 2){
	            elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	            while(elemChildren.length){
	                this.elem.layerElement.removeChild(elemChildren[0]);
	            }
	        }
	        this.elem.layerElement.appendChild(groupPath);
	        this.elem.layerElement.removeAttribute('mask');
	        groupPath.setAttribute('stroke','#fff');
	    }
	    this.initialized = true;
	    this.pathMasker = groupPath;
	};

	SVGStrokeEffect.prototype.renderFrame = function(forceRender){
	    if(!this.initialized){
	        this.initialize();
	    }
	    var i, len = this.paths.length;
	    var mask, path;
	    for(i=0;i<len;i+=1){
	        if(this.paths[i].m === -1) {
	            continue;
	        }
	        mask = this.elem.maskManager.viewData[this.paths[i].m];
	        path = this.paths[i].p;
	        if(forceRender || this.filterManager._mdf || mask.prop._mdf){
	            path.setAttribute('d',mask.lastPath);
	        }
	        if(forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf){
	            var dasharrayValue;
	            if(this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100){
	                var s = Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var e = Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var l = path.getTotalLength();
	                dasharrayValue = '0 0 0 ' + l*s + ' ';
	                var lineLength = l*(e-s);
	                var segment = 1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	                var units = Math.floor(lineLength/segment);
	                var j;
	                for(j=0;j<units;j+=1){
	                    dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100 + ' ';
	                }
	                dasharrayValue += '0 ' + l*10 + ' 0 0';
	            } else {
	                dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	            }
	            path.setAttribute('stroke-dasharray',dasharrayValue);
	        }
	    }
	    if(forceRender || this.filterManager.effectElements[4].p._mdf){
	        this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);
	    }
	    
	    if(forceRender || this.filterManager.effectElements[6].p._mdf){
	        this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);
	    }
	    if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(forceRender || this.filterManager.effectElements[3].p._mdf){
	            var color = this.filterManager.effectElements[3].p.v;
	            this.pathMasker.setAttribute('stroke','rgb('+bm_floor(color[0]*255)+','+bm_floor(color[1]*255)+','+bm_floor(color[2]*255)+')');
	        }
	    }
	};
	function SVGTritoneFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    var feComponentTransfer = createNS('feComponentTransfer');
	    feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	    filter.appendChild(feComponentTransfer);
	    this.matrixFilter = feComponentTransfer;
	    var feFuncR = createNS('feFuncR');
	    feFuncR.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncR);
	    this.feFuncR = feFuncR;
	    var feFuncG = createNS('feFuncG');
	    feFuncG.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncG);
	    this.feFuncG = feFuncG;
	    var feFuncB = createNS('feFuncB');
	    feFuncB.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncB);
	    this.feFuncB = feFuncB;
	}

	SVGTritoneFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var color1 = this.filterManager.effectElements[0].p.v;
	        var color2 = this.filterManager.effectElements[1].p.v;
	        var color3 = this.filterManager.effectElements[2].p.v;
	        var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
	        var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
	        var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
	        this.feFuncR.setAttribute('tableValues', tableR);
	        this.feFuncG.setAttribute('tableValues', tableG);
	        this.feFuncB.setAttribute('tableValues', tableB);
	        //var opacity = this.filterManager.effectElements[2].p.v/100;
	        //this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGProLevelsFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var effectElements = this.filterManager.effectElements;
	    var feComponentTransfer = createNS('feComponentTransfer');
	    
	    if(effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1){
	        this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
	    }
	    if(effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1){
	        this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
	    }
	    if(effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1){
	        this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	    if(effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1){
	        this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
	    }
	    
	    if(this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA){
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        feComponentTransfer = createNS('feComponentTransfer');
	    }

	    if(effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1){

	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
	        this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
	        this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	}

	SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
	    var feFunc = createNS(type);
	    feFunc.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFunc);
	    return feFunc;
	};

	SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
	    var cnt = 0;
	    var segments = 256;
	    var perc;
	    var min = Math.min(inputBlack, inputWhite);
	    var max = Math.max(inputBlack, inputWhite);
	    var table = Array.call(null,{length:segments});
	    var colorValue;
	    var pos = 0;
	    var outputDelta = outputWhite - outputBlack; 
	    var inputDelta = inputWhite - inputBlack; 
	    while(cnt <= 256) {
	        perc = cnt/256;
	        if(perc <= min){
	            colorValue = inputDelta < 0 ? outputWhite : outputBlack;
	        } else if(perc >= max){
	            colorValue = inputDelta < 0 ? outputBlack : outputWhite;
	        } else {
	            colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
	        }
	        table[pos++] = colorValue;
	        cnt += 256/(segments-1);
	    }
	    return table.join(' ');
	};

	SVGProLevelsFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var val;
	        var effectElements = this.filterManager.effectElements;
	        if(this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)){
	            val = this.getTableValue(effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v,effectElements[7].p.v);
	            this.feFuncRComposed.setAttribute('tableValues',val);
	            this.feFuncGComposed.setAttribute('tableValues',val);
	            this.feFuncBComposed.setAttribute('tableValues',val);
	        }


	        if(this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)){
	            val = this.getTableValue(effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v,effectElements[14].p.v);
	            this.feFuncR.setAttribute('tableValues',val);
	        }

	        if(this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)){
	            val = this.getTableValue(effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v,effectElements[21].p.v);
	            this.feFuncG.setAttribute('tableValues',val);
	        }

	        if(this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)){
	            val = this.getTableValue(effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v,effectElements[28].p.v);
	            this.feFuncB.setAttribute('tableValues',val);
	        }

	        if(this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)){
	            val = this.getTableValue(effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v,effectElements[35].p.v);
	            this.feFuncA.setAttribute('tableValues',val);
	        }
	        
	    }
	};
	function SVGDropShadowEffect(filter, filterManager) {
	    var filterSize = filterManager.container.globalData.renderConfig.filterSize;
	    filter.setAttribute('x', filterSize.x);
	    filter.setAttribute('y', filterSize.y);
	    filter.setAttribute('width', filterSize.width);
	    filter.setAttribute('height', filterSize.height);
	    this.filterManager = filterManager;

	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('in','SourceAlpha');
	    feGaussianBlur.setAttribute('result','drop_shadow_1');
	    feGaussianBlur.setAttribute('stdDeviation','0');
	    this.feGaussianBlur = feGaussianBlur;
	    filter.appendChild(feGaussianBlur);

	    var feOffset = createNS('feOffset');
	    feOffset.setAttribute('dx','25');
	    feOffset.setAttribute('dy','0');
	    feOffset.setAttribute('in','drop_shadow_1');
	    feOffset.setAttribute('result','drop_shadow_2');
	    this.feOffset = feOffset;
	    filter.appendChild(feOffset);
	    var feFlood = createNS('feFlood');
	    feFlood.setAttribute('flood-color','#00ff00');
	    feFlood.setAttribute('flood-opacity','1');
	    feFlood.setAttribute('result','drop_shadow_3');
	    this.feFlood = feFlood;
	    filter.appendChild(feFlood);

	    var feComposite = createNS('feComposite');
	    feComposite.setAttribute('in','drop_shadow_3');
	    feComposite.setAttribute('in2','drop_shadow_2');
	    feComposite.setAttribute('operator','in');
	    feComposite.setAttribute('result','drop_shadow_4');
	    filter.appendChild(feComposite);


	    var feMerge = createNS('feMerge');
	    filter.appendChild(feMerge);
	    var feMergeNode;
	    feMergeNode = createNS('feMergeNode');
	    feMerge.appendChild(feMergeNode);
	    feMergeNode = createNS('feMergeNode');
	    feMergeNode.setAttribute('in','SourceGraphic');
	    this.feMergeNode = feMergeNode;
	    this.feMerge = feMerge;
	    this.originalNodeAdded = false;
	    feMerge.appendChild(feMergeNode);
	}

	SVGDropShadowEffect.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        if(forceRender || this.filterManager.effectElements[4].p._mdf){
	            this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
	        }
	        if(forceRender || this.filterManager.effectElements[0].p._mdf){
	            var col = this.filterManager.effectElements[0].p.v;
	            this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));
	        }
	        if(forceRender || this.filterManager.effectElements[1].p._mdf){
	            this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);
	        }
	        if(forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf){
	            var distance = this.filterManager.effectElements[3].p.v;
	            var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
	            var x = distance * Math.cos(angle);
	            var y = distance * Math.sin(angle);
	            this.feOffset.setAttribute('dx', x);
	            this.feOffset.setAttribute('dy', y);
	        }
	        /*if(forceRender || this.filterManager.effectElements[5].p._mdf){
	            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
	                this.feMerge.removeChild(this.feMergeNode);
	                this.originalNodeAdded = false;
	            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
	                this.feMerge.appendChild(this.feMergeNode);
	                this.originalNodeAdded = true;
	            }
	        }*/
	    }
	};
	var _svgMatteSymbols = [];

	function SVGMatte3Effect(filterElem, filterManager, elem){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.filterElem = filterElem;
	    this.elem = elem;
	    elem.matteElement = createNS('g');
	    elem.matteElement.appendChild(elem.layerElement);
	    elem.matteElement.appendChild(elem.transformedElement);
	    elem.baseElement = elem.matteElement;
	}

	SVGMatte3Effect.prototype.findSymbol = function(mask) {
	    var i = 0, len = _svgMatteSymbols.length;
	    while(i < len) {
	        if(_svgMatteSymbols[i] === mask) {
	            return _svgMatteSymbols[i];
	        }
	        i += 1;
	    }
	    return null;
	};

	SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
	    var parentNode = mask.layerElement.parentNode;
	    if(!parentNode) {
	        return;
	    }
	    var children = parentNode.children;
	    var i = 0, len = children.length;
	    while (i < len) {
	        if (children[i] === mask.layerElement) {
	            break;
	        }
	        i += 1;
	    }
	    var nextChild;
	    if (i <= len - 2) {
	        nextChild = children[i + 1];
	    }
	    var useElem = createNS('use');
	    useElem.setAttribute('href', '#' + symbolId);
	    if(nextChild) {
	        parentNode.insertBefore(useElem, nextChild);
	    } else {
	        parentNode.appendChild(useElem);
	    }
	};

	SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
	    if(!this.findSymbol(mask)) {
	        var symbolId = createElementID();
	        var masker = createNS('mask');
	        masker.setAttribute('id', mask.layerId);
	        masker.setAttribute('mask-type', 'alpha');
	        _svgMatteSymbols.push(mask);
	        var defs = elem.globalData.defs;
	        defs.appendChild(masker);
	        var symbol = createNS('symbol');
	        symbol.setAttribute('id', symbolId);
	        this.replaceInParent(mask, symbolId);
	        symbol.appendChild(mask.layerElement);
	        defs.appendChild(symbol);
	        var useElem = createNS('use');
	        useElem.setAttribute('href', '#' + symbolId);
	        masker.appendChild(useElem);
	        mask.data.hd = false;
	        mask.show();
	    }
	    elem.setMatte(mask.layerId);
	};

	SVGMatte3Effect.prototype.initialize = function() {
	    var ind = this.filterManager.effectElements[0].p.v;
	    var elements = this.elem.comp.elements;
	    var i = 0, len = elements.length;
	    while (i < len) {
	    	if (elements[i] && elements[i].data.ind === ind) {
	    		this.setElementAsMask(this.elem, elements[i]);
	    	}
	    	i += 1;
	    }
	    this.initialized = true;
	};

	SVGMatte3Effect.prototype.renderFrame = function() {
		if(!this.initialized) {
			this.initialize();
		}
	};
	function SVGEffects(elem){
	    var i, len = elem.data.ef ? elem.data.ef.length : 0;
	    var filId = createElementID();
	    var fil = filtersFactory.createFilter(filId);
	    var count = 0;
	    this.filters = [];
	    var filterManager;
	    for(i=0;i<len;i+=1){
	        filterManager = null;
	        if(elem.data.ef[i].ty === 20){
	            count += 1;
	            filterManager = new SVGTintFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 21){
	            count += 1;
	            filterManager = new SVGFillFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 22){
	            filterManager = new SVGStrokeEffect(elem, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 23){
	            count += 1;
	            filterManager = new SVGTritoneFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 24){
	            count += 1;
	            filterManager = new SVGProLevelsFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 25){
	            count += 1;
	            filterManager = new SVGDropShadowEffect(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 28){
	            //count += 1;
	            filterManager = new SVGMatte3Effect(fil, elem.effectsManager.effectElements[i], elem);
	        }else if(elem.data.ef[i].ty === 29){
	            count += 1;
	            filterManager = new SVGGaussianBlurEffect(fil, elem.effectsManager.effectElements[i]);
	        }
	        if(filterManager) {
	            this.filters.push(filterManager);
	        }
	    }
	    if(count){
	        elem.globalData.defs.appendChild(fil);
	        elem.layerElement.setAttribute('filter','url(' + locationHref + '#'+filId+')');
	    }
	    if (this.filters.length) {
	        elem.addRenderableComponent(this);
	    }
	}

	SVGEffects.prototype.renderFrame = function(_isFirstFrame){
	    var i, len = this.filters.length;
	    for(i=0;i<len;i+=1){
	        this.filters[i].renderFrame(_isFirstFrame);
	    }
	};
	function CVContextData() {
		this.saved = [];
	    this.cArrPos = 0;
	    this.cTr = new Matrix();
	    this.cO = 1;
	    var i, len = 15;
	    this.savedOp = createTypedArray('float32', len);
	    for(i=0;i<len;i+=1){
	        this.saved[i] = createTypedArray('float32', 16);
	    }
	    this._length = len;
	}

	CVContextData.prototype.duplicate = function() {
		var newLength = this._length * 2;
		var currentSavedOp = this.savedOp;
	    this.savedOp = createTypedArray('float32', newLength);
	    this.savedOp.set(currentSavedOp);
	    var i = 0;
	    for(i = this._length; i < newLength; i += 1) {
	        this.saved[i] = createTypedArray('float32', 16);
	    }
	    this._length = newLength;
	};

	CVContextData.prototype.reset = function() {
		this.cArrPos = 0;
		this.cTr.reset();
	    this.cO = 1;
	};
	function CVBaseElement(){
	}

	CVBaseElement.prototype = {
	    createElements: function(){},
	    initRendererElement: function(){},
	    createContainerElements: function(){
	        this.canvasContext = this.globalData.canvasContext;
	        this.renderableEffectsManager = new CVEffects();
	    },
	    createContent: function(){},
	    setBlendMode: function(){
	        var globalData = this.globalData;
	        if(globalData.blendMode !== this.data.bm) {
	            globalData.blendMode = this.data.bm;
	            var blendModeValue = getBlendMode(this.data.bm);
	            globalData.canvasContext.globalCompositeOperation = blendModeValue;
	        }
	    },
	    createRenderableComponents: function(){
	        this.maskManager = new CVMaskElement(this.data, this);
	    },
	    hideElement: function(){
	        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	            this.hidden = true;
	        }
	    },
	    showElement: function(){
	        if (this.isInRange && !this.isTransparent){
	            this.hidden = false;
	            this._isFirstFrame = true;
	            this.maskManager._isFirstFrame = true;
	        }
	    },
	    renderFrame: function() {
	        if (this.hidden || this.data.hd) {
	            return;
	        }
	        this.renderTransform();
	        this.renderRenderable();
	        this.setBlendMode();
	        var forceRealStack = this.data.ty === 0;
	        this.globalData.renderer.save(forceRealStack);
	        this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
	        this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v);
	        this.renderInnerContent();
	        this.globalData.renderer.restore(forceRealStack);
	        if(this.maskManager.hasMasks) {
	            this.globalData.renderer.restore(true);
	        }
	        if (this._isFirstFrame) {
	            this._isFirstFrame = false;
	        }
	    },
	    destroy: function(){
	        this.canvasContext = null;
	        this.data = null;
	        this.globalData = null;
	        this.maskManager.destroy();
	    },
	    mHelper: new Matrix()
	};
	CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
	CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;

	function CVImageElement(data, globalData, comp){
	    this.assetData = globalData.getAssetData(data.refId);
	    this.img = globalData.imageLoader.getImage(this.assetData);
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);

	CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

	CVImageElement.prototype.createContent = function(){

	    if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
	        var canvas = createTag('canvas');
	        canvas.width = this.assetData.w;
	        canvas.height = this.assetData.h;
	        var ctx = canvas.getContext('2d');

	        var imgW = this.img.width;
	        var imgH = this.img.height;
	        var imgRel = imgW / imgH;
	        var canvasRel = this.assetData.w/this.assetData.h;
	        var widthCrop, heightCrop;
	        var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
	        if((imgRel > canvasRel && par === 'xMidYMid slice') || (imgRel < canvasRel && par !== 'xMidYMid slice')) {
	            heightCrop = imgH;
	            widthCrop = heightCrop*canvasRel;
	        } else {
	            widthCrop = imgW;
	            heightCrop = widthCrop/canvasRel;
	        }
	        ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);
	        this.img = canvas;
	    }

	};

	CVImageElement.prototype.renderInnerContent = function(parentMatrix){
	    this.canvasContext.drawImage(this.img, 0, 0);
	};

	CVImageElement.prototype.destroy = function(){
	    this.img = null;
	};
	function CVCompElement(data, globalData, comp) {
	    this.completeLayers = false;
	    this.layers = data.layers;
	    this.pendingElements = [];
	    this.elements = createSizedArray(this.layers.length);
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate, this) : {_placeholder:true};
	}

	extendPrototype([CanvasRenderer, ICompElement, CVBaseElement], CVCompElement);

	CVCompElement.prototype.renderInnerContent = function() {
	    var ctx = this.canvasContext;
	    ctx.beginPath();
	    ctx.moveTo(0, 0);
	    ctx.lineTo(this.data.w, 0);
	    ctx.lineTo(this.data.w, this.data.h);
	    ctx.lineTo(0, this.data.h);
	    ctx.lineTo(0, 0);
	    ctx.clip();
	    var i,len = this.layers.length;
	    for( i = len - 1; i >= 0; i -= 1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	};

	CVCompElement.prototype.destroy = function(){
	    var i,len = this.layers.length;
	    for( i = len - 1; i >= 0; i -= 1 ){
	        if(this.elements[i]) {
	            this.elements[i].destroy();
	        }
	    }
	    this.layers = null;
	    this.elements = null;
	};

	function CVMaskElement(data,element){
	    this.data = data;
	    this.element = element;
	    this.masksProperties = this.data.masksProperties || [];
	    this.viewData = createSizedArray(this.masksProperties.length);
	    var i, len = this.masksProperties.length, hasMasks = false;
	    for (i = 0; i < len; i++) {
	        if(this.masksProperties[i].mode !== 'n'){
	            hasMasks = true;
	        }
	        this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3);
	    }
	    this.hasMasks = hasMasks;
	    if(hasMasks) {
	        this.element.addRenderableComponent(this);
	    }
	}

	CVMaskElement.prototype.renderFrame = function () {
	    if(!this.hasMasks){
	        return;
	    }
	    var transform = this.element.finalTransform.mat;
	    var ctx = this.element.canvasContext;
	    var i, len = this.masksProperties.length;
	    var pt,pts,data;
	    ctx.beginPath();
	    for (i = 0; i < len; i++) {
	        if(this.masksProperties[i].mode !== 'n'){
	            if (this.masksProperties[i].inv) {
	                ctx.moveTo(0, 0);
	                ctx.lineTo(this.element.globalData.compSize.w, 0);
	                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
	                ctx.lineTo(0, this.element.globalData.compSize.h);
	                ctx.lineTo(0, 0);
	            }
	            data = this.viewData[i].v;
	            pt = transform.applyToPointArray(data.v[0][0],data.v[0][1],0);
	            ctx.moveTo(pt[0], pt[1]);
	            var j, jLen = data._length;
	            for (j = 1; j < jLen; j++) {
	                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
	                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	            }
	            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
	            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	        }
	    }
	    this.element.globalData.renderer.save(true);
	    ctx.clip();
	};

	CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;

	CVMaskElement.prototype.destroy = function(){
	    this.element = null;
	};
	function CVShapeElement(data, globalData, comp) {
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this.transformsManager = new ShapeTransformManager();
	    this.initElement(data, globalData, comp);
	}

	extendPrototype([BaseElement,TransformElement,CVBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableElement], CVShapeElement);

	CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;

	CVShapeElement.prototype.transformHelper = {opacity:1,_opMdf:false};

	CVShapeElement.prototype.dashResetter = [];

	CVShapeElement.prototype.createContent = function(){
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData, true, []);
	};

	CVShapeElement.prototype.createStyleElement = function(data, transforms) {
	    var styleElem = {
	        data: data,
	        type: data.ty,
	        preTransforms: this.transformsManager.addTransformSequence(transforms),
	        transforms: [],
	        elements: [],
	        closed: data.hd === true
	    };
	    var elementData = {};
	    if(data.ty == 'fl' || data.ty == 'st'){
	        elementData.c = PropertyFactory.getProp(this,data.c,1,255,this);
	        if(!elementData.c.k){
	            styleElem.co = 'rgb('+bm_floor(elementData.c.v[0])+','+bm_floor(elementData.c.v[1])+','+bm_floor(elementData.c.v[2])+')';
	        }
	    } else if (data.ty === 'gf' || data.ty === 'gs') {
	        elementData.s = PropertyFactory.getProp(this,data.s,1,null,this);
	        elementData.e = PropertyFactory.getProp(this,data.e,1,null,this);
	        elementData.h = PropertyFactory.getProp(this,data.h||{k:0},0,0.01,this);
	        elementData.a = PropertyFactory.getProp(this,data.a||{k:0},0,degToRads,this);
	        elementData.g = new GradientProperty(this,data.g,this);
	    }
	    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,this);
	    if(data.ty == 'st' || data.ty == 'gs') {
	        styleElem.lc = this.lcEnum[data.lc] || 'round';
	        styleElem.lj = this.ljEnum[data.lj] || 'round';
	        if(data.lj == 1) {
	            styleElem.ml = data.ml;
	        }
	        elementData.w = PropertyFactory.getProp(this,data.w,0,null,this);
	        if(!elementData.w.k){
	            styleElem.wi = elementData.w.v;
	        }
	        if(data.d){
	            var d = new DashProperty(this,data.d,'canvas', this);
	            elementData.d = d;
	            if(!elementData.d.k){
	                styleElem.da = elementData.d.dashArray;
	                styleElem.do = elementData.d.dashoffset[0];
	            }
	        }
	    } else {
	        styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
	    }
	    this.stylesList.push(styleElem);
	    elementData.style = styleElem;
	    return elementData;
	};

	CVShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = {
	        it: [],
	        prevViewData: []
	    };
	    return elementData;
	};

	CVShapeElement.prototype.createTransformElement = function(data) {
	    var elementData = {
	        transform : {
	            opacity: 1,
	            _opMdf:false,
	            key: this.transformsManager.getNewKey(),
	            op: PropertyFactory.getProp(this,data.o,0,0.01,this),
	            mProps: TransformPropertyFactory.getTransformProperty(this,data,this)
	        }
	    };
	    return elementData;
	};

	CVShapeElement.prototype.createShapeElement = function(data) {
	    var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
	    
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    return elementData;
	};

	CVShapeElement.prototype.reloadShapes = function() {
	    this._isFirstFrame = true;
	    var i, len = this.itemsData.length;
	    for (i = 0; i < len; i += 1) {
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData, true, []);
	    len = this.dynamicProperties.length;
	    for (i = 0; i < len; i += 1) {
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	};

	CVShapeElement.prototype.addTransformToStyleList = function(transform) {
	    var i, len = this.stylesList.length;
	    for (i = 0; i < len; i += 1) {
	        if(!this.stylesList[i].closed) {
	            this.stylesList[i].transforms.push(transform);
	        }
	    }
	};

	CVShapeElement.prototype.removeTransformFromStyleList = function() {
	    var i, len = this.stylesList.length;
	    for (i = 0; i < len; i += 1) {
	        if(!this.stylesList[i].closed) {
	            this.stylesList[i].transforms.pop();
	        }
	    }
	};

	CVShapeElement.prototype.closeStyles = function(styles) {
	    var i, len = styles.length;
	    for (i = 0; i < len; i += 1) {
	        styles[i].closed = true;
	    }
	};

	CVShapeElement.prototype.searchShapes = function(arr,itemsData, prevViewData, shouldRender, transforms){
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownStyles = [], ownModifiers = [], processedPos, modifier, currentTransform;
	    var ownTransforms = [].concat(transforms);
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._shouldRender = shouldRender;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st'|| arr[i].ty == 'gf'|| arr[i].ty == 'gs'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            
	            ownStyles.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData, shouldRender, ownTransforms);
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                currentTransform = this.createTransformElement(arr[i]);
	                itemsData[i] = currentTransform;
	            }
	            ownTransforms.push(itemsData[i]);
	            this.addTransformToStyleList(itemsData[i]);
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i]);
	            }
	            
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i]);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        } else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData);
	                this.shapeModifiers.push(modifier);
	                shouldRender = false;
	            }else {
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    this.removeTransformFromStyleList();
	    this.closeStyles(ownStyles);
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};

	CVShapeElement.prototype.renderInnerContent = function() {
	    this.transformHelper.opacity = 1;
	    this.transformHelper._opMdf = false;
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	    this.renderShape(this.transformHelper,this.shapesData,this.itemsData,true);
	};

	CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
	    if(parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
	        groupTransform.opacity = parentTransform.opacity;
	        groupTransform.opacity *= groupTransform.op.v;
	        groupTransform._opMdf = true;
	    }
	};

	CVShapeElement.prototype.drawLayer = function() {
	    var i, len = this.stylesList.length;
	    var j, jLen, k, kLen,elems,nodes, renderer = this.globalData.renderer, ctx = this.globalData.canvasContext, type, currentStyle;
	    for(i=0;i<len;i+=1){
	        currentStyle = this.stylesList[i];
	        type = currentStyle.type;

	        //Skipping style when
	        //Stroke width equals 0
	        //style should not be rendered (extra unused repeaters)
	        //current opacity equals 0
	        //global opacity equals 0
	        if(((type === 'st' || type === 'gs') && currentStyle.wi === 0) || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0){
	            continue;
	        }
	        renderer.save();
	        elems = currentStyle.elements;
	        if(type === 'st' || type === 'gs'){
	            ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
	            ctx.lineWidth = currentStyle.wi;
	            ctx.lineCap = currentStyle.lc;
	            ctx.lineJoin = currentStyle.lj;
	            ctx.miterLimit = currentStyle.ml || 0;
	        } else {
	            ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
	        }
	        renderer.ctxOpacity(currentStyle.coOp);
	        if(type !== 'st' && type !== 'gs'){
	            ctx.beginPath();
	        }
	        renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
	        jLen = elems.length;
	        for(j=0;j<jLen;j+=1){
	            if(type === 'st' || type === 'gs'){
	                ctx.beginPath();
	                if(currentStyle.da){
	                    ctx.setLineDash(currentStyle.da);
	                    ctx.lineDashOffset = currentStyle.do;
	                }
	            }
	            nodes = elems[j].trNodes;
	            kLen = nodes.length;

	            for(k=0;k<kLen;k+=1){
	                if(nodes[k].t == 'm'){
	                    ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);
	                }else if(nodes[k].t == 'c'){
	                    ctx.bezierCurveTo(nodes[k].pts[0],nodes[k].pts[1],nodes[k].pts[2],nodes[k].pts[3],nodes[k].pts[4],nodes[k].pts[5]);
	                }else {
	                    ctx.closePath();
	                }
	            }
	            if(type === 'st' || type === 'gs'){
	                ctx.stroke();
	                if(currentStyle.da){
	                    ctx.setLineDash(this.dashResetter);
	                }
	            }
	        }
	        if(type !== 'st' && type !== 'gs'){
	            ctx.fill(currentStyle.r);
	        }
	        renderer.restore();
	    }
	};

	CVShapeElement.prototype.renderShape = function(parentTransform,items,data,isMain){
	    var i, len = items.length - 1;
	    var groupTransform;
	    groupTransform = parentTransform;
	    for(i=len;i>=0;i-=1){
	        if(items[i].ty == 'tr'){
	            groupTransform = data[i].transform;
	            this.renderShapeTransform(parentTransform, groupTransform);
	        }else if(items[i].ty == 'sh' || items[i].ty == 'el' || items[i].ty == 'rc' || items[i].ty == 'sr'){
	            this.renderPath(items[i],data[i]);
	        }else if(items[i].ty == 'fl'){
	            this.renderFill(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'st'){
	            this.renderStroke(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'gf' || items[i].ty == 'gs'){
	            this.renderGradientFill(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'gr'){
	            this.renderShape(groupTransform,items[i].it,data[i].it);
	        }else if(items[i].ty == 'tm');
	    }
	    if(isMain){
	        this.drawLayer();
	    }
	    
	};

	CVShapeElement.prototype.renderStyledShape = function(styledShape, shape){
	    if(this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
	        var shapeNodes = styledShape.trNodes;
	        var paths = shape.paths;
	        var i, len, j, jLen = paths._length;
	        shapeNodes.length = 0;
	        var groupTransformMat = styledShape.transforms.finalTransform;
	        for (j = 0; j < jLen; j += 1) {
	            var pathNodes = paths.shapes[j];
	            if(pathNodes && pathNodes.v){
	                len = pathNodes._length;
	                for (i = 1; i < len; i += 1) {
	                    if (i === 1) {
	                        shapeNodes.push({
	                            t: 'm',
	                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                        });
	                    }
	                    shapeNodes.push({
	                        t: 'c',
	                        pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
	                    });
	                }
	                if (len === 1) {
	                    shapeNodes.push({
	                        t: 'm',
	                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                    });
	                }
	                if (pathNodes.c && len) {
	                    shapeNodes.push({
	                        t: 'c',
	                        pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
	                    });
	                    shapeNodes.push({
	                        t: 'z'
	                    });
	                }
	            }
	        }
	        styledShape.trNodes = shapeNodes;
	    }
	};

	CVShapeElement.prototype.renderPath = function(pathData,itemData){
	    if(pathData.hd !== true && pathData._shouldRender) {
	        var i, len = itemData.styledShapes.length;
	        for (i = 0; i < len; i += 1) {
	            this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
	        }
	    }
	};

	CVShapeElement.prototype.renderFill = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;

	    if (itemData.c._mdf || this._isFirstFrame) {
	        styleElem.co = 'rgb(' 
	        + bm_floor(itemData.c.v[0]) + ',' 
	        + bm_floor(itemData.c.v[1]) + ',' 
	        + bm_floor(itemData.c.v[2]) + ')';
	    }
	    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
	        styleElem.coOp = itemData.o.v * groupTransform.opacity;
	    }
	};

	CVShapeElement.prototype.renderGradientFill = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	    if(!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || (styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf))) {
	        var ctx = this.globalData.canvasContext;
	        var grd;
	        var pt1 = itemData.s.v, pt2 = itemData.e.v;
	        if (styleData.t === 1) {
	            grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
	        } else {
	            var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	            var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);

	            var percent = itemData.h.v >= 1 ? 0.99 : itemData.h.v <= -1 ? -0.99: itemData.h.v;
	            var dist = rad * percent;
	            var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
	            var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
	            var grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
	        }

	        var i, len = styleData.g.p;
	        var cValues = itemData.g.c;
	        var opacity = 1;

	        for (i = 0; i < len; i += 1){
	            if(itemData.g._hasOpacity && itemData.g._collapsable) {
	                opacity = itemData.g.o[i*2 + 1];
	            }
	            grd.addColorStop(cValues[i * 4] / 100,'rgba('+ cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ','+cValues[i * 4 + 3] + ',' + opacity + ')');
	        }
	        styleElem.grd = grd;
	    }
	    styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    
	};

	CVShapeElement.prototype.renderStroke = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	    var d = itemData.d;
	    if(d && (d._mdf  || this._isFirstFrame)){
	        styleElem.da = d.dashArray;
	        styleElem.do = d.dashoffset[0];
	    }
	    if(itemData.c._mdf || this._isFirstFrame){
	        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame){
	        styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    }
	    if(itemData.w._mdf || this._isFirstFrame){
	        styleElem.wi = itemData.w.v;
	    }
	};


	CVShapeElement.prototype.destroy = function(){
	    this.shapesData = null;
	    this.globalData = null;
	    this.canvasContext = null;
	    this.stylesList.length = 0;
	    this.itemsData.length = 0;
	};


	function CVSolidElement(data, globalData, comp) {
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);

	CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

	CVSolidElement.prototype.renderInnerContent = function() {
	    var ctx = this.canvasContext;
	    ctx.fillStyle = this.data.sc;
	    ctx.fillRect(0, 0, this.data.sw, this.data.sh);
	    //
	};
	function CVTextElement(data, globalData, comp){
	    this.textSpans = [];
	    this.yOffset = 0;
	    this.fillColorAnim = false;
	    this.strokeColorAnim = false;
	    this.strokeWidthAnim = false;
	    this.stroke = false;
	    this.fill = false;
	    this.justifyOffset = 0;
	    this.currentRender = null;
	    this.renderType = 'canvas';
	    this.values = {
	        fill: 'rgba(0,0,0,0)',
	        stroke: 'rgba(0,0,0,0)',
	        sWidth: 0,
	        fValue: ''
	    };
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement,TransformElement,CVBaseElement,HierarchyElement,FrameElement,RenderableElement,ITextElement], CVTextElement);

	CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');

	CVTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);

	    var hasFill = false;
	    if(documentData.fc) {
	        hasFill = true;
	        this.values.fill = this.buildColor(documentData.fc);
	    }else {
	        this.values.fill = 'rgba(0,0,0,0)';
	    }
	    this.fill = hasFill;
	    var hasStroke = false;
	    if(documentData.sc){
	        hasStroke = true;
	        this.values.stroke = this.buildColor(documentData.sc);
	        this.values.sWidth = documentData.sw;
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    var i, len;
	    var letters = documentData.l;
	    var matrixHelper = this.mHelper;
	    this.stroke = hasStroke;
	    this.values.fValue = documentData.finalSize + 'px '+ this.globalData.fontManager.getFontByName(documentData.f).fFamily;
	    len = documentData.finalText.length;
	    //this.tHelper.font = this.values.fValue;
	    var charData, shapeData, k, kLen, shapes, j, jLen, pathNodes, commands, pathArr, singleShape = this.data.singleShape;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var cnt = 0;
	    for (i = 0; i < len; i += 1) {
	        charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	        shapeData = charData && charData.data || {};
	        matrixHelper.reset();
	        if(singleShape && letters[i].n) {
	            xPos = -trackingOffset;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	        }

	        shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	        jLen = shapes.length;
	        matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);
	        if(singleShape){
	            this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	        }
	        commands = createSizedArray(jLen);
	        for(j=0;j<jLen;j+=1){
	            kLen = shapes[j].ks.k.i.length;
	            pathNodes = shapes[j].ks.k;
	            pathArr = [];
	            for(k=1;k<kLen;k+=1){
	                if(k==1){
	                    pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	                }
	                pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));
	            }
	            pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	            commands[j] = pathArr;
	        }
	        if(singleShape){
	            xPos += letters[i].l;
	            xPos += trackingOffset;
	        }
	        if(this.textSpans[cnt]){
	            this.textSpans[cnt].elem = commands;
	        } else {
	            this.textSpans[cnt] = {elem: commands};
	        }
	        cnt +=1;
	    }
	};

	CVTextElement.prototype.renderInnerContent = function(){
	    var ctx = this.canvasContext;
	    this.finalTransform.mat.props;
	    ctx.font = this.values.fValue;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 4;

	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    }

	    var  i,len, j, jLen, k, kLen;
	    var renderedLetters = this.textAnimator.renderedLetters;

	    var letters = this.textProperty.currentData.l;

	    len = letters.length;
	    var renderedLetter;
	    var lastFill = null, lastStroke = null, lastStrokeW = null, commands, pathArr;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            continue;
	        }
	        renderedLetter = renderedLetters[i];
	        if(renderedLetter){
	            this.globalData.renderer.save();
	            this.globalData.renderer.ctxTransform(renderedLetter.p);
	            this.globalData.renderer.ctxOpacity(renderedLetter.o);
	        }
	        if(this.fill){
	            if(renderedLetter && renderedLetter.fc){
	                if(lastFill !== renderedLetter.fc){
	                    lastFill = renderedLetter.fc;
	                    ctx.fillStyle = renderedLetter.fc;
	                }
	            }else if(lastFill !== this.values.fill){
	                lastFill = this.values.fill;
	                ctx.fillStyle = this.values.fill;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.fill();
	            ///ctx.fillText(this.textSpans[i].val,0,0);
	        }
	        if(this.stroke){
	            if(renderedLetter && renderedLetter.sw){
	                if(lastStrokeW !== renderedLetter.sw){
	                    lastStrokeW = renderedLetter.sw;
	                    ctx.lineWidth = renderedLetter.sw;
	                }
	            }else if(lastStrokeW !== this.values.sWidth){
	                lastStrokeW = this.values.sWidth;
	                ctx.lineWidth = this.values.sWidth;
	            }
	            if(renderedLetter && renderedLetter.sc){
	                if(lastStroke !== renderedLetter.sc){
	                    lastStroke = renderedLetter.sc;
	                    ctx.strokeStyle = renderedLetter.sc;
	                }
	            }else if(lastStroke !== this.values.stroke){
	                lastStroke = this.values.stroke;
	                ctx.strokeStyle = this.values.stroke;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.stroke();
	            ///ctx.strokeText(letters[i].val,0,0);
	        }
	        if(renderedLetter) {
	            this.globalData.renderer.restore();
	        }
	    }
	};
	function CVEffects() {

	}
	CVEffects.prototype.renderFrame = function(){};
	function HBaseElement(data,globalData,comp){}
	HBaseElement.prototype = {
	    checkBlendMode: function(){},
	    initRendererElement: function(){
	        this.baseElement = createTag(this.data.tg || 'div');
	        if(this.data.hasMask) {
	            this.svgElement = createNS('svg');
	            this.layerElement = createNS('g');
	            this.maskedElement = this.layerElement;
	            this.svgElement.appendChild(this.layerElement);
	            this.baseElement.appendChild(this.svgElement);
	        } else {
	            this.layerElement = this.baseElement;
	        }
	        styleDiv(this.baseElement);
	    },
	    createContainerElements: function(){
	        this.renderableEffectsManager = new CVEffects();
	        this.transformedElement = this.baseElement;
	        this.maskedElement = this.layerElement;
	        if (this.data.ln) {
	            this.layerElement.setAttribute('id',this.data.ln);
	        }
	        if (this.data.cl) {
	            this.layerElement.setAttribute('class', this.data.cl);
	        }
	        if (this.data.bm !== 0) {
	            this.setBlendMode();
	        }
	    },
	    renderElement: function() {
	        if(this.finalTransform._matMdf){
	            this.transformedElement.style.transform = this.transformedElement.style.webkitTransform = this.finalTransform.mat.toCSS();
	        }
	        if(this.finalTransform._opMdf){
	            this.transformedElement.style.opacity = this.finalTransform.mProp.o.v;
	        }
	    },
	    renderFrame: function() {
	        //If it is exported as hidden (data.hd === true) no need to render
	        //If it is not visible no need to render
	        if (this.data.hd || this.hidden) {
	            return;
	        }
	        this.renderTransform();
	        this.renderRenderable();
	        this.renderElement();
	        this.renderInnerContent();
	        if (this._isFirstFrame) {
	            this._isFirstFrame = false;
	        }
	    },
	    destroy: function(){
	        this.layerElement = null;
	        this.transformedElement = null;
	        if(this.matteElement) {
	            this.matteElement = null;
	        }
	        if(this.maskManager) {
	            this.maskManager.destroy();
	            this.maskManager = null;
	        }
	    },
	    createRenderableComponents: function(){
	        this.maskManager = new MaskElement(this.data, this, this.globalData);
	    },
	    addEffects: function(){
	    },
	    setMatte: function(){}
	};
	HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
	HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
	HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
	function HSolidElement(data,globalData,comp){
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement], HSolidElement);

	HSolidElement.prototype.createContent = function(){
	    var rect;
	    if(this.data.hasMask){
	        rect = createNS('rect');
	        rect.setAttribute('width',this.data.sw);
	        rect.setAttribute('height',this.data.sh);
	        rect.setAttribute('fill',this.data.sc);
	        this.svgElement.setAttribute('width',this.data.sw);
	        this.svgElement.setAttribute('height',this.data.sh);
	    } else {
	        rect = createTag('div');
	        rect.style.width = this.data.sw + 'px';
	        rect.style.height = this.data.sh + 'px';
	        rect.style.backgroundColor = this.data.sc;
	    }
	    this.layerElement.appendChild(rect);
	};

	function HCompElement(data,globalData,comp){
	    this.layers = data.layers;
	    this.supports3d = !data.hasMask;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data,globalData,comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this) : {_placeholder:true};
	}

	extendPrototype([HybridRenderer, ICompElement, HBaseElement], HCompElement);
	HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;

	HCompElement.prototype.createContainerElements = function(){
	    this._createBaseContainerElements();
	    //divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
	    if(this.data.hasMask){
	        this.svgElement.setAttribute('width',this.data.w);
	        this.svgElement.setAttribute('height',this.data.h);
	        this.transformedElement = this.baseElement;
	    } else {
	        this.transformedElement = this.layerElement;
	    }
	};

	HCompElement.prototype.addTo3dContainer = function(elem,pos) {
	    var j = 0;
	    var nextElement;
	    while(j<pos){
	        if(this.elements[j] && this.elements[j].getBaseElement){
	            nextElement = this.elements[j].getBaseElement();
	        }
	        j += 1;
	    }
	    if(nextElement){
	        this.layerElement.insertBefore(elem, nextElement);
	    } else {
	        this.layerElement.appendChild(elem);
	    }
	};

	function HShapeElement(data,globalData,comp){
	    //List of drawable elements
	    this.shapes = [];
	    // Full shape data
	    this.shapesData = data.shapes;
	    //List of styles that will be applied to shapes
	    this.stylesList = [];
	    //List of modifiers that will be applied to shapes
	    this.shapeModifiers = [];
	    //List of items in shape tree
	    this.itemsData = [];
	    //List of items in previous shape tree
	    this.processedElements = [];
	    // List of animated components
	    this.animatedContents = [];
	    this.shapesContainer = createNS('g');
	    this.initElement(data,globalData,comp);
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	    this.prevViewData = [];
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    };
	}
	extendPrototype([BaseElement,TransformElement,HSolidElement,SVGShapeElement,HBaseElement,HierarchyElement,FrameElement,RenderableElement], HShapeElement);
	HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;

	HShapeElement.prototype.createContent = function(){
	    var cont;
	    this.baseElement.style.fontSize = 0;
	    if (this.data.hasMask) {
	        this.layerElement.appendChild(this.shapesContainer);
	        cont = this.svgElement;
	    } else {
	        cont = createNS('svg');
	        var size = this.comp.data ? this.comp.data : this.globalData.compSize;
	        cont.setAttribute('width',size.w);
	        cont.setAttribute('height',size.h);
	        cont.appendChild(this.shapesContainer);
	        this.layerElement.appendChild(cont);
	    }

	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.shapesContainer,0, [], true);
	    this.filterUniqueShapes();
	    this.shapeCont = cont;
	};

	HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
	    var i, len = transformers.length;
	    for(i = 0; i < len; i += 1) {
	        point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
	    }
	    return point;
	};

	HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
	    var shape = item.sh.v;
	    var transformers = item.transformers;
	    var i, len = shape._length, vPoint, oPoint, nextIPoint, nextVPoint;
	    if (len <= 1) {
	        return;
	    }
	    for (i = 0; i < len - 1; i += 1) {
	        vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	        oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	        nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
	        nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
	        this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	    if(shape.c) {
	        vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	        oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	        nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
	        nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
	        this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	};

	HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
	    this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
	    var bounds = this.shapeBoundingBox;
	    boundingBox.x = bm_min(bounds.left, boundingBox.x);
	    boundingBox.xMax = bm_max(bounds.right, boundingBox.xMax);
	    boundingBox.y = bm_min(bounds.top, boundingBox.y);
	    boundingBox.yMax = bm_max(bounds.bottom, boundingBox.yMax);
	};

	HShapeElement.prototype.shapeBoundingBox = {
	    left:0,
	    right:0,
	    top:0,
	    bottom:0,
	};

	HShapeElement.prototype.tempBoundingBox = {
	    x:0,
	    xMax:0,
	    y:0,
	    yMax:0,
	    width:0,
	    height:0
	};

	HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {

	    var bounds = [[p0[0],p3[0]], [p0[1],p3[1]]];

	    for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) {

	      b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	      a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	      c = 3 * p1[i] - 3 * p0[i];

	      b = b | 0;
	      a = a | 0;
	      c = c | 0;

	      if (a === 0) {

	        if (b === 0) {
	          continue;
	        }

	        t = -c / b;

	        if (0 < t && t < 1) {
	          bounds[i].push(this.calculateF(t,p0,p1,p2,p3,i));
	        }
	        continue;
	      }

	      b2ac = b * b - 4 * c * a;

	      if (b2ac < 0) {
	        continue;
	      }

	      t1 = (-b + bm_sqrt(b2ac))/(2 * a);
	      if (0 < t1 && t1 < 1) bounds[i].push(this.calculateF(t1,p0,p1,p2,p3,i));

	      t2 = (-b - bm_sqrt(b2ac))/(2 * a);
	      if (0 < t2 && t2 < 1) bounds[i].push(this.calculateF(t2,p0,p1,p2,p3,i));

	    }

	    this.shapeBoundingBox.left = bm_min.apply(null, bounds[0]);
	    this.shapeBoundingBox.top = bm_min.apply(null, bounds[1]);
	    this.shapeBoundingBox.right = bm_max.apply(null, bounds[0]);
	    this.shapeBoundingBox.bottom = bm_max.apply(null, bounds[1]);
	  };

	  HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
	    return bm_pow(1-t, 3) * p0[i]
	        + 3 * bm_pow(1-t, 2) * t * p1[i]
	        + 3 * (1-t) * bm_pow(t, 2) * p2[i]
	        + bm_pow(t, 3) * p3[i];
	  };

	HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
	    var i, len = itemsData.length;
	    for(i = 0; i < len; i += 1) {
	        if(itemsData[i] && itemsData[i].sh) {
	            this.calculateShapeBoundingBox(itemsData[i], boundingBox);
	        } else if(itemsData[i] && itemsData[i].it) {
	            this.calculateBoundingBox(itemsData[i].it, boundingBox);
	        }
	    }
	};

	HShapeElement.prototype.currentBoxContains = function(box) {
	    return this.currentBBox.x <= box.x 
	    && this.currentBBox.y <= box.y 
	    && this.currentBBox.width + this.currentBBox.x >= box.x + box.width
	    && this.currentBBox.height + this.currentBBox.y >= box.y + box.height
	};

	HShapeElement.prototype.renderInnerContent = function() {
	    this._renderShapeFrame();

	    if(!this.hidden && (this._isFirstFrame || this._mdf)) {
	        var tempBoundingBox = this.tempBoundingBox;
	        var max = 999999;
	        tempBoundingBox.x = max;
	        tempBoundingBox.xMax = -max;
	        tempBoundingBox.y = max;
	        tempBoundingBox.yMax = -max;
	        this.calculateBoundingBox(this.itemsData, tempBoundingBox);
	        tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
	        tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y;
	        //var tempBoundingBox = this.shapeCont.getBBox();
	        if(this.currentBoxContains(tempBoundingBox)) {
	            return;
	        }
	        var changed = false;
	        if(this.currentBBox.w !== tempBoundingBox.width){
	            this.currentBBox.w = tempBoundingBox.width;
	            this.shapeCont.setAttribute('width',tempBoundingBox.width);
	            changed = true;
	        }
	        if(this.currentBBox.h !== tempBoundingBox.height){
	            this.currentBBox.h = tempBoundingBox.height;
	            this.shapeCont.setAttribute('height',tempBoundingBox.height);
	            changed = true;
	        }
	        if(changed  || this.currentBBox.x !== tempBoundingBox.x  || this.currentBBox.y !== tempBoundingBox.y){
	            this.currentBBox.w = tempBoundingBox.width;
	            this.currentBBox.h = tempBoundingBox.height;
	            this.currentBBox.x = tempBoundingBox.x;
	            this.currentBBox.y = tempBoundingBox.y;

	            this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	            this.shapeCont.style.transform = this.shapeCont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        }
	    }

	};
	function HTextElement(data,globalData,comp){
	    this.textSpans = [];
	    this.textPaths = [];
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    };
	    this.renderType = 'svg';
	    this.isMasked = false;
	    this.initElement(data,globalData,comp);

	}
	extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement], HTextElement);

	HTextElement.prototype.createContent = function(){
	    this.isMasked = this.checkMasks();
	    if(this.isMasked){
	        this.renderType = 'svg';
	        this.compW = this.comp.data.w;
	        this.compH = this.comp.data.h;
	        this.svgElement.setAttribute('width',this.compW);
	        this.svgElement.setAttribute('height',this.compH);
	        var g = createNS('g');
	        this.maskedElement.appendChild(g);
	        this.innerElem = g;
	    } else {
	        this.renderType = 'html';
	        this.innerElem = this.layerElement;
	    }

	    this.checkParenting();

	};

	HTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var innerElemStyle = this.innerElem.style;
	    innerElemStyle.color = innerElemStyle.fill = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
	    if(documentData.sc){
	        innerElemStyle.stroke = this.buildColor(documentData.sc);
	        innerElemStyle.strokeWidth = documentData.sw+'px';
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(!this.globalData.fontManager.chars){
	        innerElemStyle.fontSize = documentData.finalSize+'px';
	        innerElemStyle.lineHeight = documentData.finalSize+'px';
	        if(fontData.fClass){
	            this.innerElem.className = fontData.fClass;
	        } else {
	            innerElemStyle.fontFamily = fontData.fFamily;
	            var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	            innerElemStyle.fontStyle = fStyle;
	            innerElemStyle.fontWeight = fWeight;
	        }
	    }
	    var i, len;

	    var letters = documentData.l;
	    len = letters.length;
	    var tSpan,tParent,tCont;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '';
	    var cnt = 0;
	    for (i = 0;i < len ;i += 1) {
	        if(this.globalData.fontManager.chars){
	            if(!this.textPaths[cnt]){
	                tSpan = createNS('path');
	                tSpan.setAttribute('stroke-linecap', 'butt');
	                tSpan.setAttribute('stroke-linejoin','round');
	                tSpan.setAttribute('stroke-miterlimit','4');
	            } else {
	                tSpan = this.textPaths[cnt];
	            }
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tCont = tParent.children[0];
	                } else {

	                    tParent = createTag('div');
	                    tParent.style.lineHeight = 0;
	                    tCont = createNS('svg');
	                    tCont.appendChild(tSpan);
	                    styleDiv(tParent);
	                }
	            }
	        }else {
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tSpan = this.textPaths[cnt];
	                } else {
	                    tParent = createTag('span');
	                    styleDiv(tParent);
	                    tSpan = createTag('span');
	                    styleDiv(tSpan);
	                    tParent.appendChild(tSpan);
	                }
	            } else {
	                tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
	            }
	        }
	        //tSpan.setAttribute('visibility', 'hidden');
	        if(this.globalData.fontManager.chars){
	            var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	            var shapeData;
	            if(charData){
	                shapeData = charData.data;
	            } else {
	                shapeData = null;
	            }
	            matrixHelper.reset();
	            if(shapeData && shapeData.shapes){
	                shapes = shapeData.shapes[0].it;
	                matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);
	                shapeStr = this.createPathShape(matrixHelper,shapes);
	                tSpan.setAttribute('d',shapeStr);
	            }
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                if(shapeData && shapeData.shapes){

	                    //document.body.appendChild is needed to get exact measure of shape
	                    document.body.appendChild(tCont);
	                    var boundingBox = tCont.getBBox();
	                    tCont.setAttribute('width',boundingBox.width + 2);
	                    tCont.setAttribute('height',boundingBox.height + 2);
	                    tCont.setAttribute('viewBox',(boundingBox.x-1)+' '+ (boundingBox.y-1)+' '+ (boundingBox.width+2)+' '+ (boundingBox.height+2));
	                    tCont.style.transform = tCont.style.webkitTransform = 'translate(' + (boundingBox.x-1) + 'px,' + (boundingBox.y-1) + 'px)';

	                    letters[i].yOffset = boundingBox.y-1;

	                } else {
	                    tCont.setAttribute('width',1);
	                    tCont.setAttribute('height',1);
	                }
	                    tParent.appendChild(tCont);
	            }else {
	                this.innerElem.appendChild(tSpan);
	            }
	        }else {
	            tSpan.textContent = letters[i].val;
	            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                //
	                tSpan.style.transform = tSpan.style.webkitTransform = 'translate3d(0,'+ -documentData.finalSize/1.2+'px,0)';
	            } else {
	                this.innerElem.appendChild(tSpan);
	            }
	        }
	        //
	        if(!this.isMasked){
	            this.textSpans[cnt] = tParent;
	        }else {
	            this.textSpans[cnt] = tSpan;
	        }
	        this.textSpans[cnt].style.display = 'block';
	        this.textPaths[cnt] = tSpan;
	        cnt += 1;
	    }
	    while(cnt < this.textSpans.length){
	        this.textSpans[cnt].style.display = 'none';
	        cnt += 1;
	    }
	};

	HTextElement.prototype.renderInnerContent = function() {

	    if(this.data.singleShape){
	        if(!this._isFirstFrame && !this.lettersChangedFlag){
	            return;
	        } else {
	            // Todo Benchmark if using this is better than getBBox
	             if(this.isMasked && this.finalTransform._matMdf){
	                 this.svgElement.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+ -this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);
	                this.svgElement.style.transform = this.svgElement.style.webkitTransform = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
	             }
	        }
	    }

	    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    if(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag){
	        return;
	    }
	    var  i,len, count = 0;
	    var renderedLetters = this.textAnimator.renderedLetters;

	    var letters = this.textProperty.currentData.l;

	    len = letters.length;
	    var renderedLetter, textSpan, textPath;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            count += 1;
	            continue;
	        }
	        textSpan = this.textSpans[i];
	        textPath = this.textPaths[i];
	        renderedLetter = renderedLetters[count];
	        count += 1;
	        if(renderedLetter._mdf.m) {
	            if(!this.isMasked){
	                textSpan.style.transform = textSpan.style.webkitTransform = renderedLetter.m;
	            }else {
	                textSpan.setAttribute('transform',renderedLetter.m);
	            }
	        }
	        ////textSpan.setAttribute('opacity',renderedLetter.o);
	        textSpan.style.opacity = renderedLetter.o;
	        if(renderedLetter.sw && renderedLetter._mdf.sw){
	            textPath.setAttribute('stroke-width',renderedLetter.sw);
	        }
	        if(renderedLetter.sc && renderedLetter._mdf.sc){
	            textPath.setAttribute('stroke',renderedLetter.sc);
	        }
	        if(renderedLetter.fc && renderedLetter._mdf.fc){
	            textPath.setAttribute('fill',renderedLetter.fc);
	            textPath.style.color = renderedLetter.fc;
	        }
	    }

	    if(this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)){
	        var boundingBox = this.innerElem.getBBox();

	        if(this.currentBBox.w !== boundingBox.width){
	            this.currentBBox.w = boundingBox.width;
	            this.svgElement.setAttribute('width',boundingBox.width);
	        }
	        if(this.currentBBox.h !== boundingBox.height){
	            this.currentBBox.h = boundingBox.height;
	            this.svgElement.setAttribute('height',boundingBox.height);
	        }

	        var margin = 1;
	        if(this.currentBBox.w !== (boundingBox.width + margin*2) || this.currentBBox.h !== (boundingBox.height + margin*2)  || this.currentBBox.x !== (boundingBox.x - margin)  || this.currentBBox.y !== (boundingBox.y - margin)){
	            this.currentBBox.w = boundingBox.width + margin*2;
	            this.currentBBox.h = boundingBox.height + margin*2;
	            this.currentBBox.x = boundingBox.x - margin;
	            this.currentBBox.y = boundingBox.y - margin;

	            this.svgElement.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	            this.svgElement.style.transform = this.svgElement.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        }
	    }
	};
	function HImageElement(data,globalData,comp){
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data,globalData,comp);
	}

	extendPrototype([BaseElement,TransformElement,HBaseElement,HSolidElement,HierarchyElement,FrameElement,RenderableElement], HImageElement);


	HImageElement.prototype.createContent = function(){
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    var img = new Image();

	    if(this.data.hasMask){
	        this.imageElem = createNS('image');
	        this.imageElem.setAttribute('width',this.assetData.w+"px");
	        this.imageElem.setAttribute('height',this.assetData.h+"px");
	        this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	        this.layerElement.appendChild(this.imageElem);
	        this.baseElement.setAttribute('width',this.assetData.w);
	        this.baseElement.setAttribute('height',this.assetData.h);
	    } else {
	        this.layerElement.appendChild(img);
	    }
	    img.src = assetPath;
	    if(this.data.ln){
	        this.baseElement.setAttribute('id',this.data.ln);
	    }
	};
	function HCameraElement(data,globalData,comp){
	    this.initFrame();
	    this.initBaseData(data,globalData,comp);
	    this.initHierarchy();
	    var getProp = PropertyFactory.getProp;
	    this.pe = getProp(this,data.pe,0,0,this);
	    if(data.ks.p.s){
	        this.px = getProp(this,data.ks.p.x,1,0,this);
	        this.py = getProp(this,data.ks.p.y,1,0,this);
	        this.pz = getProp(this,data.ks.p.z,1,0,this);
	    }else {
	        this.p = getProp(this,data.ks.p,1,0,this);
	    }
	    if(data.ks.a){
	        this.a = getProp(this,data.ks.a,1,0,this);
	    }
	    if(data.ks.or.k.length && data.ks.or.k[0].to){
	        var i,len = data.ks.or.k.length;
	        for(i=0;i<len;i+=1){
	            data.ks.or.k[i].to = null;
	            data.ks.or.k[i].ti = null;
	        }
	    }
	    this.or = getProp(this,data.ks.or,1,degToRads,this);
	    this.or.sh = true;
	    this.rx = getProp(this,data.ks.rx,0,degToRads,this);
	    this.ry = getProp(this,data.ks.ry,0,degToRads,this);
	    this.rz = getProp(this,data.ks.rz,0,degToRads,this);
	    this.mat = new Matrix();
	    this._prevMat = new Matrix();
	    this._isFirstFrame = true;
	    
	    // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
	    this.finalTransform = {
	        mProp: this
	    };
	}
	extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);

	HCameraElement.prototype.setup = function() {
	    var i, len = this.comp.threeDElements.length, comp;
	    for(i=0;i<len;i+=1){
	        //[perspectiveElem,container]
	        comp = this.comp.threeDElements[i];
	        if(comp.type === '3d') {
	            comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
	            comp.container.style.transformOrigin = comp.container.style.mozTransformOrigin = comp.container.style.webkitTransformOrigin = "0px 0px 0px";
	            comp.perspectiveElem.style.transform = comp.perspectiveElem.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	        }
	    }
	};

	HCameraElement.prototype.createElements = function(){
	};

	HCameraElement.prototype.hide = function(){
	};

	HCameraElement.prototype.renderFrame = function(){
	    var _mdf = this._isFirstFrame;
	    var i, len;
	    if(this.hierarchy){
	        len = this.hierarchy.length;
	        for(i=0;i<len;i+=1){
	            _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
	        }
	    }
	    if(_mdf || this.pe._mdf || (this.p && this.p._mdf) || (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || (this.a && this.a._mdf)) {
	        this.mat.reset();

	        if(this.hierarchy){
	            len = this.hierarchy.length - 1;
	            for (i = len; i >= 0; i -= 1) {
	                var mTransf = this.hierarchy[i].finalTransform.mProp;
	                this.mat.translate(-mTransf.p.v[0],-mTransf.p.v[1],mTransf.p.v[2]);
	                this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
	                this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
	                this.mat.scale(1/mTransf.s.v[0],1/mTransf.s.v[1],1/mTransf.s.v[2]);
	                this.mat.translate(mTransf.a.v[0],mTransf.a.v[1],mTransf.a.v[2]);
	            }
	        }
	        if (this.p) {
	            this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);
	        } else {
	            this.mat.translate(-this.px.v,-this.py.v,this.pz.v);
	        }
	        if (this.a) {
	            var diffVector;
	            if (this.p) {
	                diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
	            } else {
	                diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
	            }
	            var mag = Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));
	            //var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
	            var lookDir = [diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];
	            var lookLengthOnXZ = Math.sqrt( lookDir[2]*lookDir[2] + lookDir[0]*lookDir[0] );
	            var m_rotationX = (Math.atan2( lookDir[1], lookLengthOnXZ ));
	            var m_rotationY = (Math.atan2( lookDir[0], -lookDir[2]));
	            this.mat.rotateY(m_rotationY).rotateX(-m_rotationX);

	        }
	        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	        this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
	        this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);
	        this.mat.translate(0,0,this.pe.v);


	        

	        var hasMatrixChanged = !this._prevMat.equals(this.mat);
	        if((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
	            len = this.comp.threeDElements.length;
	            var comp;
	            for(i=0;i<len;i+=1){
	                comp = this.comp.threeDElements[i];
	                if(comp.type === '3d') {
	                    if(hasMatrixChanged) {
	                        comp.container.style.transform = comp.container.style.webkitTransform = this.mat.toCSS();
	                    }
	                    if(this.pe._mdf) {
	                        comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
	                    }
	                }
	            }
	            this.mat.clone(this._prevMat);
	        }
	    }
	    this._isFirstFrame = false;
	};

	HCameraElement.prototype.prepareFrame = function(num) {
	    this.prepareProperties(num, true);
	};

	HCameraElement.prototype.destroy = function(){
	};
	HCameraElement.prototype.getBaseElement = function(){return null;};
	var animationManager = (function(){
	    var moduleOb = {};
	    var registeredAnimations = [];
	    var initTime = 0;
	    var len = 0;
	    var playingAnimationsNum = 0;
	    var _stopped = true;
	    var _isFrozen = false;

	    function removeElement(ev){
	        var i = 0;
	        var animItem = ev.target;
	        while(i<len) {
	            if (registeredAnimations[i].animation === animItem) {
	                registeredAnimations.splice(i, 1);
	                i -= 1;
	                len -= 1;
	                if(!animItem.isPaused){
	                    subtractPlayingCount();
	                }
	            }
	            i += 1;
	        }
	    }

	    function registerAnimation(element, animationData){
	        if(!element){
	            return null;
	        }
	        var i=0;
	        while(i<len){
	            if(registeredAnimations[i].elem == element && registeredAnimations[i].elem !== null ){
	                return registeredAnimations[i].animation;
	            }
	            i+=1;
	        }
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, element);
	        animItem.setData(element, animationData);
	        return animItem;
	    }

	    function getRegisteredAnimations() {
	        var i, len = registeredAnimations.length;
	        var animations = [];
	        for(i = 0; i < len; i += 1) {
	            animations.push(registeredAnimations[i].animation);
	        }
	        return animations;
	    }

	    function addPlayingCount(){
	        playingAnimationsNum += 1;
	        activate();
	    }

	    function subtractPlayingCount(){
	        playingAnimationsNum -= 1;
	    }

	    function setupAnimation(animItem, element){
	        animItem.addEventListener('destroy',removeElement);
	        animItem.addEventListener('_active',addPlayingCount);
	        animItem.addEventListener('_idle',subtractPlayingCount);
	        registeredAnimations.push({elem: element,animation:animItem});
	        len += 1;
	    }

	    function loadAnimation(params){
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, null);
	        animItem.setParams(params);
	        return animItem;
	    }


	    function setSpeed(val,animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setSpeed(val, animation);
	        }
	    }

	    function setDirection(val, animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setDirection(val, animation);
	        }
	    }

	    function play(animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.play(animation);
	        }
	    }
	    function resume(nowTime) {
	        var elapsedTime = nowTime - initTime;
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.advanceTime(elapsedTime);
	        }
	        initTime = nowTime;
	        if(playingAnimationsNum && !_isFrozen) {
	            window.requestAnimationFrame(resume);
	        } else {
	            _stopped = true;
	        }
	    }

	    function first(nowTime){
	        initTime = nowTime;
	        window.requestAnimationFrame(resume);
	    }

	    function pause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.pause(animation);
	        }
	    }

	    function goToAndStop(value,isFrame,animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);
	        }
	    }

	    function stop(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.stop(animation);
	        }
	    }

	    function togglePause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.togglePause(animation);
	        }
	    }

	    function destroy(animation) {
	        var i;
	        for(i=(len-1);i>=0;i-=1){
	            registeredAnimations[i].animation.destroy(animation);
	        }
	    }

	    function searchAnimations(animationData, standalone, renderer){
	        var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')),
	                  [].slice.call(document.getElementsByClassName('bodymovin')));
	        var i, len = animElements.length;
	        for(i=0;i<len;i+=1){
	            if(renderer){
	                animElements[i].setAttribute('data-bm-type',renderer);
	            }
	            registerAnimation(animElements[i], animationData);
	        }
	        if(standalone && len === 0){
	            if(!renderer){
	                renderer = 'svg';
	            }
	            var body = document.getElementsByTagName('body')[0];
	            body.innerHTML = '';
	            var div = createTag('div');
	            div.style.width = '100%';
	            div.style.height = '100%';
	            div.setAttribute('data-bm-type',renderer);
	            body.appendChild(div);
	            registerAnimation(div, animationData);
	        }
	    }

	    function resize(){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.resize();
	        }
	    }

	    function activate(){
	        if(!_isFrozen && playingAnimationsNum){
	            if(_stopped) {
	                window.requestAnimationFrame(first);
	                _stopped = false;
	            }
	        }
	    }

	    function freeze() {
	        _isFrozen = true;
	    }

	    function unfreeze() {
	        _isFrozen = false;
	        activate();
	    }

	    moduleOb.registerAnimation = registerAnimation;
	    moduleOb.loadAnimation = loadAnimation;
	    moduleOb.setSpeed = setSpeed;
	    moduleOb.setDirection = setDirection;
	    moduleOb.play = play;
	    moduleOb.pause = pause;
	    moduleOb.stop = stop;
	    moduleOb.togglePause = togglePause;
	    moduleOb.searchAnimations = searchAnimations;
	    moduleOb.resize = resize;
	    //moduleOb.start = start;
	    moduleOb.goToAndStop = goToAndStop;
	    moduleOb.destroy = destroy;
	    moduleOb.freeze = freeze;
	    moduleOb.unfreeze = unfreeze;
	    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
	    return moduleOb;
	}());

	var AnimationItem = function () {
	    this._cbs = [];
	    this.name = '';
	    this.path = '';
	    this.isLoaded = false;
	    this.currentFrame = 0;
	    this.currentRawFrame = 0;
	    this.firstFrame = 0;
	    this.totalFrames = 0;
	    this.frameRate = 0;
	    this.frameMult = 0;
	    this.playSpeed = 1;
	    this.playDirection = 1;
	    this.playCount = 0;
	    this.animationData = {};
	    this.assets = [];
	    this.isPaused = true;
	    this.autoplay = false;
	    this.loop = true;
	    this.renderer = null;
	    this.animationID = createElementID();
	    this.assetsPath = '';
	    this.timeCompleted = 0;
	    this.segmentPos = 0;
	    this.isSubframeEnabled = subframeEnabled;
	    this.segments = [];
	    this._idle = true;
	    this._completedLoop = false;
	    this.projectInterface = ProjectInterface();
	    this.imagePreloader = new ImagePreloader();
	};

	extendPrototype([BaseEvent], AnimationItem);

	AnimationItem.prototype.setParams = function(params) {
	    if(params.context){
	        this.context = params.context;
	    }
	    if(params.wrapper || params.container){
	        this.wrapper = params.wrapper || params.container;
	    }
	    var animType = params.animType ? params.animType : params.renderer ? params.renderer : 'svg';
	    switch(animType){
	        case 'canvas':
	            this.renderer = new CanvasRenderer(this, params.rendererSettings);
	            break;
	        case 'svg':
	            this.renderer = new SVGRenderer(this, params.rendererSettings);
	            break;
	        default:
	            this.renderer = new HybridRenderer(this, params.rendererSettings);
	            break;
	    }
	    this.imagePreloader.setCacheType(animType);
	    this.renderer.setProjectInterface(this.projectInterface);
	    this.animType = animType;
	    if (params.loop === ''
	        || params.loop === null
	        || params.loop === undefined
	        || params.loop === true)
	    {
	        this.loop = true;
	    } else if (params.loop === false) {
	        this.loop = false;
	    } else {
	        this.loop = parseInt(params.loop);
	    }
	    this.autoplay = 'autoplay' in params ? params.autoplay : true;
	    this.name = params.name ? params.name :  '';
	    this.autoloadSegments = params.hasOwnProperty('autoloadSegments') ? params.autoloadSegments :  true;
	    this.assetsPath = params.assetsPath;
	    this.initialSegment = params.initialSegment;
	    if (params.animationData) {
	        this.configAnimation(params.animationData);
	    } else if(params.path){

	        if( params.path.lastIndexOf('\\') !== -1){
	            this.path = params.path.substr(0,params.path.lastIndexOf('\\')+1);
	        } else {
	            this.path = params.path.substr(0,params.path.lastIndexOf('/')+1);
	        }
	        this.fileName = params.path.substr(params.path.lastIndexOf('/')+1);
	        this.fileName = this.fileName.substr(0,this.fileName.lastIndexOf('.json'));

	        assetLoader.load(params.path, this.configAnimation.bind(this), function() {
	            this.trigger('data_failed');
	        }.bind(this));
	    }

	};

	AnimationItem.prototype.setData = function (wrapper, animationData) {
	    var params = {
	        wrapper: wrapper,
	        animationData: animationData ? (typeof animationData  === "object") ? animationData : JSON.parse(animationData) : null
	    };
	    var wrapperAttributes = wrapper.attributes;

	    params.path = wrapperAttributes.getNamedItem('data-animation-path') ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') ? wrapperAttributes.getNamedItem('data-bm-path').value :  wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
	    params.animType = wrapperAttributes.getNamedItem('data-anim-type') ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') ? wrapperAttributes.getNamedItem('bm-type').value :  wrapperAttributes.getNamedItem('data-bm-renderer') ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';

	    var loop = wrapperAttributes.getNamedItem('data-anim-loop') ? wrapperAttributes.getNamedItem('data-anim-loop').value :  wrapperAttributes.getNamedItem('data-bm-loop') ? wrapperAttributes.getNamedItem('data-bm-loop').value :  wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
	    if(loop === '');else if(loop === 'false'){
	        params.loop = false;
	    }else if(loop === 'true'){
	        params.loop = true;
	    }else {
	        params.loop = parseInt(loop);
	    }
	    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') ? wrapperAttributes.getNamedItem('data-anim-autoplay').value :  wrapperAttributes.getNamedItem('data-bm-autoplay') ? wrapperAttributes.getNamedItem('data-bm-autoplay').value :  wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
	    params.autoplay = autoplay !== "false";

	    params.name = wrapperAttributes.getNamedItem('data-name') ? wrapperAttributes.getNamedItem('data-name').value :  wrapperAttributes.getNamedItem('data-bm-name') ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value :  '';
	    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') ? wrapperAttributes.getNamedItem('data-anim-prerender').value :  wrapperAttributes.getNamedItem('data-bm-prerender') ? wrapperAttributes.getNamedItem('data-bm-prerender').value :  wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';

	    if(prerender === 'false'){
	        params.prerender = false;
	    }
	    this.setParams(params);
	};

	AnimationItem.prototype.includeLayers = function(data) {
	    if(data.op > this.animationData.op){
	        this.animationData.op = data.op;
	        this.totalFrames = Math.floor(data.op - this.animationData.ip);
	    }
	    var layers = this.animationData.layers;
	    var i, len = layers.length;
	    var newLayers = data.layers;
	    var j, jLen = newLayers.length;
	    for(j=0;j<jLen;j+=1){
	        i = 0;
	        while(i<len){
	            if(layers[i].id == newLayers[j].id){
	                layers[i] = newLayers[j];
	                break;
	            }
	            i += 1;
	        }
	    }
	    if(data.chars || data.fonts){
	        this.renderer.globalData.fontManager.addChars(data.chars);
	        this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
	    }
	    if(data.assets){
	        len = data.assets.length;
	        for(i = 0; i < len; i += 1){
	            this.animationData.assets.push(data.assets[i]);
	        }
	    }
	    this.animationData.__complete = false;
	    dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	    this.renderer.includeLayers(data.layers);
	    if(expressionsPlugin){
	        expressionsPlugin.initExpressions(this);
	    }
	    this.loadNextSegment();
	};

	AnimationItem.prototype.loadNextSegment = function() {
	    var segments = this.animationData.segments;
	    if(!segments || segments.length === 0 || !this.autoloadSegments){
	        this.trigger('data_ready');
	        this.timeCompleted = this.totalFrames;
	        return;
	    }
	    var segment = segments.shift();
	    this.timeCompleted = segment.time * this.frameRate;
	    var segmentPath = this.path+this.fileName+'_' + this.segmentPos + '.json';
	    this.segmentPos += 1;
	    assetLoader.load(segmentPath, this.includeLayers.bind(this), function() {
	        this.trigger('data_failed');
	    }.bind(this));
	};

	AnimationItem.prototype.loadSegments = function() {
	    var segments = this.animationData.segments;
	    if(!segments) {
	        this.timeCompleted = this.totalFrames;
	    }
	    this.loadNextSegment();
	};

	AnimationItem.prototype.imagesLoaded = function() {
	    this.trigger('loaded_images');
	    this.checkLoaded();
	};

	AnimationItem.prototype.preloadImages = function() {
	    this.imagePreloader.setAssetsPath(this.assetsPath);
	    this.imagePreloader.setPath(this.path);
	    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
	};

	AnimationItem.prototype.configAnimation = function (animData) {
	    if(!this.renderer){
	        return;
	    }
	    try {
	        this.animationData = animData;

	        if (this.initialSegment) {
	            this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
	            this.firstFrame = Math.round(this.initialSegment[0]);
	        } else {
	            this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
	            this.firstFrame = Math.round(this.animationData.ip);
	        }
	        this.renderer.configAnimation(animData);
	        if(!animData.assets){
	            animData.assets = [];
	        }

	        this.assets = this.animationData.assets;
	        this.frameRate = this.animationData.fr;
	        this.frameMult = this.animationData.fr / 1000;
	        this.renderer.searchExtraCompositions(animData.assets);
	        this.trigger('config_ready');
	        this.preloadImages();
	        this.loadSegments();
	        this.updaFrameModifier();
	        this.waitForFontsLoaded();
	    } catch(error) {
	        this.triggerConfigError(error);
	    }
	};

	AnimationItem.prototype.waitForFontsLoaded = function(){
	    if(!this.renderer) {
	        return;
	    }
	    if(this.renderer.globalData.fontManager.isLoaded){
	        this.checkLoaded();
	    }else {
	        setTimeout(this.waitForFontsLoaded.bind(this),20);
	    }
	};

	AnimationItem.prototype.checkLoaded = function () {
	    if (!this.isLoaded 
	        && this.renderer.globalData.fontManager.isLoaded
	        && (this.imagePreloader.loaded() || this.renderer.rendererType !== 'canvas')
	    ) {
	        this.isLoaded = true;
	        dataManager.completeData(this.animationData, this.renderer.globalData.fontManager);
	        if(expressionsPlugin){
	            expressionsPlugin.initExpressions(this);
	        }
	        this.renderer.initItems();
	        setTimeout(function() {
	            this.trigger('DOMLoaded');
	        }.bind(this), 0);
	        this.gotoFrame();
	        if(this.autoplay){
	            this.play();
	        }
	    }
	};

	AnimationItem.prototype.resize = function () {
	    this.renderer.updateContainerSize();
	};

	AnimationItem.prototype.setSubframe = function(flag){
	    this.isSubframeEnabled = !!flag;
	};

	AnimationItem.prototype.gotoFrame = function () {
	    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame;

	    if(this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted){
	        this.currentFrame = this.timeCompleted;
	    }
	    this.trigger('enterFrame');
	    this.renderFrame();
	};

	AnimationItem.prototype.renderFrame = function () {
	    if(this.isLoaded === false){
	        return;
	    }
	    try {
	        this.renderer.renderFrame(this.currentFrame + this.firstFrame);
	    } catch(error) {
	        this.triggerRenderFrameError(error);
	    }
	};

	AnimationItem.prototype.play = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.isPaused = false;
	        if(this._idle){
	            this._idle = false;
	            this.trigger('_active');
	        }
	    }
	};

	AnimationItem.prototype.pause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === false){
	        this.isPaused = true;
	        this._idle = true;
	        this.trigger('_idle');
	    }
	};

	AnimationItem.prototype.togglePause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.play();
	    }else {
	        this.pause();
	    }
	};

	AnimationItem.prototype.stop = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.pause();
	    this.playCount = 0;
	    this._completedLoop = false;
	    this.setCurrentRawFrameValue(0);
	};

	AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(isFrame){
	        this.setCurrentRawFrameValue(value);
	    }else {
	        this.setCurrentRawFrameValue(value * this.frameModifier);
	    }
	    this.pause();
	};

	AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
	    this.goToAndStop(value, isFrame, name);
	    this.play();
	};

	AnimationItem.prototype.advanceTime = function (value) {
	    if (this.isPaused === true || this.isLoaded === false) {
	        return;
	    }
	    var nextValue = this.currentRawFrame + value * this.frameModifier;
	    var _isComplete = false;
	    // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
	    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
	    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
	        if (!this.loop || this.playCount === this.loop) {
	            if (!this.checkSegments(nextValue >  this.totalFrames ? nextValue % this.totalFrames : 0)) {
	                _isComplete = true;
	                nextValue = this.totalFrames - 1;
	            }
	        } else if (nextValue >= this.totalFrames) {
	            this.playCount += 1;
	            if (!this.checkSegments(nextValue % this.totalFrames)) {
	                this.setCurrentRawFrameValue(nextValue % this.totalFrames);
	                this._completedLoop = true;
	                this.trigger('loopComplete');
	            }
	        } else {
	            this.setCurrentRawFrameValue(nextValue);
	        }
	    } else if(nextValue < 0) {
	        if (!this.checkSegments(nextValue % this.totalFrames)) {
	            if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
	                this.setCurrentRawFrameValue(this.totalFrames + (nextValue % this.totalFrames));
	                if(!this._completedLoop) {
	                    this._completedLoop = true;
	                } else {
	                    this.trigger('loopComplete');
	                }
	            } else {
	                _isComplete = true;
	                nextValue = 0;
	            }
	        }
	    } else {
	        this.setCurrentRawFrameValue(nextValue);
	    }
	    if (_isComplete) {
	        this.setCurrentRawFrameValue(nextValue);
	        this.pause();
	        this.trigger('complete');
	    }
	};

	AnimationItem.prototype.adjustSegment = function(arr, offset){
	    this.playCount = 0;
	    if(arr[1] < arr[0]){
	        if(this.frameModifier > 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(-1);
	            }
	        }
	        this.timeCompleted = this.totalFrames = arr[0] - arr[1];
	        this.firstFrame = arr[1];
	        this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
	    } else if(arr[1] > arr[0]){
	        if(this.frameModifier < 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(1);
	            }
	        }
	        this.timeCompleted = this.totalFrames = arr[1] - arr[0];
	        this.firstFrame = arr[0];
	        this.setCurrentRawFrameValue(0.001 + offset);
	    }
	    this.trigger('segmentStart');
	};
	AnimationItem.prototype.setSegment = function (init,end) {
	    var pendingFrame = -1;
	    if(this.isPaused) {
	        if (this.currentRawFrame + this.firstFrame < init) {
	            pendingFrame = init;
	        } else if (this.currentRawFrame + this.firstFrame > end) {
	            pendingFrame = end - init;
	        }
	    }

	    this.firstFrame = init;
	    this.timeCompleted = this.totalFrames = end - init;
	    if(pendingFrame !== -1) {
	        this.goToAndStop(pendingFrame,true);
	    }
	};

	AnimationItem.prototype.playSegments = function (arr, forceFlag) {
	    if (forceFlag) {
	        this.segments.length = 0;
	    }
	    if (typeof arr[0] === 'object') {
	        var i, len = arr.length;
	        for (i = 0; i < len; i += 1) {
	            this.segments.push(arr[i]);
	        }
	    } else {
	        this.segments.push(arr);
	    }
	    if (this.segments.length && forceFlag) {
	        this.adjustSegment(this.segments.shift(), 0);
	    }
	    if (this.isPaused) {
	        this.play();
	    }
	};

	AnimationItem.prototype.resetSegments = function (forceFlag) {
	    this.segments.length = 0;
	    this.segments.push([this.animationData.ip,this.animationData.op]);
	    //this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
	    if (forceFlag) {
	        this.checkSegments(0);
	    }
	};
	AnimationItem.prototype.checkSegments = function(offset) {
	    if (this.segments.length) {
	        this.adjustSegment(this.segments.shift(), offset);
	        return true;
	    }
	    return false;
	};

	AnimationItem.prototype.destroy = function (name) {
	    if ((name && this.name != name) || !this.renderer) {
	        return;
	    }
	    this.renderer.destroy();
	    this.imagePreloader.destroy();
	    this.trigger('destroy');
	    this._cbs = null;
	    this.onEnterFrame = this.onLoopComplete = this.onComplete = this.onSegmentStart = this.onDestroy = null;
	    this.renderer = null;
	};

	AnimationItem.prototype.setCurrentRawFrameValue = function(value){
	    this.currentRawFrame = value;
	    this.gotoFrame();
	};

	AnimationItem.prototype.setSpeed = function (val) {
	    this.playSpeed = val;
	    this.updaFrameModifier();
	};

	AnimationItem.prototype.setDirection = function (val) {
	    this.playDirection = val < 0 ? -1 : 1;
	    this.updaFrameModifier();
	};

	AnimationItem.prototype.updaFrameModifier = function () {
	    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
	};

	AnimationItem.prototype.getPath = function () {
	    return this.path;
	};

	AnimationItem.prototype.getAssetsPath = function (assetData) {
	    var path = '';
	    if(assetData.e) {
	        path = assetData.p;
	    } else if(this.assetsPath){
	        var imagePath = assetData.p;
	        if(imagePath.indexOf('images/') !== -1){
	            imagePath = imagePath.split('/')[1];
	        }
	        path = this.assetsPath + imagePath;
	    } else {
	        path = this.path;
	        path += assetData.u ? assetData.u : '';
	        path += assetData.p;
	    }
	    return path;
	};

	AnimationItem.prototype.getAssetData = function (id) {
	    var i = 0, len = this.assets.length;
	    while (i < len) {
	        if(id == this.assets[i].id){
	            return this.assets[i];
	        }
	        i += 1;
	    }
	};

	AnimationItem.prototype.hide = function () {
	    this.renderer.hide();
	};

	AnimationItem.prototype.show = function () {
	    this.renderer.show();
	};

	AnimationItem.prototype.getDuration = function (isFrame) {
	    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
	};

	AnimationItem.prototype.trigger = function(name){
	    if(this._cbs && this._cbs[name]){
	        switch(name){
	            case 'enterFrame':
	                this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameModifier));
	                break;
	            case 'loopComplete':
	                this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	                break;
	            case 'complete':
	                this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));
	                break;
	            case 'segmentStart':
	                this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	                break;
	            case 'destroy':
	                this.triggerEvent(name,new BMDestroyEvent(name,this));
	                break;
	            default:
	                this.triggerEvent(name);
	        }
	    }
	    if(name === 'enterFrame' && this.onEnterFrame){
	        this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	    }
	    if(name === 'loopComplete' && this.onLoopComplete){
	        this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	    }
	    if(name === 'complete' && this.onComplete){
	        this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));
	    }
	    if(name === 'segmentStart' && this.onSegmentStart){
	        this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	    }
	    if(name === 'destroy' && this.onDestroy){
	        this.onDestroy.call(this,new BMDestroyEvent(name,this));
	    }
	};

	AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {

	    var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
	    this.triggerEvent('error', error);

	    if (this.onError) {
	        this.onError.call(this, error);
	    }
	};

	AnimationItem.prototype.triggerConfigError = function(nativeError) {

	    var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
	    this.triggerEvent('error', error);

	    if (this.onError) {
	        this.onError.call(this, error);
	    }
	};
	var Expressions = (function(){
	    var ob = {};
	    ob.initExpressions = initExpressions;


	    function initExpressions(animation){

	    	var stackCount = 0;
	    	var registers = [];

	    	function pushExpression() {
				stackCount += 1;
	    	}

	    	function popExpression() {
				stackCount -= 1;
				if (stackCount === 0) {
					releaseInstances();
				}
	    	}

	    	function registerExpressionProperty(expression) {
	    		if (registers.indexOf(expression) === -1) {
					registers.push(expression);
	    		}
	    	}

	    	function releaseInstances() {
	    		var i, len = registers.length;
	    		for (i = 0; i < len; i += 1) {
					registers[i].release();
	    		}
	    		registers.length = 0;
	    	}

	        animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
	        animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
	        animation.renderer.globalData.pushExpression = pushExpression;
	        animation.renderer.globalData.popExpression = popExpression;
	        animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
	    }
	   return ob;
	}());

	expressionsPlugin = Expressions;

	var ExpressionManager = (function(){
	    var ob = {};
	    var Math = BMMath;

	    BezierFactory.getBezierEasing(0.333,0,.833,.833, 'easeIn').get;
	    BezierFactory.getBezierEasing(0.167,0.167,.667,1, 'easeOut').get;
	    BezierFactory.getBezierEasing(.33,0,.667,1, 'easeInOut').get;

	    function initiateExpression(elem,data,property){
	        var val = data.x;
	        var needsVelocity = /velocity(?![\w\d])/.test(val);
	        var _needsRandom = val.indexOf('random') !== -1;
	        var elemType = elem.data.ty;
	        var transform,content,effect;
	        var thisProperty = property;
	        thisProperty.valueAtTime = thisProperty.getValueAtTime;
	        Object.defineProperty(thisProperty, 'value', {
	            get: function() {
	                return thisProperty.v
	            }
	        });
	        elem.comp.frameDuration = 1/elem.comp.globalData.frameRate;
	        elem.comp.displayStartTime = 0;
	        elem.data.ip/elem.comp.globalData.frameRate;
	        elem.data.op/elem.comp.globalData.frameRate;
	        elem.data.sw ? elem.data.sw : 0;
	        elem.data.sh ? elem.data.sh : 0;
	        elem.data.nm;
	        var thisLayer, velocityAtTime;
	        if(data.xf) {
	            var i, len = data.xf.length;
	            for(i = 0; i < len; i += 1) {
	                eval('(function(){ return ' + data.xf[i] + '}())');
	            }
	        }

	        var scoped_bm_rt;
	        var expression_function = eval('[function _expression_function(){' + val+';scoped_bm_rt=$bm_rt}' + ']')[0];
	        property.kf ? data.k.length : 0;

	        !this.data || this.data.hd !== true;

	        (function wiggle(freq,amp){
	            var i,j, len = this.pv.length ? this.pv.length : 1;
	            var addedAmps = createTypedArray('float32', len);
	            freq = 5;
	            var iterations = Math.floor(time*freq);
	            i = 0;
	            j = 0;
	            while(i<iterations){
	                //var rnd = BMMath.random();
	                for(j=0;j<len;j+=1){
	                    addedAmps[j] += -amp + amp*2*BMMath.random();
	                    //addedAmps[j] += -amp + amp*2*rnd;
	                }
	                i += 1;
	            }
	            //var rnd2 = BMMath.random();
	            var periods = time*freq;
	            var perc = periods - Math.floor(periods);
	            var arr = createTypedArray('float32', len);
	            if(len>1){
	                for(j=0;j<len;j+=1){
	                    arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*BMMath.random())*perc;
	                    //arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	                    //arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	                }
	                return arr;
	            } else {
	                return this.pv + addedAmps[0] + (-amp + amp*2*BMMath.random())*perc;
	            }
	        }).bind(this);

	        if(thisProperty.loopIn) {
	            thisProperty.loopIn.bind(thisProperty);
	        }

	        if(thisProperty.loopOut) {
	            thisProperty.loopOut.bind(thisProperty);
	        }

	        if(thisProperty.smooth) {
	            thisProperty.smooth.bind(thisProperty);
	        }

	        if(this.getValueAtTime) {
	            this.getValueAtTime.bind(this);
	        }

	        if(this.getVelocityAtTime) {
	            velocityAtTime = this.getVelocityAtTime.bind(this);
	        }

	        elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

	        function seedRandom(seed){
	            BMMath.seedrandom(randSeed + seed);
	        }

	        var time, value;
	        elem.data.ind;
	        var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	        var parent;
	        var randSeed = Math.floor(Math.random()*1000000);
	        elem.globalData;
	        function executeExpression(_value) {
	            // globalData.pushExpression();
	            value = _value;
	            if (_needsRandom) {
	                seedRandom(randSeed);
	            }
	            if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
	                return value;
	            }
	            if(this.propType === 'textSelector'){
	                this.textIndex;
	                this.textTotal;
	                this.selectorValue;
	            }
	            if (!thisLayer) {
	                elem.layerInterface.text;
	                thisLayer = elem.layerInterface;
	                elem.comp.compInterface;
	                thisLayer.toWorld.bind(thisLayer);
	                thisLayer.fromWorld.bind(thisLayer);
	                thisLayer.fromComp.bind(thisLayer);
	                thisLayer.toComp.bind(thisLayer);
	                thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
	            }
	            if (!transform) {
	                transform = elem.layerInterface("ADBE Transform Group");
	                if(transform) {
	                    transform.anchorPoint;
	                    /*position = transform.position;
	                    rotation = transform.rotation;
	                    scale = transform.scale;*/
	                }
	            }
	            
	            if (elemType === 4 && !content) {
	                content = thisLayer("ADBE Root Vectors Group");
	            }
	            if (!effect) {
	                effect = thisLayer(4);
	            }
	            hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	            if (hasParent && !parent) {
	                parent = elem.hierarchy[0].layerInterface;
	            }
	            time = this.comp.renderedFrame/this.comp.globalData.frameRate;
	            if (needsVelocity) {
	                velocityAtTime(time);
	            }
	            expression_function();
	            this.frameExpressionId = elem.globalData.frameId;


	            //TODO: Check if it's possible to return on ShapeInterface the .v value
	            if (scoped_bm_rt.propType === "shape") ;
	            // globalData.popExpression();
	            return scoped_bm_rt;
	        }
	        return executeExpression;
	    }

	    ob.initiateExpression = initiateExpression;
	    return ob;
	}());
	var expressionHelpers = (function(){

	    function searchExpressions(elem,data,prop){
	        if(data.x){
	            prop.k = true;
	            prop.x = true;
	            prop.initiateExpression = ExpressionManager.initiateExpression;
	            prop.effectsSequence.push(prop.initiateExpression(elem,data,prop).bind(prop));
	        }
	    }

	    function getValueAtTime(frameNum) {
	        frameNum *= this.elem.globalData.frameRate;
	        frameNum -= this.offsetTime;
	        if(frameNum !== this._cachingAtTime.lastFrame) {
	            this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
	            this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
	            this._cachingAtTime.lastFrame = frameNum;
	        }
	        return this._cachingAtTime.value;

	    }

	    function getSpeedAtTime(frameNum) {
	        var delta = -0.01;
	        var v1 = this.getValueAtTime(frameNum);
	        var v2 = this.getValueAtTime(frameNum + delta);
	        var speed = 0;
	        if(v1.length){
	            var i;
	            for(i=0;i<v1.length;i+=1){
	                speed += Math.pow(v2[i] - v1[i], 2);
	            }
	            speed = Math.sqrt(speed) * 100;
	        } else {
	            speed = 0;
	        }
	        return speed;
	    }

	    function getVelocityAtTime(frameNum) {
	        if(this.vel !== undefined){
	            return this.vel;
	        }
	        var delta = -0.001;
	        //frameNum += this.elem.data.st;
	        var v1 = this.getValueAtTime(frameNum);
	        var v2 = this.getValueAtTime(frameNum + delta);
	        var velocity;
	        if(v1.length){
	            velocity = createTypedArray('float32', v1.length);
	            var i;
	            for(i=0;i<v1.length;i+=1){
	                //removing frameRate
	                //if needed, don't add it here
	                //velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	                velocity[i] = (v2[i] - v1[i])/delta;
	            }
	        } else {
	            velocity = (v2 - v1)/delta;
	        }
	        return velocity;
	    }

	    function getStaticValueAtTime() {
	        return this.pv;
	    }

	    function setGroupProperty(propertyGroup){
	        this.propertyGroup = propertyGroup;
	    }

		return {
			searchExpressions: searchExpressions,
			getSpeedAtTime: getSpeedAtTime,
			getVelocityAtTime: getVelocityAtTime,
			getValueAtTime: getValueAtTime,
			getStaticValueAtTime: getStaticValueAtTime,
			setGroupProperty: setGroupProperty,
		}
	}());
	(function addPropertyDecorator() {

	    function loopOut(type,duration,durationFlag){
	        if(!this.k || !this.keyframes){
	            return this.pv;
	        }
	        type = type ? type.toLowerCase() : '';
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var lastKeyFrame = keyframes[keyframes.length - 1].t;
	        if(currentFrame<=lastKeyFrame){
	            return this.pv;
	        }else {
	            var cycleDuration, firstKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,lastKeyFrame - this.elem.data.ip);
	                } else {
	                    cycleDuration = Math.abs(lastKeyFrame - elem.comp.globalData.frameRate*duration);
	                }
	                firstKeyFrame = lastKeyFrame - cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(iterations % 2 !== 0){
	                    return this.getValueAtTime(((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = (endV[i]-initV[i])*repeats + current[i];
	                    }
	                    return ret;
	                }
	                return (endV-initV)*repeats + current;
	            } else if(type === 'continue'){
	                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(lastValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = lastValue[i] + (lastValue[i]-nextLastValue[i])*((currentFrame - lastKeyFrame)/ this.comp.globalData.frameRate)/0.0005;
	                    }
	                    return ret;
	                }
	                return lastValue + (lastValue-nextLastValue)*(((currentFrame - lastKeyFrame))/0.001);
	            }
	            return this.getValueAtTime((((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }

	    function loopIn(type,duration, durationFlag) {
	        if(!this.k){
	            return this.pv;
	        }
	        type = type ? type.toLowerCase() : '';
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var firstKeyFrame = keyframes[0].t;
	        if(currentFrame>=firstKeyFrame){
	            return this.pv;
	        }else {
	            var cycleDuration, lastKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                lastKeyFrame = keyframes[duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,this.elem.data.op - firstKeyFrame);
	                } else {
	                    cycleDuration = Math.abs(elem.comp.globalData.frameRate*duration);
	                }
	                lastKeyFrame = firstKeyFrame + cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((firstKeyFrame - currentFrame)/cycleDuration);
	                if(iterations % 2 === 0){
	                    return this.getValueAtTime((((firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((firstKeyFrame - currentFrame)/cycleDuration)+1;
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = current[i]-(endV[i]-initV[i])*repeats;
	                    }
	                    return ret;
	                }
	                return current-(endV-initV)*repeats;
	            } else if(type === 'continue'){
	                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(firstValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = firstValue[i] + (firstValue[i]-nextFirstValue[i])*(firstKeyFrame - currentFrame)/0.001;
	                    }
	                    return ret;
	                }
	                return firstValue + (firstValue-nextFirstValue)*(firstKeyFrame - currentFrame)/0.001;
	            }
	            return this.getValueAtTime(((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }

	    function smooth(width, samples) {
	        if (!this.k){
	            return this.pv;
	        }
	        width = (width || 0.4) * 0.5;
	        samples = Math.floor(samples || 5);
	        if (samples <= 1) {
	            return this.pv;
	        }
	        var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
	        var initFrame = currentTime - width;
	        var endFrame = currentTime + width;
	        var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
	        var i = 0, j = 0;
	        var value;
	        if (this.pv.length) {
	            value = createTypedArray('float32', this.pv.length);
	        } else {
	            value = 0;
	        }
	        var sampleValue;
	        while (i < samples) {
	            sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
	            if(this.pv.length) {
	                for (j = 0; j < this.pv.length; j += 1) {
	                    value[j] += sampleValue[j];
	                }
	            } else {
	                value += sampleValue;
	            }
	            i += 1;
	        }
	        if(this.pv.length) {
	            for (j = 0; j < this.pv.length; j += 1) {
	                value[j] /= samples;
	            }
	        } else {
	            value /= samples;
	        }
	        return value;
	    }

	    function getTransformValueAtTime(time) {
	        console.warn('Transform at time not supported');
	    }

	    function getTransformStaticValueAtTime(time) {

	    }

	    var getTransformProperty = TransformPropertyFactory.getTransformProperty;
	    TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
	        var prop = getTransformProperty(elem, data, container);
	        if(prop.dynamicProperties.length) {
	            prop.getValueAtTime = getTransformValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = expressionHelpers.setGroupProperty;
	        return prop;
	    };

	    var propertyGetProp = PropertyFactory.getProp;
	    PropertyFactory.getProp = function(elem,data,type, mult, container){
	        var prop = propertyGetProp(elem,data,type, mult, container);
	        //prop.getVelocityAtTime = getVelocityAtTime;
	        //prop.loopOut = loopOut;
	        //prop.loopIn = loopIn;
	        if(prop.kf){
	            prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = expressionHelpers.setGroupProperty;
	        prop.loopOut = loopOut;
	        prop.loopIn = loopIn;
	        prop.smooth = smooth;
	        prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
	        prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
	        prop.numKeys = data.a === 1 ? data.k.length : 0;
	        prop.propertyIndex = data.ix;
	        var value = 0;
	        if(type !== 0) {
	            value = createTypedArray('float32', data.a === 1 ?  data.k[0].s.length : data.k.length);
	        }
	        prop._cachingAtTime = {
	            lastFrame: initialDefaultFrame,
	            lastIndex: 0,
	            value: value
	        };
	        expressionHelpers.searchExpressions(elem,data,prop);
	        if(prop.k){
	            container.addDynamicProperty(prop);
	        }

	        return prop;
	    };

	    function getShapeValueAtTime(frameNum) {
	        //For now this caching object is created only when needed instead of creating it when the shape is initialized.
	        if (!this._cachingAtTime) {
	            this._cachingAtTime = {
	                shapeValue: shape_pool.clone(this.pv),
	                lastIndex: 0,
	                lastTime: initialDefaultFrame
	            };
	        }
	        
	        frameNum *= this.elem.globalData.frameRate;
	        frameNum -= this.offsetTime;
	        if(frameNum !== this._cachingAtTime.lastTime) {
	            this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
	            this._cachingAtTime.lastTime = frameNum;
	            this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
	        }
	        return this._cachingAtTime.shapeValue;
	    }

	    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
	    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();

	    function ShapeExpressions(){}
	    ShapeExpressions.prototype = {
	        vertices: function(prop, time){
	            if (this.k) {
	                this.getValue();
	            }
	            var shapePath = this.v;
	            if(time !== undefined) {
	                shapePath = this.getValueAtTime(time, 0);
	            }
	            var i, len = shapePath._length;
	            var vertices = shapePath[prop];
	            var points = shapePath.v;
	            var arr = createSizedArray(len);
	            for(i = 0; i < len; i += 1) {
	                if(prop === 'i' || prop === 'o') {
	                    arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
	                } else {
	                    arr[i] = [vertices[i][0], vertices[i][1]];
	                }
	                
	            }
	            return arr;
	        },
	        points: function(time){
	            return this.vertices('v', time);
	        },
	        inTangents: function(time){
	            return this.vertices('i', time);
	        },
	        outTangents: function(time){
	            return this.vertices('o', time);
	        },
	        isClosed: function(){
	            return this.v.c;
	        },
	        pointOnPath: function(perc, time){
	            var shapePath = this.v;
	            if(time !== undefined) {
	                shapePath = this.getValueAtTime(time, 0);
	            }
	            if(!this._segmentsLength) {
	                this._segmentsLength = bez.getSegmentsLength(shapePath);
	            }

	            var segmentsLength = this._segmentsLength;
	            var lengths = segmentsLength.lengths;
	            var lengthPos = segmentsLength.totalLength * perc;
	            var i = 0, len = lengths.length;
	            var accumulatedLength = 0, pt;
	            while(i < len) {
	                if(accumulatedLength + lengths[i].addedLength > lengthPos) {
	                    var initIndex = i;
	                    var endIndex = (shapePath.c && i === len - 1) ? 0 : i + 1;
	                    var segmentPerc = (lengthPos - accumulatedLength)/lengths[i].addedLength;
	                    pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
	                    break;
	                } else {
	                    accumulatedLength += lengths[i].addedLength;
	                }
	                i += 1;
	            }
	            if(!pt){
	                pt = shapePath.c ? [shapePath.v[0][0],shapePath.v[0][1]]:[shapePath.v[shapePath._length-1][0],shapePath.v[shapePath._length-1][1]];
	            }
	            return pt;
	        },
	        vectorOnPath: function(perc, time, vectorType){
	            //perc doesn't use triple equality because it can be a Number object as well as a primitive.
	            perc = perc == 1 ? this.v.c ? 0 : 0.999 : perc;
	            var pt1 = this.pointOnPath(perc, time);
	            var pt2 = this.pointOnPath(perc + 0.001, time);
	            var xLength = pt2[0] - pt1[0];
	            var yLength = pt2[1] - pt1[1];
	            var magnitude = Math.sqrt(Math.pow(xLength,2) + Math.pow(yLength,2));
	            if (magnitude === 0) {
	                return [0,0];
	            }
	            var unitVector = vectorType === 'tangent' ? [xLength/magnitude, yLength/magnitude] : [-yLength/magnitude, xLength/magnitude];
	            return unitVector;
	        },
	        tangentOnPath: function(perc, time){
	            return this.vectorOnPath(perc, time, 'tangent');
	        },
	        normalOnPath: function(perc, time){
	            return this.vectorOnPath(perc, time, 'normal');
	        },
	        setGroupProperty: expressionHelpers.setGroupProperty,
	        getValueAtTime: expressionHelpers.getStaticValueAtTime
	    };
	    extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
	    extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
	    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
	    KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;

	    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
	    ShapePropertyFactory.getShapeProp = function(elem,data,type, arr, trims){
	        var prop = propertyGetShapeProp(elem,data,type, arr, trims);
	        prop.propertyIndex = data.ix;
	        prop.lock = false;
	        if(type === 3){
	            expressionHelpers.searchExpressions(elem,data.pt,prop);
	        } else if(type === 4){
	            expressionHelpers.searchExpressions(elem,data.ks,prop);
	        }
	        if(prop.k){
	            elem.addDynamicProperty(prop);
	        }
	        return prop;
	    };
	}());
	(function addDecorator() {

	    function searchExpressions(){
	        if(this.data.d.x){
	            this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem,this.data.d,this);
	            this.addEffect(this.getExpressionValue.bind(this));
	            return true;
	        }
	    }

	    TextProperty.prototype.getExpressionValue = function(currentValue, text) {
	        var newValue = this.calculateExpression(text);
	        if(currentValue.t !== newValue) {
	            var newData = {};
	            this.copyData(newData, currentValue);
	            newData.t = newValue.toString();
	            newData.__complete = false;
	            return newData;
	        }
	        return currentValue;
	    };

	    TextProperty.prototype.searchProperty = function(){

	        var isKeyframed = this.searchKeyframes();
	        var hasExpressions = this.searchExpressions();
	        this.kf = isKeyframed || hasExpressions;
	        return this.kf;
	    };

	    TextProperty.prototype.searchExpressions = searchExpressions;
	    
	}());
	var ShapeExpressionInterface = (function(){

	    function iterateElements(shapes,view, propertyGroup){
	        var arr = [];
	        var i, len = shapes ? shapes.length : 0;
	        for(i=0;i<len;i+=1){
	            if(shapes[i].ty == 'gr'){
	                arr.push(groupInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'fl'){
	                arr.push(fillInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'st'){
	                arr.push(strokeInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tm'){
	                arr.push(trimInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tr');else if(shapes[i].ty == 'el'){
	                arr.push(ellipseInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'sr'){
	                arr.push(starInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'sh'){
	                arr.push(pathInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rc'){
	                arr.push(rectInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rd'){
	                arr.push(roundedInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rp'){
	                arr.push(repeaterInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }
	        }
	        return arr;
	    }

	    function contentsInterfaceFactory(shape,view, propertyGroup){
	       var interfaces;
	       var interfaceFunction = function _interfaceFunction(value){
	           var i = 0, len = interfaces.length;
	            while(i<len){
	                if(interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value){
	                   return interfaces[i];
	                }
	                i+=1;
	            }
	            if(typeof value === 'number'){
	               return interfaces[value-1];
	            }
	       };
	       interfaceFunction.propertyGroup = function(val){
	           if(val === 1){
	               return interfaceFunction;
	           } else {
	               return propertyGroup(val-1);
	           }
	       };
	       interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
	       interfaceFunction.numProperties = interfaces.length;
	       interfaceFunction.propertyIndex = shape.cix;
	       interfaceFunction._name = shape.nm;

	       return interfaceFunction;
	   }

	    function groupInterfaceFactory(shape,view, propertyGroup){
	        var interfaceFunction = function _interfaceFunction(value){
	            switch(value){
	                case 'ADBE Vectors Group':
	                case 'Contents':
	                case 2:
	                    return interfaceFunction.content;
	                //Not necessary for now. Keeping them here in case a new case appears
	                //case 'ADBE Vector Transform Group':
	                //case 3:
	                default:
	                    return interfaceFunction.transform;
	            }
	        };
	        interfaceFunction.propertyGroup = function(val){
	            if(val === 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(val-1);
	            }
	        };
	        var content = contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);
	        var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1],view.it[view.it.length - 1],interfaceFunction.propertyGroup);
	        interfaceFunction.content = content;
	        interfaceFunction.transform = transformInterface;
	        Object.defineProperty(interfaceFunction, '_name', {
	            get: function(){
	                return shape.nm;
	            }
	        });
	        //interfaceFunction.content = interfaceFunction;
	        interfaceFunction.numProperties = shape.np;
	        interfaceFunction.propertyIndex = shape.ix;
	        interfaceFunction.nm = shape.nm;
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }

	    function fillInterfaceFactory(shape,view,propertyGroup){
	        function interfaceFunction(val){
	            if(val === 'Color' || val === 'color'){
	                return interfaceFunction.color;
	            } else if(val === 'Opacity' || val === 'opacity'){
	                return interfaceFunction.opacity;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'color': {
	                get: ExpressionPropertyInterface(view.c)
	            },
	            'opacity': {
	                get: ExpressionPropertyInterface(view.o)
	            },
	            '_name': { value: shape.nm },
	            'mn': { value: shape.mn }
	        });

	        view.c.setGroupProperty(propertyGroup);
	        view.o.setGroupProperty(propertyGroup);
	        return interfaceFunction;
	    }

	    function strokeInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val === 1){
	                return ob;
	            } else {
	                return propertyGroup(val-1);
	            }
	        }
	        function _dashPropertyGroup(val){
	            if(val === 1){
	                return dashOb;
	            } else {
	                return _propertyGroup(val-1);
	            }
	        }
	        function addPropertyToDashOb(i) {
	            Object.defineProperty(dashOb, shape.d[i].nm, {
	                get: ExpressionPropertyInterface(view.d.dataProps[i].p)
	            });
	        }
	        var i, len = shape.d ? shape.d.length : 0;
	        var dashOb = {};
	        for (i = 0; i < len; i += 1) {
	            addPropertyToDashOb(i);
	            view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
	        }

	        function interfaceFunction(val){
	            if(val === 'Color' || val === 'color'){
	                return interfaceFunction.color;
	            } else if(val === 'Opacity' || val === 'opacity'){
	                return interfaceFunction.opacity;
	            } else if(val === 'Stroke Width' || val === 'stroke width'){
	                return interfaceFunction.strokeWidth;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'color': {
	                get: ExpressionPropertyInterface(view.c)
	            },
	            'opacity': {
	                get: ExpressionPropertyInterface(view.o)
	            },
	            'strokeWidth': {
	                get: ExpressionPropertyInterface(view.w)
	            },
	            'dash': {
	                get: function() {
	                    return dashOb;
	                }
	            },
	            '_name': { value: shape.nm },
	            'mn': { value: shape.mn }
	        });

	        view.c.setGroupProperty(_propertyGroup);
	        view.o.setGroupProperty(_propertyGroup);
	        view.w.setGroupProperty(_propertyGroup);
	        return interfaceFunction;
	    }

	    function trimInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;

	        view.s.setGroupProperty(_propertyGroup);
	        view.e.setGroupProperty(_propertyGroup);
	        view.o.setGroupProperty(_propertyGroup);

	        function interfaceFunction(val){
	            if(val === shape.e.ix || val === 'End' || val === 'end'){
	                return interfaceFunction.end;
	            }
	            if(val === shape.s.ix){
	                return interfaceFunction.start;
	            }
	            if(val === shape.o.ix){
	                return interfaceFunction.offset;
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;
	        interfaceFunction.propertyGroup = propertyGroup;

	        Object.defineProperties(interfaceFunction, {
	            'start': {
	                get: ExpressionPropertyInterface(view.s)
	            },
	            'end': {
	                get: ExpressionPropertyInterface(view.e)
	            },
	            'offset': {
	                get: ExpressionPropertyInterface(view.o)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }

	    function transformInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        view.transform.mProps.o.setGroupProperty(_propertyGroup);
	        view.transform.mProps.p.setGroupProperty(_propertyGroup);
	        view.transform.mProps.a.setGroupProperty(_propertyGroup);
	        view.transform.mProps.s.setGroupProperty(_propertyGroup);
	        view.transform.mProps.r.setGroupProperty(_propertyGroup);
	        if(view.transform.mProps.sk){
	            view.transform.mProps.sk.setGroupProperty(_propertyGroup);
	            view.transform.mProps.sa.setGroupProperty(_propertyGroup);
	        }
	        view.transform.op.setGroupProperty(_propertyGroup);

	        function interfaceFunction(value){
	            if(shape.a.ix === value || value === 'Anchor Point'){
	                return interfaceFunction.anchorPoint;
	            }
	            if(shape.o.ix === value || value === 'Opacity'){
	                return interfaceFunction.opacity;
	            }
	            if(shape.p.ix === value || value === 'Position'){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation'){
	                return interfaceFunction.rotation;
	            }
	            if(shape.s.ix === value || value === 'Scale'){
	                return interfaceFunction.scale;
	            }
	            if(shape.sk && shape.sk.ix === value || value === 'Skew'){
	                return interfaceFunction.skew;
	            }
	            if(shape.sa && shape.sa.ix === value || value === 'Skew Axis'){
	                return interfaceFunction.skewAxis;
	            }

	        }
	        Object.defineProperties(interfaceFunction, {
	            'opacity': {
	                get: ExpressionPropertyInterface(view.transform.mProps.o)
	            },
	            'position': {
	                get: ExpressionPropertyInterface(view.transform.mProps.p)
	            },
	            'anchorPoint': {
	                get: ExpressionPropertyInterface(view.transform.mProps.a)
	            },
	            'scale': {
	                get: ExpressionPropertyInterface(view.transform.mProps.s)
	            },
	            'rotation': {
	                get: ExpressionPropertyInterface(view.transform.mProps.r)
	            },
	            'skew': {
	                get: ExpressionPropertyInterface(view.transform.mProps.sk)
	            },
	            'skewAxis': {
	                get: ExpressionPropertyInterface(view.transform.mProps.sa)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.ty = 'tr';
	        interfaceFunction.mn = shape.mn;
	        interfaceFunction.propertyGroup = propertyGroup;
	        return interfaceFunction;
	    }

	    function ellipseInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        prop.s.setGroupProperty(_propertyGroup);
	        prop.p.setGroupProperty(_propertyGroup);
	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.s.ix === value){
	                return interfaceFunction.size;
	            }
	        }

	        Object.defineProperties(interfaceFunction, {
	            'size': {
	                get: ExpressionPropertyInterface(prop.s)
	            },
	            'position': {
	                get: ExpressionPropertyInterface(prop.p)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }

	    function starInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.or.setGroupProperty(_propertyGroup);
	        prop.os.setGroupProperty(_propertyGroup);
	        prop.pt.setGroupProperty(_propertyGroup);
	        prop.p.setGroupProperty(_propertyGroup);
	        prop.r.setGroupProperty(_propertyGroup);
	        if(shape.ir){
	            prop.ir.setGroupProperty(_propertyGroup);
	            prop.is.setGroupProperty(_propertyGroup);
	        }

	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value){
	                return interfaceFunction.rotation;
	            }
	            if(shape.pt.ix === value){
	                return interfaceFunction.points;
	            }
	            if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
	                return interfaceFunction.outerRadius;
	            }
	            if(shape.os.ix === value){
	                return interfaceFunction.outerRoundness;
	            }
	            if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
	                return interfaceFunction.innerRadius;
	            }
	            if(shape.is && shape.is.ix === value){
	                return interfaceFunction.innerRoundness;
	            }

	        }

	        Object.defineProperties(interfaceFunction, {
	            'position': {
	                get: ExpressionPropertyInterface(prop.p)
	            },
	            'rotation': {
	                get: ExpressionPropertyInterface(prop.r)
	            },
	            'points': {
	                get: ExpressionPropertyInterface(prop.pt)
	            },
	            'outerRadius': {
	                get: ExpressionPropertyInterface(prop.or)
	            },
	            'outerRoundness': {
	                get: ExpressionPropertyInterface(prop.os)
	            },
	            'innerRadius': {
	                get: ExpressionPropertyInterface(prop.ir)
	            },
	            'innerRoundness': {
	                get: ExpressionPropertyInterface(prop.is)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }

	    function rectInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.p.setGroupProperty(_propertyGroup);
	        prop.s.setGroupProperty(_propertyGroup);
	        prop.r.setGroupProperty(_propertyGroup);

	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value){
	                return interfaceFunction.roundness;
	            }
	            if(shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size'){
	                return interfaceFunction.size;
	            }

	        }
	        Object.defineProperties(interfaceFunction, {
	            'position': {
	                get: ExpressionPropertyInterface(prop.p)
	            },
	            'roundness': {
	                get: ExpressionPropertyInterface(prop.r)
	            },
	            'size': {
	                get: ExpressionPropertyInterface(prop.s)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }

	    function roundedInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.rd.setGroupProperty(_propertyGroup);

	        function interfaceFunction(value){
	            if(shape.r.ix === value || 'Round Corners 1' === value){
	                return interfaceFunction.radius;
	            }

	        }
	        Object.defineProperties(interfaceFunction, {
	            'radius': {
	                get: ExpressionPropertyInterface(prop.rd)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }

	    function repeaterInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.c.setGroupProperty(_propertyGroup);
	        prop.o.setGroupProperty(_propertyGroup);

	        function interfaceFunction(value){
	            if(shape.c.ix === value || 'Copies' === value){
	                return interfaceFunction.copies;
	            } else if(shape.o.ix === value || 'Offset' === value){
	                return interfaceFunction.offset;
	            }

	        }
	        Object.defineProperties(interfaceFunction, {
	            'copies': {
	                get: ExpressionPropertyInterface(prop.c)
	            },
	            'offset': {
	                get: ExpressionPropertyInterface(prop.o)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }

	    function pathInterfaceFactory(shape,view,propertyGroup){
	        var prop = view.sh;
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        prop.setGroupProperty(_propertyGroup);

	        function interfaceFunction(val){
	            if(val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2){
	                return interfaceFunction.path;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'path': {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                }
	            },
	            'shape': {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                }
	            },
	            '_name': { value: shape.nm },
	            'ix': { value: shape.ix },
	            'propertyIndex': { value: shape.ix },
	            'mn': { value: shape.mn }
	        });
	        return interfaceFunction;
	    }

	    return function(shapes,view,propertyGroup) {
	        var interfaces;
	        function _interfaceFunction(value){
	            if(typeof value === 'number'){
	                return interfaces[value-1];
	            } else {
	                var i = 0, len = interfaces.length;
	                while(i<len){
	                    if(interfaces[i]._name === value){
	                        return interfaces[i];
	                    }
	                    i+=1;
	                }
	            }
	        }
	        _interfaceFunction.propertyGroup = propertyGroup;
	        interfaces = iterateElements(shapes, view, _interfaceFunction);
	        _interfaceFunction.numProperties = interfaces.length;
	        return _interfaceFunction;
	    };
	}());

	var TextExpressionInterface = (function(){
		return function(elem){
	        var _prevValue, _sourceText;
	        function _thisLayerFunction(){
	        }
	        Object.defineProperty(_thisLayerFunction, "sourceText", {
	            get: function(){
	                elem.textProperty.getValue();
	                var stringValue = elem.textProperty.currentData.t;
	                if(stringValue !== _prevValue) {
	                    elem.textProperty.currentData.t = _prevValue;
	                    _sourceText = new String(stringValue);
	                    //If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
	                    _sourceText.value = stringValue ? stringValue : new String(stringValue);
	                }
	                return _sourceText;
	            }
	        });
	        return _thisLayerFunction;
	    };
	}());
	var LayerExpressionInterface = (function (){
	    function toWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	        }
	        return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	    }
	    function fromWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	    function fromComp(arr){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }

	    function sampleImage() {
	        return [1,1,1,1];
	    }


	    return function(elem){

	        var transformInterface;

	        function _registerMaskInterface(maskManager){
	            _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
	        }
	        function _registerEffectsInterface(effects){
	            _thisLayerFunction.effect = effects;
	        }

	        function _thisLayerFunction(name){
	            switch(name){
	                case "ADBE Root Vectors Group":
	                case "Contents":
	                case 2:
	                    return _thisLayerFunction.shapeInterface;
	                case 1:
	                case 6:
	                case "Transform":
	                case "transform":
	                case "ADBE Transform Group":
	                    return transformInterface;
	                case 4:
	                case "ADBE Effect Parade":
	                case "effects":
	                case "Effects":
	                    return _thisLayerFunction.effect;
	            }
	        }
	        _thisLayerFunction.toWorld = toWorld;
	        _thisLayerFunction.fromWorld = fromWorld;
	        _thisLayerFunction.toComp = toWorld;
	        _thisLayerFunction.fromComp = fromComp;
	        _thisLayerFunction.sampleImage = sampleImage;
	        _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
	        _thisLayerFunction._elem = elem;
	        transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
	        var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
	        Object.defineProperties(_thisLayerFunction,{
	            hasParent: {
	                get: function(){
	                    return elem.hierarchy.length;
	                }
	            },
	            parent: {
	                get: function(){
	                    return elem.hierarchy[0].layerInterface;
	                }
	            },
	            rotation: getDescriptor(transformInterface, 'rotation'),
	            scale: getDescriptor(transformInterface, 'scale'),
	            position: getDescriptor(transformInterface, 'position'),
	            opacity: getDescriptor(transformInterface, 'opacity'),
	            anchorPoint: anchorPointDescriptor,
	            anchor_point: anchorPointDescriptor,
	            transform: {
	                get: function () {
	                    return transformInterface;
	                }
	            },
	            active: {
	                get: function(){
	                    return elem.isInRange;
	                }
	            }
	        });

	        _thisLayerFunction.startTime = elem.data.st;
	        _thisLayerFunction.index = elem.data.ind;
	        _thisLayerFunction.source = elem.data.refId;
	        _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
	        _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
	        _thisLayerFunction.inPoint = elem.data.ip/elem.comp.globalData.frameRate;
	        _thisLayerFunction.outPoint = elem.data.op/elem.comp.globalData.frameRate;
	        _thisLayerFunction._name = elem.data.nm;

	        _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
	        _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
	        return _thisLayerFunction;
	    };
	}());

	var CompExpressionInterface = (function () {
	    return function(comp) {
	        function _thisLayerFunction(name) {
	            var i = 0, len = comp.layers.length;
	            while ( i < len) {
	                if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
	                    return comp.elements[i].layerInterface;
	                }
	                i += 1;
	            }
	            return null;
	            //return {active:false};
	        }
	        Object.defineProperty(_thisLayerFunction, "_name", { value: comp.data.nm });
	        _thisLayerFunction.layer = _thisLayerFunction;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
	        _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
	        _thisLayerFunction.displayStartTime = 0;
	        _thisLayerFunction.numLayers = comp.layers.length;
	        return _thisLayerFunction;
	    };
	}());
	var TransformExpressionInterface = (function (){
	    return function(transform){
	        function _thisFunction(name){
	            switch(name){
	                case "scale":
	                case "Scale":
	                case "ADBE Scale":
	                case 6:
	                    return _thisFunction.scale;
	                case "rotation":
	                case "Rotation":
	                case "ADBE Rotation":
	                case "ADBE Rotate Z":
	                case 10:
	                    return _thisFunction.rotation;
	                case "ADBE Rotate X":
	                    return _thisFunction.xRotation;
	                case "ADBE Rotate Y":
	                    return _thisFunction.yRotation;
	                case "position":
	                case "Position":
	                case "ADBE Position":
	                case 2:
	                    return _thisFunction.position;
	                case 'ADBE Position_0':
	                    return _thisFunction.xPosition;
	                case 'ADBE Position_1':
	                    return _thisFunction.yPosition;
	                case 'ADBE Position_2':
	                    return _thisFunction.zPosition;
	                case "anchorPoint":
	                case "AnchorPoint":
	                case "Anchor Point":
	                case "ADBE AnchorPoint":
	                case 1:
	                    return _thisFunction.anchorPoint;
	                case "opacity":
	                case "Opacity":
	                case 11:
	                    return _thisFunction.opacity;
	            }
	        }

	        Object.defineProperty(_thisFunction, "rotation", {
	            get: ExpressionPropertyInterface(transform.r || transform.rz)
	        });

	        Object.defineProperty(_thisFunction, "zRotation", {
	            get: ExpressionPropertyInterface(transform.rz || transform.r)
	        });

	        Object.defineProperty(_thisFunction, "xRotation", {
	            get: ExpressionPropertyInterface(transform.rx)
	        });

	        Object.defineProperty(_thisFunction, "yRotation", {
	            get: ExpressionPropertyInterface(transform.ry)
	        });
	        Object.defineProperty(_thisFunction, "scale", {
	            get: ExpressionPropertyInterface(transform.s)
	        });

	        if(transform.p) {
	            var _transformFactory = ExpressionPropertyInterface(transform.p);
	        }
	        Object.defineProperty(_thisFunction, "position", {
	            get: function () {
	                if(transform.p) {
	                    return _transformFactory();
	                } else {
	                    return [transform.px.v, transform.py.v, transform.pz ? transform.pz.v : 0];
	                }
	            }
	        });

	        Object.defineProperty(_thisFunction, "xPosition", {
	            get: ExpressionPropertyInterface(transform.px)
	        });

	        Object.defineProperty(_thisFunction, "yPosition", {
	            get: ExpressionPropertyInterface(transform.py)
	        });

	        Object.defineProperty(_thisFunction, "zPosition", {
	            get: ExpressionPropertyInterface(transform.pz)
	        });

	        Object.defineProperty(_thisFunction, "anchorPoint", {
	            get: ExpressionPropertyInterface(transform.a)
	        });

	        Object.defineProperty(_thisFunction, "opacity", {
	            get: ExpressionPropertyInterface(transform.o)
	        });

	        Object.defineProperty(_thisFunction, "skew", {
	            get: ExpressionPropertyInterface(transform.sk)
	        });

	        Object.defineProperty(_thisFunction, "skewAxis", {
	            get: ExpressionPropertyInterface(transform.sa)
	        });

	        Object.defineProperty(_thisFunction, "orientation", {
	            get: ExpressionPropertyInterface(transform.or)
	        });

	        return _thisFunction;
	    };
	}());
	var ProjectInterface = (function (){

	    function registerComposition(comp){
	        this.compositions.push(comp);
	    }

	    return function(){
	        function _thisProjectFunction(name){
	            var i = 0, len = this.compositions.length;
	            while(i<len){
	                if(this.compositions[i].data && this.compositions[i].data.nm === name){
	                    if(this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
	                        this.compositions[i].prepareFrame(this.currentFrame);
	                    }
	                    return this.compositions[i].compInterface;
	                }
	                i+=1;
	            }
	        }

	        _thisProjectFunction.compositions = [];
	        _thisProjectFunction.currentFrame = 0;

	        _thisProjectFunction.registerComposition = registerComposition;



	        return _thisProjectFunction;
	    };
	}());
	var EffectsExpressionInterface = (function (){
	    var ob = {
	        createEffectsInterface: createEffectsInterface
	    };

	    function createEffectsInterface(elem, propertyGroup){
	        if(elem.effectsManager){

	            var effectElements = [];
	            var effectsData = elem.data.ef;
	            var i, len = elem.effectsManager.effectElements.length;
	            for(i=0;i<len;i+=1){
	                effectElements.push(createGroupInterface(effectsData[i],elem.effectsManager.effectElements[i],propertyGroup,elem));
	            }

	            return function(name){
	                var effects = elem.data.ef || [], i = 0, len = effects.length;
	                while(i<len) {
	                    if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                        return effectElements[i];
	                    }
	                    i += 1;
	                }
	            };
	        }
	    }

	    function createGroupInterface(data,elements, propertyGroup, elem){
	        var effectElements = [];
	        var i, len = data.ef.length;
	        for(i=0;i<len;i+=1){
	            if(data.ef[i].ty === 5){
	                effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],elements.effectElements[i].propertyGroup, elem));
	            } else {
	                effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty, elem, _propertyGroup));
	            }
	        }

	        function _propertyGroup(val) {
	            if(val === 1){
	               return groupInterface;
	            } else {
	               return propertyGroup(val-1);
	            }
	        }

	        var groupInterface = function(name){
	            var effects = data.ef, i = 0, len = effects.length;
	            while(i<len) {
	                if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                    if(effects[i].ty === 5){
	                        return effectElements[i];
	                    } else {
	                        return effectElements[i]();
	                    }
	                }
	                i += 1;
	            }
	            return effectElements[0]();
	        };

	        groupInterface.propertyGroup = _propertyGroup;

	        if(data.mn === 'ADBE Color Control'){
	            Object.defineProperty(groupInterface, 'color', {
	                get: function(){
	                    return effectElements[0]();
	                }
	            });
	        }
	        Object.defineProperty(groupInterface, 'numProperties', {
	            get: function(){
	                return data.np;
	            }
	        });
	        groupInterface.active = groupInterface.enabled = data.en !== 0;
	        return groupInterface;
	    }

	    function createValueInterface(element, type, elem, propertyGroup){
	        var expressionProperty = ExpressionPropertyInterface(element.p);
	        function interfaceFunction(){
	            if(type === 10){
	                return elem.comp.compInterface(element.p.v);
	            }
	            return expressionProperty();
	        }

	        if(element.p.setGroupProperty) {
	            element.p.setGroupProperty(propertyGroup);
	        }

	        return interfaceFunction;
	    }

	    return ob;

	}());
	var MaskManagerInterface = (function(){

		function MaskInterface(mask, data){
			this._mask = mask;
			this._data = data;
		}
		Object.defineProperty(MaskInterface.prototype, 'maskPath', {
	        get: function(){
	            if(this._mask.prop.k){
	                this._mask.prop.getValue();
	            }
	            return this._mask.prop;
	        }
	    });
		Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
	        get: function(){
	            if(this._mask.op.k){
	                this._mask.op.getValue();
	            }
	            return this._mask.op.v * 100;
	        }
	    });

		var MaskManager = function(maskManager, elem){
			var _masksInterfaces = createSizedArray(maskManager.viewData.length);
			var i, len = maskManager.viewData.length;
			for(i = 0; i < len; i += 1) {
				_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
			}

			var maskFunction = function(name){
				i = 0;
			    while(i<len){
			        if(maskManager.masksProperties[i].nm === name){
			            return _masksInterfaces[i];
			        }
			        i += 1;
			    }
			};
			return maskFunction;
		};
		return MaskManager;
	}());

	var ExpressionPropertyInterface = (function() {

	    var defaultUnidimensionalValue = {pv:0, v:0, mult: 1};
	    var defaultMultidimensionalValue = {pv:[0,0,0], v:[0,0,0], mult: 1};

	    function completeProperty(expressionValue, property, type) {
	        Object.defineProperty(expressionValue, 'velocity', {
	            get: function(){
	                return property.getVelocityAtTime(property.comp.currentFrame);
	            }
	        });
	        expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
	        expressionValue.key = function(pos) {
	            if (!expressionValue.numKeys) {
	                return 0;
	            } else {
	                var value = '';
	                if ('s' in property.keyframes[pos-1]) {
	                    value = property.keyframes[pos-1].s;
	                } else if ('e' in property.keyframes[pos-2]) {
	                    value = property.keyframes[pos-2].e;
	                } else {
	                    value = property.keyframes[pos-2].s;
	                }
	                var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value);
	                valueProp.time = property.keyframes[pos-1].t / property.elem.comp.globalData.frameRate;
	                return valueProp;
	            }
	        };
	        expressionValue.valueAtTime = property.getValueAtTime;
	        expressionValue.speedAtTime = property.getSpeedAtTime;
	        expressionValue.velocityAtTime = property.getVelocityAtTime;
	        expressionValue.propertyGroup = property.propertyGroup;
	    }

	    function UnidimensionalPropertyInterface(property) {
	        if(!property || !('pv' in property)) {
	            property = defaultUnidimensionalValue;
	        }
	        var mult = 1 / property.mult;
	        var val = property.pv * mult;
	        var expressionValue = new Number(val);
	        expressionValue.value = val;
	        completeProperty(expressionValue, property, 'unidimensional');

	        return function() {
	            if (property.k) {
	                property.getValue();
	            }
	            val = property.v * mult;
	            if(expressionValue.value !== val) {
	                expressionValue = new Number(val);
	                expressionValue.value = val;
	                completeProperty(expressionValue, property, 'unidimensional');
	            }
	            return expressionValue;
	        }
	    }

	    function MultidimensionalPropertyInterface(property) {
	        if(!property || !('pv' in property)) {
	            property = defaultMultidimensionalValue;
	        }
	        var mult = 1 / property.mult;
	        var len = property.pv.length;
	        var expressionValue = createTypedArray('float32', len);
	        var arrValue = createTypedArray('float32', len);
	        expressionValue.value = arrValue;
	        completeProperty(expressionValue, property, 'multidimensional');

	        return function() {
	            if (property.k) {
	                property.getValue();
	            }
	            for (var i = 0; i < len; i += 1) {
	                expressionValue[i] = arrValue[i] = property.v[i] * mult;
	            }
	            return expressionValue;
	        }
	    }

	    //TODO: try to avoid using this getter
	    function defaultGetter() {
	        return defaultUnidimensionalValue;
	    }
	    
	    return function(property) {
	        if(!property) {
	            return defaultGetter;
	        } else if (property.propType === 'unidimensional') {
	            return UnidimensionalPropertyInterface(property);
	        } else {
	            return MultidimensionalPropertyInterface(property);
	        }
	    }
	}());

	(function(){

	    var TextExpressionSelectorProp = (function(){

	        function getValueProxy(index,total){
	            this.textIndex = index+1;
	            this.textTotal = total;
	            this.v = this.getValue() * this.mult;
	            return this.v;
	        }

	        return function TextExpressionSelectorProp(elem,data){
	            this.pv = 1;
	            this.comp = elem.comp;
	            this.elem = elem;
	            this.mult = 0.01;
	            this.propType = 'textSelector';
	            this.textTotal = data.totalChars;
	            this.selectorValue = 100;
	            this.lastValue = [1,1,1];
	            this.k = true;
	            this.x = true;
	            this.getValue = ExpressionManager.initiateExpression.bind(this)(elem,data,this);
	            this.getMult = getValueProxy;
	            this.getVelocityAtTime = expressionHelpers.getVelocityAtTime;
	            if(this.kf){
	                this.getValueAtTime = expressionHelpers.getValueAtTime.bind(this);
	            } else {
	                this.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(this);
	            }
	            this.setGroupProperty = expressionHelpers.setGroupProperty;
	        };
	    }());

		var propertyGetTextProp = TextSelectorProp.getTextSelectorProp;
		TextSelectorProp.getTextSelectorProp = function(elem, data,arr){
		    if(data.t === 1){
		        return new TextExpressionSelectorProp(elem, data,arr);
		    } else {
		        return propertyGetTextProp(elem,data,arr);
		    }
		};
	}());
	function SliderEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function AngleEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function ColorEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,container);
	}
	function PointEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,container);
	}
	function LayerIndexEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function MaskIndexEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function CheckboxEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function NoValueEffect(){
	    this.p = {};
	}
	function EffectsManager(){}
	function EffectsManager(data,element){
	    var effects = data.ef || [];
	    this.effectElements = [];
	    var i,len = effects.length;
	    var effectItem;
	    for(i=0;i<len;i++) {
	        effectItem = new GroupEffect(effects[i],element);
	        this.effectElements.push(effectItem);
	    }
	}

	function GroupEffect(data,element){
	    this.init(data,element);
	}

	extendPrototype([DynamicPropertyContainer], GroupEffect);

	GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;

	GroupEffect.prototype.init = function(data,element){
	    this.data = data;
	    this.effectElements = [];
	    this.initDynamicPropertyContainer(element);
	    var i, len = this.data.ef.length;
	    var eff, effects = this.data.ef;
	    for(i=0;i<len;i+=1){
	        eff = null;
	        switch(effects[i].ty){
	            case 0:
	                eff = new SliderEffect(effects[i],element,this);
	                break;
	            case 1:
	                eff = new AngleEffect(effects[i],element,this);
	                break;
	            case 2:
	                eff = new ColorEffect(effects[i],element,this);
	                break;
	            case 3:
	                eff = new PointEffect(effects[i],element,this);
	                break;
	            case 4:
	            case 7:
	                eff = new CheckboxEffect(effects[i],element,this);
	                break;
	            case 10:
	                eff = new LayerIndexEffect(effects[i],element,this);
	                break;
	            case 11:
	                eff = new MaskIndexEffect(effects[i],element,this);
	                break;
	            case 5:
	                eff = new EffectsManager(effects[i],element,this);
	                break;
	            //case 6:
	            default:
	                eff = new NoValueEffect(effects[i]);
	                break;
	        }
	        if(eff) {
	            this.effectElements.push(eff);
	        }
	    }
	};

	var lottie = {};

	function setLocationHref (href) {
	    locationHref = href;
	}

	function searchAnimations() {
	    {
	        animationManager.searchAnimations();
	    }
	}

	function setSubframeRendering(flag) {
	    subframeEnabled = flag;
	}

	function loadAnimation(params) {
	    return animationManager.loadAnimation(params);
	}

	function setQuality(value) {
	    if (typeof value === 'string') {
	        switch (value) {
	            case 'high':
	                defaultCurveSegments = 200;
	                break;
	            case 'medium':
	                defaultCurveSegments = 50;
	                break;
	            case 'low':
	                defaultCurveSegments = 10;
	                break;
	        }
	    } else if (!isNaN(value) && value > 1) {
	        defaultCurveSegments = value;
	    }
	}

	function inBrowser() {
	    return typeof navigator !== 'undefined';
	}

	function installPlugin(type, plugin) {
	    if (type === 'expressions') {
	        expressionsPlugin = plugin;
	    }
	}

	function getFactory(name) {
	    switch (name) {
	        case "propertyFactory":
	            return PropertyFactory;
	        case "shapePropertyFactory":
	            return ShapePropertyFactory;
	        case "matrix":
	            return Matrix;
	    }
	}

	lottie.play = animationManager.play;
	lottie.pause = animationManager.pause;
	lottie.setLocationHref = setLocationHref;
	lottie.togglePause = animationManager.togglePause;
	lottie.setSpeed = animationManager.setSpeed;
	lottie.setDirection = animationManager.setDirection;
	lottie.stop = animationManager.stop;
	lottie.searchAnimations = searchAnimations;
	lottie.registerAnimation = animationManager.registerAnimation;
	lottie.loadAnimation = loadAnimation;
	lottie.setSubframeRendering = setSubframeRendering;
	lottie.resize = animationManager.resize;
	//lottie.start = start;
	lottie.goToAndStop = animationManager.goToAndStop;
	lottie.destroy = animationManager.destroy;
	lottie.setQuality = setQuality;
	lottie.inBrowser = inBrowser;
	lottie.installPlugin = installPlugin;
	lottie.freeze = animationManager.freeze;
	lottie.unfreeze = animationManager.unfreeze;
	lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
	lottie.__getFactory = getFactory;
	lottie.version = '5.6.10';

	function checkReady() {
	    if (document.readyState === "complete") {
	        clearInterval(readyStateCheckInterval);
	        searchAnimations();
	    }
	}

	function getQueryVariable(variable) {
	    var vars = queryString.split('&');
	    for (var i = 0; i < vars.length; i++) {
	        var pair = vars[i].split('=');
	        if (decodeURIComponent(pair[0]) == variable) {
	            return decodeURIComponent(pair[1]);
	        }
	    }
	}
	{
	    var scripts = document.getElementsByTagName('script');
	    var index = scripts.length - 1;
	    var myScript = scripts[index] || {
	        src: ''
	    };
	    var queryString = myScript.src.replace(/^[^\?]+\??/, '');
	    getQueryVariable('renderer');
	}
	var readyStateCheckInterval = setInterval(checkReady, 100);

	return lottie;
	}));
} (lottie$1));

var lottie = lottie$1.exports;

var v$i = "5.6.9";
var fr$i = 60;
var ip$i = 0;
var op$i = 180;
var w$i = 300;
var h$i = 300;
var nm$i = "blue_bored";
var ddd$i = 0;
var assets$i = [
];
var layers$i = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 10,
									s: [
										{
											i: [
												[
													0,
													-1.258
												],
												[
													26.423,
													0
												],
												[
													0,
													0.93
												],
												[
													-25.32,
													0
												]
											],
											o: [
												[
													0,
													1.336
												],
												[
													-25.203,
													0
												],
												[
													0,
													-1.945
												],
												[
													25.743,
													0
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.514,
													-3.774
												],
												[
													-23.824,
													-4.805
												],
												[
													4.413,
													-5.686
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 75,
									s: [
										{
											i: [
												[
													0,
													-1.258
												],
												[
													26.423,
													0
												],
												[
													0,
													0.93
												],
												[
													-25.32,
													0
												]
											],
											o: [
												[
													0,
													1.336
												],
												[
													-25.203,
													0
												],
												[
													0,
													-1.945
												],
												[
													25.743,
													0
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.514,
													-3.774
												],
												[
													-23.824,
													-4.805
												],
												[
													4.413,
													-5.686
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 126,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													24.651,
													-4.305
												],
												[
													4.538,
													10.914
												],
												[
													-15.574,
													-4.305
												],
												[
													4.788,
													-22.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 128,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													24.651,
													-4.305
												],
												[
													4.538,
													10.914
												],
												[
													-15.574,
													-4.305
												],
												[
													4.788,
													-22.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 162,
									s: [
										{
											i: [
												[
													0,
													-1.258
												],
												[
													26.423,
													0
												],
												[
													0,
													0.93
												],
												[
													-25.32,
													0
												]
											],
											o: [
												[
													0,
													1.336
												],
												[
													-25.203,
													0
												],
												[
													0,
													-1.945
												],
												[
													25.743,
													0
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.514,
													-3.774
												],
												[
													-23.824,
													-4.805
												],
												[
													4.413,
													-5.686
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 0,
						s: [
							150.205,
							158.077,
							0
						],
						to: [
							0,
							0.625,
							0
						],
						ti: [
							0,
							-0.625,
							0
						]
					},
					{
						i: {
							x: 0.1,
							y: 0.1
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 10,
						s: [
							150.205,
							161.827,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.1,
							y: 1
						},
						o: {
							x: 0.1,
							y: 0
						},
						t: 75,
						s: [
							150.205,
							161.827,
							0
						],
						to: [
							0,
							-2.917,
							0
						],
						ti: [
							0,
							2.917,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 0.22
						},
						o: {
							x: 0.1,
							y: 0.1
						},
						t: 126,
						s: [
							150.205,
							144.327,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 128,
						s: [
							150.205,
							144.327,
							0
						],
						to: [
							0,
							2.917,
							0
						],
						ti: [
							0,
							-2.292,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 162,
						s: [
							150.205,
							161.827,
							0
						],
						to: [
							0,
							2.292,
							0
						],
						ti: [
							0,
							0.625,
							0
						]
					},
					{
						t: 179,
						s: [
							150.205,
							158.077,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					3.955,
					8.077,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-5.208,
										2.332
									],
									[
										6.438,
										0
									],
									[
										3.239,
										-2.707
									],
									[
										-6.439,
										0
									]
								],
								o: [
									[
										-3.239,
										-2.707
									],
									[
										-6.439,
										0
									],
									[
										3.239,
										2.707
									],
									[
										6.438,
										0
									]
								],
								v: [
									[
										19.277,
										9.456
									],
									[
										3.955,
										4.951
									],
									[
										-11.367,
										9.456
									],
									[
										4.538,
										10.914
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.909803926945,
								0.090196080506,
								0.301960796118,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 10,
									s: [
										{
											i: [
												[
													0,
													-1.258
												],
												[
													26.423,
													0
												],
												[
													0,
													0.93
												],
												[
													-25.32,
													0
												]
											],
											o: [
												[
													0,
													1.336
												],
												[
													-25.203,
													0
												],
												[
													0,
													-1.945
												],
												[
													25.743,
													0
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.514,
													-3.774
												],
												[
													-23.824,
													-4.805
												],
												[
													4.413,
													-5.686
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 75,
									s: [
										{
											i: [
												[
													0,
													-1.258
												],
												[
													26.423,
													0
												],
												[
													0,
													0.93
												],
												[
													-25.32,
													0
												]
											],
											o: [
												[
													0,
													1.336
												],
												[
													-25.203,
													0
												],
												[
													0,
													-1.945
												],
												[
													25.743,
													0
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.514,
													-3.774
												],
												[
													-23.824,
													-4.805
												],
												[
													4.413,
													-5.686
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 126,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													24.651,
													-4.305
												],
												[
													4.538,
													10.914
												],
												[
													-15.574,
													-4.305
												],
												[
													4.788,
													-22.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 128,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													24.651,
													-4.305
												],
												[
													4.538,
													10.914
												],
												[
													-15.574,
													-4.305
												],
												[
													4.788,
													-22.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 162,
									s: [
										{
											i: [
												[
													0,
													-1.258
												],
												[
													26.423,
													0
												],
												[
													0,
													0.93
												],
												[
													-25.32,
													0
												]
											],
											o: [
												[
													0,
													1.336
												],
												[
													-25.203,
													0
												],
												[
													0,
													-1.945
												],
												[
													25.743,
													0
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.514,
													-3.774
												],
												[
													-23.824,
													-4.805
												],
												[
													4.413,
													-5.686
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 0,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							-1.042,
							0
						],
						ti: [
							0,
							1.042,
							0
						]
					},
					{
						i: {
							x: 0.1,
							y: 0.1
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 10,
						s: [
							150.789,
							137.241,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.1,
							y: 1
						},
						o: {
							x: 0.1,
							y: 0
						},
						t: 75,
						s: [
							150.789,
							137.241,
							0
						],
						to: [
							0,
							-3.75,
							0
						],
						ti: [
							0,
							3.75,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 0.22
						},
						o: {
							x: 0.1,
							y: 0.1
						},
						t: 126,
						s: [
							150.789,
							114.741,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 128,
						s: [
							150.789,
							114.741,
							0
						],
						to: [
							0,
							3.75,
							0
						],
						ti: [
							0,
							-4.792,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 162,
						s: [
							150.789,
							137.241,
							0
						],
						to: [
							0,
							4.792,
							0
						],
						ti: [
							0,
							-1.042,
							0
						]
					},
					{
						t: 179,
						s: [
							150.789,
							143.491,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.539,
					-6.509,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										8.179,
										0.029
									],
									[
										-0.046,
										-2.596
									],
									[
										-1.283,
										0.011
									],
									[
										-5.247,
										0.255
									],
									[
										0,
										1.245
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0.14,
										1.858
									],
									[
										0.023,
										1.282
									],
									[
										6.155,
										-0.054
									],
									[
										1.244,
										-0.061
									],
									[
										0,
										0
									],
									[
										-6.537,
										-0.361
									]
								],
								v: [
									[
										6.378,
										-11.001
									],
									[
										6.663,
										-4.327
									],
									[
										9.021,
										-2.017
									],
									[
										26.239,
										-2.492
									],
									[
										28.455,
										-4.828
									],
									[
										29.625,
										-10.395
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										6.537,
										-0.361
									],
									[
										0,
										0
									],
									[
										-1.243,
										-0.061
									],
									[
										-6.155,
										-0.054
									],
									[
										-0.023,
										1.282
									],
									[
										-0.14,
										1.858
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										1.245
									],
									[
										5.248,
										0.255
									],
									[
										1.283,
										0.011
									],
									[
										0.046,
										-2.596
									],
									[
										-8.179,
										0.029
									]
								],
								v: [
									[
										-20.547,
										-10.395
									],
									[
										-19.378,
										-4.828
									],
									[
										-17.162,
										-2.492
									],
									[
										0.056,
										-2.017
									],
									[
										2.414,
										-4.327
									],
									[
										2.699,
										-11.001
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.471,
							y: 0.812
						},
						o: {
							x: 0.606,
							y: 0
						},
						t: 0,
						s: [
							150.788,
							151.064,
							0
						],
						to: [
							0,
							1.046,
							0
						],
						ti: [
							0,
							-2.705,
							0
						]
					},
					{
						i: {
							x: 0.61,
							y: 1
						},
						o: {
							x: 0.137,
							y: 1
						},
						t: 15,
						s: [
							150.788,
							159.473,
							0
						],
						to: [
							0,
							1.425,
							0
						],
						ti: [
							0,
							0.104,
							0
						]
					},
					{
						i: {
							x: 0.1,
							y: 1
						},
						o: {
							x: 0.1,
							y: 0
						},
						t: 75,
						s: [
							150.788,
							161.064,
							0
						],
						to: [
							0,
							-2.5,
							0
						],
						ti: [
							0,
							4.167,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 0.22
						},
						o: {
							x: 0.1,
							y: 0.1
						},
						t: 126,
						s: [
							150.788,
							136.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 128,
						s: [
							150.788,
							136.064,
							0
						],
						to: [
							0,
							4.167,
							0
						],
						ti: [
							0,
							-2.5,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 162,
						s: [
							150.788,
							161.064,
							0
						],
						to: [
							0,
							2.5,
							0
						],
						ti: [
							0,
							-1.667,
							0
						]
					},
					{
						t: 179,
						s: [
							150.788,
							151.064,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 10,
									s: [
										{
											i: [
												[
													0,
													-1.258
												],
												[
													26.423,
													0
												],
												[
													0,
													0.93
												],
												[
													-25.32,
													0
												]
											],
											o: [
												[
													0,
													1.336
												],
												[
													-25.203,
													0
												],
												[
													0,
													-1.945
												],
												[
													25.743,
													0
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.514,
													-3.774
												],
												[
													-23.824,
													-4.805
												],
												[
													4.413,
													-5.686
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 75,
									s: [
										{
											i: [
												[
													0,
													-1.258
												],
												[
													26.423,
													0
												],
												[
													0,
													0.93
												],
												[
													-25.32,
													0
												]
											],
											o: [
												[
													0,
													1.336
												],
												[
													-25.203,
													0
												],
												[
													0,
													-1.945
												],
												[
													25.743,
													0
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.514,
													-3.774
												],
												[
													-23.824,
													-4.805
												],
												[
													4.413,
													-5.686
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 126,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													24.651,
													-4.305
												],
												[
													4.538,
													10.914
												],
												[
													-15.574,
													-4.305
												],
												[
													4.788,
													-22.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 128,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													24.651,
													-4.305
												],
												[
													4.538,
													10.914
												],
												[
													-15.574,
													-4.305
												],
												[
													4.788,
													-22.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 162,
									s: [
										{
											i: [
												[
													0,
													-1.258
												],
												[
													26.423,
													0
												],
												[
													0,
													0.93
												],
												[
													-25.32,
													0
												]
											],
											o: [
												[
													0,
													1.336
												],
												[
													-25.203,
													0
												],
												[
													0,
													-1.945
												],
												[
													25.743,
													0
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.514,
													-3.774
												],
												[
													-23.824,
													-4.805
												],
												[
													4.413,
													-5.686
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eye white left",
		parent: 7,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-16.705,
							-30.107,
							0
						],
						to: [
							0,
							0.521,
							0
						],
						ti: [
							0,
							-0.521,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 10,
						s: [
							-16.705,
							-26.982,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 162,
						s: [
							-16.705,
							-26.982,
							0
						],
						to: [
							0,
							-0.521,
							0
						],
						ti: [
							0,
							0.521,
							0
						]
					},
					{
						t: 179,
						s: [
							-16.705,
							-30.107,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.705,
					-30.107,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-15.455,
										-30.107
									],
									[
										-16.705,
										-28.857
									],
									[
										-17.955,
										-30.107
									],
									[
										-16.705,
										-31.357
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							131.295,
							121.643,
							0
						],
						to: [
							0,
							1.667,
							0
						],
						ti: [
							0,
							-1.667,
							0
						]
					},
					{
						i: {
							x: 0.19,
							y: 0.19
						},
						o: {
							x: 0.54,
							y: 0.54
						},
						t: 30,
						s: [
							131.295,
							131.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.1,
							y: 1
						},
						o: {
							x: 0.1,
							y: 0
						},
						t: 75,
						s: [
							131.295,
							131.643,
							0
						],
						to: [
							0,
							-4.167,
							0
						],
						ti: [
							0,
							4.167,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 0.22
						},
						o: {
							x: 0.1,
							y: 0.1
						},
						t: 126,
						s: [
							131.295,
							106.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 128,
						s: [
							131.295,
							106.643,
							0
						],
						to: [
							0,
							4.167,
							0
						],
						ti: [
							0,
							-2.5,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 162,
						s: [
							131.295,
							131.643,
							0
						],
						to: [
							0,
							2.5,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						t: 179,
						s: [
							131.295,
							121.643,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-14.955,
					-28.357,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 30,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 33,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 36,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 75,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 88,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 126,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 141,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 10,
									s: [
										{
											i: [
												[
													0.08,
													0
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													-0.17,
													0
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.969,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.952,
													-28.388
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 162,
									s: [
										{
											i: [
												[
													0.08,
													0
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													-0.17,
													0
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.969,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.952,
													-28.388
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye white right",
		parent: 9,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0.521,
							0
						],
						ti: [
							0,
							-0.521,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 10,
						s: [
							21.1,
							-26.588,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 162,
						s: [
							21.1,
							-26.588,
							0
						],
						to: [
							0,
							-0.521,
							0
						],
						ti: [
							0,
							0.521,
							0
						]
					},
					{
						t: 179,
						s: [
							21.1,
							-29.713,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					21.1,
					-29.713,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										22.35,
										-29.713
									],
									[
										21.1,
										-28.463
									],
									[
										19.85,
										-29.713
									],
									[
										21.1,
										-30.963
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							169.1,
							122.037,
							0
						],
						to: [
							0,
							1.667,
							0
						],
						ti: [
							0,
							-1.667,
							0
						]
					},
					{
						i: {
							x: 0.19,
							y: 0.19
						},
						o: {
							x: 0.54,
							y: 0.54
						},
						t: 30,
						s: [
							169.1,
							132.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.1,
							y: 1
						},
						o: {
							x: 0.1,
							y: 0
						},
						t: 75,
						s: [
							169.1,
							132.037,
							0
						],
						to: [
							0,
							-4.167,
							0
						],
						ti: [
							0,
							4.167,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 0.22
						},
						o: {
							x: 0.1,
							y: 0.1
						},
						t: 126,
						s: [
							169.1,
							107.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 128,
						s: [
							169.1,
							107.037,
							0
						],
						to: [
							0,
							4.167,
							0
						],
						ti: [
							0,
							-2.5,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 162,
						s: [
							169.1,
							132.037,
							0
						],
						to: [
							0,
							2.5,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						t: 179,
						s: [
							169.1,
							122.037,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					22.85,
					-27.963,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 30,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 33,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 36,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 75,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 88,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 126,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 141,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 10,
									s: [
										{
											i: [
												[
													0,
													-0.1
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-0.006
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-28
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.861,
													-27.9
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 162,
									s: [
										{
											i: [
												[
													0,
													-0.1
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-0.006
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-28
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.861,
													-27.9
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "hat",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					37.193,
					-103.34,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					37.193,
					-103.34,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 75,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 126,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													33.467,
													6.696
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 128,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													33.467,
													6.696
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									t: 162,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.352941185236,
								0.717647075653,
								0.870588243008,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 12,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 75,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 126,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.154,
													-2.558
												],
												[
													3.048,
													-10.644
												]
											],
											o: [
												[
													3.217,
													-9.179
												],
												[
													6.775,
													2.423
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													43.6,
													-110.048
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 128,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.154,
													-2.558
												],
												[
													3.048,
													-10.644
												]
											],
											o: [
												[
													3.217,
													-9.179
												],
												[
													6.775,
													2.423
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													43.6,
													-110.048
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									t: 162,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.223529413342,
								0.662745118141,
								0.882352948189,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							1.667,
							0
						],
						ti: [
							0,
							-1.667,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 30,
						s: [
							150.205,
							141.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 75,
						s: [
							150.205,
							141.599,
							0
						],
						to: [
							0,
							-1.667,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 126,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 128,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							1.667,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 162,
						s: [
							150.205,
							141.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						t: 179,
						s: [
							150.205,
							131.599,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					3.955,
					-18.401,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-48.329
									],
									[
										48.329,
										0
									],
									[
										0,
										48.329
									],
									[
										-48.329,
										0
									]
								],
								o: [
									[
										0,
										48.329
									],
									[
										-48.329,
										0
									],
									[
										0,
										-48.329
									],
									[
										48.329,
										0
									]
								],
								v: [
									[
										91.463,
										-18.401
									],
									[
										3.955,
										69.106
									],
									[
										-83.553,
										-18.401
									],
									[
										3.955,
										-105.909
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0.09,
									0.545,
									0.863,
									1,
									0.46,
									0.449,
									0.851,
									1,
									0.83,
									0.353,
									0.839,
									1,
									0.89,
									0.353,
									0.839,
									1,
									0.95,
									0.353,
									0.839,
									1
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								3,
								-20
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								90.393,
								-19
							],
							ix: 6
						},
						t: 2,
						h: {
							a: 0,
							k: 0,
							ix: 7
						},
						a: {
							a: 0,
							k: 0,
							ix: 8
						},
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "arm left",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-68.945,
					24.924,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-68.945,
					24.924,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-12.283,
													-34.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-61.467,
													68.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 146,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-12.283,
													-34.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-61.467,
													68.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196078431,
								0.890196078431,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "arm right",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					78.794,
					24.924,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					78.794,
					24.924,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													8.434,
													-31.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													71.816,
													63.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 51,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													45.434,
													-33.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													80.816,
													37.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 56,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													45.434,
													-33.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													70.816,
													49.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 67.875,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													45.434,
													-33.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													81.816,
													35.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													45.434,
													-33.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													70.816,
													49.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 91.875,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													45.434,
													-33.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													81.816,
													35.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 102,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													45.434,
													-33.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													70.816,
													49.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 112,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													45.434,
													-33.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													81.816,
													35.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 126,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													45.434,
													-33.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													70.816,
													49.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									t: 162,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "sock left",
		parent: 16,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-16.159,
					121.574,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					121.574,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.623
									],
									[
										0,
										0
									],
									[
										5.993,
										-0.388
									],
									[
										0,
										6.474
									],
									[
										0,
										0
									],
									[
										-0.623,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										6.005
									],
									[
										-6.566,
										0.425
									],
									[
										0,
										0
									],
									[
										0,
										-0.623
									],
									[
										0,
										0
									],
									[
										0.623,
										0
									]
								],
								v: [
									[
										-4.885,
										81.842
									],
									[
										-4.885,
										109.913
									],
									[
										-15.409,
										121.549
									],
									[
										-27.433,
										110.299
									],
									[
										-27.433,
										81.842
									],
									[
										-26.306,
										80.715
									],
									[
										-6.012,
										80.715
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "sock right",
		parent: 17,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					24.069,
					121.574,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					121.574,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.623
									],
									[
										0,
										0
									],
									[
										5.993,
										-0.388
									],
									[
										0,
										6.474
									],
									[
										0,
										0
									],
									[
										-0.623,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										6.005
									],
									[
										-6.566,
										0.425
									],
									[
										0,
										0
									],
									[
										0,
										-0.623
									],
									[
										0,
										0
									],
									[
										0.623,
										0
									]
								],
								v: [
									[
										35.343,
										81.842
									],
									[
										35.343,
										109.913
									],
									[
										24.819,
										121.549
									],
									[
										12.795,
										110.299
									],
									[
										12.795,
										81.842
									],
									[
										13.922,
										80.715
									],
									[
										34.216,
										80.715
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.091,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-16.159,
										110.639
									],
									[
										-16.159,
										28.873
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					170.319,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										24.069,
										110.639
									],
									[
										24.069,
										28.873
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					151,
					270,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$i = [
];
var AbbeBored = {
	v: v$i,
	fr: fr$i,
	ip: ip$i,
	op: op$i,
	w: w$i,
	h: h$i,
	nm: nm$i,
	ddd: ddd$i,
	assets: assets$i,
	layers: layers$i,
	markers: markers$i
};

var v$h = "5.6.9";
var fr$h = 60;
var ip$h = 0;
var op$h = 141;
var w$h = 300;
var h$h = 300;
var nm$h = "blue_happy";
var ddd$h = 0;
var assets$h = [
	{
		id: "comp_0",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "tounge mask",
				parent: 5,
				td: 1,
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 0,
								s: [
									4.538,
									1.064,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 21,
								s: [
									4.538,
									1.064,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 41,
								s: [
									4.538,
									1.064,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 61,
								s: [
									4.538,
									1.064,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 80,
								s: [
									4.538,
									1.064,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 100,
								s: [
									4.538,
									1.064,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 120,
								s: [
									4.538,
									1.064,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							4.538,
							1.064,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												-5.006
											],
											[
												15.664,
												0
											],
											[
												0,
												6.669
											],
											[
												-14.181,
												-0.249
											]
										],
										o: [
											[
												0,
												6.097
											],
											[
												-15.664,
												0
											],
											[
												0,
												-6.002
											],
											[
												14.181,
												0.249
											]
										],
										v: [
											[
												32.901,
												-4.805
											],
											[
												4.538,
												10.914
											],
											[
												-23.824,
												-4.805
											],
											[
												4.538,
												-8.061
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 90,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "tounge",
				tt: 1,
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 0,
								s: [
									153.955,
									158.077,
									0
								],
								to: [
									0,
									5,
									0
								],
								ti: [
									0,
									5,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 21,
								s: [
									153.955,
									188.077,
									0
								],
								to: [
									0,
									-5,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 41,
								s: [
									153.955,
									128.077,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 61,
								s: [
									153.955,
									188.077,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 80,
								s: [
									153.955,
									128.077,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									-5,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 100,
								s: [
									153.955,
									188.077,
									0
								],
								to: [
									0,
									5,
									0
								],
								ti: [
									0,
									5,
									0
								]
							},
							{
								t: 120,
								s: [
									153.955,
									158.077,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							3.955,
							8.077,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 1,
											s: [
												{
													i: [
														[
															-5.208,
															2.332
														],
														[
															6.438,
															0
														],
														[
															3.239,
															-2.707
														],
														[
															-6.439,
															0
														]
													],
													o: [
														[
															-3.239,
															-2.707
														],
														[
															-6.439,
															0
														],
														[
															3.239,
															2.707
														],
														[
															6.438,
															0
														]
													],
													v: [
														[
															19.277,
															9.456
														],
														[
															3.955,
															4.951
														],
														[
															-11.367,
															9.456
														],
														[
															4.538,
															10.914
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 24,
											s: [
												{
													i: [
														[
															-5.208,
															2.332
														],
														[
															9.42,
															0
														],
														[
															3.239,
															-2.707
														],
														[
															-6.439,
															0
														]
													],
													o: [
														[
															-3.239,
															-2.707
														],
														[
															-9.205,
															0
														],
														[
															3.239,
															2.707
														],
														[
															6.438,
															0
														]
													],
													v: [
														[
															19.277,
															9.456
														],
														[
															3.955,
															2.607
														],
														[
															-11.367,
															9.456
														],
														[
															4.538,
															10.914
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 44,
											s: [
												{
													i: [
														[
															-5.208,
															2.332
														],
														[
															9.42,
															0
														],
														[
															2.117,
															-1.774
														],
														[
															-6.439,
															0
														]
													],
													o: [
														[
															-2.652,
															-1.649
														],
														[
															-9.205,
															0
														],
														[
															3.239,
															2.707
														],
														[
															6.438,
															0
														]
													],
													v: [
														[
															19.277,
															9.456
														],
														[
															3.91,
															7.357
														],
														[
															-11.367,
															9.456
														],
														[
															4.538,
															10.914
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 64,
											s: [
												{
													i: [
														[
															-5.208,
															2.332
														],
														[
															9.42,
															0
														],
														[
															3.239,
															-2.707
														],
														[
															-6.439,
															0
														]
													],
													o: [
														[
															-3.239,
															-2.707
														],
														[
															-9.205,
															0
														],
														[
															3.239,
															2.707
														],
														[
															6.438,
															0
														]
													],
													v: [
														[
															19.277,
															9.456
														],
														[
															3.955,
															2.607
														],
														[
															-11.367,
															9.456
														],
														[
															4.538,
															10.914
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 83,
											s: [
												{
													i: [
														[
															-5.208,
															2.332
														],
														[
															9.42,
															0
														],
														[
															2.117,
															-1.774
														],
														[
															-6.439,
															0
														]
													],
													o: [
														[
															-2.652,
															-1.649
														],
														[
															-9.205,
															0
														],
														[
															3.239,
															2.707
														],
														[
															6.438,
															0
														]
													],
													v: [
														[
															19.277,
															9.456
														],
														[
															3.91,
															7.357
														],
														[
															-11.367,
															9.456
														],
														[
															4.538,
															10.914
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 103,
											s: [
												{
													i: [
														[
															-5.208,
															2.332
														],
														[
															9.42,
															0
														],
														[
															3.239,
															-2.707
														],
														[
															-6.439,
															0
														]
													],
													o: [
														[
															-3.239,
															-2.707
														],
														[
															-9.205,
															0
														],
														[
															3.239,
															2.707
														],
														[
															6.438,
															0
														]
													],
													v: [
														[
															19.277,
															9.456
														],
														[
															3.955,
															2.607
														],
														[
															-11.367,
															9.456
														],
														[
															4.538,
															10.914
														]
													],
													c: true
												}
											]
										},
										{
											t: 123,
											s: [
												{
													i: [
														[
															-5.208,
															2.332
														],
														[
															6.438,
															0
														],
														[
															3.239,
															-2.707
														],
														[
															-6.439,
															0
														]
													],
													o: [
														[
															-3.239,
															-2.707
														],
														[
															-6.439,
															0
														],
														[
															3.239,
															2.707
														],
														[
															6.438,
															0
														]
													],
													v: [
														[
															19.277,
															9.456
														],
														[
															3.955,
															4.951
														],
														[
															-11.367,
															9.456
														],
														[
															4.538,
															10.914
														]
													],
													c: true
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.909803926945,
										0.090196080506,
										0.301960796118,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 90,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "teeth mask",
				parent: 5,
				td: 1,
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							4.538,
							1.064,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							4.538,
							1.064,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												-5.006
											],
											[
												15.664,
												0
											],
											[
												0,
												6.669
											],
											[
												-14.181,
												-0.249
											]
										],
										o: [
											[
												0,
												6.097
											],
											[
												-15.664,
												0
											],
											[
												0,
												-6.002
											],
											[
												14.181,
												0.249
											]
										],
										v: [
											[
												32.901,
												-4.805
											],
											[
												4.538,
												10.914
											],
											[
												-23.824,
												-4.805
											],
											[
												4.538,
												-8.061
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 90,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "teeth",
				tt: 1,
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 0,
								s: [
									154.539,
									143.491,
									0
								],
								to: [
									0,
									5,
									0
								],
								ti: [
									0,
									5,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 21,
								s: [
									154.539,
									173.491,
									0
								],
								to: [
									0,
									-5,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 41,
								s: [
									154.539,
									113.491,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 61,
								s: [
									154.539,
									173.491,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 80,
								s: [
									154.539,
									113.491,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									-5,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 100,
								s: [
									154.539,
									173.491,
									0
								],
								to: [
									0,
									5,
									0
								],
								ti: [
									0,
									5,
									0
								]
							},
							{
								t: 120,
								s: [
									154.539,
									143.491,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							4.539,
							-6.509,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 2,
											s: [
												{
													i: [
														[
															8.179,
															0.029
														],
														[
															-0.046,
															-2.596
														],
														[
															-1.283,
															0.011
														],
														[
															-5.247,
															0.255
														],
														[
															0,
															1.245
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0.14,
															1.858
														],
														[
															0.023,
															1.282
														],
														[
															6.155,
															-0.054
														],
														[
															1.244,
															-0.061
														],
														[
															0,
															0
														],
														[
															-6.537,
															-0.361
														]
													],
													v: [
														[
															6.378,
															-11.001
														],
														[
															6.663,
															-4.327
														],
														[
															9.021,
															-2.017
														],
														[
															26.239,
															-2.492
														],
														[
															28.455,
															-4.828
														],
														[
															29.625,
															-10.395
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 23,
											s: [
												{
													i: [
														[
															8.179,
															0.029
														],
														[
															-0.046,
															-2.596
														],
														[
															-1.283,
															0.011
														],
														[
															-5.247,
															0.255
														],
														[
															0,
															1.245
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0.14,
															1.858
														],
														[
															0.023,
															1.282
														],
														[
															6.155,
															-0.054
														],
														[
															1.244,
															-0.061
														],
														[
															0,
															0
														],
														[
															-6.537,
															-0.361
														]
													],
													v: [
														[
															6.378,
															-11.001
														],
														[
															6.663,
															-6.671
														],
														[
															9.021,
															-4.361
														],
														[
															26.239,
															-4.836
														],
														[
															28.455,
															-7.172
														],
														[
															29.625,
															-10.395
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 43,
											s: [
												{
													i: [
														[
															8.179,
															0.029
														],
														[
															-0.046,
															-2.596
														],
														[
															-1.283,
															0.011
														],
														[
															-5.247,
															0.255
														],
														[
															0,
															1.245
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0.14,
															1.858
														],
														[
															0.023,
															1.282
														],
														[
															6.155,
															-0.054
														],
														[
															1.244,
															-0.061
														],
														[
															0,
															0
														],
														[
															-6.537,
															-0.361
														]
													],
													v: [
														[
															6.378,
															-11.001
														],
														[
															6.663,
															-2.296
														],
														[
															9.021,
															0.014
														],
														[
															26.239,
															-0.461
														],
														[
															28.455,
															-2.797
														],
														[
															29.625,
															-10.395
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 63,
											s: [
												{
													i: [
														[
															8.179,
															0.029
														],
														[
															-0.046,
															-2.596
														],
														[
															-1.283,
															0.011
														],
														[
															-5.247,
															0.255
														],
														[
															0,
															1.245
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0.14,
															1.858
														],
														[
															0.023,
															1.282
														],
														[
															6.155,
															-0.054
														],
														[
															1.244,
															-0.061
														],
														[
															0,
															0
														],
														[
															-6.537,
															-0.361
														]
													],
													v: [
														[
															6.378,
															-11.001
														],
														[
															6.663,
															-6.671
														],
														[
															9.021,
															-4.361
														],
														[
															26.239,
															-4.836
														],
														[
															28.455,
															-7.172
														],
														[
															29.625,
															-10.395
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 82,
											s: [
												{
													i: [
														[
															8.179,
															0.029
														],
														[
															-0.046,
															-2.596
														],
														[
															-1.283,
															0.011
														],
														[
															-5.247,
															0.255
														],
														[
															0,
															1.245
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0.14,
															1.858
														],
														[
															0.023,
															1.282
														],
														[
															6.155,
															-0.054
														],
														[
															1.244,
															-0.061
														],
														[
															0,
															0
														],
														[
															-6.537,
															-0.361
														]
													],
													v: [
														[
															6.378,
															-11.001
														],
														[
															6.663,
															-2.296
														],
														[
															9.021,
															0.014
														],
														[
															26.239,
															-0.461
														],
														[
															28.455,
															-2.797
														],
														[
															29.625,
															-10.395
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 102,
											s: [
												{
													i: [
														[
															8.179,
															0.029
														],
														[
															-0.046,
															-2.596
														],
														[
															-1.283,
															0.011
														],
														[
															-5.247,
															0.255
														],
														[
															0,
															1.245
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0.14,
															1.858
														],
														[
															0.023,
															1.282
														],
														[
															6.155,
															-0.054
														],
														[
															1.244,
															-0.061
														],
														[
															0,
															0
														],
														[
															-6.537,
															-0.361
														]
													],
													v: [
														[
															6.378,
															-11.001
														],
														[
															6.663,
															-6.671
														],
														[
															9.021,
															-4.361
														],
														[
															26.239,
															-4.836
														],
														[
															28.455,
															-7.172
														],
														[
															29.625,
															-10.395
														]
													],
													c: true
												}
											]
										},
										{
											t: 122,
											s: [
												{
													i: [
														[
															8.179,
															0.029
														],
														[
															-0.046,
															-2.596
														],
														[
															-1.283,
															0.011
														],
														[
															-5.247,
															0.255
														],
														[
															0,
															1.245
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0.14,
															1.858
														],
														[
															0.023,
															1.282
														],
														[
															6.155,
															-0.054
														],
														[
															1.244,
															-0.061
														],
														[
															0,
															0
														],
														[
															-6.537,
															-0.361
														]
													],
													v: [
														[
															6.378,
															-11.001
														],
														[
															6.663,
															-4.327
														],
														[
															9.021,
															-2.017
														],
														[
															26.239,
															-2.492
														],
														[
															28.455,
															-4.828
														],
														[
															29.625,
															-10.395
														]
													],
													c: true
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 2,
											s: [
												{
													i: [
														[
															6.537,
															-0.361
														],
														[
															0,
															0
														],
														[
															-1.243,
															-0.061
														],
														[
															-6.155,
															-0.054
														],
														[
															-0.023,
															1.282
														],
														[
															-0.14,
															1.858
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															1.245
														],
														[
															5.248,
															0.255
														],
														[
															1.283,
															0.011
														],
														[
															0.046,
															-2.596
														],
														[
															-8.179,
															0.029
														]
													],
													v: [
														[
															-20.547,
															-10.395
														],
														[
															-19.378,
															-4.828
														],
														[
															-17.162,
															-2.492
														],
														[
															0.056,
															-2.017
														],
														[
															2.414,
															-4.327
														],
														[
															2.699,
															-11.001
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 23,
											s: [
												{
													i: [
														[
															6.537,
															-0.361
														],
														[
															0,
															0
														],
														[
															-1.243,
															-0.061
														],
														[
															-6.155,
															-0.054
														],
														[
															-0.023,
															1.282
														],
														[
															-0.14,
															1.858
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															1.245
														],
														[
															5.248,
															0.255
														],
														[
															1.283,
															0.011
														],
														[
															0.046,
															-2.596
														],
														[
															-8.179,
															0.029
														]
													],
													v: [
														[
															-20.547,
															-10.395
														],
														[
															-19.378,
															-7.172
														],
														[
															-17.162,
															-4.836
														],
														[
															0.056,
															-4.361
														],
														[
															2.414,
															-6.671
														],
														[
															2.699,
															-11.001
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 43,
											s: [
												{
													i: [
														[
															6.537,
															-0.361
														],
														[
															0,
															0
														],
														[
															-1.243,
															-0.061
														],
														[
															-6.155,
															-0.054
														],
														[
															-0.023,
															1.282
														],
														[
															-0.14,
															1.858
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															1.245
														],
														[
															5.248,
															0.255
														],
														[
															1.283,
															0.011
														],
														[
															0.046,
															-2.596
														],
														[
															-8.179,
															0.029
														]
													],
													v: [
														[
															-20.547,
															-10.395
														],
														[
															-19.378,
															-2.797
														],
														[
															-17.162,
															-0.461
														],
														[
															0.056,
															0.014
														],
														[
															2.414,
															-2.296
														],
														[
															2.699,
															-11.001
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 63,
											s: [
												{
													i: [
														[
															6.537,
															-0.361
														],
														[
															0,
															0
														],
														[
															-1.243,
															-0.061
														],
														[
															-6.155,
															-0.054
														],
														[
															-0.023,
															1.282
														],
														[
															-0.14,
															1.858
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															1.245
														],
														[
															5.248,
															0.255
														],
														[
															1.283,
															0.011
														],
														[
															0.046,
															-2.596
														],
														[
															-8.179,
															0.029
														]
													],
													v: [
														[
															-20.547,
															-10.395
														],
														[
															-19.378,
															-7.172
														],
														[
															-17.162,
															-4.836
														],
														[
															0.056,
															-4.361
														],
														[
															2.414,
															-6.671
														],
														[
															2.699,
															-11.001
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 82,
											s: [
												{
													i: [
														[
															6.537,
															-0.361
														],
														[
															0,
															0
														],
														[
															-1.243,
															-0.061
														],
														[
															-6.155,
															-0.054
														],
														[
															-0.023,
															1.282
														],
														[
															-0.14,
															1.858
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															1.245
														],
														[
															5.248,
															0.255
														],
														[
															1.283,
															0.011
														],
														[
															0.046,
															-2.596
														],
														[
															-8.179,
															0.029
														]
													],
													v: [
														[
															-20.547,
															-10.395
														],
														[
															-19.378,
															-2.797
														],
														[
															-17.162,
															-0.461
														],
														[
															0.056,
															0.014
														],
														[
															2.414,
															-2.296
														],
														[
															2.699,
															-11.001
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 102,
											s: [
												{
													i: [
														[
															6.537,
															-0.361
														],
														[
															0,
															0
														],
														[
															-1.243,
															-0.061
														],
														[
															-6.155,
															-0.054
														],
														[
															-0.023,
															1.282
														],
														[
															-0.14,
															1.858
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															1.245
														],
														[
															5.248,
															0.255
														],
														[
															1.283,
															0.011
														],
														[
															0.046,
															-2.596
														],
														[
															-8.179,
															0.029
														]
													],
													v: [
														[
															-20.547,
															-10.395
														],
														[
															-19.378,
															-7.172
														],
														[
															-17.162,
															-4.836
														],
														[
															0.056,
															-4.361
														],
														[
															2.414,
															-6.671
														],
														[
															2.699,
															-11.001
														]
													],
													c: true
												}
											]
										},
										{
											t: 122,
											s: [
												{
													i: [
														[
															6.537,
															-0.361
														],
														[
															0,
															0
														],
														[
															-1.243,
															-0.061
														],
														[
															-6.155,
															-0.054
														],
														[
															-0.023,
															1.282
														],
														[
															-0.14,
															1.858
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															1.245
														],
														[
															5.248,
															0.255
														],
														[
															1.283,
															0.011
														],
														[
															0.046,
															-2.596
														],
														[
															-8.179,
															0.029
														]
													],
													v: [
														[
															-20.547,
															-10.395
														],
														[
															-19.378,
															-4.828
														],
														[
															-17.162,
															-2.492
														],
														[
															0.056,
															-2.017
														],
														[
															2.414,
															-4.327
														],
														[
															2.699,
															-11.001
														]
													],
													c: true
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "mouth",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 0,
								s: [
									154.538,
									151.064,
									0
								],
								to: [
									0,
									5,
									0
								],
								ti: [
									0,
									5,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 21,
								s: [
									154.538,
									181.064,
									0
								],
								to: [
									0,
									-5,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 41,
								s: [
									154.538,
									121.064,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 61,
								s: [
									154.538,
									181.064,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 80,
								s: [
									154.538,
									121.064,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									-5,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 100,
								s: [
									154.538,
									181.064,
									0
								],
								to: [
									0,
									5,
									0
								],
								ti: [
									0,
									5,
									0
								]
							},
							{
								t: 120,
								s: [
									154.538,
									151.064,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							4.538,
							1.064,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												-5.006
											],
											[
												15.664,
												0
											],
											[
												0,
												6.669
											],
											[
												-14.181,
												-0.249
											]
										],
										o: [
											[
												0,
												6.097
											],
											[
												-15.664,
												0
											],
											[
												0,
												-6.002
											],
											[
												14.181,
												0.249
											]
										],
										v: [
											[
												32.901,
												-4.805
											],
											[
												4.538,
												10.914
											],
											[
												-23.824,
												-4.805
											],
											[
												4.538,
												-8.061
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 90,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "eye white left",
				parent: 7,
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 1,
								s: [
									-16.705,
									-30.107,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 22,
								s: [
									-16.705,
									-30.107,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 42,
								s: [
									-16.705,
									-30.107,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 62,
								s: [
									-16.705,
									-30.107,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 81,
								s: [
									-16.705,
									-30.107,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 101,
								s: [
									-16.705,
									-30.107,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 121,
								s: [
									-16.705,
									-30.107,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							-16.705,
							-30.107,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												-0.69
											],
											[
												0.69,
												0
											],
											[
												0,
												0.69
											],
											[
												-0.69,
												0
											]
										],
										o: [
											[
												0,
												0.69
											],
											[
												-0.69,
												0
											],
											[
												0,
												-0.69
											],
											[
												0.69,
												0
											]
										],
										v: [
											[
												-15.455,
												-30.107
											],
											[
												-16.705,
												-28.857
											],
											[
												-17.955,
												-30.107
											],
											[
												-16.705,
												-31.357
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 65,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "eye left",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 1,
								s: [
									135.045,
									121.643,
									0
								],
								to: [
									0,
									6.667,
									0
								],
								ti: [
									0,
									5,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 22,
								s: [
									135.045,
									161.643,
									0
								],
								to: [
									0,
									-5,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 42,
								s: [
									135.045,
									91.643,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 62,
								s: [
									135.045,
									161.643,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 81,
								s: [
									135.045,
									91.643,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									-5,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 101,
								s: [
									135.045,
									161.643,
									0
								],
								to: [
									0,
									5,
									0
								],
								ti: [
									0,
									6.667,
									0
								]
							},
							{
								t: 121,
								s: [
									135.045,
									121.643,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							-14.955,
							-28.357,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												-2.209
											],
											[
												2.209,
												0
											],
											[
												0,
												2.209
											],
											[
												-2.209,
												0
											]
										],
										o: [
											[
												0,
												2.209
											],
											[
												-2.209,
												0
											],
											[
												0,
												-2.209
											],
											[
												2.209,
												0
											]
										],
										v: [
											[
												-10.955,
												-28.357
											],
											[
												-14.955,
												-24.357
											],
											[
												-18.955,
												-28.357
											],
											[
												-14.955,
												-32.357
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "eye white right",
				parent: 9,
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 1,
								s: [
									21.1,
									-29.713,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 22,
								s: [
									21.1,
									-29.713,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 42,
								s: [
									21.1,
									-29.713,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 62,
								s: [
									21.1,
									-29.713,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 81,
								s: [
									21.1,
									-29.713,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.3,
									y: 0.3
								},
								t: 101,
								s: [
									21.1,
									-29.713,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 121,
								s: [
									21.1,
									-29.713,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							21.1,
							-29.713,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												-0.69
											],
											[
												0.69,
												0
											],
											[
												0,
												0.69
											],
											[
												-0.69,
												0
											]
										],
										o: [
											[
												0,
												0.69
											],
											[
												-0.69,
												0
											],
											[
												0,
												-0.69
											],
											[
												0.69,
												0
											]
										],
										v: [
											[
												22.35,
												-29.713
											],
											[
												21.1,
												-28.463
											],
											[
												19.85,
												-29.713
											],
											[
												21.1,
												-30.963
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 65,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 4,
				nm: "eye right",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 1,
								s: [
									172.85,
									122.037,
									0
								],
								to: [
									0,
									6.667,
									0
								],
								ti: [
									0,
									5,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 22,
								s: [
									172.85,
									162.037,
									0
								],
								to: [
									0,
									-5,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 42,
								s: [
									172.85,
									92.037,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 62,
								s: [
									172.85,
									162.037,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 81,
								s: [
									172.85,
									92.037,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									-5,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.3,
									y: 0
								},
								t: 101,
								s: [
									172.85,
									162.037,
									0
								],
								to: [
									0,
									5,
									0
								],
								ti: [
									0,
									6.667,
									0
								]
							},
							{
								t: 121,
								s: [
									172.85,
									122.037,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							22.85,
							-27.963,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												-2.209
											],
											[
												2.209,
												0
											],
											[
												0,
												2.209
											],
											[
												-2.209,
												0
											]
										],
										o: [
											[
												0,
												2.209
											],
											[
												-2.209,
												0
											],
											[
												0,
												-2.209
											],
											[
												2.209,
												0
											]
										],
										v: [
											[
												26.85,
												-27.963
											],
											[
												22.85,
												-23.963
											],
											[
												18.85,
												-27.963
											],
											[
												22.85,
												-31.963
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "hat",
				parent: 11,
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							37.193,
							-103.34,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							37.193,
							-103.34,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 1,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															19.917,
															11.012
														],
														[
															0,
															0
														]
													],
													v: [
														[
															11.533,
															-104.821
														],
														[
															60.952,
															-85.106
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 21,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															17.467,
															26.571
														],
														[
															0,
															0
														]
													],
													v: [
														[
															6.533,
															-104.821
														],
														[
															55.952,
															-85.106
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 41,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															25.467,
															6.571
														],
														[
															0,
															0
														]
													],
													v: [
														[
															11.533,
															-104.821
														],
														[
															60.952,
															-85.106
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 61,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															17.467,
															26.571
														],
														[
															0,
															0
														]
													],
													v: [
														[
															6.533,
															-104.821
														],
														[
															55.952,
															-85.106
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 80,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															25.467,
															6.571
														],
														[
															0,
															0
														]
													],
													v: [
														[
															11.533,
															-104.821
														],
														[
															60.952,
															-85.106
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 100,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															17.467,
															26.571
														],
														[
															0,
															0
														]
													],
													v: [
														[
															6.533,
															-104.821
														],
														[
															55.952,
															-85.106
														]
													],
													c: false
												}
											]
										},
										{
											t: 120,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															19.917,
															11.012
														],
														[
															0,
															0
														]
													],
													v: [
														[
															11.533,
															-104.821
														],
														[
															60.952,
															-85.106
														]
													],
													c: false
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.352941185236,
										0.717647075653,
										0.870588243008,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 12,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 1,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-13.647,
															-5.444
														],
														[
															5.444,
															-13.647
														]
													],
													o: [
														[
															5.444,
															-13.647
														],
														[
															13.647,
															5.444
														],
														[
															0,
															0
														]
													],
													v: [
														[
															11.533,
															-104.821
														],
														[
															46.1,
															-119.673
														],
														[
															60.952,
															-85.106
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 21,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-13.647,
															-5.444
														],
														[
															5.444,
															-13.647
														]
													],
													o: [
														[
															5.444,
															-13.647
														],
														[
															13.647,
															5.444
														],
														[
															0,
															0
														]
													],
													v: [
														[
															5.283,
															-101.821
														],
														[
															41.1,
															-116.673
														],
														[
															54.702,
															-82.106
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 41,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-13.647,
															-5.444
														],
														[
															5.444,
															-13.647
														]
													],
													o: [
														[
															5.444,
															-13.647
														],
														[
															13.647,
															5.444
														],
														[
															0,
															0
														]
													],
													v: [
														[
															11.158,
															-104.321
														],
														[
															45.85,
															-115.923
														],
														[
															61.202,
															-84.106
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 61,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-13.647,
															-5.444
														],
														[
															5.444,
															-13.647
														]
													],
													o: [
														[
															5.444,
															-13.647
														],
														[
															13.647,
															5.444
														],
														[
															0,
															0
														]
													],
													v: [
														[
															5.283,
															-101.821
														],
														[
															41.1,
															-116.673
														],
														[
															54.702,
															-82.106
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 80,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-13.647,
															-5.444
														],
														[
															5.444,
															-13.647
														]
													],
													o: [
														[
															5.444,
															-13.647
														],
														[
															13.647,
															5.444
														],
														[
															0,
															0
														]
													],
													v: [
														[
															11.158,
															-104.321
														],
														[
															45.85,
															-115.923
														],
														[
															61.202,
															-84.106
														]
													],
													c: true
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 100,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-13.647,
															-5.444
														],
														[
															5.444,
															-13.647
														]
													],
													o: [
														[
															5.444,
															-13.647
														],
														[
															13.647,
															5.444
														],
														[
															0,
															0
														]
													],
													v: [
														[
															5.283,
															-101.821
														],
														[
															41.1,
															-116.673
														],
														[
															54.702,
															-82.106
														]
													],
													c: true
												}
											]
										},
										{
											t: 120,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-13.647,
															-5.444
														],
														[
															5.444,
															-13.647
														]
													],
													o: [
														[
															5.444,
															-13.647
														],
														[
															13.647,
															5.444
														],
														[
															0,
															0
														]
													],
													v: [
														[
															11.533,
															-104.821
														],
														[
															46.1,
															-119.673
														],
														[
															60.952,
															-85.106
														]
													],
													c: true
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.223529413342,
										0.662745118141,
										0.882352948189,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "body",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							153.955,
							131.599,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							3.955,
							-18.401,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												-48.329
											],
											[
												48.329,
												0
											],
											[
												0,
												48.329
											],
											[
												-48.329,
												0
											]
										],
										o: [
											[
												0,
												48.329
											],
											[
												-48.329,
												0
											],
											[
												0,
												-48.329
											],
											[
												48.329,
												0
											]
										],
										v: [
											[
												91.463,
												-18.401
											],
											[
												3.955,
												69.106
											],
											[
												-83.553,
												-18.401
											],
											[
												3.955,
												-105.909
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "gf",
								o: {
									a: 0,
									k: 100,
									ix: 10
								},
								r: 1,
								bm: 0,
								g: {
									p: 5,
									k: {
										a: 0,
										k: [
											0.09,
											0.545,
											0.863,
											1,
											0.46,
											0.449,
											0.851,
											1,
											0.83,
											0.353,
											0.839,
											1,
											0.89,
											0.353,
											0.839,
											1,
											0.95,
											0.353,
											0.839,
											1
										],
										ix: 9
									}
								},
								s: {
									a: 0,
									k: [
										3,
										-20
									],
									ix: 5
								},
								e: {
									a: 0,
									k: [
										90.393,
										-19
									],
									ix: 6
								},
								t: 2,
								h: {
									a: 0,
									k: 0,
									ix: 7
								},
								a: {
									a: 0,
									k: 0,
									ix: 8
								},
								nm: "Gradient Fill 1",
								mn: "ADBE Vector Graphic - G-Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "arm left",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							81.055,
							174.924,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							-68.945,
							24.924,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 9,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-23.474,
															15.525
														]
													],
													o: [
														[
															4.791,
															-37.344
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-88.467,
															64.995
														],
														[
															-49.424,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.833,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 30,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-23.474,
															15.525
														]
													],
													o: [
														[
															-13.533,
															-35.995
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-68.967,
															74.995
														],
														[
															-49.424,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0
											},
											t: 50,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-21.576,
															6.647
														]
													],
													o: [
														[
															10.467,
															34.005
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-113.467,
															-69.505
														],
														[
															-49.424,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.833,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 70,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-23.474,
															15.525
														]
													],
													o: [
														[
															-13.533,
															-35.995
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-68.967,
															74.995
														],
														[
															-49.424,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0
											},
											t: 89,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-21.576,
															6.647
														]
													],
													o: [
														[
															10.467,
															34.005
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-113.467,
															-69.505
														],
														[
															-49.424,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 109,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-23.474,
															15.525
														]
													],
													o: [
														[
															-13.533,
															-35.995
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-68.967,
															74.995
														],
														[
															-49.424,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											t: 129,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-23.474,
															15.525
														]
													],
													o: [
														[
															4.791,
															-37.344
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-88.467,
															64.995
														],
														[
															-49.424,
															-15.147
														]
													],
													c: false
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.490196079016,
										0.890196084976,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 18,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "arm right",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							228.794,
							174.924,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							78.794,
							24.924,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 3,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															23.474,
															15.525
														]
													],
													o: [
														[
															-4.791,
															-37.344
														],
														[
															0,
															0
														]
													],
													v: [
														[
															98.316,
															64.995
														],
														[
															59.273,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 24,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															23.474,
															15.525
														]
													],
													o: [
														[
															6.684,
															-35.995
														],
														[
															0,
															0
														]
													],
													v: [
														[
															81.316,
															69.995
														],
														[
															59.273,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 44,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															15.227,
															3.647
														]
													],
													o: [
														[
															-11.316,
															32.505
														],
														[
															0,
															0
														]
													],
													v: [
														[
															125.316,
															-67.005
														],
														[
															59.273,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 64,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															23.474,
															15.525
														]
													],
													o: [
														[
															6.684,
															-35.995
														],
														[
															0,
															0
														]
													],
													v: [
														[
															81.316,
															69.995
														],
														[
															59.273,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 83,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															15.227,
															3.647
														]
													],
													o: [
														[
															-11.316,
															32.505
														],
														[
															0,
															0
														]
													],
													v: [
														[
															125.316,
															-67.005
														],
														[
															59.273,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.5,
												y: 1
											},
											o: {
												x: 0.3,
												y: 0
											},
											t: 103,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															23.474,
															15.525
														]
													],
													o: [
														[
															6.684,
															-35.995
														],
														[
															0,
															0
														]
													],
													v: [
														[
															81.316,
															69.995
														],
														[
															59.273,
															-15.147
														]
													],
													c: false
												}
											]
										},
										{
											t: 123,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															23.474,
															15.525
														]
													],
													o: [
														[
															-4.791,
															-37.344
														],
														[
															0,
															0
														]
													],
													v: [
														[
															98.316,
															64.995
														],
														[
															59.273,
															-15.147
														]
													],
													c: false
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.490196079016,
										0.890196084976,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 18,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 180,
				st: 0,
				bm: 0
			}
		]
	}
];
var layers$h = [
	{
		ddd: 0,
		ind: 1,
		ty: 0,
		nm: "blue_happy_body-precomp",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 0,
						s: [
							146.25,
							150,
							0
						],
						to: [
							0,
							1.667,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 25,
						s: [
							146.25,
							160,
							0
						],
						to: [
							0,
							-0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 44,
						s: [
							146.25,
							145,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 66,
						s: [
							146.25,
							160,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 86,
						s: [
							146.25,
							145,
							0
						],
						to: [
							0,
							-1.667,
							0
						],
						ti: [
							0,
							-0.833,
							0
						]
					},
					{
						t: 120,
						s: [
							146.25,
							150,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					150,
					150,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 300,
		h: 300,
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "sock left",
		parent: 4,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-16.159,
					101.144,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					101.144,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 25,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													88.092
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													88.092
												],
												[
													-26.306,
													86.965
												],
												[
													-6.012,
													86.965
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 44,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 66,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													88.092
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													88.092
												],
												[
													-26.306,
													86.965
												],
												[
													-6.012,
													86.965
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 86,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													79.967
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													79.967
												],
												[
													-26.306,
													78.84
												],
												[
													-6.012,
													78.84
												]
											],
											c: true
										}
									]
								},
								{
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "sock right",
		parent: 5,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					24.069,
					101.144,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					101.144,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 25,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													88.092
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													88.092
												],
												[
													13.922,
													86.965
												],
												[
													34.216,
													86.965
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 44,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.312,
													82.092
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.763,
													82.092
												],
												[
													13.891,
													80.965
												],
												[
													34.184,
													80.965
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 66,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													88.092
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													88.092
												],
												[
													13.922,
													86.965
												],
												[
													34.216,
													86.965
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 86,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.374,
													80.342
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.825,
													80.342
												],
												[
													13.952,
													79.215
												],
												[
													34.246,
													79.215
												]
											],
											c: true
										}
									]
								},
								{
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.091,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-16.159,
										110.639
									],
									[
										-16.159,
										28.873
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					170.319,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										24.069,
										110.639
									],
									[
										24.069,
										28.873
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					151,
					270,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$h = [
];
var AbbeExcited = {
	v: v$h,
	fr: fr$h,
	ip: ip$h,
	op: op$h,
	w: w$h,
	h: h$h,
	nm: nm$h,
	ddd: ddd$h,
	assets: assets$h,
	layers: layers$h,
	markers: markers$h
};

var v$g = "5.6.9";
var fr$g = 60;
var ip$g = 0;
var op$g = 481;
var w$g = 300;
var h$g = 300;
var nm$g = "blue_idle";
var ddd$g = 0;
var assets$g = [
];
var layers$g = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 1,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 40,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 80,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 120,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 160,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 199,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 239,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 279,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 320,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 360,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 400,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 440,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 479,
						s: [
							4.538,
							1.064,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 125,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 141,
									s: [
										{
											i: [
												[
													-3.189,
													-4.178
												],
												[
													15.664,
													0
												],
												[
													-5.914,
													3.083
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													1.515,
													1.985
												],
												[
													-15.664,
													0
												],
												[
													3.099,
													-1.615
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													23.689,
													-3.305
												],
												[
													4.202,
													6.039
												],
												[
													-16.599,
													-4.867
												],
												[
													3.701,
													0.064
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 243,
									s: [
										{
											i: [
												[
													-3.939,
													-3.365
												],
												[
													15.664,
													0
												],
												[
													-2.833,
													1.492
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0.912,
													0.779
												],
												[
													-15.664,
													0
												],
												[
													3.661,
													-1.928
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													21.064,
													-0.742
												],
												[
													4.389,
													6.226
												],
												[
													-11.911,
													-1.555
												],
												[
													4.326,
													1.627
												]
											],
											c: true
										}
									]
								},
								{
									t: 258,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 1,
						s: [
							150.205,
							158.077,
							0
						],
						to: [
							0,
							1.083,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 40,
						s: [
							150.205,
							164.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 80,
						s: [
							150.205,
							158.077,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 120,
						s: [
							150.205,
							164.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 160,
						s: [
							150.205,
							158.077,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 199,
						s: [
							150.205,
							164.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 239,
						s: [
							150.205,
							158.077,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 279,
						s: [
							150.205,
							164.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 320,
						s: [
							150.205,
							158.077,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 360,
						s: [
							150.205,
							164.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 400,
						s: [
							150.205,
							158.077,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 440,
						s: [
							150.205,
							164.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.083,
							0
						]
					},
					{
						t: 479,
						s: [
							150.205,
							158.077,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					3.955,
					8.077,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													9.456
												],
												[
													3.955,
													4.951
												],
												[
													-11.367,
													9.456
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 40,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													9.34,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-9.41,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													22.277,
													9.413
												],
												[
													3.91,
													2.701
												],
												[
													-14.242,
													9.413
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													9.456
												],
												[
													3.955,
													4.951
												],
												[
													-11.367,
													9.456
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													9.34,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-9.41,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													22.277,
													9.413
												],
												[
													3.91,
													2.701
												],
												[
													-14.242,
													9.413
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 141,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													12.581
												],
												[
													3.955,
													8.076
												],
												[
													-11.367,
													12.581
												],
												[
													4.538,
													14.039
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 239,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													15.706
												],
												[
													3.955,
													11.201
												],
												[
													-11.367,
													15.706
												],
												[
													4.538,
													17.164
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 279,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													9.34,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-9.41,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													22.277,
													9.413
												],
												[
													3.91,
													2.701
												],
												[
													-14.242,
													9.413
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 320,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													9.456
												],
												[
													3.955,
													4.951
												],
												[
													-11.367,
													9.456
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 360,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													9.34,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-9.41,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													22.277,
													9.413
												],
												[
													3.91,
													2.701
												],
												[
													-14.242,
													9.413
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 400,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													9.456
												],
												[
													3.955,
													4.951
												],
												[
													-11.367,
													9.456
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 440,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													9.34,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-9.41,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													22.277,
													9.413
												],
												[
													3.91,
													2.701
												],
												[
													-14.242,
													9.413
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									t: 479,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													9.456
												],
												[
													3.955,
													4.951
												],
												[
													-11.367,
													9.456
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.909803926945,
								0.090196080506,
								0.301960796118,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 1,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 40,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 80,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 120,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 160,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 199,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 239,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 279,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 320,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 360,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 400,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 440,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 479,
						s: [
							4.538,
							1.064,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 125,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 141,
									s: [
										{
											i: [
												[
													-3.189,
													-4.178
												],
												[
													15.664,
													0
												],
												[
													-5.914,
													3.083
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													1.515,
													1.985
												],
												[
													-15.664,
													0
												],
												[
													3.099,
													-1.615
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													23.689,
													-0.023
												],
												[
													4.202,
													9.32
												],
												[
													-16.599,
													-1.586
												],
												[
													3.701,
													3.346
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 243,
									s: [
										{
											i: [
												[
													-3.939,
													-3.365
												],
												[
													15.664,
													0
												],
												[
													-2.833,
													1.492
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0.912,
													0.779
												],
												[
													-15.664,
													0
												],
												[
													3.661,
													-1.928
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													21.064,
													-0.742
												],
												[
													4.389,
													6.226
												],
												[
													-11.911,
													-1.555
												],
												[
													4.326,
													1.627
												]
											],
											c: true
										}
									]
								},
								{
									t: 258,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 1,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							0.667,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 40,
						s: [
							150.789,
							147.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 80,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.042,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 120,
						s: [
							150.789,
							147.491,
							0
						],
						to: [
							0,
							0.042,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 160,
						s: [
							150.789,
							143.741,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.042,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 199,
						s: [
							150.789,
							147.491,
							0
						],
						to: [
							0,
							-0.042,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 239,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 279,
						s: [
							150.789,
							147.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 320,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 360,
						s: [
							150.789,
							147.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 400,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 440,
						s: [
							150.789,
							147.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.667,
							0
						]
					},
					{
						t: 479,
						s: [
							150.789,
							143.491,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.539,
					-6.509,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										8.179,
										0.029
									],
									[
										-0.046,
										-2.596
									],
									[
										-1.283,
										0.011
									],
									[
										-5.247,
										0.255
									],
									[
										0,
										1.245
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0.14,
										1.858
									],
									[
										0.023,
										1.282
									],
									[
										6.155,
										-0.054
									],
									[
										1.244,
										-0.061
									],
									[
										0,
										0
									],
									[
										-6.537,
										-0.361
									]
								],
								v: [
									[
										6.378,
										-11.001
									],
									[
										6.663,
										-4.327
									],
									[
										9.021,
										-2.017
									],
									[
										26.239,
										-2.492
									],
									[
										28.455,
										-4.828
									],
									[
										29.625,
										-10.395
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										6.537,
										-0.361
									],
									[
										0,
										0
									],
									[
										-1.243,
										-0.061
									],
									[
										-6.155,
										-0.054
									],
									[
										-0.023,
										1.282
									],
									[
										-0.14,
										1.858
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										1.245
									],
									[
										5.248,
										0.255
									],
									[
										1.283,
										0.011
									],
									[
										0.046,
										-2.596
									],
									[
										-8.179,
										0.029
									]
								],
								v: [
									[
										-20.547,
										-10.395
									],
									[
										-19.378,
										-4.828
									],
									[
										-17.162,
										-2.492
									],
									[
										0.056,
										-2.017
									],
									[
										2.414,
										-4.327
									],
									[
										2.699,
										-11.001
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 1,
						s: [
							150.788,
							151.064,
							0
						],
						to: [
							0,
							1.083,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 40,
						s: [
							150.788,
							157.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 80,
						s: [
							150.788,
							151.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 120,
						s: [
							150.788,
							157.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 160,
						s: [
							150.788,
							151.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 199,
						s: [
							150.788,
							157.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 239,
						s: [
							150.788,
							151.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 279,
						s: [
							150.788,
							157.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 320,
						s: [
							150.788,
							151.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 360,
						s: [
							150.788,
							157.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 400,
						s: [
							150.788,
							151.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 440,
						s: [
							150.788,
							157.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.083,
							0
						]
					},
					{
						t: 479,
						s: [
							150.788,
							151.064,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 125,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 141,
									s: [
										{
											i: [
												[
													-3.939,
													-3.365
												],
												[
													15.664,
													0
												],
												[
													-2.833,
													1.492
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0.912,
													0.779
												],
												[
													-15.664,
													0
												],
												[
													3.661,
													-1.928
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													21.064,
													-0.742
												],
												[
													4.389,
													6.226
												],
												[
													-11.911,
													-1.555
												],
												[
													4.326,
													1.627
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 243,
									s: [
										{
											i: [
												[
													-3.939,
													-3.365
												],
												[
													15.664,
													0
												],
												[
													-2.833,
													1.492
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0.912,
													0.779
												],
												[
													-15.664,
													0
												],
												[
													3.661,
													-1.928
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													21.064,
													-0.742
												],
												[
													4.389,
													6.226
												],
												[
													-11.911,
													-1.555
												],
												[
													4.326,
													1.627
												]
											],
											c: true
										}
									]
								},
								{
									t: 258,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eye white left",
		parent: 7,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 5,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 45,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 85,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 125,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 160,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 202,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 242,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 282,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 323,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 362,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 403,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 443,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 479,
						s: [
							-15.923,
							-30.107,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.705,
					-30.107,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-15.455,
										-30.107
									],
									[
										-16.705,
										-28.857
									],
									[
										-17.955,
										-30.107
									],
									[
										-16.705,
										-31.357
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 5,
						s: [
							131.295,
							121.643,
							0
						],
						to: [
							0,
							1.667,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 45,
						s: [
							131.295,
							131.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 85,
						s: [
							131.295,
							121.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 125,
						s: [
							131.295,
							131.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 160,
						s: [
							131.295,
							121.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 202,
						s: [
							131.295,
							131.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 242,
						s: [
							131.295,
							121.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 282,
						s: [
							131.295,
							131.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 323,
						s: [
							131.295,
							121.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 362,
						s: [
							131.295,
							131.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 403,
						s: [
							131.295,
							121.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 443,
						s: [
							131.295,
							131.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						t: 479,
						s: [
							131.295,
							121.643,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-14.955,
					-28.357,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 63,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 69,
						s: [
							100,
							4,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 75,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 100,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 106,
						s: [
							100,
							4,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 112,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 118,
						s: [
							100,
							4,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 124,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 282,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 288,
						s: [
							100,
							4,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 294,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 350,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 356,
						s: [
							100,
							4,
							100
						]
					},
					{
						t: 362,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 21,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.771,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.608,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-27.982
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 138,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.771,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.608,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-27.982
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 282,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 302,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.771,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.608,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-27.982
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 389,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.771,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.608,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-27.982
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									t: 409,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye white right",
		parent: 9,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 5,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 45,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 85,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 125,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 160,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 202,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 242,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 282,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 323,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 362,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 403,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 443,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 479,
						s: [
							21.1,
							-29.713,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					21.1,
					-29.713,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										22.35,
										-29.713
									],
									[
										21.1,
										-28.463
									],
									[
										19.85,
										-29.713
									],
									[
										21.1,
										-30.963
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 5,
						s: [
							169.1,
							122.037,
							0
						],
						to: [
							0,
							1.667,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 45,
						s: [
							169.1,
							132.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 85,
						s: [
							169.1,
							122.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 125,
						s: [
							169.1,
							132.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 160,
						s: [
							169.1,
							122.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 202,
						s: [
							169.1,
							132.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 242,
						s: [
							169.1,
							122.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 282,
						s: [
							169.1,
							132.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 323,
						s: [
							169.1,
							122.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 362,
						s: [
							169.1,
							132.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 403,
						s: [
							169.1,
							122.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 443,
						s: [
							169.1,
							132.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						t: 479,
						s: [
							169.1,
							122.037,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					22.85,
					-27.963,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 60,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 66,
						s: [
							100,
							4,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 72,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 100,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 106,
						s: [
							100,
							4,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 112,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 118,
						s: [
							100,
							4,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 124,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 285,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 291,
						s: [
							100,
							4,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 297,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 353,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.22,
								0.22,
								0.22
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.78,
								0.78,
								0.78
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 359,
						s: [
							100,
							4,
							100
						]
					},
					{
						t: 365,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 21,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.738,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.762,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.825,
													-27.9
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 138,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.738,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.762,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.825,
													-27.9
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 282,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 302,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.738,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.762,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.825,
													-27.9
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 389,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.738,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.762,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.825,
													-27.9
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									t: 409,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "hat",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					37.193,
					-103.34,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					37.193,
					-103.34,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													18.467,
													19.321
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													55.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													18.467,
													19.321
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													55.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 199,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													18.467,
													19.321
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													55.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 239,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 279,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													18.467,
													19.321
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													55.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 320,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 360,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													18.467,
													19.321
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													55.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 400,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 440,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													18.467,
													19.321
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													55.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									t: 479,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.352941185236,
								0.717647075653,
								0.870588243008,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 12,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													41.1,
													-119.673
												],
												[
													55.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													41.1,
													-119.673
												],
												[
													55.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 199,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													41.1,
													-119.673
												],
												[
													55.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 239,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 279,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													41.1,
													-119.673
												],
												[
													55.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 320,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 360,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													41.1,
													-119.673
												],
												[
													55.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 400,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 440,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													41.1,
													-119.673
												],
												[
													55.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									t: 479,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.223529413342,
								0.662745118141,
								0.882352948189,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 2,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							1.083,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 41,
						s: [
							150.205,
							138.099,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 81,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 121,
						s: [
							150.205,
							138.099,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 161,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							-0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 200,
						s: [
							150.205,
							133.099,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 240,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 280,
						s: [
							150.205,
							138.099,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 320,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 360,
						s: [
							150.205,
							138.099,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 400,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 440,
						s: [
							150.205,
							138.099,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.083,
							0
						]
					},
					{
						t: 479,
						s: [
							150.205,
							131.599,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					3.955,
					-18.401,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-48.329
									],
									[
										48.329,
										0
									],
									[
										0,
										48.329
									],
									[
										-48.329,
										0
									]
								],
								o: [
									[
										0,
										48.329
									],
									[
										-48.329,
										0
									],
									[
										0,
										-48.329
									],
									[
										48.329,
										0
									]
								],
								v: [
									[
										91.463,
										-18.401
									],
									[
										3.955,
										69.106
									],
									[
										-83.553,
										-18.401
									],
									[
										3.955,
										-105.909
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0.09,
									0.545,
									0.863,
									1,
									0.46,
									0.449,
									0.851,
									1,
									0.83,
									0.353,
									0.839,
									1,
									0.89,
									0.353,
									0.839,
									1,
									0.95,
									0.353,
									0.839,
									1
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								3,
								-20
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								90.393,
								-19
							],
							ix: 6
						},
						t: 2,
						h: {
							a: 0,
							k: 0,
							ix: 7
						},
						a: {
							a: 0,
							k: 0,
							ix: 8
						},
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "sock left",
		parent: 14,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-16.159,
					101.144,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					101.144,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 2,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 41,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-10.635,
													81.87
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-33.183,
													81.87
												],
												[
													-32.056,
													80.742
												],
												[
													-11.762,
													80.742
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 81,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 121,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-10.635,
													81.87
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-33.183,
													81.87
												],
												[
													-32.056,
													80.742
												],
												[
													-11.762,
													80.742
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 161,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 199,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-7.635,
													81.989
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-30.183,
													81.989
												],
												[
													-29.056,
													80.862
												],
												[
													-8.762,
													80.862
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 320,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 380,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-10.635,
													81.87
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-33.183,
													81.87
												],
												[
													-32.056,
													80.742
												],
												[
													-11.762,
													80.742
												]
											],
											c: true
										}
									]
								},
								{
									t: 439,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "sock right",
		parent: 15,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					24.069,
					101.144,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					101.144,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													30.093,
													81.935
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													7.545,
													81.935
												],
												[
													8.672,
													80.807
												],
												[
													28.966,
													80.807
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													30.093,
													81.935
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													7.545,
													81.935
												],
												[
													8.672,
													80.807
												],
												[
													28.966,
													80.807
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 199,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													32.843,
													81.87
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													10.295,
													81.87
												],
												[
													11.422,
													80.742
												],
												[
													31.716,
													80.742
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 320,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 380,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													30.093,
													81.935
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													7.545,
													81.935
												],
												[
													8.672,
													80.807
												],
												[
													28.966,
													80.807
												]
											],
											c: true
										}
									]
								},
								{
									t: 439,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.091,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 2,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 41,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-12.341,
													-29.639
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 81,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 121,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-12.341,
													-29.639
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 161,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 199,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-6.341,
													-29.389
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 320,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 380,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-12.341,
													-29.639
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									t: 449,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					170.319,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-11.569,
													-25.139
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-11.569,
													-25.139
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 199,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-5.569,
													-26.139
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 320,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 380,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-11.569,
													-25.139
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									t: 449,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "arm left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					77.305,
					174.924,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-68.945,
					24.924,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-3.533,
													-27.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-78.467,
													73.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 98,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-32.076,
													-20.853
												]
											],
											o: [
												[
													-34.033,
													-20.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-82.967,
													23.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 107,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-32.076,
													-20.853
												]
											],
											o: [
												[
													-34.033,
													-20.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-69.467,
													42.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 115,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-32.076,
													-20.853
												]
											],
											o: [
												[
													-34.033,
													-20.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-82.967,
													23.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 123,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-32.076,
													-20.853
												]
											],
											o: [
												[
													-34.033,
													-20.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-69.467,
													42.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 131,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-32.076,
													-20.853
												]
											],
											o: [
												[
													-34.033,
													-20.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-82.967,
													23.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 199,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-0.533,
													-25.495
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-83.967,
													66.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 239,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 279,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-3.533,
													-27.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-78.467,
													73.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 320,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 360,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-3.533,
													-27.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-78.467,
													73.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 400,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 440,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-3.533,
													-27.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-78.467,
													73.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									t: 479,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "arm right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					225.044,
					174.924,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					78.794,
					24.924,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 2,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 41,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													4.184,
													-30.495
												],
												[
													0,
													0
												]
											],
											v: [
												[
													84.816,
													69.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 81,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 121,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													4.184,
													-30.495
												],
												[
													0,
													0
												]
											],
											v: [
												[
													84.816,
													69.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 161,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 200,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-0.816,
													-29.495
												],
												[
													0,
													0
												]
											],
											v: [
												[
													94.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 240,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 280,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													4.184,
													-30.495
												],
												[
													0,
													0
												]
											],
											v: [
												[
													84.816,
													69.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 298,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-17.316,
													23.005
												],
												[
													0,
													0
												]
											],
											v: [
												[
													124.816,
													-32.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 311.564,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-23.316,
													9.505
												],
												[
													0,
													0
												]
											],
											v: [
												[
													132.816,
													-13.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 324.33,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-17.316,
													23.005
												],
												[
													0,
													0
												]
											],
											v: [
												[
													124.816,
													-32.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 336.299,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-23.316,
													9.505
												],
												[
													0,
													0
												]
											],
											v: [
												[
													132.816,
													-13.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 347.469,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-17.316,
													23.005
												],
												[
													0,
													0
												]
											],
											v: [
												[
													124.816,
													-32.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 360.234,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-23.316,
													9.505
												],
												[
													0,
													0
												]
											],
											v: [
												[
													132.816,
													-13.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 373,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-17.316,
													23.005
												],
												[
													0,
													0
												]
											],
											v: [
												[
													124.816,
													-32.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 385,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-23.316,
													9.505
												],
												[
													0,
													0
												]
											],
											v: [
												[
													132.816,
													-13.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 400,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 440,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													4.184,
													-30.495
												],
												[
													0,
													0
												]
											],
											v: [
												[
													84.816,
													69.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									t: 479,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 540,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					151,
					270,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 551,
		st: 0,
		bm: 0
	}
];
var markers$g = [
];
var AbbeIdle = {
	v: v$g,
	fr: fr$g,
	ip: ip$g,
	op: op$g,
	w: w$g,
	h: h$g,
	nm: nm$g,
	ddd: ddd$g,
	assets: assets$g,
	layers: layers$g,
	markers: markers$g
};

var v$f = "5.6.9";
var fr$f = 60;
var ip$f = 0;
var op$f = 141;
var w$f = 300;
var h$f = 300;
var nm$f = "blue_wrong_1";
var ddd$f = 0;
var assets$f = [
];
var layers$f = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 0,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 19.834,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 39.666,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 59.5,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 79.334,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 99.166,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 119,
						s: [
							4.538,
							1.064,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 28,
									s: [
										{
											i: [
												[
													4.462,
													-1.82
												],
												[
													15.664,
													0
												],
												[
													4.311,
													5.088
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-5.646,
													2.303
												],
												[
													-15.664,
													0
												],
												[
													-2.813,
													-3.32
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													25.901,
													3.32
												],
												[
													4.538,
													-5.586
												],
												[
													-19.699,
													3.07
												],
												[
													5.288,
													-10.811
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 113,
									s: [
										{
											i: [
												[
													4.462,
													-1.82
												],
												[
													15.664,
													0
												],
												[
													4.311,
													5.088
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-5.646,
													2.303
												],
												[
													-15.664,
													0
												],
												[
													-2.813,
													-3.32
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													25.901,
													3.32
												],
												[
													4.538,
													-5.586
												],
												[
													-19.699,
													3.07
												],
												[
													5.288,
													-10.811
												]
											],
											c: true
										}
									]
								},
								{
									t: 140,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 2,
						s: [
							150.205,
							158.077,
							0
						],
						to: [
							-4.167,
							0,
							0
						],
						ti: [
							-4.167,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 21.834,
						s: [
							125.205,
							158.077,
							0
						],
						to: [
							4.167,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 41.666,
						s: [
							175.205,
							158.077,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 61.5,
						s: [
							125.205,
							158.077,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 81.334,
						s: [
							175.205,
							158.077,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							4.167,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 101.166,
						s: [
							125.205,
							158.077,
							0
						],
						to: [
							-4.167,
							0,
							0
						],
						ti: [
							-4.167,
							0,
							0
						]
					},
					{
						t: 121,
						s: [
							150.205,
							158.077,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					3.955,
					8.077,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-5.208,
										2.332
									],
									[
										6.438,
										0
									],
									[
										3.239,
										-2.707
									],
									[
										-6.439,
										0
									]
								],
								o: [
									[
										-3.239,
										-2.707
									],
									[
										-6.439,
										0
									],
									[
										3.239,
										2.707
									],
									[
										6.438,
										0
									]
								],
								v: [
									[
										19.277,
										9.456
									],
									[
										3.955,
										4.951
									],
									[
										-11.367,
										9.456
									],
									[
										4.538,
										10.914
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.909803926945,
								0.090196080506,
								0.301960796118,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 0,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 19.834,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 39.666,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 59.5,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 79.334,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 99.166,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 119,
						s: [
							4.538,
							1.064,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 28,
									s: [
										{
											i: [
												[
													4.462,
													-1.82
												],
												[
													15.664,
													0
												],
												[
													4.311,
													5.088
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-5.646,
													2.303
												],
												[
													-15.664,
													0
												],
												[
													-2.813,
													-3.32
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													25.901,
													3.32
												],
												[
													4.538,
													-5.586
												],
												[
													-19.699,
													3.07
												],
												[
													5.288,
													-10.811
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 113,
									s: [
										{
											i: [
												[
													4.462,
													-1.82
												],
												[
													15.664,
													0
												],
												[
													4.311,
													5.088
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-5.646,
													2.303
												],
												[
													-15.664,
													0
												],
												[
													-2.813,
													-3.32
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													25.901,
													3.32
												],
												[
													4.538,
													-5.586
												],
												[
													-19.699,
													3.07
												],
												[
													5.288,
													-10.811
												]
											],
											c: true
										}
									]
								},
								{
									t: 140,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										4.462,
										-1.82
									],
									[
										15.664,
										0
									],
									[
										4.311,
										5.088
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										-5.646,
										2.303
									],
									[
										-15.664,
										0
									],
									[
										-2.813,
										-3.32
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										25.901,
										3.32
									],
									[
										4.538,
										-5.586
									],
									[
										-19.699,
										3.07
									],
									[
										5.288,
										-10.811
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 1,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 1,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							-4.167,
							0,
							0
						],
						ti: [
							-4.167,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 20.834,
						s: [
							125.789,
							143.491,
							0
						],
						to: [
							4.167,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 40.666,
						s: [
							175.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 60.5,
						s: [
							125.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 80.334,
						s: [
							175.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							4.167,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 100.166,
						s: [
							125.789,
							143.491,
							0
						],
						to: [
							-4.167,
							0,
							0
						],
						ti: [
							-4.167,
							0,
							0
						]
					},
					{
						t: 120,
						s: [
							150.789,
							143.491,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.539,
					-6.509,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										8.179,
										0.029
									],
									[
										-0.046,
										-2.596
									],
									[
										-1.283,
										0.011
									],
									[
										-5.247,
										0.255
									],
									[
										0,
										1.245
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0.14,
										1.858
									],
									[
										0.023,
										1.282
									],
									[
										6.155,
										-0.054
									],
									[
										1.244,
										-0.061
									],
									[
										0,
										0
									],
									[
										-6.537,
										-0.361
									]
								],
								v: [
									[
										6.378,
										-11.001
									],
									[
										6.663,
										-4.327
									],
									[
										9.021,
										-2.017
									],
									[
										26.239,
										-2.492
									],
									[
										28.455,
										-4.828
									],
									[
										29.625,
										-10.395
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										6.537,
										-0.361
									],
									[
										0,
										0
									],
									[
										-1.243,
										-0.061
									],
									[
										-6.155,
										-0.054
									],
									[
										-0.023,
										1.282
									],
									[
										-0.14,
										1.858
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										1.245
									],
									[
										5.248,
										0.255
									],
									[
										1.283,
										0.011
									],
									[
										0.046,
										-2.596
									],
									[
										-8.179,
										0.029
									]
								],
								v: [
									[
										-20.547,
										-10.395
									],
									[
										-19.378,
										-4.828
									],
									[
										-17.162,
										-2.492
									],
									[
										0.056,
										-2.017
									],
									[
										2.414,
										-4.327
									],
									[
										2.699,
										-11.001
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 0,
						s: [
							150.788,
							151.064,
							0
						],
						to: [
							-4.167,
							0,
							0
						],
						ti: [
							-4.167,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 19.834,
						s: [
							125.788,
							151.064,
							0
						],
						to: [
							4.167,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 39.666,
						s: [
							175.788,
							151.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 59.5,
						s: [
							125.788,
							151.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 79.334,
						s: [
							175.788,
							151.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							4.167,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 99.166,
						s: [
							125.788,
							151.064,
							0
						],
						to: [
							-4.167,
							0,
							0
						],
						ti: [
							-4.167,
							0,
							0
						]
					},
					{
						t: 119,
						s: [
							150.788,
							151.064,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 28,
									s: [
										{
											i: [
												[
													4.462,
													-1.82
												],
												[
													15.664,
													0
												],
												[
													4.311,
													5.088
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-5.646,
													2.303
												],
												[
													-15.664,
													0
												],
												[
													-2.813,
													-3.32
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													25.901,
													3.32
												],
												[
													4.538,
													-5.586
												],
												[
													-19.699,
													3.07
												],
												[
													5.288,
													-10.811
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 113,
									s: [
										{
											i: [
												[
													4.462,
													-1.82
												],
												[
													15.664,
													0
												],
												[
													4.311,
													5.088
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-5.646,
													2.303
												],
												[
													-15.664,
													0
												],
												[
													-2.813,
													-3.32
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													25.901,
													3.32
												],
												[
													4.538,
													-5.586
												],
												[
													-19.699,
													3.07
												],
												[
													5.288,
													-10.811
												]
											],
											c: true
										}
									]
								},
								{
									t: 140,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													32.901,
													-4.805
												],
												[
													4.538,
													10.914
												],
												[
													-23.824,
													-4.805
												],
												[
													4.538,
													-8.061
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eye white left",
		parent: 7,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 1,
						s: [
							-16.705,
							-30.107,
							0
						],
						to: [
							0.542,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 21,
						s: [
							-13.455,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 40.666,
						s: [
							-16.705,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 61,
						s: [
							-13.455,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 80.334,
						s: [
							-16.705,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 100,
						s: [
							-13.455,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0.542,
							0,
							0
						]
					},
					{
						t: 120,
						s: [
							-16.705,
							-30.107,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.705,
					-30.107,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-15.455,
										-30.107
									],
									[
										-16.705,
										-28.857
									],
									[
										-17.955,
										-30.107
									],
									[
										-16.705,
										-31.357
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 1,
						s: [
							131.295,
							121.643,
							0
						],
						to: [
							-4.167,
							0,
							0
						],
						ti: [
							-4.167,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 20.834,
						s: [
							106.295,
							121.643,
							0
						],
						to: [
							4.167,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 40.666,
						s: [
							156.295,
							121.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 60.5,
						s: [
							106.295,
							121.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 80.334,
						s: [
							156.295,
							121.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							4.167,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 100.166,
						s: [
							106.295,
							121.643,
							0
						],
						to: [
							-4.167,
							0,
							0
						],
						ti: [
							-4.167,
							0,
							0
						]
					},
					{
						t: 120,
						s: [
							131.295,
							121.643,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-14.955,
					-28.357,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 21,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 24,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 27,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 76,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 79,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 82,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 117,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 120,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 123,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 21,
									s: [
										{
											i: [
												[
													-0.12,
													-0.643
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.682,
													0.17
												]
											],
											o: [
												[
													0.124,
													2.206
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													0.443,
													0.045
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 41,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-0.246,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-0.205
												],
												[
													2.207,
													-0.093
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-15.201,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 61,
									s: [
										{
											i: [
												[
													-0.12,
													-0.643
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.682,
													0.17
												]
											],
											o: [
												[
													0.124,
													2.206
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													0.443,
													0.045
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-0.246,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-0.205
												],
												[
													2.207,
													-0.093
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-15.201,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 100,
									s: [
										{
											i: [
												[
													-0.12,
													-0.643
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.682,
													0.17
												]
											],
											o: [
												[
													0.124,
													2.206
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													0.443,
													0.045
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye white right",
		parent: 9,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 1,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0.521,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 20.834,
						s: [
							24.225,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 40.666,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 61,
						s: [
							24.225,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 80.334,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 100,
						s: [
							24.225,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0.521,
							0,
							0
						]
					},
					{
						t: 120,
						s: [
							21.1,
							-29.713,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					21.1,
					-29.713,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										22.35,
										-29.713
									],
									[
										21.1,
										-28.463
									],
									[
										19.85,
										-29.713
									],
									[
										21.1,
										-30.963
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 1,
						s: [
							169.1,
							122.037,
							0
						],
						to: [
							-4.167,
							0,
							0
						],
						ti: [
							-4.167,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 20.834,
						s: [
							144.1,
							122.037,
							0
						],
						to: [
							4.167,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 40.666,
						s: [
							194.1,
							122.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 60.5,
						s: [
							144.1,
							122.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 80.334,
						s: [
							194.1,
							122.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							4.167,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 100.166,
						s: [
							144.1,
							122.037,
							0
						],
						to: [
							-4.167,
							0,
							0
						],
						ti: [
							-4.167,
							0,
							0
						]
					},
					{
						t: 120,
						s: [
							169.1,
							122.037,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					22.85,
					-27.963,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 21,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 24,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 27,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 76,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 79,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 82,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 117,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 120,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 123,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 21,
									s: [
										{
											i: [
												[
													0,
													-0.1
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.674,
													0.088
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													0.138,
													0
												]
											],
											v: [
												[
													26.85,
													-28.062
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 41,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													0,
													0.213
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0.261,
													0
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 61,
									s: [
										{
											i: [
												[
													0,
													-0.1
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.674,
													0.088
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													0.138,
													0
												]
											],
											v: [
												[
													26.85,
													-28.062
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													0,
													0.213
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0.261,
													0
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 100,
									s: [
										{
											i: [
												[
													0,
													-0.1
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.674,
													0.088
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													0.138,
													0
												]
											],
											v: [
												[
													26.85,
													-28.062
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "hat",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					37.193,
					-103.34,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					37.193,
					-103.34,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 21,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													18.467,
													19.321
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													55.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 41,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 61,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													18.467,
													19.321
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													55.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 100,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													18.467,
													19.321
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													55.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.352941185236,
								0.717647075653,
								0.870588243008,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 12,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 21,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													41.1,
													-119.673
												],
												[
													55.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 41,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 61,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													41.1,
													-119.673
												],
												[
													55.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 100,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													41.1,
													-119.673
												],
												[
													55.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.223529413342,
								0.662745118141,
								0.882352948189,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					150.205,
					131.599,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					3.955,
					-18.401,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-48.329
									],
									[
										48.329,
										0
									],
									[
										0,
										48.329
									],
									[
										-48.329,
										0
									]
								],
								o: [
									[
										0,
										48.329
									],
									[
										-48.329,
										0
									],
									[
										0,
										-48.329
									],
									[
										48.329,
										0
									]
								],
								v: [
									[
										91.463,
										-18.401
									],
									[
										3.955,
										69.106
									],
									[
										-83.553,
										-18.401
									],
									[
										3.955,
										-105.909
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0.09,
									0.545,
									0.863,
									1,
									0.46,
									0.449,
									0.851,
									1,
									0.83,
									0.353,
									0.839,
									1,
									0.89,
									0.353,
									0.839,
									1,
									0.95,
									0.353,
									0.839,
									1
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								3,
								-20
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								90.393,
								-19
							],
							ix: 6
						},
						t: 2,
						h: {
							a: 0,
							k: 0,
							ix: 7
						},
						a: {
							a: 0,
							k: 0,
							ix: 8
						},
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "sock left",
		parent: 14,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-16.159,
					101.144,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					101.144,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 23,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-7.01,
													81.81
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-29.558,
													81.81
												],
												[
													-28.431,
													80.682
												],
												[
													-8.137,
													80.682
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 43,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-3.885,
													81.87
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-26.433,
													81.87
												],
												[
													-25.306,
													80.742
												],
												[
													-5.012,
													80.742
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 63,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-7.01,
													81.81
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-29.558,
													81.81
												],
												[
													-28.431,
													80.682
												],
												[
													-8.137,
													80.682
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 83,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-3.885,
													81.87
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-26.433,
													81.87
												],
												[
													-25.306,
													80.742
												],
												[
													-5.012,
													80.742
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 103,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-7.01,
													81.81
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-29.558,
													81.81
												],
												[
													-28.431,
													80.682
												],
												[
													-8.137,
													80.682
												]
											],
											c: true
										}
									]
								},
								{
									t: 123,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "sock right",
		parent: 15,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					24.069,
					101.144,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					101.144,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 23,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													33.218,
													81.81
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													10.67,
													81.81
												],
												[
													11.797,
													80.682
												],
												[
													32.091,
													80.682
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 43,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													37.093,
													81.87
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													14.545,
													81.87
												],
												[
													15.672,
													80.742
												],
												[
													35.966,
													80.742
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 63,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													33.218,
													81.81
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													10.67,
													81.81
												],
												[
													11.797,
													80.682
												],
												[
													32.091,
													80.682
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 83,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													37.093,
													81.87
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													14.545,
													81.87
												],
												[
													15.672,
													80.742
												],
												[
													35.966,
													80.742
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 103,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													33.218,
													81.81
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													10.67,
													81.81
												],
												[
													11.797,
													80.682
												],
												[
													32.091,
													80.682
												]
											],
											c: true
										}
									]
								},
								{
									t: 123,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.091,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 23,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													18.17
												]
											],
											o: [
												[
													-4.341,
													-26.389
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 43,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													18.17
												]
											],
											o: [
												[
													2.909,
													-24.389
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 63,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													18.17
												]
											],
											o: [
												[
													-4.341,
													-26.389
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 83,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													18.17
												]
											],
											o: [
												[
													2.909,
													-24.389
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 103,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													18.17
												]
											],
											o: [
												[
													-4.341,
													-26.389
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									t: 123,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-16.159,
													110.639
												],
												[
													-16.159,
													28.873
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					170.319,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 23,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-5.069,
													-26.889
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 43,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													18.17
												]
											],
											o: [
												[
													5.181,
													-26.889
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 63,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-5.069,
													-26.889
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 83,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													18.17
												]
											],
											o: [
												[
													5.181,
													-26.889
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 103,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-5.069,
													-26.889
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								},
								{
									t: 123,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.069,
													110.639
												],
												[
													24.069,
													28.873
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "arm left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					77.305,
					174.924,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-68.945,
					24.924,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-4.033,
													-36.495
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-71.967,
													63.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 60,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-4.033,
													-36.495
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-71.967,
													63.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 100,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-4.033,
													-36.495
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-71.967,
													63.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "arm right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					225.044,
					174.924,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					78.794,
					24.924,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 3,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 23,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													0.184,
													-35.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													91.816,
													64.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 43,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													1.184,
													-35.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													79.816,
													66.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 63,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 83,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													1.184,
													-35.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													79.816,
													66.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 103,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													0.184,
													-35.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													91.816,
													64.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									t: 123,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					151,
					270,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$f = [
];
var AbbeWrong = {
	v: v$f,
	fr: fr$f,
	ip: ip$f,
	op: op$f,
	w: w$f,
	h: h$f,
	nm: nm$f,
	ddd: ddd$f,
	assets: assets$f,
	layers: layers$f,
	markers: markers$f
};

var v$e = "5.6.9";
var fr$e = 60;
var ip$e = 0;
var op$e = 121;
var w$e = 300;
var h$e = 300;
var nm$e = "blue_yes";
var ddd$e = 0;
var assets$e = [
];
var layers$e = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 5,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 31,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 58,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 84,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 111,
						s: [
							4.538,
							1.064,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-5.006
									],
									[
										15.664,
										0
									],
									[
										0,
										6.669
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										0,
										6.097
									],
									[
										-15.664,
										0
									],
									[
										0,
										-6.002
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										32.901,
										-4.805
									],
									[
										4.538,
										10.914
									],
									[
										-23.824,
										-4.805
									],
									[
										4.538,
										-8.061
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 5,
						s: [
							150.205,
							158.077,
							0
						],
						to: [
							0,
							3.333,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 31,
						s: [
							150.205,
							178.077,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 58,
						s: [
							150.205,
							158.077,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 84,
						s: [
							150.205,
							178.077,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							3.333,
							0
						]
					},
					{
						t: 111,
						s: [
							150.205,
							158.077,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					3.955,
					8.077,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													9.456
												],
												[
													3.955,
													4.951
												],
												[
													-11.367,
													9.456
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 26,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													10.92,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-9.955,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													9.456
												],
												[
													3.83,
													2.701
												],
												[
													-11.367,
													9.456
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 53,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													9.456
												],
												[
													3.955,
													4.951
												],
												[
													-11.367,
													9.456
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 79,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													10.92,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-9.955,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													9.456
												],
												[
													3.83,
													2.701
												],
												[
													-11.367,
													9.456
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								},
								{
									t: 106,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													19.277,
													9.456
												],
												[
													3.955,
													4.951
												],
												[
													-11.367,
													9.456
												],
												[
													4.538,
													10.914
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.909803926945,
								0.090196080506,
								0.301960796118,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 5,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 31,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 58,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 84,
						s: [
							4.538,
							1.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 111,
						s: [
							4.538,
							1.064,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-5.006
									],
									[
										15.664,
										0
									],
									[
										0,
										6.669
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										0,
										6.097
									],
									[
										-15.664,
										0
									],
									[
										0,
										-6.002
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										32.901,
										-4.805
									],
									[
										4.538,
										10.914
									],
									[
										-23.824,
										-4.805
									],
									[
										4.538,
										-8.061
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 5,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							2.917,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 31,
						s: [
							150.789,
							160.991,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 58,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 84,
						s: [
							150.789,
							160.991,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							2.917,
							0
						]
					},
					{
						t: 111,
						s: [
							150.789,
							143.491,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.539,
					-6.509,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										8.179,
										0.029
									],
									[
										-0.046,
										-2.596
									],
									[
										-1.283,
										0.011
									],
									[
										-5.247,
										0.255
									],
									[
										0,
										1.245
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0.14,
										1.858
									],
									[
										0.023,
										1.282
									],
									[
										6.155,
										-0.054
									],
									[
										1.244,
										-0.061
									],
									[
										0,
										0
									],
									[
										-6.537,
										-0.361
									]
								],
								v: [
									[
										6.378,
										-11.001
									],
									[
										6.663,
										-4.327
									],
									[
										9.021,
										-2.017
									],
									[
										26.239,
										-2.492
									],
									[
										28.455,
										-4.828
									],
									[
										29.625,
										-10.395
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										6.537,
										-0.361
									],
									[
										0,
										0
									],
									[
										-1.243,
										-0.061
									],
									[
										-6.155,
										-0.054
									],
									[
										-0.023,
										1.282
									],
									[
										-0.14,
										1.858
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										1.245
									],
									[
										5.248,
										0.255
									],
									[
										1.283,
										0.011
									],
									[
										0.046,
										-2.596
									],
									[
										-8.179,
										0.029
									]
								],
								v: [
									[
										-20.547,
										-10.395
									],
									[
										-19.378,
										-4.828
									],
									[
										-17.162,
										-2.492
									],
									[
										0.056,
										-2.017
									],
									[
										2.414,
										-4.327
									],
									[
										2.699,
										-11.001
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 5,
						s: [
							150.788,
							151.064,
							0
						],
						to: [
							0,
							3.333,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 31,
						s: [
							150.788,
							171.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 58,
						s: [
							150.788,
							151.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 84,
						s: [
							150.788,
							171.064,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							3.333,
							0
						]
					},
					{
						t: 111,
						s: [
							150.788,
							151.064,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-5.006
									],
									[
										15.664,
										0
									],
									[
										0,
										6.669
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										0,
										6.097
									],
									[
										-15.664,
										0
									],
									[
										0,
										-6.002
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										32.901,
										-4.805
									],
									[
										4.538,
										10.914
									],
									[
										-23.824,
										-4.805
									],
									[
										4.538,
										-8.061
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eye white left",
		parent: 7,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 1,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 27,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 53.666,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 80.334,
						s: [
							-15.923,
							-30.107,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 107,
						s: [
							-15.923,
							-30.107,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.705,
					-30.107,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-15.455,
										-30.107
									],
									[
										-16.705,
										-28.857
									],
									[
										-17.955,
										-30.107
									],
									[
										-16.705,
										-31.357
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 1,
						s: [
							131.295,
							121.643,
							0
						],
						to: [
							0,
							4.167,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 27,
						s: [
							131.295,
							146.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 53.666,
						s: [
							131.295,
							121.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 80.334,
						s: [
							131.295,
							146.643,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							4.167,
							0
						]
					},
					{
						t: 107,
						s: [
							131.295,
							121.643,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-14.955,
					-28.357,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 21,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 25,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 29,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 77,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 81,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 85,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 101,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 105,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 109,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 25,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-27.982
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 98,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-27.982
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									t: 111,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye white right",
		parent: 9,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 1,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 27,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 53.666,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 80.334,
						s: [
							21.1,
							-29.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 107,
						s: [
							21.1,
							-29.713,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					21.1,
					-29.713,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										22.35,
										-29.713
									],
									[
										21.1,
										-28.463
									],
									[
										19.85,
										-29.713
									],
									[
										21.1,
										-30.963
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 1,
						s: [
							169.1,
							122.037,
							0
						],
						to: [
							0,
							4.167,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 27,
						s: [
							169.1,
							147.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 53.666,
						s: [
							169.1,
							122.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 80.334,
						s: [
							169.1,
							147.037,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							4.167,
							0
						]
					},
					{
						t: 107,
						s: [
							169.1,
							122.037,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					22.85,
					-27.963,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 21,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 25,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 29,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 77,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 81,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 85,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 101,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 105,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 109,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 25,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.475,
													-27.463
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 98,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.475,
													-27.463
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									t: 111,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "hat",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					37.193,
					-103.34,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					37.193,
					-103.34,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 27,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													18.467,
													19.321
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													55.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 53,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													18.467,
													19.321
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													55.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									t: 107,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.352941185236,
								0.717647075653,
								0.870588243008,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 12,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 27,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													41.1,
													-119.673
												],
												[
													55.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 53,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.533,
													-104.821
												],
												[
													41.1,
													-119.673
												],
												[
													55.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									t: 107,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.223529413342,
								0.662745118141,
								0.882352948189,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 1,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							1.667,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 27,
						s: [
							150.205,
							141.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 53,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.3,
							y: 0
						},
						t: 80,
						s: [
							150.205,
							141.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						t: 107,
						s: [
							150.205,
							131.599,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					3.955,
					-18.401,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-48.329
									],
									[
										48.329,
										0
									],
									[
										0,
										48.329
									],
									[
										-48.329,
										0
									]
								],
								o: [
									[
										0,
										48.329
									],
									[
										-48.329,
										0
									],
									[
										0,
										-48.329
									],
									[
										48.329,
										0
									]
								],
								v: [
									[
										91.463,
										-18.401
									],
									[
										3.955,
										69.106
									],
									[
										-83.553,
										-18.401
									],
									[
										3.955,
										-105.909
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0.09,
									0.545,
									0.863,
									1,
									0.46,
									0.449,
									0.851,
									1,
									0.83,
									0.353,
									0.839,
									1,
									0.89,
									0.353,
									0.839,
									1,
									0.95,
									0.353,
									0.839,
									1
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								3,
								-20
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								90.393,
								-19
							],
							ix: 6
						},
						t: 2,
						h: {
							a: 0,
							k: 0,
							ix: 7
						},
						a: {
							a: 0,
							k: 0,
							ix: 8
						},
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "sock left",
		parent: 14,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-16.159,
					101.144,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					101.144,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 27,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.769,
													88.592
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.318,
													88.592
												],
												[
													-26.19,
													87.465
												],
												[
													-5.897,
													87.465
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 53,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.769,
													88.592
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.318,
													88.592
												],
												[
													-26.19,
													87.465
												],
												[
													-5.897,
													87.465
												]
											],
											c: true
										}
									]
								},
								{
									t: 107,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													-4.885,
													81.842
												],
												[
													-4.885,
													109.913
												],
												[
													-15.409,
													121.549
												],
												[
													-27.433,
													110.299
												],
												[
													-27.433,
													81.842
												],
												[
													-26.306,
													80.715
												],
												[
													-6.012,
													80.715
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "sock right",
		parent: 15,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					24.069,
					101.144,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					101.144,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 27,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.437,
													88.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.888,
													88.842
												],
												[
													14.016,
													87.715
												],
												[
													34.309,
													87.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 53,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.437,
													88.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.888,
													88.842
												],
												[
													14.016,
													87.715
												],
												[
													34.309,
													87.715
												]
											],
											c: true
										}
									]
								},
								{
									t: 107,
									s: [
										{
											i: [
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													5.993,
													-0.388
												],
												[
													0,
													6.474
												],
												[
													0,
													0
												],
												[
													-0.623,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													6.005
												],
												[
													-6.566,
													0.425
												],
												[
													0,
													0
												],
												[
													0,
													-0.623
												],
												[
													0,
													0
												],
												[
													0.623,
													0
												]
											],
											v: [
												[
													35.343,
													81.842
												],
												[
													35.343,
													109.913
												],
												[
													24.819,
													121.549
												],
												[
													12.795,
													110.299
												],
												[
													12.795,
													81.842
												],
												[
													13.922,
													80.715
												],
												[
													34.216,
													80.715
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.091,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-16.159,
										110.639
									],
									[
										-16.159,
										28.873
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					170.319,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										24.069,
										110.639
									],
									[
										24.069,
										28.873
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "arm left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					77.305,
					174.924,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-68.945,
					24.924,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 27,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-15.533,
													-31.495
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-63.467,
													80.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 53,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-15.533,
													-31.495
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-63.467,
													80.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									t: 107,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "arm right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					225.044,
					174.924,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					78.794,
					24.924,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 4,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													12.184,
													-32.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.816,
													79.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.3,
										y: 0
									},
									t: 56,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 83,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													12.184,
													-32.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.816,
													79.495
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									t: 110,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					151,
					270,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$e = [
];
var AbbeCorrect = {
	v: v$e,
	fr: fr$e,
	ip: ip$e,
	op: op$e,
	w: w$e,
	h: h$e,
	nm: nm$e,
	ddd: ddd$e,
	assets: assets$e,
	layers: layers$e,
	markers: markers$e
};

var v$d = "5.6.9";
var fr$d = 60;
var ip$d = 0;
var op$d = 180;
var w$d = 300;
var h$d = 300;
var nm$d = "blue_wave";
var ddd$d = 0;
var assets$d = [
];
var layers$d = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-5.006
									],
									[
										15.664,
										0
									],
									[
										0,
										6.669
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										0,
										6.097
									],
									[
										-15.664,
										0
									],
									[
										0,
										-6.002
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										32.901,
										-4.805
									],
									[
										4.538,
										10.914
									],
									[
										-23.824,
										-4.805
									],
									[
										4.538,
										-8.061
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							150.205,
							158.077,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 19,
						s: [
							150.205,
							155.577,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							150.205,
							160.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							150.205,
							155.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 79,
						s: [
							150.205,
							160.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 99,
						s: [
							150.205,
							155.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 119,
						s: [
							150.205,
							160.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 139,
						s: [
							150.205,
							155.577,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 159,
						s: [
							150.205,
							160.577,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 178,
						s: [
							150.205,
							158.077,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					3.955,
					8.077,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-5.208,
										2.332
									],
									[
										6.438,
										0
									],
									[
										3.239,
										-2.707
									],
									[
										-6.439,
										0
									]
								],
								o: [
									[
										-3.239,
										-2.707
									],
									[
										-6.439,
										0
									],
									[
										3.239,
										2.707
									],
									[
										6.438,
										0
									]
								],
								v: [
									[
										19.277,
										9.456
									],
									[
										3.955,
										4.951
									],
									[
										-11.367,
										9.456
									],
									[
										4.538,
										10.914
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.909803926945,
								0.090196080506,
								0.301960796118,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-5.006
									],
									[
										15.664,
										0
									],
									[
										0,
										6.669
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										0,
										6.097
									],
									[
										-15.664,
										0
									],
									[
										0,
										-6.002
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										32.901,
										-4.805
									],
									[
										4.538,
										10.914
									],
									[
										-23.824,
										-4.805
									],
									[
										4.538,
										-8.061
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 0,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 19,
						s: [
							150.789,
							140.991,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 42,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 59,
						s: [
							150.789,
							140.991,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 82,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 99,
						s: [
							150.789,
							140.991,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 122,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 139,
						s: [
							150.789,
							140.991,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 161,
						s: [
							150.789,
							143.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 178,
						s: [
							150.789,
							143.491,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.539,
					-6.509,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										8.179,
										0.029
									],
									[
										-0.046,
										-2.596
									],
									[
										-1.283,
										0.011
									],
									[
										-5.247,
										0.255
									],
									[
										0,
										1.245
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0.14,
										1.858
									],
									[
										0.023,
										1.282
									],
									[
										6.155,
										-0.054
									],
									[
										1.244,
										-0.061
									],
									[
										0,
										0
									],
									[
										-6.537,
										-0.361
									]
								],
								v: [
									[
										6.378,
										-11.001
									],
									[
										6.663,
										-4.327
									],
									[
										9.021,
										-2.017
									],
									[
										26.239,
										-2.492
									],
									[
										28.455,
										-4.828
									],
									[
										29.625,
										-10.395
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										6.537,
										-0.361
									],
									[
										0,
										0
									],
									[
										-1.243,
										-0.061
									],
									[
										-6.155,
										-0.054
									],
									[
										-0.023,
										1.282
									],
									[
										-0.14,
										1.858
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										1.245
									],
									[
										5.248,
										0.255
									],
									[
										1.283,
										0.011
									],
									[
										0.046,
										-2.596
									],
									[
										-8.179,
										0.029
									]
								],
								v: [
									[
										-20.547,
										-10.395
									],
									[
										-19.378,
										-4.828
									],
									[
										-17.162,
										-2.492
									],
									[
										0.056,
										-2.017
									],
									[
										2.414,
										-4.327
									],
									[
										2.699,
										-11.001
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							150.788,
							151.064,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							150.788,
							148.564,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							150.788,
							153.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							150.788,
							148.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							150.788,
							153.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							150.788,
							148.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							150.788,
							153.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							150.788,
							148.564,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							150.788,
							153.564,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 178,
						s: [
							150.788,
							151.064,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.538,
					1.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-5.006
									],
									[
										15.664,
										0
									],
									[
										0,
										6.669
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										0,
										6.097
									],
									[
										-15.664,
										0
									],
									[
										0,
										-6.002
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										32.901,
										-4.805
									],
									[
										4.538,
										10.914
									],
									[
										-23.824,
										-4.805
									],
									[
										4.538,
										-8.061
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eye white left",
		parent: 7,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-16.705,
					-30.107,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.705,
					-30.107,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-15.455,
										-30.107
									],
									[
										-16.705,
										-28.857
									],
									[
										-17.955,
										-30.107
									],
									[
										-16.705,
										-31.357
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							131.295,
							121.643,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 19,
						s: [
							131.295,
							119.143,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 39,
						s: [
							131.295,
							124.143,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 59,
						s: [
							131.295,
							119.143,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 79,
						s: [
							131.295,
							124.143,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 99,
						s: [
							131.295,
							119.143,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 119,
						s: [
							131.295,
							124.143,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 139,
						s: [
							131.295,
							119.143,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 159,
						s: [
							131.295,
							124.143,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 178,
						s: [
							131.295,
							121.643,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-14.955,
					-28.357,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 10,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-15.142,
													-27.607
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 170,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-15.142,
													-27.607
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													-10.955,
													-28.357
												],
												[
													-14.955,
													-24.357
												],
												[
													-18.955,
													-28.357
												],
												[
													-14.955,
													-32.357
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye white right",
		parent: 9,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					21.1,
					-29.713,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					21.1,
					-29.713,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										22.35,
										-29.713
									],
									[
										21.1,
										-28.463
									],
									[
										19.85,
										-29.713
									],
									[
										21.1,
										-30.963
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							169.1,
							122.037,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 19,
						s: [
							169.1,
							119.537,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 39,
						s: [
							169.1,
							124.537,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 59,
						s: [
							169.1,
							119.537,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 79,
						s: [
							169.1,
							124.537,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 99,
						s: [
							169.1,
							119.537,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 119,
						s: [
							169.1,
							124.537,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 139,
						s: [
							169.1,
							119.537,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 159,
						s: [
							169.1,
							124.537,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 178,
						s: [
							169.1,
							122.037,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					22.85,
					-27.963,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 10,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-27.338
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 170,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-27.338
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												],
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												]
											],
											o: [
												[
													0,
													2.209
												],
												[
													-2.209,
													0
												],
												[
													0,
													-2.209
												],
												[
													2.209,
													0
												]
											],
											v: [
												[
													26.85,
													-27.963
												],
												[
													22.85,
													-23.963
												],
												[
													18.85,
													-27.963
												],
												[
													22.85,
													-31.963
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "hat",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					37.193,
					-103.34,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					37.193,
					-103.34,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													22.967,
													6.079
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													26.842,
													14.571
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 60,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													22.967,
													6.079
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													26.842,
													14.571
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 100,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													22.967,
													6.079
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													26.842,
													14.571
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 140,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													22.967,
													6.079
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													26.842,
													14.571
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													19.917,
													11.012
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													60.952,
													-85.106
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.352941185236,
								0.717647075653,
								0.870588243008,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 12,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													45.35,
													-116.923
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 60,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													45.35,
													-116.923
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 100,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													45.35,
													-116.923
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 140,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													45.35,
													-116.923
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-13.647,
													-5.444
												],
												[
													5.444,
													-13.647
												]
											],
											o: [
												[
													5.444,
													-13.647
												],
												[
													13.647,
													5.444
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.533,
													-104.821
												],
												[
													46.1,
													-119.673
												],
												[
													60.952,
													-85.106
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.223529413342,
								0.662745118141,
								0.882352948189,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							150.205,
							131.599,
							0
						],
						to: [
							0,
							-0.333,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							150.205,
							129.599,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							150.205,
							134.099,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							150.205,
							129.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							150.205,
							134.099,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							150.205,
							129.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							150.205,
							134.099,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							150.205,
							129.599,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.333,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							150.205,
							134.099,
							0
						],
						to: [
							0,
							0.333,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 179,
						s: [
							150.205,
							131.599,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					3.955,
					-18.401,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-48.329
									],
									[
										48.329,
										0
									],
									[
										0,
										48.329
									],
									[
										-48.329,
										0
									]
								],
								o: [
									[
										0,
										48.329
									],
									[
										-48.329,
										0
									],
									[
										0,
										-48.329
									],
									[
										48.329,
										0
									]
								],
								v: [
									[
										91.463,
										-18.401
									],
									[
										3.955,
										69.106
									],
									[
										-83.553,
										-18.401
									],
									[
										3.955,
										-105.909
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0.09,
									0.545,
									0.863,
									1,
									0.46,
									0.449,
									0.851,
									1,
									0.83,
									0.353,
									0.839,
									1,
									0.89,
									0.353,
									0.839,
									1,
									0.95,
									0.353,
									0.839,
									1
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								3,
								-20
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								90.393,
								-19
							],
							ix: 6
						},
						t: 2,
						h: {
							a: 0,
							k: 0,
							ix: 7
						},
						a: {
							a: 0,
							k: 0,
							ix: 8
						},
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "arm left",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-68.945,
					24.924,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-68.945,
					24.924,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 19.441,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-4.283,
													-35.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-78.467,
													64.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 38.883,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													1.217,
													-36.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-84.467,
													64.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 58.324,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-4.283,
													-35.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-78.467,
													64.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 77.766,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													1.217,
													-36.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-84.467,
													64.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 97.207,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-4.283,
													-35.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-78.467,
													64.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 116.648,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													1.217,
													-36.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-84.467,
													64.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 136.09,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													-4.283,
													-35.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-78.467,
													64.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 155.531,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													1.217,
													-36.995
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-84.467,
													64.495
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									t: 174,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.474,
													15.525
												]
											],
											o: [
												[
													4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-88.467,
													64.995
												],
												[
													-49.424,
													-15.147
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196078431,
								0.890196078431,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "arm right",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					78.794,
					24.924,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					78.794,
					24.924,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 16,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-4.066,
													34.005
												],
												[
													0,
													0
												]
											],
											v: [
												[
													114.816,
													-66.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 28,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-16.566,
													22.505
												],
												[
													0,
													0
												]
											],
											v: [
												[
													127.316,
													-48.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 39.17,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-4.066,
													34.005
												],
												[
													0,
													0
												]
											],
											v: [
												[
													114.816,
													-66.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 49.34,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-16.566,
													22.505
												],
												[
													0,
													0
												]
											],
											v: [
												[
													127.316,
													-48.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 59.508,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-4.066,
													34.005
												],
												[
													0,
													0
												]
											],
											v: [
												[
													114.816,
													-66.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 69.678,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-16.566,
													22.505
												],
												[
													0,
													0
												]
											],
											v: [
												[
													127.316,
													-48.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 79.848,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-4.066,
													34.005
												],
												[
													0,
													0
												]
											],
											v: [
												[
													114.816,
													-66.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 90.018,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-16.566,
													22.505
												],
												[
													0,
													0
												]
											],
											v: [
												[
													127.316,
													-48.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 100.186,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-4.066,
													34.005
												],
												[
													0,
													0
												]
											],
											v: [
												[
													114.816,
													-66.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 111,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-16.566,
													22.505
												],
												[
													0,
													0
												]
											],
											v: [
												[
													127.316,
													-48.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 122,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-4.066,
													34.005
												],
												[
													0,
													0
												]
											],
											v: [
												[
													114.816,
													-66.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 133,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-16.566,
													22.505
												],
												[
													0,
													0
												]
											],
											v: [
												[
													127.316,
													-48.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 144,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-4.066,
													34.005
												],
												[
													0,
													0
												]
											],
											v: [
												[
													114.816,
													-66.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 157,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													25.477,
													-1.853
												]
											],
											o: [
												[
													-16.566,
													22.505
												],
												[
													0,
													0
												]
											],
											v: [
												[
													127.316,
													-48.505
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													23.474,
													15.525
												]
											],
											o: [
												[
													-4.791,
													-37.344
												],
												[
													0,
													0
												]
											],
											v: [
												[
													98.316,
													64.995
												],
												[
													59.273,
													-15.147
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "sock left",
		parent: 16,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-16.159,
					121.574,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					121.574,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.623
									],
									[
										0,
										0
									],
									[
										5.993,
										-0.388
									],
									[
										0,
										6.474
									],
									[
										0,
										0
									],
									[
										-0.623,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										6.005
									],
									[
										-6.566,
										0.425
									],
									[
										0,
										0
									],
									[
										0,
										-0.623
									],
									[
										0,
										0
									],
									[
										0.623,
										0
									]
								],
								v: [
									[
										-4.885,
										81.842
									],
									[
										-4.885,
										109.913
									],
									[
										-15.409,
										121.549
									],
									[
										-27.433,
										110.299
									],
									[
										-27.433,
										81.842
									],
									[
										-26.306,
										80.715
									],
									[
										-6.012,
										80.715
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "sock right",
		parent: 17,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					24.069,
					121.574,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					121.574,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.623
									],
									[
										0,
										0
									],
									[
										5.993,
										-0.388
									],
									[
										0,
										6.474
									],
									[
										0,
										0
									],
									[
										-0.623,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										6.005
									],
									[
										-6.566,
										0.425
									],
									[
										0,
										0
									],
									[
										0,
										-0.623
									],
									[
										0,
										0
									],
									[
										0.623,
										0
									]
								],
								v: [
									[
										35.343,
										81.842
									],
									[
										35.343,
										109.913
									],
									[
										24.819,
										121.549
									],
									[
										12.795,
										110.299
									],
									[
										12.795,
										81.842
									],
									[
										13.922,
										80.715
									],
									[
										34.216,
										80.715
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.937254905701,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.091,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-16.159,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-16.159,
										110.639
									],
									[
										-16.159,
										28.873
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					170.319,
					219.756,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					24.069,
					69.756,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										24.069,
										110.639
									],
									[
										24.069,
										28.873
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.490196079016,
								0.890196084976,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					151,
					270,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$d = [
];
var AbbeWave = {
	v: v$d,
	fr: fr$d,
	ip: ip$d,
	op: op$d,
	w: w$d,
	h: h$d,
	nm: nm$d,
	ddd: ddd$d,
	assets: assets$d,
	layers: layers$d,
	markers: markers$d
};

var v$c = "5.6.9";
var fr$c = 60;
var ip$c = 0;
var op$c = 201;
var w$c = 300;
var h$c = 300;
var nm$c = "yellow_Bored";
var ddd$c = 0;
var assets$c = [
];
var layers$c = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													2.746,
													-26.057
												],
												[
													-3.73,
													-18.845
												],
												[
													-9.457,
													-26.432
												],
												[
													-3.175,
													-33.548
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 144,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 167,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									t: 180,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		parent: 5,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-20.018,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-20.018,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-1.828,
										2.315
									],
									[
										3.634,
										0
									],
									[
										1.828,
										-2.315
									],
									[
										-3.634,
										0
									]
								],
								o: [
									[
										-1.828,
										-2.315
									],
									[
										-3.634,
										0
									],
									[
										1.828,
										2.315
									],
									[
										3.634,
										0
									]
								],
								v: [
									[
										4.918,
										-20.018
									],
									[
										-3.73,
										-23.871
									],
									[
										-12.379,
										-20.018
									],
									[
										-3.73,
										-16.166
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.909803926945,
								0.090196080506,
								0.301960796118,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													2.746,
													-26.057
												],
												[
													-3.73,
													-18.845
												],
												[
													-9.457,
													-26.432
												],
												[
													-3.175,
													-33.548
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 140,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 167,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									t: 180,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		parent: 5,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-3.73,
							-29.182,
							0
						],
						to: [
							0,
							-0.625,
							0
						],
						ti: [
							0,
							0.625,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 20,
						s: [
							-3.73,
							-32.932,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							-3.73,
							-32.932,
							0
						],
						to: [
							0,
							-0.25,
							0
						],
						ti: [
							0,
							0.25,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 120,
						s: [
							-3.73,
							-34.432,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 167,
						s: [
							-3.73,
							-34.432,
							0
						],
						to: [
							0,
							0.875,
							0
						],
						ti: [
							0,
							-0.875,
							0
						]
					},
					{
						t: 180,
						s: [
							-3.73,
							-29.182,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-29.182,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-4.414
									],
									[
										4.222,
										0
									],
									[
										0,
										3.781
									],
									[
										-2.332,
										0
									]
								],
								o: [
									[
										0,
										4.414
									],
									[
										-4.222,
										0
									],
									[
										0,
										-3.781
									],
									[
										2.332,
										0
									]
								],
								v: [
									[
										0.492,
										-29.182
									],
									[
										-3.73,
										-24.768
									],
									[
										-7.953,
										-29.182
									],
									[
										-3.73,
										-33.596
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							-0.625,
							0
						],
						ti: [
							0,
							0.625,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 20,
						s: [
							146.27,
							128.164,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 29,
						s: [
							146.27,
							128.164,
							0
						],
						to: [
							-1.667,
							0,
							0
						],
						ti: [
							1.667,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 50,
						s: [
							136.27,
							128.164,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							136.27,
							128.164,
							0
						],
						to: [
							1.667,
							0,
							0
						],
						ti: [
							-1.667,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 0.22
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 79,
						s: [
							146.27,
							128.164,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 90,
						s: [
							146.27,
							128.164,
							0
						],
						to: [
							0,
							-1.042,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 120,
						s: [
							146.27,
							121.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-1.042,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 0.22
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 140,
						s: [
							146.27,
							128.164,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 167,
						s: [
							146.27,
							128.164,
							0
						],
						to: [
							0,
							0.625,
							0
						],
						ti: [
							0,
							-0.625,
							0
						]
					},
					{
						t: 180,
						s: [
							146.27,
							131.914,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													2.746,
													-26.057
												],
												[
													-3.73,
													-18.845
												],
												[
													-9.457,
													-26.432
												],
												[
													-3.175,
													-33.548
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 140,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 167,
									s: [
										{
											i: [
												[
													-0.059,
													-0.912
												],
												[
													6.062,
													0
												],
												[
													0.082,
													0.901
												],
												[
													-5.481,
													0.016
												]
											],
											o: [
												[
													-0.059,
													0.838
												],
												[
													-6.062,
													0
												],
												[
													0.189,
													-1.118
												],
												[
													5.492,
													-0.016
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.668,
													-25.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									t: 180,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "glasses",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 0,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							-2.083,
							0,
							0
						],
						ti: [
							2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 50,
						s: [
							133.738,
							90.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							133.738,
							90.321,
							0
						],
						to: [
							2.083,
							0,
							0
						],
						ti: [
							-2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 0.22
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 79,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 90,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							-1.667,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 120,
						s: [
							146.238,
							80.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-1.667,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 140,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 167,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 180,
						s: [
							146.238,
							90.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.762,
					-59.679,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-4.863,
												-70.116
											],
											[
												28.515,
												-94.778
											],
											[
												59.29,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												58.061,
												-55.581
											],
											[
												28.749,
												-30.191
											],
											[
												-0.228,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												15.683,
												0
											],
											[
												6.09,
												10.301
											]
										],
										o: [
											[
												-4.425,
												14.288
											],
											[
												-12.794,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												61.894,
												-49.242
											],
											[
												28.515,
												-24.58
											],
											[
												-1.558,
												-41.786
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-11.621,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												4.843,
												-9.71
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												2.228,
												-72.785
											],
											[
												28.749,
												-89.167
											],
											[
												55.667,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-69.418,
												-70.116
											],
											[
												-36.039,
												-94.778
											],
											[
												-5.264,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.493,
												-55.581
											],
											[
												-35.806,
												-30.191
											],
											[
												-64.783,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												12.252,
												0
											],
											[
												4.903,
												13.433
											]
										],
										o: [
											[
												-6.24,
												9.582
											],
											[
												-15.075,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.768,
												-40.494
											],
											[
												-36.039,
												-24.58
											],
											[
												-68.864,
												-47.598
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-14.302,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												2.76,
												-13.437
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-64.801,
												-65.622
											],
											[
												-35.806,
												-89.167
											],
											[
												-8.888,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-68.167,
										-59.679
									],
									[
										-35.939,
										-27.452
									],
									[
										-3.712,
										-59.679
									],
									[
										-35.939,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-3.712,
										-59.679
									],
									[
										28.515,
										-27.452
									],
									[
										60.743,
										-59.679
									],
									[
										28.515,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye white right",
		parent: 8,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 20,
						s: [
							9.853,
							-53.429,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 167,
						s: [
							9.853,
							-53.429,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 180,
						s: [
							9.853,
							-55.929,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.853,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										11.103,
										-55.929
									],
									[
										9.853,
										-54.679
									],
									[
										8.603,
										-55.929
									],
									[
										9.853,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							1.042,
							0
						],
						ti: [
							0,
							-1.042,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 20,
						s: [
							161.103,
							101.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 29,
						s: [
							161.103,
							101.571,
							0
						],
						to: [
							-1.667,
							0,
							0
						],
						ti: [
							1.667,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 50,
						s: [
							151.103,
							101.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							151.103,
							101.571,
							0
						],
						to: [
							1.667,
							0,
							0
						],
						ti: [
							-1.667,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 79,
						s: [
							161.103,
							101.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							161.103,
							101.571,
							0
						],
						to: [
							0,
							-1.667,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							161.103,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-1.667,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 140,
						s: [
							161.103,
							101.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 167,
						s: [
							161.103,
							101.571,
							0
						],
						to: [
							0,
							-1.042,
							0
						],
						ti: [
							0,
							1.042,
							0
						]
					},
					{
						t: 180,
						s: [
							161.103,
							95.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.103,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 24,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 29,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 34,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 50,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 55,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 60,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 90,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 120,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 140,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 149,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 156,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 163,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													0.022,
													-0.009
												],
												[
													1.933,
													0
												],
												[
													0.439,
													1.883
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.162,
													1.926
												],
												[
													-1.933,
													0
												],
												[
													-0.04,
													-0.009
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													10.978,
													-54.866
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 167,
									s: [
										{
											i: [
												[
													0.022,
													-0.009
												],
												[
													1.933,
													0
												],
												[
													0.439,
													1.883
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.162,
													1.926
												],
												[
													-1.933,
													0
												],
												[
													-0.04,
													-0.009
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													10.978,
													-54.866
												]
											],
											c: true
										}
									]
								},
								{
									t: 180,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye white left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0.406,
							0
						],
						ti: [
							0,
							-0.406,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 20,
						s: [
							-19.813,
							-53.491,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 167,
						s: [
							-19.813,
							-53.491,
							0
						],
						to: [
							0,
							-0.406,
							0
						],
						ti: [
							0,
							0.406,
							0
						]
					},
					{
						t: 180,
						s: [
							-19.813,
							-55.929,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.813,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-18.563,
										-55.929
									],
									[
										-19.813,
										-54.679
									],
									[
										-21.063,
										-55.929
									],
									[
										-19.813,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							1.042,
							0
						],
						ti: [
							0,
							-1.042,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 20,
						s: [
							131.437,
							101.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 29,
						s: [
							131.437,
							101.571,
							0
						],
						to: [
							-1.667,
							0,
							0
						],
						ti: [
							1.667,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 50,
						s: [
							121.437,
							101.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							121.437,
							101.571,
							0
						],
						to: [
							1.667,
							0,
							0
						],
						ti: [
							-1.667,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 79,
						s: [
							131.437,
							101.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							131.437,
							101.571,
							0
						],
						to: [
							0,
							-1.667,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							131.437,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-1.667,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 140,
						s: [
							131.437,
							101.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 167,
						s: [
							131.437,
							101.571,
							0
						],
						to: [
							0,
							-1.042,
							0
						],
						ti: [
							0,
							1.042,
							0
						]
					},
					{
						t: 180,
						s: [
							131.437,
							95.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-18.563,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 24,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 29,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 34,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 50,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 55,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 60,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 90,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 120,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 140,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 144,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 151,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 158,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													0.032,
													-0.134
												],
												[
													1.933,
													0
												],
												[
													-0.002,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.06,
													1.932
												],
												[
													-1.933,
													0
												],
												[
													0.001,
													-0.04
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-54.804
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 167,
									s: [
										{
											i: [
												[
													0.032,
													-0.134
												],
												[
													1.933,
													0
												],
												[
													-0.002,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.06,
													1.932
												],
												[
													-1.933,
													0
												],
												[
													0.001,
													-0.04
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-54.804
												]
											],
											c: true
										}
									]
								},
								{
									t: 180,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							-0.833,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 0.22
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 20,
						s: [
							146.27,
							142.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 90,
						s: [
							146.27,
							142.892,
							0
						],
						to: [
							0,
							-2.25,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 120,
						s: [
							146.27,
							129.392,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-2.25,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 140,
						s: [
							146.27,
							142.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 167,
						s: [
							146.27,
							142.892,
							0
						],
						to: [
							0,
							-0.833,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						t: 180,
						s: [
							146.27,
							137.892,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-12.108,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									]
								],
								v: [
									[
										-3.73,
										-119.688
									],
									[
										-3.73,
										-119.688
									],
									[
										-58.637,
										-64.782
									],
									[
										-58.637,
										17.312
									],
									[
										-58.637,
										40.567
									],
									[
										-3.73,
										95.473
									],
									[
										-3.73,
										95.473
									],
									[
										51.176,
										40.567
									],
									[
										51.176,
										17.312
									],
									[
										51.176,
										-64.782
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									1,
									0.941,
									0.392,
									0.25,
									0.99,
									0.902,
									0.196,
									0.5,
									0.98,
									0.863,
									0,
									0.75,
									0.951,
									0.824,
									0,
									1,
									0.922,
									0.784,
									0
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-59,
								-13
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								50.813,
								-13
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					161.742,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.742,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										11.742,
										119.688
									],
									[
										11.742,
										31.279
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.797,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.203,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-19.203,
										119.688
									],
									[
										-19.203,
										31.279
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "arm left",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.189,
													-41.7
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-70.189,
													45.7
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 29,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.189,
													-41.7
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-70.189,
													45.7
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 50,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0.189,
													-43.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-60.189,
													48.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 60,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0.189,
													-43.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-60.189,
													48.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 79,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.189,
													-41.7
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-70.189,
													45.7
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 167,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.189,
													-41.7
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-70.189,
													45.7
												]
											],
											c: false
										}
									]
								},
								{
									t: 180,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "arm right",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.189,
													-38.797
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													61.689,
													42.297
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 29,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.189,
													-38.797
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													61.689,
													42.297
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 50,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.189,
													-38.797
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													68.189,
													40.297
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 60,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.189,
													-38.797
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													68.189,
													40.297
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 79,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.189,
													-38.797
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													61.689,
													42.297
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 167,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.189,
													-38.797
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													61.689,
													42.297
												]
											],
											c: false
										}
									]
								},
								{
									t: 180,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					146,
					276,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	}
];
var markers$c = [
];
var AlfredBored = {
	v: v$c,
	fr: fr$c,
	ip: ip$c,
	op: op$c,
	w: w$c,
	h: h$c,
	nm: nm$c,
	ddd: ddd$c,
	assets: assets$c,
	layers: layers$c,
	markers: markers$c
};

var v$b = "5.6.9";
var fr$b = 60;
var ip$b = 0;
var op$b = 181;
var w$b = 300;
var h$b = 300;
var nm$b = "yellow_Happy";
var ddd$b = 0;
var assets$b = [
];
var layers$b = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 6,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-2.914
									],
									[
										6.062,
										0
									],
									[
										0,
										3.88
									],
									[
										-5.486,
										-0.143
									]
								],
								o: [
									[
										0,
										3.547
									],
									[
										-6.062,
										0
									],
									[
										0,
										-3.49
									],
									[
										5.491,
										0.143
									]
								],
								v: [
									[
										5.371,
										-26.369
									],
									[
										-3.73,
										-18.845
									],
									[
										-12.832,
										-26.369
									],
									[
										-3.738,
										-27.173
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		parent: 6,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-20.018,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-20.018,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-1.828,
										2.315
									],
									[
										3.634,
										0
									],
									[
										1.828,
										-2.315
									],
									[
										-3.634,
										0
									]
								],
								o: [
									[
										-1.828,
										-2.315
									],
									[
										-3.634,
										0
									],
									[
										1.828,
										2.315
									],
									[
										3.634,
										0
									]
								],
								v: [
									[
										4.918,
										-20.018
									],
									[
										-3.73,
										-23.871
									],
									[
										-12.379,
										-20.018
									],
									[
										-3.73,
										-16.166
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.909803926945,
								0.090196080506,
								0.301960796118,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 6,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-2.914
									],
									[
										6.062,
										0
									],
									[
										0,
										3.88
									],
									[
										-5.486,
										-0.143
									]
								],
								o: [
									[
										0,
										3.547
									],
									[
										-6.062,
										0
									],
									[
										0,
										-3.49
									],
									[
										5.491,
										0.143
									]
								],
								v: [
									[
										5.371,
										-26.369
									],
									[
										-3.73,
										-18.845
									],
									[
										-12.832,
										-26.369
									],
									[
										-3.738,
										-27.173
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		parent: 6,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-29.182,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-29.182,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-4.414
									],
									[
										4.222,
										0
									],
									[
										0,
										3.781
									],
									[
										-2.332,
										0
									]
								],
								o: [
									[
										0,
										4.414
									],
									[
										-4.222,
										0
									],
									[
										0,
										-3.781
									],
									[
										2.332,
										0
									]
								],
								v: [
									[
										0.492,
										-29.182
									],
									[
										-3.73,
										-24.768
									],
									[
										-7.953,
										-29.182
									],
									[
										-3.73,
										-33.596
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "glasses",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							-3.333,
							0
						],
						ti: [
							0,
							-3.333,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							146.238,
							70.321,
							0
						],
						to: [
							0,
							3.333,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							146.238,
							110.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							146.238,
							70.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							146.238,
							110.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							3.333,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 150,
						s: [
							146.238,
							70.321,
							0
						],
						to: [
							0,
							-3.333,
							0
						],
						ti: [
							0,
							-3.333,
							0
						]
					},
					{
						t: 180,
						s: [
							146.238,
							90.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.762,
					-59.679,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-4.863,
												-70.116
											],
											[
												28.515,
												-94.778
											],
											[
												59.29,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												58.061,
												-55.581
											],
											[
												28.749,
												-30.191
											],
											[
												-0.228,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												15.683,
												0
											],
											[
												6.09,
												10.301
											]
										],
										o: [
											[
												-4.425,
												14.288
											],
											[
												-12.794,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												61.894,
												-49.242
											],
											[
												28.515,
												-24.58
											],
											[
												-1.558,
												-41.786
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-11.621,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												4.843,
												-9.71
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												2.228,
												-72.785
											],
											[
												28.749,
												-89.167
											],
											[
												55.667,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-69.418,
												-70.116
											],
											[
												-36.039,
												-94.778
											],
											[
												-5.264,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.493,
												-55.581
											],
											[
												-35.806,
												-30.191
											],
											[
												-64.783,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												12.252,
												0
											],
											[
												4.903,
												13.433
											]
										],
										o: [
											[
												-6.24,
												9.582
											],
											[
												-15.075,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.768,
												-40.494
											],
											[
												-36.039,
												-24.58
											],
											[
												-68.864,
												-47.598
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-14.302,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												2.76,
												-13.437
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-64.801,
												-65.622
											],
											[
												-35.806,
												-89.167
											],
											[
												-8.888,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-68.167,
										-59.679
									],
									[
										-35.939,
										-27.452
									],
									[
										-3.712,
										-59.679
									],
									[
										-35.939,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-3.712,
										-59.679
									],
									[
										28.515,
										-27.452
									],
									[
										60.743,
										-59.679
									],
									[
										28.515,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							-3.75,
							0
						],
						ti: [
							0,
							-3.333,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							146.27,
							109.414,
							0
						],
						to: [
							0,
							3.333,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							146.27,
							151.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							146.27,
							109.414,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							146.27,
							151.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							3.333,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 150,
						s: [
							146.27,
							109.414,
							0
						],
						to: [
							0,
							-3.333,
							0
						],
						ti: [
							0,
							-3.75,
							0
						]
					},
					{
						t: 180,
						s: [
							146.27,
							131.914,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-2.914
									],
									[
										6.062,
										0
									],
									[
										0,
										3.88
									],
									[
										-5.486,
										-0.143
									]
								],
								o: [
									[
										0,
										3.547
									],
									[
										-6.062,
										0
									],
									[
										0,
										-3.49
									],
									[
										5.491,
										0.143
									]
								],
								v: [
									[
										5.371,
										-26.369
									],
									[
										-3.73,
										-18.845
									],
									[
										-12.832,
										-26.369
									],
									[
										-3.738,
										-27.173
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye white right",
		parent: 8,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					9.853,
					-55.929,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.853,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										11.103,
										-55.929
									],
									[
										9.853,
										-54.679
									],
									[
										8.603,
										-55.929
									],
									[
										9.853,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							-5,
							0
						],
						ti: [
							0,
							-5,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							161.103,
							65.321,
							0
						],
						to: [
							0,
							5,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							161.103,
							125.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							161.103,
							65.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							161.103,
							125.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							5,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 150,
						s: [
							161.103,
							65.321,
							0
						],
						to: [
							0,
							-5,
							0
						],
						ti: [
							0,
							-5,
							0
						]
					},
					{
						t: 180,
						s: [
							161.103,
							95.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.103,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 21,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 24,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 27,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 83,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 86,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 89,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 99,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 102,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 105,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 160,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 163,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 166,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										14.603,
										-54.679
									],
									[
										11.103,
										-51.179
									],
									[
										7.603,
										-54.679
									],
									[
										11.103,
										-58.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye white left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-19.813,
					-55.929,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.813,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-18.563,
										-55.929
									],
									[
										-19.813,
										-54.679
									],
									[
										-21.063,
										-55.929
									],
									[
										-19.813,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							-5,
							0
						],
						ti: [
							0,
							-5,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							131.437,
							65.321,
							0
						],
						to: [
							0,
							5,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							131.437,
							125.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							131.437,
							65.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							131.437,
							125.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							5,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 150,
						s: [
							131.437,
							65.321,
							0
						],
						to: [
							0,
							-5,
							0
						],
						ti: [
							0,
							-5,
							0
						]
					},
					{
						t: 180,
						s: [
							131.437,
							95.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-18.563,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 21,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 24,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 27,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 83,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 86,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 89,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 99,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 102,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 105,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 160,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 163,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 166,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										-15.063,
										-54.679
									],
									[
										-18.563,
										-51.179
									],
									[
										-22.063,
										-54.679
									],
									[
										-18.563,
										-58.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							-2.5,
							0
						],
						ti: [
							0,
							-2.5,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							146.27,
							122.892,
							0
						],
						to: [
							0,
							2.5,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							146.27,
							152.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							146.27,
							122.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							146.27,
							152.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							2.5,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 150,
						s: [
							146.27,
							122.892,
							0
						],
						to: [
							0,
							-2.5,
							0
						],
						ti: [
							0,
							-2.5,
							0
						]
					},
					{
						t: 180,
						s: [
							146.27,
							137.892,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-12.108,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									]
								],
								v: [
									[
										-3.73,
										-119.688
									],
									[
										-3.73,
										-119.688
									],
									[
										-58.637,
										-64.782
									],
									[
										-58.637,
										17.312
									],
									[
										-58.637,
										40.567
									],
									[
										-3.73,
										95.473
									],
									[
										-3.73,
										95.473
									],
									[
										51.176,
										40.567
									],
									[
										51.176,
										17.312
									],
									[
										51.176,
										-64.782
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									1,
									0.941,
									0.392,
									0.25,
									0.99,
									0.902,
									0.196,
									0.5,
									0.98,
									0.863,
									0,
									0.75,
									0.951,
									0.824,
									0,
									1,
									0.922,
									0.784,
									0
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-59,
								-13
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								50.813,
								-13
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					161.742,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.742,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										11.742,
										119.688
									],
									[
										11.742,
										31.279
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.797,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.203,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-19.203,
										119.688
									],
									[
										-19.203,
										31.279
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "arm left ",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 4,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 34,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													16.189,
													57.3
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-86.689,
													-95.8
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 64,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													5.689,
													61.3
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-83.689,
													-46.3
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 94,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													16.189,
													57.3
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-86.689,
													-95.8
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 124,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													5.689,
													61.3
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-83.689,
													-46.3
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 154,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													16.189,
													57.3
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-86.689,
													-95.8
												]
											],
											c: false
										}
									]
								},
								{
									t: 180,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "arm right",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 4,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 34,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-19.689,
													48.493
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													82.189,
													-87.703
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 64,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-15.689,
													67.424
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													73.689,
													-50.203
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 94,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-19.689,
													48.493
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													82.189,
													-87.703
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 124,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-15.689,
													67.424
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													73.689,
													-50.203
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 154,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-19.689,
													48.493
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													82.189,
													-87.703
												]
											],
											c: false
										}
									]
								},
								{
									t: 180,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					146,
					276,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	}
];
var markers$b = [
];
var AlfredExcited = {
	v: v$b,
	fr: fr$b,
	ip: ip$b,
	op: op$b,
	w: w$b,
	h: h$b,
	nm: nm$b,
	ddd: ddd$b,
	assets: assets$b,
	layers: layers$b,
	markers: markers$b
};

var v$a = "5.6.9";
var fr$a = 60;
var ip$a = 0;
var op$a = 181;
var w$a = 300;
var h$a = 300;
var nm$a = "yellow_Idle";
var ddd$a = 0;
var assets$a = [
];
var layers$a = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 6,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													0.015,
													-1.1
												],
												[
													1.574,
													0.064
												],
												[
													0.113,
													1.494
												],
												[
													-3.792,
													-0.13
												]
											],
											o: [
												[
													-0.027,
													1.994
												],
												[
													-1.272,
													-0.052
												],
												[
													-0.163,
													-2.156
												],
												[
													3.206,
													0.11
												]
											],
											v: [
												[
													-0.723,
													-26.338
												],
												[
													-4.574,
													-23.095
												],
												[
													-8.363,
													-25.682
												],
												[
													-4.144,
													-29.548
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 110,
									s: [
										{
											i: [
												[
													0.015,
													-1.1
												],
												[
													1.574,
													0.064
												],
												[
													0.113,
													1.494
												],
												[
													-3.792,
													-0.13
												]
											],
											o: [
												[
													-0.027,
													1.994
												],
												[
													-1.272,
													-0.052
												],
												[
													-0.163,
													-2.156
												],
												[
													3.206,
													0.11
												]
											],
											v: [
												[
													-0.723,
													-26.338
												],
												[
													-4.574,
													-23.095
												],
												[
													-8.363,
													-25.682
												],
												[
													-4.144,
													-29.548
												]
											],
											c: true
										}
									]
								},
								{
									t: 122,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		parent: 6,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-20.018,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-20.018,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-1.828,
										2.315
									],
									[
										3.634,
										0
									],
									[
										1.828,
										-2.315
									],
									[
										-3.634,
										0
									]
								],
								o: [
									[
										-1.828,
										-2.315
									],
									[
										-3.634,
										0
									],
									[
										1.828,
										2.315
									],
									[
										3.634,
										0
									]
								],
								v: [
									[
										4.918,
										-20.018
									],
									[
										-3.73,
										-23.871
									],
									[
										-12.379,
										-20.018
									],
									[
										-3.73,
										-16.166
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.909803926945,
								0.090196080506,
								0.301960796118,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 6,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													0.015,
													-1.1
												],
												[
													1.574,
													0.064
												],
												[
													0.113,
													1.494
												],
												[
													-3.792,
													-0.13
												]
											],
											o: [
												[
													-0.027,
													1.994
												],
												[
													-1.272,
													-0.052
												],
												[
													-0.163,
													-2.156
												],
												[
													3.206,
													0.11
												]
											],
											v: [
												[
													-0.723,
													-26.338
												],
												[
													-4.574,
													-23.095
												],
												[
													-8.363,
													-25.682
												],
												[
													-4.144,
													-29.548
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 110,
									s: [
										{
											i: [
												[
													0.015,
													-1.1
												],
												[
													1.574,
													0.064
												],
												[
													0.113,
													1.494
												],
												[
													-3.792,
													-0.13
												]
											],
											o: [
												[
													-0.027,
													1.994
												],
												[
													-1.272,
													-0.052
												],
												[
													-0.163,
													-2.156
												],
												[
													3.206,
													0.11
												]
											],
											v: [
												[
													-0.723,
													-26.338
												],
												[
													-4.574,
													-23.095
												],
												[
													-8.363,
													-25.682
												],
												[
													-4.144,
													-29.548
												]
											],
											c: true
										}
									]
								},
								{
									t: 122,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		parent: 6,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							-3.73,
							-29.182,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 90,
						s: [
							-3.73,
							-31.682,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 110,
						s: [
							-3.73,
							-31.682,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						t: 122,
						s: [
							-3.73,
							-29.182,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-29.182,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-4.414
									],
									[
										4.222,
										0
									],
									[
										0,
										3.781
									],
									[
										-2.332,
										0
									]
								],
								o: [
									[
										0,
										4.414
									],
									[
										-4.222,
										0
									],
									[
										0,
										-3.781
									],
									[
										2.332,
										0
									]
								],
								v: [
									[
										0.492,
										-29.182
									],
									[
										-3.73,
										-24.768
									],
									[
										-7.953,
										-29.182
									],
									[
										-3.73,
										-33.596
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "glasses",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							2.5,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							146.238,
							105.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 110,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							-1.667,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 144,
						s: [
							146.238,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						t: 180,
						s: [
							146.238,
							90.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.762,
					-59.679,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-4.863,
												-70.116
											],
											[
												28.515,
												-94.778
											],
											[
												59.29,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												58.061,
												-55.581
											],
											[
												28.749,
												-30.191
											],
											[
												-0.228,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												15.683,
												0
											],
											[
												6.09,
												10.301
											]
										],
										o: [
											[
												-4.425,
												14.288
											],
											[
												-12.794,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												61.894,
												-49.242
											],
											[
												28.515,
												-24.58
											],
											[
												-1.558,
												-41.786
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-11.621,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												4.843,
												-9.71
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												2.228,
												-72.785
											],
											[
												28.749,
												-89.167
											],
											[
												55.667,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-69.418,
												-70.116
											],
											[
												-36.039,
												-94.778
											],
											[
												-5.264,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.493,
												-55.581
											],
											[
												-35.806,
												-30.191
											],
											[
												-64.783,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												12.252,
												0
											],
											[
												4.903,
												13.433
											]
										],
										o: [
											[
												-6.24,
												9.582
											],
											[
												-15.075,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.768,
												-40.494
											],
											[
												-36.039,
												-24.58
											],
											[
												-68.864,
												-47.598
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-14.302,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												2.76,
												-13.437
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-64.801,
												-65.622
											],
											[
												-35.806,
												-89.167
											],
											[
												-8.888,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-68.167,
										-59.679
									],
									[
										-35.939,
										-27.452
									],
									[
										-3.712,
										-59.679
									],
									[
										-35.939,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-3.712,
										-59.679
									],
									[
										28.515,
										-27.452
									],
									[
										60.743,
										-59.679
									],
									[
										28.515,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 39,
						s: [
							146.27,
							136.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 75,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 110,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 144,
						s: [
							146.27,
							136.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						t: 180,
						s: [
							146.27,
							131.914,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													0.015,
													-1.1
												],
												[
													1.574,
													0.064
												],
												[
													0.113,
													1.494
												],
												[
													-3.792,
													-0.13
												]
											],
											o: [
												[
													-0.027,
													1.994
												],
												[
													-1.272,
													-0.052
												],
												[
													-0.163,
													-2.156
												],
												[
													3.206,
													0.11
												]
											],
											v: [
												[
													-0.723,
													-26.338
												],
												[
													-4.574,
													-23.095
												],
												[
													-8.363,
													-25.682
												],
												[
													-4.144,
													-29.548
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 110,
									s: [
										{
											i: [
												[
													0.015,
													-1.1
												],
												[
													1.574,
													0.064
												],
												[
													0.113,
													1.494
												],
												[
													-3.792,
													-0.13
												]
											],
											o: [
												[
													-0.027,
													1.994
												],
												[
													-1.272,
													-0.052
												],
												[
													-0.163,
													-2.156
												],
												[
													3.206,
													0.11
												]
											],
											v: [
												[
													-0.723,
													-26.338
												],
												[
													-4.574,
													-23.095
												],
												[
													-8.363,
													-25.682
												],
												[
													-4.144,
													-29.548
												]
											],
											c: true
										}
									]
								},
								{
									t: 122,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye white right",
		parent: 8,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					9.853,
					-55.929,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.853,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										11.103,
										-55.929
									],
									[
										9.853,
										-54.679
									],
									[
										8.603,
										-55.929
									],
									[
										9.853,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 39,
						s: [
							161.103,
							100.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 75,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 110,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 144,
						s: [
							161.103,
							100.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						t: 180,
						s: [
							161.103,
							95.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.103,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 20,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 23,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 26,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 85,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 93,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 110,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 116,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 156,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 159,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 162,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										14.603,
										-54.679
									],
									[
										11.103,
										-51.179
									],
									[
										7.603,
										-54.679
									],
									[
										11.103,
										-58.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye white left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 0,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 39,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 75,
						s: [
							-19.813,
							-55.929,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.813,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-18.563,
										-55.929
									],
									[
										-19.813,
										-54.679
									],
									[
										-21.063,
										-55.929
									],
									[
										-19.813,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 39,
						s: [
							131.437,
							100.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 75,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 110,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 144,
						s: [
							131.437,
							100.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						t: 180,
						s: [
							131.437,
							95.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-18.563,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 20,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 23,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 26,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 85,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 93,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 110,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 116,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 156,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 159,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 162,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										-15.063,
										-54.679
									],
									[
										-18.563,
										-51.179
									],
									[
										-22.063,
										-54.679
									],
									[
										-18.563,
										-58.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "body 2",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					146.27,
					137.892,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-12.108,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									]
								],
								v: [
									[
										-3.73,
										-119.688
									],
									[
										-3.73,
										-119.688
									],
									[
										-58.637,
										-64.782
									],
									[
										-58.637,
										17.312
									],
									[
										-58.637,
										40.567
									],
									[
										-3.73,
										95.473
									],
									[
										-3.73,
										95.473
									],
									[
										51.176,
										40.567
									],
									[
										51.176,
										17.312
									],
									[
										51.176,
										-64.782
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									1,
									0.941,
									0.392,
									0.25,
									0.99,
									0.902,
									0.196,
									0.5,
									0.98,
									0.863,
									0,
									0.75,
									0.951,
									0.824,
									0,
									1,
									0.922,
									0.784,
									0
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-59,
								-13
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								50.813,
								-13
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "arm left 2",
		parent: 14,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-67.159,
													-16.854
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 70,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-67.159,
													-16.854
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-36.061,
													23.55
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-67.159,
													-16.854
												],
												[
													-48.189,
													-2.3
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 110,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-28.561,
													37.05
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-67.159,
													-16.854
												],
												[
													-47.939,
													-17.3
												]
											],
											c: false
										}
									]
								},
								{
									t: 130,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-67.159,
													-16.854
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 35,
						s: [
							146.27,
							142.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 70,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 110,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 144,
						s: [
							146.27,
							142.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						t: 180,
						s: [
							146.27,
							137.892,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-12.108,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									]
								],
								v: [
									[
										-3.73,
										-119.688
									],
									[
										-3.73,
										-119.688
									],
									[
										-58.637,
										-64.782
									],
									[
										-58.637,
										17.312
									],
									[
										-58.637,
										40.567
									],
									[
										-3.73,
										95.473
									],
									[
										-3.73,
										95.473
									],
									[
										51.176,
										40.567
									],
									[
										51.176,
										17.312
									],
									[
										51.176,
										-64.782
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									1,
									0.941,
									0.392,
									0.25,
									0.99,
									0.902,
									0.196,
									0.5,
									0.98,
									0.863,
									0,
									0.75,
									0.951,
									0.824,
									0,
									1,
									0.922,
									0.784,
									0
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-59,
								-13
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								50.813,
								-13
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "arm left 3",
		parent: 14,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 70,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-31.975,
													22.747
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-45.873,
													-32.17
												],
												[
													-45.65,
													-2.372
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 110,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-34.186,
													50.8
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-47.409,
													-30.854
												],
												[
													-44.439,
													-22.05
												]
											],
											c: false
										}
									]
								},
								{
									t: 130,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					161.742,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.742,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										11.742,
										119.688
									],
									[
										11.742,
										31.279
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.797,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.203,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-19.203,
										119.688
									],
									[
										-19.203,
										31.279
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "arm right",
		parent: 14,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-23.46,
										-29.584
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										24.782,
										-44.354
									],
									[
										92.189,
										30.797
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					146,
					276,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	}
];
var markers$a = [
];
var AlfredIdle = {
	v: v$a,
	fr: fr$a,
	ip: ip$a,
	op: op$a,
	w: w$a,
	h: h$a,
	nm: nm$a,
	ddd: ddd$a,
	assets: assets$a,
	layers: layers$a,
	markers: markers$a
};

var v$9 = "5.6.9";
var fr$9 = 60;
var ip$9 = 0;
var op$9 = 180;
var w$9 = 300;
var h$9 = 300;
var nm$9 = "yellow_No";
var ddd$9 = 0;
var assets$9 = [
];
var layers$9 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 9,
									s: [
										{
											i: [
												[
													-0.121,
													-1.631
												],
												[
													6.062,
													0
												],
												[
													-0.043,
													3.463
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.263,
													3.537
												],
												[
													-6.062,
													0
												],
												[
													0.021,
													-1.693
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.152,
													-23.651
												],
												[
													-3.98,
													-25.283
												],
												[
													-12.675,
													-23.494
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 170,
									s: [
										{
											i: [
												[
													-0.121,
													-1.631
												],
												[
													6.062,
													0
												],
												[
													-0.043,
													3.463
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.263,
													3.537
												],
												[
													-6.062,
													0
												],
												[
													0.021,
													-1.693
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.152,
													-23.651
												],
												[
													-3.98,
													-25.283
												],
												[
													-12.675,
													-23.494
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		parent: 5,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-20.018,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-20.018,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-1.828,
										2.315
									],
									[
										3.634,
										0
									],
									[
										1.828,
										-2.315
									],
									[
										-3.634,
										0
									]
								],
								o: [
									[
										-1.828,
										-2.315
									],
									[
										-3.634,
										0
									],
									[
										1.828,
										2.315
									],
									[
										3.634,
										0
									]
								],
								v: [
									[
										4.918,
										-20.018
									],
									[
										-3.73,
										-23.871
									],
									[
										-12.379,
										-20.018
									],
									[
										-3.73,
										-16.166
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.909803926945,
								0.090196080506,
								0.301960796118,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 9,
									s: [
										{
											i: [
												[
													-0.121,
													-1.631
												],
												[
													6.062,
													0
												],
												[
													-0.043,
													3.463
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.263,
													3.537
												],
												[
													-6.062,
													0
												],
												[
													0.021,
													-1.693
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.152,
													-23.651
												],
												[
													-3.98,
													-25.283
												],
												[
													-12.675,
													-23.494
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 170,
									s: [
										{
											i: [
												[
													-0.121,
													-1.631
												],
												[
													6.062,
													0
												],
												[
													-0.043,
													3.463
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.263,
													3.537
												],
												[
													-6.062,
													0
												],
												[
													0.021,
													-1.693
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.152,
													-23.651
												],
												[
													-3.98,
													-25.283
												],
												[
													-12.675,
													-23.494
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		parent: 5,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-29.182,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-29.182,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-4.414
									],
									[
										4.222,
										0
									],
									[
										0,
										3.781
									],
									[
										-2.332,
										0
									]
								],
								o: [
									[
										0,
										4.414
									],
									[
										-4.222,
										0
									],
									[
										0,
										-3.781
									],
									[
										2.332,
										0
									]
								],
								v: [
									[
										0.492,
										-29.182
									],
									[
										-3.73,
										-24.768
									],
									[
										-7.953,
										-29.182
									],
									[
										-3.73,
										-33.596
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-3.73,
							-22.586,
							0
						],
						to: [
							-3.333,
							0,
							0
						],
						ti: [
							-3.333,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							-23.73,
							-22.586,
							0
						],
						to: [
							3.333,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 37,
						s: [
							16.27,
							-22.586,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 57,
						s: [
							-23.73,
							-22.586,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 77,
						s: [
							16.27,
							-22.586,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 97,
						s: [
							-23.73,
							-22.586,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 117,
						s: [
							16.27,
							-22.586,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 137,
						s: [
							-23.73,
							-22.586,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-3.333,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 157,
						s: [
							16.27,
							-22.586,
							0
						],
						to: [
							3.333,
							0,
							0
						],
						ti: [
							3.333,
							0,
							0
						]
					},
					{
						t: 176,
						s: [
							-3.73,
							-22.586,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 9,
									s: [
										{
											i: [
												[
													-0.121,
													-1.631
												],
												[
													6.062,
													0
												],
												[
													-0.043,
													3.463
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.263,
													3.537
												],
												[
													-6.062,
													0
												],
												[
													0.021,
													-1.693
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.152,
													-23.651
												],
												[
													-3.98,
													-25.283
												],
												[
													-12.675,
													-23.494
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 170,
									s: [
										{
											i: [
												[
													-0.121,
													-1.631
												],
												[
													6.062,
													0
												],
												[
													-0.043,
													3.463
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.263,
													3.537
												],
												[
													-6.062,
													0
												],
												[
													0.021,
													-1.693
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.152,
													-23.651
												],
												[
													-3.98,
													-25.283
												],
												[
													-12.675,
													-23.494
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "glasses",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-3.762,
							-59.679,
							0
						],
						to: [
							-3.333,
							0,
							0
						],
						ti: [
							-3.333,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							-23.762,
							-59.679,
							0
						],
						to: [
							3.333,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							16.238,
							-59.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							-23.762,
							-59.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							16.238,
							-59.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							-23.762,
							-59.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							16.238,
							-59.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							-23.762,
							-59.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-3.333,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							16.238,
							-59.679,
							0
						],
						to: [
							3.333,
							0,
							0
						],
						ti: [
							3.333,
							0,
							0
						]
					},
					{
						t: 179,
						s: [
							-3.762,
							-59.679,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.762,
					-59.679,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-4.863,
												-70.116
											],
											[
												28.515,
												-94.778
											],
											[
												59.29,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												58.061,
												-55.581
											],
											[
												28.749,
												-30.191
											],
											[
												-0.228,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												15.683,
												0
											],
											[
												6.09,
												10.301
											]
										],
										o: [
											[
												-4.425,
												14.288
											],
											[
												-12.794,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												61.894,
												-49.242
											],
											[
												28.515,
												-24.58
											],
											[
												-1.558,
												-41.786
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-11.621,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												4.843,
												-9.71
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												2.228,
												-72.785
											],
											[
												28.749,
												-89.167
											],
											[
												55.667,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-69.418,
												-70.116
											],
											[
												-36.039,
												-94.778
											],
											[
												-5.264,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.493,
												-55.581
											],
											[
												-35.806,
												-30.191
											],
											[
												-64.783,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												12.252,
												0
											],
											[
												4.903,
												13.433
											]
										],
										o: [
											[
												-6.24,
												9.582
											],
											[
												-15.075,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.768,
												-40.494
											],
											[
												-36.039,
												-24.58
											],
											[
												-68.864,
												-47.598
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-14.302,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												2.76,
												-13.437
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-64.801,
												-65.622
											],
											[
												-35.806,
												-89.167
											],
											[
												-8.888,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-68.167,
										-59.679
									],
									[
										-35.939,
										-27.452
									],
									[
										-3.712,
										-59.679
									],
									[
										-35.939,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-3.712,
										-59.679
									],
									[
										28.515,
										-27.452
									],
									[
										60.743,
										-59.679
									],
									[
										28.515,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye white right",
		parent: 8,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 0,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 17,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 37,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 57,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 77,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 97,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 117,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 137,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 157,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 176,
						s: [
							9.853,
							-55.929,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.853,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										11.103,
										-55.929
									],
									[
										9.853,
										-54.679
									],
									[
										8.603,
										-55.929
									],
									[
										9.853,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye right",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							11.103,
							-54.679,
							0
						],
						to: [
							-3.333,
							0,
							0
						],
						ti: [
							-3.333,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							-8.897,
							-54.679,
							0
						],
						to: [
							3.333,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 37,
						s: [
							31.103,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 57,
						s: [
							-8.897,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 77,
						s: [
							31.103,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 97,
						s: [
							-8.897,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 117,
						s: [
							31.103,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 137,
						s: [
							-8.897,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-3.333,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 157,
						s: [
							31.103,
							-54.679,
							0
						],
						to: [
							3.333,
							0,
							0
						],
						ti: [
							3.333,
							0,
							0
						]
					},
					{
						t: 176,
						s: [
							11.103,
							-54.679,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.103,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 31,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 34,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 37,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 77,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 80,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 83,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 131,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 134,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 137,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 17,
									s: [
										{
											i: [
												[
													0.085,
													0
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.918,
													0.236
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0,
													0.054
												]
											],
											v: [
												[
													14.603,
													-54.562
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 37,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													0,
													0.179
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													0.116
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.562
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 57,
									s: [
										{
											i: [
												[
													0.085,
													0
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.918,
													0.236
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0,
													0.054
												]
											],
											v: [
												[
													14.603,
													-54.562
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 77,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													0,
													0.179
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													0.116
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.562
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 97,
									s: [
										{
											i: [
												[
													0.085,
													0
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.918,
													0.236
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0,
													0.054
												]
											],
											v: [
												[
													14.603,
													-54.562
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 117,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													0,
													0.179
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													0.116
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.562
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0.085,
													0
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.918,
													0.236
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0,
													0.054
												]
											],
											v: [
												[
													14.603,
													-54.562
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 157,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													0,
													0.179
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													0.116
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.562
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									t: 176,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye white left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 0,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 17,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 37,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 57,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 77,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 97,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 117,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 137,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 157,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 176,
						s: [
							-19.813,
							-55.929,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.813,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-18.563,
										-55.929
									],
									[
										-19.813,
										-54.679
									],
									[
										-21.063,
										-55.929
									],
									[
										-19.813,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "eye left",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-18.563,
							-54.679,
							0
						],
						to: [
							-3.333,
							0,
							0
						],
						ti: [
							-3.333,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							-38.563,
							-54.679,
							0
						],
						to: [
							3.333,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 37,
						s: [
							1.437,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 57,
						s: [
							-38.563,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 77,
						s: [
							1.437,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 97,
						s: [
							-38.563,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 117,
						s: [
							1.437,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 137,
						s: [
							-38.563,
							-54.679,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-3.333,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 157,
						s: [
							1.437,
							-54.679,
							0
						],
						to: [
							3.333,
							0,
							0
						],
						ti: [
							3.333,
							0,
							0
						]
					},
					{
						t: 176,
						s: [
							-18.563,
							-54.679,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-18.563,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 31,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 34,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 37,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 77,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 80,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 83,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 131,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 134,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 137,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 17,
									s: [
										{
											i: [
												[
													0,
													0.179
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.002,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													-0.062,
													0
												]
											],
											v: [
												[
													-15,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.625,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 37,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													0.126,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													0.116
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.688
												],
												[
													-18.625,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 57,
									s: [
										{
											i: [
												[
													0,
													0.179
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.002,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													-0.062,
													0
												]
											],
											v: [
												[
													-15,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.625,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 77,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													0.126,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													0.116
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.688
												],
												[
													-18.625,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 97,
									s: [
										{
											i: [
												[
													0,
													0.179
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.002,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													-0.062,
													0
												]
											],
											v: [
												[
													-15,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.625,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 117,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													0.126,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													0.116
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.688
												],
												[
													-18.625,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													0.179
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.002,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													-0.062,
													0
												]
											],
											v: [
												[
													-15,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.625,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 157,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													0.126,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													0.116
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.688
												],
												[
													-18.625,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									t: 176,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					146.27,
					137.892,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-12.108,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									]
								],
								v: [
									[
										-3.73,
										-119.688
									],
									[
										-3.73,
										-119.688
									],
									[
										-58.637,
										-64.782
									],
									[
										-58.637,
										17.312
									],
									[
										-58.637,
										40.567
									],
									[
										-3.73,
										95.473
									],
									[
										-3.73,
										95.473
									],
									[
										51.176,
										40.567
									],
									[
										51.176,
										17.312
									],
									[
										51.176,
										-64.782
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									1,
									0.941,
									0.392,
									0.25,
									0.99,
									0.902,
									0.196,
									0.5,
									0.98,
									0.863,
									0,
									0.75,
									0.951,
									0.824,
									0,
									1,
									0.922,
									0.784,
									0
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-59,
								-13
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								50.813,
								-13
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					161.742,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.742,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.742,
													119.688
												],
												[
													11.742,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 17,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													19.646
												]
											],
											o: [
												[
													-6.242,
													-35.688
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.742,
													119.688
												],
												[
													11.742,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 37,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													19.646
												]
											],
											o: [
												[
													4.758,
													-35.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.742,
													119.688
												],
												[
													11.742,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 57,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													19.646
												]
											],
											o: [
												[
													-6.242,
													-35.688
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.742,
													119.688
												],
												[
													11.742,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 77,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													19.646
												]
											],
											o: [
												[
													4.758,
													-35.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.742,
													119.688
												],
												[
													11.742,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 97,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													19.646
												]
											],
											o: [
												[
													-6.242,
													-35.688
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.742,
													119.688
												],
												[
													11.742,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 117,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													19.646
												]
											],
											o: [
												[
													4.758,
													-35.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.742,
													119.688
												],
												[
													11.742,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													19.646
												]
											],
											o: [
												[
													-6.242,
													-35.688
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.742,
													119.688
												],
												[
													11.742,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 157,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													19.646
												]
											],
											o: [
												[
													4.758,
													-35.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.742,
													119.688
												],
												[
													11.742,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									t: 176,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.742,
													119.688
												],
												[
													11.742,
													31.279
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.797,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.203,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-19.203,
													119.688
												],
												[
													-19.203,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 17,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.797,
													-36.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-19.203,
													119.688
												],
												[
													-19.203,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 37,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													7.703,
													-38.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-19.203,
													119.688
												],
												[
													-19.203,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 57,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.797,
													-36.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-19.203,
													119.688
												],
												[
													-19.203,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 77,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													7.703,
													-38.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-19.203,
													119.688
												],
												[
													-19.203,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 97,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.797,
													-36.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-19.203,
													119.688
												],
												[
													-19.203,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 117,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													7.703,
													-38.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-19.203,
													119.688
												],
												[
													-19.203,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.797,
													-36.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-19.203,
													119.688
												],
												[
													-19.203,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 157,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													7.703,
													-38.188
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-19.203,
													119.688
												],
												[
													-19.203,
													31.279
												]
											],
											c: false
										}
									]
								},
								{
									t: 176,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-19.203,
													119.688
												],
												[
													-19.203,
													31.279
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "arm left",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 18,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													6.189,
													-46.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-71.189,
													29.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 38,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 58,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													6.189,
													-46.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-71.189,
													29.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 78,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 98,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													6.189,
													-46.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-71.189,
													29.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 118,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 138,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													6.189,
													-46.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-71.189,
													29.2
												]
											],
											c: false
										}
									]
								},
								{
									t: 167,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "arm right",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 2,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 31,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.689,
													-38.297
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													62.189,
													24.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 59,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 79,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.689,
													-38.297
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													62.189,
													24.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 99,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 119,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.689,
													-38.297
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													62.189,
													24.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 139,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 159,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.689,
													-38.297
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													62.189,
													24.797
												]
											],
											c: false
										}
									]
								},
								{
									t: 178,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					146,
					276,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$9 = [
];
var AlfredWrong = {
	v: v$9,
	fr: fr$9,
	ip: ip$9,
	op: op$9,
	w: w$9,
	h: h$9,
	nm: nm$9,
	ddd: ddd$9,
	assets: assets$9,
	layers: layers$9,
	markers: markers$9
};

var v$8 = "5.6.9";
var fr$8 = 60;
var ip$8 = 0;
var op$8 = 180;
var w$8 = 300;
var h$8 = 300;
var nm$8 = "yellow_Yes";
var ddd$8 = 0;
var assets$8 = [
];
var layers$8 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 8,
									s: [
										{
											i: [
												[
													-0.965,
													-2.201
												],
												[
													6.062,
													0
												],
												[
													-0.381,
													1.063
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.513,
													1.17
												],
												[
													-6.062,
													0
												],
												[
													0.957,
													-2.669
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.543,
													-22.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.706,
													-24.954
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 171,
									s: [
										{
											i: [
												[
													-0.965,
													-2.201
												],
												[
													6.062,
													0
												],
												[
													-0.381,
													1.063
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.513,
													1.17
												],
												[
													-6.062,
													0
												],
												[
													0.957,
													-2.669
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.543,
													-22.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.706,
													-24.954
												]
											],
											c: true
										}
									]
								},
								{
									t: 178,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		parent: 5,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-3.73,
							-20.018,
							0
						],
						to: [
							0,
							0.312,
							0
						],
						ti: [
							0,
							-0.312,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 8,
						s: [
							-3.73,
							-18.143,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 171,
						s: [
							-3.73,
							-18.143,
							0
						],
						to: [
							0,
							-0.312,
							0
						],
						ti: [
							0,
							0.312,
							0
						]
					},
					{
						t: 178,
						s: [
							-3.73,
							-20.018,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-20.018,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-1.828,
										2.315
									],
									[
										3.634,
										0
									],
									[
										1.828,
										-2.315
									],
									[
										-3.634,
										0
									]
								],
								o: [
									[
										-1.828,
										-2.315
									],
									[
										-3.634,
										0
									],
									[
										1.828,
										2.315
									],
									[
										3.634,
										0
									]
								],
								v: [
									[
										4.918,
										-20.018
									],
									[
										-3.73,
										-23.871
									],
									[
										-12.379,
										-20.018
									],
									[
										-3.73,
										-16.166
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.909803926945,
								0.090196080506,
								0.301960796118,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 8,
									s: [
										{
											i: [
												[
													-0.965,
													-2.201
												],
												[
													6.062,
													0
												],
												[
													-0.381,
													1.063
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.513,
													1.17
												],
												[
													-6.062,
													0
												],
												[
													0.957,
													-2.669
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.543,
													-22.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.706,
													-24.954
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 171,
									s: [
										{
											i: [
												[
													-0.965,
													-2.201
												],
												[
													6.062,
													0
												],
												[
													-0.381,
													1.063
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.513,
													1.17
												],
												[
													-6.062,
													0
												],
												[
													0.957,
													-2.669
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.543,
													-22.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.706,
													-24.954
												]
											],
											c: true
										}
									]
								},
								{
									t: 178,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		parent: 5,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-3.73,
							-29.182,
							0
						],
						to: [
							0,
							-0.312,
							0
						],
						ti: [
							0,
							0.312,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 8,
						s: [
							-3.73,
							-31.057,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 171,
						s: [
							-3.73,
							-31.057,
							0
						],
						to: [
							0,
							0.312,
							0
						],
						ti: [
							0,
							-0.312,
							0
						]
					},
					{
						t: 178,
						s: [
							-3.73,
							-29.182,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-29.182,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-4.414
									],
									[
										4.222,
										0
									],
									[
										0,
										3.781
									],
									[
										-2.332,
										0
									]
								],
								o: [
									[
										0,
										4.414
									],
									[
										-4.222,
										0
									],
									[
										0,
										-3.781
									],
									[
										2.332,
										0
									]
								],
								v: [
									[
										0.492,
										-29.182
									],
									[
										-3.73,
										-24.768
									],
									[
										-7.953,
										-29.182
									],
									[
										-3.73,
										-33.596
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							3.333,
							0
						],
						ti: [
							0,
							4.583,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							146.27,
							151.914,
							0
						],
						to: [
							0,
							-4.583,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 41,
						s: [
							146.27,
							104.414,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 61,
						s: [
							146.27,
							151.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 81,
						s: [
							146.27,
							104.414,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 101,
						s: [
							146.27,
							151.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 121,
						s: [
							146.27,
							104.414,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 141,
						s: [
							146.27,
							151.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							3.333,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 161,
						s: [
							146.27,
							104.414,
							0
						],
						to: [
							0,
							-3.333,
							0
						],
						ti: [
							0,
							-4.583,
							0
						]
					},
					{
						t: 179,
						s: [
							146.27,
							131.914,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 8,
									s: [
										{
											i: [
												[
													-0.965,
													-2.201
												],
												[
													6.062,
													0
												],
												[
													-0.381,
													1.063
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.513,
													1.17
												],
												[
													-6.062,
													0
												],
												[
													0.957,
													-2.669
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.543,
													-22.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.706,
													-24.954
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 171,
									s: [
										{
											i: [
												[
													-0.965,
													-2.201
												],
												[
													6.062,
													0
												],
												[
													-0.381,
													1.063
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0.513,
													1.17
												],
												[
													-6.062,
													0
												],
												[
													0.957,
													-2.669
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.543,
													-22.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.706,
													-24.954
												]
											],
											c: true
										}
									]
								},
								{
									t: 178,
									s: [
										{
											i: [
												[
													0,
													-2.914
												],
												[
													6.062,
													0
												],
												[
													0,
													3.88
												],
												[
													-5.486,
													-0.143
												]
											],
											o: [
												[
													0,
													3.547
												],
												[
													-6.062,
													0
												],
												[
													0,
													-3.49
												],
												[
													5.491,
													0.143
												]
											],
											v: [
												[
													5.371,
													-26.369
												],
												[
													-3.73,
													-18.845
												],
												[
													-12.832,
													-26.369
												],
												[
													-3.738,
													-27.173
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "glasses",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							4.167,
							0
						],
						ti: [
							0,
							3.75,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							146.238,
							115.321,
							0
						],
						to: [
							0,
							-3.75,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							146.238,
							67.821,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							146.238,
							115.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							146.238,
							67.821,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							146.238,
							115.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							146.238,
							67.821,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							146.238,
							115.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							4.167,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							146.238,
							67.821,
							0
						],
						to: [
							0,
							-4.167,
							0
						],
						ti: [
							0,
							-3.75,
							0
						]
					},
					{
						t: 179,
						s: [
							146.238,
							90.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.762,
					-59.679,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-4.863,
												-70.116
											],
											[
												28.515,
												-94.778
											],
											[
												59.29,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												58.061,
												-55.581
											],
											[
												28.749,
												-30.191
											],
											[
												-0.228,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												15.683,
												0
											],
											[
												6.09,
												10.301
											]
										],
										o: [
											[
												-4.425,
												14.288
											],
											[
												-12.794,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												61.894,
												-49.242
											],
											[
												28.515,
												-24.58
											],
											[
												-1.558,
												-41.786
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-11.621,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												4.843,
												-9.71
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												2.228,
												-72.785
											],
											[
												28.749,
												-89.167
											],
											[
												55.667,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-69.418,
												-70.116
											],
											[
												-36.039,
												-94.778
											],
											[
												-5.264,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.493,
												-55.581
											],
											[
												-35.806,
												-30.191
											],
											[
												-64.783,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												12.252,
												0
											],
											[
												4.903,
												13.433
											]
										],
										o: [
											[
												-6.24,
												9.582
											],
											[
												-15.075,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.768,
												-40.494
											],
											[
												-36.039,
												-24.58
											],
											[
												-68.864,
												-47.598
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-14.302,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												2.76,
												-13.437
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-64.801,
												-65.622
											],
											[
												-35.806,
												-89.167
											],
											[
												-8.888,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-68.167,
										-59.679
									],
									[
										-35.939,
										-27.452
									],
									[
										-3.712,
										-59.679
									],
									[
										-35.939,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-3.712,
										-59.679
									],
									[
										28.515,
										-27.452
									],
									[
										60.743,
										-59.679
									],
									[
										28.515,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye white right",
		parent: 8,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 1,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 21,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 41,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 61,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 81,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 101,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 121,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 141,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 161,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 180,
						s: [
							9.853,
							-55.929,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.853,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										11.103,
										-55.929
									],
									[
										9.853,
										-54.679
									],
									[
										8.603,
										-55.929
									],
									[
										9.853,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 1,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							4.167,
							0
						],
						ti: [
							0,
							3.75,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 21,
						s: [
							161.103,
							120.321,
							0
						],
						to: [
							0,
							-3.75,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 41,
						s: [
							161.103,
							72.821,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 61,
						s: [
							161.103,
							120.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 81,
						s: [
							161.103,
							72.821,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 101,
						s: [
							161.103,
							120.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 121,
						s: [
							161.103,
							72.821,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 141,
						s: [
							161.103,
							120.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							4.167,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 161,
						s: [
							161.103,
							72.821,
							0
						],
						to: [
							0,
							-4.167,
							0
						],
						ti: [
							0,
							-3.75,
							0
						]
					},
					{
						t: 180,
						s: [
							161.103,
							95.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.103,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 21,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 24,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 27,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 33,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 36,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 39,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 98,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 101,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 104,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 141,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 144,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 147,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 4,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 11,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													10.915,
													-54.116
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 169,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													10.915,
													-54.116
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									t: 176,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye white left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 1,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 21,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 41,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 61,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 81,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 101,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 121,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 141,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 161,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 180,
						s: [
							-19.813,
							-55.929,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.813,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-18.563,
										-55.929
									],
									[
										-19.813,
										-54.679
									],
									[
										-21.063,
										-55.929
									],
									[
										-19.813,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 1,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							4.167,
							0
						],
						ti: [
							0,
							3.75,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 21,
						s: [
							131.437,
							120.321,
							0
						],
						to: [
							0,
							-3.75,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 41,
						s: [
							131.437,
							72.821,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 61,
						s: [
							131.437,
							120.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 81,
						s: [
							131.437,
							72.821,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 101,
						s: [
							131.437,
							120.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 121,
						s: [
							131.437,
							72.821,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 141,
						s: [
							131.437,
							120.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							4.167,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 161,
						s: [
							131.437,
							72.821,
							0
						],
						to: [
							0,
							-4.167,
							0
						],
						ti: [
							0,
							-3.75,
							0
						]
					},
					{
						t: 180,
						s: [
							131.437,
							95.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-18.563,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 21,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 24,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 27,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 33,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 36,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 39,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 98,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 101,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 104,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 141,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 144,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 147,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 4,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 11,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.313,
													-54.429
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 169,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.313,
													-54.429
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									t: 176,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							0.75,
							0
						],
						ti: [
							0,
							0.708,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							146.27,
							142.392,
							0
						],
						to: [
							0,
							-0.708,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							146.27,
							133.642,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							146.27,
							142.392,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							146.27,
							133.642,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							146.27,
							142.392,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							146.27,
							133.642,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							146.27,
							142.392,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.75,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							146.27,
							133.642,
							0
						],
						to: [
							0,
							-0.75,
							0
						],
						ti: [
							0,
							-0.708,
							0
						]
					},
					{
						t: 179,
						s: [
							146.27,
							137.892,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-12.108,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									]
								],
								v: [
									[
										-3.73,
										-119.688
									],
									[
										-3.73,
										-119.688
									],
									[
										-58.637,
										-64.782
									],
									[
										-58.637,
										17.312
									],
									[
										-58.637,
										40.567
									],
									[
										-3.73,
										95.473
									],
									[
										-3.73,
										95.473
									],
									[
										51.176,
										40.567
									],
									[
										51.176,
										17.312
									],
									[
										51.176,
										-64.782
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									1,
									0.941,
									0.392,
									0.25,
									0.99,
									0.902,
									0.196,
									0.5,
									0.98,
									0.863,
									0,
									0.75,
									0.951,
									0.824,
									0,
									1,
									0.922,
									0.784,
									0
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-59,
								-13
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								50.813,
								-13
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					161.742,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.742,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										11.742,
										119.688
									],
									[
										11.742,
										31.279
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.797,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.203,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-19.203,
										119.688
									],
									[
										-19.203,
										31.279
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "arm left",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 21,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0.689,
													-44.155
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-75.689,
													54.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 41,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 61,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0.689,
													-44.155
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-75.689,
													54.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 81,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 101,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0.689,
													-44.155
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-75.689,
													54.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 121,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 141,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0.689,
													-44.155
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-75.689,
													54.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 161,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "arm right",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 3,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 23,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.689,
													-33.752
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													69.189,
													48.297
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 43,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 64,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.689,
													-33.752
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													69.189,
													48.297
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 83,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 104,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.689,
													-33.752
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													69.189,
													48.297
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 123,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 143,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.689,
													-33.752
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													69.189,
													48.297
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 163,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					146,
					276,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$8 = [
];
var AlfredCorrect = {
	v: v$8,
	fr: fr$8,
	ip: ip$8,
	op: op$8,
	w: w$8,
	h: h$8,
	nm: nm$8,
	ddd: ddd$8,
	assets: assets$8,
	layers: layers$8,
	markers: markers$8
};

var v$7 = "5.6.9";
var fr$7 = 60;
var ip$7 = 0;
var op$7 = 180;
var w$7 = 300;
var h$7 = 300;
var nm$7 = "yellow_Wave";
var ddd$7 = 0;
var assets$7 = [
];
var layers$7 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-2.914
									],
									[
										6.062,
										0
									],
									[
										0,
										3.88
									],
									[
										-5.486,
										-0.143
									]
								],
								o: [
									[
										0,
										3.547
									],
									[
										-6.062,
										0
									],
									[
										0,
										-3.49
									],
									[
										5.491,
										0.143
									]
								],
								v: [
									[
										5.371,
										-26.369
									],
									[
										-3.73,
										-18.845
									],
									[
										-12.832,
										-26.369
									],
									[
										-3.738,
										-27.173
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		parent: 5,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-20.018,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-20.018,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-1.828,
										2.315
									],
									[
										3.634,
										0
									],
									[
										1.828,
										-2.315
									],
									[
										-3.634,
										0
									]
								],
								o: [
									[
										-1.828,
										-2.315
									],
									[
										-3.634,
										0
									],
									[
										1.828,
										2.315
									],
									[
										3.634,
										0
									]
								],
								v: [
									[
										4.918,
										-20.018
									],
									[
										-3.73,
										-23.871
									],
									[
										-12.379,
										-20.018
									],
									[
										-3.73,
										-16.166
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.909803926945,
								0.090196080506,
								0.301960796118,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-2.914
									],
									[
										6.062,
										0
									],
									[
										0,
										3.88
									],
									[
										-5.486,
										-0.143
									]
								],
								o: [
									[
										0,
										3.547
									],
									[
										-6.062,
										0
									],
									[
										0,
										-3.49
									],
									[
										5.491,
										0.143
									]
								],
								v: [
									[
										5.371,
										-26.369
									],
									[
										-3.73,
										-18.845
									],
									[
										-12.832,
										-26.369
									],
									[
										-3.738,
										-27.173
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		parent: 5,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-3.73,
					-29.182,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-29.182,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-4.414
									],
									[
										4.222,
										0
									],
									[
										0,
										3.781
									],
									[
										-2.332,
										0
									]
								],
								o: [
									[
										0,
										4.414
									],
									[
										-4.222,
										0
									],
									[
										0,
										-3.781
									],
									[
										2.332,
										0
									]
								],
								v: [
									[
										0.492,
										-29.182
									],
									[
										-3.73,
										-24.768
									],
									[
										-7.953,
										-29.182
									],
									[
										-3.73,
										-33.596
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 15,
						s: [
							146.27,
							129.414,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 45,
						s: [
							146.27,
							129.414,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 75,
						s: [
							146.27,
							129.414,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 105,
						s: [
							146.27,
							129.414,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 135,
						s: [
							146.27,
							129.414,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 150,
						s: [
							146.27,
							131.914,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 165,
						s: [
							146.27,
							129.414,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						t: 179,
						s: [
							146.27,
							131.914,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-22.586,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-2.914
									],
									[
										6.062,
										0
									],
									[
										0,
										3.88
									],
									[
										-5.486,
										-0.143
									]
								],
								o: [
									[
										0,
										3.547
									],
									[
										-6.062,
										0
									],
									[
										0,
										-3.49
									],
									[
										5.491,
										0.143
									]
								],
								v: [
									[
										5.371,
										-26.369
									],
									[
										-3.73,
										-18.845
									],
									[
										-12.832,
										-26.369
									],
									[
										-3.738,
										-27.173
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "glasses",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 2,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							-0.375,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							146.238,
							88.071,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 32,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 47,
						s: [
							146.238,
							88.071,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 62,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 77,
						s: [
							146.238,
							88.071,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 92,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 107,
						s: [
							146.238,
							88.071,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 122,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 137,
						s: [
							146.238,
							88.071,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 152,
						s: [
							146.238,
							90.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 167,
						s: [
							146.238,
							88.071,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.375,
							0
						]
					},
					{
						t: 179,
						s: [
							146.238,
							90.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.762,
					-59.679,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-4.863,
												-70.116
											],
											[
												28.515,
												-94.778
											],
											[
												59.29,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												58.061,
												-55.581
											],
											[
												28.749,
												-30.191
											],
											[
												-0.228,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												15.683,
												0
											],
											[
												6.09,
												10.301
											]
										],
										o: [
											[
												-4.425,
												14.288
											],
											[
												-12.794,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												61.894,
												-49.242
											],
											[
												28.515,
												-24.58
											],
											[
												-1.558,
												-41.786
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-11.621,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												4.843,
												-9.71
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												2.228,
												-72.785
											],
											[
												28.749,
												-89.167
											],
											[
												55.667,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-15.683,
												0
											],
											[
												-5.905,
												-10.985
											]
										],
										o: [
											[
												4.425,
												-14.288
											],
											[
												13.303,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-69.418,
												-70.116
											],
											[
												-36.039,
												-94.778
											],
											[
												-5.264,
												-76.328
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												14.95,
												0
											],
											[
												2.794,
												13.393
											]
										],
										o: [
											[
												-2.002,
												14.346
											],
											[
												-14.271,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.493,
												-55.581
											],
											[
												-35.806,
												-30.191
											],
											[
												-64.783,
												-53.648
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 50,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "highlight left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												12.252,
												0
											],
											[
												4.903,
												13.433
											]
										],
										o: [
											[
												-6.24,
												9.582
											],
											[
												-15.075,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.768,
												-40.494
											],
											[
												-36.039,
												-24.58
											],
											[
												-68.864,
												-47.598
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-14.302,
												0
											],
											[
												-4.674,
												-10.158
											]
										],
										o: [
											[
												2.76,
												-13.437
											],
											[
												11.949,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-64.801,
												-65.622
											],
											[
												-35.806,
												-89.167
											],
											[
												-8.888,
												-71.954
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0.285,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 20,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "shadow left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-68.167,
										-59.679
									],
									[
										-35.939,
										-27.452
									],
									[
										-3.712,
										-59.679
									],
									[
										-35.939,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame left",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									],
									[
										0,
										17.799
									],
									[
										17.799,
										0
									]
								],
								o: [
									[
										0,
										17.799
									],
									[
										17.799,
										0
									],
									[
										0,
										-17.799
									],
									[
										-17.799,
										0
									]
								],
								v: [
									[
										-3.712,
										-59.679
									],
									[
										28.515,
										-27.452
									],
									[
										60.743,
										-59.679
									],
									[
										28.515,
										-91.906
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.86274510622,
								0.290196090937,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 6.179,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "frame right",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye white right",
		parent: 8,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 0,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 15,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 30,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 45,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 60,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 75,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 90,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 105,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 120,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 135,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 150,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 165,
						s: [
							9.853,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 179,
						s: [
							9.853,
							-55.929,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.853,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										11.103,
										-55.929
									],
									[
										9.853,
										-54.679
									],
									[
										8.603,
										-55.929
									],
									[
										9.853,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							-0.625,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 15,
						s: [
							161.103,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 45,
						s: [
							161.103,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 75,
						s: [
							161.103,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 105,
						s: [
							161.103,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 135,
						s: [
							161.103,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 150,
						s: [
							161.103,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 165,
						s: [
							161.103,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.625,
							0
						]
					},
					{
						t: 179,
						s: [
							161.103,
							95.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.103,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 30,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 33,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 36,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 75,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 78,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 81,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 135,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 138,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 141,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 15,
									s: [
										{
											i: [
												[
													0.015,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0.054,
													1.148
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.009,
													1.148
												],
												[
													-1.933,
													0
												],
												[
													-0.09,
													-1.931
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													10.884,
													-54.929
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 165,
									s: [
										{
											i: [
												[
													0.015,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0.054,
													1.148
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.009,
													1.148
												],
												[
													-1.933,
													0
												],
												[
													-0.09,
													-1.931
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													10.884,
													-54.929
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													14.603,
													-54.679
												],
												[
													11.103,
													-51.179
												],
												[
													7.603,
													-54.679
												],
												[
													11.103,
													-58.179
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye white left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 0,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 15,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 30,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 45,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 60,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 75,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 90,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 105,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 120,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 135,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 150,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 165,
						s: [
							-19.813,
							-55.929,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 179,
						s: [
							-19.813,
							-55.929,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.813,
					-55.929,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-18.563,
										-55.929
									],
									[
										-19.813,
										-54.679
									],
									[
										-21.063,
										-55.929
									],
									[
										-19.813,
										-57.179
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 65,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							-0.625,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 15,
						s: [
							131.437,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 45,
						s: [
							131.437,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 75,
						s: [
							131.437,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 105,
						s: [
							131.437,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 135,
						s: [
							131.437,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 150,
						s: [
							131.437,
							95.321,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 165,
						s: [
							131.437,
							91.571,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.625,
							0
						]
					},
					{
						t: 179,
						s: [
							131.437,
							95.321,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-18.563,
					-54.679,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 30,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 33,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 36,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 75,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 78,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 81,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 135,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 138,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 141,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 15,
									s: [
										{
											i: [
												[
													-0.05,
													-1.932
												],
												[
													1.933,
													0
												],
												[
													-0.062,
													1.304
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0.032,
													1.241
												],
												[
													-1.933,
													0
												],
												[
													0.091,
													-1.931
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.657,
													-54.866
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 165,
									s: [
										{
											i: [
												[
													-0.05,
													-1.932
												],
												[
													1.933,
													0
												],
												[
													-0.062,
													1.304
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0.032,
													1.241
												],
												[
													-1.933,
													0
												],
												[
													0.091,
													-1.931
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.657,
													-54.866
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-15.063,
													-54.679
												],
												[
													-18.563,
													-51.179
												],
												[
													-22.063,
													-54.679
												],
												[
													-18.563,
													-58.179
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							146.27,
							135.392,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 32,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 47,
						s: [
							146.27,
							135.392,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 62,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 77,
						s: [
							146.27,
							135.392,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 92,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 107,
						s: [
							146.27,
							135.392,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 122,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 137,
						s: [
							146.27,
							135.392,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 152,
						s: [
							146.27,
							137.892,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 167,
						s: [
							146.27,
							135.392,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						t: 179,
						s: [
							146.27,
							137.892,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-3.73,
					-12.108,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										30.324
									],
									[
										0,
										0
									],
									[
										30.324,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-30.324
									]
								],
								v: [
									[
										-3.73,
										-119.688
									],
									[
										-3.73,
										-119.688
									],
									[
										-58.637,
										-64.782
									],
									[
										-58.637,
										17.312
									],
									[
										-58.637,
										40.567
									],
									[
										-3.73,
										95.473
									],
									[
										-3.73,
										95.473
									],
									[
										51.176,
										40.567
									],
									[
										51.176,
										17.312
									],
									[
										51.176,
										-64.782
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									1,
									0.941,
									0.392,
									0.25,
									0.99,
									0.902,
									0.196,
									0.5,
									0.98,
									0.863,
									0,
									0.75,
									0.951,
									0.824,
									0,
									1,
									0.922,
									0.784,
									0
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-59,
								-13
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								50.813,
								-13
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					161.742,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.742,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										11.742,
										119.688
									],
									[
										11.742,
										31.279
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.797,
					225.484,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-19.203,
					75.484,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-19.203,
										119.688
									],
									[
										-19.203,
										31.279
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "arm left",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-61.924,
					-3.577,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 2,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 17,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.811,
													-65.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-69.189,
													46.7
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 32,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.189,
													-59.7
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-72.689,
													45.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 47,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.811,
													-65.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-69.189,
													46.7
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 62,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.189,
													-59.7
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-72.689,
													45.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 77,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.811,
													-65.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-69.189,
													46.7
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 92,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.189,
													-59.7
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-72.689,
													45.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 107,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.811,
													-65.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-69.189,
													46.7
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 122,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.189,
													-59.7
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-72.689,
													45.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.811,
													-65.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-69.189,
													46.7
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 152,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.189,
													-59.7
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-72.689,
													45.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 167,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.811,
													-65.2
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-69.189,
													46.7
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													22.613,
													-38.284
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-31.659,
													-44.354
												],
												[
													-92.189,
													37.2
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "arm right",
		parent: 11,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					58.486,
					-6.778,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 15,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.189,
													48.203
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													82.689,
													-90.203
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 26,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-29.189,
													36.703
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													95.189,
													-67.703
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 37.316,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.189,
													48.203
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													82.689,
													-90.203
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 48.477,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-29.189,
													36.703
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													95.189,
													-67.703
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 59.635,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.189,
													48.203
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													82.689,
													-90.203
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 70.793,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-29.189,
													36.703
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													95.189,
													-67.703
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 81.951,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.189,
													48.203
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													82.689,
													-90.203
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 93.109,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-29.189,
													36.703
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													95.189,
													-67.703
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 104.268,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.189,
													48.203
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													82.689,
													-90.203
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 115.428,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-29.189,
													36.703
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													95.189,
													-67.703
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 126.586,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.189,
													48.203
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													82.689,
													-90.203
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-29.189,
													36.703
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													95.189,
													-67.703
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 147,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.189,
													48.203
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													82.689,
													-90.203
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 157,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-29.189,
													36.703
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													95.189,
													-67.703
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 166,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.189,
													48.203
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													82.689,
													-90.203
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-23.46,
													-29.584
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													24.782,
													-44.354
												],
												[
													92.189,
													30.797
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								0.882352948189,
								0.392156869173,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					146,
					276,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-1,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					64,
					80,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								157.172,
								29.086
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-1,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$7 = [
];
var AlfredWave = {
	v: v$7,
	fr: fr$7,
	ip: ip$7,
	op: op$7,
	w: w$7,
	h: h$7,
	nm: nm$7,
	ddd: ddd$7,
	assets: assets$7,
	layers: layers$7,
	markers: markers$7
};

var v$6 = "5.5.10";
var fr$6 = 60;
var ip$6 = 0;
var op$6 = 420;
var w$6 = 300;
var h$6 = 300;
var nm$6 = "red_Bored";
var ddd$6 = 0;
var assets$6 = [
];
var layers$6 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 35.686,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 115.326,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 121.684,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 200.65,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 206.342,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 285.977,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 291.666,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 382,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									t: 411,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		parent: 5,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							7.737,
							-39.564,
							0
						],
						to: [
							0,
							-1.875,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 30,
						s: [
							7.737,
							-50.814,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-1.875,
							0
						]
					},
					{
						t: 411,
						s: [
							7.737,
							-39.564,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					7.737,
					-39.564,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-5.208,
										2.332
									],
									[
										6.438,
										0
									],
									[
										3.239,
										-2.707
									],
									[
										-6.439,
										0
									]
								],
								o: [
									[
										-3.239,
										-2.707
									],
									[
										-6.439,
										0
									],
									[
										3.239,
										2.707
									],
									[
										6.438,
										0
									]
								],
								v: [
									[
										25.561,
										-29.699
									],
									[
										10.239,
										-34.205
									],
									[
										-5.083,
										-29.699
									],
									[
										10.822,
										-28.242
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.282352954149,
								0.486274510622,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										0,
										0
									],
									to: [
										0,
										2.5
									],
									ti: [
										0,
										-2.5
									]
								},
								{
									i: {
										x: 0.5,
										y: 0.5
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 30,
									s: [
										0,
										15
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 36.111,
									s: [
										0,
										15
									],
									to: [
										0,
										0.208
									],
									ti: [
										0,
										-0.208
									]
								},
								{
									i: {
										x: 0.5,
										y: 0.5
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 115.572,
									s: [
										0,
										16.25
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 121.684,
									s: [
										0,
										16.25
									],
									to: [
										0,
										-0.208
									],
									ti: [
										0,
										0.208
									]
								},
								{
									i: {
										x: 0.5,
										y: 0.5
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 201.145,
									s: [
										0,
										15
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 207.256,
									s: [
										0,
										15
									],
									to: [
										0,
										0.208
									],
									ti: [
										0,
										-0.208
									]
								},
								{
									i: {
										x: 0.5,
										y: 0.5
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 286.717,
									s: [
										0,
										16.25
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 290.791,
									s: [
										0,
										16.25
									],
									to: [
										0,
										-0.208
									],
									ti: [
										0,
										2.708
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 382.982,
									s: [
										0,
										15
									],
									to: [
										0,
										-2.708
									],
									ti: [
										0,
										2.5
									]
								},
								{
									t: 411,
									s: [
										0,
										0
									]
								}
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 5,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 35.686,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 115.326,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 121.684,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 200.65,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 206.342,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 285.977,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 291.666,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 382,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									t: 411,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		parent: 5,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							7.737,
							-39.564,
							0
						],
						to: [
							0,
							-1.875,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 30,
						s: [
							7.737,
							-50.814,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-1.875,
							0
						]
					},
					{
						t: 411,
						s: [
							7.737,
							-39.564,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					7.737,
					-39.564,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-4.332,
										-0.363
									],
									[
										0,
										0
									],
									[
										0.821,
										-0.091
									],
									[
										4.07,
										-0.147
									],
									[
										0.046,
										1.59
									],
									[
										0.138,
										2.302
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.03,
										1.544
									],
									[
										-3.464,
										0.384
									],
									[
										-0.848,
										0.031
									],
									[
										-0.093,
										-3.219
									],
									[
										5.41,
										-0.07
									]
								],
								v: [
									[
										5.301,
										-50.708
									],
									[
										4.662,
										-43.788
									],
									[
										3.253,
										-40.861
									],
									[
										-8.122,
										-40.05
									],
									[
										-9.738,
										-42.884
									],
									[
										-10.088,
										-51.159
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										0,
										0
									],
									to: [
										0,
										1.042
									],
									ti: [
										0,
										-1.042
									]
								},
								{
									i: {
										x: 0.5,
										y: 0.5
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 30,
									s: [
										0,
										6.25
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.5,
										y: 0.5
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 36.111,
									s: [
										0,
										6.25
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.5,
										y: 0.5
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 115.572,
									s: [
										0,
										6.25
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.58,
										y: 0.851
									},
									o: {
										x: 0.246,
										y: 0
									},
									t: 121.684,
									s: [
										0,
										6.25
									],
									to: [
										0,
										-0.339
									],
									ti: [
										0,
										0.784
									]
								},
								{
									i: {
										x: 0.58,
										y: 0.947
									},
									o: {
										x: 0.242,
										y: 0.03
									},
									t: 201.145,
									s: [
										0,
										-0.541
									],
									to: [
										0,
										-1.629
									],
									ti: [
										0,
										0.784
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.242,
										y: 0.081
									},
									t: 207.256,
									s: [
										0,
										-0.541
									],
									to: [
										0,
										-1.629
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.246,
										y: 0
									},
									t: 286.717,
									s: [
										0,
										6.25
									],
									to: [
										0,
										-0.339
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.58,
										y: 0.889
									},
									o: {
										x: 0.246,
										y: 0
									},
									t: 290.791,
									s: [
										0,
										6.25
									],
									to: [
										0,
										-0.339
									],
									ti: [
										0,
										0.784
									]
								},
								{
									i: {
										x: 0.575,
										y: 1
									},
									o: {
										x: 0.242,
										y: 0.042
									},
									t: 382.982,
									s: [
										0,
										-4.291
									],
									to: [
										0,
										-1.629
									],
									ti: [
										0,
										0.703
									]
								},
								{
									t: 411,
									s: [
										0,
										0
									]
								}
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							-2.083,
							0
						],
						ti: [
							0,
							2.083,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 0.22
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 30,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.22,
							y: 1
						},
						o: {
							x: 0.78,
							y: 0
						},
						t: 35.686,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							-0.833,
							0
						]
					},
					{
						i: {
							x: 0.1,
							y: 0.1
						},
						o: {
							x: 0.78,
							y: 0.78
						},
						t: 115.326,
						s: [
							153.822,
							111.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.1,
							y: 1
						},
						o: {
							x: 0.1,
							y: 0
						},
						t: 121.016,
						s: [
							153.822,
							111.716,
							0
						],
						to: [
							0,
							-0.833,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.1,
							y: 0.1
						},
						t: 200.65,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 206.342,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							-0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 285.977,
						s: [
							153.822,
							111.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 291.666,
						s: [
							153.822,
							111.716,
							0
						],
						to: [
							0,
							-0.833,
							0
						],
						ti: [
							0,
							-1.25,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 382,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							1.25,
							0
						],
						ti: [
							0,
							-2.083,
							0
						]
					},
					{
						t: 411,
						s: [
							153.822,
							119.216,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 35.686,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 115.326,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 121.016,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 200.65,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 206.342,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 285.977,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 291.666,
									s: [
										{
											i: [
												[
													-0.092,
													-1.758
												],
												[
													4.554,
													0.095
												],
												[
													-0.085,
													2.09
												],
												[
													-2.229,
													-0.097
												]
											],
											o: [
												[
													0.065,
													1.242
												],
												[
													-4.854,
													-0.102
												],
												[
													0.072,
													-1.758
												],
												[
													1.77,
													0.077
												]
											],
											v: [
												[
													16.185,
													-36.492
												],
												[
													11.697,
													-31.492
												],
												[
													6.085,
													-36.648
												],
												[
													11.479,
													-40.34
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 382,
									s: [
										{
											i: [
												[
													0.111,
													-5.005
												],
												[
													12.678,
													0.009
												],
												[
													0,
													6.669
												],
												[
													-10.074,
													0.068
												]
											],
											o: [
												[
													-0.06,
													2.711
												],
												[
													-11.322,
													-0.008
												],
												[
													0,
													-6.002
												],
												[
													9.678,
													-0.066
												]
											],
											v: [
												[
													25.06,
													-42.211
												],
												[
													10.822,
													-28.242
												],
												[
													-4.665,
													-42.086
												],
												[
													11.197,
													-53.559
												]
											],
											c: true
										}
									]
								},
								{
									t: 411,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eye white right",
		parent: 7,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					28.025,
					-68.44,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					28.025,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										29.275,
										-68.44
									],
									[
										28.025,
										-67.19
									],
									[
										26.775,
										-68.44
									],
									[
										28.025,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							-2.083,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							172.275,
							77.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-2.083,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 115.326,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 121.016,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							-2.083,
							0
						],
						ti: [
							0,
							2.083,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 200.65,
						s: [
							172.275,
							77.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 206.342,
						s: [
							172.275,
							77.31,
							0
						],
						to: [
							0,
							2.083,
							0
						],
						ti: [
							0,
							-2.083,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 285.977,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 291.666,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							-2.083,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 382,
						s: [
							172.275,
							77.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-2.083,
							0
						]
					},
					{
						t: 411,
						s: [
							172.275,
							89.81,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					29.275,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 10,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 384.514,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 400.8125,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										32.775,
										-67.19
									],
									[
										29.275,
										-63.69
									],
									[
										25.775,
										-67.19
									],
									[
										29.275,
										-70.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye white left",
		parent: 9,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-9.679,
					-68.44,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-9.679,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-8.429,
										-68.44
									],
									[
										-9.679,
										-67.19
									],
									[
										-10.929,
										-68.44
									],
									[
										-9.679,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							-2.083,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							134.571,
							77.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-2.083,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 115.326,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 121.016,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							-2.083,
							0
						],
						ti: [
							0,
							2.083,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 200.65,
						s: [
							134.571,
							77.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 206.342,
						s: [
							134.571,
							77.31,
							0
						],
						to: [
							0,
							2.083,
							0
						],
						ti: [
							0,
							-2.083,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 285.977,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 291.666,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							-2.083,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 382,
						s: [
							134.571,
							77.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-2.083,
							0
						]
					},
					{
						t: 411,
						s: [
							134.571,
							89.81,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-8.429,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 10,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 384.514,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 400.8125,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										-4.929,
										-67.19
									],
									[
										-8.429,
										-63.69
									],
									[
										-11.929,
										-67.19
									],
									[
										-8.429,
										-70.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "hair",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					164.898,
					36.169,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					21.898,
					-120.831,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-7.696,
													1.221
												]
											],
											o: [
												[
													0.041,
													-9.184
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.584,
													-102.816
												],
												[
													25.284,
													-112.274
												],
												[
													18.917,
													-106.628
												],
												[
													24.946,
													-121.721
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 115.572,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 201.145,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-7.696,
													1.221
												]
											],
											o: [
												[
													0.041,
													-9.184
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.584,
													-102.816
												],
												[
													25.284,
													-112.274
												],
												[
													18.917,
													-106.628
												],
												[
													24.946,
													-121.721
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 286.717,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 382.982,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-7.696,
													1.221
												]
											],
											o: [
												[
													0.041,
													-9.184
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.584,
													-102.816
												],
												[
													25.284,
													-112.274
												],
												[
													18.917,
													-106.628
												],
												[
													24.946,
													-121.721
												]
											],
											c: false
										}
									]
								},
								{
									t: 411,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.929411768913,
								0.207843139768,
								0.329411774874,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 5.161,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					122.5,
					252.873,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-20.5,
					95.873,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-29.326,
										0
									]
								],
								o: [
									[
										-33.45,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-11.86,
										108.443
									],
									[
										-45.683,
										83.303
									],
									[
										-5.04,
										90.443
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										4.683,
										99.443
									],
									[
										-12.629,
										99.443
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 3,
		nm: "ARMS LILLE",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						},
						t: 0,
						s: [
							150,
							150,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						},
						t: 30,
						s: [
							150,
							152.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						},
						t: 115.572,
						s: [
							150,
							150,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						},
						t: 201.145,
						s: [
							150,
							152.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						},
						t: 286.717,
						s: [
							150,
							150,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						},
						t: 382.982,
						s: [
							150,
							152.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 411,
						s: [
							150,
							150,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		ip: 0,
		op: 480,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "arm left",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-62.279,
					28.958,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-55.279,
					21.958,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-3.506,
										-33.504
									]
								],
								o: [
									[
										-23.155,
										23.474
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-39.034,
										-19.403
									],
									[
										-70.931,
										63.32
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "buddy_mouth",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-40.435,
					35.817,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-33.435,
					28.817,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-1.364,
													1.995
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													1.364,
													1.995
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-36.271,
													28.069
												],
												[
													-36.271,
													28.069
												],
												[
													-30.6,
													28.069
												],
												[
													-30.6,
													28.069
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 10,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-1.556,
													-0.017
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													1.552,
													0.015
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-36.271,
													28.069
												],
												[
													-36.271,
													28.069
												],
												[
													-30.6,
													28.069
												],
												[
													-30.6,
													28.069
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 382.982,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-1.556,
													-0.017
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													1.552,
													0.015
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-36.271,
													28.069
												],
												[
													-36.271,
													28.069
												],
												[
													-30.6,
													28.069
												],
												[
													-30.6,
													28.069
												]
											],
											c: false
										}
									]
								},
								{
									t: 411,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-1.364,
													1.995
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													1.364,
													1.995
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-36.271,
													28.069
												],
												[
													-36.271,
													28.069
												],
												[
													-30.6,
													28.069
												],
												[
													-30.6,
													28.069
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 2,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "buddy_eye_white_right",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-29.842,
							26.597,
							0
						],
						to: [
							0,
							0.938,
							0
						],
						ti: [
							0,
							-0.938,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 10,
						s: [
							-29.842,
							32.222,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 382.982,
						s: [
							-29.842,
							32.222,
							0
						],
						to: [
							0,
							-0.938,
							0
						],
						ti: [
							0,
							0.938,
							0
						]
					},
					{
						t: 411,
						s: [
							-29.842,
							26.597,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.842,
					19.597,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-22.036,
										19.597
									],
									[
										-22.842,
										20.403
									],
									[
										-23.648,
										19.597
									],
									[
										-22.842,
										18.791
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "buddy_eye_right",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-29.331,
							27.715,
							0
						],
						to: [
							0,
							0.625,
							0
						],
						ti: [
							0,
							-0.625,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 10,
						s: [
							-29.331,
							31.465,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 382.982,
						s: [
							-29.331,
							31.465,
							0
						],
						to: [
							0,
							-0.625,
							0
						],
						ti: [
							0,
							0.625,
							0
						]
					},
					{
						t: 411,
						s: [
							-29.331,
							27.715,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.331,
					20.715,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 133.908,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 148.172,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 162.434,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 305.053,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 319.316,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 333.578125,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.203
												],
												[
													1.203,
													0
												],
												[
													0,
													1.203
												],
												[
													-1.203,
													0
												]
											],
											o: [
												[
													0,
													1.203
												],
												[
													-1.203,
													0
												],
												[
													0,
													-1.203
												],
												[
													1.203,
													0
												]
											],
											v: [
												[
													-20.154,
													20.715
												],
												[
													-22.331,
													22.892
												],
												[
													-24.508,
													20.715
												],
												[
													-22.331,
													18.537
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 10,
									s: [
										{
											i: [
												[
													0.029,
													-0.131
												],
												[
													1.203,
													0
												],
												[
													0.027,
													1.202
												],
												[
													-1.203,
													0
												]
											],
											o: [
												[
													-0.034,
													1.202
												],
												[
													-1.203,
													0
												],
												[
													0.008,
													-0.319
												],
												[
													1.203,
													0
												]
											],
											v: [
												[
													-20.154,
													20.715
												],
												[
													-22.331,
													22.892
												],
												[
													-24.508,
													20.715
												],
												[
													-22.425,
													20.35
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 382.982,
									s: [
										{
											i: [
												[
													0.029,
													-0.131
												],
												[
													1.203,
													0
												],
												[
													0.027,
													1.202
												],
												[
													-1.203,
													0
												]
											],
											o: [
												[
													-0.034,
													1.202
												],
												[
													-1.203,
													0
												],
												[
													0.008,
													-0.319
												],
												[
													1.203,
													0
												]
											],
											v: [
												[
													-20.154,
													20.715
												],
												[
													-22.331,
													22.892
												],
												[
													-24.508,
													20.715
												],
												[
													-22.425,
													20.35
												]
											],
											c: true
										}
									]
								},
								{
									t: 411,
									s: [
										{
											i: [
												[
													0,
													-1.203
												],
												[
													1.203,
													0
												],
												[
													0,
													1.203
												],
												[
													-1.203,
													0
												]
											],
											o: [
												[
													0,
													1.203
												],
												[
													-1.203,
													0
												],
												[
													0,
													-1.203
												],
												[
													1.203,
													0
												]
											],
											v: [
												[
													-20.154,
													20.715
												],
												[
													-22.331,
													22.892
												],
												[
													-24.508,
													20.715
												],
												[
													-22.331,
													18.537
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "buddy_eye_white_left",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-51.876,
							26.838,
							0
						],
						to: [
							0,
							0.964,
							0
						],
						ti: [
							0,
							-0.964,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 10,
						s: [
							-51.876,
							32.619,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 382.982,
						s: [
							-51.876,
							32.619,
							0
						],
						to: [
							0,
							-0.964,
							0
						],
						ti: [
							0,
							0.964,
							0
						]
					},
					{
						t: 411,
						s: [
							-51.876,
							26.838,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.876,
					19.838,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-44.07,
										19.838
									],
									[
										-44.876,
										20.644
									],
									[
										-45.683,
										19.838
									],
									[
										-44.876,
										19.031
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "buddy_eye_left",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-51.295,
							27.955,
							0
						],
						to: [
							0,
							0.625,
							0
						],
						ti: [
							0,
							-0.625,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 10,
						s: [
							-51.295,
							31.705,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 382.982,
						s: [
							-51.295,
							31.705,
							0
						],
						to: [
							0,
							-0.625,
							0
						],
						ti: [
							0,
							0.625,
							0
						]
					},
					{
						t: 411,
						s: [
							-51.295,
							27.955,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.295,
					20.955,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 115.572,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 129.834,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 144.096,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 286.717,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 300.979,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 315.240234375,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.203
												],
												[
													1.203,
													0
												],
												[
													0,
													1.203
												],
												[
													-1.203,
													0
												]
											],
											o: [
												[
													0,
													1.203
												],
												[
													-1.203,
													0
												],
												[
													0,
													-1.203
												],
												[
													1.203,
													0
												]
											],
											v: [
												[
													-42.117,
													20.955
												],
												[
													-44.295,
													23.133
												],
												[
													-46.472,
													20.955
												],
												[
													-44.295,
													18.778
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 10,
									s: [
										{
											i: [
												[
													0,
													-0.185
												],
												[
													1.203,
													0
												],
												[
													0,
													1.203
												],
												[
													-1.203,
													0
												]
											],
											o: [
												[
													-0.009,
													1.202
												],
												[
													-1.203,
													0
												],
												[
													0,
													-0.325
												],
												[
													1.203,
													0
												]
											],
											v: [
												[
													-42.117,
													20.955
												],
												[
													-44.295,
													23.133
												],
												[
													-46.472,
													20.955
												],
												[
													-44.373,
													20.731
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 382.982,
									s: [
										{
											i: [
												[
													0,
													-0.185
												],
												[
													1.203,
													0
												],
												[
													0,
													1.203
												],
												[
													-1.203,
													0
												]
											],
											o: [
												[
													-0.009,
													1.202
												],
												[
													-1.203,
													0
												],
												[
													0,
													-0.325
												],
												[
													1.203,
													0
												]
											],
											v: [
												[
													-42.117,
													20.955
												],
												[
													-44.295,
													23.133
												],
												[
													-46.472,
													20.955
												],
												[
													-44.373,
													20.731
												]
											],
											c: true
										}
									]
								},
								{
									t: 411,
									s: [
										{
											i: [
												[
													0,
													-1.203
												],
												[
													1.203,
													0
												],
												[
													0,
													1.203
												],
												[
													-1.203,
													0
												]
											],
											o: [
												[
													0,
													1.203
												],
												[
													-1.203,
													0
												],
												[
													0,
													-1.203
												],
												[
													1.203,
													0
												]
											],
											v: [
												[
													-42.117,
													20.955
												],
												[
													-44.295,
													23.133
												],
												[
													-46.472,
													20.955
												],
												[
													-44.295,
													18.778
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "buddy_body",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-60.288,
					34.837,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-53.288,
					27.837,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-12.197
									],
									[
										20.285,
										0.119
									],
									[
										-5.507,
										10.883
									],
									[
										-17.595,
										0
									]
								],
								o: [
									[
										0,
										12.197
									],
									[
										-18.842,
										-0.11
									],
									[
										5.321,
										-10.514
									],
									[
										17.595,
										0
									]
								],
								v: [
									[
										-15.83,
										27.227
									],
									[
										-44.793,
										53.293
									],
									[
										-90.118,
										29.051
									],
									[
										-42.259,
										2.38
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.384313732386,
								0.929411768913,
								0.603921592236,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 20,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					152.571,
					154.371,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.571,
					-2.629,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.5,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.5,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-43.725
												],
												[
													-45.204,
													0
												],
												[
													0,
													47.775
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													49.775
												],
												[
													45.204,
													0
												],
												[
													0,
													-27.975
												]
											],
											v: [
												[
													52.844,
													-54.076
												],
												[
													9.642,
													-104.9
												],
												[
													-33.561,
													-54.076
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.5,
										y: 0
									},
									t: 36,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-43.725
												],
												[
													-45.204,
													0
												],
												[
													0,
													47.775
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													49.775
												],
												[
													45.204,
													0
												],
												[
													0,
													-27.975
												]
											],
											v: [
												[
													52.844,
													-54.076
												],
												[
													9.642,
													-104.9
												],
												[
													-33.561,
													-54.076
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.5,
										y: 0
									},
									t: 115.572,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.5,
										y: 0
									},
									t: 121.684,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.5,
										y: 0
									},
									t: 201,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-43.725
												],
												[
													-45.204,
													0
												],
												[
													0,
													47.775
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													49.775
												],
												[
													45.204,
													0
												],
												[
													0,
													-27.975
												]
											],
											v: [
												[
													52.844,
													-54.076
												],
												[
													9.642,
													-104.9
												],
												[
													-33.561,
													-54.076
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.5,
										y: 0
									},
									t: 206,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-43.725
												],
												[
													-45.204,
													0
												],
												[
													0,
													47.775
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													49.775
												],
												[
													45.204,
													0
												],
												[
													0,
													-27.975
												]
											],
											v: [
												[
													52.844,
													-54.076
												],
												[
													9.642,
													-104.9
												],
												[
													-33.561,
													-54.076
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.5,
										y: 0
									},
									t: 286.717,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.5,
										y: 0
									},
									t: 290.791,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.5,
										y: 0
									},
									t: 383,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-43.725
												],
												[
													-45.204,
													0
												],
												[
													0,
													47.775
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													49.775
												],
												[
													45.204,
													0
												],
												[
													0,
													-27.975
												]
											],
											v: [
												[
													52.844,
													-54.076
												],
												[
													9.642,
													-104.9
												],
												[
													-33.561,
													-54.076
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									t: 411,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									0.894,
									0.388,
									0.408,
									0.25,
									0.902,
									0.224,
									0.349,
									0.5,
									0.91,
									0.059,
									0.29,
									0.8,
									0.808,
									0.029,
									0.235,
									1,
									0.706,
									0,
									0.18
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-67.115,
								-3
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								85.212,
								-3
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 21,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					182.463,
					256.443,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					39.463,
					99.443,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										74.243,
										99.443
									],
									[
										4.683,
										99.443
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 22,
		ty: 4,
		nm: "arm right",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					56.856,
					27.575,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					63.856,
					20.575,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-2.758,
										-68.093
									]
								],
								o: [
									[
										20.953,
										25.311
									],
									[
										0,
										0
									]
								],
								v: [
									[
										46.22,
										-23.968
									],
									[
										81.493,
										65.118
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 23,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					158.077,
					264.053,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					12.077,
					110.053,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										7.517
									],
									[
										43.448,
										0
									],
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									]
								],
								o: [
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									],
									[
										0,
										7.517
									],
									[
										43.448,
										0
									]
								],
								v: [
									[
										90.747,
										110.053
									],
									[
										12.077,
										96.443
									],
									[
										-66.593,
										110.053
									],
									[
										12.077,
										123.664
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 420,
		st: 0,
		bm: 0
	}
];
var markers$6 = [
];
var AlvaBored = {
	v: v$6,
	fr: fr$6,
	ip: ip$6,
	op: op$6,
	w: w$6,
	h: h$6,
	nm: nm$6,
	ddd: ddd$6,
	assets: assets$6,
	layers: layers$6,
	markers: markers$6
};

var v$5 = "5.6.9";
var fr$5 = 60;
var ip$5 = 0;
var op$5 = 180;
var w$5 = 300;
var h$5 = 300;
var nm$5 = "red_happy";
var ddd$5 = 0;
var assets$5 = [
];
var layers$5 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "mouth mask",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 2,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							1.25,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 32,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 47,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 62,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 77,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 92,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 107,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 122,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 137,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 152,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 167,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.25,
							0
						]
					},
					{
						t: 179,
						s: [
							153.822,
							119.216,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-5.006
									],
									[
										15.664,
										0
									],
									[
										0,
										6.669
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										0,
										6.097
									],
									[
										-15.664,
										0
									],
									[
										0,
										-6.002
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										39.185,
										-44.961
									],
									[
										10.822,
										-28.242
									],
									[
										-17.54,
										-44.961
									],
									[
										10.822,
										-43.434
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "teeth + tounge",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 1,
						s: [
							150.737,
							117.436,
							0
						],
						to: [
							0,
							1.25,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 16,
						s: [
							150.737,
							124.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 31,
						s: [
							150.737,
							117.436,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 46,
						s: [
							150.737,
							124.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 61,
						s: [
							150.737,
							117.436,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 76,
						s: [
							150.737,
							124.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 91,
						s: [
							150.737,
							117.436,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 106,
						s: [
							150.737,
							124.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 121,
						s: [
							150.737,
							117.436,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 136,
						s: [
							150.737,
							124.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 151,
						s: [
							150.737,
							117.436,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 166,
						s: [
							150.737,
							124.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.25,
							0
						]
					},
					{
						t: 179,
						s: [
							150.737,
							117.436,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					7.737,
					-39.564,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 0,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													25.561,
													-29.699
												],
												[
													10.239,
													-34.205
												],
												[
													-5.083,
													-29.699
												],
												[
													10.822,
													-28.242
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 16,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													25.561,
													-27.824
												],
												[
													10.239,
													-34.205
												],
												[
													-5.083,
													-27.824
												],
												[
													10.822,
													-26.367
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 167,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													25.561,
													-27.824
												],
												[
													10.239,
													-34.205
												],
												[
													-5.083,
													-27.824
												],
												[
													10.822,
													-26.367
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													-5.208,
													2.332
												],
												[
													6.438,
													0
												],
												[
													3.239,
													-2.707
												],
												[
													-6.439,
													0
												]
											],
											o: [
												[
													-3.239,
													-2.707
												],
												[
													-6.439,
													0
												],
												[
													3.239,
													2.707
												],
												[
													6.438,
													0
												]
											],
											v: [
												[
													25.561,
													-29.699
												],
												[
													10.239,
													-34.205
												],
												[
													-5.083,
													-29.699
												],
												[
													10.822,
													-28.242
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.282352954149,
								0.486274510622,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-4.332,
										-0.363
									],
									[
										0,
										0
									],
									[
										0.821,
										-0.091
									],
									[
										4.07,
										-0.147
									],
									[
										0.046,
										1.59
									],
									[
										0.138,
										2.302
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.03,
										1.544
									],
									[
										-3.464,
										0.384
									],
									[
										-0.848,
										0.031
									],
									[
										-0.093,
										-3.219
									],
									[
										5.41,
										-0.07
									]
								],
								v: [
									[
										5.301,
										-50.708
									],
									[
										4.662,
										-43.788
									],
									[
										3.253,
										-40.861
									],
									[
										-8.122,
										-40.05
									],
									[
										-9.738,
										-42.884
									],
									[
										-10.088,
										-51.159
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 2,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							1.25,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 32,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 47,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 62,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 77,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 92,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 107,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 122,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 137,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 152,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 167,
						s: [
							153.822,
							126.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.25,
							0
						]
					},
					{
						t: 179,
						s: [
							153.822,
							119.216,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-5.006
									],
									[
										15.664,
										0
									],
									[
										0,
										6.669
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										0,
										6.097
									],
									[
										-15.664,
										0
									],
									[
										0,
										-6.002
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										39.185,
										-44.961
									],
									[
										10.822,
										-28.242
									],
									[
										-17.54,
										-44.961
									],
									[
										10.822,
										-43.434
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "eye white right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 3,
						s: [
							171.025,
							88.56,
							0
						],
						to: [
							0,
							1.25,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 18,
						s: [
							171.025,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 33,
						s: [
							171.025,
							88.56,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 48,
						s: [
							171.025,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 63,
						s: [
							171.025,
							88.56,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							171.025,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 93,
						s: [
							171.025,
							88.56,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 108,
						s: [
							171.025,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 123,
						s: [
							171.025,
							88.56,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							171.025,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 153,
						s: [
							171.025,
							88.56,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 168,
						s: [
							171.025,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.25,
							0
						]
					},
					{
						t: 179,
						s: [
							171.025,
							88.56,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					28.025,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 12,
						s: [
							50,
							50,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 168,
						s: [
							50,
							50,
							100
						]
					},
					{
						t: 179,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										29.275,
										-68.44
									],
									[
										28.025,
										-67.19
									],
									[
										26.775,
										-68.44
									],
									[
										28.025,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 3,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							1.25,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 18,
						s: [
							172.275,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 33,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 48,
						s: [
							172.275,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 63,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							172.275,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 93,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 108,
						s: [
							172.275,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 123,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							172.275,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 153,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 168,
						s: [
							172.275,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.25,
							0
						]
					},
					{
						t: 179,
						s: [
							172.275,
							89.81,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					29.275,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													0.412,
													-0.685
												],
												[
													1.933,
													0
												],
												[
													0.552,
													1.06
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.78,
													1.769
												],
												[
													-1.933,
													0
												],
												[
													-0.682,
													-1.31
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													32.713,
													-67.252
												],
												[
													29.119,
													-68.065
												],
												[
													25.682,
													-67.034
												],
												[
													29.119,
													-69.627
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 168,
									s: [
										{
											i: [
												[
													0.412,
													-0.685
												],
												[
													1.933,
													0
												],
												[
													0.552,
													1.06
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.78,
													1.769
												],
												[
													-1.933,
													0
												],
												[
													-0.682,
													-1.31
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													32.713,
													-67.252
												],
												[
													29.119,
													-68.065
												],
												[
													25.682,
													-67.034
												],
												[
													29.119,
													-69.627
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eye white left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 3,
						s: [
							133.321,
							88.56,
							0
						],
						to: [
							0,
							1.25,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 18,
						s: [
							133.321,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 33,
						s: [
							133.321,
							88.56,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 48,
						s: [
							133.321,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 63,
						s: [
							133.321,
							88.56,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							133.321,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 93,
						s: [
							133.321,
							88.56,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 108,
						s: [
							133.321,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 123,
						s: [
							133.321,
							88.56,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							133.321,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 153,
						s: [
							133.321,
							88.56,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 168,
						s: [
							133.321,
							96.06,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.25,
							0
						]
					},
					{
						t: 179,
						s: [
							133.321,
							88.56,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-9.679,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 12,
						s: [
							50,
							50,
							100
						]
					},
					{
						i: {
							x: [
								0.5,
								0.5,
								0.5
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.4,
								0.4,
								0.4
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 168,
						s: [
							50,
							50,
							100
						]
					},
					{
						t: 179,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-8.429,
										-68.44
									],
									[
										-9.679,
										-67.19
									],
									[
										-10.929,
										-68.44
									],
									[
										-9.679,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 3,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							1.25,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 18,
						s: [
							134.571,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 33,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 48,
						s: [
							134.571,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 63,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							134.571,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 93,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 108,
						s: [
							134.571,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 123,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							134.571,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 153,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 168,
						s: [
							134.571,
							97.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.25,
							0
						]
					},
					{
						t: 179,
						s: [
							134.571,
							89.81,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-8.429,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													0.472,
													-1.39
												],
												[
													1.933,
													0
												],
												[
													0.742,
													1.44
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.414,
													1.221
												],
												[
													-1.933,
													0
												],
												[
													-0.5,
													-0.971
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-4.836,
													-67.721
												],
												[
													-8.429,
													-68.315
												],
												[
													-11.961,
													-67.721
												],
												[
													-8.492,
													-69.877
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 168,
									s: [
										{
											i: [
												[
													0.472,
													-1.39
												],
												[
													1.933,
													0
												],
												[
													0.742,
													1.44
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													-0.414,
													1.221
												],
												[
													-1.933,
													0
												],
												[
													-0.5,
													-0.971
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-4.836,
													-67.721
												],
												[
													-8.429,
													-68.315
												],
												[
													-11.961,
													-67.721
												],
												[
													-8.492,
													-69.877
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "hair",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					14.898,
					-113.831,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					21.898,
					-120.831,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 3,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 18,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-11.696,
													-3.029
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													28.034,
													-117.024
												],
												[
													21.667,
													-111.378
												],
												[
													31.446,
													-125.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 33,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 48,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-11.696,
													-3.029
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													28.034,
													-117.024
												],
												[
													21.667,
													-111.378
												],
												[
													31.446,
													-125.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 63,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 78,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-11.696,
													-3.029
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													28.034,
													-117.024
												],
												[
													21.667,
													-111.378
												],
												[
													31.446,
													-125.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 93,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 108,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-11.696,
													-3.029
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													28.034,
													-117.024
												],
												[
													21.667,
													-111.378
												],
												[
													31.446,
													-125.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 123,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 138,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-11.696,
													-3.029
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													28.034,
													-117.024
												],
												[
													21.667,
													-111.378
												],
												[
													31.446,
													-125.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 153,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 168,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-11.696,
													-3.029
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													28.034,
													-117.024
												],
												[
													21.667,
													-111.378
												],
												[
													31.446,
													-125.221
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.929411768913,
								0.207843139768,
								0.329411774874,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 5.161,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					122.5,
					252.873,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-20.5,
					95.873,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-29.326,
										0
									]
								],
								o: [
									[
										-33.45,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-11.86,
										108.443
									],
									[
										-45.683,
										83.303
									],
									[
										-5.04,
										90.443
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 9,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 17,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 24,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 31,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 38,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 45,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 52,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 59,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 67,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 74,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 81,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 88,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 95,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 102,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 109,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 116,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 123,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 130,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 144,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 151,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 158,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 165,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 172,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-4.616,
													8.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.616,
													93.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													4.683,
													99.443
												],
												[
													-12.629,
													99.443
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 3,
		nm: "Null 8",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							150,
							150,
							0
						],
						to: [
							0,
							1.083,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 15,
						s: [
							150,
							156.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							150,
							150,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 45,
						s: [
							150,
							156.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							150,
							150,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 75,
						s: [
							150,
							156.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							150,
							150,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 105,
						s: [
							150,
							156.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							150,
							150,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 135,
						s: [
							150,
							156.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 150,
						s: [
							150,
							150,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 165,
						s: [
							150,
							156.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.083,
							0
						]
					},
					{
						t: 179,
						s: [
							150,
							150,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "arm left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-62.279,
					28.958,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-55.279,
					21.958,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 2,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 17,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.569,
													-28.32
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-66.931,
													62.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 32,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 47,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.569,
													-28.32
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-66.931,
													62.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 62,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 77,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.569,
													-28.32
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-66.931,
													62.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 92,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 107,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.569,
													-28.32
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-66.931,
													62.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 122,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.569,
													-28.32
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-66.931,
													62.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 152,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 167,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.569,
													-28.32
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-66.931,
													62.32
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "buddy_mouth",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-40.435,
							35.817,
							0
						],
						to: [
							0.104,
							-0.521,
							0
						],
						ti: [
							-0.104,
							0.521,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 10,
						s: [
							-39.81,
							32.692,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 169,
						s: [
							-39.81,
							32.692,
							0
						],
						to: [
							-0.104,
							0.521,
							0
						],
						ti: [
							0.104,
							-0.521,
							0
						]
					},
					{
						t: 179,
						s: [
							-40.435,
							35.817,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-33.435,
					28.817,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-1.364,
										1.995
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										1.364,
										1.995
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-36.271,
										28.069
									],
									[
										-36.271,
										28.069
									],
									[
										-30.6,
										28.069
									],
									[
										-30.6,
										28.069
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 2,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "buddy_eye_white_right",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-29.842,
							26.597,
							0
						],
						to: [
							0.104,
							-0.521,
							0
						],
						ti: [
							-0.104,
							0.521,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 10,
						s: [
							-29.217,
							23.472,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 169,
						s: [
							-29.217,
							23.472,
							0
						],
						to: [
							-0.104,
							0.521,
							0
						],
						ti: [
							0.104,
							-0.521,
							0
						]
					},
					{
						t: 179,
						s: [
							-29.842,
							26.597,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.842,
					19.597,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-22.036,
										19.597
									],
									[
										-22.842,
										20.403
									],
									[
										-23.648,
										19.597
									],
									[
										-22.842,
										18.791
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "buddy_eye_right",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-29.331,
							27.715,
							0
						],
						to: [
							0.104,
							-0.521,
							0
						],
						ti: [
							-0.104,
							0.521,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 10,
						s: [
							-28.706,
							24.59,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 169,
						s: [
							-28.706,
							24.59,
							0
						],
						to: [
							-0.104,
							0.521,
							0
						],
						ti: [
							0.104,
							-0.521,
							0
						]
					},
					{
						t: 179,
						s: [
							-29.331,
							27.715,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.331,
					20.715,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 33,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 37,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 41,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 116,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 120,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 124,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									],
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									]
								],
								o: [
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									],
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									]
								],
								v: [
									[
										-20.154,
										20.715
									],
									[
										-22.331,
										22.892
									],
									[
										-24.508,
										20.715
									],
									[
										-22.331,
										18.537
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "buddy_eye_white_left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-51.876,
							26.838,
							0
						],
						to: [
							0.104,
							-0.521,
							0
						],
						ti: [
							-0.104,
							0.521,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 10,
						s: [
							-51.251,
							23.713,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 169,
						s: [
							-51.251,
							23.713,
							0
						],
						to: [
							-0.104,
							0.521,
							0
						],
						ti: [
							0.104,
							-0.521,
							0
						]
					},
					{
						t: 179,
						s: [
							-51.876,
							26.838,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.876,
					19.838,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-44.07,
										19.838
									],
									[
										-44.876,
										20.644
									],
									[
										-45.683,
										19.838
									],
									[
										-44.876,
										19.031
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "buddy_eye_left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							-51.295,
							27.955,
							0
						],
						to: [
							0.104,
							-0.521,
							0
						],
						ti: [
							-0.104,
							0.521,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 10,
						s: [
							-50.67,
							24.83,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 169,
						s: [
							-50.67,
							24.83,
							0
						],
						to: [
							-0.104,
							0.521,
							0
						],
						ti: [
							0.104,
							-0.521,
							0
						]
					},
					{
						t: 179,
						s: [
							-51.295,
							27.955,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.295,
					20.955,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 33,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 37,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 41,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 116,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 120,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 124,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									],
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									]
								],
								o: [
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									],
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									]
								],
								v: [
									[
										-42.117,
										20.955
									],
									[
										-44.295,
										23.133
									],
									[
										-46.472,
										20.955
									],
									[
										-44.295,
										18.778
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "buddy_body",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-60.288,
					34.837,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-53.288,
					27.837,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 15,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													36.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 32,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													23.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 48,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													36.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 63,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													23.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 78,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													36.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 92,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													23.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 107,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													36.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 122,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													23.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													36.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 152,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													23.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 167,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													36.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.384313732386,
								0.929411768913,
								0.603921592236,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					152.571,
					154.371,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.571,
					-2.629,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 15,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-54.076
												],
												[
													9.571,
													-104.9
												],
												[
													-33.632,
													-54.076
												],
												[
													-66.593,
													35.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													35.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 45,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-54.076
												],
												[
													9.571,
													-104.9
												],
												[
													-33.632,
													-54.076
												],
												[
													-66.593,
													35.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													35.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 60,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 75,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-54.076
												],
												[
													9.571,
													-104.9
												],
												[
													-33.632,
													-54.076
												],
												[
													-66.593,
													35.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													35.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 105,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-54.076
												],
												[
													9.571,
													-104.9
												],
												[
													-33.632,
													-54.076
												],
												[
													-66.593,
													35.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													35.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 135,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-54.076
												],
												[
													9.571,
													-104.9
												],
												[
													-33.632,
													-54.076
												],
												[
													-66.593,
													35.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													35.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 150,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 165,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-54.076
												],
												[
													9.571,
													-104.9
												],
												[
													-33.632,
													-54.076
												],
												[
													-66.593,
													35.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													35.725
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									0.894,
									0.388,
									0.408,
									0.25,
									0.902,
									0.224,
									0.349,
									0.5,
									0.91,
									0.059,
									0.29,
									0.8,
									0.808,
									0.029,
									0.235,
									1,
									0.706,
									0,
									0.18
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-67.115,
								-3
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								85.212,
								-3
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					182.463,
					256.443,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					39.463,
					99.443,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 8.801,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-21.493,
													11.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													75.493,
													86.943
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 17.598,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 26.398,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-21.493,
													11.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													75.493,
													86.943
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 35.195,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 43.994,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-21.493,
													11.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													75.493,
													86.943
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 52.793,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 61.592,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-21.493,
													11.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													75.493,
													86.943
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 70.391,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 79.189,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-21.493,
													11.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													75.493,
													86.943
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 87.988,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 96.787,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-21.493,
													11.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													75.493,
													86.943
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 105,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 113,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-21.493,
													11.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													75.493,
													86.943
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 121,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 129,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-21.493,
													11.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													75.493,
													86.943
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 145,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-21.493,
													11.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													75.493,
													86.943
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 153,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-21.493,
													11.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													75.493,
													86.943
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 167,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 174,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-21.493,
													11.057
												],
												[
													0,
													0
												]
											],
											v: [
												[
													75.493,
													86.943
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													74.243,
													99.443
												],
												[
													4.683,
													99.443
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 20,
		ty: 4,
		nm: "arm right",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					56.856,
					27.575,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					63.856,
					20.575,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 13,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													10.007,
													-65.118
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													72.993,
													64.618
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 28,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-17.493,
													-47.118
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													91.993,
													59.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 43,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													10.007,
													-65.118
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													72.993,
													64.618
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 58,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-17.493,
													-47.118
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													91.993,
													59.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 73,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													10.007,
													-65.118
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													72.993,
													64.618
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 88,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-17.493,
													-47.118
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													91.993,
													59.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 103,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													10.007,
													-65.118
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													72.993,
													64.618
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 118,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-17.493,
													-47.118
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													91.993,
													59.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 133,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													10.007,
													-65.118
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													72.993,
													64.618
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 148,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-17.493,
													-47.118
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													91.993,
													59.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 163,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													10.007,
													-65.118
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													72.993,
													64.618
												]
											],
											c: false
										}
									]
								},
								{
									t: 177,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 21,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					158.077,
					264.053,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					12.077,
					110.053,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										7.517
									],
									[
										43.448,
										0
									],
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									]
								],
								o: [
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									],
									[
										0,
										7.517
									],
									[
										43.448,
										0
									]
								],
								v: [
									[
										90.747,
										110.053
									],
									[
										12.077,
										96.443
									],
									[
										-66.593,
										110.053
									],
									[
										12.077,
										123.664
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$5 = [
];
var AlvaExcited = {
	v: v$5,
	fr: fr$5,
	ip: ip$5,
	op: op$5,
	w: w$5,
	h: h$5,
	nm: nm$5,
	ddd: ddd$5,
	assets: assets$5,
	layers: layers$5,
	markers: markers$5
};

var v$4 = "5.5.10";
var fr$4 = 60;
var ip$4 = 0;
var op$4 = 240;
var w$4 = 300;
var h$4 = 300;
var nm$4 = "red_idle";
var ddd$4 = 0;
var assets$4 = [
];
var layers$4 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		parent: 12,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							51.788,
							-66.923,
							0
						],
						to: [
							0,
							-4.529,
							0
						],
						ti: [
							0,
							4.529,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 120,
						s: [
							51.788,
							-94.097,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 166,
						s: [
							51.788,
							-94.097,
							0
						],
						to: [
							0,
							4.529,
							0
						],
						ti: [
							0,
							-4.529,
							0
						]
					},
					{
						t: 197,
						s: [
							51.788,
							-66.923,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 97,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													9.178,
													0
												],
												[
													0,
													6.669
												],
												[
													-6.697,
													0
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-7.822,
													0
												],
												[
													0,
													-6.002
												],
												[
													7.303,
													0
												]
											],
											v: [
												[
													23.185,
													-39.961
												],
												[
													10.822,
													-28.242
												],
												[
													-0.29,
													-40.046
												],
												[
													11.447,
													-49.934
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 122,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													9.178,
													0
												],
												[
													0,
													6.669
												],
												[
													-6.697,
													0
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-7.822,
													0
												],
												[
													0,
													-6.002
												],
												[
													7.303,
													0
												]
											],
											v: [
												[
													23.185,
													-39.961
												],
												[
													10.822,
													-28.242
												],
												[
													-0.29,
													-40.046
												],
												[
													11.447,
													-49.934
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 135,
									s: [
										{
											i: [
												[
													0,
													-3.887
												],
												[
													1.49,
													0
												],
												[
													0,
													4.824
												],
												[
													-0.635,
													0
												]
											],
											o: [
												[
													0,
													4.238
												],
												[
													-1.697,
													0
												],
												[
													0,
													-4.051
												],
												[
													2.303,
													0
												]
											],
											v: [
												[
													16.56,
													-39.711
												],
												[
													11.395,
													-34.492
												],
												[
													7.21,
													-40.296
												],
												[
													11.447,
													-45.059
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													-3.887
												],
												[
													1.49,
													0
												],
												[
													0,
													4.824
												],
												[
													-0.635,
													0
												]
											],
											o: [
												[
													0,
													4.238
												],
												[
													-1.697,
													0
												],
												[
													0,
													-4.051
												],
												[
													2.303,
													0
												]
											],
											v: [
												[
													16.56,
													-39.711
												],
												[
													11.395,
													-34.492
												],
												[
													7.21,
													-40.296
												],
												[
													11.447,
													-45.059
												]
											],
											c: true
										}
									]
								},
								{
									t: 166,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		parent: 12,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							45.08,
							-70.792,
							0
						],
						to: [
							0,
							-4.529,
							0
						],
						ti: [
							0,
							4.529,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 120,
						s: [
							45.08,
							-97.966,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 166,
						s: [
							45.08,
							-97.966,
							0
						],
						to: [
							0,
							4.529,
							0
						],
						ti: [
							0,
							-4.529,
							0
						]
					},
					{
						t: 197,
						s: [
							45.08,
							-70.792,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					7.737,
					-39.564,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-5.208,
										2.332
									],
									[
										6.438,
										0
									],
									[
										3.239,
										-2.707
									],
									[
										-6.439,
										0
									]
								],
								o: [
									[
										-3.239,
										-2.707
									],
									[
										-6.439,
										0
									],
									[
										3.239,
										2.707
									],
									[
										6.438,
										0
									]
								],
								v: [
									[
										25.561,
										-29.699
									],
									[
										10.239,
										-34.205
									],
									[
										-5.083,
										-29.699
									],
									[
										10.822,
										-28.242
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.282352954149,
								0.486274510622,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		parent: 12,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							51.788,
							-66.923,
							0
						],
						to: [
							0,
							-4.529,
							0
						],
						ti: [
							0,
							4.529,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 120,
						s: [
							51.788,
							-94.097,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 166,
						s: [
							51.788,
							-94.097,
							0
						],
						to: [
							0,
							4.529,
							0
						],
						ti: [
							0,
							-4.529,
							0
						]
					},
					{
						t: 197,
						s: [
							51.788,
							-66.923,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 97,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													9.178,
													0
												],
												[
													0,
													6.669
												],
												[
													-6.697,
													0
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-7.822,
													0
												],
												[
													0,
													-6.002
												],
												[
													7.303,
													0
												]
											],
											v: [
												[
													23.185,
													-39.961
												],
												[
													10.822,
													-28.242
												],
												[
													-0.29,
													-40.046
												],
												[
													11.447,
													-49.934
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 122,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													9.178,
													0
												],
												[
													0,
													6.669
												],
												[
													-6.697,
													0
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-7.822,
													0
												],
												[
													0,
													-6.002
												],
												[
													7.303,
													0
												]
											],
											v: [
												[
													23.185,
													-39.961
												],
												[
													10.822,
													-28.242
												],
												[
													-0.29,
													-40.046
												],
												[
													11.447,
													-49.934
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 135,
									s: [
										{
											i: [
												[
													0,
													-3.887
												],
												[
													1.49,
													0
												],
												[
													0,
													4.824
												],
												[
													-0.635,
													0
												]
											],
											o: [
												[
													0,
													4.238
												],
												[
													-1.697,
													0
												],
												[
													0,
													-4.051
												],
												[
													2.303,
													0
												]
											],
											v: [
												[
													16.56,
													-39.711
												],
												[
													11.395,
													-34.492
												],
												[
													7.21,
													-40.296
												],
												[
													11.447,
													-45.059
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													-3.887
												],
												[
													1.49,
													0
												],
												[
													0,
													4.824
												],
												[
													-0.635,
													0
												]
											],
											o: [
												[
													0,
													4.238
												],
												[
													-1.697,
													0
												],
												[
													0,
													-4.051
												],
												[
													2.303,
													0
												]
											],
											v: [
												[
													16.56,
													-39.711
												],
												[
													11.395,
													-34.492
												],
												[
													7.21,
													-40.296
												],
												[
													11.447,
													-45.059
												]
											],
											c: true
										}
									]
								},
								{
									t: 166,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		parent: 12,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							45.08,
							-70.792,
							0
						],
						to: [
							0,
							-4.529,
							0
						],
						ti: [
							0,
							4.529,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 120,
						s: [
							45.08,
							-97.966,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 166,
						s: [
							45.08,
							-97.966,
							0
						],
						to: [
							0,
							4.529,
							0
						],
						ti: [
							0,
							-4.529,
							0
						]
					},
					{
						t: 197,
						s: [
							45.08,
							-70.792,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					7.737,
					-39.564,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-4.332,
										-0.363
									],
									[
										0,
										0
									],
									[
										0.821,
										-0.091
									],
									[
										4.07,
										-0.147
									],
									[
										0.046,
										1.59
									],
									[
										0.138,
										2.302
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.03,
										1.544
									],
									[
										-3.464,
										0.384
									],
									[
										-0.848,
										0.031
									],
									[
										-0.093,
										-3.219
									],
									[
										5.41,
										-0.07
									]
								],
								v: [
									[
										5.301,
										-50.708
									],
									[
										4.662,
										-43.788
									],
									[
										3.253,
										-40.861
									],
									[
										-8.122,
										-40.05
									],
									[
										-9.738,
										-42.884
									],
									[
										-10.088,
										-51.159
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							51.788,
							-66.923,
							0
						],
						to: [
							0,
							-4.529,
							0
						],
						ti: [
							0,
							4.529,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 120,
						s: [
							51.788,
							-94.097,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 166,
						s: [
							51.788,
							-94.097,
							0
						],
						to: [
							0,
							4.529,
							0
						],
						ti: [
							0,
							-4.529,
							0
						]
					},
					{
						t: 197,
						s: [
							51.788,
							-66.923,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 97,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													9.178,
													0
												],
												[
													0,
													6.669
												],
												[
													-6.697,
													0
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-7.822,
													0
												],
												[
													0,
													-6.002
												],
												[
													7.303,
													0
												]
											],
											v: [
												[
													23.185,
													-39.961
												],
												[
													10.822,
													-28.242
												],
												[
													-0.29,
													-40.046
												],
												[
													11.447,
													-49.934
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.22,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 122,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													9.178,
													0
												],
												[
													0,
													6.669
												],
												[
													-6.697,
													0
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-7.822,
													0
												],
												[
													0,
													-6.002
												],
												[
													7.303,
													0
												]
											],
											v: [
												[
													23.185,
													-39.961
												],
												[
													10.822,
													-28.242
												],
												[
													-0.29,
													-40.046
												],
												[
													11.447,
													-49.934
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.78,
										y: 0
									},
									t: 135,
									s: [
										{
											i: [
												[
													0,
													-3.887
												],
												[
													1.49,
													0
												],
												[
													0,
													4.824
												],
												[
													-0.635,
													0
												]
											],
											o: [
												[
													0,
													4.238
												],
												[
													-1.697,
													0
												],
												[
													0,
													-4.051
												],
												[
													2.303,
													0
												]
											],
											v: [
												[
													16.56,
													-39.711
												],
												[
													11.395,
													-34.492
												],
												[
													7.21,
													-40.296
												],
												[
													11.447,
													-45.059
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 137,
									s: [
										{
											i: [
												[
													0,
													-3.887
												],
												[
													1.49,
													0
												],
												[
													0,
													4.824
												],
												[
													-0.635,
													0
												]
											],
											o: [
												[
													0,
													4.238
												],
												[
													-1.697,
													0
												],
												[
													0,
													-4.051
												],
												[
													2.303,
													0
												]
											],
											v: [
												[
													16.56,
													-39.711
												],
												[
													11.395,
													-34.492
												],
												[
													7.21,
													-40.296
												],
												[
													11.447,
													-45.059
												]
											],
											c: true
										}
									]
								},
								{
									t: 166,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eye white right",
		parent: 7,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					28.025,
					-68.44,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					28.025,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										29.275,
										-68.44
									],
									[
										28.025,
										-67.19
									],
									[
										26.775,
										-68.44
									],
									[
										28.025,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye right",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							91.903,
							-130.848,
							0
						],
						to: [
							0,
							-3.623,
							0
						],
						ti: [
							0,
							3.623,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 120,
						s: [
							91.903,
							-152.587,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 166,
						s: [
							91.903,
							-152.587,
							0
						],
						to: [
							0,
							3.623,
							0
						],
						ti: [
							0,
							-3.623,
							0
						]
					},
					{
						t: 197,
						s: [
							91.903,
							-130.848,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					29.275,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 30,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 35,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 41,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 98,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 111,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 138,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 143,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 166,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 171,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						t: 176,
						s: [
							217.391,
							217.391,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										32.775,
										-67.19
									],
									[
										29.275,
										-63.69
									],
									[
										25.775,
										-67.19
									],
									[
										29.275,
										-70.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye white left",
		parent: 9,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-9.679,
					-68.44,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-9.679,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-8.429,
										-68.44
									],
									[
										-9.679,
										-67.19
									],
									[
										-10.929,
										-68.44
									],
									[
										-9.679,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye left",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							9.936,
							-130.848,
							0
						],
						to: [
							0,
							-3.623,
							0
						],
						ti: [
							0,
							3.623,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 0.5
						},
						o: {
							x: 0.4,
							y: 0.4
						},
						t: 120,
						s: [
							9.936,
							-152.587,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 166,
						s: [
							9.936,
							-152.587,
							0
						],
						to: [
							0,
							3.623,
							0
						],
						ti: [
							0,
							-3.623,
							0
						]
					},
					{
						t: 197,
						s: [
							9.936,
							-130.848,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-8.429,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 30,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 35,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 41,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 98,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 111,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 138,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 143,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 166,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 171,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						t: 176,
						s: [
							217.391,
							217.391,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										-4.929,
										-67.19
									],
									[
										-8.429,
										-63.69
									],
									[
										-11.929,
										-67.19
									],
									[
										-8.429,
										-70.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "hair",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					75.865,
					-247.458,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					21.898,
					-120.831,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													9.804,
													-15.529
												]
											],
											o: [
												[
													2.396,
													-8.059
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													26.534,
													-112.524
												],
												[
													20.167,
													-106.878
												],
												[
													25.196,
													-90.971
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.1,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 131,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													9.804,
													-15.529
												]
											],
											o: [
												[
													2.396,
													-8.059
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													26.534,
													-112.524
												],
												[
													20.167,
													-106.878
												],
												[
													25.196,
													-90.971
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.9,
										y: 1
									},
									o: {
										x: 0.1,
										y: 0
									},
									t: 138,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-6.696,
													4.32
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													25.034,
													-124.024
												],
												[
													18.667,
													-118.378
												],
												[
													21.946,
													-135.721
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.9,
										y: 1
									},
									o: {
										x: 0.9,
										y: 0
									},
									t: 140,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-6.696,
													4.32
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													25.034,
													-124.024
												],
												[
													18.667,
													-118.378
												],
												[
													21.946,
													-135.721
												]
											],
											c: false
										}
									]
								},
								{
									t: 166,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.929411768913,
								0.207843139768,
								0.329411774874,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 5.161,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					122.5,
					252.873,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-20.5,
					95.873,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-29.326,
										0
									]
								],
								o: [
									[
										-33.45,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-11.86,
										108.443
									],
									[
										-45.683,
										83.303
									],
									[
										-5.04,
										90.443
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										4.683,
										99.443
									],
									[
										-12.629,
										99.443
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 3,
		nm: "Null 9",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							153,
							173,
							0
						],
						to: [
							0,
							1.167,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 30,
						s: [
							153,
							180,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							153,
							173,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 90,
						s: [
							153,
							180,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							153,
							173,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 150,
						s: [
							153,
							180,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 179,
						s: [
							153,
							173,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 210,
						s: [
							153,
							180,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.167,
							0
						]
					},
					{
						t: 239,
						s: [
							153,
							173,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					50,
					50,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					46,
					46,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "arm left",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-91.91,
					62.953,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-55.279,
					21.958,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.819,
													-33.07
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-68.181,
													63.82
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 60,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.819,
													-33.07
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-68.181,
													63.82
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 150,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.819,
													-33.07
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-68.181,
													63.82
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 210,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.819,
													-33.07
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-68.181,
													63.82
												]
											],
											c: false
										}
									]
								},
								{
									t: 239,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "buddy_mouth",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-44.425,
					77.863,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-33.435,
					28.817,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-1.364,
										1.995
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										1.364,
										1.995
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-36.271,
										28.069
									],
									[
										-36.271,
										28.069
									],
									[
										-30.6,
										28.069
									],
									[
										-30.6,
										28.069
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 2,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "buddy_eye_white_right",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-21.396,
					57.819,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.842,
					19.597,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-22.036,
										19.597
									],
									[
										-22.842,
										20.403
									],
									[
										-23.648,
										19.597
									],
									[
										-22.842,
										18.791
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "buddy_eye_right",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-20.285,
					60.249,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.331,
					20.715,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 49,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 55,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 61,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 143,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 149,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						t: 155,
						s: [
							217.391,
							217.391,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									],
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									]
								],
								o: [
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									],
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									]
								],
								v: [
									[
										-20.154,
										20.715
									],
									[
										-22.331,
										22.892
									],
									[
										-24.508,
										20.715
									],
									[
										-22.331,
										18.537
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "buddy_eye_white_left",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-69.297,
					58.343,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.876,
					19.838,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-44.07,
										19.838
									],
									[
										-44.876,
										20.644
									],
									[
										-45.683,
										19.838
									],
									[
										-44.876,
										19.031
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "buddy_eye_left",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-68.032,
					60.773,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.295,
					20.955,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 49,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 55,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 61,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 143,
						s: [
							217.391,
							217.391,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 149,
						s: [
							217.391,
							15,
							100
						]
					},
					{
						t: 155,
						s: [
							217.391,
							217.391,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									],
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									]
								],
								o: [
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									],
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									]
								],
								v: [
									[
										-42.117,
										20.955
									],
									[
										-44.295,
										23.133
									],
									[
										-46.472,
										20.955
									],
									[
										-44.295,
										18.778
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "buddy_body",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-87.584,
					75.733,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-53.288,
					27.837,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													33.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 60,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													25.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													33.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													25.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 150,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													33.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													25.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 210,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.237,
													33.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									t: 239,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.384313732386,
								0.929411768913,
								0.603921592236,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 20,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					152.571,
					154.371,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.571,
					-2.629,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-56.576
												],
												[
													9.571,
													-107.4
												],
												[
													-33.632,
													-56.576
												],
												[
													-66.593,
													33.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													33.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 60,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-56.576
												],
												[
													9.571,
													-107.4
												],
												[
													-33.632,
													-56.576
												],
												[
													-66.593,
													33.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													33.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 150,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-56.576
												],
												[
													9.571,
													-107.4
												],
												[
													-33.632,
													-56.576
												],
												[
													-66.593,
													33.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													33.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 179,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 210,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-56.576
												],
												[
													9.571,
													-107.4
												],
												[
													-33.632,
													-56.576
												],
												[
													-66.593,
													33.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													33.225
												]
											],
											c: true
										}
									]
								},
								{
									t: 239,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									0.894,
									0.388,
									0.408,
									0.25,
									0.902,
									0.224,
									0.349,
									0.5,
									0.91,
									0.059,
									0.29,
									0.8,
									0.808,
									0.029,
									0.235,
									1,
									0.706,
									0,
									0.18
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-67.115,
								-3
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								85.212,
								-3
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 21,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					182.463,
					256.443,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					39.463,
					99.443,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										74.243,
										99.443
									],
									[
										4.683,
										99.443
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 22,
		ty: 4,
		nm: "arm right",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					167.079,
					59.945,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					63.856,
					20.575,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					217.391,
					217.391,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 30,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.007,
													-68.618
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													76.993,
													65.368
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 60,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 90,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.007,
													-68.618
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													76.993,
													65.368
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 150,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.007,
													-68.618
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													76.993,
													65.368
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 210,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													4.007,
													-68.618
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													76.993,
													65.368
												]
											],
											c: false
										}
									]
								},
								{
									t: 239,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 23,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					158.077,
					264.053,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					12.077,
					110.053,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										7.517
									],
									[
										43.448,
										0
									],
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									]
								],
								o: [
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									],
									[
										0,
										7.517
									],
									[
										43.448,
										0
									]
								],
								v: [
									[
										90.747,
										110.053
									],
									[
										12.077,
										96.443
									],
									[
										-66.593,
										110.053
									],
									[
										12.077,
										123.664
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 240,
		st: 0,
		bm: 0
	}
];
var markers$4 = [
];
var AlvaIdle = {
	v: v$4,
	fr: fr$4,
	ip: ip$4,
	op: op$4,
	w: w$4,
	h: h$4,
	nm: nm$4,
	ddd: ddd$4,
	assets: assets$4,
	layers: layers$4,
	markers: markers$4
};

var v$3 = "5.5.10";
var fr$3 = 60;
var ip$3 = 0;
var op$3 = 180;
var w$3 = 300;
var h$3 = 300;
var nm$3 = "red_no";
var ddd$3 = 0;
var assets$3 = [
];
var layers$3 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							-2.083,
							0,
							0
						],
						ti: [
							-2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							2.083,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							2.083,
							0,
							0
						],
						ti: [
							2.083,
							0,
							0
						]
					},
					{
						t: 179,
						s: [
							153.822,
							119.216,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 9,
									s: [
										{
											i: [
												[
													1.566,
													-2.352
												],
												[
													15.664,
													0
												],
												[
													2.479,
													4.398
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-1.854,
													2.784
												],
												[
													-15.664,
													0
												],
												[
													-0.595,
													-1.055
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													31.935,
													-34.836
												],
												[
													10.572,
													-40.117
												],
												[
													-10.728,
													-35.711
												],
												[
													10.51,
													-43.122
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													1.566,
													-2.352
												],
												[
													15.664,
													0
												],
												[
													2.479,
													4.398
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-1.854,
													2.784
												],
												[
													-15.664,
													0
												],
												[
													-0.595,
													-1.055
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													31.935,
													-34.836
												],
												[
													10.572,
													-40.117
												],
												[
													-10.728,
													-35.711
												],
												[
													10.51,
													-43.122
												]
											],
											c: true
										}
									]
								},
								{
									t: 169,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					150.737,
					117.436,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					7.737,
					-39.564,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-5.208,
										2.332
									],
									[
										6.438,
										0
									],
									[
										3.239,
										-2.707
									],
									[
										-6.439,
										0
									]
								],
								o: [
									[
										-3.239,
										-2.707
									],
									[
										-6.439,
										0
									],
									[
										3.239,
										2.707
									],
									[
										6.438,
										0
									]
								],
								v: [
									[
										25.561,
										-29.699
									],
									[
										10.239,
										-34.205
									],
									[
										-5.083,
										-29.699
									],
									[
										10.822,
										-28.242
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.282352954149,
								0.486274510622,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							-2.083,
							0,
							0
						],
						ti: [
							-2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							2.083,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							2.083,
							0,
							0
						],
						ti: [
							2.083,
							0,
							0
						]
					},
					{
						t: 179,
						s: [
							153.822,
							119.216,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 9,
									s: [
										{
											i: [
												[
													1.566,
													-2.352
												],
												[
													15.664,
													0
												],
												[
													2.479,
													4.398
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-1.854,
													2.784
												],
												[
													-15.664,
													0
												],
												[
													-0.595,
													-1.055
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													31.935,
													-34.836
												],
												[
													10.572,
													-40.117
												],
												[
													-10.728,
													-35.711
												],
												[
													10.51,
													-43.122
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													1.566,
													-2.352
												],
												[
													15.664,
													0
												],
												[
													2.479,
													4.398
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-1.854,
													2.784
												],
												[
													-15.664,
													0
												],
												[
													-0.595,
													-1.055
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													31.935,
													-34.836
												],
												[
													10.572,
													-40.117
												],
												[
													-10.728,
													-35.711
												],
												[
													10.51,
													-43.122
												]
											],
											c: true
										}
									]
								},
								{
									t: 169,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					150.737,
					117.436,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					7.737,
					-39.564,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-4.332,
										-0.363
									],
									[
										0,
										0
									],
									[
										0.821,
										-0.091
									],
									[
										4.07,
										-0.147
									],
									[
										0.046,
										1.59
									],
									[
										0.138,
										2.302
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.03,
										1.544
									],
									[
										-3.464,
										0.384
									],
									[
										-0.848,
										0.031
									],
									[
										-0.093,
										-3.219
									],
									[
										5.41,
										-0.07
									]
								],
								v: [
									[
										5.301,
										-50.708
									],
									[
										4.662,
										-43.788
									],
									[
										3.253,
										-40.861
									],
									[
										-8.122,
										-40.05
									],
									[
										-9.738,
										-42.884
									],
									[
										-10.088,
										-51.159
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										0,
										0
									],
									to: [
										0,
										-1.042
									],
									ti: [
										0,
										1.042
									]
								},
								{
									i: {
										x: 0.5,
										y: 0.5
									},
									o: {
										x: 0.4,
										y: 0.4
									},
									t: 9,
									s: [
										0,
										-6.25
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 160,
									s: [
										0,
										-6.25
									],
									to: [
										0,
										1.042
									],
									ti: [
										0,
										-1.042
									]
								},
								{
									t: 169,
									s: [
										0,
										0
									]
								}
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							-2.083,
							0,
							0
						],
						ti: [
							-2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 19,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							2.083,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 39,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 59,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 79,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 99,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 119,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 139,
						s: [
							141.322,
							119.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 159,
						s: [
							166.322,
							119.216,
							0
						],
						to: [
							2.083,
							0,
							0
						],
						ti: [
							2.083,
							0,
							0
						]
					},
					{
						t: 179,
						s: [
							153.822,
							119.216,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 9,
									s: [
										{
											i: [
												[
													1.566,
													-2.352
												],
												[
													15.664,
													0
												],
												[
													2.479,
													4.398
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-1.854,
													2.784
												],
												[
													-15.664,
													0
												],
												[
													-0.595,
													-1.055
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													31.935,
													-34.836
												],
												[
													10.572,
													-40.117
												],
												[
													-10.728,
													-35.711
												],
												[
													10.51,
													-43.122
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													1.566,
													-2.352
												],
												[
													15.664,
													0
												],
												[
													2.479,
													4.398
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													-1.854,
													2.784
												],
												[
													-15.664,
													0
												],
												[
													-0.595,
													-1.055
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													31.935,
													-34.836
												],
												[
													10.572,
													-40.117
												],
												[
													-10.728,
													-35.711
												],
												[
													10.51,
													-43.122
												]
											],
											c: true
										}
									]
								},
								{
									t: 169,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eye white right",
		parent: 7,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					28.025,
					-68.44,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					28.025,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										29.275,
										-68.44
									],
									[
										28.025,
										-67.19
									],
									[
										26.775,
										-68.44
									],
									[
										28.025,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							-2.083,
							0,
							0
						],
						ti: [
							-2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							159.775,
							89.81,
							0
						],
						to: [
							2.083,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							184.775,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							159.775,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							184.775,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							159.775,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							184.775,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							159.775,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							184.775,
							89.81,
							0
						],
						to: [
							2.083,
							0,
							0
						],
						ti: [
							2.083,
							0,
							0
						]
					},
					{
						t: 179,
						s: [
							172.275,
							89.81,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					29.275,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 40,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 44,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 48,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 100,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 104,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 108,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 20,
									s: [
										{
											i: [
												[
													0,
													-0.373
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0.226,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-0.338,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-0.498
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 60,
									s: [
										{
											i: [
												[
													0,
													-0.373
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0.226,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-0.338,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-0.498
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 100,
									s: [
										{
											i: [
												[
													0,
													-0.373
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0.226,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-0.338,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-0.498
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 140,
									s: [
										{
											i: [
												[
													0,
													-0.373
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0.226,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-0.338,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-0.498
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													32.775,
													-67.19
												],
												[
													29.275,
													-63.69
												],
												[
													25.775,
													-67.19
												],
												[
													29.275,
													-70.69
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye white left",
		parent: 9,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-9.679,
					-68.44,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-9.679,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-8.429,
										-68.44
									],
									[
										-9.679,
										-67.19
									],
									[
										-10.929,
										-68.44
									],
									[
										-9.679,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							-2.083,
							0,
							0
						],
						ti: [
							-2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							122.071,
							89.81,
							0
						],
						to: [
							2.083,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							147.071,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							122.071,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							147.071,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							122.071,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							147.071,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							122.071,
							89.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-2.083,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							147.071,
							89.81,
							0
						],
						to: [
							2.083,
							0,
							0
						],
						ti: [
							2.083,
							0,
							0
						]
					},
					{
						t: 179,
						s: [
							134.571,
							89.81,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-8.429,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 40,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 44,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 48,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 100,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 104,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 108,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 20,
									s: [
										{
											i: [
												[
													0,
													-0.373
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0.367,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-0.196,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-0.498
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 60,
									s: [
										{
											i: [
												[
													0,
													-0.373
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0.367,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-0.196,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-0.498
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 100,
									s: [
										{
											i: [
												[
													0,
													-0.373
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0.367,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-0.196,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-0.498
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 140,
									s: [
										{
											i: [
												[
													0,
													-0.373
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													0.367,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-0.196,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-0.498
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												],
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												]
											],
											o: [
												[
													0,
													1.933
												],
												[
													-1.933,
													0
												],
												[
													0,
													-1.933
												],
												[
													1.933,
													0
												]
											],
											v: [
												[
													-4.929,
													-67.19
												],
												[
													-8.429,
													-63.69
												],
												[
													-11.929,
													-67.19
												],
												[
													-8.429,
													-70.69
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "hair",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							164.898,
							36.169,
							0
						],
						to: [
							-0.833,
							0,
							0
						],
						ti: [
							-0.833,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							159.898,
							36.169,
							0
						],
						to: [
							0.833,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							169.898,
							36.169,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							159.898,
							36.169,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							169.898,
							36.169,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							159.898,
							36.169,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							169.898,
							36.169,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							159.898,
							36.169,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-0.833,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							169.898,
							36.169,
							0
						],
						to: [
							0.833,
							0,
							0
						],
						ti: [
							0.833,
							0,
							0
						]
					},
					{
						t: 179,
						s: [
							164.898,
							36.169,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					21.898,
					-120.831,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 2,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 22,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-4.591,
													-4.161
												],
												[
													3.826,
													7.694
												],
												[
													9.804,
													7.441
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													4.716,
													4.274
												],
												[
													-3.417,
													-6.872
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													6.284,
													-124.774
												],
												[
													-0.083,
													-119.128
												],
												[
													-0.304,
													-134.941
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 42,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 62,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-4.591,
													-4.161
												],
												[
													3.826,
													7.694
												],
												[
													9.804,
													7.441
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													4.716,
													4.274
												],
												[
													-3.417,
													-6.872
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													6.284,
													-124.774
												],
												[
													-0.083,
													-119.128
												],
												[
													-0.304,
													-134.941
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 82,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 102,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-4.591,
													-4.161
												],
												[
													3.826,
													7.694
												],
												[
													9.804,
													7.441
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													4.716,
													4.274
												],
												[
													-3.417,
													-6.872
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													6.284,
													-124.774
												],
												[
													-0.083,
													-119.128
												],
												[
													-0.304,
													-134.941
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 122,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 142,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-4.591,
													-4.161
												],
												[
													3.826,
													7.694
												],
												[
													9.804,
													7.441
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													4.716,
													4.274
												],
												[
													-3.417,
													-6.872
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													6.284,
													-124.774
												],
												[
													-0.083,
													-119.128
												],
												[
													-0.304,
													-134.941
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 162,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.929411768913,
								0.207843139768,
								0.329411774874,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 5.161,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					122.5,
					252.873,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-20.5,
					95.873,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-29.326,
										0
									]
								],
								o: [
									[
										-33.45,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-11.86,
										108.443
									],
									[
										-45.683,
										83.303
									],
									[
										-5.04,
										90.443
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										4.683,
										99.443
									],
									[
										-12.629,
										99.443
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "arm left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					87.721,
					178.958,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-55.279,
					21.958,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-0.319,
													-33.32
												]
											],
											o: [
												[
													-29.716,
													28.153
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-73.181,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 60,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-0.319,
													-33.32
												]
											],
											o: [
												[
													-29.716,
													28.153
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-73.181,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 80,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 100,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-0.319,
													-33.32
												]
											],
											o: [
												[
													-29.716,
													28.153
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-73.181,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 120,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 140,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-0.319,
													-33.32
												]
											],
											o: [
												[
													-29.716,
													28.153
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-73.181,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 160,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.506,
													-33.504
												]
											],
											o: [
												[
													-23.155,
													23.474
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-39.034,
													-19.403
												],
												[
													-70.931,
													63.32
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "buddy_mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 1,
						s: [
							109.565,
							185.817,
							0
						],
						to: [
							-0.417,
							0,
							0
						],
						ti: [
							-0.417,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 21,
						s: [
							107.065,
							185.817,
							0
						],
						to: [
							0.417,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 41,
						s: [
							112.065,
							185.817,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 61,
						s: [
							107.065,
							185.817,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 81,
						s: [
							112.065,
							185.817,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 101,
						s: [
							107.065,
							185.817,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 121,
						s: [
							112.065,
							185.817,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 141,
						s: [
							107.065,
							185.817,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-0.417,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 161,
						s: [
							112.065,
							185.817,
							0
						],
						to: [
							0.417,
							0,
							0
						],
						ti: [
							0.417,
							0,
							0
						]
					},
					{
						t: 178,
						s: [
							109.565,
							185.817,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-33.435,
					28.817,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-1.364,
													1.995
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													1.364,
													1.995
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-36.271,
													28.069
												],
												[
													-36.271,
													28.069
												],
												[
													-30.6,
													28.069
												],
												[
													-30.6,
													28.069
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 11,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-1.889,
													-2.444
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													1.032,
													-1.506
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-36.271,
													28.069
												],
												[
													-36.271,
													28.069
												],
												[
													-30.6,
													28.069
												],
												[
													-30.6,
													28.069
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 168,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-1.889,
													-2.444
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													1.032,
													-1.506
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-36.271,
													28.069
												],
												[
													-36.271,
													28.069
												],
												[
													-30.6,
													28.069
												],
												[
													-30.6,
													28.069
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-1.364,
													1.995
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													1.364,
													1.995
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-36.271,
													28.069
												],
												[
													-36.271,
													28.069
												],
												[
													-30.6,
													28.069
												],
												[
													-30.6,
													28.069
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 2,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "buddy_eye_white_right",
		parent: 15,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-22.842,
					19.597,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.842,
					19.597,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-22.036,
										19.597
									],
									[
										-22.842,
										20.403
									],
									[
										-23.648,
										19.597
									],
									[
										-22.842,
										18.791
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "buddy_eye_right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 2,
						s: [
							120.669,
							177.715,
							0
						],
						to: [
							-0.417,
							0,
							0
						],
						ti: [
							-0.417,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 22,
						s: [
							118.169,
							177.715,
							0
						],
						to: [
							0.417,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 42,
						s: [
							123.169,
							177.715,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 62,
						s: [
							118.169,
							177.715,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 82,
						s: [
							123.169,
							177.715,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 102,
						s: [
							118.169,
							177.715,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 122,
						s: [
							123.169,
							177.715,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 142,
						s: [
							118.169,
							177.715,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-0.417,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 162,
						s: [
							123.169,
							177.715,
							0
						],
						to: [
							0.417,
							0,
							0
						],
						ti: [
							0.417,
							0,
							0
						]
					},
					{
						t: 179,
						s: [
							120.669,
							177.715,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.331,
					20.715,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 11,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 15,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 19,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 74,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 78,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 82,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 124,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 128,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 132,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									],
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									]
								],
								o: [
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									],
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									]
								],
								v: [
									[
										-20.154,
										20.715
									],
									[
										-22.331,
										22.892
									],
									[
										-24.508,
										20.715
									],
									[
										-22.331,
										18.537
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "buddy_eye_white_left",
		parent: 17,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-44.876,
					19.838,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.876,
					19.838,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-44.07,
										19.838
									],
									[
										-44.876,
										20.644
									],
									[
										-45.683,
										19.838
									],
									[
										-44.876,
										19.031
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "buddy_eye_left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 2,
						s: [
							98.705,
							177.955,
							0
						],
						to: [
							-0.417,
							0,
							0
						],
						ti: [
							-0.417,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 22,
						s: [
							96.205,
							177.955,
							0
						],
						to: [
							0.417,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 42,
						s: [
							101.205,
							177.955,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 62,
						s: [
							96.205,
							177.955,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 82,
						s: [
							101.205,
							177.955,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 102,
						s: [
							96.205,
							177.955,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 122,
						s: [
							101.205,
							177.955,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 142,
						s: [
							96.205,
							177.955,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-0.417,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 162,
						s: [
							101.205,
							177.955,
							0
						],
						to: [
							0.417,
							0,
							0
						],
						ti: [
							0.417,
							0,
							0
						]
					},
					{
						t: 179,
						s: [
							98.705,
							177.955,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.295,
					20.955,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 11,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 15,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 19,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 74,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 78,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 82,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 124,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 128,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 132,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									],
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									]
								],
								o: [
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									],
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									]
								],
								v: [
									[
										-42.117,
										20.955
									],
									[
										-44.295,
										23.133
									],
									[
										-46.472,
										20.955
									],
									[
										-44.295,
										18.778
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "buddy_body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					89.712,
					184.837,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-53.288,
					27.837,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 2,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 22,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-2.59,
													11.919
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													2.618,
													-12.051
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-86.868,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 42,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 62,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-2.59,
													11.919
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													2.618,
													-12.051
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-86.868,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 82,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 102,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-2.59,
													11.919
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													2.618,
													-12.051
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-86.868,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 122,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 142,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-2.59,
													11.919
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													2.618,
													-12.051
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-86.868,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									t: 162,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.384313732386,
								0.929411768913,
								0.603921592236,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					152.571,
					154.371,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.571,
					-2.629,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										2.908,
										35.376
									],
									[
										25.186,
										0
									],
									[
										2.681,
										-32.609
									],
									[
										0,
										-34.987
									],
									[
										-45.204,
										0
									],
									[
										0,
										42.296
									]
								],
								o: [
									[
										-2.681,
										-32.609
									],
									[
										-25.186,
										0
									],
									[
										-2.908,
										35.376
									],
									[
										0,
										42.296
									],
									[
										45.204,
										0
									],
									[
										0,
										-34.987
									]
								],
								v: [
									[
										52.773,
										-61.576
									],
									[
										9.571,
										-112.4
									],
									[
										-33.632,
										-61.576
									],
									[
										-66.593,
										28.225
									],
									[
										9.571,
										107.141
									],
									[
										85.735,
										28.225
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									0.894,
									0.388,
									0.408,
									0.25,
									0.902,
									0.224,
									0.349,
									0.5,
									0.91,
									0.059,
									0.29,
									0.8,
									0.808,
									0.029,
									0.235,
									1,
									0.706,
									0,
									0.18
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-67.115,
								-3
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								85.212,
								-3
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 20,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					182.463,
					256.443,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					39.463,
					99.443,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										74.243,
										99.443
									],
									[
										4.683,
										99.443
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 21,
		ty: 4,
		nm: "arm right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					206.856,
					177.575,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					63.856,
					20.575,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 18,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-11.743,
													-66.368
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													86.743,
													62.868
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 38,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 58,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-11.743,
													-66.368
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													86.743,
													62.868
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 78,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 98,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-11.743,
													-66.368
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													86.743,
													62.868
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 118,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 138,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-11.743,
													-66.368
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													86.743,
													62.868
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 158,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									t: 177,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 22,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					158.077,
					264.053,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					12.077,
					110.053,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										7.517
									],
									[
										43.448,
										0
									],
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									]
								],
								o: [
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									],
									[
										0,
										7.517
									],
									[
										43.448,
										0
									]
								],
								v: [
									[
										90.747,
										110.053
									],
									[
										12.077,
										96.443
									],
									[
										-66.593,
										110.053
									],
									[
										12.077,
										123.664
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$3 = [
];
var AlvaWrong = {
	v: v$3,
	fr: fr$3,
	ip: ip$3,
	op: op$3,
	w: w$3,
	h: h$3,
	nm: nm$3,
	ddd: ddd$3,
	assets: assets$3,
	layers: layers$3,
	markers: markers$3
};

var v$2 = "5.6.9";
var fr$2 = 60;
var ip$2 = 0;
var op$2 = 180;
var w$2 = 300;
var h$2 = 300;
var nm$2 = "red_yes";
var ddd$2 = 0;
var assets$2 = [
];
var layers$2 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "mouth mask",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							2.083,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							153.822,
							124.216,
							0
						],
						to: [
							0,
							-2.083,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							153.822,
							124.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							153.822,
							124.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							153.822,
							124.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							-0.833,
							0
						],
						ti: [
							0,
							-2.083,
							0
						]
					},
					{
						t: 179,
						s: [
							153.822,
							119.216,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													-1.429,
													-1.922
												],
												[
													15.664,
													0
												],
												[
													-2.046,
													3.361
												],
												[
													-14.181,
													0.268
												]
											],
											o: [
												[
													2.377,
													3.197
												],
												[
													-15.664,
													0
												],
												[
													1.478,
													-2.428
												],
												[
													17.428,
													-0.329
												]
											],
											v: [
												[
													33.123,
													-43.711
												],
												[
													11.26,
													-37.43
												],
												[
													-11.665,
													-43.648
												],
												[
													11.072,
													-41.309
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 168,
									s: [
										{
											i: [
												[
													-1.429,
													-1.922
												],
												[
													15.664,
													0
												],
												[
													-2.046,
													3.361
												],
												[
													-14.181,
													0.268
												]
											],
											o: [
												[
													2.377,
													3.197
												],
												[
													-15.664,
													0
												],
												[
													1.478,
													-2.428
												],
												[
													17.428,
													-0.329
												]
											],
											v: [
												[
													33.123,
													-43.711
												],
												[
													11.26,
													-37.43
												],
												[
													-11.665,
													-43.648
												],
												[
													11.072,
													-41.309
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "teeth + tounge",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							150.737,
							117.436,
							0
						],
						to: [
							0,
							1.25,
							0
						],
						ti: [
							0,
							2.125,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							150.737,
							124.936,
							0
						],
						to: [
							0,
							-2.125,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							150.737,
							104.686,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							150.737,
							124.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							150.737,
							104.686,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							150.737,
							124.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							150.737,
							104.686,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							150.737,
							124.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.25,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							150.737,
							104.686,
							0
						],
						to: [
							0,
							-1.25,
							0
						],
						ti: [
							0,
							-2.125,
							0
						]
					},
					{
						t: 179,
						s: [
							150.737,
							117.436,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					7.737,
					-39.564,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-5.208,
										2.332
									],
									[
										6.438,
										0
									],
									[
										3.239,
										-2.707
									],
									[
										-6.439,
										0
									]
								],
								o: [
									[
										-3.239,
										-2.707
									],
									[
										-6.439,
										0
									],
									[
										3.239,
										2.707
									],
									[
										6.438,
										0
									]
								],
								v: [
									[
										25.561,
										-29.699
									],
									[
										10.239,
										-34.205
									],
									[
										-5.083,
										-29.699
									],
									[
										10.822,
										-28.242
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.282352954149,
								0.486274510622,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-4.332,
										-0.363
									],
									[
										0,
										0
									],
									[
										0.821,
										-0.091
									],
									[
										4.07,
										-0.147
									],
									[
										0.046,
										1.59
									],
									[
										0.138,
										2.302
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.03,
										1.544
									],
									[
										-3.464,
										0.384
									],
									[
										-0.848,
										0.031
									],
									[
										-0.093,
										-3.219
									],
									[
										5.41,
										-0.07
									]
								],
								v: [
									[
										5.301,
										-50.708
									],
									[
										4.662,
										-43.788
									],
									[
										3.253,
										-40.861
									],
									[
										-8.122,
										-40.05
									],
									[
										-9.738,
										-42.884
									],
									[
										-10.088,
										-51.159
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										0,
										0
									],
									to: [
										0,
										-1.458
									],
									ti: [
										0,
										1.458
									]
								},
								{
									i: {
										x: 0.5,
										y: 0.5
									},
									o: {
										x: 0.4,
										y: 0.4
									},
									t: 12,
									s: [
										0,
										-8.75
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 168,
									s: [
										0,
										-8.75
									],
									to: [
										0,
										1.458
									],
									ti: [
										0,
										-1.458
									]
								},
								{
									t: 179,
									s: [
										0,
										0
									]
								}
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							2.083,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							153.822,
							124.216,
							0
						],
						to: [
							0,
							-2.083,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 60,
						s: [
							153.822,
							124.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 80,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 100,
						s: [
							153.822,
							124.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 120,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 140,
						s: [
							153.822,
							124.216,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							153.822,
							106.716,
							0
						],
						to: [
							0,
							-0.833,
							0
						],
						ti: [
							0,
							-2.083,
							0
						]
					},
					{
						t: 179,
						s: [
							153.822,
							119.216,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													-1.429,
													-1.922
												],
												[
													15.664,
													0
												],
												[
													-2.046,
													3.361
												],
												[
													-14.181,
													0.268
												]
											],
											o: [
												[
													2.377,
													3.197
												],
												[
													-15.664,
													0
												],
												[
													1.478,
													-2.428
												],
												[
													17.428,
													-0.329
												]
											],
											v: [
												[
													33.123,
													-43.711
												],
												[
													11.26,
													-37.43
												],
												[
													-11.665,
													-43.648
												],
												[
													11.072,
													-41.309
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 168,
									s: [
										{
											i: [
												[
													-1.429,
													-1.922
												],
												[
													15.664,
													0
												],
												[
													-2.046,
													3.361
												],
												[
													-14.181,
													0.268
												]
											],
											o: [
												[
													2.377,
													3.197
												],
												[
													-15.664,
													0
												],
												[
													1.478,
													-2.428
												],
												[
													17.428,
													-0.329
												]
											],
											v: [
												[
													33.123,
													-43.711
												],
												[
													11.26,
													-37.43
												],
												[
													-11.665,
													-43.648
												],
												[
													11.072,
													-41.309
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-5.006
												],
												[
													15.664,
													0
												],
												[
													0,
													6.669
												],
												[
													-14.181,
													-0.249
												]
											],
											o: [
												[
													0,
													6.097
												],
												[
													-15.664,
													0
												],
												[
													0,
													-6.002
												],
												[
													14.181,
													0.249
												]
											],
											v: [
												[
													39.185,
													-44.961
												],
												[
													10.822,
													-28.242
												],
												[
													-17.54,
													-44.961
												],
												[
													10.822,
													-43.434
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "eye white right",
		parent: 5,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					28.025,
					-68.44,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					28.025,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										29.275,
										-68.44
									],
									[
										28.025,
										-67.19
									],
									[
										26.775,
										-68.44
									],
									[
										28.025,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							1.667,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 18,
						s: [
							172.275,
							99.81,
							0
						],
						to: [
							0,
							-1.667,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 38,
						s: [
							172.275,
							79.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 58,
						s: [
							172.275,
							99.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							172.275,
							79.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 98,
						s: [
							172.275,
							99.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 118,
						s: [
							172.275,
							79.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							172.275,
							99.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 158,
						s: [
							172.275,
							79.81,
							0
						],
						to: [
							0,
							-1.667,
							0
						],
						ti: [
							0,
							-1.667,
							0
						]
					},
					{
						t: 179,
						s: [
							172.275,
							89.81,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					29.275,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 40,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 44,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 48,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 140,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 144,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 148,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										32.775,
										-67.19
									],
									[
										29.275,
										-63.69
									],
									[
										25.775,
										-67.19
									],
									[
										29.275,
										-70.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eye white left",
		parent: 7,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-9.679,
					-68.44,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-9.679,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-8.429,
										-68.44
									],
									[
										-9.679,
										-67.19
									],
									[
										-10.929,
										-68.44
									],
									[
										-9.679,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							1.667,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 18,
						s: [
							134.571,
							99.81,
							0
						],
						to: [
							0,
							-1.667,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 38,
						s: [
							134.571,
							79.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 58,
						s: [
							134.571,
							99.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							134.571,
							79.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 98,
						s: [
							134.571,
							99.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 118,
						s: [
							134.571,
							79.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							134.571,
							99.81,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.667,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 158,
						s: [
							134.571,
							79.81,
							0
						],
						to: [
							0,
							-1.667,
							0
						],
						ti: [
							0,
							-1.667,
							0
						]
					},
					{
						t: 179,
						s: [
							134.571,
							89.81,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-8.429,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 40,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 44,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 48,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 140,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 144,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 148,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										-4.929,
										-67.19
									],
									[
										-8.429,
										-63.69
									],
									[
										-11.929,
										-67.19
									],
									[
										-8.429,
										-70.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "hair",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							164.898,
							39.409,
							0
						],
						to: [
							0,
							0.833,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 18,
						s: [
							164.898,
							44.409,
							0
						],
						to: [
							0,
							-0.833,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 38,
						s: [
							164.898,
							34.409,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 58,
						s: [
							164.898,
							44.409,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							164.898,
							34.409,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 98,
						s: [
							164.898,
							44.409,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 118,
						s: [
							164.898,
							34.409,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							164.898,
							44.409,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.833,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 158,
						s: [
							164.898,
							34.409,
							0
						],
						to: [
							0,
							-0.833,
							0
						],
						ti: [
							0,
							-0.833,
							0
						]
					},
					{
						t: 179,
						s: [
							164.898,
							39.409,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					21.898,
					-120.831,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 18,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.196,
													-1.519
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													27.534,
													-117.524
												],
												[
													21.167,
													-111.878
												],
												[
													30.196,
													-124.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 38,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 58,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.196,
													-1.519
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													27.534,
													-117.524
												],
												[
													21.167,
													-111.878
												],
												[
													30.196,
													-124.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 78,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 98,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.196,
													-1.519
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													27.534,
													-117.524
												],
												[
													21.167,
													-111.878
												],
												[
													30.196,
													-124.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 118,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 138,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.196,
													-1.519
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													27.534,
													-117.524
												],
												[
													21.167,
													-111.878
												],
												[
													30.196,
													-124.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 158,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													27.034,
													-122.274
												],
												[
													20.667,
													-116.628
												],
												[
													28.696,
													-134.721
												]
											],
											c: false
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.929411768913,
								0.207843139768,
								0.329411774874,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 5.161,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					122.5,
					252.873,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-20.5,
					95.873,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-29.326,
										0
									]
								],
								o: [
									[
										-33.45,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-11.86,
										108.443
									],
									[
										-45.683,
										83.303
									],
									[
										-5.04,
										90.443
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										4.683,
										99.443
									],
									[
										-12.629,
										99.443
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 3,
		nm: "ARM LILLE ",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							105,
							135.5,
							0
						],
						to: [
							0,
							0.708,
							0
						],
						ti: [
							0,
							0.125,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 18,
						s: [
							105,
							139.75,
							0
						],
						to: [
							0,
							-0.125,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 38,
						s: [
							105,
							134.75,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 58,
						s: [
							105,
							139.75,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							105,
							134.75,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 98,
						s: [
							105,
							139.75,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 118,
						s: [
							105,
							134.75,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							105,
							139.75,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0.708,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 158,
						s: [
							105,
							134.75,
							0
						],
						to: [
							0,
							-0.708,
							0
						],
						ti: [
							0,
							-0.125,
							0
						]
					},
					{
						t: 179,
						s: [
							105,
							135.5,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					50,
					50,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					26,
					26,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "arm left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-16.456,
					217.147,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-55.279,
					21.958,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					384.615,
					384.615,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-3.506,
										-33.504
									]
								],
								o: [
									[
										-23.155,
										23.474
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-39.034,
										-19.403
									],
									[
										-70.931,
										63.32
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "buddy_mouth",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 3,
						s: [
							67.556,
							243.526,
							0
						],
						to: [
							0,
							1.603,
							0
						],
						ti: [
							0,
							1.603,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 15,
						s: [
							67.556,
							253.141,
							0
						],
						to: [
							0,
							-1.603,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 28.572,
						s: [
							67.556,
							233.911,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 42.143,
						s: [
							67.556,
							253.141,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 55.715,
						s: [
							67.556,
							233.911,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 69.285,
						s: [
							67.556,
							253.141,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 82.857,
						s: [
							67.556,
							233.911,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 96.428,
						s: [
							67.556,
							253.141,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 110,
						s: [
							67.556,
							233.911,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 122,
						s: [
							67.556,
							253.141,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 134,
						s: [
							67.556,
							233.911,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 146,
						s: [
							67.556,
							253.141,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.603,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 159,
						s: [
							67.556,
							233.911,
							0
						],
						to: [
							0,
							-1.603,
							0
						],
						ti: [
							0,
							-1.603,
							0
						]
					},
					{
						t: 179,
						s: [
							67.556,
							243.526,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-33.435,
					28.817,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					384.615,
					384.615,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-1.364,
										1.995
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										1.364,
										1.995
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-36.271,
										28.069
									],
									[
										-36.271,
										28.069
									],
									[
										-30.6,
										28.069
									],
									[
										-30.6,
										28.069
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 2,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "buddy_eye_white_right",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 3,
						s: [
							108.3,
							208.065,
							0
						],
						to: [
							0,
							1.603,
							0
						],
						ti: [
							0,
							1.603,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 15,
						s: [
							108.3,
							217.681,
							0
						],
						to: [
							0,
							-1.603,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 28.672,
						s: [
							108.3,
							198.45,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 42.342,
						s: [
							108.3,
							217.681,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 56.014,
						s: [
							108.3,
							198.45,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 69.684,
						s: [
							108.3,
							217.681,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 83.355,
						s: [
							108.3,
							198.45,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 97.025,
						s: [
							108.3,
							217.681,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.603,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 110.697,
						s: [
							108.3,
							198.45,
							0
						],
						to: [
							0,
							-1.603,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 123,
						s: [
							108.3,
							208.065,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 135,
						s: [
							108.3,
							198.45,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 147,
						s: [
							108.3,
							208.065,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							108.3,
							198.45,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-1.603,
							0
						]
					},
					{
						t: 179,
						s: [
							108.3,
							208.065,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.842,
					19.597,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					384.615,
					384.615,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-22.036,
										19.597
									],
									[
										-22.842,
										20.403
									],
									[
										-23.648,
										19.597
									],
									[
										-22.842,
										18.791
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "buddy_eye_right",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 3,
						s: [
							110.265,
							212.364,
							0
						],
						to: [
							0,
							1.603,
							0
						],
						ti: [
							0,
							1.603,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 15,
						s: [
							110.265,
							221.979,
							0
						],
						to: [
							0,
							-1.603,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 28.672,
						s: [
							110.265,
							202.748,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 42.342,
						s: [
							110.265,
							221.979,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 56.014,
						s: [
							110.265,
							202.748,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 69.684,
						s: [
							110.265,
							221.979,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 83.355,
						s: [
							110.265,
							202.748,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 97.025,
						s: [
							110.265,
							221.979,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.603,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 110.697,
						s: [
							110.265,
							202.748,
							0
						],
						to: [
							0,
							-1.603,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 123,
						s: [
							110.265,
							212.364,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 135,
						s: [
							110.265,
							202.748,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 147,
						s: [
							110.265,
							212.364,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							110.265,
							202.748,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-1.603,
							0
						]
					},
					{
						t: 179,
						s: [
							110.265,
							212.364,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.331,
					20.715,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 21,
						s: [
							384.615,
							384.615,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 25,
						s: [
							384.615,
							15,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 29,
						s: [
							384.615,
							384.615,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 121,
						s: [
							384.615,
							384.615,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 125,
						s: [
							384.615,
							15,
							100
						]
					},
					{
						t: 129,
						s: [
							384.615,
							384.615,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									],
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									]
								],
								o: [
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									],
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									]
								],
								v: [
									[
										-20.154,
										20.715
									],
									[
										-22.331,
										22.892
									],
									[
										-24.508,
										20.715
									],
									[
										-22.331,
										18.537
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "buddy_eye_white_left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 3,
						s: [
							23.552,
							208.991,
							0
						],
						to: [
							0,
							1.603,
							0
						],
						ti: [
							0,
							1.603,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 15,
						s: [
							23.552,
							218.607,
							0
						],
						to: [
							0,
							-1.603,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 28.672,
						s: [
							23.552,
							199.376,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 42.342,
						s: [
							23.552,
							218.607,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 56.014,
						s: [
							23.552,
							199.376,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 69.684,
						s: [
							23.552,
							218.607,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 83.355,
						s: [
							23.552,
							199.376,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 97.025,
						s: [
							23.552,
							218.607,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.603,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 110.697,
						s: [
							23.552,
							199.376,
							0
						],
						to: [
							0,
							-1.603,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 123,
						s: [
							23.552,
							208.991,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 135,
						s: [
							23.552,
							199.376,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 147,
						s: [
							23.552,
							208.991,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							23.552,
							199.376,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-1.603,
							0
						]
					},
					{
						t: 179,
						s: [
							23.552,
							208.991,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.876,
					19.838,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					384.615,
					384.615,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-44.07,
										19.838
									],
									[
										-44.876,
										20.644
									],
									[
										-45.683,
										19.838
									],
									[
										-44.876,
										19.031
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "buddy_eye_left",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 3,
						s: [
							25.79,
							213.29,
							0
						],
						to: [
							0,
							1.603,
							0
						],
						ti: [
							0,
							1.603,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 15,
						s: [
							25.79,
							222.905,
							0
						],
						to: [
							0,
							-1.603,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 28.672,
						s: [
							25.79,
							203.674,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 42.342,
						s: [
							25.79,
							222.905,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 56.014,
						s: [
							25.79,
							203.674,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 69.684,
						s: [
							25.79,
							222.905,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 83.355,
						s: [
							25.79,
							203.674,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 97.025,
						s: [
							25.79,
							222.905,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							1.603,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 110.697,
						s: [
							25.79,
							203.674,
							0
						],
						to: [
							0,
							-1.603,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 123,
						s: [
							25.79,
							213.29,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 135,
						s: [
							25.79,
							203.674,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 147,
						s: [
							25.79,
							213.29,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							25.79,
							203.674,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-1.603,
							0
						]
					},
					{
						t: 179,
						s: [
							25.79,
							213.29,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.295,
					20.955,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 21,
						s: [
							384.615,
							384.615,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 25,
						s: [
							384.615,
							15,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 29,
						s: [
							384.615,
							384.615,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 121,
						s: [
							384.615,
							384.615,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 125,
						s: [
							384.615,
							15,
							100
						]
					},
					{
						t: 129,
						s: [
							384.615,
							384.615,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									],
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									]
								],
								o: [
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									],
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									]
								],
								v: [
									[
										-42.117,
										20.955
									],
									[
										-44.295,
										23.133
									],
									[
										-46.472,
										20.955
									],
									[
										-44.295,
										18.778
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "buddy_body",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-8.802,
					239.758,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-53.288,
					27.837,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					384.615,
					384.615,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 21,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													32.301
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 41,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-89.868,
													25.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 61,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													32.301
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 81,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-89.868,
													25.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 101,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													32.301
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 121,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-89.868,
													25.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 141,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													32.301
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 161,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-89.868,
													25.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.384313732386,
								0.929411768913,
								0.603921592236,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					152.571,
					154.371,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.571,
					-2.629,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 18,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-59.076
												],
												[
													9.571,
													-109.9
												],
												[
													-33.632,
													-59.076
												],
												[
													-66.593,
													30.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													30.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 38,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-64.076
												],
												[
													9.571,
													-114.9
												],
												[
													-33.632,
													-64.076
												],
												[
													-66.593,
													25.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													25.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 58,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-59.076
												],
												[
													9.571,
													-109.9
												],
												[
													-33.632,
													-59.076
												],
												[
													-66.593,
													30.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													30.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 78,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-64.076
												],
												[
													9.571,
													-114.9
												],
												[
													-33.632,
													-64.076
												],
												[
													-66.593,
													25.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													25.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 98,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-59.076
												],
												[
													9.571,
													-109.9
												],
												[
													-33.632,
													-59.076
												],
												[
													-66.593,
													30.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													30.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 118,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-64.076
												],
												[
													9.571,
													-114.9
												],
												[
													-33.632,
													-64.076
												],
												[
													-66.593,
													25.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													25.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 138,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-59.076
												],
												[
													9.571,
													-109.9
												],
												[
													-33.632,
													-59.076
												],
												[
													-66.593,
													30.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													30.725
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 158,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-64.076
												],
												[
													9.571,
													-114.9
												],
												[
													-33.632,
													-64.076
												],
												[
													-66.593,
													25.725
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													25.725
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									0.894,
									0.388,
									0.408,
									0.25,
									0.902,
									0.224,
									0.349,
									0.5,
									0.91,
									0.059,
									0.29,
									0.8,
									0.808,
									0.029,
									0.235,
									1,
									0.706,
									0,
									0.18
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-67.115,
								-3
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								85.212,
								-3
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					182.463,
					256.443,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					39.463,
					99.443,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										74.243,
										99.443
									],
									[
										4.683,
										99.443
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 20,
		ty: 4,
		nm: "arm right",
		parent: 10,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					441.755,
					211.826,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					63.856,
					20.575,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					384.615,
					384.615,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 6,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 25,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													9.007,
													-66.842
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													74.493,
													70.868
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 46,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 66,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													9.007,
													-66.842
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													74.493,
													70.868
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 86,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 106,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													9.007,
													-66.842
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													74.493,
													70.868
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 126,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 146,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													9.007,
													-66.842
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													74.493,
													70.868
												]
											],
											c: false
										}
									]
								},
								{
									t: 166,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 21,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					158.077,
					264.053,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					12.077,
					110.053,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										7.517
									],
									[
										43.448,
										0
									],
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									]
								],
								o: [
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									],
									[
										0,
										7.517
									],
									[
										43.448,
										0
									]
								],
								v: [
									[
										90.747,
										110.053
									],
									[
										12.077,
										96.443
									],
									[
										-66.593,
										110.053
									],
									[
										12.077,
										123.664
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$2 = [
];
var AlvaCorrect = {
	v: v$2,
	fr: fr$2,
	ip: ip$2,
	op: op$2,
	w: w$2,
	h: h$2,
	nm: nm$2,
	ddd: ddd$2,
	assets: assets$2,
	layers: layers$2,
	markers: markers$2
};

var v$1 = "5.5.10";
var fr$1 = 60;
var ip$1 = 0;
var op$1 = 180;
var w$1 = 300;
var h$1 = 300;
var nm$1 = "red_wave";
var ddd$1 = 0;
var assets$1 = [
];
var layers$1 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "tounge mask",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 33,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 48,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 63,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 93,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 108,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 123,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 153,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 176,
						s: [
							153.822,
							119.216,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-5.006
									],
									[
										15.664,
										0
									],
									[
										0,
										6.669
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										0,
										6.097
									],
									[
										-15.664,
										0
									],
									[
										0,
										-6.002
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										39.185,
										-44.961
									],
									[
										10.822,
										-28.242
									],
									[
										-17.54,
										-44.961
									],
									[
										10.822,
										-43.434
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "tounge",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							150.737,
							117.436,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							150.737,
							114.936,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 33,
						s: [
							150.737,
							119.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 48,
						s: [
							150.737,
							114.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 63,
						s: [
							150.737,
							119.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							150.737,
							114.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 93,
						s: [
							150.737,
							119.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 108,
						s: [
							150.737,
							114.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 123,
						s: [
							150.737,
							119.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							150.737,
							114.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 153,
						s: [
							150.737,
							119.936,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 176,
						s: [
							150.737,
							117.436,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					7.737,
					-39.564,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-5.208,
										2.332
									],
									[
										6.438,
										0
									],
									[
										3.239,
										-2.707
									],
									[
										-6.439,
										0
									]
								],
								o: [
									[
										-3.239,
										-2.707
									],
									[
										-6.439,
										0
									],
									[
										3.239,
										2.707
									],
									[
										6.438,
										0
									]
								],
								v: [
									[
										25.561,
										-29.699
									],
									[
										10.239,
										-34.205
									],
									[
										-5.083,
										-29.699
									],
									[
										10.822,
										-28.242
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.282352954149,
								0.486274510622,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 90,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "teeth mask",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 33,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 48,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 63,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 93,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 108,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 123,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 153,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 176,
						s: [
							153.822,
							119.216,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-5.006
									],
									[
										15.664,
										0
									],
									[
										0,
										6.669
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										0,
										6.097
									],
									[
										-15.664,
										0
									],
									[
										0,
										-6.002
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										39.185,
										-44.961
									],
									[
										10.822,
										-28.242
									],
									[
										-17.54,
										-44.961
									],
									[
										10.822,
										-43.434
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "teeth",
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							150.737,
							117.436,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							150.737,
							114.936,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 33,
						s: [
							150.737,
							119.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 48,
						s: [
							150.737,
							114.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 63,
						s: [
							150.737,
							119.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							150.737,
							114.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 93,
						s: [
							150.737,
							119.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 108,
						s: [
							150.737,
							114.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 123,
						s: [
							150.737,
							119.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							150.737,
							114.936,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 153,
						s: [
							150.737,
							119.936,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 176,
						s: [
							150.737,
							117.436,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					7.737,
					-39.564,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-4.332,
										-0.363
									],
									[
										0,
										0
									],
									[
										0.821,
										-0.091
									],
									[
										4.07,
										-0.147
									],
									[
										0.046,
										1.59
									],
									[
										0.138,
										2.302
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.03,
										1.544
									],
									[
										-3.464,
										0.384
									],
									[
										-0.848,
										0.031
									],
									[
										-0.093,
										-3.219
									],
									[
										5.41,
										-0.07
									]
								],
								v: [
									[
										5.301,
										-50.708
									],
									[
										4.662,
										-43.788
									],
									[
										3.253,
										-40.861
									],
									[
										-8.122,
										-40.05
									],
									[
										-9.738,
										-42.884
									],
									[
										-10.088,
										-51.159
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "mouth",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							153.822,
							119.216,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 33,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 48,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 63,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 93,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 108,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 123,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							153.822,
							116.716,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 153,
						s: [
							153.822,
							121.716,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 176,
						s: [
							153.822,
							119.216,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					10.822,
					-37.784,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-5.006
									],
									[
										15.664,
										0
									],
									[
										0,
										6.669
									],
									[
										-14.181,
										-0.249
									]
								],
								o: [
									[
										0,
										6.097
									],
									[
										-15.664,
										0
									],
									[
										0,
										-6.002
									],
									[
										14.181,
										0.249
									]
								],
								v: [
									[
										39.185,
										-44.961
									],
									[
										10.822,
										-28.242
									],
									[
										-17.54,
										-44.961
									],
									[
										10.822,
										-43.434
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eye white right",
		parent: 7,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					28.025,
					-68.44,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					28.025,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										29.275,
										-68.44
									],
									[
										28.025,
										-67.19
									],
									[
										26.775,
										-68.44
									],
									[
										28.025,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eye right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							172.275,
							89.81,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 19,
						s: [
							172.275,
							87.31,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 34,
						s: [
							172.275,
							92.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 49,
						s: [
							172.275,
							87.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 64,
						s: [
							172.275,
							92.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 79,
						s: [
							172.275,
							87.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 94,
						s: [
							172.275,
							92.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 109,
						s: [
							172.275,
							87.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 124,
						s: [
							172.275,
							92.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 139,
						s: [
							172.275,
							87.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 154,
						s: [
							172.275,
							92.31,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 176,
						s: [
							172.275,
							89.81,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					29.275,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 34,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 37,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 40,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 93,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 96,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 99,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 106,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 109,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 112,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 153,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 156,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 159,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										32.775,
										-67.19
									],
									[
										29.275,
										-63.69
									],
									[
										25.775,
										-67.19
									],
									[
										29.275,
										-70.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye white left",
		parent: 9,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-9.679,
					-68.44,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-9.679,
					-68.44,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									],
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									]
								],
								o: [
									[
										0,
										0.69
									],
									[
										-0.69,
										0
									],
									[
										0,
										-0.69
									],
									[
										0.69,
										0
									]
								],
								v: [
									[
										-8.429,
										-68.44
									],
									[
										-9.679,
										-67.19
									],
									[
										-10.929,
										-68.44
									],
									[
										-9.679,
										-69.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "eye left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							134.571,
							89.81,
							0
						],
						to: [
							0,
							-0.417,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 19,
						s: [
							134.571,
							87.31,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 34,
						s: [
							134.571,
							92.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 49,
						s: [
							134.571,
							87.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 64,
						s: [
							134.571,
							92.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 79,
						s: [
							134.571,
							87.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 94,
						s: [
							134.571,
							92.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 109,
						s: [
							134.571,
							87.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 124,
						s: [
							134.571,
							92.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 139,
						s: [
							134.571,
							87.31,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.417,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 154,
						s: [
							134.571,
							92.31,
							0
						],
						to: [
							0,
							0.417,
							0
						],
						ti: [
							0,
							0.417,
							0
						]
					},
					{
						t: 176,
						s: [
							134.571,
							89.81,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-8.429,
					-67.19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 34,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 37,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 40,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 93,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 96,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 99,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 106,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 109,
						s: [
							100,
							5,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 112,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 153,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 156,
						s: [
							100,
							5,
							100
						]
					},
					{
						t: 159,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									],
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									]
								],
								o: [
									[
										0,
										1.933
									],
									[
										-1.933,
										0
									],
									[
										0,
										-1.933
									],
									[
										1.933,
										0
									]
								],
								v: [
									[
										-4.929,
										-67.19
									],
									[
										-8.429,
										-63.69
									],
									[
										-11.929,
										-67.19
									],
									[
										-8.429,
										-70.69
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "hair",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					246.327,
					-274.435,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					21.898,
					-120.831,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					333.333,
					333.333,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 19,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													25.659,
													-121.649
												],
												[
													19.292,
													-116.003
												],
												[
													25.696,
													-133.721
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 34,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-11.446,
													-0.616
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.909,
													-119.774
												],
												[
													23.542,
													-114.128
												],
												[
													31.946,
													-130.096
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 49,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													25.659,
													-121.649
												],
												[
													19.292,
													-116.003
												],
												[
													25.696,
													-133.721
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 64,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-11.446,
													-0.616
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.909,
													-119.774
												],
												[
													23.542,
													-114.128
												],
												[
													31.946,
													-130.096
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 79,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													25.659,
													-121.649
												],
												[
													19.292,
													-116.003
												],
												[
													25.696,
													-133.721
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 94,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-11.446,
													-0.616
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.909,
													-119.774
												],
												[
													23.542,
													-114.128
												],
												[
													31.946,
													-130.096
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 109,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													25.659,
													-121.649
												],
												[
													19.292,
													-116.003
												],
												[
													25.696,
													-133.721
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 124,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-11.446,
													-0.616
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.909,
													-119.774
												],
												[
													23.542,
													-114.128
												],
												[
													31.946,
													-130.096
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 139,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													25.659,
													-121.649
												],
												[
													19.292,
													-116.003
												],
												[
													25.696,
													-133.721
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 154,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-11.446,
													-0.616
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.909,
													-119.774
												],
												[
													23.542,
													-114.128
												],
												[
													31.946,
													-130.096
												]
											],
											c: false
										}
									]
								},
								{
									t: 176,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.058,
													-3.579
												],
												[
													7.085,
													4.862
												],
												[
													-12.358,
													1.747
												]
											],
											o: [
												[
													-0.209,
													-15.262
												],
												[
													6.113,
													4.326
												],
												[
													-7.186,
													-4.931
												],
												[
													0,
													0
												]
											],
											v: [
												[
													11.854,
													-107.441
												],
												[
													29.284,
													-120.524
												],
												[
													22.917,
													-114.878
												],
												[
													31.446,
													-134.221
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.929411768913,
								0.207843139768,
								0.329411774874,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 5.161,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "leg left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					122.5,
					252.873,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-20.5,
					95.873,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-29.326,
										0
									]
								],
								o: [
									[
										-33.45,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-11.86,
										108.443
									],
									[
										-45.683,
										83.303
									],
									[
										-5.04,
										90.443
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										4.683,
										99.443
									],
									[
										-12.629,
										99.443
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 3,
		nm: "MOVE ARMS + LILLE",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							106,
							133.5,
							0
						],
						to: [
							0,
							-0.333,
							0
						],
						ti: [
							0,
							-0.333,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 17,
						s: [
							106,
							131.5,
							0
						],
						to: [
							0,
							0.333,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 33,
						s: [
							106,
							135.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 48,
						s: [
							106,
							131.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 63,
						s: [
							106,
							135.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 78,
						s: [
							106,
							131.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 93,
						s: [
							106,
							135.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 108,
						s: [
							106,
							131.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 123,
						s: [
							106,
							135.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 138,
						s: [
							106,
							131.5,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.333,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 153,
						s: [
							106,
							135.5,
							0
						],
						to: [
							0,
							0.333,
							0
						],
						ti: [
							0,
							0.333,
							0
						]
					},
					{
						t: 176,
						s: [
							106,
							133.5,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					50,
					50,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					30,
					30,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "arm left",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-10.928,
					201.527,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-55.279,
					21.958,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					333.333,
					333.333,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-3.506,
										-33.504
									]
								],
								o: [
									[
										-23.155,
										23.474
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-39.034,
										-19.403
									],
									[
										-70.931,
										63.32
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "buddy_mouth",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 3,
						s: [
							61.882,
							224.389,
							0
						],
						to: [
							0,
							-0.694,
							0
						],
						ti: [
							0,
							-0.694,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 23,
						s: [
							61.882,
							220.223,
							0
						],
						to: [
							0,
							0.694,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 40,
						s: [
							61.882,
							228.556,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 56,
						s: [
							61.882,
							220.223,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 73,
						s: [
							61.882,
							228.556,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 89,
						s: [
							61.882,
							220.223,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 104,
						s: [
							61.882,
							228.556,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 119,
						s: [
							61.882,
							220.223,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 132,
						s: [
							61.882,
							228.556,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 145,
						s: [
							61.882,
							220.223,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.694,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 160,
						s: [
							61.882,
							228.556,
							0
						],
						to: [
							0,
							0.694,
							0
						],
						ti: [
							0,
							0.694,
							0
						]
					},
					{
						t: 179,
						s: [
							61.882,
							224.389,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-33.435,
					28.817,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					333.333,
					333.333,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-1.364,
										1.995
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										1.364,
										1.995
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-36.271,
										28.069
									],
									[
										-36.271,
										28.069
									],
									[
										-30.6,
										28.069
									],
									[
										-30.6,
										28.069
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 2,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "buddy_eye_white_right",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							97.194,
							193.656,
							0
						],
						to: [
							0,
							-0.694,
							0
						],
						ti: [
							0,
							-0.694,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							97.194,
							189.49,
							0
						],
						to: [
							0,
							0.694,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 37,
						s: [
							97.194,
							197.823,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 53,
						s: [
							97.194,
							189.49,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 70,
						s: [
							97.194,
							197.823,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 86,
						s: [
							97.194,
							189.49,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 101,
						s: [
							97.194,
							197.823,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 116,
						s: [
							97.194,
							189.49,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 129,
						s: [
							97.194,
							197.823,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 142,
						s: [
							97.194,
							189.49,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.694,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 157,
						s: [
							97.194,
							197.823,
							0
						],
						to: [
							0,
							0.694,
							0
						],
						ti: [
							0,
							0.694,
							0
						]
					},
					{
						t: 179,
						s: [
							97.194,
							193.656,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.842,
					19.597,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					333.333,
					333.333,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-22.036,
										19.597
									],
									[
										-22.842,
										20.403
									],
									[
										-23.648,
										19.597
									],
									[
										-22.842,
										18.791
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "buddy_eye_right",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							98.897,
							197.382,
							0
						],
						to: [
							0,
							-0.694,
							0
						],
						ti: [
							0,
							-0.694,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							98.897,
							193.215,
							0
						],
						to: [
							0,
							0.694,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 37,
						s: [
							98.897,
							201.549,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 53,
						s: [
							98.897,
							193.215,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 70,
						s: [
							98.897,
							201.549,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 86,
						s: [
							98.897,
							193.215,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 101,
						s: [
							98.897,
							201.549,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 116,
						s: [
							98.897,
							193.215,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 129,
						s: [
							98.897,
							201.549,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 142,
						s: [
							98.897,
							193.215,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.694,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 157,
						s: [
							98.897,
							201.549,
							0
						],
						to: [
							0,
							0.694,
							0
						],
						ti: [
							0,
							0.694,
							0
						]
					},
					{
						t: 179,
						s: [
							98.897,
							197.382,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-22.331,
					20.715,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 18,
						s: [
							333.333,
							333.333,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 22,
						s: [
							333.333,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 26,
						s: [
							333.333,
							333.3,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 70,
						s: [
							333.333,
							333.3,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 74,
						s: [
							333.333,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 78,
						s: [
							333.333,
							333.3,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 138,
						s: [
							333.333,
							333.3,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 142,
						s: [
							333.333,
							20,
							100
						]
					},
					{
						t: 146,
						s: [
							333.333,
							333.3,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									],
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									]
								],
								o: [
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									],
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									]
								],
								v: [
									[
										-20.154,
										20.715
									],
									[
										-22.331,
										22.892
									],
									[
										-24.508,
										20.715
									],
									[
										-22.331,
										18.537
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "buddy_eye_white_left",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							23.745,
							194.459,
							0
						],
						to: [
							0,
							-0.694,
							0
						],
						ti: [
							0,
							-0.694,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							23.745,
							190.292,
							0
						],
						to: [
							0,
							0.694,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 37,
						s: [
							23.745,
							198.626,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 53,
						s: [
							23.745,
							190.292,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 70,
						s: [
							23.745,
							198.626,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 86,
						s: [
							23.745,
							190.292,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 101,
						s: [
							23.745,
							198.626,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 116,
						s: [
							23.745,
							190.292,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 129,
						s: [
							23.745,
							198.626,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 142,
						s: [
							23.745,
							190.292,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.694,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 157,
						s: [
							23.745,
							198.626,
							0
						],
						to: [
							0,
							0.694,
							0
						],
						ti: [
							0,
							0.694,
							0
						]
					},
					{
						t: 179,
						s: [
							23.745,
							194.459,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.876,
					19.838,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					333.333,
					333.333,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									],
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									]
								],
								o: [
									[
										0,
										0.445
									],
									[
										-0.445,
										0
									],
									[
										0,
										-0.445
									],
									[
										0.445,
										0
									]
								],
								v: [
									[
										-44.07,
										19.838
									],
									[
										-44.876,
										20.644
									],
									[
										-45.683,
										19.838
									],
									[
										-44.876,
										19.031
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 50,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "buddy_eye_left",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 0,
						s: [
							25.685,
							198.185,
							0
						],
						to: [
							0,
							-0.694,
							0
						],
						ti: [
							0,
							-0.694,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 20,
						s: [
							25.685,
							194.018,
							0
						],
						to: [
							0,
							0.694,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 37,
						s: [
							25.685,
							202.351,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 53,
						s: [
							25.685,
							194.018,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 70,
						s: [
							25.685,
							202.351,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 86,
						s: [
							25.685,
							194.018,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 101,
						s: [
							25.685,
							202.351,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 116,
						s: [
							25.685,
							194.018,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 129,
						s: [
							25.685,
							202.351,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 142,
						s: [
							25.685,
							194.018,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							-0.694,
							0
						]
					},
					{
						i: {
							x: 0.5,
							y: 1
						},
						o: {
							x: 0.4,
							y: 0
						},
						t: 157,
						s: [
							25.685,
							202.351,
							0
						],
						to: [
							0,
							0.694,
							0
						],
						ti: [
							0,
							0.694,
							0
						]
					},
					{
						t: 179,
						s: [
							25.685,
							198.185,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-44.295,
					20.955,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 11,
						s: [
							333.333,
							333.333,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 15,
						s: [
							333.333,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 19,
						s: [
							333.333,
							333.3,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 70,
						s: [
							333.333,
							333.3,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 74,
						s: [
							333.333,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 78,
						s: [
							333.333,
							333.3,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 134,
						s: [
							333.333,
							333.3,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 138,
						s: [
							333.333,
							20,
							100
						]
					},
					{
						t: 142,
						s: [
							333.333,
							333.3,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									],
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									]
								],
								o: [
									[
										0,
										1.203
									],
									[
										-1.203,
										0
									],
									[
										0,
										-1.203
									],
									[
										1.203,
										0
									]
								],
								v: [
									[
										-42.117,
										20.955
									],
									[
										-44.295,
										23.133
									],
									[
										-46.472,
										20.955
									],
									[
										-44.295,
										18.778
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "buddy_body",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-4.295,
					221.124,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-53.288,
					27.837,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					333.333,
					333.333,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.368,
													25.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 37,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.368,
													32.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 53,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.368,
													25.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 70,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.368,
													32.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 86,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.368,
													25.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 101,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.368,
													32.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 116,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.368,
													25.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 129,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.368,
													32.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 142,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.368,
													25.551
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 157,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.368,
													32.801
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								},
								{
									t: 179,
									s: [
										{
											i: [
												[
													0,
													-12.197
												],
												[
													20.285,
													0.119
												],
												[
													-5.507,
													10.883
												],
												[
													-17.595,
													0
												]
											],
											o: [
												[
													0,
													12.197
												],
												[
													-18.842,
													-0.11
												],
												[
													5.321,
													-10.514
												],
												[
													17.595,
													0
												]
											],
											v: [
												[
													-15.83,
													27.227
												],
												[
													-44.793,
													53.293
												],
												[
													-90.118,
													29.051
												],
												[
													-42.259,
													2.38
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.384313732386,
								0.929411768913,
								0.603921592236,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 20,
		ty: 4,
		nm: "body",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					152.571,
					154.371,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					9.571,
					-2.629,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 17,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-62.576
												],
												[
													9.571,
													-113.4
												],
												[
													-33.632,
													-62.576
												],
												[
													-66.593,
													27.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													27.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 33,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-59.576
												],
												[
													9.571,
													-110.4
												],
												[
													-33.632,
													-59.576
												],
												[
													-66.593,
													30.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													30.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 48,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-62.576
												],
												[
													9.571,
													-113.4
												],
												[
													-33.632,
													-62.576
												],
												[
													-66.593,
													27.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													27.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 63,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-59.576
												],
												[
													9.571,
													-110.4
												],
												[
													-33.632,
													-59.576
												],
												[
													-66.593,
													30.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													30.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 78,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-62.576
												],
												[
													9.571,
													-113.4
												],
												[
													-33.632,
													-62.576
												],
												[
													-66.593,
													27.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													27.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 93,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-59.576
												],
												[
													9.571,
													-110.4
												],
												[
													-33.632,
													-59.576
												],
												[
													-66.593,
													30.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													30.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 108,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-62.576
												],
												[
													9.571,
													-113.4
												],
												[
													-33.632,
													-62.576
												],
												[
													-66.593,
													27.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													27.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 123,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-59.576
												],
												[
													9.571,
													-110.4
												],
												[
													-33.632,
													-59.576
												],
												[
													-66.593,
													30.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													30.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 138,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-62.576
												],
												[
													9.571,
													-113.4
												],
												[
													-33.632,
													-62.576
												],
												[
													-66.593,
													27.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													27.225
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 153,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-59.576
												],
												[
													9.571,
													-110.4
												],
												[
													-33.632,
													-59.576
												],
												[
													-66.593,
													30.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													30.225
												]
											],
											c: true
										}
									]
								},
								{
									t: 176,
									s: [
										{
											i: [
												[
													2.908,
													35.376
												],
												[
													25.186,
													0
												],
												[
													2.681,
													-32.609
												],
												[
													0,
													-34.987
												],
												[
													-45.204,
													0
												],
												[
													0,
													42.296
												]
											],
											o: [
												[
													-2.681,
													-32.609
												],
												[
													-25.186,
													0
												],
												[
													-2.908,
													35.376
												],
												[
													0,
													42.296
												],
												[
													45.204,
													0
												],
												[
													0,
													-34.987
												]
											],
											v: [
												[
													52.773,
													-61.576
												],
												[
													9.571,
													-112.4
												],
												[
													-33.632,
													-61.576
												],
												[
													-66.593,
													28.225
												],
												[
													9.571,
													107.141
												],
												[
													85.735,
													28.225
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 5,
							k: {
								a: 0,
								k: [
									0,
									0.894,
									0.388,
									0.408,
									0.25,
									0.902,
									0.224,
									0.349,
									0.5,
									0.91,
									0.059,
									0.29,
									0.8,
									0.808,
									0.029,
									0.235,
									1,
									0.706,
									0,
									0.18
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-67.115,
								-3
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								85.212,
								-3
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 21,
		ty: 4,
		nm: "leg right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					182.463,
					256.443,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					39.463,
					99.443,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										74.243,
										99.443
									],
									[
										4.683,
										99.443
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 22,
		ty: 4,
		nm: "arm right",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					386.188,
					196.916,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					63.856,
					20.575,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					333.333,
					333.333,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 14,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.493,
													32.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													100.993,
													-51.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 25.111,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-19.993,
													24.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													113.493,
													-32.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 36.223,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.493,
													32.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													100.993,
													-51.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 47.334,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-19.993,
													24.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													113.493,
													-32.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 58.443,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.493,
													32.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													100.993,
													-51.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 69.557,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-19.993,
													24.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													113.493,
													-32.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 80.668,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.493,
													32.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													100.993,
													-51.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 91.777,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-19.993,
													24.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													113.493,
													-32.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 102.891,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.493,
													32.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													100.993,
													-51.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 114,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-19.993,
													24.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													113.493,
													-32.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 125,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.493,
													32.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													100.993,
													-51.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 136,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-19.993,
													24.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													113.493,
													-32.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.4,
										y: 0
									},
									t: 147,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.493,
													32.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													100.993,
													-51.382
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.5,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 157,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-19.993,
													24.882
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													113.493,
													-32.382
												]
											],
											c: false
										}
									]
								},
								{
									t: 170,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-2.758,
													-68.093
												]
											],
											o: [
												[
													20.953,
													25.311
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.22,
													-23.968
												],
												[
													81.493,
													65.118
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.949019610882,
								0.239215686917,
								0.407843142748,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 18,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 23,
		ty: 4,
		nm: "shadow",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 3,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					158.077,
					264.053,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					12.077,
					110.053,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										7.517
									],
									[
										43.448,
										0
									],
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									]
								],
								o: [
									[
										0,
										-7.517
									],
									[
										-43.448,
										0
									],
									[
										0,
										7.517
									],
									[
										43.448,
										0
									]
								],
								v: [
									[
										90.747,
										110.053
									],
									[
										12.077,
										96.443
									],
									[
										-66.593,
										110.053
									],
									[
										12.077,
										123.664
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 180,
		st: 0,
		bm: 0
	}
];
var markers$1 = [
];
var AlvaWave = {
	v: v$1,
	fr: fr$1,
	ip: ip$1,
	op: op$1,
	w: w$1,
	h: h$1,
	nm: nm$1,
	ddd: ddd$1,
	assets: assets$1,
	layers: layers$1,
	markers: markers$1
};

var CHARACTER_MAP = {
    Abbe: {
        idle: AbbeIdle,
        bored: AbbeBored,
        wave: AbbeWave,
        correct: AbbeCorrect,
        wrong: AbbeWrong,
        excited: AbbeExcited
    },
    Alfred: {
        idle: AlfredIdle,
        bored: AlfredBored,
        wave: AlfredWave,
        correct: AlfredCorrect,
        wrong: AlfredWrong,
        excited: AlfredExcited
    },
    Alva: {
        idle: AlvaIdle,
        bored: AlvaBored,
        wave: AlvaWave,
        correct: AlvaCorrect,
        wrong: AlvaWrong,
        excited: AlvaExcited
    }
};
var LottieCharacter = /** @class */ (function (_super) {
    __extends(LottieCharacter, _super);
    function LottieCharacter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.characterRef = React__default["default"].createRef();
        _this.animationItem = null;
        _this.loadCharacter = function () {
            var _a;
            clearTimeout(_this.boredTimeout);
            var _b = _this.props, characterName = _b.characterName, mood = _b.mood, changeCharacterMood = _b.changeCharacterMood, neverBored = _b.neverBored;
            (_a = _this.animationItem) === null || _a === void 0 ? void 0 : _a.destroy();
            _this.animationItem = lottie.loadAnimation({
                container: _this.characterRef.current,
                animationData: CHARACTER_MAP[characterName][mood],
                autoplay: true,
                loop: mood !== 'wrong' && mood !== 'correct',
                name: 'Character Animation',
                renderer: 'svg'
            });
            _this.animationItem.addEventListener('complete', function () {
                if (mood === 'wrong' || mood === 'correct') {
                    changeCharacterMood('idle');
                }
            });
            if (mood !== 'bored' && mood !== 'excited' && !neverBored) {
                _this.boredTimeout = setTimeout(function () { return changeCharacterMood('bored'); }, 10000);
            }
        };
        return _this;
    }
    LottieCharacter.prototype.componentDidMount = function () {
        this.loadCharacter();
    };
    LottieCharacter.prototype.componentDidUpdate = function () {
        this.loadCharacter();
    };
    LottieCharacter.prototype.componentWillUnmount = function () {
        this.props.changeCharacterMood('idle');
        clearTimeout(this.boredTimeout);
    };
    LottieCharacter.prototype.render = function () {
        var _a = this.props; _a.characterName; _a.mood; _a.changeCharacterMood; _a.neverBored; var rest = __rest(_a, ["characterName", "mood", "changeCharacterMood", "neverBored"]);
        return React__default["default"].createElement("div", __assign$1({ ref: this.characterRef }, rest));
    };
    return LottieCharacter;
}(React__default["default"].Component));

var Achievement = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwMkMyIDAwMDAwNERCIDAwMDAzQ0M4IDAwMDAzOTIxIDAwMDAwMDFBIDAwMDAwMDFBIDAwMDA3QTAyIDAwMDA3QzE2IDAwMDAwMDFBIDAwMDAwMDFBAENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDBBRTAgMDAwMDAwMDAwMDAyQjExMCAwMDAwMDAwMCAwMDAyNUMxNSAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdEZUcFD0AC7ayo4KNoAF4uQVAZOYAD9kgqAyswAHdz/99EJw7+ef6ww5+dJhz9YYYw21x3JyvG6fPWFPn/14bf+XxBh7E3LYekOWzLjsuMAKNChM6VAxN5lyKCMshykp6e3cdhYRYjggEOZowZQUnAgLMGDAwNOuTyh/3fh+/UlFI+imBeNe68AIAMECAwBHx1JtyHcnN53H8TvMebNouNAEC5k2cM5s85L82KEHH0tDGkTJjzFhQMDLxoB0V0V0w0AhZwwAIBBENIZR7QDq7fiGHIdyWczmFyF40H11zz6MMXY1yHLeeeeeeff3nnnnnnn/////6pI3G79SMP4/ksxpJZYwAP4xzyabAMnsQ5NNqe33DDD950ljD/ww3G3IdyxXp6fPWFPnr68Nv/F4gu9iblsPSHLZlt2XGAFGjRmfLgYu3ymCgjLIcpKenp7jgKYKCNZMCJM4cMsMSAQFmDBgYGlfJ5Q/7lw/fqRiMPosIg+zdeAEAGCBAYAj46ldyHclm87kYTfMibNsuNEIFSpr4Jy5py4JtUoGTpuGPJmVImNDgYGXjQfRXRXSLQCAQAYIIYQAXwf1HsvGpe/EMOQ7ks5nHFyFy0H11zz6MMXY1yHLeeeeeeff/PPPPPPP/////1SRuX36kMP4/ksxpKSkwEEPGbKor58XriC4E3hdYByBmxZZXDE4OEGMAF0kTUFlQsAN6h2GdhzyFLAgIPxsmdSQD1BlyBFUN/JgpGiCzBNM6455aL6JUJpNiMEXfUJAZLPmaYawOYijOlMLyN0iLmyAcWMuQ4pCSjSHYHVCji8mTRSKomwmU051MDg40FoEJyFHwRNIU4EOSyXRB5OKNkRnwPbiBsggkLWWy4XC4YGyKKjUP2IGMMcwfZMkWQaoRyYJk6YkuOazJvsyc3drE2PJUMiqXjVE0KxFllwjC6Ok2SWbJKqSRMWMj9D////WU1LRq61ILu6G3+upbK3Urr//I8QuM6A8JmQGAAOO8WeCxTBuSBoAKAOAYfOWwAAACwTAJAIFQOI/NgsqIkHui2IEQQEFxHpUEIVF5jNKR5TGmTg/F4StF5gbplImRzyQPqHeTRNGg6BAz6g/BBZ8zTDJA5iKM6R4XFN0iLmyAYvEEyHFISUaQ7A1EKaLxuRYpFUUgTKac64HJihnBCchR8ETNhTgI1LJDROZcUbMNcD64h6CCCQtZWLhcLhgbIoqNQ5IgYwxzB9kyRZBqgy6YJk6YkuOazJvsyc3drE2PJUMiqXjVE0KxFllwjC6Ok2NlmySqkkTFjI/Q////1lNS0autSC7u23+upbK3Urr//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHxWjQh29gAM0J2YDu7AAoPdc+Du9twk4nZwHNzXhNoaBEzFKRUQCgUc7tm7CIQWgY+MOFgSMmInxCzGih4MEjCgsRhax1PmUCbN2nOWziG18lsVrSrHsAuSJCMWvU698J5RWD6lnCxDbP4YcOma0y2AKzT4/FZ9/o8KhZnBGrmHan0dzmd6jkkVfuIOK+46CGMEAOEmhSirG4xLZG+srnYTAdeHH1oZmOpUmEgTWpFGYrKcqegpK/2aXGOspLymCJ50BAzldMC5fN3MbOp3ueVa0ooFAiGpVLr9Lqphn/56gFQBMGdxu40sp73v/lzH8cd85jjzHLLLLXctfq/Wqz1ymy7+WWGO+Y49tEXi61nUbmZPfwn0VDAoLgEBhheFpgCFAEOk0+Uk6VB8xRFQxYC0wLDMWA8wDFoytDYyEC0CACEATDgUAxgTOEERo+LgukIQAvkYaAm0R48FNxZdHiQBMGBTbkgxUOQVQSxWYT2MbBAwhhFJORJYJGoeOWG0SVE1gmSDgZ+rWdWGGfmdDTBa1nmrn7zyyy3vHBUoQnpwPzl3WHcZfjbzwp8qXHOeZgJE79We/3f83V/m+zkCXCoGJrQBlMWf/vbuf/reNKi6iJKM8f/nf/9Y7+DYKtId//4T9JKAhgeAbHwQBZVA0CBqCKHMCxFBAEGAIfGLIWGZiWmdcdGWGCm/JmGcD5kRiACYyIJMHIjKUxFhH0CgTA0NWqGDkUBRaZir7TxaqxStJQDNLcRiDJpXRPe7L5PsAhsOVBZbMGFY+14wAHMLAGksBmGXKpgwJDxdiUEQ+4MFO85MCM5YYmsiCJAhQjBhijsjmQDCgqijJ0UVHlCy5K2GCsyb5xWkoeFo0mWVP6+zNzCweEvQpeyNDBXZchyk/Yg99ulch62NOwAiQ5RNCgApBz4S8jPVKmYuw885JrU1VjCOwNDb1BGZRAlBTxGvEuSy0+kOkxPRw7NUE3YltS3u929b3jS6y1jcyu546ppTerZ0splkviMIrW8eVblrcpmqOlwhl0oLhyX1pTW1y3z9frff1vDPVWtVxkqmZIKAUBNM9BuGEzkRhAACqAyESGWoscpHRadGoQBF60tTEItea7IJgKWNiMTQF0V7tmJImmZrE1S5U2cgBzEvys3SDpZKyEhg25/ddQ5kwDl7W71ofw2BFJE6TAFRgcnmC1akle+cFCBlwdiH5q9brSTZjBIR+QdSC3TQatPRSLwzIDiAcRkKedTWZN9fErIIgj/uukVBbG///f6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACSJozYO743Cuadmgd3peJHmbLg7zjcLRp2ZBzel4HQOMHwnS/QXHQiMOwnNEKLOLRpMGAMBQUGA4WmIBImBo3GmeGGtoVga5Fh5iC0AIBmL1aPMuc3C2uoxBPeXLHPCImAEOVtkIYWNHEhcRBi1HWrRq1DSy0U0JxeowAoViZks9ZidkWZS2qmQ6eGcSBiQHEmI4QUy6Zcm/LZTEHKL6qMPfSGcyqnTDF3O3ytaty7dLE4AemIQ9DLShkCmJCQyFEEEAEcBRjlOHTx2QA0wYB3ikVhnSPz4tKMCgYv0YVRZ1tAGEQKYOCIYCUxoyvt3YQ16VRrN9X+rs5LACMHABa0WgtrsujrXZM+zlVWc2aYKgUGAicf6/jKb2Mt5Wl2WOPLtnmXfx/98/DXf/+a3xmss3v/1/2NXfxs0oSKoOB7H88pbAoC48CoyGyZI4ChgPIBgGGhcNbysCjbWjPlwWNn5iUWtt1MBeVy2L1SVpFGOQMdqbv3oDM+OWdxN32t0i8DDAQmAsbWfao6Kp4923sv7BSmv6+xTF/RvE407TVeZc7+ub/WqjxBgVgsi/+cw+PYbw5X3fyxqPurqRai7dR0AJH3E3RZav/U5XZQn4a9EpGTQV3+6yu9/n44elOPCZbr+/9jvd6y7dlzT9Df///Ko7GQZEGCIFGGYDhgFGFYeG1HlH9pBGJADhcADBIoSwL5jEA5k+BZjUExhEEtwZmskdARqJsBwyd1x6tYuKIUhFKSLYZxIRj6nlogCBiwDu4ZECZg0RiwJkWFp4KBhBQH4daYYhCQkHHQaIJCGGH5ghmdOEFM0RM0FHxgjCT9kP9sUvyzdR0wQJjaByR/hnHOtNz069mcJguk5Rzs3MO2YCEhuI1pQRNIVL0wyqDCz4BAbLZLti7WZUumRSMcAJgUDGOoecwThiANhgSdl5XegF3XgeOZhiS4X6CbKoWMihZSE/SSGzM4WO4U92lZ+Mggy4B28t4b5lvDuXP/9cx1jlj9m1R2LdzPLHLDn1GxQ/DfeY91+o3dpgacSYSWiujsZ7P/0rBAUDAIBF7i7YgEho/BHWhUYTAYjAIIDzOnAM9dA48aXUq3WlGfLyXVmj3eRFIY5p1zWF1nhlq84kw3ifVVCswMsZJ/87Qkg7M1L7jRbOGkW4hd5LXQJDx5nyzZVyn+Pa1zf/zeqz6hcO30D5fuxrUl5+Gd3GipsaWUgog+k3JnYABMSHxl2aTW/q3r8htBQcbAY6t+/P8/mOP/znMckXViSHHLmGua/WGX0Obleccz//FHekAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAluZs4Du9tyqqt5wG9TbmfhiT4Oa43ChS4oQbxJuCwAbCWCtMMGATHQ+MDuCMYxUHAJT7BwGpooUmCwEkwWLBRG5fgUIvyYFnqTLB5gKawL2zlzYXCXci60gUfs+MNBgABsXvSqNTnp2MGbGoGOjrQKkBM7borQ47WEOZhAofGiFAe2sLbRr/XiZSSDJm5iEFacjGXeltVJsw8XZtFIbvxx0WnNWpWkKVl9CEHMHAQEJjAIYQACoIEDgFCiKehdHA7kmOnZosnHjCwVOgvm6KIRcUoBhIHQANldQ9INDhVGNPFAerttH6XapstVPJMwtOIwUdBA4BMRCxwWNmXB5FQBtSTXYhTxNojouVORN4UGAUFt8poYCSmXjKaTHGcPHD0CO3AEExqcmJmVR9kD00EDtQSYRjMQEGAwRG5yjor3dVoPqa3hzOxn3tWmG2sNCVKmcYQBms8Iv+oxN3JQxbSjZgrCX5dKrlqWg7OrTR49204xNGBcrO9QWIn9ebgdtKiPohJt79ju65IFaH+DgUXzcSl/MLsMIVgxrKMeGalJOYE4mYM1ROg0IMgW001MzIOZkXKBIHzd2MR8C0oKOlQIVkDSQTN1m7omxKDDCCQGCon43QOJXpmi3rL5YFdCx0QXJ9A0SQ6ugREqUzhONT//Uyd3YvrM9UXeF+GHmAggZ5zhxIRAoLo9gwIIZS4CgFpszzeb7msVrfpLv/LTEDrW/ysYJiQFGFZy7UTSdEQCPVaC/t2G6P8zwFOAYCrwzGmdtswF0Exy0AsyA/QOFurIntYPIGF5rRMZEyGmbqWLPCAAWzL6GFhIVgVQhUSlKOw6DxkHEgVBAVFQoVROCQ0AAqXDAwqEIOMFAglASzXCDBA1xYdKgvOBBKZbJyAMwiIJQxZaqB4YBAwDkQ7DkAZ/G5vTPGoEWahCBQ1TJ4JMQAArAgcBiYIiQCDAKGAIMBIOAwOAoQCUhktUTjBQnNrh0velMlqoq1RscGQTHN8oKSThgAWGCgFDiGZQJQoFSoAkyFA3kUOCAg57HGhvK6r/PC/0GlYBLMxqUtzZYEB+pXlFPKKevUm60ArvnjIEbFhfZ/WDmF+Tv9BSi4zkmLAcAXnenLY0Eq12e/quaCwvmf7nTFCj5391hAy12iq6cplsjw/W+vC9/Oxvn/LavO5zCpDqS7/m7oPLIZDIWykC+TQarHa7miZQNXc4XCbIcTJOEwX0CTMhtNLZYDAob0ZmKnUdKRQTGUHaEsC/wZbH4hpE1mB52TUddjcyHWO4SgXFp7v9SJaWZkHFlpU7oMrv0Fq6Zp9IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJMnRPg5vrcK9LehBvGG4kOc88Duutwr+t6AGs4bineCMWGJAYCmhWudEAY8B15joYUaiIMAbr0mfI62IwdKciu91+o/5hoDJvvalXsvjkgZ6NClE4iknMtVs/vMKlj7GLiIJBFYH0maBcrz0NDdKo6dCYquVy90wzFjCHBr4jAUxTAsMAxAYuN0ocuNfZu7D/wPBMrAQOJ5sFaXK0blNi9gAAsiB1PEwDAoaDBVqXKCFhzxw1HlMwxNHUAwEsppIZbmzhL1NUwFAJpJkSyx8eIo0MQOBZayNLWWswly3ElbOnUedealSXIkBZgMCZjUWACCFPNhkelNHFM9bn8MZhS3kYMDBfDllU5lkEUzxDIOkAB0lutjZzfVlxQCxAA7DZPZHQDUiXIx53Wfe/+oimB3////H/////////////////3N8mmwU1DEF5mLRYGj2WRhpcRgAVIIY3+9zAVtSbpP1PGk97vP1iBQ0WUq7nDKd2W/y/7LZ9SaM9/VPQV+VoIEYBtsmtbzq4XcpQBHQ5VwwpLVI1GX28s8ZPHJqLT7UoMhuLy2Cofpr8Zk13O5alCqEtgrWNvKguUrtMFSnISF2opSS6m1b3nnqth9PQQXGVpy2zj3l/L+f39Y47qspRa73v8kl/XP5z99v5Wuf+VU95d63BeRwVsDgSmDszmQgbqpQgtc6j8DgLS7Kz3NsJha7Xcm85nKRIxPcp85vN1YIe1mAkVpGpjg2X5Z3dW2qOIrOIUQ6Vajcpmgr6jXdMJMQcMxkcmYu2NRMVAF5V9mSxhmDoBp8uVGfXXBxgSA7q01I+kyYKgk48y3WHAgGYKvF9wMO68jBgLVAcFZwEBzv+/aqgNC0waCskAgiGh16d3ILhhdaPQOAcMAAw9OE6hQQw5B0LAlBCgEcmaKPyyKRWbqyuItKX2YEB8ZuFGEAY091IAufC6CKQWseAjAMDTBEBQwJ7UkC4Xg5HYclr6SBnaDJdqF3MM7G7COKaDuStqc4WALY4IQD/////8sqFMPn///+X//////////////P//+huxqzEJCyY0zobzOZEFZY/SmFFqtnud7HRC/S6u6zsBEFHzv76JET0vuz2VIy+Q5frCtEGz8e+guc5KqetjJLjWj5FhX398mIMpYZOoVu02dT5+Gaa/lvLUVrXrEMrViU7IX4mLNBB8y/9fu5puwcGWTdX959pXOaymGouD6Jbz8lhGedipjzu7VS3UeN3nVqazu87/6/X/f7nUWHlV2z3+SuQd1h/6/s9ct8/nbR/ywAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACS10ToO743Czq4oAbxtuJJWJPg5rjcLSLegBvGW4igkBK9G5oTDAUHzISLTSMNTAoAkJAFBVW15B4B1GI/rdK7Rmh4iVZa3jygDDai3hm3W0u5jDypTBwHm5JahqWFfeE69TmLINEHwUCrPgu4/70xWcdtpgKEjkEdelaGrFPLVeMSBoEMfv4HApsr82ZI+tQw8HHzlktmI2CgytyG8mfFAOZ9OjgLMJBZVYcJA0HoCUBMoAiEW5a/4wCwhTCMWDQ5gShisblLzMmFQeW4MLcE8Q5jCwHBwWEgSqGRRyQUjwz8NUVrt6OOQYHIx3cKlA2WY803MTclszVG4qsIwFzD4gVuislAghCHy+mdJWbsIBQGAOrS1LWutES5IhLA0QXHOEgLZSIQJb5/////xtiHf///+f/////////////9///V3tm9yJRFO4GZRj4FHb7u5w2ABdf+PeY0xmZCsa29ZlcaLLD/0JCjEu1b1Da+Z/nf51skKuNMyvfhIJmzuYviBxm5KcN95nAeMpMaI1X1L9Jetzaadqpu9MNeltFDuTX5mhnYFmICiuD/w1lq/m0QmB4lB1rtr4ZkL1vVHSyJwAC7jwP5At+mtXc+Z0t2gu0j1txafD/Oa3l397w7vKjzoUyWLZXfx3HZ/DDn//3pBNXf/K9ewbI4T5Pm2okAjPhsEysNARgBIFWM2xQFy+Ob/LEitsctxzvJUEGfry+pDFp4W7TtOUEp6ICEE9r9xCs6cScRvZ8JFgUEutoD/2lN19KWPoy0xKM35AEAF2ojtMUHFAFCXXZ6YFMIcBUPGNq6XasYvKYEBRMJEc1yNjmwEA2QS2u8A0AV1ztcAg1lBhE5oDGklUHGGga8EstQoUBSjRaMzuZRYtBwgMGg8lACE1QIQgQxgKBgVmL0mfeN4iCZi0TmEQOm4RAv2yNRc+Iv2sBDsMuUtxowXFpgw5LzcCzUpa0RiUVhcMrvEYDMqGY0oYjCQJEgUWhHjapYw9u7/Q6JAMDAB96aJyqL4PQk0+rPWps+eVGV+y9NDTUV+9T463X9m+b///JzT4Z6m1oGK0QGjGvw2yCmiQUHGnVP/fCL75dnfzoAzNvWf6zLOz0vm7G5azy1/P31olNmoPBd+9cldBbxn30V8brxupYldaxKNvEYOjjWaSpOyeKJGQ/Y1hUZTM5QFB89Twilg9/ojLZfkqDlTGoh4ipBj1RCUYy7G5UjS4xCgf4KIzQYJnZ2eynKtjepLMblEBylBST9/e//9fhhUsyu1LGfsnv61j7od/n8/9UlnWOfa3JWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhYYlADmuNwsut6EGsZbiPNwzwOa43CwK3oQbxhuNxOMzTIRkHGHssZ3DjSZ5E2G4sgIhUzr7lczBuV0kO/2ZRSy3Y5EqSCGqdY216vK0G52bsN2AgIBEFPR/M2QohMkxKUyR7HJkUaZ0n08ZzEKBr50b8Nxd91HUQ8IjIFgANABx3vci4scyaK29XxOsXpwUAUw5di4izmvxRwQKCFOjGRgS3i7liR/kb9RuKs+MJAW4HSgeETXEx1gWXN2WSDQgGBoLKA6CAjBo0QcCBQUBSWIdXBcC7B76O7C3pd9ckWEAANGCNAk1+AItDlWB5RSvOms7K+BUmGQS2qlG0TCsZWJXH0qZMr1dc1unxl9l8UUk8+EoNYrYZi8y4r9nuv3//uWsU///dWH89440cJM2JKXLzytRqasFvlwU/P3XMhZHyf7hVLRYfhrPAVBUnqSEdkj/UWX/UwbBLKqjmOOs79umlub7LBgfU/zKnm45KpmOoI1uX7GE791SmXznLfXKzisekb9wzNVXynGZU9mo7f3K8YmlhYHBIc3Wlk5Zrvuz8tYFyz1cIg29eyhqY73qz+OEqv3IbcBM2Xcww1zf/hn9NIC6FvBJd1u/v+SOp/f//1ansqTLusbjfTp0YvACq4MCxlXxGwhQWbVOCAMzqjLrPZc7zCCDDyss2hb3cEYG/lV26dmJp/QpuIkYopCs1vqCehgEihqC6cTYQZ1mMMQ6+o3Fb6hzBVhGVKNggGesSldZ3KYah1tFrIvGKSEPEmEqrPSzSjb0DPUmA0g5Dc6IwY0Ngr90y0YZh+HjBQPYoRN4wyCpghA5gUOX9J6PMvEOPaCM4GXEAy5zIQMFAUmyxRpBMCwaCjGZWOTkhY4gMAgLQcBGiNejcegL44waOz0zKKgjHxpUTl8ozDsfuWqG9XjjgX3YAyDOPiBA9+AaFChWfMXSAAQU15JD6a/cq4xEaAKor4oD5XSMZWO3lrLv//f/WKz//////////////////95X8VevCCbW5UvkAyoOTZVx2qSOkgzQ3M+bmgvSk3KP3kW5///HNDvyjppvGJtlxw/VeTQRRUCA3Cpy7Mcou08ujTMZNev2rdNM3Y4TAkEkrYXvssmh6dzyusxt27VeHIcpI22+a03zs1mncrU01bEhU4sF16e92hq23daiBaguqmsHrng7Dl/DeGqmq2q0fhsm3I72t6///LP7rKiIsOV1s45a3rcRr///3937VySc/8KrPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIxHROg5rbcLgLegBvG24gVYc8Dmttwugt58GsabiaaU88ON8VgY06ByNsBwXTTJA8qlBJCEYzWs5TT6mDs29MUw+GBASnfpuuTF5Yn81NZAcZsNKHRUc1yiYSLJWf3yqBMjAFgBSfVRicgRvnUv3ie4QJgasd+Hoj3kDQZKUVTF7VI1h0UsvivAdCTSUhrFaJUVK/MYjy3lMy0V2TRcxkERPNgoRo9hh1QdatBkSqLajgEAB4UJz4kkSBYobKAiy6wWWSJVd5SEUG08ZABSKMsLihwTIaRGYtLo3yB41NzUNs4AIubmfLHdyH98/lnNxUaYk/RhSubgyF2XaGAYoxLtWAQEBzjhpR65+94tgQ4sEjyZK/7zwqXrny3z////Wa9P/////////////////+Z4f//q7+qtK7mcwsGYVRgZbciMOHLaxZhcXP18rEO6uUz/0ohN+eW8KyEy3R1WpZ4Ri/zL155TEIuFF1g6uOEm7qzS2n3GzTNi9lO9lG3GDgelm5+kluD7JiRXmcs9nmdycmGt4X5SzC+qGzLJ1vKXkUqwNR9BoJHJlaeoD+nZ4oEMBZygUrdBKwsmt1KuWH4287nJVDaaIEAoOxx/nef+WqsdaIRE9JNMxi1fL89PpW1n/6/d6xvKc7u9Ln+X6y2mdFnwWCpj3nmthGsZ/QqAnAnVqPnM5Y4yo0CqVTrT/+Rkg3HUh0zySZwq4voSD34DSrkEs5TgVCTCWxy9fBxDI4wK3bM/jTOXzSMn3EEYo1hOTTVLEItHVs7ZEaobDwc9j/QbFIHZgY2ouy/TywNBIyAOq0FuJCFDzAn2vxnYKLC/BVqE62nrwMLB6bFpXUxzFg1Ew08wXYlOaRJq0zUnd9tB0AL2gteTLMNIDWD8aMYCSelk9ILspxuSmmonaBgGbMCJ4z2NBjh27Uf9y6a0YsBHhF6EDX0iw6FrYvGrl1l2L15v/tYypWtLFn71tD5VUHbtjrf////5N///UP0OVves7D3g6aR42aRBWeCYgCTDNJvW8Zo1Qi2Mq/UuFF3vx/LiD8zLpuHOS16sd/gtFp8mkMpCAOKuOzhT54V5fg9JNiK63MwFBVLYdsZErjsbj0ZsV1nxjKpT4OnhehMcUEsxOKMBvJpfaycmk1Xo3jvYAw7HZaXtfrPrswEucRkjnDV8spa3A89Ywt57ypaStZl0FvoBgLeb/v5d/mOH0CYqfVFlKpDzPHmpFN81//vVLRVYJvfuzOu8cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACOF0TwOa23C9K3oQbxhuHDmHRA3nTcPRLecB3em4ZWXzl4FBYYCzBopMUeE1OTxoFGFR2ZbMJkkfmIQSWactpSXhZwxYUCiznpTJky6ckqciqIUiqrDsTe+KrjWHlrtiQqwyEsAVnw5ILxgDLT3/i7hE54KNh6E7MP9USiiW8zF34HxyfdBLc8pQxiRqyGnjQkIRiMT1FSxg1JKX9DNLK4+Qhsr+00QadnHlbEAQKy00VZAQU8rSjGQCL4SmUodShPa8aElxvEeUhojlucQX24oBNzGwZDmY7GmoMoYHvG2KBM/zvz/515qPkhIYMWuJK6DX8yyxizJrMpMPNjdTFIp/R0bGjmexrlgEuL/ZdzWuf8fZEy1hkBsX5m09Gmx//////i8n/////////////////+u5f//+r0hjTRBWxIgLAhikIEJyCQxkfGiMwoERfAIOW8TEgR0y7hZwhEGMltWgZQwRLa5jfwr32KSvCq+sXiU5LaepF2wP1FZbHlgYlfr0lNjQc5ZcNletWLs3clNaCDZiRUfK0spLk33vy7j6aw+Gk6/lUphqnbvU5Wefu8rsTWO+y7nukAXNYjmqWaY+I4Bt1xrLVUsSHeuarY2reVJ2S0rNt83rLv9/D78ENZRQkNqcnud/WNLSf///67zC7v942/rT9LvLdVnHABlpnhScmFiyKZ8Umbn4GVVb1trlTFiciZ0wM/DR6L5XX3GXmeiFNyhcF5N7EaJ6X8yeheteZmsGANCuwpnpgEAF5CKUyLOmwaJu+wgQBSyrZ7cv7nYJCiVpdJhl9yGxZ+xS/dxkT+W5q5mUAaOWt3CAzEzMEyILWXmNCJ3/tylnTRBCscSNmISjRfCfyhcjL4m0DNNEGUgIlBuC5XY3+sbHd/2y341qg/meX9/W70sqzKlZwRDn0pABVbU5dp5M7sM////1XckcPRiD/xi7U///////+n//0anLem2YCAsWAGa8YRAwYVpEYVEYNAoYdMWdSoIZBhQYQAUghBQXGLkSqQQJP4raGhRZAFDSA5QN+GUmAhctSuIQ4HEcQbgkM+zwMSZ3OSVK+260Av8MBzTW6xBzgUZCR67NA/sCLYl8ijVIh6hg6UUux5w5ewCabsGdwMAgixKpzUWMAEfKB7NBLUE/yKZdcQDpqLTREIgEUCRTKD2sT12QTLaAwRdTma84hI75A0UiZCFR4Kg8+o8OZMJMiQGgDkT1Jb3Q6woZqUabCvVwY/dw/eWu4W5fTMyHRAG0uZFmfQPV78fwrRvD/7z901eg5PYTe4cb5QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABsJh0YN6y3D6C3mwd3puG2mHRg3rLcQErecB3em4ZCUBhc93SAFWGMSujWRQwYBMJKQVFI+gkFVmKAwsutZhjL4EMjMVggN1spRUaZFI3DzF4AqQPXim21xjaY2ExYyaVRXKNohhAJVTSzDKtBd1u+pI7a6X4/D7l6I24aMBiL1bmspW6AUPl+sbtJL7W8ZKmdb5HR4xrBDove+wxgNjuuSVWhsJszwzMEkA0VvPUFTLKD2DfMEMmiMTFULx481l/MMct3EXS/l3/7///2Z3KaCg5tAPzWfVqGP7eHjxRr///+5SyeCXov/uVu5z//////db//9y6YwGAIMDYUAMDAWAQeMZyGM3gJMHg/Mol/PTFaMXBLAQCLDGAIWGrEwVEw4DaGxc4opTklEbbeuvAwIMbouhZxMfuW7aHVuEPz5fqs5Q0St0aqpvFBUMKARYNrcEmHAxgoG/UTeaUuvQQDXjJVBQcRv3UgS60Br8NwAtMEaxo2x1/4w5jqS8zId+JPykka3YGoIFkaM8/G5AzeSorv5AjIU8cpqXxpP0zwuSAIY9EiICS16kokKdDdDT2T4Qgw+qUmDlYyAMcKKmxxlGVV/OQbGFIfu3lje5+rcu5ZMaONyJgqGXDW9llqdl83RZ87/PxooHu3+8odSX5ebIBFTmBFb0NDA94xoWMMDRkNM+HjCS0zIDMduDjFcz5JHoBHy1TCQZZT9hyHH+jUvQlJeuqypoTEoyxSu/NLjTQwtG27UEv0z2xlWfsibhYkNCIxWrznWxU1dsIKfyeM8uWsHoitCAqisKT0X541zGOeaz3CQuh/OSgmRsdtl79GeysaMtORa7urhBcftnEpCpwdAi2eOcooxRIWKbQQDGzE/1yJ5/r9b59/mocGoZzL//X/+dvKadgDiwdk6bHed1S0cFv73///1F8pQ8V7+X4///////+pb//pbKAQDKwcL2mBQDBgBmCJfmPwkmI4QGCSGHUi/mRhEAErDFBwTkkCjonExITMNBBABgEiNnTiIwTvXApu4hhYiDAEaE3xL0hBunq1oss2s0hMaY0BYhiowXRL4qGL1UXEgVpr/kIAQipgZE28raqPAbPb7DnVi7XDCA5/W2jcbmMm1bE7BlMSSbyv1BlmtCAcQtYZPi+zlY43G5IOR+JPgNAHpL6v5F2ePbQdlU6sseTrBg7Pk8wgOjwN/IAsISmwmEPnCOqQesyZdCGaxp7mU9NW4coJZuAY+gzKrG94ZYa7yWWYBRvB3p55xYHt/DT1YQ5Iuf+/+5M2pmhz7Vzlz/UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAYIYdKDWaNxF+t5kHt7bhmJh0YN5o3EMC3mQd5puJW3QiDICBYcsMZdQVzlLi3hR4IQRa02fkSeIxQlrz0xUxqIPsyqpjKmdTs9ealN2JmpcpZFXhuCNdw2/E1WygkBAJHEwkcyvxzTw/WdgLBXcuUTo+zxTAAUkTQXWg4DQ4bzrUskzU+kcBYebRehgYgYGGDhzUhSI5jOWE1DSMQWTkIcBoOFEWs0SMQxUA0HIUJEgMGIDsFAzf1aakRnha1f7myJiGNgGAZeWRowU3UOhI0Jr9dklFqo3It/8kv/9GtKcwEAATAnBSZwYBYFRgTgNGAWNCLA5GDmCcYV4vRpMiuhAsRg/h/GKQxYY8IUjIzJSAlAyzq8zHPkGAdAo7BKPIOETeVhWRx1ACZGkDITCwFh6tRdIOHWaCoMYSqs5yidKIgsOOVwXGFmagBhRITBK8EtUKhgAe5grdmxLoMaI2mwU70klmSq0MpomonpMKrWcGMSyGHhLZtcm6k3TLkf6bl0aMfGVOYFWADA2PioVYdKMQHQTrIXpT0MCEEtScFUmuMCHxMJPQ4jC5e3cxINNEIDEwgdHiE3n3vlsfm71eI2XLm4xjAK9UUocxuY6xwwypHlvu0YEaiIUhm21pv8O8cOccZ+bvN9w/KNwi5Sa5Vp2zHf///VJRgCLYshJg4kATEZcMpRoGEYYZ+GigEkWZ1ngJ7VxBrauWyE53VGKeTb5bRRu4y1j17N1nw5EMtsMeWx3LBmUhrXW6AQ1eRRLBmNHPS1lVeIJVm4PSft1MVTYvA0iDiRSdjMbgCCpTSWzjyec2I0AoAyI3QDhIxgJvA6cvC6ENPJlOWBHiYGiAlcxBtMLippmRXMg+gFABLAhMCcgYEIw4ntWquaEeBYsfr/ZCWRzwLJiTQPCBEKhlioXiz/LRaKI1zVzh8iLf+Qn//11AQFRgyE5YAwGgeYCAgYiFmEKMY9ACYIuudtwUYpj6YQDYc87Ab7D4ZxEphYPCQvLzAgJGKIc0pwUda0eRWMxD9csNP+JDZuUmMNAh01xJTsFmRUEmECAr6xDtEoZCVLX6g0xwDC8gkGG6Nyii7oZXtBlCIASHBZXUti1pnbMSQDKGtnCkhxaMbfyHM2UEpdj9brqR9kzBZuMl5xAkZO/ENKXTjU1C37g1yr1FNQBPmYGogHRUPq6ArIGhjjQh4VKYqZKEdgfNCNIDCI8jdOWT+5dLrlf47KKKrDSxW1s73/fxuR+ZlVpdZH9yp39lmW9uDTwDD1bmtf92tIbjCp38Z6Bz3hH//6v///9IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHUWJPA5rTcPDMSeB3Wm4eWYk4Dmttw6kxJ4HN6bh6RYZAQEJfBgRMCgMw48TJYXMOAEw8gTshoGhwVA2YqkYNBqoHbfiQtxM1FfHOF6ru6aclWwfcrGx6w6bYItNZdZsDhcm7ndnmgWtQ2Jjl1FGlbF2QFUD0vjNtzICotnVdepM8clHpx0TUtV+5WrnLL0maOKxXrVWULDw7QUsNBQjLJhmZQeaOauyhlDsXbrlyaoYwttWYxqCBIi2pQh/PFRaKGBKG7LoAguYMUPVDUjFrv/3LlXG98RBxyl7//3//7PJKpaXoxrqoKRsb2OgbtV2N9///WFm8qnP/MUcDc//////9s///78m3UCgaYKAE8AkAqBYNXMwWAktsYRh4cOgqYUggMiMZSWwZVhoZAans2s48B/HyF9WLUtaONwisqbE8zGINU0TuznnspUc2AW+R3OCF2w9IFlm3JBYOTPG6R2HILvrC4QaOBx9u39NnllQNekDPzG81c9q156ZiIcAV9d3VpFx2pXEoLLf55LLHo7pmpippP65aP9rc1QU4sdbgbdk0joKKMc5J6FibcETyzKnBCWKpkiSwZMayz1hlvDO68UGg4hLe6/e+f9iQ5SoLFTFFIdyaMjDzeIyFq0Lwa3//9z7N5WV5/oL738//////65///78mQAkFD1NVJFuSKwQrA7vmBwEYETB0xumFAEyc08fCiBLgcOTYrDDHBf1K0zHr/G2K2Z5upQjp5bD8Sc7TZ8l6hB2D8bFd/FCKWNLxOwaIDJOMVmicgLwNCCAViNu6apJcsQ7ubjrI6kAg6QL55V5jsqgEHNyTGde1VEAG59WZgQwsEguGkOZjgA64GvTFAGRMAGgKewu0Ceic08KJMOwKYCZlYde5GWfJirfOFEl3I/GOCcJxklbCr3fLuXN0KnQMB5VvX9/v6+/9xXAkazs+VQJRibwvq8alMOXh/6//i0LlSyWP8gyvIL3/////+2O///9LRTAwBbxQxPYtGY4d5ocAjxQMCLcxm2gKHTDgIOoxo34Dh4nR8Uvm2qHAjCBKLxynqy9BmpeSml8PyCWKOQtsNe4kAXrtbiWU5Owq87IdEDouTFkBSilfjJxtx14DSCJ1dWa27y5ZRTGioKi1Zr28ILMKUfj9ynisNNGpOz1KrcqQ4mMCQWbgKHEY1IUDq9qS3lg0N4bMszdWFmPMvrfuUa1IATyDAChCwRhFKltqKd5rvd6w7cuSQFAZy//467+q9PlTOAEoWoZvgoxS9vqec6y6eP///89P2n9U/9BdjHP/////9ub/v//SAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABqtiUAOa03EFDEmQe3puGtGJPg5qjcPPMOZB3em4lhQDGsrPZQFwAYyXQZJsBQPGeB+xAUCJieYmKAWy6Uw9MOGZ6vA85dy3OmPCX6soVdBOn5rPnVi3q+Qa1u7psCnFqWqpGTPiE+PMYKjNGuacUj2AEbxGjmrO88bEqt1TPg6DPG5hnEgYdlOtUvEO2X6nU4ZZTuyIwqwBo7hMKplp1N7/kw51sGnIPzMQLdfHO3WijCUwmGqymEEt/bsfrWsNfr/wwIhU/h//v//K1jsZAGPCy7aTi4NdyGQlJ2GO///++2q7MHO+g+n5//////7zf//9MZT0TJLyKLQCYJIVxhYARGBOAYYOoOhongjhAdZgFBHGCymcYF4PgjCUyFSppwIeiqDxI38fsyh4wctPtkOB5QbwF5dRgMgh+MWkuBY6k9FHqsaT7dx5pYYoFiAFKDySIfyARgT5I4uqzoABAyJPHFIpYbpKVG3dLzGOyI/RaK7hyZnTAD0D7mMHXGSsWkr5O4ofnMwYkU8YOHNTp51Fu7OyucEYAzwOKGKLMObQ0Lter0QTEXpcIZiiEUXHZKICizKSNW6bHsW3VmcI68K8wcGo6Lfc+/+qKTS5fRVLgA9Ny6emq17BsNmIwTzf8/97nqy2bP1LcS///////V7/f//////yMNJhs1SoWWIgQI6UQhpRkwGHDTIfTOU3NLD0Ob6WDbyicdIsaKlmaz0+xigfOydWuUWl/UL3XIE2oKjvYww5AyhNDLFHzGoBRiRGYIfWQqz4qF2I28ppUmrNlzpPEIgUQNIYD6pFQ4ssjVAwA4b7J3E3lw6oXQrVMxDyhYIRMBPkQEIKOSMhpSTJQdITCkgkF7hAxdRKyZSBoZAayDlBnYBQkODMzzIorXqpoFwLhLr+tBBZgK+BmwA7zwQBA8xgiXQv+NlMibflU0YNcTzlhia/+OH//9NMpmoGu12wAAJiiYYKe0xQB0wIZcxHfQCg+JCqcIpyCs9DGsWDGdrLVTOe0yITmL8UpnoHiVmtKh3KCp48gqBt33BMzgkUEGNHLJfiIxVOKdh6sCi4AiZMQyhF+AUl6ISCoYbou4MdEgI9K5TI5AzJ34DN6PFjEjrX7EdjZgFjZ52UTMwVREvlE5WLaRpwvJlEdAgOizcNxq2ExSRp0IbEpbTIDM0dHg8OV3fVyvEwccohpDJuDgIiGQxJMscL8ZoZ6r2y+6yTHAJTZ1lrvcsK9ftMyg6gFvLU4nBX+5ANHcgj////6uuvDP8uZy3f//////z4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAYYYdADmqNxBAw5gHuabhnZhzwN5o3EJLDlwd5tuIDRsblTtLTQMapoDRhoojFJkkfMPIQYYHhghBEF2M6Z2TKwXVtY95Ml/u2uNSlWL2wbPfCdOU0yjsbxGR7i44ywBUSRO6tqHdyGjaBX6/ZuAbm3OJopjLGhqBnU5HoU01GILCydoKNhSBdk6ZhpbHB9gWCl4DSMgxSRIjQ3g861j7Js1IgboiAIky2L5uSYkQMFDlhMGJxDgyzsqylqZazQQqh99FFIyEhAsYKpsGjDROsdDkSuxV/zU4KGJBziDP/5Fl5gQAdrDjIgEoEJALqYAgHpgAAGiQdBpIAwmEQA4YFIPZiZI1mE2DqYQDQQB1SMlAoAMkzBBx14nIaB00arV1LUeG0mjRgoAZyew991BCYZB0HQXUlKQo0J3CkdUmDhIJx4G0yMqo0QWpkwUlrYH3MMiOUyKHqV94yy6BEtTZE1AZ6hpsYKpiauv2alkPyhMhTiEwy/QyFgSC4oXLpgaMl/FKXcsWojfaMsK7IlllD/IIiZG12B5anIqoY7Cc5clKuNPUeKO9PS2vc5HML1PbuPCkYKB38xr5frLXKaRXoZCpgx5N+tocCgZllNMgntvvv///+7JuUUH8udo+//////6lnobghQo7dSqQEmj254AC0sCC53BQhomKcSsi2is+EVazjH5QpK9Tb/oWBxqRVRGS4Qpuv0lPxwWqYUtmSkEKr79K0oBzju6B8TZTaaNQMnzwJRz9Pb6W4UDMPZLYzwHGWB2jV1F0rmwAxUrHnnwv+QU8XB0iChQTH8Fh5MAHfgbFEVF4Ja7IG5cG4UAvAqFIEJgnjNjMfRQPBYmXQgOjqBwIs0Op1Mp5OBYsb1v9zdliWABDS4sRkKo+kZBiwenIN/MjdMmhvOcQPn//HJ//+p5FTF61bkEgQC5jQkZoqB5jaGRhq9hrzJpgeDRhCHRvphhteGwcVUsoCiRIDzINTCwBa1yc7SuLLo8QAUmE7CqphkAsoW+30GUzaGBhW+7r2o8FBQLE5VSH1OiADgwfutPoYpBCIGPgTDZ9VskomMTgxvpFG49XpUV5QisKiYsLvG2TUgiS5DHgWpDVmbgFC9KFlcUYMChp7oZaWAAJhYXM1+Ys7QNsVJVGZoeI3oDlqCnXEBAiVqXTTCVoGLEZ2AO10VASwEjwK/kmvVbWVeVyuLWpTdTTAT9dvfjvD9bw1jZh408AafSOUPEN23WUygTsYyy7v9flS9Z5Ct3NzmX/////+pf6f/1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGzGHOg5rTcQIsOYB7e24bJYk4DmtNw8at5gHd7bh0gUQ2WOo+hADx3GmCg+XKICIYyK5eQhC5kyfmHQemg+8OSh/Aksohfu2uYFqu2YGSypc3dgH7jnZvs1+WzM1Kk4SI/LaZVECFgQlIm77tJytzjqbrpiGHQSmB72s6qbXX0G3aTFLZrWLLogElasVt4pgvnUoK7d6R9Wql0GimogpmyZ9yIdR4Z8iTEZohFyLBwk8M73IdZwpgBkznjB8SFJR3af8tbx1lrWda6UAPy/+f/71l+LWihvIrzVG9y/TApBjDP/////Iqr1tm7cw/v/////+oK//+qXGAKAGxpRRiKHxgkBDGFWA4YBQABgug+mgWGcYOYD5gaApGMCY0YfwJRioqXYTHZGCQA5raBQ84sPxXOhadSUgyCkw1DcMiQ4+zFnhU4ur2ISbUjlr4BciWsyCQNHDh4hJSIHed2XnQWbMJDktWISgQdOtwldM/eToPY/z+GHPyFD5yqk5SLzHQyAKkPxmViAXlr9N67JdSCcKULAMEGEEDK6Z3WbZWI/nHkUo8ZMAwfPpaP9fk8Py8aDio1HRByRSKoFG0zZydl9JzOxlKN9szSRoCPIFta1/cNfZoq1wlC1Es8mqLd191HezHpHv/7/6qX/aJrO5zP///////sf//WWACzB+2fvUFQCZYmJs8Fl1ACDDfIXQ3EYENAOYzWAEfY1VlTdzhP17ztHfylwYJ+eaojFJL7vVOUMNbeR6bPco8OJCYFDsrZAaAqFipFfZG5L3sjsuvK6RBMaoXDFPunry9Vektneil63s3vPJsCW7i9rZYMic6rZp5yaoplG1sgFhQ3Gm4qAVb/53WrygUJRinfZFm1YtvHBQOFiQOaVKJMkYqsB9y/DuWN/WNPSOHa7r///7he/SjpYAV8oMg7nNrbkNNHu////1ansLhP3MN9//////3BfE7yAHWnsoZCMAIQrIYCAYYsBWYgLmcWNEYWAiFhBM/cVM7g9MLDE5YaiD8njqpQYwt/L3KBkkHaRlIheAayUURfOOPrL1NRUVfLKmlCHJfyqj5TQOTEPxYfkr8Ijkoi7ocNyiwss1slSSiNNGYJghKp8mCmax63X7ff5TnFDGQ1taa3TSNxFJwDDMNrxiudOjtDxMZphVYWxW7qxOqp0M6ZCGM1kgJHGg5Z14ZkAVgjOUEMB0AgjFaWFwxWmrWu1aOpXmLTPAsCyzees9a5q7drWpQHLDy22xMUs2tQmFzcC5Y///rlrcqk3ddqfL+j//zIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABqhiTgN6o3DuC4mAd3tuGpGJOA5qjcP+LiWB3m24WyIAJUbWmIoAjXqoF6Q0SiiSI0gdAwsHG8+xpQMruGI3L2AGZtOhVkG9TKOXIw0hQqnswc8FuCWgbU3ZVUmsaQKhJqZ+jIt0XKLbZYZZu6ttplh2VEyIFD2Oky8gOYS4lwG7/CdCZMi+bmpDwMEBGEZoInw9AuE+RAa5PFgnBZ4DQovgJNhvyJwERUtWOmRWMwBR47TgJjQ4E+TCA8CzgtZAxxgkgHEgMiMC4xZLN22SRUgxwZh+31qPlUETUlkiUEMqjOlcxKf9i0sRFc5f/5MP///pfUYAFEuNWVoGGKHExqAoSzEAzD15HTF4GDDMKTYBszREJx40QrUsYAXTO+URonij7yC3UfuV0yaI0FPBPtxYXJ48zeeY0DADPlLCBkIWg1xmrlGQjoqOkw3dgEeAk+HzBQhyBiEeMAVGUwVErWN5D2LMqNuWB4WpaaUO/OuAGKL52LcSoE7n7j72w8pF/32bgPCLYzCh1itZ+Wb8+hlaerhTRkQrPuaw1UNevQxRsBhpgduLFAszAcFVf18eZ85vOry7qkoy5XNf/O8/79qzBJCACoflbfCA8stI7YVYtv9f/6z58lhH6+r/3f//6Y6FwI/UYbmMg4wNnDIoYWSngbmA6ZhUBZj+GmOgKzqMy6w2ER03Jppfl2aTRvytgStUd7L3wi8kZrxZsfs1KtCKj5f2sskzgxNwmlQTMMeTe4x6ghLBC324/fcxJ8eiqIQhPSHSkWQKZRRLIGBEECTSWTQauHk6WiAA4CeJwhoKCCiFlBdh/AbnpLMVjdJg6GCCJlMEgqZYKCxZ0EyQAXkVgGqQBcwGnkyfP1LpoukgkkHrn16XufRKIfkF00llgPrqGcKzHP1KNVimj3OUW/8+3//+iXCgBNEno6pExZIsFMoY5hYY2sce+taYvgwYAC0Yve4ZNi4W1aVALvBYCGt4ECgY78BVcJsMCkqpWRlYJgd/C5CwMag1AnHUazAIFfqpQugFw6EAhmzFECx0iAwIkRW+MvgIwxApg8CyV5DA4MMtGFEWLSR6qB0iUClqYByInOyrccfGkWWYWCONKZ2GHgHBJNV8YkqshOac/6fxfuWBVChunZ0yCfzpM2UMRmjOzCUcEgNelXB4k30Oxg6ecGMF+iqHBYNKBuMv7erdvzvMbXcYYSNLe0u7Ws+463hSbpZaERTU9qyNeqY4pzwm3Ke///+7XONHg78NU3/Z7//06AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAadYc2DmctxAEt5YHebbhq1hzQOZy3D/7Elgd5puJampuXt3BAKMo2Y10GB4VgElGLyiIwAWrNHIUDMNVjzxSUx44PE4tzH/ECqF3JRRWqUWmYNEZvHlr6VczmN3cJWgFSalFdhAgfQmE5zY3gZsqvCVeVmwNaAUjTbdbduPxW5TGpgLFRXl2ktWkAa4Zjs3dWBnJ6o8RdOG5nABByVb0jycst9P8qXU/5XVS6jGaHdv+aoZAp2OKLKauCWgJBLsabL8+5ax7lzFsaiW9d////1rGrfEppPx8GOd/TxWJq/z///+1P/ALn/c33n//////zNAIACjjyt8DAHMJ2jAymjw8mHaonubfGMYQmHQAG3o0AKpAgniQIUvdIVApjCbt1gpctJjMDwvltCzlQp0ZkDBdVGnaOwTxoCiIAYSaWz46I5XD7ipOGQCOhzJg88bLFJhUBp4GBgVbgdBAZfGyLdd9pmJxlReJKpHCDqkoZg6QvbEYShxpZDSVa4FA0gWzvY9WD5vQkoEDEEmHmK6qrBVz4UtWgvx9jZixjJGdGAAjFKD3acMeAjChE2peAAGFQBEkiM2w0m69zG1M4bzpJQopOyOpzu9c/dmdvx4YEzEgp1ZpRydr62pjL6SGv/nP/euep3T/3dE/yvo//v///+LL6TvfqTLfEgCZ9Q5GYUWzA4bOEkgeB4wFABVDCoQgm5nD9Ee4JMBas28JOIA9QI4CjMuyZm7SjL7pnXxYFlm5fTUwwkRF1pUtM9VkQiM6C1tUScs8l3TNVbYCuw9SzGNPEGvTc6Vrp0VvleEbjgAD3y/ndl1yln2ZqPQ3VbCMhStUlXN5SJyz2p7PYMmU6JNQMURKwzs3oBKrwvm274GIkkBMSrPmsseb1nzrKB52c7zX6/f42fyT1UElvWxTOHPgOiylvf///fz2UQav9zfP//////+gbsFwGY66bMBGCZhoo5jeGJiwD5jolJ+omxjgA5gqJpjZqINEkvYsd1HcGQEZYiAKBT+qiu5SooIL3zSSqzpJLAgSNFc6cJgY9QGASLby1bGi7qeyhr8MLM6h4KgMeC/H0JgkIgOq8CgOV06xgMxUDHonpxos5BTpp+H5rM4U+ua3YjEBgg1DtHLevuFhM9H5JZbs7NwZAF/cAxQ+sYa0sq7O2ZFDg0HcoVMQNIwgOlhKqjZYBa8rw0z1FQEjQUMJmbx00KjueW8vsZ3Ma6+YH3bw/fN6yu1L8+EVXtp19XamOlFJdHoz////q9rN4YX++2+///////W/2///+7//NgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGImHNg5mbcP2sSWB3em4a9WUyDmstw7Qt5cHd6bhsSTbwMxXwKBEw7nTOwfTYAhHMzFpS1WgFPMoViz4RTymCTiZZfLNazsFxr8jXcp+S7Z5DbHnhZJiXic6inuzBKs81qLR0XsHCCjKPqyT7MJ5JCkrqqAiLLmSZsZE2smQCoifWmJkssg0Uka2TFIkTKZobhzTA4SoX9MA1WksUkGXzJ1TUTiOoWSTigQoIVMwQUTw7gNNBXQ3IaoC4hSJpBJ0UqlHVIi1A2LPo/1rdRkCgS0w1B3I4+U3Of0UIuiSqpf/M3QQBIwTzaDwFmNAbGj4AmIIEGDC8HNDsmHgMAYSjVxKANGQYUJ9uwkskadXPixS2yFmqlQyUOk1RJdq8NywmKtqTTuVhfoUES1rvXIXgMgSEJfWLOyLfCCpEZxtRRGoGCjLwQEQ1AQCCzZ0kmAmOOVCI1LG5v6uc4Fda8Wd/K5CLJhQL8UVJX6xtOp2JxsKDsFMhQ6JrN2MaISzjEOCQWzTX9Rx/rq0p1hYUGqhvRZ6VMEHzGjz+lEBxUKiMwPApuL1KmVem3yxnTRiQRp89YfrPn42rWMRTuL3xLFfEN39cnqJ95R/f//1b7uYg//zqf//////9L/v///3//9TgIwNMU3WgCQyZa65tMWoJDBQ0N+F0MDAjCZiykmAQewB25ZMrSMbMa1Sy/tWXGQD0eKTitUstKKsbVqjhQFiIMAqz363cBGOaZGJtN40J8ZID09u7MneYdCS7edM5ZrkMMSikxlMbgqG6wXHURkc/K84tHjBHb29qN5JTWqfdpNme6zMOeqhwl7rwl0qO7YvOg0PJGq3VdCit8u9pjIsBAbIkXxQNXscrWb363lzLe6jZQcFP4Za////y562nDuaeKX9y1GKOhu/////ui4z48eO/Oe///rvMpWBfZooqBRg4kBjqEhhOCRi6WR7WVIsYRgwFRlnHBjAFQBCVSNfjFk6QBIiqQID7ErjRhhK39dpL3Qi0HCrI085ULB+QoFIMRKIV6UCjavVAZWvI1EpZkLE9Oh48xcpighBbromCBRi6ww+kqSqIT0MQ9HDGvln/FsIrIGvsMs3s92hEIeZ/4u7wkLd+C4cSggklGyOKsiV/rLlLAbQM05bMPEo9odfshe92wZLNaSdNGEwJ53rL//dzsVb3b9bLrVCYBP6z/f//NYf2QA4d3CalVf+R3GUyvX///+XNPha/+3flvR//7f///qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAABqdZzIOay3D6a3lQd3puGw3dMg5qjcP3LiVB7m24R2iq3bSrBoDGhhMNopDwClY12d040ejPCODF8xWfsQExsAzWo2IhnUjJiTk5OpaMeptLBJLqctgUDmiEIjtTZ54vGoT3ST5j0AoWJrUfa83ie9KXI5LyQiLT2LyDGzNzEvnoCAnisD9z8N37fSgmL3frUkXkNmNOWoA/tK8ZQDRF6oCwtvzexm6RDo0x9wsC918ZAfKmsZuwxAw7DbAg0gNChNPVu3tc/nO67hqMlZVF3ev/9/hreEYWtb3AT59/T4axy/////WOnqolEfq///7P///Qvp3C9ahiK4IBAxFXozKCYxUCMVac11g4wZCEwOBs0RgczsBsw8CabF4WFgQ7PEBRY18s5bpIEMLULlRwY0yJ+AURFQJW8omHBWI6Jpvw7OS18RlfCCNVNexUDTFloQgo8nPGKi0NlUlg0YFH5UwJgM1BLQMwnJyNTr90k0ZBu/j90csuySBQglHJX8bzEYJRCRRWBn9Ws/S8nMxMEQh2mlLXq9JjgnqlfAQoKqRZoCWU/aYYt5lwg3nGfDRQEIhCyREiEvq4c1Uv4WI9astaLRvdrHf//Pq71lcDhNPjJXlw/5u/HJV////ucx03ax+u03yvr//9n//+uiIg4JKExZNERhYxt1jUooCAKBRua/IhgUAiAEGT3kYqAyt76SukZUaRM+cmkvM4eCzOfh5HZznrsNxJQL9RMeJT5VAwDDmdvqjioI5RyYBaQpGHmzxv1FWmweW7oHLkIKKNOyrGyiLE0xEAMy9DSbF9aRiGKiTJ5ZumNkzIeaFIMQsUSdAkHImAIHGRNR9i2IqOkoIRCfVg1FDJD7DURsGaBTLY4AbzAHbyyDQSZipuU92SdC6CAlgeig7X/UcIuNF0CMKCVj5UOJf1OsyJapTf/T///////PZr6V1HXKQ1MGEDgw8gCTAIAdMHAGk0TARhIPwwLwIzEWHzMLkCcMDCu2cKNBQGmRo2hLdAqAPVdQIQEGGbj42Vg3dAQJIAjPKoiQA4SghgbtthlU+YQCpEYur/EAAMfE0wAChYzqnIQUmsHAFSRVA8keAQh0y2FMHkgTGXwSuWOP+Y2gNlsP5J3+kLbKHyCkf25nNoWRxd7xIaLDR5hzLJgwMQba9Fka6OxYo2cs8dgLgbOYZRDQuzj+apExlDhdBGgAAhxhQUNDMqj1+exp69rCrreSqoNAIH3n/Mf/f9zzZU1+e7AS17+vorc1vv///rncbdFn+p3/nPf//yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABwJ3TAO6o3EAK3lAd5puGw1pLg5rTcPorOVB3e24XyYAAK0lgS+wYDRijChlwFRYAkECOZ+CsiwWADMVThARMqmjNqGoJDOzVpe/3bDihaJWiqDEilnsOIQc0wlFT0QJdO1L+3bThfyq1Q1YMK1BYNDbH7ST0nHA0OvwtgHP4OoH8Olgh46RyxlgNkQC0oc1RNoHDcQhPpk2YGAs4+cIkM0KCIuXhdhfAioFSg0o5gm903MBXgRAzMGg0zIcFtCQLiiAEeLkAStAcwEeCEoBIIc5EppLU6KVNNSBsFCZsipf+7j2XlkoRE0ROjXmS/7n1pktUo//9D/v/////UepBQA3WhthRYBEwrYUxeB8x1CYwdcwwziMKhUIQmMpqKMpwuMBAFXT8rlJAcZOogGAzogECW6VkJg4NJdcZ2zRrr7MiLAVZo4A8NXJV+jNZxn1pCImEQbZw/T5mew0IDILFKJioCDA4VRkwgVBUjUrf4zkIlCaFwZNPyGHrKWhnMJd+WNtMQN72hgly6sy2rbio2chiLs8LwM6dNHRXNcdMr06VAqHCQUtLEp0iiuwl7qOgQkiVTQ2slEAcAhaobJK14GixIYNHH2eqXZyycltm7e/GVpKFFiQZWMd77lv9Waq5BYtFOOmlFnzBonNSb+f//q/rbx3tXfv/T5T//q9abxcRkzTImPAw1GSBN0CxHLBSNaFcAA4Cgcz0zTKIFWZD8YZ4+ZtpaiM4zXmTTjQx21tr6pnivMFR1bM1geayZthgDI5ZQzKCOOxKUIeg0oS5GCVHPeRn84MBYYuEIAmuNck8htXYwtKkYEb8ZSPvD2dikjkB56tWaXJrtiLVIJkUug9AXGAaXiE676pv1Xnn+d6SCAxLoKTXZrjyXupPhZ6fICsKIAQBFKcVuV+8x5zvdcuN1Uqxw73/5///4uiyTHkuw7+5y/dvf////zLCP0XvZ8/7v/+QaM12kkdQhAEwaYEHEGSAkYug6f8jYEHOYVAIaHnoZiAQNDycDJ13gYBOtwx4hfoICflESBx08swqq3islCiUOBpEKIvML6UALbwK/1eVGAjCW7SHeJAkygMIEYeAoNLzCw6YKCpQIcXoTQFRMyBHd2HYrUlT7uZMsIJUoeA84ezp78GhUiVBDdHGYPEAK977N8+4YHw1AspYBJxADMlsuAHBMttVJI+KCeoAQKKwwIQaAp6G2ktaX4MgJ1YiEAQWExwJKAR2KfGpjja3WtXa2LvGRhsLx7+se9/fb808sFRXBbL7XseROzN97///77zUE5rQ7yvo//6ndAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAa7WcuDustw5GtZYHN6bhsdZy4O6y3D7i2lAd3tuFsKgfaDVDgYDJi7CpnwE5gWABgWFRpSBIYBwwBBhUhRheBDkxrOYhgwvBel1j1+rCTXJmpZKHZwHIU82yr9KoBDPNW8UCYVb1CKC1Y4lchgO0hbkHPHocpoL6xkGgoZZ60w1I97Ih9iM0K+6K8cC7ZXdz7lIZHH56Zs3MWZ5PBagOBqJ535RuixgES25IE+cO1scJ+8AT31kSVjyUu31jDVgssdwKzEQlh1GKSY/v6/DVbWF/AeVvf//////+o3FaXcsotc94vr2v////xw1BeMf8p///q9FMmS2j/zrEzHxNB0TMpBMxROzm1oMLBkQhUwD1TEAbieU46LTjtgYiIntGgLLOsY4JyKYTvfJ37AOCVDSgdd4mG55CtlvJ6zH0Z5WkZPrwMgASVCgKfac3cLC7jodmGNDXaZ6MJRSedwsxN7rMbNTdUlAj/SmmlzcDKuV602VPVTIY84UNvSYAFyVNKIhrooP8yfZl9NuVWHoZlNkAu7JGeNN3HaVv2sGRln1bOS6ojBubZq8tYavcr/rPi+SwWodb/+4b/8tZq6ffvWiwnL/gHPG3/////P7u/90v8t6f//f///qQ7MelkNqqCEITDqSTHsNQgKBALJjONSH5bQxzFYOKRV7yS+XQyZnm5NROC7Uh8DZ2rUrSMojbVgjq4HfK0suLgAoXB1vdOuR54vDjtGpFmHkCYhQxYaI40wOA8mwoSEKRzH7tWrEWdDPRx5O7AdF2SyCogIcjKclMufiF5vzJUgcKeKl2XcFhm+nW5K/tfN3G7jTF0uhAz6pRMUlGXHhfgEQGKi6ClZYJgXPXefYwyu6/DGIJF3+a/v9///Xuw7OfWeV+73K+VN7////7e3BttSv/T//////0rwaXAz5vIXKMSlOHmuLPmLRSH9CCgY3CgVzRACiJowMOJJssXyige7fCR5A5EIZ0iwJjZFhRqLwcvHMxUAQmFBgxkv1Jx4BbNcyvR4wAMUXYA5rbgq3CrUNEjdkM18AAUTrRlS8jAFFjdgKOP5IH6lsJTBfpSo0SIKA5irzQ3ADC2MGSD5ETzkbpZYMhmUCv2tocDWlX4minKxIUf3tGNCdH96HG5IivCSkD+SwqgQ8CZ4we6rZTFns2gCCBGVKVvrZmKazzC5lvXal9rBmwK5l/DV3Xe719LHV4FAdI83psb5lBFqYqb////x/8r/3dnPt85/////+sK3iwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAG/1pLA5rTcPsrWUB3m24cVXEqDu9Nw6WtJUHeabhPwAg5Zr3K8AwXNVL88ODR4aAIWnOgmDhKIwOMxkwICbkvpL0aOpeQukCC+pW+BpCLb4qHdbJOJdvQ5pUCioC2guJAXvptcQYTrm5Ch+YBUHAiNgtiHoo1SohVRVgKCNYVlk/KKuVMzaWJ7iPO6z6wzS19s7AKd37l6K3mnSylh+lQepXQcMSHS8UKtRlsymdnYrWFkgIvmYMc2aKlnZbZ3DD0pgBVId8Mn2miWA7T9WM9b/Ws693fI2PDpfzP//+//cqleKT+n2ntfyd7Wuf///71j8zR+w7///////9HLraIAOi0ebKVQSMA2KBoUGLoNGJ6yHMLJmIYLGBANGKcIGCwSFu10O+quMgkz5NwgRsoDgPUl8SJRXF+qyyFVSnMIAscDQ8FUnxICQyBgUtiHIavwEnkXcTqZYtkyIMgIWAg+LwSlIhABQolgIQBmy4Ggkw0BUtJZJ4CtSgvtIEVTXRciBZWy6acuXQgALilzxy7KeUCKwCGnEaWYCLYvu4ZZyCzFQpi1pR9ANL+SupK1rNIMEEU4bojE0mco72Wl3zGBg5YHUJgNY3aemvYat16S7a+5MqOEx/Qd7rnO73z9aUxTauVmjw7lnm+163V1lz//Xdaxv/dAv/odMwCAVM1XScpgOEBkZHxrKFzBhCPxgUWscJgDBSCFBnpgQ/GI40w4EPKAWVoyZ0nTCT6HLKWmEbkI0CKNShkIk2S1OkGgkkxma5btlyuX1TIM+LS7pFkIFM5VA19+RYBg6LFwzGxhj0Zg69PSlVPKBjSdEDpdSwTOuzSGIKIXyykt0jeQ1TvXiGBYrNvWRFIIBBZrNaUvxvWpW8AqEeEEH6GqpVLLM80qq9DMzKEC4r9vGoXN44fhlnX32bx9wVcWcN/v//X46yac2mW6Ccx/U192r////+HcsKP/5a/7vd//1S9QyBIousswYoj4ZtAoJAqYZmOdgpACiPBQUmXJigZKUYpBH02yUFGDpQVQA6KVEpqQcYCFlFSshwaVYMCgAqBpRiWEwRsjQJXfZluuKYJGtCd1RYqD0wCJhJILIh9TUZCbyKYyV+21HoWLAuTQ/dh+VqKxuZNsbc+Kv9Bj0zSXRhzKtHb1aqKiWSwQ/EfAQ3CAYYCDLIRxepZeaKPFal3HOHk8+kR6OXmkwLNWbr10AFjG3WoXMOblyj33uOFS3+XN1G6orWdcy5//+8+zV8iAybOMtT5zGbvUOH////5cz5f8F3/+///lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABvd3ywO6o3D+bulAd5VuG3HdLA5ujcNzrOVBzem4cFcr7swS3EQUGFc5GLAhF2w4JzRUFCYKyABDBM7goASy4hT1mRnmfpBxRQ3DN5wY5najYut1iyUTdnnKgIDCYwvZNGHc9waKA2hx+ywMPhGJUjYVQxrJEFbrDy/sV5lUCIwcrj/SGIC0C+J8XKBrw4FhpNl06ojiHgLnh4IkbplsMhFgpm44w3smSAkFBuMjAJCxbkz4sKi8aqJMBgCSAIQxgToQjSJm6Q/mopAEAwDqCSJDNhY0N9ZqtlV6K2OmgKBdBvqzouQNAZyya8xrV/5w/W3/7/9/////6zb00QTEH8iLOgQAZiWeZm0DZh0D5ikip24nhikBJgmCJkYzpiyCYMADc3AlJICTU8dBQpbkgXc295hEf7mGFytNuPlrSEMQak8XZuAoJQzIoYp8AqCYXBriDoDMkkQOBZMxEPM23LSqvUeeN1xCFjIAmdyQ+T41zYVoUQ9MFDkF/hlRnSUMiHitAs6F7yyalgnQviI2PDWIwA0FFYdRMAsMhcwGEBgKaOIgo0zQ2KKQtAaEL0BQKkePsJBkgZFTFxSYdUAgXAatBgUBwe2MiRIvGijVNFNI3LtEwKoLBEeHajWmzupQkQcSkxmNJGsjUyYK/9BNEwP12/+3/V/////n4gHAFb7XFLwEEDTMIOwA4VApAYzJyMghlJlEkjyJZdZv1k9DQ4BUE2ilX9yRwul1ZwsX8i75WoUocHGc8oLL5W/daGjABpFZhLnpemwDxKyhxTBDAV2yx/l+txf1Bkw0MYLPUp8ujiIMSAkYCikQFYzMkToywFUZAUi2XyuJvIiOQNYiZACGmwfiDeYWeAAJIKVhyTlalk6CIGTQDhYzRQCxAUY1TMyGChwQjgMudD5hsA3SPFRN0FnVJPTolwMLn0V/z9QpAPVSWUxvrzmn/d5zX//R//////+s0oFFYaibMBUGmBJ2Y1EYCJRhZ2H/pqYoBBgMAGfIoZrABZVtoqzFMI9B6FjpxUHquT2GOGGVhZeDWItAwjAmht2Ihe2FhNSjC7RxNBCy+HZauQ3YHGDErTlHGkvsOCTrJ2tjlBasUNYpesV4cl8ZkEZOAEeaOz1a/QS8yTaMSbKl6/D5xt/6BK3TrVA4xZEoal0tnm8r4b64Vmwvit1PRm8Zpn/cFXY6LNCckqb6djyVabfe/ljhljljBTAcP5///71rep4aHV+XIH//sX63P/////uqDqx/0+j//3dAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAcId8sDm6Nw4sspQHd6bhy53SoO7o3DxCzkwc5puGtFvIelaxjAARM65E5QHysCmAAIbsAIKCAjAZiZagYJxCvUehP0CTrE6QvzhbdowUjltNGJQzKMRCZeZRcIKqdk0Cz1afiQJQA4QibfkIQYKjiJjL52xEAqidqIvNbqCEVM4E5+N3S8YmI5ZODlgKAhwjlkRYkSgToAhgkzIvE6kQ0rEuQ4gQbwOYRcZcBgCOQAuQMpLos5oZhegLqi4A8kVCwOoaRGFAxRJABIEDRkhjxPAcsVDAvMtI8mglTOoF8QmNWWt/SSZQtwLE0lj7J5VadBX/v//6X/b////+o96I+nK5VPByV5iYaJQyZhCDxieYx4iaIGK4wYAAyhRgxwAotc2aRuWsQ/1KFjx+0Wfwe4y03oqdVOswKEohNfVqU7HhK0OFD3y29zJriaz0ylUxw5OI1MWoVtK2jwAUAa3E0H5cMEAQelKipJFBTcI+virfD2SzXWrT2sIubM203OQRGiRmmo5Sy1Nbr+p3CMO0sxjNnMOy1S+5M/k3V348SCWTv0279W7kzAU20g3xF+YBUqWZcpv/LKz+WP01lwigXU1v+/z/5z6y2W5Y3Zc93efBXLvP////zy+ack993v//5Bujkssbun4KhSYIU6YPh+DQKCosGTYyteZ4YeDwHDcy2LTuKBRmlUsNGSYKt/DplQ5FsXzpYnDrB2xtsVAEOBKquQaBPxGqsAoVjRZB7tCEFNdMiVPKEp9xECwBNRl6Yw+pUDyK2RGuxhSxrE6RYhoCAwpo3yIGxATMiQcQF1BTQLxPLHUS5gUQMCBIcUhPYKGy8BEyQRES0ghggmXAagAcEMQQoxziLBEgQQvkULBXHsEB0DICBBgfwJBTU+dZAzSQy+ukTIYVKtL9jVMzHLDUjFx0jTqWjMv9Fp3//0f+/////84ekKwrzzEAioAMiNA06EDJwJCtFPN44w2HQICzLeLMsBNDdtKODgqBzckbEhGzQWBeE28hkAZSKqQAFl6qdgGBUVBLiEoDLiWASJzAgHhVSrE3HhhXcFCgNMnGoAoMePLCGKhgFEAfqoI5AzUgCRqoSA4AR6vKomvVD++l+eZyzJ9Y9LqsyuQ1gtV0snON0aQ/DWtzaAF6Xga4VB0oJJDf26Vo28rl1piDkSFUkxGQsAv0nJI1RU5ZYopjSJ1YfKwUqq7uZ48r2ssp6UrbWGpccP//3/4/14ygZhlGWL678NztXHn////LH7vMR9Pi3//V6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGQVNLA5rK8OsrOUB3mm4c+UkmDm9Lw+SspIHObbh/i8bVn/YYYBApoCcnIweCgwKhE2CFCz6GBreAQod6ctzywp3cY0BlwsA1lLwFTe2vqq8NZNhmdNLSY7RJdEpHHl6Pih0iI0DQmmieQRPRbOwtpMfbnKaaSM/CxR4AP3MyagoH+ejlwYDh+tLfxhpwwvDLcsv60iailM1UhClVpVVMDECASWNQ5JrOdXBy2V3REdA0TXU1Gnw3TMHcU1BXlgyBYPp7uu4Y61rv/q2rv//ff///f7ewmZou8gb/+5930Ff89///itNJ37jEfJACIFcBQBGCQKmJAzngQmBBOiwXmTxEhBviQEXu9kdJQYZRoiQjwlxJm5IjHIPeXNF1q7iwoKhYqAlAk2g0JawIBwhBEUzyuhQILhXU4IwCjIRlCidLe5LCqFoqNnLAAtwKYJBJiclz7a09WCbSxJDSnTjIaWo1KLckaSSPl6QPUkNhVzZpl/Y6NAoxTK3AIbZMGdYlzrTcK9eksCwmqBR8TZAqtN1KSUOEu8UImiBLHYMrOzXCrh3+5Ya5+qsZRhk2P5f/df3v0LxODc7guP+fEe67/////Mf3eo/9H//Uf///1vqTpXdNrqUxMFhQ1x1j24YAxNMGE83YLDAgDUrMpuQUirTqWYBgo7YgJiqMGEgNabiBnwSx/JWGo7D9jxkSAchIARE2WhACYIENSdnCXpQIWNOXWKihtK+IkMS+x0DfkiLsMgB6VyPqtYySFd0KnrMSfKUwJQABMteGZmw7TZXgGEjQozqhfxoduTu7OA4LEuLBioF0h5Mv6lcdoNnXKdDmJJvFRL1P2lwVgJ6kybBD4wKO+VKwMaQkNnocr+sf3n/csOwUW4/fNf///Z7dxDsonQfJN2O7rgCzCp17T3zvu//7P3//0nMWnZ9w7j1l9DJckNJAgzCCjBduNAbMqiQhBRgDVGIQtbkD/K3DAbMv6UuC2IZBM1JZQPLBzo6h3TyIQBOCAUlQFlYWQnJpygwKBxUG4SOIzwkB3PZk6hc82mOhxZixfXOFgWyIRhZkhVB78KPkwcMmnZnbXFz2YcXe0N1obNsiwgDcW7KIxHGnmdsqQMSoJPLwoHxB5IEkoOFLkbdImOmzmJAzLdPBIbGEN3IMRbmjChxfzpsfjEju060BUCacQAiMaX7zyGmqVvt3atvmfcqsFO/f/mtf//lzkzLRojysQU42O+xC/nr////+0eqFwt/8Lf/9P//+oE3VAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABzxTSYO70vDwaykwd5tuHJ1LJg7vS8O4rGTBzmm4dYBAKv9TolAEkDYUyIxBFABAOOCIZuDSkQXzNQVRprSofuWPurg61gFhxyxEETcogszMulmSQ/WtWwUckIKvRyg43kSXYOEmgYyqYlw8SrDNaGRcztgMIFhcCKgK9SEUDMCVUW02cgAHNSQLHZJlH4ad15n2ZslDAUns1Yg19M1oNivP3FEn4kfL5daYgpnoQWxChOzi1xCuXZbulUKBkEtYpN8RzSgpJikjjchIkP3mhNgJQjaRi9lh9q1zO1nc3LlFaTustfv/1W+qw4mXz2M1bx5nS9rH+lU63573///7bv/xZDHRZ2puFuZG1QmKJShDQGB4CGJoAHnYcCRXCwYmUIAkx4lt3cgNkIhBRtCGA4XLtBoGlOEpBSqpbooAVnvPAg6GG6kw9fQrANALA1BJf+Wz6FL+WXWLqmthcYGLIYn0G0Erwg0BrcC4AfpWAOCRpgSjQZcqjtRyciMw7BnMIwaBJ2alDW2cGaAj3yqjyixIAK6kMYiA6A079uKAjSEBw9BUCKyQPlU3RqOEwHASAJikAsdb+xhMt0YMKBgGeERE6WTTtjWP//e53OZWZ5LKRYc/f75/ObqLZaNdwmn75j8q5hv////88s5lAv/89///7v/21KoGBIFL3chKswKBoytgA18DQIEswVDAzhAEDA0oYBLYFBTC5R2CU2zeL9AG7AUB7lt+jGjOKylqdln9EAjIkB0WFGwcDWi3giB5iGKSUMTJihP6umAc8MmBOBNjIfp/JnTsMqG3acgPB0FVs3FZZAMifSUMNGX5et84FxfVw27mRLqx03b0BjIfOSQ7UUFfqqwFCGTBYk+8ugdZVDzkqIA4CKywDEnkj44lb2PYTjLVAB2aBVUfbdWdmkYpuWML2Nv896ybiEEs/3////zH9M9S2t/QW9f2a4JOVSQkflfLf/+T6qIxEpe+rChQEmDa+ZoC5j4FmGpGa6sBggHhcBmKJ+YJApABoDkkKSpODlkmJrrGCADl8SMpAeLRhVNQpVHEdBIWARMNXfRitiwOQfq6rRwcADkQBDJCFDKp/IRiLNtGdYpEAwsA2pAQAxRfY4IzK4DhNLP9obMie1noAoo4UsZgKWs4Q5gkslZYjWUvZG/EhgWAUAzjU7tEAWGwAFdmTNPHgd/Vm+yJeFCOj4Zkie0KiHxl6FgAsgBSeJv21KM2Ku/13LP8NZZQawyf1r9///++1n5IitFjJItf3uh53D////7N7Ybj/r9H//h////WAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAc3d8oDm6tw1aoZQHd5XhzB3yYO7o3Dvyzkgc5puKlmEvywYwQAzTsnO9AlJMQkEzmcl/LgARyJipFtbU7R0MbyGFR8FA1Px9TBR6emFAcYdhswYDVnTYZiRBnjwXEW+kGsyQXKwKAHNRCN3Iwq3Bx87ab1ZsMpeKSveMBgsUKgbfFxnC8UiSF4BiQWDfHYLINDU8NEBwWLpgaoFsPkHo0GoRUGxojimO4CwHJ4BoDCfiHkVEAUDVA0GRCgPIOA4JkHIcEABDQybOENQGmDQTgKRgHAQSMM5Fwm6K0TEydBbrnC0CIGFp61/Wo4SAUCJ5yYK3M2SX/su1Vv/q/7f////5o/K1oKpYuwALgKYZG2ZFgy5JhkIBzkPJMPgYJG1OwlRF1YtOTjEz1nMON3kDhK7k+poY85tpMtTl+JEygqCg8GqytwjqkSyl6fpYKZ86rqvoMiJpLQiSTYaf+3WRAXsgCjEWbqbEz4Q1BtuW08ORZ/wZk6jkY1opD7tG3GsLb7TVlLKKcljso4QRBkPlxqYkIg+mexrX2LPaqD+zASfSXskkf2Y7ATLA4c+w2nQwwdzMq+WOeF6zzHWV2VSm5jv////+/g7TW+fKp/kNgvxUAEafq9f//hnrcIOAhSxhKHYcDEwXtUx6EtMQwKBczSCIiBhO0GFCrO3aU1raHczXdT5ph4Z18iERDS1C2cuVmkgVBG4lAa3QMAchYZEQRepaDSqrMWhP4SA5mC4FIpL6MFunMfaohrGY4IAwAkaFMCSkeCLEg4+0wOKDFEGcICZkVIuMsEQJmmeI8nBHw7iLDPDkA4qLYaHQ1BQSUhwBuGSB91MgQIIgg5AjgMEgc+GDwYFQJ4qC8E2ilQPQhDjQ1ECociZmTqdKi6Ca6Y6AweXFrQs+5+sRAPzUiUl8xdav6qk////6k/////6jd+mciD+vm2peozAWgkFGNQ0Yxkh6uxmKQUCgQZhjhjgELmsULVSqBDZs6MGAByyYQ40LvGTC+v/hAAUY1VpxHYgFDHYwVhKCG7mFQHKYPo3+FANF4zGwQAjcxBMDGgigRCA07igBIhNACAbH2fiMEjBHWhFHnhUw0pr06qAqgQ4RDszPzjosQDPJETlecPTBMClERvuQXPhh6cCJrAhhQL0YvMRDcM5j4MAwaJmXUsRnASKkEuqQA7Ccw5HPqaRzFAiZykOWMc9X7/e4a5jG5q3h///8/8Obnx4VnuVwvf813Kx////+Xe3Po+vy3//af6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHO3fJg7ujcOes6TB3lG4cwd0mDm6Nw6s7ZMHOUbh/AMAKkHfR4MBwdMkIbNRwzBgEAwTjCIeVGI8YbAsUCksLCrLkrDG+USF1kaB8s34ISDCSsrft339EYS/iELPkS5UPCwYBvLWwtwfBFdtRQAM2QxiiCEhmCRT5wTtBZnMiDAYyIkWvTXiZHs6HQkGIiBxjI0hmUnJ0viEoC4sSY8WymYB6AuUipER8BbMgRNE0I5FCAYRUKRIcTImRmgmTAWvANASYAwqUXOeAQEBQNNzUpC5wDGgG3EhhYpg3LDTi/p01Gi1nU0h9gSLJoV/ZVREgYTNmUSfMHQf/zv///+/////+W/LZuDEZIxsqAUYDJcYWhERAyYUkicul4ChzAwCmKZlgIhVam9kUaKgFMVUNEGICwTylCgJh8zRDaiqLcTmR0DlgIM3UeYbRKBDQZe/5naY0oyqonGzxCYBNAcmmjoZMWQbfhJqOqoqpmNQ5C4S9xPlogA5JZIuA8qIAjEOlgqDlB7YETwkyi+TxDwbdRLJSGqFpxbIaMsAcDIOAwFExL5VPqWeWcIGTYGSPDmEcFwJcY2Gsah6gBjEDnHCBAmCEBRmS8ummtlqVUs8Q4+kpf0WqHJE6XI0nnVVWfb62dZxtT//V/z3//ibrfsv86caV6AgsasZx5UBBAUBIINrisFAdEAwagi1jArNuT2znzkeAXvCAD8XuAhLlkXBddZMwBgBoyULM0crZMOmAAsKqy6hVVaC0NqMXNjHjC3wIuEQGbPao9aUIquCk+ZALtakds1HzBvQyEJgNPADsECLiyGkHE8APbC4DM0OmIarcpl0viVDSGZGXC7ikAc7DbjhuLIool4a4IhY4gMUgGaOAmSHpZXIAISilwuqAZbB3RkBcwdozMZsm7l9B0zNQ3QJBCq/tsedYjMTcnjD1JMkh/1rf//q/7f////zpb93//erjpyyXNbQmGLYoaKABiQLmLmqfoeRi4DiwTMyJ8MQ6XLZ4TBxc4y9IhIJO6CgJLb66hgxu71WUrALo0wMBxUBEKdAiAd8QAEwKFIRdynmmtIkEBEgbM0HQCHAII0ygmUYSpYuumVO+QBZJphMX4Zl8eiCDvGkBJIJSJ0igyxFCRJUBpePlMuk4XxHw5Y5pHkyCxE8RQ3CAATgJohAxkM4J8NWKBqZkOIaBmT5FS2AaME+IpF8qjnCGgKrQ00OSBuSTx9BNk0ldFmLAgRN6vqXSLggC0httOxr/RqSbpf/X/qX/////Ov6P//5QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAAByZ3SYO7o3DQackwc3leHF1JJA7vS8OwrOSB3e24VRFgAd+gSVFQmMLqGMoQ8MAADKogmBgfJp0JhKH40Gq+7G4AYGc0clAk/BefDTkjJNlMF52LLAZiw2lMq2lFhCqYeBEIZJ7cqvSpfLqxRJUHRgyPE2oWABky4YLpWPTrSE1RKid6QWimVkBCcZkbIEWYskaBKlsxJ4bYCykTEwcxNg7JXLpLimhfYdI5qYIgBXAyxMWSbjWDlUmUZkNDVTgYsKLlMw6gwEpSHSI5CaEDJiiIhxAWvEWNDOcUtmWmi6zcMUlT/o1k6DghVqHdzNlr/u1b9//r/6/////6z/7//69wmlcMxTkeXaDj+ApaPEYwgrD7DfMRAYtkZFxGPgDMKGmZkqU7e7FiVxgqBy6lYKYQnM2vQCUA0ormCh6HZccXV9DyHhUG5br42iuyCRuWOBxnTyMwUFUiaT8DgkTYNYoxGwLmqX7qUP2K0MLkMWRgkvpJqklUyPaS6kxzpmgxuI/DSeUarzhalrJh1uxFYU5es6HsuaG+x2DOtHyVFs1y+2NwGQiCIdngVTtGVzruHeYXcs/x/tWsn3f3v////X83AU9JPqZql3f/nv/+T///5PUSgKkmrHDBecwCCQyFnQ0iDowLAldoKdAuIXfMgeQwfUojdR0EERxdQPBj1joFN9eYGlsJm2Uq1M6nAgdGQJxV9Jyw+YYEonvLTTEAqdLpWLOpKEAmIRMS3UPmlNBY26y/ZfERECOw+ZjFpmWUN5TGHm5CQgWLPK/1G6z7wQiBHodzlUvRSkEMT8IJjrWaJyUi3QMC6VrrR1vru69A/o0AgEeCNDcVcyTNupMw1FyA+DwDTCQMns6mFy/2rrn8y/PeCMfed7r//+9/BrDMcdQR3+/VAvsU+z7Pf//0+ldX/4AXk2euU/Ft0kOJg2oZiwAJhaChh6WxziX5iCBQsEJjyIhEVBat3IbgBPs/QMJjplpKDTtZmxkZ20GgVtKwmGrBiwYzJby5RoEf0FAZgQMr+U9fFaIOD1Xw4XnO9TDC3IHNClCsSrVCnke17VU0wDFQJTZu8ru5yt94LdsKGKJkMSyUQJgvEMN2WP7fnKqAqknppubyw1GIWDgKXGSBimNadVq7hHp+q0JuAQvNrKmuO73kZiT9gENEwJgxIAyVV83jz88se/3DuDZW5Z//P3//+u4wRD/eXbP/+X3auP////f3Q/T/5T//rd///kn1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB3JZyIOb03D1a0kAc5puHfXvIg7ujcPMs2RB3lG4T/IhSv6BGPhwhNsnEb6JMWzAJCMkicQgqGjEhyDiE9difZEQBJpXugvABhQHHrrkmKETzdHAVWsqgNQwsQJAKBH2GjN9gqMIc4fpp10SwBpYLZeVkwYnjIuUYiSkOS9Wx9nHishMLKzF1lbFd14Oh6QIcJepUYMw4ETe74LoowYkYvXO9LX3BgGHrj9Www3IH8Zmm00UwMVrEUrZVuVLCHdVGWmJJNcgQqFYFszemCqOgYiDnq9BkYm+/uVbLv2t1r9vmeL7wxfw///n93rLjrpRUfx7e/1U7hf5////z87nY13r9H//+n//LsCxGm2rh3I22QsAsxRpTJYLDkSAZOf3uxiMMhQBklVBgJKgIleTYjAAIOOt4eKDzGCAXUlbaGOhI2fqP5QI2f4GLQOw2eX0nLNjwhMAgBmluPRYKAoMDT9QYFgib0EwMNQGcBIAFL3lEARgddzsrJEYaIggrxqbbSN2W5Q7LoeBFJA2BXdmWmQew4kH1YjhlXGBbXbcjYi0irHVlEUFZBsVQkO6zNrW7cF3IaWJXNUrYtgCV6hdm+3JsawoArjjhKcYCqOLjm6fP+93SbxrfXlpQBvd1h//3f/zUdZNb1Q2N7yz/Gt/////85dv/Of9R33Xf///+1QGUrYIgNVE6KHIEBiYw3SaHCGgKBoImc4iF6kcDC8YAwPI3cziAqEGHeSX0lDi63MRcOW1PPqgHSyZI18GDKaTrCoGECUXKgKHAjfWZ2dWFl6X98lARgkMNYya1Q4LQgZS6TPw2g4Cg4NN7PmV26pNF8sCpDRHgGokNoNCRQIuQMOiAyT0nzYxK5SAiILxACqQUCQxAhoxobaLOAzygORPiew9w0WcNhCoOZGYGGJjBH0ZCl0TMuEOE7gEhAOeXFAE2DZImZugeRaqXE1rSJ0Rq9Xfsyxyx1VEY+svMZI/9aXu3//9S/////9af81//69KqV13QgeBEUzFgHTNUBzCoCTEwdTuAcjEgCwUExj8GQsXSKsWmmNEoTNLS8waAY4HB61Ya2GEt7dykoC0hfsWGK24OeNLKYMFgQqAOGbliVhcJJnq4eshChlswmBQQROwqABLdliMkuat2JiQSJQ7NxWcJ8nhPQfkSgoAA1qURbx8lwXKXRzQMMaHIL5USNgSBDbQNR+DFJIFEQgAGPjngYCWHSImoOAlVjhwP+DechwGVRDSKIGIBBwZimRJyBggPgjajAD0wbeHE5f0WU6aqjUoC7SRu6Kfe58L2HkyPMb0XME/7MpZ/df///P//+T5D//9IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAbpd0mLu5t08M75EHOUbhtl3yZOao3Dk7ukgd3NuABfVUbTnrVUBoOmKUOmXYZhAOGAAOmKwQIauCYBiyJAS4VLTQQlqaXHjwDaFhSc3oFGtqVrlU+vKMCIUfqAFohA5FVDhCCSDPKsKAD7NzZunYZ4FlSLFiGabRvIJhOcMyhyANKwqUtqYkPKooUgxAQICJAmCeMU0BaQa4DfjpbRNQ8pqXTIhBBMpk4UQ85QAuoR8dFyCyaKimRwegPgM+IImGojJmpeKUY4ChQPpjYNFDVogcldLW3TWocZ9l/1uoeRbEHKR/na/63ZB0NDtq9T/82/////qNH9v//13Gf1oCd0GgIxxNjXoCMXgIQxQ2ZVxgHJ+GLX4YQAEGxKUtjFAgF6EX2dEoAl7OnMOAGfmG4lAWbJMGBwMqqRAx9V1UoIDrSWp/UtBYHMYbyHgqEzHJUMDhkWdCDDGR4GrSgRd1inIAOQiyD2fxMtjJHRNpWFDAZI8FBY0iNLw8kGGWA0JEQKTROl8kgv+SJFTMUmAoSTIsLhAAHC+AwjQWaVhTg5dM1QLqQDSIPKBQCSJXCx8QMapG4nQQFDRgtqOQGLgb8QiSR9lpMtTs6y+HvFuv+6CIpgeqg5RS1GF0Ov9A/0v//+h/////mj9P//0gAAbhGCAVXi7HR4FmlBKEr8OAgIEhnYnoov2YeDI8H2cy6zQKZHslFYWUA4HvjRwgNPRxJ1TlkcZApVTtiiqAYlsJUjomW5UlAKHCIBE3uix0xYI3oVv+wVQhy5Zq1Dyi5oy6tUVhJfJkmxjCbI8DAgxPhFXNDAiI1BSQyJsiYGglRRMy+QwLWTA4Q0SgTYGINiYlQiQ2klOmKyBYCeBv5OmQDgg4smieGREKBSCRERMPwEDIl+9aT6kpiMon/3nC8RqFyp2or/Wg5stq2T+z2ev/mm7f///+V36Ywpa776N3FAKMEUoMOAeBwHGHYKB6DhhBAYCTFEewwdUinVkUbEQGbTzg4Vf5Ye1YfUwcMnLTUygOo31KojeIgGVosRAYHhEDTlu/Gh0OEgRtHXYIbsGgg1K1RRxwX7aPDLi12GiIZBBu+UHwtZXIoXSDCvANzE9OSJSKpHjUB5RB5SZy8NA1NxzB/AkUnTwm4DIkZwAr4nJEoiASC00yLAiIgFrBZLABDjJMvFMcwYYNeAcSilgssHIGicUyTJqmK1TpiLgR/6SKyHB9zaWUUt2RT/u8yft///0f////8389f//9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAG4ndJk5qjdOvM6QBzdG4bJd0mTuqNw5+7pEHd0bgAACWCT3tOUraDQwZQ8huEUVQSHDO41S7ZEMFRdz1brPU5I/qRojZfTub4Ixy2VumuJyZEYAUqmligQBw+jLxJQOtEKKoFyhEVbO8w4DNY0GHZMngF8luqaRqS9aKX4MIioYczNBjjAhxLCewMEVIeTiaZRQIGA4SO9NkYiZFlm5RChIixqeI8iANUBdk6mtaJ0ckMLkmHZOEPC5REC+yZEBlQxsNskSAARBE05mnq03VlwUqf/+sgw0mrLr6VX1I2SOp60VIJ2ejZbIVL2rUXaDL////6yt///84J3CWDam5jQw4CGZz4Aw4Y0DZg6fmVMIYAB6I5lpmgY1oJYGkKyU0j4KgaPnFTeouw8FiGbqtRKw9u7oGHDwoJFAgzxMGVmDk4JB2ux6YnQEFCQqsFZEIIbuZmKwYZUqqJUpNQzNIVMNfckAznzJIuQxpZMk2LgKYswDCLA4FA8Q4TqRhsAaUKRIETQHKD5xpE2WSTFnF4TgQYA50MkBkhog1Ii5FzIql4uinh7bgBK3LgUJhlDY8iXR2BrARpxbw4oLtIRkra0DapmIwck0dSt+1AjQuqx/Ky87t/qnNVL/X/+f//8Te5f//XMCMAADkyNzF3QXmFAcMO4MMhgwQRhUJzD0QFx9EgzJgZcOkzdC8eKG68USlsZx4iS177EWPwFwMDvKTDGtk1aLoOjIKGLmMAhcOTIVyPek4ZRySySaOz1kLrLujFmYbqXHOElsXr59ImRN5NDmAELiUL5fpE6RUGgQZYxYuoh0BWNCkQ8GwQYlJImSZAFEjiJ1yTQoJiEAWEEyGM0TYL2DQRRMiHEkEAQA6GSAawJBBgFjdJ7K8sCrPt/XZZUK59kG//UpNSCzdFdvSXr++vm3f////nT/t//9eLyVpL9ULhCIBTDM8zI4G0ezDgGDqwQSIkAEBRhgWwKFJTCL0jx0R5osTDr3rl3UkoUHKTmRMLPrFzIxcqDysK5h4TcIxQEBwTIqSlgsYIUcGVSgkCRCdFSNEimVKAqgZRDyZrytRL1h4A1B+7BBjoy5KEqL8DMxwxmWC6eIafGYAXHkRctqNgywWx1FEjQ38dI1hyQJLBcgGBKETK5GkUdzVIohb0UQRDBxmoNnRslw0IETYrgCQAGYHCrJUMslU3u6a1Omlc6T4fdFvfs5kMqJozonug9/7amqt///0P////536f/+tOFwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABt13SZOao3TqLtkAc3RuG52dJE5ujcNKKGRB3el4AAAlsjwbhUIZuJAQ0KigebAUAxECzSAqRUXODCSy90JfyGpg3+5/JWgKu8eNe16KMJXHN0osFUWKBJUEjAC81pKt8srz0khFGmCIsuc5JQLLyLmxtD1+FZfl1mUAQCGknYocUibGsTBDS8AMGBwgsnkzYjjYODGZJg0MIarLKRDiZC/5cNy2LcRcLFRYTAfZYdAxNBjgFAqIYUK5kCIGKKpRsR5uAuLAUlDnCJFoPAWDZbaXZlFMix9tVuqomSklc9//bSY/Sd3vXTT6D3U6tZco/////On/d///TPKXOc/LoCEFmFMKZXDJjkOGJYodVqphkKCQJMymAaPiK7mz76oJzvMUSG4wubDKJGOkMtpn2Jh5mFQzQUISRJtJ1FJ2Q47JQyPX6S6sVwUZHFR4NsJzFHcOB33QkxFOplI0DN4hxGC02ExeiE2DAkxjQ7o5Qe0BwuAmpKjWIeQUrkOGPGkiNojiyLcQhOjnD5EGERHNKgBoEZYCJEi5cIoHAIrSLwigjQnA844jwDAcql00H4oChgCFgPKkgHVDVJqmpaLst0KkTpGjmNV192kWE4qahXMlM3/ueq///+j/////O+pn//QySAAA24mAgNKY60oEBczL0TggjDAsQigYFaZEpMKB4iDUZs1m7M5MUkXnpi7NivMiMFo7Tlp5WKQKggoBEwg3pE8Pkk6X1efDkBiIJa2siYZyEXhhgwRQSy0OMmeFz687IEvDEgxfsQd1I0KQ3DUugQhjUNCGFwvEeOMAAqJ+UaForBigoF5ZAQtsgbkwOYTAESQ7i8Q0bCKjh8jAoXIcGqicKYGAEkXSMi8fFoBI2BmgQ5pBgs6MFSClaKXpF0WD/6lE+SLOtf7/UuyN9NT1LV17q2ZtRdp//2+f//9WlyK/pYowcw+J8iTYICQwlHc5nJIDDOXFBNiCglsVvGCS3RpvIgpknTV5SAJQb67KigTk72ByOQBxMFR9GCAQ4lbC1aCOzuKTTDF+Qs2cDAKeUC7goJWLkgONIQuozlTxK0lcJgWLSqWKJQyraeVCPAJ+J6nKSQGCBUmUt117JDKZfH1gZXLHrRujSASXdmGK9x/B0yYTODghvIDAQFv72dxyLoXQAU27zG5yL/rL955fnrXdyh3cf///////GSNTy3dosloZ7RKr/6f/+t3T//6kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdRZ0gDu6Nw7ipY8HebXhphQyIuayvD17Ojwd3VuFflrXibmjIFQxMOrzMdxJBAENOFniQHpqGC4rBwEQHNXYS1QxS4WRExIWkebKBGRSGHFSoxwVBIhHRgQEiEhGjBBOXDIQCBqTw/D0uMCGkmmuNBGQYyE/AKAUNzgpPpNoMUENPQylYUwotUwhc8gXiICE45QJgANYiChMgpsTA4hnhWoC74wUZEDQDgycI8UciwGCAoEGIoHRj5AwKkpFMc4jXRLh4SINVFEGosi5qDZ4bRuimOSPAYRAZOiCof0LESdTMKFFW6jx8bgjUua6v5dIuy0yS3XV/tVfdf/2q/n///p1vyv/2lisUW6knJoEL3GJCIA5ZjE4HTEJFzj5NjDgITBoAMyAAWQTUaGaVSFQOYZk5bGHiINUeEvAR6hMPOwUCtbbWwgkl1iYb0RECahhMIFn4vhWoCoOxoZqkVgJAKZUKBIkQ47rTQmzRbhiRQBxpjQcDmyI7hQLS36kBohy5dZxB2PAakYhGYjEnTMFEZ2Uya7TpFz82xF2WlLTpHRDAVpBb59KVfTX7+sfQLVvgocEXVyAIg1KIVZTAbeGCg5O1FAEl6saUWLvMNaz5ruu16ZQu3n/85+/1/6eFcWf9s85270S+lqv+6JPd/910SU//rgIXAGGggLSpy1cGCwCaehp2kJhw4MACkxsHAsA+mFckQF9p3r9LVOL9WLRkQi9eg8xx29HWlpZNhoDBHiUkkyosJh3nHQZaNzJiIRgRrEuWvrUQ/NaqRbKKT6srTZcaWNmgBkbinKA6lBMTdDDEzmm0adSYk9ly3Ru8DT0abm68tR9jdA79OBiolEpWtKXiUjkyJsLfb/taXu/Ei/DHpIDBWL44XYi4aoS2LMmkurT38N/z9Yd1zW7SSf///////+UdoMfq2t19kiR//Fv//s0U//oUE38SKjdG+o6BRA1RhSBA8JZhAbR0QkZhYAxfIwbLovAtl/qVnBZI4rWDkJ+RIghPYaNIIXnsuUViq7GZGEjSt4sLJGMr6YALhgapNvZO4ZAIi02mKniVAQwRrMaWxbDQRl5Um1MmmkwQvBYceBTmSZsytFYmiPNRCg4gQAIDJqiC0gc0licIaOWOkLDBpGjFQ3AcARvifTQhopxDyuMuCgXIMDQEhQAMOWGCkmWgOAG8RWBCCCGCvANAgZQ1UYENEuAMJ4GHiAILlULTiCIJqdFbLdlumTItCb1/s6Q+w5Q85RQepnqq6qn3X///+e///7v/0rOqNgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHaXfHg7ujcO0O6QB3dW4apd0iLuqN03aspEXNabpcC+I21pIUwNBwysjo2nCoaAkABMZwC6HACoiYSBGNAeu2LTlmXHENg0LSQvnX9GUAkU1WlZQDOhLTISUdGE4BkTMhEIuBgwwAHh+kruCARUoCeK0toGjJixkVn6j71kQOhxmGvyiAVSJENdjT8kGOh0QhIOeSAGJeh2RhFcxIwezEBZOHvkPNj5PBcMeWsWsBgSYkPMAbwjOAZFMF3EuTQqjWYGotIg4ogZsUMiUgIng2InJqaDhAGDAqvGRFODiCKUTVegldTHx8hl5FBSf9aibFRNXZLWco9+zVq////0f////6zM2urt//YjTg0yK6XmXsMQzGMmASMNQIMPy2OTTHMQQQMBABMNRbDBBSOfWTrygE5s/HjSRAYTkdIz0yUolnH0KBpVZ+RGQlULbPIh4HmQKGAEoajN1qQHBokpFgDagMgZsaA18ar0Oa8SgOVXsl23iUmVRg5YEWK/cBDPIGgmoxooUABGinlMipflArgmDhzSdNi+SgN6DbICmgHQkBK45IN1CcAQBBZpWHND3FnzqQ6guwqBMFlcpAChYOYfMB9EaLLAwIBwWbgogeQTeaugykVOk9lOTA6Uv++RgjVclSW5zX/Wqr/9//7/////517f//+8gAK0AwBG6uwqmOBIYFzQYHB0GAOYChAY2hmX6f4qB5BT1Y5SlZh8Q6JFOo99t0jLkbM44KtUWnDQDC81EKAw6ZOIDkMoVH8oDQpZC0ViKqRzT47KDgVVuS42mv2uiIteGAaXFeHpaooE6SBgK2AyAQO8iXJPE2PIRQCyjBNi+ICk6OYTBTC344SzC3F0GikdCJTKakCmcHWMAyAGYl4mRSJ84gxJJhgUDJhhooDwPBwyr+pVMwDeT3/1nCKvt/+q+qu6XWr/1+5v1/1f//1Fx///9SowXAF3n0eW9D6mpj9Kk10BwlALFOuv4waA4QYmIo8F2YzFtjDNz9OS/cJCwC9TwsyCftJFigcwt9DFECwHmGYsmqGCBgVbBtPqAiBEUKhQDCoFA+kLACcGp30oDo6w8pC1FS+RURsuisxblUFubQP0CKyEVJHspVnZISMa1uYstefKF4TyAaXy+qgjwV/A2MaZbe5jcjbD6YYFdgMkIq07ytSRn4iXBqWBFVmQxvPDW+/vH9a/PT+Zf/////5fySP3l9DJv/+83r//+c/fPuTTVIWpzk4qxn/+U///5NyyIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABqh3SIuao3T0Dujwd3RuGzXfIk5qjcPIO+OBzdG4AFPQWCcdfRTcwICDRdEOhBgDAMCjEzuVkKpaYRAJQBXDqZum4Z6k695Ypry66BqC3wND6r2E2gyG3CdSUBTGUvGu2USvUqGSj/M5hxDqBIAJSQJUSObOsq++8skUFoKTUPS83KROkXMDUBSUIEGSRNjUmiHBxIopF0C4ZChiJlwc46DYkupGYyiQGCKDmlcgAySbGSzpdJoDKgEEAaEBoMfNRaThEgRJBDAv2KFLVVT90lKWUg+e3/0yLKrvr/rWrUkyv97qa3+tV/////qM/R//9xEXbBTtAfdhBKCYJXUwyCswgAkxMJM7cKAxKAUwDAIwKIoFAU8kLwZ4zw2u0Z5IyoF7pFNTE0J/I2zIeH2sx8zENGAsoDJCLBFQw8OMiFlRyq3DQyUBAEBAlGtaRwJmFDoIllV2yKXCAOaUXPg58yEyMdME1o7TkSJkaotxPi4AAYoxgqhcg+SfYfYGANDaLKZdLpMkRIcbkXBu0plYTeBgwR8EA8W0ujwIGSlImykFjx0A0CTBfE3kVmJdL4l4NaQHJTkMFjE+iLl9JlVIKWpJTlgWtJkb/VUbiNlyiSPRSUv++7bf//V7f//v//M/J//6FOaKFwAANpRZCBX9ZcYABJn+lnNgmn2CBGaaISEDtgAZtPbhT0kGqAHTwORL1ar9RxzKiYTYd1WphkDiSmVQ6h2EgdGnQXOeStWlhUGJwMNj6DBxmJczmaymTOm0Bxo205AprDfwqeWXSAjKk+Q8AQGOgey2OURYmyfCAOKOzmJFxazUjyWNwLCicJs4NcoAoaGaPE0LYhJlQoYYBiAcNNEADQ4oqlIENJ8CoACVUsh/wweT6KLJKot8siyl3/tpFVGv9X16WpGtSKnZf9Kpa10lTW1f////WW////yr0OI/DJ1SGAwaZalZvMPmNQoOTw5NizAQWRBHkePEFtoFiyqyh5gnXAvTAQytbUCMJXd5p8EQ8h0hoImBkHIhGIBg64pgAqZeIJqQ3ch8UKEsSwCjwsIgU0xwCkYLOTphcIVGXGipexpbTgoNANFUhI58rsMiKRHoNiAw3gOBIiMgQUgYzBaAaXjIjjMVlMEIkmzImxwipFo3GVAsdJAAggRci0R4bG5oYkMEGD7FKkBNgmfEPOOTR8ugEpgP2EEPGiHoCBlsgpbpo0LKYLqk21dG1RTEkTUZkt1U1ej3nW9foVr2/1J7////Uvpm37Pv/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAbWd8gLu6N09ApI0Hd7Xhs92yAubo3Tkrvjwc1RuABQFAoAXIbClIShOSUWYGCCX2EAdGIwlpcTBgMEhMAUzSZOym+ZlNvfgmphQzIYMtTjcLUZTScgwkCehmkjJjqRF+iUhcaCKKQmCgZMKQ9XU3BYsFRZkj8KLPy3OMQDDLcwQJBx23TdQyI00F4TA/gZdIJQN0CaJ9xwBFkWknRTHwRFE8OSCw1AwKIzRfAxA0T6kXBy3Y5FOJlgJEjM3DBBLHUiiokQtoGQxeCdCTGKZnXXU6SlqU5wNBPb/6y4X3kq3U9Su7UGRPnn9aq/99W6jd9f///+o6beUZQkSydwl2gUAjGwmDRcGgCChi+LR+CKIcaRhQCYhNohx2RYtIWGNe1FAnMMSB71hWgzJwlVloQ8XNSZYbKAK5Jh0sBgkF3waKAg5kEquQ4SiQ8cRYiKyAQMyfzB54SBnBAIwNIZVJ2eioO4bxmBg5m57AytD7RaDZ5BFHlompx6XLXn+qXpE1gxIJY5TTkVoW8YtG4W4MAPtbkAOE6pEHoHW76+ebtWrKeMSSgl90uQUB1yXvs1l1AKimSizNXdQmQrl/K73G5neq54droWc/Lvcvz73v5yRtdfi+XP+ug+jMrUfpStn1nn9f/g97LmJ/tp7qABV8lblL1hDA4PNFZ852HzAQEC4UNli9Ddmhg8HKglu6rY0pBBUPxknPnqwY2NSGs5Sz0y4dHA9VBqyHNQ60CgEwgieJ1bz6iAldOAnmL6m7HAVAFEJagU7L8v26+bTBwSNeBKksxJ4mDwsYuEU0Ci8qlckSUchgyQIBoe6syM1CkyeNxzSMGbLpNEOEWHMAiWMzYpCxOubD8UiyBYCYLBv5qkWTQh5cBMGAcWIoGDBEhpmZ2jWvVUxkIBq/91GI38snul/Zl6CZrWvto99lMtmtUh+v///513W2VQhf0SX2QAgCVgwaGDHQRMBQ0Kz4UC4jARiIlBgSdy9bfB2D2txIDAwkWi8wxM08WDpe0YiNr5dE3A9RRPl/yYPSICR0QxaUWYBBKMScodEWk3z6tCWsiY0QQgm4FvG/Rul0WFBBozDrPTABEC4URISsQMDiNCeKpXMCeJwcIAo4QYeTKRWEIisTZuLPFxEqWxdhjYi4BBEbBsNQQSTMji0Rby8AoLLxFBCIVJCXh1kcEBECcgOaKTD8iQQSqqTRWp0FnB8pV/9ZYEndZ0qq0Nv2qe/9/1f9Tf////1nvL/2fXicAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGhVJHg5vK8O+xmOB3dG5Z7UEeDu8rw2CoI8HN6XhJkGAxrLjK5MCgY1JQDwoQFh6IB+YFGhKBYuKGspfarlJB0BNLrV2xpRT83KMcJ6WUvas5msaAAsKildlIsYPYYKNApHUjQ3JSIhNU7cnjKo0OM5IAiQDPtwaEvKUN2glwAwI27W/lUjlb1SVYWjbGS2IRv9PT8rp3hCpM9Upq86zitVzfGFTrgwEj/sGr0/J9qGP1PlcE4MOlu0HXPrbrWXEIBV1MlWCLqb5r8e8/9d7+ptuWP//NfzX8/UN6/de3//X+9b6v793//+eQ//+ks2Fjq9pW76Agw7UwMSgRgaCiAPEgvGiYGgKMLwoJgQY3WxpkGzeEMiJntKAiUT7QDLjRs9IvwoHogzoyccHBiTtHd6mHgJuUCPZIWshZPUpFBRUSlJzwAKLg0mOIIRAoGBCIQwhi5TolkjKAtpG3oLRMHBCxOCEoHJWjMDmpKNiUIsCaEQaZEuXjAMkGQIMcKwfIN4i5Aw9UdADjxPkWIGHAFVIuwyQMSFkFBBWUBQUOo3QI01Fkg2IA1xkPgCQEQcNlB0G6S10EyUIM7fp2yVFSTWUzXpU9e1dv73/9X9OvUtv//a37f6X///r9fqOiYZMJAPlsBIFkIUGCVVGNYdEgApqAJ2UDV/GLCSrmAz1LAqhxvzgJA0HKo3tqqhUWg+eizFknr5hYiOCSeaUxbWyBB0xofV/O5QGpQydfUcEYOcedCoG0K7ASZm5Uo7LG8JFhDQ481bs5zi2qRhKuHUdaH5VTT0oFToEnKSfya/KKuTYXGoZBBSVEvDEI/lOtB1386BM+rGId05zF99qV4UXMDRV6ppr8hGVBhz+/l/5/q42vO/r/////3i9n/M2qD/xf7/5////d//SCRAKOQ19mLtU1M00yKOSKimQQQYbeRt+OmCQ0FgUdaV5s8j9JVIAIzWCDgi2ze7KIeMhAWo5QMVhLCnrCwmVBJONuY0CYkwCpcumZ+uCBsSJiqKQ6Mgho5qARYoSHYLAhn6AdWFTZnMgGA58Q7FHswpICyaLJGuHOGUbr1qGeuvIpq1Kz2XzzT4Ej9Pmw+5TYr/tl+3C44EO2N5WHaYDJQglLqqcz5X7tTsbQnArm2NQVZ8HVruH9/Dn9/+XbvN////P/+5R13Ofd5W6LyKP/88//2/Zuu/+lJZD4hAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAAB4yQRwO7o3DUqgjwd3peHb5BHC5ujcNWpyPFzWl4GQDMPQMXuyRAWYEBAZNyAaoBoDhPMBxKMNxPBoARkwRCImABbVLPv80k6sLHiGeTSlVDkYuPxZpr/M3e+QmIABVFEYmqEw/Aw6RGDnj/OXbwCgMkq2kaUFPAGjCioaD2xt2TxUTjbIn2Xg08DaruPPIiyOkY0YRBSLABBR1DTHyZEWLxfAAPjgNzUrph7hEy8LiJkLmTYawoQMCloDBkhJmFnBhc2MVrIwQmLAZFOmQNoEKoxSK5BATRAYMmkCEeHEkspTKrs7uyi8Nt6/ep8nDVUsoc51fT2v/r/+3Wlr9//qX/6zM/t1/X///+r9SNMzUXSKdila0gJMF07CDVSEMLRfOeSEEhnRwMmNBoS5OUcwOAYJkVozTiauzZkQK2eih4rBYbhgwIKFRAaF4gmrLDAwQcEXnm7UaEQcRLQhClqDIKYSdCAGDlBfCd08MB5EpbUeELAgowi0F27sfqKoPrs54RqEKhNXsxFyUdTVbNbFQGYnK+C1H4lTdXKjYAAurefZm9vXPuquko8Fr5PY9vKfCvEEAZwQlpNxf8g+7n3H//n/+cpqf/f5////z5UzXDtf3LF2dJd1n/u9n/rf///ywqDQAjoZGiI2dxVrAYKmu3eE20mDZgkSnByoDgcl6BSi2FmdjOYgc5xjFh+iUVotsMMSNIEk7UFPpO0wsRBYUJhN2yIOxBoyDR1tJfcsBUGYm9z6iMcNXcyBydCkd5q8miCVs+3EQAZ1ouj0/VQ0ICS46TYdwEhxARniBlIyRICFkw7i4iVy2KkREqmBXFzEmRIbgNzjEGiEUQoihRTlIqQNhcJGhQcmTggsxfMTYa5YBMgAeiGfBAPCz5ugYo0FHVst2UschtValXfKxE32bW336tBJeven9S/6qC/b1//+rycf/e3b9fV/q61N0EqJ0AWkwI4EjjhCBTD0VMihExwBTFDjO0Pow0ExGCNDSDDjR603mk8cTMJDpxu9us7Jn0Usol6lYl6YbGn6fhEqboruhCw0EDIXbyjRIQHkxf5Ak7B0Cqbg9YZgzIWECgRmzHoixBC8whtQB7s5y5EVl3rpwlrQo9UnoenqQLmWD58wtv3C6S1Ey5ckzglisQISjz5vS23K+Wo5UiTMKbbfubY+gj8DAQOGOIOQ7QxO54c/ne/vX4bmIO53////9f+MxD4cE1RRuivvT/t93/lH8h//TW5Tx4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB6R3RoO7o3DAidjwc1leHnHvGg5ubcMDJyPB3WV4RmAoCNIUfGAAFQrMEJbMLxHZ4YZB8cvDeLDQX/Bg8l60yI3UiDQDsZASIGdlus/ZcVFd+V9MeJiJcjQjQhMKgBQtofhANKDACwAhTePfILBAXKWILjQoFwM5FeMXMhasL2JfExggmhMKji1wcCmVmD6OxdNhSAzQkAs4dwGZaCHENIsViTMxZgQmBRz542LwfU3MB+EZiUCSIeWAuSVBAQeCucDjTF0z5DRP5PAsFTJ8aIwTI2NymT4dGA0NEaimivls3M2SooKUuyZSHL7/tcviyjexovV3rT31oPdevav2b/e3/2/r/VnDVnSg2P9fpZO7QWS+sy6dT2BARMr9U3kGSgAGA0idxYgQE0eDRYg4tGaaq+q+BT0uqSz9moz8aB6pJIuHKuUFyoQpYBVpjabokkc/CM1RVOUFVLUSiESCKRUaDQaqztA6BJ9PqcWCEThyFOnlVo7GnfrMxOKNguqkal92IFp291jT14biF2UXk59R2GEYXwMZJuMuvQzrud2OuNdKwKfSBVFzdavOvycJ2LAUc4Vdr7//1vfP/WDUef+v/////eU79FwR6rP/1//3yhl8gUU1+y9QQwWATR0/OphUwqGjC7eOXxMwuBFYTFxCIhU+Mso7SwJsnynO8gcC0V1GUyg4ZNAKhxQLDoFJjPypsY8tNqLDjQAKIkpK301GY6AgYDDpIBjwC3oe0iwQLWqbiCYSARGCuKr3rsrOMyDX1vxYzIsTAzRMiEIGBQPSLEOQZFcvGYNgk6SCZOFgLGjQuEVGXJgmiYIsG1k0LiKBeGPFHSOnDIsD8NYPeLRHiUyqcTdEZkfYCwRwDkCFjZaZqvtToKJUN+TZFl+pdMmRbDWx52WutfVrZ6vVq+zr19fU26vu7evr/3LD/1Had9tz/9KHUAwJu43NRQVB8wugkxnDcaD0wqGs2oHQwqANbRsYAk4hdJ2H31NTPTVg9td4PStGLQDDStFFPBh0ZJM3jb8y5aAQW1O25eIF8JZAk2IAR4G4Eebi7huowiH3Ma2zIaKC6bdKTdPNzkESySGOZG5BjLpmzUAys9jXxooJtwPGrq+sMG7Lvjgkkn1Vn3O/tTOchGKLfbMeahy5bm5ezQP4b0qAJfPf9ff//////KB+///1/////JycilX9yLf+///kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdzdsaLm6Nwz2oI4HN6Xh1V3Rwu6o3TujujQd3VuABWaFQkpBT6sIkIjZxyE90BAEYBLxtNKjQTUFMTk8OEs3lYVRVmNE3hoSukwNhLmQFbG1GebxzmHuCYAHs8KD5jSdM4ycBEEufKPyUVI7ad88hKPjLzA1AStFVJUqVgL/Jd1kemmg8PcOal5VIKWhHZAiZBBdDaBvjiKpUIeNUHGg7ZgmmXCCkiTZEzQORNh+HwFoBPgYI6LYw0RABGhNg7BSC1knioRwmJ08xFhqgGlgNMPH0EAYCICpCi61spN0DIoiADLUpVt01KKA5rTIqsqvdkWX21o1toVPdSNStS1r5p6v1///yUOdP79S1xBhTcW0aWIAYYlnBnoSAoSmGWaf7fRi0EiAGMFtAEAR+goZesEZDUNAlKv8+tLMBF5bhwoE2Zv6ZcUlgXTyjQkCzKdgMCGTSKimUQA4bKgerCzAyAXESmPJsPNxZQlSzfW24SpTPKB7NWpMxCDklziv2B4wmrbn74gHtnv1reb8xWQQdi2e5nEW7zAVGQfublGO89S5i+CUUmtPLB9m1W1YHDoCnSpaKwdnLH+73r8P/X1F+8/9fr+fvf7lDUMfu8QV2vOVP0LXt6v9f8j7OsAVFC8pMALdlUQqExiVNhmeHgKAkAiKZkh4DgLnzCIQyII2eVazY1YT6+ygZI1mamUljpCYHjLLnzTtfpbTYihe9QcDlyEgyo5issn5Kiapq1NhwwLP12Lxi7BMifeV6oWjg6T7CAQbREvXKqkRUfY0S8OsBIoRuRAaREDhLECAaCCTkebJpECIiVllsOmJkc8XwhCQwAw0RE+OoR6x9JyMFbkOEEjA3C9ZEUVmShPYoAArWJ+DiBNg2EkklKumimmlMiNtrdvzcTV5w9uZXZfvWpetWn6CrrqQu3W66Nv///9ZYW/u1//vW9TKn209rlJYmL4nDT0mDwMmIRonUh8GHQAp5mKo4iQytOlNphSRpluSyG8l5aoV4mGATfRSZJh5LWFmanBIIyJZAkN06wIVAmKw/uHzBExV4MGZSm8LGZg7GHAseEACJHBKIUcOvxNjICTLsNvNVKQ5wuUL1jSH4DRQcAUCRaHaRQ0J4VqEhcRQm1E+fG0N4ZskSmbDsJsWaHzDrAiGR2HpAWUs0cZIshyJTWLOFTUXigVyHg0FYCgYEBSTEJyXW+yVe1MnhZaSu/uyyGEPSWiebQvv1u7KU/fvVbdLv90X+pW37V/+cT2TP/9NYYPyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGTE7Hg7rK8PAyCNBzdW4aQkEeDm5tw2ipI4Hd7XghAJJN9WkKZgQGjFGBDL4KiUBwoHZmkKCTKQxhLCmzMaaq2Vl4LyJNwifoqRopkUzyRZxJ50LSn4fKEz4o5dQBhRq1+Yi9KQk23Z0/44SM51Ctca8qPMNfyclSl9G6AqKCI4xLqlu5KH+lspBCTNIn8gh+rEBUiOX6sxXT9o6bsFvrejMkZdiWjh7OVMX1vWL0QRNrzk91td81lTRkRgm6E/9MzF7amX5/+8v7/6yjX83//v8u87uhqeWdf+j/9P//V/v/6ZJ4ZQJ3wcRdDgukKAkxbLTOAhMbgAwM/j20vMOBoLg8yIszF4BajA9E0xB43yEEhZszCdSqoY+ANByXOVhqOkiMmJ0bUzE9xIKjSwAjF+SqkjgywByoIhdjyH4YtAxfEjNo6eoYKqDqeeecXmYULhymTBT+9N1DOAgABRGwBoswAoEBxFwdRKkMIMBg8Dg4CE8Wi+UwvyRdRwiwohDCADniwk0BgQFDGmwuw7S0aKyHsEAKIQsB+ijqzIsE+GEQUNon0fhrD1TW2uuqooju6HrqqTEyTZSbtS6/+pVX6//19Dbb/9ftb13/3////67WUkzrZbGLWmoQdOvOVgI0WIh9CDwzKo4NFDELASIgIjEwddKrg9bMDYUhUE/Kb82/Qolt/LMZc3aEIisjGhp/RoYxLsmDGkis08iRVkLoRBG84lCJVseNZUoCizL9KaSB/RQBNZDHukMKKxTLhAy0MqBl6RUjTUgBTLhPhhMW0rpGjCOC+TxECHmxwmDAPAUwBgiwqQIZRmAzxDSmH8NjIOLHpBJzAgQQHDwERFrD2SdZmo1XrzqDfp+tEbDV+ur1Vev9f/X9u3V//9v/2//v///7tZ3a7HTlOpQt3OgGQBMElBMQwDMDwQMNx4Ocx7DBqLsGWWQKKngxtLydUXBygp2saT3ofMkIXzqwyUB7OowYeBJKKRYaJADyw8JBixoMzfkeFxZBKgGTA7ODVhYwgfFlNhKSq91sw/Ul8QUfMOFGtX30u2Zeu+BVVzTo1nNNQYU0vmgIDxOUVcqihkam6WUKx59urXrEwM/WT1uRjz8Ick1CFwWTdps+WLnZhNwgA5qotruv/Dv5f//+9w5zX7////5r6eIY/h3/yulmHGXfo/0rr//pd3sZ24/jlkggPFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABmxORwO70vDP6cjgc1teHaXdGA7ujcOyO6MB3dW4TKBQO1HjXMCAbMWYbM8ApAQHGBIQGhoKgICkTRA1q309LlgiGZ5Gs365WqVOghaJRtmD9szkJMBKykwkthLWwAQgyEBSYgrOummw1lmCXomuGCLbBaRdrW4dfducpVUWCPMaYDuN5TE2/srkoYUlDf25ZfkUhTAe2k7rUWilHjQvJqnfZl8GCMxD9vNtbOGuUzJpK1W1Prseb6letdRkDtjyrbaLP5//6/PX7/n3ZZzf6//7///zEpGp0huQkv9itlv//WO52e3dv8LuUTkENMlpZC45jwzk0XBRpGHGbfiAJCpbg7MoS8I9vw/6ji6z3awg29ja0lRxTQtKS3soLJ/wyJBBES9sQ8ZlihoBBQBSXmkiGiLKbqLYyENnLWQRW2NjAWw5lFHTTFReZj5LEr0xLZqKL9h5nwNhHCjMEWaGUzY4LPdzcpvwp/K2GbIJuMuiuSGQsDvLduNrz8a0GSasHAkHymgnd9wlj2KZEyXp9m5QdlnnrX/h+///jP91+/////+keVJFlfvVW2jXxRz/2v0UfuIp//iVbsNjAFmDoQsKbKkoBQvMXL5MuRLAwmAwezJUhioAaShh0IQkGTqz0txEYEOXygElXTGayFxgzyv2NNYc5lMTYK8JWH05MntfEA+ZkbqFwmbbuMCrAUVFbSUeNxXwTQkwHLQQAkQksNXWxQQ0YCakK/InZjhEymMyHJEsLWBmTI7iuSxaHOKg6wwWLIMSokXyNIxIdhDgu8lCIlQQmNQCUY+jFEidF1E2PsoBZghSYC+SjEuFUskyEBoDSFSoJCTwxVrRtQenRWRhAWZnZFdn6xhLoJVK/WvV79bfepqv+l/v9X+v3vOmr5q3pt53dxylg0rmCu8/iAoxETQOW4waA8xQEM88CwIKEwLAkEpKSAOtB17CwAiADSehBiMu9d6lUIVeblDKyguU8yYGjYXHl1ozAYXl6hwgEYduxl0zAGkWJyoABwsVBM1VynyKKZ+WAseHFtSFn8pf0CAxuos3dscqLJDhygwEXBCEDAqjFajSLpi4+iXANAIfUmi+miJwQIeVB8iEJkMwQ0MamQTBhdSTHefRKRkQIdJQAsCjRAWebLmBbFIBYeA0Zhc4pAjxvGSGplUVumx0W5/o78oL2ZHS6d+rSen+pf3f1fvof9X/2+Y6qGU/0I8jHBQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAcDd8aDm6Nw1UnY0HN6Xhod3xoO6o3DWafjQd3peCELmCg8syB1mA4LmrFSeLB5MNAEMQGgTCQDT2MPloODkWnKN4llmdtqRLzNt9KgJMEQHm93nmfB6mgtyHgIqgKTk+WAwwE+gKCeUJdlnMaaYOgplKIIY0Ig2FhYDeSGK6e9M940AmjnTd2s4GJfIqHRoCvAbxoI4IaShDSaHcRQB4EcstOTjDOrLg+imJwJ1yKCNSbAkUIqbEYQRFTON0WIlAvsRAzGoNl1IpjgAiOBSOMcM4GRismuquun3FuPoWq3tk2UlzK1SlO3dvqbVsyv7f9vr+vvt/+s2fo/2fTySbryrVlzxlQCA2tAEHGOwAYJhRiygiMKIrm5FBRPNpMypQ5PUxfTBQLDkZl0sbQxBQ5L3bKBZHa2SGBCFItNxEjbNnqqT/0sPZF4RY2EAYRA4WADqjcwYcEn9fK+1B27x2VN41oKEhuAryF087q8sLLk5jdZigdHZPy5dixdV56CnpMmPSanpaFY1eQNLGgVpOeez5J86mWc+vbJCHlSGZ/88q0QHSoMBOBHGGybP9fv+fvHDmsZZ//z//9f//lI81KaIOo+kSoyz/To8v9XkT2uj6v/RFTBgIW8hpgoBBox2gY0zCZSQNHYwcKVcyZZgqO4QBNDe1EHKOcEEiUpZrjTxo4rOK07CoXEqIukpQTA5MUSZwcIglG9th+54ZMA4hB7ytMPMPMxVG6YyDWjH4zUXNDdNBpwDbgQqGDhFSUF8XzQDjiQoMIUyLpeNEgsoGSMWTUR5sYpkXEZkMRH4PfgBDh6NyNGZZTpj7NUguiiWQwOPLsgblIQnAKREPJoSkgaLSam13TRmJBGre1bW0SWap/r/1Pr//t6/1/77//r/Websv6plI+B3gX2XAMSyMMvASDAKMPwBOtQyJiOMEBDK/YxoCVXdCPzD1G1Tg8JOrBUzkr8xFLszNomE2RwKIjlOYmCh0BAwJLLBeV+5ukuhYaGloYDHzYMeSJmBmgQjQCgjIjSicahMmjKQ4BIv5AM9jJIgqtH4dOyfSge/DcCTFICAVPR36S0pTMUlNTLlgGPuikBLG1jPLrTMcq2Obj0hbazlHoteztW4aQmgozAsjXjS6w7vfMf/f71nFf5/f3/7/+apcv+4Xu+5t9lSLH0pv/3/dfT/9Fv1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGUXfHA7qjcNEKCNBzel4cxd0YDm6Nw84oIsHd6XiJAEEmHvAquFgeMJ4mMWg2L5hwRmiIACwRQGYVAyNBm7kvqTUqNewHhFO42e2QG4RT9hikijvC7KHQeDp/I8+CRgIGUlSV0JcceePu2oyCNSNTlF36T8Ootxx9FbYzGkiRJc16KTBcLhZIGbEDA2iUTuTZKGBsbGIe8bqUszHMIMdJsipkooFAXhZAcHPIFwYaSbTSZhYUVIm0iaC0DFALJQLCDQukKSyrM1631nCWbq/0DWyldev23////q71/1bf//rPene7/+wRuA0mYh2fL2mQ2eAsaYqBZhKAmuJkYABb+mw0oY+qVS2enlIHIlKNNMy3Kyzkwg0eaiS9KA9pMbEJo1srBWIFZFDhcMcDpa//aYULgEXEAVHBQPOKbhATExFEUt30L6QVGpmRv8BgzySmrO00rT1jVCdYWwezSV5yrPgULA2uc63aLRiLWmRXtzKe9pY0isww5N7m91VYpkYExbcAfhzGcgSslXJH1dGfxx5+/7///5Y3//Pv5f+P6/9yD/uaX03Vud0Pa71L+/+hD/7PzuKdyxA0wKAuGo4nWYMAhreRHpgsOg0QI0yowHFQaESiSOg2cl8NMbMCcUe4aUQxpH3NDCVPYLWY/EZEYaBCoAPE7SihXiwEHzESVz38h1ZJgK2Bj1lsVTvMTKBCADYmVQORoRWn8WtGFFkERjw1DlLac2JgZYgAoYDT4A9QmSHFQhhikMmmkmZuGpEgNEonhIS+Uh1B6KIICxHuQMblGgM8NgfICwk1ihxVoLRJUdwZMA8CO0YwXGeV00mstGtyDvUzspk682Ht/W6C6tn9HUzK+vtfX20W+un6v//55l6M/oY5zaOx4oYOBRMIkAFYip0dBGC4EacwVDV1zEgXjzIoQEUhh4ScB+mrhKfL5xSyX3O2cygLbxY2dMso1MXUjaVORFSyJOIDUUBxoCJRALALYjBBgw8ZYK60XpiRoDg4dDkuSAqMQrzAFIiG37X209Ae7LXXHgcvqNBmj5Rqir8SmgSMHvdPdErkWqPREDHGGtRmVXsXpkVR1IaVVoH0aOXKto2zsYdJRm/zdhfbHbo6SzzjUYrZUUPt6vEHZ67dYk51feWv5zeHM99yhzP/7z//v912tb5qt4DQdk0pYDiSIr6ygac9ztIrenPQy10MfwlGuam1AppIh8HBUGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB1+QRgObo3DnEgjAc3RuHMZBGA7ujcNOJyNB3el4GAMCh9PQauYwAGTRfnOrC0oB5g4HAtUgYWNxMfhkaKL92KWCUxjIlYIEofSvym46aMMtSlKwDnsI6RBrvkRsQgJZ7oiGjKh5m0tlrwmFM4OI1E6ZWwFUpji0UhRVB3aqTDupqwvTwBQxmYCiw5A5wswT2YDRAIgg4IXRmUSXUM4FrJMpG9YemN48QMiIm4g5fE9CUiNABBjHLGdGiy2SJo6aAgAH0gv4KtFZ0lTAL8ANTx3BIAVzVJrstVrus6RJ6kUPszmZefQ6TINXqqVrs1N6+3qWrb0fupmQ6tf1e//r6+3///90Wp6bMTUUIgPEk612FrzKTXNtgExSGjEr8O5y8w6Bi+hjyIGKwE8lHZj5Zw2O4KAmqpxT1Y0HXr3UjUCYbjVQQhRCDxeVBjPKhCNjQ6ya1MvAMnSEhiRECA0HOpZDDUJAZMK/STS9glxnbZEMh5iwlO0c4TpMJCXk+VAOkfEWKZFHSQOg2PCGk4kXjISAkCaKZ8LhlmRKhaSVA+Av1jmMyZmNUQDOg1E3HARFiy5qRITyBAgmbjLH1s9metd3m9tqmqfTJd2OMp6vb99Lsr3ZLq7qUyrrV16vV6/dm/fX+zW1///9d2Wmgyk0UTilRhqDc02NHQZCswWrEw7EMwFBACjsZZkqXuL6mCBGgYE2qQXMdiIZDjxZA6YmVRxTTTqcghXDfP9RFnyqCkRMzEaKI+YKMmbghMAwHIYuMDZEdKowMsEaKNiCyBU8qipk26sr7yKH00GImKi2UgkROG46BZA4xnAKOBUCWIoSpw6WQ0MnmMTBEUiRMrkRLYrU4UyAF0i4WZGZYfQ7LU1EggF+WOBgYsaKRNm4LbjcL1DZXNNFTXVa5Cez09amPDs1M3QvsmrVp2v7u122u/76uq/b/3+3+vvf1Lrb61L/9dI6YtqQNq7btCaVAKRxhsSxkeBREEBg+PpwyTxhmAoQEG5qAdOKTbyRvugjBliqeYada0zE0UOikFL5Jg98ZCkSVQGLDIKWWdssBhgIo7kinZcSDBMYLDp4L1J2UCIA0URSNjwZ6KdlsZzC4VmrRnYis7comUatHNBL9i2WNFHogDRtjlSpXjdFhM2EKZXK7qUdh1p7F4IZ7ZxuwAzjQgAS/kLhGfd5xNmQKItNlDvc7/9/X//6/u5R3f9//33Xf/c4cELU4uFNV+q3+59lPb3f2MT+1faUIWDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdyTkWDm9Lw68nIsHeaXhx5PxYOb0vDZSdjAd3teGbGJBYtNoZfwweDzXGdPKhcxEBAKQTvYyMGglDwzJ0AyEymUU9VAeaA1gobiCf8sl6QxpSHDM8lcq9D2qFCYUFyIrWALkugYkNGPNIkBxWGXzFgwIPi+LUkXTBk4K7yCKUFwk81MGnPrJ3RLAgve/NudikdghaUOqGmhtxuTRGvEs2wMkmJmf5ajMiopmG19RyGI0/koCpBzuW4nvdrdC1uUKHTfVDG8xytZwQOiTAEIfctUGWesO/lnvD92+5TuW/13ef4f39TUVLCOudpWfKj6i7tXatyI1zDsrRWkdUGSbHqxfdsaK2rETxUWKJeQtwoNmvsgAwdZgEAoYbA+YdH+cbI8YWAWYDBJJWRED4Q88VYSOAAyYvi9TTV0yCJtyMaD1180uyYRtjbmHA8QhWUIYixcZqQgksCN7JFjaBA2Hh4ouhaIw4Z/MINKAsmFUMhoE8TqJJQhcojKmOAxeYhuWQa86q8HZno1jweOwqT00vl4OSS+c3LsHUn31l1ILCrteJpgZK2yHGLQ13+5qPEQGYQR2LCHWdz7Q16FDowdt4Knr2u93/54c5/7xu75nzX7/9///ZWtAqBJo4BmiwFMSrVts1Xb0Nr+RTcsX3hR8hd9ChYRPW6HW2KgjmYswUwaDjUW+O/hgBF0wofzhxqMDA0VAjN2gMTIbvzLxpLENklM5apqOGFFQKbRKVo7KcuRFhk5GScmHl/ERfSBBeAH5l1ekd4GGylyvVOUnjLDcR1hE8J+IPNed6al0YWrA4dtjzsS2TUEcSl6mkcZwjVOUdarOvuBhD3b1S0zVJdJs+J/wumlT+3hGVlU5SLO7jhqUv9gzupZaG5nMqDGRIIRaiqBQ+EVtZfhj3/w7vusnuy/WXf1rWf8+mgfv3C4sljR1roo0XpeqhiPc4IRQ0230kHWlRmncr5IprLr6udqUoaWl4YcncCkMHhLMFCyOAjXMJAIKBM4Q4HsJKyH4ximGbaojQ7VW9L7zeGEqTyQCvUrB5BoFEiRqoUPAwtfgwIAAQQ40AUug4CGlgVD3EGRMzFaBQcLUCSis1G2HqUNK8gEEQUDsfjFbClmlhIHbEZvFQ5DMutRKWMzZNKe4Z3WRxXtmbZLt6pUvuojJG+1atn8OtkceJJEX+QbT5byoX9kRdN1nihyxlrWH/vv/+9/zX/3//993+/tepG4aaaNLj1MCorQ7Qj71/3167tRT3FUEyG+6sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAHUFBFg7vS8NoI2MF3m1weWWEUDu9Nwyojo0XN6XBmhheBg0AboJ+kAXDNuGEYiAIDwYKhqUO4KAgLgJg8+Ag1mT+6kgyAms2o8E1lWUlM5ZhpfAsmZw3ylUJIEQsGa1lhU7nTFiUz1DKAhr1iGDBSByGiPND5oIsYC6BHIKAisSUL4wxFKB0FHRpNUe2U0DhZsgn3dOaCHhEtfSV26eG0DpBVsXa74Q57vP6j1Pxuada2JBGS5T0Usbx5BspmX/leLKXlv/bldCz4HEarAYbs4471+WGOO/5lnEN83++Ya/9/nuXf9TJosKolmFXakoauQYXSh4Y4syKXuSspLVeLERehbH+62qsApeu59mcw0yUxDJMoUwwvAow1LQ4HKUwvAQBAgxvEDDwET3hyN3qpm4DhgXgRIDCnZ0MGGVyhW0iBys08YZBL2L9GQMBhXThwrVjlUUt3hGVhBqWAGLl5DohEgGxaFZEhwRblEDLPhpYiCAxcIgOefK5KLrvwlRMLOpMCvm/sqxt0pENPJrmp9zaOl3KW/oZPYSup1K6Deq2ud02SCvQjlGLR3Pw5lcj7SxQCjeUt5/f/eWuc7/c/n7xUIiiDTShUgDjEAN8w1UPVto9SCPyFSP6vwPoM6Wdj6EGUkmhLuL7mBgOGW8AGygbEQ3mE44Gn4smDYHLBmKAOhw1rlhctdlNI7h4KBuDlA79ddgMNKV+kqmhoI5CSrIobtmY+HBNgChBowGLAcGRNmIqHw2vJ3m4iUYBWwFsAoGI9NdR1lTPZ5okPGOCCXDhW5JJ5bL6VfJwp7J3MxlcE5U7yNdmrOpBImoz12AUAMNTz8L9gwEkHu3DOeFfecGwv1qRz2B17uE3BUGsoAx+BpC9eeOW8sMt97h/e5O7zWX5d/vcccsLsHb1lz//vN81reud5cyPjkIaSIm1JaEkFyiN6zifwDdvqsTuOirdAtNcIKAJy2BrUexcyMpgORmQAKPCUAps6OyAEHy+JrcqGQq6pbXmldGipClldCO3SvKYImQ9StfTZkb+mEAT/Oy6YYfOWJBqVl6KU9CIaLOVNXfEYo8bUqJRZqzxQx1m5WFqSppAjDHGBvBFrEhpoBZrTXTAKHO7bt2bsFFoZutz6zSq9m1OtQrZ1lw3GSQ78fhPMt2KeOx91LdxkEn3vLCy/JEJsO3zfP/9/j/Of+7tN9UXQ9BAaMQKDkp6JJHq/vXfZ+vrc677/k30DjAnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHX1BFA5vS8OXpyLB3eV4d6kEWDu6Nw1KjowHN7XAtyBg6sK6KVxggHmwcKfGBqxzA6DOWrYaCYiAAvYLBNUpazE3ePRSg4cb9N6rOM6KhbFbasi/0wWDhdCGR0iBGcLPtkAOZOYVJG+rpgwVQeHAbbpGLhJjIqUwooIMqk4oIdFr8KamDTYOwrEa5asdjluWltgb0bk/9Jfpad4yYJAs3OX8UO8llNqDGxPPUhhNmPiMnGLMetd5hjdZdtdcvrsxzt75Nvo/RdaRxKTUeeP39b/f65/6o/3rH95/z9a+5LdduW40wScnUL0BhxRIqtoAjVgoFWrUeJIZML1sViqGRI1TytG/jR454IwCrcnxDLKBkCTD5FTJEHTCgATEAhzmAhjDwAQELm4dppYCxSH5QoooCZNBq2ywFBE7KmJGXp7QZ5XpMDodagjA4eh4qBKlFMYaJDxEw2i+AxA4jzepFS4VFTD2wwdTFihmA4IoQjPQr/lETC4YLibhJoz8tglQKL0QjrnYzfn4zL4iyp/rueFPGLM5G4opfEuuEXr6XihrLUL/HGs+K48XwoM5HPZbr2rrckUYpAMx/e/3X81v//7z5Y/3Hf7/WG9/asgE2ctMHaBx1dL5VyHlhr/Q4YxWnW9XoWO0Me9/frFxcYTB5JURAUlA2ERgAVQrMDadMYBDKAQMGBRNLhgDAtnDDEGyIOVzyyvEUnzitciE2uI8523BMEGu7Zgs4hAIYAg+FgMmAXnZtBS1DAhNfsdt0ZIhOUwBpkOGHCQBhw8NKoBKIdY+yxzYs1sQCos72p2hJwdBHE+VRAEDGuw0AZomy0kiL8DGmSbY1Y6MqMkkmVhQaBPmgnAuA2cIaWzMtWWkTI0CgDY4YMN0hVKMDg2zIL2E24sw1ZaKbrZJrLUor7L103XSMCTdSlLvt9da6XZa6ttS2/q2drWup9f/11+tSl3rr+3vW/9/rq6lMugXVGR15F8QzRsFV8ZKKxRnwMKgsxjgDzBQIQFGddBlYAyWLYtkaUIGBWqUFu7V2MmaDDUogqmUAS5HfZdGnfWiLHDTDAA8wYfXXKakLMKCRqjbkvcQABxRiDFVTXqhltfsWa5tX7JAUENAt0tupGHZlkEBYuk0TpLtJLpQX2lnfy2/0hn7UZaRq/OpyXS9ss7Qvx+H7utCzeOl4tC9njdqTj1BAu61iJc/L//v9/f4/WjfTrbnLCI4UKCokYXU6l6EKQ87UUS7Ai2WfTRXry/vfQurY1QiU4LgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB4yQRYOcm3DsUgiwd3RuHl05FA5zS8OQJ2LBzmV4FgMYkCJMBXzSIMEhc0R3TnIvEQKMAHg2MnRYEKHmEjSjmziB6JnoJBBheVFvHTDgVf70xeFX9lS2lPufFRoFohq0yxJDEvMYBBFJlqDBCGgcMFAE8XiMBhMRI8SUrYFQYtJnmDxWTjgVMjAiMyKjI42F4KolxfAemCfSIlM1LhmNgMECjHzacGMJIyNxzQ+zIk8IXH0DYohU2Jt1nEyiX1AiWanygNs4o2JtQNCArEunUzSkyNnWztUdJpFC6qm7KWVrJVJ0Grr1LfqQZql3Q3X6utVlqqd9fb6f9T19SvVVVtRUirpfUze3V1oKUpSJw1cCiZ3m10QgcYIKYYphEYHgAYci4cpiuJEENAoZBjoGFgnk9kXdJA0x9DXBKxUCqzD7g6KatI01ygCXM+hEM5JNodAg5kJgokCEaWNLgp2gshA5+YxJ0jjuRsQtak3he1rg6AXlh70uUMHSFy6GImpdNCJkqRQAFuHui4yoXCTUPgEwpobPLYhCmxdJoLomhcKAXOkYGdGsgJA0V0iwLkKAhh5IR8RBSkyeLwocA5UO8pDnmtdeuy15mRaySNGy6qSZuv+yrLov11abqRe26Hpfskvts1fq3/10NW6/UtrN6v0dXV1d01JJMiqgeoDEoBIgRB6A0wSAjXD6PWggLAAwqUju55Dhmwww0UhYROk/MaecLBEz/W00YaJg7arwkx8FHmZaiAv8kAdQwUKkeUgG4LFmRkPhYZrOiEM0gFCJWKIcVDJioCgSmwcVXqQgcxrEBPVBcBAkqcd2i2+9NKJmDGRSBf4KrsdrzsppZRQko5+JXlL8U2oOlFHeSYwwyY1HxAJfmUV49vHPUMNMmx4LB/x6Rb3M/HhCETRbaUvvY73v7/Df/+O8YRzf85++ZZ4f+MUMLWpiljmkSYwIPZISzi5AISQnhMgBhcPzz2JA+74uYD/oOrqUgTBcRmHgm8bIljt45YIAxjuNGoAoYeBJK3TR8IMBgMqgMCxUwMBdYauxwxQCmhwACgDDluAzJQvaHFVQqMpLwyHDYZBZMAyqBgUD4bBAHMOiNElv4ecIEIJl0MOEIAaZmNgUKosU3rgUiJW3IVbJ9u0cIIs4/qGIJoXklTpGlInjhSzkznMAgVcVi5T1mYVr0ozXdnbkaQUrWDk9i1AH91cmXdqJFz1Zds53vMI4kuBgLdBQ3u/vf/+u//f+E7y/8s+/+t6/dJwsMZSDC4otEYTaTZWccLKx8M+5ekS9KJptNz1SL2Jxe80XWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAedTsUDu8rw4+nIoHd6XhutOxYOcyvDbCOiwc3tcJ0aDgt6sRDuOhcYUVcZEiMYIASDSLMmyUMAwHWAMjMhYkJQOAoylqYOEH8egCOmSixHZghlYstN5G0OSn1hHuMNUQaGvGuoOC+mBDRhyZHJC+tgQpo0AwC6qewIFyrsgoXiyOCzFbphn8KfEzBjHySii1TOCHiXjSNMIpF1vflKNRuJCNuK38LWDK7ESpYCWHxmH8VzLBAdE86dPHWGsIabW4gmqaaJXz3jQy5tkfnuuPXR85+PcMud7ruqkr1/9z/vdfvHtSK8LnBFNIZBYTtNKWITAHqItUIwPyLEoWvTtQMaYeoLsWTapLg7AzFOFROPdJQGgBVPHYaR9MXQnM3gBEQEmHAYnRgVEQ8EQ8AxQmz1IQO/DR0KRJSh2FiwtneX6aywNpWRvRaai5wOVSUlU5WOROWYyGGVDKWcDdfIxdSCFFlz6jg4aBIjiGLSab6vV/qP243HJUgLMEvn4XlLJjjNrzgGjixGWw7hXpXZCiSRyvVaVsry3HpasXUvqpMUKcnLFK7Osfu3XuyR8t5rWs91aynpKHPZI8EmxxuZ5fh388vzyrRu1+/xw/Hu9Y7wnTgEzRcc9gVF5IX1OuzksN2CYzXvFr8qIksFXtYS6mxXJhJZmaBwBThsN4usGBYzb5DfAkEIJMFC06wQiIMK7GSSlyWABBs1DaQJwMEkxNg8FAztPgYCDsHy1Mhiyt1kwYTBkJu4pihVRmBw+YnCqXNXN2xQssXgGIrwLnABMgpLo7sUeyCYJkkP0hUEA8rWJfLsq2byvnDxMVGrEu3QWYQKERbDH66+as5KY+u6My/JQuuXfgjcQgfLDPd987bPaL5Phhnv80XaDOasT2/1vPmeX/hrDdrnP///e+61+U/sDCzBgVS18xF1pstGsAbrDO9a+9zW007pFMqMNvTWv9AnNMTcmlrOAQAUwnMzGwRMUgYEtIcdYyBkjDGfIAAT/xDSj7dBYlmNCwRYtioAZMtx+2utVySzoGKgRIKrsKgOKgF4QBZgJ49ExOv6CRkWTHhewLgJ150OmIlDqypowp0LDXJtn4iAAaNMCn8rLxSpkMXbEZgnSCnm9UtyHjCwlqNNzDNPTkq1JnGysS1idZh9nGab7uOXKR1MUK7GaOtfXa9BTvw19+4CfjPDn7zy7r8+f9PLvOKWzDIqSgRSUKMWPS8a1Ew1uKFUzl1OU0sNuNMYrZXSEryp7rtqMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGpk5GA5vK8O/yCKBzdG4d6kEWDnKNw7xIIoHOUbghCJZ9rtZwkqTH73BVNBQiMKkY6GNQMKkfTIz0OMV3ybBspd84iDGiNyAKC4UjTRErSrTFFvrTeULmo4KoWKdjx5ICUUMIKX/vbh8tasGorD7igL0MQDyLKR3azN08UjdG5AoMHA1Yrjbg2UqoUslPF1DWfvY8mbiJsj/LLT93almMu7WylbKLSXLq/fmNd5jqdksOZ3G4fd39vJfNV+qs5rDL8v/+d/n/yc/f9/fddz/9/TNJqLi7iLZ2rfAK20Iucp9OutCanQs+pTNe/5JxWlSQyIRwCuG9D6MSFgIaXVAmrAcQzChgP+G0xUBCIFGYi0UJ5ATGsGEDwGe9TlY6xxleFG2AwMXlMiLVfDkQMZK0yYQ54kdxYILR40JgeW8lRIGkTE8sTROOxMTAT0mK4nB0LIQN/3c0vJrRrYI1+N3CCG50Z0mDEDoJhGxOk8gbk0OcAceE+GxoWkQ+AeyccjRQJVIukHZKYgiNlAsFxroIifjITuZIlkeXQUYm4YNBZQVC4OJStTNda12lZdF2troopmzVJVWrrbtXXU9NFP1K9taFletrve6nSVvs9JS9r6qPszP1X61VP9a9qq9rJMpCiZAkNiEBS2QsaKoPCmZEQXKBQSn01+nkE8ZMNGcWC7kSOKNxHAUZNgRZiGxgGdvrWMMmXF2lJqMpyusYMFxYBpQHU0AcGYEEYRAgygeh70qAgoBcy446ADMZFEICFnGouz+VTGm8zhgqhIwCBqON1HIqVw2cuESA4xcL3kFLjF8ul8GgYb7Oam4nwrE4TpaGWIssmA/UsALhCFUo6zomZDBtnBUEERZ5s01UQp4NCK5HomqTLSVWt9nUT9loqS7tUgVELJvWg1atDposldVrr7ILutXd170bLrQ0fs23dS/Vqq/3X/0e/+7WezskZrMSHgYFgkBTz0qrAAKmY+yb4Dpi8GGI1MeBWphkFBAIMdsow4AGtV8noLcGk44CgpMrEi8QnzFASlUrFAVebtMmBAgMgNWgcApd6XmCwYYBHDqUM5CnoDjc/sGDATMmGgCEMmJ7prbaYXUgeDY2w0VBQctI3NYHVEwKcgPAVLiABEy6RcmiLmoCEopdF1oCxT6ZaGPLxPEwQc4HFFecIHdnJsUREUIYqGdOrZ0iLiMAbOkRF0Lp6NWquq6KkGTRbZbdFqbV2QXtupbpvWm2r1vVv3vo3pbaS+9Nf72pqXpqf1dduhfVXb9vW60K5xN00zI6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACAGQRQO8o3Dfseiwc1RuXUpBFi5yjcNgSCMFvdG4MAwHKCAVoia0BCD5jFFJmqGI0KBgIQ4hJQRAGsQwJBsiBFvntgZZQhDJhvZhYCtEKoNiGbmg0cTz8iIAK1MIh4wuFRAESIYKZJMy8BAEwyL0aaOpGgoMAUGnpaE7BQZUUCh7DoFQ5rNUqdVp01LBUNGRRG3t6cMSADniCpJGoTUDSLhImZePERCRIdxokWnE3FQulsmDYxJ4jQ24jQTIk0amQqTstyOKpgOWSJiLgSdNMwNREBHw7kDElnUmjW7KTqWsydB0VqbdHMEUU6arKRet1INdTuz9FBDtUpSCmd/1dvu7e69Ndb+1JFf3611r2rtW96P7OtS7KOlRSKZNGaYL1wU57+IZGHooBm8o6YeFx+YpkRFBQGMeJoHGZzJHSR1ooKrJQRwv7O0qxDYUoVKV/tDTcl4CRtMY6iECqcNEAQvW5+qOkX0TFGUs6HS5rfg6YHpUEsSgVSlyo7GmvBYEPHGc5W0DhMCOCfOAdO4MwYnioeI0rAClyImyJmaCdnWOaUBcp41PClkx8nmLB12WmKYPpRCpmAhIaWSLBNi5Q9Qvi0jl3prdddkqln0tmoKZeyl01m71+lf1VNReyl/3qr6lbfq2V/tqf6/q9VSqVlrU3q9eqvspqFI65xcQAhAAysP1JexQoB5oYJBqDJggChQdKFYYKWPAAVpJqqvc/sZEYMNcT4FDJnIBA3KzWgqJ5uXKKNDcKWiQBKgFIha9TX40mUAhKt+gjNoGiRClpEXbkYpBYgJxMqkn1g3/TffRpsyzIUAxhQLPrD08ZKRHUiTgD0pDiqRQzY0LAW2D6pm06L8kDh1Q7zExMw7KQNsCzHyUEV4+hz3IcXFDfZkFrIkWByi+iOlFmQqQf0ly7dTJrWihekZH6kk1qdFd0NVSb3Z+pCqu+pb9SCm0V11N/Ztqltf+r/TX1MyPWr0v/qdFbOs6glNnAKnZe+bEpWk4Yf2GSBAQdGIyR1c2YWAM0M5ahJMa/GKeZfoyAlUvsiQFnUamZKWwjJE2LM6hwaMFZuFUBMLAHfSPAAg/j8Tj6mBk40IypoaAg5I3MAOiIieN2nmYVF5VPUZfYsArvYX3JovkXQFDgZqqRFIwNC0iiBYgIGLTKWOabzRYo6JnJY0IeVJmS66ajIzNBOjqFBo7KLIpgbAWjQnz60WX3tZSLLWmybNWkzs59JSnWj07VPr+pSvdt29T1Wp/q//27eur/9ale33v9fWglsip7qMnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdhTkUDvMrw1MjosHN7XB/dORAO80vLcCNigc3pcTAoL0xg4AWeMhBoNGJEJGcYUCQJGA5CGIJUoLXwAFBYFFQCQzDThFlTm69IjC7wCFNuUNJMVDS09gyAGzp7xgkDy9SIeS4iC8+gDAoioIfsQWFxDB7TI0lKSiowEeA5BMxUzUKYLB6/o21xEsqRvRhzGUyqPVY4DMlwRizL6bUjFYa/bWdd65/KpQsEmtzKsex4KHtzTe4/289DwZRmxk9t78Lmo818oQnom0Wj3+sb/edy1ru+z+sO5/zPeP4c599iR6gsBBMJxYEoYUImoUoDJ9qlD2CybRZ9vFXkMiLvYSafedbSTfQlDhQPqnkaZzvuWrwyGEANWLZhcinlzgViMuqY7VgoxcKh3qaMNXmGYEwjep4QZgHN9MIZy5AjSgZKdB3l4iRxLQsDGNg69aedekwJJIgtWaAy3R2YWYahPNSQuUS93ZfKnXYgChZ1r+X/UdzGAgKnRaIWML16OmCikOZ85TMau1bkvZr3VND+nIlPc4E/uG4Lg/Su/stBt6x1TU6ygULw1AUSnt/3ncu/l/5a5Ldre8woeMc1CFLgdsBKUxY4c3YidFzGne2wC0IWeehc45JMOO3yCnsHrtdSYIBKAAECABTERnAAaGNtWGcgoAIAzCkNzckWBoVmSA0gJsEoRZRVa6JAc9Ulw5FokCRCtS5c5l8iuZLwABFRpEqbmGSa3IaJqDYYFoaBQoFQeny7ebpmCgEEDtSiNIyGRBCAUoChdXVvQOKoiqp5lD/odyLspfBmMfrz6746yszvdusxfobNRgoITRCU4STKHJdLsZ50YCmnhQCR0wQV5cZI49zLXypJGwzuX3WpyDmFXUtpULJVEXpfPfM8f13HLX9+va/f/zHXcdd79WwjN6UYoShTVhuwZqNR83eQKuKnIs9uogD0FZ7tNGoJscT+ELRnfrNT/3zNjRHgHK5dOdhLEmtzQoAzFcJNEA0wwATDihOdMABCVQs1JNFoNoGFZnjMTB42HZgSH7Nh+wU9NAh9ZfG1c8zAfa2utjQGLXYBouZEUjwPCb8PoAStGkZBQwVPNmHFEmqtTV69dZ+J+MLIMAHgDCNUesWv0k6I585ejOc7Kl5BUurDhjqnktns9pyr83yNac+j+tEefuy2GerrEypGXVN8wqSWPgZ1TxyCta7r+93v8NZfqRlGEOmX5iuHOYLxEB/f7qPbPUkzOu/+G99bf+AxffWnDr381nv/27Fobvt7r+f/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH5I9Eg5yjcNLqGLFzeV4fRkEUDnKNwyrIIwHNTbgtMYWCqOD5MnIgwanJQS/BECzAiZNgMJEmfLTjwQHABF5YnuBAccfuhiYAOWGCSXzbODHgSYvBRf5fw4AoCMZEZhRQGUMQMJIZGhWrmRwrJshAOAgJQQqBr4QuxU+BwAmGXQe19eitcLgrJQCxZhZqgVxCo5wzwG+rB0xVLiZNEMJ4HAwusRI0cyGOTMUTwbEgViiJagBEYkssi3I002FSTD+GihZJ48xqojkRW5eQMh7XTWt3NXWkk8qaloroGj2UieazoJm6CStDTQUyb3SdJkGVrUrVdDrSrRZGg6NJlrXaki6FOp2dXru90/+uptdq6b7L6VFaLs90DRaQCbyDGYOu2IRgMwo/TI4VSuMGGQ6cgRISJVASmLRNxlVWYeo0BugayDhSlo5IZQMv3SlzZ1R7Ax0knWrpuCRffFBAQpz+ZxqmBBcPCaBT+igMY8qigtMxt/2+finZvD9K/pqKOPPVJ/Gq+VNJwptUyyzsSvEFOtTqZ18Y1Zucyd3LGtIdshs2dxa5llXoZy66+PuD/P+tcaLAm8rk7rHf7/+d7zf7pv5reP54Y571qpnrePLw8YPAgylAgOPYwVRkNetrx9a17t+LN/1UJICaKJSxJhECGGwE7kRU6EQVMk782IKRoBGCBgc8GoKEDKxgWsHf98o1NiELmXNKYFAq+C0dSUPUYdAzVo6hyeZp0CmORnCU4UZhIOx8BBFNOBoAkceAIGFha0FqDSTJQsMAHISKjdEjouh1lbezqthIB06moUkHuo3C3SRMgc9OI8IMPBuQYvmINFJE0FpGw3S3JBxPkskeGqimEIE4iYkQZBZgUBYDERmbsNM1OOi5fFDgsaKpwXhXpuyk2Upa00VJpMyaloVLei5m9alpNqpNUtdb3spKlTbWzJqqoLTWvWpr7eva2j7dq3UesymZuvd+7d2rr1boO6KSNdB5geawy5oEapGJmMBaRQ8BAIwWajg5rEg0qEDGooJjOoTajTNTrq4FjQFA2rMEmJNSrBNPk+7phDqj7QmBhgKXkIUx6lVsn1JCqsdBZDFGvnROA0k6liPzjcqzkQXBzAwCLgK1eM0zchxcIaBn+NAdx0rmhgdAJkRQ3c3RGqko3YUY4cMHWPqtEkFcujysmLDPGDIHZSKAb4YFkpoovfRU765q2te7K1rP7VX3r9a71KU2pe/6vV9W/rWrV6m9/6u1D//+r9X1ooJt1rUbgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACEuQRIO8o3DOsgiwb1NuII5BEg5yjcNQyCLBzUm4LOkAarIWun8CQbMRIzMnQvMAQQMAyIM6SRCACZKRASRA+wFtn9FACDQ0aG5hgUDMBGQRH7cDGHh+v+XJoNuSAOJmQhNI1YVDAwHzAFERgIORDk5DpKEQ4Uq0rNSWMLlMwqVhpgEACQaTiQwc5r8nhpAORBd9daTJQvhICUBQYHQDF8dh42cojwCSYTJnMUBTCwcNS6GxoMYgsFcNWFpRNCwqnUCyP6AWcWgHomZ5KcQFpDQGcUIgpOtSdFqSmWTS7KW6lOi9mNlLTWjXWtloOumylr+mpS2ak6DLs90n6Sb2rVdaq17qTdKtn101qUyTI61PbdlqSrUupS2U1aD30002MFHVpFFzhrEZJDkYbKm8YxjGqgwsEgFRP/dggXXyMTadr796+j9nwOl6nlEAql+LmKMyGbUTss9iBYJCo9qTKRYxICAACmKbOE/VAJYiKSxOBRUXMAw0rTNSqB3BmmXzFl3SoQaDHtonSiUS4PsDVIe0DI2NHIMBHo4UzVA4MYdMjpmMRSRgaJrJNR8i71VkmkNe4+UdFzIUIMamxZfoW2RprQK6lK1V1JqUmrpKs+7Nqs9ta9v16N9lepfV/VWv+u336736tl1a/sgrWr109BjR1Ipl10DDFoWd1z6IaB5o5FhKLDBYBRyczHxgcCrQIR8zwvs7MPNnJAacdnZjQBrqMAAG5LHFMMlSQwhHpfzLH+BRzRBQscISEXiIPmDwC5sCTspMAi0iAqJLqEIJMhlIDB8eaCHBDsrxDKSSyO0SVJhcDQzS06ZFiGCQHhogNmgtZJQvpkXKRbHGNA+bHi6MeUWNCmHoKKBWAsDOjuKSZiQqa2oh4lBZes+TxJJTZSYpUFBB4skcSCCnoItWtSC1lp3ZBJ2rRqmJhopMta6S72ZzrukklUtJSSClMyNVVb2UqpC9ddlIVKp7bqT17Mt1o36nXdK60XsjU7da7N+gZTqaJucLxeKSDtqVQK7EGo6GB3oYqAgAAJg4jnFicHBlJIxsDCItMEkdFAC0Dq+isNMCAXSYu6ZUVP4IMwdckoCBkB9+FFA4LDghAmBVQZlVlqySJQoGjCn8YMmMlCYRWeJWp8K7KLTXBwCbgG0CepjYzlIsjkgauWykXlMmQ0DwBPyZ41UW6RkZLc1MiigXzJAxL16yMIxRGLclDV6FEWoSY3UaFfTUrW9KpaXQWug6DLzy63X3Wtbshde1DqZVnVs62+r1LfX/t/1r9f/+t37dV77+q27qRRQSSoHgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgAjUSDnKNyuCjYwW96XCBJ/RAO8o3LYKcigc3leCACmLgelCxBvRCEDK28N0hwwwBTBhdN8FYwIA1rEQfGgqSgmCoZZyTA46cLCsirpEg9T0y0gsSX5gMqgBs6CJ6TDAFC4TJgCrLB8GBYIGBg+vdzKV4SAotLSwdsRAg1MHzAwvFky1RR5xSAB2GvwItJQMFJlT0xE1KcgZ8WsDgOxbzIxTImTJYC/ZTQqUSJkVzcyE9oLGdDGhZFClVykOxBEwSI4sGxACsiSyVSzUpiMhI0jMpkig6aClqTQTW6SC0FzJBrHKnUxqtSCSnNk+3rWt6SNdkqSbK0r3XXQor2XZ0VV1Ko+tdvpUrruz/XdVTL763UpSFdarMylLNZzUAAn3eRoVHRuIZKdD2ATBw4mHFKqwjPgK8JiP/SWniSlMKk0m+AIGr+9SaOOSM8mjlYIFSUPbWHhoPpkBA4CsdykPRUOwVOdijMzLgETisE8TYocj3xuafVO044doWVbd6vN1LIKMPfhTc1hAZiQkC54aysWf5t57/LlJqU0vOWf/DG5S6letwXY/9Y1nwsWspRf5/8//y1//rl5MywOg4MDY0QvSTCN/LaLP2I3E+vb+O//5+WS8XLAYLzCoGkuW0S3AgRGGctGLwaAYIxALhpIOJgEACJ4gFVHMYBC56R6yoCjqsWBR0WuGDirQrxMSDRq76F3IHHQOygsCQKBEmGCj78SkWB4oRqOM0EMmBBGHEJVWHgqADZ4vMCjEoQii0VaxAjZ5x0nCEINMwg1Z8fftjEpkALiQGzpDfLRSMSsxcAoCJ8umySYucvolsniSMioXAbtQEJD7k2ONZog5sReNpA8H5JI0ThmLWC0cixAB/J2yqnWpkkbLOJrTst71rpbKepNSbPrRSda0NazWnNV3XpXZ3RRTvW9a02revpr09VSS09SafeqtlLZaOfX2nukVFbqu86rRrmT5NNk8icJW0xKzQM1QcDjCI8OYiUHC4viZ6hizC/dW7LCUGM2xkBT8g4hk3OK2X4+pixyRTpkI0IAseAGihAdVQliABd+ZvV1QjQGVQWEwcZ8AJWFAbKiUBULR67doCiKEw/uFYdxWbv0kerxQGqK8iXM72cqBD+6DLL5XhbuTa/I1csV/YxPf2d7h+FZ57U3X67mtfzVZRJvLvXoqfW7+t/h+HP3rff73HDWP853vb5weCouIXm1RLDQmNBMelc6lFLTgEcpKe4cygU9xJbWokyDU2NhzvUkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAHbk7Eg5zK8tJH+KBzelwf8j0QDnKNy1+nIoHN6XgeBgFEsCMETTDgIZ/VhxgCDw+MJkY36MTBoAfkwoHiIFLLhMnbEYDC5qzAmBQK3QweBZPitMxOD4RSF4mrs5Z2YVFIoAysIVxoAXVEDBoZY6/c81oACpJKeYMQBEyUYjApZHhTAUCpQMKjFPFFxqGGc4/V+xU5agOQMNMTFpssouy+do0vZB+OOTmyuV3uyizYzSavvfA2ViPfldrUkqocP1K8N5Z41hwFsU3NRHf4fvusv7r89fex7+/1v8fx1rVbsZLzJqfvE8R4fhY73PO+nSuHXLrP2qO/+9w/hqD/UT9v2XivnWz17HmX9DpdsCLsedlhSBZgCBmBQWRBEql0zWblA2fmMSIQTrYmaZnwUATf4sWKYaJh+T4N3XzLrxADqeiOzHDVHdC1J8MFJSrl4GhT/ZogENSFA8NlgADUZAMGjkkT+lbkU8Zl0wF0JjorbV53KSzNHHYNJXLN45X/CldkgCN9Zy3uKU3cqjv2r1qmrrB6xxn+WuZSSY+KXNQ/hr7us1tQXnVuTmDhcDBElAwZCIjeoFiQqlZ4TDxA1IcatosBIYel8toLjI96SqFrnl6Tjz1ZexItv1sl9rkJFAMDBwtduM0DAmZp1ZwwLt6CTSbhRgkA05DBpcGg4/MHwy8gFERhDoGBQEwkwIFqWJwgmBEDy4YAVOSAB4jHQ0eEmHq5BIM0iY5hYEtOmoGrBcsAIiO4hWKBYygfzBiBAwPZe7LtxZ7YYg+SNsYmDc28mCZPGJQImQ4DCLCIokUQIGakwFARJrUYpiyi+mVSsXy6TKw4xEOJpFMeWN2SRMUBQBaTFMIitTLMQv2CxwpkDQLydnRVrRTRUkXkkEtS0FqUp1qQR+cSpszIHUEFGzsy0fZVPf1oopugzo1st1U3Q9NWip6S9d9qTUa9bVWayaC93rWk/Wkuh0lVVmaRFnTgJizrKFNzGhRB0TGgKYMDYeCAcEUVjMmYOTk9XaswQ1454GJi9swkEY0biAoazro3q0YTRhZ46CnCxA4RfQUECEabSXUkBCImREJANWpR80EUEg4aQGiQppjtai0AP2XpPSuaFVnOzNuGYk+xjjSonkl+eGqhdp7e58wh7mNNNw1S2aal0wTH7lTWf4Wodxa9Zt3rvfxt8f5Queq26LXd6/mv7r8O7y/v6/LWP491rlm14IBcq1wHSWOFkoWEGDK7xZCUEFy2r126SJ+7b0rqeeSQFHKCIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHYFVEg3vK8u5yCJBzk24d7kESDe5Nw4XIIoHNybhqJgpnSMXXIKgpnHmcOFq4MEFj4CVGl0DNzQWTEJzuyJVYGAJ9cyNIrBgSKv97PjEgCinUeVPMif0x9HR4IhkQgyEuGlThg3DExhFDAQgiRWnlAMxkx0iMEJWc1V8psKy0tLKFrKrHgw0mD7NHUtuli/BshqepIvKuYSQDCvZhlqu0mip7c07u9VHLyTSo/qvbzPPHOBtMBouMjvW9XJj24pmT9DK8Pyw5rL7mub/Ds5vuv3//vP/z+vzfMua7jnlzn3+E/Ky7tAU7OS0fhe/Jqrm9sX59/o4kufeP/6t0P07z7M/jb5CBJoeBREfBUKpvR1DkQBkwDzTHwnHgyYGNpoY8BgNZWYCSIOCcFRmeVSBILMCzcsq4Rd3VWkMVhKBZwLgBbzK5QYxBj1lAInWpy8wQHhAMGnP5edkwGKw4Cl/lwKDmuQYMgseOTPXZJgHOXL7zUQoCQMykspXA83WaObhtI3iLF0qm54nAaYRdE3RHwamJcKQyRxaY5aQjQ1PnjBaloHhvKEEjBIpmiSbKMRyARNRJUdBWTd96kkE0q0DZN0tmRraiyls11v0a63q6kkOmqpJBtDfTVUtJlMu219L9V1VfUunQ7WtVfrX6TKu2zVpVU2UyFcrtzMNFGhPu/KpjRlofbkTgqqGvr6ORIAgWVLYpLyiu8C3z7mMeO2SgUUluThjo3Iomre9qy4yZUXDoIrDHSZSkS9TCgdqcs46IXQy0q8igDaQGQoVA3YxYiqFnMH074t2RWBhKl1J7hdHonB1kaWwA9OlRSki4OSM2bGikGE3IpmyQmRxA+Og6Ii5qWCTdZutyCGAxyaicpumZEyOgTFIxKarIpKQprUtFE4dUghuutalJoH2RZS1IKUikqloU9d9Giu9TLd20HqvZtNGhZJSna9V7VtrS1aknd7a9tLW6N0NNlLU7s62Zqay8xqcQM0y4YOCUnWO0QGgUydDTXITU0MECI3sQxoOruMWDYWHSwsWpW4BcAN02B4emy9VqvGzICGRxMlBmLzspMWB1VE8YLa5gYKCiQGrTZ5ERAcqfdhkgoCm7GyyCsrbHBjXohRwJyHEvgEqQ3Wn0iAm6llUG5YzZgWUFEwS4NNQdZ1yTROpF8h7GxZIEgIDFY6kU7JoGRTSEEWdJkFnTqY+BBNRRJpTOpJdToIOt1LRTv116lor6roUae6n2a/3Xdu7vqVXp1VVV1stqqt/1epbM/7LrUta61bKurrd/Z6q3PWMEyimAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACDOQRAOck3DVkgigb3FuH6JBEA5yjcNkH6JBvelxDAGChq+S5lSgkFGZLYb5DDSjCY8ORkseD68DAxqQBEgAfemXlDBxtHDxMW8YmBti4rCYrKD+RhMTOC5gSLQoIlIIc2DRsGABeD+ujQaMEDEDD9RSDSqHjFJjGRCPE9lbKJxN6IsXpZmBE/mWOzwoFojyZJMc4CwB2x5KcgxGkNAqA7io5swfiT5iXzoyiaRmGqTMQhNDQjx1U0jNRTWIJILFPNjy1mp0lAXcixMETUmtI7tM0U0VubJLZJ1LTU13RSTuzp1JV1KTZ6a0amSspVSkklqSppNWgYOpS3d1a6C7tWiyr01KUlSqZ0FKSXRXWnVoV9a2WtTN02SZtJOimXmMzVEok26TRWysUftiBmK4EhCcpUQzIV5p7WzNlUWU2rQuWqdoIDEuRmUILq1Jt0jCgeFZJprhaPoDAbsuUqmEBV8aAhCSRiN6waiTBS2lfJPmNlQNLyhAbgvmJp/VJRBtMnIDRyJ4zpsRqzxNDqBfF4tH1MmPoQSHhJBE3Gq5dN0iRzh1IUImqRBGtymTqAnVSRmXkXdAxG4KVMpTPverrdaDrSfVoqXWpS0q3ro600V01PsyvoK6l+2/VZdJS0OpfZbf0G1L0X1a+upN/ZfW/32bZWs8lWXUz6aEoygCy+cLYWIg4YR/BjYVAQBg0ymfT0gPcAxWDB4cJzvJJ2FF9zXkzBwPgAOK01GxUFEJPem48UcbhD5hgBkoWZeoqGCioFwaMgeA6fJ0kdgcWmJM4EYFM1kYwMGR47Mbh5xVb3cWY9LLGcGAwLIreZ46dJQhw1AEpBGhPqQLZSMBJRwltEoJjoLyCzAclZmXxBxsJAarKg2UDE2c0GEsV0uyoRPdMyFJgMEjUfCBvtQQZqSKUxLlGmdZlKSunc9Wo4qipdNmZbpmiKCKkkndtDRSrW93XZnvfpLejs7qrrUtG/UpCldlr6KNSmu6mp/Z3U6n3ZVloKdToHZtZDgFlbqvOkaZTZgb1bmGBJ7QIiSgiMUtAELPRSWmliIBOJzQ4BkYQLSOkdgwUsajNBYHUISoeYwoFZe2csAYYWS0FDJgY2s1/+zAgSPeQhlvLQO4LIKo8tkiAl3ofeSOw22JIY3Ruch7e4Bp5Rt3WzTsgmvzo4aAgGfua+u2KrQz1dv7ucxOTLX9fQSnmOtTM/cZ1nt9LdTn9qsYQPv7qXygHAlWhNFm43ENnCOqOnIupI+wHc1rfhSHWFf97Vr6Vmm9/5m/W/r340//HLUe7/d/OTvOmU8iDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgnkEODnKNw2wkokHN4Xl51gRAOco3K7B8igb3pcDAAcAQzEgcpaj+YEABoeIHLAQIwOYMGp04jCwcRPESRVXcRz5BZC4MMR4xQ5aIGLEtlC8TMhIXVFkqsYs9AyGBkKEwTQ4CRN8QA4wYFJU8d56hQTDRGgV5EkAdbAsTBIzNx3AycrrJB32xK1L2nrN9A2KIwyCj5AysEOaSJeMD5fGfAqFHswYwjrPomZsSSy8Tocw1HcmsvDJoGhumaDsLohM63J+iZIJB3QxgYmxOFdZogkgilTZZ1zIzWpnoHnTZVFI9u7pOp2S0U0ls6k9Sa1rUp0VIIPUpdWyak1MpKhSdn7KWkptPTXWi6TMzo21Wru71Ko6KVTNWkkugu7JorUjWuasgUvdpSd5DmCIOYTBpcYqFYwMQ27MUNPIiJsRvjFKmSzo7w+EjZio0WQinb4wBNh+YEIKngkc6hgpUul80Jg0gvwYKEGAA6hdNXsCMkLoDoVmg0aOKkquvvNHlTiA5l5nphh6SjzLqKao7lejvUIzFi1FVuUlLGS80DfhllBd6are1C/hcxuxmi+s5/8w+URjGDe2JVznPs+5YcaR5TVrnNfjzeP//P/Wsscql5U9Yhyu+ak0et0xSxR2H7v7/3kebzPb9cvyp1UrGCm//V96Odbnu7/2feT6tqKGEgUYkDDjrlZkCAOZZl5t4HhguJTAZkK5eRwzFwcHh83SGay+hAAzOcVAQVYkYTAsqlDAzOYdY7DKcmMfaOYVAKshQHyUEF46yY6tTHI5JtmAQULAJFdmojBxmcjmBwwPA+dgtliUkdVJNQcvZYq3aKqTJimJ5KxeA0gQRuSCyYJ4yKgBIwnUrmApBMypjoKboi51jOlpkiaqZA3IiZiRpoDUQRdNbGolFimYJItQuY3qZSzBdBOYpGK1utFJbIp2es0dNNaabqRQU9rIKWhZN1zXuxmyPBa7Iz+7lirZ9j33+qahVBPm6acfvf5vt/4MKcVUWUxFqz9wKrGZQvh2+6AJDjqQdOJGUhpVDVZJmwz9sBzbEPGD/GDgN/2ulREypVE1mo70IWM1Z4oiEWjthQHKoo+1yipTBixpIQgmgKLihYqwxZW8cJf1nMbZbGXQTsT2nLmc1Kq0E9iRhDFN3P9fBVHZ1/7mO7sWnz3hcpsYl35mVc7jySRXlzuMks5bx3gz13LNQROihZZYONxalKUChfdC1cyXXvimp29TZrSKtSPsE/dp+t3aoD+QFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHu49EA5ujcuESCJBvc24bXkESDe5Nw4tIIkG+TbgDAcQA1sECoECAKmBOOYFEZeYwOHjjIVKwSlYYTOAkEE349MzqIx3T4HHzkmBA0mh9qhowerXR1aTF/ghkaeTDTDxZzk4KAQAMwqZlGBdyHVTuoShpjqwoKVi7xrDjwLCoSmO7rxswM1AY7O0584XA/JEZwFow2iGkwTiSZFgFgZdSZRqLjJwyMTAzNS+RoxyBwxqJ1jiMskK4ggXzpfNLOYmRFwuuXx8m6DJPSQSNWQSnWWtpu7Opmei2gtbJoLnFM9VqzFBHSosirZTIqrWi6dWya2rUtqV36Op1vSsurdFF63r9rqQXXUylqZ0Vb3sy3QZS9zRecrh5dLzRdNIySiBWkJAJAYmImC0V3GmDw85Mpr8lIqBm4dYKF4EBAdZtu8YilwLUEAKngwGBiVGaK2sMiydCioFDwOsyOxlwQoelAAMgiJLMDLhMAG40/rzayoUQglde0beyRtq/1iOOs0H4xGNA6rIofSZzU+AcEe6STkPsikLYs6RQeTEdamYqrZBMlB7MzJzE3Jx2QLqBRDeDRKfqdk1MpNB12Wq7u97KW63WyKers213UjbuiizL7s1JOnqvezutn6DKq10L3V+6NLRVvRrWmq9G9Gy1/7OpVST0EFpGheItdCWVy1QM1TBAbuUEgoimWpCd7umNpY0KrKmb71KWHOnRMYveIwOfiEUM3SlwUjOoo+FCUN6bqfRICgUEgMOAiAOdbVbJK542j1UMDaBswhMKwF/1ltuvmLvpOZigIFBazaumSzAa6zoDemymZNEgJgVmZIwIgx0xUmgeOilZQdI4V01o3LhwejREfbI2RUeFlMorspbJqUydqDMfqWt1rQrqdakEE1KV2dTt1pKVqX962oar0Fspa1K6Sd/uh9FddDTVW6ntoKZVb6v/Rs3XqZqdjikjdJMmHYkFmNSpDoF/oAAjR0Ao2mK5IQAxG0AwhAdNMtxEYIC0SQnUQ4D5dgu0xEOIeqioFSYJAB0dH9VMxBGjZVJQOFAe/8Js1BAEyYHpuFYEf4iO63BpHpvtFiCVchbSPQVLwMF34uRRMjSi7JgM4I8nTAvHzQhoCRGCZvNiAIH5SHGs1KRB3IoWkzIn3W8pD0iOE+oyKjUZmWBBVzc0Ptd1pVrWzNSoIIJL2WtCuyaVSLpP0q7MzLWg9akKm0VqrZa6n16kFpIpM7J6D1q1fUq+u/29aG+tF0K1arqZ9k9LP0E3plQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB6iQRAObk3DHMgiga3JuHg5BEA5ubcOHSCJBvcm4Q+BwTXZBCqJaYylDDaICEgKLBEFiEWCKsZigqixDcHU8lIiGbtdg4XzHQa9TriNCf5HgySES6HRaNQ7riSNFnRlpQAIVs1ltSZcR2k54yrccOHmIrwcUNiUXSyjD3MrmG4KSMuD2mSjM2QMjRIrgjomh2l08apk8FvyjEvmDCty/MEki3NRtGZNoIm5syJukcPLFpSYjTc1M0zxkM6RA1JQmzFJbLWpOtkWQc1Uf0FKOpmaaCLrdVVDZCqkbrun+jUaWSZroIO93up1MyKlXU55FXR9KpbJspmZOt09klupB2Zktn31MtPu9Cnuma0icTUbFAcqG1Y7UQvs4NLiD5CMQjPCFOmMrabeqJUVhoZpn2JAE2vJEg20AQK1hPmbjMC5KLq0wPRCAYZuog00mLffZDx+4r2hYWNBT6osqOmFBxYFh5meN02grA9beRVmQBAtFaS9LqTJkcAy45B8tOiiZBl8droqRN0zeiOgzTkAWTxnkk9SKzCLOSWM+i7psmaB4nROJ1qZSVa10UmRV0FJX1LV2ZV61Ksyq+69kdd92+h6voL//tf1ev7fvZvqRra+vpenres8eqUmZDgDHgM0tskXKoSCukFQ4PBcKloKGVgS0jCB+CANFYt7cEEBg+gjdVLM/wu6ZK/QFp15AxugHnJn88OBgCJYcRKRNj+U+9Q4BBwAzF7iQHMyTEvxo4bEud+FgJpTCApFsDHTcpTInNCsapkwB2YNgiqickwXA9UkFGSRiMA2OpmZFEHJkqMQUqLPFRaEyorEgN0ykkglY2UGgmhKLTUdUmitNFC1ay/QshQTOMtKikpda03dTILTQZ1orXudRZkH1sy0mQZT109TtqdNaNekvWm1TXVvUlWyC0WXVWrr1omSd7dVKgs890lqSWs1SdZMFZMtWNYahjSXpk8mCuVly4wWdF+kCzLJcDH65b+4cSGO+ZB4qaiYYAyDcINOCoGskgGnii7VLLuKTAhUAE5ZdCEhoTD+VUGBw0LKqrNSUMaDRAXFCez9gbbrwfpxNUCwxMCS+1TJMTZdTL4Bakyg5xJNMG7SuYuikYFxzIqFE9KRFWF6edE0TukR5ZSFdWsgiaj9SQ6xkkzxkgpNBFSmUiunQTtQZBGtqVBNNTMzpUuu1qb3oquqk+ytdWyk9eupbspka3WvS1LarQve3SZTtZ1UU7Nquup3U61626C0EEknlxMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAaYV0SDe5tw5AtogHNxbll5HRIN60uLsaohwb5heRgfGgDsEQOXUNNvjtAYaAyIOPZCBYSYoZSQEx4y6ciy+l2mbwo8MyIOCqaVl5jBV15a7sUkCu2UGLVVWodhIniSFL9utQSqog8PADksnJAIyY/BAERAs1H3PafByt9NQryQomL+JiVioPoqENA9xLpii6jMvgmEb6NSQyxk6ZsXkZ11ldFUqu6srOPtFjJNLTTKA3jeaJIpts1FlO7pU0mPI113XQsykl1OkgtdToHjI8gF2ONhYXKssWLrpJsaUSiZFU7HPeKvOEXUrZHXXmeVuBJTteDlN3vDoFGIeKA1LARDcw2LmRoIjHCmARWSop9Q8kAfC2ERw2cOOnvgBrY9ZN7mMgKeCxGbGABL1ExK14eP59XyZcCyOflBAcItiILcyFlFMSqAkZOmhmnkqs/DvzUaUeHgCfi+RicWL4yHOAvigbnKRdHJBtsTDKPrHPJgsHVOm5oPaQsg8ySaGxRGk4oYyNSBppLPrQHJGcTOOzVLdSkLroJmyKkbqUxgykpmmnQupJGpkVKRezutaKkTasmea/E2tRpNAdmvdLxn3v9hLiewlx3WB7aNl/+fZzl/tSIG25tF0IQFwuzPoBTR8E7YBYaKI4MXp1TsQ91owT2w8FQ6xwaLzo8QneNdOhWjU9E4oxqSBg9yEsWVjzajTWTcjlycpSU2JCIGbZxz0lguoKGD1SpV7AajRoZpJ8Ag22iv2dxNhOUqCHLV7NJrPCWiIVl3HWrNJzOkndZbsWZZn+ret7+vOfSawgiprWO7tmWY/h/8x5r//m8sceWN7vRsFIFTn8gn20vinO7/T7Br5RHO8UZf/xp77+iXtlovcqLffuv1V+uG/J/MP8T/uBnxQCqkemBC25nlGcqAoWA4BFyVpKNhldIBCELrskn4kMgM1lNQgXssFiRGIbbIZQGK46pKAyYACMBQgwOKhQHEwgTRLJT5goLlq4GjUvwMBjp0CEHzSCEyMMhw2JJSlE+jQ/aawCFvQMjD+01iax5OOXDkcOy4fktalt5RKK1a3/We3LDGrGtY5u5OLGhWW6TDD8NTnsxvYORa3lu5MxxA3laznnV33+/c5zHDdnDnLH/a7lv7+8fvb/P+9/urFf5VvI8WvWfJokjGUyNH4pxYuu9ZRZrnhMtXsjzPx03B7RHZvnIIlk/LNHahzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHjYzEA5qjcuSKCIBvmV5dHj0QDe6Ny8XIIgG+TbgwOBjFINhxsr6EITIL6CA+7gYCDbQDKAg8w8aSgnMQkdSgU0OzGQkNOAwOfsLDnvqsllUueVlb+iAIIgxWCJAqHCC1bEo3slFDDIJgoLtGZssk9hCRD0R6l9NOYRDyqsgn18GNOPfU4ksxFcNyGAZNELgKpgiYGhEgxuPJigyRWKrKNCFMk0zFIbRsaGBaOuicKZZcekXPlVFBIyMTZJEsujp3qMmSa6SLpNUmY1LZbshdJFBrVqTdeiiY0qCNBaXWpS0EkFr6aTKZ7pstfrsymd1Kaupugy0FIrZmRTVZl1puk6rvez2Wiy1LW6KTH1db04LGaJmzXFBjMJAFgT7FgmMEK3CHACYbYICFrwQqcZiDAMYBoyVFcBCeLyhyDGJSbNaJAKiSju/pgAVkIKJgK+48MLJgsMDAEf7C8+sDpciIBr3JAIYIGpCXhIEVnvTjUpd+kr0hKOPpM6ppVYjuOpO3QCsORbpfsbtvZIqu7OD9WKmNmi1jcku07cMblL38cK872JZ4Qfljv8OR5Lujy5+e+8zwzyw1nhjz+d3l+9d/uev3j/2uGcDcIFqhdQxm62O1NDpLfbCGN8nYcFbN8luV4k1S3kZF+kTN/d/kfdnuN5T2Y6KBQZrfyhhDc07ZO7B0dh1KM9X4GVUBsQqo+8stZI8mOQKva46BWI+3htRAqKda65qhtYKCZVGGaysiSYFWSFhNncJyiYENSgzTcbchBjJT8QiY8aOkvDKmgFTKDaFZZkAjDs/WMCYSJdZGgAMSIpGLFiaB9DNA1c3EhTRMExoLOJmTCulWmX1mOipZOpueLqDqQMSKD+bOmumiis7TZBKcQNkno+tPUpbIsykjVS2UhQXUkplILRUrpu6lXZF1pumyClVb00FL2rd1o6O6tVT2Z6a01172Ro61vU6nX1v0HUtJ0qCaBqoOg5t35fx6RwCJfoZCm/C4EJVzzLvNQOR57WhSxKHxEATQ8fCA7LgABql5Zxjg2wPgVACoQsLAwjEQqCkSVbEqaxgYKgIBOZL53YIAkBBYAqST3MthgLkoSMjSH6KAEOASYpIblMtMPAZftNozJ03JoyLANMkuyJrYwC4IzQSVHNMjUwkTP0iDJh+hdRQLbseQSL7IopDMJqQSMDUh4c4+aorSSdFNTLZFanMnTUzLsplsuYuswTSToO7opIJJug70m0FKZTsuyFTpVrpaC62oVU3ZFSzCt6q1VNu/9N6ru9dS21q1Nbap0dJ02Tut3PGDEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABzuQRAN6o3DUkgiQb3JuHM5BEA5qbcNByCJBrcW4MMAzIQiD41HUHjSL47EAV4XbB7sLA69TLyMiRYf5Sx1ZBkOSLWBZHcEQEfNAiS/y73sRAg8AkiU5D6CAtrKGWCItD8dlUuTgKQaZEuTLNK4UFKEkQaRIYjQtr2WiocoTNtX0aOYEaVhGQCFhBiKmx5E8bhc8VDZNaxnCXUigM2gZJpxFE5iZO6dAqLKVyBop2UiPobTlgvo01umtB7JprUgtNJBkkHdNR5S61rSUnUzVIKuqgu23ZqupKhQZGtk55HRTdJ2f2QZK9FFT1qfqV6WtabujeqhSrR6F1dTMtak6ky8SpuUT7jpXNjd2OqYGRugRmPGMiJiolD6SwgqkeknX+jKyW+O+fh46cwqANJWUBMbXpqqlKnio9QjIWQATqu8TC8FCEKIRWXz9vILHi1GiqFOqawCCMsHnRhDcm+aHAsXgiOM9BIfPW7R5kEzw+gQYNp0UJ4jhUSqk6aY6lGqSy4bHUCIoDfSZBSaCajIwl8+5FmsXqhdi5jqbJIIezoI3UzJtZJNl3o1qVdnrZSbd1XQR3XSrQ66d1r17VqX6uu9NrVOtX2121e11Mvslr7Nrsq3r23RQmxw5OmAwG0fCPkgKHa8OBYvCIh+ZCIC7VMzCRxDAO6E3SX06Tfr1IQOGGuza5j6bVXvrRtAXVApgh5CWVGpUJI5GEBxoOrmJyqPDj4WpJCbhw6Q96Chg2BmEKle2TW9lgOuaHJbSnCyXiwXyoBzyMEsuaGKBgJtKiByiX0TqCBKKdkUxC6dZVXRPGRsgWVpFU2SvlIe0jJtSL1uyS007OpkUmWhdJTH0nsyVkDzJLQdFNSDqdNSfZqqbUUa0GrvTZ16011J6NV9Ba2Vb0r0Uktehet6SDoKUhWp1P6mZS61pG91GpgbGZidg9oULZK/TKTR6w2jGxwKcIlCHtA4cowJbSnTc0qDy0IWOHHLbS/ipjA1eBcxkDVoh6dUEUqbRVFL6JkoOAARp1BT0gBChosf5SaWxnJaisRSCsijltYGhhzK+vQZCm/7mZnEjNiqB/m5ganc3IGy1OsbrOprsZEu4uU1QdkWWxYLUjsusnSeeDSJfUrdlV3zFjiKlLZXrZJa7Kaq666K70adJ2Ru7X39bMqpWtt0GfUtbsrvX/upSnvZVTMpdknUqg1tX6mqqVW9NNJEsGSKZiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAY8kESDeptw+FIIcHOTbh0OLQ4N7m3LcKOiAb5pcQUDmRjT5u3G0VDObADiia4gAA9BT4YkY4iCw0+tbHGLm0KsWvERCzKEMTd/nY0zmEouyUs8KgCYWz0OFU5egubXl3yghaK6gBzV5B2swakoMPhLJBGJZFZZHGModYhcrlQ0TY4XgGSESXZ6kkXW0fC0ZgmcYxVHhZsyddaKTk0mzpJIXpEKmpkEr1rUtetCpnWpr1U2XWtCpNkmv7pPXZK+yWpCuikt0NfVdt21I1s3qtRXZHrttVQ1WZSu39V/tVZqlKTRdPN1yrjXe/iiRAAySKiAGq3DAcMhCNUhCBTBTdMAgVospnoyCQubIlYOG7JAwO1JSsUyIanGjrAUYVE50usvhFh2Q4kSgABgHBJWCUXYSCRCLFlOZIIhA4FKRKHR5mIMIdn3ch1nXoIaRXMaA90uxo0PFcfJkTwE2CPjUnjymQEYFpNJ1kALpkasO4qS4TDB+RE00TiNnNjNAj02IsgmtSCIvAwSgZpppqRZ1rQUy1smk6kEGWXTBmUmbsmsySQNUk00XdZxvWe2rSapSmd7PaySqlJLdaabo3rp0XZkUUmu+ghUpb79J9Denq9+lXSdN1qZBkkEmdGX2nx4CNMF1WQ+3MuqaflguFDhoGohrJ2XWgQy9cFkB7qlunR8MnaFuS8HFd2Gy2xJevDKlrvavSNDRC3cSFkyRIcfhd7DHWfbGcAwU+cqVAqmYIGFRXRJoMGgu1yLvpL1igwKgWxEzc3UTxwvAX8ThbOJmSCAhOqifURdkzEyKVA4boCykkD5boHk0DdiyXJIGxcWkmsbpkW1HzFaaKnqUiy2PsjRTTPU02qdC9JTMta9aCCSlVLc1UgZ6rHr3Z1oqdlLdZ91GiW6W6SVT7Jv36/W7qZJVJbLs9Ba/T63oOktTO66jFKDpEJQr8QCwa1ZmT1mVRYO32eCMKN1JWTuUZGJQ0amoQuWt1EYWMQ0wv5Hx4Hyuw0MyWQW1jgUAKtL8yMYBMBFABSeL65GBQSIATPSi7SkNVH0lAL/S0OsrC8kS8s8UUbZTqZllHI3QCLTzxzPCb04EOWTNiIxlKbNzlMzGKas9+N55cxeSkq3Kt1w8scqXV7HO5PajG9xGtrHHt6CnXk+H97vuXdZY545f/L2INVtioRHTOJn+nyXP8q2NeKKaV/tGWrbIBX8F4n+Jmz9yXv/Nu2y5j+K/y7yne+Wnqq98EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAGkFJEA5uS8tyrCIBvlG5ZcTkSLepLy/tBIYHOUbkYAgCDi5LLVB0ElSkmDgivALgU1mFFXKYmIu4YAv9RYUzcQquwu+BgytSI0maTTLpLYbwZArwOIxUHUKeAeDetbIAaBJncyhJZ077UHQAQ6YMS/Slonx0llAoDKhy4BEk4kW0lnx8rIKB4ZGF8uOpMvDwW0ElSG1uxAVpoE4scmgdLSadIsGyRDlokc13ZYz5ofNElVNdWtTM61ppK611tVVWgkmpzDZAq/dY4CSzciEJfdq3fmf/q2vurluzFZTWj15b60bH163pD/Wn18LrFYrBVJTButqB2tGUNQdvIsjpKa+EIpjAAZDUAYsZM8sWdoqBczvMSyMWCAJWpWKGVA890oLrrgbFJCwEk3CgEQELDt/zAgEVWfuEWcQsQS7Y4BLbrDznBJnDhi8TLF+NbgVy5+mL6CxQnbFsxLpiLPIqNUDAJyumXTM86QgObmrpLJhNEvqKbVGyJVJZ1mpl0KJKoJEctjZ3RMxRjdUwdSanouzst60XQd0qmWynoNWyaFSKmdTvaY0BtrdL7+lyr2VrftndOkTaKf9c172/sr6wfv0aaRbu+q0udsEbZ4ARgQsYWG0MAKNJVmYU4C8ysABhKZ0OKli5piZQ3h2XUUpaYZxRD1gsvjcVEcfav2szl7V5wKZAISAY00RY8uZAXHhOWOiQA3zc4S4RMHBJFcd0kCkQ4xNiZIsK1AOouF+kbJkYgXgLkPRuXE0TBSBXXXK59EyWRZNklmg+jaYGroJLSLrEqt2RO0bFlaKjrIoXfZFambWmmumaors7n20L4s0WihSR1ruMefjl9S/OiF/k3qmz/18Kwr/ctfviO6vbv/flz5P1u/cT9EIGU4X696doyCBiWBUFF/QYKzUgsflLUyqrTIABQbmJS4oBCxyB4GMwAswRge7EmvBEHaD1MUoAL3uoSicYBxQDBGAwUCn/MBgFVV23si8WEQ1BxPCgQiiaJnoeGBEmg/BKYiZqWsuWEgubrGBwPDE9J0ycIMQhuwNWRBjQzpGaIggV2uiONBakDZ0EDQuCXLWaFdBBlEeRFbF84dKJ5mRYWkco3lxSSLIJPWikbJoLLqnSdCpFarms0NaJuhK6bLdGpJKtSjqK3N3ZVJ0aqD0LutrMynUtFJSnY6zIKa6bJrqVTZSlJVLZJb0VVLZkErG9mN9svesTrgQkmkoeoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAG0JBEA3qbcPQSCHBvk24bYkEQDm5tw4tIIgG9ybguaBQJ2oZgxTIzyWCTpvQIJHQEKOKRwpBMauXPgNvA60nzLxEEqR1bh4JCzpxCtoKqt8ypNJ9qEiKC20qzBD2P09NKhQhJG50T0ojA16PD33jD2x+ekeNtJYIEP5fvMgUi+bmICoBwG5FGNWLZKmyLopoGznzQdq2ciyibUtNNJeibx0IqUXLsbOdJNJSO7Lo0lOtkKOpjS9J0k7qoqXZkTzNVVSWl7pLXuzNqWy0GpL1LZ+vrRZ2TZSWmihqZa1IrpJvU71UW2tpPTTpI0W6kd1Ios8xPpoOkVE615RSHmjqAGWzQO3CYPHDQ3YtWQXXNCnQc1iAEOnHGZKYnExUVjh+waBJ+q3QzsD2pSgcAqULSYmOgwqBRGFKkOHEymAIgc6sFyORrdHhsIgA1EsAIw2VyE1jRHaWvxbyyMFM7NIi4Dhk+Uk2eKpSHOOkVBrceEDYxKJwvkWQSashC+gbKKpnWmgKDUgZpJMmxTJ83TUaJLmbnFGIjSiaIrdBb2TUimjUWHWhQRWmi6J9DQWmYqcxZFJlqWqpT6l2SdBlMkjWmpTMtkVru11oLqZC3UyC1dlK13W9d19NrM6N6N9a6t2STR3VayCSac6ckXJkwCGzBYdXLgzMYAwikxgsFJsgUaGTRurE7pjEEkRBgec+DWGmLGKhVQhB+TS0jgwFOGhkLmMwozEgyKL8TdYFbTMJCyDLtSUCMiKwJVW8+hMYGFEI8jrzimNJYfy7MNaVlhFSudTQY1JEA+ZVNmMUlOIUK6uOUzFZh7SRQHkyIyipJN1PLrDdRYh6lMjUmQZkzybUGdk6V2ek1d0KjZkrLVQd/TSa6SloKVVQSU+pbN1daeq912SougZa6tbpqUrbXQta6re9e6KWumt9NNl91ap9bLMzc3LyBgQFD9l7xwdHmGmStYdmoHAEWOpGRoKT8MipgcbJSxDNjC8zvuMHH66AUG2Y4sCaSYPJfRTY7EKZE0gFIdUeDBGIMvAInEcZ6aKhMsZ6E+FFzJUAYTRp3X3ArJG+kzKMIwuYiLYE5TmBfYnS+S4NOQUpNRmXwvmRNloIkSRQcuEicTWcWMyY2PKTQdEuIlB5ZdJT1kYLa1RqYM1mTOqRUtlJoL1Mo2dGpVSLJO6qrJqWlOupdBTPZWnWzMz0U3X9b0VKrZrsi1aa6SOqpVrL1r1U7U1Mqt06k3bfp/23QWeNnPmKZfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABvuQRAN7m3DbUgiAb5NuGG1XEi3qS8NUqqIBvkl5AJOSBy71cMbQSGd1hxAIxMCiZzpImctswJ7L5xin40VmRCbORGQuCdiaixxxGx+daS1Z2pYYaAigEnjDZQMXE4jCRls0quylcQ0OQXMyoxkJIAIiT2y1JVPWIDpbr7EwFG6+CZgiSpSJsA+JBieSRNlG4uY5QNHLLM6yIJoSTUT6CkkJqgkmmw6KZifQUm0wIYtaDMfprV7pqQmr1rXUzKQW2qp9BS630K1u7IspOipTugz2SZ91qpT70Kn32vSpbKqVapSCDKvRZlqRSVrRqqZX66C7sgtekyzE+kzGBqSgajT/w/BiiYrsmBAKUBCdmyoyFaVhpKgHND9U0zdIAMZJnAiAUrFg9Tzb9GGCy0OOs5YpEuIHlUILPUWFgHaa4LBxs9NucLVLMa8oSloZgD5gIAjyHUPfhsy0bbPdzayRoP0lNbRZaBcLoC+z7mpqtAwC4QkjJJzcgLce1LPGihQxWQLBrZKsisfJyapXpSMIOfuyVF1pLrddS0mW6NkbKUpFF1IVLSsp0EKborVZz9mRap+29VLXqW7KUun1K1LVptXp9Cr6HRWgp1s3brv/u1JNepjE8ki5gaAEWBUeBXwlr8MNMvewkBaSFCc0w2aCuYzzQWRQd32xuCYceu2oCgucoVVO7IX5Qtfc16ZkmAEgqJtgWLYVtDjL3Xr0dGUKbDWZG3Uqji/xQ6gFAYA6TYoFQxGeBsQSqzyzY4PpNADvio69FY5LKtW7IzdMxk4iit0E7OtNJEc9BFNNtSjBaDqS7qrToqUpVa5+pZ9lstBF6SFS1qeippgYPiBaki2bQs+enEOlDlppkk+lhBB+5FV6knGc4UcTAA1L0hxSlZLcm+kalZj0CCrdFkwAbOwDFCUO5gNdlmWRPzLmVAwBmTZmEB2PCwY5gp4wKcJRcRtY4+84DgQVAQs6nKwbPq1mBQxAk/O3kyWmQCni5QKdaSRMemNlA6KEMxNxYGdD4AcQ71F9GbkVTMAOmG0eRXPFMP2JFGpIvIzhiTFAxTie1H3N3WqxXSKTuqitJSjYgxkpdaBotNk1szW662Wy2ezMg61Ua6l1nEgL6vDOoUd19deOs93dWQ+hyHtljEqtzzGL/C+PxZ3NSn332b4rxBegtYUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeIjcODe5ty6Q2oYHNzbl3KLw4N7a3LtMahgc3JuQoLo6NtJX0L/mOWprIKuoGIR0Sykg04xxCEjJI13pCoaikddTCyM8gsV3o2X6M2wXLpmNpQujLisLJRoiD4mPB2RfAu/lK520WRQPQ62GQmsCAGCCKuR3hUCNGsLRnHNkZMY02dRRZWPZVPgG1HkyRRNTc+IToJGx9Mhrmi1F8uJJLUQBIydIzQWgYILJA2SJw6i5obFNIiButFMwmtbVrNU2SRU7JGtNmVXZ1pqQmqKZsqy9JI2d3WpFnToHlI0kX1rTerQTnWWqtlOzrvWt12sykUV+kmuqpSLKTWpakUazR6+zqZGktddlIJqMjBWAwLAeyy+ZS0EAHMT1szsF6QLA8xkInyRUM3moMTiYTqwqfVVOn3ygJfodALkBu4ZgHq10qGkqj0OBQMQ7SYqASp/AIAYCfQudikfEZ6l0shGMlBjEUsRhqMNJLIZ5K25VqNgJkYaxbGxLxSGPJggoHypFSggpRsWQbQIMdVNi8ixWMxmjdI4Rqxk0kUy6hRYpssjEkEEmporI4Uum5otZkg+ka3ZlKRZjRTILdSknRN1J2Z01OuitBTKaqyknNnroN2RsktknUzKQQpKPJo+tR1B5NGln4jpO79/M6ofDvRRHw4V1wu+eJfnQsIspbVpTasmMsGhL+SOMHJj80UeDl0GMqwcMJ7WcmZq8PDEBIwa2AgiTw4DgEYzHSpE9U2FkStCkdCCYmWyihcLVlYFftbfYcEggGTfh8lADGS0wZiHppgbA4ccO8yqCIMgcII5dnSl1Z0TVAfwAnBfWiZ0UAuhat0zguJInnLDFaRgmMo+zmiCBmsnIMOZFEkmWtmLpWXVHTBSF1TRRlfUpTupSJ5alqoutBNPnkFIJoa0HskzoqTWkkki6N3XepJS3Wtbppup6dd2XQQZGuiylpJKUmpJS1rqVRRp60rPZ1NoV1qSrranc/UazXCgJLkM5h9uw6CzGVPM6hleAWEBl4Mq4GASYFhoIA7G98hJEHHtIhMFOaFgGWySWGHqTFI9H7cF7MBBVHmXs6IjuVl9RGKq9m7E2ACceM0nlfDoCaKdEpG/eWbrvRVh2pDIwCGMhEP27cmycKBPk0B3RCmxs7JJgNOTqKLGpKppzUdjUSBGY7TGkk9Sjx9aTMQ5R2yRlINWpaS1ooqpKWZrRZ1IOmguYss1ZaDIpoIJ6FlKpGabropNQWg06ugii80ratTOgyT6loLXXscet1WRVZd7p0GoIp0m1LUuipJ10fVVWtbIU2atkTdW9sgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGw5BEA3trcO1yCGBvbW4dckEODm2tw8JIIYHONbgvOBhlYkPu2lsCK4xEADgEdTzc1BQeATCUcWCWfxSniKEs3ydL9s4Rfik8gsZzQsRiSwa3H6ljAFZigadgoIKVGRIqQU0ggwLhyzGEtOX2YuTAlyDCKla+p5+ZGzmaf+IBYAqY4JHECITxPQ9FiaWgmPQoLay3rl50GLsYU1sdRTUy0VjxSdRgpHnS4mY1Mk1KgvVd0kkkqdF6KN92Zbretdk0LKW6LKahWpJlbO+pm+1Vd0UVMk7Ks3trTrqr3dFF11rdl0t07qWu6T1vpL5xNJq2QQY0TUbhUBHhUvvJlDUzh6wKatlAqTGvm7D1RA7wIrIv479iDFMD04ASHWzpDT9ZMMxpth+Np1U76UxhQBFlCkXS70PF5H0eO7PSp7CZjHAZizsgrRQxRrrwyyaCpxysKRDIHGsksdN0S4bMbhlKBkfPmJTPAqT6jU2YuJMcME0HNBtOCNFJJzVqLkw449XTPPRZBI4ORExMDzLTdZ4waixuYoGCJo5utC7OheylrSPvOqopm93QSVU1RgyCZi+tJrKoOtJNMwptZbuyl7KVVXRWtFauldnpnUHoJr6bqpoabVUVoutJektlumiumkkyLplxOgHB9gtaH2QGG1YDkojyYGF5wYTDwRWeYeHo8K2CReQs9RcMp7mZQSXGvzKTJv0kl1DLI0oVO5KRB8YKCMkAFDaRuYUB5/VWUMvIghl643INCBxCrK40s+Xt2tMW6/bpCoTDstxLpu5OLg7wTkoEwuuYsmCdmps1Uus6A8VKTI6AmzzhSoIPNkBzGxmYGiN55IumiaKSkEDY4k6Sc1Z1IGCRxOzIMutUxQdJA67MZr80RXe9jeyTM63bf2XoLpIpKdN+yaqS6SbUUaqSSFqVbuzKVqup2ZSNaBggz0Hfe7o01qZ1poIIGKjYYdhoNAbnQIykRgoxJRDNYWVhEITMwhpBOQA4wnDDAwGRDdyXqdBcDmjIKJC+GFy86mCYRMDjVUNJRKpQGB9RVOJpJMLGzJRFgIr/pa0qHQMPEoRACWplGOw6FxCuO9St4vunitFL3QJiXbluzMyMiceHqBWJc4mxmigCWKKnZFIuKUspIs4yzEQU4o1ZcyOGR5AcSCJmSq0EzRRUZrROKMHn+g9lOpB54+paR3vWm92SslUepo1MimySSLv1J9FI4p1ppJutKq1NSLpLmrs1NBSkE0VOrprZG7PsnV01LT60KrLZCym3SQWrU6nsYImxWUwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABsyQQ4N6a3ED8ghQc5BuGno7EA3prcvUyCGBzjW4UDL5S5vXfR4M3tAOEEQGOEBvhOphBIczlCK/1LnQMCNm6Fik24mMEI/HvyoQ0ywLFGYzwY1R3KBThBw+TqWghVFK9u2mmk2viHmZm/BBQxGJ1y5Xemorp91yBQVT58dNh/NzcAaqbF6X3YE/N0OT1rMVkso6iPRMzRWgaUktBMxQY6ybaJMKaK3NTZHQse6Fkk1ps6Tu7Ld+ip0qDrTezMtFlrSSui616aq7br2XoUputKy33RZV72bVdKtamU7r96mepBBNapqyDbqQbXUp5q7KrMDEcxSJpPaEoo+jUmQjoFHZqMBEHBoZOxgY9syS+M4L4FKaHLMqk4yGTF+jQ7y4OCtFeXOaJB63Ymu1VjDHaQhQRKItbGi0+zGAqC6Z2KWCTAJDEha1VGtDoYxFoXNQkVFgFjsGak6imvXLsF2JFO30CZN2L5dBHDARKjm5aLAXwHoqs6Ax59akh6OHzqy6H7mhuZsWqC0yCLJhaaiizpIHzgtiCkEHU6LnDJFNaTKWYGaSlOYmxxKZuibmTukcMGY65uppmitnRRqppLWo3TWcdanuyejd7tUpTTBqTKQRoMmy0kE0EHWk1ne1Slut0mNzBS1KsigtBn09kEebpGqaJ4zRPFwiSi+TqgAGLU1Lz3MNMzhQzxQiBoobuCopJ6ghnTHpqtNASq5gNKgc47dShkB9Birrsvas8E0ZMMQA3egEeJS6HjLk2m9ytKUIXtwwh03wYcaFACglb5z/bUfjy6zFAZZhi6zg7EzoAtFwvGLuigFUIbqVNEk1pjxQaYrME1LMUzqSbGyiYy3qdloLG9JN6etlqQWtJTU3XXRvdCpPdBVK6KlulW6TotWtSlLM3opIutlovRSSrupSSakKmetVSkK1121dV66tfqRoXeplMrQ3+r6aLMtBz4a/LvQM6K1FhzFixBzvXgCgccVB4sJwQAjKbGAR4L7wRAKboVAxrSGAIZNNWtNQWyAzIFVxSlP9jihz8hgOTsSiIAKkpXLfjQQdeM14LEBBSFlqXSbZhMTBUbCRwWQ464UlYHadZ9ogkA49nTqc4dRMgAkksXEVqJQfxhheRUi49DKkxKosmgbCUF1A4s2WYLYxYrWtzFlqcyGo6ikigfTrPrpIqVRTW6bGBgit2dI0QooKZ2ZaZ5BJlukzuz2ZboIsg1TNopOtrqsiplrXR6lM1lXUt+tFFd2V7M6lpUVqUpNFKrdNJNeyNWymTY2RWpZxInrNTYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAbpZ0ODm5Ny+vEoUHORblj5NRAN6ivDcCyhgc29uUylytZS9eoqAURy0wADU1CUSmZxYw9oxiYcDQud2eq2FDjJopNaJvBZjjYzgxhcFRNVcMPQ6YcOlQJg5VEt4/LCgEiqjs94VB5WJujmpbGRlpgYoLIDYJW+eNjcdf9WUMT3GseasWC8VCZAp5ikiozQOh0RgZ7m1BEwK7oLIMiZ0UqCKDmLy2aKLJeQRTY3KZYRUtJSpkuinqdlsdUy2Y2ptQUzIsiyUzQ01OimgiyCrugp3qZlVLdSmstSnaxqpScYUt2RUPGaZzv8ljtqOdqKwc4iv+Vhf87rIoUhPElq4Dd3KL5GPkACpMHCkQHERHBDMUAplGEmNgGIQM4Mw0tlpxUyjR5e9vLccb0zWWlPUyqK3Vp2TDgRJQEi2p2RFCMhwMMFhhjs7argQLjwTfBNl2DJQJVcTJxjE08KtjltrRWyoBAcHLVifMiaRJhMpA2PFY2PnmRcCtMzyFIZ41Js1MibLhqdKiA5xkYulYxsO5JSnTNUkVIm5eFjSTRWqipGxug6alzQ3maBofZjdJRdmaDHmTQSTTZM6iu7nlPU5qigmk1JTmC0kVKU70kKT60aqDIOkgZs6FNFnUzIPoLrpLpqe1T9dN7bu6lqUpSalUDNjfwqRsKDCILcaVdVXMslQF3osAgLNwBExWMGTlCQSJTluXMxOrRKAFGw/KPsqO1HankwNjj1x4QlF4rMdwaIyBrJh0jXL9NWLBSQRxoCT5l0hCBIlkcUQhgcJhAmRAAACInDqSZmQ1RkARh3ILM0zE4J7MbpGhcrRm6Kaios1ZAzQY0U6KlmtEsJUHZNY4VGCCa6kU3dFa0KrItZNdbqY3dSBI1iJ8kfFijVHDC45xGka8e91zkpIPFFT8oxhKWHLDqFOJJe/SNh0bF3LVUZUz+DMVFAZCDCYCYSLAwPHpMCAwBmbjqDk2X9n7LdS257kODk9oELpImvY0xxdfJfLeNFjZjo4OBCtY4AFrYgkEVRtxabLJtB4CWkt9SozEHEJKROjCJ1jyqUsavNxBl4sm6xo/PBY4D4BxV1taxaoQBbrGrFbYl96nvthfVKGvwybmpm0CPfdn9NeLJDlK+NdwzbFqfGs7vn6r6TV1at4+q11rd7W1mn+NyZxnds1pi02t4p47gZnNiUIbD8+KUTJ5tWeKKN1VwNfYu9e/uW39YZzD/98GH5d3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGh4/EA3uLcNPNCHBvcm5aHkEQDe5tw7hIIYHOQbgcDBIMdGBGYpbGCWAKVh4CHUgwpZcJ6iFgZRN0060VO4RQzMoivi7EEVTQ45xKzO1wuBKwoSpKTKewYHxpxRgRp87dYcJkoH2wh0SbBQdGj1sUJo3bkMtuztYBCdfuzFlEUSSALQ3iumiy1Eg97LpVGCCM3YjkU2XonFmKCl1mzJLWosmDsySK02rqfZlOpS0ElrQfZBJKggggpalKo60k62prfWpbLSZ1NReir9Sk1q0WaqvqqSrs7Mkg6Drt+ktdTVpP9ta7tvZaDoLVW63OppGIYQRD8MpnlEKTpaBIEA5sAIrksAJjOyYcAuHRW4ITvOoqQMLxRumFuPGKgD5cbFCHpukREmiUCEMI44IZBUhY7TWMVzDw40loKZBnQmCCaFV4KZu2Cu7d2o5Ycy0k5o1NDdkzECMmLUkHcQIW9CcWbmSBUdAyJ+QNToJPayLltBiaRdmdZQJZEuTOls7IGKKSbKZkkHSZb90HWqgmtSC0HZ1qTXSUm9k903dd6CKa22SrWtakT2KfHJ1ooq1zKN/It+p4z/rdsD/H3bt3q/NmE5IAqIFlZyvSrYMRkDOgJoQkHhuUNCTJTIQsmLX2gW1E1pmcqY0AxpVWtK0gjDqGC6jIVmQVHBQaLAQ97RRIel7hBYOdrLOWFYGPCrMn5WUYyJipKREsQfKjaTlHrFDHk0JZNepnSNC6AJUhTI2QUZuQ5WgxitnSLp04tSJump31s5bWcRYoGfdjM0SM3Rsp6CFJ3RZVmqZVSDsinTd6a0VrdlK3+tWt1LQTWmk+ttb3U2vapl0n6F26ndJ1/WvWpb2t6aldTX6W92oaDMumpRqidSKgMEYFp3eZaDQAYimBm0HOWMC4zUNVOEuzOAXJkumo0OEZhQEGY5MrY66j9XUKMXB+FWHlg59JUAh6vAeDMFY5oCRYAOfO2bzcR4UoT2gNCCGWIR4PAh6J5e0PTr6Vowh+YzAL9UuqJgWlk8AiYrLRQQNwwkXDqk0iaLhqialt1mRkcJZmTNvW2kmo0spchhF2c1SSXTSUpTWMEWQNl3PHbMlRacPOp2rRQdFVak0lM0wWqmuktFa1NetNBCo3UiyB1NaCdaKSkWSTe6nT3dFkalL7prTZTMtmZ6mWpTM3ZJbKspS7JLWyDKUxgonwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABn2QRANbm3Dd0ghwc41uHlJBDA5trcOfSCGBvbW4GQAkCh6dvvkaUyR1EBopZCmB9XTAF9H99d2Ii0IIkSgGh1Ea1ZL4mATTXrq81uvvGTAQkgCk2VGy6EdpQwDfjDdUqEqVsGQco+YGIDJ+njJIEirRsnduSmHnBjGHFImJMuWAhoQqaSKZxAssjVm6DqdaLH0S61Flp1GR5loTdFmppl1BBFO67UGo9TJ03RdmTdb0HSOLWgpVa1b3Wu63daSkmspVaNnb6aOg6TUHopNrXU1XegzVddaW1da6/dNb9Oj1X62UkpM6m8wIqZID+k8v511cQ0IgIYdgxlAGJNgELGcwmqIcAABaxcx+34tS4LAUw7C06Zc3LK80kw2ILFp3pNTYGFQMSAImBMuT7rJ2IHP1Wt2BCASIEI3yxDqYsFAqEhoSPA/zNGq++/baQhYCzZuYpLNjafAmaM3TWgkAXyVWkpArY1TQNEkVFFxjG1M1dRkZoqcwpptUg7Gw61oupqbqZa0WN21JprWuktSSutlUFIqdkLPeyanahSuitNLWt96qK1UE7KrZ360VWre7O/paFal0U3XQqVX+7KrW9StS30q0lIzpNWVGJYC5gMCwC/7bEABMCukxMDXdHhCRmkmECdRi4iCw6cSR3I6sMaG+CwBNiwZdmgcDGo16SNpmahLgvcTHAhCiInvCRS/DDTBgV+4zhRigyruYgWDgU0jC6LAcbgSu+zyuVjMQIND+dbMwUtngBPi8bqNkUyTLVmSKKJkZZqolJNScfEqk2M1KSLqZlc1YzRSSZAb1MbqZNFNamSWsyWZIzRM1U6CbsmulQskm5kgtJNlvZKghQrRRqMKClui61qWcWyCd2c4tF1Lul6S1rbUm1kVLehZaSabKu9F0VrRVQdBrqRRQW1SnqUy0EakUzg9jKTCiQhIKB0QJS1tLAepheIYmFTE3dATORRNlWxaNXPKoZWyOAhzngJCzqp0xm1DQAMd2HYe2C5KYUHkoUkC6bAqFDMuRCJbSWBgVQGqpw2OAxkBuocUHD0PVLaKXwFfxdI0QNY5N9UdMysvGQHgS5QLxui5iC0EvSTSrNKC0WUN6Ig5ojRRRMklHzhTPOVoGiC01mKk1pJTyFNmdqRm9BFNbu6RjQUgijNFvSdaKC1KXSTSNVpKO6WmizOddSklmqW2p610dJVlPoN667ui6mfUloqTapdN69SDs6/ZrqrTW7OtBJ0j5kZpSaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdLjkMDm2ty6bHoYG9tblkNNQ4N7evLQS4hwb09uQaDxYWQW2WMEIHJaiVQqg8IhkZKHa7FOzAhPWOrNDNafL6nR2YYQs6SThqMqWm2OiZ1EranAwDIxsgKoYUBSyFyzSShgYFFZuZfBTFzFVZt5h7HKpa289SReBsWs3L8+UG7zX6ZAwNiQLpJgFGSZ9Zs6ZNFIlHNEjpiswWge0iDNCm5NNk7NQNhypoF8wY3Wukgmy1GCCTorTWs6jdmUo6ubprMqqJvuylutFSRimmipakE9XdS7J7o1IPWnUtkrXpKataCrIMvRWtbu1Nd0mZNLZ6buhoqNnd2ZBVN9kk0lU10kG1JJHBzK+VGFbYYchBYzRaFyotcYGyHNwo0BFzDQdoDKCVbuStuisZzRmPB8IaLYrtqbEYLOlq8XygrMWFlolAso0JA+QFAhEKQfK85EDCJRlKqBV4GQCogIxprYXAuCZdNCY/WcgHKDXZiqtAvl00JUAxCCSU+kiZEqbpGxcUVGqJqxYjQK3EvUxWcpnS4bqRL6RgTjlZqgxgMpIuXQ6Kk1uumlZlqRQqTQZBk/ZSLJIrQefvZJGtmrd7strumipCyNulVUyak3WtVBWvs7u7qTd1NUykWX3WugpJ0FqSSSddadmUz2qRZNFSKczRxEQKmowhoToICzNrU5EBWQDQw50fVHDhgQ4TBSqNBi7LfHXAQ0ZP7DVLHHPNvMVW1mHqea1MmBD6sxMDwMnnimmCBWRVMYaTKeVpMDI6mUEAWF0Y4+yqhOxjKlV6gE0jzRdb8eSAAwoKutfE5LXP1xWT6mzPnWHPd8YrjFbeldRvl7Put8xo1qYv93prH/+65xatN61utq+3tOXdGTgP8LFcSw1tlcU4NZf5UXTQXbnRUnftqz9Cvw1//v7ed/SPP063SlmOa/3sqy24OeJlZIAAzUMHBmamBmp9pwRCZf0z+lBSqtKl42JNI7P5akTYlnUiQPttBlzRYrNYGIFqzkQtrYsGi4gDhgNvJ7VAOqmWP8xyLkXJXBWpaPuu8kLganpUPzBhbWed8Xd5iAKbPNGzquERTO8ZbdUxiHi9X2Wib+TW87lzdoxWtsU9viBrEXW9XznOK5/g5+dUrq19aknva8ttTZxS+K4rXOLahb+deu8b1qJazb4hCt7POzuan5/7ZMwx/y1bj/db2AHvRWnQqdkde1/7eyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHOGZDA3ubctFKmGBvc15d7kEMDm5tw7jIIUHOSbgqBYkkuCw9opVAjCvAycKBQyAG83xwLqrjMyTRpHZRDcogJ5Q7nKxCFDwDMRNFw6oPURlrW1wqLwwYCeMLIiZlLDMQoFAAMtRDctCANJl935jhlATApMxrZiUiWC0yWlpY4EEUWnp83MUEVkOCDRmmbFBFFEQmJZM4pAwTRRMigboSQYhyazIqsZpIJltzJZsbImhxjF6LJsbGybqNGopWMGWmtFFZi6kzZkLpu6T1mp5ZrZzFNNVlrTTUkqiucupqrqdbXUix+wYHYYMUMz+D0q11brY26rtL4PumaBuDeAZd1G0CKHpJcSLYfnazNzUAUjh1oAEYPDHx4HQCGowAOZGHWM1OxECHM8AcMOvD1n3ZQYg+q8TawTNJAMml+kz4ughEI9LKl6hKguUB8JVeVAAwk3CpeNBseGZLQ5JxZfI8i4GKJuzHkT5Sc1BzqkFlVMuh1jdFFNRxB1JlVrnHICtJ0DJBNAydZEU2pMizmJ0uJpLonk0lqWfOa0Ez9NNVaVBFaaCFJSa1KfUpR/Hq+XpR64NFpcc/kvi0ZN8lAidrW5ERL2bF8vuoPXp97rZp/nxu+2o//pKld6ajrQMkYYZbQGSiRZgQNHJhSNAxIYwcki3zYYC+CGNmuPYkJyhLubbozE4VgSwl6ZLQXJdsRnI6GkxFFkLeg0FMLA6WZlsAihPbbvOweHOYoJESs+MrnH/nWLWby+FKJVzNZiZlApl8AGJDTQ2UbrPiezx9A4Zuuo4bOtIh7kqmgorrNjtO9SBiaspbKN0DRB1MmZIpopHJso8zMm01UndpioxZSFJZ1ZgiipdVNloGs6pS0Kk2MKKa2Qez01Jop3PPqUtVampKWii73Z10q6aq9nddbspmqdGtJ1LUzJs2t1pLWfUgznFs5m5w8IAHGIUXaWyMgQxdUjPIUEgSSk0yaSmtjgBMMuEBCloTq008IgeYwoKCOtBNNdoB4D8sTLmU9KYJACwMNOSzKwMAIwKE21sd6ngNCaVJnJlmNxoKENjtI7uMFT2qODWWGKQQ0O9aNlpFFifAVFRVlFZYLwocuopWKKJ27uuVTQbiKlrWgpA/WOdrNtaKi6SKJoZsiitE0U5mkgo3OKmCjScRNlmid1IqNDJaa6k03TQPmqNbstVaKbLWpNV3VsicME3SWdUs1dSlr002qSqVRVd1uta2UySbU3d1LroVO6266tbd7LfZBV1pO60C+VwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHg5BDA3uTcNzyCGBzkW4dMkEMDm4tw7xIIUG9zbgGARKMrDzT/LgMzESb8DCYwdcOZZQMDKwmghBMqQr85lGQwm+S8oUqL0Bp9GzTLN5YoeuBDyJGGFAyOkQNDjT/CwIViUPzluVigGPCzA5c3UyQWCx8NGUExd8lG5tT0sml9od49j6zQ4mbFgAsCTLqSKLsNl0lLmqSJ5aCCmKSZOIqYwsukkiZuYkcYI5q6R8zRQW7qoKNnU9a0jFR8xRQQZE+6ziCDUkEzGm6DIorWikg6j7uqlWpaFnMEjJGnprWmy0F2SRTazp/d11ops6kq63TRUqtB3Q2VdFBVJStqTsp1qZBaKdBzqaCjxoZIuYrpCwJWvPszIAEYdmxlwFKHgwFmygoVgROMykISI1q9eeTOyFQEZMgBa6AWtVaCPiwEor7tPZDGYABqq7qW0abSHFJFs+FHgOBQeAS+lOZYZMAoiFKk4+/Ln2u2c81UhYMQJYvH1FgoHkQPouGrImjJkNLbupy/UdZCdQTNxyzlRsfZaS1zVlIG9alImROslTdBFA8mkg7OxsmtE861H6S3ZOtBk2dz6KamTa91lxq67KZFbVKX01J1n+6KFSVbpoGKFmV1T/ukpT+qvS79n2X/3uupB9FFBEzbm5mQIwCKjCYSYdPQ2jKYTdoKSrTACNzgZIKAklSVFGmW0aWyqmSpNHtUHYkorXpC6JpNk7FlpKnm/dUx8NFB+Gos16NlzzCxBvJ+1BSDgkHNzzdIwMhC541qii0nZhImrzGoiGA1m/msynGKQKsyQmRcUUxzklIM5eSn5OouoiJqbl5aRqkZU0VUUjpZQdFl0ElLd00VPWpVb3SSUqgkZmyZupNNJFnSNkpxI8lNqdFaanrRWpJJSKSrtU/WpkWdN0nT6KT3WtFKlayTKRfVQuj6tPTTTrZ7p2qRRvZJ0VslTRdKibmpVQJI1LpYBIgARJhzXHnZoa6OE9KPEwXSDAE1PRFwK5SDTPoZl0aLcnd34YUtOVLlStjBRHlKW8U9I4wCSJTtPB9Gv1wKBCMImtWqAEjikEyG/ZEaWGiMtFid639lFDGY1UiiS6E9+KuBykR7ogaJmyndkCkIkyCKRiXTZ5inczKzksi5ildJloIpMxSY8ZHEqJ9AzZNJJNNkUnNFIstNGdOqQRdaJ5zBqKajFA+pNSBkgjMT7LTdB2pIbobKPLWujRTWpBSkndJRmpCbMXT72PO+9VFBVtGtaa1rSUtkGoJrSoKSrRd6a71UrKpVoIF55SNB1lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB5mQQoObg3DZcghwb1FuH75BCA5x7cL6KOHBvc15ZmYfC8Os5V4SgsE4cxAGSICAwkipYeGVUj3kgDEpl2VNj/FgSTnNBwFK3bQWMSl4ZlSjakVDbZkAuMipMAunA1KDgUKFN2jvxIRDjbNKfosAJKdQUUDW4lIYCom8nXhW2mvFbO0TUmSCnC8A6JJSj60DgntAvulMkkmMCbUfNy2kpBaj5sxggmXVlJzi0lWMEzj7IJpZ80TZRQUYJIHEzVJNAydJ1JoXMtnM2SZIyoqXVVP2OPNVrQSopopnFOpBakHW1zyFJloU63stJSKS1U1t6K201UkFdFNkZw6gp7oMtbdNFKqkgourOqL50tOiYFkrQ0luzpWOMPMZMbE2sGBJhRafkTBAKhsacWDTU3kH8oYOM6qhy6+GPE+jCdYrTMx23WjMYCGQsjlqWEwggGB8D0k9GhkInUqjalQsSEZAmQPQ78ubtYlmUsdYeQztrBS0ybNToGOSak0zFSLO9nM0ElG5ulTN0yKrSRQWmpSjV0jdi455JbJHC1dkjShQRnmQMWdLporU6K1po2SQZN00am1rWi7oUFKZF0dTrX3qWgpS03dLpKR91oKRqdlrd0lVpLUtvooaFlLd37qoV1a6nSZ3rrrstVFR02FAAKgpi8jLOAkCmXJebbDIcDA4MG9AuHBV+hgINYQ8huYpy8BxdaBxgY8GBmLThcUw0pmtQWutGFRSGjD4yTlKArCWgRQtsBBZLoanpgZGymiyIUsgyMMzAAOIhG7cSanE6SFTcystftLPyt5Wp/WkEDZKTPt4lLi+h1pSfUd9Hn05dUWxm+6RJt1pAzDg+VtvmTUmmyuc2fZh3vWbxvN/rPewc1pmTE+65izfOoFa3rPSHaSuZ8Ym3WJje8Ui5zjGb7+tUxvG7S7tiW1MavS+fj4z86zjH1re86vj79cuO/a1fumc4394rTGvvWsarnW9/erbi0xi1qapW1p4DOHed+JNhUWMA0DMQBKIcUDfmNpCshjtMDhR96Tu7QMKZTMNN1dR5MQZHeutL08FciHhgBhxjT62C4YUFItSXJpPyBFkwfTu6SBRMSRwZ8kByyodKB4N2Fz7nVmaMwOKArIvXUugUU015mfU8iiKSycUNygzqd1OtFVNddS1GR6tOguiYLRszVMiyVXSW6b+72PmVgapftgAJD8z+0vXiDPr65uNz+XU5/irfbxWMzV+PN/Oyo6b+0Wl7fcRbkoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeJfcKDm5ty7y+IQHOTbl0RlQoOci3Lo7ghAc5FuSoBhYDKZ22wofGGIQZhBgQBjCJUOBl0HCYtSZDO4QVVdwdPUgqBm7aosJv4PDdWeSSN7oU1ayXq4Eqn9MaNXRRZddT7/rUMXFWgUeqQRhBMK4vfXM7AgqNDxI8FDSrxl9iGIbQZBw1PU2SZdTJM0JwEql8+pBJjUTcmo4ikUTc4ty6Z1FlAfZk5qighXdjRE0SM1JWSMjRFbo3UbumiozQZdSlppppqOrSdaJu6md1In0EDqjtTO6Tpqe1FJazZChatlug591KUmtNSTnUF0Nbq1MtaCFRnSRROos7tdGmmgpOc3h6Ha0iiIhd1lx4vwdMtAaCzutfSeYOZwG4PA5EBDBASN/C8ICqQxjQ7BhOZjSWH2RdM/RcBAt6k+p2ekgYGccIMVbHoQCQCKARikkKAzGACA0PXvjVWdVuZak8sx5xJFBcDFBWdGNTDtWca1ZN8wwAZDQ4opEeQEsGYC0hkq3MlICvFx00DE3MDdRwuLPOgxGGKrMiySSMvIJopMmYGDGI8HDxiiaIMapIpJLTOOibMiugb0mRPsYILPJoIGBoyK3Tni8YInTdF0LJIqqZl2QSMkEGUgnqU2fmrrZBSSCk6CdNJNu1TM9F3shUzM599cTrR0Cd038/jAfU21scCgsBIZdhfIwCDD8MMxA5FUEmE2ibhoDrDmOkOHEtij9y2TEIMGYYlREQcEJNH1eGkjYmdAiDbQUp4cBo4Q4L9irjW4JBw5anSUUsBIFQJQA904HHBtisKQVfi62L9PO5p7iQo33BRvIqXjIEEGSTcyTTMCiTM8kZkYgmkimiszLxwZg1QLx9JNaC1lw+WnTKRPF44pFJzyNAyRRstBBTOaJmSZ5lImzLe5odstAxTdaCndSKzZVqVdBqlJJpJqRpubp1upGmsxcLru64hqyjPAMv/L8g4CYJip20bHZ0X2KXxkj1LwR8cGAhGlQp8EPwaDDIV2NYhZWIEl4yOa1JLkMamwOHGM9GVGxQACCTFyqFivbNOUB61MzSUEOxtEUZA0OraW3cMAAgLAqXTONykUEbsoQn6YiBBAHiIbQTDyrG4y6mptoIRIjZZSk6Yyk54CvIYbPk8kGdlNzyMzLhuaqKbOaKckys5gyM2OO7EBcxOGzJmi1HDUuGpitFzJNNFk6qCaCSa01rZ0FmNkVu6lLrM2RTN0HSoNTrWpNFFSKrpLQZqaCKC2QQRRmClJrc3UbTjqWtzJRo5iR5t7su2TWbvDcREYL8Z45K7ZjaDvqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHBJBDA3trcOuSCFBzb24aMkEMDe1tw6nIIUG9ybhqQcRJqSGCmWmbhRGWIYmEH59CQJCJeYx6SBQ1HJZaX0KA5seWgNdouHblDJzfxdRCeYfBz+u2DSdVCnh+lqM+MJFpzHC6MCebdoXMGSh7SSsGjlO+cainaWRsbg2vlWprJZaQezVboKpDZSoGJTNNMzOoKLqJedzqKLrQUZonGc4pbM7GJLutNbH3RPnLLSTWs3rskfbMXRUtG9bGJ5FTmKVBO7LTRdkE6t0lWqoL1pupTujWpak1LRZaa2VZNJSF2SWg7VVOttlJuutqD0butLvXqrqZ0GPouimaHTYmufZ0CQJBax1VSAHGHbYZiDCc5gcIm0Q4TApeJgk2iwVZFFazI01TackSGZc31vuQQGXr9EqygoAqDEgQ/eRQH1zBwFCOBbdLUTuY7pQlmBggSKEBEHSmLRmCp+O1aGVAoglkusW8WtGwBQRsXFr0ijkcqZ1SW+tWmvNS0dO6tf41i0lplxJPAs43+pdT738V+tzaki53qLnd87rPi2L1rPf319V+8fN919r0pel703b6z/7S3rm1d5/xnFM3ritN1pXe97xrVrff3fH+s01bWPn7/3m//p7/Gd/eq/FfXWvrXt//r7xvUP/3kphxdlBCtaMu0lqYrrmkAokDCiYcgspePwaGWEygnPSR9wEbjoFgOHnVRc1Dfm/DqjMmUpg5hU8YUKJVJnuDYxLACIh2rnlKk6FvswpnrMKGnAKAGMWbDd+XbMTssws91NHmZ0xNT0smUQRkd3Dc9CqFMkzokre1+5latsq5ZzFSfZDe4Yu+jzD9dWdZSUd07uNjJizz7uLiVHVqvlK2P2MfDHy+up4r2W6NsxUHmOq5jdPDfbHHzDernrbPy3qp+/p26abxzF9cdxPfNON75i2upIMFg0X2hq6ViSsNfUBPAT9ECWa8yMcaGZEOjRWuWLSZN13zmFgaI3tajMddswkByxmlaJfERwRJQ5QuPuRXBxAFgm/Z+UKNMkZ+ljDYcjCMmadXdOTxeW5Sm81sVA5RvM0UsklogAyTNFlpJC4iqg6bKTWiYk/TOIqH5IrOpaKKlorOnk1HUkFJKLJWc3SN0tNSbVpu6LpGJw3SSSWcWyDVKTMWRUyJotOzovdJBkHdnUmhdCpaNV3Umm6lOpJa02UpBFaClsiednQSVQUmylKoVPZTV63QWldKtW1Bnr1TXSUyC6BmgVDhgZEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACAOQQgOce3DF0ghwb01uH4pBCA5x7cMVSCHBvTW4MAhMx2A24omrDEgVMK8Ex0Iy0wjIBmkjqVJojJdcMgAEExKjDAIcLOQkWHOTbh+yw0zWWGCWlg1CZqiMFgAlAg8HncJgjOGAwIIBVDVzOOEIUTwclcFEYUB4jBQ8GHwgOy7sviMrmZktBLa/cUquaQgPBjS2xGiaClY5WpiyqqUzZ18WeQY2496yRPat7NkeI+bcW3Z+xx4VJ8U+osav3X1j0vn4vWTU9b6zLeT180mYeYWre9K1viu7wbarSvvabGc51j5xbVYsWvrmJS287hXhf7xWHXFN71u9b13X3r9/5tu/zTxNeWl8axmXX1S2Imp/7fer2+rVtWAqmvUlUg7bzWHJh1vjKAoi5mQAIGAeWTCSRorHo8wVNzyjTSTGhlQ2lS7iEMnHVPJKmRwfLqUxIVgMqiUKpy6CimHdTBKCY8rJB7xGFLjI+E7iE/Sz9LjWmgcN5hkkYJKrAEsvoI0zjDUgfQ0lKZRPZR1BY7K8y6rLWmgbmql3Yo3TU9S0bspGY0UEnZ2d7II6LIzVa9JF7oprTo3oNU7XS31WVrQWfV1GrtdWyb317darWWrZa390qnZGgqv2TVrvatS7rponC6tRk7fGJwAhUxJdBgECmTq+bBC4QDBCFTYYGSvfwxMGigTp3xC1BQqCzXknBwzeRBNGI2IwAY6NsdnmjrhgGVgAKrDkwbYQrbMjgLMFg18q34FsyYEqPrhmAcKmBlApfSC514pfczrS4CAN7qk7Dla49cAEThSeBWa4VEK9qVYc4gVtFnjt9r03XOb3kraJneZb4iXriHS1qakvA8bVPeBXOcQcXntEvXbutZNUtF8KlL2tW1a0iQ80g19L4o/r6xLUja3vP9/u+b3x6xdZxqmPXFPWu9bpuffktbe8fOaZxrftqu/Wnk3/XO8YzT73iJiu/e9a+mq7t87bo9cMLgyFjT7xSIKLGCYBj4AGAoiTwQoKPsSATITITy5dUahwCLWL06EWFdyjaRYHuuHCqXQ0gaXuO1sx4GXvwudqM7pFEqzxmBKFgK6+9diVvL5dGysDWz7UsuoKABofRahUJrRQUo1UpaZkipJZkXkqetBFNaTskk7ocypoMyFkVIIG1lLTSXskyndkk3VSdKpaaTpvUpk2WtqKmZOup20q7bu/u9fdbu9dFG/U672RU6K1ter11utS0X6k3XTZB6n166S3TQ5iiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAc7bUKDnHty7hHoQG9xbh2iQQoOba3DzMghAc3FuAUAS0zFIfmUQjEj2M1gADAEwQHzkASBwJHQAYVVwGBElh6I+BAEDYkhyj48IZt9EhTBaYfSUqAvZJYCMHhokBrNn0IgfaMAAAODEKluN0gDMbfR7WkGMAShi5tNOwNK7zszM4zwvRLs8ZYOVdBiiBtGYXnwxqKJC3vbVqF9SzeW0urUzNS+74pj0pJNuuNW+PPjO669sUr/u9/nUDNNfGd63esvhSRq4hf+fdNYpl9PHgxYtr3kpnU9om5da9M5/xmn1afWc2pibetb8/qVoZAEbxbGAF2BCk8jvmBf3tuwB5JHGGhmQGiwiQoBJ1WF6zaH0J8w4cCpee6LF23dGElrsQvxVJUkBDIdBkEtSvn6V/jHgum3ElaZu0BhxpanMvJg+2YCFM/s42qF3U4BEA2W5mKgz/FYhBmUXgyzV5D8AFA9A35mpmWybKhiCtW7oJsZC3ERTWcRoOYKN00jxdNCUSNjI2Y4bUDx1M+oopGh5FbmJVQTOsikidY3OpmS3Mk6alHmTWgxuZHXW9BBR5PSTUgpkEDRS3ammpqDqNE1mByZJo1tRUzVppsluzKTSqSUpBkU0XqW6L9dBkkXdnSQWgm267NetrXupNI3epR5NBFFzZ1CENhwSdVqzIRECDA8eMUAwmDQyYjNRtReS1Mfm8MJqgTyxqHi7puPWHErlBw/KptNYw2fdmmQ6wl4I+CCclF3sXmpKNIHmGgjy1aaVNWJgLFqz/CT2sPINTtHM22+wzgDHKtw1ZQ903ASpHMkTiDIifoLdTnUEy+VH0kkSVTIhgfSNkkFG55bIoLL5xA0ZaKCRugpS31ZdoUW0kTikZ1aCc7TUmgYtOPRUi1FTnmZbJutJJabOfOLOOlTUkit1psykFVug66CTrQdT6WmZIum1Ftbq2ZBFBZrQUmirdNeYV6nQW2lSTZ1pMcWfTPiMKmCQInIlk4INAhkqtGswkCg6YCI5qIgFtVNgwGlASlFDxsYyBmW2KOOCQk9yWmHiWE9KksIhTEw8zFmz4taiIWCV4wrLKUoS4iSAbU5AUKlEViToShoTtzNuSUSsw8AfGszJFI4kdADQ8UTE3KJgGETaWnOoou00TQUbqHXOOiaVU0zA4YnGNyypNJTGp1NI4mYJILUoxNDFFaklGC5mkhPn2Wi63TW9EwRMkjh9amZJbIpMYOozQZNSLLPLRUbKTnHUk7m7GFd0GZE0ut6TWQQbZSlMyqS0kt91L0kWOsrToNZaVSk0KnWpTNRUtAzSSNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHcJBCg5trcO0SCEBzUW4a8kEMDe1tw63IIQG9PbgswHAdZjQaGBDHpKBVMHgMYPBQSKwcGklTGiDBw/VtgaQMhzOybCY+dUwQAs1UmTLop1qJhcgl0QEBMVA9NhW1ES4kiFBm/Nz1MKDiMcByZmJkAk4juapLc5k/PX9dyQSPlI6RwuoKA+EI1LC+o8gNhTNDemcVLThqkeRL7mz6q5fMDVSaaZcdFa0HUyabmya0VOmbJLqc1SUbmybVObrc8mfZbILTMnNDBFlT0+ub1shTXUowROOufep7J0bpJKd0U+bM1nqXXdBFkE1WoUjNjzpqVdbOykFIKay3p0F7UVqRUYLUaMg6aRcLiJseDgSEBuypNTsUBhhfbGQA4GAMQC42YPUKG+HBU7zSalKzFVY8loWJQc0uWV3+MIZt8eRQh9pCGDVb7UGscqKzEgbLk7cFA6ETM1xyI04sZDkSh4ohcfmL0lqkkwkDtffVMmYogCU1LyR02YuhbQvJJJ0DJbmJXVnGLVNzBE1djkyWg6NEt2TUallbU3Sc+bJI1MgZmqTn0XrSN3czQepaaSaSkmdaBmeTXRW6S0zRBMwRUp10EZoum+7KTRY8pSK00roOyqkEbqspBKp1XZadlqU1TOZGpotTIslRTrWaLZN1rsigY9RoieOIupE3MBBhIthp8qBNEyO/A3SjSMKpkLMp2m8YxCAoeZRT3HTQCHOoQ0MOsOgtHKF7GeqrFaZbMtbHXMBF0PSsAfYiEaUvMIha5PS6YISJmjd5Cp0SCcGK00EckdbT34UknbSUW8JfRRJwGjRZKacqPzGv3zLOFH3miLWzCMKuP0+2ys9sMialkVaE6LXJTbGq3dTNMurXhjHbbi2fdXzzfbWtY3irbGfuvbOjzT4dEWrUw+5dd3NTd8X1XD/fHvup7bDWW/ut08X8Q7iGxzVuv2/1HN7rL0jRSQQACDDwjIWQOWXINpnj8AQoLzCTQ7clLJOKAQYmCG5Va0Te89YImO7cKjnHVJEF3TbK0NHlCIUhiksTgjMWQXg7K7hNJBR1KJVEKIB0uPEZI9Dmsasdl1dsAYElVWvTcLUr8T4+87v9vixqnFokGHJExrOt1ixT+fSw5vXedas+p4F7yyVtTOK4he0Devm/xA3a0ng+9t5vrOtyZiUx93gSwax94vWlsa36ZrTcucXm1b/2/lrmu6Qt699Wx7zfP8PUCL6V1fG62zNimrb3uv9vrfzv7zfdtY1/66rj79vvddZt4ucarNbElHJ42AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1+QQoOba3DqMghAc09uHoZBCA3x7cOfyCEBzT24ReMJgOULzWwOgUwNGzD4VY4GBkfEg8EW4GQxwNFhW+HM5KOhJu2mHA8UBIJTStrprhMqKhUzuUUiMMCmFjwSrMsHmk6YGGupNW5wLhRMIMLkzpmQghbtKCINEy7ahGUtlxEH0t/2RKjMlDcOtDegXVoG6lJ0FIGq1uTy4XE13TZZ2fWy2OGJsbJmaLIumitTIoppupMxUikmkktI5UpanUtaKzzUFOtNbKrZTXd61m1NSD061oMm60cxSeiykUF1uynTdq0rqZS3SR7pu29SSWtFBkDyCKazqDI3uhd2d0t6K0kkGMzYei3LgnwwIDCINL+O+0oCAcynPzZwLoBCRzV5WX84oVFrJYnZtcZmcq+LA3k3lRyshRz2MGKcRWAwKBYBOsidGmTJLywPZ1ZmyIM0pKNNw1BkRFXBp4hKXbxsb3FwMHmc8XmrWrHNB1mmKwZBbWfF4UWLm24kCtLx9nvbEffccxLarWasCS+tZx5tQMYrb5jd/EtNX/Vb6/hY38z61S+t6rqlt+Smrb3uPrNrS/dM61reo1oNqao8+tWx751fGaXxf3kxW1fTeZcXx859MY+NenpX/5v/nG641bd8/73rO/bG9Y+8/3xbGKwY8V9DXUAQCoGJn2XVAiY5pzyeCAlshC9FiPT2KgKF8UKAcEReQLxKoOAseS0pQEEaWALRn8EK0Q+nLgvp/BoPuaTAFrRQM55J4rBzrUksxEIZHgqtuFP6PGQUCbFc2wWedfuejTKFiUs3ZkgbYXmxFouYm2r1UG9YgUn1EbMO3m5ZIrvW8Xi28CNvckSJZ5aBG+Zbxva9/JLXM9daxLJeWSFT+2IeI/pG3ErjEf737bf6xunnh2vSSFim4k9L0tatM1r7PsfPkvatMfdd7v5qe2PTdN/Gf6Y/3973vN8/WPb1s9+a11im90xn5r9fOa6tql/Xe6xNXlXqQKYNBWTh2BULmCtmYpE48EDBQ1NiDIOCMjMDBUmB78RqrLUFjE+HCd2QZ3mmjiDVE2ihEARwIIIvP3RkwfJuiLz5zduaiJEfR2U+642iIQKnOdWQRXGX25e5A6Aq8xkzrF5jvrqJTElRdqfGIX96Yxn4iWZJoVZfWT4n2+v7WxX0jU3rNaZt6zaxNXEDVqf3tm9NQ7Vv9V3u1ratiBiB/vNJs4n3LS0tfPrVd3vu19Y9Lb9sem6X1WmMb+f72tGv8117fGs7+N53bwM+2d6xjOK41nWY3+aa185/390z77xTVaTwrRs1YgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcCjsKDm2tyzjIIUG9LbhzmPQoOba3Lvkggwc0xuCQCgYDslWszRBMYuYxn0DP4NBInC48E40ZAAxMWnAoZVKiAHNhyS6MPCQlKqFmRrR+1PJP/4biIQC31aEn0fs38MBBoxOWJSSjbevTC2fGGg5CK18HQnK12HN071Kl/WJ1TGxkYgBXl/UpaY8zdBC6CaSDkDOFiCLVmiZmbqTWXS+cSJU49alGSj6BqhqRqu6FadZggk6DInUlJmKnSVQUikfoPUpM4jTQSRWimktChUhXmCl1qUtqB9PfRRd3bZlsz9SD1Mm6K1U1LVuyValstVNBTb7Oqgy2QXXetF1H20Q0jy8N1lgGBzVqE9UBTQERwbosqthoCGzBtY5QYu0x89KHkDZV3SMWVltx51WwXQlBZfTHnhXVGWHMwhMvyuCgwWNJKOsvk1hIkAolzMFwmtKpBhGmFgQDeuXapA2lgkpqETB4Uy2aapDmwpy+zeDZ1MsyY9lKQscdKveizdR2rPQ2pdn7mHzUVMRczPMMmb9ts33DIp8tpjO2xVKcup9s+oYzrqn1EQ/5d9xdu9joe+XzMdT1XTY2x3bbff8c7f2XE/VMtvxPW3jUnzikIdwgTqbp9s7IAIAZAYmBwGAIUKpj43JuofGCUwWsVnmK8gS2OWTBoye0iIJbMLlM1YnUxbHpus8IwCo1BeIkMTiZYgGYbneU4WE0+5LC2wgkKGSNGObgB7Y7Xhumu8JgeL/k5885odADYSyJvc3LyTJJesxY3OrYpMkkZMitSJ2aoJKRPuXU1ntFboum60nSZIydJA7MVXQUm6KBrOI2c6mtFTMeUx50z9bFxB2pJIVo1LSNETB6ZqmmySknRUqtq1LTrZ012UgpaqLOup0V17MtlqddBNL3dF7sqp3ZVdJdTJLTagZoioBU42wtIa8YFBBmSnG9QovAwOJDgZJIg22hiEKFAwa++lWgUkcBAkG+TaV/jJtjUa02RJiMT4kpR2SbcESMS0YAhUG/sLvvoIoStQ4KqlQAKNVykSOA1kwNHJybpYunqZsBHsKClU0LBWFb+Qe+4yBn134jjo+wmZvdKm0puWrPNw/dmcbv7L0t1nFlD33GM34au2g2/5tX/vuUylWZdaf3pr9b43H+1vTetVxutHYutb/6Cavdnfe1os22f35e0c/FTa1v9X+nOycq9k3/HMhyuVzJtb7ZuVvetb32Zre1tj6C1svRyc+rf288U1hwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHNo5Cg5trcuuyCDBzS24c9kEKDe4tw6NIIIHNIbhZ5g8CMvizjrAGO0IJSxBcAAw4EBwwAKdmMSeLEFVarUpoQcipDRhCgcLy7rNgA6yu0hNrOxXGQOhc1ngsG2EtBAMZ2a1I9iMWmrxgxQBEQeRD8F0U7NWJRdmZouJf55ixcZyVAxiipRmmuPE66KB0umLmM4yjqDmZqm51TmiZqmgbU0SeiioyWk7uqpJaKeca6bupFR+xsmtI+iqpZitJIxc3vTPa0lWd2UihUgZ0U1rU6S0NJNVBBaNaSSdR1C6lrdVkkNS0l13VX2smqzMgmpNlJrWmmzvZJdFa2QdAxQZE8iiaE1QEAzEIAbmnQ9YiCxgH6GLBUCAGMmEyqdFB2ZiE4wW6UrpKdVhuU1ms8e9MrN6Tk2DiJYQVJAMGUcKBawAkJnBkMXRanGonQBd0LEElFqKrnFPJKDyKOsJmnbvQxSu7Ch5A7u51yzya4+FFGS8rnFQErcaouK1HRaTEEDWCAbnVVDrFDfoyXyX21rz9kZ6C0HGW9jZSPW99sVuD55p5qCT3W2LcTbcw3mzlSx1mVmjS573Qej09R1Q7PbFWbO/ulmmrIfU7mHWsZFv6qqjnunVT4k3chHHVnojp9MZNufVvhlxFf26+6q5XYylTy+CZceB3H6S9MxtQeAhAsYCpG0qZcJJUyRtCCOW5Uj0MhNUtwcBwcAAKzZUtMCdItkmnJ4amC3DY4qthX9pd5goO/PcJokAok7D3SIiL2MlBHHaWcuVKX8oLLz4dyTLrJHSiARSDpnEzzoEumjTNDdzExOlFSJg6RwzUt1nnQQNaaKRsxmkiykk0EVIPQTc3WySaTppoF9SCaK0TNR9KglQMlKdNFFE8eZ00LJLRNE1stDSRdaCkE2voOjTVuzKS9aek6S001VLpKegzdSSlqmHZOvSRd1IprqZTOhUq6KKLJIO7l9JAnEBAGQKZ8SWmYCAxoGWHNAUDQKYGD5zYZCQkURCDwUEt+e1I6rsxnGKvomJR3YwJYIXQN8iS8cRHANKVj1Fgcr6h6Knn4hWfCEsPOEJycDWReAMECgfjE4W/svp4nWQ9bu9t7qUQIw0TBIIhozKsTyYajqtLQdEkMPEcgG5y2eNc1nKGWPhDBhx8SroIxO9lHihWczNlEU5JE1JKEFIM7HvQ+HZjBw/OVSJLNmx5RUES9RFjunSO3uzxdIHq4+Hmm7uVNt4eiKvXhIeWpIyWk1R0Gz4xc4fKT8F2k3N1j15gwhJmzxyyNzBcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHUZBCA5uTcO1SCCBzSG4ctkEKDe2tw3dIIMHMobhFguEnA19jQyARymkgLUEMAiU4aMBIDpkGHEQGCZxY1yOouATsLlaKobqss4yd3abK0j4bdGqDgdP2xDxMLbX4RELnU1NpCc7LdIU8JhAIsCUH74yuE40uVyy+QCDpXZwUaHE1E0EqNi6gfUeOHC6XFM55E+6aSCmebmyTrSNTBFNBJ1LnM0ZBAtuT6KlpnlG5cSMK1m7LsfRNTI+ymTUXnPuZMi6kz7IHWRmLuibVUK7usyoHDeig26ruyanUutJnvWutNJTNQTRZNS121TZNVb1JUnfQfuitV661rXqepalnC4ZkWLiiZIgXwFQQ9ybb/CAImd6ycWC4QNh00GKi+IgA0gCpRAZDdNXaKwwzWaOwIy/CkpjXkHl20pLGapgcAUXGgyO4CRWk7BCVc2js2HzInq6iYCMgDWpQqMbPIZYxZmVl2tPAhNFh0WqVBuIITQLgDhPcMkkSNow04RE2c+HLEQcIocnCZy2RLVx7nDj6PUtxcNiQQlUwcLqIXFpHFyh5j1BQ0cQxpdkzTIilPFDlFBtk/ZCzMSTBL49yoghZnuoaD0kaPdbWZRSk7pKN1oVHVSXq+hdQLWPU7SB4+R7olctLNFDVvhK1qXhudSQjEaVcCgIIDAEMyh92kFqzMJcDgY8MmAJJwCIWxUUMtMhYwcaQS6LoomuyY8Oy8AgV/FdJmSAxa6nLPw70aAEp4OUdV9nFzAwiQVtzrI9L45ACHFDgTGz40OG8vxyjxMCya1UOmiCZiiCXHiykkUDpGrdNMnOgmxibJTFEuoHjCikbHeZJoHDI0Lhi6aSVN7nWdVakU5ifQeggkmmYmyqDqWtqTpup3RY8yTmrma7ppIJLd62sqpRg6qDVLWggktb1ulZkUUGrWta+yq0azRDrU6b1zBnoUVougpDa1bKQd07oprOGhLmBLOO4fgEBAYCVBWWp+CMKiL4kolT+AwKB4jHgklyY1GY8NWvTvWxqfPllYWOOBSTLlHNDF9zCUDtWRpZR9UTARZSZSfSwnpZN2RUkota+lAn+aMAgOfiMQ1hVrRmo8abSWdS3YsSDQ7FxDBSI44bEWoNj6ssgRpsXop3Uqg6lhRUHyXDFFCrseiDpNUwlJuqiF7JP1LMgsey0KOQNahypOaa/XC0u90PqxKio6d1b73aT8Orc2apcaaZY7Seh7wzcz183wPmWbrp2en1lTBedNod/lLWB/C20c3fKSKEoUNCYUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB32QQYObW3DiUghAby1uHbo5CA5prcsys6EBvS25BQOEYGT7bFMoSjJDOCMNYMBDw4sXx4EINhVRlkWxxqlZC1c64aIjtoICJZDBTlGxiqFsqQbe5uFMTBZUB2KtxQgvKahQbt1aOjVI47RpBEwUPEBYTGUE0NLlPy+lgl9wUJz1W01ex204CA+6EJc0ZOP26SlOmWWXly54gopa3pElVh8+g+HNWOy881yesw0daVtOn03sXhJqiR6WueetaDdqLWZ6HIKHaQPQ1qbpYbnGNc+ZaxuvZ1yDbb1vu1zOJV321E81tOi2tbTfRdVrHtlXT4u2VzP0k+GX21zuWMc7s+zqZhXnh0U02PNkxHppaYVAkBrQ1oIBzWPc80JJiQLJIjRk0XbMOYxITls/g2GAzujJg5Y1vuL6mm9Y+XMcj94FIpHtTggSJmE5GJU05S4Dj48yp2yV2A20lSRIiT0WJbfy7Ss8CKLO7zpH0EHCbLPIGSDSwxMk1rTNXZAxZN1IEU9N3SSWcRdBFaFzFBjEyWy60FsZOgxsXHWhPmjUDybLcvIpLTUpBabLUpSD0rKQpsfWzmykUlLRN2SWmykVJIKdSSLPpKZkF+ykWr2UkfSN3bSQrSUuyTLWu7rTSte7PQQqUpuyktNTmxgbTJFIvBUBmDQjBM44YyBBydGAwoPAowKTDUpPDAFD40ZCgfrQjcsY2oIf/4JFIfHkU9T1DwF2PRljMXd6WJ8FQKng+hMVjqlQ4MtdtzRVFShuj8QCJBCqiSaqy+XTGGeVdwAYCxs3jCkVGCwU86yJsk5sQWQM2MTJFBzQ1N0Ui4gZn0Xc4tNz1zQxVKzqKCSRwopOaKutBM0Y+6+pFJTLWimdUt3ZJN1mCqCDKTZ0EnZBFJAwUpFTsmbugtE+6nSQooOmta0VdJJJBNJFnsi9STraeZrKMU61IWUymovoqZlGyTJJKVWqgu7oV3Qp3MzMLKtCAIS/7xMFLPGtcwDuhoFJgA9IbCAVQYxxYDhqDp7j0qZGLuEwGnbhfttyKqOhp4IY7YtGLBEgWNKoJ14sXR4ficpeip1iLGXlZUa8OpIoGxyJfjnIalSOhcLIq/dE1tU0ArCq1Jss0b1nKqqYuizOUgflK6iZdNyonaTc2cw6dlykvn4leXG9PuJmGSjDlXSfu1jsHXHJiZt60vqdh6dr4hzj0bXXfe7Zf+yjlnnknJn9oy8tenqRxSvgAx8bvPQ3YC1MOKnpXtf4PWMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdNjUIDe3tw8VGoIHdsbhzKQQgN7a3Df8agwc0tuR0DMAFoHkLJwoAGg3x0AUzMEmJ3KYhGm4YC9JiN3ikugssAJlWSoHGA4cpazsmqozFLiGLzr7sIrpPqtUaVvnWQhUDnbd+8k8RAksbyPKolQmp+SOkp6tLS6zBAHFPwpimXbwI47rWDO/l8fe76lpjV4dsQK3ixMbfQr51reaXhTVvilo/reWWTVcwcUj13WuM/7/zHtBg5zjOd0tq8WrzU9JdfG82lrfUSDbdfn53vVPjFb0/eb1ul/rFd/GcZxnGb/GNbzfdtYpnN7/G9ZxfO/v51n+Jbc31f/4xj6+aVpjdsbprfxGA8sIQJMBAUVrbVKcYB4GRYYNhcRAuBRQMExjRSboYbi4JCQ0KQX42luYvJkoHTNFu1XIMYQKSrByiDcJYYkKjgSngxMWJpeswwULkEZxthYvULJQOcRdBhQjaTCj0SPmE1WnvUEMBEKPDFzVu3YMrvQvU50ZuRYtx9+K1WIV3K6oN8qtcrRVeGiymNLL2X36zmPLL1pl6LGOyvV3X7PVlmkv5Gx7D1Mb/8mFn6Ur/ziKzO/2rZi5cttWFr4LWm/fM7+0s4/9Jpk3lZatINr1uzLt0pTOzZjizn5tTabbJprX5eKuWvl5v/Vjtfoc3ejzJgGy5YAyqHxtmkuL2mgyYLVVhQAZnaJSUMfMjNR4tfeRSlVVOwy6+R+ihg4DegNYxmjK/eSCdz4dlwWBoFSwiRML6fUtpdrWJRDykYLe2VhgESGSZkxA8VorN/m4ECA61UwPqkgkoHMWKRNDJGUlpLTYuHzZlT7mjqHwzdkEqSSVkUk1GhmkYGJggjU5ggZmDrUZ03MUVoJ0aCkFIEm5xbuuaPWtBFNNlUULO60DqjNB009TqRTUxua2SY+eS1opIIJdSlJuilUu9arLZ06B9mW1J7pPQSVuz6SVnRWy0ka7oszztFJBBZu4IAYyD13DQEYWFgYZnmRvAKBwHMFhk2yJAgHJamDUaEAmV0sVdFB451YWFUrYLEw18wrmh+0rTF/MCClbHWeqwSlthYK3+OVsgGkR9JeB1VDUFVklAWSR+ktbkNLafYMUwJngO9l1B4dxCUlKy6QM1KJ2zSpY+nKuSpdtIaUOlFRpfNn3p2/P6/J7c5eWVTITbEqNc7Ua85Jpt3vZEXNvbCEH3w/2ve5C2PiNzUoew5HLDkPdB91tiFuUIQqW93HbauK9jWyyWos+biNsVHsvl3xz1Etu66iPpk7aQafsoIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHVJBCA5prcOhSCCBzS24dmkEIDe2tw7rIIIHdLbgmBoNERexijPiQCiGamBgmmMDCMakIqCjAzChZEgWviP01O6J9co0Zh8RCpuMKCmJ6QBXYy562tBce2BijM1zU6lRQCkFSdsCot5XjnZsaGDKAiSRyR2LVPJqWpJA45RVJ0zUpaZPBJS+ZHTqNIeqJkiiopos5sqgdLqzqZiXjdSOknMU6ycz0lpumk9aaSp1dA8szYwJiTp1mSmRZBlMZnmWo30mP10HWmzInUbIsi61u6nWnZqSbKWmtjYzRZ01KQa6ab9JGloptZZktd9BFJ6NS3Wy1VIqTsmyt0XelUkmanEEkTY0M0XLQUDAaIhgBTSgRbk0LBQWZVsgw0mRkAli1cyIEygxrCU8Y1mD+Y0tk6jdelZaYZg315pyjDYX3ZK1RrsmKBld9DAmmzTesS7hEmVTU/LikeFQ5EVjEExWDbMi5LXdFrcWrcSci2g+hnNPadciGT5NtQlHLSUe5xai89duZSUJrMPHac05Vtljyc2j5ugq5C17P75lc0fFFB++lTVXY84gyz69Xw7ZOq9aoYsovNy9toO0IRtzW3R3Z7am4WlJ1rnFWPhtfR6mr2yGUnNe2JZUPipqLe7m/5dUw+nNOxXwyXsfVoLW+Vyhg4CAIChYUA2AsIQFmabJxoGg0CTw79DSydwwxQHhJfMqr0S5zgCUiH2uBQHpJ9exgrjDvpGtna3VCggn9IWsokUSCEAAcH0+NwQArT3hitOCgcvMTHkAP/O3M4v2q3MdAddlyjzLRgQxsiem7LHeyc+iaUlIMxuxmgy6D2cxTdAxSRTOrNFqWtbmSBTNKDtQRWieTdluo3M5BTRM2UaUkTh6g9FJNJSS6Sk1pMZOo6kbJppLUgmknQ0FO6DqWiggy3QZ3miluiuqy90u1BJTIGJsx5662spnTWiy3rSqoPZV5gbomykjZF3EsLC8MQSBokAdwJWoAQg6YDw2YaBip0YFAUZ6AiTAySgASlonIrLSTcEKDnszgYnLFoSCgiRoQ7a5LoVZAF8UBrmo2lNjjEiJDLuz/YaFEiFz0quUVNIUJFLy2KebdicjM1PMMM0Ie2555M89RoBts3JwgPbTx4+sY9289wgXnIl+fpdFqaKZ9RS1zi9vOIH1U7hJqTUYbCWobGnecPUVxW2HS3NbemzRWYaHDsJzDISNjqKyK97GS1ih6uvVMHL8+q1j17uuH2iffVnYplnHvt3d0q+KpC5OtplJufN3zFse53fVb6ZUvZL2w5SGpXZQVKDwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABzuQQgN7a3Ds8ggwc29uHPJBCA5trcOpRyCBza25i5cZIqObYcZ8zBp0TBIyanGnBcdeBjpYNDj/Z9j5AAGqzg8CP+AhKf9epkS0zbi03PbjPhULT8xdJS3SSwqIWvmZV5EHw3nMgQAdMoOHiktFbzhyzVa6BgKX7yZMuKROhNyiktExc0GMpNA4alJBI1PIpHiaZnklJsgbmiKmdSnY+Tzx9ajZzVJz6brQUgt3VOIUU0lOk6z+tNF0ETiqjNSGkkya3RX3QMJk1a63OIIukpJVa0WzJ01qP0EkWRXdqj7OnNHWq5nWgtZ9BBF2Vnbui6lWXT1pziklK1LTzZNJI6xsdUodiD7rEoCi6xAuBTLlNNwhlF4VJhlkvsuX6Y9EI8UW2sxOYTuMnmoIkb43eRsSbYG3kxSJQSFxSAJ9/FxzzKVMIHkWqxKSS+ULjUUMIFRQTQvzirUpf8Hyq6ysKBvcLVd3h1gjCgXzDlzKlNVfZn3h/fETG7Y02wsRXlcYvaFmDustN+t4uY1pKRMW1+9gUtrGqvM5j5zaFfEkW1IOYefE966gW1GrGrWFWHf61v2xe+6WrafdqfX+t5pT3rr4vF3qmsW3jP3rH+M5rXNvN633v/6+s6tuufnWpse2P87vSmd59vnMPN9YrB1AbtZbH5WM0hv3dQ7ACSGJQYXhAglNgCBM1lYXK6dMu5WgwqAI7gsDpBIhwvsSM/M2a218tnWRPITFDnngxodGIwMGg8Hbzml8Lig23JCQNIQ8rFoCjMntWq+FiNhwbEsOMgy1GAeC8a03ZQ7ay+YHkDySBgs3RQTZFZ8xRMEjBI2Nje9aJvRQUaPdGZupzRNaLUkTRNFFaa2dN00WNzBi6gtSzytjZA2Sy+ZILWpqCFaDVOgpTII0zB3Zmdbo0jyN2RUu6lsiu9a1IpLXoH3sqiy06TM9zzLWtKkkmt2otWzMjTQSpJzQwWPU1XaFQQDgK/qPIGBRnxlAMlDwYAoLCOEEANMsw0rQMI3wlM0qkOgZjOSijdbl8+0c0cKlkTdJbtu0ACNy4vD6upEkc88ii9HWKpILADoLffsBNwqEkwtNyGknbMYqXX9ByFIsK5Skd8xAVNYjK00xkaVZ1bPsJhwiuMTCWEA57jlMUOug3Lrx+KtKjZ8Lwkms6pqEZYVHKfaknZUh9373TZ/c+HVSlU45aisHoZcGtIy80PrcrWm6phynV2rvuzx66e6rOumXvqXXxcbpm7dVxbHJs3059/va5lQ57UH0/s7E121iLtsRfydC1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeBiEGDm3ty7RFIMHNvbhptmQgN6e3Lrb1ggc29uQoEguF0xFXLqLmGM4EaCBBWCyAjGhiOhgxMxABxoVw7LpBJhUANkrgwGfkeI60pgU2IIX9UVRb5rziZsYebNe10EACbEKpO0A6ESqnhUGmGhwyVjwzMQzrWMUrUsZHhuVXLz28VwhTjimvp5uLVjWqv54uZbW7zUSFqE2Qsah5vrdKRswb7bN51iNHcrWrbG6Zp9ZlvXNot8T+9Z81ntd1ifcDW8Txt13bXpul77cY0bMt5MV+JHl/fPhUj7v7f216bxqmpfjHpjGda+vbcbOs6m8mPnMlKZvffl+7VzWuY29V+fr4xnOvLWMsGja4DTAIBwjBLUUzknSEHGCOMY9EhZEKD8zcQETUFjGheFh8uWLVYARuNeiE8qVrsprqOGJCsN5NcYpCa4hGkObQnddykZioZDE9W0Siw8SMab5mJkAAjqVhMTeilpKaV1pdHEDJRLruLvawNDstLvdMdfr/B1Cj3zEhW3usGfGszwPqt9w8x/b1jWxaHPHgbhQK2zWmrVmrHvBtWl7YpNvG873a/3JTdN6zuut2rmtqbrF98XprcWldZ195zul92zvG9f61/T43b4rbesX3uXNItvExu/n3euc61aL/qa26yYvv/NaYxvXxiaX+XSjDrxkYMFAF3yllTBTO1EbPRYGMDGDxQkOAncFUxnT1Va8NMRP+fGjMHg4hOyhu50xDmW1V23Z/NoC3Dkcy4noB0J32uWFpzknkVQFKRxK/PIrR3MZnczBCSlXuO7wL2yLa541TwG42PnNI8W8a+3uKVlg5xCh73aWviwM0xtsrrO5sR821S39LX3SXEPd8bzE+q01XNJq3prX3T4iZ3vddbvNXFKar903Tdc33r2tum4/p48LXjgmL0nc1nCEgoeca0nnBOftZENkMXGJXpMp/q9GewAYCQUDAcIkn36hgQAozLkDbgeAQbEQaN0A1HBfBjVBBA8aVMxZgTATmS8SDWpu1uORILFkxlG1PSePjguVAl2KZtY87oBCYpKrc4X+GlBHamY0WBtR0mL4DdJs8uwpLFNRpq3tZP48CNXjneZxX6zI5a3fbnHgwruFfl1MraTVg4xPLHgz6jRpa0hRZZcXgxJKS4iSapu1rbxnzVkzWLR1JqmP9ZzWNWTMXO6an3WX5cYdPPabVNWtvy03Lq+YXxm2K3+IssO2ZN1trEPU1K1zjPzv/G/ilt2j6kxTy46BgbVf0yyVYXj/M6MjH4VAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGspBCg3prcMyyCDBvaG4dZkEIDe3tw6tIIEHdobgdDxolh514UhNMF9TNgNWkqF5pqI+7uBw2VgjW5RvBr54Ko0Thgs/MSuAjaJ3P0zFzpyNAQI3W9Yh2yvxn8VxwuqK1a1rMeTlQ2zfOQT2NWtnyqibWyxdFR43OAbDQ9ZJEvkianDRz6tFFS2ZSkDiFmWlTUtDUX0VnFIIHFIpJsmkzrTOLRW6KKSCaLIqOaTudRZJBU+o1WpkzzJoounZ0ndBFk1OzqUpZ96Dukpl1p0XW6NNOt3dda7Vq23dWvTazoW3qel61uktmamlWtUwrUgxw6cK0wuFlYpxvG7IATbYkP+R4iMFLjgy8tMX1MfhQghcvVp0IGOASR4Loo/huFAUt32AHN7Kk9EZ1GL1y8oyUALrTFHShcRKDRO6dgMyEIHAIrEY/lKJvcf7aup5br1Xxcl3BYVRljyUFhxMxIxC3U9Id4D57MGj1jlha6jG2hyGNZu9JvDJXLrcaXcja1HNsaz5ceZd6aDBg/0EOetUVzu0uWjXdo4v34ZrXiz3mx0o6W91pXNx8Qxd/V+Y9zFca0zaQtRael/FVH/UEZ8jRkhcNAQ+3WUrESrMm6zZwsiAAMGguIEglywYetbhiH8KFNwy+0QcfcgBKeMNqZSoSDNRtqbPsDDQ9N1fkWUn1XzXZ+zvbsWqS1SgYsFBkiE4/KJHVxpdU1IGBW+fXEN94YZ7jWI+xDodebx7W3trrems0pRu1fO7wYl8a3iHvbHnfkrBrXVM2tmBNeLT2s/1q2rQo1sSXvaNTN9bj53mTe8QMT61u0fUu8wvS1/q+7Z9Pi+63zreq0tWnt9fO9Y3/nFr1+d4xXdqfG/iPjWv953vF84xr5pq3p6wvbWN5rnWr5v9/cmp54CvvFOQwTB8wTB1xEKXaEQNmFsgmRgXl1BCIJnOMSo2imKAniQ3qARediSehuesLAj3vBXvN6YYdRao1hjlfZb5BCTBEBNTyKAEAjjyVIdiJUNSYVT2eSTDUgIDAaEo/FmOy3rYq9VeDKK1LoPEFCLQ2+XFxg0dQw9mDsizSRZ8bqW1GW6xCFusnjBJbSw4+TT8QUky4pyEiILPBtbyVRBqSKozshwkJGR3Y9u8izGMPLpiBA1sOeOhsIbL9nqcp1xMJuUjq62MTPISJfaomkraFvvSLV3uqncp+KNe7qFq2aol3imbk4P6waArGhIAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3qQQYN7e3DmEgggc2tuHgJBBg5t7cO8R6CBzb25L3mEDiBKAIqq40wmKYtdxUWDLG+BJOYcKFYTEJbPtGGQMy3ZLktyBAPnK06jDnGb9n64n3lBjwYqingsC3aJvI0Sgr8pioBQ5EL8BGJipAFkRe6cxL8d55SuJI0yy/jLAmngQhEXPU00J3h5LWt7PNZhXeZ3O/vWn1uDutsVvmP5aT+m6a3A1i2Z7Ra19vWT0xGzmBqmdwn/g6vtqgetKfO/nGY8a8KaLNWtq4k9s/G/59Z3XEKnj+tIVa1i39t0xfFPe+bUrjePq2s4zXdsbtTX/+Naxr039a+s5iakpj7+/i2NZxml4fyxMKiyiDuEgOOiamT7kgNC5lTRmyRGLCQwcNzWwsAwJIQEFFcWmgvC1KkjQZvrzhpTuYuSIxUbisqgdvIflYoFqNkwDcfikXsOCb8y3V0YHXdYE1BuRk4aIx6XW79WcoY7VsSpA25cvMatDUAeQbfR1aqbqOtzjRdFjShY8cY869pqzQ7cm41ScxZ67K+HquNDhqyIdB+XspF9ul6NnIcf1mWclrlnJHV2XMva4+xalpOf/tfMvuW3TZ2rVM0ikqehjKh25zG0r1abPdLtSOlJuIRd298tjuJbDYhVkcvl99R1EXsTN22S2lxsOyNGAAi1eQQWKgYwpJDK4QfowOADcIFHgm/hgMaKgYzKqWUIZHBRAcXUoGGovIFihRqf7FRVccdtAZDaSPCFMPBksa/K4xayrJHSipk1UdGl4lB/ANyESSrd7bgNB+XY2oO9Ys2Apnjhqu91f6xamGfD6DaDmLGk1E1uNbdK1ixpoePZ9aloNt3gWxaDrc2qZ948ODAk3i2Pqlr71ArEx4b57TN7V02YnzuNm15YWPuTG/u2c5vW98b95/TH8u7Z1jdKa/mzjWPqmtY/zvXpf5+M63W/xvftv3p5d2vS+s3+bVxn+ubb3iLPbOoMk8+n0URAYwkF1WMiWkTBI0EYCktpiBQhGnjGxV/TJIBJi45c1Yaqxg1TER+iqmVntEAlRvqrvPlEX2Cg1FCsAnZfYRBXQzeWz/SqAred5jijYjHhkUZpt/7fZ12tzswUAdXXPF3SLgc+8X15bM89I2e1X3Wu/eN4Gbd5TUCjVfPg4v85te8+4rz7jWr7YjxoUeBiFquvXLPWnjaz2V9fTfnNoETdsZvuNE3bEFrnxL4VvH3iu4mY38fNZK61nOPiPi+849LRs0lpGxrx8Y1imIG7Zxv599Zi79q48e39I+vqls2+cYk9vnd9ZtvED3tCxebwgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAa2fkIDe2tyy9AoMHNIblpB3QgN7a3LoUSgQc2huQcEgo2UPkeKCAyHwNcCEbSogkKc5dQAi6hDGs5pwrBwoARFkDEwzUzWMZClwLTLLYtEI+JEMFEQK2BYs60iU0WrG2ww5lg8BiQWIAAoM4Ll0vleFbd2WpVY72kgmZH0QGKdQpKUgSaKSJuswSagbKNVumdSPs2izpoIorWXjyloHUjNkXdJaaaKKlpJqME7uhQUmZoTdBZuyFXNTWkuplJKTWgm1F7p7Oklc0oH1rVpopOpa7rdHrulpL6rukgignTUjQPUVVu6jRHIUz9tTay6ZUl1ZL8QHBUwWCOSJ/x0IGJssZ3ETTjAYiNWjMSASTpgRGlx1GpTMOmxE/t8SCv0xG1cgkWjPbt+HsgCZAJtoyhEKqZqrKBWvwzZC68y1aADQCRQooRqhqRHOGbmFALBMctRJ9xYCB6nTQwoBR3RKu7tnpIloMcscdTxvlCySW6RWox81TZg4fcshs8NSNb/dFqRLMkLVqquTW8unNiw8rWRV6H8jF6tI6qtLnnu+7TlZuZ517uYmkGRVp6RWbtUVH4o20ORCuugg0NiqUff9SpgYDgEFXrK6q3CJ3KShU6ZonCIiP2ABlPt6ecgpYM2SLDgt/BIHuV21M+MG+28bV6CMGCgg4BFYFBhMB13LcmT46+A4OmpyfEk4lHCsNksntTNWlxvYI08/MvqQpOAsGCKCCkUiQOInVGtJzqJrdzJ3VRTU55z6dG6jdGpNdlWUpZ1NFNaDnk0Ty1NUgo0QW9FBF3ZRgtB2RMmNFLWyDUzNGq1lpLUhQejQWtStVbIoG1SKk2VspJGnd1oH032uo4m4JbYal6m+c78FX6UbFZdFOCjDgvMFgFO9aC7zAwYMq+g20LiUBg0rmgz8wdQYyQag4xITYalqqKdZ3QmPF0VS6vXXwMaIWbyiLvbFrZiBVEmOvlG76+XAe3PGXy5Wtua3X+KG8Lhw8SOhTw7KOw92o0tCbGrdxjRILkMA8WXcYQLAHNyoeIQXRUEKQ5lkahWMNIIZbCLibkeIp4giUoixyy1nTU3JlidCxUeVj6saS2PLlTz5WBxR7sYK2UKKgioUNp6qnHN2hitbdxUXCuySONrJ7S7yN0TSs+oVjs4Z1a0Q7GILQw2ouUVUipHuMq9um51UnZbKItalAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaPikIDe2ty6HFYIHNvbl3GQQYObe3DRMggwc2tuA4CGkKLNbyR1MX7TRgcMAhk6MbP15RUGDi/opR0tlKYwvEYxE0JHKjXzRQ9qFZfLV5uIjAeWAZLFw01smCKKR7n7ffssst1ARoSDiTUvl9mkuVK/wG82FrJ0qS4KeUUFGSnTGOy0jBy490TY0ZkWME6jBIzc8iaZ9BSKbMTVJmC2rWZo0kb0qqS9M1dOm61LQPXUtabJ2TTWtrbLWg5giiitI+u9a1Jpslq2Y+6DqTUlapk2RW7o626md+9JVWnWgybU7OtnT1pLU9SDuaThSv4UBwjEgsWvki/x4GmeQ+Rj1AOABCbaGxQCFHjFp+DBo+1ulaOjocDICRJL1e344/ABNrFV4nkgm6YSKxVyJdKrTtCoDQ2eVlDIeXzAjZTGAhd5QOUGoHnrMp/N4S2VN+fi11l0UEfUDeMUP2XNfvfvXwb7pesuKyVxrNLw6V3Egv9QK0gwJp4l9SXlgY+m3X1e1M7pJbX1SI9zA8fWq4zX0m1LSSLFiQ7+mq2tvecZpredfVfumb4pj3tuNPJvesV/lpnHxnN8ava+Pn21rdn3zvFaxqetvv3+s1z87rjFMfOa6+PuNp23dlLVDAQX5DbOBUAmFo6ZTBqXisYCzyEbXDAYUQgcqIxZmSMpqOeNBLtDIDD03JgdGtS4tNcUTpgYNFQOaC0lMyotdY8hqfih1fqxgwgKh5UKKa3J5HGrONXB9E4KuV5zxN4GRNI8Xz4i3eR958SHp5rLzy43vyR/m94dL6n3X41aLvEel86xDjZ/9YUsKnxmtdzXiQcxLwK0iwYO6Y3qPnMuZIm7x949swfTNrX1q1KY37axrVce9sQ6bxT43bGdYzbG96+s5zT6vq+d3xmDrOt3pi2ba1msuNXvbGv7/d8Y+vjfzZ7SeLB1H1EgwH8g8CioCGsxV9QsCzEuBM8BsIAQ4NDHQ1TQRtMNnMMDr32L82W7MqsUN5JC95vmCDmzMRWQyibLWSKHZ1oFdxVwwux9MqlLGFxFsBAFqqlADUxkVm5PzXbaYuPb6Cxx554/rtu90BU69h10MY90udJ+5VbbHNh3DqVhT2oP7mXHHQ1F+dja1zVXstS3P7k/baTrtsyyT+i92n73Uo/dF91D2znnqtiJ5pr9kOpsTEPbzEzFxFW7bHc7+K2M+tvyr1To4riO+4b3FTE/fzLbm5lp0fwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHO5BBg3trcPFyCBBza24Z5kEIDe1tw7ZIIEHNsbhlZjg+7rzwAt8zwdF08iFQYYmVGCttcKk6/Vty6rLVNjkmQeGn5EIBjUbCZyUOZDbPVxwxKzDQ8lCNt0HgWwzROmewzo2mNCq2GwmGhA6XDwJELVuS2aTHlZ3blPTJqWYGSIWZgpZoannMtkTizA6Znzc2RZFI0UiozNkjymUmxnTMEkUkk003SqTT0mSQTdmUu930nc6pFafRMmdBIwdFNLmBlMamSdNBA+zpF9JOnQpn3QZ6kU02QUgm1mRW6kFObukpa1qVUaIOi7akU2oJIX7skgp1VKZ+gyCK6k00UEygSyRPL5KAIBmQAmtRJdQQAhkyd9TWYnEQECoWNxhtNlR8yMSxYpua/c67IhBjJvIAgEfordRQElRHavQe+U/NJpQw8jYnhpUAwXEGuVaCRozLdS3g92zHwh0yYJeq83tXsmoaRupQFyL6iBQ5pauBwrWe5yKwf5ZJ5pq212SUOspKnSZJGqrmH155k+czQ6ccq11tp9oJNPnUjY2egipBaapoUa1DjRq0mzjWn1K9HFmnbpkOt9rooGL6MHWi5fa6WrTe2052qtlaJaw9MLFzb5bDrm/P9tqohqDfqHOlkfza7/P31T2yy6Z7buXM+WuPEx7ytARyFCAEBITTmmtjSOMc1gNjOyFgg44TVpg8wADTzZhN0E8xA4U2JhCLIAcZuBjHjmX5MxYtNVgwkUqtvA7ebfJTYY3MlZIGuzstIiUdFCgciFNfpbXOZSyL3c+Nls2wGDluc+rbzDOZTdMnbfaky3YxrjlRCLWuu+V7a+vqJZMdMe89dVzFsfvpsw02faFbYmncnKtNuaTLOtrIq4hsVVTzTZu5h797H8fdxLm9bnT3NzUQ7qt99R8Rcvl8Po+70ru3cPd0+t9U9iZw+6aNUkkIPmFgaEEoEABlrIBYJmig2JnsrDAgIphsZEIFJQIDFcXCdrl+JIznC24sYz1NSU7PjIS1tb8igWI2wSKsPdWnJgqLIOg0Rfmgxzwc1nrF4SNKAjDUmZQ9EJtfWordI71Pawq24tYuCcX1taWi+j9ZVm/Ux21+iXUfa3rwbaLDnU7urdgnbzDF94Ozf6tPhN7c9Bb2Z15zWGV8XRw7Ttrlnv/HHns1p6itZTNmmztsl2C/fOT2tPRyw/mXu2xva3u0arrGbTr1c+J61Gs2nx3vv5NJ27mtba79unKN2r23tVy9b3mLdv/NydFivnw1j6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3CQQQObe3DvsegQc29uXdJBAg3xjcPIRiBBzb25L2AAEsxVAtkgARhWhGNgoTA4Cjwy2P06qwwOHWZ/GM6wXBTdOESG4wJC09xYpiLBqdZWrXK4oBlKBJG8REHw0kyg3O3PxgZlkbuwEAh9dRQcwBNTkGY2Lcqnm1r85WJFk1sk80WDvTHeG8jSYti8W2Z9yy5gz6tfULL7TLjwa1lhwN4zPGbcavS1q5zbWdPrxs2mp/aWJFg181PW8G8bOZryRMU+/a/xNSa1IP1/jNp58zeFS2YV96p75tisCHN7ZpvHv9Z+8X3uv1j5xWu751j4g+u9e81JP66zb6pr/eN63Xd6b3Lq2bbb/HswvF0mEAWxdXThjIYMkdY2OHi3okAQdyUfb5kUAkxZVXtx+WM6OwOB4virKaTcpNCEG2pZNdhiOGFDTP2OLJZhVUqJgVi2G/gtqLdVvsKMNESwN0/eOe6WNW1qPOzVtVI3ib1ofFZXGPJH0bk+541o0mIUaFaLq+9Q48SJWkNknteaG260/1evvJNJBpFrBns3XjxIO641b3ktbwps3zR5fEbe60rFngRKzRb6zetMQ6sntf5p95v77trHpifFKbj29b/cO2frGrahbzjd96//pBtn0tfV9emPfNb5rat9Vx8/NcwafFv7bx/i0atL5ziMqDSA0EQR6RUj6AA1liBdYl2YCOnonhMBPaHFRMKV3Wlr+joQEE4QmOCHCCHb6DxgM6xm00lLOCYfMUCNy8UO6a1KPApUMnq7vchyvMMbIQQ8ZWHmwQ1B0qnP7Xjg8DpFemH3l98oHpaijbshyslayy3GttsSJqGlsUU6+O/NVjLsKZlitKvn+va7799q5Z6rDVSoiq9W1TmNiHXK/fIY44Ee5fK2W90cFdizY0qysT1KdWubs3e36bDX63zK5Na5XrRzfeu19pZrnRzX/nsdne3Z5yL+jy0Uvb2bbdvTO5qc7LUWze/b3N5J89T65xyOAYxWFlAZhI0YEBjX7GghYJB8KkACENCcgjMHKUuWm5K7EkUuOpXhIAddwr+2BhEe2aVvPJnwnTExuQLdgooFKRRUGhFJj20o2xyHWLMZMHDhEBudQx2HG70dNhW09kt1Xc8a8Lha2dipNu21H4LE26gQNUzCxes+rOeo0KJPfGs2vl/qj++Lt2HufSPjGvWPRjrjNpYnrNW3xiXO6wYlKRve+oNtag1i007/rmJLvEKPqFeLDiwvX01WHbWLQINvin8bW7bktvVrb+aw9XxEx/6Q4+c/PpB3ietvnWNa+M4ve2d0/8Pfvv13TXzueFhzkwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAd6kEEDe3tw7pCYEHNvblr+QQYObW3DvMcgQc29uQ4GMuAWnrba0IgMzH5OIB2ciA5NcQFOHjHD1y19OzLl9CgSb/tgYNcItHPyFjpkC082CyVC4g6RhJU/lhrKIktTVXNhEd1qSijv2QUIvGUFsGR6jfeb1T0joK4pZnCuLQI0hMoFK33ayPxq2bXxmk+ct0ajdXGNbzBkpFiZ3SHvcbUG+oMCBBg7rDpqBmPEj+/lhQp72+N3pbNqR7ekmZZd1vNSmIPvrcLdc73JekaTVs5/3NmnrfM9q4zW+5vW1deelcVrqlfSPveae1s0+sZ+tbize1/rW8yX+ta16bxatKa+qX9sST3tuWuoVMQJBYFGKAKyFu7ooKGhS4cyAAYGyIFmxRMEAZ0jGxWIiMyGltwYk6bhiuPDjNaCX1DMAd3qsojDS6cxYMhpKFwGB4sYJQN7OVcmiwLDin4YDElRtTmnnHsfiekMu3EXSxwzmjQ3tW4AsvmJJCb4zC+gV3umYtsv9RX2Z6apekaJfNYt3tqtmJrSeDS0C8bFYNfe2W6HqNak+9vcxqRoeI/jaja3e99aeb+ZPS1sa8HF63nxWHTcKkClombVrTWfvW66xfWt+Fbf1im4+Il80trF/i+P7yZzaNvX1WtIf1TVsY9a53vGMyV7FOU6jM0DJJBEEwUC4zMuAMAMwNDTFINbEDAYZ8DqcEuAQQJgEobKrMQROOgOBI2dVOyzMNSMpN4Fo2wsfj1CMFM5CXKRpvKmoaTHCtDEY3bnygOEImUCs1LcJDflNqtTRm1VpLYo41cGdu+E2Gr2oqSkdPQtb0ag4qpVXtfUbDrFqStBmm5s2+C6Huo+6nJ7aRbdnYaxjrfDWGte9jNyNtljnxUPTY9jI3Pc+HVDGPpKWSyqbsbf/Xb6e77hz6cxsTxNXzTYNWNWh9zb+Kz9Q6ne6r/+X8WzprnVV26XpKCgfDgU1ta5d4GA0yrqzbAfioiHYgLECoSDFpyDBRb5Kci3RgvZAl5zvjkgMrLIRfcmEw7DQOL2GPY/REHWl9ztfkzQPCvxZDns+MbBRkDW9jYl8anY3jHnLJgCcv2o8aSJtxCR6a5HtXChUOOa3iSxq4i03mHE8aXOc0y8XO4dpJY2L7pCrunqxeFXNYrJTO9Vxjz13T+FDpG3fea4tiPV7TeKwokvn1XF653/jGLbzHzvWoeqZvm9c5ata+49s438U1ut6V+4Vb53Nuk2a2j58lrVpnwPq+s3xv7rfdvTWb6zjGK5xevzj//2pWSALAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHaJBAg3tjcOZSCCBzb24drkECDfGNw8BIIEHNvbgMBSY5eFuTGkB5qEKE0aUwhNjd1NUbuAVIQGJkSvJsSZh58oHLkLSNysyY0gkYtUXyoU6coMAMnCc1lDW/YDXzs5WFKkSL0ufEIBBwxHgHVLIGtVLU1eiKz5+MdrW8VkoIRmKEykvr1K1p78H8n4mOv+W7+4hmyGtn5Xf6GzRMcwrWjDomo4IL4zyzXIaxLY67M/boVl3rWYVUspem1pR2WTfI6xuw/rFOe7prkMLrNHK07q/mx1gvkTsWP0uzs268ezM9NL7Xr/Xs+vUza5To2Jya/Wcpk78N9m/7ejdX97IKVfT2X/Vup4X0zS1TVBmHI4ooFQeYe15l8SqAAoCBkxQJLxMIm8MCrpRW49SWpoNu4Mka7q26xkRzP1IGsvhNiwSsqEPW4XGZPvC+25p64uwiXMZLAQpinlQ0MWm705huJsD1jlLetfseDnhr9NYJHE3XcCeFHky9pv3xf3j1hRdV9YFd38TGJ963fOYeL73Gxj/byFE8SDe+63+5q4zDeWiYpv/d661CtSekt5t+FqlrYtebG3vzWWl/Put6w/asTGfjN9Yr6fFb11nW8Qt3tq9LV1vetet/nNKZ3im7el5NfPze3pn//VPr3zf38t7sLtMoxUCV4t9iJd40D8OlDiIBBo6dCICQW2YxUtIgVlb2302h0Bmco6Ag3DiAbDCfIlM1GJKppR1bphcNqGNQdooCUvTmjVNTVKUhBpEAaTGgRdGBHH8p2bt2ZZY1LUuLGWF4YrdoDj3Xsz1zbSeJcsOKJHZaq2uXUdq3vbi/N1Kx30h5ZSjkf3rTNpjcNoj5qccjT6nZrGwhsS7SO7Pux07ZX2X7W9qX7Ybu9WKa/H2X+jHWfbc29dpDDStazZy+W+/1p+U1neyk931n/mu5Nd3b5djJnbzK2lt+tLfk2/77vzt62jm8p9oTVSg7RvCgCAQCL+Q4nAXjM/Jc5WAUMBkiGFTDOR8xsKxIhtJh6WziPxyD8Dgp1U+reKmpiaZhSwdZjcGIhEgJTzY8CXlHRwIkGr2S0IcVk46BjwGKADHq8zSams6bJ3E5redLLDmgX0RTNeaBrMQ8Y8Ws2H0KsHGtRPNr1iSuoE9ok0GJ583l3N7xpN1r3mte0a39Yc3eYx9Rd31Afavi1rUnhwbVjYrm8J/ffxisSe+fb+taT+975til9a3XOLe194vnF/l/v2j73nGr01i+NbtJr4tXOdXzTOdYxXMH4vm2oFr/XximMfFf/q2rbpFf3a4DWwgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3OQQQOce3DuUggQc29uGUpBBg3tbcO0ReBBzb25QDgAB0TbNbFAMBZsYQBiJoWFJnAWMlZeYKGJEA4dhUtlgwBDDUSLNSVOmzK3SMeBV7pmJp5vBQBgwR2eRVNc19hs/as5ZIex2TXpkvkMhVs9DRU8F9v7k0lZnTXd/bfHl2WfiZiRqXVkOvzDpXc7nSfUCLPSF8xK519Se9NTLvEGDfddQY02NRayxG29bYpA1r5k8e+ItLRqR4v3WmvS94FPuNLq+87hWgxa5p6x64ziB3mrazu9bY9cX3r5pvP8bd8wd33neK08TONX3F+NW+Ymfnef8YriuLWvr/X+t2x6Y1X4pWl/A22Nq69JU+j2h1eSutsEgoyxejcIcSBQrIqsXHScJEQnM0SZnn+aiTpQsUxZOHfVMhGmv7TRPCBYJAIKsE97RFQ0iHhgIHFZdL54lAFeryeSRDyuIQSJarxXLKalcuoGa2+dtjDfu5q/EtotYBRUw81JnG4VZsQ/7VjWdx8WpTM1cQb3eWlvusD61DeusbtJe+o+onrGw91SDrN9WltjWOze0kW0LwLzbmmpmHfPzm2qT7tuFPq2bai4ri2/vUSF56134HrqNSt/nNM+2r/O8b+ZKVtbOvml93u55zAxNT1p63vuuffFcb9s11vG9ydiWXCzkk3oFC1K3OiHVNDL4ANAEIxgQNgD2cP8YEXJdNGqzzWkeTfbMaKXWYlapIZMXJIpt9WPSuiAQ8jpVokmNuFbs8s5xWH5NzFPEkESYDlfLVjmGtSVj1vmlTQ3/A4eR7bbTaCtlOYtLOFmXFw19NpT+qSZD1lzrWW+K3KXLmxyaxEPtG6Y1zmMtk8ylMO2QpzuksiH1XLZ4qbPvdurmr2RzHw1SqZVumu2xLYc265hrIfNdRVUe4tuynbrZ3M/Pdyx1z87f2RDOrakid7JMAkNt3SmdRGcqBgw76jJAsGACIB2ZGIEMykxmER4aqnkF94FTnGPokNywiA+aaaZIhQ9SyKIvVNGKADdIGgpOOiQFhgi+c5fpUh0oWZN42ExQOgC5MS5/6natb5PIqbK3R5W8KAbdJNz/LYUbLbGNRcRcx4OrwXdIvpiLPq9d7xbcsSF6x7Wi4viPaJakGf5vJa9db1SBeFqPqPbN7QdR9wMRN3nj0rXWIHtEpn5xitL6vm8ucT7lximr+tvjdqXxu96Xtjf3/aWtfn7tXH984ze9a3rrP1nNtRN51X0183rbH+8UxPj6+veQUjFrgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdNkECDe2Nw69IIAHNpbh3qOQIObe3LtsagAc2xuSAvDhJhkBMOUxM9xwGmiwMYCSHJiYQBNAMbHigUQbiElfWePgMCJLagrRAkbZcBE+vQMrSybu/5iA6jM777IUzn5fL4pbuPfMTcGJhiIHKCd8cPfa5M01M8amk7vPYsjioL0VruxpUjLs3bu/C/Wh01W7laK8YsurS12fpStWljiKN2sUV7NN5ea2epDF6avZfL2SNOsUc7KZrtL2ezrL62eu1dbeNj3GMmGOP5ru63Hk1+rt++mzZm3MbHtrw5SnM5OT+Xnf9vPrM0z7feCG9K71HrbvZTvt9O2u9zXWbrP2jyzrb7v3o4yIxOAh9AylzsF7DRLsOaAgHBsRAIiyBZhBOYYP4YC2QQPJNJSGt8RfyDQgAoZpq5oZ2uGqwXjA31Ay36/6dJrNAAARqWYZTI4LuC6CvVZgANpoOxjNvNbl2UcvUUYlde0wnOUUIEuazqIphgVRYWidQI3drq0uighUzc1dptyCTbcIF217yU3q6kgrT8IEb7kwvBeEdeh5KyhmsyWxlhWamsVSJ2evKbSipppFS9qUzNFFXqMPp1SV8W6h61O/ebOku1LFsmxlfJP1WdO1OOpec7zqU/vRb53DPUvF23kL208W8rnK5UpKaW+FslrAYA1iQS8QwBxymggHp0FUTmfxk27KQqVVLUnofiDMwoBHl1wQWN+ruvtqJUWqmpKmzLHoBpUVQB83wFgvrt0s/c7RJ/NeoMI6icqoVhsz3KV9pt6dNTO9fxlgR1qXIrrdI5WeTVgZjZdwJJ4OMP6+TdJ8SavBpuWsOFjbE2PomfSJFpZ5jMKtqXp38kHcN9PvFYOIkbW6Xj0tbOrU14G3VaW1EjTbp8yN0mb41Cg1tndb6pEpb5tXEaXw90tndsQN2zAvne8Rq39/4OrY/v7/OImYMTdZfW9q4/zvFvbO771nOtQ/StvEv92zaMlGAgBBgBZY0AhBAEBJmm8nAgyGCIGjozCMUjmkGJC8JCKggXJfSHEA+qCVwEq5c+7qGiDDrXHbwjMfFlhy3eWBZBZQXFROdv1uiAHTjgVTh3zLwQRhCQEkmYRCasZi9qlYP+NA3S12GASWu01pRcrVjz3q29j87sfcyixJ26tivR6+xOlV2Jfj+LNv8b8F+reCGa8s1iaWbrSt6WicXRxV2jR60iepHM2pX6vdf639bO5s32tnI34MtzN3OptJX3n8lyuVX1nnXezKPU6uTtfp+fetLO3t8p+2k5M5B962mnzsFqu91PnXpjZlyossXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHeJBAg3x7cOgx+AB3a24eAkECDfHtw67IIAHNrbhUo9Hvq+ei5ZoF6c+BlYMYEMnJCQYAtnKD0oG3xnJqhJAiZklJdN/GGWLS9guTZNi0VQpfUChcTqzNDctCrNWx6vps9v9HqTuY8BUpigBR21fjtm9WnqJNKxZztPBku3BQqRNYzjyM8GFfbzFXkW+d0rPvc3pErSuIca/i2a23ckR9qG8qzOV943F8utMUkKFXL2BPDtSFLFxmFWTNGPdXmK0lw23rWlPWHBhTxLQdelKX1/83tbeM5x8YvT1prXg1npnOM5kzTeYnp5q/5rffremZte39/l5GrNme9Zs73r/fz9+X1xDnvW/ppm1Fc2WFAhIPMZS+HAXMCIfMFwvLiDIImYIPJdqWGGYeEQWMjiUvlCgxtmQHBzaqOVZiHyJ2c3czTvBBAshMZi1dAl1OBFR37E92nRKbi+Tgg5YZ6ljGKC9qrnYwkDlV4zm1ddJFcUTzG8tMRe1FU02qQtoyumobKVZog+3pJnqTebHYPHCYeo3Rh2cvYq2WJuXtrjjHG6hqcM2rWiYslixq5dn6Vve/XtuylUWv4Qhidna7ZSxvb1HQ2mJG6CcKMiG2fqLpLbbpc+HRVVLWWchOFkfqH0+qayqfD6qla76dxEI1cvTapS0LORYBgFf7VHPexFYz6iCVaHCAsNWSWatkC6gux/Y1AqyRUHGMpwoE+rI9zDETBw0b6kd9PN45wwQGmZJ5rlRwqLBuHN0ureoxhhHlN1Ukot2rMxR0dmarrpvbwgwYt4UgZ8WBEZn091VNjN3+73h1jajU1VvrGpH3e/rZrZ8zQIO4zFesKea1pqUpi28VtNanzXULdM68uKRaR8TUpCtNWXefSC6zE1S2rbvrEG3rve5Ma8CNivm9q4vi982hXzjedVzi9tZ+d+uJ841Bzu8HUC9sT1tT5xndYNZZaWxuu95+tXvje7Zp8WmjWw3NUVxiMq+YEBLPG3VvRVMBgsz9DzjIXHhoYCFJnwOF4WZhU9tZTelMuZlCDo2EmGY0wGPT8bM+F3uzs2YGrg4JemFNGVhmEz2lz93Oaexf6yYSo0YCGr7bW5aefk5lO5y6bqWtqnXKSgFSTjixxRMdFvUOsMDznLvOP5VebywwpdyD0jZE6etDLql9Q5FtOksQNFHPPLPtho1kHrWppyl1VlGNUSSYyDqBw8aXMv02OuLczZbKqt0P7d1NKuatLmXEovY++Ji0YfbKp3UshY9nz52HHJlR0nfrOHs5TqntbUV2VdpL7qX4PHlKXN1Fjoex6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3OQQIObe3DdUggQc2tuHcJBAg3t7cOiSCAB3a24AoBDAk0VsFISAgKTowaEmLmAQQaVCaETTTC4fJgyqtGY06wiBTr9sMHXObt2xTmVir214BURZj4GK14KuY0gbYZA4k/hubnoFlHcWYCgAuKb+xrdLZy039rWeNaxjAsDlAcZ6ZjZngxI2cz029gTRKz3YNWzLe2JL1x93vndY+4ta0iVdWy50tGkza2Y8bb29rbfb3XL60TGdN9ntI9923qJbGaa3jGrTekG/hbxF1a2vv4+s4lpHm1u9NV+9X1E89IuteDefWLVxExr4viH/Jj/f974j7vfe87x73petb+33/CpXGawLQoDkm6v1aBQqnUXXcKQg4BGXowbvAzaiIRGhh+tVixiYBFAfaTauPopmcgOkQu/E1S2nBMrJpDfjduHYgvhsmEeTztKAogQivX08Sr2Z3m7mGgUTltSllFblzG/YsZ3az1LPTgLkyc7MtH5sHqm7erTT1xLUm1b0Tl74SYlb1M/T2dwg26cjZ23223w9M0e15oovB5KDjINTr1FDp5qBoxlfEUrJ63oZy0W3Ena3bpPUxKrOw6ZPXbGudNNqXxe+GR1Sbr/qWWk5jn88y9i7WviLuaq3vbXHUa81uiuNBAnuaI5kYeABipEnpXehwM51jlAJVERmJnJ1F2FmEH4kBpuxKdiqsR7QgTH64XFnIfpRZoe75Kk03CfGiWRJBuEiPWeeVbzwn5nOMy+ZeMqBE1Sa7Q4V5vCCoAn8JRLSekTQv77c7TQoLZSBH1NqurQJ532Zoss82Jt73WDaG93dwhUzEi6ktuG8pPLqtby5lv7SVnpuHNeldVrGiXf3f4tBtqkKa02c+DvwtbvnGt5mxeWl83jZvL4N623Stt0zrN/iucZtvePqFimd11LnNtRY1fnP9qf38mX1ram1eT0zXVvX2zilZM63/Cn3tujIVH0p8GCoBBAqKCMMd8RBEOwQIQwRLBIYGO4RjwBQAYHjQXoeKznEhwCODnCYIiclp5mFmRIMN4wzafTZEFsgb+A1JQ8hyBQO8uVabZgv9Tu/CSZFTdhdmkgWvZqVb1Oxym1XbCpRBiBAyC9tKKED6bXtSSqzqy504x5xc1tqjGMKDjmuPuo0NN1oyobq5s84qcas42SiDNqCtzBodTbT4z6rfnu7ij1mq1GjoZcFLWnqass/UT5iZuj6NW9e+Dss3x91Xufa1Qxl9VGzeo2nWxtU6rYica1lHYq13tq2Mc66XmYbqb71mKrOzUkgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAdakECDe3tw0E7oEHNobl0+PwIOce3DtcYfwc2tuUDBpbYmwVly6TP2kNWWthYVOAEE8GVGEHiA5VSX1I4l4d7bDRpD8DS+TNlMxAocypVCn6hwwkGrreql+qd7Gc5ynD3adSV7rqYLSpLWVJYtWa3I83ta5hSBJBbn4pGoV3PO6of38a2b3e6jyyQYcCPPLD/t65lg63nMeJ65i6zm1fPPXc3i3xVX4hXcsx4dsTVpWSPTMTF5o9dR5dQ5X2tVgXru0sON8Q9W3Ex66ewPncfVHm8/WK7g3rrHrmtPGiZxqnzb/39fulr7xN9+m961iufb6zXOKQ9b3b099a3fNfnVNV3uFSaNCh0Q0Bw/XHp9TAACMuwg3IDkA4JDZmEbJrMNMJkEWBLryCLMKKgGZVcsDiDsVJhhphJxPZx3OepBodeJ74LYheVlBQLA+sayilxsMPtyMJAR0BY/vGnpM9V8K/2pmpjFjFQBxYesmSghCMyFLi4wY+t4vmzENUS6o9u6kjazHVVPtbKWoU9RGIYWi6sXQaYlqWYVQ0pTfqbUdTMVKIpKj5dElRqZuy3ambMNHVY/mYNiNJKvTao7i0ROZ6e04xxh3rR3GmQ6i22DAoMqn4R/niCQ1dpiQJJiaacMAMwDHTFQPTCJA4YQFMQfgwqGigIs7eyRs+LAJMrRsHAeGJJal8FGHA3J57StT0zIECbd4PZ+X4p4WvK9P/Vhhvae7HkOt6K1OUskmp/nblLQbutfjKTdiui7vGklcYm49nUbEalb0o8jXeU8STMPxZN/cH3/ebvb/3tPTeKao9pLGt85jS537afblpFx8xv4O7eTMasfN9atNAzWnvrFvnGZd2pfdsYgf715nl8496++d4tWm94rn01nNs1tvOt4h61ndN31ue+vi2XlK73n7/1bd/aTfxbHgSOEFwl3TU0sgEApjIaLCMXrGBgOaBk5zoEpFhQRmliYHABkZi4ckwnaDIoSyAgCjKvhJJ/Xf7aZMF1HG5D89S1jHQBGRb7dBoJmXqC5BEJT3IdDlWu2x5ZYBElslAFNyuayv3u334dad1WNGrvk8AgO5Fj6SOjrhBitUqTWug69SqcbGhJRpRiErLtc5UtPTsqW2cunOYoovR20nZxY0VNjWNpxxnDWUm5YlpFrqUp7dpieeggyO5caNQu3U25dB74taI5Pwb22qs4vbmoHF/XS5a3Y3lFjGuOuNZ1aKmOu3ztQu7Xoy436aSsvuYdB/3sekwI6hAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAddjkCDfHty7HH38HdobhnqQQQNbW3De0ggAc2huDFgswEbaWxV5EezKN028DVInMcCCrfdkLpa6ZmLXp0lBBjiPFtoZiOMojJgEVUmplWuTUxKEK73tYFgDZkyd+VNzUv5Q5xMDAZVCkqZVI//MdwU/VyzhfNdwpxYYzXhima67kiRrWk3bMSBr2zHjusMmdybxXVYUWNthtTv4sSM9vbP3Gk8aPfEj/EO9pY2X82oktrZruLi7zGMUrvVp/u96ePevhwMx8wLwLRN/eLbg2hb+7Wr7wL0rqaeTM+swMaz943CpT6vjMPFPvVsfM0bd9Z1q1fFtfW97rvWqVru+Lap90zEzrNYldBZhcAZgiHK51Ko2QBCMxaYSBmlsDAyMVA5QsXgKD4qsyLKBkyizpxN6HBL7O591sxgiA91WCZ+IUpigSnck3KldzEOBcPatZorkEEwRbYu7ACVWWEwNnQzFWT63TaGgyM26FRQs0OcAOKuJC0D8SAPQQxuHBpMpaOhw8YWYKMWeYYT0y1UkHZZSig8XND+hRxxd02aSTqmoqOE/VCsCwTwPcYYT1aGi5JpqmHRkrcMTU5dwQkOSjluIRUwRM0LalEB9eITKYJPeqrJIi6unzT9jdqh3m1hjbHtNjFOdanq2fHVeIzLDefcqw8fN4wwZEzyBrTL4gzY1i4T/IwEBkGjm7uURISIMxq7KnaLgnG0YYUxZ77d53hgj5hUXG+GIhA4ce90k141EUeOX9ZqdyOfpqQoGVEmraqU8RsS/fIgvzPO9miz7aAkg+5s2bMPfVsQPtu2RE3sTh1S6k3Wdl6KD2Ne4/e27lsT3fvdLULayqNYltHHmnTaqWOipc9802eJNlm0y33VUtNzovbsi3N67pss3Ovmu4de97N8ti7bPU9+6pZ7bvqpqntg/XfGybbXs4Ykg1TQYs2EDQsMEgkw0NIqtdBwAgUzFRzcYVLqA0NGjxGydgpi0HkwpZHNYQQvg5o0IgpzVr3qjAjHx15YMdO5KZgwUGZ8uOus6lftEWF0VrS8yIBeh74kEJbXlEZbd7l3eE2z9QeVZ3BUpguHjARD0mBzSNIMRjahtDZuC6kTkzWbJ1Lc0IUeQQ8MnJRAhotivYsLnFuuiM5hjtEWXEj6YWLdktos3IGvHBhSeK8U9ocHLIwy4ZktVVsYYOQfUTF23S2lPDLNrq0IUjNMPlGTLOlRIx1pLsevdXXLpBqpSq1qUi0w4Uy7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHWZBAg5t7cM4SCBBvSG4dJkEADe1tw73IH8HdpbgODxgsTw+w5oqWhgSAGNwQnKkSPOFkrShGRIgonBktjLnB8YVkrm5zmT+CAgi3IOVfR3i1jvMXbGNA2MGK1Sa3c+MZ4WKAFEambFP7ZlG56tjKmJ9t5RLwYOIYrrzFrZy4wdUkxSu49txcws3+K11usWz6fe3tfhs3fEDMX0tDl1JbvY1oseM/373xqG8lh2s73DmiUxI3fFtR5YUHW41KxtYmo17taSlt2vjcuMarilPbWNZ1SHrGM78bVPXfxn3xn73mtvqld6xR5i2cbl+9/WN5xDxXVaaxq+b73Azi/xaW28apuPBcJVE3mKhRi5PSJRvQWeNYogfdDwaWBUBLzc27mEJ6B7MI3Yh5Vh/3RQIvrs1fxAViT1Ybr0sPo26VqgGCKrXE9pd+WiQGoTBEibCBBTGFvV99x+7YoKRCrHtpiTIoSBuVMYXH3NegrRlJaUqoNZEK4RE6x8Dpphi2yIYo1lubiBx0jUqD2GFbTZ6TcOmyLvUTTIvMETD1Pu0w7NUjLsiruJHNdLeNeZHqe1vS3KDeNd2mYWtJqEVEl3m5eOae2tkmIhmSHqOmaYpK4lIHWQIogB6FRkyoUL1Q+0dBAZP/G1BQ8BjI0YMKuE/pio+UCCjluw3cuod/kBCA5bm36RkRgY3IcZWlFANkeBrBEBNVTUiqj4MA3Xo7dR6J7K49YEClAZBR15yISybw3AD8WZu4kxA/Q9AsiWPN4RPu05aw3VlWTqUKpvOpJlrHs3oHEF3VVsYXtXs6dRY9r5hOWVqHGNNHshQ0QSUUhNjofqkx8OSPrSigrTzvB43srY9tNQYpHxnLcvdnrYyGU9Z7D0/30+anhjZay4OteyqZvhm59/qw16fBz+YddTNPi3dXMPhxMooOF5cgH01SB4wBAcw+BZUSYDjCgOGBEEGJoVIghYFTI4AkcUJRhINAYCTCYYuUaepvl+HCb8Jz55NLDnuKcZzTUlA4jK1a7CzJpwmxQdS1sxwHKAVsEHsIMSERAFNT7fg+xhOzdPABME7tZkFLrqtmYZEge29ejSKTOvnKMTSHdggUisgVokbuUXqMsEaFhLTs45RhaDMbudw10XzWIzV5F7pwSWL3TNIvKGMY9G65XJhZnIWxKeRI9lBCp5ThbpxxeE8pqWS+bLdbydbKbcVk5R3+DWwliXx/jv2fmvtU0xCCUO3DfPISnu3l18vylmF7EqOSMwQA0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABz2QQIN8e3Dp8gfwc2huGRpBBA3tbcOfxx/BzbG4CgOGQ8AQw5ahJmoWVyio1vBGMy56TBC9JOPztSmIQOZAgZbuOU+NPDAKED3UTuKMyiug6wNGPRMBZasAWARfkeHGFYZVIAAgJUcgStqrN41sOdg3DVPb3jTVI3eJFkniWj1rfEldfdW2FTF7Vg4jZo+8OPTGbNz6eDi+9zY142/TOtUxn3mvTcHxZb0xNF1mJjb6S8XcPFIMe14cGSV79bzfG6Yru/3je8VrCxqLi2L+vxbWvm+v769axd53vVqY36X1T2xufFt5pnNoVZN5v85rJ96xmD75rvX1i/8uaYteFaPGeWVDmYGBZkcBoTVoDoBAAKMx4Q24HAcHxkQGSAqzKSGNRcUETOm4z0v4Y72LAQyolyOtgCDWB8E57dNGSzySq/n0eW0p2IQGreqU5CEr9aJYng5eFRBxNVt4Zy+5ZrDQPC60yHbFFEkgGEVBojPBggFuMFzzUU4w84PYcscIFCiQRDiIKjTRdpU6XDMnsrWqoOsokObMfpraRgjOcP3dSYezKV+kupLLOmqXOGlxYwxcPDoJop1q1tGZDalWkyGzUc8ypGdaqxTTdxVEzDpLDFZksarObY5pHqbXNGO/wno0SOrZaoHQaFHFOYcC4MEGHt1dC8hNMLwwNEvKSCoNGpmCAASJ5Q7avOiSgBl2wGA0Rl1WxsaHpNQV1xVo4m8z1Qpsj77XOXvna0xVlUtwqSsHDTzscufvHKpY+gb65fw3n6iAOG0dPlSV0KQc7es886GXD7bu7bHNS/lU3m6tz2OpCHMt77XndF3217uM8209yM6G2ohroa8+ykGtqOKuWy11OfWx07jn90yava6rqrZ1N7/u573v2267dW+HdOpkzy9r+XPri5+NzKqamolZ0H0H9IJHhYaq9IQAySJl8TPqXCSCVgkAgoHRYtkiCFUmn61qllUFlqTP+EIAZpFWn5ITAxSKW78vxlwADUl37fpoW2RIWttT2q5CKsHbBOQSYwACMASAjD/XaPf51GxIYQ5Vq1tfD5sCs5eq/6IdbfRa9Faz8TuLV1XlmM47iHlNhacj5jVUVGHf4x7de/Fs9XNZV06LKR9v9BFXHKs4+41E6/PsOrdtbbV6NuGd6/wzer0sQ33vt7VX5y7tPxitelu677t0pOOdkzmxLNiv9uptpm15m+1ey/3f/m+7650xXr302OC1M9dl+jZmCoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeCkD+Dm2Nw8REH8HNvblwh+QAN7e3LmUafwc2tuQ4FDSreVwXgFQWYikplkIq4Lsg52o0v4YXDw0GEdodjUiRBPJ1Q5Va85k9DMPGLBcXm2TIx1aEKg5CAolQEVgs8XgDgSH7lylglqct5LRZQFAFoNjWpqmkPe24Fq4U9GfgZaA0gX08hXsYfRt0PldaWbWv735FyE3Nn1L9T6KzDcDka9Muf5+ja3ddu3W7FV1nGmIj53VF4n5bXfV5m/PWWf18+tL1uitf289tC+8D3W1+2425LK7ZvE3+1rfH82jWdjW++7OvX5Xm06buPUYrNMrmbM/8GzOuwfaWYq5lq66xS9YaLupMuxWeraa0a2AMC4sgm4KpqKFUHmIeyZ0E7ECoITHI4tw0Y+Dw0Rk5bUVXyzw4yaGh6dU2wj8vBhTnUUxpqmRgowzGtDuqFqpVDpBXuVy9qbLwPyp0KBqMiLFy5Xq4y7KOTxdmiv7vWLFrILMzajxdbiatJLuBDvi+dwbai2bcRG3LrVbUv4dn7U3apa1dvY1rwGx441e2au6hUbJ6t7jBbdQq2vW9HHy/FsX1LWNu1Xu8xb/+W2YmtXkjSRoLLeNq2679fPel4/tH1W0bEB5anrvda21qvgZ8t5odsb1nVP9Z1rEu8Qr1jW1aLXcm931Jm3xB8dUf+zX7IQESLHEhdx7zOhEfL2AFQaJDGOM/EaCqVbcxdgROMByI0bs0ldio+oFEuTzqKMx2aLSIvqMsZXVbUvQqlmqlxgDnV6WAjEwekkFJT0c/Xzw1VVFhR2aUf5zoYL2jDea24VsRdXZ6YxZ++rE1K5/Ml9zeHTNrR5uwUpa33NLeM2TMULzQaSeLaPSPWWSt6VtvVK493V7+0SuZ8angeRwtEzJu+Y+ZoGf5Mw6an1e+q/FNQ6bzW9vme80euMT47zz7tvNJNZxBvjxqU1AzildfNMWjZUU77k4RBIKSVCwShlkNAoVDiCupgZAAgqDTJGJNahsMBBdEeeiPqDBhdGBgUZFhTrzWadWMlYVJ2W9swgwcol9xU8ri2IMF5TR072YMUBoG8tPlGk7FxxV+ImYyAMqKAiMS6KRS3KKC1OIRT+GMnDsljwfXM2KUi0lHa2tRaUkh6yzJeegyOtYra++tzUT5+k2tLNQmkhVR0EhU8+SYePm02xA4dO1TGHU64l59tJInWn2sTNz2sodq9x40a7zR38nlea1PPdOPOccupNmsnltPi5Pte3Ufd9w7VmY5vep1DZt/2+uZpkS205mHc1T2Pj17zI6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGmZBAg3tbcOayB/Bza24djkD+DnEtw3LIIAHNrbgvSY+DNNg+A2RGKXAGmp1vwVXt/PEwyVgbMIvOYpuHCzwsAP3L92JESCMzrNcUslSV6frfR1WD2rJi97jxWSXSW02UgCofeSm7Zq2amUxbjE3y2dtS7sXPa40maZLYOts+hKjHLHmuPaxyG25U5CD7bHDWZ9q7kG3uRdNvWP2odY+DyVWpLlHxL2Qffbth1tMWZqzas31Xb933v7bCTmdpTua10P6a+K2nH9/Fwvb6ZTJl77qdjYc+YdUVn7mr6bT96D53uh6kyyGPlzHoUiwnvKx1mGAGYZADBBEAFYEgjOBMHxEqQqjIxASZYoqYxPIQJWByDTcV5nONIsHu5FscV9BQfnd0svlFMFwialcspZYxYsizfPCUEoJLKOKS0aOKpMA0FHZiX9o70SRYr50h0sKCaeaCiDlt5IYQNRC7DpecQ6vqnmrZVzZ7paka1Kx8mrlvJ4ykyTi4t0H6lz5lUuejR855xJbauYW+jzLlSpOtg84vchCbpWaxJ0StcW5iCbeoY60U2y3dB59uo4xjbfDnWzq64ZS7mboi2S25WhjLllPeyW06+mVsY16MPWX55e+ZTNnxrJExC8wcEXul2AiAhhGIGQAUqqVRaCBdE2RDJKaRAb2SJfQyCTHkrXPHGsXK8OigWi1dykWohZXAn+98QShiSmwVAksy1TpbNpjZdgwgDSoCZbbu09JHqe5NOGwfVXDHqECOYwSo4GGcX6DEtwxJWccaKbGIgszTklorsbTar5B9kjlE6wepeK85wbCBtQ3dduXQTlMv6nBlEQvd4rqIlb6UXy1yGS0ecTgTqIKmsfm7fPJVHGH98FvStpyyDeU5Lae7c2MZ01O62MZxXXyV3eSSff2ULrOnK5secZXO5W14U9ONQcsyePNFSEzR2wpYMJAuD2bLxJQQYetxm0MSkuEZ1BatbjmMiOLDdhkP3merKNTokrIvDeeEAmBA0WwYbWosH9hytfb+ZZCSBVqthUXk+VPCXiAICkuq2apb8rs1K9l/3JqaqoVbogBeUTz7Wx3HaVU07VWhh6XRLW3ZIXa11Nc5uxlPhj6Vt5o1c7KzGS5FZ8MhnSMVCx2HVXrSkqo0/thfPqS91Qh7Hpug9FU2Ony2GviomDjLSlrz0sm0U4dTWS23ntvc2y7m23btjG3NMtbavFsZxcU5j3Obb4fwtTaYhZ04iqwpRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3CQP4N8Y3Dusgfwc29uHVpA/g3tjcOxSB+BzaW4Y6ZaMIIWAxZdBm5wNoC91ci4AyxuZhomVgT1xZ/ZaIQIZUiBdqDlc3o9HjBIBnNMQTzk87FmUxNnzl0ylJCE5fzGwhzgWjtysMHxCDWpTMzlKrEYq9lLvawwrE0Xjuolt2W1Wadn9bUVxcxFRyBDdhep0tw/MwL5RQdsT6V732bUz37L3rvOrq+9zV4spRbKH0p7tPNHGQOLNmPrOwNMs1jt13Kxuwt608pa6N21atz/dXOy00jX7HTpetHfp29HoLUrubFP/mv5S/x/SBmYp6n2bjm189roMzK221q7W1u29sgTRMYsfPSgMC4rP0GjB4eKACsWAQsCDIOANPBxEMqC8wCRnbQRGBlUXefXCjsofgDfUzlC7NfNgI3s5rrl8utoFv0xeA3YzZAkm1buqsfag6cheMKghYDYFv0PKtfdqpEY1bxp2ueXPVY+HLMr+FWk+2TF8YjSVhWr/GhT1peKt3vB1qHmFPPCg71eDqtY/pqHbFM6bolYOLVtBtPJXxZaazmmcZh68OsOI371qut1pnWstUeXOd6jUrnNd4r7W+971nFqY3imN7xuD62k1PTFfrwsaxGzm9fTG5N4xmtNS0pjdM6zen1msm/vFdel/SXNIEst7rLbIuIZbIzAtUuTXjSRpkOqAtUvUFxwxUdZ8vkwA1S7UWbrBTlIonWyYYQtslFXxkQ8eQNndVrgmNt9LYPoEooywIGCFHZ5MEgDA16Tt1DCxVVJufq2qGZn88YbaDnb1S3HK24+rW6oU7U6r+NRIlcd+Yeu5q6iZlDh6OnWarMHOnj14m6V5qmP5Rqi/nKWl7n+2Mxc/OjcnX/266FC5qsd39uxFbu6DqN/SazkEs9tq32Y69e93up7VL9Fac7Lde18r14ui++7lspemWmjbjGWtN7VrFll7P/OfzXda+fWt5rFZmYEc1eqoDkwOi4PosHjHgTQWBQBTSTNM9gEbHokA0EpqYIKCOqNLcoOjW56GX5CoEa5xIrSFhcquQARGELqwzblNolEJ1RmBGKw4pmFgmjjuUobAqxueMsBRSQBdeNztPAExW1PTL/TG6XWylxYAcRH15NI2EPtA+yRQtCp3KbzqcsjsI3LII0KsJas1NuEzyNk9XnFliS6plJ8ksl6VcnF03Q07jo1XZ8pkrbNzT68DZMfJUWRYYkuxOFrzfuZDmHZGPR3quTv1U62aW0rcijcM9Jwb7E3/VabjB9Wqlk32tHzl199R6H3UfVyphOHajSGCpIadyKIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeKkD8Dm2Nw7pIH4HNsbhw2QP4N7Q3Dnkffgc2tuCEJGEhUoA8sOIvmCpiYfBLEEjwVCmTvQYMHCTSBcBXZCimesejys1ESBO5QgISrNdYZGNyIaCAWgXW3Nb1pyQENuZYqU8fzo79ACQtsJMFx+WRuW1385MUK356xgvXmsB6fgkVGrtWdsmeZjajgaWLon1ip906WTTlh/sdm2412zkHxW5pa5dPA4627z+L7L7O3zbQuWrZb6t0860ev8zaN6jTDnzSO1auvpXHbSzTNYv0O13LsO2zpn/+cpbdq92Ue2swfejO3q2wze9dmscykjreO/a9P1Zo3WbWWfWV1Xu6sFZYm+c5f260jlpc7EwvHQIOhBa6DghAwUDJjHXmoA6EAIqDIwaJUCioCTCDLAQPScjNZoyWpz8WJEMNLykVysYOCRTFOWgiEwOkLd2PO1Bc+zAUAGhTleUTCLK88YGFi8hD3XqyavWwu3qKw9l21bemsK5wCkXufZPb6XjdrRmrbnvJH/tBE43ErU5VIt/KN3Q7cz0X7VdSKGrK1roGDxuCBq7+e9yyLmWciq/X9z+s+u6jW23cvBB3dFS+TS92moa5sc7BuWnIcihX36u2arAv6dan6/N2qMdvUfpkU3YY/oc+mfFW18Z1v8q9n23p1+s9/dkX5W1Wd6O/0eUzBpKkrSPw1czBjDwsoAQoPmOBy2YMMLHh4AbFVsPWIAQ4HGDCyTo/z+EBGDA/a7+KFN2lJgIA3BPKGV+UjTzBAF+qbW3YXFlK4NLnSUiCpuI2pRZmbtmXu5jzKYGozABVFxcWFhYwOplx4ciVx+ddQSSqnEjpOExGULWYo9HCpiwooaI4+xw4rlpc4cqCjSWq3RMEmu5B5rjhctCJFrLJqehRhUpyiO6LfZ0ZRkdsNK12MpahDIU4uxzOd0QfKzHFXjjN6WUpT4eHVOEd2U7gm1nneU2tyLHD23p477Ja6HWMAQwiCUVm3TmGAmY42JoMQlwHeCKeu9HQygdA41JGwFMtwUKI2UiM28WLLKeNGACdqmXfPW50KDCjrjxlX0/AalT8S2ksM/RZdGedEwAAGAtV8diViPzkqrZ2nLwyv0YnnPcAW1CaOPY3WKDx5K7YgeMVtyBQU7jqy0JoOPvQXkrLUiScLXW9hiUUO5VpanJ20MlvOQ6zi9nI7tI0rYi6c7XbElnnjyp+WK5vUEh9Hkqljo486dV/jM3tO72lFLPY1l8Tf2xJrN1T0xyb3S/l7mVT6qz902Hb6hz6iZnXpzW9SziJms7IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGtpBAA3tbcNiyB/Bva24bIkEADe1tw6JIH4HNobgQAIJFFgF9MZTGMcjAzCdliBrQPIImIy9iM/Yi0SFQcwDVR3oFVMqSWighYv0CnMboQIB1Fx302OMMC4ZLJ/ttkTrSej6hSnoTAVDrKfiskzqVXsyy42k1nUKTGxFKGq1rvunKrsQc1hsvWo+4NZJDOTj04srOm2nTWPXdS7H0zaeNWumVodEPfB1yxo5NrUXUihScOdDKuHJoWs9OkWNh2/ZCuy5Y+3MbDbOVLoulfm65dFTEy57u+X1DW7pd9U6HepUJPcxsy6d13O7iodUv3se7ljKQQrFylbEg0eWBmvEYnhkwqMDpgwsjqggM5iAUgPFLp+SLsOFdA4MgdY28aILiF+q/teI2wSEqGyKG45L2uIf2O8mUP21itO8RbGGUsqfCavfXpNSh2PwtOosLk0gYemeN61CND8663MlN1F8a9wo8vRMu3prLvYek+6z56X01M1cfc17mO77MahsRC7LYcuXN3tt55t1U2ta7pls0+oPvanbXHzzaVl8VEE9sS7mG6j5s/HTWLoHHTFwzYy2U/lsSvutnWp3nDr61+GMeya77jll3X07h91sRP2kKRC7OGmq2ocBDkDAE0MdCjEQ9r0bDA0iA4JkWL+joAaZWA4agVefJt2wqM08ubAuOHYkFQSCVvtkg2caGVAuM5W+qKSGOf1VxYBlarty/JbNXGl2zfOzbi3PPGwowhonHQ5zlm0+mUg04cUe26a960NYy3IvOoGp9Qule3wyqPNpVVRiSk3ZzUVrSl3TUeriF4q2KzD3S93FxbC17HS489+590xy3CTGXui6mHRd8sZPencXUw2IurcvnLpXqeK+tz+Ot+59cOY5jWS+J3sayz0pJFdsPJ5CgYArYUXa2hJBoKMfXY1WEl0l5DRgdaAk+YtXoGFrB5yHm6Izmqa603UVzOX2lEInZmmQ1n8tF8BkBkkErMpVA1MXPvSulFAd2Idi8WFi6Gko7casTVJKpqtLmk6yvugjSpoEjmJLc2gkMG5pSijIqksW5SihohBzY0VLga7rJKCdoE7iOzJFnBGeVrsOY5XRWZDlHCFMzdVA2WGCUaIVi5cFiqpeqo9OholSolhUawig2Hzcy4xjTljOdnH2a8y5ZiJW9Uq2qQyDqp9qZne3LlGNWOJSXMU62MT6YbBDdzpQsOHD7GOHAJgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB5CQPwN7Y3Du8gfgc2xuHWZA/A3tjcOXSB+BvaG4IQdi8WfV0FcGawQDDF1iMHNPFGhPAQoj4LBY00PKOnWq5EoverNblkVBhJJ7L7J5N02QgqTrFoeKwenS5BAJI86umBMkwvR1UhKHM2pZd2dp5RhLqjEPrXKVdWp3y8lfOkby9q3KKsv+1HyRdst5Up/G1jixpjl+OsNPYfuHFGK3O43mrn+x0bVQbr+uHEVH2nrLrs1fls5iXn7L8Tbx+1DFBDf3ZpjCGoZfxW3dTS3fWOH8xircw/kcbOXnZihtBWO7zr7OVtSnN6/f+m9rw1p33zoLb2MzTet2bFbZmdYtW+NuLvbr2roaF1UTh1Ph1DsUEbnLUY1ARAFjEOWMtB5IMKhwxqF1MkizLg/Gju5kHzukBBgHUmtDKxov8yYUHVrjD6Z+oomMlKow0SHc0bCwHTVFVpSUBi1R53jBQgyBGOJ6or9m7hL7DOrV/GmIR+22FJ8+/Gogonokk/51Iw8va5iP2Fr62H6c8wzL8LDtkI86t4OqiiURe5FXX2L4y7jjq6jfsK19fXvP5B2xXrV1ZXvpf8pOR8hQxK93sf2jT8VKbb21q29r1pLNaNc7f7MYn7GYHY67Gzlc6a4832bs9v1mfv9Zc6lpt09M5ktbD3+y3NrzH0vez6cnoZzo5siDi1SpeFGhNMrkQj9h8UFzKhx5Jow8BIhFPet2da+dE2hhm2ZE21p4jCwuKy5wlCobqI4DIDAzMV1V0UkL7Enk04tt+bGFqGSUMmsbnzFNFbm4nAePdv/5s4mIPwWdq7Q97E1PZYW2Vxy4irW/RqbOOPLXnrQ1RuD113nWIooETzz/tOWjfYPHbsfbjF138S1Vx44jyyWYaw0dv9Y4+X43y6yNbl6Zd/0rWN3ljVz25HT67ObTegpm7bWK0irWrt4Wv9+v9NNv2S1Smty/W/wTWNenytt/OvLnWnWrzSaXl9PTeodugaXPNCtpYKIa6cyNheg2FcBfAhGCQ82suYsSAgpqFUAl16eiyeptd6lzUUjalsdMTC5y4/N+J0oyDqOpQy5ccPJjpFtR3radrFohPwAIAEkBFXVa+ElkuNrCPNrS5VIYSFB2gCwaYcUNxc1lthz2hp0D1lQ+FaEqiOSaz549RQWuVFSjoMhRg+1KNzlEN7vWA4gvJLLMPEeSzJs9yhUYwtRBI2aJtkq4LsekqI8osGow96GmQdI+YH1vCjCOjmhYLg6olGOei0yhlNUnu1tyksfUUpcpkdWsaW6t3KsOiqbkhCB4qFwmLxAAXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAdGkD8De2Nw7TIH0HNpbh3yQPwN7e3Dw0dfQc2luWXqmR9VTYCjuO+4oCwUXkNMAVmQ2DD1a7DHLzsp3Gr8CGElL1fOQGHKEPV2eKjcGqXKSdcSIpwcRNQGw/Ww5IK1BCLLvEAw7lSXWIbq00z2Gn2vVo2to9En0cliM+gdIdnnlq9ZspLuMnLcrlUTfIVDtmzR3FjDf0dfii5yBhxWk92tP6ymab+vUXzSv3u+1kbyPK2dW/lNdWViyYbYwrvlG3m6deOfq7aesx1N62Nrvsqm+NLr0gYW9Wncs6Gep9LNtXrV+tHLfr25zz946VvtMqzXa2tO82zNaZTa2xmZbipMww5eglC4wGAi7RZlD6DDAgDMg3M2YF7gwKzHw2a4pEzaORJGpDx60wlwDsmYWDlPK+nJ9+AcOSembHfcF6DBBprKMLGXOnkzAoDuPCZqoz1f7VIPjoGHiUMefcN4SrOly+6/dr8WzTP1IFS/QXUtfalZLFJRXRTaVi9WFSme/s1EkFbCR0QsEqNq7Q7MngvT0EG24eU5L6vyzZNAkwxKC0WE2oKGirS+31rrafOKTZFW+5wjXV3JLZU4WxL9uDE7J6jNqMrcrOV52fLq2+Mmbmhv26SaI5cNnFO0svXJsu9NR/bjcIRUlctay83YQWcy7XY0UCRiIa77UmXK/MmkwjjWgVRgyUhhvIwYeQihylpmZCIBMZ8UBsEDwD3GUhi1LOtiVEyiTgwVUXb2NOrF0Qi1VjHC1H4anJ3UUHRZEiWSrktzxl2pWs39d91fBVLmVL+Pbe4sryDHze0Kzdud6+e60+gyz4gRWuSentChdub5NYYv9UxBiVtXbRaXwq5lrLjWPCgTXb8VpS1ITz0ja1DpFk365tjGI0+swMYv5t4e63nUf33SuYHhxJ4s2vufHvTcmfXES+5t6zvf9b7i+sKHWJasX421Y1fUWkau6W1WHnNr6kg0z/ev1r/Nc4ib1GhmFQAOBVNZTFmYNB5h7emTxGjICAYZoDqFBCBTFjfAw/RAfd/HpUwO3OCIhh5PC5IJgxECk1M4dO6V8xMdZ4oTI0sMEahQIaFnZqyhSTcMcyIkTshiQ09LXpdSmxIl0UNbCaKGtsB5TUbDCh9m4JISVkwcjBoipl26KlZoWmCJFFMyjVg5xFTOoMhCUJtwRKVOSFWPT3NNThG0EXMMGSmRNG4xmqYhGKBzUpOZ1d09js5PjLV1Lt72enFOL7nGbUFJSrzzVYYxazUYn6nTW01FN33GYbjslr/I5B6sWWc925DkM2bU5SVl37HIobnn2bOSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeJjD8DW3ty63IH0G9obhz2QPwN7Y3Do8gfQc2huCJYaM8yWNMkb41F4P5MsTTFzyl8MGHUIsM/lUtkKgRv1AJDTmjwfnZbEYoGxequ5f7hP4IyB2WKvw92aWo4F35yY/CpjSUb9q3DwpBEu1EqakrUlCv+tXvXxEdvZRgfdpI0kZhvaBFzFlyzXhy7gwWJ5ApPDhYxnxot3GLZ+5UiQO2P4+Nb1akLO6vYtfLLG0108+3K0Gl9U+4sfsXhQNvMR5Ja1gvdZ8z3fxNCzArDmif4pH1XcCDrW7a+t6mv9y21iuvBnxv0tb6rm9NQ3kXMV5mTFa13O+hwc0j0tfebW+LzfGZYF7a8em7w/EAI8CIHHpiJMiQVhDKCgONonwf7oACUkNNOWBplGoUAQ1Jyyq1ERQHOKtxoffhOuVS+XmNDs3cYbfnpWYwJJLMRdhiOaIrFoRF+ZLwX8yDj1GCgK0lPUdeXUOdJWxbuvO/N8EMPBKHQ1gVpCF5ZxwlRi7BWqB8w9SYEQQDRIMFi7POSYSbmyjxaj1ciqQSGiWT5RIMPw6XFR5qHD6MrGsJCmPLt1MHq0D9hosKvA00QB8EkqYhk3bnDCEh4GU5dukObKCr8SUp5zOL2VRPUiGqi1x8ak1Z13KsNGIu9X9ykKzlydmmsi0MZ5W5dLuas8wIWLA7i0Nji+BTWARUsUUFTKAyZkoBMVQqpTNNGkzCc/IiRx0AE3lSg0gmK60FxtzuipLEWzPnPW2FBQGynOzae81N50sFNxJhWtY1Uzxxv1liUtWncT36/BG6qj1ffTpmcYs0tK/bkN0fXQ2ty7GQq3nfhZZM2jarSHV9lx6VMa2v0u9T3H6wVj5vrNq6YuR/+sv0jlLT1mSzyejS9u8LtI0Lc2yzLJLr6V6DIHYc+d9itY7flL5XJx69nH3tWwdVvZydmBqvvT9pyk/ak1r7t7e929SkeZNfi6jrG5On99xlb5bhbLYCFBKOUrUk14BUEGSJcbFBiMAjBIQvkHy6hlVLAoyPdLKrcSqEGW9hfy2tDWEOmLkk7KmB0kZiAQToMR+Clf9QWQZiMat1SqCO9HJY9YXAmjM0jVDMxndufsNJblb5LsdRoxTBZx92wTlliJIslTYgQIAijnUhRTELp5Z2CZFQ+6H4ofIe2aK5pjjEGVrA0RkUgMh+KodXdi4vRpZRBRBAdDThYbWLszFW8buSlGO1Uplugx4p/Srg5XOKFOh0GNaW4+kyBiI7pVmxKDs+9pLipWUEJ8aSm6Po1q8OUnMxEXFyNc50PFShEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAG0JA/g1tbcOpSB9BzaW4aNkEADW1tw6rIH0G9sbgEkAqigRwnIQ0Mj8BYBj65B8q4kDGGBott3iH1EMzaoMSB3cUXvW4GHSOvWmmpVbQIGs4TRbp3jRTk2rM2i681LhUVy+pQCVKKlmbuHbVO6N61WOShakgQvltrcnpQN9qKM1cmtVVFlntxylWw3WTrNpPsMqVbL4WmEd7GuMDNddJ6T1y5p9qcXJvB07DUKS7205JeDW0keZuGn12U6nJNe98sThitrO3VDUaWSYs62/tlj2Q6IiohzWH6i76axtM2Nda1y+zsNdLWcuuppr3vZTCRW/lFEvVoMyERDoqTfQBWwsCDBuaMQCAsAEQCMyAFJQVQGYfaoCFq7orLoaEAWZnxl3Yg8M9dZEDCeU2aGvLn3FhFxoU+7jekK/kHz/zcvk0kkMYEiWgatWjE/XuSjOOR144lK7y8tZTTIs1P4wj1HeTTXnlpY9JfrSQrLXsFsexVS0uRmX4pcvtIZNNvauptLMpMm5Jk9QYWnjJy1JOh6xWVplIzgaiQL67Z3OnTXpucZoW5UzO8ak0/It4R0qtOErSjGK8nuUulIXGnS3NWhJue42nUvlVf+2x2/PU7erGCKt2/K+pmT85w73GDptgRh0LjBguUBn/mGCmRQk4xew6AMOBgKUEiSHrEvxg1NwxGkaRAKc1u5DoWGpVi0pq8QyAoLehy1biU4rDP0tW65Cn5TnRq1II0sZJ9Ny/Le73D2GrTWtOHIFK3GtI0lVy064xh7pbKbaYu5kW6XSzvljbWOG1b5N0mycY6IhOJdN6aDpOnbclVSdhj9twpZzmbq4YrLGynR1tOn2z3a/vqpZe9subL+quIu4bdS3qJujkM70KZLK991xa8MtODsw12ec65paq72a22l0nqNerQaoG42mKjQgNSEBU0ZmsQ1u0AdIEA6UwtWJeKTNgJxKDU1b+QwIXeOCnBYmb2PVX2pTCiqpVYbem8BCETMSfGJTCizCIpIa+K+5VSQdDQcVq3tRlEeppdTTdSvm06lp8rZP/xjvt67Serfvo1ajlX9XX6sTmKKethmBa57J3EnZdu7Evh1dLn312keY21e0NEdltHn2s9u55/7a77sFIo62xtvb3ous/b+2LM2mPUbdpNuXL2mW6zj0V4nfzNvGuYWwvLObnr034ZvbpvtcirOUp2f1OevTb1v/U3enOozkP2erkz7dJaYQ4TweYBpfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABpKQP4N7Q3DxsgfAc2luHRI8/A3tjcO+xx8BzaW5DBIAiSvFrw4mSF50IKXIQ5gaSeZ3R4TKwB2p2RypKUzuxR9gIvzhbixgovDtZwGhXq6EEP1YN7NSQvNYtbwYVA03PaREJA9tccMJrGpj2kfizcxKWj3YDxzB7jRBznQrYlCBhg2KVRYekZmUqzAzg1ST2E5Y37NHuO0Q9mV4tz1oVMayZe3dDbYaVY0aTSGGxWOeKIFupakd82avhGg2HaB9FLTozvu1SMeyLYactSrRkRMS75aqvc1b1kwfdbQl2pvx1qyDFeLaJt7SlBqDQoJSgcOiEKDgCcVIoRAkyzHTawLSCC4YMqgVnQiAgFeRIAoCll94kxTuyMaOH7mY1YaeY+YztR287ErCoqnfCKFKGqrLQwLIe0zWYEkshbqAAhKdoM1LJBHbV6pYlCjEUpuIOZHbTVelkjLRKjn7wtik3GGGEQnjJPHJI4uedJI/J0iMJfqLpQjEkWx6sXtqUwRKl5TcxWI4swZamiIz9YuuqqgQwxNBLU7td4k1Exhkvh+3Ymp8aep7fjEfWX1NR9AeFPUylFKjU77o1elJ9hlrJWVSVzYxa9HNiy9i2lrq4e4yfksySetMXjOSZZZQlFhT8CphwkZeLtGgKEMrMQkQE5qhCwqZYIMRpxEbu2xmfpZaqY4xmFhpvSsH1anTIAyFzrtLfenAtNGKlJAlZr5UB5bhlxWZkl2fggt2MA9u3SS7tqbp8Ze5NyxixA39XRQvVPY8brHl0HXtrEWxRX++XOG7KqNUfs8d0U1Qn4rwQXtWm3jtVpP8WM0RPOuxTdu77ELj9E78bzlr4/LcGTW7e2hZnXoXr9zl/pSfX0fZ/Mijta0F78kjiTZmwXlZWq1qlHsr9Wfgz9v12eetvbSmwZTu+Wf+kw3tvvXpfXP3+uxaOZmuUquj+y2BREJDH4XZm/wIBBUB4xrxUOq8JQmZzCzN0kTMZLFkSsdvK7wRY6pzCBtxHsnLbyGKEDzSmG70LlxhQwn67jkMVzmyABi+r9NLpuhhLwGDBbAbs/EKr6Vd2ezrN7lmmP7VoyMUs5lN09jSw4bWVQmUc45BfI6Wl6Vky2iZUmvE1JttmDHko+rgxApdqdxJuEKhQ/OSu39ebbXJ56CKJKSrypIhYlGOj+IJzLqIoSQwYWutQayzf2CqEmqjEFclBGsnCPut1hqcVYW0kztZ04LXJ1p+yducJM2uz9VhNzcZoqns/Gqy2IbiBPHrUgxRhsLVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdvkD6DW2Nw6NIHwG9mbh2OPPoN7Y3LuUcfAb2luSzBlnDA2lwp/jTDCnU5AgGHkKs1Z0ZAwTCl4Q3LoeYgdagExo/YKCN1LIQrwinYUx+HacUGXLp405ktVwFgKxcp6kiSg5bg0VBCEFaFGbPINzuY2ZuCKtSpKto3usB87bpKBFQk/e9k63XmF9ryrq6fwxtPfQ9XMKYX2bxpD51h59HWl8Waf+xK+s9sSTp5iGy1pd6R49hskvHB85E3RS8sajl60VG435vuz30vE19Wc5t1m0eJ5r/dWs+xtpaer1H6ZW14Krdpbq0tHavzlnYWLN+0uutp161cp17zP/3VgjptZ9iqWqxZDDOP/zIkUGBGCLTJSQCLdmrc56IWPBgEFwVcI+l/zNsEBF6mjr2aFQA2nOR4l8unohCgEVvzadnGZsmKhKaKtDlJ91XoQwgaE3NqPyuDZyNhiEmnU4/c7L5mtTzjcG8vYcMKgiJscRd0tWUkQtRZEUjEooHpjSkTpASMEgwhJhQ/n2YPzkbJoJibItGHYeQPoMaKcGsnep7Ukz0jfhEmcINNPsaaTg4bAQ/oCkkUaYpyCRkJ3hbvZNzzrtNYjLdhgA3/4y3bUDSEYa2vTZH9ecd407GdMlhKs1OKnLuP8lC3qdRatKg2u8PEOszVyJB5j4K113mNsaMGrAU7P0Fxwz0fY+/hgpgnAvOBJc2JBs3TNDCOBC1cqj8qAR7C7LAFvN0jgMIJu7EKfBt0N5zXLQ6CtRlVHBACESwCox08gzpq1evQclNnKmTKmoJVgodLssxzy69Oq7E/WK77ypfWk1j16qEeNuwp1qpG1Bn1p57HYnIetNLV9tP3Jr66H1KaTZmry88fhYmrNLU/oZmlNy8PZjP07GprFPMdNJfY6OzM3dh6bQZfNgW3t87SFnmGmYH9+zm49audtIHMR78U12C8z7ebXptbKV3W7R1ab3Lv0mfhg/8u4v8KTCBRu7zmqWJhGnbgDsmgEAkasXsRQlGeTgOWnJuSqGlDQtzqqy6E0mLogpBg+wzuWQLdFiiUqMMzS6jrhpfNApaabFQd54npsIKMFDXX3M2at6ktUsuilNVo2lCN1qBHZuPG10Y2ZLHYtV/q+TiyiRt/YmA+2x0CCTqtCqeE2rYTzVdOSaIypFQrJE2wpGaMnRplkqRuaZYfNZW12ElJwbzssMUiaiTJ5JhY2W1F4tryieisjRMRkpOMo+U27fFdpelcyeRTj99XGCKKGXlqzFn5YnnQJKwnXSnFOEVsfPaWhKMfCcc8JSj/iUVcQkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHSpA+g3tLcO1SB8BzaW4dhkD6DW2Nw7vIH0G9PbgcIxJBFglbqwTKDB6IDJDYxCFmphzH4BMDKx4BllP3EsBAz9JKNhHASdqUpio9Re+zF4fiJhY+tnUab63FUNZPqap1DWb1Ke2RFTSR4Dj9W5hVrTtmxR5c4sjkxdhdSdq62gxiVDWJLrsGRQgWe/CJiT1i80SBDTEECKokqC9hUVUnvhF7WSRnnLvgsfy0CxH2W4TkppLKGM7i93Szz68mIsMXBWM5+f1/Y3IU1O5Wy6MrjkV4PWj49hPIxWipl14s1CCTPvfJKaS02vGV78xRdfHzV7GZ2/VUntz6N0kckaVJNnoMCx0UBgLiEoHjGlhHbJQYS34wqGGDgUDGWwumyrYZNNwkVGBwRQtJWUapeBgFArU4zQS0zEQnJfN9eaNAYaXYoREU1KF1SAFf3HGlUBSydGhboFwt+F7ymWzlJR52cZicxvZsqb0+BWavFhDIBJ4rSphmLE2xWUUe3BpGmaNSkpqA4jMYmI2o980tuGRtdVSpWpBuOwWj6kXRoLgajiCM9jDZoCjbJdyUF3wrsvfsWL20klvW9tqcU9TgnJuSJK6qVItVShKFx1bWpxhUoylisszqZLUr26pptfb6JeVb05xzUuxGqnP2lSmbKCjD7YpZgnTiGs4GAvzKGUGVFE7yDRETOkiaDGzGGSYM2KU215DAGbXlgoNggLAd3sqMIM5fxojQ3Bg8xYSWnOspjVV9guBWqtzKUK/j2MEg4QaITAUlxpJ6gu0PZqYlt2ufvVchiHB99joK0o9/Vjgr8M0V9BDZWuWR26NIuqxRu0Fk69NRi9HPdYcou73Mh3zijjfI7QTSkFIaWtH1VV1a+zFGZlfT3qtOTG61S7G7HbG9yaTerTto72r1c+/M9kDm5rUVo45/KN02lZ3t+jrk3a+84/e3/Wk0nLPO5ZvIaY1TaxTWLLT+sw3tjh7pgcLRgCgsiT1kqbpUl9DPcw5YEYmFx8z0qWsn6YHMhAKxqS0FtTx8540Jp1+Z7bEZonflkM1sI2AA7RHtpE1bDtLCSK3uo+jnPrfiYGDOkza3XznLlXV2aguzVt5xWWWFF9MTR6PX9G2NfTg9++xvqYvSNt9NH1418WvPAg4eR5L3iRYVIun+MWhzwrq3N9tedetMvMbxaHrVfBnriLZ1tqzuu66tHnngRZ6Qre2ca1LfU2PPb0rW285zrxMR6vPvUWLe9sQ8Vl1T0p8bzBtqmdYtTf+MSbh5taDj+l4OKW19X9PXVM0exsb3XD1T1fPIz4pQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0OQPoNbY3DncgfAb2luHQZA+g3tLcOeSB8BzSW4dcIARpZjW09TC/wjC2w4UOgRZpAQgcMuYTDU7GGtHRJA0fNdAQVfmHdC51UomiN/AFQIN12vpUczFkJVBa9bGnWQ20BXo4MgrMkssK9ezWl9D3sltU8WhXykU1DtczkcF4Vj9UyHk5BNLy3ZculLjnXvluo+55ywykd68GW6sVep0C+1s7X7sVr9cedZZbpLay1ljfZFCos5FZS6eQqGW436uPXv7z9cgpvTLdbPW6/61fJy+37t/WLvVfv9a7mxTXv/P1hr2L5Da1b/acbeRVgp/7MT1ZitL16Uf3LMP3WWrGYGbUbWDUtIIAGZwMpgkSaPMguFa2KDJtg8qxq5owCRK7DYGsQyys4wZIhN+F35zEHGAkkHTMr7lSEoch2eWIM3svStLCnrVlZFfTcjsjQ60Z7t2YPn8f5VqOBV5LmmRUSFObYUdRBbiFqolFMWXRuxVyykddW5Od0vFaNMRERLOcmp3qKBApc7XWLpqqoYNo36xkuVlGKUttaeyadS04yIm6mrbasl5bkLthP7FDmQpZemHYjjcmGINvRUpU+nbpQuM25PVaZizSV7ux+5HLdKrnGfSVjkXVK67CSUdnL3OGVDfOGqKAchQFlRoGTAgEykFeVXK+GHhaRCCteQVEDURFvm1DB4rAGFRepTMoOfYBowi4cG748wBNZTKmZNChq+Bilmby2HMljckbJrDdtZHY1LI2WWWQxa3nDUxT0V6rLHSqc7Vt1cQYiu+KiCbJsuvVnKSjJqFosyms1TTCzGYqVQ9ks21d4+MJsEkllGT1tr3FRCZbgfjbLWW5VHKcHtzX86s7NYieiYSYh1otrsKJLqpkPhvWUSWepalwpy8dP1tTx0+kpacZyYgvU9nrUPWTtys53B0K8JVNO5eEdqUWYbkNWgs6mNvJTglWwTRN4yqKhSPAUxaA1BWCJKDoNIaeYgCKXw4FjEgjjCiRgdKKqSqvE27omHn/JwStwLNC9wwroZqAZmHo6ARKimVtQqjgKH4zT5WmfVqaffYMDp+RevVnsKfGntyuW48sLOK1ZEKKLvELZtlhh9KSJEolrR03JazTDc11CFqHRSQ+ZRNdNRyKTUxJkctYlZv5JGbjNeyZFTNSzENJsol0cbaVR3CHhKoXEp0pRhDMQznblI75WjxZeakL8YXs4MtQlSWunOKWo5a1PIb2pRhk5Q+XTSfjqBRbMev8hWz272EKruhftPP4pWpJA+FwKkQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAd8kD4DW0tw0TIH0G9mbh1CPPgNcS3LSsefQb0ZuQIpNMcglEecbYyy8fTqgJSZyRjjsxHIb0t13flwyCm1d4GD3YIh+mhxtTHDKFYMae50YIMPGIFag+D+7sMXgTnbkXh2YopaJDpIFN92N08pvS3kIjzg1cpah0yNC5UCouULMYiVzGWiBLYxYELOwnF6OCA8ri6CMDRdY8uUMTWZPMI1YlrmvDZLIXufdmHnEIyhPTYYV8bc2hE9m44oq3Cc3l8VtRWiZWpTtxDNSSFuKeWvTNNYh2a0YyPKTWYnBFN00MZwtnsXPfOMcRPZSxRpWoyjVOi19jWyTg1kE+yz7pnJJRU2WsT80DBbNWjJMGEpjAQxRQyAUdzMMk3kBUwTeNZAWnr9MlKx4xeeW4Qao6YtHu/EIbvYzoWINVJTjVmgwQaVF3pfSqp2rPfyqYWr2EukqNy+pypKuTWOH17zFqtW+V058kjSaBn6Qt2tdqf4FFVpaLpymXhE9ropgioA3Pl3Iaamn4S25ZrrpDnrUxcwYYJZWKUVO46zoxAq/daEak8Q5malGlzkwnetHYvW7NuZtxj7HNk5Gr9Xr3jvmPsvr22NeT49z9Z/tvXMk/M5Cm83n+eW2MqDzEMSrCCBccWNstZG3V4jEahMk0EKCTuBG9a8Y4ERC21gbFuoqCDAkKRWdEHAylqQOYjDr22nAc/4mFhHXc1xmb6glauXaSdbjD9NOxoWC4qBHk5fiXK+VJErDnfdtoInEiBcKxyCFnWyZKbKgixyjgk9p4gWXWyY3AqwtOJLWsq4dQoVJmk+U20butAgjmupE0YKLUcfSjdMpTkn8ixBl6SqFBIwpFs8ktay9WmlbTd1FnVp/p4tHHpopwaZl5OtdaMM9Kx1uVbK7ml4lYQivK6uHvw2MnLQnnYj6ctfji8thFpTHfM8kc1GlBWrN00QhC0a1DYKT3XGZwoCZEniSBZgoFBbhmLKKFcC00hbqzAyX5+sIC3QSIwpWQU2MapbZEaeKLUihGLYFcZVccX3gWKX7gsBUacyxKr9nK9X5Lm0r4YrrNKSAw4g8H5WG0rXIHRXkmhZdrtK1V4mkyJbagWon8KNbSj6ORWUUKlmNc4suHosmvUkfYnJpendKUyEbRc4h16VhsKUnDtU5PKPT870/iffWgl7+xLxMtOl6+QU/3bZedu5VM/n5MvGvz8T+40TDoW5v8NU9qrw5gu8tBHjQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHe5A+A3tLcO/SB7BzSW4dUkD4DW0tw6HIHsHNJbgQiY8QAYSsR9ZBDNLBN8QChnw2/kAAUyZYyqMyqGhwBODyRIhZUWfiTsy0MVHzh1h0KlU0Ih6AoOdFV1OyhVavLbNprFqIzsEgAAY0xSdrRiWVNUc7DUU+h2j0wSubBzcLptSmS5pkBGprRqRJAtlKrMIjcWU25RjYjZXSCs2HH7tmcy0ptrEE4ET6c3c1I6H0JRuBmXmygnPXtkRicHvUpclWyBw+jmvsoMk7BqLC1zg+lZp57itKpvhC15WXQszanO7qdbKetMulc3+l5ekbWVk2UGyaUTSiw2/G5Rv525SnUZ+MMwg2BOVgdMl7XeIQqPAxQONoJRkBGDKQZFBzDUURp4LVUyMIFoSEzoV7rC2ZndxoDYGjt+V2DOEH7noBqU0FgJTchTYmU1YbCoB1LFq01l/X0xgwOHtaSgkmpfP3ZdSYSla9zVtBR0Oh9AtOZOVium5KLDa8UUfFEicjEZUxKm5MNRcUh5qN8oRba6mxbi5bS27hQ2VkaltyVYNGurDYOcm2iafsZu3dUjvgn5WxA+XewvqKSObXTUaRIV2GrQRalFAbjkkM6fLMeRMyWkhXnK12N8EML3W9WTimlcZMsWxCN9ObGzstGPSgnc6uPxSCsZMQhJFlmV10CgXWGBAPWngpVABk5Ad4YsKiDxhVnNdMOZHgKs9y9AqvjsCwrF3lQ6Ttu2ZSBQJHXAfOmfkwcRa5LIDciy76iurFPKlsRWrMwQMAMSaDLrXLkYtUGrz70/KpubC2mSZNNdzCupq5JOSFl7Cjem0JOfVajdIDOe0Kj8RLlUKU0LGSUdiZD7j9XLNk2zGL3qkaCCljM5KwjSzyy8Ui0Ef2kaqKqnqVIoT+0WaglkpU09jEVLZFjKVhHqve0ytCHlSyOoXHJyYu5xkotG4RqDsw0v9mx2LgcqrnVT2UkWQ915KLR30qwyosYLFAPKgkLNUQtT5awi4YvgRnIDDQHFQkYCCrWoiYhEA0EGR84wmeK9RQXgSdnM7YCf4XYbty+UGBGTDfxBM+0+gqRxsclj76iFqA0/n3W7jajF7C9O26i+rO8JMsPQt2iH6dF9WwvGEI6qpSOkOM40jmfmxmmC9vXg0osk3exanzDUeQXOoGH8wwtHWpcsPSnW5BNNTGZH2IVZB0UGabVTlqZk/BaadocIcgSTkx72Cqlo5dGw3p6LWbkFlFYW3JA+Oeow1KLWxuoXjKCLK6++dxhcKZYWbUyGSRvlC8mr8Tg27ULeKG0UUKCAgbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0CQPoM7e3Dokgewb0luHT5A+A1tjcOfyB7BzSW4EjDiFVMz9lbczHpK+oFKiJ0sReuBGVxrIkuo4wg4dqIhCTo89jsiMWGZHSPpJ5TgJDEWxlKUODqLAcm6fT7Oo+9iqXSn2zclFSlu2a2ccj13dyjNCbIvbdbu5x/PEn3SNTVbz2zXcD7vdtfQ8xM2i1n+33XEB7nE+Lbo8pSfGoLvFJKQ8xoNL33AiQI0S8aPaaBXULGv3OWXxosbN4Lh/A9YOdbga9NZpfG4uc61rNt189dW+Pb276Fb69ra+s+TEL01j094v3nNIGMf5xPW+cUrumbVtm26ah3+NQd0h23p0yQEm3NQ7QgVDmEuU30OL8M9MRdYTzDgM2kISuXyVUtTVulqWN1WGOjQHikyy+xKbhWUnpuzYfh4xQi3WXO2qLJ20NGL2JfOqJyqAq9IHBYNXDhM5yS9L5ZSaRpsV6Vu2kqXSxAiYeXKaupSUSQmaTfEvARsou+U7QKOiquvPZSE6SjbGGYtTlcpJ3GkxQsgQLb0mo8TmSaNxxHsIwt6y6fqE5Rm12JxpaULSQP7Vk4r29r+boKzlWQb20LGyhGaJY4w/4jdWv6bePlamx2fmjdKtl5V5y55vYyu8W8k/UZt5aXl67OLpTIgKqy9DAGTACDOhkImmNTesh7hg2QlwTzCmKxowCRLp8aK3BQhATTuFIuWBwFnRPKYiYVNNKl0rpAcTQdDrCHZlT5rH5nXp3/c2U1JaRBtK0Gmq2aXVe9nadXPGprT+cvWsuw4gWYbRQ+3FH0n1EjL7U9HZa21sd+c6rWu6dHme6dPLtaT/d5tfMnNaHNav/W7jHLHmkT35eY8af5iNdta4yvtNLW5in0WR6w0w/iajOusf+47mb+RXtWlu9a30T96ZeFDt803ca/24uvfoGY5fjvuUb9llitnYbMvdy3Gq5bNnr16CWmlUJyhqWk2kAYl0A4bwMXaVMIgGYJiJk4Et6OCEChiipgcFEs5BM0+0/zMdWRzzqWNZmHAQmVP/LpfiFhUTeV9V0SRrgjBVI3n1eLzv9VlQ0LUXUJlFDT09ixzsyuL6GwZVhFuIfXMjJBNIosqvaqiV5VxlnRQXiRFHqUkoavITPkeQJlFMlkWDJGrry7cGFoumvSFbWOgQxjSTXRrTW8yfG8anJmUMZSi3NFJRqajZiTCtNTq8xl8tqdRdtznsZ9XYzgs91qzaY8t+N2td70/SG/WXLL6KlYZODcbqWzjCU9VhWalakotV1QmQnoB8yyFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAZ9kD6DW0Nw7tH3oHNJbhz6QPYNbS3Drkgegb0luAuSQGtxaTXgcwEEOjw8QGjYGXUjhgQyiFPTTtVDkYlkLDYow3qztAwtt7diLxC+YIFu3FaZPO5FVqz3KayovSxvOkT7Z/AtJS1JivMY5Zt/dpcCVJtLAceOJqBopMsnA+eg+SGmyoOeRwuKuyTMHD6pJFXZRdqUkXSbaGcQ7EAxTT67tmSJa+nVJQcNpxiHlShSI+9ESVKxpanLs0yz3Rjjiuapqdi98YesK/IxVVdpFZ7P6KpUupmVLbWGSGRhiVM5jVO/BPNjUdjxrmvZJtDAKFAE7KDrMRkCmKoiZpBKvEeQxepcuUYFC0SltqZokAxivgcGpmV3rcbMAXhfH6no3NAIeuyWxxHGMLXKgFzbXcHAhUonaFNAqi29ps8KXCns/DDkTtiauaIyjsoiWI9g5AjaROqRIUTnApNlt8O9Goep9oFHMxTUXxNtyOaJCufgyaebnIhbRmamtuk8qWVIUOVpm0TCe3abS3LwJ6TkpKTlZxRyx5v0hTgndo5IsbbOSQjEEXRQTZwutF6D+EZIkLbMdita3knNadyuCRjsXVS2D5KY2rGJSCUW6607aRZew2lJSbVhsMFM0m2zRs0RmQCfK83PV2YwYPknCBI4/5dVzIQuvXSm9OxZpSOpx9yGDLjA4HlVlxSRAl0ShqXSp+ACRPSx1wVrex8RgU3rtdcsiiNq2uxfOG47jnVi+edVuUpsUvmjkdYC81YQjHEaq9QLvSqxyz6uSOk7lcbINXJq9k0tTEK72l9ktJNpJhtmRVmy8SyXyBPesOn1FGH+DK+oFknwk221CMjCLKk5DOFWuoigbjEifJZ0uhjtzjUZ6pKe7Nd33WpPuOR3UUIMVk16NP6kmFql7+Zi+Wp5rz2thkmOor6ZSpJTK1Jl6yUpmFVvS5nZsHN6HoQAthGgoHRBGzuwWBwAGMTfcgCY+3avFo8zE3cUoOxd8JFWfUAnJ+5IJO8klFhrIqas/fHFWBe/GUafZ3pZRPAhJJAMruzOVztSniuS/aKraZhNgkFBXEbCRBlQUWTkYJzi5lWcGIIZL6iobFiAtF7TVQaSxZCpPUlGffgKkcBdaFoNZHWUYsrkJKTo7HURGrzE1FoiRa4FptWWUzCskp1k5TkjVhAo3O0pzP9A1cpQbiwzmJl2mck0pK/6T1KpxqlFFbQTVtiMo+UYXTsg+aXnGHpTJylUa2oyhUW5IpT1BKcp3TKYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdfkD2DW0tw65IHoG9Jbh0+QPYN7S3Dpcgegb0luAcQJkKndG9a+hBwCESYJKfNaqcu2CgpQHXjEsaJ3jrgIeNoFLgQdLnGMLMYrhBVM8MpKhC9LFGlqwWF+l94/Nyz24MepYtYWXVscr1KGVTUxhJXdnMaExI4tOx0mIZrPC+pkh0hZQTZblKZdo2WiuySIWbdaUKbmrMhcfm/dLm18RQnNBzJc2KyYiIpllDiOckme2nAst8tHMeRyMWslq5XcjiSPWV1tSjDa+tSnCccyCbs5dHfbyoaq5QgUSuRuoZKa9JV5SyD+va+rSvTmRS/R3NIjica+PyUIKyhNzCdwkqplK7cIRt9wpAkYMDCxKmsGAhfQCgxhH8a6DXlagjDW/BAUDnkemPaqOMJiUN+s/k0Wf4YLyCpBfyqIAEQrM/NRt8nCQ4Q1aptvhep5NNjwpR1zvnJfYmrdBLLUZoJfmqam34kEmmDMHrRQn1ce2wmiYWLPD8mNJ2S8kRxlGQI6axjDiVswhpVi0JlPkTnK0mqry7TUSTVGmd0raiKUZLtE8mZQ1tU0ejPKjZ22vRlJ6TVTfNOCfUhiixEnNK15rNEklWPbkGMTXm0+EVYNMVPDULthBBJS4VHxksrDJsaqiRSW87bhBjISrU2XPa9VPLSYYvZKaEEIQhJMvmzB9AK2CxIsKhicQAJmuUMG0BL4n6Z20tDlZISKH6JAOVYw6ZIMQqZbhTQJWBAlTJ4yxPHrXlNJFVvRIgBK1JA+C2G56xvWcvs50ObQpugo4NRXLLhKpMXE+TmpxZQn56x0BkggjubcXpIGbQK1aFgwVJQWmojXd6mYNMU9qTDCTah5HtRjUb3YmkLkL3EU3qRVR9TVWrMwauEHxfOpFSYgSlFylpob1meP9rR+VNKE7jp2FNyjlQu0queynGFRjqTeZlsPlrMOsrS96zV38tKO1SWs4q9FDZ1toJvHWqQCUicAcxANByctBLF1xQCMb9jQgRuJANmAEkvpTCwNRh0pitbjBr4D7TLds6ruhYVzbrQveQiIqyT71zW2UoPPbP18lyQ4+96MiQRP1i0diFaA6OYyn49AVJXvqsQOks0KyxKaMMMuclLVyWVTRUsv4k0mj6TLkFzmrkC5pXYUUmymxFUlkR/U1ULRqMqagTsOy6TYKuIVF6WXYipuIFGy3Vy9jikSWcZ35vqmNWSVlfzZQRIajJLWKgzisXlNbWQ1O3Jv8JWxsm81L3tWlCmF5ZUe3vRJzWlNiUvfxHakZ30mpxq01mAvqPsql2xQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGqJA+AztDcN8SB7BrTG4a0kD4DW0Nw61IHoG8sbgtqCrV7KVvZGTBIJ0V/DrxnQt2nSYtGB94pI66L5mGCmPMI3bqU4OP5DYgyebJ0teyhVjxRu6/rLqla1Qu83kqxlDDWNz2eVPjym3qzCOZeNpSHGhQ0euQcZI6BhFjiagdZjkLfLnGmPbDSWKiySJdCiDvUVFCyuE4mTiS1HvIk5QaLGhzZU2wuSw7GMxLlVdO0i8yclj6KlDzjqqiHmJdTZ5lMdJA0S8M0XC1MKQSzOvokPTWu6MszcLxUoLb24qiJdD5IUi4pnhQ/phoyZsNMHYfyDUxwMxhFRxJh62mGtLD/Bg7shKxpkNgRKiXGe2cnhCkVxbr+2qCjBwfecZkfJgYGMKc6Q2co8SC6eaq6Z9CKGdlSN7RVa5TqvhL86KYo2mc1lex9E6uKkVrHcOssXuteZhax2jrxfvWKzFOgROOT19X2XuF+nUgjlqXsrHvXvMDeLL63fuWdtugtdn4Z67TbTcG16+LMml8t9m24c/XtzNuzfcrauLXotpH1ZW/S1muusvlX6fe1f17LdBlp75pjFPpHXpt+U1t/XKY3WPmGNnppM07XNcrM/qY0+x2nCxCMqKAIiIuK/zqgF2PQWVIpCfdS6IlRPG4ZvyF0UljIrgvlFUNcaeuEHMiqNY5L5tC1pTUfavTw0uXCVZeo3jHss3GvQu39zL525lVwprHkPLZojmRVNcMOcOurjxyDnGmiaHF2JRWRzh8jiFDsdBkC1qOPhXWxeOzJOPuiBw8YcWNPJPO4QeylYqQxZY4Wc1LzRhUyi5483OHOY9o3RQxTPWleovukSzmqmVCYQffUTN6+OxyIxtW4+bGVSj6FFh5jse5DaLNsOLG0NKENC6NDoORSxUHAOMpCjDxBmjPJArOYnegalViIRQKicSiRhicptDN27KXwMz6Gr2qbKGBYiLVrdHb6MmtkZt2zEYuXge65I7NR5XrqQGXOgpPK7dorVWOUuUTV/P16dfZdHHpBcbfPmvfZxTNncodQvm0FG2MrGt71VmNdut100dNbIao8mYprTV79sqfKIrYfUq42rsg0ho8/Q4q/dqBxc6y3fIKu8wy2/dbL1aywznwOV/kaFDzT3Z9Yff1i1I7ZWdq1Sa4y/NHnZu7TK1l7m7OtMY/E69NYZprKVy9Ze/+dXz152e+8Px0pB0uV+MlFB1twJj4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB42QPQNbS3DtMgeQbyluHV5A9A3tLcOpSB5BvKW4MAKM0jUveCEM5GOquWKFRaCXDKXGMcEIiTGKeHpUjycfLjxbAwsJVpI3cyEag6y3TT61jAQJJxqMrdKPrtWVP0Mkxay97xYytbjdG2qfhav27N6pnP0FxvkWNNsdhcywJEZm5GIxFKkjGKIGpNuis9SZlGw23jFeLAOocmuu7WlLUamlEiRwGrIEEJI7PRwgxG3hBBEIxphgwajKCppVYtp3KKtoFWVYMyukrWVjBWyskcYoIllIq3BiKc4PnVWVjJS2eqovGfQR+rKHNmwmuk03OMYR233BvUC0Lcdf+snGXtiooD9tbNdM0y5KMSZQEnDIMYcUg0M4rYi+YR3gZDZwm+HeSl7QDMSAiPJFYnnpayd4r2P86sjrR1TairQqnmIdBAEXaHyJ8awCRGOT01aZ+3sByudEkUtFX4ZwPfqTNjOPM6ztSocMoTbS0yJSM20bKHYR+sQLwKXIvaKaqKS8pwlBdqEiU7uLsHnWbImXrqyauumnNJ6A2XXUJSqkmEU1TigrUTG2VoJ6gSi+BtpRRAh1hWiNZ6NDevil/ONSvOOaxf1VJAuldu16eWoXapKzcNVirjFMy250rN8Fq9KYukstCST3NbkdW1zFItXjHW5NtKxUUWahk5whrMAUFg04QALtepaZhB6DmdrhdwHoKXLZBCeL8XnEM4dW8dECjxe8pEIY33aMOL6G+4VVuEbCweqlLc4RFHKWXnKq0pXw570QLk/cN28q0orymryioJbTYWJFKTNQepOzpaNrUoowjeTNKqvfKaB710a6JFdPguq03RGybWgHmiajcyVEsmiyZLHHE7lWnskBPSctttnsxtY4hahJpiSJO22pvTadHV1Nlqz1tMUtKVL3Bp0otr3TlFE6e50mZwulVJ1Ss3u+zyXpRaOo/D5VqV8uUYQNtMzjUESSUJvLvyrg5efVUQ2vLVlVY/URIFmEnCAp0EAiSZlB6HeZMAAwdMeII6m2FZFacsszjcY2cUKV1zKWXaMRA36WMT0VjSEUMsXnpHSP+SmyGk1EU7brl1ZgaTUql9LfqyyXWKCo/S1bGNfHwI1GjzCK30XLKECTbAnxkTmDeoYLmvBJ5ooh5t6FQwRTVTWjZxebVrx7axTwbEqCHypbHqsM7jcWUy9kMpKto7VxB4KNdXVUjCcUQmPTn4MTio2sZmbk1CtahLIwvqQnFmE7isdnXYSm1HL1+JNTucJtOhBfXr3XQMalcESSc8Zs1Wd13UckootLEp1q9dnF6issAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeXj7yDW2Nw6JIHkG9JbhxSQPQN7S3DssgeQbyluBJoKFV0rVZ+q4xygfJIDgrAM3HVMsKZtKPIVEobkMfTkORtgcGQsHBcvnGGglAuWWYSx2uEgom1K9PZZlqaGpVatqNTMofKIwJAk/ANSpSXo3Kr3KaU03njbR648LHnL/CVLrVq86v/bstNF5syskZdPrk6uvUQuRr1VnTiYFV7wqfVLWFD1EyZZdZiWrbj/NX1bSFS/A4sy6g6YcrC85Z6sbz1NdRvXcvKpx0/guucZjZicdhyZp77399EL19X9ci6ehq9mbZ93moG6P23av5bUaZ6V7Fr89ZfR/rY5eGcrFh+oWvZyF/QUbot3aMwuWrkvgo4MRDwCBMleRlRiFADrpxUeDcBFPls5oQ8RJza0d5jL/AWAwSpEZRTyALhMrT1xaJSsKCWer3l8qguKtchVifmlFX7iMDVUHFUJ6XX4dpLMpmY3KW+qU1A2+l2yFZpZPfIsXScYg2qhMTgwjbfiqEsUcvo8SsxTQYTImqKrmhy1JagVtm9XXaaR57WY0+uo60HRNxTm3PYIM8E4Vuec3rxYiT2zBPYS7U7qc3bBODeTYRaal/51JGqlOHRpSjD3jBiCko3KeTk1Hy3djDFrSi+mF7mrBar2K2asv+9HKF7C6i/cjGM6vqiMiM0GmGNcgZ2gozF6p1PsDkybLomAHKEczDsueJNsxzTYTZL2cuwMBTGrWfSy2O8FQVuk9D0XmM1fy21Ztwe0C1CaliOW79qzO5XsbNyP441Fp+Qr0TW1b2GSQ228vMilhMk2owlyJaCgzNgkhrk4yXf4G4F0CSs5Iok+TZVw9K5x1e3MtkrD6bcwvq6spNoULOTXjKNK9ggZK1abS+vK9ifUa7eazGSUWY6zdQ2TDsjkYTnPsyjDZ2s5levuyzEN9afUav5s5y2k7ZTfKa3zVH1VVN882UFIZNueSkxgbRrMAkoMcLoea+g2h4CcIKACm46IGWir3o6GL0QOIHnll165GZvLdYega1ZpkJs7aiz93rJCc2GgkLNM25IzSyFZW55T87B8wskkCbykl0lnMKf6kqfirP1yxN2JxFKZIzMPISEhtI7PT5KcDS523MNHbiwgRdpjHo5HcrgvNXCZSMXTtyHGtac0Lwh00l4o11U2ky9wLlkyupJzaJmOgi8o+OM9ZNxaa85K6pJAXUYelrnxMThyK1ECPF8hTTEZwtdS5ttRyqZyEFkCzMH0rWPyK97HZXDF2lkf/lPJXFXF7nBlhmMaqtVyokklJ4jsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHPZA9A1tjcOayB5BvKW4bSkD2DWltw7zIHkG8sbgDJyo9WusKnXHALWDJjBRhOaho5LMjFNBYE5M9LYqwIzi0GgKWKK50DsmJE1yVsqsUUPIKRamswvkJVzJ7Mq9VFzI3IK0Fvv2TY8l9TCl3unr5U+8q990a5XnUEDdLw5fFyFZa23MPJaxNFhipcla5C3QvR/FHPVWZlIjyi9c9ejDH0UoRbl17dzUewnW9KPavVhzM+W3uu8xWya7GVmt22K0ghe9/9m/9kXu618Wv39xbO51oYr4z9bQsZRrb3mmNWl9m7MO7btvevezat/dyCtK2pRYzR+uUvdql1yS1sYYQpNV1ycFgkRGHnaYz+oZy4yNIGsBlYjBTUxBXyXpocGEIr3bst1aucgiOWEZxuw6mJFojYk8A0YXPg2jv767r9ubcr13gYvRS7SA5VZq0q3WztUmV/OK5ySKQOKkD3CBCyTHlKUGNSlmBqLUEkB5BCu5dGIxnLKwNmJO1SRVr4Kj7NJNRP+F6jmUQUUhNqJ/XuxeRkhuKVq1JBKM5KtRag1i2qxRwksoyixpBH7sGKR3bF3CSac4xmTsxWgehBHmwxS4orpvGu5ZucoZrOR3Y357TlKhGpTjGp7CfuK+ThcquvbOJNbrtPF11iQZKpULHnAZnBrtiwYrYQ+XUCcKnqAxZwWCPF9qNPKeGCREXnXNasUZlxshzdyimOq6fmWX61h2k0qTGrRNjqzeOMaeGfzyu2K/M63KK9U6fbZm15BJOg1TiUntcx6kttid3SKxIOMWRs7aDjOUc8xVdRflqSS7E1XzWpNwjFnKTebLnDSJ13rPSWYkzOmub0syWS9u48uvbtRctm0WNVcyNlw5z33KTa31CDjqVVT2xd0m04eWppyntdDXM54vZfvncw46Nl21dkxN9xbGXVw4oOGxxA4OgBkqOB6MHGxELBcGYWRAuZiK+HVL6iAPM2HHtT3NEgQhfWJG4xMuEcbyQGM1RfiHH0sqlcolNOYAD/SuzPYwAVAYvjnpoj9VJ+HUmIg1at9jLCm5B0df76KWawerEtxrefrE3duJqYnoVk1rGfq6LLRp3WynBU8gvZmip5fQ4mrx+zkrfdQ4pofXW9FyGztS8ubQoF7FYYXqN/C3SHXlu0YttK3XUvVul1/lyzL111aVicxSw7kO1+8wO1ym3M9VV6qFVv43XK2av+9b+t1bwVt199veZXv+is6zbZq8/d7+Z7+W7+e31mo7xcwh6maNBS+JhuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB4yQPINbS3Dm0geQb0luHW5A8g3tLcPBSB4BrSW4MQHNGBZukNFWXgnGHRUrhCqOevVuXiYWynS0vsqp05zijsmK2gF2Yh2wPLjfzrpQdLZwQAbYXVzfKIPqh3p5fZlDY4W+92os13HXzo8M5Tvt6kfmtyUWbZmuyKzlLKWZULqprKvuDB5M+HpzGzbDVWcbdIUCcjKIzKF6n6Bo6SMPSTlJ04nUZC9RFCCyyxEIWlIavcH2RxPxtsVXKW9V+oQ+5C5a0E1yybRZKTbUNliFTPlqRjJxZtp1QXk0nSjc9d4Q2CW7npmWQXOTTx60HNpp4usyxM8qqs9GxNlyirdxn9bknT5TYMnNqtSQcCFgoVMQHzGxMtIJAcubiDJND3MRARogmyURgBkmUAhp0YlS1WRmClu/uvnemBoRawnqatOiQelilqMV3rQST9zC+z6ceCXUjD6RqNalszP1qW5SwjeVac4iVlQKSqeQjkoNomK1nJlfyZ5s0tNJHKaOCM0jMItVgAyNO4pPRbb0D1UbsaqGyXNVJpBEU3D0hRRTUgzKUoyQRrEbbC0UlPNh0Vtx5djbabuTZFatZPIr7lySikaNa6dY1Eo02hOY6TG+EdQV6mjnKMZOaRVUnPxT5LCa54k7VerGCz5zr63SU7gwhqmA0dgRBZHQwweVWYhIF7iB9UHhINDTiRRifTIA8oH2sQ3ORFGQ1GiLoV0CfJRTmXgDqUjWoFfG4QgU4xWOUtK+ymFPPdtNwe6Cd5JruFCpRb7O38bEltSrW9YswsmSiREeLipHp9CiyQqtaPRl6UZUe/JRalkYEaZNFhxCwcMI0Rts2So4puNyWQo2myDUbbGrQhuFMW2UlGyjfYVmoi09iCKG1ddBboSKuUT8m/ikFU1oQK7qs1U2WevuXKb/DrT00xF8kSPGzkK0xtZbn76UQzKwjKOKK3ipGjY9KELF9fIxq1p55MI5S11yfelmaLE4ATGaQCRRayD74mWoi4N/AKQOiNYunwfNYPnGL0kNzKqxjMCt0puUPY6wapNwiFyujGgMdoZfTyuAEAz6SuzNyqDoKp76w0PtBklNTyne8K0th2gu0zLNkcka8CRHRpUgJihk0jcM3LVc2KMwyKjLDSNEmKrSs/ZBFCNnnEKiE4bXLsNJ5SI87ZA7GopNrERHtoS1NKkkpFrpApqilMFVdRMPnuIEDSZHkoUq+MTDoqa9TeiLR+sLrzbYla8GYNKRrE2ctrF2ZZGSVV57CoYQyaYqLFO+sLJLMUsgnBTKcnFGeR6nBacO3isZqxkiRTZcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdDkDyDW0tw6JGHgHMpblsGQPQNaQ3DoEgeAa0luCRGac6UBE/Za7ZhmIljQpCh86B5QVQ4gzMaoZTC6YgARDcqA0aamEpgox4djd1pEJmppDmwxqFRs+DstDh2vTRpP6ggummUiHqr/qtrLLuU5GKWrQEFprPk9nMRLOm1tioiIpURT3CXYOolCxSWTqz7UVThx6xZ013KIS0p1yFtC5UzKVViFtdNhYosmZYgkdNfNmimowgybDWsqxWjCTbdSs+yzKW63dSvEcGGMhaFM3Sj5RnKCrbONQe+OMLui+G4g1Hq850pSWJxQKOZycfvxmbavYtpKUXybnKEfU0pz9xalrMkUopBcHmFwS4YsBhCCaYwUNCI9sUFQeYtAjrDoLHIaFQSxqUxqgXmfPqnF2O18HPJAdz2o3M0hc6OVpW1efckcJwmu9l8ZgymqJsMJgWWTFy5NS6zKaBv/psjKjcpzBhCysm0lOMIuQJPuCKTelVKO+aNwYQmHodV7+fiI0zRzFSxueJLjaw91ZxhvNrqTTjU2E5K1RWKCBVhZKSjESsE10yyNJ8FKsqsuinsWLhCXXaXVWHP5syfODvtzl4zYqcqi1BaEMYZ8smaWu6nqjGVOpVkqVWijZuE1WfDEU0TdVXkxKDsnsY9+QKyBEg0zhhQ6CV0Q4YBkRVnXGCR5ibaYmbAjxmVy23DKWxwNgsGhKddPTP6CUVJk+zyPhVWI1SBI7GrESe21KsttEeyjv1l9t0zs2s7mU/nhew1lePkPVUcHImw7Dgb1Q4SUSHhZ1JR4pMmpbvDmRsqwKuI+E5hxTVQ5BzMKtKIPEUsYPLXNe3FxURDUPF5D00dJzoytUjRyozKPSLeBpCEGNSlUpVNNsXURiqRV9sVFKPtyJZduERnzNN4Yn62FFgyoG2UyCKbN19y9vHHy1Mh4xHgxqZbUR2GjxCpM4SL5pFKatyIdwkCdkRCTiAkwUTj7ViNMwVz6WUNeHzKZ0pa1KbsMkIi1ZpKOCLo6FgCH7b/UzAkhIP7K5U2OKxKKSpNdbcsv2JdL5+rTfLJBdjn2mRGaVae86lsKpAq5pARLxkquoo7V0ajBVldF0aySFdFKZNiRxpalEyQzFqM6pNaaazWRfLtTRT8j9bk0YgirNjF0lsYlyzVzjC4qLZaGk0j+syimvNhiE0cbk+NTqWIcUirRDHbkjWnJ6s0C0LpevBhOcJRnGcmOk2jxOTGXd+Uv2rcr5KRyEvvhVTStauXYdMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHbJA8A3pLcNRyB5BvKG4dEkD0DWntw6jIHkG9PbhToy8FT7oXyXwORSGSIwNMDcTFMJP8wJ3LppuRutDbYz/hSJBD7CLU7AwXhzeb1OY78QY8mRCbrFJuPtOk/ZZkvODq9+bQeUUlmX57f25XlmUvmqk+aUijZUBIhlGKtrn0BOwvBYw7vioKyWK1kMXmauKYjy5XCYfNQptVVeWMEN0iHYLxpqExTqQpKbNj4gdSiykkSogpM+ajZRhki8kJxQtunUvBy8HjLp50Sndr9KJNNQwx4RUntTZ7GRlbS2p7cnzdNfdizBqS8oqs3kpSV+rqxtlVh1ZizXxlZq5XdNt1IiUFKTZdgqQAsAkAoAlCMm6oDfaUFTQeJHHJAABKL0kAEZjqAJAfuQ35JTHr0lxjDtHDlolDgvKzI848W4h97rqrOMxWNY/Gy0WD/opl2nxu1cJ3OdpcqbKM429jmHjmcRRkEC7SSSjNJhBysRAtmNFD3UVSiak5nHjVMEYg+pUmRYabJz3NMIwilmikSpbIZkmtNXMJU2hkOtNohTNRjrNK6jlgVi7O0oeldy6QaZjTCamFiJQWMscSPNhZefZ6HMtS58cl6MbmTKJkRFOZL/RuNZpmOHp1ooUWwueWODSdQkwXAoU3WIGHeC1yQCMedsw27pGUYERZ0a2csjZxqKJc4yGUVnlAi6elLkPbM5s9UWlcGTtiGIdp6uWbcc8JfMIks8isu5uxSRmVYYVNZX9fEWBtOsWK4nhUs/vukuX8fbyV7LebN5MTQXmvHx3KNWJHzHgOo7zFsOerTxWV5Lj6+qRNRXWX2ruEO2J9s/zDpuJSBf314FcQcbiW1WNbF6ae7gSeBaPa98eLWlq/V4dLRr+Nu02NS53GrXe60v8yVze82KS33u/+Ymfr1r61g494+Za/OYn9bWrSvgQK0nxLGngMruYbCCIiEIJaKy2WCEHKDxrwjAAUrrWEQCafVgZhXtDsjeqDTFYWX4P1qvQpoY6sxfUsQXbjRwVEb71QTFbNfcOyLUtwUjAdqremt01rKXfnhfpHKBms8K/hbvLH9aVfN130KXdYD6B9fcDO4H8G2rw5W15BfUiPYWLWvWtIMaLqNiHietPZvo5u8PLQdtjlNp/uNiBrd6RNU8j/WJM1j0he9ZYls7hWiTWx49/qkkCsW8DMHHrmLaBvUDGcRp8V1LettatqW1803XMetvvWP6Yxfce+r/wdSbm1XO7bprNM2mpW1MyMrx7FYyZqYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB5GQPANbY3Dxkgdwb2xuHRZA8A3tLcOoSB3BzSW4AgcSTocBUE2RoJmUo2Zd0KIz4JlYWeGfuCSS32HZ1PYxmsUsro/S+VNsYaawL8QeyctJSI6SKGGP5x9Rq9S1NQxPSSmrEQG2RilLuWSzGTzMRuU+s7x2ko5RwhJnJ9h/43J+7yaFzYmXn1jURw4U3XIXVrD6xxbq84LxglW2btX3oyuufd99CpPxYuecq0XHGOSsU1pYmdi5+BlZa30/P5mnPnTCO7OTW9rX6tVuPWnLsMQ2petMcYjedfs3mzP/SP6bZrsq5//+2g3YbN1gO85qXT8+bWob03Xtu9s/tWcgrdxy3uI1LqpDWMBUgniGE5k4QXAzAAVuDLIBHU0oJXkEQKZGIQ4WrN8xwNTqse+QSRdxi0Qw6zDsivWy0dW+/UihqVDwSmXalqeeU2vOXzNirLn7sy3o8BtHg+1LaSz3uF2pU5RTRoXVqJhHcsw3XMdR1HdD9efKFmxbeuwNwprKTy1/WRNIdDx47usTTq5UtqvaomxNnYhJ+XpP6y1mjVXL35BXe9etUm/y9uaorRprL/j5n1yWsT12Ftcco9fl6d7pjSWy7V5s07jz9Ou9aN97pmD7zNesxDfIrVrWtb9q5yKqRVZxv363eYrttrsC12t+1iK6HDa1Vbq8Qh/TL8PRUIREOEAEGrTjSWoVhwMOuMKDhrxOrheJiraHCL7QLPPsz0zGdVzTpw2JtpJkAtAz+t2aDEuF507p522XW5Mz+TVZVSPVLIxldS8yajMWKTG7Ys1puaptzRE05DUBCowh+Im7igPzkWbxtRsqxuyXRIp4+zKbMCRCsyfReJhAlSCVpIixDSVIpy2ifXKQQWZSTrzSc+FIiPbUy0DMCPWg9lzXxVV8ehWalFScoQSxaK27KXxaS8qx6j5NN3GCXVnOsvJWv1Nq176915vpjynmonWjQrS2qk/waSyTmJSnWz7HR8yYkglVxOxRTMFBAtYpRAbDxQYpJtQS9CDwmCOhAxlLDEYMd2YpYaW6c22RBYtLrkhgpZlekwd+fdAAglsyGUwqfhxzJ+ret07nVeQCoZIXvp/jMWp5+tS0UDyjOhTKdWCqicnmRMfqcFR+CF5OwjaZO7CZOXO6mkvNl3t8nySTs2ko1EwiitFTszFMFkDLajIqLJlNS8JQ0wWgxDWp1UnxgwaZmws6CiZKUs1G2SacUS6jUi6CHySX86iy7ss0uq2pur35QmtBVOuX2Ttk372Kkvbe3GUJuxVyB6rU6iw9ua0cz4+S8p5Ge7blNWa8KiYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAdZkDuDejNw8rHnYG9Jbl1iQO4N6S3Dycgdgc0luIEMfD0mVU2lFzzBJEHOaewjGDlSdNZsJnBuPI65aaMvqy4+1IWLRVPOW/FwF7hOnQZpH8QgApU8zdVQSCNO5T4a5akMFdgxFVsCtMqtz8Z5WoJmrRV6ejzTyEWoSJtELciimnagPT0T0U1HgpoKHQTHHauOlQw0SUs80gQqoI5pzhHCiCdCDqCOPtIRZTAZtWbRkJnlKEjdSb5igQyQtomxAIhgUaU62u8svbRW4MTKqwOiclF3bosBVkUbOm2UeqSaGUiJvamJJmUCpDjkLeEk2MJbMIc0sghZx7lbcoeS4FkhoESKVtbFYkgBgAwUPTJMCAWmBwEhJGjuRDAkZQIyxIA6U+GuhDeBJHbUvBeQmFUTi1aeZUygW/VkcOR8LD0nYOjbBJ+fFQDmZwDVgBbz00MOIBWMS7Ct9WcoaPOmjVqch9BrTxOBJekDa420mgxNdETtqJxYgKLVbNFiNdS5GFZFcVO1MkM8gNnoJ4VUINaiZTmiJUah15PF1TRq8rJKCkUJp8ZNsHYGlULmMkQRTRI4fHzew9cpTGvX28ZlUXzZ8bgtcFU6nNYiYWR6ptRv1kka9zYjdrsIaroUJXIymi2XXlfy2oMsy9SO9tZCmiuZmMW4JWmLKKsTVDhAOEwols1VIZ4xYpHqZC0qlZsZgj2i4FpRFaCp+df9Kw/rQiOXV0ZRuCgjLD1RfTaWqxECYw0JqizbDtxebrVqVedWCLM8RAnuVBHudxpZdGcs78epLpRBR1tieQK0XjFQtKw2jLS5VBOCb4khHN65hR7Jx7lG06Nim00UvJEnWwimshWckmRIFX4i1EyMooNXZ5yGCCVmrxIR00zJUmQymlCcVUOy9I4Jfp4oogiWzG5n4XNleUVtKaxEi7cezFVaFS9WxOEU7nGlJUms10LUX3ut5cLpp2K3FhqM6XuLTVZOewYlS8+6dxTwCD4FDhfCYo6BlpFUEDQbd4RgYySC2ZFUMmBLKKhNJyJ0kpXYeWgPAJ5qUfq2i1NzKHoGtvsQCmuuZOMtlTcCEDZtarpkPc/uUjIhz/V833lVW1njuxJq8zaUm0vIkEUEmZMNMtYSsoKMNIZHcPT3JzKIWESbiUXOr43NRCCjm97izJGwgpC8zA0pC2tZNOS2Tkz6goiqzNAupBFsWMs2XtGwiw2sUldnhMJKmgqSaKQfkdvWzGzYtVtDKL2e9psohhCMFNxfV05xi3VwTglsWJNKWvKW5GTaqO+iamlCF+0E56pUVmpK46UfXz75MNxRKK4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdrkDuDe0tw7lIHYG9pbh1WQPANbe3Do0gdgc2xuDAUIzcJBIOj87KxjBIoIVlhTAg05oKUtoAx7JkVy3klUwnuaVOhgHSM7vzT0mSjEIoWkNWkWaGtxv3qVjjjqSC3ZytMxd+GK1dKBJ9UONqZr3L/0s/SUmXpQmmtExBJFFMahyyBhsgNGysyNY9eSNRklOiRtNCosrFAVmUL3NZSPmpMtAqwvMxJ5DBlFJAhtGkZIsNHn5clG1mIsIWoyVns6QyZuXkqudgb/SZyS0Z95laPi2za6koOjFlaNo1NXdcKnHECHt1OXrcxFdVlzhmr3HOj+vhHK5utjN+Tv+K6SUucR07UMrCBCDzhWuAUwzkPTXUm2dzRCHRpwR0TMZGGcl2jmn4I3k4Z+s2JEMzCRWvJmzWJbOgIOvVqSjj8oBIDDryR5y488KkIGl0/Gk2pI9OEOl8LvMZVZpZzGT17lLWtXoB6pNnx64MI4vgdOMtxi8jBJ+FFbVaXPeAhOIVOkaFBhQ+wkcZgu1aOnWUlntQkLJkzKy7jqRGjIImUm9goXQz1N16p0A2rrKakT94zhxJubWo3L9FHXTXgktGClbUImcQ6o83UZTnsnzaqJ1Pf5qWrBdryxzMl5xUvtTjGD7ZSZkrJA92TjNBc8uEW2p9PWf0EGmtQWuCaElIBRp061IDfgKEJxFVAahWwxP0wHlId/I3LHRTIC0wuaUu1S5P8YcSz9aDGzSWmUOm4Gp1RUE9B8t1qVRB84xO5NzT/e2/ZsV8bVernd3N1q5eUjy71qtWue0Lwqt94MS+dOMazjSFv41Hx8tj7ECzxr69Cw4tuKYvN67l36agx6282NY3LGplxgbcYurNcWe2N2hzXlzlwviNe0t4F673aDPmve3/rNh7mN62s8pnMXL+uKR7XvJaJmt649ppqUzmvt49KUjxd0rn51uurQN1pAvvxb1i23qmfrddRvbfo+tBuwKVnjMo3E4QULGDJkJgsFEYMcRyU3Q5UMhEQOMrywxoCGRwFL4LUoMAmIaonnxjTtF/Y/MW4VWvjQJE3tibQp5piAqY7L5+RObnL4glq2TG/b5T0VLjbvW6O3MP0d6ZOK09ya/+3lfEZnLUWcsWL+ZcXL+jgepW+7C42+iYZ1bZp7e1c9br2/HrNIlrC3G1jyXrqOdojdz3P+jryo4m3/D2rLZ1ru+sddjs/a7WWpCcWv2R2nXJYZ1qtWatPbazETLNb7tZOvrZrbTn7n2rWfyjU0XtvPMU7W9j5mtVu3u7W9f6BmrFI2njxyzx6sDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGjJA8g1pbcOjSB2BvTG4dkkDsDe0tw7VIHUG9JbgQGhatIoHhq+YcILbG/QyJ67jUxnlg8ifzG5Nt1NvdRFnnd7bhJgUWq0BPbnQsrksjfd+L0lluGX6bt3k5beJou7GOEr3hnczv9wzXh6KJo9S13rUeanKCjs3ZL0WMu9RVmYLlb5YkcUcfiDibGyx6aL7YcnjhKXRVNRhjOaSlZG4O0pspzmmjqRlz7OwdzbY5yp+Lc1lMuUmxUy3epuZMtZUM2uh8MPObOu+d0w69zJRbbX7Wbopbtr7Ov5mov4P7mOqp1GSbTLml5YHstMR2AeUyJnNz0rX7lojBEgHSGQwwITYEFgs23xNSA0xnJlE82M4+1EXKQT+XoSJirWhVBLAwNnAsdpIZWOxmDqCkwbK+Veftl+niimNfOI7nuZ0Urxt0ixhJTTOCHY3E7x67H9kivLMRecotdiSz1bUYs0X/lelQjutYG3/9Wlo1HjjSjuXfXd6NZEywvmOCqxp1UVJTWgtb6VdZ6e6TyhhPtObdlyeQ47dM32zG3rFeln6U2Oj3Lnr7ZbTt67vfrd9hZv9MrseQ2jaevVre7sco5jmXem7Oytc5ZOxTbKu3tMPN7HxdaNkpVHYECQMXm57tOSu0w+JB0qzUcMzIUBhKRhlr4GFCq7wQTALnHBCRMRtmanS07tCI9dnjdGgTVAgY8M9irTWbE3KNXaGWqzRSnlkeSJIAGG43hGrNSVVKDvNyin2M5ol4Gfq8UoFot5rS6SIWZieJkRIwYbTfA3hGmrFDTi9japM3GlFMUmgQ/GmmFpHj8tvF0TTydZmK3vYHVZee4sjMhyLSy73IppJVbS9Kw5Alat+OXKKOTEbXYlayPKrsXGsbn5bOzbBdVPvg5bbQSgtmRzpYQRirEr0CPJP3XTvudKGLKOkvNBUXZ4U0qKX0sJhxBRD0eC2YLvbKnGREkDJjC1G4whCzkuE2EFT5fOHJ2+fJATEm9nqlulBQudtaf6O2jBCYeh2H1m110QzjjnQJ/w5TSOQjwSWQLqYtUnxm7S8hHLMtLTQMYNEkJwLLnCJSKiJlAowgkeZbLRLlixAaVKMqpBIsgiOHKjzaEiOyYVdNY2rSdr7hEhQt3cV7VgWh3tkmWSUhmJKFGwHkVKnkmoNyvXVyx8tNCxCWFtdckmFIIYmHTiudrFLS6a81mIpRZOe8refgpqdOq5JwVg3TLX5nt1H1bcKTvosl0WRSjKXjLNmzFOSri4IsqxPPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABpqQO4N6M3DsUfdQc0luHZpA6g1tLcOcx51BvaW5MJJgc9K0qRboo2CJMwcBgVK0jDFQNFMbbQ4dZFhMQavo79oeGQ/Amc6/JglFHRQUzT6VEqM0T1Vc4i1XmNNm+0UoZjNWtWVv5X9WWXr+WNSdtfxNjwhWEoKlApu/w2bSiMNiznZbHZG2hCYEOMebWJPM9iOZkIpwGPgoydZMOcmg9IlSIh4QlPDp3CUGlXVoPjGl1rNDoa97RF65S5qdjvkTHZ33cv8+W3czJiaTMejPmO3w0jBs4bCU+tAnwqcZ3kp3PfqRqY8JNhe1zotbF91OeowuNDJYkSteVaTvhUOkQdZoSgsCiBRUZCRjSkGKQk2aVUk88R7Xw0Mk8Iv1aRFSfvyuG4/LguQpKzsQzGG3e2D71zJVGN00DVlA4bgW/Ksr87T3qWhp8cKOnk7SsweQzRkmJKWoTFETl8TTTQI6pWzSzCcDECxKWSXVSVgkTDXPMs00fetckzBpOdG10OG5IqYUSy6VRG41TGwPbLYuXRRnSHY9qCmoL3V9XWSVlJys4xI003JpQSYpX5sVGpXKlWmquTCssfUNVXqUZKarOUYRjNzNT9MksloGGJu3bnte4T2lG17qGTpWT4wZsEkzfHWJsAZQ9JpKInrYcSuCWiyhTM4E0WpwdDtyJEICZlmpFvo9/wxA5kZfAuDZF+4yEBCvH1n1EZE3BpFSmr7YXCHpkNpNSMq1v/ZsWr1y9d7WntTORId8Q/BaCexmyqWQmFHTbaLtrv1vUSETTk+LBMyjpCobVQVNQ4qygLn0ULtXCdKeWjxxWMizJM1i82EbkfPzWJMmpVK0PKaXVMKSQrMMMRamVmV6yNdYpLNQQZqFQSeqhnJVd62m7TTXVx2M23KF46VMYsvCWS++4yuKcp+TUFJSS18qan6yFXJJdLtzbQvnGZLJtWS0iERNQGQaDIKDAFDI6cpft0fwanaiVhy5sJaCa8CQPD7GTPINTeQPfGKlqRQ5bkb9wViQBsronCg+XuKi9S4/Qvq51aXStd0zAlLrtLJs6W1IYtVxlky5Ehc1GfJm5PZSVl1YGz8pI4Y1G2LbJE0UZvZXbj5SksUStJ2yih6rRtBZab0bPdaRE1A0JCWLY6mlBEy43y7KGKGcrxWpy9Joy6UbSgj2OyRxQM0YXvJStdVWmHwqSJkgyeSww1/bUH7E+5dOvOCUJMZBPI7BJGpKF7UdY2sUbnH1sPJvaX3xbankE8lGdmphgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdBjzqDe0ty7vIHQHNpbhzmQOoN6S3DWsgdQa0ZuAECmZhAOCEkJlWQxRwA1k2iTYmlJ9oEDAKQHATVcqWARCBGTYia0MzX3KQyIYhcpbozW/swUIYVAzswFuOuvene2lFY/EaeXMPbArVP7/LeVqvXrVb+SJyLITDGVZ1pRXMVZnaDEaSFlOLLCFCsiYJiaKa3RPLIdkDyNt6WJHkpsJP1LUaQqNUpiFVA9hFGr8NxJdmePWqPxeatfW6RwZqj1yonnZGnTEyyq0Kq4szzECmsRhSCcEoS8Ub2Mksbgd3wzMqUJUwrV7zRLCzE1157KM/lSWy874r7CPWX8YKYmwfnay0KU1IFBSYrCzWWlzCjoWFIsS1TEISMAh1RwkC5g61kITZg8chqoZDtQpc+rJJLVlaE2nmqkutVQQBM7jMZaHBDtCMJna9PFo4x6YlUtHgFn8tyudqc+k1ckFm1VXJZEibjl2jaTbWPYmoimwtBWfvE9yLJ1ElI2IbNSUfcXUiq1FlpkEEFKwm0uxmmJtTyJVIoIGF8cQRSMFnQrSOrVk3PeiTtBD6s6exhGMUOSmRYyxCFoFZo01LaRwnTKU8mtFjaRN0nJvSGUcm1acdqTPksucLN/GlNySHy3JLo4LNSqR1lJcmjOcVnJ2hQdlXYJKICLDCg0w4pg+WxpTAQ3RIAI4khaYoYTb2lEGTKCw0M13+VtPj1HjL/OLWlUXBzN5dQU0CIS8KEYIbPD7UJiehy3O3c30kWcH5M+aIuKzE7F+mtYWr9LzDnmzA1E1UyOUoEBGghkYq+KtZustNQb8JyX1VD46vsj5hESGtc5Cr2Gb6BK47dt9haS8pGEppmtTSLtok3NrShNpZV9ES61QTbRrzSb8mp9Z7FXS8YUo6o7bpJSblW/ehUpPZRuSnjl4n1V+306V3qdPWlYRhasZzgxSqqicIyknFi1pSbxWWoBWWhPIG2ycooCZEZABlfsTVw/YMGFDKAH/Eszol8j/Yg9ssyR1oCWibHmiLTRumluJbaew1P9sLehmQSt1Je8K4YPv2aeCnuj1qJJ9tHtzv/rPG9Xno3TfNiRSkR56NnWOkgaagkqQQ8YJT4EiTed05E1zUiJ9mYkXypORRuSrORP6+UngEBU9wxbu2UsStj6unUvY0uGNTIYmyC7p0bm0HTxd1ibWeyj9XRKnsgx7IwjUyRPUcvGO6ZJbeizJ2FaU7xhklttLZ+flOW7R5Tq2xHYLgqr7vuy/RSzdbG02wgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHN5A6g3tjcOqyB0BzTG4c6kDoDW0tw0HIHUG9LbgqihihUXNToQDxgxdgEpSu2gSEqaI7mCSZf9sM5TUDQjggUeI4FalGIfvAIxgaMt0ag9EkKgRNNDkkO9hx1p23V42KYtwrJhqdjU8KeO65N8qWIXyvqGDDlHJZdq9MyeszL1E91nuUvHSjFX4T1lXutMw7sbe6U7xZTr2jqz1KsHrDuN1+zt6TTjhisop09cyGGCi5a5OvXrRb7z7ia8s/sPnk7f4dgr9mJpXvxpHS1a/DN7M1369XK/733ZvV2D73nrVeb1nYI9pje+1aGuQpZdcl7679Lz1XqVr9vt8tU2NEuPDhGE5gEXGChgFACxFynSBhUSuaAVQSYIAjPxgGGUY0YmBCaccm67DjvNEopY7lq+2JG2jywgfKXlqW5wnrmWWACENUiNFk3STwZqVqURGFXLcpt4xKj7UuW6uFHn3GYmmlO59FaswzLWPHljl0S2n0cM2WVFUzNq0imNunsu3588u5zfuLm642w99G70fcb3WWdnEjdX+axqtoXb7SNetq0nsc196ylX3If5Xeh7O62xRermW2mrUplq9tm69D1Nu5v914/vb698bTvVbjbiu/mU+CmQaxDXZj2/Nv16vbW19vmrsnOOhAM0PmzQNzKpTYFQMOTVi2Jn7oa5QOCqo16d9oeNxGGqTJJHLKdKg3OYDAiG1+W6SHTIRaYo4YY5biIXAZhoUqfOnf9kO9T+mNQLKb9dnRUALdyL0mV29jJqsYwtWpyH2twf7PQGRUutrFJotlK1jcUcqJpiZVlz5JMyVLx3IFVkax0uH3x0SXaFvGthD7neUakfklFuMJKMNy1tRmL4dW3pJxY/YbYpdm3XU2oK4stTkkN+TcaUlFlaXpqCKTU0WuxWP33bepQ3+fhKaHFo+9hexq6ZfKGqsQn4bkKuCFXJR2dMRoZP0VWCI+aXVtc5kQy5zWJhcIjNg4siz6Cyi3YRAJp9qCn1Qal7feQ55RTinje+bQSWc4pRzNgKhJTCX0l9yJqp0t/nVkU1blhiNiTzedNdrXsN0jZq9q8vUH3okU1pj6SY5r21aTEXKnkWH3XE7Fl+YQYschE4o9AoR4PobZlm11MLnHU6rXTlqTD7DjFbUTZLb7Y+HOhM69z2SdPnao2iLljotsve3Y233MWhWy+OXRG6nVdQ6o3fSUP6tlXPuj4mOUoOczbIbDpqXd87ZT28PVs+SFFER4EwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABsqQOoN7Q3DT8cdAb0huXTpA5g3tLcOmxJyBzaW5IQELhV1ra1npLFCCgG4lubmGMnVsMdaAwMcedrypJ0xCrbrHHjwzdowoVmeuE9sppFEH/U/di25M1Sk1ndic5Wn83sTultjLOrvP9ZU923ZYgUg8eHJFC9ig5Cxk2IZ80UUeOuVmhpq0ULMebB4lgbZIeHSMqoJuxxZ7PEFqMZGW4GCxqnLlwWx6CRRg01EPhWJNRIUal8WSxbSiQUbqyQX3JQstkw6PJTHiL09pQxLgqXMI2qFtrQZKUOQZ0ikjoyhrqo2JJiT7ludjntxivENdepo80QQkD4EgYiGmkpitJXaBQkeVXuLAIBQVpCAs2apAz21GV1Ig4Zvr6o7MYxp6MtvYqT1HnZHBd5s0ubeV1nZgf/2z6BLUm2q6nhdFV/O1nnlbfvf2BHMa3ogQzgXMQODq2F3GVWeTU2YccfCmVicYhw46R4nxKGBwcKl0PGMhxii5q5g/JLPmxhFqtZts5hmyVMWtikMLO6qzirkkvLssXz2Pso6mqFNWXu1JNxp7Ib5djzqtR/CrxSGqXD0QySjyb6rbWcPcdSVO/JCq0qq7dq1Uw0xw5NgLgwiMDM4uXSY0jeYtFgajSxABaZwSOKskyV9DD2N2Yq2VJw0LEDhJ2WDX8H1FSCelbMGoSTEDASiqzrONdlzI5Reyla+Y/Kq15s6SzHY5nYwl1m3jNPN3mMnoC/icMNwOnrgsdgQtJZKhSgWpKUV1hG5HJC0rSNA6H2jleCJZJMYZtWbz8Jo7PNSWWQqLCpqc0tg6dY+WmFckrNBFhtHBalntqSIW5o71VOMspFNB/dQ2T1k9uebS7p3FbUe104yXTZpvJzZjGpxTxLIeeXKD98fCb5xlrG5iieL9rzTjB1IpWlPs23B6ysAsXUGRalUn1B60SwfRIKtAgEBHJhI6EjFEuMZghlsNZSlhBicwuy81vO/DCJlaR5T0qpyQSZU8szEKWuqllWpdv4xWfitCxSWNSnbXI1PVrtiWPtWuS90youuSI7b1oxrlT+KF5yRkamwX6NVDhSYphkTxcVkU7PNDoytJmU0lyYmdBVZGlI5yiJDNtUlKxRPwh5Xrtk0DkE/TCcbkzKXww0jS2iHVWHwuTKKaiUIKbGTacnEtZFthRPZJImIq4rjaetdpNRhI8u5nyvE46g9WvGM5vkg2EtuLFwXqoIISqP3Ep5JVQgG2ToZwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdUkDkDezNw53HnEG9pbl0eQOQN7S3DTEbcgc0ZuSU2MVRF2sVl6+jJEwXAnVAgEcMTqsSHM+VRJHUoicxD7ATlW0mJX6WZ+MPAkhlk+1RT0/iBA9Kdz5nOlWFbM/1Nldh184Inq8MPsqyYl+c9WiNm9lGeTO9JiDcOBwogChItD6DUpx9LAVnlFyuYHmpHlsgVBAECkEqIOQU5EI2Cg6CZVKTrZggBkzPxp9FgYGm/GltAxYFeAAwni0pLgOgaQMOgDh/klIsgrUxFSLZWMIqcONfe8vTsd3tWkpRkTpZUou+4S5pVFkEop9ShFpw9CK6zdOqBOIpviJAx4IkOcqEHsiRRMtMSWRGCQx04LiqYtHRzMQfwhbbREEuxHUkDmU4DZCLTNYvAS0TJZNK2YiE1XiDtUtuQUMXqhcDYRLYsvzG4ypyL36ml+RN3aRoqqD55017Vyhls115e2cOBnobgMQqVaRNNLtPJit5EwklwbipMxBua7SlsE01LR8uqvkGVFGZSUaRqVM+qpewvZRtqir52sgUiyUQwam0ffH0KYpqHWW7MsquXlDWH3bN5/k9XaNsOztRpEUXKEFLpzuKhpZibUG5qooCu3b7ntTm3JdTqdC9qbMHe4RxAlBa9tuMe5nzkihKPZfj2JMLPflAIExgjTggZ3EvgplGVgTfiMeNDI22USAEgGBybsxg/q6zljMiG3IZfTSuEGBCkulbpNWbDoVEGMwNlRXGFLu3jZybBA1ampYjdUQkmWHLM3hauy+7TVXk1cwspmDUUSNdVhiG6iSUabiW9mZa2n5RYhBXbi3bxHM2tLHXBG0m+RtxHsWzD4XiFds00kkNSPxzoEVq1GV41gmdHGcVaUTS2WSx+ynUHyxVZ6jTaP3FrdXRwjbWqtulGkUptsNy3FNTbQbCFz3cWvq4o1edupqqKKNyhSDuvbajfNzRTgkjWk3GxotNdM0mqbKwQMAVXjUdtLCBQNIeWOADhi5BYBJgSAgwC25XSXXWOE+Fg0hm8vlZZG7b1alNVYjSofnaW9FUl6trPkGtRm6WuzZZVqzUn7ty5ham2z09TzNuykBaGIRqTMQRLBl0nLbRgfe1llKEo6RRjDbQtnSIYYiqbQI2TRPljYwlDggd7q6PKKw8CuU796lz4qMp0aLdIx4shtELorLPlRt17+Fddno5JW0udtWEhYuHLR0l5da9xNCPsMuKO57tfStvU3b21TNOm7c2I/uG8o7ul6BlpC2gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHaZA4g3tLcOgyBwBvSW4drkDgDe2Nw5pIHAG9JbhIwLACYbwQGqoZDVGlAUNiEPNxIlEWmGggQ8qM6u3YfReN1tg4IfdPSJ0kaMHB4Fp2wNRdCNiMVZDI7+PsxdHLV/Simdakl8iYGnjcpJnf1bE/UczV2lVJ5IKYRptM4hVXYaZt+vNnyBtE1BAYhFyaxZDTLDB9E9XtjYfpCgX6BzMp+CFqZEmypC5uWWX66ycXHECmrblMNN2yiPS75tVNNlmkeefxNnEKzSs/Fi7gvTLoy5/vvLubpm2VpKqxUSRSRNY6VtVcepJefScyljE6jm1P5KMlewfkkrautWjg1i6UXmxxdDBEXXGLC5AzcMCV6rLBAApQYBGA5evCoABQmHS+RvyYRYSdET5K6IHxh4ZL4MxpG6mHEbpZRLpRWTSeCnuL/2+yZjH5VM11s3pmdmUkFOr0pl0ctVJi/G7jkXbmpESF5AWDyJSBkqtBLVVlWnypmJZ7d+NKOmqpEq56kDy82xiU3qeyDFqJpLVPrWYfZ2s5uKGmlGYC/SYXWVxrZney2gxRCbGmKOpzu3bUozzca/dBnfG06a6HF5LZi7JmBKndWh193KoxT2fOpKJIXVL9S0VxZlqKCSnaYlCc/06jcVcUpZOKFG+DOeSFcyjkpYKFUFzERNc7bKzvaZaOi4Sm6MFJshY1FRcwKbRljVWVPUVQMxTrYTEmwyql0NCED5Pg9rhR4EBktl8HQNfWk1TK9RXIGbSgs2LBVC1acsN0uP1qSehmdt1aL6wwpDWFJc+OrcsZbjt5+2zmN33oT1NRdhz0/E42tgaqwxdpY6648cQ1ar+f8vTdpn2YvlIbWb+16ndLNc658vUXLOd/N3WMY6edpFtLV13mft/Vt9Fz1OWutRMRRrr+c2dZ6k71KW5TMv2r1V9LQbSkMf2eO24VmUt70cXSzG6+t37fWrLVInpYaaj6iNiGxnQKDA9A6FwMdEWOKrU5fwwGIAxg7ag4KTmhjgIZ/0GFAjS4cn5KreciWsexVvQfEhEJr0shtxK2VRc/IobfO7DqE6mk2M8m7uW09MwtsE5f/79ek/POCbW7aijNzcjlU2kiE4kxHNZvbmQoG4Fdit9jarbT2tksRVpxWpvV1i28Jujm3qAvCaZFrmS6yJuyZkidN8y8JsOannhFHFptddNDLTgpjFbY016/klGU8c9NUqsi63vFnK7DXySUuMdV1ePUppeErjCctUnN6U4qrq37YlVSWWliFiEnx2cpZKtlDSVCcOZYqhJGFOqSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAABraQOIN7W3Dm8gbwb0xuHiZA3A3tjcODSBuBvSW4LvEIAh3fKCFVQvNgpFcocBDSBVtIeMgGigua7RxWWJVGaSgcFOq6XblUIApyzEHtktku3KJ7kUsPvDdBP2uqJvzNWaz6jgDZ3esay1hayl1a7Ye55oq8vcgyWb3pU9U1+r4czdup5kneugazMOdKkLy+HPOMp5+bfucvcpREworw2Tp7i5Ybsfr9X1Uup7zp3RRSh7Wygmmdhn7dlOmZVTpjbidjrc9rT0Pcu5zD/USf26/Z66NZrfy1lucgZy173Ws2LYbUyXr3S3Tk3UfiGvNxsHa5IHjCwokFn3QcKgOkwY+AEVRG0O5hQZKk0TSZsOjWDUm4moEaHYqanmLe6IkFYamr770ogJQDRu60Go6SS8Ox3LcAwqZn6qQzCm8v6nKe3WrS3CD9ZXonnmNOZ1/IVztrWT08+qwzq2X4FW1du4tZUQKvrPVytnb0ibjjeantykSyjLzrbuWaYXc6xFy2u1cbagjx2aWr8PzVUjgWuVWwObB8T9YJ29nrU2/WtSnd7F/hqtXex67m561ujs7uR1mrzswV/ZW1zbu7NKQUfYx9qC82pT7L3ddreay7kVPykPO3X/DCPq5kUNBYGKpqnU7LQQuAmRXoCd2VCMeNzFVnqkMhfC8DSrM+vpoJx6mPHrrIm3vkZggPU90HEbjGyYBYE916P/IHUtamI+z2vRXqdVxVAW+pZDQWpbame0EHTk3cRXxhzjtWwjXVjPj1c09tVlCyqs9baMZWrLruanhpVZjaVs/RJ4YstjP1pZw7LOS6zXjG9Vn8zXorvKVrD8f6ytgjk8jtZpbt7ufs1c+lnnrPaxeGq73I71rVlwvsL5nPXRTWBis0ln6bB3ZlrS6u3a3uws/LxRbDq2l0VEmXi5dN8pVb8MvtN2yt3sbfvHFBd1FVMJJ4yNS8uIYQUszYKkaquYO/gp1rMMDEFnCaZq02Dj9wJXKHoUzFc6LMLb/CpD46Livbl2cjYJI0sIkTa5V12z1/K+zBzs5PIB4LQqelmqWWUc5en5ydvfsjXUqpzYhT3k8Dnq1lySU61tStjpQTwq1JKoYK7kUVL3OTUlqzSWeMNJmSsMfN6sMVJEr21dQ5HMg3XYuaHbRxhcrZZjR6aCPxApmZSLJeErl6uc7yHzYoHrSUxlH+ni8oast4NR6+SpBJe3RubSB+bsXJUlJGtOFRh+y1S8lYIVkUoK5OKtIc5ERPVSJgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABpqQNwNaQ3DKkcbgbyNuVsJA3g1obcKbRhvBnA25ISoyWQOuuxIAM4KXzHRkScEg77KTHxRZS3eUU6nS0z+NxYvLBoFR1ZKFwmXHCgR4KBIZ6nPvufl2BpDZtX5yjobs4rwkCsfu2J3meFXXKO3d7Yo5MMBUQ/Ai5x0vUSkSa0SMjsViIOKLHSlCxY8oQcczVFDynekpOS5Gy/daC2Wg+koSxM3cFqblGoa2MJImIJlVlIp3VGMi6a1p1h+Hirgphyw0ZlKxK7wijyBw6Rgt3wTNNFE4jC1lOfN3oyHXMDr4eZhalasqBYggWCYxELFRGosDYVAmtDAGhwfswZ5DAeCCACBwG+qdxgUkHIzkzVVsjzGxgnnmtTGvCUnp7kt7LuBQKNRWpD9LHVDsreslZnulNvqB8BtWsZ437N2/O35BnlWA1Yw4ooXVcACUXHJgrKesFoIQsehnaGSGYchBhnC2vjMGHMlaCAYwcWoJVwxC5jkHR2DCAhejWGZ0P0hSKt9WQEymTJfppoRMysEMo4ytVMnKhR86bkYkgBXObIlOZhhVDCqdSToKMoyhxb1BYkgy7Mbh1JTHxURoLDSJWl7FWvKpFjEHUnFHA5Foe1/zHIVnwRfuQQo4bmw3abIgGss1G53KSTr/S1jfvdHYe1J315Z1cY1OV7Nxc6bqr5XrH72W8eVMcc8xSeBox+Yo2NM40LGWMd5sKPICv32Bn7XYgqGxkHixSzreFSphSfchuOhsK14ejMKuzBjYjszJKTHlVJyNK0P2aRyyqgoeiAjflIkXY+tN2aOflyBlBiCJW7CEuMPI7uLQ4gkKilp8BghgcSLjcxjLjADK4ZRaHlpuKHGsJKQfetNglw+eIUa6/zrPPZ1Tau6ZHAFnOR4R6fs3+ZqoWruUyrZBMIwyxq53P1yfrfls+FYWrSN/XqMjGTaH3XUmsyQ83flJOWoWcf12pGqnNaQmpb9GC+fwtvOkWRLD6uTTz8zJdypZQ3L7mhZKCJXoqMINRClZmxBm6pWwqZ7hXJjcmyCN1XWrpsRRc1cJhCpCYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAS2ejeDORNylLIG8GYDbg4+QN4HtE3BrsGbwPaJuRwphzQV+uhApi6M6k7oGEDQTRCknFjzr7MNMbkmBpkf8u3WaW+cswb7LH/e+q5l6DqDvNch98q/11brChVDjhrL/53HD8nYurHSm/mfTdzO5pnKi1szuyKQyUeuUqo9n9ZWylm9HmNp17a3Xspq67m+qXfRE73M7sUroimSqkNkeh3tUnUZ2jpyjtsJ1QG0rg8RWu7LvjRU5MJ9mNPDEiVwmeonhahYg0EUoWn0TYS4mwA0ljooReG0rUzsmQYfmRLCBHkV3UJESCCZYDVo3S0qmg/MjJBJEo1ihT+y8/Zf8+fc7n9l+9/l5nkZXLsznzLNr5w7n/t/8z/zI4f+qz+Hzn8jRpz87276ndTlrEvyDNaIe3f900P3yJcs9ASR4S71iW1gSRR0mnMhQL4yTvPNcJpToSzF2E2W3iijVUhqBJhFl0E8Rc6Kbufmp8RQsSEPglKBCXbCBO3UB4iwCGO6+ti1/7Bv////////////////////vbcibbHZ9kNKqmV1K9DOMiPTeZrsdVmIJuyHnR3c7zK8jPUlzsoVTngtxPjhXgvg6rqVQ03N2ScRw+BPiXQC2tH8UzalOIBwiOTWSswSd8ew6NcCeDuizUqtYyX/wX///////////////////1qnfTfmWZdyHmVZVZkUpRpqrud1IWk1keZEQdQNCDdwz6SqHbk2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADJ4o3ge0TcmOQJvA1om5MPbTeB7RNyZHIG8ClCbgQ962F7YGTVfbP3rPkqseygbqC0CY6JgoiRaiq5UJ3JF18aRuakC+IYRS7t8uf8P///////////////////pZP2f6ox1SbUqORzoUQi3OR7rtVnMRqVWnY6EPmch3a5jBL5Qvn1iwMBYAe43Manrvbs4sjVxlLC1VmgwVSV4ixqKanu21AgvMQWAmpTW1ba1jd/1/r//////////////////+n76MazIybAmRkORWWzuxqI0jkIRqoqHYpS4puDnMg3aYaZS06PgLRVJmcpX9NXx/f+hm0bDoFGeou0C7N0BvD6eMw9ONXy4N9zoWgKAblvV6x7/9n///////////////////9X62ltSzIpVRgZprLNecSS+2IHoNd824UO1CROZMNTvyWBXKpApRwRILQEwW1l7rz7hWCwosGgVc4OM+p4FgyFJqSFvckygZi8dVnb0Hn/T+n/////////////////+83Upqcz5mI6OQyokqPO7PXOsyKxWJR2K0qn2uh1UyyKRDyXMdSs87TgiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAwJ3N4ENE3JdEYbwPUJuSoCA3gO1qUF1QJvApQm5AgSAABoQHbmK+/f1FFRLsDlRqSVNpWsgC6UCKPRY7fULhCzgmoQRtd/yS/7////////////////////q1utDu0xdREx31c8l5HtZCgnvwd6RVytqDARAt4I9USEOfDDJR43N5lPZwvavx//RxKJZqCKzwv8vMQRZQP+XfqaNFngJDMd6fK/8////////////////////7N6bMxtqVfW9xBFiHuS0rHoyIrK9b1Po52Md6O7pZCtMpCINBgQVxHEoRhLIBFKf+pJZecKd6060GQcpj6RkBRQJz3xDGlkwvQmxQU/8o+V//////////tua8ckNUCoLFkqCp8IMGRREuVcsQKaFSojCTACeMoHlWH0FAQmEobB6IU9abP5EHHFqQopQVsxjowKCliWSN5Us80IDB1f8ff9v6///////////////////fv0azPTO4t6M9yppMQEdanZGS5mIOy3Y7syA5ARxCYg5JTKFWHhw0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAALmjDeA6hNwWZDm8DVCbktyGN4DnE3JWURbwHOJuQWIFhWEY1S3O+g9jQ0EDQmyORSQ0TRcMZPTj4UPhqLhxNPUb/83///////////////////9XZKWXuiSOc16qiK2pGUp0bRXZiaVIfBTSnVaujFREIxGKW9AZjcmMC5mBsF3CSrSTrX9KkqjQ0fZwatWsXuOo8f/NNygN4uL/7kv/f+n//////////////////1+9lZeVFrO1yKp1JRVOqnUr7Ih6P2MCaVutlK7Kgl6MzNb7HEjUHRFBYISBiWp+hRCqAL0DtKyZQWjwNln6hcY0CceGE/xz/r////////////////////+fdM11kI+hnUh2HZGOZrEQkW5FcrIhXM7leQrGMMylxAI28hAY3h6/whYJAGggJITOf1/KgxFjXUS8vSJlGbyCefyoLhM//P/////////////////////1166zStPM6M05dmdbZTrZy7dThSq5FMxxUyFdT3lUyoRxkRuQy7CKwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAACt303gOcTclKxBvAc4m5JzfTeARRNyTRBm8BSibkUkTA0VWr/9B2SUItRvm1lCjFRKnfA3qIijCf1Hf+n//////////////////9Oi+qI87zu6OyMyqVEZgyqP0VZUQ5lMVGqaHPyaorWluendZFHCewehTQiHlzAicyv/KmxtJbDarVQaqXVJf474FSn/nf9///////////////////+v7rWyXtyI7Od1cxKWOyOY79jhyojyM5EZ3R3u9rlMZltF0f3hBRvAeBgwEhf/yWYAdBbekqRo7+Ivw6NHf6m/////////////////////9tflch0VlOOax1dEoZpiyyHdDsytu52IcBaISM1AVwW7MhYKf5nOiZQ6FCz9/8aOjraCuvAyvaO/fQHT/2/////////////////////2Vf0ZNOiXZVNV6vHKjqwtbWcrulku0yKVVag6ArA9lt5Ea7tgXCEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAlSDN4BFE3JJcUbwFEJuSQYs3gCUTckWuZvAUQm5FHK7nt/6rWBtB2lJrxX+M8PK3/b/////////////////////tz1rlyvv3oV2UhSFQQ07FUjoqVdDKmq8jqiM4Ncsi7rwV4/JZzpFUoMKl//Vk0778T8V9OoJP/b//////////////////////trZ2otnKRCNoxdnzGctUYzIZisyFd9JlMaUxC3WQyUSYoNEmpvFJ46B/+rXgv/rdP83l////////////////////////7nvdyPRnWpVM7oq7IdzuiojKRZzPVTAzMrK6nPR3O1jj1KVjJgmSwaTWQkh2K//6tNX9uOnt/4n/7//////////////////////voldpjyusxiopzlUxDoxhlG3Zm1vXGCFFVGz07809q9mGn3IPJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAH6dTeAIRNyOy3m8AQibkNAAt4AAAAAcwAbwAAAAH///yf/zd/z9///////////////////////39vrX2VCsVWIZjGZUoRTXCHJyaMtFIxSAR6xlz3f3EXlyEvzkM1X////6+//f////////////////////////y7nV1S7zOjGwzx885tOFxzyQKg8S0p3TXf8rSQ/Mb21H/////////////////4NZX1PtWHf575HiIO/////////////////1ulgayoa/es6z/+ysFTvEoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAAAAA3gAAAAAAABvAAAAAAAADeAAAAAAAAG8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAAAAAN4AAAAAAAAbwAAAAAAAA3gAAAAAAABvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA";

var CircularProgressEnd = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwNjg2IDAwMDAwNkQ2IDAwMDAzMDJFIDAwMDAyQUM0IDAwMDAwMDRFIDAwMDAwMDRFIDAwMDA3QkM4IDAwMDA3OUE0IDAwMDAwMDM0IDAwMDAwMDM0AENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDA3OUIgMDAwMDAwMDAwMDAwRDc1NSAwMDAwMDAwMCAwMDAwQUI2RSAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeAXE4FbwAA7otaAK3kABzWQVJ5WYADr8gqzytAAGdrDpjrrfYGAxjBYaEuG8PB2tueLnnq6p5+CdfKm8rZnpKYmGmHh5+0eLHSRygagK8XmCQmUZsYbnG5hoIWsYJYeAuAaTgZbfIYGAhmMZAF8IZRMRQexgZcMAhAQ0Aau3EvPuudQNY7j38JW4aw6Q6AdB9ItU6x1iMQciWXY3L5IsIWnLboprrfu/UhhyF3s7fu/KIxLKr/rsYg1yHL0rjcvqP/F8ow/kOSzGnfx/H8jEYpKTD8OZ08bl9P3CVy+3n+sMMM/1hhh+69JSc3nXzz1Xz7rDDD86Sk5nXp6fP869PmD7y4f1gh/wQyjhOH6YxSUj6KYAQEMQHDKjg0ZENrbzfYs5WfOjoTm5E4NzNhUTRTszcrPi46pjkiOBw1kDICQAMQdyLzDkORLKjIAIQazR54njedMJtpmaKWvXW1tYdBxMBxL0Tf+H78odty2dsPYm1+jZAWwMkkyRQMGimy+H6eVv+zhrkOYw25bX37tRuNy+3rCkpIxD8vt6w+vTy+MSyxdjb/v/D9vf4Ybp43G5fSSiMP4/kORik5UwzlcbjdPT08YllJzeeeffwpKSkpMPzww5vPPPv5555/hhzOkpKSxhh+87AYggCAPvEBwHAQBDqBAEHO/5QMf+HwAAAAAgKBhTQBQAaihUyMAwuEAMWJ0BoAgYcOAqIGFUABuswBwgMPE0N8AySNiWAysGZCDYuUTgFBgEiAgMG2INuilg/UM5IILlD9AOqB8B6InQG6oYyGfKAnoixeBqMLhQ1AArIncZkQoESg2UJySKw5ZAyWD4AxCUUCKj5GVI0fRNKIoxTKJgxkKcK2GeLYswXGOkg6JYKxeOJJI11KKxBSHC5iqXTxZpI0aCTsvdCtjIplwyMnNzZEzOoMkqiiuvSWyaaKFNnUZJonWSoG7uyKS+v/013/+vTrZHv///////////+AAAAQIBQOXgsARg+zMgIAwKAStQKgIDFgnEaAEGgDVZUAw6CAMeGEPSA0qRimH7BqwEiYdcRgHBg3KDVotQ8jCLIcSWxzQHJAMwSAaBBcOBEILgAODC1mpBkjIPxJkU4R6M6RgnoMhhioTsbG5KkmahacFzQaqFKCAIuEY0TyQg+kTQxNyKqpB8BBxxFwgRAxzCuiausutRRRXmYpUgw7iCpFAh5mpZdZSlOi1ddJlENJw3J0um5Bi6ieZA2SSSWurSWy1oqV0nMCmbsarMk0kkWOo9FH/rv/1aFI6zrtQdlP1Jf3/////////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJR1PJB3uAAK7JibPuZABdlRkmLvcrg0mkZMHe4XhJEVAEedRYCgBGACBwYLoUhhGhNGGOEMYEYhRkfhJnA+kyaehop1WLGmMwEOYHAKJg+BLmAkBKYGJhmORH4wyY0BZkkPmPQ0YANYYlTIDXNAGUHJAsBYwUMAqTDFJ8Maj4MNRg0hGXiaY8FJowflqSAAhx5LSioEAAjMHhIFAoUEJgIJjw1MMCEwMDwIBxEJTJ5OMXjoAg2IqaK6CCUVAcPAwQAFQ4SEJED59B8MEAyFG5Ia0TvFAHAIEYGGAEWArGSYHICkvmnNSeN0lFGkU8olbUGDPLCmmNKlL8uTS2ItKIawaJEEuU/4Om3QYtSS3dSdlW5Y2s3Fq0zIb1PelMO5cdmW3vldFfwr0tjdynvascz1hau0uGNXta/OxEeyd6RWlUet6dSCYAAAM027tyVZP1Ab5DgISBMLG84xJTIKDM7rYwOEgCBX+rQ0OUIolo0JpAEqVdrJlBS4riI0QOnMppC5eIhnGQsd12nhcSCZTJ3+iWFLBZcyNzSxVDHDpe2ZFg90zOOkr6jfttMYd3lrkuyr4xmvHqSv2ra3cwv2r3aKrlcy1zP9fvW6fXea5/95+PN7vY9/n61lvmWX75zfP1n+O8Ltj5spUQJKdz1qdy/a6AZj7YAy5p0IY25KURhQLoiBMwNFAw2Poy9Rw6IkU7/rQ8pcMydBcx4FIw4CcFBwYOA2YcjKYGBoYahaBiIMHxtBoNmHYhGEw3iwFmCoFKymDoHBYEQ4Ckm1VwMFgoGJgmAoOCioEBqsGECU/RaIMFUxLtsxUaFixVFCIxoQAqdpyIUFM6VXpmnkgDCVXlyAuGgFQRgZFzZO8USbKzC+wFcSSLlMtLrpfO416pOOA07kfdx/7bbOBZcqbmIci1qhyh6OZYtajs/QW7NXCfynaeSUEWnMct54XLOVLUy7Z6DBcRG6DV5VJEIe9zi9TaeoWnYFlsJbdIksAGYJgYucwLDYxLXcxyrowq6szkLkyqOUweBoMCIhAAKAcYZkMGE0YFAxHDDsQzCEHjBgAzDADwEOC+TAYAjAMCTCYEk8wMAqaQ6AINABM1dqsYoCLeiQAqPNZZe6K1WFJvNBC4CQakWJCOjmbRRpkL9RlK1lD5sPBUw4zvFv6Ju1pnM3DblvBTNzhVpu7MZDuczgWmjchvv/Btibj16Q3YErcrSnVButI8Hj5ew3Yp+XKHcolsxTf3tbev1ylx7rv7xu5NgXsPjrNYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACM5SxwV7YAC4B9kxrmgAapZBV1kagAI1yCqTItAAXytl003xCACSgOmAYAMYAQC5hMA+GJ+FmY3hlxqvqymQIk+cPqVRohhhGKoBGDAIjAUArDls8GvPKUTgDwUJgajmUtZiBQbzYDiEY+AM0NLYzOgswpYMPGBGIgVIMHPAFcGDj5hwoY0LlUHHqMWCi1BcESHCEJeowcOYEYAIGHhJUCCwFgIWMAIwUciQAuwsA6irDgEAhAEYCZAUMAoqFRFHuHXgf9y01Ul27uiChVIVrZgIAEBKV7Q68JSGUyZtcooguN/U31sKZPdJ4IkE5KZfAkifyOMGl3G2tSJgzxS+tKpe+8XlK0oBxuR25T3d9jkvmbkWu27U3llrtbdbVrLeWr+P4Zf2lxLGRdTknSzSRXz2/oetj/YkAs6W9BzQX0CAcYKAYVIRhYsGGDkeLkAlpD85XOprkyKJAwFqpmASnpinFYFB4MFhw4QQQUDFpRmw5aRixZkQA2/Zy2QcDlRqjyDQTCEJLesYa4td2Lz6q4RyWImkX6kJMBCqIOLo0urOtMf9MGggtwn2pJEECbsLlVuSsJfKiXLbpqlOprXkFmnlNFe+5PZxmKzdFarVd9s6rSqkoocu02reHcbGsu2sZmbLVZh0v52llEUvt+7sa4AAAQAIDAgHA4HAmNAwLg+BFkRAYlFBkAujTIgCtC3s2IsMuBAABvwOB5umiAoEAMQAgaoGXUeBmwcitFppSXGUGYNAt/EQEoh/9ZusQoPI4zpPg3cAYCQAAQF1It59kG0CJhxAWmA2CBOANjYWwAXDgTGYssFgQltuiOMYwUoVCHlcBgCDKABAYG2ogqmFtk1n2U9UMthlsaYAwHEbk4OMi5PiuiOgEhIBgIABB4W8yI0Rh1PZ7U3kwQRg9QjRxmiA2BlxZYeMUOHSgkAwuiHQBtIn+3oM7N7EYLgRIYLkJAMsDIIiyCCGhECHjZAqBgbyiDBdBq8G8ItgfKHGlkgAfUSsgv////kTFljNm6xyx3kDGbNxO5Xi4z8i5PuQcyJw+TBULh5MM8EBRA4pYXGGRQukLNEIA9YWULEKYH+FzjlDZDiCOEFA9oXYuYgwuUmh/FkB0AAAAAAAVUFIoDoMxkzUpAAY6Ail4VsSaCaBepqaolIW8ERBR7VUyb1tRTWpn0jEwTfV9SCFNBInmhp//sYKRQZD/pvTf2SSWWu3//9vbTTYv1Jv////oNso6bopvRWkSBYYn/////v1vTvpqZNTd/lxx3lqzNJhyIFIuEoZIEueKRmMIXCUKRgyJJlwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjvkFkmHoAApJILTsE0ABueQV6YegAD/8grEwUwAHIGwAAAAAENONuXHlc9mBaN1KDhBBWpSGPJgNvAo1AUBixBqoZMZADIIAGt4yI5oypuTZuXqNEuk4USqVyGjqScxG0mKgZl4umDDaFmBkslyMRIETAwCZI8hojIRELrF8TYPBcPFouEQJUzJkjDI8RhAiZMCfPESKJFCOPjwRZFloIESJ4fydUhcmS6Tg5BueWjOHkSgbFQjRyiCl03WaLKhTNiimUDqVzEokiRJOYlg2L580SKiKjEwNiomgxieIERE1MWJ8c8uonFFQ1OHTEkTI1KIyhcHcQ02RZaSRRL5aUZGLOg6jE+eNESfKJmTZXZFM1TKTGBigoumjGbLSUYTzJIpoGpii6DKUTJs6nKKaB9JJJB5kmzKdakqSTyjpBgAAAAAAAAAAAACEMShzqrB36E7KNyssaXzQLoAUA569kMosihqq6bopyRHFevZOggxQNSWHeTzNm7U03VqJBzJmUZ9n9BbpoebEqXh5GqNba9D9rLda9TJsiiYMYF9Lb61PXrXbW5un0EFaKCJdJIvOsyWhd0+tb2oIroJrTWmfTouhZTIOyFa71MpWmaqW6SCbKRQdJaKO7qUp1bbKSUkmbxEAAAAAAhVCaOysZQiEUdcoal4vETTHJBCmAapDCAy5gDKgibE+h0azJNJAnS6i5ouwjoi08T45KzxoXygo4xmQIZwZ4MRE/QJ4PVGGbJmRRNhwJmZaHeQJIxKLGRWIsX0DpePEws4kZGBgT6RBk0dZ42LpNFx39MpnkLrTdA3lxElmRUtE6miTKR5kvY45spbF48iTZmgxSrdFBdZTQOnjVzEuJp2exvpqTLyi8nUtBi8tO+k5tNFstCqyLrZDMzBmXZqaF1tWjWpK1JaCkUVJrUm7JLbdPZdfZateXAAAAAACB50QBCoFM8xlKiA/m4+XLgAvgNgRcwSIICDJB84zxEhzlls4fL6jFnSYxPFoonVpG6yqYLQNExViEziAouYS0pkDGQHJOkaYGhoSBcMBwlUqIMsmRGBNDTHlGalUfSJmkxgWimT5oarWs2J0xIibIdRfLBDx5MG1MZuifPDlFEyQrUWUUHJ4rk6VjRlGJYQUot0UjyZGIk8W0z06Z0TRFF0SGlREiiSzQ4WHsXTVzqZgTzprT3MUCytIyNl5bUYoMdc2NGPF0nlloumxqdOMkdNjVkDdMyMk3QSMjrJFZjVjFIznDFArusprQd2SUakqi6imbF6boqmgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH+o9Sdw8AAtfyCo7gvAAeEiFCgOnty2REqXgcPbmzMSIAAAAAAFbtfh0igLxIKvORtsziuA08OYFDnEwhkJGbeRy2klc3RUMowtW6lM/zBeO7RUUZqPdR1It2UXLLY6VvZmAWpvE80Gt1fFw0RqSgnKWdp49qM1aWYfqXwJUvXbG5ZUik5lE6spq25NORmA77wQBPv9IZHcs463vf5aw7z+7qfTVqlWvErNV+q8ARqtMxaU1LEts5U9Jfn6bVa3qWy2Zuy+7njjqpT9os5uU00GTFPKpzLHdJjql3q721lrK1lreruGGM13DLPeNNTX88Oc3S5b+pqm7zff5Z5/2u51db1lV/mv/HHnNWse5a7rLLuv/f/+99rZfjVxYh3RjMAAAAACRBE5kJMQEaWaPnsJC2MUk6RlOJvSX2+y9t58b3GrAqxs8fc+n0DMs0sKM9a6QkbY/rxThExG6fj5xhb0fdDuZHFztiWjyP90hRI0G0d9thpI7o2N6HK5yhxH+nWa5rr3zi267tjOYjzWssMkB5DhU7pVwtxL3vPu286tXEfWbvdY+YVqRHDotENqcVcOBXMLVIbLumLUtSl4GLU2+ca43NvGdYjYvj3zrPrncb09o9ZsU3a/+vvXzFjWfW3n2/3Gta27W9M5zr7rGtCn1esWL3QgAAJ2ZyN4n5Lrld+n5gVx2HjRUAGwNHOAPBQZGVjsH0MxGpdbzuSS32W0tM6L/sCUnIY1BDZpLfzq35mYd18GmN89cOPSTUogzRVhKA206zvKnoZp6luRSFltyg13DUErMrnaQaVegVwr5D6cVE/y7YGs6S6G+p1YuEasbcMb1qvi7tXbx6+oh1TlxLCdLMGJHlTrUaTfuHur+CxQpVwwKd12q6qXESsKHWLWSdmy6aoL9ZTiuUtO99rXzT2tXEen3FcPXxvA3XW87xutrVrv6m//rilra+/bO8W9d5p97+rW+c/e65rmm4uiZy/ki0RRoQgAAAAARBRnI9Rrn5b3+o7FWIQCBwiTVhHKk8hqXq2Xyum/LO9i/16/QZYZYzdXPKU44QmOymHI1OV2euB+mmBgSpEOlqNCw/PVdJ1dHlGh009+NYgSPWVvjTRpYK7RrphZYhdmhd7tX7//tn53feHsWfc9awZJ9v6Ro92s5Zm9qzGldyz2tfMWmpIOIMsO0TEu3sGqu9U6msQ3FxbXVf/be8bh+2YOvAtJi0Kf59c3pa01/qla6ta9t1/77/1rmDrVfjeLYza2dY3uN///XxdxalwLOuCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB450zyB5e3C9a6pEDe9uXVGzOcHnDcM+OyhQN724zIYAAGcudRJHgoTn2MVH7epDstEvKc5hhsGHUeyRqFAZJbz4Tbs9iFFE2axqJyP3Wi7So3NKxUOMNRB9IpSQbS1YxDLhOs5L/sRR0JcA3LQE2TctypasIefjOuXIaKMHwXk4FauEmkJ3zxPRU2pU8rnr6IxQH7kcsygQ00ifkjTDjElzC9N4vC+MWYosVmfpA4UY5Ia4MS+qlM1NzMomadTLvMJh04X1Akgxkoriwn4hzExzYtbcGE1l+WpWp8rnJwduLt9PrG8bzibOtXrim9Wh2vPvz2xbcWtdf/Ns2l1afW5Mi0WuWdbF3QdJxZoiEq9/siABm1GOI55aFePS1W2A6PQ9Q+AbIsBlkINNNRGmdujKWLfM8Jum2kGTVoikhNrCz0iOKsdIOCul9YVj5dLRew2FQnmrUBlThnRB+vHNWHVZagUjZxueLmsJqXULcaE9UjS4OMd3LLW+fn5/x8W+6xPqJCtTULNYeMUrikaO5aiR6Wx4cXNMyyb1aePmNvE0SNaO4R1dZ9H1tMKUFTjF33unbNmpyXNN+sr2Xvzfb3fvLvv/VhU3+b6dhqLCEIAAAAAAAGe6G1XloflUhgTbtOXToOgK1E0RJD+AgnGcS6bWpBXlERnL2nytVePVWcuAGDOs02HastktPNyzs7Btyle2WSWcmi+zvmEStavC+sOqCzstdmC4xDMYfbc6yjCRNOdqGe1KOXcpHWwePKIyzKOS6xSU0XYa80CUGMrlvMd3ss+Z8ub3jWytX52US2KT8Nwmkyy5QynVmdrzuFNhS5SiS1YlR2pJKHmk05fjEqsY873OblkzLpDTPnAdNn2e5Xq44c738uc53v7y3nhncz19y79IVtcNvNgL3pfSOpck85Da7Vi+1jAAA6UiPn8oUTLAxB3WEpLFvOwIWCoUpCisViGYbFFDXLhLPaPZ2yl1O1pY085NzEW6c7F9Wz/SXgJ9XpazsWgahdx9UXPSamOVqQ1wQ8YsVGptpRcVmh0XbcwxKxocjWrVmbT1d1KVNszVikC1f9Wvv6zfw9W+5oc0RhU1H02LQ1YrlUtZVkbcl9RZ67asWZoFn0NqbY1d51RimakSmprRsbp4M1d/51i3x72zqfeL69d/OfjWPreN3xvNdX8KyBFCk7A14vCbmppRfwmKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAaSak0gWXtw6K1J7g84bliFoTCB6e3EesgmED3huBQAAABmNUS5KPEBqtWVuTKo1OMaQHggozIjfgONA0/EInhfVxp+ikF6kwiVumpasRbk5kOvJP27c5KpW+VNjVmLMRe2CIJa7HYIXxI8CyDdbHF9CmYG2OomNnTy01KxTvs9xnWYbM8VT2+XUFrlXZ2nsbiuIMokdGV1vWv9t6+c4xuHRXp1IPnJjiFhaoclvEkexve94s+L5pCjQm5wbtuL6FbX+cWgp6NAfQKRXuZ5vSa+f72zvP9q0gw5txtigclgbLEcY96SLorUt7dnfLV2ZO0MVAAAAAAADXau5ZlMLM/q1rk1VghrMOlQYFxs0Hpw4FrD0vzAMZh6WRacnsLXI/DM/FF1N2hVLTQzSOrDsqgGcV9DkT62KM2WmNJg0xIIDGAq5Goz89I5DI59sUFr9l8Zf2JwNB0un5blKcMc4njK4tRZ7lV2HJHEnFbSCKCnrcr5d7+GGfb/au9V7lqU2MKsQlUnqUmGGu3ovEIzuZpsPrzuFTuNWtVykEuzmLXaD9fWs0+EF4X5d2lx3hYw1e/9Yb7vHD/yy/G33dnSwShnl4LLRATdqf84S3Eb/0v2f3B7NH9M9dKv0gCAAO1ToTI4DHCtlTUE5EZ1hsMrhFWAYaMjANwdhIIAuk7ViM3ZLWtz+Xbk1J885mKVIesU0qprFigp5uioJD26/VmJx1EqRtaHyXlbovP2luXdXdNxTlaFV9WrXTvEl2Cqpixp21TPzSZT+PZsvmPitf8Z+K49ZN6xEs+iWnzCjamj6y3T3pCpEhbzXT2stmOWHTc1oVf/aeO6eP2mRij11mXFN41nOcf73i3pmMWCp8WiorduF07W6nxR29NkWUuLadCGAABeouIVVoQEFTKmtXYDuMLTOAQEKESDphLedWYAkAUTZ23eOK3P5LIu+dybpqudFBy6y4yA5zLD1xmFuo7VeFQpsUGsbcpxVlQSwQtk/CQRYWapCFgf04JoIu5rN1B5lfi8k6mAW12rVXpE3m1N0FdBVy6J/V+sOhLnvnHIvPNPclyZK5S8JfDs1S3sdf3KmpssrVXkSvyGgnohOOtC5dBME0t27u4+zfuTcvNwpJ6xH6tLYs25qmoIi/sNU9JLLOrlWZpJiOvTdcp5Nw1A0u3j9uXWas59nGpZx3lcvVcM79WzS591W/Hna9X8MbPMb2W/v2c8L+e8ct/lruO8r3b/a+Fy5lW/ufdVO40WGrWVm5hrWW8P7cz/nMKwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGd33LAPmTcQMwqYQPGW5dUdMmhOntw4u6JrgcYbnuhpFC6CgTgeRXsfq3YeoC/DOpwx0lLTdSNfQ0RybaDn25udh/KpWys8s1YPbxrqmrm1NQzFKGVS+5TWZHGWtVojGZx9B0B8QUMfQGUh0hRJ83LpePrMCSL5PnTIkiLkwXzySZZKRsXjE0MTEmTpimaF4pEYRRNZVN1pJGvvTSRugmjKSZPGhua02N540QNDy0DctKOqXn7rOKKxkmguyCakVzA2J8uml3QW6Zxtb7tqQZTG7LP1qV1popLSV0ndb33r9S+cihLWfS3apq4xXpAAAAqQyQ5DlCED1rC7YlqXqDCUAJokANeQxHDD8m59Yq5cOuxDuNFjT5Xoo8TnkK2TzTZXts337fl13IbK7Dyv4ps22pttGCwQWbdIJHTiL8IApJXaTGGCuXOMJfaBrkPTklpIc+QxaaoqaHsqSJuRIsYy7UffhojIYjAkbaZXh6/bw7+q17942d7uxq1eltuMSOZlNuMQTRSvWefZHXnM5Rfm7dizUluqGmt93MV887uq2VJjQP3GYdty6KZXr+eGWU/f7nvva2//HmMzved6lz7zDLGxldz1nn3XPw32/Vw3lh/fy1+r2G88eTX7xws43McN48zxzvEheBbuwIxCQb4QAAAHvanWWlFbiQTm5M+sVmU6dBwJRpuStpyRJt2546ZVWDQASHM4YhJWnxV9JVUjFe5B89OvoXqaVIJI/MDrnsQfLH6h2DrMtn4Gibos1bIcxGjCC2FeDiHofsKFFY1l6XBPYTYzos0jiMCG81qZhkh7jMDeuGd9HPxuJSToxTrQlXO/Gvq+d5pW1fDi4tAjvIrWsahRldI+iwntJaP3bVfUTEmcVtbd22Sa+ouosSK+eVXMGBHdtuHbjev9aU1j3xS2dZ3eTNJIMe1N1pq+dPL2g0/xi83keLrqseH4DF9RsRkRjJ6EaheFIzEAAAAAADNtESDhs9429xSGnXjDlpknSYbEP/NIrLuZfYl0n7arXdT9+NROUQco0+b+vbKqXGcjt2PRSw3GmhuFSvTTZ9zWvhQRZGmU1SNhE5Lmx0EH8kUKrzdZ0r9rDUqtTmEk5QO1Dna0rps8LtakdxqMflu9Zfv//m/3/fwx523crVpXWylNq7y7q1jELEsyrcs8u1P3nVm9U03vK7nQ56+zlhSztPE41bmbNnDK/zv5Z8739/hz918O9zw7Zwwwxw5l/83+vw3hnXs/q19/33UDntqfG8txe17gJ3XsVgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAABkleSqE6e3Dz0OmUDzhuV2mlKoRp7cOsO6XQPL25zIIAAHx0trU459YGDdq08cJjFuHmdJ0koQMjHEUGPQGeWgYCixMRaSZS25T1qkup69qMw68UY5LqCbjNqTXq0QjfK1WLQTAMIljGEeAkAEYYYrp6qyDFVUPTcxQXUCCqG9hiW3q0W892VdrTC1uqv5WNVsasZdZhRKa//z97mri+M4xmXNo2GXN94i6fzxHs0Xca2dVixW2G+zS+t3967viK/VMZX+BWTMK5RAGI40mJh4hWodWsICEglQZDjZZakXIcZ6a6O2dM+JIAACoTQzpnI1FdrUuqfGkjzYC+gDSOCA0EgsIuFu0Zb2XQ7KJfP4c7dlL6v+7TfLWbDKq2EGxbGW01WRwNO4yeNrMsM5gNh6wBUgsAsDPOvOyuAIflcGQzDMtksvnIq6t61lqNclV+tDkYppBb3O0MbydN1o3BtJNWrOXP/61bLnLO8M9YzHcJuJ26eHJyzRX8a1qKcqzkxcu6wq6u4YWd55W7f39V8v/O5Zwtw+77+R6Yv/hXq3O0u9fvXd44Y3d3bPLVWvvm+61zn4Z81rWsvu6x1vneb/X/l/dZYYfl+uY71zev/PWt9/7neTLOwFueFVEoAADi6VpKVYmAwPsU0ukFPDrfOupcADJYBCZtchghQkaX9AkxfmeUMap8sMrHJTqliucTtTW8Ji5Wu2dUdrL38gS4uTuEmJ26PxXNrjBbN2q9V+v1K3KFl+sNznGn05sWKXcLzLqAvpRTKVwt8a+P//q0+PnFv9Uli6vesWl48Ryx9SZhUt/92z4L2I2WzneN/W6vYD/Ptev1qv+re1vb4+/86xi8pdYQFZgNG6mONJ/chuerd03kXKXqgkAAM94cJyJXIVVpb8/jDDvOWvcFJgiwWzNmkwQQcIlDH4u9VLHaWNW5JOVMpDTrbXM1iAK0btQB2s5sonYcgx6FFqjYF9vy9RAychAwAsTYRFDTrkMNdEqNI63pnv4U5bViJBfZzViYGc5m1CY6Ex8MS4Y0IlIYVe0ZeDFxmu95ra0KLWC20xAkjW2jYqekhUhRsQp1qM+V1qN1bW1FgbsnVRlu8a8rNG1SO6YEhe6PT80dwiN2JIsSH9ave+PubO6xPHh99PmtMfc17UxveNZmv9U8XvUaVcKV5jqijBcPD93L6LvKHdmKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABShcyqB4W3EMcclUD1huWD1xJoTl7dwOQqVQXWG5ELIAAHpTcMxeGoQVL5vditSRdu6YjYjCUToB6lAEAyeb1S6PTOGONuvzfMaXNrNWR2J6AqkYms616/es3blaH29jo2j4EzYZAiEGtBDpkkslZFR7ya03540WMq32u5IwK1j5QdNCYXXczH+2a//qVZXRo816cMuFe3Vctv9rNlZ86xr2dW+L5JsvceUhBACtQEJRzBxIWk94ZVUac7o9db9XWz1o0KQAAENV6jopsoQ6TOzO0ENLnRsFghnmICaCBmTqwW02HD1+P925MW7uXzuVHA0Puwra609TXmlS+klbvU0KZtJWluVCHCRysMNYCxUHXEVwTNCpJ5iz6vNJZS3JhbivpUhrOy/rbyW3PV92IYmmwvn8Wh2dnpmSs6mFhGkxlmefLdvtnu9Zbucsaxscxsd3WzqU9XOVOjS09TtO989VnZdhO38bO6bPOQ077Q1hWoL9JR1+7rR2WP++2EpeJ9pqCNf2js0kh1T7v3O1Ncxps6tqlzkF/lyaxlGHOZ4Z/lnS2cu5Z26u+YZZ7/H+95vvbW8sP3+Fzlm9+NjLPG5Z5Z/mtat4Yb/8c7+RQcGAAAAP9hux87gdGzJFu7DGN6GFerCp8kKpT0Etn+gA+2aujANM3a3L9ztztnVq7i1BozrQnH73MY1Xq5RWl3e7jeuVihNUQkJKJcIcwF5aKQtoewQZ1uE5nnFZtxvX3iM9YE93GHZrpVjV711CjSQ/r6/9M1g3zv0rq7+mojBJnDI9tBmm1ueHXVd4zmtN2fQq95il9btr4qnIt4kGeNVcM6u4iLvQcPTSxNMBXq74gbBNf/u/X3eU/tr+Y8/7fNe+82UAABeVDDqspQtGqYWM5fYWikgtcMBO4YHqEujkhWJrskzQH3dp75fHdS+zi/0saamTCE6mYPHKHfejlSRNZkLLZHK2vy+mcaD0/JMUAEhgK6zmQBznNhmERJymyxF1YxLotR8cens01nVPQRCP2cYhHItI6squQXLHfdlwLM9eu3MLe/w3jb1rePd2sMKOZpKaG7l5/bEVvX+wTWvSatH+YVeX8akuvcq0s3SU0xaud5ju7Syin1i/7pymS0styt3Kt+bu/fzp7uvvWu5V8reVe5f5rvcscfu1u9zuV9WcLdak7n9jHev1jnrDvccMMf/+ZWrv/Vy3yvhtlOCymogTbOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAWmX0mguXtw/zIJVA9TbhXZeSnC4e3EfMgkkF3huKyAAABW9xaaRAGDxOarXqW6+cCmAIIExJo8sAdotBxnujs1H5ZyzRUlLYx5ycjTWpDT2Pj8OyCml2Gc/2foLd2fnKhmjQIGJAEfE3IS+jWeOBvOL95GUy+8eq3cX/6pCtWGuXUkr+A1ynunp2+0XWaf//Hpq/z7Wxf03m3kc9WpJJ/R9TFsZ+In9cbvWNA1871e8kWDWaJvMW9c4xEESBRbHXB0MvnZwCuNEkpIH/6Nn72o267GoQAB10VnI7gQh3zlUT7JsotfjJhDgtTNHgMUMWSND2nstoaW/Db+QZe7hSxmBYfXfei65Zq/KZTef+Hn4d5+mlMibtT9dNwJsZYNSFrAWoBpEPgLmRmT4xo5pIDLEUFyEQHMOFsYJVGySBxI4fLJOEwXSoNcrCtiTUQEgxRH4Z8jxvC8NXMVmDbupbMkmhTPy0TZeOF4xTIoYmjInCHkgksrGhkaEpN0C6eSczImbplEpG6aZkmtA4cKRFSqWyQJGYKSNKJwyM1sZnUFJ0DM3WaKPlJI+ozTWpkKCLG60KLpGyNSjPQegvUu6K7L1rtUtd2RS2oIuyaqVNa1KmkCQGAAAAAAAUZkdNRigGIC+7FPNY8dGGJYSrLIAZx6KCuunVlVqYuUmVJKbu8+9j0fltyvydyl1PLKSvnVuQDrPchnY61J4Zx6IMNsxMYhZZlLu0T4YtKrWK0tr2g6jZzCrGgzQ2GG1Qr2hUv7f/4xnON09//iJHi2YI0TGNUvuLWJmBrXzr/f9Nbz/v7+vneocTWZL0jy5NGFaYGQDBxwFbhQ+ywdo+qou2K9+N9WABAAAntVLMSLkCeqGAXgbaZj8WLvGJhoKfjGI40EnMYJh47Ym7TN3dftrlPlMvTSzFmIwSmhGHSZOwiTR1OZ6YFWZSy5YFpjtMAVA8KmSt8Ubm6afQ40ZkXKbxYCVqPWV7L/ZA/N5mMqjjcXBk8DSmt2XN1giNvVMNwdKX7lV6zDrcZbDLBIGdXbxztPvDvN3K+V2rd3hLpZnA0RpYo5913JS/nz09SaqRa1GKagvQ/M0dBlem5uy6lSFVpVbrWc7VWpfj0OzbWJQ+k3tqUsv41O3ITrV3Cn7fxvVeZaypqsZl9qny+Ht4cppuf7cpae/zk1YkWeGWXd591zO59zuf6zqYY/yvRfzdyvlZnN5Zz2f41cK2scbuX1LWse4VAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAFXm9JoDlrcRQSCSQPWW4Zvc8ghGntw/tIJNA84bgIggAAbchyZhAAdWmxvVLsNLsuiEwojN4NVcDxMWiEhzjOUpw5bzzzx1MxKGdV8KWpT0ne3Z6m7U3bq1K1YpF8fgWgZYScL+apGI7EC8maljGZKsyNFNbNNUpdmSB48iThyFM4QiSWiam7I/dp216aDppqUo3TOoMZk92SUzoOm1NkVXQQNzjPVXMVmpmjSRPIOZsntZX/pqTTrbdW6JjdoW9SaW6lxd3G/uQtsEAAAZn6xz2cHpUrPRFdSyDnqY0Im48HM7PPQ+NaICBRayPO08rdYEryrGZpr3z76uMqqhU7LI35dirSQO/NKw+y9b1uXFXddBOJ21Z0ry0QihCPxCCXhYy/klUye5g8tiDiSyKzreZNYgqNZXYJgN7ZdF4eg2GnK1XlVaNMJ5EGsunB12vS461nyza3jdw/OvdjtyilUuwo7Uw6cQv7qYSmWV5uW0dNnSU+qDtiinKSxC88bXc6WvhyzLnolL85Mjdd852frZ8q46jGdzmp3+VPrapa28bNNnu3a/PeHMMb2OFNcyx3c5b3jzPm6Pf61eu5WeZ7r4d3jb3jWvfQ1eY5Rm1yjsYbr4Z2scdcq6/VTmNYMEAAAelyct16HgN8YxMQjDbOnGaOisioZ0mC75KEfldczA0QtUspj2Vu3lTYy+Zwc6VQqDs4ChczLqa3KLDvV6ObeSQvENg91OQ5BDiH88VDbiqOw5QoTQxK1zW2x5X31En08VS84asxanYpTiVK2yPaemN/+uffXrTO6Y1mk8JhiRPEfYors2pbOM/4treos0KL48XFq7paJCirvbHX2f6u473/vOLY17Vx/E1Fi/GPrO7Z/9sbzn/6izCMVRrQaUxLg8dWWU8ekU9RQICAEAAD6/U1vIKa1l2N9gJ1pSjWDW0MRCYf0JaEiYpof1QwzCLE9SUNLUtdVQYxAKgUx2GJI9FDFa1qKwTQM/d1trqoFvwQzRKlH4UMLHDgqZT1Iwt2ZDcZbAsfsbuY6mcpXhN1cLGcYsSizRWJRdiGMtgbT01KGC7evw/9Z4at039wwt5ZSvsSvY5RGQxKX0NJRxufnZ6ZmMO7td1W7Lq2pdFMcsMd5z/1K01uNOlA8PQBTXI1hqiuVbtLjvec13Pe/zxlu60pvfK7dm1P8wyucwwu/9rXMrF/HmOfLlnuv3nhhv/5vW965hzVjHuf/9Xf49/W8vw7+8Nb+r/bVKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABxdwRyDae3LX0ClUDw9uVWFzIoHlbdRZRKQQPWG5BIAAAH707K1HZMCQUm9Dzaf59GxFu7ok2IAAaWOt1F9xpEpQHC5Ff04715+ZTDle1e3Mx54VbIekLqxPssgthj2RKvD0eib9QFA0rY5A+IawS8jSFknJdcz2RQXUqeaVh4/gHXpkezQoVoTyeLlXLZvLUba+3bZo5G3x35jzvo2v//eZtz82rEm3ErR3M8YrXbY8Nwbo+8xqK7cfOqXriSIvbQ7V2rVdesDSkgx2ZRzPIW4Gcbjx65+N6zS9/ifcOl4Gq4zfed7g01LSt+grGM+1a5n/TSkt8UrB9F+hZ7r4KAv8hAAA00ikp+GN0q8+zlQQ3AyVSQrtmtDOxoKYaacVl9W3OfG8LdFewhiPv8z+PwZd7S4TVZ/a1M3PJw5Vfrv/B8BmwWAR84xPhXVwqJ3OtVY3n4rGRxj71Pi0bNU035XsxnVnW2u0W0dsdqatoW8V/z7/21ncm9b8skV8wzR40bVX9GTU+m22ra1m3zWHtej1mxim/mFBbW5IPFUrWhsnifXzabW83l1rPtnxvWbXn1jN85xqsXWd13v4iwL/43vF/r7rjNM2zu2t21C2blJCfoIuK/6a9VBAAAAD5y1G8EBAAuhik5epKdkjLaEqBGhQQxGcQZsUNInfO260h1llu3nUr0Mqljn0tHIJJWo6CUfbu0/K8jyuyeG0rBVQlkcdbWEk1OLDrRSL1HDpOrnl4ajLXNzh4lGzj5sTSQUDaObKHIV3/9MUdPNt5hyzn27hjjzdh5z+rmobdPY6d7O28ubyRCp0bziJ42p7B76ILgNJBL5M4LmWGZhfHf5BlOu2qLtgEgADhKankRoygqKG6sxS5oeDIkteBQoUBgLYeXYaMemMn1EpfMK7Z3IFlSG5IZ6ac5W1kwVEt4piyyBpY72cXeWdiDXZG4ay1mrTXqx13VFmAEIS5hClPsOBOR5iCljcEZJnF0mz6a2qg8cBR25dnOzlaGovRsRq50czFaSipG9TraU+7uWI5es63hvDHXKkzVyrZXqm6e9ep4i7bzQxMQxTUcQf2jjV2auSCnl9zVapynu156Honjz9WNZ160BSqSzLJmyP3Vi/6k2sdV6XeGohSZ4XO42uWaWb5OxWQZfYtYV6tuesZZ7ytW69q3Yv7/7NH+Fb+2s63Mt3b9ve8dVa3caGgpt9r5dyyqY41Y4bjCdiDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAamaEchGnty/TGJJA84blh9dRyEZe3cb0gj0C1hugyAAAB9vdmObbQEJglpYbkT6RVkLkx8tMAUwJMmRoGxcgEuXFZbZk8qb+kjs7X+1lBNLEINYe1xp0lkUnjrsXJZctUlqQx2LUE5JYiuUdgNSfhchwk9kdotMw2Jba4UBtW6xZZ/WBiK4v9IanYrJR7BsmEKN5OHlRg3aHj//1q+g6xJi2I+aTXmlew4edQJaQJoDyDS2b+fFpo12+Cz4e+u/bMt4DJtmjsUrFiJTXpTHz8X/3S1sfTkUuUstUlju1r0/ts/8D+bbJteuZYsbr/+GwlcJFIYAAHsr3O3VXC6nbWGMdT1YS2AyAAhw79DWLTEGB1pvjB8skr4S2nnrX6kT2xWCUvV4tMgy3YkEhhOEakzcolA7dnRvqV06s0ciEqHGruYu0n6Rt4XE409tuBrUdwbWmj78395238hE7EYzN2JdKLk9bjMERqZa3KbO6Dmdr/x7zt7fdd1lXr9uWaCUTedPPzueNNR081erdrUVffMtYxqrqdwtZZ2bvL+XNfflcvdmR4yyxMYclszMUcssW+flr8P3rCg1qVaqTlmzZv52LdjPvcd7uas7t5953LHm72Xfzy3+X9u/3f7wpstfh/Oaxt8/WH9t8/XK343KgIIAAAA+l1XTRglDRNaffV4m/pkiUTxkUBXB1Zpfl8AYNTpzV60gl8rmZTvtfd/CH6aIwXNWJx2a9btPhWyjcB2YOygO3IZkaHEBPWT6WMaE+aVWnY8CHtha0CrVT6Wkra+Yytnev4jyDek71iam5knkri+fr4zqDatv/TW/ChRoThXUz2/1JLAvWL8/xs5krDUuoWv62xjcXUikYMSOL91z8xCqT2ay0SvQvgWeFwgDGjYHnuv/vJ/um7bye//ye7/+/3wEggAAcrMIZnuEAT65elbvvG7pe1wCBEaYGdiOb0gZoEkUIATBmntzcF+JbIn7sZ0sce9l7xGBAu4+rT3IgZucXcKB5+ML5fyG5exJ/nChMPuMh8mIY3JUAKaajQperBL21dx75WztdEEv5KoBm6eQ1pt+KTGdYdKG5Ow+GcKjcWnnnZNTq1y+Tx3PLKW/rvMsLPLmVFrCYvZ1IxNQxHpPBDCdRPkul2cCyu1fryTGXWsNWHpqcYc+8siWNjec5apa0Xyfuy2la1RWmo65P4UE1Y1hTWZn6XVu1WyosYK1epaXCnwprWWNbkt5vCrS8qV6mVupqvPZUnM+52MOc7ll/LVvO/nln/Lkz3Gr3uP83atcyn/1rv9uay3cyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGWF1GoNl7cxRyCPQPWG4X0XkaA2ntxG5II5A9YboAgAAAf0zPcR3TANKqP7EMrMSHQl5vECGTCkCrh7cHMykUgNZTCa2T+W4fysz9LRPqwmB5FYwzhUVlFupBVPnqlp3Ke3nexE01dsXgO03SFNKqTTU5J1Xx2uKumYtzZF1Azml4zk37pFhPVazOMN4o2xgVdYGaXxv//eaU+q5z6XjW1Aj5gv4GJnB7a9q21TMTOt03O2siTlkkz7Vw/pjTexOcJ/OvvjI+mJEyf7lBiNE5vZJBHy/rWZd3/vn/eXyXxbk81a/W90vzwgyEAAB8sRTFTB3C5VpNNvxEX6jipE9DRJTUhT5UjFkx4eMjXNxdCmpoDh2tS36aLxVOVeSWKFKYELjLKY48Td2wRuAqdynMj8HULIH4ZLA6m4EUFTloi8LOIep4aibOnITfZpLZt/KbOB4Q+mVHS14K5P3Zh45ZRSmTRuHaVfD1vjDUKzwlF3mescO81qtazuSj69qQ3aevL5+Bn5mZn53CGeP3HqCZlNNN46sUPZVWrw7IMa17dD2lx1YjuVxxobYO+jD6CkqcmN1Mpbe7v6fKzXxq1ZdO4WqlPYvVKWzd7jhjQZdw33mWO6tLvPW7He/W5/46wt4Z3f/f47s0vf+7T81l3PnKmGeOWHL9TnL9mtzO5n/2a3hFmMBkmryqUU8/XiwkFMEFUIVnJahp2ZlwY8FDgcvmZ6BIlamsvv53asTijtuXUnpiDKSYgOpIJdq1QUcC9l+phrJ8PMnQgyMYXa3DhRV3ZxzAbGZhjvN0z3j2aLNuPKyxLSxKqyd0lV/brT2n//9fePXP+Mw71jR5HstsQa0tFk0/x4tJ/XWLse+xV3fVaWveW2Ir+akCBl9CzMOJoFi5oMQ4wPKDLFwSG5d7XsGsOnb71ahVS2inat02WAAAAMmt4b8cS4DchDtWIW0RP2JvAWGBtRgCnGCykDgmOgp/jDrgwM9Tvyudyinb02wFORkzRpRG526yZkcpZPPs+fSDYDT0gVZbEEmUclXLUUHEbjaoZuGJjDuxqHGqvtxTN64OiEDt2hqN3JBfgaMq0wU3kBww5szWf6VxVyrDpsAg9qNrm6flTLv97Xu5ctZ3rGGNqGqexGpZMySHbc5hSVHxvVopT0FLTym1KqtPUuS3laOTstsXuV4n+dWn3JlpwFE78xNz96zLY9botY4yLvMq++VrPabKNV86C1S1N0O8K9+llu6a5ulpcMqelz3Xyq3/7u/vGxW/LK7ev91u181Ku47xv0mpurv+fyrfwv445a1ll+q1e8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABYlcxyB5e3ETEajkC1huVkF3GoNl7cRTSCOQXWG4DBIAAHsm3W2MBFgFBSyvGUPvAd9VZQ0xhzOGOlIaLCgKUjX5NS5ZUd7W7+XLMcrYv1LLPZHPTUFzuF+tyYl+85yrTK07S3JkkyKQuJ3GtGuLJFvAmRUrU9h53Z3jUj94rXud7x7drn3Kp4dt6///xiBbX+fTPt4TzTZ/7O4+Ytq6tjdP9Zrjw8f23//n7kxez1rw4IDQHelyzoaaJDhoRpQkVZWaKPUN1vyOyypWrzzEBkAAADWDucaCDPNyRTs802IRBzlDAqTDqxUUGrkFszEFSqMXy16QR91qjLL8opOs2ovmEy0XW4PjGPiXa7j1KKGH2XglVadNCUim2FqqKZ9i0ZUUPpOxGXt1fSWQ+472sydmOXJyZzyvaiVdpt7Oy7btceqPTVM3K0/GoaaY6cHXbNX97/vNZZ1q290+XKKIw5NO1T1HCfy/TXqluSwbFJHTxKQZzc7qrqzjS95cl2NyzHLe7Fy1UsymCnXc+ljsljFfV+alc523jdxldWrzmF2m1ayn5RGMqlPQXb27W6S5cr0vfu4zVPP2MatrPlzW6Sx2c1U1ZzpOb/dnUts63Uy7lb3llY5y7jR3MPpaXm7iwPOGAgAAP/XxHdo6AI9Cvehrb8yGINbZcIzF7kCwWSMKJ5JS7U/ljIK1vOl52thUh5p1PRdlj7wH2M5fOx7tNXr269SPK4iBkIQpkPPp++hH/Vzu2u5JFzFht165va242LtuZsxPbDtOrSOd0vA/3j/4+vm2tW1rdKYvqkZ/5d434ETcG1d6p9/EmmNtvn5+M51bW9z01GtXMmxFcNNEG7RcOiqosVSbuQ/dTvN02epK9Fz1BEEAADosrrQJB0ByWqnYhQw9Swaga3YAkgrBDvpuCZhAC52SP9Ss6lD7NLi1Naicmkq0WYoJlJS1jMDT8YpZp2IjOLIaw2JpS35tjDNoIXyo62QVGuUqlcuExl5YGh9cMFOjab6R2I1T00fiM1YsVpVGHwfaTxt3KbsAy26/zPVMWmZy+X0+POf+ruW8LWOu455Y1prORV6bcNSmml1S+4MHOzSXZTH8a9mm3nW1D/JLBEalHZZNb7272mrWXaiUfh9wqKMyybor2Oorlbuyrn1O44XcMq3aZ35Rhnhexq3eWrMd3U5lveVNXkOdJ923WpebzrZ93U7v8v1l++X8vwuf3GZq8v4by3co7m8cdfjr+6v6rAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAfai0aAuMNy6VDo4AsxblzKJRwB5k3LX8SjgCw9uem7NEBgaCm1ZgKmhuKLFhLkkxEbSigJ7FhaKvmLuxOvfA7hW43VlFm03SXNdetijwyqlyk7lxtRijbJZgWC36g9u2O2srtaEPGFsMOLZx6Hn5yfV6K0DRt/JfJXwnLvJb8xRUFDEpyg+1SPJUwpqW5HY5PyyWQ9jL7mWX/veqTVq53PDLKfsVpVT6+nj89nPYZxaCaeplyx92PYbqY7v2dXakNWfys/arZRSY7ORmJTOW8ruV25jP1v1fvXNVMscuYas58uYY37VrLXM+8x7e3X1nha5OV8d455d1zLlvust4byw3rOxhvePd95jnu3jZx7ds91lc1L0NIwu9GayDCDEs3rE3Ru1ADzxU1ZQFkdsglSbgkOJgN7L5XOWIZqcyq828cmhT1Ou+l2XP4/0xWY/FHpmoPoIi9rwzleVDPFoLnQG+RAQYTZUImYjlD5MR2joIuxME2ssOVkimbFNAnUimRU4blY6bHisiQImDEzLw0TMwv1VvLt0E0aDmJqTDLKhw1TQRLpIkogyaRvc66jr0TYsmZmRGks+s1Ws3dMmykYmRo5qba0jVaC0Uk1ma3pumkx8popsamqN0GmSKVBFAzNUiucUpJBFNbouzLXTVdSdNalOuyaSCkEjZLj5qx3y1RfubjS5mFC2l/tZ5Ylbj0IiQe0BFiY4KAoWqkf6s7cMXrHLV5+bMsoYOnl5v3EJVeqRyXOA59RxYm7sy+u7rNnudgOGHwiOwEwFzodCPZFjxoR5mUSwXBwkOOEQJs3IgbImxUJgd5PE+XiaPLMCdMaBsaoGwuE3MC4kktP2OKoprUszRMSygWESgopENJ26CyXJ4njIrE6kkXmTpImDFxTGpgtBmUtIzSPEWLgyUyps6nOIlx0y4dWzJMgpNJjqzFz5k5ggpNBUyeoyVUtrMki99dCtq3SZ3ukl1dFaaJ1nRm/xnRfFDelTH5FEn1LKXsuszT8OOOlB6CYhg8AitbAp3Nu0Tr1ssMdRq1T8hcnfiUQ3JZuJXYpMyGlcp6KOmj09kvV/H/D4E+MYOUTYgChRsGy4bLQ46WZe5UbE3azjPdYcXB61uT5rfQNw3qmhJFCo1bw74//+L/HpiuHmLN0Nts3xFK+fU72+nsWWZmmg1t9Z7X2vUfNr3vPXVYETDjOdNm2BTfr82h6w/k+9/d64rTFpNVg6h3zS/zLEzXNfn78bft/r+mN4t9f5vrX1Wv38+2d+lpM6x4j/OlYGqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHQZBGgFp7cOnSCNALL24byj8cAuYtw7lH40AtRbj0kUjqJYDe/Lt27dCyiHlLkYzNAyZEdZeZRGAiSCd5qSWxSV4Z6uSfkhoX1VVFAUCySW2JdEK7hUc3i3CcqS+VNxYhPukPlDxLi/ADAPgZz6yFLy7gmAr9trdAViQgt154T5TP6QY7cy4gtceAp7OaWMzEOa27xt/41TNsQ65rist4TZEjKxVRKagQa6WFNGq4S39r0m7ySSG917W1X7lzTcY3UGsGu5VmpjcDGK4+JNV+N1kjy3hQN5z94rndMt9vTN74zEtX7x61znNN6xekfUCJqlvqTPz739s71jO/u9ae33W/xnHjfOxtjHHX56a7LoIh1Zo8M5R0hoYCJw0VFYAMJJ7tBPztqAqlWxjTzVdkRfd1ozcfqSxGURWHK1pw5FEZbNukyuBJkfSNNQmgm4QscLqKhKrRSHK1CKJ6HCcoLMxxJnr1StT/em1XUnYmW56NzxCSzgwHkmtV1nWbZ+NwMfdbQIjap4b1naGarXmsz6dW1eOcJ5es24+H9Yb+PqWLB3bOoEK1Yh7JRaQEV3vOqw/W0HN8z23XVpZrYla6Yx4ubY1ezZW16Ux8R4u/qv3C+PnW76y83LHzeutw6fHxT5tTeaa+sb39Z/pm/vqL9iu+gYHm5hLr9A8bms1WiiSZ5ocScdQVOSxc6JStpEptU1NlTa3lDF6MPqgSf95JqlmZ6tbp4z2lkEAyekazB9OSIp4ngRiCCBnAzRFVjlD7IGKVGsOxazc3J2Tx8xVRPHS+YF4h6JsaHTUssYrTHGTLl4mEm6TO2gupBkTBJmK60jEsmpxkjAqGCJWddaS5os+jc0TZSC1051FMskmxJkeYEmdUgzlxI6tFbU1s6KKzRS2NDxm6ak7s9lmrLUtadJa9SbM1a6kWVLDLTUySK9aSmT0HoVrppIourrUbfVrtK0TcmOWqCnXsnOoAhLHVARYJ5Crlds3twA4dybpc6LGzni+8+/bVB4NDkLlsNzM5AcCxmHpzCNwFe6y5zYyLmF4GeiOAH0NFTK5gL0cgcgXEQEbRuUEi6XjUipOnEUTctnDRMiJGHyoswK5NF0oDkEQGQIks6UzVJd12rTOnE6Z9JNaZPkgo0QOOYqWRc+X0i0amSBsYqQN0jyWfUfpvUpE4YHCgRBIgg+i+RA4fL80L6JkgkrQU7KUZFuk59MwoWdnqebOcRnFLMVIVLZN3WpVaj60im6lIn0VKVUy3QrTamylMpkjKtTrUs8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAABe9dRSEaY3b9kWjUGzhuVjFxFILlbcP5xWNQPWG5BAAAAH8WfaxlOIQKuu7bdc5ppLdIUPBxweDFBl1ZXyMkPDk7I3dsQxH5fKKWl1vDOXRF/5dLYU9Emr2H+llfVFd+U2bM1IrWZ8TwMHZOBuRXFFCqVW4C9RM9CdVUzOfV/E1Yy41NNcoWqDglXRLaUr2XmZvu5brTv+3rcaiaMTan7eJtyt6X2/90zMywsranTNtnuhhWHbb3OeFtLREKpAlgWip3nruRFybv+t39/7eunVNdP/uN7X8v/v22uCImAAD+sZkrfbTAG5jyMwZUsP+tUQnAlAEnHYcU60SwKoMXiizlWJJTz2F6kpJ601oYHetzn2f10c4VJYVGIanqGXui83pXpdrlS+gFfoiWqZdzhupZwYdKYtIKfF8Lssk9SxD0su8xgWX7ic7HLUhrRPKg5OVcuRCalf8wz7vmW8P7au85rO/QX96gWXzPxGcxuVMewPOzdjV/K/h2tfpMO2J3cMVuVPy5+G6OWVa1M+9BKq+E5rVHZlFb/tc7jzPCvu1qP5Wr3Ketjux/402OVu7rPG5dwpcssr+td5uprHl7PXf7jlWw3hc1vX4ay5zeWfdau4d7V0CU1mZAoAAADR7its4WOFJh9t7iMw6smL4SciVOm8ZnBBidyCzXb9Nf3KbVjVPZs1ZqSsxpIbl1I8Ew79/s3hLZVHH5mMn6l9Qfx/AdALE8PQJNGR1JVOSk3LTI4RJcd0nPSTVo+WvPlK59BFAdo4H8Egta1zP/m+2sr6hupZIdBykUu1rdScshj/qqbLSWaM2x/E0kcimNld4MFlredzhAF1HwiWQPPDi1gbrVva5fdaZ9nF8mKiAAAPTSUW/RLRMNUczL3pYdEVkmBDF+jV01+GcAExBbz+R6aj72TdXnLGM+2DNrUJh6duOlIZiB5t7nclEA0fKKpPvbA1tb6K7QHCa2VCqYxLCGL0QeGGG6thg25jAj2w/yE1KkRvUkqop+UyiQ0NFL5uUxpo8jaf38dbxy3//nvHeW8b+FuzP3pjG1QZRfdjLWVR5tWLuMzJssrGsLVW72rPXpJSWa/f5nncvxp6a0Fxty7s5Zqy/Cnt2bvM+Zd/X541+8t2qKxhnRW981zC1fzv3t2u5/y7lzeO/w/LWGvuY4WcanNd/XM/53l3dvC3nhO77fq6zxvpkg2ChAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABytzQ6Eaw3D7kgjEDy9uGdWlEATqTcvcxaNQbOG7AIQAAH8VAuc7EwIwSNPSiQYOK+yO8oZeXZMSvOnoOeMN2PYOQBZbIW4OtD1W5OVL/0komWtKhxgSkfWK/LITI49m8UViS7MrVFAzVIdR1Coh0UsUDbPnOUkHSqIX3/t7kGcRjU5eoKlSvjclXZXynrTFiVVoVLmeUsvnorTWN577z//lbO1u5/ec/lPYobNa7HMpXjOXpZQY3amNW3vdbf7wqVL0uy3hlYy/Pm+6r3I7QY67hhXw3jlvDfNa/fd71/atrDuO8cMP/+71lhv8f/V8FlGQzeQyyp0cguCbrEh6ZaKxUgIgQAAPrG6Me6BgB8pZSYxx92aRBIYDEjJ4LhPHMwQ2VyiDmXw9EaeCaDcknbje1ohGVYHUf2eiLoU03J311KX8mF5SaW07EYFbFOLuwA8i1F8JmPOZUn65Eq2qnNJKayvN8qmthUmHJZex57K1cIa0KZ8dD2G9KEp1ygG2PXFsYt818usxM1iP1awSQXNviKI/HrXApBYoLU/fOUjdeLCf1jW6oX77prWnLcft0jTCRbgp08u4sWHiA4yqia2tanw2YreZ5BhOEN5mbOYGqWj2f6zuf6tSdy+teSkOuMfN42pr57ytMa9vF+PGzBxGzNndc23iLX+/prVcSf+5VDIbqYARWTXZVNR9w5BGl8gIkTHzMljxCFgQE4RUnIc+UzFPYoq2OPLFH2HWLN5HZc9FLBcWll63RzGE7Ac7S1ntggkiuJkG4CCRETMvIMXB1EMMDY1UaFshCqSzMyJxA3LZeTOLNTIrmBiXC+UCKDHjklY3MTidv2PUWrTUmYoFQ2SNXOmKnTPF11oLMjqaSnqqQKyyZTWdQZkEFIl00NzhAUDIpprNmSWzKd/6jGmboGRtW/RslgIdlHYtrV6H/oWb8n5gzvJ3m/7f0IggAAf1j48T3sW5dTKpEaX2ttlVEF1hQAhNE1h4AoQcWiiz/PlE7NLLqmFaFQG0+yvaMtpM3bcdp8pNaikPypZbIaeXQInDEmlQKsYQqFAoEmBU/ItF6kud+SyGRxm/I4GahdncsbmXZVNfzGGdXaeN5z0OuG8L1xTPHV23v/73etcu5csXsKa3lnZiePYhfysa1yzlVt7tXdZ5T1Wkrbptz1Xd7tzLW9THcpJnBVydhON/OxvVq9ewq/3eWHMs9Ve1saCYo97q7v/++/n2xl3e929/jrePbvMeY1O/zPf/j3f6/dfHuevywy/C5zX5ax3X45NGaRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAfnh0UAesNy6hDosAsybl2WLRYC6k3LlUSiwC1JufvDoO/QBC3yW0ubIlZlzp6CBEaAmY0sd1oDHIJHl/4rAMB2XTlkEZ6tZbgN9XQSOZdQvVNy+hqNKh1pEtgJlssjsMxqIO63F53ESIaCJwLMqDQLhDDzzU1LcX8v0+6CWRyHJ6R0lZt9UNeZhm/K41f5+M+8bgwiWTe4n/2P7/7v7yv1fwwr8ktDS1aDc3SwRWlFNhWg6NZYTsopfpsd7npXU3jJeyy7yhrb7vcz8ORt+3ZhmrdjFJlSYcms6/1qLCzu5nZqXL/L1qvMW8Mb1afx7Uwqfhcz7+O8uYY59x1Ux7lz99x73ms/5+8+5c/HCzrGv9argKUnCPnKQ4HtUFeGId6WhpLc9N1KNVoEEGRDP/PykxRC3BeCeaVBVp/J6A5r8c78xAUTLmztRst+QapYrKnDl0pd6XxOaf2G41iNkewsPKwIzDVQlo4kiyQRRdLxfL54pG5FzMjy2iaGaY7Ei4YHiLLJguoGJmXydF0LwW8vHGNEabtftUpNzBywgpRNqJwmiVWTaNEkjGmWym8xPpGRqXDM4bGB1NTmRdspSSZFygOwc4gSBgVzc6mnMWQrN3dSKkk02c3RQLJ5anOnnRM0ztNaCN1LWtkGSpuyJ+qkyCS1X0GR0nPoupkTJM54wX9mcI/sUymYPiIaTZlUimYhMRiohmYkIkyaosA2AgUFZ8vBKoa1OS/Vuzdvdtz70tFjj1yyH5RWlcXxl9NOx2duNfabpPjcbEjKwBlglYbIJuE5GyyZI4bZcF4PscwqnSqUS+RNAkluxPGReIoTRMnCTUdUfJsuEHHQOQRIki+cdrrWtjJ3UpJSJuyZVMDEupEy7nCfZRkSZgkcLZ9zhkbsZomDVpJGSzxQSRus1MC6SxfLCzJE0mCmRPJJLUhQSVap0SwykjJNJaSaKp4vMmipNT1G6aaN29LTW6bGTPrWtJqbrTSqW9JI0QTY1/R0JW+8vDgJkpKssmJTJ3ntt4gyLNTHxwMjNkHVwnfKM41lFMqS3MX8YpRQU3SNTU/RVsYas4w5Q24CleNlxqVPuRUgvBzAF2ArABJh/RsGpaIsTYwS+M6Q4i5uZE+ShYIoiVLJl0ol0mzEpFElkSgboECI0ZgXGR5ASRQRSSU1VNaLI2TdnQLyKRksmi6gdJxNAzJYvsmgazqLJnHXZMuHSityyYpWQNjdySLhmeMUnWWUaTsigtNnRtrZI6ktZdQRooJNSLtSS2W1ZcUglRdbaNBlNcxdtI5RezKQRWtS3RRN07Hcr4rsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAFwlzEINl7dQqSCKQbOG6WFXsQg+HtxHJH4hCN4bgEgAAAfuY+qrfiRAbNp2IZo5Zcg1PV2zFoPRU0xgN4At2nN+6UNxKPw9ZldLnP41YlBlPucemZjduUxSMx6kzwpIIkufIekTtnu/FcKVDxblzCjVjVlhx3V+yZnTFo1vjbhTLjWet7xH8VjbVap3ube9v//rGdYxfHxilmrVdVzPbG62h11bGIOab3jGfmBbVsU1euMa94GqYxqWpE4JSc816yqDIMkB62jS7Hw20W8AuvVU5vPfmKgSCAAB/beZq3dqMFWqF9JDMuE15ty3ZiXGokcox8YmqqhJXu4j/2X+iUcfugksUu2XUZy+yaLRnsf+g3BT8u84j+x+IxKOvTArgQ9KGNrtTPLe2lBCjW4xjDzOXEbMyZiGty2VOzPQTA0qxvRaWSn87sonpHEs7UMzLpsGXZMxiEagy1f1/56udzzx/m/yxoYlQXKOvYqwDf7z6J4rUszq6o9/evSq9cpu5allTHOVUl7HVaP0N6AJTBUsp6sdmL+NbeNrVa3fme41v7vKkr27tJd73VvWX44Yy/6lz95Zd5b/LX9x1rLVTXNZ36fPLnab8M94Y7xzqfb3nXr4YZ1MdWOZfj9jmG7m6QEAAAAaOtbLJg6B4Lsbb/wHAzRltuWCAhyQz4q9EIEKLjuQ/MYxoabGmvb1rVFn7hvBhQQ5N/DdPV5jTUsc3jXqy+UqNXF+IkDTI0pnOZmgwIULHjy7eqzDlumvu9IEe0fMOjlFcm6CpspKPDxCt//8Y+P/9a/3itM0tExGzjG6b1EvGxi/+t5+/a+s4/p97zP85pjE2/Eqs6DBuhZE8gucY8qp6Hlgmw7Xr1Ub6ojv0ggEAAD65tpTQoFAwOonJpXBEqZ23B1y5ANFgKRmIWoudGvB5QZx9dtqCYHcB832s7gXtK9ylazEfkrFcwI6WLpzvGU0UGO66LiRbS0GqRmRL0SHBgkwx0wXKX9dl+X3QnQ267qsNeGJ3JHF34mJVVnZyIwiGJyL2n4u54udJqeB1OoagdlrhPZIOz397/eZZWss5uW4Xp2lkmURgp3YrAFWKV5uk3flVuF5vrXj2H42MM59984di+cs+12cs3tROpOU1HAreTb6PtD93Uj7ZnLdFKbMu32k1ezpaTPtnGFV61+rjarXrVzHHHWdeX4ZY1L9+mpsPzz5jZ5h93nb3Mr2Xakqr5UO8tav1am9ar0mPM97r2Lmt1M+5dzkoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAACA+NRAEaw3LrkKiQDzFuXNIfEgFp7cvFRqIAjL25+Wa7OH8IWAyvp5a+rJIAaWpSSh0EoZiPtEN0TMCOZqjTZtS1/61l7pXnf/OQMtZK2ZmbVK29xZtWeKumLLP2g2oChpfCXCzqRZCXoIWIiDQR44kGXTeDs1Hzf1+oauWaaRvLLuSbtHWs0UH27Elqv9A0VhqKyySMzeKkkdm3Yn/7/8z/8N5/zPDWdeg1Wl0leCgt5WL16SW34vT1/K1hdwvWNV8OQZjD/MO85lnnXq1Ze8Mf1hDD6TUnxtdsTGFStzC7q3d7rHHLDlPXp90GdHnfy+5b7zDX9/eGet49rYW7P4axxzr565qpe7j3D+cz/Xcfzq0/bOHN/v+Z/r87jZMT5c0EGSwE6y6U5YSSmomDNyFWj6HWqVzBzrD2hwROalGqzZqDln8p+TteuxVnuEruQzRvi8tL7dHmisExlmbF2o9EIwbSC6oCPEmBkFLGpFDouY3GiMsakVKLrKhEjqivPEybGxCHC+YF4gI7T5OpFUlRjBnyZcvGh1D7KpnGc+hOqNDqZiTpKDXWx03SNyNLg57sampqpJaR83LlEf5MJqQSSZBRxzYnCUIxM4QMgZ08kazY6tMuump0DjJpJLdIuGCBwxUaoHmc6zJpp9ToL2XQNnTpKOIILSrdkmTu6FbKoGQCNSczcPQust0COfaFDgADqYxsw/KGGMPReMOVCgg870w4UBDmcFto3Km7Q5WgOzZyz7CYebZ1GTQxGbeUSpobaM807F4btUFay3JKVizc1SKaOgMoXAFEkcy0QShpHWUBGgUZYKhlrFquVzTzqVgWqXiK+VfORG1hx2eDE3fWdfVPr6tXzVphvpOqoqqXceaHajYqqZblbeNNmHJNWRq9nBypbUHUHONP5VK3qRYcLQ8ViLNdWh4zCpJTFt+8tqUj6tHiRqyW3nFrVxDm38QrPq+2cUj/eM0rb6r97j5vemY3/g/Fs3+7zZeSCcZt0fezQf3uBhNdnn7jV6Coedpi5hUApc6FyiIOXWDRPhy/bj87MSOfvYXoelrUXPTpe+RulGXRlsYbrLJe/mECtjlOTMUpGOrIWgXQm4SAE8D5Q6O8bjxUTWxpc1nUPKfyqnzZHnXC9H3IfynWLwrpCArjTS7HI8VjVamPjeL3+L21bE8+drhvirMZKtky1EljyqmFZtV00We0ks8Jvg/UZ5fXhbtjO2zCmbFGa6vi53baqhRtPM4ruDfOsekj3dnlpmR/Ndvi6xf1t4E9fqDFZbZrjMeJvWcXxX7t8eJ4GL21X+2s6xE3TEb5zu14NvCw10uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeHkESAWotw6nHogB9Pbl5aPRAB7k3LhseiQF1JuezMNwhziS14bk8zDlZrzSWfmIEmRJnWNkTsyh8MHuu/com4Hjdq1lQ2a1G7celzY5RHJLDczepW/itHFV81LLKJa7dhoD0B+oWrBDCJhbAL6B+g7DMkBOJPEFKBHk0TJdMCHnCofKx01IOoispk8XjYum6ZmShoLiH5Ac8iZNHUTSm/VpJWQY+kUrF5Mny6YD7SMEDzl4zUXTc2TKC1HE3RW7JpIqdbpmtTKKpOlwbhqQtFE6sySSN0XUpNnMkUmOmlaSlIIILdKbJJmKJxRqpGyKZ9abnnRWitJ0e6aK0NFKgzrz1nNFrdJVdGqqjmZk3o7O7wqKSBSkgyTakVpqSRS/RJedI0Z9EakAbcspapldu5OpLZ2rjctbnXAlkZbsw2Zj1BZl9Z3JFLYGX1E67ly5yIuzebCBAsAFEygA+A1iRmXZRmMrS5VPSCxH8zp75grMB8qIKeqwIa2zKKSFMucI0oWNOK1Q58fOtb+q79a7vfM3bbVa48R8/PTEPOXjDA8KaK6a4XliZpiSWBW0ObGtPq3tDcnbme7ElfPiT1rmJv58Teqxq7hT7xn13fNqV1NXEK0Osa9v7QJsUrvVqWxWtvf6xbGf913D+qZ8/vqf4x7/6+c/Pt/An8ybKoTGIcX35yxjSyFG9tRkOFBg0eCCJMw8iRAZI8s9DMPRexjrUh7DNPDF2TLRbnIKkOxShrxi/hMOxyVTU3DryR0mQv+I+AIsGuBlkskRNRzkBxC5zUcgmiMJomRxG8zLZsRYjSRL5bJ0nTi2L54wLxTIqUiXImM0bpl03Wl60Mz3TY0ZNRSN0CaTIAWzqSBcJEvqJ41TLx4umqkZdUZllA8gaJHTjoutExSJ4gBOEOLpfMll1KZlg+zzZkk2Wio6ZpWOpmKi+kmkmzG00Uhdbs5kgvdepSlucmi3SRaugkbrnElrUbKp3SNF2oGPd1GMT3QgoWRwIiTcfp8aSJs6XksKSjTJgwZ5MCWNAHQjk9rOGp2MW7Ofz2oamI1JMWHO5F6Cm1evUOOcvjeNy7g7Tnu0TAfoMgAmgQeITEwT6i6Xh2kUI4csxOmpNDMlwsnC0iXTheUaGxsdY3NFqc4QInVmhBTU8kgg3qTZlLsyndF1omZMnCfLRxNNMnjQ1J0yUxsXkqnNjNAwummipNkmpGSJESLkmUUjyaknc4dRepkkVJ0kUjiakkklLOGNlU0UE0U2ZV2WmrZWtlqQWmb7JVKrZBSltUyK3ZTIpq6aXZlmVIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHYYZEALqTctCQuJALMm4dBikOBGXtyxq4okAsvbnzOUPTuEyuarSYSqnxoIwyBKQacmGVlJkqGwMVQzanHnZaG8k29lPUzuYReHoFEYhf8RlduzHqSeeGK1Wx7oovII9QPu8YhUUmLeAvgcWLLEISGpl2ajmEDIqMaTJkOePo+Xi8VpgaFcrHiOK54sFgvGRHrLZbJ8ZUvECTRWpNtqnUigkmkmhppJpJnyyXysyBoZF8iJTN0zQumiDT7GyaZWI48ynOqKiKKzBRkR6yCE2TxwvLLxVRY+bINdJmuzLNja50xN1JmbqQpF9FFnrW6CK3dlJLW920Faa031KorQrZVM+mZQYnUf78Rf8+c4kpvvTHI1VrNge1E0ayFcjZxEslhlBORGPPzbrQPSb5d7IJTFhwVakkmKSe38ggKfnngv2oYl8zDr+SggQ5gnUGkjfD5BCxWWo8ZEeRhkPo4ZlwfaLE6VVHT54tHyVKhiWS6tZeQKhdOjWL5MpFtJan9bUFspFBdFkWM0UTIuFVzdZiaFYwNFOkb0p6igotGZsmmxxZup1Fk3RKCZNlAmTNFSJspjyKb61JWpqNTWxw41RxkV1oO79VOpmr7W119Sm2WtKtNT6jwR0HCXA3+3FramgYD3bpoanZ53GfQ8jCVQwKydgom6FWgUIIhnTkN6SsRlOGFz8ZPJ3cmK0RtPVGKN/Iy3JwIhGojMRBx52CJE8UFjfJCOc+wjgCWHtYYrOKSQs63rifu4hilKpZKVpHWO59agMe3zx5B6ypijMtD40a9IGP/m33fw8bvLWHmLZ1DZKQKO9ahQndLPJH8XFL7vM/8R+2x8Vi3iur4hUeLzesSNra5vpI9YTxltfvM4vv2s9p6zTVvFk1Hge33Wm9RL/UKJWuKb8lN49b+2LUtbea49d6/3l5Wt/803SkW8aEnuAWo9H8LFAnw5ubuSNuryrWdgmkM4UJyCPVXKUxifj8qi1NWt93lLLE/KZBKq0B2bdetBr/zcpn7deKWo/djsobD0Rg6DGAfBER39XJdshoPnbFS6OVUK/tWjnaJeaHA8G8e0NvXZ+OlZ5sXlz//r5pin1STwMWrGgP7v8xd7q9pfEeWm83p4m4Hj0krnc+I26eLfLbR+2vpHVYOvW8bOvH+af59s0t594jQ7az/rVr63H18cKrFR3by6D4sdyl/h/PpcHANerL36AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB4SDQ4Daw3LVkCiADy9uXTodDgHmTcurQ6HAPMm5/70/u/AokGMpKeC68yytmLEk+SAYD3RtxxpU5b52QcFnr8vl9FKZNrP6kOy6MTbSUfqCfv5y6Q9l+6XlWYZ08MMSlzYYl7oqHoI1Thx37jOUubK4cGtdoqjvTNTcZvz05cpsJXO27vJfjPUs7Dl2ltvo4M1D8mwpbWWtf3WXcMsN5c1jlqguTU3avz9+ZlHM5q9f3Fpj7tzDH7OXMMKCYw/L9V7WPcrdFg9EvhEOzmVmzcnql7Gtas45flr8f3re8Ll3VvC/hd5nZ52925zDPvLGX4Za/u8u/y73HPfNd/DH/1rWfcqnSSrOyFUHv/ylf/hNH64cUHr75VlsgjqRqKQ7KEuGBWw1QFuymVK/0ShiRVrVnX8rYRqmgJQWnnauclp3huYRKralbszUNx6D4DVDEIYBIE+DIKRXXlbE4wGlfKGyN+4Ti4x6xdtUeJCjMkJjjPmeZieF/N5jgOWo0XP/1muN1zTW6z6zDvBkmpSJJDzptj6oyy7gfNvGz85a2u+M/MkW3rAd1X3TtDmmK73l1eNaDWNjP1nP+K2xmDCvrMX43Te9b993p/evznP1j/5x8Y/z8Xt/7+ZmbxiYd2nL2Fu4CP5MWGUkAEAAkxHKlJfmZiGpWq5MMORCODIzR0LTsGkDzR+AMoxepbGq8YjknbJEaCMU0TiONC/tmYiz85PPE3gg11G5E4SYWgA2JCdjkFlbkDIAZkgOYaEYQ1ZMEoS5ZcqoplUeiIIFwkyZMHHyXVpHS+RUcwUV0DiKK31rTW6bOtdzyi8iXisZGZTIqo0TZAiJHGRTRKy0zVBBE0N6jEopHzj0zjrkaSDl9E2JVJZMF5zzG62umswTqqazskVkFGbLdBNkUy8yKjiT7om6SS7G6SK7pLrRo6lWUitk1oKMluiee6arn0cUb/OPXPosDDDcpLVDbkj3iAFG5Q5tDZ5PUAAIIqoSIrQuTQPXSR/61Pl89HYcXe6VFL68MQZfpHel1C/sDWXclEfjjJ2UkDQC+YXNA0oMbjuTkwWUBxkebj+OcYFs1LRkcKzmBWHkiazcqECKZaH0XjBjAuE8RcQCOpGrpKbUlUtVBJp42k6cRJ1EwMC8yanL44iiUTjlpSCSaaR9BpkUnRWg6BjywT54nDh4lDeTZieN3NFH1oKUZoI63Z1GaZVOomCSmTZ3QNUjZZ1mzyRoyKF0EUkGZlKUlSrWu60lOggtZikyRsj6Gm9r9yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeQj0MAuoty5pHoYAtPblsB9w4Bae3LvMMhgDzhudePOiBISM4C3K0akV6YjYgBKDGDNgqUalWZeKRQgUVXFFHEdp13kuVc73JqGpWw1yI237nyi1KICm6tBKp5mfI0/leYb+q8AvCHhlARIBkCXiLDgKpdIkbCzxfEuTBIkOJsfZfMjjKMTQmjUsk8UEy4ouqL6BEjIpENFoHUeRMTBT96bJOmaGak0504UiZKqROGxOGx2iVzU65aMWWdQqTQPMYoF6gbaZq8zZzzEWjsN1Gk0dIvm6KkEzNkTQ2RU61JapeNEUbrpoqOOgfUki5km6bPTU6bMgdzjpJPoskXlLWgkpbol3SQdSlupSK09A4T9ahkdQMGGJhSVaSw+0DlgSnSFBZlABkrxrRxrhoCBMFgefh15KenuZWrdWI0DvQWriBZBMUNFS0kum5bOswyhmXyzr2Q1AZRm4LWAigBs2B/P7sSoWC+GC4MbM2tlmTMF3mSOrbNjjekN1PBpBiNrekFOpY9IV6/P+sf1xSPAziJ5NwWJVVh1vWnsqGbGn774xfOqXjbkrFz6w90n1iBeLDgMOkvE3fE+oMSJbUtIG7TxfmmPLbEuXse28UxqmMyzXmzW1YNNU3r6z6W3mB7Z1X6/+6xfjGa5xqz6n1vX9tZz8U+bylPs5TscjAxrFjW6WAF3taVyChhxB5BQMqIMAEKoF2WgTD9VZinwuW7Hbs5k5aY1BEYnPSvc09UU6+lLEpW+kdj8VfiLnUcIfYSUEMKWUKt6hZFRHTiPisVp1AwMd4fpp66hMKpnhupocfcOF0cWyGsxov/xr/V/TUuq3xhqtaJLCTq2uVl/94uztke0aNbNdefVNYbLZ+sTeu8wXNlVytf6Xtvaaz/WT3xNW3/zjVNe0L6rnEm/nGYOY+ZI1Pqs1d3tvO9a/rb7+65nbzATMGchIKpmhK2+3l/y6iJKHmLqUb/ZOFBLEYg2wWIXCaqomaNjrVIgEs4JlNS3hE6tS/UwkVhxFAaSURCBJZNTcdgeWOnqGZY4ccfBs8DvA5L3DgE3hA0uw7T/afqLxuzDcCZS27Ug+rSTlz69eXT9LKotO5T9q5zCWSXsOrz1LrNNr/33/7rVfdTuWGd2rhjdpKsSilBJ6T7Gd6WRPDGdq41ssuXs8+24nZ7ruN/uXNSqKS6GaaxPTe5VvLLD+19YXc7VX//V3Lvdbq73rW7uHdbuU2GGrtnP+5d7z/w1zvf3lj+H8yrWOa/Dfd/3PPXN58rFX2GFUVvSSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHiJBCgNp7cOmxCFAbL25dxkEKAuntw13CoYBcvbn/01pVHPKFpoz8P1p+NPTDiXyMANZGTLnk+iEUSPUu0jmWx2jY1OUMooqtmcpofiEIWTBmLtTNuQSt9lwyR0XBcuNQ+99mxAkMkOF1JeOsfxdhaknKzE7aFObybO3Mspkt8i2jmKjE7eMLxHLqSkZW3i9Pr6QOU6UpBltqv1/vNI+Zba81O6kVqK23l9bXTytWGKt5l3abNYlI9I+4cKdk1mDebPhSQo6aXanP9tL6zybeWrt/j7r4Wcxt73nObYo83rUC9s+9NzwdTx7YxV794vjX/zmsbN9bxBn+vbGo3+MU14O/jfxB+77xGrT6+tXn/Z8dlzkHMwHTwdGZl1XgdtpKSbDgMiabB1ojqiKTMmHO1SL7c6GqfDLKX6kEjkSszh2GuzGMfsWVCoJcJ3n8pXsg6ml0/RjNLcGMFoHIpxmvKI0livPYvqwf3pEQTyWK0PcsLizsUdKsO6wYTJCncHy7URpJZmhV9vv+b3iQpK3zPedblZkTFUh/LzuPjbctMlI00GfVod6XeYxFo/ziFiffgw5dLTUkDkfJ5wQmaNXdIlc63qW0KL6e2NVzZ/q25fXH1vU1tzUrXNra16Zvb0x7TY1vV7Ta3/76+85vfEmvn7lliMixz2xHRTmV40gDgjXYxyLOrGWIs0AyIwwExZQzdI0Q8xqpA9Ydw5dH8KleU0te1KJbFIw8rLXNbaJzUKbnOsqlsFS6H8GlR2FTD/xdaBXkkEbBxkyCkVaOjn+iYCeb1cW2kepzI44JK0y3trLv5gVgxWKZRtCMYCQKJFGK+hRfv/W/vPjem6Pb6c1NBXMJvSV71paBuA+s+crah1rTLrdViaJAm1W+tVhsCmZmCsJPqBjXESfGH+5cYhzQayf51JGvbc8KNSsN1Gtm/bNWl195rqtf5fvO/jX+b4zr+/3vF//uutYlxnP3G1n2z/rFv92g70clVfHggDDpyjnoxP4v3Ky0KUw1Udj41EnAzuB3EopqtIprtNyzXvxvGH3mfp+ZJ9l8JO8MPQTS0Vd2coTXjmC80CJOfQ0laDPIlKQGy0r1sWTKj6drKVUebXo1Po187iQoU8sZQWW2M92ptR1a2+vj63rGK+/vCpV02wm6VsXOKYzX+73NXVbQMWvafNme+b23im82kuuYt7OKkVbAu56Xy81i8sDeLZ18fNfrWvrM8CNFz8bh+tLfWMbt9fG9fWc7+8Yzbf9PrXx/9W3vyA3od42Vi/iEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAABz2FQoDZe3LqUghQD09uGT3RDALh7cugyCEAXT24/f+1O+HyTAoxpuyj4iqZN8FFBUM+QSwogjI2EzU/rc/ciVyGYTZuYZxZxWHxVyJ6UakdG/EagKRxeGmuOu7jp5RpvWLSMKcuAaImIsZHAi0OenK5q5JHSlm2zAnTIcEdCbLWcct+m6i1lpbHi5Tk5Pl0dhL3jbrOvfPxn0rfW71hs1ZLXhOGmpUr0alrw30sazc4OnrfbWIEJxpuI8n18btH3Dnb0OS+oyFJVobfPbdnON7wq0xBz9XxiryfGbR4PnrumN4i13a+7/VK/P3vPx93+85tbWt2z771/rNtYgbNb6E8+npoF8sUQCboo6k1XfmdsQwmpGUYCYIbw4ZVKc80NB1fLAzshlMbpY1FpPM5zkZfprEw4beyn53tZ9ZK1CQw648COW7mMZd55bAgxmoMdQMRRhuMsY/ocVfQ5lfQdqZRw1SuW+sFzcmrt93GFMxv2JjsbqnN8yIbVHk3WmPnH+5J603AcbZzSV/e6qbXUP6keyRdNsdyfNlbXhyxo9YzfW2vqsSrylFCmsRVSjltPYmr8uDjvUvv4WPnHvaHNmSLSF62reXWY1ta1qmfvHx9Vxr51T6xiud71XGqa/+8VvmHvVt6x/W3zb5xrFt7i+mjFYgTdLlLamqOQsSaKGMYQZmIAWTjUiaKO763oEktBdlOprOtFLT6wW6sWlc/LZfb5EnAoJNAdukpb+pLF4ZKk7gbSkAxq8eXvGam9leK+HbEeDdEunCBM9cvF1mNH8kCP3NyVpxptygRrUpj//GL/3rr6q15zb7s4wp92u2yOdvu/39axqHfu8uHz9/Fs1u44o+ivlQy3vv734u/emb0+r5xutJ6WtbFNRf8Ug6+5bY+NROZXCz5PU3TvjZltY1ri9JW+PWbKo9nRw7JcIjVJlLtT765Omz5mZc8wyMx/IQmQxYrUYAQ1q3B9NHdQxXj+FWR3oClDjWZRIYej12rZbvEZG7HI7AUIpH8lj7BtL4BSJCADBGAezPhU5Xk8p3GNAe3U3PRaS7fHfLGXe8wZIjbKy2VFVEZBqNDay1ze+N/Os6+aRrWnsusQoNZsrUFwrFwkpXCbVafVN7veBTLqzn941TOcW0qsxmGGwqNXapNmuu5a9L4pfPpi+rP3V6xfB3aNr1vC36yVr5bP8X3jFa+nzjUmdWzTevmuL/P1PS1MarC1e+raxiuvresVxuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB4eHQgEZk3LqMOhAHzJuXc4dCAHqbcufQ6EAPU25+pitCPKCYWvV60/0zGk8WjDA4VmFs2lA7sDAGAChZHqdz3qfOkkHz0jpJ2VwU8C9JU87+3ZyNQLILMAPvArzW4Ah6lhxi7oCURWwZFBLgHUDbUNqJs1J0cY5hcIqSZIF42LxBx7Wal1AzLhmS5wdBXNmTLp9ExI8ZwsFUiZRJE1OIv7o0kXXZ2TKCJkblwni6VisZE7cujeIkZzRCdmyKnMEjEipKIm7OiitqazRMeycJIhx8mSSUmk1Avabo1smmtAyYwZNaBoaOcNXUpIyVUp0EzA2OujQbvPWRW9FCm7rRWg1SCTIIWNG4E4gD7OENa0RHVUMCNRExp45Dt2CbchlgMfI+DANBoRukmGEXTid51ILgWvewsyDORVIZbqkHAMZppf29FotdhtrEDOrMOnJo1A7JImJSGZDkgTMJSGzCAJDjYnhcgy5DyOKhPkBYqEwVWSLyzhuYFpMmyKEybmhePJpFIY8myYGYOFs3RUv0EmR1M9NAzlEtGZiXjxUMSsgeMhvk6YLPpqLCjUyRRM2SJosmSC2TSpWZ0h2G5IkyWiLE6tl1uTK6DJVLUqmYpma2STNzedNmTWtHWmimgs8ZUqb9r3Vak9CyklJ602NqdzelqjB9z7rk/j4sUBhyoGFYHq1Cn7iMZbuvpAeCi4iLGAuGoFGIHjRJJeHp57Y3QReU0VWk1DVqC2sPc6je5yyOSncqh2hlThW5mC3OZRcitOSANQBcIAvMXIGmCjjMqGSLYz5METGSIgRNNAbZ41KaZ5M4VSZKpHJk0iTyBoUSqgbDqJI+Ujp1RUTT+pBFFTJNUkbGaBdc4T5RNibrLxXLpdKaSR9JSKmUyBiRhNGpd6bKcxMzQom5RHSSI7HNiob00qKJugipDcwrdJaaR41PJomaa3SoWOs6qjJJ03fRbUmtaa6Jy9Rute1aq3dM2xolCz8lHNfxECiSIGBCAV3ZgCVQw0t2k5XjLQGuLmICAtGCAyXKyrF1s8VgmKQ1Fsru4ZxaI6basfaFWlcpyn46701GWsyaVRCEsrr1rJfDAoNywCJEGEDCtBxIjtPDkFE8MyT5FC4skDYrFhA2UZlYmieIaXCZTMVmZSLaTDpJFiAlI4dK6CCG9adS60qKJqcYyRcjDI1KDoIk4ZEWMFzRl77pFMxLxtZBA+tjJRucLhkRhWJM6VC2eUYI0nNHSRfmakmagifNjZAyMEFUb01PTVRRZBm0nsmgpSCnVous0pXfXUzIGsBzj7UitvRgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeCikGA+nty7VFIMCdPbl1B5QYEZw3LxTsggH1huc0uqFhKc9QHgDFhfLqF3a/0zLV4lqQQnJShuYImsJ0xjx4sGiTdoYlry33dqZY3Gl7tNdbm87UJLGMKlKvqFxJ+Z53o07jnKoP811dh+g4CVgxhcgsh6XLsCUofylynGZxRiccYLat2qmDQwwWiqJucuwoYqmWEd5/xN6pDgUxj/FN3xnGd6kxM27dM8VUJx+tyZ29bma/ZHWoeL7lwxtV+w3hY3eetbZy6bEkrUPjMGGmm5IGqX817T6zSvpibFp6+1JIcTNty2vq2o8H6xu194zHzvVd7zvdremc7xitdat86+K3gZzT+2vFIHICyWb+4QrWt1UsiGiSd3A0SdOMqDK7YEAZQjHmqlCQo8AUvwq5tYDp5PakzlV6uWL6ZQW1p0IdbeAInYlUuZ7Jn1eadcWGXnaixt5WvNfXQPWgCSyArSXLPV55tR7x4SLUsZLqNyaoSoi4SKH7hwXyGyzYZk+lXJvOyRjdNOYF75z/m+tfeca+bx41YzhOzp9gdS48JvZXmWePts9KQqsDXTDFbOdYmtbOO5tbDGQyDD0lYflh7vTV8ViRsXx9+2dTWxq8sl6VpJWT1tEt951Fp64iY1u3x9arX39NZzaT518X+4VIeMX1jW9xphS4DkN9+DT6eoGAmx1WNQXfmICW6wFC5D82ARiM1fTUHK1XeYbZZcumFyb6SVTtLNUluKtAb6ES6ERSApG3efn4JpazwwmVR6GHUZOyvoPereWyAQ4etdnJVNNTxoZVPzFmH4XCaG3X53HOfhmrNzN9+M7Eklj70LzUj+S+7epda1/7/95a7zmVXtNUx7Yygy/S08z9mrVtSmnz1f7bv4Y8rV+1t1ruv1vH93K+UqfuU0laRU2t6nc8/uc7n38N4/9ft7C99ndynu3//msK01rHH/7nUv9/LXMtb53tb9mEDfuGP3siWIUy+8vMU4W1MooxcfEcFg+LaHD4z7dnZcEIGipccYGJqG7OLGEkKXrxSZxVfNrasxOCYeylL40MuULZrD8Y+G3R0zCHJC8E1H2xNnd2UwPD7OFhI6B4MQZ6ZBPPeqS93bK9J+ektFNz8CSCFzFip39VLD/TUQmsHXyvwbXcBu0HV4vKJRbpt5/+tb/VXVTPLGtydr5cr0sGwmNWJj7WpqzQUncZ3lixnlfmanJTu7lj+9ZZau83EX8h63dkF7dbc9/OV+4Yc3uplz8OT+8sa2FLYrXsd9zzpZn8q27/LFe9e/HO/iut1+jy5W1EO8XEMAS9WI9ghLfpEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGmIhCANl7cN/OiDAXMW5acaUGA2ntyyE0oQBdPbn9//Bqss9EPVm9bjD9+wWG0kRAANiBVQLyGAk+8DsE65Ls0tFHaatutHY9Az+s2cCahmQ9sfZktepunltvdRhkBwhIiegEQ3wB2YiOQ+Ezq6NSIkjpfavAYjqjWo9gRX1Hlna/Sz1vmlNF2d7BKtyxbfOvjd8Wvi/x97gtWo+Mtfj3mrTUSBq0LUL2xb5tF94tKea9d/31uDVyR8RdXt/r4xn0+7/4/zvVMUt9TzvZfveMX17Z19Ypm3/+P/X/G94+KV3jWt5x/8X+bfyWm2Fl0E8X6UMjsIKEAUdSUNL2TS9kUFI8mkIeKJjmGHuHPoJXYh+nfZ2qOGoCszeFWAoi9kbUBZPbf6LffrS6OTEr+kl1LhXYm7EPjOBxQBHDHAtcD0hSpGIlQc0qIkXH8XEU0cgo5JqYpl4slY8gmxaI5JZWJgzSFnEEFIF8pDwpJdTstjBaJ5akl1sXiykaJoFJRUU6jdzcmz7GKZiy0UaCJ9RgVjNOfQUe0E2UkSJIFsjS4apT7U9OghmLVIOtNNZrPGpkcXZa0HdFJ2UyaRj+d8jq0N44yMOGfDpg/FSkeX3I/5f3+Mk1vhrBU8/dunh5R5UUMBZGKIzFPwlWBlYsSLkK01mVyedqU03ylqw9MsAaa9Dc5XSwNVl8XgaUSh9JuVSBh+UlglwlOkUBcA/MIdYspnLUJlHy2mmn3NfTsXvzVgTUzBrWz6I+wzvIcVttA0nz+S6tZKxYmd//NLbgUvb51vFpXssVhTlL7xRrvXUZtntTe7Vmbc5fyatSb539wc98uoR/qasdY+dekDO81+ZvjFMUxuP32KyOHxaGUTtDyOOXzHrwuEvUa+KTD7zYjcGB6TzcPZIZcSUXBBSVRy/EKKUvFALOwq2MygMXSOYWQVaeXzb6LvRMX91aD8rkO1nfizd2uSitFaapZlsPxObrSmeaxfkjpRFn70GeN0vQhgsxyxItyVOScVFW5PWnZEvue/tCtV7PF1EjyQrfe0QpZn17Po+Nf/3rq98V+P65kfSTtyntjWbt3tmrFrN669p4XxSt67n3jWdSQN1bZU4pd0d/G73ltqmPbeM5znOa072tn5/LW1B/5Gk33sY6L0r70P0UUU74pm+yPzswAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABjhrQgBae3Lt8IggHzBuWqIFBgPl7cuvQ6BAjT257Mzj0UOcWPXosZbIq8Rh1NxYc55QtsDkAOJJwJkvTKn2l+8cO3c+3cpJGXjdS19umh3sxPzFLLotLaucVlcCsrUgngDWWAI0cR1PIy1AfUTLJp82vVA9vE19QXKAyWppjpHeSbZtItmsvQdya1j//Hzm2dfGdw2u+4EOjK42x/Hc4sK8kTG96tPqnq8a9fVfvxddsgN1YSmzLaLX0pbW9618Ux6bxWtt2rjeYelZ3vCUqwYMvardsFC/m/g0cItOXr/eL3e7muths9VIGhbepog/8y7aXToKaoon4uPEGXSUiO+zKPVYdhNJWl97LCzKo+9cLTQZPCaO9LYGjklpILizswdlZjTXnod5YQZ8JYNnB3hckNlEejJlolkCRWL4caJdH0UhQY5xok6Tk0PLkTNTM3Jw+xFyyXCqkLwdjkNMlmJskteq6lIoPTUgUCwYKIuXEysTyK3WXB2GRMlwzJ9amSY1Nk1KJ8lD7JKtNnYh5fI1MojplIxJ5Sk0y6bmjJpU0ztNlmySJ5E2RPIGDpTjMmjRNkVIJIJmroOvX9aSSCTqSbWmy0WTSO8TALSiZVbzxMuht5Y2cXCwkvUk9DnAjWmFrAoHAlESwLDhppgGOSvQ4/H35FaeduVLUtoYRIoQzR4Yfnol8H2so3K7URfl+ncrYvxKm4m+HEXUdwDgsk3i3aGyMvm60UV+mxreIQ8mraGwY9bsLXAitGnsZsVxmJJsjRqXznP+/Tfp9X8akWWmJX24j7Wt2bXtIPhagwffdqWxTbDq9cZ+PvbZbmRhniPru9b+6S+26Z+cazLnHze25/3z+mPXN/6/d76zr/VtW9fjW8/Xp///85hbfbZEvDH7l+8l84X3Xj0bGgc4JjJFL4fxlTIQUAQ8VlVsM6NEYclQGDhRmBIApZJATvUj3QTbsT0Qc5zIGTPaU4lWSzL2V7cofSHX2cZdrl24k48dWUZgcIig0RMzlJI5TP0XEUhKktZCKJM7mMubm7hZiP5a2wxLzfGW3NTOm9DSpMFrTVZ9Ytj714+sx/nW2V/O1Syt0Hcdlj7rK3Pn8LcG0J9rVK5rDvh9PEtXGc4p1+uyx5QhjbYixfXpHgZ1q+MeDvEmL+mpZq6rBeR8+2KZ77M0TG6bzm8GfP38/WLb997+vvNsPda+cfV6UxLQB1Neme2AaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAc/gUCBOXty5vCIECNPblveQQQC6e3DmcggQIy9uP4eUmly2zeIjO09DGaG/UfNNGZAMJkAHO8zIUaLnCIZm8xg7DKJx/JXOZ16DJwFE3bSweimzjrLbkZadMQdLm7WGYdm2Wue8SgEyDPGWCeB6Bq5NqV+yoRdWl8hx4o/4qjiTx3l2VXWTiOkgPHCE1tkZjNA12ukSi9amL7+s4tn41nesvoVYDLaE5MDi8rhfV8RmvFmewLbzmrfC3ZttLBrLnMWsskR0m1CqWxTxcRYXv3uN7tes9q1pj0rJpmjTv4sTVsxvfOv/vNtUi11/r/51Pv6tmv1untPqLH5sWVpCGt8yeNsEhPxyoo75YhBcJp3Z3HsYAbmpUkomgUKjFgVBwLRJQKj78R2dibt2o3hR4yinqv2m1LE4pLEeTD3V4eabahUtfGZaPfkjKnMbGixmhmAmB6CejcV+kQ8VyriK434lIxiRmCPFiMbyzLRTpVhfx55WprgtR/oFONcsdr1nNP/bNfrPxreItdv40rXFfu4dpUw8fxdPp3z+usT7eQ/NJWSFi2MRrQpY7tAszk3tka8aLambfX1jc1bfcHcezfO9ixKbj7rSL6Wtr51jONxvfX3j/FomvvVrf6v8zbjRPnGo2gao0nf8fFXRRtFogQyA4uKZ+rXm6SUvzEkN2ykS4w1c6BQHI031N45acCKy2mpJXTWMaeLRZ7KCC3/gSrWhfyhx6GHIco77u0XZC+cbXhlgTIXaAIoyl3dPK2IolIyYVy6Y16PWNPFwxuXbJVQx0VLx9lhhEYQ2cf6f3nEbxNbx91zi97+v1hdPttLC1uMJxvL90gUgxpXtott09M7j+lfE3fWbQ5axkTaDMx1m39YnzFpiu9x/unxArn53feIOs3xnGc+XV/quN2+//6em6fGL4367z/m0SDv5+aV+85//z848uf//jE39znktSiODh5kYppNWrKORproZIhibqpuYCPs7pgaEXEldDAcNZ4xuIYyL8IFZTIo06DoQPDXHc1G3krRaD5yacqjxkcIjB/jkAkgGgHOTQvJ/TL6OYzlY3Po1cqzOGqsV9mA6hsbU5riRRM8F4ppSNoq46EI/3F8e2s41b59Ne33lIstUYrmpHRVqJjFL5jtz2ExRY+q53/qbUfGI9NbtWBJaZJVhToi1tfdYsls1t9RM6v6w43viLEpDtulL0lx/Jun3bOvvWP8X99X+80l17a/+NR4WvbWL2+sW/38fWdyY18f38cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHZYDAgTqTctDwKCALL25Z8a0CAeXty5g5oACNYbn/zyJ8vcZngXbQSiYuvxGaq331RrMwKDlhMXPCnFiJQzLvtPibxwxF5JJqbCxekFIzxTKIQDIn2m5dFc7DLKe3EKkhdmKQ9MJ8RQWcFlAjgCUAXYLGhOxNMgM+O4dBqOSeTMXFwlREixtWRUmTI6gXXRJ0n1nSgSg5xFRtj8TRuUigmgmrQSoWWtlOi5cNjdky6XBaS0rKJmtRcdFBc+tkTdFE8TKSSKK7MtApmJqTpuR5OGhkVUpqXDE1J9bLzp11LTSN1stKtjhugm9FNmdk3qSWVkdJmPaey1nlUE6l1G6+Y9omHQSZeDZxj9cjLNWFUBeblPYPlDRFQKUKtHTRGCLfikxEUTQxZqMNR6A5iOyPHd+/I5Wvthr6vtOym5jbsX3Xqcr08ngKRw7Pr3lR+iFknB/iVEhF7B9EQrT/jIVesLCqaZ3sXGnz6sK77OIUTGmttTr5YTL3wWvV6f4v//8Y+faJHrFjxI0M7nef4WNeH7Xp9Y+Nb926ubWt92+4FozlAkjs8rnm0aHCjPPbH+JMZ+K0xu1cY3LTNNfFL/X1rOa9x/+f9/FP/um8+9PnG8xNOQOnADQoy1t/r+oHhme5Ady3fU6pIBVMgLvFk01Bx04YDLGaAx973uYnATzTEYwlE5+rrwumweO5Ushqv3M1Wo1nzeiUwzDECxF3l0wyyGYLMECE7FoCROqm6xMM6HyNDjGedlbKZeusP2W2VU2vq0VqkcIDTFeqhRUvvO///81vnNpb61AXLZZVv3JrgRN7gR6uMK0ONe+ouf9U9mqTOfTOsxsVv5n6EtsWkKsD0z5MWvm+N/dPi2dZe2xBw9Dbq605SlDteOebWL5w8lC1/Q979FA/+69bWv0jOMvmDQhKxpcYLgt4lHx0UDiSZ5wB58iBrC5hnbatN2uBdEAymbf/dDP6xlUeawsSUYvtD3LE1G2r12at3moaj79Spaquoenmjplig0BSI6Xtv25RWGqruXovFsa+Uur09imv4zFHM5RWPUtq3LonPW4duRJ+5b2x+ud//5+WWv1jrDLOnkleq/ExLZrtvnM+WpPVs0k7UqWr9zH79r8a9XHWs9Z6s/ly/PRhyq1anr2s/z193PHmtb/nM9b3lzUu5um3aw7r8+f3PPPve7qB2nQDDrBO6xNNY/2gBl0poB/NqKt7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB36KP4E6e3LKrYgQJy9uXiY2/gTmTctjweAAfL25/nWLXIr6D5GI3dnqkYlsSVaXiWK004oI86I2RMyZADFUFJE5Mia9QTURxlVX7kMtGgQvzATOY/AUglsuhpwZW+rovlKljSOHXQceC1yH+BNqwEMMFNx3bKepOCjN9FqBx3Vxb5I0Cs6KQ9JYZqKSE3x5WtignauVnLU53cIWvjeN21rOc2n+6z4kcH1ky2pmasDWH7C2MlnPEk0LM1o+8RMWhPdWmvB8ubOSnV7gnnJeOuE+v95vEvqfFM7zevvrGo28OGNwouq+8v/3nMa0fMK/1TV803mn9vb3rreM/NtfMLO/anja1a9sxidkcDkL+tWqH3Uxpwklncp8pUwOjZOpcFBzcCHCgpRD6VTXK9rj6169bVLl/aCA5Kl17vTEMy63eiL7ajU1J7rLZBKmt0lE3EwD4Qoqx6jUy4wlMdZuIhIP32pIdIsXNqLlONu3Gqnq1RMUZcPmw6r3i3fy7/9/q/x8V19WrmHeDpus1T2z8vH139XVZbVxGzTWby/Vt63S3xjMWAwOatitagzXG9YpvF9Z+MY1j43fcXW586l2mwt7GhUHWa0Ph+MH1+218lsbmpRGNF/n7N/Uq589KNBsqF2ZbhhMVlyqrNZBTRnVjRhvHmrCag4DBXPIn9cdh0clENUOUsy07DKl1KijEFTER47OMehilpn2lrsvfRtIjrqNzGaEDhOAsfEBwzgMfMCwLUUhpCyCOKQtiBcdI8XEDQoqNi4akTIGdNiVU6SaZOm5RL5FCJFS6drVNTQUY0VOfLKiieWXkCaHIROVMT7m5gRdNE4gzopKQRL5gS506aUUi+mdMCgT5xY6CkZFohxdd5cROUzdNNF3dVGikxi5xSnOWanUZoszpqZStBcwrReaoui+mgip7rZ3WcdmRWigtbqTuync2zwPRCLvKhALBwS6mc1hdY2qVgTEUE0LIPzodDmlJpWPLAT8NZuxuUzG5/PcBtJZyqGrH4nMZwFlNuXTRWZlzvQiQw3Fn7eBwIYD7A0CeCTjkY5TteniW9Synnm9Wae8OPC72DGcGClW6HS/hKKCvMHcXPesff3jO9YvnHt9abqwo8CDl6n8XxfcTNLvKWlz82rXe6Q3DGL4tWJSl4bzPTNYbkubY/f5l+KUpvVNZtb2zu1IOc1l//18wMb3rWd3r/v/P+NeNbWNfNN4+vrG9a8rkwEWgTaSqCjI4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZpaMAA2oNy7vAn4CdRbl1OIPwE6e3LwcQfQG09uf/HldbogQIDTTWJqcdZuHEtWgEwtOQzC04r4RGmUIhPe/buQuNUkvsdzxyddgMXZ2tTFyq0pu35VFcbUEyh77sIwcVvbAzYY4MuFlgEIZoXMUSiQIipgTBVHo4miWykSBRNWWmiTKRbcgxIIJJJmaCJPqLAyh0yME1o7a0WrRVQ2RzZZwrF48zuxqyKJZRTSXSMbHEDFE+tdTpspZgsvLIaTpSy6m1VTKqcxpa1ppvmMAQDrLtX2/hp+Dd8zPrtszsTWqUA8GNqCXc9XOL/6xaacMO6ExGioa8OvvMrAr7YEo+JGAlSac8U9DSlUPSwFjj5QO6kOyuGLdLhWuNMbk4CaCfcuazBM/NUUAtesS1sDtvbHoXbXss6HxWgaOK8AngRoyouEpEcK1Lw/k2SQxDpUWVSGlsc4nk6CRsiSBgOaSZfKaygYHThDDpRFfMzEprQUlfUbO9J1l9VIyUmWkDMeCCppmrHy8tJRSUeLpyicZzNMmkyWQrWo0dFRnMSOH0RIonnMlH1osmmtR1jJzFdSjRBsvS+63OM7MgswZmrY6r01KSugmqyCkazy21G6bwnYYiRURQuxu1TKf6jUx0SIescKEkbUXqzUEtaXc0th5kARnFZ52htCpqpqgyKjzR99Ii6FZ3qluXWqNrLXmtMEjlLDdyfwiDIlm2X1lz6vvYeSlYc7uz/RAAfcBtC+fn3HWDSVqdttvcLwo6hN6rhWdmbYDlVkVkCkKOxRHafQ6ErEY+3ae+9/Hg43TefBtDpduhRH8Kh+y6vvUJjescSXGYNN7zaDnMOGtW+9yWzeTbhpSQXFTPnLTy88Lcl76tSBv1xqsOPifdKTST63vxc6g11nP9bQ4H3XED41atP/q1Pj51m24N9YkzSNj6zn+CQrJ3l5j/hmTYyOJ2eLnZx27LhRVcqlyYRi0oyeOwOMqJM+4FRsrg5gTW8W7y99a96M2ZCyp3X1bdYWXOxbitWZdFWKNPtdeJuld+7TWYGjhnHKAIDPGMXErDwZFpCWI/nrDAj6XLQhRu7c7aesz+L47PZ+9q9d6Qw6VKc6F5tFiU1/ncmaQ4mPCzAvhthx1h7k/mLETW21WMzBHYMxm7etSQYWMYeOOvE1LBti+FXGP9qVSdUM0V/C1WJDpq2bx8e172gUvNWPdyg1t/qNS0K26Yza1YEPU2M3ze9bXz/638HON4zqFA3mXE8XON+n8hegpabvMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHiY8+gTp7cuzx99AfT24dfkD6Bentw2S+n4Btvbn+motEB41kzoMuMW5x9Ido3hcJ9mADpYPJn83mZXBeEkyz5+cYAfFsVyft0l6rMV27ukPD441dxcpTayeCGqaM13olcMU0hnGzuwOYqwtIM9xCDliJxGftTs8VYh0VuiLJejbRryArIkRD0s5xm2O2qGEuJV1WRS5TKkmYIDlrVd4tW+6fda6kzGc26FM2LpqSW7RoMiqjyyarbG62d3tizjLGrq2IXrvsMJUqprRTVaVkze+pbxr33TFa43vF/Wk7bE/zPr1krSW+cWrbWczY3rNaT1+b2zjNPXG9Z37xImPfO8fd7Z1uH/q1s1+NffkhbziIuFbOUB6AcVG81cduIR2aaeXXQtIA5zgx73Ro24KvsJR1hiw9b6QDdmKn45Z0jgPqHAGztBh6DXot7ibs8wqR2ISOrFvex2w4QkiYA6FiJYOFC3rgu8qJjVLM3v2YxUAqocNjj3YErNmBVdKJ6p2pc2qpqKZjsxw3G+7eud69/q1ty7gzS5nhr8dEzai2hsryBBj2rD1jTq0XOnKFNu8HNfanYoiqOlsXL2siF41aPJTVNV3W1r01nGrX0+3jVJva2bbk+L1t/qke+t43eJjwMffxfGM63jX1e/3rGs/WK43Wn1vNcbxn/Xh5/SaoWyy8kigV+czF7D+tZGALilgCZBcaU0fucAvRtQhMkFQqTNDAcPRyXSLOO3cI/g6LI1YWTuPnI45Kpx9HbgqGpJH4/dYlQOe4y6jkBxi+N8CeR4MdU0L8cJ0nYn0+dLtSLtuVzOwKl96WrL0s6YXrdGxLCkWH7I1RIzdHkzj/O/neLXk3PamrPruKTrEn/pKgnLvNTvaYnzPeS+J6RqxNUxq+9y4lN94eLqDI34xClf43P8Xzu/+cVrqm302oWrZj/039/H1b/NsW9cWpvP9vj41qBfedxqVz8/GfreLU/+Nazqudf6zi+IX8erCENmERo1ruESdvUaSqay8pIZmEEJtUaacIGbAY8JqKJ9SGCKsdvTtiay7QUb/QQ8zFHIuRinis/DbsRGUwXMUEucnN5HVaaW8KQjkkBIm6Jgqrm6ZRxLtOJxDojGkFywsj9mg/d/JtxcozlmsG0tI8aeHfUGkv/+NemvWmdarnPiuDkwT71jF6JWLmHnvt3mxrWaZmhxZI+959KaklspG9HRrZas5zamdTbrTH//zi+81gz+Duvp/nX1T/Gv6a+fbOd6x91+ff+GZoHO55yxM/78aE/yYNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAByJ9PoDag3LaT6fQG09uXY48+ATmTcuaRp8Abcm5/Y7WOoTEgil3YmMY1KLrS7qTIJLAZieg0Y1gYwi87J2o0zwPpDUKjdSnkd+IUDZlNIhDFuawjktoaSBILlkQeXF6XwiTrtnbqMwCHC+wa4ZAWWQcuJmZuVS0R41jpFWNhvGJRN0VolAvl5qRkYHi4tNjU1HsnjxJEseQWt767opOqmeSUUybPEcfMTEni2i7yCGCJqUDW5gtZoeKZTRIx0CZUyrJLTLiSZDiLjkFgwLJfPHK2PukmipBpnQTQSTUo0RukgYUGXVZSSdToveqtalpvdbVOZH97fduhJE5pDfrN7pcP63KQCzu7gEh7MFvzDObcWdO2lMVJZrzB3QhpJ5h0CA5ljnS14YnLZTEK8xRXpXALzqxv+/cViNeA4lJLTzxCL079X3igmOvw3rdjvCgFaKaizQbV3TCVhvqGDCcsYMaRdOPpa7JB8OLVjjXfUg2fJpU2aHPd9fX/+PW1dVxTdbtjBO2zRrRZt6z0/DnjP42NQ94nngNnX4l32fn7rjTnBqpYi7y2wqTy+lotK0tm/9N3pfWL3j7p83v97x7+9a01nW6618/GK///H3nUG3Pt83FYxqFNrj6DMq/+lJoOolMbRBzdtvpLrEtbGzNlCLZhjGMAdthkPmh0nYlrg/cBx51qeUVqWXWYb4+D7OxRyGD8b8SrwZRX3vjW8mfy1uVNDTgE0AtIQuKOA7BliaHeXTqyBEQNSmTJFjY4Q8lyHGCkzp8rMmbsTBYNECkXDA8iXSKDXI8zPoHFrZ1LWmpbJzJTscLpdQLpGHiRKhbNkVniqgmdMVGaaCkDQ1Uo1My4pB7qW71lMyImXSZkSNziTHkjZ2NEEDdN0LLRdSkjxmibqS0XSZ0dqnpoMzpUa6mUprOju6kE2dFmTqspFbLtRsyb1alnBv/bN2075EA2qtIpbSUsZfhaT8mAB4CnTDYM0EsMFN3bLXSCkl113cJmrapbUQl0Fvq583C34mMXh+PyuibSMyjNjGT6wLJW5jGgLwEECcAF9HskyIF4pE8QEn3JgixdJ0okMKo6TM3MDhqSKblw3L60zMxL5fNjEixJjOFguMmtWy1KZaToTGznS8bOZEeVyXL5aRqPlZ0DIyY0QWyabpopGButNdlqXSmB0kC2TTkigfRW6y6jTdyo1N6DoVsWzBRotnd6LopbstrJs9Fkqt13upKtrJoOglUgpFbrSUn3Su6mnX7SoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3SGPYE5i3LrcHewGzFuWKmA+ARp7cvBwJ6AjUm5/jBAwyQqeYWRobrTMstS5acOxJJ8DeHMmACju3OPE2gwKo3i/oZh+UX6O3Y3qcnGsvm0lT8QYTF4jzKDHAjVWhm5mGIHbsw+VLuJEN4D8wQ8CwIeKITZNEQIq5ecgRBjpMmIqSZaLpgtNZOGpdM0Vl40RIuTJw2I4yGUJ0vD0XDqa2SfMk2UpPTpzRNItEcXDqRLmiaJMF46YnTFy8X2RQWbk8UrGalPatj6jhSNCbIOVS8ZGxeMkUUjiKKKaDFG6T1IooMsyWo0Opmrsimo1UjS6TIM6aR9eitGzpXqS01MVnqWyS6zag7qz7yd4O/2pSWGQ5SwXzO2JdPPC/KYBbQWAN2QFLmNgYOAEWARxUTcNirpOZS5SCUU9HXnp99oS2JekrZ9GI9LqR6XTh2pQVKkbhxuriTrOR3hx4pIASBcOIWGSLxMlcixaWdHJIKZJGw3i8Vy8X1IGBFz5keMjc1L6ROHCiTo6SbIGXiAkIfOKSdFtak6KlUHQn0GLZZNziBaN0EibRSSUo8XS4mp1GhVMXSMDHZKp2cxKJuTBED5ZJ0uloxSdjM2dJSaZNWZrJKTdIxUmbmDJM6SC3Xoo6KaamUzdJSr0bVsqy3NUa1TXwHZ9oOmOvtN7aoYKTNmhCUOyzqTcrZi0BTJqwjAGRImUjnJPDTZY6OMC08VnrL9TX0FvHJ5X6fqLNFqM8p8LtHKXljL1RPkYaVSvA707KWWYgRBAJE1yaMEKygZE43p91GyrWWZ3LrLXhZYd1jxFc5QLxMwrK56xsTJP87z//jH3vPzr+kn1et6PnctaQn9o3pa1bTf5rr5g6v/vHrTEHakvH033tH1bF/AxkXCBrWBxfwHPwMGZ3hxrxlWuYOXr5+63G5/gZaWBJbuv+D+j1vDoSEYlFrbjQ+/koZ8UEkhAKFImJhgANOnGWiVFPwwIKLvw5T2Uzg1+SW5flMjU1a6+q8IdWDnO1qKAoGgJusQsP+0mNNjf340MsRUQHEzAfAoARuRNEpi5yXHPccwrFo4RYvJksZGxgUFkKXjxseLZBSRL5UKxkiakaOcTBASJnlpMpLdOpqklJMYl8sz54yQL5dLRg7mJOHi6pM1ZIxLbqUXkpkSh9CplqUbmJlHLKBofIxJZq6JmYLN0ay4oxTRZloJnlqrUmlNHTTQMkXVauuvRSSWp2Wo3ezVMttBSR9M5A4LLHzE5y0KXnJwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeGhj0BO4Ny6vDHkCcvbl1mEPIF5k3LqUKeQJzJuf8qCj4osgFmBud2WWJqEwUrGXsTlWFCB8xKIMSBS3A0PSqLNVgZ1ZbBkTqav8vww6DZFMX9fxocojTw8oFwRmhisZcJncmmqFpjMhkhW4ekHqgGYN3EELyxyhtECG0K6Qhw2JoplxMdhmfOHU0yfPEwUyGGCRaIwkis5bLJ0hgzxETh02M0FVpK2RRQWZJmZmTMsERMSGmrJH0XYyPIMieTQSNUEETzpE0Sib0NK6BmXECLpkYaE+UC6pkTpTQL6FFaal9FFk1mq0DiJkpNWyFSKCB16mXZkUTJKmvTUzpVM7qdS3Rs1anPrv8DiO03Dsv4X0ZEpLbJBPINxFwZfGI2/z0J5mKUIAQN8bO5+hDpxlEqGuw7TqvE/0Rfynx59K/b/qdsyYc/7UZ92W7YXU841R35c1lnFvCYcdnpSkYAcRAgD4AUxYkh+mKiS8m8j4sFhXocBLyRZYFYDJOr2w/85dpNYaHrQrna7MFHQYEWBnPxn/XxaXEGkCAxbbUtIirZ81tRlPHvG89N1tfxp8wVKp5Nff1/rNH8NSaZ1tkfsWd2kbLske8KkC+K7/jY1JasOHasur2/v82vuBjWd/7vu0tfTH+s7mr84+vrwNW+7/GazWlfH7Ev/SWP8IOJMGtvWFZEIbKo/UlZ+thsKTyAIsDHu4eU5poHMiEdS6UQuLwY/sPO9jdtXXUfZ4l4LDL3bWKz8EwVI5ezmUyGPxiuqWH68RabPi1hcOBARXwIUGJxZpmYjPizS2MaPkiZialIl0yFFxGpqi5fJ0zPpETK5qbmhRNyykQEuG5Gk8fpuyK+p0EFpmlNbGKJcJoyLBVRL9NbFwkDQ4qeuiasm5sZqRRPmbpmCSkUVFwhxDjEqkaXj5NEu7V1lvQWzqvTTNnUtpsbrpJIOmgignX9XpPst36TopbUVmimpILNQwgKmgLF3T3uS/n0taUXo6qGSYniFBJo46ENy5CalGYToEBHwjLBAaZWUgq0OpCa0airgye5dyht/X1Z+7riN9FqkkgmQSxnVqXQZG5QsaBI5HmnUQoYLOB3CAgPkNUDKIFgbguYtCzikOYYF4slSNgcJkk7FAvGBqiVDzoG5kaFJRBi+YEMKjpWpJdaKaaSBu6CTl42KZMonSeMkJgpy+PaZ1NRujUbUDxiXETIyNDBkDqK0kpfIaTJsbEoXTxRIRk6lKPOgmpJFbdBmRUbLNTRqKKbIJumhUzP2bZqnto0WUd06Sjdbrpqc0TblOzngPtb6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGv3E8gRqDctRuJ5AnUG5dlgLuBG4Ny4bAncDNPbn4Rjmp2IFAyH4tN7mL7MnWfRS1QuTgKcYpyd1yYlsUGnlb+TyV5JbDbz3Zm/cr16Vm7UpDOS7VJnKIrMTbwx2KyKUPnBUBschhEE8RqJuE6jpDg1mZQNEhlkJmXnYm1EifNki6WS6ZG5Mk+o3SNSsfIYUCHGBuOcgkcPn0n1UmW8zRd6KnNTAoplg2M0UGmRJJOfOGbmKNlKWamJ9Tu5u9FHMj7MbqK5gkYIIIWRUzJnklp3Wp10Xdj6aKzvoJUkDiIONu95vKjv8qctQq6SxLKVpAqV+7+A3+tLSM7D0dDgmjWscyjMpd990VAYSKAgCTnQCDgUDIWqQFORJ39Sx1KCa7jWlT/QLRS6fnbF+pbl0RrQFKpO/LpwdBMSavEygDSEbCtSbFaBwMwI1JYypTMTAxRTJg6SRUNTEyLBkYlovGiaCJ8qniyYjkkeXCIk0idPHmbXRqooWZJS2STKSB0umju6jElkWPIoUkrrWovGR5KzHmpPWii6R5ZoZol9007pLd2PrUqyk2Veg5qgkpXWmtkUzNyn2cRCew73/zVTcH1nt466nSkrvd2n4SMgKmGuKBE4rOSWGZfuGHMRyUoHgA1cCMBpiwFGAgJhgcCgpOJz36hh33jcqQ8llmtAriSIdB1LX0llFDFBG5KzTGGp113hf55nGZdMzJFQviF/ABMvB+wFomDMh4uiHE6QpqMiSqJVHcXSuXFJl1I3KpsopkOUmWiueWXmIuXhmCgbJsiutlo9SlszoOggmTBgTaRuTKzRFIwKR5SCSTHyi81QTMmIqYH1IpUU0UVHD5GmJRRRLyTonGnHZFlIUEdnpMi5ozmikjiS0qj6S0kHRNFn7Ulszb6FmXW7ukpA3dggtWEs1qf97leTOyuaLS1zS4KR8MosIjfp6jd2OIioSAErOgPMtpMyzNERMaLrJ4Ql5YblkMNdo7snvxmeZ3GRQE0J97c+/9SkoIHtwLfgSCoBhDkq5jEuUQjwh4B8jAMIEV/ASCdeqpNWRzddVNDM0P66jVmfPYLU21gOTy0Z7lNNsNdzWj/HxvFv/m+L31n7vRjy2eI+xHtqGpY+cwdXmbv40fEHauh5vbXtS2Mw4i6jN1Lq2tLS/397XzP72x/6xbb7/c19Vlruv+tYrfVt41nfzje943T5v97/x9U17zb88cWgjee/npPoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0mHOwE6g3Lu0OdQJ3FuXYHY6gRvDctKuF2AjT25/WYS3yh7CzIbJYnAT9OFk3IYAoEB5OZlKEXzs+zBijRKwiIIibA5a8LTWc2L8mqxuvlWSLZusEnXhKqKtcm2AujKtP9Q2KGQylRhqdCSQWBDFoCEG6gNYT+TxZMy8OaUTAcJFSDE0dHCTw7S6S6LGZBjJEwRQQNDylJpkoTJXPFwqKLxlvrqV3fcyOlI4mkoeEkD9M0NC0ZqU6SGtNMyQSJ43QM0Zg5npLPJkwXSwTJMsbmE3XmbJJXpKY+ixsmxu6qKBsbHGPZspaCzak6ToPTRSUtrrSRZFJdHtSddN6NSM7RVMt9r8Y1/H3EeFe8sFQotCln5LS0DxsQBwSjgZIMmiBglanihxr58Y2HiIASotVG+cq3i9/yigxlKdCuG5rQgvlWZjsQWCcKU5OzGJHTxamVe1GODZCzwgMF0gTIIKNgtEwyYyxDiuLKHOJ0ulgZoujSIsSLpGA4UTY6gTaZbPs5oUDpkeOGaaJdNfqTRT6CHKJgUTqCKZC00ZoZnz5gdOqY3spAwLq0SdLSZcSnUTiSlqTMCPMjMmielRc0SyYmJipkkVugk5qg55Avu5miXTrn0HNWSWo16J5NrKRqe1F00kdJT3Wasg7KRetU5KrpGKBv7J+gqhThqckVDYX6eAYy0eGkplhlcEgeDjkGjhqkYEaJgowCgoLhUAPDAMiorMv7TySXy1z1aF0ua15fzX6J8a0vj3KF247UmJW4mEPu84EgGSjwSFCWrWF+P1ZkjPYzFpU7kxPTU/P6jdPq1nT2ZnWMhqzcts016lpZp0JqVZUNLZy33H/7/N6/e6nce446zp7dqRzM7rf1pzCtjNWr2Xct49q61Ume1f5l3W9bs1tUchvW6btTOpYu5VrfeZZ/jvXM8MeZ1Mt1MO85je73DHHXbWu/hrWXe7q9yX9i1blfeAeKpgQYSvZDfE/NX8pkoISySYoVD6OWp+OPw2F+VAUXEVy65rYInHMMXFhKHV6YKdyljepDelErnL78KfcqHm4uLDkij2OGFHcfyOZyuWQ/nEH5cN2EIBbhsi7G+M+L357QlCpUPhuOYjhV5ArWkBybt2aYTVCtWO+fZOdtetsCNGz9b//38/++t6tjOIESK6hRs4xWfOcNc0aLqv3EtmsNu1C+66zjOI0Hund6QaQ6XjyQYMT7rj7xneM43q+fefW7+fXzjdaxb+eupCcgnf3UsutUv+lkulV+2Vr25wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZ1azqBOZNy3m/HQB9Sblt5xOYDam3Ls0CcgJ3Nuf4RQrCaZSUisD8dwE70SobLtw0k2psEogtsyAjGvSGTnRpb+llcTgXdmrDtnbuP1AVJJqJxZTasy+P0takjlp9XIilE1+knkQmIWMAKGAOIsJIpFU6QVI8VB4JIvmp1kSYMztbKNjyZ0mHOlVJ1R0FAixCloknYxRX2eyLL1VmRlOlxFRF1nklWOprYul9FaLLNTTdRxA3V7rUU3NS6YIGyaJXQOLpIFZ0VM1JGpV2Sc4pdZjhIieaJRWbK7p1f12KTbVK/VJjlr5+6laa8jzSgrLqqQkFQiCNT22CTMXghVZTMKiiUodEQMlh7OBBxcViCIzySiPSiHsK1Z+rVx+3FdGNv1F36pr1upHKDcblctcJy4fi66I27peCZBxYNjgDLCyjYvmxqW2IkT49EigVigaKJs4XKC0zU+aGRB0jhPIsi4z5RHNGyXyq0yUpW+6nUuvOl2kXzZMijH0UblhSnMjAyOJKUkfdDOzBF1LdlIlBSRFi+mo8kSCZ1JFEzKrJO7psqtakKE6tJSjK63dHUpNk0Vsyql162q2dazhs6sNYJfeMT7A+wlbrtFvzi0SjzQWwICFWMrQC7snbPDKRCX4krLUAdOaxqBpKry4QKOslisgiUE3ndnausajpwRPLJZbF6kxKrNDTTnI0+8Wh+AtShiVO2Uc0QEFGARcQIHpDNHThKk0UyoLkJEfjxPqGybrKL6JEkWLBE0ycPnCfOnlECNyGkFI4njUxQq9ds7Wt5maUi+Yk8Xk0HdI4WloKPn1JOkqs2WpRdLSknsk7pMcNCCF0vl5BPUbonTEwZR1dJFnRueqdJRuplOu2fZkjF4eExU28Hnd/FnQiIzF6jBXVnZfua2G/5bKYoklaMkTGUMplMvmW1eNpbUSzgoCGkAIGohMGBokSAJiIE7bjNnfWJT7Xotlhq69EFx1PZ+oEhunhmJVpTvKdeiBX8dG3E1LZxWQZYQHC5gAnwbeHol02Lo+iGlggY4yJjpPlo0G0bKLB7SJ02NiyOw0J9BMqF42YgJcLAyxZLrk0nX+kqcZSqi4W0y6aHC6XSgmzIomxktZ48iXUDVa1GplTLx9dqSLUUzErkTKxUKaZobzFBzAyOpLMFLRugpSBvOomKKC3RWcSTqPT8ydG62SW7urUpdnZtSV1VmyxoGZgFBTlqUWmn9ZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHcpA4APp7cOiyBwAnT24dghzeBOoNy1hC3ABtPbnQuNgaIAlKGCoBwYBYHTknxgl5J1QYAAwQEMcnCog06k5LUKGy/DnLB+8y+aF5c61qnrzkYpUtdv/k/mFmnh6NOk/O4I1UeSLUzTUWmi2AfB1CEh6FEnXDCfLonJzuduK4qoE+5LhVPoNsqy+obI3r08HMNvlUrKSqq247+9VxvVvbePvf808WHDfQoFZWh3a2oj2NpxeuqZvm2LYl1fDI+xuD8e1mCFdmuucwZ2TcLGmf1xmua7pT01mBLnE0uMYzExnOs31Pmu8ZkvGrE9s1kpmur482s4tNeusbzXHp6Zn1773v6zS9fqlv668tf43Js8PJTiXAyNl49BDtO0xN+U01MmUhjM0AUxlYzkoOkMuZiwKaXq0qGIehivZnLk/N0y2qzuYOn9NuTSF0Ye1Bd23E5bdacljDSaBNvRxEQGifijith/ueTtcHJjjK9gip9lgyfavxuirblzf6iMD5FJYnL5ULVfr2+vX5rm31n7o5NlINbx2xzdare1YuXJ9GvilM7i51uJV/F/k+frt8tVmqegOURV6g728+M2hUha3vG7Wnx9z4rnNN0vbNNeJjzS2/1ufxM4h71bHzq3+cR6f/WrY39bpXdabrXF9Yx8W8XV8fcDP9RWJgJLbFQZFCRBWj0DTMOxkRAF0q0hQwbMaa5SZkqdwIBgpZ65GGGQLUrOrfwppdPyGYo1euVFYjSdlVW86NmmpZ5rTjVOuy7DsjpFACcwy4AzA2KEZnTBIUiREzKJCGgzZVNhYkzMsG7KWXiZQKJDTdREzI+XiskdNRzxZx9NjqN+yVqk93RNkTU1PpF5RDlIUi2mmcQM0EElWzySkVFozVRfWdLxomTJRMDckTY/SWpFa7qdTpUHQQPOkgT6TJmzrputNjqLO6BkmxvZE6tSkbOt3Y6YqTU5ouy91rUeYxWYHFE5kEvaVrK/7cDjEUNjCgOZyUxGNQE49LawMM9BYwyIAMNA7mXTGgsrhlrcWu6hdFuzLZyXS+nR+ktaNX6lLatOFR0tNLXZdXfI0/9Y7jrHiaYjIDiSiBLUuyOcGJLQ1BbSE6iNcS2dPX25G6J2SWbUXVJ1YfsTG5Mf//11/mn+qbi0jPnGsWLBvf5iT6lvAzmufb+9fGvPTXt9/yRY+oT5viNMWbesX3j/V9Z9dZ1e2da281jEXWY8DXvmlvjV60pvNs/F70z/rP3i2sZxfG80+PjXvGk7xoAviZ9FIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABt+QNwDZe3DWMgbgGy9uFaY83gHhbcqAxdvAPKG53/a5JFekgcECROpK+r0QzEWsK+gIRpA7YaKM/IbnEQjzQ7K4D3ypHdYTvyaXPtAy82uWorUzm8pVDkjpYvJbNiR9c+QTCaIOFSeY9AFKAjtNK2q4FrTuGru4rBNB1XMKNai0vNj/cHMlfAL9BguUn1/j/ec+u7+mqeuLPdZ2+hRc73uJjcGJLvP/3qtMb1qtt/3+NekDDSoor6NreN29q/43vGs/X9Ka2+tnUHNItfNfesW3mnviPTe679/jV9a29s8hy5tSm7am1nGb/O9TU1BvXW9UvWl56++NS733QFZ7OyJgcq7Krs3RxF+mYFt1cnMubgQXjASCEtXk9EnIy7nAGOU9lIrMAwlrEfwkc3WoM5TD8gtRSSdl9Jg8lHDSOHYIUXk1wWtlTh0sLDll7NH9HG0PeN+0Gal2Vja4lIWoO5ZS20hOMHO/8//FvjFPfd/bOoW8ae6jQq6paXT69q4/3reL5rvFq61qnzf7h6dK19Wt9fX8Xe/B1///nNt7qw0lva949t202b81t/01rUuvL/T/G6+9YepMVvGvi1tY1b4h6392tu/kjfH9aYgaxPT4cchM3EkwmrKLU1TQX74qSHapQFXQ4lChMGBqK7DMtpuY87+GMtqRt4oR2pcrVKnLWN+Wy2zao87MtuvB2ekWnh4bKJ4mrqNJDt506nFdwWowkca11uiapUgzj7r///+L/+IunxDaZHys+LtsQ+u7j91/z8zExUwq7Y13xEv/3viK5i6ZUvqah8tfvrlttTc98t63Wu6q/pHf8rbI226Kmn337+odFumN9Q2j8v8Nm/SMFnZmxd06EDPxEBEcNIK6OFoLEu+/sXj0ul1LlllrufbW443WF3vt0N3PKzlejUurWb2FaXZYUEIoHnDN0xo8cpQhz1Y8ZN1WJypJP7WllvQSD4W///v+f/5ntJlreZ2uJSrnT6qfxtf/xzHNKR9wvzMQ/8V33E788XfrM0kv9W1tcLX+/PbzERH0gt1O91y6VV8VEy13VY0dKNZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAARDgjeAWDtyiBCG8AcHbkt0lN4APKlBkcKbwBeJuf0NtBBV5vHDkprvG1kqCZWvIWinLYkVirOZ61vL+Zav5WN3aXHm8/3zuVveE1r6/cB0uD8HoSiQc8ocg6alVZmM9jTqrNnHG1NUwpnf//9epZ7+de309kfbbXpnGInf0Wnq1T3ns6HoaiOecbNd8i8+jMdVqOqmTmvZ2NnSqYEhNXb94KqXFzye6QpQ+q358eqgl1MiGXpHBs7HBNTdXLCjwx5rHncbtj6etQVss9a/X8xsXO1c/qcrnCKEgPhcI5rSpqnIa6VU49ehxtNKtoPMo7c2///0pqY5lu7Wv6a9W636Zq2U031d/0sm9qPnmMjuccO6nqdXHec9Uqs5FaqKcyLOea5dC1rqoTJUPUD0uM6/+PrEKeHYEkTYH2tGvFhnY6Eo60dFFjgNUrdNjbIPocoCh0ww7iOS++e8ae//1f//j/9yGlHJDJoqdaDxkPuioTWKA8fFRwAKExUaWJmHGyjR4aQECwTQwcr/8Pn/edNztGgyTFAUEJVtZMenzjOv/q/i0YfrH/xn43/95i/aKGHEgyPVvv/7df+6L////9l/////+qP77/9/Zp30Vr3dkczA61OeFtznMOqJLR1o6IhEKZ3XBnFnZ4K1fH33gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAACVn03gAcTckrRhvABQm5IHizeAAhNyOo3m8AAibnfqaKQUALBYD0JCXZf+n/U3/tsiHN//////X/////////////Wn28zu+7HVXdzFSfd7qpiPRSOR1elDhXBZ61GsRkaVW9mMJz6iGv0Q4KEaCuBcK6tv/6/+d/33VUL////////////////////+alVWhFmcyPnUPQITR1mSz5nRUU9VVpDlVCFbVkochUIWW6IoglZLG/6ASo////////////////////////////2RfJWygiNZ9zndWRTByO51yb3c+6IVz1qRGM5Wqh2VitqZ3CJ/YBbv+5oK///////////////////////////vr1T5+q7CUUpIIYtIUC0P0r+/XImzjeAXjfjM0tagxrQibQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABQwC3gAAAACsABvAAAAAAAADeAAAAAAAAG8AAAAD///////////////+uBfOsuPA09tQF6grTnZVLhU0BSRUMDnpDqwVEX////////////////pO45D2iUkLNEBoTJcGhWIhcaEu1rlgJcKBlJEjU0sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAAAAN4AAAAAAAAbwAAAAAAAA3gAAAAAAABvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==";

var CircularProgressLoading = "data:audio/mpeg;base64,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";

var Correct = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwM0EzIDAwMDAwMjdCIDAwMDAxOTg0IDAwMDAxNjcxIDAwMDAwMDFBIDAwMDAwMDFBIDAwMDA1NzJFIDAwMDA2MjU2IDAwMDAwMDAwIDAwMDAwMDAwAENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDA4M0QgMDAwMDAwMDAwMDAwODEzMyAwMDAwMDAwMCAwMDAwNURFMSAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAbQalSFPeAC3s1KkKe8AF46QVYZSgAD3UgqwylAAH8fCcLYLYJoQh0XweghBcEMZKPFYaZpmmh7m2HIQQhA9ZOzTUcfDArHm8QGBOGgTgnBcDrV7+zAnEMQxQK9/ujx48eRI94b9jV6fQ9DzoUCsiau/fv2R48ePHjx48f39KUpSm/Sn99+98PE4choE4FsAzgG4AWARgHYEMFWEjHGcEVjQ9D0PZ90fq9Xv74gPHkfdHjx48iao8ePKaze9KU///ve977xSl779KUpr4pSlP/6Upr3vvN7x7vAA94AAOAABweAOjh58cPP9/AAAE4AAjMAEdDx3Q8Pfx5E4QQWwTQhDiSgTQXAnB0MlHicNM0zTOtzbC+EEIQLmQsuajjyMCsZN4gMCGFsIIQguB1qN/ZgTiGIYoFG/3R48ePHke8N+xq9D0PQ86EMVjzV379nZHjx48eKx48f39KQIlKb9Kf3373wwJw0C2EEE0AWwBOAFgBYBGAdgQwkY4zIisZzmmh7PPRjV6vZ4+Hjx5H3R4wKx5E1R48eU1m94lKf//3ve994pS99+lKU18UpSn/9KU1733m8N/d4AHvAABwAAODwAyOHnxw8/38AAATgACMwAA6Hjsw8PD8QHFCNBMwUAIgwLtADQ4G3Ohc4B0zAnoDaZQQCwMbwJkJ6RYRExH4N1xAEZ0Z4fw+ELQQ2YPCSouINoSAUAiew9QLTSyTIJgBbU0TchB0hkUPZFGH9i8xFEzRy8Nk2KpOFYoGgs4+ViiRYxUm7nsoGQ4iJHS6cPmKJnost1pVoFUnhlhEQMQpA5qgDFgBmzAnidRMxQAsQzKp13MhTidUXCBCyiiYkFKpMmrmpkWEC8ktR6UXukda7Try8tRMrMTWi+kmJ51Lr/rO//1kYBIgSaJqtFVSSkl1onCqqpJSaaqIIipj//lj854g1n//nH+vw1EBY8PkE0hMALiQC8gBIsDiqwbsA9qIPaA3G0EA8DI+CZBr1FyiJiPwb+HSiVi4h/DIoWQhgYPCP4uYOwbAHBRPYcoFjpZJkEwQoqZmT5CDOhgEOJFGH9i8xFE0z5NDZNiqRQrFA0FnHysUSLGKk3SLVZQKQuIiR0unD5iiZ6K0XZTLQKpPCzg7oGKWgdNYBjQQuMwJ4nUTMUAKWGZVRdTiehoFxAc4WUUTEgpVJk1c1MiggXkk1HpRfSO750/Ly1EysxNaL1GSYjHUuv+s7//WRgDRQe0S6tFVSSkl1mJwqpVJKTTVRAsZMf/8sfmXiDWf/+cf6/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIkYDQB3dAALPs6sTsTAAgggE8DmqNw3jAKQG8Ubh9nKZ0naYEAuYXD+ZnRGaSgYAgCZSOg2VQpMLhjNLHGM1yOMSQyWGIQDWIukRCQoGUHT0S0a+Fk5VijomDllWL9l7GDqee6qj6MizTlnpkODDFxOirYoBQPonUluPByIDLo44UsitHWr07/UN505pikBP1QS2JP5Sypv3L0/uUchqOUK83HfVvn+atNUEsgB5Iw/HH7gd1I3OUzB43dgCnMIAWEo4ZMslAo6B1Y1Ck8K1p0WBNrI2tuFSvjA8LjdPLKWRUU33D61jf8wjuckt61nvDL7nMO/+e8sv7+v3/df//3n///////3G9UdpG4SD16lmetZa///////8v///////////////////taLZP/iYOuAAAAD8f5fvAr8VfvKkgxrZbBr6trZ5EJkM2VROhNBq8dYrQagrg6CdIiW3cbpgQEkyeURUdYoxERsEXHgdCY/lc2J0hiJ9IzMS9ZmsZImpsZnSdc3MzQpMWUi6bF48isyKRIqIixJF8tIOX3KaJcSKa1FI4ZMPs4O4ZENQHUCMYXUh+w6g7BUFjHSRAWk2JQtE6mXkDVj03Wgp052rWgpO/rt9rd////6Z0yMhkFqMf//+QpZdIW2TVBQiNcKY92AQMKEvBwVjAbCCodjZBp4LJxl5AgGChoUEDoANAw8DhrpFAJnJ6VydbeMtZa/UNMCbsrlxXlzCh8OVBgyXKBsyXgzNr0VopA2zdRRW7t6OQVE4ha1KatqNDOk8PsZkvDuIIXRySGFYskyLlHcLKIuXi8VyHjpDtCzhHIuEUQVZJjlIi1CURwi0DfICXB7QHPLIyZRHLDbh6EJgMEJJkDAkQNKTAwAgA5UBmCIDgIfkHLGg+hHossQqQpAjYgA/GJiQEgjmSjy0yKpLY4XkzpsitddmQMbUmSPMtFFnVXa6lrZ1/9U4MsIRA3sO51Gzf//////8y/5HW7lDBAwDmOfYslMSgovEj8y4ymiMKAk93Vf9IJQF1SJDYlTJkwRIg3sUdp+ofg61KXBa060vjSewyUaatV9b9K70ulGcZlr8wFLrtmlltXCm7KYzeNieIkURzSLE0WyiXUD5iRpsVSZPLICO0jhAYdpYGKYjmyDEGMyeWXSdKQ21l4gRFSRLwxpqIKhqkSoBIgDcNQNcVDSRQIe0FkQgGGNR4J8ZE8cIcmXTUmjxPGyazV0jEtpUa2UkZF50b3ul6VK9Ki1Tff/+sukVHJAwgMaNFFL///////k67+okAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACBBoTYPby3DDbOoAbzJuH5WhNA7rTcNos6cBzNG4lMBN1VSGACQCBwYLyBhiQg7AQAdNYwGAKUyDAaBZMKQsUwSAPS4hiISqFkxioCYAPBgu80CkoMHEIgJDqhYaBV0qytMc1VFiRcxEqG3cWmSFYclMEVyplG1pxFK5aWUPRZiZhBEk1RVo24VWvLLlelmHec0YDZIwVzozPRS+7r8PBm2rTIvOWKrA1kTL3NmaTBsyzyLOrDT1xaHW+i0AzFdw39vSdarERgRg5rqmI+amgSOZR6rU7iootCXpBr149ylUCRF3qaGKJ9ohH4e7Up4LkcqrZfrVWrT1+6/fM8Msu/3HPvf3Uv/v/73//+fv//////+/lcqt3fxetP1n///r52xF2uJBmlOZ7ISX4WgKiccBgKZr7g51TOFhYKbWHWwESsAOS3CACqOcpr3sxhzPdKtyFOCv2OyKUIFjAtA8URZ1Szk3A0DdgpochqU0vsTFnfOUmzInSbTIgR5eNDx8niLEPJwxYxSSTJmbGZiaEmZniGGxuaLNzxmbn0CGE4asZkAEDjQBCAXBgLoQEFUF+GXxyA44mySHKMSAlAiRkbok+geTMFnlpUjTsk8zQ39FT+3R0v///oGSysKMN843///y1eGGtpeAEBzCQKjQPkjZoZDCkFQKAJgMHRQCBg+FxpA5hmWDycAQjd4OJIUlYk74hyx0EIRSmxhT5gcIyARzQlObk0WdYMxBIC8/pKxDpSeSqizo6+zN4YjyV1A9slMWWXBIoVUxpqlNWrQLbmGVqputBMMSmNNkicoh2Rua71HDUqnIalLtPA5rfLWhUwyqDI1CYOiMgrW6GHJ6aaxNymUpJgoEthBczpU1cIzpgLEmEGaDkQCiRnKAESXKzlftmllMThqajN+xG6W79JIsM+f9a/u7X5vK/v/5vvf3lvDmOu58y/e//+//////////1LkRVVgF8sqUj///6aWmlLtM5BIgNIdY6WFFQvAFgmkeKgA3MMDNojWCe0UBYs3EhCASbDn9cNHAtoc+jHo84jpSt4n+W+pTDGrjDhUEISUGYW1tZcViCvtTjnL1aPGcubd2k1qtuxSkUHewy6h3D8ajqJRRIkiRUgg/GBNrL5WLBFxnyDERE5GBKkMGOpkGJ0iBBB3F9MgwrWUSsIIhfEPsXRBEOwAsgAWChkEG5BdDjB2EWIALcLgIKRxqmQUomqReIumx9ExPprekkjN1upa1PWp+jSqt7///8yLxqDbA2cGv///KAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgbZ8uDu9Ny1uz5sHdTbh/loS4Pby3DCbPnAczNuH+dVmyXIKBYxAD823k09eDcSIcwDBEEjgFwEMOgUN1WaIlEIBkSLFjoYiQAFSk0IUFgVAeIAeLBA4eqhKppTNzhNl9wKArncSCX8b0ZOTOwgiHC7AYGqNo2pzl4RUAdtlKb6RhCntJuLdty+DpN9eDJ21H2RMbTibkzt2XuzirI9O1Ipazh3oGopQ4KXpfCFWFMWKPNAsMNbhDWaebfmPQPB8SZGziI3Yq1ws5BJhhJjHZicZuhRwRL/ougoCDRBeNVyVKI0teWrSQZAXIeze956S3XygKHsvt8+3Q0ke1e3r98xy3a7+6m8td3lq53n7//7+v/v9////1yatQwwCAXtsL1aCC24IzkAfGL9dGCQrEoCq7BwGXgCFxkimgBCBc6BxfUiJoZNaKGa51BF4peInAeKgha3VqzcsjVMrY6VK9CmBCBJhseo33bk6Tc2MuTRVnhUUo68TjE7nre8cJ4pl4jBmiLkXKKxny8QYxIkUzAjSYQMTEjCoNsgBBiHmpLEqTRKIHiKFZZSMidIu5BiIGihyxzQ8waIBlCCEgDaAWgA0EOOHeVygLYGUE4GQyhPImZsXS+YpGZbdFjszbWZPZI/2VdXpVen///9TKUGPDPl9QKHv//+qGnhYUh1IQEhQIkwJFCTFQCZFAEAcAADgNpoGA2mGcX+YIgFKiKG0DpyNCERMbkLoiIAEOrqhQoPOFFhH2tVo/A4MAUwkA6t7hx4UMzMQ4BBamzEl2LEQSw4k61JlTL4SY4LEwdKYf5BdLelXyWdsvAzURBNu7cNwiYrvxCoZhD9QK5T625AvKP2E0p+UrTexYOA16yKBXimZh1nXi0biy+4axkDDn2VQAxZCWNKm7kGQhRUBHhyqfy2W9fVhq92vy9XVaWxiGo5LHVkP18u40dJlr946qSy3/e7yy3vu9/q5vP+Zcwy5//////++///////cypWBCxj9crN///8p29PxRdYCBhptlAcMBADVOQhBVZE0xmxxIColMEeeKqHoYhwD3ocVttqMjnqGoyyyR71DlA/VSHIxFnYcNdETmIDhDzUruX7r6OO//bFLKaLLmO938iZPECK46jUzJ1NiZLyBmT6z5usxI4iZPGosJAB2lUiyZATQ0RKxqZEcUlkwdWYEDHKD4Q+ofsDYCAR0KEBvUWSMEMujYLA4xSxKGBkTiRkdQKbG51BaKKDoOvXUtSqnq1q+t9////1JLUUCsYLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIRWhLA9rLcNns+ZB3NG5hIaEoDu8tw1UzpkHdTbmpDbOEVzACAGMBUEExRkAzJTBtMD4BgwCgEDAdBFMBgC0wHwPDEUHOMK8C4zwkINl7w4Mscx8A4YVlZgw7ER5gY1ia3CX+T0QBT3Y+WADmkwSKQ2wEKHwc+Jh5EmIgMCEQBriqqnm5P6whcpk2iZk/GW1+Vz2N+xyayc8lCWO7b/RO5HGgTM22kRYE7z+z8UrydCp0HvBQjltSbs8TwQfD1NDryzbMYEoIu3eWxuDHcYG0BIUyCCVI26QPKOlJ+IoG+G8KgDwxFmr9w66lapKMo1VgXsznWu45Wu87yvft3Mec3hhvLdWx39a3V/lrHDfP/P/7/f/X///////rVKhzhh7q+Jn///yVNKYacFW4CBaY9waafBakkzEGhIgILhmVAQAJD1gERmNM/S5LcBGLcxCApSgcSFCHYGBwDAjKeTywalroUFSHEOTttglSer94sSjrGo3IYnQq2vfPRuYn5brPWE3URIuOcSBEiaLpOHzUcovDNDuMSLmjKHNIoSJDSCkuRYYJfJUZUnxwm5qUC4eHUSZdHIHUSR01EIhcAccDZ8EgwTSA2DRQYC4ELMjeEcnhVifxzxQw5ZMm5xMzZMrkoaGySjBlp7rQZnZLdqnQ61Xobqr///0ymUiGDmCSvCf11mSp9BAKmH4hG00qBOdiRWF1DAwdxkNTD4NDb9FjK4KhYHAoGgEKxImESsHNnGsDIgwsChEEpYHftReBcwQKsvU8vSHk4hYOdpzoOEKODQFLxI1uqAJZsY0n8grectPYKrqVsvaE099HorRmO7a/GG5swW0t1CFgjXWcQuBH8c5t4288OTU/F2ivO6cKTObXsFvPEaKOw628Mv5xkTSYIeN2G6OHdTXfEQmjxAEAEMIYmc04hCNcNGBdhVEByL7KYsQT6TFZzAUNclcMs1faIZy25em41Kday1Yx7E7+H4flnlhrHLuq3ec/X4by5///8//x/f////6xsZQeAAYIv0dUMNf///mMq8QdNLQQhOYpRiYYhqXUWIPAWCABR2MczSMKQgX2CAkMr5Wko4Y8Ck63JsKHrWzpI3tbpPwdacN+HRh1K2WrSSefpUrEo3HpHALxQ/qXSNxWwPddlNPAue8s5idtk85OEAHPL48LJIpkkVHJwckuERdjQh4rxDysOwnSXK5uQ0ki8WCDEBMyuLiIaakGIeTx8ho0AbpDhDpAt6AqYErBwYs4G4w6IUchguUfy+OaShIGRwuMeNjyBIpVpFRSuipaVbIJdrdVdkq6////OmJiK8JWPLAkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACDFoSgPb03DQLOmAc1RuXjWhKg7rLcNVM6XBzNG4hl4mEofDgCoNCAMCpSQxYwnjABAZDABzAeAHMA0AIEgqmBgSeVAHwsYF3xwEepLIVEzMCaqAQwgBmggQePCJC9JgYGXVcuKueXZUNYa/izm1FUlO8wQXYciCppQscaO0lejpxFVQBGBMJRWqz6Fw/nR8r0kASxprRUsX0903mqMJbFHbMSdRfLhv3D8RYA2Vm8BowOCvhpcDsyXVGJK4rALrWJFhIWuNLlEpaAxMcGJ3BYeZJab1SD4A1ZDnxjRCK6xocUmkMwxW/dZieEHwXIrkPXeTNbGC6WYsd5rWEmvWsM8q/8xzy/f/f3jzuO8d5/3f//O/3f///////ZxmFLkBb5U9peN+cgdggKD5oZLi5bAwMTkIAugyCAWBXS3jSlqg4CUIkwlUQcKl5a1kCNIwHPCNEg7R5RT0sFseeV0YzUk7gOuKhWyymCIg30alrj5RKFvdnqxL4f/v4ax2OcREUGOsckiRZIqPliXIsZEcOt1mRdMB7HGMoMgWR8EXIYaEadSLBIlEjCiWC4XiaJYpnRziHlYQnC1ANSoB0wMagChw+ENvDBYqQdsgYssNjIcXS2aG5ZKanci5qmimmcMatBZiu6Cu1H63dX////Y0cVgcRmgzjDlqAFlzCANDPnQDYwbDC0EQCB5gMHDDCwCZoorgQqQMDICGKvOgSVMaQWl6gmVkJkxg1Js77OltUTfVJ0Cik/HBcF54BMAtaGPBG9SvSnfGE3k6aBn1x5wasbSda7Go9axpJm9AcUvOcqmmo3SBIcgSPORDcvgqFQ7GX7fCzJqkDQYxOVwBQuLZWj2K3HUgijcKXzXYbnIPijSrZKEpiusRZnokc0o1KgECDYGZ0zxci8WUw0wB2LUsi8ajstk0C0dSrnuxZs/z+6tYaw1ruu4Zf//9n+47/m/53/////////////1ljXcmUWLOf///00tNKXaVtC4OMocw4yFkDXQGQ2QA0QAE0cgDA4YSniqPSlCyYcQoIQIKcNcIMaMDhiDJ2PddeIrRge9TQC3FCeytOBp6hkETzOWGs5hb4tyoE9aPP71emyrVrmVOQEc8Y1hukBJU8Rg54+CMKo9l8fzQhqBaGqOaOkkCRMR5KqY5RMkbJImyofJhA3QMC4dJQXMZiiCOAREQNKhBvYRwOSFzQgQSQSYPeIKRIkSuOIxTKB41JwxKyKKmMDNaGpNjV3drqvSS6Te3///+XofmMqW0O///9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfjaEmDu8tw0+zpcHdSbh91oSYPbw3Dd7OlQc1NuYefltlqgICjCALTXOOTrYLR4kxCB5AJRbow2DA1bZgyECh6DDA1xBoeTSBI6PY8XJgwaAQEWhAQcm3AwCQDtda3fVlRQSnCgMNCtySDpTDarg4AHgsvwzqXLZZfSvF1Kgw0xRpfBnD6tNn4XnXwryyXywVPaqxK3KbfvU7VBekEQbWDXjqN0cl2Ii+qmsDSGSMKZs7My7EA9eZwn8d2u+66ZBi/UOP4j8vYzuwUSB1hHOicJHBlRaCJrwVvRMTDh1yb0Ql1mGnlj8g1J/+csXMsd95Uzr6xr81rWt2Nf/N58w3/713////v//////////y+P13TcutTE////Rjcj8AJvigIGBsgGHAfMDa+DgASCbcyDHgiMEoDS0iAQTBJAYAQFr6t6io6ELrHYPw+gGeyih58F8NCa0mvRU67WbJUsrXU48sfSMK9a1fd26zh7rsjsUWWFrVm3dQMi0SZADQniKkBLhXRJMsD5cdBNIDnmRNivDTG4UiRGZJUhg0iID2WUCcLBEyfTGcSK5sXxHIm8WsM7D2APuCSAR4QBDLgncioswZIZUmxTibND02L6zYnZkeMUTJFfWtTvU1ejX9BS1Kagv///1lApC9FmF1qIlBLZE/yQBARBAjKNZhUA7gABYvgLANLjKADzAlKjCgDZg4QGEzE2jrhEROZOTN4WANAEIwAElAfCF3Q4SctodqYYSytaDJYCcgLHLDyUBRqUAZyPAzOUKmUROOvrIRI5Syh1qjXpbDWOE1HpyNNibUQHd9utHL4zTMxdGC2BQO9zvOHP09VhzxSKGZI97Q6Nsbdok8WD7sKfiIKthiBpG2fUfeVfqgSrC/qmRzwRmI6oSy7wVCo0ipNyKkgNrkzT3bVBKYZmINj0p3y1Jt2f/HVzGt3DmGH5Zb3rn/lf/8Mss8f/8Of/73/////////a2DkhgmLbvo///8r2xF3EU3GgYbVqx0oCGDQGnOIhUYNABgYhgXngQcjwkScI5uIpYu8WjxtReeEZMECScsoOpByZZAsEtBomdSF64+pUX+aC878sNfX5WzyLQ/FHLYVTU0zGZ+xnWzxu0JoOaPw0iksjycWKEIMTROkaQ0uqHg1J0fybFpKgpccJDBqjaLA+SPHokSJlMXMPZPkRImQ0ixcGODVZkAcYUmGqQAxAaQDGhYsCkRc4YVGqQcrDhI1IlSILPF0ihfLhmikZLSK5cP6kHTTNNadkVJ+tG63Qq////MpkAwUWymUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHtGhJg7rLcOBs+UBzNG4fFaEiDustw3Oz5QHdUbnCXu4sOBAAMGw1NEKTNzRFMMAIMAAGMFQhAQkiEEDT5hBJWxpqEAhgUDgKsaioLMLNKDCWK2RU+bWrACXMGMCmJsOBKqrDJGTtMMJ061ThCov8uBlKiEYVviKgcEJ1mBXNYl0LisKp8MqtTKXZMfbinHJH5q0cfjcghmQR+adinf6grX7KdCObzyKFS5d0vfqVSyNT07yizlMLeWSRVfSlBd8dHTdM0A/ow75bZQWpUIzofeh9WULrd9gMJg6ZlVaedqPS+fnatLqbw5r/7fzvZdzy//1+Hf/7W6vf3hzX//////////////75VlTX1AYx949///6aaWxp2U6jBQnNI9U8QCSgJNhC4cTqBoeOaTg0CPGzsNQAl/gqOQKlznXARQjACwgwMYFDSWTtMgH2fzK5oAZLKpMg2v5uqaLMWbx1x1qwG89iC3qYDfvTNJjP9t6pcr5RJIV4dI+TQ1J0vkCHGWDczIgPsrFEokDIQeCTSE7EWPEKSoyg7RZJByyTCQ5hcKKxQ46i0iQ8T2FoAXHIoK6JQA0SENAAaDhdcLgQyKKKLQHfIaVyJDiJcpEyal0fZKqLiRxRoXE36aKlIrRWr0/TUlq2///+6RTKwqyQPO///9cZh53V1AgATBsQDSibDoUHBoWCAEBQRUBxg8FxszDRlMHBpyo8qStL/CxFWQ3CFmgOMrwqgIYf2sGDFSorLuZqne3hEGdQMMww7ABTqZkyZfZARYgoK1hliw48KciNRYEtUaazwP1TvVIa9BL8t065EOiazF5p+o5Kpl/csMI4v6MRXFgD8QCsxYeWx2A7D2UvHNqyaG5Q+t53r74wW5cnWg4ww4xMYELARz8FDo8YYhQwW1VKd0Wc317qtlCw/Lr4w1GrFLHb9Jd3MfCN//1MtXP73X/jjnl/93l3W8Nb1z+8z5/8//////////1epXVZfAtnBn///orUMcbuhwEIXmB1SmFwdggBGgIBnWEQIGl5bERGsODhKuy9KHFmI8sbUaJsRGgZa85RVWtORdMtizR5cwqfX87ifTUGrhBFL5ZDUpEu+B2qPzK6k8z6pnEnwsTdHe/O7aHkcJDhnxYBcROF4jhxEOclSQMki+XjFYzQyBExcg544BUSdTLBIkoXyDk4iOUTpedhwjy5BiFJkO0BQKDZQGYWgLjwMKBBIKF0BmxB44CCFwc4QTHouG6aiZJEi6mOm9IyJk2bWmixqgqta2ZSvVeu11X///0UjIho1i+y4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAAB+FnyAPb03LhLOkgc1RuH3WhHg7rDcNhM6SBzM25iMFNVScKgC4gBoMBdHwwmwegsAmPAJmBEBSCgABUH8RmQmDEA+sIWcnC34XAkbiYbYWDktNRE4Rige6igMIwSK2Ja9AJAS44KBk3JQx0LErYQQAEoKTBanSmaaBdqX4q9eNT5jwGUAbyvS0+MUNnnfmJyGFDUGn0lbrZQ9tw4ReUBZPTV5RHtYKVO2ly7D+1mQ28oMYA8j+075W4CdxoNumhb0X0vmJNCaeODB2GYkmbYeFwQ8bKBbDSyCdSBi6WWMOcJ3qWIupy9blU3cu/VuUtNWtfqtjjS2cu/v9d3rnOfj+eWu85+v33////8v//////+5lPqLvjFMLKctxRr6YAKE5synj63MOAIRAAweCU8wSDzV3LJAaYUIUEhGATAQ6lQQkqoMlOSiUnxgmekamLHWbUs02MWCsNS2cOAYWtOCi0KVjHYBTWZM9MWiUqj1KyOTS5oligppdT414Zj4uYpi+LA5Q0UiKnyoTUniKFcny6RpjGVIcLnHeGQjhPizymbkPTGaJgXEXjpiWzorpOqTKgtIN8DFox4XqAOAAb0oFioNygoFBsbDIIYBOjHCNhnhnyENiocImWygaE4bnzRIpl5FHs5scU2krU/XddbXr///6kTEoEaO16bcONfUEAwDiQuGu9rHIwxGFoRgEDzAYQiEOAcGxuYZBlWDgCyihUoKAoiBRoyIMQOQZL2A4sagiIy535sFhAm6ylLB9XYIgS5lYHdXCIDIYJMqDVTRMaqvlI51HreyvKIHBrSApFADEajwz/JmghMrkavknmv5spiD1VYlMvYyOA6Z/cWYZSSL0bX1/uQvdns/MtPdyV0UMSh/qd0ZQ+kPQfKuQI0sDHLWHNhvcInqECISSyE1SyVQyDksij7q2JyHH+eerHZfp+5+1ItYUVbHnP5rt+b3/571v//Dvcc+Xua3zPf9///9/////////vKW07uETaX7if///XS00Zf5dIFFhl6+HHwURCyQAgAqdmBRIZo+hjUIAQMxSEX2MqzMuB/zBiyydAc0MCAh5lQ8VXqsXpGHJ1uSr/GFpTvACDGwP1D7pJ8L/YBD7Wty9hk7Zi7pQHbs3KDWcVRJ4ZYTEfZNE8TxMk6LOODWHKIaSpWI81ImPBAx1DsGVJgpE2TpLEXJxBMfkS6TSzEjBmC6ZGwYEEFg2oQaAIMCMQvgBF4WWA3sFgx0jHBy41RoDPlgdBgXydNDY1MC0mXWRMU1r7rRRQ6u6+z9f////pl8iZLDiKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB/hnRwO603LWrOkQd1RuXeGfHg7rLcMpM6SBzNG4f53WdJimAYFGEQoml+WnQgthwZDICmC4pBwImEgsGuc6GjAoGrGkowMFCEaNAAS2MwfWmYAaLNSqHMMMN/uXogOL/QPFGdGQBytPFWFrr0jKcSMhAADDENYyw1h6KDgQJCmes6MqvUjMRqCd09m1S2orDd1Xi8k6Zc11+qjgsljL5Rpy3JcjOj3D72o4NqyqBmGQ1E4RAbwv2zF8WoU7uNalcMvQ+sJpMqWXo2iAiZwyZ76SjzBgjBDlRtTbrGiQEmgpyu9IlkscpLkUrxl/X2i0XuV+z9bP+XL2WGf75+W8M/5zv6v1995hvW//n/////v///////w3tTJsExSiq0ElehRchDAZn4dDIqAGqcmBUaAowWBM0nHcFGKKklzsmSQeQZLjgYvY3ZpC/VgjjHYEhVp4HngORJ6g0ApdjVXmKBG8mGXtuuygfN4L78MmZbBUgtwbHqaOaz7M4TRZICIzLxBSYGfKA6i8ViLlcukSH2XlpEVGUIEOcRorQwJlZLjcHNRMjUwOEuWJMEfK5ukOwG5weMP0DugYdIFoxTDyj+MyGXRZIs8toEoTAzZiUyIG5HEwmTSZaN2dS1tXTOn0r1sn7alK0UqCv///UouinitSmCSqStgVTFAIMBRRMZvbMOxxMBgQSEAILmAAFGEwrmat2mLwuqkLTsZByp2BkgHx1B02yIXDgkCPYHRVTWT7daBY0X6L5I7LSmm9FRZZQOQg4JEkEKXTzL6alAymsHxEBEUo6JrMhllDfw3HOS9rD+ymCcpp73/mXRd+67cOe77z0ctjjK34kFGyy/BF+Mw47D6yOGb16XQh+JNDsMQLHmMMibu8DYTOTONIVPImwuWXYYawYLAy1Y7aRtzYMn7c7SQTG86afv/hWraw3/73llh3Lv/+ud/v/nvv6/+c5/75////////////qvtutDbwT3Cnfxh4IAxoGcHLA8Dg+tcQBJ4jAAFNYTUSM6IRa1K1+V/l5SnFWxPqje8qgmWKrIoDcjdM/qgL6o6w7HYymSxoHHOUr9t35jLmuLIYGtzUds5T9TPDHKtMyTpw6PstDKmpRHYZGROHyGGJGEoXScSKQ7B+GMMSeJkxKZsVzp4oG5NFMurIadIuSSkRjRnhoiCQzQcgAFJBsEBoANmAt6HNElFCC7FqMhcg4lGpoXk0DQ3LRg6Ts6NLdBanar1N+30v///1JENFJGQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgAaEYDusNyyCz5EHMRbl8hnRgO6w3DNjPkAdzFuJ2B2mJJjQIGGYEmz0RnZofmHwAGBADAkbwgNTB8EzqAJTX8BhdADq6CimcuBJs9JBfwVAIYhw4xJ0/b0odoTLzSHmWy1JYq00aS/zpAxCIChEfVWTeaitFFEaAKdoXsQYczEQRmHYO03GQxWQyivPROZWFWGHAsBSEZvAkekTXYw5pVDB8rbFXh6ceF730Ubely7ypmtvA9EUkcbWxK3RZm11ur+P2sV2IwutNAuKq4wGLqg6oyMLsXie4IHO4yhrDZlepuJiv3LorL8MpJbnZVS2uyn4L3h/5bqa5f7v+Zay325vWX5Xv7vWu//ef////3//////8piUQIm+x+ppumpZc/q7gIGzSMXOnBcSATYQuHF2io2MoZYxWBkMVDmXKmd0GOBXYYT9k6J6yBmSXkbwu2I1En5eeN1YDSfW2/K4pDMqcvk78NvLG6SovuD9wzDU3R8tYZ4XCfHGM2TxXMS8TRFS6QUiTDsIgdLSLEALZDxmRjiyspk6SBmgW1kyRxPFIoE0fPF9Evj6L43xbQ5oCSGRwXISYsgSMtFEQRGiWj5DS2VTNRUKaZ4vnmtMGLzLqUtkUfqt+yPWyP///1KTHoghFEST+u01lOYAAaYJi0Zse8cjiQPArGDB4NwaHJhoJBrjwRkEHCjqowETHpyyyBicIswKB2EICREcBNZrqy1JwY0+kQNfUvEoyyvYVXwIJJ2BihVShTzgSd6IYbumAqkPOx4DP3JVA1flHTOE+MqiKvEFWvMlYPBsUqzjMlir4XXGGQy+HaSMqeYAx9R9pzVFduPAzFp59Yaf65E56VTERgmDnyxY2prCFVRorPzSst8YCBgQywsNQVpBQdoS9YzUkUTpH1uSGCLkxfvUVqvI6TmP/vGpEsed/v/z9Y//73rmOufvf7z//////7/////6+tKl1LymBIa///9VaZgxsaBAcDUwCqUwgDUswrYVgCQAEQACaIjqNHwAgyyDbs5ThIVDtBiaV8bcBYE0hWuMCqUM7RPtF5A8scaaoujajCoEIwGhO1NQwu17ZRD823CFTW8KKb7Zp5mOTxSNBjhZ5oWCeOk6QYg5QIGREb5cPJm5sSZfMhzB6HSYDgIqSJdSLRfKZw1WeKRsTZLm41B7DLY0BOwZ8BsASYBaD5hAUnxCYT2MwMyViqOEkDjuTiaZ1Rg5sigXVo/Wivtutfq+r///+pJYxBlSqwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHx2hGA9rTcuYMyNBzU25fYZ8UDu8Ny22z40HczbiZghuaWghANMAYFIwd0QDCaCKMBsBEwBQAQcBgYBoBgUA9MOcy8wfgGxJcYMwXEQcYGMHg+im0uluZWfKzZ8kclY0s5hD5t1RaZQ87P0711BRqXdBIR/QCEBQdkkBF1ngdqRxhiIETsHlUff6B9S+l3hLpqORNI53mKJhYQnr7wJKoGXtKHkicujkEsuhTjMTbo7kLgtmrVnBfiNxu5Cb0rpcZlxsq0sZE+KmCsgjAmOnGcAmgOKfHRY8BZM4sSXc3a3G2xV6+Vm3LJbE8rtnmPcef++Y/jzv77+eG////ev3rLLX6///9//////////6yrRKq0d/Z/q96Xvwy9AYYZA5xjfn5RyYYBAUBQyHzBwFEJDOGfsxeHQcZBDNPweNhwYsDwV6ERFNYtIJA1PHPDNyjc3nLVK1gVhUUmuMagIQhVLQhqXZEQFHZfS+l6v7E5U1hWKXYdiLwwilq0dSW4xUvGYd4X5uTJsWCeHeM0O4myQNxYiiQAnxnhQJMk0KEK4+xsCmECKyYuydGZHJNCGDTKxMDHG6KRKCdSQETHPDZAM0wBCAbWgT4Q4LNCpDSIsL8mSYFkD7Jo2PpEMK6BqiaHXmiSb1JnFFwyTvobK7roujq/r6v/WiYJi6Bez0IZupASBcxCAI2ddA8WCow5BUAgqKCgDQUMCwwN8AuMvQMEA4huWAsSSUdyFKMJKUOiAgwEJMSIAAWnDjYyIBArGIYcp34DVkZu9Dd4BAKmgJGhAOBw4IQcd1fQqCp/LxnVdN1CxwhdLW6qdvxUnr9Bm68WnmDOMoTDsVztx9h0XfJhjBoiyCmduCpNCbUVe9YixIaf16Ycmo/OYSOIPS/0PxtlLY79LOSsuYkAq0aaa0JIF/AOovGgjZKosv+UNmY+7FJhuQxGfoaF+ML2O950WfN46yn+7y7zn1d4d/nf1Z/e8ef3L//////////////8pTQQwho/08rGY0/rKi5pgOIxkZIBsKHAsBqfxYBsAAmYHgMZUP4AiiMIleS+xrJKYGBnEkjbKncR3BIx+LFqX0aFIpS11B9MVhK8XAbEMVuYmylTRshe1dsaUxYk3NeEMwxB2EBS2EbvcymL0VIiQAXEKUNxlTQkCyaEuT455Ezwxo+EEy8kQwX5Lj5MB3ifTMcszLxQIgShRSKxOm455BiyT42RCogcR8LYEEwQnBJQyYLNCxMB4DAag+hCcaayySJIJG5wnjAnCLluhSM1qfpIslpPofr29v///zItkHDly06QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB9RmxQPby3LOzNjQdzNuXw2dEg9rDct5s6LBzU25f52WVJUg0A4wEATTDRRLMhgFMBAPDAAoFBeIgGjAQBOMSsnowbABBUNBAo5JMAl3QqEC4cOhQ0HkIIBBsuoYqhDoEHDUjk8ViIGAURS3rlucoAFkcBAa7lFV3ts7UCqjbLDzP1hkujFw2EX25vvR37V6rOXIehbyEg7+r0c+Ext8YYhyD2hs4h/J/5TWf5x2dLzp3HTBpYRAkqnorPzjoz8CtjtUsnfKV0DdV2smVAghMFsThR3RuVpCLpcmu05Kp0mcr0chpsZnb8kr081It4461fy3j+tzNW/rm8uYd/Pn//8z1/P1/O///////////////qvLYk+gPFqzEBtwRnCgcGMtrGNgfA0BVniQMI+GAQRmnI7mQQDCQSAkFFFCRdoYGAZoUBfKRsjQzMLFqKCsxErUNt/JGeP/FGliJdzwUkXgfBeLiSqkYdewcldiO9+pKJQ7vatmtcg+usgInlAjh3OYEwakVJsdgucfjiJNJEaZGJgQcgI7hyCHpGEixGuganRaCsbCtTpVRKhBiXJkLfggOB9IM+RQQFDTBkhojFFnkMM0ySPmRsUy65UL5ktTpmSaK36CZ56r3q/o////+uoukwROqWagNkCE8GAJGAaDGYeSdZiXhEmAsA8YBQBhgQgBsrMB4B0wuyazCkAVLAABLAQIdcOLDDM2ppOxMYCnDGFjFnj5DwUQUoZjIYxGjFhl4shIQVAvsdfmbIrEiJeEtxfgxAIv9SayIaf0BQWr0d2u53y+zHcYrOwa01lixobdqxIJU/kMOszWSwyyxe0qrPeyh7YKgxvnJemCX0fqIUk7H5utuHre9XWXQEyJQpyi/7DHaOVj6ksqHvG9ong0z/vbB8j9zHtis7FKWUSiHNU1S7bkl/Lmv/D79Hh+v/96/ev/8ssf7zLn9///////////////t7k8oW4wBaooW2iow4UnDTgfEDQKCYJAYUEAADgAIZyzImVxm6qAt7owBApCIM6NVGBiCt6UQUAnjQIthQC1OGp6ZbRhRWBa8/r2gkGl1LkLGnorpHPKxdnLyNJguIL0Y/YmnappyxZyuSPIhhPjENBkiLE8Uh7Mhzxwi1HScKRdJ0omoz4x47yCiSClSaHSR6A9EHJcoESL5iWTE2IiRUsmox4hUP8LPDQgQVA3PDGwXtAFYAQEi4zKQ55BSsOMTkO8rFw+kmSpeNDRJJk0DFXVW6rLpqrW3Zb7f///+UCHhtCTegAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfSZ8QDustw4O0IoHdTbh4dnRAPaw3LjzPiQd1NuJbCnMVrHgRDhfNpk1O2wGBw+GBQLBUXTAIITC8Cx7XTLMGx5aPOgoGBwBDqFkJGECwILiS4ThjC80JVIVPOUQ1CUEZdlrZhgbrOikaFFJqyJRdhSdTMWUCIChWqjHWVv0ykwoZzuy1EyPTsu5V3BMtXtARcJ32VtmnKsAMctN8tKAYfYe5jiU7M3ZY2+LrMsj74QI60OWYdlMNxp930duvPthlM9YT9d9PhuwUAEZAA8BygucWDVvo3zasL0rtWtBTWH1vwRz9TVLNS6rhnT3pTzH949qWMvy/nO/3DnP/XMufznN5///////////////2Vascl/i////olURfZmIjAowCD8x/vM2EF9pyfpgCESShgwHBhq+RjOFhCIIQQgBolkgpxglUtFBOg6osSoDTGEekGmtP9C25KxRJoUocB30BpgRBedR5VrbwevaSN0ikARKHy90Wru1T6iWNbCN03SDjjE9EVGVIe7D+TpVJYZ0V4ghcLhNkqRgvEhOQjkPjGQJElSIj7FnjLEeTAzhEEllwlCkNAvnRnhyBfCThjMAQYHFwGqQFwhbULIA9ASkJ2EwGXE6izDQhxRNyZciyRPGpiaJMZKdHVdkL6qO/+pT////6BmeHLQOvDLtNJUqCwBoBBGMHZBQxtwUAUBKp0YCAG4kBYYCQFBizjxBUBIDIlHA4Mi0YAKtU+wNIYDBCRCYoe4Zw1CfLJkVltt7ZS8WfSuK01OBIABUxAJJgBfJupfCTPEJBXjepr76schFJBD5xuapI3ndgb4EddL1zpA39FPyLF9btaFwY7MrmtPK+dCriONmbI9rbSx1q7+5z0bcqQww/EDQbDMXizI2/bEgKrnGRrmYgl6R4TjoC04HHRofZgD2wy7lLKqCm+MYW6XDWO793D/33nOc7rvO93jvnP/9/j///8x//////////////3qgmGRNsnrR90FpiACjAkTzKjZTNsSzAYGAoABgCB6N5cUzRUsIGRty+rsOunUYEWFg0NK2AkoPJlMTpGS1AYDWDmn6XzFHhU7YvOOm2wQWNGGaIHAUxk62KypAm5tmBoaHA8nqrlZ8zS9n27WwtlYohdMXCokSADiYeRzCsXiQIwixPFY6mOePaZFSDj2RMbpOERG0PQ0TcsEVLA5ZFycJ4fA9HiIBa6Hvh/w0QBGwAGEBDIgW6J8GogyGMmISDHjOikhZ5mTyBqXyLIkeaGB9kSiowT1MbKZM1rt1fbX////rrMRyB3kRUkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHbmdDA7nLcvOs6IB3Um4cwZ0MDuqNw62zocHc0bmMxJ9WZCIATA8KjH77DUkXjA4C0xjAwMRADxgCAhr9YpkeFKXREmdgxGWkIDJgeClMGJiIZm7OT3JQDtJRXrLtYeEDsMQTsDWFWGMLQH7qCxN2HLVeWAnjbeML7oGYBUipXld6mm4rZpNxrlSVJ8Lvd13pZepYTHb2CuYebShpa0Sjajt51WvxJrtKyR9par2NQ/BLrvg/0ViDsSGHodd9YoMCnWEGI6IumUARRO9tRIQva0FijbqxwFGZ2csTUbkdSZv517dS9bz/et8/t7PD+d/m/33//9f+v1r////////////////86aCnSogC3DjX0xAMAZg4ExpjghwsHhh+C5gSCJgkHxgKAwACcy/OcWHAiHA4SYwYKjm9EZwBe0eUwlbDCjgqQB7Rgg0caTCZtVYRgGroDS7DSLQqOGgTqiQoLBUkGyStSNduD5RBgBhx7NfljFFxSG1hblsqoh2iTBi4jiCDlOQQgpPDmjkjjIsURbCNIoUhS4vyPE3iCIjwXKSxDiGmBGjlCljAmyIG4ypEz5UJ02IkOAQkGCOEAUwpImwLQQBPJoLHxnAtJDIwXYIDCmFUaKLkTJ86YEmgRU1SNroGSOnUy3fd6bW9S7qem3///sYEOD9xcinu///9N2UPupQFwBMCgwMeeCM7hWMKwNBIAmBwLBgHGBIoGKVDGHYWA6SLA1iMBJRaNhxSaSUMLVUCL+Drxmq0XvfF+owjaJAoq+UDrmEdIMlJoxxgLqsvRNgdLlSqGG5NbHRNmzLY1LJfjrVyHacophfonHIGO0iI6B8EqSgpMionQsidB1KWPwuEnEBgCky+bDwXBlSKGRuPscwpGRFzIc0jiBlcUUgopcd4b4AKVAtTAXLhp5Eg9AagtwqwyKOUWBCpECGFI3MUibMTc2N3Oopmxmuyk0FnlJ6T3r+g9rr////dAuF4iBPw8/LjK5BwDGEgLmnc7nTwdlAxjIDgkUDAAFjBkKzPAbx4GTyDJAgDMBgXAZ+epxfAtlDQAELhnd6rcX8V6rXZbjbQzDFIg3SUDDQQErCzZNBkcoR6gJ4l/QwuVLQ1AXPhyq0us2a9z62dYY8W0UMHTkTIYVCInCSHUOEXMKBJ0UcdyBdLglyxxjoFzF4T8K+NMc8ZsWWXE00hnxQY01ls2LA+h8C4g90QXG+QIBKgEQ0B4QDQiBOwjccYeQOVE3DAFfFzmCRFSaIOWC4VC8kfNjQ6YMe1WQN3uktBa1Ie33////uZDqKJAyIM7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB01nQwO6o3LvDPhge1NuWlmdDg7mbcuzM+EB3VG5jUMuksCIwGMAhTMb+ZNwAzMFQAb0wBCxOoUBc0TGEyeAsHBgsZQBmEEEA0KLzVmC4hgwSiyQCDI8NEItVZPCLy+JqGxADB52CnrHKBhSSp40wqXO6psspFFki0XwcAGkpdeoJx+43f5jSR6uSIfUPZEJSCkuQQdoy5BiNNRmymTJ4fJsREnCXBvMITOcJgqEgRwuQd5YIwbhufJUukTIoO4WkrkSD5hHAm0Y0AwKIAAYSSHshgkMtBcyCg0WoYQnwiAuAZJEhCJkyYmJmYE+s2OIVmKfUnpJUWu9F+6tqu////oqLBPlAd+VWINLTQCoAZgHAkGGWhoYigPhgPgHgIBMwGAFmLBgDphJiQmDABaJFigmOijAiTABhAWIx4FCoUIdQEGQ7HUMggJDrFlYXEbIgs8BhByrXLZaQLIbMwFchAY36a7DZweDLTpmbLHIitmVxOBrNW9QVI/WwKw7gz0bIoQcwY8dxECqXS2TA+hQRiQQb5qSo/CzRAUkzgwy8Q8cJJFMniYHgvGpEh7IAVCycKBOENC/4WICDQBlAekCxgPOAUwSwWaJzEBxQJPDAELmJwc4xMTQlWOk4cKi55Vq+ikbvvo1W69N2vb///1nCBj6C50uJzalcMMrQEGBIYmaFpmTYogACC5BgKAKswkBRmkc4kFYkHi3hbUQigxcT0XqCgnWFQGwiZ6dKVMgooutppS2khI4wF8QvwIUhJ9yoPh9f0OO89FM7EjXyFVdUz7X4xlap7MqqzZaICH6jnCuEMIoVkyyOcYCujoRJkcA7zU6RcWcNYiopVh8m6ReJokC+bkBcyHo1MDyRTL5wjR9hkQXOAgwGCwCKigQbpCBw9oiQgKREbY6SCjoJwwZJSRgZnD6l6S1v3MkWf+/6v////UhMyTGROTS6EtnVYJAkDhlNnyeOxgKMHQBMAwTFRUMDQGSsAUMGKIOg5oioTJUtkqhYEblYiaLGBQcXhMEPOWddBKNZ8qvvumOPAktmWqmUWGYwcNYeDQTzpDMUEiS5kZbLxwxUUqe2QuC8EpjVnHcOztwc8pjMlYPudHWUBmSkSh4gRNkTEfEHKijhASaDiSPFiGSFuJ1MQkL5sQEnDckCVIOQ0mjAxHQRRhBoW5BsMFEAGZEgOQAKEg8QAgEHMQtWTAX2AsAC+hNCthxuX3J4mSdJkjEjMqE4lPG6TaKzRa/bS+m67e////WkmQUUoYkXaOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdvZsGDusty8gz4QHdUbh11nwQO6y3DurOhAe1lubk2+i8y+hgiIJkdkZg+H5gcAxbwSAMSAkwYDY0vngw2GIzwVnogBmLApgp0nIIlBBh6wgYPMUOM+uQgaU+jPkg0l1eMHVkSHlULEc4eMAo8JHGnL4LlKqv68bePk3ZWAxwScnV5LwkcbuzG8pdJrcDIcHPfJ0YtDUVi+Pv5C43Dj04WYm66w8Rf+I06/4Jp7McfRrjSonKJbKo1TRt3rl96m5rpopsiUMIsaANCFJBSsMAeOCmkxhrj90EuypLc1L4rhDNfPK7dy3z/1rde7v+f/87r+f/46/v/+e9///////v///////3Wqz8OjUr+v811MYwAAUwNEYzWsI6dBooBwsAEFBfAoAkwTGNZDDIFhUuTXTLj11IWCA8YxClvD64QQCLbnkFCRpOl+mcSZjKwrW2lNbp1aUEBhwwcDFiaFS7kGUI1+pckQFzIWk0YQs61JPLFeSFTsg576yEiAecNeK+Dao7jNAgRVLZMiyx9lMh5DFENKRLBjEUUYIpYg5DR/E7EiLmNB9kRLiI5o8k6aEUL4zRFyChc0GAAwINACo0AsYAFgAQNCxUG2RQEzIgPAkQ7FjtE6k+TRXJo6QeaFU+dWXTZPo2PqZ10nZ00G7srpv///+onyZFmkkRVkWaOQPelaYGg+Z8IKbFhOYMAQKAYDQxGQOMABXM443MTBDdEeYKKJgDgZaCPLzKKP+WBYNBHGEpoDIovhZmn5bRh5QHeuVQACVwKiiMOnip2CgDJEjVwOW6NyAlDhpcuGacmkuYWLO6ti00l0CUJTV9mpwzPQ1HWlQxA8pmW9irk3IFdiPQ+tBtoCfRzYeicTo57J2ZXZd2U0TY3Gg+gdx62tTygosiYsI/aBhk1h5ZGCLRCJRZ03KZxR1cs4lTXaSkv/llM2rP4f/csM+87j+v/v9/+6/+c///+/v/////////////lGqrdp3qJTBTY1ZCUAURAzBdDYwfwgDALAVRzAwHIUACIADTAcCpMD0AMIWl2DGgAaBCpYhEHJCEoVB0GnQuYAJ0zsUODpVMXYM2ZqzoNkbm0B5m6Irl8iJCWeLpLFb13GDO3HmHNjQuLR2Z+QLyxp7HMKruvo6cKc1Yy6uvu5GEpYlA0IhyLwVMwzXfpw2GPdPuBAUTgbGMO1JI1djturfmrdZtJ+gcdHlxGCI5GFGa0ZrmBxpc0qlEIMrUFkcy09ypiSc7yN0lvlNVu4Ws89Yf/95d5h/773m+47//xy/9f+////////////////eu5x1wdggAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHSWdAg5nTcOks2EB3VG5doZ8ADusty58z4MHd0bilppS+yHo6AjA+0O5lYmDJYAQIDJhIImDwiesDpr8dg+gAkCTwFOGkTCAAAj/scfcAQBgZzgr6egLh13sZAwJKtYZLpvGYisQezcCFUfk4k7VpLyLrOvHoccsAbrXjsWct/ZyKZy6W6ge66q2k4V95RyxDTCXI5GbVLPuVD24k+803KOssnp1wHJd1wXFqTTxyypbpaWMxd+YS4cPqiQiBAJG4x1gtUYYcXHL8JKNq3RicHu2/T5xW1fpb2e8ZTLaLL6uOGX/+86s1l/81n39f//vLH9fzmv//7////////////+t37UB+5Ocsd9YhccwMDgzvmo3wEIwjAMsmYHBYYHgkYOgWYdCMLD8ClK4DJARZ+wkxRExJQsuZgKIBppgYEEH1jFr2sSJjdaLt2RVL9xZ4HuRlR6AIRnxEHR4U0TJfhrdhskErGUEtyaVQh55RZ7M4YRYZdggCCak8SBJkTJEniKGgr5AhbxxESIgXi8ThBQ9odI4Q6xsXCRKA8E0TJoRIlhmyCGRmURxmaI5YjYTEbIN6gMHQTCgYBUFi4WHBhMsBq8OKG+HIDPETIwny+bGxqyJRNUT6KClFw+p7pJvdS9Vbv13t12///9aQxo656tyPvQn+MAwYmPAYiggIADZctQmAcw6EQ2FzYxUEQRm2DI3GOHqQHCxgCLLACXVIZMIX8MqQe4HNSqChtzF7MnWDMSHSrfxhsMg8auoMCMyVIxJwIuRALOncdkxi4SDUjWqRzH65Vm+UmNRM+RKhU9AsjgCNSmIRqAp54W4yKFdjjT3BX3BD8NcgF+4bbk37+SR6W6fYb63LYm7tWs3r8L5RlGDhJAviA7CYIdAR4hKNUcZytdrb5O/G6splFbecus8zsY45VsN93u9zdje+f3//Xf/eGt9/HX/+///////////////3QQyz6G8lI1GX6ZagGIg0NGXROChBEhHIQDGRIMDwKEQZGBiHAIPCETBA26YsNEIYmYVqCKLPx0jDgQwsOCXQvCsmKMggONLblECs3SNbIk8YKAA4YEgZHqFulE4utuQwQ1yfDgLKX1Hacabt6qyOvFi6N8L0BhyEJ4tjuFcLhcJ8bRVHwQYi5XMiVIuQEcJUEpiQkCHPHII4myZJ8iSZodFiIgYmIuGWSuOQFzYWmBc2BAcBkjgDRgAqcG/hwIrYPfGPJodZKibyKjDJs6XjE4VzVNzNFNBkHa6aLW671X6Canrf///+pNMi4hpbNQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAABsNnwIO5o3DmjOggd1RuHfGe/A7rDcuws6BB3VG53UlcMMPAAGGNKvGfQNBgLtOBgCA0CgQJ5lXipikGY8KDB+iSzlCEoHrFUAu0FASJZAUbRaXEqY27kpZanNACyNwzDqcomoYQyVqljYlAkV3pQpYnKXla+ZLCMEfaNHJ2VXbeWHImOWJifHkfiZKpudJAcw0UXXKhfKCJ8zHSYlEjyqaGItwyxbJ0vl4d6YxpDy8swKhPpEDEZikS0GhidgGL4IhYZUL/A3QELBvg5Q6B3Ij7IkTJmyRcJs8YmbpouUDzMm2t11ui3dSutXrb/+//zFiHETLCUqglsSiZYAwQieYJ+mZCCiYJgcugDBs3UOAM0pEkxoA8rKmHBF2BooCALIDMpXrU9VCAphVZw76FTqMKhLlJksRly6WBs5ZQVDQKtBC5bCJzgpDp1CoVRNrEOQY+gYIk0Sfilv0tJcpKefjpASCBCGEIRnhZozpMkXGXIMRoxo1hpEFHSO5AyLoncQjHCJ2IeaFErmRExflknSJmg5pE0SAEBWVzcoD0JRcLxAiPA4gAEIsEAIA4MIaJ6DIRBR8kPGdEtFynCGLKCaDGZemqCLFBN9SKa01WUr9up/////pOPkZkmR7Rasy6BWTEgImWJIm4QFiQRgwAzAUGg4ITCEEznpRDT0Hg0KbMcMDAIAKhQEizIlGOJRUqeKAw445VFxVjy6WN8DSDBS17YW+LZxcHMBpGn2qwrIMlbKkWsGydfMOLIBNEaE0dNOwbAWrVWJw5Tu0z1aT8wK+c1C2sy+3Nu1NyV8nHZzi8bgxi8uqBYLac78Kh195Y9cHU+GEWfinZ6+je0jclgW/EmqrmMAc05yW0WrSaT1cNMRYeROPaifbNymvQ/ZiOUrxzr15bb7r9Y9pc8ub1/O/vPf7/+65/5a////////////////3hKcHJpeUYRtyFhy5BgiG5oVfJv+Epg8CAIAwwPEEw0AgwSDszabseMMwhMIGDBRJEFAiA2d1QwRPMwYYDNigyeHENDmaEQF/MHwXmmopsi2teGgqmA4tAAl0lyqk16VQFA8BLOYMkeNG2g26Zx4vQUVatKnW4XCChAED5CRIkXSPJQgp1FMWAXOMsOSW0SHjkEkJqMqKIJURUzJ4kBwkaOw2J0n1DhJxhqm5PE0K+LjC5Qe0Fxg4kDnlAvcAgITgeuKTJsRqJ/IsLEMwLgIsXSRIqVTE2LKycTZBSTUKjqzU2S3bZdupDsj////rYZYXxuhAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0lnPwO6y3Ln7OgAd3NuHZWe+g9qjcPKs5/B7VG5ppTEm4oIjAAQTFuezNQWy5EqIACHgKCgmG1vHGaAnHHPhQsEBygur5ACdgKHDRkFLDJg0GCNQjko0xWRNRfxfqOKc5EHkbEyxEWHSKXy5bnyhZsclETlcy8gEPkxuxbcx9IBvXI1KMr0EN0dJKGD4CeWasSF9oHjy+IKf2ExCkm6kMshXQ4TN20f7VZ23Zd+rKJuJwLvOLxaFRqYVyg4uhAMgCC1CGZKM1tGhRJi7LHZYZDkBv/hlMZS7GRUuNPRVu3a9bHn7sc1Z5rvf1//rX//6/+a7/5///////////////vD4jG5UK1GYtArBiyJg6Fhok2B02AA0MiQhgEGpgEAZhKMxo5QBgKLhlQyXrd5JRfS9DkiJrAcNSkFFqE42gdfxgSc7cpyWMXKAAGBgcATMraWEUanizbiMGQiSqQJsAYC4kPKoGBEbj5WII+R4TeFy1Gy0LOCKBbTYigs4aRMjPkomkLgLhJDlE2TJoRAfY+hIBHoucbxPF8dwsJWJssksWRTxzyfRGSH0RYokkDb4fQOYahtYHIIb4MACBAcoLEAuiH8IiIRjQIsRQZ8yWUUiZKxoXzNkqRob+guipdJkNW9d0Hp////8zKJWJE21NxB2xEAAYAoAJhhFbmJmCaDgMC/hgAgagwA4GgtmGeiOYfwNo6geoQBR5wEBRGUOKDY8ha3o0dHR4PZr5Fk7fpTzjjN+LElNmoLWloXdGrEiyQMMI8NcZmzpvFY1jzkoT9CyIWRP/ybsu9y3Q9lDtjbDUxmxzRW4uMiA2Dw3CoPSJOlseSPGYHgbw7RjBXBZxDCMKorwdoliaHyO50DcmRoj8TxMESTjWGeDIRAguZCwYBqMCJIApEHIh7pYDGgygyQlAzKBIIu5Npl8pEWKyN6B5FGpSlGCCkVa2S277KVT////QTMx8iWnjVUpiT0qzEACJICgOoSGMiCAKgEr/MBIA8wDQAzASAMMhEJoxRARTGpQcCMeWASkKBhRUZK6p2TCWoGXAgkONSgqGBxVW1yI5SFml+joEDGozDg4EA49lyfQ0AQkCQVpCgccXpDjO2giJMqJ3Hxa46ssqfPUckkZNDGhAIGSFBjSHUQwV4ZkY4pDYJUa4oYmykYDrIaKGFwj8MEnjBREh/J9AgQ4zAmyCkGKBiNAdBYLo1TQVoGAg0MEm4ElYe8BgwwYDKQZcFmCNg7QZdICWjU3TMzIn1lU6s2NFIGJqm+xtTRNnRd9Slt190+////045JHKnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAddZz4DuqNy9mzn4Ht4bl0hnPYO7o3LprPfQd3NuLM9IXOYqBgeMRBaOAwiDBALKEoVmDALmI4YHOiNGXIbD7EwQZ20tRwQDiZoyghAlu2EiwYHLDWFhUSvluEgl6qDIGPAwul62JeYqYG46bKtiBj0u+sbKnZ47qulfgl0lZeZAzppdLO18ZTG5svhiwUqbi5RmxpkXOEKPJoMuWR1EWLZdKTKIOMwJTJAqjQIiUiZKozQ7iJDjHSQUnifNiKDJFBY7xnjYioNzAsaBBJAwR4A4IBAEAULGZHCJOKoNmFIFMfQzTGaBKE4bHkTBExZI0QX02SJ1BlrdSqF+t1XvQ///+qWCSGaMWIucYctUgFABMBABQw2TSjDkBwMC8BcDADgABYwCwBjAJCrMQhIMwzwXRGUCElMDB2uAIMJRA40qDhNDmDgIxkQFAEHWEXHgFTmebxsiXgMB2Us0iK8HyEi9YZAHLmAJ1KxLjYJAcDrC2E+7OLouVLbs3Oc3m4cccJaQ0KTYwFG423eXvA/VLF4nAz/1nrWPGEl1yNxkDQnTgx94vDcthyw48rcd9IpyRSGyyxHURASDhYQIgkTjRCKsDWKbVVZKlpk71Jfa92m7DFitNy7+X8Llu93/7vPn3//n5b/mX/+sMN/rXdf/P//////////////q1ow8cYXpZVEXiSNCoMGOE5GuYlAYJWhgAI0TzAALDjGujRQNBooJhQiI5iKgQDOSJHIZkpQYQAFQHMZLWUo1sSdivBTKWaITisAZC0yRi18Y+CKOkIOX7QFL1U7hbiQBTxcIEig547TYKXDLPlPKtEGEdhqYoQVEkxc5BCDiexYSmISniqNInhzSeGqQAcIYKJ8WgPXD0RlRmiNH0VyKCzSeWRAtl9Q+yCETK45InEMsBs4JhxSoCwUBS6DAITGhqRBBiCEYl5KEeQpACJoFYmU5ME07JugpExZVRmki7O3e9Nf2fbf///0JIEOJZmXS2FNRSCBQmmIajm7gABg5jIEiobDQWmGYsHGnnGzIoAZcBgirYq8eJjGhU0YkbCBg9XI4DioCcuNzKd0MwTDj6CwWxp6FIMOZAzsWGRIcBgMnI3q3A4IigOAHKePrWBogd+2zF7FrOzR1ZRKuWCAj0H8At4aZVFyoESFmEXIIQg0hjxzSUE7mROkwH+FmlQY8UoMsLwmiOLZMjqJwnzguFImSkMyTZfL4+AycLYA3QIwBGQFeABjBQQGRALhC7AxmMeQUTAZwcqZqWUz7Fs+TJaTprTZtDSPOrrU+v1K/v///2cmh8FAo0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHJ2e9g7mjcOGs59B3Um5chZz0DmqNy9K0HsHtTbirMQG3AVAMRCIYY1wY5DQYEgOguNA4BQAGRnCu1mKgjnC0RPN2BwgVFHVjQlShLlOYoepAZcQSp9vrInfbgDRhoRMtajrFUJJcMGEBZZhA9hSUiSV9Oqajj/pMkKo0rfpn4bWmk+VirblZeJEL0hhUa47BwkQHKGoM0bEeQ0c4uERLiimPohBSoohDBPY6TIrHybHYdPGxaIMXC8QEZlEnjYiQ2wsaD0A0kLTAGtoGUDAKEwYPBQAHBCOhSZZEABtkOSIETpoYnDRI1MS+6mPWR6zUydluy9/7aq9mb///VMyaHs/TWqySC4gDQGMJYxNDhBXMxgEg40MwwHA4Zz41gGYxIk4AkxoISXIIRYQAV46DGDRYEBh4EGjgUCoJYiq9hvH0SFL9qVoRWofTeOEXAA0SCpFJGzqHyRzFManE5wKSpqXkoa7KZFLo5HpDHidEoilg4IV4mDYkRyyPIYZDiJYmB6HcbJDLEuRQvDKFIigzhFTIVRMEOOojMEQHPH0mUR5IgVjcVwmggALcgk4bkBeAbBQHAgTUCBB2CHCFxnBNgzYrYWc5PnCaJ4yLajN2XdSVHd0LMrV0Evb+////qWZDlGhzO/ORdxEizDAYN4sobpBgMBiEChYdNcMekI+VZji4KMIMEgbEmEjAFeoSOL6DAYvUZAUsMsOXwAAMvMtKJLJYeKBltP3AaZxCfGnggBvqgwxGCoZaghMmWVLoZaMg08cHw631ypfu0XJePJGFQaIcqQwV8ghqQ8W0iY6hSJcG+YFctE2VR9CPRmUydFdLA5xokKXL5uXhwjGCwpFswIkSbifSKkWD+CXAPNgPagZUOBmwwBwoLIBZhbE2kwPogBGEqQ1BMi4+TYfZ00NkDx0wZLU93Umyqrvd+vW3W/9f//UxVQJwbqvKH/aCQgLmC0RCYP4HoEAEQRS0oASMAINExZ1cTFAChNcyMS3AAYso8i5jPxAqJDqgqGHAAOBm+zioYvcX6g2PtbYKEBC9atigAiAiBEdBSFUBEiRVUNRsDg8VVhkEpdJb6vESIk0Z63saNFK9NAUPREvDOChxDyLkXEJiqYCEgppFCfI4ZQZYhhJnSmM0OALYCcRbBUjVAT2NYTuQQc8ggfKfJwqnS4KTG8XTQaopcLmQ1WE0gKgCPh3gbAgNQBsUVAwiFpI5ItpEiCCcBpE0RxdND5mTBEkEzyCy3QW70zBzyb9qr/3t2///3QYolYXIeNXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB5tnvAO6y3DqLOewd1RuHZmc8A7nDcu9s16B7U25jUMvsyEVAYwcDkzFw02yA90EeTA8PBIDwEDB2rFBgAIhpUBlwLigYqh+CUYuDFQhgyKAsOqMlNALAgR2lE2CwvoEBzQQJBRlKt416meBsGXCrODSEwlzbZsydo0PhBYw7194ftzzqxuQUlJGH+xlyjrBYeh11qGlljQIMrwy2sv3SRGm61Vp9R2lVVONQG7Utex7ZXjCI080bjNxuUAU0SaM3qQiuk5kmR+A0zgYKu8ayaw1Zw2sKCtCdKGo/Xp7sfl1uc+N27ONrf9/+dtY45Ydw/+61n/5d/8eY9/X/vHv/z+/////////vnKaCWLX8P9FHO2KNxUGjBAxxJkoyHAAHAMYTASYSjGdiGubZhidoWPGwMMIjKNgqiE9ocBAT0CF0tS+BsSwhBKpKORF3n1gSOERZIdkLwjBwzBMQBy87LEESezCkTXXlTL4/HRkClDPZxOKUcZqXaeIwgZUMuhbchxACKFsiJcJ0h5oMwQ4Zkh5ASCEyYkqL8L5itCeJYcAl4whzyJk8UR1DwO4Z0c4bRsXB2koQYMuGAXgGWwKhwvgAN2AKBgPDgYYWAcFAYDFQOOGPGYImXHMDQiZPtLRPmpeL5XZZmmtVBjpiktdBf262/X///9skUjSmtNwAvMQAEYIhKZIXOZHimYRAQYAAQYPgqYEAAYmkSbIcqYyhWMqAwgwQEIQ5wQZg5ukXQBkWToqAfuXOqiItGB2MsOawWyTAbKGAsAM9UIcTDTOW0kWlc7LbNaWMxPEocKyYRDtuvDFXCnlblTDc2JOqutpT/QbIL1NE5p0oW48ckNqXe7jmLVfZkTtTDoTsRvvZF6bJ36ky99d0IhTUUDM3LVKbuqCpEdwTUMeDhIS0akJzU6FmE7AVSVS6n5MZ0H1bdXf71Xz3jvH88////XdZ6/ePM+b5/7////7//+////////96+s7LmW58crNGzkwAwIDBQCaMJsEBAAyxNMFAFmBIEQYnKjhgSBJGjJiwAtexMIGmBVH7ZkoFHUKCTMhGbGaFjwpYNHloyxWfCQNs66k818o0lUYh6NMBURA6lrJ1ZCEUDhDBWzMoLtCNG7dDJmaO69dNbuS+jmCwGLATCKsWaTorUnBsikSUI4mhc4z4zhOE6sfZODZGeEKiEpdHMNRkRkCLlAhg7SENiDkAG+bi5yLOmIDCCYeEWMBxAPagGijKAKBD1BAQMABkY3EgJgukiajpJ8pEKbokMNSDInDZ1pmRq9SlMgttq6/1r/bf//90HMjQaWQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAchZrwDuaNy+Iz3gHd0bhzVnu4O5m3DlTOeQd1NueW5Y/axDA0CzGROTX8JyYNAYARKFJgoDIXFY0s/AwPCpYEzyE1BaARpGEKZ0kVNEEKgDIYiON8oODVgUyZs9ERm1C1PJISdzzAIB/65hYd2Wmt+MgpIKrwmIpaycLePVLXztZym1chmZjV81E6kcIBENGGkM2TqkyqRcjSDCvEHIEYD5KpIjnh9EiaFoJ9ZOm5FjQlB+KaQ+CqTJTIOeTIeTQfYScL2AGGANoTAUHBsAfqAcBD/hq0XIOEoEDGAQEnys5qXzMxROH0EmMkXsu7nEFoqdLrdBe6t9f///1O6jgubteOVWOVl0BVagCD6ggNAYwGAUBBsYNDadX+mbfFCZCEgJZMeIRZRC4IYqVnUmxZ1E4w4LMYJRoHM5BgYGEwiy9Z0ZfcvQ3oAGxIJg9ZSAQvkYOFI5F5B4JHAJM5FsKAMuhx1E3zGCZzsZUxp/pqDq1BjDNATYcSCEaJkHwEiUS+LKKwsRaIwY4oF8hxBSsMcIiIXDIZDw+QiQz6iOLA7yJDJkHE/DNFMki8gSAuEjoiAhwNyAMANIEEIMCW4DGAAMMLAgID5wTBDZD0xxCEQ+RRxcI5iCyuTI5jF5zU1uXDyaLPopm1D6v7tU6lf/2/9AxUMuOoqTv//VSy6MuUoKYLhAZ0LEbtiIPAISAQFgDDhKMPABOLxbNeg7MM8O5McUDbqSGAD0dUEMUjMHGAk4NsK0BgJD2GZazEMcZIiu1KJqPlT4B7JMAYZEZo7InoZEgZF2stChJwmE0NG9DQ4dlk9hcoInOEQE9DVD3hyXHwcJ8+OojRjy+OEZQ6QE4mK3GmHQCtTIpkBHomx5FmkSJFIhhbMhjzp8ny4OUogYoxBxlQsUBEcDwUG1AVoDc8RcNWB640BbhcREB8lIrDuQNDFFAwIuieQY47NdaLKQ/VS+u1T+n7W6v/SnBfqPpEaMsaalcoRAKYljsYWhCNAc9QcAZgEEhieK5w9yJruOZpgxkS5hkgGGCQYwh0D9DEBAABUAMOCBoAjENQHiLJXalbciAStwaBJrxdvwaDBoYxSNaShagSwzDmnpOu+yJ7GykTpGG1YjMhq6zqU26YjCKjIhzifGSHbKZXLI7SGkIajnDpKpNnxgC5BCcpEHI4XGOIukCQI8rlwdQ6jMmDEmhnzQhpqTxEg98BwQ3sJUAccAg4bcIDCFg+ILhw+QXMXCeJsaBRJpEwKSJmaqNFNMUUVvUimaM/etVvU39f///ugyh2k5CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHiGa7A7qbcOfM94B7VG4a3ZruDuntw7QzncHdzbiUx56WNEIEiEQjFPYjFcOC4K2jAIBTAQKDBMNTabezIEa0OiQ4GABUEoCAAwGNSQoag5AZkYCgZN0LaBUJIntjjwixciFl7UA7hjQAgGDWpBcYCPspsv4QFCgKrIwDDkSAlNQV8HKisulFa1hEqKGC8GqQKCI4iZAS4oZUWaPRiQwyFzlMkC6cRYTiHsGhFi8RYwI0iZGEoVTYnC4dHUTQ5JNFwtmY7SFFBi+BEcG8IGUICsgtZKgLREQLAyYhg5A+yOHUbFM65qQxEi9F2Up01OpF1LUcbdS6TM7epe72/1f/oMbkPIIefoUT0M1//P/py3WoZkGgGmB0FaGDfyRYUYAKGALzAhC2MTpSIxJQpjOKzDqhQwOikqgBANcvMMEe5Q9I8YJmxBloAgimF110yAuJDgIBFpQOUW7IDosCM+DXIDhDssSQqWymMllIYUlQYxjG/jboRvPlBqLYREcAyhAjUiQyY5RgL4jEy8dHIFyG5PF4+Uy2TJIC3CegyKRAbhER/Ii5KFYeibHUP5ZIsSYswniAlsbIWuiJCDAMCUAzjQCgQBcACEGMsIkPYZBIoR42iVEESCGp8uLLRZKBw1LiZ5ZxBNXZF37a0frv1r////1ENIgWm7SRt3EMzBIFDJlkDPoEC86x0DDBACwYLhmNdxj2ExiBbbAICCAaf6XStSMy52hA5QMjz0o0PU5UgnMfuu7C/F3PNKGcv6EZwEQZMpkoc1ZXTdGWtrBrRVgUzCgdGXxjMhys/yNSmgUY/hxF9N5faoL1EscMu746Eksx6wDkjshY4hgqtwanPbCrHOaqcfsr9jfKt6q1S0g0B6ASgADGiEOLsNcuRkopOoYpm+sWDEj2wzWxLXVN21vH/vfX///1//n///5//z//////////n5mcSD//s/9GOVW47oKAgxsMwzFDQHASwIKAWSAyYmASeenGblAeZWIhxSYaRAYFS0Bg0ciLo/uesKsiZMDHBQKDA6eXo8zspyFQHXEPG02mmnaYWBqpUwOJG3bZLZmj+JswxDatIUFE4oovm3MV8s61t/o4RUZMfY1hJRokmUByRpCjFQfBsNAUdEdxLkEMRmBkxCUNVjmjOEeUByCFOj2Wzo1BcxNF84NIvmh8WAUqQwMFBkwGkgGSoE0BiUG5YLTEGkNFIhikRwZCkSNHopLLiRgiXCfOKc+ZpmptXuifVe3rd/au////90TIiRKpG/2///9QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB4tnOgO6k3DyjOdge3NuHYGc6A7uTcPIM50B7Um4ppbDzkq6MDAlM+2HNygtZsRAODAqMGwkQkHG4mAKBB58RCDJgGCFviqNBxJwBZeCApkQgIRAngBBIYEQ4uA1NnBMFiSXhZFsz5qwnlBAALbLKp4p6DQhgTEnujThLuHYzvVZdIWx5TMtu1fiZqJ9DHxP5SYiw3CfF+w9SNJsZsxIMWScEpkEE9EaMeLiD6jnjyUjZyBDRGeNSwQEjEysSJYJkRyITA3CMEMCCPgfwGpA2PhdUGtEokSHAWBNpbGOTMS0s+cUYlXukcKrHF3aY9mUtS7syaO/39l/6v69EhhAUFabvtj4zYxYxa/RQ+pr813C3SOOCQEjCtCWMGsA5GNsqPRgKABGAmD+ZSSI4FA3DiAQkYcKEwgvkqG5zI4CQ8AjhAGlnx4LMkBYEBQcXzUXYI0tIgukDgwoB3OJgZJ4IKkd0viwCvQzNO9VFFBtpRLJcFQqDnzbL1td2aWmm7j0DJCFgwOJqOkkVkWIwmRJhlS0SZMCAhSNCcEJiaG6mKAMhRQxSRxmM2mR5XIiQ8gRQNCLnCcGcMSi5ABCw6xPoCFgCdCyYIFAtMNBDJRHowxYS8N4Y8ckgSBqalogpMolFAvIJo0n7KWnqXt7+rW3b///1MOgpGZi53bo7nO7NXf/000zJG7pkCENzBSlzJoU0nIQPAmYGAIQhKafUqYTBqFw4wIHJAQwUACgKDhlM5L1PgLApEUIlnVIKfJb+My2ClVmsKXqLqlh5xhggNJCi3SNBgYIXdqOzDzHnGe6fZcYaEq0yqC49R9oL96hjlKMqQAaowxSBOJnS4MsSaZByQH0TJSJ8zRGVIoKXJ0i5BTMolZieImbFomyoV3IuT5iXWYh5OE0G2jiExCMgDSHULofcZgZYUQnR0mQ6S0oxcrGp84bG6jFJz5kg9lOrX1Va1LXslt6///+ykUmM1dF70XKFU5pG+helhRux/sRlvUzQiICkwWBLTAJAsIgP0AIhALcQwDQhDCJQ8MJcC4500BADLkGVo/mOwnGfLtMsJMmSBX0RAwdrMeFaYMAoZeFZSZKSRQfEQR131KpQDGhQeGATGBJStdjiOSFTT4JgJlRf1ik3PNa7L9UlmkgHpJjRD4Rbg8Qyg2hmywK8LGwx5cIONkhpEUxyiqMi40SCk0OAckbxfHkXKRAc0rG46BkiSJ4hSKEDMxjkiVCxsG5oWMgcsG0E4TQsRHEPHLFvKhAyIEAJkiKSBWNTM3Lc2SUZm6J5Haab6CkbN1Vdf////WxPkDSDO31+htn8p9v7tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdEZ7mDu4tw8sz3MHd0bhzpnuIOam3LrLNcgd1NuPtxh/1iGAIKmRzImf4LgYJEaAKBpgQDJYCgxSgYy1CIBEoOMmMiACW2vIeOIYMCBxIHGQIAlZxYOpcyGVQLCIZVQcJFJT7R3sC50AlLahxddB54nAZhdg93LS9CYUi8ajMCyDOxTWrVewVicAphcRuajnOamTDmlo2KVNjAxH8rDNDbICQQ3Jwc0kSyTh4rFQoHD5AkimMkZoEDPkRMySAEgWkCHBYyQ8gYsYxCYH2OUTBmTR9KmbpoJmjLUgiupntSU+tF611s39bf///qU5mWDdxs8KuXbHVVFCrVUaELNOPCqH2Nbbjd9s0bLQqAZh4KgVAEUABohgAEpMDZhwFZvTcIGUURgYGPQYELfQ5gQJJ00u4YmHDg8hLKgEIA4GAYoDsBaw3yqygwGBxgFl0QZGjIUAQoDQhiSe7ulrU3XPrWWYLPLmNBkk4053uSaphJ6KFDGCzRTg9YQUIcQ8hWLhUIGUyeK5Gl9bEMEdCcxG45A5JPjhIsN4oixIJHyuTZEiuXTMuECMCuRQegbiLonMTsBLCBhxpCiFA1aJ1FoEAhBUiozBmYGRQNjBaReJs4g6KSbm660WQSRUz1Koqv23//2//0ljLHS8urnCjKP1VcIoxtjre1yofq00tf55QqEDVjwO7gIeEKjQoGzAABDhychdhmYXN6/qFIEAhAkMAB3hrKyEVFSgg0b+sr1IMvy3vwNEVB1csJisqKtIHEggelWtKYWc/UZl7Z2hU7Xw4Oxaihb2SfCry/jaxY2EAxiDWMD7DsHyZk0OIrENJJ1lUzJ4ioyI5iZXMieIkTiKB8dBNl4fJgXVIFdRXH2RcWaOUHvAY8B7AOKHtCyB7EBhORMkEHcgQEeSXc6eNZkY1syW1fUpmau1ve39P//q/UqixKE89UHv/rfg0JDIx/fMQ4Web9H+W1aD2F/WzevSFt6uxx62RmGCKAIHC1sBCICB0DzCEDjtQsTNkGgFMMmLMARLnDwYwEA2CmQMQQ3kYMLJhgwCFAjFnSnpxLxEF00VmdNszgSDA0aIwECstbVczKptvGHQ1eLnvlalLWXElNPjYdmhj5GCByMIePRmNIcRDh5FpMCGF0wLZUNFkmXhzi0ISjwSJwZxzIhhuVieILHosEkeIgMyTqJDBIw2EUoAIkUgB4UBvUGOiNCHnQtiMeOYPJHkCIGfNDpkaTEvGa1JIz/1rUy0W+ztqv77//q/91EFJokzKanJC5lAbo0k9cOnVI1KoiMXa0YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHYok4A7prcuzM5wB3UW5dtfjcDeZNy7nDm8HdPbm7QSV6FHxCDxirAxkaGxZNSYEA8cAYwCCMAOqYoBCQkiyBdZ51ByFMYwy/rOZ1GEQnj0E1iSeJPBK2EsOXm80ahMTALh32XOFGZTVZq1p3Ibd2B0QEAEH5zr1xSzP541a9QlhgwEqPERkky4XSkM49jAfkFkkUyisul0bTM2DnF8cxmUR+QQczMTYxY4mePIG6aYPoQwtQIMAFMCdAN0xHcSg9jpJmhWTCiXiki84gdRdBCrVUp2ooqSX9dXq6///6tta1F8wPIUKqC1IVMqz2d1uqtldJTqZmQ6kK+oxVrdlO6ndlLPIfrKYxiu/y/LHnEggMVQuJnVAQBzYBA4GAKYGD0dO8sZCAQNEwqIMqLSDDBJg1BGnL/gJi1tdpao4wBLVIlWl0pXNILNaYLClqPWl4CnSzhgCl8yWLO8iUUCoEbAzqlQUvzEB2XJrT1y5TRXYyo9hbgUccsig6yGGCRNDlkcRxFyiOkzY2IKOSThRFtHwkZlsmXKpobjnGx0gqRFyLuYMKTIqHtjWKIoMK4BLFwBdcMZCg0RwkDH0WimZl13SWfPT7ukpJ3tVUtbPfXv//////qJ4aB1v9Ltw/l6IBOIeAse1neTo90kURaWzyWJkFHC578L9iXxRm4sQHH/h0RgGDY6AgwAQkFBMfANHihYcgiUIAISlsSuE/yWSkVbGnBUcHYqgaK1p2H6nYk/L/OZYjJf4WRVMrxdrXpyPNJjDpRpgMLRnpruc3OUFNfr9lU8XR3ECIsw5RkbHjYdJBSJE0VSg6BkmXBmSJkTJ5Mig9pFI+TKzZEqlw7NjAiqCZ4mhfD8MmFvoDaDpJ0QmKZXJIcJOmA6iZKREj9MxSNTJFFmUkyvrTZf6lK6n7UtX716TLv+6kTIxNDWkbp0lo57egggmpZpTObpJpstFB0VI6SZpmzNOkwAhIcZKbaVhMjF2sa0dgphRgke5jQAIOAZVBixZowMIsyM88zIEMx45ZMfTBfJ1w0M6giDJko2ltxUeShkAzAoVFmipWsPYm1F+FzJnF+gMFQqbO6DqwFiv2epF9PmmfWo+0jq7saw7T4HquhYimL7VwhNq88bnKC9RD95K9nirTUzLG0OiVtDUrm0wIEaBDbkNVvrDScJdhrAMw5wHsJCaJ7ND5qX4jOyYpGj2xvfr/873j/2t7/////////////X////19f4+P/r9tmx/jftu/pPTOKXz6V3jXxrWPe2Mavrfvu+sUpf73uuNbtrfxu+4/S3jknyT8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAABj+ONwOYa3Ll0Ybgcy9uUyo83g1g7cKMxhvBvCm5tY1pl0hwGmF2SaqAKvm4iMEJBhYIGd8IY5FBNtlDvrMgleZ5E5b+OM6BVaC1u9biNTCCviLwzc1MDJSiMGtMlrvRqH4dlM7BHZS2CjwvUF/uOPOb6dNxPTY6ZrN2dTo2SMSVZJ7lhqal4vsi6CBgip1LY+UkjUyKh7E04CKAlgCiMTAyLxuo6ZlAyWy9nWpau+2j9XX/////r7fqSqdSCPWl3QrZakHqRSdjimRpV01usyUk7mVZx1stNVkVIHUmpWdummmZpgXe4W4ET7MALkwYA0SLKf6OJhsIHYJ4bRApRSRTpyqFIEBxFzpQuV3GHGEGd4UFFknWf2llxf52V7uhELgyCsAEHyWgbSNtilzLojTxmSKYT+M5fl2eWW6lrbaqTpV+47FFruNuJH7bJC+37AxyabGt6wXkkeXg11nO63rWExsi7HCGwQkB6DqYzvORzRsFXpqOy0+LbzBl194zm////1/////////////8f///6////+d/MBV2vr23m+sevjfPl3Nim4FL5+9RNfG9YxjWtU9bZ3rOa//NbTa3vVZq5pitpJbSXGgYT3eq9IvM2WUaCwBOR6LslMztDujX3MmnBkC2XEisJjubgg50upqf9d5SVLtnNmLeSOI2JVWz5Wz/8ssssv/nf/+7HUHjzXN17HK3KHFGREOdr/nOa+aaNSJ4cQEsajpQ8VF/7fv/////////3feue6JOPdDXNdHLIp26H2dVZB9WZ5qtMdT1MVjSjMhymsej3PnOpjI9i9ZRkd/nakBgYkCAuTdvumOCx6O8YKLKbsRWi865REEihMvA1N9X8diB3div4zuNJLZnDjIZDALuzliewiVPdx1adHLL8dby//y6pYZDo9NzbsRHonqznEzqSm2d5udQ5uxc0mD0CsDIDJYWiIjYmNnOv///////////fQ490PSlkuqO7OkzPSSzTqTDGPPeXZzyM5UMQ1KJNOdHueYyTkVipxRjDKQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAgwPN4F4STBJw2bwNwM4AAAA3gAAAAAAABvAAAAAv3IgsrqO0lSnkMWEAQcUQG8rVRSzLbgQmZZZ0NHpZ8r////+VU///////R8soO+HSp2eDQi7fLB2WeGvEUSw7Ikn2j8AbQJFbvxmGhRJ8+HZtWbtq/DMOlKAoVX9mYqUqqvD2b8KHf////wWKxF///////88p4mKjLDxZBFZ08Ilg11Dzp6HeTREpYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAAAADeAAAAAAAAG8AAAAAAAAN4AAAAAAAAbwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=";

var Incorrect = "data:audio/mpeg;base64,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";

var StarProgress = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwNzgzIDAwMDAwNjQ4IDAwMDA3NTA5IDAwMDA0MUE5IDAwMDAxMEJDIDAwMDAxMEExIDAwMDA3QkRGIDAwMDA3QkM0IDAwMDAxMEExIDAwMDAxMEExAENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDA4NTcgMDAwMDAwMDAwMDA0NUYxOSAwMDAwMDAwMCAwMDAzREZENyAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAbqdNKFPwAA7k6aQKxkAB9yQUwZWgAD0EgpwytAADTIOLeJuPWQsnYk4GcAUBGFSK+A7gCcALAOww10OQzhyIcsV6e3hUlEYsV4ba2xNYjEHIhyMRiMRiHH/f+H5fb/fcKy0AQAzMOFDtY7UODAEwumut37UMNYZw1yHJ+pGH8fyMUnN4YYczp43G5fY5vOnt5509JKIxGIxGIxGKS33CpSUmHPwqUmHN5554fvOvT55/vPPPP8MMM8/1hhhh+sMMMOfnnhh+8888+/nnnn38MM8+/rDD//DDDDn7zwww5+88+/vPPPP/wzzzz/CklEsjcbjcbjcbp83/WH2HrDpDorpFqnVOieWnMgC7D8o9gUJjKZSgI5fNOhhi7GcO5OV43bwqRiMWJt22HrHSIWIxB3IcjEMP4/jluW/8bt933CaUoAAxnKG08cEBwPG0oZwQOHUHce07DDF2MQdyfmH8ch3H8lmG6lJY5XlcbjcvlnN16enp69PGIxGIxGIxGIxLJf3CkpKSxzeFJSWObr09vDmdenp6fP886e3n+FSxbz/DCkww5rCpYw5vPPDDm88888/zzzz7rDCnzz/WGHP1hhhhz888MMOfnnnn+8888+6wzzzz+pSRiMQ+/7/v+/8bl9t/xOD7//4fBASQQB4BYagZyJAAgCA1EIwGtKBAHgYBI4DAdA1aGAkMhPwCQ8GqhFwAgiVQMGQAUPCYA4mM6DB4GRIBY8Hohkw1xHI5gkqQN2iPA/YMTkwRUZAi5Fh2jMlocomUwCDAH9Jk4XhOopIDhQ0SaIgJEBn4AHCMk6dQGVHMDC4s43L5qP4lIkCSLZaHIGORJ5JR8hrnTVOpSa0K0GGOBgg1MUCaUZGQcQCzRrdYSDAoVQt1Ew5doooomVIn2mfUey1ovqXlYySMa0UReiwLUkkZFRf4Y+RH5fV9Ybk3+tJZdMWLwjELhCSQ1PRbpfW1HzAV0yX///fUtQuZ///wSI4EQ0AsOQM7EgAQAAauD4DWBAoDQAR+A0FQNOhQJCoT8AuGBBITUAYGlUDAjAGDQqAOFj5BgsDGjgt6Ech3h9ikSKCipBaKKUEdBt5MEVHYRcixERzS0Q4mUwDCgHxHmheFKikgN49RJoiAoYDNuAN0VJ1aAypBA38ZY3L6I/iyiQJI+WiGDHIk8ko+TLnTVOpS1oVoMMcDAxqdQJpRkZB+ALLGt1hIIChFC3UXHMaKKKJykT+Z9TZa1vqXmySRjWiiNUZBakkkiov8NTIj83/WHVN/rUsumLF4TyGKCSQ1PRbpfW1H1CupL///vqqHOf//8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJx5BPBlqgALGyCXDKzAAijkE4GWoAA2BIKMMpUAAITSAZwCzgYMzSAY+wpAYNRcAakRXAZniKAYCwtgakCegYOwqgaPxlgYPgRAYEAxAAAAAwGBLC4IAAKgcoBgIcAZ9AQNSgA0hgCQ4Dh0GIwMBAUBIABAFQcAQsbCAOgSFYnYDBoEC5QTAIX9AMAY8Clx3g2ODmi5SJioh7AAwWI8DFDNKIqx0nAHFQZ4dopUWwDCoXAsTQDAGSheDYQwOF/wwkOEXCToggF9SICjDlnxNTY6OEgJwyIqTy2KUyNDyDmuwC5qAKQKBwtpZGgVKwDANJ5NLlICI8AsDy3PcxD3mYfBtuO5JYnXJo9nTB1C5spntZVrFIGfQdMEAnC46zySKIz5p1XBIIg4F2qkc/XSDiQYAbV2lUxNEkSGg2JPHHs1Lqf+o3orLyhPzsr/v/oKZU1HY6/6v+A9bgbrLAGBGeBloPAYQNoFyYBj8ShxAGYw8FhAGcg4BjEFhi8i4hEUwCgwMwJ7BYIdcRYPEH0MCLEyPorEwMYMYPJBTUsGRNJqNCuRwWECO3OkRUBFyB5SIdcPXOkTLwGKg2iaXNjAmC6kkpMCTAAwEJHAa6StL+gbrqW4aKJN+oO6TzfihSIN+a6/bS1/0f76f8axa+r+Rxa+v+ka/39RPf///2o///77LIuUSDp+//8DBuQkDZGMsCKCQMXoBgMIx4wNFRmANIpgAMK4ZANngRAKCHAyNF7AwCAOBoGsWeBhoDUAcAMDDeFELUgYNeAxbAAfg7kM8BxywCFILIw9MLfgpvD1QFxgLZhYQ2ITcHdDlzEQDBsORQLJhGwjoOoJxFmBq4PyB0QCwcSwnRbANexEkE/hgsIRYHaLgZAUO8jB/OidQJIALCg6QUQsEWAtHC6Qg01Kgm+swVWgVyo7smxMlcnCqyagIrAYnJOvmwIRQLQje/RFeBEeeruMa0ovqXj6eYPqP5ZzL0sgLddImAoGtuRZLqqFYDxfLq/qFOGF1r1quZm5TdT0PV/6CnTM3J8Uo11O3v/qtWYywK+VEFL77q/h7AEqgJFgM0IBA4A0iIG6oKBRPAAhcDFUwLCBXx0AacyDgYrYA0OOUM6BhUHgoEgEgsDBwJLZqwyoWsCywMHAEGxgezQihUGcJMAgAAYAAA6w7IgCTAuQVMvn0wtOAwsBA/EAIFh8AGKA4McI6HSBAGAaFKpDhzzBjWCIWhxYN3i3lcggGSBuL4dIypeIgv88boIJIKI5RPFZSkTA9/EcDgb8QiDwo////+r//9b//zMrtpu/8fJh1K/Zzn//+m6Ci4XDEgZugtNk//63WrHKGNC5gklPX//gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACIB5TAd6gAC8Doow7dAAXwXrLA9qTcNXumdBzc24CwB5gYAmmBEGEZuxYJgfARmBSB8YDqOBgIA8GAAC8BgQTAgBXMAoD8wHQCTCUAgCBDwUBE+4MAcAGDBIWBiOgGpEAY8MFAIGTNg3uCEgBwiwfsKwKFHgT4MIA0sGAAxsLnAYEFkAoGFpYsAgAAKHAwgcFmYgqGDwUHA2QDQeGXBcYKHADA4BCMDVlgM78A6ZQDaDARcwbxAABxCoBRUAIWIWEWDAQncdgzwyJgLkG0J2TPmCRcJomC+WT5oa0yYUX0NSIuwsvBScJyKia0Utv/+TBs/9f/6Lf0it///tTOBohFkHX2u1a0GZO+qkkbutU8ZGaRcLLEycIwVuPgQCGWMTUzUkapmDMYBo+xctz+mJMiEg44NFtucMpxQBmJgaRphYKFBgKAI8RhAAnDikCBAAKFDGQBTwL6hc2F+AwQSBDR8k0RRZECKiyxlxaxCdASQQuMsOEZMG9A+YQYHxj8KgIDi0CwjXFxhboLnADAoGOrgcEeBmSoFAwaAEAQQBE7ikB/Fxi5CqRccsvUpZUgZmi000kE01Jst21VmQW4BgIcJur///mf///3/2///9Sxdldm//q/t1My3QW6B02My8QQahATFMozq7O0+hYBQWCaNdcdYwxwQTBqABMT8yYywgPgcEMYBwBRg9BiCMEgwBAETBREgFAICYQ1VACaUYIQQAxqxGFFqAmOAIlCAOct3AQcKYQwJW2fMEESoSjEQFmaUxgwAQKUqR3MaWLloeA4aNCQQXMIGiyQ5UDqbt+ZBcc88bQ0Zy4fz0bseLGDCgBEZUEaaBJgmAn00IgI7IGNYth+RLl0xNRnWTHGXyGlQwUaLQN0UWZzws8WkAXCbIR2r0m//sQ9B/1mn/7t/ctf//9R0tBZMM0g/2/ahorrm10Dy50+WD6RLFJIcwLgxxjli8G/Y1Qm5qtF1GVQdR5Tu0uyqsBC+ZytAKDpiEbAWwAYqGLwmAhUYMAQYDy9YWJZZVppdIDBQMB1BTDhQmVSIOEQPRI0AkESgVTTpgV5lYpilEAOsZia7VSOsvVrKXKunaUMW+iq2SXpyJ7JurGTeEQcYuDGI0R5J0YYKhxyJAwKCTAwKRuCOIgoe6ZEaRMrmJ4PhJ48bF4yLxmSJaUVjWbVskkbUVjGhBgD48mC2yn7f/7jOH2/Ub//oP+uSSX///OGwEFkXJ1v9WqtfS1GOpK5iymSLxFUSiaAhABYxPG8OAeEnr6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAf0g0oD25tw1G6ZgHd0biAGDSYPbg3DSLomAd09uEAICAaMFYFE3TB9AEHiYDwJ5ihnWmcQAuYC4DRgjARmEiE0KAHEQKJg2iamBYBeWmBwORA5EBoTjMdAzkZDCMw8iTzC4WLABsqcwYQAqZtxYQUCzCgIwAMBIMyln9HRAADdxAWYEalwgw2R8TWRSGQJQCH0EACCAsKGIB4AMTlOYzZ1MfKSiBCguYUVgATTeQaDQSwGWzyAuMiZKJixEmSRbIYMoTxRYcRYQL5YTMkzxo6dFZBwbqAN1GyVf1//8x/6P/6P+p////WXQ4ZE1P7+7Lc4lUfdSqrqSW56dPmREBzSWH8SULAgMHHCRU3N3dN1KTOJGrUfutvmXLd2h6kEZggOxuhTYkLgODAzjTQ2WBAwfEseIIaIYkAEwSAAwQKgiANjbbqDzyEgwU0MoBxoHFgwsBrwlQFcVwo01KIQmVtUaQz5t2eRSLLphKgz7FzmBp8WWcstTsg+C2t0BKBlxzhWIw4tMQCzCRIEAAOEUDWYwWNUQ0T0SY7A95zElBTjpqfSMyqo+eK5kTqKWqgbGJkkLNANQAilB9mdvV/+lYrmj/y9/+Un/nSRb///yaJYTI1fW36KlLatvNnzJO62oolk+TRdIKGpKNUTBNBcBf/WYBICBgKAZmC2IQbU6cJhag3GBgFaYWzFpikBomBgCUYGwQ5gUBYgIHQwEgSDD6BNMFcA8xgELzISQEQCACMQjxqbMYBTBBwx4XYCYEFD6YoIXWZe/sBhwAjuZIAkwnUHAFFJI0aHGap/ixsAh1FAaIjCgIu6o2nGQgS0i9QwLBU/MCaDJ+Y05qBzmaQTgIFBwOJCKd5ZYhwXEEAxAIQeHTCcikdHUOSs0Jk3NCqWSoOQbHzp6cUldlLH4BcAJzFHf//+g/+//6v+n///61CNSwbf+ypvZa2XUilpGSBkozRLDF8uIihR0BcOHjFWO10HSQWimYOic1srQRb87xD26IUrAYOgadatEPD+YKA6Y8vOakB2IQQDgWMLAgBAHBYDTF0PzBwAxo07IQfMOOUVFSwCTjgRWB9C8KlSzmsLrh+xNx1YrorUjCgzAyIFBcqUflz8CQ9YJqsHR1kSET/tCgIHDCBGDdpxliaQwdgUwQJTNCp152UuCGnox7wp0k8mpdsi4hUvnPrn7///UgWoANQvv//////////wdf///6//////z////6////////////Zfjyn////////+d///X/3W+fiFl/llnQsjorOpT0AS5QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHmHnKC9ubdMHOmXB3LW4grg0iD25Nw2A65QntTbgAgIAKBQKDASE5MkJXwwXAIwMD8YtBu5kIgRoThYIAwMwZDAQAJDgSzB1FMMCYDgqA4WFjFzMaDDBQgwOMMHJy2IGHAsConFnzRTtZ5d5+10uAsEOhJQgMGQ5Nnh9MFJ9xBgTLWAIOBxAjqx1JUDASu2YgwGhIoFipCamQGHyh1Rwkaa2QiIcFh4wIeT9ZQG+hi0LdDgHGHHFQwHMIuQw8XiDH1GBEDEjlooorRZtNSJMDHATIPTqdf//9L///1f60H///8pCFyIP/+tJafV2TziCZeNTFRiO8sEkK0L4YvIcKYVDVZuioyZmM0jSGpW7Kd+mEqxmDwHHtRDgIlDCcGzGylzBsYR4WTAQCAcQSqRgOCZigO5gmAKdiOojOHB0MDNHAoSOgcGXCR8FChbCGVblmQ3VZEgPSoSiSof9w1nsxk8MwW/6mDIUclhGMtGf1uY0Gn8AZC9Rlnlhs2lgKkX2VlfaHoUEOFWG8rHINEnKHmMkk0jAxNEiToG5tSRSZ36jcFfBIzR3///7P/////f///6xLByLf/1Xtr2Whe7tUcUpI1NikOcbBwGxCcMEzLH7PrIQBjABA7MEgW4z3oAzC2BQMIUAcxrDMjQdBgAwEpCC0YKYrJgMArmDsBiYWI4JgXANmEhIUCBCdoNLDGNc4KXzJRQOExwHJjlTxr7Qyh2HWWHj0MGIi6GzBwSCCQSYAIjIgDgoWB0IhoODhpSkQjJhAGytYhEHCgExKFJ9mNBpnUeaHgn8K5qkkZSKGhipi4sYADrDq5DC4YKG8wkoyRD0hxjKiFTAcajY+UCLEPIoUSsVDi0EWZK6QrgEZAWcV4urU/7f/p/////7f//+iTwgiHNLf/pqRTRd6qDootZIzROmRgieJ0fQhQc4LlgOcFYEASmhup6J5FSSlJJIrSqQ/MuV7tIAAYsYt6YG4ExqIjchwdTFzEQDrAR05gtAHmCAAAYCQT5gGAJioExYEcMBsAhQcQAzFBRJUh6Y4uRyQhmWWJCaZIhLJu06d9K+6xkMy4bAi7y8Gpu4udnVVkSk2yFYNppYC3lMx0IydmIsGc4OfAxUZpOd6OdEAKAgYJMECi8HIvh0gpER8RQoicjQmkyAlRy4fIY50niqspMZpqTddHUVg74HgBqVv///S/////qMP///UwsYtht/7Uq1b3rXrUtMyZzyB4ny6wrglY6SSJhIylnOOM7/19IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB+SDSIPbi3DYjplAe3NuHCHnJA9trcNjOmTB7dG4QRmAoBYYPonZwVrcGHyDGYJAUxgAMrGL6FsYJYP5gzgGGFwDGYGYD4sE8YgwK4kG2YyCCMCTsMRJyUHMLuA5IAAIBgIHF5EWFljohcvAj6zzAgA2AmJi5ggaTAhUAlzgYRL6Ns7C+zEwwaDTCwNBtLsAgC3mRQSlyAh5+TIEwyEbPEUTVVUxcVMtGzKh0wQLEgRrQjAxmQtOC9zBshQGaMCiJvHOJIn1kMQKBNEWKBOlQ4itjiCr0jcCtDZDM9VvV//zD/////f///1nhcw2H//XUk96lJGmpzdjApOeTNyZIqOAcAYkD8RkBbzxktqklMgmZd1s9kPzvLduktiYAYCBgaA/mhAaQYHwF5gHgWGGIW0PGjmBYAmYEQExgHAlBgG5gIAdmEGDOYDgA7tlqQALJqtzgkIqDARRQkQBBecHDpEBUrVoOkEdZWu8MEi81lERnChCoGPrHTVAgKAg1YyObvsiJQBrDWFWLANTDGUrIzgUgwdDAA+X7HAoqgKYs4KmOkZQhyhkzqQ+B3GZiXln1GJOGJqaIoUlM1O7JiMAPQSQLf///nf////9v///UZhAMm0l//2t+p9DdkHWXS2YEiNkMhEoPk0Ph8HgoCQlattX6wwAESA2GhATiEGdJhcDAxAiMRE6wyWALgwMMwCQEDAlD0DgLzApAQMFkU4wGgOkJLMiUIL2L+M2oUciyI8XGRiaLxiJSa2WoJ51kthmDKTBBWCEX0i00VLkBpaREckBRIsYkKiiWDagkDUdSUdFiCoEtgYNgpXNSxzm6kWDDMzNAiX9Jg50V9BMwmIg4woEIMMkWEiJOOc8mYqNziygdNiekk6KB9PXEIE9ApzVP///0/////9v///rIJPKX/21rf6HqPsgzG04ZmgjA5gEQBcjCErTTRdkHTNnDyW7so7O6S5wgAbMAcQox0UZzAVAuAgDBhxmeGAEEIYA4KYAALCoE4VAQMBUAUwagpS7YkGvU9ZAHpXmDCxpgeDQQAhoqJDwsOCAOHL781IYgdryElIZYdNFd6YJIDLXbCqRyhYOXYpklSz1m63UqF/I4KpmAgRhxmaHBmcAxmJOvgBBYGC0Sx4KhwQwQuIVPlQjyo44xqkUTJkvmTJlQ1WdTWtatzdnOIgkcBSGPpNL///oP/////T///+fHAGbvr/2rX23ZDbRQTWWDIuEwTQ5hChyhATjNC5wNjt7v6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgWekeD25NwwI6ZQXdTbh56DSJPbm3C3jplAd0puTAbAaMDYDkwtxTjtJQ3MWsEgwmgPzIJL7M8YC0MBfBIAJgKhZigHxghAhmGGQKYMADIQEAgMEkAHDwFCTHeAashqGGggUDwCDmXDBnrYHAq4i/DRFKWmmGHIXACgeS7MEAwwHBwQjyh2SYCpEEI5f8ueYWENCTXBwgRABKKJFMTMDSxGJGweBt9MHR7pGGDxkZEh6GA6CQaATQHiWQgAyGNUOMNSImPRdRLBJl4XMfkSNEmUgmaIOlKIzwCADikkKfr//6P////+v///7jaEfm7V6f3U9J1PWqTyqMtoFM2MzcwSGWHorECAKoK+TxIMorGZmpzZmMDYmC4RFAZ4dxF3aACYSIgOMEyVN6+UMGQfMGAQMlTgNVAkBQ7mAocmBgNA0E05TAQ5i98DP+5gYrZuZsQ6awQ8TBQxoCN4qBmCIJPUz4y1FFHty0nV1qWvyoNHWjCwVZaH6ApubV1+10Jiwqe7AzCFiAqKXzsqxGIdUqETEhWdum0MahDBfDgJ0h6BikVDdBJRughK6RpRPtU++XgTUFRlF3///7/////6H///0BnBJv/7/+/Za0ndCkYFUvkSD9BoF0n0BrxYsYb//pAADDAAAJMAcCowOBWTWOWKMGoC8wAwVTA2W/MNoIkFATF7DBmB2MCUBYwBwAjDSApMI8AErAF7ETugw2xh1qayKGRhAFHBCEAQDUGOgCV4RldrQ1YqUcGRoST/XWl8ggUzFgNsIYJw8UBwGCH0DiMushwYOyYkAB4QJQsLgpkpUGI4AeDA1IxYOEIOVAtFcs1kGxighAEZ0c4eiaTIsOeMUniYNzBJyWSKRgeTu8/dJougToBsARrs/r//6X///r/5h///6i6HJjFLav/XVT91KQVdSkTFBBZSQNSdIGNoUYWAfRw1M3s6Rg6aqFV+pvzvIfofQtWYXEMfXWWYsA0YQhmY0sCZpBSJBOBgTMKxuMDggAQNGOoHmFwLMGdhN1eD2DJIEAIwYMGlEmAPABo9GVow/ORG4lwj0rCryH2DMIaQ5aMiSyMCsaI6Ahp866DVY8/TgCBUocbruEFzSiBKMFAQJDA0BNS8GBZA2TizG6EA3JCInc89jBc4+c197pqPgFgTcz///1/////////zh8LSf/7/7etldHHwihuJAUQNwDo/FK2d6TNcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIinjJlXtgANPuiTCvUAAtOkFMGVqAAedIKMMo0AAAAwAwDYXAcMLYYQwnUvTCtCtMLcEMxKiZTGHB/EgNk8DCLA4MDoAEMAsMHERQRAYAoBxIEmAdKBBOUx9SMTDkgTAQZAErkcEzSR8v23G1p3FFF3BBev5fKwrzKpsLiCYCZKAJrosCtKYNNNVXUk8/rbCgeWkMkiRQiBAiXOcIWFo2pY3CBJTWuV2kP5ej8Zi0opLsUjHKa7VwqbpLGu7/L85RDBCJF2ae3n3VPn39fvv555/vOnt4SuJ5/uvT26kbl9/D69PbqU+ff/eeeqfPv/vPeqfPv/vPPWef//591nn+s1FXmz/PP//+/+ef85//+f/r+f+X6/n9z5Nayf2VK57e1vLXP/tcWE5QZKco7ZpMBUAcwJwfzDNApNLsZgwDANB0D0weCHzBFBhJgIQQASYFIJJCAcYBwA5g5BTmB6AeW7HgA2aBsoDQYDMgAHiQRFAwEEgoWGABBgyZE2JQvjUGZIsDbIRyLlDiAyELhOj0GQhxg2yBtsI1HKFuEvFmi1CMRSQXSDJwMmkA5+wDksAEmQtqAEGCzIgYaom0U4XEVXJQfBuZGblRI3NEDZaJOpOtHSr1rQKo7Q5IwNG///9/////////1pkCM0f/9er/vVpIrSOmUuitg1UQY1ETjFR5lIGAQyBn8WgAGkDB4UAAEIG2CIBJPgZYFwHCDEBQWgaBRYEhCAoHAGAABg8OAYtDwX6E2ADC8AQAAHDoDCwnAXAYFAcF7AsPC4MDAArAGBQYogCAUTqN8DBIHAGA4e+GzBegMvBi4QVHcLPGYLRNlAcYCwMAwEARBEdJVAgEBWhsbBZMFygMMAQDNpPAxaFQFAmJRCwsDNovA0GWgChEGKw5IZsA1YgwWBpo0nJ4MZjhFBjjGPEpkTHCMkMsR5WNiPMh6UUzI85mOeWwbnjJqGbK5cOGYJAYFA2Ro5p0mSKpOCAKBf41qxmz5cHGZE4RMoEQJMmDEulouk6iZl1jEuqlgkLHvIgSZMEQNiYJwyIoaFAcwiBbLhYZE+XVF5FAmpwUuQ4vFwlpcTV9QYpIKpAroS4yZOMmRQnDQTubpsmmybrTdNOMcOAiReSLxskZGxSHKEEgwUkyqKnRSSN60UyXZejvYfY2m/6uCUUAq4AgOBsiIhEBpwoIBgaeBAGTAYgNhPBFhlSIrTIw5yiOIwK2MGJxqnMnQJA1LiKdaTKcomxiSIyi8kqVr0WEUC0DwLjoBuAUUooIsB8I7ttQqQ2//U1Bvzp7+T0f///////X//+3/+l/3V7f/63/9FH////t//gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACYmLzgd3YACq70lA7kwAYynvMBXtgAMxPagCszAAaSFQmMSRUNr8fM6jLMoCjMiIVOAW8MxyWMVAPMQh9BwkmJotGGIYGMommDQCoIxIHQSFLfHQIebjnDkIJVMVhETk1QuOmSgRMPgkClyCBEYRgKuxYZRNcRsaGKUDdUIYu9q7oY1JostZR4tiX2IgaFScwIJMcKzWrU2pgM8JQEKl4XICAZfrExEAslml5R1uqajbamkESOFqHtfnZiMsjOGU3zWOONNljjyAlMkxhCjHaCIYAqCu7Z/LvcpnH//8u/lT48/LrwpixXH//3+yuPdz///////yid6qu9tbP6yrMijOWv59b//////L/7j+q0Sa0OkwkXOzS5Wsu41cZl3e4fj+W+///v8Jdj+8Mq0n/drPW+Yymy0dK6HrWOP8y7v////9//6v///////2zjVEhwCmGg6bO7BnUvGPREYbLxlggmJASgKGQoAAEYCAJUAcgViom2IuHyEBD3ALSE/DmEXJk4PwsJBR9ymTJYTIkXkygK4XFDNh8hInyCHTI1NCZKA6yoSpFxQwagAUoAM4A3wzYugxAFsCAi4yaLZfMVFBM67FEn1nXUhVfV/6zE1DqgW8SRef9X//UXn+jt//VoJfMX///+tEXY2UvqVQS///9vTUghTMjFQUAEMDwHIwhg0DPCG6MZcHNVwWI3NTQRQwvAJDABBQMBgCMmCoMBYBcwEAJTB2CqMAYARpKXCJYgCDAAI1A3NZOTCQUw8bLVq0BAiVCEOfwgSexXsjLuMRHQsuLGXNdRIxFiKFu2HrKVwCASORuWvKv1VjHGnQPL18F/AILk4gaiBAIpLbGJhKx1lQyi+2OHKZ13+cKNTdhpSA2KUsTp8q3O2M+X8sv7njlfw7Yf+AB4nMSJ1Yo7axy5rvab//////L9f+3pZtR///t/cfncf///////5bXwZbS///umnNZf398/////9/+P/3mcoAI0Xqopdb//z32gjmsP/+f/d//4TVr+//6pufrDHPK9SROIvPu3mF+jrp5Ry1zoZnjG5LKjEUIGDaENFUoiMAo1ghwEyTQU20RdADjAZgBqkDKcAYYJIA2EBsQXR0BaAHqDOhq8ZNAjxc4YoDIgggVBN4N3iUxPAcoH8ECCOwMKQ3sL+Btg1QuHFtD0w+4ZcDVA5Y7gtdBZ4AhANUANmAOgAv2DaYh4hIHyEGFaC4CPHPNmJsrmZuYEwXENBzAuGjJ0EFIN0GHWLgIoaN////////pv/////WszNEGpupAuF8vp+v+/+tN1pqMCcRMybJ8ghcLhw+yXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACGKQTwZagADc0gpQylAAHRHvNB3aAANvvafDuUAAAwbkOAzbhfAwUhpA0rgoAwIEjAxBDWAwUGRAwkBBAzBlQAwggqAzzDDAwEhTAwOgxAUBwBgJDWGWwMEgOwWEMFnwNGKC2AEvoGCAAYIWGqQQJBYgvSFCQnUCwQChEdY2w9kdhWD8QvsJ7FmimB/g1wWODWE5CdwsnDRxjA8wuYOUCASDQQGCwuYC4EPqAmKBgxQN2CPh0KAyEEAK6SYe+HzkNAzgEA5cGRA0IaQ7RrmhmXTFaiNTRLpuigRhfMmL6k6wzkbT/WGSiLt7xQoXer86fu/6z9v6n/pvOt/Iuc0rL/kVNakKv8fBbdMvpv31mg/qd//1IUdalVrHWYd/25xNq7qqSM0jq1sz/8IpQNGSAWOgb4IAgMAHdAq/D8AMakIsBpB4KVBZg5wcUZAbEgBI6FhIWZDlAFAwCQYEoAYCEYjlFscRJgYkCIYK4RQZ4YwWbIuRQdpNha+IuG+jHDpJggQXwIKNVyBhxAREg3YFswtGCAaBjfgByMT8NIzYCSIFJ4nguEYwGPogeIkBiwYcYHSiyi4eMjJLMjVSSaqywanzQzSqEgGw31DPCG/RdILsT/U3/t/1nv9qv6igva/9RWVp13/I8lmUaq/0iOIi3/X2Nv9lFAq/+/NzXVrUs6TBSPMpT1+3FALMJgrMHBJNEM3MZQTMBgeMdUAOZUxMGgPKoOGH4GCQ1slJAdMJh8AIECMAm4hswCwMT4BjVgZkPmDLoW6BQsGLwaDQGsQoILjC4hyxchPCCAYVD6ChR2ieBOQfiLJI8EIIERAMYB2wxEBYEDcQ6RPg4BIgwKOaGWgM0pAaVB9wNoyA1wkCRMN8DMhoweqF0RQQ6xRyqakwUkiDFgcCRqxwpss6mYmk1WtZ1P2OD4HoAUEPReTt7f/84l+jr//tWZo/dlf//+6iSGZJ5J7PQL5oggm1H29dL1oMyM+tNRMkDTSKptTSyTkgNBRhELHAW6ZEEZh4DmAQ6NhIwmLjAILj4qB0XkWjAIfLql6WqiCQNQgAwoKBwpjDLQapIYCgUlA9YUUUOI9IQqhl0mSHDKj2SRDRZBuQAfQuEUGIsN8iRBRljUqkHFkinC3Ba6AMJAywsDUYQPtGAPAgFDQLAQ9cLfhMDIiZqbkKS6RVIiYk6NUfK0DI2LyTlIuzYwdRkkk19zpOhnoGaGkiXVJf/9vWdJ39KtX/9NFRMGz+ibI1///9YoEPeIqatfWikOc6T//U+vUl1ougovFYOKHCXUXf/4MgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgLe0qD25tw2y9JkHdUbiBV8SgPbm3C2b2mhd01uDABAGMAQCcwHQwjIEaWMLMEwwGgHjCXGRNHEfYwbwMxoK4wIgKTCxBOEgkzAKAQEQhI4MseWoQhyEQ4BgmjNqABAHggdMJCCgLdICCARrP0izTui446EAoMAQQBhFv0kWKTyqJQAOCoche84GKUT2mowEgAhQo0w5FlWoACIAITKjYYwTQjgzM3KoWRAgI9gOCCIAfsGWSbD0FE0KMKMViRI88TBoVCmOQVoyw8LJ8tlxMm0EUjNmrLA+A5cA6o2Sr///tmRr+rS//pZg3zFqSm///rMRISDu90WpF0lCZK1lLWjvrWjXUlZ1pOmeKBfYnB7EEhkyqXR9DSrn9vLCB9EjToMFQFOPj7MkQRCgWBdPTChBDAgKTBICwUGBheBogBsHBKYTjUp2rMWepC7kNGAJiFgDgqN4kAg6BRoMzhnUenGTNOsNgYQ9cHO6s5lzR3FktOxggCtorHEm5P87pMReVv2wmCArGAJA/AI0gMaECzcwooY8mRBMUKOSI2H8vE+MMwNj5FRirQSRMTyiGltI0Osjd1qSutRKAOLgNRg45jZH7f9/kaPT+s1y7//MWcnvzhWXrr///KQfkHOM2dlsky0iVPUar/1JdC7qduXjA3IaPgpCFS+7p+kwCABzAZAWMFQIc1BUHzFqBJMFECIwyiCTRgF2MGoDkHA6mFIBGYRQBRgKgGmAyBmOiVKKGFgQhAEczABRTA1gxNBIyQeMHDho8AQ0hJMSNCLPSpSXfySOwkGxgaSSYQbIXMSXhoHBzkQYQDQXBFJlnRQQTxYsrWmK2zmIYEwUY6UGPEJgaseO3AEBCwCCkoBAQBSwC0h+oBog5ILehCg4RBUTkLKNi2UCCEmgZkmTJ40M0SHmyKlWZJLaZGwDjhZULanf//tX7/rb//rrRR/fv///sNgmjVb0VJGVMc4topHK/p2fpHFnVoJnFmbGxSKxAQ3YzxFTI+fKC6wql6tDuHNYCQYluCA4NMYiMOgWMDQDMLAXOEAPMOgaAgOAoCyYMh4BxoCDDgU0GF/pPKzFt0aYLMgXS2WbOsiT5VUSAcOHJRdlEecmAYtKGuu4tm+/dtoFxP13oQxbOmf6A5LCMGHhwg0wYQwXtCoVOp7wDYCphchM0yQPmA9yC1IsJQuUUz55TpsgpdK9W1RuHJBOj7////ZL9LS//qqRb6n////jiITeu9zy1///6laSaSBxjo4i+aHv/+kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIHXrKA9ybcMWvSXB3LW4gwe0kD25tw1s95cHdPbhUQKAcMFEGM1LinzGLApMBYB0RjcGe4MWYXwJxgbAnAoJYOEwDgQDBEAmMHYSEwWEwUDQgBGERQTFgQgwwEqAcOzBwJIAaTB4uangDBwRLZI9oLTmvP+sljxg4Ap5LyeRZCAUuermEGEQNDAKCQYGH2S0UHBwNf1YEv4iUqoNBcxuMTKQUCRQAi8YODpEgzDwKDI4EaBaCISCgQxoG9iChBxAp+ShER8jvNEiaZFEihPEqaKSNiwpNGrmSYNRgZgjZSW3//VX6XtT///Wbt+/Pq///nBzxwIIJ01IpFRAZkppKUlXXvdO2kigYpHEFlxEyMRpmQ4RYCCg8JloQQD2uS0CYanKKgMBBnMj+nMDAtSNEKXGQB3mBIRGCQFGDIGmAwCGCACo7GO46BcJSbhBHJc1Aou8bUzZTJEcAMbkAOXImHLR8emtfbqnEogm+pg115kUqF2Ov+1p2UDFHU/GWsWXM9sNExNYIBDwTNCAhhTmEcETo0KA4QtRHJcLISUKqMKOwS0lESgTRpLhmkamrKJrJlBGztSV50egc0BKFE2b///6P///+g3////9YwhQQ+tFZimkiu1D66/q1rUldjhkSJJl0NTNShUAoCgamBwHoaBMPhhsBfEISJg/kTGkORGYNIFhEAsYR4Khg/g8mAqAEYEwHZhSiwDRIYYDAUAMJDiyBgAMRWQd2GJB4kMM2JSREww9oKNKmm4fYkuiVA4iMQEFY0Ui87umBAqBIu6poIAAZEkMRYJKgiCAdBGSA6tSMgjAH+SGMCDRCgmrKR544rec6SGFggCmwKXAK6GAROoh4jgPoNkVqLjH2mZDmmQ9E0XUmLpgXCgfKpWNTcxQRSTfTkDAECEgDGpOl//9ft7X///QRNfq1rV///nxwidU09lGyJXIsKCPGaKVVuptm1ugpkFOcNxquM6OcDdIghsVnDCST6Knt6S5B+hFYAACYPiAcWTIZThMYJAOYajkcpiCYVgaYJhmqkEDiDgdKAUMgBxaCsVebwCQqPqtEaEBIF8rtS7CoWBUga7lyKbb1WxneReqkdJpMOsbnMJexeD053UaPx7lVnnmmbtbAwJPEWTGcMHXNAwORC1yg1yMljHuSWQr/OuWjF6vrbtljr3Ke8bWa+uN///LYT8AQ0i/////////f//zn///f/////////h/////6//////////xhXLFNf/f3JAtum/v4/////+P/X53nedwbq1Lvdxe1G3/pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB9V7SQPbi3DTr1lAd1RuH84tJA9yTcNePaUB7U24MAIBMAgeGAcIGYnsfJg0BTgAFowfRnTSrHUMJkFEwAgfzBoBpMKEFgqgKGAGAAYXwm5gwmEFLGC64CH0MTCtExkCEQkYGCgI6Llhg+KsAOkhEAtZeadL/LKGBQDDBEAy0vkYCACMAY676tgiGk7gMBlyLiA9bS5HWYE14EgD3GKmo8mFS0MzLDcRkx8VARYQhgA6C4wrYMOHwhv4esK0GuMwRIn1kDGNMTEwkqbnCwYsTpdRZI6nQ2TkwOaDYNMUmv///2/V///MW+rqt//+ioY4zZ91mqJ0mFlVj6r/a6Ta7oLWikxmYniYIGKTGsLhMiuJfDzvdrCDqUqwkwHhAyn67WDU4gYLjAFiTaFwDDMBzAAEjEoCDCEAWSGDwRmXY7Fgk5l4RFyYQjgo+dMsnEmC9JYDJSrlVY19551yadWxrpQQFQCmyKbjtwVOmFE2usSCBQBDLyS/etgpUBO2utPBO1SwzJILgQZOCJxqyBCSdkGgkOIEJDASkTo1CLEkM0Ow0QHCPZbSKp03mJxN0FrqdnbrUbiiA60Ocedf///pfo///yKN9fVr///RDB5RVajomZSU6/v9a0eutGqyJsgYkaeJ5MmUiNF4T8x6jAHAGMBYCEwVwuDTUZqMaEEowGAUjAYHpM3oZ4wBQKFpGCsAiDhkDABAuFAEzDbDqDBQk0zEgA5gQJrnMYGgxuBQCIRYACgZMHgBKcwKchIrIVNFsRBejfgIMDQdZslwjmgcqVQ9AK3hZJAXDpgwAhwCCgALbs8T8YkrIXFXKW9MDg4wsDjiAYAzwGhiJG9I4BPiiFwMvCzx9joGwbBayZqI8ZQT8alU4ZE25gVTIonykms3NJ482pAZ8TwHoE8mr//9XWn7f//602f1dk///6mJkiReo7qOqIeM8cZqlr7L0/U9NBkUVlhErkiQ0LfxkibRpLo3aqr9/+tjRF1ChooAgYBYSZlTJHmDqB+WAJjBqDfMrIAgwMgMTAVAMIgGwcDUYAQAF4wpgSxZw1535EAhYOCIYB5lgQJKFkwIFVEYIOgSWAbSxOQQw1VpZVrzlJzrMXAFwU0zFXiFhdpjkRXS+KVDTGfvGoG7QJCmEOmefBaibNQYIyYQCYYgDjhygb6OYHwikRQpgT6JNsXi0UiSmaCDomhhUaVKSRTS9E3BpQXhP3//9f1N+l//+s+e+t////qTD8SJLapS0EnLxbQf/60f7KXUm5aSKRDRZpImTjKb//QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgTfEgD26Nw1o9pQHtRbiCx7SAPbo3DUr2kwd3BuAgBUSBbMIgAY3nQEDJKBIMJ0DUxACLjX0FBMKQGAwDATjA5AeMLYGMwKABBYHsxYBLzAg5pyewGf3ZBAcaTeCy8YsPAQEM1Dy3ocWmATg0NDQqpQxdkCn1TkAwGCJEQLlIAUqgSSxam8OAaWQJLGeiwmCQBPRNFi6UI8BqLCIHdFPQmlDJLIzEsNwbyiXXKZQBABQgbvDYA/wkIRBB8Is0P2ImPlicHOJEibFpZdPqIMWimibJKRMzRRonXc1AWECLidDVJH6//v7////9D9qnV///WmVhlD61IUTiTEiOkqGTdva5qi1Rx1KTWszSkNMzAXIJWOMzK8wU5x8v3X5YzrQXOEADIXCUMHRPwwCQUjACALMBAO4w8BBTAwAYAgCpgIgJGAsBIYAoDIGBKMKkHAUFuWyUdChUAvRDNQeUFpQwCND4GKolGlE5jsZo4MeF1AwBAjL0Wn1cCFu3ADrjwSEIZpyoOPFKYeQbaQthi4WDmLJCwIz+gnPAZ+XMMCEBvoXrFDEaeFwFUb5UJ0iTl0wKqZkgxst1mrpmiBidUp+86WgTgWkm6Tf//+pv2///mLf+///+ock8m3TRQRSIgeZ+//7VMt1OowSOl44LIJc3RKi2q/R80iGYCAFxgqiGmso9CYwoSZgmAHmEGWgZrpMpgdgKA4AswgQKjFDBBMCEAcwAQDTFTE+UsonzIoBH0qhZoOCHmAODVAzBRYiMSYCKlQyxLdrzIndUCTmMRGBI4AgEwYiBFMk+RYEFgcGA6FRCNioGX6QNBRYlISgalSsC1TFwBB8woLASWGApzbGBqYxAgMfETAgUBgwGJwGEodIF9gwMHTFQXMJ/JNAhxJB8B0uk8XzY6YlVAnC+VTZEzTTSWrqMwEFgRRiKlR///f6n+o9//+xA1/U3XV//9ahQwaQXm2SZEvFsmTM8i2l6mmfqeYJIrMVHWLBKkcIzJwhzCIabXBBHv4fxZJckwDAowuEM7z88z4DMMEcLkkchjmYDhIEBOYMgOYYBeAAMAABGZQtmFEEvmVOk0QsBAILMlC23AwMAgVN5HgGi7R6jY7k9DbdWwllFL1gnoRgZYutpssLgpxAYiSZQnILN67DBGwM+bRTMAiJkAmZOZnnApYDBkNGjkYIAFYUIRMUGOeINE9EPICZkSdZNEVY6alYzPpqJ5M1PHkjQ69J+sgo9Bqiv//+r////9bf/S///5NmaPdaklGJWKjtq/2/ut1VmRXKLEyKYOcXUHPaWWe7foAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH/nrIhXqAAMdvSUCu0AAtXkFGeVqAAgLIKMMo0AAwGAPgwHkwPwIjF/fWMCsSgwtgODCTCFNEUW4wBwKQKAiQhDmEeEYYIgGhg2ARGI0HyEAltlWsCJmBpQYGCDAcSuBu5JAgMAVANFgZMODY4At+BsdFQE3ybLgf4DDgADmoFggqh3h6wWIBiMjw+UBYUK1ASDC18CSQNNDEwgIIBAMBA9ERsIYDeoQrQOOfA/doDaSwEGwFA4a8AAeDiYYxGMHSFh5NkOKaBFCdOFgqoldSBVL6ZFiRc+XGUgg6vpEYEzQWUFFmX//2+pvqf//9i6/7d///9Enw+qT1oLZTJEOOdS1610K/spFBOiYGKKjEckV0giIuQFnC5gn2t1idwjCQWjGglDx4ZzV0rTD0JzGUwTVcwgUIhgmAhhoFAsDwNDUHAOZAikGAK1dL0AwcDaAkwIBgWUgGCQ9MPcAsBDGQgcVIbZgREujOEGGcKgy5wXIKIA0DGELIFmCAYb+FnA1aGEyBCCAs4zDLYzgaoE9h6IBAwBqCH1BAXAyQQBgCMYGuDLg9mg8DGIETcgpmbJGySR5ZubKQUigim/1epIigyw4H////V////Xf////+mYIN163dFb+31/+6tN3Om5VUZmnIxoAAAAAAAoAICABm4VgYREAGnS2BgA+gZtFwGOg8A8EgZjJYGKBcBwqnAYtM4QgQngMKCwAIeAQB4GHjmiHrAVAIGCwaAwggCBIbj0gBYLiSCgAMljADEw1C0g3TQSEeDgDA4X3AUBoCAeBioEgMAk3dzrAFBASQZceA5MV4DBwLC2I6iNFNFaILK7AEgUAIxgYqJwGTA4BjMIiggMIBgDBzOAZIQaAGzAGAdb7YgAAEAwbZh04jQUmI/AKCpYD4w9EiQ/nWqP/C6gkDcggnsQDHIEFBShwcoVsUQSDYAxCIQaKX/xYywRAUGM2bkDFzjjHYUyGi5RlSLkeOSTR8mSYIMyHWm++6iJiyCIIEAFyDgInkHJ9MmxzyLHCLDlGKBSIeICitDpFRzVHbf+p//8g4jw1J8nGTJgnDRIihODjN5Bx8DgL5fN2Mzc0aMaDc8eZwvECWgRYoookyWhjRngMAgAN9NKKjIvIKMgDTQHxDhkEDethWAUMgWqBuwMSFDAQW/kECYEcZJirKA5Q9CQODuLDM4Ym58eyQ5SSToIOmmankjIpJJkuZnlprmROWbJXJItMGuF3DlCZkuSjDOGMEC60v7oIM9kqCvnG+nepq+ucNf///////1////1f/////X/6f//of/9F/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACYyMTwd3gACjsElQ7lAAJE4zMhXqgALjNKfCsyAAZSkaYPCGYLWGZHhQYih0BQ+N2zfNLiTMLxcMMQCMMxHMLgMMLQdAwcmLIKlAIggDC4qcwIAJhQIkIfMWHAODyCzKnGEABAALEApVwjiGAF61yg4FPQhWXefdTB5lll0ZY9rHlqwMoNaoKzOcHJU0GgcIQYYFABgsHGEQUhJRAMKvg4OYjHIedZ92mkQFZY6iNsQl0rbzJZT3yHdZLVXUnrVc6XGq+1qLU1Pbzpfx1ayy5TVqrMV0mXiWYzBRa6ldGP2cdfua/n///jy7DrSW27zdxPnL////XwZXx///////nY9T/v///+tbc7L/uP6tGBccv/fMf/XP//+rHYgjaPDhKLGzjz////9Za39nm+f///1bG+f3XPy1lTd73uOPZSWlcXCtj+/x////////1Ia6agAoWMI8Az8JTEgVAAHMxB4xeDAQAWcgQAJFrCPshZA0BkWLpNCyhQgC4ccJVNTUmhyhTi+XieSLxBVlQiqBfNEB3E+cKpbQJ1adJki+SJDRzRlRcJkTYDk4GoBhvpGkOKowyDnDI+yj8xQdUpGrL0klI0UW0u35kbADAg6UirpK+v/0jI18rf9f/+tv/PekZP//9SyaGGWv///////URY2/9IOAnAgAxgEA+GPEReZa4dJgogVmBIBmZayKJiChimAAAKYF4JJgZAVmCGAYYFYExgJgjmCQDcBgSDAEAOD5RXQ+UAUBgYBN4GDiWBiABGApUOmBtgHFgSMoAQqFHCyIWeAsAQ+QLpAEgUBQIpk+XjcLECNGkA0Bxvj8I5DHyoN8mROohhEywLWUhPYY1DVYNggDCqeAyaQAcWRSIFQIHuBb8H9TD8Q90+QcdY1R1DhKhqkGokELpdNVnzq2TWgUS8ymqtWiYlIUiDUJAZNUgBx6FwmQpEhD7JZM/9ZsNU2ZKPgaZgbfZx9D0//pKKQ7nW30x8jSXc4SZmZ/9L88OomhjgMNhQPmLqC//up9m+s160fszIpush5SE7GzOv/t2XmuiciaIYC6GxFb0A5hpIiF9zHNNc0CigJMsmydd7XycD9A1QICBgAWAjhBQboXOCCArQZgtG503dAmCCFwmDw5YhcZsMQBb4FzgXCCdA5AGwYDdgYkDE4ZHDAYXPiC4YDDVZByTFbhYmByYrg6A9QOIBsEA3gE8DsLhMFwmBzCCEUIObugXC4g1SCDegmmmmmmm+pBll8ulRaCH/////////9aafof//rQNDQ5//qLg+D4PmlCcHJQ5wfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAf9kE+GVoAA6hIKUMpQABxKCTYd2gADfcEoQ7dQAAMGo8D6bEAxQlwPgJoBCYA5w1wMc9wGJ0DKOzA00NgN8XYDI4zACF4BytAwiAgLJEAEmAHFELAgYpaHpgCFAxKBlTQAwYCIQCTcBguGMwBkwNgwG6YEgAmpAwywMvESJkmzEOIGUD7DJCnhyhWFLjRIeQcWwQFHIDEYswLPhb0TwGDbADTA5YP3NQ8gALQAYwGIRkh/BvQDBFAMiLEahcUXpbYh5FkS+srk+PhzI6odhkVHLhnRWtYpgtKDqZN0SODNlzdSCh9iARo3oywnv6d3/rdbf1Zikmk//rdjT/7Om3zIc3/U2pByNP/9iHf6tO6RQN7f0iN/9qaCRWQrdviFANsABqcAzRkMBAe8OBmlQA0IDBswoFAxxgDUnQAQgBSoTiLLA1aELFwDQ4FAY7BGYaKBhS4GMEhjoXMg4IPsOlD4wGiAsgYIkQeUSUihaF4OeMw4rcvjOha8J3IxEnR8kDODPhigPkFzhb4HGDJAZZmD5wGOKjqD5gslEvBGGEJBplAbwDwIG1OAFAAFC5WLxkVSZPlw2NFHzy0lk6RNZ43oG1UZ8ZBFqq5dDeDPpusXhBTd+tbO39W3+ggnv/SROF9ur+0rf/dBjT6zc9+r5kTIzhrf+5Ot//QSNP+iUm/6aFZcHTdTPvhUCjBMHjEccjEPJDJwDjB0PDFkXja83zTAmzEUXAKGQjCYwbAgCAArEZEgSq5rYgoACABsDFyACkwFFIamIGIIAIHE7FIDHmwsVEKiBhkjEbI9iah2xmRaRgEMHYDckOMMQ9UEA8MvhooYVEMD6jADnmBkeEDCAJBQLKgGGgUDhiADVEARZAHhRC4xRZQnAMDDljJCcyLGSiiekSIcXVI2L6KLJSaSRvrbVeZiVg2dEDFw8Yrb//zrPmKv/b///9SVazQwupv//WdGoRJX/+j/6mXq9lI00HSKBs7Fw6AtTKcnmykLB5uBwEiSG5bA0VuJoUDDw6AF3gqAyNUpEiqefMMuiih0Ae+AsAQAA6KRHeJRD8A+ELoh2R3CfiClogoy5FRAUP1FsFeFbB8Qs4XKOaQUPyEdA2KD9gukIJB8JBTEvi3EqITE+GOAIBYGDAWBIgAaVJwGFw8CIFB0AhQUiI4GaKI+RCURyOaRUho5RPGyJFR7RQmRkXkjYxROmpsk+r9IpCFgCg0GYL6RkpL//mRw3XUZGN/9//9v+dRqSMkiVNW///MA9sirf///1q7dJJ2qSRRMSKiukAJ42ed9ugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIH4LLA9ujcNeQSaB3VG4gQgsqL26N00pBJgXdzbpZoYAmYHgEhjKlzGcYCIYH4A5gEhTmRwheYd4PpgHgYmDiA6DAqjBHACJgJDARA9NQmCAATKEghTBM5sJgCycUDGBhKC4cTmChDwgwBNIOSYTcdzJG+D/OwJCYYJhA81Bo7KYU2CjUIc4dB0IgqCBYHayqZGpP1GFiqYpexkoiEocAJsaS2nhhoGaEgHoAMSQEAgc4AMDgoEEiDIA7yYGGQAbolRDjNEcgZooMaF4iplIESZqXDhgitaCaKW6lG43A4gN+LCRit/b/omZ17KOk7/6P/+/9dJ0mRNkB4Osu/V+rdjoypmi3//V2f/WvRRRTTOGRuYsJ2ELCABis0L9QOuavMMCQZEIaGA11GW4nCgHgQCzDWNV2iEKQUCgiEZihQBhgqGAq7Y0VQK5lPKXLDM0MXYZWqmQgnndxGVQKGqO1FHRpoBZWvuBXJlbIG7QEs6OtifaHW2T5avi7NJaRslTZWXCEENAQcENRAM+lA3BUEwAKGA2cSwWSM2RIb4xxPlAnx8jFLynJId5OoKWkjLJVOnWNlPekvRmMNTAyjcBoTk0bt6X/sRxEuUh3X/zb//NavtOspbnCeMz9v/9ZdcyFaFs9//bX/0erXWgykkjh8/TFamybrdPEIBGAEAKYB4CxgdA3mOWmyZtQR4CCHEANxhqJBGIuCkYBAF5gQAEGCaE4WiVmMCIGo9aXGikSGYCS0AoKGA4BRzUi5WUmDjERMvOCgVCaFX59EqVhXCeBuKWgUB0BiTj+OAngn2OgCw8rgEiCWklomHhAgqomCnepWmgpqw0IBgSGAwmEJSBGEz8ZAZGgYFcFlIN2g2cACGi0g3sNYQ0UELOLwfCOYTJiaGZFCfZROEWc6xOnSLKQUcdTIt6yKjUAwoIQDNEjN//9lsip+9L+r//1q9frmKkyBH0Wq//1FMWURJHf/fV11W7epSlLl5E6eRRKRTFyDZHg2MWViwYHtj3zQBQAhmYFBEZhz8a8CUYJgmYGg0atI8JLMWlMHg9MAwiHg4MCAMMDQLOnHASJuEg0X5IBhJN8iIGDhwMC1GG7igCrCCQGAlou/QSqWxB1I+sPbZAy5hiljcn5ep7YeQnpWKArtikpjzO3sWEgJugOHxgeMAVjWTEGxIAmCJCtQbDhf8OWE5kHFrHyMuaChyBMoqF8qGDIoE4fXN0kGPo7prve5GsL4VIwdZr//3SUbP1W/rf////VRdzQzX//6SzAnlI////7e+vpXTTLbE4NIyLn0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACDmCSovco3TVcDlwd3JuIDoHJi9ujcttQSWJ7VG4AIKACjIEgqE6YWTbphzhujAFBgiASGU+A8YfgB5gFgnFQJwwIwZjBSASMBIA4wLgGDnIVMIhxyVBjCAdCCM2pAMTNwNAwqDgGYBA7EhoOIcTGIrKwowBMaXO7D1AnaYSA7B59mb6KVrrQyf5OQwaCHIAICGgYQgRFNRVaSrn0lKAxpYYAQQGDGg/MIqcysLgNEXA4Y8ETwDNhxmADCgucLkCZiJBqIgwnRZAsJ9ZAEhwG5cMiZdz5kTjkV0Woor2qcyJwDABg343Uizf/7mRxFWtVH+r/6u3r0mUkt0T6I3UzS3/1dRdFcNG//9X+qro0E2WaImEpl4dJbGcE7kkSxhkiTQarRUpqX6MHAPM8U5BZAmFoHmFQdGtrpGLQlGFwJAAJDAEIxYaI0YGAKc4iBxC1RvgwyEAElKIAUSChopC4OUCgiCFzt3Ijli78qjY5D7gNKXuqwtW/Cq70JTN42KWx6ecJySIEctONlDttq27TUAzeIECAjLsDIGZSVhiAK+FXBRhAIfRMjmBqggpFieIEUSBoHDA2FwmBqbGxsby4bqM0EkHWktTv54ao+BAiaaCH//1p+v/////9npJGKaS+//6aRkam6v//q/26/SUqktzM6cImT5qH0awCRaAQGhgygYmS4gyaXINJhCAqGC6FWY2ydphshJmB2AmFQBTAEA6FhSDARAqMA4GE7LaGlUWERUAGBMHDqTBgCGHpJg4+MA7zIDmlhYHMqbxYXTofRwH/UDeMwMCLyoHMUJAhVIgBAIBuKoCxYvMSgyA1Zpeuoiek+kC2JPEtyzZW9d5iocafvnRLoGctgFCAMwZA1wIEiAXRGScY0SmHJjvJo6NkiEiyJFh7LZVNU6RMl8ulBIrGKVFT27GAsohgqY7c/9X/UY3ddTOr////7retFjRI1NiaJ80v//utIcxE1/9b2XdX9m7prpIGDLQMkx3F8coWoN+IKH8tlr272XAADC6oVAOMAYFUwh0MzEUCHAICxgAgogkr0wFwRzACAXQYHARTAeADCwCYMAkMR5cRNdAWouIRcTRNBs0xwciHrCkwOTgoegIe6nZpGXTnlg26JqK2Lulj1OsyhxWuP8tpnjKEf2kpgxdrzTSYDdUpbUvoo8YkaULQDzAxpIDZgwxMFwQEgIpouQUIQ4ggm5yGD6IqkozSQQQNlGp+VjFMzNaS9dV+bJAPLjIrdJX//2NvdD/vf/q//tWimXTdBP//0GWJSRb//f/7++utaLma0ZESHGhsePPTo6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACBWDSZPbo3TdUElQe3NuHjoJKG9yjcMJwSWB3c24AACDAPAQMBoCcwUQljH4YQM90MYwaATTBpBmMZRCAw6QZDBTAjMBwD8wQwPCITkBAjAQC486vCwkDhdlTOTER1cAVRQeEBxuVQEwcBMJAguCFuDFnAt8nG2J3ZhksRIgwOMy0VxV6SSoiIAZQyx8QqMv6OBsMIzwWmU/rJ4HanDKkk/zLhUwglNQIDKiQDtzwNGHAwR0CA0LGQwYahhAUEH5DrHwOaH6D5RNFENGWK5fMC4XT6BuXzyzx9NO6CTdpkQUG1hVn1L//84o63UmpN///VoPWr9dbqVMDUyJpJD/1e6aiJFX//b/9vQrZNZmy1nEDIZgjRyR5RPxlZkoBFrVU3cKADGAyCCYgCLJj7g3mBIAEPAPGM8L4YlICRgGASmCoBCYAoJ5gMAFiIAswFADzvzxri64OSELdKaKVmMDwOEiQGe4lEXSS1MDAaFr78S+tKGHscR3XKhasCl48qd6a0iVsX0OgSqRdaAlE4GXa3JnLME3XysL/KykwkQNOPAMwAMbALoLwQEBYolZdFrIaK+TpZI4fTJkPJkiBpKqj6TFVJI6pmtRrfpopgUqGlksozT//9Rwt+h/////9SO8rltbf/+mqHqp///r//tqoPOoKOpkNF2fUanUp78mAAABQIwBBkCUwCAmDDHbeMQYM4wJQPTAmA2MjELgw9gDjAUBUEYHxgFgUjQWBgIAPpJHJw2i+7zgIQKJtNMDCM0ABBGDWKt8YDCkOEAGDicPBFM6RxfTN4YLXo5MrTxbkylsEmTOZs+6qa9n3CACwZGRS5vWYNTi6aDdoZHAIYeDZAWQysBV2CIABlRgbyAAEFympgVRcArw4SMEZEuTaJkQceDd1KOsssIpG6jzqtQZ92WMiIUGGr//+maJo10lmD+lUtBNn/UZqf/7prSSJQfzVH//61k0anv//q/29dd1pLWYmhQNkhbxDS6aKZsaz0JhBwAmEoFGjByHM4TAYWTAELjOVfDEQEhUDDAIHgaEa1kAa1TlDgWOIanoaLxooiEBMTImlJOFtmcsBclnrfrEoqs1H5pe6lzH5W4TdWkNqyycuJyMOfdpitjrv2vmHYGlrZW3bEjmEAZkpsZEFB+QA4SGgJiHoiih8xSFyniLlVIvlBSiqoqlVBNKlcx2RUuk6/zh0CsBczqRPf/+kkVvR/////+raYpopP//6nKQjI2////7f9bU1GNEqIkwbKn/6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAePgkmT26NwwdBZc3dTbiFCMyIPco3DXUFlCe3RugAAxEUaAnMFAAYyNyrDQ6A+CAtgQA+YpyGphqgnmACByYF4GpgLAsiwagIABMBgDs7K4GiBjzRjGxUeCE5RAMmwCBkgmj8DBV2Zst6YI5ll4Qrbbh59H4ckoJC3rXofQ2UmnCrhprqxcHEq8HTFAB+lh2GpFrpiw6Bq0r/CAox4WMggQsNgdtgGwgCBgBioEhI0gGhYuYR+ZBmy4RMY83QSJksjksmianUU0jCanUEGQWigj1uWRWwWkCAhqm3//rUo0f0G2+//r/73u9VAvllJBt/+2tZoOgiL////3+rOztOmgaGBFSuO8uGLD4VrsUzSAAABwpkIgDBohGMWgGg4iAwAwoCJhWt5hsD5EB5hSCAVCcWEIwRAMwAAYz89LWLUq8U0mXIUpLtATuVmR1bPBg6CgJd0OVrMfoWtt2Ye3Rhr8PzAeMDz6gylb/KNtLWEnoalDgMGd9/nSKpVHMyzIy58D4IBaI9BdMMDCRGo4TQZhY7SkinrNzRBNkElMtTqdNT9/0TohKO1VT//+m39F0kHqzbbq33/+qutSJePL///ra3/////q7Jn3N0CmMwx/1GAYAiYDIFhgnBTmNG06aOAaIGCuMB0HIxjkfDFjBWMCsCMwZAOTAzDJHg9TAPAXMAYF42BATFwIoi24YPDFIFYmIRaasMKSZIBAgUmBAmvOHTGB0DBsiK5Tkx5pqZScIOMiUrioqtUZwIAAzlCgRg4qAQmBYgAiMZgACBwAQTvbL1yNVCAq3EuKBQUYUAQETplUCgZKoBmQANjYDgQOPiEoYKFmiuigxlyiWx9kBLxgZDLi4C8gVjpFGTOkEWTpqnZTJKftNRSIKRgtZK7mSH//UdOGqXPf////9WmmpM6gVS2k73/V9BFQk4wH/9fpX/ov1ey1LWmamSA5JDxWhkboup16qTtr83wyAAENECoA5gKAuGI+gAY2AQBgPgWpWmJ8GwYN4DhewwAgIzATARDAOyICcwAAETj1IEhDN1KM2bKKDoeQigBB05k215IthUIHQOmuSuETbsOyzlWlMJf0sTrZxArhPg1VVrLwUEy+AFjQ83CFrwlCazYS5iOBaQ1WAMxCwArACiUgoGEEjBFHEMHEOAiZCDKmhTJlNzxiXUzFFzc1WiUnSRZJKp6/UUieHME5nqf//1Jq/U/99v99v+rdkjhmTrf//nCqbr/////6qSnZ0DJNR8iw5JInVfSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHY4JKFXqABNQwSUCu0AAjKkFEeVqAA1fIJwMrMAAAAIMAUBMwFwJzBnCTMLxVswTwlzBFBJMEcFMx9QsjEIBSMAsCYwKwLjACChMB4AAwEQGUQzDfBIBIBSlooQMqAcABQeBixYPagSJg2sIaAuLIOGRwNmkACMB/hbXLR8UwLPCeQ+YaIrQoDMjSDfDUkgs2GqQ1IVqGZEKnRCAtBbyKWELDsMQvaBmRAGEPgIVADbQkYAKICOAHBgui43iKCYjSH2T5oVC3TNCobnXQSLSkUi4XEj+pV99igPkBgSIYeZS///U5t9/9a1r6///1XpzMvJt//9ApjGkt//1///67WQppGJ8dpYaxvUTAaYFgyYhlmbQpadpEsYtBYQhqaaqoZWBIrYYHAYWiMIQPAwMlzghURITUEAyAGIEBmwsVBANBEGAwokZkOSD4gbxikBSIWjkaOogjE0TAlg1BBAPQHQJgA8AK8OUMiHsj8F9wkDD1BZwb8GKyDDKBuBCos0Gz4DAMTwAMpAIVAYoYAgwBJSAcUEGDlhoQgUokCIUc0miJkaZHXMHK6ZuZueSRUyrIvt/uRQZUQ43dH//9Bfr//////7nVmbr//+mUDE+r//////qpmaysblcxc+1+gAACEAD0LABBBAxEWACAQBtAMgYVDwGm0OBiYigYKA4BJGBwLAxqWwM1lsGoBGYBCAQoBAMaiMDA4FIwSsdYzIGShUBhQLFo0ExHghxAwGgoBgACACAg1kuqorHwJAAN6BsIGFEzUtJusvDZSNAbMA3YLYAMBA2xYoUQaTqlFEV0QVRpkgGqgMZEADHQIA0UYgMcBxNBSL3c+q2AUHAMJgUG24gGGMCcNPOGv84/FmBkQTgHzidxpjKhisafTU/+tBkFu6jIcwiAoMUGMmIIDMEQImr/t9mdmW6br6mYdhDyJi5BchECfL5uVDM3HMHMr//1r/+r//Wv/yIDNkXJ8ZgXIRAuEwVBzxzyfJxA0NzBibGXImK3HGq0DCAGA7kIwMDnoDSqTABB4HIUgBjxPgsdQAFUAEawMbnUDCAcCQKAYAIGFxICIRgPAgKCYW8cwcwRAQ8LqxGIsoT+LjIqRQkhaxGpMl5Mtoi6IkVCTLA7zhTImRUkz5cIKI2NSPHWO41JUnRjwI+BYIfEXHHkDHIGKMCWJgUgBAQB2wJCAUGI3N0EX1Fc1MkF5JkEJxA3dL5EF6uZlFtNNNAmSLGyDdX/r/03QQQTTdv+tX/+e/dTJpuzN006f/9cxf/q//6BMH/+5qpk036CF9jdCgyDeAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACVqKUgdzYAKjMSmg7cwAZUYlNBXdgALDxGYCtzABelFEvaYeDZv8bssMUCFaASdzAwflCeQQEDAYRHQaXEEhgvQvaDBExwHFgEv86phQMZYDlmUTgKAGFghd5EYcBbamT9wFaTSfaWOqCAFFVUqgUDrqjT3O2oKoLAsa1jLKOvBD8uU3CRuKIQQxcYAQMZCynRIJkQujFILL1w+4Lqw/DUZa7KaWA3BclyYrE2vRqGn+f5/pdleo7vMbMtpYzWy7Vkf/+sarSUbTCCyMs6hqNSmM0tLS0tmrS5Za73////LuWWVJIqtWlpaWlpZTGX2idnHWWWWWPP/XfobGOOOOOONmzlR4ZVr+ssscf5//v//8ccccccq0qzQ5Khh3DLeP445Y75/6///Lv/21lllW7jjjjjvGrjl3v5ZWqaVOyw1fjjP9a4+5MFYXyBAEwYJTdO2MC66pUURqIkkOzjzswaM2y4pOTQzwj4kiKmwucOmIMTJARcpFSqPpIxQMUSZMVuQIni8XUC6iamheJ42R1szk86ZNDNFcZUugOQAPINVEg84gZGyC0klJKMkkkkDVFFFFFG7K3SSS9looopKMiaDo0i6iikkkkkk6v//pt1JJJJJIoP//V/9v///+uRpWS///+3///opF43NRQOAMAguAQoLA5n/ocGRpDmQYYmK7Tn16bGHgEmJQnGGI7GNYEGBIJBAZGFgiGBwgjwNl3hYuZs66Zhgw0kOHQJepVdSpx0twqDmMFwqEqYA0EqCgGX9S2VEJD0gT1Vyyr1wSR9Fpu67KtsiYpT13iak2ILgxcZA2LZCgDYAI+bVtnLEY8IrDAkMYi0HiwzFmUOvIoKZtGU0Xts0L8pTlABSRrPGx23TWruN3L862P6ss23r7m6WDRYBMsjx4cWPRT93LPWXzVH/75//vn//48+gL7PNvnd7/t7UBRe7////////8y4vf7//+/9W2W/+X//////5f/4///v+41oiKgyBsa5/P/6r8///9XH/1//9W1/81Luf+qbL+by13HWrVfPCwsM/QSOwmiWfhwEp0Qw/9MUEjBgAwooCKlJ5ikgMOCkBqk1BI6y8kCCEQFJh64y5bFYDVAarHGTZFzYmyGEEJkghMKQHMHYXEC+aCuBgAaA6BzQtDD1ysIXE7kTIYOYLkFADIE6OQK0E6MGoAZpAarEeH3AJKF7yIhaGK2DEg4CKE4b0CYJwzN3TQdboU//Z6dvzBxCYiab////6LdTUGppv////V////6B443//////1mbrTdzA9H0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAffkE+GVoAA7NIKUcpQAKBSKTQd2gADV8Sow7VAAQMBIEDFtEAwQNAP3K8DD44A/uhwOGEYDSyNAyL8gCwEBt2xgYmOAaGAcqgcGQAlABgYKgYnGYC4gBYUFkYYDExBqJAKphfgL3AbEgFxADEoChgPkAMGgoIMSSL5DDcScMLCHmI5g2hcYjAVITFyNFsE2jNEyJ+Pk6HmFjGQHQGRQQmgb2Dwi5yYDaQDzoDQ0PVDdqAwowDWhQAjgfEJ/HAbmRiam4uYvLcZI2KRExTT5PGaaK3rMqQNBBXQM0UUaw4s0OOpA3rDJE9/m6v+a/+klQOf2OemY+ttP2Sft2/2IOeq/9Babnv9ZAU/9T9aY+zW38fD//TZ0yZVXgAIBrADiI3wOGZBIaE2As4DNjQhhAMIwMOZBMUAIWAKKC0hZEGXAbMCIBCBCYYL3iAhBwMSDFIiOwGCIaqBtIBQ2LiOh648jnilxskyGWQ9UuE2ThKiYhisQAChILhBpCth3iEpoKQM3FJkMLob6AuCACAAatCGxDHClwF0wHtGi1CAo4CIAgFgYMsAUbD1A5QW4cBfM0kCYJmU0US6OeS5FCqZLUYGjNkeMmbuZJJJSND1DRbOnmIeme/7of1vV/otQL7+/9Rg/V0Ftzf19/9Rgaf+umo0J8/Zb/SPf/XRRKA7laPyN//1MPhJuuUQAiYkDSZBVecpncZHhoYUDGZUPebqH0YWBwYSAgPAoIAUMEAZVXMAQ5MRRkMNwaC00FgAGCGgFFAEAQbmAMnQCgoTAjPikgFEowxAYDNKAuaD0xQQ2RrjkCzAyQLPB/RujHCEwfMHHgMARMy4KmAaJBvoEQxbE4jDAMBhcAGQAxsI6IgAoFHOC/AGQSgYsiJtAeAAYqAbcqF6QRAQ/IN0G9BcMGPibxAYgBigkQIlzcc4ukKZS8nLVisksuF5JGpJy79E6UQ5ICA0lSKKSb///86nSvZBRtWyL/23SV/6m////sikM8Mq39vr3+v6l+rXQNWPLczLJLnzh8pIqqAzTVV9XcMLDPsQLUkRlG4/wghDgQmvwEiASUCBSKwEEiQUkBzBbgb1DaQuiDdEDDhgLBjUMBBbIQqKKMMxFeJ82KxFCDEuMyLID5iyK2HsgYoETqajMk8FkQeiMiM0HxC5isOSKRFKjoHWQULJQ9wLIgnlA4hwDAhgKhgMOEBsUHlCwIj0ipPCzhcJBCLEWJ4sl1BE2IpRRPF50UkVJJImt1ozJvSUUw5EJhB2F9FH///9jjfd1orKht//Rf/zr6v///2GuOI+37//6m//pNUklRZRdQGkVQIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIC4nLg9ujcNmxKbF3VW6d3iUuL2qNwzvEZondUbhlSSoyBUYA6B5iwhPBwBpgBgAGEMIqaKACZgogmBwAoiATAoU4kAoAgLwQSn6BBhAUsUSBFBGE0wVEDXUUxYAIhwVDwaBMWVmHQY0UveWUoWyFkMEsaL6pGqhVfByxmzza83oe/YUFUYC3INBIIUpQE0qY8bbG15AQ5QiHAoOAzCsDNxQMbyC14CX4DJDQcJAoXEdBQ8NQT8XibD5SLFAZ8WaYHSIkDJ03KyymcIikdJErMXDhqdWo6gyD60To5IhIDdAbS1f//9J+zvskgpykTJLmTo6/9zdJ/9bVrSS9v//VTKiLfq/VqW2putrV0q0mao+XTcxNBnhSQ0CGmp4dTUANqTLDmDB0nKgFiQWGAIBmBBuGygaiMEIyAgiCgRorEIGjpY8YdlSjTlvkrlIGhMk/X8has8vyDiLUFTMVYa9sqkTtOU/1v5+BqSGnAeqC29lTPm+XLByrm0irvQ+7KRrtPwzuQA0EDeIDBYMAwoiQMSCMBoei4AFB0BgUCF0oDoYdp4XCQEeSfGuVWMjYgo0WpKSNmlY1MTqzyT2lhH0pNh+IGFhSG0l5v///tlktKfrqUiUELf+pkXb7Ui4bbJf9//2SEhSRf9v/9X/t61tWipBNAvC0pm/rAFrSeohAWJEHzF6BmBwEokCeYGwpxmAB0mB2BkYHIGY0C6YDQHBgKgEPIaTUb66rCLBk4mjLBjwMLjwYyAUUt+OBC+JdZwkNzYLqFkLdX1fd9V4OQDSSGTNX4VvZ5ALQVa4GfcKAU0UUXsTPR4exnag8GNAh1NBv0gwMoABQ8BwuoAcEAbSAQfDyBswaWGKRB4/BcyLYNgYY2x9igB9FtE8am5okZFx0U0VnmJ9SlIU3Mjb1IkyIRBioQxFr///6/UvXzFlEiaLU/+pOfXf+rq////cfY7UH/R/2+tu6vuzIIKXOPUXkDMW4i4jMS1IACHfhxCWYaACc2AGHAIYAgaYAKMYkDCDQIMFQERyBoZBcABIBDBpTtmhCHcF2ESRCGQmuoSDRpAoaqrBrrKSS9YnADVZfK6stlTdnecemkjXofU6abDl16JXDzWEk3acG53JgMCQXW6z8GoIBZMEwQKjwRHQyOGYEoA3YILiCRFzYrkiQQkSkMyWpkYniTN0kmUX2mCDpnUHXslb3IaTQN1hU/////MW+q0wM6Dej1ukoxZbr+ovJaTV///9RdQV////7er+uy0jeTZQE76QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACGqKSovcq3DWETmCd3RuX64pKA9urcskxKZNzVG4AFUxdUwCQHDB8S5NAoLYwOgAzADA3MCcuwwMAqzBDAyBQh5gHgVAIPcaAMMAAAQw8ODn4ZMEhZI9A4EBELCJMECAQysSTCgaBQCLvhcEFx0sU7TJo3fxgiX0h99pQrsLA8HAiOPUydPdXxcdK6LLoMEgpyxgHqDKqoDJAli0aRsmFAA871FxgTFQGKiCBg9BgauGgGHAOBhYYgDD4Eg6A0BgsCBINB3RIBUg1aH+FzuLERF5UJ0fiWMkHPWUVT7E0mkpbVGaF+xRGPBQLiAJ1X///r6VtVSJSY6O8wMV/61oHTdkH0P1U637f/+tY+Bm0/6//X79TepNbos7JHXLJsPkkCwHSEeRZBpudUOAAA7buA0AzDxXDtoHxYEAABphStBr2CJgUHY8MTSwSH6y0KwAQnAFQYIv+8hgIQX0b5K0wQKKgOsIDQpnZfZqyHcoKZO7LQ2bS3rtK3LxYwki3Rp0MrJpHKxgyRxKJKbNJRucVxm6xR04fIgDMcAQDCoIBQAR8DEkwFGoLRADjIgCK3LJARlRT0RpDvNiiTQ9oHEiZLB80TMC8ZM5fQWx1lpXnGf5XJgQjFGMX////1/9NN0f1fXTR2/RVrT9///rkPK5p/V/9/9v97a1OZrL5OHi8s/XVTFyTAPAYMFw882IgFjA+ALTEMEclIzjwqTAaBjHgugaCaYGwToYBmYBwBJjkSbPLBwyPBwcCNLMOBWGjwcc+PJyhBEBhEKgJYDUBrMjSCRs6dEMQ24q2GopCkgYiqrZHkelhEWHQbmx1s6GQoFKVx0cBVBUNKBBaebRfD+sWCoKDUJgBGIDGK/AzkUQQkMAY9BcGEhACEJBY0KTICT4ZbHMEFyJFAXOUSomQ4urL5sXVH0kjiZFjI1RKy0LVrR6lEyOSF/x2kWdTf///pfUo1Y+bl0rpv/2ttf9fb///61ESIcVv/9Xt/b3db2dBSVFySL5XIoTw7ED2DGLusAAAAC3X0EIFMOeo+wNS5AWA5i0xHvQqYkBYVDya5hQCQSSAsVFHaUs0XAvdtVZIErpkAKMXfij+pmNUQVfrO2+VSxD0BNlfOVuy7kNySFPu9sxNPhKmsJcw6+c7AcFKzSLF+48uwCogLDQcNABjgWCgSQgWBCPg+EQeKOeFwjELJgZFUomtJIm0WY5UfrNk0zj1PzjP9ZiDQMYLf////b69NSKbfpUaSaKRoXUND2MElqdBLv///I0l/9/////vS6qKBkVi4fBb6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAc2ikqD3KNw0fFJcndUbqGOKSIPbq3LUcTlid1RuHGWqLAHGDUPOa2wFgGBZCAFzBnBGM50DIwZALTAdAgAwEZgOA/CQDwKAZMMBcbAqZAcAHAcJBQmEYwDzNQqLVNRL1osqRR9QfMjg9TrN4KlaRUBYAQFAKVUqVkoWmJUNbWO41IMg2skSk0pW1xqkUh6AG6Pwm9BgWAIKGgMGhA4okBIcDsoQMiZAEFhxoXsEICdJkSYWeQdiFKotpiigmWiBG6kWMzzpILQMkzdO6TTb8tihRCUnzzf///6261rUo0NDcvKV/93dv/rX////KJVQ////6vr1s1dSCjNMnCbHAQVMx94BAAAoZZ8VAREV/GdAzqNI6AUpTe0qDBwITAYCBYFTCMFk+rxh2h+TrAFms7VTLkyKIqVEXNb5KHU3STTUWCHgHXblmMulcIeIkAtFUpljhOHKGZK9dl2mxLBPIsNflzV4EYZDb6uS2aggAExgGAEAIAAcAoAAJAYLgKBA6gYIEiD4y6cL54ZGssE8aOgbkUNFJrNrLm72r3TUafsLSBhw43jb////qf+mio3Wv62dNqKJstFLfz6lKnmZv//+TAsf+3//f2/r31oqWXDEskQSMlfSyZEgHAdmFgFgcwgQIYGCYDQFhhCl9miCHEYNAD5g2AUF1TCfA3MAYCgwEwLjCsQ6TBIjUOBB4vHj9X5bYwoAMdnSIdDG4GB5gIcZeBLmBwQboTLQQvX9MyRcsODwEYwDLzBQs7yDEGqnUPwRJZggjSkXWBhmMCoAEAzO18oSZ+JBAorQX6DCoBQrAMkYGlBSBn8OgkFAMSiQMDgJEIbaK0HUOweRMRBo9EkDdYpEbJYc8QIQQuprcizpEVLxsT7GibUZuaWTudGVEKifRhpsq3//62etH600qh9iyUzHt91UCeXs30qrJV9v//ykPZW/v+9tH+km/Wt1KSUpbycKpkaCJBvxOEOQ6evplsAADaytILAeYO5AaGh2gOEQMGEKKmH4vFUJzEAE0yjAYJxkCRCBBCtPesRhfpOCUkAVaKdgOIhh6WIMNdbm/qjabMYUMe2UTW4Gamyh/H7hpWpdTXXNZbD8tLcLyYiqRsyo2p0Emgln7BFM5t4wMAGAcSBu4DlIgQHAoAUAKEBuAQFIKOeSgs4mRqEwWDMvnkCZMi09GgjWyDqRa69A1+pxKwvgRFl////6X6rInDA2U3/Tl1NT1/mOtH/1f/1F4T87fv//qf//3uiYrcqlkjyqYn0cgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH9opKG9yjcNYROVB3dG4ezikmT26Nw2BFZMHtUbgAAAgSJpyGAKAmYJRKhq+BEiwKgVAOMCorUwFw+goAoTBujwGRgVA4gYDYtIYTBRy0QjQWWyvMGBlST1EIBMjjIxcBUHEVRoOBwEL6yEyqC3gaG3GLwpr0GqphAjaIrNRqGMyWnOqaYppNoAgSy5p6gKRD4LjWOv1xXcRdlCEgAk8CaMAIKBm0YAzIC1gP1AGNAOADmhfEQmFYImIkKmWWGZMC8ovnCKGiJmpA1RRKyJ03M0ELJKTJ9fuTQuEBQAJ8K+3///7dWmhTMigZI9t2Z0zApGhq6kXdBa7ooWOouui31J/+mQAaCv7///qV9fe9F6BmX0SCjPl02WcejF3JXMWdMDcOOrxZEgCDAaMDELCKcMEQWMHghEAGmEweEwBGDoKAQRA7YYUFuRAjBC5SUSEYyDoA4GWSX7BwMzxHAmFaGIsko8I7TMETLRlc9cT9svlsCwS90tUKamNB7jpULJavFZZH2yacVwVUwMKPBQABh8gHUOgFdAMQRBs4HmAaJhgEZEckm3FHJckCKpmiKSi8ePmKBgfTNlpllRw2Wm+ql9RXGqJxJBFv///V7fQpJm5Kpu3/zNm//qf///83e/////V+pVVdjhvPHSYFeIgYPcisAADfFBAYAYEpg6INGi8FiYFABgCA+MFogky+gDDBDA8MGAAkGAPGAwGcVQGEgDDGkxWARERzIhwABhgoQYABF2ThBEmiZOSBilSRbLW8A1w19fEe1Ovzmn4YcBKFO7DTquQ3yDcAqwpupUF1llFwi36E1csLdtU7dWeJZunAIGJEAChQI6AGy4IxAgmAUKEFgahw4MMhEDJ8RkIBkSI+OgnmQOk8QEqGiFAnEFEyXFJGh7pTpk/0AyYDBESZMv/1f/bS/dTpHisi7/stdTlU8yP8xsgfW+tFuv//H0Jxb9av/frb0eu6q191mtiLFcZgni01zQNGNdXURACmDaXUaIIFoOA/VlMEIJkaSZMCkFYwDwGREA2GAzJpGByAWIUB4splSAsIBwstmTHwKBGAKKhgRwYbLdK1gAClIXCRPilPfmrUOQ+6D6LDclqlMdUqa9DTXHcTSXlDKEEsYYyR+FdNKb1n7LXJSBGeAzwsDePQOEZACagioASQAEgACgwskOBLozQjsXRERsGhcHpaRiYl4zM0Tc6bH6ZeTOrd+t/54qhyR86/////b+xpazf/1//rR////YkTB3//////rZ1KZSnJgxIaXUzZy5DJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACDSJyQvcq3TL8Sljd3RuHoYrKDXqABNIxKXOu0ABAFeJUACEYE5gULLGVYGaYAQFhgMgVmFQBmZ5wOYMBkCwEoGAYMFEI8wLgAAMBKLIQDo0wYEkHH+MCgMwODSzIVDhmsFpRmEgQEB2MmDgOu8QAAOZc4qi0GD4zImlqolAHXCoK/6sbpM3UORr1gIgamAGBZQotsqkxpQV5BgCtdiqhapxGBQFAMBgkbAoHgNHg4DCwBAwoRAy+HIAIA4ZHDEo5RTFJCEhASLDNokVKiJeKpPGqCJgiU0TiRRMCbQLrstSKkVa83DHgUAYpY6nS////Wlqqui50iBrV6vrQNVJtV6k07Iqvrb6//plEYaX9v9//V+qy0l1zFIuF82IcLnJI1OoRoAAAIMjL9K9MNz0KYSGgXTlAhNGxgUmD4OCQHjgCEARs2MBQRMNCDhR1K9qjc1eqifZxw4NY2NAMJRjR0ct5xYAfZ93apsZ+Lw+oOyaDmzum2qgMVfGWsOaI06hRJnVquG/L57TmjigMFPGG+AGEQMu9AaBDWAOGiHhY4JyC1BFzM+kXxzy2osMcSMTAqJuZut0mZVNBStVFb/jmChiuc////9uuzoJrSQW9WqqyamTOuyTP/TN6////luh//////f0kDNSR0yIgmDF/SAKQ4WA6MIQKQwjEXDF/E7MKcB8wFgHjBGEmMdAIt9ggB8tIPA4mAeAIYBwABgUAtGAAC2CgGwwSBYeDUGDeocsUwNMoAcVBQ4Cg4PlFfD+B4QGSIgGOkfSaZFjQWEMKgSAkYMcJyEExJiLizRui/EFgbPAMGQ4EQgRFxk+OaOw0FrGCak0BAIAkuA50BtxAIBYERwChULSS8M2HBCOx7FDkUIiTiiKHDBiwUDynNzEzWyRipI4ymdkFTdPUmZlkrgsPJJk7f//9rK/rUkkfRSZughpp0zyafV7dL62//+svkMQ/t//q/b+z3Wp3kykYlgkzx9wAAEBV1oZlQEDBgKAk5jEMKXrMGDQBo3gIDAMF5CA4yEQqACV5geCpgqGCXBNB4AtoGIBERZoLFw5YSkREcslydIcFrRIjqICaGJmWSImZ8jUDU1LRTFuKaQrIrUUkLmNRaBjBzBmBnh4GaFWQo1wDAIYUAEIgKdQBjQcMVoH7CjifSVJ88TzDlHDAorNUEVn01qui7GSZdLinWjrOHldTFItBgQiiCH/////61mrN9VkEEEjInnU9b9brRWYqd///+xdJ86//////7+y2ussGySwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAC1WQUwZWoACC0gowyjQAJSpBOh3agAJ6OyaDttAAAYBYGcQSBggggSXwWqA3QGARDMDLIlAEMQG0xoAk3gZ3BQFgmIBAHDYDCIiAsPAKAADDoPAOB4YkAsYw1eDbMUcDAYDAKBYC4sCIDAGAgBgOAkCxEQ980HwMwCwyDBIYQAiBw9wWMVIRiVhCgsAnQkAMBgATkEgCIThq0khG4s0iJfWVCwGMAMCAMDEYlGVLIguBhMFgYeaIGHRsYDtIMDbADIBCAkSwGg+LjTJ8QQFkDgAxCIA9ULfQsVFDCjDJDEKoyBcKpRJwQTGbJ8WQMwTg55PldEvEacMSKmxeGoo1Jpk2ZAmCaFADsN03QaaIAQCgcCIVFJE+OUTJBSAlIiwTCwOFiaySq9Any+bkULhoRcnzcnC4aF83JQsk6XWNnzlZMmRJldVA56jz1mDoINoU0ycoG6aZcQQL5fTNEGTLBECaMS6TJkTRXMSKlUN4LyS0WZFWWETE1KQxwNr9eg8jQ0z/rqmaTh0ITEgYmEGigcYqRoB2cDAlgtOAwAcNJGMEaizQGgI/DbJc6PEvEsRmNBqLEhJScXzM0UaOsyKKR0uOzKc3QaXVEkpKytE3EGM0BwIrYlQH4S3m4jZANFtTW49Ukklsz39DdOoz/6//T/5PdJf8rLf/////////q//+//+///Wh/7//+lABgKDBhWKxlWkxy2vJhsEoKBgFAQYs4+YREEYqhoYHhSYMBwYjgUYZgcPA6YBAEY5BCBILD6AsBigFzwrogIAkuAZTC4GBQcFiwsYzQ2xAwbOCxHDoQYARZAnISmFwItIZMGrgGgKLmDGw9DMh8IuAjwtdFdJMio3CTJopEyXRYSGBkYGx4U8ONIIFngBQIA0BgDREBl1TAsixC4DwAFjQxgZFEIBMSJjRBsEkFMiBEiR5WEAWdZFQsCTJFU30USZJ1RqyRWRRRqrZRkZDqFzDiD8gMAhYDHJJAyMDwGAKO1SSSKJMkNKpR/V3/WTIcit/qSMlGxEUf/6y8TqJPP9FElRbUf/v9bJLSf0iiCADgCAkNtJFST//9Fm/rPekj1okFoqWyTmAXDZq2gwFMiTTkGIODlXUgMRjBQdpatjGbannSToWGA8wvBJhUByjUJKC1g+BVQHWVE8dhBL7FwxKZ50nOl82RJ5uTEDA6LIOALgMOJ+F7GISJJEAtNiBMRg0CTGEHCBQAAcgn4b5MBaBLQvQFADlg2yQSJBGmpM3N2TOKehQ///9G49RhA4jb1er//+l//////9/////qOGSv//9N6AfAoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAh9kE0FdoAAvFIKY6zQACAeQT4ZWgADq0gpgylAAAcAAJBswtFUzRaE6JmQxcEAxICodA43ixYzYHsxXBkwfCMOEcxJBQwEAQrAIwIIILBiJ7JcPXCycUAFzYDgAAToDvCiAg3LBqEDEob4FyAGg4G+EA2MhiIZUUsL0QqLUIACSA20FqFdFjMw1WINEfkED4kBQRFROYXEFzjmDIIjpGVDG45IfIMAbgygGLDhpgC2gBj4ApCACFAHDDILKQbHxyAumKcLcM0SIpAcBGFErpGxfGsJUbpF4uuUTc8tImEzJSbHXXQVemQFj5QImBlm4AxE+T6loIIrMi0yr//84gV1o/rWs19f/Us8tv6zEkf//1st39c3C1Ie8SaL/9v1f+ze1laiaQZboFtQ5Y54AAAAuEojAiGBZCXFKVQDQMLPLCpRJ0s+T1Zkoe0YUMPszFnCGi3jGjHBqYYxEqF+LUOSQYYgyZiQUkiqkgVCLkMI8gJLl0hR5Kw7R3E6UxwDni5BYxoDvJ0iREiGj6IqRQXOYjCC0AIAgBBUDSkwboBfsO8GIQ6IXKMqQ4pkwRcuE2YG5ueexutJkVIuzqZOyaH/+iT4yhOGDfQTdv////1If/+t2/1LN/////0Emf//////1alqTQMykTgXUgfsLIBwCA+uRwBAyB4puAYvJwHLxsBk2igZ3CAJYkDRAWAxEAQKkYEgaCEagYaAIQEMEXsLQAMOIDrhR6GdAYlCGFBMgJBCPBtkCJENsKBQBQJLEDFHAwAAnjwpUAomKUHPH0LhFxjXCycMFB8Iug5wcqHSjsFDCCwcULnG2G7IOEAQDAlgSJgmDGoGpg1FAYEGAaQGbFtGCGBgGl4GHGizg+YUgSpMk24X2HNE6l0sEbGTDfRGpbRMCo6aBxBSa2UkdPoqXMETRJHaw1BG1Jn+Deg7qN/hkIuppr/Of/2X//SU//7f8jS3/+kykTP/lke//S1LRNf+dK3/9R1RXEIgNG5C2oAMIPIB1noAIIDWhQLAAN2IAixAGBAhAgY8OBjwAAI4MQBYIA4AJwBvCDaQpcgZCCBSLBCYBtqAcBC9AguOIehwGJAxkyFKgm4bJJE0TApcX4ucLOCyBCYTsMkGNg9IpkYYj2REmBdCUAtYAyyoA4MGKiAjMBjoGxZAbomThmOaNMIZ4IhAYhEGDnkkQBkQMEBUK2FLFEoGBHDaTPpHEzRlOm7KYzNTi2WpIvroqQ6ZYFtrNPwQgSdWozV8IgRtKm36//9L/+idb/V3/WuUkP/uvcm/1ZYIT/9aKjIp/r1EJ//XkMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHzZBMh3aAANNSCeDuUAAeEkEwT26tw1BIJoXNUbhhoVBIwlEgy5bwz/o0yKGkxgF0xEIM4UX0z8HcwWA8FDQYOggYuh2LBSkuVBPMUxSBZ4CwASmOIL3igQviBgsIGDFBaODeIPKAwCFRHLAWHga5MGJh9iUiKkBIuRcM4BvMMiG3lAXxmSJ4h40Rvl0gIByUTwH4h0wzYgqQgjIcZDRsiCwZAGcJ4LtAwBMDHkwWvAchyBijwOAh8QjcFCYdEIFMRiCPRQI/IpGo6jE1MTEnydQpppFV1E6fSdJa3d0FI+6RkXRqBhhwmpsk6kTFAvpt//+pzVX/U///V/6kv//+tNL66ZJH1/+v/S//Qu2ySlVmy3c4TQsbxF3gCEigtBNjEg0lVETCEfMTCYw6DAKCUjA4Ll/lgQSIjEAFFbDJiCw1xPIuUigW0BSePQ0g+cMuiGlwgI2z5PF8niLENJ0kB0DPFEjCaNhzyKkWIiZDOkVGdNA+o6zpgUS2QEbAzUdY5or4WKjDAwjcGywbsDxhjYpBsI6xBIYRFjo+TUwLZyS6bGRSHKJo2Rakfy8ilZFX/RMS6aj5DZQLEQsqHEtFFl0UTTb//1oFZH+utv/+tr/5ir///b+kshooEiLf////b/1oaS0lHCOFzAAAb5JXmAgAQYNoepo2i3GEWASYCQBpgIAwGI2Z8YKIAoVAIAQApMCiYAwGw0AmGAYJGTvhQSAgUGv0le3ISAGqGGEZjZOFQNCoHBaDymLDUAhgJm+z8wFP2YjGMxGDBwCq5xYm+bQIfVK0KRQAwZ7VLEwkyWzsEZy2Jn0+zcZkUIKIBgYEhxQCQ0BjoehSGgY6CI1gAgqPgL/CXhj5FRWCAi2ETHCRAhwtSidl5A+YH5ukYmimWauUEnTW9dFvqLo+hPwmCSnVZzElUXbf////qf1/71VPq+x7//+u7K/JsgSf/1f///u1V16TpT5ES4ALKk9RCDjAjTOIUgwwGWXg0PGkvADBmYrAxcREcxWCh4FodBVYccmou6TupfJ0goEw2DzJF1YE+5Ay1lqrUjkJEtdV/4nSxmvCoHiMRh935AxJVSOw5QvXTRlpDYWtsol87TSxKqRD+LcQ8OhAxYEAQYDj4HDEAtBJgICYgqFo4gkGryADfJIh5uRMiZVIYRZmLhdKZdUk6jhrWgpFFmSXVr9J2I0uAJABwR1Bl2ouer///Mkv/W3//W3/oo///6l/5DSstv////t6m6qnXQYwURYaYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB9iQS5Pbq3TXEgmTd3RuIDJBKA7urcMoSCZJ3NG6AAAi5QAAFMBUCYwbhfTQ+IwMIwDEwEwCBIAcxFS/zAQCAMAQBElAecgwUgGVFQSdjJ8dwdkAAHCzKUFA4nDARAUYMgGSgQkJNDfoaASAEeVc4qeXGwPRSwzDsqcJDJR1rsEtZomfr+TDadTPeAgFHxEFIycRIcl/U1WKS+FBq8SUOSCycBIZAxGJwCCUBo4HhQFAYQDgGGwOLsBQRjMA2EEnE6iAxYFWHwnCKkDHafWxXI0rMiiXXuo1PqMdn1Mv7VEyCQCPmiKlsgbsR59B3//+v/3V9n/tUyjXVfSY6r//+pNldVZDSCv/9/vr/+trvUtl1TyZcSTLwuEAAAAWVsMBIEmFhRHMSSmGgFJFlyDT1BTCkHgUHLOEjTDIAi3pEAgIbAZMAgFbrrkoWhAJALCC+wsCCwCoOLBtwoAYWSgyIckiCz3kv2JNxdStrTGtMphUmeGs5WNDAkVfRHZ/WNMreKGoXCX6FCiDiiGRAbwAOGAFFgMoIAOqgLEAb2GOGfL5Oi4SKjOjNlQ4oixWIugqbDpNTM3poreboKSQdTM9d32Wo4OaM2RQ3Pd3RTU6v//1f+62+3/6tfXWf////+oyJ9BH/////31autSRskTxFUdRAChgaK5jVRR/d7ZkMNQFEUqCIduSwZsEyYZg4YGhWYUg8ZQg89rNDG4o91lHA0mZocQzMQDRkLHQoVqF3g0JDAEDBpZ8tupij6ZErtwRQc7rhU6uHoMBAAAAskZAm8jmmunoo89bFWoioO85QKDwKqgx9IpUiizfR9YgciNoTYH6ASJgGAAeASlAMHj4CA8AySBgCAUBgwDAwPgHB4QVELEkQIQYQ8bRESAi5zUeKieJsfbEWM0VMs4mTR0uGBuig6mVo0HTlcWaGgDvIaitE1oE8ssIVf//TX//6v//+9D//+sySdr9E0IcVl///pf9lalVstSn2PmQ/F4xD8A24AADZypsAgFMORcO3TfMUwADAEBoEmoQPmGgOjQAAYKUnDA8F0ShkwEWmU5DikGhuIoAvWfa6BYi9rNnzhpPhWRnbcJ+3CKepDNV3XubRjzQ30jEPQ08M7MWaRljkrXkLqOFefiRLWozwog1wyMJzCg4JCwMA2BIGBgiIWTCkhCcMSCUxmC4PQ9IjZPG5ZWpSRfNmRZCdVWkndGr/2pIJBESdUj1LMUkb/////3/+tevLWt9bLert//1f6xtf/////r66tTprWkajoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgQkEoD3KNwxxIJg3N0biFGQSQPbq3DSUglhe1Nui1oOAaMDIAswyQyjdzDHMO0A4wIANwoCkZYoxBhrgYGAmAcIwCBkBsWFIYmUE8xOMzjIyMOAIuY+6dQhAoUAl8xeJAElRUFAIIDQNQ7CQAEgCYDAJj0dMzZKtRvvsuq/5gUHNdUNctXU2oexNkqlbEniBADQrYcVQOpmrpE9QOKrEYrAwzAWUiE4ApoGwIW0DuNQOaTAwUEAVMBiiwWOBYILYBgododUcItAo4rU0IkIVIOaLRI9AnjMzMUEy6kkgZmCCzJBnUtNJt1LlQgQb8JmqmtBjAmyVJ80Un/9e///////////rQZ2/I4jVv/79//rqbas+61pOmnZM2QMhS4ugAAABWlJ2lQNDs9My9QRhl9iwEjkOQEikXnHhOXFMDg6NLLMABw0JWqx2H4i1ZqD9LbEBa0xRVIRdid7sJvLRp4DsVvoYjF3eT5uwdG2fyR81durEXjpHYWu3d7Yu38ZcBwYOfQiTkyKFBqBAxIEDDjQGNwGEJAPEBYWGFAbkEAJcXOZEDJ8wIabugTSczNiifZTUmrdOtm9SX11LHUFgRMuuvNXTf//+3/b//V5gn9Wdf////7pijt//////2d0K1KWdMC4OgAgGAwCsLg8GA8aOZCSXRgYBCmAUBoYGoV5kbIYmG0A6YDgCat4JA2MHsHEAgCJmGF4ZoUkLBgYmqBGCAjdp0WBTG4M2YPYkRGDlDRKYoBgUFTENoMVbZEu6K06t7krAiosucuaxlsKfBetlEgTiVhSMmQYLKcOAn43iTzSG9YG1N3AvUAMAByw9AAwdBe0DChwA2OggNOhkDAoHDkQgDYIgEAwJQy4oYwQwZUMSB6pECEDJiFI5RGFwQGLBTTQOJFZ1kVOLNzUxZW7KZrUESOEpichZSDroIrJsmS4gn//t0n//9f///qV///popv2zMdBo239f2rU/vqWzJ1paDKamkcL5KEGFfDEIAtsnADgIzBmA8NCIMcOEQEgMyoAuAB5RIAQv8MACA0AMMBBEAB4VEmBgGcnhwlXzgwQIhDClTFwSqOaA740FTPmn5UfLhYpaTsxNdlj0rySofFr7cWdwJFmluLF5eggfZoyqjdWfRWjkdZ92ri4A9YSgGKQbAwtDAH6Bm4B6MAx8BoYcQCZQcMOQGeGfNSEJEchE6mUE3NWMDrJJOk1bGjzNdft6DqYmgBUETNe61oIF52///W3////1P/rf///U1/rJgoVf/////7WR0ky86yTWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIE5BKG9yjcNUSCWF3dG6gakEmT2qtw0/IJQHdUbgAAAgZvwcAIYEIDJhNBgGvkReYXQFxgTgFmAkCkYKZ6hgggYmAiA0W1HAAzAMByHQBBwEAYKHNAPKkHWEFgOI1X0qwofzEYmFAOHA1CwWDjKW8dczCAmxrrgKfiDo9WHKoUZos9NZ61YqqvnDV9gvdqJbuVpRM+UuToX05auW7vCGEBXRcAXXBoGAyp4AWQBnRIGaQBSYAULC9gfkFrIjgLjkBFeNBCxJlg1LJ1E8Xll0ky8aHTRc8otomJ8wN1Op3qbmbyyOwAogOSVXqpoMotGv//+3/PII2yx1K0jWtzhOOs6jUtZcJ91X///f+bCy02/9X///1MqlUzIOcmBNkQE4ACoCXOAAPmDqhHRLXmFoQGCAJmA4OGbChIIwIBygxACAYPxawKgQBCg1GW+4UdeZ+GDIdFBiy4YENMEgBc48CQGl4PBsARyDbdeauQ4y5djVLDBofam19+pA81RXaukWlAGVuIms/MNwe7MtFfIKK0BvIBhC4JgwNe1APsgbQeCwEKHRGQDQUdwrcuDlEQGeJAixMEWY6g9ImUHMUEWNElLN0mUp0tf+ouj7FpHs2uuqZGRXo///r//////9av//9JTfzc8gv////6urZVXsio6ThdEfAAAZgAABmAOAcYDgHJg8jSGsiUGYWoJgkBiYEwDpjblymBSC0YHgC5gOgFmAoBEYRAOKGbNjLeARtBo8DAoSQkAuIBIdGYyBc2r+NmCCBwFQMMJQY3IPqOQnIuWSyugnhwCKkFeqmeB93bYY6aqzkslXiAAC7VV34AgVZa1H1ZG/ZehroZCGwKWCAABigDAAsAwCRANAhcDGIZAWAgIgoF1JFQLAEPdDYiDj4FODmE+Qc6QUj0zU4UByiaRZ1HC+8ulVMzPmjO62v6SSzAhwBQmLRlTsm5eMDVa///1/+37/ffrNdfrQf///U7e9ZmITX/9P+q/+jUq1WpBVSzZzIpFQXK9BecwGCQxRTM9ZhoxTC0YAYkAk1rOULhcAgLL4FUHTCwEDAIHA4+Z9uc+UPPCyLjFlyZGQAn0JTSjwKEDwVwpQm2slNFQNpeolZtx6F5sAgZkkjjT7JjrANRa3LFhGlsvV6DQNZSC+7EYnXRUAEBQuHGWDV4WLgZMaBjhYGwFgYsMBiBYWjCdBDguGC0MeDM8MyRMnCKlsjydRPnz5ZTMEjjpqamtNSnf9X6RRL4lAov3OXN7f////////////1V7/SJhNb//////rdV7LQRQMER7MQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB4+QShu7o3DIcglyd1RuntZBKlXqABM1yCXOuSAAAAAAFUOHQLAgfGJLznWuNGGohmBwVGGYBG+xHGMA+pDEwMAkGDIkDjBMGVLQAMFOuBAVhjqtsYEGJnLDAU4DkYyMDWIqQvChJcpQc0kVn3wbk/movQNbGAAv+1F0Y+tdpT+s5XbGoUr5IwwIBRzbtImzNziUHtTeoXQ8iE4SCB/gBRoBs0DalAREg1UBbABYKHzBaULLDzkuT5AR9lMvlQuIImx0rGSkDA4uXq6SzJJFFboKs76LKPkaFoBbKzdM2RRKiVv/29X/sv5ivu6vWddTrqqWitSkVrf/+yD1fRMR/v//+3/+ptStO81WbmZFRZQAAGzpTUwBAAw4HM7YJAxMAVj4VCEziLMxwA9hUAA4CjAUFQqABgA4ydPMSWEUxlyjblQIyBuCQKVDjsbX6tJ7nMDAE677o46vzj/vEyWOvTOu07b63oEmX+gVn8FMAl7lPS/r/QxLWcinkASIuAcHFcAaPgc4YAgUDgQYnDkQt4DEA0SIFEvmxQG8fTKKRguo1Nk0z9FBVqCCk6v/0CCkwJKjq1JnUq3////9d/V/+z6F9Kgn7f/63/zdA9/////+2/0aSCimRQAADSGMA4BAwGAVjCiBzNLgJMwkAGi8ZgMgrmNGJcYS4Aq+zAKAYEQBZgaALAgA0wFQEzAPBVMGEDQBYAF9BBpCA2OBaUOoIGAKLyyCAESYygjUbQbOBoDRDxBciI4SDm5gUQugH4iaCVCUBcYuhzx1EY4gOISh7YNth9jrE+j4HeNMzD5yDjSIEQ0RqA8MHQgaYkBmCoGLTh3gAgICgsRkIxDmCxkAJISo1UVVl8iiCnLxsplJKZbrPLuy6vV7ppoCOAviVytsupA6myP////zzfMHr3rbUam71vZaCJ173X//3/qMB1Gn/////793dlstJEmScKoAAAA6Y6LxggMGWokZIyZlMQmFwCYPApoOWCQRVmdp4DB4UCA4xwEDQyMJxCoNj5WEJA4QN0RqAkINyA7ZFBQY5wqAs0hRxkUTG4cNUS+TJFSOEJzYiLl9g+MfJDx8CnCtxc5KEGGoOeMYM8aDHCwD+ThJikgsdApwDEAA0CBgsUBSBgiyBZg2hxolMppkmXDpYTZyidQdlPZdSkluhtr/Vk0Xwv0KowbrW6Sbq////+///7SW1NpUEU0f///+mPsxf//////2oaa1pJHUwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAu9kFGeVqAAchIKUMo0ACfKQUQZWoACm0gmgytAAAAAABAABwAyEBmsvgYJDoGFjgBhoeganIISHIMCgGDgeF/wMeh8Dt4gFfDIIGGBUBg4CAOA4JEERqSgAgGAwkCgMXkYEiSMmYGwOAIGDgUBg4BAEi8AYvAOCos80Wah6gAwMEaEPAKNoCg8BtqAgDMaMdTBsbFYDpCkWggBQGGQIBQAgEggAgFpmqJKjTTHGKUNEwQgUIQ0HsCFROI4QEhkDADUIkgpWwGMAgBiAOAYWBgWYGTGMFKAY5dYCAEEARAwgAwHggBoFB0ybPbog2fDVY7xZZBzcQQHAaCAwjIG5QypQFakBFwigTJ/+XCKE4RUPjHemTZPiyBzCHFYTeAoURQwZeHJFwkRMSA+9+z80UXDQZsg5umXzccwihogYCzRyhmiMK5NCziAkBKqJMjKk0QL/2//+aDnk+6zM3IITjIGBoM2bGjLTLhFDQeBlyuQci5PmyRNDSIqQU8iTJASaIsbFALbCGFEumqCAnUAoKjPCUnNSBDrA2qAdoG8IhkIExAC4kdQQjQ+o+g0EbArw4hGayqHE5sfHqVIuiXjdMwKKjRFqbpT59JNJKfPoNWgtFJFSSCChPmblo8X7CPWpm5uZpvw6JqSW3/of+j+s9/1t/15//////////+v//6v//////1/0vgYDCwHVhCGOAdpTArIHPF2BghggFwsMJgeHEAGDigB3ENAYSE4AwaAwgEgMfjYDFoBAXEwGEwOAkHAMBIGwaGJQspAkGARIwG8IGAQ+BhEMkSAEDIGKQIRoNqAoCBXhCMPZBQHh74hEYANA8i4swEIADGwYjDEAygN4hbx0C5zwm0iJSK5FhUx8k6ACBADASA4mESKQ5QWlh/gMCgEei4QqYugaBcDhIaAXAwhOJ9HQPtMDPYUGKLoQiGaHSO4cZAQxKTJNENJYlg8CRdICYGUwHUI1NUh8nEE5KEVQqddaJ0BwHAOTwi2Z9zgRCgDCdFKpUX7A3TAKJ5EkavqHUNrkv509xjzLOlbzpa46S1rf1ns6Un++wBoPLqneo2EwK04kd47UftmwaSJnqacGy9Rt1FtX+cAqAjL6jzoqdQEAGBrkCi7A2UOR+A1mSAMGA4GD4iQFjyIqCI4iExIC5wudEABSIzA6SIkWLBWJcPGXhjBWjCzhSqiLkmYmBkSBoYyopMjS6XDNMnWWhMkmJxE8qQEhwZOy1lQ6RRabTMXwFopDTA2WqCIKyzFFTE4RArIMp3LdSXWs/q9d/6iHBvJ//H8N6S/yYFsb/rbt/0Pb79T//1/+Oj+fb+//ls9+/+3/lH/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJDpBPBlqAALlSCmDKUAAhpiU2HdoACz/EKUu1QAEGgAAM+pXhIwM4hjxuAZrTQAYDCFAaEwMAYGDDAZlwWAYAjiADIiAwHAjAwAAuBABwDAKDgVuBgEBIBbALlA6AANUAMqRQgdQG5ongMnAZJhZwMGAYkoDY+AQQCwQjkcAIQABxgZgToAsCB1AUqSQWNE2TIZcIuJ1LQzo2xHgf4PdDUh2lw8VCDihhCYEBcZYmBzSGkGCIEMQi2jNDuIeAUGB0UAUGTYjEmCuO0A4oBYEMMnybIuwI4AKAwJBw5YkiXSF4NNbGyL5QHEhcxTZiHkkUTY0SSd1JhYYBohhNqWk2tATmBhQJguv40AtAN/9yYKudV89x9Prb1N0j+tvU2sw/5iFk4xPqKrVP5d/6YlE3+YGCX8+r/ULUpvJgnDzJPWAcVOgSPC8A1QQfYeAMDh2wMYUAyZYnh2A2cC0wLCgwmaGYWjigwAQAagfQTKwXzD5wBgQBwUNUJpvHoTuRNMOCEbCfhnNNi4SZYHgojNjsD1hCEUEIkhVNCHjwHzigxzxPjBYcT5qLmG8BlAguMnTI8y3FzBegMKDwRQghUA4bMLXgsNEFRzmR/5fTT6GaomBqZFU1ZH/+s1b/IeI3R////////////v///W/1ILf//50+ryBl08kvRtAgGmEgWmFARmx1XmKIQg4QDD0BDEWCDYQxDA8MDCMBX8BgAlA8BAMmA4CGAwagbTSFpADAEjA/gNg0LjBpYjEDeIQLCRBEG8hLgGBhOwdMIAgZMqFsRWohOLOMCADtFwhkgXDjMCCKwy8K1H0F1AcgI1HCOkPaAkEDpguBC5oUmJ3C3QgiGrgyyGNhBwuILHBXRwAAEgBhwFSgBRcDMFwMUCA0xYVZBhcIhMJRD2g2caYtArJqOUQpVcdpsdH2ThVMnRTQY66j5FisbFxSaSqbJpIPXSSNiHhhACAEhpUNlOr////Uau//Wv//1f/oq/////QMhqDhOqZauhrepqB44cIqVTItcBBZASoAAB5WmZJ9nngl50yFbAwMcwkKhUdlloZIaiEIXtJQAEQAzIoxID8I3DCBXGMEEAGDYdANUQgFCikhwizykVieIIbmBeJ8ixPEgMuMcaD0QAiY0CIDvJAlCRFlCDRmhwi4SLDhIMMyQYY0rEqQEcoQnD2hSgBIkDCzAMQGABBgkNDkBSIpIMii4iCkCIaUSBEVNjUvEybIqUbnz7UE1pIplwqpovQX6r/mp0T2L4yNm////+t2b/qQ//+v/6l/////rRJskkP//dAxI8nz4GzDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAAB+6MTAPbo3DYkQnQc1RuYMo1LC9qrcsZxKbFzVG6fVjRVADEIOhiQo8GBMB4RADAYCAwNxkB55QHBKjQA4OBhMBUEQwPAJTExRO0xY5E7t2kPkx4g5QQHP0KDpspeocrtQUsmYCFKmSLSINQAH/awk45dR5nXWmimnSrYli6LEWHSRW5ljd3KaUnsYGDpiF+0LmhJerIRWCzwopIC4hChSJwOsBnRQGNXAas6Bn5IHffhUQDuoGKKhtgFBxbAJDDGCeRCUcJICARyWiuNgrJmxXFlTjmZTOFswPjMEXRLKKSCq7Uk9TVouH8ANFDSI42//7f/1H3/9av//t/863/6///vHUWC87IrV3f84kRYuDLi5h8nTyZ9R9klq8csVDTvy8MlgRQ4VAxiU+nQgyYcAo6FgUHxEEB4MmCGpKFqAeQWgx5Yz7T0eirrGAFj1Jy2iu8m6EAakCKxQ+umKx6mnGvRqSy13YRCpmmZtakMbh18ILWK1BnLJndfV9YwXy0JSFaizR1D0J9FWHaAzRED9bQN0fFkhdWASEBYuF7QuFIqUzccI+yYFnHUzIc9FJSJFScMn500U6ikQZE8dZbf9TqJsZEM5A1xMRqTJ7////50kP/qX//82/+ZFb////9bBxJEGS/6vqUZieRcRbAgmbfTX7AFrS0RUAQQA3mK+tqYIgGYKAKMBoCYwVw1TPODrAQIoVANMCIC0wOwSgMHWPHBogcbQcnUXiAIGaTiQeLcdMYMM0sBWkCDVDDBhSYeNBXtKBZ0TbvTzowRTxV8lD4AAJBhqAR2p5hS/WnorK0PLcKoVq6eS7acOBIBFyM3FJieyqIACAwZOF7AaA4DBoVAwCHgcNQMJKYA0bABFIBwhBwME3B74BoADCIskR+Gwi9FGFRFwF4eRUiVNDqjxfKRiyZwjisdLxKEFNCbOIorTZaaT193KBXEJgEAU2Nv//b/+pH/9H////6//6//b9kSDjMoLX0O9eqYnzRIUYnpeRRWeSnVtBMMAb8444IBh8sTA4cKjFAEYPi5oophcFCwHBQSLAUS5TMQCgEecwemUoTHUnlLE+i/Lhocy8igqX7IWQrAsAibyR+HoEnbNWc5AT9Rt55+GnBgBWyJQ3W08/Z9J6QtygmNaTPhyJUJ8bUWoRoPQAzYDihgMsOLRDwcdGiF9BYRCcXMRMrlE8T5JnimTxvlhEj0U1pIHTdpqVnstber+syIMLwLmjh5/////1v/6jb//1//qf////+kQ0kVd/7V9zMjSbecU4/1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB12JTBu7o3LRMSmSd1RuoPYtKA9urcsyxKZN3VG5AAAAHdllSCEwDCw4Q+QwvBRYEkCQGvOZjDCKgepwFgNRHMZQBX+IQQLIB5gUBAlxl7iIDFA5ZaQwcFmXFJgQERASsSG88j/DLDTMgybftiMUgqVSuItuOAKNEZrtZkzW2+U0ZzQydBVYigpfR/X1TUljqiDhB54cIcgO0uhq0B4kCrQT6B7V4GQLA1AgYBCGKgEixFwt2DbIc0WAa5JjHDXHAsqjNF+syNSYMUlomq02WShIGpdPMivUqr+5fFCBdSXjDV////7uke/zjf/+o2/b/////9Z0mSXWj6/6+iTw+CKFQwKoTI1+V+AAAd6LskMBwFOAltMTwBLwAYDjBZazP8GTCEIiQBFLB0FAMFaEQQPEDE9aMODOTMKpFoUObXVdF2AuPaoX1dxAi8TQEQxItOWmcttLbdqOrybCwhkr6Mhnp197rw3NQ5IYRBl54U0oZdIY0xEfk6Xw05ENGBMoCgcLegQoQMORC3IFlIXUiWkVIINtMfhXDo4SWNSkRc6S7HTx0mDZj6KaSDKLjss1U6t6lu/qLpmQYMaDRMv////88t////+3//////+o3QW//6tzKeN2N2MNrXcmKAQAjAsBhNQNL0wtgDxoEYwGADwIXaZeoYZgigVBADhgUgBhUCkwLQUgqWmKGIXdzho8Aig0WVEJBgYQTAYYLgoVOlGjDRMEhw6AF2g4ADhGWphGojMHNIcyhh7jQXvQSlzBIDaWtIsAC7011AGHxBW5sKUwYAFx3Decvq2ZgKohcgs4fhGIoIQ4T6GohIIgiD4GMSKBo4TgZYAAGMCeAUIgxSBYiA3LD7jAGNGPD0w6MiYxCXG4RwsBFT8uk6fIFJo+x9RmeIimbLLR81ZKplp+tTJmYtAWMDJF/f/+3/+3/////////b//1yUIiasu+ur3UtyuaCMBcKJMkwWCuXjl4ch7AAAAA+5QyswECA2DmAxAAxmw0AZhUZpteJocMQoASBruDQ5ruUQQAHlOMngFvWVt+wiVvE2UOrA4UsxoKqrB3HQhbWWZwVG6kpkz+vC2JckacuapIejUcZvA96o1t/mcKvflvn/oBzS6KImUxcA+RCINSAYEjoAwoADfAQ6YHLQu4QCGXC3gYg9j4IERAyHemaGbpOsxNjRNJj0wd1JG6mNkK1//pHTIEwqSD/////rRdv9av//v///////UiNctP/6voopOZkieTdZ9HQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAf4i0oD3KNwyxEpg3dUbiBmLSYPbq3LUUPlzd1RuHdZsUAABAJRq+FzGFaAGGAeGCOA6YTQuZn/gEmAaCEiWYBYCRgMAVhgpJICSgXmECucdDJiMDwy+DKxUAigEGgMFhQZqIQQDC7wEA1MEBxl5aJGgykFppXMlYlayZM74wBgMCkrVAGSNLdJjbU2RLpXFGRkAJ7tLBADgZWdaKObtKDVBGjqFxg3hIuHwAZMEEAQDjeQOiHC4MDhDwDpINCYfwBgeH3D3T48i4xqjeGkKssj8JIbIIlw6MqYmSzE1NSpI4ihEDIumJ00RdqKkWbfSIIRYWYSCTa//q//6P//////9v/7f/+tjc+ghq6/2ombjpEaDYIMVGUZvCiHlwAAAB5U9KdgXBs0Kx0QAugIBoLgIHTa8ZgUE5gECCGIIAcWBZghe4wbI6hBpyfT8u2mKna5+CDZiwDQYaRYXOtp22HpN8dOl1amq0Gvo761HieaGWQw8967WrzL4UzWFMXXdqUu3EosM4Q0ZkdJw6SpVDAgCgcEwABjQJBwDgwIQYcwMjhvQrQ8LYsvDQMyUTc6XSo6jFymcZJl7MkaMtkP2/rNDwf8GoIe0/////6lV/7r//////////1DOkU///UmZkVMDiY02fVrgZoAcAOYDwDxsZgOGFoA4UANmAKAeYWQzhoEgHDwDZQAmmQFwKjCMANMEBBw3MWbDyX4wEJdaAB0NAxeu5DIAiYgQTMgYEEK5zBQQQBQYDAQABwMa2Xu0oU2F5rLd6SbYmMDLIE11OZIQgC55Q1Rzm1hhcBIEBgO7qA0v3HY4hqQMNXhq4VQjkCwIIMFzYNzwGBiDUMgauKYGVEGFpwAwmAwWAAJBYDAAHIkGTiPxcYpAZIQGDGBNGI+h2lAtyLkCE7FwrrMGQNpeKRKl1Zsgi/Qo/ZMoEAEFxzSQQ1////+///////9v/7f//Wiapu/b21vQKpoXCIj7TSMjUyTEhgx+IAAAA8MukoaIRGMSNcKgGI+PSYIG4ZNioYDAy5oGAsiBEwUAQRDwuHBIk+TlJ6TQzWZmjk1FQQwQUWEzit7aonLMkbyowSp7FP17NnUnd9rrE3fpl9XoAm4rfgf1Gmjq7XezCAHCY5oiJQIOLQOeH7ENcIBIOJALKwMrPAXHAYwGBhwIeISiDaAbyIVKY5hWNy8PoukXOmDoIGxmfM1ukk6KaZNzRS2Qv7/oGR4P6A0FKxs3////7Pf/ZD//1N/+/////9IpjIsv//onESqM2HwwDbdYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHy4tKG9yjctORWWN3VG5eZiUob2qNy1tEpUndTbsAAAAeWMTLSGBGDWaTBbphKgUmAgAAYBoEJgIEkGKaHcSgOmAaAUp4sAjGCuBOWiMCAYYKxxYKIosflIqATAwCSYj61DM5WYOXeL/l1w4CI5wtBwyUKH2apGYnEJW2rorFEQURsdGncpiMGLWaApcwyXowjoCT7SrQUa+NABx2hDIkDEpjOBk5FhjwuZEFAMoPAOgAZO2AafA0IsAJ0AQNEKgEABHQZBSKBbJ4fZAUCSUVSucXJsjirUYordRiU0jQvIrZW2t/oFAwGuBjARsbt////+gkpN9/SX//7t/+3/9v//okaJOZdl2/bnDIjCIEoXVOo8x/Uz9gAAADw04KtwWA017zkxKBMt0BALBCZGSAZDoGiAAkyiIBTDgDQYUhINin7KmDGr8zgpRpQGcL5A0SDAjFU7VgoeRJdgHA0r37nnSjd29Kpp9k5msu0wF+V4QWuuH4pJKdazTE7VlNZWNG2G0Qxg+xlRwimEwR4yQUEhAGAXjgcYgCS0DFDQ5UUsGjBk5Ph8RIDrKAtZFCkXVs5XWgtFj7spNTJSyWi6i7pVer+pEkBukKe/////u1D/t//////////uYMmr//WpE8Rcey0eMUUD5+tgAAADzbKAuAGYEgJxnHocGDEBMFwAwIBSYGJDxjcBFAYHQAgEGAEAOMAAAoW4qlQuaMHBPVbTRRQa9saAjxtCELBDyADIhkBAkNY8SgwcGcNL84aGjetglHMSipAaXwhB0jO6N/5QvqGUul0SGZVnTAQ5FAFPZSyLOy9IqQs0MaDXD8SGkNGoIVANRAGCAIaAkZDxAUMAiEEEDAggOGARlyIEOE3iCBSIgT5PF8mmPpFUom7GDWJo1MiZNiqXDrmit39uopJjpAYCi2I6v/7//7JrNl6vQ//+i/Vt/////+tzQhlqv9r61G5NC2F9An6UpniwAAN/XKSFMBQeOWrEARVF9S4BgWcxtMMAiAMHAKYBAMYBgQSgCYEQYEuYpIfksBj0rShTFDC7NS+S5B4MnaMDokoC5yga9lHS0j6xd+5ZSXodlsoYO5bztfiMSXKviahqHWMw87cgQRPLE0+FHn5HPKw+QwQLOEdDQDIIacCcQDTgeegDLAW+DbUFAhq8L7ihwtPHkonSHE2OAmjGSR9AwQSOIJKMEkjxkxgWkkUELerb6jw6hdipu3////9rf///////////ZRZMkP/q9BjBiuo3RScN50AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB2GJShvbo3LEERlzd1RuXr4nKnXqAAr8RGYOuUAAAAAAHgJqo4AQYA4KZkoKSmACA3mzMwMxKjKWAYMDACcdAKQjMAsB8wRQCDBgJFIxZTPXDQ4HTRZe/RgACWQgVpxm4+DhcMNREDRVt0n3RRINAJOVXygOktxmWrzLwltMIETvgJ0GoSmNuTGUd0zAaBA4BZAux1XEcIcJABWqIpMWMSiGzBoYFBwBhQA8sBghAGNCgVYgCAA1UHQBvwjMZIXASAuAmSIEXY4iYJy8XEFukYJIomqpWPJGyK1pUVsr+UC+ag4KRAw//9///WeV/dP//1M3///6v//1nxy+m3/XoqPEaWTI8TwIa20AAAAPTSFtiICThNQyYfVLzBABAMMZrMJaJK+UHllDwpAwKYQOYE0eAonA68VcO5G4greNFVuNXp2BOswZ9HnQ3ijsvHV3qZiL0xhtoKf2bjMOxOGHNt5Po09grZGv0+cAy8miLjME6NQR6YCkwaBAsbFAgCuANONC34VQKAxQgcGJ8LBVMC+ZkwOMxSKJ83RQLhfMUUTBKyKlmxitk7Kbv/WmOg8YjuRb/////v/1//////////6BGFxf/9XRSOkGPJXJAAAADpICgARgCACmCOCKYdKKxgeBKGD0BIYAwAwWAXMewD0wKgJjAQAHKwCgQA+YEgAwXAYFgDTAYA4A9cgBggCg4UoIwCQAS0XwAgQDBCACiAYwCzRQImFpg+hjQNGVJ0TaQAgRkQg+h2CCAY2FxB6gpEWYKYQwuC4i6XRcpFhlAsfHJFfLRcHeMMc8yE4jSFkjAImJ1AiDAaAARUAaE2Bji4GRIBaKA4UJ3E8hxogEMkkYCtiHsanC4SRVXOmZPuy3ZBBNAyM0aqH/9SSIgOGZPLV/////ZBf+g///1///////1OmOp6v/9BFyaNiuXTFKCZoCAAAAHZuzwwYKjGAwPdB8ziL0ghkKmE0SGJll6VCvAcAzCoCLJrbCoRA3ScP+OYO4TyLnCxkUCcEHhgUXEOUVg9Uni8KRGCbk8Ow3PHSBnbDKDNniQIGTBDSVHIKhFBriCQnsmzZQtJiaClkibFtH4plUigN5g4kGAAWRgYMMDYJC1gSYVoMaOUXR6L5mTZwjTJJzRdS2SU761KTQQ7Or/+pR0LZGSv////96v///////////5kTtv//dZgs0TYgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjykE8OVoAA0lIJsMrMACY6FUodvQAKjcInA7UQAABABNoGP5CKSAzJCgFBeBllXgkAQJMkAESgiWoGUgiBsAvBgUDAAQGQABAgUHAKDogguQOMTBUiBo2Ie0FCJQGXGwmAcbA1qkBhMMwH2MSfD2BUVIAZAUagYAEG+DVKiRaLg6ki6YlEMvhnQBRQG1BJDYwJxI4K0JAfzQ3TAMFCcwFA4twtgfOFkQbcOUmdN3gSGBl0tqSSgMHgODHA1YwDjJA4oDEEAGCCe6SutqjTxlgDAAWODuC1wOkGbH4UpqLv/TNUvw9clBsCHoJhaGF1ZwLgxO/////5XDLYlMriC4lMkxlxQY7yBitx3mIy//+v9b///3/lx/HeVCHkTHAUyJjMGJPi4DxuKAHNHGLjGcGQFKGBFECAEQMhzCcHQBysgC1gcWNoncDgqQCJFCi5AiSQMiBQEBRAKDINAWAkUhgIBYVgYBBABATFgIuA08tBXQuIdIs4dYn0Lmh1CYhtIxpFzrmRQGbNy4VhtlYhx0rojyT4ngQHIxAkRpEHMUxkyEGyWS6RAPTKhSHyWhWoa46OEwjIBiwGMECEuVymkaAkcGwSPogReJ5w1YHGEFFxlgmy2m7/3dMwq5Pm867LTzg8f8jxz0v0FokpoIUEP////6CFBCpBqGr//dvoI///zP+apI9tn3302st31J93xVhfZN41lkOaBCgKMFJBAMm44BsAuYgPmJDKMpVES6wkGNoECRgqBBYGEx0EigcaYO1ZACqBHkDKkASgyYzJkBKCYtMl+/DZI24sCy122mw4+ygSSVK1lkK7qZzpl6WUtmfZd05hGoajVyet3oAg3TfQ7BD/gQGX4MITNJ3MtCNquNGcEhzwomggGXWLjMurT8q7SsNa05Uufp+rV2HYddB/oejVNfxlNLlfqSqXSqmyq00qpqampu/+VrKmyyoWsp+mWDpnUUPRqNRqmv6rW9ZVqampscf1llTU1bHHH9ZZWuxOzjj/5ZVqtLZs1t6yyq1ccceflljjjjjhjzLHHHHHHn5fKc8cccefvHHHHHHHn/vHcpjMZYQ6vIlGrXcaWWyRL+EVqY4FCgo4mDBQ2KKpVDTCDzLKTxVTdozPCzEDzDBxwOBjyAZY1NAEMw+0kMVBl4UEQZEWaLhLSZFiSIEMiXS6RU1KRdIqXEzrGySSBsmiXSdpGSNlUDpdLr0Wv0zIvFIZYZoiwrYbQxwD8F0wudD5SImRNECJknTW2oyRRZFHSSTRRRbSfosttaP6kUUUdSRYFxFV0UUUW////9B///////9X///UkkdSrR91lx2xEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJZItNA9urcq8v6jBl825gqhM0Du6Nw5NCqIWsUbhnRf0CgIGAgDOYZp15kLA3g4C4UApMBUKgwl0oTDMBRBoCRgGASmAYAiYFACIGNwIHJCGCkp15gkmsRs01L1JpZJaCFyM1iCJaW6X8JgVFC6oKEAZkRetpJ1eKCV0l3L7a4XeZcAhZMOHlLotDMDNiqN1TUfh82PQKwRHB2B4WM6iKkM4DYEOWXRZ5gGEwMFAcG4gwEBhBPgZsNoMAICAIGJAwEGkCkQ2ILRhGAxggQpFQignoxHKHKD4i2aFkyIUQnNDEmVm6ZfdExLqjZ2M0UFKSqWupGzuTRNgADsDP5wBEIhbSJE6kikikgqiVfU/+l6ZOjkH/9csDLDu1/9vKREit31alDWHpG2r+tA19BzwhMVCyigmYGY5qBbAwIHQspKiaCWkltmyVjzMsa1CrIYmivmtz6lAYmAl2h2JKkOF+ARhIw5BNB+Mmj/C/DDJesIsg5piTiHj1j1mWhhoKx4nDoUETWGBWIYoFZE17sb9PnOdb9cHQoyVibj1iyyJpuYDnjnjnkHN0hZg4DQLcAbLAcnABMDLAggTAhQQUFLjli4yDk+Rc3TTWZl8vm9AuGnQQQQQ6CCCCCCD//6BMEAIugv////////////////1ppuovm4eHh4ZYe8S2xEBBgKNplx/5m6N5gIFQyEpjACJwsxRnCAhikA5hSBqc5cABQQNFy4QoZnNLBiAWDQWEwUOByOCeyYYANh52diCi1cCCQA1NBovMYSjPgymItVtwzOqAzqlRfmYWdcVepm11FBCBOGCHochTtCQjOjUtwVoLYFhBFQ1eIzCw4QlFhCywSgJtJcDWhQyKBhpIKoQJHgMcWAxIEvC1ARCDqC3AlMNkDLA6SDCwC3DnDyblIhD7GY2i4TyBsZHDpuXp1ZYNzpfSQSRZSBumhR/IGPYATETQzQdHTpP///9zdX/qSS//+pL/8yS9Vum6qVJdU0TH8dxoTdpiyjI4LGudcmad1ADlen1gDmgQFZVG8QFKDzES7DzYVOFQABQoso3MJDpwHk5fpDluqjig2me8xVEtwb+VhUopUU13MjT9WFwl0AQJdkUERCSuHZbRPFyV9uks9TqGGXv9DK+6IeOrJGVAxnBbA/pMiGC1EiJ/MQ90WkT0IAgCCQEngE7ANcTAyhEJqxH4KLQBAYNBo1QcDFeGZFzjQFhEjLJJkWJwgZWPJHECuWXZZnPGqlTFM4yzNaaS6DOz9S0iOD4AcKHPKR91exrv///VLl/+tf//9b//W/9X7b0VuUhfDvNjA8buYIugmOw9ZHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB++FTIO6o3DeUInwczRuIKITMA9ujcNgQmbBzVG4fliyLBg6AZpYhJzmEIcGA4HRhOAxuXQxk8EhQGQqA40FRgQDILjgkcSgTBqDNYQKEf1S5nMAjwtQF+yGsAi6faNCdazgaQL5KdM9NaLJiPUymD48a6/LlJMl6lUobdFmsQp4raaG/llxSEcDgCb5IBa8Yikw5AG2wXTGGNgb4oYVAQwewbARzgMM1AwY8DIpQNmxA10YDKlAFhoZYHeF3hYUJKLgHGJRLQgKQpqUkCPJg6gQYxFzMs1ZR4qWlpN1KTdSO61K/YyHSJ5ASANSZLV7Mimmur///mT/+pJv//qX/+l6P3+6lZ0uk4gQMdxIoH1HEDdQrw4itP02r9VNEXiHAmO4lX7JzBwHMCAswBGioADCgBQeEACUvSCgZOYuWY5Re1PlfD5qmctero3gJMHLIKtwRCTTBQsuU1YLKm4tdjH6hrlBEaWAYIaddhp+n9o4tDstivGswI57/xcw4x5KA7RAYsDNCdhtiKBywGDDBaABk9AH1pBRsHvgABwt8BEHFdGfJ0ipeSIKM0Zl0ny6RxPsis8OoiBeMUD6KK0qRWMk1Ota/1t+YkVDPgGGopYix/vpGz///9TkyyX/Wil//9an/+Yv//0epNFZ8vG9KtlLSDuiisbXlvWoCgmAgBpgMgtGIUgEZBIRRgPAEmBKAUYDIIRgJm+mFICGYAoEBgGABGA2ACYBwCoGqh4gJgQyUXPJKjAQcaBGHsllyV6sbkBZQMVGiIvFhcLAI6Gueng1lnBkBamvDCup+fqy11Wit1MGAExl8RaLNMa/J2kq7cG9LRAELlUm0FWcOQD5BZg2xQIn4cwUQ3IAJCK4BYUDYIBCIA1hEDwxgNmOAUEADGxCglMGwEPaC18UCRcRgNocg1LCRAxeEVIgfnyaWYGKB83OH1MuZJGBqjWvrZL65iUBSIN5TRZrbS0H///9W////7f//r/1+3qZSaRcNhtEuXi+ktlpIkPJBNlLfpXeh9dBgMHmoq+clEIODBgEDGDw8bbl5ngMmDQKFAKUAgqhIHPkuQIHT5I9iQrdIw2NCtVJN9crOQaacZYeDWcrxYC11KpRRxKrj092U270veGkgd75+Rw21Z2HLk1608U4/z3qXXhlBlykgsnBLxbCeGUNygFwYLEwBCAGTeAbMqBJcH4hyIOGi1itRAcX4rxAyNRJBAnS+ThDCDIVpni+YpqToz1bGqLKS7K9f2TIYOMG7i8eSbr0f///rMn/9aLf//Wzf/U//+r9yyOlE3ROstNqQypVRdUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAf+hMuD26twwC/psHMzbmB2FSoO7o3DGUHmhd1NuW4pOBcBcwBgdDDvUqMYQJ4wFQDzAAArCAdTH4E2MMMDYkAhGABAQBeYAAE5rIC3FBsKmJ4CoYIFg4SUHaoGBw0QJfuUFFQxcCLwLicJFeeLVyFmQWVGdNzZk06WwLdhiTq+S3Qoh2lZrA7lL8aIvSVRNPZhKP6+kE8vEVFkFUQEDbiCGhJDmhdURIMjB5QDQ+AuMQ3IGshQBhoDgGBwDFALAaC4N6g4HDSBtQQeIIlsT6KaM4KmOWYkkO0wQUTZ4nSfUXzpdQs6jVNE2bRRqSSV/ZSYkYZ6TqT+7IHlq///9v///9///7629v6lqy4VykKOmTZNInGnmHKJFQZcV6Ydd5dJgUFGfJ8c7AhQFAuETBQEN1LExmBRYKJcKECMJET4sEPFjpBw4rXSJoINRwc9HJmT9BgCJbsITZArK6znqyIzxS3DEB1K9JOzrxPi6DUY47shnmJVo5IseRTKG1ga5REdDtKxOksMoQUoCWm5RFEDSASMA0oBJgA4ClwsdDMiPQxqw4SdUT40yBIERLx0sHz06s8TqS0momqGmhUml26/8zMCAiUDW/7f//////////////9JKmmWyb+5EUKlxEAJQFY8UJxCkwf2gKN8w6B4EhGbw5UZjBgTAsDA0QCmD4cm/hhgY2BDMAoxp1eWBYWCXO2DQAOCkZkyiB4BR8LEACDh0GURfwSALpf0yEbKB1TpxXbtRNuzsxNDQZAFFZtgybz7KQTvXy3jOnDkA6Bq9QuWczsLCRTQ9wbYfkJRKYckRQQWDwk2BYGLcBkxYAYIAMIBnmQGfDBesDGgQMCgDAwDQUR6I6GeFmCzxyBmRY0iYHQPBNsmTJiQwqpl1I+swZjiZkkZGhRos97P9VQ6QuiKDFuJp6ndkZszP///3///////6vf3/a2iXEhjyeJkqF+Tp1E8iVS2bM2cf73CMBH1bsk6WAuMIK0MIxAEYBiIDgQFZh+zhh4FSaacZf0ZA4ObtaCACaZy1SObhu7TrkYY1KhfkLIi3Sa8OxmHWXwwozS65AFHep6aOU7mMviTkP7FrMtnYYhc9LZu247xMBecfBfKqRCMOs1JQfBPjUEJQaDDlQDCgEaAxTAWqIUEzFxCkRHYssiBuUigmZlVI1Ol015fdK6aKCbVn3QWp6Sq13v+iomwxkSyaXrUn////b///////r///7uieRLxsjpILjqJ8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHGoRLA7qjcPHQiWB7lG4dohMqD2qNw6VCZYHd0bhYyKIGAowkCs13k062CMFDsXoMTxaM29DMzAdQTGAANr7EIMh3Z9wxEDB5pxxfJKRj7sKrNsIANUKyAaeSgUXHRLQAcETuY66BiB73tehh/ateCoKlq8wUJhTOo4ul0nEZy0WEvI+8ZUwj6kVKW/F0HUG0J3OCjCziOPjJjMEDAgFC50AwyBijIHzKga06AQTBvgEAigCg40Q84xR9HRxkQGRIieLo5ZCFyouMQJdrm09Wo4gta1LbdV/6iZDugBCZ5/rRQ//////U///////r//rRMifHcT5MsgpNKocsgh5F+hW5D0sAMCoQpg0KwmAmEaYAwEgjAvKoIRgdCzmCKAQOgVlgBxJsKAtxxMREcSFwmHhodjwEkT/RhE8mBDKwSPBkIjQSTpCoCLco8FrVys6MNClWtw5HdqYRCni0EwyzB13Ep1hXqa+4CScQcpfbVENFA1BV3pEOE+i3DVFDjRF+LNF+LYRMAoKEgIGDMgcAYDWWAVvAywMBQ0CJCHoB7gEgBHC2kOJ8dA5pcHGYmhXKBLms3LRfKCKBupaBq00TSdJbvep2V/UalADFgBUzNm1IougtX///t/9bf////////onzAc8hpEjU+eorxnhtgnvpTmGAAR0BoKA7mBIqOYYAS4wBoCQLTAkArMkAIgw1wCgUBSBgL18BcDkPHlvAshBAUbKhDWAZquChYJDSiEA14SDh4aLFkHFbV7MQgdaAwuhDuODB85Vf7KYTyJj84mw1tUzS3Aep13MxizqLrLAFhTkI/lUbIeM+OSRAP6KSGdLwgQa4c0DGAAKggBJAAEoLagY8+FhAaaMmGGEbCEgavMiBCz0BYBYyiTxAVoOpisOEwWmpNNmompRdBNNnb67/KBwLbhiYmCqgt201nm//////f//////er/11rc8OEaRYNU2UfRRQJkbyws7qhK9wgBDCcGTXahzqkYQgfDA8ATAwLTO5bjEcASgERCAAMBMwADkLAi/yYRMAMTpI6oxx4YOQJqYt2gULIQXHnUGgp5xgLUco1B24gRAcJUrdoGpbUehiUXlTKB0r5NqwmBY1KXIbpDTUFhEBsXlbQQ4gSAeRZg7xQChRRnAv0Q8ZkG4gEGxCoFAQHtJgaJUGRgFxoecBIMLJQRARSYt4rckSseGgOo0L46SqXnRPHDF1s1B1tMUGQMk1sk67rX/MzhFg5pKILVbsn///+////+///6/V7/71OVFDdKpJHzRA1MHTRI4vJ3oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHRIRKg7ujcNLweWB3VG5d4hEqL26N20nB5YHd0bldKSQkCph6BRrQMB6SCAQSIJBYwPDk2dl4xqA4vs1pPQhIFpxhIOOhQBMDSpceCUw6Nl5gQSnMvRkYXWjCQIMHIdfRUCFTXXhsmRj5MGsahNJKZNJZZEkRQEIK2sSgKLNaehnShmnFa8s96xGAQyoMX3FxChRwDOkETELjoIYGMR5DLom0EyANmQMUMA74EDAogMwLDugJACphAAEjGfE7FogA6h8D6KxMF4yPmiSjIvkeVFKSSc0bMlpOyO1b/+cJoY8BQ+OFbfXQ////b/9v/7f//r///e6jpmOg1Kpk6KC01oC1DyP+tpSySUCh0WzDD6zGggSwBhZ4RAKYss4uQwCBMWBNHQDAUbEECRgQAMEBO3IFBTbUitjP2hRZkCVxiAZbZnKdSxVMU2GfCgFOSCZfGnes2pXF5ZHm4QO/sVibW2cq7dmPRK1Sryi6E1T0NCeh9C4ibG4TBFyqNUb5NjGBwYEgIGHFAPOgcwiBgzgggKGDgBcYNmTQpC2E0RUmxZJXKRdRKJPlVloTlM6yC0l3mqd2pe3/UsnCkRNvretv///q///////7/3//WyikTZWRL6LskznDEQAKXpe4GAJmAWDYYaSbBjehEGA4AaLARmAKDEYGpXJgzACmAIAEghRZMAoIMWEAILBUEMZAz0ygmFy9z3VU1kfwMA8MBRAuAhYTHhMEALuoBCIGeFE8x4vQPiDpyakrzlJG24ioKzdnVI+9A2SUQtlrfw/dQhX2CQdc7xjHChiHCkBkyeDUiJEUE5kDMwwiGzAYoiCwoDDugHmQWAAZYsLtg9ANoFAnCiiRQQWIgR6BFDI3LqaCJ5k0VsmkZI01mSzI1OobrtQ/zcigYLKhm263RVX///9F3/7I//1////2/3+miYFInCsgVHz6U0L+FE09BQwXB0zuhE3FCsWDwDAEAQMMs2BMPghGQEaySgkWjIlckHQaNsQAZAECMITVkQgB5EmlFVUxYITxEYFLFa10KlgR3VVm9gyQufSV8aWnhqwyvT+xtn7gva7zwQ9kzaRqKNwL7PwR4mghUjh8lEmw1SRwYoG+TAXNi9AFFAYBgBvjQtoGJFDDC2YNyB0kSC+43iwakVJkpkuTqzM3Y2OnDAvqQSMKzyl0lp6VTf/1EeQYwEzU/rdSH//////////////23STIeRBNJ3QzyiuLrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3GEyYPZo3DZMJlgd3RuHl4RJA7mjcOhwiUB3dG5UpHQABwBsqhEGBuwEYS4WAoAqIgOzAiBNMgwHIeH2MAQA8GACCwIAMBVA65OsFxwQieAqg5dNmDG1kkLIcPTAlACgl3GiAIRuryobwYooFOHcd9XbT52vDUGSRH5FJYB7Vvohzj5PfDbNqBwHsdstoXE+CxCcrGQrQT4OaGJCCEHFTFLBi4TQFCAChsDCzQbLAxhEDAhwBUIN5xcQckGCg9M6NQqkUHPLYt5FTEhyzijMn1mi0Dh5JaRtWgaKOIrRU2mpSvuxwgoswRgNotpde6v/////1f////////utNEkjxaRLq3N0VOPoro/9MibRAeYNBQaJvocIBYJCOYLAgDQPMTkqLnJmgYGG9MBQjCEBPlGggCTilwwQBQXkM+FgFwRIAckGDRi4GpshEm4/cbWy0mBRk6Zc3V2pLevfRTcF0qgkqht9ZiAHblcCxay0hL6daBLmTDFGCLSQMokGHSTItJocLAo4IkwRMAQTgbROAU6AsfDawbYhxIhQMOH7jwTRIkWGTKY3iukZlQ1RUXS4ZOiYs+qtJJaPRU/b/RIEH4AWBjZTb62S3/////9/////////qU5iRYnCkgtaN1KI8bZsYrhaPhgaAphsGxt31B6EOBiOEJhkCwIFk2xn4ySBAaBoQAsBgYIBXHozaLC6JM+OlkJLhue11UCElp2hHIZMoBXRXfdApRktc+SDpo0pw0CsLv3JS40Fr7QUJiGNI2Ogtq65jJnXRid2fQnrWbgLCrmRQMQ30mhZAi44zQlxSA6hjA9gQaAgeBhAwGgaAbksBhQYGZQgBAwTJgSFgLARPQnMONGgJ0FeHwQAYB8rEeQcmVrKhTIedmbukkXlrLrIJGCSqda13dvrJQUwCRIpGrbdM2f/////9v/7f//+qrf226KKBqQUkC4UC8ZI1pyyOwunxGsMkKAQEMGg1NG8pOhBtBQnNcMAQzMqwMIigAQrkAGlmDAEESZxMHMzAxMxQoN6mwABF6hIGQ4MmEgWJNJBhoYqAgkEbZG1Q8YBWlRhvDFxFOF0naduvFaq9ndX4r1DupGGmTMOZ2ztYrkxqH1dLbRyUagXIiwYMIgI9EcsGDQ9URyM4KWDyCfAUOBCMAxDIDGoQNaEAz5INvAxQcT4J4Jscoc9IcsyGeHOL5sfLI7So6lSbMHZkHOuizmtSkWRbVq/WdUGQg0EdiKT2dO6v///2////2/////9b+5scLhDFGa0nWjsRZuYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfchMoFeqAA0zCJYa5QAC42QUwZWoACDkgowyjQADAAAAKgB5gRgbmD6HmYbaLYciAYFgCwiAPMAcC4RECmBECGUArIAUKwaByYEQDAEAaEYDAIQOApagagsPCO8SILHRqhc8FiADh0AEQwBg0F2D5E5DBC5gTsO0DFghAOBY6wyKSqZVNyTIOOMGAUZNYhQUwRgLlUMUZgpE2IQhiMZkN7E3CfR6FGJAdQ7hPw0DYZ4sCol0AgAALAsDAIKBoFgWkAAxMAGDQCg2AqABjQUAwiowxxClC8MaXCVKpSKhoQd2okySJsZMbulfPpqXXfoM/9RgZD0GEidLCvUis4q3//////////////qUfMxa2KJdZloINJ4usmsAXQWoyslF5vOUHaioYqEBhYGGAwcY3goYPDB4EMGg4VAAwD2TIB0cA3gAfqHGihBco1w6YLYjYFCivhZ0PIMoJ0EekBEAxwigRBY1H8mSeWZokIJsKIdMJ2G+OSLSLETxDieIeYE6PgY4PGLMF6OcTgzg+iIEkKiL06QURyUxQo/Bq0QhAzbUB5MB5sLKRAAPCJUKGEGCNBcKRdKJ0zHaYJORjrW5iZoLS3dqmNEU+rr/9y8NQyLaT/6f///2///////////tMC0fNtaK01pLKrWUDiAx8BwbaAZzKIecDNRZFAAYMAwGWS2BiBUgYTLoGoUMAKBxZwGIREAwDgSBYDwQFvYbIAkKASJYNmBcAsAWiCRgMGAPbAOGoWaC6kEISDpwtPHKHABgMHAkCgCg+F8xSQzongxJwoEQE6ENJ0MCARApEQsdRFtGVGYFIkTK5cM0C+H+BvYQhFyDOk4M0PBE0j5EzYYwG9wFAWAULwbkCiGAWoAQYQMqiYDLpIAqBwJB0ORDAwg8DSw9AwEDxURmgxIQhPjsIGRMi5PuOSFjIygeyKIJEQEY4ixBi4SpgYFlbmJFz5obmBoaNMCcJAWcOeQIrEaXhyRS4LBcXKgsuOtGUQaA0HENBMnDpusvm5Pm8vnDRBAkCAkFJQgJcIExNFc2HERqBtr/Yhh9ZmzFxCaLTRTmhmmX3m6kEEGLiJu9yKmxMmpiXTAoksFzZRJAh0mjcpE8US8Zk7JkVoKmXTAzb0FHxiEyUF69FethZQmTKLQEZ4m4AQoagFGgGAgWNBYQI4AaEBaKURlxmSAnDEFfJpIkEzmhWShHRPmqRNSZFMkSsoILUu5kks2nTC99S0jFBcxOqWrfzETkRY4CgmnNhZBcQW0wNkjFgUoknZPe3UktTrr//63+v6mPK/zhZ////2/////6lf//6H/+m3/3//0WwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJP41PB3aAAqvJuhDs4AAijjE0Du6Ny37GaUmMUbp0lMjAMDjAsADCsegOixi2IRgaCBhqChhkJp14KRhwDJg4DIYFhg6CBgMHoABcwwC8BcUAoiAZdh+4g0L9CHDgEIhgC1BtwGZNgbaWBhAYXMlMgYsYxRbhkwFhwOHBqoYAfsN4iAesRc4HshjURAXEiQ0UCSKhaB3EaI5HIJpZESwTQyB0njUdJIEeKRC/oj0VoQYZkgIzogQVwDFpgN7cCIsGgUMhBi4WIO2J2DAQ9jYHKHNElMzIpESNSmK6O8nTWZEWDihhF4iqK7IorLqSKKLSaHKM0zyXV7usmSdIoAKLA7qgAokNomSKmqku9E1/V/+k5kMcNNlaK6S2oolw2R//9IslVFGogQ2mSSSUkQ4bSKqP60vqNq2X/1ool0hgBBMNuHEfFbxgmHAsGJ4wK1aGGXIxoB2BJ0PSutt3qSHZOwxpj7u/TyRiD3uwziBGdvmwBdEZYhLYu+kUuyu/SS/LDDGnrSy7FJu/DEOVYbpn8h+3MP5HWHuvEH4tSiWTb/z8QfyclEMTrO2yLCmM6Mw0As4y1Y8PJeLUgNx7Ubn5RLKtPfww1hzDmef/n+H5/z//D8+4fv//////////ecxLJNVf/////+kMBd40///+WG5v4qcDAAYdq6fljkAgrAw5GOIGjrkGxDCmBAOBwcGAwJCIAkgRJiARYHBwWGTolgBGA6AT8SXwGCAYDKWFoTAjE00oSibCCAZE5WOXFQHQCgFCDgNzGuvY3Wq/rIWuQpNRAakc5TvMxVOxJWNCW+K9npgR8lmC4AbngEg1kWTCycLRw98WISILtGSFmhbwOwMgA3eA0IGQAx6wDjOQBi6IGlEhy4jsV4CQMVqHPDaAuHGuTxDhjBXTYihVIeZFxy8NcZYd86XTY+oulJzNi4bnEDRI5MWrPppp9VBMuEXDQAJHxRSJrVt+l///6RBurRSX5ef+/derRaiko6OQRNiibpusvJqTd9n7+mj/+2kw6gtCLgwAAD/W2YAlp+Au+OqBGMgz9uiWQhGjKjOqMaFHUawM9MtmLzdYU19d0cjDNVil+m2VvYS6i3HQcJltirAz9zVzeUzSQ1df13ZyVRaGXrkbzReeo3WfsaInQSoZ4gJDiOIQYBUKwsZmNUniiHFkFBECBqRAwAMDigQMEBBvGGRQsIBvYcoNAEaD6J4ghDCaLpDT5WK5fSN06Jo6k1KooJNUkmtanRpdVm/WuSYe2KIsw//6a1/dlKZq000CMHk3Nk0UC8PxTJArGqCR43t///dbGxHmSKSTMpVv/////dExUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACDSMTQO6o3LsEXoybxRu4HYxMA7ujctDxicB3NG4fVqhKAIgBowFmc2hKwwZC0GAEYagEYhmgeQjGNEOYSAWYBgqWoBAwHaxpGFgocJPzFLrI7KZuNLpSGBoBdoxE4FAENWpq0oqCg9cDO3sMEuKwtd+lSxCeeODo0l5eQHN2WvDrCvftrsAKZNPiDvTBhwAWuIjWFIizhKIrcVQ4gvaISjcKAtoeUhpsAaTAzBMBcoAABA05cDUuwkVA15IJAQ+YfIFg4cMOkMRlRAYVqLNEoJE6XVj5LJcWShbMh7RM0UWcqtYrukZJUi8rSe61/nHFbCgg5I6i//////MTjKpXQZSKFleq/9fXaoumhuTBcJcjDdBzhqjqTZF/bvS/X/rpCUSeVAAIscsXiGDk7Qkf8hAC/wySnGhgYBBAcgw3KYZWZhpjPUDqPzeoX4aUu5HloMSU2ENEfkwpdKIAaFNRqOyGbsU12thEZ2Uv7StZf6BolDTla3EYZpojCWkh6pECADnDqGVJGRYZYvEkRIY0ZY2FIjPjYFDhboDjuAGiwGEDgYoOGgiOSLkVEFhziLGJQIsOIcorH1lEvFbWojTB0VFIc4miJF5ImiRY+akBPEVHJNyaTZFFjIyf6yiTIYFCylSX//f6n/6KQ+iAoIomJdMSBGxNGyTqM///9+kodREjpdRWyJk/7/+3//VMRW0VrKqwwAYhCwwaxM5KN4UCEw0AwxCDcgTk3NZ4wTCMwOAQID0wPBsRJw1NR1PExgCOScnRFgFHOMQMnKsh8nBMhEFHCIBFhRFcUAWtqMrCqPEqUqaG2QMGhmXymCpW3zDyyih8Sf6dd99nchlb0BPLHaQgBQtMIEDbYMXDOj8RUVRSH2RAgA5ghYckQOGXQJBygAM0A0U8DJPgDqQGbEAYlACIAI/BuaK+OILFR5EJxBYh4y5eIeViqLWRUuGqjViecuJLPGRkVkk3WTLOX1GybPZV0f3MjM6IKBdp5J/////b6PSSW7Oj/3rt/61LnCYHsc06XSoik9TrTa/t9f//5ME2mtyXu4n2YUBgcFBeCggWoTByYOFyZeE0oaUA2zFSgG2U6wQWDlhw+wMlY12BVB2dl72xNNL+gx9A1lChjWmRLuaa+7BaK4/E7PX90HI0+Moi0o+flDZYm0OJX9WYjaIENQgZJDPkgS6Tk4gI2Lo6ydJQthyYbWCEGFggNyHACNCuC5AGBozwvhnBiCFCLolpRbQJpy2Q8gzI0z5ZSdBalLW1bmzoqSSXSq//LJSFPJ8ejF/////+o2f1qSUl///r1Pp0yGmdRyyJ5m/6////zolFwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgljMwD26twwjGJwXNTbh4SMzAvbo3TX0XmRc1RuXJZcj6YB4BBg+DqmisEEGBOL3MCQD0wIAuTLoBUMGIBASADQoIgJSVoL2I2ioEYoAG9wbKhYITmaaFwIhBxoVesLAYyxgoBJQNN0lAyQBWcxR75AFjpVj7wMw2VzMunrEvauW5exl0HrLiLMXfY2sG8k3E1AC4wdAI/DLBAAtsNUXCLoQVEkJkfxyRS4pYmguqDwgWGIDBnAqHgdNAMHAcBIPAYH4BwgFzhaAJvHEFACTwxSEHcMsISkcVCBEVIKggozLxZLhUprLqqLKOIKQNl0H9v+qWhGQYKL60r/////rU9qFRnX//2/9SzpxhTybSJgupMkgY1VKTZ9f///UuQ4jyogANaPtwEIFMLRw5gUwIAkKmFgoQHYh+Ch64K5cBUENFEwU44YAEZrkvkE8tFqTCYxVfIAi3Lqt81Znj/vc6RIBeyUx6lk1HYlFmWu1Dr9QHOPjW3HZ69BWGoKmCkRghEYFYXEOwjzhNlAlTAXo7Y+RW4NzgvwAoYMIAMoHYJMI3Fbi5RVHEllYrloqkcXkzUspHlrPpFM0dakXRR7WWhS9f/1oGpFy6bLf//////1bq////6nSczRSUzI//////zpuigAZC36SAKAfMGoRY0UgezBKAKMDUAEwDwBjAYEYMXgTUwEgEkugqASFwBhRMFhkgBiATBwCalCIC0Jje0i5XIcht2xGPABiYQxlwG8jio0bnqlJIVJsRN+6Sj5TWnkelvkm1LYvDlMzZ2GkyuxKX2fWCnFHsPoIEGUE7DrGQIuNYc5RASSGVGIS4lQCwAVEAUqBpygGAFAAFgBBIYSEWBIWDgIX1EISgVyCDmDjIIPk/KxFzxueomqBURWpJkU11MkgtBjZ669/+fJUTyNFRt////9vXZFdNA6r////0EFk2WEDZZgo2U7+9+3///5k55gEhp4VUhwNgX6HFVaYDBBEKyIjAVqGN2KNFstCHBVORdYdAmUBqSY7nVgchwq6xmCIDuNyUyGlkZQBN48qO0oZyhOaXDOVC5VBXms5U2GIMrZG37FoclsESqAHZnYfs4v+KQFwiPhYBaR0jykOwcoRAixoajTI4SsgIJCCKgGCwMAkBoXAiYAaJhfQUUWgQHJwWEd4+xwjBMiDIGJk5VKuikarZTGrKLrTp86zJPQNl9df9aB8aoIi5stL/////290qP///t/QUbEUNTVTWdS9X////8xHAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHZYzLi7ujcNcRiYB3VG4hgjMoD3KNw1pGJgXdTboAY83NEAChCYkXEeXGyYHAEHBcYLgUYkmYdPj2YKgsHAsq8uYF1geJFgEMkRDSY0MB0IL0kcdUZbpcSaBia4YIDMOVnSqYIkkNADfqyhUsKCBssD0kZ3VePPiXJdB/moRNu0YZI47XX0gNx8WYIpCfC8LGHyCzRTByxSx4Z0c4ipFRlxliWD8hYgIDABEYGsIAblyBb2ACWAxoEBcULgC10QOO0pJm5ECHj5LRM3GdHlNNFZkQw8mc6J1JRxKgutnZnsq3+alcgA5zN/////9vSTRNmTb///+7Jl0kiAE8bGia0G+zev///84kapv87q6jAIATE1hjwsKRYRg4CAqBBheLhvGNQKHYFBKYJgMpmMHSIxGUGhGAAuZK5l0bma7SV6sW085jyS/YfSPZonIjlHa5e189u5LOWa9LBsob1sDK8cICbE5b0x5YGZ5BDrr7FJDkjLj5OkAFGLYuQiZdLhNjYFjIsQchgJhwEBAEjwN6MCxsL/gY8ANcZEG3xYA90XCSTGBMlYipIJoGCJi1MtHD56pNSLa3UjoUnT7f+6YboCQI3Nv/////v9SqTf///+ePkYm5x0bJrVr/////TcV08pkhNEYCAMBRMDVMAxHRZTAzAsHgdTBKAXMB8ckyxRXB0CcIAIYOisACMJOQVAo6CxYOGOoEGAhOWITIiA4YN1fo3Q+YtLIjB4AAhQLk0EF4eRYWarEMkIaPjgwO3aKSSKtYiMvZAlqorC2ySpTqOs0W4sE+k0sh8nQAKIk4F6xaA/ELhBQQeiMYSwo4nUzC1If0aoXzCyIBwsDHkQMj4A2ZoDYCQMAdAxIsEwYNlg2dECDmCZClBkhXzUU0P8TReKo5BVMTSaHykX2NZ5Oiq5dRmaKz6b2Wg7vf7GQygN1wxgLY+v////V9DqoOfU6H+r/r6D0ziZfFtJwnim7mydbrvTbv/f//sXz5VPgDPQhk40ABiqPp4uGAOCsoDUKACACRMHh4DAPIgDEYFlmTDnUHBIEjmnyFuZggKv+xKIKprfcVkaAEu6pCZXAxBP2VW3jSVhUkeN8qbPtetcdRmr7PPFG6yCRy6Ac4nOzLc3aFLieBWpHC+FPJIpGTF0ZgXEXhmRzjUPhAyADdABnA7eA9zGiDaQMQLwRILqxXB7LQ7S0ShqXCKlwzSOH3WisyQanWp09S0KlqUk//9ZvI8XEkr/////7vdS3Mi46q////7sUSuVTREwsau3tV////6BSPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB3WMSwu7o3TUkWlxd1RuX7ozKA9ujcNbxmXF3VG6ARdypS2RgkD5jnLh+yQJh6CgGDUw8B8xEQM5WIAxOAcIC5BtDIwESGrgLACHUHARi9WrCX8ZJBajqgReBHxDMxZBEAeojSOEiqpyzF+mvFgYKF2H3omqaty7pui/igee1lsgkLivxFbKnMWd5uy71/B9hjRmgy8J9Flj+L4axHCOCgO0OJHQxfFygVECeQF3QGbBgksIQBQuIJDJCMQscFFD2SIE2dIqMeU0SmxQldNBRkWSdTZI2cyJs3eWCfRNFGCB00Uyl6LfZbOF8QspZL//////1Mt7///7/qPpETQKhkpJaKa2/////1TMXzgDMwAquDAOMKXROKx+AQDggCk3TCAJzYgEiYXCoBT0s4IUoEBgwaPBQUEMToQZYssduTKEEjc1h2IgQAFQj1l0F3Pe2FUEdSFnF/wJQx2NY4R2/KadxmUw06z3xlqbE391SQu40FkBcDVIgKPsUiMgMQnC+MqTo9piziBkOHcCACRELEQNU3A2QsPwAwAoYwTaH5BaMI/MhhHSsTI6iaJghxgzGhshRTartZXMWrW/1//QQIOL4tN/////9vo0UUf///9bIkyRFA1N10nZX/////ziqjjMVRbAQHBhUgblGBRMFWmyYH4DRgmBzGS0ImYJQHzIzAMABZmFF82QPAIGoMEG5hmFDbSWSz6boGD0C31bkOqhjoIFxgFAJZVyFUgEDPyzIUDCaMn24uS/lNQ0dA8ytRdBg7ktMhhej+NPjSxl7vvKmEp0BfwAoKF/xPYgKMwLnHcQ0bAdYmiDk2IAFUPjBuUGNgBoQGRYgetIAo7DIgEpgCgYL/izg38RwHeQKxOiEgjI3IoXiuXEUz7F8rJmqnOKNEpsylnWSLqCbJqdant/pFgGgQUEQYuu1v///6vV7qoOpD/1f/q1rLMa6JqcKrJ3W3Ra3///9SzEoEmiAMMukskZBAlhsxKIgCAGEBMDgOMCyaMZjFLNIqtOCASAqNAmODguMRUMlhLRQE6saVSUxhyWMge5JBlyl86pVBTC4Q3dmKLcPSV8MbW7U5Dbhvg12lpJdDNZrrqxiM343CYfFbjWC/RMGAxouZxyS+RMTyPI6A1UbDMg2OBi0AYCBiwoG6YA3ABY0LMDHBZQZgQkDGpOm5RMyyWSLlxSjA0U7saGhXQPU2op6lIXvv1f+kRpbEJy0c/////+/1JMZ////r1IHFk8VFpLZJkH/f////3NTBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhtjMmL26Nwz9F5cXdTbmEiMSYPbo3DUcYlhd1RuABg1VQKgCmAcB0YSZqppyiDGCeBXFw4MYLinGRyHKYE4EBgGAEDwCAJAKEDWEKpjAKYUDEgUY1psnMTB14vAw9LwBCS6lbDAUocFQQDoIQKFLGelOpoDEWnk1C/ylrhv3BE6+8naWwBdoJAn6Zms93V1tpC3UfWCW4JgtqMqAUaKwy4qh5MBkxZJsKRDlyJiQCgxpCQBqgAJyAIRA0kADXBQNGjCJMDFngbPgMLw1YDcsPYDIpsITF8WcLYO4yJdRmONJFiygTRcRTTXQTTY4ambLSUzJLVddn+x1MhoAwcUYumiG////9H1dNBbnzJFNm/rV/r9lLOrMB3l4i5cNzJnQWytF/f///7SBjvUAMMv8w0GgEYiMScPCYYMAKgKR4MEwyNTxSGgiR3TDCoBhYeRKwUMaEQhzE6lorkgSLsqrpxpAsTCwlQ5CQ/7Zmxtq577RNq6oqaFt/lXu/vCZooEbB2PRh+KR/W2k9mtGl5DeH2OYcLwpA6MwITokNFIDmkHKRERzg6AFjgAgAaoGAAXIDdwhIFAjICkCHCgyBk8fTJ8vkyOBE4Xi4ZVGc866Wyb1oJKdKmkir//LBPCEgcYnT//////9SNS3////3OLMyicorWv//////HgSuVMogAPIQTDAmQDMAIUQdA7FgHBwAkwPwVTJXDeHgmh4C0wCwCC14WXyQJMJODCRwwAIM3tAg2AQgWtkBcsDAysLuvyYqnhyiLAaJCAldaq48ItdXuKhJRIv2hgzh3J6aeuWrtSRKBdFVK6HY24kPK/kCtsLeFuC51FgyMA0HEoBsJ0LdpB8IywwiFFTLoqI0yKBasEwwGEGAFKANfTA6NcCwMDOlwGBwX8AOHBxAapFdGdGXJkgosgnxjjQ3J0fJaRQmhfIMT52gx1A6tlH1LM0kVsiy6v91HTYyDTAurNiff////0v2upaZ1akK//7/11OowLhJjLmpNpF1Gr7J//V//1MkQUl1ADLZE2Yv0YcC6GtKRB7JCIDDBAfTKUOjAUCQCDhEEIYA5KLDFwNDspQlGi1pitAkUbYqsVTt6WFrQaWgPeCD1eQU58w1ty3zziFFG91HigJ+Iy5yZEw1xmLL49IXGcmBaCdWK/IlAQWFxkBIkMcSyiaHMIePJDSSFbkAFkGQWTBZaKmBowAGADA3PBxwOuHBB3kB3joMx9lY0KJgQidAqps6zpumktV1IX023dBuvf+xmRwiAkpoi//////r9rJqV////10kS8Zmyk3QXb/q///9WVkwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAIUIxKDXagAMCuqaOuUAAq7kFIWVqAEgBIKUMo0AAAUNGQCACzE0YTHm6z6xQjOwiDFgBCIrDAczzWw1jGwKDDoBi9DTyASwcBSfgFguBhgFAZSTIBQPFFGySgjgDAoDD0A4oT0Bh4UgWH4IhsASARO4j4T4JvD6C/BAHwoZB2D4I8bJfWUyDiFBZoXMCbxoCBRcweiKVF+IRkRDV47CJh+QXzFyh+RaE6hkQTmQAip0PAOEaZFxCcTiSgegGzBZgAUNAYKFYCSwBi4QgYbCoAgJE5AMAMMlDGAgEPsUINch46yyPJaI5IihMlxSCZNkOLxmmZsmdugcQRRZSlK92/010CaEAEEv////t9XVnE00f+3//udpjWIOkylMeSq7N7fV//+xImywAAARIHmAsADAQEMRJY5APQICkoULTAArNCCAOCi7BQANQYg05jgZ2HJgZNcDbAOwNAiorcUqRZAgI7hzw2MY8khjxmScJMwMh3m5RJ9SC2NCSGdUQQqnicWZrOkHWT58c8WcbkBPD8ZkVSRIgRYulU3MSLIECIGeDCoEDwWghZoY0LPitxlyGh75FSScvm6LmZ40QQNn86mpqa6a9NTt6v/+ZrHotIIf////+pdVdJM4gmv////sovqNhBTv//rJgAAAAYBxIAp9DkgCkABgIHAaHO45YGEg2BhMEgBF4DQIHA2wIyoLIDGwDQQAtJwMPBkMCDaAwACg9sDAITAYMpQTFuDlw38P0AKP4OKQAwfZIa7GpBSLEEAxYEAMAB0DBYcBsZUgZoJkELhgMAc8N7EGgEgEEIJBuBmWukVz6KSi4AwAwsiC4UCQDD5hcqkCLCE5MFFk0CcJ0LmwvwFiguQboguAwEwMeHEDdJHAy8DFoq/AsAA+MkxAMYwdgnQokTAxAKwhBAbcBECBzwvSH9DLohF/qaQc3QLZMMThmfK50lhYkhBYXOMAckeR1FIcf/6mk+NMijFQvm5PnDQuMmxfAAAgOJ4x4wBCUZggRYGaGqXiAkwRU0/6v//3K6CaSCaJu5uYIFxZum90GNE3WmgQYXQWJipC5h0kAICUCsOokyCkgOaQ40LBFyLF8nSGlUd4WhjNEDKgCjIboC0knwCBwLBADA4aiAUGDrDrJ8lyaiqLwJ+JSDhKQ7BOmQJikS+WGpKl82MmLjG8zMjF6zVJ90jVnZS3WiyLKTSW7oIqbqH4TcrMNReCrHLrojxHcEoPNbf0/8vLZbKUpf+s9/7f//////pnv///V//r//X//r+r///0MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJt5BSBlaAAKuSCcDKtAAirkFCGVoAA3xIKccpQAALTwMuIcBIGAxhEAgAQGK4oBoEqgZjlQGrwMBjmigZsIAGrGcCISgmDgMEBsDDYRAYLQDgUBmxYDCsBQ8AM+DygNEAKlw3YJCAyyJ3AgmFmlwCpALCRQongBgECzMzKoXCgoaIY4IgQ2RXSFDFo+RPgs8YwTAqjHFUhwyZeE8DnCeiIkVKJFiJDMkML5VMjAqsWC6bhyoapDIIRsgdsQBYCOshRZIuwFnoYEIKWioTpcBAPCgEggs4ZUWQRZEkmFkOKew5pRLo7jIaaymTpEkzUtLIis+kbmRmWFuipOyCKD0dTVVfQAgcAKjVKKx5up3HKBqqBYMTtZRX6sckGpgjDXQP/yHMZDMEDMkVs6lmSReVJo0WrrYPoJk1Q5TlmrXOnjFqZ5/k6BEAlrMWV66Lc631GwiZVitAMajoMCgYLT4kYGEkaBlgBAACsA4+gIFwGKQKBhMNjuJUWcLIEYiCYVAegyQvoKwXBYGA/l5AQ6Q5Byj2MkyVFpl4Wg8ESikZMTlH0Ez7kmfRNFmbHXqRZJO8+g5LqmxeHcBYAcJLKZI4D0Zvd0xTEmC4IpJo2pzlJVrQQsOe9N6u2vV//T/6xNwvv/6IfSi+r/SF1P/9emh/+v/Nz3Rq///uTfUyf//+ceAcAQNBksBYLgYT3oNywM7OsDcgVA5OMABgUBtKhgaFGYGCbkAomAMFgcA4HgFAQCAAANAAYgBF5AeYCEKAoeAK/iiEQBtcRqM0A5KQcNVgmdAaBECD8QDiI8BdUVAGkZGDPjJA2QMeOgih4xEIC8PY1RvjrTHIFQGXKBoM2O8mzUYwkCLEwITFwmhzimbB84+iyRySQNRICwcSkQ0gZfImBESAMcD4CICcBcwYPDOwUyA4SKkdIiamJqkOckISCuFkoopHSm47xZ5JDHn0TEvO69m6zAyRdlLtoUqK1KRXghKBprZk/rrKIX6ENfW384LoTB9f+tqCCX6qsxX9bDtK7OsyPWb3p7P+iOp9RZRV29tX9ym0AAg2C/hKBCWIqBi1ogYQaKVBoDAUQggVDbGMACVhoIgmeFsJUAAKGDCCBvhXGmOYRYLPEuK2EJSYKY2HLgFggWQiPhJBSZMIDkmiaaahSJkYDJC2Fg2LpoRUwMCcIIaF8UuKCIiMALOj6MCDnCaHMJ1RWJw2Lg0xxjJiEws8QAAyCgDEAwGC5XFnkgH8AqmBaOFo5fMk03QtAYFCCIxhOESMTCxES4cOKQNnZv+sxSQSW7PrrdJ06vP//yMG22r76yiKtv/of///0NRwqF8xU6S/ZP/pl/qIcpP/V/8uPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAByyN0QdugADxEbow7dAAHeY3Ng7qjcO8RubB3dG41GttFMOLTYuwxMSMFAFZkOAChjxCMxIVh1W5EYKgKGoCQwN4g5Ygg55EB6FnFoV0NUh9S+ToN5AMCKFiD4R+FiFAh6JIkCGTEByiTA4iuxdMiPNTxDSyPgbQ+SAloY4gQuEjhmhzisRxD0g6UiRFiVHNFAnCeMh3FokByjcXMdQFfDoQ3oONC3AHXTAYAKDQGDbIGwwYqWHxCAQsZKkFJ0jWIaM6VVJF4rG6L6R4+ijrRUlskpJ3o1O+r/1okWEdBpRUTRb/t///+kd+tFIvDmoHKSSlot16v/bekj/r///+kkQ4ln+JP8rcQDJ3KwYqCAEIQzTiMbZQxJSWbURAqEl/WtAABQbYh6oGOCAYsIGCiPGNLBFAyEI3HaTIKBAMEBGwI6EJRQJPhb8S45JIhbMiJXHNKxWNnJgtmY5xJi0kRH0VjEc0nTZIfyCojknhTg1cKRJEdQyQyw9E2LlFmk8SZGmo6R5RIYI+E9CRBZOBxFIBwoCQoLJwDhIN1SoGyigRRSDEWFnE8bE0OcVjpdLpOmBeRmpiXjySSVJJNGpJFNaKDpVsz1t/1GxGiFQJBTc8bJf9L///60TD6VZqQKankTFakktf/+9eyX+r///1orHJIkyK0lboOgGDBwM7I3MBAuTAMCgDMDgTMTYrNXghAwfEgJs5JgBjKrzhwMQCSIAYhBHESoAWFo22aO8TWF8mFKmgUu0PC3hR5b5HJpjnuOMApHBTeX90E/JJS0ll6YjIasNbgWcda7MtNd1EhwucTeLkG0FzQj4UOO8vEgOcXC6IWHYRdEsDyGvAEAiOQv8EJ8DeCgAWgekVwMCLEdB1ScDlhkxS5SIATZDSFKZIlplEIWTF1IHCHH0UlIKRRTsiqk7pWSerX/1LJ8UIQYdqTf9T//9v9Rk/Wt0CwZk6itF1LRXr//19Sm/1f//+6zqZLJWZ6QsmAQKnRQ5lAoo2qEmAgJmKiqmGIAo0pGGDYPCIEBoeChEKgSDQWEjPYAMJGvMEiE8xBfDFGfxYeRgMfNxjSDcKUzYjPSdYoMDpBK3djc9KX9oNu6+zDGkxO1uPu29uEDyqlJpAUqJ7ElI0MYDcIMYFkZUujMlQY0myKjkCgigLcGOBmwLDwNSiCkgCToAoCFzACQAdoQmFgEFB4D9i6RhRKRESVIEXiLnS8Tr3WojTA+6mdI1ZVZqbLQTZ+6/W36nLQhOHOFiPGzf67f/+/6zFvUiiakHPJLOJPu2z///dn/WYt+v/+tlHCbUeQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAeHjc0Tu6Nw0zG5sHNUbh4iNzJO6o3DHkamxczRugAAO1IHXSsKAnPaz4MRwJBwitaMBwAMRIfMjxDRDWquEMGzBB8xUDmhgODhUx+LDBVBJHXAVlVTQ5LUdFpgQqLGTobIttrcaUTfOZX4YYM3occucr0tbONO1LlttcgWpWdWGYQ5z6sx2T5HDBD4hXBjBjRpDiEXFiJsZoWaZE8OIh40xoihRSouUA0QAotBIKB3QpYDEoGJGgYMAJKFhg7ReBfAZsaxsO4cI4iQG0UC6aEFMmeYTk+qtFSugm1R9V6mV/+qZiMxNpUU3+kcR/vqW9nrXTX1rS3RQOlkixxMvpqZ1M/1+//rq/////1Hi+1Wakr0EIfM+bovCmYywRAUKaEzEKxEDAMAk7qcQFCsDNNsggLHBRJDF5IzGC1T2l8Ywy0sAAoKYNMNbVpbCt5ukaGQKslaijcYh23YpJbHnYg1wmYSvTeWo0uWM136OMRQuJEPFajJkYJtImRQpk0WyKl80EYj2ZF8G3RN4f0DCDQMAhBJGKwGNRSIo4n0iA9kMIsbkVLRbLheJ0qpFxycscMnJQ3Y1Taig+tJOikpf9S/9aRMG4ggVbf/////q/SSc2P00qKNm////t////9ky4XHAAA4y/zLS8RgsB5+UXBiwE46B4yCQFAQySIc2FAgFA6WXLXLoC4gjBL3ZVAJzFI9bDgC68VHZsuS9dSFgrkMAW6OW/Dcl+NxgeGm+NKMh9+3Ywl9aegOpHF6LIYTNw9LGk5vw2Ju0H0pDCiOocJJiaiBhxlwW8lB1oi5SJGZIkHKgs8io6AxUAoECxYDLtwBpoDTQDHAyaAqBDRwtaGeEok2OcS5ByfIIRAmS2XTMxKSk7GTqSNkDZnWgyNKitj6SNVFX/9ZMjhGcNjrf6k1P3/Vu6211PNLPWigkQ8iJoYoqQNkr//+rvRb/////pGxxwBrUMEJ3lgaGmuO9wWAq3RwCmPIOa3F4yBFbi6cJJYnCV6Qhxs4zRJlg7vSdqktVUodx1pIlUrpMFvHleG3Ss5c5rM5YjcVtbp5TQ0T2PPSQK9NyGORmtDcsxK7MQcgAyQ8ijkOI0mTYjC+T4sorpkXNi6OeGWQveGCQtwGKgDogFhQLHiCiZC5SACNzIc0lyMIMPSReLSKSi2npTRNKlTZS22V0W2//62MCND9Um/+f//+/9dezuihKrn1d////X/////9ZSMQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHko1ME7ujcNOxqZB3VG4hMjUqD26Nyw5Gps3M0bgAADf52VbgYAZgyRB5rMoCFYZAsDBkYMhIYmO4abhEYPAKEBMXNEAAIEIyEARvCAkvsDawEAyObIoflrDFkoo0ah5nAmXXbispSp2FsqbNJvLrKGR+HVoYxKvuSa7G3pSVwhh232lb4w8/VHGXaKJqKEDEwnwnRQIxSCEHFiIIPZSHcRElCHE4LOIqMoDZQlQWmgLngNHLBEWAzg0LMAFAwxgHph0g5ZADh1AnyYLpFR1syxgJXrLBMH3ooJOgjoVUlXrp0tX/KShji+e/+iv/6m6aF1bs6kHnS6mgRxFSLl04rQb9fr/q2Wk///t//pJnjHcofdQAwBDM4ZeQwxB9DVINNcwsHwz9AwHAoj6FwARyBIZNQuhDJAHMxjBQN3pVTcbiyRucOO4ugMWttGGVrVXWl66kvgBKK7BNDvPLCtOSO6sK/kof6SP5DcOyOCGhVkyHDnivjHDqOk8RjDPFIi4/FUeSNKI6ymUSsHqAUDhAABvUA6WAgSCQYLGRCQOWFoC7RZ4wRsEugdKReLpIqRTWdSrPsxeRspkvSUhdXWvq/9SDiOwJCi2//0v///7foqQL5qZMiybL/2//rv/////1jOEk7LcklSEB4VDrMdpFgwIAMTAXAGQfZcYIZzBhOAgGAQAWBABLANBCCIL8IKgkMTrNplR6YldnTug0bYk9zcn2NJOAsUFULKwpyAuFLhKABeqcStxopK/bLmnPNGasudeIPymuWya0oE6sPtfXU4zI3YYU4BEiJCSDKAHARpEgTwbaOIVqOgT8dE+itiuMYEwAs0gYo4W+AYQGBgRIGBIAF1wQtwAsoIlwxAxgACACYYbhPCEJCjeGcKxiJiPZiVikVVF11lJisRMxUx9BSkl1GyLma02ZBaqtX/MyBBasLKBgldf/r//U+v/am1SJgeHUUDE2WgYJp6C7Vq62V12a9v////6mQHPJ8YAAAALjfkDfGDAYfoYY0GEI13lUCGCGgZLDUsVsR1QxX+NKJhrkSGM7YIiSvnqOjirEnfhmD3pVqe+45L0wW82n8c1jl2IwmvvX1Ox+feZ8ZdJY9dnJTbpcZLYpjNETELnxpD8UBy0zU0J8vDmkyTZAUiLC0Bug6gJFgdZAXGCihdUH6kkOSHtkQJsqmRbc6X5WWgmtSrVpIdror9ep///1XGNHEf/+ia//UtTKrt9SqlOp5fMjdBadmf///6v/////mSQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACA2NyoPbo3DXMalwd1FuHnY1LC7ujdMoRqZJzU26iTY1DAuAWYDASRi5ILmB8CkYC4Ci1BkBMwwRbjGmAuMD0AkiAFTvQeMNfAFIEooVBYEB5rGaYuClAQW/cKC01E9i/6YSgpmyWFiV92XhYClSc4NA7kOL7MENoDbuoQ8kqj2Va+o5fBwywpt37uPxONzzZ25sEjhGdD5Q2MLmhOYXuDAwlEMCjkkAFvGKQERsUB4FLlIdIpEPTBvYDHlwEDwH0AoBA2QUG5oaiGMRmiBA2OCyw+Yc9AwFqGmTBeNXNC2X2SRTMyAmKaCtzPoF4wuboMzrZXv/oGIXxC0Errf/0v/76/7PbuswJom3J42ZlopoN1N/+pStv//v//XizSk0uh1xlemDYYHkojmIIDP4RAuWAaMN1SMkgySzIgHUoAgIdNhw1H0v0QhjVxAMhQuZhDLIET1JMaYK10tY3RCIt+4Son/Wa+kXYWvmtFJ974t9mVSmMyRyYjE4rGY4150GVPRbd80HWMkJuHMH4WEc8mRCRYuMrFdFAQXHPFyC4CODhBYkJcAwCTBEgxQA7gMoOsNsTUO0NoTgJhLBND+UiLlkqGjl46igpSKmppLeaX6Tstbq//+fNiDjOGykP//////qSWsul1ZxlW3f///pJf////7OmUwBrwwysKAQYOkCeI4EPCmYFAgSAGYIAeY4rOaeB6YCAQvkwBAhZgjHSJcLXo2TxklEEFToLeo4mkOOACr3zGQAwNAUcEhxAcjO5b2TbrP+kQYkSw5egOPxa5XwuXmgoAm7wM+HHTyfV7XBcF1C2TpFw5YPkBsGCA41BrFkjBwoEsVA+UulUY0tkFEFw40OgAcMAATAk9AWDgNBAsYAtDD0hAYfQx46BMSVIuViDDpJwsG5PJpsYool9FFlMcTQdZrppLRRqS0V7W/1HXC9BfJN3X/ud/+t1Lrbd92vWtBjE6QYyUUabXv3f/+2tX+r///7yHIgAAVLKoZVuCg3PqRYaGKGSuG7GLQMGaxQaLLQdMKnaxcJKdC0ZuvzC4Yhd1msQXY6i50E7yO/DECs5fxlUqirtqZSibkEoy7u9PWX8fuBZigk8rhmggmzMz51iHDYImRIUMM2mRUtEkWCkXy4gT4pxufHQHfEhC6YcAB74AfALIR2CCApYTiKOM8MqVWTMECgUSXaotKQUpBkkaVu3RUv///0CQIuJsNXb/oMj/9l0Uqu6mRoqoFF1GZUTeqmzJf//+g/////+pSjwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAg2jUoD2qNwuXGponMNbiGCNSgvbo3LQcalxc1NuJbB7HBYAcwOAMDUaJVGgoBAAWDgOBGAAYHxWpgWAmgEAYcAIAQGYjGha2UPAMRAJYOIH5NHKDDJFMRZrNGamACJsuE3UzsMGlV5CgBICDZ8qg4s3GNHPMNDcqTyb5HIY85qt7sl+CwEk8Pr0W8w9rMwwl+6cjxzRDhQAQgRbCdGwJ2Fxi3jWFRE6E8JxFuIIIHFwE0HwCUwAiIEAAGfQADSATRAIQgYIAAaAAwpUshkULqA3ookgPg4L0UchDUvE2mSJWZJIukyR5uzOtBFabUUGpopqZ22R1/oJIlULKhJkjBb1/1P/+3/Uuvup1EcXScLZqbGiTopPai//1vrr/////5kMaigAADrTMeUdJREbDm5CBH8YWKgUwinzKQhTKbu6DQSUYsZIRpKb4n0pE60Ayp04215w39fxiC7mW0ERjkPvllTwhrPJmfkP8qyu/auVH1frk3TUUvjs1A9Malwoi2GFG00KTE0bDAcQ4UCKNhOJUf0B7CDgS8ElBOgHSCXAbQkoNooDEHakOUcZ6zGjkgfWybNopPXS7dfWtS6v//TODFBbTX/6l///9fZXoutBz6k1//////////6yo+AMPPyzYIABMD0DY04QKDCZAPMCAAkiAvMBUAcwUhbTEXArMCgAMKgAuPKyRVMVBzARwwcCMUBQBhgULIhRNmJKxDQnKlJrEdwyYwJA5DdNeCluOwX2aY3jOw6gfhnLIGsxWirU9WVqxBgPguaL07kPGzN+3IZRDZIkFEpC3jjEZjhDtjTFCikjci4hIMkJ4lwg4goPoL5hIGA0JAwpIDIRwEwAMo5AwZIDFjw2kMhCQhmw9MehaRO5eNBtGIyRqTBoZDsZBSjYskDSRUgm51fM1III0matalKX/1ni8GWQ9Qky2z/3TS//ZWm6+v6lIHETIfyLEqXi+lW6db7X9v1rskg///U3//YniILgDVoILWQFR2Zl6RgMJpIqGkAVMTOUyyFwACAgNGAgSiY1kSLCMGsKQhjF8nYg67D7uoqMRa9DLztLYIhdKYUpy6bhv/BUBsW7JbUsv6tzFC+jjtSa66D70rvRWghmrG66RQGSFACqHOFqFoMDouEvk+WRojhLxJDGjuJ4XKMIcAYnAwxA8sABIC3AMIhcIdIKKHREEFwD8kSpVKxwmiIufWUTZTJKRSQdamUtX3d+z9fb+uWxTTpsi3/pf///9e9qZkkeSuyrf////////9EmnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIX41KDXaABMcRqaOuUAAkJkE6GVoAA05IJ0srQAAAS/5CABgUBxhYLhiwTJ/kwA0AYkIhgCCph8SxngVBsGOZiOAJEDbWlVwoE40JY/A2yA0yQDpaAeTAaLiUDYbAGCEBdwfQmSCAbU2DdgOPhi4MUFkP8GpibyQRA0Y8gw0yHDKniJlgmRmBlheA2MC0CdxIiJCbhjiHDLCmk+IsMIZ8P1C5knQxEPZSEMD4hOpOEYMcMsKFMh9h+xaRHaOSBiQYzgGCfgZbOByiwGWCgIAAiGh7IauCx0QHIwWaUB1kMGqOkhhokfJREgTIzc1KzGJoddJb1KRN1qutTVqf2/ZaJ0WMTU+tv+tSv19b3rQf0kXZ9ZguRUWakau6ToX//+p11LX/////XkwiAAAALDcXcAKA4xsVDd0PMViUweB3nCweCCyZpB4KB6q6CKGkXL4koZ+G7Ay6MBpQLGUibIePkvmx8cJkF0BB5KFEZ8XhiRYwJMXAg5QJ9JFZlKJNjHGLE4R5sR5uokCaLpccfRFyUL5OkSTJkonyKl8ySL0zMThDxkiKB+w7AdLCx8UUNCDIInIT+H+TMCqfL5obouiZIqRTbTUiyTr7t1////qPjcJOn/3WZs3/dXSs11aPUmeUooOtBboX////v/////2PJh0gGaTUAYCwMbzkZMDKUvAOxAGF1oBkgHgY9S4GiRCBhwNBcAJUAwHRYwDQIEwKAoGAajgPAgDQgATYGUNC3C2Dki4ybFqAUWAWMA2yDjkBzwugFlRYhdMBQABngAWfDiloIjLk8WmI4bA7yaHkZsZ8aRbLpeOEPHyOcmRBMbRFA9wLFCHniQJ8zJo4PgMHBcgQwpEkbDHAOEBfYUCRASgSxPBgQDOiAMsCQTK6RpXl8aZw1RTqYDqEgMqLC0AAIIHwhaeAcDEiDGGq3+v/CxQT2JzDpxjB2CDBlyTHeRQxX//m//9i4Q8cYceLIOlEiQ4BcCM6Vqk0////6kEv//+vJwcxiJi4ykRAXAUyJjjIwiA4CbK5JlxNi+bkuTi0TdAAAADgACoCAIhAfoBjlQBZ0DG6bAJAAGASYAE0AMElcA58AZCGgm8UAUSiFyxOgN1QFFAN0ANQFAoGBsFjYHGdIgM4OYKSJgVgNVj8K8Q8WWVS8OYPZcGgPmosD5LqaRw1IKaOcIqcKRIFomyYIwjS4bJE6bHyBlIjh9kHPHUzUh4OLipkyiWTAA0WKKL5yYQF8BAWFnJmTCBdXZ5Ex5LKRw0pykRBZfUyDOgx2tauqipl39NVt/Wbf/yPPf/yjQt/+ZIf//9LrTRf//+putF/+//0sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACcqQVIZWgACcUgoQyjQAJEZBQhlaAAM/yCmDKUAADkAMCjMZsDAA5IsAAFgUPwGRjEBmkBgmnALNsDDIEAoIwkAgChwIyBZSgQAgpMGwUCIGGMw9kLIQUGgSUiCwpYNuDFQucomYBIURyGFADgYEQYbAM8KHC1kOVLxeHcLsrCyw9AUsQY4XyHCfSmTBRIEHpjPjgEpi1jqIkXCJjpLrlJIrE6dYj0SoYDuEBQNy1KB4dBZFJCfgIXziZNEeo3AWPgAMQTIAGgxS4oETwQwZYY0PoMyRAzNywk8MKlovk+eU5ekFIQixAkymTJOFcmjMoFplopI0ajIqa2tzQuk0IKCMB/IoRUmhlx1kmThOl5KcDAwIlpsq5dHUnvwxeIXJ5ekXfM0jUoSsYnTxkcNjUxND5kmThQIgblgzNDVRf5sk2pv0lJDHjYWeqOP5dRS7fo3FCoqbU8+BqporwBo4ugPEg6SCzsFNoEDIMYDIhiQYZHlEOCJsSYBpEElDIvDqMsdpqXSRQVDmGRPHIOwtWgUjbnEED6KOibKWpEnILPHFtZWuz6TnTogoFBAFhdcxKIEdrVYTYQYYo9DAvGa0Uj6T6+UnZvpOiupTsuv/7/86ktM6pNJaCmd66zEW31/yYYN/1Unt/+63r/2//6D////5z/C+QGGJwBUAAAYwM6AwLjgFSsBkfYgabBAGGNKBlQQABPEDXAjAXBoGfwuAYBQFN8AIAwMmSCLIY0DGqw1aClEMskuTQs0ghBB3DqFxAZVgFrRMBk4GKEA4MLkC/oGHHhnAjUCgYAUGXxmi6ImGFi+OWsc4CRQXCYkWF650eSDniGl9IrjgJgdY/FYVsQ4+K1OkykRMdpFQIByVNCKEccKQlAhxbMBkBtha+AseAslNxQJwhSYKo5qxLA1SThECWQLheUBIQJRFFGML5MspAlBvOpHfpFVNT28mCqo6qgyrVE2AYXA1YQ3Q2Jq/pBxAXYSL6jRleoZYQBQ6ZbQveoZY2LLVnvrLy0BcoqyMbv5RZDW36NhdDaOP/nL62/fH0kp9WiDUWUQTLlMBxMHAQ/hEQxUA03AOGk0XC8GXAdPAxAFIqJCFADQAIgSC0xBgfGNMPRE4AiBIoNIuAcDGTSAeADjwteDG6vNiKFQrqGSGEakgJSqQamTgrQtHyqH6CEo54m0TiJEIJd000hYCJqIoJTGaDGgjEXQlIZIiACwgDMvRmyfTQ+DbQRELmyLkDK8zTAzBEFCIAoIcJFRjiZJ07/9BBn0/LZssvIpTbfqR//TSK/z6qDPWLQRI35MEAPl1m///////+h/r1+r/rKf1pLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAg6hM6HcoAA1XCaYO1QACBSEzQO6o3DW8PngczNuHBYawAwaIDGZuOouQ6wUTDwPgdOp1Dn+kMDjgx2DkjUuhwAigpCyABIIZ0LAAPoABVwoNDEQ4CDihgvyKAFkDTEagiwhygyChaxRRWAsjGeKw5IEBQDR0gpZH0O0sORcmSNI8T2GXR6GRLhXFyjcKxdEfC2irNjpUHOBvcaQj4OqNkeyMIwQVDqD7GZELDSKKAnsU4fI5o5IGCDAWDg4uBgSQGWIgUOgiJgWhjBD9CYDuDqFCC4RCUZwWeQMgQy4/k0ViixwumilFI6aF9bM7MiX2ZSTJIrQdFVmpWdbP9lyVMAsSG8tNm/fWbIHS6xcOGt7U13ZV3+dX0Vt//////3LA61mKfkdflM1TUbjCAmpSBbi6jFRnlTkUGWFZ4lWJSBoBE6Bq4M9D1BRxskCYoClhSIrY2GNHwDAYaqFak0O4WEVgfZIEDJMvOUiZOOay+YGxdLxTHUTZMHi8QFAiRMkwVkTIiI+hcY4SUJ8cJHEwViGkwQYnSKESQL48kCHOGiKSDVooAAR+BgiIYyCACF/A2oTaQIUmLaK1KR8hqisTJSImbIqLxiYJIrWxnZKyklodF0d6l3+3/y8UQx0WNkH/9TqQIuaLZJbXXr/+r6H//////qOkUQNyXxI7LIkyRUEgsOJkL5ZkILpgKB0+ncYUAubiRylWkYwkmcEx0wkcWgmADr8RnAPgjDM3TodR3ncYGmLPy5nQO9mCEr1DAybyRLAFTQhyU5xCoJjl6Ktja7Z3ZjlPCFzIYTqon/ygqFvPFyPJ8c0ihXI4jiGh6whYTkF1IggLgHyRUYhJBq4vECG4UB9CWloWYBQCNATkAkgBg4IHGYi5AJAAAiQFjIWZEBQ24REQgGmaEkKkQQnCWIgThcPHCsSVjhqdLBPG6SlpHzM47KTNTRmQU7O1r0lL/rNTUmBCAiBkYt/VumdMiQIkaIlxJ03RRUtf/39l/////2+qicNHLQ38gFDWN+QNPDgYbFHRNVSIFqoNACoKMawskACA4CgQmXaSAiUfGdIzSkU/Yq/dK0p1WGShyFOHkiYMFFvZC1KFPO8jbPRtnLWYNiMZtTXZVnS0tLflj60UtisxSRCHiMNCImhYUS5BiimJGQEmiccmikVk3HGSJER8lIvGxIh0hTAksHxBq4DiIWUaAQAQcQiHsPVEfFgzL5aOlxI6ZmLuS57WpAsmJqza2Zukktka///8gIs0N0FxidMnf/qRWs0J08ykaK17//MW8yS/0f///S/VLorU8/Mm+SAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAIGI3Mg7ujcNJQecB3U24flhEwD26NwybCJwnNTbiLPYs8MAwwzCE34Us2/BMDCILAWkQNAWbEwQYfgWKgMW9ayHIQOEA4sSGHAEkABHOET0SgLH3VfxHdRYFCDdnXVpM6EC3wIAWGtUbUuTCUcJp/xQaKD2YqOu3s3OS6mjzvRUvc/MNxqna3DMddsdwuEQRIkkPgZAGx4bAbaGIy8gHJiVFsZwXKLURhPENHIFvFKitQwEGTAVJB0gB0oDL2wFIIGADh2QAAwLLDEWIUUcsG6BBS+MAZkkyyMwPkiJ0gRKDTNTVlIHllwqI6STMylILTTTNdS1f/67lgrDKiBjRSH/eZFxEXRoamZsgtO6SCbf6qvp//////+xgRQrN1f+03lMSbqh2KgZmAsLmBwYpPUjiFUAQolRWCoIAlmruWSqimUrlztPEVFXbxqWxuwvpSLpPez6DVGhAMX/DjyKv0uiXO8/6HsWmrTzTEhz7MWZp8az+S6NyyH6SahoY0mUiJsgTBSTNRzSDE0TQwCiTZgTpsN4aJsLSO+YidgtDDVIWsAb2AF1AbwGLwt6FbkVFBClh2jPDNHywWCCFhMmEXNUzI1utkTMqOmgp2SW2mkp1LWl///OKJsXhDE7f+k5imiiy0nqbf/9f///////UsyIf62tLxIQACABsRhAGDsmMYWoQAyAqp0DgClVDGcIpFgGRgAdF8OGi+ANTB5ZR7BAmDikgog57SWUIXtLXYlS+Uk5pvzQx0KAqfBa5N6NNGaQ1W25RALDx7Fmnz0owlWdM9mbJlF2ENtMw89LtOxExCYQmIkOohTYmg5MrCojpJ0dIsBEh/HofQ4i6mLOIIMyKDPEVD1wbPgCkAQrAN1LANVAIKBbsDKCRAwh4GMAiEIgMP4yxByPIOQwapfIAUC2Vjc4gfu6LMmgYs6qq5so2WpaaDrvV/+s4oZUSYdTrZ1/7IOTBDTE3LrMi60W2vt9/0W//////rSOFAC/yD0gABlqihbFAwPm1jybxAZEEFfPFDRgqKmFwCspbSQbaDJJEd7F8o/jENk8ff+xRPvFllSu3HXdMGBaoveUU001+FuUuV96fucfne6q38pTKnhgdpUFRmWzNBHiOLRKGBdTNyeIgQ0tiisQYgw75Mk8UiLosXygYk+LCOQGXxQIekAZYBYoIAizg1Ea54kxUCgQUrmB0poGRfUmpzY+/QO2XU1TtoKWzmiS6Skerb/UQ4iQdYb1X/7stEpnjlWpv//9f//////4+/+WAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH4oRLg7ujcNkwqZB3U24gRhMsD26Nw19CpkHNUbh+WpJ4DQNhg8HMZHHEwQBhHmAgIFQCgKBBtHEBgyDoIAYoBZAKFAgsNgWB1Tg4NTXEFgBiJJtLxtrbxrvUtZQ2JYUzQwpY8W9cprqE1JZ5XSSjC4sVkkdj0plU/lceP6RKkUAWhNOYPGHi5MtKFmjhFcKYtixwh7QlMY4QGDexCQrkREnFKGwxxFSaJs6KTIsTY1REA98AIABjQgGFpgcIWBwSoGAIgKEACQ4W8B+gfcQAIgRRiRMiZJ4pEmRFE0H8diSbUywolzikWRUtA1rMEF0kFWderq/3OE2UjwzKSX/0VIsMwQMnjZFJBFff/qr+v//////2mD/5EIqhp0VtDgDjIlBbIjGUShgAVsWSqCRiarQQHzljwACRomDqXlAIuhEUqyC2Bk6MTjQqOSVdsUYK8+MKAAxq0XVRXA27KZqTr4VVU/Xlmssr9yrH6SGZ1wn5lWDxR5zuEgLiFymZeKhPIjsEfDhHoiY+xwmRNDnkYOIdyRBi6MgRUqiMxKQInA21A2zAU8FjocQAcklhAIRML3DqGIOEtl8nzQrk4UjyZotaKWfNVl5OtaCnT6Sk70+r3/+syJoLCh2qR/+mtBAxMqDrp1f//6///////lkhht/zDKVlEAApKBAQhKmEQr2YIgUYVAgRzU3BIGRkBEXlAPyoisANiS5AswDT+gW8wCAhnEBQul202UR1VEMEmMzUDu8ZuemMgghCBoSfVIYOA0C3/Y6+4qLEzhBbUJC7tJKMI9QyRkQMAo06TfOrHF4OU44s4h4p455DxXBxkuAuAIMK+kQMQhEeEUGOIYLkGmMaRUi5iGxDoIKJOAgaF6AbBoGKZAsXAEEARGCWg3XFvBuEJAydHoT+NAg5GjgPChRzFF48OkkVmNRgkUiw61KXpo1nFKTepFf/ZX06im4NjAsgnzS9fvrWfNi+blw4y00UtNCvS9f9SH//////SMS4pv8kmWyJzE4wgSnRTwUl0OG6EAsAGqmBneYCAZVArD0kVeAEaLG0606UohHZVEoBR1aCIOGpTFIKUVWbM3ImqiyOHVeSKngporzSx2nuqXK+6+rkLZ9NN5Fn3fWHc4dL5EiaLhXOoCDRgjSE4C0DjGkMeMgXUVFwioyw5xOE6PJBBcgN2BaWBgQIGnMga0IDQiHeGVAsAPixBfAUYZ4lidLhcRJI8UCWMD6CjZVS6CatOtBSHY51UK///SQJQRyQFN7f9aCnIAXjVJbU0W1//X///////8xKp7/jwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACA+ESoO7o3DSEJmAd1RuIGITKg9ujcNkwmYBzVG4a8v1FoaCkxTAgPNU5TAoDEoAgzRQIAcOE4UAwbKHLPHAJRUycaJsYEAT7kRMCcoWWnSBwHAEOrZBwCkSLA6lqvzJjoxAZDgQOCErUKl5MzQJraWGFQgigbkKZZVu5alszK04S1SkVhXjpow/E+2hAQxZKpSF0GIg2kS0OUDfRdhtIpcY8ZYgIsgcBbDYBqlcOsR5AiLCE4baAUVBzIDTygGBwNVwNzgGC4ucUUY0SMQMJ2DbSWImamwm8dxRLhOuXy0TpuikkcLxsbqWlVSNFziRmxoecws2p6v/SWPsCw4fJbOt3/QWfSGsgUWLiqkXpdav6/uv//////yyJ1MVfW4dDLxLZKoDDgomCWAmGAglUBnKYswoxTRIeA0KgGvxg5bIRH4MJR7DF8heyTCx4U9S76CBUQ55mjfRcmFF/lQqEy57bK2og6K7WPLfn6Kbxs85S3JdQ6jcDzz90Uhag3cXIQUwIgSRKDIjrGYEKibBiHxmGF6VkSIlRESgaC0jJoGQggKBC/wNhQFmYFBwagDeIKDR3ClBNBJBzS6MmySBGlonTZEuLUXTVnu7XTSpupl22VS///6i4UC8LMqb/1qUYnbou3W//////////6lKN/82ypZJVACJQIwoEcYH6yRgjg4AUCNW5EAFAlmO0NOYEgDYkBCYAIBZKEhcFIGEORgoMNdQUAt0gtAb9vvebGPAoqGN1iaNpi5W9wkJKkFASC1TKVKqMyT6QREz7SOI8s/IbszQzdE6yM4iAWpROeboxWmphgGgzwwh/JQP0EmDVADxAjkSgMkMYbEGGiLkiuEcYkOGSICOgTuF/QDAgXAAZMKBgYQGwBAZQOH3AMUk4DUGRES8WERmI2L4zZecSmTJXcuGxsXE6SjBM+XlOtBb6LKRPtSPpXdWuu9/qWovkcF/CUWml/6kDEwKxOG6RfZ1tTUt6/9/rf//////oLIRjv8M1y6Qucq0aFxzgHBI/HhYuMIB6CpkSghwJbOzhWdVogOjQhRAu8JFyCuRIlvPjbnIfV1BCckJZgTBFVMFjRdgTMmiX4HcFzUsr0Ezj2441+0tFAzOX8xkd6KVa8tH8i42ycL5OkPE6FgXKPgZMkCLEFQMyqO0rEQJgnBSJRJshowgslEIAFBIGMCgYhaF1QFhIkoWhjQFPEaCkxCw7yTTPF8uG5Il2mcTWbJrmSJqzKRa6Ta0U3W96v//rKR0h4stF3/9SZxZSJ84pbqSosv/////////62TK3+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAiEhEmDu6Nwz/CZgXdSbh++NyoPbo3DVMHlwb1RuGWrOIgFKAyDCtO8x9O9AaAxdlAckwejIgHJbuDoAGCYJoomAhhQGCJvpACAgYxDiQxHWCgiq8INi+9dayWhMJsNdaNGkGRiQeskvYklPy9D5DVuFZ8iKlbAyxoMCwiBYg2OSOukCpShmoY5LTVhZYsK0chodUnzMV8U4qEQC0YLeR5E2BqkhAxWR4rcggyIs4PzFwihhcIgkM+GOilwBgYNgwCTgAN6BtkQG+FgMVQuZAIEg0JClg6YG4hMRdlwhpuQhUGaL5ZMSccgJVdkDZyLkUW73MDJS0ZubJVputKt1bf7WNETIAoSRUkzi17V9jBFMaiZZIadMzE2SRRo+pfr/rR//////8fY4WP+0uYYkApVBLVCUAyoGhhbORgGISfqhishgaA5iiUlOOAYpQBhiPTKShYIgcHlUGVLqklsxl9pbCHuaCnzKXFTzc5L5/noeiXOjVg2Uuy82EGR2Q5ZWIcn7/zcjbjOWHfguJVyNK44iCqNxZAuIqigSTHAXDMUMYEOFnFdIaxCsO4unzAagFSEuEdgEeA4QsOEsCmB5CMGCLKI0ZYiLy+cNjUlCdWisvJqUikmnVfqS1s6ltZJO///mJdL4bgTlTSf/0qkjRJd07f9f/1f/////9eRY+4LCkXSwAwVQizAwSrEIUoUAeJQFxGACFgDzE8EnT4LJF/XLiYWMQxdEAGRFoQcliQJjxJ1QaLR8VAGjXVetagEy0hAIcgokO5a9ZW5qkKNyUGyJljUBM/fGlv4SWJw+2xKBP1D7hNcsL9c5ySAjfFgFyEMIkHrBshBQ2YWYLGLkIYKRK5iO0QEIsKUl4XALMLY/By4RGA3SAeHAy9kDZmwMyHBZ6BlAYf8NJFfCxQVqKiPkY4hpuOcZDOEWWTiZ0tE+6KlnS2TtBaGmroJPZNHV1Lf/rnURySKh9DY1Wr/dSJicGfKJopJSakG2VX//sl//////1l0mD7P//z6JbFnlVqFjU/9pP6CyYbWaoCnucJbgkATOFgoDC0uy1CTKHiNaiRDhAy9m7Xnlj6b7AovGYq1qUp3KWuzDa7loN6y+ZcB9XP5P0tJf5XoJ2BXnVsbE0p3rt50olLisRcc9AvlYpi7E7EQFxkRFHJ8lSHk0To+x2DkokVHUMI2GaF+M0Fr4ERgUoAHCgmUEphq8g4fuKBE8jQGkM4Vy8S5WOSDGB5kSVNK1rmFk1rWqjapSCHt//+xqR5BjVFf/rrUZFQ0RPGiN07f3+////////sWQl/igAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHa4RKg5ujcM4QmYB3VG4gTYkoFe2AA1hCJgK5QAB3m1VEPA0xiDD9hGPehgaMgKA6L5h4PnfZ8EH0rCziMHHQBACNIIWAk6AsFgyaGkEVAFzN/SkgEJBS6m40Y4BmHEgUBEyUq0rnW6orKFAoq18oVJcze7u7SWpe/kUagg0moo5QSunbebiYwRkRCYfhgGhdIAQwbIjwXKKSFlBhQaJMEQH0Qwa5fJ0jRlRtj6G2LEAoYBoHAz58ACcCioAowCxkPgFeDcC5hyScICOEc0vkGHcViNLSj5Ml1I+9E6i6CJ1FBkLPMqNGtT/6v+lH2L8cKbf/pSONSRMjBmoIq/r/////////MC2b/pJSmPNlTsC4UmE0UmE4Qp+KLjgAmBgGmS5DGCIHvgm2Xmcgvc0hWtJVtSW2JK0s1Y6kDuDORPOC3MUsJBDmpURV9rDKcJA88sXHh8MxWmrcu3YKlD4tmisWtv8+leGBwESI4rj0eI4ZIbY6SbMC+XRmzMniDEfYqmpMGBIksLOHWM2AYCAy6QDKgQaAQaBRCELQQ1cIGC6IyJFxyS2YniobrLRkmsxY42ikbKf10k9afX///1F5ESYq7v/67lE+6dbK9///2//////6zE2b/QrHQAABQwEAADAgBSMPtI4wDAnDBEAACAATAKA+MGQGwxyBtzArBLMDECNGlHoWABWUROkGoBQqSBSkBRSFAhKx9oJQ+EIRJQqBy+AQKTwOguNBSXL5q2Ps9jk9AoGPMDEIou2Xyy3ubiMPsHUHTwdVkMtdlYWHZumjsDPzDsGS1t1jKbLokMyxBpk3Emh1XZrPrG2NOzTxSTp0ltQuEmmHhhRuYOBEogiWiIrNDKWqTbVU8ZVBkWgqWNivzsjvy+d5fx5q7XtU+Oeu9/mfd8wx13LefOf//zf//////7zv0kTsz9vuP//////48kj8yC3fq9B0+dFko2////hgUd+VLlYfht3gACjDhQN+BI4yTTEoZKwSXQMABA1MezGIZDAmgIaClQYECAi4csHQgJCgIihRmIVEEyFIMPkOyH/GsK0EQD0Q6MUiNNNlhjcXxGDSMxA5NmSJXTSMDc6UC2Okri3kGHwSBBx3Hy8OYViAFYniwiMAtEoOSRYh4xpFyqUUzMciYEuTBoTAr4pEbgLFgMelAkrAUIBb+Fk4uQWaI+I0uCjE0meJVEoyqYInjEvP1T6KDWr/qZfVV//61F8SgZO3/2ZSyaRSQZ1PV//////////pm3+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAC2WQUwZWoACAsgpQyigAJIJBPh3KAAJ1ranTsPACIgAaAgFgAA8yi5wHF0HFkCoaAxaBQMWKgEWvAEVBEyeA1MMAMUg0FISEgMRAcQEgUBggFghBweQ6T5dCgXAaIwAwwAUBINQGCwNK49GJEw5ADBYEAGCoOBYY6A8Mj+Depisvm5oBIPBpg5wnYOQD9QRAUQRKRIoLc0dMcILA0MqHuCihaGUlDrFAEWSc3WmbpD+OUJSGZLBbGbHSMyeOlkWkgAWvEaUg6QMKEuMwMgX1ABAYDKx2AwgIQMlBsDCoIAUAIXCh8AWjhdEAFGAYjEAkQncR0VT6ZcOm5XQTN1IGiY5wgiKWE9DXFaFA2HWMaOgpJENG+i60S8YughqUgec0NE6CyBlYNWFokCbEFwAQaFpQzIypDBzy8QU4YieikozFtAwYHA09tZnTN0KakGf36kEF603yLECKZFCqRYnSGlAzJ4io7ymO8ghOkWJkmSYL5PEVKRNF8uMukp0h9l01yIhAAEfaW0K5iYEcBR4WABUSAW2BZECBADbYN+BZwG5FzFwXOSJCmYbiEMApFTQ6TEKDUbnIXHw1I0UlHxiEFDm0Jc1Uc7Uwx2LS5jnJ1zUMMYwQJxqHXED+aPCQfHrXIQFxWCmHpxx5hwOiJWv//dlr///Vf/z1OoQNT9e4/b///+v///////9f/+SKma8tMwoOTG1RPqo4zaQAUKgKEDA4kM14A0y/zHwbxL/CAHhAVAwi8G6IGMLgZwCFnQMEGA4RMAISINFmiolYZUPlHCbCnA1AAYocBkWgAwoLqh3izx8k+VCLCgBgAGihOItwoo+BCxTNRZwxxKCkiBjdDCpYKQ+hziks0NBcJbMxSJHkVIiRAsECMxlz5iYniAk6bpEkIWEpCgky2US6LhFFGiBEABkTQEu4ICYcmK4GXx3GgrcZ8rCgh3EBSKBEjCal0llJIjGjtRUpzIjRKJsxqeQQrd06RkZJNVSf62cjSdR+omhlhKRBwHggM66ASFGyXi8bUXWj/Mn6SaN//v6JDSEdFv6ki8Xj4zwj8BoCQU1SSf/1P0SiQiX/9FEhpVRCAAAAH7sYtkGABjXj3K2VqZrAKCOQ1hnDXDjT5c0LUbOh6jZ2TUNPmmo2NXq9WIYTg6GR4wKxkZ1er394b9/HpTWb3+KP2N/d+xv37948VkSmX8+oDArGR48ePHj+PDf3pTUBD1G5qQGAACBSIkqEJwnB0GgqICsiX/pSmvS973v/jW////////////////m996///93kxP////6w+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhee84DuqNwv+9qhGXzbp9V7zgO5o3DcMNoEcxRuK1DHGNqACOITU8fhQA0jnRR/MU0EOzQAAxNmAgFCoUHC1hCAaJPkckNBImASR/1I4KjaJMgiSZBe9XytSjxeIzK8zwlvYHQ6vayFVJFiLsFY2Ilq9ZqXtPlVNZlj+Q1RNhehfbYnzhiPCtRxDMisj4EbienJEtEDDCAkg9hq4NsEbFAZwWYIQjJCNBZgs8RwJkRUcIY0HYQMiweyBkggWQAMBQNElBMkFrYWkAZgwQQMgDsFZEEhkxS4atJ0TUhhNj8TI/ESJ0iqSJFycdkiUJghxJIpJuqdoJLVTNaJfVelWdPnUyHFu5XWm6nUWy4Yg0FB8xLnDP//////1Oqi231LWdFPIRISf8b/kyAAAAB+9bgJQIDuU2TTHZLnhK7dmqocL0u5G08J6awxVGC0NlvS0SjCdRuKuQ+W0JMap1m8ozqeGW2xkQxT1gRJ841WPCs5N3VD+MaG5DiyTR8qF9BIjDcY4nBmSmQhKk4XSsam5fKhHlw1PERKZoMwS4gsH5CBgA3gXQBJITCKTDFSAn4U4h4xxUJIzKhTPEykSJ1klmTO2tNNal2Wgpl66tTLt6l2LqboILoragsuiEZfPrb//////6t//qUXFU0zBTPRkDjACDTLYZjAQC1NUq1smAppm3pQGBIAhACBcFnCA5ACRxCINvHMGCTU8exvH2cdsz0QXYh2WNkNhgFH0TQI0sG0hW18rznM7M4lRminHBmqXHKYwtsFdtRlnDzQ5TEGJ0dhDRyTQZkbBbJotigg2sVqQEP0IGLaVB3FMUqREQsYEVI02GfHIMUxSANnRMQ5cAgSBlVYGRKAZQKAcpAUChcsP1Fkh+4hIOWGrTc2FdGZGiiOcO9B1GRaNDZaJiimTRsghXUgXVLsbHUqSFNmd6VlEMLpsbOyqlzIpEVJoOcVlG3//////0qmTWr/RcxJFkf8j/kSAAAAB3ncGFl2ToQNQtgd1hGAiFEmACA1EBAouM0eqlwv5TZpyzRkRUO1pnL9wFD1yZacpJv3xV0CL0EskMLYLGZFG/mWtU03IZqnz3YiU9WyocnJs5bNimP5dJA3Ky2PGxZIikVR3RziYJ5IixMlMnSKk+ZnCsXiuIDCew2UTgMsBspoGuOgsZFmi3CAog4QWOCFiLlA0OlI3NSalI6gksmS8bbzE1XSU62uvmqklXo+tWoc4rOkyTIrZZqZG4Dgohpqia///1f//6ydZaKP/VMBCYnnS///rNf8kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHP3rNg7mjcO+vebBzdG4dLe8yDuqNw6895oHN0bi1OyJ5UkjD4/TsYFBIJG5rVLvGAyMm5wmGBgHphkwjWAUCMZA5pNqBy1BCICU4eXFLYflamLlo3z7ZILNMlla1lhsmGO2uVn70Q83QKoVJh6n3kct5XrZWqJnbYG/cutUFsNh9ojjGWIUhh9MmxZAsZARZom0W8lRUBZBFSiRxgTRKDoL5TIMOcQcuBsodIEIsQaBmUIFqwBQsZoG3wBiwfYMQD6FkkDDpi8UyELpTIadNycUxNEKWDLQOKJg/SUp0anpLTqdJm69S0k0SqbKTNWXdZ5ieLg0XSR//r////6XX/6mKjv/VTTMFMJJQYYB/ZlYoEABaw6csMBmkz+TBUJmDwAghDAUFCoMAysJdtegoBEIYcUboDI+j7XfMUApauNlL/vaYmAkQYLCDzQAgTbGzRikpcFpAUJHepb0sgKfpMbFBH6RyXQgh0n9oy8TxsRouBIkidN0xzhyBmx/LgoxdIiOwXET6hZg+i0N0gpsWBGgzQ5YzoYCAQBBCDAkeARRAwwkOSHIBQOAwDIoQIN9GSEmFLkiTxFRkC6VCLkcTpUJpAmT6SqSKZ00oproJPvW6dNnVe9Z9M8TRg1kN0WdMmBIhLB7u23/////9el//RKP/yH6785A7BAUAZiUbh7oNYYICfbdQMDxiYNR2kGY0JhQB5agMEjw4Kxig/BFOJHUAJpxzpMnW7CatZNCOOfcfs0AYLGkPkT3tYLBsCMSgR9VdDQNLGmlGUvo60zMSO2tCVpARmUQxiMOOkzGMHyK6OksEqOSMaOIS4ZYlw8ZAiZHEVCbJwXMRMWeo8MaMEmSwRIfyHBfYS4DJARawGKQ+woqIoXwtkGrBfkRJAfJESKjAPJGpfNpcLxQdPSWgbF52R7GLpOtla0r27pzxASGucTRTMlOzLNhQocYaqf7f/////6KP/UkkXiQR/9NNKYkyEVAhgT/n+h4Cgy3RWwmAZgYylGJYmVgQOABYHX+uYSU03FViUFBoEdSCqBO8wR74ImWVEQFGuPUHIBgYCnyqttasAyhHh3WlMtVEoxLpbL6WzllSyuxDUQhDLLMRhSAthMi7JwZ0gB40TKjC4yJEmJyHkjBhl0liGlkrGo5A5xIkyLoqkeOSGAgRGwwcA8IBpiJEAM8BAJHBb4FtRHIXBJiijljljsWQQgQ4yaKQ+aSRw0Rdl580Y+pGnW6OgbXuaoJ0l1rc1LhMmhio1WtSSKZkYpphb2kgv//////9qOpv60i+PV3/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACCl7y4Pao3DXL3mgczRuHbnvMA7qjcMYPabBzM24vzj9q4MA0AUwaAkjTEAzBQGgsAmFQDAaBGYEAvhi6BkmAYBoYCIApdBCIAhRFWNWCigGFFlCobPhcEjIkGnp6KO+0JCSng3BN04oEuRKRUG0pJ1DmiY+K8WesXBEFy2xN/TQXPdyiEjyWww5TOGnagR2xsmwsZMDLl4WWO0XMYjXGsHaJYXCGIRcwsBBhTiZEJiqUBmxzCgcJkaZLF4XIDZ4LGw2IDBCQOgqA4JkDLqgsXAFGCCIDQ4iIfiGXhlTElykiOAvkiNg4TiSJHDml5JGty8PhJJbWorQzJrpsjUva60o4CDl42MlvWkswLJoQ4ip9TP1f6v///+1FV/9S0XNf//00s1EW7EABMQ/Y2yQyECS9dwcBTD60Mqk8AgZK1JIiFSwS+QsTX9ZiMgV1YW8MnnZdSu68Tgv1eeMOHVogZ3VEHibRmTy0zyKJUliVVMc61ytWnn0rMpcuzDPCAEFHOJRYzIyiZqTpSLg4RXhyCLkTL4zZFh6PmpESLFIzJ4iQ5RMF4wEEAahCBgEBAHEwNCGBYWCIqHoB2hhkEDFY2RSI+ycRPpEaZGJDXdaZqYntNBkEkdFv1stLX96CqBibOeZ3psqtYtwW8miLf//////fUr/6y2Vf/quyh205AqCphM5x5kP5gsAiJaTZgUC5hCrxtCV4QCQoAbsK2p9gyUk06DEmvgwYcbWy5nuc5C24CQt8Zp74eKNoNLwKhKkbVlBHieZuNJeMcUJgUw99uNUVW/DWNA3ChKA0MuK/kjLwzhFiFIYSA4SBkaZiUCNDviGl4ckc8ZMTyNMkhulEh5DiaTPEHD4kyDizxQANQwWug28AFaD3gMInDrgsRDbxxg3hGNEClEfI6CUTL5IGhEx20z5SLbmz1mSzMvotovWzaV1upTv9JjYnz5qghTRXW5mXxPIpcnkU///////vtf/rYgho//pxpqV/lhTAdAPGh2BoASKWaYNDglxg4PMIXIwZoSgxM6gRa8v9Ced8icSk7F2lpnxaTUqKdt2W4ySMSh1JuNNQrXXHZPZtwzAtfDLDdrOeiEDwRJaGVEyTKjVimmWDdRNi5iBD5GfNyHGZLkQHtRsTh0+QEnSoUSGlkgAmwNXjIALKA2HALMBbYzAZZDLhWFJCEgj4xIgYGLIHS8gYpGSk1mK2synVq6lK61vrb9S6icNk1LSurSY6MqRE8r///////v/+sxRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgye8qDu6Nw2G95gHdUbh9t6ywO7o3DRD3mQd1NuIi+DCxgBAaH5h17ByIU5gYCwCAcOAvMxZAo8TGQwtAsoBxYw0Ol6gbNKCiEI2YCCCQOfCmBAmPAA8AQuCEXEVhAFJlrpdc00OLkAonQXIAKA4aQ3LZRdmdkxVGEgChdxr9iMVJ+ZsRhryxUJzgq0undFrQNxUDAMbEgRc4YGociLGFzo6A+YZkMbGpDhjR9kHFLloMtDQGKLSMgQMgIx4XBhgwAUyCQEDOWwBgAGUGASLBZGLgEMFgEehYyGqhQ4n0lzVQ5Aro9G5kTpgWi8gfRpooKL6S2RWnOJvdExZNNChfVWaGcnyaSWf1oUDqgmGBvEXZ+n//////706P+lUNIvq/8S/os2p180KTD86hdUyYF0VGuMwMHSRNKwMCoEuGhJRkLItZGjgqDVqMGBUwF7oGGKujTUYy66PD/sgfNx0tWdPOpk0Bsj/xdh7+OFMMzeeSYUkbw5nVpK1JH4W5Fy7DZRI0aBFxUS4cHknkhoEVFKikxZweyPSYzxIDGEyQ8wLZfFJDeIMMeO6O4PyDkwbmAgEAQbAGCA20BAANBFnCGC1ijjNCkxnjyZdRICxOqKKkpcSTetNVmQppspaV7sy1dXWnTMTc+kk6NmtQWVRa0bf//////7N/9aRo8ZgJ0UyhADphPtBrSTIMBJQVpqAkwfUEz3IwwECMiBwFC5cpDsCTIMPCwKMMLumEB5zhYgaLAbHWqNAUOTXEIC/kvh0w4pWeAgWIKYLrgC05rHq0LMHO0IYIikDR2Q8rU1JQbeVEVOKimJEK6fHGMcRBEoC5i8RMZcQGEBg90A4UPYpUXAOWVR2kHLZWSFtHYw54s1Mc4YAhKCgcLIQt+A3xsDPCABAwGQBA0JgKJASACUCCCrD3w+MdpGk+aDWJY85MmCKJMGDI0TilpI0nRrUk86cnqLbpLvZJEnifMzc4brXopHybBumZlo+///////9aPX+zIkAMu/5TluWQ+ugwREU4lBoOBNiCCFK4qEuZDCkxNwGOLSbcVDlBFKx8E7lvHDTr2Zo88Pwtebmt1UvnWUIclFG6M1cmLPe28alEXdNbTZ7MWp4Vnl9atNU7+0sOQBRdIuXTUql4h42jyBdIwmRoEYRpgM0Zl0c83IYQQei6RQullxmikWiuJRBwAzgL4BegDF8SwGBElEAjEc4QWHSKodrnzaeSMyAl91pHU0NJjp1FlrVvfZFnuylb91nTEwWztrumUCqJsEMT1f//////7f+tymW//kwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHTXrLA7mjcNkveYB3U24dkessDuaNw1c9pgHNUbilnoQ1cmAAxVQoNy8rBsMABP0WAMwyPs20E5HBBENKBAqR7dSOlPZOkoGFh2np8IAZVBOD6ZOE42bkhVIYLBw6yICc5vXkU1h50IABwqUb6RhxoXV7NT1egbi0hhrUHkkcDCtiGDkEeURyxnC8aE0KGFKj5Fnh2xqjPGpPjlMQUd5eL5FCgQ9AZgbA4xJQwiCQUVMBAwDSCgAuAmggmCyUG7QsvEoBrhjBxEHFtJcnDMh5eIYVDdM2kUZaC1ni+kbu6DLda0dkda1b91KQQMjdNN3VRWtA0K4fkxgimn//////+v/+gSxD/1UsqiK+hQDTB2DjMsUUjrQyAKAkwGFkwgBpTgBAaFxKLiYQ6QmSAU1IDCxEMHK6QDxyhtVzMgWFhh3IMgAAmEJMOQE4Urc90nBkXu+AAa/45PU83epu3oGlcEv5Jl8xiVPUUCAkVK46CdKpImhXHATQlIyGqSjlcpi5y4iTZHDgF6MqSAyJFSaL5TEdimChRQgLpAIsAMAERAsuEsHLGiTKRHFAnzMmy8bEWMjMuopIGKLbqWg6N1Vupu67vap+plMbIpueXfWaudKY910v//////9f/1omjf+nkvfxiYkAhiaf56WBAKCcvABgIKgJGJhJG7AXmGwEFvV2lF7ACqOC1Vg1AyqQxBTpNMaWYq90NMoSUaU70Xa8KPg0EMKlymlNKUV1ru5NQEIWG2hh6m7W7FnfLM4uVnyJchbs0awPAz5GrHkaZNj6Kg/lMjRYBlBtloXIOYUxqkoXR4LY6CKkyT5fIQnCyKGD1Q0kPAAsIAaYAWggPKB7wBQAOaOWFr4d8PuTRFhlCwOQaFYi5JDuSKjEwTlN60zU4fec1qQbSdO1PV1WYyJ4romaCa3dTLNzQTERqXXP///////1K/90jhkf/8UpaaMtaQkmCbcfXFaKT5R9RMiABngDIKMTXoJAHHGRA8YQQF2hYIh6fVZI3agHOEMnVBLZdQQSFB6yIMgZ+GkN88i5m5WGiEpqGrFJA05yvrs9YhcBvfD8VyjJAhmiIlUnCBDpchkcoZUR8RcVsQEWSMYNUg5LORMgQ7SKl5EvDcIueGSGXC+gN5QGBIOxAMUQRHhHYWdFmBxRKD7DGA2iqOo0UYGhubFU6kapHS6fXaiVkloKWqpP3ZJXt9SR0ji+bO7IVMqaF0wHatX//////+tX/80RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIqW3LlXdgBsvvWZCuUABrFkFOGUqAAiDIKdMmoAIAAIZw+q5zAMESgEgSVJ2aFBiaII0CSOYXA4wSPgcMcmDt81HmUIqxkIQEdXybmJAIuEL8jS2H8lJACvxBTxRFYphI4nKzNUjO6aVQTQUzpuuLBwsENYzhztJNUFaGaCAXTUctKepYu6btUUrkMEvTg5v277Y3+XPD0axgtypD8OV3cgKN4wTnAM1AOCJaOA6DGIjpnYAPDQKEy76/5Wpm8bsu48svlEpjWUv7DuWO79u1lv/7rWt7z7rTX43T8sSyJUlWkymK96rlrd669+mkQAh4xBW92Icxp9Owzh+H3SEU0dSJu3D9PrDPOnzzzz/Cnp+6www5nSUmG888+4U9vNoAcAKWXv/f4ms78DOh7QefAMwEUEOUiT5hMUmJaea2PxjwIL1VsAAQMAIIgCYCCbmskYRKRC4yo6BPIqAckAevC34dIyJGFgUIWSDnh4FkCsBdSXBLRZA6hxGBGD7FekIPZuZF4mkUDtA+USJCliAETKBcIkQE2HQQErmZOkkZl8go6C0QwumqBgPlMqls1LzFBFAvl5ycJ0UOF/wGhQGNOANCSsGsDEghMHLCvDqIEPs+QVZkifMjE2qdAwQfUknt1WdXRdX/6aRNXU1+tSJuKWLxog3//////+//6y8MJoBAcxYvFMAZ0BUQBgSgHqCg1QgN1wFD4BRMEQYDICw24aoGGgMHAAkhgSAQGERgCxsAGAYOAIYnDjhSgeoMeLOE5kcJ/DGgXUBjMMii5g7xgQUMWlkRAGxghCVD4y6IWEJh0lEyNjJkRcYZHFHFkCTiOBQILAI6cFIkIGQRhorWsTgLedHGOwjyJikhmESwbFMuE2USadyZYcB4TmNgR2LGRpEy4bE0XCYImRUnVk6YlE8kbOcSMhZZE5FzYnDYnGKhmXSGjmmpiikgbkeUXd2ZdaK0SuTg6wxOCYTAxiPwMdhUEQpAwSBRUwbxjPCPCOJknCiI5AIApBwcKARAcOKEmDLpdE6lU+o8tkywDcoWJlIXRMWFxkBHGTBPDmLJAh5XJ8sE4cRNybNiCE0SBFwxIOxnMGKJeWaIoE0oumK0VLss1OIGYXQBYAmvSrZJHl7/6gwcMil4AAABAAAABmDXJZBujRCtAzoAooDQhZgWsCZpCxE8yA9EkGReIEKcL4uosqsQhpQgNJzJpC43nnl3pbqhiLZ7PbuTk5ASNPNZ7L/YzbPEcEi5LRaj0xW998yyf//8xo/OMJFd/MKCIFgnMYy/zpdtP2cwqIt1OJB4YZX///3////1f7un//6mfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACECIz4dvYAK20Qqu7EgAXg4fPI5ubdtHRCgRrUW53zLK++qlJMMAYIMmoTdJ4SPmLP7DjtqDMhVIYKMGueZkRGY0Al4W6OW6ENSx0HhZSi1CmqwNHmx+7JfQoPnQaHZlEXz7rdp+ZHC85NT1Iecss8yth0Szr14o/0qygqSv1Uu6nrT/qpLPxx7M4yzlXD/1q1crVKmE72Ca2Uvps8MLsuqzWOVaranc4hllV5yvhlLH/tSimnZ+E1MM8q1JM3IboKXcT3cl8trfjYiExvLlrGEMMYPAbtwFKCqAlrU2l9PwrAtBHGT6gCit1aZ+6HlWH5TctzMo5fzw3YzwpeZY5f/fw/nd//NY4d5Z/v/rv///+8Of///6//5//3//+apnaWU2tLoCpVAAAAAAAADW/3h3Xa5CYJROT2+0lusQ4g4BMjiMhyiimPkosRVRMl5MfRNmZYLZgT5CGZofMUHQpFI3NSkZqRRWan1jZJ44VjBy6s0NZaPqdExQRbpKTRU+21bOpOihLs4+itBqKSkl0eyaKJofTPJKLzOXaSNFUydSnUmy1syK2rKSUirFkZkvhngWvkgMEixZHkki4PRdOkiozJFNEvIOjSW62Wp1Kq+zW////////QTJsm5IgAAAAa3rdSPsIZvAJgoQHiAqRDx74TPMoh9ubRQSCG36wsPwDMMsrukxV2GVwAMBCRWNyvHYbgSHhQQJjarBdqrKrNn6OkpYJfzGkp61jEIDXBbaJy9/UzYfaJDVkWLxEEEj5DSbCEQt103SOJmrOhSnVopSuscwrmZMuXi+igaImjm6z6KysdLyTIVm6RcHcViYMzYvKMC8YnD502QczSQMzVB2M2nTORZai4VyNMhW6If0VuHwjKgLwDvBl4hhARjCGCbSLl9RYMigWz5LkXQNFJl1I3RPOg58xTazJTCp/pXS3d/6//9/V+mTCRYg1AAAADnf7ztEqMODAmUY+Ol9E63IYzv2U/zQZkz49UYtGWyuVatS5BqkjMMRZ6ZTQw6WB6hOeMxczq46rTMjzppbaxsfKqCw79mrMqTIMaJKKBQL5qbNKBFycSUmamTMkqijvnE00DSZpHDpkZSq60DFSysxkkmlWyS00TYxSZR0uMxjNTczZTaTywXr0DA0ZpiaGhNDgIYbizCDgG4K8LKSDOXRchOFEaxsXSWKJuRhsx00NzVmdS06KlIUruhQRR/7Uj7N///X//Y4RcP1IMiuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfYiE4FcqACyLEJ9K3QAKBuQUw5SgADaUgogylAAM+4VLzhl5xIdmRQyZMjBjFqmRwuBgm416qvll4ZAAwQEANGOMA0LgSB4og4RxDkkDGMFeOBIKEDYuDPCkxBEWwMiAQFgUIQ5ZGkHIcU1JKI0unxmiNH41dRsbAWEyY3CJEiTpEzMpFxMd5mUjxUMzQqEXCADEkmo6fMUEkr3ZA8kqxGLHKNCKrOE4XHTNlon1FMxOTI4eOoJ0jMxIoRMzl1MgJfQOGhFXSKCjVNZitNN2m1I2NC2tpDykQUvC0CkhyQtCBEDQGBaGWRcIXNwuqEZF5xZ5kK2GkR5HltyqYszHFus8YJIUFIrrWxc//uhb////+tssGx08KnJAAAAH4Ybr077sMWABwefmKF04fi+oazhAuMAwIA7SNwNvLpGDgLgwSiWDo4xUSwyJRLBAyyESIgUnSLoGh82dEyKxqXyOUdTdNExGoJIRUul4rGJNmhokcNSsgZHyiiQ81a9kkvo2W9FCmXEzGZJms+59A+o3ueMXRWy0kKJcUcNZ86edkFzztSTZ0DZSkFqSLrOtjI+mbj2iOYPJID7EEwxiNkghBRolcmkT7rL7lU4igcXpJObKZlr/pK//S//////usdhOGkAgCimssEDIOAIVA7ZYJFgLrAEiwNyjG2PAwCKgY8KHHgELA34BdQCgALNgZwgxwia1jkgHGANokAxwhE8GQjRzoYvPCcA9QNsIIy3UvNU4hcNXifw+Qgo8mJ9NFAZs460JTBtgHKFodhNmZPq81Il8pB+4ZbHeXybInWyCbIoLmfetwuAFKFwPUJxAWWT6dlWaq7XOOmkhVkXN3HPIOkHzigyJmhNqaYJjJDqKylKtqRUcRJktl9JFdHImGXA9SGJBNhTGUIIVDZBiLkX///9vr/2/+n+bqLjGhMFQQgAwQwBoYBmDwGiNAWGA2wBtQMYADBwxONMn0ybHMGUHAGqxZZE5lNJNgZAkBwqgDDMAy6BkBYHPlB6pSIYKoUAXQCBALKgIMB9AEiAUIEiOSNcdZTFoHcLLFvJIjwslGkOsjAaAiLoE6IDjYeXzUzNFsbIrLhgXz5AjU6cNMuIpF5EixZNUTM1MDznl5XLTL6M0bQmKWmpknMTNaVlIJp06SaOpMuGCRxbLUxyZmB1bLWizuaHlUEaaKSBsOIZ4XGgTBGkXTUktSaZAyDhZcKcdIqYH11LWtM0HWLNKo7jJJbuzOi///5YNf1f//3/99ZNm5Axzzc3L6ZcQbUtboIQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJXpBUB2tAAJovquTntAAfcglGlb0ACzLAKrqzMADdLqmlVN3G5Gay2QAJOpCNGIX9dnarsxV2p60/rVRAlPyXBwlMViK6VhVis5YCu6fiTvVFbm/jsOvC7sujsZnIafq0imzl/YZclyX9h2drRqnhlrLXYdlMt7jKbNaNS6XPtDD/p6uQ5UPS6NRqllMzSxmU0stpbtLLbMtiMZf2Mx5w6XHW8LWWOqbKmprWWXKtLy1TZZWtZ7uWrkajUus7/7VqtWlUpjMts40sZs6xuPs5TlgYC+XaXtWzS0tLLZbZyyra+xjjjayy73Wsvxx/9cvamuVtayuy2zzlnHVNTU1WGXCXcsZl0PU12IhQSY1EZkQnmvlIlB1B1CSgFR+UGYk5UPRq1fs00qjUulUNQ9Dz/RmU0uNWZjMps6pqampqamtbyyyyrU1NTWhiAAAB/X+1rQlKhriiwc8OkCjGJNJq0TMlxoBWxOzA6X3puZuxmmdL5vMDRN5mbzMlGUgt0GT9UzdBA0ay3pmlSC00FumpCpBqCe9BaanQ+r///31uqg30NN+g1dBZfN7tWnp0LJuyb1sm9N6b9b03qZb+m1TazN00C4yZgShiXgU8E7GWokyXUse5QQLhcW5cBcPnBAcDPIchMwAAAMed5+GG68YqITzBRE5uONEIC2jqVe2JbZitlKxtDMHiXIlAzyhkTzwNGsGu2Iw+9PBpfavLbsJsTNDHaJ633MIJXfJZTFc6Wh5vHvbdqVVolM262V+/nynTsULeuYu5/SW8qabyypaerGcreedy1hyagtW65z+9/uNnvcef//j/9/v8s4d5Jd45UvOd/L/z/HeH9xxq1bna1qVRqXc7llz/o4azvWaXt+7az7W1y33Xe5VqWrV3r736x5+f//Lm92c+csYxKVPtCnukTW4Bfxx4wIA021Z3oS1l+GlV3jlWV2W2KnK8qnquWNeoFekBgIpsaGqm7hL76mAAAAAAAFrusv3nn/3ohIQRctaTSbBqKkikTRqF+AAyGxUSJkdpi5MkGmRePrIlWXiBE8bEWPonGE5FxIyNj5kk9dphRZJI2VU1aTEoLKJo2SLxsYopKVSUcLpqitFlmJjX3WitJJ7/0W6NTvd0kkWZFHXqfWiy1JKlEZk1a6S2uYkVIqXjI+YmhfKJqYmSTqd7mKSjIvJO9ZwnlOk+tSXzFFaigbHWJQrkVIqfJgZYUsmYECJ46tBAvJF5Ji6XS6i6AbTAiknDeColAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACfSQVIZSgACr0gpwylAAIlYlPh3NgAL5RCpTowABUYjoHybLJ8UGAQCA1zIDBgQMC5AzFcgYGJPAHQyAizSRImBqz4N6AUugNAwKmALVCRDCwhCFwJuLGJEQcZMvCGCbiKBgIMIiZizhOY8jsH8XoXXLweyFwAg84JzMCkX1F6yzEwTFsC6w5wz4y44CEEapIl01KI0jVjNJhO4zZoQAwJ4hCKlgzdIoE8YOcIK5oaLcgpDiKkyOoZ9EeSLGSJFjE4kYsx9k3QRToXFnENLxkdOJF4xKZmixj+cL6aRiZjfJAc8QDHQRAdhfc+YGxJkHBtAMsAaleBhDQNQAKAw30MQiEgyY6i+TpiToxxXAwgcQVIsfUXkXWix43W6CkESfIuSJDDqJfSNUUXQNFruxLDKkYVyBE2RA1LA3SBEaThFUD5NFMqEBKQhcooIF04b0pxVSi9+qpUxBoDRR8yNBPAhGVnTGuHwAULjKBkgHBSiqAxAUSgbKPGg3hqjWYG6QUsDmDMENDVqsjy6Q8iAyhOmwzqDNPE4JcHmPE8Q0bhdV9BSRshOpl04yV/YhhRMEzyjEpGx1JzH+6BdSrVvSVr//ZBKtkFM96KK6Lf/6B80pVmaSlOpsxMVkAL6zX/rmTr/0q3WZnThgSAqiLlsrLQdB1qr1PWp62MTVIpEWLKWpJ60P///+r/8rWVCw0KAEWAo8JDACBOLm4xaFC0UXbVMEtipSX1MoVzoOwz8yBRM2Vy2KPqziKt1YiKBr7ui0xgrcnDjcEhQpHgJuEdnojJ7/e359/MJZaimEvlDJiIWcRAK4tLfpn3iFNdgGG5q5cks5AUfTdXBGZ3dBlRWa1v9U2XKlNnV3KbUEW8p/t7eONPq9b7Q4SiznL+VpTl3C9fmocvRivSRCV3KljCpYlk32MTvzF+grxqz2lzm6W33DlNIGfMkuYP9Jx0IDAtOxpzuLfbAu1+79qT087MzE3qSRCnmMqSZoc7ueVj7uVX+b/WWN3+fr/5+F3Glncef/8/f//7/v////P/9//8/9a7SvqpSFANxpFbyT8AAAAFJW0iGIjLAHwcJcTWkaFAlB1AYCyS6OUPCiuO8xIo455g45ZDDcjCmZjOEiZk8ePnk3XKRMpGpXsko1NzgsZOHCbOlAzWUjZRqbpmjnS8pPSRu1r9dnZSa0kVGjnUlrSnmW7KTZSfdNlF8wTMEzpydMlqRWkjSPTV1HnTRUmfWg7lQ+USUNiuPAzQIcMVCiCUCJkoNUrEYREnpLFYmCLrLhms4ta6l1Iuo+zPbQ0/9v/////31IEwS7AYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAc2iE+je5NyxxEKNGtQbuDuITaO8m3bGsQn0b01u4QAAABlj3HKlf5GEHEpgDqe8yBAC2z+0zvUEFr/b4zu1CASLWOw5ea7EGKxNDFS6Yl35RuXRkhHR4HsQ1Xl9TCt2pRSyCpLnSa3NykiDHocyH6eUGyiLl0nDQip4tKMTxikGeiws6poZOg9q7syKRWRIsTiRFVGJxzBSnPpzWkWzQ1U1ExlM0IKVSgsxLhFlGJxCi6ZdWmbIm6CTnM8gbE0YpmZSH88LMJURMXYpQXEBMAv8LnFhFJBq4TsLkLw+ieKR4myKolcwPoqSMEjZFJk0kjyG1qDrQv1evb/6P/t9veX0CYcFiAAAAGq+Ges5iTtOEQI/g8iA0ti7ZnZJRKZHLIuJKuW36hl/qus3M/kldWJxWetJlLMp6W7Zzxs7w3P7ppLuzT8mo1EoxFdSoxYpGJOrOEWPsePrMzjupIvKRZa6LVJPWzqdjIvKMlKoIso1TRNEnRUrdZdRUYl1zVziCToJImz0nRak6kXRrMZrqJovD7LpmiLQJ2AhgFoWKjXK45Q5xBSWJMxLpVRLBsmWC8Zq3RZ0VJWWirvUyX/pJO7/////9pwZYump2iAAAABrPCvKH3SMKwFEgOMKCGOGCBBw0Kffh21itfVLKC65mKBIA0mFeqEN7D7Unog96CoBiIP0s+4tKg7IYsMCkaJUCNyiEVjeNLjXltBBLWoIvWrc1HjCIBlzdZc7roGEeCYNhoGBMDmni4gXCKBJpEXUWGdAyOrZSdzqTpLIIYimyVPOfLK0yNMD8yMCeLTk8mfL6jVy6USGqHgomxQKw7jiBmxBkS8V0SmsxQRNk03MTijIulk+tNEskwLkHoZ0nBzADQgBCBfwWPhvgXWHJDFgY2F0MkRQhBKRASGFM8XhziLF6ZHZ4xPJnEElLPrZkpcddvqS3SUn7///+l1LuRpVJpgbiIAAAA53neZS1UYsFCFQOHW0UnJpqrcZBK4usGd50ka20se6nemHasvwR2xzkO47DFefbkRGefb3av/3CHpVcsT298wuy2C1709meLp0xNUI/G5TcxMh9Jo/F6q6Rk7q6qKK6ZqiXTNExROnE6KzRA2mpq6Bgy1qoai+owPTxSPIztIyUk5+kggZo2WmYlLpnCkSIyRhHHgJoMGIUTsGocw3iZDxKRFTMk0yUJxio4myeipI3rWyPV0tv96Sv//+3//SGHOIDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH6IhPdW9gArwRCfSt0ACmZkFYmUoAAqlIKtMg0AL6AAAAAAAAAFbRGEK4bhddtSsmDgUhmIXBw8aZeDlt4VSWoLm3XAAoYLJoD137iWHJvstawQBDb0/YtQxHP0JpEX38rWXf5huw/dqxrLfb8No2QxDkzKKOxyk5LMNTt77Nq/eTbhe95Z59+3nn3XMMv/+37kOXML1mxZy7rOns7y13XMc/yz+5e3jyds3PsUtW727Zu1fx1hhnY1e1v8869Pz887NDWjcDv1BT/rFVqXssMy+QvxK79mQymtnSS3H8eU/f5vesd/lvH//n/+ev//www3hh/8pKSxXhiMWN17ef/+eeeeefcKenz1hhhzOkww/ueeEsl+x2AjAABAAAAH65unt06zEVDGxk9c4cuRxeu+1JNChRwga06Vxvk6QUslMiRqQwjSaE+JkeTBwhpsQMkwoVH4rE4latOYl4sHzJJibUVi6PRXdSlkieMzIvlJkZgXEiOsqo2ZbfqW7qWs4tjdFOpRsyC0LUV2RbucNTBNZgapnTKdSWgYuqpJVC6CVCipdNM2KRUHiQMT2LMC7S2ISjvJ4fBeIYRdayymSpeOoopKVdkFVM70m/3/9f///9f/7lE2YAgIAAAAAByKFE1Sh8oGDJC1DIqLwGEDBZgHcwwSBsBpXHIDnF4QVUZhtgGjKhQOFkoDJ4Z8BYMApOIqIICBxCixbSaFIDTMkSHG5VFbjvEFx1CliKkALBATpaGoJgmI8HOEFB2JkXj+QUoGJOrWya0z5Dx3kUJIgjD+HtiimKJwgRiRceVKQYWQTI4xoTQrkwaMXnImxsaooMgcIggk6SjAuGhwnGHMLpBydJ9KcSUOco2MTJO6qV/LheEKClBtkMJwyNEzRbppEVcM7EwMTUvO6SnRRZljKmPQRf6Dpm7GZFxQ4WFhbMDAkQMmJD7haOLmD1BlhkBzxvE+XCeIIsdhDyumXlE8smRWpNDXAAIgYccHjCyUzIKWDEpE0o6XUUCLGRsvV1ITAdhCHyvZBlJ0fpAIAAAAAAAVVVh6AWwGWLKxjxW5Ew+hJATxpjoHGMYhFwdiiQNY2xkAUMmGaJPNXrjkFsQB51MhZ3yCOM+HPKrLfq8oOTx5l82/1PbLhUOQky6Pc3/V/8l00CmpA0Z////oIKNEDBkygnrTRetX+p7f9NNIuHzM3Ky0lDY0TPJ/1IIGBcZC///+oyLrKQ//1G6mNFuOMLuE7GOCthzx6iNmQlZgSilpoug6DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB3yDUqdvQAbAL+rO6UwAY6IlUA1jDcqavimBnCm4cIAAAGOOOP6rWsppwlAgaHGa0QcYKcwVfr0tTV280YucAVh/ESST3wLei0Wp5LDd6pDk1XVNRU24rWrTVaxNcLPp0xWpLsrtL3W9a5y5Wp63LmX42bFK0dqL63p3DCxnurVw3cqdlvL2u5d+/WpGHy3H/5j+Nz+Y///+Hd83j+93Ms6fHm88td/n42f3j/P3jqmxyyxsyqXfzHXObwmrv5Z9u2KlrK3nvPLvMssq2WOOfL/fyyy7/dbuY6t/z8781TUL82J6UvtXi7otbgRutA7sMQ22KQU0vwzncs7+dql7Yx7P3sgrEGWYQkiy0ynA5SAAAAAAAA6VaOtiiJtA+4UY8XkkVGxixSKyQvQVCRI2YxIKgfJouJJGJqYkSLyRgQI2RJ0xY2SFyF42MS6gklUlrOmKNaRtatRkapHBxUWMjZSRkks11GRsmiiyloqQV1Jdv++lfo1JWRRZT9TKSetFFXRMh0lW/S0TVSKNTsiipFdSS0dHSSotWjU/ooqSVWXTWdmx0mSAmjiJA2PC4yIjnE8fICQUzIqXTYySKJdMUTWEFign4WhRuTxX/+OWrE3L5RSy+JrDgAEHBEq0lDAQw6oXvS7R4VEYrH6xMFWNrD63FliNKEhucDLEf2Fyyblr9ug+VprC6YHfSBmcQTB7KH9d+SQ4prNQ5NxuISzJlDB6CzL62NupZnKGXzF6X0E5E3ZjM/e1rPO5fpKueFWnmLFSrnUvZ1pZjYl1qku35RSxu7lLK9+kr36S5LJu/SY29Yax33Hf63h+uZ6wz/6ljn7ypOVP3uXzT8QWy9mbfJCIvm1KE41CUNQHppsuTAZ+5zOINg9yIKhENySBIbrTlPVyll3KxT1rEoq26Srbqb7T3MaepZt1L1jd2zuNVqtPDbLaKRXpTavanbUqzzwu/lrle5er3OW7t+kr38M4AVIzepjb0ynkLI4FSkicjdiOwO1iHX5SHXkJCHrACgVRsQic7G5+1SSu01wdmReVsbu7z8QPKpZI87dS7lVkNHUrWbcxdzqcf9p0Vy1vm/xwx7gpxE9zSU1EL0ZxkJYhUPMLulWuh7nTaoeacpvzUfp/67srUOd2Wzo/rqb5pINjbWPQeGj9GMnoapL1S9vTt2f1W3qhDj6TEI9HphQRTDcBkmNQbD4xyVFsUaeZdtF/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdIiVMjWptzEXE6SGtZbhs2IUSNbe3DckRo0by9uAwAAABWjTrPrepqGapi4x3wavn+huKOs8MQcRuB1QcNSvT6QqTPu8rjZO09FM+EKvWIFoIbbWaj9nk5blNJTU0OX5XlhKscKZp9trEZoLJwxN1k+gZGJnN2ckiUJ5NBJJGeXSTRRMTFJRx0D58upmRgis0ool5aCBgmy3OpLSNkVIG5cPLSPOaOaGZ8wZTJsmks6pZuyzWYKcyokyTxuLWiaiFBthvAVaHGB7QhUfxXzAbZcHgixCJk2WFlwuG55SSDMt5uilNk9bJILZJbKWySnWyKNJFbJLU7f/qX261KWyJgM0RA1MmU8AAAAt44Wt/x72ljK4n7pdR6LPyz6GYOUdJQxPOZq6zTWLyN02a0kMMued1oeZuyrBmcrst+hZKHcfl6+5QzOu1DcPySGMaCeylLhNPfBK/tDLpTEoRk+ke7SSbUolsBSh4Huv8mqfKlu52MvxxpaLLcu1TyqnxllHN0dLXymal+/P4z1yrMXsJyzTZZ2Z6hhu3MTMjmYvYryjl2/uailiMZ6ll6IWZfZlN6eldNbnoNfxyF/tWdZhrN2tDtJCutQv2wOGlCMHabDP07lww7G7cdhdPTyjKn7d1erWMblTLt7Ln9zxwyzxy3zLHvMauPO475lv8t8y13nf/v/zL8cv/Lf81fxxxmGBOXfzt4k7YxAYAAAA/+4dwn1IKIDlcqSl7u1d2zGXSqLLjGyBh8oiLXX9l1mIyaiJAWckjtMupZ13otGGrVp6Yq4XLWr1LhdmX1pbFSmrNwaK5dNadqFmj2ae6efR42tOzsd6xl7B+sfVda9sahafQm+eBZ7Vtmw+jWfRbMT59Pa721vl7BuxM1ItIcKNCj3tvGN7gwfjyzRa+E+gzaxCUzmwt9USiGYSIhaWCStRbYsFKl5g2o2MqlZbYgWta+aYtvXq+n/z8/HzX////4t//////////////////mr1wNGKqoAAAAfreG8InCHlBQGAy5osgz5DLuwy2yBEzpMYeiTJpE3WB6zpRqH5RXYa4sak83wlFHiZbS44Xt1ea5SymGolWzzuvqySSU0C1ZarXsfDNltQ1li08rcZiO3nD6Exbvr2+MbrbNawW2XLDbEKNitc1jZr9eNu2viE+3Dw2vrZjRYr2LuJFe6/tZ9WjdGtb9txC/qysLCoVMryhYgzQcZGCXLlrPgWItx5Pa2bV0h0aHB1D1rMHVb+1n1a//73ndrb//x/611jf/////x///7f7////r8QnynOqNgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAHg4hOo5uLctiRCeRvbW7fqiM2Fc2ACw/EJ9K3QABkAAAAZY6xrSluSWAcKTEiHO8GAFAlmz8y5PaCKesyo81TGQCNslgSVSxxoysV4xECjwHOdhcwrmLQySEpQaSiA6WO16XWUqpZS/jqyjHGzGaAVBZ2GorDuJVSHNNCdHpIuEFPpmxgSQQwt1LQMkkkFUtE6paMtKIYbE8aLWZImZ43Y8XllUzUVzU0eaUy6XSHmxsViwiSByo+TiJeTNpqkfMjzvLxhMTA6govLUXIsJFw+UWYKIGEQhQXeKUGYIEKoSkMyMiTRmO4bxmZFoniPJ1BNJCidsXUUjtS2epjZSv6O6a1f///9uuyRSLZHJsoAAAAD89Z4U7sIRoxmBKx5CqnQ4+FdhEKl0NqDHOjgcBNYghzo0/Tv4V5pQxodC/1aOuxHKhKOKF0lSdo9U/MPd6FVY33HC/yvIZxUkDUUTLhUcJWx4jlM6kUB/KhPSVehSMk0lshTUtFB0C6iVExjE1NDE+xRQdI2cvGyTGaRst7ruaIoFBy0dzMtSZkX10k2NUFF1KmiovFx9BAeRUHOGdIco7w8A6guQDMDfHKHQ6kLJi4ZmBfPEmmtBZut0kC8jUtjKk7sjdd/7NSf/+////rRDkGxtjL+f6hirERYZmLQ6ZYWR6JlojqvZxSNZdtTdNxqB7jkrAolCV2wLSPrMvpFleBwvF5FDs0/r9sPEJ2GFDXH5hNjnNXeP5H5Xafqewu8a+BQq2u+86D02ZqVROJZxKhsZ0cxPSssBDeYXpuz+q/9/vfr6/LfItbdq9eorFHT0WVN9Slq0ONNU+avWbWOuUO+1n/pfwtS+luU9uvVrZzNju+UPbmfcNYyjlFc1qZgmla5CWeLaSGKwcBDqtjZx4JZk6zL3hrNs/9aWYv3S91T5VOZazwsZaucqY4/zn/Xy/9b///f/ljr9////////6////13///////5+dq/KLG4TIAAAAz1hhdjbA2PBweSMB3ZqBj9d8ivQW8cNilAvaB1CofiMgVRnCaJ0Zo0Hohgd4oJkwZmhDSaIAEAwUGOIxK7MqlY1LpRPmSa0i4VzIWSWjBJEwLp5jEyKCkmQMEiPVUyaCPq6k62Ppm7IugpKpNSR9SLuYrRdbbpJlxOZrQQWcZA1WgaM1JaKlJU1OlWYbJmxNnRtGxTHaNMG5ZBRRSfHaTg0iaJygYl4mC4booI1Laykk13ZF9f//r//////qpEWcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAK55BUhlKAAIESCrTItAAhkilGnc2ACu5BK3uk0ABI0GcGPNlAhAgBUwwAAAFFnB/RkiQACXAWKAcC+J5Cy4LSREwgHmJLh64WbD9AM40A3JgIRIIMwAUAWSYnRaYNnAxiGPCyyHCtQ7gZGOGh8i5eGODrikA0kLpCFSGiMRzzo7R2GZufMBFRGYN4BOZExligMqgdLJFTxVL6CCJuLJFAhdAWeQIZ0P0SC6IbSeZAmifUThOGaZuhHMFLC4RBqRDByiHmikCwLiMmMWQupaRoThmmboENJcqEVHKF+K1HAO4UEUUFmBqXDaiii1MyIoRAfbGS3dBmWLIF6DQQDgIhUfAy6RESaKTl0osgQ0IgQ0FSdFV3VRvrUaEIRMuCAAr4pcUcgizErmhgec1N0FGiZXmw4DhOBiMMDgHAAM2XA5ZsAqgFFYGNEBg0LnAudDohHZEh0jmDpH4WWLmGNIYTLnUEkiiQ0mQbdD0RJSVKaJsUisiYl1jZzFGmkQAAAAAAAozp0RSoBMD2gbBJ0gS0RoEHC55IHoeA7xEmJYmi5uSrD6S7qSHsaJpE1qy+n7VJvdCt2RU/UttBTWTd/6/pU2t//+3/7f9X/7NodaLmRs61f1pKdSP+mpSDU3QQ0//////qUmaEobsip6//ZlvUgyi4eL7sZm5LvQ3+7gAAAPy7+P6puxJ/mdDoGKkIIQoGAJk0vp4q9MO251B4v8ChI8RlMUBy6MMw6/0PyCPPNRU794SNIKKWajuy6bpYlIakMlge7SP1LeTc5fu56z5dllNSxndS1y/VjMtUUZuzFpsJpfwzxjWV6lodxqdjOfMty3GljkhSYtfvmVrWFvX1efr8dY/Zxw73eVnCmpf1QdufrP8a2+49yyv3sqXfZmHXhYLZnf7hjzVWCKW/Ztds247hc3e/mWOdjKvXpL+Pbd7VXOzy/vHHO5ct4fzuNmYlcCOtFZc4EGy+okaka1dX0FPY1OGHIZo7UOXcpDXvXs4/SVMt5UVq9Wz1fpc6Xf/jq/wOBh0M0Vf4AAAAAAAAFqqvSkWAmgn9Ri2Yl6ZE0lQrwJSMMbF4liRUamo5UTEwPmI8k0UR3G7Hy6eTRFmpNAvTJaNXl1nWXUlqSdSRex1HqyKB9ZdZKXlss2RrZJzZG/rZ1o/+rWyq2ektlujWrdbqdGtFJ13UxDKLorqfRQNnRQSUk7LSdqNdLpVOjujX1I6nqPmqRkYlFZwcSZ8CVBJwvg0jsHskPYdpTMCkSp5M0LxsYmBsySZrCbmyL2QlOzwqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACISJVCM5w3Kwb8pgaytuJDIlSo1rDdsLtCnRh724IAAAAGsMKSMSykjqw4AKNAwFCLEN+86AETEwHIh5UjPUU4CcR1KQZJCVlFGCRiG4bn8sKF/33yfRyGKxOG3Idiilb7sTf+X5s7bSMRiUWMK7tsQinM69/LCUT8vz7hKJRSYPRC90WOOXb+den32pMSykzwwwsYfvsot0mG6eVy+n5Xp7falJScwpKSkww/e9c/lXH889f3usMOfhhhh/5554/+EsjEOP5FKzgJeFsDEYzGBQGCUK5ExFNH4mXLcuH7UNv/G7VSGIxY3hhzdPb5SUlv8KSxzPPPdenz1UsXuawrY8n6tDSvu3KFzk7RTe9Tl+7+8MM+YYWPt17WsKfPVikwuw2ztxJZYw/BgAZD29YUkMP5DlmG3fkMNqVlwzb0FILna/D9m3T2NRuXuWODnuowhpkhm3vl+UYpp/tTChhynr0mdPN8s0lyKKyOv3uss94Z55+w1Yu+nmrZbUQ84YCGcmGH20bP+tPbt6l51Va+P5iee//+//mob7Yhtb/b/x7Y+pYXnTt3E283Nz/T99pJT/NbYn//j+br/nbf/smEjWTyBOSNiAEypIAhPOVKDZSlWaT0TwTQw/n1PI/AQJAAAA+Utdd2ihqJLrR7MDOFIJQEUGHAIOGrSLfCEAWlRoPtHZ2nS8tBbVyIgKBsqsITlhnGaStW69LDXdFAD8QEzpr1iJO0zpr0utyVyaeQ3LVqNMqXOqq7PyqXZWaWrZoYy/MO2cZc+ztPW/NLYzs1ZTLcr/40tbLtNSym9la+NQ9Gr2VNLqbLdLGbW7NWU2dVqaMymzhTU01WtYa1lrX7xy/O7/MNZ6xpbGGMZlsprWrXbk0+zEkxlMWIywQgNNjGItUAhGECpZM5SpljONtwWsw9RzLsuLO1JVLsJqXd3S0tnVWM2eVqa13dNfq0tLjqtTY//1e7qxnOlpbOqam/61ruOPMssv1WprW6tLj9Wlpcf3ALEEFZDlWO8JYCugurAAAAtoJUiWW1HCl0PQQFxlC0+mjpgtgIVAXy+VOpkV7vLaXE5SSuZ1JBkYWvUisVDac6jbmC8C0+qy4TjYwMFYdtQ47AXNC2xUSx8U9Mv4+HkSG/mzbFb7gUtT5/+/feKavv0vSJT+mr0ve9NX9N4+4ESVjj5f4iQ48B5qlP6Vhx8R/73xTMfV/SVXx2BDFtSEEQkBfATzjYFA+QxwU5zqNqUFU44fFNQ74vv5vimrxAHSUHO2CnSCgNnRrvZ9Y84HwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAc6iFAjm3t2zfEKfmMPbmBuITiN8m3bOUOn0b01uyAAAABvW9XZhsckLxGGQsGmcSEy4YU/qfzlVmziMGPNambNQcJxpdxi0y48RddIC+3avMRqB5SSiiMLsu7XpZDlYyzlOMGUWFLZ3YhlBr3IosYvIrmKKxwEOrNCtPmUMcxc/Oe3V+//euKxtR4kiIhdc6n3SS9Hs28xaPrsMTNLZpbp5c3YpHKKqcvJKwoNNq6etGGmoNZfiO8eslLeyjXidREeZJO0LFyD4bx/FuOEOZNxHNU2mY2yDDfK+mMwn0WkPWJNw66rrWvj139//GLWtnX//////x///8f6//+/8fFnphK3ZWnMAAAAAAABN67h39yx7BF8wqgm9jciVL9RhYN1KK7ot7NQU6vJVag//cF1cpbSzrCYPlUut01NlvWdWW8zlOOeOpqjgiDKbLOC9ZdK6LluZvXUj7Eb49t1r/6/5r619resWE91C3u9faLmDm1o2a7+LS6zWFFevYT6NnXfTyvXusWhVrIzRs02w2lrWCy7bLQtN0VUgAoUYuKGsZbTJiM1oXnYmasFW0tvddbtb11X6z/vf+8b/////t8b/////////////////rCRaOqCkAAAAD8M8LcUYmNEg0mhThOfwhgJbFEZIWAC2FaTMGTnBj+YIArBmIrGhuKvoyFlkMEAbfmWzrkRxoK/niC4oIh5QSyBoVnO38IKkstcd15yrepo3SGAgPKnted3Y+5dGqgakRKqA8GyjIpLCBZLKUimapJmy0kmRTWpAySLpwgxdIYo1YnZ0oGk8Vkyu5gWyLJqTVMDMmBjnNCsieIOUHQQI9zY8eQJ0vTqJtRPIJmhTOGiBiWCBEwT4lIXgYRD9BOgcgB+qOcKcGVHCI7E5Bc6ShASHjNjMFQnGIkThEidczPz6zY+fRc4meW1aBifXX9at1qR/qf/2/v1MikWSWKhugQAAAAGt/vV16ndRRMMDz8iAiEXeltp/5bDEWlZ2NZEEeCSPrDr6QqalE2ka696bpcoY3eWBKD8ozrRW9vvc3+ldzGK8q3u24w7SwcCUlUvqHEarSIqRuTlJmY4h+La0VmpgtFB9luzNOmpusvHUD6ZhME3STYuqpIIqWvWpaabGiJKko6kkDEyRUtSbu6iYmk6M1NUrppkIdw7TYmBdSVBZCyEuAhiAUhKCGO0LaswNyRNiaZnUUjY+ugtI9U7Jtd73rb/fX//f///2WJuiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHYohOpXKgBsTRCfStUAAs8kFOGVqAAkZIKcMpIAAgAAAAYXc+xByEBDilAYBiLPCDQxkEAUAGgTzclbEwAMAgcAIZgbHJgN5ByByxzRpEGICQ03PAkCxjzc6SY5SiSHyA8CASGBFCAEkUSqqo4QA8aSHFeolSXAKBxaGMHwOgljZi8UyHmxcJ8wMjU8ViIBeJE12NlKs3qNUXpkWTHzQYoIlhdNSi+iyZqgkdSW5qtMzUTxNpGZiixeRSNDibG6CRopTm9JBBLL5oautZsSo6SBlYgA5QuECwABECxMA0cWYSo4hzx2k2PJPl0iJXIYtRsggpkbqUjMED6k9WZvV/9//////51EsOztkAAAAbz1rCbfceDmREmY5HW2g4GpvQRh/IYiod0NuA59YL1DIF8dxOkOIYTB2NQb5uPamIaR5cJwERsg5UPHUTay0TApE2WjI8owNC+iJSROF5JInzxwyPGheTUbHDclF7GFNS/9FTmyjFI3SZFFFSKaKSSlsdRNqatGm5gxfMXWbJMt02MlLpIOlfNHTl5Ct0zh4mhomBKj8MqJ6EahvA6CBFsW4i5icSYvk+Uy+x9JFDU6qFt6vXr/tr//////qYoEgfoEDEBxlSOBwLAgMwsJAwePgIggEQALxEgFAgMuAlGgoJgKCcQeFvIGEwOGIgAACYKHAAoCwBhAILgYGFQGtAKBhIHpLEBy0LGF9BRUAAAGkFkwEgfm6EoEEPEDImHohk4IgCAoAgsmIQ10FEGFBhq8T+OwmwbiBoAQwSQ4VqKEMDD5WJkZcZMToOYQQOSE7gsGSClgVsGXrJPdVQYnEFxYxOhoaCyxzyfRICM4HQpjqLiBstS2a9WQQ8mOYLkIgOeRc3MCYSGZIqRQyEhFnCyhHQpEgq7HUiUIqVE0UVLzxNj6E4Bt4hczJw0RQQdSAfKQEAkQBwBAieFJFkc0gJNGxFiiWv+27/1/siTZublxgbUAwICAJAQCwTAwADgDgoBhkGgBAcMFgFAALnBOAarIORc8TZucIoaENHaaC4iaK4WIhY0JyAQLQMqmADEoQAOAw7hyRwl4UkSRsNUTqRguYMRDpFAi5Z2mtAGgcBrcCAEANAFLCEY9Fc1MAkEEeghsiIW5EbisCNi4gQJZwzL4oxeMTgrhuYIkuSJeWQFuyqOySjZFFRu6aTLZBk2q3p/o/sx/rqs9lUEFarerW2uybL97Or7+jsvVlAuC7OqPKdf1pmCRmdet38oppJIq/t/////6aabGZuXEGTTdqv/0kWKQypdR/+jwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB9aHUqdvQAasb+ru57QAHrIJTJWtABtVQClCt0ABAQAAAGVrL8srkatTTSm/WiZ9dGQiwOBoehmjvWI7RP66zbBR+CPpoB6FskjdBEbr+vhEn+fZxnGTPobsNUb9Sqfll6PwUWhU5lkl+rQ2LOWtdtVr1qYyxvZ/hawgxR1zGyqaw7zXctUtbl6pVqUljLuVXCtqUVV1XLW7NLh+v7lv//8cea3zvNZ19Wo99/PHn44/vmf653HmXLuu41aa8ra4s7+Gv7vOUXv7Y7Y5TXtYdw53DDeqtjPLmsO5bxy3l3Lv6tYflruX0leLRSXz2UYisJUxYgpqvyUP5S27raRuvuxOatbzmbdXe6v2frfnhVzuVpoZmdD2psgqyEAAAAAAA/tbec11i9TYFtMuDb5xF0iibGAAbxMnMSYZuozL7IG7HS1FI6Ph2XDc0cyJYsTMkXSRV9Rmg6jdC6NR07WOcuH0zzskjUdSrM1VoOtBdfqXWr/77tu2i92e2tVSKtnazrMyooup6kdZxbLQeyTLRVq2d6KWrs7X1IbPWcRmJkjLw7S8XgnwQoX8vjkLWKA8ymo1KRq5kXVHTJoJnA/FZSiTtWcKEAAAADPusKSURixXfylQzBoUNlmwCM0gSkf+X01R/JYtBxA4idNkzJmk3G4/A9eYeN/6OF7vLMnc5iORikrzV2hyIQ1ax8zbzv4SuN56qWLmNPykwzzz/tIz97LMhvZXrVvC5rHtvHKtnL+85j3PCq3uffwwwzqVMMP/Pv55597/Ob1z+28e4a53mHMP1/4a7vefeV99+tMUWMba47mMrdt/4ftVI3T1IxDE5jnTxikxp6ent51Kenp+5ayw5+tWMMOcu2Kmufn2/9+reo7EA3K0pl6r3klsphyPSqjilDLMfwqUmdjW9/nT2QcPfA8AY/PAQZ3mfdVKSksYxtyHIeRGYxWGGARnDiThkiaFY3WNQWQBgBgGXWEOIIbOLiI8mR/JorlszWP4yhcUUXNjiSZgWy2AgGT5uXU6a01pOtysapqMjYmUEkjWUUjZhqmxkxkbqTOG5kbLlFNlHUUkTRFEnmatSS3atk/a7tpKW9OuiyLoqrSXrR2NkbUyCi4UDZa1pJVWMlLWmYomepJSKCa2WvXTZKgpbJJajR/Wx+UTZI2UOaYE8JRIALKGZFIkXRIESzmpkTRxMuoIn0SkpCKpV8uopM/Hn/G4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAd4kFWOToABAdIKoMpQABpiIUqdqgAbvESpU7NAAACAByBxmydQioGZIWWgF6DJARwAyNAlAnjAgiAGIAB74RWDKAPABQgDUIDfRDEyZFxEXIoVBSRgI6FfIuUh6J01cc1IWUK6UEyEZ0loummaMQIZI+YkqXBniS1seOFxA3TJcekEyial5EqKVTRcunkHWmXjMnFk0R5wulBaGlXWymN002QYql5FFTpOiZrU6v1O6DGZfTQZlKLiQ+BCMg4BxwA4uFkQm0cArUihEjhNI1GJgDbw2jE86S1qoJ5BB2l8cBMFQn03zMix01Ok6WEThmTRPJutjpqZIl4c83NF0UOt+l/9ESF//6//yGp/cmZnOCCYGQCgOEgbMEDQEA1cAWAgDACDGBLKAyQQL7hF0K0AwIAFkAgQTqLML5DRSyYzZ4ixYEdDHjnkOGkTp0zGdNxxB6Ino6QjGyS0S4pkzAc4TkbkNH8qC1ElZbEgRMi5uTiA9D2eLJRNSsiVElTM1UamLoNJovkUOkWI84RUmDqGkpaC7uXEEDczTKpPGqLJpJImaanVrvU7GblwnDRPTTJhIdAZDHPAGWADJwbBwfqMgIVHMHccJpGkUSgASCGETJ5JJa1UzRmFniE7C5yLk+QQwQTlMix01Ok6cUZFMyTJlJbHTUpIl4ZcnzRdFCut+l/9EOqfb/Q2R/+sdJp8EAAAAf+8frSpz4GEYQ57NT0M5ZQHNVyLD8ARhDEIfKLNIYUSiTJoVzQPIXDEjhbiaLpBS8Xh7SJ00KRedBayGlUzIcT5qXjZjgnIgYrI7XIaZKRQL5WYoFZFJzA+Riegigs13WlUjSSmBs6SajQ2QNkkUnQNVGxiZOyR9LY3a5EWQSonzFjYyTUlSMj9FFAumjqmxeWynIatxmTUgRRHYI7AaUiPhDXIALjIiMsSZOlgzMSqWDcmTlklpLmTpG1Rq60dlLdaH/u3/////fZMhhDnypAAAAH9/fK0Sa+xMwfjYZQV5Kuv9NvEeEuA1BENWifRah9kwK8MsZkiQZZCKFNGIRUcocRqHEBdxOjlFszIqimpIsEGTI0nEzy0iVHKFqFeGkgRYsnikmXCKkwRckXJk1LJAR8Em1ZxM4bUWS1qomLGJ5MuoFlM1mrUVLNloutE4dZqkzRI6TBPF5Mul43NTJNFaB8xLR8uskXnLpeNkHmKzRJbDlFscokyuRUcwc8MQAZMEJQDlh9jdGZEpDVJwhxKnC8XiAniaKZcL1AxQTNWl1BMvVPSdamUtv1oqRdT/1t/6t/V2qTNBfjpZZqsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIQYhOI7ybcMPxCgRrTW5gIiM4lcqAC2PEJ5K5QAAgAAAAb1upXgBRdeiThgyEJwSDQkKyvIVOLCNUYAngYBAhqGGBwyYBKV7u4zpTh+UKoLVEhZZm3TgxpjH4LEQqIiVhAEhdCevS27GInJIEfTtW5SxLgYKYq055oq/xXNiDmAs4wLxsOAuoniUImELB6XMDAzOJrdnQSQSpFE1L6xNpYLheKhWLaR0+mk5bUVDhgfKZxk01TcfA+x5PGRRKw6DIvkVPEWNjc86jE+VTEtuyRTRcvFwwSRLhGlwmCsL0ckL5iAgYmD3wP4Q9AMJDlidhBMqiAApcrGYpMvkkVi2PReHabusnTInp9Ewc3Njia7JKMV1r/T3a/9bf+2r1e60zQeiGppXSAAAAO8/neT6rA4KIIZgJCJsSuzT68swEreYzMmfTX2aw1DbtU12lTvpZ2MRaJRzOnJCanrmE3bvWf+7EpbnchmxWn+U0qXisrC5JFHR3KdE6XEyaifPkuO8uJLQSTNGUtStJJluszPI0EziJxU2ZFSdzVkndvOqUyVFRLIu6Ll1IwpoaCpxSNluU1WUmfH0YQdhJBURtAmIFBMBLiQJAeYyzQSZI4WmRqbOYqRZ0mTW6FHZ0e1NL/22t/////9RMMVS6IAAAAGHM877gITA4aGQBEZJi5gBqGSAUDgI6LJ1M0x3WCICAwQCgNMNcBcKiZjNisCwk6XyIi9GXAeCwRBFFAdAtArYcQegBAYA4VCU3HhZO1MRxwmCDEVHwV1lMdZHA4PlgfJQIEM5MycJkuEsTZEzxibGZWJ4IgInFHjA1qUpPWyB1Fa3JRRAD5NJOaGJuoumKy2iZGCZgXjiLpoUkzAjSKEwWTFI6TCzNZFZoYrLClonkkE3TSTY0LxmmpywR46BzhjDEUmFooKAcLcAiAoZdDNE2HqjVFkFIXORUgJOk4eJeRVT0jhmgp0mQWdRS11Gd2/1Mz////r/76j5w3ZkoAAAAfvPUoljsMPQRjwNONBkHBBkDyZT0Pv0NcIAQGI8hyoXmRMZchw+BUC4PCgy6Vy8imgPkmRcYSLi2kycNy8gbOmYlUmibJRR80ZE1KJfD1SeJo+mUSsaG5iWS0VjUxQLBiPtFlzNN0qXRoqZbGCikdQOImSWaIJoOtCZoFG6krsmmX1m5VWkTRsggYJombJsfSQQcuspnRWaIVImJoWiGjbOEPGKK8GRBQ4WZEomI9C5jpPGJeMESQKJVMHMTM0rTearUtaTan2Xf+rRf/////9NQ3TM+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACtKQUgZSoACSkgpwykgAJI49Sh2tgAqKQCv7ntAAWRksj6C0QAFEB/EIQoQFdYCBgGyOjBGYE5EIB8d4HFEgCEgLNAGjQCwIC0cDCAdMYpEiguAVgDKI5A1cLgMQi0vlILJiIG5TBqASRC3QMDYCgMBs/UZtNDMvEmYAPAIWTADBgDAAMAgBRoD2amToi5zJNReYAoNgGg8KAoGxAdOGAybJt1blMaToKRTFqEpAYGBQbwH0C38ZyYHKTLe6RolTeoCwXBtATEBgAFUVoJyEEBz7Uk0L0akztTp0DRY5olMXGN0WUDbQL7BsAXDhlkQdPplI3FykYTKRq9Nmc3QJg1FCEYQYvIHmfBvAGzA2IELhQEBcOTwn8VoSAuAjygO4iF///8/9fqNDBE3YmyuMmXFlRNB2SK6mNHQIuVR0CdBcYm8AoDgDA0DEopBwPA1CkQMmggDJQsAweGgFBaBhkDgVA4EQEA0DA1QIDieAy8Hug2fD2RCwgyjTlAG4wMifDTAF0AWeAyxMrFpE8GRBkA2QOcEcQD1g7C0CAGrm0cZaOGws1NbCnHCyXSBlVGy0H3Som5mp1LWqs1TQWykkE0WUgj6DV/T69m29Bf2TvUpfSUu3S3TZlfspPfW+dSGcJkqmySKvqMTIfycTRO3b01F5lGqXb///6P7/////9BIuMMwVSfRdBS3+37KZbZ5lKnacp2WGgAKYQmfz4cM8CjSVz9RF3Yq3JyojVEQGYIpnYl4GDZDGoGkzuuzAL4NakUAwcyIoAl1OVIX6adTyaHYzDr4gIHcWKRiXS6bjL83X9fmGXJd2Ga+e+y2UxmU2JTXUWbPDZcVlsO4RqNVbVTO9dxishpt2cKsupnKcKgY3Kb1W5Ku5Yy2zh3LL+b1app7Wd2U37tWW0nc8LeP6y/8LONytarZVuXt1Ik4TDgSCAIabbuvyytZYSaKxmtjdvcnO5ZY6y73PPljPljHHeq01LZbvn3bNnG/f7r8YzSy19oGb6FStkKNpd0vC1QSAl3MhWKnSp6YdZjkp1NTVB2Mxm1eu8pauEah6ly1zGZpa8ZtfrDvd2au941auN4aEwAAAAAAACP+7Wt/mE+fXC/Q+JX1nU2ckDo0AhY8jVI1L7pmB9lGjnTdC5IGrmaRopY9EXTUymf600FpqQ3ZTGk6PdJlM6mT0GdbJ01Mpk6vW++r/7J1LfQqU2nqtZegt1NZRKNtoVJqNHSQTpoMpTOt0LJ63ZS3rTV9TtbUgmtSJuxmVFhUJ2FQGQTB4F+SZkU00i4ZuZpMtI0idhGmXt9VIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74GAAAAeVhVJ1boAC2ZBKfq1QAGhSQVIZSgACfEgqAykwAJYwAAAAAAAA5lnn+GG68snFpgkPOHbjPBgMAGudWeJ00SK4hEGQAMkQAFpClBOhBCQIqS5NEaS6ZkNFZMhthDjBAixw1IYOhMnxywBgolMzNiLHjxiyTsozNjJEmSgyTvRL5Nh3BRymPJSRL5kbsalCs1Nzhsxoy6kTAoE2HzHG6TrWy/1b9JRyiTSDpostvd0lO26SSCBxJBZRWm7pziJeUikbMYmJsfZFNSbouyJkidoLRPVNo6pjMUE0JmYOTxeIOaFQeCbJoXOLUDQCNsTkMuPJARlSVJwwHt0kVl9NEmi9PJJk8k62WbQjSbl5T7vvncwYAAAAAAAHN55/zPuuzToLABSwWugiY4pA6XS6UTQdANBwGiDGg8FQiw5yzIsEVXMjYfJMGiBMnC8V0WMCkgHOIokial1zjpJOqYGK5iVTqnZNRkx4mS6Q8xk0bInDqaKKTlkpGyR1qi8maGL7LRRdbW1t0WZqqn2UbGzIJJbOlqS0HS0kiLEGJ42VfVRLrVs6k0UEkUEkVooKqSWiykrLRt6DMyq1E0W0SOMi2ZFkoHzgCAYDAkgJ4i5JrIqMqkQEipLE86JicYmTG6JdZCr0UFfdgK4/wqKQ8c8gJDUkyfAyw4A0yBt1IDQwAhkBsJ4oMG7hlSAi3gZAEPAGFlgMHQEVQJDwKlgGnorcnBNwEQBBRWxDxphigNWDeJQZoMcDAwsonxW5dFxm4tImQ5YpEG6ogqK6LhMk0TEujjD1CIGBuXxIxsmQ5Qxo5oZdJF07EPHQaqJgmCcEJR1mJHFk0HSXCaQTcyNiLl82Jm6JFyuUjIZYvjmi5S4QYmllFE6azlEcwnGooJoIG6ZGkVJ1BIyonig7Ur61KU5UTJgG/gYkmAMjAxwYGwQHSBt5B3JsgZIkyPwCQAFAIGmJgYsQIQiwmRMiURmTQ7WpQ+gEgBbjNadNSpPkQOm45hFDRM4XRhEmTpTJtFi+T45hOICdz6BvYgJNEWKxwvEWWZkVMSKkVSWamRPJKNw0QPOXnWYl2ut+Xf/xXhpI+QMQuLNGVNopcSgIAggAEmJWBqRYDRAWsMUqYUuRQfBAhqFwExAKpD5xAYUkKWQPKFzkARHl1GxFkGTcihEBQg7VzIiyn3epM3dJbOtFSTttSNCJGR9SFVdlf6Bsk9vR//QbZbsun//0NvbUcPoFwqJl9lItfrUTyKv9Wspm7oIGiDamuymUXUSyNYhyBspboOtbWr/pdaJl/rb////X+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaZiFMnZoAC3TEKdO1MAFs+I0CObe3TcsRoEa1FuKgAAABjjjjqtEnXaEOKHRCsWW2bMmg2MkDAGAgayUDY8KkTJJlAjySMCKxcg4mIuNAwKJECiQFM6aHy6ZJupiiWDI1IkaJmqZgLeVBajNZLHTI+gXTVZcLZkuWHLLVoqU56ut7JtRoJmLJKLDmaCRgmxqec8fMDFkUlMp3ZEwJ9EydZi5w2PGCbmqSSSK00UTiaVjxqtTqIuamZAieHUM6QULoAYECMwHyDLEqK2YkxskSIcXyqTxFTM8W5ipkcyZbVHKSO9bqX/7/////+2qZkQcrUAAAAP3vHVZ9n+iYhCC5lIFxZ29JZbDgzIDigQoFoQgkLKGRMyYGQWOUiRY1WMoOMpj6JsxDBonJAky0TR1mWopF8tF4qmakjInyuLSM6YHCSMCyVHJovJkmaIk05mThGlTUZrNHWlU21kpihNkTpRY4miipR8+pNGcN5iqtjVI4TZcMiZNGIsiZnkloLMjrmqSBo5gmeZ0jIyUmx0nCsbjtPEVFoHKCz4ChBzhYxskcK6RxUHoipTKBPE6RJj5aMzJ1GSboqUfY6tr7LQrS/s6r/////97JpFgbSBJEAAAAY63rdZ4XWQHGBx4cBEI0ImW2rClU/G3EZUbbGiwJhfisGv7MRx+4KC4NKLFucfCSYR5VfWMzNXO3ucpbVit2Jzl+xhaU0X0oLUwhr2apHcZdN2oEbTFHHbB1nNYVNfGrfOLa3JO70pLttq0rrL/erX9o8S82oOfvMHERVRvFlev7+NE896WrW29dtixq63aJGr7KVwUtT/nQ1SgTQAKEZP9oN06anY2xLM6qitk8ZjjZ1i1a59r2trO//ny29v///r/Ov/////////////////nEZugxrMgAAAD+87y/IEuwgcOWDEWW0dmm9/31gxtUZTbT20hqKOXDTpM5nIDsKUQ9cfaHpLFInYGCY8jrSuvSz2VNlqbk+cpjlvd/CUp4KquFB1nqCBE0SNNz5NlR6ZgTAZOSLJO6KTnqa2RWk9JJ0ygmfUgYmCS0KDpLNzRTIGKnTWiZJHDY2QRUT55aK0EFpKPmaaRYU5QNkEnTM0zZF1GBkoVoZDlinDjAIoHADbIfQxhCDhEaj6GoUiyQEolopmpukVjaynOIIqZ0zq1LpNt/6NJ7f/S///7poi5SfJ1wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH+IhOBXNgANmRCeSt0AAiykFGGUoAA2FIKIMrQAD8ObfeXu+EBgwkHDI5nPioISGcvb+6zVMSD00ACKmQbAqFA4IeZj8qgNtoAaU9aWw8I0Vp63QWNB8iEAeTHzK3jh+Gpm7j9BLqrXX+jE/nhTNwLJxOVTkPT0UsQLS4Quvah2cxt2pYVQW3+6HWOGXdd3j/a+PNYxi7FrExTV7+fLlS1dy1X3TXL+dq5nl+N29GJH2U1KOJVO/lPbsUmrFrPC1ew5nVw7n2kt73elD/xaGW6rlUdEQEnyCh1QFfjG3YTvXjJtvpGZNDUvjuWVSrS8yu65W7y1z8Mr3P5llX5/8///9a/+b/f///////////+9f+v//1///P796lzShgAAAAYbzz1DCthWAAIoMdhzjHgx4ALoQLL3xpb5EAHhQOxGCwsMiLGiQ8XYzJHlhYaOKiUyRSJQjR8EeLjCiUkVlwuJOyjEiJmUDQkybpOakRIwNuJovEyVTMhhgyjhaK5kkXSgbDoLz6DJJUb0lVKOLPTMoKOGp1A2TUipBJR9zNRQpKToI0TCblQ4iYH1TFZ41dkHWmimavW6jYutWkUS0YEwOYPovDXGVFfDI4bCMoUxZI/FQhp8uFIwK6RdOIpKPaKKJopFFZ3+zLb+vR//////uZjWJ9NEpOeJ4cwDHKAPdMAzYMDI6QFHIGZ0B5iTFzCfgbziZgYkmCz0E74giAAvAUhn1CMzZQnQXIAYAFwMRYLAEkVjUNuFsBvGIDgmNL7IMknkkpQgmLQIMC0QWETYeLSR2K+Nk1MUFifhHY0hYDAcgnCAI3zIWFWyI0RQA1xS4fORIcCjqC2Ra0ppLoJswxhCDjL5Nm4uMjCcZZx0nQVprSOOeY8taTkQRTJonDMojNuMmLMQQlNAMvCgh3mJUPL0EjVMoj5FdHLIBKxutCxEBAAV8WWIBh0A+yIE+VyTJgqE4ef+r/9f69X//3PN6bGbm5GDgDeQbXE/g3KBYgAMPBsDC08gAceGNBPgXME6RMbIrcZMNvIsRBZMKI+WAMJg4DLhNAAEYGgxECQmAzoAhzCVFSLgeEdwBIYFFAAp8EQUECsNVjbHWTpEy+JuHYQ8ZcplwEIMnCGFEQ0ZsoDnA3mHY7oldZopaCJibuZmw5yU0NJkT6RcLyBPGB9M6gmbqPajU/Whl5L01GKc7UpakXQRWitNbpaBmvUmyZghdSDoGRiZubNQd0nOJIsymQTPsaFwXMNMfJfNiuYrRqWgOg0BAAE3E8RYwKrL1qOGxUIaQEh5iUkUnpqb///Nvs6v///7L23QZE+aIIWTdOkpVDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACZOQVAdrQAChj/rU57QAoAYdRpW9gAs1wCq6sTAB3YjUatbx5QKUoOuShNA6w14Zz3Zlvyp3oBji0i2QFAGBKHxSNZUxSFRRSthESZEsLOQzKJ96FRRuKujMPNQO880dhMsHAExZlrktdh3B/oZazCX2Yc61PQwzTfS3IatWZS+r7xxxkiYFuU0ajVm99qVRqVX4i70PX8YzDMZnICiLaVst5Y1qazcl1Nazxxq9yq0vK2WWdNlTX7MzDM7NQzGaXlNLpVTdrQ1Lr+WUph2zu5TPqXBSkV9lPTT/Rqmzxlstwq1auP37VrLWVrv/+PMsvxx5jhNff5jVsU1reWWPK1Nm/ruzzkqCq5pFzF/iyyEQVNGjJIVgwKYQGCgLLXiQTIAVLZM+zDmHNei0y7TKnKjU9Mv6/sVzq0tLVlNnlNjSymls8lUNRrHCmlUapvq0obAAAA/+LW9pVNtlLuA5p+lqLYmE5SboGg1jzMER7ku6B0uMZm7FZfTnB6FBBAuGk4Pcvugm6CDetNSDIGjUGqQN5mPcl3QW6aakFmadZcQ6qadP1If/+v0G9aCH030ENBD9NdnrtTTqQQugg1ab79qetPUg30E3+Zm6JmbpIIjvJccAK2CvjLJhcMz5IDkKaZmXy+pBaZ0vplwfnJyGfLxOqQAAAMed/9czuzs4rOhWbvwGREAKAGSWeSCOWo0+zlsLLB0c4CEwAwqK35uL16zlW4m/1BNogS+W3Y5TVMq0XgpnhgISs2UxmK52ZT3HL/sWLHJiO502Xe5X4oh3U9OwJI+YSi3WpqC3VppiVUed/uda/9SegBmdfv/+P42e5//f/+/vn5fhytllHK3eV793v5fjZ5cyz7rLO7Vrd1lH35pe4Y/3u56NVcOVMbNzmWNi9jb7W/HG7TU2WsKbPusccce9/tWtWx7zmGE/R5yCBZC3Sgf1p7MhABP+7jlurAjzMhpoIhOEqs3qnLtqrct5XJm9jjj+HLVbMvoVIYb31M8yAAAAAAAD/LfP3vuu5Rhlp04TCpZ28pReTRJkgI/j7AZ6Uy0bIlgyPlIc2YkVRJUwZaRkpR1BIxYQkLxkXi8fqdFrzpRRnDY/Z0pxFyiTBvSLxsiYmKKKKOiiitFqrIf0kn/9ujtooo+tFqKLrZezOpJ0UBWxEnpTEnWcmRzSCpsZEWL5UOOUSaTmBeJ4yMi8XUTEipqYmKKzh9VbbPSS6RtLJMk6cJo3NygF/RSo5guYaRPGycwKRNElUTRsgxqa8XBPbqYnStDf/+ZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAnfkFSmUoAAtHIKcMpMACKOJT4dzgAK8sQqU7DQASAAAAAAAAEThKCwHXNBXQbB4CA4BgkDjmgK4SRAwKADTiR8haagXARDQMKDAItANBhUgRUSBBMGF7wtMEKi4xAY2J0sDBEpiOwugGXxyRBUSoqF0jhaCAIBc6HiDEAhCKXPitR4M2N01OkkIUE5DhIOLLG4F8DdZiTJoUBsGqCTsPAzCBFCBF0ZsZYgKR9ZmVUE0SBUWsUykMwogouMpkMLKBqfKTmJMmqTa3few2RxufQY1PlQuIk0mXUWSRrMzRNNBSB0vk+pjySDS4SY3QsPAgLAz48AwIAwuAkMC0cVkUwgpASBEVUfEci9AyicDDARNo8GciJYOPVUnWbLIaLGREh6SJfdSTWQ9RVGiPZFCcIORQ2KJuOcOaXyeLqZuRAg5TJggYYUWs1NjRJJdB81Xr6NayZHMDeTZ9TRqCSGZkxIhaOAuNSAYAguPFUBskYgIYFM2UMkPgXZ4CrwRhTAdcPeDjSiXTxcNjEYAxSTJAfZmtFZqbDlitZTIIJaOc6Kui7GRoiiamx48mnq2NxtGCajhgibHXRMqvooFA7WpKktdVf/9Sa1pKSqqZkl0Vf/3UUXRVqPKMnrziRkThfPGzKvfqUTRsr+s/UpazWXyRFAGhVMFmDOy0nU23QZZw4VpkWSGF1FSloV3////7/1lllTWo0hpABhQrnPCsWxXKla7AyAkjlAwuFjEpQOSl0xQH0oWnMMmXfaszlSlIUtSuKAF/K3MBcSEM8AoBHhY1CJxaHY3Sy2dnZx94nZklLVp4ATqBwPFQMyWVTVy7EorNV4Licq/GHYtH5Qh82eXTMpkPJ2zKt41ZTLc7tip3s3LnirS6bnb/5Z1sK9vtD2tLMLPaWms1MMcpqHMJiWy+nhy72/nYwvTdPhOYyvk3hFbdzP5XZzv5TV2LNjYPDDYmENeIAERBtAhF2YyqiS8il6ZsSqvnDle5Ko5ZnsLc1Wwz/DHt3Ozn+Hf5rLDvdf/N9wylU9l/8/n7/f/r/3///4f/df////j+pVDSMwQAVq0WhrwAAAA1lln/4ROeERFLIxOd3lYrDyEZAvxiGw8RgzMfhuRHo47ykeKAwaA/l5AoDnOl41L5hXcml41JMwQRSkomTx2kc6SBwumzEgpR43TSRMDq0K1J3Zat961MgndBRseOHnoKRamgpF00Kl0kVF9SZseOGakjV0E1pNTQUk03QUu5utU6XjUnE0oj4LMkgCXBgEgFQH1IOYXx3ksQSok0DUeazAxc+ykK0mUnUfq3anW////////9BZJukAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHb4dPo3uDcsSRCkRrUm7dXiE6jm5ty2fEJ5G9tbtgAAAAfnhnhK2sEQWNCxgzseszgQCZfSU6escha/CoBnZJSD9ilcSJPHG4g0GSoYI1WHBltmMPlDZKIkRLTQ1Tz8urW/p56LymfrVrV2hoUJkSd6Q4RsukySiydLQ5pqVTqB8wTCEIMnpIF5STvqoOiYoGyJPlwzKBqYHWOmqB9I3mpdQYrGy02Uko6WhmTRA0PMRVZNSfMD59MulFEzMWTNUGeXTQ2J5lsTZADYZchg5RUEehloKoYiETEKh6w5IdKSZdHSTJibFcipqVy4Tpos1MzEqrPIppJGimXvWy2f+qkk//7//9/0j4zSgVEAAAAMdb1+rsXeYCoDtkaOdyqujGbNSocAXDcpjTrTE1Yq4ZN0q1H+gaYkUZnUOjfVaWrex1TZd1ZsymO0WOeMqkTPWDbsylSjVqJwixeTPMXjh1FlukyLL0nrRRrZJTrTmKK0aNSSLnWZ6110TFlIkVPoqN1oos7my6kkWUjSPmqLImLosksipVJQmi6WGJMBaQCxCykUiTROkoLiK5CHCLFYsl4zRLBNHzNkqTo1JWWipW1f/6KLf/////WiaikRmjYUwAAAAMct5YzTcUSwMKjDKOO1mMOCylrvQypUyN/V9KpHgsLDGPsmb955U5T0Pm2QdEoNs7hqmXVyWkBSTEucFUFJN1da5TZu1At6jtX5qODgLEJY9zvRNNIjSoWyWUxBU02MifCYipZRukpJFOi1F2VTJBYzp0ipsYonJwvIpGhwwcuGSZqaoObqWiTKBaMSiYMRU65gsoIoOiZpJH0VsyBkg5kszN0DIvORMc8nCfD0RCEOnDyANuDGYgAG+E2KmI5FmjtNiLjmDaPLPF4nklss5cypHmSora6NzX/o7NS////7dWks2I1EJQAAAAH4fhnSO2jghYYKunoqysdFT8jlZ/XrU2OXCEOTQYbajDkPv3di9VrynqGLZxJ968gIRxzpTnP8tV+bzh2Ga8fqzOeP0tE3VK2Ey6QlIfBqSQTH4+UzM0Nx2DuGKXak3Ni8mkk713pmLlFE8dTMEEDqDlJI8o2c1NUz5nUpHOooF9JMuJuPU+ko+s8cUkpNBE3TKnRTTTLpSagimPEdw6i6MYS4YhCEBC5gnAU5eC2jAEEZjQ8SRmYE4zc5Ueukiikta2PVsvspT/XbRR///7f/8yGKUURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB8uHzvVyoAK7sQnwrdAAKvpBVBlKAAI4yCtTGtAApwAAAAAAAACUImTL1xu5WEg4YWCBjk3nQ0ksSHIbl6+ZxnYbYGBwNKGAUiKYTRWFjSJVyKjmAmCAxgShMEFMiDEqILgmKQGgAK0OGxeNqncnxzCqbk8XlqNxmwBQAM4KMVCbJA+ZGRNEVJhRETx0uGJqkG6EkQY4fTpv6lnrLcrGQ5BenDI+bIsYpny6mZIIpIFhCipSB06iakQZOfKRko1TNzpjWfTni9dF6bm5PqVTLxQMRyC0RAZ8X4CAGKsOmELCdSKuMEnS8O4tlorlgomNEwNU6SkkU1zJZqkltqRr/2ZXQTTepBqaCCFaab006lf6q3c62m90n/37kYZQx0OFAuxnYGwQYKASGNwHRQOHQCcAOcHFmokkRcokVGWLpDCNFDi4DxUImmQIqjgBoMHWUieKhsklUqkeJl2SlMyJ8fZFnW6zBMzPpG5NKpm59Eopbsk1u3VoOspKOUFVrZ1H0LMgijd6nUcNTkxMzQ0OHbms0OulSTXWtBNB2opMqo6USBj2VyDDuDLAWmk+JxGXJ4iZBS+RSo+TpEywZoon3ez1ost3u1v3/9X/////9SRNEFYmxzyAk6k4cICyQviImI/h7AX0A354CxkDbRy+GWgvYISg3WMyMGYA15sAImCcADbihlwhnAFFBohy4b4KRImNUqi4g0slSBDLDNjKC5BkCSIAJ/E3DiDCojksoDHkVPjwIXEpjvPE2IKjkBq4VsTI/JnHSWonxcgoAdgzZByfFeDUAupHNWQEQlIsLgKrpn0xwLTN1IEXL7kCGWEBhwpkOLpMl1MuFEbRmeSda1IEXJsnxcBUYwIAWCJGRfIqMycIMLOIaTjqzFnroEQGXDL4nMToMwTBBy+bmi0y4aEaR4EgIaUXVF9ZqXTJJJ7qDCQsSlLv9NnLhogdJ8LQAbCBaYBpTYGNChaeAMACwwQAEAzInBzyDk+dGXHGLgKktlZIgKRDRwk0cHYBjVgGXEAYMMIVJYZYckQlEKlIskFQN0DhAiLLos1ZuZCkhMRmD5OJHlJ3WYamrpgAAAAAAAWqY1CVABpElBWpNL5uPEeQSxTECHgdKKyexcPGZqocZfTQl5kpixuPAnm/9schcaYf/mjoGhfN/9f0zMvm5KFw0///N00zS6CH///+mm5ogxv1KTqb/u1f/pl83YvplxCgggn/rTc0QZN////mKKP//QTTrTTHoPQeATtN3QNB7m5ueW6CDJ4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAeBhtKnb2ACw/AqzunAAGLSJVAM5w3LA0ApAa0tuN6AAABjjjj+WsstNKWMOghDgDAMk07V3O9JYzMMqZUFwIBARxRyXhcmcjUnmaKYhy38f5Tqyal1DLJ7spjNPKYBJQ7CU3pdlVsdzw3j27ZwtTX1ssdVr9Mo5B8alm8tWM6tndvl27cl9N+sq29dptr0pu/3+83W5/P///f/zeP75fx5SU3e1u/3fPx1lhl/fyz5Wxz3Zj1+rll/O/9iVVe7s41Ld29jl3P8s9d3Vu41vwq5Zfll3e+b1V3Vy/n9zvzcth6fnYvLZHSxeNvY1mG5A/UUdOFynDdBV1na3N3ruesaS/jjl9Xl/avhRI1l1H+wAAAAAAAAVsqrrRMR/AVIHiLhPJZdOG5dQMg1MBbRmpAScSNSGldFReconC8kWCeLpqUi8bGri00ky6g6KKS+kdLrLMjZbM0xNkSyPgizzI2SSdFRtZRdU6KOa2dfpO62+/Vq60dFFJaS2V0nrRbRRak8pkUIlostDRYyQSSdBIvPRRZVFSTqoo1LRrQSdHrSdlJUS7UcLyJwykRI4ZgG2wsZMClieWRw5xoXiyREnVHS6XWMi8tE8cLdC/J2PG/d0l3VJYlcvmKKNtwMdc32SJMs4Zc4awudCW6xd9FNQd9lcR9z5gdJA4SQjc4HXIxDc0/lM5FV13wZYyGRPo68AQI6bX3gdyZd9u7ebhuNyh/MZfVh+1LKt+5hN3puN5UlWN1oYdqT0m+9t55W8qTO3clGNPyX9qWM7dykrXcae1KL0rp6+VJZp8qTGnxjd+ksZ28sO8/7Wvxz/uuZ9w5+dPb7+qlj6mHMKsNyN4GIPsqRwQKFEcQCNBFmoB1wontXXI+TW5E5EtcilhuSO5Mw/cpLnKfKxdt1LExYr36TlPrCpYr36SzT5WLWGrXyHkrvSNdMgkdmcr5Z0c7S91zPmWWGNPqxXzqX6mNPfwu26j/y/Vh1ecg8QXqQxROHC3Ag5lbzz6IAGCICTp4iECgPXhCIYilellckfxn4ydOCgXIzNq7WIZhuVQm9LKG/hHWIz0oppBQyuKap6eHEGmL2Nbxq7w/XM7JprbHGp1vDXy84NpKR7QPzJqdvqUuNHbDTY1p1T9TF1Dv/+r2T6tMvbxFz1e2q6/lv8tURS732aHEyfBx0MeeUP/tje2P9v3/NOvqY0p/ibO5Ubwds1oeScO5gexIQ7HDtJqZ1Fa2sv0YMmgvY0k7LceRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGeohUIxmTcvfRCnxnU25eBiFCje5N21LD6RGsxbhUAAAAVpUoE21WzTSBloWKDJXnWdGHHPibuxdpp5KwTKLmNM6rgva41eC5VljCL/YGp4Cypo/ZuztzKZluMvwrRitWx5QR90XWqXclpoT6RkidQdM8eLJdZaSlrPUepJKpb3TNUVF9JSa1n3O0EFKPTjJUWOUzQ9TUt2TSZVVNlvQWpCpaRxB0lGRgTrD4KZDC2OWBYQRqJgKSLA+ifKJLFskydMyLGRYTPFxKaqdJ6DrZJknXd2sqiyqOrSdVlsktkv/+tr7VUWWURCUWI+L0AAAAAAAZulxud+Zir2DuJmnNu4EPurAUXWjNrtOEdeSBXvpZbfdGWTEPRHcalMF7giCJ5Mhlk1IIdktDhPTMMyiUTMrt01/6sugtjL9RepZMi0UzJAoPNVmx4jUx9lVs3UYmJ1moJJGyTqZMyMzpqsnGSUio4mx9FNKmpzc2mLJmx0mzNAuLLB5MwRTPmDEcQQukMJwwIObkPImYGaSiDEXJpIiRWD4yVEkFuHCfFJCOQaVAWGJ8GkKmTxAhgkiPowJkgBwnCXNyiXy8ZroKSZ0kZxBTosloLprpWat0klO7IslWpJbLZ/2pUbrZbO6KLEyHQitnAEAAAABrf7wuwA7bcwoXHwEJQItOpa6yHWrOSmCcq6L6j7pM2ibcoFiLy3i3L9y13WWxqFQm44Et1PRCU2aarVylU9TVaWdsXLUSTGgAvS7tK5KKZVKI4SeTGWIsXi25eLQodB1JGJ1E1SzJJ5qioyWUjI6kXkDWQ4+iaLZI1Mi8ZKQPoF5FGkdMTpNG6TIlwolU6alUmiskZO6lOnOOfdkCLF1jyM+RAixVIEIyGOE3AL8CvCxg2FIELQDdw5wsQg4vFIcR4c0gJETpdomqKCCZiemrGJeNknuqmi6/9JaKSWv611P///esunhQxEEsU2YAAAAyx/etzUgVhMMvPIaWFw5nelLozZCED67sCvCvWTN1X9cdKXP2/WmVNOjMC2KIlCTw7+61beGXc8qapWps97iL1NFZND1NLi8TRNKIEidGZJ1EunjUmRfk71JF51tWy6nRZFFExOmpgo+YmtdE1Nq06JdRRetlJrMmRQLx8njY2SdFExRRMUWW6zFE1vMUjJSSaKBNDnEzGNG8AtwEESAQSIMKBGZEoizR2pEyRE3IcOcbOkXnTqSpJJF5IyRZaK2be/6ulX/+v//+jSMkhSJPLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB4CITqN7g3LZsRnkc01u3SohOpXKgBsHRCfStUAAYAAAAHM8M7Eva4RC48bCK+OgpQoDMziFdfboNhQnSs+BVLmyRmzutmg6AJasWC1gA4DkNSK3V/PLGhGLFBxficthmS3rW4jWjT4w/Vo87MZmAMGymLwp/qxbLpPmiiso8Qhso1TJEIMrMyRopJ1WRskcbUVTg3C8Q84aIF1IyKc8aGSzRZksvH2prMlkyR5sfKZ01J47WeIa5kbmyaBedM+zLZaR00OooLIqTJXPjFGoITiCooMLJwbAAveMoNKIQChVDiIamMYQ8rFgtE8OktF5jFNzZI1YzRSMUj/ekeVX9atkLf//+/+uyRSRN2arQAAAAGOt63NPTDxbIwmDji4vJgs9sisyOVvPCoZPlzSta3Bc1K2yNnyux4hCZ2JvGPO3H5E/pMunLk7PWqvd4OzCLnXdlNy1yhlC+lYpu1ACaQ4j6CBqR0zhTSHoXxJi1BJKgZLo9BanTMlGJqZKLpcMjY4ec3RPpGzmyaZ9BZqpDOouaMdQY8RXTRLhiaG61JIpmVZsgbOuSRc03ODxIoX0lhiAtw7hkAXQegFYlzwnYeCVE1dMvF4uj1JM6dRNWdkUzxvSdjL3VQr/X6Pr/7L///6yRNnNWKkAAAADO5hyJu2hm2xWERClDvI9MZhVAG1OGE/HQZIAuBwMKgcDY40CxAN5HOFxIE0RqI6CkCQKDtEmYjnF0niIENC34BoeCuDyQhgZKoJkXKRxIpF5AzTIUBoJD+NgulMflGrlYhhiUiiYGRufJkuBuRR0zdzWpbL9SNrE8blY8mgbGpgbooTBNZ2fSSM6TG1ZfXKRTPHTU1KiR04WEzqkzFV3MJ1SCSSy4x5TMaFA2FzmRESkJyC0YAoAikA9sN4LY3hslAsjtLhBC8TJWRmSZfTdFaDLSc4yCLas43/vdH///q//6SBT0sgAAADWG951H0FgBjhBndZ4cwOEK8xzlVNGCVAaBAc2YDeYnieGVMi8SiJCnB1CyC4XiIFcgRoRwxgIjZPE2V2vRufNi+WjA3W5MHRuEifM0TJyJLOmJkWDJJFF0SUazuaL7r66VZsmZomiS0Ua0mmyDJO0vVJ1szlw7MTp91LebzQ9ZTspazFajzqrUy0UFkwRg7USSF6LGFkYuUQwfiImQ5pKk+k5fQIggboqPJJKe672dm/7f+r/////+pEdJPmoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74GAAAAs9kFQGVqAAlBIKhMpEACE2HUadvYAK8EErU5rwAmTHwJwMzIKAAComBsUBhAOihQy0WSsBgwNAMBwDByLDGoIAyLGLACEJEOE2IFshwAQoAxgMgMCA8BcqA6Ok4msTeahQDhQBBvoX3F+KCGADcTOWi04pcPkDI4X7DFwxBKQ7gtKI0eTVFM2YTAOwDa45wsYoMdQfsOIlSyOa5e2SQFcD2gswJTJUUgKTJ0BIATYxSMkDqZvTdcN9FSDEg5xqQAcoiJJmSJFhZqBEjEyN9Ve6BpJ8oEEKA1xkxYxWgrcVqMsRpESgZEHFaol1EyJpCszcgZi60Gu8aAnkDA4JDxiBhSgs8c0kiIE4ZkwWC6QIhoNkiB0WJpFEySdO/7JFEiZFzIiBEE0D7Jm7JH6b3cwI8cZOFwc8FgABgcGgGAgDModAwoKAHAEAoYhQJAKAANUBgMQEFBDVH4Y4WkgwnIYgyY6TafOEWIMITDjBvIBgoGgSBoYSHUVyOIEdKKZMkapMgJiZOCAAAAAAABOKNFODUEClULLwLFxlSqPJbLpXBCCLwQ8nQ1aKsjiSLx0pokPMiGjFcxYWg4iakueVLq/RUmYHFoMyLmClpLatS0dFSDKZv1v1IIs731e92X701Mh/ZnV/TtUv//Xl4xLhWN1I/zBE1SnH/ukt0Wsn//////7oJjsJtI2ZNNBfqt9msyzckzZmWbm6H/lkAAADWWXf3zLtxnTRUwTUPgykkAwUvaJz+pZalCmSbyfYiSTHqEyYVCBHUBM2lsug2BZ+kfS3LkJ0Q5edSLUztR+fxWkEBqEUZhqlwqzH4fnh9aZqTczupnrdiNRpJ90FMqCc5lhvCfiO7kxudhu3h+V2W0vLUjS65lWtara5T/je7ze8td1vHDtvk3zOZpscb1nXdZ7wt8xy5z62da7vLrtO8mM609jreePK8cvdqU9WtYiVnlvHDnebuXbFJT0nd1rOqudmtn+WWGNLWsax7jy/m1pyZdOw27zwTiqaILNlXv++jYX/h9f8OxvsolN2ze3HZ7K9hjL7N293l+lr2diSoHhGWplCrmAAABZHS62hXACCCrmqtZkg4qrm+UAHt0Z9HWI+Hyu3Zh01wp60ZmXEGE7p1pl3Ffe0H6z/8Tvdbe29t6zV7trSEOaDTcuoXw9xuSBemdWxD1qv//r863////9b+dY/tn/H3bOs2/zqucb/rjecb3AVrNrdv7f1kvnEaua43jFtetvbO/nW/b/F67xv/O9Z9vaHN4MByw2zKo/hIBDy8KVDo8RSrhwhvHJ7WK+nqxQ8ZmjcHpKDNs1cokUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhriFODWcNyt0/KYGstbiICIU6Naw3K4kQqEPe1uPzp6ent7ja8DCg1vMsesTLmuCJCFsEiC2Zilg5N6ozD7twGXtPmpGxXDgQ41i9E43HHAaw8lnBdr7w+7jsNYawyhljsP5GC+1qpSRCkjGNPdv9wqWKSpGM5fT0+ff5x8X4lmeWOHbfOY57rzcvp6SWYWLFiklkslcC09vP//869PL6enp6fP9f/e//O4f9zL9VN97n//hzO3nv8KmH71zfaeXv+77XHchyUJoAAQCIW0SIU3ceH+zD+Ow5DuNff+N27eVikpLde3nhSUlJLJfT591hUsVLef4YVLFi9b+rrOIZ2KJy26QPYisYmN4yOxKr1zDmdjDWFJYpL2G9YUlJSYbp6Br8XDx8zQAQ/n509Pb1SQxDkNsPRPRHM7mZs+7/w/GJZSW91LFEXINWBgDXIpYjc3JZ+Wzlj8463srrzFm9qfv17tGX9o8P1lvHPWH6cpGLpopl1k59a0D4xTEgpoKTZSzV0k1mSk66CjM4gbN9aV9f9+jZ00qkmQtTrU6/rbbQGU7Mt01rN01rqVMTFL2Wzs9de3urVUt0H6mNVkiYJGpiZIFMLcHokSoTkvn0B7mK0h7XMkzEecLNFXKPhmSp4qCgAAANymMxl2XdlMw6BARA9JHJ1wQHDgr1QDSWhQSY2ssMrp1nei0cCwFM2XSxQZ3rcYa9UmpdqGE1nKf52ozDs5TU1Nqgf6imn+h6ejTtRljSsMZpaXHedatMxmW0uMtjMRf18J7XbWONWlrU1NlW3qmrfnzK1hTZd5yrZqymMxmM2u67+6tLS00ajVNTU1atlznKuf7xxy7vf444/j9N39VaWlrZdqyl/X9a6w1lS5kvgaI14N5ExljKmXKqVOlYrEWuv7LbN2rMv6/MZjNLS/Vs42bOO9VaWrS0tnHHVnGlpccef/4852zjjyrZq0uP6y/Gzjz9Zd1jjj/6yypscefvmppAVLL4L8IJ+EFBTiAAAAhltHpHpOU0Vasl9FcCJSYXogI5iFJ59k3C8LDIjFh6oh0pVbUSSaoSvZ5X7m+gahSXeQLWtjv2+TVb4prw2CI/ZzIkDREzLi03dNzA0d6K03Ur+zKQQ1ppzdNNN1ILTQWmmpBBabU3QY6XzdZfL6RcNFpvf2r1p0KabLTdSCJJj3JQ0RE3AS4CLDnkm49xMyGTBwD0RJMlzRempBloVp0EGTQZae23/Wv31ospK9T////nS4wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHRIhQI1t7dt4RKm5rL24gUiE4ju5ty2bEJ5GttbggAAAAfzvO3pERAQElMF3OdkUthqZ48+botPAwKcJgtMYu4Nl9nia9Mu/DIyBvZLW7wdNwzIIeHQ4eJplybsZkGeuYSrsM3Zq1S43oyGAyaV2plLIMR42w6J57Es1WpQJY06tu3bqyRv/S0H4l3NATELDBNNq+X1rzbgxW6NNAj6l1uusp5S3vMw7V0kP2tDm6uhuOWyvfPn2N2iMLzGdTIQpyEsJPD1aSDBVCCH4ZYvyAHyoXNWNLqaVUQYb5SwXtIL2NLvOqbh1rX73/861//vea1xn//////63///////v/4+NvXcKxKHEAAAAAAAAMf1n+7lBFxUICyD/xXGtFpbHndfgyaXZqOFG5ZMv7yGp5w4zVkjLqWHn+rsLbWgh6npr/b3cJqHr8Si1LjjchqfgtX1HjSRsR8tT3Kmcnr3W4t4u8ZpuDFzrWN/G/WuoUb1pding+tt58WtbbrXELWM4n1miupCtDgxYT6NJGzBe4fRpX25XGa2Nttq11CQ6NDkcT+H0h4BKAfA/wrTpRKpTyqVrDAQp8nlFVhVMKFutt1rrG81zr7+tfGvb////+u8//////////////5/9fnT5WnTSFYgAAAAa3rdSPqoM3JAHMKAKOCgTDg1Rqe2eYI+7hpVLSOn+jCwJirFlQwNAy/GYrUjwWFUA9iPxuPr3Wa/o4ZEx1c5Cn7juFLqC45RtIgqXz9mtG7BMUwQ9jTX2kh42GaNBlTMnTUcBis/OBCokFoHUy6pM+k6NJA4pGo6og5BTYoGBsTyjI1Pm02k+ZmR4smi1MpAtlQY42kDJkniRLJobGxEjYpMeYqHyqTBoa0jMxc1L6jU1PFYokuXBOIs0PsJKHug2CAOXTYOiEHkiGWBO4YCIuRYuCuDsIKaOSQ5BLmiKBrQTPKLy3MjFC7KTLyC0V+uns9P///29XVZMjWIcaJ2QAAABzvO4W4OIg4KLCO4CdZdZyZVdh2Dn+f5mYEik427zKuo1OulLqTNpjbzkgrUr7ySuQELUJRXmorhey+kfWIblkAxWrO9zlSyWgRvPI0JpML6KQ1pIrLCgSgnosS4pKxiYIopI7pIJzFZPNS+gfLjmqjsuqafY8Sx93UdqVMWTN1mK1EsPNqjculw6pFJlIssf0TWtRdNTaqSBdGKJcOAfguQ8yOJQI0BNgvhJiCCiRAmyjc2LpLEmdJqBeelTWaJuzsZslajUtJvrv0v/7K///8qH44m5AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB0CIzqVuoALAsQn0rdAALOpBTjlKgAIZyCoDJxAAIAAAAGfcMLz7pHjRWZmMmedhhFuAmstHD1AwNw1dhegDBwEA0UrQFwSDd5AiHjsQL5DY5gg0KAMc9h2jVLI4BNgFBUFAULeRhJlE0emWSbNzpOlQnqBZHKBECxnCDlMjyueMydJ8vk8XCLoLNDAukuG6FsMGOpKVZXz9VMmnHSbl00L6BZomSTldFBNBSjBakD900CLFMvrRSLxRSQTLs1NkEzS087Om6UvsarZRMkwQ4hhYH8U4NXClQoGxMA3IcsOQKCNSDEMImSBOKJojDemupzk8iy2Qn0kdec/+23/////9FlmiqSgAAAB+sNzdO7bXEOgCDj8wwHDbE4vrtLIR8ChgMdjBtUXGbEENx9C2EYZoBxRBjA1N1ECJogYSHmhACWNDFndJRsYmpGTjKMC4TIuxpsYk6YlEpLQMDUuGyO5oSr1UE01L10a73SUxeTSpGyU3oqUpGeSMWUtFTopuYTp5bF1F3OWOKqTSrZCy3eXlIKSUbnyNIVRWFgGNEsEehwJESXHYRUnDYxmZwlymtA+fUfrWzJVNp///Vq//////zg5RePACAKMzcjBzBHwCw8DjigSGAKeATAgKBh7HaFihKgdX6CjoEAoD3gHhQDAgEEIwbuNYzgDQAAw4AAEgUGhLA0oIwRBVJAR0SAb+ILhbsnwMAgogJGg4L5ouMuLLJ8MtjbDeRCgWyBsQDdIcwvstBcW8WYNAnCYD7gmBgtPDbRWogMmY/JYfQzCxcBdJ8PxAgAgbyjEHJEBRCikH7smSA544xcZumQc+gFwo2QukH+MBaCKDLJ2WzqrXm6E1IeVxZZsaDjIYNYgZODKjtD0hlhKRBw9IZZdSikShVMEHTtlQlBmEBwDLnCHn0CuYHnMBWR0AYNC4sgMUjRFbGw5xXIEbGZDjb///z30EEEEEGHNBuuHvgKDMDAQKC0gDBQAEkIOF1BDRxkQKZPjsLJPlQh5PkePBAhokFJMT4AIDwbcAwKJAMhmwDAoTAw8FwFgCBgYCh4AbohZCIQCAos0cga4gqKQEciwjlXmFwsgAzWDtAGXBuiBjQXVlYtA0ALCGyCpBHEUJIWFFArHzYulwZIvFxY5puxkLUiYqMzTSqoLQZ1oporQ3mKS1r1qS/6V/pq+pX9Xr0nWvW2talJr79f/0tvzNYy5MpH0P62N0Z5kr/MHSSZLq//////6DGibpvf//9JMxHJMC8kk6kl6/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjUjFGHb2ACxzAqxOhAAGEqIUSVvQALVcOpkrVAAa1Nll9WGYdf2JQpZJgAyc1ZGqlAGFoU5M/ALkwi2/amoCATEG889TMMC0sHSp2nQxL3CU7aSzluM7SJXSmSsqep1o1ee6NPs3UwURZq8sN1KtDWpaaXT32bMfpJZUqzl2relOTxkIE2whAldXJVTWsuyyns2q81bi8p7TU1DcylOblLJmZbW7uz2p/d2e5a+tTaytY5arVaXOlgHGzyb5hjV/HCzuv97LKgtX61NlVXyWdFgGU1ccr+es9xicpc57G387bw/LXM9asZ1LdJev5Z0dbdnO9nrPmWrGdvXN1uWqBscnhyWSSGlTKBAwNKAktqsyI4M4jEMK/fykqVKXc9nnYl+u4TVS/Xqd7hS3ab9dzwu7/K5xpNklH0AAAHUk9piyIxgEcOXJk2ZmM0jyBPlwSAAvH05dI4ljdMuEEc6UGKZkapFkixLJmxaK7MLkOrLBi6R53tol41SYvmCC0HWYGDGY+CdPuaH0Dc0dZxGo2NKaC0UjzK+my1Lv26eztUtVnZRxez0E60mqRSZNB1pjnl5rVJs50yPIImxrTNHWZoLWplpItdns+gnV1ovZ6JePImBTOOWiTIQawawONEHjljoLKyaIQiCJPkUL6JYMTiJWKlzQ+jtPxnq+W5fq2adAAAAwww5nlhdlb+URecEi53cQa0UDQY1HcbuzNWR31QKyGiMGR5FwEcHdgeMZzUfbBGHpmKeKBAWGY3HJVNcpG533/bKCkKsc9nEcpilvVLH9q0eFeNV6S5vtjKzD5AAeeNRuO1LMan+dm72N6e1q7awxxx7dvRdHLDnf1lb1W7rvf/8Of/fx5Vymtcor/LuO+/zn/f/eeOH7tb5T4VMIjdprfKenv7uyzWETZw4lihj8uoKS+7kMVbdfDWGdixUr9t2v3hr9d/O/Td1W/lfKvKZPL78Jl7DoYZVfU3GhyrGCrlnb155HXgiS349NTEYzsU09fn7EYnssMO5buXLN2pSALxSB2P5tAAAADDDD9517f54OQQABBuLRQBFLxgXESIok0UCGAgLAaIUMwOYmaj0bFIjiZZE1QHSKIpNEmTQ3IiaHSQNA3sghqedR1B0UeaGalJJEVQSWgxwxNRqitSKOxkbJLMmMTVSZkYmiRmyR0xMDAupPS1u1bN71s29S2QeibIPR730qk1bJObSdPJVKSXWamTKqMnMEkalIoKTqU61PUlsy26aaaPWamrEcZmpqZDrJYXERggsJ2HNE4m5KkBIMxFiiSJ86yBibGKTy8lZH06zV8rseP83EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHwpBVpk6ABPsSCrTJ0AAbViFKnZoAC1tEKdO1MAEAgAAAAAAAfAuVMySYYYA6wtwBsQIPAq0ACYCnCaG0bEGDEwDQABdGFyQSQhx4C4YDABQ5AiRfHGamBMDLjli5BBMeSAjUJksSBmgzYhQjyUJBkElJ1IG6Y4yDoE2R5SGXIkyKLDmkHTSTWXR2UjU2KheL6kklGzF61U8ZmCRVIm5UJ91F1TLWzLUyF2y+YMyaCSaBggjSf1poKQZBBtk1FxzcQUDAwWkgYsCHEimDPjkj4KZ00dZdMh1AEiBJi6ipRqpF6abpFWVDpum70yfLZaPl4ul4vGZkUiueQNpiXkS6kTYoiabsmtqtdv/omgtqXv/V/+WC18EAAAAAAABakTlAgYHPYECAcpBx4JzA2PAGARYb5sQYG5wBwQBdOFrIEEYYXFuE6jUJcvjjMSfMiZH2QATuPJARqEyTyIy7jrEcChR9EgyCSloXNEBmxzzAi5DyOFnjuZFFhzUjRRcWTJBD6ydSJwvF84ZJKNkzZN6U0L5w2KpE0ioT7qLqTLWzNp6dRNmDIupJNAwQXSf1poJpumm9abS458QoFugRAQMaDDiRLBnxyR8Fk6aJLLpSHUAKKEOLpqpI1Ui7oISZGXQPoIGikFKJ8tlo+Xi6k5iZJEyXGSQRLxiXTImxRE002TW1Wuj/9E0FtS9lfpf/lI1f8wAAABvDLW6WAWmMlHZzzqTqZtbsshpaIPZAOAgbC0AMGD1hzhwlMZ0kjhJoC5hkS0WxcJiRYhSRJkrJF0tE0bHXUohxbMGHOWZF5iHClyZE+DNSBImxWWVjZiMLajamWiPSSUpNBZrerRfOJGBsnRWT1M1ZM1mpqo3NXLtE8jrNmdMlkC8kcSPJGJ5A+ovXSRqScnlpKcvGSKkjpDC8kO4dw/CCxNBqoApCLEHSDlEQD5Tg5I7CJOOcViGlQzLpNOZOgjZF2VUauj9TW/q2X/////3ziZbIOex1UAAAAP1+W6sM0sUWiUn0mqa1S4Pz0iYIAghkK2G0QEZo1H4dh0kSeJ0nESICxGQ5JIkaGLRBxTLB8slVS00TpOpGxOuy1FEiY+RRidSLqiiTqydMS4TZodNXQJof0K1oJmCS0a+taS2MWOskYF2xskp1OktSSRkbqd63NZ0oHzcipoYlpJFJJZq5iaJnkjq2SLrLzFNCxkUyqQ0nDxMiEo+Q20AIwswYo5pUEJhzx8FcmUiClUhxPsZEyoxNZkmp1qWyaVXat1P/ZV2/////6NSZkTBCOBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1uIzyObi3btkRnka1Ju3e4jOBW6gAu5RCdSuUADIAAAAH71vUy3ZoIGAphovnTh8LDVk0Ow0yqBmsNaWocDgkwS2PF+n9ib6VW2dEcE2U1o1GHha3JpQSgNqpHIjlZws4S6ll8T3D9LctzV9EyOM7jPHhPF4ihuYFVM0KhqbOXR2B+JF0VIJG5cRUz3RspkkSfNSCmxHGBmaF1FInEWUfzRIumiz6l0zpMF8iJoUzUzI00NDIxKjnDR1sikbostzZGowPujPE0SRKETGXF8RYighcCfIgPZDCgLUQcYQsk85YHabE0Wzcvkik82RPKUiapOpJutZktF39drKP/+r///+o3E2kOLsgQAAAAP53DOw/40IARkd/mp8MZcCZrXaSmdILBTmZVcxeB10VmFLtjLLs2TsFqQFEqaLxh1hETHpfakYiFPapvm4IlsNvzKJHenaayhQsC3aVyqkNDwzRcIcXCaJ8uHEThPuExSoqUt3MVoLWi6SE6yRuTJeNC8cMS4pJzVA2VJwtoGiCbIKrKRkR5dKpuaOO4zUXpcMDcxmDF8yWeRmqDucPFRFFIwN0iNGcKQrwogpIPsFaGUEsJ0iYn8QMPYphw8RQlCBF9MrG54nUUFGZdN0nME0zdCzpIu6Rl+3os6v/1fszv/8zIAI6JAnrf561GJuAw4vMlHTTL4/y9LNqjdCGF+yld4YAASIwMoNwDBIABQCC5B2FcWktGIskngQAMW4jzzjHrIaSIQAUlyDlAqGZUWzJnyNl4myJIHSiMYFqxng+QmxySGqURAn0yKj7MTMuHzIpoChRvu6BfRSSU9dJzatZqQxQ1i6mpMvoGDGazc5TNDVjc4kzIrUigU0UCyWDZEfzxkgdYqmaKRgmYrPyada0kWOMitjc4QcuDhH8ZoVkS4AYCA3CCIEivjwHJDNkXHNHQakBHSTpTRKBOmk2rQRRc4pE67O9q1Pt/XdBf//+rv/7qIiOYeeogAAAAYV8+xB2E5HpBgBAhLO9BgxMAkiHUp5ySvYI7LwGxmACABcRoIKijuIOI0c8nwKiRUTYeyJjrFIkgQ4TiC1cQTHGThMrTW5DSdKxdKxLG6ZfL4/Bf8T2NoZKQ8zYfaKJIF4d5IomZVJ0hocMd63ObM66q1qUlSOSYLzGp02LzGNE1N0TjIpGpNoTBaC1GBRJgwMEi+aGxsgo2UpFM4qg6Ll1FE0WYKNjNNTlkdg+RSItY5ongMGiXi2BZQM0HPFbkOJQc83IIXjxIOoeimanzJGdU6zynVMVv1UF1/1PWqj///b/96iwOIk0lwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAj7kFMmUoAEsdIKUMpIACTCQU4drYACir/ru57QAAQAAAAAAAJjNxyyJAYEeBu1oDBAAB0AoCAxVMWUXyKjiA1KsAZuBgRoOMhFmLhAwAcGwcVlEQJxEXMBYAHwgCj3YMgGxcifiQAKLgMGAkFC+7rU+o1aQUL/haeGwByZKGLoMoapamClBb2AEEBuwaBFxSZgUvYyHlfiCYZEC4AWAYwSgOCpnZe1NdnUpY1gxQGMAvuTxOEmQwiGtJls7Putluit8ZsgZExwFkiYfAHyDgHQIKXnTQdI+DKmpXd1JnBjHK6LoqfFwCRAAAAwoFzYgGQM1HPIOQQxJ8qFO///+v6/3Wbm6DM6DWat/k+iQMiZ4gZJgABgMcWAzgYD41wOCrAGXg3hAw4kBQWHug38L7iaCFxcYx4lMiYpMQTK6jNZQnQMEBA26oB5ADmCQQjwdvNioLYQcMuDgDEQOEB/iBQIaIPOpDoM3H8vF8iBiRUNTIiVUhYC8Qw+JuNWczPoOuxxZwuG6BeZSJyYGCCK0UkzN11rW3c/X0b7vWzqduipT2qprQqVetI3UkvtW6KS1OvZTJNZOu62MERNhBSYMZmlrXTKRMC4x0G5WMz69eZpmh08UkUVp+///9Tf/////+mXzcWQQQ0SLiDoIPVapu4zGaWMxl/XZZSuZiSZIAGnoEG1HBAZXUu1LoeelhrIVBXxpDjzYOAkUljMmZ01qNYxN2Zh2pmQrWa870GM6kcpt3JU/0eKoI+k1Wh6Hp6XRrB9nef5/otPSqVTONn6aXT1bBhMcS2V9llTRqNVa+sKaVU0PO8/MOy29jfuWuzbOJruWNy1TUsts40tXHn/VpaXHm92d4ZRqjrSqNQ1KbPMtZU0qlUppaWl1NRqmtWJVDT7QsEAKVstq01Nf3jZnZbZyqZX8rfec7ll3v7z7rLtrvLOFalvbzxvZU1bGzZs81WjUNUsIisVnKB9mBAkAMCB3VZlWkrAVoqApgqXMScp3oe+rGYzGn2hqey1uls5XMtY1aWU2d/veNLGYZjNq1ljjVxpbISQAAAAAAAAf6z61rWuZDfAOzTiRc1GCnMDEvkgOMmGqRcRdi+edi+5m5oyZwlEEDputyTN1pqZSH7mDOmgaWXWo3rMCURUzugt5m7TN7qagzJ/Vp///odN6F6+g9PsnU1Sz6DXqZ6boOt0KCL0FvT1IakNN9N/rQ71FxmTOGiZgeL47BjAnAlBwYQ1SNCTKBgaGZuxfOMiX1KCM4t6nKl3rlAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH5YZRpW9gAs5wSp6s0AAnNkFSGUoAAs3IKYMpMAD5AAAAY67/65nXpIIX2BQE3nWMqIAUILCXq0ojlvlKtRrJUMDig5IBnD8Tj21a8FPbUlj9ySkHgGJVqj9Ud2A4LsXnwAoexWXS6NXrEpz3j+6liluyWY+tlf7hYiCL72QZG6Knp5i3rlei5asbrWMfz/vz8zBi+a+f/3+53ecy/v/+P75+vyypv1Ec+aq398/f8x/HfM/7ayywvXMolGprWscdYVM56re5dyuVrNjWd/Cn79/L6tNWy33G9rWP9w/96pt7s9w+vajuc1MSeRtbjruwO1ohB4UxZospfmCnSlcffipHrWdPnYpt465hFb2PPztZWiHngosPuv+G8hAAAAAAAA97rD9575ng+jaGlQNHS656lGRPGxSIsR5AgCqJOlo0JocRNG5RIsoyScjRsHkCZIqVVE8fOosIwUeNTU1Wgl1zq0nMTU7qRWikfI8VqedRNGxioye6K1utltsYUG60b9u/RbpaCV06lO6SWj1o1JP0mJkWSRE1XZRtrLpdLy0WOoGSSSlPTRRZSKLKSSeyaS0UW3QSSS6klFM1PGKBHDJDnBsoX1IaQUcJeIsQIiyy8Q4l0US6XUkll1Fi8Xkj1bRE5j0XoiI3TJwQsbFBMScG0AM6qAFIAcY6AtbGuI6AqWFFFFBu8iQDDQC04BFwBoEKSAGakcGLQb8FhxmLOEKkgHzjDGTIIOgPSBusI5IYHpLDV4ucZwjiVLoX6DliLiPUzQ+sukHRIufRIuKSDaTUjhSKAfoLC1JiLGJXUXzM3E3DqNyMJlYxyZBTVNIpmpPm5qQYoFRzA0QI4d5SIMN0fiJEq5RROG1Ko+YIHlLQQdBAWcVydRRMES6ak2paKVlV1mSBoRQqA2MBuwsXDI4YrGTJsZciZOIEyXSDA3RLIGcZgZM4FjIzgWeEKjBHKKZATauOoBcIJmXnpHa3jmEUPTA8W1loaQ4yLIHjUuE4aKMCofQZNNxzTYxIqRYgxuXiwRYxNSkXS6XS8shpNEuIXEmRMkWMupKubf/WGcjS+RcrDwGAieTJwGzYYyAMAikQGgwE2QDQwDBDQMQBNnLg5ZXFai/RAXeAWUZMLGQbzA3ioplwdZWIKJ2mQs4+gjdIc8Si5DRzSCmT7IXMC4amyBi9FJJb7USHksZHz5ZcxNUf/ZA3Raj9aLf9t61uddNJlVPo///SJ40TOFRRcqRZaFaKlDLEyl/9iinW6DdSG6jAsk8SpNiCw/k+go4mtlpMp9StH1sYkVIr1JJam////zjfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB4OJUidqgAbbMQp07NAAWrYhQI1trdu+RCfRzUm7SAAAAH5bxx5jFn1BQs/pujgCLVlsQ1AxsAKGA9qkBgiMwRIZgoEGFxHBzTIMWHS4QUVImyHDrPjGjRJkli2WieRWuQ4hpiRo5E+anxrCE5DA1eN5Ab6iKnFEeszIAX3LTmZaH0gkZTBJM9upG6qRmyBuio3WT54oJss2YxPJk4X0zx82MUU7mTGpQJtArl1iaYslw3PFtI1SSMzRRqkZGKRxJjUqrMk1ERJ4oDMjRIgJyGiGUAyYcWQF/CFIEGqycHaMIcJMjnJjqI8zJwiaJ43UZbH0jVzhxBNndlnHp/1tZl/////batEnR2i5kjFTNYAAAA/L98/kNvmQxHaC9F+tco3ecIUkAaGA0oEUKLhJAW9RDRgojqQJIiiREhsEwOksFgR2I0MSXKpeKtBUslA3JgvpskZE2QMuCiE+mWkyLFFEoGDkTNEDc1NCuOpO6Ruxo96+mtaDnUEEzxgaHzqCVpsfUmySR5ZlUkgYqOE2YG5aKxkTKjhm1kzI6mYJqNmMzia8yMkFqRJ4nSoPZWNxmRzg7QEhgzQhOOAgYzAuMvDyTxgQUwIaTTJk5NjVZ1BB2Wky11PZ1LrQ/1rW1v////6VjEsjdMz8EEAAAAf/cM7EXRgDCIU8mPuJ/zkpuPTQYUCEk7gQYPTymIw1LdSR548r5ptNTx9647IqGNKcWZmaudrU2dzGjsSXuFqxhaWCpnQs5P6s1LC8PIpE4yQSNZIlAK4ubInEGu11LNUtIpMPjIMZrNnSL1SSc4miePqMlaJqYIDmJY6ggSRgpZcN0kmQSZFbG0nGx7SNi4bMm4xhvGMThyCoMcYgD8ASwA+gSklRLhbEuI2TFrRKiwwTLxuWqPrWk5kko+kkiy+qcq/+p//////rRMgtwmKNapAAAAA/W8K8w6bEKQwyETjIWIg/RSe5BbuvA7ETEVpp76ucyZ1ZuJ8bHSKKNrHWIzsAOvchkhUkRGLSW7IZ/O7z5ZAkkh6tG6W/KLqqjYnBhd7A+Zj8yyubE2Tq0yoViBhrjh9B0UTJzBVdJVkjA2dMjjsiyRSKZqkdMk0kkS+YWNjJbWSKRkcIkdMzxdIQraRmWj6Si8ZrNzFNimeSembpuyymTpgsQnKArAcQHbAEcDyAAqFJCwDhLAjYWka4+SokOSSpDTxNmhEifNZmximfmLprWldb03Os/o6lmLN/+iv9mt69bUkiHhl0Zo2Y0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74GAAAAgqh82jm4t2xLEJ9G9NbiKuNUHVvQAK+kQn0rdAAiAAAABljljlKWBEwMMVBUw8zz5CKBxNRWcWD1ZlHmBQGFAI/GVS5fF+VQNBiyw0GLmbiShZQO00Zaw9aguORIhixK77cY2/0hq440MtmnWkEEwfjSUzoAANiDdZ52ZwkjIi5Nk4PRiTY5qBcTMTMJ4TC6yodQSM1NSsUHWpZBDpA0BzmQNTBIukycPmCBZSK6BdNS6Ymh6YnjQig9lImTI0IumxmYkcxVKiRcLyRsalZN1F5FMxRLhfZ0VjIEyKCJIvjlBY4HvgBkLhQtgGkloOyLmFjLhAxxCkRbSaJWbEOPu5icWfRc6kjMD6lO6KKB9dH9FlOkp/b3/1q/o+ykiyTpDgtSEAAAAfnrPCnhhZ6rgInHcJasETsZvVTxp+GMBPJLx44458veuL3ZR1MnKzIq8zHqGjISU1Q27GHMeZ3JdczjtX9ZZ2Zx62v08plRuTCo2TLiRYbuYoG6I/mNbIMk9q66rKTPLOpIJGyCZrNUUEElJGyJuZsitSmXYwRM0k0Dc8io/NTGzLQSUx9FF0kEjFBqaBamRSKscYw4sRAwi4WAmQwYcoStMnGh0xOIE4unEDdaWk9Gta0evr2/tpK//////qGWbP2oAAAAAAAABhQcYQGGNERhgZDjI5WgeYKBmNGh6SvC5fDnHRiM8wBDmdKA6bZnrZ2y+PKBrre+VovyCNxeX0st99yUm1yzF/m7esPm4m89R/4vlScm3bQ2dC3G8JVh2V089K5uxY+rbppp+nt1Scxr29RuX9w5nT26kPy+/lUlMrl9+Xy+139Z2+U+eesfyz7nn3Df67PZb32zzmFekpMM8sqSk3GKS9vuqli7FKTlfOxUlkkqRXj6JLM6bZwn7pMYGuZUdbOxds7w5jlz+//cP/W8/3///4///+8+0kbvyiWTLK1TsvghFdTeB6ksuw278P0mGG6eNxunz/8OZ08rp9U9v8OZ0/ZRF6fLDD8+1I3L+wAAIAAAAf+GG5W0tkw0JgBkOlOQcTpXwqxFYBjYlwpABUqOaQYhCQI8sjnHRzSLE6KOeMR7UQU2OBIUQ0qkUL7XstR04XVGKKjxWJsjR6K6BoaGBbNkES6VlVGhRMy67p0k2W1/tdJbsmdQSQepJkHRdN0mRqQqqQNzqCJfNETqVNlIl5l3dT1qWjekk1NMwJgh5E3JwiIYnDiCfEFR7MiIE0RpQQmBsRE2MVrQZGzvpM+z/7//oaCH////+mUSecAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlBkFYmUoAEofIK1MbAAKAaGUadvYALa8Cqu7MgAQEAAAAAAACMIK6SShHYGBBEBGoo6AMcKIG1NDgA0iknx6BvcokaYmIBAYAMOGYAcaAOlGgJLg9Q8GMxhCFRbybHOHNGadi+Qo+BekCFDChRZqJYElQmBHjRQH0JuE+jTJ8c8suUi+suprRQQjkEWFfJogRHjkEwKGEmM7JFgiBJTBaQyw+SaG+iTBQLJxazEkUDZezGZJpKrlg1L6ZFCBjmkcR5ASkkkdWeSosoyqZSSnW9imXQvgH0GySRFEC+XDBM0Y+XjERmJpqSUpV3SpjkmtKykPmhuWCcUUBmA+QLPgYAUBnRAOYAHEw2sOYIBi3CwjbHETJSKRFxlCgQcnDKpS0CLEOKwIQQAAEWwa5RPHTFRZRROqqS3Ts+brK5DR6ctqSSbW31gwAAAAAAAV1UBLQDaJw4YziZm4bqYAri3GWKp08mUnKiRmaoCwCuEBZE26KyuO4iJypa703YfBKlInin/+YOZFQqGX9mZkMxJ0pFEjywY/9v81SNDymRS///+1NaCzV5qba3SWt/+r2X+yJYJBA8X1niuV2UZGv+gman0Gdv//9ZmV3oKQQ2/0DBFBnYqDLiuAvidBlyRLBDyNMDFkE6000HuYAAAG8eY/lWprUqaUuoQhgj/gIHBglD0/nhHYdfm4W6AIMYGEHZIKKsVq0sJfmQx1wbEoeTnS/D31artUcqmMYrJoBGRaHJ7OM3aKxa1d59uvMzNFQ51tY85ynQ+n4Ki8qwwpKfLOpO6q15TQUtjt+5f3ejM2nRTd3jzfN3u9yy//3hl/O5fc1b5jE6vM6buev7+OGV3HDnMrXatbWdLGa0e7n3H/r00alP5T1ymr1536vLtvuVmzzkppcdZ6v5a/+Yf/8tcuX8ucwsR2UuzTv1J31mnDsLDFuI21RpdMw6AWZSGXvPdmL+NS9ybne2Mbsqv4448vatJWFyoF9xU2+thAAAAAAAA/us/x3zHfxFPU4AhIqlxxdEmS0XiaKxkF4gZaOaVXKQzRseWQIvF5MulEeEVpkaQUnSdOsbGwm0zYyLx9NFFSVpkkksyNjdFlrRMUzVMUCTJqoyNmoJGRtY6XkloosovGU/6kqST/9KzWoos6STopJOtHUkiySSkkknSd2Joh5BTWjUta0UVF0xRRQdJJKupJKyKSSWii1JaKLdI1R6SRNFacJorGJMkNHkfQWIhgkXgnYm0SZHNKpZICOaVSdRMjY4xwmjZI2ig39FAs0V2XfyG4gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI+IlUBWcAArxvmlCtUAAfBkFKGUqAA43IKlMnEADDGNzFLTPxTwwAGjmcQ1HAhV8NNQvBgDEU6TfsisaEMRhp1b5Ic7gXq0OHFjulCIMfio5bcIS9TTGntcet/Xnfhrb1Nq78ARNuLmv/QRSH4hSwQrugq2r1+pXlVNLInTUU/KJuLPdGpy1zDGvWysU+GNa9G7lqizqY36Sbt36WravU8xKZ+3Ulda9bpK9a1LJXWs09THPeH583+Ge/33mesf1Sc7+Fmn1fw5uXxCMuOwBlTQVLwYQRHPKREZBVCNItNBgLQmSM7eCAYs+buROCIzJ4pK7la7a5bpK9azOy+ku1rN+xnXrVb9inqXe3+Xd5xq5XqPFFr8tv2KfC5O38O3M7nd38LtazbvV6lazfpK+W3QU0hqQW6irVYxIWB6ky776QS/T2MvaRIkEaTQQMODEMGBYw1mFD2OYXSmUiAlsZAJmwNSWGdFuFsFzjgH8hxMmpmYGajEckiBNlkwLpsVTcwKJ8LpCpGq9FbIIpMmamJotFJSKqVazxRLhPOswPupI22c1vRU9KjV3rq/+9atGiqqkpJKlo/akl1oni8tBd0DMyJwzUyC0mdA29VJ1/ai2k7e1bdalmUyKyBsYk6xDTcc1idFbE+gZFYnkZdNbBCsMjQjWVWf7tBeNWL6yYAzY0DZ3Qc1Az+ADIlAPBJE/B84pohYaIe4ECxDBoGHiCFD0BgQtAHFoOiDkQ2AZgxFbjrJkZEXpJhtxGInAFgCZGJOhACCDlk4TRiihL5XMCqspFcrBbUTNFFBAZoW5iJmRQD8UThfJNRDBMSyYsQ5Ig5FT7utEhoySSGgUiOPoo1GxkeUXHabJmU2LkwNzrnknSRUy0UjheZRuXy5rUs3pkwZF/J8uMbH1LYY4OsLLIoUEFuiYubsYGJZEbilDEqJldi4pZ01MhrDvD9RZIm1THky6apNdFLl39XoAhAA0kfUhr6v/sTRL/RrZnr//UgS/wQAAAAAAAEswnSICuFYEUAb3A7lZAkRlxxkDHwgKyF9yMAl5XcWYQ4lxCQcoWbZ0CRGdHUQEU4VsIRnDRd2Jk6SQ7iiQZh4Igk7oM8gAxhXIIeJ8cwQKQccwjCbd/kUNnNEXTPrOmyTN22zMuF8mTYxLpYM1HS+Xy9JkyMd3Q7NUWSYJQi5OIl4xMTBEuEPMS4Xy+XC+5U7rTQNFGhogg03NiVMhPwHEK1EERzhwi4SkdWaHSuQEcsa4Ng4GxgMjCUSSHokTc2R///6/zc+ipKtd+/0XkQT8+fZzZqmbb+tMbBv4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACBGITwdzYALCsRpE7NAAXh4jOo3ubdsjRCfRvTW5/LvzMtYCw9TEIHR2shmBQAgGTqizVFpJ1DgQYSQH1nxMUsSdZm8Numt6IMVzIBB/5lsj9TcraknsIxwWMXdklHTye/S8llFOTcEXL9rOhoSyT7uXAll9KamilNJYq7tWzdps5XSEALR2sd1rkq5a/+939X79eW1vdv9y61PzHbVuru5njepbM5VpcNdyrYZWGu2Ltymp4llGa+OU9fu0tW9YlX4ZZ1+fVnbUisYTEse7cCQMo4tJfamSA1AEXlgFbKKMapX+drKbyj0zOy+ieXDHtJcnqa3n+rVjLD/1z+5Zb/X/+//f448////////53////+f///8///uVatL5faBedgAAADeGWW6WGXEaYCLTnqDjneuyl/XdmSsGBQMywH4XMTI0SdHUPJecuivGBPIEVLZoXiyHoiLrLpROUk0UD5skmcNFuovF8gIruUkjY3LxWlIixkm7F1EpJOtFkUWq9J9JSSnWYl0yUpJI+6nMUVpsgkpXSTRRRRXRPJOp2VurrVWed1ooup6M3JUhpNFEUKKBAoBAOEg2dDFJVMXWsi5qYsfNzqjIyUt9FBVbbu/6S1t/Ukl/////+iYkyQUipdbIgAAAAfhnhTxhr48MAoxAN2d3PGEgr+TPVF3hcKOrtPeP4Jai02GotDj0PQ9z1DIETAmcYgOqvWFUoyEESDD74TUcq6pvpqXF3ZLH6PK/KpQECstf6HYZiDGJEjM3NUjEiJ8zNiVJwM5GKyZ0+kpJr3pIJsjLSyAnSYTSQOzEuJsaKMDpgiWi8bJsaUpMmhVNSKnTUjDjLciqRqpFZeLzl487psdmR8zL6CUsEgOYQ8aggkOMVwLmAA5BdWJ0FyECD+j4FBDSJkmBjSOLqRaLxXMS7ZPY+gXUUlmqKkqS0UlKX/e7rb/////dSRkVkDZErCAAAANb1vV2CndRVMIDT8CgaBWhS202XOMQwxU8ldVNocMT9x9mzzcvmVluZUzqRGORzJ9CI9Kc79i/Z7hyHoewtRXedn7MxBDKItSzxQTcpUx+dNajUlx2jGSrXNjJaT10LKQWouomiBsbGx84uaKdJJNFkXQdd6aaKCaRmfQcezMswRNTBSVFbIKK1JXl0pM1AxKQ7RkD2LpTH0kBPQvYMAXMeInAiykRTcvmqJucM01GCSFkUp70K/r3/9J//////6IliZ+XQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgaic2Fc4AAwDEJ9K1QACkKQVaZSgACVEgq0ybQAv3nnEGcBQAKlGiCIGmfcMBkwOAABLgh9jSaSDgqAzB4POFi4wEFC/LgrAyC5VmHRmVdhwUlkRhqWubGpSn0DjYrZEJdTU39x+HHbo7/4V9S+RjQqdtucqjD90VLQ0DxyTry0mdHepq6hqF9Pfxtb1X7l+HPqX/zz1LqzYMsJfnRUtrt/cxdzrcna/ZvHnbP3ZfVpZS7GVfGzN1cKOgn7cpw1R7z7Q/y/hnnq3F62sMK8/Hml0jY1HWWigTiqOTvjwJf5X7Jn+lLeu5DdmVQ3S75qWY9x3jf1+rmdnLv9y/6vf//////1rn55/n39f+9/n39f///f/////v/+v3fl8MYavcZAAAAG8/1hXiY8DMiDNFkPRlDB7j0F6CHggQUuDgQHJhB6Q7CWHUTRoRxRIATIipuXCaJBAgpPEYIwBQ2YkSND7vdbGpmXy0XVSmXjEjhcJUQZSZPHzJRuTRkkqYyka10Um/9mY+mZHHPJospRipzZlsxkoydkK6BgiconT7nTiCCamN3dTorUpSakaM1SahQKQ5BLFogAlwaoC4UgYmBFyqWS8eIm8oMRIoF9E0TWip/Wnen///r//////qk0cPgEAAAAAAAF9IqDnGziZBMuJCI3UIxGKMwBhVgLIQMZRLoIAYX/IAFkpSPhy4NmwuHAwjADRBAv8A9sFTBECJiUxHZPhYcbi0iBiBEBHNHWXETcWQRAY8SEiohcUiQInxzRAzmonQkEy4XBOpXDFJUIqMsXjFBJaJUKxDCcN1Gg+ykG1jkk0OcS5AROwqXYZtIqE+8vl9MWcLmIOLmQIwqnC8mgw5qCKTqTebnDQ+XDQn0iiTRuXiDDlkCIkZjlEWsi5km3c0HPKxOE+TiDoM6DG6Y7yHhEQJxFzEGJUpGx0ySSUfcxIGNlv/umm6ZuOWGRxYwMmFELCAAXNk8TggmM2bkHL5uRQuMQQihobFcmSaMiNFCBjUUIA9ECBIBmwwY3Bt4LghSxHCzhQSyiUDMiouU4ZkVMVVvzAL5DBLBdL6C3SWpanqagQAAAAAAABXSqD+g8Q6BgF4uG5uKRGkGNiuB/OkqSxscWgaF8vyRMCTWkRFmKnQNx7ku+pN6nVHIeUPQlEltX36DKQJdNL/b3WSZTJRaf//5otPc0/b///dTKQZBD0DJJSv86611/2cwQTTTpplxCgh/oTS6G3//1qWdOmqkUf/6CemmmiPdMFLE8HgokChUgbvTemm4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIMYnRp29gArowKt7owAAiciVQDOcNyrhAKYGsLbiwgAAAY/vH96prWUSi66DSvoyEiEhZg0Rps53KO0SSUDkJuZhLmNBqGsEONVg6NU7jzlPCo7wu5PRaPwVnM3H2nI80oiCS9Uvh2tlZkncc+ZWK03S0FBqa7hat3qVKeJOk90H38rG6tBEtWqC5Mxzl/C1WxwqRGfTyx3vncsKtbn1u//46x1+6vOYUPMrdL+FizVz3z9Wt9q/+er9WtjnM2ZKy2QUvNZ5d1eiUtv1ala3Yj1vdjWf5XcqvKCpfpdar3st03cb35Zbv1reGv/LsrsMqmYRJ3Im4YdVXTvNWVyzN9m70zWGoPtY7ST+Fu1Vmaa5lnlK+Z1edu3rdLvPX2eJIvWHq98gAAAAAAABRVpe6BFgG6GVLhtrMk0HJkmR1gC5BUTUnSaTUUi1MTyR0qGSRkUydUZl01dEey6g5iy0WWrUovOyzh9aknnDV1DmmRsxk7omLLNVOs6a1o1oJUfW11t/71V6T0rOk9XWjUkup0WpOkxEi61LR0VGyS0UVoout0WUtq0dJ2U7VqSq6TV9E8bImJdUtRAisPoQVDEQyY/EKdNDcgJXPEONjFBMuoqJo+yRsdLPLSL0yNyCKtVIxYrxueZQ/JcBDRTBIgTnCSGHonoPqeCopjgo/qbzzXMUOpzwLodNy446EggN/6V23/pJzNh8uhhr8++juWWdv/ajCPVPDcPyuYfyWtbYhAl2nv2OZxvGVxunqSy9G3/f2KfPb7fzv50+WGF2V28Ke/9jDdPL85uiypLF2Vy/tP2klnK9vCkv1IxYzp7fdb1/Mcfz1n3XM8/w/Cksc/VjmdJhhhLIxVdNibaNzSHZunoYjGYSAx60VGSNzWPC3AcSZcuEROH6z+RSvL7+famFen+ksVJZynt4Un1+V7eqTlu39vL7Pz93kslS7ZBF+zFivhRT1/DWefMstUnLdupUxqWK9P3Db7rvXROZ2z/EwI7RDUofycibv0zsO5KlyOSWrNPaBwdQeJO5I6SWVpRS07O2mHfkCOG69A+Utj8utW8qTdVwa1S3OXrs/jSVMEVa179447/PP8GHk1mQ2qmaqED7yAIZtoPbMOrtx1tbdssXUPT//F1H//99f1d131Tvrmv/vd/EwfLW9TsY9M3unzsarH7a5q/+/j+a//ht/++JRMpPIDuPECQzEB3ipO0TA2hxOftY5snZQZPbVP/agAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABniIVKM5e3L50QqNazFuWuohRo1ubctvxCkRnM25lQAAAFarHFhoem7N1rzwB7ryQ+u19GvUcdeZyzDqeKnm696yy2KONXZjM40Mv5jFZbDDrZx2W15belUatdnMaTWWGONSQ4QbP3MfT+kaFquqWn23W99UzXW61pjOa1zL/u+tQdZzqlsVg/U1LWrL611bHvSJ83xrdNZvfH39Z+8ZvvFrY19/xn1mNcOZzltBigRSlOYlTYZiuncWi7NhubMxXDEa9dV1T51q1cY+df+2619t5r86+vn4ri2a/f/////z8W/17fHzXWZVSw6k/AAAAAAAAEG6WMw7rLKITSEwDlUuXqeNkrcnGgtmS8zVsULhTyQitKG7xSPSJ3YdjMOP58fj86/jfU0hjN2O2ZqNRqvH/3lfr8paeWzLeSy30xJs2QMy47oopl44xGJJOi8xRWtG6KKJrNUXMkzNM8fQRRSMnRPH0TrmSZmyCJiyjdI6ZprUaGaSBmbsUicQI4ihMl80KZBDhMDMFovDlESHOIGXi4iLwUINIQ4qkGHKJALogUoNwiiDPCARMirE/E+PkskccJ9Me0yZMTIyTZNaLus7SZTutHWk60aVaNmZF1sprqWipTqe1+zUkloqSqdaLSiQUiJ4PtAAAAHMse/lZaupcKpj7r40/Nqq/0Wq2XcMkhWIzT6xSGpJLbsC8ZI88przVLCZuM0b3/2UTNXd7LczO8jztWsK1+VMeepmUqpn+WaFs2IqXkyBF5TOUY1DWtTpomr3dqjZ3ZM4ZI0zpFkiiazE1RZFTol01NVl1LUbLMTYxNi8mbnDZRxJRskZOsyNmRZaSklsTRdUyJiQEzLpAiCsPscgBdQDJhS4WxTHKH8ujhFKk6USdOmKZOmJFUzFG6aCVkWOl51fRdSX+ynb/////vWiZE+LiTyUDAAAAH/zv52HzT6Edh7LrGpa24BfmGoQoqfxbtQt4oVS8ZdQOlLpO9+Fd+ZU40ukRYGRqjVNuVS77WPMM8IBhnvd7pWnV3FpaWWnlk6xDkTMZknUncmiLC8Mqlmqi86+6qKkVJomrOxNF01MjapKyV06RkkkhWiarWXjImSdMSqRU1PWTWYomJdLpqYqUkgkiqdSNlJGRBi2Q0XKbEQFJEBAREDMURgIJCgioPkig6hkjhAisXj5FjZIixPGSSRiXUrKMkjJFu70mRR/0qO3/1f//0aSRdHIFwnnZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAeUiE6jm5N21jEJ5GttbmDGITYVzYALGsQn0rdAACAAAABvW9V44o/CEqhItnxwMRBpisilrRHia6z2BDl8hCVALmL2jeLaYLFlI6JUduboLjFGhSQlLisNp43FYdmcquolQxl2nal89aszuAsMSp7Ze+spLRsOpMixpLpEEkGRJ4GoCoprOMgktJbKd2WmkkoxOC1F4mTM2Ny8ial40oKWYILKh01dFUwNiGkafTJksmxGmEwSJdI0PmyZk55E1SedOqPlQ6Yni6cJokTwyAxobMITh74NzwGUC6sXgecgolMUAOIdpDiYHJHsvFw8TxFTJOcPMamjubrSRNnVZpi61r/drrUv////q/c6WiZdlkAAAAfzvM70jQsBREYwkHBHlsUz1+LkGwhwRDEOk4EwumHX4dq/Xmkbm01B246/mEtIB+WWdUsWnrHe23agfsYu1a0u5SxKXqLupVgNZNHqXlIHiOiVSmS5QElQs9jJaJo67qRU5xR01NjNE2My6Ym8vJu5skbl1a1IG1djprQQMzeiOyoyTRKJ9anPOm6jxmaoOmSRcqTTJ5kRA9DkJ4ww0DDAC0K4BZDwHsJqIocwgRomWOWDtJ50mmbHmuYGaFTslWzKXXW32vuv/+/9n//ssSc1pe4czrz7gF9A4iGShEZZmJkV7GQgcYMADgsnSLQ/TrMCDDKhg8rZMDFw4raS1h3o1ng3CXCMWXJZhx9Yefh+mUCiAi2zaGYTJJd38ph/JTSxmHam6fJwgUHw4zBu0QbDuVxmCIYh2SRGpQUVLBVOmUkxSYUG8tbvY///u13HW4atv/OWp+h1T0mVXWp+7Q6t1+VL+Odndu/V5HqWk3fl0iszVizq7YzmbWGHLfLn57/5ZZnN7uy6R0rOJ5ra0VokAMAAVYAkBVhGfuy+EvgB7qSB5+DY9jqm1jv62W79/n1Pucy/9/8z/6/f//6/HXMta/////////////+f///////Nfds6nw6aMAAAAcr55VKR2GVp2mHBZ+QKEED8SC3F42/QhMLaBlroN9I0kSFIiOUNBZCl8X42C4USJlQgpHkeERpBhzCfN1JalomiBKMan1uUC6RonZajYxOlw+ZpnCkZLScxSKJ+m6RotXvpIMpM2lkxQRdJLPLRSQZKZJGLLQUpkVGh1M8paKamTSUga1KTSdJRkpBOhOqQus8TY6ysdMBQZEwuDEoiGDGE0OMuEYXC6icMSdTJ9F0KNdqKrKRQr/r/9f/////+x4iKQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAALOZBUDlagAH8yCpTJNACh9ilGnb2ACz3BKzujIAEACCcL46BjRzQIgYDHADAoAQMQhAhA6g8lUDEAcAkDAMRocQRBoHhBwBoCCQFD2RjkDxBwMJgMDLg4BwoAJD4GggWG6NFCtjQLmwLAQEwGHThZULaF/w9rPusQnG2LIDC4dAK4H6hjALijKkMXUkgF9BSwW+CAAyYx5FhLQyyRBMdTk7ZsQTIiGXxH44RQZXLYdkCQOdRRD9aKbX3D4xYyYE7lYnCkOYVC8OSHwimGYyxDZyynZ93kAHMJwtizBOgwxWgyA+BwGSJw3IgRYxJ0WcUS4qyCyLmJdQSa+XyIJuIIDZMxzDxPkQOlczNxQRQASHBOxVIsMsZE8kcc1Ur93Wbldjc33VbffQMCAEQJ84MwJcBgIHAYaBAGOwmDUCAYWAgDAzAQAAsUEsDlCBiDBjxxkDIsJ0FWK0JAfKZSMTIcoLfg/UTgBgMeAYqFIGFAWGCRPIg0P2KIzwhMZHSKkVJ0xKJqTSJAAAAAAADmqk1oBisAHxDQBcEIgv6bGBF2AgBBgOgigGsSh88aHSasc5eMhbUHHikcPjU7TVvXZaCbKd97Losi7an6n+1D7terf9X1fX/ZS2/1v///UYmZBN0Frf/c4t2/zFq2R///////Wmbkos3NE3W9//9FSysljJ0q9f/A4AAAGssvy5qVU3tySdMCFTkLg08oAwU2zoxqPyl3Y+4rZVFTEGU7FdMIB0RYaYE/cYksYf6gi2dHIUEEcwlLsY0EdhipL3BAou1GOwRXwpcp3Llm7/J+WxuV4zF3tmmuwyi4+r8KbOta/n3I/Uprde5L5iVYdrXZ356VzSmO6Wlxxsfy33lzvdZY3f1f3h3PDlNqPWbXZvHncs/rVfuY5d5ev3K93HCHnigOEVI1V7W7uvHJz8qK5dtxmer/nhzuHL/LVukr4cpM8KtfC1e1vHO3fsb1v8eyuON3kkZl8cbouaBmJpKq6Um0uRsknLK/IVhUwl+7N7diXzPc8oxnlV/nbNegrb5jqv4hM9YJihLuAAAAAAAB0UVqSpLiRBBwveiWkqjMwmZIE8J4ALMeCeJ4lSYWbkNIrQKx4zJw+iYEXJBMoGZaTMhWiaBdMqZqlZ6zEsJopF1JB0WmReQODyRI1MS4fRMjdlmS2WamyC0HmqVXqXTZ6/61Vs9S2ujUg7LS2SqW1SbOip1mY6DGzVqeiZHWSMUFJGNTJLs6ls1SbLU9R1B3ZqSTuyqRROIqLZVk0PknB9B6gWnicCqLcRVEhhByTKBKlgrsTJePoFY1TY+a4DU3xHU9p83YvMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACDCH04NZe3LOkCpQaw9uJbYlSo1rLdpssCq49i243Xp6enzldNBLETAhwMHR7OmyNEGSIWJFJoLBGUIpxP4xqJlvATckIxBwGcNYkEMQxBbtv287tw+vN/43OXsvgN+3/duVpmuvT9mJRDE5DDX5fnnmPnddP37G/Y2Nzjnwo3NyheJuO8eMGKPGyJXGsUiRHjzMhxUePHjArIkeHHvf/FLv37+PfeKX3vcOv1873vd77+Ka/7x5r4pdnjx1IaA9Ym4X4DuKWFoACADgG4EjEzIWhb+P8RGd+xq9Xq9Xs7+JAeQIjyA8eM79+/fx395YjyA8iQIkTV7wL0XLY3SK8nB52i7kbp1h+47k3ncTFr33fcOeBAeRHlMKQ6HOAAOnAAAAANyuG3/h+NxuN25Q4ECJ7DPooNTOGVenjc7cpZiWCDR+YxBrDkQ48sMRydjU/Tyu7VZbG68xOyyYnMKSa9NdtLGWFqrzvMvxzEniZ3HZaWhfGIbixGE/xiS9LPZK1xibE+pdYktPZlt/XG721vG9f7/+//6+T6z863resZ/tn4+dfdf9YuqVTGvulNapd/ndPrEK0T4xulabx8Y+P8/7xPbef84pn//G5u1K+rlCRJkuYXw1jRVxfKvYTJbEFxviFDg7rCtWKcOxYLrcRWW5oEgAAAXZbQO0zpnUPOQ8gIXngeBgoqBTMHQg70uqCAYBCGPPHJ7gYahqwVdMMFqi1LFHmfhb7SXFcZ4aeq6TTkQ06mJRJhzKVSsRWFVKxGloeQ1Foaa9D0PP0wRSpQZxo1GqaarTUNRF/Yrh25cjzWmi1J6vcz3KbNzLf3bl2HYzKo12mnrGcZh2ezlVqtazqxmXZSqNSqmlUalUZjPMsqaVU3d4/cw1llTY/urjZx59N2W8/U9dlNNa3Z07TOl1LGjPJpZRl0HWwgOmVVVMkVkASDyYyxljMOYc1lrr+tZfmM1buWq1vKmprWWWP9yyyyyz3zHHHGrS0tNla7hGqaVSp/Z2rGaWUy3HGmprVrKmtd1VpaWls1aWlpcsqa1vGsyJIcvVTU1qK7zdAoK8oAAAAAAAAB7g3ScAXjmNJickOUihH6LieAtwHjo6K49iWP5+W0E6ACG1lb1o2iosyk0WHmW9ynT/zMSdmZylKNnjlHGpvlNnfL3vfVN7fxH//3TK/fbzjGMqZl9b7l9wy/6qX3sY8+9799/wxmzhlc3++4QYgaG5LG8d4C4AY6xvH9sUmSzd5+0z+JwI6UORJ/2dYKgKIf/1B8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAc3iVGjWpNy3tEqVGsSbh3iITqObk3bYMPn0a1BuWgAAABj+s8M5QutewWbHWfrEgu98TgXktXMbT0rFIJS70RbrIq7/X0PYnUf6AZVDrXY9K5+pD0vu2auWOcdd3nvtbpaWpATL2xqqurTQ+gbE8XyRLqQ5RbMUnKKQ1zZS1nqJr00aJx7qMC8cUXlm54mmmheTLqJiYE8YmqpikuiXk0jAdyRPGRgotkyRVA1Lx0uorSRSMWMD6JxaiZdkkkh8l0hhFxpDkrImAZ4FIChhpBDTQLqjMcJHDuI0cJVLA5R0hpUYxNUkVKdkjas6ySWqYutv6nu1v76///9FlmBXHMIoms1S1gAAAD963rcw+1GhiH7FwwrChikWfWiaWb9KCxSNNdpG7Px8GztHCtvy5Vlyn+pUOKQU+7NizWyu5auP9Rz0RuX8qsOvPJGdQNVwPkyRVRWUZDkmjmJqXljPoPUbLKTq1OtSakVzE1MlmpkgkY1rRSSSoo0jdAyZJTl1EyKJOkyXTxuYmpSNndaBkTxiySZeSKJqgvLBdVRWQ4kljlGhkRIZQA3g1eFzAnIh45YgKLYM0TJDSMIkVjEZlAmi2eSNkzI+1Sy6ySTrbakyrfWzOz3/+///9KpZgKHImWjJ1EAAAADHW9XZpnrNgEFjFZwO6lcMHy/X6nWTQ6wNfaOBv/GmC5T8Oy9DjtckrJH2FABUcucq3NLsfuNkAPCsKd/pLdrXscI1SwbZe6vM0UrqoTGGo9SqSzJbKREUyZLY+TEkCGl2TZHCWjTanKJgjTRaisxWmWUSLmo6y0Sqy+aF2xP8vWLZmVTxucW9OVSaPpkrNy8ThuYkVLiROGbMpHPpFAyK1Jimis1QMSiPJAiHjNizBbhlwuIBpo2g9YliaGTFkCVigS6w8DuLpXNyfHw7HlmyFFbHnuil3lFSn/o7mv/9a//9fVQTMBjiVVVKwAAAAP7+eFPDg0DBRId4GwxplU9Tl2UxF80ZTeTVitbfhm8Jbs5MdkGSerT8NY3pZFsy+pFD/6eLym/lnMQTMTMJnabs9vSYFZmeUzdWaj6lE3JhEwMJqakaHVHpS1rppuqp7su1RsUy6bmKRdPLRRTNkmUXzVaCCS1p1mSykpJZosvGy0UCgxsppoZqM3cpmKDsiXki6iosmhRI0WIhwngUOLJEYBDjMi5BzysLgGARUZ48kbEPMTRInjiyedJJM6YIscW5xGqkuyP/vUlS///2//rRIemKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfch84Fc2AC3JEJ5K3QACdqQU4ZSgACLcgqAykAAPw5t94fYeJBAwIFjH45PnmQBBtc7N6B+VsPGr0QhYj1iAGAwA1FrT6wy/UfxaYIAwaCqeROU9UGQe8CuRZPX/LoHq2s+YR6YpJdLojU1UxeoqhMjgGmiU5P1Ls1Wh6khurVtU9yWqGqjr269jWsNZf+Xfwy5/ZJ2HZfXt3r9By1e3Xnsalumr0ueG7eGtawjU3E6k12M0GNflfDdNhXw5jzLneY2cM6fGix12gkb6wW6OUmL3I/ixMqBUpMBTC7XQiMFu5Dz9QNEJRP/Vzr443cLeXe8sfbz5/8/VXnefv////vOd/H////////////X/+//////X/rXapepgAAAAYbzz1DCthMABBYYfJm8ORjAIg5CadutLSh/AIBwNtMAOHDmEIM6RJhbSwTbB8ROE6RAtMMyRUg4YvBEkEKEIXC6gjOmJdLxPoG5cTSOGBLFIOVJ4pE8XjIljdiYNSgfPGJqTpuRxpus3TSvulUgktzijAvMYpHS6arMEEzBlIuYOYOtSVIxTc5NTJA2JpI8gaoTiqS00EHTpm9KXlMpFEqHhrEwZjkDIjXD2AyyG0iUSbJkaB81LxiYEAMiiamB8zSWtSlJstS6SdfqXf/0X//////TSHWQdKko0E8CIgABgNQkAaDgCsQupAaJDyQclCuB57oUZgGkQcRCBOWRBoAwg3YdQsgL2B0YG9fgQbggKGpkHsOUCCDTMwMKHFSAQFDjszyJlAihVKwWiCPg4EG3QhAFInnRUiMyOwvrQPBbsL1g2AB8ZGiC7F75eLpgaImxcD4AyGAwXE4CFRTgvnQWq1mIg9BaZuYMKeJwC2YeuiMoMoOMkO1mXbdTnGTOFwiBmOSNMcw1FuD1BOIj4WkP1JhdNE1IwoFNNJ/mh0voEuTBsi7oMyYgmH+CykBgeIcI9HoXMQElCONyqQ0vf//+/6F3WbjuHJDlwRAxbBBMMZjkEgSxbJwgh02J8wNCobqIuQQa49k+Vwb4CAQASTA1EIIcgGOZggQAJHAKBwRBAbMhboOLJUVqKSJQWIWEMui8HPmE7MwuGAzxMEAMBSkDQAFCJOLJI2C3wWAXMJoCeMiF8SJF9RF0EjxcI5M64taKzUghmYIjnKVRSUt1adzJa0FIPQMVOvUtD/o/1N1Vf9fXqdm1q1oprv9bM3+tS9tXOJjjICanpqrqqcxIqgg6lv90ETijFtX///6//+zbf//6a0CbJUpHUUHSWr9WAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI9YxSJ29gAqwP6uvntAAhCiVKjent22pBqZGtPbkEAAAAVrWssst6mmApymBA5hRGdATGpjAOBnmoZVTNaZNTQc5IMBQAInupgsPMqjVI88qlkEqdNah6qu1QVlDuwC/0YclrM4/MMv7gFxJiEjg+pVpae5DLku7LcbuqKrSbsVatWc68CHG+7qYzjVsssq9BVps8JTdsyfeq13KZh2IvqrZcv400av2sPxxwxxx1jru8sf1TWaS7lHsrVaNXefj+PcPw/uGW7VrCmlThNaLVGGgyKT9Ve48535ZRS3VPcvfP4Z9w1+fe3MKfC3b5uv+G712xjjZ3SzOderZs8ppVIqjcJ6FyeLKDFljBwYECIcMlxXclbzutL33ZJG7fb9P8atYySajWWdWvrVLvdiz9PKabLWesNVq1nmyIMNgAAAAE/9a4xa2MQoIAnH/Bj0qQW5mVGI0DLGAc1PkozGxLsZGruXEXWS5cnTY0pk8tYwOumgv7midE3QUyWmtzhKF9TmjqWkyjNLMEboLpqp+t2Wpq/9rOhoJ3QrZPbUzKRfTUy0LGBQM3vu1aSFS0qCe6DrU1atk6kX1IuvqdldZugg5cM1F8dhWXAUwS0L+O8liikTy8U0yQMTZEwOqQL4QJnCUVl6JDn0EAAAADO5Yr08xORuVtVamhIXCanOGNAy8XLgxpydClbTk6KVocuLBY7g4vRJm7vc+kJjduDX/iTmWJesmBKJ9KJ/4fgByIbppUFxL8y6ciM/QRSlhyV36kCstlxHZMx4TyVzeDLedVXpmFHrLi2I+ojLSbPiVvSrAW1/t5qHGgRpNQ7wKQ48OeBNfdM5vv6ja3uXeN4pnOfam77tSDuHTEkze7QxhJYZ4/w/B4gO4+gYhshyHuP89DoSKHtygsnIKvjqx0/vuPek0O+IloFY+6arXTf4E0ON5pmqO7iJpd1Vxfw5kAXlGq9EsL9kgs2LRoDy8Se1Jrv6RPA1e8kBtZ1faJ5pnSD4BAAAAAz1Yu09ykxp70NwMmQaCoDjToXa9n5qLWqWK5ICjlAV6Sh/5mMxyVx2tnqVWqrQct1oZkOci7MUdcqAMJ3V/VXDWWW92gwtZx1bT1jWbX0Y7ifUg1bn3w1xIUatGqkKNLreYd48Cus/Ndb1r7///9dffz/Td9YjWtPWv3649v/i9PnWLK4lyFT1+q13TMHVcfMGl86rS1fS2/nWN1pbfrFpuuvnW9f5+3rjZrYGZya1wnixBAgEYhTCRDxPbQ26dbGeDFhYlcstutvYtJ7LWPXXmbF8f8GEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABy6IVfsYe3L/MPqtYzhuHd4lRo3qbcu1ROlRrMm7hyAAAAAAAAAKGEhViDYKbHneryGBRg5eK/BaYrLWGwFInKa8eDNtHaX+Q1Gplrt54qezEaarhD1e7FIajUzLpTLaCelN61aq41q9nVNLIjGbFzLVfa9rxZLZi4nklrndMZxWlvXMK9fX2zqm6437etIV7Yrq281xXG66t9b+vnP3nUt9xpnGAzXUkdKOceyjUKmlcoLEvmII8QcA1YUNYiFBaQ1AjRgnibqGp5VMKzCZobFd7p9uLq2fb1ri2bXrq2669fbddYtm3r9br8QYuLfWLbx669v/n2tnXt7brq3w2n4wbDXSgAAAAAAhB+7Mq7ji9TklSYC0uUvaaGgprarme9W5rxwEK+jLy0kPO9DL8ymfiUllmM1XwjVmrFItPTN+I2Y9IoZsSrduzNZ2blqWPC/vLV+rjhW3Wzna1rdmpaqUvO9527hv8u47rZy3OW6rV8bk9S2qa9Tdmb0ap561d5cy3jlZudx5lnjrfe75h+PztjVNnM/aual9FawpJ+KzU5WpaaCX5WM5ZdGSvy9CwxAdORDZhrNXZb19oGgGHaCNVY1nS3qa/S45Y/a7vHWW62ePMu75+P5dxx1lvv67q1/1qWl5+OOu1abuPNZd/98y7jjrLuXceZd1QtIlB47sQlAIAAAAxx1vV2SQC6pZA6IMYK06zWpJFKIFV8ftWrTEZA38SlbbUDZ4ypm02acF9pp/XcibDWzXJmchrOzn3GAZZfgF+JfhTcgJsr6JzRumfVMipoUyHHDUfi+ZLYxJIbhppn0FlVrJoLSNHRPJIHzpiaLI1jQrJnDFiZROE2XCmcNzIrpNcpO5TIgovl0sl03QIssumyBezp5E3RYtGyDnyaMmLzoEKTqI0BgiujOCfgDVAckhxwWgCOhqh8BBxuCxjIkNGiZEPHaXydIlNjzmV0zyJomotJslSXMal/1tdK/9ev//7aWkVSJilU5eZaAAAAGW/x/GtBysIWggMI0GzZxf6ibDGyQA5xQ4KtF1PS+KsVpZNL3dptM6ZzMuFG7iH6oH/fyjjtJ2x+VBIp2IRu5zHb+uG3VnNBjGmHOL6BGpkwOsuIlI2LxGi+XolVMwdbUEtJRxJjE8dOHzImj7lVlqUXklnElJlUzPNWgUWLJGF8smhPFAiRqmTqCRikYlwzOHzA0c8TyKaLFlNAxQOkiTw5RAysOcLPHCAZoArCAgoMVEVwZsQwZcdg5xMD0YkoN88XiCl8upLMUEUD6jdkzZltZ6Slpf0lqQe39Wr/f/66jqYrBBjRzV1QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhSiE4jm6N2wnEaFG9Nbt/iITgVzYALa0QnkrdQACAAAAB+eGdJDatgsHwcIgIuDtibDBYxuMTycs+8aTb6n1TCazPGWNdd+BZt40fnhEQ+xunZTKXqWEjsgEZyPFNaAJDKoZnpd87D802Bx9W6S7EuiEMlSlrNJK7R8ojwbkgN4ixfNCgXi+aDvBMQJ8NqaRuYImrJoTKdWiTRsS6Y8j05ASuZFtzUxni8kouLL6BWNGOrWsuEwOWLhHaTZkSxIuXy6XiyeOFVNAuGJsUFGzJGjsaFpAmSqblIdIslROiFBCgemH1DfwJQhkCPD5A+UPcDpA9UXOR6h8FAlCSK5CjnmhUUblEyKxqVUkT5ubmx5VapqaUnR/akzN/V/9mo+7+yzIdpWNSfGQAAABjl+t6lLnI5GDmRxZOGA0RyqRObmI6rafAbeiUiiUAy2YyqyldMjlUvxiWFBKiEdTYZUN3DLLdWgnOUsq3ja+vaWkw2jyjyzQkzEurMSgxx0DY3Heqp0UkGSQrbfU6Z48s+pSZxKYu6LpGZg7NaqtFBJqKUyN3cymxog67Mtqy6ynWcN0tMulAfRiFQ7Q2hhw5QkSKGE6TSYYF0SZIulhIm5MNmOoH0WZ607qUg6tWt3/+tr///7//rQcvmRehuesMJth4VAZQEgwzmGnUdpSJlsNgIJsWdhOx9WKBcHFQY695DgmAbak3grsOiLsuEqqPCU9dh1pDlQOqcdNygRuU0ORGpvH5JTWIzUgvD69VwDBAWV1rMagqplCqavLaeG4zSY6jkqUWVZYw+fx1rL+/3mF7LX8jGbxchmzUs1c7U1lu5V7Znbs7Zz7btbq4TETscrWrEalHd241zcr3WqarZXubyyu4VLlNjvd7CFug1p/mVM8QXQtFiAeDUfFO5QuN8IYiT7ypr0Kj83R9nceY43K//zC1jvHmff7+uXv/H////+fhv+///////////////r/////3+u9vTOIrZAAAAA/D90+VwOBDCgQylpPVcF+M0jeTPnic0WWHkAOgQEgwMkTI0SPFPJsyJFQYYVJEkjc4OaM4TANQoVCaIImbnjVkjEql4uEaiUGRPGBOMGFikUi2YlApl9AvkaRAvmRkYk6USPM2dN2SS6qK2upE9NjRMougbLWbLOIVuiYJm551LsZ3OrRKyZ4pH0HN1TZk1IsfRcuoopMtE0UyKSJVIqM6PkhpOCgBGAuQMXiaDkE4J1FENyeKpummX0ydKCJgYJ10nSUy1pIa+plt/Z6P///v//1i8N0FAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIrJBShlKAANfSCiDKUAAlTkFQHa0AAqtAK1Oe0ABRfWUBlxC4GQAgbmMBgSwHaThAZA54AdZWGyO0AESAUPAEEgsrAQuBQ8AlQHQEQQFMMVi4w9QDfnRIEj4atK6JgEgCg6QAImACBFLupaLZew1YFwgfQGzYXNi5iGHkTyh2kjUgiI2DL4WFh75ODkJkVVe5RG+/idAufD10hcY5449FnXZ5myk6qANtA1QKUHAeTIuOeT9zrO9PdNS2QRTrxmDU3GYIgdC5wQUGQEExm5+cNxyyOJJI4qy6nTYmiAFMuuitSNiuWQumGFxzB3DrFAEELSSDF8v3q///Q+v/d7/6Z75ugTBOMQ8rgYMKBix4Fg4HBdgbNKA0bEFwy+HrgBCAsMDpAuDEFxcYfIHwClA+cWWRNZKTGRcBCYD/HAMadA5cUCSQBNIPdGaGSIiG2CSAQVhcYBQACxsCDAVsskjY3cRySBIkMIgTwesLaQ4sgkBLBAyMDFg72lw4YH1JIliXzMiho6Rw2MmMCJuT51BZoUEDs4kmeXuWmW2XmQ6CkVVpMtajEzemggtMzWtbKQQZaRuZonbzOdTKCzinsp0EC+fXTSQZjqiHmAdAN4h5wjSLpqeto/kaGxC0JERMD66C2UcUQMY0c0d6TrTejX///OfsrX//6l/X+XC4aC5BzDRBBAvpuggpaboIdy3lamprVZ9lyu7BKAk5ik1YYt8ybLWMZehYZKpFYt0YFwZWsAjwOBJjKbKbMufp2pBGo7LZWsLDD7RZ4oelsejUnjsO1VwNeh6ejTvQ87zvSlwWIu7La0qrRKU0tiahqNZX7TPoZYarc16Ho1GqalpZmljMppZbLe42eVbtLDLsypodfnO45VqWW2cbOOv/mWNLZs73hjhyrO1YzGZba1rLHHe6tNGpdTZZRqNS69qq1kuqpoptLpVDL+xmWy2zO2db/DmNizjjayy73Wsu4448/lmzcs4ayrU26tWtljZxwmo0/zguzLaz/OUypTIAjjHHQMZZAlUikg8ikisgGRRTBWKxFyXZf1/YzGo1WrS61l9LWrU2WOOtU3Mstay+rKaampqampqamtCgAAAD+uvi0J8woaoSZgGZO3kTqSPpsZl8wHaFUEoNTckCUZRcNkE0kEi4aTM3Uyi4aKLhupnQZ0EPoMZu5gaVM6lmkwHoeTMGdNRpUXGdB0NSC3QdD1IVp//7a7amXTfetOpDpp1IaZJl96tN6ab0Fp0062Tem9N+m9PrT3VpvTfMDRTF83QMRxmxYDoAdAlBmTB4LMByFNMe5uYIm5gyBmbwfYPtiB5PtWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB96HUaVvYALMEEquqcgAKG5BUplKAAKpSCnDKUAAu4AAAGOHf73ee+QQ7KmRm/8FhgFBjDJNNTGMOYPAsGjOYyOHaJbyVJZlSSaQyVvq8NwVEIMLu0FNck+c1QSSjgiWAUWbhJJqVXrmF/lzWsa9fsvqdrXP7ftTaU315FLafOYzyppu1lS09WM5W889ZYXeSVdlJzXfx127zD////v75lr8+3eZx6pljTdy5+/xvcuZdw5+tZfzfJuW0+O9fe5Ut0cpwxvZ51b++1tct912/lcpatXdTLeWsedtc5rdnKtvWtbtzsZdmMwmibpBT1w5FhUHlzQ3dhTWn7aTKoIm7vJdfp92LstuU/eyK3+WWdqtfrde4bF2b8JffQwAAAAAAArqSrTdSbEAE+gfgBSRJqUyy6Tp4xJkZ8G9wOPICiemazxDiCrMS6arHlkC6QEnTxFTRJNxBUmzEumqJiiyLa0jJKdNTFbOpSSJ4jiJFg2UXkkUXUqko4XTVFaNZii7v+/9ul6VaKNmRRSepKpS9SW9uixAiJJJI1GWsukVSMjZZgblE1WZJOpN6ZikkklWijSJ5f0XpPooso4bpmRkUzAgRGilSGjKiwoJkyaoMYol1EmTVIyLynWXTVYLVyodasFb4KiUgAAAAAAABR4dA+zYzTFJh6AHAIALlwN2dAztUc0RwBEQUhySTNQMOmClkDDtwLRQFzIW5IwJiQMGEC08wH4OVHYNAzD7iEoiIfKF/hWg6RChLjvG4OoN5MQ5ILmxApGClTpRLijpuRMoGJ5IQmDGRfKohKMsHeG1UkkTJPrUX0kBPZAZACkTxIl0iRmmkUC8aOohqd0FjmkcPsuk4MmOURo5hkdLxiaGKSCa3QQTSQp1DtHcWjEyOsXThMKMk1PqWtJkDxTK5BiAiPwxmMYVB2EXPm5gQMqisiRACjAKvwMqKAwZAMVh4QxCISDbHUTxsZOTIywZ8Hzpnki8inZAnFny+kgidJYhw9EPSMiqapny+cNCcTpuw5JGkRJo8OcR6ZRGeIqQ4nyLH0SySJDjIhRN4XFSMETJOqpnrPP/6xjQ5rekRQTwIXJ5zxLCYBAdFcC4ADgpA3wDQIQJGVqHMJwQqQpGFYIUoEgZDgCCYCQAccdRcuF4hhTFmnSqMcm+VyfFChtR8ukOIe6P01maJsyBdOGyS1t6BcHCcTPKZKYpOY/3QMVbLpTK6P/91synT0d0ktSX/9pGrpILM0lXV1TEfi6Yt/9d/9VaSkCkxNlcVMihULqCSHSdb1VLZWYmTomJOlhHrR1P////3+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeAiVInaoAC11EKdOzQAF2GIT6Obi3LacPoUbzFuWQAAAB+WWXyl9VeL8BBUxEZY0ezxsUtIGrREQPIhCgcUiOAh5TE9EcUiKl4SIWErC+IKThDR1D4FlFU1JE2Jw3NDRCQ0gUiw8m5sXUx9CySuLhFiNh4UViqmQc3MyGHTNVisPk3RQSPJJmlTpqSQRSY+ixuxkdWVT5TUmmYJHWTJgxMzJjEydBbFBzEjDFAomCRRcpFFIsmyjVJzE2cyWYmx5EycxKqJsidH0XSyPQ2xfiWEWBvKAEvFwB+A3RnhOJExzhiDSMxsE8QAg5mTBF2KTJnVzNkjs4ZILSo1LZaX+93/6v///r3QJgY8unE1+QAAABvX5bqwzArQBFicoyNTzY3o/L74x4XCgBcQ8BeGfHMMByyAmI6jAvmChujuJshxdSDHhFimTxVPlR3WxYLKiiW5qoyKJGjWGaLTFtiqVkScNHIupAxSNioOlLm00dSdT6rouZoKM1JFY1MFspazJJR1SRikoxoqmbHCmkZlI6WSks6ZLUimZIpmSJmi5gXUqM4ZIIucJUyK47C6WBX0QsaBEIFzCnlgjxcwwCyPRLJETKpHkUl8mDAzQUgmtBazlNGk1JqnU39alK/////9VVaxoIxkQAAAB+9buTbdHneYCBw5sISsMOfIeqoRCMMvXkejBONGHSXc9T/TMec+XDISyWG3Ia03SGmm0qaDy2KseoOX+3KfKzQ0j0T+VJhfSSTtQqpaV3jItk2ZoE8WFFIvlVy8SYm0k0kjhsYIHlpuiis4bWMVE8xDioUjpNOXWYqsk5uigcN0HTMVo1HCggQYc4xJ5IlSyYnCmdSLRog7KMZrKJ5MycyKxcPskYlEeRnRnR6GdIMGpDWD9ACyAYyyI6DERkI8J8vF0iBaUtZNEWJ9DQRomrGyki6e1VqtRb9611/9X///60S6M6Lm0LVAAAADLHW9YypoIYEmCH5xh5FG2sxqGpe/r5koB8ryyGn5W7VaKybb14RZkupPSxN7JiRDoA85PxGrRXd0uP24vHaCCcaXtSspsvJ+bF/M1OE6gTTmxfKJ55OkwIiT7Ll1FJziTKdFaLMz1lJkS6dTOGzOpNCxfSpl1aVSSTKOE8TJfY2KxVSSZ1m1RedFFaDmCazVqSa0EVFYoojKFMqjdKYhUASAFYZIXKO46UhyiGEcRYi0h5FWJsqmR1BJA2SZSzF091UNu/+pJJJ//v/Ra/+1RkVhCYdr5gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHOIhOo3t7dtTxCeRzTW4gWiE91c2AAzbEJ5K3QAAgAAAAfnhnSS9nBMLmNgAAuD0JkHDD4yiJrJiV5uqyT2ilwolUlb9yR8KzKnRIBODK1SB4McazOpvDSLA76yuepMq2WFNVlEMyvDGxlSCwzGJRC4lbZYKuniWgsbLfcSBAFNGtm0k2aWrnX/3Lbe8uGUnSPFhSXzGjxbPNSvocGJCtjcfFsSMDuFhvirP3A7Las1oFoUf11r++oMWBekKNDW2ItqIFeF2JCCuE5HpFwC4XxzIchjnMsHUrWyHNGVz598ZxNmbes+Tdt/2tivxn///7/18f///////////////6xbO4cVWEAAAAY5b1utALnIVGBw4cTGIcCmuyKy4cOvdAStB+r6KbYI7AkOQ81e3KKzqsemO1I9Ec4oqgNKq+djVm9/M4dmcaaiuYWrdigjqXMCyqIlwzHetMuGRQOmZ4pEq4+GH0luqqqiimi5RWTS+iVrPmB+fSZSlUjBFjZJSNNNkTBFZTY3LD6U4pExosaqNU3NEklITYkWZSJkUUBjDmHaJiO4LeFGCPhMAzkIhigbE0pl5ZuSg7jFIwM0TdTIqSPrWtZitJ69SlP/tRR///6v/9jgsR4Gn2AAAAAAAAABgMMGCxVlDNv+reu4WDQhRBy0emKwGgDe+WNwfhpiK7EzpQIwIG297zt/MOXD8nqoMr/qzdmVRazG2JixxFN8s8/ueqZ1LN+zZw7V0TAc031i+/t2rXpY9K6G9Y3SfQzMCrfzz7vfd55556wwy/D+2rkhy+rZnKXn455Y9121jvO9zWvxt6yykdrH86bK5y5lcrflnnnhfzv54awxqzlbX18qWvBM5L26TSSiOSzn+a7GYcjNelg6W02dJFceY8p//He8N7/We/////rf//+eees89fXjcNy+Yct35fqkpKTm8KSkww/eeeGH55591hnn+sOb7qV7PtUmxaIAAAA/D909SOEwIYkAGWuZw7kRCDWK9d0JRFA4sGx8DrwBHQgQkxaymVR9JjmkWEYCd0hrEidHETouQLcA5GPkqE+a3ZSE4XTMtLRQJw+TJDygmXzdMzLxgay6VknTSIw4VjWpjI3PW/Ut3OO5gmYm6a0EFpOo2RSd01GTpp7oMVyigZGZbQOGM4ipMyZd1rppLSRZJjJ2VcnybGcJwqDmh/RH4N1CDh9RW5PDlIj4Jt1lE3IaXjqJiZKVdkLILfVv9f/1f/////1OkTp4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACZuQViZSgAScEgrexrQAIDodRp29gAsCQKs7pxAAAIAAAAAAASIoUTySxRQIhhNwhWYk+gBm2w2QMQ9WHIhgQaw5yh1AHBAWRg2DAk+AkoGwBFUC2lZERGghGVxCYeRHZAE0iykVhWhICPBXxkSBDnjvMjhbI0RdAUuKTFjJwiZDyKkVICRVzJ1JMgsZsfIgmZEuQBEh4eyZFFFRDiPFztdBhcBHjJlVI0JgqG6jYipFll5FJ2YvDyi1qJfNzUi7jnlIghQJ1A2WimOas1JpaNCtG3WQcdIZHFjHPIsRQrFxZotzdSRGg3VHGkaorpKdFFqQzxXWqgz/ZMvm5oTAzAxQsQAKGA1DAZIUJoDYgVkTmK3HUKULBRJ8vkMIgRQslcvJGKKkiBDGjgAJLAYoeHAhfIlB3DpMS6WHRMS6gTSRsuntdmK5EyFPFSk7rZal+kQwAAAAAAAAAAAAAAABOVMmHwBImw9lj+SZTC2phTDLDrRTQRY0PlZ+O8D0GxTlTo2rGQS5pXftkceixkEnV/7qYvlBPb7/MC8MIYmpfP///l9I0P02T///+602TTTdA+2pmXR/6X/6Z4kzdSJuYlMuGyCaKf+mms3dP///502da//9BJBNFy4bCeBIBfDkDAF4cg9yCbpH0E201NfAAAAMcccf3qmymlzQpKg0b6MXIAgecqVz0zFc4edJniNwqTmfR5iwSpG5ZllJKoKeK3t94jMIiwuluQNSzMRlM/NyoWBC9TjT0pu0keyzsd3hWns5TX7TfZxxxnEPZFAM/LMLFJnuUzOG60xlDur2rVa/vt6ynnV/Xf7zdjL+85//v8v7lvXau8IhTd1Us75/f1a7hW73PlzK7W5V5BUWp9XOdvcu1pdGc8ru6WpQUeVvO7nl29WyrVqbeO7NrLLXdZa/+3qtLlr8cbE7ONKf6MyaB3BvvItJDCB1pTLLnDdxqr3Xn4zpZduks4RG5Vz1qM8yy3evXLd3CVCijDBSmQdRgAAAAAAAaKVa9FFEfwGQha0TqnWxkbIok0XhGYAPFwlVImiuY0SZRQLxskSJdROkBNUi8ZGyKIyZdNUEj60UXX0DIydRsmjakZIGxHEmXTVRkkkkZKWa6lGzrRZTopN9J0kv/U/7pUUbpJOtt+ijpJOp1zMkS860qn0VGTUkk0UWUiupKjrapKtHRRZXRSo6SRe5dKqi8TRiYBi0LKRyCSHNJ08QIgxcJoi1aJgbGSi8bIol0BKNzpZxFYa4lLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74GAAAAiWiFSFYwACvJAKUK1MACK+QUgZWoADeUgqEyUwAsMJu/KJK77pl/xYAVSBtpaC9xNpdtoyuC+gcAKpN5WTSGB7iHU74bi876NzZfeidHbdiUvfGImv5+ILg5y4KkLK32hyP21TRu3DE5G6aUuXFYfqWaexVzlFyWSufpLt+MUsHTlPhhreeV+pZzwu25RYpLueGNupRV6XC5ep6liV2rdS7bqY36SrYldqkr26nM991zuv3rP995vuH50/ef9e3hfwwwuxuOPw4bZl3saUgBXgb4iAiQiuwFX6mDstPcCGYHfyJSCNxyQRugoqferGdTG3UxsU+V6n1ez1lep7l6nws295XNcnauVJADrW6K/TWe7nrNXDmeHd56wr65fuY2K9axX7Xl8AMvo0b5G9FkcCpOPvInIgt+l2RF0WhlqEApt7RmQLdmoOOR5XIoTCJJDKChw/MD74PzFuE6DHkOJAdZMGxgWS8eUXyQJsomxUI8wQL6Q5gXOlha9loJoLTMDY2ZNNSSLqeo45NEaVVLMDdaq2upN0qKC1Jmpkkv+r/7qX0HVooszqpVtbU+l6zJNS1JoLTJgnDN0FKWkx091qpW9T/S/opet2NlmJOpmqUvHTMc1ZOCdi6ksnS66BeTZJ1IrNVGSJ7cAXJ+RIsOWsfCiVAw4LQNFmIAkaAamCYBoxA0aJQufCgUC9gnALni8Bh5UAFJIDA6sAaEgDBHAskRcgWdEJBmyyIiKsg4pAOVFyBEFDLEkTINlkgRw0g0EPfIcRMc0ok6ZJlw4TBLKRJkngBAaNk+ZnEAxORQzSLyg1SQUlS6RNEmxMx6Lp4fJOjYHcTLvPjcFRPMlOkcOo4ZJl04mUXoJpy8gZufJ02OmxmT59kTJSa1nllExTY+iV3TpJM7mhPEhTIO5XKqaTE8QYN9GuTJ0vpGZxI8tnORBIQkJUrlIrom52Ynjozo4QvSIaLIImfKpTND6C1OUjXk8pfqWjSTBoDwvc3oIUusx/9SYcSfb01s63oJP7bbj5f4BAAAAAAABsqdpDlBdSLWA1YfIALDOPaBFyTH2ahcADY4F6AGGJusiAuAZsWYK0Gy7oMRgyQuAphl8QlFuII2qPJSHATBHkKoaROm6X0hH45ix2FMUANIZQpDKNb5BzU4VFLQKNaSbv+2fJg0JgqF8xPk4eWTxIGpfIqXzC1v6i+aFYghfLp8nDAxNjxHjhJ8pFcuMThX9BrWQbpFcuJhdAGxgUQQQJkQTIabFRA6dJ8agvhjgE2DEAYrELEIO4aCJaN///+r83N1Weh9vpugV0PWV1IGG7ra9/okc55uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdYiFAnbqAG3fEKNO3QAF2OHzqObm3bZUQnka21uUAAAABvmWWb6q2iwQHBBhkGY9CBxUptdqtFl8CDLiEwGcEuBQBgMAEUqSJROCdiOG8cC3QcqoiZFUDQcBYCQQBwCIsQItrL5iYOfNisRxMl1bppDnAsByAjIlc2IuigQ9RFy6OaYrpmhgbhjw0TXUkXmTazKpVJF1BEdZmgWUjxmgykzU0TZBk3MDia0UWUcPDMoLKyZcKLGxgaJpGx08yBwxPpoqU1M1Ni2gpNRBZEhmRNqQpcXQfqHLB8ozQfKIRC3DqLpFTIyPEwbmpfLpUPqUZmJaNUklIJIP+hv/qpP/////754c0pGw2sAAAAfvmOsoaykUsEwh5J6lmYZyrrAXDAYuWGKRHoyw3yJlgSio2OCcjxDRlTQuF8isGoMgpFSCkNKRkmXUVnjVEhw+i8bvNi6JUJKTJqQ0uni8Xhzi6UiLGSRsbE0XiNR0S6XTFFTsiyKKkmUoyOH3QSXWa0FUzqLm+YorUpIyL1FlF1aJeRRLp5FBkdkkkkWOFtIyeikp5kRZQ/DqICUSyJ1DhgYwGBigYBwEgpFiSPE6OxaJOlAxKLGSSBg6VJPWaoouktdqkmf/rRRdJ///6n/9aKKKhCIXCeBRRAAAAA1vW7kfYRF16iRZPjAEeEi33lh9kF1wk0Zec/dRd1oPXq9khdR8GhQ0ouJAkirv5Wam3sNDpgUA8bgimiVS1vGU1qaB3et2NX4lwIFKGJ9j0TNkiYNzEtpFEnDZCPgkw6weF1HXMlOgqlomaloqKrlpMmkXTOT5Rc8ggYGLmKB1FBJNZwvHTQqnjQ6bE+ddZ4n0i6aGqy9PLPszGLooGxmX2RJ0olYc8awvRXA9ILmA00DqYLmxyBpFIMsDCEojBIciPY2DMyLRPEeRVB0msdZjqKjp5tkVGTKr/fZCj///7+r3U5SWTRpKEAAAAc7zPC3ICIGHEirmCnVYaP00zCa0Qlj7mGwyQjBJe40Nug70rp6EgA9VoFmYCj8fl44OwNN156i3Sdz0/sVyjFNTXaX70aaUnlNzVES5NE9RTTH5I1OG5gURPhiutbTYvLUtlU1JoskgYomBMSM0S6VqmKJu6SakkDyjyFCy0UDN3N2KI4T6akUETRTseTNqyctFBSi6UmZNyoxH4YMcg7wtIjw4B6gtYBZD3HiFuG01GooGB1AvniTTWaJm90mMk1Kegq6lPSr/Vd7f/7f1f/8mj8bICgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIF4hNhXNgAtpRCdSuUAAsUkFSGUoAAg3IKtMi0ADfcKlhw0Qx4fmRw2ZUkRmx8mPQuCgW/UseNQdb4wFGUEx62OYiRlYi05pTySq5HmwumOjKWMHWLcubO6jECBAcuRw1Irevxubh+GIxOvzFc8J+AACCvWsybtuJPU9LFXbiV95aS5Pyr5YzoeAJZYocd63j3+9+vh+W+Rq03blizLbVNZ5UwlFu3TYzlndi13V/OntVZTDMcntd5KKa7SWKlarYuW/12k7nY3vnL8Xpvwwk0Vjr6QPA1R4AqFoWo/IfkwA4Uw6bgxJvobnpB790vdU9apytc7herZVM73cf5v+03/r////X753Hv//////////////P///f///3XMqmdgWsSAAAAP1hyVxtgbOF9GHRIc/AwYN2fwPdhcrlJfAsJA1XcLIROY2xwlAc4aBHjKFQY0PXL41ySNxki6OMJlQ6YcJBicPut0VOViaI6WTRymViIjUYrm7rOkIYFBiuRYySY0LDkyVtA6YGqlPV1JutE2TNjAzTUk6MrMmbHlosfcxRdPY8XDpSlA4dWZHUzM2OJld3QWgo6tFBA3ZOaugdXK5GiE6SQ7Q5AVoBQCJvDChDBYRzB7J4cBVQNSLEMJgnzE0MVqWjqSTWyVenb2/9Lb///1//UiOkdxqkaDGDnmygIAQCqwWWAYwKOcPsW8dgGeiA5wBg+YgiEigjIT8DbYV0ToMgO0mwJGQP0GAw4YNVgB1SOGYFyECTCYFYN5SOGdFBBjoeiZk+iZFQXKH4C5wuaDyiExDg9oSQ1MibLxOFw0D4Ay6FshQI4RZbkOKZamKRFT5oXDU3FgDuhkYXZeGND9BrA3VFtNGQJoi6ROE4t01IDeFBCWikUyADwQYmTBAmBnjIrJMigy0DpuT5QNCcM0yCEXJoZUXwyw2xyRSJFTE8dSKZrVmJuVy5Ny6swW59BkFjJE+BhwYjgYIuYfJdJYmiacxOmpdOgGA0E5kjvVRdNTIHTciRBRS4WLiEAnAPcFnlcZMgBUIgZnyfSNC4eTMifJQulodYpgEQgJiQMwqA2iwAaOBZKBiBocgG9Ba8LjEaiFSKjLIizhPZPCzSMJlIyMknPHCwASIIALcUig5idJ04pMppJUaaoAAAAAAAFNZtWJ0AdBZwWMkyQIusL0ZMO8bA4BlBtHU1OowjzRLhsnRKJucWSSSBcLiH60EbJppIJKda+yuyzc3Uv+r7KWbrdv//2W6e37///7Xfp+kSSSa1f0FpLt/1PRdNSCDVv/7f///rUXy+aOlZf/9CgtM+dJchko0wNC4ya/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACECHUadvYAK9sCre6MgAId4hUA1nDcq3QCmBrC24lIAAAH5d/9463NSdCaYEEnEXxpJQJBzQoZl0M1YdjkrZIQAphi2cqygINZa4UHwm5JZa4k/SO5XkCFkjnqd+pbUpojPSvQXG2S33ZoMqSNcqff3f5Kq8opMpVvWdLjcT8WKnLDNml+k/ka7epaHcanYz/MsrPMbEsTp1rLuq2quXO3+f/5Yd1f7d5hqxazvS790PLv759avzGt+PKXV2pey1GrbWoVau91e1cvRqc7hR50VPEcq3L3eZY53sq9u9axztXtbtY2da/erFLWva/WX0sceOQQPOOG+zuSlHpczQVWwS97UH/d9j76xe5di2F+1jYk+V7DGg3Wy527hdvZs5Bk4NNSaKz8AAAAAAAACii1XqUKSAWocGXE0ajM0c4TxmOgBkxcKJqYEkx8zJKkYskSKkkiGoOal42QMhjHY2MWMWSay1nUC8kYoH6T1LNmOEDJ10TjrLqCUvLaXkVLRzJbpfRpLb/r1V1Wsp1MlUtqKkVopaTspK5gRpx1NUizImSaaKSSklstK1Gtkmoqel0na2itltonDZcmk5MkVLxgF8Q/IZMfRHkVRIqRxUNydLxWUbImpw2MazU8IZaDNEJXTwr+FSkjFJg6bL0JhihgYEkpw0QOYXXDXehIMIw0jggRYkCR2A1NATE9rluG77/4RCMUzsNYhEFuWv+gjDlu3I4g7DLH8sex115XT09SUTlJG7VJSWM69e3blcbjdvUojEYh6G7d7HHLO3uvT77UlFJSfSYYYfXp6eUQNuvT0+eFJT54UlJY3T09JhuvT0+fe/3fa2X4Yf/Obzz7+edvv/dzzpNYb7qMOwxBY7jx5DAwGNBjMAtAnRFlyJiLokENtbd+fib/xu1KIYlnM7GGde3qkpLGqSkvbp7f6t9qUljmdu/ezxtblFaYrRBlMUtz1HMYbo52p/595lf7qksYV69vmdPn3WFPbp+gAihWA4Pb1UlD+P5LJty3Lh1TMv+HAwDcBStQN58I3G5fdp5/ksCkjQR3XLcuXxiGJRM2bFjPO5BdSpT6pJjt+n3L2Ht5vm8efnrn5vYlTKRpnLtqawfjF0wg+oPP+qft56mDV5rH399/x///W7jl3umXXs93PzXF/HDB+rfs3m5ubv/fbkm/zW2J+Ov/5ptf8v/4bJ7gug6qsqSTchTAlgRLNUJaKvT6axzZUwMgJci/RwEkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaniFSjOXty8rEKj2Mvbh2aI0SNbo3LzcRo0bzNujIAAAB8pYi/MeXNLpHBIVCOEmHm4p0vQsZiT9SZgRm2tJsTFzTOnthpr1O1mAb0FVs/o5VHZdQxGW26tLKbOH27Ven3Zpcbz8QE9k7vuL380aFTWa1pht+cV1murW+a4xu2c63a9rYprFr6ivYOPF1ndse1o1vnNJsU1f6zfed4+/TXrnGNZta2vnNXsGLEb1KhJ4l9DlJK7LcfqtixlUtPnStaqSvXGbca3ta+da9q1xa281/zX4tb5x//X4tq1t1rr/6///+a1/3v5tvNa6xYnyBi1xIgAAAAAAAAEGOV1pOOODtsrFdH9LTGnLAq9YEmEw6MjoRh1lYEJgd5otLH3lkSn3lis7C4H+pMbXm0PsVjNzdWMxnG5EJVKNSmrZpY/DjRoZu2OWbHkFvgbnvWLB3Zd7vrOtQa/e9Vxb2rWtoXtPa97QvBgxXU+YOcQMbvZ9C3vUGHm7/dM3xEo4OEBdPIJ/scCV6/OtngLpHH8n7OChL6WEho6UJioaT0wS+gnSJL4W46UJirpFKa6nbVWtysLDqBJGpa2NQc2hV1q1sar9arrFrf/eLeusPtW3jda/11/v6/9a19rfNt5rXWLCzIbkMelkAAAAfr8M6kTV4qwVlntlF+29r4wBD1C1pGozaOTWiNM7MYgG1NurwYAn6lThPdWeZwos/8H1cZRVq0tbdSPRanzrS6tTW6zS3bTygaZd0yPpFI3Mj5Bj5qVWI42GuSTUDZNE1fR1mrLMVmBeQRLshpqRxskbJJl1OYk6am6SReRUtEmkzE3IK5sZIlktJG6RMnjIvOikuXnUTpqy0SaJ1SU4McfMhCUZITyISjYAeMA0oIPnBYCMaKTC2JqQYTsRJR4tkWIMXSGkFTMjZJFCo/djpeWij1GTVVfutnW39J6v//V0q1Gwzo6Ty1UQAAAB+t63UlctnjAw4Do6m1yXVXJhxlUHO2c9Sgr8TLlQpnz+UDSpdcku2G2Iiy13cEPSIp2n6zhqLZV8N52asuoaX+fcZOo8vWilUPGZFSys8opiyTxeIsbENHNF+fesuoE06kqVdJaSTl0umBeSJUmjYolVCpI5c2dajcxLqaKSZMookWIcXTEnSeIMVjM1pGx01Jk1uUi6iibJJoTpkfrRGVJEcoUEaDuD9hc4DqgdHhkANVClhCYMbBvw6xSpDSdKxaIaVUi8M0XzVkS8XkUVosovGLKS6KLpot7LRRU6Kn/otspX17/66SZOikikW3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIMIhOI5ybcsBQ6gRvTW5gGiM4lc2AC19EJ5K3QABgAAAAZY95alrjDwcARVMTNk4EtjBQPSGdmVNSja8EeXdMBwNcrpOWzR5m+YrKkxX5C4SLsRaVO3dTrYq+oWBJEY6GNwLCKlHezgmYjT2OblSU2MmrhQETEsX69ENFdAeTccohGIaQA1WXjIuhbUNOQdBM8ks2dJJkU1qQMkjpkLOSIomdNSZSPk45skgdKRgYnyoXmSZSJeI0dJuiThkmQApoJpkYxdPmyZeKKJggas5eSY2KpZKJdNCecgxXE7jNCGh8wsoMLg/AXDibg+47SGh4w20iRASLitxzC4TjESJwiRddM2c2TScvJmSJsuikkoySWj9Vns9/62/92t6P1LIaxKLaoAAAAGt/vCvADX42YIIHnBKBlHezblfhMZY0c+CyeJ1m2lURiGefu28luNU1BTzWbcygpXwpZdf1zmEMyzd+HrWUu5Zo2YtpP3I4cMiaaPYtNVmh48UhxI1stE4yKuy3s0zRPppGbGSkJrZFJRmasy00fo0FJJpGxL1rTSMUlqoKRZaZg9SzIudjAvlYvDvKwvI8AnQHsHGE6E4NxGDEeonqZgmTUiaZnUXNnXZaTaV69ektX+zaX/9v///mSpUWwQAAAB+fcn0hxhgcCzAINMdBo+cWTBgIYgwSpAizHUgkwULMP1gQGAokgJeNeZf608EDrOIgh3MoAjL9whniVgcptPfeTTVHn+6GG7VHWjshztySAAsDwU19/4m+HJimlmMZmIZ5jYpIneayk3K/qX9a5e5//+rOPdZxK3AditnKL9SnxtZZz2czhjVx7eyqd/Vyrej0suVsty21jT3cMqLOrb3jyz27nuzjhSWbGP6mYrKnfd2DHpLkmBACHrREEKdUsXU4cJgOBIvdisviG9WsKTXLuOXMMeWPra7/Of9rvP3////+t95///////////////P///////mtVd3LGBJgAAAAZ9wwxhtgZQDAIzMIkjbXEx8HLfxaWQ7OOuToWdA00oBQMK2IUdBFykLCXxvkXDFpATEghUKw4h1EDC24FkAsgrm5xI1uo2L5ZNC2UUlpmRLDdIGeRPGRwiqnNzhDkjVSRNLKRU5gy1L9KyaKjdKWVn2ZE1ZRmmYmDKSmyzB1LWp0UDQxTKBeNDh5F1HkEjFaqLstEurTNmaddBSSRWJwdBxMgIqyiF1YatECEsOJAYRAzcvJIE2Rcpl9j5kihUp1JIKZSKGtevf/0t//////WcGOKCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAC2KQU4ZSoACRUgpwykgAH+IdSp29gAsfQSs7pPAAokDD4xZpcABBgaVKHGAGPgIgAtiM0VgMoOC3gD2/wvaAuEwWCIEAyDag5gCwDQRFrDCgGPBQBhYGBAgwDAyL5aAcQbANAAA4DhdWQcqCZgkAQsozzyyLnJMMiBigMjB/AcAguFE2jqLbKSWJIGKxH5JlcgAW+h+ANlBkZg1ciRL4uQQHDFYnMQQGYIIM0ASAwxgcOCzgxtRenUpg28XOMmHKFRzBBAiohKJ1EZoDUFmjKkVoqd7V6ZwqDni5yJi5BchEBQYrcfhpJk+biEQyouUWaMcQdTKcum5VJxNFFXGTEBAsgE+FMdJgX1pmjOXCYF8LQBgsEgNBESkLKEpFMgpASkbE0dPK/3dTMv9Z75pMyfY4TgNlgYDAoXvBvOBg0JgHBsDDAIBs4IAB06TFkZcXGLIHMIgMmpAdZRGdHwTIzwpYfAWFAYJJQGVimBhoGgYEAI3AuGCwoP1C/oWgjqL5HECFnBq4fIoEZmZrdaIN9A05QCoQAayJ7C2RLpEDJIBAg+KMHYBDI4RHJiZnSqViDkkOQZHTZEU9ApmBACXRURZ+66lJporNUlGbKWuik6l3Wijpt97fQforp6+h9XVV+pk0HV9dBvV9LfVrMjIWSR6kLr+uYFI+XU639ZgbIpsk///////0EGUXDQ3Tdv//6JGjnF5KiipJLXtwGAAABlay/uOOtzVpZIAFzgCw0EQTGo39jVyNNemmjpCloTAhk7UsDhKHpc/0tvyyjfWOwy8LuuKlZUwhm8/MpnJfnKKEKhDVpHKKfDCf521ay/OYr2qfG5jvC7ZmlZYPWBXTKcea1qzTY3qlWpYvdyrXb2WVI/rPNZdxxs/9+1la5v8csv/LPm6urlXGZ7ewy7vLLv9w7nrH/u8wr59xdFTFDVyYZh2m1zeNe5OY53M6mFqxlh3DncMN6q2Ldz9Y2+Xc62eG8dYYYbz1/42t7hyN6nKSfa82zLmlqbL/jb/yqkmG/imH0899nnJjeu85T5YZ4c7h9Nq9MneNNTQgiRAAAAAAAA1JOtaLXRHQADoXvOmj/cR/2xveEAF8UrNGUq1Eirzd5WDcJYjVaky3VfxHdIK5ZqNcnlpvf18bivswnsbGdb8GLuhztW5Xm9RoNsQbfL+nvTeYl93//99b1v6///+9fOt/639W1621nevjPzi/zau62+rqN577/1b1hRaSyXzqNrNbZzS/1vfzj+m/itvn79Yu8Vx7RY2LMrlmKolTFFhBfkkVh1tE62lFiViZX2G2SPIxvPaLPwVmomeLTM6thQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdZiNODWntw7VEadGsPbhvyIVWMZi3LTsPq8Yw9ud09upDD+QxDkyjwj5GXqMv4ScXQ6kNrCOYiepOxchEiKpIbOJWMoZw5EVwp7csfydnM76w7/28ZuG4bzxpIxefudp7dyYpJZYlEssYbrbMOkeW9u8iTNbcwUntEhR4GLX3Hlt4ce2aUpaHMqc3vfECke+6UpTWYDymc33imb68Der33j7vfd/7/G8+mvjG+sLEqfOhUN4r4SM5gjgmCoUhOCcIQ6gp9Xq9WUlY37PH9L3h3ve2KR4+9UpSnv6UpTVo0STVIrFHgxjmUC7URzXa1LiPJHlzu95rXvfcKuKb3/Eph49UE2SapCs2yAAAAPww5+8oxVTkX4gnLznBIAJwyyiZ2kIxRBOveOTjaUi1B1TuSjUUi9fcfgqUWcc5W28vzmYm/8btfDEcwLBZ2nzrUlSxelEYscviHdvdVc396SRIiZeKVxcL0vfVLzXlzZqu5+lNd/Z4hu48O/gUj3+qUprdHlPe+8Y+96pv3g4187zn/W71/zAx9/xGpslUZ0KhdhxgqzmByCGJRSE4JwdDyVjV6vZJpX6vfx903Dve+90o/h/0pTWN0xSlK680BnmnZor5iJyOgvV2FRttnUd45wtw82pve97mpiJfPxEpI8lQybn5sEMTk8AAAAAAIu2Iah5DZmdLHYNC6jEGEpypWwRD7OXZrv6cRipn+oL8oXdATXpHx631swTew3DMZj8m7qVRmW0uEqh6/rHdXlamy3GI/C69e6tFdJEuscSSSculI6ipnoqoorrUbPU6TsYmqluu6RsbLSc2SdazFFJaKKN31IMgzIMtdGyklHUTZN1l42MTJ0VGxNkNFakVLo5orUUCJ4AVQo4rom0WcOUsio4SIlU0MCiTJdLtI2NkqN0kkknUkkklrpJJPRRRR9NGkkYool01brb+vSSSSepJJLUkLNJk1FfEgAAAAAI1a3KcccLcPjrjcGEs9LOoatZYi/t1rJ6En1A0io8Zdux2cm4rUxlGG5TZuzv4SqZs/cjUPdqym/S2aa1fr0kFy69es1rrVpa6taNGvBaqxa63muvWutZxG38btvVa41itPiFb7xa2/mtbXrXWMYz97ve+b7rrNdV3bOpoVKahTy23WRikVJwpptTpyltIAAbK5CSEnUeT9SqVWsMsZxcXsWmIULfzj4ta2Pa1rb/+LW3/Wv/zrNfa1df4/9q11////i1rW/xa1v8bN1hBQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIC4lPg5uLcMZw+oRjEW5hMiE4jm6NyvFD6FG9NbnH/1Vmm4rPBwOMPmw5eQSYPM5h52UMnbhhlgqGHnu5aJg8GMmg2HVmW2tyyUpBv84T8ytrM86IoPkw4y56astl2GOV6VSl/JBM3K8tqv4VAUvq8XcowxAisUigQ0dRFUjpRWVTULaDImJdUZLLBqxrqUkeRM1GBOoE0YnSPUb0zhmYnHTMTQvlU+RVNl0UkTo6iKnydPk8RUmCwiZGpikXVEuTpeUTJqiTReM1olwukycTY2Lx4ZcT6NEWWLQK0BOAPgcIMuCyRDBfhacOWT46DErGxcHCUVmZAC8XkTEql80RSWan1pGzo3oLU6/ZknRRNf7/b+vZvXqpLIcShVKxildAAAAMed53D45IBzI26MX93KeQTbvMDEvqW8m3lt0LzZx6/DtbJ0ZRZh6RXmeSezGrd2l5nrVBGspmdv446tUUcbyNVaQzLpVkVdZFk1G0pOmquioxRpUXqXUk6jZSR84XZilWyzGsySZI/MmqWcdZSLZsYl1JM8ZUUUHRNXMTVSnOoJIrYxNmScxKhsdIcWiiISlUEHCygOnFwECI4jxokCLJFThial0pJkyYJmtaSdT0nRRbvpaP+1nV/////rrUdNh3IliAAAAB+GeFPDCt4sGBoShVYnfUwLBdXD/0hfVpmaYqXR61IthnCp2RRmYiLpqQcocGEipuHYYm0x4cfYdPR4RylcKeOivy65L4YicWd+xUr6j+YBCnrkcpeCVFQxGVTJshSZIaYGiSA+i8DUAG8O6kCypFGzoJIJUjE1K7imlQxMzUvE8kbnDU0LxxR1jpWJ4qomSCzMuENGeLxJFQmiqP5iXCaPkVNTx9kThqTxuVUc0UgZlZyKmpsVBzhcxdE4CyAwiMIUcQoDVCJ5JQbwuIMLilw/QZsvmYpMg5LmxbHomiIld1l1IvOVkTQ3cvHj9ls5sfUk7dVSLM9D+p9X+1/fqoHSMKxaPp8wAAABljrHWMqc1HEwItOELA4BgalrNFszeDGQPZahBdiPymS0mOFAmlLMonO2be5YQjpzec1hfy/60drYVY9R42e0t9mTd7GHUTQpmhkonrPIn02J4+m1akk0GUurq3WmarUeTME1LnK0UlmCbKoLr7LTRSSWauzJMZIp1PvlZig7qOovWtIpkiPImLEpSAcoJkToJuTB6OS5cEuUo+XjU2cxUttk1qQZFVdd0tTI/96n//////UZiepkqwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAAB92ITgVyoADY0QnkrdAAq6ZBSBlKgAJXyCnDKRAAw3nnQMoCwCHgoYyAhhl6nUEwZYCBgQANq97JlNlAAbrgCgQDTqFDjQs+H3GCOIhooIjzEYIRCRkQAkRjRqjPkBEdgmNw40gBkO84T1bkadJsgpkTZIKLhMEwBgoBizxnCFJUrk4ogxcKBNGg6yZPHzUrk0K2DSC4eUWlKQSTXWyB1Fa5DEiQK5NHzhVLKbFkxOmR0wNieXRNziCNEwkCMSbOJHikU0jBRFpuUlFPSdN0HUtjMzWWkc3HaOURwuYY4OuIUAsEwFA0FyA2gMZjljZFDjmD6FnkyUTUnDQl5MqTziZ5SRxTU1qa+feta/Xumr///V/+qqcPlJJRAAAAA/P9UmN0vWYaDmQLx7Tbm/UOUkEWnYBvOCYIFdQIiJLDaGkRAXpRKRF0xW4oqiTSSGaPjIA1ICfB8E6XDVzVkDI2JkmB/Y1N0jhwigtA5BFS6TpOnCHssnDEoJmEvE0iUSfWnTN00lJdGjPLZBRYTNEEUC8bKNVGxo085sibnlLpoJ5xRgfUakyeTTM0EkErnkU3ROOxxjCXkmWzltMdI5JUIIOWQcOgDGomIuEiA4hSxqWyqTRQYkCiVTBzFM9WtbGOukn1a0qv7bt/////+szGVJBNSyYQKYugbsAyYYDkUwMIZA9KwBJQDmVyqTQsYwAPLZAGtgYIAIOIYCw4AsIgMBh4DDIfLhiM2WTMVqGjAavO4GFRYXDoapHe5eBqAjYA4gAMBADAIJDIjLLjzdAslpIBwCAgAwDg2Bg0CgLAwW4qmiaSAnEnUS+fQENAaCgGAwaGlixhxZsOFfcjx7N7om4WnihwwwWOCdAv+JsmCka07uZE4hSTXBgLBuYGNwLBA2IIGRBaRt0ziKCdGk7KMnRZC5vFxkYJ0FnCig23C2IeIG7A6ghCvPkHHYNSkavTsdZ1E+MsVCDGyDIu8PfDogMKCIAIaBfwNlDVYx43BoDMEeQwc4dqnr///T/b01maY7yKHhoFcuJIm5XZM3SNDR0BxjMCEg0EzcSgBhcBgYIGQGOAsBnpJAZcAIGTReAYIQMCgwBgQAMBgDAIFDiAJAIQVDfxbguYC0MLhRAIOknaUmAKhwNmBBvgGULB4wDCZJSCmQWgCDASosYZcDnAhxJmpeI8unCgbDKHZVHceMj4pEzPmwzhWVSVatl0jRBNBd3WYHKS100mbS+Ya+qvrqWyv21rez31uz0VpX662U7rr2prQ2raudPFsdpVNkjVXVTZYrUsG7I3bzM3PmCkH7f//////////QMzcc8rE4ZIu6Fqr+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACSSP0odvYAC2MArU6LQAIHYhSA3t7ctnQ6nRnMW5yq0uOsspVfyiIIAzBhc4RFNBBkUmnS6ld1dquXdUNUBmxGfGmxRlIQgtK3ydmbjTcl8uTMOlG05UWGWuzL3FZLSSONSqXSQaCHOl9qcxoH6d6w4TEnef6NXJmAaC1QVqa1alr0plMtRlLou7DvKamq35jO9d5IZ2tjZwuxq1DUNUiu93s701LqbnOfTZZfj2ZpZTZq81awrXLU3+u4d/dXf36amx5zPGZpaWdpspp4mJF9UUYFlVLy5lTdnJ2l1Zu44yzmWXNZd7nny9+FjeONnmNmU8wrRqmpprd6zS0tLKYdjMdglkrJYQ2JCcWWMDBAsDgoZLix5yldNTkraseuUsplNfTtP9ZiU1b3ZszsO1q9XGxe1M2btLjY/LLWWP/jVxvaFwAAAHSda0UTIrE0K+AGxANEvqu5gxgalMxBOA8G54e6TKMR4Jokuo4Shm6A4zZAuGJus4S5ggaGbpqZla0DpsyJuqgnoKaOMtNEjR0jxuqYIutFO6C1LTofQrU3/V31qbTrW7UNNTrSQrdCtVSzhKWVWqpaaDpoLUmplJM63Qsnpqat60kN2shr2L6SSJTMFkwkR5kiCuBXhfx/GDHpHoVkBArKZclwzUcOn5A+B42ccmctU4n3DdupZf9sDyrUZW7wWADI+AABCWrMnNUsVvcJqCu5pxHJMJFDkDEIBITBcNdp6WYgiMTLZ300gnnJ2HHRh+IQS1uMS2+DQx/Ke9EaOSUsXlf2K/1azY5smbQId6QxOFlhSjNq75/mrZW8S8Zi24V3NnsllKYESseBV/adqq/pNDkiUgx6Rd6znMHW3t9QLYxvFM+JqudY15q+Hr6ZmJUJ+Emy2FGS4UgR8nxEkLPdLFsP060g6P+x1riKr8ODXtsrr7xFg2pJqHt5XcLeqywqQ400jpOqh1HNOInWAuoVR9E1PxBIo/l0x3TUVtvSJvEs0W2HkOPe0SseTF4UeJVKN/EOZIAAAAHcMc6nLesJixD9CeDQZFBkvt0+5bFaXKGryHM4HWaVI3VabKbNNdwyzxoJTazlW5m9l2hs4JgxvCmv6q85/f0iXjhiigiRVkVIsUiZNSgMsTZdRJovInEU0UUkyyTR+tnUXjNjdLWtFVmU7/96NdmdaJq7oo0kmXRRRrRPJLaxMigSIski60aCzEupGLJGSaLJIoJIrZVanWjU+suqSSepI0SSdd1s6JNlUulCTRbASgFUIWJ4gBaSIEOdIEXjY1UTSR0vF5FFAvGybbKvSNjZdQmn+FRQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAfziFX7OMNw8NEKv2MPbhsOIUqM6i3LukQpUa1NuZqYAAAAAAAADBfJliG9aIpgV8aU5hCGWZDaGQKofprUPR1prtQXC0BJWtXsSv1a6epaZz2u3Hehnkkp61eTRqYisSjUzfltyXSmgv2cOY4W7Ny3YlkCWt45fzWWs71beNbtm7W7+X63rmWeOtVddy3+t8yzwxx/HWWOHcvx13HmW8sddx1/O/+9Zfzu6GrnTTsml0bxjcgeeQXpl3nhgyzIpNbexIZAtFAIVDVO7rIk50cFRLlcB3XSl78zVHGaSXUFqlwnqt7LeW8dZY8yzyq8y3jru+44Zb5l3HfNfnh3HClpdbs4d3zf93zXf/eu48y/muZbxy/6WLQfZDPyTTKGAAIAAAAhBqq9DnLlcSHm8e8K8PRFnJ6mRIQV+GXNhecKJI7DRYakUZpIaj1mln56Ha1JN3K96XRCBdWpmvLaajh2SW6WPOzDtS/ZuU/IxFJ7G9aPmlpLxbXiyR4sN9mLrXlxm2dYxBxHfQ6SQ6t0GIyvdvZIzDAdxt1xuvtXcHG64vW3tqnv8VvrEa9YXrtkc67ypla2OForGhpfjdJYD+TyvQkaQQMNAQIek5DhP5RoSunJhozPnb2I5S6tm31jedWzbOrZ1jed11bOsb1XX+dZrRhe/4hW8KLq2/jfxXG60tmuNW9bfL1RJaKZ9JQAAAAxx53+3m/ZMQEGPq/Vitg9MXxZE0c7SFoUqj8MUj7Sqmg+qnfWp3wf+7GonTVpZWr2LWOF7fY9N0sahm/epsLTJX2YfJqsSMDY1WTBoakcYuemRqSpusxRSUmerouqmzmLIHzFE4ouH0zymNkDqzhmZMbILNGTWowdymXHLqBwyY6ePmaDJVmKSjVSRuaHUXKSSBstRDUkhmx7J8SiSYTgBlEmEICeJsT8VCBjIDuIcWSqViKmZ4l0TFBaOczVajRNT0dJ2f/ezL/////1VqRGZLB4JazAAAAGs/z/Oka82cVZAsSrZHbGMNvlDMJQQnOBhhWu3Rr+DYWu4yCH4Fh/jRXioHJj0wjMizG34o4jNZ/r6GKUcRl1J3d2Kvqz5aj31oyZkiRYyIGViYH9JArGpDSUGqVmZRisuOtK6O1kp08YmSymXy0eK1E8syzJNEumSB90kmL5qWSUKZqRYzNyImxQPoqNzhiYIl5FysxuWjZTSyboIpGJAkR0joLpUEBiGAgqEUCEAiouArCCopYcwaY4SHkcSRVHceNiRJs4fUcL6SKE2ZM+yKqWiitB/qWy02Uv+tq/99/V11MTYpouc1VZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIFYlOo5ybdNYRCgRrUW7gJiE4Fb2ACvJEKBK3QAAgAAAAY63q7JGEt8BgsYVIh7kdlYlR9eacHQA/bS1ogUFHBR8rt0XXZPKG4sWdtTaUoSUurtTsEsPdZ6R0FExMygiW0cVr1d00OUsRgizUsV6asEB5lUsi0MPqal4Z8xICSJFiLpuYnjYiAWpDnnnTW6DGiluyMyc2KRWJJY5hEymiaJlVA3NzJMyVUYplYon3SscNEByxmSIoEkkUlGDmpPnSoimeKBoUSZLaLsZoMalViKoGZNkwK2MyLi5wvEcsMij7AHEOEL4icBkRCUXKJuHMH0bj7JMlk0yXIuRJKgUDpaSTUZpJpptZSc3dbUeq6VFdf921t//oddlE2REj5spbIAAAA/DuGeErUgJASo9PTCTXlkpmGxW85Q3547zN4Bh1artPg7tyZlKwk9SwxD0A5U+b2EROpajtLlapsq03I88X0i9La+Ux1fK+pzsRMjcix5pRJEwLxq7MOhB0Vl0yQZOgk9VrObHjSYmxxAomMrIqWfSMzakkm/RMkEpiqcNycZE1dA8p000pgk5wvUnROHzZ5wrFcfh1mRsMwOWAugRoXYN0SPImQckzgpExOESJ5MhhWUU0DFkrLqSNkEjB0tfSVb22Y4//9/6v/X0SYDGwzKQIt+G7sbiC8Aw8M6IDXfM/3SMUBi7EGvOqiqqkWCAomCD8DUHD6McXZwzV9nqgtrrPhgGJhunsO00t/dwWvcmWWUQA/EMyq5l9DZtNedmfkGWdLZIiWYbruOwXT3ZipTzdO+8Z+xTw3QuClnT53bVXDLPX7x/tvHmsZZm+1iiyzrVsLFmt2kq50tJnWrYc5e19Ss+96rKqG9DNPzuM7q3T4371y/Ztd1zV/CtTVrOu7qQK6bWX8mGYpFBwaRGI0GpEKwv4lSsmUxGIQ7LHel8dy7Yq0vMrtTly/vK7vHWO/x/efd/v////+/nl+X////////////////////7/XaGduXwukAAAAYV8/qRhwH9VoIS08IaBworiQ243K6pNBtgHaggSDkqXiJlcmxvmRVWHtMULHSDFElAvwDA5LmBumtq1GzGZsaILRZIvDXHWbnTxeOlM8gmUSoYus8TRSMEPZ9Hq1KUs1pmDoIuilPImiDLdFR5F9Kt7nXME1pHTy6Sj5s2ylKYvKoMtkLMms2Lw5RFjAihIjmFwPzHIHKIuakGKhqWzAyMDdI1OIpKboonq63/r//ur/////+5JFc3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACNOQUYZWgADXMgogylAAJQJBUh2tAAKhPutTntAAWSiiiVhyAkNgFJwBgcTgZvH4GGAUBjYyBwBaDVRHhcyA0CwTmANGAAi4OsgRjgYAuTZgIDEumHFgZkCBuyoABQ1J0EIcuomwcoNsBgIBggATBKdNTHsnU4ggM+I3EBw5cUckz5TNDMSgRdpoiN8PGHwDIC4BwGo4mvYlBbOyKxNBAcZMNVkGHApM0ZBOgyympNA8paZHC4IuAplcpkXdbnTyLJr2UaMxu5/Rk+yRHlcuFIUATgeoPtR9Zmai3lctmJUPLqZBJEyIKSw1RzED5utBo7xCcYQpQToJcTZFSTPkmTBUMC5ev//6Kf1v///V+xcRNy+bpiKBtAeuACPBxYAYgHEADBBbAChgrogGUxQY9CtxZZ8OXH4cE0UTayGAWbgOwgZQKBz6gGDQAfJKLmIgN8bwnQiQJNhRgFygFhgBJkEQkskkPsoJiwnSIkCJ4uBEMiOXDE5BDIhoZFGTRZyoZG62PlIyNEDiA5J86gcZNBFzNAgJeMTU6kZmKj2o1LdaFR02bpqOvoMySjFM8itBSlppOkjRutJRgZp61OZnTZBjV6aKCKCKKTu6abGKZMECD8h2EeXzcrnU6lqQJQiYX+KQ5xEi4ast6Klojkh6IuUmTUpIpPet///yybfZX//9F/+2t0DA8brTm6m01IW92JVLqbLLLdCzl4GDGalmfAIbReimX9nWwqAqYwK8AjVHKaAYsXaWM60Tay1llMDSnKAaJmLHZiRPtMwm6/r8zEWvohvrVrypyn+i2eUBM6fqbf2HaWxM2bEqvymWy2lbrAz7qw3I1Lo1Tcw1alUqprUpf6HrWVWUxmHamLe4fvV29qllvPrU1r+91TWsaXHdyzurharRq1MyqXU2VWlpZTS9qy2lq0t6ml1nGGXJZ4JAn1nYjDUu+rS0s7hTVatXeV+1l3WWXf1rnMsu7x/dmpZ1r90vK1beWWNnUSh6ngJnTLpe1lQFIVFVYQwBsywVSgEggMCLjNeglOVIpTZxs4ZcFyXdlucdf2HX9h3lZ/ozKbOOPK0qtY0uP5U0ajVrKtTSqmy+rZFoAAAH/xbP7afyFRzvDTJ3EiURJEeqMwJAeg1gnAXA1L6BoyZutMwLijhcNJ0e5TTMy+bzMehcqQZN1epZfN1KMENDQN6y+XzdBnTN1ILM06y4hqQWm9/603//t039Saf9lpvpvUhTUPQuNXWnpppsowZ1INWm9b9tTfrdXQ1p6dBzAuGiZuTB6D+CSAhAlBPJcwNSTHOUEC4ShotIuAABiCUenqlHLlwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfYhlGlb0AGz5BKqapIACoqQVYZSgAChkgqQykwACkAAABjzu/y33l2GF6DAkYV8GNghax2IOpJNOZ6urXZuaUGdTmnm6cnl0DSqVTDTdRx5ascRdpJdcktLXxxkD4szDhi37WUqsUEk7Uxs3beUqrS7meWuY47mE7XzdF+Jfv5ivWppi3VppRKp6vl3ur+qkNVFR2+75zHDtXn48//3rLX5f9fOl3yS3eZ1L1z/x/LLLeOHc8bPP/lWds1Zy1r9f+rc/GdZVuXq1S1jhzG32t+OOdatW1ytfyrWefn/d6z/V/WtfboKj7P1A190Z97maQCIw8w7bkOtC3lZlDsFy7sp5at/UlNjtjuMm1ll3tatm2a8kEqisfUAgAAAAD/XU6RMClQDooONjjRQuXiePrOkuCEwAdICX1kVGZLrkNIMpIvKLBddSKKaziZdORO55ZdNUTExRUlqQossul1bLdaJk6Is4nkkiaSrMVrRRrRZFFFlonWNW2Ukp+/fpJd93pJP2UlpJNW1aKLWXJotl1FE2SWeReigTJdNC8TZVQRKJNJzAvGxkXi8YomJFTUxLprMiDJO+oyRR1ssmTVajBJEol0ljcQGPj+LlGiTpqyJudLpaSTJk1SLxFi8kkXi9KxLBV7PSKCIQHEJgSMgYJEBASBxDwX0DLoHaSgCqQNGTAwKADbswy2BiBYpNIcIhKAKBAw58BiGAAFCjsA02CIWbAMBQTCCPxPgnAVoOAGx8UGI3J4PSDchjQWWLOGdcUARUa4e2BizYj4VAWWHvgdCusgQnYsAYmABnQoLCBBdMUuSgXNjCRFaiEpEw1eMUkDSiMwTRVL5UL7itCsZEoRYxHLJoiKzNFZ4XILIHAShoXzxfcT0FrBBDQpl4gxVIuH4AsFLxkmTLzVNRoZGizxmmZpDllwuMmbGyJfL60EUjJ0VUkTM0UYJmhmVzMvzRU0TJ88OQZhmQMmjAkfBQWGFBBcZ0XhMkySijhNDLE0H1DyikRCFOVTiDutI0UYIC5BlDAcwniYRQPIujtZd5HkNKRiQ0pKKAxpFCKkWQLpk5iTxqTpbIoTB5Bj56pa06lDJVVfVYOEevzA8JYI9IcF73IYG1jDLoY1Ay7AZADNIQRDDy2MycJAyNAQJCtykH5g3KFBnVzMtFgkxmDA+Q5VKfNRnCGEwWCfF0RUXNtHSXHOJGSzBR04pFBvTMiJoOpUyNjGyX9aCCf7vZfWf/9Cplo+9FVT//0ZolU1R5SnWvSdyGHkHb/3UpX9KpqzMzYrC5z5bN2T9P7KX6Jiy0TIzMnrZLX//t/+v8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGrohTh2qAAu3RCnDtTABdFh9GDemty8pEaMG8wbnVwQiDHSS4pfEz0oFZi9TDBMivqykvAs5As6KGGVAxawRIPmK5Ei+QwrrKLETGyiOWPBPF4tGw6hmi8TpsUFpUTEoaBHl0oBEaAcJGZFFOieCfUSZdMDdZeplBi89RqUjy0VLpobIrulUQ4L1ChSdZJBRxjBalIuZ1oHqdJaBmzM6Jgemh9E5RNjyaCkUls61qSQTWix09TaTajhECoTRCDNBi8EQcnByhzS6K0NCGkTFkjnE2o1K6zA6k6CkFVNTqSZnq3eh/omJVZv////9ekXiDDtarVwLkDOXQMBCAJoJxswiA5aZOsuUyL72x2Zbqwr4H9gCmhpCnMVysIBkNJonCVKJVHIGVH0TJEjYOgG2T5ePG5cdbJlEgROl8qFUnAi0BRoj0W0mxbyJF4tGhNkwkaEsfIukTRcNyibjqKq2WcY0WkjtSdzhNBZcJaSKCJsZmKRmlZ1mClIpLQTWZJF9FM3PKKZ9ZbLRgU1JHnUmmcRTN0FHJmbHkETU4ZMyaZFEyoONydHEQUJmDSBQQs0eiYFJk0TA7RukmRxmWyITMpIHj9NBS0potNF1speipS/7LMSdWv///7f7VHCkLUZmpHtIys4ViSLLAQIdwwQOQjAJgbWbiwWw9Lhi77uwpgutXxrO6RDBHcZo5jRIo+bbw2MAZRHIy2r/1XvgaPr3zkjkOGzt/91IYdyAKCadBrj+ioMAiQUHQBobqgaRLH5KzUeY7TpsPQnmRPUeUUB3FFTJGSCDdJV0bsDAAYx8yZJRqyS1res+iiYJHzVklXUXjkvF5A+mgZJXNETVBToGSVU4tKpI+g9SjE2HcNQ9SeSAkwgoMoDdAmLjtExUMsoGgyi0nlIxRMiSWiylpLXXZJFlWqrSRXXWmmggYFwuHv+3///+iXRPSk3NfhwKg527ULAaShh+wkETC5ASG2FYCAFBAMGQU+8BrngAYDOw9daPaa6ObJ3bWxNRWTO3ZnoHe9wI1Va4OKMCgVo7/qkVgcSpPv/G6eXQSyNTNgwOEMwYs5ADXBoNurv1SsVCmRAgREygT7EVm5sUxeEQUtNFaTqrWzmSjZzEQmBWJ9JSy6pjqNlrQoJm7OqipGiYoGRPFE+mkmbImrKN1IoF4yZAyRp0N0k0VKQUUjIi5wdYuxYRNwJAWVDuH8ZojROpMl8oGZIlI6emZOmqDorRPJMi7pqUuyfZJ7KQQQTTWTZNuzaH3/+3/8yMhliZNVSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACkyDUYN703KnsOpQYyduZo4vPBXOAAqwRChCt0AAh1q46qmxdZvo2BCQBCRwfWbOXGXkBGzGAixdhHYIJx4QHiIoNAcaAIrMnOAYACgKFiIwYBLdJljAuSBAhCU0mWzal78R1PdpSgKDxgwMVgKuU41ysFWGVyjWigw9rj7v5akbsS8GgyYS/VYCEDAxCTPZwDYaLMmXrGObgFASFxEOCgYuu+TBlKUylktUibNk8WTMlfpkcEP+/D2QudragSTw7Dz/QzAUisRudtUspmpmSNFQyMsWSwaxGIvRRaMxqSzFPfopdSzVeUT85eo4nLs7FuxMRqhqW5y1S1rtXVu9as1rtikt2aarQVbMWlb+4OGzpr8VmH43Pvrhdeh97VNUr2L+qbGtd3hfvWqtSvKJtCW905nhnzPLHW8O8y5jlVwnt5Vbms8O45Vct53r9m1zCnpLFHJoWyxgcPS2/ldZ40klCQkT/ac9PWMwT7EsKHA7QCyCohWYV87L0qAtdZa8DJpfAYNiQAwmns2YZadMznxCLWrMdf6NOFPKPyftmM35TDtLDMVlVp6oS/zwhQk4myUBH5W5MZ+aJ22wEwHFx4rHjRqhs45XnUOO/3xUDoFqGqrMarZN3+yMtfpTY5trr62n+s31njpY4wUCWFQjAkJbA9OIoNTCSmItNvt7N/3vzTjh4bCKRNr/////8hOrEhwMTCo3sdjzYTMViowcYDzBwNih0w2zzM5WC48QBhxZGQAHJ8wQBwKAwSFgqFDTR5MEhEgBhkkSjQVe9ZrcXtWDJA6NBAaE6omY1VfPGrhsZAHl0tnnWNRVgK5mzu4vaWSvWU3IUJqFsPo7Fo2fltktDLsENukxWcCgRl7TF6t5D9AvaffaX4NKWeoReszCZ1HS9+rZxhmYnsK1mlxpq0s59JzKmyZXBplMgAIKR6JOhHrWH436f+fXtarVo3+T00FLvceYjcyrfrH8+8i29bww3dsWvw1bhqLSqLwVHo2yRAct6bS4swPFLEqbZ3rU/MTOO8cMe6y1lvv7paeMmAAAt/DLf/j+//X8/9ZZb5++/v7l/e8/+3bz/nNfhhhlp0kAV+5nhh+8f5bp5Zlh3/5q4QuSWBwEPlCI2kJTPWaAA8bWRoAaxUp7M3IiQDwAZBqOkQeThAigYFRydLwvjU3KZgokTYrhn4nIompfbrXWbHFJmBFjU1NCOIKeFIi2oIlU8tJE+klTMzE8bdB2//QSTMKnQrXRLqaSKtFaLKV2WfMaRgtM6k02poV0Wq6CVVJbUGPFwj0TcnxXzANsIuLYU5Nk6Uy41Muk+cTRRP3tfRT7t/////////1MUjVwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAoakFYGUoAArRIKsMfEACMGQVAdrIAC/sCrQ7EgABC4B44CgkDKCgxYAN1A2aALgQMwzAAAgEuAUDg3LJoIHggUB8UQIGDgwGZlkjxYAwWAcAC3wEyQDKELKQ34CXkvicBBMaRcE6j2M6H0QJkcknCBjnkTI8VuMwLNHkTkUjh0ZwiCAyYY0FaEQK5gZCeh1JGQ5xwdAwTRGXFEUQIuRc3IcRIONIDJkWaRhCDZdNNMtE2T5FDUT6XC4aE0RYZYdJxRiig6CJFnPqVL5mblwmC4ONJAg5FyyykC8RJZOkyZGdlTJNvK5iRNSRGGBfL5uaLTNGKpMhMMOcRUukzoqdSTssgxgkrf9M+ggbmB4VuGRxOYGMDAFAAxgDZ8NVjjJkVuOMdhTJ8qGZPjmE4xSSKRuZGw6RjhKQWCAxh8AIqFhJBiNEKkOLzqcyMi8TSi8XqaukgiRowiDnjdaSaSSdL69B5SRd2MLMt4HdlDOVAt8O4i74EwFeH4EkOovDqEIUZuOeNtxPwoQSgmgeNqjI+aCdx+GQSQaxubE4ax9jlDOjVTUmpBrjlmhodiPwt2B1hoY5xFf61v5JmCSyCEUNP/6m6b2METT7///sm6BogX002T9NakF/51Gz/6Zog0zNy4TjIGiDmH+gxum6CH///ZEmjZJv/80dSBukaDnkHJ8T47GZDyDjgZkELoIJvep6CgeaO4HfGCggwDLoBdmoIFs0cxoCa6gZMcslONFRQJAYXnTPUAdZuCRIzOdd7AV0MvYuuR611zcYsu/QUllhceZI3SQu3AEmdeAJM75IC3eRRCIz0xb+Sxx9msvw5mlsJ8ARIoZNvEBnmIkgNEg0MG4qCN3oIFyijtxKQXonNTsb1H56pQVb8x+XLUxMOLfpKtuWT+HbGeGOdTG3Qu279qvL5irfl8o5T0+6mNfPXO63lzPP+b1jvtP/b2fZbZw3zuse4W738xw1njj+u59/PXc8fxyqYY87rLl/W+8/uX81+eHKla7Ga3aTU5XhiISd/pRPxWflEhrZ6u/3DfOZdyz3a3+Wt81nz/3rvcN/3m9c7MWXbi/3Y6rhPOVUC21+xaXWoCMB0CdStWNS6TJOmBFTpRMAG7GZJ1i8UUHKRyYl1ZYNUTxiVS8bHSdMTY4NQyZE+s1RN3NhSAW9ECHGxdPGReRZ1KWYpsYjlF5ajJ0klso2sous60WmKNLUkbnklJf+3qqo9lI3W2tHSetknVpIkCTZTaXSNkktBJLRRZVGklrRZT9FvpUltpOa1pF5ai8SRiLWDeEcwmxkSdUWRzTcuoE8XlsbJJOYtOGhDuIySiusJLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJP5BUhWsgAKqPSoCsvAAfAkFQGUoAA3ZIKkMpMACVMia4YA8bpy4YjBIZGu3GFMmTAyOEm3OBwFQdE5ei6xAEZiACcXq7buPmUCBVZYN7oAa67bjN0jdRncPyzNp7KoTFmgRt33cdR043Kocfhz5ZDnIbp5yPtYikRtSbGhfBHpcgBmPMhOdkrdoDxhp+oHuW+ZW7tNuflmVvCKV5fjP/Y3b7LKSgl1e3cszc/Ut0mNPasVafU/cCg8Oz9+kwx5vv83+WH8/uG88vwsc3+dupcv8w1LLztv3ADB2yLER3Mk0OLLyBADY0fGfq7eBpj7wO7EmfylhuahyZl9Sxhu3cvU+VJuWXaeper9w3Yr9pMafVjd7O7jqf3Ug2sy6fnOz9THk7apuby5lvPtTlvKxu3X7U5T9uu2xOBN9ww/95Z/zeeGpuM1L0Ms7BQzuUrK2jy5ci4EbzH4CJ8nUrskdnb8NkdDwJgGwUaWQyCm2qI51zal5FU6vFdwqR7SVYz3QO95rjeb4P5y3uL9ywZsZrrdZdajuPzS+c11v/Nv/nWcZ9Yv/9df4////8L///4+9f/Of/v////////F4u/8e+HkSHfW/TO8b/+f/rH/////+v//8a3//6Z/hY3h9aFBZcvFW4ZrCsGSIx6xqGu6v9I2wP2QHNA/AoQiA8L0DEkghOAZHiBxT4GA9gZyEGUDkCBhYeMEPZAzY8FtoD8IFioGKbgsjFbjHh6RGDbIiGQR0isCpEeJKTRADYP2MBdlUNyRMpGxedjYwSSLhIGy5Egy4I1RQDrDiHcPBkYitxpikGOHhUCJkiPBSZEoESLZBUUFuovkTdF6BgXjVaRiZLQdNFDSZCbotQXY1E1U7KoLMjo/DfdBm08jCsyZ+s3TND5qsyIaRcDBBRkTJ0C8dWp0WWmoWojCkx5lLUkiyBSPi7GIXiooxWbUaU6tlTxKn7fqTDURGvr6+pI6f/8ulp/TR/Wt//UWvmwZlwveOkMCD5FxiAgyIYXAaukXSDVZEx0A2eOF4LqwtmBUIWaQLjDnniPEbhZcdZ3YXGPBFyLiFCGCeC8y6bjsLI4xbBW4t4skggemLCt1IEXNh3oityTD6FYnhS5JCPwPMQaGNPxZDkweMEGD9yaJs0MTrf8uFxAny+msvm51mNyuYnjczt/zR2Jsn3TN3L5ubE6USIGpOzQtF9vpP/oFc4aH0hcApeXBmy+6aay+XxSIfwEOBaBsCzRySUIgWjdv//+r+mnXvvv/pvfNTdNNk1LZSH7KomY9n3pGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACJKKU4drIAK/sgqg7EwAJaYtRg5rTcqLw+lBrEG4whxE0QMTGajADKcDCCOgo6cwyMjXnVgW5BqCMeHJfjpIjuL9K6diEJTs3eyA2VuO8yYiRDALljT7tbZ+qKPWajttba/L4gzhxJS+8YnILh903Hg9y3YkWFBLMcdUkNUDYFdQAFDDYqPjw9qDcIQvEQAGAaAwNMdt5JAkw/kUm3/n4xDmL+Q5VldvCWXpuWczp8951869PfuVPt28s7cqsc/cGu+wBMRtJunp8KTDCx9fuqn7sfnnrDmd37fdYby7Znp+luSyC5FJpVUo4rM9t44c1lzPPLXN4a7nhhhvvM8/w5//vP8Obz/Wf4c3n3WGWubz/WH4Ybzlcbt5/////+///w/deV08OTm69PnAMER8AH9225B7ZXFW6hYYUUY2v47jX24NFeJvR2CkQNQiFJQcJPGgguM2QYqEXJ4tGZsVjFbHjIdqJVKJMHz5cLJxE3NTxNkoWS8Wi+TiZeJ5AnikZmAs0dYtINYiXBigR6IPKhDx6JcwMzBblo7MmfbXqpaSSLXo0VvSd31MTg6UzLUkjdNJJK6KKP+tkUfVrMUTpikosF4iQlEPlGRMSaIsRYniskZGykTFGiizevX3////War/////0j5PGySn/3VSPxpyXKAAVNiiMygCWVAYCmFyQcvMRncRqboaAAHAwEkIYuCxAy4KUClkLBTGDUNVyslSfThNSAR+hsUBvy/K0gKALKxCYgx2SYPVU1ZS58RQdXSumAmdSt2oYa8uZgz/RKC3cltLlQ1q7YnfoUiWdS9ASYQaZIKQqjMywVZC5Qxw1DVnwJAKbP26MY1GbjAnGnrE27TtTtaHm1paKmjUawpr+O5rdLGa1qUynC1ljZ3Sxm9TWssX1IQRpR6XMenqtnUqs/W/HPHWWFN3eOGX9yzxs6yzlD1y59ZBIIykM5eEjpbkZmpFVuzGeesLVWzrXfypsceZd/uvx5lNU+P7x/WX44/jzLL8f1j+svx5rL8qbqOr7Y///+///x/8cfy7VYDPQ1Gpduls+EwmQWjGlYCtUFEAcCbZPYtknqD4zvxyH6SNba1Zco55d+nprFpwY1Gcq7kxaetY565yA1ON6l1S1vDuNNbxyt3vpdf2vJb33zAySJkY0SkH9A7ECB8RByAEGHSWy1RSRUls/+pNalWqUul9JLWkkxSIMfa3NEnUylJqdvr1+pb+tjpcL6mMyWURcc40SL5pOvSUiimtdvo/V////Wk//1f//8vonfxEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACIqHz4VzYAK0C/pgrMQAKXJBVhlKAAKfSCtDJSAAZvABgIRGMBUd6fplMeg4JAARGXHkdDQRyMMGFwaCACIQELAUoAoQBAIGAcYF/zF4gKBAsANNibL0Px43DjpTtx0Qa0tWguABCWnJiS0Awnbi68FydYWHb8jp7Lty2jct8quccdhH2GIatXX/vPo+0G2aaRza633KwEDFzoNBQGKXMNh+D4ljaeac/tH2pKs//O5A1uNfhSVv5axnbnLVrLHWH5Xub5/6wquTWbYKhknuW8ct3cNZ4Vu/hzPms/5/Mrdre900qlUWhMMPEzpK9M1ry2YYm4FgSamZ3UsrUs9j+Weff3jh3P/5nzfP/la1jv////////+//////////LSyW1sd///////////W6vlmOV33WHInovHkxAcIYeJgGPY3BOi8pWseeGPEFwHYixqKTFlmwswi5GBkQZBMUGLnIuQc1Om5oQ0T4iYFwi5Fy+5gRQghqUyCHifSHMJwxFbjNm5FzcmCCIkPJ8mCDl4UgGXAbqAagAwBsEB6hBhZgYoFgJsZcrmBOHzAuGiaboVU3600GW6a003Zf3/ppIEXJ9N6mtd//+32UYPTPJD7KZUMLmqKb01Gk+j////EDv+EwfD6DgGxQHANUpEBwNOsAcmAxIoBdECx8CiIHMygJYBokAChgDbyxaQtSIFAOAhoAgAIJkEIwlgMeLAa+A4OBgYIDQkQkIcaC8UDcwWAWMToOYI0YNtMFT7EEGTEoCAghGNsdoyofQXIRY/L5iR5GB+wiwpcxICakEJog5GFASU6cSZ0Bnx8BcwMuRUdA6xeh6QXUhjMBQQPkZNl3+J1HOFgGYZAiBFzAWQQQjBC5AySIoThpy77pyweJs6Q4iA7CDjmEYSpbK5fHkihDjcyMCKFRN2mhRM0V/kwQIXocuOsfRdJ0rlwwTLhgsiJFgQghG5gaFI3TSMEGd/7JGiSJPkTRN3vvv0Dcm0jch4zYYjBIEI1A3RYAUmGLgDhQYxEzEHCiicyTJ0iZNEFHePQ7CJlkyMSdTMxzRyR4EfBiIOOF6XUCiRqimassxTKK1UADgWANZoBwgISCw0jALMGEAGlJAh4pMsBhQWSM2N4MRlAiR8iRGl4dggcmxlBZI6SmYkNM0zBA+SCBsYomilGRoaKJ84bF0uqKKzdkiOC1Q7CDmRUJ8gxVWanimHQiBysklrClB2x7UT5moAvi2QUuprRV6++6q9b1O35k3+5db/MR6f/5NJ1f9Bnpf9dm///+r86//6lzdBaKdvWlb/9mZ3WkhtTP/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkbjFOHb0ACtVAq4Ow0ACGiIVKNYw3aaz4q0Yw1uaFL1CSYAIkyKbGckQS00Lixjh+cMdPOvM1A2MtFBUCL9ug1tEUdCsBQCp0lxYoFgp9QxcZgzpmBBpIs5cVwUhkwmdOs+q4WuwqSw099Z+oZh10XBWKhky2NOjCY/Dsdd13qrsuTFYzRZVLFqmyl0gh6Lw60VnSQzjBYCYgiaayZ4gZk8ZAuZQaYYCXhSJYKul5bVz5U/z/T3eVIzBFWl5qV0Xd5YfvHH90tLyrj+OGWdT9ZWe9zy7/cpp/r4qDEhcJnv/Pm73O3KaJSfDKtjzfNY5WPy3y1hTc1fx5b/m+VbOu4f9z+/3HmeOPN3e4d13WX1N0U9OV7z8w7FnodJ1W8pJuVSyw+VNYxr4c73VzPfe1sbWOt/d5jr//L8ss6Bg9Mdj+VNDUveStGnaf2U8bsIzq11N4NQN2OmBLB0BIhMWQH4voIoEGovScXUEkyVLyzJZ5NEepemS2MVOq6lJGKCRigbzEkSVLrHlk0ki6goyWtReqRU6kHQWySk0a/Uukv//siij16KnUvUkpTo1qep60x6G7L1PZFJa0nRWik6lO1F6S30dT7r+6WjzJaRkYmii8ZkEkQYQmglZJDCmiY/EmUzA3KJkkXlomR09YyOhOqSpUSuU1RAAAAA/GnvF3xO9J4HdBYY5yd005zZwgcAX0wRzWTpHg44OGu935PExEIHsdlx4am2tz9PbpX/dt533jLLqCpG4bf923bdeG7uaqM5zm728IYd+X09PX/DC5bldPT15fG5XK5bMTl7nVH2ey6pSXq+d2vL5fSYa5hhhhhuHdawqWJZSW8991hUpKSnp6fPPPPveb/6uP73rnP/P6dkLJsMOfuvnnhr86eVw+/7vs4YYsIhIAAjEItAgETAUHXW19/5/CUQxDj/xunt91SUlJnv9WKSpY5+GFJSYYf+FSphhzufcNZY6mcLU8/jwyDOXU9fXaK/V7d/XO5555/2pcwzzz/9alDsO/bD1/M4AMAAAAD888qJXtqxXhhuEhf4QWDn0/ZXGKKnl9yWc9O4M7Jb9C/79z0ojFqphY5Wn6Skzy79ixSYWWZYfXt8qWM72eVIXC6XzdBNAuMmkgyZccnk8lBiAGwA6AkAwZMHAMAYkumowUgyadBdkta/1/9v29v9M3NP/Utr/TTTTX9Fb///6/9X96SK3SRY8TSCZLKSDTRSkTH1E5rQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIQIhUg1rDcr0ReqBh825mQiFMDedNyohD6xGHtbivjFISFWZvQT+tgUWZQNthpO2gOE1EulzKPJylwTiDi/Tj34EgRezYF/NefptJJPwHCXfmohL1g2awl/X1lUut1aKW7j8O0cphmlk0pgGGKZl0q1yns/M3e9lWE/jYpasES3CPU+MAxWgjUvmty+IMERDVEBjrKR8glg8adCUS+BMZXVsXrNfPOvZs2ca+8N43satXG9zD+5a/Wv5zuWtdt5yfLeGG8f1vePPyrUcPSWkki5kwmGpqtNjO4y7rkuS7r+xmlr7pYZjMtluOO7tnnP7lWq0tnH+5Zax5ruWWWWXP/8LWWVrVrKtl+9/llr97x5z+bxxxxx/f41ceaiT5sutNWXb/0xT6WlnU7w9ktg1pbSjKGHGGqoNOMpGk6JlEDWIY1sLm/SRZI5mWyCHXEUq4blbGYI1oL28O+YOaxmCErY2I+Ias3IyQGi5IESPG5Is5OF41Ny6lNSsPkxFhF2EQA8oz4fiMsLlIEcG+RFMtFRJjY1Tugmb9Wn1NZP2TegykEGTToNatdzhMjQNFJvUyaHUXDRqiYHMJ0VuO8zGXImUyDlcwLhcYzNzS91Iev9q///Vrsd0HSW3R////10G6jBaOs+b5BCY0cmGMQOtFrs9BwsaMGGsTDggALRFQDOMimhWgKP11dKVYcE5xaloJblMBQZfKejMV2pXkySRTToiuURAr4ftgLNEvW+qQQ97+zk1KnehmKO1C1VXAg993afN+ZLHn6p3deiDnalbq3oatSmAIAfnB/nan4PpXCaVB8BN3ZIYMEOBzKGxnYFFxrRwwNMsDSeAQJm6CVkqtq9YCh6F5uzFXqfmah7crhmxDU9Gp6UQzO1qaelNNdvfezmM5bjS41rWOPM/1llVx5la1azx5lfZTAQOEBwN7YNlb9xqHIjG7kO0lq5XnakMwFM2ZVXq2blnlNnjjrLuWW8ed7Wpdbs8rYbx5jjrLvN6yx5l3eOsu6y/HHWX77rHmWW8cLNAyONa7jjN37MLFEUC6SRUAEAAAfu5Pl9TMOrVnkXigjfT2/w9e0SIK9GySKqVtcrvZDmjVVqp8V7CPaNmuNa+9bzF1Bi238wZsobFtGWiaslUbL60epJM0EuLXrZKZGxNWipJKiySnW1STovRRUk60fU9E1WiipJ1ostFSSVFicXUaTr1I31skSTHC8w0AN4cZAZEyJZMumqjZIyL1E1UlpPRalWl/////////9SZgUesAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACOCHz4Obo3DAMOqEZw9un+IfQBXKAANxQ+mCs0AAdmadlL4EC80XnzSAJJh0XXJTkcIK5m/JgYMJ4J6mCBpgAeYoHq0ggFOKbGiDJePG6sLHGkw/GtxiFssUrDhgSUb6sD1PwOEbJdLvYYOBKhcNvzBMO9oHbbLlDUKXlBU4WyjcirSt6zzEBFwkSIKgREyMx1lk6PA6hJCeNyUJ8lSmLJJ8xWREzYhQsCDZ4LhRTRsiE4uYZsgAyhCF4cZCpEUWm5NE6iTSRkS5sapoojPFtAplFM8UDItFs4tmNTUxSdFzU2Nz6Tsgqo1OmKJw6TpZJYdYGJZAwuLAOYWAJHRAcgRZSFAEyJSNTY0HwSBOjyaFYhhWQWyNpqyCamdl1mI6S0g/Pf1HD///+sx+qohwX+JNqKymWzjW2iUgAAAAfv+swBhVyef5LY5z0R0i3Hn4YdSVv49Y+mw4D8UsPy/kw5E5BNPEJ2Nv5IHbl7CocnMJuMXs7dTDWf/UqVPryuX6tU/eUhu6akmV7/ascGN/Bj2eRX97RGCJV/ZSFsCGAQABs8icGQ8XZc2lkZ5Imb3gTZpq/xT/GKf//7x81p/9W+P//j////Gv//SBJH3nTMxR3OJ7TYhfe9Xf3v8f71///////////////////////////////73//xJuu76wAEAhrSFmhSCBhmYhAoARhrk3mK4IjogMTYVc/IwBhHJAwObHDV4Bo0CU4XY6idIkSYtgfcLJw404DYGLlMiLCyzMGosTyUxjR4Dkw2pReIAxFGTLiRqXBliKG4WUkHGdJgniyM2QQxOmJNl0hR5IELPJGWBkxAAZsnCsTpAiDFgfZDC6Xhpg3iDbBMABBoAw4TMR6DbxEB2EsPonCDkQKQ+ThcPFdZeTNWmCbrYvKNlLPJFxOeZJnQMmc8tk+kymVoIIoMp0CeKJQD1hmCOICGMA+MfQzIkxDEicKxQL5ULUyLDskn1KauzUlP6DNrt/v////+6BMvVQUdThyba2ied/67WaykGmn3AbVC4kiI+li4zHBBUCIYBpWG8ikg0EWUSxwzKBDxWBZ5ZIcM6EAIcwdZwiYlAjBiDNFgdiLFUmy07OSrlEjlkOIqXi0OFIc0sEmgSZBUo7iiM0MqQQki0TxFiGk4blQnh0lw4fJYnhfjBEtFaCtwMCwBEuBEJFLg4CDeIdZBg9kfA4CbLRFiiaGZoRJJkjp4/UqimgymrdT3ro6d9vsrr7TEtkeHqi4yJl4ulcip4upniqhRozcmE1LSqdPWr1/p/v//////1GZkh3TN/ioAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAsfkFYGUoAAhrIKwMm0ACLmIUodvYAK+z+rk7DwAiSAgQJwBMBACLACScBpkAsOAKYgCkwbDgiUDUANUg2MAD9zQOkEfDGCNx3A3cRMdgx4gwMsgDBAMGLAZBh+JDifI8nhkw8IWSCOgupEEA5UPoOM2ND8UAHRC2CkCYFGJ8WSKOOs3TJ9Ii5cGwKKK4N8c4nhlTMMsj8TpEy4SB1zNZNj5J0eSLGiBExcogoG+kwTJARwC1mhUBsQImGMw+cXGfHMTAXEgSJAyMBiwxiITC3EBNTIEAECy00IqkQ4i5Fzcvl9NNN8slAgxZIoSRcKpkRA8USaOl4+KROkVJ0hpFZotaCSCCDm5gaGiDEsQ0rkXLKBfWYIBicousghQC/odMWiaJIyJ5Mh4YCK5xJBBBqFPT03pvTTrTetzWkikkTgswcxYcwLQxRwxOLGbCyyJmxBzcvJmZbOlM+X0SwTaygOWKSDAob6BoE4X4AwIAhwfEHzGA5QuIvJDnHSdHUQ0qk0dBL5fDELDPhZoDIoFngLxLom4LkFANJLweoUQgQkYnhTECHkgkcOJl9AgRPzIpmg9UR9dJZk6Vd3XXak2pN2ZVFlr37Ox9RdNG9IZ636JJmhSRnkGj2c4xHLqvqP+tur/V///yaPIfTG6v6qjJJBWr6SLv9v///Ot//90GQ///9TkktGtv//xoGtF7hYLOvLLrKlMVDTFCcy7ZNIIzQwqSP6nKl8XWbM2tNFmcioSICQ12AMpEENpPH2rQzTyluTAi4yCZ+ZSq3WT+vXFYBkbyrwoWxBgQ1O1em71y/l9WpypWsz9yfxtVsrlJIo6tpoDKoZjPaC5hnSV+2s5Vfi9LerXLt61DfZckeOA5al3Yr3GvT1qCatSqp9adw7vD7OOPfwpo9/cZjC1ll3WeX4b7vHd6lt9ppVNMOLTKDONFrOOP7r3Jyz9vlPnYz5zcpayFAVitmd3U7Yx79fvKvabeWVN3ternvn5atShrOUCXZXE6elkpeZV6DzU4l1y5uNtAi9Pnu5rHmE1SVtWu1LP5a/uGrdWtkmB49DW0WLIAAAAyy/nwwsyx+e6d0zOdPuvMSzcSlWfLVFoF4XmNHcGfN2NvxJFpisKJGcY1Jp4u7KOmIdPm2df7zuHTFq7+d/WLZb3JwxLS9H8DGcS4gRonv9xIEWh+D0FwUFX8d/mHHxA1f/PxT++P/j/63m+P9/7p8Zx/TP+/iSK5/GPiv9d09N6xem85p/j5xn/Gt+u/jW9f/73rGf/EvuWFFw/ZHNSjtG2cCkX5MMLk54iOcS0Ol5IIMCZxuiXst5ouAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIeIVSBW9gAshverSsSAAqBkFaGUoAAmJIK0Mo0ADtetDCAgoETxBsuPInDfaBzIE85vIBAZAjUZHBDMGzUjZm6JfkAqYiIHGFahMeqRSPxOH3ig2H030iZZPpBONSS92Y3dtyxfbyRwwMGZxO0k1rDlupSR6vMfcq087aq0FLW5UtM+b2AIZiselOUvq6iMclNmLVbN3KUSntW62NlDltGVKprBLN1g4ElEL3KrGM/d5Kp+/zKxZx+1yrzK3Y73HLPve//Py/Lu+Z93vussbtr7tJhT55yiQSChaw4ljOvTUFJffyWfEY3hl/b2GGf0/e/n3uGH59wzr45fhjWy+liknqPLE3ZoHERIam4zWr9vOH4pH5RZmate/Yv44YWc+0u88/7ehM3Wodg7/zYAAAAGH71MDgBHNH+3QuPeIQgRQcOWagUio/G5ARliNHCITCFwOlIoTyBsOorlUi5eTJEVgiZGDjJkoIGxVMjYnjhXcWEi92SugsyTUZoJsZJHTUvLZNFR1IjRmTZZw2LqaDmqkzVTpoGRuikWzAZpYyoWNASUTIxEFhqkiVCsOlA+eLyzyLLYytZaKVepabIqfRs60dB16pkTx/6XR+lVXSWQIiDLar/VX+/6jJJF59ZYPl02KI5peIkxwyNaJw2CAvBlwSR6VGgSGF4BYkRoQFgJBwAkYGRKAaoYBmBIGZChdcBogBuiwGIAAZ+CJtAwhQHEQBiwEkABpkFDg3RRhZJTDoAtAGaGYGsQIZ4VuKAIuZB7Yb+HrDUG+J+HQI7FcHyTQwQ9MWWMEplIcoojMkFJEVArGpOkkWSERL4oAqGRDCJDHIkCHATFA1NioVh2EwXCaIokgQYcRBk1GB43IAXBZJeIsRUyQPGItRqI8DFwGEDAMBFl8hhoDdIDDsgNwXAGGjKE0XTegnZM3WJ2EEDEhByyJkXNiKJGhOk6YF4nmOl08VVOfI8iYe8BjBwaODcIgMM6LNHQTaZdLpodICmDfhSRNaBifRLBlUdOjklRU2UkxwPaNiLGJwwNzRjI8TJgbujOHS4gVycJxaa0EycMDxueL6R9I0QZNFNTmCCESIqn0HQYLNlRJLWtkquicRSqHVdl0iGCh0ghBmQiIDUISwLThNS6KQAqMFbgDDTorY2I5JDlLS4PMCFE+HaOQxTNiXNyYPxLlVIeykS+mmYmRNSdJX3LiC3b0t6CBca1FaVJWtH0Gb0TUdw9DN0VPTH8omSKab0VlEmksZdl1fRTv/dNzNN90G9i+gkjkr/o+o/9BAkDxfM00zdN6/1ItMS6cX3//9X/+v9v//+h8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACS+J0QdzYAC7sQrE7DQAYU4fRBW9AArss+rSszACq0tlYICgYwuQDItmEoAliYGM5kEvEwXMJCs3wtjT40IhsydRRIUBApzwaPAoEAzCBEWBVAQoBmRgMvbq6BKBLWnnHYlLGtTUiJQcyIZSqhc9OZdnY/lGYPe4UBLTpROrGo0pbLYjGYTEXdpV9P9BkE2YZt6ppPJ5po7fRGvLaLG1VmrEYpMO81XjWscZI60akdj625ZMNyROLlKDEBCYYCuSw5RaOS6HJuOVYZopPK9PDLZimmex/edyVWZVnqfvW7Mtidml/v7vUtXLPL8cIw+cjiEHVWQI7NydxxHIaQ8MOWKG/ZxuTNX7s19XmrVymnk/jLyQHASYTkxmzj/f//33v/vHmt8y/v////////9///9f+T7PdrL////n5ZUzxWM8KstRQAAAANd/dWC1sySddoIpZkUSYhIIxRDnJgK6I0SAxCXc+PiA7FEobJlRafLsvkiPYlB2FwzZBBBBEoGh86qyCzQ4OZNJNBJc6lLzGCB46eQQQQmaa1smXzdNOpBN0jBRggtMwUozMzczTKzERshl8+YHjAlBzm6ZugpA4mmaoMgkyT2otZS3ZSLdaSkqi9UTUiSNzQKMFwSsfCWOjlLxNMC8olkjFB0TKp6LLWszaijt/////////2J5jmv4TEha+CR8O7j2hooGBARnqFwsELIPBzDODAeCEGI6vlNY95geGrxXJFVcIKGLMLxZJAaZUeqRV14Ggqdd8tWPLYOltHBUPWn+cyvGoaaQnOp6dyrv/mmdQQ7DlWd+ihqrfi1DXj2dJ2WwW9LQvq4yjJyJXTvq/1LUsSu/GYFg+Sy6PuzWmo8/lDY4/CRLB3fdkQhAUCbdkicykH8nI1QwLYjsukd6F5bpt4U1+l1T/etY/cwtY4Zd1vH88vq6zuVataXyuH4g4VMXng2Zlk7QSd36SpvVi1a7fzosd4a5jqw6atNFbyyz3//+HP/////////////////////////v///////+V6sIhEAAAADef1Iw/gEmZJE0bAgW+04kSSYaJCWxHBnwMZDEgAqZODiH8UiUjpFi2aHiGlUfRPskREXMKaYGJFSqR5aJskEzQsqdzrGtEyNVJpOZJGSZFZqpEyROH1nnZ0zxiSxcIsYnCieMzRz5dUYmBfQUsupLJgkh+HsUkLeBoiF1YkotYmAucXCZkFNSJENUXUE0C9LqlqdTsyXXXTW3qWv7JNSMWIqVTYs2Qaj2/+kxsXBS5Xt///9TvxYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAs5kFUGUqAAj7IK4Mm0ACJCOVYdrYAKsb+sk57QAC+FkhZCEgHQAJAgdIeEC0DWoQMSkA4KQAJyBhIY5YFXhoByngOohEGhv42AGAUBACAYBEgiAqimDbABgWByYGAyGBpIIgRBCJfDclYrDbD4CeAUCYCgGEfAoBDjj6IgxACmPQx4/Bc+GAQy0DdgN3FQxPrTRJwR4P5EyfPhYyHFgoBBJhtB+iJ+ZGSLFwghdIOT5sVBHYW0AYAIjIuibgumi6TlYiofGKikQQ1J8iaAoQWYTxiKMGXQwgKEWMcNYWkqImy7/pNY3QMDRMxNx0kSIiMqQANViUhSIrQQRIFayJMLMq26lF4qkmRMghVJBM+bqY0WIJi8AwGHQuCIwVIUqQEqEWIcbFEzKqf////K6boIHTcWMP0DpA3kPuGqAywO0cZAyJlw+RQ0IIWSfHPNjQlBxjkEDJ0c8LGAtAAkHgMCA8DMRFAxiLAHiMM0BgYBgUAAXOhboNXiCxuKVI0QVESPCFh9mIZMwy6YkIBKwYUD2IA4gWYC6YAKSBAYgEGAKWT4PZfEtFuIYWwk5TKxpFuYFEPS6hHEJaB8pLc1Ka0buk6L9mROpOlUddbq0n63spD1LXovWtCZZsPoway7syx/G5Z7XWak5TGtbpf//QX//Sc0W1fT91Vvbr0KzJJq/WQv//9X////U/2+uyRLF1TJL+r+tLpdfsqUgSKLKpUi8Dj62CAIbWmYYivmOy6zHEg28chuDiKlABWcOfkAWwGJyuX1JZZ3IotKnbcxjs7ZpIvD0SwmIxGIBSHgWQUtJFIx2UUs7RWKlyUWd59u/hU/5Wxp5llRiBKSYsXvprFaxSVfvVsLFJhLKmGoefGvzVXChzdKEY41pblypzDD8OYYVM8c6tXLDC9nXzzt5drYZ52+5cy1hll8dZTPNShVHexu3ZnOnn6PljPDV2/vPDX///vu89b+pjdzy1nrWWfc73/hz8tX9UkPwPF3/ctc6CcKBwgABgERMTkWI0CEPw/UOQ4/j+RSky3SRCMTFJhjdxpOXr2NPX7fx3nuvT09P3WeedcvGZAAAAGMYpiQR8eNUiTrCTAwGhGpt0x5GExKZ4RwF+O6eNyUomRayjNRONTZnHoX3MDE2QRHIimkedNBe9lIn2Wca7PQQY6ZFh9ZxkkXZRmk00TqZ1qRRV1KpaNO3+u2vp7oVvpq2fTVtqJ59lK2SWgi90E0UkXpoVqa6GtJttam9Nez2N0GSNDdE2KJHH0OoKsYAfCCWokwmlizcuGcyNUlGYgJnBemBKbblNQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH24xVA1p7crKwCvRnDW4fpg1KDm3tyxbBKtGcNbrGljMph2nHjhNTom5M7XK4Z5MI9eZU06GqKerwJKmRRpIoUZGqyIRRJ/ar8u7Syl/o1eksG0tHKZ2OxmQS67DdncpEQV27OqL5Vla3KX9jKtQlt1FbPChNz6NZiRBjE+TKt7yNiDBktGfUjRmVxi4zGfM0KGutYzu8dMHvHb4c1JPn4/m+sXtur15l641k385rV7Xdrf1ixYu6vVaF6L1PWevmaNbG4lf7U3u+/jVr7zrPra98bpBrWsX1q9rX4xjNYMFWq1iOoxjqVzHcupOSDBuHul1cfA+hvDeJaeKlrI3MSKYosGalmZys+r9ahYx7Wtbe8wYL2wU+sU0AAAAP3+9XSVeZ1MymwrOZMa+53H7W5Tu18roGjHQD20eU3K61upT4X63I9L7eXM5/PdSzhuHpz7Odq73DXf3TSQROrSq1uixFH0kFKNFJmBjUbpspM+uhnmQX7KWmTjKp309utVSdtmTQ2qZPZ+g69zYhlNnXoazdbrTUicQdkGdfUh2pm7Z+yummtb6jq1qNDdSJ9IaTQJuLqIc8+XXHwjnzMlKZqnMmM4eOCKujr5AU5E5VFYuvgKMADFZ52TJWpdgYEGi54ZDBQcMoVMdZq+bTGfrdbZXMLMNFD1HcSSEH1cNu0F3qaG5XLJe9Cq9Iu1xZHTv7lSulYnpmyOjy0o7GMsaexnnYt5TwFPHjx6yWtEjTOQUhemKIqoz5SOVqOTLZgw4zrU0aHjGaQ1cHhxtI2q96nC4MRImGPu8Olo25M/Nb1rF0iq23bGdy4ri1sXjfcupfBr9P2uH5P498WurX9Mwo14MbPjYhZpp9qrFv+BLj2pH/xvUryR97Y+qtzInlW5bLdCOkkAFgepeP0aR1symcUfMqmGdtu8tCXe8WzF89IsY5OmXJ1Ief+aAAAAA/vM8I2CFRp+HJQ9cAFQMN9Bzztw1KaWm3JMY9SypMkEVSZh6ko6m5yvIrFXeMefapnlPUePML+uqG1Zrd/Xcf3j/HZFFF0zFkadZeQH0Oaii6Rstj7JLouho0VMZIn7TB1D8JOgec2QtSZ0knVRvRSRZdkdVTulU9HVWyZdLh9G+1VNF0rWNklb1oqZVFTpLZeitaC9HV1JPMCcb0iRIxRCLANIqHEL5PRHCPEvIkqaF5IyN1mRwyPzE1bYiZcW34iAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACGSEUwVvQAC/D4qErVAAIB5BYhk5gAOoSCwDJTAAy7hKKR1DFXgyIAhFNOqbiELM3lx5Qcd95+nq0yQcSdxTCoWE5PDWNI5e5dPSzNfVnC2vuHUAVaMP/bde1ADXFSOI/+xIJAj7s7a3F7UYZ21+L1IYdh0JiJuI7EOTleNxuno3CV247Z5HYzhiUS/447DXIcpKWG2cRSPsrZ3L5RDlO0ivDkswu0MTsMLicvltnHDmcYqcry+X59wp7uWFLOZ5Zf39c5v+a7T288sMMO5YYXqlBzdTD87c3lrlenqY3KmH9pKSk12vb7hTy/Pv0lNhnepMLGG8+1t7z/+61lT/uZpZJJrzhsAeZakMTrvQvsYZWuverEYkFjWFSWavbt9s5264PoMDgQEGcqYAAAAGOedyGEjDDKhKe/d2SwS45r7xahxIY4xial1EpmBBBBEAqsJwJwpMUHY0RJwzKpo459M0KKCDmhPkeUQwISaRiutaSCtlIl53TTPsy0DU+VETQ1ZA0NkjI5LylNN2ekpNK5cZSpkcOlA4TRmko3dJFnZla2XZG1r7PtWjoqdl0zjU1tZ1rQZd0UWoqZeqy6NXprV1uvWtan9FBIzNzI2MyeSJIZ0WwZUe0jQ6WyZWibF5EuKguBCYLJ9ehYpjFZQrIX9MQeIjA9gvgSgWwJOQACKblkax0vGJmAakL6jnBKYXLKwIDg8aboEeOYyRgVWmSiwMsDdMAJIxxgmECQdIiSBfHNC3pEdwxxCjkkaQExW5rZFmQNVkcN0WcQMUkK+NhE1QMzR0E2JZFZdOhfEG6AAIS8MqPg8TxdLh0zGTQY8ZpKJ0lyCHi4kk5GkEImOcXTRky4XTJk1rSQdekjsjbQUmT5LiwF1A+kkYzEoMXkScMzVSmU62aykSaRNGVU6C1KqOmRRMFl8wUTRTMxriEApY3OmRDTizhuZHZikyaK0CkfUuZE4xATlbJurrW9VSkSwbVugZS8+l9KrsXlC7WeCplwSIyBbSVBq5qBADYA0XUU0k5uKYLESIX4AYudDJgJiNkU6S0z5OIGyJqmszSRJswH2Ao8uuahkAOiKKaamMGIwoEwQ+SpxNJE5mic3JhFAlSGFwaxPkVMSyVElGRZNC+XEGTNUECIjEBtuIIDdPk+SZVJoXERYg5LmKJjQ1vTQoLMypKJYPkOOpsYotWzuc1p0tCeW6amUooHli4zIm0SbKhwuHybL5uoxKKDrLtBJ0jGjba1OZsfRqq1/zRzQ6VTZbmCiuOsjF5w6gmgggxvM0knS61oFBIxGVUt060WUq6logAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB6qMVCdqgALSTzqk7FAAnCJBUI1p7cNlv6oRrL27IAAAAGWGdLSu6Ca4YZay/zhO1DRi8RfhtsbZieWNg6RUipgBVIBk6QBwIQCUZlc1mDoqNjM0HUkZUiYlAzSKIzQGQPgwKXiZOmqii6kka1sam6i+pFa0yqYkcNpxTCCkyVDU6XTpoonC+XyCE2QqBuRAZ4gAf4kifDigsGMyQQ3K59Y6B9kTKhoyLHkWRrXVRVlxBJ0S6ozOus8ptTXVQc+OsRYxPGCBfZaKaZis89mUmmdQRQSUs8hu5pMalrRRUgaMaHHVcyE9Gi2seda1JHzJMWoYwhxEzVy6bIE8iXi0mpqzNS2dBNavTU9q3UloISqViurQAAAAH7/VZpRhMNdf2mlUZf0joJmb6T2CsiTJGGCBeGUCyYDuBAseFuMzQuMUkDFGtTEHZJFjdIrOM0SYywCFolEolNkjNNSjEwWpMyPGNFpgxqbpHDRAxIQuu5qmmaEws8mXSIjqMyZcWeTgssslImQ5Akk0EWOFwzIY6kVqqSd7KW2kpziSmuk55Fbpuq6XWpZ0/WXyaTNVPrn0lqep7onbqrWgtbqU8xbrp2TUkudR9aKaSkECaOHSyMExKblYqF5gbDJsJKQceL1yLY5MIqjiAAAAB+es6j7giiLI4xMSuSQCY2+LBY39zde5KcKKbVsDAR2EKYmqmMpzq8q2u25uENZq5Xa/6l1LL4MSNETJwm52ud1TXbX9qaiQNbjWh7xuFSi4aWNDlqJ7Qcvrv4jewwaRNrhOqdoQk4IiDAYnuXt2+qkTqsWHsbc28X9P8e/rmsZuxi+7036en+bf/eM7zk1dbgyYr7e28SYhxL71j/61bXp8W+9Wzis3/rjXrndd5O91ut6b0/n3By3wNl2SjNEhQo964br/Naf/V8avreca3j417/OK/5xmNi1/bepiAAAABrHm8oBBqEeO2tyq4nYYe0nRA+NmkxuyzkRhuBwaOcdaa8avYU3O1blm5N9tvllqpZlFPIaWX4txMpSZaRGo/29f7d7W5JaJjL2lqUvae7yAwKRKRKPZ9WtWR5ZZ9WWCwMOF0XOCcgKnLxg06sujXUquhS0iw9wJ65z6+ls97LWXVsYtuXOfm2c/VcYpeBS2PSBWDP643n6tjfxm+rW+8XxnOItK41829IHv9YxTNsW3j79YkrrNq7eHOq3hvQZ2Od9uDCtB3fW8Q7++R+kTH8Q6XSLdTgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAZVjNSjOGt03e+qdGtPblqd+U6Nae3TzkGpAa29uSAAAAB/ed5PBxhW7IKjxzMNHAEllIZHh3DsvrZUdcZaexz1ip9m3az/n2pmkdrHtyilde9W7Hqo+NFifpsr32bXLtXqBoktSS0FJtuVFNIYg3qQPrOJKUgdQJIvHCXUS6R8cQ7y4O0CdMzqZqZJkQbx4lxIkU6lrTZz3oIGy1upSSCSSVNDX7UmSSICnTTdRo56zKNUkXRTTpJtW0+mqt0Lqq3ZFaC63XHK7V0lLNUFKYkygXCkSpsoyMTcyWpSaqG1Ck7erZf3+a9LAAAAAyy1u5BZUltLqYYyTExskmKvfjTY7xl2L02ZOAiB4XitcqmYzKqCruksVMKehb+jpaWzYwvy3GcjodiL82IrUt6l1Tsxcpb5keYmpvOIcTMPG4zdFhWpVvo4R3Nr3H8FiYS2LpsNFLR2ISyureeNIpSwRlHlmgwn+7e2I+Pndq3vfNKywaa3fHn3n438ag3e1mzmHEib3GtFzm+9W1amNa1n739RcfN8YxiF7fdrb1bWqW3GtamM5lpDq9y9cKt6hOJWrvKviLmkeBV745cslJL/e9Fr7/2pfSCUAAAABjnvUy8QpiDB1fKW5xo17xOCG5zDfx2cqV30dYRAjegFP2K965lqgjd67hXgVl8srVp6S/LpdYja7BSCXze2n1XuyOzhhW13+nkfUfWtWvqkJVVbzylpWXTdGQ1trSBpnbdQFwco9l2+Zh63sea0Z3c7sN0Dfx81rTF/v28kW0H68+NWxvXzTN9f698eAs1rRqZf/9w9zU3r5xXf174xSmt0x/bHpA3r/W/j/O9ntjHxu1ZLW8j5WxC6F1iQHkd48hX+vXECScCPG3W6ymDTzDUfly/SNLMRLFu7qSyG5ZARtHZM2UhF4Rq3KGhV2qN3cQssesDEwq7dp9aWDZm7GJ/LkdplEI7Vl8ciE3GZa5ELQBGPIacTW4Fm7c1ST0KmrOLY5p95aA25fyq2K8Vdo6KM40dSXRTMnWZRuMSKmYb0+VYgkON4d5KE1CQDuJuCqT9oW45Lz2cm+mNWlrEm9qYxauLWpA03Q40mfjOPuN6Wx7NSz6wVCtVZq/V6Zfw4+aTZ17VzD9o9vua1629mPH3a2I+c1v81vEz7NrcxNrhrER8pBd2JrVtax1tnboUK8u4/tF1nN9YzudKC5pYmNOEfR0AaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGInrTo1lbdPRwGjBvT25dFjFKjWnt27vF6QGtvbhAAAAAbw3hXhwwMgWYRe3DEqWSFsbhxC9nYtdZregyWPiSJARJdrzRShpeWaSX7z3HZCyy1lb1W+fw7E20MKhLJkszS5Vc7l+7VrtRTYw8cZ3O9iRegYkO49FpQZ7LIGiYceiIhWiCKQ5wxASPvqJTHeSVCScPmdnLiIXZ7ds3LOmU2b3O+u6mN+zMCNL9+7nZDXK1dK7obE3NPezr3RV7X8z/7YdJmdn3U6nU+GOSUs+8mxSuYLrFwXPhoqSeldxdTatKf13tmFmGIA87PbyCWwioIYJaOs4bbUcXzi7WLFOudOgE3z66waCYa9TwQFa3jHJbnjg+6Ed+bpLMRm5y3H5KqUwGoMVPsrc9kZnNY1Ka1ILJyOrFy8R0fW7wntYDtiIEYjpJRVC9ZFTCqqo71efpBdnqeB2luU7YjiQq27a36iJwvp5PFlGQGdzou/SksHUTUlIPtJHvSBS94MHH3TV6WxjU79IJrEVhbMxaNUefOtwN4xAxXOcUprdcZrJTe9z1ljakxT3trN/WDue2L1h+PNLFXD+dkNDZebHcqYtsMeu3dWQosmN7w+2IHwrhJPEVUUsyUjkAAAADKz3lp3THmR7zF5tu0mUqNhiDhUt1UyuvVT2ochp1DAjDmDUxH7k1uTSPLOxr/j8IbnRxHfb9ySsolj+KzGbTBgGXxKHpnOmsUNLKtsUBvbG57dwgxnKI16gJdgJ87fzt6sXnDclm2irvI1M66bWky1ErCUhYvJWxnhQ34+ks3RISt+LU3T29KfGfCvfzQqb9dYtnOqYtjEbe8m+y3lq3Xx/r7pe/1ifWfrWs03Wa2863q/3jG/vP/pv71Ky6381xTfvesSA8by2Kl8r4Sy2yx6RtX1f5rT//51r/H//38U//hfDu/y3q6+Ax4RSu5RR/mGnJpixCflO7MA0L8yB/nyW8YYAnIrwNA1boHhyWvJT1IvesambrgYx6YjtLKov8Zg5XRjI2wJvojH5fUk0qrWMuqlMxbpONa09GWkniqNtUB9McOErlS3yI5NRaQIjpwiI1XVOlAMR5AvlXOrVl0p1WO9fVKGuUbMODm9qzavjddbgw9Z9a0n3bed7xuv9dakgtrLjrqG5Ug11mLvEDUe2n2MWtR9rVr5+sazS2aTUprf384zmtIlMZ3C1DtGtTcaC2p5jRSHxFKnrbgzw84zn3xL97zSm96//+M/WN/OvIauUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3KMUSNae3Dv0ZpEb29u2rXtRo1l7dOxwKjBvT24IAAAAGWeWNM7JlYYt9kU2z5wppB4iGuvLKG7elzUoxGIzJjBjj1CGkVpZNTMom5ZQUV6niL5L+tTE1Qy+tH60eVXCoQ0Tdp8HQVK4RE43Q35RnIJ3lWbL+M81JXb2ENArmFNnixssNqj1iPKMilYd6Q5+0Pz5RDiiVUXCJVlUr1vWcImEuoD57Ji19+2Mw8+TcFwtvV6bpTO/j4x8fz2pQ0Ufe756/rXdoGd0hyVrm2q41W9v7azS2PvPpXfzrOLZ/hZo93j6+K3zPmDRmL4XWC3yXhqiHZW+skl6Qq7pm2dZ1v6/98f//WP/LHVQggAAAAazwr0jpmDRpZuPWHjhasBv5sGHjbPLSV45p4pXGHTVjBoCRw48HRJ/3+mpucoY7jqkv4Lk5KqGWQTQR/bWYdSiJR1HmXQ1TwXBUrjF2Rzc0qndYVT6jRmJyb40OFSSdZaoCdfopdLlxjQXtoNZEifytrUtj9wUxLW20R4+O4vgyWJfWnrhJNqHaWmba+Y1rxsWrTFp4l8fOfvXv7z6rl7GvV46394+MZ9cfNYUet94gatv6/zndvimbZ98Qc0vvNdNFbbzeHTMSNDrHu8NJNNzd9t0rlCs+gUx6b9q5vr4///9Pb/fz/8Rt9jliAAAAB+8LtAz8Y4p3xikp47WJDosBlGGFS5H2+ykdO6I6Oduaaktpo3DU3eprtjfbr2sEoqC/rGjt4S96FgCpo1+NxByX5iVum5WoLcRqlnly+nhZmxChDSkuSlm3nTreM4m3EnZIUrk5qd60FMlqK28Or2FIhTml4LQrW6NjWMV+N4rL9f5192rXe95x/8fH+PuxsO91kt/Wmq71n69b/G8fH9c6xe/9//C/+s/P+M63RPOHx909ZdYtjKuTp3H5HfQmJbo4+dIEGDWCwIM5dSC8THcI/3Wc465iBKUR7uQQsukKoCZFyhAvNNf+MQ3MQLp34FlYMYGoiFBZwIOiVBKZLMUVHXj+cYVtiMOU8shuUNYiU3LkOJnDz4KfcN+XMrV7lSVU9S0Fscm9JsTPP3y1aCkIyvLhEVub3Y6RGFkjszPdBtF3inePRgOZuBxq6ji3UQw4iclhiyKplfLzi+m3m2MVvCxqn8l9X3Tfpjer1+NS69qK9v3SejZPCtG8GJualbQK21D1mb59/iuse/rCzb6vnGN/etWj0z6X+dbzM4Pbw1UvOVkIZ7MMWHaBqtN41jNs7lCRsA+CtYMQYJGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAadfVIjWXtw9TGaEG9vbhx59UQt6e3D+MaoAb49uWAAAABjb/tmXmSUEXKE4QbtDI1XIOZV6lXKljc3edh2YMa4bQsN0MkpM68ulFyxlb1IW+l9fC5NSy3hWghYxzokQE/p4pDK5y9PT1fDWLL0szJPI9npClO5GOlIU9Idn9oEsm4cFXwd2VSiTsRfornIn1N1fRnNWF3S8GSaDmS1PmHTON/z/EbWNev3/j//4rTXp/DfV1Bt7YvqtN3rq2vnOtax9a/xbf1bf+X33vPtvHxb+do/3mvpn1h2bXr04JpLNkkvzqNG1uQTuKgdXrqyxOxP7rVaCCRWJRBj0w/cBITTQbMxIBadIJLNQ9eZJvTjIczEiQ8WAfyZf2Ty6hvxKGrER728vOKVY7px4ah2Pv+2VexgSChe6kTtTkMz+q12I0MZwpXUY+4rbPFZGOA3MllGqIPeKBoVkXC81TMEBUOjROQczkM0TEWlgLmwsb454LZAHwnDqV68nn7u0XMKNCkziNqlYr5zrrHnhZ8G9M1zv7t67jNRx2wxVdVzErafGcZrCj6pee+q6rTfxFximbXpefWPm9MY+sbcXC/zbEsKPm8lFUinBPOT6VLxX1IlYM2oW8QbS7tXec6/z/rX/+vvX1iDRqAB3qrcm1HCSkLZSujay/6nAC2g48baKTUnpqdQqC59TZ/UJJqwiJamLBXEweWHZPFLOUzqKt5ZryPGYlkTn3tUdYgZDSivTvXSV3/sUGWOU24NTcrpW1ohapSmoy5NVkT44sOE7yHCVWYLA5MDx9dbJHHYzrONkVhxTQosKBFOgaBc8o/MlIT2NfF7w/TeaQt1prc+s6+dY375v8ZzreKLn4ru01aXpWsD3zHvjP+vrOL4mrJje9V9I9PXd66/x8SwYevnFse1ZqbmYl0kVwuHGA5Rm+1Z647UHRQwZedfW2t9gd/vLcoa2Yg3g6PaZOMrfiBjjgkSl1gWZ01eo+yULcmmJ3gwBGFREcmBoYOQ4DP/BOEvfuHH3uV5zJgKi0rlziY23TiV6GnLUrMMHBH9Vsdh+Utcn6WgoqCNMbG5RIcFnvPhfgtlkLQxjLip9qxOZRDt65Nx1suD/VbIgDOVSGPBjHicYvYrG3PXB4zin2gIQ4dva6PKVYIFJdee1obyfcSsPNc0t8a+q1zqb121oR4clM3ruLvdN6iWl8uLfHj63AzW0tc4p/CXs7nh6+8fesYnh//Oo7Bm0RfYFOgz9MmdRL8FWqyJH3EpW2YlN5vTH17f/6r/TOsY+NetYv2cyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGOnnRi3hbcP9xmfBvb25cxfdAjemNw9U+p8G+PbgAf5vCncAxFIFmx+6eOQQQgJmkKEB7WJTQWK0GzGEzEIdJIIfKVw1KqCUzWu39XYx1/XLwtd7K70FXOMJJSgZI15rEazp4J5hLsZmhaUGjFCsxo+bMYSEhWNJ4uIU8SlWqEtpSatTlxrVhiO5IEqx9KwR2PccaoYGpFPUwvajSNTcOfVQmy3Mtr4nv+P7v6qmWTrmoi7fte63/tnZzbYjh0b3LR25/X//PWQZ//i4tzqUOkwEYhiYfLy02eeBAFGjRowdT+3CSMcu2pxs5jB8LdzmSxjKq5KGGf/BgwQre2KIyeAYky9ukaYatgwNlMrvxYKeyyvGAms16THG1N5wwhSzWNP/JGsStusaae2BMQzM6MYEHZoIOdCDIeo5NEJ6QTK+NFQbFMwOEq+yH+yiKqFdqRmVTXBXp9InEcvzJ0Sin2k8aL588NwuBcn1nlU60l9CzJ8smUpsKtJNl4F64vaTdaQ9P4c7Nq9b+HLuvz/87xvWkjrEkGPfUSLqBI93CpT49d59L43qWts+H71+80/xr53t9rWYDN85w3y7fRWFhp0LQhClMdEVYe9j3EnjSTxo2IFvWn3m2Pv6/+PvVr/W8Qvc4UQAAAAMvy5LmUmUv4ZYvPMqLNwGAYyTkAxk9dFHpFVtoQORRJbPGCYRnVqYqatt2J+TxqmlUhl24Q5K/JqrKJHKY9UicSfWjBnRPJ15baZdHm4diOUSoTl5TUjk6zVo0yI4gIdLpRJbKj614xMysaomSqdakOy2fGRcPBHH0B0ByqfKp0dFpKTUyCbL9X/Ez0dcyf/uQ9va3c27M/SZzLzTemg9x7+wWvku317zrf2k9fp6aPfTMpes9mXYjnf+ZmZmV1VW5N4NnMuwmweg1FgkFU+QlvLY2r0rrtnAkaFxHyo5YGranHDdyOsKMQzjGQSvPMNcshDTW6EecW2pJJDsbdESBb0MvcFbZjAQnBUEJDJW1aD6uVUhnNzaWntxNwFXyeX5XH+g127jtP+iWVUeDg69T7Q9Lo7BMpmohAskQ5WqtVujvY3ubttVOtjZgtdC/Hcp4CxmIkG9CmJiSz9sTpisRQOYur4yTWw17Sqmw4LZ4GqQ6E9cHixNHhPpdRoMGudZvW1NW+KWrbWL1+cXz972f9Pq03p9Xzms0PEk967ibtXFqf/NbfWsd4/gf5+PfFrelf61tXUaLM/lesRfUeiDBPA3b6d0WYsW9KTrBMWU53KvRcEmjGiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB7uMT6N7e3Dkb4oEa09uHin1PA3t7cO1vmeBzT24IAAAAGt3LsGJvgDtEIC8EMPdDy5Tgz8ebUoleQ9FLzdlLW6QtpFAIjA6RuUAcyWSKxF5jCWdgiQVVuMO+D7cceizDcqaComFwEwdhVVZ3D1VtZ2MS2H8qWNscJIx3FrfM+ZbtbxwmMhiPdjYXqevBosqpVK9OOMsdJKRDE2gixKlKCKkrbXkDFGR8QRdKFPKJWYzhxi2w/vj6xJ8Q9VpXVPmn3f/23jGdejjCg5geLSu/XGpa2tbf3j+1d6+c6rJvO901DtnNrY//xhqt/jGc72zWhaZo7iYCsPmChqsrAfwLRYOPm9619tV3nVf9/H/+Kb+f5tvqTQAAAAO83SStWw0fwJEO3DbSHIWmejiEQ10Jr6tTERWGdN7n4EQEQtD4DAcBcqA5925RWmotejsays6i0plkMw3WgRxZHOJimWlMEn3plMJk12MY09NIHqKszLcZ29h4YX8ukiY6GzGM5RoN3CaG4uLBjbyMr1erUgrVWZR9mE/2xsLVPZWm6XfC5Ur+kGu7fES+Mxt293m7Z1ve8bzn4+P8/Gfdw3rNb+mKa3e/kz/F9a6/9vrev5dbzrEt/95+tfOM5xfHzX6vWLBzfDkxiyk73BT0PHxAtieosBxzAaKPRr9ta/7qniiY5mEGBwdXDoIc4wOgpuGKZaCyp+3khOEFCQXEYBRCLqhgOZtEqbrNhEWlUMVp53IzZ3RK0kATFHZf1+YVDVZhrd2NrAipIUMSgED+zGOSWNztHQPqk1aqUap3cN24t0JWpzZgCoUJ2KJlY3+17R4KNWzbT2YquhqhbL0fpzrpvLozQd1V6eSAgYbg3Ug2rMFth5tHriuKVrFpld01f5h+tL0+tbrvd96zmfO9vratqlNbt9bzSLfxb6tjO7fGdenz8bpXV7/Gf8b1C3E/+cyvI7tqtBgQcKh+/jQHBxbtwH+HuoIWD4ZIuSynDmOy5yzDyxTGJ/CHq0NsaRzBSwEALFiwDKkoaVFp2GRoIyOoXjWwZdWeyWZIMpNJOCZmboZY6cs1L5VLC/0VkkKeJlsOxVnjyLKec1YQ2Alg0UjEFQLIpTE5nVMezMrIUJEIzDTp/ZymL+3RC/KB+yu1fGbUyw6tHRuFcp2RdGG7JwHSTIpBMmyesdglOhBnEPUU3vNe9Z5cZ+d2fRqwXketrfUS3982iVx/rFvhu1/Ztlp61xi+L4xTerW3rdNZzTNv//9S/O8U1vH3X0lgfXxb0znEeHFg5WzqXd3saO+ZZr0ixtBQ4GZlDrFNXqDwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdces8Dentw6m/54G9vbhyh6TyOae3Du73nQb29uMcsZVDKaRn1kbuBLhjDWWjt2MMljEwZ2Yg2GRU7Ax4FK4LVUYMYQKf9BeSfThb2bltv5LWo6Bw16FQMwZ2X+uVnsdGZfZIdDARsx6sX+hmUz8tlEB0ESj+FUS8TqrSTBnEBua0erj2UKlPZTnxlcYXZ3omaKkZGyArO5Ie7fospmNmMuubvVfRUkBRjG4KFiaqO7TPIU1d1tnxKacaUtWtbbxr59rUz9/5b9YtjOdz13Sn3mn8Xevr5xb7/zbGvj7yzeu76+dY1X3tnef6x4EtINoq4Q5Ep1uZWGWrQ3PqAkLCEDyZU7QpD/IadY3LsAJ3jPKVQlu04zN9kVTd2kBPqn7blXo41xZbrNcjiRo4Nh4UBgscAlFGJQFLp2HaSW0svfFtS8Lk5tlpKau4UegVnrODBGlINqLNrT0QuQxmUSugxhJYwk8rU7ZRR4jXEiMMxEp5ToyOrnbYzKZSR4aibocdPljiuB4MjAgTgTo9bdZxcnp+FUYB7My2X9DZ8Q3Tlit4+pK6xeDZzxj//OP9Yv85x8/+kX+8mNa9L31+/mza8fO/T4tn7/39517OP+tf63/v/HritpIF5I8PUzawrx8nRBZ6PNw4P37Qab1STFPqu7UqQQAAAAMeXaB4yoBjBMIMKAh8ZEwB/kVTE4lEhTJ6N9bdI0llk1AKwa0BTMQpwwIX0UNdZm8k3YjUb7NqKs0ac6kAP5PQ1VmYhCFkvaZDogCe6xTu/E4Y+k3C8nBWtsr6yUYYzXFjq7b8ykiwLqO8f/LAwqSM9bXNYanFmTDHEFShKzHQiGxNE7OuUcJsjEYZzl1BJFzNmPre/m+M6gfOK719V1/X61//99t1N77xNb/F7Wpi/+v9/OP7/4+8Z1qt8Rd7xn/7zjefX/PtWj2NmlmRTQrQINVbmFLAEoLBYEgIfDZ33Uf2xPxRXZozSHea1H8GQN3E6jdLEiM3yuq3QiG2fJsyG9ARADDAcZNRFAkLAbTYBhMvnJLZvSy48b+KryKNuzFJyxBkBwM0UQCAOWBJKSQTTitA1CGJdWrWY3DnWmBVSqpiYHz+BjpAurUuDpOk6qt7UqjqYVo7suKuU7ajFNU+h1m9lmL0tTrb9uSQ9hPYqsViomjObFGzuJWv3a2YF6OVa4vJb/OfbOf/841hsjT3gUi4rjH+q6t9a9KZzbOb6zve95/zWLB38f69Nf0x6a3nNdx9wZKNrHKcR6oTKwJCCrWVjfUhCA6IBlQg+t1OsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHAXxPI3t7cOjvWdBvb24dWek4De3tw1s9p6G9tbggAAAAZc7YhtUhlrAHhjE4bTsZ4m+Y0Ssd+GpNFILlJWBMwbuwFKQVLDnHwEgr2ZReHrj9amYal91Wd7Uv4Dk9LFp23A0BVH2GAIzdNDAV7oVcgR/o7ycm5bnCY8q9sfWhWy8aqVXLJDIQ8WWi0KNayHKaO+Q2K9hymkh5pEzjNSsbaV72JY9zeL6daNMtqvrUO+8VtubX1PnF9azbHt/v63n///N963m9JdYxTWs3zrf1iv+s5trGv//n4+HG2d///43v4z/rV9Yh6zDfv3NhoqpKPbO/uNXEQFVTTDv6dePc56MrmMWth62c2osl/R0GLGYNFzlxyGo27DP0Lm6vzYaoQj51UeYIELWdaKUEMRSZgSVXMHDjqKjBIg5kIe6feSq67IB0EMMXmVFwV+v1g9MzFZZQSK69YlmMkT/WHN5mV6wxT4RyuQ9HpaeIxxWdlcT1blYhyeiR2lmTtzAM9gWjkhTSwV0zGcJMaTgZqG4bNQNxpIu603DtulK6vX4zmuvrO9fWMYt7Unx/G1E3XOd43im9Y9/jH1iud7trVv/emFr4xXGf/65xBz/m1fLvd4jI3JKEOlcQWFs3FZnza9QFCzyRFPsryxrUsNCgGZ7ym/B7nx1OaB2EAVYT9jbe0kAt3Wwkypk87I3JMvHTepsRgSa6GzF8XptPvk80xTFgB9LRicPyuGHefWpMvAxEEBhtD2DktIFZsUeqQOK87vzsBQWdBKXJVL+WZziR2e0baYJKtECG0dG3E76qtqRrHHc4sHGV2KWeMGOcSCN8HVEamdthMhBwqzVOw7E22SuDyRyzH1qTVtQHKy49Kema1+s0tr4r87+Jsz2zLfdMZ/rnedb9K/Ovf618bvuv//7ZXf9c//////+NXwctsaDLBVavXE0d5Co/qCoXD7VBYulfogAAAAd8zuQGoYF8gwoGfeRuIyJRU0c1JhRx68zWiUAo4RSfUFWWBgUj1x4mUpYPAsSs3YhnqtnDMAuDKr78tk416tMRNsCEoMW0aEulf0sdisWltyWYYFInDgHggaj6kZHi4xsfOHkAeyG4/yWPEAkVpGQ8SQSLxIEgXTYhjaJsbG5u5WXitApCMCegphJlAeg/nTJZ1FdJKucorM0VJM31LVr+pNFs4vqSW6lJOndLT9JkVqd7KdazV6le9Gr62vPO2SxCGBKSZdSUfPGqBlIAY4gPU9aQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAABuZ7zoN7a3DwT2mwb09uHq39NA3t7cOfvSbBvbG41nqVxAlBTBvsycHeCMK3u4k6YC7iwXVdt/sKWGgwDgFrKTCKgKPTuQIHEaAJ44BcSPTE1Y3Sz60WpKjgGznUidtuMOxVbQoElhOFhdm8GS1d1HFJmXSiA46TCYLE1HkUycXi4ZGI90SkJ4RieFuC+GpEMRuKBuYDuLpNKZPJY4txiifGh8zHCMUCAMollmJdC0B4GSOhBTJAhl4uoFw3M2SS1oOtNTbXQ3/rat1spVkPuktl1pMvbW9akW1bVXV9aT6lb2uXmMlpzo8y4o8fMjQ3Omk6iExDLrP3f6Msb9R+1aDTVITNFnvugQegGg5ujmBluclrgWrrdmGvIylMIxKELejvehIzDrSGBRuYo5t4n+vYsrph4Ao5XzhrTcn+bhMqUGGBAqqHPVVFJuBIGdTUQfmnnLKXcDWOkuJ6PozXHsxsbMmTwYhcVG/lV6oamhBzxGOCyVVb6Mh7KXujGQpdKrDeaK1CJUToxiJJWh8ZWuK1LLDZXG01/emN+HBzvf+N/Xr87t//96gz51XMfVPXVMa1B+s3pvX+c//Ov7fG9ttdazb/OPrP99b+K/3e2gtrVRuJoc7OrFdEjTVgy8GguFgIdUBU/bHue+vHurbsIrmvRIvRoiNIGQeAVBzXIoBHQkCSFPBFmfgkmD1opxBgeCgYwswOCcAxGUDUcZFnNT9yUwM7cRXiTCZbRv6ztRt0JI+LOIPXKDAk2FRfQwcArRZjsWcF3WwxiDJF1OiiduB1p9+nXNfexVGJAhqMGmlF2ozhUatiIQ+UioaGZ4zohjHpNGOW4xjpYh93qwI1XMasMohhhj4qkVMe0rI+rHxvN899mjBFvLfUDGcX1rxN//+3xSalqXj+99Wz728uLW1t9nG/nX/tjW6Wo+j0zb3+PX++Lb/+8Y1q7f5LuLQcsBZo3NdYMWsLevjdsT1gcZldrUsNIITH+82QDqQSkcuReBhOYJAznv++C7qd0lrtaGARW0FDgCVjmmEWKEIlIUc7Ss9iPH/mI08LjIPw7DeMOMplzcotKllGKgiPKYYCHYjJZBeqP829V+bYpKQwJB0Cjb1M14quDQWD4QgzuIghGaI9H5aynjsJKMRS8URKQw1DIGglquUEMqlMehUAGTApAuXpRHKzFajp+CrULFv3eya/XJtO7tL5+17GtmPcxj+pbKz217azT97ZmdtMz8/M+lirszk/M5Oa1Mzm9lVzzXcdJzsnPcoMcaVeCYZIkFmiYwf1+/rAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB4J9zQObk3Du75mgc29uXEHpNA5prcOEveaBvTW5xypZU7oVBRj6AGlwkxWaQQtza8Z3D40NFB25w1CG7spTUh5p0HAQGMbSTngQoMlA25sHo3HlbpQrG9M1SYKJAFtm7QbS7ZhlHKBC5podMukhoz953bhhxWU2HDlL9DnF4Uw4TxNmREC4RcjzWmUBVEGMyGEcOEqFAqmpATYXKRpwuEPFvNSIkwSRbHaQUbBEBGyZbOGROj2K8EpFPGgKVGcHMKg1ieTPESOsmnNFHjZZXZKmklpXoJpMyFGipzWkpaCukkikZIXu32epb362dBt6P0Uld6Sjh5kJgshwtxIjrU5ibrWdWydZowYKKmf6tbpI/ABCDTAljMfhNTR9Fjp7F4TLZVFh5J1PPvnOsLFgp23BSuTVBhMdivmAgCcDRnsj0BTkBr8paabty9sEC0roMCeJY6wcHNZRYL3GLGhWAtunErAuanfpyqGNt2lh1NaGMkAqo7HDeXfLhzUVEUKuivSxjnknlEsuLNVXoehCgdxi3zGifZaoY+i3gZco5eDODkLGXw0pGuOr5rN2ba+fBgxpqv/WXWdVx/v/Wfm2MZ3e0bNfiHF/t6bpjdMY+bZ/+7fOPr/XxnKrnxn/7//prP+K5r4MKFbE7Gp1TROOrMmb0reskWZNMzXPf/3vVPQNLHAYYLnxhQGMzhthjul1zKBpGQHFodZe6LdW4A4y8SILUxGMM1lOCJL9kAJfz7xeSNJgFvKSW3m4DQtWJ+oepXbYLSYLvXq/YNBmKrI2MHcCMvXDjdotT0lyABxGxeIBRHGXkieUSUNCQMg5Yol8CUCdFJEgDaSjmxoeHeeTMiOXCiYhmMjFAuE0jqJElCouDChWgJQNYiRMA4B3nB3GrFA8yKq9OdPoNVVr3ba1XWz2euqukmurq6e+pWuuo2N062tvZN1dadExSQdjE1LqAykSUM0ye5yfkQwUSLr0czopdAiK5qjuGv6SDSBkDd1Ms1prQrQgglujdFpIcW6CAGMhpM4wUEGyoAYOpSJBZprsqgjN83skkw3Zq7R5fDr+Zs6fV9I4oyoYswXDA6Q3F+mBQE/TNnZjDsRqWkMep6LIqWxgtIlDxsGlisHseolpMkmSRxRPHaPhNHKQyQYZQ0BUR5kmOwrNTIvksOMRI4hggU0JIPUKiFvHOPQol0lCWJdJqVknPVFw3dFamZnVvSVf6Ttdu3tUpJPZdS+7Nt0yw2S7f9PdFaSBfZRkZJEiPMilAzSLDBZ2yzVCZ9e1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAcLeM0jenty92+ZgHNvbhmF4TYt6a3b6L3mAc5FuSAAAAB3HOTP2tQ0c+DRxPtwywAN8+IVmlex556JqSnaezsyJxmcFgOYY2a1GPOlcIRrmmonPQ2/0MSOTrKSTFgkhg91WtSO24kFtEWsy4780aPsOb5S65Bb/09uXS6BmBHsbOm3j1stAjTqSEoTzdD1JxxXbWzxLKx+w1coCoiwYSUVb9rdPz2w4UdNTtUDhBTlSHJFdMtXsRx/niZpX2t7wNZ1rGc///+uv8at8QNb3j7//9frdvjFt7//1r63je/j/MCNbP///z//r/evvFbZxeBDblcrmWseePNVE6hWP1jTUsSdkVAxjSiGswQjA8Bbl3xgGGEWZXZ65FFIZp/AwFU6Yay0EAgVHzegsu4sCCgRgKx3OdmVMlcWIPyQASOTDkcm40CyVyNOX2+b5MpAgkYv0qTZtGW4yllTatSizuUkQJupTB0XhjjeCwwkS9hFCrIJ4oerkLVPSziT9eQouxszPmh5tjTLShyCcSem47js7EPk4AHYcRoG4py8H4zHU3pZrliQaZjWxWvtHhbtq/vimLb/z93+s5zmmoPrv4x/rVL51vOqXtvX3/rP/zqmG/d9///4x9Ytr/4pAxNbD/SKPxSsynfLUSRqhUjSTRKjBQRmTf+sAcscqWPKGmH0IOmXWoWZO9FQsqhBI4EDP3TPRARMKftg78vSSiDhRjAlU5VCrsWf2F2qaZ5ADwNOU7kMri8zSO9A9yHUVyYKcSUNA8mzxeV00ahyGoKnbCzVljDGo5DUurHxMpmZJDcgPYolJIqLCskB/L5VLSY5SlEciBoXx7FEvC+jNzUvmgcwAC+LgwxJF41LqnSKL0WUtdVFFBbav93906tCrVrT3MVsghZCjW9epmapjhimzIf/91pJpUpkeJUeSh7T4aSpNbvnvKbhhn5UAhge4GEgYvt+2WKyDABMppkaDpZtCSyRlD4qyIkspQ3UIBIhMRAE4eYTCgWMKAFQOhZM9LsZcp5qlR2UCTxexoLiMicendxI2XpohQImIDuPJYaCijUVrNpKn0b164zKB8F8bhPl0lhk0SbUNc6Ylwuj5TKYjcokaThsSzOUCBkUHYUSQJshiRECqRQXIQMiYvBPpxyIkmTo54gKDyDc8QnHMGCMiUnIsaugoyPpOnrTTPqUzHkLaVbNTWmigitNbou2tS0XUiipNlJIppJK6u2q0sXTTZO11W/sYoLL6KRDT5BiWLxIGqBimkYLMjcZRy0+HQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGB3bNq3lbdwOPOXRvcm4cteswDenty+G9ZcG9xbmAAA/nSVYMUXMOvQMZuRONflkiMKCRIKYoy5skLhcgjzstQSNByRz1nK+MkK+eWV1WtVIhYlvNPFbZdLo06UHTUprP+5EOIDzpiV056jVPT6geSx6UyKlSEctJZAWWmyElR9eSgTobqSNkjpuTLZTEki09AfD6CYaFTRqRg6cN0iEBRIE8kAhFypifOFbVDl905nbJv9sdf3P/H8d/NdW762beJ919/zz//wgrcTH/////b7qLh6Jw1PRAAHgXbJe2QAAAAO4U9Rw1LTV7g9oKUvZGIAZKoGgxxiKHH7dIATFWLK2lKIsyZGEBxlBeZdOHLUxhY+iiiG0x54EiMH09BHn1KgAmMFwGQMla2vpiToLJttyQ4igIZOkGHgEJT9alUfqQr4iLjUrXi+OIfQkQ4yGEeUSfI8iaJVL5fKA6GGEQUZElCmUxsHRzRpDTJgmSLEGMCRFmrE6DGCdhWyRTIwgZXFzlUcIhODEB6CNByxC4hLI5E6XEDYtoooHZ86spFY0Z0EkUkrVG70Na6zDZp921rqd1Ogy1s6rqqUr11l9M813611JUNSLIGjoIF1JRFR3kOJk0IuWXMnBU8C486Zx3rVjfwtyZjxnwGJn6lkOLzZiIQoxp+YrMtffSKS1egcJVUAgdAKBkYFonwAGeGDIkHHGauwxRwodb1+pB14pbIWa7l0ZnXmjzN0iC4aYxmN4JGNkbhH2GP5apHFgeMQ2g3BJOS7dbfrMBXSp5mP5sTpOoqOO1D1E+SikqzpFTquI5MasUh4uw1ZiL50ioY2RnspTQJiQcZQDGoW1hVDExM1Js5kj5trePLfdN5zrW/imcW/1v5/k3q2c//5//z/jWsf/P/+N////wpt6zr/H+f///94zisS9viG3tEWeHiFmsbB5j9veJypbktfYKAJkdqe0KtTetDlBxhAkYT4CRgwFBIoGoK5zEiICb4lAlDDFBIqNRqsODqdDJXSt7S13xVoz/WZU8xIHNMT1eZcr6sbTEWKoS6jDS5AqHGOB4GCU8oejq64bgfBp8hcuOCtBqFgiCBbOlctlAzI4pkgRUrEWF2MmO0W4nCCkySTkEIwhhNIMQMpG5iM2P4sgaRAiMHGYIsoZUWcJ6BsFh0IIyQQYw6QYiqA8m5oamiNAxSROrNEnWgyTuzVIIIu16Gg9ToP9S02UzIKTXZS9l7ezomB5JXXqS+uy1LSdSBdKJDFCCxNlQkDMzKCJi6OL11LtAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABo16TIN7a3Dszzlwc29uVz3dNy3lbcwsvOVBzmW5x1S00lQaGLIz0Gabfdl2lDzPy8OEFKoFh6w/cFDwGy9a6V6CggQTGRMmMEmFC3cik/D9NIJHSWZVA6Xz215VWjUoeKBH3RgIQQy6OTHV3MQ9g7MbwyfdrcsJYzGIWhJhgRjEuTi4TnKaQzF0dpCHmURvMB9L5RF0mEqMcfy6cKBoVuYCTBzx6Fo7BLU0i8MYfiYC2ge4EADnFAbR7kaoum5cWfbdXMVKZSdm7L/fUn626/dWlq/qr/UYEsn1f/+iyTLSMFDjMk0Z8+kfQFAM+hlOU3Ho60Yqg0UtJggSsOgRraiiapmV5gYKuwyOKqTbRW1P5Xpe4wAIEY0ZwoGjfgQNJHNQaQvBrUtgh3ZmdiyHAeAGv+5jSoHgVVijbN0eAgLW0FQkFAaOKQrgqZLwbtEpU8D6S45U0aanN06k6fjt5KnsMpnq5iC0kmfajKCh1m4/VCEsmWZF9ezCQagkO+6igM7ecqNJkdQaCufrbcm0PeOcCze0TS11W9YO/Tea/W/jX9vv7zfW/5M737b1/veL5rnWteff+P8////++Feywfun//3////v3zebGsw9IQysMdwZGR5uaYUN+3e4AAAAADb1uYj7oAmIMQAIblc7D7wmTI4cNvBhGW9lD0u9Bb1pJAwIRSm2wkk/1A1mMxygpZ7796haHCGaXZiN1YFgeHp5PRUw9U9aK0ic+9Xzh6at0ktUJ5AD8TyKeXSZcMXHcsjJtaRxPWYPZ5Vc1tBhKYaDuBLJQ2JIPtFM0JJKAsASPJJHyjOT7GqXLeuaq//76/5///ia+r//Ob6ZU1x/1/P//yqy6uf///+euOHRduWNz1R8dak/dI5awgXA5lCfm+w+ionQFQSggR+NVEwaQTyqYKrM+dJZQGCKSwiADwmCQ6ZhEx9p2s7MGBAQAh40o6Z/oCgOGpOp2QAIWCrloL10k48FwFCEAjssLIAKDgoYXCwKF5c26zBxFBGMvbH3yWvH5e6S71qstZg7cA0UtnI47buqow/BkZZM7NSXyOLRyVM4jMeiM03jqw5F3HkMyr9wZI/tFSUkfeCJt8y84BRYJIqRPtLo1Lrudy3jZmLlu3Z1nhUsay5qz3+/rXdcyy1/N/veWtd///n9zy1+9b/u89a/W//9/zf91qtej+s8Pz///mu63///M8a2eNypa5JL7jSukkV+pPWUrZlfWPSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAY2dkyLemt2+49ZUHOTblvh6SwN7a3EBb5lAd29uAB/DKxahJj5ARZrJ4mzBxC7xiEcVQZvnailegipMkTeUuf8dEjqg8o5KZQdVVpdDJ5qQwA/e5A6abMZdKmZVF26ORbjkC5uCa7ykI6d6A6WxDdPBNp+6o4ywYYhlwdhafJBy4SZdQHOOMYpNJMyKJibJmxgTi4ShLmZuZzEij3Ol0cZqPYomZgZkQkiaWgqR3DFHAbksRS6ZLPrSVVdbqqet/17/Vs16uvQZTnNBl26betFV9NE2anf//9SpsdTco+FYvZda+8a0zDz8oRGbmocZBDFHqFAaBQSKBI0KvlQoA0mY06b7NGGg2X/XaFQQDAcBC2dPDY8BkAgoDi1kSgVdypnrg6DIyvguysxh7YnBSMQ721H1QqEQwFiAY2JKCUwmDkEijxf51V8MRpIw/mBNjMDsFyDkjhHYPkpkQIMNAiBOiwjNEMJ8aBNl8eyg4zArUUoZjiJwiIrguA6Wjg+DMRcXIQcdIz5UH2smRxEQFBgZZCzhiieRUiuOYShsXC6TBDTNmWi7OkTx6tRrZaa0nanXUvdTspS/utazq66V21d3v6kDBA/t26H1UNFFlGBfYfygQYmC0yZPNP2CUaJXLLHczNMpMTxThgFV2aNzMoDOrFwFYJbL0dtQmqvgw0Fkg6BDgMBCkRrB+Q8UXIkDp+K1NAWtAkfi16LxJDuUB0VVfIXTalBqgMvXm0pB1EgLsQcaO66iwDL1YIhMymtEIeJId4OIhl4PKRNZI2I5iXhGQqxJCWjKPFZcHeP4zE4cJGJE4Owew8isTQnEcySYvEoQUi0T0RkOcwGQAwj1AmYcZLBbSULg3jvLlNZqyaNsvJKdCpN36CN67ajr2f2+utTddFv/1mCzZCv9v3e9VBpw3NiISRmZszmLlQmd0qxlUy8CqYoCRgpFBiuGTG4WXhHgHC4DmAa4mHoQqGKiS0V8/5CAqDOOpuj4ZelGcAp9GUZqYl4AKIqvhpdMlb5QBFOEwAOCSG6tTgp+ShcqWhfZZqwCtizCgSCQE5EdQfZ0l+lDTsPeODLScbLVlCT9DAOhJJtRsiNpMp1yFqU7EnTwo6OM4WyYlL5OHZEOliPBZV5gjpJKfikLee5H5XJ2KNElOBrgbRPUaQmY/lLMyG86fVgOUmMWj4pqlf5a///43qnx7fXxvOc61/b4rXed0lpT43mn38/Oa//7kjtcbf///z///j4z/JfVp6ogwnNI3cqwJIWsUk1CFQgGxqx/0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHV3tKg5t7cO9vmVBzb25bieUsDnGtw+u9JQHORbjWVJBcALLHZqEFFrkQiadBIIzIGVMdicv4z/Nx2lJ2mSiCCFrbWzJiIyIlNy2elojAANK2H41I9QCx+GZEm6LDySTSG5rGVtWs3Ju0HL7WGMjAAQZDTo87JI2mE77TnlkUPzzSpGwuBfkJV6eVzco5lVlZYimVpelzI2nyotrbeulWebk2MipSrpcHi+whamjnW+uxJNTnqBaIaYx5iuE0a0HGal57uBDtTwL5p5NRNWpjV6+/+M5z85+/mm76p9f+ur39Pve8f43/9///X/8au9////4p///86xu1vWqedNUK2m+WNT1nTA0lvCnfRh4UAhm+eGqgIhLZWKARxzB4GNeRgxyBDCgduScs2+VAZIAyR/k4AUrGfoZrlyYiTJFkIA3e27rXZG4cJjEVTGRraemYthkLElouaiu4q64IEQ2ShRtIUXbvL9dN145HHFWElt1YYTzoQ49TrfK1lZ0NsdW4iSVTOgUY+XoWIaVWVCmkHDlYkOPU4ywpeSZ0jHJvcUwu28ekCfA9HcX/aGNiMiyaz/Xe4/9fD99V9//nWsfOMZp65+8Y+Nbz/jH+cb1r4z961//////83YMa+///r///5zjVqyxbwaoSm3JXwc4k1qFCx5rDL7U/uNPJl/mTjKDi+hZIFhxwAiEKGlIMZbBBe1cSx3ea0ugOGieK9CQQFqgEQDkoVMyhcGgsSBrWIOlbXJuckUZp2NsmiDQm7wpzmYvfUhp5VGk7DGBZBQVWO05nthmDD3mlkoxxKJeNg9iXkmO4olMmJkQgqSHgOMWAmI5R+MBhXZAlC4UB7E8pFwxGWJ0aCdDEEDJ5TNnRKxymqhMCSBIhNxFDBGCJkOU+opoF5SkEzZanSTZa7LX7L+6tZ6t/37L3WpnXb9XZSlnlf//Wqup6KLGRSNjrn3NjoabenKdtUrWjAANNHpc3IAygFvuSgxqgCEpzkaGiAwLA5RRWiw+6GSY6UbvLXEZLMcAQ4esgUUCIOAYLIYJnNUcOMwdEWuMVXmNBNDQeBECqCSCAGgJaIfssSmMAAgw+Riyhd5n67mDuG9zeM1j72rzFxCkxoCfSJCeSTIeTgs0vEBIMTY1STL5LjuIMM6SQkRHF4ZgukeQIbBHEUJkagzw5InIjzccwW5ZBlkRFnDJCE5PDPh6oCqIeQ8S8mT5PECKg8IHzzMs8ySZqigfdBX63QXXvSVS2dGzWqfrpKS669VfrnHRb+v/RTdE2TY8ZHy+WSQIi6SCLGyiLoyLgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB3x6SgN8e3DTDulyc01uHPHbKy5x7cupO6UBzcG5x7hciI4BDo0UXzHJcvlsI4JHv7xuwQAQK+aecrL6poAEIzhbswCBk+DFDIPAM4w6FWtP6wBv1YnJjL0vpqCodLWF50olTrRVoVO19mzPmCF7TCAPMwiAIC48FVMV1qTeFwm5NxemIQotpgnWoZVaeS6OpjcYjyKiVAaJqpVYP1Pt0SC1IpDlk/mZZM9F3JQW5JlAK7pMNk8ZCSYk7V9AaRdR7ELOBPoR1IpnGOwXv8xNZrmt8W+t4395rjWt5/3i3+v94v/n09N1t9/7x9/6////xneG/cX4////////1813rGftVXxSNe9oGgClIN6gAAPLGtMvEVAWFHOYwArXH8nlUiUImWK+YRBLXmISCHGZJvS9rL6LJBR8YcEHMkAjwJdqgctX6/litjL51O1e5MBbC5EEOXlfdt5F4ioAIHGenmNEwKsqQcbvPVa8SzxMjqBBMyGPAmFZMLxaYGQzEuPQkTI6dJwnRUTDElDVMoGxLDgPlpCLhICMkwli+RzFAvHxMB9HCAWI8gq4LYHs3JZkjFM0PupMwuybuhbt/t/v+tSKet03RUeXdFrX1109EuGpgu3//qdLTrPFAvHXAlp+iAAAAAAbGzftaLrEhaFj9K5c4Kqg4FxHNwcNWQRNUy1WYwGYRBDoraGgmOhoxiJzuipJicBgYjgjaypn81UZJblVOQgBZj+MlZBI4Jhl+oCli6IgLABXRgcAtutReU8/z9NIdZ0Y+9aGK6FCbywvGeeeHBYXqfVZkIYsNsKGxuCjUN3N+u2OO1pnSiNFlP5dn6gnNqbaLDS2lYHobiFOJbE2r1tZUUN7L8Y1BxGxXM+ff/er/evj/+2s09t1tre/95+sZxXOdbn183+d//WP/nF61xiv////////zrH96ZkrCsKEjxvosdW6Kq6BCATJD5M1hNCBnCP4iBZhEVG5rEHQJdrsoBVOfR6GQFMYiG0eTChslejl64x82HCAFCyIUhYUl83eG3kbq2AUA1eqPtEdeCEtICiyed5LFkJgIaIYQw0EVutsToVYYakTOHipnyEbk0Q1ZgUyJk0WhzUC8TRfHQRAnxzxbiMLRFEC+UBnykThVFzGrFYpEuPokhzTE3MRwkwTZcIeQpHitBugH4oMLTxGovyYIoPJkXFGyJYWnay0zc1SnE02f102eurQft6qneykNFCyFv/0DVNdf2qr9ruzoXQSSPlIy7LMc0a+hgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAY8d8sLXGt1Bw+ZIHORblaV3S4t5U3EWD4kAd3RuAB/DWUljQ7+SIncHqdkqAgX4K46sLOZ9vcIBL4xBEBHMRh4AmMHgcaXxEAG9t7cV73JnZ6WTaBT4QPAT6uJTxZv1kyNnLRBACxADQUBlgmnSOI6e3s5BM+9Y9CTPkEqNzQyHMmYD3LCgw9Uhhh5OUyseDkubG49h7GA/pnjhoLAkRMSAMhY9VSSYYdIxIAbAlowgl5JDDrJVA+gZmCVWg9NNlU3/p/+p/+zVKap1JU6dX+7WLheLHb//1VovUnYkDzmrlxcXs6cbVJchIFABk41BGiVA+AgAZfcHAg7LwDVQCAw7RkXWmM/6yTAYGiZa0wYAgAMTI6WO0EMz4LRGGQwJiIDKEM6irhKZvvB7akILBQRZeytcrKqEdAKnQkAEAyZwUBxYA5gNgGEhKAgqqRjyyovFbCi1RuTpCKi0BqgPjJ4PkQJQhBWhBhy3OkmcICWxJC0O+M+wrpUGWKJqXheDVH4c0ZIi4uYiQ6RB4s4sionSfLYrQc8ToAohcgBbJELeAuQNA6VidIeXS8RVGs2OHkkFFxazZBTMpkE1mjKSqrV//u6qdJKtNlK9u6qqkyo/+rZXUjSQSTMJcSLws0qkQXY0RMlLdFZ6juqNcAL7n2K7ODCWQMQIjJY4zERhhjM0Bg5ictgmVxd3y7af6NiZCQRlGn6osQu6z9nLfxKfvxSlbpDbRGnN/F5XForE4tKoIXiOBqCmV6bYacMD0FDSQ5F4Cd6ZoBOEIDeFKp4wLkVBmLZISEQtCLGhykIjkRGUF5AKxQuXFodHCIgFdBwjCnqTiYFzCjADhoKQrCQK6hUOOIjjW2655mpqNrSv1S1//////6ISt///+t3LyA16MbVyksaaqWAGMAVkMawEbGkUYCACAgCEI8mCfehcR0aA4RolqJkqamvCgsACSWShgWIzHG88piM7BwUMGFAyChclAevWMpdtNaPYIQlK0OFVLXYgtI5KBkiXK9R0QAI0DhMxVQN8JFHEDEx1MkQYEe1lbxUsXHgcsgoXPBjA+NQmyiQ4lSCiqGyKMKDGqLaFio9jcL4Y8KDGMIaPgc0WEcJMhqknyRHLIgIYQ8O8JOQAUQLqUR0k2HrkDDXDEA05ILPAmDDFAZGFll8cIuU0K5XLBNqNzVCXi+mXimpbmTroIpo0UUqlMtLqu1kdnSp1qrQv7WT7otWUCZPt+rZ7V60luaUECoYkybF0rk6TKRsbJqWbKw49AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAFW2bLwzs7cSEvaPB3mG5XcZsoDe2txCY7I8Hd0bnAAAAB/V/kukhfsHw0cTfxvlHjRGDXJZFovLGfIgqKRGssKkKRIwmCgoGQCNGfx95+L5vjLrUql6vmHQ5Ho888Dx2BpZDDNQsApJCQXTwEp3WcCOR2mkkShg4mDkSDRePnEUHjjiKqQLig0iSIoHDQfLiS5Au5oShEIhglDQeGGNICSOisNA6FoPwGMwij6Do8QNPWiZhy2oj3//////3//85xx3/2lwmEDKFbqfWgNJAw9RgyyCBGdN9PYwGBMwnEo4Chw0RBoLAsLgxOmGKQLg4xUCSoFhYUmFg+YdERlhBnBTAYRAJgUOg4AyQBCZri1HZslABfh0yUJqFBwGSHnE13FUtVMzNDJOlI5IQDIc0cHSIbGBASxJI1Tdbi3iqAW1chfqliJrjkR0M4FaM+zvPquWHXrdaDZq7AKqb6ONBa/X1l0fZVDjfLIdOUwIw9WNJdH+Ko+F85BZVruwO0NzmxJoiozIcYOwZVEumjZD8nbtF6CEUlJXpbMrqU0psWrVnueqazzn8/nccd/q/3e8eaz1lrHev/Hef91r+2r3/rmuf//////zJ3u65h/9/X6/+f//q/3mVm52fytXIAmd3t5UedSxreqWUQ3V7daackhYRZ0e6bX0mqrGZf3gkPDBRTdBC48ojIYmoCkf0NUJpjK+e7LmahEcb5LxynRbacgKk3EVKUL0w5Q5b/tJWmyhpFR1UeAsImFCj6FB6nOxVnVNQu+z2Qw7CyeXAox2hexwoD3TQHKbGZNJIkigJ2UCAL5IHx9OFAkjAtSJYyHpL48h4mQ/pEI+N6aBos3IQScOoFCNS8JiTzclzdRizrTRdSVVm9v//r//////5w67/75AKnSpbK9Dz+q3NWDB2FnEdlpYoECpjDgPjd2oDTYUjFQceFBCHFv11o8Gjg5ghmYaBAkBVGZiIHdRpkQAYuUgALElto6HNL9M5OeBXWmRUZDAYwgMZ0vZvxIHUoLLEQclsMhIGKjKzAx6HMkGTCwNegVAVirTQAKhqDwGpNLUVwgwYMD7FUW4dBECYHWTSJYIwdJNi0iCgwRFRBo2haRBAZ0lBURtjcGgOeJGGWysQoyQywNyAsuFfIkH1C5B4hxWFxBZCPABgUDSlgcDBwUUCbiEBaFaHyoOozJwn0FFoxICm5kXnc1PO6171IK9lVoJWZBfuiu9bfS//1E6Thr/+v+klRRU45JWLokVibsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAABopmSIN8e3LoDOjwd1NuGvWdIA5uDcQAs+NB3eW4rV7l6IR0Q+IGfXPZyzpLkHER8W8GY5EFF2PaxBPlrBg0HxZZQEDoMFocNDRkQMJhAGAkiFY8Bn+eh1G0ZStey+qM6CdBRj8Pwa6bW2tuHmgLfokAxkcREISJQIgcAQIkPCGqUirIfgxiR6j7J+miWnUXUvzNDb2dCGyJ2+RxwpoqtjuKmO4yW9JqM9bocrVEiFp+hzXAhVYHZAiNOwtYHQXhGztK8wx+pxYzFslm9lxTG6YrE9NfWf/84trf/////+fv////////////////TUky1WhtZQyBZi6uJhcJbsNkQBgUHAANZl/2ZmAJYBCBAstEXyS7agYdstsxQIygUxIY89U8x1MA1QMx6gzQdoLS1Mi48eWI8FouYGLhIMh3rMbbkrNAoKOq2AAYECwOJB6g3oox4IqBGItegMvqpNcbgp+rlGZGkMyMuOQGEReDZJEukSHMIss0KZDhojIjKCfhoiQDwZDwLWWy6swIIVBgifSaD3UAuGHOEomJODHEoaiViMQuYBpACXwF2B4BGg3x2jLFEpE6RApC4EUj9IuGJfLJ9001n1WtWyv+p+my/////rpESKiatWpRnEAKATBT1AQrU6h0Egdp5h4DG+c0ZmEjJrcgDhW8glNBACEABgYUFZYEDQ1c+7vMBPAaWA0IcyEwIqmuxHh8o5ZC4u2yUAsKLzgLJOdfSELbBcIAgSY+ADqMZ+cxNrLQmExl0/eJPtd+YfmRAcAskiIkwrpHkwSQyrCpkQMRlyLiziUGuNlImCgLWRcmXFhGOIAakKSItgyYpQbwuJAuDfHg2KJFyTNBzQ4sD8MTDPkAGYFmk2XhiEYVzxXNTYxYyKS2QvRWpkO611/6/f/////rLxJtzLsNs0AoGmSySml4KrMThAIPl3AMRR1sRBqGFZQ4q1kAAHByYZgoMbENgYFMgDzDzMUUzzAIwVJHBGUglFBoIYADl1EFkalNkA7WlChAGEQ0nsIwMIGkhVUVYUUiAAQ5A4xAxCYSPDj6YmKJylBC3RiCPCRSRKE8iDBYCghvV6TC32qLhUwWTXnWl4NNZtTN2fZxU4VKode9TZuL6KbOg8Cl6VMTlsBNwljss9d2WoYtFo4HcRYa63KOL/MYw5mBJNKNf6ELL3eh5X7zuzK6lNOX7na1DNS/Vm/lnXtZ4//f1zf//P/9Zf/5/+H6/n///////////////+v1uKVLXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABttFx4Nd2uD3rNjgd5JuW52bHg5uTcONs+OB3cm45yMzMVd83Fs/IMiIOgDBrehQRTDuUTGoMxCAyE920UIiVAnFQSEYLmFICIlmC4VGNACHBoOGDISmHIIlAthgAqWVmJJ9sAY8ypTAQhOTAsLAspsOAGq9+QsBiADC4At8KBoFAwCLHIAZRVAY4MLAYmXiWezNI5zC+acD9NwaxQNnalMzrXILdKBXMdR7Hdd1prOo3HHnuxTjEXhcSWN3d+Abs8zGSxt2ad5l7Pe/luim8KRub7NAYTmoOpglE0yjiUFOtUh6nk+Oeqlu5jdLJMksf8g/q//UwTHjOOU+6TEQMDxhUeQk1yQTO0/waA4gEw2H3YyeFQwKDzAQECwPFgMlYDRYQAcwWFBGFysFGZDkZbBZwg8FYcHgaAiAVgEtk2WRIGpptorlkaElWNsJWBVLJGJARQ5iiYqpAEEjAIRMWD8USZjsKAoDFnFLmFwBC3zhwlADAi8oyIz4ZaGsK1DxiU1kgRcbQuMXxByMD0xnxgDFLwnEiBDBTA94qhqomxxDNC4iFFpJIaIaCFzwr40CCjtE3i3mAthFgbyB7wfAGWwNsDF4nAUuF5E4ShPDTH8+dIoQhgUjdZcdRSdkkUjZB1dTM9Vr2M+tf////+uiRNvGXS2YWFLrGOrECQkVgSABGAUvQEJjhSSNDgYMEFN2BrxTrGAU2AKVhABYYQCmFooJ0DuA404teImO49TsQfhzk82yxpQUdKwMRuCq8QgyYTWmno2oAUJbzVh4XM8TjXQAmRV0qSX0hxcpPiB2CrZiBIFYLLyeL45Y2x2jyK2IoRcrkaPoT2Yi5RKQm4fQrhFCoT49EmOkZoZ4g5FhkxQQ3y4ShZD4h+D8ymxNmxNJiRitgxwPQAuwtYg0aI6iwTxuSpqTCZSRon3Wk1aDug3sva3tU2t1f////1yZP/Zh+JO2q0wxRIBHUTA28yoDA8FhEKZmrkpk4KYOJ1TgkCZdGwaEGqiKCyYwMCxlAM5FjG9EBbSGyVRMHopV1YZYjK8iaLrFUPWexgSAEf0B7EEBaOwjChQAMSB0czNAEyaiDlQiN4bYGgHSJZw1BnRfZHZYURqGXhlC0Tg4iKDvI4nRkh1EPJwiQjAUIGNjEujJC4xBQtjgHomR2iSjhIwnCRJEcIrZAT2LCRER0KeRxQI4ZJxqCdBvgOsXGFvwuIjxOouUbJOJjFHSdJl1OTqnPq02VdJqGpD/3bb/////zJRxwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAZvZsgDfGtxAAzowHd4blr1nR4N8k3D87PjAd5NuPpKOpbeQ0vYNyAi7cbUsCoAhYeCwAIATmTGLvNBSNLOGNgGw4LAUwODRIUg4CnFFAZKBJgsGK1sTQtiqgL/Kaww+L9igDJhGl64LdXWfxfA0BX+dCBQqBTCYHEgEYrC74jQCWajwuy63PcpjbQAqQXMDDEDGgcQ3D1KRdKMTAljctMh7jxHONwcoxH8fRkFMwHIO4omhmMQvkYL6mOxM1ErJU6gWDDkgTBNwV0LgKw/DKHixBHYgWmxOQNkLsZ07O6P16n972//////6Jah9DSuww9HgwHTQx+DJe7jodAEFpgeAhzA2RWVplAiCggWJE703jAw01ckMJMTCgIw0LMtwzB74+myMqWDLBUBMqDI0Clmy6zFx0CL+qUQKFh8DAaiwQCrVAgQnAjeYSEEgKHFKsQAGlhDVQkjGDJBNGbSj5gYEtZ/kUGUOGrc2F9BwcQRHa5UfJ3ZUyO/DVl+JC3JXUdcxAYnTDMUplK1gpE466Y7Bj1uc8khS3dV5lbGHtfYpT6f4v4l07zijBEe0oJQ0tnaq7XGduJLICs5bt01PdpLeOqbuuVsb2t639neX65v+c1h3+c3l3X6/+f////////////////UhFNOsVsakVZ0W5MpiQkVJgaGyoHIzCILOqwwclF4lG0nILg4cGhiUMo5vmYuBYFFBlMMngWuYaIZgsHA4Uo9qhbhC1gsmby+GIiTCdFJlSwAsBZtIZJhCNgAABANB4oCDLJ+MngZRMkACRiAtdK0ZdBl6CH+GiKUFwEwLUH+GSIeWiNGWH8vEeQwcgXERgxCEHPFwDfJgmiLsQQnDAeR0OPBZIIISmIuI6MoQjmqjcQoRg4wK2BnAeyQ4tjMmw3xnh9JkQLxu609azBJm3RV7Lbf/9v////+sqFBDPkP2mZluDE8XBaLW6sDa4j2YOC0b+zwaDBEEAMaFJgENhQAhUChQLmPhEEAww4XR40GhjqSlY/g0WXmBACYSByHRk66FTIerAw4qROphYYGwUNQQAkpAaBCYGqwBAqZ2AQSGAIgHAWBRrZymag+FQkHBBAcYOAyrEMnbfEvaxFxQ7wWTg3kELEgF4haSaEEH4V0csQqQQuCeRkT4WViujnCMw9AZIZsh4hIURZZHlsokGKZOF4T8TgmBgIBDniApDx4IELPEJAtgDUYHSIGMAX3EEBAMbYgoJxTHMlQrGZyWzVE6U0EnNkzaj63qUzKv9qSttX////NiJJkyiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGg2ZHg5qLcwqM6LB7mG5d4Z8aDvZtw8qzowHdxbjLO5BccJQOYUnYAD6gkZTjRPMCAQyfhjDwqMKBIiCcqV7rEowNPqMJHA4caOSdIKFw560hckwRpLwoHvGtRkzKmhRHFgBWZDjpMHYYtBWNnSxGvJ0FUErUaF0ZacZImDggqHbKXjTDWZAEReh9qQRwTo7x8kXEfCwDnkQHUXzcmSKFkiI4iKlgipWJtEdI5REByyHj6JlM+QwrnSdHPKLEQFEJYeUi2OeLAmGyhsoVYagLkFbDklFRuQFBjVMrJoqN0LIvVv6ug2////////N0mduVQK1QSAVMJUWkHD0pNOEmCYBAGxgEgqmDkkiYDoO44CA4ToAQIAGNCwHIkSIBEYNBpiMQGokMYwL5iu9GdR8REMxMK2bBAAgsDBdYSmLgsAfYhDg8Bg4RAQBqCIto/AgFsFDAKIgMYAD7tEJ5M3nYwiLDIoTL9mEgaq0HCBWVOdK9YVMlkSsark9A4LTlAKqvVytwvwMwK9StyStboveo3lG7ibrNHZguGGTsTnXgmZRHHEd5QR0J17nkV1LlMG7QppBepbx++MBIguW053UrV+Tzoug6zjTdans2NZT8W1nvuWu5c3+HNZY6/Xeb/u+95/5c/+f/75//r/////3//////2rRTVspjqYf+TKcmNwvmaYFEQKMoCgMkACGAAemWtZhcM0WETkgk6EjAKAJiSCRCCACGAAAOYGAgYpgWcBA0ZGhKCgdAQxwWAgBlyr4KtJ9NdXoIgGBQNFrwuAq7hICGxo/tETKYQNAEQAaChJMEBpEhveABA0kmmEogu4sAI7PGkNIDQAuYAkEZMNRGgO0ZgxJQbQs8lyRKwyhBRkyHE0cMSJHyLGQuITgT4oMaozJFEBHo+ydE4k+LSQwyFxxzDYgYfUaAuAFQBq0QYHSiTEGKZMjoLZMpoFlkFMgVTiZgilW+pnrZm1dlqVv/////84PZq3zMUbusAYAhyYHNOYDBWXAQCDwLEABmFIXG316GZIoGDA4KChYMRQEgUUCisXDhYCgxgowAgc0+pAD8ZQBGJCBWIAURBgUFQpW50oFZK4y6waWF1iYdBAQW5WGVoeVg4sWy9HUwYUMcBzYRUOtzKxZrCGwYASplDI1NXgXMiCIXERCysLeQ/JAgZJlAcQtKhlyBDKk0bCgRW5Hi1E2TJfHYQIiIzpInljLGgthqIIGYxw5wmwZUcIjRArkACxEdg+gvoDa4FYIGDIQbQK1KhAi0QwkiAkYZmZupEwMtI3zia37oKq0n9dnXq7////6llcc0wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB35nRgO8k3DiDNjQc3BuX2GdFg7ybcORM+NB3b24qx7sWVKIQsMOlKCEKT5fJKcGAWYWh8cEOUHM0YMA7aJAJrCoECgtMVAAwGHhIYhBuKg2MUTMw6ozEYOMVlMMIYkAAgEKCvIsAxl4Fb1UiAKEQUdwoA8NF+W9EQHa2FgSDAAIwCCQcYQDoXeBhgQAYLl13wiAYFS/KdchVrmlrilAudG2ILFQPKI/Kh8dI0RzzAnExyyWKYfYgZ0P2K5WIaQMXOLPHyRAnSDiFhZgyJYRIkTQjUkxYxwDULBOjHibxAcBIgDEAOoDVDlENFymZ4go+SsSQ3zZNAtoqNC7R6KF9etmS1q9tDb/////dI8rGVwmNywRg0zUSRKzhAYScqxQxAEj09oBXMMzA2mzJWEJrpNETUYkNo4llwKnmBLR1daZcZmbGDCkKmVtKbk4MDvi0iWDAkgQKgGTCiv1BlpsraUyp7AgUBwuYieGieJlIk5i3FEXDUvX01FaTZLrviAREEQ21xZwpgyREDMcsrGJXI0jhOY1CEHYbF8ZcZxY9CEoyo4jclx+KZGDQGKsags86KVFMJMh5mRhDRZRBBAID4LGAvaLlHCJ2HNHaTQ5w+CsSB80TMDh4xRNXTZaCTXrqZkv9b7q0Nf9f//7mJqeZ2+kbbI0sQAAYrusYZBM09bwEBowFAEwQCA5dq40QAwOKYWCYQEwCATC4FBQEDI4/o4BjEArByMBsbNDlszycjIwjCDGtl8EdwEDqhQAUvmWrWRyCCyYYAKHABABJ5AOiuXZCBPAQOAbVDEQRAVDMsA5C9UzO2lRUqAZmRcxL1IlbwsgTmBAIn4PuOWP4zpERWhoWA44X5QF4O8SiOcO8ZsXEN0WkkhokeM6LQOUPREBSbCPh/HwJ1IYIzGEKULJgQEkxsGg4QuYCxAILADAJYQnD2RYRkRxCORYSmcJxR9kUTdA6mg6RitN92uvZauugq67/6lf//+URgFfHsIzXyQgQYcHYYshUhJYwCAFCgGCgdmNlwmDoZhYKLhF9QcClAACREeCyECIg8xcfBowLQh5W0ZKQjQEDjYqgSib9Im0ytzMZDAybz/IShoMRnhlkSBRMF1wsEg0ATeMLFztmg3EGIlFnbmPbDDE05FrsgfiVGEHIyI0vI5j2QUc/29EITO2q9D1g6T8RcVLmg6SKvNxO6TkrQzISl1wchFlgVR8qKZjN4oE8ScA2EVEJFLIW1F2GA3QF5XZgwbQ93xS8X31r23bfvun+//9//G8f/X///3////////////iyPiYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfmZ8WDvYNw4Iz40HOPbh51mxYN9m3DmbNiwd5Nua1We2z4wICEyTOkyoAUaANgyexgaAQVFszQ+MxgFMwjARk6YgQCSKgICoxKEUwEAIeEAwUAAwiE0wWMo7REgxBCsxUAgQgYXDRJEQCPQFwDLvphp8NOYWGCiHACFgHWHSpHQHLtsmUAVsBAPBUDhGHxg8IZgWDKN6KajrY0R070aUvHYVVixHA3XECizBS4gqHti4BlygdD1BmBBgvBhHBhCDiHiwpkcOYOWRx0XGLIFCixEOIsRw8kUEJSaIIJtE/DKkELBTIQUuHvB4g/QbQIMcwOgDlhYxsDPkYVjZx4TMDJF0z7LdkXSU9V77VIK9bMzf7N///9RmsnDy98j8QYeVA0Y3gBRKUyWkiMDFYQMDhw6BfDdoKFACWmDASsACgESgVTQvKYOCgCBBi8SAJnnBgaYiLRgMFBUGoEhoDImu+6coajF3dT8Zerx+VLF/qEJzMyY2hWIACDg6YDDJkFTA5HI9JkwYpNvG4iwGh500toSK4ZD40WQ4iQMLEj6H2n0KgrJruCESnRKXxcnWeDWgcGcjIj9qc7MqvUTIhqcVckFzLCk1IADQhxIjjVqaNg8mC7+I5Odq5gVzj2jVp9f61rGP//v7//+9//ev///////////////ikOPrVuKUbAASHndbZiAaDQJiBeclCx4oGcY+9CBABCgCq8AgAAwEASDhieASZAQEJgWJxhSOhkksh3Q2xiEDaKxhAEgKDYeAZRmGWlIAF1NsulpoOEFC4BBqNAm3YRAJNkQIjoCsUYgYDhIYDheZKGMYoAKpcDgaJgEL1opFxXObx32KsEFIBqgQSEmIoJKQYVAiJFTUoDGEokMyNIUmJiSpAxxDHE6KOPJGDiOsLOFnEQHOIuMuK0IAQUh4yAvSdYcwckREYwgABpgMlQCAhzBXxnidJkZIg4uUd48ldSSM8fSNTU+nba+jd12R+v//////YsFJOVLRxV/y2JmKi4s6qfKS4EBQDAgDBgNI6WMwgWFie4iDIKC7OzAAcBTgfMssEAEwkPzQYxMWUc0qMTBQTBQhTXeFKpt12pRTsOIOpkKaoijoILirtjSIqsboN1TpmgCADSC9MKggHENUhVA76L0S+YY5cNrCMJFxClzQNpELiUx5Gk5EiHjnGY31FoQqIgITksOWWhskOE9qGVZzQZkni2VyiL4gI4hJxwC4zo6EzIjBrB5SJggqBFQUWIQhvgfwXMJ+IQqkWIoXyMKpoaGi0UFJsqyH0taLLXv0n36+v/V//1spM4fsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHQGfFA5yLcOgs6MBzsW4drZ8SDnWtw7wzYsHOybn863WkBUMmHoWZcBokEEykdgSBDCAPNY/Uz0J06h4gM4STJgmYGCRj8Eq1ioLBAcMvjgwLBSCZmlRYY6EL/igPCAusRPgDB1pzJV0OTAQKCoGDpgwEkAMLvKtQeWmEAJ0EAQ4ADAZ5MSnwzsFQqIgEAUiFOGOoeRRgzkw3GhaRliHCaC4wy8OomzMvlIcYzhHFIsjVIaHTkFIYMMXCMqWhax0kQkEHYjJAg5FTg7w8RMjNk+YlEcwnByA/QP0AIoFgGgg3gHcfIIUBWqRqTBeIqZXdi6tIyQ1K9tFTvV/+h/////qMS4gfpa0dlSOo6PDD3iMykRvZ8RAARg0weOjbn2MohoBBGkSog1tTAqhKIAoZwYFgEhzMHwjMnxzNqJNMFAHTlMFgJJgTSSX2lupuirAa0otgUAYYAgYhSysYAKWto3yRZcALgQQAgAQBMTj3EQYBwJiAA1JobuUwV04BbrKrwioywe4F0hPQ5QxxBS8aicg+gyJDiIJCtCJk6RUiw8kcTI6RaysTRDSDmAzBMlMvCPzUgAm0WYXiLjJHWGYIsRYuilA4gCfC5QpQZYiZDCKiUieNCIJkwgYpGhuVWX6Jr9avX/b/////+ouFRfLk1TQkdBJpAOmTwuJBzYXAaloKFZwp/iSvXIrOIASGQGQpEYFmM4IDILmBILgYQACBBg4M5yaxhgoIgCCcwQAkweA5+ki2nI8tYTNVWZMgQZIWaAQFkQBl/F0t6ra1NmY0HpgIFhgkBBhAIYCOkDBKUAels5asCfQGAPKXqxoIxKkB/Alp8FAQgvwcoLyL4TMew1k4TIYhGCyJglYw46ibiXiMDuJUlCGOiy6MwyymBlhpQJ4wAmA5x2juG8HsByD3DiAShGEvECC4jFEvG8jlFI1YvlFMxWtaBcRQoLQZX1Lf/d//////6zM0MHzvQG1hpYAABrPPCaUFQCpMEBoSA4KFBw+7GvgkYBgO57Zy+o4Aw4CYGGQuEYEhEYPBAYjAqYkDaeFmcY/iwYPB+UBoRBK68sDgFfRAE0x3nGQ4jQaioAxxDdZyPCFzSBwDmuAkFC25gOIZUBUwECUsAADgSRNV0nUkHDyq02rG18cY5wlMMEEoHRDyKVL5HDKE6SSREiaHMGfJIdZCl0gSBBR7EBRomA2SIEoRYV4XOXCiKAFSIAKMakNPDMDVDYyHBfoZwZoC5CHh0BJEa5ACcHWTpcSLTMaWSN1uybIqWz0t1t/rbtv////9OYllcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABrNmRYN8m3L+rOiQd5RuWaWdGA5xrcQCs2JB3s25y+FUrDkiTh7EPySsHSrBIcLAYMMRDkgJxWIFQGYLBccL6FlyYiMhMIgFMIxmSgZRDJzODIQY9AQkJAYBUnpVC0BTOUU45HWbl3R4Ey58SYD0TDCIIkwIAoAMCAowMHEMAiNuKXEQHM3sLAqlhh+VDk7nDE0HSKARHkigfQ6XSUIMQgpRBAgpFQ+6BJk+RU6So5xiTh8jBai+Xy4XiBECFmjdE+DMHD5seKYvRdmCQZGBGwNqExDCoYiJIqD6J0ZpzQeUzVaSCZeQTt1srtV////////mIXZyf19i5pgKBxjIyxq+AAOA1EwABGYGAKFREMm+UMYA6MAhMwAEgUDBYChcEAAMmDAUQCoUHaN5gcRmEmiaZxYKehiQXgoPgYThQAhQBA4CBwhKoIeNEF4GHBQABxfIAKjsFAaHB5BAFQYIwOJBFK4w+AjA5BNnJ8wOHUuVsFUEq5YIl5KodZoXJdcMRicBZAxpGFELlEwZD4KZFybJ8ZogBPBbyQMZggQ5o6h3DMjkFkkBlxkRepmaZGCmkyOAR6QYTuOkkSKEOEBhCg9BiECQgAK8AVUAULClhCNIdYnwihOEIdHOPOpkpqiYJUlKN06KvU/+36v////1rJoo18r0xBa+hkQmAc+BQjBj2LXW6jOZqPICS5EGUZTAwRhTglQMIJQSACgELpMshYxKlifKGRhIChuAg6SgJJVgC10x5W3ScnGvvuj6wEgATWGBuMku/j4rKIQCAQIZQWpQRxIFsYLnpcLdU4RXWqy5rbQB+E2E8TJYsIAwRBJIlxgx6kgXSSKwdJJjzLT5GH0T/Jg5CjNTUyL6JKjaM4/Byh4EFOOMRgFtEuExCyDdGFEEHcMUfh9RJcuj8aG6K3ZlOktm6///r//////1LONjPPrBSMpUDwxQpAwFDxhaPw0ABgeARgoC5sPJppYEpheCRgIAoUBoFA6NAK0ESB0cCULgeGBEYDAIFh2OIzmMNAFMHgaMAgaFQVDgGLtltXLROeqrNmAAJDwQGBgPMNbWgaYYHAkWACFgLAIACQUhQAzBQKTDNUjCoNDAkCCqAaMgkD4JAqdcBMJiL2PSJyEoDvFwDcEFiHCOUhaw1SMUZsZYiZ0dAzxKB6AswZEbZDxYxcg54pcYRmQeSyIzIsoMvCFCCD5FaiZDMEckMgKXIwPgC9wJ7BpESwIBhxpGCTkwPRkkOWXjaXTxuggkTpgtrGSC/+uv7v/////+YnyujAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdNTcQDndLw6yzYoHeNbl/VnRAOei3DRTNiwd3JucJW+i+12BUfmeuSAv2g0gAa2YECoADwCTsAicbIAACJgaXaOAiYLgsNGEYMg+Ch0LAhjwKmPMKnJzAmWYmAQEhGHRgYCgiAFiDNmPquUCRbYqFQzaAGAagmgsSAwHAeVABAQewxwwSBUwiDcw6H8wuEMDhDUhlLVGgEDUxQvYEstgTbUcjd0UAStgthVR9H4gdwqKLv86OLQYBXg2F3aWG4fXatNx4w+0MQzYg2Kz0oaAu6QLSfdfkgfWG7DFVvtyZugMAQgrCoGoswpNJ0sarr1Y3Uypd0WruVjne/21/d//6/7////yh8bvULfRTMKBEZPu4Z/AMEAGhPHAUBgEBYQTUybzMMBQoCEKFbYEZ8rww6CwsDTBo0HgwKCwxSjjsBtMvEUwYCgUP3XTBAwGSWTeYgl7DLbBYOFAIEiExFFRRYuUj8AgMLARbQGAwqAjBoSNIjcx0JTDgNDAQX+UEfZQiidNX7TIYGkdhwEnAowuhdBhCIcHiVEkMIPIkRhgvxWZDJJQSQcB0XhwheCTEDHcbGRsJ2LAc4KgFsGSNw4SRGorWIyDsBWQVwAQwHeCSBOwvo8RKRBCTHsXDAuMcTRUiupnaiyP6rf13//////mZwokMZE0GDm8XMaYTgDM6KhVAgjDZQBxoUnjYWaSBoQAYYDQBqWaEQXACFABg4GZdoJBcIgwQwG8wZw/zVlCJMQUAUwKgDkBgQCKYAwACg4sAGrtdCI0tZyOgVwtOgQgISkMAARDLrO+YDwCDODASAhMBoC4wCgLTDJAlCAQyYFJLxXjPEwEtGnooMOKoAcPCfiDhx5JClxyRGIsQbaPxARfCkRjCLDHiFQ+EP1EoCex0DPlkX4l5meQHyLgWK1OD7JkZIcYhKOUJwIcOEnjUkxsBqRTDYQP8QIQAOLHMFIDTOC7HcTBgQRFM3LqRcY4cU6KSCvV6X/9/////+alMdhp2lfqWtaQdMfRpM9gUYekqOAdKTAEGjKiYjJkLkCRepAJL2AEIeSBSWZiQaFywy5hMyEQ8JM4DgSJiwGpSNASKCBigLWpQuaVEoY1B3mAL1Zu0paCEtK9I8ucIQEdGDYnUKCpgwAgvBbVWZKVwa2KTOPOidxmECHEFEfmQ60S4RIxJcpj7J4qDaGmOslxwEWJsdRFDAiRaJIdZkaFxAeiiRiBAzcgo7jFA6LsToJ8C1QAEBYqQccQsknSIGJkYmiaZsgpTMk6/2/////////1yusAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAIGWfDg72jcNXM6LBzj24fzZ0QDvZtwwCg4sHO6XCIyrBeSf5gKHBkFPhl6NCWqegABcQACYgg+a0ZWaVhiYSBQMAvD6LaMYhAQMAYwDAcwfDAwoEkxJD80MfY5UvoxLOUwnAMxODkaAIEgKn4CABLhtMa0mEmYYDA6qcIFdnJVAsumiI7oUA8BA8QAQNCiEAsKguZAGqAg2LABCQAlUDFwuIXXTCf1rqE9NsXCGgEEE3qEGkUC00hB1EaISEkPJ0aYYGC0kXCRheH0KWJoWIXIRYbJgPkZo4LIcdguhQotgjIQgHMHELeaC3CjB9gtkG3ByIGnDEuDeYGwUG1B6YWjny+OQSI9Eup7mRiVzd3dUyZGvWpf9+n/////+kozTNV5RGtAL1GAAeBYiacEbMo6IwEnERCE7CqhaeGGwCBgAl8PAF20AJEIGAmCwiKgIMLIXZZ1YBmCheAiEYPBQEATGZWknBzRo3BF0qAJXhhIAq3yKLUabjRmCqIMYboYJCZht/GOAsnKth12AyhGRXMAw6tBlUR4aKvVCahdToo/nzzSQeHKLFaEqXsJDXbOrWKaHLBWj/dPk4g7qFxZTEy8VpxJwvwLoqQBIADQWJ3Ix1aRls7jU+frUXVf6/7+////////8f//////////////////5gWjVYAdtfBecGAQZAzcaKCMYGgSKgGYDBUIAjMBBYMyvGMQRYFQTiACDEME8wCAgwUA4xMCoKg+t0wfC8xyDgyfFU8kkkyUDwwIAQOB0mFMDAJDroJ/ojOG2F8lCBINxEBQIBBym5s/LaKdpqAkDgABAEA8wCAgw9OwwIDgMIQiBZphfSeaqsCoUk69zIREzwyodggAYEI42GwTA7xGgtZBSmOIQXDoB7FakGE4HBGw+iJjnE4TZEBbxly+MiTQ+SPFoDLo5pLD+Ogjh5GbD1CGhvgjsMwC6gCgC4g9AQEDGhBSDEEJNJycQMzQ2SMjE0RZ1t/Uv//3/V///+s6dNUNR25BbwCMCGA5GLHeCmQPetYQiWZBR6YWg+WyWujIkAkWpmYFgaWUL9jwTDIfGKqAmsoHDxLmD4JIzSBg6xlkWG5vxDcOiMAAcCipxoCloKYN2EIBS5b6KsOICAKpOvhK1yo1vJ4KxwBImowLBEA1Y1Abzt/AK65idn84RPyatSZylnMTlUqfuXtI+JQDGsb9LMS2tahqVTOV2Ow9G+W35jsabSlVvUsiMNXpLKsYb5UorHTxpJEjNoov///+OFSYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIq2bDA76TcrCn+MBrmVwgGZsODvZtyyyi4kG+aXCXTjQnlUKMKAlNC0LOfgQCBHW+BA8AQtGKAnniabmmwchgOxgKAEOaYBYCgoASYAICxgNAUmAAAgYDALZgbAxGBoB2YAw5Zo6hhmHOAYYPALQWAqjrJAaAGSABKFlAFK9HLVodEKgOCwFybhZMcAHUFJgCkQExBgApZQVAGMCIEAwSQCjATAlHgRlyGAKA6VgJuMJAFrxJQCUjGXWAtgSYhYRYiYXQDtDME8dF2OYGrx8hiIZ0qhisW4dInkW8MUjlGg9DqGIkXiHmIn4RwMoTYhUQmEHibjAZ4SiMoMkLkELjPAGkDbADjgL0GbC1ArAtoe6MUaB8gZOkXLhqYkwfMjBZu9S2TU/VqdSv1f/////00Tqx31+U1RaxjsIf/izkrfdRAUa4chnsGNbDg8XkXatprIYBlvpICAMkAQMIFE49OlSGDxGPA1aL2MSduCXftzz1BcHJAq9XBgWmn1uLyfheQAJdEYsPI8HJpXJUoSIbZvEV/PQ/UibjGpO5NPD8NWK8el0cs2OxmkutNjUYnq9HhD8RjUPUkPW84E+7XiF3KJ0detnO3YJlsYfkqkS19mx7no1IKuaz4iFy7idXd///+oqZlUfepbZKBQUE0xdzU0KGkuAyAwXAAwEAoIE86gyczfEMFAwCQPBABNhRxDgHMPwFMBQYMBgXAQWmHYEGTCMHSrbAouzFAIDAcIjAUAi/6DilChLI04FA48CQAMEgKMDgSMBQRMBQMSEgowGAovoIADEQHPwYMgKYDAOZhBwDQHBoImBoOlmUtVZgMAyObLGduk4wrcY8VRGGBHE0WR1DMk2QEWeQY6IUFBhqItyR8awjYWeUExyTFNAzGVLBACuJMTYz5DRXRmhzSIIkVFsHOFyCAoCBgnoLDAuDDihfh8ImhgLPFZJwkSbNTiJOmLuopNfY3Urqr//7/////1sibDt8lOmQmAgIYDHKlg8F0KwoFDUfDgeCM/EAmDyBB1k9R0BGDgCYyAAgBo0CzEIDEkgZr4ZoK6mYAGYDIoqHwUCHVbvA0MOwhKbBDjS1F2SJKAYANor5UzBQqEHAMFlmzUkR2IJtQMsnB4OrcqvKWAS1xM3hWfIZe3F3IFWPGLtM9NJAVFEYNjSqUbfSKxOORimgJ6LkVp8ofcWOz0tn4xSSClktPjqRUmC0Fxpml02IKWxCHrUUgZ3p+XZW9/rDnLmIdMgm72////BwOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB+5mw4Pei3LYSKiAZ9tcH52fDA72TcOAM2IBzsm5wtxhmZewwDwQTCmJNMS8DcHAYAYAAOAfaSYAQTxhVpUGB8DEGAMmAkAEg2lsCQCC6oIAGAQCyCYwAQDhEBGYJAhho/DrGG0AWYDYAZgLgKjoBrZIfThjTWk1FMmEBYAQBAkKXBgAhcIiAcYsrXEjALACLeEwB4oAQYCgIZg/hDg4HsBAshwAQKAGYJFo+vNaTYnofQPTGcEJxOg6BWrjsWThBzhkTpYGZFdK46RujwLsojNlciw4hKZeJMd45YrZMbZPEEI4Zs6MqXEy4WieHQXRyAGWNQGwEpG4NpC0iwjAK45xTQKhmyBkxkTxitSndEwt99f///////zAsD/qSmCHbQSiYBtjFop4WITpAAFZIVCYLQCYOAOFgLyyie4kAapoYEYBYcAQYB4C5gGgkGBcAaYFYXZobgUhwWRgTAOEQDA4AM1GLkQAbfV1N2lMbFAGRGAGw1hyLYBBF9SKHkZSYKRVEACacBHbwZyieY6AhwAIAFgiOSt0xXdVlKq1ZrjgRCB8JTUwsPVHK9I0d2vi0PT887VZslHDcFdu1IE7MSmN0FFWxlDOqepDcG0jRrDjuQZCDqsJgBp6gsqhbnTteXVLeHc8LtDc4ehxusIM///+KgGzckNAl6AgOMyEYB2RFsCQCDAoNx0BwwSTk21zT4VzBEBgMMCPAsA7EC/phECoIAEwsEgxBC8x8KQyBk050xEwIJwxHC8wHBZSxN1TNHoFAEkMX/TljQFBQDDaYfhAAQEac3Z1WBAoCC7oyA5c0wBBUwvBEyhKoxxCtM9vhECLzkgFysWAGHVbV9pMieA7w3hvh5QgUNGEKOQIlR3kmRw9iwE2I/DGAsJfJ8TsGojPkiIxFeMTEfieImRch7CPzMQnG6RhIlg4MgLjH0J4E2hhQBjgAIC/5NidR5HLLo7BrlEd5qhPGZ02RQLzOrRTV+m2rWqtf/////9jhgaP8qty94xwCBYNmMhQizBcXSdCBscWPhqMBEQelAvIuLpS0Q/LLFAJg4C0ITE8dzJhxjRiHDHAUzBwBDA4CC9SCr4NFQ6pFQVEJcIgbBwFl0WAJ2loVYkOKPa+ggBAcBhQDoFBY0oZsBDQthpYkCDJU5oQmQ+MZW0gmFBjbIIOcLiDICRFRvDpWOEnBxlwvl0eSdJIjC0JwGaGTKgswnyfIUhpFyQNyFNBoGI9Fwg5bIKUx8k4Oob4jMAkQIcFnRFxtHSKDgGYGaH0RM1MUXecRRTUyNJVX9f///////6mNRgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgzZ0MDvptw1qzYkHOybl2pnQwO8i3DnjOhwd5FuMYeeNsRKAoUDwwAqQxREgEAK6wEBUwyAowFAE4Ins07CUOAsIQB1CUBxgFAAVAwAsQAJGAwB6YDADhgAA8GBYLKaS4BYVBWMCgCYwZQHgCAop9WxINMISAPL9J7rmAQAZgjAGhgHBgIABJMIclChoBcWAEL3pIEACrgCACwwgg2DBGBGBwAAJAWIgIU9Wmp/L8p2QoquCQIPkHeTA/Bg0VJNEZs2FnDlG4zAtYswQAC5I1xBQV0ZMkx5QMzxDiCDOkoTRGE2M6ZE+Q4ni8S4g0pEHJsXMGqg1aBWQEjBaSGqwRDJkQoLpyaJMXIYlcwlBjqi4dQRda2dL9aOr3+r/////qUcUY/YsbcFDmY/KZgQXxtjKmoYMwEIzWPmNaCAvWMgVLpAhPa4LAqYGAWKhAxcxUCsyBLI6GEMyOCQwtDlkoWAl/X3uwEr2X12UoDB4FmDDIAsoQHpvpAJ5I8ueAgAMCwTMBApMKCcAANoJASAKfT6rFfeBogup3oCFvI4fZExP6iiVS6Ylwc0myBGbEFFxEkWzo3B3FwskSHAXzci5wmVGo5BTI4kUC4X0C9KBRGXD5RnQDJE+hbgYQnEhgnIckbQ5pBC6bk8YKTTda3Q6DP/q////////nUJM6sHtcL3gYHDN1kjUwRCyZCAJgcCzLQaGxjf1hMo5hINoQFUFrfEgMWAOYfAhhQLjxKMSEUx2IDNk6EWeCCMClEYXCI0WmYFs0yVL4xDbF3dEISMAAMvaiGIQAmAIwEmiX8UpHAIDgmRBcyyEjExAFjqJCeBJGIwE05RdTJWMu232IjgQ8PdIGPIZOQ43j5HSTpUIEPxGE6LKEaifSME6iMxzBsECJ0ZkfBNEsK4bi4xlRkBwjhLjDJjnE+al0nBlSKjGhqYNwA4glA2ElxSY5JDiLnCBFsoEufdJSaCSlo9m+pv//t////+6Zw1fX34+6AiAUwERUxzBNcddBkSAYweE8x/rEOcExeDC6q+AMCERQYFjFINMLjQxAADAYuDAwYmmZ0XumEiYYaAAyLw4OoAjBwKWQtxckAtBXwvEIAZgYGGAQAQgsFAd3VY1nDwDU0MMAABBQKC0Gl4wOASsDuYlypmk+hY8DHEXpbDoognsmhmyHCAxdLBOk8VymXFEPG+PBByQIuO4WgXw2yDkiiS5dIcWCyO8qjRIaPgZoaqJBkCAJGBEiADCEJgueA3QbxizRYxXiCDUIGLYRQZs0M0W00DOirp1+1N////////zhqangAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHi2dCg72LcNjM6HBzkW4fOZ8KDvWtw38z4YHOQbimhmPOyW6MGAbMs45NchPgddwyCxfolDc0vdUyMA9iJEHgJDVFUOChJsFA0XXBwHFQIjBoJhATguChjoGxYDQABIQgKFABYbEUHlAmyMVXqYAg8XGMCAYMCQMSNUQXahmWlQrayCgAAAJiMWTCYmDBIAxopDAEAkK0EqeAsAi9oBZCnE34+xzwtqMoK4LMDSh4LAhciZHDNprHEQMMlGUGMTIsOcNAVoLkFKGhgoXh5AdY5JSJ4VwbIqIpaQYjxqDnitROwatFKACsA+hdUDcYxQ90cBcJIXMRqR08uYJOkgfRTdndvqS//9X////+spmSGOUfwb0v0asERlUSNYiEHocTBoQO3N4yyB0sg4VKoMTcuHgELxCIzA4MAwaMmh8ysnzX+4MdgUyyAyQDAoEMCUsZmCgyvVlllbC+FgRYGCoCaCySkGASieOgBBYSDwVCBbgGOEHIYVCqma6HbSfZEnRFYGXFUGWDLofgKDMBQYyhDUxaCNNCuXScJgiwXoFAlchpZZxrkNKZIl0iZHl0pDKl4zHaOsi5dHaaKQIEQwQgKIZ8EWBCAbA6xbBbBWzJjMGh01UU1IJpuja9Tt/a////////zhoUz1aCYImUtASEZiNfZiSHYCBQuIYLgcvQoEs2CMYaHAEgigCCgOgoE1vCgLjQbiACDA4VQsKIBBMyZLkwEjsCj+IQOEhCCgBgYEC+A0AUpVSQ3jyqqEgBAsYLBYYJgQ8Q0FpQB5MAxgQAKoDAQBTBoE2LhUOTFMUjIgKDCwEUWkbACASUymymSwzIIak4mo/iVCSiFA7jSJgJsOoT8TMOAqHsOM0A2FRSJQT0Pw4EBvHYFSJQgDEEaGFKA/iSGQjAlIno9wv5RJosAuQlYmI1BcwDEAYwFABsgtghh7hyi0kTIuHiaStJBR5NRqvpP90Fq//V/////6Jqxq+OFa/iFgUZlvBkgDOPDsYAIKMNBo7e6DDY6DA+CAgCQSlIDAEDBKYiCgMC5j8ZGHSkIzCBgYf0XpicZGCAwYMBAkB0/UqkYknH7oKVIoLhQICIhBpbFeyYxd1JUtiWpFQ0taIiABm5CsZZI4GBYYBFGkALLX1awmHp7OhjAiw9CMCCkTKpKEyLMGUJYaJAy8Okjy8jNikRBIZQkiBDPmxPkXG6TxUIwdY5wgkQ0dQ2RwGqiSG8SpPCyQ2crA9FBiyC+T4zJAyWSKJmRBz6aDGbJMq6VH/b/v//////qPubsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACFdnQYO9k3DTCMhgb5tcHuGfCA72LcOUomFBvu1w5LnMWOvUwNAsyuXE17GcwGAJDkOB6lCEAQcQhmalAGTBuYJAQAghAgHNPBABCwAmBIBLgMFASMEDDMDDkP+UcM4xFMEAfMLxxBQMO8sEklHk9kz0okNTAAQjB8IDAMIzBUFgUASAAwGAZxiQFy3ZKASAYBCgYWiOZAhEY0BwAhSDgOWgYAASWrLYgYAHDb1hiNoWjBoYNwCPBsh+oNtRgk2HeE7ioiew1SSRDhsgUQWg3E/h7Y7h3kWIiKTFBjlF0dhRD3hpkIIDDoEqFBiFRosViBkUFlhhET+HzgP0OXABQhwW9iKisjKCuCcyACgTEljQijm6CRfMiofUqpL+lb//q+r///9SkC0l32+qtUSIMfPDlCKCXjCoISCQWDx1hTkwPGgwEFNb5EAiAAhQDkS9BoODgYECwxIGTSDdNyloEkoHAQyABH9MDAJXjJGdNaU0dRSQBB4QSULKUdBqmIyFjxSoEmWtVCagAMQJTvwQzIuJAYICqz5odhQAZOzBgS83sVtUoSLX84LIFa5I7ElijwPLD0cfV8FjzL+SzKDXQwswFLX2ppiLfaq0UPRqrK7cpqWKZyFKolGQACIBwcCPY0xr1PJn1na8ii1arXuWMea3neesl1v///+sO40lA15UtAYFB0a4hEoQsMIAxCAkLAQmh21mUoxmBAIBACgwBx4FEVAgAyghJCYFgCYUh6YkG+Y5wkakQ0Zsj6YGBqBguMJQeGQCWorOg0keku/b/g0CiwBAOAtVhIAAQADkgkBULZEIAOMCQyBwNmAQlmEQSGUgepMhAEJwOYnsj2zJ9mfoFsUGcEIScDCpARrCexzCPFyDAGMH0LPHATQ9CoCwi1kRHJFhIaXiIkMIgPBECHEQG+VieHSPZYGXFkjGmJOOaEuPwesSAZKAfhWwlIR6K2KgzovRlyqVCVTJtpkmouPOIqMFqU/7X///////8zMzxk292qsSKoUYY6H7Ao8ArJMEGjAwcwFEg0vuwysCIwtBMvEAgvJg9DAbDgFMHAnFQzMGAdMGwgMqQ2MODxOiURM9g6MDQiMBghMBAbCwBggBSIFi+KaypmSPsFANFgFSTUyTDLcFQJAgU6IBAwaFigQHCRhZCaLvhFoRDJh4E4jFxgFaAmSrSz1VZWpcCRi+Ea11JoRR/2qPFBTsy6ke+KwbGoHkFZ0Keo4cmb2hk3ak1GY7LI/LZZDkPReIZb7beZ7FJBUMGiQeIFjs4ZS1KFMqyjFqpa5bzu3sqc40uwxXa7///yghAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAeAZkIDvZNyzMg4YG+6XBn5EwoN92uDszMhAd7NueUDgu9EYPMLkaDnKKwKexI5KEwTHA1kzoyXEwKBCDACJADWqvAGBGYPAiOAgwwwiB4wMFYyjDo/cJUyKA4w3Dkw5DowAA8uaKgEMgCyyWL6aMusWBAmDElAowCAEHBSBAEcZp5fBeiSaKZfYxOBUwNGowWFoEAKoclgDQIR6iDtIIn6clpAmgvQTQTEVuPQk4vh9CfScIAOQQYfZQD5Q9QmhnxkRVDiIcLcPBMEoSw7CVSGYTSOjGEiOeXjMmywVDpHiEhkJwFCAdwAwIWFDAC0Ab4yogGMgTCRdOGqrmpimZnztbs++r////////saJ8sY5GX0KgOb6CHtCIQD3VTAACEA1mY+dmAYVltl8pLLiCgGg0HGCCoGFvjAUCTC0MTEU/DAcqFOzAYEDDgASgDS168xwAAqAa1X+cmOhcAyYKygOw4AmpopKViECkgjMUAVpjQsyYQy2A3FEAhJGiMl62RcMErebuoUyNYdgDZWhx+BLMG3YfwjEzS0b6y9r7yS5/pXLqGCXmrRWBL+Nyfi05MRuzBlPA8jx3qkjUjZcxaeV+sKzF13zzaZhfsYU0qDTBAk8tX////sCqNzVX2lloDBfgQCRbNc9KscGg4bvkqAmcDBKVVAoDiQIDgEIZkIEoBiIJDCYGDCoUDLxOzs1qzFwejD4FhoSSyYGCZIBV7qLzXJfhA4CQIAMwEAWOiQCl23iMBB3obmuZIYcAAQEnGrg98mLAQOGFE40jW1Ni7J3mTHjLzRhyqWBXZn5BLYrMxiYpbEOSdmbrzsjh6HpTLIZklLDsgkUjnLEhl8blMZlsDzsd+VVaZrDWn7fG+0JdDlw9RVozHL1+12tjWxysAZU9yh7///8aHK07JKqCIwEB8xcXcwsDsKgEw0EgMCgSZMcbQ8aUgODh1CADMEACC4BUwWCAICZUSlRhGJJiKA5lGFB9IGBiAGwjDUeBIMAovkGAMGA6W8ZOuV0nCKoElADCIBggAEtyAAlvAgEluLUQ2AgGgwGwYBxhixJhuHxhCBo6BS0C2q7WYl02AoWKYSAmY7RbhXxhl0pGg0iZGiQ0aQr5OnicGyPAzAzA55BxmBQYypuXCi4yhsUi8cGgOJxqjEIeQBQ5JBxyg1UKRAGYBziFJDyJMI0SEpFQixNk4QhiXFpIucUjda6K/////////+s4hAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHjWZCo75rcuTs6FB3j24d1RMGDXuLgx0iYYGu7XBgAAAAa+9GYHMAAOMFS+MaAOIhDaqMgGPAUOBOaVSOZChWBgOTACAXL1o9JrOMEAHGAMAOYDwJpgRAiGC2D+YeglBoGhmGDqESYFIGIAAbAICIQAgimj0nKoqsAuSDAgAJMUKAFiwBqqoGASUoFABCUA9BIsRRciAMHQCjAFFRAIChgJAQxhSTWEWVCaRk6+2zOYHKGWUQm5HLAyFpODkoDCmZPHeLUYMYAlECVJotB/HoPUuj1HVIZB02QL4xByk4YckiQH1NE3EpCQjDgr45BYgCYVhiDfExGYcaZcJhRNE02d0Fs9f/1f///////rl4RhqvATgGA4IGJwHAI8h4MJ9JCWkoWGyMJGLAjBgvFQcYIAiTIMA7alyxEDjA5+MGhUxUDDLv/Nk6s00UDDwOEgUYHAZQJxYEs5TWfiBWXwcpaoEYIATfIyI0T5fdkoGC7OR0AAIBGBRKY0K5nkCiMPEQOBwQXUhExZcCfKqDJ32RyRHsnCWDlJ+iVMnGVuZGeI5VPxKo+77ZfSSsR16YHrnJVtYFK2P6PcukDGVCYKJDB8AzgBgKtZNJUMCEmI0nLFTsCPaPvWdXz/j4tv///P+///////////////////////77j71nclqjjkFcMMACSZhaBRlUI0EUYBxQRiEgOEADpQAkxN3DAAANEIEIEAJEQCRgWgPmBeAMYFoR5gKmQGgkVQYKwVhgTgpGCIACAQEjAQABFACRUAEtgIwA5hxnCLYqEmAoAShsBAAiITQGFQUYSCabiaBgEKDIoAScNiSAFMowMDTDYCEQOLSjIBYEGAF7JCmVDLxPwhC2FSDwMPfx64ZfLsUgh64EfCMXn+bBGIvNP7A863mdFQT0pqQ5Qu5GH5kWMpe+pYgaNt9SpHCMPA0CLDPio+/bWrcLlUYkUivS7GrhZrFS0ZoD6f///wUIfaxmpMSgDK2BLYjDBrSw4YYAAeY6HiTHKYDgELAgiE8gXAJLwWHoGAOTAkYcBOAgIMClzOqyYMIBNdsHEUVhAnQgEW6w5ekmcSCFtJYrrGgDflWWHIALAEkSDQsdCgoXhZBMTuAcNIqpiCgCwZqEuZ015/m5pKO1FWnu5aXm7ETilNhIbMW7Lp2B2mx2QTMFUtLOVqeklVDVl8pq3pXI6lS3ar17XZS7TdMBQDcRMdVZ6KeGYROxmxS8nuZdyyvhvNe7///6xGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACOZnQIO+m3C3SChga5tcIgWbAg76bcrnM2HBrTW4+YjMDPsFgBHTYMSAkQyYQOgIYGAWY9BuZl0wNLKYCYD5eowDwDkhTARAuFQEjARA4KgCZgJARmAyAKYGoOxiph+m2Uc+YjALACBqMCIAswOAHRIAMwAQEDAWACQqMBQAUSAPQIpchgAoMAWMBABQwCgBXtFQAnlMAEAJ6QKA7BAkAUYAoABgEAUmC6FuCh9DAKAIAwGYEAHBwByYIiADSABoASabBgSAWRYMFgkAQFD5BPwYiL6JkNIrC4yACCQkBgLnM0xAg1QupHkcoRAXKMoXh2izhqCgCAk4OcO0oiORnozpsTwyY1BdCeQy4HbA7fFcBwwbzCVm4skqmQyJAiJjkF9FRspZigYKUgmginbdFO//b/////+kbnDfdy/Ym3SHDweJStaOmA6JhEBGCCmLIwvITCwsonizFdIKHBCJwYCRCJRkHGR0qdHFpisBmIgMsIKARzF5qGpEpRtKljUhGA1dl5ioBVpopt1WW9igiqBhgAIg9P0y3SDGEvOzVrSA2Itjl1+Cnyei9Il9vw/b091WkuOdBN1rsM5NvPvtWiVqMZxSXRTGzckESnpfFqHOlvW8N5vtS4ui1h+UwX0fdvev1XpfmZDiJni9+r////4SrbhTLGjEIBGUJDgI7VVFRp6DgDGEBMmVd0mHw8lABZVAhe8RABGAwAaFAIzAfAuIQEggBwIAcMD0DQw8C/RahowZQSzCEABAwXhgMAFgAAdcxaRKcUAKEYCQYAKMADDAAaHQLgGoS2ciwABgBAFBcB9iRKAMIwCCICQwAwIRCEUYSg95g2gmmAmAOGAZMbTrBIAiXatCFcHo2LyBsMOkG4Abrh4QDRnYjkQEGiOsMABf4jQ+xfH0O9Yy4pUpG5BRZQrYO+QcioxxGDtGcGVIONA6NIeiNIMUCLDnlwQEMxmgMNQbBYAvBzwtfDog1APZFJDCIeO4fY/kMQNUzI4kXj1FdSSn11fV///////ozUrvl6bup3mvxk5Bp80ODouMoDJ9BPAkKYcIiilkLBgsQNUbJiBMRMEHEZ4xBs+vo30Aypox5ZmD1MRikXR5aK/zxx1GVLlcraSRI9gDX2JvwEB0UACGNcxOUkAQZyoAaiv2AV30UOte6Po2D3HiPUmFgwxgaDjHmSxImiJxIbjVRaOUsJApmJoZEQzW581SKRwonzhqtBEoEUbCABRAKKB6iXDEHeSo9jVy8Ti4eQr9F//////////+s44AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAbwRkEDnOLg50zoMHOtbho1mwgOca3L8SMgAc9xcK1WGnhX0VCGYd6oQlwwMNcMFgl3kqj1S6BVSMCAkrABiYLsDEhMSgkSAqYhgQFGKxaBkUYxgh1KGGLiQYNRI8PwQHERGTqqI5odIdRPV3DqRA8HQqAgwMOUNAxb6+TBYHMBAoEAhHEED82REjYJYFimJBACAdPBtmRJZwwvRSS8mdtFVqJgO2Ffbbx5oDhQK8Mal7+vA2jsynkLZo9FBB7t2Y1ed2OQ46Usm5XEZW0Celtnt6Hc51p6wylKlhMFVpw0yF2olCoIcSK4U8sqflZ7d5U6EAMLa2////iAEfyeWC5CYHDpihAm3hMnkuZBAYSDhgAPnH/CYaKoJABxm3EYAiQQiEKhIhjAUFDDcEgMMxgWQZjIdpnnGoBCcxSCMmL9lDxLzbZlDUk2oEdAhBYwEAsLg0BABghu6eUAFqgAByvmuGAQHmEQ2mVoUmNQKrxWBdNJdWBVJa7TFnuLHRoGQE9AKgnIc0exgM6KJKhPRwCBDDi6J4JElygHEHPJ44QVwxNCOSgwRTQOIF4dqQ9CVGGKiOZJhzBwArhIjlAYwFwIMCdjCEoRB4kuSI8h9RTZBBJ1IooO1lLb3u3///////6aZ/WdyG2uBcLmaI2Bu2HARKQkFbfmFBUddhxjoPDwjYwX/DgMrgRgQIDyg6AoxmMAUJwCtzxyxIsiYDAaTr9BwHailK0pHVmj9MsV+wELANCSBArASUgYAkwCIEtILXkoFIgUatYRigDmDwaqmsOiu3jd2XwClQ7KcgT8bxMQtQwZKD6dPqGsYAvjzTKRxIeSBqXFE8zLxJifD6cTHwgF8wJY1L44y8VkQ1SJo0DzC6g0BOkAEUMcXxvEzJcxMDccqk2QTQRUui/1/1////////3PK7hqIyN3yoMzDZFOJHNsyJpgMSCENGC2BiZRhL5jNgNmCcAKYAQBRgGAOBwBihIyBiHA/LLVyYIwDoyEqYfwvhoVlsGFSBkIgIjAwAZC4FIGAad0wDQA5CAQAACACqxWMGAKJWgwGISADMAIAYxAADAAFSUHhOYdCqLIiB4sLh0eHVGGZ+LJhoTGDQ0FgEg8/6l5b1lSuy2xftCUFwE6ytCq0Mu5F7UMMgaG0SEx523XUpZo+0SfpijP4MZDmzd0JOxKB6zYqezF3ceW3ZZDLrtyQxSQICQKDWwgIatOjiLzUXpmnsd2HccaWvUrZ3rtSzs6BQpoLp7v//4WE4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHBUPAg53i4M+oCFBzu1warPr6DXuLgxseoIGe8XDB6HQXQOhMweGzQzcOChcEAIiAQiABesdCgxyFEyXBoHDqWrDgaJgCdQEgiYSAoYEA2VAyBwcmTgeGVZfnTQ0l+QEYwoGgIBQOCMwDAVR56X6ehhaawwAYYEojAUtmHAhWSTCgSEAEKAGCQIDQMShUwCAzL8fMyjcaA6EAVAiu1jL1YPAYXAD8MwY5CIfdijZw7jmP9efVkk/LZBH7L/V31nXOpKF3Ls1H5bH6teGHah+UNtSVLsZ+vZsyxr0vUSYyYEBYYAa60pdF4dfiL58y1zur/ATcDbhzd7////tBUI8powpQgyYhDZhieG7ROzJB4CBcVCJgYNRq9LJksBBMQr7FAJqXpVKdplNILAThwDGIAsGCyZmr5BmJYQoXAwF0q9M+agza0yGMtWCgIlnQYDiC8DrAMaZJIVb4DDBRgI0NnPY4OPxoEQ3fWA0/0l8oYp1NXqdeLvRBbQJFROrVs50lixYdOluV61NSztWKXabGLUfJvDsr+K9yr56pd4adl0oDSORSUJbnVU1hmHaK3Q6KAVYCQkpcfDBMjW9xxKFvexpBC7rUJqhZCE/b//pzklUVAAECaAaZekc8wYAygLDAtCKgGGB6B0AgAyYBBPoQABiMABRYwBwJDAaADMAoJAmALMCkKgLgLmBcQGauJoph6g+GAMACYMgBgGCbVMXvRbac3iokE48AGsGo4kS1J6zAgAKwKYPEpEOiz4wDAANjCY7MgGM3YgzgoJLApBw/FhEYGBQGFaByPrKV/u015oUOOAkbFXHWTKZZDLdGCOzHpfALpLFgumhyzegG09y6X6fy1UcmRzTrS5652tNv7B9JV+5nZkjXoKfqrZps7NYDPLdWcVhKjSWRoLlWw+5ioaoG2YxFxGJhjmIRgIHpQJo8DTSYFUFEIEDAFgoDQSI4GFEwwBsHDsell8JOmYagIYSAYYCg2XnMCgHKwBuzdprS8lM0X0EoYIapw4BLIXqNAkwACVAgwMhQEgATmcsYZfFY8SS46TyCywjQH3LuNGe5+Vb3gcp/2wsdhxxbclj8clN/UfaO/UxJas7TSufkUmlvKW5Xp+ZWJRlGoL3BmGdnXd5YODGJPLbhJY/WvcktVO6Cyu3////9YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGuza9Af7q4ufHR6A/3VxavOD0B/uLi6YdHkGPcXCDQkLEJcAxZBcTXTZOB1wQw5KKTorILJ1qrGAyAwWATgwKowHQkTB+BNMIsGgwIjdDTXUoMMQNMwVABjB8BgMDIA0wGAFjAiADQHQC7JeMWACa2VABzAKAMDgEwuAIYE4JJgWCxhWApeUMCQwaBIBBcAkLMEgkMH0nMvJqMIApMGwrMKgIJgKGhhWgYFgCX8CoJg0Fy0ih4KB1jgkAqRAcByLStMcUujylCCRfMobO8llLWOrOis3KInfh5dDnzEerv0ySQMvbFIFbkw6y834hhIo2dXtvZ5AEVMgFe3AgSyEDOBvRLOu5rqVLIwgBBHtZJgBgSmCCEcYOQGRgmgYGEICEYIIBJhDjQmBmpgb+w2hhLh0mBsB6YCoKg6EAYNIBRgCgTGAoAAtNWiBnRIgCBEAKYAQAQsDoYJ4B4oCmYbgsBAUYCABZBIsGEgeGAQgGGQZkwdHO8dGFItGOYyiITSIRjDQFjC0BQcExiCBxgKAYBBEIC0QAYmmBgVLSzxMArGmeOywaH46Wwa8pvGlsyIRAIme0iCVoOW/iVbWINYo7tezfib6sMh19GelzkJrdInOym9SWeWynRef04fRx8j3GUlAVhNB2mUa5koh155j7hkwAr9LzRkHgHQYB6YCQCZggAhmAUF4YSQEpgrIjGicTyZDwXJiphQGCoBeYEYRRggALqBEwEbqKoqpooLlBQBIGABMBED4wAwFgECOYVDBjsNA0RGOwuKicwkFBJYmTgMYnHJ5WamiiYWlLAXMICESDyaYODhgIEiEDEAECgDXqVgxN8RAGB2sF10BzfOi/Tlucogt59HbXKkOnmsloq+5dJ4y3innluPw4s3CpO1JhzAJRD0XUlK4324cwDZeN593b6tN2xAMuWskxjCpX1oHDYYs2juKkCoAqaqgSDpgZglGBUCeYIATINC8MI8CUwSBVzMtN5PbhKsxkxQTBbDYMCQHUwvghh0A0VBMHAE5xfaAIMANEgFw4DktgYEIBhgDAVGBWCmZFB4wETKYwBxdC4nAByMpCIKhcw88DodJMvkU1qXjLAOMPhQOORkMXmKA+sMYIBYUApgQWGHQmXcIgOHAB/hIXBcFCMCXX9YerWizK2pv4hJTUMFAIBAJfiu3WhKsikIdR5gJ21ltHkD7JeMqVhFgapgLBBYVoEjZLL5Dh9rA8Jxq7rziQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABsA4vIH+4uLspyeQP9xcXVzk7gf7q4OvHl4BjvVwhJEhAYgtwkxpmuYzQSggjbO5FFNU64km2sgLgRGAkDACAlDB0C6MHQCYxhAZDAEJNNKRZEx3Q8AgMUDAnAQD0IBEHAAwMCFpabHUORgCgJGAMAmYAICqqRc8wOwFzIITMMAww4TDC4LC4EBgyMdA4wKBjLMaOv3UxKKTFAqMNDArB5CGBAJTEISAQuMEhQoApMAkApggBoYgYJqomCAiq5kCwsWR42x5ZNK7bKlNm1T4fh0HrgN3opdlrTHVlT2RVdDrvm36w8uc6LOVGKSplaySOcpuzXN7yXFDTwRgFMqgXw4QdydAR3of0OAEecdACLprdFgLB4HAMEBMDYEEweAhDA3BDMEcD4xymyTkvWRHlqjBfHaMCsGkwiAEzAxAYMAIAAwDwCkTlShwARMACJAiGACAoYAYCBgbgJGAoAqYCoCpjMIAwZCIWGAycYwCBgsEmHSoYILZjxZGO4QabRZskBg0MDAtMQiIxODzAAMMNEAxQFBQArBmEQAYYCyoggepWBUHLBAYGUzKHIJgAiqMgByZxKhgCMzU1YHstLLhh9GMsFiDiuBJIg4kknndVarhr7o12xtYoZ+xXAnlUP679mCW1Ee4wBJxa1OAYCMlG1DALLwyqgrwvE9KixMAoFgIyoDOYFoNBg7iKGEqAMY3YkJk7hUnDanYYyoKJhCBHmCWGoYCAGhgwg5GAuAsYBoAyyi5qg7NTAfAMBoDMvAwGpgFAwl5TAwKSqAo6CJhYO5hQBpiKOg8SAQIBnud5j7+Bg+eJh+NI0MZhKDQKDcwLAEEh6OAWAgUQeMHADFgyAgGmAQNDwOKRRQQAg0B0FYzCoMWOyhaTpLgSOTqLYulBLoOU015JI3yQyw672HQlvlF15u7OQ23ZGJ4nCoca9ronAKhQ9uLnf/////+rJwC9CqQ0oVJDyFBey65bSWdIIi3beAkB2uqiMCAIMGQyMOxoMDR0MuTDMpAgM7VLN/rZOWMGOjTpNGE5MvSHMRx1AxtGF4IEwArrT/R+GQER2EIHiIDBoCTDEEzA8GAwjBYDTAkJDEsDzAQMWamJ4NGFR4GYCfmeMhGAYqGMxcmCgZoKmHgOmHQcIHAQIwcK5giFg4Bxg4A5gmA6PhYAUwEAIAAClWMANBJfJVBKhylAZhY8NQM6xa5gCbzzJ5NEjCQsFN6yN9425TXmePi1h1ZWmWgovZyXdj+EupLvOZdv8DLGTOz//////pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdVOLsDHOLg7uc3gD+9XFzw6O4H96uDqpzeAY91cJK1gSIl6xQIcvMiy2q7VDUigMBnuXa2AMBheNKwBAYysEDRAcM4OQ4Y5Dbp+OXB8zzMD/xuNoXAxMSjcQUMxlQxwETFgfGimgMbuh2QThcchw9CoWFhsrIBiyCQWYHBAQnTBhQBo4IFgYqLZmhvGUgcb/Yh+oGGMyUYaSQ0dzDYVBoHMaAswQCQgSGCAOYpDJaQxQCiABGBgEAhWKhhAe/itD3IoOkh/KW/bRT48AyqD0o3XZsxHEdAD4snUufGAorCqRYNrjTx0BK7dlxG3gRFC3Yp6IkDIICph7RMeVHf/////0f/9H7P1VSEoOQRI5wxKDjAmypmFPJgElZEAiA0ucwwwNBcEh+YkC0YoCeYijqZqEiZEoOZ1tCZOZueHQUblm4a0KMZ5ncYeiiFgAMDwMIhDQ4r+KgGgoJDAcFjAYGiEFjB0MjCcLTEUSDCwCRYLjAcdQMFRiQHgQIhgOH5gWYBgKx5kdUplQTZgmCJiYIxhiBwqPKHIwjBIwBAowLA0mBcwGAcwUAkwLAcvSpUWoGAEMIwBZmovBigL+hwII2PI779NzMCQJJgSVmbO4b3SxBM5zgRNdzAYdZAxFJ1gDiMwXYhNaci2tNsURhWFitNggORcc+dapMCZNYsoOsMsjaFBotRxpOS+C2Fq/T7SfMPATMKwGMMAUMWQVMDxiMohFMaGiNs8RN3p3N9TZMRF3MpilCoICx6mI4LISmTsCAACrNMGALFgxHg+MDg1EIamAAZlnzGAMzAwUDEMICIXzCcUDAEIzFkDDHYQjAzqTC0hTAoOR4mTD0DCQJgCAA8OBZgFAOBQcaCFQFAwUmA4GruWutYGAMCQCLwq5ZEpcodPu/K1VWohAEsGkUBwO2Fnr+0D1KCv7SyVq67qdhMMiAAYynFDjBc5PrfcLHQXFwE8fbZ///////93///6cl/OOXuYGAUBgV7jgWaLNEIckmVTpeoC0liIBAwEAGzA9A5TdMGsGIVCBMFMU8w9CIjJuBSMnVDwiJAMAQEIgCtFQqDAsBOMBcAswLABCUBQBACCoAwoAYFwAgMA2YAoGBgjAMmBWBsPB1CQ8GLgSGB4HCIMS540Q5iWHhiGJJoWJJknrhpwZBiqHZj2HpgyARgmFRhqAIXBcFA6HAKFALCwGhgOIJFWozmAYGotiwOO1ASYinLuv68zSGZtLcwMABGqlWFaQlY/sMwQobRKys3jcrtLL5A7WGDKUuioe4S4ZXVsdrnGh4/3VgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHkTq7Af7i4OkHF4A/3VweHN7sDHuLg8meHgGPdXChGAMAvwHYaqcKEtxIyTg7HjZylAlupgvNYUwEAAzA6ADMEYHUwqA2zCLCBMMINIGh6GY4BKcXo/ZjWAqGPIFUYHYI5hTAXGCAA0YEQFZaYWApbG0IOAcCwCxEDMKAPGBOA+YBwFYjAVIkOYACBgYGJNmMBoY4NABNoBLxig0GRdqeDIJ1oeGHAUY8G46QzCY+UGMCBEIGoFBQID4yD0ZBwLJ1ioEiY6ACUIl8GBNQTqikOsUgJvBUBFAWehWdRZ5ttMj0AvGno/01A0E0rS3DZQ5EPNwU3VE1p5LmGPO3NCRhQXmarv/////+n7tWn/v/9C+xuasRwJkVyAL0uY8iUq5QZeRZzCbgoAkXDMAQCMwCgMzAVA5MDMAYwMw1zABLIMmZAc1wnJTFPD5MSYG4wnwXjALAFMF0AgwHQOBoBNHUv0QALGASAMIgDAcACYBgD4QD8GASr8MKhRMAQDIBQMEgxMOQSMJARBpImLZOGMYom4IaHZQ3hgemJpImHgDmCgIGIYUoNLCJipimAwCmBYICIBS5hb0eAlAKnARAKnwutEtgymbHnHTeQnuoYGgEuxjDesPaHE2gtbdNmzOWsNlaXA0OqxRCFsueVb7LH+TrjE9YDJKYJM0U0ErX+0hO0oU05vETmvL8p2FXUqnaT6QbEYAYVADMEcBAwEgEjCoA0MCwLkwxwmTAkAoMI8G831DNDKcDOBgnhgzhMGAuBSYAwDpgEgYAABNM8vgnIIABgEA0YCoFAAAkKoMhVBMMAECIxSCTAwFMdmAwsCDPwfMBhwVLRpURmG2ueOeprwCmOEKYRJ5lcHAolmKg8YFEwqKAABAUBgKDEZVqF0hAA03CIGkIDcF/X6RVXyqVdrUHoehg62xYGl/0C2XtXxljBm0XM4UOswY6xJ/3ziDEk+FWsPj7UXn2Aw48BmxX///////9LP+j/v/6qYNpUam0LKgI6QgOaAkNzWLEIqKAAmAGAC5K9HTcgwBwGTAnAmFADDAwCEMBkEcwkAZTCjCPMGtWM79wSTDxEYMEgNcEAamDSBKDARQ4KAwBwDnTWwYAwAygTTTAdAJMBcA8wGAJzAqAiMAoAEwABIw7CoRCEDh2MRgZCpHmEggAoejCshDVpXzl4HxgRjCMCDCoDBILhIpCz6mQhAYUAJHMEAOYCACh8W/CgBv8X0YQySkYOtRkskbg+z+KyjQBvS2GM9a0/cYak/auXhcZxrTaPn6gbAmHMnXVDE8s7WeXNf3n1hh9qEf/////////f//9YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABvA5O4H+4uDo5weAY9xcHQDq7Af7i4NVG95A/3Vwhn2PF2ogcpmCegfzrhkPYYxNtpkwAgAaw4A0YAAAYWAMSkMF8A8qAoBgDhgwhBmP+HQYtbhJjjA9GCwJiYMAJxgKA1mBuBcJAoGAAAEsEvJYRaIAAFMAgA0wFgByYBswGQDjATAeHkMDAgFQYUAcwEHBAbDPgvHgOZBCZp/lG1zWYLDoCQBUCJjUCDIYMEg0wIChCA0gU3BAAwaCxIHl3WHjISMAgooDCGkif2QNJXvDkFPhAQkCWoKCLCPbTQxPtFb9cLge8rWrsNS2SJrrsnHDazSufu7Y4CrxtnYRxaSouy5Zgk9Do8DoKxOvBLrsXgpQWA3MEIBhgBALkIHJgbAimBwBAYMQI5gQCQGGoJ2YcxTRhWQeGSUEgYNITZhhAwgYCkwCQAjARAaBwCkiiDAwaAkFgDwCASCACSwA+YAgHJgegbmJCKkQYcGACGZh4AmEA8AmWYQERidfnIj6YXUIOzZiQKGNBiYLFJgUSl5gIC2oLp90AwIhwVEIDSiMCBgUAT7qBpsMyYkqqtNZrdZeudgqEqibE1ms9UsVxKnofpqb7NPcNrTX2ltR0tJVaQNu7cxWMhI2gYNcJ7///////////9LacBKhNhjRiZlsNWOK4b6X7LX8ZwqZcS0QYAIYDQBxgQAyg4FkwNgcTEqCCMCUJUy/DOjZnUYMP8OExHQvjCjEBMBoDYwGgFU0wUAiwpgi6DAFAHHgBjAfAUMBcA0dA/MCQCAwFQMTHgMMkkIw8DzGwIMbjYkDhhgWDSxNxFA0pSUAhmJbDgNMTgIwAMkixEESIVA0HLEDhcIQgHCEFCAcAbTUQi8qGr7MRk7jNLXtRO24MMxONMPtXYbeh8JesKvWffKWwpxGfuJYzYuvVbb8v/Fqlan5la6XDxDR//////r6fv/f///RlDsEZQQvRIkynz0QIo7rQX2YGuZIdAkYBgCZgJAUmBiBmYJoF4QB+CgEjAyDKMW0Is35GGzGgHFMUkGcwTQUjAIBhMFACEOAeJgBFMHbYiHAOggBUYAgIgGgIAAWACwSASVQ6MKwQMDwqMIQiBAdgUUzCoGSAATAQgjms9gEQpiqKphCJJgGAzXDDUHeBARjoGokBQAmVgYD0riQD3EbVI2cGgLaS11aLsP9RxiD2nl1mbQEwZ+XJZ/FofsxlkFJTPZKXcfmEunCqSw3aKv9oLirEI7lgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdjOjqB/uLg0KcHkD/dXFzc3uwH+6uDpZydwY91cIDemlwMQM88BUkjDFL+kkA0BhQAVtSYBNlKoCEEsMADBoFxhEgdDwwZhxgnmHCT0ZO6PhrKJgGMQC8HFlBYBcwDAGQqAUCgAigFUvWWeMAcA5QEYASMA0CRBUEAGhAA5gGAYlgCmMCqZPBhgsXjAuAo0MNl0weTDcKlN0RowiQTBBFMTkYxqLDEQDBwNAoOBIBMQBUwkBBCEQABC144ADAgRLPmAAaCgsFAOggi9CkIzB04SxRubI0CKCsCOq1eHqBmzEWnNCcuAos4i02uvm6jC2dMQZdIHnhWP/njVaGPT////////9H/+xX9WVhuEfEfBIkuDLZBqnSSxiLkLQlS81vhAAYCAVEYGxgFgmmB0CyYBwTRgHgMmCaD6YgBgZqOjrmZ2HgYJYRJhzgTmEwBcYEgCJMEakOreIgDYgJADgYB2JjQF4iAFAgAI0ASTCWYIgMl6WYHgZAIHg4WAsP4XGQ3+2sznJAw0BkwfBIu8WiDAXFgGFhCAgAqBQCCgQMCQCS4VEmcvuVslizxyJwaB2V6Wl9KYu6n1G5XLY5AM+4TRIfag72oflENQC68NQSxaGoKh5x41eg4fxVqSpxHoZ5wE1EAJ6T4N4MxVNJF3mJoKxgvMDgNDAwBMMAED0wAQmzAyBYGhwzCEAYMgEzkxGk4TMQBcAIbZgahzGCcA+YLIFQGAhgVG5Mx2lCh4A0wBgCkqAUBIDQNQoAYIAqQhMCgLAANGDQSmDQSGEggjpJGYS+m19JGKhtGXwbmCQImGYbkAFGBYFmD4JGDYGmBQBkAAFQHAECaewBAFwCYAk6ETHrL+SF2GtQFATjPw88sRwm0qp6G1+yiIN88rus5sR+HHoabbeCHIbtwxNQw/dc6cebHlEf//////u//q/e//9dZpcMjiQskaGwtNEiK70bTrUob5obu21bkiyICAwBwHgMAuYDYcQOB9MB8CEwLhhTJpMIMYdZYyxAcTFEBAMMcMUwHQUyqCUWAIUAyAwKgDoJzAGADHgDAAAcOgXDgDgCAGFALTAcHRodTBAJjBsBjDMEzFQRTFAETIMIzHAhDYShDNUGDB4DzBMFjBAMzDoFh4GDAcDyUATEIFiz66kvTAQEZerhY4QAS5VYlU2zSl+HVY7aj6Ah61muEyRnslrS5oCqvYw5Ublsad6/IGAq8bKoTKqR5Yeq8v2wnS0czcv////////t/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGdTg7gf7q4O9nJ2Bj3Vwc7OTqB/uLg8OcnYGPdXCEXdTmoScH0gQXpipx6ZUSbuxaLskZ0QgNF0EKDBTAiHgKTBNAZMGgDUwYhWzMoDjPTUbgMEEHQdDBLCJMBkEcwKAGwQAE0x9QSAEouxFNNNBNAKgCkgBoyA6KAW/pg4BDFSQMTAUIjCcOjE8HTBNUDLPVSImzJcTzAADTBkLggIAEBBcELgAiLGmoqppVp3rrZ0pUowqsv1pzOXleOGHusLxd5k6zGcwK71uNx565TD0kl7hONWlzaOJbcujjUw/EDXsqBrl//////////08bklStZ1RprW0x4aTtbxx0dVXtfU1TdegFACAABswAwDzAXAPMAgHMw6AyjFJEYMDglQxHRjDbYRjMRQZsxBwRzBKCcMCEFAwEAQR0BQBAVrmTJR6ZKAgBjAhAYMBwBwIAvCoBQOCKHg/MFBOMEAJMXQBHQZMGRGMVSDMhB4MDySOIThNJiYMTQsARVmDAFIFAYTyEAhoHBYLggFSYGioASTBgGACL7bl8EyyYB0wo2xllCKTyO40hZTRRoC37fZUbuOq/0eau9Dutna1RSpPZwHzT3htgLoyVakSgSNS2xgaNTHX//////+5X///7qMoJJD5LqaQYpLgrEeW8lCp3TRdStIgG3zIADDADATMCUCcGgkGBKCEYFwHJhqCpmFaFmAGQDoOfMMU4UowVQ8jAFAxMHACwOBIMBECEeAHT+L8pzAAA8qgDgEA0SADMEYDEwDwHjAiANMEgwFC0yCPS2QkBQSBgqAACVyWCnrMGexKZhckGAiGAQGLBtd6AFAGYiDQXA4hCSiyZqayg6lKfQ6FHGL5rXZS+kNKOSR1kxVU2HKvvxhw3erSRzXEjjzUzrzKtyw7swM0Kcus6t26bO9VwF3Cg8x///////7ei1Vv+j3Nu/Tk7rWU5ZaDACF6mTS1F2rvaBgBoaQxEAAKYbUjADAKUCMAgB4wPQYzA0DHMEADkw7Q1jGBAgMigOM53xEjMlHuMGgDsw/AqjBAA4IAOzACAMAwKyWcOKCAoAlLYAAQg4CsRgPGA8BcYGoEphWKIVBUAiIYDA0JBoYJBcYejOYogMY/G4Z9Z2bEDcYbg0Y4BYYYiyYoBuRBIAQGMHgWiq5TBQBSgGjAsAnkJgczGQdAABNsi1ATMEFm2kMxRQw546AKNSXi/X3k0qij6XXua5KLtiKvIzq67TYa8fbSIwdYwt43pd////////2f+z6raOrrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABt83OwH+6uDtxydQY7xcGrDc7Af7q4PQHB1Bj3FwlmJ8TEb4zQ4C6g2iHnoZasj3LDM5TzfZZ4KAAAgF5gDAMmAsFiYAYJJgbhkmDGJEY+ZMJxAMWmHcBWYCAUxgegvGDoCSj4YBoAgQA0roWADa6rtnEFgIBwwGAMTAwABCAFwMGwOHcBBAYAAiYFAoYDAcYPhKCBUMNChNA+eMPiuMPAqAw9GBoFGC4GAEDobAIKPmFwDMCwDFgYTRGQEaAo+kk15RtS52pmlldydcO/GIg1ty3bjlFHpM70uoYg5NPB1SFzkahtxX2hq3y0Fb3V////////9nd//f1zblA4CDCOKCyAsFgC4kv3SFRIqt0UUZwXOTqbQwCD0wZBswJEAyhDwwpKYwOek0vLg62MkzIYo1ujwzyQE0QAAx1FoBA0YXggAg8YajkpkQgIJAKFgrMCwfCApMBhNMLwTRPAwSeYw4FDHgzMyi0dBhgsfmZUKfCZAiKxhonlBJMKBsQgcEC0xeFzF4TDA6YhACyQaCBEAASDSIRAoFlxQQE66zo4pQ3Gs7DXWAp3t6SgJFNRdS94mwx+HWkLwadEX8jksYO+1AvOMuMz2kVKv6H4njUzGhAup1L//////+6vs71aWC5K3u+xHUe0eGi4JpDsEiNMZJ0IScj6y1h0QGgEFrKojwBRgggZmAwBEYDwURgcgnmEMGUYeoqZiMIMnDmESZEYDRhVAFmCgBoYNwJZgAARmBsAKTADU60GdlyhoAgSAAbYwGQC0PWHiAHhoMC1QcFIBC8EgADhwBAWmKIRGnM8mhgYgQeTAoPDBkAXmIABVnLUMTAALNou6DoSWvSIVIxVvFrTTc21afBDNZuHWMrxaFKIvcc92pVFYXemXfvwRIJRDsVhqWMEtTlWEiINMp////////X+nj9fFf//XySOLHE6gYxAYWZblGVTonJ/KwDoA7sMeekvcYDIDpgUAOGDiAsYJAVIGBYMCIEEwLAQDDHMOMmtTcwKwDTD2EDMLIREwPg3bJgVAEmBCA2sWDUXAIBAFQCzANA5MAkAswQQDTAxBOEYEIXBQGDBgYBlmjBgSMBmwiXRlQtGyCYfdYxxRaGUR+ZoJoUPBkEChwgMQgAxMEzBoOMHAswMEA4LEwKMBg0WAJdkwODVA2EsEaW0ZqV5gi02AK3J2sOAwCYXAErgqPxmBnMZa9zV5JAkgg5i8GxJl09A8D3Wr9nRBlkuX///////b6HWJ2ez6Mcpf1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZ3NzsB/uLg82cXUD/dXB4A3uoH+8uDrhxdQY91cMm+wJs4j3dlAaZKMJ9vYq2jPU8bSV4wACYBQFpgVgEiEA8RBPmHWBkYUALpk+IpGYqnIYaARhiFgJAYdEwNQfBIBMwDQHUAyeYqAGyVLoGABGAcAaWkMBgCBMYrAdAxaXqEBQEA8LAABCoAjYx2LxYuG2MuP3oGFYxCISqGUwAcCi6AIARgUEBgAZm9SMzV3LZM0h+3fZDAFtiW5DFIy/aSy9FnPHjI5JEog+bO+Q3SSyr2Xy2D7dxplI5NyVmWi1S3f///////+j7P99Vv0SHkjRcCeFKYoaxJSLPeA6EwRACv8WAAmdGAEBSJAYgYDQWAUMIUNowjA4jDZEbMQcSUxg0YDjjNsNGsIcwSQ6zCcECMIQDAwDARwSBEYDAAwhAOmwUAQtkuuIAFTARABMCUBEwLwDg4GEwdBswBCQxyA4wACYw1B8lCAyDMAwqCAwvPIxYyEyXOUw1EccAlN0FBUYPhEYlACCApMDQKTVBIDioAiQSCQGlqyYJX+SuFgJQdfl+E3UqHG4zN+0GUdWGrKfJ2mhvA6DI4QRAA/zxxuVK8gCJOGxad0tOhvN5KfsgNi6O////////V26/6rv9+2mpZlanSCCwDqN5yNwuBlrtaM1FyiYAtgSGqVxgLgEmBMBUFQAjCBDKMCIJUwgQ6jDhQMODQVQzSg+TClDhMCkFcwyQJDAKAyMBsCowDAA0wU0GDCMAEwCQCjAhAjDgEFPmBqB2CAGTArAXCANh4A8wNgITAqAnMA8BswEwTDA0AuME0HwEJEGLeGAYLIIJgOgDmAeBWNARCIBtDcQgBmAaAiy5AwqALBwCQcAA8jXVJrwd9QNQCDMFYH/fxuTntURCRYbpMSpm8knnZopbYv4S+QTeGFSOwJF5dnGsAgEj1////////02L/3IkO6rv3en4CXYmInA01/REOC0UFJLCszQRoooplxWjpFgYAQwAgUTAhCsMFcIMwOQwkszEGBRMjhBY6cjtjDjCdMKMVAwhQwzDQAeMFUBQwUQIgsAGtd6ltBUBIDAOlwA4BQuwYLIFBgLgDkoNmAALAUDDAYVzF4LCyRiuCZhocBKZxxcpxxKKBjGO48EZg4IZgMAwIBYwNBwLAUgYKAKHAYUA4jAJAwGAchPXSgwjgy1iTmthIgEceJzDtRvFiDB1vSZfMfmGf07yq4cB5oJgOHmvtfb6AmXwy40plPLd4o1n6P/////+6/an//2a91N+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHPDe6Af7q4Ozm91A/3VwdWNzmB/urg2wb3YD/cXC5mk4D/DdYA6g6QkBNY5yPwt5Q1ZC4nTMAUAxKUwMgTjBrBJMBMHgwCxQjC9GFMCoR4wbBczVia9MHkVAwngZjCZA6MBoDMOCfMB4AYLAKIjEIAKwoAAJL5mBAAm+bpmBQA+lAYAAYYFAIDBIMaABBAaCQFmCg4mHheIDTL2IjdwvzHQRgEFrKzAUCzBkDjBkC0M2hGAQHrrSceJ7FDHVeFdS+1D2gTDLG4v7ADcHweSBJLNR2Gnof6pEE4I7FH6ksogO5Acrj7pyB2YrBMJzLm3IOt///////yiNlkXZb0SY7J9zt9vk5UyJoSAH0ElDiHEPkxlIDGUmzot0r1QJSY4AWLAUkwVRg8ghGCgB+YB4kxgIC8mMYMoZEaNJkfM5mOAVkYMAZZhNAImBKEIDANTBaARBwFwwAKDgAxEAK08aAgMAIA0AgEGBKBeYQYBwMAGMWwAMAwVAIEGGgehwFAEUxkDQUQpk2JJqTV54aaRhMahgQHRiWKBhQB5geEDohUES45MAagwGE0CAOgcnmGAIxBRFOWKK6vLtYKhMc5mywyqyg6LMhpaSfaJUdR/odgZ/4lLbkLrtFeqdZ228SmrNK0TJnP//////9Pbq7f3U3fV1wEqPWN8TRDwqpAsS3F4S5c7alE4wxvmfiwAZgVABAwAwwCQcTBzAVMVIB0wPQXTIADTPkcw4yCRBDESABMA4JIwlQMgMBUAghh4ABIxwS+QBAJIQFy1q7ygD8wDAPAcBYCQfQCAkFjDQMSwDAQDgwOhgOCQCPc1RqM2SM8wqFAwgBwwSAMwYAot2IABBoEiQNkQVGBYGlxQMAyaSt0oVjTuU1iz/KBITn8g6FsIi1huDX5FJZp4XjjbW2swLF3vhVI/CnTev5DbfsEfmNw5ocDL7EP//////6M3cf3su2vQN9ds8BHOoqHaUV4RBglvHMcJfyvNklCNJApW3ddiP40ASwRkA8AyBgJTAMA+JQOjCEAJMKIGYxGxzzCYHZPIdBgwqQ2TDkDGMCUGowdwGRwBwdAYQZFgAlmqoAgBEwAwAoHMBMCwAAOGAQBSOAchxaEQ6MPDY0MCjIAaMSgEMQQoRzFSFNeVIXy5ooYmFQKLA8OEZcoKBNMxHMLgEwACwqA04CEAPq00t9G011Mnadd13EfV7nyxdFy3JciH35rTzwuE/c+716H4rA0By3KXV6lFdlcJyPL7///////+/9r+S//0/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHjzc5Ax7i4OenF1A/3VweZOLkB/uLg6ObnUD/dXCag9M4kC9YiCADMpZq+7SEUE0U231HQAQ4AdS5iQFAKJQLDAhBjMLwRwwDQCzHSBCMAEfQwsk8jfyjCM0QLowIwlzCpAHHgHTACBLQDAYAMuAFgAxoCgKAEJSAIEcSAwKgH5QBIFQCygYmCwMYFEBiIpGPgEYxGBh0LmMhaagQp35imkjWZTTJi4tixYARKQ7mFw8CQaj4PBNAIHBghAcBtPaiXdMGANaSaiGqkmcU6dM476LzXk0m3ak5kDPRXl+m5z0uxkWqfkjksHTsPvS5LBZwWcGAqp///////9eSW3W9bFpWwqhfokLUnUuiznCjFYXA5g6xJw/RXwy0JJWUIcSbiqScyZBZ50R4AIwEwKDATATMEIFgwRQJwMGOYgoI5gkCwmKcuIaAB5xirgmmECBMYCwBphdALmBEAxCh4AUiAOYujIDQBBkAhIkwBAFDATAAAgAghAlMFQgIg0CwIGJQbDAEDQimBQcGEAEGNohmS2WGeJLA42wIGREBAXCsAgADAOLZhYFBIHBABA0CwwABCATtrDhwNI6tAYMw6beJIVsFmHV9u0j8RAM9TtwzSRGXwRGZ2TQ1Hbkup+tq22SxXqY9Yz5X2AG////////v9SU2a////qwejUEPjBkD0h1jxF1EYBZpIIqsNvFgABPYEAIGASCoYCIQBgfA1GDOBIIAOTB3CuMFwFkxgxLzkqc5MtAKEwzgJDDtBXMDcJwwJQDTBVAHLfI1sHQNRDGQCFJGAWAqYCoI4NAmFgVzJQgMIEUxQbjAYIBg1EiEZFJZicOECoOG5Ix6xCKLGQQMYPBY8MzAQYCwXMIABG5AowmE07yIFGAAGu2BBGEw4Gtzg9hEKrKzO9FY4/KKUUXG+zBo7FXea4zx23lh2K2pxpD6ts3lGzht3ToG617tvdrJH//////T6HYseLKeSGeuoi2eLagryfOWMLZTxPwhpPTTIOQ8tDzRwnjpjQATXVqJuOMQAIjgAIGAZMEIDMwBgITAeACMDsPwxBhOjAjAzN/JIswohjDDAAFMCwA8RAlmCYAkYEQAxgTADOm2ZsywSJ6tiDxgKADmBcBMYBgCxCCQKAAEB4BgMAogg4JzA4HzEcTjLkdTZSeDIYHAUGYUFQMBwwPB8wMCwwHB8wMB8wHAsVBseAkwFANl61kwUsE3wUByVsCQ06DD33VI6zSYQ3Vac7D+EpdGWRB3YEjkCSmhrw3S00cpoC3WXvXzBoqL1f//////9zWfdt/r3sQPd9dOkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB243uQH+4uDqZwdAP91cG0zc5gf3i4M8m51A/u1w6QL8JqjR0BPRx0GWW8d5dR/EETclEo4AQASsAkwFwCQqCaIQWzDFDBMAsH4wlhQzC7MPOA1OgxdBgBoN8wwhDDA1AtMC0ExRcBAPoCkZhUA1jAFANGgEVNhCAoYJABwYBcMElDMyCBAuDgISjKopMcCQGi8wm5DSdXAT1EImBTRAITMDAoiJRhYNGAwWnkWpBwYCwRZOmMrEXZoJQGCJ0WP32SwA1GhlMOs/chGKOLZdOJxOma7E31lMuqw1K4PoIu3WTNnYhLnFjnAqHVWI/////u+xC/KoKh65LShLZRMsMlBGHF2LS8zDmw1WRyhY6y3AXkWOsKAA8DUTKXGgEIERCLoCQBDLo+BgEAoA+YPgIpgQA9mFuHsYRghRhFhImFAP8cIpPxhPh6mLAGcYTgBZgdAXmAyAQLAghwAs2slL0LgdIzjwJxgGATmA6AWVQGTAOApMVARMEg8MPQ2MPwwLyGBAFDoCGAgxGMIenM6TgsKDBoEy85gQCQOA4mEswABcKgGEAeW6h8SA2G2UosoqM7ZgghdJ/0+GYuezidbzFBK/isbjuLMQZexpZAz+UY2YlUbyTR553vsTEWfSL3M1tX///////+WMdv6aVisLVMH+5nTc9MBhMFGjXA1RdBxjLYy6EvXc6cPsllqgxUC0tUYAhUYAikYlg8ZjBoYki+a5DAbhS0fs5KbWHQZqBWZMEyZBB8YXhqYGAeXSeCJhQBVLAUA6bgQCYCGkxbBkwpAEQhZdRicVv4ZWCAYaDEQTMRkIAAE+UYDSZLHgyAQGYRBaAgFDVFUvYge0orBaE0iBbDEjISXASHWeW6dqH2bsPoZQ5cpWFSnSShyKSN9pdYxp7Vio8ktnZZEX6ZfRxZ/bslg5iGS///////9S4l2OrdnpCOngmp9aU3oQsB3+rK+dJPzeBYEgJQFoA0i7FwUnlDbCGdOYOgaYJAcYVAKgaIg6MCyKEQaGgYvmla5HVmkGyZUmOrAGERuGD4QAkAjA8LSz5c5kzXDAQDIJLqBcATBYCjBIMSzBiRAWAoIPTKhAeLAQAj0oZy0mDWR6nKbAamGIAYDgYfC4gYQaBg6PBhbQmAFKEBrTE6kH0+1N4oqusx4IIbi8LWnnffFoyENE5L7uvEozMOA8VZ2oHisZmpibyjTlQBMUMpfh56r///////v7+vuvF+9iPYv8aAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAckNzmB/uLg7YcHMGPcXB3M3OQH+6uDpBvdAP91cJELMp8PoG5DCMsSRLeKEgABdZcjuoRLnEQBoAAcGAPRQBMwaQJjCHA+MDQSYwVgBjC4RmMIM3gxoAdDATB6MBQAoIGDJgOB0CAwFgBXXTuLgGAQAAUACCEBhIwDAeGAKAeKgPhguKwWYNLxjMTGNx0ChuYZCpionGVjkft3h9kcBBQCoZJh0YODJgUELMGAeIgqSgMdAi7kjc38XIhxQPdiSts2zdVdu2/Dk1YbbBHH1p8ZS+9qrN1pLDcJoobsyWjZ8+NPWoY5Lw4oL//////3f8M/2sWVf5F4+9AdWykVtPR1EX1yRLOTcEZBxScCPZEhYIVepFsM2qgrGhmSgOGACA2IgPTA6AMMEABQwCA4jB9E3MLIJExJCJzfeKFBwrZhggmGBoCsYGQOxgKAmGAEAGYM4B6EZKACjIPAPAIDQIBDBACgAALMCoAwwDAACIsGJh8AQ0YlGwQsyIGFB3M8I8z+wTgRSNqnIDE0SRZMX2hAEElsnpGh815MIvwmuhIZggKWABoJXml6po12dbIzaNy+FKVL0SRawzbF4nal7vSCCHSdmGoMgWrBVHRzUOxqERiZsZQ1zv//////63qavHE2Pu6l5Tmcm0cOTQlwDxfEZiJaLcKlDQjIEgigzgrkCUMs5eZKpryijAQcDeCQAzBOA3MFgEIwZQgzAoFtMA07g6hitzKSEbMBsKMwfQbQaECYBwHRgBA0g4AwtlEFbkBQOAgRhHgCDAzA6BgEgyBUDQWMNwFDAYDBCMFwZMFA6MXgtMYA7MfxEMaafBRgmChEhYCQUFZgSAAYAYABcDBEYGAGoWk+hKTcWgiAOACWzQ5rNguHqZn6/WL5wJE44xB2Ze6svfuBHqeLB74zS1cn4xuP7jDrz3YOqy4FDrrBv/////+urVn7ZxAoy9iRrUqSl7jI2t4xB0+uPal9O1WsqMnwKINQnxypgkJNnvXhAzMkJQ0AGvUmA3MBEDEwEAIjAnApMPYB0wmBITEQDeMAVpM2EC7zHFEgMMgBUxHwKjA1B5DhLhUBgEgCQlo6loYAKSACgoBQSBsDATjAvABDgiA4ODAwODEQHjBgDCYLzAsMgMDAFB4yeIsww3IzeIkyNFMwCAQwgAgwSBIlCsCgiqu0sHAqYDA2HAaYAgC7gcBKZiszcUi52jXm3OWq+jD6yZylfurZoXXjV7OduW6LcMxiS00hgW3fjb0P7uezBYZ///////1Gey3RS1VLPta/e26lnM0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHUzc5Ax7q4NiG11A/3VwdXN7kB/urg06bnUD/cXDddYaLKkXa8hMB1GDNEa4kXOPKqdHWQyQwAABzAOAzMBIAgwcQeTAhChMJIT4ChymV6EycZaCpgfhcmFcGGYIoJxgbAFGBEBmUADiEBV31rK2JqhgBJgKABFABgGAXMCYBAKgLmA4EkIcmAAHiIATCMKGHrwMVQ/NDiDNuKOMECBJQgAwqgkCwoBYKBwDC0CggVkEYEK1K5i0ywN2X/STUIlLN3gvsBZe7jlOcyR5H6d+PvLCbsuiczajktoKOUal81O2X4hx2X+xJB3V//////66i6QXFV2dpBl0RXNtTat4s5EWUXYByV0A0iD9E0RJCh0HQYoVB6BkRJnbS16MQfuBTABAXMAEAIKgJGAKCSIQFhUIQwqhBjFLO9Opkl8eQzMPYJ4wXQTDALBIHgsDAmAREgL2AvEghLwlyEeEZwCAuYAAEpgAgJGDgHAEFjBsBTA4Pi1phCFBhwI5hOJpk6IRnXOJhANYwKxioC4ECJrZECSk2lMSKwABQBAoEXTbKr6JOmyUMA5d0qzbnAk1MyOHLjd56Oz0VhNPQS1xKGJx2Ha0tkNNXh+vGbEovBJiP///////9mlSFVNy3ROLHIoqTlGDDT5kJIbBbwt8FcXRMxq7xP7x/zALALHgBzAnAgMEkCUwcAUTAGCsGgUzFWGdMLYoo2X2CCI/8wwAujBBAFMGIC0DBAGA4AgW0hZeRIgvExlLoKgGGA2AaYGIEYsDAYeBGGAkCBlMMwLFgJBowA4RTGIVjBQ+jj98jRogDAIBjAYBzAUCVQA4GjA8DTA8DwgDCzoUBBd48CIgBNmC5W1SKYoydzo0/bivdCZh6GEKxZ0zp15ulmJbXkUslkijMYjWcqnJRM1K163fHFqP//////J7pzSSHsyVc/MTKWl2vI9M2PHXjDpcoRkTI6SxFxJEEdEjZDvL0QZAC+a0EilYmOxowBACAYAqYHYDBgLgSCMEIwIQrDCoB3MABFY0g0MDBLCQCoHoMAACoBJgKgWg4AoLAHPMpm46YqISAwvsi+GADGAAAGDBuDg2CjKYhEDEAKETIIOMGhMwgOjyhWOYkgxgZzGAMMBhsw+CTC4NjhgQApXg4FgYKuFBwXAD7VkuEokzocjEkguBYflMj29TJ3PtRl4JZXpMYlLspZy1Up5qVRunj8qkNa+St////////Z4Qdd/UxG37CGr1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0M3uQH+6uDqJucwP91cGvje5Af3i4O/m9yA/3Vwwch3G6NIG0YDmS03ECJA1STu/Dpb5sAMAdKoAAFAxMBICYiB2MGcI8wOgFgID0YgpCxvPDvGS8B+Yi4BxgmALBAG4kBqYFYBIkArQo9q3igBrtNaBAAAOBKMAAC4wBQADAYJRAFJgwDoYCYJAgwUC4wrAsAgcYOIMa8TyZlAuYEiiKAAFQZMAAIDgFGg2LAJA4DCywOANsjH2LonPKztI9ls3D9uzL30k8m7E4k0+B3ilUYkF92IAh+nlFeOxeXy+vBf00xlZseAf//////9546g/mhd95hSrBGy68LgduFSZ10ZSzctApiPRmJoc4tgdBAy9D1l+XRAkoWAWFg4QANopGAkAeYI4NRhPgoDIPhhOAqGLcDIYOyVh0RHQmQgLqYXoYpgHggGB2BwDQAIiYDQEaYY4AJKiIAcwDgChYCYGAHhgM4GANRwMLQBCoKgEPhkHjCENDAAITDsZDEoHTChNjR+xAYRJgMM5gKCpgoEJg0ERhgAIVABCsiC5jRdhK6cZUr2yjWqlfdtrsZXfBbX5PF2mt1ZgtRrax6dxKs46FWXwBT6t42b9Seh+U18qCLiYQa///////rX9lQsEUXgcy7tZQ9j1DjbJl7hc4hcsbtZD1WN5mFyFwcVAzBD0AMTas4gkBMOKKBAJmBIAiQxpImAQomn4WGHRXG29FnUr0mPjRGDggGBQvGABKGGALAIKKaHCzjIC0qcwXB4wmAQIFAwnCoqgql2YuDgABpi0AgIHgIpAozmWwWY7Ex3ZSHP2+HHELhcwaGAwtoPCQ3Ye1xERIRCzFRZAEjw+ijMMw1chqJswfi1afB/nBhisz2YwlNaX2IYyoeS+9WnqaOy5qEJqSmdxf///////qr3HEjrbnIbsJOOmAk8gfLpEyjJh5YqosPBWnZM6DhOsuZGweZ2C4i0nSzFS2A18CwC6hZMACKgMmAUA6YBADpgrA4mBoCQYPQg5hBjJGQ2N6bYrhJiOi0GG4FiLBFmAYEUYHgA5gigHEQPbH1uvA1BDuBQDTApAnMDQCYiAMMBMAt1wsDgCDkwBEMwKB8wTAMw/CcwzHIzIE4zHN84iF8xtAgwYDAGAommYMAqAg1VhJAGMCALUwBwDlyGVwYqRA8gAR+FR4Xmsu6/UCyeCn5WMkypBwIYwj8qjFeHbkrpsaGllMejFPRzMcoItjNf//////1b1Wp82y0ILiB+KwhrBkY9xGhjCqnvEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAesNzgB/uLg7IbnID/dXB3k3OIH+2uDoxvcgP9tcJTmT5Gi/knVYEuCeMI/BXxYAR234S0Z2W1gsUAIAwGw0DwYDYdJhSBHmGMAiYWo0pjCIBmR2MeYlAipgWArmDMCmYTwFJgKAShUElSaLMEwKWtCAC22HgDTAdArAINgJBOAASaQYXAZjMKDwiEkCKhszQXzYM7OKmQ5ODzFIiMGAwwiKxYCJwmHQKYkAwCDQADqAUu0LCJ0nJaBK4BWYqrIX9gpUbsTtLCXwY0wx/H2gWQ0tl+ZdL4LyhuPy6Myd23QonJlEbkMHJe5+/R////933MWGpZxoFlqehpQJIvSAZwMETBZYFYwOA4DwiewaLjwGOLCBrflzehjlCLOBZAqBnCyE0jlEBQCGUp5NBKoCJgLgMIzGBYCaYEQUxiDgKGC4LoYpIcxgHEqG6ufwZIoNQUBLMLMHUwFgkzAtBSDAUC7yjReZFAv4zsQgERQwOwKFeGA+AEYPiK0N2AgNDBECgKG5gYOBgeBJjCMBsRrpqMSoMA4WFUwbAMIF4OCIEAUYDAgpeWRGQAFALDgYAwEqDKUtOkAMARzmHylNF+nFyg9/b9K5jXITKoZkD9wPIaSNWqCO0+WL8u/fkD70uFg+t3//////o2Nz+ImAF6ybXpJvpe5Uc/FEjkijim8oyLpydDFlWi3JwSymThugsYeibOGFiwAzRS6hgKAGGAIBkYIoAxgVAfGB0DmYb4MhhrigmHEHqZNishjEA4GBSEYYJgDJhQA7mB+BCYBwCQQANDK5mCGAKAWPADjoBJgFgOGAoCkVgGmBiCMYOCgoGAwOMFhoQSjsZAchRTOOgjhLI9WBHmQApZhQaZYAkIyYUFAUER0cotQocXBQkOUl6xdrNK5VHBkbeZYTjx0nFyJm4zcIpZBamIBiUpkdyHb2c/S0OF+dqfeFHVf/////7PaG3MNki4WEjD7xdQsNFXpLLPGiTmkh94fGvAYJniyUKXBRhBDtP8V0PsGiSUjA8AhzspzJj4I0FAAoBAWXWYIQApgLgUmCQAiYZwY4OCtMSszkw7kwDY2GEMYYNswpQLzAGBJMDUC0BBsuEGAtphLYWyoqh3DgHzAIAnIADzAqBDBIGRkA4NDBYdzLgE0MmMIPTDkoyt8Mu6TCaww6WNuMEJQXFSFHSdCo6PGgKBjFRESAy9qJRfZWJBI4SYKpH3i2VRxlOOurRyh5H5Y7DViAn+gp0Z2KzkZl07hNXI00+GLURk1a1gH2aPv/////tanabxG4uxJmonaA6EMlmGlJG3Okw3Edcs4KAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHRTe4gf7i4Orm5yBj3FwaBNzkB/eLg74bnEGPcXDDcp0JD7AH5DEIHeY5bDHUwn3ija0VN1BgIBMYBYFACAIMAAIowHQQjBkBLMaMNYwqgezd6PxME8WMxBRQzCiAiMEMEcwCAYjAHAfHgBWoIElCg4BZpadalZgJgIGAiCQYA4BA0OA4SmHhSYHA4UGRgMzGRAMYpHBn0GmTvIYmQAQTzAwgQpCAmtpG9BKOgOBQaAZ4eDZCA0GGssrVrTHceB3ldmOrp+G+tPXUx2X8llHQ3pujm5VGc8407cVo4znN2L+r+H//////7cZO0tLjnPAY9SygUCcyqatNqcsULR6zBYUNmU2Qjp6oEZ1Lkx2njxV8qXv4XUTpWQ2RfjKpIh6YCAABgOgEGBMBOLAbGCyB+YQglxhLD1mJSAMd6RDxjkA7GAMHYYUoQhgXg3mBuC2YCoFBfoZAFngEACMgNJbCQEpCAWYBgCYCBNBIDxgMMmBAIGGEHAoChgwyKjHQyMvjQxIfj+rFMkKsyKKTHAvLwQowaBCAADwiEQCBAQDgUYQBZQClgHFSXQSK5UxWI2Vw6rszsQgqkhaOTF4DpaOSQ3Ypp7HlbHW6tq5G6r/S+U43k//////+zvYYRjxOLPGdN40V3PBYZU6ZU1dLbp99oH91NGCWtppiksB22svG8rKtpR971yo4GCYhGD4RhAMmKA/GOJEmLB7GVcjnbicmqZfGEowGMgTmAgGFAXAYGCgL2YMTonZMAAHFAEVnMCQZMPACKAtGhaFgqksHCsIPoUHgGFRikgmXAmfJIZnYNFwTEAXMBBF4gKDwICUbkriYJq/SuiSTSjtG3RXz+OVAUYlcQZNYp5Hiz2IQFF7Mkq1ZTnGI1ldz5dp78cy1Ys8sNPf//////+gvoQ9RwczzJ5AXUUFzKErQNlHGQ5sNoQtWMMRtS1WyJxkQlWOqg+idTXkplWuk9K5EqDADAJMA4CsBBiAIHIwTQNjCxEhMCMmAyGFIzmXgjMfsO4wxwZygKUwVwQTBBBCBwApgPACruEQCJQAQqBlgVAMGAMAcDMrcgHMNBsxGFgoaTB4GMVigdEgKK5kAsmuQEe6o5lsWmCAIYeCgCFhhcIGDhOWTDAOiiFgsVQqNBRCbK1zqbIHPEq8aAjnS1sb7OQ1uP0TAIkpk9cXxjdFAMojVJD9PKrM1AdpwpPXxlsfmr4L+r6/6f9N//RqfyaNrlEWsopS2AmpAYNsKgAKXMci8mwiSSkgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABiI3OYH+2uDnJvcgY91cHGze4gf7q4O8m5xA/21wwp2c/T3Owuw+ThbDucWb1XWpph/hkABIUkAQBgAZgkAqGAqCQYPQCJg4gomDaSQbsItZhpgYGASCgGBjGB0AGCgRzAOAlIgAGavy7KVaibYHhC4A5gHAEhgAAcEhYGMHKBooqkJcCgwwRFNfEDwss4svNQHjFQZEKOLAhALXaYqkJBKajL3oqRp0ILkDv09LNv1IcaKV6hDQLdJeu38+0u6t2vWt8mb0/9qrqrxn//////+vXbRYJXE2/QY03Oe3uYe3hz6WEyRlzNEvoAehec8SCdRqilsscV+QaAEYAIFpgTAhGAiCGQgXmAOCYYNAOxlGhuGYMhoeyZqRkbj4mG6HeYGQJBgrgjAIAswCASYgmMoa5wAADLtJeKlMAIA4wAgB24EoCmBgFFAohwrpHo3mC4BmDICGCwtGG9yGFIbGKQPmHgdiwGg4LBUEmfmAgHgEC0wggOENwqAzwo+r9dAwCAB4G0ZnGY/DjO5XDlynkkOsTf2NU0ak0klN6amb16XXa9h2rMP8l1mMad6P//////tL+LsQuSuHLI1axqUgBAdPJcpxES7ng/djYEJFtIynDzIynUYULSlStYonWYK3EeAfHQAwUD+YBINZgCgxmFEGiYTQq5jWNMGZAWwYNARpgRAPGGCDMYMQCo0EsAgKy3TWHuQyBQBjzgEA9cBEDQYB4EpgLAVg4KAEBJhUGwQBxgWEIUBIxFA4wtDQGBkMwUYICyYNB6gJTzeO2RBoga9iPDda5KA0oaU/j0xqTL2f2EuDG4flEFXnEhh5aKb7KKGrQQ1G7va8ooecpoJjsOZZ5X+oT/////6OnRUhjSbIASSKQqHjpo5PioTHhIJZcwLBxppyjQneVA0wY6gJ8hwGcRwHKwAxR9khiOcrwSACSsRo9Y5KAeDAHAMCyYPgVpg+AomD8HyYmY7ZgEO8HiY5sYbwTRjYhdmKoA4YJIAZgbAOmCOBA2Z/hwAVLwtkCAAAYAKYAQGw6AQOghmAwAGITQeMiy4kPApBMyADEwEw1MNleDYrAwnLMvIDCBoxkXEA+YaAgUEMJDhIRCA8ti0lfrzseZ+3zNnMaXADFaWQtkwn4+s2hWZK6OL5Z9jnyaQ1Ltyks5TGcogWU3MqVLH+qr/93/7P6Ou8q0DFljQWUITjJJ5YJCzkHAs5IfebPkwqkUHvEQXFyZsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAa5N7iB/uLg3UbnID/dXB1g2uAH+6uDq5tcQY91cJWQrjKEPCUoUnhQrsw4bE2xxprDa31AyAAsIAQMEAAUBBUGAQDQYkYP4OFiMG85w0uAfzHOC/MBgKYwWwhzASAXFQTBwBt1Y60V/QqAAlEOAGgoAEQANO0nxAqe5hUHBUOCoQMRgQHFsxSBDTImPMmczoETIgABQWHhOHAQBAkvqtMCgV0QqBFDmYsDaZEV5KarNUDlMgdnOkk1iannxsxqYxm7NmvjLZ/OplLq8znYu0s7LdWvd///////7xRqXE1R/SKKWQUpM0LIAda7yawTA7xrGKUK5jEnNAgo2iEnqM8TB0ctK6DQV8vO87gmA2AeIwEzAcAFMAMDUwMAbzCEAqMYQcQLCTnU40uYWQWZhHBQGBsCWEAgGAGBMYAIDMbeSHE6x4C1FELgTgAAIssYGYBwkBEMgKBQqAANCwRGG4OmDoNGEYUmCYPmCZqmYMkmhIUGIITBgDAoEQSGa10B1OYBgE8gKBhsCyVeFxET2coTn7j0jpW7NwfekjLaOlLXkpYpZpbmcrmaS52tas4Vr+M1nO2q9r///////9MiYUwXVLNIKSKL7XADFr6k6FqpQRJ1dGQzm4Rg7hRiEH+TwkCw0XSHZ4XtTCFgATAAAwXQPAfmCCDsYSgWhgwCLmGUEUBBRjQKAUEjcTBdDMDgiDCNAPAAAK3BYEKkdsLACgIA8aAEDgAYNBIGhgQgShwBxgsEIMB0YA8FB4YEAMYBAOYFjgYHh6Y6FsZ75iY2jsZNgUDg8CwTCoBGDQFQ8iK/YkAxUA1RxiXVrPsrIwGrGIy5MMQ7dt00AxCHZ9sepZDlW7rOfuV6ampJfnUyg2OUktsuMi93/////9PBpomOKc5YDU4iKhgy+aIrNuNAVAYNlFCgmabB55Gw8QbAV12ZtVdfD2KaFZWvQ/pTtXLyShBouI7asskAIDhgZgoGC6EQYWQMhhJBNGD8MMIj6T8bMzM/kLgwFgQzARBDEYMpgIADmAGAmJAHRJOSHSYCNuJgDAHhABBgKADmAKBmYGYEAGFNGEwMEEwHAMOHgwkCJtjBwRTFotTMawjR0IjDcYTAIGTBUNEEQGBdgAWAoLgAOAWBgGoEM1zPc8y82FL+X+8UNuFSQ1duS6FsCpLdDGotE9243L7Xz0ri/dW6fUurcthL7v///q/9lyupxhRB1QuFjbjyWBA044lh54sg6HpJSkmJJhZNZYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAGazY4gf3i4Nmm9yAz3VweYbzeB/YNyyqbHMD/cXDDyISIvwi6hTJLmZvhpH1WIxtR93hQAgSAYGDIFD4Yii6YxiqYGGOYzFUaSi6dA9+Y1k8ZaBWYpkMIwnMAgPJgxGgPVvZmpiPACyJf4KAksAYRAIlSIREkaOFYOFxeIGgcChUBEIzQfjtzsMwFYOUhhUOgAFkwEJgA1SAxkDNycZQxPBTpsl1k8TgGKyKUw/K+W4ZjtqUySMU3Lur9yVTtfKrhcwv/bwu2qZj///////VTRZrGDXRrRMQyQ8kLseuQISI4nY+xyTbgitKSMlcEBOJCwSQkVCcSi4xdZTF0OEZfgZAMIADDAKBGMAID0wFAdR4F8wWwzjClHtMC1WY0DnoDEdApMLYLkwxAVzBVABAwFAFAWgtpbNn0FADnUBwB7SSEA9jRgHABmEYFkwfGDAFBQFDAcB0ZTCcFTDYCjCQ6DbWIzA8bzCUCAEAJbtQ4wCBZeTztcBwExhJCcblH2R2XHUBuVZuALdrOU33+djUM2qaP1c5NWnt65YrW52mzuSa5bt3/u0f/////71ofS05sRtSJBaitdNL0hM6WF5JSS1zSlo62BaRbhvG6XZHF3HOgh8HsYg+maJxKYJkBAIGDQFmHofmTwemGZmGNwcGNY4mW8oHa8ZGLIVmFYpGJIBmKYkGGojGCYRmAoBpWkIBPEiIhyFgOAQJF0jDgTTAQMkw1LjBICDBgNjBgADAgKDCgHTFETjFc9DS9ZihIDBoCiYDQoALFiECGGu0meCAEizUwqiAQN6jQEelUSgThTMyoMkXiqQ8gJXJcc0rkQHSZHC8Q4gJMmyZBCGF0opF0mkyufRddv///7f//+v//+vV/+tTL0mSavuqynSQY0PgPxkvA+2u0QueOTfYy+6iiMCmplqvPuVrxlypy8pElgyTjO1YJJAqna1GYMAkwVAFEABsHmAWA4YAoLxg8A2GCODqYDgXRjtiKHQcJGZQgR5g7hRGAEEgHAEGASAQKAQjwEjzsAXY1Yv4yEQAFpSqohQCgxODwwSJvmDAEEDEQAsxKIiAYmSUEf+SYKxa7iYOmFBKhwEAAet/ywBWIK1NkgdX66Zc3VuL6vdFreU3AEfiU1GHWqUFS/U52Vcxlt6l1hXzwwoPpqcFP//////7uMxSndSJa9r+lTqE+pDEVG7xYyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGyTY4gf7a4OcGpxA/3Vwc9NzgB/uLgz2a3ID/cXDMZqNg9ArieC0taGNZNmv0ijrXGfPMKgAFpjAbAwMEwC4wKwCjAKBBMAIBgZB8MGMZU2zheDBwDaMIMFcwSgVzA/ApBwPQIAlMAUABs67LbImukIAohAFMAsAkAgFGAMAIJAQCIXILTiIJL+AUEAAiaiHmA24NXDG0cLgIADwMKMvEgAOA1L0AAqBDoCxx+Vyw+tR2YYp5XeptaqR+ei8eqVpRdz7hjR3sM7uFiS4Y2buU5oQO/////9H3XXjbITQhrihFIALvuFjAwBBqNMHdgdlRCy8/eQsM4gxECaYxA5iFpIlapCvaVUiynZeGVJYMgRFAIF5gRAojQFhhzAjGCOJwYjanZ2ttqmMeCwYAYF4QDWYBYDxgWgOmAEB6YHYBbeuwhkioCgBDAWAWMAQA0IA/S6LNGEYEDoWmDwIFAIAogigITDcHTBwcTEU6TDy1jLkmDCEWzCQCFCyAGS5YOAcWBEhAAQgM+g6B6SbB1fssSeVTfeVN1wiz3yCtH2HTzhupcj0/dlNiar1M6Cvc7nzXN0wAuS///1/V+/1rusWq+KCsug7ELXlGDbl2kQm1LyCgCgrMmEGjzB6EDhQL5YVSfKLA0y6HCV5JW4PrJoTzQ23FA4gAEQHGAAAcYEoCRgWgOmDCA6SBgGDkBSYJQupkQpkmEyECYX4DxglgvGCUEUVgYAoB9JtXKayD5AAOFAAZ8oA/MAgC8wCAGSYA0mDBhcKGCgMYGC5gUBGBQkKBoxgBjHAuOQWQw+SzJQiFAgq0RhdTMUBbQkAQkAC96mrM3dm3elT3Ow8OGcbkFNFsqWZdmlqZ2M9/Kp2l1zG3Vt8+M6zu0l69+7/R//0/+Sqyg9q1LFgiSFBCkcRSChUw0MgSEVkwGBxOCZoYBjQBDgBqJJA4hyh8VT2J+tl4OodrkJLA8dU1oU+ocTjIgCDAqASMDMCgMA8MAEB0wYAHDDhENMVwfw3GVejGJCIMBoHUwegfSEEwSBHMBwAAMAKgCgj6wYjACGQBi2KlrYhUANOIQBUIDxhQDGEAMKgwGiFBkRD8569AMmQ4zlQBmBwKRCERhUrBa3AsAnYS3RPHQA9St0WgR61RyOEwxKH7w3R7mJulh+cltTmcz3Hd/tbeNLY5S53wUPf//////+Y6x59LVC2BHKdrIpji2gwHSD3sefXQtYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABiA3OIGe0uDnJucAP9xcGQjU4gZ7i4Num5xA/3VwnKkkaRKHNhajKw2gJ+pBcoHSSUZSYBwExQDaFgLzAjCDFgVjAEDeMYYYg1IS/DHtALEQMJgIhHggBADAiOWlpIETGiI0tGWU8w4AUYAoAaVgOeFkzLAzHk0NjABiZsZ2gOdATJM8bNmRLzGPJMmDDRWEZSW8Fgyh7jrhiSfT4vehhAsP40tJDdJy5agK7P26XG/hb19beeWsNSa1rU/U5Wx///////4us/EYupAq6pMYhZlZa48ihhBC2KYbJmnACarCKpVC5F7HAEbGQyCuq4W8lKgTgPGmgpQlajywwwJALgMCSYHoI5g0hdgUDww8hfzHvSSNjQl0WdtMQMRgwxwciILpp4UAfGQAQcAGgBUdJQB0QwMAMAADAKB6YFAAQsAWBAsYMDI0UDFoHLhCMBlyDF4MNED4yveDHihMQAQQhYEAJEMqAQiARg0Elxw4ABwETFSfXilayZyFUIs12DY1H7MQlkelE2odnEcr9zV3X8wz5rWc/vG7Q6sX9/+j35j9n/6Xx9TjrVoSxoFcKBUUyZZpcUGA0QYaJMEQqKHyJmMCQLLI2uMnCOUEgQUMnAkLhAA5xWg2DE8WZNlis2/I6BAAgG5QYFwIRgWgAGBALYYeJoRoLDbGGeBSYKYLBgnAImBgAmCgATAPANSZhajLL3RiwsAEPAHA4AthhQAuHAklAKX4OFrakIELhAAXoGGYt6YoCAKPJgABAADrwCgDSMd6Tu4uCBWnsRgZ1txh3IGpaSYjud2VX6sai12/YxuZct4ZYZ5Xa3LuV3gqBv//////+3xDFhgoTAR6ISMiLMSgKPLKFgGigRGI90zDJUapXosmE6OlGBhE/IQW4lah7MIowxEZ9YZLhg4B8GgPBQEswMAKTAHEHMLMF8wVhjTd8JRMIwFkwuArDAzBBMA4AwwKAPndDAH2wLGTpFQAS75EAUoYtYwQgMAYAQCAGVtMBwcMGQdTrHgvBgKmEQeGFI9GuU2GKo7IuDALl3jAADS9BgEAwYBDrJvS8vAgfRPajw7cjhDQaCw/ErkGEpv9aJXrVZmWV8q1SYwqVu/u9lhN8tXuXyiff//////XcTFgYLgjWGikH1OW21Afc+RGpItFkBMMPkytyy0OEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdKhTeB/Wty0uaXED+8XB2CNN4H9a3LQRqcQP9tcIS6en0O+PzpVCiTg+hYrieNEbRma2ULASAxh8Bxg0LJg+LBjSRhjmX5ngJRvNLJm2FRkGK5iMRBg6AQQCwkH6AZt3yUkIQAEgBCgJCwfmCICokgUBxYBCIJlAzAQEgaAJgEAAcCQ4GZhMBhsIFwsAZhGHhg0BJYBtxSAGFM2qx9uy0ISGwAigrxrHOFUOBF0y4OExLDYegwpKCFF4TQ+PYhHU2JNmWZLNETRj5oQ2dnZv/f////////1//1/s3Wu13amy10VJ0p1lprTRTUp3dk3qXdeipJaqkUF0ULUk556wFxhRK9EQiIcJA/WVVCGibmIRpWKOC/C7WwpxowyFb6twCAcwqB0xFBwRkyYnCiYvmqabYGcagQbciODAHFROFgRMKBRLZM8gRakCpOrPZ8YFAeCASMGAAJAEKgDBILEAaMUhYWExhIGJ+GGwsZPOBkGrmnhKZbFZhwSlQQlYJKgBLqiIIgYADwCLqTSWsZfZnTSmbtRlMgoqaHJXfs4YwZVs0uU7u3Zoq9ru8eXq9F26HwXMN936v/u/+vav20KabaKlgXLoHuDgCGh1qWl43j0EVn5s8RUUallXUUKEGrFhJyHsah3HOQUMxIj3ZouSosA25gEARhIF5hgJAMGYwaWYxRJM0Fxk4jBIzbHwx4AgxPFkw7BURAiSAW5bWHaeNp4QBqAweDJcphAAoCCAwdCMweAQOBcwcBgMFIwjAIwhAYmBcw2LE0PSgw6EUxVFFpTcFV0u3/R0RwTIIgPQRgewgAKeS5LCJHuSK0R4F4zLUyUHcIM5k6JcOHCUSRdJEzQJhqbOdume6v9f/////////a/9qm92X0Op1pLUpNd106CaC1utJnXMWspFlKtWizsxopFKxymaLdknrUyKVBJ6NzyUGHZTyhQ8KcUatYAwDSgJRx2jqHNkgeVqYN2MAwBYwCwDzAGAdHQSAUEIYdQQJgDDSm0iMiYLQRxg1BIGByEKJA+GAQAoYBYBSAtYJpadDwAUAJGowBgCy0q7hCAMHBhhYWCQpIgGFjxmbBYknjw2cGtGQrRMVmEjAKHV5KUw8mI0VnS5L0la47DsMtfF+N5QzDlWHt1aTOetcvc1V3Z3nvet1+ayu7qKIf+n/9fT9n+3bLucB2C4SYFUyRleRFjhd3YwMqKDAuYC4UEpEVPgNTgMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGSGs4AfxrcsXGpxA/u1wXfMDiBnNpg0AbHED/cXDMqKZlSkEG1MxvvXRN1On4ELhsnrJgEw6JiaY3HZhg1GJBAZHFJQXDyOIChxMaIIxOhDCZUMNA9Y6sTdY24iUrKi0yUDB1fBgdLipyLJCoAMCBBAgYgEpiAGmCVEY914AI5hkOGAAA+ydDSGtogDAEV0uVpYVgRcXxpHQcRJCfkIml00XJczNhLiRdJnc1LSCyBgyzUyWgYMaqRsv//////////////qZVluurQrOYK9FxMnW/BpmXA/b/TH3/+74TLRuDoR4vQtmrElz0emkqxAUYJO7ORPZsbJn5h5+EJZZYYFcChIyYxTF0wcGcy8DUyevQxaMgxhGUWAkxxCMIBswFA0wNABTNkb9K5VOvdWcYAlp4EAwaCJAQqUw4BWinUkcYcMgwQAQ6bGknFMKswOCQYDkxCTAgVA3OW45rzvTFH8bjKNqAxSG4rRVb+VaW08vcWWY67fy19zXOfzGp+PNWA+at//////Z1+A1BYIqki7DyAXedF1OKwmWJAIPAEiNeou8u1q1EWh9ouHcZOFxbQF5OBMtw/TOC3WCqJ54iWAQjOYADpgAKmFByYOKZicaGCWAb8MJvTlmoDQaHP5j8NmLAQqYwaAKV22wP/AK11VmJIuoakQYnwpMRAghCAUcKKhcOMdKzN2Uz5APXIAQFiIQC4ALAqqjKHifuCUyUTXigK9nHOz8svY3X55bm6LF44GyuZfhVxsT2gSLBciPB03///////yGJhRdbA+ZAhaqosZsCAaMPAjQKsuKGGklkROgeSjSwvpwQ9UimH6fhol/R7MMZo9I6lE6EZTdEQCgqBiYBoA5gdgnmByEeYJIBBhuAMGBSB2a0AXhkBhUGAuE0YPoBwcE8CgFjABAFhmsgRd0dAGYa6YOAVMA4AwLAAIViEIBcA04NA5gACFYEBIARQMbkI15jzPx2SRMHAkOB5gMCiMFJTNgQdX6xCAH9i8tznHmpYp3KZpabGm+VPpUw7lczy5b73HfzuP9pPyu8PGtv/23f3f//e5tFAgYC9zVh5xjfSLnDcMrSaJ1jkkJAI1LJuMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABx+PN4H9a3LycMcAP8puWlY+4Af1TcPAQJwA/zW5w+oXKEb5wFhQ03FGTpDlkq36LeRd4nzR7BwamHQRGD5GmHwfmepeC3XnQh3GQoTGN4LmLAGAIYTCgDCgBIHW9AcPEoCoGmBQCoypCr3awPAgFwDMCQcHQfMAQTMAQeMFAjMEA7MAAvMmm4MPgcHAAAwuJmq3l+hoD8lvuOkU0sOeO4donwWIl4vjsHsmgPAvlMrNycPASpMxRMVInDyB1AxWipJjdTIKv/f/////////+v/Xt7f1bWSQQbZB1OtJGtS00UXWqy0lWZS2ZSCKRxnW1aKkknO11IIJKpMqrsktZq4bIuUPUq8YJAT5ICpCLBMRSQBf4l0kumZGAOBAYFgDRgLASmBGBuYKgPZgbgKGDAD4YqgpJutj2goiowLAqzA5BPMB8C8GAaT5bBg0OrRSBQlmAsASEALgYDEwFQACICkRgJjQAhgLAKGACAAYAYEpgIgBGAIBCYFQQIUAxEAhpgnhArkBICRgCANMNDgBiAAFarKVztu0IQZMAVA4FYTgDxcWJBMF7jpQnEwL8KUYjxTzDkOJTUNmzT1NY1nM9////+n3+v1v2v//dLb1+m010vpdLq9E2U592qy1c2iURU1dVOOoiIyNsVMJnbS2YB3k/yXzqVqgMpIELNxPEsUkJIoY867OvWFwOMGhBBQymB4XmAoGmEIIg4ogFHB1Zdpq2OQwH5goJBgGGBgwCYYBa/I/FmuKDNfL1l9CziE4DAmoCTA2YCAgYIgStQCAUIgVAweg4CjN8UzGoIjBcBkArF39BgFvezpKlWCXsAChCyIYA4AeMgrjQgPEooTjdRFKIoT1IDjjFITmOPq7uciEh23////////////f/9EVn6HmH01ejqyKxinHPS56nPVVrRzUNZVOmnzGz10srKlZyGTkz0QttpRBVkjJWojDJ8bSFqMoFQbEea5Bg8AIBQGjAzAgMGcA4qgVmBaCOOBAGHeIwYs6MxlrmLGF2J+YPoXBgmgWGBYBMDAVzAGAEay4cHTDkEQBYEAJMAcBAwRQFDApAIbkHAFF5RCAURAXBACydRgEgGGAaB+YEAF5iODDGAOAcDgImFo/qyKahYAFKtBMgIV2j0NYjQckXhJwsDQYAnGhaNxJJmZUXEBvJp4vJmCBeSUmtJNJNFWZuuu3/9//V/v///9f2/99TN77X9lMzbp2Z6a1H1rMnVUpNaTqdktSqmSUpauo7Qvq87WzaG4CFVPMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcfiTcB/WtywSYHEDPbTBsqLt4H9a3LH5scQM9xcLyxYBhlwUEiytMZoC+hrzTBYA2IggBRGBCdac4OIkxxEwxWGMyvS81gFkyFpQ0JCIyAFQxSEkxaH8iC4wJAV7I2rDLmQioBNfQSIxOMYKgmCgbXkHA0YDAEYBAGAgmMGQSIAoBhwGL43mIQhmBQIhgmCQEt4tZVFP/Bpz9RoT0SIxhPQWYKYUi+o8SI1Gxasnmgwo5h2F42NFIl43UXHVRoJHHMbM/////9Xr//6///v71VrfVQquitt2utGtJTJzFlO6qlHS4nftbSNVobTVdNU2OWUo1d0z59N0EVpHXOrMbRZa5cQQPDyJYVtCBedaJsceFrUsplxLPKgCIkC8YFoDIJAAEYHxg8hWGBqUoddQXJiVg1GE2FmYKYH5gggvCQA4FAEGgKXGcNtnUSVAwmkgEIpjogIR4WMQgbSxBoQj6nuYAMg0hDgk+E/NoEDAxJBdR20oSIwBojmQc+UHqb4OPGGoxezB0Yk87S0tfPdNHrdyl3jv9YXNixN5RK3f/////+jS/aEm6lFWn1knrRMkSRwsXCcoSc6EgE0sXLNF2TixXUCz+iTgr5eI5kEiHpajMe2SuymUWcMBAbMHgcMLwaMJACMZxDATaGsciGfHNmy5RGLgdGF4KAYgTC8GFhn/a2/eSWEFKgRKR/KAHMBwFEQLl91NAcKxABhgUBBEHhgaA5gQIAiGIyAH8wWCQGAFFRkA0UwUAqe8NMwcR6wvolhKj0EME4ITl08YmBokgYGx4sRWovpHU0U3TvTWmindJv///6v//////+v9ur+prNZG6r51J2Wmg9FncxWpk0XZ1WpuivXWpJ0U6Ck9B0UlKbWy0GSZBjmksmpq9QsB0LxKK4BNikUDKShuAYUg6AgIEbjA3AgFADjBsBGMCkBQwEgNTDxHRMQVBEwowaDAiAABQaZgCgviMBgu5BLL4g2NLpOtvVMgSAURAjDoAwJAq1zBQEAwABQbAAHMJgAwWJTBQZNUyMzOKRI8hgxRgWWy1n7KVg4orImbEnkjMbkFWJwdbn6tixcyuz+Frmt8/udbHf81a/Xd8zztN/93/+hX/svRXctw6mYWRQbhsYSQWGmFqRRWde1iB4u1AxIpQH3pSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHWJA3Af5rcMZGhwAzvFwa+jDcB/Wty8vHm4D+tbn5o4vRHCRnmapfUymhsK0+HvW45YMAEHADjAHASBwBwAAUMFAGZSRgNB1FQZI0ClTjGfCDMAUJAwLwLAKBOYCwDJfGddRTWkAwASKLIUJpgHgEhcCYwHQCmjEoDwjAmTQQWKoDRgJgGkACYKAyMDYH0gAvMEwCdIF/gMAcnkkogkVUlLRnCMAipGNx2Anw5SGYGpiMkoGpkfJpauZHEkUkEGSonkaNlsZrdP//3/V1f//9X9f/19mXX7qbWujqnKkE1JNovSdFa1oI00WRTZU4ZMaOyFF0U1LPdaHW6na7sm2iukyTpnXs6FM31e1ETgBC0NwPHxgevHSrxuvzgz4GgEYUgmiuYNBWYvDmBRbEY+mTEBnFurGd5YApcAoFhhUCJgQCIXBMwCACstRfqqiTTZZUgAQvIhFCACQg1RQSAogAq5TD4KMFCkzgazODMOKkICBshAiu0jYPLos5iCa6sDIH2mVBY5D7utXppbL5LflNHWldNT5bw13WsrnLOeX7wx7cAxYMf/96v//+6xNa6RK96kBE5KD50JCyGGp1poPxaLhwG3C54KLAJVYQTecFu1QpFW5kjfnq5JI74p6B+uVXaqi2o8YCgUYOBQYCCsYqksYxG+Y+ncYYQSb76SYqC0ZCgmYPjIiuYNAsNAkr6Xuustni5ioBbokwQkwVunAY0BoJCMlApOsQAROkgCCIpDBBCzGoFhYIluKNppgoHi5jLXRcGSK2gjKIn4jYmIwpcGFmhfJU1MiSRNzp10zhocWkpSOxmcTbTVpO3//X///X/9P/////+y0dbb0jBS1JovTWyJspjyS0UnOILsit3OpopUU6c+nRSsrekpJulPop2RtNbNN6rKfzSURrC5sJvJY1SFyCcAVFhZAxVsICBIMJEwWAYwGHwx3EsxrK0xXEM4RSYzFBAz0A4zOI0w8K0wgDkwnBEwmCsHAyydMagC4CMiUdDgbSSDAIMAgAMFwTg0ZA5eZgqCwCBswoAIxEDQwjDI1gUQxUDoAgSYGAqDgJHgJDAkQCP2j4jgvhwA3CeG3FiJgkQTItkqOwqUeJhJmpjm5dUcdAvzZk0mueMElIrvv/t/+23V71/61/r/XVu33Vv6bevSSdB06T002Zap10aCCD2UaZokitJqzA3UcTTWks6ykkHoIukdVRrSczW66ClILqc8uIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABy2KNwH+U3LuMObgP61uXH4y3Af5rcuxQ5uA/qm53IyvlWLasPR/k5OmZC8q6Vp9PmVACVEDAAAXCADzAHACMBQDIwdwLzAeCJMWAPg0DS7DBFA6BgYpgYgijwNhQCoLAKMCuPY5atycAjAJWIYCoArdiEBpphgFADigAKwqYrHmRGAWAyYAoMRghBOmFODOIgFiwAIYCICCSCXBCACodDzKXBfMBcLoAmcSA3hTCeQFRmQk5hw4qoPx5PPyV1PR2LHmkaPMOb+83T/X9U///X////6dP0sZc/U1VpOOdp5Q4y6m2lp6mTGOdC5y0RWOY81UuWse5c453Ocq5hEaXJY0I+4qnD9KNSHaVaiCraFGdcMgKjLzMNZGoGYbgaChpMdABBhhmB4CGHpKmVI4nKBDHPxKmVw+GQRVGAoAJ8EIBvU4T+MoYGXRYQGAeBg5DBIMEARLRkQOGCACEQOlQMzBgQTBADQYG5hOZ5oaoZjkG5hoBwjARVokACDijDqsTQmufBYKkAaJkeEYDkBc0ywgmhIEY+fNi03NygmpNRcOUlOuiitFaTHElO6Skb/9/9tm7p+v3//fv+6v1auyfWn3vdBdSE7QdFNbVrdaCa0jVbsp0FpKQWtFRmtboLmKTsmxy6S0j6adRmAMQoUZHK9X2OJdI1ninugVPQkJVmArnJXpIGVlzgUAUqQwEgJzAICBMLAL0wGg1zCTCSNkILgxKhDzCdAZMIID4eAIMBQBUKgGpBQ9CmrIhJystaGh6W4AQD6h8OF6ysAcAAEGAIAATAIiAD8wNAEzALE8Dh7xICgKgDDoBIVABGQAnIaOqZxHogIcobzF5RaHG5MNCOSp8xTNjAcZeRSUkpjIyTPqWo+vVSdFJa/V///2/////b//3/+966SDpKVWmpBNN1LXuo+ztTUzak6DPTdb0U1l1Mxc2QUgizJu1OmmeZFLdTTNfah0j9YVokrAWBIolHqsfpCh9FsUrZFCAuBgJAQwVDcwiDkFAkYRAkABDKpSG7Tmmq0HmXKdmS6JmAAogIwBgSBUE10rSZGiiqWnAAApWgYMx4nC/4oApgMBYFCYFASYNhIKAKPAQXCMPAiMTTZMlxDEgoAwXmAABGB4EF5iAAQsAK93kYCg+FkPQmiWQhUAjFgkMMGxhQRJIeIJ1HolkEqTFlMm2Otyh++3v3Vafs23/VP0XeqqvZVfpfr7dfuc/ZkZTptj2Ux6nKepOYQsafmqcp6zzFZTjVOU5rnHnKUV2POV5CehMl1tKs+kKhQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaCkDcB/Dtw5rEm8D+tbll6DNwH9O3LQkYcAP61ucr67bGNiJkYQ9TQ5mULY+Ur8qYyJTUEAAUBINCphkzGOTaIAibcVJkPen/LWQsA1WBAcvDA4bMIgB2n+Z+6DYVtOqXNVsEQDJAKNBVoKXIhANtENKgRDUwIaDLRsNDJgzQch4uq4V0EBJvRoFLnHQCvJitEHiOAUaIgCwmJi4rEgeUqQYXkTXR0Ioehi9XnKz//////7Ztv///329evd/be5jXY806rkjiZWaxjJOZTVK10ZbqcrsZW0+dY0xmYqkycQMQ0w9mPOPNIMcWjikXw2siHCOPVMYreSg6QrhVpchjHEhUVkxUJBgKD5gQHAMBkQgAMhuY9EQZlCQfTmEYcgeYmmqYTDOKBiYXAIBAUT3eyZYK6KMQiAgtSAglMFgTTKBQflQBi7phACRgMBYiAQwLAoYAEw3Agx2LAxbAYiGUoCEwDAIt6pNNpFVRRa0RSvOHBhhbB4HYJ8Qi4o2Jw8j7n2KJPMDVbmSadFSSbtdFSLHKur/v99//f1////6q6+3+uvQSWzqSU6c0Uig7oXdal0mXopLdNqC6qbmC6nruk60jiBikySbIqWiztugeSBAtXVhOb9uZXKExFcuI7ITw3swUwSFMNjBhKC5gCEAyA5gwApg4E5jQBZl5aZz4WBjcIpm0FAYRoQEhgeBKZrixho0WXSz4WAuCAMByWpcoHAWYDgcn6KACzYKAgYBgaHB+YcioZLq6YlAyoohCpNvYqv90HqiMsZ6EAAhI0kC5haQMJDJ5Ifc8IzqFTLrS5xk+Y5p5xlv/p//////6d//v/97LfZmNVDpjvRTTVOVGVjJph5xU6PoeWqc/ba9DlRmSROPjiJwFI3uA0E0wnrY4gtK2pEOLYyJtyfLKoNEV6rTvwjMOgIOgCAAnMHRjMUQeMbQzMzidMTiYPjFAMixwMSQ5JgIBgZO2YEAIx6ms3ECEw3ARAAYCgamPHyYG4mTAUPAOYCAIXjMAAUMBBGBINmBaoGMgYJBhABFv0rVwr0L/x2kfrIdQ6EE2Ok1AbzIyMUkixFFIepSMmQMdaSSabbtQUipd/v///9X///+///6+jv1XvZStVTak0Vq1KVdTIILuq6mZSqCak1LQWmzpVO1BJqN6botZl6lKOH3sCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAGoI83AZ07cOdwZuA/rW5avjTcBnlNy4hEG4D+qbmYj8uGDA7AiRA6JDZDfKESruTp0DA4AzB8EzAAIDJoHTD0BDD0IzJdJzvO2wwuzFoYi3yAUwTAocAFyUv4857LYDU0lkZAQEAAGW7mA4ChYCygFTAAD0vzAcFjAQQTDoXTU4QTKMMgUBZdZYzdmNq+Wqyt/X3i4+eOhED8HCFTS4knhoxiRo+MGEDmVj0OOa6zjz19v////X6e///b9Nf+31zaH2tdEmHmvVFmqPHZ9ypQdUy+5hhhjGsYccecYiz7zWLMuxiXjrlypJHc1jjTjzzx1rPUNVq5VB8B6VBSRnIQ4lYrHzQpUcVVLRmAYdmKAHhcNzDcfzEIzzAYTjK1+TPmrTUkVDJcQiJEACJQEAsaDcMBNrLH2RqPKnpgYCAQFoUBIGgEDg7VnDgFIgrBIBGCgMmBYdGE4DGJYKGW6LmXAAmFQbM+CANKwFV8k+yedWSkJ4nDBtjADUPM0TJUtNh5Gi0lE5EgomB1BFE0W67LOo1oTN29t/33/96v+/997KWl9r1Lsr+9vUqhqta/ZmMkGZBFJM3v0jRNaTMktBJGtzFA1UtNFNkazNI87XPsT5RDAB6mIum4BPlIFxqCLwFQRhJx2OB6ANi8sBwQngIwETAeA6MCUAgwIQeDAuCcMCwBEwzB+jDfSwMHkLEKgEGAWCmAQNFpjABK9GZOi6eomXQUxQAM5GgMVNlFBCAyJAQv2oOYBIB5gCACrlMKEX4wDgTm4l3xCAEDgFU237Vw3J2JyFhfDrg+LZCSDEeKcQjVyJhkMGOMOZzSE1rOjmsuef/9/////////27Urtt6ao/bzJjshrnGHGZpxp55jKcapqGXPdnRFdHOZaVPZGY049myF5OrTs1znVCcehmwxMb8w1EfKGok39FsO9DxG2qxuXLkEQKmDQJAQLDAQGTAIgTAUnDF8BjRw9zJnwDJwHQIL5hoKAQOhh0DIKByB3ggVbJemfEIDEIGAoAgKAqiwBABswJAAIDMtQ2hgMDwADkEgAZJBMYHBeYMAqFACAQCRpKdeqv3IXorc1wAsOkAXJCFOXEIx4zH57ERUoIElMISBrzjzz0e5z1PPZ2/bp3fprp/b1r9ftv6V/td/up+bcxX3d5DVjjWPY9yp7GKfPc5VMIjdTyee53Y48xy5s4qh8w2eiuWdOUPMBBepp28gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGxIU3AP47cuWxBuA/ym5aViDcBnjty3JH24D+qbhDxWFhMBo3FwiDQRAeAiDAWvwyFyl4PKEAJgIBcwAQnTAlBaMCsEowSATjDpEUNawx0wWAKhUCswOQOREBuQgRg0ABK1433caQI8rPVTCoBAgALfSGXmAoCpdQiAFYgYAICwsCEFAIjDBF3MEACMwFAJkKzABAFZq+7YJ+Cm+exnY3CECRqC4gw4aaQPNHjBYKDGONoaY+azLYx1vV7devv///16f2//azf0/+vZVoc1mVT5pVMue61uaUmsxxiIrnyTO5rHTD2bPVmQxHY+hYcB6FnoWYFulO+iNDMoTaWHB4zBGmpsOF47atoiABRRMDIB1OgmBqFgnSYScwZgLTEFDpM3ZCcw5QOAAEgYHgGpgZAaoAi/VKnvH7pMAE1J+3DIgMC9oYAQiiYBYBBdkwHABzAJAAMAEBpAUDQBDAdBkMJMPIMCEMAwAh4F2Q8EACodGtyNX6arygQCCC0IYK4UIEg1KFzSMUuRMwjDjGE5qq5hxpiNdlaY6Wt/e2n0/tZPS9V0tfv7bPq2/210qp3MVdnOOVpRHkKujoY09XNMWhRzzzFY5HMQ5zWPmIbWSN0PNPnGNKOV9ypcrvq2VqcHSYORYaEpkE0A+EmdSyXE7zKDAOAHFgfDBCAaMEgCwwBwnTBJC7AJLpp3irmIGBOYDwLhgdAYGAMAsDACDAGAJY48cUp2WK0F+kNSYB1xC8ajsbLbFQApVyJCTpgHgMjoHBhDB5mECAaHAwsxYcpNiy+FbmDxN650JwLAgGBARHDyJp5FDjjDTSNln5rOxhh27GH3///////9P3p67///0ZqGJNqyIh9LOdQiYdQ1mKn3OnXOQ2Yx6Iefd2OeYp7Lj7GoxyKYazKcVFE0FT15tUVbEhRZxk49OthIIP98QZx5S3ctcFgDKgRIdSULzC0EjOsYDAofDH+LQQ9RpmK5iKFpi0AwJA0wiBcwGAxL1qCjzqKWlQAEQUPwcCICC8tELBAmEJAUUBCUA2HASJCeYFg+YJjESIiYohmntBIUAlckKcVhy+lpOO2gDYiDhEAXiLKDOYVIip6CoPjFIyQ5DO895ipXVlPfrftdPnLv+x++/q/r5/+29X9Pu9929DVnG1qcceaees1p8xGmHO05bEU1GVzlPZZpzkC0XR5qGsWRijOacahzTGY9SRwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABkGENwGeO3LYMEbgP41uWIYs3AT1TcuLRpuA/rW5xcs4eLGIeFIjJglGCNK9KGDtMZTGC4ARgNgBGASAMCAgTABA8MAEFFCM0ByYjDNCOBQE5gCgCIrKZjIATSYnGYCzhCXLEi6ocA07YBACVkhlCenS3wMAcIgLDAYBTMGQUYBB5lADyE7TE2Hwwsd94NhqH1AY44EI6AgKOh5QgPjqnuhrvQ+jTdkZFd////ndf////9f2aru/9LX016NVlZNpqpVjGmGKROMQ4fc890mHMrWNee25jj5OVVKFhzVwdIGdkBbgmINiGo08zFzOcmp+nUdSRQ2iGRJcM2IAgX+CB2YRDCAEmCZnQemGTMZ9oJwyOGsWcYWIxoAeF1DEYEMGCBh8PQwsRYilYwAA4DjoYBwGBwGSsL2syWQRACPhAwMRA0SBpnCAGQAUYHBhcrAtcqB3S7K2nchUySQeTYeijUeTmZocLs9MzUY5aspJIO6CT1q1XTataPs2tb+qpXQ6uv91PXX6m//9Orfb1J7fdBGp69b1MtjiNTmqZqbHqDWRooOgkpk2Ugzsgs4ipVKmgyJ0plBGpDgVhE4ZBkruDDQWB4BBUDRg9MQqTyY45sVQGuaDgAGRhMHwBJh8MIycMlD4PriQMxACcsxFF8BCKYKg6lbDNJIIlJ2vt0U2JgLckEggr0vKDgBAAAmAQCpWOMiYYDhsYyjSYMA8NA2JAY/kSc533kpmyOrQAfClH6iHEGQRqRmsa7mFCI1DTVOV3X3Vbr3df/t/0///99//9O/2+nr07z5lDphqnHzzVKtXc15iTnHhNnlrzmMdFuXOVzjyA4xVmGq7s1FUwhI5GDB+em9mTy+zJkH6S5QRC3FMrCdLZU4buhKekBAgDQYMEAtMHwiGQuCDGNIIzNcV5MahgMYg6MXRFBIKGCAFg4Jl+vCw5lSGw8AbDCgFEfQMEbthgAIJAQADDlB36IhWHQCMJBlM3UQMLhFDBgGgcRwTLlbMH5UDgVgrNxREvEyJZATxA2PmZwkDNBTlR4+kggzJpKTUkt0WrSRdN97dVX2Vqf/V9fXt/U3Zau1X/0G2f1KZW1BCy6rOgdrpJIqZJdB3TSdk59NkE0kHUnQNEUdF1MddFlMgtC6zta1ILSWipbscvcWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZDizcBnVNy23H24DOqbhkuCNwGeO3LQcbbgP4duZ2JtYLmnkIS0/k9a9ealZc9NRhwjAgwBDQxmC4wRDQyJIAyfpc/wQsFJAEKMDhOMDQULIBwF0W5S0RxpcrEz1yQcABbcQgUlwh4RAsk+GAePBuWAdAwLGMA1mGQIL6Igrij5LikME0lNDV4CIWguhAhkIsjJp6FDjDj3FzqRXWeesz62f////6f6f/7f+nr/6/a5ujM5EminuazIhMznsUOZEIj3J2Q89HMZjiqHGGT0OHqnscjMxp5hiHMhjOeyHHHmqWzztJE0nKwsjiJIuBNq4NiIdD+B2Xs/dwgAADAGYDg0sKYHCIZSB+Y/AyYvD2Zmr6fqqiZykCY1EMGAkYwBaMAoJBELATKIrLVwzYXApVMoDIwIBUt8qsjam8VgqXDT3AAABcGzD4CDCtITCgCDA0DUmFDkGE5Xnawwtf0FNyDUKgLZglBTBYQWziM04YyBhXdJAQPS56sciujGsrzv+tt/b3sv7fX0/t/T9UzE9+tT/pdDjFQxmdMjMNR3u5tVNIFU5TZx5hqUWaZMONQuzox7nsa01CyI5iGu5mrqcqFlmjNYycuNieXWDoGCZDiLcZPTL+L9GAoAAYEoDgWAIME8HYwQQOzCQIVNuULsw4QNDBTAjMDME4wKwBzAQASQkpZyqgjzoNIR2R8T3f5sqPIVAJpRYA4DANRAiAXUzMAcEowUBNjBdAIMAcA5dCc7C51IldedM5r6CSBAsOiQSB8YXQ04jyLGOe6ns7fpW6J///W//////////09UZaL3REKIahhbPdDjUOYwumyIh7Gjw4fMm0Qw9SqFz2PtRR3sjSSKirb+Phj7Hh/CsUUMhKlVpwF+UBOiTSN9IsydGQAAgxAFDFA9MugUyitjNKAMJYc7lejRZqMMmgyeOjAwCMFggBClSl/5HAKeyAZt25gIAGAAKBQWQhUIBi8xYMuOTAUSCgMDQJDhuBIGIQcCQG2dmKGym0uYA4zuRqEICYbDxUD4dnug2GSjzhuQQ0w9WKtSh1K6n39t/f9/7//+vX//10/93ZVr7H0OofPMm7GHmqeec882chrIzrNRD3OZGVndEH2d0PPYxD9ixph5Y9jDxpc0w5STNjwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGW3w3AZ47ctEx5uAzim4YQhrcBnjtyxzIG4D+nbicotdBsmUEMsOWOAPHWTNI0uRJcwBgAgSBeUAgGCOA0YHQBgWB9MHweA0PDpiYIAwpQKDAsALAoEAJAPL90cActr7rQwwERgAIbpplAAIcAGIwBiYBcOAFCoAYCAXBAARgDgBGCqB8LAahwCggALJgCnmZyySgdWvfpgXOJAjGiUcLC7mFjndTy7IxyK9fRXt9v//v////v//+///6o5lrP3Y9pyHkT1NYiYc63Nc489Tn3MdXd2Y49zCjD7xqGAFE5UbAJtdHTpg94RezkTRmUjEcwVKZ2TC8NE5Gp0KABYkMEQTL6GTQmIh6bMUJr68nfqYYHERjVAmhACYFCxMMzCYHa5TtKgFMJv0rkdmUmFgO0BeSwZQFlhgEB2jEIHBgGMThc3PLDbArFAkpkCQG9pcJdatrpNkaBXFgNgsE4fEI6RE48YoWMNNPGw9KNe2tzj2aqM7qrX+/6t/f2b9M79985v2N/6H391+711cxTE6shiGOhxKc90LGmGnVWc91lSjNKOrExhxk81mZchmFTDj7SyHGGsQGH2KOjYEbB2nVIzzikkA7FeMZ07AlPpXmAsAAAgNzBAANBADohBWMKsC41XCoTAkCeME8C4wLgEQIAYUAQsZYNlBsCyWWsJjJUAAZcIAA1XIThCAQpyhLa2DQCjAAAPLpmAMKKYBoJ4QAWwaNxtmLXrjiRiLVRWC0KEVGhEhcyrIdMSiLo2tP371T/r/////X9/9P///0WlkXZR51NPVj7mueZqXdDzKmmqcdQxjJY8meecehiHmnO51FZlZLDoXnYaSFMws908PCMjD/R0RzhKVMv3Dc2VOimOoAHASYbiIARMMTSYMniRMcn/OVXLMWAMMXxkMGxmEgMEIRJzLAwxFYk/yxlamhQUvMZA1IZLtSCecAorFUDRkDhkFjAFfQhlBoJ1YHIS1QNVwxN7oq7k2BIoDowSwnPJuWtOMOKg/Jsn06LvWi5if9797X39v7f0t1stfbpS87vZ2ezV189V3a7sxqqcWWadLMp5ipNZmOHEVGNWppzFVnHmXmq6m2dlMQ1ya6LU+Tcw0oaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABS5/N4E9O3KvkIbwM6VuU0Ic3gNwrcqZRxvAnpW5mpcuQ6ECxHMjkUzUiljbJF3TAMDTAQCzAAJhYPTEcGjDCDz1tszD0BTBYWSgFjBYGYIkUbeyVPy2CG32glMV1VDGhKMqBNbpEJqKy6DAYDzFYAAERSIlKy5+XLlcV7Iak+C4dG5EeOMU5TZ+zPVf/2///////////////alNzamHq720V2dz2mNNn2Uw0xzCZp930vWhyY9xCBi0V1420AXoBF7XxmHUMcRiVyON0KxVRwfXjtE7ygwiBNQUwNEMwoAQwFCoxxJoy/B05DQIxjFIGgCHBkVQJIAXZ480hlctWREX/Q3QgCgC08sZ6w+lUk2DMVBEwQCUwQIclDFPR+HGcljsPSyVO6w14SHCQ4BAEcokyOyVKKMjITev7Jff+j3/+3/v6/9/7///269U6qblpqWSiRJTsR2aitM9GsNOdHyEvOVrWR4xFsKQhb/K9VHY01b7aV2YII55ISnK7mEMQEsVBwECYSB5gkhApDGKTMex8AAKplQMhcFGAQUuemb75TjTU0k9k65HnW288ONowKHuqUGBgKZfcRioHJXMAibezcIgvUFP3DhjAxQ8UQES0qZcxkp//////////////////ZamO9js9pFMRKu5Tq6M9SHJZ89xqlUXKc7nShGZmJdGQrR4xveh/LHIdnBl5azIeJjZGHyEC55rURbWnYEsCJAGuUwIJAyFHUx5As4FP0xbBExDEIWDYwCAFVJWKPxaNSF34bdOgoUK0v0IEj1cvcp9SCxEwxABZhYPwiBmWOup3G5qRU9LTUEpAhw4AYiAg9zVZ3I7Nd+6NrvV07//9P/////6//+T//603dWKsrIehEQjLPuqmZiEvVssxZ90pESsmiS2KdUd0Uqq91LaOqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAATUjzeBnRNyqNEG8CelblI18N4E8E3KcsObwG4VuZyYO9DidjVF8WFoqyudvyhuaba3TAcEC/ZhsC40kBgWGR50L5hUA5giAjEUA64V4u/k/2DlzVK+8ZVUhElisZcp0H9c2SmBoNDBhmBwEtujbDrJ41u9RS6zNXFCYMqbot9LG/t////////////p////dd7OUjKgNWIuzsgYru5UZk7lsrnW7pe5TFm4OJsQRMRWeWt0RWdpR2A55zDSyqS4HGbEAohhVvuOq1LoGAeDgRR7AgXmCpHmAKHHBLCBwKGDYnmE4DioNJJr9hmU14y4DG4ozELgI3ZeLvsqT6Zc09mYyAI0BwqEpgCTIcISskCqqRB+oxL6jtUtcBwQ4SEBAhjGQpD6FHJdV/////f/0+zf//9P////myzdVf5jpZux2OV2YYVDnnWr8y1jquOM6ROgqhBtlRFZ1Ye7QWo2AuRjK/tJVJYrkwfLTypdq6b5Ttg4ABqBpjcSGFEMZnrZ9e6mCyYYrC4OG6miTaw0NV5bIaKmd93Yoo+xiVtv8+t6PJ5MoUsAxxCDUl4rW90Oxp1YzJovIr4zDuIMqsiK33tX////////////////6f3tNpRTIshXV7nO1XR0sxda1K6IgxtNyQW7j064f/NE9h8Xa9WxAg+AUEAZMI6YUdL561BAwAXDEgEQggHDoxeBzAaINBog7RNzFA7MGBAFBsCgZK1W97rczJpm9Fb61ZE/Q8AWjvUsGyahcOAU6TJQbEltATDYEa458eklmpRdMUw4GMK2PdXXK3/////31////t3///7/9//f3Raq4jMzvRTKRSsYSldXEDyY1nsRnu93q7asRZmo5R7rC39XPhlgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEeJA3gHwTcJQNxvAnYm5P8ITeAe8pQlnGm8CdibnPUMEacWkAi9dty69EHhFAEYBAphcWmHxQYeER9dcBgoBQMMBgAFAOmWBbSU00pjVyUQGyyNQxTxWJMsXa0hRNLgwKAQAiAULFF4Eo49lOYzUa7MhzFooS1Ka1bX/6f/////////////t/+la2PKpuzqVnRbpPNk2Vt7lU75m6ZEIZ3M+h2IzrnIXeUiKzAtrpJAK1RhhAcdUq7uRV9nlBgACQmNEIoSI5qoYZYiBDMLrRgQyBitHtWFrk/O3prUqlqnT/s6XMgEus6Spc2GYWCgsRhIhMlLlB6NR176Fy5ZN4Qx4MWMpilK9FJ0e3136fp///2////2//9/t9v99JFyW7MYlSIVAZ3zKhvhPEFPGRBzw2VvZAOYIK40yTIvb9uXA9qgdR43dXbu6fGxbb9x0LkAAKPioCmBEpJNG1FYJAR02C4sFhUODhz/2PhypStydCkett8nrYDEn2L90kGGf2BqWBPbPzkxOzkhlFoAsKjSVGz////////R9AXkg68ePAIOHTIcLHLw8xATB1AXGGCgSEblsNtQlxEWBM+cGhz7N9MrMQjcmSw7qR1HYaoBg5BE/4XEDGDEGxZiekZjmGVq4QXAILTyEgBgjW6DOR0b7JpLSa8wTTFV8MXZSXSbi+rpgAPMxOQcdMK46USh2fs1JfSTKBTlOQ63R01ZbV//+n//6////////////yo88rujyHViXdCqdTlRCvu7s8qulqvXXZ9WFFuihzodmsZCKqC1AK+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABDSON4DbE3KUEabwG6JuT+263gHsTcpGSBvAnom4/g+uVMwZcMDYxvVjKOSVoZggSYkDBAIcaLHMFAOQwYKhAij4JAMCSaUV6lahg10GFMOZxAzju28jyQU9jOlAwwFUjB8V7Ui1DWnLkp3VC0XT97//////////////////ufqnpn7Kyu7Iqo0xnMdFyOl3ZbvWkdqSERojdnZnaplZUBkNxiW3qkETEtZI+TZBpTetOlI3ZAoAp9A0PjBkCTAoJHLOOi5EASAkCzAQEC0r+PrLqGxt2KZ+WZOW3rL7O4wy1lairmLHEgFMJASDAnZA5Tfwy8WUssU9PaIJHKozHbenen/////////////////tmNTtuZ9WOpmZSC+dJi0dzSNVFuVKFsRCqVYJ3bY+qrx0ZnORwc/AT+oGCGE6opLjypK3uZk55flhwIAwqBCB9OKfQdDEgC+rRV5txq3uZX6WD9POxSFOzfbleb6kkawSOBgYGoBDLFn9lm56UXbtjZHKyEp6f//////////////////k+z5UPOU6uh62Dk/3o2HyqpQUzakZvUKAQ9J9SxugLkbZ1oexWkkks/WUosFhu7dwfSCp8KgCW1TKMAxJMGhcMDjrOmUZBREAgLU7GiKvZhKMJiJxqeuvI7kTZkwfNmzEXIWikewyGzBkHm4QSla38hlcC4V730wMRqol7onqdv///////////////+vXX20mb2KWrklVqOwqeinZiSkMsyNakQ2t2EPL27hyQ1bFVTFmqUok4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAP1cbeAfBNykXIG8Buibg8SAN4BaE3KIcFbwI4JuTPI2IIEaKHj7vWaVpbREiEmyUHqdIUGUDadfSBmsdLBva46pnTz7Xr3qnxNkbxU1Jm5VJLaeZpwaCDFAZeNEyZjGdqt2tXzrRB2Mn/1/////////////////9/7LRylWd7IbmPZKMOZqAqtc4atKUXPgvlJWFjeE/OkJy/kKQb3ThjikiRYEOeOUFyvGC/zL04TAIAAECQhCcxmJY5RLYwgEUsAGDAXU3QHMIs6mpqNQ7bxhmHHgarAbkO/LW6r9bkLAAYDAzDTqvpRxKRyukr0FPhDDme3V79v/////////////////t0o/oxkKRzsm6ld4zsaSxVqZiI8idFKEKq3VQqNMFTapNnRVXIhU1MK7znykMKnxu6ks0npxaaBMvuTAAcOPZYCwZHMspDtxdtHa3ndqS3OdzfSWzkF8eF9KVpTWQIELvqA08ptVpdlvWtDWU/9/Vv/////////////////9tWa6nb9jIrOyOp3PrpVYlDoZlRUXs+FYNVUrTIZV+yU3fzg6/1Rn0QUCjG1t0tumbmimr0EgIw8AyqNgDiDqxSCgdAwHIAsPBZRWAW1zuTEumYYfmNNwlsH6rPPYg90JMkIBQUNCKCqd+ZVFa1Pe1zg5rWZr39f/f////////////////a/db0pWjXCURTOYzyuYchyLLPQoNzIsgVk2zaDIuD74qPG/ObGFgYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAANnHzeAesJQgq8m8A+Cbk5pyN4BZE3KAsTbwD2Juf6wY2Ctnu7nzud6zTMIZYwcsoIgaDBY2iHmZEAQgCEC/L+zOuazwr1rNuG4pGIpc/kqda0/ZlIJPcLur+MrA63C8Ff/////////0a0saZHhl4s1o2DiDYwDC40G1pFRIC9gEoeBTKQdUVeGHTR/TcxjpC21zz7MVVkqUl+0EAEAhCcDFpQPqJ0BGQQBgSDxEAW5yeG8fq9p3+lcsfJxn4mY9NwbdlCmCujCY+ROmpBjjY+gx1cqpGPb/9v/////////////////t/ZHocp3odDI5Lbi3RzHaRlVHkUEL7SkUjpqVTuR6aY7gLqQqgs6rve7MRgyE7X3NZy5Xa9kygcuDHzX/OLw70y0Q0O/Fqd/93N2sNUnIcpZ+9lOxyIvq4QY4xa3Vmu37XK3O7s2////////////////////+fz3yOhEkd3ehiOzKV3G6cwwf95sCZkaLCRLi0R8wIsnHPt+HaD/cM4U+0ll+xLKz7zqxmChAkhoYeGGJxJu6CZKTK0gYFc1WKHotfys0tSllq+4cisrfd82hunDcGQUNA5ghWqvKYrLpLj+7+GHMv1/v///////////////////tWrMqVuyKc5WU5TzH1Z+d9zwqLZHczMZyO6IctaXK/BNyHLDY2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADvIM3gDsTcnuvZvALYm5N+bzeAOxNyerCW8AeCbnmeITOInjS6rTT1tmUtX8m8FAkxhlGLN+R4LXw+jvUuW8tYzFitKKSTZWKKtNySA4A4Sg0JhmI4zVWrrusv0////////////////////+++5FWWpDKszoYqOQxZGMZEKyKqH0oyk0O1EHRGOeDADSpVCexj2mWInf0WUKwU5Qf0+NmijrAS3TQQCACpaYyDHoiBuoOHBYkAQy2sbtZ/VzyppS6WEqrZuxWnJZEo2strwQNTEvnaamscw/Lr6/////////////////////6MWzoQpClStTLY5CSlOahjF7SFVEkEyo42EBy1APw+vy7U0JNC+F8iegGJYZfXoNV2BLsas2IxQ/PNRAxKXK0lvIrvPLeGXKkq7KbVq7brUck1DUPoRF8JFL696mqYfr9J//7//////////////////2qzNrzqqTERbEPcYsQiopl1btJMOR7iTpfjZ3PllRDBa5hmYqK6yQWTMdf/Zdk5z0N3YYYCAseEIFOaLYCBISBaELT3Wh7P/pbmVvGKwfGaWUwND1Wrg9r3CooYlLbVSay7+O/953n///////////////////7t/dE0oqISWQxSgkRauiGWpHZkUqnZQtmykmsrrdZFBuQhyi4TEQFQCFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA3CIN4A6E3J08ebwD2JuDH4a3gDQTcm4xxvAHgm5fpvuRf3l3G8+Lsxt2FpF8D5HRIO9sph6LV7+Pd7t0m5+XV5daqzdnK1jGAsHKBEHT3Mcc//f+v////////////////////6vfUy8zWvurXV3K6I1HMxeiC0V0HZwj7koQz5rNuynUUwfJZG+c6c/90eL24r+6vVIEiifqRTRRQFMBfTV7cODEESUlNKqlnD9VL/LlM/d6i+hlst08+3/DApftmlyxqWe4az1/////////////////////yvkX2bS7u5jvY6pMqq1jMhuaRlq5nVCVuVEZpCo7MruVys7EKiUdgv/7Va7KJ5NAiZEwwcOIDMoiYETEwJwcZNLrs5kiTpqgmkxkkbG5WH2JENchiO/f+n///////////////////6/6zbLJSV1orGQynItlOyJzuUGyEOrWo7GvOYqfEJQzzF9swhp8zDKMH1lnv2dNncqYdQhDZhwRnBScY3A6jr1tws3b34brcz/CXdlnKa3ar2pSzBW19I5W3d3l/9//////////////////////un/n98h+2R27nVFMZrmR1KV9XWyLOyMhBlMn5HMcscyyPODDhYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAL+fzeANBNyZ3BG8AdCbktGHN4ANE3JhsCbwBoJufr5/2QTQG+WyRCyQDVIw+EWEihDCePJOvuyzqSRsbIOgdTMRSROFF0qDN//////////////////////1319wTu+ZUgqK1mnY6HJZau6OZGIrjuO8RuTj1z8F2qpPrb3DfnXl83+e7MagtlDGFbRDkPFWRzaUrmRcyx/+83u1Up8Ms7tfHLmMTem9Vu7s4Y8/n/////////////////////1932dZXL6HTDOzqqqZmZmO7EOpbKVEoj6pR2vwXyZjlPk+suVz9P8yRJERg0E+MAAL4W4YQS8iqS9StRigikpB0VGpeDZPstNt///////////////////////3atH2sZDPK0hKOrmMqnbmuVTEQ+uYpHckqsglkKqhXY/Y4G3KE9/v6u9aZqTxYJUiocoACSA8TMLDBLikbkixt06FaRopTO5qtIZUWYTBeOOlp/f////////////////////dafqzLQz51VHp30JuVPoU5zsUl3SpF3BwxbOGeTL3fQ5IQLyNgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAACgXs3gA0TclZwpvAGYm5H+G7eAAVHATDB28AWibn62GhMew9gSwYEzATJy6z/7q1otSmA4CFr////////////////////////Vr7uQx3GMjG3O53R1czugdkIVj1cHV1407ooakqO5Rdwlp9rgL///mh4nUimagENAncUmKiT7FZdvrU9VdJakJSQ1av//////////////////////TJyo5nRkUxa1UytZ2i5DOZ5t31IUG5kSaySIysxBTylQ0C9sstxf/+jnKDML0BkRRMTp/9f85xW///////////9m6w8MJi4hStQrUZHkwzLGwoQBQSizy5NKGmyQcMhIOgicDIYBt///6SjpqbDCgBkNxqTi8/+rsk/0KKP/////////////////////6fsnW1z7Hbc1LHKlnOiLYt3B3vQq0fYmpkR5ga8q4nG7z4E9yTgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAO4PN4AAETAjQcbwAAImAAAA3gAAAAAAABvAAAAA/8oUCFUf//////////////ncNfryz/zrOo9+Cs8r/1YKd//////////////7p7Ws7EUkIlHpbBZ8O74l/yz0CKsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAAAADeAAAAAAAAG8AAAAAAAAN4AAAAAAAAbwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=";

var Transition = "data:audio/mpeg;base64,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";

var IntroSound = "data:audio/mpeg;base64,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";

var ExerciseFinished0 = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwMkQ3IDAwMDAwNDU0IDAwMDA0N0YyIDAwMDAyMkQxIDAwMDAwMDRFIDAwMDAwMDRFIDAwMDA2QTY2IDAwMDA3NTE5IDAwMDAwMDM0IDAwMDAwMDM0AENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDBBQUYgMDAwMDAwMDAwMDAyQzdDMSAwMDAwMDAwMCAwMDAyNzA3RSAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAARWTTeDDELwpgoW8GHvXh51mvINYw3D4rLfAazhuKWs0dexgIrCj+oYlqGYLPuUVT48meWdfOb+k/MzM0b/zhDeWjuBQdR3XmDKtYhiONAeCQGRGBotlg3KD/e0W6eYl0mAnDYLxixUvFI8SLiQTB/qek/8yeQaLxMUY8nxIwc/MGFjFulHmOQty83TxXFGBYmEXpZ60dQ0vKep33coGOpwg//Oajl/UGIzDSBYsI7eBRQNdQwlKLoNK1zH6olRDtMoIL/GmOd574pTOIj+06sXbEpUKEMKMp1GfitQtOHqGGGIGQIYYZpDgRbtFkvPQk7In15YY4U0fESHaZ/uGuDzUEOSsfdPnFL2eN88TT/f/1nd9018v8UvuBmPncDVMyRH/zbWYUVzTkG0FXyx8zsEWekOaPTNokPbgtSz9Jx5cggmj1OqcH+2t//8MP5eOOJTomIBg5ws9bZcs1NUejO7IlFzEh1n87Bi6IpXqPWtfLn1605T5xubkcvqPio4v1x2lKlX8mHPx4GAXAw9ZDDE5DaFnj5NPXZFH0S8AhjmGHp1/5VGXLgeGIbkVEwNIuAoTD7xhwASNLupMv/Tu/WZ2/674k1xKhVVAGy+W3ORB3Kt+JyOVyuRwXRyuN2qKrK2dx69KIxZp4xLIYmaCMXrFfGqu9w0A77NMvYw5djcxDEpa2ztx8aSG605bx1hnu3vP+V7f4YUlipYw5z6lJzPKWSuWWKljDHvN83b1UpMAGG1lDKyhOvYmD8gnq1HIYZy9R/H3CwQcLBmgaDrZXua+6LZ4OkbGzEiVXznXwRQgS3gz9S+/nhUjE5K6dw3/kc/Ns7FAFLWrq3uG0pBeB5eXMY5G2UDgBpJHGKlQ9qQ+bO26NdFQDhHS0Y689JOW5h3LUojLX55YRJ8zhXcrWtAACVYw+fjcP5U9aMNYkDdFYL9i9buUlWX3L3crFTHsBuvbp8alepGKSkzru5Z6+8ulkYsVHbtR+VrrWguidzhyUv27EYkzts7d+ZoHYa5OZ0kMQ5bp7f5/un7nrDmHPwwypN56pLFJukwqYYYUlJhXzzr2xAEQGD4gAZccsP5A4FnKlIYE/qOdKEJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHrGJBhWcgAuyLeIKs7ABfykEcGUoAA+HIJEMpQADVVgCEglxMdksAFgNPow4A4uYkr9IiIA2n5PAzCEPpDmMAUNPOXXwhOcvzeOD4baMBCDIwPIwxAEADREsmbM4e1oRKGrEwyKkgBjJLbo4/JEqQEW28vHAEhHVfuo+79xKESzBc+cw0SKsdEYIKIU0UOaXXiD8O4yhMd13/a0X3U2S8ooeWgrjGazfjC5GLDwQ7G5fesO/R0c5GKV/37ZnPV5ykisvZBRSVndG4jHJQwxuql7kUTgM8isXl9v4Lt3InG6kKjefwBvCknMrFyxVw5vXKsvp6fuGOXNSjLV6i3WxysWA/o+P/q5COmfmst1fOB/vvgIPQAKll9GcA2seVRkUNR/BgBsgsnhuNJ8IpuPblD0PJDEsswRVp724MhH93E6OnQ8MOJDDGo45WM8JjEAQkDAcjiwe7C1UwzBT0y0BgYZATDQ4xBGRlae3ehTpMLDy9b9iAAAQ24kTyib9SilikcgF5422degoAGBAS/4HXu8LluPF7ecTi9t4m9ceNW61HSczu3OZ6/WPLdDlXz1SZbvyuN3MbE7uXzF7GV0Eok2nYbu87EIOaRAU7PS/Ogq09rG+3SKb/kcnP/D//Deuf+uZ7t6y5XDxiRkLSES+fxDfPe5/3wjsra27/dz7/+g8gGQaBqIHLmjbA9ScDADA6QAYWBjx4BUoAU4SgyYguSgwCAESNS8NcaA7C4XzcjTRM3GiVy2KAByoFghYENBBdByMR2BYGJiA03KguQLsFeUIDiYAUAhcgScRmKVAcYCxcXEMwQ4nDcrlQZYT+KSHIIuaC0BpZHF0mibGSDIp4ihZLweBQDwQnwwOh8AhMILC3DdHyVxCYmBlTdbmhkbzYghNFgpHjFkEDh0gpeJ00k7YihGlUvGZZTNiJFYipRKo9olMmh0EmRE8WSLm5HkuTRfKZGF0pJmKtWxsmX2uieQoTRbFxJF0qBktKcL7nEEq0/v////////6vq///xeAYQgHVA2tkWIAuQAcIDVwGZBgChwDqQGHJFIRuLPHOHYLgLxVLw+R4HYcNiuPkqGShok2XhQAGZChoI+gzIDsYFm4fuDY+BAyBLuQ4QFC1gMVEgF/xlQbRC7BmwtqLWBRECwsSYQoJ2HMJwrl4XEGnjNEYbi5i4Ch4jiCFgvB+AsgulswLYlAZQOeOYRMtDcHkRcUOKVKZERujiMVNufNFlw+9Cs4oxRqPIsU0zpUWVEXWkXyXLxoYmswKZNEobFlAzTYmyuTRPl8pOOcmi6updMzZJ0DRWtBSkDJkj8uPSdS0LH1Gq6Xv///73f6//v+pTM1v/r/4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACVqQSIZWgACxUglQyjQAKW5BVbjaAAJTyCqTFNAABqCAMUyAOwBklCgOBoGN5+BiwcAYLBYGjgkEISBtkAaHRLToXUESHKEoiAhIh8AzJERahICBGJQHKGsIRCUhaBKANRABI8BcMKkCZULPgMUQtEAxDYApeCEMGrQUDggTgAAg20V8BguBgAYItAngL7AaoYAKdAzgMIQwTCA24PI55fKoZGAygkQXFJjZGZBsKGFhJh6FbDImpBUjMbQvxzAwMH3GiQYVoN0LmBWA7w+iLE+I1DIo5hqZoGqjUoFpJjA8UEESuT4mwgSBdMCRUT8kjA1MzYmyZICTxdOFAqE6NoukVJMgo3CZLhIsWBmDihjSZNSsWyRJVNTOdUy1JOpyXLyU3Y+frXPpxmCsyJ9MmzhpSSuYPTT9adf9/+qadD///Umkk1lv///JUByktgCDCHAOcBhcNgAsfGdJkBoAYGSZVUVndbqPHWWdPLMTVM2HCFYEhRECEIAkyGA/sIovjwAjAv5DYJQXwIGP6hVIICeH8Y4XtZugseoDeNVGiYLcA6SVMUDYcZAKazdMoDAi8VpJyCgHklWHExLF1NPSVc+bsirRRNyYtddJ0dVBVbJGzIKdBBJl0aKOpNk3Pq9KpJ7aFrUFpPUyqaNehV3r/+r////////+v//wAAEAwIAAAAgEBgMBgFiCuJIiBuHVhOmISC3ekk8igYvKYCwlSjgWLgY8CM0BmqQGDTAiDMWEFjsKxME4TpMC6DH2M1m6hlAsYDBAGUEBhQPaFxAYOOBr2IGEAsp+XwsMDLA0BcghQGwSQ4V0BAEMjCE1fZYyAarIELgBsFhdWbC7D+ABEhBxoASGAwoyyZ9B6lAYsWAwLIAAMXHOHALjIwiAWEgCqgAt4GbFA2eE7iOhBwjFlqZbo3VIYKAHYIIDgYqGZ8Zsg4e0ILhZCUxZI4SAlQVswyyb36/58i4s8ZMWWOeV2MzcghORZBOCvDUC0EGzxsw5RMjmol0ckWSTIzP////sOYQQ0IIi455BzcQXEFx3g2PknHPFzlcvkXK7GZuaJxlSkdFKlwVAgTjoDIxgMqAUeAGDCfhnhyRzBKRZIKOojSIlsfy4bgAAWEAAAARGk6hmWibJSezT15gsR3KA5FhQgtI+11JrdZSOm7OpTaaZfcvmI/DKCof018YBY+DkL5l/tdBCaCNjnLgXsIuS//Qah8LeCvjkBCxvNHHoSn/+/9zQwHuOc3HuS6Zcb////9Y5B6FgmAwhQJc4aDnN3HOX//////9tD//N2QvWaLTOj3MyszTNE00NC1BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAefjFSnR2AC0I8q5OXMAGF2QUgM7y3C8LzqUN09uCAAGQBd1GQFcFpBdcsm7Iufoo5ZzMZpXwYclsRBZ0AKjjS2Ps1sufqJP9IKTWUv1MRzGtg8KYLDQIjGHgDBoXhY/UxYpc5q/uzVvR3XN3bm7WWOUvjjnz0xuCb9etNxmXZy+6/E1DcOxddLE3Fhh61go9jFbMupLXN02MpltbLOvj3f6/+YY6+13GrWq1Nfhcy/D8datVsqbKtaW7S0tm1LcLm/vZ0272P41bP495rHW8KXmWVLlhzuWWN7HGl/XfzxqVcGZwLc5+Hccf/L/139ZZ3KWGWuvzKrXc8efl+svxx1r8f7rv/93H/3e//3qgCia0yIAcQA6vaKI1u3d9Oc7uqpSRFwHHAXuSZeoqU+iiimkbOi62MjY2PnSHABADYkzqJ9NjEvE8iicLyTmJePqSLxedaCKJdJQmj6aJkTJFTU4ZKSKRkOE8mPkZkcoMjCjDGiziiYnCDF43MTVNEyJ4vIootOF42r6KzWcSSSMkTFGZPZSK2WyJqsxcxvKR0ZlFNFSTrMWVMi8Xkk2U6KjZLpF5EyNlmqKRkbJJLRRUkkmkbVot+iiykkl0US6ak0RKOK//6CuCnlQX8ThWTzbwmyW9buR8x3DGlRbnIgv+XX8OTtutJIpSU8ExynQZMNYz6XkeJnBa1IXbjdqVtKYpJ44rIoVFWYRmgvMvcx130eddi7x6SIjRpUEU1mgks5MT1Hfl09SWKWvSSaprsgh2/PX+MwKAsZbalMuxxktaCnhhF195bArQE9WbJYUMFMzA5riR+Py6btzt6OVNUuqLUp73X2/uZZf3OU5X909WvM01nPeVXvLuGe9ZX7mEtJgd8lNiBs6t+ltyrfb2GdTvKepllb73HG1Z1Yrz/LW+5d5rCvMWLdb7lS5kpjC8M7n39Y2Ln9/XN/lnWnLVP29zDXNW8e7/LLe8OZb3+Wu//dZ8v9z1vGI4Ve7oc92GQAVABdSMQEBvEZ1oIstW/z3nnVranIBYodE4mdCavdY71ZjdfPOxlS93jMasV8oIh8w5KRsvl3dcz337WMGuJ4OLY3jbdubUG64zW0tYVXTPFrVsjKZuurzsQoh0VHQQOTNExeNA3CixKXzS+NVxn6z8618Vtq2Nfe9Y9s5+f9/W9y7xnvo1vf4x8Vx//v69NbxfG819bZ191v/629cY/9tenz/j/f+Pj+tc6mihw8bVYeY+pq0UJcdWPGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIWpBSIzvDdLGPKpQ/LW4hLjFEDHHtyxC8qZD8rbtAAAAAc5+T0gQY1VgHHJ8FZYxHn7sZOlFNP1RfNSF2EdzGDY3eCgtf12bZ6pO/fqMCAokBheKWZXEXSlrLY3Ss1gp7gKBtMCzugTh97YxutdnrD8OjDU5Vltm1cn7v8wm71+9YhxracdrfYzalF2isR7rpxeNS7JdL6QQ6ahcSVsAZ/lu5BZ+iprMam5ndLLbGrGOeWfb+q9mMSq1yve3YqduXq/ef+O+fT4UFaaghiuHZqNZySV0NHWs012vT63YtYfha7jjbzysbxwxx5zt/L985f1yzUr5fNJuRbWv5zPDHLW+6+zhvHdypjnj3DPX5/h+8NY73vf5bx3rueWe+WP3vd6Scxyw1upVSABSAH1XWC7ga5JIlYF4MS+se/zfNyixPIdD+QeHkspMr3f3Svi/meWfLMqoNbq95Jn6C76u5VT0tNa73Gnt8ZExcxUlWgkcWggxLEwpmDpH3dzYqRliky+SZfHkojC8XxYg7DM3OG5go6gfQOOvWitNC3SdaKFJ0tbLV1WugiuxePVpn0UjGg3dlpu1S2Wkky6SS6anrUj02dmWqpaaCfqpV/0lomaVl/V7Qw1RmlVRb896nFfni5E5ABCnZTBg8eHnji7NUgAb9yCbXY7CSBhkYHUA2TDFcTy0AUBS452al7puaYBAzD4vI4EyT9WYvyD6WjXyXJQZMZIIOHz+zFFFI/OwLI8G7S9cp6em5mU6XzbHjTzKyDcyC9K9wY4sFSMBsoUpEdtXrowmAnayJ+BfMNPJECaLcyIXKfj+szuOvrzuaJpufvaOFYT19RrY4sKDLZrZ4We6bncmr1b9wYO6xXE9CGv7QFCdkSJ33Z2pxfR32cOo24UKNWlJXGWDGtWAzxd7xHzbMOz57qDCiUNd1Lv7iRPrdcZrbLzWc6fsUK7Dq2f/94+ZK0r/8fPxv41pv1r+i5iMCIhAAAAA+Ne6hBcM8utz1Sn/LvwFzHkjm1pBcc0a406OGD7zn7wmK7Xc7dm/uDKLsst2bbvKwGJkuZ/JZFpdQX4bsSXOyVIFB9Glz92YJqu3EglB02f0eHeQLR1m1HmGJMsSAngkAmBayUA5szOlBLYxI8cOosWqW1vuruXZ1fhrk4Qpj2xde6Yd089BbG0jmKrWPa2XNqdr2fOzm301kMiurmZ9ludLuXoNc+Lma+qvmptrt5rYbar//fP8h1ALh3fFz42JAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACH+O0SMbw3DTMCpAP09uX24xRgxujcNZRikAzb25IAAAAH85prUgByAgrGW+rJSMjJjT++Mw6no59WLuW6ySgXdTX4NBZukoshcYSslkPO/ZkYEB3/TAzllA/qyGCNPp4xH3NCgEaepGUAsgU4WdE5c5UYpG1Ye1yHKv23ng2ls7m8KsemX8q2Ey3y5Sx6Mz9NDTrXdP3JMW7xJ22lszayTAjTJnQA1XJcXHHHO7NVHrZfHG0obefeS3tPlZqZVZBqXVq9DanquOGc5X/u6+u2P/K7T4M8eTDDF4qW5lvHPC/TyPueeFq7ru6+ePeU+P2vy5v8M+XL/c862sO558oVsz+Gsss+71zePf3v+4Y93vOrqrr9ay/HX40mO+//dZf++d1v8vzw5UtfrdrNHxmuZAf5vODjSG1G1r/77xyHupLDqgZgjhu5TI5U9+l8tPz1Sd0zrCfvTefYOjeNFLpC6CzgFLCDDvyKAZVjO3cafs231U08GFAs8g2rEeZrMMg8p2dtVUX3ZITbuOpMMzkX5AOZamWhDaQ4/o096P2DEKW9q4/+7apqmM23uDXHznUKNqFjecYzrfprfuvOG8zPWKHGjU1S0B5anveBXObZkx6YprWs4p9brTOsar8Yt76mrbX191z943vFPnWP8Wrj/Ob/G/5+M9Tb4n7/NWsAh8/P90rLS2sXqOwwwUI2ocDliA2hUw4AM2k7+RV4kGxYJOzTEr1s3Ymh8ChuYVhopmUMAVufGQwNH6BpL/V4AvbdUYCCw+jgPTNgYJAUBW8AUFzECQGXi6RZAihIE8gQAirmBeRAw4EiA6g5EyNp8vk6YE8TRQMC0UCDmRExWQy8LiPDVFU4nQGAx3ruZFM0QL4oEMAgbESK1JlRsddFBFI4imblkipYCz5cNbJHUXegaJHRmyJLYuu7Goxw2UEy4WmRSdM8tGZ0WNnSWjTqSMjxgfdSnW7rWkyanUtF2oxzD9G2+uzvTalQRpucbtWtVkH2WtTe1bNqKHCgNTlpqOwDXL+vL50Fedww20evKbUM10lAaSBJILCC+muTjYWsYSnetvHFaS9eoNWuymJx2ArcMGRHI0AN62GtZz3brVZmUOmmFDhraVzfckN7FzEqUTTF8d7Efr7GxxHsFvVahbVW1p00GVgfBEQXseJp5DvH2wVi3rR9iuZ8Z+7VxmJZ9nUO0fVfbOqYzmuP9zH80b8Z854kiwbaz4VpdVxX5z9WvvON2+t/WMf4xn29MZ18xNb39/WvjGLY/98V9cW+q6+t5+Nf+/3j/5+a6x/jX3vwP0aAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZHaVJB+ptw3K26VGNTbhoWMUaMak3Twceo0Z01uYBAAAH6+YQwRZJ64V4C+iCG4oWR25tm1q67cUl7cEKjnA3RltJXU6TjfmtMVH8WtTS/GzRw07ViXz0DvlHV0GQXLWk9eKxq3fdxbEpzlxAyKnj5ZMjMiKCpbQJQPcJ4yF8bF0pG6Z06XSdLii2ZJJEPFPElKRDx3GY+CBFxzE2MU1op4dcBvRm+9TU0EGZKWCAO6aKbtpt1DxXcyoi1rnTrl500VJpKnfWy1KWpMxUp0HWgt3dTPUaz5gySAQf9XIn+rqZ8a3N6FMAMAADeGrr1IOqcT9h8HbLzugRF1Nsjl8FpxR6q/8roVbS+h7HQ8FWGwi6UxEDa7elEoVsWdLofrxuNMqlUpytPPDDEVSGiHotuO9drGGJ59FKLs9fGPSWZoEQPEVKCKnRIYHgOpD7KhoYVGJfOGyRwwKxqXEB5GQIsXyFFykyOeI2KhkXisYmpsbzAOuBNxfUmzrZk1mSC0Uki8Q6lUgyDsmtBmQHhVT3UWV5sVjNa1oOiySKaalKdGipbIs7pIoLUlq0bpMulSXJwTi9qy0gLNMniy9N/d1nqz7KyAAAAB+8qGjTyXPr67cA9zlsdtYKwWo6rB8rdqxQo3ltSMO3aN3ofSdpKS5g0tHJ5r83EXbhzmEMQ/DEulxYALDGTAr1nXJcOTMspoaFjL8yikUUGOFoyOVE4TU1LIngpOOcgxqgbSqeWbGJqdJw0Yc0bJQI8c0Xw8jmC3rzSmpygiJaBwA4T6rJsit0VLRdigNI0pLUms2MaDMxcKfdbGZESXZNE0LypomynWjZ611PdbqTRdJJFSmr77Io061ETT2Xv/3qoV2///9fr15ib9YADAAA/+ymGigJPLOzE1EhtJQMoFo7CACFNFREr5vfAj6BUSYM2ajCRB5tpLVU94ApJqsssMHN9TU8Mu+rY/tuXMnlGTHVsDIMx6p4ouyFr7So5EHTBQ2ZyfoexiNZCGBHiQFooDyJhqNIgRsdRJqZdKBEJEgkqdL8uSRGEIg7RaHy0N0OQGQZIzjzMzhdPGRsWmBkAsgAMDxLVnj6ZYiZooMeOn1nBTQTelLtTsgigXB/dB2QRUzILJs3TTdCdTUktkWZ1JtMHSc3Z1up9J0V66SCCTIugT0rLapvRW7V91qVV/QrU6/q113+pT2ekeaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHs4xRAzqjcOMxihQ/bW7avblGLOqNw6nGaBGNtbj914YZ0HOFBEvuRIwvA5odhIiKNDgPAbkcAQG24UBZPMShzAAj1jho9G7wyBQudOi5YQSmAEqvnIag7jkQ9Xl64V8yOVKyluDHUU1n+iTgtdaLA6DIkrk8plR0wIiOEZkiyRBiImJmVS8SwFgZOnRaRBMumBqcIoViYUcIEmXiGnR0h6AKAR1DjGZFoAJCgY0iGkkCMydRKpYPmQ5w+wvoA5SIYLmNyRRMUESsyakEU0i4Pk+mYnKRPIrUbJoymJ+SWY0nUbEmi5qgaoJJrZrujTTWlTarTSWkgjRddbbKr7Ly+Sa6Dv+7fqSs1vr6/+/V2V514tMgAEAAD70d6HmWOLFsiLhKQOhD9Tc1nmnVDNeU1W4qJI9CcgZAD6Yeyqkgyn3ncXlB03EXjfqJw7NRqAY5Whi+SARlRkjjSPHLYMn5RiXxrRvExTMjQ2H0oOk5ID2LhgSJdNiVDwUyTWmUFFIuEqPc+kSQww4hjiTjKF4KoALIIIcQDqMC4UpuiaILJo+CbqOqWlrNTZjFSdZkQTRVdA+9Vas1ugtJRmIMPOs3OkyamqSLrouitJa5g6za6nUpdbo1OpJd3Sor7DAn0tTN11rW9dBNFSlJLUrUq1Xb/2o38nfBsUAH96eow4TjLTjgKXZGecEBhXNUNpP5WCzExI8/aeMpiLtCgIGgjqInidF5iQCRHmFQiSxyBC9icT/Rp/qrRGSUyd7e4TlC4rymCwJZNQnGHULuvrJwYOkFioRUvO5iYEKQFFFReJUsBQJLY6RZTKNDpfI4zTc2Jgk0VHRyAoLIcTxsZhCDAzYgY4uo3UtJqQgMBKsWyrZFmQZnWplIOK2QRVdNJnRVdyfHA1aSS1mJFDzmV3VUiYIu7pqdGY3tMnZKgjUgtut+jevNCed/NXAfX/+25mLEAAAAD8LijY4YFMV7VpcE0URBFhcXK8O2qhMAwJqlgBLURgZgKKdPGsyZ1DEhht9Z65m8602OzlV2IxBrb2IYdqL1FJKyO2EP4OCWhWLEJfSLOKPCcNTElUo0Nkh5iMj0dImF4zOjvJce5LDlc3NywzUiaGhmbj0I4nhAG4QEQMghOQvQT0KMINIuG5gswRMzQ1JMeZYYGaZsitSRmgmtk1Fwch1DSTQWgXlrUs+fQZSEyMUhGnWYqJVSBiZptdkEklpUlvTUyK601up2Pq1qd6TLRao3LXt/u1u9aS0GRpVfXX/6/QfucXWkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAAB09u0YNZw3Dzcan0Z3Bu4j27RA1rbcM1NugBnj24/uMBChARAHYvRiMkCsLCCSKjXpWYiApYBBTF5QeVTT+kBBkmngKzx/IwmSNVwwqykjTVGqMNgnTuw5TlAFZhLLIhHJeh4HBgWwmUe+1I4CiL/KHmAO8sbrVXimrNmSVn2h+tjbiO2LyLsRajhVxrVqeBpx95uK0sbh+Nw6uaBJa28OjIxstA2lPLOUkFy6R0kcUNT+mLEP0lrmVFPSibvyyYisPzUMIOPZnK8bdzlLncyz+47tW+4CxJBT/akd7WWvtczx/V2/XuU067drHvP5ll3n4f+PP3//3////XP//zqWef17Gf/5PQQAAAANYbZ6FAUh3Wt15Yh0RdLFziY0N2RRIu3LoFruS3gqFmIKB2a0j2gSjNldEvZvjKaNpLlSiOwfN0pQFyl2LMJm2ArzV0YNMs4SgcaPx1h04+xZx8Z6RFgTqmRxECJl8ulUpD8kUidIYeSIeLKLR4rpkeTp4nSOGkW1Gg2TMTkLOMyOJUPRDAIYwEYEqVCDHy8fNmMimOaA2EVOGFAwOldBNk0zc1Wbjml8vMYIHTykC7ZRialaggZooMUxcLLJlTnmNEzdHZBa2RT0EU3WaMmiit1LfSfUm2bIajIkEP/shZXRWyO//9vfo9VbaZs+qWv59KUFkYEF2syJW0QCzUwQTZKIdE9Bjwao4CAIv18obUjuOoImJxSo0WXDKHhDDI0HBQOa+Hh0G9LPPqMZkKMU2/Ewom5b9NOQ6mbHkxWJL/hyB4Jh5LUxohoLhXqSJNArUMoLLOZujomty6BEBj3Opfhx22QNFZ0pyxRBOoosK2yObI5CzuXQImi4tmBIbEQCJFbXEC7ssgNojkv0lmBgwwMVAjMd0/GaA4kZgIQW21lmTTXudR32kPS4TbSxr7ECQJFnJ94akNiG6lfu8sv1JYCibdFqAkHYM9sgjdeG5iSx6lt27FPnG3nfmjwxgdkm/53mOOWG7Uo5+t4d1vnf339f///O4xK969ZSpPd//6yv5W9rob9TiXYzUBBZAQXExF/asEUpUdM6TF2mDppEA+OABJDV33blCQL8sox1LWMS50aOVyGOKtk8DVJJnFpWyQxQMBInlvYYbzNy4lKUCOUZnVX2dPKOKnNX02TubYhbhnMqsjT6g9Fxo5uqbTA1KxTqQ0mQvjKfRnoxgg2llpJNEYSXkcMRjdxJ8XpqO/eXrnV15GbrmmMU8md13W+/pWa91bEpq17WputM5p9apvf/z5d61jN8596f//4z92+MfF4oun6J9Yis//jqUgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACN50UAN643Cvilo0Yy9eoQm3QgzrbcKpqejQ/OF41vUEmCFoVDi3j10UNmEhoUiDBG8Whncj4UDiwoGizOiphwREKcNRUEhTFIWiGvEu85JecGgS3goCb+WLCMlTWZjBE04Kq4sORHlEMTBaAMGLTEgZwE8fW+OhYm2J/24MuA4VpkLhiHodcl+mvpbgEeg4FqMwmUOtGadl1yNP/2SsfZxXlD+RiwrZBy2mUjABTif+Gkg7VmLs2JAAAAkttU0qv08CQE3V2R0ACwHAiMO6IswUAkeWaudMwZLY/KOx2jlsYnGRsCQpMnDpIFr+qa9a3ayg3tL2Wt5N3AuLCsi0lis0ehQ9fW1Yy/us51mzCblH8oaE1vLev/v46/Tt46z73////v75////+r+P//////3MHuZ//9mH260gAAABvWtNaf1zsOyt4BmYhQShv6hulfReszPV5qHUpASCZdaX0JbAviERNn+V/ONXo1ndqQw4sxnjWcuLvA6ZwpJaPJhgtc5Qc0GNGiMjtkgQjqdQPCvt4sw5Y79uy10iaampVscSd5EfLUi/BdqgvCCWX721GySFBjqk/SdnTuHFxa3vevx8au9V9fjOK61nGvT11h8fVaYb6hUITwnAxKEphp1hGwxr7pb////6/1jHkPwCCPOt1nhGSTthjQlYLrOIwSMiQMHDHrVxK1rsGAiIoFFvTtgAIYVEYk2movBkQJGJiJFAoq5CWpfSAy/6GLysaEgEkTUY3CDEgQcGT/N2ILULDp7wqMOnATATVn2PW6d/Iyoo0n54yBAUZZZS01O7TyOXIbb1xCiSNlmVqKMx1TwEje+pACUtV3kzI9CYCgpMoeRVsq+5cq2aaZ64w4CmGyhxKGicwGRdpqXXd2Kkg1UpM3BIAowwzfyLTucgsXdZvW6+LS4VM41SAIHkaZ7cxjsGMmr5fWzw0/rySi5b7Bj3vB+sf//ww5OSjPf4fz//+f/////f+5nyUsYGXCx7d/9OogAAAAfOJVwYCrtFepAJhLZVvc4N0+8sp8ZbgouiCnwcaS65YnJT3+Pq/cVXVMx6IyppE1KoxVoXvzi2NLJAJWEPhcNWaWNTj1psSyzIKekoddrovy/f5YVty61Tb5jcwyu5zuH49w5uYvV4jVypY0zSMY4Y3e1MJ+dgNAWJHmrGXN5YYY5bzx3/LdJS6wwxz//+5hruGu/SUv/9z7uA9gVeKVI6Fup+9mWSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjbYk8DmeNwrIoKNGc4XiBNiUSNZ03S+inoUZzlevyo5odD4AEMuW5CxwEmXg4YVyJo0QFmrgqWl+Ang5mQIvtuQKhRYaZRkMBI3TUxS5p5mJYPomKQWHgsZwLxKgjCDpKeGOpCK/d2ZMBRGh+WfkogVIbY8BRd1E1WdgnuOwEGCIIhI923BlDlK1pCR+BgMiy4gVAdM+8pqvGGBCLzz6xtxUUp6kxpm7TGc4YHAi2TAoTTgiaBBCbBmcymov9E9N1GjuVqbpJTdVOrQAg8eFBQ0I0gFXRbGfpOUs/fj1nKYziChZqsFIxtmj8NthwmLFWDZE/rIxIZKxLyhYjBQ0XpmrTX7A6BoBo6m6vL0qkSzb8FS+20ZtmA83zmv7hnfj0vpgMD4w8eNhZrxxYDBxElQiQ/Ud//cnGUAAAAD8+bgx2pF3ky4wN4CNHl7KKryvNjbvww/sjdtOYpgHgEvC9Ln4RqoruFZ77ADdIGodZShw4tItzi8WjmQwXynp+TU9a08YcuKXtVaTl/tkLCo6mNzPvI3qYrWbcR1XlfJfjnXor0zatalkct0UWkUTu83zHdXC7NUCNojNqny7hvLu/yzx33PcZt1//ev/+6x/nfxwj0gNliqzt5gVtfzl3/lQ07////1EAAAAD88fTdMMAVOSgHlT1NqvPFcPOQXS/SRinzCNCHIFYS30OgLAaYfwOrDfC/hGQLJq6ajCVFDQIAgkGU8bVOIAUJDyNyf1JVrySEGU5dkVBYQLdosO0/yWLoSJlC+DCXc+eaxKZfIGWxdsZhhdPhGoRL6BnrSm8fePXI02lfdBLIjL7MSYjQGIFSuVUg0XtV7UdrJBU4OQM1WO0RtHjjzci2AEFGEOmBtBBwuoio4j+ZRiip7l2Xw52WRuXEAEzBCI65PwZzHCniDmy9n5fwwgJAY7bWiIFT1p+US1pcAYXdY4VLrrS+hfuB6kFWnWy5n/5/rDHcs6KbNnjfo6PuchAAAAAfrudAj/A0TtQUNMGnqfAs5VeuzSqx5WYxaa+jW0kRgi/bG2rl8IYkdtR5d7W5ffwbIz6Jxell8belk8EzEHLSaqIaiZFpMMuO4MhopMgghOWOFFKIefnBM+DpfO2u1MHIzszFLXkWU1Q9jOctq268UlccvYw3Kq8ugRNZ7Y7Xxp6mdbVaB4oEiqtkUev0/6sb/VW5Xt/fommZf+Fn9d/uXP7bzvTEg5+8M6DxQEpZoxYOVrWYdCv/Xp+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI6WJPg3rbcL/rOhRnOG6jYY8+De9NwwUtKFGdYbr+VuXRoFIhaTrhLACbEGHV5BqRoJHcEIThJ2YNMZdPE4dIkrAjJizDnW7CuEE0QoSMMXCGhQLIlEXWEB2gCj0JjzR1gMCMZEmi8n1TcVkHAiRbhiSoqnGsGyhz1PbLtrqZolAMgACMYI02cfFw1HVNHEiRVIEK1MpC/lmXs6ByG5r7Rh//TGXZLLU060uikMFAXNA5DTCxYWjI57cl2SGYLOLBGenyLEvUYp3veCDXQCooYWtHpNZiwOkOWTQjYjF4zHJRbpn0f2OUFZy0OhmAyvyA7dLTUtJSTeK7oFpDDAY3obWbPveRFWdfrIYRDkAzWpi/eyoX8b7BJWF4PVm2bHvcsstX8LVO/dUYGnLDWmga6h0XRYwhjmr9v/UgAAAAP1v7qCNm9S++BQecDqBazNxF+IioZhTNPn30TIZ4FijbWFg1BkJbqxe0osrGp1G9aryZWRZ9y/LIu6Mu4weUJvCKMuiwxrDxTjzxaGUHY3KqeYnJRA9PXTRuvru1T2Kr409FMZbpdW95yrCmlMooYLu5Wn+t5PfQ2HUlrXKb6/eZV4LbomQZRurPT+Gf77vHurt7+9lERnv53uv/LX7vxGNWcnggX/+gyr93+Ov3/b/1OhdbZ5BFhF+39hr9/8FGByCFzOnGLzBeMNj4zaiWl+RmBhAjPzEi5cD7A0oSIMAJDBgsWFwoEnRrQ8Rg6HERQr4wMMUsIQQwELJCUWEGKVrLHYMCARWBpIyAYx8QgDZRY4GRooIDGIhc9GsRL1d72MufwSTRQJoIKp2vxFQGD2whVW+tKnHLpHBsbNMTsS1xH6o1UVWS6mnmZ3qajREekyy8vzk6pQ0ZxJ3PplspLp6HEtsFYUYUK2r7TsYaE55LSMYJh0gPiokeHTNerJIh9h/Z+OzMaqIchs+71Le52YhVNntvoerGFPHDPsGnZSUNpTepIImZU8GdapZ7dpGI0231bPp8Kkv5vmG/3hrDGHM9Vu3NPNeMsH6bwK65h0Yrga8RToarIAAAAH77+SEloVmzKR0kyPiievjVhlVJJe/QtVn2xrXVUbYfUr1X0SgZl9bdCiUrM3+86k5HnPhcPTdNGZTm0aC1kAxWzpdsnkUsr2XDaNBlerdimDYp2IN2vzch1rl6LYUW5ZafDW8NyCkpasr1OyDKUximvSaAKGXxxQKpcqfXwp7LJEMyOzBoceCzlu3Oc7+ONLdu5bVdP/v975/3Lv7g1UE5uCuapbuX3t95j/Nb1r9WOkzwKXEBhcWe/0c95IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACMxhz6N603SwCnokYxhepIWVPI3rTdK6LKiRjEm6IAAAAGtcp4YGAAmDFPs2boOxhnWSJYQiDn3ggHPTPHDBsWa6HQxMhMmZACgMLihY0gdG04AYGHHVEJtLEqATOqEXwdwm4fnA4i9RkS61aR6QUToDBFW+MODCowSeDUMHNWpv0uwODyZSktyEH1M17zzwx6NQh1tBjEoBw6umVWsWNmNPT9l0pHKpp5aKU22YQ1Nx5QeODspWOLp2A4XTbqSCPhBJlxx3y3owZJkzSGcMpfSBd8XcbGVD4GJEwqPvvM269DTVLENXqegGQZgxzpzF2kxj7zfjCJygpC+Z2yDnwdHSs3epOtvNS+Da123b1us/b2ZVHu69UslG942N93h2vnA4RaejioGPij0jisDOVDeKoG260F6EAAAAB++60saUcs3SBIJwho++s3uWmkprN63vZAwucHbll2iQ6mW97dL+bJH+Fh5brd2vC5jNx7OamG1irjFhSccP2onFH2fZy2IvRId6jOLS6W+0m3y5ja1NRSl1H5z5+xnvs/Uy+Bs4e+vWs0lmd7MyqWsbr1o5RU/M5iVEjQW6Acq2OtbrfznP3+8n1WpRc5+ub/+/9eAnRvYx6i1e5ny5k18q4HB4MraiHFf/voIAAAAH93cbCZCKDS4uOB3yMDrjiK46M7BoTOwEJbzTsAYZFjcwYcuLDTRDjEzEwgCBLVCxs1bt9jWiRAlWvQDXEiTGbTrOfFR5AepsZxGLC1gzDlR5uXcUmClZKKUrDLoWYs1VjXOSCC6zLYqjyFQy4HXh2UvrWSchykMO+a9A7Ss2cyOPGHOyOTsYjdSbeaFx1hgwBU/Di+2nTJlW66rjrhBZxZY/9LPiwxfZlF8y8QROJkE9lL5hr5VbBYS9CTBq00FUj73ZLhPdi0BR3KV0bok2V3NUn3K81e5NyF0mWAAecwc126wAWdOy8lGpi+8QbFMVJ2x9iVw02sdiT3ZyR/IjhreNXtfDLKVyjHmXPseeD5oVLqlw1ZpGvIrQ80/0pYxKAAAAA/f80yWzY/IkaYfi7HY/beNdgJ7M3Anlh0OKGYiW2R3VTP+kg9VJiymRl7JDr8usuk0oiuM/Kn4bPfYIiSxaGIOj8tv3IaZc/ePmBNHByTp8XReSLM2Ww9H5DUTp41RTMmRN0C0iP6RoUCucTMDIrlqH4GyYzZdM2MVEMBBIKgLATxqgghM0kl3L9kyYICVKOgzptY6RQVaSC2Uigdpsk739Z2ZesJLiIxR0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkhZ08DmtNwvapqBGsYXiQxjzyN603S1CnoUYxhev1rKUmLAOSgNky/IiBTgZQlRiwzIIXWTtMgKJc5inQ0GXmI2bagbGBDwlPBowyQwxKE4pIgAmZOABQNBiAkMgXrA0RZ76l7xZ9EwqWDF7kGQQlFpDsBhZhwQCal+wVNBtB3K7Whwk/TLYblBkgoEPK+iUobDBpa+xwhbtBd9Oupcq0gREW99qxNCIc712ESMxYZ9qaKlYiThEUWCyBYEmEVKkUjKh6qr8hVVTTIstJiFuzGIm4oqEHry5jATjNlh4pKKtDrPG18ASTc9iQAjAiZqll16heC3Hqafe6VzxYDG4JupKiwCIhUVj08qpJFzyu3epKuN2q/kTfyJT+U1LG+7+fMMea/OpP4awp+61+edUJDACtlCljwOwuZPIQObzR5W0kwAAAAPq/jmoXhZn9EA8LwTa2XYzT/lgAqV5eqzUyrEBa9S3ZZt5RorPAElecOzT97LXvlWovmVDXM1Ko5EWYMtWI7tMpkyVhsRW28M9ZdNqKqsOVaO1GGNZR1G5s2ceytVcozjQWL9nP5nPjQrluzPzEYt1+Vp2X252vO007Jq6rbWFqzWfOVicW0gho+dutrDKm5VsVreWd5+sd3e/dxx1zmcsdlm9Wz2xnc5+N08tCAqQetzhgybOVV//xQgAAAAY2t6mzPx0a3n0ShkBg6GYfKmkKpkoQ2q2AjCZa4YNotRqRjAyBxqChh4RhQxZY6CwwREHwTBAQyoZUTgXMEqaYptTq9neEQUOhp6GMNIpCgIzBQmlEgQcExkz4EqRxoKSIV4UqpC08qmZlbY0LEJGHofl8MN3T8jUFGCCPc2Fm2Fu5HQh1GK8Th+ILmatT9pQIBcN3cRIe2IwrRUeSqSlO7EolLCU4mwiNHK7hlRKFvLdSFR8AgStu04K1kHR4rHJRN170iyn4hP1dzzEwNOk967aj9LLpVXuQVADZQSMCPbrTIyAW9NRvGFSx+Ict09LUubrQc88WbhL9TVE5mucqY5/j+Nmp3tW60qHjA9pE4UG3OCSDdTnTPaUe9JtAAAAAa/9YoaEwM7W2QClgSBpuW3OVXT1i85D82mGKFYaBAn9aul/rqIrw5dj9zIMBJtZ0ldo87XaVII6xqSQLATDhWro0FhuFrLGGLb7Y3sZu89OMdFEyvdnV/L5y9lGr26TnN4upbtV6TUP2spRVvV8JbMPd9fHNQaQVsMasqWxEbunMi/e4Z4byzw5vL5bS7/uGud5/bv0EpSQwzlOO7/38vqn1SigyHQPtUCp576Lv6fPpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI6mVPI3rLcqyqCiRTGF6h5ZU+De8twt2taAGMvbggAAAAa3nZwNCFzKwxKxcLWTC703b/MeegwpelR4FYzWuQSPYK8AJWBYIIxpgnQhBBc+YWSWDRwGINEBnEOqwMw0DQloh0hs0GAAINHllgLHFFyGfVCxJCcgoimAgAwtBoMRIUlm6rDlgagRg+Ov8EAFsP9SOy2BuqislkBgnK4hD5TNSu3QAJx3U5FmsJIwmUbtrGr2HrT+mTDxZVArtkQ9inw07jiKdHEQ06bMSt08s5c+06CGzGQWqBRjglZb1ukzIK1HhyGoXVwupTi0EtqZ9xfXGllOE7E4yOBnGFG442Rv4GiVpy7r/Qu/hSb/PCX1oBbFSduRB3+67nrDHPPmqt3tf96qRdru/FvbOEYt+ErT1v33//vJMI+rcQAAAAFuJmG0mbuCAUBh0yIL3auvI2i+ItVbjLWuKH3yQwW05zpNjT6alhGnymlN5/U3ejytn14k9khj0IbaRw4CJLWZrhEql6mxhMdu1aardhqtEkeJHy32f3t78Pr43KnN0PJ6tjMzO73d3Mqbfc6jNPt44NZncN3pikaqJuvWoYnt/qxcw1n+XcvpJZ+949/f5ZX9ZQEwXX4WWhF4q9ZUTi7TwhqCKvOI//15Y/i0oWJiJRVgZyskARJkrUdGgiQA05KUiN04ggZWdDJgpSFgoOAAqUAYbGAcFgQCUwEuDQsZ2Gg5KliW4YSNLMPKXFbIXnLgICSg9kcpVCNBaX6gIsVgwXMEKyYmMVHiIBWMXIYEAhKpTofiwAvdVlPTPSoih9Bz1gXNmWTv/uwpQCiHWrSqow9y6ShsRsuDjnXDgX3DnUuaR+Xcoq8U7NLVlAmc8svctFu9lnhG4dOIO0IUzaZUnH5jUptX6THsVuTECuwGGzm5t1p6nrTE7anJqOFzQzSKQ+wBz5FHKJy4s5NFTZ5Yf/J/lBGpBllYkmffyx7Z5zOvIs/1uzd4Ey7nyhBQX+nxdPWwlc5I3//UyyhPun1KiWQ7k9Ss0tA6qlymUVrLwh9UaL6wBAAD1UMF9xUHAKRl0AOXcBhEWytROGmJNpMuKxSAGRMBYZYgoK6JYTd2CX9qy1sCRbkP33bc5k9jUAGkrt5re4KApXOWZhxvNnGsJrgSHxB9XOTb/v1yrhcbRCmiapR9KN86pMBwPPfE+396w4m7z4X6axqvvnFYT2IT4IvVmKDSSDCeVvjOvjeotL3+5BCt6RY3J2sd/9X/1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACStuTyN6y3CqyyokZw9uJo3tPI3rLdq2LSiRjD24IAAAAG/qVn1Ai4YGPuvYf8x4IM/njQF0yEHiC5Rb6ZhYY6tTQGYoiYFAZ8gDHQ1LJCx8zgAwhB4AlSg+ADrIXtDG8kHpsN0Y8PMMHZ4ieXzJBIkFEIAdPpGonGjWlQ2AQAgkjQB1XId8HI34gtegs3WiTHJI+D0smnZx0jkgRKisRs0UcTnNFBzK1Zwx4aW08OYIIwUtHqOCyKuGALwk3MxpLmL083Vf2LvqcC8H2EuSguru9chluY0y4pJSHIky83v4/FpmxXrtEwgB+F9IV47arGPpYnOOtVldeSJpAq2XShuyjMWh2YmKeYd7LPdy5uvOxS1JZ3WFh/fwqf2/vuH++VnLtNrDPHn85//+8r+OHe1dz6IcMNdIBIGDjI1qAfi6Fv10AAAADWf56TtYdlvB5gJOWXgTtxx2QplxvUPOzOJlxxDiBstYgJuQ0FytW4haT7nNw3Eqs9yafl1XwlD6PjjD6FyXNevi0CjwygJ0nvxhtUZ+7YQGVT1hazis/rXSznWNwzzvWCsQGO9bQvt7TSWyDeiVIC/pau29ImOhqRXSapvOfrG/JXOoML6+/nV6a/rFDtjavFpnOdW186tD3vzUjDyrykR0o6P9XvWQAAAAP1ctwASFYyLJjp9IJjHLA8uyOOZDMw5CEVCAIikyZ1kXzYcBIgjVAAuCVgVQgnMiuZCgIUwUBmOIHHPNef00AxsRkXpQbUbZkUKoBMSmAQkqkxYYNKQsHSKHiQWdJphUCZgMyxMFmiQocPjS10qDEFiACLDYabBOqiUqnJCJ3FoYfdy5RRsdACzMZpq6qcARbtPcTdFldShhJdCcM3dqkhiin5VYjkniDLouaslygC7izqXO1I6NDoiVAwoySjEw0pvxuTSmHLEq3Ip5ucoYWEHP3nEL9iimJ2WYyqZdEv8PNxrlde86/G1zOJSuzP2prHCZvWZ10Wq63L7Eio7lrClwmv/HF58b/Pwy5n3mG//X/vWtb1z9/9jvc98pP5/fx/88N/9Td/2Xp4FniZizf8oAAAAH5/zbDlu0lmlFSh5USpLfmYaVCsKnHdaPMuMjrERjJbpQ9mLdlM2Y/MQXNl9JDT3JbfabGqSMW5iGKRtqZUyza89BVPKOYxKlgyBtQ9w3loQQhyvDrjHSO91gOL3efk4LZvD7XNW02Y0GjYfT0IbTbgm6bzBuuQwJky/WKYvLBz9/HralZs7tne/f5tASJKK436ZrnUv/19ZpjxIU1QAxguIH+z/vWquj6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAl6dM8jmst0sUpaJFMYXqGBl0CNay3S363oUY09uiAAAABq3nUZ+YfERgMLvMjUOgIGroxZATBy+DB4zlDkNcjDrRxuaYs+ppzYomMuOAKoFNgZuGjghpGMChYUaomQhZwqiC7LzApITC1UQcVFjyBA1xseGCIaCmAkhEQgtmAiwcEIkhaMiHZtfRTMMAUyd+HUExpCo6PYK+7tu0iUKAwmInQy0pUcujdqhHAw4h1rFNGUaYcos68DEw0/q+FQYsHkI+zTvL2obj9S1ujQIbAE+60InM6eikbdGmDVk6KBgFKDJi7NutVvU9umh2cjLqS0oNxuRp5tR6ijM/KuOPIWqjU2U2z1b+FdVVTeC5yGpfcw/LCpas1Hhe7DGrep938q93dj8dwJ3nL9/ffw1h3//+57/9/l/8xyw/Wt/uzpp66oRm1x5GQBUeKiWhAAAAAW0AxSLjlUohIWE1Cw73ZULqMSUUeio/jxvCxlLwhe4LfMOj405h1eC2/qo9yH8KSMLml0YnJPEZRArVn/bactR6DXjhmp+L7RLWFnVuLYZp138L3Muacjn7uSuVdq7pIn+rNJ8oxxw3cxvY5RPFpVa4p1Pa/UxLYYKyRWw4eOt/+8d/vLD7fOb3jre88/5jhdoFW42rtjDKV0loMAA8ExQUC0sgLBc0tCv/fk8UQAAAAGtczfQeogA8xh1WCm1KncHhzYJMM2UrIlwouMMfMKrfMFQE0jLkzGLDAgjH0AEfCg4BYSAATQzMi0zyAYNNnWMiEkTWwEPgFDgBpMtUSGQacKPboqSMmOEhpEHMUpqqSKgMSFMskT0tdDEzpQ5BL8S9lCg1PZMtbNUepupNNlGQIEvV77MmlWaKilrOY/WkqK0QMmBV3XBgS5NT1qbjNgUOjVQlIeTeeq0MI7M/n6ItM5ly/ZyoZ/uo5LPl70OAyGmt24jas61ydle7i0QgC9ppL3XYL04Pc4ZvZWsa2Ha1PckkLwq2J7PdbfK3Nb/Uj5vn4b+yKJQkalyElGF48yyMKiztWZFE6EAAAABvH/zSTfSZtS5RABmAClnzvISsdL5YG00+OtkEINR5CeTg0qowvEiApQdevdVLi1lLcNJxavPZ2GKay5dtezQ4EvSyrbtVH+W65NSpHbn5cZYoTD5wxi9NDzi9riqSSJjcBavi6py7j4o7xB96FNsvNHOFEvHiw1aG0T168Lu17+vLPC3vFbQctO9at9+nvaLdIGW8mbYuNw8RbfPxq9saf0bYe7wHKOBZa2DZecT9LtkYa9YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIQmHQI3rLdpkKSjRN714kme88DWstytSuqFGMPbggAAAAdx7jKgErmEC7+w6oqDI8CqRgaACmGLDItYAyCkqLBJgVhSKWmWLdiwkLsGppCI8SBgVoTzNODJXz3BQUhEtkwoZxX0EkkWGCBkBkdZkkG7qbxIAlZjhAgAEQIwxBjOaUshKxVT1zK0I0QPB0HRx04W9cbAhcOsEpbPbTCwoPYqU+EedG/enoCU0mr9KrmCyri/ktmmg/nHqtLJ6AvvObUzY7uzckMgZsXrml8KbMUuR7P6lrkR5q7nBD+sW39POW63zt2rz8nYDAaWZetv6SKzTPpdYlFm/q5leu/azbFq/zn9/DLev+33dEkAOl1fn6glr7OdNMgL/tBb8rWdxo8Ep/5fwoAAAAFLWGKBS7OUgmQEGzfcstTKWwO8soR4WIkwR6zAADgpyFpQFYnYxRx14tsac//c07bVbG9bW9cHA0ikOMp6OL2fKVWtMOdeelYhcol97zeRMx/WiYtNnf99Xj4YfrNvmNhscMLcXZgOGK5xHPQWqBbM+df43e9Kbx8wt/3/zb53/DJtn/fl8cMDbVmV1HSxNiL2/9sRJxyqx5DqY4cAkii8SS+OkuPDlHijI4FGCqJJ2SBEnMBeEgASIGU4yGKqwBVRxOYdyACAeVJSIc6NsaHkgCRLjY0cJjHH9FqTUDBkAAfTFhswgxUBMVHCCuAEXNeQHhwsiSHZgSFS2ycOWECGCaiQ1YWHr/qHUl6HzFAdJUuEzjXQ6sMi0uzs6bynsTbYmTRWVyUoDnzQkYjasQLWzhMUjdNWXZXlzJXlxqR6TTqJoQ9GVHl/q0wxO3rs5LZa7ePJNaU6nVqVZ689VHbtYSuM0U5OsyGk5dLUy2LOU/kcZvIYzEb0ur7zv1r9nBuUUuzfM+2d4fjrOmz3IquWH5Y75/9/e89cwsYfj+GPcMssPy/+cy1+fe7+5zXdavauFCIWCN2uB03WAAAABr/3HInQU2NKnmZPDoIvagikbiuhccmZvBDathXEkcAEpuX0dBYrTtOpbug5V73Avu4vLCVxeXT0N4SF4HSR8XI80DSCQZVJtm8vpqbD6LuC/CE3xnFvAMCfONJhhpn2Vn7WwYYo1tRIsO0aFnBkxtl3TVIPcbK4ecsOE543mnxiN/S95UZn6vvfpA3NmzCWCfc8NqxNH38ZvnWsYrnGm62Kz6rMqGGrfnf2lVCVVRrbWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACD9hz6Naw3ac62o0Yw1upRnROg3rLcrKrehRnD26IAAAAGt4Tabhojol3VJPswN/2NZ+MTCBVNrRIZSFOAIEU8yZszgYwoUgHlEElQD0A6FUJfigYW6iokWohEESYFDmHiUIbMlFnfGhMWBiUACUIyEIMC40zUhIIUrOK1KjhbEoBpMF7EI27xqMIumPBNOjTn5qOoV4Yy00Fh5cf4Y8TtGnXt9pXDldbG5K1b73a7gUQ/JiU6+0zRWZHT8ltSGsa6t9JTVKti4sHOxhVJ03N7zt23DW+59xlLKKSCdYWIewzuVXdsY2qz4pFXLrM56/JsG68wpKSj1nbmprO3KM52g5e737fctcq4b7Z98fj38d1S8le7YCKW268obxZSb0VmLov7C2gAAAAP1/3VnQxvlcvqCYsJbPnBlJFknmszcSknaFSSlwKMv6jfAaHIqrN8aFAbhUgXjvRadkspo7UF24tHIDaKjBC3RlchxrtUgDdXiy+ec0YYxSPbzg5mUzpEq7rku1EuyeYLUedNFJ0HEyOsRUKZqy0wFM4gSSlJsui6vWovtTU2ztdRwOHug9WtkuqtalJJpHmlxDIp+2z2IVryq1qVOYakzEAMOB4ynaYBlmE8IiXwzaVGKORUMZ4+YgCb/myQbDEIEWwiJwJdT/8DhEDPtzWD0ijXeSYCJVAGKT5VUMfFc9pKTSCM2ZQVREwsGijVkxgTApKEVlEopRKQBgpATBy86QyKSGTsNaTIDijQXuZtfGSR4apMswMG5SLTqWrYgUQjq23qkbeBAx1MqeiUfWVJ528yOJmpO7tDPr+l9LLNVnvlKy6ScSFe6dl0Gw1OOqNGTRKMsK5sq5Vv6fpg05XqzcMNpGVNrUzFYFlscxghgUtsy+JtJGlLklYa7c5cypKeZqz1fWExMxmNRbFscslt7Gzleta+92l19mmo717tnO3zv9/mNbV/V7n6yqfrvd6w3vXKu0/x99sz91LenLb1m9VAAAAAb7vKIpwsBvauEhAMgHQoP08TuQlx1Iv22Z8KNwx4ySAfxoDtR8I1alqtE9bC4pBaaH1oLCZbALtOdnJYRSs+iK62awE6VR5qtlmcRpfuVM91fLcZCcrn7w3FxxfF191PTUFu34bNs/It4F6+2m2/NH4Uu+yaXMAmIxtSLiJqf3teSu67u2Qzi19+39YON/aYQvF6u/G1C/pjeP7+uIuJt2noOHBxLwAf+v1WE2mQoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACTx+zoN7y3CrizokYw9upOmjOg3vLcqEp+jRjEV63qvMFUNFTIx4yQtgZnxl2gZlsEqsYULK0GDAIkXlFOBFYwk9MdExpWQbDn0QmDzHXEIiNwumvCkyZqgJFEyKZYWw+SCwNNhYGRlX8QjY8YCAgKDZEISVwEJRpnYKXgCeEIc3xMJV0XkMYMLo3pIp0FAOXpUt9OCMmKQPFFpimqwDr4Un0iABGa1O3IISLdKMWepps2pqKIsSnhWCRPpKYYjeMRoZ6WXlSXJhYJs9emoo7OqyNJkyHyVsYlVFUr19u7fxottkWvk1G7Dj4QuxEb8om7G4plADx2MHTh9ukTjDVJzT+SfU5Q0u5mdpMXxkNu7OTl7DLv6r4WeSqZncO7x7r+dr6w5zdrme87/83j//z9frX9vZZ4//6/WOuf//3PlYe0BPZpgAAAAGH/8kcV9rWOxCMx1FE1r8bikDkIWCRp7I9ImMy8ueYxw7Fp4bTanFhr0GkJ52vEIKlrRYpQvVZxsKtjLGn4RwtQ23P4pYvwa0Kvb32VkgWhk3rau8YukqUzl8va1uC4V35uq8Z3NrNsSxqp7Pjx7RdQ5x7lwZXykg2+M4hwc7+MxMpr/33v43jWdQ0durPGrH1nP//+KU3SJiQwIBQ8DZOF3dzXfB3SnHPk82YzwPMJS0AT8qKm35pp8qYC1hHBBwwTGHhoGXiVwMeZjDxUWKjCS0OVQuNGoghya6EdRgKUjSVQA1IKCDExYEMJImpChIZaMMcAomkA+5E6gguIjYZDjBQJkM2OhbEDHQQVMgcGKBN6CQsxUAWsGCe20UoMPApY/DfPQYB8ZrxZVQyMmvyjctlSqCVtFRU8QEQTLnDltDDAcIzeX1oFabdFU4YcWgWrSx2lh+jlfFB8qRmEXwv4RzCvCrsNoDY7K4hhdxvySF7mLbV2TSZm8agefl0quQa+zt0Vaw/FpJq4zlPqJzENSmH5TIpq0+kmlsZwv07t2pmN/dqY4Z87+HcPt26P7OOV38d2fqY1MQSKauhwUhdY+ww/Lpp2ieYx51vi//EAAAABrH+VlfSOly0XIMhhklFm9MdjSHVyoAkzwUbVW1W6kZBdNLSMV+Urxxla/YVKHNmIHZ/LbMUn8ZI/cuppCv8bJULpwkzWRQRodrchhaOqSEAZ7UpiJopMZmqRo7mDrVNkyCnnQWnadNJDXlo/atImQrCIGZgRGpnrPPda0Thi1kXWtA4ZKdZ0yUfJh5doklg48LieIQE4QKN9H/lb1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdXblAjOcN04ww6FGs4bp4Nx0CNZw3DxrioEa09uCAAAABr/22IRijJjVcpo+vjMMMBQDgvKMkJurfTzBqRcVqAw3Nt0NEMQTBVgzH4NlRgviMFWgBB0ZKEh/PpoqhX0jmMhTZYBa0uaAk22ApyvGmwk/ZiDEXjYlhTsXRXomQcZAwfcom4SLKgT8c5h68ms2/dCHbEdwsPe9tu9U5WzUwnZ/UizqSuipeezC/aaVj3nbGTdmi0TP3Bqfcw7UjuWvuRKVXq1aVyarzCgmcL9W9dzp2aUNMz2VzV7LKW3s8rljGgz7VnK92ewx1zW7O62eu653u/3/P/mua3//zLmHN73X6I1pXvZ9KAAAAA1/1VUioHMCGYTTSo5T42i4wCwMWvyKnM1SyDkxxQuap4ROt3JBAOWIPBFUbF8fJQDRhS3aiFzYeISDGXvoCWoqLLnC41K11Xyxn2JQS+KwbO1wIePY5C3H/daz6qL2S1umUMdn8pu8Iy3fx7STeLz2tv5H72GsIs/NNYw1I821naO5P/Xl+s7m35o/j17eHc56A0Sq71tZ7b1+7c3+t5y6p+VWJzlndmpS3Z+r3d6bdqzadXOmvZTdn/yysV5r+Tlyr9vOpZ33//ffwy+pto0LM9jmvYasYtyHWa3o16FMAAAADLn/KzBiFfqqVYdOelOejBohgbcFAiYgWLJIwvuw0iYQmNusgoKNA8yBAHdImVtKBoYMGDHnXR2AwzM0uoRXIki96qbdE61DZGh1ARgsEh0HiWSzjkSiGZ/3dlyYVJK4BWs9GdPQy4yBx5/wBGtM6vyijr7gOmZQ4tiH93KGcpGJzGUpl2qkXx/laG96uSjtS9Pb3DVKtlquNnXLESlF+3Py+pIaTC7XppZfimUf5rcs7ySOjKqV4pdN36lPzDLOmk/am+5RrK7hlut38/5uzq5lrLne7//1rDDVr9/+P8//+73Xdf295xYnY5GogAAAAa5/IbNKYYOmRKX5PihP3bFiagrcEwjIACYGIIJh1qDo80CwBWsUIAp8ZBWHaDljmnsjA2oKg0EgCtM3GQRrSC8yYmpxkPKwSTIQYgEMXSdhsqgzKBC4TmKwkAZfiXC1aeGKRyQguj/Ylb1lOVF4MNDgTj+bNT0s8OLaImc8PcF8QmZP5ka17RzVklQ60zlO27gEGg2fxGN959BThyRTNO1LVpeajZvMd9C8SI7fPnDasklkkl93KOPByVhclc9vGrHxjdn31Xb6W3jXo9x/7R/4E/9Pj5pv/6z//r////53X5newTgEyp95zaRe/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIq3RPg3rDcKyryiRjDW4hPZk+jmnt2m+vKNGXtbrHWMqQ4mFBYOlRwBhpgxyEyZ1KEB0aOCv2mWaDRHjMMgAFMiAB0wHXYgIGQOfGzTCKsBlbegkaYuUo2a96GHHnIBQGqihMQjUKWmgKYCkBMUAROMpuNukaTSRY4mGTIVNgsCLuSpvRoBKFrmGEs9ftRNYr3S+EzUpkIJFKObZW3ssgJ839WtTXr7tJkOJMTK/qF2pU7NZrM7qw2lWvhnjIcYzNy+PyaVV7vK7koQyZuLK5HTympehqUxLliq7VakfmHJqGIzD/Pkl2p+dynjzbRqkgXPOXWaDtebls3jhO0erVqasWtVd85Xyxy3j+Grm8f73P993SW+7x53Xcv5Y5rvb+XNf3D+7rhIXMyUewAiryLmX9LAAAAA/f7gplTL6bmJhgKTZG83wAwtqRfdgE+2eB9EIWokxGAOFL0nE+eMyr4RMmlDzCotk/7W77XKGbuUz9OlTyG+s+G56ljG+K1NVw7slRjLacBKGzKUfaXZixosoGyTqdapgochqqqtNF0FDUmx26SSSJLAzIIm5o6LpGFBNS0zRD3W7UlrM1KMSE6k3TQrWpdaKdJzySbvZ115qRcIfCpn6iyQ8ToYbGv+pAAAAAZ39XUCAOOhikAKARZO4yaxjghHMGBESYzSxg+aNCpYbEgAMAXFAJMNLlUhmQghAKs1MZbC3xCtCoo0AM64cWQyIVKHJEvKIAL9SQyJ8alDxtGiAkHlqCAIDkCxQAFHhrYAYDdeJv03VsCxmfCgZkjkgoc2GuXjA02EQVt3gYszi7TJUqFvlzsMNsiLtCG8rXpTRk83wXy7q1PLVh5dtzGb8RjpuaiKBeuEYva3LSFRStkeS0ONAQ2KhM7EpleyNjhOp53CBSZNoel2I/Ij2jVBhuU00Jrc++vWExT3jfGvl9euHtNya+sQrVpSRxfagNAj+Hdai2bb0INPZ4zsIEHfm7////9sAAAAD9f82kG+1/lUcNDTpZUyNgwGkVCiVs0d+KaggQQNlhghRJeCK4m4o9xMOdT3CmOBrU7jAsi9pFOOj8Q5TXcntG+p1R61KygeSOngr0WRSdzhIT5gyZxd0EloSxRLM5oiqaoryetAmKr3LoXxiYM7UmN3RW7XSMklqUmg6+s2eTz1AwVXVptUhQXrUle3MbVhV1DFfoRKmWKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACIx9z4N7e3KwrBoUYwtupQ39Og3t7cKoKCiRjD14/f4y4BYQJCUFlchYPMjzzbzMxcxHkppxUHzMgNEszItMvLUxTLxAzMDecxcHMGDTJFoxSfSRV8SHYGDzQBQygrSNnZEZ+IIhApGceADDhBBYVEiZAbgwwaATERUOTRkAQJoSWvsXLoRhHSAGxGBgdlLtElZwiBw3yVD9oUIsaIhYsJ0qIqwdkotCphNz4Hya0FsUsUwXyy7RkJyWC9QItKUZINVbdSvnOGqNTn4dcBcIctVh4Q/EVvgwkcyyq6c44apUyGSKOeHBUcLcSdUP5UTIqVuGx6j1u2t0emH+aTt0us63nyb1Dj+But75k181f31jMn3f7vi1tV38a1je/i/xfGs6pvGPr3zjWryyxG/d1AAAAAfr/qkUX9jNNAQMUAiBx20xbEqvJxoSifVqxiUImLHUrFQXpYVTNmd4sAgi7BI1mMLphyu9LFZKzet9+Cn6Uui0Leh6IbsV6TB4IunxUm6xqOGtQYBy/V3Il+ue2oNnudF1vD7XR9qD4k88p1LZbqMLIgJJaQQ82/o+Srfb3Vq6m6N5zhiTXPsdtMkquLdMxUuOtUZw+nv99cXEXStgAaSk9lGseIVAiXhw2lH1cuVZUOBJog6Z6KCgapkBQY7J0OZTDS4USRlDyEjCz4AhQ2MuNAFl2jVYYIcP2ZMokJaYmDmew4KO2dGOBJj4iZ4TiqSAldfJhhERCq0F5ueuQzcRIjkCmI0cpkNMMAGUBRnBCXUEgtHJP0s2WxblSWXqMAGXcKgELBKccpA0y9hdxi7E4GIs5qTJJ0Spxsgtw5FlZU5QiGF/gt0r88ixt55PlcxrKcZ54DAo7Ft0rnJVR1yyq7mEEEX0wPpmhO3BGK/wVYXoxEZAnW1Yh6tgIUj5GpqeXVc66oqFesJRBIa8b2xjZaHs9mnU97xqRJJnmL/5gzWpOr3cKFFpeT5xuM/pFoxXxnFYmPvMDOdbpqm/DiZ3v0vNmX6v85x8fNaVmCAHB0CPJ36aAAAAB3H9yR7lLJrGlGjhrTsBRDUFMlamNBT0rOPDNlFKJoIJHKLS44FgdgzFPXPAsxA2eaCCzGHOp8G6KEPstyvOSY4E83RWvkiXydvHKHWLPafnHj/NpI2qwYknh0ie+/nfxA1vdt//WvJ/aJiHnVUkTd5BYZ7xrxq78vzT95F9/q2d1vnH1hjzWDIUJViQyTceDMeDsGCzyQsNFxHUpPDCDsBES70K/pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdidc+jWXtw+Y/KBG9PbpupwUCNZe3TvTGnwb09uCAAAAB+9XVHESQE1Yxg0g4OAX0meg08nKg4XgDpB+A2z19CEUCKxgQrDqZoUmpGLLw6QKDppwIGIYUNN3KsAODjYZNUjoxi3EkFEhX/j5cFioOWKAka0gGCIUsMf9t49aV+pBnCZq35kYCRObRynozRfFwbCnmmtRDWPL2FdHvVn4RTxjY54kfNI+8SXqqqPnuHmoznRZIXPH3GvdTtT614KcPKP4cUvLlXUCaFm8SrU4WYIEznHX5pVc4azTEWFl/fd2POYOqw/LWLv7w+9MYfz4pneY2MT7trPr9U3rP3efX394+MXz5w0p/6SAAAABqvhQpuERSRCKjlRfBpr8dIDmIBY8R3yqPLhA5oBxg8XVmKg0AF65kUiS5nC5nCYYjg4EtioJNIGAiAmZPuVXgGDtFAUKlbKCJaA8gFhx1pTogwiUAgUea0wdgimKPKjlG792VhAdliwqfLzTY/mNRWP1MBK63rAO46bKHehYW/4o2u4ryuGqFdhmgW28c9+R3tJRLNkZ1Cf4mgglFYmFM4/MZ5C3TLxptjK+fSWvFphJa34EaJRsdtz+G23bXcDWf4mru74pa9LR9bpj198S0392vG19fG843//9/X/+fvV/r7vbFfrws53r//53fO/4ofJ2t/oQAAAAH2O3o2Dm5CGlTipujPs258UarHlQ4OOohFIKnNIZpYZEARnKBB66TIkKnLV30Coo6yZQ4jYqVzBBUGhtJiLUxgCO+3VrzXWRiAOiHkVgkDxIGLKMJ8wyu2VtjhtKFQ9vWbSZI5Nqh/HwTGfF8otZ8LLco7Vu/MN24wf4cFcud6+mnOm4EaG3wO7hVeam2h8RxqxuWbti0/3usJcu8YhKN1757na25b7fZ36aVtbyxYFo+IUSlcez60S8eWDqkTONVtC1amJpPrONY12z5x6/GbfVqf11ILYL4c/nb0KNFJRkAYknSIgkwG/M/WzekEIK3aHDIVbmcEmhNkyhW8HVjCkllGiPskMsyAlMmXTANflhOZQWMslYoKMyVQDMLFnL9SIxxwiLrxGgcXTJBB0eNhzRqSz0LWGq9Bxmddm8o+wsoQID2Iw1GTAV6MiopcBYO9fZM26rd0VlmrvqePFf1q5ytphblfQoS1EhQvtD2SrE+8COuXp8Cw2UytccYUMKtrVTyl3JmQ51RBvDs5ZhTwr5y9Y9KTuPzLRkxaFNjUTOI30qPjcaktHPGs6Xt0xik2HAxUvcai6gKFSobB4BOEY/IqPGpBf/rAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJZ3TOg3vDcqpr+iRl7W4lGfc6jmntwmyv6O2XrbjlrGPEgOZ0QGcF5gwKmECRQ5qCP92jAasAkEBiItMHgQcQGelxm54YYHmSCQc4tNNXFk3DIGUxl1MuBEJBjxkBW0wwNMXBRZTYCZojhxYSghjw897Ykii7QAEggoQVGRMaFSY/M9DrY8CKWpOoOFBauoZCUwioBl+AENiga44QGtfRqd5UEefBAovpZvU2CXkrnsewQlnFt0uKmspcrs/L37d6u3WlwtxGjpozlDcbmXAsRjG1GJJIn9ziYROfrMdt4Y08afi3ch9yX/ppHx02bNgyitI3ajgbVaHbk19NFX23IX2m8nJt5fMWJbK2vTuWVDdzm7FTHVi3Y1lQfXid6/ju5zfMatez2/hctX8Oczw7393v/8NWd6wv4cvZihCdB4FSmgynYCHiEf85QAAAANY/uSQticusx0v2dDoVCUjSLockEECStsV7+ACVyO4cCnbwHtSOYfZqSiFTwRzzSgo2U71WiI4cYlTpNFW7Trs81Izsy8nzsOPULBHJA8xw+Oz1lKjMzVBzBZWeUpJbtOVqPItc4gmcNlE1cuInEyKFgamBk6KyVs+ZmqTqUaoU6CC01WucM5LOaUTrKq1mrqutZtSsy6lqonQ3IZV9PotFDKA+ecOIAAAAGvqU4oAhImGEBoOAJ/KY2KFz3RuNNoUyICGClQ+FlJnyQLKmE9p2A8acUiKlQ8oQEDlJhDhEwqKAVMmMdmRMGWxFDpSw5YISqo6G7EkwQZBmzBUwXNGcSs6AAE2rpW84CR52twtN9IQuQ6L9p1qagIOEAiAc/yMQqHE+H8UppKI4gtKzh6xGilXGHUsiHlrtuYgqkLU9YS5SShQA1IrFCTiikhzNblGOuDWE7c1O1oTHLqEqa187XORqhLyEvFM2pYo4TVYus6FvkutHPBRjO/wywp5Fc1WirtUs609eQYcONedx6WV7e9Y3LEONCvHpGgx75Yo2odtU+cQL3rTFPfFt2zjNtYzvESButIeH8aNSHm0+vnG8/Wv49AaLASVJgZCF8qmgAAAAAD/P+uv5m1PjVQMOlUFaNN1ZOmyeaBdms2F0OdXgpQu2JDx3O8DJSlxmO5h4NLAD8nUpYmBqATZjTTZ6xz8QuDOwbq2IBCPDbC0070TPutVfMKKyla1KQZR7r5+e7jiG2qym+lMY2DGEjS5Nqh1cu+Lkz5+O67eyVrm4htOvmfSuYptOqJ7dzExVLgYIlIqA/73lQih6CQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACUN9ToN7w3KXSwo0ZetuIo33Po5p7dLQOiiRl7W7y5lSohGbiI4cmGiLNRkFPQLTE/s8kxJwGIoGGArxgIYJNpkCsIy4IBTQCiHwh5Ko0a+bmRSIkYsIHpYxY+MXJDBUJJoGGRk4IPHqWpiIO64VJUDUrF1jTemOYaHg5VYoAkuZJgpabEUqAMKrRokB0RVyUGi8XjS5ZsBsMDp7jYFZ0hKms5QqlKdb3ijG2e9U6vOacCKY07TZHAUnvz8stz1BnWpLtZ+L+Urp57N9Yrk9LZqaAXanpmWzEMPvKZBi+rZX+ltyGmOOQ+0nm4Dhx4bPLb/yutEaWURCbvV/uRDtvkhs5Q5+6s9TUD/2sY9U+5OZYfSYyvHl/8L+HP/dTCvvlfDDX58y/lbeVut+eOPc8O2rG+2Mss8v/97/vNY2hR6Jdz7X2/90AAAADev+ZZwuOMdmBoIwxB8yd4uzRJWYwwlK0sZ8DXekwCWIBtCxcXZRuKTKVagIp0QBS3bDFgjsF9GULUu10goyFN7hdVNyPY85cA+upr0hpd/bqHfRWjXNPqDnFLUt1u+oh0IcXdozEEEA3bzaUZdumLR7vVQ2ztt3ttm6GSen5/3Nu/cdyFSa4SLK+7rUlLnFAsAIoQAAAAN2c6hCATC4gMJCILAiC2SmlVIdFDgZSx6CqMiBQZF0ZwcRJQ60YgwGBjHlxkSJIQafNuyMLpKFAMGDSIihDgcSKMuBJIFMyIaKjy3zrAY4NA5AIRYKZQ4FnI0NeEZINBCwmNpMo7RuN4LiusmQNKBboMGS2J6vR2NEF9EPvGjpgtIsOJZ+LVvuSkJJHVzLKpDxiwl+R23wo7O1QdtkyuWHzBa0SI/qhggD1iVkeDF0zWTrY+R5frMENFscc4VzhIQ5MKtgsfsFvtR4loETTMwztUBSLWMXcGpos1QqxmzUWsO8F9mHB+/6T7+MTWx95z87rj0xre903HpnN54MSNjwNxoOvqn9MfX3eEJCBqfokGAAAABhb/ccV650ruUxgKnwOLuNXqmePgT92IOe8yIGQgxgEJEGPqGUpnZB22aEYqmJW1Me+z0LyxCnHlZhVLKtKuaaryJGZE8eUps6KQ9UEEHC1HlNM1qHCkeG3Oy6yy+kpaKnda661JIMX1pIXO6I/AvGyA+GqKLmh4uosfQnGUQUklp60FKukZMkicQZRx6tS2miZmpbLqT6K1XSXZlO3ZTddfspnSWhMUlMpaZsdREp1QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlTfc6Dm3tynE3aNGXrbmSN+TyOaw3SgTBo7ae1uOZYy5BCEIUqi0s67xIAjUV7MGwQ0uPhacMnMNAjDWMxIwUPMOZQKeDIKZONEpa3YLE5zBcZDOjweBQ5zDMAYcLyiPloNTQQE0wBKRpVYAYe1IWKpmCAZgIAOghmQ48Q4AD2Cj2GCxioEl2MhLKCwDN8n0ocYYLodVNneQZFQIWEpHNlMgU4QCeR+DIYYLsn65Pxrh2XxTEnQ/Tgfjuw/47Ibu1YTQytWDlhmyqqu8HXFho90uhMY0FcKzWUIXS6VKa0oZlAuYgtCiSKnYU+fzx0wLCcbsskWOrID80XFduHcaNzG1Mq9ml1Ao6JdafpHEFgxO2tTanXDLcu5LRP4W6Vg217ax94tuBfeNwsXzWt3GKw7i7aotHW7fG9b/vXz5Sbp67jsFL7+7tUAAAADL/+aU+s7v1xWAwvSiBceSwIsX1UFwN+jCXZxSQbxhGJhUF1oNyOb0krcgpRXU3CRURyJfe55JszU6Wxw73puCojuZG1TZHUu567Qx9qsXIfHK0yZt1Shw92nzS33/MXpU3l700DqsTVNapbJQbT6YZvpFdtcT06Tq9yp19/1TT+2bnZf3X/8/z3X/9f//xw3i1DmoY2WndRAAAAA5bwrjAKCCiY4BgOAEYUvNWgs3xDDA5uMZA0oABUbmqYmbDESYyFAx64WOgbwYIAViU3CfSZ6eGf02xwMEAUSQ7hApoFCwTjhVyNCH3MbhgJ9mGF5kERnT7FhhQNWY6RIS8KiqXrYlS3homnYJQlYWwxgw4xc5f3upqWo0qmsZ0A4Kkp52KW2Y5YTVVPxoUpjd7F07tNqG9xWejFNRxStuHpVEJmmvRjt+7nhJV/xrc3O0kv5MV7sNRiipam2jPzXpolDMlnuatxypO9qX4xNzlHFKWMXe1KWOTn0UMv5nYoqSVSOmq1rd/VjLXL3JTbyz1lU5z7O+Yc1vnMN5frWsNb5j3fcb12pe+5W5jSa/mH7w7rDOzlupeyFDkUsjk6KcAAAAAAPef8fU2ceR/wuoY+Wu9i19FCvnQsEqQ2dzKNough7pWO9FFIacZIxKrhzhAkNbT9LEgpDczooUySZKrWlAu3jOhMQxYhJJOZmyAzH8xs5uYFzqda1neaKJBdSa76aBi6kC4pdJSwpGWYn2et3c1ZGigmca6TdO6V0S8owPW69SJxOkbKTPIdNVrspZvaBPo1JLlWjiAfPCzg1+bAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJPn3PA5vDcqyuehRrC25k9f86jentwog3aJGXobvXMpSMgwxSGzBoKCwDnW1NxBk5w+DLRoMuiklABgRYQuQJES6xgKMAhkwoQMkBRkiZuSAQJDTSowycGJgFCULIY6DGMg7GQh+fh9QsfpXvAZgXIltUAQTDJg4KZgHMnISoiSEEIABhoagwss1oaB3jUadIWNxoPiDppcGCAKRE9RzzW4bT1sZaZvB0qst0fd1sqlmkGDU1+zEM30nquEhonYkeEopuyzKIczzh7Kx2K2aGajroZV6WlxjN+UVpTGoBl81IbD/yyQ0lrKxHb1qciGMOU9WpMVYhGZy7JrP3saeX028r+MEUmWe4O5JN1aePVK8Xt16G5zGvv8Nb+vvm8ct/hrH/z1vm9fhX7rLPe8re+Z653+8z5+sv7zd3g+jK/0Sn+63raYAAAAG//TYS8jTpJjVMeIN3NCK8ep2fqlTelaj8UhuBl41NNTLjv/bbG1ybiUoSou8hjlKIRyDcBadJndFXvz9NGVZ52UwLJJTBth+Wz0DfTSdclqBXcIHbnRMCfPu59LjTzN3Dp5h66ZsfXcemeLCoQNHpM7fdHTd5+F6Yy0YemttuplGn7bpenTP8LRKKUp9zS1R9u5e6bimu/iZn/j//9tN4NpmGsbStMzKEAAAAD887ClZpIqY4Yjw2ikYKLHLmh8gudMFntgyWRl0Jw6oCko+mZSnGag1ADpYhLtNYWdQIcWsZ4AYUOpQLcxCFEy1gXeOtSmQCjzoQCDDjXEakClUNmSGGqCr6MGGKMpiSK6l9NwFkseKxIXBshioRDWM+oqBgUAhAbbWqBIBI2Q3mt4nAMuJnZvguUx1xFjAS6NmZU+hgeatOVc2woy6bGYgM71tbTQfF4O1xXaeYFfVrCwa4xkxst0aExOdyH3lgYITt+q8tkqmePH6LVL/DhJFa40Ky5V94LdHZ1pcQ4J2w1cjGNaZm2GpdsElpmSNXbTDymJ8J3MCI+jRPjxsU3fWse+Pnzya1ikK+4MNi04wvvF871Fx/vFN7tWXzo0aBsWSBKYAAAABvP/pC3jW7FLDqAU3Vh85jt8ugOIhb43VVBaCZPnwgXZzSPcVkU4V0Iuj4WdbHZeAdMrsxq9nJEuFemnHSoTDOu2SKhh2KJX1OE9SBQ7PT8OAuI9z3XHOslYNTWp6WZqJG9Bzy/Y0oI2DipkxijDnOVuzodaWuJpUo0upu5g/+dn5a6EO5uH50+uT5v4ml+uK/b/rbuNWHiMgLdA6R2gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACPp2TwObw3Ch6+okawtuoRXRPo3p7crRuWhRnC243qvHCEOmFQSAR5FlQDInMSu40NLzDhbBImYKYYEA6gMhCHDJXEABygQRHgYCL1jhKYCNmrzq2w5LR4FkMRB5hwUMEhkQi46CIGHAQHIBAcEKWrrVsW2YiFEQS6YXLw49DCBckXYoDitHR2litydYxcDkzDhoAjwkGs2l7LGVrZsX6SOcSKzs7UoSlkH186cWLTWZfOR5cNDDlx8YxlLJfM3qCerSOZfeCIFxvWpbORnlE/eE9GKtjOWcu5xN1rt7dM7WVSxchpm38uZPvuV/W5XlcalVO8FvuOdvL6S7bs08zjewt2uZYWr9Jqmt5V+XsozlvHeHMrfLdfXdfvuf5YYds3da1b79aYmbtexfp87WYFe8Uk1mBrLxadELXOrQAAAAH7/bRFKGoa7MBcyafExiBazS0BaratSN7dRdMYbo0wKE6tyOsd+H4LFtUfZfhXgvfXuqIqRr7lG13cjceXy/7WF2HJe/MjrdOsVUlovuTk/jrPmcX37d0VnYEKOY+rb7ILWRdUgeaSm3Rn3azpm4961np3LTMU6KO77fTIrj5dbnZXLnRFR8Vf7V7cJXxUmm+9qipYVAYDEiw4GoW/SQAAAAP7u4SBY0sGIlpQDoaoKnEVhsQUZSHhnzbMWHNa4A1GAgFYDo4iFizIaaL6BhE04g8hg0IsMLBYkHMizgm1FCSNLJoMMCUBRFW4aYpLLSQ6ING8CqgZ0KN4BQJqWK20xgAzvNwddZj/go2866UuVfkQ8vTRFjC7xYcV9YWGaj1LEZEYla7vgE6z5hU5VNEaMyMEa7cyaVbjGxaGnFHEzGjNz7edmO2w2mPAlZ9y1ukINvVEOMCkNmZMxZrNtoNnNmZ9zuKynVm/1eDFfwYTNdOOTpcP6btvWpWTEWBX5m38yzZfW3jEH+1Prefr5zv63Gveb2gy6gbimFPtZ8UJk3/3OfMblrgAAAAZc/bZEm30c2NUw7aesZQg0KMsgS4Kz1FHH0rZoxXW5RMvepgx103NyVqZCiNVuz803BWq7jGHrGlzlV8KNp7CqN/Xn5H68zOsEpV7bs07SUSTvQFLpqnoE1MzuJma5fRxh7HfbNt3b4tiZ6lTz3wlJuaulGXHKqTsFCN8rtW/a/+nSxsvO+2W/zNwwvOPPMqztS2ds1oxTKbDtvui4/+P/3SxnajnMipUBocYDqfs/1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACGJxz6Oaw3C8znoEbw1uZXn5Og3vDcqDuKiRjCG7YAAAAHN4ZvyYiAQAEREAmLDAoMQlA6OATBIGM0AF7EyAJpAVd8TXqAxwKnwMCGmsAEApDMzM4xQ1YxUcQGDTRpzIiUjotwmZw2ghLAwOGu+w4yBsyzJt4EY8ZIc6oMIL2bVbRQAIirLyADFacyBKbqsRb0spXhczTrJit6rn1RmWcgtr6f8E2M60NCSeTEVnFHpDlTVeXs5+blEm5SV5ZnG6bXO44xqmzvRixdy5UtRyi5VrVJBN3MLHce5/AUbuWMbUdr1JT2U0+Eas01/uf47xzx/OVS/drLCmv7/8O2+9zvVrd3WGs7m7ffz3c//1zXc//8u87ncxzxpsAyVHiVCErUk+0X0X4rUSSqgAAAAb1+rYYDpWw7lfAhSDwiMMeygku0EIqKZvvJHZS6qPG7VOpU01YG7MsUQ2YddpHxaQmS61SdeIGvd7CUQ1F4OYR1yLUvlFe5Xeu03mEnvOPQ+kYMEXTdRiZpksMQ1JY1oremtSmWWHSg25oqpA8kXDyzxuyF0DEeRmeHkblRKu6JiWomBso6Wo0GZ0F9nWtFEoLUmyS3r1mDpmxRaYopL7pLmdOit0etOrV7KX6loIrdFToppsbIILFv7yNigoaIFAEpXCxIAgx2qCcbKGAGRNUFyjIgMwCMJn5dJnSGZCFiqOAlciLXsIElNMyJLKpg6pkpiIgEcMgMLG6hQ4FpAqIGEGhkpagmFilnoEMhEXGcnS9G5IUmehRQJBzQkUhYMDUZaBNJiQW4JgouhhyQjQCDgliCvXbqCJHw9UzaOs6nfyLPonwn/F4xNDgJfLKkoi6g+FexAbsvpXmHnhyAZBN3YblT6UcY7T52nsl3HgY48kYrwl9pqP6sTsggKZjkcg2mYzS4wDXktb9TGURt1ad9HZpolNw1yL0t3OFY/M02UxS1LkQuUdTvNfVysXIpOyqd/GX8zvb1l/3cOdw1vuGOGt9y1zv1st16XVXlagxy/fe3//uOX9////sCnu3XVdaV+/WQAAAAG+fg9a62nd3NxICDdJj866yCEijKmgQRBC1IP1GoU3ilNMvCYqSMW5KrWMErCX4XSSVfKBsH425TYn3wlsPxCN0WWeMQdN/7NunPBfdFWAAvh4EuC8OBCSaauYp/ejo7fHdW8H1CcJWziU5LElIU4wdSSVBNwdHe/CXEpfl08T19/J00p+k1E+/fBixVy//////1P9xXF9DoulifboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAl2fE6jW8NynGrKJGMIbiQx3TqOae3acKeokYwteiAAAAB+9ZlQ8ZNmZJMPEIeFXoanOg7EV4HdEiwhbMHiSJaRnM9LDDBIkSzDD9Q9CQAARoJqboZIDiEBMgFx4bMSLjb10HHSDCeLVxUnASeBQcWMCULEBIRJYdQJIp+XgFAiMcadJU+RAJEgGFQaUKbsQQqBAgnW7KDYIAQgEUoavtYYqhn4nFL7gq/b6BsqyA99YtSYFUzkRG/ZzWEpdweyqdhyrHZHAVvF/pTKHwkUZmHcs5TmNBL2ydtQN2OYSp9J6XwTt2ItOymHpIuyvHJVT1G9na3KuPJDXtSuV8wj+cajFLNX7tyb1LKtuPyyll9JZw+n5c327YmfpbdfPG9lex3vv2+63vmP5b1vHHuGH46vdrV7OOc9uxu5uvjhzuuf+rm8rSLvd2xFRX+cnoAAAAH7/2yoyPbbnZkQAAcKRV9lqw6BFm4pzBr0Mymq7Y3bHAr2tPPCIfLUDRYJqVqz8RCF1tw4UKg/f0jwsGgKKQbDUB59t0EEv5DVPXognFrKEXAD/FjhJiKIdmj8sdzvHZVivU3Nd1dh7coe59wKK0iwOUkw8kqMunu2ufffm4v5t2df4q/GjR7BYefSilLQ2eqQ/s+oowYQDRAAAAAy/KZHREYYBAJCpb1iIMC41iTiBqBpmHlCmCAAxg5RWpV6D3piTZVdhQo7BeE1KMIRAviGozHjgZWHQwpkHKItvChh91AyEYaUsAT4ctX+IHQMkmtFDQJ3S3ZzRZglQcWUpR5Ko4tqXXWmiM54kUMAPcZda3CQGjaEM6DRQNpxWYGVILWq3yhRYcA0DGevAoQ1G1AOLkRlCWpRSR8qFtVjBEZYNFS1PWBwnYaRFHCZnIItmhnxRVpxSsrYfqmPRDuxu8qqdUzrhzhvYVFGliXaguV3avVSFvmZU4iXgxPDiozDK03fu3W4lPe0FTtcGI8zA1uXFb58L6pj31rOs1pLv0kxjM1IOncOH7zwdfEJ7PifiB4ZG9y4110v8/i6AAAAA/X6bCvNp8KwsjDjHF0E2Y1G1qJYzCzICjz7y2mfiylGpClWzXiYhIoS9dFU0xF0HvlkdVSc25nUsNHYpMQiIHg0aZrEUB8ZCBJhubkC+WPgmTw6C2TYqRND2r7uG8luhbth3+blCmt5p7y2B0mqpupHLTjXQuy55Qd3dW+O6dL0DWk0MwGWYFC5bbnFqqTooG6BgLBVTzugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIWnXPI5p7dKsq6gRvCW5lZds4Du3typo5aFGsIbogAAAAaz1iSgIziATAoiQBq3Eg8NIFY+MCDAg+Ej67wc8ORNHpRIMMmBGSBKzOWPkejXEmFnfYkzJGc2LdeAX4GwRDT4DC13F8DaDBoqCEsvLklzjLqzJrKRmQjJjTBCpgleHVCnDV41mJM2EJRPtm6e0yMBVhlaeSGnUIy8NKfI0mxktCLoL1lQMzCDDQMFujNRNunFfPPDu4zoU9WrTMdG57VrevoL17gwwyrtbI4tKjibjTSIG6upEKKAuYseyUitrpyVsNpq2OVGWEqZ21ZcWLMsl4EN9aeK/Zqa819Z+dtXnhVzvWNWtBzXVaWrWls/PxrWrU1jx9+kkTWK28vI6AjtJjpZswuqboAAAAH4/8yNFDJJVK5Yk0Nj46AK+rvMJaRhaIutxYIL0WsZO9Cmg8GMCIHWYiMKnDIIrPs3XGyL564XMTFtWcHidRgdppjrv5eiFrTS4apI1nHaoqyJsx9zrWK/BGDKj5dfazMNV29Ry/hGsn8iT3Kbc2VVMQHliFx/YmXJTghtbod3c1N+brm2WKb9fV8qN5//VXSNK9uJlCztHsVS39i3/9+dvVFBtrnNZ/zOia+Cg4BxOBgPjQVg0dDBVIjiAOTCMKTEwDxkEDJxc6W+DAYZJB4nBSqYUHmflAoCpFGYoYWAjCgk0UGRbNWRBkHM7PDb0J4ghFaiXiMzThoNMAQFnA4LApWaUmigORAjOS/hthGIwpuoWAXYEYeYINr8R8pYgATIQgTKWjKXI6CQEBaTxO2oZqQHau2kTtXJfcZHFY2ppqggmEOpWQbh5x2aA4HQzp1rbG1v8NuZo5l6y9iLDTEkuQEuCU2+Sb+6mlw9R7KuXCCdhWvVM0Tl8V7c3rTCcT6q5SqOZbthpKxYUKwuLSxu9i9jbJYDliSbDZrWWbDVbECSfceDtuxiaA8brZxi/1j4g6vW8Pd80niRH8J1HkhRIbbLQpGO4GKT6vfLoYuld9vqYAAAAGO/7MN8nvLKSbMOlDeRCEoKdzTFuMytSTfx5K2pVeBwkCkabyN96AQgM+63brwseeOzyogKh6XdmX+bGw6G3yflwp2L/XoZmtDF3tKENueGhoczq4ycNGCBfJV193qmO7adpgbeO5qUauhCADlH4+VOq7tz1HvFytDe6eFWFYPGV7T+v/iOEnrGzfxSJ98y88aTXHx//zMV9oscWo2AGH2f/rAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACTOEzoObe3CWqgokZeteJZ3dOI3t7cqArChRnBm6/DO4Og00OCDH4DJhO+wJCBtGHHDB6YGO5hMEuUJHxxAQLKBVBg6CDFMCJgQiwI1sYOBGCgbYElYWCzQT9+CoxmiKKpjDQxgSK4ZJhh+CidNhGwxIeMePgAQqxIkBUIBS4Y0LlrE/2VDQMKisFUeKdBgoADi2fHQVXBaVI4X6tIyELdmGOxpeiicmaBHC0ny90sFGSUniPT2wOaqcFZeAl4asWZ1PuI4bZcqBsnRMtGddxcNQ8Uaq07z9bG2RfY3SPcHBaYEjDQSbWTLW8L7hHWl08OFS2ip9mJe4xG9lVMJ/DgNvsuKNsd5EkZdYxTLJZ+xTrjDheHTw60xjE0a29/63XFc7vutI+9Y2113vcssXc2b4vq+6e2/vOPmv3/fXzvML72ECdAAAAA/P/ggOFa1B3vWQ1hNRjmJCcRcxnmej2A7yujTKEuyTFDURyOkwFrChy4nDI0P5WsIef1J6oklxJUSjT+G4fUt4UDcqO0oJIlLHokstrvui1j15ZXmX3u426lzfFSzvXh75Y99TISSkoVzplF22jvqsYyq+/htscu1KqSxw9MXKhIQWrvCizS7VafbEwHExVixViiAAAAB+e5ghLzHhULmAsBiQqBV08/uNaETOF4FMQWGTFkYwaZUgm8bGBmDhAkvhAuvsvAacVgVHJvUiPiEBNCTEEYMHDZUZyzGBmGxgRMVACZ2MwDX7LfAELMfCTAigFAbpmEm5ixMFhlFNItBMoArYq4um9ywQVG1YEhrRICDoCjsGWdJYRZHx9EDcTQGsVLx6nAEZjF7DWwcapNjHGyQpjPxTzHKcr16qkIUDthkWK3QtzgLK2/c25sT6eVMzeqGCc8E2unN0kE/NGerYlywqmx7kbQ6C2OoI/VebLGZVziQ1cshhuS5U6upHxCUzC/cIT1tXoLnrc+NY872CxR65rGbmKFA1HjV1v4+f/91xXE8SbGa6vTN8brWBEti0ZJzRmmzofvteBzk//zSAAAAA/H9tUXMhC+XYJMCseSGBbMqZeQQizRaRvYrDlieWcsAUTZrKE96y+EFbLOspUo6+T9VKmC/Hxsam3Rjyz4LlECvTVnOyhjECzM/QQ/AIZIgAMoR/tP2KovHFovnec+bh/+PeXProO6E2nTkDdOBR2MWunRK3J0q/j/7/rXKRmSxdzce9//adrY0pwVKHRdYdeZCx5hr+PQHRIM2JAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjEdE6je3twmurqFGMLbiYJ0ziObw3avLHn0ZyhuWAAAABlrtEOk5koYaQFw8GCorFmXywkxmXsQ8cJejR4EkZQTqGGihJQYGGKIGCmXhUGJpoLtIXNCYfGCIzQlAg0YeXjYYoqDmpyRGGGRsREPBDGpmyEAhQNCQaHvy3xghWNB5iZM9zLU8w4NSOkzNnxRBChSr++gasgkBi/xEk9IAHK7xEjBQHyLarlQgVaz6UgQy57yMgUNQQF5N3Q4+LzptMyWdQXOSClIeF5yYbXeN6mKeM2v9vcrcCHO/VDfJAVq8sTsUlUpC8BVHO7WEjFoomxzc22BH0/c4V0hedWtjCb0WC4PtMd95ljWxbT6JiFvEtJrW18+HrGd5xr63rWsx913Gxf6pvEx8Tgi5DGRyTq1pXp8NGuAAAAB+X+2BwUk6LJ4DRtvlSN9PxZ5GoNhfCNsadXkAxRD4HJgWOpnULlqF6b2/KSANWKYWZ+FR7K9BMw5rOGyxuW0uEmr36OE3coAeulu0h3xkuu1Lc8tzjLJt1HMdUtZpMPudu3ae+1I7Y06JDtNSOvuPczNubiIn4j61Wn3cvpFtf/brSiUzrC6xYGwCACNiCN6vVGnjb2PSQAAAAOZ3ZISksWF5lcSkQSJgIMqcyRADQoNLCHEANBAWMiXTSYR4RwaKzUaVAImBDgpinGZKECjibCiDywAUASZzERcyM8MtTwaOg4Sa0FEIxFMMSETDQJMFJEHGJg5ADlpjqqBgxUvkwclkDLFdIikguqaxcUCCgmUATWygGJAoWIWHtZfqUk07VpwomiPVh2f0jIrDSq4vZF25LDGVKSJjeEeve1CCaWC4Kt0NWpLKW9ahqW14I7fxp56rK2h8jtTHNuVFGq1V+WaRiMV6y0Yfkc5EuNrJ53d19I3X0+1qUVYW1mmllrLKXWbuOGc1DUZgmvF/f97J69zuet0W8Mre+TdPhKpTllZ5ewoPz7rWXf1/0v/hz8cuXc+7xv4XGDoc2qUlli8nf/jsrUfu9dAAAAA7vW0CmWJlSDqHhhWweik+kFsyEEMvVndpqbtp9zTosVgI0B1OUnX8hCmiQj+XfgMkBak8s/Q0jXYzu6+ESW60lsrSy9jwTdfCdkbmalrwMmiEGgaHXIatLW7GhFh7cgqLvy1i6PoGzY/vKxjYLckaOsyXFyA9EYosmxJR42UozpC5Z76cazzQhGzC46RxP/wnlkWn8qPi2+ai0auT9h0PUY/m3/XU1Iu92r9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJUnXOA5rDcqjr6gRnC24lteE4Dm8NysC3p9GsIbvLdSPjg1EjgYLEwkDkCQiUJiyVG4Q6Y+MiB4JChppp/moYRETwFViKaZ0uZweiKgwCkZU4meXhFUluB3MREjrBTYygKtdiGDKjDKGjeLYFWFdVAabw2GL06VzBdCKDRAidZ/SqeEQcwQ4AgHMZWKAkQSyD4omJuEQlYSHIbVuKxzFFG3xUEnYKanOCpItOMTtwSNKgLGQwyOih6/DN5nctcjjhwY7cUpe6xkFuI3aXPu4lcjsfnd8h2URytHoFnPv24JkVuHcnrgqUWIVK1lPZRYRq00J/4rR35mllcUnsYXU1MYardlUTd2Wa7i7lWBe5ZXKGzlyzq3er5YVZrHGnnL1qvu3nlc/8e87zW86PXKbGxYq5XcLN/CzU9dAVdR/1FGNtlvapU+j16AAAABvX8aMiOREvJPFUAKUl6BwWtDLxCMzfNVpnOflWK3Bd6OmUzFkXVuXJWkbMa3AK20gpymxhKAKmrZSOJYsGgtabcm7wXdlER1Ca99369qlSetVF9H42coweuSFj9lW3ppA0yKvtq3ZBQaqLOSqlFAulmtMUa+Ll562yqf2O1YtksqFmSrZ2Y4nvitI4lTpplXt1Kp10cgJFBRpJLd+ZNuBMQQZU5PcbVkRkUzSNxpugwFIaghTmGweEqcafRMFDBIQJjQPvIDJFAoEgUamGKgOG2ZAAiImMxJHN6V4YMCfAMbGDHxkASJlJUO1h4iYIIjwEacXw3GSEDYIXPEgZtGhhD8ksZADpfs0IjohAZgLgLLWBl4GAAYxc5cph4IqEKgSpYQFpP1LsbPB4u43FokKBemVTkaR4c6/KpmMD4Xdq43V0ww+cxTyyJQBGY/EN65aiktzu1qd/MbkSbNMyOmucttLqS2tL19wzHL/dNziN6Goc1BMkkV6ZU7l8C0FitKZBDtqK14eik3cq8szExIaWnrW5iRTWF+3q1hbv44V8t4ZS2tT7na/0l/7d3PKtllv8f1jrP8a2s9458r0mVjdbC/W5bw176rSZJmVRj7yIj/+VAAAAAcy/1ZAEUDAdWXDoQBAQ0YWckUOwWNuikAtKeZSuHL7P3lTcM5HVIRrdqpxDTohRWI49osaM7xaTlT4Yw5KOrMuyqMzfZ6pJcmzymYdWpCQ4oNDqUIVvZdBQseohmvX0+7GyDkmRc3EKOgHVy3OKRpGhuDxKRltrQ8kQYpUQ6qg1JMssjLmXWnSaGV0nwx1J9U1PxMXB9HxKj4qaV+ru5n7v/nm7oW0SRNi6f/YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACTdyzgOaw3KcDDoEZehupAHhOg3vDcJmKGgRl6F45rc8QFExoYDEYpAwMQJEqjKt3NrkQyMRy+yVRjnATIbQsRAAPIgAUJix9rwMrAaMZqgYRQXzCvoaWGVgAsEBR4OGkxalDEwhXj4gWDKjL7koE3JtNJuBCZGAgyEHmaOY6EM4FXCEH04GTEAMve+otDfVuogMqauovylCo5bvOatosWINo4DEpPo6TIpYFRO5ejUnVQJsVvbWZYtk7N99qbGxS14Yo6eWy+aypKfCpYwtPRGpXlO1ZqCWnWaTG0yGH+W6ltrUMzNLeT0g6rhKH6WVGZE+k5aiOOc9OU0ur16TLONblctr2mlO/QyGvlLbXb/KevzWOV7K3hXk9WHJRb3YtYYX9YYXMOc/+7q6w1lY/neXgOMGGlneJd+zfxNSJJYJLaP7NsAAAADW/9RIDDo/QPaUWBFgTaqeI0pGwvb8n0ZOrEEabicwANcAo7k/Q5KLtl6LFmIfEdJk/RqQdtzjtLq/RFQ0MP6ZgeMagj5khVNhMjDpbzKhxHp8ObT+o6kTyLtr3NIa6XFh0+WyGUFRw2mdlWaLiXbQ9rRX35g6O2UcPeP+U+uvOW5+xlRW+OV5RD6SphrqZoawICqQ9///0YZ1ImIiczU9NFFAECsyELKZNvn1NRjrAkQjeAFQ44ffpD4xwfLRmVjAQzrSMJPlADJVozFBXeZSNlZEYIBGxkRkwASlDxWQwdBiAY8OPwnsWVJRMeQXUVrIBMeQXXaI8jQh4yS7QIo9O6wFZkEgIAfBUJiQY+rsspkgsyB52abKIwurlANlRd3MKVpcYRtkNuajCl6kaf4mwuXUD0Tcup6a1djESrXaeE50s7LK9LVllj3SldiS361VT01dqRhyItS3qj1MluUEYizwX71yYpX3qyZ24hS09BGJyejec/av9v3KSvulsSWH6Xl3uV3WW+3q2NBe1cu83a5nS5Z3albvOb5//+tfhlrev/LO3Uyyx5jbzzywrdi8ewqmnza6E0AAAADuG9M+EhCYiBp3pJ0Z5ITqryMkANRUgUTIWZDGtCWkvoM6qAc0ijRWn7+XwDehb9635VPgQNpGRPIhtUAeAWluHgAWgBAjg9IX2FVuI5OFRgzDDb0Wq8jTJEWluur6jGXRLvc0wdB6o1HQoP2IpoviYg2ly5T3FUJDiqJNQa174JFRRC6h5sKmChomkNvFNxXCetdqsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlEds4DusNytAxp5G8JbmUZ3TgObw3CyzBn0awtuq2NaUkIWg4XzFwLhoHWBAgPzHcgwGDoEI90xgCx2UCFDzhcybgYECzhAhbc8BlZZEREW0304WDmm0gEOF0hy7TamPJ1xwIicbeaYBO4bqFzxk6HZ2cMmC7NDUwhAGjYfJRoKMCwVdyLqni4SG5iSJfmJDw8IUsoX7CE7ERZXcnnADkV87FOhxlMGvLNM8HhXLUpgMHZiseoJxdNfKnguNzcj1G5nKtRSmVXZyPwv5HqQXow6rlZ01aq8by15uCWzy3tTTSFO7UYpZZEH9naWNRVg0BXYlMP9Myrdl38ZbepJbv78zRXLdxy3voJZerVpfSVr1TKjys/hW1S9r2sakt7K7X7wz3hZ3/db7/cd2f1d1lvP9Uvf3hScZKY89kRyt+Fz5R8sVZWYgAAAAb/9KNNGKoG0KKp3ghGExswMCkG1UTMfFjDW4FXeizUIAZxhCfOMOmkdWI8aJNcdNBx5pRI2NYF6K0sooxGZC3rVGzsreWQxuHbKsn5tNk+G5QNUO6bIukxqukQXkUEv/me9ZCKPjXrY98sdH7NVgPNu1CkMaGWhfRpDF/Ork1y53wtuK0df1DzTVRi1Sz3rZWRn/Krqp2xD5U31DylLujdRjHXQS4zniOPd8qvR/+dveW5UKC0y+JDDwTShWDMFAQyjJT4wfMcH51gsDzIQUBrKYgjOTDi4cEjLBIHIyc5kByQA5gpUDC9FQw5wRSMIgDG1YiLQwwccRBQiAzDCoRCFEkWKhwcaoiTixAhYSEEIGDRqBBGWgABVVXus0veHBJeNdDzN0AQgDh8wEBpW7jxrMBPLGFDk4ZRN7dNLqq8GMAprONeculUxgWas4tiVim7lmXyKFv3Wi9frzSOZvQ77+U9eZrSSs7DTZHWoqSd5QY3ZRRSzGrC39mIlMOBHbtLOZxB5n7q51bE7OX6aHIHn4tMRSte3jzUru/MxjKU0VXktzy3U7ZxoaTDfbHcs+dn9Xb+86HmXPzww53n/hVv5/hdwwt4UHMs5Zbne1322ZW4+A0HUINaoAAAABh/+2ISAlBdocoTfCloP7CIXI7LGQd628SttCn6zWw3z8NYVUvtVqsJdhzn/jkTYMzGQT8MQSu9MHcrj/ZG979rYpp/kFVLT6Kw8rw1TL4uQQdoF+O0tz9PdAfxNZBe7Rr57Ul8JTSsW5F7XvOD0sdSPJnDYdzlGpHLLredOzMTnbchatXDzpojb0npLnbP9xfzvPNZmxfaNTw623V0+mWoxr2k7ZsjlEpIUklhUggAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI4HXOo5rDcKNJSgRrD14kgd04DusNyn6v6BGsLbggAAAAY52JGWoGiwGMZERiJgYkGXZWbgFJmMIrdSxMT5OGXboQPwU3MAcMQ8V0rcCLReg6xM6YZAebdTAhvYJkVJcUSdOgp0JAA0iKkXWXuLFAa4AwdjMFmZJhQYNABYgrkeKXQ5dTrSTtQGkgey7jc0XRo+ziNwQizCqGWx0Rnb2jn5YwttraqUlsqgpoz20XmklHP4KKZUkV5ZjUuksBYZSi1BNyHoxBUXg+dyuYVIKj2NNRwxL6WtixmCcKtZu9i9Sbp2nxW5OxKo7sxS5UrbUcitakmVy/jTTt3fa278zauTMk1hLdY8qZa7+88t18Px1cy/G1nvWNX7GeWu9y/9/zPXM+97rXNVMub1dHC4XbijVtl1nTwgXnKqAAAABrf8laz0kH7tPWVMAR2QQVq86UE5NN5L0dbtVRWHmhhiZNELLTGjSyBNSt3oGo6Kkk7LX+oPlDc1R2Yk3LBxHanl5GnDbcUsh/uGWXbY5d3rTrcutK2fCh1iL1x/rybr9e2MV3XFt7rXEWHEzaDEhtmYUFgg5xePD+MS71S14NNV344fAZVzCrSB6KAig2h02dOj0BksKO22J/XWdX//qubrTJAHRkqLoNCIvSoKIxMMMINMCQpDj4LlgkAjTWTfnk0TPCBVaSIgcGFjD4mpUgAQcEQABDTDpEGxnCUCVyID0yJgkyz4OemHDNJLZAZaWCYCbOeIg5kRQVPFBVMCCTNnBgYxBkKUI6VbiHMG/2IQoCFmVAxWeZYTCdeGa1YiRWs29tmbeXqC1XwUJmJNfbILVl01IIdVj/b7yu3GaSGKsFQ1J7GMrouy+ei+GdajvQFIuzLpPtC4ZyjD5u9N3akJm7NiQNIfuIyqZm2a009IocZZCovSXpdM9lnffa1T4/cluu0lTKNU0gmbeXcr1nv1tzWGO8d81nypf/V3Cv/95hj/8/8s/1nnnn37ljl65UwsW86/nK4/w/5lFRVEZ/f3vWuAAAABnOf7Ywg4LAZ6eZAF+SiSAeHM1Gml1ptu1RtHzwUMrumy+fbnlCyUdPD9ZuiwT9xSmnYeka3NWIq0lT87FZZNxntjl+G5By3AckudgezznYJNw/K2yRHKGffBXfPeemHQyz7oiGy85Ltm5NhwOVZKLHOjPITdNfC0yxvW6E0LfsTdT+bpB/9XV7ncVUu42bvg40AzytetPs486+KgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACRd3TgN7w3CdzEoEYetuJEXlOA5rDcp2r2gRp626/CbeAqlhi6MAwEwYHTeGkIHsgLhh7XQrcoxKSGp1jpj5QYMUEpEADVi6YAKfBCGmdmBrwK/ACn14GdmZhYcpIBHa+gUEiQUPCpEaDICnsEAgkoiQoi4YMEhEIKCxddciAQz4ZCgEvwvOma0xm6CF+0tS1bxA0FSClsGoVSNta9gedI63JektahKSFPJ1ONS+8h4+t2bjcnTgyrYyBsFLFYbce7jzl6DYIfbVE9msuxvr07jE9k/2W7kBSvGV26i4I5Gq8eceKQ9DssemKalV6UMrq4TMugORy6mlUnv2OZf/MsJVasymX43rU9dt8/Vy/VmL1nG3zGphrUtxvY/d3lvmXMOb7rKrhdx7r6ueUznlrW7fMbuQTCj2kNTbGrbGPaPWwAAAAP7+2xqnJjulQpaCdiOK9MZp2KVdtKtgFOeK8Q96YoSqIdiTagJByYLkCPxHNsCCzF7VsNNl7JmacE+yRMphMcRWXhRcteEUYlisfj5duF06/V2OuihfZ5dPyyalW4u2cfT2dqpsfvpw7U4JiW3KH7nZynXDXPV2Pu6RNHtUtlccfPxUW1Rro//mJj2NvcxbDBVHSjLU5QqgL0brUL4EBCMWAgx0IUE6pjBIxMmTYHJozMOi/ygJ0SAMEr2MhFAy8VRGqGJB3g8MFloXKhBVrpxGAXVgQsDiKJ4VDTQJRIkFsFKXtAJUiOhwMoyMQQ5D3AsGlcNZZwNexwIw4kC5A4kKgQYKo1H0GRggKEVnyFKlFPNj+0/2vyB/6VsSuarrxOOEAYzSwDHyRzkWZ+UL6Vpq7gqkjEVi8UmZLDlfCbsUc1ca3Qy+rT3ZZ8CXpFW5WtU7tuZy5i8cOzteM1HkjbqSmkgNxbc1bj6t1BdwjMA18IfqxiMR3V6vjzWN3CluawmM8Nc+9nu7ljv9Xa2fKHK3S7+13eOPP3ze7u//PPXefllrVa/2gvXbt3WdfOv2on8awE4N/ZV2fGL7zIAAAAH7/aibXhYNMWYkKR0DUa5b5unh4SEbJW4xCGRjsG0sGbNQE+qHHA+2pBJduSCHiTFPDYzbOlTXVjIrUaobs8pda7bzFO5KZIMlUZUqCPEOeefRs4icPZLviFt+yZtlPuZfTbcaltqeT0hm+CprJp6WpdzVotvuYQf90a29yT3bud/++riKf8x79ny9cNg+Dk25Nu3orW0aMZGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACXJ5zYObw3KdbCoEZwhuJK3lOA5rDcrWumeRrC27xqVYCGSMYYMxnECjoEagYiD5tmKGiBEQEEOADKjQI0HX7FTIUYMVQUBiEOopUDrwRGJhQGTIY4PGEFpEKgq1RWYSPMjkGFFJcIsAA8JFyzABNDuDp4WTUVhGElDKIAFZzPQCDi1MIRRK9RRqKrC9AQKuqgkAoYDQ8aAFEZMIAN0iL98SdZXLYdlLRE+47DMNwSXatzVR0TLOEwZKq7D1myulno/WhURgCHYFiu4nH5dFrrds6a7UzmIRFojfsSjtuy9NV7+1KBllnO5LIAfZu8pmo0ljWjWEnbDHc9XZNA0q5ukhVijwxm538/mP5jjT2L1+fr3J+/8/dnLfe1a+/7bypu/2ze1fw7lvv6y/8eXs89XK2srOrd+1ham7n49sY2clPFYJKd6o49X3tcqYAAAAGv/bPRwFXklrJVmRGTLoiT+4MbNhde64xXPqfd+cabXYtK5AJEoJ+u7i0IvCsI8+IkBvqsFyNVaU1qs+5Lu1txSOr+tahhZ0bkOjRdFgSgxd8pi0UIP1afy9Q1PpRPFzN3FEDHPhRKWIYj0QS08iq+sF1Clkz0WdX5Aw7qDaiJt7+O7oaMm7f99O4szbtD2ihGjT/SMhpiUpTrPKZCoWM0Ck0SBFfl7TBg8MNUkyAFTOoOAQDV0COhjyS6zIOyKOOqzOJVg03jdhwSrFnoUAMOPaHMOaNOLHgiSRMkZIYtIFS4oOb9oYUSQg2ZUOIonkK8OeglslpEBAzDnxAPQTCoGCGIo9A4/B75hYCW2TWikAlslCX0ldGz1b1W5erFA5W5D9VCs0shihegIpIqeWVyEsprWocm4Ye2L13tswu7fuTsojM/G8ruqWH5Y6Uvo24xqfm68lbyJRjli3TUcRqvszmHZqB60bi9Nap2iS+hl12Kv/amqS5S5YY/V7Xz5rGlrZUlepSyurq5X5WuTVfDDmXM7e9dww/m89Zf+9f39f/Odz1jzPeFvWGE/9Jjh2zft769+EiKEafi332WvWYAAAAGsf+yLCiZTDMSQ6gy0HBllxDF/nx1MN7mqbVKmJDEVeRu7EIFiABC8FunYmIyM5c+o6cMgbkaiHueICvdtnVp3GazdiAZ9lmPKZZj85dFwyX6Iom23JGeeN5BO723X2Y09a0aSs9DKz7WKwgeh6uQJJRDxl59j5pYz/aUL9W5vdrMuc+1RO227m+2fs7e2ymaY1yt3anB5xorMJH5fbn3Mf27+q/vu6fL5uGn6uIVDCfqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlpf02De8NyrS5Z9GMLbiZaBzYObw3CebloEZwhuq1WNMpMHOzb3Mz0KQmruEmsxDVONJziB6lCAU0+VEolToyc+CGwwIfMfIEeCoJmIiAyglCiRHhCZmlhCcZrYgquQhhQILAAJxaAIA5Hx/TGwkkHREVu2q0cVVJiNPEglj5VPwUZwAypShtE60GQKDRFBswkMDg0YA1+NsmK3nutKRARl9FFJmcKw0D8wMh0Ut1JG+doDbg/crh0tREvlU/GYKhqgpWyY09fDGlfWcmYHrVKk7DHx+2/VO+0ar36ql9uJfL4be+tqM4Leil2jgxtexCzA8PRaZkmuQRXhuZ1ViE3+c9/8zvXu54Z3e81fvc7jjYm6m8d0m8c7VWkx/PeW7meXcf1j+sP7lnXxw7vGZvZ02rEZl/7xzwyy33//9Za3c38NWWZ7r5r/IowAAAAN6/JZBbBC2PVwsI08IwIjXZVLFxZTbnx9cu5phsAPq49hQiMMrQDZU1WKII35e/3cWwrBIcm6ScdFSYPzG3cxlVaBncYj3GPx2CLegSy5zZRJsrzZk2WKkJta7+GoXuhKpupj66WlNzrTTXjCMmC621U2Xjh74ddUoc27IprWp1R+l3RGz/h7aYldW+XW6aZzXdVrpy3mann7ju5/+Il0zE3548tIM73enu6kEkiDLcmagEDAOEBIRE00xYDHJMMfCMKgZII4A6BTy0M1YRMlDTACQlIWIp3mtBQiSxYkWHMBW0yBk7By8BmcGhBQKF5zRQMHFyY6sJQBDSCFT0wIoS6gcxoeMVCzJzBL94xQlKE4CCqwZd11iIDFREWAXlYQBiBFGBmtwsGqbVeb92y7TqUj85CgF/M7keyREH9f/NO8HShcNw3BRdexuGIKgW1K7crhmryDLd3OR2YnKr9SQ0lmxZpIOgh/5NSbhmR2rNJHXs5nSVHownaLqnTvTMvmoYcexJKmcF/vCdpLUy/81YywmL3dyuzy1TduZ/fyyy3nUyt/21/M8p/dvfJzX61YpN97jV7jvtW53L8ecvzN76GV5y+jpMe1afP9a/n/Vx/8eYZ49tBYs8qjUtgAAAAb5+k7lrKTgyWs6MO9HFbktryNoXORSZXdfmmPzToq8eBcMqsETIYq4vynC2C1Yf5JRUusnqdBAbB3yOH45HJDXhp4Itq++sDTd6wIhwzxgjLGWOkm8NeydawX8fapxXLXHZLJND1xho8russdfHK3ETb1ybd1P7JcM02tv92krkDopm7im656vm49q79P4////7j+MZlHAr//QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAImnfOo1rDcLOMOeRnCG4k0ek4Dm8Nyru6J9GnrbigAAAAY4VI2YIuZoyB/A4IdszUI/sQTcEcpXTonfGFGB9QePBJIwYIzYBe4WHGOMjDsEgUsxiWGAAuvFQIOnl901UbB0QJFRALnWWg5WZAKaMukw+ZlywWJiVFei7DJDAg0lo/yUcpWeKD2A1EfAUEbgUAL1QCBdRTCfi5dXUEX6yS3Xjcx6Bw09njmQhcy1nVaWrq3Yn5VU5ZgSkf6kyhzCtblt6zLKSb5lIrcrkFabx+tTOlGvu8gm7TfuWP7Uprcy/+PyzOC3nqztiz9iV3p2x8HUWFnuN3d/v63vP8t/b//1jzKdwqX8+fj/45YVcc8MscP/H9f/fw3n3LLf4a7zPuO8sM6nAUBgO2Ccy9Aux9utgAAAAay3ckSSw1W3O4KonNONRNFrxRhLH89wy6BMGifFXUaYo8aiSoZSlQVqbJSXFxhxmHUVtxVvlvJfezTcSapq7+NzaXfuzMeX1TYSxn72wqbwWwlt3BaXUhnEARlkGJOez/3OuaUmSpYm4lPaDVPLNPPHCwC4lFbFmw9OhqGwQ5REI0sbVNlHEXTby7KSq/3KM36VG8St91aKI+eOwCIHCq3DJ1kgLtEyxOHwMKtNv/p5qhfACDYxyRjLgHIAMpiYrFZnvGmExuYFCXUMDggAocBgCM4GBpxFDcIXFclgkSUMYCyABUpFGNh4FMxIdHnYEAdKIxgzAQHhwRjj4AUDFA4mHx0iYE+hmguFAGUuSqUy0gKgEm+mMq4vIhPSpjsAISkIhCBP8/wwBJiPpHYhERa2MTpWiFrYq4FJAYcOzdj0NBQM5KJ2eTtoqSaweiP5wByCZ+OzWOM3bjcdnH9lsdp5Hy7WuTkT5hO4R2dszDkOblbzr1LUu7eZRFbcD0MfmIvHJLPwzOV8KadkP5YxyT9x5hSXr1JerVO3MLuNPz7/43ZbNaq3K1SXZZVqStr9Z8zywyw//1vlX95W/yta+zVnY3fwvWYrWz3qrQZ/uYAdiW0QNfR2gAAAAZZ62xsFBR4NH6YKBBBedpQq/F3xrwGI8zeJfYz6G+QosRMhtKHYTJO1SrC3qMcu2BXiaj06eQT2NKdubEih1Iz0+FNaErIrbZ7oZ2Z76HqrlDILcRaVewmX+r83qWxzHx31bdUkuVUZFmpHO0evSfXC1JXeudalSjF5dbUlbZbZq7p7qi/hOFr9OXeq6biLlNqqTT7Gddbv/46//6912eTptwbMJjxG1Lf/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACTt+TgObw3KuLln0ZwhuZJ3hOA5rDcq+OufRrCG45QTLRh0qGTDwYCCooFVlGDBecmiwGOZlIAXi7RwqOUHBccBJI6AihkLMLJSUmAIOYWbGVjClphByHLYUMyRWDA4ZEGWBYqMUJisaCgy5YyHmDAJgQgZwAuQYEQJZiAWIgO0wMabaRGpjTjNHS5LhNebo6gQIswRoTtIgdYrc4XVC422eapGR0Eeo25xVrq/u1rKAhdUbyjb0pBU+7cYjVLPTHf5M2sr1XKdjFu1L6TOelF6GIhOz1a5bdu5IcoclUU1PUFI9sfs35pl2M1QS1n78RR77dDYt2LNuWcidqjsZZ93c3TVPwrT3bGPP+pnlvPmFveV7Ox23cxvYY4Y7wuT+9a/HDXbvMse4Xu44WqW1jhqls6yq9+x+r/Nfver2ulX/KB/UzhQAAAAO1dXWehcd0mjSlfx6zl+YKpX8eyFYxGNR1AnLnhpHyRxag3NTiJkq5tlMXXwkeq9gWrsqctb1PWjbY5dSUkXjM3Wl8uizi41p57oK+teCISD7GjhBvLNICGhKBLNQgL8TI/+Od2uLIaL2PZ0oTmxCmCKVMHqsqxwmQpmvkoewwepjOwyB62OSLt/b48fZLQSzw92sVXfVz89z9V13/P//9jYtXhhVog23fV7nlKTA4iMsC4aTZILAUARENDmp8McAASNsoHBuakqWxL6j64FcgFML0tKJURmRRrl4ZpL5mCZCzMwtA2YoaCGLGwKa0cOSg4qZUQnuYASjobQoWbLrA04v0yKcOVt3MCnByVJdY5ZAKEFYhCCEmLuigSsRKkpXyIQr9IxLktJtrWgON0rwF6YZp5y8NCpqSUytEepGMILJSRabpr7tSme+ahEWgaarYVdXJfzKht0r80dNPaZ9lWxy7I8rkxLmaymltcdvGXT8Za64NDfijYakqs0NuWVqfcssVrN2VyKRfvHGxLNzd6czt38dY7u2Levu7t1Mq+OOdyz+FXmGP/hn3vOcywzsbw5XoMt/f3bxmL1qkq0WFuxapxEY8udrLIbK7/t9NAAAAA3l/0Rb9KBR+NIITmEWpKhsRtDKXYzb2MDX9uDYqrpEtvCQdlrKFDQlGtu2QlYsy2krx1POJWY5TrYscbpLHgt5vvZlrf02rz82d7v4P2WC7AdGHtCQtBCfEdQEjr/Ti3pVjv36rl0gosgTOIosHpnWIMM0jBFHb1V+phg6qKm7zT5lnOiElvrqpoROlWTFqMx/S3XLmViGqri////uJ6LKQc8jDR4u02RiG1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlJek4Dm8NymOwqG2XobmYl6TYObw3KfDpoEawpu+1azPQaLTIoIFoOYFE6kjAonO+ScAigAAO2OiE441EhsGDCbJkYAZyNEwc7QILHdNpAgxXWuYiqK4M+KTIEUvoYgBIYGTApVTgw8IlljhgYMCDJF8HNTCBktTFMALAwCl5ig2lkiCwdcQyDL8ZCNCthDJVUDAAYBQgUBV3qFpNUJYC2ePw7UYU1anqyBhC371NAyi40qalUpdge7Ymqas9sWf+Uz9RxtW8s+Vq1jGllMYhrLVXGkpcpROZyiXW7EOLwu1pvOCablLKeP9lSXIebrOvBewi9JGqWpGpfZ28M9S2aLnbVy1emu4429WsudwqZYY6sdzv0uf6q3s7Pfy73Hv1+4Vefreq36r/u/nzm+XcK9TPk1K918L01bzIt260kiSKa/mrb/uAAAAAAHDX6bBDpQA3DEkAPVqYiv5lU0bakaUMbSTmHSbSfJalkcAtSl/bSWB8lqa3qO92jdv1wULLhXP2bOFzdFJbW6R65zdAFB4luRD48YI0GcphX/v4/jibrr/i3k8YvTDBD+IjicjZmq3lSlYivt2eOJmWnuf/UalPFwbS3F3tdXdGjDchw0qN19//+VE0V4ASEJP3v1McsJGYSEYQ1iafGCBQlwYgMx52pGBRANGNB8hIRyRYnMFwo1opGRMzFOZsvsVPBw5MiBAVBAopMLUwgACMczk6d0xsPc8oezK00w4OLksEHjUEOQILAUxBAQIhpwxKQXWlqZSQNwTHDAIqAYMC5WCjNtIwMiqmo0IuBKAAFQEie/bwFnHO40ONl34FsOHXV240sbzJYqTUYczi7h5Mje+flLk4aeN+rUOO88MSnsak5Un6k9DMi5YuymTvLupJqkZtTU5BTEYTqfiMYuQ9G4KYLJ6WvLGAQNRyS/LH7p7tjKlo5dPRiNVqnbeFbCnzwqV79uLd7hhYu1fr7r43+W9dr5ZZZ2s+Yd1utzHWX47xz3lrn9x/Hudu/ct2792Yu3t4VKlnKEjdrN/SD24nG+f+toAAAADX/yHl+FAlmcnR7OAhdB76R5VS3soAkKhs/cgmApOkyypMq+7gQWw3TTOy+kD1tei+4chvyx6lOcvgG5Hb+U1p+LW5nUGWPqZiMGskJzBUpkRxQrVi44mR3srT2Z9zednnkB6tJzhFHaGyA0w5rmaORnEynqdNc6d57HqhhydDLmKp5pT0PM0OnseeynXN2//U90dnPo21S3WjtAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJS3pOI5rDcpruSgRrCG7lGec4DusNyoO6KBGnrbsgAAAAcvylpRgQoEAjCG0YJEZMDzDYMPiNswoBBpFpYGDCwNBkLBkubBSYQ2CGQ8EclJtSB4mavgKENQkMGJMKEExKsRhySHMgFG8IEoAOPvMGEzMkjHJBolApMolBoB48FpSbwoqje1hLoWPJHlyKRu5dZc4EF3ZpQNVBNHGlDj3KOLQQLIyoIaeoIDdyl0bC5nvmq0rHGtmt15ZAMRjtJI2sT8BQ84dakuSuntyjcNyqV8ygCWSyvA1NhQ6nOQRDNnt2kemk/Vl6JyX27TSJXaxgOVu9N36avao7d+tG7cpq7xr5drz9yOW7FWfwrav632tbubqV+UlP37eNW9hV5l/4frW73P73di9zm+WccceZ2PwvUu+77u1y/dzZjtlw0/rIqxzH//toAAAADuP4rbZknC3CQL0PCGac2eehpivewRcZC9/cZel84rsqL43CJemCwa2yScplmVttGv4S+Ut0dbPj/UUQo6e7clOGeXHuz7T6DodYfMx8vcrTc9gX/m9ev9PEqP4863aKe4xpJCtE8bdXDkXE/VTErCJVW1RKz9p+iRcXO7TcaT3dPdxGlVF1Na1//9f9xX8JvYzIHKdl737l2OGBInGEwmkRXjIKFxjA4Wg8EjC0DjGEB1bAuIgjP3hxGYpCZBCZAWTEFriFyIUhzmZe5wSbMMFTDGiZK84lRJA5hA5ozojBDTZQwiJGiYglgsABRYkFFWpkgSgJKWA1laYQOS8TRdB6RobBaspQNIRqPznuWPFpejpSqLpnQ07kyk4kjZjEOt0KFRFx4EnSashvQiQkVoekNHbU5oLtyndmQzMOWpbR6m7+M5ajkiy1jcn6tq3Vp4tKcNMYo7UulT7xqg7uUPLMQN1wJ6WUlmVWOS/dF2luTNNTTFPnUj9Pjazm52ZiUX7Uyxwz1rueV/fblX5ygwufhdlv713X/zHusuZfjhV3zf6tavY73Q1LNPaw5N4SblJRXUUKh4m3+fHGq85j/UAAAABvP/ZiXebM6MtLnncBMtcrNkR1WhpJTDsTdFwuxFkJjko4+xGo41jvLALYrVlrWgjylj5PIdzj2GA5rMallwt3q4NhERpWacUTyrLhisP65t+Vjqe+ZLo5m746nm+pfFz56VdpYXHPUnlyltfb6rdKyDp28sa/ZEsnmbZzHNwyJZVy1te+orvuItj6U+a/////mm9TfbIZTKTY5eWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACYZ+TYOaw3KgrloEZetuZbHtNg5rDcphKugRl617ylMSWBMDhMwSdQMqgENTAABMImU7dKgEKAFHlATBZkOWshkcbmOJmcQm8ds3dcKITLtDjQx5clqUXQKnME4CFwOJGDHjI0xB464xGoafwSLCzasCIuPPASVGggC6AIMhAOMCaQPIUwBg0KD0mXrKxTyKVjQ0dRsvrNJFgyWgKTIRlsubpAEHFVF3jGKzoDzplkcCsYDGz1FIUtBZUujE/BbbUs/e3amnjfaPUlmz/26W1It3NVqTKS2K9PV3bzeCQzMtp67gSmtfmJt+I1rFuEamdyubos7F6HIYm6lajl+F2mlUt3hEbtNNR6ggDKiw5rlruO8cbeNS59Tcuvbs1tYaxy1+ssbWv1+NFWwz+v+8s/v36lrDVu5Vxu2qSRZU9Jj9nHmX6vXQsBMAIjH71/SAAAAB+t3LwqBFXmiwWAOm21K82QIb6p5XDCdakUo7jwNAeu4fbA9SB2klCJdJRrZhMXircUGK/TMsrezOTNZIKvelkoGiK37hhsuYrOhFOnTXapvkU5L71/ub99MdEc9J7Yq2VPBukvcXTuE4bL5bUKKTdwrW/f7Xc7Zu6nqWOmGwe2W7dsb06+9h366inX//H3/6zo6k9HFUvCHzsuAqus5hmZgwDmdTCGIIFEMMGRlByHDpCYqPQ9CmchQvDg2AgIdM4JNA1NssZ0+ZhjRm1B3BQ83ck2KYxMUQPlEUBZkwA4PMXYVuKosOXJ3JfnIDCFSAhIWAiRA14ERE16GHFD1AeFCEKHLyQi+qdAsFlJCTasFkLjv0XgYmIxTXrCXLU2tU98vNCKjxwQMEe6M1HjLnq8ppTDZeNj07GoIWAmZDcn3bjNiU24/S02OW69fN3oZqVKDN+KaE35fKN2M3ahvHGNxaI6zrR6zOYRSUQHP3YpaeuNRaDqtBezqSqYpsKbsbwi9vLGrYxlnKfeOHa3bVyU4fzVNU5hrK9ewt4517PO/rfKXn/hdsZZc3q7jczz5bv2/m8Z/lLqiuTlelw7d1ss9QVROzEvvv/7KAAAAA/DemlgwCZdSBQCifMDjuEIniHZyplEJHXT9EjfQlDx4ZEHVrAWEgYZrOuFSuVERZ7NkNRl0V+axmRIMd6PDus+ZBVTjGDWLKYVogiviKjUOYrn8lu6672P+K4ru3RLWVLFTfX2P7zA/J+Jf3UPnf1MczUW7c754m/vaheOWu85hwCfFuQavp3//2haPneiYJImd2/YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlNes2DusNymw5KC2nobmWB7TYN6w3Kt7ZnkYetu8a0lZ8YCC8Y0g6BiLJQEBQHGOYmFcamDJiBAxQSQBMaUhSmEQGKCmyomfTskbIOvDCszENlMH/NE5McvM2gIgEPh1wzTAw6hBkZKiRJMIEEDXFRyG54ASFzQ4kYAsuccxvLIUEwQkAACXO5Ab/BACRrgTjeMaHw+yOFQCHad/cNvoENk2DvRJVGmlDrNVWApsaZjbafIYq2SHZbI7EUm6rqymjkNfKUz2FBRYw1R3YxKILsQFE6OY/tTsqcaniWbYoVlV3D0VoqkvhiVPrKX3bDEqKN1ZFLa+rN/GvVl9SSSymwrVaCvnXmcLPMP1hhj9fLCP5Sy/OS6t29S9xq//eWO549+tvVe7b3zdznd/jnWo6T92rlmn7zKn3P42fMIYifGyUA/fm//iwAAAAAAe71tKcsxDkdfkwgENUNrTVFzF53DXR1CObqu8jlczGIqIuVvY8wpRoszZFVivRySmMNsEYZOpNyxZLVg40re7pEao+jURzlAeIkxo+z4NL2wrXcVHtHazdfMvY3NmWFXRmeZ0HHVTQzxxfyMloqK0hB9zLPdaz98zHT1G0PHMvFHQtVVSmta/Ffz88u/9pfxh0DcTP9D2ila0DE0hLYolwcaGTAJqE+ZBoGI0wssN+TBY+BbwZbIAziEQIUjFKZESZ7SauK0B5zLygBoMSFaCXUC4UyLIAWgh+Sk0riqJKhwxgAWKlBcClwuPBxwGH1NDBYG/e0xgQkBll1rCIA50bBwt0wEOoU0URJm1F4dFqPHLZ2JB45dDL3woaVGrk1GSbMAzEWekrBHpmnUabO/VWkhp0Y47LNKeOSuenKSZqRh1I3lJY3KJfH7jdrMTuVc3jhjdvGuxygqbidmrdpn2hmU1JLBL5PrFbEOP9TdvxCNT9p/Za9k/MSumjuPdxC/EJmWb3SWseW6TmeN+Z1yfsWabc7Ymcf3reeOsb+7uta7auV9fl/93dx3l+eGGdj7lSl7lP3rPXOpo/j7L+v01TQOQAAAAP7quzkRAVA27NjHoxfinaVhxwR1yuCnDPzt4pgNjcHgGi5CySJkzh8EzRjZk6mFnU/TAkBwuEqFwUEhSBcXpzuNUKoeGNqm14ZlZU8DhrJQx5DW0+gIHTtBa5tSb202YOTV7bdXyqmdUhKji5fcVBQedLTrHt3vzR5s6ITgq5prLUNbfpy1/OxnSlUr1W+rfUpnabcwem76r6/np7J/lcLx3vkBAQnD69/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAI6XjOA5nDcrEOueRp6G6lpec2DmsNypc559GnobvLdZ9TBI1MTB4DEZOQuaYXB4TzDA4BFkQlqWTMU2sZqqYx7cHWbZh8LOm5cZCEvSuNTU4fzOhQWTrI2hFeYaI2UMttFGCguIPmEmjKgM4MDi2gYsWAhn0vokcn4PJF6n7ViWsnumsykDAQyocPAw6lNTrADwXhxpVDxaXr4oF4r+uT7uuEpGJP1fTnX7fnJUjJHs7lDGpbUh6X/Ebt/Knu2bsSkMulOXYrSYyp7a+c/lDvaacn2ly/CU7gOzG5fUlU3KpfelUfltBfnIbx3T4zU9TVKKLQ+4lJTW8aHdvcHZSyzUvWM8Meayw3yxWpft17v7z7lhvLf4Z95rv97vWu/++Xvzy1nbraprs3hhUsWYqTNLGQa1O9Au75/3SgAAAAOd3kOAEekYYbcotQG33mm8UtRq1o2ELCAbmXTGDbPlvBbOBLkbECxFuQBqpiQnrAljthoMQY465OBJsi4Sq23pRxy0YP/DIl47baQSe4RBahPIlHyAxAkeVkZ/RHtAxHz54RJq0OQlwiIEwfjBBVbedrPxDEdmS3ZBqG3vTMhEM9JHUU6TZCLUWNh34ykq1urlWeBw/fh2jj+q9b47ekqk+LgfBFPA1CKxS5n/Ry3SNfMOB8xAMllCQWMSggyE7jkydGFiGA2+CiQZsYncCpJYDoMGqOSOJAAUcUYGWnFcc3o40BgLNFLhlClkYVQanjAQILl2jFCQCDGmJmz4oIMcBCpUWcO2FRJ8RiUwoGJTgyAgMvuZUdcSVc1kBjA8SCxAeCxJn78o7Jqz9aVJwIXN0XrJi5kDTDwy8VnFYxBkBGAspi8F0IQOxayi05BcS7D79T9JfvVLsM35yKS6V0UjiNt9YrWpqktppFnMRLNkE/rKYsU8ZxikvkMkxrQvKzLdxuMSvKfncOyC7PxqWyC1F6HePbtLCpByxhbzqd39PGOUO6lJnPTu8KLVJnjhb+5jha3u7n9fmVevvPPn7+rhdzyvYyvG7e5Zyp5XLm+pETxsBay33765s/UAAAAB3H+MCTyUJjLymBGnDAQ1ZmhwDDqxLyuEf1lvYBAMpsLB+JzBPRKj9E6mhPTSPSIkILMMg+1tsYUykUQoHBgLD4E06Ou2rUrdA0kPhLgBDpNoS+HQ4JqtbL/3rq3uZia6nlWaEPQSmkCNKXELO/MXC8GrQuhy6pbzxMU4+kq3qmsdMtcMMHV3K3zUItyqXrd1KTP8f/L89u738/ujj0xi/1EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJJnrOA5rDcLDueeRl625kNfU4DmsNwmu6aBGXobnGtKWZGDDoYoARb0SA4QRjIZ+OSk8xgJhYhJeAQVC1hnZlwANQmeUiIrdgsxYQ2h8W+whHki4AEOZM26YXSmGEHKFmcIJ8lqEUiJmgFh0FRCUYUFhAXCxBC8dag5sVSCDRZoGBrqOpfuAy+7XUXH+b4DG2SQGzd+xCV9XteVuZnJDz1QDRp5v5MukluXWnpVE4mLet4P+jezq9nZzk8qzoK0Si1WtjKrUQllHQWJjkumdWZyNQmxZpaO1IpbLopnT0c1C+SjKVUNPSx6A4rnamrGVJS7po3d5SxqdeaehVuVT9nG/jrX0tju+d7R91z6XKIW8uZW6W9Vt5fh3Wvyx5Yra/ut3uYZ65+GXLtezjZs4TO8K/bPabHVcNAFTofyBIstjnKYAAAAH46qkIICXVpijFTClMoSNzsqmkFEP8gCFCPby8dgU24QwcbMC40QBbCfLe6Xb8tEPTSLq4izNztePsq3IlaEKhXI3DPEmnspndDwaVm5kTpAaWTGnQfBFaVs3bPlNf52fLGzbN+egutKliZBnZcTzeGdMfaQ+1bXPOI2aXfbphaLR62mDKPy2G6j6a7rpGNrN9O2tpOHHnX98RfX//uiLdLNDiLtvWuqmKJ1Mv13dPDhikYGUBCsOSAUgABgsKHowIZRMwsEFJFUugIK3o9NES8zJY0IBZ8AAZ6Jlh6tAYiDGmIp3GGJO+SLxG8XqalANAyZEuQiFoniMEm+IEDdguDZctgzRRt2vMulxgwrhPCsIssHCrQjAy1ZRMYjjuLcXmjk3WJwQI1txswbPpCLehmefcUa/Nms7AUI29HqQrMoaCX0kNVZRPSman4jUrSyvKq8ji0alN6KTljGUVcIYfjKIYzNPXdupc/tqW24jPw3NVO09+OynDCtTUvJZhS0+M9PZTOn5uy+djuFnDuE3Uk/Lf4fY7YytSqmq1pVW5rP/u4fnzeedNX/tvPDm8793DDDev1zuvu17+6/OcnsbmVq5lna+1wO4HTHquYiSoAAAAG9fk6pih2Yg7oyCL+KqyfiKx52YEUoRaYmXNlJpDTI14g7+Zx2qJIbTkbSdlWrSjsULmbjlFQmyIzSL1bpeieT2YRKI0qFBDDmhW3NrBoKHeokn+v4sZwW8bxfUqzkUg6BmNIKSoeWx5qQ9jCo8rvn+onbm6mu27itR8xWrw8/KPtcdVf3a8/8/c9vdJs8qnPU1vSETrUgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACTh5zYOaw3KaiXn0aehe5QHtNg5rDcK8LyeRl626yvTSdpCbTFAXDhGEBEOEJi5gnIRsFVSnCOgox8ViZ+8xoxJjDRrAIlZgJQI07MxoozAZS8QmgYtKAjdExQUEM3cMIQAp9NYrOCMl4OSAYMHPzLg1FiE6ZsIm4aECxKHEiQsTQia++pMhHS7kvyOG38AhhFWIJVJgomR+MPW1w5GlEXkdGUef6W0kdFxZZxBxksb+Wy88JuUeDDMn6jzcbi5oHjWeqtHlC4jDMZpZXCpbKbs0+d2HrUSqztSXZUsvzs0lDldlUBQbNSKMPfjZ1DeNqNVrWqlPLpjlJGMZXG5PTWrdPzKphZvTlDYv713DO7jTXN9lki1fxt5Wud1/75rdjfMOTXMMs9ZYbxrZVt1aSm+1hhrKgt9nal1S722ti86Rzvs7nGAAAABjrdRYJDNj8FWkvB86XkjMLm3bYzfYhR3mQyYncxJyPipxzVZKUYr451zbY2+FrZPh0Ozy0izHSqzDBoPICw8QhFhZMBkPTrcskHM4wPaZwfBNvEAEf7q+EmWhR6VG/tFqyiU9ZihUg5YbHsJSGRm5ReVWKrGU+v0pOLmSaX/kuB2zSuBqQCP/n/f3cy4VJofx0vLljN/PzxixjIlGFR84SgJiQGmU5mZqKhkY+FviQKGLxyvoVBhccY9gY0SUP3RbmOIwhaDkwkDHYwMSuEIULDgauM+ze0wjkIOCSsRi3uMKGT8Eh4ECPeoIYMWOBwN+pxQAZECQK0E7cVmjxAQD2hNyQGJWhx5XTSGeolF25qEygRnLayuE2knx4WobgtAQpKxGZgqjpYhfggmhYl1JSR2Ixi9aomJSLLckl9HYymntq7eXcit1ZRQNCk9JnAlLLY5FX+/J9KSUzcjtSirFZdcsyl45XLN0EPyy3SZ1IxqctfTxCO5X5VYqX/lV2X09u5bt/cr47uboauGdqmxu2t56+5U/uGX1sf1v8LXL97u+dwu/hh3CxWx7nvDlTHG5/9vidpwseYUGmqkV2JIAAAAGX6qiEVBAqKVMWEVgDFL9y160AZSQV0W1oCs7Y4qQrFIIqJnBHcsj3XKRYn6sVlEMO+GouXUJQxyPzBH40JSYux9pCNk73a61pzVAJ1zI2HCD8lH4locIapVD2Zd52+GfE6Oy+Xxve2kiabOtJiTDh27Va+VF9q67Tm08jLYp3MJ29z3M3bvdLGsh8X2/teojdMsOCUCh9ocJIYo8+0iXGEkgmkVLuUh7KP6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAj5fE2DesNwnkvp9GXrbuRV4zYN6w3K6DgnUZetuvw7EDJ2QzckCCRnRjAEYxLgPgNNXWUpbGJEjW3YKLAhXk24ywZ2mMGCdk0ETAKuED40gcmLiI4k2FVpvB5bEydZSkeNGDBJvo+kAhVYrNJ6mIJFyCE+LTpQrgAgwIHGhdGoERAQoMe6ZMeCXIEQXdd5fLTxYUBVZsL1Y9RQHCmcK15anBCDDVJNonSeLy5RJkdiWyp6otdym60MODIO3bGXY/bme0sel0ct15jbuxjCHL8un7NyJym1WlcxuxenaR3Kr6P1ekEKocKkxMO5b/5uZuWc6khcL6SmktTHt7PK9+dq5zGv+890c1XwuyC7+88dXdfvveY/h+Gv1+e8dZa7zGtnhS/27GcKm7l/OcsZ5a1ct7uA8gxeXO73xPaKoAAAAD8/zQxJCpy23wzkkWUA5QCjIhOFCZ0An9YSiyF28GiOuMK7MXRvobV00wtiQTrmswhN1CuYl0+nWtww8dsWurHdd4eHCPjM0H0yQpg7O7cB77YHL+HR8cz7WujmZtikMTXctT7hM7UxDKzq2i/hrba+avZu5ll1pHnPa+bpRqz2Uz2c/9OvZnJZRZyWO//cZ/dQkToHHkmhqj+/2kfEQHZn7GW1IQZ3DTGM9QPNaVGvlQWM6JaMqDgsBEghhSxmgruFQAZWSAABmwbIwKYNYqWkBmKGhkih0SxjQZi1KAsBGCKCx0OiCgxKhM14wieWTDBAcncgSNgJIONl8OOCBKkVTxdqqeIoADjcOtyTdHQrQoMijCSDbaS9wpaW2z5SNHFsyZ+6RbZM3CR9ETmTTNbFwpdaoLURizz0/aeF01y5Xxr0tPn+dNjDU5L5RLbWWd6matAtqCJVD9bOA849IbTD8ovKqsZry+tE5NhWyw7bz7ar0M/TSqTTU7G7eV6pnQYfc1j//NSG7vCWxufs59qd7rdfH9Y7+ryp/3b2FzX54/Xv9zwyu4U2OsOZ5Xsq9DyvBZ4rXFbrhfs/NyogAAAAb1u4/cVUIhtfxBcLziz2NRLcZ8JLm+c4FJzyfBgkEhxBYmMC0ryVjccxnphrPtuBt0MpZXAKxIFW+lJoXIad4ZvRj10mDEszVhoUmhjOCEOgtHsvUI++CQQa0WQA1/qLT6ja1mJHpt7t7zc/KiD0Gv5chrUqynJrNz09REk5IwN7zu2s/b5ore+W07k+VtV3z/2xsKI1yk/bb2t3cJw/ma2/NRW2oirk7KwPNEgHCJoRoFfFv+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI5HnOA3rDcLaOGeRnC26htek4DecNyoK4p9GHrbr8M2yGHJwiFSYrTcIRUwmbAXQZictlSOUfewZCEzMw7UwRQSTpbNUMKnMKBA1JRo070VPrOCBbOjCgR+SKIzEjlomQBJopTGCAgkGos+iVYGcr6BrpgCiwKCsvAqdTBE4oCrvjVtG8ICqoDwKCUyGAMFalGYkuAURRP7UhKUL8yy8MnaBJ5BPiFLNYnHqYulLL+c0y35yIz0krP1TRWX6zo9Vo1bi8SrWq+FepRx+pAcbkNeQx6WRbcup7lXGlilJKYZjtSIT9NG6W185cntXLmEuwpJulszcoh2SRGzHrdW/S36W5bq2/3y7a/Ds1er3srOP2e2f/n8x1Xtfvee+VrvO779rPWN3Ctq9rLu/u4Y/26RtTiIqDx03LYYYAAAAHNfsdTBh8ljsHiGwpiIlaShFolCsaaHGZupM5wiWJQ0oiAvaiVBXdhTNmA9SPQ/KqqYTRoMongSbkD80cTdaKwJfuy+bebbYHnzntR9udUfaVIcMnDxuTdw6+1A+Hp8d9XVtrYxVW51Z6lj2uJaCPSDB9ZWcc6mOuEJuafUmzDx8/datMb1EsfxUNdaxo4pdVu6ZcdoOm6Osqu3LzPH1f1zdv5bb9za5ew88cCSxRMD//6suVnBM7Cwa5MMa8JBhtsKYwAiIoWiKDKMUtKhQ0sAgS0A109qaZIwAi5tyTujNJgqjuuWBzZuOfEZVIsEOZhFEQ5adWsIIUHYYMzmCS0whjnCUZwQcWAtn+XWrOSmvO/BAWtZHZ76dVyKJbaGJXF15BicH+hh6lWy+MO+t1cMaqVBrEjxoXiKAQ7lRNglWMklOcDU8MSa/j8z+UPXpXEqWxvOrfnrVPnYeq/LpVKZFbgmV42/q0lutTxiV28n7nITT4THLv3b/O4VcLNPeoaC1SxOknsdY7q65nhl3vZnP6+5ZjT08q/+a53mfe/+t4/z+44873Xdfz+91+se1t55/y7znLu350TxLkj1jP2gAAAAP3+l6CwHOpYsSWEvCT5qIFCIzf1euRq5b1CiGjYdSlPhWq47T2E8Hy1J9kJAah37ih3H9tTXPVOObHH6WPn6VyMeRpohYmtGDQmAZsd9IOqJH09cqjmqmDnPHW6evhnXbuoheOGm52Hmh6ns4lk0yt0ouOy5kU5vHER9cOb9sq7XYyZ/rhtcvdO91zcTu///+a/590cR2qAToI5uOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACIZ2TgN6w3KyjonUZwtuJeHpNA5rDcqDr6eBjCG4x3OP2aAZmvm5EQp1mGFxj+2YiAmMBrcQoamKhS/xQ0kmYJiy0mVvsjCZs4VC6FipDTugqTJRrwEJNbpTXcsagKWhQc84gGlvk/UKcSYAYkKVA5syzbvuZUsKnUSYyjY09OhocdZgrWyFvoBLUP0RFZbXcwZJFKSVyUtnLZiAGBllpytF0OiXcqxpngVDMXM3P+znYj8pfbCLxOxrtSbsU3zk9Kcs783O6pbfH9qRSCMqa1Dkrs9xv4Rmdry2mno89sfldfOvjZsy+xWvdsXqss5RzExRQPB8z21jnaw1nlb7e7a1yhk1nVi/jh+OOev/8//X5c3r//Pv7z3v+4//9+5+eFXwFgbvvdOp498lsH/pgAAAAZf3g0GIiKSKQOY3T+ptXR0A0C4cmcKeUqMboZCk5nKy7LLGfQ/MS5KFDgVjm3LkLElQuU9fH+fzS9cZhs0qo7bY7cT+44rmRLC6tOzUtxuBwyzsEznKj7ujoRR8oNf37Y6azpRrLuaVbRbctcnNn0DAcdmDmwRPOnbtWzsPOMPud9tuWtqYuXtfZynjuWm76qPdfT5h6p2tl27atd/PxxO2Jn7/4ZMXEdn1Fkn/+rdyJqKGI1cZSF5QBhkAmECEZWhpqMEhBKcIwQEjCw6bYLthIqaNemyPPmMEAwZekNESMDwM7CcxJALl07QajEC8/ZgybMm8CEMDQCAE0pIHHiIGhe+psZ6nRAZPEKZySCi54y5TbWPAgXBhcpLKUHCU4wcWfqVDAgsAh4TGG6PYgCVZOORUDCWoIjKj5PS1CIuQMTyrWLQ6inlURyTxq8mMm7w/djFJF4xa1N09HemorddmguX3jsby5BOMGW2sxmRwZSRyvbgmU9gbFuMbiWn4WHffCZm5/dbsTs2aCrGtWZVhLKS0/8PQ2/tDLIcyvWqC9hfv50Gu4WXhocq0VpaWvnPyv8Od3bz339Y73v8avO4//cN6udpaWvV3hrLK721hy2763tAtYJLYzfuovz//MKVIC0sQYGQSF4FcKWeAJ8KHUzH2O7hu0i93AaE/L0RadeprpAhLKUwbPLpabIX0wEQqvGb1I6v2Ba2pXK34v+575S2rbaPnRMW4gCZDhg+KUoRJaBAE3UAUP14qt5m+EHTajbRMTlvNiVXSQmEyUPIpDeE7z89YFCWWbS64qLS2eE/JcWR9outq2u3tzRtPHDVvydV1ZZLwXA51iv/0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlXd80DesNyso351GcLbiSB/zQN6w3Keq9nuZehuMrsqZ6Yi9mdrCYxIIhQQOsmwfjmEBDPB4qNQOFYTMzwgQEMzJng4kvExoYyCoUUqylVCas6RfSEiBhRgh4jhhG8qPR4ivUqkTIADbGBGcog4YMqQIpUbBAo6BVLwCGGTELcaBFoy961QqTZKjsWk4ViH8FAQsKCwJc9LmtpNMeDYhppAsqQT1t5CAde7RjpBpcJmLDjq+xmKrN5fNah2tGIblcGPxQzMtjcq5PzF+TW8rec7uYltScnpY/Enfe1NNfxsTdmLy7OGoMkLyS+UvpAk9MWLd7GmgGbldPTU2eMCWI7fqN7uvGZfTWMOy2pR425qg1bqVIYjF+9GqaX15qlvX7/6/8q31dZd5u7jnlzu//PKr+W5rDV27l3nbEnF2Rp174I70d+b9a4iAAAAP1u4spBJbbExkmPAcCA2cZwbZLZ2UVnZTLeXKKaWVIG6J0OO6VDBbMmIECG+qRx5xI7Sdum2BRSBnxWdhIpNG41MQxk+16UrnsyPsVfKfvS4fSKNELMbFNKzV/goQlzksuq9Hq2sup0Vutm2dF8vhZsPse22s5aTB7ItZ5rFI052ijtbD+oiIreyu3vVb2/uuZb75dFQ00ubO3d7qe5nNu62v/7uvhRodBRppFP/R/LFOY8RGdFqoCADKgacNXHSmZkwCreZkLmJEwsxMMYKg5AMaVQpZwKFQ5+VmCgspqA8xpT5CCjQoSMb1ICASBpVuAQuFSCEaQ75F6hxKZ5w5QqMO6RYmIhrlkrkeHF1yIgy8EBWpzbQMRYPQL5HkrRig/G5xXpIdbsmmX/CiXnmG4XAV6tE5KxofXZiWZVLKsZFYY7Ls5+zAVNi4i63s5jHnhxv2uSjCAN0ktqWb8aVvktFjAkJm6XUco7N+JudGL+a+IZjcnhqAJVabNQUtu3nJZfVwm6SGOSybpoJnZ/V/GZt/z6C1y/Y7hZ3ZtYXru7HL09yXUtz8eZf/cf3+//nO713v67+GO/q/UvY29YVsuZ5ZXP/W/w/fbm6I4pl+Vt/f9QYAAAAAAAABzn7RdTHwlTohX8zAJZcQXR7DLHnlQkZZ9M1CdpVuDdQxUMyIM5Tg19xy7Hq0PLJw9BZ4bWZGndW5XQk3FPfS8irqi7Efdr+LgWJseJhjwIYfHeUAwRfsDU+I/iNYIOvc+fx8pqMdjRQGh3iqDGxYbEy7tGPECFdrP6b7pDbqUu6XiPhr+X+EockEKEi6DQhOX/3yrya5AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJN4JNA3rDcJoMeeRp624i0dk2DWsNyvGwZxGcPbjfcZgwkxAV2muuAAjprnQYWirlpTH0wzEbFnBogJIWFDRoR48FaIOjDKHwLAWoSEBNmYU4DgaeYVHmWvh4QXNOi9SPBkQxkQZiAd8aEpiG+IxoZQmtNF8RwY8gjXgYcFwKD8aBhRlRABKwLdC6EBtMQNUPDjUpScd0qNpbt9lww51pxojZhtEtpX3qjYoJf/JYV/alSbV9S5yO7IXkjDR272JDlcmrUry7Ddib5MSPLU5XbJbo6sklk7NWbEuo7VDDFDP8mo7GY7HpZAcy89SW3rl6S4Prazi0QpMMYdlEas1MbmHN/vOh3+s/yyxfXKzZn3/oZm7Xmq2GWW/+9jrWH4frHWst//Me679FvPtb94c7vD8PqfrH9/h3n7yz3qvwCAWUIFc1cAAAAPy/N9lkYRtcojhkQZ1OgwCYgII2WCVYJg05UMcM1zXYiKGrp0jyYGODc87kZJcLYQ92D+mTCE0NWKjWJEPrvY58ETMt0jpaeO/HIvqTjb5Vta+A+G/Widj39RZbPvl3sm9k57SRhLxBsqDR8TnYl03fCXUNe+DlzO3q6lDq+1J/4uflt9K29kr026Vjpq7qa/re027b044XXgMJKNMobK2IGjyWUfRMNFkaDAMzmy2pJYlUsQqAILU+rSVBpizBkWLNRg0LixLqgYwZBwV5g6qGfEBLakA4QhQh0GFoDFiYwCMiGZYF3YCgCIAETXABQUmHMGRicMAhZklEr+RAEgrMyykaRfXHbbE/iDlHGIJUcRVlsSmFoI0xJ5HUERFfSmmfdSUtkVlmchrSmUQJN5VpDDU7O7obuNBTSzHGpPXYpnSxzFmsm3ao85TPvo830dzOVS+/P0r6QA6MDO1KKWmjWFFrdqtVnpy9nE+6i9ypnnGJfhT7qcsY/j3LOezlE9Hs7clt2M69ezuzv/w7ljzWOX/+u87/67//3f7w3zmeFrGoYj1JX+f1O2Z6pAAAAA/uq44WkvSNVQ4gKE8x3Vi5bo1nm8TNmWmI9SzrlRggJWYWuBoT44qedRURbvCeZ+4CfMgruA3d7MWwL/mI3VeeHm5NAxcK4rJAtfWDK4Xdo8IYtLEfTFFpfLZCm1MxkAjQ5spLW9N9s58PWJMRN+2bbpL92iZds2N7O9sh6eZZ6WjP94h3lp8bwwx5otfLb51eekOlKwI2LZ+/X/Vcf/WMw/lm9YsT3rGekYTe5CujPlUqHHl9Or+sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACRSBTQN6w3CgjBnUaehuo/4FNA3rDcrhMGbBrC2419RsZlLyZ8PtcTKIQc0CdMRFlLXIEl8isjKlU1CokDH5hFCDUOjJYFaTVLE3BAAOagGpohApYDBU0nUwYgVKqoiIDExlWBkgYVEZEoFN8YEY/YpjRtJBTDGwmdPLMGAatZUDkT6VjQRfwVAK8XOAhTgiohqcJWBT8Ii/J2jEEq1O+T8ggL2xe4OkEk0UOaYir6V0skTN5SamH2q2O07jynmEzLp7UY7JruModmTdm486Mgwm4eb6g2+bu293L09nLIo+/0GMHva4kLguISCpcnZrs3HNWbsptxndJL9QVELd+xUytcsfbxo+W8sIXGtYRmIU2VJrLPKxndtbw7/2bf/z8P73X/lr8ub7rPPLP+c/HL993r//WeHf/Hf/UwPDzEaCAAAAB/P0ODh4NbiJKDC8ASDUcnQgQZExcWsnAnetoSowtdUSTWc7pyHIgXMCE7URwD2QtbkZVyUujAPsmCbwNxWJBw0atUe43e4Jw7Py2EwwTtAOh2Otw2WgwbAE6GqWK3wa/El1duOnmesaIywOc2IigamtFjx8UddpTQqlIpRlHi0I7rKKMri4eoxrxC8V7tC6x262MMih8g5Cf+v26/r2HbM8UhpfdJKUGA5sBWZECooO8Z8ynOowkAkY6eESkxqF9qQoIhz8xqdHYxaU0aIWmoRKKGNBADYgKJvShkEIGCsEOsCwstyGF2El8pGZ6ATAxCNYIFAICeR0QjY69gcebcFFnHKo+BawQld0aIySG1glKmOW5fMgU8OYxBkxE6/WpAuJICJyzwaKL1bDVG/7uln4fmX6kcEPfU7TWpZj9BRROWVbE9lhEYw90lm5mWR6tWc2GJ6zVycO7Uzx1HspxlFvVNDkto5JH6tuX1a9nCrlP2sbN7tDJb+MeoKfnMLl7PtfOal2FFk9F7HtHLtbpMNZf393+awxz7vvO733//ffwqd3zf81n3+81rWv5jrfP/+/9+5LsV9YhXDnr/rOYUzcqbboOgTIyBIZC5wxIoyx+9y/dQSX82LwejNXYhCZpcNVMwsGbKUcjtpV5YIuPV1+JYkxNI3SoqmpoKXjBilE3G2gYt7UlvY+mfJF62UADUD9UHoEHkg2kM6TEbS67s5fmB+/hlTBNW/WvzUhHnrNSO95rY/QeglkwgnbqqtFilwbnVIk41ji442Z4iPVZdMZejFtlzHsSg+avbTSQnuRSoDEmiIuIi9nv0mmM767ejsVftQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkTd80DesNyrWwJ1GcLbqQB5TQN6w3Kiy/nuYw1uN3K7wFCMNO8id5HgzaGL+JQF4zOSU6NTHmMcIQBo2BljDJZ4zoMe3mnFJ/iPaBj4GUhAgZAA4QYt2QixpMCRRAEBgEh0rbMSGMMERaFD5gwKsRn0rMBow7ohBiVVxjHBmSBRwpJ93LY2HAolDa32Tp82mJpMocZ3OKJLo/P+5bPEbGnUkqZAIltMo5+Vi0eV6BVCeuSCtlUeOkm3Av8yhuvVsSSBoZgLTyRfk/T3nSgmxffyNPhK2RPrIo9UgmB8H3j9l2pmVy+jZ7KLbgw1P/Ul2VFYhi9OTUemd09jVPXv03JRS1bOPcvwzvVZuM1qKnjdXKpnK7GdJ2xvWe+X99ww13+cxw1n3+/+u6wzo+9sb13PCwymP4/dx+of0HR7Ov66AAAAAx/9sKSAxmEZyrOLAwqQlmAI0v7skaasP+LyNASBsLYjD0P3NPGgnZQma7MfhoqklkMyulXfAtd2YywfCOMmtNzuM/sY2ZXLsqSVPRn0Cgzc56Y8iCtqpFXqjUdh78zj1L7ie5SX3TB2u0JokPe+zRhILpqSksPn2nJ7k7DjqZ/QUKKdbXWzbf22Y2xezSb/uqomXuTeqdOuMFrDpIoQTDJX+crMDR2n/+n7txnqGRFLRyPBckMiSUAzsOybFBGltwBC2wCLBJsqF4graDCJZsaYF4zHOTOP09xpQHOAYROKKMTdDlQXHkB5SZoBwYHHhIQyLmmdOP0nCCuxCBMyAtFhyPAUOyCsNGBItILcLORncZn5e+mKgWMQocOwkMVG53hVK/UbwbuNKwiUxTicqZrUPiELQcrUGQzel+eb52q7luPOMqppiHKGh1BTuxGDsIvjcsXXbnZLbi7sVZyah2WWrNA99JynpncrPA7mNK9MSchiEamM47ZeKtL5Xj9erL6Dc9G8L9rKTU+dFHaLKxuh/G7cpN0MP1rFeU8vzWOfe83zuP6s83/P1hj2//6x5hW+5ljey3T5/nfz39zqLRrPq8FkLjPEu5uQAAAAAAAAAMOfcZoTBwiZIMLLTXwqF4xWdbT0RZ0u1qVrEP3H2nn0c+RqfTkIBKekD1wI1+EYw7TJ8wy6bzQQoxYZhAkzKuQ5t48Zm9cYBQ02eg/EIvrOJkw+yZeNDeocy6c69VfVsowrqRR1NZItRqSMCm1R02aglRZ0amUtlpopGiZmyK1ut5xSklOylXuutXTTQajNVIsmYnioEX9H/bYkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJYYFMg3rDcqZMacBl624klf0yDesNyrox5sGcLbjlyq0YzAlFp6STg4YGnEQtllpRkcAu8aaihpt1xAvM+cEvy71hDOOyygtFQ8M1aNciMiRVkMyEFDJ9DByDA9GXGOMgUIERQUDpoGoCkIEIkhwsGqQMiHEpljEgLBdixfABEFgwh01swIhqYjHsejoCMqhGQ0rfAIQMjZZMyXJNRv38uUhRiX1GxPyLSf2HH4EiW6tp4lv/nt5HglmDdXaeWFTlJFbV63EO6yypJXjP33klmc8+j43pE2K9YlkXn6CQ3rUMw5D8B0zuObXahHuxuWxyRRrGWzNeWw1nGdw1Y3IpnGMUs5hX3W/Wdizl2/nd5Qy+hh3OklVrd2lluNLjy73DLmufh3X67+/3vL8P7lrHv4Y9ufh3nPs63vH8MuZ77vLC70qT6vVb321+9VRIomJ7XSpAtzNqjdV9mEgUkyeOUJybYsUQPcc9y/iQRyhJkCpAA5El6DvqOVTPy/JBRsBgzh8C7zl6T5/q/C7yft2txahM1Enb5AnleILL0lTJebIMEo8vvHZ/r/HPTiNVSlujUinon2HpaQT2HVyNZ8qZS0lPf0kgSlFVItLdcVpWqxrHTPfEvZXE8dsZKkNYy03H2SazF6jUPa/+tW5q//9Vf648ZqJ0TOVWXgkiNvMhpGYy7J08sbYlC6tnACOHEYmEFPcIiQMhgxECgLVTiowN7EA9gBj0hCyE/Jv5CYZMzDCxljAMmjhGDQjOFxYXLr4AqkmRGCDgrKhzMKqaCQoA5Sh6gok+FwjiroV9wVIUYcFgSVq3lSLm1H8oEIq0IuJlEWYheeIU5DUnzTeRvv3byZDFt/bkUVnqSIvqxV35iALMu7WppTz56LSerd2/9aAoCgp145ddZnE7yNKeqyicg1rHwXBsQnoZnqOdp3mtUGc/VpobrSCtE7k/J71+7VoJ/lNUqzmtbyv6wwv/9Sd7frYzdLz7t/H8cM953t5d//7/N4Y//4Y719TudqphV/HLve6/+/rLvdd1/2R4gbyfd3R+O9v//ZmDq9544IOXw3TSwFWhV1KCuvNOZwbDc2BMZTyyXgrYxiKp+vQLTMhXDfJD1h4hFb0/M8zxrrR4Za8RSdNosBLJb6vIoKaDPwzSwAsLjC6auIginrlrntVJpe+R2APlvoN/6vmF79Cq4QvdNmjoVXXV2DtomJuL5VJ1E6Le/uCWfUVVaflBeDrHHFatxzo2rr6jn9kUyKvpjGzb001XtdEafOj1/0OE4x3/2O6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJSnbMg3rDcqyMGcRl624iYdU0Dentyocu51GXobrdjOGDXh0WTpKmmRA5gI2aSLgkIECKYXXm4OIuWhIQqNuHGpjLSUwIoYBNIGIcTUGjUEX+TINKcMBoBK8yrccHhgoL0SqGPSqSkZ6YocBABrQZVEiIaGKzChB6oVAJiG5ZEvGhSw8mgFgCBAK6AqEsNfMQDZUPE6jcUmhyb5v45FoiLdk0QJFKEyKlUxBU4ZhTYGwj1oHy6VCUn4yiTXpuYVnmG4NtA1XWFBNvBqnpZfL7GUYiVN/JmzDVHImKQLTQNHoEltqw0u5QPszi3uXvw6j8SZ/aaGZBTUkB5WX1sTeqGpVv0OdzG3Ywnq1Lnc1/3s8sKlBjKK/JZdm8rlmfzz3v73K/cP/8v3zm+//563zmOFitd3ju7S+BQ26/5XLHm064/0FT3uVhAAAAHM/tFvt/LCAAH2O1AKqUSMU4ZuDQLgNeczTeJSQ9uL6o8MJLSRgSwExDhj4Q8DCqX5xhLwmGg97lKHo3SRJQviqb4qSVWVJZmA5SxHOcYmJm0xYojmpiZq0CcKazGm5O/iu5d1aTc7K9fDI9E847BIs5TSo800VPH7VWawujdRjmlts+88cptcNt1TVHP7uL+qq37nvqfc+0bcdA4NPSei37Nz0X7P/3p/Xt2NHCCIyjK5QECmtKwORkUyQPOUkzhxQm9WBJKODCsY+YXDGIPgpkPCUdDYAQFyMWaJChgzYI0G7ImWLVkOJrDyB4G0S1ugCcmZBpREoECJDBhzAsxYS6Juwyl5lgM0YtSGCWCucvgMCqKjghu7mhhrTDEEA6IJVtISRoSiSKMFcUqAwJmDphNpKB4iBR+8IO0beuczKzIcTx0cmFBGbOyw3DCzVou82/ju4ideIBmTqIeGtQq1U/qq2tTNDCuGk4C2t6HOZB2J6rJZ3lzwcGZ7lxhyzePHhaitdMwtX3BhYzW9fSLPTTBWFeucYh+mtx8w7Wpen+t1+rffp/rOM+Fl7n4uWbWmC0Kw44erQEvx3sgAAAAfv7peyQZaRPOEuRxh0gMkEYipueavK7CJUSEIKMNY6Ryt5UDTLcOdwch9F8Vznl4UhJWg8D4BkKo9ENSxFVX4TGjMqtsF1UUdxpKIgDHEgeDBWJFhKdQwRQaPNCGJv5r4rqVe5LviJ1F3tVvPGOwhB+uY8043ocP38QoOPGnN3TVQxJSUm9b//iIvj7ppuyTwcOg8eesZan+phk+tKwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACT9yTIN7w3Kga9nAYehuJWYFMg3rDcq6L6bBl624rUMBFQHGFkId5LFAslGOgBhY+XjGCo27MNkhCY2kZjosZcQBAo6aPxkhgYqCiw4KhQYpAIwMFCxGJGQDhgcoXYMMFWAEgCZWEhYXBziy5QowQDGCAwEKQ8MPDRCBmiADjmBlpQVrAkR/FQ5MfIKhb/IcFJpOhcKKAUgFH2biqkqoqGRyGEKbOpK70XI0QdB8WEMXV5Djcwm0Xq0SijV6t2U2LE3H4vMTEMPdQb7y9NWrcGR1+5RN0lu1FaCB4bqTT8V7cswmHGlsZqyTC8+sSuunAsXbs/cMSCNWs/uwXVvZ0M5HZdu3hvCa+rUqzNLlha7V5lrPHCfq38svw19uK1c/mccO503M88b+OX/vDWXf5+9a/VcVt/ApoD0P+3jNN/pp1qXd77H629AUQnBWmyComBiUMMZK0nFrRFLQkZT0emWMBmSbYtD4SYwyUnGLEhzmLaTJZeLlDARklrEQ49AW7w8k28Imd5HOw8Yc9hFUfHi2VIkBbATgmMD5VEUPmgQAlNaCARXyH91rg8dF0Ij+sRQsexhjudVwDh79CKflCcnZlOecq3qw9kdH7xDefvH9fHxvY/3WmRRlDgGde2mlc/9VJ166MZqUrKNcABq2WSrAUI57DMDA5sBAVGgv52CMio2QyAU0CIaCR0gNmdIAZrGmUh3M4AEHDBCXMiROGfNMMIxwJIpkArEYcCChL+CEeHDTQGDAhWtEy5HsSr05hjYsmXffl5RnfwIGSIYEI1L5EYdoIhDvw2ZCFGSK6iTqlzXZeCMEgBJs/NOSRItwmbEb0DJndZL6Hu/QQ/ds2m4ubIaZ+pDvGnemHIKswFK6OTRnOXTNu64cQoJbNdjcHUbUpVyM07FdS+GGyQC7VPKmHxxocYpocgWmoYPzuRh3MKkza+/L9TVJufpaSrU1Ha3MMa2VaxhdwrT3c+x2x21jc7hdw7nY33HD8dZXs8P/+fhved23uplzP7/cv/ueX//Mtc3jnnrPdn8jtpv67u+fvVCVskxtBTo+nWmoXXQIl/w+NL5McgZjzHsnRa5F8iE2h7wSQRQc4rHsUXwDwYipT6iAk11UJh4SzJwJZYUs7nBJWlV921FAtNbDZBiwa6eeo1MyWSRoo3IYRWwwmCDu3CFfti5YjFwSHuuHtcgxIdzzCEEnysNSvC5Iiz547CBnxJWfVQlxqSunn2Jnt3Wdt6r3V+xv3U/G18VEstYqaFQMs8l/f7DJw3na/+jQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlAgkyDestys8y5sGcLbiS2ATIN6w3CayynUZwhuqtqZT2NHkAUtQKy0LyJuJWCglVhIuHwZhjRMJUH+MqbFAKrGcIomIahB5JMQjTRlwEEEkAOKmYGHIkhR0DmxhgYhaJcEUisjSDiBAkAWUADAAESZL6kVtLkUiI5QKLDVkPlNgo+4oODNxEYNPNyAUeccu2/oOLhO4DiI8U4UIjpetmttwCUGF5RmdGIZDSUccTYs5YMomc8Ze0RjjTXhkN6tjVo6KJWpY/1rUSjXPzhuXSyQUsimn9qszuztL2TSyxSRp4miSiDbLcYfeZ5aGdt3IYn7VXClwmcItYprH0lPNV/v49llNWs91vdjLK7K523nnTapate3a5llT3sanfvZ/zV/LDLL/3ruX6wq50l/lvWu85rW983rm/7h3uHeY5bqdTnsxra/eoJAUKcOqMqRHG8v6JlgMQpjw7Q6rgMAkdemehMyrOMdfl84CVvakm7Ic3EdczhhGcpTfDtQ3HXFa23tO52bryeSYZL85SVq0hrdoFKLQUOgmKnVySeEcyea558FYJBdemW1/1nGHnqP+Lr9VTc89KMlY/Gx+zjE1FHtWUKIlVI7K6BPJRwhNKKOtk4kouldRO3p1O7htXMRbJPPo7DFnMOW7t9tteDDFfm2njlDTI/76erKzTIMiFkRIbFDBmhIYQoAJVnSowHslhlamHDVDxEBM8fflyBCaMewCDC5B0qY8+aAkDlINAFUObmsJTkPAMGJXBMFOyHSDLiiRYAXA6xEBAWBSgYfLifwz8VngYHYoWBi/xCTHh1cwxFshiizfodiIM/peiUE0Ys2F7qhEZkLl0g8W06j4lhJMOTSqgC3HXryiNIw5TGbE49qkpoNldVqcmsRrU3M4vpLKd3pDjO017UqjUvuy7semHimmxWsbVMwWzLs5XDL6U9d4oomrQutK6XtxzL8bswTLvnMaWvIsLdi5/3L1+xyno+/zK9/aSzLrmHPq3blDT8p7FTt61nu7nzueX7w1zm/3vX5Z3O/lh3PLWeP/rW/1/fw/Le+Z8tB8YP26EkAAAADetwZt7K9QtmHkauFQEVTZBFpiKtepOxHBnd7sJZ20KPu0y1+LuUEREMJGJq0SjU5waLL2G25mxNuRTxyEPQ5uEawbrfmMo87eACdFCKJc2nE0niNBkScF68b/MzwkpjLteY4EA+WkiILgPGqHcdnnX0MR5uimEZJoXm+o1XobSK9z/9//WSoa8NHy5wKjxYCs6v0Mve5AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJKH/Mg5rDcLfL2bRrC24kbckyDestypGvZxGsIbj60rKgAMlBESDEaU0MpiM2MbQ4HrCDhwN5QoFMxOJUhniJVPLDx8VEmaSjUR2kfDEpWaoollgdOONHKQoIJFtRyIYROHXiQi1oIInZZhBwiRCJAZg0aoe5Y8OMk+MMOR/qmFKdMACgdQ8zIIkHBBWdd5LMxI1OGCyb7/s64/6TVSxXJlNzi06MxcaYctRIcXB26yaC9cM9tMlsvj247UfJlsA5yqP6s2Y4/UsbBfjt6YtUzqzuM27UGy6tFWQR+zeh5mtiUbgNUEpwgNpVJEYPXNO9w3SWZTupKOR3kq5Z7XntV6eZluNumq3rOsO73jrLXaenq67ZpreWOrOq2Of6nea/n7xx5d5/8/uWtby3Q2M/1rvfz5vu9/rH7Xe7/t4LGf0IjmAAAAB+OoLEkbQe2gUNOiNgCuSiTANRYlIaZi6muXJJbQuqtzgR6ItJWOJjLzgt/meS4WbBUthgzGZvKVH2JjyqOvF0b4F+5SNLk2T+ylCLUESZGSBujZZNaI6yl2PxoPjIYVk6BhT8xr7U9sdprQyTx5sIG5+hoTbbisqecPGhCuNjYsLY9Bu/PqRZyoOmVVqMq6rlJk7a4jmP3n4jiammse9URGgqt4uaiT8s8/CxFS3Ib7mJ/6vvV2FG1pREcO++Jn1uZkgDAonSAUA/WjKFNmwWDAAecwC+T8kAI2aAMWLyGUAWGnERpwprB0s7qJaJNCWuVKRjGgsKCwJPoVOnIOI6NTHXRhQxcURhyQIbpGUK4MUURTSTMQBplMRp4mGp6LjpMsB0Qp5J1SiBYE2Qk0EW4slOp08KYCEtQZ07sQIw36huZHSnnma8FMdnYzfnK9E8Ehhd+Brdajl7oQ7G4y88xUvTMZnLsSf2jlNSVrHaMyaguypr1qUTMPQ7DDqX5LCcYQ19al6xSxKxKLjZbvPhMrl1q9Yt1atamnt0v3d4SrPmedXOzjbk163jKtWqPDtTW6nN9xjWPMs+4b1++7/eGGu43bwSDCEIJudKh6Z9YrZmDvv+lP6QAAAAP3p6QMJm5iVhVQErmv7SlLnMzoom3yWVrkzGWpbfWXMOsUrHGoDwpLpqgNXDLp3naL1521srEVFVtyxSFPQQVEIVZpp5VCBsJc5Ti/WFQnvAaGq3oqkEAkYghB/PqO6gd9OxDXTnQZehBWINS0ik3iwi13h5KIrIkKdvVj3EMSbOUq1BRmkx3NfS33rflTqqarYwXAIdMOYVpRV8/J3//pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACQd4TIN6w3K2rJmwYe9uITWjNA3rDcqwrubBrDG4yrwQVBUExJdnB9jNQQzARBwGvQw09PeThI0hZVFEg1HtymcDyk3y2GWtmDKggU5YQOCiAEgwOEKo1BWeGjQ1SZ8XdEIMmXmmBrWsiRoWMjhNhgqEA5tSdI1EqGUmIu6YUDBi1nMlZIAgIcYW5Dzpj4G1xmkuHheyUCMasNScbGF5Mdl8uQ6izmnv3KBk8i+kgiimKeG4OuwzAj5y+mm6bB+84CnKl5/rEsld2QRyhZ9D1HMuBK60Si0etQEumJw9TQ2w2WN3hqikTlPPF4cjEfw3urFodhFXbyVLFy1rC/jSzt6bq17dDPW8/5vfb1qX/nSVLNJlvH8amd69+U5nztP+//+6/v8//sau83+7f/j3X28jzMEtR5ER0R/Hafz9V/q6xgaa91i6YoHxTQZExACMQujGaTJe8c8hBEdIWVjRbT3QgjRFJKi6EWV6OmQ46t5UICccTlZwYdNbEWtGOsdS2zDQuJNCLmtehAGxx3pxi/U6HxaxjWtrtWv4ETXxjeL2w469X9c0eyObnftsGt350zTSyvYV554ebT7lcqPnDVHrxwrHnvbWcYruFDvnG/reN4z8ffvX/e8fGr1hVi0tner1h4MFnMfmqQ+X3oacDX2rYpn+jePH8NiOk2YhGzGNEFWj+Ic2Km1Q4YaRcYKJTCyqNN2MCQFhL+VjECDBnBgNOiE8FgQPqGcCr5pgRnKAKuxpEgWADTIQ4a0wyi8FEUIGKGEJGlLF3yYaIQJM2UpT4qhgtL4mR+wpEcubFaUsDX/k/YKbNbjEEETcafxGVB21IE7wU55uQwCHJ9UtaONrIY7Qb5i1qKQI8nbmFPfpqKK0kTi8u/O3vjgxmBJTG5uLMPr6mIIb21SShuE1DfasFxejjcZuxSYp6eX4U0vr2sIxjFo9OY95fx1V+p2vlna/8eay5f527upv7XNcyyy5veFnlSpU31Ir8HvYIS1tU51SV47tvw+Nb/tv965+WL7CS91puUGDjAZTZuLKNKNXFi0duTy8m7y6/43d/HPnm68RjpqHKHHvhxpsfCwb0vqEhES4jaZg023Tyi8xKvlku1qGV2JtCxnsWMwaB9SITLTv+nYelowav1/+aduTdqnPsb3XylYWOxY1z13lRXPdux5zVxijaxdf7mZ93d1+fpXfmm9WmbloGP7Nme3syetmT/2/bxgqGQm4UmypVSu56lUiZQFy3d/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlqf0wDmstwr2wpsGMJbmWZ5zAN7w3KvTimwawhuaskiZIIjCohSsh+MGLx4ZkAqVTqhYXHzR2RB5VhCWMWPLuSliZmWxr0ebYBQWCI6U9oZQg4GaAGpYSADAhTj5Ra+ieXqMUoMgsWABQchJARVEAws+RNqCEC81NSBeY0AEAURHNMwTEQcODRQhCCoZESTr7FiSNda0Iw5Mvu6OGNxht+ZwWglurJYnUHrvulMEHv9GJej+5ktiMrS6lTxvxK2d0kvm5bnjVp33lEkjUls3n9oKHBsb+PqxfHCfi9JebHCXOyZO8j2VnxZ1i+kIXRBjgVY3bv3J2IZxiIz780somnlxmM7ms69n9Z2d4Z/jv/y/Ghyh+lsxizR97zeOeWqk92np93tVb+VXLtvHPWt8zy3qlld+vzvP5jljreFexrne71y/yA1kTjp3p/dRJ8ygi/KAGNQH3ZQMjNWov7YYal/3mUsqt12tOFcqxDSCSNxGhC6iJEmmUd0L84ewL7tcgTSwTLX+gaVLbvT9ZgE43v5qCv3crv0OHohYssZsEE5SMCVOgUI2ZKGM/lLayo+tWqt09stXicI1XTjI41cGus8Rr9MQ+PMH1V9Q2qnG3yUYyPb68lJdhTYO8PVZtXny7+b9zzyG0juIsJ4/ob/bXX/W0EGBOF+9/+vjbliK5vIa38TEQYbNpmcjaI44EGj5p684YCDpEA0KAy6PIL/JOmCkRtYQzaIkymJEcSqAwSMPjRgLWnoVMTDnhDwcBy15EZoSWWkQsKAhrIsLACSKqoOhEvE4WPgooMFDxCAvGSgwWGVIrOiqmYOAVRStZK8HHrvSh5TOVZC4GC5UxARoLUaF0jdZu0VogsgOtJ69KjDCcY+3WGnlkMEs0dmjtxR8aOOVpupQOzP3bGNnGLYRHB4IXH4k4kXjSijLoYf6HmaQBtrzuxN9HHYFAKgdK7sMy2vSx+W/zkHXIFnaWkiMO0l2xfuaod1O2M87ne4/TZ44zG8bUdsW6bco3h/Mq+e7sWu2LOf9w1vev/DHXe02f2cb2fO71u9jj9kvQc2Cs2h/VO5mr/z7/5P6GWJNlHzFlhotYroBAeZeSffVg757uNJWbhip6hw7mxgmBhHqQEFgmIQYxVZ1DOQQgbEaOabTGVyy2zCDK0qdqJy2/E1fVLUGxNaoFIQgtwHhqHgRxGhwEga0wgCtej8Uh+MQdNOwq8cDIiTRs1eMYUnB4eH0iMLMaNOsOxS0EFCBOMEjC6p4zOmomYu+qp//66f+KdJgfMkENUv81zfN/HH/Vc3Hm4ywvY4d+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJYHnMA5rDcqoJ2bBjL14k/ekwDustyqSwZsGnrbjtmDCwJTCw4fd9EJ5rsTg6JMFLzGKomfALgKErThGFMW+GgkNKzkqYozPqKhWthChdaCAwwM5C81YRdqyQu7M4OEggsAZsDnIskRdRaQFgwYAlBMBAjABXTAAVdp8mHqFCpQSaEQxPQaDxZJ8DBmRq1tcLKUbxXOETWjPk2BALFN1So6lqycQEFUwLRtlAMmDWp9jCNNNEJmBmzPBQstn3fudnH6qT8juZv+6EDcm43Nxq89cYf2Mvo9b7UDXaVSUsdV9mdyWKSmAFObVO0R+6GPRmAabOKyyxSz1+eiuEbmu7qXZ6I2L/I9Vv6nrGe888PzvVNW7V2mic3Ecs8LmP4VP7hvude7zK3jZ1n/Mcvywwyr527lXLPWX/Xw/Kv7dEcKNbbbtzG9/M7tn9XUOg6Wkp4YO0ShVyUlWo0zY1t4FHZ/dyIvZjHKKBe3Ze46Vucum0b4Gpp5a0P0MmSUVLJ4vKxoeHq0rTTe2RaMCClHDaUP5jqfKWZc3W213zl1+3mtiR4PyFfT6n+Me/puXe41vSXVvSlYUD11bM/9GKBr5jeSZnvnsEbUHDFPLDc4O/W26S5gUhA4THJ1vOpNzgHIAImUAdinD21j3LBcTiQVaLvUN2aM90auTFoE2gMvY6ZhESJJ0hSX6MMCKOIAlIggc4CEzLH01YlBwXhICoJEJMHHDVA1HmlBlo3uAVFoNhxcR3zHskJJhwAyOMkDEj4EIK/C8kLDkTHkC2icQBM6cgIml3Z6CzGk5KNCYWKhwM1ZCr6kWfDzBZkvOuBR55WfDw9SliA6WzSPUxYYaxH6RwBc3GF4Cor2VKkdzfGysO06NT3YYi25Y7mcpiEy3GBLMT7aiFeKr2lT+u9AMreqHFiTzSMGALgf935HGobg2Co1DUcU3X2493O3ZltWJ3oGvUstvzVyVUF2XVq1FMyXDfMbGOtc3r89yS3jUhmNapL1vVrOrvvblq3y7h+//e/7zLm8cM+85zHlvH99/VjDHm7hDUmrilK+f77721/4rKLpX6SHzQlXclUtR6H1T3TG8SJmrs9WGx2KpCmdjhk5Q6iaB9gnUOQC5YGAq4JDxHYCeD7JshsVTBMsUPAUkRN6iHUuH3RE4/WYmZWecR/UHQeYwHg1ngPPy+phjYZC1u2Eez6DWvOGK5+EWPUpNE+aSoQBYxKzRgULsOWZQZIE16ChMayF79qV2ih27/6+2fXNS9zJuriEDM2BxnSxH3IAQNFFK/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACUx+zAOaw3CjzBnAZetuJUYBMA5rDcK0MCbBnC243hTjAYAwkiFgsBQ0feTGYSTSkRhh2HrgiyWdEQQ3aRJBpgoEMeQHmLphVaFhipU6hUCZ8IbhiEDlb2Ujss25pY5WaIVRiTazgEHKoVW4waJOtOEw9QFQRYLVCBZoyr2qSC4MBAQqEd2FiNGNHAcBZcqumMsBR04WHPs6vWR50MVn6GUS+/E1dj2bsgEAAfmC7MQRkpoakjFI3DDsqw0U/qjhGFXbdZHnLdw1XlcDxbGTxuK0eT9v5XpFkrSYBEaRhbMoFm14rDQ7LYW5LP5Qzt12StnvyyQXtTFapdu5xfOfpPm7GX7xxr57vdy7hu3V5+vk09evMwj8lpb0/vLuP65MY7y+kx1vncsN91zLee+77Xyptbxy/Xcf//x3l/NXsr+xgs49ftdaj+8dMHVz/GxmxUu+7ZUXH7stt4SGePdDVqIekiOmU65K5obLAjIMV8r1KrDaRDUCVG7EUwtqWZ4hdG6fSQX1C5SsT1HzNiy31LLVtUcvgkB1J4JAtLJRNjO/dPFxT5VbCCTuY3orQ3ejTTlL5ka248Ow3LEUjJho6ZplQ9xwltY255lr/viOa//37f+k7bzZ7kgmCUPGDDlOHo6VHKRj3I+7//pxpoBIRUIgq7zADA4HAi1CCaAgUXnANwOlBF0GWiEaboIvekLxkuN66MKFw48GLnndwDVhtW8YiImMGAdiZcqvgGBzHuzUmUw0OQXSm5GGCMqoNWCj0zglQJeRgg5sQTPYaEKEzJBHJfijZjzKjiTTqQcoS1qUStVZ46eJIYOtD9hWAbrNtyzNUXUgamEfCbMohhYAeLKJqu1J1ZLbuvtVgJoMFSN25O39F7wwTGMMpud3EMaTeM5Ns4exurytHxd9pyqU1HGuJuQqreh9oEYUfcZiHaW9fqYY026s9hfwp7NPEs8qlXG7SdnLeu42+cs6/Ktf3LqCU5UucawqfzWf5b3lnYsdwz/Df//5doMNfU7VsVd97rD/13X63h/eZ/+featERC0xpfFSP7oCU0ywqe61gLoDUVWoQolO28mYOvRdqJvYfLnIl+LC3RTonYgy8whppfDwiE7TNIdWQkimFueXtD2FVlcirXFsOrRVry/YJmM7drGWE5NqZPJxx4ey57gHwBrqK0SGu4W+74MSGtiB90oNPOlNx1U7LO3QfgwIYsVQIUhG2Vvk8iiptOJ3BMe52p09T0DWohvf1/93PcU6WdvpssNSw8A29Tqy6lCp0kHfyX0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlnfswDmstyqwxJsGcLbiRd+zAOay3CZSUnAawxeMb8hSuAU7VckoOEs06ezNQkRIYoYopxu4DvM2oMEDJP6gUCmCeDwqMmALDJYMZqNCJITLhaA5qs5pBh95hqwyTwsSIsBMbX8JODbAgKAHpSS4NMHWkrzHhgIAAoqBkSd0wGHB7YDjr6IsmMBFUZDTDiqJUpb2UQhEmEdhaB8vi8DFxyIyicIGhDUTEobTCBNK6X4f9AEoTUhi22kZf2A27SZ/JuGYclVV/GGRyM3KlecrXJZDHZvUSpolCKZg7yPpTLvisPL1n42/tHWg9wVh8oHZDNu89MNYxO9hhNS2WXuQVlyzh3m41hT29Xq9zV/+fX3rderllEL8tpItRVKDG/z//+Yay3na/Df83vf/uU4/q1vHuWuc5v88ta5V7e/VTfM6+wfyM+9WvStreWNMMBh8kCzaUxqAhz8iwKp4udn2XP9vtAuWTabvAcsjqqcfis7US/LoQLH5YzZY9EzcAjXquGtDrOpXPtLadC4rhD9qH5WxOTQDLYxTSr3nyEKaWQPGg2C8/A8A5BOTVcOi+kP1XXLHdHotddNfRtr1Trr3so0QcZJmQgjx1hYfM3bpMmGLGKWaDw6l1O4UXmdZ31/d9Tc3sibZfT/Zu3waOIHPv2hZlF6Bn24IEI9MniZ7oFFA8fAVppIYkwjSMMfx4ovqv3cMSZLABqODAwcX1QmHMAUwKBG0LEYZFHYANqWnMM0PBFLnrQMOYNQgGwwyCBhQxYkqslAlrDKU9KhgyoyI2OvGzu+l8W0JojqIYCEFJWi0qwqMC868P075SGoom+kYZmzIzj2us4aSDIHXkkJWDB6WVtkIGxk2UvT3hL66gF24/anpt+XEldDFb8Gd1CJ7l2UVsrNixg9zsyyLSNyZLEqJFF32HSNq0tkNWqyZ43XxZDO0k/R1KK5vPKpSQj6LU7T3c5uW/hunlmr303MOWse3d7ywhqtL4xJJ6j1cxu6z/+4Vcr2E5ezz/eXN9/f2fs97nV3zuvz/ePP3nrDvN/nq9oQBKnomP/NYAIc0XXjOaUDj0Itlh5NrnsgWfn1umPPh2duydmMDuXfpEy1RRSbhx9lWSlubTGQzsywZ8rdRtI5rkoNx2eB8wMyNxtB809RamQXIB6THrjKivCSXFvTj/ZbfvOPy1N8ctSkHzkM2pVqcq1TkdS1Q9xS4kgPkK0avGa5mvYYYPD4GBlgrpph5pE9FR5cSEHj/uTwlWy52kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJGn1Mg5vDcJrJKdFrDF4lffswDestyp0wpsGHpbjt2VDAzFkI1hQ8lIRyeXIhhAKTBMXnoirqlzoiEhCANynFIBUzQA5iCCUeKyYBl5h4CDAIFDr2jhCZOMnLjqByHYwcdAxuVQokEDCDImBwgicwRCxgpSBiQtyYKCoARQfSgZuhJMDIy3KPIQFBUGLNNUfVyhIDZdzbSYLlOCL+D0tq9BG5skPy0FfgBYN5AAROKHILHXyepOwa6VzCBKWbbaer1pbq5YwltNH4ClVfCNxbucju36/xqvMLzeiHocRklspizdoNzsPiyiftPgyx0uReW4bzv1KapK6mNaW0F+m+f+aw+kp7ljCv/N/jv8fz7fw7dzobtq1f5l3f/rDu8+7z33fP1+e7fMtd7j9vLLDfN7/+Z57z1j+fbEDzUcLrc/qAH9bKgKGc6BP00kGSQLfR1Kx43GqRrHTYnP/T7PxLpYvi9BGUEMsSQk0dVSuQTJVtuy9uSh87L55wIHfObxlxSHJUHpJJbKvqu/KHS2MbBGhMp1VEy8nNCdak5aZnN+/f0zS85as59Xu29XcprlIWT5eeKLWaUxt0t2W/ZhMxOXcwkWNivlzorMFEvh8VE5EQii9LuNLrFSS3j/w0MDYlEyxgAhNTMZ0iI0zVZzG+k44JQqkAcdUOf+BEVDXk7rYgQuFE6XqA8xy8LhDYBodBxAytcCPCIFFzVihqYJYBEsNADMMCEmKVZMTGYouNQAgpyMFzTjBQGKgFUiLClos2XCAgIziolMEOaXSqkjjb3SCfmUwYW3lxcg0kqKyFhhYZYzJlHwWM1qo7ZBGySRwpebJZNFofg6I2Jm2u1/dOvBLzZya9LMm9i9ixF4AlVNZlzqv/SK9d59mn+r+xG38YxbdiH4AVzHnjiLnyeXSh4bt3sxSVpTlSQ/SdlfZq3K90+WNitq5lhn3LDLefM7tPXl96xFYzn2Od5y1r8ddw5Z5q/Wy1n/773LD738vfr86+u71Vz5zeesNY3PzxrfDnG8FQdN+7+f+ywx+ubUUPBFEJ6kBCiI07sSeuLo8vGoI025yVJTJo39oWQQKlxlAaUaM8zSXE/Yy6IQxi1NyCVRDGYhMM5kmo4sFMs8fVlLbqN5yikpg4ExQ6gXQeYXn6GL/56/DZbBRqV2nsKZnNZSr5zLOuJlrPGzEuK4ozApxNa0makl/e//L+1i0d+fP/tZ/mXt3V3fv7kexJMDiFRqkpkUWhQSnkMKpq2K/1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJXnvMA5rLcrEsWbBh624ivccyDWsNwtoz5oGcIbjVesQAEORjYWQBUkmTgKUFBFkZA5g6PmKQSxBHQkRpitLoDCgwKKZ3FjElSRcja65hWgsLDlMlCrQgln4JKCABwgmMCLB10aXqWjwpJMwZseFGF0mkJmNCvWOFTKBAKRRJbsCq6fS4oJGi5QLFgL+jAVeyWN545c9+c4hU6dnyqcxJ53qCkjFoVKiAUOIfGtSikTqTeZIK/kLmI7LHdeyxZpcJx9os5DqvzDsFOi5mcbksOynLKKtjep3XalrgtO63NuFKy6QNZkUAwJDMdp43QNs8TvSiPVJrKU55081Ld08vtUud/vfuyrDudyvrdvDuOesK9ydu2aejnLEzM2cMrWX3Ma2GGeOd/dfPv8t8//t2NX7mrX7+7c7l+/yy/PnMr85lpKvLcIj3f+v1VKrA48xKxiwEQveFsIEXHEzXc8CSCZCjpcuiJcpAwYqOZh8j2FGqwp00ZQoicNRwLYbCEpMWIOBLJIuJMJKr7hazcQRRbjyM24LTl5WjtD8dMnAlh9WcB8PR7kj/SZ2q5mHnaMFjr6zpyCtJraHSixU2JsrjqOjvNCix2LHViw6QTGIbJLUWPfMyx2w45vEP+55f/FW3fcV875jTpue0PKKMtJ22mT5po1o5+SUj+xf/1wCcy9dcL0z0Yh4GugsubwQT2l+koAKiVEbT+jRMSsRRhJgQxCRKABZ8LGywdIjSGZCdKkM9RURADpEWEmdAGUDipVlJjhKmgsqaWYR2YcapuwcYGjUVaMOkocWDrcdaNgQWVTLeZt0ddjuTR5dU1EkzH8pIone/kGsIC8EY4y6BYSTdldtPQ8Bp4fhlSi/HonO3KTlB2T0tJL+Qi1Vp8JJJZXDNvUPWIYfe5BzWJZRt9E4rL3fdCy1iLRuedWetUjlvNLnaYhNX6lSmxw3Vltik7Ldb5GJVYyx3nhXtdx5nz8s//PDG7L8pDhWsy3CmsVsO75hnq52rz8cN3Of38tb7/KoNiUPmjiARLBsnSbgYwLH/p/8R0IT3lVUYyOlV52/GAAEkTMT74vq+Wts1e7vGIxqFt0ZNPqcQA6DGhYThh1qZ5UfmgTTJm4vbLmGLueyo2KX25BkqlLt8iEASHBwIav+JA0fIgBakEMOx0ByAudhOEYa0oKdwbvczF3QztBdiPaTHD0phH8GgVKsRBglFWgrJGFmDgXoQTDwjn1vQ5UZHlaltL6mvitohs0mZqU6QTbJfymy6DaFAcB10aNDrxwsJghP1d//6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACQVvTAN7y3KnaVm0ZwxeJNHlMA5vLcLKLKaBrD25/PYwLD2A7sMGD5oOITBzIIEQuZmI5hkIE3csAQEI22tgwAMBFhEDxVdhiQCBSB5xEGmKiQcG1EyAaMGKw4ZamBMSphAIjAmYULCo0omZaHgkOcZdggPASGCEELrmJq7LWCLHJQUBLuDuocxYzTuY82iPytsUjbW3/pZTH1CX703Mv077SogSxrPWQscQ1qtYyuwKRQqQQEvhS2MQuLv3YjMJlktlVDnckEZljyU1LE3Yl24hQ28n/gvKrMv3EoPjqwbjSp34KcaLyx43rmcYMaQ8tDEZZCJnC5YvawuSyzO1LdPlytO/JJ2lntZ/jjY/P+9/XM8d4yuin9SiXZU8s/Wv3+86uvy5/67+6/2ODjNLcpU18VaVUb984q9Dpv//0CAAAAP/CXh6VvQ5wBx1AW2GCAvlLm49Mrk3tzdV1PibzQ7TQ0tyxNx96WqLjXLIqZ6GRv7aU0RxiOad0G2aj1OZBdi6VkWJCaA1xuNrscplkilHDqijpaEnWC0VzWDmHZmV291J3Z2vZN/arDSbIvhvbJyKhWeLrN1jONVvMrE09tW9xq4pOg4WHMOlnukRxcwSlRdjijRtzRSly0uAR0QwpFHN2J/rxwgsqiwxkAWQIIwK9zvRNRlb0woSzI49JgK1d/zBhVZ8PgYTBAkUA0obkRBZlACogAQYeYRonSIR0MMITIpNSRkQGUAAoFmSC4cUlgHGBkREaPJeqCTHzV0S+a8gNAo9ioBOAEdL0r+bIFAsWHyggbCk8UEELzhheEtvzi5G8i10hFkcDWFDw0KdZksskUm4MZSRVMdlXSqErRF56GYjWklyXZZUFaZn6aRVWd01iUv/DNHZf+vAMsdxu7krjd6JPfS32dujDFJNS524acN+Za0uSPNEHiqw/RU17dNUr2eSue32fqcy1a1br8z53mNrnP/93M8qs3PUNqWTm8pdvLW/7vuOP6/ne/3uWuawz/HHLuW8uZf+s8MvqetFzVEQ2F1qtU0aj96jpEmqvASyjgoJbDQNDGSDsXnNvvvTTOurvUCNOo3VYOxiN6fZfSoh48DvEqZqd98CqRtIxMNYkFiZa9ZeHtShkO4GY1L30cX4zUxh3pooGunysST7NdUKqxuw4u3+sbb4v+bf3tump8ekLFfBrEh1jYzVmdQlM5N67USSb401KwbQFzbFoFY0GSPuuKapmTfx9fGMX38/FPu3jNjzeQojkwrNW3Y26H7yv12VvN+/99YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkecEwDe8Nwlqk5sGMMXiVJ2S4Oay3KradmgZw9eN1nxKhcaGFwYw41RdOzQiQWTpCiEApUmAn9KoMYMFLjR3aAYEKEQVHJeYKMQOQAAUIBo1MwDRoAEAgYmIGjTACf1tl0FHwsItBAwsYWXgZUIQtsYBKWvF32VocDVwxGovCFQUSLVxLlLxAIcIAEmAEkVhQQCwE2ZujqSq7LGvQfGlsE0Iy2NohQFtnsaSZ0icXInAakS69kHogIOvbP2pVHtUmHasb3ZpHZh6Yn35jbwvfdxrPTLsJK4kmlGoXCH8mVtQE4CnFmlpnAWrKLLkPzL3+mZqWvtWi1DLM5u1btZYS7GVT9XdnGdwvUt+nv/y5jlzm+bxx3XuUlySdlmFSU28d9y5+sOb3vHWe8f//yw5dOHWnGCqBYVAlbNVCkmI9TiSP/CnIt5yke2Mhl9MStEUqT6F46OSZRr69mGccZWpLC3Qxl22ENeg+VMqkdVuCX7sWWERidpHxYDKqZ9IipRFgOw+eH595hHjf/puktt9yyx7LlcGUfNzMyVZmmTtZ3bTOQ5tKZavVbO1Vl7y/7OsdhPmE+fggc/Mev2dEfJCAspawqBUqYppUMC72NHw6BIaV1t9BNP715XZEYKMgRBlOnfMzgg+YLB4TGCAEYaBpQi0KodRsMCkXoIQZd0UPNkRmIAwhSA5U5YKRmiLF4S8BUWGAlGMYg0EXYDhgw+B1YKFAKINsdIA6Alg5FcIkyNiAALDQVzGBIqJBJdEhWZFhAgZkEWXWOkaYkMQAHljbO5+IzjCJffsjoitF9lAgYlMqnlgxOFFV6EZAmVargKVg65+pXYq2LNL2esySjidJO17dt5Y1K25Q/GIq70NZ2mmvrPvXE3DdN5ExWFtadZazoOs1BrMaZxWb+SS6BX5ghwG7xm/Kb8Yv63b1V/6PXJnK3fymKny+VduYVe85hlrVPR9qYUsYjFqrYpbNjLm+Y67rLPuOW/z/W95/vWWG+/vnNYfbB6C1yNL0v6f3X+3nNJ/2BCaRRSuAAVyExuq3NK4wvgXLCUTz0RKmxju6F+ZUpQxaD4PjkfYGr2nh9J2J1aF7ljXJShLfKOunHmVQw9Ede9FnWymbVgysHyzYb6RtNcPFVO0eeGRW6LtDnLNFLX6vjO7a/8u9UxjHzCrW8R93UsK9oKSjVU0HDFFgKys2PPuBn51vM/zGzFzjfzKMC7CB+UGiw8oGxi1RMLjQg4sVsKKGIUsAABe79qQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI+n3MA3rDcKBJabBnD14kzcEuDmstwrk3ZoGcLbitVYwFpwwkGrAgIOMJRFOjAYMiwCigMgQJSsnMUvjqQBYDln4EaaMCiFQFwCyjAzTDEogoUTAgpGG3b9AgECTQHOsqLlA0Ic1MyKDwKUGiS2hwc3gw8CDxZgaDAQahiEBmcpkBE9LZtke0pVC5MzFkUNbiC0bF10ioNtZlqo9KKS1sZj+HFijQS6xNWAWmiOLOcpVTwLhViz8RqSUl3mqSjlkQb+tGIdo4k6kP36OUTEUlEXrNbbtIn+VK1lrzPmWt81OHYjKV4TErtQFdgmVPpJI38/+eVvc3TVpbWy1Ld67nupau43Nfz98w/99ytXr89hbtVPu3d459/X/vLWedvlfvO4Y63jW/88+d73X73/d8//5//3edwKAjl7H9I7f0I7STP4uGD1wat1nokSbBW+yxnViRx6vu1MwXDN0kBNUdJJIZX5OOm7oRKRvA9q5aeKKYxaq9NM7VK1uIw/GkrbSQLjNRRJCPuLWuoW9NSd1DoiE3K/IDNTWkdny4pr2/zX51vNKQbfOd4zAvaa/zuJfNdMNITLaeMxxcNWq53rV90h5DgOnxlYxC50UPCJyT08QE4CSbd9dZERCEed6NXapiU3BiAkQqNjXt7M3o4wQBjBwmMUjpRdy0tiEqZVEXnZWlyBiFeHmHl1l4l4DWAzZgUZDFgwgiYzocsJAhjZZ5hQPCKXiFeOFzdE09DOEzCJg6EBDCKoAEAoCJBkdQuLN6KXq5TLR0kCjWLdBZ68zVYgrh/ca6+GXYRtHZrT6ykQttJpWvgAlr1hR1A84E1mtKMRCo3OgpIcocobgp/JiklkTprdLC6jYWxWKZp7WZ1p07FrO55yaB32fJyKBNyUzUxWa7DNkzWXQt0W4RDKo0eHodooDmHCfeETl7degylvZq/SU9vnOTtNbktntPqzzCmz7+WesruMz+cNRHLGQTlX7GseZ85u5+sufzXPwxrdy3bcoqUPnRG5iWmhYHXE73G/vX/9Aio+PSFUU7PDwPXekuHCmKTKIBkjAZiXX5BUsdeGap1/u5OvwyOA1m1kQCLTH4oviH01o+qKhT5X3D2cgfiGqRy7NiH3Hh21KIjJrMsofrc2ZVH5c6TARkzrRYT2j2TnTNObDY9WpuYY+3NNrjPE5d5e1vKjbNCFJ6Lz6tEghz7DtnZUZ1czkqjqLaZEtqI7+mb4ZDt7HXHHzEXLHn2VP1/P/x/X8fp01v7urNgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACGpjTAN6w3KzDAmQaetuHz2LMg3rDcMCOCYBvC247ZlxmT4RNqfJh6afz5gd1GgoCDQ4kG9BimirS/pFdVtgAUKAYavXQgA1mnWDBshIgJEUxxgsHW11FQAbwiZLmHBQKXNSCMKMLQg5OjwLMi7xf9b4YjVK25eoziomPN4qAwxR02DNSLlyR6msv+7t6XtjqSzBBGzWKUKgBEaL3QTlPpk7rA26lrJHkHGQLLH8cdqGV/s1Kpi3nWuSqLzlqSxV0qCRyd6L01HovytGYap6lLPvo6bXXGyXGsDDb2RSlhyOZsglmUmjlmhgaAYHcSrH72uUlub1b/7t+luZXt45f3nMtZaw7+sr2OedilqxivrKnu+Rc74z71EA8R0dTkVmJM8/6LRqr3/7f/6/9gEWTY4aQSHGYHZFvCkeKBwVOd95mcdTNHTK27+53HhAWVlVCwXNctYP8A0RQwAeBqNwJw4yCkZJdKW+A4oSeiGQWkIWtvYaPWG9iyqvJLOy+iU2gSBqIaB7CzTcgSi+yTbJXZz7o4OnYo8qfdLYKTeSS+oTHTEkchlyhI4T2mzjQhoP9ovmGXLCs0Vk5NJfEzfxVdQ3r4iWz7rmPbnQgTLu3hFx+9g0MnAQc9bZH8L2+v+3DHaomaJIAYswNPNGFUkxERmAJhkA2mgzUcJBx1eEtQTEQp7a7O2xSpgZmiZWIWgwgwwMmjRkwyIeDnDDCEEGXEmgNFBJNBUEAV0mFAP2MlUDlBkZyQUoOxJVAcIJCvlBjJy2EcUMfldEswlMqqZ1ErKtFEkYoVdhkTRWgNVEHMiNI2RBePShoyYMV1/b2sP/DVXDOVTlex9L8sqSmiq3bXyCAasVkcklOcqdp7nOe6IyqJxGD3FllNfdOnv00xIaWZj9nWMjosq1Ll+FWpvtbLv5b5vvfx1/7q571TWsMJqz36U2SftKJRUDwyBSralJqUYIoKkSXZVrmRgxOTPVkgIAggOBAlARkEJQdYzY4GYzDD65TuUKypG9q1Cz0W3ipOPXRGNYxf+Aw46FkPoCFdRpiRcVyZtrNnsntxWZZWvKD4o/DXaWA8bE/2yMrBUNQ1cgRENZJAUEC1MHzKlG1cLL/9+9aCg1o6hb5PnVYSNm00uHcblJ5xScJhBnC4dpMNF0c2Pma9TuUaVsHgrs41nTZb1w67+XO6OW11tqoa2be7uP+p/6n56+/6f7D7xc8KS70bdL02TQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAledUsDmsNwqqvZkGnvbiSJ8S4Oaw3CzjAmQaw9uMJWwAxgiCJ+KbmCkOZIqQc0EvwUQzEi4AoGCAEkiFRC3Fq0phCwdTe6MAwuLHWADIsTBF/FqgBUYRKD07eGZdGdCBkIZeCocQkErQNFEBUqGQQiiK3zD0RINRFUkYiURThIGjgYZQgPjK9QSJS9S8ZKrGjjPyNn8PTkwsIxGcYUCgIRRNO8emCqqSQ/Npwf1fiMhqMHWXfDAUhFpdnncwuWo3hM1JFTxaLQBYmIfhF9+YElTe1J2ArsVhhl0D214O+3Noi6yYLSWQU1h4JlIR0mrwSy+VZwa09zLzRGCw1OTFmV2ZuauZyuUQfuWdjM3as1e51av56vVbeqbLky/OVSljMhm5qtlbufr98+/l+t47yy3/N75/bPPy53DWF7qkVvDZMDhEcLyZFnryxvl1h6tLVLhxyJnnRXqIxq4IdnnqBS3c05+isXTAoFp2SMf5JLCajpAjFhS5kEuNu78LTO6cxUxIKgRDhDZ30JN6bG+N5JrYWPIbkCbOXWLtaNkgneTal5J8fGP/n+lvSsX0tjON7rNH8bWIE+Nxm6K8Yct69TbLD27ke1eXpeldxoTq1b007tr3/x8a+P//jG9fxdYxqn29BYBDxz1/bdhMc+aNuQrk+1eM06JmkMCzFa8YUHBjfTDU9hoKgQxOnAxOEAFexOaORhugjAKBNdWgFiqZsmYSJj27w+MSDHGh4kYIOYc4SwTBkDBJQsaMIhVVSBU5LIGGEtZDhIGgMVgIwxgyYFei8y/ipkamvjoFHBMSNrCO60iFXX6iemYQ1i5QMUkldgkExXyz5sxDlK2MMjLnQLE1KAhamtzLV/CzljTz7syWMSmLUurcORqnh2pD+M7dtXK8AySXsTd1yYlBDxTjOXnas8k3lLX3kDyLDP2zCGYMprL7u7Faejs0kemZXck9ycsRemr3pZVu1KX712UY8sas3bm62qfcqmpXb+3Usa7hh/c+aww1+f583b/eOvyz3f5rueWGGG8MP5v95f3eH2HhsSXN1PT1ZbjhjDgsigsdQiPeLdoZlgoVe2ArcleWT3dTeW5dfv0C9Y1fVlZXOSJOmOp0mFDK0CEe4/DDEcqWJLZs9a2878QJD16bjGU5N01fCl5yuNtjSz4o0RZHEmrxmemlCew1VvdIv+v/j7tNqTOaUgYmtbMmJt1tSSLCZG2DAgaevWrUfFe1SZ18+vrCttsn36fGf8W3jGvnX/+Prfriu6YrmtYGSxv+Lx4sJHlAzOUNt3VirkxwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI/3RLg5nDcr5uSYBvCW4kocUsDmsNyn0v5kGnobiUw0KAUxAeTDgFcoxaCTA8kBT1RmAILMgrcMSqG00CjVK85cCVXNpraF1PPjJpvgF+1pBhx9KsbRkADZ2kHp4Y4hnOBFwKbjpaFsYGiYIZfpqJooJ0mLgNFNWQ0DomxN80YilijHk1U81BY/CHmhqGFOma3YcSWeyBmZCTBIUqnzMwvVPqLEBS1rkpPlEn7syjdnK9UpJmtaj763IvUwznaSQPpNQ/IojI5fUcu7PxZpkYgF51zKdPK/TBU54mw9lsTdhfli1G1b5JFpU2F7YJfGL343T3/sTVLVr36WzOznJ+Ryy1v/u1dUu8fltamsZ9mZRay3y/j3v65znP7vv8/6/cb2OXP5hy5hn38c7NUaCrAguPngbX9pfw27T1P/ms2jGClzcJUYkLFWVKHpuqEAgAIRCdxJrlbkAPdz5bY49Dg2a6yG+ybrTtaJFtdepzUSbluJM1ibZ3Kwm3pgqWQbHp5v7M9jKq9JIsK9+KvIl00QpYiFAPHFigGidAKCaNpmYbX/8/G/NOVSg1LzWodmypGkKaNEVJ0aJaCJENUm0thHRPPZ6vJMy3UZW1C8zJ+78LrLz/xlUJK+3uhEzG5SSza2/v/939/uvmQhvWYk0+DLOB59m2gJxAtuz6t0DcjCy/AS/YCYkIpijQEShKgCEgECpyTE0oAGI0uWFuN3By95ZYstOWHsyBW+4YGYEM3xEFXiYgKIrwGHmmRgZCH0mTgp0zsRjCgWgoW3BwwZCiw0xaMzQFO1pqLSebAQ4ELGxoYwhgKPTtqSja9rUw+Dq6m3LQVl0cC3Axz9ITDUQeLL0qwKhUUDUaBkbjcstarYVbczXubfeXQ45M7G57B5pl/aal2/Uc290SdZw6rK4Zbxa0bcBVFrMtbqzJ74k4j9Ncgp/36ed9GoNeppQ6MFQ/m2sWp5yFxGVv/LrE7GLeOUM02vvZduWpimr26H6sqmKd+5i5KJmt/c72Pcu2/wz5+/7vustZ/Xv91rlbK+kZTXJxtUexQOmUbQoar++1X8m/sEmDEERygMiWMhRHoUlSZTDbNF/TjVNiKtaxHcee1lavhVHC+LkXWwfSOG0ehDYBvk4Kc70P+l2ullxJw6ui13DstudVRubeUbEHFcAUEMkAoEIfjLqdp9frrqIHWkVVl48a2NEuWIsCYQBlmhtjAUNqIkPMnOpatKbybAqfTK38fF/1f/8rlwybVQyR4ZPd6dDBVbkBoqHbO70qer6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACWF4SwOaw3KzzjmAawhuJG3lLg5rDcLSOOYBp624jUMqvMEjoSlwICoCRRjPFGgAEXcDAsalIIGNEpZ6qBl00VAIhDxt2VHUP3igkEqygiGAhwQcQ8Bk4BAEpYyy0FUDfAQvFM6TBAQvGFSZZEdBgZABBDWxUuAkBuBbUGeqaBz19JKFRay3eU5BolqzJmCq4e6SM8xoobbuWtlkoUWTViTdwaiLvImQZEr8cRLwu62aLSVWLD/5lhuM17a84vCXjib8WouyuOQY88Wf/OjgeR1XdeBujIHlc6eawmuvCEuTBDOV9twbPIoa9h1BWfqUM2o1dRx0Gxt0l1N79UUxKZ6lxjWUBYSqUTtPXp71nP7uOFDupP557nu4Rqk1vX2bt3l/ncdc1/cdYXMbP/+vy5jhlnzPe963zmN6nubEy67AiHie+sP96hvN400OmAYjylpRlGoXokx6AlaYEf218cfnH4CtZcn6WvAE3OvGKjgWKuirdC2pt2TIfHtKmsyBXaNr8XI2/sRe6DcJfOT8QqvB2zRS7nOyI9YgFC8ixloLLYNAAAb3ENOb/vq7zzxwsgyJcjGwbbDA+eBQ9RBPFkMCw2UFgb0JWVsVus98gWHsKDqlmmonK0+puI3aOu2Ib8V4Ki4vnuur//4qO8bK5euXY8AG3vU4Uf3tXt/RWjI6AxGxgUghAFAzOBaKGogMYLCAFIJiMRkQsmNg4DEa66GwtSfFKaAXKXeY4cOCnfYUGm4uW/EiQQ3MgOGhpEsWqZsGY8iYIYpAFEEQXVZ4YwuRK2foJjGCiU6UCXGVcXWbaUSl2YxACF7y/BEfsRh1F3Yv+DRiSWsBYACLDtMlYDjPtFEtGXx9PdDddUvxuUGeHPyxsO5F5TEZbK78KjziWo3zKJSx6oBnHZydty84ZdaZZDDU+0t0V9TciWGXK/LgxZ2X5d9gjZ483N0pV8GvzuNw0/sOQ5L4dm5XMS+5bm7c1qp+PLnOV6S5u5+VDuR3q129vPGzhrfe4fnrXOc/DmstZfzn4595uvhvefMscLV2nwrWMCQPiR7XoVSLxdrKt6aIDI7oyc1JQL/xKWw1YQWMxHO6pnWIcLUlIMOIk0m3ZAYILiUYsgXw9YQegZB0FO5mWuCbOkkeasVqsWG2PIfrjM3v6OlT9UcekrBORYIZOqLEuTCHg+bxEddz+9WHtVNkbaumdttJH1jcxQOk9Q8mdNkSGLytczcQ7HGlKPhdd8SbH7hTKC+Ws4b1bd0Q+/b8siIi3npcxrn6vox/N/v//ttMZbXq21zYSOHjyKBxRMpvpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjdeEuDesNwsS4pgGXrbiZF6yoOaw3CrjjmAZehuMI2MBJh7sChwlXAdJGfph2hAYYHCqKbIiqqxFoyv4YfEuOlM46nZe1MBd0CAEG467BAfMuIc8sBWAJXmJBG/lqAmEAvwlsuRJguoCh0IX6WBREOgQu2NZl5t1qI3NYZ6n0wRqjEC4MDShwMuTLOpLeXO0p738EBnrvR4cHak6gimLyw+kezyOyiQZ6t5dyn9yqfwlMsfV8qOxHH/m4v9eZfuG7EKlTxyHT+uy3ZRROWqvaGmTNuueMuK1mA4YdJ+HAhcZbZljEpcuyOSCl1HM3/j2NScgmFv/dk0hqxueouWOdpblFylw1rPHlPYtybuNfLDXNayyx7l3P965rX2fs585nf3vC/zmfLncsNb+5b+qBWiJ4d6ocFXHtHcF9BY0iPKiptmnYoA11DVKA5emrUqhgyKTUlG5/Bupn0c2AIunYWldmUEYKNEQB0p8epxynjmJ2cNXFpjOrwWfcVwYYSXz7Xt6cJqlBOtIYk0spBc8mdaqfSri+v+Y5OoQXNabsOyVHsgJLEDg1nDQhjhi80IQyiScgbZxerOqPZdrIpoyf7XSZse+WnaniYv+J5rhXZTY6iu+6/n++Y9vEKzcsmZUVUELHMQtB8nb+qzA5EBTEY8IlwYtFph4BGirOY8IIcATD6NMfEkmGzOS3zvtCcRwkcpASA1BFLqiUZhwAkZFAwhZk2gFDRANGAREDN4CMqWNsLGAZn5bgl3EigdKMGGLWARcNEZS2hjBw0qSoXwY0Y1+BxUi5KKMDlrnvcVShnMqvuTXxbElBHHRCBpsTcRMIlLpIjwpfPMwBwGPPZLIfpcZvDfM/5RTkfmLVeQw9BcplM5PRtmC+2XVZRHYrKE3nZljzoFu66DLYmmxk/r3wCvtIHCWsmVzFWRqPwmWQBXeLTR5e91V9JVJXYZbfbuzGkcSXQ311nJrTmONSre7zGX0t/eVNjE/wm5ZTT9Wz3f4ZXfz3nl/P5jyxuprfN7q50mNzHLla7W/PmX/f7X5ne6TCLUUGKAZYp8eZTli7yAAaGLWAEQ54kJUDFQQv1ytZexbt7XmFBtuKeOG0UxHtiIXZ/ElFyCeUwigoDlUppMqypTItFN+Md7ixQMw3J5Zdx32nLMExIwRk0UVPDoo0QA9qXSJv/v7qYd6MJPMYfa0DouHZqiAScKhuXB8ODgkFpICGxGK2lGhGg6WYRh+KW0s1JC0bDqzo/1G9SL3UbdlLNTX/f/9/x9jNKVxtzaw457VL3s//9IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJannKg3rDcJ4LWYBl6W5i+eEsDmXtwwA5JYG8LbiMr6EAMbf4mGAZlhUIVg7nQNBDoUHVhlKQjUmWrUhdBb5rEXC+LBnTEgjUHZCEpdJeZg4oGyJ+NsClYWJGTIF/AMSEa80qgtwHOUlE1UvDEEhUWzhsI8/DoFYVJGOGt1QCJAPMw0Kh0rFdrAIRKRaw6EPxzjOHaaASAAA1BbYVOuF7WqF8lFnKSMbPqA0mlyyqrKsbFnXZ6ggB75dCbMYtyWZkcumcZXL3ablRXY1Ybm8KqyxUwVdsabouZvExn3cOTuiqrBUpbRajW16wyyhwovbfyMLsjLvMt+ewsuxdex5XQmJzcutNvLn9gjlPYlOFNnIZN8cz5Ny6W1rcY7Ywy1vHu8M+dzv77n/7/tJrX4/Zsc5j3/rY71a53HD/orfK4SB8ib6EMQJ0h9VKdXWjiKhphljuwPkJIxxj0NWaB5HkkGdx+X1++Z1fYJYNZnfBmQlo/5E8BvKUpmWBHoO9Gu4ZyRT9ckpHngQWCLnVd3ylKWC8pCQ/BxGZ6m2kz88If5/vv+6TlmfbuXWokkjiQ24RH2LJzVvNPOMzxLI6qo3NXJSTlE7eOz1W1lVv9+HjsL/b8VOKo98nN/ndf/sZhyTKO9dS+MZW9P9ysCEUGrhENCswqLDIh8OFDcxMHV2g45GVwnZIQGgGcCA38a8153Y2jcv1qUNlxQaM1ozry4BkA4HYACCkT1HTShOEYZHEYo7OMNzhb+SF3meIaIfOiW6NAMRhrYRPb1qalLHYfvJxQHSullg5CUuBkBIyGmWTsTIxkLJ2IipjkEJOCKMBBN5vu3CJLC8WNVqZzZkczwLu6kfNCcfrhkVJ/tkijLa3nAr0sUw/V0oBHyYBzHEDHQ5mRU5lmWLSn1CF8+q/0eKGJ9iOBoOhlZ1SneI8bjezKdPOLK5KRomPCO2vnUKHPqP9xbSxKtb27hqLXeda+s71euvnXg1rvEGaamNYdRGusut+eDm26ai2CCgkZMv8jpfq30gBTIz1rpiAyChc60bEYFLmEhgj74Q7MzF3GG7eD859lEPZV0ETEmPVku1b4w6ZQZ8FVnfZkh0azAD9qFy1YSPQLL31ictfy3Ypr/OTmv1tjDQgkmFkvII+mRWqZMJx5NJdTZ3V/9LQi4mNhQ/KFUQ9ZpKapKecLRkO5czVJrioyPtRg4v2arwzt0HjNhrLXTZKbdv20wsYqfProW5eJR1WXJeeO7q7dG74+b/+Ja6GWpBq3re5erguNc6eX/XoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJAntKg3l7crPMGWBl7G4k3gEoDmntwpOwJcGnobiGnRHg458HMHBAE8mcmBoQIaOTDIqrMZYHNnTwGQJSK7adci61RPGgwuyNlUEGKpWwAOYAU9GGDAAyUGiAELQhUM1CQUIAoDXaHh19g1IDQKiLDbkmSCDhyhzQOEL/NLUdRUXUsxuixm5scTBlNtzu8XCFviCDgFVU+RCkPSJITJJ+jw5UMLYAmunNmgentEyuGKAuVp4gmNyetptpQsK4ftqAQDdET8dIHXDFcDBJWVYOUMh6N06WJVgpkgyiZEnKYv0PKhMFTKxAgXCDrCkZWc/kFFTiqZmFinVqpXKJMVKJ5gOZxhsjNGZGHVM6bcvW9nYnu6Zvu2f9bzm1t0+r2zSNq94e701S2Z/a3zmmr3vmLXFLSw0XI2G97+Z+X+Tu3HkOBx1zHeHEDBMBg88kQDhuU1O0q6JDfaalO9hNy6hXHehzLKBeqbxhCImsrxJm9lO0aZc1Wnopf2RIsLE3Qqq6ssVHvXcKN8fmAJ7WSc1AX762pnVn1pbp3u6c69oKM1rsU2L9lSVYevwuvtw18yNzGkOH91zSk8ZebUxdLn/9JXp00bZ+78d8eneyOH82Km3l7o9no6dNfvjuuVNhJs63UInDlAyCB0QGDoulxJHX7uiUxcCD0aGhhMBmKxqYd/IKhQUB4yCzCQXFj/bSLHARF3hkaVS53+uKWv275ILjTcXiKoUaNxtp5ySLCGWCss2Q1rhgnhmhiaxhRoIIAgivAwBgw4geIGLOrNLlGQEFwWTlpy8qoVsM4YNASxAgNk+juythKDiPkTCCcpcyeBhF1LuS1FljOFmiHOZLtkpp1ZvtTsSub3JTworcnSCouQ4XpyK8jal0lDQbW4uagCGiaK86GxuJ8cIiiFk5HUJcvw7hCHSFDrkiyNhbjtOYlxxFuYx/Mb6rIu1MpTghw1ZBRyXTpc1z3E8pYiJNFzhq3ceSeHHkxO1X9aff+q03Sa8Lx58Q23GVZO8xWLa8DwtQKSQL7zmucZ//+Nb7yuIH1ePJNSNGTjxDrSqSYyYCYBh7w2tWCcBYgspvXK+5ZoNK2Y8ajXp5lBAYQdDRCJgdbkYYNdweyFuWEUqVy3MzApY2dJyPKzt08tt4xDQJBlSOsY8XSuLVSFr1F/8RqybW9kIhzjRIaobEkBwHwfB6xxh5liw4QA7cPIkuVSXklWiBGFRCQR1gqOq6R3eSri4Ktl2S7vizubMktiVBEuHQxcTCCT8kUECja22wig0sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACQmASgOae3Kcq1lwZehuJFYBKA5p7cJdp+XBp6V4qM/MEEY4IUGSiMsm0AMbyMxh4DI2jhhCBhDTUhkFU66uua2aPu81yfhRfRoTvOmZ0EIQMYMwOCQywYIFEVdwTNKGLmGCpZCRRKqwYEK1kxIsLG2XMeayPE6VaK1HiYhYlEsHACaqnMscu7PtIrgYbxUrZDS8G+pGI/yWmbYyEscZKC4pVxfz6nj4bIDQzMquUJ8t6GMxyM6HH8XxnlLwfSiiw5S+uJ8iHFiM1sWlWOM0CEjFEyLkcKyoxbCOftaBbkSxqwkps4eEvOw7V0gKE2XDenXzU4sSebDmnVG9NmVE+RkKKk6WfsE7bbMaSkDdrf4zqPPmse9vnWnsGPCg/DNeFDg5jQJ86zreIGazavT0rmtq6rbGcQaxmVPeZNd+kuriW5yxx4dcTWOdld7ZCVKK7sR+z3Ot4eOW9PY0XMFcMJcxezJ9GEKLmJIIkoEWXg4rQWFtsuMLpaa1bWe8Oad/F9tyWagwce7xym/cTx///xdI8KxcO71bDhUeYpl4nJ5clhsCih3IfniIp50k2ljEU4fYSC56/fW1xczyv9WMilGjhggMNDfnBQ5iUkGxCGigUOqQaU5zrO59/mIlETBoIORhsw0CDKg8MFyw08WUKWImDUOFQHBKeyE1gMThtvY3HWlvND0oaY9U+X8TyLSo9nXnBgZHQYKGrBK3mvCDT5W00pNIUwQEmhFr0cErXJQkI5IbKSAodNVnrLGXuC7yu0nYwGAF1ONAj5uI3CJUaBwmiaDpJsqLJypi2YXR+GUojsVM2YkdqzJm6pWDmUL5yhqZXUVZ4qs4z3TaoRMM6DSQtInoXNymCOE1Jy1G6W9ODrV57IaOoYQ1V0dinclgWA/TJNBMquKcJcn6sM5Di4KhxVjLTbUiGqj9pvhtYIqy497m8znqqmrSus6pr6rW+9WpAhXnxK81Dez4kvusbdqQmuKwtbjqHXdbR4eI2q+mN4xj31b2hArQmDTFIX/XcNcAVjBQ8AyzGinzixIMey0F5CpW1N73XE+cMc7krAVKhuTMsLoxDnR5/GccR4IyE7XoCnbG6HDMIJIrNKSN+HzcoNU7N9ff62W5uXvv/Pfu633Unxh+kgJD6k2C51ahOaXhngrzS2nU2c3E5/V9r0gWVOXUpMFDINiA8BjwieeBccfFQmScasFmt2j0Bsge2H3mS3+kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlHfcmDm3tyr2t5UGcJbiLSASYN5e3K7jMkwaehuZVDohNZmYTjAAMohozvRDaIDMUgZCeYoIgQQlMEGIMfVpKqEafyMIpQe0SYTM2m+BQhryaacxxxXKTAAMaEjExUwAPDGhHtrJkIeIwYREabRdFbQ0XlYGjeYOARBGNTJh6tSMTbKOkIEnstJKlsrlw9qz0hTGJ+X1wVC05k/OZDn6HqFFqLMc7GuJSd3Vx03tj85kKqsML1WL5vHKW13CP59Q60bVzPZCyxDUQpENRWruIYzGNAOo0BZT+LmeJPjQUKXQo6zTKowz+MYbLibZkJ0+S/nckS+qRFNCqWZGSIrDks+Y2Zkfn952iSNNDvajDFi1jSYzvObZ3TxZLarvcHFcRqQlNDgwrY014coD15K37rusfT6euPNE97YrBsAkHhmR5ATX5/dY1ioQeoVIaR5gYh5qxWapSr9p7/6tXuZ1McN0tvVqE09BKAhVI+7irIiyES+HjZ412efyu7ryQ1ciMCvFWxppRy7Q912kww/9pYqoihXvv3xzMzMv/1/flNS7upzlKbk15HW3sado2PgUTwMyYnbElWQRdBQ+wrWlIIpSNGAobkr1o4lUtT+bUb3wnBKc3J7NciWICNr7RUIiiQkWLHQucYkBoKjlGceym4V2MXT2Jmn/GEkJqkRjEc87NVPHGhUvMMCxpogFx0urUqgN1abJT7HcHSbK5juOMhq6ESQDBqpc5Mo3nVh2YjQwhCNMYHNmsOk4Y4jRCZIutTorDCE6uhMRdTGH5Y1NOTEFrs6YcpxKaJTKZDz8nVrEczm4LlsbTddo26ojsLKtuNoFsWtBXdEUpYFpexJs5U6iX5Bi/p1yDqwzKtStauYzZIh/CRSdPMdJ2pwl5W3IC4iqkQBlsavlIEX80SQJ4yz3SJI3BndCOqcyFfAMLSLjLhx79LvIsBlbWuG4yRH2L71V5BxvElqbptsj0YbwXs1rYreDeBdwxHe1kjxNRoTczwsb031h1kxLrOMWx9ZtuuK1hYDJvzVkCq61fsI7HuSygK5jXHAEtRcRynI5eoZNeDrOoc+YECM1QktlYUCwwmmHNULwgIuIpSkK4uT1oU6kSTEhyvLs1t7+JDhOS6nyobb6FYoAMo11S2PWTGuLr4n+YoQ1+4kJTLKVAFTyALFQ8EQXIFROLAIhEEb2iHsE4oLyHRLM8iyMWLaiGaQLFCJZiDMSEhUOw6MZtmdRjJF7JT81j9xkq0LGsseNiMJf3qGDJjlPdOhEmx7Lf//o7nRLTP4fj/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIWXhJA3l7crEuKTBl624kqiMgDmXtytGzJIGnpbmIsyMOKwVpKAmwYpqAGR0QcagwSM+F0+G3Sge/FP9tarRWXQLk4KVtdnSq0JuoimsqkK1cEdEWyO40ixMLhlCgIcRrUDkzPFxF6F+JMqXzrEWeNbV5MNAbE3kebaLM71IYcisByikqaPl8oVS1SSPGN4zt17Po+YG60f5jwF0PRDTTi8ak+2F0YB7o0TRFizAunkJRHdBVhURi7D4RRlKuzBEE8XUh9IYcqLQgvyfLoinBLIdFVTlHb1uGS1WqxhRx/n7R44Lo+6qB0xTOqx5lbERqgak5WlvN7Xc8+Df+v3GrFZr1fZo9zmj633ExR98yRY0tpM0rmmYOXmsSQVHVI8zVjfv6XDVcu/3cuusYdF0x9jO1HqKZQKYi2HKLeM51afyu8SOo2GYTOJod5SooVqdNxhU7O0XP0/lDtmU7g3Se6nW5b4tBZqX3NsXPvc+5vX6qP4u5/2XaCyrflh18m54vsVgkk80NEzRAgR2CCIFS2IOcYkVEQ30aJpplb28K0XS01VXOyx9Pc9yJoyKuWxsdqnVEdrLiG1Fdd1VUyzM5K/T/4+IfMTsnbKLT40QERUWWbjGsyZb2ubpYaKgIwEZjPR8IBua7DRr/HG3R4YTBhgEFBQKpEx1CqJUa/HzjkCrvhxfCwzF5IkSW7cBsZIcmuVA5WdtxKAicW7QcFhgacGhllEHAqQoaGIwpLBYJTYvU10vQuREN/WoLkbeVN0WHtM1kU7aMYSqkNREJ5Zyv4XEG+XsjDFxAjtzPNts3ZiYCDl4VEJZL9HRSHKl2gDhTipPtRbnaE8nTJczoNF7UkJ4joQxPh6XQthM0CPhVHGLbDSEq0fYuQ+D2KMlx0K5mO9JGUpF442JWLLJGnXVXrmvK9YxLGTyrWHUGmLSY9Y+PTWIkkKLFiPpYjdAxat92cIl1fVnvMyZxPArBxWl30rdRrkqxVcsO67mge2Il9UxnFa/eNYxbFcQ8UzMhdBrR1N01Ud9DEBTZXQcBgtaD3SrWN6u9Zgan3FiZwpIOjDLcmIA3Vbo7DXV5tCSHbdOthOF0/WqoSqVTpX0zS0XcBGYxH95L66cGofPJn5D5/635WKpQRRnUbYTm6xU9kHmjynRCJIyXDxNqNk8j4YmHxrW8lpSDNsCVld4sNnkWb4kNs5ZHmyrfVZ/ciZSTo5GW+v/73fcvhLc2c5O4qXAduF/yBqumnHVf/9/0/j3b2KYJW/YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACO6HR4Oae3KhLMkkbehuJIYhHA7l7cq9OiQBt6G4gxeZgBsHtEeCjaYxFhra8GSQ4YEB5gwhjwFSnf5S7l+o67cok7kQrLYYs7anScjTlZBRYkGMjQUAF5tsoBhciyExQIxIsillvVKUzkry/qISwrrF610S9NdIxozWntZwzhdqpFlPbBsMPhtycjxfukyfqrSDNVVRWJqYJruptxNo6K8cHqhXRiIar29UPDvR0A3S8K93EGOxxCetrcvJIyjRQ0pUuoieHMfxOjkL8LCcj0/zhfF6grLQhmVIcDChBVD4JIuFUyqRPv1lpiRG3K0pHOMxZZ07iPK8gNLIcL29v6Ur6y698S1i0fTSNOYUXWY0bd488dhYZNVmtK8vfW/WzFnF8+lrYg31THpWXctdY9ba3XGP8Qdd7ElqbAAAIIGd4KjZzZQv9gJCukQOwZJ6T1t2d5i698+72bUFX4uQGiSbmaG6opiveIyVlaHUJ7BmlWn50rmeG3Rrx8wYclbroNuQ+Qxp54HFnpOk/cRC5J3d8VCOpI1LNyocHRdRDChpgiCK7JiMghA0cUFqEhCWyR2HJJwiPF2suzLwdFr0tvMwsRNLH8V8+jL1asNRDxjZZZFSBYshrn+v/4aSupAaYdl4cek+YshQYPlUaImEY8AgYNgSYggkKAMwhAcuWKMriDvQPBDsuVBjhZQpeQkjDa7DFXZoITzdDW4LJsZCCgSCGGhGgHLHkgUITHjIgUFVbAhc9rDLW6kwgkCxp0ntgmHYg6VLJdS6pedOxZ25YhONXKMz5gs63WDiGpd6bIaSSrxdk7ExCsTo3hNynHQLkIAZpcQeiEE6JkGmpGJFYwuk+tN5bj+Mw6z6HceChkJWd8qNUS1lqL4dqy2HGGpLioD3MRVFvH6bj6OzMTPCWC/rLgwIQ+tAhOMNljt0Neqwwo0KHV5n63fNM2vFrP6S4mrNfFI2NY3ekKloHjYf48trwtt0BexEo6gwWu7fLGzP/eut4xr79KY9L6/znfjdCpbFjBCc6YGMADSQPfUrJ4wttYWrORa/Eg6xt3q9sVqjojeTJ63BsFtULtNFEmwui+FhFzSrtcsrE0MKcOWRnnVsOBNmDVmhwtl7C5+EsHfMRwQkUPhEkehzuQxYdyMMdQvA8UGBUeChWDmRBJPFBKJtgaCYcSIzoQMLgOLFGJWYCwtDOwPCCIOaQ+kkQg+/ZvW7zSnRedvmZiauuIiuob+P++L/3/hK6xsnUvFFEPoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkfhsYDmXtwk2u5AGXobiJuExgOZe3KcykjgaeleFgRCBjBK7NWaIwUKAoIjldxDIQCQgMgEWABMFy8qWU9YYk0SOJOO3UlLUIErkpTZHCMBY6QF3G3aAHE+mXF1F8ACNA43ES6xynAY4RglYal60pmVqtAzSiAUEZsxFRdQFqLD4CX/D7vQ1VsODGzSrzKtTPKTPs6YcrC+/ivJ3jhZpV6XcDKTSgJcnzKLySi53GuexYBXBeK5oNtPs72ArDiVMQWlWnKK8YhCW8+BTixCjT5KXNkMlkUKXOeybVB/aRi2YCFHgaxHR1wqFVHP5U1gq5vOVyuyuU1rdqXKhVDM3QrXtNNBtvHt8X1fdNVl1f/W91rDhbXTbChP4NYr6M5WaoUFTss0BngV3VcPnze441TVoD7d3275zf3xvGvjGoo9NdaUiKg+/2Ygok9KisWYdqrIZVewxX9j+sf+CrcmGXmhIAkuj1c2YuyMMY/UahrcpHNdWVRfk+acqzXv5poNaOGsdoizxgOdj7qtTS2jm53V4u5IoaO7aABhsPCbJR3IgWYHKlNvUEjTByC1ObK2tfU9QHdj4kXliFmmzNUmv7hqqFqYo2k+zf0qc9IpSoM3VnWa3IclFcyIbD7D1MUEIwoRBQ2GIwWYFE6I78rCov0DD31exw5Isdjknhbuu8w9asdLyIVP0noeFZvDltXFkaEBEKtkBACJBAmkYOCI3NXY2nc/bU1AKRqJehVViEIrL+ljKaVvJ23gpvpLbugG6M9gxoWmKFGhw4GNrd0c+YZ52sG2FDIEtHYaC+nx4gapPw8D+EwFoD9DJFoYqsT9ENJwryfvQci52mi8mccp4It8hrIqUadsRtyeh/rtCHSjSTxXLOGCDhwL6k4iHF8UzkkLKpmtmlNVgRJnH73n4g31fWfmuPm2fXdse0tc5hXiMVK5j6iX3Sua7b4jW2sXhONrqzcHT2X/V7arfdaX9r29vuMCVBfbz1owEAjtsgKJCjQikNo3SHqKo2VYKbx3k+vHq1XTcNWuOghw6nx22Psl7JGOtBdzXKdj1jsJ6DLV6FolF1tTxUjkx512YUA95fjs7hlsXWw+M46EWKvxTWpEPoDaJU3IEhHfrEJZpZRDcR9AkijJk5I0w3bl8RRRQya3Rod89h2XqrUgInkYjBJLxZzvHfU01o4ZFGpnyL9Vz68BFFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJrIREg5rDcqVPGNBl624jLhUSDmXtysU5osG3rbhgyIJiXDHozSZjAY9kxq2ixHMrDMwWAHYfocAsdZe+raPsjYLC7D6rOp5ZR0rVG/dpBAme8YBCGBkigkEABRMkUFAZqHw2WEnJlkxVGwhL4tgqq9eYFBydlqeKqqd8edxUUcmnXsSaGcYBpZnCIz8PZU0/Unsu15yKYWbWepNXwosH5gRnkUex7WkuipapiXBTVLgkhWnuUOAbZIaPQ3d2/tmPCILstSYbKWHN819Ttdb6pGzaaMCuosNFXkk8glD+yKPWHBd2GLluUtOtQxNxKckMgjL6wmJUDkx10/udqRPKahyZjsJswFeppPGHqt0merNi7nqzf/OxSSu1+OHbVvC5TcgiVXaOrYl1ezTZ4Ulm7GMZukvZ01S7EuSl4oBlMzKqPP/wq67/65zV7mVrIKCiuqVas0ImSJVSBiqHPHGGbNrdnoCv6+9v867jjcGBZi6nWmF6YSvUp3q03hCxcCnKNHQk85W+1CoTzYmNsYIjhvWDqx+512ewSK66nneqt3vpi7ttJonl6tdxUGalFgikhUpHVTX2bFxuvbzih45UJGh5U+wqL5Qfrqq7pWpOnS6kYa26p9M7v/6dcS6oXhTjuv//5/nm//+r7niK7+/v69vaooIf7EZh2wIAzI4qPWkYABY4UmjGoQMACoxeAlaSUAMjTSVjljyMWmUwoXdcaJstiExgv6FOWXyZstMBJHGcLLl/ZMDWgyJ9hYceaMAEtkWhjsiyexZyXz2JrFBqmz7UjKHFksNxZnDgyyOtz7UJ/hSv55555LwXaonvmPO+09z51Mb5gheGEnTLGIh4mwlRjCbCTBGQcqKPxCTnbnNvjlcLkdxKj+wPE7zgJMoThKILlWIpiUr+Alkja7bamFxdxJgh6onxCZmpiepYel0qwgtT+MZ7/Zqw8Y55dRfWtGzMKLM5uNdY1beYObUg6eX1ubNHsKFBhPdwofgRsazmjE/WYTMyxFbO2KmAyK1gc27f1q+a+uNZ1S2rZ+IWQEruODIaJTDBzEYUdKFPokcicUmYYu3i1i0zqkWtpytewFSyuJiR1C7O4br1ND9KwhStXR2Kl0lnBTF/NMx8tsbNnOZiLxXfqZe54bnYOQxsKnnqdxTKuOHuSN6MVH508WKjtNyYavcs86eVBEIYpLGHlSCOpObJ9qO50xJ+0bb0pBXBae4olFLbKmKy1K5/v5aqzl9TbXxL298M54/4+5nr+//+YntFYGQWLLComJN/Rt0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1Z4RIN4e3LxcOigcw9uXNXnEA5l7cNJPOKBzC24gGADOAYi4jJSYG8BnIeYAGNadWfWXZls3AE3E43nXorj3dtPXG5Qu2XT6WsYM1gOl5E3mAl2xKYskHPLqLbaCiopZBbLmtKlT1guBKeXx+GcLUgoIds3qlHKJq8Q1JHmqfOoWrTZv3tMSbs2wEiJC6fNB7rMM7VakY5JkGbSuOKWR/rOS+pxJn7peQqGXc4UTljdp1yj2fv8Sw3rlbuNYsWzbEjQ2u7fFaZWJgZ4jArp8Rqa+3F3CYW1wh5xKwrlvYL0zWvz/r1+8Y/gax5vGrXGJ96vj/FM71mTE+vB95cJ763ddff8W9AxBZ6wgyEhDR4mMOjYxZMhKFJ8AoFPa+6d8thmC3Qksvr0tfOtW3lHZ6YVLDVOKFcwyaPg5QX+dkumHPEqG8aMiw7EWANYgtzl1MlglM1TSw79FGZBLpZJHqjNFc3d1rVTimcdRdY76jHN49odqSej2AuR2uVE4mVl+dqdQ9+TapkqpCoSFQ4sdOzJBSw4bdO2nerS+7XLehrveJW+aWr20CLFivazommIO4t6R4ak7TEgPo336fFZ8Zl1Lim/BrAn1fNfvWP84/+/jP8XMKucYt621nWIuMe7y0avbaXh6tHvmLqnz97///tj61qlJsUlUM04LShxxAYhIIDKd0AgEBQDS5kDtKE4PvCa929fvXLWLJKl/Nz41BFA0rNm5sgRuDlyqbMNUNMBIdRFyVkMtaWow02meJPqQLeV9LoTMO3L5VMSxl0vwqvIUaTEAuV9WvS2K61FrSWstN5hW0c0JigtzEwH6ol4kLEvj1GrLFiVjevcUMZGVVxFKnW0ylZMnqpqIxRmF8+bJL4e5ZY0OJLPBltRwgtcjg4rS6UDhPPAxv5hU2zQNwvGgTeNEcI0By1r/5zrGLfG8XvTFZMWxG+s7942saxq2KeBi0eDWeszuoFaBZypdaGYtgAL0CgAMAAAz/kAgoCMCqVyGNJw2HTkFvdqarcws2cqaniduDKBr2K4zqSB4Spi2JcpCEESIHhuVZFSx1vHlgdwl7tFaYq6w8s9G789WyZLP8qliUGmdEC+aTdrDvpsSlTDWJiHJFRBKLQkgHkdRBDpNkQdDpI1DsUvrNBUQBaO+iSseAfMgbpHxjoWmGt7erTzGkT0PbTWrwaLJIFlHrZ/pVZ5kOp5y7g4xzHft+q3dR7JY6WO6d83vvuqboMhCHn0WrtNTOQZJiPxeVQ6tY4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmQh8IDmcNynknokGnvXiV6AwYO4w3KmS8hwawtuGzBYIAXxHBFEJMk96eAO7DAoGMNCRlg8ATA4AbaG2uROZY6zKni8chhYd26zoRBrLXSgGWo/KVng2loXDnRYdkYq2FgQyxDUusiKoGoKtpA2KmkAl+s+qoatZxoealFmVP8zZ1oOrvTILtDqWQ/O1L2MppL78SPuNaflDlU9egrUNqZQahxOJQxQ9HWGFStZaG9irWjPBH1CjCSBcaOZoocjBedWptY288Ic2GGlqWRGxFHSbDDT1QPBstjM/NUuG6WJdj8NVqXOGb0NS92WAuo09pMebhC7Evn68/jqrPT0vpY/O3oNuyyL0EsltrlvLL7/ObwtVt8r6/PWq2N6Q3ZTS1o1lKqbcuyqWd6u3rUzhdprc1Epm5LrNaxS3sJy9vePO/d3+Hf3+u7rcsWsXg626aViqsHS2tHONC0McCtjwl0ZmxLCk2vs2rbT9NYi+FWq5grpXsSRVLIhRBnKXWCNrWnbULCQIp8u1LjMal2IiYU/pve/c/dZvi31DxnGMaz/7f11uLWFrVqMDlCYYOHUGbOvvb7ByRp6Zu1/O657dSsKtc33WJq1b+uf9ZrDECBGQINrUaEoEhYJsbVX1VuFkiYfPSwmhpoqZv/7iSKWRJWmGrXGwgZmEZPmas4mVAWmEIJLxMBQGIgEQEOJNtTaFbabLI1WcmwmJGH2pmOwK1+zSqLv2D1GRjO1tB3xwyMQRMKdAflYEe0JDXGjv+hwM5R1bltOQ4L4ac1eNw23FPRqEqkMRnMKa3VwYbCqTOjs1JCzqzKafKUSy5G6XUgnYadlWxgZcJWyYf1ua+HScGlZAn+XnT0WaHVbC9Fl23lmX/Va/CljZ4bepL5NaQwTFV9tali3HweWYicojEhitWXxKelcDPvFJiDs5yfp30hhW+FxdjzO2GPBvGRYfjMWpb2csXpbLLEvo41Vxf+5drdv3MOa/m8+38Mse0m8beeVez393tXdavT1vly7jlXnqurGXKm6XtDjqvO7z1vnMv+3CZDF/3lZr39mYeHkILHFhAYLcXMdyEvzX3lh+tdksd+TV4K/61Nlco61J2y0vCbhEvYJFX+dx++v7D9zd0eUocxazX3S4Xs+9WvlrOfNKcBMu253OPPtB/H+3h6rCY8pbScko2a5JMnvKGU0vUEIkHV3MYiVQbH1DRJ6p9GKp9tqlHtz9tmNRJps5y8umrv/rjrfo3ZxWT4qPLH7tBNORHn3KOng6q9gLSKO/q86oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHFHHCg3h7cPLveFBvD25dMcEGDmHty5o9IUHMPblpwcAmkkJkxqPIxskmZ6WhgKoDhKofh2TfJ4XeibrVJHpfNBdj27b12KJWB43IdlcWDY4CZc4TWnbaq7xKRxo5DdUyEUwX/k16H5K5MIwlzcl3YWLcaLJD2+QyPW9KySQ8419R8bvWfW2tLObYJur0KZIzhDbSXpFQOJQIdaHZJuUFrHiki/O4sVqVJis59tTmXhrUS9SdvbNUdUg2tCo5R3O77K+yxWxzvfbbK6tbeXl/uj7OsXpFgscY/oNJJ6/Nr4vvN87zS8mczfUa1sb3mBn31afJBQZa9C0Nc5LEdVDuhE4BDpqeabApmUhJ1lCcqTmNBoUA4LeqG4ZhMuiz58hp7aWapXzmrMety966shUIbK1iBVCo0udrTIEqhGR018qbQE4ENQ2+YZYRHdeMP86913ZZU1Kl92aSu+VNsUfBJp4FJb4yYesy2mlkjQYOP2E+0uoA42c6nByWI1R/pFeci7IqM22ULjMuVC4JxF4o5HilVcTdTGGYhbUupGRsb8+Ju+oEkkiqbYL+jthbXCFPaHqDdl+JMxJ7bw50xJeNalbM2pJMbpre8Zzu+vTH/vXWt7+M/VL63W1sQJYOKWv7XmrWDal7TaM3+PffdpYUdVNbt9SZgiQjBGHQQYdFRnsDAIAMYkbSIrFYPjLuwqcqz1XCaRWlMhkCXc/C0rFVE8G7rLLnt88KUIwFq0FDV4LhhPxV65ZlrKwgXiOgalIaLsxbymLTIlwchmnfqdrVsGpLnuYWf46xVjtluk1e/jXukyWUT87GKYe5pB3sRhqZClIxtTXDxEgv1hjEkH+zMrWwKZDDzesSsP1OQ1S8fR3JrewoW48GryebDZO/XcaeA9hR+xS1raC9zSFJrOcN1IsTM+rtbM4y79b4nz67g/X+49d/P9v7bp/qeYWAmn8SczwW4Uu3r7tzeg9BL0AZi6VmVSEJAAwOcDR4QEAGQRR1hjowLPPq5MilE1ENPa6D5UsUsMejbjq2LkTwj7hphvm2VfpAFWtjQ8+U31Do0qrJX1jIsh61RvzhSY9vTnu0tLUZp37XO13qGzK4RNRNXTm84lXTzG75j7jr6EQlWnrlQf5lDJXjtoSZcNLxS3hRH7aWx6JAN9pbZpFOyOfVTYX1DHqBq5VcoddQMxrR3jgnGCNGjbriNXNst2a5tDgw62pXf+6eufjcHGfbNc/41nH+P/bXtrHxvX+s7xantT+uMfXrref/CqDHXr/97dvnFqdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHP2tBA3h7cu1MeCBvD25ddecADWXty0owoIG8Qbl1H/M6jTziAWDDBR4iAlMIrDEvhLY7VFXkdeMKi5KNCzaS3Dj4S2BV1KrUVkeUFSrmZQwWVjWlWA1VlVjISGLkv41pL0L0R2a3bcqUXZK8s3NRYaFfm4g97e2R2UFDpsj18WCrnU2MxaxHa6jxaPlcjzRepxpTpbnbp2O81E6LcnTMRawq2RSKZWl0KlKrl7qI1MKwnUajXFaZXb1vZbrmjr5za+IBzNOtvHc2ewt9bTxsWp4+q51Jau8We4rFrDlZYuM09sU1jV9ybx6zR/qtcxBpJU8kOUwxuRTScoSQQrdt+g97nXY4mqgONAXzzmIyYANDMDCRJYi8Xgcdlqj76Q5JoH+IOTSQNONPoLLu7flxVTKOOxACLSTaA5gjKaNM9Gg04ThW4l7XX7DEFNRGVw+LLg19oehyS2d0knTBoYvAStfR3CNgEhAdMdJILxRTNuYL2I4Oa6T8D2ZmYlq7ORBwSRLahL+WY1C8DiMEkSJIQc6kOZRGiW4n5KjrcaUYU6lU64nDAaXilWUXEZ1TXWsa1SaETpMxG6NCkw9g5zWFL5LYn1vvLWxStdYzq3lw9taua6pmbi8g/Ephc9vaIZCX94p0y9MUyWiSUa46FxbH1sp9KPBUAVTx5JLmCR0iDFQkTBmmMTlcge7BrVieaJG4agGHiK9+4g6QYS/0kdCGmhNbiJCurDdDk6pQpDD7PQ30XVtGh1+zzhHgmpQ689fsvHQuvdguVWWzT0jxAg3bowMw4q6tGfxFPJM5zQ3kt32ot2GrE/W3VU63KOy2YseVQwlc7g4ufyGul0cSvZIubQnzawR4EB7Ee1yxtkV7W7vEerzDC+o6j03Biunn3d8928zAveFBrbD7dawdeLm1qt+N4pqfNqam16a+syY3XzRK7jfFqW3XWcU3Wtdaru+N3hbVlcH6viMYdvXv1+07BGCDqQdAepwmFE6BoqHFYW5C17cUanWaVctzTXJ6HsmkQ/cgKNy5/GaSpZy2XTaWoHEU+48SElEabozaspe9bTc3bAzo8TPgenhDvzMzQ1HrLpQi3bMDqLmigH5OE0qqiIibLOFpNAmjYoJEyZstJ5qTJDVmRSMjI2NFompeOGSLm5dL51jQ+hTRTZNBjEjUHLyaLrTQdZkiaOkgxjWity+YnFpqrKrNqTdmdnV01pOpdzBjhEL4Nb2bcPX6XU53Z2KkiNGTa9m9fO2t+mgn6e8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABzt6P4Nae3LsMAfway9uHTGi/AzrDcvKvZ9BrT25d8cAjqgPbUAhFCQZn76O40qfkLlTT9zcKWQGAqdUV0ygZ3IFko8Kl7Y2DxlbVRPgcLkxhfYONO8Dh0VkK1mvQEFkBESlVieKSTQ5XVl0oncHEpZBDTOodvSB/GXn0sg3jEmj1zV6cLdBe6bF+0aNfEkuIN2F7X0VqtitTm4yPKwX92+JJElxEifTbijdSFAbJ433pttBmvncZvmvHgxZKajUeU9J9x3+IuNxqUtPHtjeIW8X+Y+6X9PPLTeolba36e0Klt5pmBaNuusWtS+8Utm+PqlMZ3jVsTbbjaNMgCVpyHODQvSuTJjBDQT0OmPLjA1MPB4qg42ZZTjTi+utn+1DLw5rEdyNuhCXQYFKW6iR8MqoZF2CEGCpkKgP8ifS1GRQuOCiIYFWljgBtoWIHp3RfqQLljcMRXVIPC4w7EJabgPcAHErjRt1txBmLrqHDxnetTU+btx4ErHtXvnbm2stdPVdEdPWPOqQd7eql7IyvIsKPJBbI0ZVXYY14MB9TLdDvDrHbrt96VgQo+3KHO/1SsOknzC3it/nOd5vXMtfvOb4zWWmMw5IF8WrDvu2IdN79MYzW+5Nb97b3m0W8W8n3bF9at8Zxau8QLjFwtLkCrK3RLmDR5zgKrJiM6iLQ5fLJl2GH5WXCyUSUBgmGJoClZrFpChnxWXxmB3MR/SVInCUoMBOmMC4FhmGolKCCQmpB9ZbJvCyaJQKg2RTNTFf+6N+WdOHOV6aWVJbO0hUHLZVRau1dLqvTv087ct0tmtLLNncuqWrt+jk+FaU0+5dyZuW5jdB9zLCGZPZ3zfLXK/2re53P8rXavcLNHSU1+1lumrTdrO1OavXLtnOzqrfnakrt5ZXMJVclGd6tX7n+WVz8JzXMdd7v9554438b+NE4EB7hRybQzFsnjEg8etEA2FlUanj7X7kU/NQ8GAhZ+esw3cDEEJyqql6xmOzaxGDuh1PZ+odSQvq3wWplvrCHfkLJXlXS4TyFs5AgSXah2eNw2mqAsyWtOtMSCkVErcdE+Kog5k7Mbe5RT41PQ6vkSVPTCJ5ioxM8NQhXHQzQVbeI/Hk4y7V2a3UuYEGKjXsSKZ/xG1OyK+BhPPm2JCQ20SK54zZ5PCrAVs0s9FpOag1zfEXG3jqMlYr+aFf6fPbNlH2nCd75bs7k13jWkYXtYUa9q6hUrDgeNmBnd8btuB7yb1euPDi/ebxK6zm9c51vf1jECLJ5N53e+tW3LFDeFQY6sisrFCGwogFxOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdahb6DGXty7LDn0GdPbl0lqPgH6w3LObPfgYy9uV8IlhYZMhdisqXT/Q9qCpJDfHdvwU4zCEeo4oQ4IFaafYgMeB9+mSYJ/xlITEm4bEUssMHDInDG8aUE4EWlI+o4EWLQsQTLxO7PannEmWuMjBUMqnY1mA1ZfNwQx3GZYe9K5SsrtqgQJGZ/GewYNWWK1Rt3gRncavc/CeYyu8RHquZWGBCnrm/gVjahw6MWb1w8faezRoNZMP8esd7WauYM0TNp41obZAke9mzi0+oECj57XN5MZvWNFli+89I1qb+fLA3LGhb1vFJcfWK1xTE+cYlz7yUh7tf7xmLbdM4+N6tq3//8C4tWmYCYIBhwRWZQAOJcFoTry5wnGe50XncWTQE154V8zyY0RkDt08QQ0oH6yljM2kpvKGP8/RQUaYMiGewxVmYfko0adHMcBmKgEipMbJ7nshfJiHZhsosss8xzCwwZbzTiqrw5LroCRV+KSRlpVOcbLxr02t9joe5VrI3QG9hYKyMVr3Zp9um5ibdVgwZXKt86gd+1Qa4xu008zdu00WFajy0CDPaDaNDgOEHUXTZHxRxktF1J7wa2rrdJKeks27Qqen3DjQJayRr6ziusRtVh13i02//vON0rj3mrfVrbxi9N41T43651b2tnXr/K/cogwmJTgNKLLiqi/OSTUS8pGtRR7GeeIt6/iw9MZYrcchVFGuniSx77EH+UrWQLMSqQGAr8CMLLZqXOL5iVYlJc6WM7OWiEKwiBSh5ph6YfZfJ31YWPM4PqU9Bu3evRIaXA1qmu9jUTdzWEoq5wxPWO3rtSrqLbs3MvnfnL9aXT3zdjkFUtBLOR/U53K/vsA4186XHmczUpsqHLtrPmNa/hT7yw5jnq3n9SVXccd0uuZ3eXea7jS18Ncpc8scK+uZY4Y4447m9a/Kth3G9/401UQqQtdRsFBMpq8GTVOoXmBmKxwB+jVP9n2SQz9UpqG5TdYdeJ+4/NQBdr01iWVXpLwTMOQ7RU0ZfFetuB2/lksuJUovNuxhZMUd90Y7DdV5m5kV7Lq5IAfVpYITgiEuhbKaeH5dSq3mGDIrUvpHix40pBY8ez/Fnogj6aSHM4zxI9H0TFsQFdvPlmg71JLK3zP1i8SHqNuPEgxHO24tnB97yXlfS7zHpHbvbeb1tCvv1xn0zC9LTZp7Xvq9N51bdI+NZ/1qFb/P+dYt9a+/LpaUpMmxd1Y5O2t/06jrsqlphtpO1ve69MwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHg4M9gfqLcuAOJ8A/b25dfez2B+pty2e63wD9PblLjSGAEnOxACNsFTsnYFlNwoU+0A4p7QCj8/JsRTLpVsmBwTHmHTCS0rVkVsJkCQweHYutuD59+J10SCmNDeNnYKJ0ABGhq7A95/IDWhNQa4ZCIiOGRWTIaR5QKQDJFHOGxoTZMuHHGZiZlVx1lwxPlAdp5mHAbFI+blCpkVnDhigWjiKS3KBgbHCwXSKl8nj6GeKCzE+oySTPGqUrJoILWYIs6lGiyeQQZA+mdm5g7rNjdlHlnDd1GyCSa0TcxNzx1aSMwSpoIUaCCzJSDJIMmtJ1u6CbLSUtBJNSSktSaDo1vu6FBZimyTrUeGHuL+CBAiAALxvAHR0mmbyrNB4pEqn9Qt+oixlDOCF+vKoVQTSs4YRymbaxSv8+IGEkZiIPdISO2pBYFgJ64LingwkBzVAHGTg8aC4gLFj1QPMSqVQ5NRtMAwAkopqs8pEgYayRUiNtX22wg6BjRpLtrbNeRgeQ6uMEutnOBm9IEkF9dTTx4UCW9YcaX2hPocWS3ra26au/8CbO721i2KUzG1iSbG8YruLHrPutbQoV5I1o2971X1lzNnOc+TGok0OlqW395jZrrOMe2KY+/9w4sU2mOqoqzmvdM+1H/88pp2OvvKZpOSxm0cIhBuqhWs87MpY/vclUGoTXZVocQbA0lHKi6kzBDEa6VcJT1YQTDSEeApUHmCFS2mcW/CTATQcPgeQDoA2qcsZCJg9DbyNw7TM4etLbByVllrI1LBdMEiIga+DQTQRJtAigyJ0yLqi4VT6CBgQpRTYol4f1GZmVi+XTJSR51mU8WkjY8dSUiaGhiZnT9NRqqxcU5obmZkmZuXXWYqKCZkYqTQlaYmaaBipMzW7m5omkXE5fUZsiX1GM8nTUs2QZSkWNk3ZCkhXZGpNNFa1NNUmoOqZtumaotoudTbe5ujhda16/sUqCAhYZIMECeQ0KwwzoLq3HWhyvbbxTKUQ6jZPIl3lQVKV3BwBBNpmMZaLTkyFOwmDlUCHBnmGBkjp47agwKXigvbfAUCnkbFQATPHQpnyfTKU7lbWjMH+z/M1Yq2jiIrMeB39WsOFX5y2SUtuI/b5XeFqQujnqj2nr66tLu1J8xbTVuz5rmBTF8QI3jQse94/3SBHxDk+qTwP/Exin25Ylpr1ruDje7XtittQ7UzjV85i1zTWZqeaaXOc6vWlrfF76+c4zb7zb/GdZluOiNcx0pN5s3aP0+5DCDxCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABrFcvYH5y3LuTxeQP29uXWm28gxrLcu5wt5Bjb25ZAZyEBGjHBSqtLIVGqklpmhSq5dgst08C6ah9ku9QQ2AkZqWDx1OnrDawT9pMDhoHUeUwQYxbeGelSDo186d9jYB2BPwbwqoy6clFh4KstWWHpv7TTH1Pn6VsYJvhvLHWU1H2I6ufnVjWOO7r8aldaVVX8rWqv3sMsOyytYt17uWeXLWrMsnLv9u6s477c3f5y/Vy5j+86bu627F3CtjV/6uP75hh3PPLlPdy7ljl3fM+XLWTQVurwixaaVePb+Y6/4tsHhpme6bcJisvj1xJ2pUPefa84motyrDgE5A1ULVabPQ/oiqnSUQfqytAuOxkv82hf+Hn+bOHHstiq/n2XI6AKN5ONL6OpmwFYCpPDUBNTibhGAzgORFet1JR4KQohDwyBdCEvmx5/WEPzAXDNwxe3xqJuArsOIMZcO4DGxWawJJqmpZHLpxo45k1R+0bLfGj0vLDe2vB2xRcNzjZl+4sGM56atWrXUSDDkphx3e08DGL5tuPjcBz8bNIzjSPH3HjRfWaWSkfeMPo9ouXWafNovt8VpiNmR5XOM5+N+nkj4lvBxFtAxbW6y29bS6+dQa5zNGeovK9hxMpLXalKEN2SNMKQCsDHUNqotWkcMRqLU1K5VJYk9nZUC3x4svE3jByaVdIOdRpwUgIAGA0aBQkgAjw1SgBiXtHjEPyl23vZgIHBbZdjQ1KDpJyqWJ3qi0DSKCIAcl3IW1o4RqZpKKpds0sadk4NFLq8/MVq99V9/Orcqxm/qm3G86tM6tWH9WJdRXq/NY6ysdnbH3qXtPnOY7uZdu5c+lwqVsrU9Vy7d7eu1N75Y5+q1jO/f3/1ftc5M4Ybyw/uF69zdmzjzmO/y1vd61j3XMtc3vuHd77zn8/XN/ytqDSMCWOQBfG5t3E/x6vhhjS6290iLc0hwUbGAhU6wagbhxB3I0+kSpWnRjKelasgCBKo8Yq4LOS+IEgGEAcDNhVI/jWnRMIBBgHGk4UDDOAuHQYJQtsUNUsNBVIFoxk7TBkFObVgCejyI3awx1GWUrxkDrhUQGmSGpuzEjt14D0JKXF84SvNQlOy3kjR61fvo7H8szPopYltT9u1jLllh8aHEtGgZyypTLa8zPtq392hVpTNaQs51Hkmv9zff3FhYxjWcyb+b+3zW+pLf33Wmq5l1bcG00LefmutVpmHn/W4+76tbWr53vOdZ1jP3Svx/jfxbN/8VxX/ea29f85rvEKzBk9YkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAc3cLwDGqNy2M6nkD9vbl2NlO4Mby3LpbLdwY1huY2ipmKPUqS1j1G0t/pFHdxmQZTcrRkMGCbKggTcBNNwsCEAZ4BLI8TGLi5nlHmwyfIhJCgFQsnDmUihOUlgAxLAtK2snVMN9wKOF/hICtS/4BjkjjohEjLN0onUOEgRhAjUV0HZw0gkzxodNCgI8NEk1KGWTWZGpFCuWDMk3Fak66JfLxo5oYKOJM5TSKqE1WTBCFAxRNTBSZhLBdQdBAzRNGSMlpLPo0TypqgxRRRQUyJtQd2Nk3RZFNFk0lo3QSMUUUWWxiyk0XbRU1TsvdbJULosqdJCiv+z4xX9Pz5tX6wyrzR9+hagFgYwbYNMlB1N5pvtIZhhRlBKsmMFz3SQDroLXzFPAg0HRahXTtlLjAUJKo2UFwjBjQwd+wqGvM2CacmoWeHpVX9MoCC2wwonT5gaHJaqhfYM/blrCGRALQOad4ndMK2Lr2SA17fvTvriLW7Xl7Aqrt+HGgEiffOKT73AZLLq8OlYVfClbIkfMjXett1g+LXefNSvvb7xWub3v42I//t/bGcUrfedvr6+c01TfrvOI31fFd71W8H7x86preKfNPa99fN6a1r///y1bTFNW6xhTR01nW7sZZMZRdX0lM8Qsinb6CH8tbgallFLF4uOCANBYYHiEkATOVqG4cVXMCFZiCggbtkoTOhygQnZQcDoIES6xx4keeN07dWkmCh7hsAiSTpqhYDTUbOSoEMkcVuMFymPovoSTPRpH/t2VQ1UeGZbKd0rBYXX7FrUXTpw5nzbMatJli/9nV6KcU6i+qn3e5fEKti9n87jYs4dnZVL5veGWOWsuZ01fLPW86W5jr9/rH+Yfq5axzzx7lhllf/uf2MMKu/xy/Vr/yy7dsZZ44ar2dcx1ha1WmJ0KYcYnlKGzbAQ5+uu5PNaVrUxdh42it1T2l9iIaIIhoqNMzNxnQcJ+4ChuMz0Vrw8xgzQBpZQiaACAGVRQYuBLH+XdDKIEVJTQjUhxYqCzikHhMMecaOMk+HAKxI7BECbqF0R/fpl5qYcvcxqTEn0ZbA6YoNMmDAsWg7Ci7P8tvoDHTMLn6XtqVKVWrOH14Jt1M7sI59WTYsLtWblrdm9ZrUsTn94zcu1lfxrPQ9+fL+GNTePcOXamOOGG8dcpbV/dbDPeOHatzmGGrna2P67nlj3He/xt7/mvyyyy3zPDGp3L98xz5vKmVDakS+osZJZuDBukwbw7y9rfHyrd+PiP35+IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGV1Y8AfuLcOuul2Bjc25d8arqDG5tyz8f3cGNbXEmBwsyuIYeCkRaTYXjZVdQbW5OSiCHkGDwPGDUjFtIfa4LJTfQ2l4/TIXHJkcYLSsiGQUHMz9AEKuxFn+UbCBADAbOW1GAYwAxBMSNYKZTXIvI56Ccn0coijIcnbBfk8QBzgH4NsvIVmp8Lgi9QNUxalGxqgRFkkjNEVuTyKR5Z5SZkYrNnlY6iXmSlAbbqLrmTGSKkUEamrSWgmi6SS3Z1VTZJrJ9BJSludUFZoVFaAXiEaFbgIgQG6pIicasUrKueXNPHErFXIzn0u6nJHRaKIackjU/Fa0EwBatX9wE4yOyKLWQ48T4MLD9vgucOPY1HGIRxNZ7DDCcCnYkHDBCacINFMfF16sSY5BbzFSlBXa9zaDJSbrHAyPB0GymCVmMxp1vQJJ3KBZM/1M/5cHwbFxYxwHco0S8Vy4kV1CCpmZHzRMYwiUtHRxolFMaaYZcJ0xOziR6aD0bE6gsuTdFVygLGs4XzymQO0knPIKNU3UtZkmm6lo02MqbJmjmrrTXTQMzRNEwWi71GqlqMnd5i2gigkzG6KVdSa2sigb03WmgnreyrMpz7FxSVabX1t3x93kdk7J2VMTlgO6BmK0SxrksyfKDHej0xRwE/5KRJ/tZQ4PWc6JSOWEI0ZEERFqha2VAgahwOoBxJCKAQGJlw0vQLGdO6jnwhPYqvSYzlL9WebmEFTlNMA1HEuYqsJJnPlEiBwWcaaqFvXmxugKXJwWcB+CH2G+Q40Y+OUA0kuOaHz4jskkhzHLJeNSuQI3E6k4xdLzGJrPOs+6JqxiZIOpyBTJjYyUo+mpaKjJFS6klmhhRRUg6kWOI1GU8gkvNkmcyoIorZCs3ZBSbqda3QQVoMpNNd1ugtaU2ZdycSfClOBMmMlRHcPss/HlHrlHeiok/n/2Amvq+BRwoskDDNJDz21cJyzMWJRjQFCxZQUFrNCgiX3S+5mxrlOgsLCElXbM+QHJKuAQICTrJA5bGo8/leNGBxZjASo5Fy5B7hWDkEeq0EcOyp2ZWoxQNJKocbIREwC5UWqU8dobMWEgyB8JF9HdtTlbLKm27Vams7uZVZmOYudW7yz21llnauxDms7/463yVy6vjX5ZC0xK5iIGR5WdOaSUYZKFGqVFlQSrlm4DotdE4Gb5tKKrjHdt7JQPmX/XTJ4PhZ35cfsi5Z+Hd///0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0BkuoMbo3Lx7IdAY5FuWnT46gxri4Mqnp1BnW1wbG/KWaCAGkICypWF9obhuMw43s12il5UIgUOP6mopackMIquWscwAL0zsWT7gBAE8TUw8VIQVKgQKOIA3oBosuJnTbymDAanD1YNBM4IAE0woIeNyH6IgBfrFoisK6i7xgYMcUkK4Vw2MBfC2G4zgGTbBsBEj5sTJUFfE/kmi5dYPQRLJcjiNSeQGCaBqR9R8ySWkpI4kXDVIhzGilookeSyRnQU6a61rZaCSP1poo0KnSZmpMmvZlPNUn1stJl1mqkj7Ogm1BktBZijrn6Nurbt40zhu+d/qLtPN93e9sd6OdhNrn+93Nt6kOpW35Mp2lrtRfx/Xuh+Qy2bgi1NiQwXUY3AKhIjCtO18YBhlcRMXiQQFsVLC6xmIamACaPIEAiIyCL0egcToIfeA3VpzCDxBxDli7TAYoOTnkxGMCZrDoDaSvZMp9nXXepiAQuZJOcANlcomSmYmZNBjQMjCikXNmIuRxdAPRBUD5ikSBLIuRQWSkoqjKsHwlU+bH7TVM1YQnPOTi0WOGRudGQTMzFz+qkfbTRLySaSnUzLS0qZq9Co+owSTQdJSDLdFaLbJMbvWySlss+k+io5MFDZEXvhfqjAW5swGO/mtSy89Xa2Tcvyf41R+3d3LVHAQkmEigWketiEF1rHGd26ekkkaFRxeu8tNQ4/NVnUFsZHkT/q2maBPuMq+HMTAQMJhRxcQnX+ChpMxSpiFhHgwCEjIQHS9XSOgYUJIXipjsBoTxYAQWsK2NOORMrQBmHiy0h/bs/Kpc/0qZ6MElxYGtT8szsISpym53Bg9i/SX4ZmK/YfurB03zeN3mu5TucT5qS444b5rjyWcAyoCjhZ6hzwAluXDCA+HXllhl2ggYIrcLgsBnAGSzC+HUpxEKlXT6CSSRbLQUIKLOChgsyyfpeNhgYCbzRJY+snhUBt881TKGMrkoqKzjT1aYccWYVSFh/iwUOwMYoytrFUgHQOe0csAGXWRnfJPMAkLFXpYjSO2QP4dtppukKmZkFsDCAapk3WTqsXhMJq3S56RJoK4wOXU9eW081RucCQ25CsLtDJYaMIBbudn7790XcMH6rblbQrjMu52abvf7dg+43ndWuf/d/YeQiRahaAEjA7g65s0Qix8yAVEmyAZSgsbAIu2bPDgeMnWFLg/lWuvPh6keTNDrCaWlmqnur1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAcBP7mDG+Li5YfXMGN8XFqM9OYMb4uDEB+dAY1xcGZOYled2pqpxsLh1qT2QTGnPceWSDcNIdiJcj6YwgEzSJ4v7LlZDDABoKThhwbAhiwALDRuKaIEozoDMFEA07RLAiywd/mmN1a4YpSoQaVrP+xsz2KjDUnNrgcRhcMCq9FjLvKAC00RgkOCBr8GLro1/Q/FpWyHTPjDxKm4fcaaopZGyzNneOfpwS7mOqeew7DEbX5LcbNfervM4vjDmvlGOsc8avInf/C1818TYXcPYb5/oSlf3prMxgzb/1/5ftvOX/T4/isVEiHVWjpLq2+PZ33nodbmV15nufje+/KMwChiFTGz6SRyIvJXrsULUYhK4rGae5ZHQsaQSUCMiHUDTAylgLOQaMmTGqnUnDhxyTBxVDUBngNNBYhHDcwwSZ4JD88mWm/DTzmPgkajBC3kbzCAmODK8w0fCZ/CEAteXuKgtcpEB4EU0MCgc2wZ0DWwv3EHggtmb2tzEYFEgPLZVGb8hbCBQdTT2XadLV7p7lWOz2VttOsjptfIeZYZ8lF5i1nczjjh3L26Qz9y4P+9smztDWqBq1YdkV82X/Pg/3Kx+ne4j/w3kZbs9M3Qr85+S7t2c1tWR+zLa8n+/uvJvzf/34QW1oWCdmBH5AseDGHs5qRWGJY/0sbBDThA4SZ4RBgEEDOKFaUvTDMMBYDR4KydnxgZwlia0zDDEoCVSszkWa+YC2SlMeW0low4pTCoLRUXMh4BpSYsOoaHwuI0cZO1Zxyz7O2WGAQ4aqKCaLlSF/viENPDFQw/lANi9qR4Tb+mAwTP2KfCgTWsbqzEUtT96N2F3U12bpN44Z46+m5VgPmOt1tVnKcGBmqx51xW8RwoKHqTRJF0V7UbmlSciYQw+8a4XMhxbCNI63UlWYS6YI9SxKhcEIgz5G8DXQRp6t/KaaxadeIZ0kYjEgIScJVuNmNX6ZJI0B2yIKL5nzjwOF04EBtbPqnMCYW+xsFkXlCgOFspSLbYVARghZAJZQezVFobM5CxggLNJUXi4cALyJDSEQTAQBDOOUCt6Y3LIfs332gAACh1pPa5nDMeTtqWMbGanU9hRUMav6oofrwDLOdsbw3rGd24v/Vv/v+YNins9XO1K24eabt63OJaUqzQup7aqdgC4iHPPRAl7GF2c/FgyMpa5LGM0+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdBRziDO+LiwufXMGNcXBmk+OQMb4uDHbecwY3NuH9c4ExAWQgjL5oB6ZxaNwdv1ZeDOVvVD5lQrA5joaKAp6tkknMEIqNBr9UYQaJPmHp40GGcyJg78LF5UMThh4FApibuJArklYA95dIZDps0AhgeGgApucJHpCKCNbDgvU3U2QihtBRLVtgMGzASnQQOrCLbcIDcWIoFmKCu1ezAUKp8JYDBBB9LuzTlzdUVLEo1jH7cazUp5li1G9rW/peSn8IE1+WPaTPLGrjz/1+Xf/9f/7v5eSx9/617u/8r98cet7yi3PdLz+fT/5ZKJxM8ge/YrgRFaPb4ZircE1n1yV3SNv13Mfi7bklU4gWDFlvnblsMspluGT5Ryno2oFQ6iKhzLqKwDq2PwEIDx2FjesyHQENkIQHBzyQljEQYADgM5gUVcSBw0zokk8BYMTCZcS2goRzXiyCrCMpAZKgWAz2F7ntCA25yCUYHxoxEBwBwpcIZo4tRM/MQhcaANuRYX4q2MeAtNercqTVWxYuOZU1VjWLMKfsoncd4Z47ya1v8rf/r82wUX6qHb5vU7//U1lzE72rz7F7VxbDlDYzskIyM1RZDoGfQ0guCpCxxcgCeagMJjTbMmkjltSltiefRqie5ioQz8wQQUJPiSVYHnVTGo7KIF/4uY0Ig4XGYgdUBp7AgQaQNpPGqPC/EvZG5zXgANjNIIb5/keTYyuMPNwnExVEKY6eM6ygZAaiq0TDwAMtoAQAd9HOkVZsE1GaMkKT22n7kVjCnL6xSvjLduFItT0y587ftzddVCx2SQ3zXfsQu5EP1Ita/9dwT4s9PhV29M5/Mfvf36uZWW45d0UJmSqUvGgNa0sjlsnmCEotr2jWbXXJNNxXInAakAwK+4DUspXBiL4wmcfTKSOYVCUWDnAMeG0LTAR7KIGAjJrhu/zoIWwhQ4lAjJUswMPRrAoQClNtSRDdKTKMuEvgh6jRAxgkAhYuOWtRyCIwElBk1lL0yVilnGbIBDFx83ppT4pX+YgBoQ8iJGgNkD3CuM2ThHlUugDKFwF10DIXhOG5XMg5+ZkygI/HcxsPb1LSQWKReXH1UBfJpKt3b7//9X+3/t/1f/6931ff/c22P7qHOzBrUKMbW0DCr0oJMcNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHUz84Azzi4NgHpxBnfFwcxbjoDHKNw4c3HMGN0bhYBuQiuANI7OOFp7pilwF4u6xWN24GtSJmRADTAQHcQw0I1DB8XIHKUjIOMTBJIlRciG6piA7GAwQY+ZZg8RBiOMIgoyaEVLzWpxQAvsw5OokARgVyGDwMsIlwOjAzvJTB2sN8hYKhkMD5EDlH4IBgGTTCAAYnAxuophwlgduUqfaFz0VHQCYbNKzZ1vofa5RwSYVB6Z9NaxtOZJ6S1UGgBNSrbjVRUAznKdm3f/UemPWv353W//7zVFBcblfMrZ3Hf01SLP8V0q7UNZhJAYStbQSGOJNCShClSVqfLCgQHEiJJaBzigUFgrJKKPcOMBkIimMMiXMPZc58688bglwq0TX4VTEGBaaRlIisQygtaZJAoMnghYOAmcGQgL/DgOKBYFdDF48ODgQAgJmY8QGiui7kXiCZBYihuoILLCwAMHgs8CODCJuFsAFAkgDWI7jjA0JkoARDMNCE12HBoJtHY8/C2IHU6fZQ0WJSYrt0Gr8tmAsDXB3SburTvZxqnWxe5K3GtpC0v1Zr/y7qK+yK1yPd/H8tOk1MIEhm3gb+j/2e3qSXIziGKBo2FjVyhUFwWueQcK1h3vCwoUF2oxcaTNUSp/YiZoFUpEiSRl8KN6otrnPsVnBCAdERIVMBNADpksOKKg4swxKAgUQWRBdRgxmYBCJwgBJimFQE18y4IHeWAYVUlpiEPl+C478EIJMfpwLwYw+BImUAp+E0ICTJtstGRCZlG71UkaMS8RAgJWE7AZxkPJNj4LLoEMAwR4vpoIrEJjQ1KBMC5zZcdrC5EVIlSyKzh1ZDMyQWgowWZE0s+hQW63QWmpSC01U3qZboLetqHXqb63/V7++pk1MmqgZmxcOlcmDE3Js2Lh1I0WkyB0+XA2EQOQpGgMOYo5h8F09WXZsfGrkcNvoTvN+GANYVxJqabkrkRmPSCtDo4KhAsw9NZpBjIcrimCwcYqVOy+gyHPm5T4GeG5A3gpAHQcWDEhTAQZ40nnzT7aCZW0H0CC11OgIOn3QwMLgGeBQEZk5rdH6T0cCXEAwYMGTUUl5wi4zAss6MqBojYb+ZEUNSsdHWLIFvWTh0nyAlkySMA9U0SMSqcDFxu600GTpG6ZTaYMnUaMWCDF8+eWaL3Uy9Bvr1ILoX2qWmpkL9v/tv/Vd66aSBm5cRNyYK5cOm5gedCgmkaB8Ew6IHU7bVUCwcTXsOrW21S0JAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3RuuIMco3LHR9cgY1tcHRn44AzyjcvItxvBrlG5ZmwMDGEYxEEAqUOYg7bHo+8bAJxyJbBbyyQvQMAEMAI4ADSaZLfR5VExyCWKtIMGg+KhQp3DOx5MAGMSBCU4GVBcAzyCm9bGxTqSoiR4MAI8M1rhYKG8FiI8EAlYMAAmDSonzUNL3FwooIAYYkTwOBK/JCQRAWgSwlQupA6o8EREb48pjpGQDpwzsOYUScNjMEAE3J5FRIFKXBY3D3ieYjiitTolInFllBMo3ouiXSmyzVLoo+i1FFupJ+td6NFv///9Xtep2SVROGyzheWmXaS2daSlnVGRfH5ZxSNaHb4nmW9d8t/3g91Ba//UG8iimpKRWslqgEQha7Cn+m4/IYclsNdkBITEIGVGSJqaigOMt0BxIByW9joIBt81mQHbMDNMbaK8IoKyDfD48kc3ZvC4JoNGJ/jpF/QagDPSZm1k8SOiimAsBrrfwcCWsvMtc0ArZy/rt3YjP01WOGJkjQ5T2rlSzhbLeNFlnUhVvCnSyqdlNv0/73K9j/3+Frs7axyvY45ZZXZNjjePbir0BrR0Iz3/5WqWFQ0VBIShYOliowOBnEAAoeXSg8nPOqQijTmmnRatjLTzGPGhDDEMKcUBQFQ87kKibxv4+78UDgDIJFQC/gCHA4CTJjOXnOQAhXDLOBkDK/MIBoSFZqclBY1magQOCwwgKWIGWialnJUpYAvmMAkAQMKAVIwGg88GeDG90N3BYRB4aE7SmMumDgCh80EwOFzMijZE0l5TFhZ4fiaBYmB0v4BRsrC5y6USBiGgFPxOJcTNy4G4JlI3OCySLEELooA6F/SRTTJJ9jIiKJhjcQUt2RJ00Z0H/7f/2+/////V/dtWuumqi12WtSlXek9tB1MyC6rqdKuijRQ59JhV3vUubfavn2Y0XxIQUPCMSZpIZiCaNKu1BO0pSLyP3Bjg2bFtnQiCZhUHLuMKg9LwKCBoDaBcRmWxKvp8QET011FIiAoiYKHYlbACBguKUtTP5ORNGQIChYmqKAkV1oC4pd9hABKZ5WNGJdSbICZYBQ8CA4GoSXhBocSHTTGQWaFC5MD3/ZuOBAWYUxP4nkKTQWEj2M0MaQYqEkFrA7SsYlcyFoRMSKENDYDBY/j0cCxgiKZQJu9SlRc2RpqktboFIZGgcq6279T1q/+pXX///1aC+z3qrXZmVQc86lLRU63UXGv0GS65o5E1ReglRozwia704GnAjkF2iZgmEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAddgDgDHKty9vCG8Ge0bllc9OIM74uDbR6cAa3xcBABpAJCWSNygIpzJZK3cjbBXTa02J83gZwQjMwEBGhmKxKIw8ZcZrMFF2uAIbN/HjAQNggwiIF0GoA+YWIYKmoBA5rMBrWMjhIWGzIR4Dq+RSECsMCAIWBidZgYAHvDIMvY6EBBQUFmlMRQEpXo/BUBCIAggcmfzcAg27EXJAqFkUQfAWTAOXAfwZUlymUzAPyAsORySugYmwYvIksi5NCuLOJDVMA7yJuswvmLKIiyRZbuslCHoHbv7/1f/q3///1r+379/o1Kf1slfs6SKlIpr3RZJekjslsk2mi6LOieTAnWdYPd7ZHkzcyyVYQACLgQGdFRlgAwlHyB04Yn1ejHoDhhnqa4WBQhBWbHghYYOiqtCnMAgOMKQKewRACYBBIw9aCBIBIkCglFl5QyMFwUEYBmIAuiQRF7x4EbqhphEuYCH0WDJA8wkAY4mBsxaW0wIAt6x4NJgQAAkeYBAuwsaAIwUBIxXGxAir15xqDcGOEBicFfA1pcQVJMh45pMj5JATqOUkiXFiExAFmA6h9m6ybIIah05kibkSfUYoxWqVJDWkiNQrrUYN6vt1L6///7V/r9X1/21brUq66lU0klqeiy1OyVbutN7qRrVU7W6dTqZDupSTnUlJ+HThdYug1DxgyVgpGogtJX67FRTErbd/5qOv1lGnMJTcGB6DYyOF/zw3gmG2YRomiXAYORHTjCoylQcCKptHTAwjQTJyxiZmQRLq5d6HniMRoBcKkG7gEPHOW6YpHwuhBgWQ0kEOBBu66ZcnEr40oLlBYlYgGMUK5qIuCY7QIKAsH450tuMsXdyVYW66mE9hbpof3Kfj1dc9z8p3/79fPVPzsovf/83lUHnv/R//p6f16GufBI2IxYuLLFBhcRGAqKFm2g4BnErTrhrxKFGBFjBkBkgFGMwYQ45YdBGQFtZVsf5fK54daBDExesLDgwyMTIlHAYO05hKErRSGBiQGMGw5BCa1EwEXRwKTgxBEGxVTEwYHcwxOKVpU2XS7DrmAEyEJIDFYhA5g0jHbXKYHg4KMb1iwdEgErEq0weAqNeBEAjLRTRmgmPwZAcYWjLMDGATYHLZZN6ryoHBt+7Vu7i8NLevS6az1OO31eszlHbH71qhzygLfJLv//DlBPJMKf93Vf/Z/+xk2GA0hyT506GUlBIFVhQPhZYsyAAMbmgTYJwqoSFhPgoSUWJOCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGhj04gxvi4MvOZxBnc24eChjeDPKty7XG28GeUbklTA4jmbblA0umozb1LqoWBwU8Ebh6ItREBiQAzXDNAkv4fAIoQPGDQM1MTfodAQcGLVLcplmxFxgD0C0EwAFAb4LAhkZWv9m0gYg3AwCMTDgIWFT+GBiZQjxjFOhqIKguRMJgCwcMACXzO1jiEBmLzGXCbeidWJS9Sm0pIzQOk83R+7VyiANAslyxyqMvs343jAWsbDu4uZZ7Mz///zN/X95G+f/545TYgPf////o/pijzww0MA6GOHBw+BwzJGjZg2owQQdMTsgJGZgqLkT4YZjDUHAdkyT2guc8zrPLDUXZI6khi0ZgcqFxiQq3UoP0VjHCuNy11BZNWsyoDFbQgECjQeciNgVkEsBR5OKbGFNyUt3lexb5iSeVlL4LBDKOYX/AX9BWmXvThEgEqAsoBQC4hfwt4daBNCcGHzErnRliJlID6oXMWiyYpGYuQAMBQWbIO5gampdIMXVlkZIwFnH1Fg83KLrK55zx/3NhtzM63/+/////////+vUv/WpOpbUNanUit5krn7gOB3EaUpABI8Ez6BxtQhoQhiPDmTNNQEDhibhoOv005lsOrX3Lok4bHQoHxCFRkCGPwWFQscBH5aJupgYDGDyUqVdxhQJsCEAKSKMtnEwRKjVgFJDcZsKpggEA5AAoROUtrFmZgMejxlSqT9CxcOnVEZ5IHRI6IgUKC6ZIF0BKjE+imFhQZnOU1SNNHkfyKA1AQwBWgGjQMAwDRRhsEaamo0AMJAoijmx83E4EURJc8Fro7iw5EkA5Il3NCwvWxbWRZpBXvZQ6xpJmCm/9d2//rb////1/9q121VeyaDsp3SarUzIsmiyFmrdzqv0zRK6rpMvdbIKWkxglQ4qN+0V2RehK8yABSg5eRY9U6YyHjvz76SmIuI90MQocHRhoZKCmPAUoOZnGUvR4BoVGQuzpG0YC0TEQ0Ysa6ORINgEmVQEwoiQEHCF8OxRrxcMOCQkw3CWBMHCA7Q+zIDpN+gMAiNLlEouwjmChMpikQOEw0gcBYi0T0l4i4vBaScFLA7AHAEDIqRMuIFcCSoRYnkzU1IaVzREmBglxBIYhdD2UmWVVs6mJBMj00Smf9EmyCJlkz1/QX/qv3f//X33+6lf/6+kh3ouy6C0lVs6LqSWtTrXZaD0qOrZTJLZjqLVqu55S1up2nkTNTXa1SJo0lYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABz8/N4Mc6uDp0CbwZ5RuXoZA3gxyrcO2R5vBnlG4kpCUYk1gtcMsi0EvPDUPP+rmA40/863o4EzEIKIQGYBCRVA5p5CEQBfQDBs04C12tVMSgJNYAgotCYkSQMpRMzQKTDZolbYIY7I1aWuQIkeDQ5IADAAADQWiwHnA47GCr3mZQIiIFhIKVOCIDAgBppHtchgYHRisLbboaNfiMZlKLsKeox8HNSl25BSXasDGB4M1Zip9hS+VXqe0nNL7dp7MU78Ma7e/+/jksx7zUjv9/9YVWofWq70r3WI3zLdPpvVvvXoUrhtjBGeNPVFjhZyyagmJwkAQ+HQsNcBwo+4iI0LFpY8YJoeNeM8E8XQI+HppDLHRIWEROgV2KjAH6fyhEYWMgEsLggcF7DzKApV4zsmCAGr0/BhhwHw6YLAJbQz6pVMigcJzGPwOVQAABGq1zK7XGyGJDAYpAwYAE2Ecj3YGMLBApBwNC6CVQwQgJUIsKV6p6hcDGKFeWdp4gNYh5Oi6JwLcAakUCiAihkM6WiTGUAMcjLkg6BwZxzNCI/qKA41C0UCgT/kwYoi+UxGJdJRRFtUg713/93//9f//bf/1X/W73rU91pK1mKta6Lp+aIKRTZNkVJJ2vRXTUpaTqOJG0xYGeMArJkSGxpoUu7j7mXAaAt2byjhGWp+v84kfgppsYsyGWkAVRfgwHJAgBRkNWqjgYgDJi0IuCtUaEDimBQmraYXMYjmiVpgscmqRckGDnwJBNSstavdD8QrEMNQ0EUkQYKz1CGMPd0wIDWEg4mEwEBoomcWRtaMEjYOkxWB3FdsVQngiYN1BnhyAMroQEQBN0SeNiVG8CIIBtROopqElLxiT5cC5ljM0LKYyhOpFwaauWCdWMykstH90FDoIqtM8ns3/Wu1//V/6rdfv//1VLXRa3VU9b0UGumpnRppsdQUpB6LNSVrqU6Rx302Y6mgjdbrS3W62RVW9a3d1qMYPZoI5TRDO6YXCKCkq00WtQQuRll9pURWg5igZjwfAkBmaQkRBcDG5NWnCgyM4F5hag4KJyxgYESEGmLlUIggJFkwMFwIEFNTEI8QAyJOpnReYwagAADBQApeDA/OaL4kRQ9ogIDYML4o8wcTBNUzoJ8iqEL9uS9heJ8ZsfIj8aAGWQgSCjkE0RcpkmLWAA6JIulZBEjCgThoXSGJn0R3KOuifMrOojDihCVGb+pZkLZOGT+3rb///1dW2q+//++72rUr71qTd/UYonDqkHVTU71Mle6PdZzQpp1LfdF1pOg6bUl3XWmumhWiZmzrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdsiDeDPaNy7VEW8Gt0blo0+uAMb4uDUr1cAZ5NuSEYtyI1DlPMV0aUWYn48rby9qbJIBlDTmzPWkKBQSGQCMGwbR3MFy2VWkKhBgEA0UUoEQCu+YFBClGYQEMYRnUNDeYGCqY7BgmiAi6iLd0EaEp9h4jSgth4GRUAxgXjHlGxiDzMEIRCDZQIrLgKApcl2HyUVIQgMDAOR1WU5rE8QMXORAdIGs7g2xPC8NR3lUhQHjCfSQRNxAJROEXOBjIvGZiRhiK2WkfKHnDih8ZFj+tJiMGkbGbJrqV/+v/7f///96+vqq1WZm1JrVt9dlVqUi1ln1qdHW6/umvo0tS1KY4zTB0l5tFsGkpuYdWS8xjCoUCgm8Zo0oMkmzNgy7ICk0SiksfZmgjKTUDcRBZpBUhLDDlramBiYybswqgTHDDRvwsLBYGNAlSwGEx6pycIDCQAaIvto1xAUnNCzD4weoAxCU7HDoEfIXKgWlDAemsUBZfdNMmDILVWCoCdMSjQI5U4PgTcK8JSFyCtgAoQgMO4pFM3GWJ8AYOH1J8wTURYnTMumwnEyL6Y7GKZ5E1O6bkciYDHILNVL2TKBixxX//+vf/////3+9/TUt6lp9FaC2RUdZmpIprRQSRTreyKCj6S63qU61MybLXP2SvdNlMtBWdSSbXNJC3+i6brTzzVfSPyxmluxFmsvFQvvTwFEYECgeKgZk4wOBRt0OjA6AJDC/tE+oQZL+Cw0hKMAUzA1wBNRZg7oHHgA0YjZM1hQdOZDkYGRBjcBOKqQwKGTbqsMSV0Bj8QiUIBKBogB6GzA2/XKjGmiEAp4GsyaOrxZrC2iGByExPGYuyyZp18517OF1ltrC3ZX7vVqM5PTY3dlP//5WdZ81DHP/9/NQfjdwf+r/9n/30JIDBseWBYVIgJVAFEBsXIFxRIvkyrgDSYOBFQUfUGCuHARQlvDrMjQqFxhsBVaXSx+Hryj2oPcWVNcIQ6YmDQwBjEAjTqReii5wQDTSYDSzhkOFLEjAIDXSZ7JxgkOhxpCguKo5cYxWUp5dTtsvbCMA4eNpgkCL+MBic4KhDCCYGmkkuj2+SXrzu+nipuIBGYvAbRHNtlAWUYCsnBjAPRT4+CLF04M2TYBsxS7KOOTbGZogbqOmRD5BEXcyoVpvGuzmWrZQ76m//3/6/9//1/Ur//9S9Xupa9BDRXeipS7WWpbX1JUaaRwas23dcQX3QHO1bK2dZi3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHTYu3gxyjcuuSBvBrlG4c9jjeDPKNy7vHG4GN0blN9gBLUzABCBZ7EWTKwPHNzE6yrUseCTCMCmCgctsyYCiAEm5SsGAteCYg8kVAGrBw0ZEYFAyPJjEmDQLMagMCFowINbRm8fJXNLc9pkEGMwUY6DjEEwwgGHSgyZUIImzwSLwwAw8YEBCeagjVmhmGA+YdIxdCs/ZLnh2iTDmDRAw2EWsnhyB/HUcI0PiL7LPk0HREQI4umA4jFJAaSQ+EUjhC25xRkyyJHl1NYizrSS6//f9v/6v9+pvv/+6Hruju1KpBFBJfWtqkpquaKUeujWjN6SDrQToutnQoboKe9SK6nW6FZ2UijKK5dYLGTUqxWKnMl4xOgY2v+Hmo0ENO1GlmFgajAnVXAziEg0YSEbuLDggQGDiUMAFngGEcrMABdyjVRJHBWPKkwSExK/KiMGGdnDkPAu51DAoZJjQnqTAYwIGzvBGMGTgdBD/IAneBgalzorUWGbiYjCQ8C1Iw+aERFmCEw+Q1EAsUILFAXGZmpfGiBhkAj4zQTSIaZrZQqSZyQJMaRsyJVbTLLrH1dNmtQHWKk6aNv//1f/r9tuuv19vqrX/v6FSN0UEUlpoprWp2uuip3a6a0VstnpKZlaVaNaSSpmy1roLPu+gyaa2ov0HPLESSX0BiTSwMUmGo+/yM8QfGQU7PIFbBODIjMRA8UBQ6E0JIG9BQEIgYHEZjUMsWIQABQizMRhlUJiQkgADrBA0LGvQKXONEFdGO3aVYucWBIcLUynXCouN9nkwSPic3lQWylSQJDjaIaqbOCYLGZmwqua1qH0hqF8UKSQIQQGK1EwKKcQTYsg2INT5sfWHVKpInkhcKJxEbCI4zJMslBfOkjIfkFazrTZFVWl+3/+v//1//6vq7b+qt0GqSdSm3RSUynRfW9STqZCmitrLRZaVFF0nSd3U7IOmukkxxaKLU611WdZhigUqWwh1PoS+Ki7XS3UrVoaUwZMaH7shmlQEJyaIaDA6Y4hNxMnKIm3hMHHRCbyJqGMAEVMELkFgl3FSgmxBxHMaYlWmDPCBjYFbF2JvBdbDLwmDGviqgeX5mo4BNUCIGQqQjMZGWmy5RhaaDhho8mErRRnUBjgxGcFBAeAuAwGGdHcTZVIkQoGXAlx2Pn0CLk2Ui8FzBkfOEFWGQS0tRs9SzpusddI1fZCN0wWZrqVtV////+ir7/66l/qX3fbskuqdUpB0FMlps9GtaSCd6S1Uy4kpBOpB0rIIz6DMk6dKaorNVougiZroqppJ1HxbYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABpuBOAMco3LkkEbwa3RuXRI83gxyjcs5HpwBjXFwc9jINqKRHTMAXMhJbrDDutkgh+cZEviTDIpDg8rODkkBQMajKIsA31QpMZhbFpZg0BTgEB6fxgUUCACJcEI3M9hpi5mMwLccxykDF1IyDwBGgCvAUC5g9IGABYNgocD6taeINBrqqLMDU6CwlB0adx1H+JVIhwfsXRkANWTDjSQNXTSKYOHC2JJoqMCufIioYR9SRF1kFMaBIt0STWYJqK30D5MLUr////////q//b1evayd/ZVSqlqSq71u8/uyPXoqWjndCeQfBs2TPAgzRoNvYfGW4IOh2wqwlMDABEzINIgdA8TuSynpoCYYVC8Cl4WBDbBEUAjNhuQMWBo6YqPyJGQEBtUxsOGgk5IeGDwmrAcCAOlL8GMpIsAOnCGYK3Ch+ZMEiQqncDUU6XKEBwPTAUABoHVpMSDVa0RGhtMHBwqI7tsZl5ODPB/gwARozIHNwBaYNo0KxLDXEJACC4ecuIrQJg2KZeQD5ykarIkwY4Z1Hu7HJQXKTVaQ+SWZbvVf/r/R9XV//3/6q+1W9aFX2a63RqQqzqTrTS0GdTuprOylXdrWUgigtnd3Zj4fk/Prim548lJUKvENob9l8y1ywpfmJVXdd1hUNW43H3NFBmYWBZf0yAKBUGmQkM1luCoQcIG9ipEEIkCAozowoNzAwWMIAQZKJm4TCAAmSDunzxCWqol8DAQGCxDgq4LAw1scTKk2GwcKhstus4wAGUoi7MaEQBL4mAgQNBlbzikwQBhISACygNULDnkPH0OcmVyQAEHvTNECyRculSLkWYl0fkRXjaZDTSVUcMEapBT9q00R2oX/v/+39ur29////b+i/06lzi1KorN7JqoWRQTRSUk7rWtTNprpuk9lXQVd0HatNJBVeyKaqlKSW7HYL9qChRiKSNJMiA2KPSyZh01KJyVOnYjhVRmWNIfAdWKgAd2cBraRBGmfpKk0oRoYiaryPTREEQIMkkIwbFlBnHSZjJ4xGlHgQKQg4JiMXAQIOdBEwsiBZOtEa0x8RhZyVV2lO+YOExkcGFADZq0GxD1RucpVlMaHF8YYoqO7MRkwQOocs52NQZhhNe1TCp75aXfa5u/+v5+OpT38ef/67jOlDfT3f/6Oj+eY1joEZFTZwBUiBh0JDGFC4KqcGTxYXNhlBYKD61iBK1mgOeDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAbWiTgDPKNy5ZCG8GOUbl3aNNwMco3LLh6cAY1tcISk0YLIjgBhZjIt0kK+2o0Eqh2C7sk5LBkSgpFCIEGGA2wwcMsOukWTRpai6JgkBwyYBBDemBwkVBMUCEwECANMUVDBZIbxPZrD3rQMCloFMBhaeyXwGxxhG0GhwUqiLBN+iQPKBJdQMzhZpjoCv68+BUSJ0ZAg4uQDKrg2AipOE8WzczDcEu581SFMLqkTIuqSSFwsQN5ZJT0jFj2QKraxQZSX///v/q////t//7qrd63X3oIINospaFBSa02oqd0FOlZFTNQaxio4mykXoWQU7Mmiyz6uy9rzacVc5c88iKm0v0uVnrrjCgD9wuQOQ8UFOSFhCYJBI4CwaKnyMUBd53nCgmMVEK40seKL3mCAIlmZYPAodEsQwDGqwGlkYPLosDG7xxsihwBEJgEIo0shMCiY5KozJZMFowMApxm/RXVYqg+KehgkWGdglNwys0lSiQUYJWE7AY/oIDIDnKNDAc4DRpwWAk8ipMahIszCErObjJpiDS6pEqXskVlDnJrL7aSkZpUp//V39f/6vv1a/rrtr0P/vutdSr80P0HWx2u9BBamoLpKUtJ1uy7qopIopM6qC1OxxukWzXNqoEzKgnxBljQNTYZ4ikyJWiMr2bs7tG7j5KNxQQC0wKBZINNoMA5kM+NzcgLBckB70EABBgeiIVF8OGDhGSIoFEURmQqj8tAADmTBF6hwBLMWKY7b4GuLXnAJQeasMhhvFDASY6NCZ/GnlABJgCylLcuoaHAgsFms3zcgZgRQdoroGPnhbwmPBEh7KpcDC5qfU50R2QUvnThFjdZeDtOYmtAW1tNZWUm0nd0ruTqjimV1q97qXv+p+///V+/ddtX3026rIrUg6SLPpqRQZZpeySCbLosidTSV1HHXY6pklJqSUi6qqGgi9SnZTqWgYKRj85972XBzDEsMnJVS5uE/jGoagaRQa78sJAoKOMlFzqoDakmPuIrWbha1htgMfYcCSCEw0PME+g5eAXpp0jETHYGOQSlW36YxiB0YMDKwsYJT8G6hi76RRqaCwRMAuKuZHVnCN4QJmIm6XkTfWDZ6IS+ZaqAD1rEji2Mup5QYsHr3vX+e6dnVf32u3cYA9gV/+1df+OVFud/6Hv/+vsTlrP+3//V2ZKmUdFEPEgOiQPA0SHqC06MSRgsALxjDAFaeFDCDJ8aRSLgA2kKgIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAebijcDHKNy5LHG8GeUbl02QN4M8o3DJx6cAa1xcFTgA4OeAvERTWcYEu6NKCvPDioHXdZ+IGglASAnEIgWYWGjnmYDW8q2QYAhJ5tPSMMPBGuChaXGMGhQGKZcoGCRNw0jzCp0VxDSirrT5h5imCBeHBVaooIDA6BMFVgHLAgBBML2LhUKvkJAdtUgBCNjPA4EAHXXKBujKiC4pEiQ0wNIaE5EBIkXR3olgHESSKi0oyB4smqQrU6gXRBiBGJmxwn+6h2KQya9SyUJ5rNbdXt9f/3tVX1vbqR3/f1sz9aqt3W7LQSUyka2SW80ZaC061umkkgmzUTJJnrU9SdST2UkpMyQRNXseegghZZ6Djk2ws0iMjQp/MhCiOjYmsrmWY9LyRqG2UYSh6CACmGwSSAQrDoMABmIGwJExEBx5xvM3cAgSNg0OlUCmA0gYVJgKQRhwQmkAgraY3QIsAUeHsQeT2GU0AlCEAtqpgYWHNl2YsUoAA7X1eLiZ264NAjmjgDIhSYzEDJPamsuD8KKTQ3AThCpkOJ48RchCZAo+GMN3Tciqjjl4XK6zQXLD+qoJP55zbUfbUspDyy0f/3///9Tf2///+t/pqdbstbqXTUzIo6TqRTQfet7NXZR5TqQdBSmoscpu+tSbOpCyCnRRqdM6kx9IrpfrDDYsB1YCbBRjIXEflhk/GFqQ/cvL7l4MCCK6XhkQJ1TMY8f+Hh0RGPBgul+g4NwMVBU/AwBxlIDQzCpDMlihPcwAPSYSLXhhuzSjCQXMLg8mEqEAhA5n8kGB5gBrYIAcUA6lAwFjayI43QEAsyIB5h+4FYgB4axFxcIGpQCBR7MCeJkqizQDQRVSom4ssrpmEZYxSQGXUbupyetUoqz+Q1/WoibrW3+/19/66v7f+//19b+nQVs6ndNGkpSaCCkKqKFaJxSLoJpNRdTpLUn7ooIJIVIIqWzqUtA/da3d1KWmukizrQpHFP8uYZJGCPGQmCQB6XBh998GD1nm69cTsjJMICLnAyZdobrf6PBYoYQwz1I4SY8AxQZEHc5ggUPQhksdA+2Y40Z21ZlgHNTVMbikDMEaGw8CR4DHWw+BRa670rtjSIDtJ8ydaSqIQEUSYd3L4MlsPz7pEAjn5bVwvSqTmDRGv3vavatrG1TRbPWTnZMwvd73/5+re8f5vv//7mKo9OlX/3/9v2OcyMoedFjUwXGhpMisVNqB09PlSIlAsNjQwZF1CrgiD5lweDSTQNgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHm403AzyjcsTHpwBne1weDjzcDHKNy7TDG4GuTblQZIg06BCaOXigKqsJfaXPE1Je848/Iop8UIBl8AJbBC7aUCpLAbkAkWmXByqxJ8wICH5BwrKBCYICQNTACS5gYVmvBMzhFNCWMAN+GHJbM3Jj+RBV5FATVgKMVtw4kAAIHi2ztDoggxHVtm2BwsMvgMiBdeuQheK4y48A1AgO0hqZdNCgRJhygsnIialpUVA2NUFidUEy2Mc5VdMwIRq3UfTQZykkvQMibIEyKP9/6qqv9W7WXqbX+/9SuvrQumpV9DZmTZSSaNSKdaCKzdBbJLQSsgaOkigykqm60E0VqM1MijqRWitN3Wx5R6aqQsfUkNgwzALGgSmbswkgvdTB/5a12o8eT0WnYbUqCJeuSmTAxb02oif1hitZoxDF0jgUpsTMBEi7pzqUIQMSTxAWGchMeBVfDrXmoOKqqMZZjQu/jDAQbnwWwFPwUJuOzxKFY8OobSdlqkyILczcIp45OUViCCEceaboa87Bc4NDLF8M883op+UuU5vmn8wi+X45f//qt3n/Md/+b/VMOPf//u0Vp/dqqFWOGtIERdphuIC6yRpL1lQAEBRI5w0WB9qkoF3UQSIkxyWrIGbN4CKinGmrTTriSnl8PbbbhpuLNyoSgUURUDgARYmfxa9T7ioXNegVXzERACVURgjpVkQiBKCGmuWB0aIIpeAwwGpS0dMlTJ4DCCAMhgx1FcjIeMenMx2UxcADgcQFPCpJtQwBLaLyCgsNSCxny9Z8qkNMBWSLkCA3FoNuYipkxOoh7o4k0TM4HJE4bpnhQTKJgWSaEk6zYi/ZJJaK5GpqoO5HjyyaL29V9f+3/rt9Wrvtq3f9tda6qW3XWtIyopqQTQMqq1rshSZNFI+aoG6Jigau7Tc9Wo70EGWx9BnQmq00jzIspTIoVLQUeobknuQjhwIZ/OPOEGXhljvWJBHIrDLoxtqIjFZgAAohIZgoGGSSygTWOhWBmeUAdmJACIwMi9ME38EyATmEwIAQOTSsiAxmwCOC8qNKt0kMVNUzCDwgaJOlgoGiI+YKV4Ga4qAYEKwCgBXygYlqIQKIwGZQADVneoibPjwXR9QOfTIgR5MuEUFCgP8PgzUo8RYeEVGBuarLg5aQ7bJNXU5qgQ5lJHta2QNGOGT+t+39vXV2/6HVbt3X1WfvWnTUzb1rS7ooPQZFSCa2TZRuyCLrpMihMHNmdBC6LUkmZSb3ZdmOoKmW6k5MJmmF7QgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0eNNwMbo3Lrcgbga5RuHT443AzujcuhSBuBrlG4W0rEnKIqIGGW7lpcK6muQcu1pcfrtgYOKnBmIEjICqAOCTWkyGIfMCFjLlJSmPA4OggxooGhpiANTjZwECnh1Iyr4zsxlTRnSYc9Zi4sIQhIxqBKNm1qAAnTrgEYDlcrpJROlEhFmyCIwUFMhaVN3RgcdpkWQwwyoygHNBgSKnx2pKScnCFY3cxE8lQwROi0l03WLdIai5qT1dc3lxpSP9lEyerW/Vt9tf/fU3b9ff11b+9X61dq0WZ7JMgy1sy1JGJsmi9SVNlJqWpE2dFrIutF1upSz6TWSW6SlMqyTIrZrsZqeXUuRiEMs4CAJkBIrvMaXSEKwqvS2U9FmoudLZazhipAMTEYQZGYPAwkBTBxSeZxCATGCRhAbaIewUiKgCN3i8wGS4fEQ9MFiCDQE6pbBrersgwKBEOhQKBEgMGhs8KmjBwOHoEIQGjarxiUKaU7jxmAgqAQCn5UkhHkTIqRpmQwDUFhpkyWzp4ok+BkUZBTyLMRpqZpMRd0TAgyRFjDRvmZXlPQbZUwL6kkPV+/XX7tS/1f///77PZVT1PUpVaa0VJNZZk7OkgiyVNNS01MpaCS59a1PdZ9kkHUfdBI2TUmkmp3amnUpGt6loGLPZzZ3AgUqlmbGnUNGMClA0GqyWOOz668E5KXeGRQFLpIBGilK8DH1eMQQYKDm9G7iNJBRguwwVGHhgcCjAR4a9gSZnIlxdc0Y2qqUMucdPcZAAUeJQRtL0XHTBmcjFVEmORZAIlmPAcCLBmFAxhJwxN7IDHyUlhdMignMDmRwtbGYJUvGJoUQsOKiU8mtc0PivJGaY2DgtBupItaC1HHJtrO26lpuik72/u+++pX/f6n/+rq9Vtl3XT1qZSl1uylpprWhZ6Sa1LooVool5ka1pugtOyKk0mQWhN6a1opr0Fomil1ugpNNa7MaqzHjgRAKBQhe8RRB4045caTw+zVgFpwnTcNy1+kAvMRA9sKlgkBAIOZREgaIgcmYEZAg2/YVEgcCTYBkAgPCAkYCBppgLNQMwCEaB7NW4w42AwYAwhXhwNVuMGC87kWjBxmBSeUVaU6q1XXghtWSgQOg0GLiZa/BTSKwrh4doA18kSbRPHkRwgHJBUjFBNiB000WUxkSKBFS6pXrOl6PhCZt1LSN3Wi3XUrfq/a9769e7f6+v1OvfV+rWpVJCtG0+pJtdJBdNBbpoOyDmyVbM/dJFdlLTQZFV3VWtmaYJIoUWQZbJUlumqo6iAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdPjjcDG6Ny4RGm4Gt0blySQNwMbo3Dd0VbgY3RuWnFgIrU4GHkAgyAxQFgiZ1t4F6v4ziTN0hpcyZRABgVCCwWYWhQtuIIFyLLIgdQQtuz0xlBCAlTYwESN/BjADE5w0SRMzIXxZ9YgBpKrwE0g0EUiu41EfMhnxK1UOUAcAQgETAwhI1DiwCDS6UBsUlpdE8jlCCBQGMA2eYYBBVsZFYdAW+l1TKWU5RUbCkS+8ZtAVuksxLTutSBVSJ0/I5DoseJdTPXX16+v//9Xq/r/6N19NVS/qpsqkpTWRWmpqSLIvWkihdTJrZSSGZppqdBdJB0E1Isyb6LI0DV0WqRmyjJS2UgjUZ2EohMpSNOWUAAovKxJU7WXubR7NyNhVp2HFLBaZqJQ4OAAcCDAhTw8jkFA/bPUbJYFxtDw4mPFC5FMRlxrBWDhAxmADABeMOvMoEFTgmwiIWR1KiMbHmjJYNB0Xc9QsKgDCHneBramw8R3ZhzC6MYTI+STGEBokYoxZKRQdA6BiyAti1ouRU+guRVzhkT6RPJLVdWsqyPah6kknSWv/6mtX7rt7L1X9X61+z6kX+2y6W6mqtUpkUFvTqOOpFzyndz+y12XVSN6z9JS2QWmabm7HVpqoGyClOpaSSJmYJNN2eaFNZYm45OUPKajoqltlVECbYrS2YZvU0ORwQg4QeskM6GSIkNII2IM3EAMaMhNdX03ycZihOUCxiQQKjYZ3iIwOmM0kTMANT7sR1uCUoiF0E40Wr5a8Y8FCm6WlctZsZQ5wIBgtc6PQyDhFOGAjzw2Xy4OWKOWBfgZK+LhIofMibjpAWDDgWpFIdCaKCQ51NEfChwmqBgvU7OkRZ5iad7F6cf9v9ev6q3V+r+/Wrv77ILdl6/b3Ux5Kup6rLZnVMVObMqYJJ0l101rdNqbqTZS0k6S1LQWkYHUVpILuggymddTsu5ulK0rGZrEAtVplQagTxs5cucYDDEsg96XMFCkw4phiCxoFAImxe8hJMmGH5aWFQOWEwgDQcxyYITIzMBAhcayDrHGZFBVz7L8N1ACQaaIpxoiAUzPvqCRcDjBOpabHFg2QKIQV4AFjIwBn8ikJMDqI0ix4aIGnSDODyXTEuHyBAmfKZeRdQvk5izG6RwiiBAU6zZbvm6iWXM17WTL1tX/6Xtqr1/v/7f+q/VVQ+u6l13V3Qpu1FJCeQSWkbstRkiiyR9BZoo0Wip303RQTWy0WtZSbtPGabItPLMJq83A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHE4o3AzujcuOyBuBjlG4dGizcDG6Ny35G24GN0bl4llKwmvgHHFsVdtFXC2GGYcdxiUqht+pYFyMaImFEzWzUOmoPY4heZcUrMjbtv4AEZB4x0DFUkHWwBNjlz1Nky0CTGgFWNjj6lU0MyCkiRoGKgSbahmROY8ZtVRVlyIKogABN2XkoYZSAJWq4d8lBjiCDERH8DI5BRB5QUkTRSACFicUTiaRXWZzFZkZnCAxGR9ndNVSjRy6qZN0Vomikvfrr13e23//799ddf/d3vvfrqQWfapS1JKWmm1ak2QdSLKd1JmaalOipdToJoKW9FaNS7WpJK03Q1LUgaNUQGQK4aaFOQFGBlRr9KPS5X8CtnYU6kuaJKHcnCUSmUQslMgaJAAwMEm0iTSTHQTg9lKy5EAQ4QgAxogzAAiDD0YbEJn8DMDMEFooB0FOOupVYEFouk3zKi6J1ANGGFAHJx0FTVU1F/teaTQCELExFpJdGDRNEc8jRaQNEVI0i5VLqRfJwDAFhkijPHC2TB9jo9mxmWB/j61Hu5QQUQa6PukWScb//a/6/1//vffXfb7v7rsqtV2utSbqRWnZF7ILUktE7RqNFoMy1oa1OplHU0HSdBb1umaJpvY6u6Rmi6lIoNZ1VaKBcYgkYbVGWbkCnEiSgb+Q02jM3Mjcezlb5Dg+CitAiQggABTDBxPtQcICTOQChWq27JAMPDQgZEGAxFDlIQnpzpUyMaYE5VH5E7j+GGEAKaWdsuT1OWii8wQVKYkQI0wUEm7Fz3bcsYFhUIZDOuqZjvGeEmLolEI8RokwpTF80BvCMVBA+ZE4aIn2IoyCA0lik0GRT2aX0yeTj+9anTmiaTda//1Id+l7ba+rU9lfU/u929FVbbKZJ1oXoqRNbMgxmgtRwxW7n0U2dFBqkkTy06noopsilc/dBM3ZzVBTopMs2QcxPviKAJWmBMFog1T7qUrMWO4b7PjUVLNSGXunIRwnMRJ2ZlBWNABi4vI5wCEI4DSWHSgUnEZ3hNpYCqfBFuYQVmuEwYCmDhaBjPHbYY64VxgNAg4aXWFSo9nBMjWhsAEQM86cSNUddhkmafRgZGn1IKYslMmx8DuFSAz6Q3LBLGKJGGoWtCaE8yCyoWjNNAZRSaRBjpKrWo8vlhlkNT0vrJbvpdP/9v/Ujd+6v//1v+rrTpszukqi7Ks6kWWaosiicpsijRRTo5i61Oi9mQTTZZ1BkjA8imp0EprQMKCN10mdRrPwVgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABuuLNwMbo3LjEYbga3RuW7JA3AzujcOPwpuBnk24FSOoUFJQHWwMym++Csr2txisehyGc4nQvkEG0EEQoPABhRKmBODA0Y6JxdpJVBm/C5zBxiIiFgkrKxg1OYOlaCJffZ0VcMRVILC7C3vWyCR4x2zMbd0D3LjDHkW1NCQAnJSSh5IKsBhiGS+OkvjMnyuBosxEzVMqmRWWGuPmtzEc9kz5sWUseI2SrdVS6i8snblx+tkjRJX1v31bUvor+v/b9bfrW2/Q1WtZ6l1IvRrSs0xWmo1UbpIIWQTpIpst1rppIop1Vss0UZporTRdFBNqSb3TopPRQOS+1ICqHqxjgkHkzdFAUvEhSZVlerxK8cmJsyqNxmwsHmxgSqJhgcoIYwHRZsQoQhwqtSImBgaoVquwb8ajpwNdyDRtA+10dE1SsOVfMSwwEsOGACgKRmC6CbbtA0ZJwwRAkLKAAv7qG3IC4CFBQ3EmYk5vJgTY9jgE2gYBmZFwZlMnBzx9BImdUiyI6ymgxkOayRwb0dD0F9zJNZDlMivVQl2v/UtX+6/V9lV9X2Vszt339frq162q0HWiyqtFE3u6Ds90E0Kak1OgylOySLoJrSLimZ9JJlLTdbpMpN0kVqMU3M2ktOlukYM+A2sVlDuaN7HrcO0/j9tpGIzBbcyoJBj2uoxEdUfCGJdcMoCDDAyOuSDhVxigNRKIhguYUQ5gRQdQZo2gggUQaUo9alYhdysDBwugOEJCdPNGCSYOr19vCqAcDWjpT1ZYVAMM1nDn8S+RAlBCxBRXQN3FFgIYbpuanxUkX1EBSSNnHOUmkQeLm1lqqlaUMzP1a5W27q+rW9vrv//XR99JX/qq9775xqKqaaqSTKWdd0a1rSUpaR90LpoqWnoJMtTOhoJosySSKKSmYxqMU0UKDMhUpEzMXbRTPMhZeXBNR0GeGhNOJqv44zQ5c2Ntn5edmcnRUMeg1NAwsB04TGoZtNwEIZM5iVcSqJbCIFUAKxGkwMYJBwsyh0QBBjhoWIiPwhAkBxd4DDovNLA0QgB6zAAiOlHUwwFSszMqVI7yE6H10tPFgQMBw1QIAEBZzReMCdLxkdAhYc4mieWapkiDcgaTJImxOmx95EnTMiLrHPSpH+tJKRrun62Wk6/1fXsv6/77f/7PWq7al+uld6kL1rd9KyKmUpaNkVumtFVA0UkdRS591JJGNSJjU1zeXGp2QToJGZ8pYeBmHJNgUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAbGjzcDPKNy2HHG4GeSblvONtwMco3LdMebga3NuSqGgOBihCcZbJ0kIiNARGj7cXVZHL5LL2wumVAsYDAijpYFAEAIkKHkg9PcwyFXXfoWIbOiUXMMIgshmEJswCRjRY/SKCw7YvVZjGo+VhZ5miNDMBAI5EPTIBUFlci+xV51QLDoZUbiwyRGB820kBFh+Ph7KRmBuigfdjZNEtoCedrj6KxmksgKFZDI+cwN/WnW0mNeyRhXdf9Pr+3/9v36/V11PU/132VQ0Fb61ubLW2aqUpS0Dl3VZaBxJTsdWmyN1Z92RNk1um9Bs2W90q3TZSKEvs7tnK4cbshyCXDJlCeEMrKIyYq6FDGK1q9xwWhCggMrg5YAaGSdBkAaOg1MAA4wWSnXXkNCmeEILh40MEiqIx5rOCNJqACYhEQEbompf4KKEOkLbM5MFhI6+XzFZJDlyIAIwVzkt34ZvL2JGBRWYGLqFUpuGBNEcPaYzQBGkgQpJGN0iTJ1R946lVuRBFblhEkGrS61no6NBe2m1n///t/+/6upv7/bX1KXulWzb9S2WeuiY2RUt1rTS0Xatt2ZTH0UWZJTJGDVoKTRUt5ibKLyDn1O+1IzoTZzKgklYvY28N6p073ZE/DSHHUuYO5UXp6eQtbJRAJCtWwxoG0UDAQJb6ItYMlgZocNg4KP+YFA6jC6QKORp5AEPmsREgsYCK0MWn2c6VkI2CAM/EITCOYlsyCUh4PLgcZyhUKTjEaGARkEiSeU2eyQEYTZVF0Q0g4GtGm5AjBzUxJUUUmmWigQw4XjiBBjAwUQ2Rj0z/zajm7d3mjL/6+pv//u9f7qd/9kuyqn1JVV0k1Ku6n2Uyq6CCkVr1OitNTqQTRQa7mylG6lVu6mSQZJNK6nTLyaVDUk93UiyTJHEM81HGghyoxswxONJloNC2KOuLAE63WbpoLZOKGRj4GlSBhZNAy1HcdKhEoFnKeDUjGwWVpc0ZuZWIUsDWQjGSESL6gQfWPEkmX4fYwSXFvFZ6ugoknCbRgtSHMKlCfCUL60y6JMneYMCnBp1qAeFUjS8Q4dQ5AJwHkqGBqxiUw3JbZ0Z0xQTMiBpIIFWOU9Sus6ax9vTV9ZtU7f/26//1p//6n737V6ka+7rUugtaLPXOOhdKg5ktlPZ2TQYxQZ2e6J9JbLZdNaR5FF0UEkUaJ1aaZ53dSd00XUePeaKEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAG+Iw3AzujcuFRxuBndG5bPhjcDO6Ny7BIG4GuUbgQgNq3hkGI3HCI6zfwHLY8zmBWMPRD0Qb8ZGjFAJ9gc1v2DgqYbK2cxgsTNWsYSGq+EAyytNIxlzFuIRIZnhgnaZ6ftli6tvxAAMQqBMnUeChOdZpBddHldUrKkaRkFgRWKJyMt6YUPNLhEHE8RrDLmhNAi2hQEUDY1MjIuBpxq6VRLlVlJDhZR0cTkehRV6R6fueq6igS1b+r+q/ra9f9Xe6796/7P19XrWpNar0WRW10tTIou6SdSK0E1NUk6KqmXSRdkGdkkFomrIrdNkrpvUt1F5NI0TPpIIuevoPYa+nQWDwCipWD43IVBdemH36XTXgarGWbjiQZiDOaYwDIAQYlSNxAqTmxorFmFmDDydBKBNjNkWBG5hyMYUAhkohaYEWIwtcVBBk6CZs1gFZYFQMAGh72KYRpgYvYGogvZDo/6cbYFtEICcEMkQ5LogYGKRFi6LlAw683TNUDFRVCAMfTc+5HMylk8bHDA+iPtmc91rdyMSWYv9adL9X3rd3r/6v+p61+//9a9K9ls2rUgglpMm6q1qdE8zui6DpJpXUggpSM2PJLVTZklqrXQdbOmgYJru9BVamoHlJOYryAWFtLCpoVlUEDByAJNdorxSpuUqeunkLWnbFQhVUYAQoIJap9uY2gXGxg5pUOJg4YzYABCfRhQKI4km+xYEGz1WA1Y2aZHX1iqPJhJQW5UCU7EBQZ5xkzICq9Ce7pMDpKs6hjCCwKRmEE/XMgQ2I0hhDCLDkAZ2EGCDciRfOl0pANASfNknTHSgowYgylokJJhOkWvWjNM39cpJ1v//////39Xs6vW3+vtW1CtaS0U61OvQWyCnSZkjdGtBBJkrGDJpHGdloUUbp1rQTQdKeNDVc7hUlxxHILd2MOgbwYBNYFHZQsSXayTFS1z25Q2/D2tnf9e5KRi67AAKC0qDFhBiqPYIBxjUiKbocDDgbV5BSShjUyiI0p5GAwIDAirYYHIqu3BahISQDmBWyYVC7E5cTAM6GJgYiRJZoerFhhhz2K2OE0gCB00WJxYLxG4WjAfhujuF4BqEg6kCHmKjBIL1kVPorSI8tKRYeK1GyZUNVKN/ONL+x9b2Ws3qbXVVfb+tf6/sqzP17/1K7r2Tf36up1LZFNaqkFJJqSdZxlosyZsgb1s5ddPd1uiy05sz0E1PZzrIIpqWfQRTZzBNZ1NRmaaaKJg4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABuqNNwM8o3LY0gbgZ3RuG0Is3AxyjctvSBuBjdG4h2JASM1ClYC8TEK0E13chEPthoJmAHrYGYWAChhjoEosBgkd+MDAJMNhSfW4JH1egBBDaCxzCqfElESjoCB9wDNotflbeEAqaiIKkxbSxVsBIdOCp4wCcho1QS9KmiICrmIQE+oICojE03P6JM3J4+PIkYNcYz7pmZRQOjuIkfUko4VkTViRbIOstvZb2rN3N3or61GCSKvq/2W//T/9e/eu9dXr7+r6aK3VRUy7regis+55kmQWijRdBSKSdbprSTsnsmyKK1qMUEFKWyCmRVTTP7oqP1KUiYsZU8qUxgsKhgrkEwF2U056kSUgJmVLIIKnoZZeQoSAp4wEfPeZyYNOUFRGOQA29ZcENUVS9SnBLcKF6XKzSZbYwAD5MJaJf2USsziBDstYqRRgBSexCCBTDPtF95XVLywYrfI4sYAIEqREKssJs3IsLo0IYBvwIb6XkyHpl0silR6U1NjZJjIn7KNVDqdSzbXVlxajB/Y6qtma3/R//9Bv//9Vfu6Guqt02entvWa0zSzakHMj6j6SCOyklH21uqgaIrSZOlSSZb1MzuZJoGMwdFbZ5NJmSSQRUlMGRvWACTkLgRMHfkV9MXsmmY0x6JwDyWkIPMGAFCcYrCJAAFYXIfYYAwQLaZDAwqDWtDoLRoDkASJsFEsVBAY/1Lgc4H2WFbePv0YeExEenNhKWIDSIOAQ8P2js6lpeJarQ442IYAZkwZwVSyw0LSJDS8PwGiVBwY5pWY6XSsH7F+vZ0TRiJupZDJFUajb0C5NM2fZdMroKr/1tU23//+v1dX3X2163WvfvTulRqWmpSbLRMFOgqnTospBNNqSLnz1a0FomNNN2W1loIPUtk0zJGtnpLPrmxUrpmtraazKxDgtCGtljgyyWQmRSGu+Uim2hkB4VhCwpgQAnyY4CsxbGISk10/ZUjyZEHMFYczAzptSBc8BAZZpjYkpJqsjaetIu8YMiE1OVhjExwwMsuTBi8nCxUJZas50mJoTNspbc0RFZbOcMSyRUV9ZdBFdIeSBsWVFwmAEhmnluimpaRPLUpcZ9TrPepfpNVdZ1Sl93rrr9X//9VnVoddn/f/ZPrWpqCkU13U7LTRTUtFJlT91qSZBz6m2daN6TJoKWi6lrTZTJGJx0F1oUWdI6mmkhTWt0mdNjp9MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAbii7cDHJty1HHG4Gd0blpiPtwM7m3DQ0ebga3RuWgpfGSoZtCSOuWQwRZE5A1xWqFvZKo45AqHX8GQKYZDkKAQzlbqRoDASXLBmEQY+oUBKrzJ4VIEWLCIKiMyeEFiGTxUlw4jrMna0FjcDhs3iioNChxNLgYAExXkqmbfjAHWYipKGdBQFgYbPzD9Y+SpUGWImYAeTB7hZWdOGxKB8BaauUDzVkEQpDmqMj6lnm1S7TeYv8puirbbZmV/3X/1f9D9Wqj61VaqdTfslUijXstBSq1I1szGSzZB2uyBsp2QdlHUdBkGU6SCR1N9z7JKW6UxpGyK0DngY3GZYvd5jXwMZFAGsdjiYDjRuHmXv41qOvpCxUoemQBYNS8HAC+3cv4bCbMnFQQxAbe2w0s2dQTaSiZoJKDFDNjMeE2KQNDyNgjjBwGjbSACBnztQ0BE30OAcfYgi5TtJfV4kkTdSJm8Z2aJE0RQxUBrQBxM4mbrHKBISggtVFkVpktWZISQRVbXU6z+g3qWqv/Xb3+rXv/ay/6u33VdfbWvXW63U6ndKgjd02WmmkpSdFFk1qZFk2QTUkhY2dL2RUdpIJzh9FJBJTsjc0OLooJ1JUkJeTChDyDII88AZFRRxQhYzcsXMn3MlL+zU4WB1NXY9SpWmQECYMEKDlCSwhpQOMYgIA6LGhEAIY2pCAnNIFC5plCGkCmQyiT0xgq4YgDNTeIhNTNtQwSUCCZn7fq0s1cZK99l8pih1BPSqTORUjkSdWABEOyfSqYnyLnlIrYtqfHLQQcaSjNJmT+W3Vq21opMtvf7d/V+//b/vV9+/2b9bVNZTKTOrQQWtJRogyq7JLRWgaoporSdbnFKomKTLRVddGpC9j6CB9V0jZbGi0lJVpKQqTmCZUNEJc00EvKPE0zWlt83F8piC838gaMRoRgRjwRERYPfEEibzx0dDjZgBmrzgZ+wWXPm/EJdxOMVBDAhdJYwdYRubhEqdEwwlaKxhJKkBAGf4HGTOg9hII2d3WLtRWCpU/gAOGNAzyz80XDEvEDRRA1gs6mcWeWaA0BJMmjKTsmYGa1mCKAyx+z17Gk1029FFGqv/19f2/7r//9Xv/6+3UplKZaCPoMtNCdTtomqWinZOggg1TH6SVSa0kWUmmd0Xo3SczbTWo+ZOktSSaq5tWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZmiDcDO5ty0vHG4GN0blqSMNwMbo3LRUgbgZ3NuE+8QpCAqAKSAA8GTu806VsGSvdiTw5OS0qB7tEoUYmPjgkZAXseeNoJrYW5agxiYSv8Rhy/DQT8AG7GyUADNFmph6I0yDHIutAMTZQUUltlShQUOasSC4DlBsD/J5EAI0gFBEy6KG5AKtO3Tm5WIwrGQ5QJ1Dgx5M10DQQuYqa5AXdaxyEZiPFTaXqMKVT+9RaR+v9X7/Zf9Vf96/X//9v9TqdFChfTTbQdJq0lLTTTZqdZxkLoGKlKz7KSTRUtSb17WRTRmCsmLGqQ21JTBBmgIWnHCgVt6oK22OmlWcEy2Ariq5hwOxkUBErDKCpvVbE9zFBtnj+mRAjHFoTw2FFYCTJ66gyGbKYqUr9eiq9MYBoWDlBA9uYqOHHuZgdkHKTc37VrHAuJu3G3+C4kEHKmliaNUzUjimQYDVlhvGpoamhcJQWWO13ZKyRs5F3dSo3bKaqhTn8xZ32TRq6v+ur/v1//9SvVa/Uzfu669da03QRU9Vq1JUm1tZTMyCDutzdM4gedalJzqBi1qk1IJJJIrd1JKp0TN3QemyFE2SA4wGSvAQ/PJS/CVS02tPhjemZ+lwl8hVtSlLhmkiDXzcRZncFlUAApgv1mJjow/IqBrFMcSAoBkQEDCwECa2gQfiwBJ2W3ZaYA8hAU9UtLtn+pRjKIbMBDAMx6DkAbaln3wbIIAgEjEhxlxubkUIKVikAAmJoxc6xfTGRJdNNUdSE6sfdGTblBO57WyjVlspX3OG/7drav3//7er/236/X/SdrK63RN1OtaZ5zilTRZitNkVpuaPekkgix1B3WtmW9rMfUeSo5pQZNBJJzJdkLFwJKBATPERBhvEJRzmBIDstcZ7Emtxujhq9R25YMhYCPGjGQB6DBh5j1shd0OZoPRkLAfApf9KkM5AuHiy8Fg0BBClJlQ8rumlc9AAWGDPgJM5uQjGzJY4RyCmT2J5N4jwpkxiX0TYDAANi1DkkcOkNJ0fYHg4hpaWYnU0AbqmfPmyCCCzCtR5x0M9fZaVDOv600Kr//+ur9S/+//9rf+/df2U7V0WUyL00k1p1ppLM1qWmmjU5i9R1dTmyJrrTRQZPrYwc6pSa0phZbJJmSkHZBSKbH5uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGmo+3AxubcM4yBuBncm4aWjzcDG5ty1DDm4Gd0blWxKlTwEYVIJ7MIZuuuPVqePShypypxugqKIITRApOEBgDJXAVea4PwLAIKaZUIBdfxgKWXYBRuYWGGogr/A0IYGtFOWAY2CB9RmLsSEAaekTBQcIwFDpATgiABXODASDW5FugdCsFkMacfJwdRdNQNfzMj1G5oouinGC7LI8+myxuaykxPpUF6q3pLrZ7vrqb//29ar///X39/2qVoeiyCmVZq2ST2ZTJoLZOy2STRRTW7rppXbPqTRRQOJPzKmY01LooVlJbHkmoWRUkm61IIIpn1K6clMN+w1P1h6xMO78CwujZfOYW6aUCMhAwusoMI4+YOdKfcYLAQQPQVFjLwiPrVU2NRLxGdjykyAaaHMMZFWbtillOqoQgA9UqFN8WoOsSTCKgMMICURfpQ51FH5a7CThQVOvvAqkwkUECcADoqJnzpsx0NGKyNFyiuyBO6k1Ft/629nbexp+vrbf/+r6v36vq/vv7Lr066u7JqmjOasaKME9SSDskfTTW6WikeSSZ61JanTUZGx1FFZu9FTmaqTUFoHXTUgmy2dBFnVPLKTAFVCxkTAvFIRnr8S2WPM98FTUGxfQ6CAAbJAQw4ZSUNdNVRLnCgSbmIq1KAI/tXCggmGYWkF/CtRKguBqaBzGgRrjI4fjdcxQIHnJdD1hcMNnYQqID5YIAi8zZDhGiEHhnJEUIT5ZQv8ZEUTFmmRSA8QIcdUdSm4yxCLWlIY9JEhtlF1ZFT139TrXY73WtT1svq//2qr/q///VQV/9SHvrtTaqu6CU0RrRc7QTsq62SU6rJvU6kHUtaBkpN3QWgktat0nSdJFNBTmNGyTMjNV4rCoLCwBjKmF6U1scYlK2xQK3GUSmHJp4YcISMUBkCzDQh+TKCtnE4sELDsBPuGHnCQKgEygwAiaDgYKAw4GsgMaElYmHMIa6wAwUZB2KkVIS2x4omY7IDVAlIuNx092WqoTjoNqPFj908mU5dL5XHGBiE4uM1assRayq7ajJ6BElpKUsmTS+hc69PSdfc4e/q/66q3vXqfqbt99Vb/1rXt+1lMjSXWynUm6dd0TrMmpBBbLpPQZBkGZN12rMEUEFGbpG6zQ8k6tNG6SWbF4565BBTOLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABnuKNwMbm3LJMSbgZ1RuWhIo3AzujcsyxhuBndG5QRxARiLCzA5hRf94L1HAMzDTDYRMOxRK3CMmecomlNzOFZ+bIwKEJ9S30in8BIc4hnBeShoZLDhiY0MLtMxBXMl79wpwjAUgx8ILlsuIREx9eMbVx8hEQQ1hkqITUQqDPis8dBhGAPzHqZEixVGemgH0ZUN6zzohxLKVl80ZnIEtFzZIaz1mjJfbX71nq7q/+//f7/f69v/Zteqj72Up1VNSdrqWgtF3ZJ7JUZx3WkmySSmRW67IrsiymaipSmSVQO0EWTUg6jVNM6GFYJ7hShlOpQQwgGgIqZyzesxqncZ5cIm/8Py0gNgqO5JRhTFN6oc1hCqblu8qYZAvAXzVIY2CSXWKIjCYtr5tTacbXHqYezkA6wFZYo9RAhOxqAJojiI6LGeRdMKUxlsVnTfjXmnrBUJsgp4vEUAS0HAeSWksmxCEl6ToIu60T10DVywi7fqUrQ7Zkd7/66/d/3f1V1t//9lVb9epeq6Pq7qUhTzRGtaOmdRoueRagzIpMyCNNlUlpU0V3daCS0KbsXboH0yfS5lCDMGQJuLEhQszDwCoRhtBehek1JHrZbSv3do34X2YYUjgSZERNYMHV4CgMQhBvgixSC0JL8jI25ZpJIWD8eklQk4A0AzgpRrZRA+FOYAsKQR+izsmpHYzXj2yo4tR4RGF3kBLP20d8FQsanLaJNuOk8XAdAYxQTMlnRcSSKmUTjnEGIqjcqR1qpI+tr/9Z6tXoOrW/01K+r2/69aFvr9v1KZL+10WSVX0zqk1ppH3OLWtNCapLdlMldVdNBaSalU7JNRUtSTJrc660nRMFLNZiu+cRnpylOzHTRVMfweVXgoXJorN2IxGJU5UB3l4jIIgwMgKzTPBW5Cn3Il6eWHBRcw8GDLdR0wCqqDigRDJgIovkzQqtR+hlz0mCQ4KIBoNkowJG3NIECya4TehxvkZtKrUEAIsggoqWKQqGZFiJGpDQKpRkZ9IyUUQyYyRTyMZ6SS1IH6b6fsy085+o+r0v/v/R/7/+//936NfptUu9JSabouk6SLoMinMUDd1JLdalJLUiqigpVjGtqCLOjSNXdSFFa0botMXmKlrRdj30pSwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZwjzcDG5NyzVHG4GNzblk9/NwMbi3LKEcbgY1JuXggJk5wopUIQqMLhiT9ujTtSjUqfm4/hVASqRKOGRCK0QapO3BQXAzGwtXzRS0zKyYEg80gPEDGHHRKUGEEssM3PK0SYRLYAMJQDKgBUMHLyEp8GWIKYWiLhqLtV+hOl0NNzHnuYidOdLJdIcXh9Ajs0J9I6gosDkHrUyf2WTzoJE+iRBHdXrWgp6dOqpP9erV//2+r//191/9VbemhrZ2dFTMitq0aB3RrsgfeZrU6LOaKTPzG6kEKa1Z+pSSZ1TIULIWTd3n01Vp0GY0VWDUNFBErEkCArLnQb9rtyG+vZR5P/fTcAymo6ZqAPwZeOSeCRUEMAApTJTFgCQiIWTmMeQyQ5B0gghB0QtUzUrbnC2zMBa+DWVrzj2Ufwe5GIlZFcI6OztgUJXS3KgTPEJS5Gp0wJhiHm5NgYLDJFEpMYKTFjJZNJaZ9FbJsuo0Yu0VvVUpqD1N9aT/3/1bOr6//r7/qav63+pv2u1lsyFJJS1MrVUztuk6kKDqSXSSTstBJaKKCjx6pAwrprQdk1IqZz601JLZV1TqcFVSiVDlROwnwdI8sMqGu7FpY38JjWUXwQbChK2IeW3CMoT2JbRAHp6Rtqha7QFIHsGp8Za6oVDCLjV2Zkno/sSrRWSgkvBxqv13knQEQEkyHBMQKAGACQKcpBLZaAFAQyIAcuTSg+aF41RGOBmFUX2ZFzYS0zSXUaprROocuIFZVFD1etVfqKylWVV2/vVe3/+tdfv/bRdu+uuuqyq1NQqQQTNK1utJ3ZFBBRdRZSK12ZNSLILQTdkGdrqUarMKUN4oo5lyJEQrp4tOh1HhNZN1zdkuKmMz1Opo8tlbizkSlkFxMcJFtEPTKDlaDaB2lM8RuJuryywGh3mAoB+TmqgIZH3IgIGUHwQb4staAXthbMQJTHr7EZEICJ/KQJ7h4FfTDHkIAMXY9GoU1k1JKlhHmKiwQ5AkAN7TYuKSWdFyu1Uonti+uoxnKl9TKelrb9Db//7NX/1qbbv/90PqWuq7dms+qzuui3Y9PnltRss1NEHZBFA6iyCk010Jktk91rSU6k0FUJ1SlJpzm60VI1n1maYSDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGb4o3AxubcsrRxuBrcm5ZojjcDG5typW2m8GNNbloa9S+idpisgtjDjO5LAbxw1JpiehiiSfEY4MAJCJLbNZMlvw0KCRkA8zWGGFy8Ci6jBpQQVU8BGhAKmPjXDG16GpBAtFDRZlfUEUkEFUBMLxQEXvCnxAKB7JVbog3BkZgYat+hlh5BInjcZgDqcezRkzNJFIkrVGyTrWZIIqMZMo0l+o9apTUqlKSq1+v//+7b1+23X1ur+3U+++9FqrO62XPpPdNDzWig70FLZSaKCmY0RRUdZRkigkySC0lqdTJNWfoJJrUp5lesxgCFLkZgCTJw15jE5MTWGW6z143Ootwiw89WAxQiARuxgHEqnBmYQ/M2IwUw0Vi6mICEoHJRNdBsgqJBAtWqXA6LdgSe2gtlgvDgiJTNQWkcMcFjEncGQokU2mOQpnE25tdebNAgZb2rLzYvnCydJ8C4ESRMWrUHxMtszNlvLjWNlnez/tWvTWqo1V/b/1f/+r/V/V/vrb2oVbPUtOt61U1U0tB3TRQZNBkVrNUkUUFKSY7TqRtopqTTdNaSbrQdFzykWUgtSkVrQOm7gOTwtqSfQlLJRtXelmkXdeN7G7yClqO9KFHRwZa4NHKxDZgWISpdZnQzIZtMKJgQRGgY0ctEBiPNiS4YwIamAK8rjMBQqGzAwF4kuHylqJZgGWBssQgbUbwgEXDgV9GGjAMYuKQdLrLJEwOkvDlAcgDFI1a0nOCMjy7LLimTSLq0ptI53Wf9dTtf7JId/X//6tf1f//99Sn9m3r16NF0EXbZdBNqLLSSWzJVoIJVMk1k3WzJU1J1sgmgmtFc2dlnWSUkmtSCSk6S1IUzFQZSrNDwhqYwDdHnd+HNQVHLFJScppm+QnAUkcoSnNYHrEgbG6oZWxcUeKQIs1a4PlEigSqioExohkxqjbnODFpTOqcB3Zs2Ci572gw/Ze77XYRFn0geMvA/IQzi1eaQKzAmOcAEIyZGp0BPeuednneUZ7X/9f6uv19v//b//0f7//626Ld1Unp1LpnHzqBKt+2FyER4Q+eeHUY/bX7qWPscy9A06Q76wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABmmNNwMbm3K4UabwZ21uGGYI3Axujcr8x9uBjUm4aKo2YhA4aQSGrtMnsurNv/DE/KrFiJUpg4ktgHG77G4g7Z8SQTEptd1AGFD9CAgZMZkbAQDFm1TQwQFa8I0RRHCPRGCV6qNSh5HkEjQyhBCTMQg6pYCIAB6olI2mKNGcAsM15aiZnB0KHwB7YH0TQNy5cQhPKuo2apz91lpZD+aaqtDtq6P9W3/Wtf9D/r/f//q2dC1elVWcWtamUtFS6TorqdalImq0GSSUiyKDpq2QW7oopqPGzKTRWmplugyCc3eZMbqQTZk1n0jqR79eOCjkRp6LUTmdWrGJDK4TlKYtBUaKocUGTPQIGPICkNz5tDoY8AVYJCBfghArpsAUSJg0CjAGGNjHTLSR6IFs0bhGADA8hJYT7QAOIGCDIkTwa/FlsNK7mMLRuMyDm0k0sNGNit1AEqU0UUndAZkWQaRK1pl7UmtT1P69X/vrX////////7Mv7K/Z1r+h7LdSlnVpUta63Opq01WZJ3WpaklNTu1ToraiyFW1lOpCkitkklKNAlKMgf8FKWDOhTIZrzAl7S+djDwfUk0up1ZAKJtVJRxSk04ygSXroApAoKmkYKJv0AgZIAyNBXkRLCYyPzpCo3PQU4E+3EwU3Zk/DqvcZOMipARkw6Cyl/kdmoQXTPw6AOe3midwxMSHkaiK6BB+OWkggtkSLF7rIa6CazRrl+VEbov+dZnva33v//9fVtbqar/27/667tV71Ja2UimkmlezXS0FLSW72Rebuk6lJrZFSlO1a2Wt0XWaLB6Tn6+ZSVM9BCDV8r+VoAeUEI2WRO46kuf6kvxirXqz5CCHoMFFDBS0yQyXS0VBmeFvAvkCBo+vlVI5aMKxkfxkUZoOyw1D133/fi48Q5mDCSxYmKjjx1QaZIpTYajzPXQw/L46XmEQt1LFEVFIHpeAjBgmgbOtQy79j55aEqsuhO9/Xda6nu92V/q/q//2/9v1f/sv3Voqtuqt0K1LTUpkT6bJKUpaSOipbTzppo1Op2eo3pqdloopJ1pumzmJ6mpA2bbVpM6pibgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAYcjjcDG6Nyq7HG8GdNblhyONwH7m3Kt0SbwY2puXCZaCLIZoc2ytNetvJZI5K61irSxSnLAEOjUoAw6hwMNU3gwmTPA9oK+zBQ6GyUfayYUnMIDEVxHUfQwoMZdE3Qj6h4gcyY6VZkjaFjQZFikHJQNt5wRgLyNchpaSIBiwtFeWUDExJ1IngMEuE5E6utjAcg9u5SdWnomEmnz/9T0e7Vp////6/6v/q/7X9/uzMp9lsgvXuplpKQQWbrSSd0VGbKWpSk06alGrIMhSdJNChUmyKdBJmopV6SKCRi3XnXWr06CDQPCEdqSleHY81u7VlEmhmD45ff4WbRooTwAhzlNVMUTJttwIA1K7OzJMkTig+ggEjbADDsJypQWIFIgyrYfgolFmnqIBSKE9NeEPpATuUd93AMUobllncwdIAsxILUp1KEpSSoTq+bIPRmH1a0KlVfqb//+r//+//////6/dG6nuzrepOky11sut1ou6N0VtUyqd0loUNk0lqTVU7MgutJSalOiqhc6W7otwQ4ICBBDbEbZ04oMp3L99nPaTeCwTBJioEk6ZSnOXQIzkSHFnFCDGTIQoVCqercNHKpmtvuHE0COW9cPOGZYDC1O5MdTIMuLTGoAa7kX2XxdDF5my3Xzc8wQNs0tw3Uw6iZHJAHuN4+qgxmJtPvUtGydJWjI9V1dS3Z9+9lpVf/6v///r//+yXVrr9F9dS1PSSTpKaeYwUpCgiyVdlrPJoUk1mqRx0EKnWbJsqpkVMaLWnROU000aKzFBBlIsdcxZ9ddb5KMR0JXN61nGknqamgaKz2ElzTfGh1TscDri5ph2iQOLAw4LhEQU/ViHCUjJAdCpMMWW5WQF9uJSjjsiMbW/Oy9CYcUSmBDxMdsz+H32uO3BEym+SgLlUnEI5UiMBIsNDGPVhKMXlXz1MzlO0/b7fR/2//9v/f//9v3//erNOuaynLWimGshjLPUw1zTlexFPZENcw465yUOOVDGMQ4qec6Iy0dsjSB5gSo2HgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAFdoO3gxubcqzxBvBnbW5VkjjeB+otypRBm8GdNbmhcAkIMlUVLhO9ZkEst1MbU/nqtNooPWXgTANUIXIh9AQUB9d4AgHhohDKYwNCekOAXtIg5RcEAdqU1YswoRlgGLorRrTNdDAvVA5OgFt4kh5F4AlkvcQON3+s9TN2I1EmwDwlJaNS0RZTo2UcU1b1uflxtv7fX////+r///t//v19kntdmfU7NUpdnbSQTWra6lIqUgy0l9kzdCi6RgjdVFkHoHz37Kl+KuWmJBKJ1GXpeDbAJYWVMw9EqTUilF7lqg4k6EFUYHil+U4o23BQIImW9iafENt3X2YGLCpGHAA4DonTYAFF/Y0r+0YAGVIyClTGOXGwqYCw9Zl9Mz/kAU9pfRh4RI/xWyZJIHQb4855nU4k55K7M7dWeWYtr2/rb6n/////V///r+/o3//oteg7btR001rdaKSaLOitFNlLUqcqUjrUukqy1XUpFSlroXPOsyZZtVKNSVosUaOCcDHCRjKMtWtThMvQa8uSpDm2rSEoJ0jjvnODgZWS3H09KBK9ZhmGMZZammX6gIwgKVSinoJEMOAxxBLzTp8DBg+yaj+K+su8/DcexpBgKDHJ7WQuUEjMCeZ9TFIZw1dqyzUmtDW0+lUn9qe/2V9/////////9+9+29lbNd2VRSUyekpJTvWgtnTVUkqlSqd1K6TJOmijUnUzJoMgtJJ3qWyKJsmyp17yEIDqmUMZVZbIiAeRpD0zMuvS+KbwfHbSTDA25DyOoLDdxIVEmhDvO/ju1GQSozAMUPizBRUImNNR+oH+oqb2XRGDmjDgk3mAgNJ9UUKe1iFNAMBxNRIDJcc8WTMlqTALhslqWsKo6PKkuj1zDv6vr/////////r////X69NDd169SDqSZ1qTorZdbrazLU9bKU01ZZzoTqSaaB+s1VU0KrjUn+WhgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABVyPN4H6k3KkL+bwY01uVbY+3gxqTcKkRJvBjbW5Xz3DZCMCwl9b3ExkTHXDPvNJPVCQO+soGiTSTtIGgx5NImQ4QQXxiIwLiZoVCe8QUxDCkZFochaVR4SwAhijq3CKqrHPkjlAWcNEY/I0/bbMtQYkcVBdfXVorKa0gLiWHey1h+LL1GFTTtVOUbXt9e39/9f//////+3+t0l1f+y2p9dBCm7O91pOgeQPvRtWedbsupS9bp5noWvWymoOylJs9SqSLoqMUlmwtrbRDKAIUDWjQIlHm5u1Bk/a+btWsGQGZASsYCOqTD6O01AxoyG6NUcNOs6gs6EQ0ikEgIFQbghE9iFaxICU3hYgMUFHGsiBBbqy5s66pS3KN5ovjzqBs8WUmZIGIJ+WMjoHRGjX3bU/SdN//X/7/6/////9f//6v32br1MtK1VVN1ovVN6C0FqZV3dqkFMjst0HSMFUWYwLt2wf6Rsswphtr5iyWk2FljGDcJIpTVmzxS2UV6/4S21ZLAdSTcUXG6G7dv1cQ4pDwNHhoPBReBixoCJAJexlBE1biLLZLflz+uiYmOUQYn0qByC8VaxFwWAgaEO5ImU5ypfCbT9X8jqZiUFIAFkXT+zojLG/WX/V8sdu/V///9v///+r/+r/7ftX+y93ZFmRSoXUploOxo1mRWm3RSdTLW7KZBa0kK3TZnRpsitR1a1KUkrM0lJrWgdZiulkI8wLXBRYBYtTT8YgCRTkv1N1ElC0shTVdUiFIrWbAJQs7VRQhajr+g4cLOFCiKgBk4CxIHBDnzNSxDJgKWhfH4cV2cmLGAkQkAQxG6JhPx+X4OQn1LJ6ymmkmtEEkQZB60Ak6fWd3+y0f+/9/S/6/////9X/1fXf+/69Va/Wqp3Z2TQRcyTuiy1OlvZSCVbOpFaarX1GN1psnPIqUpGgcCRiiHnMwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAUbgzeDGoNypxFG8GNNblg+AN4H7e3Ki0abwZ0puWJtZRrAU1hWvrhZFK3Gq1pDnKJyfsDgFQeWDx1fJiplLGK4ORW6dYC8IxT+GnBCEurSSgEl5QEBoRNyaEwGYJ2DidND6Hh3I5hTw+YWQ8UXUaxZdckFyHa1zB5uZs4HZxJlrdR5n573VZGZvUv7V6//6/////////3/V/1VPrajZTr017oOaX1VqNGTRZNS9S77ueWnqumtZqX/d+sz5Dxg8BQwSueEApJoWNGbDG6jlW7L/XKGeztFgABg0cg+dGidngqJMGHaFQLRrurmYcCMICZ6X3AVKGgMOk9uGYrVMUpKK7s3EZT/Im7DSB4I9JohFoavUjpIb01PimyjKgDrRTXssFYKTc6qzoV3nHt/b/1v//t////////9/63dS+7LQZmUyCC3RWgxkp1LRorspFazVleyKCDLQ7Lqs9bKsjSPITd06SSyOMMEWU4DGI0LiX9ackevNyolte5tDqHBUqIiNuBhSbAnvUPCFmkYDZBoGv0OQSoOlAZTERtTCILi9LQyCFosByG1eQOucGCBcbFpFRSe4/dlxZ2+z0aC5+dyxJmBmgAK8bGt+5uz6/xb/5p//66/t//9+n////xr////////P////////////////////x/////j//H/xv/Ocf+9qelN41jV8/WtZt6atj7zjGK/N9Y3nOLXveW0s4CY1RGQzoYakefXaWGXJAB5jzBg7iTMbmYdhuNXJXUt2yQISgaZYZoAYoqx9vQdqge2nVNu9KTDCCBYRGRQOAoj+iIDOtJx42Rdg8uatHyoMMjHEZEiWvFOQqglD8/SyxAZIp7zypxViUFi6aKBEWfe62XUyRtrp67/q///7//////X/+3urfs2nNPRaMezGSY1k0ZERrzaFWRptmR2PVXR1a0885DKpW7JYuGCmwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAVXiDeB+otyrlIG8GNNbhPRuN4Mam3KgLxbwY01uWk+BChrAAkAgOR4sQ3GZcOC/hQ2VbUk2wjAJTs3MB56RP1uN6Oq/fsKA36Hl5ATJjhKBDC0jHR0SlMuyh4USDyZ55QsCepMDC5RpfCMS1VWVPN8amQYAgXumN2KbFEACkvS1mIpI2vtvWy3uc7Vd6er+//2////+///6/3112V9VnSVUp16kKLqTpMmgtlqoJKUtVNSqKSkmVXSSqUhoKTXW7TJCLEJiPKr0vE/qOYa4A8bgteFxaDr+ssY7ljbLAgdASpYrLAMXv06ehdSd9fkSlMLMKJIWTgodgdhkBUDPfjL6eCCA4HMmwyxPc4rIdOlB1/JTB0/YhqeikNg4XQcsIIOkigOE0UeXpBQrrzjutZt0Zoj+3V/1t//7f/v///VV/rX6n/0t1VoPQZukyKmrWkg1JNV6VjZjlJnordSS0mUi60FOkZrZNkFstjNBFTqddFnU7opT0sWCaQFzMGW+zltXZh2TwfDudJdq4y1kUwWtcg6iN+argwbWglQSMCgaXiRgkAkyQkCjwDEgBxGcprU0MIk+2/iJVAGflgVKNTW5QJFlOrTmXa0PgkHE6lhEsomDk8AvBJ0GqSPHvS0/pV//b/q7bf/////////7/VtZ7OzIO61KoOs0Wm2QNzKEHvm8NN56t6qNM+DFAbgWTNJAwgbQnYwBdxIodaENeKVR52M6B/q+WNNRkghZNciBwKDgE5Su0wGWwY68WbpNiIYOqELyAQYsDLiEK06/D0jhgZHI5MX22o/FGE6oa0MVWk08IiVtpACEPLlZWZIXMg/EZJFb0Atht6XWe7qS/+v/2v////////+v/V9l9WpBal0F1ak1KqrZJGpVTJp6lpLoGlbE6USjicA3JyzfKKBzkVeNqgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEwIu3gxqTcp6xZvBjLW5UFjDeB+mtykxEm8GMqbmOPCIZAHZcNw6ann4fxsY83MVOswkMwRCrQnCZNpcjhT3vDKFdNADgcoJjMZJnlV2V/WJqpeHgScFLQI7mreCOyNDYKkEJj0so+1n1Q8rZ4ui6SyiDWydPsrWR/zHzftbX///f2+3//////////s+m60l06FGmrWtk2WiydFKp1etbp2ZaDrZaqmdFB1Mz73XZd0NkT/XJsZU3lIgkOQUImvUzuXuXbFrGexkZAokJMg4BtC+9jc089iIMStxZyDAPHSisNa43VLwYhKZZWu0TWlcyenIQj1lIaWt08htNUuvnLok1syhbdbqaSnWsJOapP3HO3rr0+1H/6v///////////r//1qWqzLVQWpJ2QputSnWpbJKQW26j+6mXpqUklSXQTTRemg1G550FqQdTU1GwTaDiqJwhQBII8aybIU9S6FRmx5r4yTOUMdg13msnUJOLEUtkRLM8v520p7yKCqRQNJAREdxQaxl1fCAwsTQlx6FuQdo2YKOHB3LgW63OWyzeTIS+sovcY451RkAbhHV6hqX6vQ6dLUv//////9v/////t267KZTu/Qe6SKF1umyNPdSDXspJlVLRRTU9JfZdTM60aa6lpOyCmV1LUybuiaOiL2ngydY6eWluFvvBFqz/SyrZyt0sei5Cs3WIEg8UVQm7jWHd7YaTdaLcMsJSomOHCx0SSmCb25O09lI8SJ5HEXzPoJKR6N08Z2evQizK1VQFlfvaVZ6HACCc950wl+u/9P9tf/f////////////7z1dM531qfdjENc0yafMc5zmoa69TbrU+d00ZXd1V3drlpbRLqcqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABRiHN4H6a3KSrrbwY0puU8I+3gflrcJXxdvBjJ25HG/LcDmE0NA8kkqHcNVLGr4zVmCUII4UBHANuvg+ZbEJCdSpIDjeNsX7JQi4RkMZMDPgkblS17lMDAC6qa9A4Hlkh8oVwHLa0Vy1VnWMkxaF4+gmggyQFGIC1JaRRPPVXfM+qvv/6/v/////3//fW///r16Pb6qLui663UtF9B2dabp9JadI+5sggg6l2UiktaVS00UWZrKUampuiq1SqJgRF1g3FZmNiFhM8k+MmsyzG3zlaxFyUYAkkdDiUpbjfp1VmXX/b6eiE4JIXgKxbglbCKAoJ2HpvOoIgKQs5IWUHMCgQKTS3xs08dzfvs1FgyJAt/3MQiPKAfOde4XFey9d9f9P/6f9f///////6f7Jt17bUY48intMPRbTHS2YjEyefJGulXfUqI8uRWHH4qZDN4/xELiXthBoBsEzM2OeS/iOyVtaysJPpQvgXzaSYHEdvWhYKGaBd8sT8vp0EgjHFzidTjCzj5zNHMTRK41axNJkn9YFASi945ZIH2pqfksj6Xl6xmpG7IglS6pVse/znnOv///r1f////t/////7/S7/W7KqWpalMjZSmRQX7qda6Ft0TVS71qU9VBJNlJospR5FBBBFSqaBominQOIJ0j7MZTJyKAhGkLdgSBdzcsuW79WJSMlCAAcdDlG0X5KKz/JYfxllR2sA5Nl6MQ4IWhhgIHnKlFN0BeeKQl+VDj7JTeKNnpmb8zH3499mymejFsPNOcfaAYbR+C/6fbzP9N//7f//////9+n///zvSqs5i1Vr0Q52WqtNdzEvVzmd0co5hayF5iGIcefvNVGPY5FnGD0/8qQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAATLjzeB+TtyljFm8D8NblK6GN4MZa3KWEWbwYy1uQ+pgrwmAtAoD5bj3bKYWGpg5UhwhJUYgtTJmBmZ3KemWrzNM6Pv89jA1bn0HCxEFKiZ6koMN2hCYHCQqlTsLHtQergOzCt3prVIouWvmauLSpqIRDffBZ8frle/2/////+3//////p/9O9Vtehqmq52ppp7Ws+eYruo8pyvnIY6GK9j0n6DY1zZzupp86s449RxXQuag848oblIgbh2APk7Gctr9Qwm9itBt1Z9eQOwsoKDjIQ+d5bL53M1A59mMbBwCVL3LaDbxYeBjL6mqUky7UXrIujPkyivL425BDFqN4UqqhppPWrdZxBCKSPeslD///f//////////////69+h6FmqerpborRZFJ1nTJalII2ooztJK6akjz1qWlaklTdaadJbO1Szq3OJVMPqUdKVGQoqoZEyZlDcZbU5jVy7y9SEg6vJSNGtFPNyfwgsWLkUZIgJ5YOWpuNbdRro/ZDoYDIaC1hQqnKzqClX2edDpDU0dp7MB8kuFx3RULt/HZJRwJIrU9xxt6Hq7f/+r+3/3////////0v+rfVXZTorXWjW/QdJTs6CmSWvd59CpdTLT1p6nVSUg6SGpzVliPvPB09CTbtvKZViiVRxCNP29dntXO7VmMpWhrAw1XEwUhZickQ7WqF0s2qVkw2cwIquCppWHB5yuU3cBhNCN+ofZQewYWUKN3rn78WlEorzDhG4DO03qbdg8m7+snf+n9H///////9v//////9XvoPutSdlOpSFJWgg1SnWtF0EnWyGo6u3SpGSL1J591IpmtN1pp2Tdp1egMU5QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEzok3gxprcpGQpvBjLW5R9czeB+mtyj0+m8Gcqblfc6DQgi60kjW/d2hlljsQt52MsUC3BghicCA8i9knjie2F5a8jWi2wqBQ7kwAsCDEAZSNBu5aswyFV7uwTI3RN0BChYoLyu/bnOyrOXQGJHYprddKiFmaupKudfQWmvr71d/+3////X//////9P//9WutbtdFBndNBO6S0UnZBk1P2M0kNT2QRSvZe7WdlUnWutqR7bdAuiemhfwRpYiiAHilrywRhlFaPKl5nUaqPGM/CgEmAo9uzmGW2bSkaR/oQqAcAiqHoshMjysXq26GVImK1STTKgXOSZDQ2cbp2q4zf+8Yk26173QdmWEd79Q4///Qf/1/////////////1e3s30WepFak2QWpNaVe7UUD7OkpdT0jRBkd91rau6Sd0D/6KRzMGojDEQyYIJkAUBzHwhy5VkGu2iamWdlWV8JWoVIjihXm2z8FAaaUtYwQ4SpFxF8mSpPB1N+gg7R085hHwAZXtV+OE0sVLNSsUdbOxDOF1sKY9vG/QTTuCclNTKaofH896X19v///6///////X////p1a+vqafdGpedWgmpGsxRyvVROtunO3cNFX2UPfnqx9tsoPFXnRZCIEgTEmZ2GJRLaTvz2cvqabvUbgZgbujAlaaaqgDl2K759Ru2t8qJfUDCZYWmkE3nRyQRgL/e2aUfMZoVoYJLItOQ5P0mVIvgIGs9x6seCR/4iH/667//T////////+n3/r/7dEe+roYjGKYq2VyNGP3MZlZN9zkqrsrWYurDNKsE4k+aK2rnkKUVKrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABKSMN4H5a3KU0gbwYwduEuo83gxlrcIwQVvBjKm5TygA3FyAUh/MjG+ex3Bvj6334BfG6XQdE7pGa5N1Fqp6aX7SKmbQgBpCLRBsM+jRoiPlM0dNPAwAibnL8AgaBW6zVtVf+HvtNIUoo8u1MpUCVXVasm/f2+j/////////////b//VVsuvQSQddS3SZmSQdanZOyrug19SlMns7spSC0VuzK3Uup1Ota61JOii5naDAXjcKYSWgSjK0MpgKX1sbFTd6VV+R9WF2hN9cUPCa7+JzVY617BnEDoDCrCB2xTvRRM53VioqhGHszYQcqkMCYEok9G6XI/fyUaV5RVu2mKNQDjd+Nm/531b/+v//////t1/////Z+fdvRNXNWjGurnKObIrHKPut1NZjD6mzjVZ1dWV3nGGsiXZHZaE6KYyHHm5jGlzYDpFuiWrrjuxBVduVjV+3zLfW6RB4ltraAOc11RRBzcqaHKx0eSpjDghRoSBg5h9TCHq25+eiQi4bbcij5mijAVTVPlX2/O6z7AoXDm306YFKyXsSz+3v3q//////X7f//////+30qtlL063pqporRZJGmpNV0k1VJsyCLL1vVXTa6CnZFSFNSK6KdJlprpLqrUpNB02OraxuQCrRnrKZiZr2eRWb3+7FLVXcxlI6DRGB9SdEgcrCXOTKuIVlVJCNsSZ98qDVL1qvfEAT+QLWf8H1FRYiYgCX4wXZmJmkdtR+jw9GPPuBAbbdBH+nt9P////////7/////79tvau56G5jVRDlrdXMS6K6qRWfPXmHnK6qpxlGuTrIFLIPtWJsruyUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAARddDeB+VNyhWUm8GMZTBJeQN4H5a3CMcabwPwpuYrMogHkOMbS4Ul3FvbJneMLltjT8y8v06Zj3RvB2kfal+TdToc5CSONE0MYFuYoFRrm5q1gYaBMZPXHjMIwgYTYlGVmtk92FpuCA65j1aWQB499WjT53lu1f/////////////f9k773zEurdFstUcmmmvUxLsTxWFmOKLaW/e6dkkyXxAU9PEjFJ0irMn2eYVUyVW6BXPlMrr1d26ve1cHrnBsM6XVvRJR9t5FSt/2Jxkv4MqJnR9k1tQ+Dqne9ITkzJfTQyewQ6kPaQZKrM7foa2oqXy1r9Yfhzrf8///+QB/v/////9ev+hiLnTSREQMmRoIFTIaaHEJEZNoRS554WW614aPEhCBluB1h0HBEI0ik2ICwIeWxfcGN1R8rtfD8myN5BMYbAdEMUzsQVPci8cFRIcRyKjw8qkowmsKCzv1PgEVfVzUq0AgJYMUCSTVurk9meDRG9ncuugkk7BWu+1bt6Pn/tq///////////////XZS6712e1NTpoporQTW6TvSepSmW1zbZSLKQUlRPpNQRU+ugqyaK0vrW6tVSCkmOoshIwwlI7DvdrelmFi8SNnY62R9GlFx3+dKp8mGnYRG1eiMNI6tKKzwXLKZdFSY7lxoibFu6vo69XeU5fDCegL49zkrKOxXLN61NAhJ/nBdt/2+b///////////1//919aWbfczXVnnTz0uSnMjGtO6H95yPRj3reZIzHY5EONYkMZjDzWPnImcV1NjAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEOIm3gflTcorxVvAzBW5RlhzeB+mtyhWUm8D8ZTB4mRpA6gvUJYW1UtcRc31TfNUFDMJmSc+xoXQ31GMI/D1Uvu/LTSFxZr7FZ8aFRr3xHkyFi04qb5sDHFUFKGmv3rmEP57j1+dx9NWQMlv4t/RO337//////////////2TX0s7+uZNmHqml6KTzD2oepqO9bXOTfU1DzjD7Wc57brsQtEak5NoTQzIDoYCceji9rMDjdLFzNbEseMMNAzPcM0/FhJ28kxxulcvEo+VpnF+bX/hUqYYjJVwy/Bn4BwK1IwxD52nsR3dKk+XLnv7U7TB4e3WAL9fv8Z/9v/b/////////6/v1ZGX+lctkMqqVikMRFbShEeqszOrId2VUJi9mcjIjRhEcjGJOcw7jYfPONBoE5AcYJE6lV12qR/jfbvbShFAhXofAQdjS5/StQzS9b95iqYnGMpJdLmwdjdtWxECVri9iUiQ1djHMtf3cg+MOk8U7ng6tJQVps+2WP6//R////////////7f/t/6W+pa76aVWmZutRxjNBBa2TQRRU3raitS2WYosyVZ9B2ZqrIJIH2EBTMnXKFpYiHFAEPB3iwqc8lw2TUvs2qe7UzVkSZgkeZPMinaj9EUcYk4d1w6hfkqhKBSR5Z9zcdXvukp9WB8YAOYkQFqhtWLeN+VbwhktVvHDutb/KMYf///vRlde3////u///+lIaFRKJwRIkBORPA0eAQBMQKeKAGODQRDzHBAIBEu9YVdMkzhMBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABChzN4H5a3KM8abwYyduUSYg3gfhrcoMRRvA/Km5UZCBIzwFOGI0PW5q76C5XyqZzbnR1fDtHeTIsYDYpS5UOBYAl9EOmN+z1JjFYaxUuazKiUkznbitan1u1P7/w/nyJMzw76nWpzAGA8v59/V/6v//////////9X///9WpTWUivQWjWpRxS37J1qfc0fd/WLtG6D8O+0mhlEvb054ZTwivMs41KiYiqcTq5cwt2atu79zJWZOCSRF5mY3ORNFetXZ18AzCTRCOoVKkW8lpWa+PfFEVX4SmNEaYXNiup3tBydx70vTe7zocaAGbpwft6P/2//1////////////tX/0nXuhr0PZ0dTHRSSVacjq7mGIyzJhxhinGDrIZOOuqmHnu08845VIHzS6tUmbQCkZUCiMwNIRl45NT+RsfX978Gws5qr9eE5apeaffCq/Use6Ez5KBj9RSOms2K1JYpVhh4EvvR+mTJc3v83hSVcZWyi/r063ZwGOtXZkm9P37V//////////////2//3r7rRQrZTom6bUGTTWko/ZPXZBSFt6F61sgkqyaE6g6aSbOus78nzNEIWziuA0BHAdAT7YwTxrU1tvzuUzRhpWnSac9TbGvJC32WTayCAMkmSoO/zd2VdSl7X5aygMoKh3jomcIVJVX3bFnO9f1nMlYc9/9Ugof8Ll/+nzv///f///////////+n6dfnGS99iZN6TjNEY5KySyoqWP1deYznE9SA5zGY15V0MftqcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAQ1gjeDGGtyhhCG8GMKblBF+N4H4a3KEUTbwYwpuYxLxgqh8jZTftdpc7sv53mGEAoVUl9uhY3MYSiU24guCqn7Nvv1vnwd/FTKczpb1KVFkwKbK8mosSEX8eZWpXWrytrs/j/W5wEIKXfMft/vb///////////////rqqbXQ333U7teta6br1utB6SCq0lTs9Wu6kkVOzpzhHFpHQHqI4fFQEsxTwGwhdgxKHoIprMxT58z7yUZR5dElUAgdOnVmChalLad/CetK1qKzlKoxUVQ5dr5bTkIhyDNugokLLJnxOQ35vO9YvvUwyxh6b0AvT6gw/p/6///////////////f7e/Zs3Ocxp9WZ6Kcxrd2dUc9jXuezz2MNqplVmOkiKiE+DFQJ2v6UquO0ggSoBeOhPOTa6jNV6x+Svl1PXcqhs1yn6kafO/QK/vuJCmGLxjHFC80ic6+rNUqJgX9XE50EStE1nf1y5auza4qff1TjoAvIfnH//oVf///////////////2dl/R6nTQSTW2pLrZ7Lu90mRcwT3Q1PN0jBZrz/tOw08Sw6MOrwwhDwIJwuROnkgqy+rXxw+3rLQtGo5tG06viwtP2mlbtXX1yTUxv01DkzP87XdEolLozhNgrzcyh1DjhSd3+niWLe/6OqIGh33EG3r/6f//////////////26/VrNMu6Zim3oqHuee7vQ4xznY1abSqolzKlnUxbGocqMhrmWKHYVzYEGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAPRdbeB+FNygPFm8GMKblC6JN4H4a3KBMdbwPepuXUYwwTxyGgpJta3Ctrf2LsAFttyjh2PSYOgyzOOvVTKHaXWzFQiJxColV+7OOKOrH62ElQnLTSwoK3K96rl+UGVf93kcjAAnr9Pp//////////////////+z6oiNarWU4w+iMq8yV7h6m86d2tWxigUPbEaJTCOlJWTu22WIP4MnY4/U7cs0OdvfPqXJW/kae6B5TWrwge9P3m1xfDJScByzrfe3SvlayqFgz5Y/Sj3H1KxzfPpsOY7gBe1/Dr6UAaM/LP///////////////9Pr71/2Xox1XVaeYYe81m593RWu7Lq1XJkZWoapmai6mMrueYhORM1ZYGYM5wB6Bxm+DB82N/L76x3tsCXuEOVxfUXlEbabWvLNvNLkDLF4IsYJ48Tdzwq531MCgWrsQCKoerhqWO49+tg8cA6563QQqB1OjX/3/0u//////////////1f1dbWffqWrZS1mybJqQqet1oKd0Wv0UtSSTpIK6CqkmpUFOZ0qkJzbIptu3ENOM5gOwIyo30F/Ju/zjVohAw0Y5MnZoZqIIAUPV0g9J6IIRWVwBoVKvUGPXZKisWqncBPqQEs3+Ou9Xzk9jQrbd0qwErV8Sv+zf////////////////XX/QyYxhqVMtdSI21rSpipPnmPd0U5z0ZppiM5yTmnpqYymnsrm5ymyuYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEG463gfhrcoFSBvA9524PjeTeB+FNygPBm8GMHbkn8cyxZRYzChsru+39ouuVOvgmNWn5SGwpO6Ht0dxk+KyaNdY4ZKFu0Rrryn8qa1WKjnK3qbI5od3M1Z1+7X182r4c/d0ToY/6v/ft//////////b//////+vXSQPoKszIObIo9NS7prUza0OyKrUkbulu7uut0HUi6S0VoobMt16zKEklsW05h8CNKSNHjbnltSakwfZmRT8Zyfztj8D7jUCKUdBvnslzCJ7cmUttahxCJc5EWAIgQgqoN9Ut/AWxSXlvpuC7+IW/7////////////////Xb+1aJOop7nHHGHXe1DkRj2tUztNNQ51OS7rV0MKpmZxp5z3UmppI92qahkyPOlMORchHyLpBeTahw5r/3tZQHsqmjWW3iyAtxO/Bl9kEWcAgcxWeSbl7DaPC5uoQqSAp+Sk7CLBZDlYs4avfV1Yx56VNwHP6//7/////////////////nUT7z7TJ045WLUOOZzEY007dDDSu3txEed4/SuhafK2/2M6FWlgiBlrh40pG5dhyzNY458x/7yfqgOoclanXcoi39aYkuorPqOPEzeuRXn0dcscMfR3cW/2wUhJEQNjl25lvnbKk7XP7Twh/Yz////////////////9v09W2o7G2dKzlOWs9DCtjyxzoi0c0yxTdD1Klz21mMqO5ImdM76wEs3MavkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABA+AN4GYU3J68IbwPwduT9o83gfhTcnqRpvA/BW5IA/ktGHo5k46hgfpea4VMbij1WJQaKIl8w74KTeqO7caVFHpJJV27s6vt2v8qWZSgnU9frt2BMSFMXzvWu/Pdxjrq58/RMB/+n2/9P///////////////tZaPmtqhitPMYsbZWWfNd5p7tPV1NSYzs6Ohc11IaizrUMpk8QT+PM7tLo5BghcBln1nVnOJBvLvl6wom4WUa0oDllnUypqbsNVFytzW8o2wjaL1F9i9dKpX7rbeoHHR2kGHe5Y9/eDpWv/biD+Ub//////////////////7dJx6m8wxHMqh3OQw8+aY5z6mnrdDT6vpvOd0U9eOEo/GNTVabEuUcmQ5AapWriz9S714l9byxrqU4N5MBQtJm3UW/Pe0PNfdmJENGh0o0SyxPPOzuZFBzt/Ju5lYVWrju3qK785/1Wr639+4Cj//p//////////////////0+6TTjz7LY0+hx7K80w/mvXOM9TXdDkORTTTVW6Ucxmc9bOqbvWSqXbl2rxYQ0mdr1SBeDe2easMJZ/Ts6uMOz1de21bhdm7xnSTtaKlEKJLeTZ3t5L5dekqQWXOeKEXL96bw7lq2+v//1CbP8L//9P///////////////6E7tNK/1Vjl3iRznOo+qPd71Vl3dWdUo71LK5WZUuZ9GpjRJE3cgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAPGJTeBmMJQejH28D8Cbg82CN4H4O3J68gbwYwJuBpRAzACRxKD6nZ9z1lhzkTYVcafXATqfOUI8fNySu5MjnCViWbVEwby/Msa/cmIOdObjAPygJKDzd7uN+3rtZ5Py///X+/d1f+7//////6/6BRpsDrFwCVItEgPiM29pYYXYLBkExIBkB0asYOAgEaAiBUWcDw6DKMKlDAMw6TmZlm2K5nkvvnIJZFdcjBnNrsNwjteHNVL8MlQMVaM3XJxMr3OX66/72MoFup6Nm1+VjL+4zcDc//wDfyP//1///////////////+Tt7MsioykY7X0K7qR5CzIV1jmYvmW7MyUOipFUVZB2PVUdkYUVchQrth1sh+hmi35vBv5p85/LkdarKWVUQZWxhRhxebfm0p1fc8dElm8QteXNtlzvdIvSGi3Kg+7/lYaHmVzk5zP8cOf1wY/6f////////////////f/60rQ+10pOWzGMk5DT7Pndut0ZiTo1aOa6zDJeGmSwgumJJuubR25L7OwcdmjvRWrrG7d5jv+84tPUYxXd34NZv/Lve4P0VQt5ARQe1C72P45zKjOeMqDRsOVomNdj3N/lt8sO/+Kb8F//7f////////////7f6evexmpVbMppSM6shzHchpETVne5zIz1RFk1tRI5DmMQyIR2eUzuhX3RrjgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAD5Yk3gfg7cnZPRvBh4m5PRiLeB+CtydfDG8D8CbljlL6iEkQCPArmLXNf+PZhsG2a0hE+n9sL35Z0duH5YrxN5GJR8ulXju7mH8dpvc7jZQIJjJWWh+d1yX67Unr3OdKBr+n/v9f///////////////+ds/Wp6GXMdEU4wxzVkTZt3Wp9bTZzmtY6yXUe1scaYy1JqVyuujq8ZMxpZIcVBMzWvPTtn69rn/W4AypG6ALDSGuhYt5V2m2r0JaKg7xYpUZNHvu52BZeh7gHgd5iwrRW+tNZXaF4/75W/B//////////////////++/5JbseV7m3iyCkV8rMYonMV3UZpon98QuTC2BHQef/RqkpzI716nhzQWlWZdwteFj9/r0OHclUtL0f3Ni9vcUxfWnUm6REJuosicZRlW1jigjoaTcEAgbyE04/n2vqk/tyBcdfrwKf8//////////////////361mS195nRXZVRy2IhUYi77K9tUKrW6Kd2SacyMxVOVzEMoyjTJncZJGIgSBEzGLLan3fX1lrtZheL7YKuv6lSJF74TyCspS7KjD4qg2wPHG/ro4Jj3M3gATWU0+f9s97/5y7//8V/Bf+/1///////////////9fV9t1wlX2OyKiVQ5mZiuzM0GZS3aWylbci3JMVbOgkRWB120Eia0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA7NzN4H4O3JzMdbwPmVuTw4c3gfgrcnVxBvA/B25SFCjF8uC8/M96y6/7zrRmkZwuUJV/14HoxuQ/WgCfUseNQt0BZNhs9jfN10PV7yHlsMsQIJjUOf2dV99yn8+f+EX9v//////////////////7L0RKpQ9rqaP0eap9FYda0QkYRD6RitLeZKuvxHSNZCo0R63P6unZGDEBGV3fM0SataW02FCHhmDUQxlC7EcpJF9ybPF4qB4SMDsw9A/daghMbmrFsHuJ+rMlKXOE4z/wFf9f/b////////////////X/XqS7ojTkNPd31SzPoj3OXdSuRGWNV0V1Y0UWqklWxVjGJsi0HRGJxHcIOdqOfwdf6rm31utUgmq7lKqtbuUyQNj7V+XYJjqOtCY0hX13b+O/67iefNTIswsMXFVtfW7U39aKd/6dQtv3/////////////////7+idPs+yo52a6NIe53kO7o10M6tqxSujOx8x2eRko6KsQoBjr/JVOzmGowuy8GU2OdsUvWusMu6ZHUnrzb5ZykmVf3TbiOcrvs1gpr+a6+flzTWmaWcnpAyGy9/XNc33uch///CJv///r////////////////W1a9mnzENOV7Jmmjj1ZjXq5vceqrNc28005D1Sas98rZCoG0sBVdCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAOvjzeB+BNydC728GHnbk5qFN4H4K3JxMAbwMkJuT5YhFC3DfSunPc29Q6ff9bstTUtolNbGcdYnfvYYx+ynIxu1BY0q+z7u+99Ds+dnlYu+Sotfb7vlf/3Z3//l/r/////////////////+/+29CKZmkQ5EBO6FNQhbjGq9L0MQySWV70SeptUWrNLXahrBGMYSlEonYEGqKWTl3dSnxzxs9rXdCedieqDNT8E0zHcdKTaKbjUnFFGEYj/WsmaausnoAymCecutt/t/LB3/9RC353/////////////////f/rq+dMSchyGmqy3Oc1nqYhh89bOUeTfMzicLhHOd0T8ZNGN7gqME1IpkOLGQkrpX+sbvTev12PRXUWwYtrdhnWXK/zOlg2i1GjsQxevHl/uyQEIs4SVF4kU8mF/l3eX/2f1z/wg35P/////////////////6I/X+7G3N3yI5iqqKiFSRXOjLdrkVMzIruqLYyPHfaehU3woOmVVllcNg0RRO9fq7Xmdzgz7EoalfJsLmWl9iLGgxozw2RnyBKDxPZ0Q0ceD7FMBkljadbHrIKUOd+uAf1//////////////////6K12P7yPd3OViFK9FaoODRFMxnYYk11Muai3WOcxgpIQpMpJ+8XNA0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADj4k3gZgrcmqtJvA+Im5NiiDeBDytyb1IG8D3ibhdyUHioJPvuXyd3P1laW5u/i3nfmmg2O0nyi2xiI0U4TFsOhhhW3iqk9lr6iAEhInhUtdw7nvlyNf//UB/7//////////////////+3X2qhJ1s17K6FIqEQxVsQ1ruq2ZyOZtERW1Wow977UFh4isxa9TDrgxkslITnu1r0rdbUBmDhaRIi8dIdtI6WI/oiExseJkQxERq6bVheJF0pMgjgzg9J5SvmQwf+B/////////////////////d1VN8SzH4NtAIri62Nd9YSryVo4NiYI1XCCnPSky4+/hhZBdgoDgKhSFbX1+MQ1TmBIdeOuTV14vU1hyqxlMI9cF3mtJmpKza+tgUjqB4Nlvb4+rwdf/hj///////////////////0/qzo2kYperyPVd9WQ9JdT1M65Fo7KdXKZHRCsMI8rOLl+LOh/sQEhYVxuEZewIm8W3T51jw23puqFby2HdD0sdljDhXbgvE1iEG1mv4so28ZXQQ9TLed7vn5pK/3/+Af///////////////////+vW99bJlRuUYiohjdgTEWZZ2PYHKR0VdQZXOZGm2O0qIdFZWU6M7BgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAA351t4GPO3JsETbwNeJuTj5A3gY87cGhOhvA14m5T2HBkKSCop/z9a9vHXaAtBlTGu2il2st7fzCTGcq10FvHbN6+shLYONVBqHqDxaqfOs/6f3//Bc36///////////////////tdUdzDUojqh/ZDjq2Y+rHsaw4aJDQa4w6BmnLUWbrRqeEG2QTJ0H8c1IIJCCSlSnTQ7J5xprQiCpqn1mkYZsSBD7VkYyLWUwXu4uu619pht4w3g2j0n1vUXO/uqCv/+L/t///////////////////b1NdUculCLcjouxnZDTXm3RFZ9Cse/O5FqjyJVXVgepkN84P2gVl1Wkaiv1bz24/a4ON7OX3Uh/Vuwdc7ExPYtUWh3Vmvn2UCWxmQTcXcOyTW5f8fbFr/8Df6f//////////////////+lUWx7GHHMjTjEdTnMTMLTEV0PY56Me7btMMc00pYmk17kknpzrMkx7HMx44ZlSwnYJ8kaa2Wv3ujW26QMRL7op1z++99EQ3pRvGdYqN+/sYBFX+gOIyIn+5Pn4w0f/8R////////////////////1fe7VIEnQpUQq0MKDqiuyQNc7P0Z5aXXhBtjFEC9nWxIrvYza2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA4aFN4HvO3JqsSbwMaJuTYIc3gfArcmjQpvA9pW5y8N0jDc4PrQcW3jH/8rq61HKbeowdlcPcMEYl1hrwRqaUet2vsaT628kwB3kTJrUDefu6h//4GP//////////////////rXbenNn9OZMPqYpx5i5lNHz50w2iHNeaYrIe5lkUmyOYYpVlsq/EV/dsIkvqxMA8Q2Dy9f/e1dislDhmoThJzEGt2PMgoJcY4vDOOBETPTw+DcZUgGWIELyn71LHO/+L/////////////////////XZzMQ5WK1FPPaMzklcmRrIzpMUzKhmTcl0e86sahmfhKmqjiPU+nhxuJZR6P95tuJnr0EjpIHRPiMfxQakR6kOYaJHiBiwRViWUrinEi+K6Ecqz1JqUxKyX+A/////////////////////u9XVc7ncxSoZGZn1IZCHzGuZ7FJEUMrJr2MdI1HsmkQRpCChTgD8rat3GOK+o30Gl/b6o2VlqxOljB1j4MakfpGocwmi1RDKgMh/A2HzyisIosWiDttWcGC/4J/b/////////////////+v2f6PI1kKepishEojOd1GFShd0TlIXqrnynR13Ya4ynusD7j+LgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAANChDeBbxNyZxD28C3ibkyQlN4GLalBiTSbwPaJuStINRKuHled3XU/3bJsMMh30zEJdvpTaT0gyrK+RN2Or/GdJ9wt+aQJFbzNq//9WTX/4B/f///////////////////52rzwZSUQzwSPKlKFWZaPI18q5lHOsrs7RZwx3eB5kqIJ+i7p0GjsEhqiX3H9d/PzFgoRU6Ph8PHWZPDwi1Iaq6bcP/7fi7MlfIPSwIDH3/v4sVlf/xX9P/////////////////77e3apqPVzKbp7sGOpnOsqsYzSbHoyiCKcz1vV0crHgj8IRT1P+h0+AMFZuIDtsvTmx8WIj7GpMCZ+YDBsJyi4yAiRFLKThdT96w+m+wlIJUPZ1qLqzpN/5v0f////////t0tG1CrhZbQ4CYABAUDZoXDAbBF7wdNKDsiKknF2hgCBUULCRpM0VAhqFpFEPTm9zZp779G2KRgPVhh3lYWbz1BMSYQxBUK7obrj8Ih2cH4e4iVarZmMO/+J///////////////////v3r1+xijpz1K2xkRr8DLE69pd8pHNwJ493lBQgYII6RHu61sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADK4E3gW0rcmAt5vAtom5MgjDeBjRNyYs528CWibkRGjECwIJSlX1DPqciDwWYIisgozHbn0BqQGDCDKSbqCuV3JUddQ6jSGs6jOeiPb/hn////////////////////83Tpu6udErKxXOxjC85p3Nmq50VCmos4yLaLqlVJb6Eah0ru0YkgluBR6b6p0fs9a0hujsrJAOcmo3nEBGRNnJ5Or3qJgcGdDcD+QVWXT2Hc3+K////////////////////l/Wqomh27OiiL3KK5jU2410Sw5+sdlgIVD/El9cGUem8kXK0A1EFs0+m530nanMiVUUTgc91uQnRNFkmaj0FU2RaIWvjQN2xKMEc79dRd/4F/f//////////////////+/5Cs+up0JdEBHRUdHmMgJfLciqCZHkarayHVLsWlHQdq0BPCnQQ+ogAQ4U8ow+Vn1McWXJW0nCIZI5TRDnDUWojYsvMrj3ESks4MUPqNn23GBb/E/3/////////////////+v/uWpkehrNV0K9VSBId3HfQUwhXrsbSxtGpOPnb0OeiKTFm+egAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAvCFN4DNK3Jl0ObwMaJuS8I83gQ0Tcl5x5vA1om5FkSY4ytjz/LeqdLEi+4xHqbpjtccY06MXHU9Qgh/UaiSBrOp1/IT/4R////////////////////+q3pbXPMxjodSMkWe7SFeY3MpEZUzuZ5zVkeyjCZgtnNHBVSniUO6EAkKzS+d/b+7zhRUSqycjTLujMXEpKi04SskamrF0sZnD0M6a0aqesdX/xX////////////////////t3nlIjpIqu4U810OD2ZmMkySSOqs5GIYacp1kmocWs8KcxF0whF4KpJcG4Dw9SbpP/5Wyx7R9zvWomOMQurm8Z6uPYgJNI4HwWy3o+gaf8F////////////////////6ol29UdfaZsqurqRHmZkUymSV2Om6Jsx3SUZUdTTtQOrIhHfZRJ6iQSKIWQYzRadv9yxx5pmOib5+YOIpM+cG9x+9YqraiF8GctX6tRc/5f//////////////////0+/Wqo/dbWJPMzHCu9WTa2RWc6KyupkV3ql1lFFzM5KrkMxUai8PTgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAALgf7eBTRNyVUQG8CTqSguWQN4ENE3BasEbwLUJuT4MiyIsW0Ws9vkU8xAYftZbVk5h/Jh9NKSD9YhyCzLHoCiNr1fMf+D////////////////////7vqzcyWo90OZTPoiM0qqplIrMuVGUksKcYkxWqb/0zofa/3xnDyQB2RKDWbU7P7CsMKOS2gudWkzAcGMqLUXr1ECOmSgSw9FK613Hvlv////////+/20WgA+E2CASiNxcCiOB3lM4dNvFUAYaZHAvKtEocUJTTRcCCA0WFQo9o7d//Iqai+kOFq1byeiRCcWsRp/4xX1D1FQoKe/zb/hP//////////////////9f7sXkujTvaRXeYhD2pM5ybKxEYdiu+8YqAnZLc1SLRpyPqxGQcsqgy20eQ8hgbU7v/jYRxxBZUd0FjyFAL7KNLZ+Kg7qBSYUrZKcmf/L////////////////////7K10bmUpr5FYy3M5i7KjULUhKkQqO2pZUZUHSVsaC+3muqD5nvxAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAC9os3gK0Tcl2xZvAtQm4LbjzeA7RNyUwQG8BzqSgJBweYIAENu3+Vm0vJiVJ3NWs5i4+qKZwxZHXsbtWMoVBsU9dua/9///////////////////p/bqrqxnuWhpnuIY6nlClQrzsdWP1opnq06mrKeQ9pVRy0zPUTbly6gVYajSJ1prd/+wjksbuFI08Wc6ig2FCxhLIvQShtdAOjAUr687/p///////////////////+0/6KSqTkRzGvkaCMhdqSNBgmUioznGO6Xc2y3PcjkdTsd1PQYGuLsUPqF4rEX2t8xdj0Vmzd65MckjMtUQ7eoZkF4lAshaKf+//L///////////////////+lPX0M92UsqXksdHuXUrMzH2nVmIyOYrOiqY7UISAKzFLd2YxHMxGQEhYVqRAkEJFO/tYQuo5APqaDXtoFcXGnPF/wwL5wHxkO9act6//////////xS5wsaSkq1oQawaGEMOkCojBILtHwCCpg2DghEhsqbAQmOBwONhIKEQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAosbN4DHWcBXsWbwFOJuSz4s3gKoTck5kBvAk50olwkABZks3/YPQ1wG74NPduodpWZqk6S749cyvgb1wsxWU9X/////////+iGnihNI56QCHKw0BiiATEoHahoVPGAXCpQ6KiYEgJIHpsEATJrDZRYBmBFmVm/YQk4tUIMoKN6qEQmy8c+BxDKgIFBft6n/8n////////////////////u/U3dmStCVVDrciMe53ufshHZnaSZ6zHQ7IqIYhURTMiVEr3az1wgoiFhGS3T6Zc8Fg2eLOylYihHJjRMUl+HpuoghHDif3b/n////////////////////227s3S8pDEIR6MfIe0rNYjCnO6ksiseVyGKryKdEPOm7NJcGuqEWTpSoZFE6j926sJycnCHcCrdoORA55k/48MNQBoGP09B70//////////4keusAhybmSxYihqQqIVgMUMkSb0BEHiQ0AA4JYjDxAETBNJkmoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAJsGzeA4jnAVTGm8B1CbkqCFt4DnE3JIxAbwHKdKB5gsLx9dr/46gCAbqLtZjiSIWKBlB74pJaAGiEOZ0+j/////////uprqRWeBwqyPDJ1KQ68kKioQDAlcSMLCxNYCGqlAEgQh1ixcFSI+gWCUiY7/+VGylFEVlSd+jiGIi9pr+xbgqGTf8Wf+3//////////////////X9HtbvzXRUd5qPKj3daspGsS6EsqoXM9CkMYtbnmc8rKta3HVTgq/dlTVCYWMfT/zENPAdpzpSLgqWKDeJ/sX4NA8Y6fIf9P////////////////////f0qlUZzG0KokqJO7MqO6+gKW5nVZNkZTGKpkS5xlKMKh3WejvKJIAFDIZSi/6g8Vh3YPesWnF70+5moSDhb/Uv//////////225dyigsOA86ZpA7yICAJxwTHGRAPYkXFQROvIoAqBocOrCBtClgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAACtI03gKoTclDRxvAUom5IXGzeAoTnATG928BTibmcICpBBD//J5NClbXaexKLxw8TpT4uJtRYDFv9T/+v////////////////////70Sj2Zila5NSUqyI7zoZiyIVVZaIQpKOs7srIqK52dC2MlEQiCW+BHPAYEAd7f/Frw9wXasHht7fYc1AsYO6fJ/1////////////////////+noZmnuQiKR6mcoqxGTepVd2GojEc9rloiJdFVj0ZrK92WZHUZQUhakCuN3/5QQbzPWXUYKmV+IDNBOKX8t6v/////////G9y0nyMIpBsG2kWAU5Fx4MNWcYEjaKQNHpKiqBhEUSfEYGhUszjAiFjyf/QX0m6i/0kJeZf6twmPb/r/0//////////////////9fR9dpN7VfKbsRWdEV1QtnWhysWRWrFEv9nEj4uZfsfklyoU9xFoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAAlh7N4AnE3JLECbwHOJuSIhu3gEIpwEaNpvAcQm5OJRH/9XsoSc/SkshZQ63x4txsVL/8t//////////////////////ftlVFury1YyI5kMis2zO1GFULtDmkEdWpdc/RIHdIYwoyXsJRHE4WJf/lDrTtB789S9pn/hxVv+d/////////////////////9165qGelD0U6GBSa0MdJM6FYjTvMZGolnaJTd0YA4VvO8qFeBgjRRIYIP//x0D+hte4xkLf4mO4Ko/7///////////vUPLnznODjIUNhQAjYVBsSAQ6aAKRKSFyBkPGzj2icodBsXmlCoAsOiMFjbf+CF3l0E7civ3+vQDB/+3/////////////////////+n+5EsoJncGoRHSaY7BFLia2OkVLC8wLD7t7Z/N1kFf6zAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAkyLN4ClE3JMkRbwBEJuSN343gCITckcRRvAEQm4lQLR//5qKJcdvyIyD5fhHx8f/oT//////////////////////531VJnZOtCqZEEtRHueyzq2VpZKMVVeqJLfKZT5zGeoVGXfoCsaCn/8Eal9T/qr3l+vUMv/////////////////////+v/R7rsqmWhzKVHZzrM6MjJYmhkMGYtUYrFQziioyqpaOxXXMVQxgGEwQumWxsTL//aA6n/VM39X5Ef//////////////////////6u1OqWK/5nZTWdHdBiKRmIrsYrIbRGmeroMyu1kfaRPovqDJYR+LU5GFhP/9D2+n5vm/8Sv/v//////////////////////9kJuZFa5FbVdmM5HRFczlIVHVnUp3ZHWdVZCmdmNV87TkMNFwEhSlgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAH1freAIhNyQ3Dm8AgibkbQAN4AAAABATubwBCJuchf//eK5v01/09U////////////////////////306Wc7ZkiKuRWMrqiKzV/SpTKyg8a6D3yT0RY3X+JqeI3WHv/+W/rXD8P/j///////////////////////+uXpVbVlq61RXa85zLq11SUpgR1ndWQhzGrTI5WKpJgQrNfZCysXOlP+Vo+7slv///////////0XELFhI0IYYCKAmGgcC8iODIsTtEI0yMPRGA1GGBNoREiAmEwuIO/////xf/+X///////////////////////177u7XdkSmpSEOVzIQiozEKiMUWofXPE6fPUzTJSaaWkfxkJqV2KAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABz3A3gAETcjzQpvAAIm5DuALeAAAAAIWAG8AAAAD/f/////////////////////////////tc3UzFeV3YzOMYtdPA9ZmK5EnctEZ+C+32DcSR7y5PoNxP/////+v///////////////////////79iaNR1qZUmV4vpMqnM6255kYjIlyOiXVzyldVCAsWfgCt42Fnh/////////////////ld5GWfER6v/LHlB2JXIUODv/////////////////1xLgtER78RPEriyxh5slEUq7EoaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAAAAN4AAAAAAAAbwAAAAAAAA3gAAAAAAABvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAAAADeAAAAAAAAG8AAAAAAAAN4AAAAAAAAbwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=";

var ExerciseFinished1 = "data:audio/mpeg;base64,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";

var ExerciseFinished2 = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwMkFGIDAwMDAwMzZCIDAwMDA0ODBCIDAwMDAyMjkxIDAwMDAwMDRFIDAwMDAwMDRFIDAwMDA2QUUwIDAwMDA3NERFIDAwMDAwMDM0IDAwMDAwMDM0AENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDA3RUMgMDAwMDAwMDAwMDAyRDM4NCAwMDAwMDAwMCAwMDAyNzhBOCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAACjALeAAAAAFYAW8AAAAAjaHt4GhE3JE8EbwNCJuf/////////////////9/LvR/p+D//////////////////KO/wfej/xP0/TJAZxlBIyYil///9//////////////////////////b//s7oYkhyuhUtIZz2SzFciojJRUVKSO1iXuJKYy0h6ZqiYpIDgP0yQGcZQSMmIpf///f/////////////////////////T/W3teplBlI1KIyT1czIRpq72R3RTkVuyQiPLDpaESkrw8Ty2wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEGYM3g3JrcooQ5vBuTW5ciRk1tYyAA5EjJraxkACmoYIbuqgQBplJmazCmYuR99qa6BoaSupmpav00jRZ8mCyOeZFkbgnkDgBjSeNUm6Df1N/TdD/ZMwJReggt9EvnAm4NsmIpes3///////1N/U32////9i//rQZ3qWi9BqqC3WjdJd3RTVQdlIrRU6rLSUzt3ZVBFR11A9RT4DHgf1Bq1NQwQ3dOwgDTKTM1mFMxcj77U10DQ0ldTNS1fppGiz5MFkc8yLI3BPIHADGl41SboN/U39N0P9kzAlEdBlvol84E3BtkxFL1m///////+pv6v2///2/UtNLvrT1sx1BFFFBa1oIoLdlKdSmRUt0HWlYzTVU6tqlupTOzIoqTMVp0alHPBQaU3Plios3//////9Q/6SkpKSHFVFYDlAFETAgSA2HrvUDRXLMIoPkreWfMEEs2j/A77sPS/LhgEEwwS0a13gLPgIMsmWTLJlo0f4eR4MUUxxzFDLNoPsHnmAISDBBAQZcdTeTuwzh3H8iyNhhEGQEowCSTTVNEEcAN+U5XzXNAxal9HEGsLERXRXTHWO1+H8oYZwmOoOu9r7/y+/KHIXeu9iblw/T6lEYcty3Lct/5f2pGHLcuX09PT56qRuNxunp6fPVJG43L6e2fEAPg+D7y4Pg+H9YPv//wQDFYOAg4Hw/g+f///+D/SLN///////UP+kpKSkhxVRWA5QBREwIEgNh671A0VyzCKD5K3lnzBBLNo/wO+7D0vy4YBBMMEtGtd4Cz4CDLJlkyyZaNH+HkeDFFMccxQyzaD7B55gCEgwQQEGXHU3k7sM4dx/IsjYYRBkBKMAkk01TRBHADflOV81zQMWpfRxBrCxEV0V0x1jtfh/KGGcJjqDrva+/8vvyhyF3rvYm5cP0+pRGHLcty3Lf+X9qRhy3Ll9PT0+eqkbjcbp6enz1SRuNy+ntnxAD4Pg+8uD4Ph/WD7//8EAxWDgIOB8P4Pn////g/0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAADIGQSYZWoABM0gbwwAgAIvpBW7h6AAMFSCkDCyAAEnAQGhYQKhoSgAkXgZABQGEgmBnMOgKAgDTI6AwMBAMBAsQUFWOQQUgIGBB+CwsAkOQ1cBQDCjgQFgCwPACFIBooD+hjUGgaC4gXAgYnEQAgHDRgMGigMYkMEfBc0HmKBgfE+gYHCgDAuGeAw+HhSROpk8LjHLLqJAh3g1BIGPS0Bil/gY4bQGIxUBh8CBasGoEAENIHQBsBiECgoCAyISgQl4DaB1C5sN/AkChpAVAwIgMHzB+wXBDDIsPBNOWyiYlYnT55i8LiD0g94G3wwEIOIkVgxUXy0dAgBQtJTJopERPmJgOkeS7SKxmMsIDCyQtGBuADBgAEjEBjcfZFTQyJcWSBEKBQOETZZdUpFg1IIQAHADSNT5YFzDVKhHDmmJACNGVPFEZUXCmHKmazVSCJYJ3SMaI3D61qU1lNox9B6oxgGCguDcoL4iSibhXRzRPRfKhEjqBAigM0bmQs4nheB8xLj4LcaZOCmBqo+an1sWkGMEWMlrRMzyR8iRcW8rmw5Szpw+myr912rRWWr/////////////////////////99F/9Ks/6/o66mlFMQxGKwMIcdkOQQUQrucc7qpgZysDhVKwoxz3Og7mKdwYGplVmBFCGQpjGOQryowABQMAQMBgABwMBAOBHVKGiMEkJVAuY0+7osXBPZ0LcqaIBgKAyLAYhcAkgHO6JUNzhoTrDlCh3dmciggIJwAGECfBXieANTgZUyFoucK+mHyCgDAgAygZZJoZ0ORFbDlXZ3ZMiAssvEQDLYnc2H8agNjwySAWvA2BOybt4NmwwWTANj5PE4RMwNA+EBckAo3AGJBqoc8coZIZ3128oDmFQZgnGNE3IuT4rwy4fCdIKTpMniBMRb//uXyBkTIOT5uyaZOGkghoOojBAUMTJMQ4xJli6Q0gpiRX////5cLjFxnL5fcXOLnK4euV5NkXN0y+bsmmycipkdHCYDwTTlAVsomQGgQXBDuI4hpFBmjpOkcUSqfLJgn7r8D+d9MdBmEQ4yAcoUQaSBgYoXyvxbkUy5+Zm5Bz455VFODCwCA/l8vummHKF0PwEEBc5Hf3LjJkwaJjsCw8PnIIFh4Aqil/+RQ0TLjUFuAuYG4hqgDlw+44DYUAJ0/+tN00/QQK5FCGCFxBMew+cTuT4zBa//9BBkFN305mGqBAQYAN2BlgaApcjCIB65EyuGqxm/////pp320EGLjUEGq/jvQMEj6CY4DEmyyKDHLG6QMnyCE2Xy4gsnEjRRgTgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAf4jFQnP2ACvY8q9ODMAGBWQUgMby3DMr0p0B1JuQQAAAB7bx6jcSznFrentrPy1HYrLWxLDINDwud0El6ZbY1O37+O862Vuxlbo6amlXLlV9UUVogBUMVBFdOfSSzO5KKKU35qfqw7VnJmpvdW5hlblNNlUXG3RYkzBbj25h94zKrcvqupKobfmLqarHcV2Gxp7QFegWzGpZTY4012IxmarZ17Pd6137OG9fayq1a1Wpr8K2XcPx1q1TZU1qtaVDS0tmXRnC5vl7Om3ex3Xxs/jf5rmW7FLytalOWHMsrWN67VpcNd+vZqVcF9vLQc/C/jj+su/rv6tZ3JS+rOXFlVruePPta1l+OOWX4/lrusM697m93v7repIFE1pk4Y6gBTYUJxOaEJ9VSkiLgQGA+JXL1FSn1stkjaitFkjY2TOkOBtgHHLOrdNjpeLyKJwvKcxLx9SReLzrUiiXSwXj6aJkXS6ioyUkZGRETyY+SCkCD4hbhjRliiYnCLF5NFFaJkXi8iijqLyVfXRqSSSSRRRmT2UiuuiitGjzJZBUU0VJOsxZVJIvJJtdFSSXSMkUkloskkkkqijSSTSSrRb9FFlJJLoomJqTRJRxX//groT6RX4vmyebeE2S/WetzA65pg4h7r2tZY4fzfKbczJJOkaYaxn1u5ETOy5UUp47LO5Y2Ms/mKahp6STxR478XZ8pePRxQYMimJFeuPrYlFrtqmntdmbcsius+0Uh7IrWTPECcAAEyHnBh6dvR+48T4wdm+9LCWgJGsmSwmYKZmBzWmR+Py6bn52xHLmFLqiypcv1nn25q5l2vKa2XbdWvKbVn95Y5YZ87vWV+gwlpMDvkzSQNnVv0tPKt9vYV6LfKfDLK33uONqz9ivP8tb73vNYV5ixfrfcqXMk5YXhnc33WNi5/f1zf5Z1py1T9vcw5zV/Hu/yyx3hzL95ZYZd33Vvl/u9Z4xHCr3dDnuw0gEmACZBl5VLf9/u6sqqSB4VQHzWDQJvZnPLfe6/fN3N2fq41LEs+s6D/mRPSNTeHstYW93936VE1UWzFAyQTU5SPmrFFMjDM6kZl0pGpLEXNS6XSMKw6iOMxzxQguIOcVRkiZBGRBjQ4mVigfLxVNEDdaCamNUl0V1sznEUkUlGk+bMgmktalpXWi7nXUtReKyVNFSlqMVV1uzTRnUmpJaNFJFp9FPom1FJVlF5BNB00WQe7VVMpFExY8apItvtRlVv/h9ux7lkPY4qUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIZJBRApvLcNJyCmQLT24hojFEjXMN2u28qZCMrbmilZAPmBgQJsxglJBTq/9feqW4AgVhgqAmVJh0do7KZ03QxjcJ5vPDWsaeW8nJbM5vw+jQh0DasFp8iF2/atCe6p5dcjEAyS7Q2bEnmssa2q2djvKR3GHkw/igLyP7RxyvIaSCrbI4u/0WpkwW4NgZGTBvEhgcI/w7VeyW9k0anYalczulkNJles9pq/z2t7jEqtXpu9bpKlupLKetvLeO+dp9TFaVNgVbrceh6ngyNx+T01mNXZXK9Z2LVTlS/2rS288pzeNSrV5y/R5fVvcv4cnalPluJDgD9XMu85bws5az7r6XDeONypVr2e4Z6/PeG94YY73vf5Vca+Hc62e+SzDHHd56OY02Gt0lUqAWEAWCkIP8zlXX932re2+k5JyQYehIvm9FJRf73//v7rZ65L5rKzM3/jLOgK7QHw1Tymml1/KrT53olWG8GE+3DpChXpEiqJEI9sntGjz7jLiL01iGnz/V6FSH0RzGRkCw/Z2xzbMNsR28ktB38wfemtY3m28xae24WfmbMCt649PvVb+Zmi6zdzixmHESm9UvNm99fGZr2jarq1s6jwt/OK537xN11XHky/iXzrG6e2s2//+LQaw4WqY/+//80/x8Y+f8Z9K5/xre/WP6b38bjAgAAAD99wr1RkipAGQHLrV7nM8uY2MKekyZxDCOBiMXHUg6RDFq7yyirIreNTCftTu7cJk81IZa+cVrygcAKIJjBBBg+dmlneROdhEq1EJHVzjUsvcop3KruL1qkYpad+Hmn/ic7jAEobG/0Qe6Yj7cICnqdrKY6ma23GbmMieKcdfj6S/eMivx2ao72P1qeisTmOFWtlTyvOYu7pt3bVfsmmp6pzPGn7jdzxnbL0MVt3MIdeCxY5Tdl8xO1rdNvU7l9ata3hYuzt2rayq1JfZyy1T7y3d7TUvKtaxUc+du/+dixnh2rlvG1uphvf08qrZynmW9/zfe/zWdSzn38P3+u71zlDz/5hHYjAiJcQNEAMgCLXH+sK8c1/fzx+Rza8hGOaNcadHCpfsf/Px5jb5f5ezwllvluAlYDEyYc/ksi1NctQ3ema9KogUH2rLn7sweq7skEoZE57acO8gaHWbUeoxJliQE8EgEwLWSgHNrnSglsYkeOHUWLVLa3vruXZ2+EYThCmPbF1PEw66eegtjaRzFVrH1T3TU7Xs+dkTb6ayGRXXMt9ludLuXoNc+Lma+qvnm2u3mthtqv/98/yHUAuHd8XPjYkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACGWM0aMaw3LPcYpEH09uX/YxRAzujcLnNulQXT25AAAoAH46z3GyB7KzrUdMjDJGrqUxSm5Z1ZnKeX2nWVQGcJ1eKYUZbaGa9TKl+rSQUzO7flkbl+cEPfF5Dy8vI4MI0AGTN40OvMNe5BUVgmAsoZ5Fo3L4jLa1HEbMSjsMR2lWDlsZlr7RGRayZ1G4dhTtPSudxYaUKC3wNoaazku8yAuiylksup4rn2gmoNa/BDqSWvnXqY1901WpW1VypqmefbdWrUv2buHc6+HcPxtZ743SEUlqWulS6yxxzwzp5788+Zb7/59xz5T73ayy1vms+XL+Xc7mudp4xFJesm/lhl38e5Y/+f4713VnLeO6ut/zWW+VcK2525T0tbmX65lvHLvPy/v8qWvpC9DEAKACgnAaY6dqP3n/7s9+Sw6oGYA0bmUyOVPfqxR9/fe597yb7hcp90VNIWwMmAUsIMO/IoJmMaLdXOfm4OlNHg0gWeQYXmiZrEF0PLb9tVUX3ZITbt+nKMzkX5AOyPOtCIJDjmjT3o/YMQpb2rTH/tqlfTNrbg6x7y6kjahYtnHzrfxrfuvOG8zPWKHGjU1S0jy1N5vJnObZkx6Y1rWs4p9XrTOsar8Yt76mrbXr91/3je8U+fj/GK4/zm/xv+f21/rX3v5p/9/++p6wCHz8/3KGRJ0ix5W4FkjhBhyzrHUN3+Z00Pv5QvoIQcwABPTXC7bSZHK5X9D/d0HwxfswNGbNXCUwxP1VFSUUJJcRBNpuD2YR6R0hh4DUeinPloixeJwlisgaGpPHCBFQDGhx2DPBspw0TLxPk6UCJEWIoYFolBz0ifErC/wW7AktEFRAhREoBQWNNbuXibJxAviCoWggb0eIVJlRsYuigaOZItNy6RwNy0GNkTIxpmzoGiRiLnHctjFJ2PCvDBZZcLTGqSSZqtFjOigbOki1N1KLxaMD9JTrd60mWp1Iouikaxch+izb67O9NmSoIsm5xr2rXZjBKiy12ftWzaihwoDTwAEAAjACCiEb6xLX//08pyjNdNwLoA3wNBGZO5Ob7v+d1v616zWuXPqyuUxLUUM0vSAe16ZrHPdutqrOODTaHKtuOd2kli1zEyYTTXx3sS7W/fxHsGGq1C2s7WrTkZXj4RiC9j08TN77bKxc6xbFc7+fa1cZpi31nd9V9vqmM5rj/cyedfxoTnjEWtv/CxnWqV+c/2vvOvb639Yx/j59vTGdfMRV71P4U/sHGFqbTfHee1/ezW45fn5AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhzjFCjW9Nyz1GaNBtNbhzyM0SM6m3a7MYo0L0tuiAAAABvDfyUZFlUMjkZdYJChvm0ux36tRx6XWD+w+/DSwYAmDiB8iQBkVlUggeml0Ac1UnajdqWVzcFYT76yKJOs4iwJZg1YOGidk9qBJh3ICWAFAiAZLBLt4XJHYjEth2Ar01TVWYDRyH4tEph5YK7UiMbwu0EktP9OyiSpykQCo2FcStsOOerFIPi1ubpb8vzpB0idUA/+VvC/upvKnprHMLVqCmeW+duYWLG9b7z6WULcsZ6tVu2VF6v7tQqezr41M8cK1XPPVzLLHWOW86XDt/Ld7Hlrueudx/ff3+XMq+ECdp97/8/5vmWta5nreuW8v/LPPX61/fw7nrX4c3z//X5Y7u5fn3LOnw7NVGAAgAO9nFB1f+U9bNbpMs5vspfyXDIAtuaeSUA0xcIzR43+frdrPGxLJnlyOU/b0EuNMmHgLohiJRmVP/S2YXZ5NGA+skVjqbqMUkTdR8YIkkAiCmZpJmajQkRylAzJc0LxTE/C7j1LqZwOcIYTQKUhkiseqR8otMzAomiaDqSuhRUpTIoEF1pmJufdnsnputadJBEd9jpdKJOSfY2dF0EFrMW0jqk7stFJNS0VKa6lHkU1MjWpRfOKStV6OupNlPZfVb2o6q93fV0G9I5J1EAAAAD+b1XQmmGc0EKaiJkLsK3WP/KOratUtqVxxnsoSrCqkwuFUcfdndixKef2B/oKK9TV8Z6US6emKcgELHNOMXBDbSWXtYiFA/4CazfLyiYK5oTpqQRFAyNicKo6Q6yRmTRiYk6VCOJkiJVJk3Ok4sqjmEYK1ENMiBh6ojARYWwWWRMzOFVBy8VigoICgcmCwkmyCTsy1oKRZM8PwedJ1JoJmKCNrIEQH2kgnoyIlZBZRNCs62RZZut1sutNJ9V1G7O7q0UltR6mPJLZ0Bz30Wq162U1atJe3+1d16rq1+t/RPrV4qSAAAAOUowfmOXAmr8fchndy9nUpoDlhiAhz4iGmcBT+OGX8/Ws8d8zpopLJy9ajT4EIAZTsRgSpZdGEU71NYkPZA0gh4OGw7jOnMOG8FQ+IJDuMGKLks2cloIpyUEspWk0JJHIYfx6DYsZKVqrLZqIQMHai1v2Ol3NMYTNnNPc5v8dxzvnTLSP7GJMYcfSkS1m655i98zFP3bWRt4/+pe24bZdPfP3/39w6o2RM8///xPH/////1Kr8NjQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH0o1Qo1qjcsrRmiQ3bW5eojVAjO6N06FGZ8E9vblgAAAAayyz0xsHHkmDHKC3ILqERW/zO6jeVhoPlmahhjEwYCakreUKT/nhINK6a3YljiY5ymHmsR6OVKWC6tWgl9e1LU91ADJYUunCljTGS4xcUAgZ21evPGJqkVCCkCkkxRLJVLyQEh5ESZFdEfk2TBqUFGxFEDhFjciw6TMdIYgBEBGsMmLhFCAAiQMmXBwEZYpkiiWiwWyaHOGuFigCGIcwVsbkRRRMEStTROIH3cdJusxZc2RWovJoybEHOidQOOovD2tZqgXWSTWzXdqaaaVNlKrWbLNmqRfo6Kq9kF5fHtdB39qbaupJkGo/X19/v1bspl50/jHiWAAAABW1Mom3Kw1lP1ADNreUpj5fd3YJehB4XXDFgP2tw92gn/729K5TKa8uuZ3I1VuWo1mQABkBQpbx95THpXqqlbMS/a0zI1SHaSiCpID2LiBIl02JURBTL61lijY0JUkz6RJDiHEO8T8bhsDmAOUGYewJ0YFw2ZNFmWTR8GOktTpKXPGzLOJtMiiaKrsfd1fNdBaSkxNiXom50qomrouu1a0q6DrSupN1LrdGp6S7ulRX2HKfVqb11/oJoqUpL9Vqu3/tRv5l4bsgAAAAau67EBG6BQ16hLYVqNJ0W+VPDVmbTRKxBwKWNqdGKpxMoJuDAYIiY4xCGQArAnai8VepG115RKWCBcCavD9W7CGyQ21uK5V5hXKnJiU0NCUCwc4Upaza4YMOTFJKC4Xlm5dKg4i+UTFImnGeCiRyTFpEFj5wqHTEfRTN3MiGDbMUiiI4BhEcocRPFMISYG1NB+xEaDqpMovBa8AqaGkRFZpO0lqRcuJpIMGRjRFSN0mMkUNRFxOiLqSSOrJUcxFRSW7qUplLd60HZSPQqTPJTy6kLV1v0aSS8uEGb7s2t3XdmU1079ba76//9JfQWcUuEqjjqDBjMubgNgIAi9yGiIDfy9DkdBAiNC6HVGcw1TPDpWjK+fRs1+Wu1AndTbguxIaCMU0dmHIdqXxBi6bTxhEuBhVxpZKoOfS0+pMPxqIR2WPieEtltZLWYHKHDY2dRqoybx47q9qxIje/VibNxKJYkI+1kWEhQ3RlinwnkdszAiw4kVjR7LAh3jV1NiHuaXVcQEIa9bpa+s99DrjOI+vJTwmGMTreYOFTjUGHfX3qlrZt7Zt869c1zvO8b1vH3nG90jazXXw/ct//G//r71jX//zbMTVfb///5+f8f///P/9N//cmb07AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAAB3Bu0SNZw3THTcoUZ29uoC23Ro1nbdMhtugBTj24QAAAAGXf+gIDZggb7mKFqNAc+Y/+Crb3Tt/Qqcqem5HyEA6ah6hdBomncawhscCQz9h5mCVZiHcX1QCSDDKxnDlLDUslpIIEFgnYokYnHpZLnxlSIZhE2I/TSmJar7msqSfqWb9WJsfntRFoMopca01t5pA6dPIbMbf+NvyoFAkOs3gUVONxkjJK8sopRAcahdJBCZKU1JORuYpqXVLT9idaHIhOuXTOwXgbNXjdW3hhjbqb3V04ud9kCmkgp72UjsatYZ2se48wr369amnXLnscub5rXd85/cOd/+//////8/8/zpLPP/Yxn/8nkCAAAABrW/9mU73Gq8Q50DvJblzaaKtOPbDdwMSsfXOYMbHBoCx0rIzBFW1KY7Y7azlL008buzVLOU8mymWls6Aje7ivJU791wr0BJCRGmtNShzIqHOPDiwl60kVsi5b09NNPddxdPW5VT4olYZxH9duayUi2jELo1xFVu27Ys3q0JQy0xXXzGrvVc3m1hQw7Wpi/pqLb/136e9cahoTnLDjes63uv/pnOq5/1951r3zXPx//b/4vr+1P/Zw/2QVAN/+murSHULIAAAAH4b50hBhy1+hk0MiwUWBnknTw/3cELIGQGzRunk5LOC0W4iKcPzTWS9DhH4nJ+xElmSiF5wQwp/YHp72MYoZbVeZrySpmnlAtytMxfcPJGmaA5kq1eppNlhWLZQi9L5Y7cukCPjzxSjlj7twelylPtASHWwylvk125yFrcikCtrq8ikbRBFh9rif+Msht6ndgZRkFAgBDwYrHQNhlQGNE4GBGFvq2J+YGgR23AfF2nWnHXZwVAUaXonGp2kldJVtY/+sKGGpW8C1AqBtOg6TRu7D8xQx6lzt4W+08Dvzb5jF2mb1j3m+fhutSc/96///////////8Y87yn///13Prh+B97joAjCCp0dnm4aZbWsS2CBkbFAbQnDA8OBA5H17kb3mllLSxmKZ6xksFwqKYRnsKnIlnLo+ywxMMBYll0a7iR2A4lik78GzqrbbvluKnIEftjk5tiPcM1unJ59Qei5452sWnjUhjGpDSZC+Mp9GeeDBBs17iYmiKUf5ECwN8eJH3fOp36szXVWtTIz63TetfGfvwdXxpWazthpTUK9oVN61XNPr63v/+98/Oc1zn3/+//j/dsYx8Xigqm/7xcir//A1KQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABwtt0SM5q3EILEoJa1xuGR2JRAxrTcPvtqfBnW24YAAAAG//9pUBzj3iNNho+6DCQNvWtWIyyJDAiwiTC4lGGsjKQMbMuFk0hWxL5DyeypasixppZPa7ezrWK0pWZLEw6SJxavL4Ap6lCUUSCT1DQ8aFAvivgGhUQTIkVTAnzE8Vp0vmcd5URMC4QwwIwujcIaI5GSJMcQo5ZLpLk0HIA3oMaOKkbkQJoskBE3CPwFiIBs4lhYoK1IKW1lJMvoJlNzU0Kg6xyhHoGIAoKKRdJJBBGy6ExHhFICIOBgXNDRAa5iKFJlSCrzpqO4fKCcwJci/+qoi////qPu9X///y+AAAAAQH47wuggABsDfBdGl6HiTHIzihGWQuWO6mkIhQDYIZIJYaMAPR5MOSNcFMY0LSw2rfGVwRCD46rp6YXVn38Z1A1I9sNxyOV3MFgiyVnncerpdqex1E44uo3gGKRuEUEbhEnctWcRisv3A0Vorcphte2FJnKIBc9rF2jlF6UqkcRuTWRgGjwKcOGAgFt0hiUkwCBoEMMB5G9DJrXsnfKFKGvySggiAYgNRxwvgQAKlc1zqtJVoY5jT00ZlE44bMmCmOBQxWH9Vsa2eWsda+rAmNOKhgrGsxZsXc03YzR3tY7w+ceZutSf+keZ2/3r9d7/9rQ35cRKtY2Rw9dxTZTb//Zkxer//9FUC0pcWkQ4BzWRo3rf1fgCjbkaMbNKFUbcsSACTOTrnHGk8HyqFdpNdoYTrGku41rP3dYz672wPWY8euNk81lJp6MKpgoHGrN7LLCGftmMIKfvY2ruV5171qP6sspsZV/cHDOaZXLU7KtSmaBdlsqqLBFCl2Xmw1X5cu0caSdMPQPCpVudmXd7zn8qfzf5Yx1FwwBuMX72fcMvzt0+o3PVd7R0JjW9/cm6jvV89a7zUthypl3skk8Q///////VJ//qf////9P5Z6rDiSeTvGQQMFC1rQjrjgGNPuxh7xUAeOuoEPLl3KOQKICIRVBTsGAHfZM0Jd7/yygpYLbS/OOZAMXizSdS9rsii5d8KAiqBOXYNAIZi5MYcB/aRxwF3e+ghb8SuSM9vSoyBQYNS1co3nSMrfmZj9HSITbGFNLG77tuklW8JACWYNdZChu0gkjclHhIxTvVi3NVOU8zOMGQ4gGiNzO1Aloz+WVm/M9nKlimpNdcEdCDCjN/J+xbx136eVy+47ciktelKgMLJUz/LsleBk1W5jqvUqP68lJQW84IbO9H65/d/+t6hj96x/9////P5+98//qH/s3xWr/+/FQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjgbk6DeuNwvs26BGNTbiJ1hz6Nb23SyCnoEP1leP1a1XMBOACNBgQZyGGEiR05aYiKmCjqUkpHQKAlhKJ56EwuGDrT0kIBdJjhZ9kBvQqVRZ8mLUQAFqMuW9EZU6FhLJG7OI+zuSrKrOSiErzC44vE0M4AMmyoSWbxFxn3gMLADAqG7tbgGUO3GF5QHLzKYDQMj007cpoZgHBCB5+AYfhCC09LKWjXlDFeQGCwQqiYJDaUEfKgCEAFeq3Qo4LPQTocRYAZX6ahqUNCmGiwYXAR78ICwzHgAkE/1ybqTlLM3ZjLUs6/i/jZIOIgPAkvp73KmV/cZflsYYRlJT1gQhIaN2faajsDIKfXuGNnXJqFKRnnqn76nTJlo3v/nN9y7+EN4a/n6//1/d//77//+Wdp/o7qv1+f+5OMIAAAAH9x5nIW41e6hlpJKRqe7kQr2DAiUzXUhEMuq0MBHidqRJVAGut/KJZYwv/av46naHGbsRa7I7MmWSk+ZZkCiUWcvChh60xsHJ7V7AolQpqc8AJIrFlE4bmyIy5wsEcamY6VFMgbDjLpmUyWKpDSeKyRBB8G48DJDSGPJVjFFFZ1EokOI4BBwE2MibcrIzZMzsqZqTTICVy+gpkkd0rzZ6hnh4d5k5qmsxS3seUjoqf//2//+iYmP////kSAAAAB3P7twEJjBixIKZJSIjIYjX+RAgWIh3anc2nYCLAoDwYCgYAo0pUvzTScFXCcKAR3IJgFPKo/1hsCVLWp1+IhjJ7EplbWIasGGAKWpIACzeUDi5lxzDuWFoDAAYcNpjyNpDsvm5DKYWtkxYhgNw443kDwQtlO5MxrcBQVTM0ideSRRutPLXSRVgoxwefePRAWP5FH6N4ZULCUbMmBFIoA1UFYG5vUsEYMEGFDxihyYfKAJEMACAAALUdykfSQW6CvDcxUhh036LAWZoTP7QflrPC9Tug/L/pvmBAxiQgDhB6U0hoihu1PyiHVV2YTlXCrUwmVrP3BLT2/lDPqZk2VjPX58/9dhxnd+Sb93V///TQAQAAM49+3gUJ/sKQuL6DwfLO9LYJIWcbdqA2syNiKYoePT/XnHqj3wnDd+7A1mPX8p+5K8O4wzcfJjCqIVZETLIXZfuHYjOzooFhvlidsxpycUI3stY01upizj6WSSmnpspqS9jOcVq26eHI3BFiq/8arxp+EcnNiNfHOp2th1534BbKUMij3a//Y3h+c1d7VtSZkl///n6/+6/m7fexyBLH/hnJNFgSSBgs4XKfXR/1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAItmJPA1rbcL7LefRDOG4gFYk+DW9NwvKtJ9GNZbj9/aBgQgaGiIxIQOhENO8CNwEBKI2weWxIqgEhEZQXuGiqgwyCBgVqBg5p0Y5udJiAAyDWFjRgAVMxVlkro1a3day3lC2j6P0h0DBCdEgoxJ0MhHIN9RGg8ncOhfpwPCoQxKRCpbvxFothujgQ0SFRft+3sdyln2lBi2uF0oYfuH0TmGSi/KmnQ+6kMEQvHgEpopYLbEAA36jydEhoAACJ7GlpRMCRtQi2370Pi0gGjRiLYfo+mQBpd8wEDGgddr9w66FJPT0OSGPQBSNbJAIz4jZo+/ZTT1JR9PbeaUzBiQYcgQpQw9Iyg2n921gZC8jPa1aYvzmUlchoWRAAvPg2Ku2az3v//O/204+1aP12Qjaipaf//6oQAAABQOrMyPGTOY7hNRCcFY/ViMujwtgnk2ORQzD4wgaiBz0A5N9L1po/ccKa7LNT3ZyD79eapqSMbVjbsShBbUIVUAWEfacb+CnJAQt2gp8KScyt05eWvZ+VU85KW7y+TRzLCrqnu14lel0MxCbbvdylzlU9xodDYZpDrEI1y3jjnE2ftGGAG9rJYtL8L/N77e39erllffx/Zd+u9/v/3uPXhdql9njq8/7nZXnnzHX8+1a1U/e/u4/kdP9hr94PiEDyoJWKNDzHnQCONULNbMMMkBQhvGvJGq7GgA1RTZs/UCBg0psVVc0QWO9dEY0PodlyWTeJ7Rq1EV1WI5Fe0MCWUBQcEtZcK8LFgoFEQaYlDPpI2ISGTSmWteDEl7bUQgSAZK/EabqDU7ozjwxqRQXGzTE37pXIgaFKoyaNVpcyOGcr6IjYTML0DZ15SZYwyFvNkvlJdPQ4ltdLRjChXleKQRhoTfligYwTDpAfFRI0Oody3Uu1Zf2VY4xrSHIXPsmpYzjjYwyxyeazSGFPHFQrqpWYlDffMG4Z2ng1hnd7nSMNpvgFqenoqS/nO6w/96x0/Ho/321DhtDiS8uQAAAAP3buNYvp43LE49LXRUbHqf6aGrRkwkVppWmQtMZPIrhPlXrr9nHqwrxu32E34hq/ELcDRuKTsTp1ZnjQEGCfq+TFfOewqyNsKqVPSzNLSUlmZgBfU/N1cK3Pfq1Rdhy09GF3DcCSyWzMb1FXsrRl/JVYhLwUMPwAX+lFS5rOrXlqsAVFG1kroEbpRZby1e7+947u9uolT/O73/8/Df+9aFlFg2LHn73zHe+Y/jlj+tasbE4caxn/+FQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACAtiT6Nc03DB64n0Y1luJAnRPA1vTcLyLifRjOG6IAAAAHO8esxAUDFzaCisCCkBiDwHDmNogZAPRyIg7jDBwAwwYRN0FKALjC4KQEq8OCDgMYpdlSbTWfAQDvvFJTRwSpZOMZf1yorEVhGuslpoq7QCB6mwcFAcOwwYyt58lb3ziJIAQgN5UtBBParda00GLSIPFbc1TTjPTHnJdZeKRRLXZyziyC1QxJIuaHZS17SfgQHy1hYmwwkxI475cUYMkyZJEbHZ+oF4CARopIfAxIoFTb771KLOX2dVbc0KgTAjKHCny5rGtukgTVEhudkk39JDZQ2yyp37pZe2Opeyv028n7ezKo+eUFUko5/eY575//G/a77MmIAzIi58OfMsAAAAD8c7kjYC21/Tp0IwYcHGIvbuwXcMINuuHEWjp2RY6L8y5NRZ2Gvw25dfsMUdSVz9qxZr0EReuJX7UqVhhyCiwgEh61561QNiiz1qA2Ld2/H85fnPpy0dmkxtamG8pcnrhGEXvU++wvC17Qs2vYx+mlsOTstvx19pah3oZU8EgjfKeCoCIITvIZ7QS6zrW+548q/vOraZSgMk2OP/z9Y5bxoXiT1vVYCkNzDCvuSX8cc+779m99fDmOVn7m//5PeqskETAwaEQhEvDLjCZOYMwK9zFLg0MBiQOGHmBAUZCVmSR4GJ5FJUBoIERA7AWJMbDw5PAQYvkiDgogNNdJOaerLgfucfdmanLytLEIGtS4jwluQhQ6Oiw6DCtKxy2lxljE6uRgIFBmex6JzNqZjUvjBi3jlW5bTOzF3CMKbhM+0SN0iy3+e+OsMGAK93EX206OmVbqDXnnCCz83mt0VMLDF5mUX0LdgicRIJFcp6jllVsIBMBJQGtUQFMQXT36W5uml9+rP2mGkWFs3aKvvvebopTGp4wBE5RJps0pgNMpbFYdZzNtgj2oMv03NTbtN7H5p8/kj+RH8tc3vf/rcs////////5/4fzDLX575n/e6qd5zdzbCEagvh+jc/urIAAAAH47wYzAb22/ZxI0ngMUoZDHZyhgIdOoqlho7zhWVho4ApbA7zRNWdtttly3F+5YZzVeGHRkcqlcaVe6QYQNMolPA5sNTtXLSdUap/qUEqp6KjVkjVzLV/fvNzjSaWrRWca8qvYz+EJstVtTkci9zOpckcmzGBU1dh8tm8ZbUeARbF8KwQ9YpKTW69zWHbf17G38ZTLOfh/P/PGty67C3r9jHu8d451+5av61+u73M//O3/u7f/vHVEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkYcU8De9NwsCr6BGMYbiYNyzqN703Cs6ooUYxhev1bpAqFGPnJfNmoAKQMAmPKJVUSNPIn9O4x07SHBQMakHGMJgVKhYTXCCRI2YdMLTDsR4yUkGh5RdOgGg4YhNpMOEsiCmXreXnCTAQtp91+ECMnXw4zhAIhEYWEEoVTnsYs8V1nshacraCjFpkzhnLaegnJYMM5Dfr4WorWNMAZteoJRGkZKbOdhZhwj/2oFJiFoHSQ4L6qpWCrUtI/q81bXdCqqNUIstKCGVWkj7TRCCHsS7jBTjOlhYY9E7XnrNq/fnqCipOFQIYEXMVabL68qyv337rSskCG4LwmRkgYoDbl+LZLcFv/K5XKrP2Y7DFeISSD+zU423dYd5rP//sv/+/vf////93vfO83/cdXvwvVqYaBQ50EA+KuFCTEIeizm2AAAABqr/x15Eav6/zzRsQJJoSyJYafEhOvW1NP6EDJCmIo6NrsMuxJIpF8KexnYvUte7RWJdYf6xuMqkeSQpzMlUFjsTid+5Img3Jqht27mWMlRuahXy+1M6xq0Fi1ZifJnPFoWrdmfmIxT54Vp2nn523O2rNFTqttYZXZpv42JxbSAGjy/PLmdv9Wecr46wfrH9/v//71Jqo4LQ88N3v+nt40t/P8Oa39ZQtNSP/1sAAAADDe/Z8poCoNgIWNBUON0+DHCY8UDDoqAiwGmSIhhBqEKhixOQgBp7UaABBYVBd8SrhlKYaQVFxzDRgLGBuhwgigRkLY24F3EImXkISFQONBwMw1x2UKFqDOnJxJPIScHAIhMWmOiyK8X2eiA1KyYWRiW4iO4tqXPe+jRjECnOuymA2dTz1mpDNAl7I4nGIvOV5bGTAA8X9vCRtuBiYCZ99WZALFpZLo+oqk0zEQrY/SGbGjQWht1oXHzBhx8Ey4G5i8JEhep/LU3MXJ+VVM5ZN2FjgLNC5i9N6q48xq2H5fUCjgWTg+KDIBXz84uU578MMjUelFe7jllIYHf54JF9BONQ7/73+f8/6T//////mv/v/re8t/zmG/1jhKbXLJgMrcDGE1m7zTwF3U2pZAAAAGfdZYNrAtjjwgk7vijikEqvtLduypt1wVrszgVF8GLPbW2a2puApr9l+6KrD8Iqds4zlS48GG4IoHdn2VDM5DLIpJJfaq8n5fdsWbt63jERRMbt67f78OXso1er0nObsupatV6TCH7WUopbNfGWzD3fN2a6g0mtcuzNphEE3ajZoHz7lnjz9c/8OS2l3vv/v99//uSlLirVq2LvO17H29JFFrvOH///+1IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI9WvPI3vLdMNLWfRrOW6jnaU6jW9Nwp6n6BDcvXhAAAAAZdyxbIWDdN1LoxMJGRA1VqN9LjHoxWKGy9pCKGNE4VPSsveNBQwMUM4NTT2g1EvUyMIPxIWHjwEnxx8OPDTrKjVTaQLDxEAKOz5bXqyVRMlSCVunqUeFTBgIUI14hYbiwKMHUYIvGmiMMCwBDpe6HnRagy+An5eAEnL0c6bazO33gBjLgy6kk9K7l6dno0jNDd961UqUw73CkztjRcMSjkvdx3GMHEU06XGRW8c9XpmlS0ENmQgvUAjHBKv3OCJVLtxmfrXcrTIW/Q6hEFLcnnnx7jhTVOcgFHU5Qnz5DTnSqOZQDGWlPdNf3VJjhG5PALYrH3Jh38/1reeG//7P//7w3/6yx3n/75ywKmmKGh2dCrjdJliUP3+rUQAAAANY/jQDICfpbMAl3TBADi7y9M1MR9K9EBIC9Sv4wgEIlgYhMBmT/ZoITIWX52FSHNcDT8LNLJJU2lxsVJFal1LplcoMagHBKG5yqlorVZjkg7Kb717+ORIGCOvOcuyOrkt/C1XpdS7l2P8i1arHYJqyb+TVaNZ17UoS43I5bQJEyGkyswRACU4PenJ5hjn47wyoIvfyx+tDedSc1VrYf+sdarfTOkhrLLWFFW1jjT41tZfrn/j3ff+sFspaBNbqkEAAAADLHVSjeYGC1/AZiKBToljG0DFESiC06xHDSSYAtpNBsGQStSMLBDCQ86c0RGNVDiQWS9R7AHQipikKYGANVChSViDcQodgJHa/JTBACLQCoxDHiEJMQAxklKA8xcyFgkssPGDsqxT1VMsiPFA2cO4/WENLXirYzFzW3tsrhiWS2PmMDL+ziVqosPdq7uAgLSx+Vg4i+4Q5Fgr7MtVJRU1FRxxJFwAzs5sHqDkxOK4V4xDzom0Gy4KozUKR4XE5ZORu1dkkCYyycxjLpBCWMdmYjLMburmMmmn2CwsHWHVp2QLjn+UcRh964TrHtfuGM/hBENQJ2mnHqz53v1a+X/nCtc5v/1nnruvv8HCgDDq2X5HUgaBVptT/roAAAACCuCiLU6xmAuh+EoXk2UyqoVBCgyxajReKJCXCVAO9jDJ4KMeeSy756mIQFEbjYIRagJ7cYm3mESyZZKWtA3QLBrJO1x8vUkQtqi+1XT5kwAIkpDZJN7oatPnG4uN5tFzZro1HxXzO8Tv5pVynhcZ4hFzRYV3LQ3zShcMyLXet9tUGr+2WR4v2+MP9/6zqsUlQZe7roYFATBPaXyxTWfw2mdqDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACVRpzgN803CvihoEN1heI5mvOo1zTcJTJ2iQ/L1433KpmFDwmn1dGAkw6LmaChjdUaRGlYPGGlFUEmHFGZWV4sVlrNkS7MVQ4eWBvADDwAMOiIEg1BsRA0zygxI0tPnRoCl1xkPjwJpAYETGgBKwKokIgfRtABoAijhCwIAyDCgVJhWFjaLARHQiHmDoteh5MkxqAYdVuTMdW3K05RoM1o3jJJKIy+41C5eM2caDPxaXWnNtS2SPGZsJDUNPGTS3QMLSJhcjiwcJm6a3Za267smyTufQA4SREvtyh4oFYmNNWWkEEOSkTdseMo3HJRAE7VrP7KnjHQAOF016Y+fscrY27VilRmNAFhzNjSo38jFZrEWfCF28MqXV3UmkMafGTfqWO7c/WX8r7q4+2b7/cv5yp3uP43b3Dj1LGoADEKxQNrU5ClquRoYAAAACnudHGG5oDWBSGZoMsr8uP0IRhMN5TxllLbBDMcCmIBpWPe1MHLEsuQ/2XJOK1an0h7enO3BMOzE7L3RguLiw4WK6L3aisuvSp6r9u9T3ol2diIWTK8akas6p5Fcxq6z3zna7Q86WZhFSN95fmvypb3XOzBQpyyjrL7n3ZXH3BYu4LPYCg6Sd/LnzXOat9oI3W5zX1O/vv4Z5xkoFbwq3rzA8+9NxxSX5N0toYAAAAGW8M48MUDQpmtiNOX0OIDAQcwOIeHM9cZVMxQIzQS1IinDlKl4YJgRqYyCMtiIbGEAyVQCAQWYVAhpQthAfkMaJQUDQSCQ62sPv2YNBzOIHJhlJlVhwA50okEjCQQgsoG5hABK4epKF+YPbefEACCwcgELAVKCLx+MNyZY3ENNLgu40LHM27BRHVpqemrO9E+ZR8eW2NMZBwSATJw1HIOkCo62EERtbC9ouZ1dYkgXSKiq25VIpkqBCIU/wiQkI4oLQDurySZ2oxq1YmGjrxBxK/+r1FjzuOqOrHS5wsrl1WClR1qKNLylsjisv13uOqaloqFotv8bEDb/8/3Y/fNvPj+Pf///v/+9fh2rzUyLIuVcZUxll1X+loAAAAe+dZRJw+tbATApSv21jWXmMjIs54VnjUTVMQJgEKFRWQmOVIO2KGfWQ83ajXIXJZJZwjNSklrTrbKlQw6p68buMzH67t22D24Hwty3zExpJ+1a97bP5eLe8va4mrRcxoOGBKPQhtLOCbpvMGy+JhMkX6w6/9rz+2Pvwq6xjG///TGD3JRVgWPNFz+hQclHfbpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjObE4DfMtwqEo6BGMYXiXZpTaOc03CeazoUU09uP7lqaIHQOBE+DAhwkCjIwkkNTsg4ta/E2gjMACQ1crw5fwmJp3AFqHBBQGdcgESGgOAo4PjGATNiqxqUlaOQBALgwAB1qbkIikITBwYHQKHBKPwAgoHBt/RIeGDA+KAIoJ48R4DGQerK9qIq84opkZGCLqLYafAD0XmMx4qCn9a38Kx4+9eARZBUVeXT8XeyXYYuENHyqTUYFFeYJoBwLbusldPzjJpnbNF5mJzKbTuZVa2LzKGLsHyHBERZjwSeIQ/T5agJcOcb/K40CGRqSi7Wm7Gv1vjuWZlWUPGi91o6TUqlUjSPopa/1aVyi1V1Wi0XsPC2fdWTQjX/d1jz96xeTX9z5cw5vHX61vXf3ewQ3eJZK+IsriLphAAAAHMfz0qnlnrKqMyfxcVnscT/KoCs0uzgNsaf4HQQNYanEpiTPNl3yt08lf1Rb68jTeaxNrgvduYal7HWRutYtOVHa9DW96mJSmSSyr9+tuNl87dJ/582xDnN85Kr9XcsgP8qWkwiFLrDO5es1dRPFc1q4rNPf+pJGX0KQt7eXO+t7PPepu93uWq1y9j//hl///7/c0PBsfnh9zTCnpDxYvl9e45mSAAAABvuNzghQBkUPjQAKw6kGUK8RCo5QQw4CPg3ZuIoADiR8MigCAUOBCDQa7jdh9NkhQZDhhsBmBgWATAFSMd2GI0IWDQwVQYYACIXEDQ2kLjWSYwCIOEEWoX4IQA0wOARECTI4SFQYPFYwoYV9iwKkcSVFHU+1GhJFtTa2XqUhEIFY1KW6m7kPvGZiNqmh6CTJnmWUkvn+I3SGzUZ6l5K7j4mJDLwNPaFj88lSnRqOQ/D0Au7KAI2ZNAo6sQcqTtWmWIFyBCDe9sxlSBEJi1PjhEI+58G2qeDXGsLBIEdW43V7S5a1ZnbswIA5ngkVsuirXXqyVUrH6jw1Mak/nhbh6D6zcGpcu2Jf3+7tZf/LmDb//bFjVu5jzV2xVsIELYdeKuHSXhvFzwvKemRYAAAAFfDyiNOwxwG5CJr3k0cdFs1qV6jPQcHFhC6yMOwZ5VbAxVFsa1DHINvY3oCnlV351hUkMGT7twyv5v4TAli3/Ji+t2Wy+anpDbcvQiFNNi9qUMebTbFqrKY9Gb4uqcuUebDulc5oU2y80jwljfqzoaGMXWrwu+df+jWyatqWesVz39///73qp2GXjDXrH+Mb/z////Ln9b9yq1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJOGrNo5vTdLGrOfRnEW4lZacyDfNNwmOpaBEcPXggAAAAVcuSuQAEjGbQS0swwGQYETEgCHCodHO40Cl+MnTQLjmbDDPFD2zigWYnTGruhs5MYSHGwLQUFQUzmPRRwRKyaK5wCLHoYexPiYojBjBCMDNd+CFlF4S/IJFUvQNGCg4EE5kSESAsSRetpATKXwMADMBJnJYAYFVO/NE/8iU7NA1eyjljdXVnJeKI4TT0dmBEP5bbvzSgrqQ27IKCqdiPul5FWfJw2c4IjsEt84AFMtchkAhyYKriQVaWDhYEAm7ckCAcOKAkQv2YhcfpmLYJC/87SSiHxIdIop2/jlfvZZ2/lajhog9JXTfSjllTIqBpdQul3WN7KG5vnc0Cpdjds1L/8y7v+VOX3M1/3LsxU1W1P0m9b5ZwIlj1Oz2ShJ4CZCvqpAAAAHcPwyVRJlObxpowU6OraxruC0GjmMokk6MZEQxAgwUaUw50iJz89paVuLvX/i0olwsDGvtfcZa9NtigB5g5j6wa9UxMz9l/WT9pa5cLznEzAG7iIl102MyBCOTeYmiZkaHT6jcxPJkTSICxqsyqNkB+IgcGmeTDJCIJlMzRNw/gDaJgvENJdNpNkWczPKMCG1mJNOdZ1Ls/UR4LI+pketkUVfTXmLgZcTfLARjAJ+dSnghWoIVisRGT5PQiwTKIQ8f6JAlny82sGDS6ZqJY8DG4rdBIAMXLw8uxhYcCMfmQEWrYYwMZoEEBiYEgG7KfjkjwaDBixZ9lTBwDIQ+VAVAd9T5cUtmYvCiJxiUUio+MMgkSPxQQysBthdkmC88sKpqIx+2IIEsiQLaxC4SzZhpqUCI0duLtf2la+YgEv6EfSQpUlBevvgkXQyt9R5k4xwshZGHmUMltPTAMmbG5VKg5F4aFgKXDgxWXTc6YQebkQskdFCQsoEQVAMVa/GOMoUBZazWB7FBFAwRTy3vccuS2/2XV5Mk8JX4CkI6JKA0xYrp9tBm1O71nDVSMxarIcEPnkxobEp7l//vW71r3Ow1lhhQ4/ct9y/P7wVDTnvuwu+vCxVYqQWitgAAAAVWWRoLVnmIRhnTGsdciCsVq99WkCURhrQIe+UbAFnGw+1KH7+x2ltrwZze1Bb7VFW2HZeB/i7AQRDlG8ZrMbgY0eLZdWi3Y4YKFk1m+5YpPJ84i6X6Vs3Iy3a1ZhFT404RX8aFJ+XG/JGgXVoNNKIUuq5kac1wqf6UwunL+p4a//+v86+F8flf4+N+XZbkYDclfPV9IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACZZhzKOc03CgCgoELzJepHGjNI5vTcLTLKdRrT24YAAAAGeHzMwkqY4Dg8AzCYzIRMYbEJh97HcEGGCx1mmS8CF03eIxoBlrUfhGBTOaCMHRURh8SNot9zCwcMtGwyDSR4oo2KSAAgMKFEwWPxY0VFimAQWCgaDBuZFA7vt6WAqW1FRym0BAOYVFAVHhVCRg4VmBwI2y/aRlEHlmzDAGMchQwmCFLpc1AOOwCzuQebJywWcZE+2mkU4GVNB7Twiw/b/Rmea2itMyxu5eBtQeyBxKQLBQXKY1bnplgr6LGnILAouJz0MS6++wVGr9REHSCR6WEcpIYgaDsWu5szzpZfhGlU7U1bjtvCtWge5OS+JJ+mRCMrxIAarrMMzI4Jma0YgOvTY01urGoOlUuU4zmcL+dnX95nO9r9fkBCE8GgYE4gLKSd69fYoDCNbW2/TWMRAAAAG7iUAc3TygFjjEh/XcGiNGnLVyndYwwl8I5GmIoXEQu4NCROinXSd7DmpRSLYil2/Mu2xqHa8aZkw9bIPFx0lMbBdIAQYYBYMWUMmZuYIiOhk1pnkyykKWZjxmsou504RNFZqTKx8mC1Hk1oqcwSFlOiPmxxFCT4PcjEB1FukYLZA/cnUK0CLpdr26RkH1NnMyTGKeLVKNK3MrZFiAAAABvWNyDS5YGIj+GFAUhPMohoygbjq5BEhu3rd1EjJE8KogQDPctEqppoIOa3eGHgxKOG1Hhg5UcQOnDRhjAc7MPmUgSMhgg+CAVXpCDGmBTNQMKpJUlADS1OIKH46LyYIZSwdAoFMsDlZH6KgFFILesAgxWABoap5tp+HwcTYhFIRHDL1BEIjfJTjXUqBAuCrlGzxfbBIlL66qKzZVVyTTaOaaGmbO06TT/2LtV0mrx1D+l2BALU5dvN/pEs0WSOMQli3K4aawzrsa3Kr7+3oAr0ktR+l8AV5D3u85PL53uT6jTiilzosfqUWTKJFTxubnqurFaBbFHXet1aery9S17ff1dp+/t/pij7h/N9w//raWp975nRQZQ9hdyWV2/WYpAAAAGef5Ycc+1/JswJkDxG9zxmogDAcO5RqDXxMwPgpHQBkHVQHAlSECYYuv1JFjNmv1XDxa0xWhn27JNFgA4kTjCylcoD2GxeGJhm8YV6ruJ4UdaVEaXd2IFoOC0PU68kBbYm6XuqXcCsFinyxnVYVyDHYGOs0aA23sJrmAXWPu/bVgGaAxP0gfEmp2PEbFKNkSFrrsWLONSzZ3jwN6yZw6850gvD7dr4tv+/1rPgYX1zwQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACSZpTSN803CyyynkYzBupX2nMg5zTcKCqSgQ/E14IAAAAFWpdmGxlgvGmNGgIHhUVMQJjowA7qsRBtN3jQQgzQo5gJ2X+CxBDEwZmQZgEOGCQeYkKphkMHXhQNR8WgqtSbpgoxmDQiCCIRGp3SQAGbQOwIUFgsjn8fUiA5MEhketLV0EEMwGEiIMGHwAYGATJnxQJPotMEAgdCIQjhIGTkeiKegiAsHhmSgDKXvTPv1I28syYEY98ReKXuAgtIJuzE8o1DsForO0AY0vnoBZxBd6CbrjPxiWcpdDIBWrmeEMxQcCLRYoOjAcJkOdhePYrMZXGjU8izrUCUOTxUtH+OUllct7Yp2qJSzXXraFyHoYX1YvXr0P6xx60V/6aZaPRVqfDeGMX/86/Zfl8RuRLnf/Du+fnuz8qyz61zDks5CZs6kAAAABzn/p04Vl+o+aHG/M13WUSR+rfUgN7AyZhIUNNtkLAlDRnQL3ouRWkYHdrdWJLG5qg5UVmxScYrehlWZLgIUVrlzSpY/kcYPfL1bnpkmBZJog5TAvmzGKaRPuMco0TMEBap4+URoLokjFvSMXNS4alxRKlYxEBmQIuPTlt3KwSQxIPJPC0FVJMuKNVpObOZrUURGh5Nn3qtQTEyPzpWmDGbKXXqrTeZGamOSefIVBfHuNqUjg9NYhNJEwYJUNDLwRMTWEx8v4U1VTRlZlYXHAReHBKBFjoUGhA+bdXAcMwIJTfILMBqYDq030XQMoUnI6w0oVRk0HoNPmjqYqMYkAhwtFYol0AgoGlAqBBFMMg5R0QBIhCgsMCEUA4EIk1RIgP+/YCCCWQyATIAAhbzl0BpKShFB5QokZjQQAGsP3NSteztQy5NNyQxYSBt7TWmUQUtetVSheQwad7pZKB4S3eIzsii77wwBQOcwggba9OVJmchlwqdh4CKymrOMOkT3zVaQS+24M/rBq9G4cVzsV9x+vDu9UT9jy6elsBxarAUtgmM6no3OxentdrySzg0enpbV7L8ZTEMcctapuR7KtPSqr21y5Yw79a/xiiVT5aXQBtTZRpIIuiD+tVIBAAAt8fmaSTPvQAmHGZ67xVBrEtuaqPoThaenqFDCEqBwZ5i1fF95dIKPDjjyZZdLvdeu0qE24Phh1S9YyJNj+PBBzQW80C7SdN6Yw3M0DMGxJdRSVNECTNTZFaBbNHdkl1k8YitTzoGZu6500RFIusliXOsuTRAQXgNgmyMLSU/P1rOuaZwm6626rKUZkwykT9aJiPOdi3GKaqKmSzpEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmHaMyjfNNwmCx6BEsRbiUtoTAOcy3KjDIn0ZxFuCAAAABc3ldgghUzjQFviEyJRAwUJMw0zfMiaabLEoTIpWMPqZHlMJeo6AjNoVOQDQWDpgcWEJwMNqI2+5ThYUKoJLdrdMFiEBLIyMTQgA6WMFwSBh0YJDqQ8Bo/BYXGEwwYSNidLBDEAHBoNGiAMgEoELSWlmDwGygcAoiBwQEh4IGHgu1yAQYKlLXhYsz1+TgtRY6rc59d/YtG1BV/TL+T9CSB3nqQ0/LkF5L0uRrbuHFFq22jCQdh03INw3BUdCAj52RGGgWJ1qsQjT9Ap+7oyTMMPkfJZMTmeNRjUggJ1rV2pAl2Q0usPr2N3aWIW18pEW5Jk38toqd8ZyrDOdiQZ/nWpotbeGF8q0vP1yajeOPd4yah53KS2bff3lvlj1HZfwcEw9b2XPW1QdF3Ld/Q0AAAALKzUPCedIohbcA3ziv+LB0bGNNTqBBB4mtss+8rAD0CVVvpb1NLOYrJsQxlrCCIknfZmFOIIgQqFae/2NeMPVTvqgPo7GBiRZEyRNQHwiyz7InkhkVoPlFTJnzNSTFRQvk1JpM2itYrzOTR89Wg4kAWxJw6ZEgxhR5yp+UtVT+tdQtqClpVTBr637pV6k36n+3nder9axmhwviSnVGYXEqQxMzzFCqPkGsiKiUSwKIBjgonNDWTA17maJLgImHVZeYdChCEDYA3MlkkBy43cg49EC+oqTRolmJzYky5DS1MSYjCxAHinF19AgqDIAFTITEC2BiUEA0OJJEHGZteVsMJARixc0HCFpxe8OVTDmMhZuAkj1rswdM+GWVsoXHAEZYJFRC5DUGSiDI8hopzjC1jI2lx38jqbUMBBUmsqNl2mHwJCIPgHVMGFYVHaVZjHqZ+pkZhMQpOkchGFWr14Dbekl8C7eCHmgTVPhtV7r52b3aOBse5b3DU0JOuw0iyr+vGZl6YLjt+1t/qluWW/gT6rZ/7jWy59am3je/OW8r3NwXd1N5V4DsfaMqAaAP/dnDIKXj9x17yPqdsd39dAAAAD8v77PHFw5uoOGneBI+f86LXv8zm3sC0mGoUHcS/RLIPPFaa1BsCsBwzyaLKm7Xtav3m4tD0mHPL8S1eezBmEbiUH0iqWdrAfSBqowNQHUqrSVY6LOpmxoszNkZcSN1oEygKTOMaomCJmxkx8RitMwl40SMUg/gdOxRJ8kUEjqVOkbs6p0utat1d01kcONUm+s3T9SLdc71fV6kfOvY1IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJXGrMg5zLcJWKSgQ3L16mQcsyDvMNwlOoKBDcvXreGFuIEI7MXgJl4kNCoEWhGTRwdfXZgsBJawIu0y+aTWItefIsmIAkZgJZ4jYCAJmJQCZVEoVXJqBBGl0ARC1bkwMHEeFxhFRqGJmsSMHEAQgwwkfkBS92tmKRWHAEKgcaHkvMLAoMCYCBpg0Kg4IwSnchxUgwmUrcMEiUMDTd25gY6DyqG4TT6Ax8qwwNGojgyN0i6bVoOwd2+RDU9XbcUD10U8MJiw8l7RYdKwnxod00RU91YWZm460F+nWjD8walqNepACAUKipxxNwYTljZbBEVKKuN/4+sJPXOb+J/V+7Kq0CuklfL2fM7XtDFS+wBT8EWKkF0Ni13kS3qCIV+H4/3d/9d5y79NrGkt9mq+MdlVSnt63YvZOsFwscBhwNDhC2hy13KEF9mPQAAAACu4QA3pTEnAbTiAitrnYKYFhhqpGiR+4noICIYQBlY1rD84rC87/YLi7x4/i5dC3RqWLIMoZeIVURyiqSAfbOLr62VuczZagOm9Wxl91PrX3nz69t4p4Eioi4vbNa/OqHtesOfz+NdVAlnkVjdWq7x9ZxG1/5M//Gv//rPazitEnxr+CHJNuKvKoh5V72nKzzaPzyzxGRJMEQQoDAkDmRmHgEmFQ/nI4gAoK15IdIDMuKc0iFm1ctU4cEjGM4OhRsDIEwMEjG46MHB05EyjWxtBwkVyy4qmEwOFDCY4YenvSGFRwYgHBi8SjQVmnRMHCsOGRi0oqwp+FUEoQjQwGRepW05Q0rDa327o0VjBQDMIAJ/y7bO5lGVtn0boaOvywJWiXR1OKwDAvnWvT8uQct7lbBmKBAc+iRoFdfO+7yx4Ezj1Z/KGUN/fqioY5RS+EyZkZboNq2kaTjSbldK/sJkElcqLu72YpMmAMlwq3ZnHLeG7ssjU5XRyfF+HZkU6+92BYzcwnpbSXL+sLMUxbpPZ43su/jVv//6lWGOfMKneWO0sNSGZs34JkmN3DUYy33/1rf443eh9Zh5Fr0v1KXugMOakAAAAAp9QHwSOtIHQG8wi/j7cFw/l8vTnOMhfzBgYW/6g5FvA/OUsocjPDkmi8ou51WkxJDpA1xaMYcRLQ8ma63DolnQ/lW/hWzfEegSebVd3i9Wbr8dcf2rR7q6zhRa3NXXlzfeW/WFxhsnzmOnRaHFgU8282394nm+vu19/P///1+3rHiS7SDAk+8cdZZnN1Ycjw4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACTNyTIN8w3Ctq7nUUy9uIwWtNo3zDdJsqaeRTD14138dlhdCwRDIgIUZAgZMAjT73QQg7yUbODLpnMaCJbkFAkCxQwZjDCAWBxnBgIMwEURHorUxt8eF72qOuIC6YzCZiULoU1xgIp/mIiIZaBqu2BP8YIOhAODEwWIgm/BhcFGFweYCEowHkfi6L7BgkSxTnuQMYRB5QZQUBE1GhSolHabCu9kDZ4mp6tFGbVSRlttpHlSFY7k1EVwOyUKpur8hTixe1MI/Sv6SzAz+NlcS7XVK38qkFu+yhfBcdpCsyRycdNJaK89bvYtNlGMB02UnGh1/5S03O5/uJWq0AtcnKWfopHS1HLpYzT4UDq8tVqv2PfDLPVnPvN87z/+7y5nq/zHHWotZ7hru5zWP5f/3/5f1l3X1onDrQsl5KVCm0m8yfWS9dAAAAAquoJihiqoGwAFQA6iQQvcwf5MOx21DpbUOMay4y/n3lB1DQxurPv4kj87SJSMaiVFcyScbqX/fjMv070+3Zdkvill0FkRKJiyE5HcIOKsOYwJjVNWrNlCpPJE7NFl94blLaXZdYurLdbP93co65zAhOo/yiHFJB+uKSJizyzX8OW7353rcG28W99///X59UtD+K+NeXFNY3v7v9wt1z8/+FYXtAx+aTD3qIAAAAH4fyuMHKlrQBEHRooRzOfE7YoV64KmUTMVPUiojVl4ssSIM8xs08CgEAxYMApPGCS0afMZo4RNxTGhJYG4QMTCQAatAK3QIFzC6BKDkyCXvwYJEwNAJjUJKMS4eDgYDTCAaCBewWDG7KZkwEEQDftRoqA5JmXlUEObL2MurGGYq4ljMXNrWLXUv3Ewq6ur1kdimgWBmGUtMuuecqLSWJvlC5vF9IIf+VQDrGRSexWgxrNKosGIeFsiIUSooaz43bU9DeMbmqegvOVd7vczhrfK83YxrObhQVY+/9bu3aisM1bFPXo5/WWeVa9/L2X/9B3X/+v/et2t8//s8z7utIcblkAgMgPAAXW0kTnykd2347f3hJNASAAATS4TCFJNBTBPQsutrHOXlJ7+7N1jSA2VIJHfiKWgFbPRO/SwMya5Zwiyoof7dxe+MJYSe4TFcl7VctDYumVPoUlTfAvuKuV338uEAm7JbWN1t6a1Ew16pjLumc6owe+X2viHWmIHrGdZpFZn47g35mc6WnLV/AtqXO6fEkX7/+////Iq8a1nP1iBk64jQFCic+lJndndyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkxb00DnMNwniop9FMQXiauHTSOcw3KTqjn0SyteM8dWaYCA0wEA2olo0OYGBxjiUnLAaoKr52k6zAYPNjAFmTG3ECodBtVMUlMEAIdBhkIVAkMnEQaZ3NIhAzI4QVCSYjKBjkWwUxxpQFHYsKTR4xhx02QiMemFAMYMHrL4kj2NCYLAYwSHxYKwMucKgRYxgoHaZkPAwoFxUBCObkW2MqENdUgRDpU34zWj8j0gFi0MUVu6taezgi84jM6kqeKWshkGEAUsOapblZ1ocW1Ykkczn78QcJYy9Q6sOL6f5XstqxOXvSulp8ORSXu7ALYptcOG8saXHPOpK6t7lhrdeLzr6yFmTj5wBR2XCg61S77Uwtflhupew53OIcy7/0/e61nO8//7f1+fJjufbWVXn3frWQIAgq8AofCueJIF/XaLF6LCFAAAAAQS4aMVFqSLoBrYfvA1nC6kugdvKVcWQt9y2tq7mEMQM5/6DttKVEixP44BQcQx5dHQuymterJrv9KUQCKHiHpDUEtTLQlxKjtJc1dyZLrCwMyk1nmK62dp0+1jE3SnmLZ9FNHQpompTyZNU54okMJwEe5HlEk5iutBEmLGqaCiu69T1VvQmDMiXzEuA+CQsnKlnN20M+eYqnlGAAAABvKtdiQWDw0SX7BwFRVJhgFiiLjGOUbSI4NLk04A17qyp1DAdMlKk6uJxQGGBQ+YGHYJP5g0anARQW7m3hEJpBpIFB412LL2HhgYDKRq0UQh0ZMYUDhgoeGPSFJGZonGFg6YEDIGIyUDqslJgIjOWrjNti4QKi8wsBJTXS3WFdgvWZDuUvWLXXdk8sLvQ/XjNrieF7kctQ206vEnRkKUlmjhqQQmvT3KWUTK04drOvdpMKu1ZXIEg1mFNJT0gmWXKahZg1+vlUuShbUchupyUQXO/2rBl2E91jDl2T1qaAFM7kaxgys0t+aLHCtN1v+vexx5v/lEZ5u9qrPfc/CZ7+//HL8tbpu/37s1cpcrcpoN28c7uGeu8///88O97znP///v//85zvdYc33vO39Lo3/KwCAAAFeIkarueCeC2Vvee14qWb12so4jRRKmSursPIxLOWMtW2tXdHm8adqV+fclusvWF7mtBur5N8QpsIbCIIRcaAEj+QBJZ2mgeAP7vMdzZQbwsfljGnvZI8zErc1dLvOXCTXK7DwVgPkTUuIaTS5lMpVqnKuVUuan+eZ7hrb2Ueelj83ajKPYEU2dk9s3///+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJi23Mo3zLcpZqKfQ3D14ldh80jm8N2rwpJ1GcvXggAAAAaz5XhgAkBFIK6BIch8FhkyoPPGIWCkQc15Mcx7LgywFYBhxS4QCg0lDzupEVhMCCUyiCiBRmRSGZpCBgECp5t1MHBsyWFDKw/d1FtgRhUqGAkgZ3AJb1lKtxgkigAwGVAmTBmhDAYIB+VBCAj+XpgVHRDVaYKGlJDaFA0L5IDAK8+UMtsQBByAhYiiAacpGRW3aIiaerFcoKVh3OwRad6B+1WnTi56e6xt3oTS09aV5S5TCkuspgais2c1krLOUOB+rCrYdevMX8mfODRVq196FKos0KflcPxOHJDLpXTNZZpRWrdNqL0dNDi2XZlmb2yhrMWosKuG5Zju7zDPePOTVjes/gzDOrv7WX/zd7WHfs75+Hbsr1XvbnlCLoj7MTGLWV/zL+RGuA191jf42AAAAF3aIY/uYBZIlZ453B0pNyx/aylA2WVTZEF71dImxC7yJsBgTOx8ApvojVu5LWh9e2dZdqh7sJEpZXIhoMJSTNwvnJJQvql16CWDG6+JvMW9q+SBveKeNnesMF/hw+dYbGDcn6/XWc9tSYRDpsUznSL9bgr+Ma+Y0BZ/x//6X1/Clt6ayuwcQcXWEa3OW5ha5fR6yAAAABVuf2WmARGPFR/hUEs8BQvMgUwCDFMxPNEl6zYP4HlrbvS6gXBDba8r+wUSoHGAnRjzecxRF8mCUckSEB1eBp5w5Q10Qhpk18ZyMOi2Zoa0DC0wyUHct+lCgqBAEjMdDSgIi7hJTkASYaEsFhsFBwYVg0DUtY9KXCXcMMLnBRb8pKyWalNiq33IxLsJpWOXdw5KYHrStxdMQ3uQrgpbWd+hfrNYed20avPbrvo1xfIZKqyNxV11qTHsEtPuuzP3aWLVpU1zGOS2+9cCZwQ7spgGd5Yt9r2qj9PBbg7tl941RVN5W6nzGGNirTYb/93beHfrSu3rvd58/mH0/cf5vP+9mdXss8d473yrvvf/mGPc/x3/OZ/3/////7hzWP87j+/x7hu52ojLGAAAAN7xz3BUH959QhlSSl+U9dFTyuCzlYqiMYaxTHR9NkWAR4YabpqlqUNxW7hB2mxMxpb2WDBHDdr5crXAMmAABN06rjEsXB4WQQxyPhU7vHVhdEsM6aNFao8nKpkhue7J77aNOUbUt+573h/a2LYZYy535YMe+dxRgARdIpJR3PWNZgPXG3xE8cx95v/81h+DvMSNa0DUKJ4azSnDDDAfY9wYTd6N2Lav///r1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACTqHzQOcw3KmK8nkZw9uJQYbNo5yTcp4KKfRnT143+OTwhUx0DZi6jtq3mQaIcBLIXATVk+SEBGCeEYgDqdTLI5iZyURtECPYx8yENzBAkOdKoWQi02KPoIwKZtFYCRivVmOKKDEyCZDEQHeZgjlDoSDgGXGeJ2WDGAxaAg4RASOyBmZgEDAATIMu3tClBoFBEhAULjcqTPMr3HLMVk73Pf+W5xxVOq7VzPNvZ+5c+cbWntOfts+G3njdarR6hmnn2aU0sh2vOb+CHNWmryRxmPONynuWYnJ5+XV8OxTbZVe0jYMspBIZcsiUe8OVvGx+Hxt8aWXQFFuPTG7P7wr1srfK9rOtnr9dmc8cKTcE28c98mf/+43t8/uM53uE7Wz7r6XL+b+plh+X2t/vPPLf//933//WGPN61h3v63z99xyt+PyfqsAAAAY63h9yD+7qyQkbAYlPev5ikSmGWOdhjQ2VpLTBxThrACwrOt3YHRHprOmeChGp5X7CnTK3DsSmAFF7DN4C49bvrbbLYoG45PvlulIZjn8Q1yz162sGm6ex/5Yuq9Yg+G4Ym17Rs//bvCkxmFHiQc2R45gEONHkkjXxfDZuNvdNYinJXz+T007/3i2tXpHxT5x76//3j6/xfETH+5KnZLbnfMkAAAADeGdSAwsUw4jrgUKgYwIBzApEPxi1AcvWCQQBBiJGjQS/zYlfiIVGKl0ZFBBgMBigFMPgkEooxOMTNQCQXYLogCZjMGmBBHHGsuySjswecTBgEhqWN4W6MXDQaFdeViQMEiCYhByY8MSt7jAgDAwOEAIlrPy14YFS2y/xUSmYBgoAKAsZBtmWQ1MYpGpl8ig5JFhgFqYBkJArpyGj0mTpEHFazcjTbZy8QQ4M0xYHILxLXNB3jMAXQulAmiIOUjWQMdSiIqQODhOjWFxnBXCTZItFoTwZ5szGrl8nUhfkgYDlmhDi6imWDxSNDMzUxiboOW186yklrOlt2Us86kGl51lyo3pm5PIpJLdLWcnWR6Cdu+p/d0lM6kklJMtSaCmWdQuYWbAAAAGs/32AIV3m6AZjDVGMk+2pQUKZ7eNAn+PFWcQ8xqGDADJbYv3aBVdK7Ceygp+1aLn8iShrTsMnVVticvUjPMpEA3WoM6Y/J8Qe8NHhqnV6STbwX2Oxb/rqFnDO+3WDh9PqXWcfGKaT++83N/DVSmA9RtTNtMf4j0m1iBf2UOtxvn7xG+/5L6z/eKWGEsklbyGRY8l9nv+7//+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkuhk0DvHtwoGvJ9FMNbiXaFzQOcw3KVqbn0T09eP13cPA4FQgY4ipTGFIGJCBANMhYK06JaTAQ1CkjdYGUFbZUjKThIVBw8S+MDA4xOIjDoyOO2MxMC30TXgoEicwmeAoGqZWJ4xUemBCkYkA63ZWvAEDMyeUigkNLbkGAIwqCRgHgYJyZ0VklAXMLAgcAL8xEVAgqBy5Cfr6QHCFUG4+IIlxyjXLyzfavUSne6qH3ddwLpIxKUNOg7HjHLaj3BuQC4vSMxi7JZuZ9ZJlFM4BZq3FxOl4odMBNVPBaZGw4dqUozy2Gm1o2LEMw3Y7G27sy0ngq1Ttyts9pAje8WIuMxIdcUjbzP9/LbuHWHY9rzbj1d11CvVotW+W1y+nCkm/nEaFC+lVP7fE2sW14uaV3iu//7a+fSNTGfneLX8GALCXYTYAgAACl8OoSTLSOghbgvNJB73SVxW7K9nE2XoW3V9W1KCRD2T2GrBItvatH+y3rj5d4xtyGT720J06ygD5Vo9dft/uR51JyW0tkCopkqBSoporPIoiAHzBlLHefu47DVaZSj6gtEoW9Zg7nFJqkiZlYsFuTUDz1ImKb1n3TPDcmZPVWUno1Im6SCTtq/0mWq11PTzkPDnusVclb1f///4rrmV16iQYCQOYukpKwqCDK5OPxkYIG+K0REAzKlZM1gpfsAKAAkamgHWY1DpeQwaIhYUmEyqZENxkECvkyp2R0wmUweYsC6/WwQOYODxissvBDbsIcioDDGQmFgqx+uWAsYOABhsJg0AsWqtxMDBow8AR4Yz8jhAOEYkFE6JfmnuSIihUYAlPYwRV7uZV44p1LpLuzgnpjzP5DBe84Kxce5IY5jrliV12hVmeRyKyDki1MOLGZKTDf5yIHs4T3IAkW7shp3Qmp6PvtTNYkWUTadCXCl1Ng+mXyv+4ZS2pLa85ZkffqTtPT2b83Xxpu7539/qUfXptcdvest2MMc/+pRZ978ftV43O/nf3N/rPmdvLL+/T4//633//PLLWv7l+89at/ze7usrFXXbbLR2LAAAAATXqDUls6iHgGbDyMCfhUKhIoE4Y4UqBanErXara3Zx203e+Log2N4cdtM6AM+YOQ4DXrd1dDTWLKdIyjG+YkXhjHSpGfXtGbFuIWTnnLXXVnObdPhDNw99rc89YwkM+SH/vOc6e/U2o1NuTnMCIdQ7N3/1uBfWq3x38KDrXp9f/Xku4PjAfR3i+qost7Fey8mXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJQYLNA3vDcrYsGdRjL24l3hs0jnMN2pywZ5GctbjHX7shgELAjN2MtVJQ4AGZwaAAgdYJ1AaDGWQwQLsuVTjYMCjbP4Whi7IBFjPAowmZNJcRaOfRNuCAIqnEggGZ0fE+WwARYDRNgjgOCzMSQzPkEMOGSMMLyFuknC2in3XTeGQoIJQwTbemkBiIy19r8gdNRtBdh6M4gTGEGoRA2VafX5Adar2OKU2ZdVzlzfV9Q7bazFLNjOvyIU/YTx05dPw9GMsHLh2aWyo5E3mcGajneyPKVPvKYDjNSRMhnIAtQzKo+7rd2WxCNy6K4VbuNPUlVHIHvjFt+Lk1emKaZpqvaXD8svn/7/dd5jUwgtvs7f6lFnDDnLWNWznlJsorVxrWeZa5b3dwx1Yx53+ZZZWu65f538/3r94frLL89cxzqg6JQOYY/VAAAAA5v8sXfp9dwgMUAD8xSf5HpYPA5W7sbHHVqRx5wU0KghKyjEgkWMOExjmW5BUICUaGm4UdhE5NKBcJhTOJIHkpLUZDHYOl7XqN6U8n6vz8FrhHUxN6LnpLE9dL+2XHweeta3I5Wox9HwqRn393KC76uxZmZN1httxIhYYiskz85tAnh605VhV247zEgbk9bf414mdSUljV3X4/+/f1//+9enxF3X4zOJ3hnTNgsMf///9C0AAAABjveo6MBMtBK2sPSiIaN1JpgRMPGQAqFAs0OKjBYCb1NZaJgEMGkWiYLARMHRgYigvMDwk1mLh47veLCZrQ6VQciRJFbtNLMSgQaP40PJK40AmAgIPAQmEEVlZhcCmFw0psNAF3W7uiIRCXNSSl9tBkwiEnbTOoJmBUFo4lcwL14xDO/nYB09VL9hsC9rXaWy6kX/Fs/FOnbjM9ypEJZan7uDSG1qvDd3HL1mheEmY+t+UyPGpEKDLOWTDXa8uj71N+s61S2YKkTFZ3VaWXbmM66kZld6Q2L9uCssrUouxKXbpcX6vd/Cpllvepjtm18ocSj3nVj7raz1r52xvVjC3Kq1rGrvH//Vqrz+fnlvuW88sv/mOtc//3/47z/WfML36zwoctdwyu0q4NUAAAACtz9bZi2+v5fMTJg9ib/QBaprOOUdRuvPunsl2lSNkKW8c3OAi8TZqaQ+ne9Tf18Oshxheom14QALXahFb0EbtuZ+CpJyvYWxJCclBIQxRSWzMoOQjdZPGUylR/TrJ0S1tNU5WkitFZNWsyN2OkQLM+ZHTdSjqWg5fSzZJ3XcybspJlGbKPMjcwd1KRZezupVTsvMHWkyiQdqz75S4O1////VqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACaWCTIOcw3KdrGnkUw1uJoIXMg5zDcpBMyfRjDW6uZaqx5AATByEOtDQiAJnTzjXkbVXr2pWmtAmCgK2jdUHDDadO6n4ML4kOCUGmjQMILGaODwkAnpGgMh0MIBYzAADFIIU4Q3boZMKxi8DGIAStdrSixgIikgCAwFhcMmEhuYgCgoBTAAJSafhwzFIIZ2GBilZwIhUNEFyV8QmARHNzYYLkOzQiSr2X8VQVW7VnpQn5A2prGo5VS3XhzJkcKzpMo1Hr+NA1OZT3vZy+LVZdb3TN2V2zCIxijh6khnDtl94KZ3Kb0bYaw9ynylkvon7W5Fpmji2G/uQHDzy0diWUj0LpfSxceiSw7W/scqfzn16HvMqlj9aybpCcvuYujP2995BNJXrZ1JDK/3lupjZ7jqrbvaxwprnear95y/vKxvm+fn/8/mesP53DGp4B24dK382ABAAAtqE2CjLSWRgD8wk6RKfUMF5/eWcMERW8fVxAVQdELpc2VObmhMeZqOVrairzLj3h1p0Wg/WKNMaakknD8jbFLJRFbjpuZe7OoE9zVJEHtI1dl5DNbJGJfrRUSDrSHioP1JNJ1o0bkggylMpNRxIQyCTH3OnOmZpOtSJmbVqQJiN7rXlqZ1BBqKbLqStqv038p6nHxvMT+LKgPLPDOIF0iIsyJkLqgUGGDKadUDwQBUkKo4ADOJeMKA50YijIYGaZvQuCwAJgAFwMZiDgWmoaSCsSMOa4n+Znb5iQDGMAUrY08cARiFeGMAMECdTSo5JkEvM4Ig046qBgAKmGAkCgKYDByTcqGAyDiJLSoAYku4taJB2gQxvrbIRw/KxUrT2ApX17k/k6TBopq9k4+VexrrKcLVp277LLeE1Yonqu4XICmlALuMMxuxZvYYR8mEy2VxqkxikD3scaVRx+6B0KVwI1G7sjuwwXlpoHl13K9Uz0877Td2VxSVKoOvD89gyuG7FJWmqWj3+vg/HD/uSGpr9u3Obxxybt+ePM2hTGWXZJavZd5vuWNrHHeGGfN853LPtXn8523//z+/++77zufK+rG8cMsOZbuB9sYjsGAAAABd7/6W1FuZZR0tsJjtfq+HCn8v9sSu6KPP225VdA8/+5glI/MVyo67xsvhqn3uN1Zje1XKrQezmeoNPljI8qpQO7hbUmNSCcJIbj22qEteuTD9mm6djaJ+lmtdankm06mcTUpZJkiUVqSZrMth/WpalE9VVRLtbbWpE3Wg1i2rUv0Ptzp/zJDac9ZsqoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACUiGzQOcw3KqbMnUaw1uJoIbMo5zDcqvMadRrLW63hus8JgUmixBrQVfSLMUoE80AgcAWUspBhGNkEEwMC0W5Yx4wsETkAhCBgFAGYDA4GCpkpCm4AmHAF1GmDoBMwGcxaBQYKUVWYBcKmXVCNC0VCCc8fQkGLhKHAhBSbdsoIQCOCWKOrXoHog4Yw0KAiajwOAziu0siYlpMFqcOl7K0gLsYbr14ACD4/+DGZfzPDNhFTeLvSiB8rPPjrl1PuwiXrXoqaCJ+OUd2at6QkTdubqRB/J/lfmalU7S34zDbOrfX99vkUsc6K7DMv5y/DkES7Kds5suv1rs3ALaY1u2I9If3ldpt91jnLf3U06MspdV8HplmrViVwdP46xrU3bm8Ku+a3lzu8944Z97+dT97+f//5/N//6x/8d4bx1vLPGzres/tbcnYAQAAH9/8Wtw/3LOoZKYLi5Pqs9KLKn72ttkF3S5xmUIRF9iMb5zNHQlx16uNfvSQBEg9mtjdOxK4/tSDVSEIKypIvyfk01V1HhYlnPNaBKFxjMBtk8zayisKBS1ycUXeiaaxsRICNSdaMwNEh4U3N0zZA45qJkXDUyMkHruZMS7nNzVloJoLUm09pmqFjzSpNq5qrmH2fYxKaLISsoNXJ+9Z52qf/7t3/00AAAADPPuD/mHBqQgGGGjwCmka+RJ8AGpsLBsEEgMeVNo8OHCdGKEheM0EUBABHFYcMPxixvHJgoHAomBSYrDzB4tAzLHkeq9lgVFJqIoAoNGDgC7TpBcOBw6viwDd4dBZhIEkxBDA4VQxWYSYPAAYNIMAwDfxhCdj2yNHOWxYAwaZSF6nigwGjtbnad6C/lP21QszgTfKuUgkGsYzbYbe7UldeGKW49c3HY5M4Vo3Qz8/NVFZBZDydidPQSK93uM6lhDTry+U12aSyxYn5YJDpd18d8zxlT2tjna9aE3E1X6ikXtzUAxi3Z+gx/H94d/9/O9xv6qsx7/O0ra58zxlzn7w+3Wwx3nzXNY3d3LHM9ao9fnvLDuXc6vfx/tnv872/+sNZW91N27tLUuYZ42tscxs2gAAAAMMv/NxWbbyvzglLIx0jlvVkERD9dxqM8GinnkdGUWkJY+XIKsalJfmcZpekMGCQdtm+7zM5607W5hliNzurvwoIcnZmNcf9W/DmaChzmtEAqFhlrTMgu5rZbDAJprMBwKuSah5PTTq0loENlKTJpvOGRmdLDBFRefoIpmUwnTA/qKy4mpCf6kzZk0EVkVJb5s7rdS/dLSTNXpVjheyllDDtLLfv9v//QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAllhcyDnMNynKzJ5GctbiRyGTaOcw3arLAnUZw1uNb1QraMBGYHBSYf18gaBzTugO1BNQRo6PAVOpkheJpoQuUjiY3QI1izDoUDgeKAIMQRjkCnUgSiOrfGyQPhZbGTRAnw3WqVCmZ1LDRA4lQG2FVhkgDGAAGiNSDIdDgENEdHEDAh/UywqBBIUqNrYm17DoFShh1Oj7RC1Fl/wcVRO2FiZY224P0XF3zHkAp4fjnDscfL9OvfapV3VpKSV0VJOSjCBLHG4XcaDl+fZ1E4ZpY/ncjtm9VlbS01pvClj8DPzGcJuUo9rmfqcq1rcXu2Ziilti5RX34LrPnQ9xf9s8xPWrlymx/9UmX4Y/JJ/ncsJp57vN6fa1awwnYAyr7xmLvMt3bHeat4394b5aq81l/MsO5YZY/3LP+/+X75nzLP8tfjla3vlTPb2tMAAAADL/+4lJR7y1MmJCP1W6myQZQnK3nokCg6ZpVlioJgGDZUCXLkqLww+xWpjKmWw3QY+3CLYPl82oUtJvGYwt4oYikqk3yBU1rGygZmpbUG+aHdR1g5tU8gPFnUxePJrMlkjWt/W6zF6aaaDnGKyYx9j9LUkZlE2atFB1WMx4+i+5uZo2SQKi8my013ff6vOJ2zjr1J+icfFfoIAAAAGsuZTo8PyYexuVRZUppaAG7gDK6FM9SwxwdxYL3cqUwcpzVISLPIQGBwkYsERi8ZAcwl2kgFrCgbGTQFBQw1RRg6tpoYkpUAoFsuZsOEIxCMSoD5E7JUB5hAKK0kQBkrRmqmBwCpFDm5NIw0KChkjW4RDij4Zd/3ReiE0Kw9j+5waTKo561OyR8v7nFM5zHlByV5d+U0EK3WuNRguAa/H2nK+NmxLKdIO1OUFyg7hTXLkmkcYh2mg5u76z8prs8ZNFK1uclF+jsXb8PTmHaWXwPNyCtK9s8dm1WyworPNfr72/wxrZ/zvXonseY/Bf81rUX3lrPDPf75ljj3utVufrdzHf7y7jhhhrfcP//w7/P7r/7dvbz/fa+ubwub+uRggAAAAb//xUHor/MaALrkd1fKyVVDS4zLsrjKhpOcNOaGCZGH+fmbsypM112g525h5mZwLhToupR2pBm+KzXqWaoZK5mkcyxIaR6koJym84S4yj5msRDHKLnFhykGdM4bvTNR8QrHiona61M6aSyQego8uxuXAcp5bGyZ+kZGp1IxWzG5mg6CigYrVntbCeIqSOuXnPXZCuyrfarn7PIg9xVykqp+nT//69/SAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJUoXNA5zDcp/MeeRTK24izg02jnMN2n+wZ5GcLbjfN1HrMFE8oBrjTL6joaMpyI4cBkWmwMqEQqM8gpjkblLPjARRMKjJlQMCAAC5kQzmyfacoHIYBm6svjhrACmCgwlUoHQDoHNnjYKiZl8TQvKgEMxiwrADgveiKYAAZg4Go2JkQh0mCMdL8UjuFqxYAEwAWLJpwRxbpF2ZPkyJ/U2JXTW5azUSRjTWZU9Tn6u8gmJTn5Zy9uNFrsNtyo96uROIPhUvVYzPZ5xyZL7olSeaoKSHs/rTF1Y1WfnHQoV1QM9tCyNGyKQuX7lc5X7fzdBxaWzniy9esBxmpBrfslhqYp8Zfyj/+91j+v1Nd7zP3+52xhUeTm8e3ZRlhy3Xy5clkaqay//5rueX5c5vm8O6z5l/6x/nP33+fvetWc8rFreWP1cbUx986AEAAAyWmF0R7Z0jEJHQdXKh3BuwQ9OZdxZmRC14ZZAr8QYI1Sa/KWxgYJkEC1LeoLgHu6VhLEIL/CkgdvlQMHxyf2TPve1fVjnZvliORGFmJl38aThvOu95DXfZIZGXuTrlav5ZQ75h658822BgNFbGmjvg+x98E+2Tws09cOk7vppdU8oD69szCy/fHf9zXf7u70q64NOtlcp0f//9SCAAAABjh/3FHnMq0E+0wxqihcMpxRV/EaiImA4AMUgFW4BBwFAFDELhsAAMy2GzYFlAQ7DgY+78I2m2QyYIGbUWMNIMBlcz2DwCEXgWOvswEQiYIoD3uhtaxeAYAapVdzsdLtu0u+/XKoNDAe/jUpVsUSLH6r3ibq2JFlUwmnnabbr8qNyz3z30dm92tPUDcLf1aeDubywh+WuXzdDOU/NS+ssKwSpcsSzLeHLcdk97WLfs8p52v1lkM1r+V+WztT/ux6Q47yyXTX7laibBH5tY40svy1z+/3W98uWM+63E5bhzdWjxz5elEO45YVa9ruqS/ljh+/1vmXP53mXM92dZ8/fP13//+f/Na/m/w1hq5mwqIO67TABAAA/H93BwafyxpXSGnSN6Q3NRNBSesZWSqdFimnFUkJBxCwW1jWhkaCuatncmGCPt3kpgl33ox7Fy5TP3sZTCrKxqGLZ4VnzoZP2gpG9CqG04t1yXgin92aT9qkPXJo1b2Pr7kuOD5bzkP5l5UDtirHrX3ZFlzb1orpp+pn6b9wf5YwivnuDJsfzF///vdfG8m1AR1AhcsPwx/3f/+sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACXmFzSOcw3KqbEnUay1uJUoNNA5zDcprr6eRrC24IAAAAG8t9koXGa0GSteUCBgnNb103wHxoFKCw+XXN4Dxp0NOin8YNNw0TS+44DQKFhQTGMuUDk8EB1Q6jMEi81oLhGOFB1VXNJSuaAPBggANuuJQccNxiUFmCAQ1aOtCARHEIPHg8lTAzKDDwOfNBamlyrAULoBXVA0YKgRL0NPJiloMmdTVJOV1Aojfv6epLmv3O2zJV3d5XpY79q72GYbwu8ynYSyzGlfGho+08hp2RFDbOfLEr/PUEQyzqHbMbZ5GIjNw9dglO5kkis0kpitTHPtO7croKKZh5WOtl2GX9by1zGvFe81zO1Z3/a9LzPGpKL+sOxOHrefKtBO/U3Xjd/Xe378v3l38sMM8eZZ5b/meeHa+uc1z+fr/3zDmvxzz5vC39/e+2bmKWz5usAAAADXP1ijnJrWNLDxk7Ac6jNalUXLANvHCbIS3ch2fT2LamJSojKrVhbUZXbvU7QKBtJxpJxYNgz40luEDSqqqoVlZULMc4E5lcpqtJph9FsotWgONqLsQxjG70iEXlXdty7Jx+6XWtE1GWmYlI+cqcuHAIEsxMmRVUtzRJpwljegpI6eQ3QTU9IlkUHWw8nQrNjyt1t3S6zNFtSCLaZu2pTUPSn///7q9c+6+BhQWIWKRa8jMMEcyd1QqMWHM5UzMPFoQm0wKBxYJtcUfMbmsz8DkTi1TTzJQCMS9Q4AGi76sig5hgBGBBcIg6tBhSW4WAYqrzAYBdlr7pFCDDmuCgW5a81MDAwTAoPZ9SNQWCMBARKBCBtI6PAowsBZlekEzctB7G4MvhKq40lvflkrQRuQvC9TwGy+DuW6BeZWOe7j2N2Gky3uNaGb2dSZqvs792tdkVrHKDJtoimtBk+NW7ayoNzqbtHSVHbkT0WITJovBCZuM/Zkd7Hvzk9P35j4cm6GckMMQLp66vM4zrD+7/Hn8pM8u17sNWd1dzc1lly2+8VsTt7OWX+d79JdoJ+3rf2+c1+f77rfN59/WX/+9a/n/3muf/O7zy7nbwMICLTEt6YAAAAG+f+adMX/92TCThIBT2uFU5OKQUmNtoD+y2eXwGWHhEX9ZyZfC01grfdumoE6VzDiaK1IC/dAjmyGiq0umtSqS91AEB5SHGiAJlGcCwhX7c+8u6aVpTGmSm8ZnI91//U8EJcHEiXd08gSOfk2Y2eE2uOcsnqny97+Jg/8yUrMcsqaspje/ts1XMf+395AHVlyNbhpRVStYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAb4a84De3tw3E1p1G9vbhp5rzoNbk3DarVnUa29uv//4EFa1aPV0qARwTiJU6nq70CJkOFGnyypZWZItjSygwjNKjDhAwkkE2hOJ+UbDAhgsDY0O0O2NAgSM3THdxnmiAAPTeYJTsJXs1lF8aA4Da2jOw9jjQoaj6/R0AfB4cDPNgAjXZpTC6qy0CqLcmBEzQliLWN8D8RzVvMBKZNiuP2ObPex4cmZFdI8nuxzTtUaHFrDi1sw3T+6P4GDrq3q6CwK66kd1rPSsesOLSDFsZHvbyPIcCN9bza/+t6/14l81zVVbp7sdt4kbFTWuvnVdaYNvUdK26j36X14ZclAAgAAf3/xMFE0rZ7LZIEHUM4Z/rMp3oEDob6CQ5A1LDZijSPJCHAdABADlBmLOwu0KXTitingARhxJGb7oDgYZimPVdi0EGEDoGEm7S9sL3hAGkUwfB/UG0Z2ISmaqosMAjUO4GyPoQ9xR0yBU26VXa0uELiwjoWa7zSY4tV+I3UVsft8XOYu45w23Bjset5rOEXttbYcu/a+GOfs9cKeZ6norYzbbJ9QK699b+qxLtl861aBem9697fH1f//PjfP8K3+b23jGHtf/f6/eYh1lHlRSvTm62ygM1kqf/9XTCB4ff6MuSDQQRaDSyvY3BQVBjPAaav2noICgMKXeRMd0Ehpk9+bEDv9OJPAkAMwFA4jrxSPK3g7VTxmoyzwRDZQKKhzaMKhqctOrWm4774Iox7ky3d40cdfgQw2AuxFDY2HKLCJuokXLJWQMRppTGjPl2x8xWONTHUC7VdRaJkxMjSfUXE1mJB6KTGOTjmZeYsGyJmTUuGhgUD5oWWdOpS2JxFNjhMLKZdXMCqTak100k6CLsqhUhQUZkWdS1MbMu5E2SRmdSlqMcTa8p+jT+ggAAAAY4fhXBA1K9lzurlAq4wqw+IJJGB3gMBIDOBBpF+XQUCCQBFLWk5EcAMnmY9ZtQjEn0egwMVMsHAERzNiSDgCEcJMO0EVh0qlZMCkwLZfAhCSAGFQB1kA7/sASgXlAkrgN1WKPXvzcSQtR7UfB1Iij3rHY3XhjH1f6bH265zibJ6zaxth+Na0yIdSFChvtxLQHoxu2ybpbOdQ1VRspqO+1iJSSPRv1eNT2zDjVvHgRHstc5zEzi+d3xn41///XH/zP//X//cfX/z/jyHZai+pWpEopKerKUgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJpYRMo7zDcqxMCdRrDW6l0gM0jfMN2o4pp1GMvXhAAgAAW7/1HbMFQ5DhCZpQ0hKFZmvLhhUCSc7/JvGPoQCw6Ogylf9DgDWKYkAyq5VE5gcUGMh0do0oQyy3kAK2BQymMyOZDEDTFVhkBkrKMeAVm7REdy8hhlRwwLB1x0axAKAwlBYDFAKT1jIGBBEF2bPLODIPCoVIhQ5MON0RpJKLPWHhmZTjZ3LKnV1QzDT1WVtru3lKupuU/Ytj8ZnqZdm5RhDEq7hcvxGy9OUthqQ42HbsZt9RUsrvvvSZ7hUQYzGcHjYLakFJWgSWqYKwyR1IvCY32pJasMP7S9f/rsRuUwbGJe/cO2YCx3Z7d5vXf33mufnnnhqdi3dYbh7etVILean/W6uXa8B3qlbDPDPnccqtX9/Xwvcz/HL8P1nzWt9q77ztTljuX02GO/qdAahf7IkAAAADD//FXza2cqyipypKa9BjTogC44/L+3EADu/B44E8iCTuLWwmDS0WCRB7nLHVV3D2PG7KyP433bjXFrLBr/daNvu20ASeoyBh8LhucsEAOYPIT5aY6mk0cvLSJqyYSucdkFtZEuLE1akeUtWkwxmYyLiSkzczOBTnC4YoH1uUll9nTYwNai6gXHmyjNNJaaKZ97miZLU0amWrdl19vmlWd2HqwrbX///WQAAAAOY5ULRjQm4DASPLAkAxjAidZ8nDA5g4CzpVE0KUTOQNFAEYDAjZgaEx45BAnUtMDAhdQJNZzF8GSQMwXiNJkceGbSyxRu7JRUKmIzMYqGCr09WZmEBsYCORgEFvw36DIiE6WLLnzCgDLtmBAtBBQCeRMvAIwAwFLuDmthxihMdbeGFgGZT0bzghgNFdbLSPqnh27M4sugalncL1qc985VhEKuGdDjc7SySe3VotxukgNXz7McpMJumu17VtuVuTx/PB3bd6F/BSxdxJyIZgyB8tTlLB+rdDt4H6jVDKJ51ZBYmIrnIcs6+PK2XbP93++4fqpAFr+6qRXHWWcF0e7mvmsM9VuzNvvcf1SUu91OflrWeGH95zvccuc3z//PPmfc/wvoi8RLG59mdsAAAADuv/YiPXtWZSm8YtDRUtr0AWkEhrNu/ACc9i/Aq6AKQYR0htYN2B3pcJzbFO2RLxhe/wqMlapLuuhNp4RRi7PT4JDs8rNRfi8wGTvFMtP2XTigMNmm9z11Zii3/Lpsz7/NnuERne9/W/p11zjLXXUeNHbLqKBCg73l9uv1eFjdL3u2OXpa0HXpnD74zt5CxnVqzGAkdXsVBFKA3na7FLLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACWOFTSN8w3CQalnkTwteJZIXMg5x7cpgr6eRTCG4YAAAAGucyjIRngoFSCclW0AtB72qRH6DKF68TRgpDhxB6W7hBYRmTkogeqkpAwcDzIgQOWAkWFqz9L2MkBIwCXwwRqPrxCwFMkJ8Ghl3ICYiYlGZpYUgIKIpRgAhEQhN/SAEOujqwMwKD1tKE4qPqXjwRFQI5U0MgsFnXqtiLypW5QuZfyhgdQui0+lGmW9tzCgeBFWvy/9zlfrWY9Vh6/jnEIAdWXY3a1SvqUyt6FPQM9TrymkkV6pINvvB2UllFDN3piG3Nvs53C3ActY8HU1uejFXtm1JnYrzsUoWFu1N0N2XO5Qzuc3cw139d/+71by72mivf39exhnbrw1z8PrWOcs2MZRGb2sfsa/LeeHf1/O4//53P1j3WH6zz538s+2f/X7y5++3XKIyjABAAAX0hTiDIqSMQPYIT3XAc63hcuqOCUZblprQKgfA0XaqLhjEXac2WclzrOBj2balFH5rYOlADT6jrywewSFzM8QBHPguq4rAWPItVJYD5itIMrL2JF3skn+l7T2T3e763n4iOtV7xTLGD6dVq2HItfzTd+1zp7cefXUJTByjh6lvNLQQPXbZZqQs+7Y3o33uqczoKy6kPVZskGR4emAYEJ2qCozGdzsHIFWRIRXRgAhHHjiXaa6QhoDAszGmjlwTS9dRSswMQDNRSMaFQSMS+S8pgkGmqwsYaBjMB0AA0GmMhmJPhA1ktEABmSAwwMAxgEVUQTCQPBRKZMUAGHxkKionhxolEqgJBkAIToj9SAAWAu0kcLIA6HzClajDDAi4toGUvUfKVuQazGwVS+f7RrLfUcbU4YdYmXMJ0hRlJRackOhnEiZWxjXLtxmjwCe4Z9rR0lghu34hQ4BrvGxxgt9NyKk7lDBhFpOGyy0TrKblZcSwd194k+61Z609m9TPZLRqs26QaIYqoeYuGWt85cmQ+NObbSd/TPzmNr5i4tvNvP8atLSmaZ1vyZhU+40kbVYP3fNYt66/vygAgAAIPqHMM61pAaQiSSJ+hAE1CrsvxYUNrq1LbjBfA2PXy1fQ05W+Bb3ZLCG5/nJU0Yo62GLd29YdKnvgKB529a5KoerMsv4OITh0NMBSDVToLDvw9sImvstPJSpE0h7UTX00lbck2rGiNYhBpDbtrGpduOD/tJgdpWE7dJI+dJEAfjOwnHY3pv7799fapmMio89KB2VzQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAj4cc0jm8Nynoo51GcrXqUmAzIObw3CjrUnUSyhuCAAAABvDHt0y+BEv3hfpVYwMNDij/VC7DER0VMf3wEVtzbaWErMGJ4cRJ8iECBIYYpLnjE6gUNJyjLEaoomjkk1LSQEMGQQqNGTgqtkPIIjMqQHFiKz8qBGDCwGEQqCsAbMm0CRsoCkZX4pWcGAAkWGgF/RgCaIHxli4pam8OKepRqkYRQqiv/tW1gt78nqUtsYWotHIexu8dN9oZs7rXoJmrVWxWpsJiJUkbTphEzSN60vdXGpPUmXw9eibNr0/StNZHOWI7FVhx4XMrUemK13PGu7+FPUiTiMGpZJLafCv8/f5Z1+sd/hV5nl23O81jXoLX93Q0t63juH538+5/dm36rXtar8/8rlnlbUAd/WbQeWhIUYzmxdwwf//736YAAAAH5/+2p0mWNV0z1So+Zxwg6cSpIa00rNRV5TECp8PRS+7WdMpHVhqauwytV0KPOUCQKxYGpesJi7FGePe1Ugmk6nEwjGICriglE41OUKA6Ry3Y5DkqOXXsH2vggPN8q5/2HIO53yi25KdlB1ST1uXbMqHVYqKXdXMuIBenPVu3QO8ztzFyQeEgsRJsQmoylbIse0uDy3JE////68c88MTOwDVkL5tKSGMQPY05PFBU5GolQSPkhAVDJ/igKzIVXDtCxAGqda4YIGs7oC1EAzutQM9NTgRQ3YXZSv1WYw+XHBMz8GWoy6Sm4jYBOnJcFKYwEWDB8BCisjeEQUIBAOBwwCfaMoCBkLRnRUkRMBDIWTpWxIrKIpCeNLnjKu4S5+dtRSXQnLOsqjLu9qQzyes/lIYDi2OW+KKxWYg/ksmeV2yS1WWF1MpUxRekvj8nncJNW7HMFVIGqQA6MdYBQUjkQezlWu/Kcp17r0MSuhhxi1SdlcPJSz8lilSXtAq6r8t3rGG8/3fyy3dieNF/LkJq/vKMT2O6sTd65rncK/dOxG87VS1W5a/WuZa19/DP/53Xf5vn4/3mv/8f1lrlkMkmz8099NAAAAAduHKlM8iiDVwKeaMfmTJhVDcfrGCkh5Zk/kWCkEMRuxKE/zgCWdKt6fRThqNrb1A0x05fhlVYs26jlp9o/YkPPfv+MG9ojpOTRAMA4BEZdiCbUODYT/Iu3ewixIzErR1PYmV4Fp7I5HSzAkjHK0CNEjxgZeiEGBXeaCcTJVYgczQHiMQZkB+Pnyh03vG1/UxL3ObV8L/pfzLR983jGaZIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJK4NNA5vDcJULueRnCW6hjdM2jm3twnIqJ7mcPXjLuqsFGWRFLxoNvlLwJVDxjbAwoLRO6QhR4I8DjhlBeZKcwckOAM2fMER7BBMZDwgY/LhQKsCYxTmFIRkoekc1lZBkrKAA0WNn1SJBggbgZmBiMAwCMBBjYWEIyC68lYQwgBAkKANWcXOoMGHyhokAxsaBRCTo0ufkouy0EiQ5wthb/OjIuRpcUzznZQr6t/Jp5MZX/ffa5Uwq6yUdyuSytPVtxyWzjc4vUcaVNfV9Q1otXnJbORLVOzKluMQlcOKWvBPPm0VljU3coLM42a5nHKCVtSvRmkeJNSxWynIcgXVqnuZ3Mufhhdz/9Xu//Y5V5/N02u67G72Osvsb3jdeLtLY79jWu49/n44Y8y/ufd9uaw7+96/89dw1+G9fdr6+nWITnVAAAAAMdf/rWuUXcCFUJuhetSsIA29elweMrnbyjzEwgBWabzyf0EFilNbwbqx1ms9gxsKlhjuMEM8ziTYqjxOdaw+ngvc8x2pEX0Tu2kCEDRidn89QLbvTauvysfjPg7Pvpd1b8r1Huq2jrk696zuZ5MPklVG8qVl8q4Yd8ozI2pxwoZvZVX/9/y3+Gf5+7xTfXqrDjAAAAA3c5WZ6YkC6jgGATDUAJjVmHDwOJD5drJhkhMRMwcSyN7FVTHDoNJ2VZo7mAAR3xyDm6IusskCiRlocCnrGRigMYikkokvJ5oZQnm8lgYKQbAgNBAgECAZA5y0bVyjAGPAFqYTAKoq25QHQfXRwDBWOom0th+AUQ3EuSEyi2Roa6MmbWopGmd/q49kBu1oTxvbYNI+2FSSbl2ub0hxON1RJl7AEbNVwboTizQNOOkkYrKj2VOptskOFYjjGQ44VDVdVgOnzejn1IqJTziuoUFhW6Q63xj7+vaNnfbJ7fWFVb/MP69ulc61jc3jZY2X5mzF18eHr58s/3nwRZz5FUmeWSYBVhESkfkZAAAAAAAAAAs8/9Khsy3KmFETgGh3LGYgaBt5Vh0rMK+Ftqp7OrDbw9O5lj90FNXaKw3LmT1pTSHm2yMJsvLBF1jiqb84dOS7YlG2JZXy204w24XXPpDz8019+a//pvevP5PnG8ae6xr31iXEVj1H09OCbesxc0xmHp9aeuoGI+603Sb6bI2Pi8XU9sriNTfvP9xGxxYNU5PdW54lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACT6ATQN8w3KXa9nkYw1uoWnNNA3p7cqtM+cRnLW4zs5UKdxbh0ExJMlSZ/bm6riCdJeLFUTmPhipfRuCgEMGowHWtPucQmLpMcRwwUCGsMlMBAYxwfzVZsIAEuR9BgeGIBgZHE6qLQxGATAIDNDEIWEDJZEOAcHBkwmBB4ANJHAmCACKgZU9d/ygDmAQy35MDnsC4RWoYbCD6Po3BEmwLIdKulJL5HY66C1KuXIAYLha3SJPTPZBk+kCux21yrvBqOV2XUuN+rO3qdm8ZwijwsjeS1UsY3r8Z5dghjsNPlhSKldKrIY1AqQcbh23g6eGVLVj8SwtyyVpvw/Yq3K7bbx/tal3h3Onvf/24tretSTDe8Zut//nL53XbtuxvmOEO27m71233Pf1c8e1J3PXPw7n3eHdY9/HWet/zDPHefb6g9Cft+0AAAABrv/tM7O3zbADwd/M68kVSw+zmgyPImbkNuAX1X/rPrYSekL+/BYUK71Lj2IIqy+J57e7Nv2yQyodqVXty9+W6vxAUQn6RBaRTMkAkzpmRhebm+spXqHYz5gy091OU88tCtklnFMxkMU8plrWpTmCjdSCll9BKgpBWiXmemxASWtzdBSVaCl92XoI6TJeYYtWatK0fcuzCd4ZJCoG8rOUGTEvE12VAwUDQdv1gT1eAyA9s87Bg9ZwSgkPWYg0I3Rp94d9SGKAhEDPq7BkQ2rFuaRppwYxmcMCjl3pVmJNEuGqmIqqYsIKpi6VZqIOCtcDFsgU0T3hQojS6UfSFDilCYhWm1NEEQH2FykR2A0YomrnCD+Z1xbAphTN2LLgUlg3WISJGKJdQMRqSHHS+4to9X7XAJq97yKJKVr7dtnVfGcF8QmR5RdCyOUx/rZMC9uds9xVd54zAZKw2s0MgaHxHs67LxbdsvtUlxASmqaohl6Z1K4XrjFLa/iRq61fEf0lupHO27RYX+banxt9NW0HZ+RVqh7r7vxdbYSeT///bAAAAA1z/8MFlWH6WUErUt6vWApbr7tZrwFjXMjddsRnSSSeqRMLhB1K0KtturAE+mK9swsiyljrwqOqUuuxBwnFh5h9ebu2I03stdF9rsnPGZTNiaUQm44S8oZdbzpvKzI4hSDlml1Oig+1ZlZ0SetEzc4SNJEyCnPMa0k2NFoEmRz7Os1Ux9BRYy1LE3TdCsc6zM4dF0xrdzH21NN9pfT2MG/9a23N40WfUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACZ2FTKObw3CpbNnEZy1uZfIPMg5zDcLCLebRjL24IAAAAFS7hTpoGjggTBQuKxILgQx8Lz4b2RtcsvgVQgxpdASLKkFoyyozYGRHZ0vMcbDF+EykNKBACAAhMQInHuCoKVCIWecScTKQ4WTTKBFl7gmQip0KIkQqjEQcsDhg3qp0zCqMLbKDePL6GAF2R0vKBeDS1QCB46YmYNTdsKvfkhG1aHUpo7URcp6RUrd+wPcTut0sTtOkNHq/L7ad869fIO3XuRNlWt2NRmRV4zQ1WL0lenkhAGxJu0+U5VsxLqskC08tlUqXe+TuSSOpuM5kONrBmTbSuvXZ5KJFYpZGpg70Uwpn0jc1+PLWPefJJNlhhQS/HPW4jYw/vZb//yLZ97jHfu3at29J9TF7tznc+flvHKW5WbOWXcNa/LHvfz5hl398x3vPfP5j3d7PPn1QH0sAEAADPD/yL1S/DnFpgv2V2dvWspf03jpVBw7FPcZUoGtytfeFOQBnr3f243AqGQYyedqvuBlK8/CqC45z4yJ7HTbpfq27tC5tRcUM2HdRWOBMnlEUCaUI7T7GhORMJWiswYzGCTW8nzcyWpFSiBUqzzRIzHkdUiP4t1maSq0WZ0XUmpY9lMuiaGuooH2UpZCNkzFIYV2WpZsqr9bpVSgqqkr/91nV3ZE7y5qlYEadNa7wUHHvHAIZTQZmqFmDwKlsJAMdDA86C9UdaSi4Y4Jo1ZEiIQykw2BzHkqSyCBKqQgHpjo4GUSGOk52IeAxrMGoVVUwmIoiCA4Fw2aeDSuoyOA4MGoJCg0BFGAwChQNuQYUATeyQtK/YoIyIVtYRvGhFkYuDbZoaATKdN1UEEJ3SynUPsxxWuIReerrD2azw12sESqleTsjRGnnAktLl34Bc2xf/BwuYX78de6muYRpZL3dpqC3L7tLYjDlRSvhBjopjWa9uOpTM212n1Au6ekqtUlk3Ep23C7WM5Ab1T2N/d6c5/6u4ZbsQRPd5vOLdrdwpcO9+/23jvO1ax1ukq51ccu1r9/WeqK5u5nWwx3+s//uG+63v/3v8u44c3jjljnhX/V8qpjehgAAAAb7/1UkIxX5XfkL+aZfyTbBRzm3aTFLYin18reczq2Lxb2YAw82wiqDT8h9PpT0V1GFZiyMbci2+TMHzXc87TYTAdmbn8KlFHmsNnrXY+mnrmESZdrNUVuSVjss616v9MM0C9Ya1uDT7vtqh4zXv/hi8rjXWEmarl9103xa/LVB9/dQWkxeJXHrtb/z6RvAh4UUbGrw4/x/9/4186pC0lJN5XAy55QaMkv///1KAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAiqc80Dm8Nwkitp5E8NbiWuDzKObw3CrrTnEZw1ut/nQEoFMmEpj6fEZTtMD0MxFHBUAPGz4UCBAIDQDD0MO+Z6YAcBIhiloAsWnLt5hgWXBZYMmZjwQUwxMVlAYoaCA40YUTOBg+9hgIgYEgHCEKylmCIeTFApmoKwIsAIYdFUCDh2dgJHx3jDBIaBoYKgalHZElaLKKKnlTaNq3dLdqDY1jUdhb1PKc4LcLOvTcIGQqbs2yEMK5CrGV2pUdudq6zydnnLOUE35fupBqYUnpprO8/WGrUeZDJsa2Sq7kwHQ0U2uumnMNxz7Fq1xrdm9WnG7xbLCrK4a7ljnb/nd1O7y5Um8v/5Rfx59TL//dnmtauZ2N49q0OOPNZVdbps7+O5vGku4bv4hlw9kdZcwXeeHqqoAAAACHOEmeTqDiANGyygko+smf33krHhQ/WuLREVoatdY0SHGgQ5P3rpUDQxrU02QmfuBq0gZ9i6sTtX2pfSSrcr5bi8ir33MBtY6eHiSJuoooHD5om036ziK1rH8jzjWzhtvQXZtLYFg7J1my3rJdnW5wsSRRWklUo6tdSJUkynMz1ly46u+pVa6jV0Uq+y4kQAAAAOawlYoADAQlUcBQZYMjMZYZJheQkwAWDTnViE0mJqdrjKo+ImYDXIQGORGTAog7YRAoWX0a4Qo5mggc2PGKGLprsNGBjRQoqAYk5J9mHEJgbIGNJc53ASFCIPMQGH6HBIYDSzBb6U0yeq544DkqrVJAJfw4GjyM/b7FD7INA/1RZEIWSrRxbEnktNpqq3NZUkNp+3pqPSpAx85uU/nelcWa7bwrbkkawzgrO1WrxGsounBLaDHUFYzX15UxetKq19QF86KQTSy2DVH4hyvAV+5bvTMuh2A7VRzbcUfeYm3l/OzbsZ18v5jvVSXd3hvOzzXcMcv/tXfdZ17Nf+/SbtXbWs8qu5LnfnPr5XK1v5j+bwuYfv95/rDn5dwxw+5+u4653Ll/hVzVY5gAAAAVsd/XYHy//SqkY1Fe5cJSo1RbeFIxtUUiu9oCS9SXS90gvcaa7WUpfcqAlysE5eSoIvR93qZYRW2yvdRdtWuOf2Go3TxjHJmUnidqLJGNCxfH43NnlSRTRlZsghMxhW0hgDZk+yjJXpVmyKaTzMWQLFCtA0cwUxWki55Qn5qYmbmZRU6CkFVUC6X3HokTTQ0c0tUuvam9OlS57/+60U0dptfb7f6/+lQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJj4FMg5vDcqxMycRnC24jJcc0jnMNykUzZ5EsIbjW7UpQaMJhJXACDEMstNDzs25BErgCCmTmHupxpGRGS+09lcm4Vg8oEQIyJsJkqOfelIAFvvOYIgm/yIdhmUlTrDBMZIEG5EZAGhyIg6NFxlj0GCowHKChUhMKLQEXrEGAUqDYYCGGAS9r7ElgkBRiQC/bwBcEjAhFx4ulCDCop4RBf9ty3tA2VbtRpcZejLrPXlq18W7o/alszKRaVuMNk7N1WwyteWdNlO0l3LKrMRa1Qw+/cdIiyult5zdJchFBpg0YlTt5J3SV4oU36VblWNZVIZik5RQ5E6kD08RpGhPDQ26KcdXX61lzH6lTXcalJc52pO4c1nNZb/ti1zPuVnCcys1MZu1K8+V6+PMbWEpqS3C9hu3Z3vut6/n47w/fd46tc19/Dv2rmVcQ7umf56tACAAA1h/3WWSej7scaMaOWTt0qnDuOZ/2RHdi9PvJN85If/PJ8CAxQBhvLK+QUuAIBs30miaUlg9sKtzds2cKOuS37zXo7Ulr61MHimX3syCjFRvcA9Jhy5krUT9G320xCV1Ehs1qNRvlPnWbxaMIH3naFgJ68n4X3Nt8vYeYOiDj5otpSadLoVJB3VfJsbvOLMfX8c8u+c7X81/Dv4+75zpU4Jhdvcv/7f10kAAAADVi7HCEHmUwmp8SBMCs9MsWMZcLCmzQ2F1yaYKD6P4gBCwUMPN4aRi3YNZiMGg4sAngiCbhhIqGBiWHOoyQAWXDAwJgoTL5rY8SBEAzDgGBI0CBxDykDBwMdZBaOseHA2pyja/+CCrXVtjQWjcUEhLAI4AyYPTiAZ+pSJOjEAKQvNzlt17+2sca1rK3fbHOXs5pR9vvxei/ny5ADNbHMs3grZfQfTVqWGc3DjOFW7Zb61rseYBNZ5YPgrDJoZuw+ymgsyvCe5cs5TDKa9JPSRucKlj/VYq6ec7O6uyDWrm7XO5xqxe/eX91/bOPf+e7n+dfHLPmf5UXefybk+N7G7bwp8ceXJu+5JuKceZLmth2groQJK7oAAAAB16ygLgLh+oJ8EHGdFKctPzlHmQNURv1rrondNbG4sghKjDCq12DWETTnW7iDCnOEvYhdX7Ugto+2xa7bk1Z5tU7+4PX1w2OcZgLCtj+Smq8QNUkDxbiRDW7Gf/X80v2xtWIJAkANerJLM73EElC/K0Ia/ETFxY2RWqENFaqePmP/j9a+Yv/n/+//H9GkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACW+ETAObw3Cfa1nUTy1uJooVMg5zDcI5rWeRjLW43/J9fhtAeMlAw0dlwTRevMRwKLKNFgHmPVpwtiAihJQxEDFCwwnEE1WNLClzDFps/GbBxGWleI0lAN64AdfDVul0CTAxQTM+DjAhAFIqnBkwiZmikQCCRVcBiom8SQj0o2GABxEFjoJBssL/uQQipMGOyqugziYMYEQFTDxYGFU2acVHANJCaWOs2vyrVV/K+5NUHCSfCbiropByG9A9fKz7pX872cAQDZz+vDNjGxk0t8qees3WT6uZ11sSDs5K46ozZm4hZhKKTfVLFWCaerS6hT7SqV4tkeSV1JfLLMqubsUE3ZpsblPvfIjAm+f8Z/etR3fcNbnu67jQYd7yby73v0letl2Zyr1d8p6+GFJlh+8Oc7/3fz/HmPMu445Z4/zDW71rnN9mjrGz6y+ABAAAZHTAkObMiCZgPjy46SZIGahe7PrCjwV7t1LQLJatYO2QxxN8q0fplq3W+twgdEoHgp2vzF/sDPC+cv3nUk129uC3mrNM64yWNyCwdUFFGVso6fUYsourHgjsTTdll+yql6kkUtEqNlpnThJkBaUwQZp0yVUmNBLJMmSaOtlrrkw8xlJh40ZbF+2irrtqPvS33mSwo94pIEf///q+7TQCMhgy+VSz4wC2mCMDmiL+BFKChwpmwgwwEzkZUVLLUiQQCDN7dM5BdK9pgJAJgMiHTxIAhdACN5hI9mjTIYkGIKJThCoAMUAkysAQEM2KjgIHgMZcFSgBEAGcmAgdPkwdS3XySB6ADAIDsKrO22YQAdSIjAJcoOAxABAMHV+NOGUQAW9kTsig3vmGzWI/GNPFRYUF6YhODrudVpOTZQLOTL2s4Vo82uFPrrPItnljK1/5U8q0yWQ0FNMNjpKuNebZvO1KtiNtDsUsbZmJGeaV5U+dFI+U0w2r2zkM0qV7JY+8MUcFQuXyi3NyrVfHsrnv/9x3eXNUHdc5dot5fjSZ4d1dtWMN7p7+HK27+POaobmHK9ffMe7u5f+///1+/3z+/3LWt/vX8yzs95u7bvdoIqYAAAAGtfqhVxcqb474tZ7+WkECodVKGaEBDbYZxBxx+Fte4zAOQU5orm2lSaWS7lchBr/K4xMWvhEAT8U1e3Bzx/2TUlxp/mA9kQr2OFw+YPWUJcebVOofj9dMtnV90/MHR0jdlMtMyIyDslrWmzUC+avSWaW6NaCF1Oai4yZmak82e9D7L5s9GjRvYXuWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlRhEyDm8NwqU1JxGcrbiXWDzIOcy3CYyznUZytuPuV4gIwaZDJwVBbYZpcZhhrHpwe4RcUgBRkFIccRBwa6RMCJXGUdYZHuRAxKDmbeBn5cog15rBihsbBqmRFlhqiN5kwKaIGhAZ1fYOQjT0URD0HsWBo2IyEWFWUJBJ5g4EQYXmv2G1GHcxDACLjxSSASOcjZqKtbwEmvLBrAt9hCbu3lruTyggHVypJU/7eqGpH0an4WxDdirMvhF79Wm02/d0GTZXOs34eiC34o3kxTN3q1Jx4JfQSaapHjXhagyidhAtlDaVL8QtzWfYclsCVbdDKC6Lsw1A8NsoY/PS7KWTs93K9hR5ZaxjWHfztWf1hE5N3msLPMeVqncN65/1/+OfWzzyv6tXr07vdimwtW+87z9fzeu813DXfzz5vKpjZ/mGOf9uiOjWwAAAANY/uOKayiKfgF7zgCluVgqxDQdrVPJCyS3MrskFXTEHxpevuCvnRjeEqRukGFWtHRUazuGHfbFlyLvtH8Y9jg9r+we0eZisTWdUNRWwAg8IgPmZRewtevFFtoHpG9f8rPXSV/F88ntzLt11GSjYl7XtnZBbSyjzU3g/JkRms4e24hxuy3oCiO1p8+Yn6dH/8rfedd8x/9f9fV91cTW/0lf/9f0si+Hb08jaZkB5dkIAaVwhCRlB7HRRwgHUGf4wDCDaQ3dBozlBcLGCYgCgUsV/xwFGPIUZyEaa70qcGQQ6bDRxksTqWPKDR+QkEwkARoaMEIASYVIZk8QDQPS7WSYBChgwHuQzkiBgMC6wSOKZNZmNKhvMDwLS3IgCYAF0jlbNSAovoGgyh/ElJE0uczpXNguctRyzcdWrmkpXuW40QBQM6ERiFyrXZVfkWNaOWL2OvkE/LZudd2TyF1ZNTwRYmeUzRYxQ1KVl9K7VG5TSC2tlpMri770lLfwoKVpVJhDavpqDK0vWu70t1Ynd4U3KbX7/+TdF/N7lnO8ws6/W9f+v7zLPuVf8M6+pTru+Vvzzqdu/+pvf6+prvd3P/94Z8/uV7P/5+8/tVceYUlMFwvGvqoAAAAGfP/qMVuryViKEXReS3MF5kDqfPDIgPu7yslR0vVf1PPaNqP5W+PLuinamUACzMQyuQ07eU/NN3huXUE7Ukz4X3oksUbLPUDQ/QBuCeAo89XCzyHuDOz/jRPeaPzyfOhf7G8xrQ9Zw66sze85Dt5fVssvXVchkGcXv2TehsOtRKDNa1XGza/n/v+VH/8nn1qO/r//+sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJloPMA5zDcJ0s2dRnB24lShMyDu8NwnI0Z1Gsnbrt7CbQ4FBjQmGBgg54ICBqmlGTCAWnVwWxMdpIyEARIBUymQkEzWbpaW/EZX0Z3vRi0RqKQGhKMWKUHiwFGwLgFOgQlMwoGTCoPDAi1slAYiRpeYw4AWdRgFHUwKAi+j3IrhQBF4ksUWJcm+VQKUDcLgGdT9KB+YlHc+4cVESy8xTDFfwjBCVvbgey0FpExjnC3isZUKR9yzM2BkTJGVQ5F6lpn8mwrWKkM2flWNSSWpRRRZPurKZVdfyhpIYsqoO/Uwp3YcqtObgSkXRFnvyqwrGa7Gmc41JyH2YvfHJdEIi1ymlNl9MIRerbopBU1j/aGTaw5qvvPL5rL9/nY/7tTDmU3V7369apaxypcLdfC9btVdVco5bsY87v9/nlznLm8P3l/dcx3vf17eGMzbzDHSytgAAAAb7/0K1LsN5TxjQLRnM7whjVzzuUhCKm382VI0dLvySxed+JTVbEyOUYV6qOy4X3+DGUw1b1Ar+Ucrm+Wn4fKIO7SxtumM0cC04EmEkXjUWsg8QB6Y55w47oHpaFmRmzy3nNMjmOFhqJBFSihc+QUTk89BhyswDGWss2gvVTzguWMKVDD6JMvdX3KPo/v/ub1KyZc8/3+z//Ib3lMlUBiYiW7FQAi6IICEyPlUwsBtMJ1FgwsRm7iLxUjHzAUkym4Fh9MBiZakwvON1Gk1U41VxC8HkEYY2ROHwAUmkkDXWHI4EIOCG1e7otWYeZaDAYRXy11FIIFwQBL4W7CFDxgJGgJSyXtYMVCwaILjWtBoBEAcpcsLpRGN437q2rsCvLS0ElmILwu0iYExP1KFIdtGsy2Uyys3WU8+pVkX5SGah3d+cibiwfckuUMRfl6im2tWreEbct+Yh77NwR9k3YTLXd7SY2Yw+0cgOZcOpD8ucmfYG4MEalslor1jWVexl/f+bs/jz8t77nV1u5qr+/xrcrVb++d+UZ5d327rLvcd9r53rFXDGn+7zeua3zesv/XLmW8sNZ1r1+3u3GNZTvLJ+1rhKQAAAANf/8d+pLso4IaDqSvCbIa62G7dhWWi391SmI18Ko6IEbQ7hXaM4jp75JWlTr9Yypi8mmvk7hRuzCuwbjFX3yuNeZbOyBQDgODRQ8LjrNQaDKVLF2UwM7xuaXjzyPoa81GZSZgLwDWQWKNjnmhA/KKw+4iA/MrOWYg+yuXHgGkRoKRWMkUdknaoia0dv3f/VnoqdBxv///7yYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACX+FTAOcw3KKChnUYwteJP4PMg3zDcLKtKbRnLW61ztIsc0+H0TzCwlXUCgUc8FYc2h4KK7FAEZWWAGq0le1VMQA018S5A27sDoGMtU9VdQxMdOkiAQOkAsSGesLMNEozQAhAAGOsDaOZuMiDwsAvHQKYCGw8CVuRhoIkQBYepbKZxdtDAIglyE6KjAAGSKsC1lMJrJ4OT2kTu4F8FcX92FZ15wdanmFv5LrOK0FNY1lQSoWYvCVT0FW4mt75iW0kcrZ1LcNzFT42oa06R26sSryfe5t+Xbs5x9pLfwLOR5kSvYtIbTv0N6mmqGOTFPTwfJazk2W40SOkNQzAkOSm1Wf+v+E3O4/cvalu6nPsf+Ws8sqv713PXP3hT4V7eOGt03Mc/wuU3N2K9bGzKvpsPmO//Mudw3r9ax3zuHNdxqau1ati1hl3ljv/RmnG0AAAACtr/uNpk/1LAIGu2suxpxFlC+x9fj9fq7jXaZa5NAjwY6b3df6B3A7qVuZH+8uurnX3UhmRVkmCKOlpNsgBBLMbAWc17jU2nt5RasZ106Rf3EELPp6i/xHPve2ZpBq1KHz7OXIy2GGLJ2uPpN7nip7dflsmqrR8oJCObQRfHcn5cgkQjXsLflVgwkITIDbgMEmzigIfWkhBopmhLSoEVMMUhJ33uQGhcNGlwqGA6DXTGQ0IFcUBRqcPiMBmOwiAioPAxujHjDJmDkyKAFwFcmAQSZRIZKBFjyRZYME65VNnTEgmYPCxWBkXES5EjMAgi6giAMlfAwkDG+ZCyxRQxfIjyFdTSIg/c5QSxiDuZWLqjcPXq0wgxFs5dxuDr0NF2/g1GVY2MX3luucm53lNSShTGfr0lmK97N02LnX6fO0p1dnbdAsFDkjlGcOOvKe27MLhzPG43exKaZrTGGCz8ttWN1bM9+FrK/ypl9yj3v+5a5veNnmu7y5V5+WeOWeGu8r3O1LWFf9ZYyuzvDLsty3+dHvd/eWsMuY7/vN7ww/ncLFmznu1br28h+qSGAQgAAAAbx/dZY91ueU8dSyMV7C4tUmWxwjuDl2ddsw4l/O7dgx/izDN8p1Btj7J72b4s3gGfttwcTtJqdTehT0yHBkDr6cqpHpXhKOjEBTSgfROCoJBaTmpqxMTTHpVMhlJuyA6mzzBBN+ky61GiqyaHPLq2TGHrM0CspoqOHBsdNTBdH1k8p8zKS3RYtmZYkIAamRmp2TWqvQdb55STdHW16dBHVqTUp0TqQ5Xd70f/uR/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjPg80jm8N2pkpJxFMPXiU+EzAN7w3CRajnURw1eiAAAABz70+XUGmix1TVWEgCpjaml8UtLicBqqEGZjN3bYZFjswImAsqJTM5eNBgCplBSjpsg2YYEFYMqgzsyY4KFgRgUldolQTDTKXp9Xm+BUZKoddhlpQVKMNiSykMQS7hpDzrOQwzkDIV6snBgFCsmwqUJpQvHF9JTFeUFt9qT7llBaxKsqYRKd578e52lOeYVp52cNZawpfsy2D0gs7NWgdrPVBPMwe769NGHJwtVbSbsgpq80rJh9Wvbfrde5UgaVZ9g9PeQ1qaWSud5PYV7+dzHPutZazy/X/++9y1vDD8N9z/HDPXN39Xt9v41Mu6xu0uF3fJ69qxXra5h+P/v+d3jrPWuc+p2nt5fTUMvp+VK8ruZLrxekAAAABb5THOcdTmAGZiHKfHJFxKLn3ZQxe9u7pp48K/2UiHJEBj0ZpViq1vZlm+qak3WxapEc79ahEQJBJUpZiMa563J+Xqj7auHDHo+5B3vzli+59SRdei4jbxumL/x4L7f+oOs/OYuLyQ1xmXLaiv7xHjl8v419bpRH1rvzO//WuMassWvLAMebO6xjpB6xzCK3v3rY1oXEpQuBHJV///zoIL9UZnjHGqlRMMMO2QAIdV0QDwPSEiEdIMQhMchTMAeAlmjoAnebiMDQO2FNAwODO/nhIgBQY1kcVDZIEGjQ0IwJCDhTIaUQaFsXZUYitm/CttPOCS7ANAXcUMdkRDrT2CweLA5KAFBIpdBQVA5sdJnWksEIiDXAn0DRZYArCjlF7VMz51ebzUXfWl1ajhR3PlFVB54YuRjCIu5IvyvX87udyglv43GwJM0mdSH2t0Vamh9lbbfS1WwQ/jqWOKpQj9nMQSpksmBLsSj8SjcpuvuzKWTV50E1XajVSeafOdm5DXlU/SX8KuF2j1llhzLv73zuWsP33/vaucwvVsLOsvv44d+n129vmdScv6y7hRZYaxw///LL+8z/meWfc9zdmzUtz+VrCks43sPHULQAAAACD5RMJE0UQG6jZzuJ/Q5v/gxOPDX1m2Rh3lECJMBNTo+Ub3PNzahi/cb3vu1Ptnc+1uQTpYsYYpRYGYnjMgUw/jDGyB1YRR11lPMVj42mZ9yTqy6Yo9JHVQ5fGHJWzkweLKmCTuxmz1oDtMEKKBeSWyB5VajxRpGAzjbqPtBHIQI/ZVzKgiNUdvd/R//UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJYoLMA5vDconJ6dRN616lpg8wDXMtyqOsJtGMPbj9z0JAwCHt0rWtJXQFAxsnEmMAUzpFEAgEwepCDN5IW8JhJ+RLyWbRlUAs3nhACdwMEWhCMsO/ODAx4uumAOhBkDSVgSZgoAK5KmCJFqDbIlTGKLAcnQpQdzBAZBylUdlayHjDrlxFUKgpjo4rU6s8W4hgtc/sijxgGrTfnKcv/Wv40pUDAczj1ohQynlXBkYk7ceoYbaeuPUk5Lo1Wyn9w/OfIuqLMBjFnN23fk87VqL9mZzcPrujUIprjD2SzTTaFnauY5DeMIsVJuPxOF2ZTtp7U52t2Lu/DUeoZy/Ndn6t6i783a53lzDmv1fzx33e63eZ75+Feruny/VfPdjKvZyz1jPZUkjtzWWoBq7var//NXta3nnrXN/j21jPUEXu9lFyNYjYtrxPOXYIAAAACugIFWZJJgZfCH3jVGO44+D0C3m14AMdRtmTOJvGK6ZIC1M5o3gnk4yNGirIdtqoaJlOLOQqIg+h3loDwfKovAdrVCBIJdXoHPQTHfXSsz6o/X3m1/6te7v2GJCXaeutEsSPfaNNhhsfqZt0V3NcHFn8rk56QEFD+cZM6N3nmNVC3///W6upcm3QC8czp5S8MiBAEckm3OHACkABBtdBpKKBUDKVzLCjIggKxGnG3WGDBZbNcAUwACC/q94iJGoqBhHJq4EERj0ZJJEQHXomkY2MSu2AtfgUCjBHxOBQC6YTBwQVosX3a+iu5sbxLbCMApQM1fhCZED/Gm4dtigIBpZf+UdZRJsfyUAaF9abC5rVrN6jL6rPnM5Up2IQ4euyrS+4XUwzj9jtLK2EDwsQdOVzSJl6BNUTM8LFuq3eTQZegaHFdUEgwglmnXpo5uL4cjDutJnpHDjkSuGpFbgNo8lvdl+L909nkridXuqkq5rVrWWuY544Y4bta5j2xlh97KzbrV7urfZbl/MLNbXNROrM/bmZdnjvv83+Ge//uv/P/7he5zuqTG3Vu0tjZvKg1z19EAAAADf/uSPPqX8lJqooVSY5FlceVawWov6dv2LbFlx4YvEyaCVxU6iSgmL1Z20ea+djJAtQu7QzQyGQSbk5ZfrPJxaidMzqZzJpG1dyyTXerq6LTd4iEf9fx/ttt/prW//7u//mtfiRr1GorGjD/LfZ7nMu3UCPAbpLVnYEbrFMNm/37HFpiVJtGN5b2XeNwd/63b/MMNlLbXX1QKQAkMo9cfr/+tWz6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJdILMA5zDcqAtGcRjC26mgg0wDnMtynmopxE8PXj9Ur/BQcmPAkwQdArFzAQeOlU8OJqD6HByTdsJCCjVdEZARg9TA4wJBuKw0wCuwNKBgJDQVgAcAgsgiUKKEvcFw4aeCyNqAYZACDZls+zSqkVqhwmIhKjI7LgjQ1AxWc1QVxwsBRYV0ThjQIeVJVTF12vv4Y5yN/J5uYKMPShFM+iRMmywzQFwF3XSIEvs8lwiUrXO09KxlVFzf+9EEm+d3nXvZZwYXbjda/TplwqBeXWYTu9502Ut1F4iRDlEEQOyFAyM087EZRhT0LpKNRSrjEnodSUzUSh2N1Y7DWn6hFBDNePSzv0Vf9bot//6/8e5cw3jzeVzX0vaXLdqls5Z0dqjs8tZfzsxZx7qPaysfX7uv3DWsKfDn26a9rW84he7L8JyNSyW3wJCymrasjIAAAAG+f9zfJ7KAhVzvUNmoFyW+7oAvBjmOFdn8qVgsYN0TMjDZ5ZASFsoabZrCEUhgP+ogN9Vl2KR8tkNaxtemNBPSt136rd6O9baqFYD6oaCQtfKgga8kXXkBFbzFNvyiv+9zvYelZiRqgvonp5bByJcTjQ92fLbk7BrHEtfJ57zGW2anblRqFd3U/8d//P///O64R2+5qzzf/b/26TVXLk+DAEBq6kSh4gGMHho7bGRJVpPp7BUDHLFcJDdrzT0lTJpzGiy8z6pjgl7mehKyVQ9AIYLCoYK13jwUbgDRuZGCKSo0MFKG4GqiAjmDgFRIhGOhWUAxwBoDvsATIjs3UdBjdgsBhoNQBUJgADAAJAKEsvZqwM9SmnQjpVMNtRYempZ9JPd7URfmBZRjLTBAn6eXxkKhSalkFZorVHdrUmktGJU/P59zKXKzsWefltYOajWPYAif2tY/Kpfk3NV1G1uXz65vlr96uX8alRyJHEX/zij3Qt9IddJyYDnbssa+4rqRiSWYrSz+q+GGWeW+b1j9T8/5j/5Y03MuXatq7ftbsfytM49ysaw3uBscbtWJfnawu87/f7y5l93+7rc7lV3LqDDOpN3IpO1wxIXBx10dt0AAAABBLMxA7vMwH2D6f3MUfhqtHQS9fva02hzX+wmk42Jgqjk9K82JxJf9uChAOQ2bXGXVK9iuFkx+dm4JMy81ulzPUjrEDJ00zeaEevx4+v6LqJv5c//qNF+rabt69Hk/18brjLO8+t3YLb9a6x7v6z2whj2LjTp9fesPv9QY0+I7eplM8zAvBaJg0Fz44pW7enprFmnnfT//+lX6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACYKCzANcw3KbzOnEYwtupjoPLg5vDcpKqScRLC14/uUlJGxgSqw4klCDJJzIFp/x69YOEJo4WqQsCGexFjpMrEATkPxGzJhDMOhEweCSUDiAAmEUGWAMBQ62YZAIJL4sIUMGIl7jBRwNSCEhACv51dQKUbmsTQWFAMYgCpWCHsRThA0ImvWVFGgINLOmZCshDwO8/EsmgTZpLEM6JnCTW7WL7qcT9i/GShNLGH+YQCwvberwW1uYtSm5KW1o8dyjOzuW2lxOregR649TxiR0LbX7VBcktihpo0tGrDyjcNrnopPK5O7dmYuz0epo9asVl/PjjBc5D8dfuOQY0yVQdlHo5UzqV5rK9e7zt/u8ua1jrLv397w1+uV8rud7LGtu7e1+s6Wvf+Wbn79qO1aLOilHf7+f5dyz19n+b1zC7Xu2O3LmNnVZMfFVJQySiVAAAAAZa/6FxLlzGARyBQyMfkSun+cyGs0/cL6vGpKuxuMbqsyhFAkYUCiblXYbJ3WoY7WaD/JNE1TRu99lxanJm/q7+fKQmHtr7ESNO/zchVm0qhNWoJa30VHfh3M7J1NpCtdOCajTpHi5Z1H7lmIneHTT4rvdLZo0PmSVHprdXN3FsrTrbDf/4j4/4+YbPNnTx77vZ/9d/YqlqLlnKSjo8MEAB/3BVyYQBp0xJjVeWCMFAQqkE1DoJBtEBWCBjWxZCYvxlI4JGE9BiAEzdD4ZCxT7NBARwTIh9N8yITEmVPwaMvEN8NdrpCAfmAuBkzs3rOLQgPC16SKhIUBwqGjxfXii8AUFmIgUmgdTd2wMEL+tuXPsfauzukmhkku3rGWsUnqlh6iZtNhQkhBI8WlVHDgsiXz3ZQorM0erEh/U1alTbUsnp1ZZDlQTqb8hs2eR6F58lrprWuV+P8hZuhmcH8op3G67G563KGE096UQlu8bg2q17TmQ0+zxRaDpc/t6BLd3+TGW//fMMf3T44fe7jh2km8LdnH95W8ec5O2b30/aemopfyh+LVKtbdXV3WOv3rl7D9/cy1l96arym9cq4RmTW7XcsSMBc1sBoAAAACkNEjzB0xXAXQGdB/aoye5v7gtrus8BUD6Q5Y98YXVgT1MkSqq/OM9JvXYCnJpXGVfN621kuNAPBGdCY6BxbWUGdXuROj3UDxH4irfmhG/Ig/3duJrO2l38fznzK0jYPi7kmjxdebna8+RmcLEuX0d2v2dxcptMTrU9FsHlHgqeFXpI15Ou+NdSj+nf/+xIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkUgkwDe8NykuopxGMLXqZeLS4N8w3KvSumkZy9uP1zElIDTQl8WPiQcQtRnSSHqwWAEITBDY+qHMKCHmqiIKOGCXtb1raV5mNuGAJdBIcCAhvGANHwqEkwUvIKRQ8Dt8PAMCGBsw1GjQevny2AYhs5XI0IYVn7Z+rhrAVGQgYsy10WMDxa1njTVHw4agCROC76p469lHyN3t6sIh0NJT0qR7FZVA8PDBk+pmahpuiLOqHPBJLCxzmXfj8EojVKnxlXs3b7iwuWyGtae3K3lEllu7JrcdVJnTS+lnX+qbylFLuvNRx/pdPSOTOxR3GxRuBrcnmorKp6Yt0kou7uf3PDL89//N5/z+5Xv3lvHPK1X5fxs6rVb129lhzC3jvuHNV8dzWXcd6s6w3qvrH91eYcwyr8xzr1cuVClN5jnMW7pAAAAAZ4/9RplS/LlUi2ZWqhkVCQCmdakqWGPcJlDOMP7MWxgLV3hezMhS82DW8ktESseSZ95BvmDY6tDnRggU9pgTBg5+0EKYg6BaB44H+u882Jy87vswEFstRe/QbXCnWySXdsVSZVk4uuossnlQjVeueJ1/J673O6pxki8lIHapAsOYOcPDhQ27mah1csaeEyudLq6VCAcFFgVBwcDGDrx4YEA3pbCCExEoOtkkHCdQWMFnjYI/BwOL0r4IAqOoAZB4YHy9CNJudTqSWyJB4tuZhIoGFTcygVtjMqoEHAVj68X7MBDhpzrMxRCGEEnMh3YIooFxKTDGfnpYLARSEknKBMlPmCYdnF4sVrQrF4E1fz7HFbHut46UtsySZgMMVlX5UQlva8VmB2swqcnbDP8+SycTJg+UQXCU25VT3pI9KJWEA5wRbwq1XTsQrvuMyevZjtIzqzLL1typXhP2WvPq9Dv4Nhj7p36J7MpTL52AYfhulvwFjvXySzl+997+HbPd6r5b/mp3fLPYxa/fL+FS18xldtY15293eWOud1LrfP/W8N4ctd7hh3LPV3G9S7lt2pIsMaWmxz/Hest7zy1hq5tpgAAAAYZf8kYfqzp/wWORKzcjXwaAcQz7HGX1s79QIctwNDtUdglyj7y11CKLNsXBCBLuZzqqMGXtWWErOg2jeOYhGXckjmK1MdTarIFevBc7N+NDgb9Llbf/Bk1xnaSc/8R586pa2M+2vm9VdTcivetcRrioOFLZscc/wlfjHqqp83rB384pjNPAgsMaZzcpYGGvcHGr5x/qd9lFRPa8E5Q2qnt3Ws/1XsJKez2rFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJToRMA3vDcqcsaaBLK24llg8wDfMNwkqp51D8LXjf5TIyIG2j7G1lwYYaOnlrwK6mFoCADAnHvgYHsIgQLn5g6wIQFlkXMAIjkClDQBFxdNWE8xqAxeFhJhTcDbh4BAaS6RRADA71JidlIwGLHAIIRFr5tScUxMYIjxD3SgwACU2JDTrIViYfA7vKrqbtsv3j7hcKSd6Q4vgte5v7RfHDLVaRTsNz9KBov9YsS1HGRy+DYDV1RyvKQNct17kYTkjcehqoumTS+ISaCGLzUqk8EW8sn3WDkMZope6iiMxlk1uYnb23jkWcvlURks7D8/OQuFVH8ssWhWpZH3ilFru5qMW8cr1nWf6/+fz/7hYw3z6ljXyu/N5Y9ys93j2vhjM5ynmOdmbw338qnd6w1nn/M8td5j9zufdY1rt/V7Ggsbw+4j+45fBZXcZ5IqDtCUgFWCgk6TYrwmPfva5BVzCvKgMvHoFvtkAi8OLZty9S+QxxksrUfsYN1rq2RSW4y6lV5HZHAKt87nqhTubNKrOT7trdQLCBYApZWP99CmPbvUEF9tzb9C4thr3uWZzoOOWmC7VGpAPB+ak4QmcSUDk8w+QJMW2za/ue/OMOn3MLdjGIGaUM6a+9W+89X7/+L/j+U2lxU/d2/Ofp2eJ/jNNzf0qc5tYdDbdSIEEcCbbZEzMUAIKCjDGc5kJAgesGaMKCkWuIYDXGbKFyIaRHJeMMAhACQqMjDQVVVCBG4AqBzYY3TaIQbLJIbZJI8R1clr1DzBg1d+OtTVVCwcFh6smG1WiMIKWWIoKgZGAiCT9LAOuYOFyWUgl8bBVRrUpfDUvJjW6mqsD81ykWZnUwpg00v+s6aaV+zL1osnppvG7X5lKJVFasxRrSjE1T1IadC9Yl9zlfKX4uPNT9Ins0KfdW+9Neki+cYic9bsStzIOh9/KGd+MTPW1p3YllK3j8U8vi1ST2crda1j3XK/5fhW7lZ+1nvL79/Gxy1PZfjlbt4Y9w3vHOXbx+luX8MMbWO+6/WP01irW3jYxrdx1c3S/cwymbNDXyq8J1XC6WAAAABjX8ND7PGUJaACVmawYWilL8NvQ0Dn6Y2iNbt9yBWqZ2J6qIgUcAVJlZU58ktvfIbGG5l9dz90Ry99LECQqiygIp+34C41NHXSrr8pDt1638n/4up1S/nc7+FbfZAj81BpoPyiZ6U67yIyNY818TvdHuiVG0oaqLLLPSnW3LGSSnubRm3pDkUcTD9L////UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACXmGzAN7w3Kr7Om0Zwtupe4nMI3vDcqRKKcRjD16ysWqUGmZ0pGyJkAcGkk+ALQOUE1keTFkY/Q9DAxp7dwYXArNRMZO2iAcz8yGhcsAawoiKjOSwiADBgBewiEzuFYSAwQMqLGApZnD0DhtEEmH1hDL0AeF2qqlXICD9mb9vmwQCBKJMPN0UNAJcPB199IYBog/1TF0zaUetBL106qaztcr/B9JyhaouGpaijPxck7R2oFHkxTVMuRwsZbUlss+xSStxNyhw3zj96dicDujFJFKn0u/bpY7TS6KQ0po+0uhynlMWpa+7M3Ys0MXb2WvXKXDfnUorwBK8KkTgp4a+FSxKZbhf1qz/P1e7/7zxv5Y43eYZzedXn0OdN3dj7Xd97j/af8e1sMbeOs8t9/nMc//l/m8eX967y99u5hZ3fidfWGWeN7mdm02V8BEkAAAADff0+LoZ1LMCHYWs+7kyEfBb5dT8Zze3UQ7tpXsXEn1h8ILxgIYTRs+nY4CB0VR7cFoxui7tR9f1aFxJ1XmwtRt85By7bWGl0y4OA1I02QZl8FAyr1D7upNP2Eb4OEz5tv6BQ9dyAdk+uRAH7WuaRV9r1i1dxTsrnuWb78occPQHwhYcfyGqF4P31NO5bs593Hzd8y9nFdVarV7BVN9P//TyjJylyxVayAAAAB3duKA19OzGF7JOCQiYJFm1GYOhU+0kyw4CQqPAV+cCxsAmVS/NYNm5oYAChAaKkJ4BHjZy8woGLQvqYIPGLMJf4wAKWMLEh9w2xkRhKYQ4GPY67/JjiMAXQQgjDVhkGCgcj2cQS7MDBnVhT4ofmXkShDt0Cjo1woFHX8zpXO1nUcSFTtzIUExyzJOrCDcbMqoVHpXHKGIoJ8YxKZ6FV79ukjVC38AOkt2vR1pp5XVnLdLH7OrmdZ3pValTHm4ah3kUic3Fpm5Ld4cg19aSYm2cxWpK4xEoeqTNaR4SeSWZq9yprcqtY95a73e9d/HHKt3WV7HCz+su91vu//vMPub5z9XK/cO5TOque633d9qawy3nl/cf5rWWGUqyuZ8jONzusefvtjmGerxRGQAAAAP7+UyUBxykRUME4VqlvpaEZZzOqm0RHv8ySdSQzoooh1ciVtt90MNZh/F6mvWo5O9fp372o+rc/FBL5WC2j+Hoaj2iibRYJt4XDKtZZrJ3P+Vv6xijuuPpNV/ki4tdmr75m3n/d6weoom4NmeJnFVJbet4g13lqzjeq6+tyV/zaNqsOPF87yBsuAhYMoMMCqCZ1RmQeKgVxJz////2y380AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlGiswDe8NyryuptGMPbiTyHTAN7w3KXDEnURwturv17g7PhkNDN9JEEJZ4jy5TJUaDDSA00TIhORNYC5wBsBSbruWFBEHsZdRHIEg4qHHakYIGmrpkCAsM+RC+QOG1oEjQeQGJApGq1lAEArAiBUv4Qk+BwJIuDh4WT+Gl+kqJuDgKra6rzugIB0RiKsEefZfpuw+16Tuopha5Vqp5RejzgBVJUHX0l9YozdygklE51PIX7YtTWcYjDl+mqT7axdxrqjTK9t9bjjt9hPYvHsqmNeGL1qHJFEnkidjUpf+PWLEZzyzn3enc/kTZ6m63Ga6klaMOJLJLVp8cpntecz1Uqfl3VTmPMMLGNW9nQ4dw3Zq0uWt93hn+vyw1Uz7zVqm5lq/Pa3r73Lv2P/Xb/Nf+X7/9/c7Wq8r2atn+/+GePNaz7qrZoYAAAAGHf+YTh1KnmLEhhE5UmySSCWxvNRom9heqIdykMgh2gIAk6G75evuHZuctt2XPu1x4OvrR0TZWksrklIwuX71Ss+TBz+MvsumzLtuJlG0yv1reNt7Jv/LFG+N2Sv+URXGdNGsekHf1iuMSc8GWeFpU6rqOlo1MXjZpR8wXd6tfEXXjYz+6l96xIe4modLYxrWfj5x8Ztn5r8/yVMLhdxcgLCp8VHbNn///7C3NXZghpRabqRNPogDjpIZq7RUWCUzN3EhIjhh9hwcAVipGwvQGlICylA2ClrTEx02MQAow4agRhU8aspoVgomc4wikMqU1MACINPMLMQQDtwTbdcLg5mwBjXfMZHF6R+gzLwpmRaBlSBAoBohb7tOlGBCVpmE4xKakHzDsI7ymX00GJVqcalEUBMyIN2zGBwlanvrRaBT16GnkPcpW2N5rdBKH+ZlAWEsgqGu513pm+dwiMvpJRFI4zGCnAyuSp0ZXKpXWltXCefl2vxwqv9d5p+nJjtPUp4FlXK9SQWvocc7PaPP99p+c13fO/ftfhnuhq0OOFa/reHfx/XM/+5nP3LWedPuer6qY44b1jrLDfccuZ/vet57uzlevnNT+uW9d/nK32DmxSAAAAAdsoBtEyPhrgDSTjGwQ5vs9aY0i1b/N0SKOt1IdJkvXf6kuTDp53KLr2szN6tPRmexbK6jlUFhWV1MtU0BP9ljnF879OKgutR4mG35iio/QSr4K1qqSIc4TLeOHc3LZlriu30VNmXknf2U061mXE/3/H8XVzUkh+5RV926a4mqqN/bf9/+/jac2oW0ij/6f/6P0KSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJlItMI3vDcKsrmbRjC24lmiUwDe8NymEo5xGMLXhgAAAAcwxmipVgkQiicyXQINDLSEMGUJ6IwESyAaVqhhsQhOitautcSnMNpTIyCMA4IHBcQO5mYkBAgIF1bDO5Y18BTYJg1LQx3MFR4mBxEEpAGbGRjQkLC9NDjQzOQMaEFDljiwuHF0C06t4YHoLutEGJmTjJQdNCp6YGwFo3dwYyVYXnNNsqSGbUw6gWDVmKrZQJu7YztorQLbuqBwi3YgN1qvOTcLlNerAigsO02cw7OUNR7KLU1zGX6sRqOPs5MVg+VyW9EoYfyTyrCxV3jKY5chick0o5Pv/aiMtlT35OzDdeQYV5Xby5rdjWuXe5c13n8wr65rv8+pS4c3j3nObt65lcptZYVtY7yt2c8uWPqXd67yvh++7/m//9dxq1ancpipQ6yw/es9czvW8b2r/GAAAABj/7bIRJ3dtMOXa21SUDIE8Lv4EgnWyzrJ2KEwXIaRjTHGf51kAIk6H37pGCLXikERtDvLMItUbVkK4Y91iMT5221h0/wmGcKfvwgTwJVpJImXrVPGT7QJ76iZBJ5nLy2UDZK52/yuvNJFaDnEQdqxs4gx+cehE2uM8bvQNmakI3Dv2Pp8uas968JzJ6H+3dEz+y/hZzSb1hVbjpJtxxv///rV3KIJDXN1JWFIMHMLNS+6/hAvGDu48TQ8xIyQsDkRM99nqMIWCKhep1GBmYKY0/I8LZBIEa1RGQlQgAAMTNMBvKZCEMMFjYYBzQbcMmHdBguX2MzCAhNQeUfhgWIBQaQ3aMOhgkJAoMi0SZoEGi2NwlYpjgYYkCOfPwICui386FsDwqXd3AFGmvNRV56pfajuyucC/pHLadvxAHsukK4uy2LO67FXtiNxi1Wclo0th77sBRXCUPtIXz5NXLuVzd6dlsQn5C6djkZrXK9T7mEYt1KeAHti1Jupuhh2lgKU15m1FbeWdBIO58s/+VfD+Y6s83zfOXL+dXt65ju/ny3jlyv/1+6otbrX6Ovvl2R28cZVY5rdb8NZXf3+s8f/W+Z/Wr2ZRXqzGVTfcd54Z/u1pbTAAAAA3v9yqI9+sg2ASXrVkKtYrr8FbpFetVVA2gymXZhcN6GaWuFVRSeeSoiFLrMqmUpoTBnajfrOZPMQy3hRFLABh67EQXg4daLBN73FnlNnpoPjmc9D1/gkv31FMbXx9Mpq5+9K2rm7nQ5565hhrb5Rmq4qq5r+1F0IPovtF4RLjVAyfW9pNanNDAtD5kasy05P///+tYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACVaGzKNby3KliknEYy9epTIdMo3vDdq6M2bQ/C24IAAAAHc6k2MRzdiZarOiMM3Dk2CzSXpKAC843oKL1NBeUykoGo2BWYoyGRcA0iDIC3iIpxMEUFMBItJpgEnMiC3yBx4vYHbAcIOkVQZGohPyoDu+yEEABhweAmGAVhgYLDx4EBNLDpKAAUFcx34GU6SzFgWrH3CMMdPqnxh9+WgY15EzOJW4cYrURZpalCquDwYFjVCu8SKnuxqL2N0Ctspw3KINopbBdmHqarcp5HUu/jEMN2oJ1h2ll0cl8KcC+/kHP49dyO1LF7d2G8aacpZvVx+JHNSunbpRZWa0tn7VfOxq3T2+f+qt78+Z4f/ccPx5ey/dvC/hlzP9/d5rXanN81YprHMaK1vK7T3tcu1eZY/c1zn6/n/v6ut3vpq9+nu38e9uY1opz1kAAAABhv9vG/nfnSBIGvAta6MSvzj3S7ItbypxhWV2JPUIjI/BNFglis2al91sdm9E6VYGUzVh91Y4OgiabC6yzqycXitpAUx+PftgP9Y/dXz+2Xi0yh+r/5hoHXzKcW82+vJev+M1n+2CFiBhi3+u2GuLQc71vwp6Vcpv91f5+Jt014c8aHCrvfy828RvFAMUF3LrNOE5iHUvPWNarmfPf/ruoqoIAAAAGP/0cOQFLQZBbJgaLAtCBxC1xYMzGPN4EUD4ynuKRqro1A6Ypu6CCqx/BYJKoCaVKmFCqJxQFo2goBBUqYECCQqSi5z5oAih+QwCJQkoa2gpMOWDBRFsMJS/BKACEGHiZjlWfEIiEAUOu3GHOMlHnkeyB07TKtm9ay+kSaDjuwmXjp0Je3ZSNWURsZeTJqzE0jOv7Ow5cLpKsrYbPY27dmVap8IDpc93I7lXty2V95u3Vw1avRx9Ibvyhsr4SSG42za5aoa9uregKnhVSVP3H6N9MKS9L4Knvo7VnCtlX3nzD86mf9w138/3jn/18Nd3q1WkNPV1Xqa+/rme7+ruWfK9zlXeWuX9b/8+4fzDDPe8OZ/3PG/hhbq3u09B9ak7lb3Q8b1qgAAAAWp8maWHK+ykJNlLUkDx2KfUELpDrlAFrM2lMPVAMKKvHIHqQTuDm70qSAsTtiYSgv8qNHhtcD81JC0iTTdRhTyub+lU2IWuQO8HY4cwnImegTdrysTJu+xeNPDxHqVaurcr+o181BU1mXE+oOjsJFuyPcVRYTTGl3lzISl0Q5vycMHKmpUfpZp3XQ7tlNfPDeeNd+xWq7afn5qOeHLPEwWmv9v/1qeKsahSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAl9hkwDW8NyrE0ZtGMLbiXGIzCOaw3Kb66nEYwtuNd5bECEHe34EY1Tkyl46tNxbilZxPbYom3zcjSuIaIJ5jSqZxjiYAFtPL7iMMLEYLDAjHkWgYSHRdpiQCAAYmMhEenPDwkiMKMGBQoHmaDYkGCQCpiYGDgArWZIF8A0FBS+v2eZWOCqAmLTMiAgOJGZMIRaQTavVEdzT8EA7ON2BV2xeeWAfMQjg7PB0DRBXt/rlBY0WrwuHaa5ADVnOptWZTSU+L6PhC5ifrRikpsWwRifma+co+V5Q5jdhEGs2ZlIInDbZmGTN2rSxfHsulLUY5JM3RgeJxuvQ5QFKZXlD/LsopufyrhnvV/9a+3+PO2Medq95zdrP6SvUu440W+9uZ9/nPltjmVa1jcqXL9q9vm8+fnvDHe9/+eGt8zsUl69Wl0rn5qNVJRjVwCyVtsAAAADHn7glv+2KrtFglrOyYQ0me7pYnS3t+EHh2khh8Z6abHhDaB0lm5C1RmshsSqAkAOUt25Ce8Ig+ndhlkHfQODL539P43Kx9hiPbeB5II9kQ/TlReZmN6GHgt4gmXaC1cFP+s7th8dpyVySjKA8EK9rCDc1XfMQmcNJtRhJn1a5YbWib2QJkV26D8P5fP31z/TP4OzXx9sZfxcsViWyt9vv/+vDAlE6npWQAAAANY9xTJDHnPLdAwLMdSAz6dCYCpiNZMFkgGBkPsVhT60wVNZE/imh05j8pELHJRh4f6GhlQNYQuDq8TjhCUMkOBERts6ciqCaoIaHACN3nUIwpBNcDY0+7EgckFi7A5RiFVoWCTUOsgCxwEgWuuHDAiAc3RbOtLkxMttzlKYUvd1PaWqwV7NWnKb0tyXsgRTpLkHQ7Vo4KYmwbPV+ht2ONkblTXJDWo521Vmnqn8q9evS4TFG3aTy/uoBeyRxl+HviNSvL8Ll+5DETf7KXu3LHwuYw281HhSUUWjWEtps+0nct54WvwwqWtazr46/6X8f5vPtHds2dbt919a7zGvqZpfwpbv26S7r7nN8wz/DX44Y/+OGGtVreHc61mpclUuhinnK9y9Tc7nc+hgAAAAb/9TMMffqCFai+5HXAl1L6L9jioPvdyQVpsbDMVDJ+WYtVW3DdLVjjYbdbOVuvH88EtnRiTeYYtJs8m3egm9jH3tgu7moNhH9QQj3BEk/CA6F1Np94y+GH4iubhevU3cKPbCyhqfnL6ZyTH3w2qPNkufctSvh0+zSQPW81NZbZ531xH1D7/n/U5c7P1wOYh/1o///WXMjR4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJgYTMA5zLcpVKKcQ/C14mOhswDW8Nyr6zJtGMNbjdivBDsgJnNLUUDAOZDhxoYfq1vEwMwcVzEYLX7ApAETFQXVXcp0RQUGuDWRBBnCsIFHJx0fusCAFBhCGgAzk9TAYNRJMEIwEhBVo8B3rMTgJOsSBDYAKBSIdkRneKFsgMAi0SF07NozGCAsi67MpUGDB+HDpiUFLIKBSMyzbiLhLNwzfhubVpa7C9Ywx3uT/PCTP0OLOREEhdVhT+wXeh922VRqlwbrIqf7LYHkt0dmDL9FX7MzsxQ17m7uMPY09yEvrTVpFIpXfi1nd2YrZ02EgrXJLjD9akziLr1JTbtxn7Nze86meW7tPVy3nrL/w33f8z/vMO4c7HM98rYZd/O1nfwxpsqt6alm8bdJObu3LPP3K72Ws+461/c+7z/LdizWt2qSJyqW2bdYwGTiVO0AAAAD2+MAiNN+gC0GtWfzU2Qu72II23uabuPatVpO3EjDFJT7srmcCpjSNDsTFAiYv6KUMYbVrUrh+C5qEeIokNlWE0TuqCgTj46CeI5GhRFrIKF8tlOzEzmJQLty764mvmuYtlXBtV6bI9M7daXDE288c7OOX9vepZSsaIWrAntfQAVCzCj5GVPFGuYib/dZ//1NNXcLr4RMDEnrJAQKHGhnmUYFmigjSGnWC1uzxpo6JgxBHgZ+m4mBkR65MwWWSow45OHcEMSsOUfMvgzTXEODkxguGELsFAcOCyYIEYqIDUHNCv0dBGWmVAhkgYmGzkQAhixABhhkqjoVBAaLkQVDzSBYsBRcgieGMFnC8gmm84dIzyK9fd5I+1CXM/xkq4Kd5rowAo3G3bXcVbXILkr3TONh92ocm3vj89UuUD4P7L6fHt+zLpBJp6Sx29bx5O09qUyH6j+U0CRG/MdimOfNZQuiyfb4EfuFSaWw45cLZdKI63CikcxuVSupS6otWe8w3z/w1Tf+Vzuvys54/zGLy3PlTXf/HC7Uyw5n97K3WuzG6vd48tZ6/uOG8f3f/XMbX6ncrOt2ssrU7Xm+WPwu+byFNQAAAAMt/9siL/JaMsRbiMKkgRWGqtpsS/5Xj6L4CZMVrwyETDDl+ouZd7iztslIhdOwa9Ccz5VaFnmma9bk9N+J70/rvznKCVRiQW+jLCyEgxUw5CNIiZieSE6aelBJiG9IqPma0GWdPNmTPqdS0TInLQTJUrTUYmylpmbILcxQOubmyCKTIJ61OmgcMWHgyBobmheZZgtJVCtO9P0n3TRutLq7InzVCqLP///HMeUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJf4RMA3vLcqCKKcRjDF4iphE0je5t2lsxJ1E8Lbjf14gCRkWSIushS0zhOK5pYpfcviZMBC1M2rcwYGHbNjNmfraJS83EsAQaoTAxnsSYgIIijwaFxExInN4NjFwomAQIAmhk5lwUAQpMkRjoOoDEQ9+lgzBB0SJhCHsqY0/oADRYRYPGCgADBt1pYo4KCgqClAY6jxl9gQ4xyo8rqLBWJXDj/tzis6x66ofFWwxuGhBE7U67NOTDObPRSmkEsl6ZO7FLak39mK0ftUz+5RnUo1JL/KtyV9u27FjcmeqmbC/0ifyNtcrTkbnrM/K4NicsfP5mMO7SSOOtVjPLcss4z07jqlrbv2KlXmsM8cPzy/uGfcMt27X4YXq0zVmc6/9x/7l3PLDl3PnJRTcv9mOW9fvDHmXN5/lrf6///LDHPHm8u1JbKJVnZJJHEO81QAAAAMuautjjuqGmEO3OysUxtMtyrlKk87mF1uKmsxawCCTEYn2eGA6XjU53goqHIbb56Ew4Hvv+0+QPPtyX6l8W7h3F16tDkYu4XFgqKGXufImK0biHhZN6r3bFx6Yavf29l53Z2vTXK3/lv9NjllqyG9nTtpzc9+fzHb+9kzM5XLQMUUrphWxNhyHAwsy4Qx4diY9cxgKl/6vu//LNTSQAAAANY1n1MHWRIZ6zpuRqMeZMLsigMQExRIBgctZthwsMWGSgwkvTAU8S0U00E1QyjPB2KmOuxQQmnDdTFAMVgCBAyInKoaqZIMLBYGcwCCMXSzHi9MYiRn6b4AgQkJo5tTZeXoXWsyCS67NnTJgSCYwEkg0gIYWJmMYQhHolIdJPB+poiIxHeOIsmoN4xVEYOAgYCBjnokcYEPG2RcWcZKMi4bqNCKGBsZmyRQabFwco2ciKiIqWYoF4+ZHiJF4kyHHjhMFgvGp0zNDRRcIiWyuajyOlY+zphNlk4talm6aEvup+p6q22fdb7JpzM3NXumiuzKQndFIpIOky1pUElG2j7X0kK0k1U3UkYGBcc2MhjqJqAAAABTuOAVdZVAwWDxomQ1SoUBx5xGrDmkQFfyLd0Aileqrcgw6fbf4vGmnRS+WSplExfgWDpmVWH/lsDWdRyA5Frj0PBcw7fD8LiEljjhlbGqyNU0inE5sc5zt9cu4ubs9uqeHQltLvemo6Lh3NPYg2jt2eel91M76o8ueWo1Ozsq/v/uJv+f+b/r+DvTNbv///xe76gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACWmDzIN8w3KVajnUYwteovITNA1rDcKsK2bRDD24yxjiqZYozNwNyEewADGLT5voCRAcnCiEY++lYXyeIDBMyiYZIu1/jDRNM1DhDsWyL2GQYaZNACl6WYiCxiAaGgBUGABtAsCjLYiVcAACjEYJBIAEhQUV8hYCpyhAVMAAR7TAQKBIOUGJhG7RdkuclwPBVkbBCICPuLCVpzok2iGStESiOTKntvx+W2Y0iNu2wCjrRLgWm6caafkQOmpfSSiYybjP3JRhM3qt2Yi/N9xn60dorcYyhVeakOWeNztjGeicdp7csqRKV2LdzKn1AUtqSBnrYnlpty2QP1YgykoJHAsSnqWpblWf5Z61qr//rLPf9/u+02X/ezraoZuvLd1dY4cq46z+rnqzhdluF/6XH+Zb1v8v/////+Xe91frZZ972zKMKtDhSivztCAAAAA5lu4QCoM6SNl43c1t8U71u4VXQkUtyxUCZtN2X/BhmuT2FwDKaZIuNxGgWKZ7X8ZLIaCo9llzLsGxWD51czDBdcbASSDizhOIUWDjfa5YW7lR7WnytrMg5+VOK1NtdcTdbeHynCdX2QbWb3bN/vin3oRF1u4X1bUL6lUxNmHMRBoeoQHWctADr+tt0b+v//j5HHth+zQFx+nFFkouniAHPCNLc8KJjph0mmAuIOSTArGHzrrGdNnWdjotTswZsyek8p1HRiZlYIhSnZdpiMiZwdwWYgO7hccxAQPCmDAtdQVZGLEB6C+pMHIRCdzOnEVGIQK0ELVZ0A40KoRopIXcQgHWJwZxjTZXd5BNeCG7ZzM4sqmrS2mCzKaGYpdBpd5OLVobrx0WMtv9/VT7P0lTK9UsYXLNWNYUFLar7ywpat+CKXKT2M4i/tJhS3as7EpFWsUEWm85RJ4ek8YdmQS2hoYxDWeWEar6w/f85+v/X71+v/X81q9/KaU8w5Wu5Z/nd/W+2c+/lnnhlhhv7lm13Xfz///+au9y/DLCi7z8+XNUvb92r4NslmAAAAA+gHLBmEkxcgGoc1kxSYE2W2M1gk8bXcE4FCo9MRBCQr2G5QIFEy0E8UpX2B04donklRWFqUsc9s0cj800FwIfp5Lm5X5PVBkATmPeQyqNrVdqVg16QGWaTT99u/ZN1riX6+Jb3mxn+2vuFnGcQKRa0y6d2kgvd+B9Vo9mrm+I0Sv+P62xHtItyOG/ukPXzqsbeMQOFrN885qVHiwlcK4m9vu/76RdigAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlphsyDe8NwnOp5xGHvXiSWETIObw3CRiinEYwteKtNEVFjCqAFV04k+IwU3cmAyUs1shgjAYGXp4PokyDiUwxGShWALAKIlsW3FThwZTAjuMzPA4G6aQGjg0a4lKZs/MnIjTSMMMkMC64AOAxZMLCkBZICCoWIAAMH2QiQgFREvcLBDGH7TeU6cRdBat3l9A4tXshzJgECChsumbz7tp2XW4kyXk1qA4cgqRu2JPbSDZQ5AKZA8FyqlgSfgKM15ynhX5XH0vU8Up98rRiV0+T9TlPIZrLLeVPjjH6SnvSeCJmvIcrXKKxW7i9kPMadaPOO8rVZ+cgZ/YYk0bdV2oanaGW0WNv947w1vXf7v9/+H8/WsufvHO3Yr445b/71r/3KuarZRrljVjeP9vc3/6/H+WPzzpbc7hLqWavYTv4/hyzRata137+DEPUwAAAAP3q6WErd5cqFKVuzbgTMF1TznedESVMFycn0pbRXRtWYwX4NUWhZoSk7E+mYhvirYFIOV1UpmxNnV2dF4KWaKc5iJWznZyjLxi6/Y4es6XGfHyk/m21NT6owfPxTUSufjX+IGs6iZrJm9cqrOIbfve/LjwMal1S+q6+c/e9v8dwq3McfUV8xwq7iwArFvYlG70urmer0/0/p3Up2UGKS0pk29EVAUZEhzNFzLwAiQNAn0aB1kOSYmhmlJ4kCvnCTLqMBFSHjKTChA7cPMaD0eGVmpiwOJTIVstIOB4YPk38YAEF+2Ag06DlkmKA4BLcooq6CEcqgocEhYObIUEsGS0oISEAcBcoyDu4nOJBD/CIXfkEhQJVsPcGVx+rm1WQffr3uxK7HxMmnsmXwAQ57U3FJXdajUkUmj8itXc33sYU1y7hYzleqXsxWoIdxm9/hXq8gGHYlK5a/cUgKGasxPROWRaGo9MvZOyyHX6alW7KWnawzg2BZvV2Ozvcsc+/3d3f/rD+/hzeH5/d/893NZf3LnN/f7/Pvd5zeFmzUt7z7ym/eeNX8v//7Zz1Xq3rsqluW8+Z4Z1eZZ3Aaf0sAAAADHLmSREmvezMy7s1ZskGAROZf9PSN7+ukVEr9VENG2T09gOQUDTTcmUPyRBhEsuvW1KDo2y7OhszFZybnDIqDdJp8bGSV09cCMNeckntuRGU6xsvnNeuCvrmYmHcdxD5ZNvk5tJhIfPZZy6Lk3k/bXPY3e3dba5XZO8kS1yqTJ1hNBh9FKYyxyBM7X+Y0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJMINMg3vDcpyKOcRh714lahUwDe8tyq+pppGMPXjtLTMhMBV4fcsUAAgGAIYTOqXSKhLKCxaJN6vKcHIhyhE/8OjocZckmIia+0oiBIOOVzDQR7lcFa0aSQmxnRgoOKj5AkmgiQQaiwYm8DhoDMAsQgkMGi4LgzIRpKKgSoIWpRMHgFoIwCKwrBJWFnguL04hF0+Y2JCDNjA13ZZPVUypPK8KWgnatvGn+LTKbhfPCnxFQh0qNpscqPNL4OvTXYct3q8qeyve7Zv27fYDxtWL8oms5jC5llWnnOrTM9TQNycwn7Gr+UQlkYtQYy2HIYjE3WryvK9OV6ezQwuzjaytWPxw/9f/8/n8z7jr8+8tbvao6LfbNPVx7rmes797Pn/nj/da/eG+87a//+9//N9x1fp6m6abztY91rmGN5yEsDuxdutgAAAAby+4MqXBhK4ol8q+85BsgyzVvHMp67sbJYlCwzGGMhQdiABYdBBk8pCWCoeq9geHEyp0pXDtC4hoK0BafmNhtL62WUOX1Iwssb277WtZf69mxl+N43vWW9BYz7RsWxj4+sU1qufqHXMKZ3T+8XGMwvWnz8wd7+Ma+vrN9yXxfc2b71WKfCe8+musZDkVASkuNL3p////s9S96pHLMcLShXeVnw6PmhZaAVCNkhiqkclnLqQ6O6ZeboQwOxEQHhiEsRUalQNAjPzk71EKEigISgwljMLEQ8JWcOC5VVTISgBBiXyLoyxmFCxMSg4ZBwcJAJgAUDiItKBAABBxITT9sdBHREIimghcGCjQjCg5N2mFi5NM4wmpWb8sVos0W67i1KXN04Vm7tAFEA5atK6QuClk+8gpnoh9rN+dwgCV0eOEk59TKzLZBjWsROPUtJDufKW7LNTdiWW6lFGHe3axsWrFWlleF2VSp2YInZZBb32rGncypJV7+WsqtNK6Cf7hlzf9x/WrPP/Pe/1Yzpu17/2cc+7w739d3zl/H7upRf5lVmP5lX1lj/P1//r+459oJ/Hu4zP/zeX9u38tY8yvgWe62JiAAAABv/4rMVi7Qp3ELk2ZRXERkGZ/8hQkKtYKztxj1BeLgCS4DqIczCgvyUIYrRyByI/1p7WmZVYaU4zppbC3To61CwMrSmV9CFJgzkOXymXYhW76qrcQf2T4gpiJv9gpjOE6lsakgX3Cv8z01PA+8Xlg4+4MBzzaMy+lcuH29kvFzT03uSn9vC147i+fMUO0ta+mPMSSDL0x5NR2IWFgNfJhhNDsp//d/o9QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACXCFTAN7w3Kty9mkZw1upioLMA3vDcquseaRjDW6mcoimUY1HIrSFHcGEpxuWHR6dghATF5U1avJgBlYMBguogcIXVMEhYa2xmdBC6UIDOAk3ZcMHE0nkOhta+Ahg4QZZAYIOGGORiJANBg8NJxkCAYOEhAqNCoJAKULmy7DBQ4EhzBjDRu2jmSh76ioMjcikXXQniQy/TbDw+KPCASOPV32Th3CLa862dPcWJR443jSicguNvCaTQuGJDOPK9czIqCTwFLcb0++r/UdyxO0+NabvVr+UbxnpreOVfKpHMo3KJzstpJVbyq5ahuP4VFHIDeG792mp5dMO9yxG92aa7bgqTw5lf3z97w/+91/563+t4Y9/mGNJjd1lnhzljH952f3hcvfu5T3svy3nl/47/+b/eW7GVJQ1ocszFWQZZb7Vzx7jrVr9O2U4twgAAAAa5/HKKAbdh2jcEY9nEiGIFHSexK0jF6/xWd0odnJtBGCuSPIkCDyJESx7WNqoryfGWuRCGtS2XOZB8snYqyFs9epOvVSx6U2aeSqec1mNGMUF0xTuWGR+cHRS2KZ5GiPNlPEuPo3RagbUGTymkt1sdRnDMYJzJI0NlUStHUnUmdoIJXnS/MUzMdUziJUeNFJpLvdVd+3vrOO7TYxBVB8ULkUTi0e2r+9Saa16XssNHMiKIbZxTFAwC6g8VKaJpmcN5kzUjgoyocY5DmqiKnKlIyYG7FxgAu2UdATCwA2w9BU89wXBTXVMwwsNmC3vMLGDGzwxoIMELkuoFMUPwsLwCYMGJ9DQ2YGgrYIhAcDHtMKHGeusCAp9AUWqAM7CB4VF0R1FYsHDYh2LFjl+4j3ZgOlyUxkXLddKK9M4swBZWrRiboRcMmhMBMwi7RaaV178l5Fq9LEp3+T2dFzkdr0WU/LMZDlTWaLlSpLJqkhykllaUvHGctz0ohWcqgdYz6OFJZW/0OvZK6OTWbM7SSiJ1fkUagerWt6vfvn/vL9/v981z8t63qXZTtNK6XH+/vf8q8x3+7P8738O8lWH7/Lm9d59259/OLTlSZlE3KoAt6/esLfWVyQFfXZqyAAAAB+OG0XWg/dVXCp0sq+aUaddukupXNBv6TtYfSQ/TIIi5tPPwCJsLkRqEQIyBwmk2Wgv22GhX3IX6a3Yi8ZbPKsoFgOYgWn5Fm5wuyvm2SYSqVzMvHHk8suostQF5a1rGTPupJqGpSFRoy3c1PVlRNKDJGJERdAzS6kzFJlKSTQ2RQnnYvmrFiJHKKcwRsyDsiuZNfUt6Fm7o1LZs+oiCwu1+3u1/6YsLgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmNhkwDe8NymioJsEcvXiVl+zAN7y3KY7Km0YwhuK03BRUBTC+kGAMFNiHUQ3unBRrTpHGeYhzbrehkKAoIOzJzRkMcQWNnLAUlrmAwcY4sHBhAOjnSIRE0t1MTHRaAauFhkANZgxCPAQYEjoGaGMGFkwjDAwODAAwMLMVHE81LzBwdCYHNKmDbAofS0liTY6GqsKg6uJahggUXSF6wTLaWdJgS2KW5Wg9avexnn2bxUQtyamYZML2asAmpSjlRMx+BYekD5XquFZ9ZjmEQmqPe5yxDNBegaB6azSRKh+rnL3gf2QQ5Jaad/LKvS40tBSxyAoU4sIhhmUbkL6PlDszXoaKDo7O0U9bpZLUtYY/f3+sdf+f5/vuOX6s18rdzGr9/Df93zdrePd0feZ272u933eP5/+P//f7/5Y38LVBbpZu9au444/rvP7zf37co1aoNkG9MRIQKYNqQjJVlYN344vNmvfjLtZ8lS8yi95++RGNImbD9MGhuKNkjssficcF96eAspcxqXSaG2FsXTIyN7QZ5KmEjLkbup90gVzqid170n1+2OvvKfcfjLnnPl38/Xvun+Pv32i4uockN5qu9aruNl/7z0lh/7x86j5qxT+LFT18zA+eIEioFc7stqTEZagdX9f/9qqccpayY2YKKHNfgXBQoiGza5p4CgMZoa+8GwRnH/YoY3FB1ClA8YjRTci4aSmmhwWAFAy8YHlJJNHwVIDClsxEFfoOAzZxoVEiJEQNMGIQcjmaA4cAgwbMJEBQPEm1+w4XBgcOBA0mg0IWoRC6AtQFapfF9AUEOYOCABA2+F53Kxjy+2Iy6czbuw+vP4PrIKakmQSG3sanpwzBqaLyh2CZVn0MRtnckdGXzNqw28tg6kv0VBR7mI9H85JR1M5LAFDG+VIt+tQzAkBWIBgiayvVZb3GgfBx41hZaOxXGP35qQZyOhmcLFS7U+j1EK3dfl+f97/73j+sPw/9cvXO3+0fPzzy/WOGvx7ln9TlnPHnMqtXuuc73+Z/zXdZ2K2GFqO3bW7kHLT/Dgdo/+MAAAAD+aqln4r2w9YJlEKemRpf/mdYu7z9KoQzqbskJxKUuwYWAAvTFL06q1tJ5uztvlG4HZ9RSWrKaSzhIIZr2p+TbcHOWP5HXepwXDVQsIYaYAW7wkOS5Dta8K09EBAjWPq9+bY2bWD4SQ9VR8ht154HyYpc3Zdc+8XS3USISni5AxntxzJ8Vvr/LfzH9X9/9fIyDv///qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJfoLMA3vDcpxMucRjC26lkfcwDe8tysszJkGcLbi7WlawBo7kqaG00U3D4KYBVzF0VzGIk5OZhDvA0WMjEwINppMrAAKSqJMjRsCgxnKca2ZICl7GEJhmqkZkwBgYvMISQ0AFQkSDxULCpeZSTDRNLxCIGCjYWAxqIYXABjQmDQUWGRUJjY8dF/WzM0EAc4xb9kEPmDhRKGllID+REpYtM42nRXVUsdfbmGOxJHuHgVUAZMVblOEAFQvpTyuNxS831NamnAsxG7MRWXbzqz1iayhh/6tNfhOe+53r07JI9ELUajkB2ssbUQk060aKSOHYwpS5sPT8qaTMP5g+/wJLJZHZN2QT8NRTKxh+v+7z9d/9fh/P/K/z+3n8xwv3d3t2t2ubrX8bXcd77n2ktb/K5nz+Z/ypzueM3JeUF+7O09vPDfN/z7w2IWHcccZtAAAAAYZ/mkDB/MqArWxX7KVzOt4R9LSRd47TrU30RANGLGlIQp4JTS2rFnHcfBsFt7Z6jgmAIJdibswNT2Xqz49Mplz0T8Kn7zm1yEa9hBls1oEKdjCju8mcalbLJRC68tr2bp52VF7LI8NWefOPezd3XLJt1r38Me+HstryW+qlCmP699bHw//v+/5/6/5jiUJI3LQp/93xRd/p1XmlHQAzsHyiph52HOpjoAn7BRlmobw6KTh1CcEdhoII5UyVTY3ccCC5UhUCjNtZmpaV/DAUo0Q7MlBQ4dLVjKsYwIhjWJFRVATJABUZlIADg8xARCCgw03MSDU1AoHFYaIiWKI7IIH7DgZHZPQiBETx4GRvBpayUdFxMWy7F0hNrRqWbdZ5bNiG1BaW3QI6K9bq6j/gChC6bnImTBN4p+9OcbhF57DlqdrZZVKTv46huESizuxH83es18J2ZvzkxO0sqlUFT8a/KvVlEojzj5xukf1ymMS6++jvRu7Xj9JTyd7oxAN5usjn5Nnqp3nN//773/5/O/veP56lFXVelp7PMMOYf/cub3lRb/czllVlP7sXbH3Ofhy//zGOsJJSW6VERk7olxiB0bxVj9bmASw/GdR6gUav2kyGLx5GcuQWiPd7iSlYZeiLYTBsWnGLYgOPKL1yGIJntCZxgm8qjGYBmGDRlN+AW5vjSuDA7gtmvwRKYeZvL5Y/jcJVGxwhEhWPiV4VHD24Ceo1DeaeGC10VkcmqSrX99tZyuovcPIM9amVLpuXO6NJzMm7uoW7c616KlbeoPzT7tMuYob0es2qTkS67bNf1dVbv5Z/TLe62uTyGW3bSybuXrQ//XoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACT+ATAN7y3Knqqm0PwteJGH9Mg3vDcpCp2cQ16165cqtyMcZkIo62AQJZolkVjUsXMbeFmJja4WZs9NHCQM/2oNMdKTUTRA9NARiRuqKbEMtiaSCTM5UTAJAgCLTmErhjAyYKFpRiICFnsQAxEDAERsExwY8U+14UGoyAipkQ8Cq5SHwT7SWIgUhBVBlYgEiNuIjNAbTyCuhhUfmnwRRkFbNRdzt2pKt+BZY+bxA8qageXO4RIuxC4Zhdle+Euxu00Rz1uzV3btRyxYms84pSWt29RvuNy/njLq8w9vyLCnsxKpC4ZgOCoW4ShsMR2MPtJ41aoXxtYWK8jjteU0sxDEoy/f91/Of//j/f/9as8/eWNqV1qLda3rPf9zvc1lapcP5Z3bzoKvd/9fXdVKu+dwjNJnNyeVXp7Kf1cxVw2PrXdq2BXjIAAAAtncEKcrd0N8DTxudQEIL6+Ssk5/XkcTK6p2AMTMhyY0pBNRqK2JHLma4srYBjAccf6jaa+0OcjLGJXAwbvWFhgNZiTQcktcHyeqtJELDvq1VlBOqtAu7gJ0+zoxqqX7mLmr5m/5YaWx5PWTY01beyLiIY5Wbvl73bTrCYu4dz3srare2fpYExrHVpImr4BYJwaExwVzbb6Oi7IHwcAZQTt/30L7jbhwyMKHhSvfFRk0eLJjVIFZpoBocIWlAE3FYA2QSBzk70nMIETPQZFRk4gKjHsUmai7EnEYgZsYDSYXqMDERg6NILyzamZgIiYkNmJixUDBCJv8OgploAmGhA1oxAHIhwUBGmCMCRtWnYZ8rCMAjfLEAoskSBhZX8udd31CZVFMGRyK/b9rtbKLVCIstbJKRiCv6kqvBUrXZc68lqYyF+9X9xjCl5jh3HO7a5e13HG1jhFsLWXZXbzxvSe7Eqs1vVagwp5mlocIKmJTEJY31PLMo/PTFnGGcI/RS2WVKHGrhjr8u/jrX/h+v3+uf+Nedvbp5Vnbyv5d7+XN87T83hjlhqcxv8wx5vfNd1ly5lapO2Mrd+ZysatXVJk7HbIin2yQAAAACGsfzXEeCDNzdwM8I1+e5c3P4Rahq1EDG8PyLEOVDScm0FAP86jpiqAn7ApU85o8YyjW8O00ibEAVqDykDZBol5qSw9JQ9QIw7esnWQTviL5IA/+Tzs811FP1uY+74QbucacdMZcu0+ObQbW2Xc22oQl0n5CohHH2oOuCLlt2dUXOlwqJn//f6dDG//WAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkqf8wDe8Nyn8yJtGMIbqXB/zAN7w3KgjHm0YwtuqvbDhmJF5EAv4l+BAA7QSFiJy1UjT8861Qa40VrYk3kTE6rCAA1hVBU8uQRFBwmoW8KxJmBlxocEBgKVegVDTKxsw4ZJj56Q4PFqYAmKLY8GGEEzdghcIQBKwEAIICSsiTiCoHAKzVOVojxVdLToIREMGGBpekHJk3IalkmTlKaqirz4fdfb5bi1RTV4JTZHYEVp+VQEX9XW+D36h92H+l/6pKlP8rxnc7lSmkNr6kujO8KW3O0lP3uUguWeZRun7hvVDhEH8mn5ljWFiwxH5GweHovYvuzF7n6bhUpYzEKLOZis9q/+v/9a/fcv//5rff5H8O93BdzLHLHvcNc/H6+f2eTOGsPw3zWOF7ta329j+FSJfd3jSYWsJ634bd6n0g69ThOkAAAAB3P9sxt/pKdJKvQSsZFHcdvSyytyu5zk3M31Bl0sZbfWMg8rtvFFmPQ85NI+reXX4duhj6eE5A0XgqkkEARWU1qaUWopTQRQdYoFBzCQEBAJxKOrwdmsgdV4FBv4DJ9Slo09sPuZiX+C5bATEWrcT4zi7TlLl6/u4nPqRedymuEJPbgjWEr3r4p29v5m/rrjG7xdk6O/6Lna//7qvuStgAq7DSY77+CgsY0YMiQQpzmSKgBhS48bERYaumD0FGXnEZsYKRKrqKGRsZtUuRCyD4wJGFiBqBIVhSWAMKDPARXhkIQVQUkCwNBGGDwcCmAgxi4eokYKLjAcAAJPtuREihASUBjFgoBNDEICDgiQCwQheBQQoBUZCADik3WqJ4xSWTzKH6osogiz2cv9InsvfSqWJFZ3ehMPBZ0kldrNwIFwjGGNmajVDNZz17mP3KWmpIFvVnznbc3nzOYrRadyt00U1rHOiwp7j2SOPSZz1HKGBIU7DFZFlAMByy7G5ZSYUUE59lGUitXu/3eu6/XM+d7j//lrDjx41u3Ixaua7qzh+Gt/resLmqTDtLOXrP7/WfOXP/vzuGdmal1TGxap7FbDc6DzGsuGYvbQAAAAGHfzW2+eGxl4sGfj1UvamZ+6VUFfC6lS9Vu+IiAfTF6ebeLSk3VRnZrH3ljUrU4sPe6mqy74nbnoxXp4bnPiVJu3fpGwSaYbm28gBpepjb9sH6IkulKMWGcbiRdTTD+tM2y5vXhmhuorOXume2cZ5jLYid/+FHOY9Q2L1SwhSBfNtqbZES+rrplfxxPfP/f8cKhwcCQUFm//9n//pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJSH/MA3vDcKKKObRnDV4k6f0wDe8Nyqoy5pGMIbi5VmlHzOc0MFbkBGAOAhDxYRSDMABTFzw3KAFjphoNSBClO3A4oLmmnxh4QmolQYsxg/2MREAgYEYkYPAmFEAKKhY/MZPRpdBB0LByozLlBJoaP01zCgppyN5lohAzAJMKAQOSElyYff4QgRZwwcbLo2QcLzAkYpq9Ky9Y3JbH1YblWKMamJ+IwO6dSmvMDVqh6/CUhhp2qd2QdOWx+XU7T8JmQTmWFLqWzlJ9j6eRZyyw/8IpOxudv1p7DH8Ksp1T2LG6WvQ9opmP1Y3FIHhzF0n7cNnDJHzmpx9cJuryM43KablV6jmOX+71r8Mv3zWOH3da/LDd2dtR7Kza5O0mf75+vx5+u6x1VvVcKlSzjV5/P5hhvd/PPlJvLlf6P9TtyMrwmbKkzhugAAAAV9fgKASffksIAMilh8GWL73g9DTP+DErHvlFChOGwM0lzYUf31c67CGPs/yjTR4dp4Yl9FBq6oYsalTt5SA1KhJx7qTHiOETUjE8KZ8iEZR1MhO0qdczQKbLYfilzaqnejQUtlshoqd2NxjstIvGboo3omrKd0EtDWp1LUsxZZgaGpggiYqMwWaISUJPPWFUGbBRaAcQ4xD34z//f/6u2tRM1BIJg+qwAxEuO2QS8T9hQqOcPzIl4MSICBC0YKiGDAjvkgCbQMmQEam9IaPdnelhkQe5aOZg5kYKRCRekCDkMoRTBzBmhgQsZqSswMsGmJkokv8gETDgArFgcCqCJNkQaFRlMaWEgCWpYpK2foDC3itsfFQkHHUHReqMtnaemhpQGQajcFuN/x5nqfV+Vw+F+xehjj6gcFDLaz7s2sSqigbCX8ll+/u3TRua7UuY2q1+N0k9FrNne8akajWdSGsqXdNezwuSunqSmPMAjkjga9D8ZnLMy/03Ty3UXwzsSGzVlEY/LH/w/977/63/c88v72bnu1dTFbVjuX/rXNf/cd8/VzK3hbwxx3Pfa7NY6537Odb6a/lhhawmMSyJxim/BHGLaRAAAAG//IRnfPCnEUywtvZqCw9zbSf1M2uSzUEI/u7G6ERKDOynruFDWy2pMyFmyis5HZHbeF2GxYwWx1zmp4x6pKo7VduNNpYvO+tmLYsze6h40F4iwMDwQq7URpICFBH9wH3MKKay9zWNu+Ybt1ixowJw65cTw2OmF5uKu+b/rpT6cXKDkQRHFg9IdjrWR/CVulnX99z7r8XHLdxtNwUecoW+///Xd9KawAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJTIBMA3zDcJgsubRh6G4jZfkyje5t0mGyptGMLbqZ1NoEDEUODLzIwqohrsRDSQJELnpoBlq6JGVNICkAMPxEPHtHACZjA5gcONFAInMrykx2AkB6Mhh4EGdASIiUEBoswCCQYKBIyK12GARaZDECEoxOAxIAmCwSHAIqB0tQCg5PtFJRqnAYCBbqumDgM84OBrW1gxYGgoDKHN0QcJgc/G5WCmXetJ9GvU3RsbhV2AZxfEiylSiYVBCpbUh4TzlE4bcvG5p9J6/llA8tlu7m8ft1ZbRZ24Zo6OG6kssaxq5zVijpJbnYs6nMt2aWlh6GIMlz5xSjYe6UA5zL+z+E9VjV/O9OUde7Xmpzn9/X/////3vfx/9ckGFmrKLNe7hc3//+v/8cf7X5jjrDm95/+fO9w53f3+/hUyt4Vvmaur/utSmXXE6GAAAABz9TaBBq/LitgHJAnZAJsW1TJ4JqL0+K4XKLgCociCayXAU0SrwNcPmyoul0rbJ5oiNYUDezbeKeFaioTiEyMB9NCw3n6m0QwVXtj0oRSTnOxCsuBohD+JBhrklf+O7mtF6m6OuwfOvRo4mDtdoRf+5WhtuJJHBxR6QK2jXP9D6fiZ9//+Nf5/lKpUNF5N/ru//s/1kAAAADXJhWcBKzh7VQM6YjzkSHGLgk/OEZiCHGh8kATMxsxNJL2ykw8lNDBjCglI4ABxzgyTEpEPg0ICyIHKoNOBYRBSMZ+I2CQmbmSnJMPKOmLhSNokMPSFzEuimknirYY8JSoHCzYlcERgW5f5gbhgARHgh3Jgw0QnS6wY8JtMC4TRcEXKZQcgijIoDoIKZFczAqsSibmos8BeoopMFAZEXIWCgXCwgtaSlKOmyKlmspORQ1OGSJ8vGJ5NE3ZRukX2Jl61FlMxL5Mlcmh0FNEyJARqmWCZI8cSZ8lyjTPH0C0QEsl00OGx577el66ll9B0Ux7UYqdXUvW/M1LnEFJugzmjorQTWcZSpofSRTMjJI4Hg0c83aJhShAAAAAaw3MFxJF82AXmOudMFpIYwPRUC6INxyeQmKy2+zNr7+z8FzyfXGHs1sfI6eH3l1DcGOTlceyJ7m3GgOLY15C93JVK7NHVomfX2OKmW1hhVnWmijLYcb5idurF7aiTnDGX8/97+4boFqUPqnfdu7l8PZ3fNwnsddSqY1SrGbIr2uQ66a6+J//+/j/0/mV1/T//u//wEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACTJ8TAN7w3KpzOmQZwtuJJn9MA3vDcp7s2aRp6261+8TXFsmK5lfBu6ibitpyFwjRkQ8AEMsqAwWLemJFpnQUBQAkAQuzhhMLI4AADBwM9kQMIAlnFkwCJESKZKgmSEAIHwuMBQUNGA0iDGjpWNQVTEUBRYlaUZMDOUBBeHBCEGHA4IBFRF32YDwSLCUUWMOCJggnGVdPIEJraPxSBS0PSrO6qtB93UFRGQ50jCpyWTTMBLMKcuAxGlSqVw2udRuK2phftJY1Wvz3yrtnlmU8m6t+WW5NE6WxavYXcrNJYnoxZxwxpLdzX270Wl1mGpFOyqHoGjsBYwmhp6KP8xs25dS1pXYlchq9sZa/9Y//81////qrc+rK5qexzn53ef9/+/zv7zx5jvv75cr7/vO9rZ9x39fn1PvYRSgMIKuyv1j3Hw6/59AY4zyamzWCMZB72snKWjU0+dfuzFJVWQYV6qJ644jZfhthSj1p4h0sAOZg02uvGlss2bBlAEExWKw/cgRnr3uhDUVeyA70M24aisoYLUXoUNVzxuHa1jHG3JIPzWQu/CsHT32Sy20prbPU3DebmYs7EEVZFB3wci3Q11c39MaqxSnWxxINzhe9u1sXPfDmxd//fU97+o+eYuZe6c+wfZ/Zto313f+lJXlalgY0VsHiJlgJJwQAm/oxgAQYASnTwQlhm1iYYYmDixiKEJSyh4CABVrMZCxIuEIkgHOoVAoXAocZCAVMWBTIC4IDQQElEKCEZL9E8zMJQhAgwh3EYSEBoKBEr4sPB6QwAPAwGRSS3a0WBNE1AFH4HSHBIMwWcQHoUM5bjJQFuQzOU2lzLd1W/yzwgBYtSl4MIT6gewsEaitdllRDu1ycsSSNzWNbCxP3L+WcprU1PhXq18ZdZkFqHrfKt+xZzlNvDL7eONevajM5J7sAyK3XhiOxh6JVDNPdt01qJXKk7ano/TV6kkvY55a/H//+f//3v7y7/In/53L1fHmff5+9f/4fr961rest5Z5bsYbu3//ljly7n369jG9avkTr//eFNXZwIAAAAH4/UVoajTr4h8FIZWkschWX8tQhuqlmax9hsElQgz1YJzBLmahvHjwlR+Yds8JEJhDDiKiQtxe7p5Ono9YNq058F5c7kGKBq0mI7lcghsuUTrJUY7txZfREO3CQCrZgrftz1uuN+/tst2ug+oeVlA9DOOvjt/9t3qvt5zQOHzVU29XdMfW5+vW9v/1/E/H/f74vccmv/V9n/9fUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkefswDe8Nwosy5pGntbiXWAy4Obw3KRakm0YyteO7pkZTHAxLCmIAc14KAcCVAABBp6x8L/5qUOLCwKRQqgmmBxggEHDZKwmMiIsBSUgDDO6ExUvBosPBYIQTFw4INWXGEiRngKYqZGIACdZlQuUF6Z8tJQcwYJGBAiR4LFhF2QMnKwp3pYuCGETAyYQoBQEVaIQ+JOINGqsMxL0OoZavuotmOW7j0wjCnrKzQ5KtyhGtl0ihoUg05+rPjiZPNWImuKiludHUlWsbX0dihovlNvUxKMr1PjjKeVLVJdh65KO3e5/cvbnoYlVNjBdCwNrNu5CpHuX4Tz202FST15RfjFDLJ+Yzwv8///D+f+HP/m9b39bmP24XZq5XMv/eGX7/H8M8e7/6v/393t29Y1L/daq8/W8c8cO41wfEh1T8c3FGAAAABUw3BjB3s60RQYm7RlhxS+DEmFx1HM4UQgU4pUJXCnBzDuOlOlGgFYpop9xDbYVOSgvTkfDdVDoAZiiTbEezAu25eW8NrOiYLxg3aTQjvWmXUVl43QUpMouk497pDQcSoDtSetnr31XUnXZrl88eom6C3ZE3RqSVvUkxogY7omBqXkjV0UDzPPuztTekyTt9FtfWrpsyDnwVf//Xd//6d1KGAjAQpa4xMLBAOYJiYUmCwUYkTRzBKmOwEZJYANGmWmSDwBKwCFkxMQvJhYmTAcnFRc0WoCGwWJQcHGKFRk5I4K7DDSYSXzA3UOSSIAMPPGDkyWzARCJEEhQ6XktsiC24GjAa8S5cNkoOk2jQJCstLPsoMEAnWIAgkAX4feIFlCgdN190koZlGbdXNpLOl5z9rjPyYUS1eAJlCX2h1kYCtA0owm3+h+1ObynKS1ItY03fs2f5I8aOAH1pYtlF7mUpbnDFFM6wrZfYxq0F15bN69FKLOHXdZ5XljvUjTefKrsepIhJqadftm83H5Tbzyrd1/P/nP5398/e5Dlluirc7lvL/3z//LfO8n8s9Sm9a5nzKrnWnMPyxx1c1U/PuGG62FffL+ZTv8fcMu1myAAAANc1UaFAuEBJNImRUR3A8SKMXeuRPXnZexWR5aWTYJwzc9I2EypzHQib9vxA1Z+LssybpOyiRSht7EhkFjCZUPDWfQPDo7TbcBgILiLp73Ht2U16Zc7yUd6eNX9VHrRU8xy2JnqXLzbvfHT/dU+z41HzbWoo28mJGvc9KFBi4UAKVpGvWMtkmIZ/pXRoesAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJY33Lg5vDcpQK2bRl626lAe8wDe8tyrUsJkGsPbi5y4WAKYzGzHHWIQgZSFgO9SuhR2HIC+b8LBsI1mGE0Pjy+a6OAI3JiIROJEToVKWIKHiMJmY+CAoQAAJajDjwIL0h0LgVNGrAJeoCgJYZwaQlzFVjBAMOGDERQiGAaCoJEZDNQFiLfqbqUhge1RU8DDwY4ACF5cKihERPtGboClCqCuz1OCGZ6KqK09avGYenLsRZyx9ldE6RyTKYIjBYTUeWXQ1TvpHb9jGkg2X6n+0l/tuhmd5SqXSWxLZFUpqley+8UjUmqfZwwylWEzNzlmSPM8Ll4u1PNu/cdqx5sUWeC3KYdjkZyxnItK38vRmnyv7//1++/n/8//783nV3Ul/8wv//f5z+V8e/3WW/5+famXcdz2qnZnHV/Ln9sY4fnbxKrO/SHh2tFvgsAAAADKz8cQZq4t0Bx4vLSlWMJmJj1PHy7PxCksgRpHie6pnDLNxTRkML0lDmaz1CkeRjeYjVounSSjG4zPlehZ27SbydLYaoDTzctqtADOtKriq74aXPbtf8DtjxHdxHUuq+7/+4t/DVs1fXr/nXPa/5p8Xb3UxdqtUUJHoY48ypqHul0POiG329dT1H/93R//9NGt8VnNSZygCXwCQczg0NlFHMNNED+EQXSD0xsxcEHgQHKIGgBwGXuFWUwcSFg5ghbc8cgMKBjAwcLAoKXzGEAoFlVgKZmTgRoY0mYJDRihkYeIjRKh3MNGRIJHENTEQBwkQlUJMdDh4TGAZS8KBSYVlCp+SyawAKEW+EQgLCTo0McAQMC426iQMzchTIJd2rdeWmzupUNXjkvWHDQpHYioyTTzsqp5l3Xav77aj9JMUfeVrvL1PTy3nz8amrD/4fuP9lUxBEqgrK9zCnwq3WlUuMUfeW9vyd1bsxQ8eCXX/qwqVWp6L1Wux6pKYTG5dbv81///9/f//f/WGW+amr++Z85zXN/+/3+uYfhlzmFzLveaq38aT991ruGeNvGClgnYX+12tOH01/33qRqi82QBDAjQUJeYFHBseEKh4HOwuD4EWnOpSMtYTjAaxI/blQ4B8X5h2oswZHRQ0sKvirNI8dcPkYopW30CSGFQDSwXFKsmlD8y+GMKfOKJ7rers8lrSZ34rJ/SSf2fqrOud9s69PT4za+r4/vv7rS+ts3mg6raHHszZrXOv//jdI+oe3taPFy4TX1JaFqs9re9KxLWl516YGLELlBkoCT/+nuTa7+v87JUgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACVB9y4Oaw3KXCvmkaetupZIrLg5ujcpup+aBjDV4q1oylWY/LgsKmShUnmNgsYjFhYB5imjmkF4YSLZmxPCJDICMmcYuLPldG2CmlSGECsACvk4oQxCMeGCx48QAy1BBQQhTELwgkeZWjqKEjbAzADx4yvgioLpMkeAolO5VgiFmsHMCJhKxRwM3paJStW8vUg07btCqx9IvHacblVgCneNLGj1RtTsbzkTQal2cR6fiYipAkBUh2BZGiqxe9bicB8pNXoYru1E6O/yrcwq2L9SxUt3sI83Wh5HIxF7EHTbn5SK1cpM7XxWo9j/uPlGX2rSl/IS8r+UNHIodpo3KYxnasS2vBFeq6EEw3hc3a5y9++b/+a1//qix38qw7YqX9/ruH7/v/v+f/K/5XaGt3GzlWx3nf3z9fll+Of2fTPJsdf/0pvyKoiAAAAB+/ehpn1ioIUzQfZ8KVgEjYe0gqo7goVRz7VrNeGP1aYYQGu5sqPfH0AkQhpLRdp2pdxEMZlmIu3BKodZinivIjkdiOfmcsQHqYBSfCaTdRN3vMr824YYuluWn/6rqKey5/d8VF6FT3bD9dsf90z+O033lcU9585J9r04iqf0rdJMYfKuFzpVabpCkio///T//+ivPG+KA8CCZCxjJhAKmQoMYPIZZsz4AR1wGAgwY0WJhgMhzMkDTPxMHCCKhiboHC6HdhJYgyg3KJYGBgjIERyAkEjkRAAiRmWA6uVsL4mQBIsVBwiMixiYWw8Ob2BFgTW6pEWcUJiUCt4FGYEGh1n7dygYYzDLNwgCDgR7YYE3gKIC6UCdCy8UUwIecEMTSL5aIKueDZSGDPEsIiDFgzA4x1A0FFciJTGyNNAtpGqJiQhcpGCKLJGDMcTMSNKpPE8ThbKxcPpjwSYsolXIqQ1FMqnSoTwzRNjiIIM8SAwBpkEHEIAITYtHy4XRrlUjFGBGFNzUeRkSsUiZJ+itW07/pMzGBMnkDpum9Nfu2tand2WpjimRdzzG7Ppzj02dBzEvsYqSZJvvdFJ2QVnW//2NQ7qswYdqWasDWxhK1GkxOpAsjkfWA8luEBySKPo6aaz9Uj2qHvqgnrKKT0HWo7D1NFmIxOcjcmjUPXI8YIjQTUh1IpkMORtIH0sW5NKaDsYVKLhqpU87sTyBdQslMulVRd2R9VJFnSZaKZqZOp2QRM0FooqdrIJNKzRbMX3WTjUtN4oCLQSED0D3MYhC428jIOJv/////1rUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmVgEsDmstwmEyZpGHobqYGJy4N6y3KfzImkYwtuN0kPgQLAY4CwwW+VCAZ3bRrchJOGFQSI48YSA5xM1AZ2DAxwAJ5wQkxayI/JhDJixrkGkSkWcRAEfwCcDeZIhJpKVZk15AUOkcFSZt3pE0MiDDiJfQjFLDHCGovlB4Qgy/QZlEZdKhFUyBJmSOLJGiA4CWyTptlhjBUPQUh4CrY7A1kQEwvF+oCffOtSuvKb2crFgnGiVOIwSuKahcqEZcMx3KH6Z/aa1fpqaXVpm5+FmlldfdiilF6ZuT9ty7MxBcGw9tnLbM8dCEyeU3dS+tN4vtIIRHIFijtP+3eItgg99KsXxh+GbGFLak153KSKTF6LSueoLONTX8r2tb1hzv/zPXwBb5dzrZc1r//8O5fnl+ssc9bvdx5c3nXxvWef3Vbet1u/hfs7+tyxOcAuCM8GEkAAAAD+4S9Fvd5LUt6XxgEUQIIypOJ9Il0uzXIFKysZA0Oen8QEGgf9S3C9XQg2QtUs10W6VIkjKv0TiVPxedr7ZSHVZQ1R6IC/7MGBDdqDi5HUbdD3HRyPbwPDUbBPU1fKVel9/18XuriCNRTkdYSBuSVScVtKjls63M4D4k+VSHWbePVOi2sxK0XT4jn4+/I1q/////6V6p5QMixsrO6cBCg6DK848lIR8HfxncYcE8nVGyNIqUMA2NCAKBBCJNuwLCRjikjF5E5TUCwg6YSQH9hBdBoMzJM1I4xp0zwlAkYRcAhRKVg0wEwUJL9B08hGv0YEGFz4GGgUJOI+iEW11pkZWsHCUtlV48BQEafmXjJynEoqxgRgS+XSpokDSDF02CfLbK26aggqfCkKRMy5LMyJarXftvIZgOGN352xKIvlXt5W+SykrXZX8qtvvnHJc/krjdVtXhl0/Vj8VjdJFeZ01Sv2Kv889SrTu49z70zcIXS7k0So61a/fpKz9T9uYbA+9eiwu8/n54733WP97/LmHYXf+/M41t/vmv////z5jrPDPd/dnmdTvOcy5v9b5rXc9f2Z/PmWOf577v////u//K5tXFgAAAAZ89TtGjmaqxYwJAWQdHiiy67LKubfY4+7MtoskxG+lT+qzpm3b8EMvvjUYJWDiud+liLpvX7uPA/8gydixEIfj1qrGZa/XG5ZVdiEZp7hNbWIQ2ESSz217QSeZVH7mEHvZf8df9VLHpU02pRkPTuXJLbjyrKVp0MhR8m0RorPth57aY6I+LcpEyfpvvn+Jr2/y2Kzx4C/////+msAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJhIBLg3vDcqaq+ZBl724l9iksDWsNyk8upoGMLbjnxgwMVMWKCIjSFMTEgsPmplQXTzSBAz+pNuWj3ikeABUeMCQgwFV4piPZIjAwuAIIgoYmIF4kUGRgBjGEY2GGIGwBDVMRI2BpOYWCGMHRhga10UDFfAJPMSBzAQYHNQKFEM3sMSDwaJpWu4tkeUkVlLqg6Jg0KTOdpSomOYQ4UwY2wLL5I/xRmcwlS0qGxQ4wTMWb6dMvi75u6HudZ98RAJV9K+Urp5PLozZm7N+m7b5hY/uHabK/Vsy13YnBdqBp+1bnPg7G678LpKTvb1WIy2HHQpq8y+s881LBj3R+B6eLS51qGtyUyKI14Dn4Eh6mhdLlcyy/v/3v55///zmWGsN41c+fzL//mufl//+XMeZZX/uZ4b1nvGvn3uH4dyx1YrdwpeYZXC523/72jwEpr/zchXN6PIJRxZaKsxGU8qmSNHXY6n+oRxKNPLkGsplbHA6vS6NYr5tgkxzliDqnTirVZlIErznSjGfti6LD166vo+TRpH2OlYhMDlW+l0fUS14UCfLlu+sTZ3upTRs1TlvLBzinpjfxX4+N/43uus4dQIlsSaguOIPrX6+NXvmv3e947qO/YZFU7h4xi9LVjZzm1fO8IKQKNFBeazhU0Sf+u7//b/Rnx/zBHTrSEkBwEP8Rr4fdqDfpwCZ/rYJ9H2NsIAIIx04MWtEKoYFoBqIFgqZR+zIjbmCGjLI0e+EnFOkh0DGgoAES0rrmfyGKCBUGARrATVkS5IMAGrGA40YwO4phUgkBQDR8hFA6VQJesPSYfu41QQhSZ6zJ46wSGP4TqT48G3TylpdXN8YLYtMRmREgJVLrhUYzpur2QSAQRhzp6AlLnxduKyitOY3Lkm1/cMbMsmM5ixyliOFHDEpouPDYhn3zrPJFpZT0vKONS/VWHo8+0DVJZQQFhSLCS6XarTk5SzkORbVuzLoTM1I1R0+Ms1j+GHf/XOc5z/1Xndd/faSp+Otfj+v3v+by5vnM965/LNvlP8zrV3K5jj25n+FDhypjhO1f/uW/73+6/f673deT/4qkND7HxJQFAui8xocQpypxequ9Kd93clLRWWUlmH13ddOAWjSdKUmXCpfk/Tx6kb0QqVv17xcbjYvS/k5HJNrmUFxnlrya2qkLRbCutXdNrOllkAlLcnU7Yu/qOZi3/df1ve1WnXTPVa7e1FkcVLPcet9zS9H7LWMY5lexzaYybaad/VcKakOXWql3/6rv//rcoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACZF/ywOay3KTiwmgYwtuJVnxLg3vDcpbMeaA/C243jGwQSjEAzKAgQiow6BzE5bNShww8Jw4GGRUsYKhhhUCwsKozBSCJZQEIQNOh1MtcKqTjkBmiYQGBD529CK5xARbwVKsoC8cmbhZCZIKl4AnCL4mCWKQEBZmTM0uWzhjV2C8LVyQIaEGpQ11QZBOyplvoISIbG6N2xsZz40+5UFVBuZaq4WcxFGlxatAdRbPJS/Y4wy9vIPTsB3sCwLLoPdazD1DjMZdpog80XtTmN2V7pceW7MCUMvfGnh+I1WuxetSpsxyWyly52L1pRTUdWIPBjEoblDWKF7qeTyF1bMhbhCJbPxiTxSlqXa734wbIYdtclG8d4b7+q38ywx5+qL8890dz/q4d/Pv6/ff/Oz+H18Ms/vUNi3hG8N4YW+4dzw3rHtJd/KxsUk3J60vNk1N/3ie6bMnglVq/HhEI1ml3wQBPHB6H2qf89L5dxFnByYcV7OM4aSrXVWDHpSyVZ+2NqFZ8KeXU9I/sn1UpZVujsxu7PZwbTc50QfbkRpmc52g7/O8uEJtOUGLZ33+1tcS69nzR+GOz9vLH13FWnZQu+D9/xCLZl8JZIsqcnL2VLu6uot1KUhKDefiGgzHfR96v///ThLoyRBRsput4qCRjIOZyZES8UDQcBGRKZnFACipT4GHR1OHgNYExcjMUCQEQEwCYavigCVBEBDIqMnGDrKjHQkyEHBy8icKnZgQYYMFoso7IumEDQODmmmAkYkaRSGHsDEZMpibGzASkHCy9mTNHAQVBc6MABgQE0GvBwVE2lfOxgLAiuUMum+W49m4vaenehodPJ2+MJX/lkcEVoBgZ9pQ02KU0jmrer+p6XSi9aorlWUTNq1S2L93GVQzHK9mH7FXJ12lMlpF/S+NXKTOnu0VRwrj4Rx4H55H4izJ0LMBQFIbdfdBM4VsIZpLsE0NjU1z/3llr/zs85zvOfUv7yx/esrmW9f+H95lv8uYfrC1jnlj9eU5ZW7PMs/z1j2pzO/AKmD3C/18zrN/WCegDzNELD4L4DFcQewZQ2vgKUSLCIYSyWtEdWkbuyiNRhucQbNAIyNXV29WmnBhOcjb6KT8igegjlDEauGUfkVrH+c3jHTbbiw66jky5iHtQ+LN7ZAsbEQTaq+Op4qP+ubta4l5+7Ory19IrptNY6m5t5tdQxedqx4zyo6endfzMzMU+uuZ3erfU3XsX0Ns9/9n/u/0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAk/gUsDesNyqcxpgGMLbiYl/SwN7w3KZTJmQYetuMLtKFx02VMhswcNXSdYsm2hY0JqsBT0eC+AJ0VOYsAYlsPI7BqkojAGCPsEM07EmxgCA1cM/xPoLIg4k/JXY0nV4ahoCTjPFBUjjShDOBQcIXQUJTWipQRC2vE5IuykdKBropc5McbVdzu1iAYYALHGvppkCu1U40ZZOEGyMqBsSmW1GTUEvmHes6lxCUSkm++8dKVxi9DyyJE7s5fkeX2uTNPellXPs/Lqek5RU01cik1HJW5cfeaMs/fG+8bRIrOt9nZuwzbsXH+n78FwDD9267TZYAweKBMnluyd46azF/qU0IgKigt/JRYltXPWv7hje5rmHNa1/4alnea/D9dx/+fzWH446xrayxy/HXK3aSrex/f8y7+v/e62u8vd5e+xvv1+aOlF/K0UGoxRMhYZRxJhARGyNQwhAlapJJhg0vUdiq63NYxkoZCqFq66l6P0Ihtahdqmmkmo+/60YGp71eUSeI1WmOzNxNucu5M08NSvPqnZuxEiDzSLyhxST2E+32bLTTzN9tE7KgwdU6t/fF/zwz3zMnVVz1H97Wkw9R5rGXHTKYfYVHouDUluBOIB6TVdWJ4bv03LQo/dx3drfv+pXeLBmUV+/Ymsj/3P/0ZYtgMGUTHhOyYIKip0Yp1mXi4YjiQaTRpyF+AjVsgQgmGnocBMhMFNECBlImugEQi+DGxABDYiyxEJjA6BREwY3JitI010pKAQOB0+gYGGXmQCC0GkHzNw5Qd/mEGFCBkIEslr65gKCpL0zElUGVUlswUDHh9gDjsgMOBGh4ypJxf0au+mhHn9syiBobjc40Gy48vSFU5nGsqGh5JDLHvUyllWKUVD3+XLlSV3pfUmqLuEfyiMWtPw88ujTzO5Ow+78sfxmbNmRsjdx7YZ5Wv57s8jNLqE7iMdjDsXWhuwl5K7srtvxV+7clkviEvf6GJNAcplF65h3XMMdY5fzLtzHD8q2Fr+YZY77zutWd///+Pf13WXO2e28Md55d53msMMNdsfu/YuXAOFLvX6wPukn/ldHYMr7HqgQJwkIY+DwCCrUcq9Tx2wwI55xwhLOttRnJI/19DylgEygzxWcZKOU9i7F5OGI2LPd2Vbg50ex4WP2bvC2GcImAdl8rwsvmaroO1sNOGmIJk9np/X4+PmuZ3pNSY43PalJ3aatpnShJC6/nZfVKvlzDhuQQ7Fhrh9M6fFXuUau6ItscRU1XPffF6lPMf/u///6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJUHzLA3rDcJireZBh624kwfssDe8Nwrqz5cGHrbjsdUWJDM3IqWBBRkFSA2O1NoSjMwAwAIEAIaouKSe8IpmUblAhL0EM00QVKekHdwc9MIrL4mU2gteYQ+zQZZiWYAATzHAo0CL5YBChA0pgBWkeRUSjmLKIYT0MS8aas5mJeoJX2p+PhcCxJnbWWWixtq74usWzjT0uQMib2KRJwEmY07uMKo5+geB+bjmRExqpJA24VaPMj7vKUDUaO/IozLLWdvWrdqlprEzK7M1Mzcus7lMYfvjnahmmi7lSh3IwttYRfbWbcjl9XL/gyJvlLnK5Xj7pyCJU69LbEozfksrlt+5STmLzch3Ni8MyOpR0m+Y1L/2+fZ3jnlh+FezZy5Z5q9nvH/3lzuHN67znNYd5vWs8flNr88fwwr/rHlrIeKgIup+dpc0X3qSlQyl00hqp22xpO/LxA04ZafrESO3Iua+poQjiqMFRp5GF3cTfNWU3TjYG07jpQMRSqVLvbmW+huClIe/vdii0jq2NPZTHHFpEE46vkI1jlHzw+GtH7qx7DjXHBo3xv/+P/jltNYxKkkpSN6OqINYeDyeL+rj5o9MJc25BpgZQYXL3Vti9Lpij2Rwf3tJIIKVBU05H/9VNbUHmAhRxwuqAIbBkGM8K0T0OojDjHRQ59hXgyECBwUTF7PSYSNFUVIhLM1olGhUwUkZAFpxA5I0DAJiS4pyKkhmhOISq8zkiGzKCpC57hgbQAg4sawtgzQtTqVma0DBIiOlD2jtyQDOs3UvMYiLONF2KogEQ/OSaoIj0U287hPI6d3BjtixmsPjAcDkoSYr/wRTldmmyuqKiUYtVoHf6j1/PppzOF93S0t+tIZqRZRt1a1a43JuUtlrSY4/MPpKufLpIw6X2aOmzryyWxW04D8zuojEX5tw5Va7C5A+EuldWZfmIXMqlXT8wI28xepf7h2vvX/Z/8MMf5QX+a3f3yb3la53HvMea//x3/5dw5dy/PDlbHP+/jrm9719jv6vgYTwJ9TSHO1RAYFDlQ0ohWY1gdkoSfJ/BlJDdGtkWUWBMn1wea05PBYEqNOMDN2nFHKzQTzJin5FeA6sylhCAw5orIrsaUrbNCJ6bcZjXbaNuGdWQCR8m3EHXzMubAjrOdIBpb5KDlcW5+zif3Q/1aOHnHzp4oMjhdRLNXEEbMOFZJhFr3eknbS+K3HYka0SRJZC8ycY502xo7XVtP9acbuaZC7ZpS/m+ldNbtvWOvejs6/7KQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJOn7LA3rDcJxMaYBl624k7f0sDe8Nymew5gGHrbjl9R8LlwGHSoNGJAI4oGudyKZgQALCRiY2ceeIA3AAhEz792HgMkhKpceTTBv5AIEGyEmIKnV6iXgvoqUxJgBXQSKG6ZlSw0AWUBjgiGERNnpAPBBUHOVeNPOycEnSO4CAmNXFvEsWxDodOi6nQjSBBcrSuaeloNFq0XaOGWe5zKiabuyCq/0hm4MrMdlMzbFRp0yl9WuBF5IrDDIFKr2GcLMumssP5lTVcu0k/nXtV8dWZVPU0upI7D8fiEuh5zVhYDkLEFbp6mdym7W7O4Wom/16foX3juNSORd/aR/rOd+klVBjuUXNwDUdTGxLMdWsOXsLHc7GHO19U/bl/drPH7Havdc5l+fMv/Wfe/29+/3l//93PeP75hhn+GHOY37/kQ0nrsKFv+YZ4ThMjc8qpjqrNZaoaagwc7SWVTnaUhZ3pWwlUOSrtigladRKDHRa6UrfBPcvbZTm+nrogm7IxwhyIB20M6onunilfNnXZTU9pDnl8R2HUJupdD2PEc7TaH6DshmWztjvd/fM7KpKtFFB285B5qKp5WobK/t44uZKjPbLlqeNzTrnzNKdVC25BGlHd9S2P3XGdp7lAO9zmf+mnvvqDSYxoGKg4sCYVKGv/AQ9mEgyegEETYAZTVtwxHMYIkTZcJRRgQGPGSJhrxCDAYOSyIANuEELRYqozQk1JAoQBcSBBK/CSBhpUZCMIYIrEgWJGBbxYgUEzMCJWJ6wQAmIn6WKlzPCwAkQCy1BqYGApi78uEMkS9nBehQ8eBGYFgJbjj1bTPqXCB8lv7ltOKDlD6QQjeGqi0ffASa7/yTOM025ixh+ccorHYnYzv28qj/cq0MpeJ/Y3SxKRTkveN4GVsJjzbVpfnj2/YqSqU01BTTcOWqWtG4OhuHK8J3fs37E7bl87FYfgGcgO3c5j3+01zVbH8dbptb1N5f3eP65b5reWX4Z48/uv/m//+Y/3Hv2cO67v//9d53m/1e2cWvb/yvyq9P/NPCJOaKr4Z2C+oiTr6FbHbpqxGfsJoMMWOG8rkPXg8LxVLgMqh+lyXashIekVKrjdMFvYjnYnlToJeqYkB/E3APQ8pH+kQlissJalsYTDBx5y7nxN1Y87oTMz1ODh6u556/ZXak8dRFRZvrPRtA46y1AuROQzj2NvZzsY1A8SXNe2b3VPcJ7lF0Id8w5u6HNqz2kPtXAf/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACW5/SoOaw3CaixmAZwtuJgoDKg5vDcK8sWXBrDG4js0kYFR8YqCsBvqCGkZxjYQK1nGGhAYyExNIXEJBIOHnFLs+LumAPCEQRKguAPClM2RNCKYmZniZksZIKluedwDChjmp2QrNB4Y25MsNUdLxEwIeAhwpl6eyVAR1cVdSQhomSQ9lO8kEsxhovqX9Gmj6F0mBGbCvpCrYy1GmBr8NIrw5nbcvCtTviuKiijhl8pfC8TEJFqBY8SEXuya9qHnvqXo9S63DNLNcklqrRR+CvlMpitt/ICgZ64YygeEpdwG9ia5fd+2BNdqbm7kellazQPa0xy69uK2rchgSIPRPuBKop2vKc7ecsi7fUsANWjEbnO2+81j3KY1jvO/hu/lhzmr+G96xwxx/916P9c5////l/8/n8+Wds5d3n+X5/3HD8e3PA5M6zTJhtCv3Nt1Hg3QgYqLnJQjhDipjFDIm7dR+ZdvjJYL+qyyAYeiQ8+YbeUMkqL9SygjUpe3CiiPt2n6B0WzYSSBVYZHnagPKvJ48sytEcXWyWcL0X3ZmiyFIl+vtkd3eNhDRBEV7+P4r5/dGozdTXHFXOVi7LoKXFQ+tXZPF1w5xWelplubVSVEhBnM/02JrWBE0NC8EQI80Pa001//6qWVFgBAEIGgwegmYgYZRRyEfgpSiMEGFCkYaNwclXERNMgATNh5obxGiAZCdOEVR8gNDBAMyICC46aitBAEYmHEIwccSkJIFBAo5zFBVDqX7MEDTCzZ23ZM5MDEB9P8vWioaYIsNY6KARggeuxSCdSkFEVnQWt0DCrO3STcMOBGlU0RKk5dVmKdb8fi9HDu6ajkyzuT0yTFWx/DXyvVrEElx2KSXOjcoewHR2oMl0nqzGVH9uimLdbGn5SR6LQE5lFI5ZGnVZlJ4de1iVzF/aKkpKXXZdLnkhUw3SQ2s4YvUEtcucqO7i7Pa2c5cxuWYMbjKaTtNnjlh+G5fewyj/4/yc/upR3DCj13W8t7y5f///+dz/nO/+v7qnnLdNh3Cx/Pxz5nlzuHdZYWEGfKrWQ/4BVnKEamc2KBydRHHZZGZsOTMuyRsf4yhe8/bghkMhe2Eg5mTm9X+shCBWtid1r12bh+KN4teH5cz1qM/JJxj8Wj+EZtwJPxdM2/jNOLV6EU1/HSdZ+WZviRHP8a5sglNfGhH1LdFmw9lNztm8572ddy1upd9+ySlIn9Kqz4dndd/vebrVZFaarGn2nYF+Qz0xWr18Npr+dXaR9dvstLtJ2A8IHkWMPpT/0u//9FYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAljdsqDe8twl2xZgGMLbiXx4yoObw3CarAmAZwtuML6R4jNTfxwWDVHTNzkxWMMOJQKMmOghC6Aopghl40qGHlMEiEqDC0eGkrCQVDJQDCJlwaZQmmwEQQqGTDZiaUZGHgEwMcmAgfEAWDgIxoaCD8IVB4JBIYTHJkISW5EAaYaboc2RukCBASWl0JmJomAghcO8uQiHx4QgZVwwFBBDLYrJQIBA85QLMfqbeNkU9rOZXc82EfLvqeZdAqjgbCzRoDSR6pm77xGD4ds0NeW9xsy+zLbNq5lK6WxqXT2/qP5AlDKHqf2s6MAsgiG2w0jv/dzl9NXuz0qiFFXwnKtaAIzHYCpl0R6RWqKPXf/7mNWCnYi2r1Hd3vP98sfzOvft2pi7er6zu91zk7hhznN9raw1z//9f3n85/aLHlLcsCMmUcJGJGJIoRR8vr4gShXVRZBQQQF4J9nJZpA7c06+G7rZ4x9BAzvyFPYOLDcKnGbwUW8lzV4qzvU7awgG1LHhSfrXpZOxyXynsaklqhwYbKIxGpHaqyAuMd53Y1blptd3bbqAZWWkcr323njfXLfuX75hqCluPvPJWbScaoxc7B7313MS/ZEwymExxlEOZv4rqI+U/vlltn+n96rYqqM//em5eUxCgxCFGXSQTmOBmdNBxMXxYCjBMBB4KA7fKoMYwMmYkEQCxor8CG7jO0BokvoZQCmAhpvgmgaPKwwVHDgAFHjZx0wYDCDoQDxawxcsMeCTAQ8ABJno2DkohHUTTHB0uEgNIAYAIAk/KilzqCRKg9BLMU8AgBlTjhUSEg14ousQtbDjtyVEKJx1TJfEnxqWF+2p+II+0jd1+JPBqWZOi2MeZA0J9mMapsYnY3Vt001nbnZTbu093KV3sqWX5RuVxaMQw4TVZBafebbTsYl0gv7noxawjEbZlSNZ1LJ6DL0tj7+ODA8ppqCewz5jjQQzqWyV9rUuvYfly5ha5W1MX7FypbwrT9qvzfK2Vzv5d3ytj+PO97zvf//xy73t2pyzY3lfjolWIWA1EqRXlWjPxtEJI0RPygdUI2Jx+yoKgfCM9QPF8Y/A1X7kDR6UDBGbxeBWN2pyHHAjDc2tUcW1Dsbb2JTDm2pLHM5RcxpaKzR3mYxe3NwBJ9PQDWcnKvyQxbdRZdQ2JYwQJUi8smpR4r/77iNz91MO1N05OD1M5KmlBq6XP65dtejc1WzV0D55rEo7r4l1zUs392ymM9SAGXQPJKCjE//UpIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJXnjKg3vDcK7MeXBnD24lDd8qDe8NwlYx5gGcLbinpCECMEHAWLsVScCpYcHXmLEIoFABgMqgDHgKUhwOY0HmeAELFTZpgXOnmMLLSgdMNEwgUM5vQgRJBMWOgY8Cw8ODxjACYCkrWJR4hFgUjpKGFAAVCQqcPoPCa2zLwZmiVqZBjbkSACk33LAUPGqk20RETXUg9zJwCNr8tM8KgKeabi+g1F/GmSdr1FvB43di2EFFB39i0iCj1+RxfYrtoDxxjavodqSuHO6yw5aidjt69L7en9j8RnIldga8z6dhT5uHyCHwUEaCxSSuxQbyhcMXrNuVUc0/772qCQQLc5LX7dOGn0kt3dPZnZd3KbiW79qKy+rljrDs9jT00zUt27stv4VJdvX81nruqvfvZc1j/8w//3zXfz/vcMu7w3ha+88JDI5Yci1vGGN5QSKxhwMPNhQqZQwaRlUEKsurk/jlw9hGYVP4xyvL6xVg70iiyPlG3AMKwr18uE+2box5lNFM1kuuSO44zs0WDGHlmM7qyrd2igPK3kqr7tmSzbBlmzTDjf0+bWP2mGMz9XrSNvXxv4/xve7XxSf4puLel6R58792JhgOdoOc/O7a3X2V1JrYmttru/dRYfrb198Z1fOL4x9/4v77vrW4Nt5kshYRLlX/9iXf//6dV37FUY28AXo0YzSsOj1BGHkomLIRnyENSjxhc3L+AJ5jJiYqLAIoRuwZAEqmAgiWA85xAMdBBGCtaMvQQwpFhI5EDIC4wACMQDy5YYUAoeHigcGTCyOIOQh6EDCGK9AKJmdo7FWYqLgYbRgp2QIA0L36UML4mDAEdeCGWPSl0peKETMf+KezSEy2Vr9+7gtBt7MaeknFIXGdAFwh+igVhL/wb2BJBnd7as0GGOqSUztmIS+SQdpvXuiUomI83CjtRzFvVkT1AzmtB2Eor4arU3cH+ikRu3X/nLdLTQ1DkLdOLYS+ejNqrfz72TvVc5Uq6x5hU1Uoaem1fqQnk7Nz2fM89Xu4zs7fwpdc1lvesO6///e/x7vH9ZX7+7BYI0sMBJ1kUQlEq5O9YEk6z39egygi3MYvomCpq38IKmWgZNwn6T6eq+tMFSvlQO+Wust2KxxOnf6SUUMKfdt1oha40D8JtWfktuP5IK0xuctTdiIasHgSiw5qmUHlVl+0auFHd4y7YBJbMlv9s//UfN1MLuqLPVKziiziUHHHErZf//7Eapz29oNKbPpf1/LZur1n1beLe99R0cuqQltJIaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACY14ygN7w3CnLGlwZw1uJPnnKA3vDcJdMaXBnC24oLaRphIAVrqPRIaGOahpeOhMQTGF5oNUwyxT2MaEBUkDA2WixomWYuMUwGXlbBgeEZSduylYWFgMkHzUxoiBASomcmhqAOJCaKBgAICh0ywHSNMSOgFBlx2+gUoHUd2yDKWIUBZ7FA4EMED5S3FVyIoOAlcA4KL6CyKuWKwwTJabYgwMm+UFShBtVtS22FPLKrG0Unmh64CWoxVXiFLIDX0o5YX4eCJQW7chq3ssatLNwmmq6jEtytUU5YkMdgGTQ5BELljnQ2vFr6cky/zosvo7ktqSOq2eBaOge+zSxNqOV3G9aljlRB/oYgXlyV3K2EvnaS5ZvQ3ellT+52cOyWTZWqB3besH4r93N4flqU6x+nww5H8OYZY9/+a/+d3vWPblXUrz+vsNhCHGCd6HM9tGvphFC0qCWBhr5gBR17ioskgVhxlrcQW7ak9SM8lHY5ACCCEatDYYi3FnUbp6XBxHWd52YPd2/qBe1HxYdnYp2j2Ji5Syl9+4Nr2XKHCmpw7kkkZj3dTOz1m7Km5SqEIJT0EGdF+116KJ5aLmSCJuT0jrJFJAmIoFTLJMzMFKqQTU9ZONnM2RqooupSCLqfUyLKSdJTLepKtM2ZU6tUqmiUqwhX/9n649YQyM8hCa7GQFzDvSg2zSYeYOBHADBiNepm1UmXxkwbV3gErs+HmERAo8cIihcTMUaDkShAsMETD3kmXVcBRfMgKA4sBIAMAgoKhQhWCmDL2gzUCbIrsxsfgZxFeih2bwCtch8iGx5WZ8ibCSEijQ8HqRGgZAyniQohYW9XUaI2Rm4okjjVwmVD2LcqsLkGFJFBbty6jeRuW5NOWhm1GnsOnh++ZWp6kfiMzGs89SizlOVY03bcPzzSpfdchxKZsFVvoWt59aCiwp4m3CXWJTDc7D1d84azqS+BuU0qdrUM24nO7w7jdsS+liVeHo3O/2hw3dlcVx37zctvu/Vn8L3ea1veFua1lhSZ/h2xvn//P///uX57t6u45Z27OQDSC4uGgBbRyen+SkQwwCzAhFADxdd6l6llwoo06tAjYHN3S4wfNSHsvh8WrIKRFx/bCnb7W7XEynooJy40GZuxO9ymbqlhV+ZiGpqK9mZjGHnsv+UF1zAfFcmNfDXrenXTTWs3GTIePbu5Pf1/9ezmkHbih/cH4qDqxc0mFFLfMVzvlma3bb+GEql7f/1zHVtUvlq/MN6Qa53Zq266e//6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmGecoDe8Nwrew5YGnvbiQt7SgN6w3KejGlwZw1uLVCzgxveRCC4aCSs20vMl1Ugk8jmxozouKyVg5mgIQGA8IDIWY2CCIOGiFJ0iIUNxQYEdECqYoLRofMybQMBosAxbMIVULWtGDFwskA4WScMGCDWAESEkeAKJiA2srDjoKYTBmEB6C5cNWUHHz8PKVQAMUUMFeszDB1S1+omNTmMawWQhrJ4mmhPVbL1uLuk2xDG47INGrmhcgdrA79s5bCUZl0GW4cpbOUAW6Sw9UJsUr1Y0M8/coswO9EqdmAp1kdl+pPBDIZXATGlYGIpu0NNOyjJ/HxZ3Xllb5U6LmU+Mvprtuy/t7DUU+xy/Zyv44vTD9DXg2jpsLn/Jd/ZmXWl8sjc5elNA/Xce/+spRby3KJTe1ues7/P//9f///M9dw/89a5u4fBhZ54decsn5HP58CFwx2zBL05RUDLIrJB4oDRiTEtNcbBqUhMagSGoisFNGazvwY5cIIs5blt+5GawwYRGyO22qB7GbBI0Je1Xahu/YCta07kW3dtM+62NxCZMOT7e5XmqeusXU9s6KN9nr7JbWNb/k+vJnPzr9s3mA49/NL94s+YXlHj9Tt+NZ17z4xNutJ2GNfMbf3mudRLf/P+9bp6Xpr7x6T+mWaNp+5hpIauU9w2//9yqzdWsFgoGkxFMN6OtYRfGq3giAjGBc64cM3TGsjIUFBZgwgcoKiNdRVSIaiNHp5zLAzm1QgOPDTFIT93hEBVIh1NiCUve8guE2xfxccHIi0BMTXeZRgZwe02wJFTSJEAa7y+gw+Z0gU64kCdlBqBQuLRJqTSS5EiMwy0cfVBc2tseNlTVltwim7RwzWttHU9Xzmy4kDwzAwFmjDLPduh5qYv5TeU1XlF+b5auzspqxVtI1XiN/cBUj7NJhDktjieDZ1/Q1O009WyxafRS6T+/8B3ZRKoTS5xuGp7ecAZdwzsZY536WrVv438fvfq9lnE3njVaVwe7NXdmHruOedn7uX4089jr6+s888u/vPm///7vev/H+cy3ew7a0Ejp8l/+2d8frxNF4a6eMcSG3Qcfg3IILBMMC5xSGnN1CKj2R6zcu1IanocKMw/iyFT97Uw9OcQYBF6n2Gm95L5ZWwilDfzztwdAE9K2+7unIC0TESMvpjn5PNO+ZoPWUU2h3IK/0VVpOtdrrWxiicTXdBZubmrJm6bIqUmk9PPpovUtI1TWykrmBkpS+ttbIoLpPmzrL6Kk0jV5gYHbmhsT//++QakAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJVHvKA3vLcLJMaVBnDG4k4esoDe8Nysgw5UGcMbiWxp/zMzMWhQaBgV3OVMzyHtCMgJjKVszhLLqlUGIk4gHRoJHS1JMQjgsGDw40JojymxCCE1uwcZkbzAhAIGCHosBNPLqmZlqAF2+mIG5EELjLpgYGHiFupIAGBBZnwfUEIODQc1wPXaWiioCFVSISWKhQCVgwrFgVW5GHSMIRS6GacZDq4W4bac/OMw7s5WgBksRlTxgGNLluDCjEIDEm7y+GW2t1Ziznb+rqelruP7jjEL9+WS2dmY2/8MxeheBmsrl0bfCq/eL2yacmrFuzC5JZkkbf+WQdeghxbtPL8a9Scj8jdSMUWOvwq/M1r0dlkrr9+pjZ5KHV1SxhpMO6mmUPNbprFb9547+1Lcfr1s+/Ytb3///////cbH81vuGf85l9bA+Hi4/eutdiAWGTKV4VWlMTGQjjpioQDEUlSPykvIYm9keeVpd7OVPrPZp+Bn5B4yGH6sqWJBFiMrie2dkC9n23nGk+aKIXl4T9SCFcxliW3pkVrNWeKljQndQew+mcqablfmVtc0H4mGhAD6HHI+rNd7qdMw/TN5HdvbRZz28aVt7j13TS1vp+bDSL/i2sDO7fG9rVdWmT05+f27C/s/SLaWdPtYJjNvSK6CiF0pX2fZ6XCYktly6CcFQk1qjDiVDEwIvNjWDlTQYAiQ1PJDDWzCVKmEhZHZoIOGFJgUHRxByMzJBswYmMOBwKCIyDSUC1FXpIKGKFA8JucjqZIJNLaeTAJoYAr5J4qjpYI0JrKDAQkhPVupjoCDJgYIKVC0IXzUgABBYZuhWGNOn2tiwtPSGJj86SIWkNJfauLEgZ5qWHpy/eZ9RRGUkozWB7omFkEy3TmHQS6o+Y25q/WvWY/FaB+oA/GdpOv/YtzDcZbUpn8ZzUmXKYLG4GfOXQt25TA9uUw/KWvvxN5U1eVU7e5z1+QY2nnqzcQe+3ZkuOWGP38opMP5k/eUxc/kEUuO5Suqm93JfjhMS7LfO7/VJZq/X/mt2u73+////+8/eWsMrFbDDDue6vEuXdefurWUcM8gi4UCb45hDcRZfDxFqcKDXJJk3mCy35j9K4mOcYaFDtMtgO9F5XbfPG2oU/tinVhdWMw03OrYlb1yaNXWUN5NTrVMpTjK8KT4DcZHlhHrSMdPmX8O5eivNPr6cXT4KPofcTv7tycmaO6x9e5P0xvxQ3o7JVUwo2ooMbxrcguxWCFdlc/T3Nn66utq1Bj/e3Z6aXszDH2QxTZiP9J1bGDg6dygu9JC3rwrX6lGkcWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACYt8SgN7w3Ks7Dlgaw9uJdnxKA5rDcK2MOWBh724h5yQaHmIzCA8ABBl2AYiImfJJVBzE4kHFRng7ADTi5xiRK6AKMmPgoQMBBxoUeItCIzQwMMhsRhBntKaYIvsYknDx2JDzjMSQqTyXcjijI/Ze4xgLMvAgoBCMLBouZqGNuYKIiEjNVMmgNsXEAxig4lc0wkAVIQimQcW9gsACkKSokdwM9IGMQ21d7dOrBvMY7K2W0kfeBTZncw0k6kX/Hi6jpy6Zh99JHvCvlyo8kkzlliKzVvXaOeiNfkxDGVFDcqfl/Y/B0pbSLQfhhFc3Ma28EPvfK67/wFDUqwhucmqSzMPzAcSVdKJqU2rXLm8a1NrcOQ1bjs9hTy2kpILd6fib1ONLo/TZ4a5rLPLfNXddpJbW7rLHuf/v//v/njXyzww5r/5hnrPVvPS6/ucJQ1XbkcBQVBVKcqIQyORs4oQhE5TBDX5fDNm96BcopGpTzCxX1gns81I2EdN2xFX4m901eRxR92DRK3Ia0qj0NpJVYPsRKhk8qws2dP7Y0wE4S2Jfn5h07BWDX31/R878Ept0TlfqHb7pnf+r4zbMry18W23Wxp594exK5tDprG/TeprYgZpimKfVKRdVf1V01vr5/riBaFnU0f2yrdYrX6kctEzj6daGfVW96LtuiU2hEKzHKsQliMVEx6Mrg052CHHMEHMzADAoDHngRJw24VLoSQpOFBCTkU10hYWIywsxSQRwN9CFl4UFJ7nPLBUCIgRm2wKINCcUxQwrHXVymCMs8L4ipMkVLfSJHSpKUcqLLKC48iAqBGJBlvnGp4CJQauX7WHDFsEf9BOTlVi9UihMvnYIguNUsUs4UV1lbEYCVsAQAy0oZQCFJ5yqUOHIM7limsTGdqNztjW8KkllvaS9UpHEdKAWtrre2nm7kVp4xE39pqWH4rhxpr9w7FaeSv/Mw+9cVhizXnYEvz8rkcrYA7DqTNqj/uruFJLr2MYprNixF5DKIYhxp0bl7sQNP0dFZvb/PfbPbGfb17eX4//6/+f+OX57wuVp27jXtVfxv4979/ggcx5p61aKf2rMBEDz2YovHbpaZ7UqGnETIVMZQnLTAjKIx6WN6PZIgyYlUNGqjEQG+e154Jxxk8rlEwrlFWhtxqP30At6pXmlejbkh7s3oU47V4mii3Ereu4P1Az9+X0gKxLSc7HuoGq61jf18XxitLZzFzisP4fQ5VfA3nLfEva+vvf02wMw77g6tD1NvGotoT+94kKufTH/zSTebskWtYckKBdXW22ZLi/cKod/xQJ7R++kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkMeUoDesNwn0w5YGnobiWl3ygN7w3KSy9lwYYtuJa14GC46+iyuJCYVEjgnE7EWMRHQYenOEZCHxdugEKA40540uRSREEY5iIiBILpJJ8pkmBBn/mU5hygsZOsIyAS4CkCyC0BguFl6aq7zHkWWKULjMUjByF+xkgahKDgqrBCVM6OQDP2MgQsIf+mpi+TZ6QRgS8TbREKrZRHIaEAo/DtZ3IVauQRGJFg/FHV0n4X9fmAVNgMlkrtopsuptMgq3MbWPKsblubjYdwqX+3azzZwy4bLZRNP48tapMQy60bo5DWsyqKzMNxG60L3LdDU5JLWOe56thDMPRKgblIZ2mm6u+4c1beyR5QPYqzsflVDMw/DNS1LJTctYby/WOX4bxzr2MrXe67//+9dzzz5ew1jYnOf23/e2+42vRJrxi9baMCRg8GaIjgaGmHIH0XghEAgV6nVihjKFugJ9HSaPyJGgEIa10Xwn9xpIhVP0Wrp2eIoWJeOFQxVwTknU8pPEtVJvL4bEwzWSYRCqg+QOwGAta9DuBRdIfEAPTHCMITbFzotlr55m5f1L3rQ0k4ICzTXGNm1Y62hIY6sgbZp0kPLxHZcU4dCNPzf8lKPgUd1k4c5dIdm3d937KCiI+mPQyQCRsgqZGGBYhAAUZAkHrnIyEgkxBZYZINLsbEYKPBcOYQBhgGCKAgLijrqiIAUwQbR6fQwIHOCFC7MVBwSGYq0Q6FMBFwoFroHi4w0Gl4VCUk0ICQKU2EACXqThECIJNc+Qg5kgSpbDqqhekujKJxeL9S+AA4Faizh/hLsta0BgK100cXJA1Nuewkc5HnalD6Lsc2UxsKlA0XIL6I0vdT3n/f2kmITjyX2LVx9KHHm7UvmY7E5eyCW4ylc7rMppYbk/aCURmE2H4i9WKRSNO7TQHLHalsrsU9zGNZ7fS5JINh6pInnmIxP09exrKmnqkvrQzejkrs50EZpaSza1cxy1hre89Z7zw1+t4d7//lj21ly/rHLHmOrOdjC5rKoQYUSgFjHfUniqfr96weMt3AzckbyGY1iB12MnCx86WMwvG+kE/1/mbsSwVtC0Tgz0gF4xfeatAXERg0H/aCgVX8+T8vC12cIC3Ege7D5GLXGg/RDKueUeOIYda0exKweCY7Yqd9l8TfL643Mp1Ew0WOvPFtPl0Wqx03cxB9Z6Ljzrqp6plxKDHHmVFXPvjhiikKPa9VQABY9///dq/pUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJcHxKA5rDcKsLyVBl724l5f0mDmsNwlEuZYGXobiVTZAMjHpUCEYKgMQgE0vPjF5UTYMKAcoQJkEaxmQGMDg0e3MqBTEgFpFUks9SpuooOR+Iho6GMO1WAMgCSEBaUxJ2Ig4iJRzHinJEsJhRI8SIBZEABogiOCMcCg6AYwAMkLBUiZmKBjTioZgkU0aHFzoImhQwpgX9X5gvAyDYYnOYAA60PW2ZdsSuYxqxiC6kuk0D1nrS/QTKcpiIqKFww78Crqo3nn7OWp/8q1iZicnxpKDCVRO9SQE2WZZ/cxsUsjt52IlEKSMwfWoJHL3qcuBHNbFFcKsET8PSyV35Dl2XU7+xF+ZW7j82Jbe7fpeYRaGYznGaCpd3jnjvXO77jv//nMN/nrXNf+8M9au5Xq17uGV+5M0mNqU5WbHbHdXc939553vWceuyE7kPk90q2zEGT4jKRh9bpLzzhLmApk9QLM2rRnJI1iNZfbM5zibHpIkBc0WskbnVk71NKRegvFCrYagPo8YZ/nKtxLGll++tCiMVHyQFxcW8nDLFvCz/T0xTWax/DfvnNQKxVuo7xzzfNfb7xjwsU1uut3i0d+94zD8zxtUpJCxAzq0kFzpDeWt2SDTcPdcbhZl7bml65v951NCn98Y1GmhXOEV+7/ZisVXSXq/s64BlDIjL7LMmAtCYYLCxsKvmohECAEYJA4OvJjgkQokBCcRggjghUE7ypSEUgtB5eku8pmY8QBQ5mzRZk0RMxyQXckB2hIDxkmZbNDU17Uu0NCU2gwwBoJMhLXDqswwN0Boya4EXqJgCchnBpe1ZJbN7phpC6ok2ByEJatMdUmHRQyTHJhFxXVdCAbN6hdqLRKQV71VnkzDjdy6iNTci+iwL+xaB4dnKakjVuZs43u0Mhvby1T2q/yh5qVcrsOu4r62pTT0WdeWXrNLf5jGY00rKK27PZY3WCn0difkUP9lFBKoldnnWhuGMI79jDGvZsYRnDmVWhzz3rLe8Nc53WHd2Oc5nv+f+uZZ1/y7bw3ycu5VKvcd43ZynuXLFm3vurdfPkxW5YztZOLpS14pMR39eEQkEykpgwHrE0b+vUoOGKztbWfNeVfm8iQZnFJlaoiLiDH1FVqKTF1cxq1SMZqtqkX1qZRp2azElVqPl7SA2PcNgveI4LRdTggtExytXXylW4cB+YDgeyzzHFqvzWg91u4EE1BeBogQK0NJiaRro2m+Bx4nFikoWEQhjmbq6iZYekbTH1nStHDXDL2f//63Uf/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJPn3Jg5rDcJaruVBl624lqg8kDesNwiyu5UGHrbm1Bw6CBKADQ7X6YjG51M9GQBCXjHQUApIZuHKkC/zGiEDAFx7kaioAuTaIRdFvWsokG8IlQAj2YWUbIi1wumYEQFRAFACMSZwoTFyUGqosMuUsoNMC7YCHGCXDJEFDUpDOiQElXjBCiCA6GlhGhv07C1Ewl1JaDCwhLyLDGgN2KsAda1KJW8WUskdbcXdmAYcWmwWEvWkU7z7WaW9jLpy1T4fz6koxuSSKchmnv2Xmjz6KywdTN9DtDD+UXp4pGLcXhbez+FaPUMUbk1K9QuLK5tlrgRCHJ+KQ5nNSvV6IQBSTD+QdbrW91quFHLHyjFWALmNNezsX8OZ1P/vMfw/vdfr////Wd7DLWeNWz++f+s8t9y5z/zzs41LvaTGbuYAwbEbwGd5aV5pWchhFgYMJRRV50nla4XGHi5dViKjO9vl9x1Hc94Ti0yqASQWpSvDKDnVMQ6Hx1Qkc2MySjQ1YrTmq+Z4rUjXK0CE9wpUOJRABScWHWSR0th9U/mJf7bYmdY4uPR1G/j+v/be9nrqKHGvcfuOlKly6idTP3oSkfsrPGxKbJ2rdTNhynOmGJVFIva1a0Jk2GmXez9H//VHKMkJji9pCqmEOecJQGbiaq5jMCZcJHLiKKQ0Cy8SRLyfpqIcEglsECAARBRb4ucFzZjh4KiA4mdRiERRCKCwtS4OLlnAYdNEeZsAAhZcBDgYMMONayWhFThjyg8KRtMeyLwsoUqMkBRhdNYy6pWwhx3ciQIEhU1NFcgYDks5Wkgld2JxLPtjPOpFZqejzuzEAQKuZi7W4Kn9XY1PWJBGp6vq9lWqzL/6kL+RaHb0lvvy7khdOGqbKMSCifePyW/DkYlTxxuNd5cjb0wxEs4bf53oehx1YRFpdOTMDQLOUkphMbkUuoqsNxjKdjWE/DkJpco3ctW9Zfjh3vMO/zP+9/Dn6w//x/LHV361rHWst59//y1h/Nfv/7SXsbFXe8p3m9Z6/DDmNjAy1J29GW3pOFLtQkKAwj3KzSnDQOt38K+Xe3Gup3uZoJ5J5XjAMwv6GmwhGrlWoWRYockyIXUB4dWF9PHU90uo+2CeE6u5TDsFI8SxYAysoQvd7qrtl/LopIzPqT9/UO/+pqDOaRuX5q6z1x3UMiKWYvNXcucauti1GCB6kjCJhrEI9znVCNTcsarVU5e9rbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACCqASYN5e3Kb65lEZehuIw4NIA3l7crjr6RBrD24oPd41Q9RoRzBkObsOgYTYgZ4DAklOFCEPm9Q/mIBrJPJqQNE24IJ5CXBEQTYCoSGSBTkFUDUyDCfaEIsOZMACCAIbPEBiGqNgZ08ZZ0DBIWiMJYIFMsBEghIcSFisUFhYVecmWu83BqqEp4PsUInISQA1VrAlLyw80w3zvrxYOmLOFGVj6ttaxp7Nl9v6zBp3Ozxv0zMU6jPpruyQNs6oWX6oPHKvYTxSaGDsUp1KBiRdlwiU2jDlWyVsKyT9VwVLBYHOGcrqKpXzA9QmOrnB9CWaaUcDTWwMGqa3r/Wq79/u1vmv+f/n4t//8W3//jG8U/x4m/rOvTOdVnhYpufaeufhOTfAGAAAB+rAl/D7qiGEKjIsQNQp6tpVuwzWzmFf4gPMc71UrkLATy/oxjwSVUOLFNPBYlQ3JJjQpVYsXdOtbx6rFc6t+zRsK8PXDJBKBUkyoa0Xp/haaqsUv/fXr/+xsWy2UNUXYfkx2bdkH0MDBpQmESxSJswg8gVGhweRYXpKodDSlDaSRv8xJ9sHBlhwCIRRr0/8U5FTn/rodlFZUqwp1aEUATTDOgs3seNfDmlGqmZYVQj2Q7KsKoYkJOViQKgXhfaUiksR0x1AFaRVYA8yG2d4UsUCQVJURtGA0KAsXGFYSEQMYBTi7Dk9cpMqChckWXFjR5QmHSXiLWIXPrie+AlVmMk7JuAZOhbAkYRwj1sy3jzC1Hkw4t8GzdIvF/PUWE03sXNG9FrVq039/2h7lfKu0NfiKVJKVSqlukZYaHqNxKhWTQgwYrCIWJjYIYHS+dDdP8xzUOFvLunC/J9EDDQRQl8OFUlQb5pmCZzAyKU4KqVLtxwFgQZL0AkTnywJDXjwc49dZvK8j5vJv1x/v+l/mtKyQaefWd1t39MwsZpn+FrX+t4jzYvjecbrWmZDkzz/lzxkRwjzZ4JKmckJCQF/lTpklYilpnrhVnVaf3zVvdiIzteZKzQBTMbZnF5pgzOs3QeKeepxJJFWa2KkUdt+9spm41nAvbeU5V5H1fKXLTwjcSeusfMf4xu+8bxAh5et//xn73r///6zSVytNDqmZMRaQqw4ssCa172Veo53Q2SKtvG3vnmGljSSG1dktb1Y3uLO4uCjnu8ruWLLV8wxW864sFvjuDyl85h7Ups/dABnrX/SU5edaVyIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkhhUeDeXtyuMvZAGsMbiQ+FxwOZe3KUS6kkZYhuJmOQ8dIXwS6Bno0ZtPA5eQliRoO0olzPy5qOqfObpAyB9GBwIICkpX9ZErURcF8k7TQNMYGHxFQZ9ZgFLyMtgYUME0wDwOCt2lEmQgBQMABhQF4zORLXCEYCjpIID32YioJMRFsFV1X/clB5HpAQi3DRJISZRNTM2RYlVeecVzeLlgRWSRi3E6Wr6g4UKmhOlqrVq1bZiOn7N1evzskdPNTjJChYPxdISiGg3kKkLCQovY9KOC0mkGWN0uhgHKhDYnxvD3F2GoehPQkCcGaHEbBf04YyXuk3x6OmtaQR3vYjcY1mJuX3sGGcUPFNZ/xqtJ61rrG9///f/pj+kGFaHbH1SPaA1tUFXt6HQ47O9ftWomPSfEDfj21akTcfFZdA9u/wivj2dJybbQ8YZuYNNVxWcyEeC1a7VbVvKPax5BEqzxm6/ZQBSwmWNJWHbePtqz6JrKhuUdgW848pi/VG4dj2UXk9Wruz2jpbNNQxkk1N5houe/+rme3051Jxe9Z75mYl09NunqTubl3Zv0Msu321OWLoVjMSTDNy48rC0hGSqLU5ZuT2S2NBsOisESoJJULW6jq7dim/al0jD54WWl6+Jtfj/nsYlLftyBCeiMWJBkJAg+9MkQFtynoLyjsfNYgZQ4UCZgeEhB8Ggy2oNEZn4hBEvQob1D1fy6H2LTCzkLgJI4GAQtNIqlsFXuVAzBDCAlaRSY6shIQyRhpVY5FEDzwQMPHRF+qNCMLhCQaVZM2BjQxAxWxZFylzxefZxDLInabu/kuOsc4kolQjCQL0j2NWzVZ2Lm6QqFHgLeW5WnS2qF7EtBfxVVZXPal/9pd6k9oz55buDCvVy8Ykm8gVQhtJ0QNvL2kS1NhmaDvPtJmGr1WztDwxjqR5lzEFHwScwywjsMAtxyRDlLHTlZHc1YkZl2YRiui+KBmXVYzmxskCHnMLd8UdV1r/Ot21///amLUtG3e1LbxmtnalcD9smFKsshrXYVbqLika2WTUFsl3m+MZtneoylv3ypYBgAAAfrh2HS9pSDYyxKJZCJLQ3enJvTEOn563ZhKOJwCQxpQZnsnwfUHh4STmkZEXRaAN8MKL7H00+F69PHuHowYMeV+lvQL8QvrP/8w/fxz9fFxAr5dIyoTDc25VM5C2NGmUI7JoTXQKhCEYRQDALDgaA2FEkMvLVGrTAxxVVEZnMYk4/lFf/M1qJEWHXuV12qX6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIXXrHA3l7cqeL6PBp6W4mNhsWDmntypqwo4GnpbiCI+Igw+YaKBRBo5A4ORTmXN0MUKjFbY4kEeReihrH2qwaMgjQjU5kvmhzzXGiZQQ89AOYGg34GcgI85dY0QhRkAiBB5MiDi27stL0pxJCxdYwkkoGBkoHWCTcWtBlLi9UOOrFcmSk8NwRgHlob7I5s8R9SZ9DahcaxojyAwp1DX81s+ZUJ6ss8GLqsDG/b/UW1o0R842gsj9nu2J/R1NsMlKrUKtZWY9i5HKfiSKYXFTGapFWn2hYoxopCzjM1DTXjltYCbLy0zqxlo5x2FHoQXSPWFGcoGWWLAYo8+N7rmS3vbf///3j5znONRPWSsvxqmbXmhwYOuyWs5PdwJSFCGVTZ3mhwWnDDP/evmjng4tAY65EJoWIMgUTUBh6vbgIPON5tKr2SuYiCrDXaW3FYk1VZGGukQwpKM5IlDNsrCX1YQS3AgRXTBCtKx7jQZEgYNsHd1/q/KUhJtzlXtX5/4Utl/PPPm1nqVx7dqRhNmkW9tNqbNoirMFtFnWKZEbDaf1VD25k5i7BJo2mPM01DY+F4giTPqS0l2VcSiffYo9/pStVzjYUNuDa/UO1DpAQPqQ3J/QSHDwqjSwCpLPEkw3GQigiA0UmDg6ZS7xi4UF8yYGpfpBrGbgYo6lpG03AcxQkOi8hlRhEIacrEPhxwhAI7+NAjUMHhYQlGgwUFAJaKFDGkF1rGAJNvAqGMOKIWqHQxowDFzRgSgSWtTqVnR/cRbSq0QhuIq8HqNUPsaxznctGIX1Lt8VKQDwJUloKEHC4rajiLhHOL5UXF0SifY4ENgYIENmoyP70geFh7ZscFat0VLIcA5kUNlJH8XtlS5IcPVg+kmmXtTnL8xHWrCXOanQg6Z1wdUJOnQqz1V0ZVORf1BAXprMbDOmlQWSDthW4h0ivmI/VdCvaa9W2BGxnHz8fP1nOf6avnO8+uM7tK+pDZM+FHpdSQbuCw73qB92xLitaxqvdVncnen0lqMBvBWrvsbOA2jElMMSMaMIlCsiplHpb8uMx3rCxiJzVlrVDlVmhROcM+CCQ5zqYHJdG8l0TAKkvtpxzmtEZxc4sX0vJRJrrFo7ZY6JpFkTELv5pS1dJ/k7jm3v6Tk/99e6/3w9S9+EIQtyFzyy/gfRqrIHqLtS7kMLRpxlR1/QpKkJLMlfPIaxizX/xycR6EC7Gy6T9Ivb+1s7/1tfQ4AzArTf2uGFlOLpyQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACbaKxQOae3CQK/jwZeZuJuIhEg5p7cpyMCNBl6G4gnIRCU1EciYQmNY+b2MJsMhg42EQjMFgA6u7QNlTDYTLYixJAyGS0RpVEiagXuHk4YFh1R0yhFiMfC5k2IxfBUEnnFmbGpql5gQWMqfM4RN8KMmcBJktEOjxgqARppTQKDEQdOBBMSAg48AhSg6FDEk+IDf0sAHUXigrABPh9FIbAMIdSiiZj0a4KRHqM9D4hyn5FUtXHdobqV0XZPnEp0NgLqsWZwP1hozQo00dPSYV1Odh57VsRgXRzVH6S0xnhMUIRcUxlCcRmpwuhJy4mkjCnLAhGp2LSUfXLoh5+t5JnpaJlvXSsPuGoz4TxPSZbGQtSLcOkLzLUqrrO36363rSJ4WsT1vvf/tXGrYhb+K6vXVYulRrNM1iyv7ZfPJIcasW/i0iw+4Xht0K0GM5yWzDrv1+9Rvsx8502aLACVAXJJgYefZgjyVOLcmYyOtWx92thPWy+W6yhrLvEVjS5ynOhU6znBjJaEwG8xMDKxOT6PrGY7+XKmWZBIUsDjPn8yGu5T/b/v/jzTv/rd8+dv7fOzXW1vakmNiMZ03KZWwCpFkHj9taMZKEjbpkb8ev5ZeLVbvj14TdfH9yv9PuyWiy6za5FlMle0VBZxuomMwyYJsZkjWGWwYYUHoGLZhAgm4NuIQSGFwAhFMdYVS0YHGqIpIwyCSbfUMqFhJQjY1Hx02BApcAEHTHQgaYRMAAcwCQMhltDUCjYkhQcNTDJozFKn3EIw1Q4Liy8hjTIjAGVFJeEAWKxZVSWz6+nFjrN2jI0uCBEOJ4EcNFzcWKE0rtNliWi/uzlOFGTacGRrZW2dGmWlTiQhnO5RR3zNGcY8Wdd6zEvTrLWnFo/ZjnT8RrTysPVTIadKfWIjwnsqrN81FeNM1iSN5oGScygNw/0MQliySs8FdpVOsKLC5jSr7G3OStORba0Q3RaUjwl8uUaKZuZXU0C+s+9tZ1LiNr4+c5+8715O9eV3CeSMFrXdf7vq1FpWzsMFw1Be3kjU3iHr5n3uFApNXMKl+mz3vT9NqxJEhIMSUltd6LKdLKYrDdVOyTvD6gxl2qNeAmovKmDMd4Zw11lLvZWg3y5K5TkvUypbkYpjhc3omzkxz6xWRtbqwmSRAMsQAUCk1HTi9lETVvx9c3RfacTzx8TNX94x4yYl4eYH12j0TJFoS7ijsh3ImPiak4QclI0jaeRm5pQtJkoYPhxGY0lbu7+HCJ1Iut3zIzeL9GTUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlbh8QDuntyn8wIsGnobiamGw4O6e3KnC/igaehuHcUUGBRMN1cFjHMilZM9TQMHhwMBRzJgPBBanALKBhHhwrMLfBQNXIqaSQdSwYo6vuUNjNOKCCzpPcj0QBbhinBrEIk5MMcM69L0qmOMvOYESpNabHjBE9RTEhpjCxiyCMxcNIcvhEFcF5UkVOpGvdheKwr9znULfl8BbGNLGbVa0vpVh02jnA/NtTnZXnc9UrqAkSzy8k6enV0R+woWtR5NKCbPdMDfAujtv3sJsiK9GIYoUUwv4StSqlXbmnWQhExDWZxSzjCVReHp1OLWb7OaR0P084q9TthcFS3uCn25RGdcqtIOpXuaTu3qQRS8uIuZtRNbi61bGtemsZt65x/D7VXEWeG4TXivn0auvD94GZawXtKxc7teNC3iFExBvClboMJrhXhevnYs1NtwGaq9UFyJsBCippJSmRUyNllakLLcmt4WVz6n8eOkWQpnSRtE4Oo9RzlK9eRop8Ph+H4dR+USgdqRStmKZvcL5gwVHqG2HKHAjCEAqyx73WKAnUjY+v+C3eqVv1l5XmP+h1RVubdqc0LbXSFSJDDRBWyRCUYetwogbl8ao59pU3jUh2lFKIREtsgSIQ53Z+qVU2urqSz6VDVioIrySjSaZhYXBuYD5gIGwBEswtRk0OMMwBHUSDAw2O8HpyYgBSYDAIFwfgRHBCpAG2sTZWZEQj9SioU1Q1e1VNJpibrMQ8CQmgaNQfGrMBiAKTGzaFV+GFBLCs5MAnS3M2iNiODD5iy4RGDgqyDAAn8Wo3zKGLQ01xZU/Pv+2RlWE6wsjK3K/cNtUMI2Uk/YDtSrvTmtd491IhKEsqFObg7tEhMBfIUFNqJ7erBJlnhRx6lcLeikSnDiMqE3RkQyKRpX1GWFkPksKgNkxSlhpMiR6xvEzKd+LhFWjZMthJfCU0zkaWLIciGR8+SbpDGdxhP06rXDw4dUq1rJ/zOMO+cxptwcxt3xH1vGZ97+La+vaNSuWvOX9Nxrx8Za4EuoU0GI/rC/vaqmsrpWXNZoUOvis2YFC4kt2tLC+53SCZ4EEhjMafP40oKhTXmF7QbpwjdPz3inmh2YbCw6P2DBXgg4zXB8eCdVxvnZEmZILMZYgVEPQwSY8Hi9PBjaj4ZFdPeVIDsUaA5638sRAbMiD9J+/1SG+/+rdNbQQFa9giQQx79iSIu3EaXOHjjxdhoPOKSKnwW7GSwlLpyq3QaMFrXVU4JE0Cels0s0ceIsoH36+/sA7tE7RvZuOg9VrmKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJtYfDA7p7cqrsCJBl6G4ldh0KDmXtwr8wogGXmbhKov6YGpEcii6YIAcYLBgZIhaa8iQYWA4YuBiDAwNpiREYFmFgDmDAVtstxOgvchSrogIqvWrAQYVirkozkQJ1RUEGWFrssIZJkDo4NMgASyMdjAw0ssZlOFhaEsMGiIGxMaghQOChhkgYcAHkTA2cJ3RHb8s2XYyx0FOWawWwcqtjJ5RN6kcZmWEnSDI4Gw0yF3TyqfLT2DM/bHydb2ONAq7eyt7apkJSyOfwoLBeEhzLDV53rKnlOIyVIxHQxuJejrVh35X1aso9WKU/2Upz3wY7UgpCHsSXTirZywvIjGfyfUjKtmQTtXOR0s8FdnK3J1cq+M9kcnbFtecVMumTbVHnVs1IWNRrvafG94xjWP4uLUp6YpaCy3261HjXu89Yd97j+N/qnxmDEcLVvnUsmX9o3nr8nEchQk3DIabmQKE2KlbNhDuPBQwzaki3bElCalO+OGiz1uAt2yzF9gMQfpknO/LRdxU/dmIArSSylS9Q8vBN1mI2NEJjc4xWWa39YKVthitX4qUJRYdaj/vr/NfuP2VZmHWlYzORVkRZw6QkvPEWBZhocpQmEgiOc6HnaDLaYro2qxmOPYkR43myoFB4wpDyh7laDrGBFhUYeSVZwjdQmtQTrvoRngo1NUVapYMCAYBHM4yBwKCTEooNbCEx0YDAqSMChYxSgwjsmER6YGAJjMSJzOMGJMaXiz1HZ3mVChC/37j7TVBlgjCwIu1pFsDhhLvI7JGGIqdcDIi4pK0PCiFg4jViGYUNWhkwBRDmQEMj4zBBIXGiUQl0uZW8bIFgKSBqaNFVqhfPbuTi8SSKP0XGVWsVZldemMapCbXq+7jR21uYj8QtberhmaoC6gUvC0qYFg5Uw1uLNGSMU/lJAVr1oRBxGifsyXGKpDGes0w5w5Ryqs+BhHMyHRBhKiGl2FOxTyaVAuq4bokBctahUKGWkR+Wtvng5esdUG8gSWxiNPPChWgYve+v9T5z//WkmoMW8Ou2XVsTrKwzYWbvI0BntM/hay/euOc1lphtgPoTbWsd0B2U4S4KKEWryEpBi8nSGnfApgKyBxHvd+DhFOn7apqoKRRNzpJKqInBgOZbU6olOzmCm4pcSmbzOEILEkDIoE+Z6oPuG2OSohJ2jeQ+M+1UnB4UanOn422CgF429eu3/Z824/bRB9uU8tjTGZJ3AJxsydi/BE3gYwIsoA0ojQsijShL4xhzPzktsvKqYbxncgc8GolPcvmzuJtlkg0r6YlkG02stIl2A4NebIRZoSIpc9IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACWGHwgOae3Kr7BhwawZuJhYlBg7p7cqpL+HBp5m4fkYBRiOLmclQYHDIiQJo2bgpmmHSiOgUz4pzJwVMFAYLBkWBbc0wBpCz4UBgwKrOttFBoDnOAQjc3mJDAcNYAnqaXAPHkaAMyJvgwPMUnBINK9LJPgZKpQgoIWiUFSKABAHH0rxIIYIK+7XZGrLA+SC8DO8+ckiK+lXGArm1ny9dSMTe7ISrFIuVjUCuq6rt47a2FqZ2SNEeLqNCiFveNrtrcpMxmpPqR25t7OsHLRaPvbAwPrM7cyqA73zSnDXNIMSGUZ+jFHrVwnDcii7uKdQ5hjnYxIUqNN66Tqeev3BS2dpBtQ27xTsbI8Y6wjrOdmTB0KGV9Hz8OESfeM0i5z/8fVbf1ti13u6+DnEKtpLQ9ZlqzTtTnChfVr5mzC1iHnNd41EYY94I0MEN0lMQQi3sCg0ma0iAnSwhIIMKYTYZhlItalUcvxGEYtMjtm6ymk+tF9W2bPvYpR4jpxR7rj1Wm4plSxg8MQkDAUXdVnEV3Ea/bGEQYZa1xepTjg2P/klvZCvMf///tdP3j9qZvu3lJzF8mBQk6sefDkcOcVRyFvn8IpL5EnzDik+W7t6aMsq2mmzD0F1oUkiQZN6H2ckIVYpX+44NclXLraWSONMQvVSFDIwNkkQASAJIu4HBAwiCIx+RI0RFAxTCNQ8LiQYEjTTNbHQcdpJgKlFYVMQMNKw6f7/ERMs4x8uuXATOaMBQzfLEJBJsGZMpQqOwzMYLMChMOINyMMUgBzgDERgQGLQ5EY0SDRQKCmKEAUKFSbB4rPAJCmri6rW1h13qCv3ZUztH7fXHu8Zrs3u+09ORBsjcwzahV1thhTwo8ZlhIl27iKiKdCoXSFp8/dxIVaxMbalerswmI8znXa03KNtgNjqDuDO/mH+mWo1BS0PMkWschKgcgh4LghpcjQCUwoceGnH+TrcGNTIRSU7KKxLKluR0JXNS6l0qXNOP2VlUjOy3hQXkaZVxbQM7i+sbOLV362xi9bWzmJXG32PCvParu8sSt5HVrRfuuv4Xm1t7TWr5fQ9woDLcqnAu2LowoKJzgFy+a1kxzPhWatzgqXbamVifxnOxO69rMt68iwG8+RbF0kBejxM9CkA5n25n8excGWJQXUPk7US4s6E3jRn9iUwZ9GLv7glKs1vZLCsn///P/v7Sr+9n48dTGI5Lyovds+tukXv5qjSFRVmeuTPsiHY4gTEIHYExtNGvuc7GaLRORcgBjF0ejK7EooDo4SPDyst07b7tENNY/cTVShQAQ9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74GAAAAlCisEDmXtyr6vIUGnpbiSGAQAOZe3KYK+hQZwhuEERIBTLy7M1K0LF4zXTTwLIChfDhEZOdBhUCJjOUAAXEllGkmxVaZnAKST2VtHQEKRkGIpFukg8la2MHHN6LCmAwbCKRR5smwG7IccpUawReAdEM1IvWYwQKWVGbygZURVFrgxlx1BC3KfK6Is87bLHStdEljMrqsKuPx4+bor7EsLDMjmuuZ5c7veLNTU8Z6sMDc5na8jMrAtD1GmeD6PprhzMyEtZ0yuLC4skIoTML2aLxteOSti2O5XxDlFrIICmHcX45nM6JTCLELoHEVSahGSwQWRjeKpOu3sVuj5e6USdSt6w2vCy6jU20oQj0bSaPC3LJSzt/ljYM6/r9/Fvv3vrNKYzm1a1zSHAzaBeNuu4G6Xt5I0O+tU1veJ4F5sxN01beKxZ5XVRyIq1sdLHGHAoGDlBKPN2Cp1rfkwOE1GR6zQR8Xhsi6iyNMZEL4tasNGELWSE6V43Xl10IeLSQAym0E0CTVSvMWKkNRZn2QQTS8jO9RjIQKbKG10PhcfD////+Hzy26+xtFKewNxnLzMPXcJ8XMUXIG5oMIj8oPMyWLyOET41FKqPpCpbKjSebGV+7zZ1sLixM0jaixM4JAupqwwHYedj2fR5FT4DInom9YMlDtIjAYEARiMrm6R0EGIyqUToweMhEMIBJx8+mIgUAgcmItiiBKgk8u9lQ8AyZZy7oQtJPBOkHRDoBKIhcIhWgAqURCIUjyJiOhngUHKiBOiBRAFCXshhBUHVoQlRFlAqauwBRlyWlp9IhwZE3wUcT6RWh9629Ra5WF6PBUzpqp7x7KeFmkCeSO/1V1HjQMua4VdWc4tH6jGBgVxcxXywnmOBziOcG+pYCpZ29kTdoSFnEdxdi4QUUpHN84MVYxcVgmLPDiKx2cauxNPELYporYkWF+r7NTMciiQ1qZl3Bsq3XUxlrhnVDNVcM7krlejDDfbV0N5Bj5gZgZsu31Wx5jcHPfe2N51G1vGNb8kDH3TfixI9701Nv3rqmavyJC5g4VLkWznrjsHltDMAnDKUA/rLxJgyiB5ZusonaaUPzhcneRSswnuF9ms1nyy4WaajTPfFRaG3ild3UWlKHWZndwwNNQ9W81mW1q/beUxGh4lnDITrtMgrHRP9XcXHf8f/t9tNc9l2I480SpydjTIOZngpkIFi26cxWedXRv7ZZnXtP79qabt+Gu3EZVopRZ6FmC5fULSXLvLWf2f2r/WAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdZeMEDeWNy6c8IEHMsblzZ2wIOYe3Lu7vfwdyluWUtwMpyTriwVCTBFc8dvg0iPTSB5QISApFMxZlUYae0p+Yg77nlmnwsL7jTOYejK+lU3NHUxgKqIZzUBSIHDBIxwRklj7PUyUunFeKCyYpuQs0lq4CVTIn6eGBJfEE0Y5LZo4PjR2EiAV4/t7nWLl+zZZnvztrmsuoa1IXTpXrJzAGrKDEcUezaZ0fRasJrig6UPnr0DNDx5M/GlKRa15a/6FEwsghw+iTk1k+YPcXsysXdz1oa+4fL33HCyjhP8uZ9Cts7TldEnbD01fauoZ3/rk9OWnZmZzNn+2aTA/03RJvOYa3G5Lf/uyuo+0EyHbzVxMBINM7Js1WfSzqNpoQQLuMBgJReGZEtKAmvyqWUlG90reDrd2UM5d6OrYZjBwWDRebUQumMOrMCIi1kChddM5mKHyEUpW0wEwCBU5vWRsIbkw5/m5vZKV8AYiWQzKi80ganRCOevXYq7eLen/6etjl62mrl0rRTXILVYlngRdWmV7U7WKYfwYYQZBEsWnOsf3X5YjO7E94zMHqn1UJY0lgXkyF1t7nZveaNRc9BLtqIzqV8VZ29vO6MoH1tL/27d76x2lyu/T8np/Nms2nLz9p3+6kaNiJj9FhF3+/TxOKxy1Cdy0zBt3OIAlBAYWFB6seCwHCwfMEjWFiECoWUdIsuijjS9Q3SweLRdh+4i1Jf/1F+00FiBXV7DQVwiwCqIoo6xFdezA0I0SoBYBIy0hVkELjLOvq2rDxwhuSErJ4qVmhxZp1ksm+14MfFm/GbVtvb37vnFZI8BFLbxOvG+ZOtjArUOV7Wy5h2vXEDOWKief6O5zof6UbDkcYjhDjQnFhqoYsiigualrXyQ8w1xGoy4e1zR9uNm1vi+YXrG8LWGjen15sQcwcSwtrnzRbbjf2tf/X/+f/84+f//nVrxGit3teXj2R0MqIgAUASpOZqkDpgMDQFJ4fLYWB8weGUxjD9qRgSDYCAiRQU/b8wwqvT0Ktr3t2fR11O0AKz+whMxY0hVUTLacqxW8MQYcTWP0LroXLTMEpKxySABrRgJjpARKsIu50oJuv4xuox4xhYhDW96bK+BDHLoTevEyCLVbuld03P3JqYJCdghMIzBVwoYFAA9a6uS6HLLP4LivVzjDyWBhxhkrNJRGgQLA4aHQ2Q2yvDyjS81YoYtqLRbjUtUrm70JzG2ZQnjapL7b1JVppWeZX35KVQvx2UI3O5XlXm/+eQnFqQSC3YMnByoPCMk4Xq+GR70AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHOGrAA5h7cOeP5/BzK24eLfj8DmXtwzwwn8HMMbhWYsBExlUzRQpBgWMKn8cNxAATCxKMQi5PsODDS5BEXIpI9IIFeB/NE2nSoXaYYw60zKKKOOwCqsurJJK7QQGC74o9sMdu+YiTzBUjmxBUYzQWFKGnQ1DT/4R+QuGTJfiQTk6zEa1c4jncd1jYYo6rcsz6prUK2pp64vR/pmgtb2FKpnbSrr6dQWClIdZKZgqiLSrtd0YIEkaqYhMT9Kw4lYqSzBkVbXDjT7ze954cs1YOvCznNL43beoL1nqw1hLq0B1Cvq1d13Ah0naKwt+ufrHh1LMHpeNpWk8DR4kgNve8HRGKs+scAgJDZmbDmPByYQFRiEqmrU8WrMZHQKjZLsDDQZALqOzAj2x56Xshp3rzwt0ktOVjqZZMqr7aYYACE9vU+k1xEAYiaVaY48gwOJGAUTMOSrIyYHlKDDyjxP1HoakcT9/VgxIqVQJSJMOOOFomHTatHoPFLpccZLUkqQtufgxg2MlSaofJQ/CDNqOGCo0PT/iUWFxONxcVmpUShEMSwXFayJsO9hNQEZpaRC6U130+DZdVVWGo1Lru97nuhYyafQY574jt0WjzqSg9jYi/6cx/xDXbr5ps+75791x11X2/6e1R4LAi39KVlz5mIomTQmgYOt8F3AmChicFgIio2JmuBIZU2eMS1d7Jp5Nl8gVI4MtwUsfeESisv94guAqngKBqbA2QrLWBQ/Y0oeIhE3WUWQyGDDDOEGUDShpvIAahRPrDEEhCcuiL7N1nh+vo4kn3HfY8hPPj33C7q256smZZoqvVV4ba1NSQL2/O1C0MXoKshQb9sco7xhixEvGaEysJhNQoUOj566fUpFQueRbT0aPTOL3tM/mzSS9Hji79K2rJArePJeFDzFiqyVio83p7fFsRbfGt01eBq/zS2f62x///n6/9savam6Uxv43vOdekoPY1TaNiVTK5jOB8NSgkswYXe54gXDQEMTicwoB0QC9LRorJItORVpbNrTQnEhiHarwJlTMCO1BULcJSkgKnyIhqdBdxPtrrzixmjo8LaF8OAjT06EUwKMNcgXOCIFmJAxhu0cpasNUow3FUCKq92J35nOvet3P+vLNvFZs+tesR1ATvQ2DxVhQ9fMrNtm2r1XT5cwziRe3W3WexyHSUvJSp9raP0eQn8n82jkX5225im4/a1Z6YZ23TMw8BgKTDEu5kB228pc5QoIlPMnBUcRcx/loQJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB25lvoOZe3LrL/fQdy1uWf2Y/A5l7cPHvV7B3TG5EQBLlGHqgBqeQAcBHk+sJQUECQPBgZHQADgknzZts7pYRDjuV3NiRljw1O0rrtmVvTfgGJvGYg6O5IVJFwhcxDZgqxx51pSjwXPgtqiA1nxxIinEmcZg7vXHZkkMLUh0gKbjYd1uVqkSV+I26dvIW2xza4kXM1ZY0mcx300dzftOHH4iuNms509ENBiiNMV5Dao75qjzwNrud8kmKVupPqPh5CUzxtjOC09b13bO5MVpnN5darast3t29utJLFhPWN/F3EpM45ZIsbFr0tua0CLh+8ib0JoimgDRy3qfaJT0FxPscvSgJxpxnvv/6JAHC4FFSDgxchGCYQZJxUF4CCwdCxbIjAgICYMAWERt06sgfXKRq5tRurAsPFZDQV5sBm1VupBJ7gwZeEZQyFgV6JFESC0ngMdkjFWARRQnCKMdFEmVNnXcaOSWlkL2M/XbBeDskuXTBBjIJsfscdSY9pqxqyRsgtZDUgYufH9IkSmo0m5dIo5iYNhCOmhKoqWmmiiXWNWNjc1SWpKo3HrWYF1E2JA0PJrLxonZ1uZnnWzGSKzc1OkXOLudMS1lqrmKNJTrVetCZOzM62Votdmapena1VdJdaJ1karvupalIrWZTnDa/v26hrLgJeGEY8AlENAYwQuDlQfLoBUIuTJGZT8xQwzcjUlj/wmHxARE6CPPA8b4sGjUOWw4aSp4RZI1eQIHXiCUW4MiTcUs4wJoDxgdYlgGoGqKulsue+Ktin3/BgNamjLzMFIuMMGCz4vX3iI976S5gV3W3gQt08N1A8GNRSqVOWmPHUyUm1jFs31XOKN2dv+3665x4HfUkgW2z0Xq33nOsUzJ82palYuJXtr2zNutZoOM4z8y+DnOoWaYxS1XOkSPwQm3LcKbMmtoNHWPkheim/auWmAQAGM76GIISDQZmCi7HAwsiwcGBIekwDyRJ6Jtip3RmHadF76zK3OdCJwBG2pM/W2TBmbP7OkQhbBM1WOMBVNgwGWtMOVIADDkXiR+LOS8zNCqBOKmKkceYp/K1LpyXG8DlNCfcaFwPGpKxjKWFaLDVpdd6zyhmnIcbFfr7DDT98aRMWWn1BTU0kmLjZ2tdb5xhpExKEueLrB83Vo7MXltYKUNjAcjgzwyObx7T8yz0zHMucY0hJst5tb6tWOvQ6tmGu1rtatxZ7k0jYWX+lp1ma0ts0nP/cmb/NJ/LzufOZ00rMKlWZKGV3+O537/vNgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdUZb4DmsNw024XwHNLbh3FnvQOaw3DU7Iewc09uCEEJwGQ1IAjcpMGyY2gLWiDQFRihS6lPutCXykcma3HKdX70AgnQQ3Pue2Nyn/binUzsSCpejyB7gw+vFZCJQYFQbcwVCCAYyyKvbDAHEDBoiqwwy6fljrS56pG0UDBmv0lPFJudnuyogdcu9xu/p8s+bw5T28e1sKW/rOgrSXmdy1R0UUffUphzV6U0kxyvS7zxprtigk1qrWzt3qekqzFW5HpndqE6x7N2LV7v7//72xYp8bdndexzmub7lY1hZy1nq53HV3eOs8svwvx3CmkeUuARkiYgZa3LIUIrOi5c6lJYUBlZ3SyvpGQUu0y6KA4DKXmD6ca6H6twODifVpDZIJobTYRDctfCA9xCTLzj1uAmnuDDy8oJeZgZESbMHGGVRduYkNIgSKoWDsVReCy1KCRQ47g+dAi1srgwBaoJO6M6/TgInSW9TkyjhOuAJzr2tTk6dcyao2idJFF9wULmtTa5scLSGYcJiZofWq/ao57FGza6Uy+TBUqO3Zu04TUmsJLDOIuZZLZOU+ul9vonJc9C6ZbnpOuWz1tp+y5gnJ06OJb3XPfftv9UeJV3FSrxqTwGChVZi9tDO42n0FAGMlMiczRRnEAgLsuWBFhVKkLlvt7EKKKzaMrcWxsInzVllxyOoLAGUusic9SdK7CI/EgxwMg0Mi9wclYcKgC+UPA4SQlJOwSUo9HJbo3D6FI5mTfrKlNl2nacYIaPLKHGmL8ejWDkgGcC9x1zdmXWMtWs5RTVLvbWfM8pa++M5TWqPl2Xv9D0HR2WUtSg3Zr4ZzNSvnSRu1Z1ZqU1edtYXLGquN2L6r0eV2M18stfzesqa5h2/vWf4fhlnne3ld+tjlvG3yrymrY38bWtbxs4y2x21Z3e8seUIQeO5UobUeDbws8iAEFe7qaEEbi+phRulZ5YaM14zKF0vkj0IphLNWpikYnXtf9WxlWLoukhOtwtpTKGAuMuyUMlaQNJEGB5BDbNFTBYA5QiDKXQ0rkLEUSlrQSXuOClIFKRcEuA90PSF2qkGP0YADKKSBl67ZLrIsOb69s1R8PG4Xe4xm8m9ZvStdM/tSPKrFUsO8/epI1qahf91W6ig3hRrUvM9mgU3WNrU8ni3xa2Ne1LWiWj236U3pqvbNaQb1zvUHOMZ9tW1bFvqkXQdKkmgY0poVeJnRjBEPfCIozVH11jKtKFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHSGS8g5rDcPFPB4BzT24dxYzwDmsNy0Qr3kG9PblGUSDRiAeEU/EQAMIbIwCGjBINWSpJ3n7cqAHOkrwwIh3bJK0IYgCusMRRTNCtO1faJLclDV8mWCBQwJTYBKNDaqpvMBgTYG8nRCDUEfqAiAKYqkBUI28SMgxvYjCJurH3jAJNmUlnZvGvdfmFnIT33edzzqOnq3ew1L8M7vK2sPnaWk1nlh2dpeQm+7NPVmafCv92l3es7sSnHLKmtXMbWG7tjmF3K5KZ21T3a/M8t/+7GtWezNi7y1+eWe8cO8pNY4d1jb7+8tY5dz3j/McNbvZC9I1bQiTET4AFi5Vqj5Y+Jii/jJJlqBgBhgWMeBYW1YGBBgTlGzxQYhCbY2gqDKVtkZw771uTgOgEvWtpBP0DArrNwdsiSlQDK0jWdF7VgQ6OWDBExa1BLSwQJlSAZlDBGuiAiUBmVScsERHQHaYszeOsyVuPWcwlrjTB7M2JybaLhxoSv2DGUWHuomYgsFn8KbdqQZdW3JLGiwtwW6I/mgyUiqGDW7bBgZfP9bd3xmlYbx7P9O5bwdavGjJF1aOrYdo9twbwYm95hy4v/qtoec03SSFjWrZvDrr41u+c21NvW9zYvfWN71/XOLb+6R7Zxqms19vu9ca3TyZWFAwMAyW3MW/FFVKWoyYCmAyaBhIAGd8AaWDRacYEqmjYSoAGbRduDbS1uCsrY2nIA3gAXt3nBbgWqX6uxrMjQgWsAQ4MgDzUYDGUGowAAGx92GA1Z1StTSGlmkAY6E8c8kZyOXofS1g15H4eZnhiyT7P3NZ27kcm4EG5PzhzPPGiXRzDmWdizdv4RnLlm12JYWrFNTf8cjWUOv1nUu3pynrZfWkWprVBM01XCvFd41e0l/G936tHllzHG/jjdz3+Gscbnfq7xs4Yyy9csf/Mcs8csssf/HW+6/DH+cqo9Eed9gFvcl4P1xFFfpEUDVY/z3759z7X9/u/SRrzGGlRp4JITY/4QkA8BhYNWI+qhjXnXaQ2fFuTKk9JGTAISChUriKw6Vc68jWouWwZMaAgzhLGBVYWuumv96Eyc33WMRFok1ZdhzFoAUk2ZHeA6NrsPuE8scSmMgOYo/8Ldx2CDGuNp04y43WhjRMZ3e9fqk2vFp4NMVtGxajE4RZo8sPFZryUrCj5vaNAiP/SsS9s1rfVKPs0cMVxnX1mFeutfGYNa5pWJWlZ5glqqMKxs0dfEUxhemZ3fQ04rHf/ef+nedR3+u3J8H/t96NAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABtNZPAN7w3LpDvdwb3BuGrVm7g3ubcO7uh1BvUm5LAA1pa5jQQnqaC+gt1JgoGAihEy2f47uWyuNwWoE7rSpSY8KVpOzsiNI6xFHKAWNQ4IhwqqhMICMKCF+XCwtLHdcZvJEQgc4qkvWLnGhwViRJVZg3sIlizpddlpfQwQHj8Cz07L5yP17hyfBNezhjT8Vvu3OYYSvDDK/GsMt8rymr9Hqtds1tUsetVKDdnln+f3Cp3dXuVNfq2OXq1bK92lszeNTtXeN6xr/5zeWe96z7W/63eT+Pa1/8uX6g37Fb+R7tyJdpwoSiXruTp1+F671f/9/xv4fl+tCIAGQAGnYODC3Jj5+JgiIZgQg0DVXkZlEVp11KOF8VlJOv8YcEq0sfcwDLUdai4tC/T+GNk8cVphoSB6R+V0QSmEyx6AsFFsmiO7iJizOB6WT9cWMMOh5s04z10gYUq2ymVGBLloyJ0bgX2FUgkXUXNASzM1mCkF0j5PmCE3MzBkC8bJOi5dL5uWDU0MjJIxLyR06VSqg61rZZdNESddTmiTGaSJqkZozVDY8itIvLWauswddS01ukk5ki7KPsjUznbUkE3TUikkpKtNJGjmyKS1VIoszV6D3poquauONg20ULPlcoEoDRWutDUEjZrAImOZRmmwBq/RCDTcImZ99YdnZRcWzF6UaEGYGElLlxpYEDAcPxOQNjR7c8KiY4tYoIzKwCGhY0d/NxadwyUpL9LNcVWU4IeBkuymAUsHES2k1qVxovsPIzzx2Hzxo5BCYOAbeDRdGsxQFsIkYmK5UNk8c102RSNDFaR9kklOXS8TakC6x1F0ZgipJSRktJNI1MTZZMqOHUlInTI+mgqiimpFSSSrMplJUVGJ5BbKWpNR8RIRpMIaFmhoRJY6Tte9zbnvNMArRVI7FmtZSzakQhQCFRVnDKgABRhTqc8AomuBI4Fcmq8MZhK0IMbKYoQo2CnzUww04LBhAGNASXWusiJOWk6g+YR4mgTBUTUlIEAo5dMal0ma0F1iExrMJKos/kgkWD6JVXF8npaip9+pp3R1Y48fuprJ8ul+DaonUmEi+UzpfAhDol89MknNFzZ0T5ecxKKalGRkyCBkatNzVJF0C2kTjsZLWTykDJjEuFYxMEFnDqJseWg12L7MmySbHUS6impI6eMjqB6gVTFBbmyy9RNETi7qP1qo00q3SZ1G+klQZfRprQpLqVSP4vAHLq3Lhutfd95P+Hj69ugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAawVzsDW5ty123XYG9Nbhx2QPYM5e3D68gewZyxuEOL6jh8Pal7zDUzxAGurWe6o7Uhsx6lis9MrBOkhLgsGm2o66rgTjEGRxMUAVfAwkAqcTC4WDzHgJ9QgmjD1wTDTIh4UEialaKVRIx1hJcMDOaf6iEjeuGZZejqbSYkRpIobKMybkHAwfHNQOOmam4npbp5PGRotEkjJM1U5NPUgkaWSURUihmkbKSRM2WgVji2Nkki8amKKaSKzBJIzQUzuYnFsfZOkq1SCbJKZNdFSKJgyYgTuSsK/BLJvLbk0NVmaz/C3ffWW2qXfd/9/Dn/fv9NttUZAVqgA9FpUhEAsVnLAjhrWj0MKNTcogyKy2gRDMgFZiYwBG0uYBgFBOZwvLLDyStojAjEK2FKMRoOkNAMUPfyw4UehoKqh5IhdESwGFKqIQ1eWTAzUnxf9s1eGm5gbK8mVgnD8Th7GBLAMocSRx1pG4XseL1so8tFZKpOx446CLUkWTOTxheldSLqQSSmq00VorpMiqpBF1qQWedaS1upOtkDRKkpF9FRmig5skco2SZVKta6nWqbrpMytBTs6L2VZp5yxE3UZMhN6x4PFjVhadch7nMSjTx20/wylHsZXEyaV07mt0++8vVcH1iauo4YhcsqQF8op22lbdJpDiQgL+hwetokNe6t0EqFCl/fRMrN9IQekbbd5DIYNnpu3Zo68upJTWHLEhSBjbz7/0g4xqt64pfuGvfPrf01nN90vvWqe+8ZviBbN8++/imL3xm9sa1e+739Ke995vvFNZvfN74pTN95vf0p9397+lNXvq970pS99ZvelKZvTN74pT3ieHfECmbxNXj7gRNXiUu/vR5S7ymX8fDymXkTL+Ph5Eq8eafv9vHmoCsmY1fHYEMcE4dD051HCQxQRGwxF+ShVXZLCL6ytrcspZfG9TU5exelOiPLlo5iY2+pQ/QU8Jl8PyADHNLVpXgo3bL3bpuY5twVa71OwM6ShRAoCr15yrT09jrcV/1JyrDHaqzAYsZdv7OB39Ka2/lL4xTW1+LH5oxW7/0f+VnXX/Rf9FmXX3y7+Ucq2/Ld7MMVbf+7/sOddf8K+8CykK+8K9+ixzV96r37LHNbfq2/7Czm1/Nr/YWUbXxNr36LHLr3IV7+LFmrzzV6+xwsqvPKrz/2Dzl55E2ZxsGDjZg42Zq2DA8hMDyEzP4DAwqYGFSWT3iQTIiQIiIcwbow4AgaAIAIcgDgPLwAgDCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHQZA8gfqLcO/SB6A/T24anhTgDPKNyymfHAGN7XB/UWUfA+irMUuWIdn2cVwuagNrFdCCCTUgofmJQizKMGgVn+lJaqFqTIAShuQGJS6v2k4msj5SS+BA8SBgpSbUXitp2KOks21hUBUU1fdE1PoGoIKmkcWpll5bKSSMjykUUqV0UFoskk9FqOo2oo0UWSSrRrRZSTrRdaLKSdaLrRak9FKijSSopUUakqKVFFlJOtJ1ospJJaSVFGklSSoo0knUk6KLJJOpJ1ospJJSTrRRUklSSWiioyNmMjZzE1YyLzGRedEuomReYyLxsiXTU4TRqomi8sipOlgc4nSkOcViZHNKpNDnPZSei1hnkpLAS5auzMz17qtTVFHWy2yIVCly2LbPEjJmVOvtpOgUlaOjC5ZMynhgHYvYSqy4bFLsnaSCxAw0gL41TN0yq0VbbLpHetWrNjtoln0KfNazEo38W3Brqtd2tv1+a1xa2a1zXWLWzWvrXMa2619a6tbda7rWuLbzB3mtcWtmDbNa4tbMG3rXVrbrbda6tbdbbzWuLWza2YNcQrZtbcGLqFG3aNuC91Z9az61XtbPo2H0bL2Lh8+w+fXevaPn1Hz6717p8rtPmaeCyzMSuiwldGgq1xbkOewk8zSoaqV0W5UoouS0fporKmLcxBNZmQOBMyYwRY1H3+UPlEGzlO3SBWwXh0NmGgWMAQdBqQoO0hQCJQYDDZisItCSeBILbuKhNbphweggAryCoQNRgFDIzoSVC7dpbjKxYAiQhWU/YXEhtkzmBRkThsqCOlWcDQo6idK6nZMDiky0R3ydqH0huJi0lYLVAYS0TAtpxBNjoWwNT591h/SqVTyQzKKljwiQcycsmHnSrJvJ1utNkVVf9v/////////+3qrtT0F1o1NZ2qUkqt6K+ky1My2QVWpXWzOpJJKfbyYbbMimmXfpgTPFUQWNOlmbuo9V2oPs4y7pfudrMUJScy4iHA8w4seExcYlcCItG7A8UYIChiWgQeU2DxMdGCaMIC8wxEaiAFZPh6GUOQwoRn4lCIwP+Omxy9qZzHEzogwrEpMw0Nfm01ZpaghgYgupjl/eoCXPcf40QLRyiMWp52XScFC9jvL/cKenrZK4y7qM7Xje3q/39bu57if65////BtTd1u7//2fr9V3WLCtwqUTUKguA3lFlxQLC6mGh48eQICosCrDQnNgQa0VIpERdYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABoZyOAMco3LoEUbwa3RuWJD04Axri4OYxBvBjlW5c9jINqKRHTMAXMhJbq+jutkgh+cZEviTDIpDg8rODkkBQMajKIsA31QpMZhbFpZg0BTgEB6fxgUUCACJcEI3M9hpi5mMwLccxykDF1IyDwBGgCvAUC5g9IGABYNgocD6taeINBrqqLMDU6CwlB0adx1H+JVIhwfsXRkANWTDjSQNXTSKYOHC2JJoqMCu5EVDCPqSIusgpjQJFuiSazBNRWX6B8mFqV//////////31//+6SkroUq7urqObdp4zZFfpd+b5SS0YiUucK+D4Z9oPYy3BB0O2FWEpgYAImZBpEDoHidyWU9NATDCoXgUvCwIbYIigEZsNyBiwNHTFR+RIyAgNqmNhw0EnJDwweE1YDgQB0pfgxlJFgB04QzBW4UPzJgkSFU7gainS5QgOB6YCgANA6tJiQarWiI0Npg4OFRHdtjMvJwZ4P8GACNGZA5uALTBtGhWJYa4hIAQXDzlxFaBMGxTLyAfOUkVkSYMGJuo93Y5KC5SarSHySzLd6v/r/burq///39VdXbfVp2XVWtTJUqS6lrWyNdalfrqRfQsgdSU5qp0WuzrPovZTKWtdN3nFAumG5osBZiJkNdUf0FmGoiyqq/MOs+hrtPH3tGFJkA6QptEAyJNtydluC3Qgo8stIhESCg5nRjlpgiBjAA7DO4eQmm8yqw8THZAsMFAIHCBNxbwgAxpwvmRocNcYVCqAdiwECahSGsaRBR9AACGga0J+akMcaLKHKMQAdf8rj0azvzgMBPfzwwuyuzY9/N40sk48Vr60D5a/7lTH/+W9/n7zxhJx//R/6f/6V90YGFHBPi2kilBdANuArxwBNLJ6gDPLJXhQ8FhV10iQZJAENBJqPutxsK9lhpqUTkqcOxABVFZh4QDoCMygEVAgGRzKGHoODzGdZDExaCmLiAfqHGezCFigDhKSE4wOPVyGJCMhYteHH+TuAAxBSIQCLfMEAI7UFzDygEl6xhhy3xCHmspHsCa+YUFxlUIEwLX6xU0IMYCvkBDWgZAQouxyC0WzpGEVAwcRhzDVM0UPyBoUolSBhG8oNXlZln6nZIuoEBeie6kkSRdB3//2r/1f//2X+3/73trXX3scUqyuihupNSNJjFaKCSaqa0GW+hpINat1MsxqacapRkhqHf+ETCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAeFjLcDPKNy63HG8GOUbl4GJNwMco3LGZ7cAY1tcHlHijJpC+RgLmk+vh5VD1uySJO69dDBnIwIxyZhAQgChiYVqYDCLflkRgcDiwJVpbiYTBb6mCwkxUwiICQdFA9MFBQ2gBS2BhUzL8QRLkamlQYRPhoYBJvl9i7xwkCGHe4a3CxAAQ4VtOIBchKFgM3ypEgTKgRclt8CIJEFFKC5xQAGjiAiCDmkQIMWy+TYQACFNy2XUg/hdUiXidOJF4R6wx7sSo/KVmRMoHqxlqD2diMQUl/1f/v/q63/7f7//9d9Xd0WayqS3ZjzLdBBM5RR7ukpJrpKTUhSbSTrM1qQpm7skkxm6k2RTZRxjQ7rESuKsOXPPIiptL9LlZ664woA/cLkDkPFBTkhYQmCQSOAsGip8jFAXed5woJjFRCuNLHii95ggCJZmWDwKHRLEMAxqsBpZGDy6LAxu8cbIocARCYBCKNLITAomOSqMyWTBaMDAKcZv0V1WKoPinoYJFhnYJTcMqhJUokFGCVhOwGP6CAyA5yjQwHOA0acFgJPIqTGoSLMwhK03GTTEGl1SJIXskVlDnJrL7aSlzSpT+31d/X6/6v+r/+/s/dfZXZk2oprRQQd3WpJKgb6lpoMo4gpbuqqgl02ooO6CCaKmWzPqSQp0XUjsig1jhYEKgnxBljQFTYZ4ikyJWiMr2bs7tG7j5KNxQQC0wKBZINNoMA5kM+NzcgLBckB70EABBgeiIVF8OGDhGSIoFEURmQqj8tAADmTBF6hwBLMWKY7b4GuLXnAJQeasMhhnFDASY6NCZ/GnlABJgCylLcuoaHAgsFms9NyBmBFB2iugY+eFvCY8ESHsqlwMLmp9TnRAcgpfOnCLG6y8HacxNaAtrVJrKyk2k71XcnVHFN61e91L3/V76//1fvbRWh16+y/ddFlLdTKMGdFzdbskx5NE1R2TZTJrdkFJziKqS1IJJMaKqpMpFBV61MmcNQsjbbGT73tODmGJYZOSqlzcJ/GNQ1A0ig135YSBQUcZKLnVQG1JMfcRV5uFrWG2Ax9hwJIITDQ8wT6Dl4BemnSMRMdgY5BKVbfpjGIHRgwMrCxglPwbqGLvpFGpoLBEwC4q5kdWcI3hAmYibpeRN9YNnohL5lqoAPWsSOXYy6nlBiwevezf57p2dV/fa7dxgD2BUf9q6/+ZTu53/oe//6+xOev/1//2f/0nVTpEqsAiRJl5YH1iQw9DWAy0RLBY006cxpJBk84RAIYsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeOjzcDHKNy0lD3AGeUbl6OINwM8o3LlsYbwa5RuVTgA4OeAvERTWcYEu6NKleeHFQOu6z8QNBKAkBOIRAswsNHPMwGt5VsgwBCTzaekYYeCNcFC0uMYNCgMUy5QMEibhpHmFToriGlFXWnzDzFMEC8OCq1RQQGB0CYKrAOWBACCYXsXCoVfISA7apACEbGeBwIAOuuUDdGVEFxSJEhpgaQ0JyICRIujvRLAOIkkVFpRkDxZNUhWp1AuiDECMTNjhE+6h2KbJr1LJQnmsy2VdXt9f/3tVX7t6Der39bM6lvV27IXUm/RPLTqMr3Y/Qugq9SRqtSKlqU7IOtakVLdNlslZ+6a0lpLZBbp6SCCjBt0IyhaeSYYQoo9TssqX4+MCRqNtYwpIIIACYTApIACsKl1DKQHkETFAGRL+FPGCQBGwuFyqAQCfDB4+CDUYUDZnoFLlMWm9GlOSEJjLBDqEAyFDAG2UwEJDhyhMRI0EAN32aMect+wqAHNQ4kQdMUhhtPc9ZcJQYJND8DVsMMmjY8T5LEyBRoOhN03JlRxy8Oa6zQc2JDsl89NtR9tUpEiy2//f///7f+3/2/utf9Ltd09BFa1LqQu9bbupC1bL1Lsk9Kiukuz6atq3Y8SLayL7eiWauQ4NgN2aYYCYXi1xxVhJHGFLHfoLKwcXBAWLxoJDKQZpTOpIf93hkWGSB4pq4wYJ3WKg0dwUBYqqBYhg0omWRkiGYEJJMNE+30Z8yIw0HzD4VIhqLAQLgs0qWDBdgNqAALBQoDUtMEAGH1FIIZ4BAeZQBsQcd+TxADwviLidQNmqDgRtmBFiZKos0AUQTqTIm4ncn0zCLOLqSAs9Ru6j5BrVKJGW8dLqdkVoETda29b1P7L7/9W//b7/+y163o7rQUzrRSPpKXZmUpTIKSWaoLRa9VPTXU6mZ1oOyBw+eTY+unSUkXNSamTSc6uMHHhLYJcS5StwqaMMmMtcDhj0tZd9w8Fr1nmybHAdkZDIOCCmZhkAKlCIu5UeCgcMFCBfJfYOIN4BBwVBhm5CgAIDRSFQ8ZgE7VjKhUcNO5MhqKIpkMYgJwjRGGgiPA48eJwCN3HbCqWHhQAO0iLJ00knQcGR4Cu7si43CIjjK4xwJLSTJ0xMDxDiFAya0Pq6Ri5ibGpsXh3JnEhUkhCA87vstRutFTLP21lAxdd/uyvu/+37///16X/+rapq3d1qqSQZFS2qrZlKQTdBLd2TSQSZ3Uyka1rTZFSaRvZFbrRTW7Isqmiq0+hDZqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHl403Azyjcu9wduBnlG5dcjTcDHKNy6NG24GuTblQZIg06BCaOYigKlMJfaXPE1Je848/Io1cUIBl8AJbBC7aUCpLAbkAkWmXByqxJ8wICH5BwrKBCYICQNTACS5gYVmvBMzhFNCWMAN+GHJbM3Jj+RBV5FATVgIMVtw4kAAIHi2ztDoggxHVtm2BwsMvgMiBdeuQheK4y48A1AgLaQ1MumhQIkw5QWTkRNS0pQqBsaoLE6oJlsY5yq6ZgQjdR9M40pJL0DImyBMxj/f/qq2b1b7L1No/v/9abdqer1NRZFR5d1oGyk0da2UtE2QdJB6Cz1bsgmpkklqUix1Saa0daBg6eipS1Gxo6kk2Ws8mByrgvCqkYcJ29BlCXZfxrcOrFpG51miUzKFekgfCAe+JjoIAYGmkho1lQAoAZmQZwOIQAY/AKYZgkQAAAm1TQFQaGHcKEIymFXiM8gN3VjKsYKiCIoiYqE7WFADARROWPQwKWTCYDXWsgiBKRbqg4DPmrlCMeD7HKreEXHwVCWJwWgE1gsRHlkmyRGuSAFmob2gmmmLwn0C6kSC0VC5EBxl6Ym2qgXnPZGPstjhedSX+vtur/1b7dn92qWv/0a7avVVspdnXTTWcdCzKQ00EkkUEz551IHlLWgufmbpoqrSTQSd0lIOxvgD72qyhAcRojtLVkDNnkBFRTjarTTriSnl8PbPtwuNxZuVCUCiiKgcACLEz+LXqfcVC5r0Cq+YiIASqiMEdKsiEQJQQ01ywOjRBFLwGGA1KWjpkqZPAYQQBkMGOorkZDxj05mOymLgAcDiAp4VJNqGAJbReQUFhqQWM+V7PlUhpgKyRcgQG4tBtzEVMmJ1EPdHEmiZnA5InDdM8KCZRMCyTQknWbEX6CSS0VyNTVQdyPJFloupvVfX+tTf+v/rbv9umyv77Mp3SZWlrQUp2Wu121oOiyKnTZSkDFarLWhRVdlO6mTvdFjFakDV7I1oXUt3Y66mduSe5COHAhn8484QZemWO9YkEcisMujG2rCMVmAACiEhmCgYZJLKBNY6FYGZ5QB2YkAIjAyL0wTfwTIBOYTAgBA5NKyIDGbAI4Lyo0q3SQxU1TMIPCBok6WCgaIj5gpXgZrioBgQrAKAFfKBiWohAojAZlAANWd6iJs+PBdH1A59MiBHky4RQUKA/w+DNSjxFh4RUYG5qmXBy0h22SQr3NWIcykm1rZA0Y4ZP6/b/9f2/6H27f+3r3WnZevW7OtE0ZnZB1unsuzMjRUiiit0kk01pu6FExugeSVRQqZzKmq9mrTqOPd5oKmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABzqMtwMbo3Loscbga5RuXRpA3AzujcOhxxuBrlG5W0rEnKIqIGGW7lpcK6muQcu1pcfrtgYOKnBmIEjICqAOCTWkyGIfMCFjLlJSmJA4OggxooGhpiANTjZwECnh1Iyr4zsxlTRnSYc9Zi4sIQhIxqBKNm1qAAnTrgEYDlcrpJROlEhFmyCIwUFMhaVN3RgcdpkWQwwyoygHNBgSKm47UlJOThCsbuYieTQwROi0l1NYt0dLOXSerrm8uNKR/somTzLW/Vt9q1/99TdlfX37r/6TV/pXeplorqSqSRrUmtJ6Z1VbqZ3Uq9knWipknUyq1M6NkUTRJT03OI1oLdaCCSeo+vt8IZZwEATICRXeY0ukIVhVelsp6LNRb6Wy1nDFSAYmIwgyMweBg4CmDik8ziEAmMEjCA20Q9gpEVAEbvF5gMlw+Ih6YLEEGgJ1S2DW9XZBgUCIdCgUCJAYNDZ4VNGDgcPQIQgNG1XjEoU0p3HjMBBUAgFPypJCPImRUjTMhgGoLDTJktmZ4ok+BkUZBTyLMRpqZpMRd0TAgyRFjCyN8zK8p6DbKmBfQSQ7K/f6/tV/q//b/79vqqWpmSTvdlIJ2OLNk1oUkmTQWynZJJzinTpp0Hekg7O6anQWmp3RPvRUjQnzi+ilUgs8u7TgQKVSzNjTqGjGBSgaDVZLHHZ9deCclLvDIoCl0kAjRSleBj6vGIMMFBzejdxGkgowXYYKjDwwOBRgI8NewJMzkS4uuaMbVVKGXOOnuMgAKPEoI2l6LjpgzORiqiTHIsgESzHgOBFgzCgYwk4Ym9kBj5KSwumRQTmBzI4WtjMEqXjE0KIWHFRKeTWuaHxXkjNMbBwWg3pFrQWo45TaztupabopPts/fvvq/3v1VP/9V//tvfvrotMEUGWdWpBlUbuummfTRTWaGjLTamm59Tp11HXWmk9dk0kluk6DostkVJp1Joutzx04gOBEAoJCF7xFEHjTjlxpPD6/WAWnCdNw3LX6QC8xED2wqWCQEAg5pIkDREDkzAjIEG37CokDgSbAMgEB4QEjAQNNMBZqBmAQjQPZq3GHGwGDAGEK8OBqtxgwXnci0YOMwKTyirSnVWq68ENqyUCB0GgxcTLX4KaRWFcPDtAGvkiTaJ48iOEA5AKkYoJsQOmmiyTGRIsRUu1es6Xo+EFmbdS0jd1ot11K36v2ve/16bb/X+r9/Xa1TL6Vlo2Uu9K6TMhTRLiVlseSRdNk1st0TZJlWMFnqjGm9qkD7Uq0EFVJJOdd3RWbtqsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdjjjcDG6Ny27HW4Gt0bhyCONwMbo3LfsYbgY3RuWnFgIrU4GHkAgyAxQFgiZ1t4F6u4ziTN0hpcyZRABgVCCwWYWhQtuIIFyLLIgdQQtuz0xlBCAlTYwESN/BjADE5w0SRMzIXxZ9YgBpKrwE0g0EUiu41EfMhnxK1UOUAcAQgETAwhI1DiwCDS6UBsUlpdE8jlB6hQGMA2eYYBEUWMisOgLfS6plLKcopGwpEvvGbQFbpLMS07rUgVUi6fkch2Y8S6meuvrevr//19Sur/t/apf01Ld+60qSnUlWzrooWQZBM4pJSkrqUtV0mRXTTQU6nSU7LQUgboqopstJalpJIqOs6mWyGictA6ITKUjTllAAKLysSVO1lzm0ezcjYVadhxSwWmaij8DgAHAgwIU8PI5BQP2z1GyWBcbQ8OJjxQuRTEZcawVg4QMZgAwAXjDrzKBBU4JsIiFkdSojGx5oyWDQdF3PULCoAwh53ga2psPEd2YcwujGEyPkkxhAaJGKMWSkUHQOgYsgLYtaLkVPoLYirmBkT6RPJLSurWVZHtQ9SSTpLX/2qa1fuu3svVf1frq7e3/6DM1qCS1Ldla1prR3TUgydWjspKyVSadaSmspNBkUnZVdkDiKVaDLeg6aDpqQmS2ssTa+TlDymo6KpbZVRAm2K0tmGb1NGI4IQcIPWSGdDJESGkEbEGbiAGNGQmur6b5OMxQnKBYxIIFRsM7xEYHTGaSJmAGp92I63BKURC6CcaLV8teMeChTdLSuWs2Moc4EAwWudHoZBwinDAR54bL5cHLFHLAvwMlfFwkUPmRNx0gLBhwLUikOhNFBIc6miPhQ4TVAwXqdnSIs8xNO7sXpx/2/1629Vbq/Vt7+r+p9m629bN2VqqZFFlKdzzUlrd0Hn3SZa6Cqd0+tlLZ1rTWpBRsikigldlMmt2djc6arY0mjqwZWlYzNYgFqtMqDUCeNnLlzjAYYlkHvS5goUmHFMMQWNAoBE2L3kJJkww/LSwqBywmEAaDmOTBCZGZgIELjWQdY4zIoKufZfhuoASDTRFONEQCmZ99QSLgcYJ1LTY4sGyBRCCvAAsZGAM/kUhJgdRGkWPDRA06QZweS6Ylw+Q4Ez5TLyLoC+TnWY3SOEUQICnWbXfN1EsuZr20y9bV/++/qr/727e3/Z769WpS67rrTS6CJgmgc6Kc3psnu6ektlJJmjIIVM60KBspFZ1SjqFSS2TOpVpsZKZSK0FmjU4CigAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHB4g3AzujctoP5uBjlG5c4jzcDG6Ny4DEG4GN0bl4llKwmvgHHFsVdtFXC2GGYcdxiUqht+pYFyMaImFEzWzUOmoPY4heZcUrMjbtv4AEZB4x0DFUkHWwBNjlz1Nky0CTGeFWNjj6lU0MyCkiRoGKgSbahmROY8ZtVRVlyIKogABN2XkoYZSAJWq4d8lBjiCDEWP4GRyCiDygpImikAELE4onE0iuszmKzIzOEBiMj7O6aqlGjl1UyZWitE0Ul79deu722/9XX37/r/+tW9fotVWy3U6DGWtJzJk3VRSQUiqi66+qpSb061LRRTQrZBE+5nNNE9RMkAsAccUSShaaFOQFGBlR79KPS5X8Cvmwp1Jc0SUO5OEolMohZKZA0SABgYJNpEmkmOgnB7KVlyIAhwhABjRBmABEGHow2ITP4GYGYILRQDoKcddSqwILRdJvmVF0TqAaMMKAOTjoKmqpqL/a80mgEIWJiLSS6MGiaI55Gi0gaIqRpFyqXVF8nAMAWGSKM8cLZMH2Oj2bGZYH+PrUe7lBBRBro+6RZJxv/9r//16va299//37Wtq1q+vW92QdToLWkggybIoOtRkzKN0EKSmSrqTWyC56aOCvsiuFpFdVvQUbjMQSMNqjLNyBTiRJQN/IabRmbmRuPZyt8hwfBRWgRIQQAAphg4n2oOEBJnIBQr1bdkgGHhoQMiDAYihykIT050qZGNMCcqj8idx/DDCAFNLO2XJ6nLRReYIKlMSIEaYKCTdi57tuWMCwqEMhnXVMx3jPCTF0SiEeI0SYUpi+aA3hGKggfMicNFn2IoigoaSxSaDIp7NL6yeTj+7VOnNE0m7r//Uq9+rXbZur72r9T+t7ttWqtnZB9BS0U07IM6DskggpJjiVLWn7JmztZSSlsggtRkpJJFkKCDs7OktBnU9aaR4wTsszLsCYLRBqn3UpWYsdw32fGoqWakMvdOQjhOYiTszKCsaADFxeRzgEIRwGkr+lApOIzvCbSwFU+CLcwgrNcJgwFMHC0DGeO2wx1wrjAaBBw0usKlR7OCZGtDYAIgZ508kao67DJM0+jAyNPqQUxZKZNj4HcKkBn0huWCWMUSMNQtaE0J5kFlQtGaaAyik0iDHSVWtR5fLDLIavf6yW76un3+rb/1I7+r/V+vup6tVq7uyKLMuupF1zbabsiyDoVpJWNXRTTNEknYzZTboKM7nVHmQQMkzNJJNE4g53IdIxF0qhAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABueQNwMbo3Dm8gbga3RuG0og3AzujcuvyBuBnk24FSOoUFJQHWwIym++Csr2txisehyGc4nQvkEG0EEQoPABhRKmBODA0Y6JxdpJVBm/C5zBxiIiFgkrKxg1OYOlaCJffZ0VqMRVILC7C4HWyCR4x2zMbd0D3LjDHkW1NCQAnJSSh5IKsBhiGS+OkvjMnyuBosxEzVMqmRWWGuPmtzEc9kz5sWUseI2SrdVS6i8snVOXE+tkjRL9b/q2/or//29q26//q2splo06l0dGy00FpIouiiZnD6L1KUddNNJbrXUg6JmkilMFpJaPUgmzKpMgYnWSrVpuymoqnzyh6sY4JB5M3RQFLxIUmVZXq8SvHJibMqjcZsLB5sYEqiYYHKaGMB0WbEKEIcKrUiJgYGqFarsG/Go6cDXcg0bQPtdHRNUrDlXzEsMBLDhgAoCkZgugm27QNGScMEQJCygAL+6htyAuAhQUNxJmJObyYE2PY4BNoGAZmRcGZTJwc8fQSJnVIsiOspoMZDmskcG9HQ9BfcyTWQ6yP1S7X/qWr/dfq+yq/9m7Mtt/X1qd/6a6C11UEUVrZBVapcTUtSLVUE0T6KbsmtCkaJn1IrPqRSUpWnQMEE2TQYypp1tNEkUlGU+lmy0t0jBnwG1isodzRvY9bh2n8fttIxGYLbmSCQY9rqMRHVHwhiXXDKAgwwMjrkg4VcYoDUSiIYLmFEOYEUHUGaNoIIFEGlKPWpWIXcrAwcLoDhCQnTzRgkmDq9fbwqgHA1o6U9WWFQDDNZw5/EvkQJQQsQUV0DdxRYCGG6bmp8VJF2qICkkbOOcpNIg8XNplqqlZyhUZn6tcrbd1fVrf+u/9let0Vd9Lb//72SqdBTMpq2vuizpXTZejTTY+pFaaFZ5djBLQSWpaCKSCSqTLZdlH2MDFMXWMjA3bDmQsvLYmo6DPDQmnE1X8cZocubG2z8vOzORoqGPQamgYWA6cJjUM2m4CEMmcxKuJVEthECqAFYjSYGMEg4WZQ6IAgxw0LERH4QgKA4u8Bh0XmlgaIQA9ZgARHSjqYYCpWZmVKkd5CdD66WniwIGA4aoEACAs5ovGBOl4yOgQsOcTRPLNUyRBuQNJkkTYnTY+8iTpmRF1jnpUj/WklI13TfrZaTr/V9fX9f99v/9uq7X/WpJ31LUvu6S1VrOKRSTUpJlsiiiZucNUlrTSRUyS7stKi7Ia6qkE0EjI+ggp2L5kmtaarMaIV03WmpRuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAbTircDPKNy2VHG4GeSblvWMNwMco3LdkXbga3NuSqGgOBihCcZbJ0kIiNARGj7cXVZHL5LL2wumVAsYDAijpVFAEAIkKHkg9PcwyFXXfoWIbOiUXMMIgshmEJswCRjRY/SKCw7YvVZjGo+VhZ5miNDMBAI5EPTIBUFlci+xV51QLDoZUbiwyRGB820kBFh+Ph7KRmBuigfdjZNEroCedsfRWM0lkBQrIZHzmBv6062kx9kjCu6/vTtX9v/7fvf/73+17dqkEF1G7LZGmktBE4itamm2aKZFmRNlKUki6aNkVNTW9BkV0LqSpooMs3RUpBbp0TZl5WXsOM+Q5BLhkyhPCGVlEZMVdChjFaavccFoQoIDK4OWAGhknQZAGjoNTAAOMFkp115DQpnhCC4eNDBIqiMeazgjSagAmIREBG6JqX+CihDpC2zOTBYSOvl8xWSRJciACMFc5Ld+Gby9iRgUVmBi6hVKbhgQ4jh7TGaAI0kCFJIxukSZOqPvHUpS5EEVuWESQatLrWejo1L202s///9u/+/6vb//VX/6Cektd1qSWy0KCpoZIpmKVSzMwN1qQzc49bopKRWz6LqqOpMg6db0HsaKUzun1HzZSBkNRJWL2NvDeqdO92RPw0hx1LmDuVF6enkLWyEQCQrVsMaBtFAwECW+iLWDJYGaHDYOCj/mBQOowukCjkaeQBD5rERILGAitDFp9nOlZCNggDPxCEwjmJbMglIeDy4HGcoVCk4xGhgEZBIknlNnskBGE2VRdENIOBrRpuQIwc1MSVFFJplooEMOF44gQYwMFENkY9M/82o5u3d5oy/6q+pvv/Xa71/7v/3QXq/fdrrVU6bupbKqdalpKW55GjNEqrrdaSSSVRq6M8k7uhs9lIutSaKSDoooMtkE0zatI1tHPmUcaCHKjGzDE40mWg0LYo64sATrdZumgtk4oZGPgaVIGFk0DLUdx0bESgWcp4NSMbBZWlzRm5lYhSwNZCMZIRIvqBB9Y8SSZfh9jBJcW8Vnq6CiScJtGC1IcwqUJ8JQvrTLokyd5gwKcGnU0A8KpGl4hw6hyATgPJUMDVFEphuS2zorOmKCZkQNJBAqxynqVXWdNY+3pq+s2qdv//r1f9af22/99dv2rUtVLXstka0WSWp1OmpSDPNEUnRqR3uipazNTIPWg6mQWfoomx5AyWutZqgkaIskmqmcYlWAkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAG1Y83Azujct7xhuBndG5bPjDcDO6Ny6dIG4GuUbgQgNq3hkGI3HCI6zfwHSx5nMCsYeiHog34yNGKAT7A5rfsHBUw2Vs5jBYmatYwkNV8IBlh6aRjLmLcQiQzPDBO0z0/bLF1bfiAAYhUCZOo8FCc6zSC66PK6pWVI0jILAisUTkZb0woeaXCIOJ4jWGXNCaBFtCgIoGxqZGRcC65q6VRLlVlJDhZR0cTkehRV6R6fueq1KMCWrf1f1X/pVv+rvdd/r6qrK67Veyqa1ffOKppKWkh0Uk20UF2d2RTU6q0a3VPqQXrY2TWYru2kpFRxGtRhZnNUWdGdGNfToLB4BRUrB8bkKguvTD79LprwNVjLNxxIMxBnNMYBkAIMSpG4gVJzY0VizCzBh5OglAmxmyLAjcw5GMKAQyUQtMCLEYWuKggydBM2awCssCoGADQ97FMI0wMXsDUQXsh0f9ONsC2iEBOCGSIcl0QMC6kRYui5QMOvN0zVAxUahAGPrc+5HMylk8bHDA+iPtmc91rdyMSWYv9abJfqb9bu//1f9Wtf/b/X3v2oaLug6V0jdaRx02ep0E2Rem6K3QeykDqBkozUko7ZSRuggl7OiqkfpPTOGdNTKmreqZmFtLCpoVlUEDByAJNdorxSpuU09deQtadsVCFVRgBCgglqn25jaBcbGDmlQ4mDhjNgAEJ9GFAojiSb7FgQbPVYDVjZpkdfWKo8mElBblQJTsQFBnnGTMgKr0J7ukwOkqzqGMILApGYQT9cyBDYjSGEMIsOQBnYQYINyJF86XSkA0BJ82d0x0oKMGIMpaJCSYTUkWvWjNM36lyknW/////3+t971q9nU1X2Xf9nv7PVWjdaKCKbc8Zs9N1NUzMpT0UKD1rXMmM1uySSSCJqpl6aKlKu67LMIaNtKOgbwYBNYFHZQsSXayTFNVz25Q2/D2tnf9e5KRi67AAKC0qDFhBiqPYIBxjUiKbocDDgbV5BSShjUyiI0p5GAQIDAirYYHIqu3BahISQDmBWyYVC7E5cTAM6GJgYiRJZoerFhhhz2K2OE0gCB00aJxYLxG4WjAfhujuF4BqEg6kCHmKjBIL1kVPorSI8tIIsPFajZMqGqlG/nGk3sfW9lrN6m19V9v61/r+yrN62vWvtV3tZPZfoaCO6K1umzoLUoySQWpjzIIsb2RWyjB3oJPMUmQZO0wSQQ9FajZNFFZytSFB0dJ0FrpT6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABsGGNwM8o3LXkebgZ3RuW34k3AxyjctKQ5uBjdG5h2PASM1ClYC8TEK0E5u5CIfbDQTMAPWwMwsAFDDHQJRYDBI78YGASYbCk+twSPq9ACCG0FjmFU+JKIlHQED7gGbRa/K28IBU1EQVJi2lirYCQ6cFTxgE5DRqgl6VNEQFXMQgJ9QQFRGJpuf0SZuTx8eRIwa4xn3NzMooHR3ESPqSUcKyzViRQyDrLaVlvas3c30V7pqMEkVfV/st9v0/t/fvXeur1/+/XdKtS6001pOyFTrVQVdk9SVJMwMFqrPorUiy0nWtF6SCz2hQRorQTOLHcwEmY5w+qYwWFQQVyCYC7Kac9SJKQEzKlikFT0MsvIUJAU8YCPnvM5MGnKCojHIAbesuCGqKpepTgluFC9LlZpMtsYAB8mEtEv7MSsziBDstYqRRgBSexCCBTDPtF95XVLywYrfI4sYAIEqREKssJs3IsLo0IYBvwIb6XkyHpl0silR6U1NA2SYyJ+yjVQ6nUs21qVlyo4/sdVWi2236PV+/0G///XVf3TbW/poffSQQZanqszKQdNnZlLUt3PLQrWpzNqKdBBbrRTshsY2mJw86S2RWtaD2d3Uy1GVCN6wASchcCJg7civpi9kEzGmPROAeS0hB5gwAoTjFYRIAArC5D7DAGCBbTIYGFQa1odBaNAcgCRNgolioIDH+pcDnA+ywrbx9+jDwmIj05sJSxAaRBwCHh+0dnUtQBLVaHHGxDADMmDOCqWWGhaRIaXh+A0SoODHNKzHS6Vg/Yv17OieYibqWQyRVGo29A0mmbPsumV0FOv/W1Tbf//fX6l6v1+rQ7rqqfUuymRdk0TNFSz6lGruiqiX61rN2TP6mZbvUymautSKKCmRWpSVakj6K2PrOroqEaCjABraazKxDgtCGtljgyyWQmRSau+Uim2hkB4VhCwpgQAnyY4CsxbGISk10/ZUjyZEHMFYczAzptSBc8BAZZpjYkpJqsjaetIu8YMiE1OVhjExwwMsuTBi8nCxUJZas50mJoTNspbc0RFZbOcOkqRUV9ZdBFdIeSBsWVFwmAEhmnluimpaRPLUpcZ9VZr6l+k1TOs6pS+79dfq///qt6H6X9vbXUu/R2ToMp2pNSRpH0kUGQqaySlsipZw1SU+swY7QWgimxqyV000XXVqOKQGMXvzvWwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAbcj7cDHJtw1BIG4Gd0bhpKNNwM7m3LVEYbga3RuWgpfGSoZtCSOuWQwRfE5A1xWqFvZKo45AqHX8GQKYZDkKAQzlbqRoDASXLBmEQY+oUBKrzJ4XIEWLCIKiMyeEFiGTxUlw4jrMna0FjcDhs3iioNChxNLgYAExXkqmbfjAHWYipKGdBQFgYbPzD9Y+SpUGWImYAeTB7hZWdOGxKCChaauUDzVkEQpDmqMj9Z7ql2m8x/KaaKvttZXe3de/6u31depXq9T9B/36r1rm1BTrekpG9RXRpKMXUcSSZnNmWk1GimtFajJTLsZJKqWo5TZJ3obUmRqUeROqZYvd5jXwMZFAGsdjiYDjRuHmXv41qOuhCxUoemQBYNS8HAC+3cv4bCbMnFQQxAbe2w0s2dQTaSiZoJKDFDNjMeE2KQNDyNgjjBwGjbSACBnztQ0BE30OAcfYgi5TtJfV4kkTdSJm8Z2aJE0RQxUBrQBxM4mbrHKBISggtVFmWmS1ZkhJBFVtdTrfQb1LVX/7b3+r7/21/1dvqVVQv13rs6/12a6DvSRMKbIIIpGdEySWp2TSTUgZGSVeySS1uszUvUgtS3PppzKbIukiiktKbF5BUycUIeQZBHngDIqKOKELGaVi5k+5kpf2anCwOpq7HqVK0yAgTBghQcoSWENKBxjEBAHS40IgBDG1IQE5pAoXNMoQ0gUyGUSemMFXDEAZqbxEpqZtqGCSgQTM/b9WlmrjJXvsvlMUOoJ6VSZyKkciTqwAIh2T6VTE+Rc8pFbFdT45aCDjSUZpMyfy26noba0VMtH3+3f1fv/2/7sr72X+zLvs9ar65x1poIpJPSTWylLTRSRZE5Ukg7UUDj0Tegtp83PzlCzVPWtlJqRayanUZus1OPxTKholLmmgl5R4mma0tvm4vlMQXm/kDRiNCMCMeCIiLBb4gkTeeOjocbMAM1ecDP2Cy5834hLuJxioIYELpLGDrCNzcIlTomGErRWMJJUgIAz/A4yZ0HsJBGzu6xdqKwVlP4ADhjQM8s/NFwxLxA0UQNYLOpnFnlmgNASTJoyk7JmBmtZxFAZY+tnrugaTXTb0UUaq//X3+1/7p/9f/3r/+1egpbVekpFB3qU7aS1LQWaMtBaLqWkkeW6TOgzprWgpCtM7QPObmi+s4p1sYMkgbGm46ChAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAalhzcDO5ty0nGm4GN0blpKLNwMbo3LT8YbgZ3NuVJ4hSEBUAUkAB4Mnd5p0rYMle7EnhyclpUD3aJQoxMfHBIyAvY88bQTXQty1BjEwlf4jDl+Ggn4AN2NkoAGaLNTD0RpkGORdaAYmygopLbKlCgoc1YkFwHKDYH+TyIARpAKCJl0UNyAVadunNysRhWMhygTqHBjyZroGghcxtcgLutY5CMxHjbS9RgtVTrrvUWkf/ul+/VZf9X/ev01vZ7d/s1/TXSWkmpa3pqWpkVIWUiyaFSM8k6TpOmhWy07ukpJ003rPOzJqUfrZnPqhQ1aJStsVKYIM0hC044UCp3qgrbY6aVZx2WwFcVXMOB2MigIlYZQVN6rYnuYoNs8f0yIEY4tCeGworASZPXUGQzZTFSlfr0VXpjANCwcoIHtzFRw49zMDsg5Sbm/atY4FxN242/wXEgg5U0sTRqmakcZkGA1ZYbxqaGpoXCUFljtc+yVkjZyLu6lRu2U1VCnP5izvsmjV1L/10P////+nS9+zK+ten3TRRTUqg6jFkmQQpIm3SQrZBBaRsyi+tk1IslOMtaltSoopOylKMUHWgt0Wq2qm6d6qBgMleAh+eSl+EqlptafDG9Mz9LhL5CralKXDNJEGvm4izO4LKoABTBfrMTHRh+RUDWKY4kBQDIgIGFgIE1tAg/FgCTstuy0wB5CAp6paXbP9SjGUQ2YCGAZj0HIA21LPvg2QQBAJGJDjLjc3IoQUrFIABMTRi51i+mMiS6aao6kJ1Y+3RkXcoJ3Pa6jVloqV9M4b/t9tSvv///Uq//3+1169SCT+td6C2q0UjZanpLRskp10jiloWRTvUifQZF9bMukarOqM11Mq67rZy65AgFJA+0REGG8QlHOYDwHZa4z2JNbjdG/16jtywZCwEeNGMgD0GDDzHrZC7oczQejIWA+BS/6VIZyBcPFl4LBoCCFKTKh5Xculc9BAWGDPgJM5uQjGzJY4RyCmT2J5N4jwpkxiX0TYDAANi1DkkcOkNJ0fYHg4hpaWYnU0AbqmfPmyCCCzCs4ecdDPW+y0qGd+tNCq+v3/9X6l//of+1ql/+p19k20FosmyNBB2TakpM3TSOutjA6jSUdSOskzLUu6KbshQWZ2ZTXSVdjJAxXZbMgYGaDSEoFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGv5A3AxubcNBRxuBncm5aYi7cDG5ty0RHm4Gd0bhWxKlTwEYVIJ7MIZuuuPXKePShypypxugqKIITRApOEBgDJXAVea4PwLAIKaZUIBdfxgKWXYBRuYWGGogr/A0IYGtFOWAY2CB9RmLsSEAaekTBQeIwFDpATgiABXODASDW5FugdCsFkMacfJwdRdNQNfzMj1Jmii6KcYLssjzdNljc1lJifSoJ6q3pLrZ7vrqb/f+31X/+r6+//2qVq16FWyDVMugZzqSaabF2tFbmJ5aKqbmCJuaLSZkkEFopXQroMgzJmCKKCkKaadlInUVMtFFNJmRrY+6adOSmG/Yan6w9YmHd+BYXRsvnMLdNKBGQgYXWUGEcfMHOlPuMFgAIHoKixl4RH1qqbGol4qdjykyAaaHMMZFWbtillOqoQgA9UqFN8WoOsSTCKgMMICURfpQ51FH5a7CThQVOvvAqkwkUECcADokEz502Y6GjFZGi5RXZAndSai2/9NvZ23safr62/1/1fV+k2r6tVe+/t/W6dalJIrSWitCyKCSnNjWdSRQSspKtFJGkdUqzrczaqx1bIn1OyC0j6CaS0HM2QUxxR9TosdrVrKTAFVCxkTAvFIRnr8S2WPM98FTUExfQ6CAAbJAQw4ZSUNdNVRLnCgSbmIq1KAI/tXCggmGYWkF/CtRKguBqaBzGgRrjI4fjdcxQIHnJdD1hcMNnYQqID5YIAi8zZDhGiEHhnJEUIT5ZQv8ZEUTFmmRSA8QIcdUdSm4yxCLWlIY9JEjbKLqyKnrv6nWvO91rvWy+rr/9qq926v//1e76++3ddOtSrLunUmpkFpKWtlWdTXRPopOkrVM6S1LruktKs3omSaF62UfUgitE6m1MzGpxqqwqCwsAYyphelNbHGJStsUCtxlEphyaeGHCUjFAZAsw0IfkygrZxOLBDQ7AT7hh5wkCoBMoMAImg4GCgMOBrIDGhJWJhzCGusAMFGQdipFSEtseKJmOyA1QJSLjcdPdlqqE46DajxY/dPJlOXS+VxxgYhOLjNWrLEWsq21GT0CJLSUpZMoX0LnXp6T+5w8r9V/66q3vXqfq+3Z9BV/9a+/dXrXqb7qQTWy3aumpCpkn2SRRTorUYugtChXPoUrrmazSmplJMicU2p0VI0lsjNkkgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABo6PNwMbm3LMkWbgZ1RuGjZA3AzujcM1RxuBndG5QRxARiLCzA5hRf94L1HAMzDTDYRMOxRK3CMmecomlNzOFZ+bIwKEJ9S30incBIc4hnBeShoZLDhiY0MLtMxBXMl8PwpwjAUgx8ILlsuIREx9eMbVx8hEQQ1hkqITUQqDPis8hBhGAPzHqZEixVGOmgH0ZUN6zzohxLKVl80ZnIEtFzZIaz1mjO3tr/Webq/+/9r+z/9/b7/bX2ZfVquq6SmNGUlZ1JaZ9SC2RNk1KrWkmmnWiupFGqtBbMtBJabmqLpsnOIpvQWpT1JutRizUDLJRSupQQwgGgIqZyzesxqncZ5cIm/8Py0gNgqO5JRhTFN6oc1hC23Ld5UwyBeAvmqQxsEkurcRGExbXzam042uPUw9nIB1gKyxR6iBCdjUATRHER0WM8i6YUpjLYrOm/GvNPWCoTZBTxeIoAloOA8ktJZNiEJL0nQRd1onroGrlhnZ/qUrQVtmR3v+quv31e7/rrb6n6/2Uv7V/u6VJPbdnZSkzFJA6pSc3Um+Z01mKbUkFras3ZaaCdBSKJjoMpSLskqx5DNV1IrLx/MEW4sSFCzMPAKhGGzV6F6TUketltK/d2jfhfZhhSOBJkRE1gwdXgKAxCEG+CLFILQkvyMjblmkkhYPx6SVCTgDQDOClGtlED4U5gCwpBH6LOyakdjNePbKji1HhEYXeQEs/bR3wVCxqctok246TxcB0BjFBMyWdFxJIqZycc4gxFUblSOtVJH1tf6us8iv6D9f6alf+3/X2t/rt/srXpt0UGetZkkgtNkWWykElmpjUtJ6KFNaTPsYVskgt1NXRPLTd001M6zhufPPOuk6loKbRUaM5SnZjpoqmP4PKrwULk0Vm7EYjEqcqA7y8RkEQYGQFZpngrchT7kS9PLDgouYeDBluo6YBVVBxQIhkwEUXyZoVWo/Qy56TBIcFEA0GyUYEjbmkCBZNcJvQ43yM2lVqCAEWQQUVLFIVDMmiJGpDQKpRkZ9IvKKIZMZIp5GM9JJakD9N1U/Zlp5z9R9XpL/9+/R9vdft726/+3Wv7LQq6S62ZNNloO6CLprPrRZaCFFA3dBVlPUt3QZKmgtWmtFFlqdN1UUWUmo/epk5rPdhwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaHiDcDG5NyzHHG4GNzbloqLtwMbi3LKMcbgY1JuXggJk5wopUIQqMLhiT9ujTtSjUqfm4/hVASqRKOGRCK0QapO3BQXAzGwtXzRS0zKyYIg80gPEDGHHRKUGEEssM3PK0SYRLYAMJQDKgBUMHLyEp8GWIKYWiLhqLtV+hOl0NNzHnuYidOdLJdIcXh9Ajs0J9I6gosDkHrUyf2WTzoOX1kQR3V61oKenT5xP/q1f/9v//brr1uv3+tbMutdkUWUuzoMY3oLrW9R81MUM6mip0VoUKLIuaVoposimpNNlUGqSPJIpaBmoyUywkBINAGsGsCKCJWJIEBWXOg37XbkN9eyjyf++m4BlNR0zUAfgy8ck8EioIYABSmSgIskIiFk5jHkMkOQdIIIQdELVM1K25wtszAWvg1la849lH8HuRiJWRXCOjs4sChK6W5UCZ4hKXI1OmBMMQ83JsDBYZIolJjBSYsZLJpLTPorZNl1Gku0VvVUpqD1N9aT/3/1VtV6l//X/v6/e/363WuvtZTIV1zSg6jVSaSCCWeUpkEFKUy3uy0F9F60UmQmVFkUkVKSUpNa0VvSZJqR9tElKJUOVE7CfB0j2wyoa7sWljfwmNVovgg2FCVsQ8tuEZQnsS2iAPT0nbVC12gKQPYNT4y11QqGEXGrszJPR/YlWislBJeDjVfrvJOgIkJJkOCYgUAMAEgU5SCWy0AKAhkQA5cmlB80LxqiMcDMKovsyLmwlpmktSjVNNE62ouIFZVFDVU3pV+orKVZVLt/epT2/1+y1uvV7Vau7Lre66+rSbupBVJqVPQOtQWeUita2WyFFFS60knSZbKUmqgs4y0LIpqUix9ZoyaZgiyObPBj5Q0Oo8JrJuubslxUxmep1NHlsrcWciUsguJjhItoh6ZQcrQbQO0pniNxN1eWWA0O8wFAPyc1UBDI+5EBAyg+CDfFlrQC9sLZiBKY9fYjIhARP5SBPcPAr6YY8hABi7Uo1CmsmpJUsI2YqLBDkCQA3tNjRSSzouV2qlE9sX11GM5UvqZS6Wtv0Nv//s3/1226v/0PqrqU7fWym1qujQXWgcuiy0UmOZ5KfWyU3SdjBNJbTjzFOigm7oIJJmDWoudWkyTo1o0zWtSSZ0UwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGe4w3AxubcsKwRuBrcm5ZVkDcDG5tww9HG4Gdwblqa9S+idpisgtjDjO5LAbxw1B0xPQxRJPiMcGAEhEltmsmS34aFBIyAeZrDDC5eBRdRg0oIKqeAjQgFzHxrhja9DUggWihosyvqCKSCCqAmF4oCL3hT4gFA9kqt0QbgyMwMNW/Qyw8gkTxuMwBzOPZcZMzSRSJK1Rsk61mSC1GMmUaS/UetUpqVSlJVa////3bev226+t1XVq/2rv1Wqsp9FBa21KSSqdkWOmaSK1KSOXSTZB0EEmSWkyTpGWpS2RP1IvRoJIoJIouxiiNasErkZgCTJw15jE5MTWGW6z143Ootwiw89WAxQiARuxgHEq4DMwh+ZsRgphorF1MQEJQOSia6DZBUSCBKtUuB0W7Ak9tBbLBeGIiJTNQWkcMcFjEncGQokU2mOQpnE25tdebNAgZb2rLzYvnCydJ8C4ESRMWrUHxMtszNlvLjWNlnez6PbW1PqNVf/////V32dX//vr1W/qSpH0kWsmilQQWzosaoma6alNUo8t+iyWZoKSmK2qVrN0LmggCjCCukYSy7Nt4W1Kn0JSyUbV3pRpF3Xjexu8gpajvShR0cGWuDRysQ2YFiEqXWZ0MyGbTCiYEERoGNHLRAYjzYkuGMCGpgCvK4zAUKhswMBeJLh8paiWYBlgbLEIG1G8IBFw4FfRhowDGLikHU1lkiYHSXhygOQBikataTnBGR5dllxTJpF1aU2kc9Z/11Pv9lId/X//6tf////f/11fZNql1rrQUlZ3pUEzBPdNdJaCCKLIO2pS1LW5qpGjs9aTUU1si6lrN1JrMkGQRZaSZ5aCRolM/QXdMcQXEbdx3c1BUEWJZSfTTM8OkgCMGdBzEygecIQ0dxQhqxZaPED8JwqXgbuJDIOaRGCmJhi9jNCNqTSYGlM6owGRzZsElzgz4US1dtfa69kPOg67+t0d0HIcWm5pAlTAjEywAzFJFGgmgLN655NkpZ5VWe1/9S1r6quvVX2/ddTatt9bq/1/u9d//W1lNX1/dNTrSRZkkEk6KlKo0rpIVMpBIyVpPd1puigkzsitJT0Zim7JTdSalH3QSmBxApOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABn+KNwMbm3LK8Ybga21uWRo83AxujcrCx9vBjUW4aKo2YhA4aTSGrtMnsurNv/DE/KrFiJUpg4ktgHG77G4g7n4kgmJTa7qAMKH6EBAyYzI2AgGLNqmhggK14RoiiOEeiMEr1UalDqPIJGhlCCEmYhB1SwEQAD1RKRtMUaM4BYZry0xMywOhQ+APbA+iaBuXLiEJ5Kko2apz91lpZD+aaqtDtq6P9W3/Wta1/Q/3/v6t6vutTerXXWikmx9lVopo7rNEUk2MF0E1GyTmTMnUqsxQUikZLTdNR9FNKo0QXUkpJzVaap5RukbVkD5trut0YFjiwzcBSxHpptWMSGVvblKYeeqNFUUKEJhJgAg3gCV2pzZIBGTAlV4QcR8C4RQm4CBIuCwiKA4RALhM3LnodWWyJpRghAPKRMAT6/DoAAwghDjeDXUsthpXcxe9AUZ4KNMk0sNDQvE91AAlKZiikfSNBcRZBpEorTL2pNanqf1vV/72Wv+3/a/9X/Wq1X/av7e7KVW1VFmTs62TZBlsx01dqqprRXRU7rNWRMlqRSes3RTSd3STdaLLSRU1CtBkkjc41NzyL4wxkD/gpS8zoUyGa8wJe0vnYw8HKkml1dWQCibVSUcUpNOMoEl66AKQKCppGCib9AYGSAMjQV5ESwmMj86QqNz0FOBPtxMFN2ZPw6r3GTjIqQEZMOgspf5HZqEF0z8NwBz280TuGJiQ8jURXQIPxy0kEFsiRYvbSGugmtBrl+VEbov+tmdn7fe///19W1upv9al//+vqspV6Sq6ra3ME00nUmgiyb0mUgb3XzZkFXopoIKVUb3QRXdCpWiixkkitB3NVIskmnSWYHFmYs2XAB0pGj2Z5/Hknoew7KMc7s+h8PNY8UJF0mMES6lQbMsHgBmIIBR9mK2jemwu6TrHQhkgLiGgZu/G4EuQEOVg4UxGViog6ccKkyZ09NSBoLoY3Px1G4RBX4wvGlTS8BWGCaCT1EDfsfZaE1bQnf9evU93u3//1f//////9v70UnV21tos6lu9dSWk9NNloIqZ3ZGpJaklO6amdFSbVpIuuzsy0HW9aFk1WQs6C5iAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAVEbDeDGqNyrhGG8GdNblWqGN4H6m3Kk0EbwY2puXaa6DIJzpvvi6sFvZLJHQwNYq0sUp0CA6SpAcRTIMPFgjChNkJb1mZgRUbJTLgmGgNEDmr8Pw+hhgzTom+lCvMRYSZcxTJSkQKhkgU30O7zziIcCO5EmRJ6GQIRXllBZiVUieAATCljXWyBDD27mTq09Ewk0+/9T1+1af///+v////7f/vt7PS7abIqUZ/bCt7Q8A1SstQybBDVemAzXfnZGNsh1Gm87706CDQPCEdqSleHY81u7VlEmhmFxy+/ws2jRQngBDnKaqYomTbbAIA1K7OzJMkTig+ggEjbADDsJypQWIFIgyrYfgolFmnqIBSKE9NeEPpATuUd93AMUobllncwdIAsxIVKdShKUkqE6vmyD0Zh9WtCpVX6m///q//////+v93+js6k7rSddJBNFJk3oq3r0KS3djZN1ospOqktutJJalqrZ9A6knXYyUgtRhKJej5pBxBmg3RIx1s6cUGWHL+Fna0soQBY6Ajydpn4Dt3EtyJnLn5DENEmakkMwWHDSldzlwGJGoo/71y59zRAhsW5MdUMNIjMlsH5SU7X4unK8z47g97zACbNLcTUxDiZHJALOQh9VBjMV0++tGy6StGU1XV63Z9+/f//1f///X//9vV6/v9HZ0nS0zVkVI0FPQZNNWutdJ7pqXQs9Na1dVaadSlpHjOQhJ2cVzXrdrrfJRiOhK5vWs40k9WpoGis9hJc03xodU7HA64uaYdokDiwMOC4REFP1YhwlIyQHQqTDFluNkBfbiUo47IjG1vzsvQmHFEpgQ8THbM/h99rjtwRMpvkoC5VJxCOVIjASLDQxj1YSjF5V89TM6dp+z9G+j////b/3//6///bPOX/oafRXV2dDrqr2V3PqjWNfaz2PeurqyKYhU+UFLYQ7MITmFkUcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAFWnQ3gxubcqnP9vBnbW5UVcTeB+otypnCm8GdNbmhcAkIMlUVLhO9ZkEst1MbU/nqtNooPWXgTANUIXIh9DAoD67wBAPDRCGUxgaE9IcAvaRByi4IA7UpqxZhQjLAMXRWjWma6GBeqBydALbxJDyLwBLJe4gcbv9Z6mbsRqJNgHhKS0aloiynRso4pq3rc+5cbb+31/////q///1tv+3/3q1bOlu1ndG97upBBbpstK7KNyRNrzK0tBhYOZggONLVyg6LUPygNbzdRl6Xg2wCWFlTMPRKk1IpRe5lQcSdCCqMDxa/KcUbbgoEETLexNPiG27r7MDFhUjDgAcB0TpsACi/saV/aMADKkZBSpjHLjYVMBYesy+mZ/yAKe0vow8Ikf4rZMkkDoN8ec8zqcSc8ldmdurZZi2vb+tvqf///7fUr///X+3Rv+9Lr/Ug+zqQRdTI0kVMt6CSkU0aLuestN6dCilmiDKwbz4CTc/Qi1szs0WKNHBOBjhIxlGWrYThMvQa8uSpDm2rgJQTpHHe+cHAysluPp6UCV6zDMMYyy1NMv1ARhAUqlFPQSIYcBjiCXmnT4GDB9k1H8V9i7z8Nx7GkGAoMcntZC5QSMwJ5n1MUhnDV2rLNSa0NbT6VSf2p7/ZVXf//////////10Otq/porVWplaC2oppTBgcR3TmDV1yiw0Ny+6o1ZCyy0Ige3ITh1kIDamUMZVZbIiAeRpD0zMuvS+Kfg+O2kmGBt2HkdQWG7iQqJNCHed/HdqMglRmAYofFmCioRMaaj9QP9OU3suiMHNGHBJvMBAaT6ooU9rEKaAYDiaiQGS454smZLUmAXDZLUtYVR25U/R65h3fq+v////////9v//+2rvtqRTrU6bLXWummgta0FtdM/premt1Tl0KaKrq61J0KDG6ldunBigCyhgaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABT+BN4H6k3Kh72bwY01uVKXw3gxqTcqmQRvBjbW5XzPDZCsFhL63uJjImOuGfeaSeqEgd9ZQNEmknaQNBjyaRMhwegvjERgXEzQqE94gpiGFIyLQ5C0qjwlgBDFHVuEVVWOfJHKAs4aIx+Rp+22ZagxI4qC6+urRWU1pAXEsO9lrD8WXqMKmnaqco97fXt+7/6//////////9VVX3WylVIqpqU6DoOq6N0jdGhRWm7IqdlJp3pJLdBKtZvGy17Fm1iWucuYy1tohlAEKBrRokSjzpu1Bk/a+btWsGQGZASsYCOqTD6O01AxoyG6NUcSdZ1BZ0IhpFIJAQOg3BCJ7EK1iQEpvCxAYoKONZECC3VlzZ11SluUbzRfHnUDbxZSZkgYgn5YyOgdEaNfdtT9J03/2r///r/////1/////QV29F2TdTNTZJ20kEE2s61OzKZJFOymWpSBqp+j8UJiAEKxiS+qfwvnpLSbCyxjBuEkUpqzZ4orKK9f8JbaslgOpJuKLjdDdu36uIcUh4Gjw0HgovAxY0BEgEvYygiatxFlslo5c/romJjlEGJ9KgcgvFWsRcFgIGhDuSJlOcqXwm0/V/I6mYlBSABZF0/s6Iyxv1l/1dUsdu/V///9v///+r/+r//fsjq6FecVRWughU6C0aC7uhSRpuk6V7rXmNFnVeO4R6JplSR4MT/02zFdLIR5gWuCiwCxamn4xAEikEv1N3ElC0shTVdUiFIrWbAJQs7VRQhajr+g4cLOFCiKgBk4CxIHBDnzNSxDJgKWhfH4cV2cmLGAkQkAQxG6JhPx+X4OQn1LJ6ymmkmtEEkQZB6aASdPrXv9lor/3+96tL/r/////1f///q6v9Nqnvz7JJLUpN0EXRahZFFnTZ0KaLpMZruynTugypsntMgAPFCQ4tdP0TKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAVsjjeDGoNynmZG8GM6XBbCQNwH7i3CmEgbwZ0puGJtZRrAU1hWvrhZFK3Gq1pDnSTluwOAVB5YPHV8mKmUsYrg5Fbp1gLwjFP4acEIS6tJKASXlAQGhE3JoTAZgnYOJ00PoeHcjmFPD5hZDxRdRrFl1yQXIdrXMHm5mzgdnEmWt1HmfnvdVkab1L+1ev/+v//////3///upf61UalqZNS2M07tZNSCRrWk7KrUmmt6lrS0FPQXVRWtaLvWkgg7rqWijUgk11MmoyXjqCVb4QCkmhY0psMbqOVbsv9coZ7tosAAYaOQfOjSdngqSYY7QqBaNd1czHBGICb0vuA0oaAx0ntwzFapilJRXdm4jKf5E3YaQPBHpNEItDV6kdJDemp8c+arfgtPHPf/zawk9z/+7r/7h+/79zqOizk/7v/u/u9t/Ss+HSAaAoo2dPlyQ4wBjTEkgSB0eZD5kCC0CLQxCgID4IGnXh0kGaH6Xgmw2BDSfrTMha83IyDCvY4kACECUNDxeyAxBbeT2xDQxZlits6CQdUIYolQnKBSVESNLgsIwPGZLIIWTAgYrqfgRp5zIUFSMWrUlJFededabFaNhIsLxedrKOHSgtADqmyTO6YpE+2o260Potpfeh/7f/+u3////bZ9XV/q0ulsr3V51SluZGC1GDqTWt03TZTMfm6bts60nQdJJk1T8+fNlOyC3PpmbJqeynd1Ja00GmlLDLkgQ8x5gwd1JmNzMOw3GrkrqW7ZIEJQNMsM0AMUVY+3oO1QPbTqm3elJhhBAsIjIoHAUR/REBnWk48bIuweXNWj5UGGRjiMiRLXinIVQSh+fpZYgMkU955U4qxKCxdEooERZ97rZdTJG2unrv+v//9//////r9v9q/Qy13qRJO7mM9DTnPLzr2POvmJnqae6HnObRjzZx9XJDVV1Xoe+iKea+TqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAVDgDeB+otyp9GG8GNNblT+LN4Mam3KkkZbwY01uWk+BChrAAkAgOR4sQ3GZcOC/hQ2VbUk2wjAJTs3MB56RP1uN6Oq/d8KA36Hl5ATJjhKBDC0jHR0SlMuyh4USDyZ55QsCepMDC5RpfCMS1VWVPN8amQYAgXumN2KbFEACkvS1mIpI2vtvWy3uc6PXen/7//b/7/////+utX39+lqpXQXUpnptnKa1IutSC1JU0UEUa1UmU72ey1s529bwuyTlQ52JdIk+C8UOo5hrgDxuDJ4XFoOv6yxjuWNssCB0BKlissAxe/Tp6F1J31+RKUwswokhZOCh2B2GQFQM99WX08EEBwObNhlie5xWQ6dKDr+SmDp+xDVqKQ2Dhcxywgg6SKA4TRR5ekFCuvOO61m3RmiP7dTf62////+///+rr6/9/v6112rSRU1bUFozRaSrXVqSUyqkV0aloKazUUW66CCaSelRZ0kzKpzqBnGYUsWCaQFzMGW+zltXZh2TwfDudJdq4zrIpgta5B1Eb81XBg2tBKgkYFA0vEjBIBJkhIFHgGJADiM5TWpoYRJ9t/ESqAM/LAqUamtygSLKdWnMu1ofBIOJ1LCyyiYOTwC8EnQapI8etpaf0q/r7W/6v2//////////3/pu6kF2Za1OtaFaLHXMUlPQRbpJpsmghZ0dB0b0Vuyz6DqmS0KlLezI9zqXz0x1E7GAMSJFDrQhrxSqPOhnQP9XyxpqMkELJrkQOBQcAnKV2mAy2DH7izdJsRDB1QheQCDFgZcQhWnX4ekcMDI5HJi+21H4ownVDWhiq0mng6JW2kAIQ8uVlZkhcyD8RnRW9ALYbel1nu6kv/r/9r9f+3/////+r//v1eqruzJVtdnWndTJLtUtNlrWky1WZr0lqZC6SSnrQdN0l01LWpWtVSnNM4RYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEqS83gxrSYJvRBvBjLW5UKkDeB+mtwlBBW8GMqbmOPCIZAHZcNw6aVz8P42MeXZip1mEhmCIVaE4TJtLkcKe94ZQrpoAcDlBMZjJM8quyv6xNVLw8CTgpZpHc1bwR2RobBUghMellH2s+qHlbPHuPctzJCLlt/mv/cf///6v//2/ucv/p3f//9/kvqUpQJnziUhAooTgwfLrYDoWE5EYEygqHHGzYFLqaPWdF4iIwcTFlisqbykQSHIKETXqZ3L3LuFrGexkZAokJMg4BtC+9jc089iIMSp4s5BgHjpRWGrsbql4MQlMsrXaJrSuZPTkIR6ykNLW6eQ2mqXXzl0Sa2ZQtut1NJTrWEnNUn1OOdvXXp9qP+vV///+r////////6/t76nWqtndSLn0qmU63RoJNQdJ6aKlupL+mvoLbSupaaJoipJZs2GjbBoiCECcIUASCPGsmyFPUuhUZsea+Mk7KGOwa7zWTqEnFiKWyIlmeX87aU95FBVIrDEgIiO4oNYy6vhAYWJoS49C3IO0bMFHDg7lwLdbnLZZvJkJfWUXuMcc6kZAG4R1eoal+rzTp0tS////////////r/b/9XXQVsky1IKpqWtlOpSn3TQutFSTKQVMrIJpNZboPReta6CS02dXWmybqoKuk7MqaQZLWOnlpbhb7wRas/0sq2crdLHouQrN1gAkHiiqE3caw7vbDSbrRbhlhKVExw4WOiSUwTe3J2nspHiRPI4i+Z9BJSPRunjOz16EXpWqqBsr97SrPQ4AQTnvOmEv1/9P/r/7/6f////////X/RV9/VHb3NYxD3dTjzO55t56q50xHazms6zGVzDpZnhkihs+asBPvmIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABMlzN4H6a3KRzYbwY0puU0YU3gflrcpSQpvBjJ25HG/LcDmE0NA8kkqHcNVKjV8ZqzBKEEcKAjgG3XwfMtiEhOpUkBxvG2L9koRcIyGMmBnwSNypa9ymBgBdVNegcDyyQ+UK4DltaK5aq0TGSYtC8fQTQQZICjEBaktIonnqr8z6q//9f////////+/t6v1/2+tmUtrtTUlWyLLrm6kDZRggUuvG8dCdGEUh/JuuRb+Q+oX5umvJLBuKyMbELCZ5J8ZNZlmNvnK1iLkowBJI6HEpS3G/TqrMuv+31HEJwSQvAVi3BK2EUBQTsPTedQRAUhZyQsoOYFAgUmlvjZp4Jzfvs1FgyJAt/3MQiPKAfOddnC4r2Xrvr/p//T/r//////////6fba10MVyytAeoB/A4x6SAuaTQaZrBhEa8saODtXSGOK9CUi44SxsINANgmZ6xzya8R2StrWVhJ9KF8C+bSTA4jt60LBQzQLvlifl9OgkEY4ucTqcYWcfOZo5iaJXGrWJpMk/rAoCUXvHLJA+1NT8lkfS8vWM1I3ZEEqSKSlNj3+c851///9er//////////vve/1dLaumq1JA1ZbrVanT00lVKSUgqzIIIMitqCVb0qDpImh5HK51xIoSsUOlZjKZORQEI0hbsCQLublly3fqxKRkoAADjoco2i/JRWf5LD+MsqO1gHJsvRiHBC0MMBA85UopugLzxSEvyocfZKbxRs9MzamY+/Hvs2Uz0Yth5pzj7QDDaPwX/O+3mf6b//////9P/////3T+tKebzlRVQ2seRloePmMatFY5fY45ne5i+YbLqRREJHDoci1wYCk0sVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAASohDeB+Ttyky/G8D8NblLeMN4MZa3KYUObwYy1uQ+pgrwmAtAoD5bj3bImFhqYPqQ4QkqMQWpkzAzM7lPTLV5mmdH3+exgatz6DhYiClRM9SUGG7QhMDhIVSp2Fj2oPVwHZg/d6a1SKLlr5mri0qaiEQ3o+Cz4/XK9/t//+3//t/////9f/bX59pz6mVZnnspiO6Ozq57IzOhrk0O6szTVexzTZ05EY6Y5C5+9zURfReFaykQNw7AHydjOW1+oYTWxWg26s+vIHYWUFBxkIfO8tl87magc+zGNg4BKl7ltBt4sPAxl9TVKSZdqL1kXRnyZRXl8bcghi1G8KVVQ00nr9us4ghFJHvWSh///v/////////////q///qRa7VpXW6KKq01rUpNaaDJILdrJXTqRRpukrSPqWNWC3D0wrTL4E6kZQMhOlKjIUVYMiZMyhuMtqXsauXeXqQkHV5KRo1op5uT+EFixcijJEBPLBy1NxrbqNdH7IdDAZDQWsKFU5WdQUq+zzodIamjtPZgPklwuO6Khdv47JKOBMFanZxxt6Hq7W//1f2/+////////+r3/6u+k1CgyrJ6Fd1oIMpLodO9BS9aDM7V61miSDMpR1bqupIyWhTSOSFcq9u28plWKJVHEI0/b12e1c7tWYylaGsDD1cTBSFmJyRDtaoXSzapWTDZzAiq4KmlYcHnK5TdwGE0I36h9lB7BhZQo3eufvxaUSivMOEbgMtpvU27B5N33ZZO/9P6P///////7f/////6rV1d+ym6mZTWSdJaS2Ss5km7KcwRVZFk03ugyFM/UtnUnQug6VBSS7GxanfWtrpmgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEzYg3gxprcoyOhvBjLW5SohTeB+mtykxEG8Gcqblfc6DQgi60kjW/d2Zlli/ELeeGsUC3BghicCA8i9knjie2F5a8jWi2wqBQ7kwAsCDEAZSNBu5aswyFV7uwTI3RN0BChYoLyu/bnOyrOXQGJHYprddKiFmaupKudfQWmvr71d/+3////X////v/9r//37eu1SlupOpmQqqo2ZqkVVLa2knqZk61opup2RRXRTppMqaLBNVv4/Us2/gjSxFEAPFLXlgjDKK0eVLzPBqo8Yz8KASYCj27OYZbZtKRpH+hCoBwCKoeiyEyPKxerboZUiYrVJNMqBc5JkNDZxunarjN/7xiTbrXvdB2ZYR3v1Dj//9B//X/////////////7ev33dqqmdFFJNevd1qU5+tf48VlVPcimhkNlS5hd4URl1HUkb0ZMEEyAKA5j4Q5cqyDXbRNEtZ2VZXwlahUiOKFebbPwUBppS1jBDhKkXEXyZKk8HU36CDtHTzmEfABle1X44TSxUs1KxR1s7EM4XWwpj28b7oJp3BOSna1Q+P5o/S+vt////////////9Xq/30Oy+pezTCzpr6FlzSilTTXTRUq04u6nsbKZ01U7IosedpyWLmj8zDtd50WQiBIExJmdhikltJ3c9nL6mm71G4GYG7owJWmmqoA5diu+fUbtrfKiX1AwmWFppBN50ckEYC/3tmlHzGaFaGCSyLTkOT9JlSL4CBrPcerHgkf+Ih/+v3/+n/////////9//6/7dUVFz0SzqxphrozvPQy6MQnIeah7MhlWd1c2zHuahZWo1FMOfJpJUmBygK9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABHiQN4H5a3CS8ebwYwduUcHy3gxlrcpCR9vBjKm4TygA3FyAUh/KxjfPY7g3x9b78AvjdLoOid0jNcm6i1U9NL9pFTNoQA0hFog2GfRo0RHymaOmngYARNzl+AQNArdZq2qv/D32mkKUUeXamUqBKrqtWTfv7fR///////////////Vtf2+yV6ql6nUp5m9SfpLr0kK3W6DIszu9F3oJILQRUy7al1KsdvrstzGNyJhJaBKMrQymAqetjYqZ3pVX5H1YXaE31xQ8Jrv4nNVjrXsGcQOgMKsIHbtO9FEzndWKiqEYezNhByqQwJgSiT0bpcj9/JRpXlFW7aYo1AON342b/ndqt//X//////2/+////6W99PR0NY9HHpzoetlns5zMrPNZlPNJucfVFU91d3RXRlNadQ3zjmdDjMxHLA8B1FuiWrrvuxBVduV7V+3zLfW6RB4ltraAOc11RRBzcqaHKx0eSpjDghRoSBg5h9TCHq25+eiQi4bbcij5mijAVTVPlX2/O6z7AoXDm+nTApWS9iWf29/q//////X/////////VvVfqT0lU9knQUyCDrTXQSempGy0LXUipdOclY80T1YjCUExUEZy8YW21jcgFWjPWUzEzXs8ls3v92KWqu5jKR0GiMD6k6JA5WEucmVcQrKqSEbYkz7RUGqUVqvfEAT+QLWf8H1FRYiYgCX4wXZmJmkdtR+jw9GPPngQG23QR/p7fT////////+//////1vX+p9rNq6GHFDzz6Mp9qLR6Gz9jc90PQxOYh5ZDLmEqZ9mNQhOR6GoYerSwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAARihreB+VNyiW8G8GMqblHaGN4H5a3KHj6bwPwpuYrMogHkOMbS4YLuLe2TO7YXLbGn5l5fp0zHujeDtI+1L8m6nQ5yEkcaJoYwLcxQKjXNzVrAw0CYyeuPGYRhAwmxKMrNbJ7sLTcEB1zHq0tAePe6tGnzvLdq/2/////r/////t/o/93N+vrtscipP9jmstEd2mmePfZmVUOPc006hidldGILbJolA263WZPs8wqpkqt0CufMyunq7t1e9q4PXODUM6XVvRJR9t5FSt/2Jxkv4MlEx0fZNbUPg6p3vSE5MyX00MnsEOpD2kGSqzO36GtqKl8ta9DJjOB9vsFB//7////////////+v//39tjW7opiqezO7GHuxzufMnTVZ8u4QBZA5Ht9WKfzjA7xT1nVsATaRRbEBYEPLYvuDG6o+V2vh+TZG8gGMNgOiGKZ2IKnuReOCokOI5Fh4eVSUYTWFBbP1PgEVfVzUq0AgJYMUCSTVurk9meDRG9ncuugkk7BWu+1bt6Pv9tX////////////9X/97160NFFPZzjLbZaCqnWhSZT2dnQZ2alqVTUtlTRVFN0kWWZJjrmU/NaOo0iyEjDCUkwO9zW9LMLF4kbOx1sj6NKLjv86VT5MNOwiNq9EYaR1aUVnguWUy6Kkx3LjRE2Ld1fR16u8py+GE9AXx7nJWVuiuWb1qaBCT/OC7b/t83////////9f//7f//dutrI/VOjaHqzTLurIfNPMTeqGGmKbNqTENInnMWQnJ6kJxLXS0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEWos3gflTcoHFJvAzGEwRTiLeB+mtygoU28D8ZTB4mRpA6gvUJYW1UtcRc31TfNUFDMJwSc+xoXQ31GMI/D1Uvu/LTSFxZr7FZ8uFRr3xHkyFi04qb5sDHFUFKGmv3qmEP57j1+dx9NWQMlv4t/RO337///////////////rX/V1Yw9zzT3Wqpd2dGVj1PVXue+5QjmsdzjaXNNn2V0axp1znNI0iOlSFhNDMgRBgJx6OL21blivhYuZrYljxhhoGZ7hmm0sJO3kmMG6Vy8Sj5WmcX5tf+FSphiMlXDL8GfgHArUjDEPnaexHd0qT5cue/v7z5+VNf5//v4y+rfs+70f////I/7HrJrj5U2OCEHjBsDrMOLiERgVDpYOQiSKjWHSwFIOQOBMAFhoNAkIDjBInUquu1SP8b7d7aSwoEK9D4CDsaXP6VqGaXrfvMVTE4xlJLpc2Dsbtq2IgStcXsSkSGrsY5lr+7kHxh0ninc8HVpKCtNn2yx/X/6P////////////b///+u7NdTq99FIyqSSsynagupnUtJGzsyC9nPum6NTIJ01rRMnTTMEArCtgsJ5EQ4oAh4O8WFTnkuGCal9m1T3amasiTMEjzJ5kU7UfoibjEnDuuHgX5KoSgUkeWfc3HV77pKfVgfGADmJEBarbVi3jalW7EMlqt44d1rf5RjD///96P27a////////60Fhwokig4LFKAypBQKBEuwgBCjRQhKtUdAQhHBljnnjg9ZIsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABEyEN4H5a3KF8cbwYyduUWoi3gfhrcoXx5vA/Km5UZCBIzwFOGI0PW5q76C5XyqZzbnR1fD7HeTIsYDYpS5UOBYAl9EOmN+z1JjFYaxUuazKiUktztxWtT63anO/8P58iTM8O+p1qcwBoPL+ff1f+r//////////////t6uvuzVPq1OjaiqxmnUkimmtnRS2ZS9d0GSSpMybqa73dRxoUiNGCF5wPvl841KiYiqcTq5cqW7N23d+5krMnBJIi8zMbnImivWrs6+AZhJohHUKlSLeS0rNfHviiKr8JTGiNMLmxXU72a5O496Xpvd50Q0AM38H7ej/9v///////////////rZ9zkfRbqpBTqNWYiz1np3THFeiNdVNU8xdzzEVGHXY449XU096G/ILTMRlQKIzA0hGXjk1P5Gx9f3vwbCzmqv14Tlql5p98Kr9Sx7oTPkoGPzCkdNZsVqSxSrDDwJfej9MmS5vf5vCkq4ytlF/XU1rdnAY61egk3p+/av////////////////r1rutBSkFvTZKgt1stnWki5z1JoIvdR9nPoLdB7OmrSWpE1pqdatja59faIi71wGgI4DoCfbGCeNamrw87lM0YaVp0mnPU2xryQt9lk2sggDJJkqDv83dh3Upe18bWUBlBUO8dEzhCpKq+7Ys53r+s5krDnv/qkFD/hcv//sd///7//////////+/9Nlm52fRT7aIrKcmUVzWoZcrZaTXVmWiaVc2rtk59jdVNeYizZs0rpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAQugTeDGGtyhPFm8GMKblDWLN4H4a3KEMfbwYwpuIxLxQqh8jazftdpc7sv53mGEAoVUl9uhY3MYSiU24guCqn7Nvv1vnwd/FTKczpb1KVFkwKbK8mosSEX8eZWpXWrytrs/j/W5wEIKXfMft/vR////////////9v///2fT1ak1Lo1KTZjBT10VrUktaC616qklutaNC6Jkn/Jj+aJmv0+PctyngNhC7BiUPQRTWZinz5n3kotR5dElUAgdOnVmChalLad/CetK1qKzlKoxUVQ5dr5bTkIhyDNugokLLJnxOQ35vO9YvvUwyxh6LdUAvp6gw/p/6///////////////+nuvN6JIVY1XZV2dqHqlqpaabRrKhjXZs5zlWiz32ZiBvQk5F+kQrjtIIEqAXjoTzk2uMZqvWPyV8up67lUNmuU/UjT536BX99xIUwxeMY4oXmkTnX1ZqlRMC/q4nOg0rRNZ39cuWrs2uKn39U46ALyH5x//6FX///////////6v9v/+tJd97NqdNbv7OpBrTZmQe606TUXWmrW9NBb2frrd6lIOmgjqNGRMF9kbEIeBBOFyJ04SarL6tfHD7estC0ajm0bTq+LC0/aaVu1dfXJNTG/TUOTM/t2u6JRKXRnCbBXm5lDqHHCk7v9PEsW9/0dUQNDvuINvX/0/+v//////////////rRGn1VnelzHqyHKzIproxJvLHspnW041dFZzKsczEmccciHMp851tYooAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAPugDeB+FNygPEG8GMKblBaON4H4a3KAcQbwPepuXUYwwTxyHQpJta3C3rfbF2AC225Rw7HpMHQZZnHXqplDtLrZioRE4hUSq/dnHFHVj9bCSoTlppYUFble9Vy/4Iq/7vPkYAE9fp8z/////////////////r+nOt0TNViIgVTFPeYa9mcxz5bRLnmpaqqxQ58+Gtv9NUp5v0vndtsMQfwZOxx+p25Zoc7e+fUuSuHJU90DymtXhA96fvNri+GSk4DlnW+9ulfK1lULBnyx+lHuPqVjm+fTYcx2+i9r+HX0oA0Z+Wf///////////////9v//zp+551DGpmpnHs685DX3jxb3o5zuqHsqH3mHHPIXbsc7k2KyYVDKW0ZzgD0DjN8GD5sb+X31jvbYEvcIcri+ovKI202teWbeaXIGWLwRY4njxN3PCrnfUwKBauxAIqh6uGpY7j362DxwDrnrdBCoHU6Nf/f/S////////////////73Xuh6Ght3UtB0J56n6mZPqqSdqR1BKgrd06TMtV2TVRegyNSJ9zB3YIacZzAdgRlRvoL+Td/nGrRCBhoxyZOzQzUQQAoerpB6T0QQisrgDQqVeoMeuyVFYtVO4CfUgJZv8dd6vnJ7GhW27pVgJWr4lf9m///////////////v/9voarWsp5/zjj1nOjo5prpocruRueqmIZZtnUxTs46uZYsyYAStovhlwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEBnk3gfhrcnRlJvA970wP4eTeB+FNyfjE28GMHbku8cyxZRYzChsru+39ouuVOvUmNWn5SGwpO6Ht0dxk+KyaNdY4ZKFu0Rrryn8qa1WKjnK3qVkc0O7mas6/dr6+bV8Ofu6J0Mf7q/9+3/////////////+r6uu317O1lsy3TazO9F7LdSSmvWtamM28wrRK1KwMnOrZ0VjUnRusBfEkti2nMPgRpORo8bc8tqTUmD7MyKfjOT+dsfgfcagRSjoN89kuYRPbkyltrUOIRLnIiwBECEFVBvqJb+AtikvLf/H3tPf//9fd7////////8nW85ABlJfAQiCTj9Lwu48ERi41Z4Mh5YWPHwmCixMhQWPESbpTDkXIR8h9ILybUOHNf+9rKA9lU0ay28WQFuJ34MvsgizgEDmKzyTcvYbR4XN1CFSQFPyUnYRYLIcrFnDV76urGPPSpuA5/X//f///////////////+/1N9TaHPSYqOyKRu5iHHnHuehs080xCEwfIdfgltF1D/y0tRDD+P5XBEDLXDxpSNy7Dlmaxxz5v/vJ+qA6hyVqNdyiLf1piS6is+o48TN65FefR1yxwx9Hdxb/bBSEkRA2OXbmW+dsqTtc/tPCH+Z9P/////////////////9NVSqu1FOU9FnHnu7zatmuZsivWzn2tMnnI7Oeh7Due9z88ghgeriKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA+FsN4GYU3J3rgbwPwduT/Ig3gfhTcnkRRvA/BW5IA/ktGHo5k46hgfpea4VMbij1WJQaKIl8w74KTeqO7caVFHpJJV27s6vt2v8qWZSgnU9frtiBMSFMXzvWu/Pdxjrq58/RMB/+n2/9P///////////////122PZu6H2YwgMnuqljLt9bBnwpPpHZivVekQb/pdGHSyXLwYa6OQYIXAZZ9ZrZziQby75esKJuFlGtKA6yzqZU1N2Gqi5W5reUfYRtF6i+xeulUr95beoHHR2kGHe6x7+8HStf+3EH8o3//////////////////1P/Msjz1RpzMbPlnF2Rl8ZbxOva5SPp1ug3MUnFYKg4o8WkZacmQ5AapWriz9S714l9byxrqU4N5MBQtJm3UW/Pe0PNfdmJENGh0o0SyxPPOzuZFBzt/Ju5lYVWrju3qK785/1Wr63/3AUf/9P//////////////9f+t//6Ipp7Z7szEBinTprnFzFsaiJ7zZ1J7GIYetGqp085DzmI0Gjqe94Nbl2rxYQ0mdr1SS8G9r81YYSz+nZ1cYdvV17bVuF3rvGdJO00hKIUSW8mzvbyXy69JUgsuc8UIuX703h3urb6///UJt+F//+n///////////////p7dkZ02WmdxdarsqI9qyKV1pZGmIyKk6nJZ7uak5ldVIJ+RydXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAP0kDeBmDtwda3W8D8Cbk/2QN4H4O3B4ULbwYwJuRpRAzACRxKD6nX++Ww5hE2FXGn1wE6nzlCPHzckruTI5wlYlm1RMG8vzLGv3JiDnTm4wD8oCSg83e7jft67WeT8v6YB/9f//b/////////////7f7/15xhjmV2S+ZeddLqj+aiOYzMxh61dHU8fNVnc+e81zJ6HRvoQMznXHXwsoYBmHSczM0WxXM+L75yCWRXXIwZza7DcI7XhzVS/DJUDFWjN1ycTK9zC/XX/exlAt1PRs2vysZf3Gbgbn/+Ab+R//+f//////////////0/3kVc09UfaSR1BpBDj42Zfc2cB5PcPBSQwnaWDuxhPgtPH0q22HWyH6GaLfm9b+afOfy5HWqylgVEGVsYUYcXm35tKNX3PHRJZvELXlzbZc73SL0hotyoPu/5WGh5lc5Ocz/eHP64Mf9P///////////////t///M1ve7yuymM7mKZzSjHocsxmRkRzN00NMu6s6K7z3mHmnIiTFcw9jj5joyoXj/s7Bx2aO9FausbtXmO/7zi09RjFd3fg1m/8u97g/RVC3kBFB7ULvY/jnMqM54yoNGw5WiY12PXt/lt8sO/+Kb8F//7f//////////////7229mZZ0Yj5SyujXVWVEWU53dYd1Oik3ZmoajEs1zo4SiikcLCpbKFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAD+4w3gfg7cnJlJvBh70wP4jjeB+Ctya8Um8D3xTBjlL6iEkRiPArDe1rX/j2YbBtmtIRPp/bC9+WdHbh+WK8TeRiUfLpV47uth/Hab3O42UCCU7Ky0PzuuS/Xak9e5zpQNf0/9/r///////////////718+2u9XehRTHIThxVPZplldTTZ5xhypnue72tQ1rIeZY1XYy7GrVB18jc8zGlkhxUEzNa89O2cQ42v9WgDKkboAsNIa6Fi3lXabavQloqDvFilRk0e+7nYFl6HuAeB3mLCtFb601ldoXj//7/rr//+X/f///////5zqQWMlkoAYs0KjgiOlnjgqIguTQtdJkEjITHFwQF3KMkBU2VoevU8OaVpVmXcLXhY13+vQ4dyVS0vR/c2L29xTF9adSbpEQm6iyJxlGVbWOKCOhpNwQCBvITTj+fa+qT+3IFx1+vAp/z//////////////////+9anRtVVzocqFKxmMcrpdVITKPFEOyoYhlpY4+eYvZVodFcx6Sn3diO6jzjm5FMRpKiZjFh2p9319WxuEMup/UFFvDEDUm6V0krPTlFYN0OYsR2iifU4JITJkxnAA6ISl9O5q76ZPK/zb+c+/b///////6Ft2Sw0WNgqAhimEi4DJC7TSACPIrFBRwcLHBRJRwqfiaUFh7wYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA6dwN4H4O3J0MZbwPmVuTt4I3gfgrcm0kpvA/EUoSFCjF8uC8/M96w9f951ozSM4XKEq/68D0Y3IfrQBPqWPGoW6Asmw2exvm66Hq95Dy2GWIEExqHP72q++5T+fP/CL+3//////////////////ov5nNvnOPJehaxdcSgErOSKpXt+E5adg7M/UtqtNy+AguwMmunZGDEBGV3e80SataW02FCMMwah9GULsRykkX3Js8XioHhIwOzEBD91qCExuasVge4n3VnFKXMCcZ/4Cv+f///////////////////zbqdDKpO6UIRKq5LKUt9mZqlUlt2Nqw8hzOrOV8yC5zoxj2iTBITpicR3CDnajo8HX+q5t9brVIJqu5SqrW7lMkDY+1fl2CY6jrQmNIV9d2/jv+u4nnzUyLMLDFxVbX1u1N/Winf/6hbfv/////////////////v//+ln3Qac6ItVdXEru13xR3Q4uUpkTozS6ocb9mTMpCaUfLA0Ui5hqMLsvBlNjnbGGeOPMMu4MjqT15t8s5STKv7plkNTJs+J9H0LLTEftSZQrYT4apDVAHAu3qZTLemSP/Ic7/7f///////9yWvAosJQAAHpFx4PrD4CDAJtIBVpl4uaBIjOAyUWfNHltUeDgLB4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAOfiTeB+BNydrDm8GHnbk6eFt4H4K3JyEgbwMkJuD5YhFC3DfQNXPc29Q6ff9bstTUtolNcM46xO/ewxj9lORjdqCxpV9n3d976HZ87PKxd8lRa+33fK//uzv//L/X//////////////////+nd6NI5iIh52tQMp0nKViVVEUvSuQhUS70Y6JJVdOYwcTQSw7LlKJ2BBqilk5dzqU+OeOPa13QnnYnqgzU/BNMx3HSk2im41JxRRhGI+NayVJq6uegDKYJ5y623+38sHf/1ELfnf//////////////////sjU+sxTjSE5VZLoelDrGI90o6GO502YZoY7LspsuzlmepHm0hASmPbpUimQ4sZCSulf6xu9N6/Xx6K6i2DFtbsM6y5X+Z0sG0Wo0diGL148v92SAhFnCSovEinkwv8u7y/+z+uf+EG/J///////////////////3VFvuWzupnZhB1cqI97Rizo5lddSurKpWlytZ0VXi/5yyBY2DKP4rLK4bBoiid6/V2vM7nBn2JQ1K+TYXMtL7EWNBjRnhsjPkCUHiezoho48H2KYDJLG062POyClDnfrgH8v//////////////////7a7XJRmUzMDc9MirSp1PzGI9y3OpUYzu6TpIrzMyTGY06HcrVJ7GcWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADiI03gZgrcmoOBvA+Im5NRcTeBDytyac4G8D3ibldyGDxUEn33L5O7n6ytLc3fxbzvzTQbHaT5RbYxEaKcJi2HQwwrbxVSey19RACQkTwqWu4dz3y5Gv//qA/9/////////////////+///V2K1syM6uMXolklWqVat557IpuVEZHPo5y5mEnW6oVLC7m8mHXBjJZKQnPdrXpW62oDMHC0iRF46Q7aR0sR/REJjY8TIhiIjV02rC8SLpSZBHBnB6TylfMhgt/gf/////////////////////9vdUZgZXmCNmhkEew3NHFko3zmFGMc8XnCxrhY+7RiZhBdgoDgKhTVtfX4xDVN4Eh1465NXXi9TYHKrGUwj1wXea0makrNr62BSOoHg2W9vj6vB1/+GP////////////////////qtzeyC893zKVGO5BVd8WT9FRnn5vi8DhRsxOwoDYkNV1SQYkJwrK43B7vYETeLbp86x4bb03VCt5bDCh6WOyxiErtwXiaxCDa+fxZRt4yugh6mW873fP9JX+//wD////////////////////f/PodzKaxGQtBgdpzUhTcXa3vQWtFXm9oCatanLQGcBLZTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAA0wlN4GPalBsb5bwPeJuTYXY3gY87cmpxRvA14m5T2EBkKSCop//da63jrtAWgypjXbRS7WW3L54EmEMPMfgLZuTHaywH0xUyICcFiAulSFbL2L7/Vjidr/////////XLbGnB55LiICMHCL0AMQvGuAwMlygZAosNCo0cHVAW4BqEAGPuFHh3xVkOkSVqxu9Pn6vnGmtCIKmqfWaRhmxIEPtWRjItZTBe7i67rX2mG3jDeEePSfV9Rc7+6oK//4v+3/////////////////+mu32tXZzqdqO5q0M53UpzGKaRzTiiNBsz79hXBWcvm3u8v+8ObQKy6rSNRX6t57cftcHG9nL7qQ/q3YOudiYnsWqLQ7qzXz7KBLYzIJuLuHZJrcvxj7Ytf/gb/T////////////////7/7a1pOZUer0U5lH0ZV0Pc6jsrHGuXkVdDGWQkLJj8LZ7802a7/tzejpUsJ2CfJGiq2Wv3ujW26QNEvuinXP7730RDelG8Z1iot7+xgEVf6A4jIif7k+fjDR//xH//////////////////7f/VVq7bJOWsrESdzaxOcosl0S5EdUV1BERDXMhSsQzU8tDA3M57sHgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA15xt4HvO3JixLbwMa1KDZ4w3gfArcmtQhvA9pW5y8N0jDc4PrQcW3in/8rq61HKbeowdlcPcMEYl1hrwRqaUet2vsaT628kwB3kTJrUDefu6h//4GP////////////////////1aljlo6TXmHqxs9+cU2Eyz1E6fPc30ehoZIEBFBhFcd/BCmSBD9WJgHiGweXq7rZa7FZKHDNQnCnMQa3Y9QUEuMcXhnHAiJnp4fBuMqQDLECF5T13qWOd/83//////////j62ucJhYsXQw88TQIGyC4fQcDahGTA5pAhQgNFxQXKNOJBIXSFNPDjZSyj0h7za8TPR0EjpIHRPiKx/FBqRHqQ5hokeIGLBFWJZSnxTiRfFdCOVZ6pqUxKyX+A///////////////////r/vomujCvkKjlIpCKf1dljkIMqTKImZ3szVLHWZZStczMiG8jxeN+DTat3GOK+o3zbS/x9UaxWWrE6WMHWPgxqR+kahzCaLVEMrDIfwNh88orCKLFog7bVnBgv+Cf2///////////////////6Oap3ndrMyshUMcrux3ajo6MbUxHYqvV3KlZ7OVnGdiqQ7anwP/cwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAANTgTeBbxNyaHFG8C3ibk1GPt4GNE3BrUcbwPaJuSs8BkNVw8rzu6qp/u2TYYZDvpmIS7fSm0npBlWV8ibsdX+M6T7hb80gSK3mbV//6smv/wD+////////////////////fKbUrK1Lo7FDFZKs8jpop3OVFptdmQ7A3OQGeYbsJE4K+QfT1ADoNHYJCaiX3/137/MWChFTo+Hw8dZk8uEWpDVXTbh//b8XZkr5B6WxAY+/9/Fisr/+K/p///////////////////+uejKnjLUtJimldCGWU6KwTKtEV1QhEdGNIro52iWadDhoMlKQrFHT4CQVm4gO2m/WraanGhNxuMwvScqFoiozlFxkBEiKWUnC6n71h9N9hKQSoezrUXVnSb/xf9v//////////////////v9FrU8rGV3tRzOY5ehLqtLM9Fc3jsyOzjR3JMyxDFRiOt2l8rjNC0iiLTnvNmnvv6bYpGA9WGHeVhZvPUExJhDEFQruhU64/CIdnB+HuIlDVbMxh3/xP////////////////////oj2RGajEUgNkKVXPVGQrOYh8shlfWzMqnMiEqhDodTuhGZFnnuZQjmsPQqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADOoA3gW0rcmLxZvAtom5MaireBjRNyZJEm8CWibkPjRiBYEEkpV9MZ1U5EHgdMERWQUZjtz6A1IDBhBlJN1BXK7kqOuodRpCOdRnPRHt/wz///////////////////+3l85tjMjIyJqq2kszPShRysj3dTtK6qyiSXEkxWhooAKD9zTEmjEkEtwKPTfVOj9nrWkN0dlZIBzk1G84gIyJs5PJ1e9RMDgzobgfyCqy6ew7m/xX///////////////////1p9vZZXVk2Rc10Yp7Edqk1apGYzFN7o7Ncqq8znBylsmOuVvEjlZgah5bNPc3O9idqmRKqKJwOe6LkJ0TRZJmo9BVNkWiFr40DdokowRzv11F3/gX9//////////////////t/p+zofQxkmo7mZ1YOx7sttlsVWzm2Zqq1FdZHRh6ncuwlDN+FYfggAQ4U8ow+Vn1IHFlyT2k4RDJHKaIc4ai1EbFl5lce4iUlnBih9Rs+24wLf4n+////////////////////2RHXMRHQ6FVGV0mi1Uig02VzWTUltGdFO6OZZLMfkkQGmf16iuIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAv2Ct4DNK3JicQbwMaJuSz3Y3gO0TclrNlvA1om5FkSY4ytzz/LeqdLEi/GI9TdMdrjjGnRi496hBD+o1EkDWdTr65Cf/CP////////////////////fRKI5UeY11UciqcVoUr065jlWjO5kHo7Oh2ZLGYdVDq+0+tOwpBY6HdMAkKzS9u/t/Z5woqJWTkaZd0Zi4lJUWnCVkjU1YuljM4ehnTWjVT1jq/+K///////////////////32+/RHtzmVEQGTKxKKlEnRXV6lXosjs1anvrORZ1dRBfISFRi9gAdUH4ExJMd5n+Vsse0fc71qJjjELq6cZ6uOYgJNI4HwWy3o+gaf8F////////////////////b69tVU8jshVaQxEJq9LoCX3zjULY10SwCqTHYJT6chWBDa+RIJFELIMZotO3+5Y480y7om+fmDiKTPnBvcfvWKq2ohfBnLV+rUXP+X////////////////////VLM+9K0VkZwar+/prL213j22IyYLGyohif+RnB8u6APifDoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAALzejeBbRNyX3A28CFCbktiHN4ENE3Ja0YbwLUJuXwKyaO8nxPO+v5FPMQGH7WW1ZOYfyYfTSkg/WIcgsyx6Aoja9XuY/8H///////////////////+n2592oWVCuRUNezqVjFY4t0cTSQdS3k84j87Lw25hs4PNmsLHGzBgoAc0IQJVcP1f7DMTFIJbQbOrSZgODGVFqL16iBHTJQJYeilda549/5v///////////////////9a+W89USdnMkHJoymIrslCujEkqjHY2eroKEG5mfFpmTwq2Wz3IFOFQo9w8d//Iqai+kOFq0N5PRIhUWsRp/4xX1D1FQoKfvzb/hP/////////////////3//1avdstSUajqG1RluhznaiIdOjWoyIpFYpSEIdqlQso5FuoHVlu122jyHkMDarq/+NhHHIiVHWoLHkKAX2UaW1xUHdQKTClbJTk3/X///////////////////7aaFeRkUz70ey2rWrGIIOmwgm5ryGSqVY+5XuspHc6LRc6scF07YgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAC54S3gK0TclqxxvAtQm5K8freA7RNyVq9m8B1CbkKDg8wQAIbdv8rNpeTEqTuatZzFx9UUzhiyOvY3asToVBsU9dua/9////////////////////+yXVFRWeslWfiGUjMZ36a1Jsp0KjzHImR1ZjkKkGJ+MGvTrhDsSSrDUaROtNbv/2EcljdwpGnizvRQbChKYSyL0EobXQDowFK6V53/T////////////////////X18mptmKXdWTZkra2jo7Nd3a3JMdyMjsU2UzMVkIJB3OyvHZCB9QvEcRezW65i7HorM83euTHJIzLVEO3qGZBeJwLIWin/W//L///////////////////39198lZHRXoZWRDWdlsiuSybq+pH0OWJ2YiB76eX20Xbt4eVyFakQJBCRTv7WEd1IINdTQ/e2gVxcac8X/DAvnAfGQ71py3/X/////////////////6+//8i6NfV23dUPIiqZbU0PqpDOdIsglPwGXVajmP/LUMsp5X0QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAsSON4CqE3BSLZbwFOJuSdBs3gMJZwFgvRvAc4m5KoFAADiBUb/xShpwEb0HmdOYRIzHSotKNvlxx6BdlwSTT5n/T////////////////////5XZ7I6PrtjnmWYylqZX9tSFUxbKtUpkr52KcKRXaadkKV454XKLAMgJmVm/YQk4tUIMoKN3VQiE2Xjm+BxDKgIFBft6n/8n///////////////////12693VXS0qDO55yDXyofy5qry24ceW2jsTQvRGPXj1wvQhzQMT47dPpjvBAbvJv1KuTiKeaQknf/ENt8j0RQ4zmvL/////////+iilRAmEJQmwqRQfFBWE1wGJo1oSD4JiRJg0kqiWJhQ6Gh49wYMlDkCoPD0Nv+sTk5OEO4FW7QciBzzJ/x4YagDQMfp6D3/f///////////////////6Vt0qyI1yZVdjwjHIdjswliHaemzIHfhx0gGuoAHGfQHq4RaA5Nx8MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAKfgzeA5xNyT6128B1CbktCPN4DnE3JJBBbwHKdKB5gsLx9dr/5dRogG6i7WY4kiFkDKD3xSS0ANEIcn+//b///////////////////brXoj1brYiIexnS6z3WlOiLKt1bfTOzTlFEsIAkyGal4+SANQUCwSkTHf/yo2UpEVqTv0cQxEXtNf2LcFQyb/iz/2/r/////////////////1/5OtOftcMkfgvFOkwQjw+aAqyUSJdbDlLISOuYQfeLGD+pFNUJhYx9P/MQ1QHaJnSkXCEsUG8T/YvwaB4wn+Q/6f////////////////+///9czzI7Vd1MCNUGzoU7nBKQKyy3sRmazlSzGSqZWmOxB5yEVDO6ERVMhAilkkAHDIZTX/UHisO7B71i1C96fOM1CQcLf6l///////////r1tQFQuoQh8LVmhGVDZAyQWDDrBEsOg2pIiHAAToDcWBEbMBYAhIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAACaRs3gMJRwEutxvAUom5KZireApxNyTzHW8BTibn2IRgxrv/zxUKVtdp7EovHDxOlPi4m1FgMW8T+v/////////9dTyCFh86OPCwkARdZoCjRUMioNODpxR0FiYTY4JwyLBYBiADj0l3CBDwGBAHdG/+LXh7gu1YPDb2+w5qBYwd0+T/r////////////////////1/2ox2Os6WBGYfV8qW8EYsOc8rLSQBeMFQmmuCgkwtCJEsZoCuN3/9JkG8z1l1GCplfiAzQTil/+d/0///////////////////9f60z1RCnO52Kcqhzmay3ZEYqKS1SlB3KcykCsVYNHblIVCkJcOqgyxLRO5kjAiNHk/+gvpN1F+fSQl1Mv9W4THlv+v/T////////////////////7vR79SzpV9GBFmPtmhDK5rMzpGMlFS0rRJWI1hDUQ8p5TnK57AqYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAAl6Nt4BHE3JOcJbwHOJuSFhs3gEIpwEHDVvAkQjgWZor/9XsoSc/SkshZQ63x4txsVL/8t/////////////////////6f+1dUmPqZ2NZfKXoUjmZp1dYt1UyLg2YqSsEIrq8XZXzrBGgdRHE4WJW/8odadoPfnqXtM/8OKt/zv/////////////////////98mzFSU5VPlseVirYFBFKxnV02d0UkGcp2JGmGHK7sOuDLXkWomx+TaHEhgg///HQP6G1pcYyFv8THcFUf6f//////////2c4BGIBkg+LAiBFpBGLhgQPcwNvDQDAayYkHGmGhM4iB4bDyhnxUiGo/P/BC7y6CduRX7/XoBg/u///////////W8dNICTgWoigbesyMGBwAicwHyVodas8HT5c4DBEBgRpgLg8HlgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAlWPt4ClE3BGkAbwBEJuSPYQ3gCITckXP1vAEQm5lQLI//8ypEuO36IyD5fhHx8f/yf///////////////////9f/r3l1IqVQxlSR0o6KjmKw5iWSnMzWTdTOyHKxiT7qyKpKqtKURwdjQV/+CNS+p/1V7y/XqGX///////////////////////+pXenRVeQxy7Kh0kRqoUk5kn3GdCuZ6XsDmP7bBGRIRM63hlhteNib//2gOp/1TN/V+RH///////////////////////6v2K9ty0Z2RMhylUh2ZmUYqFJU2VNJ3RS5FuYgORQ90a2Y94W87oElKEQf/6Lb6fmvzf+J/+///////////////////////WfpdDloVJjMpXSiHRyhTrVlY07Ozq7EQzCwIkqkZkaTANuJ2PxozAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAIPeTeAIhNyQLAG8Agibke6FN4AhE3JAcTbwBCJuchf//eK5v01/09U////////////////////////1zqxpKHnZDJ2SikVSh5BquRGuEKTo1mSU6bkXWtQpfA4H8ooj1QPN/+W/rXD8P/j////////////////////////612sx5TMum8hJJWMg7HPP3YrJWdn0YK4Wuy32bE/WTgh7pFfv//4ev/X8vF///////////////////////+j+TrJVz2JW6Zn2V6NtL2JM5UWs1zrGIzocdH6dADhJMr+gPuv////F//5f//////////////////////f+2p97uSVlYjkg4o5fd2NbI6KzOp1grIERGlZTGXrKejuU4J/XkoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAB3Wy3gAETcj2RhvAAIm5Gtf7eAABNyM8+G8AACbn/f////////////////////////////RPRGvo5sEwIE0HANzWfDSavEKIYYs9ZEKzrZtQkk6lAgJEcnLf/////r//////////////////////X/7021cjdlZzormVJSVNea633QqLVns7lYjtMYhDMy5LlY+UGu8HE/////////////////////66W053sY7lO6kdkMza3YGRjzlM9zVLzs0gT4EPLe5i05qRY6Tgn/////////////////////6dbVkI7PZZSNnI1JbIUphistTFVoybG2/Yc9H38VN97sYCfwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAd6PN4AAE3I2kKbwAAJuRzIU3gAATcjcw9vAAAm5/////////////////////9X0QzKjGZrmdSTuQ4m50VWV6y9JSOiGZHKx2drKS7EUsyGKhXsY7sdyMOfH////////////////////fTsronRs8zWKqs6nOqHKzpKmhAWw65SWQ9FeVLu+seNyip0+8WMlv///////////////////+v7fO7zum5jo7kKRUDFQxgc6X0RCmyOV8GjlQG5TDsVzkUPqtNv4uO8nc////////////////////+/pfLRmSU5TSvYW5lW7Plw50WetZzFQx6nRHZjBpJ5MpXGmdR8G+4YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAHHhzeAABNyN/CG8AACbkbCJN4AAE3I9sgbwAAJuP///////////////////9/2d9179zlzozMZ3IykhS2NdrGkUpVSV1UxDuzVY4XdyghYPzrISPunQf////////////////////r/1vagXQtmI5VqMV3Oo5ihjSuarFVlE1betlRmMYdrALJ4U6KCQMyX////////////////////+vlSltnYiOrOviTGIpWY5l5SJqd0HOWedBtNzGdmqqJqgmW+HjgL/////////////////////zJtRyM5KMjGMhDTGJZyM5VIyoRGnWdaM7XVnIpXdyKpnRTkgiorIjKrGO6mBoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABIgA3gAAAACfgFvAAAAAAAADeAAAAAAAAG8AAAAD////////////////51UiWgqeunqF1PJZKgivhtYSRcdJao8V////////////////5HPUSqj0sPCsyGpUilZUVcRO+qWAqzodO6wVIgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAAAAN4AAAAAAAAbwAAAAAAAA3gAAAAAAABvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==";

var ExerciseFinished3 = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwM0IxIDAwMDAwNDY4IDAwMDA0ODJFIDAwMDAyMkEzIDAwMDAwMDRFIDAwMDAwMDRFIDAwMDA2QUMxIDAwMDA3NEEwIDAwMDAwMDM0IDAwMDAwMDM0AENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDA3RUMgMDAwMDAwMDAwMDAyRDM4NCAwMDAwMDAwMCAwMDAyNzhBOCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAADrA7eAIhAAG8B28ATCABI2NN4NPE3KSjrbwZeJuRBFgAkXDBz/+oa/////////////+3BA5///+J3dLOgADF0U//1//////////////9CnX/lHS///yiAhXKMxnoxyCyh7SgIQMoAbacZmzfOu/j948ltS8eBqmdvMMETByIWzwwCcUvcYWxGXh2ze9P6U98Uzf09KNX90Y7q/ISh33qnyKc7vo1CMRj/R9T6MRslG302R1dFO7PISfv/0++xGkqjEr9b3IbUtnarFIQ76zsdiHOY7opVRqvRnmSikOV2d0DPO9sGGXCeQtwxUYEMRA4gkh4VBCpGhwwttX+eb+P6QIMf0zvVImZKJxkwciFq/Ik443KQgigc2NXx7w90eR4Gr//fzbXPOZm+pzseosjHc+c+p/Izk9XI2fzv990YhCKlkI/fkRT9TnaQjK6M3T9tCIxJO59yNor1PnHJIRD5LnqxpFHJ4AzJECgPOoeWCzsCTUcu04aTlYpnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHdoG6g1hjcvtRF4BrD25cKSE5tYwAA6EkZraxgAB/mEigQONHuCCEOYcSbl+IGB8Z5FDLKQxMz65JyX24bfiej9PMfe2/kosXcoQ0iAUUJwQhYEwhrYhOGfhyBJ6KW605cllernX+nzobX7w5/Xya9mvsLOcmnT5hU7J7wJgbLikzLY8AcRBIBxDBuI5wTGRLdEMd0wSD4VxLsS4yQYMmZnZYT3/pOMHmlQKItueTii9OnqMVyyw4q/d7cWRe2JauA8pTtlhZU7X9eb3lte+dmb5weVf/ac2vynS/t7zd+AwcODBQdn8c3gMz9IJCI7J77F/1f7B5VtZFt/zfo/6xZza8IXn3QQsyf4+37bo7q7DMxSJ4mmWXMyjApQ4q8aRvJGqWNvpu3nG5ZUuy+kqYdlEs5Nz8sdiOssxZHL3oiZfcaPSTlqHMqlLlh39/un7N1pZnn+6X9q/FKU+d0fwnlKQ2N/hD0LbJn6vbjkUDUcigbUPftisqnGSU/zrcjkOiCdEVPqNsOQuEyfIQyVV79+/Z7tZpqOROIY4UgxIESA4dvUcerHePv5u/bS3jjSROCEMqjV720RWRW850LjHOdbtORX86cVEY5FBEhx7/NIlbw70iemvqVPs7UaCFtRoLEr+97qyaG/fv8MDJu99pxDJk+r5ob+//+N//0p9/3veRkmu8iZH9F////////7H/ybZY/kOKqLUNzAcBTSBImztd6w6Y5bRMCDmBlwyyZbdMOB4mw9QMv+WXLJlx2TwAXDLNlly05acvGruBkvDCMyjAQy26RbL7TSEhCyZZtAGuujfRrj+P5Ik0DAQyAU4BpzfEDbQ4Hv5/ycUgo6u5+INYXYmOmOoOsdr8P5Qw5Cp1jsTct/5f2Yfxd7E2du/D9vVJGHbcty3ff+X9qRh/3/f+H43G7eUof9y3/f+Nxu3qMP+77/xunt9wpAfB8Hz5cHwfB/E4Pn//8EDlYOAg4Hw/g+f///+Hw3tttttttsh//H6SkhxNBahuYDgKaQJE2trvWHTHLaI+QcwMuGWTLbphwPE2HqBl/yy5ZMuOyd4C4ZZstOWnLTl41N4GS8MIzKMBDLbpFsvtNISELJlm0Aa66N9GuP4/kiTQMBDIBTgGnN8QNtDge/n/JxSCjq7o4g1hdiY6Y6g672vw/lDDWFTrHYm5b/y/sw/i72Js7d+H7eVJGH/cty3fh+X9qRh/3/f+H43G6fUodty3/f+Ny+3qUO2/8PxuX2+4UmYPg+D8HwfB8/gcH//ZwcBA5B8EAQLg+ficH34nf//+CYfyAfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAADBeQSoZWoABhcgigxpwAJPpBWbiqAAKfSCnTBNAAE5gABoaIJhYToBgsTgY8BAGDgeBmUOgNAADQo0ACBgGAASKAGGOQRUioGAhuCwkAkLQ+IEACFvAoJgHAsAYQgGiIS0Mug0CgaYFzIGIQ4AQAw3QGCxEGMSYE5BdUIsQw8QosIGBQgA0Jh1AYZDAs4nUy8M2Q8uokCHeDUCgY1KAGI3OBjJiAYdEgGGQAF+whAQBBfA5IMAMOgMFgIHwEoEJUA14aQ28OnAkBh3AhAgWtCCwm4MTDDJokCk5bKJiVi655i8M0HpCNgsbDAQnIrHw1cXzx0CgDC9qZkZE6fMTAho8l10ismOUIWGZC54LIAAggKHEdG4+yKnjhbFwgRCAOChE2cuqc6wfkGdB5h3GrlgZYfJoRxFTEmCiQE8URyRwph6qaKKkESwTq87RH4+tNXqQ0VD6EARyAMEBMLPBsooonoY0gIrxfKhEjqiHFAgxuZDLE8NQQSJcjD8bZOC8D1j5qfWx5BkEWMlrWmeSPk8XFvK5sOUs6o+m37rtWtZ6+O4QUnAr4g4GIWDjAoQ9gKGTM/N/1++6MKFhQSDolGht37vdXUxU/T6HJon87//5nuk895tqxwbPtU+6pPdD3MKNHFOdxohI05kR///12Q9vo5zdzDH//////r////3///8AACAUAAQCgADAYBgcCa4wNC6CkUKVQIzGn3ORYuCMzMG6KmhjMAoWQYDHOACTAbFVYiBfOGhOsOUJG7szkADGggwDEABBgm4iQBK8DOoQbY5YImqZhlgSgUhzBcgXAk0LSF0RCw5V92THYJ3JocAWjiCZsN0WgGzwsSAWCAFBOyaR5+BgwIWnkwAoDIsRAcZQKgZFASaAOjgY8AFzQzYs4WIV3128oC5CoLIIgxoZuQcnxPQrcMinRmSIkyaDLMQJ//9y+QMiY55Fzdk0yKGkcw0HUPgMuhcEkxDi6RVi6Q0ZkokF////+RQihoTiLkXIufFzi5yJht5XkXIObl8vm7JpsnICZHRwmA2CacjBCyBAQFBQN3DSHUQ0igzR0nSHFEnT5Klw3AIAAAAAAA+X4vz9MmJhEceAXAxAhQCqLHzfjyXQ/M0yXce54ag3gJp/TTpuFwREEDmD3J3+gyZcNJKAnYjZKAnYBLjB/8uGk02wMsAaYXgACsOMeCQwgwH/6bpv6E3LhgJeJmUxGxMzceh7//2Uzf7zMLwJYNgK4F4IAyyo0Dnkubhzx7//////6CDGn/+PNBB3QTJQ6ZnRhyTIpfNy4ZpoILNFIKMDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgQjFQnP2ACvW8q9ODMAGCuQUgMby3DPD0p0F1JuSQAAAB7Ziu9BwHk5uL29M21n5YR2Ky1sSwyHIaFzugkvTLbGp2fv47r1srdJqX0dNWlXLlV9UUVogBUMVBF1OfSSzO5KJyZvzU/Vf2rIJmpn9W5hlL5TLrlRca+FBI7AbT78w+8ZlVPL6rqSqG35i6mqx3Fdhsae0BXoFsxqWU3MZddiMZmq2dfH96137OGOvptVatarU1+FbXcPq/q1TZU1qtaVDS0tmXRnC5vl7Om3exu18bP7v81zLdil5WtSnLDmWrWN67VpcNd5Xs1Kul9vLQc/C/jj+su/rv6tZ3JS+rXXFlVruePPta1l+8csvx/LWesM697m93v7repIFE1pkmI6gBTGGTic0IT6qlJEXAgMB8SuXqKlPrZbJG1FaLJGxsmdIcDbAOOWdW6bHS8XkUTheU5iXj6ki8XnWpFEulgvH00TIul1FRkpIyMiInkx8kFIEHxC3DGjLFExOEWLyaKK0TIvF5FFHUXkq+ujUkkkkiijMnspFddFFaNHmSyCopoqSdZiyqSReSTa6KkkukZIpJLRZJJJJVFGkkmklWi36KLKSSXRRMTUmiSjiv//BXQn0ivxfNk828Jsl+ut0geYGbLoIIOde1rLHD+b5TboZJIkjTDWM+t3IiZ2XKhynjsU7lVsZZ8mKaZp6STxR478XZ8pePRxQYMimJFy4+tiUWu1rU9r5m3LJbhnnRTvZFatM8SzeAxVIeaS/UVvROo8T1wdm+9LCWgJGsmSwmYKZmBzWmR+Py6bn52xHLmFLqiylPd6zz7c1W72vKa1N23Vrym1Z1nljlhnzu9ZX6CpLSYHfJmkgbOlv2aeVb7ewrzuPLeGWVvvccbVn7Fef5a33veawuzGF+t9ypcyTlheGdzd/WNi5/ea5v8s605ap+3uYc5q/j3f5ZY7w5l+8u4Zd3lhbxtd3rPGI4Ve7oc92CEBUwBeFi6bRB2pv+/3dWVVJA8KoD5rBoE3sznlvvf/fN3N2fq41LEs+s6D/mRPSNTeHstYW93936VE1UWzFAyQTU5SPmrFFMjDM6kZl0pGpLEXNS6XSMKw6iOMxzxQguIOcVRkiZBGRBjQ4mVjA+XjU0QTWgmpjVJdFdbM5kikiko0UfNmQTSWtS0rrRdzrqWovE8lTRUpajFVdbs00RdSaklo0UkWn0U+ibUUlWUXkE0HTRZB7tVUykUTFjxqki2+1GVW/+H27HuWQ9jipQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIIJBRgzvDcNNyCmQjT24hfjFEDXMNyr+8qdCMrbj+Vk/LVRYxQaM6tRoMMu6/WH3rluISFrCIZkR8cXOOyr6boYxuE83WllT8a87ycpZnN+IYb5D9swgiSILeds0h/VPTajEAyS7Q42KOayxrardsd5SPw1tFvYoFvIdo45XkNJHrbS4vDUWplNW4PQ0tKOAkqDyH4rjCKXs7Gp2JSuZ3SztJq9Z7lX+1r9xiVU16vet4WLdSkp8t5b3vnbfzGU09C3dbj0PV5JK5LR01mmu08r1nYtVOVL/auN/PKx+OGOPOX6PL6vOX8PnalfLcqR0h65l3nM8Mctb7r7OG8cblSrnj3DPX57w3vDDHe97/LeO9dzyz3yxzHHd6DOY2sNbqVSABYQB0oZE98V8Os6/u+1b230nJOSDD0JF83opKL/e//97utnrkvmsrMzf+Ms6ArtAfDUrlNNLr+VWnzvRKsN4MJ9uHSFCvSJFUSIR7ZPaNHn3GXovTWIafP9XoVIfRHMZGQLD9nbHNsxBiO3kC0H/MH3prWN5tvMWnta2fmbMCt9Y9PvVb+Zmi6zdzixmHESm9UvNm99fGZr2jarq1s6jwt/OK537xN11XHky/iXzrG6e2s2//+LQaw4WqY/+//80/x8Y+f8Z9K5/xre/WP6b38bjfn7Pkw7oqZEgBgpz7013C9nlhuxhTyzJrEMJWGIxcdSDpENWrvbGKsin8amEWq417chkc1IZa+chuygcAKIJjBBBg+dmrO8ictgSVZRCjq24tSWOUUt7V3F61SMUtO/DzT+cfncX0lDY3alD3RyPswj0ivtZTHXOqm05kYyJsU46/H0l+8ZFfjs1P2cfrU9FYosdVa2VPT51Lvab7tqv8moLVTmfKfuN3PGdsvQxWnuYQ68Fixym7L5idrW7W9Ttr61bLeFi7O3atrKrUl9nLLVPvLPfaal5VrXqjnzt3/zsWM8O1ct42t1MN7+nlVbOU8y3v+b73vNZ0lLnnlh+/13eucoef/MI7EYEREGB6wBxQZB6Pa5ZHjmv7+fPn67IhUMy440+uGF+x//+P458v8vZ4Ulvl+JL0MChrUMUkWprl+N8q17KiCj2rLn7swtV3ZoVDUbP6cblOT0qPUqaWIAE8EgdAcslAdtc6gbsY5xw6ixapbXb67l1tvhsJwymPmL/iYd089C0bSOqq1j6p7pqeXs+dkTc01kMiuvmfZbnS7l7GuvuZr6q+eb/easPMFvVnFgA6XvKpjwyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB96C0qMaw3aq60pkHy9uIWYxRA1vLcNGxikQ3bW7IAARAH8+mC6GOEi2tm2JKJQmOPm4MCS69S543rdPfh5jAzFN3RYlLXWjNe5lS3J2WSRue7dSVyO7JIXPxXXG5GrWApLIIEe/Oo725JOx2Aq0Z3GqefmZ2tRxG9KpmUTNK3OzLaWJRGew92pfDsWf56WduLASrgtkDSGgs5SGdBS1wW1l1uK97crSV/45FKHfd4Y192quGWrv1tb723dxw7jd5+8+dw3zLPfIIkFi/OwFV1ljj3na89/c+Zb//z7jny3veWWX75rPHV/Luetc7XpIpPt17lhl38e5Y/+//eu/jlnjurr/x1lvlXCtuduW7NZFxFFGue9AdZPogAAQAUikCIyzGnf3n/7x/6GWsPBBxy5OnTQvWF/v/3ufe8r9w1X3epp2CHWB1YcRD89HamN7eO7deXTFuuIFqZx9UzWYoEtuO2s1fd5aDu7Bh9GTyUdm2o1RBNZXWn3SG89pb7rjH/tqlfjNt7rrH+dSW1bHz/9b+Pv3anW8zVfXtPjVLYiYcJxUXPChQgYGqgUIuAMRF0As6BY42heKDN6b2XX6azIuCBdX3cpSWBBzCA0NDDY1NBhw14mpS3+YXs8bMai0OROCBCDgIFPTXC37cYflcTzj8vyYdBEZbhYg1r0O15TDlLMU8bWBKooVZcQBMjbg9mEel+RhoHDDwZz8ZjVqWSGLWKTGXVIanDNHgR4k0blFnTS+WzEWjUYqTkqf/KNqNoZCoYd6sVcEyxAoLefeWU1K5zCVrtQkn6ew2U6yq7q8sdrb3y1SwUX/sc7zKr+drfL2Uy5cK3vG13VhuTm4XaSd5Z7lnZ3jjXxxwtdyxx/PuGVNOVLW8tWt9z/eXN6z1vHuNaW+5F/8ec/+/+/53v585l+GPM+3Of3+fvf85Uy/Hm8/5l//z98w/9TH4UBoAAAkAVOdNgBXKaCK91K7+v7Tym1Ga6SgVKAkkFhBfTXJBV/HW7uv3TXrNatWxpaeIwFqBDIjkaAHNbDNY5426blWKFAjmRmVkMgrTSOGZqis0WHYjms3LpobkUkyTNC6Yk8eY5SaPMrHCIwPUeheAcBiXTc0lxNNNyQRNVspJSJ166SRqpaCRstjqRuyNKyClooobmglxZmxeKajhqikiuZJLZkEa12STdbUmZ55StVdKgpbVmjO97NUpSSumpGipKyLWddTdO6uutFlamu8w9GgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAeuiVGjW6NwqK3aVC8rbiEaP0KNam3DWUYokL01ukwAAABvVSsghB1MyQhNYx54v0E02b3r//N1s8q0A2qd90MQKCHUGQYUu1LIvJYGppuCmHIT4HeL5XBkszo6V+1hIGgReKAQzwIFhd578gzdB0G4DAFNw29hF1GpKFUiBdIqRxoZF4xGcBQQRcnikYDyShuomSbNEzhYYiSJMFkRyG8HhnRUhCUnB7E5FSTxudMT5fWaA1CgHdiLqTQN00HSTOMuZE0Rg3FtPtNF3ZlInBPjJ0kkmEjMazYly2mmtSbMkYpupSSkVMpaaKDn1LPIs7pqZ0fXSZ05OOnXr10tTJqWqmlpLT1b0HdWzW6tFZ1U2B1UKyAAbAEU8xNigG4U4quvy1+d3LcOWlDkizXxULXbhS2r3dYY0GGeNiir81MW432hfq6AamuSiapaanq2ZPjUuIEk64rI59yrpPxY/G2Dxmm574WRJpyT5w8fHsEMknXwOoRhECJejJrdnY04Osey+Jtm3jY3Mt8tP3dRVX9879zGlfyidSdf7ttsqZbXuVi+69z4lv/x018U3mN6meslbRUY91SO5X/SzUQAAAAP5uOEIIaejiRrIMpmEVglQ0Ot/9jkKl+dq2yRpkMI3g1iYnq0qSuDbjK6XHhmVQ8wtNxkE7GKjME43Pfh406mrx0kGJzmzIK8Z2oapu1x0JG180gGJzsNnSUImRhAS6MwxiUisThERqhkyRmQIxKJOjhIsQUgpIlEnyyThqTozBDBWoc0pDnhtoagHACfBKZEzM4VUDYniuWEggSB4kJ9Hs0NC8kgZl+YGRMnkzUfQZtE3TNyYOkyxitB00CCDXTUtJkWHaSTGZGlwrJrPIzp9absddaaT6FJRued3VopLZbPqY8ktnMBm09FmVrstkmrUqkd2V/QrZJbVXVr9b+iW1oPUxsAAAQAOXKgMgkA0gxeDvx93n1L1PJJO8csMcIO/SQovwFL71Pf1+9yC7V3u3MRiKSyWv9GmyEIQZYqCvxKJa4L8RdsTKJDajCI/D4XCWHsWskgShfUSQ8CYZDDFSBkbkmSSRlMDEzOkwcY+nlkgO0dSEMsdwX4gIHScfOnjyi6LgeDVSj55SEwSWqtqBKUFLRTSSR01aCKbOnMyVI60zA0MkEDRNjijpqhSddZx1JrWpk6SkUFUWVpbLTRdJFyWO3Uut/dV1JMqaKWuv/qXV/+3ss6nYGxoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHwoxRI1qjcN3xihQzb25a6blGrGqNw7PGZ8GNvbkEAAAAa/ttDiSBhUAVgDKKgMdG8hfFzor3lZqdNh3BgUNuMwMmOHtJDRpWCxTSyViMMgAgaCbTwo0ufQR94IZaHDEB0kFs5XOgIMRPUlD0w6jTeSNASClbnX4fE+GhfKhFCBJG5iXSiVS8TAFgZOmIxozZNmCIyjJEURJgnjcvFEvj5DLgXJGsOMcItABIUDGkQ0kcozKqzxwrGxAhuhfQBZSH0FzG5VNS6oxLakDU2MDJNMgKU1ZSiuYpoGSZ9MmxPybooKSUbDvWmaoGLJJrZqTtda0qbK6aSzZCpF66Oir2QRy+Sa6F/1/rUlZqP1/3/6uyvOvFplAAAgAT9WHgr6p+b2LTr8/uWdylOcRp26tgLjCcoY8C9a2/1+9dn95UVqLy2VxqgiMcjV2tlJMCAEMqMkcaR44jBUTuYoazETqxYL5xalKyYk7ArnkBhexmUrGdjvK6w5RFSr3dlMhyeRZ/pZAFgAuiJJ4JFAeOWodZtZbVwi7XxPa1dTWruFLN4Spmp84pbeMfOPqLndM2xDMJV/MeVq3Fi2g7z4vzm2a+BvNvvG7Yr8+vxfFv97tqufr6UM+P8a1/8/Pzj/0vXFMWvjH/x9fH/1/////r1+//274NikAAB/P6BOZqggKrCfygjhmqoortv88NkgFJCzL47LlGmyIeDg46yBhAwdDhcLs5NoQiXUqvI1VQJL55L1FLJa3FOenlNI3r/mCwJBSaMw1Pu7BFMBBFl6IFHl0UyRNCJHydLqjIsD6CgRieHNFzH1lhNZKE2YoqIYQc6kmOQDAZFieNjMIQYGbECvGtdBBUySEBgLViSLTmlFFjyz6JikZlxAUEgnaZ2SZGtRNkEVQQUuTJMVJM7qUhUt30HsttBals60V0G3XW/Ru69Anv805wH1//tuZi36uU77iIrnWqio80/7dj+5T8L5FPf15EOKM5hqmeHSrSEIAmA1G3LYadB+8qeQwKy2XRiXU8eiDpSOILPSmbqDpcBCrjXpI9j6WnBIh+VQw9b1ykdti2W1sxGYGbDWn2dRqIybv3NYzjTg6hx1AmzcSiCJCPtZFhJ0N0ZYp9mRzbIcCK2vGFPo9UvIb+NBdOEd/XXrGxQ6Gum6wrzZ76HBrncfXx/Cg2J1vLbIs01Bh3196pPatvbNvnHrnN753bdJ7a/xvdI2s11rD9y3/8b/+vvWNfX3nNsxNV9v/8/5+dfH///z//Tf/3Jm9OwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAAB1Ru0YNZw3DpManwP3BuYcm3RAzrbcMgtugA/j24/vG7o6oJhERfcyA8OCCatdRMDaRzKuvkVFhWO4FgwFBuAZJJyEtEWFMpJvdXn6TCVmSsf2WxuQ1k6IXYpn3lCtdSMkgAsuDaiJxr7RrFp9WiI3gAWxNsSf2a+SztBQSyL1L1+7QtTnsIBb2pKWey6tjInkidecppXG5fDq7opLW3gUZGNloG0rzl6UQHTT9JBCyU7qSWS+UZUtyrP1I7YlkMS2G7kMIoPlTyurT3tY27nd3cn53faQsJJqflqB7HMsd38c+cwr369ymonbtY5c/9XNfzn5cx7v//////9c/8/zpLPP///ryej4upJCRjW2pgeViei4Kmn5YwFjfvVn5ToSrMQUDsVpHtEQqhbXqWmsw1BVPal0u3Fmt2Y9MuxGW8ylLA1RGETLuI0UDL66w1luxbCAZc5RGDIrLBBCTL5TJ0mh9JEOHaOg8ZkDGWLR4vmY+ydMB2kcNItnGGyXxBws4zH0R4ciGAQuoEYD+WiDHzhsZG6RKjmgNhVQSc1MiyVzR0EVmZii45pNppIMtkDxqpVzyVB3RQRKYslE6TLJHls7o7IIosinst1szG6JitNSaepNFak2zZBlqMiQ7f/ZVqKLI7v/+3vaj1V9M2fVLX6xiKwwc0WrT6GdAo6aKkKFsBYG926zAKEo1KZdLIyFi6PZIvCR5dJcAXEIn0dPYSteoEAVJyJX0OSwVDtXjeUJgy4/brOs+5mSpMMp5E6r94rmEYMx4ZqMqZjK8rOMCVgKASaQQ/LHDlzNEFHPfh3occNkDMUgmPqeQlswVtbZHNZcJYfFoETlabx7IbEQCJF7EEp6ssgNsjkv0lkBgwwMXAjMd0/GaA40bgIMW24LRnVeZvHfaQ3VrTbRhx2cEgSNOUBv9IZZE5irax13XJLDUfbArACQdgz5SaH9w/KJLJKW3bsU+dO878z+GMLYJvXO8x/uGdaUYfr8P/9///+v/+f/eRJy+U/cu7/+sr9xkkcBAUMg2FFRcCaoPf701XPOdjT7KBEgCEQ+OBBBAC68fWtLKWdpLsksV5LP0bSIRGdPNYi9PIom0wxULhYnl8ZprkdhuPYpO/BsAqtJubEq6pySftk7mrEe4SuN05PGzByn2e5uqajxqQxTog0nhfGU+jPPBglxLulnCjCS8iBYGOM8nxf7j3iZgxIMdeRlq+mMarjO/mLX40819sMSkz6Ha1N/Vc0+vre//93vrPzXPxf7+//jP3b4p8XihpN93rI//8dSkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACDNuUKNa43S5i0oUPy9uo9m3Pg3vbcMBKygQ/WG4IAAAAGt5bg8WTCEknmFVoKQh9BWA1rqTvfOVEZgamEikssuNkMB0FAIdc9utiAzDioEn5EmlKBkspKOtyey+KBQ4VJ3blEwq5yigI3EEjTbHWAo9YOTEIDjkpDRr5QO/rtV7FM46ZYFGJfN34/SRelZGybWNqQylv3ITcgeHIxi1qEM+aSghWdD8NJJ4WZ9tknAIDGNsSlWUbikagF/UykIwYeDoh3MDABL1tXzlckqzco3Q2qKkljhrSTpMgDBULv5ZYVMv/7uHZlzIZzEIiKxzHKekgO6na+tqxlez1nRNs0WpP8pHOcPeevyz3/Mqzt4d3r+/v9/+8f/v/3v/f59nr//7MmQAAAAM47UlT6FTVjNubIllZr96gF747Iqama4nYYJJr/lxoOYwty9M67mz3f3O3YIX5arU+N6xg3Rn55xNSp+ReIdzZSW+5Lrd1l2rGRmJc4yRIUfukbeHZPt2W/DJpcNxY0/EjPIjMjmpJtq0jCaFMssb2NEgNTFK5qEnom5cZ4808be4d9bjZxqGwofF1b4rqtfnX1FzZXFprG13WFmJj23833bM3WxjiqhUUUV3tzVR7/0P//+S1/rcwXBFgIxQgYcY4RGJEBlRCIAMyf9L+u1NzQhBDAywoVXIa3AkNPoZUFmCA5wYYncxeCyoDkQY867C6kCDoMEAcnWFlr+viLDg8Jy6TtJcgRgpaccBiqNmjjgCEFA1YGBMscNyHDMpDXm69ZfmB5Stm635mSwhdDMMU0f6nqkXIaGA1MmaCADhxG4oB5xZMpYA2Iue4I4HS2q14OBJU9rxPUMgQs2puojXqDPCmmcl1DgeYzlHdsIJAEqYGyypcpurKLl7Kmre0kdGDGk1rEjkN3GKU2VPK43ATO5FHZW7I4JCzdMx3fXrboldVy3QfSXHJZJGJqftNkamzz7G//eP8+s4He5Y///39733nP/XefctnvU7MqTPK999FydQIAAAA+aXFa4FvlqgprgcR/6/eE2p+7OwzJ4WYUWHADhpk65VFXqk1Jy9feHlm3LqZ/HDgK3Su1Lc7LlsaMRNAy9izXoVEYGpE/SIrMSmDsqkppOxsqth+pja5qlpqaXblVLNWM6XOE4UlLapObjk7K3hq2pS7SkHYq4Y19zGpFOtlBqQeuPYSrf2sNbtb+M3dbtRCHdcx53//X7/msOZw5Kcs86Dt2p2vc+sTUI1MOheKuMgJZ5+mWZSz/1f//gsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkebk8DeuNwvW3KFGdTbiORtUAOa03Cs6/okYzNuP1fpw4fS6JiMeDDPwowMaA42Ahs3CDG5cWAW/rg0YCYAqBdiGF9SejM+OMIMAXdNpHNNcw8OOxktGuxOlzxKNBKhjuO4uQEmAKKas/kFTQjJkopFZiZmhpWmUFLxqyv4+8EiIAg0XrcOSplJryBOaCXiMggNJCm6+8VsxEGADtuItVBwgTClTMEzV/sipHaXCYHAi2TAYTVBH0OgiAL1ZzKljF0M0dUaMtVpmpN1Vjp4AIRHhQYLCNIBUUPVJXUs0vN1LkRztw4x41aCES4RT28dWPzl8ZirphgyWdbmBCEBorarw1I+DoGhmS5bs1qWahSvb8Skd9qjvMB/s1Ocxyn8tXnjyw1jjr9d1+t8//v//Mr+dpaMmV2ae+taG3G9znOTjIQAAAB3t7FXublZ5Q9G4MHKEBm8PweuRTc/LH9flVhc4nKjxlYR3WdwJa+zGrzVs+/VrtIf3ciq26KELxVTMgqBwaRRezMw9aaOCj9y9YOlozZI0AMYfOuXjc2WOegWCkQ06OlRNjHpkHMSmWSWLRDSsbJEEHwbksNIdw6yygieRnUTEhxHAOGAmCRNpGzUnOoMkiZpLTICbl9BVXquyT1DPDw7oJOimdMUt7HlIqmKT6v9vb//6Jizv////VlvJ6QQEUV0FxYCmDhuYiARhEMDoQMpTISL7AYag0QgjCJhavIplHeBWXAKqXqCUg0FlD8GGco/l1yITCndHQ8F9Zk5DhqLGECoCad13kZWIBJkgbKSQEUQiIi19Gpn7aWVbFDAMNSHm2QXks4JgF+1FzJF4myN9vjdA0WH1uOW/yyEIWaZ0JAGjz428GLKlkhlCzpySYGmc9Q0cE0w0KjYCeLNSLWwvRu8FLyMECMIWMcxMT+BTQAAi2DBHcuQxIJ+pMxupXhiG4eKoc1R59bnLWq+GFeCIdh9YMCADHDAgQ+Kqw0Shumo4hGVptwos8KHC1Qsmi8dae89Ru0807Kxc3/cLPPznMNf/cP5j//////3v/dGq9H9aN/11MAAAADHX3FlRRvd1FY2P2EYiZlfn2HjnatBbfmNoViEEbjX20uaeOR0vcZ6Yw+5ncfdi8F4XLs7clkENHC8BMTDLkv/FZmlnUQLl+lUVUy8RFYceQiRqbG5gwyk1KBdNUkjhcLZMrKpibmZOE2SiCyLl5MvEQEAhslEzRTMHSU5EyoAzkQ0rFJ02oLa5xNJaZVGQd9nV0LJp3KBINoOWNJBK96m1oodfOtXFf+sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIIGJQo3rbcLvLehRnOG4jgYs+jm9N0ron6JD9YXhgAAAAY85nDJEHmGCMBEA8W6NoAgMAgt6M6ECgGm7DfmghDyaksNq3ckFDT8QtzHuVMEF1UQUWTOAwFa9Ax4QC1L2Tw81GnMEWQrFhTAF+JeiEDGB4km05Zomar2CytRO/DlZBEkctZ7YcnkAdBJJRMFUSWe6M7Kt23+Fh+QyqUO0gPWk4EMP3IH6l954ko5oMJ2XYN3VUgd4muTtRCQ3IykoVottWzhccj8QEYQYCgHOJYCGVh0V1RtdjctmMLVqWTtyHPjaqBkAbAkrz3b1SfalcWpcgEAGsBrQbUNlAlP76zGikD0/lUtcwrxh88lHZHhHtwde/V/X9uf3sP2a7v12bKGAAAAB/N++7JGT5xB5h4tooF5RVcqz9RVOT5P/PcYShICxRqrF62sTiclt25DYwl05RaynVh4akV6XOUzhqzJ4CRcFIw4VlDKI1LIXQNJQS51qexDj8Z54po3fxl2d6q8de9MZWaurcBblWNNKZihgO7laf63p76Gw6ktdymwzx5ubet4lDDGN1Z63Utd/f4b5njrucojM9+u9/v61zfYBjVnjwQL+/qdr7u/vX8/trWH73c3ItU1rKv9hogAAAAc1y0QCZB4RgcaCRhcZl7DJQpTcOKKcwGAzGAUlrSEQzDzwwoQaBPkoQ35gw4LOSCU71gCB4cAhgTMGMH8LtmGAzEJaYOEOuklDakHIJEotAECiDSJDPTERlCAIJBQMMMAzJpJVRC5ejAXEqtjDA4ywAhzCPVYJlcYkVAFUquIGglulBHXbNIDk8mYhCgSGT1bxvkOr+Mrhm05KND4mYXiQH35KyzWJO+dMvlJdPQ4ltdLPjChW9gKTRhznvKtIxQl/SA6KiR4dJatnUk7SxW5ZxjWCHw2fZtO2foauVyx15sKQwpw46Fg0tZCTLsLvWYW7TwVaC5jllMMRpvhlvuwZJJ/HDtNUww3LL3vxQ7zq02Sb5JZGu76CAAAAB875AUSdS5PgrhGi7C01HJqtveLTXLl9bCVIZqCPePmWavu2BktaOMTztxGTUVTuatsvuzfJtdD8twm0tBAhc5rMjl85dvui3Sjx3t05BjSxx8Lc3je7zkuykGcspoIsZ/RRSxS4yvVmQZUsYrWKKIXZfMLDVNa1njnStolWRmZdOQRZy13WN/X4/vfbrFrf9/f//63+4+ry9hBRhaAmJHDHCgcWObSoMf/pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB/li0AN603DJbAoEazluILGHQI3rLdMcsCgRvGG6/W7rrXzCwRM4OKBUkMhCS1x7ogYKNjSELCLb/mZszY0AmG/TAEdxmgwYFzKdLKxk6DkAsNVaSG1PpHlDlDVbrI1+pTGCXiACn8/bep9EAIaQAIOr4eKGdCkySmXU2JN9nZKBQRiRplsbtzkYjdDm9QkpHgdnuEqjDRTFnsoBcqNkJGbksVgEoIM41VbEpvUHXjB7SjhfPLPK9Nhwprxu2THqQxih1I7hav0ghaISGykhcHBiYFNw3jhlZlWPLF7OgRnAoib5jhu/9NjlYw0j+c0Y39inIl/4TcLr133opfhrusn7hGsIV8FWJrD+XaLeuU/OS+v7hceytr1bqu70EAAAAD99ybHKVQV2qNVKEys561jK1yrP5VTKXI87750pADGx2k1TWFL4UWf/Fw0loRDU/Py+gsVWtPE38djzS2Gw4vV+GqEjyI6/5d7LGyQ1BbTZjG7QxHte3PrCsHt2K9HG6Z8s8IjAlDF+W8WzSPC/tvs3e3N007GJ2W5TMSlqf9DKoAnKfmUeiRUZOcR4aCVY63Y+1Z7Yw+3jk4KVlFdxz/n65l+NDASwN6rAVLlh+faDKrV7+9fzDdfnN9s6/f/n/23HNq/5MgAAAAb7vARAyDojEFyGHhRio2BQwRCpyigYoSN4RGbCghhJgqBBzyHUEcFmRHCUwwo0vuEAwIVHDICCkwGfGQyPyLhMliqdiKcCrBm1HMfAz1OdYSCwcGEpo6ELA8SImAQrKflpanWeScrliQJ8nemYYULibxVJoAyJXO/uepYaeIs/el7gR0UCZXKn/gIeMTJb+BFb36qmXK1qdi4cFDtl/719CBuZkP14KErigyXar1IfKsSCGOLgNtiJYSu/nSf2m3lzOs7pODAmWWGGG5TjFZ2mmgICeBDq3GsETVLZuu7fjj+fZs/9SvGoFoaki7NTkp5vKh/WruXN1Dpomleo82t36kAAAAB/N8Z7Dyzar0I+EwE/ADBUDX6Ih3+oztkTXrTjvoYm04Wii4y1uSizcaeccdWmZnp6DX8sTz2ytOt8Y3JHqXGpzDRdAeSw56Hyj0aeGjnU6qaBMOQ5QSWrL2ERyJUkxnKZI5/MINjNa9Z3JJy9jbwk1lsuU5MSO5XqXJHRehwps2v0tfmOEACkxtC9ItSUmGvm+4byr52+bfxrM5zfP5+f71y6/jHrV6r3//nbeOWHf/WHeY1c+/213nM8fx7YcHt9snWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAiRYk+jW9Nwyqw59GsZbqJNpzwNa03DCC+oEZzhu6AAAABvPKbUmDgoCAIkmEVkCMTSBRMZa+bMCooECdGIwIx0zeQLDbQlILnAiWRFQwBGJiwsDLBjsiYuQvRMwUMiJhwgRADJ5QIwle5CLjwiz8xsoLyzDM1ZyAMAgKOgokMmDoyYgcGOkoY7dZMRwww1hybdVRpUU3g6LQSRnH4i1mev6kJlBESnKzMBoalpTURgRrymFBQ3K4oUBacMaoU2GYpQa5LIivNgMOhdBWoRY6UCL+NJJXFFQQ9OZ0BIBlRw0EmLNfK/3V69f3UrlgABQ97D9fyOT0tu0eniQ8NcPhyVIdEWsPmGYbjcTr45dxo7sOSuIR6T6rTjzcwqf3eNjC9hlfB4wPFjajuK//+72fSgAAAAPq/hAa5n/sw0oI5wqOPGtEIR9VlUtIoZPJpUkw5qNw0QGjGTsNigj8UNhWP1mhYyyPTbqcljsFQKo3emGdMxAxIEnExk5VVZLm+8qgeLKRpHqa/P8lE0/z4o9Kce/9F2U0EGw/HrFZ5Yb+Zf6iW9qn5F5iMS/eq07K5fFbchppbRStKG1hljQOdKw0FejsMZl92mw3uZjF69y7lhefrfO/vkzl+sOyhwWL/ynsd5h+7OW+c3h/5b/HW//ndZ/r8c8efUvGXfo1vUyCBQGFmMCp4BR8g8AwJKgOyoJ3LwBQBLwYcNA6fYZcPwiU4BkIgMGiho1zJqSMhvhgTmfu+9pVJiQFOlUUkCgFb4VYr1TeAxIMtclRmgbcjahgAfREKpu8uOFMOUciWQJClt2Lu1Ii10Wm5S7bRjFEFxYRVz5+epDOhnZi7CwCFUJVdHgYEBRKNmCA0SisIEh7xGFaKT6rMoDJ6SpNrJTibiKpaGyZUShb92tA0fAIMrbt8F6iAUeKzUARrtzl9+qlrPDBnYGpQPY7XwrX5qnrWo+8IVFAru/TkCMAx75+/TXpZIJ7mPJVfwk0jizwT1yYpHMu27OGq8pnO17VjX18b3fwy3vPL/rHRanId6+nUgAAAAP7+TCWULj7dX7aEap+wA0OkUfwvshqoe24uw9N9pxhGnCiuplZgmlZUb3nKmDRSTVtQiOOa+lKBAL119qhcmeXMI34/DkUgKL1JuUX8c4z2rjVgF3xBGV53XcpNYRR2rcaldmIYWI7i2lqX15Zk/drKMSm9Xxisw530NmukVCKaxVoZcqhEd2GoPPn9W3cx7P/vPfxWU47//3l+v3lKpSgZe+Zx/8t/ld7+tZf/M7mu/l+f75zu6uyzXXWo98oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI6WLOo3vLcLFL6hRrM24j+ZE6jetNwpsoKFEMvXhgAAAAd12UFkzNxwwohjZkoWYuQGUhbSjPx87kFb5WOWBUSNQM3JMZN08BYciRh6KYMfIpmLJa12lGIwQO/kQ/aEMBZigyEDIOC3+LhpWihevafSrGChxEAY0jRkeQTBCtqQIHwMJGBBIYFtcSnkgBDFCCgVg583QSBhFI6Shq0DJOX40pc7JrVtKoERudFiUEiSjC6EZQ8KHuF9nAZs6aTz0mf2yKHXDGk7V/dt3HIUaOo5k0fMzV08pfWgKWgCMzFlYTFMOq1iNPAE3c7Wq9x7nj44KCsKX/t9mp/licsy2nGBTtGafONyalL6Ko3WlYlI8uXJ3LuUDyJ4WjSzVSIP3zmeqe1j8xLcZTW4sWc0HSKba9lKnrV70FOVXQAAAANb5uomqx7KOtrHhQaDwBcS/Hr9h+qyMnYrAjdFDxgAQQN9AYoOxWPcpsGh/Y1hCK9FBUFNdgSKRG6GDSWWABZXUouWKCcppI2aM50pqUUTFIWUDdAezxFBopkyZDfElPlMdqjYxIGZrKyTlEjTpaUmZJF503MBGkrmsQVKqDokwUBFQGfE6ZCzCSTlBVSJmip3mha6633TUZDqDldAtL1puh161v6qS2tMZRzE0EAAAADffwUNGgEcBVCzHgcteBpowM1A22eQxI4hA9ai1huu25liCVTXSUaaM4CqxghR0RRixAMEGmpEAiH3ETUMUiLesSggMBmHGrIMwGYEDioBKgJaPDAIVBzoxBZRUwCcrCmVeJqDRZUtdaSXpiABfMomQe8SCN2ZXL2cNKdkyslk7SnZa9UUfbGDjDzOCXkeZ6GBiNCkbYlgMGlA+XTYYNfEIaiQWAmcqUS3skrSRJF9Azs2aLrrJicUo7cMSt/TZDawVRmoUjweJvplnlZqybP7FnNSgHJbF+plBkUyw1E4OpX2CgkDXITaZAmfLd0kA5t1gTO3jju3Oy+9EIehGVyWQVlrda1cxjmNzULrfnu48uxAJQ8/z2nopIr/RyAAAAENZcIaO5MsjyToEIHyqK8YZjBEHVGR2IVDUyXcWgEWvI76CONTk/QrDy7GTw48UVeOglyhiv5yDIsvNPB3XeCtAbqhq93Y95Bx0XaFRLRmxtuBiSkeO6Z9uCav4bxgyp41ZIt5JaQElX1dybf6hrlXEJ3MV0SloDlQlaHMXEcpjEb7zHi3x7V0v4/r65/+8VJ8I3+3VcKFD5+hrUigKqLRNb1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACRtmTgN603CnCfokYxBeJeGVOA5vTcJnp2iRnD16334MEA2YCwEIUkkYaDICzaiowflNvhjSosLC4bLRAWDOyCEBI5RMwBAaXgk+bpfAYC5mXRJHjEwEkxUCxR0gAmKoEvKi3EV9AocFjykyoIj5sAaFhKTMa4TXNiSExaySJeIOIhCCECMiH8LiJ4jhpIU24eLAkCNBoFkUVmWyInG4cJ5SeLTi+VbG1M6eZqDQacjEachMgpFQyZxAqgWtfiJFCZ8YWkPC4u7wkJr5Vaspb92TYKXXsCQkoNUu5ypGXTGmLLSR6EJShm8eOFWkt5Z0lNhczS2BwuXY7vx386SP18dwYto0QWxMLwQJ44TziWoYfqQWs71uM0MJnaz1ybHOWP7/2d87PzueWbZru7tLvuqurWCvcNgFwsQkaV4kz2/9eIAAAA/f5vEiD+dyZTXJPF+RZT1I01Zqdtq+rzr1NEyRlLQskf9WLPGkZHCYHs3LDSZK82dli0FyGPSVxXBjsuRGBVQLp4fxWxkQYcg2JYunUDMmjhMgOSB1JGTE2RJzpiT6J0ilJZJJomJIHCbTY+ZUi6hG0sG8R5ERibqUtMsjki3jmjVIcSySToIGLOh6JkzVPuvRkyHBOgYukgJn0gA8hNijVDkc7YhswGDR4iBYRP8OFcwEEjRAdMy681GPDpoXGQ6JVZhAAq4HGw8BhByABpFIAH5jBGAQ8GIhjwuWRMtRjHwIYA0zUeTFJwCjz+M0SqMQFSzZloGgoQiwwGJ4IBmmAqBAggIwsyIWKoKYaAmSGC5iz7+sRDi5pCeZhwYSkzAhoVe6HpifSon3dE0TcH7hinTbWiwgCK1luosmPJLBCxX79OoIBQOs1JYsCDhDomZopvQzCU45VYeqRPAptFzRuJyAgSuTima8FW7RAIHiUPCJSSEiYtQ15ukq6woJiphz1gwEinozZ1lQUmMun5593hC4IWdxuVP8nncjFEsqdh53b33cu8wnX5jqj8/rk481PZ1qpVtcqSymZv2V5b1jaEJR5QG1voqcujdPuQcAjrkIAAAADW/4+kp+rJJlAMIMBLKOE8jTbeDJwHmq/I8H5HJgUUDOpudqxIsFdGfsXnWjjsSLOWy+YhLLHF9p1ZwkVVa8P5+rXsW7DS1sQ4bLaEEItqu7M0iTh99nbDEi4bCkx7y9rmraLqNBw1IB6ENpZwTdPmbK5EwiJF+mqYgVrv+m8fFKxP///v6xY+SUQTxKTG1MiwcSjVKaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmGak4Dm9NwomnaJGMRXiWtqTgOb03CnqzoUa09uNVaaCQ4GmAxkoIXAMMFQwGHTCpFNVKE3OgTkYwMKIIx0CFjExxRWqAENuoNMG2MFHAsPGDgJkRgYAFGKChySKEJogCggVMIGjIQkDUimQOBk6yJ2JQsiZtlYCABFmQhFxGBGNBY8cgIAMKJQcDCRMpfNpmuGNACeLYkI2QGjBKmJMXw2/rRk01VbMHHCUyV0o7G1yPNZFiC72DoDl1hYwUBnydiBQMDGgcajiEwwINtgzYDgL/NOV1fwZdSOgkw0swzuI5N5LLvaV7nQU0GpjKQsLMOgfaktyq1ukxpYhS4XqaGRZJO35r9WZRGsvkEJlKiodCaXNN3SigDHFDOUz7/Y9lfM73K9eaelzsLs7Cb++3M965R2dupV/HW+/++/n+Gsb5gn4jfNXXsFKRdZo0mkAAAAb/eoeZnWxtsIYOa1kZR5Iy1xZA1+stKpbru7HVyEA2Gqip7VuKLzT0eerqUw7fhExKoMtx6GHVc6eb193/jReKRRJtA8WCHDaJlJBEjSmgxfC5tNN5SRSFyHSgX1GBYNy6mmR9RqXFEwYrVOMaopEPRFbJKEsNtIsFEgAVI8loVuVUEFVJpspVSbL+plV2TLAc08XCEiQ6J+uhsQ3b0/qq2IRBUxCFDBwHVhDi8IymZZJxqLhGLWCCr8HMtEhQ0yNEXABUBDmYKMgoEDHUx4NRqAocGEYUOhKrBykAQlfRh48cKGDzKmnL0GTDwRIEMKmvxgvKqkNGJhZ6SGqPbHwxmKhAZiSGOK7uuUiAydtktgsAs3BUGBQNCKebApwwBfUeUaNKwfxYSHoxCnUj5iyhICbeGIeIGSKTey92yJe5Ep6XHMGEZ4Z+YUEplSlXmcknpiJtZpAosZtSEKJXm53cYa4KjEC3/Y4Y0cqytL7+XZfYqQ1f/6jGFU61uzyOWp63rmUInhEDASiNw0+K44Xejq5XXpoBqUMaz/sln5+tDDUsKe9D+f9tfrtW/nUfue3zl7uX5//f/lzMSvMpLJADJICqNoU4M1lVfooYAAAAH4/vSasD2ILSWUVILLTigIJCH/iryaUpnKXFzlXNEYOPh1dkwbCb4y1RCfu6g2J5yGsqhDE/D9ElpLqJ25K97Q4TIqkhyrSqkRZls9ltmisMeCGQzZo3tsCpez1bYcVsYKYb2JVZw/VPcr4o7prN8FNcvNI76Je/fp0NomMrId976x/Nb2/9dO7f/X/+7aydhc7Zlr/mT73/v/5+9S7dqe119tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJBGROA5rTcJ7p2hRrD16iiYk6jm8twowpKFGsPXjHt5/zAoCMADcQAVkJigomJgUgkOP2sdd41JjMQ/L1tJDYK6jNOSwFAzkgSISwVDL5mLRHUrAjgesGDnAWANJJEJ43IOAl9E112FB8y5RHKDAERWOXaCTxgBRjCSlSGIeEMMMAJczDBuLKqJgiXCTs8IAxpCgWHpN3noUi3svgmDDRHYEjcohprKlr5jB1LhpLY1mGLAqGymWg4wkExF/BUDIwUBbKF86pJa3JQmZnn+lM250GAki6lKCQaMNHer3YSkEBl7xJOBgZFiDKf/xqVN73ctz8rFgU92xf3b7lUhp/ZzNjRngMsxUfTDtWM0OkW7BVaQXv1LL9nCJqyU2F29U7ynzx1N2u4Vnkx5hUzYFmigceevZnyLj7p5Vw6pyEAAAABr/weFRrPtIqusAZisoclCNSf2ace6qatlG7bLF8oMAwysrNocmsWZLctzuUB0Fe9NQp1LDyLxXnEbcahhmxfhDV9XKttcpTZU973lfR8VoLk4V222dqwurySLKn3k1V393gu2fClxN7e7lpecJEvW5GFjfz7lAF08tDaYurfEbP9t3pluz/8f/0r8NYorgFr2hpHLk6+XOsoPUMAAAADn9lJgoPGBgeFwij8MEgwWIAxSnHrEYIXIZKzHJkiJAJFgXUXM7Fh0FMLEhQgFQFHQVGTCBcx4/AkAAnoONVeMFEImaaqEwgX7YCVQ5qY0oWkdnYlwXIR5HMrFQgzetSoSCzGQgWSg4uVfDqwSVrV1Ko+sMSkIgCGhVHigWMP5VmQFErc+0MwHIo2+qsCDsewf8LkOSyJ0QCw6in4ZJAa5WLPm5clbLoYgXVLVpI/aiTDIf6tV1bX2q94uCCsoJTsV+rTKMcd5ztWrnhrdycVg1W7eo6XOremrlm83YSnmqdP9T9HLarjxTc32fqdypuXZ2laNRbu3qvcOfjhVv/z4vwe0CnVLiIss4Rdd0dfelPQAAAA1U/bS2XP5dlTAYNNrNbslAZgvFH2TVEgbGD1w1IW8coKJZyrQ5D+5dd+Xy7KzD0/vFJellVO6S1KbkJdCII+E4VzOZTv0VozqT2lfV3BuD5gxNpyfT07EE5wosJP0gsEJUWlY2Ci6+KRNXtJCzg6Y+jfTWN31RRC1wZYTnD1j3jY/3v6iozPr//84+8LkllfuPvfleefoa9zxEi8QXNQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACStwzgOby3CdahoUZxFepPmdNg5rTcLQr6fRnL261hXZ4qsFBAYFDSB5isWmAQ2YHDJ1+AmblCEb4zEc2UU4Coi8oGpBoAKpKQFhhICDikRm5kAKD08yEWMjDDFQJpyIxjCYa6EjRiNBSsZACEg0ZAOjQQwoxcJjgELzNQgaGBIwhbkg1OAIkmUYIFjwsXFAAAMAymCxZlDoYuKCMCpI+rtyHMceo2E0j2LzDPUMOSyyLBL5l9diAtytt3owYMrDWXVSEN20xGrCcSV1I8VeG7mF6hfmUO9lTlz5bbpLXZUhPgVvCqEvNjlBy3KIrSYYV887OE0+NNS2Mc71uYxgi1L6iU5caX0qyVTQ3dlKHGzhKK9BnvON0lN9P7yX7vMv+1zXd5au40vOY0mWXdf+seb/VXv63+u/z/7dkzqn3qsrUz1sAAAAD8/3FFzuTqOp2Ro/oESx4pvJG6F8o8vea09b1NaaMpcbRIjsViNBTqyrlkVmrGuxLKutCVw/K82/+60pnj0qyg+GYoUgZIsfNRoE0asgmX0mKos4kmKR11rG0SzNHaX3crJk+iU1l2TaqR5abJJGEWU6x8nV0UJfB/UaEOJ/ZkOhutAm+v3d2mQjVCZlbStVRIaRdQ0mlBOzo/Gw8ZikFmHRIAAgnyTHEw8LDLY3NYHMEGEPB5sEqJzgVaGdhw4Z4mQkAsuEaQSKk0EGITJljtLjuYgFWB4oeXISDimgRQNqFIiChAFFAB4q0iEkIcJFM/NNQM+lMu3GwrL2uGSGGOIF3zSBBY000AB0yFuoXtyHRY91ISbbSN5GlMdjNqBBHATMn2vsNd2ih4QC1YXamxgYhisyBm8AiJXacMBKsaEqu5Znnq9bE+q5oWETmX2fOOrB9rlwVarlS7GpGvUWMSQhIITVGMpZqJY2+02F+mhVaqkVFt2c61eWQ1Koas12HsZHlEg7LWQym1TLshVeVwXO/hNw1ZwtTrxwL/4bwzw12tNZ50dh/rNy/Z7/2se1hUDiJptgDjhy88f8o9SWf6aCAAAABvW6BTBQ2FT0wgLUMOkZ9R4wB0t5MIkPGl12tVYcvaFLICYCR+vATrv4FhF7NpL6jLbsKkc0lbSvrRrqW9aoYdbgrCnWq2H1oQ80OWyjJl8F3rj1xnqvxhwIR10t7tghKnd0bk89d0Vri+niM6isXyW8CH/ajbD5cc0N3dc2guAnodXbF0++/JN9ZjVrvt5Yvj/H/+N+i4OPH0t5+GrXxnX/v8ekn/9vndNYkjyqnClQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACSZizYOb03CyKln0Z09eJY2/No5vTcLDsGgRrE263ysskwYKQUA1RIOGHxoY/IIEJxs6wmk08bTBwDDhjwIDTceOSQWGoJK0GFpgoWYAHg4JMKNDFwsx5PO1PjIj0zcUTuZCaoEnADZoRdqAjEhsVKhooCBsql5ETNYNPFwYLmqiphQCrAikAC0AFTaAImBoC7wKQEtExQgCYygjMLCQoLLqiq/SoFgmB3wbAYSq4rrBYGx2zeagpQhl8PDgxJpmT+AEGa4nAi7nLLZNfR6d4GsqeNx1nmdWGaV1oElJdydrJLLj5zcOwgkAMhg4hEBAmQ9mM6nLdV/MdZdpKykZm9T7xzpsM4zu+8skWzTXKRNbP5IyKxjLIdxwzktLjnQXWj2d195475Yyqfh/bcZ7NBgFAeLoNRc4wBnGPWfP47WrKaaAAAABvu7igTiRazbV4quYfhkhbBQeXZMvBirC16TtNBjGo0skRBzKkTHAEkoal+QQDYrK6aukFBluUKdP9irIo0zyXVZuIuqrADhkacisriazGEaiwobgzQGo95RLq26vrTdzSZN0kcT4gVcmVUZU1XWDztLPFiUeYa3KpKtdnn+92dhSiYKFmNzW7wK6zmPXGr+CVlPT/Gq5+qXlKbeO5Z1p/ofk2JIXD0FyRF3MLdZUQAAAAN57U6MOBUhFiZqWJgIshCpMXCc7XpDP9IMxlo0imx5gFDEzQEYeNTwkNmFiRhRKQnKSA0AGDC514WbUfhcZAReupAo0sCMZETLy1mwhBgEUGHmaaocFChKDi8dBDVi4YITJCFPdPxM8GlBhYaEChcpKUvUAgVBAQAbDi8pERAEOIiF6pleAsAhUCNTVuM1AlkxAbUKDciQDL5wf1HOG5toA6rSwfrcYKyFKs2yFR8usUqBshlctl1+J1S/9PfVSgbWfxGYlMPbfsIE0usID7bsV5+nnZZen6j90N3K/SYSCxHpHYeOjYsPDqe6zuW19wQ+9L2VT+HeQZn92ITj49+nvf+WsPuWu5TVHNZXK+fMu5d+pjr+5a19/LvMcvyuVnnH7fcKNv/6KkAAAABl+qrv0Uj3ZVesQ0EMwxMqgTNHIJVkgGCVaaapFltVHXWyFGJxP402XRMKAcex71yqArkhaNhE3VgxrVFfbC0JNx7UL2KwG+ctl8pwnVCIj8FllNjoyhmFipbYhhugo8IHNi8iXx4NjRMunEmIisrLGVPKLhmmkudNFikXWRErsp0SeICD4DsL5MEspRGJNWYrS0jhTt0/mUzJikiftRdaHpa61tpfsrORYmv2UgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAl8Y02Dm8twnOpaFGcvXqUNoTYOby3CtDDoEZxBuuXJSvIDDYSHRhwHrCgAtGVRgYmOZyi+GXJkYqGptdEA0FABCIwMRiIKd1jGVAIJJiQLLjGHjIBIhFNGwGhgwyLJTpDASIxsyMRAzc4I4FGNg5lRAKDKfTsDwMYCNhnCYSZmaFVksAoYBGcB5IAEQgqqjoX0Fh8tOpa4YwFiwUXEDB+NNVd8aHgyAlaSwGcb6ZrzqXS2pK3YMQFLqLKUETLruG44InpHWUEEBCsLlKx0ycDEZpsia8nhudqw3QXkcIVFRUBs2VbCIyqLBkcOjpJgCz+qR5N6qTj8ymM38c7UZ7jykvxulrz01SOa9LRV0ZQ+1GFzHItAPasxaysUlXPCYk1WCaPGb5e53Xc7NzOvGsK92VWQGSFTQYJAwKnAwBCDwUCbOu84ss4WGabOzoIAAAAH7/amMtkdbJS1ohpwg0UvschdxmUYxY7qjf2GpDbZ+WfBwcbtRF6Fiw5B2oJeR4ZRebFFHpe5uj64UkYXo6sgIQzrZzagJyHlfCvWrq22/RnawKzytY+Krx0xcPzZ1LvWdwZI2nCh8XxfF9a9c5ML7V0/+97MANFk8Jwx3LXzrH/+rN3xv/7/z/eh46rv/+TpqdkuxJYTVV1d/SqIQIzDxDIQKJBMxONQUoTA6kOVb0xOPzKTFM0D4HD4KBIAMIAggXGAwoHzDiEQAXTAyAFGxwEAGKhiQAChJLwyNjMyPxkxQkIuhheARwZBwMAhcDKCNFoAApEmmGM40Qv23ZNAhHxGAmIA5ggYHIIQJKcr/DgZAgW1ZMgsmzJZYREr2nlA4YDkwWSytqi9aV9mCruFSHzqCEiEx94YIOch6XmEABZltIu2RryOVjTZVdQfqkkUZxqKXUj9S5qGpiOQNSkJpah3Rw8cFb6R0FzUAY0DuZvLTX7fVPy7teNx6T6s4zDgtlhXjQMBvrSt9NQ7TzlqTXLleelOVWL2O4Rh7t7w738LGPdRjLHGP3Mv3r8MP3nc6dAAqNEqw/CdjdHXryD2/kEAAAABjl81DC+rFiZTiIAzT4TcBrAeO40aurzh3GfbZ0cmQoUC5xLUcg94RhCG8sW7QOrDLjVph9aFZdHAUUrVIDV87zUEOLbPLDkth9h9NgxrsQlRSNjU2MDUCmYEsZKWVycJpIol445HsNI1cpKTUUTIWeZIorQWmxkzieVpGC0600hIBG6yVNyRLh0tMZqs7Otky7dm200qJYHG5sm1rt9XZdGrX09dmWZsrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJemvNI5vLcKsMOfBjEW4mKcc0Du8twnanKFGsPXogAAAAZ40zSTFw1MICJV4YShY+GKS6YHoBpM9GJHKAZuaABQstGGQgkAmKmBABs0Fn8DTQYepuqWmNgplekHJBEltJT2NOOTPxAxxsQta6ZULgQuHjYFFwqKjQ0naZC0BQAMdFi6UBAgMEBqPGyawYIgUSMaGUglAVFxYNLNg4CpgwEb9pUEDI0OYOUhPaYabkNM0hN2WJ5pCQS1GAiA+9bZ8FpE6uS8h2UlJ2sIYuqu3t5vEgNzuEcibUOrlnrclc3Knj8hmVbQ7FigoCFwU45XRY5vfTwPhK4XcuRGStY/nNVsJvDOrNt9GWfIS2nVILaG2Whyj0bpLupvmWWVFhR5w1Cvq3Nd3axyzmMMss6lnLljWPNYb/P+cqY8vdAYTMsPHBC2N6mpYE7S1Q/0p//zQlT8OSFkSGAUyAClTgxof1mo/GlhbeM4txk03IUBCtJEZ/5VBpaNHGPNrQN+6dqSQRGpINAYCt+xNV22DgPLFciIUHOXLX0ZpI4bUplFLMFJ00TIoAlDQqmiRNmhoRVMsqU5oL4nlyUQzA0HAXUHMlrRuxwWpFE6bVl50yJAykwYkPJAq2lFqCRs1Rok/bUtpsgWRcRs51JFUxdXfntjN9fXrUa81ZuSZ3lmSAEYCACVQfC4IFkkHgwozEIcDtcqwATxhGsYJDoWKjWzGlMaJREIogmYl5jZURBkRM3AxweOpKzIBEBHrjpHnBlY6lGmk4YOCQEZMLmPkz0GDAieI0PAQkCV0QjiltShBw+DjQrCVBxYNMTJVkJxLXEYSVRWJMdC4SGGD8xsWCA6F/GoQ0PIv6MJiAtZ9mq+zEk1UqXchwFPV2vChiAOCsC84m9ap7iXd+D3+eKqyvfYcppiZrQfR3U352al1mrcWCDrYciS11a68RidqNTdFEYfkeFNAkQWrUqOFK9V8Im/M3B9+u/qzqliHXwmqlJBdm7Zm567yYitipSzj4T1ibq/2vZw1N3sPuSal1qxrWq/LWNfG5up+s7l78OX9a/P9auNfQ69EQKFJsdv0Z6WYAAAAH8+hdGCauEdTgXSAxANGIlNn4uSTOVnffxusjhq09xMlb0M082WYdW3ZlEHxSmfmUUVYiG0VjuFyC4ISpmIQwDbNM/ZEnZlJM5xoT1rcrS6FnTEWLiJRmYIb7fxZV+11qLrLjRXY3qtNQffd4esLj/ecbVo8IrYp8fwHCfOMZ380+d+X/6+q434awGxIdKXblMe7iJLFlDi7kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACPllzYN7y3CbKcoEYw9eJemlNA7vLcJlMGgRl7W4/fHSMjMwQfAgFUrMDFkRTEg46eqNNZzgE02toEgw043f4x8CLOyQx03MLECYMSHJkYqBR7wGIgEmL4oDU83NPMoLTVgFOUUIzDhwHHLeAodLeOkYahGzApijUYCERtMYHHJMBGIihfUSJBgllaA1PktYGCCY86QAYXA4cc5BhmrLoDYwpOVswbhEqWCbawMqWw04kEkVO0gQRIHPdPjK7iQimbuvajjMtbveZdPav6j0Yrxj9LRl0ay/GTsgWHiDCmHNSiMljWV6s0ymkVavOQmPLPpqGI5WKleUxp2aWJWoLZpvW3drcksza79JnzU9Zyx7SwZvDuXM9YfvDDHPOzreWPeY2shGQMA48KQwLpkJB6oAUkwwXMMYgaSDz/UwAAAAPw+oppGX+qLTe57SocIiJHXrmv/khmOtgcGmrRORCV5Pe9HQfQoM6EgfqfhWUqhuiig8JDm+VineiMsmn7hUAdEOOuVExPn4gEKjV3XrAsPg73Xja2ss7BSmGSHGv1zn1+cqWauI+t33mNZtziTW/4ENdF9dLyRv4F9W1Tet4h6/3vGs439/X1hUlgdgZeXvGGesPip9JrfOLzRNMGRhQmkIAmDwpGHgCiE9DkMdzGobDE1AjFcBzGAYIJjBgJOoGhwoSJimWhKVIhHxoPAKqZuNhAWNH75mYAxAsm1ihF/A4YBTEYqSK3tuEI5hwIXPMnwzJAEysKMPBH/BAYZYDLClBADhEABRjwMtd6CUSLVNNGg6ARQOFBBvB4BRzYS6MBCAZf0VRwWCU3sN9YXFALU3oVqcSYRlDzqtdp5kNvnSw+VQRYd61Bo206Xvw9c9R7lEbxdH7lG2erZt/cT2CDIZaootD1WXW+1K9NRdjc7eyiL7S6fpZPSWY3K4pDEfkT0LVU1iUYfHG/Qy3LOrK7OH3Msa83Fbkelkt/+2P/d3HmNnP68r3rurX3dfj+NzIg1h4goVMCQMrll1rNgy4CjwgKIkfroAAAAH9+gZeyLtRyUuyUMD6GOUBCareyINKxoq4QzD9aAPCFNpxMwYYzSSEZhmIp5JzYW5gdxxGQcMVDZ+HiGoCeoC1bJ9lgqcudp24wN2SRcSscpgdNEkB7LmaBgbEmigkNJbTRZRgx+XlvWigicskWJ2SMxBgVbG44S0zSU6ypkamRY4e0m20ugbuta1a9fU/1W/rus7i6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAidYk2DmsNwlYn6BGMPXiS1uTQN7w3Cd6dn0Yw9eN70n6YNDZhcJBcOu8YLAhhwFAnIGrBoYnLZiA6mBi6BTZ8zBdqC09yocIYBhgBdMvaRCxDtMEmgsyYZYU8KA5Y4IyHOlhUkPHzIRGKNBIpIoDCrM0MIxoE08MDME+RoepNkia6sJMICQJMBftL6nMCEbZeAcRRNd5UKAx7ZK8g0e7YFhrJYnJJUwB7pYxFR5534l5UeRAkMQhYvp/JbdQ+cKHWEzW7Eox7nUgCBqBn1JxpkisVMqCcdkSjFGfO1Gc/zp4aps3YhizMdlPF62e1JBRX699/puYlcN6gmHIa5YjcZitBzCj7uvIf5ucq97O/W/HX8yzx5Tc1zCeCYJLDYjKLA7izUjXvAjrbHmFPftds/WwAAAAPy/J9IEjFxuKmZLsjGYkl1nKhhWmQUV2vNyuHJbG2RMrjtibAwVqNSaVBq3Y7B+EWrVn5hiIr5tyhksuV/J4+xpWTKd9C1hoNiDuurZh2nPCGjIufWGqvDu+lltSVXS28abTnb31j/5r4f1Bi/NIVIgL+67bXLOvmHWmM5+vZz3/bP/9N/eGDMbSReR6qOg8vN/jcaKLOhnwWKggBDh0gMiBjldA6eaMzUDoTIwoFMvUTKg0dEmTggRBoqYcWkAGNCQwSDQcMXpmRmpoNA4wMmzEJuwqbYBmdpxq5e/QJIXILAYPA61jA3sUDQMUmCEQAD1BTDCEAiMpCoEKC6ZSlKMDUDAhBASvvywBDQinMmSOAA8E155uLbutYMkVbl+Xo6ms+F5pw0J16R2gtlguMEhmELo+00uuX5dnqincpqGYVyVyi5TbYHVvw1fr6gN2aV0kKaBozs0XaeZ/HCCm71+4/MtEfefpvoIVlXnLUsk7K3ejtIwunm9tYf6kpn8pu8ylt7epDeyxn9fn3PfzePO09Xn0lT/p9d5vmOW8t8x5lzX/v91Q+KMMLNMzLxKKIMzrlMpp5pgAAAAf35tPNK+IwWwdwQYM2PAaiIllfHKK92vL5VXgOWFwi9TPbbGEcn7alAaJkHRCFQHhZkcJd5vILfpmDjW2QRtmrTmWMVbOy3bGoTWDO+m9WauCXsLDfMOHCj51NO27nitrjF3Di66RvisX116T3iRt5r8tU0Iu5lQXrMltXw4/7h79PmrV81/39az96s824wy/ut5mFnlntZ/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHWGhOI3nDcO0L6cBvOG4eHYM2DesNw52vp1G9YbggAAAAa/sy14BMz5pfgEmEIMYxbmXQ5tQqLNgiNBmUIKbnPjoSVgPOSbYgplHDcaX+m8wYClghs1rwdCbhiZkJYRB6QwwWyQ4gG+WHErQSA8YKVCPogChSE0cFFA3xiCHyODMqip4ESGb5g7m8fxVHHlxMh+GLW4L52ozlzN0UBoVQfyDBK0PS6GkHb0qwn869+WX943KnMngy28NHdrZ5UrG2X0scsyPGMdw5uNQxarYU9axvuOf38tVcI5Txb8Inrs3Uu0vN01r9Vd8/Pn5WM//8//VrvNXu/rn83z/1Ux5rlzzzRjBbd/1q1+2yCwWaKCP2vcw8kAxMZB8msbpjBKaEHCA6Ef4KiCgMvTaSsA6xEOyQu83E0KiL4LDKrGDeY0psTjWIlwFQoyns35coYJY6bESJzkkUpQksKBqQVtIGcUassiStXQ/5by5fXe/KPkiXfLLUQZzIM8EzopK792c7TQy8kUpYLV87eUQFvT1+syXj9Ytf5N08i7rfx+N4RiY3HNbgCWU+7gS+jkrWZ3OYprXKS5cyrY43KVvs8bf2u6u6gibi2Edu1Jddk9v712tl3XN/uv/5c3z8/5/5a/7QnIkSlc0xEZpUE7k0ErGrHWtcrZ/o3rdAAhAYEkxC5oUCwwiNE1DAcYy0nQdMVKQstEiLvxgvKATIMGPilwFCYjFmnLmjCIOJcBh0QzwRVCpEkXpio6hyBXifKFcGGjGv2Fx6RKeKqqaKSENBgMAi1rLQmXLaYxFnMpUgxhCVLUFeccBSh/sK4jCqWc29Nb5ihV5+JKF24Y8UQzWlttwQun5TSNp2rW3lfzyq1r7hymrBE9i79PdwZJIYrRwxFu3sM6eKQXGb0tznPm3nxmc7WU1YlOWoYxrY5Y3r1BbzpsJ679TL97v/8x2vnUv91vLv6w/6tsJBU6HxRAxEuhR1bv7WI//10EAAAADetwUXsAIUkgKApgZORDZqWMYboLeMMBTDRkQNQ4ChFJl8hUiMEIu8ooFTRNOBMIea4LABpYVFoicpumPmrtSXGgkdWqgDfAwI8Gg0Xy9q7X4BAFCyMPKRC1RAECrSqJPlhstjEUZ+oPE06bOMoa5LrUvQQrcpr8lrSWNrLiuFhjcvmeocG9zlsAOdlLbDebpdSznd50L9Y0dLuPc+RZfpRcOdt8X1rdvczynM6XCzlY7VdS9dwy+5hVw7ScyhvDPVmt++2O/9T//eXea7vuHf3/f/l3pM8TaXH+jK6vv7ptH/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACXtszIOby3Cr6gnQZy9eJJmfMg5rDcJoJyfRjD16u01VF4wAFjPQ1UyMAiI0EITERdOous0FSzLISGh0ZWEBiwOayWgoGesiKhEOgZVIANjZipcITk1g4NWOxEShggs40pENMRDMx85oWKBowFNMoASzIWGwaOmBlIGzjCxAdJTFCMQCJiIKBDsidU9zCRgxspSEEQGIg9ggoCKXMWRWZ666ZzKyYmb6ebuXTp+YjARMNR7fComnLiAOHYxDSGrHn0ig5osO8UQEBA8FPOe3SFxqTxd57+9U8xHa6mk9UieMlvW7cwmmpCXwC+DfRnlSiqv1R2o9faRzKSNNlDgw7eqSqae17IkzWw0uhgeglsPS3VNm42Uv7T/+pjPm6bWOrutXKlrvKDXO1c96w7rV3uvxrc1hz+/h//da21wo/c+cYom6KJFCrFXJFGHzHf+q7SA6xDCQTHiLEzYgk9qD1O8mpbygZ4KkkgaDWsIWDBznNlXcmKzpO1rbQIzAD0dYo9YkBNvG21V0Gey6MvKmi/KnJRQQ4Z1wlXYugR1w34cJyh2XRDUpeu6qSIW9ltlrgw4q4Z9IzO47Jhx+bxs//DlhSZrafOHu9C7AFcbbZBj51L49t4+HtoJyfFtfO8fGPRiiZu1ZUD/LTIsutg4NC9jl5xH7f///+m5VppgxaIg4BqBAoaGBR0VCMdcWxy9KGIRUEBIyaDxzwGOiJAVQo8MBGM1ig0wBMEgNmKOnmGmxIg7UWoNecNnvPjIEtoPlsIBSlDsGFRoY0kxBg56EaIhxgQCBRKasUZGWGLUO60iBiJKwcVJAqDgdTddMlMQQhAQFBytF9rVVDogusamiDqFgKzsoMa7JF+QEkdGn8aKEOjWCWp/KgtHmjhV0W43jjJy1K0ZpsKtantOxVadS1mQdbeQ8lMfYgJoxfR8G0yyr4xyXSSE2oAjtJbvuuziNX61594flGcWZDg/EcoIlSz+VHGYXl8xUns8qS9zlPO54xvDPuF/f4b3hXyrWK9rWHznf7ykv6EU0EQ+fOMGHEPHBxwBRFHlXWYblvK3oIAAAAF//qLVafViSb7WQc48TNAX5gFVOzC91JrGpZiKZFGwqEvCwUIFI2AkVZYtHrvszuJLr8yaO5r6M0t0cEKhYTE4fOxPnhei1GS4vvGvKvpqnoIcjbVx1fo3Xe8rizXKz7wr5LZg2fRvnXx8YplP58C9PfWmID1PXWf8RqW+P5YvkUP+v7W9bWxuFwyEWXkaLeiLuQw/IaQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlFYcyDm8NwnEnZ9GMPXiXtoTIOcw3Caien4Ye9eNWKz6iIUmewIIAWYFGBiMvmGRScdiI/JDPxQAIHMPhwzk1B1CJEKi5WDGPqqeoqSnOXBri4ZMkFB6ZmZDR4IBoxUbM5dDjD8ydTMiEl6iRMX0VGYSDGKhBiUgZCPodTCxYrIBU3SSM+B2hDASXEL0FYqGD5EEmCghigA96M6ZDhGAjqQxUE3QchRwFPtYXEpDQhvqybTfLARtniR9PfQFpq2Gig3KKkYZ4FgAPLuYu201Qy9fg+xSYdq5sRiKfsj1LpXfp9x2ibIWllkSilLUqSGYcG9Loch5WST3cJXCnWxuckrP6WtLe0SlEEt7RVqdls7Qy6Ht2qS1lcwps8ey38d9sd+VW8953cqkp+ryqSOuhcHnCGQeoVDbjgQECmVjLEKU6pjLu/RQAAAAP3uDGUp4WomXWjhMAr6cKs3fp1HOhW6KtLLTpv++KdVt9ILaAPQqocHZji0L8YeWJlhLvRidi74PxLLceQjZXF1ADpen9EbrsZZHArZ6yvIl/ECS1tL61qTCNnbb4LHTNk5qssaKuZq0WP/nN8tlsLqsXOPh+fFcRaa8aBjP/xbfwtf/7//3fOIrnwMsgb1SmkzKDxRa//02sJtWYwgK0aS1aHAxOUAMLTUFkMeLs0QJjEApMgAIygOysVL9KoBIAGKEkeIReEw2UDNLHOTZg3MhDIRSBoVBo6JQKbCDBo8PmPSuZSBYiAQoEFdGCgMYgAocQQM2gAHE1xY6osDBVBw2BSTQyMGBwOGimZMHhwDolEQ1CAG9COLMTAwIFQUgyIwBPsBAxgSCVu1kFwppNRo1/4IfNuypxIHlIKDL3UgAJi4c3BZn2t2nduS0L3w1DFaK6vV57q1qyhlqs7MNV4tf5D8Ekx3axhmdrxt0GmxqdhdRhkZqb1AcEZ03Kzd6anejPsDvBBUvhuIy12fnqSZuSTeefLWX43v/5zeOF/vN2v3ulo9ane6ws/vuF7XLG7wJripkIMFqyeXT3u0Nco/GtUE3uDBiAAAABov5HnKZZYeFVO0WjAsgLAiSyQaG5SumNK4ggdiEjHD5cz3D8EPXiDGUxEjqqybJ4Shz6ONLH8gUtHL+lG0xzOQxra4toTevjxUFqzQdanwWTvDr1irpR6rPazZFrfKL3nLhREXxiH/vWb6e/0i/+saYEQ6/38/7zekD/flx8fP3rW9V1WtLwgdYh3RkmNMjhOqowzEn+sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJbGbMg5zDcqlMKeFnLW4lvZkyjnMN0raoJ1GcvXjeVKqkQhgy0LGWGFwUZJKI0JDQyDO1hUzwl15GTgCY/KBh4NNACgFTfMOEIaBydwUB5iIliRUNsf884xDJxmFAGFh4aoHplkHPSTDkuMRGQgAZhYBOqBh6ZoBwCAoMEBhAGOgXcMGiMeIThGEQqFhqIwEUA4VBBWCREAgwBPUkU9wcNw4Qv0NASYa2JZEiurUfQdGCIzjP5PDStrh2k/KdjA0aXR0QIIhyuVhd6gUvn3jVrlSpYY1uxDs5Z1lCPgOL3HLhMPSiMWYaTbWRbmIj2k9ZcxHJVEblDUtb22WGa+G7LMqlBP1nRbbVh/4dZXO/hIqTCYmL+u2vzws8rfZyvZWquF21v7dbv0lXH+c+7n3K1hcqJLzONQqfI9N7fnfrmpLXXz3zxngOqH+vsAb36uMyR70qiltEAACbzBYqbSypS+tHV44NW5NrIC5hvhAuMOLhpJwaOjCjeMAJdUMbt2VJtelancMNZgOfzWg2Wwx8ZLYpaj9PlLIg+K46W1KCVSZRmZj+bmB9AsYlSabrSSmwwTsZkR0lE+MsyZIyZSalm6Q9lOS1qZuTwognJ5B+mpM1ROF1qakT2helulpFFBcxMrav97NXpVPddKZoooLHhVe2v6SAAAABHKWtOMvMfDVZi4TTIiMflA4ykznYINtF4wOFhJWGZgKkinw1gEgEx+NYCSABoDEIHMOEcw+gzbuQM0202GSzL7BMfBcxWIDC4tdMIBAYKU3QIDgEQwSAwxAM7AQCJgcMgAODpgwEEwLIAqRD4RiQRhR7yYBg4Hv3BTQyUBRwSJMkEQFlscQmoJbtO/lKvhOaNOZm9C5krayW71hcTrWkyzeBiVLGA6rixRralC3qNmVWrPP1uvYsT8ttLIswE1Wceu0zqOS19SalBPymD+R+WSnsph9dEPdiPKVrkD42+OG6tFRxSOI+QuV3ZSxGVxeVyCU1s57V7lHnheq7r38dZ2uY87lvLtLqva/vL+f/z+f9MxwoXUs2DB407YoOqJ7FMIlJ4cwyGKoTUQAAAAN8+OO4XSo2xhyrSwgo8CjP9a7CFdOJP62vqkq9eISGZQIQRtt2SB5uFpnkHtybZozPYFZ41+X0LUG4MdbvNPQzVAUzBZ6UBJE8kGy6YTqtFwvKomHVomEaRpwVm3jneclG3mb5b5tNiMl99t2S2uO9X/372zD+lzm9WV9KmB5xmqDHt63vu6Yfa39sUf+lc4x8v97ruPr4iE2HnSqXqFa3PBksBRXpPfRmQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACW98zSN8w3KiCenkZy9epUl7Mg5zDcqIKOeFnD16IAAAAHMbknBxAZ8KM+MgEjIhgyhTOb1zMYc0lFChsAiAxqLzAgVpUOzYRUPM+ZoHBwVD5hEWMDNPjwySijxpSN3GQSHz1A0JPMMioZAZhECCgiVIYAJ4IA6rQ4UlYif4twTCtMgwIBS0aIgoChkFoARADIfabF2aIyF2WgoCnCQmN5Dc++kYsOTQy2cd9dbrQLXUwZJE5QyBDVqd6CSRrLIEfRMWAYYqNxtXZzGt+eE43/G5yy3K6lduGNFhHmJ1InIJdXZ7ev3plukTjN2N23blsxlFpY3vb2L/tTabLn6sSp3YZjWEE08qgTGtRfcsZ3v/L93d8xqY/dw3y1r8uff5h+X979Lf5urj+v1vD9az5vveflv+7//7j////+PcP/dzE7J2V8IbF7z787hAAAAAz/3ofUeHzdNGtR8CSA4Q8IHvfJasa1cmGI2bVE0QHAuaDlAYaZAgFVcBRJnMwxuVP63eci2dnFjzryCHpt57KGq+F7K7P9BK5WshIEcc4sOJW+N+1M84u88WiIn3VB6riRgj/wqQqMPVODY9s4+9+udsFKb3jNo0mzuxaBbN4v+Yl/vzZ1G+vuvzuu861lyrEDTjor21O0JRo7f+/y2E1dZGWCwOhWWmHkAZcE5hNUmV5WayG5kkWAEXBxIMbgQwSAmbKHmAQiGGVGRDBEswkBRJuCEVGghgDACZUKp2YeGRhECEKLEFWwwUEy3oKE5hkIhQEmSwZOhUCAwGGGgAYmCgVGAOBQWBwwEjBIYMChUkACGKKwoCWNF0nZaIBAe7iXIQGXRLXM3adEoCUDYVcTnciLjJVnxGmiY4KGZQ3Fcz/xxRcGxDlSxOtJqjqO26auJWueYzpa0rqVIlKi3FelsQO/yoZZRZ5DQ8aF0oAa9Bl2llbU5DlyVtFcqrOwzKnqo7tekkraQTQvpcVvlMLgXPGM0M1Y5KcLPb1XHHL+4WrtPU329/9wq8Y4+oZUbRG/b3WxE8wZJZ3+Cz+rAwrndry+932t/NgD/PfBRWCuqHoxQKb0jVRA+HIcj8V5dgqT6jcudpOJx0r25qppaP2SAlz7udLq7YrywluYlLtxmnzfGo0xEtTqFrpLFOfulyOrDKByj0feHH2raiyR6NSNr6Ftja8LG4d3XltbTlc/7Y8X5xfG6LvW5fA9sVY1bF8m9f6zF+83lj6vTVdZ+PjH16XtnGNamw8xg2LscenHmbwMJGjg1P/v31AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACWVnzIOcw3KfygnUaw9eIcF/NA5t7cKMJ+dRnD16xvVR0KmDxkZgDDECoZgcgDEanMW6k2imzMQGZUYyCYCRYcI4ZaYQhEoJDnN4BQIAQIJLEAgsxcEU4TETGOCow4QHDDofSaMZF4WAQ8IjB4RAwzC5JHiKhgFAKYPG5CFhoohgbL4CMHmGgiUBQOEQjBisKSbzILLKh0LBYaFSD1geCxCDV/QNZfduyI8hla3ITAKJjfQzPPuymaj4hCv12WjDQYad1ZAGTOVGdrGlUjib+1KksnabUTeySMnp7TgKxr9ey59aYZBcm6OCe278fTTis5LoEolmSnUvf9p9LlR7XIkjZZ3bkqdbv2H8vU7824Zpbktys3Pod9zrbx3f3rtzDXK2NmxT8/l3nNc5vP993n28saudIQ3nLX6eMsao4dnQCO0pbpX/5q7/4QAAAAO/p6kBKXfrLKxKHYyEQ0iIbVPvYwac+o3CeoLNiOIRLwGjRodWBoQ80yQUsDyaVObJH/3L4gqjFn8tsabBQoYDALTgWRrLOO9bgNwPzTNWkXn9GyEPvRhi6xUnkSryvq32/1nENKdKVxbfvXwIkjJrNGreMW8UyolZH38DLP9UzKwOW8xa1rjWd5t8VvqafEegKg3676hZQESz8dnqVkARHSAIAuSAlEgBDAwAkzBNFM7FUDQUwSMTDABFQEaBplaIytoKodWAF2jFzkmKEO5n4MVAgwHeAi4dw/mCGQBCzXSpf4yABchCD4BFqFoWAGtmDABg40AApEQwAIMVCTBBGFAYlTeGhwwMYZy2jivCYeFM3YLcssQTifxUmiHUaLeXFyUINsMnMapxMUYq0OmPcDs+Vw7wTSFMRQB0vdnLEth83TVwe6n6sb8kDhuV87hC6A8IrXVuhsEQfbdNB2nzlRrLZqPdwgu1cPhDWRKuUISFhZ2FGqpWwKZiWgS+PeJbEa+aZ155tZhRfA8K9JHihIUPgwIjZgTm7psqqgmkBrtm4eFlKFN2nQQAAAAL/PplAYKgxraZyRwpotAm09MUcZ8v0n5II9WjqwDnvsR1cUgXCRYSYtmRN2cx9nlbvhN2njc2WyJ03YgJuzAUpHVYnmOusC20dRxzxVTeFKqNvG0HJM2O9XjyELm/125azdsiWpR/Zmt83rbfn3ZbmxS0L4khStc2KZ+6q+a2PaDF39WtvHzSl/2y2bS2kioblb+GFlVgUUzLKL6vlvKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkNccyDnHtyr4nJsGsPXiU91zIObw3CnCgnAaw9eNXp8swYxIhkYVIIxUkAoSGKgOYsQh3mhhAtMNCUHAIwUF1rwtQoiRiJQWARKBFLjKQJRqHAaBkPCzIavQVA6aMHA0iFgCUoQVRCAjHgoDguPFckAg8CmFBxgMlBdWMGAhC0wgFCsRgwGAoRll0LQqGm1X+1wUAYQBWoUVCFQ2mlKoUO4XEvxSGS2iRsYL2VeRhbj9N4hB/Pz8CWhc4bAOLMZhME+eiCPwsojyGkGWVus9XWIM2B3NagVStZtizMMSV0u8R0iSJigIGipgUZHRCCnVioP8nCCbFKkyDiPHUq36rLmXlUtuojbmVz18Y3W8kP01Wm3sTEXcSmda/+NW//zv53J8b1jGfvH+qZrn7ibKhxOnb0xgaRHb++33f+33/lv9t3Qmo/zBKJV8QgzFrTtUFJQ6oZD1nmSYcheGrASkrzSxVr+J6P89jXk90hlfSB+5C3SBqW09RMZ35a/SqslWWLKSWLkDAyHs0awtUN40ALyExXnP9Ks0SAGWhCAjWtDU5Ndvs7YYcTEFxc6M71TdO+8sf7xbM907uVzhPffHbWqPO6xrb91F3S7zd87t96raDq26akpbDMeFjaf0kzDWvFoosUMKglV6Q6pLpn9OWMFEAwvmdAyukwaIUtDCi0M+zg66gg4tgUdIB0QWVO6wQzceQmCQiskuWa6DJiPaZ4dGAmJpr4ZXymCqBCImYkRmo6HBgygIolUdMxAhAIFUIFj0xgyNUARkOLSl7xCTKaNPEYMIQUw4IUbYc4wwEBAwul5HrFQMqgrgsMpI+jlSQ/FH3pFaYZl8BNfZNDaacVdBIh1phhighfKVy9OdpsYZxFaKG8n+wlU73PL3MygGN0DTp2pLIV97YduHpRBmDlu83z9M4QQM9hmU08Bs2hmU36aZfm1TRNzlhXNgVmac76yGBoJvyzObqcs6x5yY5/N0lzl/6+Wvx5q/3dnHDtzWPf5lnhrm5zKrz+a3z8//X5/ljlj/OapbNbPdmbcbAoCYt1zXVsoUjv7eleg8GhpAA7wgDgSiZAqsyB4GitvVtzad1rbmsVhp9BYUQxYcHBpGauA1p3YUxNbsRibB4+RDha6nqadXtC0HgUJQ4J96eqH11QogZrIxxaJVna/OUh1uFJICpfm9SJLb0w+zqXEmkbpTe318a3HjYYLVrjHi/Ew8XHWvem7dgZ3ur/cGDExae1sXhb3ZgknxPRvqgu53aLKe1DBeaGvSUmUdXH6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJg3RMA3vDcLBJ6bRl714jhc0yDXHtwtCn5tGMPXjKZpAcLmHo4NAXGMGSCQwNxKAopg8GXUYwQmBCQkEuuIQ0LDgOzRQIWaIgQLlosqAQGWHNiSzG4M8RUP6TzJAseMDDjQvEYuJmdhJMLg5kFhsGAZjYUWZNfTzIBEaABoNMlCAg/aqnMYUDhB2RAoIBm0ZYXvDgV2G8UNKpmptKI7KR27Zm5PtGW8VA3jtwzHkRWax1iDgQuKxtkzivInoqs0p/mkQqzROi1m44EAsNuXIbxlD73FGnthL8u4xCR85VJRiZnngyo/O5LWQnl+nts0N+Vu1G6VpCJLSqZ8GbuUla3r+UKa7JHWlcCNI3IYAlNyvKJiO63unwu5Wu8qV68/ayp5LrmfdZ83l//+97r71vVjW99w/f83/5/j//v+fzC/uoAz7gIl0qcFwW75L9JAAAAA1rddN6DOAEWLGAgY0gFARpqAzXsbCLEuuXNdnczHqLYAhiOBcBQSQ8xxSlMEkSgKtSq42jGFkHEXJLmSIodR/AB9DBAAr7oWhQtTShx/nUFvSa7MqoU9mQNKRrhJxsfaLnM/zDtPPmsjrE9Vvsfu/Waa3uWbR122/jOd6/ScMSm3loMkqfWrW3SrNGpAf2x6Sxs1z4VaVexJ0gNB+yliBONTbh8RcLFm/zCZVNi1ZChsxXUovugaNeOkjjVTM4jaiGTGVIBGBuDQmsgQcFmRGIWKhgFC43DBCAgcFAaZvDJleLm4SEYHDgQDm7mQxaMA0LFZE8vcJCIhAZhMQkQVBJBMQgAsAAwmCTF4Kj6Kb8JVkwCMIhVsauk7wKCmHuQ0lvSQBJ5NmkcbWOEikZCZEEFdBkq8d4J8pctK4LNSH6ilEqFemi4IcforpdUwrk85C6Kc4laptu3C0BCm8+XUcd7crWatGIWUTBkXCUiosYaKMLaTEnP5tzpXk3NV+jy3m88Y0gQgb4jKFwkYYqeQNURvcaO7mtPHhTzaxG3Bp7Wb8Ws6rXFKbpX/Ocb9aap8ZtvPp/jGvT/O/8T0xClYIUudQpSj77OHyAAAABzmT+EBigjRxChuQec63DSyFWNT7rbxdNtm7WZc2CKMUIQABQBWZCINLejZIBy2JJmspfSIOBH235jFlPQ089bFCcslcCGI/iEmxGiqQvpoDggq9cyRO1pmU3YLcTxFssNgJba/1pltmFDf5pBYO458CH/q0NzgF4ttw25b3a5ZCZ0lcNx8zMlX8dqj2hZhPba3jz79p8wW/dXO2mIkBk98meDRE89fNIJVWN82sDtioAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACVppTAN8w3KcSdnYYy9eJSnJMA3x7cqoKSbBjL14qdbEjAYsFBjUKg5q5wMhJx6YcwLDwqvMlFDUyEaG7dkARUOgVBIKMSgbFTDgXHQiJEgy8dDfuTNHuoSKZigMK1gkUmWwQKjwxMWRIRGBhICgcDhgY6BKnZjYgCRSWoYMFSHxMHk6WfAYel+DAYLYkEAUHBQEBpdTgNuQhMiEK9wwBtcWgTCKdcx01vMdlQoKDC9sExnsbZWkG/cgrOxTulHmV1Ycbk2161YljX4hSyluEuywrZztOkRen0bYu/07hap4CK1S2TPw4laN14ipnHm9lHzq7ldS+DWJyC1bhydQWjkqdmA0xmJQy6ViUyGpMZ00/K8/zzt/lat426+eNPyXVdZb3ruH4/+/7u5z8bm+91hh9lO4XQ7DWy4ed/bnJvlH4tm6t/+/638gAAAAb3Nv0udbr+IoyAxTBwqsz2ENA+o0eje3Cs1+WQ+jcnQdAKuX6vvokDF0XsG6xl0rlMsmHZ9krwv9S13eFhVkrVWCVczXhnPJuV6dqpWTW94n9Y76BPfTOpp9/WH1odu2am73Ddv7hf48ttI/Oo1r4/1OG95Y2ImfqHTWd0juHpj13/S2N6zr5d4NuOP8lDCCcLo2WsMqSz6N4JbmeghjbUMAQUXSJ9HT89wsDOlPlKQdITVwYOKbOCQEgEzGFg+TBqULzMDjIwmSTS8ZPnsE0aOjVQVEQBMGANjQXOoYMjEyQCDVHDEpATPHgeIAKKCQWQZVERhQOEANBwEMAgYlABMB16GBASYFBKF6kyYEjwGWhBgEAhaZb6cz5A4BjwIY+hiyN0eU6pCTjABjXjmgEYSQnjBthOl2+USVP9rOBm/c4QmKtzRDEBH0zyvYI/2RNHUqlaxuPU5UEJTz87XF0YRfB8vGw3iUIaoEJemQXE2m3q49B/Ksw1wMyzgeL8gyOfJ9R1gP3+I3tD1CzBiRXrbmA5fd6Y3mnprGt7t8YrNfetYrrG9bzrW/u2aY+9WibhArT7nwX9e6GzrFMAO//05e9+CpU0ZWhyTyVVN6QUiBcV+qeYrvJwWXPLbxW46CvzAsARSw7dFXR1RyBVO08LTquQmhASwamz/iMFhDrwiTw8/w9GlO7kQRZeobMO9cOanUaIOOau2+NfJUIxy3Bhl/cUdv0n9YWYWVb99yyb/zq+q+2caQFpXCHnV4NzBhbhxomrVa9RYTytnKbMkW+dYvS3jX8ejbq1oX+9zOtewXgHytGKvKHFKt76AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlOdkwDfXtwrOo5oGMvXiVtwTAN9e3CeqfmwYyxeLeBKFkRiY7CmCAigRhgAFjEz3uKM1TlcoIFRg2L9UIJAgwpF8IEwmA5c5gQCBggUJqHC5jynBkaDphuBo8uIMAEOCVFAw6GAaD8xZDIRgADAMDClT8AQwl4RgSjDMCgIGwUAEAgECQSDAOGAJBQOodSgN0hQwEizqGiz16orK8TvZ1swMBFYwQC7+oo6hZSxxDmAZThhsZfwsySs5dzoJKfKyxN0aKpIqcb5oa6V4pzS9fBhs7xcvWOdvIlpSi00qU7O9iEiBpsUNUsrWPNlUxitBJ2FsPBYKE6SeRU5IrpF88hek0IYf5PjRSzyy3hWQZ1hXva31WJAgamiR7TvNfF8/e8/Xxr7x8fG9V1rX3vXzXNvmTOc7vX+ms7vX41Hq4s/zAEUw+c9y8P04wIdAaScjYgBPhsYEdBR1WeW/QoeO29tLaZ0AIjufGCj6cIm1brURgOUr3vSJvqZEuCR1GHlF1UIQzFrjGr0dBQg4S5clCPu15NJZIbTIqllkixKJ+3fnnGxmXCHXQlsh0lvGpavYrV00UNCD8uWt4pnMEk0WdTRPmWkHQKzEKFFu5Yt5XKrbpyeZitOG2LNeJFk3aWNA9XmHu6Red1CgZJy606vPEKT30MT2XoMiwGaUImDkRipAYADGEFh8MiGULSnvBRgLTTUYbJgJMVgkMCQHRCIgFMUR7NL6TMRg2MFBXMHAsMmxxIiJL4qVhQGDEEFTBYDDBkKTBQDQqCxgAB5CEYjAUQAiYniETAOGC8nQWACMGgPnjCQDVeRhmSSCWYYA6A6VgEE0fQuAK7mvhcCwUEQUABFqVjNC/OpkOQFEBWa2MYZD1a4wTkvO/ksxxm5/IpbvIKRJSLvAlwkFHM0xYGIRtoB8ciMQ8yW9nZ12D+V58mgdaeYzdFzFeLtdYJMoVWrTeVCqjK0bBUp0bp/FwFlaDlO452RxbEjHtmJiut+tM0esNNPs1zats/7/z86/xb1xqtcWzT0t75tbWd5xf3nwLBg+HxogOoUu1RaKgkK+yb5ybnCI7EV+uckogAKM9gpDNMy1ctLD5YxiIhc4yCVLEJYSAmFT125tsh3f6MQBSLaf5uxdG7NW3YgWVReI1BgNJ1q4AIHQfgeTxInS0hlk8WXMED2yyGL9NHQ+j0olbZpjOz2M0pp/QRnphYmZpX7gR/Frf9uNlwJaMJXLa2vzL+eHNYdQafatWrOR5Nup9avUAgc9TgSt/20P/H7kCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJkX/Lg317cK1J6aBnT14mJf0uDnXtwqMl5oGsPXitUcQOFzW3ImDzRg2dMlOj0CdCEWB0BBhboakCQck8YDhWBANAQRAIGzFhMDjgiDa85AEBYGCQwRFYyCFgVBNnSA4wSHYxLBQWG8HCYPAuCgYBALmGoBCMATBElRIbTCoDUzxoEzA0ERAAggBEvgjMoKlCRAYoWAgRVODQNbVBlQZEwwOAhGooARUkPKOhykEZjIIttN9TguwF423rglSUaXlI4N7dWNI+S00y8jog4GwvqpRMqAdvoZi1PeSYJcyK+qneVZEIUr1RMRzgx1QxngTAHgWJFxRZHIvsMfCfQ88Rri4H6OIgWTjJY1wnF9pub4Wq4pSS987xWsVfntDpTH3mts/f/3n3/99/GcV+PWl6axiHfG9wKbzebVMUrfXxvetbx/v13iH7Yl2GgpsdYsxvOOvKWhjgKOb9Nk40UaZBDSaKB+8Ycd+9KVMzDlTBAXVlY4VEwblO3TLxYGwxl0CpJypCGIEARlyC8AyitKUvotXdcWLKZojpJQ08TmWErS7k5LdBexoS50/UlT7ivi2qm1tKWDrMftWKfUT6urMjtiao6y/3/uYmX2+UP8CLzuBF2bG2LHjNr2rU9fahOsXo9anCR42zzvbxL4xe8K5pLI6SRM9aP9lfU2gVTVjeHQIRAMx8czEg6LdqqmOlQcjGaAJl4VBRhFNhB9bUuEDRNBQdA0GgcRhg5mhjCHRj6CAqBIOCocE4ymDdayEpc5kCC5geEhgCBkDhcKzAYLTEEHgUBYIBYxuB8wQChOsWAwHAcYOhCW2oUwi+YoAQCAMEAABQHLagQAIU/5EBCuyYJ0SXaUbSsqJFAxUCpBblcrwN4sQkyOVg0C8uAWkoxSk7AZj3UK7i0MmraqYmx1P5G4zxLJaIyML+MiFw5l9XCKLZH3GRQlWlubUOyrE4BgKZueGwk1UZS6OUx2U43G7eN4kUxLxdU6TVzewXP7zLdzzn214usZtDbFW/XT1o3a9dXz8Uzj4z/7/49vrH14MWlJ74pP5nk09M5haz80vrdd438+1t1v9bzNxDO3+irvaSUioIVAvxE1+HCBRm0oAISLOt1I9AsvVQA5BqVLRP6lwC7LpjkGjjE9XtXCwBznNmK7/NFgyXLYXJFIfkMw2NESGUm07UPeoYnUyXZRObxvno7xdWstC0LS1KSqKMhkeFa2oev9Q6Xww4JhL9x5YH8rrnbFfHq9pnGu3lii4ewItWB1GhPlZLChbs4Q613twzi09AKCLAAXNKY50uMDLf+2//HPZ/+kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABtZZzINce3DdKymgb49uHRm9MA1x7cO0OGZBvj247xmUACpQwYp0GwCugXlzK5ExwSElaKlIIQ2sQmAhlERHelmYAByZ+QQDAoRGSpjw8FRCJABpqdiIBhoOCQIYMnmMBAxKA4EkzogkAlzWzStBOJAZlK3yADKbwQ2r4KGLpqTU/ThgOjskWAS7jAbKlxJ0vnO5KVUzZjIlTv/l5Gpmz7FsqqKYeYtGO0GS8dL9zZ5GaM2J3sr5SL8OAz6Ox84H8r24p0tRSLtbRkedPWa3rY+Z1FMroGYL2avgzT0nvr6+frNbbxmFjdT0M0n1oUME0aHHpjpz/Y2jeMbkpgpQYWJMwaMVXQTVnTSoFQkxMegNFSwSgtMwWAJlsMnVk+MAAiAVEnQIhkEF5JOKAEVmDwIlbGBABjEAmUSd5PIRBQwyD1eNZviIAl3WVykveHAZQFNBNxtX6dWAIgRAlL5bzlrzCAFG5hRxjaIikRh0o9nSZc3FUqxhQBpXve/3TWG/fs9mOF7WEw6rC3aFlvjPp55FbiVnTA89ph26brKmFeEr7uLyEzoY01UWm9lXrNKOeOTzq1005vBktbedf+udZ1u1szgIJd//6VFSbg7axTffqCZe6pWWETboIhrAWKoTTrhDjkFevMDCYLU0jC0KwIEhwBGQmceSnZn4GgEILnWmQAAwGEygnxNO8hKLVWarTAA4DhXAloAgsw+FhoJKHtbEAIDg9DpbYhAbRpHuBhCDGLLrZStIvzOKVpjq4fYIBiPK5qdnhxEttSDJYSxaV66jQS8GGfyihXf+zuGcuMSqC5bIdq0jXhRsKzGNbPW0ka72yuOSG5t75dJ1YWUcdKcWJ0+nXSshL8V5VbhNj2OvxHrHbUX11mm9at/9f/73d7qHnHzv+v+v///////imt49rYzm3zmfRQFg5b/ZRe9TtkRkAijaniIAc4FZNXIkKXKBQaEWr2MbQfJREQAIx8uDyULM3BUwWGIbRnGAEMA9aDaJXgAorbUtTvICAEBuOPqCQeYtByA5J9AWFA0CiUwxMIqAFG513/LyqDKgTLstSCAS1lHtE9dE+11QFa0Av12wI6qgN8tS/KhUntBbSZJRPKre5fZmzDtupjWHM57mvGj7tI44cfaytrePLMrSPtIuZ30F06aVm0XN4zAwK5cvcQ1Wlmyq2uZosPUe9d6rTP+////a+5YOv6bzv/////////////7/+fq9c6xSCoaLsL+Kq3LO1NebQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmPcsqDnXtyrCnJgGsvXiYd8SoOde3CnigmAYy9eKXhACUfjMoEEQaihVGh8qjmHxCtUvmYZHhmoExsZBwdEoBCyYjAcZQ3oLDQY4isXEgoSBARD8YBgQCh4BwNhYVTRMbDBUAAgCDAYAzEUEC1xgYBhhILwYGokBadhEChh0MQGGoSAswaAEOGZZyAMqgehgEA0IQCBgAIcAUE6NKRAKAUv+uYSBxrJEAZgEALRWuFMT5nQ8ekeoDoXcHYgkyh7iqxZy5txy0jHZFVDYozKcoTS3pkQtzbbq1cOTe9TyG1OrdC+LVKYaIihErRC0NLqcJWH6mCBnSYx4qNVOmlD9FwP9cvSZkgO2sNDk7NAfXcrZgXuyZYYd4/+vm9ItnCmIT/yb1TO7az833//jGvm9bf/11reYFZIGGuWE+dQKRsMj/60AxYkT3/5i+HnA4z+2vjawokAZXL4idtwqtTtMSBGmqOUv+hc9QOYA2SgLuSrJCSrIIALSkzsDjrc3LUtcKKsTT1dW82dGV4XMYG/ikZVEpaLIjASeRIGeDhR+fo4W8esEzekGLFcoCvnL2tsdI0JhiqZPtULGYmv7WxNhR2MLf9dzb3hU4SttnpvGtxbHohN5mZ/Hi2bITbHgXhWcqN0Fqx30WelaX+qYdvFa79dbjy//XbvQoeF5KIVRGES34MCRcNjgqbjkpqMEgwwCJBGMTAaPR9VvJAKKCjMEANMbE+OkGDMZhBMCwNMEgCAIAmBQdGOwGhQIwQBYwJZjmUBQJYqCrWBCGigpgSE5g4CIAARgiDBhCAhgeIAKB0wnA1XgWCEMA4LgKkUBg3CANMCgGEAHBgIPgEA8miGAaMAIwBEaOgQBBQCmvsmeMnrYrsQjOA0hgj7LgmVIqI4ixDnN1AhKtxn7OWkF7GdaK1hfWi3knU58E26Gue1fetJ6xxzBO1L7VbNMxnmVE8U5kvX0F4ul5zMFD8TjSRileTOcTxW5keZcIa6nd6msz4g3turld0u4EeaHr/W8Xpv//4+6Y3evpbP99Y+LN8Hxd5bXGA25hOe92pm2M5vTNId64ixqCqEOyIwUVuLZ/BL+rCrojRUKbPjQVgVFhCipKcrr0ZNFjzAgevRwxJwMsw4SQZKX1ZYwh3lIqmVmT6aBKWZw20AaCchosNM9fR2ZW05K8dIfpmDGplM4IfAUR6gGTNjGMXrSolYtG+I+9jPaMb14+q5ltXEFdaPnGqa1r0rHsqqefG/jyXJtqJG078XU8XefbHvt3ub6YH1tX/96z6945Y8L38CmW0o/+p4HabGgmhAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIwXvLA3yLcqqqGYBnEl4lseUoDfMNyrMoZcGcSXj66vRGZArULe5BcoPaGmtILGCJ5nqMt6iiw4AjC4AMp3o04BAgVqYwyEAUGjQx0CVYTFYLMLl8iYpgIBJOBYFGTgWFQCFQECAIAiKggL5MgMGDMwABXkGQWTDkoCEKVlLqNNAADUWQMZCzx4UgpRNQXCwgJA4GySCWxFYh5XI01GfBrRSJaIeZDklQmBzxonSZdyQLxgYl4bRomSBuZCkkTZycJ81LiI3BwFsc5yKCkEziaSJSJgUG5KihiLk0dLZCFVEoG5YICcMycKRTHIIuPw5pEyKFw0I5z6BkXyTN2IEXi8TpMmMkiZN0zJdjIspuQUnioW0VIO9dK7JK67Mr7bvTQVstabmOta2omlOg+1FFI+0mff+S1PbGmWPLs2oh0sPSYKsIX2MHpHhSvdMr0JjL5nZTDz+iwkrzYVbrJWxxqUItOI/LlRhd7yOSXudaU3nDdNycn+f9eRCKGFBhY0xuEHK5ULgugeKJsTKLolhRwLPDIm1ZxRggQF3ai6ly0iiiQWTiNJNT6BsxVZyYQqOY3RwIk86STGCJ5I4asoxN1ooFE6YmZMObOmvuVDaxxQXivFmA4gZeu3/4y7q3/R+i+8RULhmoNWH0bCQANM1CfdJRYcLTKUseSACAsjUoMegwOKxo/1mmAIYtBDPuGAAUZSI5MPDDwiDkWZ4G40bU6DBRSMYEkwcAy+ABAZCFzDQGR+MBjsxKWjDIMBwPMQhcWEAOAxekOAYgCqvINMBhZQ8MDpa9gAyEzCwBT0XOCQCYHAAqA3SZ2ym+/Tu1J93HiUsYOyOHqsrkbZU/cJ3HlJD9qbj2n4ltnOmjSq9NyNX6LGU2J+GbGVaw0+Q9opbVpqce0/UZX1P0MO5PtCOYQfPz1+exnHcnW6OdDL6uBVmMLPy/T14uXTzcO4Y6pr9S1QZ1e1KavVp5BVu43LO88Nfz+5b1jz+/rvP7v/53+a/fP5hv+/+v/t3K7eu8y3Vyzz7jcxtpLSrr1VTRBKc2zEVbHsonKwv6NTRtbQEEOUWmUz4qETgNozeKQ3QYMyU3SnHzDIWUzUIgqHpdKksnhlTbMjXK3jAGYt0fqmemGY4XpFBS9PgoFY2RKguQtJA3jJ8uF9R01N0SiBTSSKROnkC4sgheT1n0kkGM+PUrPUW0k6zhEFkDTUQdDUiiOaCLCqka1IuT1qCRutIuKrJ1OamJspaNTpFFmKBjw30ngwE1HnVf6P+qP//qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACV55yYN8w3Kqa2lwYzJuIvXtKA3t7cK5rOXBnMm4p5oWAgLLGigKWYwSnuoB9wGQiQqBmpW40Lpcg4DMQFwDD8ycgjiLyMWj5mESGgCOhUeBAWBxgsXnHkSYsAaKJgYdGAgCi8jKYRDpkcTMMMPhMgFZh0bGGAQVAaYZHosdUxlUwoAx0HIUs1UMIg4YEA4kDC/gcHEbE7hgBKXSJmCHEmDD+9faxK67Q8IwMwVy9s/nAseiAwyU7opyRUtqf7AUTvWrD+7U0kO+X87j6VoNVrnIctzTycilWep5An6y6WQ85UAO45W7cck9yKz05ZuxGGHdlLkSR2XljVqWXtdidqTQ278GPDCMrO+6xw/O/3cuxrZZzcs7IsMrlflnLe+c5r/5h3//985zv95/97re9c3j/57y7j/57xxpcLmXas74pjJ/xb7OfXZuz8AFiqZzmNEKOo+R5fpnUtSLRhOdtZGBjWu7nobW/WXWFCDtcgJ7lDxI6Mxd+HxcOESBWhaL1LkkUCYNzpZFqcGkywIp4VEb6PyaUNPnZmPIhSGtiXklniXKQFOL5ss+kmZjnldb5opR9bGdEuLIanRNtbKJFZFFLIK90WWKwGXUDY1OlV1qZJVBBFjRReQSNziLJXepJZfRRSQp//rUicaclP/7q///+vXD1CSjJjScCpphhCpmwVIK1W4AE3Hp4rA0vC7gwIppgjwPEETFgViSFQUKFMqcLCRkj6FRkBD5kbCd2TXy35gYqCAEwoHMhBASKolmFjpMOEKiFBUITWIIqGPhA0MpiLFS5QIoAGmmHgCDrKi9IcAqJqxpHMHSZTHVy3ENWbxzMipLCChLQbSOwoWY0jvMVieawaWLskI7pJrLUwmzlCgOGmRSO4qjXCuUqfR7f4FoLWeAbkOM7erpSM75hTsjLH1b0bUPunFxDUr5KvsuEZljMkdTQ2xWuC0o3mJX2ZY8tdRG94/lRuo7yXd71tn3xq+MZ+7Z3rW8a193tuPvWPr/6384+d6lvApiZnkbGVykfwNF3bZNp5xCd61QZHTzgcgKBmYsbGmqAwuEV55/JAnfHp7dhubLZW5YqsT6kQCigdhWhMcfVplaSKCq2SpaSoa8vkD6qFfHnbLoLSYooO+WmRQ1EH4obgWBi2uGBMplIzWDYceDc1Tc0WaH3QU5SQdOYVym5DD+aKrQUW0CbsQc2SZbrHUFWUdLSRs+s6zJsy3TVd0lqepNSalm5aKBOJonD6001dfqnKJCX/u3xAK/2NS4Wd/1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACEB4SoN8e3CrC4lwZy9uIvIPKA3t7cqmLmXBnD24pZeWpMzaC8AiAgKpngGBiAmzgdZTdCZ1iACQTCwDW0YwkRmApr8LmlQEFxIU/oNCjQzSoFIBMZ4CpgcHDwFMBhlhhVDpMCS4AcDkXHSMQEYIOwsCU7wUEgwIkADlK7zAwAV2Ag0hLUgjarC2jO2dluWwtdL3l+ou/a9VWb6iTqrSARl+o2J4zWZQ+X8DeLqWrzNVLFjzqyOIPEezZ+n0CSPEJi9oXG8HXamomQdMJnka42G+RibIbyK1uTnhjVjPNO5v39I+afxYOm85TxnV7CprqanzGY4by8ebUSWDmJAgRNVfx/7//Ovr4+c/H///+fr7/+v8/X+f8biSQ7bcgmQeJPWo4QKI17pBwpWO+pA4cp8xDaLgYVbmX0ndkoMPT0qiMLe6FRVAcGgwyrE4MTbo+rXI7QxBeL8oFpmy27FYDaa20Ypowm/KkmU03/pLcsl9SLwAHNTUs/EeaPHqC8fuDhPB1BM633vLfTeMv8/s3c7YxXG67gSbUmOoHLHxmUzxfVh4xb3p9XzfW74pX7p9ax8f/3iQMVtvVLUxr6z9e+b+SlN6pMYbb/b0/97CtP/puevoyCVVyIQcyXZPMXTBCswoHMRczNiuGGnGCCSQYOFTkcw1MEVpTGKAIFBRboUEgwJMcTDCjYAKgYjCSUAhQygBYgiq3UEAgGSUIzDwcHMBiYiIQchIgw3aqSgqipcdTVhosUlUBLohAYsZ/EcV4JqKRLlLQVOvVszSxeNikPAtz8KpSnCr2VmYngQBbz92XEl52QzIDJWHDE8e2nfZvNFgboLdXC3u0PE+BBgw46cZnj9sjRTQc0fuIrIjc92hk6qXFFbCgVZrsbc23bTwcF2wq+eVWtsNjV7qa95KQH7epVbePFTLbMrbNkl/jeMf/7x/jOcf/+2s6////3/n/6pWHqKs6daxh1e026Zj6/1vDzfpAth1nLt0w1E8noHLDrEfptloOVT/G/pm9a7SyH2UyyC1fMvIq2oWnxffaLUsdbs0Ojj0MrklDPXMrMIgerIJKXCdtULHXivRuQ3o3IYgpZj9SPXc7qEBpPY0CldVJ/F+bd7emu2bvpx7LrOI//ttx0n9YL9/jG8D3FgivY1Ma16Xj2pSHPSla/fzi2NX9d+laSQc/d74+c6+v/i2IesRr2iho4L////fvJt8/asAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjDhcoDfHtwpouZYGMTbiUiGyQN8e3Koq5lgYy9uMpp5zP5he46FHFFB8AGYYEFUjNMKAcXJDpUK2KJMgNBSlL9XIXAK0UiWsjQeBAGMGgQwsHQERTCo/MRAUIF4AAjqx0QhJ/E9REBgsCTEIYMPgdLgMHpdJWkvkgcg+p52TBYBelsijJECYDii73weIYAiWyZbntjh1DHqjbUUzBQ2EsKvsvqBTLES9aRW+BCcXZyzRr7oU7NaHEzNGwvMdxJYOUarq7vfZpkPY1wdUzHHqww04fCilQ5VYUCvOtqkhPTSamBDW6RqVcZqSzakT9UaWUZdDMyu3GLOzv1qu4Tm6boW3OeFnVcyZx66+/////9a+v/8Yzv5xjH+PnOfv/Ncwdd9mlour2tF+s0+bTbvCgZpW9pEr193ZOEVPyk4xCHCoWfLPShhFLVq9QlWtVHCgZsdJDzUUv2nKyN+3Kli0abDDlh4Y0mi4kCSOHbTPJ7nyQeKttmr3N9agC/bvwS2dQOWW9rN3OsiFvLmSajlZBDJa0VJOiyiit3G24+NNDWyZblROWiq7NsDwsxuhU8yRUgqaJmTOuzGiTu1FTIlgoGCJ5F0C4kgeZ0ktdS1spFs641f9f//zvLcnF7F6la2zTHsWERAbHP/J4A+UaZkBwPHbBy64yGqrskAI1OHvIwQHF8F9EbEqm5sgcprpgsBsQJAEYKFhhEABAjLmIjEgPVuCwdHiiFQMLEwMDxjECGAgIUA5PAwiBC20RFgMFASMgws29ggE7FRCBETnPQOLiyxVBJlnC1J5PPjSOp8JAHwvHC3J+TZ/CPucOsXsGXzlon0bcKJcIaw7o3/czU+STQCyUTIEKhP7T+EKebjGdhPnFQNDNHTp0qI86nlEVz9fPZPSq/MFRnarXygcB2Ob8kYsJLCSlIYEQb4y0IJmhrAr3BglXcis6mYHllNO83O8Z48S1d2z/6a/p/8/4+P9fWtb176xvGvb5xeHm14d73w+tPfc9tYpv1xrUauIOLZgb1IPHNK59oDTBkybYgNFSILK0d2oVI9LMKyYN2xEaHOGpu5XAZDT4aS3cWK13ZxeV9ItZdprsmeOrgzKDr0Ew8LLkIa6UQHftxKxHNT9IJDb7ZvR7qWCIkyyQYNbQUKzveu2f4rvXy8qz4+K/f/jd9vLM47/8NFEtplv1qvvaD6Z3mrjBffefnEL0xZ7rCSdOERKvYcZ9E3qmdfd8++Pv1/8Igfez///2dlwqrsoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJfn3Ig5zDcKvruVBnD24lWh8gDnHtypcvpUGcPbi86BgEunAxgRANDIz++wQJwCHTAgyLMInsLAICZg1MFFQH20eCwAB5cpibwKWUiD46JAcCi2pgEJIGAUAAgYBAJLADS3DACs0LAkwaIjAoGAwKMLA4aJyQQEAhhMB0Cw0mWgYUDYMCqWRgIHMIT3UxjcolO4Yhx233hpxqd0IW/0eMYbDrRh6fzjgWNfrTNTtPfxl3Gc1L1mL1kPre85PrG5YmsH5Tlh6XMRhEio7NA/zZRIN9s7tuZK5t2HKsQW6tHHJJRySlljis3itHjT3ZT3FvX8azFYypa+7yrZUg+6EpYZrrB3yZ/GKWxKLNyo7tWkge9N1aanudjlPUs2bXMsN/hhz9Y7//////7/6x1rnO9z/9/r+3fu9o9RbDHCh3lv8eY7slzI9xDPjBDqYjV9YATBjBKGDDVep7QeTBX+wzVsSpKO5KqK5K3Jl/lhplLCo7HpdTw806SZYQcwRn67X1hNWeeB3JdPQSWkJE2FN/5BtmOz8xBSBLdHZ1mtYUICCl4t9bkwfsT41iNNJi+rejDlOuP3H3/XETeK4PWLTN5orYDTZ7P7x7Vte/pqWkklHVL0v95zu2Ga8BhYNqJ65pCI1wq31//6brXF/vXzeDDOXbP//3Os//W1lG4AJc4wgk2DER6NPpQiWZhcJmCQYWZRdCwLBwJb1zjAUyOQHkwCEAghuqRAIuu0xQEIAIVChlwRFQGmKAOqQiAZk0Ep8vMYOBClJfcVCJakvYKCYwmEA4FO+34JAbY2WIiNxIkeqZm5g0FAYMvi2FgTzzrJ01BIvOvPV/p7c5WIBUckJdsrmwWJGfWYVtqR7BZqI6r6OrNA+4UWCyWrGc1YPMgpMox/DsWW+DhcqE1CZsTOPsv6FQmtQQm9XGebpIGcvLeQkm5OmxugOqrxYkOaRGVbCN1fRKsUyDZkIPNjUB+rhXwqyvE6rErGd5hXfeesDcNTvVe19wpfNNRNbxj/////X/+8Y/////1rb7sVZGulJKav/n4iQdyvrSV17/3xWa+IP2jXI1qpKQBh6MRrk4D2QM7D9SyPSKg21Ve12QTF+kgd2oJSsCZRK5TTNLTvbBE7HJ6ekkAvNWu0zht7T0r4DhSUO1bIYnpb2Gr9x22t44c3Wur5AHUa2N23o9nVNfUHWPfF89a5mX9YmcfGJZ0r8w7/4hvi/gRn8Cr7+2vvOM3hZxfdcZ/9dek99xq5g3n3TeYN9X/zr53j//Wt+mr51HU6z///f//Tf1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACUmFx4Ocw3KTCilQYw9eJZYfGg5x7cqBr+TBnMm4ljLzCggOQIcwcCjF7oNlKZK5YxioJpqrMTFZCm8IAECN8EWwABAOBYkAVEWXQAnfiYZB5lYgs0AwVacJAUwSBk7x4Fr0VOTAFHJU62iYcKJGDwi1FK6bZW7aEoCAMx4EFpJfCAWoQr4UcgBsDzvAwAOFkhgOWx6e1jTzQOkySI85aq0qJ+FzXMo3jcrTNqls0zk206JDqYlNWP4uNDEB0sXgt6nhcSpZyryhsgYOfoVzwNDkuf3VNLJ+Wtwlz9s9gCJu18psUeeH3H6fZ8MItJ4Vfjz9P220UkzgS+H41RSCYxu0tullETlNNPzFDMZTtrb8yn+3rP7wz5zLv6/////9b/9b/+f////+v1r/ps8p/7eNjf/3/y3+VrDV/Van13W8NY1iiZ/15caUDvQ+BBkD6B+37s39U1Xanbz4z1ucrQJ8tdIH8atPWqWS33vgy3an6SOz8uor1KrLLaflOEOSXbdLZU3PjssfZ7kyzjF8bjwIILHNNZ9rHfF3/2++s6ia96ZQ+1ZL/WNNzl1FTTbH381ofo6JW6JfVL/GfnWsXvfFt/W/861revfGbXxOYNs7oZIsMobd///0Q4j2YKcRhcKsGMcFw6EqTAgGMJkkeEOAqBC10Bp9DgGNB1g74EDHBAMLgBfZMIUA7sq8L3mDB6bbHIYAluBcBgwAgQAAoSIBkhigFvkPA1m4wEjAwGL4g4LiMCMJL8P+kqXpCgCCg5ZkXZFAawBPKDI41VbrMBUAmHwe167kyqyjm0C6hspRoZFK20bAFBY1G90Yxq6dIlsb3j4hXATn12YvbZZPj+fC1lsDeMdJF1RuvVfizg7jqEgQ45nTVEgJBku6XBvpewuQvw8C7GufCHq6WsFTJ8xTyQ5J52xs8ap5oSyj2TTjHiQV3h42oZd68tV7VtUuWGWzwzJl2o3F+32hWr91+/9f/1/zj/+33////8axHkxekL7/xrxvCmrm1ZrapXO851L/JVSYKz9Rd3qgXSB+zV7W5+raw3xpKn6eBcZ2w7VpZCAsTQVDDcogaffdljRoVHYtdi03F6l68rK205TQyVoMBTXWBs1pfLYtjabuLM288pkpjImATouHtB0SAlukyzxupSB9SSlrGVRpltOkXC8VIxrKKBW9YmwFhLhWJxe+k9TMsopGKzZkWqsg5xkz9aLIpXZFn13Sq6nrd1rzBRfZ//////UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdhYMcDfMNw86wY4HOZbh3phxoN8w3DsC/jgb5huIdZgOwAEDmYGP2BjA0lGtEiKYHgiQu6wIGAkzXGzYgBKoaEYOFga60hhhN93zCARMni0LgFSFdppYCCK610hiYBPYly2AqA9ShAE2Z1oASEFgPFF0v2LJoQg1p4NBStUdVns4StuKqIQQmu1JRzd61EYJHO0sIps6X5fKalXWWDXseWMWW0UqnZNx68uxmGq81qNZs3hpgUilclo7O89Q0ksJNtSh4J2V3JdM8tUtaX35l4oan22hqYqY2e95hjVu3KGE/nh92vlN3M97s5/b7vPP/3U3rl/8t/EqSQu7KwoRBEiM/0f7Wa7mFVvGrYI1EYICCMwXmgOXjfS4OIvV9RRnLAgQDTOMvNoAElDxCCisFRhu9+2KgkxAWDAJaDguFgA+ivRQMF/0llb30ZI4rVFY0GEqlPReWNVDgq3jukIBMKh4qgEHBAud1/l9T6/rDxocAAEJ2xS2LMtxzlwUktyyksa+ZGS6LPHG9E5yxYtxOfoKiiFUgNnLP1Lca+T1IXfXDCom4O7NJvtdE02hIyh5D0C3bluZu7q/KZVWd5eUac5ypJZnuWr/Ps4zN+WX7X1u4W7Uzyvj+Nfl/LGn3vPHnO6/Ctn+WFLOVxQiIUp/b/tYpgibnSwuwc4Pm4fkLxGNnQK8AoAmIx4ZQzD+XK0bjjYVkCopMIfkyWIwaGXMUsJgHHlUVawwEmDwMZQHSP09B9p4VMXgQyJg04TOWxCABLpftoEUdAZAxQE5HBCipk4PDghAweDBO/NIxSeguHZhEMrJjGYFvXaGbjO4aBGo1HcIzy/OoS3Xwww49tS1S32pU1/3ntyy1WpmKzl+mwjcklMEz0bZhJ99yoXjQ+QrgZsT+WZBT17/LlqdlVBWj/IahyVU8altq5hX/m98qRWpUxqSrCU2c+5ZXPu3eXK1u5r8qufMr345ZV5bSUtPsOgANWf2ft/vA9yBXribdjJRgBhhck0NXJvR3i+k5GnjrN1Z4KiMwh0zI4fCoVgRJAeAcOssjTADAI0M4F0aByAlPGHYpcQbT2hLV3HkiPKEl+1YJRHImrlyJ1+QcmSUGl6AaA1YF1N1flqF6BFNzFANpdZ15XYlW9mP8ovyiva5YL6SipU7nHZH+cw6lP2ga/cChqftalwpolWuvLJJp+pfDc/9a3V2tgD9chHZyJDOct9wynpZQRytDOoPjkcqz1mjuYXdWO28e37WrOWVSzz7ffw7urhytuY1um53G/jzeu7pQRPnnO/o0q/NMVOoPGnjBKKipFQusAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJBWRFA53DcKfpyPBnGF4jkZcSDnctwp+nI0GM4XhI4LBcybOTewZC4ZMtMQHNlMEtksZkrWFqF2y8BhWFppgtZyeIJhuPIMCtwCoBCSSykVAaApgcAQXB4IE8GAInOgPMBABAAMOAAQCKwTqkQFsxHgTGABbEDgLXlGx4Cw4FXpR6LAIGLYzgwVwEEZgkD5VANUaNkMMvZhDYUCUOKt1nff6AsaSHpVfQ6RTUzGbkw/iU1D2Yk+D7XZPDLtvX2S4oOTJQ9l0VsLHe+cqWKeAXdBRn8d6lfO99/J4U5j2Nb7xKhb12IClde5UwnrcglT7zOD8wVXj8kjNelr6fbnI3F5FGJXHY7UuTMxEp6ZlNXOmpZ61TUf5ZZa7hjzf1bVFDtST3bdi/lY26tDrVnhKSYsf425oLQKdzIxosKiNMriQ5QiU3ZgQkVTuzd7d5q/YYMixGH2qxjGh4qmFwm76Bqq7WoNgu2mSqiq6JNful952HfnJ0ccyZ+5e6AD6kYPqFUyyRMq5SzcRoAM2N9tZapol+ABG1HXM8e0CgkH56y+epPs1WO/lnVsNWoe2aXfN73SV4ru9Gp3LX6tLApUWqSLW+Z563r9b7rf8k++83v9f/959SjEzxRgjW7d0GJUJPMJ////64MQXMsT8wOGxEAwqkRJ2t+ZMDLiNfSRmG6hYAGBoWGBkgHfoRiAdTAEHQCChgWCYiAYEAOFAHAoHjgKGDQeOgYFgKu5b4qChdNiLLBINn9k8MlyEt0A5gEDCXbdy94kDq+FhRkDzD8fjAsRQMIZgmAwcBSfDtstZpDrcjAIAzA4Kmx1nldh4pM7TTGqm3Ox+1Nzt6WQ2YiNqKQXLrbKcqkukaREej0qL+tjMBlT07DTLHnzlMIgqF3QUbJ5cn492G7c3CB0k3xEWyoaFA4hEY1QYXLdmW2KWWfLa6voem6eHoz2vytlUiNDDtitbt58j07Gd1s7XPpabmOOW53G//6/X9yz7a1ypV12pbt6wsDZ/roSWb6RUkpP1byWuLykAwGiOEik1eWoPUe+42+eSmlZGETvP67TOZekiWCTfla+u1rchsS4LgFgdTmOrOtp0SKKw9SS0RrQLSTzpC55YQEvgyxs8sbu5sZrQ4tIStNSyYuyinpZuHXZhdmht2a0rWG5hewpWY9ld2kh+1/wfQITnuxpqb8/ym7W7W707IP7hjNKPC0aRuTxVd8/+d/v5b3uZmMO/rP//9f3KvPPdCdTyqkTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACGZjRINdy3CYKcjgY1JeJlmPDg37TcKtp2MBjWl4jbHwM8Bb5gBj2oCgsQKKbgQVLH+Wg1UwAAAxVdA/bJswgJExPBhCMwOBAQgKLBkgYMhQYMBYYfiWYHgUXAlKRJgKAxfIeExiwQFyrkkEOC9iYBF3p5vsRAGYABK0UvQrscAQzID8wED0mKcwJAUMAtS9N1b6w7cn6C4LmKgPpHSFrk48shZ6308V7FDT2wmRV43DIcct+Xcpbkakc5QR1adqSRxYaNjjzvxr2Cxe/yMuA1yGS8UImV4Rq/UoI0+wq6cxkMjoaer5xmdtV6uNq1dx7lWpWOTu5i121zvcvvZ2W0w+lke9VtduXd4563jnlzHnO7/ffx7+GFrP6+eP0wmF3CO7V/9H/i8VKaalOQlRJm4Fi0pZrb3/O96QAxpBAUYjj9wXGoUpSX2Oo8YdLHmmo1Dhf0kBw9Bq1Jx+4Hpb9WBGxJd1sGwoYEhwmDhcsDkLgiq1LPDWE6l1ndAokXMhxBBYc40KyTLUFtyu88s2LxfMyiky1IJho6CKi0lWZFMvuKBPojPl1dTENDPgGPJ8codB5lum/f2IKtdv+suTn//T0A0PCoEYvPGJhTIxJBAwqAAl5o3imhaGAICl5gSAcGCSG+axYdQGIIMDoAIqgHpqCwAYQByjKYCIKBgNgGGGwAqYBIAwQBkJAAF5QYASpgYAoEK6ygGIRgIFABpbkwBwBZO9RIAGFgACzIWABDADYQvVFsxLQNUsRIP8wBAJjAfANVochfwIAAfAgABBAEpMImPADPlEoYg2QyyTkgA2KZZErcx+49HXiHkKUcRh6YlbowuQxmlTecl38xoyyEyJNNarQEwuGsaeWN2cmVlqZHkShmuZzkBP4tMRFjnBVwJbvc51unhVTK3T2b07zsvhpy6SajW7dLSc/G/auRpuda3Vo57Kre+3vdegq/jnzlHXww1rLf8x3r8ufrVbPl4TgwAjZZSHnHPdt0LZI9yZVcilzVO5QiJ8ZxdSFU1W1/LueFeQFHRm8F3OxNYBl4UAkCs6/EaMv85kMuPEQEKQ64volbDTcKsAbl8+AEC44Kn2cFBwQNC9TCwwy1hVTd6szFwguAjEgu1Y9jDFuACpiVZMy6bm7FKIB1zPWG6WR2JHNzk5XsNDmC/l3vyO3hzKPyOgYVrkA5a7SW5a8RFKh6dnZ3WWX9/9f//9aB9frH////v7sQLwKPf+pno+9mkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAldZUMDPstwqmnIwD96XiM9iw4Mey3ClKcjAM3leA49a4hBOo4IQBq6gqCFUdRWxdzvo8LTRWAgfZrEHoGLuJyYFAERIAOYE4A4JAYVmDgFCzpgngeAITkDAsg0AcaAiMAEAYLAKloUSTAhAdDgS0iAcCmicPASM2YEo60lDmBQNyYAOAnAMBIC0w7gtDAoC0BQiY6AeBgWlQJwKDCQBbF2lgAAgwZAUE0Ykre28GO5K35Q6m+WhC+EOMTZ42BqJDYsNC8nXnCQydfmQMzS9g5grTl7tzNYdZt14V5RWmty1whYpugWChEELbXrJYpk1piArUeKbxOaDSmvR/s9lfzsd1elurubtS35u9le5u1ewzqX1JS+gpb/3aajp6bDmsK929nrHHn67zf7zm7+NrHDmP9/Wfc6oAUIyTWv1IY7sfrUZVoZTamYQqdMBX2OqkLce3z33GCDHSdLiXTcQdRPdtUpRIAO5IkrofXRPOC7QOGYZbNGkz4m5d2UWpHDhIZDwpO7WkjuKmQ8IFt1uxZd0Cv/FHZGQAY1Vpl1n7GT9SFlJn967a93dHejSLa3O4auNGwlOdJLaCOV5jSWUa/Tia3huv3qN9/GCbeP1q0cXmEBpdH2w3udx73/7/9/5nLv//77////UldVXjAwj5TsRVuqCGA0IoUEIO0jcMUKhknnehyhX4lExgwAQDTA6BWMs0sI1QRlzCpAKMBIAqZg8eAsMAYBEwBwFTAgAfMI8GcBA2PmCADEVGfLmJABVQjQGxYAHMAkBBnJgAgNMNT3FAA2QxoCABwPDcfEYFBgIBZmASFMEA9mAqBOpqPANK/a6FgAGqpaEoAJgsAss0hlqz/OdJmRtybU5JUz3itOG895vi2a3YPob0wgvDj+vTK5NML4cFISkBtC456MqWyizeuRqOSgFBwdisM1DDDc1ARfYb+TiTIRCU9qrMWKLu88McefG5ZzCk/erWvwzw1E4hVtZWa385h29rf2qnK+e8ce3cf/HvMca139d3qvgRMHSTXKlau7rT+537Q0XTogC5fHX2tnuZ19RcFEgkuQ3EIq7K8nqTGIAA9QMTJYFyD2YYDREno3u1XUctkVRwobjpeoSIYfuqpiyUFQweHDEASGWstjr6tXISJHuDyO3KtO3HJ5z46Ggp27fsZTQiFlP2b99w4z21VaFnnahunLq0WNxtdb3qIT2SmknwmpdznK8agUWcna7wz+e+fvL/5+u/jOc7///////24VJOr/d2/rAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAG807Egf3S8O9MWJBjuW4awTsUB/dLw5+wYoD+5bkg46GM3i3gnUWj29rlYNwQ4YiAwRA+BiFMLeQNsDcBRAkgChYDWdKVCQAmBozhAtgUBQwBSEBVOGBPaNBCWACBIEhgAAIVHZQmyd/W1bSGQCG4sFr62ElQCKgJD4OERI5e7EJmJsxhmu2plyHLUof+clifldsYPhRaUTMjz+UgAZapMKWWrFa3DNqNrdvxGln5QuuAtuguKnqX8s2/oUFpDWTJq65d21x24YgaGLFqtW7l3+W8MtZ/yQ/+8Nf+X/+HarVuLcxBRi60tUCLAyaGCwIhkUtsWpzEqV/6rP1tqjQlO05P0OS7cvpZmbpLUEOGKAcDAbMYg1MkfwN7j0MPgVMBgDKoNjwJKej5g8LxgMGhg6G4QDDZ14QY2wQJY6CJVAMCAcGBJiQArF4bYa/i2BCGQ0CcMw8IwFMvQaEYiA4VjDoPk7K8UuqOsVhaVhkKALtU8Vs15W8M+xo/IB4qERDOq9GBUHU9TT03OZ271Z/2JxKeghEWCRHHEJTTa39PdbvK9JA251P2irXrs/DYJdAZUDravtAmJjeW9/nh+u9qwxvLeH91lv9c3hKe/+G+61Yz/DDD8ef//z/1hvv67njzWGWsbnilV0UMb0FQW88SqEOXGi9NznGpHpl4jAADjAINDGcVjEVDjUGQzIwSjDkWzBsHE6XeZESAKYzgkxxHGHo2orJSYEk3hIB0CBZkoAVEtX9z5bFQsH6p5A+skMNgzBgjCwYmB4H1H+YRbppmKxga+Rp4oExj0obnYes5BN3qKRUdmrL0o20zsVK0DTPYfoWpSqQWOZt5LeZRrD71R934mXBna8MU13LkljkRHkEYl165SVMcbvc94ZZ8wwk/db/nf/vf/V6d0XxzkjXxQVUAQGQEqApUFXqV8vT/6f9SGDnIgV4I8XRgL0vLUesiJP4wABIwCD4xxGQw/QQ0HrUwGAIxlGUwTCQHAyleyEoGsiQgwJBAMARZytrRmIgoLBgB33mg4D0WEFka3gi78u4OhEqBvHmIAPMiA2BAoBAZmBYBKRWKzmXtUgCOgQLDCwNGu08OwmRy2AKV6gnJ9Jdbz+joJJGpm5Y7DkzdlcZZFWj8aVHFwEI4uXMOcqYyX8C5U5uMyfdrdLLxAqbwFd6l4yCkmMeb/v67b5qkjOGucx/X9/n6yn8v3e/nd/zes9Y7//y1r/5zHDPKxv+ctegYe3zyfOs/0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAKDoHDgx7LcIzI6PQPVFwn6gsSDHtNyjanI9A9UXhW9kUqISqYILIqNEbjGnEazaYmjoIAHzBIAzBoFxIAQYZxE5n3NJmUI0IaWBNxg0B7g4T8wBgEyIBgwXADCYKVzVPofJwMoL/xsSAabENArEwBQCAPZMYIYFZgLAOAoDgYAKMAQAWBHpuBcBowWQSxCFYCgqDAgAHQHJguxAZfV82bkQGZgAAsplPE6kAv6/K9HJbia/COMMPW/T+wBFBCK0ekjNJdbFKrsqi6QLaQ6+rTJszzJfOy2W3rlLNNxpHhBg8ahhVSNz0/LJTATaH0LQvWgFb9n/xf78YeWfmrGFXtlk2d67drVO/jy7nltqWcrmZfSW5XrO7YwjfKmV/Oku6z1bw7d7V+f7y3OTFmYlb95ZYY0cs3Xr/njnfsY456/Lev3hr/y5+e+55b/963/67nr///z/WHO/bxCJjayk+gAEoAACRKoFCEopIK3+5qehmC2fAosLYLa7F8joIKBjxHmWxh0MYpaL4PE58cYPlhupJpYfEKhzjRES8DCpAsvBEdBACJ4WxBE2Lg6xzQBnQ7zyB1aiYWWAMeWGgkhYzcUifUyUiKaJ8zIYtkxk3HlmWaUFSmbojLVmbeYFAHCyLokWQv/+e/hXs///6Vb4bTUWq5RdUFFgWAH8R/kbT3geMviX2YeYAgBZgJgTGCoIaYsgpJj9Ipmo0iIYHgd5hECzGJgAoYfgPhgJhfmEaBagygdJKiHhcxX6lbKluAQAZRswBgFTASAZMB4DEFAdFADoYAUYDADhgKAMFqTApAqMAsFAFBYBQFhnVeIRJYacU7Y4YDIFjZX9i8KYi0ZFdt13gTKle7khmoco5OlhEodktWFMsbxl8alE9DDwUTSX+EBWHZREmbz9NKXPduQUCUn1EZoq/9LL3retoxbeJOy7sYZ2y+VY2MLG63NQ1SSl5PlNqUXtYd383nWpa36z3y1lZu2Kt3f9t1MtU+dzm9c3lnuUb3bys4fe+vLe4f3lqmv1796Vcwr4YZ4Xv5rv9/9733edb+9w33/1h3+Yd1+8f3/7y3nfWIGTw/kIAhAAAcJRyFGUNPX67+OULZwARBjUBg2JrUpmxZhRYihuBADixB9pYkPabPK04s/yu1sKy2CgNAltmBtiowBSZYMIYO8ctIooGopAHADMvGhw0USaymAYjK6CzicxFyOm+Q5eslTE6ZkWUQ5JRga7ymhFdzFVaSaShmkzQmj3/9JH/+o/b/T9upHRUiQSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACh6HRQH+03KIZ+jwD1pcJu4dFgf3DcojH6QQvNFwL+GTFJyAzC3AlRfqUDCOYk5qnQkGGwElS3LqBoCAmMFwFEwqx9DNVR+NXUnw1qBojGcHwMN4AkwhwNTAYAuHABRkAIvKhJXQUAHq6EgKUrCUBcBAIDwCzQmsLeKAGhYD0GABgAAcwAgHwUFIguYMACAQDWy9fz9UjTXmeFBEYBgAbNY2+6+i/LXHuafYMdGe+CG2azSTr9pNP+wSJtAnoBb18YTFIek2b6NChQwEopmAeXo87tO2j6ytVN9rFJB1PBcFSmhXYECnjlnajavZUns8YlGaOblOc/O2Y3T0VPVv18eT1LurGMaadl9etN435/CU913mGGF+1u3zLl3t23dv15yaryipQ45YbuanMsf3/0WN7HLGrq1qzn3PW892be7f46xrU17uNvVn956t5561+F/O5ytnvH8db1X/DdsD0pJsDFOYgFUJ////87lebqOUQAzROTSODizzVtDKAE4K8IlcypRBbnM9cjBnFnU9nWIACa01TQobHoNqIFz2Cy99JVfvZO3FaPf4a1OyqgHD0u+3rK3bZfa/+coeX73Y5/4w7yCedtyP+b3My/TCOaq9//x1KG0zrdvf/4kadVcj/dipb9N9yfXqip3rlBiJjPFpATAjIOkvzmQZXPVhHtuaRDE1PQldw4BpgsBRgWBpkUH5nvFxwZLJ5RYZxq1B0g9xmID5jaG4ABJv2QEQNlzkJLigEAFUEE6FDV1umAYTgIHaZr7MDAcBVkmKAGrRUGTmfpgiI8nft6wgN5Q06D2LwU/qm0Rhs+7YK30QqyC9EolBi8Hdh2BHhgKRSqWuXIbUCQLRqBvpGLtFIHrfSq3mLxLKkcnbvFaGOP9MzD4BiKdwY5tsNNUeKOTk/jdyd/GkhcvooVMT8zKqenuYymnosrNJVryqazps4nP7/djVS9MWKSWz9bdJqvetyvK3XuRWL3L3bXMu63jlv9YW8O5Xtcu/ljljjl3HPHXZim3nZwv18L3d2s7U1nUzj1W/bxoq+W8uU+/sZ97nlfrcTu+upEAAAABtDKSqOf9f//2YlUtf2EO9GVKkXCDo44zsyNgRBR9ZG2F6ZFxRCUsTq3+ZOEAgW5FQlYGkHBADFkCaE+VRzjxq6yZHagigk6ZWZEBI0qpotZAR4XmoVMmYybqWNtyxc6c8mS5FnspT7GZqKYO1I4Yt/c53olchZf67oWLq2akzlOvGfqqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAnKikYDHcNyicfpBBsTXCbGHxgMcw3KKR+kAIxNcHyc9pD/IAWUDA0jLCJD/zddYkOigAr2auy1cjXJa3AwJAwhAUFBSYMgKY3AsYFiyZtKOa+POdlPWbyjMY/BAYRhar0ICcOBodABdpgCA7F2WOSQACMAKIw1bojXIlAzAMAACD48SogCJn0C0FRxGqqlJQAMCgMLbphrvqM+UUQSsgzGyqn1DVyaj8rZq9uoapoAbo1e+1x3Ybo2HO071KrTHbNfKfi8ogLGWPHDfYLWnBL/2ZqFV0EBE2KvDRuQqs7MXm8JiH6e/Hp2ryljVaQxCS08osV5iZuR+fqVrdPYyq59xs1rtuvjT8v7oMb+87GW9UHK9BnQR63Tckl69S1M898z7vdPz7X18cfytd5/4c/DLDmeNJzms8Mf5KLNrvKK/ypn9zCtzD6arYq09izzWH95/Md8sbzBACAAAxUlj5Sj3G/z9d/KnpoXD0MU8YHBJo0jDACgElPmgUiCGx7dBwbq5Nfb2ZBERoYIihAabC2orcTsLgJsdJOmzlcXILLY0QYwOE6x4BBCupPSTFbFpDlN0VMRmsiiz6V0eqXXGU3eupZHB202MbP7/l59krpSnrQdDQFmvsQJrvct9WUbd+to6z1elyigYc4oGwQuTLo80m63ruKUNvJU4G2TfEADDASLAxai7zBA5MnhsvkIBGYCFxkUImjJSfKz5sUtGMAWBhoJABjzEwQBEq4u4j3zAiBaNaANgrpjRBHSWBiShUNAiWPXNy5udJFU7YyyFgLRllu+42TyhG35lEy7Unfv1BkrodYbIJ+B4rAcM2IEnoNiEWfxaULp5E60PvJCH9eBoT+NQdyag12Zuhkc+9ijyirgM9gOWJizsBvXqFS6MP/U7nVlkZhrCA3+k9+J17fY5Uvzc9S1Kt+h325H9ReGrlzDHKtbxzp8vyzsfqrZtzMZn5/GRV6KUVt6t4Z9u97hrDK/zKzzcxzPLl7fNfll3KnrXcu93a32j3Vmat2Zzt0ly3YmN1p/Gen6fCvI9UmfbOhYEElthUxmNpN/9f//zUo3yMuNEXIYeisNJjr7x1D4RrCIMtllZGLJueFrLhkIoIEL5oK+B/UCZxAwWvk6VDiyrPi8FwkaZm6DrLznQEvHplunOCz0GZTM90B8ppqIfKLVlZJqygSUZtCUG9RDyCJJmrt/DCm/XrDgBk7PzbgcZs62i1B9m+k5Wkm0kup9IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJaohGAfzDcpQsCPQPM24m9iEWB/MtypGfY0A85XBKkhiKcD4N8SAyw/BdBYFMW1lMh7XlZO57krwQ3oAQAX/DAcHBE0aACgFofryU5JgADA+aWco+CDaTYNZFoOKKXbP1oRWTxx/2gDQOZI/LCzCoDEJXakYEB4sGXLkNq7trcMutA7+Mug6RtaX+7VKZhvPO0d6XZQw8jWYFjDuwmmjDyw2+r1WZDJ5fL094AgeOunF56DLMRZC/jcYMijYGbbmsbcsjZSeLO498tawoGsm/D92kzprEOyuvXrXZTao7GMTjsqlMtl3KtmXXeXJyt81uZntS3Obt9u5dnZu/q/nXtWatq5yajMktzNWzdwq585haxtz9zkxrK5u5hurc53fOcyz7z916vb9mv9q5u1QW7UsztY53orErVb7E1MXJ+9Tbxnv523q8uBj1kQAwQAFFCBgqjNSOn+/+tJfnaSUwRBkBCIVGlo06/kBLldsGArMdtr2co3/cMkODHLlp3SmkUHJjky1N5VW7B+NxkTONZ2lmcjUCkBo4RZVGkkKKtmXPoJKTGWXkWTIykzVZKIIjsyaNHrnzMYhodZ7r/q69v/sjrT13akpT7Vr/dTVs5rc/ag4aPpdX37WSjWENAoHOpXx4C2lnOYZaiZBlnIZxfTMcRorEEelKkSUyG8SNaKyosBQ1kUB4erGLOjoDLIiwLL7GMREFSoZxVp2aaGvCQDAKmO1lQuH1FAYDp9zZKpSAAMKFEDBsFA4HAl9GzxyXO6yBaBgkCL2fhbT3vqrZBjI3eMe6AmDrsjtl7HrfyLQmCaV7IAf5+o/F1V4lB7T3km1bHspG4sIk06/konG/ZrBblt8th2rdTUrstVVih6GGy0crUyL/NLYPRz83EYerUlJTw9Lo/QtklETl0ZmtTG9yzPUzPW6uO7mqbtJLZXJatu7L7ecvynbP6v9ncas9hlKalJeuW8KTO9zKvhd/LPlzufOZ8wzww5lYtaz/WWOuc+7l9fHe+539ZxHKrK53O7Jp+VX79WRxp+ZTSbq0ONaztCEx5gNoOKZOQz/uv1+LuVJFbeaQuunqLhixcWYu+0Buyki27uMaQGz7b3+XrV9YYmIoYmosb66yStUu6UDU8b28kpyVSHgJBX3aoaR6pXSnCm1GXWbvNyVk2e//koy53F/ca1x5art65nr+YampulhfPxnf/98qOpyZtvUnvjBU+7U0QiKJw0bBAPCQajGAREegYNxVBYDjrwEtSrmGKLlCzGzJUdaxAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACdOKRQMcy3KOZ+j0PxhcpVohFAxzLcqhqmMAbU14h1+20jDpBhygKsaV7dmVN/LYvGkuh4BOMNAVTMcAyZkCtdSdbCYPHZloytRBwSVEXgX0X+GgwQg8u0FACYpKhyjPnBSmFwIKAFKRKJXwqDoHr3H8CwRBhFDj2WrJgCuFs9mdjLRH2MFAOpF4tWeB6Kk0uUZ/uUTuryadSOSic9tuMSWOQ6y6H25OSwiVxJpzO2mKDQNFp+W24FhiAH1Vph5icPQ07GnpuO5B8Nr5X4+r7SSbcdj78iwLJqSeimHKSUUlLIO2IhWrUcluRW/LM8LUD43rPaSV0nz+PK9LjH8qTOW19U9Lzf6xqUNXOvMUsak9d66ShlueN3ud3PPl2mlXZ/fLVTl7n63jhjl3d7t3Gzzt7msd4bwxxq1a8zVlMtmsYxfl8HSmRzb8yOQUuE9QzeN6pZ5Y0CLFAAgAAk2JWTdM0p9/v7/XK9DyRVXAtPpTNylExGonOy9ccxZbsjwPXWbawwy9N9PGXzSqZnUwgoklMx/lLfl9ekspV02FrWs47hKxbL32MuZZYO9OfzXKbmst1t51JHuQby1Y1/6zntPzv697//X07Q8PtfR96/8WbLPDJ0k7pQ4HREHH/cfs2fotd29EXVhXczSMJ6piKLwCTIbxw4Dfyq4CcSkX5TpTWdBSbJi4REAYNMBCcIxZgMBP6xhtU1oFBoRFA22iI5CQjJqEPRr4oSgiAj+wUpsofBzFZU6xhEDBcRhyrIA6+kWa3TS2NRGcDgfLmGwqDn+j7tyKGjKozguOUVBUZG110ZfFGd7bNF4bgujeFuUtomuSIkBmKeRZ4WpuXTNE8b3ucqGCY1C5R8ezbANAvW70dgp9nubdNJA1l0r3CKWhu3JVBt2pQSyemKkoztVrHMqaRxvCpVxqT1TecWr35TTvvL+S2vzc1lljerVs7E5SQRn+MzhlXyq5auU9/meVnVrHPGl1Wz/Pn1Mstb1//lcx5Vwwy7jjllyzS56v1efjlrGpexzyxfuYs51J+tunrTIiSBMlYKco12+9f+tRN2MZQ9TZ1xKPAkEjsRFHcfi06F8vxWhlRpH8LATDAJRUs8uiqVtYxbe0fMjAwaLKDEcUxnEhmDMuloDm4h54sG5SMyYnAOoh3LQQUs4GITF2SWOlBI4w5qnUMooZYnkzIzukoskgcGkgsZ1ddkB9kSMyGVXez1/Wc6/+t2QW+tl1nlGQMEQ86qLDR5Uk6haFYtQ+QYlNU12AH9scAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjui8UB+8Nwq2w4tBszbp8GJxYH5k3LHLSiAL1RuA6g1I6C381gLp0B0lzKslLFBLe78chlN5ljeI7PUuJly5AuOGeKA0IO+yOHHTacKiSy1+QGSgAVJTbq81IHhDTXjXuVQdezoSp/RYVBwgUXRIKp12GCNhjb/PCKASCkPymAbDlyCHttxDzpQchuMTN5fNK9vZbViih0pymJ6klUBSx8cVAIrS076yyD7FPMRZx2utJac99R2ZRS3J6ILP7Mw3G47BkFxp/3XdWXTMklM9jNP9SZZ3pdGI3zDPVPRx95cM6LdzPC7YufK7c5R436sNdvXsd2qlWz++yHCYt8vWp2Wcwu613X5Z81j+re63Mqn/3PHPW9Za//y39bPn/h3PX485njvuHMub5+VPQ35uxJu4zNq3qz3LeP38AAAAQADiHk1g+b//b571BL/6h+QIqQlTNTQCBqPxZ04DeHBDOel8vGlray6nYzhQkGY0u4kyocfb5VcRGSUlkjh+ZhuxFY4aQ8Zv0yllkzMyKgTKRAvMXDdZMjiJ5qTH1JGB0bRk5FhjXEhRRRONRURpq5HmKjI+qmmockR4mZGKevq/Ykfar9aT3UvVWtBA6gZmqJok3rSfUlpVmEzyRBLiBxw+T9Ksz/48wqBYZo5cQVR+SLLajkYiuvT872ZZ7GJZOylYN2SwWciacLW2gQe6sqBA7KVWwqNtNR7WFdWil0DCikPw72hKBwt0L9JKKSp3KdiWSq+pUBra+WJsO1x1jIERA6sXOXXZzcmQbZmBJGhgbkCNTpYLxLkSJ8mkiKCfiONTI6XSdOk6iTRiOIc0hpcI1i65cMiHjFMygT5NFAxMx1D5JI6gXUjBj5dLpdWmZksblE1SoHyuYJrUxsau6aKSaR5NEoE2kyNnUyST0pizrSMUy7Qaku9aLpJsy2sipSCaqlsitvrooqskutWtnU6lJVstlrOoJmqDpMgyJsqUWMTPsNHVo3xdZY4ULxSV+ogimnq0MRHEBxEBT1DAziMxa+FgU9RkgVM5+xGKnHDd2nzMMZHxcy+hYJmNqFWghsW5V66Ccs81iaibLhZGv+g6RQ0JAmCcQB0IipFCbSKZwmAzgoVMcGNLZDDRMRoXE2C6pQZwX3IwiqCKaxqjTcuGzisj260y4XA3ALFB2l8qn1qqW+qt2Mh3pak3v+atWztU+a1SyfPM6n9bWUbdBM4fUk60NVVmMosEh7AfGhtprwl92zW0OAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAG44lEgZqbcv+NyDQ/lG4bXTsKB+9rw9U2oED+UbgvDEvF8ESwE6GM6LSTq13CmyrLoqP07y93DbAFhYGjoHLnXo+6qEFgIs8bHNPFPCASji6TzSSSCo4OENQjMAiRwdwB24lDs4pYByd+Cq4WBAZlTYUR4ixQGifIYADAc4niwkYORQMYjuWXWcvk6eMh8jGHTVMXCWQIBLhkmpqBsxAWDpTciovTRRgimSgY+I4HOSJg2djImydPE8XUDFBZxaCnsUitNXQUxkiV1s66egkitaKMvGtlW6FPsnRdFK91oO+2tb0a6NJX2f//+v621KSWirRUkbrrc8veIIAAAAPFxX2EOpQzv2B5nDyNLZ7tyB4Dzb8pgigOFgCYaBRiMum1AqHJEAgQwEB06RQBN0CghWWTAIlCYKOCuTAAvhxwVfsifQwEZDPYKnmfhQLHDDiYGWgcLTC4jaIl0MBJ7kQ1DFrNOMNDBYRulotD6JwMfJAZUDtLQUDC5CTHWOYQwY4EIsZAvF9Aug1BGRiT4vgDQZIEAFag5YOSAaFFxHBpjLU1JQ5YaoWnE+wCwIW4xc3IsOSEiwGJAjMDpE2GSSLI1euspjPLbW33XN0rH16loqOHE1l48ZpOp0aq6kE2oM6C2c4rX3Wpbak0jJF1GSAZiVlkdSrf8O6E1HAoYx2kiaTKRRzK2NGv4Z7msJQ7MrZ9FxYoIQFWoxwcPfSxYSc1xKBg6hAk0txGgxkI8ERIQDkLa0uyctGBgo0urNhK+AwnEVEAmYEh4XBYYaY/TSn1WGFQo4AEQssPzlF4Cf+Mv+YMcs0jE9DVHMQ2KCkMfQWbKHeD68IvJI1KkuTy0MB1HT0jFOdput0daSAIGd2AXRr1M4jp9hAHjR43tM+k5jy3OyqZs3vxx5+3l/LLWX0uG/3j92m6kUoYSmApPXAHDWsFnrUueIg6Xgr/b6fQeySg+KjGqDRVhnm4PsyG9lVNbIuWkexEZGWAQpVANJTgQRqmMPA4wixTE4zMnCZH8w2D1EhYBKCGFRMYBIJEDzAAQATZQkGARYq6XInqbIeGHpAJC66kKRA88yPTEq2NACgyIVC5L/EQDVAMApsjlggFmSSXD6+nsIiGrxaws4SQtIHfXAHEhA4gsOemPBQAwD0KFzQgxUI8G6ZFSJkaWwgCMVx6Aw4dEBgQJ9IuLkDjaSKBAAoJJ0CygiJDQoOKxlLRHCEAZDAuzIqMaQ4qGifZ9Ja1sHSqTav/KY7qjrr0q+pGkk//o79a1ake3utFFnooOajD/93Y//roAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB4hQP4H80vDsKcgAP5teHmU6/gfza8OtKF/A/u14ExOUvMBJioJ6yKR8/h2caKvRP2OBZyIWng/wOVxhIIAwkmDhqYjhhEhAgMLORyGB6lkY/GoJQoGDIVIhVD7nGRzGimtIYASiqPBlEhGfASX7TGHCmcmjhgz3GoAcYlJw1PZ+zR/kELF0ZWqHFDEQUMAv8s6RM+WnEgagAehCQxxiUP232XKOhofZXBTzaMQCns2KXDEiaGjmzFDpCbE2kNXTKAxvLCJSlW5vYqYEvOwQHEGzyW1yQNTHWYNDIapLutIKW5nvO1Y1ytv+SRCO1/6y/vP/HXaqcHP5eYL36xoT9T5EAuK/xKJUf/W76fgqJRnMeCFGYyL6pYMRrWKWn1dfkqAEIIiw4kAEeQIERYBGBwWZxlB3SzJtGBxUYABIOERaGXBz7MEiQIAooDTEgQg4DDpYFmLFW/UkYkiIsXxIMO6BRYbHVI4+BZTGcCuTJZQblUYQTM5ddwzLy04eJThgllckfBN4shKEGjhX5yV+rtks8y5VAzV1HgWDKau/cNzz2vq/gCIq7sMEMMAYiFQuJQIzBeP2K9IzJFB9TEBWAcwCCsfs5RmifssAxgA68DWGWPZhfx1ay3lzXNasznP/8v///etVJxxpilPLBxZj4tyrEavO57///5USw2QWoQ4tBWJ1WuSqiMcbtTVqVQeQhIMBKd7/EIVMiBowmGwKIyqVT5BNMOBcRBwaBCZhgQLEwKMQDwKoUFGhQI1KAVGTLSGdOgW6rgVBpieAjzEVWRlKhAM3SUxHrDngsApnBxUDiJvFFQoGPinegsdCHigij4rA/yHhbotInWLABt6cLCqWbEH2l8gT0MXCE8HGe2VNMHhJ0mFswXyIhCAadXAiE4JDllrMNIcy+0/XmbD4L3ggONGh0IGCm8nKanZ8wNIUQAZfhSktnAtJn3DLmPN4f/wG0q3r/5///9/4g12wMdcQ+3///////+IAfeoEDdVA/wLhHhKVtDlI5ZY7EijNV5rxYAtp7bJdlmU2jAUKwMHhmKJJ1gjokExhaApEAy8QECSHpkQEz3u+ngNFa3pENs8naj6kIEA0YPFGY1gCmggmIRJMZzyMF0KEAAmCpSGBBxhggx+lIgtOZuYdAmLzVJbX63k69YXC2bAUBOEoSI/bOzGLyBibymtGBMNNRmYDxBA84TzMrY4JBigrhr+DheHwwFZDLYeFgKtUzlRe9H1yTEwKBpWRAieVnGxlbQXGqdGOaYK1HlTvN8/m/5zXyXn9//////1NWefVvfo/////////iAH6gQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeOUD+B/OLw4ooIAD+bXh65QvoH94vDt6gfgY7xeGGGdow0JI5cHyejJEVb/W43MwVKyEDGAgNG05kCjE4/EAFMVCUwYnzdYnMUjQDBMMG9gwiHA4MGDRSBC2LLAdHpj0XMOMbndXb2o2suLbmSCWDAuwtYhgsUnVWUZrMgDbhmA6A4/FAJaoq1YNY7NxwIGMwkhAqNrLYobQ9XXIUizGEJFjFAzzvFATbtyMGDlU8mv9k48AG4OG0hlIMBLKsmJmGwQ+xhMeCwCvtmSJsz2NeaZwwgSF0FPqBAXM37OrVMYCCgBCSYLPmLWa+ePd49/8M/7LVQ8///////9y5cffrcqX+////////6nwaBoOiV6/ZWY0ylW2OKqH2JnsurSvAsAEmACi5CAAwEEgLIBKYUCJjKFnwXqYtHxaVEBNcAAVpRk0olgJtRFQ8OAWjMgjAiAKjt5rjyiEfgKBFxAEBzAQoOxHUw0qDIQKMDm0wYNRqBpWVAMcAF9oXEA2btDo6Lshx8X7nUrGAR01vgTo48sbf9VJuRmJ4hpL6WPRAOD1mO3CZAmK3rlsrLORgGiSrrUoi/f1YSVHg+Pjw5Vjw6BOtvGtYggcEQM1LnZGqXuGWPP7l/8/Xa7zf////////GoX/18a//////////BoGjxWJk1j6IKEgwc7TaOXeVx/GkopWzYwYBNeIGAiAQQORIAQwCJaQy5RAxCGMCASYSA0YDgCYBhq8IEC4ECGEIwYGBuZVAQykxEHQMCtTCsn0+44KwYYwJAyQAYHDjABzDoSTcgEDAIdkrlgR4ANWAQcggwAARwxmOzeTA1DBdsYIASwwCAdUwBFBnrhAgTKXLfj7RGQr9MFFIeFcEW4acwIEyUCN7OmslQGIrOG6BWMkyQaaV2PqytEqRWaKZUSAwPUfIgFBr1BcHSiAb0OsyLZhUWAQAoGFUBLapp/89YZf/K138IMVjtf/////OfuZeLP87H2gP6bF3xQZCVvnSnZ6hg+NvpFIrG3aipIBokGbISICEJZgQBRg+EJgwE5hgNJoefxhWHZgsCxgiAJeNBouWYRDoKBaRDBDQkj6OZiML6vkeYzK2ttZDF6BwAJqGCoQHAozmI5fGQQiGHgUmJQyTAsHEgumAACDQCXsMBA842iGcK5Z8oM+UmRyWoMBswZQUJ6lkBOgtVi7OhGnS49K/r8xsBBWcWhD6wZgEBzSunVBwFdswCIViTjW0SrWsbTkp+VjBIDlmSgT2zVyeh5rxCDTGQOfYhBZAAWr3bePPxyyx53HszFOf//////++P1/3bFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHg1A+gfzi8OqKB+BjvF4dYUD6B/OLw5knH0GObXmEyGIM0gpf1t+i4NGWG4rcsSq2lKYABiexWBkUjCBjMdAkLAwxglDRi5MoCQSG5hIAiwJAgZCAsSB8EAMSgpKIDPgrKwEUHYrBCqTSUalbjDyoBIWQxiJgUdHs4CYjQYDpL7mVAWDgGikxhAmgKUBAiDBowMTgxnsTauzlDYLhZeIAApx+nmTAKPAp5mDNBetfI0X5E60RhiFGDBPPLPWGdkAgNjkEssMUgl3jEQwQ1gZVF8LlWdj6wQQRmwkQpjkbIA3G84Zg1O5YUCggHCZGAZAgwBsblzPe8d5a5/dSViXf///////51VvNTMgqUz1XKd9QwzuKbUM8+sMQmtDkThipdjooA5EAEZZU8hhGDIND4eAAx1As5eKsUCEwvAwBCsVgYKgMksQjyCQ1DiMMAQ7MMw0VkAorJfOGnOgKSvMDhSMhwSGQHC4CAAYzQZOjAEQiZfTGImA5XMQFSICgCHCZh4oDjE4lN8BNcq7mX3nJSvBADUCuGYIgNDZgLUmoKcOYuEyAdhoXM4fqfsI5vc4SKC00jIbamtkaAc+YQDBfGBnBL8UtaxBDRg4MytgjbxJw3Mr9lMCLKekDG11RQAp1Odbq7//x3zXcc6RxL3///////qU3t/V23twmxJ0aG6r0g8SEWPQZ1pZB9KouDgbFwgtAQJmPy0QhwtIYUMRpIuA4avCNE4wYAAARlOTBIeMDAwWcpVGBmkEvaREUYAIAAQgBRd/plMCGhAOJAMLAQVLJk62GRc+daF4XHxQREIVM3KDAosEBQSYOQpscaT6grVnoSWLvhQPsuCoIOiIYBHtbpdtdUvj8VMoBJWN3NzMkIQ8sZiLT3xAQKR9aOquBAlwxOEFRRp6BoQUu5VgtN34iCgm+sgCgqiFe7GXohgqBNE1Sxm6VC9Jymx3zuXOay3cur1x/v////9/49V/68hl/1YSiVowCpKKIyBrsWxi3JHVl9FGmfiwfiwIAQQIjChaDgEYIMRiRxm61yZdKjYCoARCAAqCzAwFMNnwGDMHNgwIDzYQMSJMRlemLKpVKmYUYmixkEJioCJQOCDccew4CAgCtJlMzAkQKAcxsrARIGEoIBUIjICM/VLMVClmyTDiNAKAkgR4ENzlQ4tVe19rjOQuCMeNDYiJxbPA7JZ5fqQcWWEUsRNfulT3L2MNHmtbT/uUibjutEkJzL25BgSv96xQDhdv5mYVvsmLjMKTEAoNNbu7z/veZ63zOo6fP///////LcIOJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHe1C+gfzi8OlJx9A/u14eZUL6B/OLw7UnH4D+aXhgVxui58SCCrnCVUtsPVaKXzktVlCoCXaYQAQMCBoAjmHgcAgSYMNx48xiRpMDi9KZzTA4CIhoYQA4iDgkuACATJ4cYkYDEadhQAncU1FAaIqKYxBKaAhAJgYnHbJ+YU6I1pDAojKDwi0KglZYYK25TpgIcmXA8CAW4bptOd9fQhFClK7Dq4BFgWCQGyZolRq7DzLIGZw1+miD8EIBYY870woxED2ZP9A4UCbqmAhi/lK3ALgG5Q34ZLAFKA1KxIaS6sYLDLeTFmOPsg8X1MoAoHAlYrupsUGHcO487vnedmIb1z///////03/f5JvuRCgoeBpGk8RLjFb6scCbqUD71kjFgWOl4FsAgHzBgOhGNpk4LZx+FIYBZg0EQYDKlxCABesxGHcAAgEHaYAiIYtBmi8YpCMwpYFRlMEvcYqlgGCgWtSAAQHnFZLGOZLgJhTBMDTFwEaLDCiMaDg4WQkigAY4DG2Qxb+G5E0SAWpMBU5L2j1QCitkVE0FVlkucDdlaLcoe2z4gJHZ63r4CIKaVBa0S+79mRGaCs4+JWC0eExWIAgWOobBxtC3MFAKBrFa9MKzEiKciGJXFgMEIcqyPb1n/MP1hj92bTOv////////1qrgZ1/UkmxdJQOYmbCwJxFpRI6xj/ZfH9pyt0bqAQELS4waGAw5mDUALT4yuGzEAUCBGhOMBk1MUiEQqHAMoUEJiQDJojI8dQkCJVAc+AgWZcE5q0HiwBW6YTAh80hAjMmLAeYHJL/oJAsDHPMFAZgSMxVF5iQcNDUVbLPMlayFxS7yQZ1QrlA7ZbDTRH7ohQDBwxFhqyyVNSb1YJ9WCwhnQQDlBn/YaYbAlQcFGcufUIEWfz11roOBD4BAChEPmDglvLnG6MdEIgAopYI86ZKtNbDDX87z9V/wm1vZ/r//////5LNf9S99hP///////p6nQQid8H3oh7P0DXCWmXluiICq27u8qGlhsgAy8EjlRMMMHhIILZgwsmjmQbboRiwfixLDimCg8kinmZjKhIMChaDIsNJiNm5lUaqbprQar0sAEwILAEJWPILmDhiewPhihPkSMMNGZiKwwMVIVsBWAAwwIDnolggAw1bz8vTPqDMjUPMmJAQqWqAwW6k8IBJutgGVP640XrJ1r1k0PusCRMEPAoaXKfAwr5EumfVnG9XdDoBFCWBDiHH0ZVfpLebxqdCCGYI0tFPaPIEpi5f7+Wtb5/5x1fn////////6g+3v/////5Dl/+2IHCAMLB+D4fUGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB4dOPoF84vDoqgfwM7peHjU+9gfzi8OYpx9Bjm14fQJgTDQLhIk8EsfXZiEVymoDQ8LpNsUDZxzTAIT9QeMsjw3A1jBgRqgIIRUiHo8EwcRBUEERFT0MCBFXBgwpsXAQBjKEot0Y4ggOjwhB7PgIKztiGMBV8eGQIJQYGEcS2Q0BDEoJEILBoDVKZ3D40ELNLDawtQGB5wiEAHK3UEDBvYLusxXsuswkL0sX+onVphwGzcpwSVQvjUPQyLDlvTAoVcqJOmHBCWy6nibdkl5oRA3UyGBd/J+iqv8uYKBoweCnJg1RWTc/Hf5Ya/We/lLXL3///////3TmDRDX//////9/uvUIqzxUNKBkNFgaKuJhEXlQBw4kk6esxIK8X5P20ni2K80VGNmBIDggHjBwZDFkBzogKwMGgUAsFBClEjqiAY2BCSA8UDaCQrMZQsdcxKBJGNVimjkwIPBmDAEZesklEoxlNMwBHswLAcwtDsoGFrizQQAh5mCIQ6tNcuEibfr4gOBXGZj1xDEZBoS60/BsRW08RwaA08ZvLNO67rZo1Lmejop3XzckOAuSBW7/S10297e1QVU074OP3Za3k5j3ctfstiGeW1dNLVjurn/ru/539boHZ/9f/////6u6/93v+7/////srrdZBqVPFQVUDIaEQNFW9MibEAXGGNWrNmRsrZfJpuJjIMRRFQGYNDhgsIGiyqYrCocOjBcnN3XcVAgcCAMiAUCBEZGYGFQqKicoGDviQ3L2GEU8UABtC0SyhwKGM6wHOEmHC0SAdG85mYV8ZskImOyuZCD7fGAwXBRhYLDADAIAMZDgDeQdCqU8OvpDhbcwOG2fF7jlGpMJgEwkB0L1iLMe5MUMPbAHpkDJ4kFhQq1pb6NJSQUOjrcjFYHd4wUCmsy2RFmaC1K9AwBBQHMCJAFKHvMPAJ7JVk3W9XJAEYRE6Z7dEtXfy7Yz1V7vfct8oGk3v/////+/uOP7r44dyNqs75WRAY2N4X8txTLF+O0s+/FtF4HDBfSlgNBZigTAkTGO0UZP2YixppcPmLgmY5Ab1kAASHEpcIRwLE0GCs00HCgCAZdJMNTHgqzhfhhVDmWAaShEHAwwWRTnbWMPuUzKAjIR3L1hAqCTlL0CAaZTTRYlNTPzCQYtehBRS+2BgJnbLTA6NJdjyP680xFYkhgb7pvuQ6sScFRuWQautoxhwm5ahqpwxPgcxYecXKHFYKKzKdvWJC0PmJBTySgRgzQMLUcpFVRwkMEIUVkXSQTp+fzH9Yb7+/3aYtfw///////83kl6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAd4UD2BnOLw46nH0D+7Xh6lQPYH84vDoqgfAP5teNM1wRAZQTQfyWpQwbs+iMvlbuTrnV4gULEEB0xQnACCDAADNBYs76aDAo4MIB4wCCERAgHkQ1MEAQRoEaKAyATEQIRTMTssvCFQoW2SQTlMgm42AFwMaVUm5mGI0Y0zp0kKDidUNZQYIBIKERhcMgECl/QaGRCdzE4IQCsPT/bVKcDBBB4wGCjfuUGge3NpaZtGrGKAQkCrM3HuM2h8wGG5Mra/7RV/s8dxiJhIPRkaGUNQyoIRCKNUVeIMqAwxeEIF8vmxIbLUrW8mdOWCgOYBDziw8gW2elpf/Ws+//d/JUzs9f//////uXLj7ygwb4KYblsahvqpLN7k5X5564pGslZBINR0AACA6pQcDYMCQxFE0yeHs+fGgxPBASI0wdBhaxaZ0TI4MDAQbBoBRQHjHwLWamEAeqytyL0vS+ZgoWpKCLZmBmCgADW4mMg8mZoJgoHRJAd8HAgGC1KEZYqYIOnPKwOLFtKRbhEl1F7WLIZGRRwsFq/Xc2N1HJHgQ1iyDk5+I5CZVBLd4LbsvMycKj8cfcwIMgkDEyLVRwEe871vjgiQJBpkYbQeOgbJce3I5LQUNArSSbhxJdV9Dd5zH8/w/f/dci3///////7oIrETephORkEJGyNwmzk3qJDJBPwdNbloyASYgDAAMigsgEBjRZmJACJJoxAfTjIVKDy0wEAsveIByrsCBkhZJmwBFQCDydccywrCgDiIIAYOIakAJMQqs2QAygckQJBgIMaREyMcQfCxEQhoKJAEJIL5AgPJKpemHjoYlFAcL26u5Lm7QkmEQsDRQKmKsaLApHcWAOLMk+BUAmTgMBhUvuIrUjo0IF3YJkuGPBxry1FzGAhHA4ACLMZCmuHAyUy+hoFshgzekwoBIlDBgwCvLKrb7RtcpgICiQRdy49anNer3Wvw3+8/yqr0s57/////n/HX+3qtJq4rm2FvBtiSo6JEQpCE1LpPRS9wJa3QeJDcwwBEQoABKMPg0CDAqt48d2jAhRAwzMcANAYWBKiMaZLIXOys4BHxnERqbGGRAnMmI6C/2SmHy6ZHFZh4HBwdMDlQ7XEzBCaNvhM0aGgc2mBgwJJi8gXBVHCEcKq+ZdqpSK+YVBKOkqLXNITaNf0RYWedmV1ppeQWBgVrDSCyKG3KfZVJyn/Y+omNKDaMqYQFRlqwoDz1I04ulfxjOBVAy6srMmDovOyNpmNqmvL7BgGZWDQSqkhMTZm+Zfr/53H+Y3HFtf///////zDn/+rFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHd1A9gfzi8OuqB8BjvF4eAUD2DHOLw7SoHwGO8Xh4zKQ0QqTuYC/LCHxEnA+ElkjIp0kBqtxbkwWMASATPZuMMhUxSCwgJm3wcYqFo6ByI+hUCGCg0DgmYrBwUW4OkogFhgwOoYmZUK9iTSvEfSzphmmmRg6YMBxQCBkRm230SoQ6WNDCZmCAKkcAQqsoGhdGwoGgUGRwIjOCgleCKuTFgABzAIAXmZUxRcJaLSWQpm2VkmbzwEAlr0gc1pocEmEsgXGn+PD5tmuvGYtCC/hEKGDQtTyds5jKNxUFALAvM7sNCQSduL01MyymXSZMCiuZ133Pp96uc/ev3n35qAef//////+parRez+i/1W6VhaPQBi0qNVpLJoDoLEip67zww5Y8IMvCgBormEAkmBYAmGgwGeoqnTTNmKoTCgSmDoWppAAIkMzGAegCEjlEgAmN4TCwBo+kQQvuQgGzUAACYIFGNBmHDKWgMDR/MlVmApfCydGKA6lqYdEYxTkSLEQWEhMYsER39aDxCXO9zUVgn8SFTDLAANIHgoMbEVAlbWmPSFgEZEUqfcMS6rQqZMBbxynqLvuxDLRTE4Ef5lTOZC01jN/ckts9Eg1EhIPNYjZCFX7qSqhzZi1kHGxkkeFAlA12tl///Nf//Wc6////////6qyL/zoo8/iezORQbzOjTRis+FIv2QTMTfqdLARMSAGwEGURBU00Ky0gjBJEgzlxXQYMUhQxWASYJmAxERAwxwMTCB3Eq4GCY0eGWtGcgANBZG9bdkuuZgVoRRxoU1yIGnUk2YQQxvcQGGkiBhs10cDqvwaEAaAgMFDAoVM3ocwOBlVmuRlxGmAkGKeMECc2vFQcUS365bS/GapKGKD63WCnfj8ChgMwdBw33MMAlkTOFEB48JCmGw25Ew0Yv1nWrxBWdPd8C/MslZgIHrPy3JWxP+VQQYyDsieGBlP0+898w1j3PLLdBEv5r////+/qPPr/4XqbD7uCLlEQSZUkd+hh6zEp6Qyl5oAiCnYsCq+DBcCRIGTAMLE8DAwjTEpBz0kNjE8cFKDAEBmiBgNGBgCAUexQAAwFAqDphoCkYMBAJdmEtxYWmSMDKYXgAPB6LAMYRCccTGSYSEkYugQYNFoDgQNBIWBIsDwUAUmiAIGCh0R9gMPsfQgaYiGxZLZygSJDO4CT4S6fFVVbjaPiYQURMAmst9bhxzVbJiMslMIgBcryMDDBhEiEGRqkk6wVNhyV2liSgsi4NGgos77Mm94xkYBYRw+0sZAyzJq1//3nf/+YV4x3X//////6rxTn3b1YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB85QPQH84vDkagfAY7xeHx1A8gxzi8OOJx8BjvF5jRDcBwBTi5xEguDQXCjbhHJXWdB1BGJzBYIQEIzjIKNnh0DDYEBExYUzWqzMeh0waHzAoYFgCQjkiCJkEKGBg+AsSASCaLCCbxl0eBwFBAfLAFSbMAhAyE6jMoCEQODgagcRt4wk2jcIcMMAceIxgIEGCgU2ctiFAQCAOZAOBmJ7GNAShMXyrCpWi+KBtIgsAc44NDH4BLZsOYao01kLAcwQDBoJL9ufWCBUjQoo3eVA4PMuaCvIw6FZWHD0aCM+sGixn3tPEQwjNyGgM7MZAIgban62F0GjjAEMYgZhz6ISlx5yXmOF3f83+W6aG//f//////y5Wrv/YklC3Jm4icmFJpXt1ZynlsKrRiUSAZAEiFlbaQ4OAYweDUKAgYHhqYuGoY/uUZDC6MAWEDYreIgpSrMIx+UsFgkLaGHgEvMAQZLXIWMLR3gAwqDZlwcDSaZg6GhyaUYylBgyCRgWPYYSTA4OAIST4dZDxyjEKHO5u8mJ5e1jsawXkrCuRsgsJkrFYldvCzh7FfGAyGRCBe1SXUqmTRpRHYcIhI4tLABgMD4AkMr0ltIiLMUtNXl6Ir6Nffrqx3ux3MZOGFRETQ9Z6qq902JjXMP7+Gt/+sIz////////81AvPu3v9UduL0BhGIQU3JqMtsSJyYddt3Yg4bHBgfmJgO3IDKYwIAzXSGAgGb0cex9VcFyBQPGQBigOMNBUMB4CfAEKAleQYYTUw+GAaWDqw4tKGAplw6HDCnoNeGAeICf4XD51psGKtoApsy0OG6I5IPk8RkAA0GGBBAY/ChwR/hBAGhEW/eYt3AJCFFXigHN+xIwYAggTr8TvUOZgIAIZTOChNdx24MzMICFwH0WezsKAhACkSjUKiBnxhUfK7pgsAkzYxTXq0bBwYjoBGLQmWCwNee/HpC47+GARCJHZZhKABEAHOpc7/M+f3/1lubcLff/////n/SwRv8LNSJVQvG95VRGbkdp86kUbe3jabtFBGDICBFu4GBkQACDRMBwlGAQeGRofHwSGmAgVmAoEmEYL4EwUItmLAupejw8A4Bl9PUYUDMXwb157M+YJjAYXAghgIwKBA9mcDEGDqfAJOBwbxIJEwJTFKAAhQ8o0EjFwyNF0Jjha+HY0k4uthzCS2IAM4CAiWCl7D2GKlcQZFpMD5TTOpEYip5dqYbtBATmnjbiCQND4CDiluSszba3UlcOoD3jAIEm55oLF86scmZaIxCZdAjzLsHQCx3DHePP/X//6rS7v///////uYh94oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeVTj0DHOLy5KnXsGOcXh7tQPIMc2vDpacewP7xecZwRgBpVnl3pW4NPRZRnCF42YMioiD40Tk0TEAIckzeizAYDDBiDRod6KQUHpELDG4IEQLHB4YLARkMNhQ4A50mAhUJZxQkWMirxEHjAoEY4YGARmFdG3AGNCNBGWBgZzcZnd8GAQgZAI6mLtg0QjQpTdFAgXLImCdpIIjBQcCGLw43pasdAKlpgYHmjJGFgankPABXK+2jIZGVDSNCRwJXMugDRAq9ORkLqjoVd1njoGDgbAIqR2YWUTg4Lz25TjBaq70iANKungKJFuXKaJMMzKgLBRiKwAlsX0mLFBfx73X73+t0iWPP//////1lSN64ZuAHhKoi+4YBmmpRMRJ0r9WnjbuOQMjMeBjMCEPpoGKAzJzAIZMI2c622zKJSHQkZCAQUBoJByFJo8dJrBipLqF20JJoU6kgFSqfxQUwICzI6vMxB0wWCgKAzACSPUZMwWcAOHQMSiIlDxDaTDbYggHjgOMMjw7U8RY0OwzRgq8p9IBykjxkFLeaql8nW6tFZMfJiRT785LqRvh6QqnhsKgByLcfBQFkBhUJMWgV03Z/GVyZGxOxmJgYRw/RBUBOtblUEQ27AqLTBwOg4hABCCZ/LD9frv8/+/dhz////////8X66qtGXrStTtEY6B1N0LnQph7zV6dlcFBQDgwBiIEAAGggRmKWIYIBpgoZGt3iZURJmEBAgCFkQgQGFxEDgSYkKRgBIGJAyKowkLJdwxSHnMEIARyLahQGmY7WZ6IIsa1nAEimyXAY4HgJC5jotGSgqzDAkciDk5xEAmVhBgK4dZkGoBoKDGajICOhCMKbjSUyRHnEzdEGDuSyp/goImbg6TT21pLPEBXAyKi6VHzHQ51G0WOAjpmxhwshrElVUEV2nmo7ACA5spYC1cPGDAMiAZHNVGJqEEoSYsFIkO8nQq3WVJa1jzHDfdbfBdev/////8v+Gn/79zdbeyKYBVEhSrYLgj2eRglU3TSyB3kJA9LctcDBHIQFMWw6JQJMAhNMqgLNwSZMTAbMJACMGgDTcBgDiwEhCamCgrA4XS3ZMOS4jI4MhYAp5RBu5IAZgsnI8D5ACylgQJZ06NBhmKJocBBggD4EAi/EeCIFGCAMyMlBxiIdnPyshKEAFUIWoIwS9bL48ouYCFI0D2HsykstjRb8xedVYHvj002yQMDRZ6F1l52oNeaOTDpW8KDl7JBKFarX/cT2Q1iIBFEPShmk5eszcMsHSxDlzLFDk1XPldnn/r///32xS8/n/////+s4o6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHSU49Afza8OTJ97A/u14ehTryDHNrw5AnXoGObXiAp0QALk8MARdC0OPZTPmuP3diTKJU0gw2BiQCBBaJQMakW5ggLGBisY8Q51UiFZZFAeDAWiGFxW4gUEIJOSojBoaN2hUMA5gomhwOHQGSAFMxYEyw5zW4ZXGRAIICB1IlmRqQYpAogKwcHuWYwhNDKw2HkWxoKOZwyYuQBNusRMl5XrVGikZsBBiKUBSgjPaQmBkOwosKkYhJnsg4LFi6EqoPfUDEr9u8yMWNH5AQ1CnvTKDg2k3RUc+TFEGs8gOKFxk8K9SZaDDAUFAdgIOqzskYrTa739by/f/hTsu////////3aeZ+pSlcwZAe4SsRC2qEcpEq1uKQDDsUcUkDUlAp8QwLQ4ABowTBwGjC0CDGY1DEU6igBg4MggK1KSYBkizIUESUhkYSEATBwFC2gcc0Mo3kwEwtOMweK0wJAkICRB4wQHk4AQAwkFsHPyZACOieEDEXRPMVDUx2CmPpB0isKgqOSLEklLO40tEKBoMngsBOc3ZoqgDEy8qLA0NuZD0PuUtKDINehHkMCKGLLZMCAnYMEIoLlT4iwZham7FGpKMGFFdi+jdCL2MdjjpiIoAgTGGfr0c+7//3H8f1//8H8////////oJbz7k/KBENACjYCpPNRuJTPbPy2QPzMSp/SQDGIgCvIeBgoBThpcEQsAw1MTBwy6OAcYyIGmJwwYBAZg4clYRMYl4sF4MLYofza5ELTmD1IXOIAa+qmgFBBg5mG2xQAh2UAICiQ4aZzKvGASwMIk8eKjAwoy8CASANJgVCQgmM4FDTe4QgqTLztsFQ9D8uA6y4TiWcEhamyts3AiKkiM2XS2MPxl11NDBxuysEmDGAwubisHLwMJuEDA1j8vXeEG8KpaOMwCIwOTjwa3SyIimGcakAu3ShdGMyH1AEPSAHhOGsd4c5jzv/2qqC9//////z/jM9452alEVaIZZu22GCFpR9yaWtGpVg6z/vaQDUhDaexhoGpJBi2QiDjGWDQc6NBhsBFuDFgUKwEQhxdJp4vDB6BQbbsYkAcYATpEgciuLASHmvmJ0GaXCQ4AACCxGoDI2rMqtcnOBksvGDFw0fhwOtEwQUAwqBhQxsvOumUWE1kkGlJPMmgJ3mimGtpEcOa9TP5DBiAkRphQCuG+zN3pHQBYFjLprwGQuD6dl5h4bGx4vT6rVkFZi/SZqLoxtUAJgs6UwIrTbr1ow/yCI2kXVrRdZ9Ct55a/v/zmv3dhHP///////VJL+qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1xOPIMc2vDmScegY7teHgU68gxzi8ObKB6A/ul4bG/yQyjKAoQnddkDsxOYjS1oCtRm/ESoBCoBkMEjERA0mFmzCgXMVqw5AdgIDi9xkAAgITBQqAoBGdCGYFEAs1hRFmyDIYMAYXWqA8vywBIV4hybGWxcgoXiFS+I2UYFTglkTGAyDGoQhJghfMmggIqEgUOEkk2oxAACy9eKwEEjIaYWBxJdx3yKBo9hTurJFQFXYwBjUkLGUVcjN4jCAqfb1mrYzBhOIPUpiYAENgSGl1RMkKgE3Nyq+DAAFGTKmyy+H2/Tjk3IJvNDHR418PdxqKCOjs491jv/1Vw7ygjf///////+rrmWVriUocgEUa0v21Dssd51o5EZJN2JbDowEpgGCgoBBhGBKfpgUBBgmIYiAExFCk0sQ0aEEeAcwUB1IEwLB18jI0cTBMUiIewuAiEtdhiiHjEhCAK92vO0YJCOZOg2rQuAwZEc4rQAwldkycA1uAjBxoQBBSWyIQFGRIUyZZORKAUTRhQxfiLytqk2ApxGIQ5EnKXK2rziitykjGWtvXar5y2Up8LWYdBhiodnDzRzAQpeZhQ+7kpfZq+W7VpJVOiwIxXCGnjY5dryh33ASnMrHF/wlUWWH/3/1/cP/diN6///////9V56TfygIVqqEIBQEBqRlcNQl+mw2sI1DUqhQcUUMkj13m4zqYPBhMKDEwnMLo8t+JD9J9PUw+FAEDTPJMEYlAS+MVDw60Hw4QGDEANEJl46FC7KA00aHDMA0L7phmCgcdaKpkR+G1BoY3NRhIEILAoGgUCmNAkMgEwOBjAZZMegADFpobL1owEtJmDS2xms5MBiwst9F51p4QAwwAdFuwNCJY8JhMEsswYC+hgEKMHdOhCgLYYp9rchZmUDGKS6U1kGg4MLwIAZIJUW1KAPhnKV9qGDoAMchCXKoSmL3a+XO7y//1+rUS///////v/NS31P0wDgL2lSVj3QpYQg0YDND1p9ZVVloiBMwbAkYA1PtL0wDCYwKA9GgxALU0DG0yBCUGhc19BcwSAcwFAUxWKIAhUGGeNAIYLgEoGYXDeLBNEBCAKTTDjB4khJfhGBJMAZhUFZzYIhj0upiWCZhYHhcRrAEhKRMKcUkYQIKnDbPA4005pD5pOpiq2suHAxovgcaW83yjrisNY4MyIfoZLuA004o8MgayClM3Clcg4zAgwae/sRUZxvWJoqAxYDLgQEeaJsZb2ltQ9BFhI06AJxSQBao88+f+PP7h/71GOf///////0+v+7kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeGTjwDHOLw4EnHoGObXl7FQPAMc4vDm6gegY5xeHSjCXgKMIUw21mYit+3QMdhiJx1wIIQ5gIENNCgCFAua4bw8PQIEDSJjMWnUkFatgCYRgYCiM3sDNCDMdLpkcJgVfGRUyigZXGqXDcyySlIUCJlCSgJ6GLwoLAgwiKDvp1Mt04NojxBhZBwaMCHRr5j0XmBAaHDwRHcIuDTR4HJOt+iY4gOB6sJgIDmhrmYAC6HJW1IetI0rzGCjQ3hqkh9sACHCg6wLS2GGCAGsKVQCvkDCJkQUAFPD84Wjj1enmk70P6gKH7JI0IRAkFhQYJyu0nyXXU4XkuS33CrrD+fzmtY5vvl////////caHClSo5ivIIOI9syfeHm7UlJBNW9IobfF7SUAiMFJGkSECwLQ7mGAmYQBhjoREOCMriwueyRLQLCoCgQgW4NB5nUAAYDBBdaaYRRQkCoUkkhKIAAOQweQwYDgaEQuhDktNETXNUhMwWNsR4bMpFyIRCg2sxAEZyOnKB5gop1RptXBggGgVYEhBk4AHDCRzT5p0U2kJwKEiYZg+Q3JGnSwOBYEloQRSl2mXhynClN2tS2A2TWa1BTOy1GhBw02agdh+K3vvJHKAhABmFNREJgj90+Gv1/4c//3ub////////3ekzs2xwUm61gLrUFplePk9UajEQjk7HnaaYDRSFgCIgEFgCKhgyK1xUUBhDMbHg7mWTLovL1mFgQAgmGC0iFxp8ECEqhYEGGQ0D7mRCYzgHgwBBYEKhWOpQYdRZlkKpeA4IAUkmpngaNr4DmhigMmDREECUxiLQgAmFhkMAYhAgIQJo0og4jrFAIBW4vdL0HAhzkpTINKBxOUuceTqUMFMAA8xOZgcAo8/0LcsIG7X2kNflpQQnvb14yIevqX7U5dZKUMA1PXqzhYAIkKm7jwEmXbBgIYZM4WIdiYJAhgQDVKJivc+6z///m//9uljhv//////VWOf+r0bgVsI4VDASfNvKz6JS6G5ukkEqiMVRlMXgcMAhiMMioLMIh4eDAYUDZKjOwLkDEALCAwwCy+BEJwQDTM6wAhPHkeYKCBjcNtyMBGVl5eQRgBFJTUyGpAcdC0YJAhgUwnCaQY1iZuMCmBQCLC0SBBiAQhgaKAcryHwoGTiJzWYnqq1FGNJvFgD1GuGNhCXbT1bo619pNKYIKK64A28cuYdKHXg+ShwNfSSKPiICOyjyq2vqE2a0rpEPFYH3MEB1k9Aq9TiewwsQOCQ4Y3DbrMrRUyxy73Pf/z//eMa7////////hX/9WgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHJ068gxza8uZJx6Bnu14dbTjwB/Nrw6InHkD+7XidxGCCilIQ4+jwSePyWLQdnBUvj7ZioK2cI8pLEAdMhqpdAFGBkAYGkCsZHAzEi7YUAAJLgQBBKOBcahhcJU+Y/RkOGSQMRBktsDgG8aDJgIUmdQ0YGA4CEJgQnG8G6ZK6JtgLg0aDwGhEOJLBjFyN+kTDNCk0FIKB4KgZEBsSX2n4Vga8QuBmWbphYGygOBrU+54qCGNixMO091mzihhZEGa0cEjwopu1d/SILhgUA20pnxHhTKrvN/WDTTLb+ICBkscbsXlDIwABBQXiit7+zWsP3vn97+tfcWbz////////UHfg9NpD8cEJaltMBg6HnVlFmMRi7RNVvKGlri75WEqephoCpgIDBcAwDJk41U8yfCcQAOYZgEOgqAAlQSGWQ4mBAdixBmBYJmJIAILGFYDJxqWO256+zAoLgURBEGYCBcweCI4SHkxqLE1HA8wEId6xoKEJETCwGAS1DTjJGYzOgMACYilCyxYJkTDlTIfGSpwORCYGZxFobkzoGAHgsLM1qy2JpiPJGWx2AwXYdIXcFAWWI6Mri0ed/LtnqHZTV8CwXWpKKCM5czuYwwOCoQ5LXR1WxDmrX//7/9f+e7Pf///////85PSxG6N4tziFYZrYhRv4LpH5XQUliBR0Sgoho2AYigQHGqFCUAMxyQTL4dNioMyOFwwNmCAsXMMMg0rCxncigoBiSIMMEE7oHAUPTEwXQA0YjBo0AlVzIisMhi4BCRMwwODT34oMJQUyQJgoCDBBtZxjRUYyDGLIipjBgAxgLJGUwwBWcjQ1SAS/YcKLAx0znUQFs6jLVYHcSuaI0qhjDzPK8AcXNVd5pjJm+oou6IOFHwISZp8qfFTHPkuqKNjRJKQgGe19AQRtNyuwW9ENpHmbhDfp/uzOzmtf+91P3hljMKx3+f//////uam5GC7B2gJg9ggqplRhrQWp/9vtEpM/sECQrkgMmBwAIOmH4ABcEAcC5iAORxqxhkOBhgQGzOSgATAQGldGeIiGAYTkxTBQHQgbImYbBSqcRgdOJ5EoDGHYGmUQHDwTCgAmCYqHAZzmDhvE1BGB4GAIXMLAAuHCwCShCgaPpoZwexFhQDEgplrgS1AU9jLVkmfn5mQKgGdls8NwhmIXNhoAZlKmxyAHBSmjWnDiwcCSOcc0DE1GXLZdFoYfT9W7CjxMHTZhpm3vs8be1+5q4MmYgCmhrAsSe2p3D//fOf/7u3+////////0OpMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHiE48Axzi8OXJx4Bjm15cdUDyDHOLw4KnHkGObXirGW9MZy36rWctPgRr8PswcGNXpt9ZMMAkmL7gItIAzfJUQbMMDMwWc1xmWwwDQAYuBIiAYgOIYHzLwkMIDIamgUPRtA7zgGIwkCExQSBUs2EGI5s8gKSCERgQHn0F8YPxJQeSYggIKBYCGFScBhYYFIrtJQgYFlFjEAFL4J0quEQCLyiwPeIZCJiKTmRwGuR5mvs+V2piZlBokDmIzEByAwoB033RbJDrImvtu10vvJSzyXUFs+Ri3btTBIAy17/igLee6nU1Okt9h1TMRhEwyCUrXpgevjvne6y3z9fyPsSz///////9+5zxHV/////ogCNuGgTNnWutz56p33m56HY+97suim+oYnoYmDZMHwc7BECwKKxRnHeF6YMFahxhkKlQKGEQYJAE4kDASVyg9o4lDoaaZNMCFg4ACyAcDELTGrFNQBRMsKCAURJhbbGKZEcLFRk0NGQBwkwGIlKKoiEwqFsoMCVTLxYt2tdXrOVbkkCoAl7BocN4cQgLWkvJ2YPVuTqHJUBEbLYNk8VKg602BFM34GAKpKFV1qSQMFXFl0NKnz7LbUkgqyYsTOc+pIDqfzxjNxwxATmeASvHEXXFcM8f3/f3/73uMf////////i9jqpRLWViYAUZpMUpoblGFd2KWDX6ZXE2YDQqqgoRrwN0AEQgMdCxjYFHG34HFpSkHBgtMYiGg8KzL47MIJAzgEzApiNki1lRgQ0CRlbVPZba5TGJUMoBpgygYXKBrWegXumbQaBg4Agqj+YFG4kOQSOEAoGBRgwKGekgEFUmA8hd+s+xa1wAqAjLFQMCgJgCx4DjEhZEZIJDH5qlhrMHA5sbJ9wK1F8IPZmDgE9QyHVIRGfgC5X78VROrjAIn5WMA9cfLdDMQKIASAAlCnGfOf7nr//X//8+lVp5////////Q1P/C/KrSioq0VCv9YW86T9tn6p3RSJ6ph/SQAjxbRLMagV5jGIBFgKBRaZbERh9bGBg0YXCJhsMEQIEIZC4ENglkCEkaE4FHRkAK8MnKdL6AkwHXXKYSposwFQBADMFGI+VBzES4IquYgIpiwGPAxiAqBgoSElYRUIMLRwNykQAhKZAwlPdWtUKNYNCjRZAaFmVsefl13hLmmRLiC0sh6dhhS1Xb6TNQLgPZE/yqKyACSKM27Cw3M9ZvC3kOGBgLZp1CYx+5XsRh12SEg7AjMoJ1nv//8P/X/9yW/////////cpaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB6BOvAH84vDkCceQY7teHfU68Axzi8OPJ14Bjm14Vy0f4rSZCdHMOdzQC5T0w9scgfN8RQUByCXIAhYYFDBuU2mKQcYnKRjM+D78MaB8wAAQaCBEBDFpICBoZ+LAIcwc1TA49N2jZawIYoOFrTm5LAhYPmT4iYeGpCFEUBgpm26cY6zIK/YGDA0LSgQmAhaGCMxAG0hS95gMUmlIKYgAawLD4PQnuCYFDiYoICpr2KhwpWVAzlMZp0izFYRd92YnQXjBQJRqgahh9B6GoZeoSEtQwYEi8MjnEF61BP1kphoQxAAAuETQ4Fkoq+Map5U3AyIA2cNgZFI+2LOOP//f/DGSO33////////cI4p9v///6ZLOQyYCKqQFDiw7y0UUeC1GXTcmSy0gAcBAwgNMGgGHguMLAWMGgEAoVlrDLIbzEQREExgoDbhFAKpkmOxDAYIX+GQkMlwxHgGMPxyCAmXSEAwjEiaYLnuYhgiGAODgAMEwKOIwlMD0yHjaMFBDMnBy5QWUBGDGHEJVABGCmGs565ahwl0DQ7JV9tiXSKAZkLSjynUz15qBfS/g5LKBlt56ndFlTOtTFABQDUla2jlsLmrTNx1XvM8cnrVzRosSeGF3OdnySXYYCoKTL73M8gSf/ned/uv1//lI+6///////9Qt6Gw07qqBrEDD2mgNcgGD29lc3jeisLIR8pmn8YWBYqGzNS0MICUAhoULZsNbgQWKCGNwCAgCYdNocOTL5lMEwQMDIVLJnwfIFmG14sxLUtWVACIwCZgdoGmRjAKJpmDhgfsW5kBunbweYbJJEoQwDGBiQnmYbECAFO0wcMjcKgBxaS5YYz5yUvxgOp1KqHJC8Ag2ngpc7y2ourwLCBMeLSqlpQSMKKD4ytZgrtypfRMH2sGDwshdhxeWdPLaiqTMX6BQCkUgFQS32Or8MK0kAqBACm6VuE7zL9a/////8m2z5///////1Kvq///////ZRHXaVuUIGEI5vs5cFtpSw9LL8ri0e2Mg0WJ4yCDDgfEgEHK9HwwGBTOgqOBnMaVJgkSmMxEkQDQsKAAxanTAQwFiOYnIJpcdCwHMJIdC5lYcHWSKCgSihkSCA0DQEIj2dorxgDWGVAWYRMwCOgMSmQk4MDwEzKaCoCEJBx1cLCqsjFU6Ulo4MAbXU5TKDQBHSYMemJlj6bZniG9kmgi3UCgNm12JQQJEsOxx9UuH+McJm400Sg/nYhL46pKPKmsw8FhKHKW3Pab4sBpjAA78sZZnzL////+f+q8x3///////+7c9YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAddTrwDHOLw1enHkD+aXhsVOPIH82vDmCceAY7teHQi4jK3cvItFiba08uvN0WzBs7ATuL2FRsYPCz7GQwAIAwYySKCYw+CzIBWOWpIwSNzAwFGAkgeYqCoCIZloxGB3oY9A4KDhroNo8mB0iHCVoqQ6cxeozlFgkHlANQ1MHho/uWTD7jCZOYaMphoFqkMQhYBA0BAEvMgUYNKB04KBhRToSEU2bZNAZDjPwuFDcJ4BRBZdIHPcKD0JQEEw0CGXxHr8hUQl+F/wqLiwDd6FVi8EXEQ5bNXjo0Bddn803E6qq7ZNQBYLPNWsXKzyjIOMNg1YBstuxY7+v/+/v/+q/H////////5Pf1WHQrwAKBYE4P5cM6KQs9KKam4fbDQCgBVKxIFBpHMSPBcMwaNhGLjJiIKCmBh6LBIaEIyDVhyE6GAR0AjkYUHJoQRK9MEnRH4lB5d1YiDoBlJw0SigCSlEBUNcVExvFDWgcFRQTDB5EZpS64lACwMgHGDKiLCkKwJ+IfUyX0joj/Lxq+XpYE12VRKXRE3LZwIf3Lo0gGTYWq8cZHlzmOlDZdt+CZ+sNFZIqz5vCrNDwSSgkDB8ypJVt3GhtRJW03gKKpbwJh////////+qXv////////yBdL41AFQCfEkJ4pF5kOo7X0prlWVQeOhIwQCUGTDAEEgOabNwVCaOJjRLGRxeGBwWDIOFimQMMSlRiErglIFB+MAjAxiLSACGXjYthVRd7zEACMV0wyCFlmsgHBacycBkIrh8jMJEEMOx4pLBmu0wMGmxYJCggai3rrhTMmYWFbgCF1YYOi4RIvfzOAolKGzgkfU8/k9ZbkFAZp0qe2Vqgd6HneZjMGDEDqzzgMX3YzsMKgW52ziXDhy1qVzLkJXmLgzpuZR7sY//P////+pM6////////u01NaRpsDLwa93xYTr8h2StQYe1iMP5KoHZiYogQo6NAaleYahGIwdMDxCAwNGIxQmA4dggDDA8J1zCoLJ0GHA+iEQgwux0LDNICUlDBgZUFDAkCyACWUMFMdhyNWQFAwoJfGDobnEJyBwzGfAEGBIUolgIICpcj0EJ7KzCxwwASOGUAUboBn7TwS/ZxSNJKoKZ8ow6lQ5E2+72QAYoJrMbBFaa0MBe4HVjh0MDH4dNnKW0jMWH0mZDHHh7vcy2NpOYIDJ6wXtahQ3Jikc8KDRogHAiO9HZ/Le//9///rKe////////+pSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHi047gx3i8Ospx3Bju14dkTjuDHeLw3SnHgGebXhpbd1JldSWocts0WdKR1oCbBKK8DLQg9BoChAv4aElWAz8BsmAUs6YQmIYeDAYHAAYHgQBQfVkAwrhwymGQ1GBYvBxRhQFzLMJAcAZmGQZAAb9LXIABEgUMLTwGlcC4NvGDRKMV2DMXF4ODwLBIJQ6JC4wQAxUBCAEkACLhGPjwFIIIw6vlNx9U3VDhICFmhCHDIuYdpER/mLyZl7LDBwgJgC5eTXJaYJCrfKdrqipZZNSC38R6Z8EDt0ocfOAN9sxqH8duS8mIYAJbrVyX0pIHQMaIrcpZH3X5b/9///+ca5////////dhDk////////9GMSgg2AMbQEJfLhNo47O2MQ1FaXBbLfI8BYFVoBgaDoKgwKDCIPTAIJzCQCjOsojEUGSYFjEkJBUDQCAIUAcx3GgWA8yrAkqjcYwjmYEgEARmC4BgIEQUCaziEDDCprjSkJh4ZQUBRg4I5zgRhi8PwRNhhkAo09FsUvjDAMFHCwJf4BQ5zjyHH0ZLrNJb1PVhjTC94s5DQ8zhMJ0mtQe04w8dcN8nBp9KpwLAT7vUFwFdzXYmXFgAGnTO4o+6cWV+/yHVdXgaFzkvUnFZjVaXQ2FTAyULfZmLfd1////z/3zVWxz////////UjcGTrdRaAUUT2DsnjsxBMUh+3KHerNgyMKAxigQH6wRnOLcPJAAIfzXAHzBYBBkDwqCAsBYEIVlBg0K4FBUwnBYRBaYsB0MAeZZCgjWsEYBAkiiTAIZDqOYhBOAgXVSBocmfq0GFE5GvYJGFpIoTy0gAJSfT4KyFoTHpKMqPkkAxACS3TGIHc1OpVjDzNuFMBBdZr/PEmY4z9mCx2RBiWUUzAgQHJVKXGgISBjBF6SJDV5zDAbRpizaxW9hnYcFNfFUWNKCgvO56yfWdaSNCwmALK3kps9f+/5z/5+8YF5////////hS2/////9K7FInZSA2KH3SgKM0blsgiL+P1D0TixIChJVK7Dg2mONC4wYGgsFCQtG6gQAQQYQDoYtC0pYFKAI0MKQqbQVCgCHze4mMEgExqKSIFItFmnbQoMV5QzOGAwOF/QKbjbM5MhiA3sBTAJiHiorATBwFkBg4S4AEEzLh49VOJjZTJ3XrYFIy/69wSBmsCBACL8TthmCodfxK5WuCMZTGW4t+8ELpy2zpvREigHpwaLtOh2A2Wb5d4zBvY4BgSbpwoAyPWq0el6hxFDOc3B/q3f/////+/qpIf////////zrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB19OvAMd2vDaCceAZ5xeHR047gx3a8ObJx3Bnu14Z5B6/klE7RgjF4jTahypEoCgGRagyIGBITFUBwSBQ4CplcKhMCY0DIwLJumM4sOwcAosIpMDBhEFRMHRh2IhCDYkFBgsBRjcCYKAQFGWWsXeHASkqWXMPlfMPQFC4Bt+XENVi7MGY0MoQYMIgXGmsFAZiYGDg0EgMWgVXB3tcJB7HnIe0lAVkigPKywKHMeA9HjQQt9sjcH/SkJB1TeUTbnWAgGcqMOs8AOE3lyjzNm4BUmY/IlbnH1YwzdsoDpWlTTaBwK91NrszigURCbmtVgKvjnz+//7///sj/////////5P/////////9c9Ly5QiAENQ8A2JYd3ojIq9iicmVrAveKBgYCJVAAYHGcDwItl+jCIgOym0VDpADBYTqqGAhgoODpcYPW4OXwiM5hwhAwCmgikpis8MHSEDviOBGBCMIwmwQwGVzm8kMxxM1MBwCGchYGmCgmLAcAAZLkwsIB0QAcUJ0t4iqmC4S6gYCHqSgDE8TA1tGN0rkUCzjEwEalad+tLhgFOPPt3lJf2C5G6q2PTMThsTqvav9pmlNPhoCgm1fUObPdwv1myKJgoNR19ohzndd/////9fF+////////7s33ZRMCpRAFF9aLuWYYeR72cwMz+SuO5S8AAGqjQkXhMApj+U4FAdQ0xQE4yIPR3SqBxhyGZCARgOLRgABxjoK5gUBRWFRgaEQYS6YxiACKFSOoEANiwkAxgwT5mCDIIAJvwEAZtWHAjlAxmCIEkULK6IhKRlqQsLBwSNBQjNDxFstGlYr1ORMVgQFBnIEIAe6qosQ+sOxiXNdccMQB4DemmdHAOFJArdJ4iMADtxWJIsSwwUngj1G1nc/ObdEIAJgcBIpEgqCNtfu1HlcQcChJXYpEWXawr5/3+a/+f92Mc////////u3JG6/xcEBDiLMIgdp5I+2ByHeksRjUJWFgcdCwxPBSKGC4MioDmIIVkQYGBQbgUoDOINjEsCjAcKTBcDi9wKDZQkzSEIQm6YWgMAghEohHgRMfQ9e+BhoDhEAK5RVLjHoNBkBQcCZhAARygOJjcv5gEAYsLLKEzSRCKoGYSPp0mAihgYYbO4hgE2JsKlKfSDIBBYQBQQ5JncsiAQcD0zJn5esSMmbxeMTjttuoRCqbiVDj1XaLW0i2nBvv8rH/3dx5V8uAgJTyyEwNVyqy6AroONL7ZWxRT/1/P//5/6qxz////////+XqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeNTjuB/drw60jnYGd9XB7ROuwMd2vDqacdgY5teIyGD/DNAc0YphAUY/cUizaAXepGKP0m8YPhQSgAYZgm45gkYQCBAwFBUSG42qDkwNB0wJCMwcEARgGYKh+EASZJg4IhsHiIiJjqCxgSABgqDCzkly4ZfYIAIw6FYyxAYwCAIoBMvibYFAYfUYaBBMAQSTjg4FAgQDGIkq5hCFAFzOZazKQUHBK4mmOaWAZdKjYcEnFJDBXtZm0Jc78q/Ihe1GqW5TDw0tx2HeYQAgWVySKF654oOGWy5sT+cqZ+9aE3MGgs3NsEnKvakWeroOJmWwU1ekw5////v//8H55////////8hkf////7///6nf9UsZEyAe4APYQKha0xRtpFZnDjx1utZor7kqQYoRpumYgBKAlGwZcQg4YNjTjREQ0slMKDwzclg6QgoAPVjTB+0HFpgMcbA2vWbcLM3IQgIArJZwwXMoeYAIGpMUwhFo5FQ8wGMExnAQwpAow2A8DAeYRg610ChRITAACwIKBkyKBg4BqDFPDMaYGDAKddXZmaVyGTpiQBsHcBVyCYABCuOxPv9OpItNdBlFZReGoEZcRAnQqbJRaZCk1nnHq0wklBpgmBMolCe0j3hXtumMAwRCC6kMsOc25v//9a/X/3kZ5+KyX/////6v/Z1t3ljKUQAu0vVCkMGjNegB2WPOpLs467xfwLhijeYRhEsoxiL8SAQSAUwKG8yHIMwvAZW4xMA9IAwYDNS4zEBEwWNpFEQB2IAMIAFBIOLDl7AqAcYJAGBDmGDwMEwcJGAoAjYFLzLecDhwLjEoBAwSKCYClw8MGBHCIIkLGKJJu8cBicMA0ET0M6cRcy41zHM8ZioChQvNrSsKnbXzDSkOL3Ylsw7RghC0+LK2KBCQsvh1m7o6OAYWSMei8rWrYxxruoXCl6XjUroqDKt3f90YOzEgBiDCG52+65zf/+tf/6Yv3///////+5b9T7f///6v6f91X/vRJJKIUF41MDeWGYq60AVYYlzaZOI2j/jJAMUi5RseToyBTTYrMFiARCIywXAFzzBIIBw2EgemmWVIQGZoUxh5TlCBFR0cZFJEEjNIkaY3xbaMrkMYgA0wG1JPyWDWbI2Rit9j06MOoUOFi+BkBi0MLCr6mFgBhZsecnsUXDGobZpkYaAlqEBB3XSW2KACCmdOBSlgDNETnGlXYLf4u/2aeRlZgII1tWycMMAnxKpXJsGNu5j35QzNNiATEBqrm2SktWZ2ibkSFRi4HB0chbUaTW9/++///vWH/////////at////12fu9P/36QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHNE67gfza8OwI52BnfFwdvTrsDHdrw4+nXcGO8XhhJWcbEA0A8lQ3C2J+Id7IZuHZ+XteGA8AQ5FQchAEGTU6IAIaAAEMDBw6aB1NjAYoMKiNxzBA4b41WHRA3ggvpamXAAhAYUFqjIgABCAEtUrDNqQNZBwOCRgwAEJJNJW4IWx/wGGDkMZCJExSCR9XpiRuXNQQgUXPAS0ACaikIEXTKwYAoZF+joMYWTgwBZsy5UEhkBkhsHB0vmYdqCMEU+yqacdwrUA10jYNGSOKRmMIX9sarQAVhk4sNXphkBY73+UEEwQUHqfL7d7v9f/6////oX8/////////VH6v////////1IlVKjOGlBZxC5prRGRQRDDfvdBz1w9GI6Iy41ApTEMLLwUCnPPgUByJOMnhjrFQDEgKFiAaMGBAsLCoMYq4mBDIuMGOrZ3K0GCZtxKUAYAAko6ZyzBhNKHANAgRA0wUeDrmTMROc1SBzBAFDAynUYBJyKhhMIREhDxgwfmtwcocOgK7FH4dZSh10TDOc0MHAJSlWFuqmKQyfYCZwsJJijp9l1Xnj7qvoYkBbd4w/hICXeMGC5b9LALVrGEq0lOjXswiG28tQBRduYagJE4rGsPQQnvB2t85/4fz//eM3/4kcS////4732J///9GudoC/KPZq0/9qGKRuPy584dpI9FHOCggGBIMkgHA4DwYChn8MYECAAg0YDHkaYMMYlCWHAAWWUrMDwcJgIMyBCMEEGJkzIA0McAFL7GCAhEwJoVoIAMCooCJhCnIQnAGFARAaAByNVmJMVB7OKgFMEQyBAMEC4IA1jmLmCk1yGQpp1pCBBJvW3cOAk9iEOQngIEPVDxJZXW1psTWawyAmIjSMNDOPJArKZiRNNfdIyNwKwlW6BjChhpMMSVkVLfztPirfNF8abrRXVw5p2JDETBAfGKS7Ln/z/7///Pwd3////////86b/////u//Sz/TwhapChCmR0byN1dl/X+eN+oitCOCEBgAES2SYjwCABguPIBBwwkCMwHE410JUWH4DAsY0AIvNZ7cwaLQwIRhsBYEFMyMAyKGKolMQT1QoHgEJQBMIStMRgDTBLsGDoLnIJLGDIZiR9GAoUQ6poYNEIiAhgwKlmC+RgAJGVQIkssAl/A7WpEGBJupacw3RQECZBQuK4iq6MhhAtuvbgmBZeSgCC4209og0O2TuC36CK8BhWyqdpWo5/VuRlrFABhBJ5t+3s52rK606DghR1WN2+Yf/9/9///9b/////////vesAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0hOu4Md2vDtCOdgY31cHXUa7Ax3q4NrI53BnfFwbtVSrf1Q4rNDT3Q2/7413whp+ZA6jrDIYGCAIMHMHwEFgKMwwVFQNMAAcDiXNKk9EABugsCJAUCQvozJsPTBMqDK8AwKGhieD7bmKYMlYAl3VhW4I1mJhEmH4ImDgDlwDAsHzgMsjGUUwF4AQJgYUoJBQqccyQzAQaYoIGNFhwqkEBKyGuuKyN8RkHcBLM6hjkbSYq4Vm7Api4yyiBqeZoiQMcBy4Clkuhy++5fl9CIOZNIZKpGxjcuPoPA1oss9uZKBwveExL2kioKgc8r6Wu953////9/9ae/////////73r///////5VoswoqR4L0g5rRYLfV53f4/7qP7B8BPoFwEz4tLkmxBRhgCYy8CpWYSZGQIh4Z4BkYRhppo+i+WoQdMuKTB2JGMLBh7QGPAppTWXvDAIOKB4IMBAPMHVxMOwEAQMBANGEwpnKhzGPRMGM4CGG5DmCYGqVmAwIkICmBIKN8lWYHgAaeBUPDDuB7aaDKi9oyASHhjUehg+AD6t9uDVViEBzDwQAcCz+uNYicG1Ik4jARQDHHlMOBgUv6YKACunTZG3x/Og2ha8AcCchj5KAL/83KexlZBEIryXWZwvfP1zff///8ZD/5C3///9H6v+qbia9QU92ETmcv+79yisrelNjFpUSHAWMDAZSJMGgkFAHMnhwTCCgMmCgMnPYaGIIQggAQwUywAJgwBoOBcycHgwHFAOdIcDMDL0l+Y/CwrppM6WaMAQUBBgGTYnKVohGCAfnGBDGM8im/AHmIQ6GBgFBAIiQXK5MNwaZ8YGAI75nEEZWBTdLjK13sBdhhQhAgyVJBNV3WbM8ZpiyUwqApFeG5HDzxiMEWmxZ3Y8XlaG6jc0W42YCA6p76CH8L13BsDUvAgG7tNQY/er5PDDiHVrLjtyfmfz1//z////6/f1HV////69B2vX//XSuW3MIrMqtJgvHNuG72ofgqBXfpXIlhCQgwMKoUYgYmGBhhjONApQEGnQhzsUpaiAKkSeTPkSjIyQAjRi4WIVYwhFCoQYCmRYRgoOKZ1E0yNBzToHkKaYodjUtNMNtoBCAxgEBovDQSGAEjeRBVNswICDBqVMwncRgBUDPnRnkRAEAmfgABGPyqHDhSmGX2bvXpB5lIDb+q0qScgB4JbGRYOyySP6TA99jA4Wrdn4hrV3J4IjbVtkVxij375jSRYqgJUdZ6MoVnj///////6n+/kbf///////o9YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdKTjsDHdrw1uf3cGOcXB4FGuoMc6uDtqOdQZ31cKR+S/SAAnIlKgljbjSB2XzfuDoZn61AIwEMPgMSkAgHlUCAKPYMAxVMxWKwwALQIBgLgyJBoLAgOicy4xnH9awY4QyMZhoJiSBiiKZeKBhwDF7IeGHZ7GIQAAwDC95CMRnurZgtjJn0Jpg6LBRCCxOCClqRnQyiAAhUZHTv0kteX2f2KNwghpSdJgQCAXuKwE/8qex2FDyqDFxMaaWvula7cbcp0BkCduq4qAx6hGYL/nn3VdR/rWTNLwJEKtK1pvrFX60WbqNA78TEhnuZb/+/////jY5////////2jt/////1fQrp/2da18Q3HQTBHAoPdTlZa+1Rlc/trkYkTsColMKAl7DLoGV+YjFhVApjwQmXTEeeBpiYVqamQgMv8RBMv0GBAdBJMZwCDjYoLMAgMwuOR4Cod0JKiygRggIgcJoVJFGASmdPgxisaGNgQYPKw8Z0zBEGmUBAqiKsxhgkmn0wIgKxNmsw6r7KL2UzgIEh4EPC8sMRpxGdGNhbAdaxRTKt67XRfJrQ0DrcndkFAC6QBls3HId3eXOPUoVJRkAXqiw1Nz8MIJjakpS2KVPntO7Kf3/////qt/////Q3N6E1FjGkTIoMZawNt6aBpU/kVg9u0wo8YIB6qJkEQKBmWy4YVCkNGdTYeWW5hwCBwIMEAFT5QKw4UmaFMQj8O7wYVQWcFMTCwSFgOFgUIwMRAMGAILEEZSAoBhLiwJE8zfWwxopUxHCcwzFMxIAUvgBAiDgGIiOBoCJxjwVmPA1GBoEAYAk3GBvQ982qgKgOBQeDg/YWik4Gb7QsxFB8OAF9703EUVy6TaxB4iqAsUvr/RvoTAcKW6TrYUBljHPOugHlRgABrqShWyT4cyj76Oy4sDPv3////////n6su+s4v///6P/p9qPZ7+9J3oqX03RsIyqYfCAYu2qdw6kIbnTy2LQC5UCkJ2BhIKDZrw4YoImeHZghQEFhkbCcc6iwkFx4zcjBIEYERKVGZmJK9mcgg4wmvqxQPGrHJb5HssAKFDMjAkfDT8BAwZTBEACYRDj4MTHJGDEACQ4LkeYPMFQdQ4hwUiwAEIAmHommgQ5hAKBgBNjnIQW6SSR4XyYWjSnL7NWisBcRKARi4vyilteOKCxtjMEOOqlONJgogA1eAMCB/aZoUuws82vppz6iAC/6lRIOYVdQ2yUiEGlZ84EKx1///5f//9yK/+AP////f99BH/9A/rxc8lIqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHmU66gx3a8OUJx2Bjm14eCTrqDHdrw6SnXUGebXiQNIERH/MSFa3aZhDEbeFiK1467EdfiGCqAocRiqJhUCCpAUfoMBUwXAEGASZ2iiYOgYBQKFhTC4AigosqMTSlC4yjyvAUhjEAaVBTCMGC40LDAQrioEmN6bmMQVgEFgqA5gMHBvcbZgHGJmqEJhUG4YeKbGCiRgwIZkChUGoBJKPpaRIAJgKROuMALeNFWDXQhgic1BlbK2YLFCwIYcHjQHCJjUcMCFIcirfNoDRxxMHnLTUpjgQxGieBbPN1L8kSqlyI2c+ltLJrWUE8d8spDkFzWGG+f//z/3/7n/////////+Tev////r+ZWW37v33f/VbaZIjhQyhAyIacCPsprS+RcdF2qFrpVFYFA4WCBkYVqamOQ8TBoLh8wEVzURaJheDAaYLFjHzBoQEggY8GBgBHgoXGBBGCqoNAgxSYC5iw5eNJ5OwwcvCbJhgVS7MLl45a5zNr2AVcMKARIgMCzCB0umPCSmCcJhy+dCakQOgAi8vVIrZZf1VczakBQI0NGmZglwFYjPUdK1+s5ZKnXhqPO8/IkC2LESAQVFgcLtalMCY91luDYTLEBEv415oG+Y23dQ+Dhm5ATsZY5f//////+UX7////////9n/////Fkbaf9f1ySDBCosyhKItqkflzXCak47Mpa5eLRI8iCRBC1xSCmRQQ48B5g4DYUD4x7JowNA8CgAHBItgwWBADBWFCcJR7BxjCMNDTkFysDwEaoCBxGIWBFsxYBcxMT8wbEslARNswBBw4hGMwJl81zCEWC4iJaEw9BgMrLUMDKRAxQYNAgh0FX0yaCWdswUUWSi+Y+OgELSFXNkmAy9AOYwPPo+8ksvwVhqZlXNxDABVSMNQkSEYAMfAmvPzExoGy7lx/hoNfWV9swh7N/JIDsJ8AZNksViWH9///v/+//lT////////8qf1////d5Sv7vxb3f1dduAk0gOMKWrxXXMMEcaw27eQbbf1035KgjBRCBIGNCgN4wIMSQAEJNMCHsz2b0JhgoHGEhCgWKEtlpl8lhRcmPAcKko0EM1dGJyKDh6WxMCgNWRYIduxqsJBQDjoIMDok3nODGp9B2xEJcTAGikYSlFCY1SNFgsx4YMHtmPv86b4S2XBcAg4KCpv9+7q4JI/8mbKAAQ0YXJlODIvOZtBht+b8+pm70hcgeKacABrDZZGnm/mq62Uu6wcBztpeLHbf2bzdRwGEhOUQ84n5Yf///7///cx////////+V/1O////+z/lP7PS5qgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHBE67AxzS8Oio11BnfVwaURrsDG+Lg4+jXUGN8XCCodHJHxgqFKtuUmSJchwpRBL1SqbbpHKcWKsEpZMxMFAQGAlMQxyRjewpAw9T0MVhF6DAI2AQAMTHcwsMxYTGDzKazJiG5mUIqlfwlBbfqBmQBwaNBQcCVEjCApOjQQ08wz3oXMDmMxwdVpnhYFBiyF7S+ZowZxHKYKY8YqQ0z5Tt6lYytgBnSXL/P0rY5M6BqcnqR65JQQNl0RhuVBgrO9FiYHLzAE4rS4s0s7/bR3LwUjR1GPN5zLKcf9BElG5VuT3v3//////38qX/////////tff///+r7Vf9Ck///plmIiPGDAMCLjIcC9UUWyvmswiagHVOp4qj5l4ASkI6JP0CgJ0DAQ4wMIMwJjFQEs8aGAr+Eg1expTUALEHmIWODixsxEANEUxZDR2DDZS+HDCdZAsChMEgYBxgcGhxoP5icWpkQC6c5MFqzigHjBQBBYKnrFgjDBaNmgpAwSq6QqaEwFDAQAG1xMcyKGADAkwlkz2s4UgreYKEgntHYCikPDgEPpS1XtYljLVgAwD30HQUdfJsr38zxp6VTDNEWjlKVbu8zxu8g8SIeTtHe2zzWv//////1Lf567////qb39VVn6NGjpp1vHDaYRO5II4qZDdXi9liGXWqQZSPRDJICAI8UxEQMlqZaToWlygqhmZKNK2o6JO2YGPhgyZioAgwBQsYYlnvGxbESZE5lzlr2VJpGAFoClEDgGoeWCwYij5iKJHqQKYCLqdoYEhQfDIAGhNbIgeMDA3uLGuve8D5L3uMUnkmRVWFBFdN6HamK7cBoQO28FqC6zXoXZhpucbfmT9YxUKgWl9qAJLzO1dnGXUqJ0xfEQBs5X7uVOzpmz/13/vfv///////3P/lTn////7/2f1e61m/TE81qnQJkAXKYizKS09HAMmnGvy9VeDgoHhA0DgQ3ARWBMTJ3zMjDDD0kSFDGRRdgEElrjg8IwgyuZBEGPoBho6beFEweZrADRAWYFhKOMyMJuIzQHUDAUBTCZYP7v0xqgyZmDAEDgwWjFR22YxACi2wiAJisjmp1GJDpnIQAoOWyrEQgZmIWBY1KxIaqTUAhyAoMYQZHJJWDKCkh/NU7FGlMPfRekM0zzF7H1AIPtaj2Fv/mWjJ00pbanqiIHt/Yz1Qw8MiEwKBHLT/s1P7///////6nn/Kuu//////+ipP0+52kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABzdOuoMc4vDmx9dQZ5xcHhkc6Axvq4OLo51BjfFwfyLFqZKZBGFrL17zbB5My1/IAmm3jcBlUFGLga7ZWDEiTDxUZIIwuYFGpmMCDwWIA2TFx7jAQzHgeZeKZhJOGJwCIDAbyJZekxKEEBKPSZ6VwFARjbLApuGDweSgYCjE9W8DHtYO5iosBMIJY0DAMNiYYiQdJQW10xCCjjwBXY4tqNqhZ+vJgoJDJmWRqajQMhiGrW4ymarHYl0/Aa7Y3FI/tQmWy13E9YDEIJa9yA1/X/zsPQUAGy1GQ8fajxyv0kvYANDqMv5Bvf////////5U/////////73////6G//XuXI+27tVRQ0MkCaBr3JIKAQm1OV3OiUldSalcshAsbx0IGWw+2AwMHjBIMBIzMUBM5SYzHoHGgQYIEtEChWXZMKogIHJReAYKTJgSC4DMLIlULICQAQcwUxSVjbwYFh4YAAAohzCFkMZ10FDUVCxEJQ4QmFAYDgWYHE6vAsATIhYOAuYEAMrA92H0NVLx0DsmHgAakIY8EolDrTYdVVa0ZWEYcE6XkDQayF1JRQNgTFd6UplA4C0wkEHVttFlueczNvVDWAOAOdM6CheG/jcrIAmPDSSqNveCD//7l/////ZbI97tjo3aa0vr91DYpWPHCtQCQHAS3YY41DSsaZA+7/w++09GjPCB4gwiV0Yk5l8goImJHBnhcUBfmOgsNBZMARccWVGFchv4SBYg9thMFADJDNQgQAQBEF+lAEGaY7GhQJiQpMkMCgNOUAYMUnSEqTMBQdKBCSFCg0uQYGgZeBwCDIvmbIPjwZgICS/SfDcG7jgEtgLnGfB+FAjF2WkwHBrLp8LhAvhr+sIcFQEZNALiLKVevlnmZcaXIKrNpmAIQc/WTdAUBdpr/JaWADe/DtSTyRkY0B7mqpO5F94d////1//ql/8V////o61KuDk0XX3xL0MYfwOlGlNENRRe4D+Y0CZFiNbmLD6SiHHXaPDLP7YUEiYrLASYyDIjmDqqL5EJmHKRtmAiy/Zo4gTAxgwapkak9mNSh0AWXLGoFhJhLYgSZ0mzXR9CgbNyAFHsdAphouH+JGZA0ZokFhcUlAoTiMFi4oABIIEMwsFjCo2PdFUrDwVAjR2lU6mBfSA3iM9moGgBTV+YIizsCgBBpyDABM43oyVASxf4bZmgdLqN0CIDUxgEHMWn4xDn5dqxxqEqS+zvKNNSs77LbjASIuRyQL/x/f///////97n4N////T/9LF1Vrp1q/nauQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdeTrqB/drwzcf3YGedXB1FGugMc6uDpyNdAZ3xcH6FgLI+wtDijy6HoOSMc7v3YnF2yRYhAMxABV6CYBSqAZjeJCQYiAQcBgoOAwVAdxyUBkvjAUHBoEBY+ACXAKUsChmaBhgGAMTActeGUiRIGQoApgawpkcH6gQAAUGjoaGmyYGRoY8gYVgACi8WDzDCwmEzLhN6C9hioGZYWAkFV2055HDU0ScacWsPNNDRAJ0YOgaNPlHBwJVpiksi8qi7QIvKGFKud114IUtkBKDOdqHmq6/Osn4Wu4/lJoQAUir7mLMvT0YZYdJiEn3r///5////f/////////l//////9+pzdxzuyv0dHxapDiOpgFFTVZcOSKA3ajN2YysfWhYoLAwdNJFjaXnBIyckkEQYOzrhtDDAoKUBmHgoEkazMZQC6kBTBEQWMOBWVmDyyPBVIxWCFpemHIwmTAHDwro4mDYFHHoqiA9TM8CRAA4CAWGDAUIUkCQD4DJAPMBQzNJzJJiGYXLpBL2RKnlqyTEYYVIweuiXSiItfMJRXGgV1btVkMHKcKVRxWm7NygOBCkJQZeT3Smc7355PzVcOisJ+WsdZ6lMAIO3FsOXb636/7/////dV+unoqtwL9A96i4RRgCkEs3Bs35HMOpG1ZI6MhkyIFGjAUIDwAAVULMjoIBQCMshgSDSYxioBshCpJY4ZtDZhE6CYWFTmaCKjETCpGJg4oWW9UERvMHE1MLwhtAgAgCJZnqhQhpYx4C4wSAQmGdlI6HQEAEDCchJdswbEsyaB9lzK2hNqztStNHND8yUL9DV+K7vMPe5vy67iQ9Db9RFRtar6uJHE5HQjbylAJUIXAekkMJQi7zDBeSzbyd9uumvGMftR6AiQCgcDshg1QTL8v/X/////99/1nl////rTsb8vetcclhrRcWSVZfPU1G/GADYlNp8OPYpVgBLWXTsLfaJwC3dewWVDEQcRhBi4emMa8pgADgEy2/NffwwLRFAo+24KCxIROAJxHzGoAZh4McaAqbGpGytyLitJaFpphaAmiBqJF9OowQnT0WiMkF8PN4FGrFRYOmBBeHCMwGFBkAGAAqY2VRxmgEw3QFLdh5DmrbACkyAGGFUI/6tSJMOrBNmYqAkIhXK5+k65T7MnrOwojT0rPhUDsqMICKU24ixb8cM33g+Xrxkd5RZ7OZXqa25REH40o5KYXvmv//////3a/Wc////vbelG/a6k33z2rQcu8xtUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHXE46AzzS8Oqo50BjnFwbaRzqDG+Lg5Uf3QGN9XCXyUROgiZOYQIu65jdZBLmNtPgxvH7bs2o6MTDgTWEGA+VAQZpHaZ1sEDYx0KAQBWvBCCZUYKFYCE5lQlCwjOFgQBCw3cG0UTADDQ3BwBHQGpcYNAhnZNGKQMMgpMcwUHj4ADMQ/w68IjAgqBzZbZn0KVBrgagojXmI1n/LI6MBmGasoLVwAsyfBdoW/LFr2mgqlYAGDnNlEphmcZjF82ttIFAMrmqoQIjxQRZbOQ8jRVtbyguBvVWr5pgSHXd7wJAzU+LbfSEay///9f//+8P////////+9R///9Ue5Td6mqoXorqvoqULXbZjKGUnBkojoX6YUpxDzjw+0uy93XkrLfHSsCQMwMmF6E4y+FjBYOaCYWMZzUOhhGQ0MIhh7xEISQBmbQcYfZQ0JxQUmFxIvMyyQC9M+Ag4im6RjGJkTpKxQIwqYMSB1LVmIikLlMwCQR4EhwyAhASLAALAICMIBgWLR7BdmPAasIPA2krx5QdpK+jERvQuUwvylub8EgBMeiRFSUu5yMIfNNk8UiqtfYw/YjA1woF7DqKIT28bmcQWfHwCBqCq/zQNcytt0KgDAIAtNyYI9+9f///////KL/zX//r6P7qR/QbVzNOX+lLnjq+hEMqKEEk0U4QohjEZTopWUP+riLxbcXkwwRhgY9ZhooKiJhpMrKOgAQJGZJpdJuoGOFTGCKACAjGyUwJTBc2YCjGUoJZoyiiLjLccJd46HDBtmMWAIFA5TUwWVDjLTM6r4nZIAHiklzmEhqRA4WNymaiYYHDUg4GgSlkv5uCwDxqrsnEACNFIot8x+LtepYg5RhgCr/uymMx5kDlPS3N9EFoKhqVFl5IDQcyeljCsNTuWEAqQq02OSa9F38Z6jd9YO0+M9CNa///9///+qv/iv////f913/t1Jq+rU+8RQyP7DvQpYsH2OPzaZpD8agNsceb8hTisDRfDjBk5lAO3w6KFhiBjsFAst2UEsECIqFgc3YSMHijGwQwANEu1tjKnNLNPUeBV5pnFRCTBYLRoQAgCDCcHTrEtjBM2jPcFDAoEzAsEVaAMEwOAwwJApbpgGAJg+O5sGGIcEyV8jtM9UsLwQSg8YZmNFZEuKMNReRq4UFFb8fgWpfLzvZKNv+ppDdiGAcDr+mCARpQ3nffLe8ttiZNVMDAP7k9LUccKtR2mEl6ZbE1MJ7hv4j////+z3V7/eL2PepulVU9bIpdLn9IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB5NOOYMc2vDjSNdAZ31cHmEc5gxzi4Mbn51BjXFwZ49oOCGtAwiJVIhNhprr9RtoUNULrWIZCwTYG0kwcC4ANGBkWBgUAphoHBoHBRea4YuDqrTEYmGiKYBHxiNqm/wkDgubPGQJApptVxgEhALiSsBhCatAJp4BgYFmGAYOkcyLWh0Bn5AIQDhOAICAsxDQ8CpVYMwkmM3dzdokxwBCBRrBMAREQABKEJGpmnwhI1Er+bVocDNqjaYqrBgQwHD66p3Ayi77Lhhb7OiMhkrFR9wIytoSG7X/pqsl0pjhaCAG7rmEpib4xCinJ+iw7///////9kX/////////R0///9P602Nof2fZSgbZq3MSlMJPrBqDAE2BkrE5ezSGmjQ1F1lQzO0saW8Kmg0mS4AAa+jIQyCHeMpKDxBVAagDMUGUAS0wgAN1KwxCDB8KjRkw6sglsExC46PqJ6BEqoyUJuHBwoEYPCqc0HsYzNAZggUDQJFgikIWDlVCBGujAAmAAYGOx3BgWIbKuSaarA5MAUBvIFTLQbYvPLIi0jTREAtLjjLqSjyQBXbf2Ny5FGG5BGCYBo0ShM/9p/IrhYrYZV6AwBBKOTzGXsy1ZznIbEgbxbC2Cc1l///////7tP/f///+rv6FIf6sjizbRzG2QGrUL0v29YVQJqCow6rALbKFHk3GGwDTTLrunBbqlArfgvGFwAaDCpctN8wUTDOxIKgLbEYvBijBgFEpqjxFMNzs12CBQbmQB4NAA1khCYAOMsAXpCwTMPaMmBpg4BNhEBKPPPUyK9z3QRCxAFAIOgEwyFiYUAJTqka2AT6alC5UCrP1HVWKVoCyUFtZIgGbOXocNxoBK965T0MmMKjcMCLkVXmflpkIpHvyEg1df+DDBwFmjAwIXrUUXQnZ6t/JX4kjL3XxIgFF+/Uj0aWglTG4tT0X7/9/////+5Zz8Sf//9f6mxO48ze+nIBt6ouLOMcMIpk6H1bzSqNrwINLNlKGLWFHHYm3atwW/rxN+IRgk/cYMFq3mAHr5BhEsITdqRakn6CiTDUZ0hTaOBmOw5NQF1wcDNrzUBUzJAKr1JGUhOa9BDSW5jhiNh2cw/lBonCMAoAw4HITCgBIclC0OBjcZmfmKEEx75Qy6A1NBIA22BGOllDTOncgKGH4XMYJDb2uVZqXFhGbT85mrqpjEWmR0Eg9p1LLoGv/nhJYVgFAbjm2XHvMcqjGUmoHemmkDPrOft///933o//+KzqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcRTjoDHNrwzujXUD9cXByVHOgMc4uDyCccwZ7teFU2Qt1VuLtmEz+tBWkvd/XebjKotKILfEUAAYSpWUASAzJROYehgPBs1oM0CbFwgMLDg42Dw7Jh0DaeZRBzmmYgqXUNEnVaZgECgwAxYCgcx0tTYIaTrSSAICD8sZR+ZyQMjguQmI+mHqoGCQhwDgSZEmU4p2EQWtJUuMIhhBIk0wI2/0IQJ/oxlNshZyZALoRRuEyaPKbORFrk6GAkUh7pEXZEwU9WDuDQLYzyzuxvOUyLqFMn3nlMyMlBGKxTGV2Nf///////6q/////////97////f+q3nrt4s6Wb6ffa7RdkJwOECAOs72kcCvL4dMXlcLdSWROZNIGtIIU5zFmHATZMkaOvqS5eU1QOQIJZeZ9mCWoRgKhExi4RDTQaggipiDg5QCHgUYWZhokEGHQKMgYwCUTitSMGy4yYDkEhQJhoEtGpWWl8kbyQvm1yEYXAbW6juPssAWaX6rs0CsxQAtAk96QNbbmIA+rVAmtVWiT8pgqWNMoKKeeXIeCEA8jtF38bkfvUxdaRZrbg/n6wo1Z1sY1XDndf////////V/nP///65FTOat8y3/M9GhdD5odAYUaKX7VXSoct036kL7PFLbMEz5VDStsjGguSgAqmOdi4BC5n0PkwXojBYPUWMHnRWAHCQATcyEDGbGRQS0gzsWCYJjIPTfUGJAYZOEBrscMmTmDgSegVBk74mKBKAgeVhJ/R4gBwrMWgdOlepgsFmMDuEBJSDs6SMac47aEoDMaNEwEA2xWnya/PM9AoguRifjsyQAGxKW8ZEjbKJc7IQHLJgAAs1wepUeWX5SRoU2VQNOaLdT+s7s1aEYES3fO7Bdn/5//////+Vr/xX////0uHD37KvJIRYKWXW3/bQ1MRU8CVCcox8CaSuzSS3IevONKo7F2dRAZAEwBA9MUmDtYIwsC101omA4MGngOgYFS4wQK7PBCDC0TBgYAqE5EaIOCAyAAEgAYwQLdCe8QcD1l8DEVRDEAIBIKB4HjBICjlYvzBhmDOoFhgHjAwABAcuMOCQwWh1Y4UHj7DIEgpf6GHehtEIwQJSuX0eVoGJgMph3GB55WYwxUgR8HWrwUOhC9YOvw+w65EJUxaSGDiDUuXLn4Z1LKoJmAbM+0xzud3qu3qFN6Am53e4///////+qPv///////+r1H//+u6Qs0oiZrAx3zpZ7prpH9LX2yKVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHeE45gxza8O/J1zBju14dmRzmDO+Lg8OjXIGd8XBGaBFUTsky2Ldr/h1OK7DaxmVOm61eGJEOBwHFZ11BWqmUTcydkxggWGXSYvtPkw2ApAYrK4sLAaDQpEyaoCMJmKQwBQGapDLQXNMHgUuEYBEQjrBokiJVoZhYqHO7SYif4CW4hCoGUQUHCFiT+McEFbR4YXqay7DzOsyUL1hkcCUArVEGjLvoOIFitZdBaz5TYJFVutXn4KsLoTzbR5W5Ew1Dz6wMBQemCog9+m7so3WtcbIwSUpStQ2sWc/PDKHqaApPRPvf7z/////1+/x1////////9////+vRuYfJVFnRpGxi5e6+u1tiUBZ66ImwwKHBRDBpCBDctbL1cxSfX++blPazN6hABIQIjdjCQAW+MQwmTyGAFMHRvMHRJMGwASJW0lwSgGuYwFFkLBACkFMCw6MKQvCoFA0vAUAzrkQPl7XIMKBEMMgpGgSYaYMiYcHkOYonAatAQIgyFgdOoEiqaocQgYhDAEw0jPIVUWysHYwsM3NpooIUDNTx3st6xaD47PtnXcYqGiwBZvy6LiEJbSB5O57cX5d+MRVsIoRvlyOsU/+ZRNTWbVXn7iW1rPKz9hKZ160BR2f3z///////3r////////9X/////59ivpxSe8hTcy1aGTj/qgJR4RngNNjIEKV0tpsrOoPlauXIn3LfyDRkGJh19y0QwGHLJ8eXkY2TC+gNBowCFDQDAUypfAxOFQYxJ/KXAGBJrwAwMDtCOYoALOUyBgIBt0McCABBEKgQRicwNiDGclFnHApMDCIIjQ2GhAYDC6/QEHDBZKNzFpMBFR6nCXytULgJNFQ00upwUNWEN7PuO318wQMxIBU09KbbCI7FHVmA4EWqB0xCBLINDL1WXQdHDLVyJNJlTq3bKc0m5vLKgHAKpF/24SuT7////////+//5T////1xZLgsAizX14yRY2uVAb3liUqdHNnJpqrN1FzWjNXMaNS9LXL5aXBSqrBorTSyXO9NCzGSABgJGkUacLoJmZmPEJ95sPEb0A4lhtJGVGetQMjjZhUZCylyKAM0+/MIAX5WmzqAwTCDBIYDgmYBBQWRJqKsGAxweQBRgAgAEFF8RoMjweAQOKASNBYwSMzhoDHieuEvs6bcF4hQE3AcEjegbHgczlx4vNsvXMYKAqpZXA0rk6E115ZLo+UAd7X3dBjtKYCETqz8Au7hjzsMLOsAwARfT2wjW9zHFFgcG5PhDEi3vv///////eT9Z7+T/0/6GsChskhYuQeXz9zBM3ijsmxRjWpF82AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3ZOOYMc2vDviccga5teHbEc5Azvi4NyI1zBnfFwcNzgulnIlNkBeBHVfrKpA+7tulapoAdlYcMASdhQOWbALRLXfYCjEVMLRFjGJwyhkYgQAODRiwKmIg4aSAoXCxioRmAgIBnORBJDgYDAkoLaGO3MbAAcKZ+MEQ4BbTGkvN4hkEh8MASgDELKW7WI7xMKGCkR0EuHBIMBVq3MGfjoS/CbR5Q0GDSJNaltxVnJgKAmdO57sEIEpw7rMWYJFzsdsg4RiRhQI/tpy2hdy+63Zm19v6bFaMm3y5hDaiZQEQ06VLI89f//////+7H/////////e///7N1z7xrGLQw6VSt266rNLUP35dZm1aK8GDAEDBjMYWdslbmnw6FVVV66dlzFXhZsKCIDD1RcMN6HYymLGGsDMBCYwwMEuZYMAOGxwKJWGYByI2APBAdIoIIyfZpwvDwiirSEe4LMTmYxUH1dBAbMGFI7NHzAylH36YDESLwYNiEwXKrAFw5McxCEMC2kT0J0OJDM8dtVBVJRU+V8BQKkiuSHbbDq4wgDQJX3A1qYZO0CDpSREsSiDxQqMCRG0qdmLOX2qZolFBBUCaecZPIcP3jYTTBxNFtt2/n///////+v/////////Ox///bt1GGiiQ+pOitKa2nnSsucS0eYZHVqa0ufYhYqlYAHIQEGCrKtRoSmSv5C0pRxv32nJc/gXHzFBsLgAGQ1Ez6EwMIF8mCD5zJ0HC4hBTCSyaNHLBpQHnILVBoQ2YKPB082EwgqUrLAcocCAEWBpplJhldKARFTCIhPpyQxkJyuUiERoYgQBGLBoJBIEhVKAcAhjI4G0R04jyNxpm+UgFgUroQBI06lC0jHezkjYElUVQCj7PSzbWQaCX1h1mLvN5BnbY8H/MFgJUUXWjW/fMW7P5YTUz5A+PPtx64vlMGG68Ik9f////+fv/1V/9n//1Wa6BuPk8CEHmG0JTcCthxlfoQtpl0aRlJS8g6WYZxOQEDtmb9iU8zd3pdMQL2susLIRk4cXlCAxvTKBFTJ/EfzNDd/lUlNIqEBZWAmokQXpjDQMLAQa6penNr48ANAQufxwmkGJhkuJ3wMOj1oqMWxM4MARCHhoAthMEicFApWtAW8oFJBwhaq4dlj7eu6tVIV3S3Jpwsl73tWq/tqGpcYdNsll1Wc63Z35LJJQn1LtwU0F4wIEW9wldvuXMuw3QEIKrZqq0+P43MkpRIAUtBHpzX////////2/7v/+r9RZrUXlDh1tDbq2ovePtSfVpuoZdDiwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdQTjmDHNrw6qfnIGt8XB3lGuQMb6uDwp+cQZ5xcGlSRIkhKnAMIVI1t8qaG3YWIy2hg64wQZGpkENN3MChwGgI0qg19teEYqMUARRtWYyYBy8IybQABQEeDAZ4Gh+lwHEMmBRIR013RUBayKAMwdLQELWZoPmCAIfgIZgEuC2rGAmkQ7Zgp4CgBI8YAigHMRojlhcAAV6EUCtsTWvMq6M0gx4ddLCSU0w2ExgDVfais7MF6Yflb+NPSzgR6ouXEjIwPvxcttQxyxyzb2PMT+aYb/7ylUTWAYJDzd45R7////////ynv////////+////+pO4assWReMHyzLcJoVc90tUxq56uKm2xruQxB1kyvAMbQeHBkhk7mkP7B8WeNfr/pBijwZQXp1DSamKZ+MJ9syIAc0MejT6FAdIkLJWNQoJzjXRkhQAutgIaPqOAMFBQEZgqul4DT8ZWA6toFAgEMptZnDlzNmA0RgYFCwSBhg4GEQSMBBEv2pEEAg5uCjBoBEgCzZE1Zaco4AmcMYNFiYeC8YfmG4yvGHTGQ0HhVe5BciUMZhH37Ycj7i3GSNfjhYEjT7GMqy/Pb1qM3RCC7FWnfPXfmpG6BQGJBMQDJhSzrZ+I///9yC6aEoS7nhRZlYqbQbuevBNED2WoJAM8sAUPpDAKWYViS1ixdwJpOZs79PBDkNUq54oMo4hIS8gKnQqDmbWC1llCAeNIDEFWVGjgKzw5hFk8BO5kaUcGKpTmah6NxjUsDgglDxUFZUn8NGyY9gWjI6oNBA4RI0w3EUOZYGgSnuuwwFCcoC1faUyzzBsVDFkexoM1usvXOuVFNjsoTcJhbGhOUIp5hkzGqphiIT70ectjYJACMt3kNweCCGI47AVAGHgsCzg4NVleWfetjb+09U/badR85lnVSOBwN2myw1l///f/////c5+s9//7X+3VdYkjDDtCmoJGYhYgwBygtWgmZk2sBRZI6WTLdQoCKewlZGxM56WMV5yFwzi1yGWsEQLC6IMIlikMphVXICboCAyMxfUBTBSKjjHYukUlwTG4wHCAdoxobG1xMDgONnIw8AEoG2hwAAoCIIyUFAIDy7oELxvKFmEPGZYAJEChISIPhhCAwpIgWWZMDgQwWVDjxuMDBdFZdlmMqBmAQas5G41wqRIXLhpl9rxR4cYxqSB4STFSXxtl7mZtuu8oD3ZB1ckXMFh1rUtyaB+VXF612UIWBFTrSWr8xuWqMkByDvbbg7NfUd/E3//9yDiL7Ck+XiIKHhHmRW8Qm1vGJCg03HG3BxrWnlT5FAuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHg045Axza8OJH5yBjfFwdmRrkDG+Lg7UfnEGN8XBd6YrFRQAdsoQouXkhtpj+NISJf97o/TOoQkU0eDhCCAMTzAYCMQKd9HQMEhcxMHXEAAHMABB6R0pOsHLAwqFTWoSCghEAcWSZrSYOFKirbrjJQsAagTCsiArIjAgVPMTgy8cANgxCDYUmqYQghgWYUBtOBIEI4g7FiUlONcwVkgVL+B0ERpSwAhKC30j0QkysgqSrVgeXX6RE2B5XPtgAw/BkUj5bKyHAbQsaSPc3U1AMcksLt3V25cxw7g4AQDRaWw1ew3///////8q/////////97///lZ62WbbVpS03oINsLyo2lAicIksAraWMULQKx4GfCkAukt0wxUzfpb0bPZ+RPPArEkux1aNSNRwJMCIoFIs6IoKGDlJiCOqNNx4pcKA8vB0QZe2E8WDF0CGgVFT6o9A9Ccmso6DgEBQQPS0wwEUXQwLnlxkDbuZxCJADxIIsNAwFUwaQgLUAYMY7Z5epgjUpe3ZoJfxuSDBnl8DwMSxT5YfCWxsyAqPY3fkNLLEtXfkNl1SIORVu0WV7gUBlZtJLKHfMts/ZrOl75D1HR5uc1ewHQQPA+XvXGbbf3/o//7f/asUdY9ASalLQpJuKOPFAMZEkJEnsayiPeeVQMFiLKgcIMOWnVRZQ11oOKJizJG4LxMDYaDBMFHZCDmUghgYadDJQbTixAd+Yg4KBgIZwCo+EQ+RAgCQzD6ce2jAgA54WEQodQ2FzEHAsDNQMGAA0WOyaEAQFlwSoQDXt9CrmNJhYZA65x4NBQWAoRl0gwBAoFCApE0gBQJVVghwl5Mbch8llmaSUGEBMNpUZn6j1jxUfOESrsWEYKdiVS7ItZJpLFhIEygsjOZzy3ea5jblOlubqKVd1vKZjzpKTr/PTuHf///////K/+pv///joxV0xFDrh5RpdYutDXVlzajzGrXW6FiT1iyB4wRWF8jKE3WASRUQsaVJqqaN0dOHm8l7LFERlcMgTG6gpQDCA4AkZqIQARi55IQUBcIJkdHEtsp2NWRhJWdyABggG2AEEjueRAIh2TQQ5rrMBgsz4HSoG2fmBBydwVRlBjnCwaYBEqSKIio1/p7S1mQ6VDQrUHhisCPAdp0Cv+LBd1WImMJWPAVwFwL7rLVZKY8NwkGozAVLEE/oegxrrYDA4BtSWPK7eAwOHHzn40pz2/uq4NvqzO6S2fj8KvNLSKBNB7swFfCf579FNH//+soXSw6HAEZJyyjzJbpIhRyFtcFAgSQJRPzwGCJIYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHeE45Axza8OiH1xBjnFwaxRrmDG+Lg7CfnEGt8XCILDF1CHIEqRCJgULnxOBVMpOvKtK7dsEBwMnwoBTFASR6N5ElWBJswMTDBhqZ+FwQY1C7BwKL09AUGQLExUBAAkGPh2WAEbFK4sHC1SwRcEKAcL08CAkBBhTkQkE0jkjGKCDDu3g0Djw4jEgaZQHoNhcEMRBDyxZejxMTaQtlfa1mCoOmXZJAAqdOvDrjPYgJMdFFhL+VlupVCYrIoXBic8ESisPB8WIQS/284+Xa3JiEX0+7W2A85jnK6WIpeXJqV3u////////71/////////3///11dDpVhsytAhJrzThpMJISXM5ZYtQgu2lFCkln9R8OBxAwss4CvVyp1sHhyCouzZvE7mhAkhGWB6sIWjAQAM+kFQovoIhYYiGhelYkXYKMhuXhzFHDyGMYRDQw4T1NTLkHUJWFL+prLtMVBMBPgIJgkDQsQDJsHMHhENGwXEaEIOBQEEwYCQIAS6yKphkBmskWNEFYJGpfasqjSKLWiwCAs+BUBLCvfm+7uKdGMRsTDBqVLD8mfeXzcYbdTZfcOvqujMVE8EVYjI88MLb6O5UXdhWh5q2eOFqu7YsEp56HaZ25B37///+hNhmZaetWNg7Pj7eFFUigTCZJhh5lKpJ4WOjlOo0EDX1wPuu1+4eZzlAjmQzUiS2XnHEgw8DQFGLDIkHH6ipQDsdCCI6JLWsimYuOLrMOBSYOMlBxF9i3AFxoBm4CAwWsuW7ye7cm2MbCsik4YIWXggWHjnaYmIQkK3mYQJA8kBvBYxp5CoVTOBgJDAiyV23fa7Aa71jJ1GJD8DhcsDAeDz4KLGCQeVgKZqPnSLAQTBl/FfUekcVSEqs7hqkmHw33f1qWbkF/ae1F+saHUng29Uof7////////97+z////RRa2lXSSfTbu6nW0KHnmtOsRJIcEZwwkULmmIxd8YcUUfd/4KcFlGaxF7jJAaYmQyYOOJCmnMQ8D2jCQ4Kh7UEKAwcVpCwmHAZv4yDWMaagSZAdOMHDDD+5CtHMdBigNAgLMwlMw0HTEwbJgoFRucnbiX4HHYVEocAxIGGHwSW5UHFgkQgIwObzcJkjIcFXVbVWWAy3y3HBM6wUmBKxHVa25ETYcFEquuIWKsFuhF4s1qYCADnTQtarxGDgMzm1dj2ta0+yLPWFyHJjLm759+mVnXdZZ9HqIIaa1n/0///+vqLBkLETLVn4wDFj7HsOEBUbeFZJhNx2k9Hx6i40AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB2M/OIMc6uDXR+cgZ1xcHmj84gzzq4Odn5xBrXFwjayAZQWotwuIW+QjRWkzl1WIwa1rB/EFxw2GcxlHg51AEFnEFcJBlhYUGoZcyYLFpzCwHIAAOkIVAhmAIGIHyRc0wCXzbYMLpmmTcLDwYBZhEGp1F1jEJcjMsAUOwsApguARy+AximBZheALriwFoNF6XGEhgUVFg1L1Aogh4NH2X3Ay+FUoab9JQw9EwmEVItd7/NlrrCmGgGotUkR3BiPe4zKJhqsSa7EhGAcrLqubZlw8ANjXPjkczWxOaHADne/YuUKyYE5NUvVu9R/8x6f9f+hNGiIFi5fQo4VLseUVSS3tYhdcBVD58UMJ7p6mHQ0Ep7BgTAFpshVPL3VdFwJ/Sc0pS2NtBUwNQaSQMy5REgtHwxpRobOQ6+85gGDsHqfGFhoZCqU24puJgaY8cLTumIgqwJg5mmdwsi0pSYUFh6AZmQFQBwOFAyiNeMEC0vWgYzUMAIOBpoIRp8PIsR2X+n0ANFPGYDULCZSLuMrnX3YiYmOAkErlvG21e9lSYOth8bRbggwGCGLbrN7l+GVPDemUY7YXe/uv2o28s7QRWdV9bP////l9Vj7lirwSrCoqQJIHjiKpNBd5Np68XrM9LkM4bEFZzKxMgQzWE40w2qMnYg/rVlC4hAz7qjGS8Y2HZACTBwSCogM5u8MAUTAAUMOE58UQxoFoXg4fhw4MojcZOpwADCM+mfDUQAUxI0W+d5d8QCgFAGCDDoKhIAwuAggE83AP4wmEkmTcdBEeAIBASgwocYfgi19BYFBCYOgYVALTKhlo7KHsfBsIwABAR4QDK1mOu+t6RRcwtCpuERnpZXSoh5q9iMJeX30rgEAqARARP5soXv3PuEkeXFhc5krJa/VaOwM3dC+WTUxr9b9X2/7v/XZY2RcMAI6UKmDZQLWws8u9ywkg0sBACxp4ItPpjiDstfWaZOAY6iBA8ocV6ok9DJYDl77OY9rSmnnYbCEIYdKj6Z1cytZYoiCCZawsDw6Y8hmSAQUOflJigccCjsyBBWkQNXSBwGPFAZ9F+mgQs7aJJhMXH83yYZkRuUPCAKorhASABKSWLLLnAADIBSbRDgiBJIAGwO/WeYiCUfRZMlhwMEjXXZXzCWeK3DR6DgjMWae4rx95a9Tos/j95rocAMCqKYExmGp549+gjVMjLvi0Z/D8r1I3V2cnjhnjP3fo///xRKEIUWEzzokVCRER3pNkRz3gQ8F3Q2belQwE7x4RAgXcIYYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdnPziDHOLg5UfnEGt8XBzA/OQM74uDl5+cQZ3xcFdz8JFykEjCd5FNnlRdhKelZ/Gju+5C/hCQjF5CL+DScAgPMvuwOB5fAKgUzYF00YcAyEY2KlVdJkAeMAKPSYADAuhDBgSMOJwSBSqhdJOUmABlOnG5gYFQADgCYCPAioZjxTBE3AIJSFHgcikgOMPApkJhoKGDyCa+KJgMDKWL2kbWS8iZK7kZjGRORLf2H3fuQEwICA9hcPT9mJOnTztPBDM6OcjgKBtAGAN/rD9O9vn3L7n3FNL21l54a5V1L2kW+/edOec39P//p2UVQ+cS5pFSVAYeVB8TIxMoZfFTjRodF58VSwEQ880kIu2pc+hwjJwnZFCXIylUrhMbrOG30PrhWlBgVFTBENCWZqZIJRoMf8dCQoLGmBTLV3GHA6lghMRELlhSMaXEkwUGHZAAGEQTBEICkWy4va1sEhM1aGDAoBGQcCD+ac0ggnRi8VNIEgkNCkrCsCJ2IkjIAGA+biESYiljZoCutUZYwUueYPB7esGWqp3Llb5oxoZxYBv5RzzkJXSyblEMNUo70tS3dIwMDGIz1qMY9/UGYVkZq2D/vn+f3L6s8CW3hg3f9////1fuWm9LgrDiUzzoOgSQahMGZdQqVNizhVzxRB9jzosjKp2FxzlKLSNomNADWaZ2n2eJ1YaeB52hg0OM6MxwGMLHyACOsn2UNKEZeZuJt4jIZGNqmMYFjBwIxMpMMNjnhEExBgyyOABi7GX4UOBoEAglA0zW7TaQPJgkugwGGTsLSMNu4HKKHSgFKYJ6oBzCoRVGOAUhEoOq5QCl4KidCWw+xBvRCADMIHUlK5HBcpklQBBiJfDmOaPFFTS+hd6QQzUKwPDZa1s2cAwd/9+49+mH9rJkZb/d2VOBBd67KcUfUd/////YNFWXlhUsphYPucWGpSEhZoBWhrRzyw2wydNtgNQcEj2l/k5guaanwO3WyikvFc68aJQ11pJHHdcwqkpqCkKAJkQIUDo0UrXTRJBk1oTWmgeDlteBjAQlUZwkgyGNBAwafGHHbQAKOmDAooCqDtPhwCjM36BTEIAUDMGHw+FcRArgxgIoKBBAjMICNIcBBMuMWAWYjI5pFCjwSzR+iqx4FVO0dVExIMUY3KrwTK4gwEYMym0AwPIaRiPxCF22vSiJRtHqIA4HONfj7T+5dsSpx7RAAe1XUfP/3WtR1am7sbvr+v+n//7NSrWVuhFLwOcSsst0WDtJMm4keUUW55FRFTAfYTNpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGuz65Axzi4OFH9yBjfVwczP7iDPOLg6kjXEGt9XB0HnDkA2o0kB4SzW4ySmvNpVmHzlbdIu/4FFyd5jUONVNvmREZrigoKQaYfg0KN0Ao4aUIRkYEERE7DComOIhcOH4JDI0K2yF0INCgFGKmZeArtCwOAwhPJA4xtJi9zYUL2uiAAEIBMFBZVIlBYVBYVLyNsGQtk1pmLO1tMqMmB0oEcrc6QO31/w4rROI3rcRL3wxTT0eHgDbhicLeTg6BLFuAJDrXd0FrBlGvYnO979yka06nN0L/0/3Zn///1vWPHsFGuoEcDkWSLRuJySKr26w4UeVHQwnZRsyEQgTwyAZCpooOxCyy1xWrMLdRyoFKhGZCdjgMPJocAmWgT4Q+SEpwZaRBSb5hAwxExEGVlNrRjD0ADX4wLHXjoGGjFlMvUIgMQhM6uYw4NI0HC4YAJEQwlAU5ZCwwrJIyeA4YA5AfACMxboDAgh8W3MLAeMUjWUJa078ObXYyqLJUgEImBMkZHK56eixgeDI8Bs9G6aUsDdukgmWs4opfLE1bAMBNvcMHY5+9VVvW0ju7cKe/7ut2Y7YmM7/t+V/////yRBh0keIipo0h7xftYWA0OGRaBKk03CmoXNxdfhmlAckaJMIBaj+qllmDxomsHvxOftjoPMPEcKAMFGwwcAjnQRTNpkZjGw6U1ScMOBVcZhEcjwVMHDERiIFMUwShTaJaRHMnHZNhkQ8BXTV6ZOtZmkZjwDgUwOUDhbfEe2NXAIqBAOFZMBgaEZWARCXeWcDReaOGIQKH+ftuqSzTY44yfJnNbEQYe9qGbX4shMEhC9kusXp9Gh1590mwEwWgOo6CR9ohA8s932b9/6sw8nFA5zbELGe+Vd0krnuVr/p+r9X//+pNp2xYrdDzwMfFTBpD26Y0KPBckkw43XEwmyjjSXCuAYqWIAFTh2mnZqOAXmbfBZMAuBYaO8iCUyBGSqNVAS6AGdHVjphQIYUxI8wyYERpeihbHyugHUQa+zAWM288cIwCaSDXyrey8wBA4w6eweP9WgdA4wUG04IUIZF4FNwAAWQDEQKAAEH6SdiJcMwNBQzCOFW9IuNvDAKCJncCN8HEaqFx4IjrlzbomDgaphxOejFpxG3+kh9AXjunKAOfYRA01/KgcnL9/dilVYHlZ/Nd7zO9BKSc/BlSj/////////7f63Xf/7ereKUocJhAJhPMNWo7JiJDmAcGUAJhKbQC5MWKiVMZSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0s/OIM84uDWZ9cgP3xcGkD25Azvi4OYn5xBrfFwZ/XEDB2yCZxwUxYSGmFJx9VB12VTrWoEl6HMxaRBQFGJAeo4cpM4KAytgqDzNxFS+dwFNJnZgYWhUDgEZDwWMnAAwkeTcw8BwxMqlUWAjYQoCVNlDjFwrNfgYCglK4cF5k+NGRZscoEAMFxhcCFABQCOwKAxfLahUYm5QuBgCvJuD7uJCV/MpHQyYxfJbNdUpaRVqJ7mDgfIZZlD+KKV67KpAWgsxO2jd0tRZtOzAWGt9m2g+1ifuqB2e75NacFxKWtW5/d+min///fUfvYoYqxoBeNYkPj5BjguaMC4BGhlriwWHHGsa8MkzQkf4sgF85RCU+hokhciCOh21t+sAoEGTkZAHmHkQQEGOibLlsBgGboIrFxEi5BMAAxVA2sbEIAJk5iRGdoXLNMbkWdJUDwEl+FwQYx1xnwNBg5Q6jB2MNXUwmUTZgNGAMsweAZEJ0fRwFBABSOlJq8lAoXUDQpylgp8Jt3DEoGU0Xs5EfcKNrZMFixdVWxUkSdz8Ps7FG2TGaqqQjIFAbrXakK7j+UliuTduXFlSDv5YTLM4az7SHv1f///9Vne3QEcsytlYvw6AwkENBGySF5ELKKXqUwf4DDGPojSSOI+QGwJ/oGfqMxCpDTc5LVKpzLhKKBgieJSIBW6gYVNvFk6hEAgZESMAhsmkZ0PjBWAnUwQWPSJ08AdMID1iohkQWKA4wMtjEYcAQEGguYACRvpHjJmJxiIwsiU1JRRVAtig4heCQAbQNTDWxMsjlDIWUsOR5M+K4wuBG6wPJrlPVKBmx7LOpZaa+z+WqVDOV1eJI8TriW5p5f13m5H2nwybN3L/7fet8rZ936f7P///zaVjegXWgB4TYPnzY6uxCaan2CpiLLPqZYXXXabmiIg4JHjoFVjmsidiMurOuRHo/FywNGgF1U3gDMWAjKjJAetgRG5mJGXqGAkxIUUoMBBC5pqiIDE0XUjBlo85ZKAEyBuEhMYCFpO6FwAYbgRv4BAYPg4GGCSGfpkxi9wg6cEIKnSgQmAhioCBAmiyGAcw2ZgdhE5mJzjsNfbJCpY10wEJwMAYk7tLKqR3mirgm34q7jdLP17jA5RVrMTnw4Gurq1J8f/s69+TKc9s/ezL/+leUiBHY/Mc/nf0///9bUIe+tTFQiAanpcEmHwsk6saHQiSHAIUe1ApAiTD5IwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZ9PrkDO+Lg1ifnIGN8XB5U/uAM84uDqp/cAa3xcGdOQGEEE4XIJFXk6st6oWvmbd12IVBLSwYPGTlyHEEDg4LGN6qN2AySGwEi6EyCh4kABAkzQjCCrKJLIqzBUtamauCL2WbGnTSoMboww4HRICrjMCgAHl8w+QjnAAGBRK4PtposKaGzMwWNxCk0jlpxKJOoo4jc9ooASiPjQ0VrltWK3mYA4ESGkn+9UqxiFbFlE/KLiz5eXBe3cddfuet0EOVZVv3nt/zfK8Qajc+X+/T/d////QYGXiy02vJAaBq5qUDSIxRtxwDote1mWHrBQAgGN7wH8gMp9sMDOfdbM7LsyaEM8tEAgYaSjoIY6KgIQMtGWiPeuABPzTmmmGBLKQYFhAEZShkLiVsZg54eifl0zD08SAiQAbsgFhBh8SBHNDBe6xgoJn8A4ZERoKGKcSdDEREGmnmDQEpuWzMBAo0ELRoGS2ahdBTvI8K/wsFevlKojTwPOioBzs2f29cflssoWdZUkErujwXBUH7mdf/5PAySo+mW6s7/N/fY0/Oo7Wvf3//+v/9O9yXxr62gVyT8cpkJLNREPLuohpyhp5I9Rs+thKwoXOETAhaPRBKdJJ4FbKSDW+et1HNf9Y4iKxhsbqABCpGBaa3hSN6SAVDZjQvxRRYyWGWJipBYiaQBgNXZQ6AqODc4bMGgUMXg0A11uGOAcRAUx2UUMwICGMCgpN+JwwyrwHYRghAYIBABEQDSfRNUTFRSYSDpsM2GGwW/zwuEnM3QcAKepABzUCHBQVVjffNT9poZhIB25TR2OigJd16IIlClc7TSFNSHCEKP3KpY+2eu8eqI4Lp3i5tr9Z40TRmny/VPb92jKfz//V7umU2KD9Y1gWSQFQdizySBU+5QIKC6lKAQYjWmR4lSVWIxhUDPo0scFmDlGpDCxRQAoDMId5/27Mjg14GaUiqxUFDdjAGg5NZDQ4ZMVOS/BiIgYwQJ8JDGAgitpgRAqUdcDC5E0cGIEc9lOJQEz50LpJKBAxAK1DE6nDTwLF4GAswifDsNfMwuswqEVziwIKAsBgMKAIwMA1TmDAaYbNJjMWkQbTMl7ezbrUr9oYGFik+qUbB2syPrpAEINenbPx1JWXRiTwSgS5ubSBiIyF5JRXKuPcsG7OD647FO2PLP91fVkQv3jPUWDP+7W6n9jf1exSVNDb1pRvYfF0Oh558LqIpWJg08PnqD4lE3WocOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAG4D+4gxvi4NsH5xBjfFwdXPzgDPOLg7KfnAGt9XBhDP2BGcgShlq5G4pVsVWJeiL6dlUoVrKioICpP4Ma1ND9qUWDEVy1hw4ANBSq5hgokUCA8umHg4UmSkBApmdWMF+jJ0aPqqiMHpGBmQgkYrEYCAocBQYPDFSlMP4EJHINDwQBFrr3X8h1h5GwuMLbRTRfryNfkS7lMJE8Bj0bCwDaVzUvk0jMNhCGqtilj5CALlNFZIyW1T1mZ4gkBv1Zi8C/hlvLOtIrWnet//6pWxFADpsN3//X/f//+n3FyxFhTIJKCcRk1IaLkxzx5lrx2xBQUNkRoXebY9QTUe0lIRpHTomOoUGeaLs9YY0eWv1Aqiy6iqGGJBaNpqQAEDhmprJW6BUJNWA2HOgXQZYGDxMAmaNJi8aAk4RLJ1x0i+aqhiwKgsRBiqLBiGsnAAar5LgGmk33KjBkrNLg8uao6NBAQAGLkQSYoxdQY5iEFAnaa3FGMP07lClUZJE6oXed+cpm+mi2MN1IvUnkZGXUkHdT73H7qI9sEAKHeR/L/7y4pzNu7zko7vX9xfBEu1Wp7zP/6P/z/7tC9QuAT0s0Q5WCZUgQJlSwAeVCoqg8HDAQhtJdjbFrkbuoKHQicDAKAeRTBgtGvRojJoch591pK/HS4WAejyIgsnudDHzUmzDpMMsCpeJVARhYFtyMGFBrACtAUU5rQFGADyZ0KAcBDAh7dtPhKJigNBhLBjBYETGJgKRBM3uKCp0TVwfGAQDhCyUCARzEW3gaEYlB5yk/jwbSnks9ahgvm/CVRlQNhwSUZYFKLFMvIBE2MS6iv2xCBXuiStlaAZ6xI2HScvS5vIdkW9YblE/nGsK8C2ed+3hkubPuF+z56z2/+vZQ0Vpsc16zQrg60mYaUEQRLxRDlDSDLWBsFGvHiAwWLiNgs1xMCsrWKW+OKhMpDC6VXL1RdICRTC3GatyaRGJWrcPXgjFDEEkOJTGD5a7omAk5t6SW2LcGBBqkBwhLvm7qgE4zEAIx5APwFQgINoC1jM8LcSVL4wxYMxqEEgBJa5hAEBygS5j8C4OfsChSjivpCSw8mDFqgMAcdE40mIQaGFB5lzdH/WS9Lkr+MOAGSDqKfqPNJZOwyRT1q5VQTRyHu0r0TE48KyMCIC62FJJuf+5pxrKhljUN2//94MbYlP2Y/7v2obrp/Rs7OsZ2QIbWOEJAAHnCgSMpAo4OKKQ6fAsQBAPnjalkAfSOmWCE+JQogAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABu8+uIMc4uDWZ/cQY3xcGxUc5Axvi4M9n5yBrfFwiLvj4wtYz8GMxASKoExNx2ctYYrEq0Vh8kKBioFLChAUDAKcKHxgIAqnLjmFhLfQfCFXEjCIUJgqahF4hJppAFmDBIb4C6jRgcdFAGR+We1lnxglMC1MDhrDAECppQsCPJpEKxCwoHgKRAZpJcFNQtmIB4ZGUAOD6/pBLoATKUhG14GMzgJBRxpHLn9hxGdLtj+NarotRyPwxkwZ/X+wUYnBkESPKjy//+amsaSi44Vn//D3jc2jq4P/K/3f//000R5gTpbn4cPnXkD5N6QmKkKUlGJOqW4UJqQTmRcY6MiAxxI7Fg8UqRTYrJGmsHfeZhmUvRLo2GMCGxr4iUBIFLZGtMRERxqIRAbpGPgU2XQAIUdAumIQI9smHoRt6mCQQ0kEbgyN6WSy8xNczHoDdRFEwiSD4LBMglYerQjCKtosAhkCMyV+iuXVMFi8zyuWYKdrucmCaWCZUW4LPJwv3n77wVLTCoCeXneUz5OZb45CgtBWomA4IBX51Rxv//crh3FOed67Heaw7lH2abr0N/2///+np2/VXODlJSEEuHMsUtrdghSh7nlyg9MYiIgkLkgZetmEAGDpGIyCNyGeooNhj0grKB08biD0O8ISQDC8hQnjIAd/FpDNVSdElJiaCUzYUaWI0uycAkGFCwRuiJSGTlrxgBoJBAXAEUJYBAAYPFBnAMlqUFRUMBQ8gHTmZQmFQSGBxu5f1RseBbrI9mBQGY6SaaDkyWRuFDzlPsnaID2rltotI4cn6QwCAIRKuW6RDexainWsyivaafQiMAxrkf5/f3qdxdPHUE3v125lZXpjhrv/////////f/////xVEWut1GJwXCxxqmOIMGnmFUNQtOKPoM0Fri9CxAyAU2zQYoKlcZVzhsfd6CqjsVZQ6EQJQESdUQwUkEwASE0oXMSlhyRAlAoGrZGRgkaedeSIMAKhSPObKl/GTBaTK2UUYwu8YZIKr4hAawQXLJj6NGBB4HRIYAqXZEBEZIgGAXMCgsBAEzalkM3eh+PurL32hS4zAohmm+nJTEYJcIw0FZmnpcbbL5N3CkcaVYw2nFcRm3lZlX/vclc+4sy1qesb/8c6RimGX3//////6A68YpxlLTUG5hbajayIu5EpgFCjgPBS+1RtSVqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAd6bTgDPKNyzufnIGd8XB1+EuIM8o3LK59cgY3xcE0kZAxM63wg0eLT9f1WppjP4sxdg78PJmyodBREpILAoABgrM8PgwABXWKgCMQA5UI4BjEghZIYuBwYQjWp/Ch8MyBEwqJgN6x4NmCEijmzpPheKmhkt0mXACXqctF82KTDGnBOlhkGjEDDkvwikiuTCFS0Kh0FDA5SHkF4HSCFljaIGGymAakBuvg6xmxBxSJYgg54GMEkiYom8EQgcRoXSgTZBi4fGUIGFyCIol0n06LJjbTFwGyQ6GatEusK+bKLj//6H/+//////60+/6nqtWySE51bjAJSvXsA3plFVyqn/EGbG5daT8ySwsdIJiVgkw0o0DjYETmSRcCVubEJmEw7XuYCoiLKJKEGVEokAmDmK0XJBJCZgfqdQeEEjXTDRsuidwCAlAEjEcQzEhphAYV0yDaH77NuZKDBr0GKiQFmFhgcuZZiRJFEqCoFYktcVCKmI8D4ESsMFg030eRICtFd+GG6QWvtzWZiEEhwPlsqf2/IWimAQpKp7Xy9BC+c9Yqx21lmzTNedNz5D/6z5KMFvXt0PMf/vs8dntya7/////9zLGK2CyjYTFXHdUm1ALaGUr2HylVEy0vNtVcYOVOhgBbuakW2JU67ZiBWsRhr1Ixh2mRAIVLIHhAYEDxlJsppS8u2YYCLpluCg7LaMGlImApn5HCJEISSqQTKYmYmYLSkRLlw7SUZixvmJQqWkTmHAMbIAZkRQg9ng0ahwBe5Thg5gEDrHU0MEiw3McC8rOoSMswzg5QoUZEAtmFEI0zYd5cJsVqBiyZLlQmzQjAseJwxKJGDsKxFzUcs0DFRPIlMmF3WanESaRMRj0V1nFE0KCZRo3/+j///////r+/+h121KW/ZlpqoO2zKTWtTqRUtmsm1dFa0XW+pT0EJlx0lLvV8VdqOPoMhOJxVIiGyd9Y1UlTbvp2SQxDEHDpG9qVRpYymaZEcKQaWPCoefNnfABD8vMCDVznQnJhZQnGn+bQAs1Aga36mJcdZwhBhhR4GewQ5yvSIHC8vHYUBhcrahzfsICEmHgYtARAUwUCweXyYjthd+HHfvUbSm4GBh4yZ857Gu7MFEgBqUmM5mn5CsJ2hf6jrTrjyt0Yp/bH8//iu2C/8zf3/44MKkXdUB7/////b9SEJFSKQ4zISbgyuug6ioyYCsq9x4WYL2m0F1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaoRziDO+Lg79CnAGeUblqU+OIMc4uDVh6cQY3xcIdiwViAsQxGW/QfjTiz7g1365AGdO8UPmVCsDmOh4wCnq2CSdIQio0GutPhBolOYenjQYZzImCvwsXlQxOGHAUCmJu4kEuSVgD5l0hkOmzQCGB4aACg5wkejooI1sOC9QdTZC6G0FEtW2AwbMBKdBA/MIttwgtxYilOYoK7Up2AoVT4SwGCCD6XeNOXNyorMSjVWP5xrNSnmWLVuZf+6XkM/yBO/lvKkzyxq75/////////3//R///+jEKM9AzQbIoAqn2LWBknjaQ+k8fcVGMTW4Ama052OlhMAQmE6Z4DW4ddlNF/aSszR6IHk6tBUHIQERkFmAAQX4EZRfFuwIHRpIoLdUOFQg1sdCRhMBmojcgCHhMYMERjgEtBEJihC5xIHPsQggwTkCYpEwCIQAYAPJySKGAZcaIDAUAgYImoAEENRMQgFbwEA4iNRtxrAYQ1IqYCzSFGSIQMfA37EBo6RMbSBuOERMCyEc4qmTFAjiiThECwHYKBwojLHgxYReQAiN0Forhl5FzIrqqeHUIRFIoN+v///+v//1f7t+1f129bLqotzNF3VTTSRStTZJTWroVtfvU6C1UFbTmuv8gbvCPsGgLBWhQA1jOAmEypmy9oKctj0ZwnnQU6RDMNg5bZgoLJQnBiulw26d4sqsoALVv2YiC4GD4yoB0vCyTMAA4ysI0OxmRGK8RNi7UmdGAiEZ9BzQneQSm5mUYmgBOeiUUoB0mZCuQVA6SqaJiYDGa0sFga6DQoVTNEj0OyckMTy0zrwqxhTiABvxT4y32VSLUimXPluduhup2WOwY////2HvuQBzUK/X91+CSE70/+s5///2/7mKoFxp4VGiEAGmn2oQDYRLSIlmkHkijXBUCOadYeFEmyCqqyCgh2kAEo7wWgMlLAYZaK9sgdCtBi4CobhxEuQzArGg0wcwtPoYWUnAJ7lMgGhFzEERCFGbtJhY6LA5gokZ6Br1IGFkUHIE2HJkDs4MxBhNR4QYRDZjzFFkPV0lCBepAeMANFEwEBk+iyBicXmqEiJACMuVg7E5AcCwSEEBGifa/DkBzspMHgJlkpy5NMYhyXyOshfzdPAOCV7zWZc8/f/7VTa0e7lFr/1/GNZhQ1/d////7ayAbFNr7YXF4WpcoIKMkyIMIFBw94MHlIQMScFRZaEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGWT65Axvi4O1v9wBnlG5aFPTiDO+Lgzye3EGd8XBmEkGPBXI7cgCyNdqQjcYy5tPfi1qeeIkAyysOGHCrMCOiT6ZCQghiwQu1hZMPs6JFQEgBlEqYKJCTEYOAGagrJzhVFMGJOEwZOwCqgBAplC/CEPGVW2YEohrkFCMGiQLRabLHC8jI0cAELjVw5FgbI32molI6OdUXMGklmt6Bpe/l+OmCQKv+1ljlCKPC1UUhWmvh7ae9jld1u//zVT2n9+d1//q8+DEcbmf8r/f///9Trh90G7Hg4DzHJac3iinjRA0E5yLihJ/vEKOkKGIAjEQYGOZTKZsSanRNTjcEuFWfdZhVHoECKE4xmF0xDGA3YJHAYHzcIRAwKXYYrArlDALEQRMAoow6pwwNAQBmPwEuIgICdRZR+4AQYKs+OIBhQ8KAQwuET3JEMLoIS3gIDRa9QR3GnAkMkoEEYBMRCs2yJBYNsLUZGQDqDTEUGODCIErQWiizywkfJ0oAIJizVlA6WQ6MqrIsTYbg8akPFLJhZCXZiUt6iIxCI2Yjj/SUKSEzQUtv/9/////7f/6q/+p2Vq1KWtdbrstSFlO6Val1mNrOzpItrSRXWswk/2dfQz0wmiogbxf5+XRNaYlXHrHqd1TqLMYgbKxewlk0raYuAN1CFpG08xkRxfwcBTUgFrmgEqQSPG5WBGtzgNRTEQAtKZaIJhnLHzDhgAQahiKmPR2EBgwSA10DIdM1vQC5Ix6FILJhU0wLAJkQwBZemCIR6ajL6jUUfqljUhcF/krjGxYai8cFROkvPAYQHUj5nywplYnZh9F3z12o2uKxKusYE5/N1puvAHdSrn83c5cgYCE2/nv///9/nTKCcUbDYLb4sQUsVZFw8Jw8YKCKiLMAwmdKKQbIQPD7gEZ5u0JyLkRwfKVTL0rsf2CoErO6MEoCLlAw4CXgZSOJWS4GDRkKAzl9BCONSZ01Q1ZPIJkzICFREOIC2JhYk0chAmrojq0mP0gc2Dya6dhgQXnPlwACIbUAgEBywS4VkNsKABckPDAoMIBiCHkh+Yf9rjB7LSTGwrRHrUl6XTbpsQYvdnLtO4MlrZTCPtFWlMhuDICv65v+b5Wv7j/8pMP/XMKB1ugXxv/+n//sWjW2tQBhuXBtqGtCAaFgcW5gjoc9xdiE2NFnpegEQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABpg+OIMb4uDtzrbwZ5RuWhT04gxvi4PFvxvBrlG5Z+wMDGEYRQIBUocxB22LQ/AbIKJyIrBcJmC9AwAhgCOABysyEAUFKomchLVnQMLEXVCinWN2eTAGMSCECwNUFwDeQp7Wfqe2kqKI0GAMeGauwsFDeCxEeCMrAAYABEGlRPcmShkXegQQA4xIngcDV6RWBMG6MYm0cTKoPHgi80muxF3FL0P1IW6lrMYANPTY3JZKsaRv81/Rbkemf13c1LN0N7OZ//xzx+nvZHf////+b7XDqDRlBC10QBgcKhV5IsTD4BGJn4dLHiwlPA2ecMUpCXULakKRWKQ2mIAHKqavcw6B3jgVxH5crryDgrBIRh4xUKS1oWB7+qGGGwEaiBazWwmCAmxZUsCGlRkIUSJSgWAA0eUGDNQlbkFwIspUBgAEmbX+GwhfRgADmAzYI7OZZVpGYRUWFwAwPoptcEQbUBYsX7M3E1QFrq0yGjGkTIsiMYBq4gbWOSbkaZF0iAGFELUVDZyYGEX0CLg4sUD5DSXRCEOaMUypZGgTzjtNmJ4qak0jo2EUT3/9rf3/dtav+qu3bV/0/tQRrZb1WS0Kd2POghRZSCSKDTE5Wofn3QEyO8EBaMvECGVoXFTTa5mquuYloWAEAA+iCjdGn4kUreuMQ3FKB0BkFRnjAKKCADNAsGR3oASTjLXBkCXuYUJCw+cefCBbNaBBwkMMIWuGlH6hclVliF8xMDAKABgAqUBUEnUTMYtohswICILDwbdJosBl2U7nNMBhEyoi2lOjAuPHbXzeQnmRDaEA+0/9WrG2Kg4XtrSZ26RVCrlncd2XRila5dTlkOeci7/8rS3HD/gzD9/zGzYMhn//T///2tizG5hgAKiMiUa4VFHUoe8BVG2Ch4oDzXlyLEAM6YeCpCCfoRiTNJDMQTRpV2oJ2tKheR+4McGzhbZ0IgmYVBy7jCoPS8CggaA3gXEZlsSr6esBEtNdRSIgKImCh2JWwAgYKilLUz+TkTRkCAoWJqigJFdaAuKXfYQASmeVjRiXUmyAmWAUPAgOBqEl4QaHEh1KxkFmhQuTA9/2hjgQFmFMT+J5Ck0FhI9jNDGkGKhJBawO0rGJXMhaETEihDQ2AwRH8hTgWMERTKBN3qUqMtkaaqRugUhkaBypX9/etX///9/7d+1dTaVWvX3dSlJ2Z0XqSRSTRZTaC7UUEk3ZnqVZkkHMAxnYLGOpILKH3xu62sgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZ3PjiDG+Lg4M+HAGeUbljg9OIM74uDK56cQZ3xcEJjoF1y2xoIDCPZLK7+S9pr7u09UHwA5BCUgAAb8yEdFRY06xbottyAMVPPHgAEwQYWNMsOKFzEDcJCQKBgMzYMZ2GDRU0lC9myYQiSgCAA0BFdgYCHgioMtQ4sABgQFxlyjAFV2nUXORBBgtM1l4FA92JHRUV1zI4jcIk8xiGZPXm8F9DQtfW3hVyWDl25XTOhvWT03FHsc91P//x5qK8+h5//36CV4Xb//6f///sQhqT48UeLoEyniI+1bjIPyiBiYhVCKigs5QqxqxYgLKVl0ApMW5OCIDHBQNOiLqtifWaNSgOMN1VjEAOJQfNkQVZwQkdgFOAAUYfAj2IggAONbZAogBnUEBkWoKVRhEHIIzGxPFgshmRAm6skw1QQUaRoTJdmHAEfeCpkyemAgK9ZEKJhCYnuAAez9IIwcDDJJaTbZK84+B+HKELFwZ8DRkRQJXIeQEokaSAuEdSlmixZxAFoEOI83WTZOIiDzJE3Ik/RRi5UqSGtSI+DdakG//1L6///91/r/6v/1d9L0nQ2Z1q6dFkls1nTdCiu6lWn3vQGYrtkpHr87aw8XJedAwZKwUjUIWkr9diopiVtu/81HX6yjTmEpuDA9BsZHC/54bwTDbMI0TRLgMHIjpxhUZSoOBFU2jpgYRoJk5YxMzIIl1cu9DzxGI0AuFSDdwCHjnLdMUj4XQgwLIaSCHAg3ddMuTiV8aUFygsSsQDGKFc1EXBMdoEFAWD8c6W3GWLu5KsLddTCewt00P7lPx6uue5+U7/9+vnhT87KL3//7yqDz3/o//09Oj9iLBYg5ImS82lAQMMQxS3PrlDQ0Jh9ojYAAwcbfNpOqFgEA+0EORlCuCwB/mYsrlreQxMcsLvCxQYaNMYCgvbMDNlOKQAhgKJGy5Bx65oFEU6CkMMKOBrtXKYEBvYYa7LhXUxF9H7AiDDD0DiESgMwOOjnrFMBuMHE+CxoKoHLWW6AglRsgSaMmEVQ6CY/JILjDAZZgYoBrS6WWTes5oIB8XtZ3cXhpecnpreqKG+slmezNj/1qhzygL+SXf/+HKC0kxf933/2f/Tq2lUAdjQugGSYiYJAutSj9yCbjBYbXUEAfOVjXsFI8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGXj24gxvi4PJQ5vBrlG5ZhPjiDG+Lg5pA28GeUbklTA4jmbblA0umozb1LqoWBwU8Ebh6ItREBiQAzkGaBJfw+ARQgeMGgZqYm/Q6Ag4MWqW5TLNiLjAHoFoJgAKA3wWBDIytf7bSBiDcDAIxMOAhYVP4YGJlCPGMU2GogqC5EwmALBwwAJfM7WOIQGYvMZcJt6J1YlL1KbSkjNA6TzdH7tXKIA0CyXLHKoy+zfjeMBaxsO7i5lnszP///M39f3kb5//njlN6BL////+73aWsqUlqSmKvE8m0Q9kUjpg+gA1BcJhgwLhwTjlDXCfI4QUyZtULFmhMmZq7UDpqNMe1+n9dckIhiARsJKDGW2MXD9/4dZoHHVJJOYxKBVXGCgOLCc2KKzAqKDoYncPAKPihzYiIwGzVqCTZiA4lY/bIlsIzGYXqRgOomkQCDQKPAEMCpUB8MGCgGwQCAABBA3ODFRMBcsxImURCYcZHAa0sKCJYjTFIzEFAM8GIYs2QTNigXSqXRki6slRORMCAx9RSLTaRRdZEzyR4/1ubCjsUzrav79//+9///vd9Ve1dL6He6KaNS3XTu910k6B1Sk1uylmi2PtXdKzmlJa3rQWya2RWm60WnT4imtLIlnJ4dkmlBc0v3DapYs/T8y1p+6aVPu5ogERUJR2MpAxGFHglaD0ElkDBTJnLWjCAdwhQAXcZ+omAcAG/SRONMOwEAByoGBT/N228YFE5EQVbmMiIgG+n6O1kI8pCFAwIJXkgLUpatbWOIgwZJKVaw/MhkssTufJ2AEyi/LzSCZxxihggBUnbXc3UpMaPitsWudnsGVUfcKDf/vlH9Nz5b/9/mo/A2dxH2////Z/0iqXCVRdNADnD4NPn0gZAwnKoNxYOBuBlGDbiyAbFjb0JXmQAKUHLyLHqnTGQ8d+ffSUxFxHuhiFDg6MNDJQUx4ClBzM4yl6PANCoyF2dI2jAWiYiGjFjXRyJBsAkyqAmFESAg4Qvh2KNeLhhwSEmG4SwJg4QHaH2ZAdJv0BgERpcolF2EcwUJlMUiBwmGkDgLEWiekvEXF4LSTgpYHYA4AgZBSJlxArgSVCLE8mampDSuaIkwMEuIJDELoeykyyqtnUxIJkemiUz/UiTZBEyyZ6/oL/9+71//+/r/7e71/3rr9NlrZ10NPRoO63UySCt01tWi7JK0610FmzFLDUG1/8CtueDKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABpiCOIMco3LpcYbwZ5RuXjog3gxyrcujQlvBnlG5oUlyAzsJFDopdJYvGpdG2WxOmjdmEkAJMJgBJ8EgZAiZyLyrYgEAczgAXJfEFCpgwNASKJhQ1CB8FCRCo0NLheBg5Fumx13JAtMLiVO0u4PBVCM8SVDBN3NKAcYBQ0EWrIsIbTS53AMBCYx4P4HUsd8okVLoiJLkcB2KYhKQMqGCzEiQGFGomCpoJzMjxfNhCYrubDwsS9BEzHb5QNEXZRXP9SBiNikiv////7/3///3///979araaD/ugrp1MpDUy2dPda3dJ5xdiOW7Xwb715njkPGvGeCeLoEfD00hljokLCJDQK7FRgD9P5QiMLGQCWFwQOC9h5lAUq8Z2TBADV6fgww4D4dMFgEtoZ9UqmRQOE5jH4HKoAAAjVa5ldrjZDEhgMUgYMACbCOR7sDGFggUg4GhdBKoYIQEqEWFK9U9QuBjFCvLO08QGsQ8nRdE4FuANSKBRARQyGdLRJizADHIy5IOgcGcczQiP6igONQtFAoE/5MGKIvlMRiXSUURbVIO9dL/3f//1/t/t/v++3r/qZlJLuggpaLWQSZnWx5kWWjZnumpda11OkitWp1UrroIUUVr9jZPkfqziPuZcBoC3ZvKOEZam2/ziR+CmmxizIZaQBVF+DAckCAFGQ1aqOBiAMmLQi7K1RoQOKYFCatphcxiOaJWmCxyapFyQYOfAkE1Ky1q90PxCsQw1DQRSRBgrPUIYw93TAgNYSDiYTAQGiiZxZG1owSNg6TFYFcV2xVCeCJg3UGeHIAyuhARAE3RJ42JUbwIggG1E6imoSUvGJPlwLmWMzQ6mMoTqRcGmrlgnVjMpLLR/dBQ6CKrTPJ9v+v//q/9VtX3//u1al669ndnWkzsuyddaKC3Vqd66Nbu6aF0kUkaqVaknTSUtNSlH1mqzd/fmJhQ/1CmaCOU0QzumFwiYpKtNFrUELkZZfaVEVoOYoGY8HwJAZmkJEQXAxuTVpwoMjOBeYWoOCicsYGBEhBpi5VCIICRZMDBcCBBTUxCPEAMiTqZ0XmMGoAAAwUAKXgwPzmi+JEUPaICA2DC+KPMIJgmqZ0E+RVCF+3JewvE+M2PkR+NADLIQJBRyCaIuUyTFrAAdEkXSsgiRhQJw0NSGJn0R3KOuibmW6iMOKEJUZv6lmQtk4ZP7fb////Vtqv//rb+v12QWqmq/Qq0KSfSXopM7JrTfdNNCzG7JJOi7oLdzZBRq4Phw5nCxlp9gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAddczeDPaNy6XBm8Gt0blweQOAMco3DnD8bwZ5RuSEYtyI1DlPMV0aUWYn48rby9qbJIBlDTnNetIUCgkMgEYNg2juYLlsqtIVCDAIBoopQIgFd8wKCFKMwgIYwjOoaG8wMFUx2DBNEBF1EW7oI0JT7DxGlBbDwMioBjAvGPKNjEHmYIQiEGygRWXAUBS5LsPkoqQhAYGAcjqspzWJ4gYuciA6QNZ3BtieF4ajvKpCgPGE+kgibiASicIucDGReMzEjDEVstI+UPLBxQ+Mix/WkxGDSNjNk9Sv9uv/7f////+/od69dd0HqZO6F3TQn3TRWxndrLhFC5tdHzQwPSwAVuTnGPSlouSzayXmMYVCgUE3jNGlBkk2ZsGXZAUmiUUlj7M0EZSagbiILNIKkJYYctbUwMTGTdmFUCY4YaN+FhYLAxoEqWAwmPVOThAYSADRF9tGuICk5oWYfGD1AGISnY4dAj5C5UC0oYD01igLL7ppkwZBaqwVATpiUaBHKnB8CbhXhKQuQVsAFCEBh3FIpm4yxPgDBw+pPmCaiLE6Zl02E4mRfTHYxTPImp3dyORQGOQWaqXsmUDFjiv//7r3//3/1f/+91dP+uqguldlrY6p1rps7qZaKkm7u9JE6myKTIupVaq1udEi1SrcqsRlZwdx/oum60881X0j8sZpbsRZrLxUL708BRGBAoDxUBmJwwOAozch0YHQBIML+0T6hAyX8Fg0hKMAFMwGXAEaizBroDjwAMjCNkzWFB05kORgZEGNwE4qpDAoZNuqwxJXQGPxCJQgEoGiAHobMDb9cqMaaIQCngaySxGiEIn0exTAMPCEpolA6ThRL4jFMzNUDonU2QNzURqtRsRVIapos6TPpGqk2UQBuuUiFROoP//q////V//f/v/VXQW96T6rstFJaC9+p9bXdb3WzJLsplqspaNHZSlVpXsiipBnVPrXVQmaCN3V9GxoJrC6CR0uljiNjrQVUfNpsSYgQiUxgIhQGGKBWjkSgCBFMwAEzVYHKAG/oYOVjGBQOrk0eXjB4lDD6DB0VSK14xqYpcps4a12ijAUGkKYPBSvjA4xOWpowwshZ7DoBL3tmRNb9x0WU6wsLTHIHYQ1GXlAUEYCVnBSAGiFnxqECLpkM2RcAUyI/Y4ZOQ9jMqIG6iyZDrjmIu5lQrTeL9nMtWgoaa1M3/7v/1/V//sv3q+r1VK+teup1obmjLZdBGy0mTOHWQSZFFGzIVIqTZlrTrRNkVhkZZo+tLfoUWGg2NyIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHVYQ3gxyjcubv5vBrlG5eIgjcDPKNy7PIG4GN0bhMtgBLUzABCBZ7EWTKwPHNyidZVqWPBJhGBTBQOW2ZMBRACTcpWDAWvBMQeSKgDVg4aMiMCgZHkxiTBoFmNQGBC0YEGtozePkrmlue0yCDGYKMdBxiCYYQDDpQZMqEETZ4JF4YAYeMCAhPNQRqzQzDAfMOkYuhWfslzw7RJhzBogYbCLWTw5A/jqOEaHxF9lnyaDoiIEcXTAcRikgNJIfCKRwhbbGCjJlkSPLqaxFnWkl1/+/7f/1f73qb7/trX1P0kVqQbqc8tGlnaNMypPRdNzWpdfMbs7MtFkq0EmdbpoHCG0ElmjosRjtSuXWCxk1KsVipzJeMToFO1/w81Gghp2o0swsDUYE6q4GcQkGjCQjdxYcECAwcShgAs8AwjlZgALuUaqJI4Kx5UmCQmJX5URgwzs4ch4F3OoYFDJMaE9SYDGBA2d4IxgycDoIf5AE7wMDUudFaiwzcTEYSHgWpGHzQiIswQmHyGogFihBYoC4zM1L40QMMgEfGaCaRDTNbKFSTOOQJY0jZkSq2mWXWPq5mzWoDrFSdNG3//6v/1/266/X+r0377KXZ1VLqupGhSscsrOtZ02QboJro0Ejjs9J1HvEGqNYXQlUpAcjDDZqVBC/SygEibHRknu1BblDIMQfGBKdfDysYnBUVmKgqIggMhkticaABQGIgYLFZkEPrOIQIYBC6+xCIUmTFxXMBAtPYCh426CwqADTxnJgPbtJQJziQRDB6hyccGjg5GjTB5KI2eVBvGUggCJGSF0UwmUmER6Z+MrUWHP2kLwviQj0BUMBkPhABJThomgWQFAhqWysfWGilUkS0kJ1ROIjAMRmzJMplBfOkjIfkFazrTYxVS0v2+rrX///r+r//V1VLTbdmU63QqdBklpIKRZTIpqRZVJMyU1JNbpazNN0qKNanQZ1rTORaQijsezJXeTReRSpbCHU+hL4qLtdLdStWhpTBkxofuyGaVAQnJohsMDpjiE3EycoibeEwcdEJvImoYwARUwQuQWCXcVKCbEHEcxpiVaYM8IGNgVsXYm8F1sMvCYMa+KqB5fmajgE1QIgZCpCMxkZabLlGFpoOGGjyYStFGdQGODEZwUEB4C4DAYZ0dxNlUiRCgZcCXHYtn0CLk2Ui8FzBkfOEFWGQS0tRs9SzE3WOukefZCN0wWdXq2/////0Vdv1ddXuplek7WVtVo0rM61NZA8tI7WiZJWOpI3si11dSCFlu6SaRxFdpitjyBg61LWk6S90zbmSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAByuKN4Mco3LpEabwa3RuWq3i4Axyjcu8R5vBjlW5amrKBeiK4yxWxTItiz19HFU6eB3cYUsiTCoxDBMn+BlcYBBhr0viQLfUMAJj0OYsDMJgaWGAAqh2MFjILAhEQdIJpEQLfM6nJVjUGdCwEU2GAAPAkWBKqgoHzCqoMCDYXLwwKU80SQKE21TKVvUSBgvA1GchtHeJUvECDkiZFKAbM2GwjsNXTMiPBxYURJNFRgVzcgqhRj6khz1jhMaA8t0STWYJqKy6GgfJhNSv/79f/+3//6v/27Wa3T09aSLp2UuYqQVoqmU6i6LnTF7LRS961s7qdSFN0E3TZda69BZ0WcUU0zGW4IOh2wqwlMDABEzILIgdA8TuTlPTQEwwqF4FLwsCG2CIoBGbDcgYsDR0xUfkSMgIDapjYcNBJyQ8MHhNWA4EAdKX4MZSRYAdOEMwVuFD8yYJEhVO4Gop0uUIDgemAoADQOrSYkGq1oiNDaYODhUR3bYzLycGeD/BgAjRmQObgC0wbRoViWGuISAEFw85cRWgTBsUy8gHzlJFZEmDHDN1Hu7HJQXKTekPklmW71f/X+vurq//7+/q/V66tO1XetVJ9KtaluhU90GehWkzpaSVswdFqL30klpLWimkt2STXNFJorWkcToUaLrMRMhrqj+gsw1EWVVX5h1n0Ndp4+9owKTCAHSFMaCAZBJjY5Oy3BboQFHllpECIkFAczowcLTAQQMFAAdIZlwPITTHhlVh4mOyBYYKAQOECbi3hABjThfMjQ4a4wqFUA7FgIE1CkFY0iCj6AAENA1oT8mBAGFNJgXMBoA4fcmyOIsmfKgBgl6aCB0i5qaRzFol0lGGeNpkO9LnDBHk6/WmiPKF///9v7f/3v///X99f1da3ut2da677ooLNlPUtnZEyVU+Mn874cpqYHBzBV35/gfmTddIkGSQBDQSaj7rcbCvZYaaiE5KnDsQAVRWYeEA6AjMoBFQIBkcyhh6Dg8xnWQxMWgpi4gH6hxnswhYoA4SkhOMDj1chiQjIWL3hx/k7gAMQUiEAi3zBACO1Bcw8oBJesYYct8Qh5rKR7AmvmFBcZVCBMC1+sVNCDGAr5AQ1oGQEKLscgtFs6RhFQMHEYcw1TNFD8gaFKJUgYRvKDV5PMs/U7JF1RAXonupJEkXQd//9q/9X//9v2b/7v7Xai2pNSklrXupBZm9SKkUT7JO7uzJIpoLW6qlHk6mZN0FpomLumtBK60HUizdBZui6jwsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAZfPTgDO+Lg5rDG8GOUbl5ePNwMco3LIx6cAY1tcISk0YLIjgBhZjIt0kK+2g0Eqh2C7sk5LBklA0UKBBjA2wwcZYddIsmjS1F0TCQOGTAQhvTBxIqExQQmBBAHMUVDC0hvE9msPetAwKWgUwGFp7JfAbHGEbQaHBSqIsE36JA8oEl1AzOFmmOgK/rz4TmUtdSH3IMKi5MyMyyXUduunZJ+37OTRKXWNal1lk4vIb79DJP//yq8vfuGv1/8/kwED3/////qTEUbFlOcfWgNTTw4XDRpwsYMBYwLC514POKONjipwJCNILFILOKucueeRFTaX6XKz2DxhQCB4XIHIeKCnJCwhMEgkcBYNFT5GKAu87zhQTGKiFcaWPFF7zBAESzMsHgUOiWIYBjVYDSyMHl0WBjd442RQ4AiEwCEUaWQmBRMclUZksmC0YGAU6zforqsVQfFPQwSLDOwSm4ZWaSpRIKMErCdgMf0EBkBzlGhgOcBo04LASeRUmNQkWZhCVpuMmmINLqkSpeyRWjnJrL7aSkZpUp/b/v6///////VX+qtT1ut10NLdaNkHQd06Ck1IKQSWtJbKRSQVQooIWfVuigifWyBicRVwG13vYVfAqCfEGWNA1NhniKTIlaIyvZuzu0buPko3FBALTAoFkg02gwDmQz43NyAsFyQHvQQAEGB6IhUXw4YOEZIigURRGZCqPy0AAOZMEXqHAEsxYpjtvga4tecAlB5qwyGG8UMBJjo0Jn8aeUAEmALKUty6hocCCwWazfNyBmBFB2iugY+eFvCY8ESHsqk4GFzU+pzogOQUvnThFjdZeDtOYmtAW1tNZWUm0nd0ruTqjim9ave6l/61Vf//q/f2W1q1+ylrTRUqiylIKuylpIHlvZFBSlJor0EVsgySGko0qOGq7qPoqs8yXUtkE6S6bHUNSCbUTd4c+97Tg5hiWGTkqpc3CfxjUNQNIoNd+WEgUFHGSi51UBtSTH3EVebha1htgMfYcCSCEw0PME+g5eAXpp0jETHYGOQSlW36YxiB0YMDKwsYJT8G6hi76RRqaCwRMAuKuZHVnCN4QJmIm6XkTfWDZ6IS+ZaqAD1rEji2Mup5QYsHr3s3+e6dnVf32u3cYA9gV/+1df/MqLc7/0Pf/9fYnLWf9v//7NSn6h6wslAmNnkqnmguNCbFPDSV0HChRx5xw8aOpEbQWKAVofJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdvfzcDHKNy4/EG8GeUbl5GONwM8o3LmUbbwa5RuVTgA4OeAvERTWcYEu6NKleeHFQOu6z8QNBKAkBOIRAswsNHPMwGuBVsgwBCTzaekYYeCNcFC0uMYNCgMUy5QMEibhpHmFToriGlFXWnzDzFMEC8OCq1RQQGB0CYKrAOWBACCYXsXCoVfISA7apACEbGeBwIAOuuUDdGVEFxSJEhpgaQ0JyICRIujvRLAOIkkVE0oyB4snkhWp1AuiDECMTNjhE+6h2KQya9SyUJ5nZltur2+v/72qr92b29W1/W161N9dqCS3TUtOgikp0GWtBNuzs6CalWQZBTrXN1K0DNDhKKbYAFUOxsMD/JC4DSIyNCn8yDlEdGxNZYEsx6XkjUNsowlD0EAFMNgkkAhWHQYADMQNgSJigHHnG8zdwCBI2DQ6VQKYDSBhUmApBGHBCaQCCtpjdAiwBR4exB5LYZTQCUIQC2qmBhYc2XZixSgADtfV4t5nbrg0COaOAMiFJjEQMk9qay4PwopNDcBOEKmQ4njxFyEJkCj4Yw3dNyKqOOXhcrrNBcsP6qgk9885tqPtqWUh5nUf/3/1f/1N/7f+zdtendVT3XfdBN1rqQUipCitS17GaaDqWtdSDOtDdF0HU273c6zJK7oGSJlt99VJVmrkODYDdmiGAmF4tccVYSRxhSx36CysHFwQFi8aCQykGaUzqSH/d4ZFhkgeKauMGCd1ioNHcFAWKqgWIYNKJlkZIhmBCSTDRPt9GfMiMNB8w+FSIaiwEC4LNKlgwXYDagACwUKA1LTBABh9RSCGeAQHmUAbEHHfk8QA8L4i4nUDZqg4EbZgRYmSqLNAFEE6kyJuJ3J9Mwizi6kgLPUbuo+Qa1SiRlvHS6rIrURN1rb71P7L7/11f2/9//avW/utBmqe7VqZTrdnsZqSSQWmpTMpTpLd0lJop1uy0WVppmiFazCo+nWkxuvOm6CZ5TK3nNLuUrcKmjDJjLXA4Y9LWXfcPBXdM82TY4DsjIZBwQUzMMgBUoRE3KjwUDhgoQL5L7BxBvAIOCoMM3IUABAaKQqHjMAnasZUKjhp3JkNRRFMhjEBOEaIw0ER4HHjxOARu47YViw8KAB2kRZOmkk6DgyPAV3dkXG4REcZXGOBJaSZOmJgeIcQoGTWh9XcxcxNkTYvDuTOJCpJCEB53fZajdaKqz9tZQMXXf71ff79v3//+9ddv+3+ylqs9qBxBqk1Jmk+tSCaDJKTdk0aC71KU13vM0Uney0WNEUJs60kUXZFSqCTorWcg1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHipA3AzyjcMhNpwBnc25d1kDcDHKNwxMfnAGt7XBTZIg06BCaOYigKlMJfaXPE1Je848/Io1cUIBl8AJbBC7aUCpLAbkAkWmXByqxJ8wICH5BwrKBCYICQNTACS5gYVmvBMzhFNCWMAN+GHJbM3Jj+RBV5FATVgIMVtw4kAAIHi2ztDoggxHVtm2BwsMvgMiBdeuQheK4y48A1AgLaQ1MunigRJhygsnIialpUVA2NUFidUEy2Mc5VdMwIRq3UfTU0pJL0EibIEzGP9/1/7N1b/qbX+/1frboOmnVdSOpSJmkpHRdZgjPXQTTSPLeksyoVrosiyCD+yKJkigkizpmiNFNN6Cc/Wg6ak2Szyz64ZgFhQJTN2YSQXupg/8ta7UePJ6LTsNqVBEvXJTJgYt6bURP6wxWs0Yhi6RwKU2JmAiRd051KEIGJJ4gLDOQmPAqvh1rzUHFVVGMsxoXfxhgINz4LYCn4KE3HZ4lCseHUNpOy1SZEFuZuEF8jCoWjQfANeDSKZZMyqPsqAiyJOgm6Y1C+xdSKi2UOYgRNKil6jJ2yg+y6i86kv/////7P9uv//bZX/rZ3VejWeRnHSMzePLcAhJdu0byApetSfUat/i59YJJeJ50tWQM2eQEVFONNWmnXElPL4e2fbhpuLNyoSgUURUDgARYmfxa9T7ioXNegVXzERACVURgjpVkQiBKCGmuWB0aIIpeAwwGpS0dMlTJ4DCCAMhgx1FcjIeMenMx2UxcADgcQFPCpJtQwBLaLyCgsNSCxny9Z8qkNMBWSLkCA3FoNuYipkxOoh7o4k0TM4HJE4bmZ4UEyiYFkmhJOs2Iv2SSWiuRqaqDuR48smi6m9VPX///Xb/9/90//XZnvuipKupjdSKNbnaN0kk3WilqWjZVJaSlsildzVk3TWy3djhko2UZlxVbn2UpSCaRlUhY4zxMjJQiShkZJEgWBjtJD1icmJbGYjTvkMjZclVZW8ugZmfqMs7VjCJNQt0UPKQdHWIneA5ILgYOLVk22nkBpiGYFV60qgManTRQUSGFHSwbGxa5gT+ES6h8UURUFbinwvFENLcFOD5Q9em+zmM15g4fqNczqUj0iohHK+tXqacx/DOzupE8pD/O8/f/97k1z8uf+9/rD7lbv/+7+7v0dMrQlO0mNOi4IsBUTjYRFhhYPzQRYgNBh1BEEDhM6KiYQgBgEEIqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0eLNwMbo3Ln8gbga5RuHLI03AzujcOZRpuBrlG5W0rEnKIqIGGW7lpcK6muQcu1pcfrtgYOKnBmIEjICqAOCTWkyGIfMCFjLlJSmJA4OggxooGhpiANTjZwECnh1Iyr4zsxlTRnSYc9Zi4sIQhIxqBKNm1qAAnTrgEYDlcrpJROlEhFmyCIwUFMhaVN3RgcdpkWQwwyoygHNBgSKnx2pKScnCFY3cxFClQwROi0l03WLdHSzmpPV1zeXGlI/2UTJ6tb9X+1a/++pu36+/r/3ftT6SnU1u6CLshPumYKRZR1F12RQScySTmNFJGkg6S02XY6gpmSM61rQQmTovOLSW6rG/T8VisMs4CAJkBIrvMaXSEKwqvS2U9Fmot9LZ1nDFSAYmIwgyMweBg4CmDik8ziEAmMEjCA20Q9gpEVAEbvF5gMlw+Ih6YLEEGgJ1S2C29XZBgUCIdCgUCJAYNDZ4VNGDgcPQIQgNG1XjEoU0p3HjMBBUAgFPypJCPImRUjTMhgGoLDTJktmZ4ok+BkUZBTyLMRpqZpMRd0TAgyiLGFkb5mV5T0G2VMC+ySHq/evr92pfrq27/97/67bVXsuqgs8myTUHvUtBFJB1Oyd8/WyS6emjdalOktBNb0kTbSMlrZq0aTIOzqTqSQayBxwIFKpZmxp1DRjApQNBqsljjs+uvBOSl3hkUBS6SARopSvAx9XjEGGCg5vRu4jSQUYLsMFRh4YHAowEeGvYEmZyJcXXNGNqqlDLnHT3GQAFHiUEbS9Fx0wZnIxVRJjkWQCJZjwHAiwZhQMYScMTeyAx8lJYXTIoJzA5kcLWxmCVLxiaFELDiolPJrXND4ryRmmNhQtBupItaC1HHJtrO26lpuik+3fv3+pX//U/++r73VQ/19KuhW7J1OdVZFBnUykFqSZSSKkDHWtJl7In1smnRWkkmrOHrImrKRorUit1UTFM+WhkcCIBQSEL3iKIPGnHLjSeH1+sAtOE6bhu+v0gF5iIHt1UsEgIBBzSRIGiIHJmBGQINv2FRIHAk2AZAIDwgJGAgaaYCzUDMAhGgezVuMONgMGAMIV4cDVbjBgvO5FowcZgUnlFWlOqtV14IbVkoEDoNBi4mWvwU0isK4eHaANfJEm0Tx5EcIByQVIxQN2IHTTRZJjIkUCKl2h6zpej4QmbdS0jd1s3XUrfq/a97/Xv/1/9179l+lsqk91MpBze676RmgtNJJVkkW1psiizrTVTn6qz1SZ67rdBUxWpF2PI5ipJPN0FkA0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcdgjcDG6Ny4dFm4Gt0blwmCtwMbo3Lb8gbgY3RuGnFgIrU4GHkAgyAxQFgiZ1t4F6u4ziTN0hpYZMogAwKhBYLMLQoW3EEC5FlkQOoIW3Z6YyghASpsYCJG/gxgBic4aJcmZkL4s+sQA0lV4CaQaCKRXcaiPmQz4laqHKAOAIQCJgYQkahxYBBpdKA2KS0uieRyg9QoDGAbPMMAiK2MisOgLfS6plLKcoqNhSJfeM2gK3SWYlp3WpAqpF0/I5DoseJez119b19f+r/q9X/X6up7qd+vW9vpsktGnazWU6aqlq07qSSQQRTXSTTazMpS3abJn3NmBC4KF6QHMtosAtCqiEylI05ZQACi8rLlTtZc5tHs3I2FWnYcUsFpmolDg4ABwIMCFPDyOQUD9s9RslgXG0PDiY8ULkUxGXGsFYOEDGYAMAF4w68ygQVOCbCIhZHUqIxseaMlg0HRdz1CwqAMIed4GtqbDxHdmHMLoxhMj5JMYQGiRijFkpFB0DoGLIC2LWi5FT6C2Iq5wyJ9Inklqv1lWR6ND1JJOktf/apG37p29l6v1frX7K/v/dTVLvoIMzHlqWaK5itBKgki1C7pOkkgpBSCaa0VMgzILQRMEU1H0nSUgktkZ9FCix5CkZ1PS1libXycoeU1HRVLbKqIE2xWlswzepocjghBwg9ZIZ0MkRIaQRsQZuIAY0ZCa6vpvk4zFCcoFjEggVGwzvERgdMZpImYAan3YjrcEpRELoJxotXy14x4KFN0tK5azYyhzgQDBa50ehkHCKcMBHnhsvlwcsUcsC/AyV8XCRQ+ZE3HSAsGHAtSKQ6E0TBIc6miPhQ4TVAwXqdnSIs8xNO9i9OP//1629S1ur9X/bV9VXWy3r+3t9JNBRrTQshWtkKKjZN0lOp0kVpoGjoJpupaLMkmtNkqCCZxy6UAx6/MgDUPplaVjM1iAWq0yoNQJ42IuXOMBhiWQt6XMFCkw4phiCxoFAImxe8hJMmGH5aWFQOWEwgDQcxyYITIzMBAhcayDrHGZFBVz7L8N1ACQaaIpxoiAUzPvqCRcDjBOpabHFg2QKIQVsACxkYAz+RSEmCHEaRY8NEDTpBnB5LpiTB8hwJnymXkXQF8nOsxukcIoogKdZst3zdRLLma9rJl62r7v9L21V/97ba9v/3/V/T0a6SDqVRatFeqmeTTUikpnZFlJqQZCzMhM9bpUGeyGyLrRo0VKUbObUUlaTObsagAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHAoY3AzujcuBxtuBjlG5c+jjcDG6Ny1/Gm4GN0bl4llKwmvgHHFsVdtFXC2GGYcdxiUqht+pYFyMaImFEzWzUOmoPY4heZcUrMjbtv4AEZB4x0DFUkHWwBNjlz1Nky0CTGeFWNjj6lU0MyCkiRoGKgSbahmROY8ZtVRVlyIKogABN2XkoYZSAJWq4d8lBjiCDERH8DI5BRB5QUkTRSACFicUTiaRXWZzFZkZnByYkR+7pqqUaS6qZN0Vomikvfrr1rd7bf//v3/W3W/1q/7aV2TQU6lqRum6CmouqmcpMtaJ1NM8tnZb0qlqQqQZTuZIzZOpOaINVBMMI4AAjcBNCnICjAyR79KPS5X8CtnYU6kuaJKHcnCUSmUQslMgaJAAwMEm0iTSTHQTg9lKy5EAQ4QgAxogzAAiDD0YbEJn8DMDMEFooB0FOOupVYEFouk3zKi6J1ANGGFAHJx0FTVU1F/teaTQCELExFpJdGDRNEc8jRaQNEVI0i5VLqRfJwDAGBkijPHC2TB9lj2bGZYH+PrUe7lBBRBrmPukWScb1f9r//16v2/d9f93v/1W7UqTppon0EDJ2SdSaTTOi6bqZ9NSCmW6GhN6SCnRWgyK0l0EFmrIImbrmzXpLsbrY0xBIw2qMs3IFOJElYX8hptGZuZG49nK3yHB8FFaBEhBAACmGDifag4QEmcgFCvVt2SAYeGhAyIMBiKHKQhPTnSpkY0wJyqPyJ3H8MMIAU0s7ZcnqctFF5ggqUxIgRpgoJN2Lnu25YwLCoQyGddUzHeM8JMXRKIR4jRJhSmL5oDeEYqCB8yJw0RPsRRkFDSWKTQZFPRaX1k8nH9+6c0TSaqtf/1KVe/S9tvV6nt+p+tb+rRujUihUlVdekgixxAzTMWWxqxupJBOgyzi1s7vUylm12QdzVJru61LYzTek60E0mSSWp3c9tOwJgtEGqfdSlZix3DfZ8aipZqKy905COE5iJOzMoKxoAMXF5HOAQhHAaSwyUCk4jO8JtLAVT4ItzCCs1wmDAUwcLQMZ47bDHXCuMBoEHDS6wqVHs4Jka0NgAiBnnTiRqjrsMkzT6MDI0+pBTFkpk2PgdwqQGfSG5YJY6iRhqFrQmhPMgsqFpNNAZRSaRBjpKrWo8vlhlkNT3+slv1d//2/9Tb91av/191avW1dbVup9FkGm1loo30ktSdC1e6S0mrQTP1WTTqVppMtSkWOnkUVKZa7I0D/olgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABtWNNwMbo3LnEgbga3RuG9Y23AzujcuNSBuBnk24FSOoUFJQHWwMym++Csr2txisehyGc4nQvkEG0EEQoPABhRKj5ODA0Y6JxdpJVBm/C5zBxiIiFgkrKxg1OYOlaCJffZ0VqMRVILC7C4HWyCR4x2zMbd0D3LjDHkW1NCQAnJSSh5IKsBhiGS+OkvjMnyuBosxEzVMqmRWWGuPmtzEc9kz5sWUseI2SrdWuovLJ1TlxPrZI0SV9b99W39Ff/+3626/3q+1W69q1MmummcWgtBdFIxOM7J0WUip1rda3WpkWW6aFa1LW2gt1OmtCkgym3dI8tlmrG0iyh6sY4JB5M3RQFLxIUltZXq8SvHJibMqjcZsLB5sYEqiYYHKaGMB0WbEKEIcKrUiJgYGqFarkG/Go6cDXcg0bQPtdHRNUrDlXzEsMBLDhgAoCkZgugm27QNGScMEQJCygAL+6htyAuAhQSNxJmJObyYE2PY4BNoGAZmRcGZTJwc8fQSJnVIsiOspoMZDmskcG9HQ9BfcyTWQ5TI9VCXa/9S1Vfuv1fqr//s3v39aqddW7pr32RQZ1KSZ0U30klIWQWizKRTRpGK1UEmQOpqWgyVmWtSkkEzVakFIspaZkbXUklWgg504yW6Rgz4DaxWUO5o3setw7T+P22ksjMFtzJBIMe11GIjqj4QxLrhlAQYYGR1yQcKuMUBqJREMFzCiHMCKDqDNG0EECiDSlHrUrELuVgYOF0BwhITp5owSTB1evt4VQDga0dKerLCoBhms4c/iXyIEoIWIKK6Bu4osBDDdNzU+Kki7VEBSSNnHOUmkQeLm1lqqlZyhmZ+rWxW27q/1v/Xf9VXrrQ76tv6r/f1ILUhQVWhWeRZ3d1I1omqGiiyknSXZF6nUim6aVNaK6aSSDGswWdUkkt01JoKUYT5cVmS9IGQsvLYmo+DPDQmnE+X8cZocubG2z8vOzORoqGPQamgYWA6cJjUM2m4CEMmcxKuJVEthECqAFYjSYGMEg4WZQ6IAgxw0LERH4QgSA4u8Bh0XmlgaIQA9ZgARHSjqYYCpWZmVKkd5CdD66WniwIGA4aoEACAs5onjAnS8ZHQIWHOJonlmqZIg3IGkySJsTpsfdZEnTMiLrHPSpH+tJKRqbpv1smk6/1fXsv6/77f/7a+3+vvUpVfd63scSZd20bqW610EUZopJBF2ay2UtkKLI20GUeqOOeTWglSMZ+y2ZVbOt1pngAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAbxjDcDPKNy3NHm4GeSblsSPtwMco3DdUgbga3NuCqGgOBihCcZbJ0kIiNARGj7cXVZHL5LL2wumVAsYDAijpVFAEAIkKHkg9PcwyF3XfoWIbOiUXMMIgshmEJswCRjRY/SKCw7YvVZjGo+VhZ5miNDMBAI5EPTIBUFlci+xV51QLDoZUbiwyRGB820kBFh+Ph7KRmBuigfdjZNEtoCedsfRWM0lkBQrIZHzmBv606bSY+yRhXdP+n1/b/+373r9X7q9r77IOgtGg62RdVKiiyCbVLR1JMikpaLpG7JoJoKVUg6a0VKQTSMEqNZxJlGTJMzrNnM3WtGb3BuA8OM+Q5BLhkyhPCGVlEZMVdChjQa1e44LQhQQGVwcsANDJOgyANHQamAAcYLJTrryGhTPCEFw8aGCRVEY81nBGk1ABMQiICN0TUv8FFCHSFtmcmCwkdfL5iskhy5EAEYK5yW78M3l7EjAorMDF1CqU3DAhxHD2mM0ARpIEKSRjdIkydUfeOpVbkQRW5QRJBq0tlrPR0al7abWf//+3/76urqb/XtqfqajXoJsquvU7rTUktM1QSQZF0WVRUitNKkcTemhdVF6K0FpItdSNS6CFTXdN2UmZKQRSUgixkolYvY28N6p073ZE/DSHHUuYO5UXp6eQtbJRAJCtWwxoG0UDAQJb6ItYMlgZocNg4KP+YFA6jC6QKORp5AEPmsREgsYCK0MWn2c6VkI2CAM/EITCOYlsyCUh4PLgcZyhUKTjEaGARkEiSeU2eyQEYTZVF0Q0g4GtGm5AjBzUxJUUUmmWigQw4XjiBBjAwUQ2Rj0z/zajm7d3mjL/6+pvv/2u9f73f79+2rqUrbq1Js88zq6b1OY3SQoKdJV1HWrnk+bKagZ1NTepnUtJK9jZlorWgujUgg6NzqKjjQQ5UY2YYnGky0GhbFHXFgCdbrN00FsnFDIx8DSpAwsmgZajuOjYiUCzlPBqRjYLK0uaM3MrEKWBrIRjJCJF9QIPrHiSTL8PsYJLi3is9XQUSThNowWpDmFShPhKF9aZdEmTvMGBTg06mgHhVKJeIcOocgE4DyVDA1ZEphuS2zozpigmZEDSQQKscp6ldZ01j7ent1m1Tt///q/61/7f9XXbXZSNPVdFlooJuj1VsgtaC9BazIyZ001suktBJ1upbpmToUE1sndaSjZR2arZSVSamRUgkyL61qZbTwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGyIk3AzujcuARRuBndG5bNhrcDO6Ny6pHW4GuUbkQgNq3hkGI3HCI6zfwXLY8zmBWMPRD0Qb8ZGjFAJ9gc1v2DgqYbK2cxgsTNWsYSGq+EAyw9NIxlzFuIRIZnhgnaZ6ftli6tvxAAMQqBMnUeChOdZpBddHldUrKkaRkFgRWKJyMt6YUPNLhEHE8RrDLmhNAi2hQEUDY1MjIuBdc1dKolyqykhwso6OJyPQoqtqPT9z31GBLVv/+q/963/Va91/dS+rt6eyr2Xf1etCktlV2NTrJoIpMZr1LdSkUluzoqs6e9GtOykzBFaaKjqCR50q1Gsietb/mcdOgsHgFFSsHxuQqC69MPv0umvA1WMs3HEgzEGc0xgGQAgxKkbiBUnNjRWLMLMGHk6CUCbGbIsCNzDkYwoBDJRC0wIsRha4qCDJ0EzZrAKywKgYAND3sUwjTAxewNRBeyHR/042wLaIQE4IZIhyXRAwMUiLGIuUDDrzdM1QMVFUIAx9Z8+5HMylk8bHDA+iPtmc91rdyMSWYv9abJfqb9bvr7fV99anrX/0dXd19+u1ldK6a2skdRRMVo2Y0OJmqlvTQVfZTIqW6DJIoprZNdneydlpqTdlLqQWaI64+jYthbSwqaFZVBAwcgCTXaK8UqblWeunkLWnbFQhVUYAQoIJap9uY2gXGxg5pUOJg4YzYABCfRhQKI4km+xYEGz1WA1Y2aZHX1iqPJhJQW5UCU7EBQZ5xkzICq9Ce7pMDpKs6hjCCwKRmEE/XMgQ2I0hhDCLDkAZ2EGCDciRfOl0pANASfNnSTHSgowkGUtEhJMJ0i160Zpn+pcpJ1v//////99XskrVX66q/prs/Wt0k0nTWpTJucqWitalMnMXNEHRRQTSSQSqdCqzJIosyz7aepp/AsTkHjx6gGOgbwYBNYFHZQsSXayTFS1z3Sht+HtbO/69yUjF12AAUFpUGLCDFUewQDjGpEU3Q4GHA2ryCklDGplERpTyMBgQGBFWwwORVduC1CQkgHMCtkwqF2Jy4mAZ0MTAxEiSzQ9WLDDDoQrY4TSAIHTRYnFgvEbhaMB+G6O4XgGoSDqQIeYqMEgvWRU+itIjy0giw8VqNkyoaqUb+caTdTOt7LWb1Nrqq9v61/r+yrN62p/33ZP17buv3VUy10VUaSaSR1NN1KWgeTTSTrdSLzq0F00S8xxTrdBlKpKskknWtJFNBzBNzU4i6qbnkooAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABvGPNwM8o3LQsNbgZ3RuWnIq3AxyjctFxBuBjdG5h2JASM1ClLC8TEK0E13cg6H2w0EzAD1sDMLABQwx0CUWAwSO/GBgEmGwpPrcEj6vQAghtBY5hVPiSiJR0BA+4Bm0WvytvCAVNREFSYtpYq2AkOnBU8YBOQ0aoJelTREBVzOICfUEBURiabn9Embk8fHkSMGuMZ90zMooHR3ESPqSUcKyzViRbIOstvZb2rN0jd6K+mowSRV9X+y32/T+z/v9d67+v1f6S0KkFJMqmmo5SQqekq1abpKZklJvQstBlIJspFSabOit00mNTjTJOmpkGTRpOmus0nUU2WbyKYwWFQQVyCYC7Ke89SJKQEzKlikFT0MsvIUJAU8YCPnvM5MGnKCojHIAbesGCGqKpepTgluFC9LlZpMtsYAB8mEtEv7KI2ZxAh2WsVIowApPYhBAphn2i+8rql5YMVvkcWMAECVIiFWWE2bkWF0aEMA34EN9LyZD0y6WRSo9KamgbJMZE/ZRqodTqWba6suVGD+x1VbNt/0f//Qb/1f1619qba+u936r0qr6c8t9jdBJSE2STWkk6SKKkjzqpp21r0FtZPRdFkXUdrRktcWRYokb1gAk5C4ETB25FfTF7IJmNMeicA8lpCDzBgBQnGKwiQABWFyH2GAMEC2mR4MKg1rQ6C0aA5AEibBRLFQQGP9S4HOB9lhW3j79GHhMRHpzYSliA0iDgEPD9o7OpaXiWq0OONiGAGZMGcFUssNC0iQ0vD8BolQcGOaVmOl0rB+xfr2dE8xE3UshkiqNRt6BcmmbP10yugqv/W1Tf//76//91/tra/q1J6kEe9bGqDLbZPSPKddlonUUVsikyaK0lOgaqez0EVL2ax99k2UyBxgo0SFRWtprMrEOC0Ia2WODLJZCYVJq75SKbaGQHhWELCmBACfJjgKzFsYhKTXT9lSPJkQcwVhzMDOm1IFzwEBlmmNiSkmqyNp60i7xgyITU5WGMTHDAyy5MGLycLFQllqznSYmhM2yltzREVls5w6SpFRX1l0EV0h5IGxZUXCYASGaeW6KalpE8tSlxn1Os19S/Saq6zqlL7v11+r//+q3ofpb//rev67Mtq2WpS03rOppuktDSqXRUhWpKp0XUt1spkaloKPU7Ogkiz7InzFWei7LXIdIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAb0ibcDHJty09HG4Gd0bloyNNwM7m3LU0Zbga3RuWgpfGSYZtCSOuWQwRfE5A1xWqFvZKo45AqHX8GQKYZDkKAQzlbqRoDASXLBmEQY+oUBKrzJ4VIEWLCIKiMyeEFiGTxUlw4jrMna0FjcDhs3iioNChxNLgYAExXkqmbfjAHWYipKGdBQFgYbPzD9Y+SpUGWImYAeTB7hZWdOGxKB8BaauUDzVkEQpDmqMj9Z7ql2m8xf5TdFVu21lf917/ZX/V/V/1ep1qarUtSG1V01nlXSUiaGKaSS0TBSmUgnOpGz1JziZ9SZxAwRTUpKfWyKTpvdJaSTrQuerx9mFGZYvd5jXwMZFAGsdiiYDjRuHmXv41qOuhCxUoemQBYNS8HAC+8Zfw2E2ZOKghiA29thpZs6gm0lEzQSUGKGbGY8JsUgaHkbBHGDgNG2kAEDPnahoCJvocA4+xBFynaS+rxJIm6kTN4zs0SJoihioDWgDiZxM3WOUCQlSC1UWZaZLVmSEkEVW11Ot9BvUtVf+u2/9X3/tr+1X96XXd7Xre7Ld2rUp0UKlsiipSRso2RYxZJ0EmWanqKkFrXfSQU6F1pIKRRNEk0jjIVpXU7dl2ppGDNCxQh5BkEeeAMioo4oQsZuWLmT7mSl/ZqcLA6mrsepUrTICBMGCFByhJXw0oHGMQEAdFjQiAEMbUhATmkChc0yhDSBTIZRJ6YwVcMQBmpvESmpm2oYJKBBMz9v1aWauMle+y+UxQ6gnpVJnIqRyJOrAAiHZPpVMT5FzykVsW1PjloIONJRmkzJ/LbqerbWiplo+/27+r9/+3/er7/s2y1vunqZ1rpaa0DjrZBJWtbpKnkFrN3TSeggkqaHWRU1VEx3ptSOO9TmSnQdSjNaRyzGrbwFMqGiUuaaCgJHh6ZrS2+bi+UxBeb+QNGI0IwIx4IiIsFviCRN546OhxswAzV5wM/YLLnzfiEu4nGKghgQuksYOsI3NwiVOiYYStFYwklSAgDP8DjJnQewkEbO7rF2orBWU/gAOGNAzyz80TBiXiBoogawWdc4s8s0BoCSZNGUnZMwM1rOIoDLH1s9expNdNvRRRqr/9ff7f+vt1N22//9bKZep9VGy1zy00WdajNU86NdS62MFIOkjPItTUq9NNBNB0HZbJJutFanTUmkzK000DdEHiFwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaoizcDO5tyzRHm4GN0blqKPNwMbo3LSsebgZ3NuVJ4hSEBUAUkAB4Mnd5p0rYMle7EnhyclpUD3aJQoxMfHBIyAvY88bQTWwty1BjEwlf4jDl+Ggn4AN2NkoAGaLNTD0RpkGORdaAYmygopLbKlCgoc1YkFwHKDYH+TyIARpAKCJl0UNyAVadunNysRhWMhygTqHBjyZroGghcxtcgLutY5CMxHjbS9RhSq+9RaR+v7pfv9l/1N/vWvv9+qv7devUpaLsylKWzKTc46luiikcNVqZ3UaOmrWaO6S12WbOmmpO7Mg6Va2Wpa0WY0Uo4LRJNwJTBBmkIWnHCgWb1QVtsdNKs4JlsBXFVzDgdjIoCJWGUFTeq2J7mKDbPH9MiBGOLQnhsKKwEmT11BkM2UxUpX69FV6YwDQsHKCB7cxUcOPczA7IOUm5v2rWOBcTduNv8FxIIOVNLE0apmpHFMgwGrLDeNTQ1NC4Sgssdruz2SNnIu7qVG7ZTVUKc/os77Jo1dX/XQ/79f//V3va/tV13/23frd2SaaInTBNTIoT1JSE7Up0tSa1ukpS2qYysut2snapN0bvWmm6jq1oHTBoYDJXgIfnk5fhKpabWnwxvTM/S4S+Qq2pSlwzSRBr5uIszuCyqAAUwX6zEx0YfkVA1imOJAUAyICBhYCBNbQIPxYAk7LbstMAeQgKeqWl2z/UoxlENmAhgGY9ByANtSz74NkEAQCRiQ4y43NyKEFKxSAATE0YudYvpjIku6ao6kJ1Y+6Mm3KCdz2tajWtlK/OG/7fbUr7//V/qV+v9qtett2VrZTXuklqpIJGjIuq6CKaaqSnQQUiykK0HVrTY2RdkmXoKLybnT610Ump59BtbVOkfei0RCGG8QlHOYDwHZa4z2JNbjdG/16jtywZCwEeNGMgD0GDDzHrZC7oczQejIWA+BS/6VIZyBcPFl4LBoCCFKTKh5XdNK56AAsMGfASZzchGNmSxwjkFMnsTybxHhTJjEvomwGAAbFqHJI4dIaTo+wPBxDS0sxOpoA3VM+fNkEEFmGo846Get9lpUM6/rTQq9f/26v1L/7/1fb9f+revroUdTKYwSW6S1M5u6CltUmk6p13SNUZnQdNaz60GSMTqCZo61IGS3RRZFSl1OulZlIJmSTIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGZYW3AxubcsixVuBncm5akiTcDG5tyznCW4Gd0blWxKlTwEYVIJ7MIZuuuPVqePShypypxugqKIITRApOEBgDJXAVea4PwLAIKaZUIhdfxgaWXYBRuYWGGogr/A0IYGtFOWAY2CB9RmLsSEAaekTBQcIwFDpATgiABXODASDW5FugdCsFkMacfJwdRdNQNfzMj1G5oouinGG0jzdNljc1lJifSoJ6q3pLps9311N/v/bXqv/b/r1v76vdSqlfqVXQQrU+9aKaSklrQRO6SFNJFdkmS7I+pJJ1ugkXkWZTVoWaeKyAjGlEvAviadOSmG/Yan6w9YmHd+BYXRsvnMLdNKBGQgYXWUGEcfMHOlPuMFgIIHoKixl4RH1qqbGol4jOx5SZANNDmGMirN2xSynVUIQAeqVCm+LUHWJJhFQGGEBKIv0oc6ij8tdhJwoKnX3gVSYSKCBOAB0SCZ86bMdDRisjRcorsgTupNRbf+m3s7b2NP1+2mv11/V9X6Tf/+//W1ak9NnbWplOtA9TZV3WhUy0jZBJS0LLnEkWUpmRtRdKtegtE6s3rTVd7milHlQu4KbWUmAKqFjImBeKQjPX4lsseZ74KmoNi+h0EAA2SAhhwykoa6aqiXOFAk3MRVqUAR/auFBBMMwtIL+FaiVBcFU0DmNAjXGRw/G65igQPOS6HrC4YbOwhUQHywQBF5myHCNEIPDNpEUIT5ZQv8ZEUTFmmRSA8QIcdUdSm4yxCLWlIY9JEhtlF1ZFTW7+p1rzvda1PWy/63/7VV/1bf/9TVXf9V+37OmpdJToKTQZ0FJ3dF2Za1prSqmTMy6lGyjZTqWpNlJpMpa0mdJBOggYo1GOGp6TvCVhUFhYAxlTC9Ka2OMSlbYnlbjKJTDk08MOEJGKAyBZhoQ/JlBWzicWCGh2An3DDzhIFQCZQYARNBwMFAYcDWQGNCSsTDmENdYAYKMg7FSKkJbY8UTMdkBqgSkXG46e7LVUJx0G1Hix+6eTKcul8rjjAxCcXGatWWItZVdtRk9AiS0lKWTKF9C516el+cPK/V/11Vv16n6Te3Z9Ct/+vb+j0dbO9Vs3SqTM1WdepkDQwZkU6TrSWtI0nnNkn0kE2ayCK0XWfTOdDvFE6h41BoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABpWPtwMbm3DLUgbgZ1RuGmIg3Azujcs0RRuBndG5QRxARiLCzA5hRf94L1G+szDTDYRMOxRK3CMmecomlNzOFZ+bIwKEJ9S20incBIc4hnBeShoZLDhiY0MLtMxBXMl79wpwjAUgx8ILlsuIREx9eMbVx8hEQQ1hkqITUQqDPis8dBhGAPzHqZEixVGemgH0ZUN6zzohxLKVl80ZnIEtFzZIaz1mjJN7a/1nm6v/v/3+//ev/f2bpWrX0utKg7JI2QUjdkXSdJFNSLTcxWu6KU46kUHQpnU9NTpIMtSbpnVKroH5mtR6mtBHd1l1BNIxWopXUoIYQDQEVM5ZvWY1TuM8uETf+H5aQGwVHckowpim9UOawhbblu8qYZAvAXzVIY2CSXVuIjCYtr5tTacbXHqYezkA6wFZYo9RAhOxqAJojiI6LGeRdMKUxlsVnTfjXmnrBUJsgp4vEUAS0HAeSWksmxCEl6ToIu60T10DVywi9/qUrQVVzh2/9Wuv+r3f3rrb/11f/s61/pug+uyCa2ZSKmPGiziLLWndTpnNTqUk6jFNVeykELU0bpLeu1akqmd9FFZ1BST1uio+3FiQoWZh4BUIw2KvAvSakj1stpX7u0b8L7MOKRwJMiImsGDq8BQGIQg3wRYpBaEl+Rkbcs0kkLB+PSSoScAaAZwUo1sogfCnMAWFII/RZ2TUjsZrx7ZUcWo8IjC7yAln7aO+CoWNTltEm3HSeLgOgMdQTMlnRcSSKmSJxziDEVRuVIz6qSPra//WeRWr0H/9av1Vbf9fZber/9SlVN10U0GeyKLKRdM6bMZKTXQZa01o3ugjQTOIsgktnXWkX55bMm7UUz5ueRdSzRI1Sk3CBK3OHNaU7MdNFUx/B5VeChcmis3YjEYlTlQHeXiMgiDAyArNM8FbkKfciXp5YcFFzDwYMt1HTAKqoOKBEMmAii+TNCq1H6GXPSYJDgogGg2SjAkbc0gQLJrhN6HG+Rm0qtQQAiyCCipYpCoZkWIkakNAqlGRn0jJRRDJjJFPIxtJJakD9N1U/Zlp5z9R9XZJf/vb6P/f/3//vuta+pSWgplquki7s61JVo63WklZkEUVotQXooILoqdTpKWtbIM7KdJ9NzU3PLQSQWi5hU9/4hwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAa5jrcDG5Ny0DIG4GNzbhnyONwMbi3LHkTbgY1JuXggJk5wopUIQqMLhiT9ujTtSjUqfm4/hVASqRKOGRCK0QapO3BQXAzGwtXzRS0zKyYIg80gPEDGHHRVKDCCWWGbnlaJMIlsAGEoBlQAqGDl5CU+DLEFMLRFw1F2q/QnS6Gm5jz3MROnOlkukOLw+gR2aE+kdQUWByDy2pk/ssnkkEifWRBHdXrWgp6dPnE/16Wr//Zvq/9vr9fv6kevXU1SC01orWihdB0mdbrSXRQTZSTpOgkpJJa1poHzmx9jZKfZaCSmQTSQTUgmnUpBBaCSlMitzExIrBrAigiViSBAVlzoN+125DfXsn8n/vpuAZTUdM3AH4MvHJPBIqCGAAUpkpiwBIRELJzGPIZIcg6QQQg6IWqZqVtzhbZmAtfBrK15x7KP4PcjESsiuEdHZxYFCV0tyoEzxCUuRqdMCYYh5uTYGCwyRRKTGCkxYyWTSpn0Vsmy6jSXaK3qqSag9TfWk/9/9VbOr//6/99q/rf00vro32ZlMykGWjWcayaKZu9JSkkUETrsgzr3TqPpMpS2QQTTNzj1miCLK10FrW6jNF03UmbVTNSiVDlROwnwdI8sMqGu7FpY38JjWUXwQbChK2IeW3CMoT2JbRAHp6Rtqha7QFIHsGp8Za6oVDCLjV2Zkno/sSrRWSgkvBxqv13knQESEkyHBMQKAGACQKcpBLZaAFAQyIAcuTSg3NC8aojHAzCqL7Mi5sJaZpLoGqa0TrVy4gVlUUPU3qr9RWUqyqXb+9Snt1+v2Wt16qW3t3/Xo6m1XdlPSeyDIMyJxRpRdCpNNkXXR6K2ZJTorUta6lmBotF0lma0mdSKCZgbqpJ1V0OcDl0Oo8JrJuubslxUxmep1NHlsra7ORKWQXExwkW0Q9MoOVoNoHaUzxG4m6vLLAaHeYCgH5OaqAhkfciAgZQfBBviy1oBe2FsxAlMevsRkQgIn8pAnuHgV9MMeQgAxdj0ahTWTUkqWEeYnCwQ5AkAN7TY0Uks6LldqpRPbF9dRjOVL6mU9Lt+ht/+r2q/+ptHbf/0Pq+/66SNVSkjqVqjB1mCSq1MZMyamRUZpqWikmqtSaaWxuyqk0DOo+q0yQ002VRQWaCpxvCvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGio43AxubcsnR5uBrcm5Z3jTcDG5tyqZCG8GNNblqa9S+idpisgtjDjO5LAbxw1JpiXQxRJPiMcGAEhEltmsmS34aFBIyAeZrDDC5eBRdRg0oIKqeAjQgFTHxrhja9DUggWihosyvqCKSCCqAmF4oCL3hT4gFA9kqt0QbgyMwMNW/Qyw8gkTxuMwB1OPZcPJmaSJsSVlKNknWsyQWoxkyjSX6j1qlNSqUpKrX6/9f1+7b1/2/r71f/f6mXW66lrTZNV7nE2c0c4dM2QM7pGTIqprSUqigtF6akzMwdZkmgfTNLJLUt11ukpHTrd0T41cjMAKZOGvMYnJiawy3WevG51FuEWHnqwGKEQCN2MA4lXAZmEPzNiMFMNFYupiAhKByUTXQbIKiQQJVqlwOi3YEntoLZYLw4IiUzUFpHDHBYxJ3BkKJFNpjkKZxNubXWmzQIGW9qy82L5wsmZPgXAiSJi1ag+JltmZst5caxss70X27Vra69Rqr//9X1f+r9qv2V/9f293ZTXrprppMYLNEnM6JjXdTLtWnQZaLoVH1uz2RU6mOOmz6TqUo1QWYukhSY2WimbJn0Q94W1Kn0JSyUbV3pZpF3Xjexu8gpajvShR0cGWuDRysQ2YDiE0uszoZkM2mFEwIIjQMaOWiAxHmxJcMYENTAFeVxmAoVDZgYC8SXD5S1EswDLA2WIQNqN4QCLhwK+jORgGMXFITLrLJEwOkvDlAcgDFI1FaTnBGR5dllxTJpF1aU2kc9Z/11Pv1WUh39f//q/ur///v2S/od0U+1BlumyCkFutZkg62SutJM1UmpkXUpTughWgZpGC0FHUUGZlo110z5k9SzRJbOgkp3OuEQ4Ss0PCGpjAN0dd34c1BUcsUlJ9NM3yE4CkjlCU5rA9YkDY3VDK2LijxSBFmrXB8okUCVUVAmNEMmNUbc5wYtKZ1TgO7NmwUXPe0GH7L3fa7CIs+kDxl4H5CGcWrzSBWYExM4AIRkyNToCe9c87PO8orPa//r/V1219v//79///f//e1vXqvTTpref7tW3fTWlUiyD1n1rRfZ3qSZWmt1o1n0XlfKH/y7Vmy4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABjKItwMbm3KvRebwZ1tMGPI03Axujcq+RpvBjUW5aKo2YhA4aTSGrtMnsurNv/DE/KrFiJUpg4ktgHG77G4g7n4kgmJTa7qAMKH6EBAyYzI2AgGLNqmhggK14RoiiOEeiMEr1UalDqOoJGhlCCEmYhB1SwEQAD1RKRtMUaM4BYZry0xMywOhQ+APbA+iaBuXLiEJ5VJRs1Tn9ZaWQ/mmqrQ7auj/Vt/1rWv9v/f6///Rs+j3vZbup6bpoHU03ZrKPOitaCCCbpvQW9aVTdaKklqTWkg7pLSYxSdlumjz4Pg+OHmIH66OCjkRp6LUTmdWrGJDK4TlKYtBUaKo4oZM9Agx5AVDc+bQ6GeAVYJCC/BCCungFEkwaCjAGGNjHTLSR6IFs0bhGADA8hJYT7QAOIGCDIkTwa/FlsNK7mMLRuMyDm0k0ssYWqHukEs/jjl3uEGY8w58k/e86b1Bcip9c96Yv/0//+5u741AKLSsDiMoDMBqFXFQcWBwRARUcIjIYHCUPh86FDLGEzACCQZMDwGD4iZA/4KUsGdCmRDXlpL2l87GHg+5JpdTqyAUTaqSjilJpxlAkvXQBSBQVNIwUTfoDAyQBkaCvIiWExkfnSFRuegpwJ9uJgpuzJ+HVhRk4yKkBGTDoLKX+R2ahBdM/DcAc9vNE7hiYkPI1EV0CD8ctJBBbIkWL3WQ10E1mjXL80Rui/62Z2e1v7///9Wzt1N/1f7/6d2q9/WpJ6mW7IvWgmxmiqYpuggpFnTezOk7unSUnoH2ZFBBA3OOtbnVoVupFJlWc1pqOaoZZizZcAHSkaPZnn8eSeh7Dsoq53Z9D4eax4oSLpMYIl1Kg2ZYPADMQQCj7MVtG9Nhd0nWOhDJAXENAzd+NwJcgIcrBwpiMrFRB044VJkzp6akDQXQxufjqNwiCvxheNFKaXgKwwTQSeogb9j7LQmraE7/r16nu92//+r///////t/2Utl7NWyClVKrmRsbzJJNTNrWnda6KkWdOh3oqe7pXZ0UaKbPZNbre66mSnHakAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAVNMbeDGtLgq9Hm8GdNblYmQN4H6m3Cp8cbwY2puHacUGQTnTfel1YLeyWSOhgaxVpYpToEB0lSA4imQYeLBGFCbIS3rMzAio2SmXBMNAaIHNX4fh9DDBmnRN9KFeYiwky5imSlIgVDJApvod3nnEQ4EdyJMiT0MgQivLOGNWdylwATNOs/++YRC9/97W7r/z/8anyp6ep7aFt//X//o/63DHIDKUExCwEwKFRQkdjguHENCLQgkGCocE4LCB4DGA+BRx4+NkBunQQaB4QjtSUrw7Hmt7qyiTQzC45ff4WbRooTwAhzlNVMUTJttwIA1K7OzJMkTig+ggEjbADDsJypQTkCkQZVsPwUSizT1EApFCemvCH0gJ3KO+7gGKUNyyzuYOkAWYkFqU6lCUpJUJivmyD0Zh9WtqlVfqb//+r+v6v//////bo0H01Mtm1KW9aLI1qVopJIaNbprs6t0krMklSVdmRVe1GifacXU6aTOkZhnNIOIM0G6LuOtzTisyw5fws7WllCALHQEeT9M/Adu4luRM5c/IYhokzUkhmCw4eUrucuAxI1FH/euXPuaIENi3JjqhhpEZktg/KSna/F05XmfHcHveYATZpbiamIcTI5IBZyEPqoMdFdPvrRsukrRlNV1et2ffv3//9X///1///b+v/bev1Mq1aCKnSQrQSdKgtdTKSdStS0HQTVS2UizmVJLUpTJ07pPUipFaaKd06Byut8lGI6Erm9azjSWqamgaKz2ElzTfGh1TscDrjDqjtEgcWBhwXCIgp+rEOEpGSA6FSYYstxsgL7cSlHHZEY2t+dl6Ew4olMCHiY7X38PvtcduCJlN8lAXKpOIRypEYCRYaGMeewlGeVfPUzOU7T9vRvo/7P////v///7fpdzf66JQ2ce0vVzkcwxjmY5j0eqr5rI9TszZ5hqKyKYTE5pyOxyvm89nMNnFUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAFRXI3gxubcq1xhvBnbW5U6izeB+otyp/Bm8GdNbmZcAkIMlUVLhO9ZkEst1MbU/nqtNooPWXgTANUIXIh9DAoD67wBAPDRCGUxgaE9IcAvaRByi4IA7UpqxZhQjLAMXRWjWma6GBeqBydALT4kh5F4AlkvcQON3+s9TN2I1EmwDwlJaNS0RZTo2UcU1b1uflxtv7fX//f//1f7f/t/u3/qTqV73XfRS6KkZ1anWtFTInE+s1Ke4930sZ3X7usRNrvr5YFXd/rqMvS8G2ASwsqZh6JUmpFKL3MqDiToQVRgeKX5TijbcFAgiZb2Jp8Q23dfZgYsKkYcADgOidNgAUX9jSv7RgAZUjIKVMY5cbCpgLD1mX0zP+QBT2l9GHhEj/FbJl5A6DfHnPMkpxJzyV2Z26tlmLa9v62+p////t+r+3//7t9/f131v3SZOiutBNFF6Uyp0V0UEUlLuynX3bZExrUyS0lMgzJKN0G2TXSrO80VEJFijRwTgY4SMZRlq1ucJl6DXlyVIc21cBKCdI475zg4GVktx9PSgSvWYZhjGWWppl+oCMIClUop6CRDDgMcQS806fAwYPsmo/ivrLvPw3HsaQYCgxye1kLlBIzAnmfUxSGcNXass1JrQ1tPpVJ/anv9lVd//////////+v72rayujQWpS+pSNaa2rQfdKynXR0Wuktm0lqTZJJS61Op2dNBJdRpK7+hghAdUyhjKrLZEQDyNIemZl16XxTeD47aSYYG3IeR1BYbuJCok0Id538d2oyCVGYBih8WYKKhExpqP1A/05Tey6Iwc0YcEm8wEBpPqihT2sQpoBgOJqJAZLjniyZktSYBcNktS1hVHblT9F9cw7+r61f////////r///+rd3U1lLUu6FqNGinVdb3QUkmmi9qS1akumtkFso4pBFJTGwMJp6VBntjoKI/gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABUiON4H6k3Kq0cbwY01uVEzG3gxmi4KgRxvBjbW5Xz3DZCMCwl9b3ExkTHXDPvNJPVCQO+soGiTSTtIGgx5NImQ4PQXxiIwLiZoVCe8QUxDCkZFochaVR4SwAhijq3CKqrHPkjlAWcNEY/I0/bbMtQYkcVBdfXVorKa0gLiWHey1h+LL1GFTTtVOUe//dv3f/X/////q/+3/pLq/0eqpFSN62pNemldlIqZzqOy3qQpVLVRZNSqCjU677p2o1aSmWnatBlG7RmttEMoAhQNaNAiUedN2oMn7Xzdq1gyAzICVjAR1SYfR2moGNGQ3RqjiTrOoLOhENIpBICB0G4IRPYhWsSAlN4WIDFBRxrIgQW6subOuqUtyjeaL486gbPFlJmSBiCfljI6B0Ro1921Puk6b/7V6///X/////1////vtVutXXXrXqo3UpSLtPJrQo0EmM1oqam9SLoqWkmtSK7tUkyKmdjyqTqdVjy1MmarrXS0mwssYwbhJFKas2eKKyivX/CW2rJYHUk3FFxuh99v1cQ4pDwNHhoeCi8DFjgRICXsZQRatxFrZLflz+jGgYmOFIJD3CQcGl4J1gW4B7A7h4GYJIQlTJoRgHCHEfSOpmJQUgAUSLp/Z0Rljfpl/1dUsUU1f/Rf/9X/v/KFCTbWiEKBgXLA6dcSOJSITIMDTgJhkAFSoMCdo9oLpMx5xASQTCrMVishHmBa4KLALFqafjEASKcl+pu4koWlkKarqkQpFazYBKFltVFCFqOv6Dhws4UKIqAGTgLEgcEOfM1LEMmApaF8fhxXZyYsYCRCQBDEbomE/H5fg5CfUsnrKaaSa0QSRBkHrQCTp9a9/tRX39/7+l/1/////6v//+r7rvb1WWz2d62ZO19CcTo6kb3a6CkUKLqqoI0FpMhZ1o0Dy6mtR01uZnjdkeIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAVCibeDGoNyo9AG8GNNbldlvt4H7e3KrsgbwZ0puGJtZRrAU1hWvrhZFK3eq1pDnSTluwMAVB5YPHV8mKmUsYrg5Fbp1gLwjFP4acEIS6tJKASXlAQGhE3JoTAZgnYOJ00PoeHcjmFPD5hZDxRdRrFl1yQXIdrXMHm5mzgdnEmWt1GjPz3uqyNN6l/avR////////////6vqZ21XWt1r9B0VptdknTZFJk1rSrWizuimtemgkpTpKdHWrQnXpmLrpzxzc8TJeCVb4QCkmhI0psMbqOVfsv9coZ7O0WAAGDRyD50aJ2eCokwYdoVAtGu6uZhwIwgJnpfcBUoaAw6T24ZitUxSkoruzcRlP8ibsNIHgj0miEWhq9SOkhvTU+KbKMqAOtFNeywVgpNzqrUK7zj/9tX9b/////////t/V9//W16bLQTpKppVMndbs9JakmSXW62fdSNBd0U1nGoHowdsX4SNnPmXIvWGCLKcBjEaFxL+tOSPXm5US2vcxQ6hwVKiIjbgYUlwJ71DwhZpGA2QaBr9DkEqDpQGUxEbUwiC4vS0MghaLAchtXkDrnBggXGxaRUUnuP3ZdWdvs9GgufncsSZgZoACvG+t+5uz6/xb/5p//66/t//9+n////+v///////8/X/////////////////////////zr/7/p/qmc++rw9+3pveMYh7wsSJS6xhjstIMmjAmCklsVHIFiJo93cylLDLkgQ8x5gwdxJmNzMOw3GrkrqW7ZIEJQNMsM0AMUVY+3oO1QPbTqm3elJhhBAsIjIoHAUR/REBnWk48bIuweXNWj5UGGRjiMiRLXinIVQSh+fpZYgMkU955U4qxKCxdEooERZ97rZdTJG2unrv+r///v////+nr//2X930Rq2dXchMMcx5zISGKyHH0PVVUxZzmoquc+e05VQqdfQ5z0MYseYhhhrpJzGJzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAUjhDeB+otyqjHm8GNNbhTmNN4Mam3KlkYbwY01uVo+BChrAAkAgOR4sQ3GZcOC/hQ2VbUk2wjAJTs3MB56RP1uN6Oq/fsKA36Hl5ATJjhKBDC0jHR0SlMuyh4USDyZ55QsCepMDC5RpfCMS1VWVPN8amQYAgXumN2KbFEACkvS1mIpI2vtvXW9znRq709X9//////////1vq/7fqdOlZbKRddA2QWvU1kmW1RzZa6tdSvU62UkkybzpZkGar9uYzW0jxP6jmGuAPG4MHhcWg6/rLGO5Y2ywIHQEqWKywDF79OnoXUnfX5EpTCzCiSFk4KHYHYZAVAz34y+ngggOBzZsMsT3OKyHTpWOfyUwdP2IanopDYOF0HLCCDpIoDhNFHl6QUK6847rWl0Zoj/fV/1t//7f/v/X///+3U/vZ1P3WupSDJKuvZkl10HZ7LSY0dbLdFqabJIprrTVZ3vRW6bJ3orSWgldbzqbKMpYsE0gLmYMt9rLauzDsng+Hc6S7VxnWRTBa1yDqI35quDBtaCVBIwKBpeJGCQCTJCQKPAMSAHEZymtTQwiT7b+IlUAZ+WBUo1NblAkWU6tOZdrQ+CQcTqWESyiYOTwC8EnQapI8etpaf0q/r//6v2//////////+rU99adeZO6LVvN2Um5zspNKiqp00VrdVzyCLKs7u7n0VVMp1sgrRu91ums6s4cFJ2MAXcSKHWhDXilUedjOgf6vljTUZIIWTXIgcCg4BOUrtMBlsGP3Fm6TYiGDqhC8gEGLAy4hCtOvw9I4YGRyOTF9tqPxRhOqGtDFVpNPCIlbaQAhDy5WVmSFzIPxGdFb0Atht6XWe7qS/71/+31//////////V/7vVqrWigzJqddBndS1oqZ3PKZbzNCpFFG+6LMtlqWz1aSCm0Zq7qW7poGarbp0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEt3k3gxqTcp7SBvBjLW4TrkDeB+mtwm7IG8GMqbiOPCIZAHZcNw6ann4fxsY8uzFTrcJDMEQq0JwmTaXI4U97wyhXTQA4HKCYzGSZ5Vdlf1iaqXh4EnBS0CO5q3gjsjQ2CpBCY9LKPtZ9UPK2eLouksog1snT7K1kf8x837W1///qf2///////v//1+2v1KTSf3oO9FSkUbVoaabuhWkhZbs5xSojioy5kl99kieRQLX0mZ3LKm8pEEhyChE16mdy9y7haxnsZGQKJCTIOAbQvvY3NPPYiDEqeLOQYB46UVhrXG6peDEJTLK12ia0rmT05CEespDS1unkNpql185dEmtmULbrdTSU61hJzVJ9Tjnb116faj/r1f//////7fb9v/6/19Gjsu1tl0FuyXdal02ZSSSdnVSWtSKG+p0XqQZJbKWpBNVs5ejMnou5qjqd0z6QnCFAEgjxrJshT1LnVGbHmvjJM5Qx2DXeaydQk4sRS2REszy/nbSnvIoKpFA0kBER3FBrGXV8IDCxNCXHoW5B2jZgo4cHcuBbrc5bLN5MhL6yi9xjjnUjIA3COr1DUv1eh06X///////t///////2/1aFS0FKWpOtNM/UkbWqXQfpJJzelrTQXQd3Zaa0a1tRdVqTOjZTV12SdNazF4MssdPLS3C33gi1Z/pZVs5W6WPRchWbrECQeKKoTdxrDu9sNJutFuGWEpUTHDhY6JJTBNv3J2nspHiRPI4i+Z9BJSPRunjOz16EXpWqqBsr97SrPQ4AQTnveYS/X/0/21/9/9P//////+n/073VPzWo5i9FRmrQxUNKI73U5DjTUcmdVVFMNY9kczU9GOKOajV7uVQuVYxaKaxYqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABMduN4H6a3KckSbwY0puUlXE3gflrcpURBvBjJ25FzfluBzCaGgeSSVDuGqljV8ZqzBKEEcKAjgG3XwfMtiEhOpUkBxvG2L9koRcIyGMmBnwSNypa9ymBgBdVNegcDyyQ+UK4DltaK5aq0TGSYtC8fQTQQZICjEBaktIonnqr8z6q+//r/////////r/f6//9f3Tp2Qsik9NFZwOiAdENTxmbddKbBMOzJwTgZWyaKHqiRZGnCUisG4rMxsQsJnknxk1mWY2+crWIuSjAEkjocSlLcb9Oqsy6/7fUcQnBJC8BWLcErYRQFBOw9N51BEBSFnJCyg5gUCBSaW+Nmnjub99mosGRIFv+5hxEeUA+c69wuK9l/fX/T9/0/67/////v//0/P/19OYbmHNNMachzF0VHMorOyOiuZMNepiIchpxqGliBzTWmHnVqiEBgj0hH4VA4SxsINAMQmZ6xzya8R2StrWVhJ9KF8C+bSTA4jt60LBQzQLvlifl9OgkEY4ucTqcYWcfOZo5iaJXGrWJpMk/rAoCUXvHLJA+1NT8lkfSEvWM1I3ZEEqXVKtj3+c851////q/////b//////X2QVQQRquk+hQT6kmrUo/OEJ+SDmYtVzDd8NsbtKRPqhrn48OsSVZjKZORQEI0hbsCQLublly3fqxKRkoQADjoco2i/JRWf5LD+MsqO1gHJsvRiIBC0MMBA85UopugLzxSEvyocfZKbxRs9MzfmY+/Hvs2Uz0Yth5pzj7QDDVR+C/53u3mf6b//////////f//33/dK7vRbn2zHPc4x3R0zz1R3OUwx02oeYudWw7PPOsdX0NKLAAmfggxoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAASJhreB+TtymLHG8D8NblNSGN4MZa3KXMUbwYy1uQ+pgrwmAtAoD5bj3bImFhqYOVIcISVGILUyZgZmdynplq8zTOj7/PYwNW59BwsRBSomepKDDdoQmBwkKpU7Cx7UHq4Dswrdma1SKLlr5mri0qaiEQ3o+Cz4/XK9/t/////9v///9f///P76bUVXTZrOqLNQxzlVqql6y6HIsxzjHmmc7maqz3z2chW1BE/yYfPlIgbh2APk7Gctr9Qwm9itBt1Z9eQOwsoKDjIQ+d5bL53M1A59mMbBwCVL3LaDbxYeBjL6mqUky7UXrIujPkyivL425BDFqN4UqqhppPWrdZxBCKSO71kof//7v/////////////V//1dVC6Cm67IJLRSTZNN3dDdVFnNEUVXU6KCS1Ja2RrdM86113UmpNa2pvWgmlRPJrF3SlRkKKqGRMmZQ3GW1OY1cu8vUhIOryUjRrRTzcn8ILFi5FGSICeWDlqbjW3Ua6P2Q6GAyGgtYUKpys6gpV9nnQ6Q1NHaezAfJLhcd0VC7fx2SUcCSK1Pccbeh6u3//q/t////////9ur3/p+z9HVXddFVTLrZzRBFbIUzd0qRxaSClprUzspF0kaaG9Z5SKaSM2Rl1hnaJs3kNu28plWKJVHEI0/b149q53asxlK0NYGHq4mCkLMTkiHa1Qulm1SsmGzmBFVwVNKw4POVym7gMJoRv1D7KD2DCyhRu9c/fi0olFeYdI3AZ2m9TbsHk3f1k7/0/o////////t////t///atdr0q3Wyk1LZF9UwfqdB1pIqorSpsmbrSdSb0KD71J00Wd03RTWqpZitHoAYM2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAE64o3gxprco6vRvBjLW5SpfLeB+mtykFDW8Gcqblfc6DQgi60kjW/d2ZlljsQt28MsUC3BghicCA8i9knjie2F5a8jWi2wqBQ7kwAsCDEAZSNBu5aswyFV7uwTI3RN0BChYoLyu/bnOyrOXQGJHYprddKiFmaupKudfQWmvr71d/+3///76////////7LZS+y1XpJMq7qdJJUxSeqpJVBlVIoIPszLRoNdSn2tpo1zjoooXapBZ6JmoZ3k2/gjSxFEAPFLXlgjDKK0eVLzOo1UeMZ+FAJMBR7dnMMts2lI0j/QhUA4BFUPRZCZHlYvVt0MqR4VqkmmVAuckyGhs43TtVxm/94xJt1r3ug7MsI736hP///Qf/1//////////////btb60dJFdaCklOaJqstzrsyFSdVbMtRyNrshsclHdew1+nnafpg2oyYIJkAUBzHwhy5ZINdtE0TLOyrK+ErUKkRxQrzbZ+CgNNKWsYIcJUi4i+TJUng6m/QQdo6ecwj4AMr2q/HCaWKlmpWKOtnYhnC62FMe3jfoJp3BOSna1Q7H896X19v/////////////9XVV77qrdBBlJVIqWz02Uo3WqqtFFdBNF6Kkl3cxRnmV/ATbCWKcD41kZJ0l50WQiBIExJmdfSUS2UZ/PZy+ppu9RuBmBu6MCVppqqAOXYrvn1G7a3yol9QMJlhaaQTedHJBGAv97ZpR8xmhWhgksi05Dk/SZUi+Agaz3Hqx4JL+Ih/+uu//0//////////v//X9NbTJr3PqbZD2eezOZeYe6vukwxjZk4xXVT3ZyyNZaHPWZIlecER38La4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABIN+t4H5a3KPsGbwYwduUgYA3gxlrcpCx5vBjKm5TygA3FyAUh/KxjfPY7g3x9b78AvjdLoOid0jNcm6i1U9WX7SKmbQgBpCLRBsM+jRoiPlM0dNPAwAibnL8AgaBW6zVtVf+HvtNIUoo8u1MpUCVXVasm/f2+j/////////////b//UtSHVanXs7OtS3Utqk0knWi6SmsknXZ01umzJWmryxlbHNRrpsd7A5KWIUbhTCS0CUZWhlMBU9bGxU3elVfkfVhdoTfXFDwmu/ic1WOtewZxA6AwqwgdsU70UTOd1YqKoRh7M2EHKpDAmBKJPRulyP38lGleUVbvMUagHG78bN/zu1W//r//////7f/////999mRjFNrRqGqrmHIjq1DlVKK7HmNUxLNNZ1U+eYa6mkGimtyVyp/ayKTagOkW6JauuO7EFV25WNX7fMt9bpEHiW2toA5zWSiiDm5U0OVjo8lTGHBCjQkDBzD6mEPVtz89EhFw225FHzNFGAqmqfKvt+d1n2BQuHN9OmBSsl7Es/t7/V/////+v2//////f//73V6lsvstS0UE6d0lUk67JvQRWizMtWylqUm6jtZm634hJM4LC2T6pbU1OBuQCrRnrKZiZr2eS2b3+7FLVXcxlI6DRGB9SdEgcrCXNZlXEKyqkhG2JM+0VBql61XviAJ/ITWf8H1FRYiYgCX4wXZmJmkdtR+jw9GPPuBAbbdBH+nttmf////////3////v/1/braiK6VnTjLsfmWMSex6LUxKujmtdGZDjHaYUWULujnbObu5qHozVOJnqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAARoizeB+VNyi5GG8GMqblH2FN4H5a3KMkfbwPwpuIrMogHkOMbS4Ul3FvbJneMLltjT8y8v06Zj3RvB2kfal+TdToc5CSONE0MYFuYoFRrm5q1gYaBMZPXHjMIwgYTYlGVmtk92FpuCA65j1aWQB497q0afO8t2r//////1/////2/0//930/REZn0m6mJa59j0Q5jSrpMpOR9VV1o7z1RykxGrRTJIu4Me3V9Ps8wqpkqt0Vc+ZldPV3bq97VweucGoZ0ureiSj7byKlb/sTjJfwZKJjo+ya2ofB1TvekJyZkvpoZPYIdSHtIMlVmdv0NbUVL5a16GTGcD7fYKD//3//////////9P9P0///VfnanIshPc1Tbu57H2RnQ5UVX3Znc1GdyZXSs4xGtLfVTVqso0lXJUii2ICwIeWxcuDG6o+V2vh+TZG8gGMNgOiGKZ2IKnuReOCokOI5Fh4eVSUYTWFBZ36nwCKvq5qVaAQEsGKBJJq3VyezPBojezuXXQSd2Ctd9q3b0fP/bV////9////////v///2daknZJNJKzH0baSqTqT1I1s1TIbOilUt2n0kmPMi6a1Uj8NKV4+MkcfokiyEjDBojsO92t6WYWLxI2djrZH0aUXHf50qnyYadhEbV6Iw0jq0oofBcspl0VJjuXGiJsW7q+jr1d5Tl8MJ6Avj3OSso7Fcs3rU0CEn+cF23/b5v///////////////ZLKutrrWahiUf7o6OZPdJyMx6o9kZs5TFcw27GT2Q4xz3OR1sYczMyojmmuSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEWIE3gflTcomx9vAzBW4QWKTeB+sJgh25m8D8qbl4mRpA6gvUJYW1UtcRc31TfNUFDMJmSc+xoXQ31GMI/D1Uvu/LTSFxZr7FZ8uFRr3xHkyFi04qb5sDHFUFKGVX71TCH89x6/O4+mrIGS38W29E7ffv///////////r/+npr060znPoa5qHTFMWrGOibXc5HOO1RUdmVz6mmHoUYZSA9ITS6sZ7AOnaE0IyBEGAnHo4vazA43SxczWxLHjDDQMz3mafiwk7eSYwbpXLxKPlaZxfm1/4VKmGIyVcMvwZ+AcCtSMMQ+dp7Ed3SpPly57+1O0weHt1gC/VPf6f/b/2///////////ffutPpdj6qp7FZ3KQisxTykOljor3tY6KNU9XKpWo1jImNZEZCHTKxdhg0GgTkBxekTqVXXoLlPrvbvbShFAhXofAQdjS5/StQzS9b95iqYnGMpJdLmwdjdtWxEJWuL2JSJNXYxzLX9xkHxh0ninc8O6/9aZja7/8/6J9fzv/////935vW5iSQigs2ReFVKCAuTQDgleEAVCQCEZ4+yVcFxgqEwdLjSgEPjxxExEQ4oAh4O8WFjPJcNjczxYz+7UzVkSZgkeMnmRTtR+iI3GJOHdcPAvyVQSgKSPLPubjq990lPqwPjABzEiAtVtqxbxtSreEMlqt44OiLOEQZ+GHzfr6////////////////pts763mKzpVENSbU5jiE42uC/1Iy/yB4NpRVH/ZDQEriI0GzJlgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABFuCN4H5a3KHcbbwYyduUFXM3gfhrcoux9vA/Km4UZCBIzwFOGI0PW5q76C5XyuZzbnR1fDtHeTIsYDYpS5UOBYAl9EOmN+z1JjFYaxUuazKiUkznbitan1u1P7/w/nyJMzw76nWpzAGA8v59/V/vV///////////q///7+n9lLrZ2aumtJBKmim7IrWtJ2up011KTeggktmoLo1sqaojxxsnyQNs1c0Y3nGpUTEVTidXLlS3Zq27v3MlZk4JJEXmZjc5E0V61drXwDMJNEI6hUqRbyWlZr498URVfhKY0Rphc2K6nezXJ3HvS9N7vOiMAGbpwft6P/2////////////////bq6ve6zj3RjDjTFZDrXR1PYzU9zUTfRzHZDjTTFrVjzNGuiTKGupinFTJsSMqBRGYGkIy8cmp/I2Pr+93BsLOaq/XhOWqXmn3wqv1LHuhM+SgY/UUjprNitSWKVYYeBL70fpkyXN7rm9UlXGVsov66mtbs4DHWrtSb0/ftT////////////////v9lM1lqvX1rY6y0lvc4nI20242goKiqN/De7EOCLJUNNUMhfdEVwGQI4DoCfbGCeNamtw87lM0YaVp0mnPU2xryQt9lk2sggDJJkqDv83dlXUpe18bWUBlBUO8dEzhCpKq+7Ys53r+s5krDnv/qkFD/hcv/0+d///7///////////T9vPaiO7Mk013Y8xlmLPd11ddruhipR3aqGGT7mHsc7HnHIYztmtc0w04+ehxpcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAARBhTeDGGtyhs/G8GMKblEqOt4H4a3KB0GbwYwpuYxLxgqh8jazftdpc7sv53mGEAoVUl9uhY3MYSiU24guCqn7Nvv1vnwd/FTKczpb1KVFkwKbK8mosSEX8eZWpXWrytrs/j/OucBCCl+Y/b/e3/////////////9f9f6qtdBTspmWpFSqrLQUiimu72dVa6FmWy2emmzskz2rdIu3KCqSF0XYqBHK4DYQuwYlD0EU1mYp8+Z95KMpIuiSqAQOnTqzBQtSltO/hPWla1FZylUYqKocu18tpyEQ5Bm3QUSFlkz4/Ib83nesX3qYZYw9N1QC+nqDD+n/r///////////////1Tf33Z86cebdzyxNZUJVNV6OiIc0xlPpR3eXsDP6MasFDdw5zDLEyrKuO0ggSoBeOhPOTa6jNV6v+Svl1PXcqhs1yn6kafO/QK/vuJCmGLxjHFC80ic6+rNUsJgX9XE50GlaJrO/rly1Qza4qff1TjoAvIfpP//Qq////////////////v9te1J1VIKRuu6qZktNSdGyKa3TZ6L6a00lJNQetbuutklp11OpNSkEWTXOg+EIeBBOFyJ04SarL6tfHD7estC0ajm0bTq+LC0/aaVu1dfXJNTG/TUOTM/t2u6JRKXRnCbBXm5lDqHHCk7v9PEsW9/7qiBocnuINvX/0////////////////+9FO2Wm5rIjmnznUxrEBtnU6mrGLKKYrGnKzselSxkpdW6G3gPU94IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAQIgjeB+FNyfm4G8GMKblB5+t4H4a3J5jmbwPepuXUYwwTxyHQpJtavC3rf2LsAFttyjh2PSYOgyzOOvVTKHaXWzFQiJxColV+7OOKOrH62ElQnLTSwoK3K96rl+UEVe+7z5GABPX6fT////r///////////+n707vORZ0yai0PspkmZzayc4xVOmKjK60MqhjnTG5fOE4gJGbZ9S/LFHbbDEH8GTscfqduWaHO3vn1LkrfyNPdA8prV4QPen7za4vhkpOA5Z1vvbpXytZVCqZ8sfpR7j6lY5vn02HMdvova/h19KANN+Wf////////////////7e9ZzV9e+bZDFNY06ejE0dlp5mIYZLwXuKPR9CElVAUJcVngwPtntAZzgD0DjN8GD5sb+X31jvbYEvcIcri+ovKI202teWbeaXIGWLwRY4njxN3PCrnfUwKBauxAIqh6uGpY7j362DxwDrnrdBDB1Ouv/v/pd//////////+3//6v/XtdW1O7orZ1IVqSZqt1ps6bbNTstbutNJ2OoGy1BpL7mT8QCOFSxG9baGnGcwHYEZUb6C/k3f5xq0QgYaMcmTs0M1EEAKHq6Qek9EEIrK4A0KlXqDHrslRWLVTuAn1ICWb/HXer5yexoVtu+rAStXxK/7N///////////////+//N6sqPZUpfOe05HUwlUT3vrE0nim1d1ULfakhEMnFud8PeYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEHYM3gfhrcnluRvA9525QQizeB+FNyglDm8GMHbku8cyxZRYzChsru+39ouuVL71JjVp+UhsKTuh7dHcZPtZNGuscMlC3aI115T+VNarFRzlb1Nkc0O7mas6/dr6+bV8Ofu6J0Mf9X/v2//////////////6//bXtVaipSKmU1kHRPPRTd7VbuymZkmRdNa7u7rTo0nSPMaujfJSMA3niKepJbFtOYfAjSkjR4255bUmpMH2ZkU/Gcn87Y/A+41AilHQb57Jcwie3JlLbWocQiXORFgCIEIKqDfUS38BbFJeW+m4Lv4hb/v3////////////////6erzKMi1RjjnrVmPZZcZmaApSuo1C6LXQdgvSdIhcFn3oOypxdKYci5CPkPpBeTahw5s672soD2VTRrLbxZAW4nfgy+yCLOAQOYrPJNy9htHhc3UIVJAU/JSdhFgshysWcNXvu6sY89Km4Dn9f/9////////////////p6NdtT1dXZHoc77HHTj2NQ2dZ5210PR5phx7pakxDGc84qzz3OmrLx6lmGYAgZa4eNKRuXX4szW8c+b/7yfqgOoclanXcoi39aYkuorPqOPEzeuRXn0dcscMfR3cW/2wUhJEQNjl25lvnaVSdrn9p4Q/sZ//////////////////77XYyrMax5qNsYpxy2Y52Wj3R0PV6VdWRVHTWU89DXZDUPeu42NouVYlUytHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABBV7N4GYU3J7sUbwPwduT0nk3gfhTcnjuVvA/BW5IA/ktGHo5k46hgfpea4VMbij1WJQaKIl8w74KTeqO7caVFHpJJV27s6vt2v8qWZSgnU9frtiBMSFMXzvWu/PdxmXVz5+iYD/9Pt/6f//////////////1/1dTzTj0mM6ljHVmQ1mVD0nmtd2nHIhyuZUvQbw/OJpXCuHeoU8QFv4ATro5BghcBln1mtnOJBvLvl6wom4WUa0oDllnUypqbsNVFytzW8o+wjaL1F9i9dKpX7rbeoHHR2kGHe6x7+8HStf+3EH8o3//////////////////9UoqHs6XvsiZzIyzys+qno2xtVsxzMlJNDkUxpqpLmHOyonL9jucHdcmQ5AapWriz9S714l9byxrqU4N5MBQtJm3UW/Pe0PNfdmJENGh0o0SyxPPOzuZFBzt/Ju5lYVWrju2aK785/1Wr6/79wFH//T/////////////////7+52v1dXV5G5mrKiKqoYzdqki4C87V5xbLEQ0sWqQfc+WdKjwbl2rxYQ0mdr1SS8Hds81YYSz+nZ1cYdvV17bVuF3rvGdJO00hKIUSW8m7e3kvl16SpBZc54oRcv3pvDuWrb6///UJs/wv//0//////////////+n07HIlE0RHZ0OUjoxfKPHk8WuPI0lHri960taHABEf1pUl2PG0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAPziDeBmDtyeVHm8D8Cbk7UlN4H4mlBzTvbwYwJuRpRAzACRxKD6nX++Www5E2FXGn1wE6nzlCPHzckruTI5wlYlm1RMG8vzLGv3JiDnTm4wD8oCSg83e7jft6zrPJ+X9MA/b1//9v////////////////1WdRDzUW7Y+tFVXMNmHGo7GpY6lndGecin1WZY4w5FQ+hcquu2I0rephZQwDMOk5mZZtiLmeS++cglkV1yMGc2uw3CO14c1UvwyVAxVozdcnEyvcwv11/3sZQLdT0bNr8rGX9xm4G5//gG/kf//r///////////////p3ro7tkPVodUcisYMiYy3dauVm1OiX1ORqrRiMaiKzPIyqaj/Wg5IrYdbIfoZot+b1v96/vf5cjrVZSyqiDK2MKMOLzb8mwih8YYJiDTxngLXJ4WJJndQZ8SJaWTQDdxzwYEsskcYqMnWg3ryEfq/////////6l0KB9JIEbhUTOYAwiGwEJGBgHizgMQHC5kOqFTJk2ecUBVgADIeOByP+zsHHZo70Vq6xu1ec3/ecWnqMYru78Gs3/l3vcH6KoW8gIoPahd7H8c5lRnPGVBo2HK0TGux69v8tvlh3/xTfgv//b//////////////6fpb+fK896o3mkPVMrsjnBqioGrMo/qSntPmbSkEBE4oJWCKwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAD6ok3gfg7cnfupvBh4m5PYkDeB+Ctwd1HW8D8CbljlL6iEkQCPArDe1rn/j2YbBtmtIRPp/bC9+WdHbh+WK8TeRiUfLpV47uth/Hab3O42UCCYyVlofndcl+u1J69znSga/p/7/X////////////////vqrtedOMq7HTnYxTEsYjoqrNoi0sdmmHKcbZb1rd3UcY9FlZ6hwXkdqZjSyQ4qCZmteenbOq9rn/W4AypG6ALDSGuhYt5V2m2r0JaKg7xYpUZNHvu52BZeh7gHgd5iwrRW+tNZXaF4/75W/B//+///////////////p/onX3noKdwaOVjPnZ0RCOo5d3B0s9BDSWNEqR9RFbsIhOt7eQjAL16nhzQWlWZnha8LGu/16HDuSqWl6P7mxe3uKYvrTqTdIiE3UWROMoyraxxQR0NJuCAQN5Cacfz7X1Sf25AuOv14FP+f/////////////////+v6qi7Kq3dkorLRyPLKYszJckqsr1OyXZDVFmSio6sxykROhK1z1IcYkimI0lRMxiy2p9319Za7WYXi+2Crr+pUiRe+E8grKldlRh8VQbYHjjf10cEx7mbwAJrKafP+2e9/85dr//FfwX/v9f//////////////6sn/2tRro9SI1EVIl4pinqZSFKTZtnRiPISzGRVu5TKguxnICTnIog1IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA96ON4H4O3JwzlbwPmVuT2o83gfgrcndxpvA+J25SFCjF8uC8/M96y6/7zrRmkZyOUJV/14HoxuQ/WgCfUseNQt0BZNhs9jfN10PV7yHlsMsQIJjUOf3tV99yn8+f+EX9v///////////////////65xpjue5iZ551GmXc4+ceuiGIypLoavRmMHSzzmd3SaqKbsar3VDJCgEXTsjBiAjK7vmaJNXVLWTYUIwzBqIYyhdiOUki+5Nni8VA8JGB2YgIfutQQmNzVisD3E/VnFKXOE4z/wFf8//////////////////p/7ET2QjsV3qR3Ohy1MY47EcCeCGX0dugu+n9xZ4C2IH+q6phXGJxHcIOdqOjwdf61m31utUemq/lKqtbuUyQNj7V+XYJjqOtCY0hX13b+O/67iefNTIswsMXFdtfW7U39aKd//qFt+b//////////////////8u3usxTWSQep7XkZGGKOd3MZT7EFUM5F1Jop2LcrlKiIyIlpkLV1IiRsHMNRhdl4Mpsc7YpetdIJOoTeYFY8LGkmTIPR9ZeWQ1Mmz4n0fQstMR+1JlCthPhqkNUAcC7eplMt6ZI/8Im////////////////////+tUu885Tm6TWdWOMMPNW6vVaWnIyUY9KtOc9ZpxyKdqrM10OOPY40lYVQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAOfiDeB+BNydxAW8GHnbk7SJt4H4K3JtzybwMkJuT5YhFC3DfSunPc29Q6Z3/W7LU1LaJTWxnHWJ372GMfspyMbtQWNKvs+7vvfQ7PnZ5WLvkqLX2+75X/92d//5f6///////////////////1p26nksiq9ToRDElWjJeOzHdi2Vm0epnZy7srrUzMoKHff7cypKJ2BBqilk5dzqW8c8bPa13QnnYnqgzU/BNMx3HSk2im41JxRRhGI+NayZpq6uegDKYJ5y623+38sHf/1ELfnf/////////////////02+rWSmiOxjomeXNue57HVOXNax6FVzGPZlc91PIABfaOnFpkechJmikikUyHFjISV0r/WN3pvX67HorqLYMW1uwzrLlf5nSwbRajR2IYvXjy/3ZICEWcJKi8SKeTC/y7vL/7P6//wg35P////////////////0/v2vVkW89VsxDGIdk71sVquypO5Eejlaro7oyndxiqiK6shnUeYo368yssrhsGiKJ3r9Xa8zucGfYlDUr5Nhcy0vsRY0FmjPDZGfIEoPE9nRDRx4PsUwGSWNp1sedkFKHO/XAP5f/////////////////p+i30Lqtbmlt0VDIjqrMS0pGJKGjhNtjLWwvLOTUy/WUFhWkmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADmIc3gZgrcmuOdvA+Im5N2hzeBDytybZBm8D3ibldyUHioJPvuXyd3P1laW5u/i3nfmmg2O0nyi2xiI0U4TFsOhhhW3iqk9lr6iAEhInhUtdw7nvlyNf//UB/7//////////////////37WdNOW6u7jVqzIeyojKxpF25z7MiIqHueW5VQ85lOoyeVrdsWxoOYdcGMlkY+c92telbragMwcLSJEXjpDtpHSxH9EQmNjxMiGIiNXT1heJF0pMgjgzg9J5SvmQwW/wP//////////////////v//lLdm7m0W7qRkdDTMU4hnQLdA8II9R1opPURr63MXwDm53DUF2CgOAqFIVtfX4xDVO4Eh1465NXXi9TWHKrGUwj1wXea0makrNr02BSOoHg2W9vj6vB1/+GP////////////////////9Ta7MVVkdytLoU5ylIh2dVUyqzNdrOzu5VQ6Kriw1BlZBhhtp3C/zI8hYVxuD3ewIm8W3T51jw23puqFby2GFDosdljEJXbgvE1iEG1mv4so28ZXQQ9TLed7vn5pK/3/+Af////////////////////0yI9ZGdtrLWzIpXD1RFdx3RFZXZnLsazSEg2Bk+WTZPk4MyukVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAA3+Ft4GPO3JsbybwPeJuTk5A3gY87cGtx9vA94m4T2EBkKSCop/z9a9vHXaAtBlTGu2il2st7fzCTGcq10FvHbN6+shLYONVBqHqDxaqfOs/6f7//Bc36/////////////////3//a3ei1qs4dV5pjnuqsrs6Oe9Kqk1qZ89Us5iIjs9nLfWOjAS86YFF7irIdIkrVjd6fP1fONNaEQVNU+s0jDNiQIfasjGRaymC93F13WvtMNvGG8I8ek+t6i/f3VBX//F/2///////////////////VOnR5EREkOh0q5mLQURlR6IrYSDaUXEQfwkYYVuqzwd6a3gxGGgVl1Wkaiv1bz24/a4ON7OX3Uh/Vuwdc7ExPYtUWh3Vmvn2UCWxmQW8XcOyTW5f8fbFr/8Df6f////////////////9/vmroivNMRJ7mnn1RqIjHIrLsSd3NmO2vOMONVEap7ocuuzTFNMTJOOnIyXKmw27I/xPrRMfOs5/3ujW26QNEvuinXP7730RDGlG8Z1io37+xgEVf6A4jIif7k+fjDR9/8R//////////////////0/16XVVujDLoRqTO8tHlsZlQtmXNqQx90cppSXU7XYxBVFLdpiHLdJBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAyslt4HvalBrsUbwMaJuTZYE3gfArcmpQ5vA9pW5y8N0jDc4PrQcW3in/8rq61HKbeowdlcPVEgbBVkghzEIRhzs6SbhBF5J1hWALYZTjMYOu6Y5f+ND//////////24wu5QELCVCSAXEh1yDawwKhx6VCYLFEpEwsKlhOxwUDgXAilpfViYB4hsHl6/+9q7E8lDhmoThTmINbseoKCXGOLwzjgREb08Pg3GVIBliBC8p671LHO/+L////////////////////+rzWLsRJas8lZKstTlvOyuSS0EtVYzMjqyKhVJRXYpZXODWVTmJ4jTxC1kso9Ie823Ez0dBI6SB0T4jH8UGpEepDjw0SPEDFgirEspXFOJF8V0I5VnqTUpiVkv8B/7f//////////////////e/NqZbm8hTCqlmq7lqzjm3OVdzNVSMxldHOLmDyA3WyC2qGMcVkEjaq7jHFfUb5tpf4+qNlZasTpYwdY+DGpH6RqHMJEWqIZUBkP4Gw+eUVhFFi0QdtqzgwX/BP7f//////////////////+1qPbS1yqxERXR6EWVFYhWR3YQZRnTY9zJQiszM6RAjx/LQfauGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAMVJbeBi3pQahGW8C3ibg0uEN4GNE3JkUNbwPaJuU64GIMYxJj2bdVU/ZQtBJUFNknADrxo2k9IMqyvkTdjq/xnSfcLfmkCRW8zav8/1ZNf///vP3/////////swleoNDZMLmoTcHSQHBcQTw5jGioMjxQkaAbyxMFwQgBoWKKXWg0dgkNUS+/+u/f5iwUIqdHw+HjrMnh4RakNVdNuH/9vxdmSvkHpYEBj7/38WKyv/4r+n//////////////////5dGLoiqjHPmQ+yhQYojTy1rnRVc97nVDMqk1W8xEVSkRCiHREKZIaEEVPgJBWRxAdtl+tW01ONCbjcZhek5ULRFRflFxkBEiKWUnC6n3esPpf2EpBKh7OtRdWdJv/F/2///////////////////tybamNR1kImkxHdSzNQl9ndjoRKK6JsehyqgK1tD3s5lwJptqFo/iHpzd5s099+jbFIwHqww7ysLN56gmJMIYgqFd0N1x+EQ7OD8PcRKtVszGHf/E////////////////////+y3fe6GYzvLtKW3Itu1EK7uiMjsZkrLdERFOpFeDA0kKwPL23AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADJ5A3gW0rcGRQhvAtom5MNbTeBbRNyZhEW8CWibkRGjECwIJSlX0xn1ORB4HTBEVkFGY7c+gNSAwYQZSTdQVyu5KjrqHUaQjnUZz1j2/4Z///////////////////0qvZnby6F3SszszS7qpnKx0Ytydm5pjO1at1lqV1drtTR3yjjGJIJbgUem+qdH7PWmkN0dlZIBzk1G84gIyJs5PJ1e9RMDgzobgfyCqy6ew7m/xX///////////////////6301RiqRVbHSd2hncy73lz5KI0yau7qQU4ezozmCxZ8Pr4h6ypsqSlBcH1UhLOTFbOVqcyJVRROBz3W5CdE0WSZqPQVTZFoha+NA3bEowRzvqXUXf+Bf3//////////////////7O2q/dV8qlOgVq1TzLznG/1Zl9c3MAwbFkgjvCpe9tY6ooPD6iABDhTyjD5WfUgcWXJPaThEMkcpohzhqLURsl5lce4iUlnBih9Rs+24wLf4n+////////////////////PtZ7Kc7nVjI9jhjNmd5ld3Rx1IpFO1UZ3kc9qERjUdpi4qJtVBGoyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAviBN4DNK3Jk0gbwMaJuCzX83gQ0TclsQBvA1Qm5FkSY4ytjz/LfnSxIvxiPU3THa44xp0YuPdShBD+o1EkDWdXX1yE/+Ef//////////////////+zf6bXKdd9lVDoZHeOzszHMzixpEcinejEMezjMkmj0M4U33NZZVmlDumASFZpe3f2/s84UVErJy6Zd0Zi4lJUWnCVkjU1YuljM4ehnTWjVT1jq/+K////////////////////9rZ20lQ5D7aEY1yuUrMZ1V7Oj0voQ92Y6NciGKh6nO0jIezI6mZqAkJcG4Dw9S70//lbLHtH3O9aiY4xC6unGerj2ICTSOB8Fst6PoGn/Bf///////////////////VvWqmqzuyd2e5PQ12NUh0c59Ku2xdmHJNbMFjLzVtGq+5k3hIJFELIMZotO3+444hzx7mk+XkDhEeXKBbcSvUEatNAgD0dX00Hn/L///////////////////+/oiodcqtPfI7ut3O6hTJWZdDubmeaqbMJ4P/o6i7oVAGp/+sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAALxgzeBTRNyXW4m8B1CbktyQN4DtE3BXrkbwKUJuT4MjURYtotZ7fIp5iAw/az9WTmH8mH00pIP1iHILMsegKI2vV8x/4P///////////////////zf99qolzIViWORmspcrIYg5SlRlZjsz0mIc10Y0Jp9QkHq/d94SBGFigA5EJQLM6Hqz+wzExSCW0Gzq0mYDgxlRai9eogR0yUCWHopXWuePf+b/////////////////9v//urIRSq28xZEnkSglUgsZL1WR3pW6O9zQ5mhSpBxvyyorGRCJIahg90VL/yKmovpDhatW8nokQnFrEaf+MV9Q9RUKCnv82/4T///////////////////9//S1pZ3LF+V3Q7M7qmimCXmUjuxjodJkkdmEPOQx0cfZqKYzq2od3NECDaEgfMdf+wjjiCyo7oLHkKAX2UaWz8VB3UCkwpXSnJn/1////////////////////39TaLMy6FMzqjqU6NHKPi9T0I9KoMbO8GqdT9BCdMn8ehKMYgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADDJA3gK0TcF7xJvAtQm5LYiTeA7RNyUUQW8BzqSgJBweYIAEN2/ys2l5MSpOmatZzFx9UUzhiyOvY3asZQqDYp6/mv/f///////////////////pTvXfnKplpQisSxkI6ysczFOxUK1md6koVqEV0dSIhEIi2VtGZCuZFRUKweWGo0idaa3f/sI5LG7hSNPFnOooNhQlMJZF6CUNroB0YClfXnf9P////////////////////TqrmeyKZCkZWcskrq9IdTEagVGKlmSVysrkd01MzSFKhldkGHR0diH0D6heKxF7Nb5i7HorNm71yY5JGZHUQ571DMgvE4FkLRT/3/5f///////////////////t02u5btnTGa7B2W82hGVFDHJSrorNYEyrdCOylUhpltRCA17ZDBBhdQrUiBIISKbv7WELqOQD3U0GvbQK4uNOeL/hgXzgPjId605b7f////////+33XOiMEWFSBQ8ECxOPPEXC4CYNNtFQuwTvaJRQeQFQ4CgXB4CQqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAtqEN4CqE3JYkQbwFOJuSixu3gMJZwFQN1vAc4m5EVAoAAcQKjf9hShpwEb0HmdOYRIzHSo+jbTLjj0C7LgkmnzP+n///////////////////623vctkbNRruZlVldSqiUPVkSyMiIS1ES5dDIrwFP5PRaI0PWCglQosAxATNZv2EJOLVCDKCjeqhEJsvHN8DiGVAQKC/b1P/6f////////////////////1slsyldkQ3qdkOjvMZqqqM53udUCMZEdzKrtI5lkRHsDnPDCczbUEQ5oGJ8dun0x3ggN3k36lXHcRTzSEk7/4ht+R6Iocjpd5//////////+s9QTLggJzwcCxtLSAZYaDyUh4EhoOvaBFEAmIgSAiCxQsSDRA4ooKlDkCoPD0Nvt1YTk5OEO4FW7QciBzzJ/x4YagDQMfp6D3/f////////////////////ub3Kimbqy6KKPjGpS+/gAhJGRGaK7E2TNazPqsfaK8uXHTgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAALGhTeA5xNyVHH28B1CbgrGJN4DnE3BQMKbwHOJuTmCwvH12v/l1GiAbqLtZjiSIWKBlB74pJaAGiEOTX7/9v////////////////////ZN0WZ0tdVKilIhMehS2OZDSvRAxkRLuRjFIRrHaSUggmXKWSa6yflygWCUiY7/+VGylIitSd+jiGIi9pr+xbgqGTf8Wf+3////////////////////qr2ro+l2ZlsRWYhZO7OfdHlaRHu0qIW5leR1R0O2hQhmI4mZTsgzlTSoTCxj6dfzENPAdomdKRcISxQbxP9i/BMDxjp8h/0////////////////////vTfq7veins06kVlMKnmSZ0JnNDWy0MTKtVZUOQwgrNohwYkL400ZSQAKGQylF/1F8jGuw29YtOL3p84zUJBwt/qX//////////////////////1/ey7UIxiIhuzlIzuaaryGUGplqba2hLIUS7jYIeyLKufHnX0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAACpHk3gKoTclDv5vAUom5J9fjeARxNySxAG8BTibmcICpBBD3/5PJoUra7T2JReOHidKfFxNqLAYt/qf/1////////////////////b/urtRpXVnKQp0K2pA6pHKhHSQQ6x+aCERHwmodx1yReiQ1fptWzwGBAHdG/+LXh6kF2rB4be32HNQLGDunyf9f////////////////////s5cxNFcjTFSWVHnV3e1TM5jbkKiqc6KzsLxVhUhksGI2o9HDLt1YzQFwe//opkG9vWXUYKmV+IDNBOKX/53/T////////////////////tvbehmM6tUxDqjKYE5XzPKjA9yGR6lRjRmYg+xNQTGnhdwRRCAOFxiKMCIWPJ/9BfSbqL9aSEvS/1bhMeW/6/9P///////////////////+36bI2KrIDBzmKzqnLM7MpHVC9l0S0Iyz2+7GJlfGyaQyyRgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAAlJ0N4AnE3JNT+bwHOJuSaYq3gEUTckkxRvAcQm5OJRH/+6MoSc/SkshZQ63x4txsVL/8t//////////////////////fzt7q07uzK1mXQqOxQonhHnOTi/RLpYh0+iBsTR3YAVOOaoRHE4WJW/8odadoPfnqXtM/8OKt/zv/////////////////////1pL02pVyXVnO5xCHZiFOUqlU5JplnWqFSwdEl6FBVYMcWycQK5b4VQ4kEEH//tHoH9Da9xjIW/xMdwVR//f/////////////////////6/VfahGR3NWz2ZirecPeac6OXV0Op2eYzMefKYu5Tw7oOLSwCeW3MHRGCxtv/BC7y6CduRX7/XoBg//b//////////////////////byL2OrVdjvZSlmkY3VZNjGKVkdk3dEVzq9HyM66NYR631TmwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAmaNN4ClE3JELlbwBEJuR6Qy3gCERMD0jRvAEIjglIFo//8ypEuO36IyD5fhHx8f/oT/////////////////////6Um7eyMiuqB1STcjOV0d30zkQxSOKS6Wd2axSSFSWxHKrENkMUZkL1LGgr/9DUvqf9Ve8v16hl////////////////////////9Vd7IR0I7GdiuqUdUMDc7SoX5tOm/C+JkPIVHpb29W8Ob3V42Jl//tAaz+thbrfCD/b//////////+oWlcTrCRgXMCUSBsWLuPgQmXcDbErMg4OB8KKYAzJgoD6FFVNB0jCwr/8h19PzfN/4lvp//////////9arHrirhECSTrjAUOCISCw1w8WNoQ8F0AIWA5kQjWgopYYF50F2D0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAIjiTeAIhNyRJD28AhCbkg6Ht4AiE3JBcZbwBCJuchf//eK5v01/09U////////////////////////6pQ6qzu7pO6ujGWHnHdH3uZ7E31lczoyHVArVzK5y3U7iISrEsTinD3//Tf7fl+X/xf////////////////////////qz1ZL3PYGrOrI0rsqOEc/lZVkscrIzUUjsgpkeRjldnCpUUYyd0dJ9///E//7f/m////////////////////////RVd6ryI7tsrjsrHo9q0KU2U75HMyKgZmUtWKhyuRs7vCQiahrQ26vf////4v//L////////////////////////rVrosic0lClOSxWZiv2sjnykZmY6K1UUhGOVFKfEoyIUq6q7A3hBUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAB64o3gAETcj6RBvAAIm5GZADeAAAAANdDm8AACbn/f////////////////////////////6Lm30MrptXyGUiupCBLs0zO9aPVCKe6JZ7IisqUGc5DgJ1q4bloH/////6////////////////////////9kVFl6MdlkISpmaZkORKEVaJKZ2UtneQpTakPRSrUykDR6MaaiY41////////////////m7AxepjAOUDqC4VBM4RAyTCTYcFiIWKpNBE6dLHgo5AZGB4eEyAY/////////////////////1SkmpUzpuh3VmWasq51Qz1QujMSVkkeq0qpVJtBK4Mmq2JM9R8cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAXYAN4AAAAA1j4bwAAJuRu383gAATcjPuhvAAAm5////////////////1uVdTngGIyg4sYE7TwxZocoHVDgbcbB1qBGiCYeiw88oJFP////////////////////9NKfboZHYWjFNIjOznOqWOyIyJc9VHQ68E75YAvYfY/fJaXBTUH////////////////////9vcrfu7K0zSOeRURxaqVEKxJJTvTcyOhjMcGKAkMGZPVgMG4Op9C/X/////////////////////pv3WHV2ZDIysx7UY7LVRzCfmlJbJDyiRMztwXG7utTXfpa9gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAG1jjeAABNyM+3W8AACbkbZ/t4AAE3I07ubwAAJuf/////////////////////+ydM6vOdHsR2LF1zNdSVoHRCsjq86lU0xDoQ7JMa77A6qrtUd7Zf////////////////////9m6dGIjTpRqQRsI0IuUKzHQ3NlgSzlkFhZTM5vPkzhhNEQKxf////////////////////2srNQ/sR0ldLsNdz6sVjpvo8zHKrO0znV5gVIWN3AQSPxlt66QHDf////////////////////6/ZMtbVOqnEqqsx0dVks2mKTWC8cL0IBPgiF4SvHzAhRB4M+pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABTQC3gAAAACXABvAAAAAAAADeAAAAAAAAG8AAAAD////////////////1PXwkbEp1JIskseDcidzthCgVDRGVEroKpasq4Nf////////////////7YiLAI8kSyUVGUT2VhV5WdDgNHmAKV8NSwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAAAAN4AAAAAAAAbwAAAAAAAA3gAAAAAAABvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==";

var ExerciseFinished4 = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwMzlDIDAwMDAwMzZCIDAwMDA0ODA5IDAwMDAyMjkyIDAwMDAwMDRFIDAwMDAwMDRFIDAwMDA2QURFIDAwMDA3NEUwIDAwMDAwMDM0IDAwMDAwMDM0AENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDA3RUMgMDAwMDAwMDAwMDAyRDM4NCAwMDAwMDAwMCAwMDAyNzhBOCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAEIALeAIQAAJkKm8AQiOCAx8OYH4e3Lu8HcgPwxuTAjQQ1AP6w3zAfU6GC+P///+w////////////+IDmH//7RwIfkhtf0Vz+7avQAKO/dpOP/tZ///////////Ket4Y6PHn/7qQ4xjiTi5oWzryVVb+KfACwGoATHhfqDoEd/OG42zumoaed1Db7rrm2FGQTKXMbmBQgo73QHKpynlDuQTC3Qcidl76P3HocnInF30isvgNd79zBODIip9bfHQyaUh0RFIrFG/hQDQWH6kUDO3rQrhJMKRwbyCGQ3sZfxxu1yP9dp864UU50PZ38R+2QWf7bIqsVkFX3XCwxx4BfDIiq9Xq9jUdcUo3p862d+rIjGr38eHPAngofPVPqvErI8gnO7pDc4CvQ9z993+Gd+r2ePJEYIke9qv741Izx9wGTVNQ9Q497RNUiP49Jvn1+X8f+lKZprNIgPiH2rO4h04yMAGd3yYG2V5Rixwk+xHgdasTpTgTgxA1Cwa34ytRw5fXjcbzZXHofkkMqZop33SMAE2whj1g0ZpSDnx+B+OXIYmzuDHcqSypJYTC2AMElElkb+UKwjuSGG1QgGhXVnA4AAERoSFp/4FwrY8wWiOJw+HgLj8JChIYHlVhIBA0uxUc1RbgWLKryWT36UynWPDs/O3llfWOXucCATGFm347NDs/+arzM/MDzry2vuvODxOvOz+8tuNr18DFV8d7sOa+xSenFnU5tf06vvf9vjFX7sdOXfvnesiv83/NftP05fbt2n3zsp1352bzTtx+R3ZK6Y8vrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAH83E+Axh7cvjwB7BjDG5cxSE1tYyAA8skZnaxkAB904mvoroD2tqbhcKAo6nV811a6xHkRXRUaS0Vpy1HrXW+EskF+PNckygbsPo8EYdkzIRJkqqKQ7zo2CQGtt0LKPK9St6WiWEjd2DoHwoHjZe1t38GuM/b6qLegkIJmeaYUitnkfqB41tDnmzilXBHqxzLeeaIdRU+u2VXwz5OdkVKHwz2OdXtk0WaMrE5ZCGpGaQ+Mt3Tigg7j0o9W5YlEYd7c0PIDGo5FAk0Pc4c94tXkWMwPJNuDhDf0Y2ZQUZ5qt0kRSbrTMeNLG1alIjHGoz2rfL+HHhXjyP74xasfGr4YK3u/nlcE/DCKMaPABw+UQkkCEZAgz0PvPTqQc8ZQZOtg6SbD1YxCcu8e3pdJcMPU0L4JbqqLCr1b9hj6qncqccSVQ1DlCj3ErD3JlyQtwiSupXoCesO8yEhwWSrrZRKmqtwYq/ScEgdt6HcZY8CXi/JRfaQ2jWAaB2bGBqIhPbWqohDEq5DPgkLvqYlRZTmY/LR/bbWnZmrfUVhXldi8cR3dawOkJyuMHFCgS3xzSk4DhYK6YsEMR6tFQ8qQyevQ2awF8S2B8Jb1rJ+iczn3ZU2conXVilklrlC9Zvbf7dAscg7uhs7r+wKG31jr9Ld/XWNoXRL81/K+wkcvPc3jkzDlJpPTM0b+lb1jc0M63J9H4pIyMT//f/////If3tRiDXHcQmKWHKAGQnROSty2dpzoByzCVkCLzAoJgglm0F3ngNc6X5cMsmYIKANXbgIngEMCgmKGWXAwadbrISDFHMcUwwSzaKbJ8mAISDDDAQZcdOuTuA1xyIcnkJhhEGQErQCSTTXNEEcAN+U5XzXNAxal9HEGsLsRXRXSLVOxOH60MM4VOqdd7O4fp85Q7C71jsTct36fKYjDluW5btu/G79I/jvuXG43Ty+3lKIfht/43G6e3qUP+/8Ny+vb7hSA+HwfpD5d/E7//8EAxWDgIOB8P4Ph////4P9Ic1//////9Q/vakYjD+JoNMMQjQJHyQPusOutKstOYgRfB5F5gEUxRQEGXbdeA1M0TwKCYopiilo1jswLlgEcBFmGSAizDBQ3toJDJLMssyRTDBLtqb3E0C5BijmOKBh065E0hUjiNYgYuYZBhmEJYgE02XTXFHBDnvO+c3UzJBSvkcMMoTELxl40H1B2Jv3WdhiCY6Rax2du+//YgzhQdU672du/L8pQ/jls7Z2zty4fvzD+OW5cbjcvp7eVJG43K43T288qSNxuN09P3WFTMHwfB94Pg+D5+sHw///g4CByJwQBAuD5+XB9+t///4DD+gPgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACqSQSwZSoABmsgkwwRwAJN5BWbiqAAKhyCnTBNAAGKBQQMEIRBDAIlQAogGCBgcUWF1AHfPA20AQBJgexlCKlEBAhBYEAWDIuYMID2CQUAoAQGASAuEBXRQINAQJoI9AwiDgbqiRAAhIQRRKwoIYA+DU1IiASBALA4jgMFgodRdWXiDkDNTxFiSDdgYhGQGE1GBhxFAYPCQBwWEjDdALD0DaAaAKDYbwK0OBMbAaEIoj8TmG/ESDFwc4XMMcJSHsvFovKNiiiXi67KMiDCzhbgy+IWGSKx8UEmeOhi0Rq5kZE660CiSJjc2TJoZYgolINWA2MDXFnOUy6eMi2OaCECBcQn6zVVFhag/wqiJGqZwgRKmhSIqYlwxJljEmSIpi4U1oqZE4Xa3XRJR1rZTIatcjhcJDAAAOGXhHI0Rjh0kyOovmhWWomjhPJpECNiMFlFssH5Jmg/C4nNT62PIUFskta1sk5sgt5ubE1Wp3b/+s9fkQpXrItUBjOdENIpmGXRTzzCgDBIEcLCgWnmg+PFBS44aNEJkympIcLjjHS44YY0kecqbnMYjs6muUnolbt7fXsrtVF1Vz9GQznHJvRWqqucd9d/////t//////7z/9aZ6L/////+gAAAOAQKBQABgMBAOBITxcaKwhIhVA+PM+QGIolwRmZg3RU0MZgFCyDAY5wASWDYqrEQNzhoTrDlCRukzOQAMaCDAMQAEGCbiJAErwM6hBtjnCvmYZYEoGA5guQLgSaFpC6IhYcru7JjsE7k0OALRxBM2G6LQDZ4WJALBACgnZNzR+BgwIWnkwAoDIsRAcZQKgZFASaAOjgY8AFzQzYs4WIV3128oC5CoLIIgxoZuQcnxPQrcMinRmSIkyaDLMQL/+1y+QMiY55Fzdk0yKGkcw0HUPgMuhcEkxAi6RVi6Q0ZkokF////+RQihoTiLkXIufFzi5yJht5XkXIObl8vm7JpsnICZHRwmA2CacjBCyBAQFBQN3DSHUQ0igzR0nSHFEnT5Klw3AAAAIAAAA+vxfn6ZMTCC48AuBiBCgFUWPm/GUt0P0zcl3HuajUG8BNP6adNMLgiIIHMHuTv9Bky4aSUBOxGyUBOwCXGD/5cNJptgZYA0wvAAFYcY8EhhBgP/03Tf0JuXDAS8TMpiNiZm49D3//spm/3mYXgSwbAVwLwQBllRoHPJc3Dnj3//////0EGNP/8eaCDugmSh0zOjDkmRS+blwzTQQWaKQUYGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgDjFQnP2AGva8q9ODMAGFqQUgMby3DLb0p0B1JuSQAAAB7ZhY0K4lnOLW8DdvfH4xGHYy+CwyHIeFzugkvTGb3J2/fx3XrZW7GVujpqaVcuVX1RRWiAFQxUEV059JLM7koopTfmp+rDtWcmam91bmGVuU02VRcbdFiTMFuPbmH3jMqty+q6kqht+YupqsdxXYbGntAV6BbMallNjjTXYjDs1Wzr2e71rv2cN6+1lVq1qtTX4Vsu4fV1q1TZU1qtaVDS0tmXRnC5vl7Om3ex3Xxs/u/zXMt2KXla1KcsOZZWsb12rS4a79ezUq4L7eWg5+F/HH9Zd/Xf1azuSl9WcuLKrXc8efa1rL8ccsvx/LXdYZ173N7vf3W9SQKJrTJsx1ACmwxNic0IT6qlJEXAgMB8SuXqKlPrZbKNlorRZI2NkzpDgbYBxyzq3TY6Xi8iicLynMS8fpF4vOtSKJdLBePpomRdLqKjJSRkZERPJj5IKQIPiFuGNGWKJicIsXk0UVomReLyKKOovJV9dGpJJJJFFGZPZSK66KK0aPMlkFRTRUk6zFlUki8km10VJJdIyRSSWiySSSSqKNJJNI2rRb9FFlJJLoomJqTRJRxX//groT6RX4vmyebeE2S/LPWdAOuaYQIh6dp6OpY3K7d3Om5M0EnRtMLYT63ceJnBdakykziZyiloXLa/L4AgCU3H8n6J078XZ8pePRxWMMijkuvagGcpKbtqmpsO1ZfYluG7c5IKkntZNEQJvoATIebi/0Zm4bmHqbHFad05mEs0TRZsoTQwUzMDmtMj8fl03L7M5HKmFLqiylOua1rC5q5nbry2guYZ4xuZtUued/HLCvzu+5UdyklpMDvCU2IGzpb9LbmuZXsK9Fvkvwyyt97jjas/Yrz/LW+97zWF2YsX6D7lS5knLC8M7n91jYuf3mub/udactU/b3MOc1bx7v8st7w5l+8ssMu7y1bxv93rPGI4Ve7oc92EWAwwBZBADyeX55/nurKqkmeFUB81g0Cb2Zt5c/8Ob3dubs4VcalJLOZOg7ZkT0jU3h7LWFvd/O/SompwtmKklJqcmj55ZRcjDM6bHS6UjUliDmpqalAlxniOMxzxQgsoOcVRkiZBGRBjQ4mVigfLxqaIG60FqY1SXZdbXOIpMkkznz9SaS2UtK60XSMXUtReJ5KmipVRiqut7TRnUmpJaNFJFmPop6kTaipWkXkHQdNmQe7VVMpFExY8apItvtRlzf/D7dj3LIexxUoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIW5BRozvDcNNyCmQLT24hOjFEDXMNyzk9qVB8vbkAAAEAfVyy/BiRQAS0uZEq3N1u753CpbgiKuQjOZEgHFzTsq+gmIwJTYX6Z/rVLjKZmdlUhlszahyAHuJQFzRBEkQW87ewnLKnjXJZAMxMzNmxR1vq4arXaLKzRPwytKPFGV5IZnoMp4rOQVRtLlb/RbJXLdHqaWjHASVB5D2K7hFnKilU7DU3M50tFU1es9yz7PZbqyytfvV71vC9XsTk3rHnfz1238xlKnoXDrsSh6ngqVyWftWaa7TyvW7Fqpypf7jjfzysbxwxx5y/R9+rzl/D7NSny+VI6Ra5l3nM8Mcv33X2cM8d3KlXPHuGevz3hveGGO973+W8d67nWz3yxzHe70GcxtYa3UqlECIgCwUl+hBUvX9/6t7b6SCRkgw9CRfN6KSjve/++97lvmFPQWrNDf+Ms6ArtAfDUrlMql3cpmnzvTVYbwW594cSFJmkSKokQl2yPaNHnjOS4i4TWIafP9jQqEgCOYyMgWGNnbHNstLEdxIFoOfmDm9NTYtmNvL2lbbx/mbNK3rj03vFd+Zmi/N3OLGYcRNb1TM2b318VmvaNrOrWzqPC3rOK537xN11W3xl/EvnWN09tZt//8WgxYcLVMf/f/zmn+N4x8/4z6Vz/jW9+sf03v43G/XauUyKkVIAiA1+gmdY26l7djGX0mDOIYSsMRi46kHSIYtXe2WUsnn72sL/aX78Jk9BIZa90VuygcAKIJjBBBhCf2llvInOwiVfEJHVrxqWXr1FO5Vc4vWqRilp34eaf+JzuL6Shsb/RB7piPtwgKep2spjqZrbcZuYyJ4px1+PpL94yK/HZqjvY8rS+isTmOFWtlTxvOUXd027tqv8mmp6pzPGn7jdz3O2XoYrbuYQ68Fixym7L5idrW6bep3L61a1vCxdnbtW1lVqS+zllqn3lu72mpeVa1io587d/87FjPDtXLeNrdTDe/p5VWzlPMt//N97/NbqY597h+/13eucoef/MI7EYERFUA2ABQJT0O9prpz/7+d7kjm1VhCaa+sNNJwqX7H85+PMbeN/l63hLLfLbpJcGR8sM7EYfqmoLUN3pmbpWpsbI8GI7j72vXa7a2wKZBM16zRleuaqN9MzUa1ZsxDLL4dBabYhu7dvWxX0gQo0SLBpNrNde99b3m3iz/EHD/EDVIcGm9V1bOIW9XjUcceqba4b2l61hwq6z63iZ+fTGb3mrTETGvrec1zum7Wvb3u8ra+LZzr/Wt/Os7rb3e41Gtaqztba/yHUAuHdoNzaKiQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACEmC0iMaw3aq60pkIytuXhYvSoxubdLjNumAnT24AAAJAH4V5fDccL2vIbXiMCjD6NIV5DC92fwTRS3GRsPZ2vdlQrTOLfV1OtyeyMM4lEF424xKGl1I4/HH75MM3a/Bsb6zI2rYzAGwzRt4bn2+p4IkMdgK5GeRanvymdoLUtikGUtJBc2vOlmZTDURk9zTlRuHZFDz4srfmJLiEFwM4iK11FZ0ENWstrTU8Z7nMTUGu/JIEm69vGpjd3aq0lzVDbnsq9vO3dq1MrO8P3nh3D8cs98eiEWL9LAVLrLHHPmdPR5/vmW9f+ee8+U93O/25hzlTPlzLueeu/2npIpPsx7lhl38f7j//z9979Xue91db/mst8q4Vtzty3ZrIuIoo1xz0B1KfRoACIA4Gg7L3HpLtG9/+8cuUMtYeCDjlydOVQv8L/fz1+essbusMKfc7anYIdYHVhwkP0clmKtne9266NEq2sQcaNUqjj2rAoNVm5STqh5o5G3khhseG4jLh0dY+KhIdx48/eaMPJzbWfNu2N2VdvVqPbqOpSI4t/f93JgtcrNNnuPRTHQcjcem5WjCRRn9JTHIeQs9T181hzj+/9DH3Pt7zvd77/v+q1gGfAAACAB/YNnH2UCWMlKRhQQDe1a26T7EX87BjKXJlMpZa/soTnS9OFMk54ZgZrtC+qcrNZasZl0ONyXVD0NQ1Hn3aDGZbelzZSEGIF1Ca5Vhmstw7MBAHqYvny6ZGR40TLCSBFpeKgNmyIECE2oFx3cnSkVi8UDI8UiLuZjdEJhGYKJFaiopi5AuuT6jculgvmp4sjKh8IH8I5pRmyKaLGkyuimXSkHxqUbOZIpLSSUhMSLlZmRS2HUPNZgeZndNFaKJmy0EnSXp1UjyDrUpJbuuki6nos7JGqyCPRZHf1O607akd1N+vZB/Xb2rZtRhpI+tinBoQBg1cUp3rnMN08zlGc1sCMwH1BoA3J+L3c7NNc7Xyy1S9vzVX6ehqxLk4ZRKmZArwyrHHlHNfZqTO30ODHcN5taDXO5Mmct18eDS7W/fxItZWdUtbHKwqBlgPh0PdTsslnrbWNE1TOoWLQc7xnNoX9sWjb9/fVfbddfOa4+J9MTrfjWnxJWtvu0K1fqmvnP9vvON2xredW//+fb4+cZrEO3uxyhGKlREgNIqMT46tYaYpxtVQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhujFCDW9NyzlGaMCdNbh0mM0QM6m3K+kYo0G0tuP42GXU6+iqWT6MmmFiQ3vUdZzMyCdorN25WjM9XaWFAEwUOPkRgckvtCYH7Wgynhqmh2OOFYguJwFSyVrL9VnmeRVUtIasGDRGye0/lA6kcVUFAiCZLBLt4XJHYjEth19rE1TbZgNHIfkUelDywVfqRGH8Ls1JLT/WYxJVKSIBUbCuJW2MOerFFMotboat+ftUg6ROqAf/K3y/uxjlTyqxjUtWoKbpT87cwsWN63nzlWULcwz5ay7eUXq/u1Cp7OvjU7jhWq28+6yyx1jlnnS4dt5bvc5a7nrD9833eP5cyr6gTKn3jzu/5vHWv1zPW8vt5b/Luev1r8vw7nrX4c3z+fr8sd3cv73K3T4dmq/TmcDQB3IaFU5PdjzuWdDnt3JcMgC25p5JMHUB1GaPlrmrVvtezSRSZ1NSSnzvQS41CYeAuiGIlDNM/9LZhdn5omD6ikVjqbmRikx84bjBEkwQBaZpG6ajQujlKB0lzQlimMcLuPUumZwOcIYTQKUjkislUj5RZjM4UTRNBJBJ3Q1HLF1AbaaaJufdkrJ7utadJBEd7zpdKJOSfY2cxdBBazFnpHVJ3ZaKSaC0VK3Uo8impka1S+cUl1ejrqTZT22qsq9qNBS/vq9raRyTq/3pX1GXaFTkuQtqInRCxV1fjEqx13lq1g8kMJzhdWYXCt6JuzXsYQzZ1lJ8Y9O2Llf7UYl09KJWSCFjmnGLcjbSWXtYiEkf8BNZv7yigVzQnTUglAyNicKo6Q6yRmXjExJ0qEcTJESqTJudJxZVHMJQVqJKZEDD1RGAiwtgssiZmcKqB8vFYoKCAoHJgsJJsgk7IrWgpFkzxKB51JqNzRMxQW7WQIIPtSC1UWIiSSllE0Laa0DVlm63dk603dmVdRuyTurRUnZGupjyS0XUOemtSLVXayLJNq0l9X9nXSXqurX63bon174qAAASAO7I4DWDJahGFVlvH6nK8co3jpDEBDoxEcLcBT+OGXPx1lvHmNumlkUnL1qLPgSgBlOxGBJRVdGBKdsTWIrakDSCHhhsTjOnMOG8FQ+IJDcYMcuSza0tBFOSgllK0mhAkchh/HoNixkpLqsWzUQgYO1C630x0u5pjB2QyJqXObW/u453v0y0j+w45jDj6UiWxuueYvfM9P42sjbx/9S+bc3J0/E83/V33EfLGT8//2+f/jv7/+v+pVfhsaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHzY1Qg1qjcuaxigQbb25dojVCDO6Nw7xGZ8DNvbj+zK0QMUW6rchAYxQFAYvYT5fhw2/kU7Wp7NJXgr3GVvKFJ/zQkqf+tbqUtBS50sK61iYvUsTppmOS+vF5enuoAZK+mc40saYwXcXFAIGfudXnjp5IqERIEol2KJZKpeSAkPIiTIroj8myYNSgo2IogcIsbkWHSZjkhiAEQEXwyYuEUIACJAyZcHARlimTqyqWC2UhzhuhYoAhiHMFBE+RExROLKzpmpw0SdyGldZiaJy2tajYzMWIuI2djFA4pIvDvWmaoImpsZnUGU6SKKdNVbJIVpm1I89FKy20VV05otBZfHtNBDervX1ZtQaj9fXqq6n/t86fxjxJAAAAA7qOIuZbWwMaTXa/9XIj2U1WYsILNB+oZUF6Xe71aObxtZ1Mo7HY3PTVLJIlQzEamsyAKMyPEBsYcOIwFH6lUMAdRvOKxwmWMfrhJbTAnlZAUr1yVpEKtX+rjaNAUKfWrJ45jmO8v6CQBLAEkHkngVUBgctR6xKZbVwb9pZI9rVzFctSwt6pCWXCTz2pPa0Cmt/TLr0rbEMokfarnKveLFtLeXxd5y+9dwLZt90vbFd53XVN4t8X3jWs5/0ZM9tZ9df/fvnO7fVL5gU+74xatMb1vH+dZ386v9f1zqu//pu5BsU/GtQJVAokClqeCRxDIYSZZxBSkusOe2H4csv3HZp2XCIAgUHjeDJRxpLfT8pkkJnae62krXVSclcYiGEBy3s3EFyrjMMhBoKgWKO1Muza8wIUuVKQ0STculogxmYmKRej6ChiVxqignUThmYj6M03SIYPZicKIpAGCyBEGKxTCEaBqygm4nV3VSZRsF0gGQQ9EjNFnakWdN0FGjiCyCKRik6RwwnHTURcXBUpzZFyiQBFygis+YJHEJ17LZ0FIoHkGoGLG8tTdTprazs1NGkktNZoQZDd3UydOtS6bMqo3Tv9q6S1Wv/9162nFYSnIGgWJrX9ixO0WBJj2GVu9FM35dhEFGcw1TPDpWBMOfRqN+QUHL/InGHEpIhSTV/CMO1D8ML3SkfEHS4CEWXTkNQK4E86JEPv8/kTmfzx4y2TmBuO2Pobep1Wo2YyX8dnSkOBBYIjexsiWNxKJYkI+2gOkhQtoyxTYTI5wMtjjDiRVOj1l5eHPX0nh5q/lb4Tw6H7zLi+f0j0kh+mbOev/HhMMYnW7wcLOKQb31961a2d7t7az/XVfH+7Wpu2vm290n1D1q3fxr23iBTVMZp851bf3n/vMxfPemM7pqt5cWk+a2xSvh51vW/vFpMtWkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAABmdt0yM4g3DrsaoAP29uYkHPRoznbdNFRKiQza25jAAAAH91qZkcTZWXdjQ+W16A1+qDsTgfGmksQm33tymGC04G7AEssUuG8q9mgoqWKzuOH81K901Syvhm4hojA/9axTUNZkaEm9X0YmVNZxI0N1IuYmY9m0xHkwRRSMllY0JszPIl8vl8nRcxUNR3lUOLBdOEQTNGMCmXiugWBXRTkEC+YJIqRN0DNIqFAuk+cJgSgWkzdFNnZ0FVoE6tyGDMHk2c+ggkzutOipbrUkakXNmUzMynrVoIOzKUut+pb7zAAvQ1v0JZ+/+T0fGbYP5OkLW9yHsQYs1qpP50EjnYnRv68iX5hiEcymKZqEwzBkRh6zbu14u7+EZoYDoY9KZJx7cJlga9jBINxE+ICfuUtKxjyASAZVI3xk0eMjnuG4ty6hNTKuJo67Q51Seinq4OLUjmekiVayxHNDTDGMEQkWAmC/EVW4VrQLQ1aBYZaarW8O8S2vIxxaxk6/jyPLZw9izYvveZ/SBeLWZrOHMNhxGmzrd64zqmb6rv/X3muveub/Fc5zbX+M1zu1NxfZ1b01SBbUX5xrOq/FvmsWuPmuPe09/4dd7+9e+808Xe8b+b68eNvVPCAAAABvD+TUodUukcrxz5m6FGJbTJkoOoCkv1D013Y1A0ojSmI5OH7o/N7KKkxK5qQOQ6DvRK5B0ery/HGBKWW3XmcpVE0zygi5lEZfQv8nqZoTmSrDlNJtYXC2UIvS+WO3LpAj488Uo5Y+7cHpcpT7QEh1sMpeZNducha3Ioora6uMgjaIIsPtcT/3ORN8H9iytYKBACHgxWOebDKgMaJwMCMLcFsTqwM/D9tIgF2n6nH7cQkBR5aicNWZyV2K9ret/hNyqNvAwQKgbLoTRRerD9SO0FLfl+GeVPA8Cz+GMXaZnlzWWesL1etKMcss+2eX8sdZ//N/3mNTHke5zm+c1+/+ofPLaRUGibp2oBXfbgEEAAAAT8e6sSIgqPzvzk3BFVWIQAztncbh25KnfTSGCg8AEVLD8NxyMTcsgOkr09NMUOq+pmpHpbKsp6VvIY0QCxWlbchyhp7m1s25TLSHnSJ7R2IPg0PHygdZ17ZKJs6i03UseSVBoUExMoD0aDYWkIIY+ITp7IOMKQRwiAYYn0HzuqnnKmmomw+L3SGpFMbzmu+GGjZg1Yxrnw6L6+PmnXP+9/LZmXd1N7/++6iHulrZlznSy22jZ18zdcxG63Mi2KLzwyblPtjmTuqF5PXi10AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACP530KN543a5SkpePw9eZWHvQI5rbcqVqCmRPD16YAAAAH71lY6VAgaAxAemGDZhEwdpDGrEiqMNNZfFL1cxitD35Rgaq5okseUtAjNG2WVUbwxyIbXNBcLV1QspYgzuAJx/Ja5D8beUaAaSkmfDrWX6p87kfj0DBPMIh+WVK8Ipn/TfAoxL5wNFYpL5TXZtlyX6lLfu5drQ5EMGUQhnzSUQVnQ+/yXerM+2yTgEBjG13SrKLvxGnhf1MoaAYMPB0Q7gIGJytq50zMUNeOXInaltSiZGyJJEyEMEzXfuSik121zVm9jQvbu4FxEUHOMUtiC80lX1ys02vq25xtmi4W+Rh7nLt6+n7369emtO3na7lztyMfe79jCx3He8NWsKe3f1rf1sLGWVbDv/fzu4aFVHYHrWRcWveFN/nf2aDAAAAAAAAAM/GLYjzxXgjAYb0PbfkE3FX9kDzMDZvPQyzJE8x5YlJoAtUk3K6exalVNTRmXSCV0lz71aV9jj7nEybnmwuM4VosUd/SsS0CJZRTbxa/iRdy+G+vDiRcQITO/1d5Es5QmuWMyIxLRYdd6pJCrtlUpzqnd64tu2d1+K41HgscXb7GK4+73tjWs2smvrykoll8z3uf/78t7+M/v/2zyA5bvnlWW76s7Xxd1FL9M/nxaKxw9gAAAAVsf7duCoaQqMNAghBhhwDGgUsZ+jpq0pmPxGi0/E/TbWgmMy4ZLGZCLJLqnlFJ6PnT07+SJVZHpZqPxdEBB4vOrBw+4UC0cbcWAWbF30PEnziki2ip4rYeTccRnNiJba9I6SfoGQ8nzKEpOKdq2pXfnF1xXN67U4XlnK1uwvnGndIve+pAFUt13kRJqEwE9SHIaVVFU+uUGdmtQ2mJDgSYnWHPqJcJOWFdnrNSvypUvU3JVTNJLAgYogtYtyy3V5rleJyu45cWgunjo4HDytVr5dgmCFrV5fObmbEjZywSUVrd9ujQ26cypca2W6H85ZDHc6n402FrPGtYpatXHKW0NFarWPp8stUFvOl1YprmGGHMPxz/WOsqlbhADJQiJBzjmT6Mi96EQAAABRZbJThNDUFqAjoBrQAQmL0Fy9dqWJx467R2CG8Dv6s8x1rKOw4/8AOQ/lJYytTVNb3Yzp7ggmErWldeDuIvkdAb5rQK03KNmPr7rjxsWzryQLV8Wn1rGL4mhtufl8jHmdZz5PPpvFfEDhUt9Zx//8xvm8zjjGINaY+Mf7tT95UKqWGQJqou7gCAdmJjah1KBAtQ6lxUllEVkJ60Duc3FWOUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlOgNAjW+N0pIoaZA8PXiCZpUiM6y3Km6gp0Cw9eCAAAABvWWd2YUGQsNCABIYFqzKtGcnQ7n+8HK05sYuXUoC77zRhrb02VIgIEDDN4nPQllnwMDt0hmXTMQbV5S6JbFMxOZ2X1WHf+Rw20sVAFjQsHIJMYMpefcNTsBqqBUSj8vm6kfljpUNsHFtSFatG917iFEbvymNziur+GN94pRnYLNM9AoJY5QqyJowVndYI3651kqQ72tVuVbrX1PA4HHJQANA9bjNqbVe5es4Z1LWW5+QNnM/gJZ9mfv0uE1218plrwhweda5QCoCGh19mxTXklo7f7jOVr24sv2XzWeb4QM3XPKz2ilNjDtitT0l23jvtu5TZUnKfu91sp/O7KcZdT1K9Lapv+5/6/eqfG/zPnMKmsMN53N95vDt3ATBVZiNFhCMcY6MWAAABmW/IwEwyFpcUHlNo017d3eMupvd2TtKKWrhfybn5XL6mF/uMtvaZTFI3E7lTeerEAvGBDD+jP/mPZhDTjwdQdS4xFDMnzXGd5f4xal3sCWHlzzWPNNBtbbyBmK5OTfn/XvLrMkhIQtWL7t/853W2b4ly9j3mz8X/r/i19/t03VMiV8YLHVrZi5E/up4upIlMbqxRKrtIoOJE0KOTl0sNUmEAAAAbz/dT15tqCByoCWaWIpNQAwajanDx5ADLOwwGjL7yyUzjhxVRkakNRlk63VlBhwAkdMqZNAOSAXPUlM5Ncl2MfiL+Qw/QcBbmp0JJ1wvtJ7ksuPo3QtS5dqIVZ+GIzL4NAAc3K6k5brQS9TyRutQZRS79axHc7Mqcm4YAFeaqEQeVe/M1lnWw4yBWvvRAkTmoCSECgQEPBvwkQl4sI/FJhMXs8Ksvw+kr1lZzMElOWGW+5Y9lE7TvGpgW0VgmXSTildruFK+8Q5jVq4bxgafqy+R4RK1Cs8O5YY/vXfscxxxqaywqdzx+p6Fx3YMtzS4iDAG4/g3rxHCVtO/32cd52s6AAABSpa46BXmBSnWTdT6ZPMPxM0G7GcpYGTXg2V4vqwFhSW6scQZxRUdyvdnqblWHZNK4xMySAR0RNV29vmDBcTsp66xM/g0POJbVr07zzQoO9Wtq0XWs7vEzJqt7XhREKcM51en3jx6AcUrGt87+s//Fd5tRUW+90/1e2viu/6RDKAIcImhXS04hynJcjvz74TcFGH1GEopFtwoXIEl49A1DUCswAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI6XpSIxvTcLAqGnQbD17iNdVEDG8tywWq6VA8wXmgAAAARe9UvWpxKV6gs5wSfF1ZiRLFwMEkgSAAEiGjkgQyEDCgArRL4ccAZHzCR2Qy91Ybbg6qFQVABgFMYHQsMCETMRCy37tPZF59wGIQ5LMEumNSAwwRZs9z+3LkY9lQXAHWk05T3dxKUTRYBM37ZmKT48NC5DTUlPqApRGLXyLtWINTniIGy6MsPXhNv01yIzzKHqMmOdShjsxTzz7vomUCUB4FJb1nap3ulPI7D0Yp7Viv2Yxl7MDGAaSZp5LPYd7vs9N9QcAWWE5z6WeOErg2lsSW3cpKOlyq/PULZbV2gtyavNWZfQWZynwxv26+uYW6lWbpOascu6w3Y536mOH38M+1Ncz5h37+9Y/lPbq6rYGxpd66o96cc3TEgAAABYo1aJP+/AoUC/qpUQklxZoJsSzCHwvLHGsvAuU29jfZ3dxMktkk2GBDDx6JyO3/4362GUjuM+FCikn4zKBvVc8MnOKZpTWc5P2maWz8y3iUtTOL++K71ePLSLO3Z3PLdw0ybvf5f5lbEQLm47viPSl/S+76/zAiW3Sm//jX12t9XtUXoCBPzxDDVrU/3v+XdzytjxmkXhIzWCl72CGK2MfJU2Sd5pnvVPdDdvHHmcsxZyqMyrLBjcVrr1twhlTAOAmjQ6ZSnHMzRosGZeGmJgMFOm8pvJ4TA1BOV5yCKF8ou4KwwYBLmHQYmNjGASZh1mzFYzKqo8GJkJwmCKEYtOhafRxolAw0QztBKM5TNyy1HxCi+stjNre42aAcbh2BKfb1xma11sbs1bK9HhMhdis9LSsiAI/M5MxX23A5tXVeIv/CZqKyx1nuJbgEC/pISjunlEaCm3UrZynVLjLqqjxG290t3uvzKtvdHVmAKUc5rlSmAShLctrPBbtxzCrhnTY3Hdy7DML+PVO93lvHXM95/FMfw/Dnd45c1zHeX6y7j+q/O97+HNdwy7urgtgWGoljP2Nuy7341feyZjbIAAAA6fs5EdCPu/ltiKeyLjWEug4YaeRw1Db1SMjVeWf1YtblOuzk0miBgTCDISCAEFDsEq8vTdeSXXAERo7hzT5smUSq5DC8SJfJtI4pRoQ5aa1JPJ4yUmUHKRgpJZaMDGbqY8bIlAyY1LBiZnBljAySZaJtHAI7B8M0YFBFKXklpJOpnM0Ytx+6k0a1qSpFkWxCWPZBJFJKcFEhpTG90oFyQ9R2xVhuKhXdzK5EtblfasrcL/PDvCupmHq88k7ugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB/RuUSM6y3K1yhpUDxFeX5XfRIxrDdLfrKkQXD25YAAAAGPcf3VT0Y8HCKoA8+edWJQ4/6fKTat69Ro6DQptO4h8HMJKalgYJfV+t0is13OhppXPwJFVhY27rPgCALShAAAkwcLYnGi8bbIQCxcWG5xeYcOTxFVEv3bu5SnKns2Kwsaq+znW7hBpglVrMSnqbuuUuL6WqtxidYhode+0ROvLerNCiM7xzwOdUMJiBJnDV+oI4FAINKhZfJQq7E7GfavccN435pZYNAu43ccv393lJzFiZ5hPPOWysnH7s/S14/n+tYapo3FO4Sf49YmP/8sfwt93qN83rnda5vLP/1X3l+GXccb2sBP0GsgVRJPhx3LsYSu7/872nU3a4AAABu4KJmW7U8MxuIZsRaipSiqKZMCXUfaMEpy48GVJfnhu1qpa3XmIFZAwJH5jYoMMW1+L6is5QIEBP5E3SQJQmjo5JgXj5k5sRAvqGVSZTGyjhURUWTRRuzsbFtjZArKLzmajxcZGsyNRurSKBomqcMgkQG8UVJMrsjWlSdyZHAghQVXVqWUh0ss4ed48CvOXQYzVrf372/8fdf+SS2e37suWCpn9/V3PyspMVUd8sXvL/xEAAAAY6zuWKZJZ+CyyN4HU/UPZKMS5/45Aq1kQhYMys2DM1kE0BZF8tejnKY72xYkXZJD0CyXs9BUaeKTq3whRpOAyIEkAEItNUUHuJG4nhJKsshlObGkxs6r4ZTAJxNW7N+lyjwVHO9gin09cukd2HF8wPLIDi2Jjq7VWfTWlt6V3r6kIDMEbseFrIsWsrepWWKJ60DUDeyavSvu+73czqb/J2ScsI3+Xf/88bNNTF1QHyBazgESucpX9wuUn2MO3srtaDpTanvuUlXu8vz/DP8cZ3uG88scO2r+XcPz1vuG9XPtVN/3v9x538rH7sb7f4ot2CxcogyRroy2RAAAAloiayiIWBQ9DjOmQcfZoLGAuo4sGnBcaLrZJTRy6vrDGlpbL9W4tS0sspIYbqhiEdHjgRRbRiC9FWudMSCa5jT5uN2v8CFCpJs9p2y94+O5fsNdRa6zj+8CJZJxordaBWkk82ygjZV9b5rpsBcgeEYzao83/vHte3/YFLN94+t//FasCCtWu8/WsXr95+8ax9wb2fMfuZk12n/ZF/PLq0HUENLkKdn+Z/0uTyST+501+KN/0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhVdtAjOct2sIp6RAcQXmCR4UCM5y3C2Cfo0CxJeUAAAABvvaudKypfoEdCw4DUhNA0V0Zavl51PROHTEBM4cwki/4mMb7oFcSapH+u0GFByEQA30ce+Fww/M3KktWDNwiQWVOic1iQqOOeLobaNYQDJrL0g4mBM87+7WuWCSOHbVDqXWcgVZA2PfrLAU3bEjAQT/2qUoBzDqUkeNxTgrbnJS3NpMOiNqtVGlSgC/VsUL8oND3zWgRoZ5A8BQUtXfK3457/dVAoEg1Mb+H73ewzn8pUm0chcgrFUBUWt+3DUPyvLLeF3luGKsMTE/nNWHmt7rXq8vuUn44yu1h3G1njf3zdXDHL85d+refOYa7nzXP/+4b3Xw1TA6iZqiv1lIwSl842Y73W3MwAAAIQIxrRHKMqtWhfaNMtZOquylO0qAL9pNInxmU0mNrHDeHcKvLMhnIKlVaHo1GGtL4RRL+CS1i4Uzp0+o2HlA4zpqc0MRSRLLNqBfMC+swZ0TNZ1celJMbnC4m9RqdWZm5qkiyYxEkHmRJGYKpIFAfzdaVBJN7IrWpAnkettVVAmSFou2tpqr8bO7HfN7q+YwLM852z+oBkNTaTpA5BtcoP9vz7bX1hLLkaduv+0AAAADm991K1F3MFGFDAWa/kGxyNvTDqj7ltEkw6E/yGQiBEnBl4HKLPZA7NNG6X52Q3ZFDcBvNp54bl7kNba82dhRQ+InwAWHZngsLCQ1feKtStjSbk9BL862pmXQEWwg+rb/VaSgaZ8o3K5fSS+x/LKEnGM1ED4IAsTN8mjMpzpK023Vi0AiqteyAk1Q/nqemy75XG7wh6UFIhaCpq1lz86X99xccIykerv3sfx/uGMRC4AanIqJRZvqWvjWlkhs585+P2J2Tz0QpvuWIE1nz/zwvYZV7XNZ91dr49y/HHm+6yq4b3jY/G3UvY4Y7/LuXbWWPPtcKAUsOiERawMwD0CKtPjAAAAnYMAt1VLEiuxGXsxjL7zrDMkfWmuuZih844/8DV+4713U7lqV9wlVJAE7DdqdZovIEyAzAN5FuIgcL6SKjqjE9WxfRKIJCX01KTuThPEULzLLiM7JBI2cwkTScuImiayqaDudE8ZiUiQSY6ZmwvCidQIQib9da1MknLpdQpVpa2dzhdEGUTE2IWmyTUfyH+ddGlcAHb/L+2FxzIufbdqg7lIsfVtj8pibSoaprG//L5ruAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH8nVQgxnDcMOOOkQPMm6hedtCDGctyzk46JBsvbv99q084ShxATxUAPX3ON34y16Wt5HWwQMoAjU11GZYcYrZ1OSGRwDVoG5vrDjuS9plDGuTdEyq1HJU0kUCJT0yQQqAlg1jUmgOVZ8WpKaa9njQfXjAVFCK1PVzp4IER6Xl+f+KYXr0jX1H56Ot2qhesFUMrVHL8N3YxSQUBuP1KwZWV1YflcNSYQJBAnFL/Gx7WaKtlSWZfSR/VN9e0zEaJF6SxcxtxiV4WcKspXyEanr0NRbLteVw5I5VVnqTWFPGvn4zEqSZzmI3QbyxrcpM88p2vhj3GpYv3N9vW+9ypcq3L+OOVbVXuvsYVdd5+GVYGRwaNXBQ5sOuQhtE4tkgAAAdSov3pmEelpXhvw6qagadHpI7VwUMey7nhc+3+dNX7yM1qa9hHKSUu7EGnL7foKKGPIaZLb1MbFq5IKWzdc6tZkUg9ArtQN1x7Yho4CpSUtcvOmYllMqJHXSN3OugNBZ86mMqYoLNTImBdgjZE3IoVmuhTUdTQSU5wqOo8pkziKuohwpWggWl1LUdSRddBnY3ZNS2UtRibMmplqTQNziL1IIpHjdBGzoOpaCNSJvUo2RUZlio0sgmRWTKXu9qLqv1SdhhvFUVnD0XRBblb3WWI1VTlIhwUrHDa80ForcE2CoKpMXmLKCwCQ6nTyorsqhKDjPWToyL0oX8ZJNwIXvWuoYySyhqIA1rgkQtqYKhEwy9hT+sHxJgEeGzQplDsuO0h7YqBZ17xCZd90HdWHCAGpRCIw/JL0thu7Rp0yGH4ghS7Y8SwWDHJjFiU3JR7JbgtlJou/ao7eE9LJvEHU04qSZxao5XNXvnqlnv7s2uQwjTh+OXa+WtVauVZKkWcvafRs9nfzNqZou/fy1MY0eVSmncO3Jj8vtWOYZ5VN0e5/Khx/HC73m92+67jTfl3HGRYcz+xlzm+6/tjKpXauwIuzAefr9K6qVE+/vGQAAAAyN372fDrRCbxqvFLYqrGvmRqpuMw5OwFOoVtfnpP2f5T2LENSipZlXblavDkopH/gqKteBMSPiRARvYp6sRjjT4xZn8UtA0yA3lRAcKY7xDXe08b7ua8fO4k0eHEsuPAiu4EWHNBXbMTneTGmb6vn0AuaepcYFZp7YtvFo1ZMViMbNqk2M33r78pvDzj4bJYGpMT4rjcXOd6zantuBD9N78feMe9vjed6xvVt/G/Te61vfe829s7tJCaf1vX/214JfVlfMxSb1vyXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB/ZvUAMZy3K0a1o0Dy9uIMIdPoznLcreuqiQLLW4/CXUliOMwcYLqLBTcCfay7j9TNRrTlNeoYGeeotpddQywqFwl9l/Vmpoq5f6NLma00puzNmAwLD70O84UbYcoMEVhYMoPEWraJLC0smZTBlOsKCo5iPReGHOlsE0z4GkpA0tnozMU0GGCM4strPHFYrXh2pBIYFDV2GSJOkEMS3836V7Rxa/Z7G4ZNI23tWFPLtW9Ne+5MTGSRlA0rDr58zz1lnzvZ6dbkpfnj3K1vHHVq3rBuQQbyo+Df4Z6pLcxPfl/McsrE7lK6K9Xwh3t3OZ3nvXaamhGWfKWirY/+Hd9q2e0O7uH/zKpy1UB7rKLfjkWb/9Ma1az/2gM3ny0AAAAR0BmX8NDIXnYopU+dWeoVApG4abpaUOAi0jmKexP0FjO9jQztFZnMpLGKCUxWCW6zarluycrtnuS6tDUQuV6VhZWF6w3Bmv41IUaFHVVq6My94W/DR9qwXWG/ddvvGi0slrhhPKjtjy0vDholBq1IrpYt85xvG9YzDpBxrHxjH1v/VYIqr0+v9W+9Y9sY3jesY+ZDagEEL0nVtMLFAuBBAQiUY9pBIgFmp06NkqM2I1EAAAADWWGs6xYEfsdZTQA7MCUku5Mw1Qzsw5VAyFprbMjJFjANFAV5sej03TU0AVdTUvdu/JpmU1Hqdl6c5SYwj4hk4YQ3gEmh+WsupouggLCErvXcN4QFRy0XaahbvXcevEFlZTWzsZQ9duaoSJXlRnqOFCZNrZLMmannySX4g40+Z7l64IVmbTOc1f9OxOKNDCZVESClNelvc/DDm7c5p4wwKnuZfhrXav5fdSqGk7WMaY9Xx22K9blu8//+cwoqV68/r3ItnvKQa/e95YvflrLKezsUmeOOOVvVbGHKueP/qp+8+51/7rmOGf4c3+98w/n/zPv/3f61zm981+t5557sZlB1AAAAAvZ02zBxSXZiffqlhvUbdWUvwKIgEJIOIY0tnVjfbF61KL294UudmMTErcbUPKMV2VhJVfuNLejMxWtPMTFIyAahHRZ1WGd3REbYupWUF8emZpFZoikeQNjFAqGQXQGyelETsnVmKx9AohYLElyMkgpBJ+ozdlGp5PrdkrVCzCoIqvoOtF7Xe6npLOmC0NE3XUy6mZtWzvspBFJiTOJ6ktSSj11rs5mNTc+JxjXKDtY2sWPkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhXiE8jGct2z866BB8zbl4qF0CMZo3Dc8Pn0F1BuSAAAABrPWt8WCbQCOIRHUcarU9qfsWo1AMYh5uSsrZEFwogkIqSkZBbuSmy8UjoaS80F+5ukppiSQnsTXIYBaRhFUNNLJDu3JnVYYfmFpHULAl2V6rafG3MnQ3C8uZ6rylAxm2EFXJ+BMsKV9kL61JaRDgYPER9lz9Muv2HW5ADFHTAk8zWg6k327J4g1wisfUYDMFCSYS+t3L+Xsrd6zlSjSEttfXwvcy/DCzVYyLTU/tjYt+Wat+O4as97Vy5qtuzKZHM5zsgy1fzu7wy/DbJP+5yWQxI6mXOXNc3uDfkXdTH17NTUzMVbmP5b59Pf/8s/7vv87//vv6/7n8/+5YcyuTl7uOr3lZzt0AAAACbdD9MwBwytfKmmpTD8GsxfSJISCQ1W1fUgxl0stzd3tqzdn5qgsUmNe3fqzbeqZtO42IwqigaO6pMo8zqW4YF2s+xfBsfK6bKdnD5Kx9j1KR8xMzQcuZF0nDAgBiipSDGpqZDlmoekbJBwisyElCNHIB4RbS4H7kRQQTPOkudNDZZ1FjA+tbpI1LWpMjgtZQSWYKXU7Mq6CtT02MEHdFOkrqTSW7sizGyWgyzVZuRZye71zc6yzepSmSSPPRbK3LwF+vXzlvpovARFNVgAAADPPm+cZG1YoGy8P9I6lj7fM8puOQ2+j+zLzEgRcdTV1rM5TXLU1Rv5S6fq/XpefhFbdqLgqZJ4MSMatWUMlaDWeamtZEV8/O30KIzxkUgMaWOGKS5kdAJAEESJ8pxZxqxkRoyhikL0MRDoAw6AOcsZUdkwNkDpATQCg4kkAhEDQdBEuEEDHhTyuVQbBwwDIzSWk2imjWPwzrJ0UkU9Z5JIQhAYAHkiNG/dxcpXYopLPVKebGxQHs9Y3TN01vTRY4XyTSrQOMm6lIpqPKJ8uGDHlnKkHcvo3eZsnM2sumtkVr3dafWpXZm0C4uNaYRAQAAAK3f9gEEw7UhEORzCOx91WsyJ0E6xuE+MhilDcu0Ez2lt0st7SS6ls40U5IqrK5amcv8CDGDOJL78qjlMkzST9MfMC+XS+agqF5GqYMIPKo6y8fRJg0UnHOWgWRoysbpGBfUtaZQD7LEGlxai4ms8T5AQTg/VhyBCMprQOnEU1GJobnz6zo0zSo0M0FbuxiLQIJlBElTVzGcpOi2qumo6TJstzjHGQPVJVJrbUcTXUqeSRMTVFi4ihdkFHiLmrIou7TFE0dOtkaDOm6CnetTJ1PTu6V2djBd3IQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH5IXPoxnLcsYuagQLD25jXiU4jOstywW+KBAsPblkAAAAb3+fNouykxFEQwEyM5as3cuyXUusRV0WYo2AUQ8Jnrh+LXJXqvuRSK/7ObVBVyoI9B2407olwSBCw5iMDjaYKpLrQOUyyAFJLaPHG7Q53Zkwj6K/zf4VhwmUy61heZ/ZyzrOLGJ9rqPsFjPrkUsBObvsalMzCqAQhzlVIdTjLHu51fwcPWUeViY5Wt/zP928qt27nHVfWssM/5/63n/XoByM51u7n51uqyU3xLLv/3Hdn4+z7vN8mrX1dTF//7Z3Ld27de9zvf+x9inpcZmjl9FhzL6ezXxn8P3hqznrl39f/fys8/e+d7r9/38P/m7WFfD7uDgvgp3YWAAABNQ32qCNZnqk1JJU7Tzva3BNsUEDHLmgd3I1Lfq1cYatX5dq5L8Lub/4xGUvU9D3owEVmLxypEb9eOt/vCnpt+4VoGE6zu97PiezpphiZhTZhvI+YMNnwpcwX0K/ZqLyokS0WcO5Ufwa3IABaORmfrf1a28QImrapLBfYxvdfb4x9dThFWxWusVzqut//P+sUvG3nW863nOtb3XH/9sb/+sRcwrwd4jZ+/umJ/H39ZfzoYr42Rjt9dBOVraN/Fqa8HtTAAAAA3lhvK6minkIYmMAv17JXYoMeTMpwpHxaU4sCvKKHTPVy6EEwzFpmR3I+6UTv7XNEq0Su3oeVzchluxjyI6eBRMxo41YRDmw2Wr/yoWljqOH5ybrag+HLEOmeVA1PnZzxgEuJItYYYM47QZQUweP1ZSVkw8c3SGM1DDy1qGUzsFz2SpIPtKwt7nYtU9ICgQF9BqUifarYYr3d2cq3eUti5SUSVkOS+zlj3e69ytz19DV8u4nerVTTsUgeQbgvWeP7zoYGqQ8vKEXaWxV3FLMmytVO6tUK65/8c+1Z3DWeM7UtxfT+zl/CtI8qm8LFaLYzFm/WyxqW7+fc9b+7T/j36lTefMN2ub/VeZxv1J/mOOPcuY5VAZeRogAAAUOxW+oMKAXd9xj0vznqsSZo1oARe28+lety1ul7h2lz53moDprVNUcGAG5Ch0zWKNvKLWVSw0Kft5bhxfBuBtvq/ffIwJYtNdd0YKyMn7awUXm+Npwi3jSQpbE5hxCfoG+86obw64MOEtbtbwMVpu8aNap4PHubY/t/W+kSPzO+571jW8Y/+fnFa/7x9fFc51n/78D118evxXdc5iXrjG/TX99Qp9brr+uo+p9YrjWcf5+oY7ljswKx/3/qywAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACC+FTqMby3asbVoeBxFuImYlOozrLcsXNafQPL25QAAAAHMP3+SwC3wLMhUZyy6zX+5rWNDegGifdl6sosSjY+xt5HWikBUfvXep7EpdGBo5lnSiMDb2MyhooFDiEaGAISIxIixhmamItdWgYaIQvKvfs4Q/+ZoHxb8crOEdRqlta7ZpXf1VtV2JXqSPrkhA2sjlebtE72s+0L8xxr1iulXVr8t13KSPgV1ECDc3NuYxu5lfrbs1ccLkQcO1vmeWWWqnMeXGjoPUeLCXPn8/WT3cx3DePNWqavMWoRbzvZVaucxbs87K+0tij/POp8om8/5Zq42JmpGLVWd3lhjj9f9dz1nh3V+k7zf87nl/MtXLl3v/3HHDuGeHce7lGxVXQQMErSxgAAAAAAABEBoX8Rfu3V1XrZRZ4mjKXGsStUjiNavydxv//ZRc3uvbqxetj2mfbBAaVkiT/zcgpb8w3mdLw0Nk0kFDHFZlJrnBAKx5aZRNjZayJmqzUuoDHmSajVE+umaxZVh8stNi4s6D+cQHUbMkedE8tZsyK0TAm22V71TgjVp0t2RRTr/U7Mp6Lsita1aluo29v1psuamDHuUAHnQWLstl4Val1kq9iIR6AAAAHaGYkL/xwsAXwEQ3cNah+aciOw8ziOw7DWE7Mxd/EiBGQOAOTnd2OyWTyyXwzhK4pSPFax+c4SC3Hv0nhikqljDizFBmL00EV5+UQE14eq0sqld+KUM1DkEGDY/M9IInWfh4y2MPwxv+tci2pVDrFdXYmlXJzOlXrT1Gpwp/JK/70OfRL7r5oqtTlFiMQ1I3VGiJIOiKYvL29W7bqYyupP9jsDcXVavV8beeGfcc9X5SRGc09Lzy3Cs7l/cbxt/r/txijux+M4Z1Pwyx1fsxu9Uxwt83jjlhq1rLHdz8ak1D0/a7a3Xr1MtU+d7Vnd2/ulnMv5l/bGfMs7mf59zy7zuGP/rvMddzy1/O/jZuL7CQAAAKdYAr/vAQeUleerYU0rmIGcZ+lkAuBmkalVHOU8ju299x7eldir2AHO3LpukVkMBBQ1ek/Lqzz0vX3ZfexmpmO00Ow/EMo320/R5fYFNxtKmNEcGuNarGtI4ujXOrIdIl5FC56JzDwkXPwHcFwFlCu2wJi1ZNVh3lvnWWBWt4/s4+Pm2N/f0exx0xMjt0vJvGP61384/hUzreaWzbO9YfZzrf/+//j79pXKNEnV/AqIVRbkKMTA9H6H9WZ+Xt/mP87oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACAmFTqMZy3LXsQnkBw9uYYYtNgzvTcsrQ2fQHFG7oAAAAFerAOEhwVuY4JCHRggXZVWo6HmrM3GYZtuTBKNhnnmdeGLJcx6ZrduxuzUoaSpP/dlF1rqjN2Vx4MbLxpMEy0w06kjNJLq6j4GPtUVJZyry/clGN3/rVvoe1UGs5THq/uFRb5lIsoyvtoztCGajnqV9JulpaWepLKmFnS2mz1ZilnZAqg6MgQ+Q1pafmrVnHPlm5FLXbDNbuWv1jzfMs8fepotjsfhWMxSQVRYUX/jz9Zb67b40tneeGf4RmNSm12plaocM8Mcd0vcdXM7fcaW5N4XK967jqvb3TW94W//d6vrf59/8d5451qTtu9h/M977/f/DG5crl3oyKEfQAAAADbiVlSJHjjYz3bjjd6N/F8hQ57ysxl0Wq7sTnb9Wgzocq9JZiDGp+cjN6WjkBaIKY/zXm5cdilkVVFKnlUZpWi9aGBHUNK6urrpijyHE5nYextrEHLW0Pi92a4Uzhp9VrWno3osBVpdjR0u2IEOGAdKuIBMqIdq1173hsWqtpDGSPvGc7zr6+rjyxuC5Zplv3a+/bf+dfO6bzfxa1hL+Pf0+4+af/Oc479vhPmpxa4GLXtnMHeJ6QK/WcRMY+741evprwtX1X4xjdL/W84/3TN7/w1t9uzMZqp7r1MBlbg/6+Wd65PWsMrkWpo3Tv4OAIyBg9zEiJfkqisCSqJXO6i8ccKXxCB3+lAoEK+jsubuhgFAAiLC6y1WQOtLZPY27pgIFuduVKvy2jaIZSRKrv0kAR6VROE29atwTB1Nbwit1/1AUoZ0El5dSXEgbPasnl8rsF/5XgsBAzuzuP5w7D23LBwWU5VOX8db5N173csqO13vc981vVzHlcaJV7Mpkd7mMB0V/Ln//2ILc91bLZaPGU0mVj5XCbFJTUtfsEUlNhuzvdNexp7XcK1em5WnbklyuYT9i9jhzWq9epUq0s//5d1zLX1JzvL/dZ61lz+fhzK5rOnwn/w5+Nm1zG92EgAAAAIYIfjx3u6u17F+kk+TV0eQYxFeDHVh6nqyu7fzw3PVKfO3uVX+ZW3eiTJB47NXbgGQRveXEWJ3G6X2RLJcTAOAkkaJHCKmqhpsXkVoGxomfLCSKzYnlitTVM0KZfKboFk0WJtNljwV0klMXhlQWgCwE2RhEEEkFqZzAnC6aoOYEXVvvVRSOHSYuibpqmqCKu/UyLoMpSKZmeIsW000egj9K1MmXTMEkVIMk6NBKzu6tq2qZF3QSTqRSpser09addlzjH0nSCOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhiis2DOstytK16BAsQbiDeDTYM6y3KyTUn0BxFud18rFadKhMPDsAqQKhvphTw/WjGMcvQ3HZ5y1oCMmDTw7cTPafDEPU1FQwVR15PPPBItzEzURCf7lmeMEpeEiGM0SAam1+afyU0z/IUzssqy2lycKhkBzxp4xarD7ZsbaRsWvxSezhuvLKOpDkppY0veqhAzX4CRrhqflmMNyTNDSLXhkCBc9VpymiwdHDpCSBA5/CxU3rcTi1N3VPSX6LXLeOu597hzuDdVNMbu23uSiXR2/jV7rn1MLFqS0Mpnv3vKls4zled5yblEBQfj+v/OpBdS1q32X5SiILRgT/v44/jnVk++d3Xq08qoqmsf/v27WGH7qZXKmv/9Yf3nMO7y7lf3+Vfe+Y3dU6dYABAFQhCE/nLq93PD7VPHsaVP8EhWhN/Vz3QXdaxwx/KrzCYw+kwaA+FkhO4b/TtWUWsoLQH2t8SUmgpgExUWZk8bOwuGgbskWVOZqOzZZEDQXzoGZubG1kVpivHjMcorKRTQTEgCyknDpkSykE0VmBFEUXUeUxSXNktNeyCSQoqC6VA3OLZP7oJ01tWsvmiSaBo7NQWtX7qSUx50DRZqXUBj0rFhdz0VPct8PKbr5EwXFQnvlnHLNLVm5gns6K92+qX47DtLlyUX67vs/UcAhIwoI+iEwoBYeKOpdgmBpqR1Xsfld0tqyqmwT3wqRMGlTeglEzHAQQOX7Pt0sPdS0UbgGX2Ls3bp3hprQSC49FFYXM8nUJ0usUly+4Mvxt1HZrUl1nltK7Vp61BpfhYk9D9xS6UQzcaBUps56qOmlqHZJDSAV7r+u4SiWU39mZ+tTaeeX3L+u7/8O/ndrIQzndudKJfS2KPlb+dzwyv34hnuD7lR/dWs62djGtV1dtWcM8dTEmh6Vcr5asVJY/8oz5dneXMNY3sbGXcLGGNWhna+s9b/WOPNXt4Vt8w3+9WMvz19WOKHwnhF1qgAEAAey+oEWPMpm7lunxjTooDDqBmr+SOU2spmr+XeTlrlB/vvFJ6dWmqOVsdGDwvCANw3nqwqlnj5kkgmxRAhzyRMmqSjo5ySz5qsh6SKbFBJNAmYr5k6yqlM0CaQcQhWamCKS63EQD31Eqbki6KNZQSVQYvVk6dVX+7MWBx61pJz7K+6V8xoEXUbMxmXE3VZF6dqkUubmCCnM0I3/QORT4oX/va/89il3JTWbX+OVeMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH2IZNgxnDcsMuCeQHEm5huik4jOcNyuU459AcPbjev7jkvBzh7AosQir63fx1qgu15ZHYQ9Q6ODizrbRrfan5DPwJNSPCHZTAstjtu1fVVdamXIdEQWCZqX5DCgwmlrYuJ8ZhKLc9Us296j3yo32zl1SXWb80875VPxrPVXxty9b1uxYUBwZzj+ahGWPa0y5mbOZFhH3ttZV7MlVtFyscQQoC1P3aWbfuLbuV7dmm1jp/LP81zH8ddwzrvEuvKpSxeCr0Ujko1vD9//wbIbGfYPjkVu2ML+q05njhuhjksx1ygm87c/c5nzPOrbylERppZ3edi92vS6z1hlf3nlrmX65v7H6yxy3+e+/jll/NYY1v7vOvs+5/wLQAAABIe/4v97dwnq1SConZL6BSkmfuXV6TOmu83PU89q5Le4vjfoGwAxqcky/M2Vjllu8+m+xtQ2x+rsi5YBBRmUjIwTQllS2sVC2gxYugsuJC4CZL5qTyKy66JogKGNVnXQqSKYzQVMmC6QMkS8tKQ0kVkwxkbpzh51FxOpNVbsxRE/JLKZZKCCjE+g+tHWgtTJnysxugs6Zn1pVMzqZqSemkmjRc4YmRfUnpKUmdVElAO+v6/9XG7xl47fb8jXvXrZoAAAA/sPy6IM4HAKYEhKBjZDJJZH2Vtfn8I44jaRmJy5P5xQIAYsjH1XQB7WIMmpQ88QmLjDpNelcDzC+GnqHgZsmZEQKnacNA5LnKPuG1+jgSNJWY1+Z09Wfm50QHh2N50mFyWL5xqSh/HInLudmRNAqRx+FdTbr0l6SRPlJMVKSrRPd+LM4EtV7EonWRDVX4uM3W/jYZ7D1/7l2nvWJidmm1wqZfSUkswsXubxssev1ZnL7co+cwsdqUljtbUz9O9WVJ97CxejEC87j9/909TH8r8utd5nYpsc7lmtUpqtNr6eaw1vOva7n3mtTGUuy3vd3H//Huq/cMtZ/jnnT/d7qxa3h/O/+rNqvXG2sAAgAmk2tdL+6rz+d2X240v5ewMjD8zD8vxws7yu3tynKzM52atyIEAnaTlhh7FbGPRbO/dxzvK6p91q1vi/BnobNBpj3TnzSBhi3hzcIFZoCaofzJDme6w21h4y1vICQ3X5tdDQyHBOJ9xiUOxHUiXbIWOxsHrHhPf/jVNf4b1ijbfesZif6//+/rFI1tXvnXhq6ms418xb2/+MZ8uLVxEYc2ga+vq8vv/PlweuYq7KZYmxiLBFRKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACP+LTIMae3Kl7WoEDe1uIQ4rNAzrDcs4wydQPD24+3BCpYfYikKXBJPkvBAFnztt3gVgUWi6lRaoxIJr5dVbhhTJfdSB+p48LYSmaqrSMpatJ84651KyF6pmgq2SUUxIwJkHMUAJiwwyFByEu+9CA1sEwyyKyWLGTF3pqdblcttjOaYcyFKZhdMrXcGY36vBXg4kOL8wuJBZm10WBHqFKvmEOZVYkXi/IQXU8F9wFtQeoji5TiQApyZA+gbQeiQLRzTyPPSCzQsRj+Bfxt2evb2Yo27Wbl2MWLk+VSxywj/Sz5ms+hIcnVaXVnUsNJabnveaouFpOMu6wo67cdYhOWG3VdyyxrtsRqUqqhRDoYYrbEgK3fw1x8PbtMFvUloeLfDrPxCtaWLHgVtXtiutqF47bNjG7wt2xFg7rFwywAAQAOZmOzjkg1CdZdZ9Hb2ZnR6iMazzK4zuNefbrtn+vtuipAmb4k2XMwE5K8htkFufg/KS1RRQLtMDobLpKsS6E4kkcYnnUTNSLPGe7n2STdZs5NsSTTJjhmNQlpKkQaTMlyMkkmZmKNaZiauZpoqei1NrrQICnMzc6j160Vvm+k63rdFFEzdFnTUkvrRbrTU1Q9D5gPpPtVPHKTqup1zrL1Lfo+rhLpVWXO3ook+w2+6UaoaXmq1u49dayCSYliQ6sUPaKEgaZUMz0vrRt44VNwxgyKQYVvvJ3NjSBFiMmJjCyQgYie7cw2KOOPhdYQVA03R9yj9S3TuotSMXrNSZseyeQ8v5cjsZorWLjSLcQafdXVvcvezmedeIQ/10fsQNC8cOZbTKCGPq2BDtLbtanlF2zzdTGz8w+MFV+VLeXcse91yihqE3KXHLcTlktzvZ71+6moZltDukopmQ0lbmU5A1XGV2r9WgkN/tq9c3S/XwzppzfJh0pqU02WVej3UuVLlvKG5rdLKH1kUp1bv/+rFP38d/nYxy5+X/zf2dYWs8+/vD9ZapMMa6+LAAAAA5koNBeQak6/vn27Mt7AMBNCBgH/jj9OVXl9udoaOtLexvWNevdfd+RAhW55iKsOtBai9k1Hp2O40rdy4dSp33iMzGdI41Ra+oVYWs5pTCfoxVY1u121OINQYvlmrjDfmBVso6jOsTeynEWAj0Zxpl+QmaLPF1bN87u5vHuYWqWxr43ukaivt2Wk95sf1//z8bn1CtiPe984dK7GM395JrX//+NxIVZ9SH9SH7VxrX1Gzr0rvxc7xn0+da//1/7/29N/+nt//iGUZkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjHi02DGsNwvi1Z9A3wbl6l4zyMYe3ayTWoEDwxuP1nT3MUp2CIppbhhnnUoSEaZx0GWNLYnXd2FCI6LN1MxCCOEkSQgd+HbfuNytabAFbERHcZjFYDryyhjxZVo9CxpQd0yYKRDS/Lrv3YaQ7D+LwQVi8bi8XjfyKffxPJ3HYZwuxgjsP41mf3QXLEUhh/I3aaZORh0EbJUw2Zl9epSUmOUAN9KGyRmbkEjt9u50rohzbq0oPpdVohqYpKSGIpL4/D7/5s1gt34nGIw/kOXNYYWNSjWO8bMbuTkQlFJhhhrCnr7pJXj2ciM7dr2edn7cxjnXt2olcw53O/hY1hKKLHPVJG70Pye5MZfXwzy5dmeWaXPK1CtXvx1zXMv1u73PK/vHDWVSxX3/O3beeXN77hrCxSV5RhmAACAKbiyzIt3kL01n7YopnjpJ2SsWPFUXLA7m35bHKikxPisoi4MMfrkrglbNFKpWRE/EXpO4lUp5cJuyBIKE+GCBgXDQ0YmlIoKQNUjQmzM6kWCWGyZG58zOmLsgfTRTL6blEqrQQNi0WgVyLizxWpPomiZ5kEHQmBTdIr3SQ0G115s6lIpMtSCtTJuqpS1mTWRnC4zpKQWszayF6CBgYHiy6KibUPBQAyW5kpx02mP//qX9T7f248nVAEDCAAAAB+pTFYettVcdDVUolRCcXiYnDrwqSbGw1YJTlwGMkMGVy0VKYt3WaSp7Z6WyWM5O9G4faxEIGZc7UmQcW9StYjqgyc7mJ0tQkMsqwTAcfsLWmLV+VveISrWcJCxLSia2ZsXZflpXNyuhI5Dm5cw2NUqEwy4sSkc7q5xiP2OBSFBRb2IhT9qjR69iJKoVIhrjqNDV0jdG3lguxv26DGvD1DnjUgU3O8ewr7w41l385+sYnmzEv3G7rLyJm+38Dc0fGN5YaYriauY8dqxakF1JBf0h69n2M3fTxLNz7Vq63T6rreYZoZqNz/W8WhKqKUPiMTVkAAADawEYvQOHDAQtcO4fR8uVmmx+ULuTqiNrDL8aK7UztZ3eZX7lCWAjToblW14RuBXG39Durd+w1nuWLDbQ5xaH7Nr3d6m2zrfZ+XLM0Sk9AjCV1pUe43FPRxuZVGtSH7/JgfHZi8Z96pauZnvrSV8Fjx6OX727qzf7v9Skvw823PUmv/vX36Ldtd/6ZJbm1LVzqVnZ369n1vlL7KyrlmRQVTexONIrllnEOVuW2Hw0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIS4RPAfnDcrItah4N724gYhs0DGcNy1hDJ1A8QbnG2A/T3dNjkEOKoTFfGLAkdluyuoBdmxNIJAPLEZUw0OifVujvQHHakPRGAoJgaDHudF/WJQCXjJpmXa47qA1hbcWesllK7m6vBEWjLfVuY3FWvNZoHzpI1gIQP7FHmjLhR+WQzMS6W5VYOhrCGbjtS95aj9RpucMwU30Tcm9KpVM3838pZmHaO5TYZ0tKHHprTkx6l+kpM7OtztWUxWPRaF2atJLbOVN3dmlvUspoZ63S9oeY1bNym7jzmu0spmoetYS2rVs4W87GNHa7dxuUeWuy6eu3vy1Yxt2u5Sl9bMozrVs88cb2d/u995hhufz739450HdWsMf5vL9Zaz7vnO1rnHMEgV7c8kAAAAAAAAAZuEjKRcqFa0zjHjPw0rtUMSqqa57Q9R7zZp74exMF3CgIOtYBOTZWChVUZcbbvMxEVaLPVTopnkocG7RNaj1e3tql4G39IENsTUatonxPVl/tAbNyZ7bHpXOJW8VLjJAWrff1XywotcOUjjSG+1i28y+8KLi1oupqxva1q1rq2tY3etcwteFb3vArrGMfWt/P9v9a/3um3vaNKJCg1rsDtcvnh7W22LaEmq12ghmBaBP64KnbERndqZh2kqU1PdpccTHQG1YGWSu4wcCJFvexqXXXhfeigmKTfy2gclRUNYDsn9vQa+yFZCjPgINCzOZijgy/clDgrc52mgi/Wj2JVTCbOPatXG7jQW6Wlvw9yknb0RhMpf2G2CXc9PlS1Zu/JX+zUziVK9F+p3Nu8PJGhkrEGvLC/zmr+/qa1c3ayoX8sa13vOVN/vedy52tVtx+gv0v7y3+PKCw5T/S2Hd41PtUudinlWFamwjWd+Uf/zdNQxWx9SvXmretytutPO3qSxHf5jflVNvn3c9dnpPKrl/mvpeWcOfYvX72Xd/2k527y9JtY1eY2eyxRPKUQQAABlqMGViWRln5fW3yWKy9cVQNK07lqP3X7Uv1LsgwhEqkVqnymRh7aYa3NK1KPtdLOL/jNNIKXCs8CpKTO+NQQVNTAmTUUZy+VTizKLo0On7kcUUiiRYhxXIiYpkPL6kzcjWVUcIKmR5qs0SrKJDxcYcoBdKo1iMWyjcipqZkHMWlwsmKIsZbKaKGfoMgkx4+jLhqdmxcavW9ObHziLpoHTA+yJqYoJmSbVKfujrRoLLiRMpld13cxRTp0FrqU7TSkpkOnWyjBne9BDf00zqKQN+ZQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB+yJTQH6e3K47nn0Dw9uHkIpOIfnDdroPqfQF725zWBvLmXY4ALguoJ5v091+s6+U67Rhobmo/KHMMOE3RDaq/MPSS9D3JDKE8G0mrNNETBr0E0NvvVkUTZcQlVAktWAy94cF1TNDbSgt6mj5NSO1xGYCQQ59mtMws6iwIcmIreqNyVVUwsSqNdiX3rO+lfX7HcsEaGp9d4oyErAs4vEckTYfUj7vuDB8Fwvldroftb1iW/xmkm7Q+3xGa1Y209StcX3JZiwiT4JM5t77GWPSuhWkmeOo86GHWt124xXF29ixqUpZ7VHlzcnF8sbk3Fea0+tJPVULlHRVZErmucUpPErAfQ4MTd9XYFdPaXDthtI8VGs61WNDqzEbV1AACAFeg0aGf+f/ea1vNusxMui/A4SX15djrGhxk1yrVvf/ZsHCvfTYUsQU7xanAVSC88MsMnRpMZWeU+87ailjb1jVdGnNu/vuI8spIG8bUD7TY9rG+/jDlhgxu09ZYuLkyBpw3rx5H1nO8602bmpEYzo3Df1rrW/v68aJW0m8fcHOPbGvjf99VgS2xmeatK4i01fxdZ3/rf/372rJmPC+t/51rfzi+tw7zTT0lxpcyfVgkOJAE05RAAAAAzve7XRaULVdg1Jr+3/z8KVAWepz9SBn7KwFeLFVHwuyXOdvUUcr9fuzEk9B8yD6a3hXwUJGAyg9HGWRmmqy3HF40U6/GwW5mgy/BIvHLu8t4yix+P6v2fkvZTchiPwjbSbFqhrVO9zwfzCHqGo7GdaN47uuQNI+UPRc/ecsx1nYy3llvGR5Tlr977/e7y/CxljN5/fx7Yw+7l3V2aqU1upf+pzK7+qljPso3lnEny7+Mxlh23hy/S2c7Ezm/ud6rY3X7huvVpu71MU1NTvvfyw7ve8rtzH6mdTdPr9buXed3lhq3nvH/x5/MsO1rs2QAZACZDIP4iB/fGMr43mlOj0KogSsgsurQbNjrDt9G01lABon6yTPHkIsJAVOo0Q7dXg29BfbXCBjZcIHwIU6tTfvIX1z/xpftKzODPtTKmsR3rw6y4zjFMp++4G6LOPFPYD071hh37u8esbXveezLIyWrqmt/4z5P/iBi+Id8f7xrFN/cCus+FG3t/f/GsfLdj/Xx//m9dXjJOuc338Yz/jNPeXOPr2+Pn4xnOP82hmXBXSf9fkst4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAebi84lPwAC3HEJ1KFQAGY2QUaZSoASfcgqAxTQAGAAAABqmd2ubMQW0tg4bwd/+lumgAKNCHthiTEAAQ7ySSrRu53KXVKvVJTkhzaWAQFHYCeCrTVaZM+QJRIXubS3ty7KtDrDs3TkG88c676JwOvllc1+bK8e7/CWX78Pdj1BKqaG5h2PtZ2Mf7vru+2HCetboLXJuaehMW7LtTmHKtn/3/8r443ZfFp/DX5fzfe/lyt3uPN5YUvKnOa593c3G8rWu157uPezNP2zc/POJcyx1hl/c+5Y3qe3HLspsyyVX+W7Ovwuy2il9am1SV+Sqpby3//hU1+8OfT3t/ruNSdv2tYXc+4V8fw7l3OxnvC9lhagA2AJ2t/DiURmUxmJeH7j7KJDwx4ZMQQNCQLzzUahUWT0qlwcgBZARYYBEjQvlMnw8QkZBwsIFtJoaxo540FoHYTInoiB8upJyIA3RLJ8xRZE6H6GzLoDpPkEFwojkKMy+ViwJ1LiB4iBsgqmnIYmkM8aFZFSyJjPiVE4dNVVOixgXE1lxi8ZEYRYep/NbaKZiiW2WbLu5kmZrU9a0WY3XOGhqjzQuHSsxgXGMzX73fyYIiXjc3L7KTVRZNaj5pZRun6ns1NNdBNy6XTO83dCtadG6JfTQWZJhg1sgAAAAAAACdI8LGxIy+UB7DYwMsKAYTAGq3QAoBACPgbqWBjBA3QseAxoGgoLQMRCkDIBPDXESPgiAYGNAEBgsIgZqBwGSkeBgAuIF0yC10EQHC+5Chc8AKCAxEFsgWABdMxLiwsW4ihACRNBQxEgHAMg45JkPBmYjSQQNigUBzSgbE6UzorYsIG1FZqT5AC4s+alkiZBiZICOSVi2MylOnDc8mXjpDxW4zYuRNZuVCcSIESxeYjY9mbK0HvdRPmCy0RckybMicK602LxeJkc1RMmpdOoKZR1NJazpw4eUiVyCE2Xx1k+5Fzc4VyGFQ0WTLlZM6TpcICMyRVBRSLqCmMTtbpOupzJTbMtq25sibGhPuZqTMV0TBnTTmegj5dLyZgfUfNUTiaSSkmMWUtGgkr6EBQrkgtiFA1iAEIACAdOk4c4mAUQT46UGEoYeAI+AagWlJ3DnoIIhdBKDMwGKSh00L6zp1EhOauUCUSMh62KqhkO51ZmymVopJOtBNSCJmmcn3Lq1FiGu6A8ZubpnlukR3dZiy1nR6I91evX1boKdmoKul/ddTuv19JSuvr2SUeSRmiOq1+1X/r/6T0EE9Bn/r/smdRUlSSSRRupWv28AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHV4XPhz8AAu0PufDsYABd3iU2B+Xty3JC55D8PbvMFOspPx/lMIoNYJSChGSCtI2CeFiTpdS3pdUOa091XsBegSRWtDyCR1CgRcUHFQCslqSqFQdyzLyyTiS6ZgHfNPsxt/GPt3+WzNa1d+ZZ32trHfKHLjVf1rPVncxnrmOrnLnLVyr8nkVmV3MprK3+Ou6ppdlbmrlqtrK1DUHTvJm7+tXLVNWxyudtyq9Vl9Bf/LXec/HeVuY/CtnV+9j38b1rePblNf1vHeX8zlu8MrPKu99xpedx13uGVW7ld7hYlWeU9h3X633eeWtXv/fLGe+//83j3XMu6+vvLHf/+X/rLXP/76VZwfwpVpX1gV91jLXSeLNF0SyKgJsGtVCJWtxlwmBpqCAymAL6Oke1G1hjAUsGiCERZKYLWrCrFlsSfqW0uD1ml6muOU7My2llL5SSIJSNtIpqtf3MRJByF428s/q5chnLuV/LLOCrGXbWNDGbNq/T2ca9zcHUu+fvlzPlFqhvf/fs442V8tKnrVLcpcbO8eZ3aXCn+WT2tZ1LO9/l3V/8p/uOffyqTfd/av5Vst8zu5442aKmtYZ5Zyiky3hhqtnvHXP/e8eY57ztbpr+dbv4Zbx3jhYl+FrX7sfz+3O/rtvLu6v42b3NbkwYGcdk7HOJ/RbCoDqA+qZdnQPEfJok5CQuwkNBCezdkkxb5mSYzJ0VUswump9BK2Zc7iy6Z5lFGm8aNmR68tX4cl30j7g5IqkJZqMP7nKJHZ5KmQP5PbpbPWdGXsEuiY3lyxtk08e/0mq/ivaHrBV0qy6vjdpq4h3lYIqdLqyN8W8BrbEbuylf7tvG1ZHtdrTzFdTG7AvHr8Ztve97iOOJ7w3MvtoWbe9q/L9ungxtVliR9YgqJxi1vv3pj1h21LHxCy1vGFSqtkVzk+m19Qa5vHlrSb4ZNY3DiX+qSva58XOfi73drUbY1aVpf7rSeeXw55apbICAAAABnVH4ugsT0dZCC8l8MddHWeM1D0PQNLFVgzSwzrNzIgpLlnWhsReR/6DKilOEHTuUyF3uBT16SPaxq0zO3icBt5fTynmFn3DTrlWNre2Ny3299beK14+9R4WMxaQWXdIKjSsPZfo29439fcHbZn3jxrfPRIblW+afUDfpLvwIzCy0iR66r8/Gc5zSlWTOfh5H3LH1v6+tw6Roc/i6Y4EbavYFukCNBrrW8az//jFMvr/N8XZ6Wz653r1i3tBziTe/TWcfMX1rreNRrY9N4lxbG6Xvi72Zj8eRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACFmLzKMbe3LOsNnQIw9uYq4vMAfrDcseQqdQPD27IAAAAH6uwa7gqRXzT3ogljrrqedqINZl7xtfTSMOPA5Cl7evQlsnKcKALObu70ak2cv3C48r+1IgQojQI5mVKQAzySiHo6EFBAJMJBQSrFX5fl1DACmojApbc/MAyWV5c91RiG3bi7Fwj1vAjwpVHtuZEQ+V5wK8o4UkGn/7wtW8c8edXs0bD9qgLoQ9TMasjw6Qswn0sto9Ie1Cpodd73S+qZ3TcJcxswTz1VyZI3+q/EGLFkcEdpjP9y04Vg0jnGXluex2VwZoEOBtvgTyNl6rhSuciKOQsCtvK9i0p3csS/znLDMuE4rqXkxu7HGxVjpiDGe/y5zAzA910qqwXFazLDt3G0KSNSf5/qY4lCYIqpFLN3umw6xlnVNIb7utYA4GP52MML9ivQU0/gmWGfR9hytW+Xd3YQhYwt5HOG5PLrMx2Pp5pg2p3GmGGLm4i8+tOGPc23kPdqS6TmNQlw72hMMjVLNc1N39ftWRKe+vl81TlVCgUc1RbVZXHD8/97pWZzlhzVzuJm2Pv5ctYlYH119TW/z/nP+b17xYruzuSdv0+thv1TOcf51/SbO4bLWy7R2rX387+M+mseBjeK1+/vOM6942t5pvGdU+751m+/qBXV4Y2H3PFo9gtRKgzsiEsQt7IqXZvOFjK5Uh1G1SwsMMugqDxCgP0meNm8Thi9fmJW6uKzmlgUGdUss545mYh5in22ZCMOMjAEJC4YeB0bvV6eIplLGAyF+ZDjahqm332zwjKJzMn1Xao9m+6r9iN+xVba7NVS9+CxLsrrXscr+UxA3FKI/D7sye5cq1d2x5dPH2tOTlcjGONupBOOeff+BJNlele9d+phhdxrudEHkd6tnGothU/f6w3huUQbDC7JbYuRuYtXs82GxuzS7ry+gm7ExOUON/mF3CkntZPw98zCN0Fz6T+U9ahpccb+VJVlUzefSUU2fd6ywxxp8sO0Uo3j+WMei89zKrUz1KZ3dzL8rFJLJmalVvTDIAAAA1gNDcHVVGM9fj+4bu09NlBDjrXj0q1vLlPQ1K8n2OjSBh2zd7lhdxzHhqoOesLFq0F0kzJF+R0aVF8+4XU+r6C0T+PXXoXGNjUXOZHu4UX0or9F/36zWv84tVT6y/nxr2xBTrjtjbnHM+vBnZI1GSWrWxRa2pnPpv79q4v3s0s+7/1+f9/Osv8W3D3XvGtihXrjF/8Y1nP1j21aHDtdlremfn2+873S73OZLQNav8fOc4zrX95M63643n1r8Y3GjHRYCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACJSLzAH7e3K08Sn0Be1uYLIzMgTnDcNJxOcQHD25+pVAfx9sChKogoCcxl4L0yOjnecBgBxA4GANp0GPl+TARkyYZVa1frqx7J4Y/hBsgSMMkNBYSd+LRWwmSuGNSiDQETEIIUBihTTqtuii5f8vjfDh6RR6nUri5Mb5SlosMSvWFpOsYM9kivZqIfFV6GKUkm6tgQbKDcos1pne6MZ9OBYzRqXRVatKzpJTCuMCdY4lJ5oCsj5iqCJelGFX0gucaPPq97xb4ewHF421exYld6pWu7v21zen9guDKdUVvVTJeG21gVfsra9zJCq4Lda+aJFY0Kg0XaKd2iLVW1iVrLRhhsN5YDdt8qj5gxm59CgfwK6gVY46fzqBV/OrWZ/fszbZUqR5Ej3pAfrnU1p/MXqTAYABkRkESGJFAD7+VwMyTLIyMxuBlOouaw/AgzVpYBlRl4zy0mM4axbA1rE4c5pttQ7NyDM1PDP3Ui4RdNB7JLEMpNFk0XUX0lMYHSxZRLqDJpUZgelynN0mWmTljBTxOSN0aBgRSROpEsnTlE0Oo2vtrmrLMy46Buhv+t61qM0jBF2UsyU6nZk0rNsuuykzcwHCaW3ZJJaqk0kW61OmiitlLegtS1si6CC2f9qanXMETzKXipRdwP2CbZIqhVYl0P00eBnx4Du5AS/18MgJUwntkLpxaTzecehmrStcAmAKteB7pXVvzuPPlI1olsPIAwaKQLesM/TwmY4wyM37k9csXqOq41F3W+bkDDL+OXKmPMIGsUNt55TO4MR3nlR63RZPjXtwxE70ap9bm5V1QwoI6t6N1vymIhdxx5hj+dLUhjO/lnjhrHHD86SgajYltW12DL2pR3ms8stTD8wq9SXpTSu3D1+9G5TPZv/nzDvb1Xt6cmYfs5by+rTUkNX4hOUNqioKazDc/ZqyuR5XN3rPYpGM8KfP8d2d5YZ8uTuFNrmuWKTLO7as5Y1OTuP93utl2UWe/hb5iAQAAEMhtDCQigEWd/m0nGXxyXY8p36H8NRj12aqam8534dvk5707Xs8l1qk3BiE0qAa6mHUzj2Ctj+0kbTT1nE64u22uBAl1i+4UEXN19Vyut7We0bVeWe0C+7uf/cd3oq6TZfX1WFI2nu4NT2HCrqqp/b4uNw40j545YxbdcfeMWpHgRb6iQt4j03//nMLPy91OyOVbUT1dMlfvXz711XdfVrr5GR9Dakq6+a+8TOt2rnUdmzrNbYpXM/+/feomdW8eDqfOre9vu2a7/zS1tQ1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdaik0hOXty7dE5pCMPbl4WKzKDae3LLUMnUCw9uwQAAAB7vTTVLswEqt3cxEsZYAZFaIvNxqo67unOXjcjH1M6lK9swzEyXBYJ4K167hJZ3vLY9GuYoJnIfl09EHHhNJebaRWJZCw3LiNUDO8vjUCtCli41mdvgx9WVTHeKhVlmFI2z5vPWC+q9zhDIXpRuY1dEnV7fitWxSxGBwrV5VyjNj+NGm+q5tfUB5FhM7lWsRzcZmyu8Xt86vRSOlFpj2h0albWt9xMxIc+mN7iSurRN0Y37m4REqxoBSKi248bwpXKS9defxN5vrfzuDrN7S3xHlV7U+vj5ib148HG4l4sTUN9JEviPVGAAIIAH4+7pzTAhpZuSSTGWhBiesamIRADUwog7mXPlJau+RGIyeoqmfxoqQqTxbWEagWf3BRf1P2CRGRVsTqNwB2YrUgcGBos5dXe/tjDwt01Ah0uU0X3pFpCZGaZOUo2H/HJlWXcCmoXpEeH9LhITUpvNhpJGSK8a58YMqdvc9dTrah+2+JqfGI0f7vDU88JlbL0vquYLnq+9b28nqWxZOrFFAsSv7zTNjnaZsiT7vPLS1MWeQ3uJWHSHxVZEcmS8K8eamH8ByhwMtargTtt+3WkiV1JLu2bQfan3m1tYzreaYiPK7+M5Y4WQUqMBAAAADfYnQLQaidd/qT8pxDDWAnqrOaajJBxllE/R2JNlhI5hvY8pWHQYYoX1rX8pU9lyrBJhAjRSI6hygbOIp+UN2xKl6z1294DeqZIYTD+r6BvosxsW3rpz73K2KrLgqXquYodXWInjYSlGVXsrE9f6gvFbUQ+iUXFmqusF8b6RGNXRsNVkwwsEX4mnpiBB1boVZ071ArE9NX3958NIMOsvYOlOprPHVazsJoy0SJ/RsUtHuzzVzdxliOcjY6YpXTzG8OsSODze8x3vUkuI2K3+ZGaSZhgai2hXYNv8UniUzvLBiWeV9vcdyzVzi+AwEQAAAMjMOkMh3/0/9C1Ws/nK9wWXuPhL3bGP8ppLlwRndy/TSq1369F9inGhLbp1b4Ips2LxWjlcApnW+Z5rFzTSFRvjxO8O+9/X4jvcZf/WTSjN8P0i7i/yJXS7lsxTW1bOdg631ZMSwo1odt3kzmJE25Wg2176+JoWLxnP5d2xi1t31/r6upJe/ni6xFxmG+Zo7+DXL+BGpf39/rWLbw45YUPWpa4tuStt/4xSWm8RbR9alr6X9KRvJulM7x6fVL6y88G9pv6LOgYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI0oxMAZrDcKvwueQN6G5iUis0h+nt2sM+J9A3rbmbUskWIQkGPC+qUtmDd2sNQKos2qhIOUwPBDF30L3nWeplOS/7tuPTvlVf1yxA1QGt5ajFTWbdXtij02AxiVSaZooCfJ3wqHRZpamFMx+XRjkosz1BSwhKqGMp+relMqaxyfpIxq/Zld6zNRumi1e6z21TUEblshldSkks0yCJSuC4O79FLr4yENM88elVytddOCsr/a2845cuShtKuFi9Z/Hn/jfvR2xUf752nls06mWWG/xuzcMvG28sa9PTMqlucscq+8Dev031JFZVI5JLcNxymk9DPztvtezL4XGb0/IrNLnuajk1UrYX7WVShtWKSlx5n9Td6rcvTFzLO/lq/nvGcorvez/K1mQT8zGbuGFLO9p8LGdmiv6tqjIAF2FQtELff+tQR+N9MvoLaSgWNwbP5aQl6rWJfEkCH8emqduCPsw8B/6kHYoYWIOjjzrwP4ckCVPZ1nmAvNj5ZrGKbbh0Ix4PnQgiC28E1ILxVixYf7QHAaNG0L9yEY6+aLBuOWWFVqG3uuFhxVp5OgQzh13/V9DjxyI9uyqfD1LHRFa+82vL1nECNydMTvMTay7nkX2ytjbvqNNO5WY7n62/iBlaUL4yogAAAC7xVqxLLG1fBaStG8FpDaUaSJfpDEVSlGSOSmNNOkyiIgFjb5QqQoSWpOYxKZiz8oCzNgmPvRIHTuSJdTOaRh7mPADh46Hbglm7j2tRgeQxqLwl2HShuBVVMrWZSosFigj9RV3yQQ5RLuZPK1wUZ0yIpSnLZufFdAGA+YELen8dsR8wHlFLm1pyGw7cMTJwXUflELiTR4qdWbOEKsJ6/iu3BTsquTrXJHZYT2l7wXBoYW7cFtVV73tjX+oCTWT8UjJbMRU2y55ZXji56iqh8+ndQemnKFAzB8WSLuketVLSu41qLiaHRlmpEteNGUtNavvtUFlxPBvlX5jY/h21G3Wz6aI+kQ7WPitc5zBwoH5poEACmaQghV+BYPEfSsA8Yus2qwjuBYMMSJDgR4q667ImLNEte0eBJB3KMIzzaN1LHIuc6iXhHRG1KvVPOtHaq1KJfY6bz/RTPB0/nmqwccUcnlp1l0CyzA4mbqWgwPwOzQ1LjyZg43egyYqWmL27ObZ/+yHzu5c1pyWzdVuc65ZSRsf1bOnIa9U2+b9txH3smU2IQnVT+2J3O2063u+WR06IZfKAXG3V233ptxQBeuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACHqKzAE6w3LH7+nEDw9uX/YVNgTl7ct1RGcQHDG5tZqZCuGWgHExKRGgCoHKZsxUwMEMaqdQuB4k01/QsQNEgUtgyHc5VG31hqUBhVl7UGI0knqzPakSrxmSlwCqbV8IANGVQLWYOh6NT78pJ0lbmEe92dcFCU2FuYp7OThy692pG47S03L8is1r0JnWn34Anr0swmbNaE4rEpIy3Wnldm/g971EWX9nKKDpPhzPPDfJu1Vm4rdkV29VzjHe7v4Zat0kNynPOlqX+yuXfdw/8qbKfyduQX6d1uU8E0nZXGoThlGak3G2o46bHvO5rnLkaq4QxlUdhvpNvHvbmpbnfxyuYP7Rdm32v/d/+V7Hd3e/nNbpLlN3Us1jVtfapW9+klstx1e7qtKr+faR4kkkIAAdIEhUBISpfMdVnia5es00XjMSRuLo3Yja/mdqST6M7i8md97nhW7v6QSiqimqotirdP40/JqVujjruK6U+K6nr8z1lRW95a7N1r2vhzfUZXFdQ5MRtVz9Zqebeys0J1W801gayshxoMsHEJfrm82tZS3es+fM/m+L+sOurU8Kbe55I+9/VfT/wr5rB3REPt2Ou3a7Xq/x8wd3pr57b5WR/JDPCnp/vG8/Fa3Zs+sT53n3jf4p86g/Ty1cwF+7/nfMoWSr+FPhIdaXux4UrBeWQuWmMrDdWe7UZX6m4fSnJKE1L8VlEbghsoOeoKR79XaevDjuSF2Kd3GAjA6WTXH1Yk7T6yqlwh5wHEhiKKxQKg/NK8kbaxn5RgW0IEkXlKdjWXBnLAea0hJ7Iw5IqIP1CToVacII4qSIXxvb5kG4KRKtTIwR4zmvI1qXa+2VppsYKYiXYIrgwRDQRjyKh7m56j1jKxWO460z/E1aOppoDxWPHjBuAypZRVVmY7H595i1gPYkXanQ2DuJPWBu0dgeQH6rkORXqSQ/JXG+4d4dH0lYzufGatskG9tX1Ampm2vdsdU1R/vFKea0+ZIFIZ/RsAQSpbAIAABIhIwkdM2eHcky4clt/c5ckSegHdKKKe/PKlmJtkE5nGrHN1buG6l2sPXVncji22a0+cnqzUfheFuz7EJw3CJi9ktE1MUy8JUK03UlYkvFVtPCTGxDKw+hOSCvgcFlGUxMLsNCLlDUnKMXYuC06j4HBJaaOS1Vo5tRIPhaeYPXHBIxetemDqrI7uP/LTBxAfPL473mlKvtvLTe6ZJFqGw40V8rqxDq/tJlY/DJ2su01SFcoWOqnJ/Wq26KWZ5G63Tm6U+l8t3/V6r0zWZ+7GTv7fo9tvzsxzVCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAc7iU8hOGN23/E5xA8vbl9aKzIE6e3Lk8Sm0Dw9uQQAAAB6RnEbGsJrRNDQ+NT9NgW2tVKGJPDEqi+Qw8unsMLOFHSLxWdOw9Jqacd+s/FunjVPHGP4JdrbZU/b8ReTSKdkUtlsustL0I7QjhZVUUys+VC2PZojdJ1Dq6YSCeaIxxSJCc1DU9cqYn56fHy1xxWSnjJCW1PcF/a02SXhJsJPnrxJdeOT4xVHrT1G0yUrMkqFCQi+oQ2L4Vny78Os1mtqJUImk6FIY5T6tMkhb/W3WVrrS2HUrDdGcZ1lzsOT3NbmzjWzePqX2s1yHv9j+xutJ+Zei/N2vPfvz9l8TvX6Z6WN7iwAiAAN9iQwdYKs7+rCpIepcdxuzMiMQDmMlpLtevrKowNft+Pzdik1jU7Uq9lJeBDjA8rf2M2K3bkrlbXrNzclHF/AqXeBiNmf7YaN2n0O2F6C1RI7psZGIjrTwcUiwXiixKXpxay5Uspm+HMrQ8TIpkw8kmq9WtQ3FCdREShMdgest9xolnBymld1hOO75PvUzNrb2sX1nxl7mZ+hkaFRextRwGCsWDNDlfQJawIPpHeT+PXx3P4tHn+mfFsQawYevv53ulNP90vPTOf6qSf0h5tb/518RPiBr13jyQcivOOjZG4iWQqNs0Q7pk3g6JEZjDOmoX3LUHVCNVl9DTUlSZYQOjJHB1V0sH2tTMagLd+W3W8fREtab0ztPLuTczKRoHSTmW7RWyMbBGnsNdQ5suDr22wxGue5gKJhilktrL8SfENWPtRmdliNURmRqjQxy3GhN7azhvZVzuDK4tznXXlTXrGf1fNmo0+K6zrNr7isJzQ4NPV4hu86vXHpXmEj5k4j6ODVFfN5rPV1BSMOOf7RGizwGXcCMwJydrjp6aSFGcViR88eOTC8sqqqx9JBy6opFzH9cWph3bUWSAqD901RH2cZky/eQ1Oyrc9mpyzjOIS4cosmoosEFkAAcuoZiYqea81AbIcMKnzEddRSs9NcCU5XanbF1RicnqsIz52tXpZffzgpCana9yIEUkVqlvVOXY7O2eZalnUqccI9Fm18ypuaDa21zMpjDevZk9DhpAXyinYNbzfGbXJyzQlbEyhN2FjTBKZU+s07M+w1LVHBSONIVrxExPB1eLqBBmhte7sZ5Qct7dluNxzzquoceN8axpkYYWX+tPC4zV3qzZNbwIMCLC1nMK0zYxOVnTc5N0TN761PPXMrDmFengsc2rVrd/ql6xbQ1FZOMk9b73971TE239vmFFx2x9NKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHEojOIThLcuNxKbQPL25hchU4h+HtyxO/Z5A3sblgAAAAeK85dhcnAABiKSCfdxso5ELMP0cVbuusLoD2NcQSLosYQw7CRigtqknZnmpZXpKHGUWNzjwK7Y9IZfrsrl9yMJWRiTVydQcUihC5wSBBcnnAapAgY7SMVkUEUUACMgaBCK66goXBM2QDbRKjNg8BAoXBAhi4UDhKWgZTeFGNUl5MJShBjOxYrRWjlWQOrwzdiTj5rLufglKR4KDhpZJXGLOLIiUNB40qpJRmmKrsS26s7qk1yAjITBGREys5TSxnZwVUdBTz2FtLXXjLPppaoVk204L+1sVlfv1armom6gQAABxEeREAxcz/08K/5/ucrobkvFCw96G3bprFunh9Zb818Zmm7+GHzEut8zEhl5qBKSleo/hhY+bdeRVqSBBgyKfn3BVbAwazCSb+/kmkuiIjxQLmZcHAcRg63LR5NDV8ZRznde66Ojd8ayfwTbVGX46uanTN1OumF7DYGa6kTrDqPGxErWmaPo8PWPEjR29lWcbrrda63l/JvMd4619yKtHNFWdscndHm8U1XOL6xu9oFoS5Uj5ZhX1v0hQb6gSRY2LQsyxXsN5jz6lvJGnetWLwJc2zneviTOv8y/VWGa8zIAIAAxKyoVqIbpwlxXRIy0Hmzla37ioCFMWxMLmFpJdstSeDHG4KQzvomscmWFVyEjpLmkcelPJO4LeyHkudaGZQ96qS8XpjdiVTbuwEzp6/i7SXlbjqYWGKhpyE6Wy+nTIrqpk5nPTfERa4jQ29CVEozmRy7QTs0YBpJklqwN5NwBxbOkmSFN5yl5euDm2JTDCuUaytSiuoWFmizrpvY0o5Mi5cYlTdL4azRFUWn67cGaNeimhMCkaZ6vqRsXy3Rk0oWmJmzNbTO/i9MN1pJ5m1RatWNPOy19XkXK/mNizjndpYskKE7g6ewm7O70cbT++tRtZpN9R+5xvBtCzEzqBuPqLKyQ8Ph7R11kAAADDOMbSAWGHECDrGeq6S1Xtuho/A6jhVyipXtyNWc+0HwMXzCv4TeHYpQRZg03EjQG3GUq1TxjH7WfXBTEXkHDmlCxayrddS0suS0aPrryk8humTzJywTljxLUtJ1rJ4sWQrh2lxViE2xyHLblqIj89XqMn7x9Lkcnj70/XrzZ6NmsFbTPWrXWnbLIWXa3bjWIe3WXpW9cn70na539sO8ht0vOZOM1yy6ddxrb47bG6z9Z37rOpl/cD01akvwhDE4yQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB9SLTIH5e3LaUTmkDyxu30IzMANh7cMoxKbQHDG5+FMdRznwgjpSLFMzLSlJrQygEuNtDUDWpqBWuMiJQQjplbWI/Jq11KQuTcgtq/c5BNZ3Lkx3dSA1lCKRPJ4Xv/8JmK4xxOqarU0F4sMmsuNp417qWp2OWLfLZnvo0I6HcMkaFE9ivHN/Bz60VTa3sLgzNeHzx9Oexe4y8u3VW1uzhhYo/hZbHm7QnUlY+rxH28XhakUMFEnFhcGms3b3ea2+m8gzKoy5yOcNK1sk25kVjk5sGYMLNdXj0gt7YzQGH6U+FtyJ4X+OqXeYl6ZxBdOp8w0+4NcpLlmVvhVxLTXoxUVrzOK0hxbXx5/NPHZ1ar59fGNzPLWvEbIAAAAGtNRmIBjmQFLMqWxPVaKVU0M0z+KpBoM5B83h9mXrPnbfdQVE6XHGxMa5uSKBrLIh5BIMqn2s85947Ofv1NR9WlwOnLxd+wEelt2Cj1Xari88jF/mcab10X9V9XazzsEFmkzWVHXGR8JzsC9iwBB+cHAeisqTpU5+UF8B69Obs4t1w0vAYLnB7EJ5xZ+Z/cX6UcjqhHTCw0VrarpvSKNi1U8eV3PbtWNpLE4vEWUOZn8osRy87nrlGpx4jnIrVR7+ys8+5isbC+uz09Lz8tTBBvQZ+sWOV98DBQxMxYKcUnqrrgGjrH6XKf5B8Rm4MEnv5RRCVWsCBjJn4oYYrtEgaj5GttElndWh5AXRSMzdeQ6nc7VeVJ4SzKfw/V7aaDWeqXcKyTbiyU3vGG3xpWA323YWujsSKPua2sUzAVFGRmVh3uW6TwGHZOmRmXK+rXsSI+njKBmtaRrXbe6mpr6hyd/WtGtlPxYrRDDq05smo+L1vqKgUL5+KV7CgNjE3NdFceaxHRDa8L8j1frMryd4+co8OC3J9Sqy6SPJ9erDllZ2Cy+2ub5ifxXUKeaDAbZ5tx2OeJL40ZWRfJSNaBqP3DdFa5K1SO9fH1Hnf7e58mkSAgABZjHsMR15XTnt53rtWNyikkhFOLzmq+vhiRUsf7uC7WeefI9OfhdV0spZ7cornz+Y6kixK+8NXEJ5uIk0vOQ1wm7NP16ztmTmYCWMbEk95u9e9mrWvQMIep0eoTpKFkaVopQWfYsmKZlHUc2VtUq1QW1zz2bNGrfpNyktvF0ejv71mfv82ct5xZpDP21xYyin2Vxo0uozmXp+720aq7CvTxHT/5abZT2Mx1nfrE5Ndtzcz/S9bHH5tjXdPUv+5n/es/bom5P0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdIhU0B+GNy4HFJlA8MbmBqGzAH4e3K/cQnEDetufSmCcJlXKkg6hWhHzyZI8ph4fExRk7EJTClSPHHHnHmtIdGDJDI7Cx4pIWtMlrSmH4ldhqs9UJvzsPjQl9MUlzzTlWSVa1msmvR5bYhWIY3weGH4mvYudqC2TATKmNExQbCqFWSB/PAF3ytfs6vWV1BQnDhcc9SBZUW42nmmvUbs/iJbZwulw8ghYpDHEviu9e0wR8vOv5Ue4tais5daZjkLiCXLL8PTmqQyWHRo9dx9ur0bDMyZtLX2l6F7K9aZDG3X1beOm7R21WnML9znWdqxmwRbsN26N7dZmm/s9HSljr4WpGfvORxZAAAAGtFgYoA0ZAivNPii9D16rasVM4ioIKAp5H2/ybZtAVWUUViHKPG7l8SiusuhhUEC30p5NR91R2fj6CWUXcDkRzWIlMDfHssg0WD1C0ou5CiSpEM+Xlcjj/g5TekzT74a6pgYFDZIt0FikRWVtg6vzOcfhqV/OT9DcEZMuMT6zjmUga1Y5i4ruobiA2OaEva7bsdf4XWG1sMCExYtuvnJtDdkqvyqnKsQqnWq+3d69bkmR8jz8pUrZNXonKQ2R2fWXtGh/iKrNI+/mm17DN1EXTWvdPrK1c5PrcLcE05kXZKCuQ5Vql6LsUzO6YYsSRnEvUMzBTjQ87bY3BIVpmyqQxOvegNJKgdl3nfgNnlrHLleA4Tu5BItRJRtIk29BhYu2b0EKyXs7NmZTGGbdDKTU0m6+6kV14E813tm5DUBcurQhkQ8HFjhbzGzdsR1mhPv2tJRrWixTuK2KpYMasZIx472DBbYjiwMNYaw50pfG3sPO2+2VRNCbVyrVZAmwra6rruzwMlQmcTTozeG5TulwaaUUKVTkylL/a/XnBJxI7NaE/SGXF4ws6WPyAqmpRuS5Zu2ok0515UMkRkuwHWstMK08qsdXbKtl4TtLP91jMMHN6QM26emRKubZ/nDCI4VQgAAAI+DDhhIojlVuqlMm83vvDUyMArGSO8pHX4i63ErvG75+1+l9tibEWjnw01t9ZxUY1aeC2CstYJW7+6gl1SfvWqSGc4drSg4Y6Klbo2vtdLc9athouM3sJyEolD5UXfPFmiJNBAQXXJtHXIQg7c49sNUTqr2pTxW4+65PK4/nECzXIUcn3F7YTdDGLPOzcs2PWaN540J5LPfUa0J29V02naK7V05ZB21jrSa9raPm7UV2tvvZbbiav1ckJWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHgItNANh7csUxOcQF7G5fGicyAeHty0ZFJxAYPbnreAowSUDwHE485OIzeZzo9dhqQN1WBH7r2uZc07lNMRmYY/2I3Pwve+Mh31R9cq0lOK8S7nrO72XKW56+s/N9mgkb3juXxt9r732zHogmfB3Ku1m62KagRcdscKsz2IuIWsWgXYDniysVs5hZiZgyw9xWxxURKC6NNbxYUBWwI2o1HjfFs2vX6rUKtj/fx8UhNrGp0JvHVuEPU2n71lXKqkq8TqmtKqrHI4ObOwRpl5TbLpdTH4dKcxthkZFbSBBcCXxbqe7V08eC0z2zXLYxxWRu3mC2qOPFY2/bnPaFIzsTLAfqibMbWtWrK15nqtqVBAAAWYGUUQhF9rFpiTelcwnI8wEU4Zc07a4r08WPlltrG8Qa+5pmgRqZDlXmnnzRTCst8IdEMlu8BJj6wflJmctLPsL1EVTpKo1FO9953v+Yncg235WqU0/6NzAtgsw8wYGrhLPGyQPDXwn0LbV6vZ9tzaWxOY5NevPZeadS+wrFh4Tyy8PVsmqK1F1IHqUiexY+xtcZeOUY7sf+11qa3gOHjgrbBJwc+sg6WOOlr5i1RtLRvZgpW07Lm3ytu57ncttX4GsBjmMC1H3Vag6hdVF+9ZRWmpC/ghQ/sonu1IXSySAX1jkxHt173NvDX7JUIi9TD2Ou/A9WU55/Mx1qd/tuaVJkmnjl4VelPXMfmbu1fLH7wt0ZDFDSKn9nvEi777f1eXMWMnHrre79WRhRPFaxS6vtgtLVsW2Z5KdxkKOm5HGuNxp2Wl8OTYrJ+xp6dgaNP38WSl5XyEDGUancYrAvObfGUUREqs/0IrI5tV1xRDk63KHG94TkJviHqT5iUKuin4yPXaka2heJzFmb6wEohqpRaqYUzKxYhIlhVcTb3bcklXltZmtlV8jt/3ja2PVWtX1nXgOEeCD0tYhKgAAwoyhzGLrMSIMip1JqJsaoDeS5fZc2NzhWpSLaSdbmg6yoINFcQGwYJJzy0Excbsfxk773uMmPq8XdMvMTb1i145YfltcOq7Qqe29b/pE7fnMa1KV1ZOkMgRK0lmvHezR30GWrLAJwX1WsEF3SDasF9PjO2yB5XNTQmPcb5+Yld4tTHfbszPFBB0wNUDsmayzxGCkbMCDhs1nOIT9uVLNDZtSxY0lojnmA+zJNA1fTnqZupB1eNe1vd7BvNWFWJPrMX3t8004/11m2o73TIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAAB8qKzKB5e3LPsHnEBe9uX6YpMIHh7cuHxOaQHD25IBQAAFbolWaqf/WJUZVlLsr0/BXV4SsftVoh/dx9KO1BlJdXDE5vLDPWEcv3WZQOnAvF7F2T0osYVsasw7GdJndTn9bcUjThre81qUGs/W5oTryKNXQDQUSuWGWt42PjErTteVCjWZabh7inynnzEumize/e0jva708SZRFuXeWXvXsVgYYsJxxVelyxqxXYViplbaao73dtYZnBmWnjPCV6cVz9GIJBNz3dnFEqFNp5udWh0eqVd2fNhyK6Rkel4O98xRH8GfVKpw/U9HcmC6ljPYzbAiN8CA/xhtYHa6iP4VqtsGOz0lgxmBZQhKq5Cp9/G84iw8QV7RZQABJCmIoRn+wRr5zvKvsox8AaVoWdyxnm560lYc318LtngKmIQ8qkqO6l6+/zg9qsd8ZSsW1RIMe+7fv96xT5XZ1arq1GSFZ7Brm28Y/i5eP6sMNy1mWKkDp1iV3K1TV8sbq9lgzHG4LlVwrODu08kKVzi21H1nVJV566eb+K6+/95ruajGlo0PatVD+NFxFgy7Zqa9ptQcY09TL1fT6qRzHXUPGqx7Yy1MMFq25M8FhveWG1WncporNBixX9Xs274i53TcO9o29mO2Dl9gAggACryI3hGeOi2wdqX50lS3yiuQQI7kD1Y6WvgyqpZbJZgxpLsSitjhjeY1LV5t7ElT22zInSCzcwsfel7k3575Dpi1b8Ebe4taDayFrP1TC6cIkVeU2FtsZ4hOt7pT3/zvKuMZyUdN9hg6UB4QFw9iyOOdQ4uULYYyfnTqSHO0Zf5kUmrQ42cbl3WHRdLlWErNKPlgtjetwzqyc647eVCErlPo1XrsvSlZDVtRkTL1gccskFlitWoELEimOJHJEzUUkEmzb0wuLAzuk7lDm5P0aYy2o0Y5Wc8rpeev47+SOeqbfx4L9jc1THkVMRcs8CIhtGTGs6rN7RglWFtoAAFmM2nf7ZVXz1+GUHSuXkICOjHK05ck2q8ro/sSaJfnv85S58AcpWIMycx+4Fyy+9q7aUxzmMYZvurQ7BfuH39/Dy+Gyu4zy+HsTTHp+8Q7e5tXv6Uv2Nlo/gZ8DNVcFv8031rEJ5CjpGNKuSxOR2DFcsrm07XbUB7rXnc3+9vlDXCjdY38fPzB1SaDDQ9HRn8KdPKhigMUrG5uM6YZb03WWFFhJ9lj/agLYsyXT3piz6PPFXTphXKuert/qXvYczVuWFI8ansjmhEOHpsgZxe8bclL3YLb3NTGYkDIwSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACG+LS6B6e3C5j/neBetuX4orMIHh7csDQKd4F725SKJAACBEdiQnDFZQSTo1EitycltiVQt3GehQCRy3mh/TWEkaWROFejya7qyubba1vb/v4jjAtVFZW9oCQsG1YJl1fdNK5dY5owL0P9yoXG8TEOLVgKu+deVR0fny2qVjsYKGKojNFbqXH+nt4affJ4hO4D2e6jUhNTcgysb2u3zm8YYsBjYoJQhIjqb3Jmy7g0YGazZqsBlzIc6EwSMHUss81nDVJJI91CqTDOssLo66zRllkqhiqek3IKeqOZVwpFS4Zy9N9eeuDe8hObCFcrmaNFY3qlYnuEPMpCnCdHx0IOpaFfgSXfP3jdBu5xGvKweytUWGBeSy6iUeu2eK1Hy0Rleoa/ctntYD+bcwrOqwoAAAAABQzZNCMBksHi4/dNZjR7ocCtrTfc6Wg+mMS5hf+KtNlYh34PpF7x5r4i0F8xvaGhc1NmEF+N9MQ4fG3YVOeq1pUef/t91bzKkC2ZU8xKRqTRhBK+aOEw2spM7GwfjE3IJeGv+d9W80dDTqpPH4qrhlc1y64VUVMTa7hGR3tOGKjHTbFuzm2oeaeSFw4mbr7uFTZe1Tp87CBqcTNzqkUyv6zRh8pK4i0zkgVKC7RMk2liSIphkAAEDX2W4OLME0cW7q5LsKtW5KKMLMAEmrUttHTPU7GNUOVLOw5b3d7GV4OXXrIkputZQmP1jLbuGO4xNcs1K+As7kMKPrO9yVNy1f8t0NvjZYLNoi4TWCeO9+1frGrRjuREJVTxvpguki91tDjWzqsVy3HNOzUnUO4+y8yU7/U+n82qK+lVadTcfhyqF+zf31ApbLarFypy4M75C6wXkjlGSZdzniuTCedl9XwFZAjMh04YYjEvJtGw1YdogKGKKDRGQnFZfO2RaWzvP6rAW1eZlY+iUt2pniqdctuTKdWZo1qx3iIj6ZaqpWJUuR1j1uO/8vIsCJmc3SscKxgAAAAATTImccU8ls5/vmBXc5Ex40S7lrMHWI9YUGusdqYou9mlDTSpjZb/S1GpU7+VVPmvscXzvXk3D9v61w2Pc63mKzes/xjfr/XUOs7FAe63J19UV01V3TeG5twuDljQ11h+TOFaka2/9b1vxZom8YivaZ1/95/zv63vwd+PmV+3NmJIzZXGr6pT6rrG4tYm4SkcoUCN/fGKbvuaarq1nOK4OFL3rh/jUBmrM0WwrI8tbfEXlBeKmenMAbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgmisug2Hty0fEptAXvbluuJziMPY3LKcSnEDwxuWWAAAAcQx8N2PWXlCQrkarP5SrLdSK0ckBwjlGlf+UEKqK1F4pfnIE1NRvWUo3NJ5Q1dkgYNosPMOX5aqZVZrskfvKrD2ZF5zpAIHEXKOvua94kP6031hYXDXDJGLofcc133vNu31JHwdNcMM97wXrU1oOdEKamPqHGjostyuY4D5dDTLiypxmxEfeG4Uoo48N4qpUOgtjAroEz77l16TopDUa2uNlewmTBYUNwyjkRxb1McyeepeOehpPFYxNTBNPcvTi2qtEosfwtK4hsbOnpoUNgmOh4hxkV+Y5uuLAzp+PfB+HKyvJpEYjDjcn72CqHLD6XuS6mYncJR2if1eUtuHYPXtnmgABmSFgoCUCnWcXx31F3Cbk0Stw1AL456bpZrxttrlj5s3Fyd7oQ1Jql205hWrN36vvRDJ+2T5gHjNDi78bvP6QLeTNcxssZ5Ld5Lfes43jG/BZtxL/etQ5w85nbdQN7eQPg8rMCJaE4Xl3dii7xNvxs3ea9r2n1SXeqZzLrePitp82jQMRttr5nckf5nODbO5ID74x4DaywZsTPGaAo2WHHk9dyu1Tl+1wY8aze3R6acHkS0B5De/MWGl3sB/M7dwaU183rmuImomq4xWFC5N+mAALtt9IyIBDJxghhS1iGHLil+ch8BRT5+G4vqQ/1Yn04r1SK2Tb4w1nbbSI0pTemZraq7X2R7ZrLpLYs64jZ18xnKsNl2BKwvRkhWWI2ToprnimhNsXc/IKtJApWxQFOa7M9/W9g6eqSpxnbXLtKNTWn89ZP2Zy5OPRaQ/2Bq01yyxdH7uvuUv9X7TkU0t3TnVX1ierMTTbFBraUR1+p3MB/aaUvr2nKdYKR/EVaoVNJaNRNHy1G5z0Na0sTEcTaxv9q+5yyPrU+9q1YayWPQ2SmkMaK5nJz7OWx81IIBCuRowA6I/kHYXnY1vWPKbHexol+tL3u/tXdFXnO67vDvajQL39Yuz+BXQt40262WcQdbOCJ2tIYL3F2qb1g5827MnWP1k++FY9RCP6VZ29NY3ejmEtUfgyBTApd3c+sGPKB+efEaNxHrrcyvOez3Xz3uhq/b27V3Yqbl6TSb9mQwfkca6KFDcXrl+bPo7XtanW+LVx9Q+AITj5aq7ay+tqh/52wgoR6ycLb2WIcDk60lTHa5dCuehetNZ6tpYtnf9b9abbGJ2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHqYnNoThjcs5RSbQh7G5jiiU4lPeACrY96DqOsAFhAAAAXlQWlM9FJNIEGBgQKgiUWvqUE5V1SQE5Dq0zsQ84cHxyUtYhyN00okrl39uwymEcqQ4sLXvO5bjfbsvrSiMzny2MCRV9JUSE5Tbscg3HdYJ0CcQy3biWqBufD4HY7tl8G5OVlISEMR2nRDN165SSxLXyZn6crFQ5OciTtA3VJDsE3jCvlcd3CIcICyFBUOHB4nOnrr4qvqHH1xINTy8d5bvRwzL68J05mft/7GOOOnw64uyheH2Kt17nxMO/AiXsF1YJJYlhJfnT5IyuXEBDxflqH61RXLx0/ZtToPu2Z89tIqQczajDRypPEKDp7f7nx8xxKAAja4cJjza7imNS187zjsO9jZFznhr6xTb7xJov17wtSiPnjq0EnBMcq+BuHNB3AVxqXQuLV6/zgEbfzB7aBDyi++fv1VrCqzdK3DTGLv5zdtyjbzLie/vONgbjbP/M19cNBGxelQYhKtYsLBILqrKUWQmrL/0Z7K+yeMdtPve90lKLJ22fW5/OpB5JVmdO1btsZmbVvbrroEMyUsF9Z9rXX8nXomrsOxLJtZ5c6eqHI6L4pu89RrG0i7XauXoxv3vkCeW1zMXZRyO0gYAAAAxtPJpzSD9Dy8OkabyHiGiRBQy+tz1Ovnxy2G89OQJkmo5iXF1QwBOQsuMqNbi5EuE1N4dRwk7NYnMEnRPT7UxIx1IaaDmfrxJJMySXrhuJ9OhpRH2e7klGs5iFFWahPjrHFGNFEYclCTknzgGcT8sInyHvS8Gkrh9HWQkqiTD5VJ/LonSFqBiLFGTqSVJ7Jc6VYZR2ktLcqSVHOS1YMqGTlWEJSSOTqVN6EjWx68UTO6YlUwxILyFGq4uT9QyS2cm1U4a2FXPopzPYz6m8WZcQ2qeMzVsncwIELMV7JXcHcbNJp4T5liR4cRWuD6O9eM11msHD67I+ZnGupr0tukPcHTPFzAja3WSt5pIfjSWlW5a43a1J1YKsqSCIAAAAAADikS7LRau+HunXfaTCYG1TPULMY6o9aKKywsZZwikuiR++nOTVQc082jycjqOSeOtNJUPVUVJ1x1I+dSzzEtLalaMuclLGF60lxmoYvHcT1i0vYTjp9BdEfUh4BOspafQND0xtc6adpPfbnoqQ3inOfy2L+7p74bn9q0Sdv5+GVu22nMJS84dZH3LKtsSk5rFnuZWuze9twe0KhAUNMbAzCEFVxROAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACUeQUAZSIADL0gpAxqgAJGIrNB2MAAr6PqfTnvADMTUbgBgUawFg5dEGAbE+BqxYGEEAMORcYeIDbGgNGPAwoYNkIYTYgMCpE4BkcnhwkSC+QBsCx0QXFfEMImO8ql4BZAPwaOARAy8WBSwgqcJUlCycC/gbeAcAtgFh4YPDCgYzBt4ZsjkTZEk0hNhAB3EEFwjnDMEsZJDiWkgzzrF0Y0dBAyGj4Gqbk8UUSNI4kjySBi6nK5dHJGcIOQ1AnzImC6mgeQNy6imbFlk1oGhitVjFMzNUkybHwOeRUhyZkbIlliZKSR01Ui6kCuYLNkjQqtSI0okYTY6SMM1kUH2VCfTTNUDWcI8mDp1JOWzBFTmKRobpnS4mTBtSPMpUpnDJanQ5mzHmpF0wJsu59bmdE4UZxaHcnj5XMGLpubmC0HPKQQuamF1fWofVGajwSMOealRPNAVwTdZMZVEwooyWIoVhNHwhSzl3JhIBeECMDig/EIIlicbuBWC7CYGASxmIIKMkJBmNzkKuFADBCPBKJyJ0j0xZjVUeEo2MUiHqlzUMcuZZHVjCgsisVJSgvMc44hIjjjFICN0IqksxsZHEBcVxow+HCUdJio+KC85+qM6NRJpjUko9FYhFUZEZUgFc4sTkxKclVeao+R61kJaURTknqeevZc73HyucaaeizFMLPNKIqI/1HxdJiSyuetnqdqZ/2arD1sp8koC+iDhu6faHGpNFAIGNMiAoRQ5pb6rod5sU4zVdqwo2OD4bUPTHUzLxlmy35awvwvSGIcirutYdhRZRle6o2dJXNFWQzB8VOpG/FaU00osrHdiBH0kz8SGcvtjeOnp6a3DjkQxMSyxe7A8Dw3nD8DxN/7u5E4jsOPF4ff/GUSyMTGc7rtuvXmqnafPOeno5QSiVwPnamq0OSq9F6DCWNBopi1T1pVyrLu5526SkwuYX6eZtO5RU1WNz1e3XwemI4xaJ9u0Vyi1hSQ9TZXqfUWgeIYSyURK3+fL9JutcmJA+0QgCURzLF//3Q/nSyp/bWdafl1LLLMirYX6Wvav2pBS3sMakzyvnZsVs7/8yhm5jMZUVjm+4dv4zlX05AAAAA+d3XK0fCNTyAQuw3WAtVa1zxMaxefLcxl5UN42MUeNkePePHmm8YpKPoEzijLqp7DmjXvDgtqoh1mx76xtcUpimr3rrOc31l5PXf1i7hNDr/bFtaxSuosSBj+u5Js2e1anGt8bkbZsPoMORzjb3R78ZrjVs/e7bxfWIF82r821jGM/6t7/Gb3v6Wtfef90/9s01/DiTtcKmL0p8U3rNs6xWkbGbZj6jW1qBLGj7tefQMNPLJzrd++a06gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjTikwDGHtyxbDJxCXrbmKWLSoNZe3LG0JmkJexufl8aUoSZLxgNpMQECT2VuNVV+JwDNxeiwwjBADElortd1VWu4KtICsXSBoi2yDygyzn3hyUwA1PK2pc1tvX+DortU1a6u1OVoayW0lGN3OVS6Ho06UBS2Haj9UsUNhVzEv1dJ2JCLkdrKvK6Oukcwn6QpzWFEdoS8FqcpbXr00XFDS2k5VMjDSG9RJuqFlewnzi2FI3WYY+2twNFDVS3QHKqRbYtFO5K59AfQE8zN14GsY1Vsoq8KNyTyOhWmgql65NUyroqJHh+xpW+srarT1Yo+6ok4DRrbD1ZdTTQLWtaGuanSlI7XhldRYul2pVCi2ayoky/exk21ZhZ2wsrLLCjYhLmXPivo8SAxRq5xAgQMYh+33PEYn0KKQAAAAPGw9p8MREJeqIrUQjUF++hO4UKO+I2J+rW1rYXpyq2ItWw23rWETPLUlt+RC7u7X1LKuYtaqO0Z83abKYVmJrCVuPIQettNOjwQssROjyO1qUonXoy1kvguary9VyKA9E96JpUmqJ16ZJQJZOgxlh0n2ibSedbmzL100aakksSSxats+58MUPzoHane42SqF3NQWc6Xfc01kwuogSlDa443Hl20gdQX3oW9Tcsokm1V8sY8uNDZ0Pnvb3/c0d/nAjpPsSkhAR4sBWgy9lpYFtq3GXNIMDTAVLtQw7tNCpnTdYddwucDxWhSmxAEuh6VQRF3AYi/7YIrhDggYWrLL+VNNiVBKC2Jl8UlVmUxzK82MSZr1pVFZWBT1XM7NGnX425mKNbHrXekMZkwc7KjYicHoQxcViRIbv7w1pFshvMXuzLt2ewsOF5KKFcx2iHO9Y1FEZWqM4C4E7zrbk+tDj5hvp2GzKc6KRiMZkkShDF0xy3n9/Dhj1GCnkAtdzaUxFbKneahuLarVrAjpUFHgwWyl1bCo9OxtJ8O2JDPpPo+rzw9szJOl2xXqnbNHgqxvSruVkYXtFEbi1BniyOSRaY0jNusSW7OrKKR3KuncS+fmm9WeTWRwgAAACs8yYmOkdCUhUQttHjCtmD9Wvt6kwRqI3T29onaXk8Zuk7UMyWE7vvJ3TNMa9cSMsOFtOZzEvy1XXwEbX75Xjt/7TnNE5DWdDA+/LbDE52/Ws3rDEcRKK3Wp4w+hOyOkm7Sx1xwzMDMGXtjQQTY6ulbnOp1Z7bVgWUeLh8YVpk93TWZY1e3ZrILXgeXx+htMbSmzOf94bQXZWtO6Zw22Z2j9KbdxqtbMon1r9I7ZZc7b+fh551+ta/ef36T1loMJioqtgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIaInKgzh7csxQiZAx7G5hki8qDWHtywRCZpDXsbn8sXBSKYw7Ne24F2aisfMr0WvCZTUyr4Y3JqH38aU0J/Z2/Vu2Iaam8MvY1A9mgFDAsrtWYEr3H2AI0PXncmbzybHTdyZijHbl0rZlIsrecqxQwJWeeSrVb/cXDHRrOW8B4SMQ9o21skFX7vP86hK5ialLTT62lK8Juxw00hkz03JFpXtzezF3enZoug5UfPJAhx1rTMuHx/MWnjUbavOMmTEcE8d9LA3nDEfI4UkGmMFDUanIu1IytxcVOiiWMqlaj+Q0ny2kmSNVmdQMUfox+plMoi7p9RMzJIzsjZEURov1Sr51bmJZ4nENieLeBD7mwywH1jwXEffnfqvNYFbPtK9XszA8/h6tmA/KF5yydQSilYlOnvOQjWmr53j4+e3qcbqpV76ueww3zc/WFfTYuiFTnpaPmASVgPtM43Cbnu3Gxw5dO4LCWr3xXtGZd6yz//7ScHZkjRWu4vZPT1yFvu3Pr1Thg7O2oW2/oYQRNq47H7ypw+cVjqD4fkU7JI7p/QVizrdDrMsKitdk/Ph4Tk2sM5bJi5qqjdejWNnS2tzUvvo1z1KLmMz8n4YdyfhTvunZ/mcxaG+PzG5SiluHK7tnuykvK7LXbPu3j6JzpmZ+vsW6g9VvKbdm5hI5LEHSp4tzfYAFJSI2uXOUlDhAtLDb4KqRx58sal+nmm+gV53EaBeY2GXezB6YFuVZKFRLLc93p+KPHD1Jaswy1iUyv+ijyOzSjNNbiQYEmcnLe+bR21C2yAcbyyNVg335fYlnjVGg28LcBNIxUqTuD5vhuCnPJVv2VdZgQUbGboyulV9kMisQFh5red0ljxmZwXSTb3t0splOoD8OlXtup5fEzOrDiMk7TieLtIsUB0vVnTpPXM31enzyjKAx1U9VbYzYbJnzqFlTIxVqomiHPWBonfxsqRStkkBr0wM88advkhsanisLuMl+2PnJynhTT7ZIEBykZ1OolG4oua0+K/GXCuJmF/WmVAgAALdSaiRUy19QTSb/59bV8VfLfet/jbE12b4zdvDaFqjaSVfvCDXCWRj6nWM4hWVVfBKeH1PSHttZW1nbTlepRYcnLG+w+S32PvPz3TD83P/cWrpy8Dp7kwlfG9MCsmJhwVRqcEs9C8EC85WmXpkuv6xAZxx2OXUJQspM9b7dLdmunFCdfSeW2SRLU3v3g2+/r2ZZvX5qv9xZO7N7Xz7X2mOw5MEb1bMNbWlaXbinLORX6+2ivkF+mY1DCgKaWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB/6JyyMYe3LBEFmkKexuX04nLAzh7cuAQ+YQ9725BAAAAG8tdoftWqSzhhXSUNW207qp3K5Tz2mxOgl+7VTdimynfe6L2Grv3SiNbTs6V4cKTsoCKsxU5d+frwmhxll+OqW0ka4vP4aZfRRqpekNie+7NPTyxsREIeWhtRjMpgtZ6OeYGoseN5IVz+malTbHjT4O8yHTWxtdIa83RrFyZnSibHjg8LxSBDjYvSeBCivmdwZW2rw5k4p3JTM6ofe0aM3rozXxgoecbcxRF6FZqsbx7USdsPmRo0h8GRcQOrtRGJtyuEknDQR6FWXnOSJp4rlOstu4L1ntAZKPosVliv9t9fWNqM3QtUg7mjVxmsWkRVxYLM56+fmO36XePbIABACIdurP5wC+K/4xvNtwW4E5C9sW7C14pMxO8IsWmJTEf7lYD4aT2cGxS+FDt9NbrJ4j43gOx5XY9RXtIfZm1bIwb16KkVVqtP9ez8vO9Lscjydst0cUlIf7egPUeu+2+ZlkrlpOYmBiMCI4SXdl778/Wvs+rqZHC0vFZFfv53prN8tXKt3i3+LqW+PNRuOMNzP3+frV+8K/X9V/SlJntvmNVo8spFVql27NzPV9i6KvWuzvzNJmzQzQDDm6DFNflUoaa797W9UKZRHFa5nruONWx7PoaKE00uwm6fcvryed47rU3wA3JqtXiNF3CXDY51PN9IHgmTT8s72CVEZPeoFm7ghW0UdVN2g7vRxjOt5zZM9So2NFc3ZfZUWtSxI0kC08jbaIkT5iO4kRuarrotIr++sQJ4OUJ1M3t7IjDqRy7XT6X/UG8SK9kfxGOZUx5ZFMqlFHdM8HeqP9pMfD4vMmkMkiv1luYD8U7i4KaqSlQpV0hsTVHgt6t2+QxmO5FITDTrmwt79YfKRcRFE+mgMlG9xb7xI8GM/mbnPb3wJavZoFryLD2L9PosR0ysD5kkc/vVbeBGOhUlMAAC2NSXr6bt/pFhXb/vn/Ml2EswA+s4iavVXS9xZUjdMASLJfmA54tAWCMK6CjU9SFvFXy6UkTCj02rWDsCmcdUfu7SojD+8DcEvjxXP5JHNnivEo57mj7zrN91bozXVIzb/mV5ttVsR5lVK0RS+Wukz9SZioSxwVM3umzwYHvGfb1dKUqmV3Hjo9C4O9+2/ExK53gWtGVa6hvYMB/FjvswNuO62zJJCg+sGJ4LK/WnN+xx54F93rWBDtDrPH75umy7iPLS1tDo3/Frwt3vnEsv1TEB9e8eBExnENNokAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfYicsimHty4zE5hDcPblxuLTCMPe3LU0SmUNw9uSAAAAAcNqjqUpmqkZmTAIrVnDmsO8rYTnWdJwvlE7+NXGKSmD6KRQ3HioRCnU/jBdrDcAgYiZC36WVQN21N77KF0UvJiEpGBB5Q9X5xlMQsRFxG3bNl5o2xt9Fcrz/F/3GLeLGZMxLwp25kgu1bHpZsiZbi9vu5Sw2DDJA21SqSHCZ1O4QXK9qu76jSS3dPtUZ2tSVTKjLy9ljvJYUWT60EhNFMIfCqxsD2qHv47CwzQzrQ6CwNTMxvmpK720wG7OrnMux6zWV9FXFcvHfv53NiONxjuTc70yPLsdM2b37dBhesKJGe/LJM11ziFCsz1y+hM26ag109qUaqcQgAAC2RZbVM/B7G+z/71/MJuzQzgl6ezqZ46gWrhPUdPkiA20/+miQj/mrrCpNG4/ZyxtfOzT5TvzDNlIqqlwGetZXs8DubykSNqVNuLUuIrnHc1WrIzvVpN514vy53Qxjdv3CPBiZcrNr106i5Tzc4zLBpE7UZJVSiicUbo7Zq948tKbzGpBgt0dS5QjVsZvH3mt1fGhSRWthcWe0SDiBGpSZvZ38Z9bdsQ6QmO+oVMKXnIuXkfM9PvEGNTKs7ZZ68iSwYDys1N3kgTxo817x9PId3k9/qta5vbe6RJov3BqokAwAAPxwq912hxq63NAyQsau/9fWaZYU6JmlJMX3jTWzbksTIQU0a07DrUq8JCJ0lmNVM148CHqUbvux4XDNExRDZ963nPvFzn7fsPhZb9TMrI3nNitZs6xb+RnN66u3nGn8aMlozZFpl3Fg2bldtjVNJFOxDuzmkPOaahx/j1Y2aGtMDazsWawJq3tl4vmSynubba0uVKrq7A1MFYx1eKysL5xk04voVNxcWfub5ebnBPPnkeO00Z3N/GcXWHeX8PV26md4nh79Xup8Q40C2ZdfF6RLwK5b2CG34/xnGnL5i5XjboDAC0GdekgrhAhxfvLfdfjc1TUA9y7l+dT5FcwztTMfRGhq3j89Cf3de6PSaQUtLXw3c5g/eO5Vadmq8lFwjYlvuez3X9cagQlbeO/c4druWNUi7994+3kSEzPMaswu9uoMG2pGGEnGPwbq0xFBRlS5corNV4zU8kCJrOcq9LYng7W8xbWxJiuremG6LCht5/KZ9ba+3wn93j7cFjvnVbWz40fLzTyadjbYf19f+asK0GJiaH41qZiZtSn3e8CsBxc8Qcet75vBtNis9L2z90pNOpsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAHVYpLInhjctHQGYQ1725eoiksieHty0tBplC3vbsEgAAALak6pRP0XNAN9hmN83n+rHc7Vmhcpw5ZuMWrkvmZHIIEuDAk+rVFKr9PM45TYQZZUGKGZc3Yu452CYU9H6ZYqO0N3ByV1svoxjNNm7bDcbx+mgYW2QiWkhuuj60Dce8al4l01r+fK5aoXo8dhk+ZcZT1Nvs6Ygj2wP5FG9Y5uvWeSSwTzowZLlkSGpQ+2/LmjwLQHlooL6XeaXPmClKNaCcFRfUQR1QkiE16EaNp1p5pP4oFwfUNCYMPTvpCyXXobJFNjA5Ny8o6qpWsOaPfy188WGdPsu5nXpykby1ixzszPdqmBvc9TcAAAQeySTuvxVD1r/PxPSltBazTYIcF7jSUam68RvKk84O8ZNlo1qgjEIxUnfe4Oc5sOiK3pSCzRozqQecHPnew+vb3XGK9WRNMsd/RRKpTNX3b/5x/GhNz2Hh/2qzcraplx0rp+xKx/NDfJ1CHF22k1VjhDgbjYm7NSmMJFuhxk4yOUOJq2MW+LY8K1HKNHZ53k72aJaG22gRYE1PJi+8UlrIw1gRMm+cVnr+t93thzvEtW1q+bzw6uqwbxMefLZDfyaj0ltJucDmgLnP6sTTIEAAABBK6VjA/ygBquLDlz98qb+b1bgeMQVOX+8+ku8nLeI8+gfrV67JatjlcoQhwfR27O8s45jtsCamcYqzajsUWOnfh9NPPZb+sVm9nJv8bznkWGZwpJmTMsbE8Kp+L866pF+YsI/Twi11Cj1Vr5qleQIb9mb8KEkSfidzgZeR3ODDhObM3+KuGtqWGxlTif1D0/gwVMHGjwrDzTTg8gt0zG1pg4JDRSNnNSWYHa78J21LDx/HV6uZy3qcWwmCwulRX1WWRIWhvYiJwzQVnbAuJW5siuUrOu4k080BSR8z4pZqh7d3pqO3YZHBnj/49tW88wAmigAAIva9t769wxdX/O/r7pZKhNMt/bO1XC3hkSJcnNi+slDH9WoW+GoWGNJJuWPmCiYDLSM1wmPdx47cMN+9wodMRNR9v5qwPlUO0a8lxSWvr7Up4Le/fXpfbZlWXbILndUwn0ZnOmcwHjYW4tC3s5clC2QcXt8TWpr5Z5nll564SsrnTVd+3yydzrt9RRuao1vMryjg/bbfflzjdPAjPIj2IwIhPotPR/I8hYvWFAiXaoseLDeONX8O8ebe708Dd2O0XW3+q0vrfrSGxow01EpOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGe4XMok9jcugRSYQ3D25Zcicyhr2Ny9dE5dEMPblJhgAAKTZ0kpxTWJsFyGLj/PtbetNbKWA8cfWczzz3VRIRRYn+dwdfMI6yNUVO5tU1bajPmFWZCgYOpuSquY/M+/vdSbtWgmGiEQQ+fK1Ot27M7qeF9M/mUjeWYPr+O1sshYmxYXJLNXLpyYPOUlvfp1YYU+Q2fTmJOU/WJhm1Y/aTLRCgKuuNQ2g1REVR4H9fVE2YyxCcRwqrxwq0t1J2pE83Gg0hSWWPPxOywvpej9/LrvRL4XrTNYepiFCofma0jz7swwN88dmCP6LNKnrWJgAABNSDLrQ8rAF4o//77+8fuwE6AZSlwqY4dhytLsL6h7e5W8cPlM9z6FVZ028gjtn8ZfuP1mTWIttx8U/H2hvPY+3Nxy2QcRrP9QETWL48az81o8KB75garvOcN2pGe72LldsVUHSCpnTOp3qrepMujgorNqLoe51QWJWtKg+bQsyWrWjlDfqVNo1OsOtZ3J6RcKZVwWzWdJuEySslDShp1WM1m17R9WBus9oTdEZlw5vGtXFxPC+r6pXb/MGPA1EmjvWC0WZPwry1dQMQnK+IbFHSemeBuJ9TYw/rvv4WM+2PfcO6jbIAAATSTdbU21AxmhHx/nOdeLp4ixaWvf19UxGq3DAblbbcnbHmdQzSIweBVWpXEa0sh/apqLYDluoOwdOfetL7lpfcaapc6IQCTVYe9v1pOd/wWXniaZlvbzf4/jdtDWvnXs42gc+MF05u5DHZ+vw3ahPIcjWltT675+uMSVhXRpv7L4rqzWxm6DpnVXVGsYgWt2aK7XwVdshCQuJYlPHUaJakmuJERwuhZXuO84lXN/T5dQzu9WLsbH94PRwX/tlvWpdjmZvlmZW2nCAAAF0D6D1eiCqY65/5flhKqe2yMgHLMr2FbCG+3ar/JiyGXWcsOVIXY3UDgqNubLqLK3n+dPB0HalVaR27iy1EVi2irmK1Nry2N0mUi09VFm9TSmS9bFRpxvE17VizVUsCVOx5U1Z8pd0gKlCUBChyqdwTKGqVDSocSFHsVLIYydc6rUJgvVw3NFwolzSZvRaGh/s0WDmBa31Tuo8dglUqUS6vY3BSp6BIsaSO1GzQIktaQGN96xrol0Xd+XA/IzZjUe7PaRgcl2rbRXKG4RYOIceKxxHja/bE8+b1FCh5dx6vXGkfa6te8kG1Ibnhx3JGfvioAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABuqKTCU14ALf8KmUpGAAaqZBNplKAAICyCkTClAAQIAAAB1NddSL1kmAXwJxSPnGq7tqMTkN9yZ54v3BbMaMgXqpc6VtlbSmomSsZyGLcC+aZjWhMr17HiSQXsfk8c9UjYrqN9fN8YgRaQanwpol2qlrYr9a+oMWzO4atimKzRoeH0KuE7NfVrxWpjq2P0oqdXrTW/PZli5jVgyZkgqhlmfwWbFNfzqdzRrMwQoOoL+WBJSAv7c4MFhMiE/juc7/v4EK8c3ICmMtKlvdQKYfajNz5igKRjkgQrTRGy8BujbiUu1VjyUjbrXeN7kxAj4dwPG1GvLv//1j1HazkQCICj4khN6/CQtpr1vP+8uYy0ONzDXN5zF3td6Huq2sK/cI5R9r20Y6ecidnLDe71XOxGs5judNS0Vpskuw/tm3jb7vHLmc7Dciv5Sm1OTkM44aypu7w73dbm7t6VWuX8buFigtY7npfLpdXtXZbhBEZq4wDVg65V73uq2ON/L7OFLlq9GbFeVay5/471zGnv1aaglk3Usap7Uvn8b9at+eGG937Wf3dW8u1ecpH6nqX+Zd5dxq4VZugvVbtbHK39LVs5V8ML3ak5Xx1lvWpmW1ce46xzucy5cErNlRsrAIAAAAAACmZEzImo8RdEMKA3QDTDQAkCHTgY4SBtRCR0A4uKQA2qwG3yaGkoUAGWw+cDCEgNADAKXOKSE4JEHFxjsIICAEQUMbBZCOkoCvk4WAuYGfG2GXxkwv2A0JASIMgwkZmJwzHG5mHTjGDIBdQQMODAFABY+FzoNvgsBPrUXUzYcY4yiOMvh74rQcwOoGyhZYCwsAUQCIGAYBqdAxSMzWGqB5J8nx7L5FyLFQegtFFeHSOYQYjhliHkXZZmRNqzyjMnDxYIIO0m1kAHhibIeLNG8J5HID7ithriUTESIvGRusjzUwPEXIuRQny6YGhTPkENSZFPMDIzLxXHhjQ+LjKRZJkgJOClkEkySZEnS2XDUhpuku5ok7ool5R1SKi5UrzhHFxy0Xy8ioxLpucN0jxxFJjGgztlcc4yJ0hpcIMkQ8mSykVjI3OmBacyME1Inm9UAAAAAAAJ7TdikezhYNvAIqD4yoQBTLPjDOQYUcg1qqNDh3jhREcjTrUkiqJHYaIXpI9ZEFDEERguAwfFfK7K7XVGQxxo41ElKzsYTt5JHGaauIxUipZTObrqxlWrL3vY7WdzZbkc6WZ1myr+rM//9l6Voy//7upFQ5itSiMrf+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAh6ikuHYwACro+ZxOSsAONiJTAHve3K6EIm0IYxuf5hK3zvP2ikuaXsiTqBoQNJmYIGrAuYtqp0oEhtmra9yAGgJy1FAkxlLmBM6lrdYHUMnZKz2KvEupiWKwMSl09KYIf9ZjuQm7SP84UNQ7JZyHr7+wdNTeUtmmzXcodpYflkkiuMlllNciTvQDO1eS2Mwy609Z3OZ4U0qprd6bpJXjQYV62VJjjBk5LLNe5eobM9VnZmpp+K12XS/T3dtfjhj3Hcqznc6mNWRZyu1esWKse7jr79SvDLO789zOp3+dp6SOSW/nfvSjUrje4vhMyme7hlN9oNyF5pDCLfKms9brZYXLl+V09f87d/GvnnurM0tBVs0tiBb1N3+7t1OVa+GO7Ew/05Z5vnPpfteF7QAAAAHv3uOi2klYPk0lkysGx5Y7JsgVElzj0RLkWpDeSTaD6UpEqNqgokCvLM9ei0sPtpqcXT0iiEaacPLLrNbdnIVPyglaLkkdhdxcSjdFFvc55rZ55sXvmkyUoeVOoPlQdQgkC9MuId0/LGW1v/O+GJOvrra3zsrUj2mjKNHTU3edp+6+90PbD3Mg9TrJso3zUQhB2pe90MerLLZTGNWaddbtf1aQy/OtnP1FvrwK7O1cHioi4nChaVAZDcQtcPWZiRqOR7UQUegt5ui/lVRfR1DaK+Ily9CEDHV4/g5C3oeOMfaHp5kXajDoCjUJ2H0dacu2NEE32+5K1FDQwg4ridTMhb4qPcGZOEsUQZhCRjn+XYORFs6hNcHIeot6DBsEMYxNDBBvoMbiackoq4z3ay8RJc1evLbetlwhyj1oYnD7OB86VbAPsex4pMPweBdyDmYMSCSs5TXVB+HCGG+UheE0dcynORnfLxoLjTAr7MakyvJJUsx8s0BeUq1DhaewGGI3n7Kc7YyxnqPdP5svlJmBrVdKgy8E9O7EeeLaHHZIT6G9md1vpuh7kpeB80e7xJncmIuPeltxoFI148NxrLCz/rG8SXVZABAAEzdVUtapYKYWD6rsr8xraXOlK1v+vXewZNq73zMQnJ5sKi+jO2ZcpSOXlMKWa0bg9sVrs0vuLKSs2/MHFa/YkQnaDToqXXr2Onsjx+vb71Pm7nunaE0+kjWR2Q41Ak6ICozQUJJJ6/TDhLG+xZlbVqsD6ZWt+K1Y+vfNpHjbi9JHLsCqOLKcrmubtpnMpdylpfn4K5Pbs401s2pF/cz/wMV2k5s2rk7N+nPdmtcmsXPWGAzqbcxAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIXYXLAxh7ctGQWYQh725jMhcsFYwACws7JpKYwAHdyJRO3Yij9RJlT5x8eu3mozTRqxEpFAbuxGA6aYDxPdKuwzGohAURhtFZpriuDDSxoDXbL3JmaSA3yXuQjrMNhx+4d5PWrlas/0dussJEoa+ycK22uLCyspmD9eEKOJcqFcHlaRhSBbl2GCjR9DGPwI8axymS1RsWYWXcNTJZVuJ+uTWrbnE7Ur14y0fIdGYoathEpZSZJ5vH6mEOZ2ZSp1qNJzOlCb0cvlXKlyWFo/XsK93tYD7K6j3eKdOKpWwmGdy1IzKhthbUK6uhUeBvcKDFe2i/vlU3RzsVq83Sxlm7A+iMSv1bLUu27M2KTWa40saNG1v61B1rdMZfNf3SO8dzSwmOfrtHgJ8oQAAIA6kXNs82lG4RBpM++4PprNKQkiqWyrZO9kl0oHJ7R22Vi1UjhZ8oQdKJPtJucm74xD8R5mlW+Zlbm4SRmhzTyPmJwxGgxWXcJylg+JqLGxeEzQtyxPjGPA1AZ3jmyuUlILA1SMcr+OuJL3cqpxAk/UK9HSkNicNOcWK+Zn8F7akWXLgnnFlTsPHxjGvWvz6xoNM4csaiPYdP8Wj3zjeLbtjclcRLPVa/caarbftWF6WrZ5Z5PXGtwYUXdLYzWmbWh2vSvrq3k1HF0Ryv6q3hUqUlmvRrrUzSELgFyBPBdhFBTSBNu4zhdipEhC7iDhdQCETNRPTrplbCyhZAuwxR9kkWtxODZHUdhUiK6m6Rax0525ydAjJ5FEe2o2/7ty/CPWIhEIYdx/HUhh/11U8N08nz7Ulb9v+5bluW5cbp6S5La7twTIoNhtiDsPxLKd/3bct32uNYchpkojFyhjbkPw/k5HoYlE5V5Zjla3ju5NS2vMV774Wfo8JRUsRR+MKSZll6xSXbMVvU+NJSfYoKTCkxqUkO8mt0k5nynpMq2H1b8Yv17tWzhrv9naG5jaksekEdjD/QE/9aJ4VrNLMTFDZh2zKcccblXdBf1nr8s69JhvWGNu/nqtlX7Vy/WF+fqfc3+kIUGUMgAAADMyHt3W2FhgCLjlO1hYsWLFixY6LzezBgTCYaVMDs8ct0Sw8Mz9le+wFbZROS2vX3hu+rLBgoODihwio0FdXKLHGFh+vXvv/kHfdDOzt95nMnV5LJ4lmb7nZ8N07Z+JAkEgkKFhxTDBIwYGqzrF4uI31pLjq+hsT116/7x0pSB3a0fUNUpTKUnMlhhxRzCe13u9zdrkW/N63pTJ1/avV95lmBvbVpSn0mz1smjsHzMWiBzQKVD1kp9P3ZF/vn74AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACKeQUQZOgADecgpAxTQAI4oTLh2MgArhO2cDmMABTJE0FIEoNQRqJuFEDF4gcSgJQC9oG84IxCAAAiQvAMaBtoGLHiggxkQ8AAQF3AMOwNUYAMAA0BjBDVwGBDhcKDgQpwZBLhAQtZD9iGFAiwAw8L3ibBVgABBRAKAwsfDHRlRmkRKJ0W0AooAMXGGtxc4XOi5BjhcwzAzJGCbB8E+ShEhJxcohOPQe2I7JcapsOAQRLA0yQJ41GmRwsZcIALWP44FEIRUuMYkQGZJssmxOFhybE+GhPk2TZES6xx3TPFkzMETNEgaaReTMSZQNkElKTQWZGxVL5VVIuaF8vyfNzBM3Qd2mKTmKpmo4o0RSTpprY4k6EwTZ2qqTVRVXe6tbs2/rM0KN6lPfr/+jMEl0Lp///2UjKqSnOQHCLOGoSAFBMGBeJASsSQkROSiLI2HAE7E7JpaXRNxtGWWlpoZi1KBsapCNhzx7CZjEH4TkKmG6H9ySJxUOYJwBQyGUUjMFdEyJUzJgxCXNBludMBzheExvIBPIRMKipIqKR8cxFNDQuOZDFGOSR0gFE8USRKjxWPpLjCD2Iww8ljAwJElTUkj6jYoHCifLDRAuGpdNicmTCSRqMDJi+eZ1NapMlDpJlAvl8uLNzEzPomZepLUkdSdanWtF1um66TLRe61V62QZaH97/0VGSXVfbqr/+////+5JEBTOx1AyAEtBxIeDwD0muF2iEBQcWuyEkGkmi2j0XGhS6Q48whQQ2c5SVytyA+02kNui7KsbJZauWHbD6pGoQwbGJh7mYJJInJ9BhSXrMUNVIKZtoj7GUtkqXQlbjImggFszkxnNyJTNQVC4rOymPOlA1GrbFMYk3HBuJcFarkymQtyeaU1XVxgyLVZCyl9mXU7+QPLtaeKczh3kglOOFax8vlNbBycZLqzZqzlyvTWsMs6vx7VNl93O5D0NT2cSwv0V3K9r6Dedi7H4RhjutOYR6Ytz3JXy3qvPY0eM1Vwr24GxpcpXhVfzcj9+LOPLFycymp6792VzOOfcNzuFS7v91eVNZ63Y7jlrdWtn3HPOpy/cnbL31hwR2asxF0STcnF8/ViZCX6U94eZgM0QTDmEghEAVCCST1YyhF0JkaWjTDSo6iL66qJSNkxs8VjY4MgFCMyPJadiJ17smren2TLv9V+c1adLj7rwxF57ySe7Z6zfW+tHeTLr4dP+1a3xYfbWrFILmJo9LlTeJcjZlqGbfPrrRUlm05sL6r5mZ6cmczL7aYbs7XunsyCj1r71u3bWyrH63jq6lJvPTNN2cmlMyvTMOSdUqRTK5DOf3XrnaBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhki0oDGHtwztE5dD3sbiAWJSgMPe3LKkGmEIW9ua1+PK2J9N4rlO2DRkAYYlyhkxJOq1BC8VhmVrgZrFHLZ3BYygOwzhXUrXbKpHLoyXwfpoWG4ajVWigNrObmX8mmu4RSVVhlwXMtsth5/3McF5YNZyWh/uk8upR/qiBRjTszXNCvBhP05Gcni5sp5SHHkkmqWHJDba6zGZrPXkKrysDTd5Es9euFGaezNZmWn8K7m2q44YjRpsbZYNJ489ZoemVSJC5fXrcqfmE2U232gy1MtDTzQmu5Y0GIySNJ/G47cy5K52p7vaxt3pdqntm8ZcH6LKsqGK9ZpG5WPYsNlVijY7OUPEdWrlwhVzujY15YNRYySVNIWJm93GrqLg592yulzF/zTVPJvU6CAAAABi2G59HfnAP88jiQ6A+hw6HbtvgZedwTymJyw3h1rZvhqHblRS+sXVyMs9NNwmZ8XbnWW3D19vaGx4zAlPTSAqMiwi5U6Y6f1lbvXPD30aEqXR4mW+vp1e7NrNdpHdXfKNNv3XlrYXCpZWX23CUnMz0hkklsFp5y1/912uyeIDSTCrQ6SLumv7PTua1XrXopWp9vy35SVl6X9mZv3X3nW8fXE57aTbG960WbRY5e6W1W69HSJu6va23mX9XWmlMmYGjyt9nIN7unKMK1KaaAqBgCwjXoBpqEqdVosxBW6OaM9iWoX+d3sGKhMZgxqxypMHi53UqFbf4/KBeQnD1NhLAdTIzLzlAYFpuOoht3+oafQDYyvh6YNMKeuHqH5t4G40rOw/MZDXFCku5wW+uI0bGa0jP2JJqxxf1xfpmCyLcVzmdHU+ZYqavG3Ksifh1jVUclsViwIq7yzN9Xzcn1txTSvjwqR3zG9vDgUoZ5M0IT8JlbWuZzbWtZjsz1CFc5Np+uRf2BXxW9iPRWrtURVc3JBlRKscHOOwo15CV6fZbLTGt2ULYnWOZxng/1YLHNCifTfClti1GOrZGtWC5vJm1rXTA3V9Ny7nA6NoEAAACLo8thxzKzBSavduqHKj7ZBOOtPVNoEGeRtMoe6vJIyWgxBYHnS17bT9w73IM3IqYHakPmxaSDe8LFfXUveK70uro7NvGL3rjH3868SKnI8G1paRHUV7Cq+UzCp2yVubnI5kOUSMF3c1PRhgUxPZszq1oSkcZYEWSW7ZE1jFNZ3ukLdNSMDzTDDrDc3GsaM35rPXU/zSTO56OosGfLxhjs3jUrJi8TMB1Fy9vTWYMkXVnseFbNo9nF992xN8+LmmZ8wHBmsO0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIOopJgzh7cr/QuYQh7G5e0isoDOHtywtEphD3sbi5f5HWEtNgqVWNw8IeXlqWq+VNZkOH06T9PWeFe89N3tzG2VF3G9lMWj8gzudq4Nigukr8ewqCUZgnkD2aSmtalCn+TNlfVFX2GAgzdWZKPl1V1rdfu7a0RYtF0ooK85H7SHGvJf3rmqdYD0Qmus5tAUbconJXXbHM/CayHXaIzpA/VYSQ9whqFNingan28a1QxNzVA25nm1oxujtcjS4t76PSzZUqyUs5+JtcLbItK9QTK1C3KQ7DlWDVhh/ms4Vhr78n76XajXU5oJ9GJBtZ1U8ZXF+9mpZHxYMyebk+zWY2x7C9Y1G5rZ4GNxFxFf5090+YJmx69wwOCGLhD3Vd5tbVF+S9Q2MEAIARFq5rkv2D4m7xbPv/W0WIpylWbf4tBPX3cKMvi7vRcH3fcAWk2NP/S2IuMwFNiBEYQLNOnFb2oc/j29OTuY/G7ChlnnHmtbmemZnJmmHv0s18dvNWGDKyBc0aInjgpNl0ITMmhtJYvM0nD9bspl7yDrtLrcv85SszOPW9lqkCJ22s519ouUR9Hm6zN6OqKZQ7XHdWT+OGlpt91lY8ohZdT164zRUxDZ/MrVvX1dlrz7uRVy23681hxVSVC7meVqIxmI3r9LLwtCjXSZ48/LH72kJH9fwOfa5/09mEolymScW2/lftWtVa3FMsL8vRckVuU5YQ3zffXBfkMrZYMyhmubNrwIEDPbPTetamcZtLFGQ5H6qXqVhalhfWo+nbI35tSe9rKVCKw8Qnr47kWutI5cGP2yIN5Qnwcem5ttRgZ1S4sCsgWhqRKnYmGeKr2eHAvbPtJtCWCiGJhleLjdFLQ6Yp2ne+kT06kIatUZIzFpQuckra4RixPlUQ4lrcq5FBSqIY3UieZomJorY4zQFUwYnbbxrfvXlFdM4Ww9hRLRpLyMbcztd2RRqvXpWkbFoEcEzaANAF5r7vi1bWyQPOMWr8f/rndD3fsm7+2LRrTMrO4XxDxcspPrYo0kyPIeu3UxazGrIcLUjOtvD9SDIOtu2rbvvJuugol1hv8ptq0mfnpYpq9la13N6T2L3gshsj6gjRCPBXiE9OC7ojCWz55H/1XRxv6m5MiQnjuGjHXn6TO9a1H2+5GpvXSk81Gtyrtkn9S1qVg3PaipCtQKsUq3u67bPZ+Xo9ttsd+jX5lVq51tx6F3Hav1p+zF+zfMb7pnpZcoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACAiKyYMYe3DR0UlkKexuH9IvJoxh7ctxRGWQ1725y/LKe+hl34wEZODwuWuflyiu3swEPCSrBAg05QbtTOCE+HnllD6Kulc1ZnLfRkcZosqr6FRVFDk9lEIzfzu07X6KrbkZY88WGb0NjiMLLHui4v/thqfR2NlYn7SiI6HxouN63a2KR0NcFpbhVgYiP8rtKxMN0V4ko8N88aVu8xymimlSrIE1rWsp7NjHGbHJtXDpvivLqBXRmCFqkD32j1cdpL2NjcpUc/bVOhTpyJymFQnnNTMiriLNFGnJmKI9anNvVS++HrQY/HFlhTxYc77MZyVL9MMUNDzmV+HkjXuFmKzupm2E8Uq3empqPX0d4yvlwxIZSRCHf987o5Zg5YpIBgMAXY2xtqgFRPN0+8b/5vUqTEdc1caz3pcYbUvxVbS8XUqbLzvrkNQZiUUW67Z4m48x+azST+x2uIYUy1x1djklptEzUruuQVTlhhYn+kVDivzNq88kdeWHx/D8S1QoWP0Pn19iSSycnNyGajCNYeCcidPn18SxtKmt7zDi1DZOkICyqG+5szWeqhRbVpwx1ChOx9Q1zayDrqOpeT6mz2dO6jWKGCLtpyBh3DvqqmmVz76yO0Ldqu+29D6qK5kktSkdvmt3I7v/OLs6a9fLL3iACAABunzxxs1M8vshrnktd3lvuNvSi6Qzv4svCc7o9Y0mSPLcZFE41MwxjcvWbTo8qffqkqFuRqpWlE/UuUcsc6Ha+c+mNQv4LavuW3Nxi0Vm7a8Ruhv6xWx/CMVTtDP37+S+Pr+8OHKrnlYmGrKqWozDDR7yC9MhyYYitfNbksjCHAq5JX6g3Ez6d87iQVJCfngQdgUUkTS5jTeeJBXK/CcU01QlJeM27z46EsRoREhh+YCCnbnKM4v4rPVXK9t6vbxD0of7Co6sDkwIexLmbaqcDiQ1XVZoqSmjQcSt07likOaVY2rs576NfG4T+R0+XasZWbWfiXMLEaJNZaERAMALTuyk1ss4B+Qf6bxr/CN1doJdFprxLIercWS79SezvLwsLR8tQnqSQClnvneoKo25R3BxgZ6asky/R3V3zO15Z9YzjcNEPLuD5hrChtUekPdcapvH8zFAZo09MvGJXvGVwqfTPR+mGGKwxiHqxSmAT9OK1eojG5ljYhWfPdZunpYNE/CcocClM6+s4hYk3CZp2ZTQ3C/hrjeN4fer7MOBJ9bgTQIjUz6niLhggWxGg49L4g5cIbyPEgxPtrp8R3m8V8bUJn03Q2qS+fL84l3JjdIdc/wdx51gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAcshkojGGNyzVCZdDXvbl5aLyqMYe3LTsLl0Ke9uQACAkBvHPPW99/G4dA0VTtfuecssXEn2g3aVRUMXDW8v+UOhDdySy6w0vkqwwjCBsH/3OHHCVZAudDI8dcotu7Wj9a9xPGU8nXa4jude9TvpOb7jKd58J5gge6Puj+fvlGV6mTuFuYa2trmOv1aLzqYgrfoJxynLxFgZM+ecvSCFhrmkAvjFM6objSP7H8HTJ2Hw6lswXQl82sX6ssoZ6SImiYJZgWYjortmMMDCtOfkBSSjVDFxseoJ06075oaHEdTHDlYV7sxuUfcXY4Z/W1SRE3M02h63tc27S8/Xj9FyQHF7CV6pIAwAs86zRSTKrCbmq+fvH/hP8Zbi4Z3elqLPit7ZFX64d3MBxdfUMQJzQKIjZVn8KPIqorOwx8t8mmwkMmoMaelm37tXep2+1ryZrp9GnpfWfX/Xvtrj1i7eRYkCBdqjzsCzuvLhEQ2h5q7LKbI/3E8oidjQ90j5kz6p95BSlawJXuqf//3t6QY9WWBbUFyeWn3Dh7YJa7pb1r9Uy2RG+HWrxW3znN9YgWgW1JHyz6f6h7hw4l8yRc3+rQ40Ofe4FN5+94xWmZIrpL4bQIAAQGsMt56msN8lYu6RYf+tX69elIRyDtWlUCoec/OCITVeTsE1Zy3qeyRvfKFauT03BDFMLc7h3nLMy81+GLUnuhFY6xTUKJeuvfW94tCy9w/pHQx7VvpTe7a3j4vBcnuKRbRXJqrlko5vXJ4uTyyirODkwwuHWZ5eVQvRMRXsbTfZiYZ7RUXDSUNUu7yYfzT1xiSU0Sd3gsrLOk1ZSLAU9GYsDCudsS0oYeHk6thnW1KR1d7CwdZmFgN5kfo6NHZLRnKrKzuUNXZs5JyHSr3NL5ZaIXV5mOX9gzfeKstXO+XrI7bo7IdGcZ1bWaV1uJphpxgwAXdDmMaigGEz/X41/hXUtCixb0+cJf6y6zJuHGsXp5N/kGofqVYIFa5pCW4Zy3PWPVliwbs47JtyN+5qqTefau3sNHVrAytZea+MV9//Lu8SurVdtTLpylsxIFbTrfZXq1RpU3GZCILYUpvqdWNcPd54NoFW2NpxeK30dxH7Otf7zinz4UuLUXtHYt5137+KqqU3ieuNY1BzHo5Pqxnsd4kzKYsWeZ8+MvXOJE79wkh4cJ6Ycovn7e9YHKWNZggxqy53Cx9/b973mIcoSSxeYuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAGxotLIw9jcNbxGXQh725bjiculYeAC4JE5ZKa8AFkAAEAalO9fqxOfQPqGQluf3+/TcIOS9IbMFbnH/NiCp1nMkddUao6QVy4cstWVdBIlqzuF7SYb2R2rr25pxZyvZtlOvT8+Zq7r2uSSzFbbGegtO5W1mper2fLH2lirBrEvqK5san65tQqNUqkYOW5Xu1T3o2urV5ogGLiFGtcjSrXftZNGIZFL5ykpHdY2zDyM2IKY/WWreBe6sdP6LX3S1CoXYOwjIh4bO12GK5Y2WIk5whUNUCl0z1F0UN7KoD3rX8nHmTlmZftKf/fYcMjl/f3rNx6vqypmQh8ATWsyPfkYArr5vr/+BBrhkK6ma5zh9S2FTr5lvgiaTfUITNndK9xnlx5XcruAoHcPN2LTofbhpqfU+FXjOcbyxQGTGaZpEpB17b+Lbz8+mNbV0qno9hLb2CaSbitxyNyfaFK7ZDuMMdkQ825wWVlc6njMEaPTO5+zNT2BJDZH0XGcffzqjNCjsb7szm4MseA3uqYqxTYzuDFxLebEOIs5fqWG4sKWWX9MxcWd1mrI/r9RbOULbe9ft1d2u13xAeo2NO69NvNa1R3mBbdXlb+uPBjKMIlgBACvKN00287wNzvQUuQMLSz2Pww/DAuVXHCfbLxXzCaU9dTqtsYVRK6eS5hQCg66raLhQm+aj6lfbT/ME+3816Yu9vholriBLSWSb519b3TckOsG9L239V/zvX+d5tHtXXteBPlns8RUeC/iZxChQm5UuD+7nNqvg7e2m1nKQtVxiQ30Dsb3/V/BPVHrlnZYdINH0OV/FqzIXZ9+4y6euW3kzY311pjjOzqNlQnJPuLStNytze5eLDe4izPYEe8bX+62/iQmSkD4gxYX+m/OYto1Y0KmK3vvMIASIAAAC6bzRb1mQpm+yfOtR3KNSqQOhl1bVF1Dxtuc622wPFQqWNY8dFhakilLViRLZYJINGxZ04wokFukJY50jStMNnex93+YWmpcxv3OO5R5PrNL53ut95pBxt8wwmx8x9+yqRNN633sU5TiyhS4V9WVWEETpyFxUUbdl1l9BvRWO0849xjzN9oGM699ZkXpl5jvp24R0jSGfjnAgyu4Nb0g6zCzN7WboWF04pRKlQr6Od7eT7pEeTN09ILBAe61EbFiRxvmPemn71X7d1suo31ekSfMKHW8OPDrrN92hlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAKs5BMBlKAAILSCiTClAAkSicoHYwACvk/ZlOM8AFA4ZlkshiAioFQQ9gLiw54GKCC2HxzRkwBDQHCaGIdIFzYgGBpUwGgBC/ImYjBMhc4GnRgYAyHJFQkTiAhQPkGiI7ANDhMOKDAOIDvMhQo8mpSJgY4vkeKADuhdwnIOlnDVZJmBPlpjAh5ExhiUxQwnRATkWDVTmpac3FxlcoE4TZVEIiJDMBiML4iEwXYeRRpHXIYTRgUyukXFJGpTC5AWvi0CkhQIyZ8gBgfouMYgdKZicHNKRkRMcgVoRQuj7JMiRRD5Rxh4AwgKBEdjuDVgfoHujHuWU3I8gZ5RcKRVRLRwmky+TBmUxjkkBzySIQ6W0hyRZgjIRiMmJSGcGTFpLwtEckgRbH4vDrGZGkgSJgeMjUm1mSyLmh42MVkFUamp5WkWBORkalspIEMNkEyMRLh9ZkswIVj5speQMvCyRRCCkBIsRY+OecWeLpfPmZfQPFiatVgQFAAAAAAegpJEh7Pw4BJbh4URvOK90ZGMdT1gpYsgpdUORqso+pLDlOdCCznet3M9WZzUOKmFPmqv1VYgUejGYjkRFEjUnZUGzjtlYgfI4YJloKnZtLndn6d8cdfSRCncQjnSVzkoJVP5NkXT/ucRZZ2bZq27f5RIQZjuys8qO2Z/+6ZfTtUy6mdRhWyMl/AyaPIMOkgCSK+LbGiJfBgyr0uVVGhKboaoHKwhcABE3N/UrW6MPeZtbMOPXGUMUEOtwY70Wr2XVTJcF+py4+0jwz3GbdKymHYzemqGmpXVpq1JL5ymppNVs4TWWqshuSSrKcn4mH+YluVRZ+qatAL8v6+0ntUNNqrS42ZTKZTuetzE1L5VAUjwjU9Go1JrcqfBlUsbPL5bRy2KzNWGok151nJt0U7SRWlpYznLpVZqT2VmW5ULXHgmY1Wp4lqNS+7nEYlAEifyzQxmvuLX6sqzsxWty1bilWGIMa3DDX52zn2mlUvrvpx+atNQ36vaWkktrv3v3ZyvS6ir5SmKdq/nd+kw/mc3KtV6aHpBhzLX6mrmcKnpAAAAA7d82ye6jNtFpAUG0KjI5QLwzlfQp5vrOt1gRaVZWFYjRXfxYm7DbOvukXUXMkuYudNjf6ut4iPo9oUtcW3b3a4cH2zWLGvWntjL17Wz68GLpOvdVm3usGL7RGaSrY+mh0tAZkcj1Ioo9497SSQ/EkgwJ9YgwYs0SPu2c5rBtTdcva1h7guOrxYlfelZt+1M482fm1r7hvVIxqX4xivxS8Om5b4zE+s6zje7f/V7atDr/JIz+gMulc7+ZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACAKFygVjAALYUMlkozwA7OZBMhkqAAHzSCiTAlAA3uIQuGqd64FfuBBhBQ9zrTTX0gKN1ZBC0e0sG7Xa1cWRLn9kE/D8CRCahyljzkymtSJy0/IMi1HyWOSo3i8eOFuU28MqCm5R61nKJJTZsSlk5nbo8LdrDLmNz79bluamZfhYrxvtfdjnd7y7nT27ct+9lTaxtx25U5212GsI5ynuV53K3aXTLp6fqS/6emt2pjCzexledyUReahd/mM3W1y5rG20pp8RuciOEB1q3ZZR25PFYNrUEDyXs5fwrRGZgCX1q+VFAFeWt7Dkkl8Zm7dDM3JjfdvPT02HN15BDdm1yfo98tzFXe6moPuY9xu5bmcbfbtSzjN08SxnxCgdilAAAAAbrWu9kjJEPRZk4RfbgsbjNmsQQKPFzMuI9tw7PXNXvX470bIpHd+3kIa5F6lMT6lzAevZorDCaorc/Qqmocq6rHYbY3rO5ntWz31LuDHxrLhqu8UrnWJVbFV1W2KkHJ38zPZKpG6iNC7MwnQzp5CR4MTNBUcVjeap2t9PeBWfvFqyFyWv/B9N21mC3RpoTOkMw6Y3FiWiakrfdsvbZ08tLTDk1q58z5TjlelpPDbYkmGSBS8tYF4954bA6hx7VvPSDeTWpd3r4dItoUeF/fMGyxqQDnQJoppsH4ERDkjwFRDiyAmh8rmgBbB2C6JgLMG8HdC1omxAo+RejeFKAoIChkDblSXMiJjLEgHbHIGRA0CABqkGqwukW1LTYUGRgrA2zcDICBYQEhwRGAwMZGqBsQE3IoWDUjxli6G8AY4IF+Q3QIhQFghw8gqkTg4yLDwOMPuTI4wsACiYlwNMsA3JYDGGQGkVq0kEEUhkzMg5wiiJFyuVwt7AwoMGwALThZZDAGE4NuDlHUVqG0tzZIzLRuQc4WSLk+OBAqDnkTDV4ZERAaABgAT6FyA7wWYDMBCAKC6zUn3ZMgA9DHpGpIEgQQ3RHMIYWj6JIkHIqSZuVBBoW8hxAe6BYKCwcQYCIQA0LEBBAoBwMLCAvoASLYgJDkDI2KpaRLpdUZMUkluxkXXSTbk+RcompudQdFBJjNNNy49EpUGbhZIGzBbcfguUHyh5xCwg0TmQYXKNMaQ7SJilyCEXRJwmymXEfawAAAAAAAYpGZgja/tW5Ho8xRJkQUqouCC6EdBxao0xHFxQiLq6NV1cUOIHYr3bZ6nnIMQAACAUf9jWe9GbOHyGdgcQVCqyt1IquivZ3rZSJhwYLE/eevZ1+3fDiOIDBEePaJEO6zK3/lfNT/s2v/9/5qnw+qB8pnvJ7s/gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhFkE6GNkAA09IJ5MEcACcWQTIZOgACo8gn0w6gADhJEwkTdyeHpgsTELUE9OG4/mBkWxZSJsdIKIRkHDlyHkDBuSmM2WAOlIoRUUgK1NzQgwgmZlMaRHC8IK5TIqVSGFMc1E4LlKhdHYIxIiO4nSKjtMDc2UgxVNydJoxE3BsoXAhi4Mig2CQuBU6BGKK5qxcLBgeTJ0iYz5ASND5SoK1J0UiTRPGiyaMkdFzFEvOukK2HcPhiBB8Rwmg/Y1TZ0jZN1F9blhNlLLr6mRIsmapF41KBYLpoTRJF0cog5ibooOWakUGYxsbpGimJJJ6JdTWtYypVOE6al4zMzpOopmiKJigkXlrrdukolWdSnTMTVap+gpbvXVzZEnndaRkaOiqmi66k3/pAABIgAAAIyi0OoYcOzNMOMYqUNEhCwmFoHxJHRQBUKCKKBMIojqRAsBY4qLAfiMSGCSjoqNKDx6KOkxIEUeGw6SQ45UKnTTjQ0IoSu4OR88oRKkB0iRGw6YznlD3EUSQehgTg9HgdGlRwSio+Kyp7G0OMHwfD4CCALQmGRoTOInFxw8qaYPIiDVx48oXdDVNjUamISHjyAwacx5orMdkMciYOl5pxiobMNZTjDVNnTSh7lHjzGFzShpx6Ozf5gmVj3apw6sw52Y3/sLaMzG3Ovuf/5OpHxyDoIQDnBjURoDZAANwETNDIzSBYgNtzcTiOWH7gJLgEtli3CiEQBvALmAKWAbhKGLxplsiY0C0GWBNo5IDhYNwgoMBwIukwOZLxLjmCtxyC4BiQQZyM0SAzpeRNiJj7N0SobkTFaJnBzQ31IXELSdKaBZNjEyNBc4ZHFLi5x6IwR0AYBGAFujUQgDTk7lIvqUbGQyY4CZEpjqJAtJoCchRhSYYuFxD7L5FiHzU2UOYfZRaSUVCRMCfKY7y+ZIEQMmI8yJokjhFTw5pqiTZfRWdHEimswk0oyNCoThmXCGF0uG50iRPkGOFRNZPGrEVHkiZNIEWKZTJaZprNDU8iYHUjB6z5GH06SLVM3TNykYoHD5DlIqSMDhuowQQUappmifJQsEEPk9IuQw6aqNXUkY9SZik5tyAAAAAAAAJk9R2e6iYFx1GHzEPIDxGBtKjiC9xgAuBEyj0oJqTDy4rC2RKpA65iINR8KpY5i572OLkjHoYRD8kJSY1qOYzBeFiYaHuMRmDaPBCjUWj3uruhjvJ6schdy5E9lkZxUfj6l0zx1CxPzmVydBUPORDsl0nocTIdsac+h9DesjVecTmHu7I1DLoa+phzPzdv7EHU89zUmo9X6/Z3ZaFaG0+7Jt4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI2opKB2MgAsDwSZTkvABgThcmFYwAC2XC5VKY8APdd3ZQlcXJLgr8a6h1ATAE0HVeoysOcAE5DZrjWkikUnrMgVHECwHfAr1ugKCLZKDLDNjYq/TktWkznWpGLLQzB2bcbdV4KdW5WZqV+3RWb+cu2+E1qfk2PzNFS8ZBF49J7Muuymy/MqrxijiuViTS6epH2f99XRf2LdsduVJVhWr4v7AtRpO5mW1Ld6mkOtTVPDstmZbUyt2pulr4xl/nWi1SRX9Z009Wvw9PUtJ2vNX9S7KnopTO5Xsv5axpq7gOtMzU9ldxlmVu5Lq0FRWGpdXpbt2lv2p+lhive3OdjDXnWZ4197b+NNWkkdr4zcB8oOSyr3kvvxv9XNbs6u2MvxqVuUu/maSZw5XvSrHCxenYlf/WWstZ6uiK2AAAAB5yigWaTUQMltgVDIljXLCtrhDmJfNEUqC9ZTtdRH8GJd6oJ19qtv7zb4hsMbxYus51JlKxbZgQIE1q/UusY3Ruvm1qRI8Lwo8bWpYcOfxab/zXO9aw9xvd3uMxZob1ggYiYYmbvGV4wR0kooD149iwaVxemom/A18wJ4kONf/dfvNYOcxaX1FfRrQtwb1zNPj/219bz9/NablrGiRc/++K5v/7X3XX377z8QfvWtbl+5b/ed4+twxLn3+XbU3DsefZXyRKVI0G8ygKrjdeQxyjjjtWHqVQUm8LLXVazbVrlcZxUCgCAJy87DMYDVzSoc1vymH7EC2orSOoLFk7zU9PVsX6uOdhZsUwsUjuxSW921+WU9qbqzd+WVr2Egxwj3J6i+FyKVu3OWZXQ29b3ljVr8ryrKtfu475hcvfYq/3tBZltJMTVNe3HrzsNYh+xZuZW8ZXcl9n9a7PU25yzNfjzfe/+Vq7AMtoZ6dl1yhzop6jgDVjGkjsToPhjlrueVJW+5qrDsA8mpygtwqBpTX7rCXVLrlyGXdxrSm1Krerd+tr8M5m9epOzUSoLX9yu5Ws+6wu41vlse7wmNjDHcIAAAAG5W1j91wYno5Ln6V91zOF2zvVbRFFyBqxLaTkSrJBiqqOpWEfZWY9HC9dQz7SDcmb3b9Wy8U5rbtAbGNwvudvTUOkaSfKn9/LWIxtZyTw4sr5vgXhw3KFvf3reMNUy4hUjsHmla4dtR3sRT5YTjTzE+fnUwvowujKhLFG1W1IcTcGjDSNGi0X2NamprNf85+LzVu5v2qttQ3NlhQM4vPekLFMYpS8WunJ9OkaVV0X2tW9njbq0aLa/3R7Crp1euc23Xcu4MGtt6g2xe+PWmK/U/4zsiL0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB6mQUAZSYADy0gn0xrwAIeYhKh2MAArzvWaTmPABLI5aItBwmz4egF9g6MZUawggXwkJAwiEXKMoB2gBsgBRAERGAXSAYgBYYrgDvgc5BUYboPxG8MgDcAgAeBKIYmDBJJCFR0k4Q0QXFxkkcMCuR4rw1SAl0qnTJRUOmBoRch5MuYkBIGRp+s8iTJ8zNioQcsDmDLDKjmjGjGIGyJYSHQTZPDuJ5COA4aGxgaEyHqhqkn0zdlGxgWTItGJqUEklNOO6DZcLpLGC0SaMWSrMKSCFNNegkpBaaaDKNEGXMTczWcWXjFFbLUtbJorOPqui7qdJz6akEG1NVTdbaHzZBFNJJR1Fr166Xt6U4bKW1aer9f+AQAAAAAABM1oLMjdAcyCaBobiSgeqA9gVAaiJVhXBeEMUACiJkS9UoNqmFwWYo5VePSr47DDlV6f053hQzmeqHVlbTFIdruL9lnSZu6c2KabwmaMdZps6zZkQpQYZU4qHBylwuITErkLL+hZLGyadWIxfJKYiLft7JGfRVa6lVp0qZRIo60+/iOplfH3XowrE0yrEXMSBBZYEslYrbmkPUXFM7ze+KZYFY4Ier1DD3WO7VVWGslrYbr1evbzQZLT51/neou4lKOec0pn7xe/pr0pr/p569VsJ9u1dZznGMf2zXX//9c+mMbznfp/6/5/////5SxszSW1VxTJ9DJFSpOl2VbYcd0kAju/TKRQ4XEjKPNNQUwH3W0qqX8GQmobIXdaDA7Co68sqY038snpXFm7YTUlh1ci2pTN3YdooZhmzLo1Eq1WpuI9lNmpWmIanuSS1nuIwzFYZqU8luwaxF2Z2q0GBqsZZ05T9Va8O2dVpTKatPKoefZ+rNTOko6ablecZtyuK0VmgtRLeF2vKZTEYrLccu0tLM5WKlNVfaLTE9axlNW/VqxWM87uxqklVFai1r862VBrVNLcaSjpuY0sctX/uVdYcyv9uTti1g+kDRW1KvytantY9mrNepSfJKKxTd73WWX49wms7Gr//zLuVbW6Tmq9bLtm///u9MJoVRAAAAE5nYvWPIbxdqciSHq5sSlkynJrSquYS+lhJM5pMnIsKGxD+jzq2AzMaFN1r2pr4su3u9V81b/5Ts25LQczRYVtWtXPu+3iE+Yo0OBqDFy9iNUaFrNYsGsWuHvg61CtD3NO+tWHrMSJFu+sonb5xjxPG2/hybxL94vafGo72u69/Btf09v/71xjP3rGL5ra+d63/jf+sV1/rGP42ax9ax9Z16/1rbVf/mvzqmv8Z8OtjaIn2jmf2zuu0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgciskDGHtyufB5dCWMbmDyKyIM4e3LYMKlELe9ucIri+MWQzRxg7FMoTe11G5QppkVh6/KrgLAglWq4LqRd2aRh8haq1mKYsmtzcOOC4ghEq6nsTlI+cIs/DSEl9nVh3K/hUtUconXRh2pTwXTSu/hS3wpYUl21SV731atR6Q227ELIcDNGhxlzG3q8PMjcxEyQ1VQq1jRY92RlZLT3ZIangavCjZ6tVaJVrLt9aR7Fkb2iA53nZjljlib2XLq1lc46893zEYh2LTP2xscWdjgTmWsvzFXLFlWvD2POTb2aZBKu7549xXL1UsaIOFubVJtlo/VDa2s9VQpW+ExKF9GkpXbBE1CaWO65cdxLNlcvU3D9cvo1E7r21nH3uKxRNlmAAAAB4wXONskVJj1MwlaFa15Yq7HzJSHQ5216W2Ct3ITkjbSsl6nTJOgRvuUnYc2MPj7WmnXIZgQ3+1Y7XIc7dz7dVc7F9HatM2u9SY5m9ba6ueOHFjut2PCN7i46YLsamvOslsVKaryDVt07+09s5DaJ31ztkhcf2/Z8/tc+lpXwq3MxqtHmo42evKKnT0//VtSvN1eWrt6b7OUp2di9/MavLm3v1O7qR0Xfm/1Mn/7u1+7C/XrsLKVsJdI3EZi2spd5sIuFPxp/ZqVP3GZtVAQhlEpiG7b0qX5xl4J/DVJu83B733JlXaOrDtIm3EbWK0xoVOx2QPXObtVKeJYuNjILbfVvY27UaeSOiXCHlD7xfnyvWBAF9fMqIIs4SvrpyrHg4kxTUJVnW63efT6ApWSBLBr8LzuSJ565vRPIcajccNl+d1VyeRVxEnhVSCfJ8jzUizRpWBW19K0uwrR3KljVM1VevM60tISrjhbE6qIrikHBLyxFaoU1OhWX6ePVLI5DieltORifQYVFyxMakZ0e1QVI0RWZMHxAQndYUBajMq72wPm+9T/jxG27yWHZ/me0sNLzWmxD1TFNtkK1K5gABAAmIWlqJpZiJHP24tiljjiVphuUZWRrut08bHb5WMwk+4tkXM8WXU4qFYhbFCi17XaiiPCrHeHXFXCrNrV43hRWzeK/W3IzzrVcSHdkVDnFgT1xq9M+30wSMOHz17LR82q1F5T+lesv4CgVc8rpRStpdHRNbRVa8s93Zvj7etLEwqqPE1asSPF1m9t1xpfdp9BVrMpWCFCRUKB3mXuvb6z6Y3C1NK1YqwJ6igj01vP3JHl3vDfHfxaRNwb2pWBAtu73UCsOj5/HjZ+rVbIGPfU9ajyCZsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH7orJIxh7csBwqVQtjG5f4iskiWHtywNEZZCHsbkAAAgAV535VL5NLZfgQlKN3dbne2rNK+xGK3OvzUmpYxKe3Ca+5qX3IEU6qNwTot15vc03GH84/KEaIYkMmjt/Ws7WrU5blVuay5c3GicthqbJr+JHt8bYMxHzdpVJooEIOrDjPiDT7+KXZVBCN6b+HjEk1PMuYCdV5f9uThEzCeLmOhx5qOC479ZLQ2y8ZodsD9As7ezXtaLWzhWNWPAhbPUtsOKvK9M0YoSpZ0Uy93FUpfi0eQ8tUPB1v57QlbRmaoYu4/kjhxka37nRgUqeTkR+2PV5QLMqljWrltcF941tG2FsONazudireBTTU5LhhrGg6i+9LXh3ixeUZaAQQAE1wlbNqAR1upmcK4fRyz9C+Z/TZrrt4+H8mANT5lMvHbIg7E5Guv2UxRmiHaVZf8/cphz/z3fN8Ym9K5ZYm+zz6w69JWm17smuTSS8cl27jamGG+qhwZMtcSNrBIK484HSeGpPNNlLmTS/OmbOsnlZgN/L+9tN7a3s65/rh7gKz9Hm+JrSxl1lvo8nL9e25lrLWT4qWvM6102R1fb+1/pbLuLpgf2LO1f8aU8MYnnt/HKOLnW2o73fE2KngwAABAARSOs7sSpUCWg7lmiJ6rnl7gDzpT7ra3QPxfzna/1oYeCvDTqMnIou5dlvbeoGtszfxfcSc3KAL93Ghne4avSi4rp25OrcZV7jyIfNS0b5+8v7votapqQ2XGLqePHhu7a+flq01Ftmh7pp7ueMssNuqzPbnJUJxvmiQGo70Ac6DiT7pi8OMwRm9iRUSjNDZpX1oNZn0VvrD2pI8jpxsxv21XKdkOyRWODehD5x0/LebS7ibeoFdMjTPBVLSplGWZLRMjiiNi88mTjItt542coira4K7Tilw03ZKvWxZqsNKuc0Q5s0fdp4076JDtRE008Omts0+YbhakuDCzTYDAAinbhLsSBD0lf/CZZv42NVW/JvNcx5cQGYPhwi7l8jZ/Z6fySW5ZdXpAzeZFXp1kus28++2n0u0rMzk3grf55w06Nlb+3tPzMzS7By2ZT81vTkZCRw6dCNAengU2PxxBqnCpofyw6do9iyb8xWGzjd9K9divSepmzfoIEjzmtLS4weG33p94pbZfvM9XKX/mnbpBOH5hrdZv/5zNGXfcvmXbrdhuBnN2rlWE7sGvUpScrWvuXq3BHfu2buQUIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACBmLSIMYe3DA0QlkFexuYE4rIAxl7ctnxSTQh724ubtZZx/GS2UQSi1Lu7uxXvzQg0203uBa/I0r3j12cPp4m16nUbYgYJxmD5uHtSaAIVZaZH0fmfwiIU+NPX/vZ21NVZtYe1JW7YFbqM2qpj1l/J8f2rq8WNgwlocURnlrHi33fedyvVs7p3KNuBFmwqoLpola28xUMjKyPBhNSpnFxRZfnCEyKWSjhtSPta3PIhy8fjpqi7jzKNhcd6+dnYiUKOKHh03pViZqVVeEPioyOpySpFBwoCeeFgu/kalefkF6onStBXlwgwGpgjqROtsJD25hTUM0kPSzkdy7coMrY3XUW1c6S7ArTxixL1ywuT698y0kX3qpVeKY93WosGHLtNbADIARznQ9IUSRG+fh7Br3WPAXX3ryYifMaKLGyvrUzVqxiDpGpCJly36Ra2ssxI1uyIl1ZcTyhxPTTJns6jDyzN5f0Bwt+017JnJ/2kzzrTsdfolecHZchRC4yhqMVpWEsWlkRoDIcIcQj9mOX+zW60R0PFuu61TZntyc+J9lcvyVZ5VaPKG8srBLKx7rPbNJ/+ihfOovcIjs5t5rT8pMHu1Zp9tiaabl77bCxrz1aN/a9MvlKtOxXYi++d7gy8mUu3STm8pbSgyg8azhRbwj16Ik0THJq9WsVWyw/biGs+XKz2yOB3BG0nHwm5DbkMqe6DF+2Sgx2ZC8U5hlVilJWysV5ZZok2UWyfZPi9YfPIlXBuzbWoEu4k+ojxz3Ll8/cr4zbW9ZeTna/Ru4lI+1Xl1dL1e7ODxF1hPZ0yxUabJcmKOmNZiN0DTxEPYjEd7GuXJVwUPgReolaqJNUhUu5E3UsVwbWKlVSnmQ6k8ezxXuutqRTR2eeIiECilywQlDCy2PT8DaFqOBngIe2RlcnJ30F+k3BAvaqo/CAKVsco9nNTLurFl1hPNre1RrwZ1FEgSRcyUpdVxdf4vR6+u245GMSAYAGxN83FhgTKvXx8HtT7V9tNTREe/2qzveqB8k4kdYaK2V6UsqoRjmElLO5ayeX1nV0se62rU1DhKp5ekVwjZ3u+IEOSLdUSZzHitx6QdW3E1X/fruDHXPbbxaLLSh0Z9LeGY72duOF3CJAcCfNI7htsB4zKmA/a59wVPC3m2sR3Pbd2zUe1sz3z6vJtqe8ydQVXOEpoLBBZpcQPCtTWd0+Mw6Wvm9apGdUYrAl8W9JInbLbt7w7MS/FYGue3rNrWHsl7fE9fqJeBafb7D1mjemGuszk+spQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAg6i0gDOXtw0NC5RCHvbmCGMyAM5e3C/EUlUFWxuJuXxKV0MskcAS8QyKQk+7FW68cufYHgv3Lbs07L5SmGIrDvd1ar+u7DcqJCQw555Zbg6WQ6/lV14zHEF5VCcM6OVTkdq0UEwLIvkbXGHZaExlStR2xTxZLeNC+n7Lms9IDkxJxNpCrNClf2gWt4F3Zpbnhaj+Z+3KxKXhPaQXjJHyxvUOYHGCqU6Y3VUJyY4rHJGfs9ocBoZjtgoF951ypXdIOYrC/a0ghxdStVLA9junJwL8rmchrpUl8YoqFMbCzvU68TuISuq2J1mhqxW6OgfzpaexI+p1exJx6xOB7vVfyFGYdtHNI62yqW3ioh1pWxd3rZ7txbvuPHvRykiRvvMe2YmauFEDQIgBJc8TDYkCu56UvvB6032C2357198y7YM6iC7klhzNTjnJmzeNleSR9WxR5Hnv59uNcQ4KkZoGUTXNGL07Lv/eIVG54/8aPqFaLGxNeb21729ZXcKfUrnZreKx+p4TVuDtqalOxj+SKnnOZeT7ezRWeK+ieLAmnhQ2pye1eTTRIPzmmd+bGMQHNwjPIjukd9KyRvZ94k+rQo2KbxW8GsKWnaVIrq5r8y91AvPt7rd4mniu3CeLp7i+c4196jbe3rqutXmr9Zha3PlDHrz3qZhrOU4VMpVDRiwq9nt54/TYQoXTkVPXlerMDujWqY/dpXGlNRuwWUZczW3FZt5twNQtcwmVDky52X7sXcaCXWoiwfnM2BVlesMcMzFXaiBiQdTY1n2vEXFokTquEcO2edyxm0LcX18Gqis9f6t5Z0VJTMXcZ8oY0JqVMFdxUi5kvSZct0U+Pe6gVF4zFqY+EPds8DcKzdibwdX1CYDXH8aNXNgmYb7VLavrR2D/NlIK5hQBb36AhOJzsxblzBZFmLJEPJOlYumFENkWKuG5tNuMbsFjTaflYCCFWq1Cvs810Rd+uFdBUO3JGabIV2HTG9ePWNslZGJQpSJrOswp84Y/usS7bABAAREIrcXDNfGmIJ7IVix2A1b+2Wno0Cq7YfTtE+psHS4YLRTraxA+s22GNyVqqUKXKVcbban56H7ocS662q9M03N6Q1z/205Utc0serzBnLix5rYzmkcaoSDxEVQDWKYliWuKZwP3Wx+NhY7C8dJ46LXrIXz05s583bdue3ZPop8+hqvqy9Sts//r9rV163vPCQPSe03vltZnnWLY79IoVVnkzl7QT80jemLZpW0dL9NII44NdetTZ35zmFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAH1YpIgxh7cNfxGTQd7G7faisiDGHtyzfFJRB2Pbjk/y59bmdKNgfOznru7MhITl8q9qPzWFyZUvgfl/Cd27soaethW9uTzdhh7cecm4zuUIiqGy+vfwj+u0tmxHvwzSjAbpjPHE/aK/WHsk9IFa2vNGbmZx1s/CQGaqqw8udo1NfG7OCNRcJ1a8SE9bbsVoTXOr0gmo7LqSWO5sipKssZJdNe6YeeRlj1tNDUjYdDql4sZlXLlDnvEv0QUJeosdSv4jpTSTN5YHicOp9BouD/UkGSPlNqValy3x2KkZSnS2ktV0uGRLRUitotaUa1FdIBUtKvViIu89YbbI1KiFNhIQWilMPm+LNBgwcqbc8FZk1a+6tsCkBqQSACQAEJGMvhU+en/S5LSPjLFfDYHRTeu+rCgOmUTJdJZ4yNtawXNNawg1OVkmJY2ruUNjbd0XC85C9YU4iS3a8a+F9X1tp9UrIDEbWpTQskBbkb+Tf6zOWfL5W69TNK6YJ0NKtjdWDmhCWgEwqMDsB4J1Y1A+UCqkiVLb9C0sccK8MDA4OKFCQh2pNumcv5wZy+xhmgs42TVCGnXPKaWUPtbaZ+9aZM4iIyhsv3sy/FnnEPuOXuP8Ppuq+V7n71JctR/WYGqwPO2+dohNHft7Z2tb35bMAdrVvCpYm5RIX/G1T1yilcxLZ55CWMUpL1SWVYvKErovUnM94vNg6bfv+1uKzrP3WwuyRvcvtoR14XKKtPDWqmr8ud2V8kKmYGtaYGB9pqw7xa0SaPAgv59KYv8FsYyXaRycbonc2rVsb1mHRXo1ha538J45Q/HmfvaMCRo8pm8DeERUsBpLhqbI7yr+jpweRIy4fvEIeQmuDWHdnkvqs26vVW/Q+8RjmZmfauYk7GaIuWZhePGaAy1jwZ2+rZVSK9vXZ1Mg825Rt2X8G6hTSTRqnfPmPakQa27hNz5ijV28mR01MPXFCXmM2kdz7reWuX0dqd7+vi8O7+JZfNJAJEAK5znrwpaVM3OhNXq4p314Ha3771UwKW0RhtkcHvlRvO04KZQ2W0WZLB6qYOHGxmU6omeMVoNWyet6/dK+JRWJKPjat7k8jYtHk+/T6xiFphVbc1Rr1Vk8qpZD2W3KadCNHSqVtkUQ/3o5ku9U0Ndv6Ylnta9crnskDV26sD23jePbGo0+cQIVlKsQfW8PV7P5sUe+s1fvN/ncSFdW2cbTw6QKa8d/JJXOZby4aqNsFcx2fdoe9x7WjRvCk73VvStp92zvXxWmP6wbgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAKBYrIo1l7cp+P6ZQ9KG4iohMojD3twxlBpZCGMbsAgBgAV9xpMsRihZwJG2aBhADfEMyIOapIFH5yyRiDkS8qM2F2UFxAQApDLFUATMNMsZBnxAIglcqPtwbjAjZgYQ1tM1Dx10gWpsrUzXcyx/rDKXneBZBd4aFUOaS27+SBrb2TMhaezUnA6y8nMY41hPVwl2F6tMimTa5OQhbAQgetXnhcmSLQ0bxwFvETKWEdqFJxhUi5nw5JVCi8KxRl0b1UdUSqFPYzU3qKzMW1VKJhZlYf6ndjAPUtyGq1+2MBpsjx+uGp6+ydxA1IXNQpaFDUK0yRWnUN5HcWZJqhjJIomFQJSZVrMi0lEGyNL2KpF5zMh85s6GpqiUkc2NHPY6y2mi0KR4j2tzVyZe9XsSnh0NJvUx2K9ONqifp6rMzrpcObEq2KFJPHivHt8tU0CkdgU76G4299bpLp5E1CjN1IgYADvL3bHr6bMV/shBMxbnbMjdJSIn2BG/ay77a0HQZzlb2yxqF9CXMSdOofLhteBzm2540rql4bTWD8JgajHxlOesLd9zFWk8KYWeXNn5yKI5TCIJBVIoGpYfAJjiQ5Fbprm5niYRYG7q1REdfo+1CAPykae1Gt3XEPu56V/5b7CGQWd1xksTV0tybm1wO1rZG7SfeIk7SNFT1lSxEQAAAALsUlUgYDdgGZXgEKZEvxkFG5BgNpOQ6Hx4l9JkIOKST0uYuyMGCcZM0NVh5kvFgPE4xNS3o9Dke2nYQgyGSWcWUkZJnAzCQH4YhwOa2ozQonEAfhoKBuMgsb52nEY8LYTggg/0edZJ1Gl0KRjIkR6y5hxl/R6vVb5DIKfNMb5b1eq2Zjfs7tzXc76Ap8wE4figcVeX9UNjAuH+LMjJH0wNilT55rtziP2OPDjtb6JSfEWm2CDW/nYFArFZSVSIYpF3CYlIwKRX2gPHigeUeYTkzyAd6vW2xP+PAZHC0kWBnD9Vwl04RrQfFiWmZXOI1YdwWtJv5/u8DNM1h5ZGrDXe01M0gU9cwGx44Q45OomIrkAEAAADuigwDA1Q7U89RZ3tWDy/q2hpe0R/dj+pesD4yJTbUnO0uXjeaSPxfWe0rhn4GEl0y0zXrz+NfspyeSxLLba91t6522Zma9St0zM7n69ekWVX3Tvvw59tfs4+t1zElnUknUJdoPSJI6pUmS8d2A8qL1jOuR/NbVy8wdjN8OJSVp09szb9nnL8rPqUhTFJReHHa0WRVq5W8N4Mtt7yaFg6e6+f03h9in7tdtBVe845W9c/fZvtsnuvN73gprLyyT6Dm0IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACKGFSoU/AALAL9lwozAAa0pBOplJAAIISCiTBFAApg/nApVpUNzkaSi2rdEuP1UsCEqtlcfWcp2k0VhwpVCr96Sdoo4rEl0wJwofiMCT0ZYS7NyZdmB3scakmYBqWXJdyPtx91nKmGhOVB7cFjq+bdP5Da+g8yp/WrxBV75LAKXukIxMvlBd1ujrwkv85bXVMmbvGtWKN1aC71h0l3RV9XFmo1WmaXGvOXbszV7yxSQ9L6781cI12zlPVvzl0ms2N0sOwzDMqh67XnfnKDKltU0arxWnjM5PVq2VJuH7GON2a1uZzuTc58oitJfkUqh6B9ct3qtfdb6azM2I1VvzlWpL5dG5rOMyi1LaS9PS25Dc5Zh+tzvd9rXsZfTXNZ2abV3lfmVf9U2X0t2xf5iqx0KHdudfw8D2qqul3KX0vkdrWo3WuPbVZV1gxduXH/uTk37xgh2OmqTkFn4Dl8xdYj6NYSSqXUXlk+OjIkmq8cWTciJiWpE1aiAa+euVcjJMTKnXo2TGXmD589Mlj6livLmyoaHDtYl6AdonofK7NiMhRPM81fIWIqchmGLa3T/D/81di/13XoXaNMLuW3q03zNK6065H3403WBbN21MEcTVZptKa1Mz9602JdG5B2xNflmZra9HmWMyA+6U0wbG/DXxSAAAAAAAAEjQ6Vh/DLpwg44Byws6DedMjADQIIgYGUEgkgM0g3YZHA4kEyJwc8nyBikxaxcwuQhyZDxlyDihR6ImIAieB2CggQmGJBcAzBYGUC4QdheEAQ5EMTg2DQ5gNBEGCwBZGFz4euDY4LkC/IZGLYrUaQ7g6YMRCwjmFUfiIFchgzAYrEEyJiziNRHCITkeISkkUy4KWIwQmEAiZGXIOOYThOH0EBZQfELmIAMsLKIKMyQEniBi5UTcuuMqSArcPjFLilCmXxQAoAcAuM+WiZPEuLOGWJUwLxDyGkBJorGRfLjGRTMRymGXFbjJi4CIIFAXIMgJ3dIgYzYzJWWXDAVsLKJs8arJ0WaQIcRZLxiYGJSMjQvFEvHS65dJMgh40SMDQn03WX0ycQZRcNC+mnTTbIM5NEONTUuuYl0yVSLxNLNWMS6XUkn5kcL5M0EVrRbqdTLu+/YQAAAAAAAvSG+myhRmtESfWyodGqxcSkIOYh3kIYcwcYguc5Ki6iLogoKRQ2Qcc9Bc6lIotUxhIWXZmqo8e6IZRpzLMrjQFHOcTECFIRnUCAIID1RilqdxrjSCZ1ExN20I23ysY1iuqonYs2Wrn5rI3rZv//3RV9HNKVH/9137f//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjDhUoHYwAAuk15gOSwAGC6LSAMYe3DNUEkwJexucYjDilb0Okz56VbUmASQQiDhRouU1qBjJEFiASlTPUpikKXxcWdmlhkvmHLWmV2sBfJIaCn9byAGtMZVys1sgwEs6kTKAuI0iRyY2WyAwi3zbFsWuU0WirwF4mvNHWQrpdztOiupa0PS6bmZ3eNBS1Za4Lq0z9SWRxGzHYpDrU/uyWKxW1ErXY1yUw7x3b25VLolGXZq0vb8u1KqWdxzlkumuw9OV/ls7SUE/QVcJU+0NSqrS0uWXZ1+M+UNFLqXPDC9UlXbVLGLeFNypKZ61c3Mdv0+MdvTtnKXU9zDmOVbH8uWq9buemxSu/LuSyelV+1nbwpq0QjW8+w5S7wpsr2rN7O7+GVTdjf1Mamta7n97mFbHYOB0IeUWxydik0sqj5fBS8ULo6DytrZ+lr7UkupWGlC276pt11o9EgnEoCQ/DmAkOSVZ5KSdZORxJSETo6nJNKBV9OTT1bvPe7i56xePtYSLmo2pXNpWlVLQQplS3VtTmvLmlyUx6B5crs0e9scF4EhkIDBJiTulYRj5noLPWajgd2uJDKBplt75+fnd2Wb72xatW35l+llsxUXWz7X6bWnerWFxhtpiX8yprhpB6UMSdd51d/6dQzw6xnP3feojAjQZFJ0OEYYYJ1UjAcApVDgRYCQymY2tpLTW7apc+TsZqy35h9H2lZCBS1RyjU2tYQDK5E5LDHzcWdYy+D0ySJtgfd3YZgWjiL5PXDcCWWtiTh0v4RBX+Ys7g8Vz2tbWjQKsj2Kxs8h5DALk3K20afLi80+hy2emQ8q8fSxVXZ949cubtocFZAiNTkrI7A4JRWqFGtVrt1pJYcTNZITA1HahT/GJWCF3s+fptVyHmiy5c3KW7G/nSKcXTI5OMY6nZfH0aI0PI0aMza7Kr2tkYVyokKYmVgrdWMDEzLbfAnhVsp3LsLarJJLaUu/NuA23me53mzqkb+alNvGpu3v/X3NS0PPhMqEdQoYCXE6bMuOVJRhit3hWpCfWgxH0DMPLK4LbxihR4tx1IpkrmKROS1VjNLFh1e5Uq03VULjrpdTMBK7FCx0Le5Pa7BQ7iNfX6qHARnknZVxzNy9ZjUdG43ZcP5fjQlKyrrovPjh8wHo8Unw5lsSwtcBU712O8SbG5jowocCVWV3x3hR3ipM51N5DbeULXnciotE1PGv/3oV+6tyltvaurpsyUgLLXb234L7rdYJmr1/xc80f9q6O85efpVv7xfactjWAIMAul3QCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH2oVIAxh7cuKRCSAl725e4iciDGHtyw1CJRAlsbm5MSqHGtOLfm50e7UwdmdlDovIqmLeyvS2tCd7molbv/Wu3YGdqy0engrKUxOG1D5hfEuz/JOlgEPTs3PS7ucjvxrU7Lpb2dzkZHAorzQ38fLNT5xbwGBtX9wUFBZ0fEjzMUCPnH1jx09k03HULyzIbO3zRI+pp+hDG4Q8+0ZTIw/VKUi1EbY+rVkjWcYUyKVjNtTH9aG8mZIF9bvap6nGYsR/O5n4llY7lwfZxxzwVjQ+MFySqGQI8dEub1qf0iQZVS3qg4u5Kt1V+wKxsbl3htbVImI4uBzRsH4YERKvpXFVqeFueE2uTpnhZcvR1jM8KMwTvv5eIVtwTv3PVUNmRlTyvPerUjfr9xxizjrFcVrEa9JaRUP8w3t+f6avluL2pibxJ6uFrSURCSYWxRrvqpyTsA3sZzHfP7QPfWNw35BltQ5oyFzQqz5wnkvaa3mlo9sp2SPMgmJaYW8vqmZkIqxSp1VItKkzfmi4rahUapO2ZLzp6G55g7gxbVTzepEXhaXLUizH1SPTeM5eLijBDZlJhDzlb3sZTVUPhOUSeZrZ37nEiUrZ3LAjqbC08rV/r21R5AixIm57P1zEistHjep5IzBGlW58UpikWf/FLY1ef1e51qLHzvMWAkfygzvb3QS3ayCZNjP8Z35SI3sG5Un6CfwqQQ1axe5L4bjECrkdqHn0gGVdsPghQ1iFxqxfhqTs+eaL3N6vSu1hZj8/bmGm7tJXipOJV44O6Tw8wIl80hxDjap0a2xVLBcW13FgTR4963zIrjtdMFIN54tWt9mSJLN8vYuNR7QHzIsMh2seaZ1qmj/2823QYygcE0x0cYcm9y53u7cijYXKH3trcjnZwKAxpXBQVemQxDnjp2O+hKOkFhmgwGaI9erpzTzM/s9YXeGtzP2rtcOauXk6fK7uj4kGLldLtsW1Svt75VRpotvEo56i61PJiWNvVP85gQam7SKAQAFyh1ERaiGrfyW+vz/prcPfLHGRq4fEjRhJQHSdAuc05BYWAnI9Qu06cggW2Y4t1h147rfkvM2zs27EvUMEX4sRHzBcdmevt++Zbbh5x/bN3KCI/L5JLleK6GnhMDIohaRFratMCsbqqM+te6ShnF5idrFJq60Uo1aKvTszvrn7rF51OWOHD9ZdUuWGJ56yFitJn/mz/W+/LxFTTnWvzyzs+I/iz89+ib7LnXd1++TNbwRXte+Nqmnsy7CS2r5jVgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACBuJyIMPe3LFEMlUDexuXtotIAxh7cspQqTQN7G5mpXhWpo1MywchFbGfLNp6tAAUhlGrUZKR1cb4gbS4MLIfBlVExOonRkj5YjnMUCEH6aZ4j1DvIQPUT0mR1Icozaj3cGaqJzIh0V6xRGVUpKTLgq0pGao1YimY0qhytXkOMaJGYXTBYsUeWE3P3sR89anTE8U7apWbEPMWreioe9Rn729XlJd/USp7MjW3QJWW1IdodGJ3maloOoEOJdxmgZpSkfbcxQWQ85ZHrA1qtyc1cbyLvZyZlGzq841VDe3V7IsWzFd3ZoEIoR3rhyYnNuoybsqV0rEhVlZXivQw3EPpHq/peEoYErHGy1JSs24TVFgMUsHUeDbEauMa1bNnkEWR0UQMQAOQOrfSAQMiP3XMTGfmJ/Xe86+LRI0WSDWd5pmVb1OuTDCZiElU5t0ss962v2l5DesXWRMl5Zal2q1m9vZavWCSx0dYV9x2srtaGmfV7LrcRQmaPqsUuf3k2EFRRqq4vByy8tMmBrNHCm41Bt370eiqhHcwEl5hCT6eMZVq/bkMLKZerlccrqOtjWte2ej2Bphb303KX60P9dYTztrNmvR0uzN70tj+W1ivSspHZmvdXKd9K36a+ww1FPZsUdnLZIifZV2mrW7sEBcyhV/8a05uyDXWK+GuRfdV6HIv1e4UkwsIzaklz+NmfWo6SwFJKX8sWJLPPy0ipVu/TZSi1KJdbxvS5l0tni8iwZHsF6xbr8Zt8PMwlLvL5D1QOJbQue+n2tWvvVnzJdDFd3to0mZ8YWYOmXEje1Y3HrDcnJDjkOd5B9vrLIyt8WtdKphXbizTx3zd6PXms6orSGFxSlWJ8+1EkSKAUzqMnlLRDCwzJvDAoVtcX2q4DtpVieaIqqNVZUSsf3Taw+2lDpvM0pJQKlUMqGMjJ8p3Der3LbJEhtrlqHast4+Y3pvVYTyHE19ai4p4uYORKAAIAAjwLurBxmln8Ewe182r7xFhapfWLM6uixlpfVLi1IYcWUSz/2HkUWm72lgS2V8jg3Zal/GRhDG9a+Nni6lK5mS3e14vqS5Fx+dub2favT1JbfYoSUJZUpLDZXUyjWISQ6IoLOkAczV4GhqIJeAqOayKOm0v7Fn5X6pXnUw1Uxba1/nJnWLn3EVyjzWE0yVXXd6TFTXempZy1fclplVyUuE3L9J59lCGtr8TLZszx37eY8i76TM5al8zpydtzLGLr2hvR1AViSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAeVisgDGHty67EpFBXvbt5iLSAMYe3LRMSk0FY9udy+exrU96ZC+YavZW+6rwACkyfv285ReuzjmW7tJllkptG4S+8VUOflyIkmXJsK2Vun3kwiKdz/Ozhfj1V+ojdy3hKyNqgU26PmusGt5cZpRuoxMjM2Rbp98q3Nvg3xryQKbrt8hp/ztt69uvFWV22vHWIz9FTw7PoPYKM2pWRifW7buV6wQdL8HSuQhO43ukdZlxfWrxGdqdHzFcITDCWXTXCURzwlC1Paj3G4zTUj2bp2SrY+ex3+pDpRR0P3Te5skW6OjxWBvthD3ikN5tNRza6OFdOFW5whwYkBcOFNwdPYPgYzJu14b34zmuKwfE03KAQCAAKqUhsLBFXf4Dj3jGdt1tv0br23naIP6erMUDSssQvt2jJbOahcB3OESuYkZjhPGd6qrRX0RhWWuVlcr2Zoe82t/mPEyhrC4vGZNHuW5Pts8udOfpLDxjLx6/YFwlKNicTzXociYHEnssrgT5RlCulEa6jJ+2TuC2VrXFTt7ZtJDXTM3PmqOdkVKtqVjMOt31/BniunFQqhLolHL8Naiqd63Tvnbi9cTj1FxGlzBxRuvSrK5HeX00nmc4mvVukq3R4Tu7zDc/hLU7dHfw8Ui5vGtiunB5bGq6u3xVNDrK4Z3bE+XvxKLoV+IZcr3+5EUGm5Y2t7wgIaf2T2ftTfKGKwPlf3vczEatI6Npub4N7XT67dblOWr3X+bE9sppp7G1Wpc68hj9+UMSJOREt90zG8jnbPrqTWbJGHJDb2ZVvkLRlX8zjWk+9v6Y1Ajp9uiO4u6WfX26tHk3SBBa2rFd0YjrhMCvamCLfOdubmqYHebjKfTrWcOGYNM3n3q64OxmYpnbmpnzy1jRiSMCjlZ0u/Jy5Xu4q2S8dsePI7jVjVh3KJDECpZbqmI7lTLXukNctWp1UW4jnd4WYWGp9DQ6M4Lje4rA3RmJgliUibiNcK00mqU3jeO/hxrKbbICAAFDsqYCCpn35ONVazaXZ1+s92UnSlaihUkto6PyVP/cAHB4052ltpGk4fsUoelpSJFTvnK+6Qou/mud58Z49XGbR0sStQwY9Inz83tPn+ze3Q4amaHjgnmHCOeKnUV8wTHuyMioRJ3tBSlzU2Wd+zSvNapEZm/6nswuUeG3IxHt+d2prG8QImYz5ZWG2DVhu6WWePnFXOeF86p95h3trPrhjcI1KYxSeNV9XE3tCe4kgytOJvCm+7+mty1pum86/xTdJMQatmNUm+Y8kYdMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHy4rIIlh7csiwuTQhjG5fFi0gCT3ty2REJNCHvbkAgAAAU1poIpKA5QiznXQVm3cadn9rnI98RuSL8s9UjhyNpEN3pWl3AMtgSxbjs9GN1sGOU75SqvuthMWePr8UlFpkVVlw3OiyatsDKyX3eB8Xw1wo6cmqxQjRC8c11AcfGznc+cwGFlyr4TvNbN0CK4PGzV4UzVCvPK3sjFVTF9jMikS8SldUusSRK1U8ZTR3SPrSdhiUjPqwKtQ7l0u38V7CgQqMqUhwpZkjIvs5yqlX3dskj1URX7xuyrlUpcJMv4cKNwxan6vZ9n8/izOB0q6Jg6kfLWdza7pZXzOLiyRFY/meOEZz39wYWZIdY0CP903jLXNG3ETJECAADfWfweZUr7JTCO00lHlKkeZ35pEwu4xjWXAuY/C0xNNExobOW6sux3fNFpyuK/H2raGCzLX7aU7PpfHWEPXYCuiERh6imkG7bMnbJ3CueDq7AePpD0yEsT4ViU4eiQwyfThqHqaIPNMB8HBdayPdj0zMlaHAQjplpkpmrjFc7Jy+rWJNSla6G/d1OtpDRdVX8bEFfzLTX71Z55PFhi7LO1v8NLsTy+OvZWBR7tF3Xml8vVe9en3pBdg6X2tGjbk9sv9cwlQ6aoms0SOAdKSs85ljlCF3eXG8KXCmXh0atFtALqWBFGWXclBLiJXYEI9JHxno2LaEp181IUVsX4D2FM1KtWsTt+zxYzfQ306r4UKDXN9V9bOFJWfbeqKl8JIRzDWr2JH93tct2nFcNCt8bx4ep4MKejuivv6QsxIbguzCVqrPtWw4LvFpHNXPILZK4sy0xKjH9FNZxtae8VuPhcvUFiHDfu1Uy7bTGVF5IjI4sadbn13S8r4zbAZWZ7LGTrAiFKSAcTEltrZgp16rpoU6ukqhiqVioUkSNCfZitiFLluw8nXLfAs9hxcUg6xuE9Vt489/uuX7zc9nDqLuAgACToVUmglvn/yl5hZxruHtARVfvHuyyOblDeZyWCBiJlx12wfuDxrjMLLNSPK1Ppp41n0KOxLrNIz5y/ga+N0lh0apINlOqGJxhwd1rPWlp96vDbGR9qbbXBbGZ2rXC6ondQ2wvq89imkeaIFnQw7FM34V14cB9ptY4Et4D6HCpVZlhTvaa1qlM1rZzwxvWxQPZY2I270i4zdih6xW+q+80PEnTzAwQUpmsWZxU0BuvquHr2aR7fcv09ix4et3rbcGm4GaUn9s6y47Y4VnltaxBw1iQlvgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB9uKx4MPe3LRsSk0Fe9uXjYVIAxh7ctGROTQhj25u1qX69XCPgvVJh21ylfAKAOqGicais2kDo/d3h9ELCKNI+FUGWZKUBGxER6dPihrLCRJsTk03EmrAkcZF5wZW+E/aZS/qaZxZIEZ+/hP3H5xvDVteZIuojAJKSBsfezdKtWu+jYsy7SkzbibNWCeR4y4ZYDnDUCuo3armGkSQvDqNNaT0+t1ttgxPatKpJTxHctodGXcF9a09kOM08ko1ueXzmulaerGlUo3v40OKyKA6WfDaoYTehF3aeQ57DfQTYuaL6LPDgH8iFVlsQpwjq1tbW03lHASi6gu2JvvFfTRocCEwNre47fPYTlbd/LS0CFmucaw+g1tFJLopggABWO7oZQMlLf0rAtqN3+PHQ3X1iHLu1cwHtkkSSPTcL60+IuOgHntaHmPjDlfxdKzLtxfrlxg5f0rd/Sn3rfewYd4DaoWLDFB+JYVJ9Y+PqSC5LNoW4zlhkjsJ8RmzJ/M6cP55FSY4kRIjkOPNC5nGNSsPV8wK2e1UyfxZugR9zf1z/SHFngQFG2KFlYbwVO1ZxncGLi0kXdMbzbG3+rNkNuitEuc6kg5hVmvFjaYvTUrhmDB3qJvf+9Y3m1fuNveJ6vqWxGzi+dWxmkfMObHPHdXP5SLsv0ut4XZgRofypGM7O71T6RZ3dZZSqRzcqkFK58MO6MjSFlMsl02/V6bfpxYLeWWd3fl1+no4m9Mjhj4qhZdNbYtOFmRnZ7RJ//7ZmY1i8ZSro7Sw3lgQMTQM+ub4eTQn9mx5CeQ7RdvJ2J+2UZ2OBX6pt03pxSrzFd9rX3KdmX+NaVj9SKRKSbxaDDxFrfUJlVLFNZERWBqYUe2RWOE7bX0abKOT+Gu7vbPDV9tM7XWKrlYLeMdrX8RrMMNXJpSIQ0RqMyiPBLxIKAcmBd22rG26nket+W1m0zw8TNTq+NZe5klfm15AYSO6koGwAJRaiKgIaeOOZpTdzVk3bH/5/ttTXiG1AiXFW/XK0GSyIgakR62c497hSpSG2nVVbnTFfFZdalia19/Fm5ndz0whChXcGkbFa79IGNeBbd1w+1hxe7uwx4agTL5ZTLEoz7eqRyQuM3IaP5YjMOYEu6LuR1eO4wNoZZjRbCq54mM2z8ZpCUcCsdgbeunDD57mBp9uu4sTcnxjVfuDerFVfjpo642K0ga1DlV88+YcCLvU2HPUOFFki71itqS71T0pv4eXj0ffMSt8/OIdqTyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAftikeB+XtyxhE5NBWMbl7KJSAMYe3LSkMk0FW9ufGexM2lCiA6q+NWXwZWIZaKrLsKbG7L5DHmac3RYRu3MxR+3UcqZSXU0fRl0seJ2qOzy6p9O+QS7HU3TXLm4y80ahulh1WFGyRHzbDf6bMOU1daxqZgbX0CMwsBbxxqNRQKQoD/PpHf0T8HaFTRmV48fQfaz12rnvXGo+I7yj6VxXBRuLFD1Lu1WWBVy3Y/FCdirhQoNIMSI8+aYtChp52inFfP56omdiZkNTiSt365bG4SRAO21NM7tXl8zHplmrZlJmSAtifiN622PEhRUICXtrm7clpWKuMjEWtLp6hprszGn53BWOni1a8XLlbFXLOppdS/4hUhV88/LACpKAKAAqpStQGvWs8qnJrMMvOFrP/bVbZVJXPXg1JMFlqZR0MApC9RPbMVaucVXTK9oFJuV1Dz8TESn7dkzNtrVH9OKhyN3y1tOl7+3Oq1f2m8Xr2lqJwtLDcRVJTbI9iu6nVEpOdEdcCNHSpeiHT/3FKy9DkhEZp8v/a9MpP/vXfeVuniH6lx+G46nbmVrjJPXONsU265Zd+yf0zBB06m2Ul+XOpF+StrL7i3YHK1Zeyc7Y42OeetN6Ullhr6ywgvZlsY+sNO5zPuHcZGU+jOX7zqQSIoU+MC1cMdRHl91cNZ3H1nohDb7RqHNsIXq0t+43MS6/YtV3IfWUy+WXN9p4clPyaJSajT9XrOlnBXPdPFbHziSLr53HY3B9iRXLpQk9s0Ua4cD7ibz7WfqKG3K/LXt9d1aOezgqF5wVrZJNE7nFYyfxj8USnf6mr2JecHC14t1fq8eHGtPTM7xnj5zCiKm6G9Tv4iPj5V6y8NJMa3OiyBidn5F15lQ3wG9F5YfRwZlaXs2DkRCFsryjJtdRmNmTipZLqB4Lc6ZHORYcoLH7vdPYD2ZrrA3Gq8g4pJh43RIDh63p4M/xW63AGwAEIqCJ6hszMnFi0V3um0i36yWdQc9xqN5KLn59BQytkgnC0z1W1kqTZiiw71txXq7YsrqXMTTZSm9+2qQGxPozUXHcIsSaBW2Na+MUrnDNI1t2ds8dtiQ5zBQ4l6jc6tzO6osD4J2nEIcz4VS3lnjf6ljRnrjHV6nY9QGzvtUmg+JrGqv2NpidSPHbRFy2x3ilhxnOrfnD/Ukvx66vPrLa/frUBkpDpPGpLWA9eRW+fVZ6ImH7Vd01f7+rw92gUn9M5jxX8OtryYkiVKDkmFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAH0orIpWHgAsZRKUSksADoYkE8GToAAnFIKNMUoAAEAcAAbsZYblcvQ5oPP+x+Z1DDKC8hwLD50H4yOMNPptziIeq82ZCMLh2h5/x1KO4JtUpRWNaNUsOJHjmyc7Y/Z7aiUeVhp/akZMSyp1Vsb+0JsZXVXGJEhv70grFsTNjxIIWaTFV3Ds4MjhrV1ZSC2Pe2Xlka9dUVxDVThDaqxnHOIsCHs74UZQXfNvr5mxW4jt1NKeIznrjV1PCpLeFB9bqlDYB5PItEVplZZFkusWZ7BYWclqfo/xGnSWHz9YgLquXBU7WixvliJdXzsN+imKmo0FgfOCTQ5wY5odLvH76HG02zRWOG8c4enPON4kvjHt/L71hQayRKgkAgAB4kEEEunkDEb9FAFnP3yYoKTH0/9W28jY9YB5oxUeZjmaUpQiF1/rTHWnvZ6yJtavdUs3Q+pPs62xkzdtc+s6+bqc4eWv2p1KZ0zShVq6hrYW3Iq15KaCK8jK6w/WsoTw7Bo6Cgfl8gBJrTtuiuhZQ5j9fJ/J6kiWx503pOW5j16AdoY8vLtqscctXeVnDX7s1/Pcs9ZyrcHKU8O23Oq2+b1l1a05e+In2HoHW63nJ+kd71rlOrT2d2fZbW0mezbKI4xQN5GDiD4XQAaAHUE/AmAOIEzEGgKHA0iAy0AcULPgaxUBpiwWTAY1QAwNAALgMCACiYnYDHlAbOhbyAAPAOeA4IHKBc+JzWGvHOFJihSQFIAYoYAEMDV4zwggLiGgQ0Y0c4g5NCsAFAA8gDQMLQiLjIEPMi4YEcPghyZUUFAAb2F7CGiEYg9iWKBmQcmxzDIxNz5DxrjrJkWMY8VMR2JzRG2fIIfFyHhlCQL48EBKJEDAco4WFA2IDpB+KhXJUWYLkLjEwaF8mzcqVrMybJ8+YE6UTJROFIqkQIYZDNkUKY2CgQQjiaPlcwNDI0UbIHicOl80Yuny2Xi4ZGxnSUcWYuWi+Xy4WS+blA2M1Fo8eLyDmBopCgnM6RfTQPmBonZSHql0yW1I+s3RNZoizLUtS/pmZ8yTMVnTcrmDrus0rRqUrwQAAAAAAAJHI5YWyp4rnlBbOFkBkekQLYBceFh5EOF4SCqYjlhrQwwfMiNHhIYx7HnHO9BYi2c5Ocas1mXLE5IynnzXdB4rzjyrz1Jzyco6NM1MU91nKqiwIggQ02Yp6Mq9HpONLnKbMucVl1oyTP+hnMZc+qIbn2PPRVPJDmkhhh089z3Y8wxzGcwz//ZVWayf//rdZ6G3MM7J/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJGH3MB2MAALXuubDksAAkIhUiDGXtyqRB5YDEobm7MtgZMueHJGMFTNQdY+2EFNAhUuQskKBBQUGgCAziMJDCYtEpJOtwk73YbOsoDWAUmdAUDJi5MMyBdzkrNJAgg4REKmNIEAysUGyBg0JfVsLUF2vymC5qwMtbkuWzdThibcoakbwu04TWn6ty2tDsopZTJmAuTIJe7rWXms52q7+7gtxX2a05UHu1D0atUcNO0+z/U+MvjTWnBdlnLEWm4P9FolVnYrPTsfcl0WWu1FvirstdYi5Lkv8+0NMOZ0oEu5d0SsT1SU0MRkN+Gn9clrLuuC7ruu7DMav/FcIzGaKtzVmalUulUiy1utapp7LXf7l3Va/azu3rtLjrtFqm7+GssOY5ar7zlNWvKb9/K1TU1bvc+6yyxv+Kg0euEBXnnAf0vaBCaQDiahYMpRFMRlauQmSa2cl0tC3PYEZfRGUj1D8u+sdPUohKiUWoj90svUZi5MukxXURF0sk6NpdCuXGVlx8zn9Ln7XWK3o18MvUhSpktayhuS1GhLzly7hkeranq2CN0ypJ5cxaUp3GI2TvfUKq4ugPnmstWGKrt3ooHlrq1laytZdtfaXnLTezTVl12vtlrfOfnfs2mbTNumGu1Z+fz/nZ/8tP5jXHBEFApI03VHmqHUs27SoyA61S7CMKNpqYwtHlTcQgNglZScIDEJPF32toqJto1JPDwBgIjBDOYCEgspC9TdneUEh+LPyuAdCZglSq57Zez+PRCGnbdqjWi1ZfEwzZrTbwS9r3O2tF4CxItpS+3u9qxxJXKww9Ql41zSVCJLe2JdXMFTrNM81YbiXORgOdrbH6ubG+jZpLnWhiEmbCQ+I2VysTG6jE+U6iXj8TpK14y0keJMUMbGA47rtXxmTt7+OpGNYQxckLcjoShzi2MhpnXGcLs0aIuVwbh4IiMol0f7YrFQuHBmz3u0J2W+Cq5KSuNss6XVjxd7tFgsaQVKrbIdKRHri9ezrS06sxtDpuS8FWxoc0WPa24E0zbHs111FrD1vNr4vXcT5pKY83sQzonk45Cm7Lq1KxEVlGZwJursiNhOgs3abpPTzHa0tjbpx7kKz6jsq2LUrSRLpVHD3IdmsrNTg4WqRriLFQWWLzI9oi2eBnOMKkcJxuUiCkB0LlDiQ1qHEipwjBwHAYCIQRwRjdR3MqOopB2SKqb45oS3lLqooSC4riwgkj4k/Rb4hkpVi6qo17aVd94eN7haWYjdsczS3UzzPxcaR13MRTmwyvfy5kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACdGKyINae3CmbrlwJQluIoorHgzh7csJwuUA9625uOKIBwMEmJcjwQ1644Uc1CsdkiggCAIZNHOMyrB6w6MYED0okvEwoPbsGBhkEBhzJkAyx2SoSS50IX+1hVfeK9WRSJ9kBruK69vV0KSjbQX2trtbi0xa1lL1ZsiYdL4KcqrOvWpGm4ax1LZnklWAwjfDUmcGpSA9RbiBl5LsF0X0g07C9LAzKZDTqP07CXG6GpQxiUWHIvyFnSwCFE/OVgMl6fyHH9MkzlOQbpqi7CZFSaKcUUTEFqsq1ami4juJaX4UouJuni0EGQ8cxxDdDpSQXyLN0QlpGCPEnQ/k6XFWq5DVSkndnFgZkOezs0OJEY4e6esNQmBJd6+YW+AnoWYipfZP9/Dck6aLxheNV07AfMc7e2rjMGNENpGSwXJy3VcPrSQt4i4zNXWLwYmb4xF/3nXt933ArB19Kj0yMaEYAGEC50ThoIDmepTTIxzSQPI6TQVD7EvUMLGKWx4kEekNFlVRaRNbVqiUW+bYnCcl3XUm+nTTZSe5JFktuUl47WRupwi15MIJU2TKJuSFOm0RU2KBOotBWRCRsWlSbScptdppWKBpAqwkVMsIryq3/uvsKT2F3VSlsK3cbW1257lVxlJRhpuDFVGcI/ZQjDZ1nt69BwAGvQTfQJjhUlpUm0sElEYoICeESBEmbwJdZLszgQuzBQyMQxHnAK6GBfhypNlTMUd6Aniey5NOM4Mee6AWcPy0B04aRreJiUbu4xpoEXitRPGYbazXs194VcZuWyOLy1X4VSQVjiuIrCpWCBu1qPdSvcql4tQ40BPmYL44nKHAhupqRsxWJPO06qHrt6poTthgxYNYKmYWVxbWVSq1U2iqVXEvE/jqVyhwvFbJZmKrMwLqO3QGKfMJ7AVzXNeZu3dtshytUmm9CWfCy1qc7em22E0Mr1dITFSjVI+iNbVCpBgISrISfOlRQ1g8ElM2Np+nK1RkTGcG0/nGLDKA0oL9nviyjYq4XcF88aIE++5McG+vHmzJa+/nGd4xd3WKQzluTIsKuUZygxRGle9YUJN4HctvdUxnT/ON2jWs7taNXb5mVEeM5Xmq1RYUtWpJT6x9YpbWVu0l3WoaGJ1Z7nrVddOqGwuWHGWmPZefcfY7qHu7utI2abHjZqJ04vflZ43NzFzUw9DcNgCwlAeFoB4IojDcfcu966KUplLVsqY5EuUe3b/7lS4vIpoH4sSNzj0mtcdhNFX3unitscOphbmrdeeHJbVlGr0aqscm2M5DKf3V3M93dVb2OaTevqjvOUUrgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAisi0aDOntwrlB5QDFrbmCKKRwMYe3LWEQkkMe9uYLaW+qIquzDIELJHKIwQjK8W5fJprcTISVWuBKK8n5TkRaavdaDfwkjFoazdZFyB010Z2GBgB4GhMsytohurP3qQWBsIc61Y3Zzs4UsDxd1pBVnbHMlqCwq8N8djcdwlfr3pfUA9p2VvciZnCUmXzgv3Zsare28xm4WF1eHPSDpgitcCW83y6ixXb6PRwN9PCZjoJo5zq+JVithk3Zeiti4Q0/6Ovl4rIcXFczUlkGocpkspf4KtPNWHs3JuHpNPi7yrk7i5pyDdwcYi4YY9GxtkUSiUbEZRCTzQCGKVfPuGyJROqdZRLYUbGyoNJmkXxifu4j6ErmxPnUpGE06Mra8bGVX799Zg5bqSPt/53duiMcF/piZzj8YNFItnca5q1kwB52pa7znNHr3ud0w/l5YWJlzfN27nFohbn8bKmjI696yxQiRMnNfRRFIM/6lVh1VV5FKiwrNpbKV3PXse061Y++GWgcTdJ9JF2akOIJMP4zHwdRWP5oiatqGua+DF588wdpvSzLVZVz/e2EJH2ixxo+WvMGOsp5adm6rrZXMPRQLIL5p74c2GPZDlNCG/RW1tNuonqYQ6bczNVPFIbnTT/aqSvo3VKlCkLFBxRHZ1KzYHer13bOeo3erSuc6wt/K9yld+H5fEI9EYDl8HxdizeJuXnweCbiczBM3f1QsYY1bw19bC5RRjOVRa5cV+iUts0SDqBGQDjSsSJNek1FepnBszlWq10lGB64fUbO4ntM9il/Z52O0d5HZ4lp5IsV5FYHJUPO8wuDNP8kZP29iZ4M964bnsSFPSVuYFJWI1VftMSHiF8R29C6RH9PHa9JZv0xnu42O9wOqCuSVnrjUBweQHkFrfq9+y0Wk7KXuGhiOZmV43R1EdcVaZkob56nQxGM0Rm6qciTsCaq9V0VFQok0k0LOKUntI8nfTN+/9wIUaDqeGr0gAAAAZvjzqGsBR5qj02eDQnpnVcY18SY3uvlvvbPBUsiPkhud+qb4/R57RMYz9+Oxw2GJPeB3OKeMB7usKv1a+NZ3vwKRI8G6HKZxZKLMePq0+L6z9WUcGErNuMKi5gPHVVWr2NTQl3ujihhVn+YFGks1KzQmKLaBmto14FXrkrHT2HWE8b433n4ve8OszHS7586pt4wUq2szlXwIG8eWHjOaTQMWhxI97bvFgx9/UJwtSaNAxqKyQ32/LDhQM+8TEuN5t9QdVpCnlfzw/SJjEKkkY0mMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIOovHgxl7cMIQmTQZ7G5hIjEaDGXtw0TDpEBnvbihh+GIEae0aCwSNTXVn4drrQPgeXPz25I7Cba1abKVS6nuOk/MEwK/UEQA0KAREUkO6lagwoWuzkSi8wr10rF3GQWotu1TQ3KaWUzsBcLbHSkZwnXb91Cpl9e26M6lSSIiwHrebB7rhmlfuFdsjtxVTNEdw2pVsvcrwEhdPQPe7XuFEa9QHj+CxKWITVLqhtrE3iHVhjOO5Z2WkSRyh4zJEVrfW719uKrUypIbMyqeO2JpibCVsCxAanFXrDLGXnGBpfuhDfAnfZqw2gqM5Gs5zFkftjQo2aCdUsV65VZ3RblQXpD3kV0zxEPZG9tjRYCRniz0mg6tF+c0kYWy8bWtYrut6Q26LsAEAAAfSy3GkiZtbuaUV9s5+/3/8KJ8YmzrD2fNkwZcK2MtzJPbMFcMCxrMHes0rZapi3smxB7Y8oqaRWmtu7a7AnULv7VBy8dYh02crFe/XrR9Rx9ayTh/WNpoE9Su0ohJC1WCwAIohA8TzrDe2S5kdUdVzD1n+/2GH3orRX56zrR3NFz5K1aW6a0tmcirRqz/7bNtW1H6NXyI7fjyO9PotjYP6faKrlW15522t8T3Z9NpOIf6s+L++2/HW0EjjoKvaFxIhFoDsxISrDdNXqyGhGXH2DEscJZnbJRZbe3UvZ1YzM1JqMvkkVYYuGBNMedsFLPtFlkV1MUqQbcoRhe3jPz9LL6We7t+1ahUN2/ViSfY7bM6w21z58TsDYsxVwzrg3jXRTVGfahYgVrLaSWiKcqwI3cmdyV7e+Xtz0SL5TRt+I+o9MYxBJC8Mzc3x91jOTyMwNcB7CQlKYkYrxWd1OuoEKt4sA9mE3Kpe7AnZE4ilDijlc9mZUrgIYXhOxmtpckWzR8R8q18iHZ4E/FyaDoLppD4tI50t/Uu0JZFzckAnibPKM1rFpzINRvVzK0P4Cvft8+XrDDg43VqZL2dxtYzLHv8xrZ3LV86JFVEV1v9C59/Ov/CznMv+/bEd7dvsFM3VTncmc9Kb1COnpWm95+MvHBoix2y6kyjmas0j+DLTO4FfWmqZb4DlB0r2BaPSE+pXVqfFbbzE1h3HvGla3NngPW+8SVko3KdXHyYprrNg1x608sIeu6QOxwabqu174c1CeFLIhXo5v+b73X21DqtXQhkhtVbwoMiui0ntFjq+8msT3ix9YpSFAb512f+48OXwPZjxfE930eHHY0XAcYtId8Oq29r0v9V3Tda6pSNaPnECPnE8OcDYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB4OKR6MZe3bI8SkkHO9uXEYnIIfhjds7wmSQpb25AAQAAHI3yal2VIHGlctqcnPa2PtW8MOzNZdF3n673V+cvzr/5vyuRnSAV+Ik5Mmppc7ePOylnEEUWu42sK9HXmZZU+WtumV1CfMcF9mBWBDpjGc/M+E/fxGM6Ey3qWsXz4zi0Lw4TardbvAzDgML/U8B7EjxH7H90pDfHKcIsKqOF9D3vGqSxL2g1vaPp5VizqJubNKbxCbp6KVW0tJI5RXJPTvbMaLZGJpPFcxH8u4tszK7DPZ5pI0azzZoLa6fsKZeK1CFqC5OEZrdMbM/fsDfPrKuozwIrtgjNz3eYGbvZ9a9+4xmKPr/OZIuattKpCFIAAVaz4WGx5nA8HZdvMXYZ7I8qMhcoAsHpgvInDAqLKjg0VhhERCrDU48R1nt8VvSbjpyizRM3pafWfj/TU3Uh0j0zVvvE3an34ONxbuMB7Vrprfco1IxmPpGJ0xuEGI5HMW0fWz8TJJbMD6G3b1itIOsT6b9OnkdVOULM9vn73JDovuo7ZlnkcY0J9BvFi0s26patPi38H6e6vI9fws23uLPBzlXTYrePv6mxZ7PA9bfftj6pe09f643rNYNI8mt0zvvou8GwAEAABI4Q5MZoBFhOWcRaicj6s+4cszahX5/vmf01uG7Naaxed+2XLomZVLblLBtvmFI8MeneZ51r2FS1KaXDtR7mS3tixXb0R16Gs/t4tWPtYeEtMJpLT1vf4u+fnFgllJe0ofdarWjD60+ULuaSLr3Zw8WMCODNErZzsn6wMOXrUqGCyJx991e/FjEM/Q+DjDRlBMISbRo8QnT4uxPGa0rlpTZIuciOH3q3icmeK45nKK7TLBSajPhwRnh0SEpKPBNIadxt5uOl7v1msFqN3evVwwp2tr5K5fPsmb/3L5i3PERgAAKqimqHrDx9gzMJ/5Pfwznt8yYm6VjYCYuQC6aJWt3I+C0s2Us5UxQVNnmydJm9akgKVjrTTVHh+mfrUeR89cP03ET6Lvi+8Pc3zevvdiV8tJIGYTjF+kw3JJ0pNMyiXKfYSTiBnOShGEraDjWkPfTyWnlfxqYqulQunkHKd3dvtXP9fuPBe7oheIUGsKm2SjyNLR/Bnv6Y1imse9ntozmx51TOGu8OHeDNHznMSj5etCx2pw99Vve/+Ie/qHDzXTIwLGokj8ankAw+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfVicejGHtyylFZNC1vbp7mLR6Mve3C6EEk0GQxuQACAABWp7eVNjXHp0efblmLBQQ1qxrdrt1CzmXdWO1N1rHKd26eTvIxhUsu5BLbUlJJ88qNl1uHcJXjM2JyR540caztTp1TKGNlRR8zNt4UKXVMZkgVy42XFoZMB5JaBasN5WJuDm13JlQmE7h27k/V0afVttUWMca53CvjcrkSJjXSHyTVrmtI1YsBhX4UWeLmWkVRtsWLiz6j98rJlGX/oYrYC4ULDs4HJhu+b4bEuDPQ17pkZHGE+S7c2S4UjDHUydMtV2XTmqn67V+kipFQ8Sywws6eJdAYmxbgaXEA/83eK6eZ39xcWZrebcKSzFdle0zqbdvBjgMiRDAAAlFSGxJBLnf8Vv/vztfZ3mJqbVTOloChXa58oaQPVwVis7spzzeFINFkjkDbIfuOkrUg5lpimvTyy7S80WAvMrI7fwL6zXftjdfTNKLpn3qkFXVRsVWLznaAnWG9nb8sKcQLapB3J2BLuHmmJM7h2w9ZY7Y2RoTtjtbWc/NKUpEX2CO4Mbk5YtA1u02d2kbo0bGq41/d/vcaSsSLf5rp5mPiG0ZnvR3JPpGzQ5YkubZ+rZzrdsX9sYtq+qw6WjwpJs/X+psx9AAMAADU3jlzCUhBEpzs2aGABjJJNePH2dhSwc73F9o7+fDVo9aGCNEdC0o0QM1TMTN48caj1o1Bs1KZ22Q9qmVkOmfbAkITCyunufGv7emtSYtaHFbIJfT1QtduGZas0ODS9MR4+V526Q6Wr7yxGVqP6ND3lWKtV3feDVMmWeotSFK5ipLmsGkC0j9gfbfrlxq8hstmbFJsxe3KZSVYJjuspmBMMNXa3aZ9IyMRyQVAs504QldCw4PLagKqEsEoRSvTsRrY2iykeIUtqXw1EjzvSpYS9uUzel85U7ZLGzCcm19qS0rXajhp85OM7a91G+IX/nia3actCIEAeIV3YA5G/MBb/+Ef8T3EW3kloJw6CllA0CEYp34gAaWtVJI8VTLiRelnLPLYYs6sLebOzN+rscD3xt+VSzla2etM22fmXosXrLvvoZwlBEsVQC4ZIwzJenpOH4cCIBQ6J7Rjd2tNlujKzVFLq26q2j5pmv/P266yxxUq2JMJ/P0bvWbQWrAjnWb/s/+9eF2p6s2O25SvacX6Ddit/ozhh7HPZ2K3Z03zWr5OSxEtMZGQnmdGA1sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH3orHgw97ct/ROSQd725gMisejGHtyvRC5NCUMbm5QWu5bfBLWpqj3p3QOcVjTq+dEYF4+3fz7rSWFphMlUpAfY8CT0cIJDWVTYf0jkvmkzNDiO2xlY4ER6roD6rxRupozXM3suGbW8X3vcGz/65/J2CkDEtDgRtxK7m8LK4PxoQ3bVFw3v4Dk5Me7RnnQ9ZjRr6h4SbYMI41AsyOc1tXszPUsqVW+Q+OwI9W3hRHJ2oIdKbupGNTE4W4aqRkh/xyUKVnP4/MRE2xn5BGwX1mcUou6Oa4fv6wIuaP1AeR/HWkEvFSicSbK/VKR1HPEO+IcR7Bzs02MNj6DOoJnNvqrm/NYkZxlhv6StU23d5WBX2/3alYTBFcXkQQAAABMY98En+Tm//8kX/4x9YzSlpXss49zrzU9ossLfvqq7jT3xqBRzkcbR4EZwarIKPAZL6xqDaPFp8ZpPpSK+0edPa54MTHAvimt7pjWYcdwqhDxWuDKtwV8niEwbQY6JaVpiVKUHwdY4HJDjJUx4mOrW5z1vD1dGqttkzW/NxLRz9Wzk8t4F8fUPMNWSu1LKztzHHgsyNVdH0PMBhU7deJHxjNKaxJAgwoqHQpIUObCrZ6TQu3UguaYi5ZU4yXmy2qy0mt6ga+pr1tJqmp6LvsNa6kTmJ3k95IkWZWgAAgAAUFXDOrhGx7VHnqphMHw/ctUPb8DNBpeXLHKfeVuQ0sBVItNR8mMmtXf5VfGnbllfqZN0p4FqZZYUVrudBJLcnrvFa1HE7gobAwu2OA7jPfn9+8ZYbtiiQUs/PpXRcwH2ov2zQItNrczYu1fLjT/vY7xkiNzar2U96PNZh4jUUCDH/E1ePe8BZjQHVnbM7Pd/eM5OaKtr+tqWa0qnUMVM5fYaMZY0FyP+j1ziuMJZUpg02nGWjEz7cHe4bcrtKh6cKLN5DZLqhWKxhVbOOhqkatIxVGAXNhfot+rs1Up4PGFlhtbxjb3GO1TwYsbNY8OA/02q7fxAtCb42Gx4NYTQ6AACVx3wskQs/PoVr+soTV9ib/R+Sh5IgB9NgSHWKcaMNPd0ctmHDg1KncriVTyeLL/Wf2bdakvxMKKGa8vmlH6dk/PrfnMSTS9K9Ad7ZYVy2O5BFCdWKy4TBKNgaMhSXUErCtepam/bfvVa7AbkNNRix23P1mZn7MIbaLCUdEdNaknD8eMUj70LLzX56cnmv59osxX6248xjO8bzVmK12zBTiTnXu3vmcq/fK3h7N1tdE4fV042LQlCeTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACbKLxwM4e3KtkWlUGStuIL4pHhWHgAtZRWRCmMABoLMBJEOCW3nYZUmnWioDUwqIWtB/SJjI3afaAYMQQvixNnSkDOsUKn0zSVyh9XgxgB/mbRQiC05oClSxIw7Dvrkdl7mIJoypkrks6Yq5cEQcqduEHMcL/p+MbL8XkX5OFSrVp4u1I+RaHaXjgQsgi7bnp9qAnhMzsWTeCOhZn4XMxT/kozx6MN4jgnV1CP06nBD1KhydfJVD2xhU51nQX8SQbpJiGFjVikyiBuGGJ4n0k0I1RwFk6zQN87j9TSFWTp4q2HFXTxXlItuGYzYu1axEyWTSnfsifUqicYTOrUW8Z476rOjTEZmeddsltN1o9HzMraKw+l2KWYaZS7myt6GGuX1bRKRL8wKg8VpEh/pxVKlXPIDndwbnjK34eRoz1/aLLDjZ1uRsrt4+1u8aDA80dwhz9cokgAAdsJ0YouG5UpgL1l/C8d862H/rJczDgrSYoQutZmcqvm07byulGarzLSXR1rFlOWXTLm6/UOLH6TZVHDxqtsv+6Z1aLSxU3WOqoONkUC2zwdo2DiLB3DpIcxRDIuUOFzmTLKa5FqqpNbDHk41NG3/HNnah7TiCzTsWVOZn7fnpqm3xey5VhVNBFdkel0jzDlbu3sKKLFaf2//jiY3TNw6Lq5p6ky5nP3LVquNiZ+1BiTgsxFiNrmzZ32apKj+E1Lk2vMjYFCT0JSBnH+calZY71XsicIwzqEYJhqlxQ8mkZiT9FpvhFiUsdQMECkVuZsntWJRVPYqvjuUFXVpCgeFGVu4MWnavEvLVmS5QDnJY5UbJZWpsTio0yX6FztSHPKtjjAgrmPnN4b6OX1PPKYzaO7PNSsqWWWTu8WbWpmlUTdHcWCSDZgf77kpYF53uPVXFjlbm5WtSy2G6ztJxv2hPMbKfKrOxvT8SdSNi4gQmx2wvXcddOW0PSDcdq6tMmp1TAfS7TDma5oqRRolQx15iRcXDyVZbZ40NOYuyRLZhXrGvuHCU8u56fF7P+83KmLbtm6UP4PlplYsAKo3N6p7C5iWaUtlMcnTCkZk4tFXL+O6XrKZIqbrHtUq1ZEuHFD+Nup9/Lo577xTZymdhyhFdCbMS2RhMXh4qxcvbYcpmO0+vvKh6tyyxo+HYUj44kE8UjyEYmE4hgeFPGI0ry+DcoRmR8f+/K1wmrEzMGYYGQNR8RJZ3u6aw6uhgfJxTMvHBTQ5Ki9ltUlX1SLP462ldusg/vjIJaTua1tXjpSpaR0dTqCYqPoDpHPMicvY772nufrRTs5WHGYL8cuq1zL2VyNu+Vcs2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdVkE4mKaAA/9IJZMO8ACBOLRwdh4AK/0Rk05bAASGAAAAAAADy6kKkIsi8QZILB4N49APPBgWhkkuMQdxkZG4NgQAOUTBxIHzwOwG2O4LgC3FITUoLPpHyTC1jDmJmXkh2kkPaZJPHuMApxyEgOI2HEWmRlzHKCA4CAF3EMHgvGJ4liRCogrKFMxLxsgE3BthawJwvE8SgSwYAvD6IyFSBXgixIsO4urW6BdOLQQOFAkyfqWecmkqUWTRmRskkmylqd3e7S4xdMieSJSJQlRvYou7MXlKut0jNlJId0FVsmgmhLhQTJQuGRommiik6J9mejQ/MkkikgijtougpX/10klWSWnp3//gEhAAAAAAGEEHkQwbAuUieBIgEJEFpVa7aub3jmmnzlxBlzYyzIZDLZmVRtzRBRywypw6FvERwqwsN5Jq6ajrUbmi0PQ1U9OoheibfXg0Ms6FQ7TAAIGZZdLotyTcKuNe1LDEngj5xnOXlVOLUkkhKhoXohQhwmy7dH/EhsrE9GDDZUkU6ZZGAvy7kjxlW4KJHsBsnVDvWK8kkZU4SJL0eUmpZ7CeaqurQ9xkRFkkrEc4EK0KPZ5XELGYutT1zI27ut7hRN+EjzpUa2kVtSJpVu0I7+0GaFDffyVx/9PYrX77o+d1ifP+7Yz8S5//xBRkfDq0HDhPb6z8VpabW7f/3JbHINrLmISD8YZXNM32hDtjWNs1NPKWCkBA21gb25sbW1cP5FY5tS4OZFDrXZPk24F1c+lImUg5Iep0f6QWF6ywHN7HV2jzO+uMTPYyWs1sEJ1P5mp9Tb3Tgak75WEqQJXquPFezPfCxaPDiwXqldHLEhRNqlyXD9Ux5S3LaEKRtgteKQIh7q86yUoc43nV1c5lc7U2xO7ti7bsy3mnzGzCtnExdz9LkoVJAXJ13R9oiKXTPGq3vnNzWi6RHN1BnUEPFqONF1d2/MLDko2ZxanynYYyqSanUzHzuJyr04aUZqyts8z7VGGuGRdt1oMKamoECND7dms9rX9M53nUseLmQNAAAAdt2pKHphO3mIzuW7Ox/arNLVt+zdla41Wqi2pVtmbWm6qBd1+6a5Z96FthdVYYMVet8sMcxP5Sb5UzMXtPUNxu6fXGvp1LczF8cMsolTpVZ48hL3ieWyyH0JJOSWeoiWWwoQy6PhsVUji9TO5nZV5ZVhfAmu2dS9f+nc9DoxVh1CPLnHtW2Cux5+xL5+Z3K2rfLQ/K5NM061+tHZlYxtGtyjaB0+61FN9pPZXrVz65ekbGY9SbTTvrWYXDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAI0YhJBWHgAr3wOVSjMABl4kFEGUkAAsXIKZMO0ACphLJh+HIHAJ42K8qgBgAWQJKZQsR+J8q8Ws61HZOHQN8OMB3AHYBGAng3xcy9nJdaNOzkoWMnYSAQgeghBLEIQxlhpx5mDHhtc6rUhoHIdByIREUMFDDkNAWwWwNQJgLgSwnZbydk7J2dajjKQ/zrQ8t43wh4ZYOcl5cDQJwXBCHCVjf6zSAwMlJmw5znV6fV6fV6HsasYD8Vig1uGznQaB0HC0HwchBCWELLmh6vj5o2JwnZpqNRoer0PV6jUDBR48mzDfqxkWU41NlGBiZ2eZqkkeRr6is+XJix4cVQPGWmH/tAgRIWFbAbFTaFeiHxoURy3HkeMjBdbLi8iONo0GVmnezYnbt53m2P9a9G7eIFv/ikfawgPW0QQIAAOzREGa/eOJCojN9u27M0vdevXvvx7d6vuNQ12iSBZBRRnZmTMvstUmeRQ4tQ1jtHFh5mUjve97zRSZn5mVy+PY/gm+7/dC+vO33FjkVIqH3VgqhvvQRNVWnZrEF4/oJx64wHhMO5uVk23pPfeji9/6NoZbVvsWrOzt7rGHELEiKEqqHP7Mfr1aXl7d2aZ/TOtvrFjjSyVlMve7c/9nZp69/ccR5NqxbeZvM9X7zWlOmmOBLyuzMw/KGPMxjzocjIKJ3BMGAsBAoDJAaoGZOgZcCCSIDUsAyCCISBsAe4IYBARGI5RJhfsG4xAoZAHgyI8WsCRgeIG8Bisg4pwNmgbZDlC4hekUA6QN8NRQAuARAG5QWvFIkhwlsokRNCTCyALgBRBaBcBXFYDAQYCNikWSrL4+yClMuiE4fcDQABgAYAjRQQXSC0IqheoDViQFaEcMkREY1YacDagWYFTFcEeBjMXgggHQh0pqR4xos0dIsklikK2dNBNZmcEfk2XybJcnBpkOGUEEyfHSO0ck4szI0XKTJGitUjxsmaOThmmfVGPEFyDmZByLjgZzexNl8NWolEc0sEWSQSMkTpimYpols0OU6VS+mxfL5UQ1uy02WummaLdmtmrmV1orWtJL9akkq/tZ1rt///pACAAAAAARY7Vx8dHzB8F4ljQAI0uXEGRNF1pnlLSWxuPQoJpqNjJM1PmQ9DRlIJEsSzm6zE6p1FwlDRI0cwMi8dMzZaKCKLIIKJASwTAlzhOHEZyWSRNnYurCdmxcL6bl83UajAiYlpmdNC6XUi8zstZmxfM3ZNegbppuyqdFll027OtVB5mSZvTTNN9ZmSKVFJJJXWj3QdFJt29NBkzT6G22g3+pJLqV1fVUl/////4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHf5BNhkWgAO7SCaDGtAAnRkE+GUoAAlvIKIMKcAA4FuojkoEwDdQOkBsMKUFgD2gXoDHGNC+INUOkAJ4BtBUBiBchgxiAZgcIVyQxRyEiOEHGDdKKQXEqJNAvD8Xh5JkqfEyC+GQ7SRUQj9ySWOMYNAD3F0kS8XSgbj2HaasqyJKCYDnD0JeFsDmkuYFEcYfRKBoRUMKdLpKkmNBwZh6kEbi4SRuOCMpjSmx40MiRdIvrPIEUiGhOHwlzI2TccxNYwl445edaLukimtSLssYk2NCSMnRNSpNRkgpSC0Vm+asYJIJqQrRRSe1J2RpJKNVJS6ip1Mp/QR39R+iiqzqN3e/3/2qWi5xJN9dvX35WJotkDcSYEmCahySRTLoPocoWAVMYIS8YQhkFAukMS4kiSLxgSRqmSROGHE8NCemYGjGTjwNjUTMYAeJdRKzyCSdIeCiRKI4R3EkiaJmxIqmSKI7R+EYEvIBTLwgpLKEmGCJAzE+ZZKGpZTE+GAIYn49BhgtQ9ThTKJaShdHuVlhfLqjExMDY6eMzMJ0Jabj8Pw5S+SBIkknIA9DQpHEyWMUC4eLTUrRSWlQHobl0zSJRAsNnMS6ZH2MDqKCCSkjN1Js84Xqmru603QY+z7oJbMtFBqlLQZ/1NVupVWpV9G36jdlKPrRMFo0n9BBtuR4C4EXYatMQtUFzYhIBgzgBqEQcIVI8kQcFAgBBY2HriFQMGTAFKgaYqA8ABiQABScWQRQDKsAFA4NjIXOhgkLolkmFLDLYYwGCLhFxDIitSHidCcQFgL4l45IuUEAMcwgg4hcwfiQ1MuTMWQOYOMLqAsMExJkTiFuQIgg1WHSidUDyZNkuIIDwRcdohcS8dY+AbohthEiDC5R9EeYEqG2EiTY7CYJgky4eCxkAoCGrQ6wZGD4iKi5RAUsDSJ40KyKlORQgBECDuaEXIuT4sgZggQ4hSYuYaREiRHSRUfkEzJRqdMXSLxiiThfJsnyCEUNDdBjzHj7FgmRZI4SaGkVjx0gqyaImQ46aoptYyMj6VJNFVtaupPQQZPbq88iUTUwMnWaJJrRTSrWi6SVbeiihRMU1Ku9L1VX+SFoIswqQIi4dUQFXOYpwPRQKzzIkDp4DmLGW2VTiA6ciWnKpMsWxzMZzDJ9jDIlFxHIn3uNCCyajqCcWIcTaYo0MkEQ888dEkKlChRRqa0uxxUxDjENcwcPWYY5w+PDcfHChxxpIeMNVGMNOGyVcwxib6cjoaYpx0fPNV2dGQ5XOTHqTOn//v82O/nIz2b/91NOXzf9f+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACQGFSgdnAACgTPm05jAAIq4pHgzh7cqdwmWA8y25mWzBAwhPP70aUMi87rRBaMpGMYKDJHNgMdhPp9gIGuVVdMxLcaAjQEuICtzd5K5dySS+kAzKm+L2qXQhuiwyxp5/mHQJTSy2w6XMqetFFnObWkBQOEg9DyRTM25IdmLKNpEw2kLOMFjbOrs/ZeGkg1rruxKG4zRZSV1b8gZQ1Lkqi0Y3KpqUx54oGlESpnzjmo5bo/o4ad6LV5TKcpVameU0czfWrSOVPRGz9l8JW/0RhmzNTUPRqmtzUul3zUrsX61SVVc5rP9S67LZ3kxXyr1ruE9hjRU1WrZkkWpvtZbxadMS67q1ll9HUr3q2u1o/j9qpv85mvNfLo/T/K71NSW8odorVTLs3etXa2V7tbfNfzLX5/ljjWt/lZkmHGnlkAAAADL0Ho1JIbB6ckohFtaeDkust2tDK7BXA6ORNZgeSqbLn7d+2aae/7Waa2+WgMlz2y08wtplGz1x46Jtc/pay1cvloWnrZ85a/Z9ZtloHs6uNWa+14N2K9LNWg1lY316fdlQX3F57Y6eout1rW+9bZXGcx7p3tyszNaXzd3O/vm03rN8nKzWf2tsnXZiIAv7bhqwCF3SRbqLUFY9fVUVWVULyiGUVgENJregp0wlRggu8IEBGwrtH2X0ZeZhwIWWlVYhKcsJDAcNQ016CovDrkM6h55JQ8D9uTOtjm4zADYJdljLq89FsJ6EzFNEnGnZPLm2zkilZUNlhZeuoTarHjb1NTNI8R91Mx96zSqw5j/b/HvZ/u0TE7q6scEOmf2ir1HOjWzr2Jm5cwmy0XblAWUVFKQt5Cnd160aNWr5revJFayo1gjtktcPWvNs7zK6aC9tZJ5j1XEE/4akTm6UbWJxZWAwXE0H71kPqNtvuyxqUVSpZzyJqfz5SnazI+CsPjNPRFqRUMi6NJUR1YpT9jTo9xcGtang0alCmIVWHepYsNultfwY8jO4Z98zYbIuIgyX4gopIFyTo/T7VqoSayXaQKWyMngrVjJ/e1TPc9bHM+1+yD7pAvK81XYspXg4+syEN3wyb7u+Gv5NuWm6Cdlal1DnXxFv6SOMOGz2LmJumQaDx2kAfcgO02PlJDFJLH5MOpnTdlvq5pisq7C2j7Tr2KdRPVsmCDSdabLfDqll9VBef3cbe491O+uriWV5o9lPdNOjtedC2T1c8NbbY79zH+y9UYw4EY6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgWi8eDGHtw0zDpID0vblquJyAMPY3DvEWjwYY9uPfFraOye5rEMiQCgQbch5arFpBaLjMqcZ+pfJCg3MZtxZygiuVfGamYlOTznuW1CELelOcAU81UqdzzqSien+Z46s0+E3M0VjCCqurZavc3lYYWYcHFt+XsrauWm9JS/FQpoUGNiWD/bFawD+zBXLJF1JPi1IF6NkRemgQKP9Z03qEtpdC4uDM11j0u5vJ2xvlo8etjZuBdwcnk7fAzmrkaSsUrckYKtVisfRFSoFU8alRFdrU4xXrRHV7fPJOikc00lb05CeJ841M24V0BUML1SKpHN62rDjjbMluL+yXjvose0OVyRzJMpYeGGKroM1XssWrW8WrNT6NetK2gYpmDE6facZQRpaM87Ddw5OUobL5KUqmDU4wWan8jGMqnMkLanMnOkpOkiPQ9HVUENlJZMtqz08NM8dihs8DVIHnhRs29Pne57v6zVeQUkuJJt63Lrcl9/WpZlwkaRnuX7+Gl19nVSgjsEC7AjD2UKPhGOpSTFseLlwgRtz0hxWOTDNhCXjDEkRamiamx/7afavtUNamdyeDLqzuz68eNdmtGznOc73TW7bjv25rtWF833XwMvaaa5nsm4bd7ekLNs/VNy2vWDWLilZp2aMwQpfLXGNxAMZ4VuFztICRRlb8aZtFn+pX/B2pGy0gw6hPWvFh4vrGNzx6KBClBNdrVimKqI+jtefj11r+JfWd3gubnAiLy1NLc3tFn3vjF5n/tBD7++pYEtEnsxj0zNJhmnr30PnLNXfs4qWFVYuPyOcOu7WrZiPpQk6RsI7f29a/n98sjWvtQQvUbh3syfuhLXYYlp4fCfCXID59w7SRO8VkidLGhLomU8BUZcqfxtEwdGHVbLLNUba2TxtYOZmhqAoRoEbcu+5W1HaIMdKdNdjpaXOt0MOudOdk68wlqdWePsxSC2ebeKKzM7NhdnbU+RNJ32Wy1n9O/VJqsdbmZILB6VDZ6Mc0C9YQPFrGfvSLVqzqCQ1rWmmaLRhbayx5YkSLBxXe8OMNeN/UR2r0KbXBPqxixCewr5ramGyVnV6HPWBW1Qsn1Fy4iOYOAxCpSxBTJUCkSLAHslwJggqFn23s7k7eR9tbgqVZAcJ1GhtYSkYMKyLj/frMrYzZ2Ndm8pUqdimfUYMUXMZ69lVtawsWrnFI8efDc0HrtKPYtvuPGrluUUefw3CSNk0z5hvZOq8yx9a9JqVxEljUkti6rkgQ3sF/e94cj6TObWkmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHQYpIAw97cupRKQQ9b25a5iUgDD2Ny1/EJFD0vbndvFjLkwQw2NQRDtDLl8hBL2775PCu1317V387ebtGST5nJuPdCXAk7+NGfM2q7fLittyZtBs9jsD203janlestL2tFzn7/+8R4q6g3etxsJlxiQaQZpt0viu4bYsM1I2JMUvPFkiM13jfFcdS43BmU43BXlOlMQtV3uA/bHivotw7usNkeA7btRveJXEkDbanFQz6y2qBjPajqWLdX6e4lDrmirt8rYz2dkb1ZBgx5H6+2LlWVgK6DZ873RfTLY1ryvakeXJWOGWRzjZhSUo35Sj/w8UiQ7VhV7Cro6ovvOvmNDtS0bkdggAAAjF9TwFcTd5GrqM2AClYtvkCa+e+K+UYQYiaHSQP4wVBOo8WDyt3QRWt8Ncw8WG5oS1yQTz5gYc13VWxW7eGF762/xSWA3uo2pEPucrmwYxFpl9jW8Yw3uFTnTja2tjCrnpPkXY6V25FsTxyl9FdIMnFOF8WwMtDRwphXwymPyHD+m92WDNG9fWJoayp0sj3CNuBvGc+EsQ2qHCeLKXkV+9IqJDg4j1YkpeHTPrvFqt+n2Luo2Gau6tuJqVxHgSP4FdRuyvnKFd4yzwqXraS8Jgc4F86caxk63riHK+8rhredXhNUeDbf3b8zLawhBPWKbWbgE4Z29N2B2RM2m341NfWGdwQLFCiPcGg4I2rY21jyT4iQGS0Om7S6jw40GA1n1l5cLF1lIZibt9Z2ZrBfbuVLy90P3KZjFvtfppfYUlSBD2oR38L1k6ovvrkK7djqnPFcqCAIhXYpj13OY5ZGPS+WUOPp29F7tsr+QeXQ6H4T6rlZaWkmJo0hToS8yV1tVGiXwv2S4ufSurHEE9VF4xVrFKM8XmjCFRex2I2bqS8KUl1DkvxXxY/VJe0UM3rWlcq97HMrEfT1nHscNBgUEAAD8ZrEyoc5tvpIi54/0xmd3//8bWgnTlxWSi1gKr7GZTtYJio8xt3TasojEmVkZlzXDJJa+5Kbp8a+M2eyK5pdvctcNzy/eP4GL2p61zijxqWVcqmxzOVJMTGgCcJRyZl9maF2TIn6cjPTIT6lfEpP5dwnkV9uHl2ssK+8hrlujbQ2Mq3r7P3851Y/obKW5+qVTHXFtxIDJPt9qLZVeetKfNvWkbdmFsUbc9991b43zm1K2zE17aZo9J7xK63Hzu+cbrD8TVN5lgUy7a8Rqz1vRqlUZEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB/KJxwMPe3LOMSkkLS9uY6YlHAxh7cqiwuVQga251Lr9O3ebEUafHK5TkDA7tieNqoA7WcaVfraLrL7S/CboaCTZ4GAYKoSR/Oa7TllbCkfsx9RoDVAmhNkWfDhDPCDhsVDLHa48Wza8h3iaz+/zdxR159p9EFhY4uf4sa+cXtuqlRzGy6c3BQne5s+oykTzqikPBTXfUZLOKcG+V4csdXyR3KBrO22Ay1hLDhNHUb5yfMs9YceT602CQljVZfmpDVOr10sNSJkXliqUTy2xtuUSuHJjUKMgwIbIqYMytT6E2jIi62+V6qZjgeOJ5nAlWhGyOURIj3UUivmXNK7WnOGumZscMRNfUeaE8tW+Tpc0mzRaY3XL6BI41vWCYADCHLGm6wfmX+mDpsIXzWeTf+f/3skpYcSGGkBSB+YzWZxopny5/IW5dGiVv1Z7Ql2zYpHe51q//eUyhT3UeC8gxd0f58tt6+9e7VajuG7gyRGNVRk5lDVcl2c7CCOKXH+xm+kkKJoPdKaX0+8h5e0rJDs7huNGqKrGBPK8/JqY1/reque1dEkmViviwHt37lrCu3DzAjfOPr/3hQIfoutyU1N6akvuA4zxp54kTOl1qryzVeHnf3F+d3t7b1T0vAgNkTxY+d/Gdbluor9d/6d/2TkHE/VXF8xAIuCbxHABYKJHcRVdUBbyTOW8YVKJLBBEgFbE20ay4Cs6zlSOjFnLbC+stf9c8loV7vxAUhobkNyOC71FWjHblWX2LMCSqL8gMJc6JuayqWcMDG/vLAfwJmSC3sa5Z7sbAOIumlWr2BwR8jyH81fQLIQ4I9RyMxfHzltleIpjWVer0OJMz7mjZVSIF/KDYZjzgwqMkk1mxgUCnQ1Xq9yXNJEOdNSDg1h53hqnUI6E+JglUgpW9Loaeh6Euywduub1UaTWCyMiEubyOrKtiMkjqM7WJtSKkTrqkNUI1PMD4lkKM3GeijwLmjGs86q1tZ3lmSIwaVMd99vX7x88rmZyiK9ujLEr11DvdrtEbXgWF8RYAAAG9oYgS6RVoBDS5ieEiV80U0pwZUYWyEKXHngIYQbVoQLdiBPtPvPIoXsae6Xr4fyeXZ58jy17WOf1fd7U0EStqY6bULlSW8gzIkSWnkDE4XHTMxYPpeKRMN6pOJmJfsN0feZOJR8kI99+rGaWoRjpo9Z76cVP9h7c62bvq6VmZh0mtn4+Lc18n+bQp6j2oQ7ZLmS1k0yIo+2Hv2Soce++HLYfqBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfdi0gDD3tw3bFJJD0vbt+6KRwMYe3LZcVkUMS9uNv8yWB29gECLuPDKWvIbA0AshOo61hvNgNWX40hbhGleLiwJgylKrGJfZGd/OlydGgcSiopm5UUmjWZm7PcfFhVexcuUOZrpTDCuo1Lw/h54cPeq1132fC1ejMRJb1S/3PbOqX1a2cREJeWnvRkjK+P2R1vE5h7Q5YaozpZs5HiqzwQpxvFg017QHjOuGCz9eV7yAqLwoEWTGq7tGOZDKqncA8kzRqPFjVcFJP5z/WJVeZSUfR12ytkOK5MqaV7Yr1SkmxOEuUOVa+cU0o8vXygYmd45qWDR6cGVu7FFw3Vq9cpaxW6d+8gXntbxqyTYUsFXxvSm5JOroM/QAQAAAPBvJqGusbxGcT0IhlaqdhNtlV2qSyMPOUq8FCCJpqSz71uuuLyMZCUUtKzg9G27LgnV1Hq24pWWDrFs5rqzqPddyyUZzIfJlydT4l970zTF2rxFKvvJXzjeDMZ+5E9ARRXHOchREpO4/DnQ0aSE3R8Bagwa1dZa21YhxU85vo7K5l8V7+NCvrFM510IitqtyhpbHJhW95bpsZhxa3YbxLY98fMuqT6jq981Yt7d9eLq7DHg6hvHKJA0i940wueY0bt9s4tF3DiQ7YxqRhtH3HgQNX3H3fxM3kBZK3eGYy9jczuifprU800AvFk012l06Y8rPGVWqs1V/We8LeUgfx9ZqQNZkdPSSx3K2eFvDKvKXVs50uVirhn2BpVft0rGUzrbJC23SS4lrm2sbtWOjn16IYVDbBdUccxvLXG9XZIp1KSRUwbzvH+38VfjLeT9LwrVJV7FeK1MgYi9ltOV4yx743qjxzhHUvQ2JOq188kpO6rB1Sz664VqsIEi1KWcUzB8s6VXaJUqEmE4QY2DnLGqU7dhcMMbBePVXx4CvxOfykUL45nkzifibWpIdIrInHxwnKZxjwmKWXMS24L6+4LjPi0CM88LN72ivH69Zpm+da3mTUdFpZEAAABbez1a71ut45BDl5ScNzdjnVlW62w5kZZSSZacQZrT4XESLodhuPl4qMFUc3zdEXmhimia8JzcfvX/1Wc+FZC22ZamFOrLLNm8G9afePGdvGWZZVrCxJJ+yplIN6aYGY0kSujhTLYoUQYQ7USjU7AOaJEpuI23cW1U92mzlOVQTv2Y75Ylt//VYGtsp6KRBHOemZ3HBsWlap60bsWx4Xzj6rSIs1ZHFg7e51e3hPp6UvF+I8ObdpVNWW1n2q7j01XdoUC1PHzvNoUGBes7dmSXG8Z1W0LYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIIYpIgw97crYPCUQhLG7ksiMkDGXtyqkt5jBmMbm7YtZUE4GZgBpjwQhMckW9EOibn8HJgggLMUoAUBsg/wJwZoYBAx1l8TinbjQVLcxFGgDQYS/zqw/iCGoh7MaD0t8ZC04hCnW040P25zjQo7+r1tcHzY4q+Mcj1Xti2fiyabM6u2RVhco9sa1UWpkLk6FOtn4sIe3IQ3oQi1s6Fk52yAxxVyxMkNH9koxSx2esW8TUSMoC6vJ1FBkjvvqj5raYMGLjUSPpk08e2iaveB4DO9M47WJDnFwcXJqdN7jRO+WSNEb4znEzp/vMCmcP8YpaykfNzzLxw3Ga4NmFxmfX1lzeyQpKV35I24tfqFF8SltfEPHh2y8iwNZ+Za1hSwGxfRIAAAA3lHvkeXBgZD0phdsR8gTJ0DJHI2pk4T2WxZJkP2E2k2n59hB1TuE26YszPGJ6hjBO7S9llX241lV+brzyzV7z0ayqFz9ot841y77kV21z9UcJwdNpSi2T6KTltQnRn0Q4i4eCiqJa1u19y9WFNmJ91htz3V6t+lMvM7lJUla2L3Mv067uWgv0Fqfl5nKTN6Ure7S607m/m3nbfesdrdGtrO/RwDD7ho0AX+NwwTEB7MJO/TWZdHrDOwCBR8eMXtRZAtl7AgcOmCkFyQUUKni4hnoAp8F0mKgPPmcSOApEiMhdb6u4qOFNRkMFwJBjvr1kKlS70Fmpl3XcUyburmBHGgJdTAXlXkzZhr8ONEoam3lbNv0llsVR+sIwjfIKXQh5IjyBYl0HqPdOGWd6HikqIlwuKqFmHKPEYI1Q6jSDNNAdRgj9HKW0GESskIuhDzRQBbYhlLtOzLUB0nZGCxkvmOIwuLIcUFFtMzK+kY7bgarZ/eskZjbW5+pVOoWx22uL7L1S6Tz5QtBpMZoq08Hy5OEty2ZL507d0ZYzO2sl8StDE5QXlqMTi8bI8FyjwKxY8CG2xoVmd56ufb8w3mJN5rC3GkvCfa3qnvmbe9RGKP/E+//SBnDUTAAAIAMAHK8lkpIlDQqwiDtMS8clYnk0aBmOp4Wly9baOtOe9q/Xs3qxEhLtriqGKvNXZp967tLsuvGa6F0dlo4gkSy6PClcjLMHwwe86iXMnqa5y2txdC5aNbClQn2zgzULYn6S8sX6z10L2qt2iswtWKKMU63ZSdzI57Zv88vyeyez+7rbObHl3pNhc2GWY5z2NdC9PJ7M38yzquN366y21P/+t5h//zQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACD+JxwMPe3LR0JkUPSxuYN4pGgxh7cr/QuRQ8zG5zk7/QPJkTwdZjrvkIpcqc/tZIrEbh1Jsk4+SECiASRTg3iUATx+hDQnTbQPlHCW1UJM0R5FvXFS/nKbxup2CyXT8eaPSkayFMS6bl+rCwQpYCd3dzbn8JmhPmluTx/R25XKZazlDlcijKUyTg1iPnOuLsT+Z9d7UcpLWFxZU9uaR/RxZU67jJY42Zs1CamdXRjCPMTaeG9fLWN2kbl2uVxH1hhVsB6w5vuNqBv/sphmshiqclEcjEqVFHrlnZ4S5XOFYmDKi6baR9xMO4zx9twlfo9FK5shN9oL280qhrZlTLQ8UT8/jmlPqIj9P6v6ahTwrNtrbt823XdZn8yzd/veIUjdukPEYQAAAAPiL4sZX7nakmoRnKl6WbIQ2g2YWBY0uJS2opGYCoNIk7cIAaoVvcks6WNiSNvYNRVKRVYUm/rlyRDle32yebWbWlqOh9G0lQNKo+wuIXUutdiaXbA59LbGWCCoOni8fl0vK7sF9kWpXC8oGRKAaQywhAICJpE04vXZlWUh1DEtsyJJNgMVjzV698z3tnfrMLqGX3asVw8v7sJ8eWWztHmNycn70hY4xLP7ObVz2kK029CtVyTk1gV3UQ53zt+vWPL2br0/zO328TotVFh3tC5WqVryToaxw4zF2yP0fEPjAr+8myREGOVG4cvw7DUohlrtWZdW5RO58jZk8LmOhDD/SyxO09arIe1InTUVJZt5WYYwlsThV+4u5ISexGvSMqW1/71rWua2WoG0fDZlo3CDqvVbSzbzHvh/SaA+RbLNpnuyMsRjlZpUqqGGeE1WbFZCYVOjxnJ8sDnEgvZMOn7Ej3b5zcpJmZWNkVlZ52e0SuImYZbz3eKo51pKLlTK8nhhoWybZX6uZILCp355v29kb7JDSiq4Q2JUPJnaigQVbRseMMA9lCzGmg1yfrBHP86WSBI2s+dN7ViRXq9ziQNz+Jum548CJqHldPJY+673AgXxMOYKAAAAGNbxXEkGvvUJDBgwxYQtJJ06n7XishR1kZBWinNc5XWxZetGwhWElgY1dJovOq3crzN9hm3z3U2I7dPIcSPIaw5hft2Z2TaX3s84qtNZUFlYe4X1i54OD4+Lg+j+Vw/FBIqCaUOCzlkLuX3hPJZXMr3FSH6QcGvyfn8+cdX2odsql5gd3aW02FVaqxjXb1vSlPnq43qszign7TTZ+WNxxpdc7g9hm1nKbeLK3xztvH1/n5mzHZScgo+85kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74GAAAAfEi0cFYeAC5XE5BKe8AGsqQTCZWoACa0gnwxrQAMZmxclDdBaMsuymqtgErlcjt0lQXNG3veR97VtJqI9Ri+zoRhoeFG2qdTPW9zjbm7DBW6xHGmZnB7DiuTOq3GzAzM8SPikeBAtuempZawn+Fyzq96rC+JlajzYxrNq3vu239ncRbuywWO8iwu0Wt3jI9RKC+sLCgY2c9RHYR9qKVWTu/CypWtLKn7ewbwJG3F4V40WPFngQFEWJyOhfevU01zohWM7+8yhgxnJnIpRRlYeh4S9OJ9XPIzgxKpoM8/4NOXtqYCfoUnTiSD9UQXiwXN+k3pyyKxlzB09ljwYbtSywJmOeNJ9Z1RitEh5uyY1nUfVKbzPSQEAAAAYv7QKNe82vcJFArrHQ6mc3gebFtfFpMtMJIzub9mxVSbZ8uFM3UT343Hh7hTrcJnZaQFPpKOSCq5bzaLXe/bfpCrMcincaQ3NXw3jTE/rSuPnE2dOrRXacVSIVtmE5j2Tx1nQlVg/0UoUNKtCBMhCKKYvx/MjpAKpWPfaEkEg4s1lfBqpkY3qVOSMTBW9/uHqjds+CYQGg1otY+ZV51eLmPqBM1zb/+fAyx7Z6stGx0/3lk+0g4ubhDcHN/vcLEKRVOUN3j33vGYMTEDEz+0Ws8OHAdQXBipK3ucf2170gfrQAAAAABAADkYdFqH8BwCJZY0CKAYBCIGtkEKtRRE5gZWOwGyEQfh05cA3OFwM4IJanL5EybAyYFAECQDGwyRIekiSaZQJwDEwKAx2JwJAYLSFMkk5w0TJ9QYzHKBuwDGIvAxuK05k+5XpIOCwPAw0AgMAgcVwDKpLAxmDeifLxtN0kDyJcHwAgEAYMAQ6QMLjEDHY5AxWCVtcwc4tZo11KaYgYQAANqAMAATkHyIhiQNWGKa1GRBCTUmpay4eLZDxOZ9B0i4ZCJhwYAwABoEAMQBgEQEAwSBwbHxS4GDAEFkB5SS0jJJaCLGKa3QPGKBiOWZk+xdc0L0rhfQDBIJAOBY9i+DlC+HoCPCIDtD4xH4WwIqaFxGis3WaGqZ9BBmZqkbW6yuTxeQMkVFEn3daezrNGdNFuQQaZqQcQQHAURzQ1eWxyBwE2MwISDwRcnyuLIHMJwXGTaaH5gSleXwkDWcOQBQPBNhPPxkEwYSrVaSgw59Db+bugPcS/Z9qrSmSg/kuE/Dn92Z+tl0C8ShmSIT8YP0HWi7e6bIIpoOgghtc3OO27JlxZgSqSFFlmiBMFuZIGKbj0Ljv1Lq1dT6lmzbs2Sgw45zcwJRBA9PF83HIa1329v9X+yP3Vb6kLV/PuhHoPQ0QKzdI0sSBQTd0DRA3TfgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAl9dc4HZwACqWz58OYkACXF7TANae3KZDBnAPShuNRxvEHEbAxwwDANQCNAbOGKABQKpAkQSGA15iOkVKQBxMNGLmnE4O+BTK2IAi6qRqdKeC8URZx9UWGIrlStStYpVVLOt2k691XtefSan3lVtnVFElp6B3+dt01zwQwdItGt4nUbqtlMuIF/1/xxhjoLkhhiyULEWssjR7RXiivEuUJy8mpqXQ8yBQxHZkSTCQKmLd444rR37ic9TuXF4aZg4EDO8wN34o/s3GH8lsN4O+8y8Ki11xMKeiMw2yN/V+sBeF5GgRaWOW/UAPpEIIjkobSDojK4nDdI9kaiFyXU34Tk7AEMX4vF61ypTSaQxWOyupFJDGY9JNU8vrVLF2cpa9evnSUszWn5+1c7lUwwqVprKRyetqpYu0/e9qWMFBGq6DB6alnx9twAqEEgvqT8bSwTbL0xLDmAnCEPxXbL6Qq7KIVnJonIY2Q5pVhzKplqJha9RzkWkmKYMBZrNuUsRpkR8xUVRC1QFQeiXJxcyrFNGRsmDyJZETLCoLAsiBkSilO0I625qc/KDp6jbihZSjm7r1KbPrYvqsTJli2Ly5+q+pZX93GJ+pS37bO+pbctq0KrMYs4ysiWlJqqqOZO53FkUNlgoQcKGwooOhQ2I1t8JrbihZ3r1Fi6zLVGRCkNCkMICDmxtAIkXlZhVRsYBxTRn1Bs4hmzRkmppi5nBZjApgiAGNJJqhjdVW1QWD2aq2sCWs9V28zF5Y8y555S/r7P+jyqV9V2vI6TOrMadpdzJqN5WYluQKAL/MWWBExNwnRcj/CHF6SI9J4kGBZAEQEIrCXEKBtG+A6g3UCPUskGKZoP1DSBAXgAcGiSIfxuvB6idK1DXsj8vompYU4/OV+dKhcU60bTyFTsadUAsSWIKMVhRSOPlCUCqk6XFcK3R+iSiYoS9P45mVgLcdUa0NUvFDEjPqwZmJDnFdJ5ib1C4sTFCTyiZpVDAUymiwnzNBUMz59InldaDVxpeFGeoay1exG6a2Hz61YuKPmLNYOq5pXfxZ8+3/CCfBDdjZtgtP4/Eo39OMYnhnIcoRbXxQQmoW9zoSEhA4WHFyrJFBDC0MsaS3KnUmu+0SvVIcqS8k3Lbs0KEiNMqjChaBKHTkisoMGjAaiQJxUwGoqbCweSRaA2uRwqSMde4thputFKco6kLEA5D6y6VjxaVJR6mnUcSKm+/aXPUyzL96yzQUzXqNJNZ1p4dYOa0QgsJRKZUHTwseXPTrXFaCWieVWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJJYlIg1l7crAOmXA9iW4iEiseDOHtytm8JQD0MbmsyldJKPMojMmhAQ08Dg0lEyqg3ZwwD4AERGuCSIZuBJjHMCgghFZwaB5gFyUyBVBk1V+s+binjDbAGHsFiUQfdQBsTttaZap9nESynYKU7VQWFakw5VxMCmes2NPCvicmHJl088zgpSXKkx9kLFIH2aypH+J1BG0K1DBmAixHBnQTeIAFWTI90qQsmh2uj+Vh2w5FCywm1Wp56o4UNRnIp3sZ4qmxyZoD92zoROxv6UxpVMarJYppaXhvN5jMzi/0zuDexMLtwesUFMKfuo0bU8N5BL+9YaTObAwK6NGVSoVVIKivzsV0XWpp2y0aLPO+zFbsNT1mu8VtqUxHgadxZmuXXlXC6fx8uOPLWPLBuxwLTYiYvS292tTWH8f/2tvcGVJTN7sxJCwwGAvg+xCWYepnkQk+FSRCtYSlTym8DjXwXa/r8zNT+zrzE7ezKZQ9Gfnis4shvGOMvsNpOXQWgLjTJGgOjxAFDrYoEIDXJpbGkNLkk2k1G17yeVjbN/CpAmo2xslXpIZyESjTyEYSDxooQkUysY7tSh6tOKXbZycVpNMyy6g3fy4l07gT5G86f85epxvfC9hOrhtTynq793f8z/N/2qxUAMH7+GtIaD4qMH9FxOZHpW402gvaZlp0DGLAcQpqQjixjMhyKgRrAlo15OZEZW1nTcWSw24MQh2pm7UDU8ioNwJFKNiTRJRnVmLMffl+XBd14oaYLDc7KZbh9aep3ao6SWtTW6JikVUysCPULEjojOimNGD1I9lo2xbQVlicD1QlRn6zKG2o2rsMR7BewaxpXuV0xVdRrNrCpmWxzJad3aAut6U5MGwq5W6XUZ/GzWBFZWesWrm3qZ+uWu8WuseNS8OESBtXLp6xeI0K2AnHSdbJp1rSPJm/U0NwbGSFCvd44t109FaUITDEcKeS8BCVxFw+z1Mr22jnO3qhydRXGPLReo2xrXtSbF4Wouaa3iSWLWr6ub7zBrmM+vJ9RSVP2gFAHUohCj+U7eWFjDkFIoMsOSRzKbHKxbKzrbAckMahr6ciELBy5vTEsIV2U4js1ZIJ09MS56CM9XMPM0Xff3adezTLrzk98za2Wy1um3Isgj5StjOrE8rGR67KMtCSUz4nInxYGL9nGGHb9vx3i9VNnnVsJZZ75yf2Z+2navNOb0fzTd/3no71Y+tLfOV7f/6V1yK/Wq5iqdp1p2kz2QNO9Puz7amstX1yOaPC6u6hZ9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACH6LxgMve3LFsRkkPQ9uXfovHAw9jcMzxaRQ9DG4mKrOAqaDDyDwI/L9l3WDQssIC1hVBholMML4xzeQp5C8Z7tlmpZbOqzMdhWpwpR3pM81Ci306tYbuU5+vuoo7E8ex2JhmcGVPU3prL4tOSuZN1kXMkKHqV6107FBkdQ10c5+k5Qtvi3WG+mq6vI3QFewmWb6y/pDVzetobV6uY8eG31xZUvm1yihDBVEPMZU2YMR4kdwRLWhDuWjx3DOC6JZ6PWeM41ZraZS4qUqxqNCPI9Oq2KnYR1KpXNJn7y+MEkUJQMDdIqp3Cd73CDtGuOGJIp09lJVVPF0vHUpmdYcnui6K030SdTcwOO57sjSn3q/Eeql+9c9zRZZ4XjvGBigK5zixc+XbE2QWPeoupwAAAAD7t65oTwwl5hqjSZRc0slT6Zc/3vuYWzRLZ0i+JJiGUf8sGEiqnIqyRiCgtC3iI5T014Pv80rnWvmDu154DnRO5fy2m+vWms/GobHiLHe1fzMeLsS4aJ39XeIpeOuFao0UMxsQtubNQIUbe27x7wZ1xeG9rFcb03rOd6zfG89xeK1is/xjG/ptcqbkZ6U1W9/494mqRo1I7Pr/OIEK/eQ873bMTeLMFNzza+o1t6+9wsfG58bpq+83kpTO8W1SSi4PJcrRKQJfEDHnS9Yhch1YciZPRlXTiLx2W1p0lu+79us3nQ38uScbjaLHEQEZW3fMKxD3IdUqMpqO6vWZtc19660hJjV1JG66qow12dPbl4OnFVYFZsbDgW4KUhiy8zWY4TESyszrKyh+fXWRIKC0NhzXsL+xMtPw0CIrDjFq5+C3cvPPGBsVUw/lk8fU0acWdeYb0kC1jEdCwFCwdCUaFNcSTISTjrK5E8yIJc82YUvHp7VieSk9sSiqHqgciE4FI4FTifdqjSssjmjWEk5GyRxzPHhn2SwWzwyM8q9Z7a2W1aVr7ROb22pnrlsCZas5AAgAAB9uxqgjSKU8KBQznDPrG1PGl8VX0ZJ4xBClQqIJBpkCT6VwkDy5IeqQ/IYXvkjKwwmdp3LJzpmdyt+P9dgVFaFY+w9v0mdrts6h+eXVVxcnEZlOUiWeF0Ji+biYIocjIfwKF1GUBOKBsPlYlVX7arcN7OkhOaHp4QC86wq/PmZ/zj2hYIZaMlB21FcmRXjjr0CdJfv+frasbd7LFY8FB/q31U3T3ZrS7t2o64lV7G+69Bdlo9g9mnLXpneyq6hrPZBNKQ3xhtj+2MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAeBi8cDDHtw6jEY9D2Pbt/aLxqMPe3DfcLj0PS9ucpmlbLGSRzyQuvfvkM21y7V8IVq6duHN9tMzlhFgjoqMTEGJOHoulA/fdo1yUMDkxZyK7q/1heesdPyuVTRiWgeVuq4RbV1/96c2uNd69RStOtCM01SHm2tfd8x2DrnUGA4QEjGnnY0YzsTkoYDEztrxMtMEuD8d0CmK5xutFbiIpZ13ZT9/HW7Ro1ovn1aLhWzEJOZqUhwliX47IojScFDTsloScUaxHnmhxn815VbVkVCMJYfBPEUlTUQu6TXaJa1LGLk5q+qw3KKCmol48NZhx30TV9biry1iLJu+7WfxYUllpXxVfre743mPvbuXKAAAAAp5WGxUJq8L4OtG4/ycw5Oz8zMzOtUdRQCgSrDjT0E0SLkkcc44ZKH8+zechlUsLTxc0qZsVK4iQo/kZqz+3+L0h0fN9svW45k2swUNcYT6Bquv/CcYF4z1AMSxEq9QKGuiXNx7hKUUSY3jtQhCkoXdbEbUSuNR8dPgeLGlYmNmo4zszCpXK6LZV9UssL2p/M8baI8cJ16Jy8o1Yfsza/eNlH0aCtx7XzPmjhqI2N93a2/gRo0d5h5AbsKTqmJlxW1Kyw0PTsDcZ3fcL5jP5nkGSA6ixYXtttYn8q68TEW0mnW4+KQRYgAAAAc7jasCMyIjlQfQ7DCM2wt7wLFJ8aej+3r1/79fmhqkuA8XxC1ZABNp8xZpbbYGQubmw3h53H7uqSUO6vrquNLntzySFGh5vWlMW+I+FFVsakkhMKLJqWO1wXurSbvV7NCjwY2FU1ODpefv2mBPDP+eLjOFBEbDpBiG2uUoyP54d9sUZW3w3yvlIqnrfuZ7C23zxIXkzRkLwTTSXVZdT1SNYquU58bZoDgwF3Shon0+Q05GRunRjI8ZW1RpZ4qWAsJ4tiPWla0MaujJlHmC2ukTqOTo3kIRCgVzp72CK8VSeZcwWuDuBiTUl2N/W0iuU0Bg+M73jqueWsfKWAAAADeN6diRj3Wskxcq+uNbfrI//+U9XXNzKTOmhbhNRldFD+0AgZkl8oyQSjmL4pZmRvc3zFWmYzM+3bX/tTEzJijpFotXOTlNN7/6+t1qn8vIRxqxvumD8dHXIpCEkmjyHuXt4yNS0T4ri+IaIEWZovGdss2RNtbW5V1EViGF0o8hwSeLh9FxneJMwLrl4qFafqBP45k+r77XTZWWsHUGOxK61MYgYvrbx8yKmHCdZnvBsxVgZX4Dy0TsU9qNieVLHB3Hi28DMlqUtHjT7lvAjYdTPHPxaT5qJxg2z9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHaYrHog97cvJxaPQ9j26d4iMcCeHty7FFI9D2PbkAAAgATFGdAjiSl5SSAW/JIpbmOG/9KrH39/+BCgQGNWPkSZxuZFtLk4tl603huYUZr1o8iRazvZX0O8VwyybZ/32ZaZj63nfziI33jMRfhkoWzR2bDc5y11nFNwaKbTbhdSvIzC1ssJcHU2M2m1zO9ketBknDcdpDS+H8qR+q7blDrnVs4eJZtV7inIRGYakXf1X0x9KswHy8zbkeM7bZTLmqrcUXBakTBZorK8RS4hs+mqr2JNasaMzHCnoURypernFZIbHFgQ83TztweU3Cw17nnqz1gTQbQvvG81fM3o8YtMzbC/vPXLyTT0oAAAACJIf01h/rMK2OKp18S6JHzMieabs9mW96BUhmokwgyfqKAjpZut3W3Cmjg5TGjZ1yXmkHvvb1zxN4m7734N848XUjtwgyx2Uw3rHNmPv6jWprW9sc7bFc22IwrpXIiM1otwRLazsaVXD9VHWXo82oGMnUNdORYoN3CSSIbqEoXO6eJ5sgLtnUyqhq7MHGNZbbRk4hTe/P1OtZfGpSMydWIUfFH9mtRPWxwREj+O8kdw4CaocaqQxCYJpMzAjmF6yn29bYzHmDeMwLZUlY+UkdvpJqPBhLuC3LiBHv7Oecd643nYb0bo9bXiY9ZbTxaInFqKYFJil2WmgFrqPqgo//PKrjr+Zf+7k7jXdiOTddxChErVsr3pTYs5fWjMdkOqbV7K7YysVpbyWQnsBORaMUHcB64XzB175pN0Q+lqr06ziwMbVSHFrNfWMZztvVy8ysDlAa3yeU7JGc8KpTMyuJWonAtx5C5HQSKrKu1CXOSzPqXdswGaZmUjOhKjZz5TbY/bL/xKa1lWqxYaWKG1TOC2rV1KltPl2suT90nm9ggN1FU8eQ3LEeO+bpYzknW2Ht7S8sjxzZHCA1RYGXShTcKl4MPVokCsSviwImbWmzqeSuH+IMZ/SL961EyAB0QAAAAA7tXEMDaXv79Auc4+JCrbP6FA+nTM9CoZ4uFYfDsSRIH0FlDCd+aU0mnd8bicSmMHNIik+dQ6Q9ahQ9YvMtfwLf6rHnT7ErMw08rDAjbtiu33jfevJFgTv0L1HV13qcxFfWRrC4HjZUzltaCak7EVJul0KZ2qjbJSR4/gFTBX3zXFvEWVUyq+MpYVI9N+ziy1b3OKqDxVLShq5gNxyqVXRU7A0oS7Mzq6uo5Ra2o1ZiopgROWFMrmHtQzP8s0Q3lRVuYJm5tgOKtX5Iau0/kxPiF8KGDGzp/P95gz3xh/hycJ8xI+72p5A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB9KFyAMPe3LNsSkUIS9uagItHAzp7cqJOGWQZiG53T0kffYwIYOuuad+VI/T7AG1DVjKWBMBPyxCYF3GAIAAvhviHlALAk1o8Bvk+LQJAMMnwboMcXQQckxqCkD7VzqOyI9jrEvqHiIx4mY3isbVfOyQbvINNys8lJYmcMDyaHuV9ExZWMpQp+iPvJE1Dh4piJR/CVitvi7hLp5uePtwU7kmo19vJXVWdm27gUfzK+PSWOwFgbz8goeuGR/GgqCeHGvmWJTNJ1tmNx1Kj2RxV8sd5i0FXQ4237x7SJhkcntprMLyNCdYZXKM5q1mvJp+yJ67i1MksJX6iPI/eqR/am5Ir1whwIysprdq6va2M+bVOwzb434DPpEAAAAb6SQMp+QWS8QLtPhe5OkFnpyUqTESJJZsHio+Kid6Ni89o0zPgp4pta0iRlKiRYD93aWtL2rPS2v/4HbVxa2VMpXT3LvVq33u29wNRZWRjaFJM1Z0oVDAWC5skImZ6LS8cqVVCBPJj7FCo7ZWaWu/nSqhssNzjWhsjLHZoVafP9N+l8KBsZVpXOlqFO10f5vGktWBDtTN8Z+db1SNBYot4ttbzjD9W2hPZ95puNid7uDC8OC1e931f7W3qnpnHxt9mmcZpn63qsEj8MPcJCCBIFdCaqJwYMiMj0EUA5ABTGZCCAhlzxhEIyHM0FM+iEIsMWmrLGQQkVEyqwLji7wwDEAMUOAkmBhpiVQgTgoObgCc1AZ56ZxwccOboaY90DGZCJGnIKbGABl7kG04EDkSVSqmVLlB/yBuzd59MZVFLlUQkLMXMjW41Qk3mKU/VOcJzR+W1QtTMoT9SpoHMf7pTBpKZVe/SKIOJTq5rLahJ9mOhuG54o1AzrtQtLSPSW0fphIWb6sLsuTlPdUnCh44xtjDQmAX1YP5vQ1sIMT0MEWUG6PoTYWUeJKksoYt1xDVDExqF4fqcO06h3IJ6ciFlyeKxnVqugMEJ8lly4EyORQyvmV4zK5jQlufqexzrDYmG5nIOn1qJaCrIEyHn4j92cokW555cGptb2Zrq6ZIUHFlA2RJ67i5fUf18Lbc3y6pfFokOHekrnYkiAAAAO8csUTnECwsuDkrbz3OtQ402ylaSVqkZ5cZURDMxXFc8Qjo5o+5jLe363f29m5a+p0Ddquav7rvuJHw9SSPNxHf/rSLaak+ZspRhr0YPAYxaB4IdCQRJCE8HjBQRgnYimF0iJWDbOpThYRag9qd6+NHdoEYcK26XF06XFrLNUw+kTSSZZcs8JX1zwWZV4x08BiS3lkcLvPPnA4/ZtmyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhvi0eDD3tyutBpNDEsbmA+JRwMPe3LacVkAJS9udS52Yo3UdvBjWndUMKpHJXWud1zhCMFuI0FUMFdvjaKVXFMDFE1McwR0KQYJcRcicG2QMu0x5lvOIfCiI0XxGzKsv71ejHIyJ854ygUFKQNU/iz3eYeztTy7PZzgOEqvfxFYqIqcWI51mSTJU5h4ZIJ/raccG9QNqFsysorpd2vPI+x3Oi7V56KxZfquHFa5D0gm0WOesTXiYu5TsDpuYmpyfty6jMx+xJ4dXj9n2r1cpECcaPZGCdRsS6Vq5YoqvcFE2MFkS6VjMzqSzCxuUKPDco+19SwlFCVjVHaqIa8tDlTjK1q+eI8hJ1Axau31oOW2LEgz+Iy5jy51i8L1gvWGA0tbjW/rau4dcx6zMAgAACetAhjyTjE1lkPrYos2d1PMghtDAmtyBZteRErQiDyqKCGbFp75LFfieyggkv7vat6WlJ+tKfZilKTe9Mqc514zvCsdrb9S7fUl+rd8cvCjtePUyusak6GGiHVNGQR1EqARyGcA2VFFekyjMP1ihtXUK8KtD5canzNMnf3Zxhsr+e1NfzJ287+fG7e/Uv8zmcx+axZnH9rMOx31j759Ovei5PP87v3m03pT/Y///tzOxqQrVH8KtfKbc07RoM5UfgGEvmD3SOxBKpGwHM8L8rl2PdGIUoo6mOpJmiS16O4I0byWNZBrkckaCnHFpQ3CuhWZoqqYZE8lnNUoTEUSdjxo14222uYrbBjxmt64yvZnzFKsxbrEJ8u0NFlfRFdXXaqwWpDnJuOZaTqE6fxn25XJ7M1XmVqWirl6vOTHV5pZXZsHrIfqxuLJu0J6pXkipjwnrC82ztrlCnhXiwoL3KhYlcUytcW1jfnLBfP4zOrcyuoT5D3sLKrYIkJU0w2H5Sdd17qMtw29/hzamNmXbgp1yrUUpn7nDeQWRcSTTS2hVmarxWzOJcQ4Oc6jXnjbrAW4Wcy5rmWYJ94q8AEhMhWRIIoVnxdi8ba2cfkfqTSopcSNMi5IXscHliZ8djIbfL3Fxx6NBORE01q2Z+2RcRo98w9PqQo3e4jxqtd3N+swWDb6e0KSDFktu0K+WGDp2vLt5FbW5dL8rOlVM8Pd8oyhVQ41Mnl06AwJJUKZr8kCDLGYlvTNp4xTQ1NDUK43TcS1v8bnfKpSxYzK4G9DrV6xSw3sCJmO53tq1t/67uG8bLTNSzveIlYlXloMZgtuG98at5n7bm7lGzt/6wKZj6vWmcapDnhwdYgQIk2qb3m0m9SMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHNIrHAwx7cufxKPA9j25driccjC3ty7tF44EmPbj88dVw78otWtKOw5+uxH05ssoT+bPTXt667kpTIgCmTAPx2Tcts4/VF657ZrVpxpS0563yp0t2dt97N8KBvX+P5I2nN2/jRJR8vUCyPmqz2Fitr73ZzKB/FXcSDGOxYRu3s7i6W7tCdUB1GmoVyiTmH+llOXsmikhw48GmN3lplVMiugVXCtQ99AveDBvfFm+JOuWC9Kq2PbShhszer32FzHpBivWtvgs6rgSrDRPRtb2R6srqLNarerMMatnnhJiZ5K/Vy02Qc3lmgvq9Rs/sye0D6prMsBujxX0OzlFpaNaeSBaSEn+YOmsE/iSexGzSrjdFXZWW0zP7mT1q0t1an4FhnqEWyu48xuN65RZ+6wjStHeq10NbwcQXDVtxtz5l9tfGLytsVkeUeMkF42OUXVZs6xqlNWu9kXmyNGe7Z02+coCnkRjI9fK9CUMnOpVDBIwPUhROGNjYKMkLxVREVzTuA/3WLD21OECas27fG4byFEUplqV4uIbnGXCHN7pXPH2Ir1dyPbpFcscJqYlJHYIjqilJmm0VAdQpIqEP1cr3FaVSe0biGQHiha2M/1XetY8Z44QXjDLXUKJCmzq7arXFnco0WdzlzF/y+zjgAAAAH7Hd1g8snou+0VqO8+WLZ3wiQpx/39qn1zAm00RAeBPIMGRiXJMcxx03QH+o6zr1VTVKE4dJHC8Bgz4Om2LbNvv5iQF3azam4ImqAVqtbIr3EmZ9Uz4cz+HlQNk7VDYWVVKqK8MVkZUoo1Wcq0xRhfB1qpESla2QL5Wd4tBcMytxuGFogsY/lQ7Tr2mtavvbbQ012xrhJRG/TLFb3Nrcm1kdRYC4jtyrYcK2I3r7axs7DWrFGYS4wFyyw5aq71lkw/a4KmfK5LptziwXuLRrvYO32JN4g2d+29VeQ4dltzh0bs4+5bucGso+edZkBcCsedQloqJqvcLbzP1NWv34pnK2uqLBgfQIbgkpHoXlsVH4k7TPL3zijB6curL4cSOT/EsCNvWt63Hxn4gYV8HDLPNKdyjfPcQcWxWLWd/r0s1RoijY4jK5vqHjEUZI1Up0UtsTAcyNQ1CREQggQU0XtWJ/NEh4cbIWbJ/qZ23trMul6rPEVUOubeusMOmNiXCtJSuSbUgnUr3JGKbUas0OyOP52y3XMVfTssCRdORnHc3PLKc+WVT9gU2nTkyr6RT9X0Z43M7LWWrFhlixawGKFCc60/pBm1uWFCcGdztM421aa0Gj59ncbrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB4KJRoJve3LqcUjgSY9uXdYpGgo97ctwxOPRJj25utaIH1Bo2KyKjS6KCuIuI7jvHzb+0KPEZVG4tqWJ4jISIiwWDGN6UsLJ1u66jO8R2Srl5YbfpURIzc9tqycpqtt/dK1hN8W3gPCJQhbMpSunkbNI1q4+m9Ep03FIrGFTI52mVC5vybDxZ4qrgkfJETpyBYtZKCUGIZgwDEeamg33Acn23jRBPNbGsozTL4pLT63Fm+Yi6sTc/S8HQysCfYIiRfxDwpDevIauY8tcCO1PLuWoub7hywWZXp2I+tPiPFeqR8ySLVocByQcsHUGBJJO1RIM7+FHY55qKvPivpG5khtbE3MShZZsZrrDc8EJFJItBHx5sVkYNego/a5WKL9Z2cgjfuiPzSExHkSMrC/ih3tWkrIWV7B+pgbMjhP1IIznljxBkg5zuJTGNa3CnmmpZVvLv1Gb0Grc5ws1v4G97hPYsyrPVzZk68ZDCnZ1AP0i10ol0pU1Gojm8QNjLahS0yH6h6vnhUjRIrEnFTFnfJBiPFkXCdgxl6NmLXfg5X1G7a1WMYwWbbNO9iQGRyc97bk+jW2JHk94jC27WIDw94iEnq26fRmaIf7K4pQ+DIP5+3nzPSIj5JnqeQqHS9t1ljyv2mTcOuaY3td6UjXVWbxm9t4rNjEoetBSZkBohrNWHXGjRwiQyV9VO4uM2vr1tR7hrg5cE+/Imc60ahGnyPjXpBYI2Zo3i3gMD5xb4za36WFK7VeIt3z5LW9rY1StobVLmHAXZ1EMUqFtsjxyi6z9Y+YygajkaXJaZE7Y/KoVMO1+tRTlNJERzkRCwWJsKJsH4HKcqgU1Ja7xlsxS55qE5dM0VtJy8ZK+Pea/XDOSswkki2pOnM05gRmJTNKnuzx25OM2t1ZHFTw3HDctK6fG38jWibduptkmtChuTfur1cxTlnQ7NYuM3pn3aIuIOZoLW16+5MXf1jTNd5HGS1487ZRytiLAAAIAFBVQF9bWKyVdLCTmzq+q2ezf7KRevTMwA3E1CcFMabcix+B1CYu1rLU/C6mp6FGezxHsWXFNxVmur/X3CxE1C3aVwSCw3Ukx83jajb3SRqz7skVKwXBxXc7K9VTMs5lSjfhjPdbesKED+PtHMUdwc4UCV2xKGOsPnkPtjNXZlPn9rz4+LNT+OwM6iRB1OlzlgdpKWJPHboj+Riiv86q3yxc3s2TQHrfOppY1oVXbAnY8m1FVifR22JFdtcaHJTMuovraM/at2xVqtb73uZhbKx/vwb09LRsBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAeFikaCj3ty8BEY0FHvbl4qJxoKPe3LtMUjQTY9uZimgXwAqxLnlrDhm6O/De972O2DX++v8P3KsOj6CO1Ml42c8VxisSki0gbTDTNi9Mu4F9zyavbben0u5wo+NNkemtZ99V1k7oLFBfLiAPNGnmzuM7HXUz6mLzriOZaEN/jtreywNR2UmzGeiVOs0E+zH6ap7LKLQDCM4viNbLwqR6+lXkzmdCw0nYnUsgDmTSffXml9IEBDz5hro4z0cTwONgYVNpiSj1D09WQuiP7Qp2WNGYnjm3PO9pB7Iwq+BAzil41GSHGhanY6RKIYdsN9Et2Z9Hzd1esJ68iZreW1548DaGsbImY0T0vdWVj6irqRXNwpCLbLWJCSa2xyL3mXxZYHxeJ/brfpHdLJ/oWdSIq/owXjbphnXTLVqdeAvsbDDZWZegMUDcSuJHjdRucL43/qmXywu0Uc7prhnQkYio071F3ncHc8SCvtTGzqaJAUSclc4DCeYqUUhpez8YV5wO481Ch42HJ2MpdPn+NNcBrmwokPXZ5s8dgpIsPVlVp6Zqvv/dG8/XRzw7kPIydSMN9iU6OPFt1FzOpC1Ypb/caFFYpm1kj6V7g4sDWrkMrl64szA3t76FY3nNZetSSdKCyGVYpb473L2jnCznGJsf7iML+Hp7fONN8lqx1hz+LoS0BKoPKaChzSFRz3LxXOKJiFCzjP/94M8R6tOB8uBEohFyRXJ/B3iG4HovXgfw4ensR/pnhNymaz9y9fyWisTJDgQN63nGZXsK885pMBe0y3qCBtrfNe84gUywJdILmVlQ9+wtTHaDZCFOdKuISojUZh0FvHOPg61ApTDPVWSOc9q7/vS8tleyF3R9y+I86JHCBnO95hH6YaFHEgmpnTSresUFaTJ5ItOzWdwYbhdWNilc1id5lgjxM6xKukIfvJJWxrfSbTdMzsWrTu3kSNCrW23ysf3ZI8ORxjLL6e28sUF/Ahv+4bcNVtWu3j+JPLTaXQA8EinUOYPSONZe3ckrU+YJdmfjaj85TlQ9Okj3m9OxR1XYD/WWmF9D8/YP7vRH0zawLhyhb73CvpF3vWNYy8pGbmR5doZkLbYTnv0f0nbod6WZW+qds+ORU4dMUBaVC7ThlIQm0ohcUhZIBXh7qRjELQ8/H7uabN/VpVT5FMDi3QXheFy4Lg/5m2f4xqLCUKnXRpwLqsuapkU1V0cEZ3GtpqZ4aVcpVZDj1jKyAwaiqNqyplfZTtimYVEjT+VijV0SGo11Kaz1jZXJxgK1snpdelYX0W+XVY2fbW9XeZ25xfTWbVvaBmJmYMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgxi0WDL3twz5EpBDUvbiIWLxaMve3K2MKkUHQlubuNNZTeOu2HscqAlCoO62NkPGomXA5YalpD8fNc6ZXzAThHDrEDDnZS4k4TGYjFC2+TjK6VMA/4MTTuH1lnhSQq7cFHV7AguUKJK2TU1mvgT2b0WywJD0MYBgZVduPEgMD2Pm/tNFUcBC3GRhXMedx6sVaHKRFnMaKPfybw5PkaTxaY2NmfadXzlSn+6KMpV0+YDhXLU+cC2OT5TZmh+jzByJ0BEO5ecHFDISFI9TMp/s6glXzgdj1iZmhpUyObeinFXKmCztrC3v3+4LovDi5rBenhjK8XBEo2RPngT2OzE8cYTAyx7vKzMinY+rlzeR/uNSDisRhhXZNWSag37Vb4S/uFpnpSBBAWqbu4rvdzQ+tS6zftvqcIz//vPvEhaixRZCopc2m+rpEjZLQmdKwU2EYxc26Z82+bMTURzxuuP/fHclFizWnGQ4G1uxeJArP8embQ2eO5wMUtDbZ25TrKtURWJNYTb19Ku7MbAroDBKm3KM1Rd4bpIRyKqsFzVDGiu4n8jYstL5386iYbmCG/ZlqjqDaaJFrl62Tz4h33H3vGr01afeZIHeV3uk+t1tem4OGesrx7AjRp6agY1XcTUG2ax9xN/1819QmvwX2d6xW8GPDYAIBAA5RV44Ohm7Y49BuhS/ww+qJ2FjmlnMrmxXemKZz0QsOVj4H6PQ0AnEuSkXYvqGxUdAo8eH2pkOoyw5oT5jrmlWZQqqK0K+IsYZYjaqIUHHzXevNKrUu43fKw9wmVJW7qy7Vm4GaYkjYQJ+pJkz1hhdWbX7cnkGoWNPsEJyiMLOfzAhanJAT9Uw6K6PdsbzQcB6k4k2c82CPc6l+IrJNPHKJjENDoY5hpG54xfD8Q5bH4iicp1tY0SzvkiHeNdmWY71rck24vlXlmWGRKp8tw4j3UUqOVh3UXlYXAXNAl6fMxbmSZ82v5E5BZW5bZ05BgqWlTHV3iRGyLJCba/T2LZyVrTu01s3iKWRl044aCCoYKmzlQcGoyCrX193V1xa+8PLFiIC2gWi9gsE6yMtoaCEd45GjKgnIVBpI1FOC8WrSbuH/+aubMeSpRDGDpQrY7u7fknFVVocjBIQvghKIwdLESp8TAmgJTADkpCKyIQvZyshOBOiKzLyL0qLGyAUmGY7ufK9yELg4FZjbGNVqxi15LlZXj/LZVsslr/JAkYQ3LJlYzbbZnHIsSmsiOLP3dvc1WOLuycKl/7T1+5F9NNr3Ol2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHg4tGoo97cO7xWNBR724eLisaCT3ty4rFo4DWPbgAAAAAnDxxMcwBS6QhvUNlPRD7Suabb3cWbe61znsVIyYbDlOhuICRbULaomSJBZq/0w9tPilo94NIV3OC1sz88WdqUWo76Ewwn/vn//LA63K9isY/G5C2D09r3tv+FEVZltkKKzsqsd1anzKmjvVzEkFSrzwShBDSSKnXKmT71XNcO2sb1Vdx4TGlF5Ei2ODeYClbYv9XDFtwZR4rhDDwfrMaBdmVzysrcu5aNbiqnNuy0w4EKO52fN1NVpV43s+LxsbgQVVRzjPGy6Qb9wlLal7X1V/qHDxCb4kLN4r+PSXLyHqjI7YY+/XF7QdwZp6KRUmWgUkksnUKUXokbWc4wxxosX/6+Lv2B8rigNGRKCstotH8J+/h6q8VkGG8xSuolb9mViteMDCypBkzpszSWBisXePfMN/IhlcxFc8TTfFjyWtn0rjWYb17M/qzLC1Di4gsKOQtOHC6YUurEPSxhnCdzYHGX1RK96vMzzGFfBY1ULQooT9WzpOK4IlgUzc4fetU8sRGvmQ0zAhm4vyI59RqTzTqkW5u1Wnl1dqaM7d6alc3NTaw2Z5melmJUKlmXL8vrG8olYb8yLWOiCoJkvEZLt8lLx4Ee1fa0CX47a1KWK3wlzqLjsusvrUtKkydAxDXAF+T2saWzhstNIHTM1L6xuf/wY0N+pENbpTsMo3C3QHBI0iz0tK3uoU3niyR4kJ0+gR38M7lQxtauj7oxt1cw9fNb1Uj6e887GSJX2TkG25JvubV5oWMnEoXpzPrRFmVmhPFamkyvocqESdyXPE5yjSAgyLYCbK1KqzLjD3PRtpI2rqAxmknT6VheG9hm8fEGmJToMp6hjk8Vk1lA4aZ1AunOjgwsB7HrBtFUr1P21AlVss+cNTW4tM76JaN4WYEFdRH0KrZEb1tDok+NQo0p4eRsbYzbZjliMuLR6vI9WeI7nZK1+sTWa8t1pByk1IhBAFcyssRd8ko+zC/bN/N+Zx19kqplNzkCyxi9bVveaZD6pax5Va+r2lx06WMmJcUeV1HjRL4tXeNfwkTHZWDxFarGvNY2c3xj3xSE/fQWN5OssLg51eMN1IhzG3OSw7VyJXBcqHscIxSXnrXSPU8k8JhgNdUqpmBvaYzKvZ2u8O5XsTecwpVYlmpGMCLMOsBzpt9HeM2NVbVIb8dG4bXqvhbrmm2eIyJxLqP2cnl5XFPSsEFCKvoZ0zzsi4a2JtdtMOssLO70sqYesQl1Gt7Sws1g2jKyLrEetabj1gPusAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABzSJRoJve3LmMWjQTe9uXa4lGAi97curxSNA9j25WZJICvgTUV2TjARrUI4tYx2vbqL/jH94dLtSlvaCUR5RNHTClW71hSQoLbrV77tBYKubld83RXI42RXO7wYjIzzXe4+f6wp7ucCK4m8WxArlk2zXrnFs7zEeK95POv1swRIbdETrXIrX06PP1TLdx9FzLquRsK92cja8pBtH3n1eMrxCj/7nO6Pd8+3jWfauWA2GwgqsUyOPaFpW6P6GqXFD0YuJmNCG7DKzMMWLBze7DbcO0DcOdxg4zqRgb1maZxcYT6NlPT2prW5VP6w2Pclo15bets+FNM8iQp3Fwzi3j1cIV1VVnEmIGC6i2iuKIvURj/OGtzi697W/8O22ZZaHb1jUKEsrqLCj79JbQqwaMELGtKODRtdRH8KvjyOvEjp5l3TG9azmE5ZPSXM8eto2M58XVqtupa5ZG+tZGpXaf09H6egK5XF5lXCeZWxdC4nISohSUWlBO+0+jPceNpzfxaRWZ6wblYlCsyY9ta1mZJLqdhRR+KFXIY4YZjVSzfAvO3KosCmpB04wYu408r3L5zVdGqeyVbYCskgOEZZQlUqFDExhw2gkNccMqysbzWJE1GXTFDgSWrAzWDqPDZW+TcClpfvVoP+Z7zopTgSoZEMUnUKXSZSxa7Zzh4x5rC+5vrUGsE9nyoa3x7sDlFjvJY0H7n1m87Je8N88mcHmLPrqdzdVndz4vBnru2vf+92VXOUSVShxLKVQ5lVj6fFtLjOZoEihLHRnh0crl9Vyoqh50vT5N03k5FrlNmAjFwXs0DBWD/OB5dxfQKSs1baUiQPMoUsojpOg82POaOeYO29DFIjDrlX3U7+BZUv2lWpaRpjOi2wWZVselfp/iskTEv3Cqi1aroWnOWK+ZqtbQ5OWny5nP9PpV3B+/WK1LV6v26G4s1r+1c73uNBapNQGOnvnbFBgjwbNvACnH1m25DTtr5AXM1lh+7mb/dOQ34uIQ4MKiG/QsIqJF3QS2OjHqUyxjF+nMkpfGldPPCmnrX1i/W85+tfT6OvwLKaOmHrnAs/tWTd4Ns2y7zIxODguaKA9mFzdnYjzqOxbQld01BTh8p8kJcC/n2uWJjV7nHdMy7ekkLGror9Ca7RKpO4n6ggRFa+39Rm1kfQ0uvJJTqQgyPVsVtZW0/mVhfPj5YJ2ODd/22Z7jFGNxVi4njXbmZcHk/rAanB0rGt/q6zCit8rLNDcVjdo0G77CmTMDPpCg73jG26d8xWrGr9PNYjUrF22AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAd3icYCb3ty8FFo1Envbl0aKxoMPe3LpkRjQSe9ubmKhNoVga2LI5TKaIBNb1Yrapeud/yw62Yn7nlhKtCVcT4lDg8bGamLwcKjGK2bdxr+0FxiSRD0hT7YFfI3xYnrFznOa3alXJajI1vWphWGt/P859r63iAhxfIxVotxlN1KJg3lTWcwTvUCDOROuMitZnFPoYSLS6SSyqnKHLeSZKQoEJjRJ6E6bmUcrFAVHiwGK9fMrB6lVIu0ScSh8+3iw7jPm1sfTMiivGcstbyBCgTRlX53jdRKq5XLl9VramqRwYczv2aFMsNO3z9vzirTHXemGDCzM5TTMm71lyxvqPY8NrgtrrWL0bp5YMVKAAAACFqWkIxBdDWxZGa1LE81vPfW+rU/+YOcQLymovTLlPLqza/bGreo0ZbvJDyyP6M7WwyvVaxQm2fC6iwMajVfW9Ma1i1qJOKzsd1U/GKnLZgZxml85varG9tAnRCcdrpRP0mp2JkZUKYC6m5ZmZ4cKEqi6FChyFvboJWx555FcxF1WVbDdu1KrT/Z0VHY07iJ97hQYrYcyqc4TmVmWWJi9MPndob3cEyp4m3Ndx38KB8xnzZDPFicp0sdrU3q1yXmJsb2FRRp4sFefMTDEWFxHtE1WNSznd5DxPe8vxjUW0ZyfVrGzmWtImrQsvdLbt62zAmzh3HFjnMsaAt+850pbbzjf1/WsJublSin0wnMdVJY+TxXDtj95aXb603iK11w9j6ivojx2+ZXlu/i6VU2c4/xmjc/mrChMbtyaX8kTTdjXpiauGFpc6vTwq3r+sO0SYbLFTz03ztSRbp9LSGHSRhHtpY1GazZJtmnxWFqExv1g/IKGQ2d+z/Oq7tSmnNsXS0hipQMGV7RWKeKcL5jNd45noqWtwb3BscnbjeWsPcOsunUeA/gQLrh9tmcGabbZaS22ez6NeuX79nkpFi2jwoGJtS7hunmPNO3z2Zte3mZYu5Z9ha06xyArp50TEURlIkoOX/OHu/Lu9MfWZLQsMh1Uq6RzEnScxsOESS+ldLXM9ZcQnOHAi5bEj6zPaRosku40HFa4+fA22vG1iuyR1h9H3rOr59I2txLtUZagwjza9Wfrk/kkVUF+oWk9kgpTpgNjw/y1EJJMq4iIOBSv6OC6eJhOJueKwXgv4yqgWbsVcN7pmRxjRFlC2tzJSrFibvNm+0vHr2PGXByorGYjpyfYnns2qqeK1q1cvrN7KyP0Ob4ativo06uWi2uDczLlu3F+vt/PHvPO/Udd43DjW8u259a72Zg14N8QoOcNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHeYlGAi97cu3RWNBB724c6ikaCLHty7bFI0EEvbk6paYQYFSg8fh23jrB/b16oL0l+NzfGJYUN4i1yxoevr6YWkkfShVyqi2gbiwXCbxLv4Nr+76e2oZPGKJCzBlb6SVtuvznMlpqKxvSspGmFmdoTHcY/7+0fxn6hZEwplQpF00KNVxkMRb9GKyqcUrbCsRDiLUcBuHYWxlMRQR3Jwf6lrNHhuChew15Au3Fq7D9XrXWHcIMFEDijnesOLjJhTKc5T6w96iZXZ7KBEr1XFmcIbIf6uZWh9FUagXLJF3HeUiyqxXrb/NnkCMz5Q/D7dt3V8rhFexVzuHZlkx/WFFYps0iakpDif/dYNhcqy0lnQzgFVB5GC2s7F8F9PrNlr0m+vr/O40sRrMRIn+jlo6oKjbIEL2n2yQmCPAl28mhSwXlLrLjElZ6sdZNZu/l3TP/02P4GL7jLbxPNzqA7lePbRbfFtR4sNteo+DFV75WwV9SH7ZFqdcvMRXg620YiPXBdFS6gqdmhQ4EdugJk3meEpn0U/2Z5d6w3ieNm1vO2GiuEchx/LljgxWedvSSru31gxj2UzZBgRmW2sRH7VBetyyozkUaidQIysVsWY6G9jW4ca6qbGRsftMKEuGB5Eveet4l1dG97ViU1esezmsViXznGdQMR931K1Mn0DoRxA1XH0b1qFZHTv8unk2t99+ZhZtKQOxuZgqXyIUhIJqQsJu31ixWuit25t7xWojOI8rMYLS2tnm0ypWHXN66/7cxQp47KShjONxQ1ZiRqXp586+qKFWQVMwPZYquZn8x+txOYRe5Ia5cjIPxQJpQrktGs3SQKed/LmX1nvpdPllQqpGI1Mq1icKaxBvncFpRaFNbU1sCUVzGwMcFEQ9OFnyrYVlpyz7exJFbLCZ9Z9asUM6G6HC9IDNO6Z/ieVV0UV/2f7zDnVba49ohaxG1Wnpu9p73ZqxIeW6LrF4cRizqND1K7JhGI1J3G4XVVCnkHuyqlpNV04ZOKOlyIHzliENg02SDpxJasRxE6G9OsGE0Z+b1UR0TMtqsE9J6wIEJyg2xXH3ezezuMV0pkycsKDeNW9sbxFgfdu8ldJ27M+hNydQhSMwxTiUJPFWupHR1kjVL4fQSZDD+Q4/Te9n0aC2M0VOrMpyLbHe0ZuaVQ/b32defMNnYYyqTpxDdP9MMbUwrhRxe459HpwpdvvBcWROTVfyUncOp1a5RVw/UTahqGM0dlYFXArVJnk/hp5jZZ3GFTV2FuquIUFsf6nmzaucPIFWTV3zPK5bh1tLLPPeoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABveIxqIve3LrsOjARe9uXU4pFgk97cu7QuLBF725AAAABC0lwnBF3uPxb1DVERr8ypTNLZ3q/9dWrp6sN7idpysB/pBipGizwaQWvEle+y2xcPavcxY7i+ORRxKaw+tSv+/vXr1Kz2jKZ0euGmsaIx0tTWs23WdXRH065ngaes7uWpbTZULNLBcUtdiUMRAHaLKzl7bIbZ6X1nVbwWaJY/jXQk/Z0vLA3bN9Y8sRhcULcYUW07Gy3pCZK1jvXFPVVWG1uetUFlm3ErBzaNFUTW5QNWnjRnsHVnK9I7bOwsmN4vrxNws7bn3h4jVrjy6nixbaxetmav/8KMcVILSW4RgqTz4rBJ6hWSOr7t8TMm/TX98ZvSDAQ5nUc8Z+fqrZo8ryt9Tt122aRyg3VzG8w2RqRUOjP4F4s0R+2uWH+r/OZWxVToTA/LEW6TD7FryV3veqQaMLMwQIhfmVJr/bmdPHsWIbx8lZdjdpTbG3KotSDFcM1lbZFzRtgS2hpk4XtaqrEFHK5ti/DlG1eDNK1ppdoalj/LaqXyrg4ixC+t0aNTF1I5K6DFeq2lZnGkVxSK5TquZ5oaiansN8cS0w3Q1kd7Ur6rmytzGvH9U/sUnk1NmsSHHaN2zaauLXccy5cXTNauZnaHpTpolCcB4rONQl+NcHj76hrGcz/3x9zN7jO8cW1jJ6pSHRC2rh5Di2i1lVzCura9KutaoxY23Q6qNJqhlb4TuGkX2ZY2tSZ/tOr6Vcm06C3NMGRK0hTxad/61jMcKEhzNOzKKChe8Il4ymsjTsL8qikTgmSqFjXY93JFqQuaB1FeT23Cgwm26C0+cVQwO2ldU1aaR9WPVJYWWxDjycVbHdq9VKWBdRyYZYCeYW6PmeIzRntGx6+pEtejU9fN0Z+xzRmdqc6T3gMLXFnb67rTFsr8C+4dI0GmH9YdaTPpYGs2lf0j6+MUnbcxvQdNHYIwbVFxWBv7iJkT80XbhrMf3zP/RthQbsEzeUZNlen3iv1LaC9g2Vrx9DgZfzSPK0rAhxnCJduVT3x2vuDPW2v71h5upYFaMbWhBfrtlbwoUWFaDFg1jPJ4N1TXEuMMJ4sSOM1hQKrMlQxDjSIsJtEoNhRjVLaaKSV7M5PY7Wu2AyzF66Zd6jq6HROxWKlcZp4UjUrDk54D0KAu8dSqaM9XbtLRszytyLhu2dioxSUiLiTUd65sbml3JubnKGtuTMm4SjX1cytiqewY6RQG5n1Ic1MRZoO7bY4uHk0aPm9ocZu1uzK81BA4aKj9gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAd8iUWCT3ty5PFIwD2Pbh0SKxgIve3DqUMjAPY9uTpfUcCMDioOLo+tSw1Mra/CTiYxrHxn4hTOGMKV++LaMR+cLjDfam3FhyrNo24+3Gz6GzPJob96/q8jXYZttcz+jLnMb+m+3K5qlhqwnQqjEVTCzQIMjnXP9tYiNahq4q+NAfxT+nTi5USyillQnAkFgwy2FCYQ9aGCTwV2+SLPZwjWhUvdvVjM26N5DYqmiJZ04Ujf78FtbSas5DWpGpxmgJxMRoaoklzCjK5pUTC+huTbuNBhxYM8eVj09SiWgxvlui963bc7Q6sjG4siFSSRIDM/gTx9y0WZ2eV9GdYzdgiPqPKvZGWab58Oss6JaWHWgO5kzrZsRv8iDre/C/ScpO5k81RZd1FUZiwCjppie78Lusxql9chKuQnsRfpY8qUnmIDc8zPu0lo8D2vvVa3bW1ClZeWCazaz21J6Qcb37V3Hc4LWWKBplXbaYKjPdXHSi1k8p1qClzCbWwekqAbrtKyKxTQLTssSsSM5KuNt3BeqKE8RbA5Qd3zfFawrJVedyGatnMjoFoJ+p+M7jSwGo009NWG5P573aVt/ETt2Gy1I/VrE8unoO4rIr0FDUsd82sy81104Rawtx9fWaR4u9WjwKbxeJvvc4bYXngZxL6XmWi9AIwkE0HH0Wnph1YevaaPS/rj2/o2d08fJF4ewrxbFAtnCrocC/z48OK81uWZza/u0eSSzc/QidWu6bxuLjMXX3S/nTVMyKZOmkRmC6k3R9W/9vt5MqyjUC7XcqoMJPpxTRk6hR3IWrMtLpgZkA7Y1tOoV0WjFE+fva4vl5Cu3GCun6GvlUyGNuD8tsnriAwoYbp+JVyPdr1Hf3VjOnIUN4/XL1HP2SCrYU2o8SFtig3a4D508mcN4zqBNApB3mL2dKvDvgR4E+YjuOoYXdworqeFtq3vdpn8TcrfAfVm364ixm2E/i7RmmJAdxWZxs9pvnYupHmbOXte/ZPTMtQ0xesNh4B0WqB5IEDa+rTr5CWwLWoqnx6hNOrqn3uG2u8Rs3CvAt/Td9fMDTA0x4umBdnJF2+h01eBrNNahw40dhS6kSUBjP2Eh7CtLQ8Cel+T6vw5q9QnFFYVlOjEUqOX1CjZI0kJ2biRgODowHsJSK903NGvCu/vePl5R0uUMVSoO5HqTd2QzGVPPmBvtEXziWlY/i2ktZ7ZrtBsr1OrFVJMyQpmRxzWAxp16/f2VrMiG1HQ4DWyvH7C8ntEzKnI/3mmNW1Jmk7nSFCnrIlFYrGtAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGxIpGAex7cvCRWLA9j25dciMWBr3ty5nFIwDWPbnFq0BxFZvHT7R/YlCOZYOo7X7Jnp3c2NMYgfKiGH5fRRjkToYlNvlZeLZ+/7SN+tPjfVhzywawoMRdfd85/+N+EzzMDC7Ql5PHZI0PV39szWpqqTaIbjAfdrjssnWYqkcm4zmRbQtvc4WcHOuRdFMo2m93PONNb79giKZD15HuJvHVLr959vvSMrcF90iYrfPhyYoCWzAqrHjC5xGabxrTadQb7zB/gHVlVPcwp9M3gsi5mtvE+6K6rdXGdeWA7mgrhzrSPWFD+bXrGrJl9Wl779LYzJDgXAlMYi0EiG1um2dx+bDANtlgy+l1GTLf76yLmBBGktDEViSTdfOLpaZuhKnunomgtGWrGlXnYl37Stjh7RYSvmriJjeNP5XS7QmWPiqMe2Y3PW8xIHw+pVSzOdO5QXSujIY5K9uVywd5cGpO1iHIkF5kcDtMIUgxFzaJ3GLI90uVAXqqkVURdR8rtwQlRRbS4+Ym3jO9PhrqcRbSmPwuSjeNytUjxwrBhypRzVENqtWK4wdMD7rtZUxgHUzssNRNbCq1CyvD/wsxosZWNTt87crK1ihzXa4VmlWw2V4zQc7ibx7vntpN4tPBxDpqNLExF2Dbk10RhgjJVBhXqCrTb8ilpj21jOf6datBscZyHcPSG84nQk2lQXcI0KjDHhudIFq5VuIU00NnbWFrcL7ivqQokR3XH/9sXgRnJ88JwcROV0uGVnix9X+If3t7AaVmZSOStlv1U+VqNVcFWvyUl+MlGmkX9oRChExI0yrhHs7bGt/05qRufNCROFaWkQRb5CJ8wotfWyKLUnoyPpLnMdryKnDyWU3EzGowP30GNAW4UKLO222237A/gqpNUxNvDHmZqRzfLCjqxVOLxCWmPXHvAa2GNXNZYLdl7JXz103KOrE3P3zbDj5xWZ9FWUmNiXFZ6hY12FtF8sHub20/MmYqP6yJ47jUTgED2oQjlWcEmNZ9TpLWbPMsemPoDeA4ruTOIl8QdXYcXtmngUveZvW1TBcW5DkPetjvUmYUP5p61ZosKFS0yFSPE6lUxY4z8o3KZXISjznUKQyLuqi5ngql2yJzLjEfM8BCVE6w6Y52JAfBiRIbl59apmM+TalSuV2ujUVZ+vmxhOxrZYrNDgrk/osaIzxo0248WIr40Q9lfAtWIrmRtu/frD5C1tZfaiKWlEMa1iduqoM1gf51HYLzbxb3+YLZJI8jSvIMS1cZ8ffh1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3KKRQHve3LWcWjANS9uHV4nFge97cvIRaLA9j25vEvBA3kNxWKdDvX2OGtPlHX1J4/z/TUJvhVckLNg9D2HkvFEJq/N4+XrjA7N9Za72fZlYIVPjcWNhejqV3HboDxlgRXloH+prSPswlcnielYcDM7bKR/m+5p7x5Tpsjn6tWm9D37tiU0BFHa2ISnD5VZcyHKRXmmex1C0F5HyN5EPV1FxH3PWXDk5LSFa52G4nToan14OvbUrOXRgQlJuTJphlVC4RCiytPmysJTsktZX0Fnt48Gab6fUqxOKj3Lu1VXK5R2TT2A+zCfvKwoFvtzY7vlexvnUkPdbeLprn1WHaV7mDe3zuNGfxruUFbOiCjIOw4D/EpjXofntbu93r73pDbREHoNJA6GD6ZK3aJkKKUsYxhXID8X4tsae1nHE+dytsDO9+2rQ5KMLM5a3kv8j2+c31T6xHp4bbK9YZmal1Y8YYb+6toxoWnbUThiM6UgJMfyeZI5kq2G4w8xIqQUSWtDrfedNeNzMWI9df6vdutAR7IoXCBjDyQ0VG71Dj1RZyRo/eQWe89YMBkgqe8Boiw2OebMF2zP9x1TRrZlw0PXq4tEjp9liQMSb3j0jQKf2bt/fpE1Ceaq33pI8+vSS148tqXBCq+mNnNr75Jo/8qUpaFLulte22OLHeKdvcucY8DiXKEIxOrMaPqElI0aFa0bFaQ/FxbDbNKtucNxbIN1Cno8HWbX8m2ttj2s3xxHz/aK71R9Ce4+cR4ktlDpJMzxnesrEqmZUOSEEKbWJMEnJToxjRH02G8hK8aDGhsLPrvV6xpW54xMR1w0gZ5pMrLqtoNaWipoqk3MhUZSssRabmN2zMuT2ytWeJ2DRio15bFXaEr5d03ZDZLPHKsK7a3OcZDswe9YLSRNrMZh1rLW5UYnsB98+zM2xqaZbXYa00uXGZXf18PG4cWtvNqXDZVdPtRa/6Cv26sy1t/PvNsbyFyE+MySK1YNxxTFypSjpy4gpavpmodYxRTV8T8kZsda1Gj5X2SG91E1umXtWJ+YjHjey9J+us71PDjT7rAzKrKRIynVrPNFYk6hDFBWT1IlTHInTkSR0mIqxcZBXCxIYXWyinmgTR2WK3n6fsZWstF0yQz4cDiVeqxtZvZ64rhHItlZDLFKcnNXOJvplcubDLExQurptke1vln1RuaH0E5kKU5w4XDNAVTAu1c5Kd4oV9lkOpcxoRRoSyo2Z4tTWhQ3zNdhxGzFhRZ95gQn0HWp4MWTeo2bfPnzFjFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAdsisUBr3tw6nE4oD0vbl0uJRQIve3LwcWigQe9uECRm4XwUmeIDpHQlK4+ErDswz4rrX1iK9YrMp+uadEhJyZouZbDrZk5HxBnVcOrjNbOGCr6B8xH0smkdakSZ1FNNrkewqZ+cVyrY1uhqFnkY0iHv4mnHO8arPnHcxkrhebYatXCPgqx2yrKwfSdTpwItIuMQ7kPPoR0yzRJQvLEGCw2g/F3KGw7YnFCHzS3P4Us+c2zasJI4L2m3RfmFEIYwzuCwlXqqco0NlP3SrXEmVRGhurrt5AYokFywk4Wn1a3mc+mYz22YjJHWV5tULq1dwvBcos808S8GFLalKbiarWeqizEl3bVsU+N6no26jDcMau+cu/uU6Iw/Dmxi1K2JecEBIiUBQWEYEGUJAA6IhFahmLCM3SzK0SRegxSMmZGC+qQI9ne4tW51PPiDjyUj7xBZ25/IwpxX5mtZ/ArHtS1LyvYV1UuYzy7KuGZJqC5K1cj0c2VUkke52mwS4IsmTYxuarZsUiNryidOhSvJ5nNVRqMLdSPAeT0zTD5lXKFtkFWIfbKQ7jCMJsS3c4mDfQmM4boySW1HnZHGzirYZzH5PFXU7K2x1EwnyuGXDCsKqK5viQrp8i4LmldWzErusCWl8fbbq+6YhtkF9t9jUlsV+4F0LRwvGxkEcZcY5VEjCdpvtSzGpamd71vOF6A3N2F1Giqwim0OQmZzOrQFiraxYguFMX3CXXhsEeezKfaeRsBWSN9Zob97SBrfpS/Q5gqxsjeTQsbxcPIuJK135o0WViYEU2q6PWekGEudMC4WGIvCnMNJHAfxBWgw1eaVXhOGdmf7zFiZy6b6MMrEf51TsDKz3kzmJNnNsN5YGM99um9fb6OLYr2Na7nHgsbVJBVDFRkc2/Mrc2z7pNGb3yUcHL2rFZH6kmzTcCCwpmIwrDLNrFG3DZHgPcT1rnVp/fcG1cWY3sN573p9Z8HQw4XnMAhi5aLOVlAW3X8jRGtmu8YiavuSkeLJdfSKiblIOYrGZul1mLIsdziz4YIb2VUOEZo8F8y7iM1n7Xk/D2kj7z9al879ZLnAqzKFK4ePPWLqG71je99ifyNz1gkTjyO2sTiT8lZloUdaIcm0ucUlw/yfHIL0q0MmUycWYr6AvuTUoW9XuEDTc6aG1FRcOpqR6YiyQLp0v7ZELE2HFYydWPFGKpLscCI+2+joRaMrI7fFrAZ55H7gZTeuT8aku+jKzam1FiMUV01qdcaXB+qKE7Wnl67kYb+FLK+pu7rWvmmG28Cs94US0fFt+t8QNgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeKisUB73ty8ZEYoD2PblzWKxYGve3DtcUiwNY9ub13MRZq7+y++2V4x/jwnGaeuYvxP/aA+1R7AZ1aaKkdlOXZhQpwrLK8VrYs3196puJZjtWE3vWd46xOyvFcdyHML97X/5mhQtSp2hxqMmxkwVCxN2IMW1aZxVkaT/j3XMVSzKZgfLo+ELPY11aeK2Ux8Ri5nsXs1CEEuSyVQh7PJX5hSLOIrW+OsupGjTKtiJUyssTOIVdXu6gNqdMKU5VCqG6NEXFVYhzEhbi/TqpsxO2JdwoWZ7MEeBndFbCU2qS57XLdIRcxpYkjhhied5nNNSKyO9b219CevLM9M5xJVtowZevY0Zh+L5rI3MtG6KSvFxUXNA7+y++1Uwq8nH1PR3mux1mZze9w+MhLFhMOQ7N1JdibcWwD8mghhfZV+XbMKTo4Xtiqhsb6bXZn0ZlktEp/eE3QdSuNXcN4tXZZK6liPp7af2am6Or5sKJmUilg3jpEzyiICXwWJnIYmk/AQg+UMjgdzHOK6WxBcMXo4q400a6VydXEqlKBIOkbGnaGjf/hTrLYokaXEnzGTZc+rUnoSqOaK1P5pSl2/eTKVifR8tSsc1hS4P5UvHypblSipCe7Wz8UZ+qdDVmRmo2wVYr2FxZ73w1wq9n8RVVgQ4c2NYtDa86rpk1NBpbGoQ4CrOoMVgGU32GCe7iR3jC7mi21D1vVvvOIkZnb2RkdF0duIsqFqyRd3/u07Z9aruDmHjEBshOqPD1VSEN3urYzMlYtYlrf/eHTAxUQ1SFsVZkIqLPpviQseuYV46OMBj3Fqi1M/Q+FDTESacvSnFtQopzRVyLj0EkLFk3E/M5ve69e7bXGkJWvCfHK9P5obbuNKXxq0yvINEHKjle9i5mgPl1Fi6iK1izJaSsW+u55gObLAr7v4UrZPLX0jwWA+HXcWLbK9jNihk1S0C7ZHZaQYFZtxIDJ87jYmgQrstdOUF1bdNeG78r+qzRjoEpKbURgnyoX/zC/FSZOZvX+mFvsWweZnLwl0WAT9GgOewtYOEvYs6kDO1VKkq5nhtjHD28mo1KWBAhb/9YEr1XNMFf25vEGm5txb6jR64xuWSk0BhZ2m7clIySccLCjP89zVTyrOkuB5IabhWC7BJ0co1eouwT0xiyGJIkbavH/eKmdsqL7EwSW+8ZzMu1cpl9DFEOc8jwTiucF9ASw9wlTZcR2Jbex3Gz6CyMV2Tc6jY1yzuSvSLLpiZYTAktx00m4KhjTw6redQ3kTOmDDm7h3V6cjbu++cYlqpn8aLpmcfbMOLpspNAGdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHgorFAe97cupROLA9725eDiUSB+Hty7hFooD3vbjMGaQIAqvuya1jwyu++w3cpp56e8X+sV7JfTouN0a2ngcgdKRgqNROC9V5t1WNHtSBNiPEzd68TMjcfV26LBbHzc5xoOrfPwuq6ZITYiEgRZ/rhvdxa79Mx8V+ToO1caeKmdrTjs5ZD9ZR3JI4oCQUync2E5Q0SdPwQheyVKuM6ndZvCg1w/SB9MyJvaEZTOkX96vrRY8rc8HEXJbXEiubZEg24S50KbarZYsVueRVdGgzUo/dPdSTwcYbpTxYXsKm3Juc37dmWK32dKglLet71Gt3N9CfKWK9iUc3B9uvzeaeK+o/eyzQafGJsTavDqQzXUIMSN8YaNW68lvvxd29mnH1/7t8sZ23HKX3Y8ENRiuPRzUEKPuFAitjdSeamrwt0q4qWHDVkZrpGhwO5N9XCsTf9d9hYr3guadJkzrpyiRdWmr/E1WzBtnV7xXrR0wG9OPsE6ZkNSapjRVy8Stj4PMfgaQ1S9b9l3AveOrH700VqC5wLMNVC4tTm4sUem806edGUgnNhj4Q9CGxvqdsx+Xk05QVI1TbjQ8yUgUvvGXNtTDMqqsMyehP46eVT5DrqNwVkGz9WxocWIiUNrJ41cbmfMT/wcQKU3mkd05vuzPY18fdcv4uKhXMs9IggSz9Q4uviAeXdbjVqtqxR5/u//cbMhmZRP1XJfhV5WN5XuYJNyqxO179yvuvfx1at/nO8/dShbm9RGSpIER92tXQKQ/jWvvF2Z3VsUpYD9JFpHKyD7RrbtPbEDSYOBzSiFw1Ic9F2r45+ZXTaZiEqBtVxonUzDVNYnpBxSBrHJDhTRb4vN6QU4q3yJfl4V56GwoEtj+S/3M5YhMTLhSna2KlcJ9uoikWYKkkUqTR8WK8gP9VgPYTBW0Fqew85f33aH5Xx/uCZzCgUvEyyssWn+5HrfApWSLBjvIcR5bMaLOyQ4WJJ9OetZ8aBD1hmPSYebRvF3uvgzFr/uT61tT/+v8WWkFg7pKHIny3oEMdzcLqps3Fur4T2tldpUyssJmmuzOENSSqRrtExmkN7587x85hqrStdv4TSZbqEyVjSf4zXULO29ialCzqiIfLcuz2cYiGx+ojtNeaRhQStTgpZCDHBVLl0o5MYjWhwFfVSMLpQxZWxO5mUJhxY7zGp9VdajP2pbYlGtIGOrHNcn+hBx3YIbEd6DZJn0J/fEC2G1qYj3SCw8cIze/kw8coL5vYEnBYsxlDF0pk83N0eVlpmWPbT+aDu+tsdNWzAlYqTXiPd+mLUhwockuJkgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3WKxIHve3Lw0ViQNe9uG4YnFAa9jcusRGKA1725hy5lAqz48rP/Y9La1dZxM/fzO9fH1InaRsQ024o8kgL+YM08D+WIVp8XsmbYgOoSspjc08XcNyhxyYKGyuiyRKp+LLF1iuL6q8iR7L7YIIytrZM4rUXcbNsb8eEnTGV8iudK6M8uumRSsj4xTHE2Jae5uQjmU66YyqP50X4sfcMxNbvh/lreLy7V6ITti4GidSivCvC9p8J0uTkcq3pRsJ0Q4bDDYW9zhuEVRmBlsZYzm4XhQ3BnnZG6LaA/u5QqXg3g72+fvMyVcHNiUGm6NuuJGKLB1HjMs+4bFFy17vC2u6azL85k19bza0WTzKnU50BKlNCdKeoGBta2sb1WHEnpn/fVO8Q371gTIS45VyZLnC2xvatWU43O4W2pjadK9dzxJIunrZhXwF3Jqdg7Lu1P8S0sxULdtvbGNviwWO896QKwK4u/bW9SbhJNQqNEolRyp1Wn4zsJY0MQw110fr05W5FswOU5C5Iaos5fPaQITCtQkWlI0CKrVEww3Jh0q671anjpNdLUdDEg2tznTLEf52KFqVbnDfqxfTDjhXqifEdxc26zA9Yi+GDJh84Np1q2HVmVLsuhzyTrTgp1Fc/5UzbMuqXvSVgtPeW1Hm90vJ5beFBlcN4vWDWJ5ptnTegBGH6mI71EdvXLljLx7DvnzfyR4/fLDjdMg+C1gKEXNKQ2RxpCpVjeQteudSvHUCNR7WNEO54603Roe1nV60/l9r9o6PjqKgoeN153j1se62dWFOU3BwWmEKTDx2pqsITY7LiyhFkcZPgSPASF4JkcVGFYmvn2KPMwuLCyVSeYrxyTUf1m/dqENAegfHgplscNKtzyJafny0rPLW1YMlR4WSQan+QnkRfpmr3F6ZYV2lziXK+qepdb0XHIrVGqtPe1YrLVnx75w7TWemdmO2MTWBx3Z2+f8DgbsrM6gH56mKXHMUPqVntqj3O/nf9Ice+0IfRiZnEYrw3DDRzDH1q94kal3r1wi5gs7I7dQlY5q98y7tea1njvGLarT0hR6N7y00ppmhvEXcDO5c2rqDei5dqY54TPd4+hs7Yl1ecqrITRTOKqOpiRpommOBssjVCn4DuJK1wWFUox1Eur9xH0SiBUrG/vrdJW2FAPduQlbNAkomCvhtm4625PNRnNkdiNHk4w41XPdHsSbe37ghHhKBcq482CClkMfq6dza4rKrbRmGd9RIq9VtmJoj+BXSvYni3bMCTF9Vrm8PPtTdoETXkI16AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeMikUB73ty59EosD2Pbl2mKxAHse3LscXiQNY9uJXKeIMOm+1OW83O2NvUB/d9FbYFPn/4lVDg8jPDuQkShNohbjp3HY2K8Gl2+W9MWpfMFitaHHirC5aYbI6YNR4d54Vp9f+HRdOGp2pSmeeacZsOTE2bzpt99YoYCgVtGSO4MLbnTX1U0qtzMsoUipy5Gk3rxpqkehhMc93kCHEXFpIj2jW9PNiWyjZSQGAeLOln2oV4eYNFMTqIoEc5vEixO7tjQZM2YikhG69VUsXxaOk43KidUsDXSu1U4JWBS9aRoNXka0aNDhuEVyclVXOYTApEOYmVejQ6s7bNCgfGoFnkDEddNzg0Oq/WJZcWjv5JbWoTOm/I7/yVO57Eb/yzTp6kzN0KnQI0YigQK5ofjkf3W3x1lczE7jDNHKOMvoays75qkpvMKkBetrN8/3pFc9w7SMicUTP1DHixcy48LF6xJXj/2Z2B2+o1SJxWngu3R0qQ/l54TVGxT5MCASk9UIbGee0Nctr84keqVOyKyBAREJDTvjYZGTcbe7ViuSeV7LEOFHH8fz1Q3blczPcQYk6+rlbAxAcIrxeo1OLQ2xIlznX5FM2N8NnvFos7TyjhRWV7qzMu8P+xrUDGHB3eWreyz7rukT3hw37O6oyPMQt5rApRsQrpKvtxgjl/16f/AyLfKFrLpyxDv3+d2VEIoJgpTGq0IReMR9UldApFq6yWFU9Rrjq8COhycLnmW0cUKjDE7t8zWxb/d8zZQndnJmjKlJiYmKu7TscS0a9I+rOE4147tbbGI95Fe1rmJKSI5jYkbVKYKT2uh9IjTUgiQn8eUKDBiwLRHcFvZWZInKjXBGpJWR4kGSeFGw31XCXUibrd1OhsSzfajtxpptXj7V66S0FWxYNWvT2DefWKPGJ+4wL7lQ1ZVrMrmLUFxh7ZbOaG3e5xSFhTK7T2LSRve+Pi2HyuhMTNtlZdV3W9a+rDXUWsyKCkgRxPKj/EsKU6kemrlId/Iprf1p6Jyg0J4tD0wKoAh5qJBfnJdbWOpVqlxO6Wmbsjcrw4ryLAvuWBJCtSJbVLfLk3Io5aRZT+bzpcI0DV3sLxc5i42ulVuJZ5HgWbGxdHspz+IKnShhyOS8iGw/SYnenk8b2jpdZjQoz5RKs/k83yZu/VyFHl2uCrYzunrWfvFtEIc0xEUoXqucqsranVTuJCliKdKMT+8Xesx47UxdhiTuMkF7Aldm6W1lQ1UwIsJhpSXW2d84704Nr2LBbbwY87FGfb17xLYzBgsO9wp418WjVxChRnz6NYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHJolFAa97cujxSKApj25c7isQB73tw7fFYgDWPbhSzKF7SyIf4bb/cmYUW+cf/X3lcMqQiqvDtbGQdUcr47pXMtL4hdXtUX3tPEYXmX+la8h0XSgQ60fMFmXLlR9bW/qmXkCPCbIbIIGgENhvWaWmcZza1MvzfVmXz1hXcsV46erTxGMyQNNkQpUXQlKj+UJtg0CXiAkUt6hwJ4lq01HcWLRvKaK1HerGl1Ctp9WkWy81nmYaHbhu9T1hK1TMMS7LAVCGqrFot2aAzsEfWse013l74g0nywSxYka8OS9VfZPvJt0j0hK27X4UHMSPGePc41D9cRXzC4xoNot/vFpqyBhZCpx4A/i4vxbzKFL7v1p87WZquWIQ6lM6Sn4PHyEDc5ZM0Vs67pzRr1Enq9lHEew4guHh7i67XAV7Az2hx//RjmOv4b2GDOmzmZMPnmrTbi6excdZyseI5KbUDubee50ErOeGvp564s+nM8yai/BmBQ08n0rM0yQ3keSjLRbMhT2cdVoxKtDHOKxVxfT1us3tLtDWpMMyrkV13iLu6y7cWZIochivpmPJHeK9kaZkYtJUkyNV0FiVtVqsk2nS06ltIimGM3yQXq4a1uLnUHM01YEN9NGnvA1r7junbnZ/Aa414s+M7g2gyUSuV8CaZ+Ek7/lFk3nC9Hq/ivHD61F+e7nuc67LDIYQXymgqF1AXNXloEsFdoWywL3i5cM5nbM7bGNWTzs+JYcNha6YzqT0+1c0woNlYhKiB9obPTGMbrPn+9p3p/oQuWd5M/ubVUVOtPj+ywE8VqoIOjI7Yhy7hoWcrOq1+Pu2763aIsp5lL7ENdgUMFxiWtf73aGmLoo5FY4x5Uvu7g0v4S05Otwkk1vXGDZsgMutXo3Vs2Qp3E8mG7Bl53sdjj3keVYmdlkT7yBvdNR3N9FZrXtSFCvTdMbjdsi6zuFqE73TWqerlaZZCTUCmNURC3WcfcTXpDaBZ3MfPzCdoacvBAZAKBcwEha0ynP2mHEtVyKy44ellWhp6mZ4ojuGtXxGpfJ2Od/nfzWJuKqMMG6K0hhIYkS1H2rY9qQ9xnze7fGdAZU+uoRFXQLmgXBEmMoVlJMYwDvhMoaknwZyIguNHzhTMKd2rkUgDaqtPuWCGr1VqWeaur7kj4hnghq7IWncH0uU33cs69ePdXKZfRqtex2Bwu4PYEiuZmJOKJiQqEpX6sYKLjV0XDnVikirqOq4Z7w6NzMnVvF3dLwLsyqjuFqSwoGf1922qvFH9NYh7+Mw75lUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0iIxQDve3Ln0VigHY9uXT4lFAW97cumxSKAdj25UT4A73ExdnKACtv73S1NT2+d/Ei7105EQg0D9KkhTUiC/Ia4tDm6jagOKWf71bMB7WDSlWJyVh2HujmdVxn89psenzvNdxU9HjuL4mJvHGaC7dLF4c8W19UlgaXR1qhpZXFkuqX67cNsJoIZlzL6iUNsqzSKk31URCymjcVUeHBfYpJNlsamNQLZQJ1CT7VaVab5aswNxsTsqXcXi1Cb0c2wGJOpKWCso6CrMxLPavptOcCI22iw9woUSasCLl5SBemYryl396RUk/UM39Ie6tEKBbWG/G9WjZtjNt2zCixqwKfGoMa8GiVROqALfOGboBT8/bPcx/MpSZ+GcKgoNCQMSYfIjoE6QlKHNmUJ5hSsStrzyCXWaK3GDHcG2lKR42qXrvdd6tmd64MKrspjkaYsSNG1R/GnpufF8t1YMVzVVcJdqTynUiqP853KQvR8KZSpxQjmLYgVGhLYrVhxeSMrCn2qeIroT6WAkT+oqD8f0c62pNTD6BETygye5uK1YaFReIM9QM7PFjabkRDb5H0CaPD7PjCrc1M5MjKrYDR4URw2rWVlWErQ9Uy1wkwhiGYgTuDdXNH+KYgw4VM+WmdU+qzwLtTM433W+NZf+jxuShdUQo5TXmnBJ1Ou5N1bNY/+P7v7Pr6SUiZJ4I06D/Ljlrj1j0l1a2JPSas9s28OCuneniFs6sb4dmpwh1rreNU754tYeuKhE0Qw5VAqYMWDm+4OfRsydrAooji9bU6+VS5aVCgDvhQTichklK1J58Zr4uwt5KVKZqg2w41AxCe3hRXNkVpckplUp0+m5yp91g2nQlJQUYlcxkssQoUFlUKic51dieAvwporldWsC1HkgxoWL4ir7yJqFvu55WSM5+DCexzonZnBkf7+9sT9W7xhrcWaE/pjT+LPXUN7qJBjQdYz811CCQ3SjjjoEtRWXygT+lDylaRPZndMy2vjSq1gMBJAVATAIniEp6uMHp3DSO7L//DejJywjP9luxQ6RnkCdtk1PXFsbhxXr9Rtd51cYsVlgbxu1/qFS+19OQGo+Yy2ik9lwZWTJxFvTEiHsrwdx5rlxSpPhZRggWksnl0zsjlNm0rAg3s+VZHjHSaUXb5D0No+x7Z3aKyJlwR5gHMXlVOTaqXR2N7daBeFAJ28Vl4zkwq1iZounzzx3Nve1gSN27WVUdlbVU2xXJPKOBRabrLGrskXwXmc9rXnKtZMPoN/u7x9PqVTRvrGLXi1hVyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdgisQBeHtw7jE4gDWPbl4mLQ4Hve3DxEQiALY9uc14By2pENnlYgq/4xhTdubp/597+XKkp25bKYHZs+AiFeeJRyhkdA+9u5b1qgg/6u72qWz25LrNilWU6zNqJq3NLPI30VdfPilMW5/XmgMCrjGXAtAj6tX03u1NQIRcW9Qn5aMbslolm9DD3fHoci6caJZsQ4mKDLkKclleZCBfZc4kz/Ft1aW95ksL5hsvHc4bpBvuu82OFCX6bUzGyrmFhc2oqIkBhem5UuSpj3Z7PIysssvqy984sSw0MMPUXyUmZGBl1H3BULkdEaK/x95nhRH1csDyNnu811iWi9qkJ9V8r5Jqapvfj+FElaaQc09WLrWTFP0sZHNm/nfjnMs6wNYSxDzQuBCLhGTRpLUjSrkZmX20sMS1YPzZ2VTh6BVMForc46u3v2WFFjUp/esZnSZ5rSqazYNtT5iZxNeDmua0y2ovFIiuP9Sust/0nTCgGgXg7SVsbkr1QyKEvw1RQhMrCSby1VrmyTtaYluuV29ao0dXTZgsNUL/z6Z8rEsMMFZRqqUd2hvew0+h00kkKGpydIbHdPYUSNWE3pBbfqNHthuRXFcqOIuVG59oeRDtWHKMyq5vTDGwLNj8y0YpJHzLeJjHmiQ48bGm3bXAsx/bzdYec094jMNESXIuH7MkX5Resb6rkrh/FfbtXevjODnXmFkOplJcf6gHyoTKfOO8TQIqw7vX7pDb4zaqX0LS1Ec25Ts/ok1Yy0eUc9+tc0sr4keE+lZTLM60LVp3kX4hR/KpFYr1EwJxvqd67QxMN7xlXAdByHooB2DCQCcOoelSHAGgRkT5CVFt84U3PWHPaEnJE4X6MyLZNEM8LUldea56rx3rzAqGNieP3T9KOLC6gq9wfnxDk1azZFd+zkwOolXWlI3P1XGpeR7Gcme8SFChROu1A8WI177ur257p46aolfTT+ZxpLWu82jx37+DW9tb1AmiVhZVJFLhOdxMO3imP1zLeRbetvz6bl0Ox2LiuShkJ4OiKZgxHA+r7DFvUnCM5XGyHKgqRlhMdpaJ2E9l1eHZtusuc94mv48rNLMf2Y7WztvVSsrLaHDve8PNoMBYck+3x1NtDokza1Pj24mZejzaUyW1NvkNIsLWLWEjMYaiqTV6TzMcR8yLC6clHHXZ2slWtaVTMwOEDf3e8EuDkqGFJ7w0wVptXlezt7xqirpWSpyJiJCbUkwuTnKr10rDQWFYe7xH+i0wPYTSxNS6hOSmWGJZV0VYc1e3qrTp+47xSDt7PLqa+fn2ztj1AePNXt7bh0zpgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHW4lEAWx7cugROJAtL25dJi0QB73tw7TFYgC3vbhUyaUjo/D8vtF5PntYyUqWp72z8zcxN6BSWUg/l0hlQbNA4PpNVkd9fh8XiYvZlhzFcd3C+jicKOJ4q6HFhzQ46tviFa9s2rmHEnqiT+cBaU5WszqLWtJMwLT2W2NYerbyMxq+92BOHK8fp7RvylGn0YMAZRrBsLQVZSlIk03Aev7x8qDTx+9kQpkOBhwkYsGuL41jbAZpUn4PBEsTqLRVMEdTRWW1Y0y8hxwLKtWYsB6ytVH1mW1qRXCC9X3HfxZdMS9Nu1Irc3MTZOw+LfL1WrMS9qTQa33iFm8GmHy6s/3JDzSfGM2xGjkRSpk1EgL8P1+L1pq0X6cYx/+btMNzAlCShkyQNAQoTsoEFoC8i6pE8olupSkMNFFVUL+nK9NZmYWueHF3rFfNqA3Rax4ytVTqPTGYGYPzen+IjlRnVTJdW3XDxXTnWcSXQ5wRx6SEaOxCyMjTOAv4NY5oCjUzyVneN71sPc/2jMBR3XzqYGluV2IDqu7/bAi2M6FKdRqErSR1qCAxrmK8pErZvM46Dwa0TDast7yk0DULcFSjlVL1dnCwR1qZILqSzPGXnrdAc04wuN2CRXM8OtNQa+XwrV+oud+q5lk1LLM40rB9sRm6wZlUakOnXub+Pks03itGT0y8kjU3i39Xqvgv1a2N5uDPLBAhKdeorq3thwXVIlp/PFxpiiN8BfqwtmkKfq9y+1mBbD74382vTcKHUuBfhbdq583OEn8XOPfDMYBKXBhQh7BixoXYkvH2waQQ+UOUKlPtNsBjl+SxdTKYJMRoW8PrKuFVdvGZD2JvP0/UpqDSJLu2YO6j6ZDCPOCrkg1MUSRZkTjdZUNyVSsOsLWqZhRtNrNv3gQoW2CeLXMkrdBS0KLFp25rZWGHaLCq9fRLvWZzb2SPApCv8PtZtFzAapI2Z4Nt116ZpmSDbHFIBqzw/xyLVorp165hU9LeP/SjPVdzLU5RG+hi5Radcm53jD7DVZrfW1FcZG5TPsQkG6V9meE10hQdytzvEOHTXziOqJI+JnKEdJeWSr/FbS6pAxb5jMk8I0k+rmSK6Q3MBOMt2tpJwxHSl3hNFQhZcB6zrRZ0KNvbYkBxa1K3k+swdTw5zPJlDVyqap4MPW86g4Xz8wf5/KkyFa1uKUhLLG2NXY2Rnoqz/Tm22Azt2HNtpi6pxBqzLTcy2nmbWJcl+fqmJQ6Z1mM4IuEpnze+3Gv38sGSG2OEal93xnz4a4kGjDNDti+v87vNOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABtCKxIFve3DqMViALe9uXSonEAO97cuKRaJAd724VP0oJ/x0VyLSPF5My61erhn41/iPR9BXB4nGxGSkB+pYvsZ4t13qAzwHF7jd/u0Kk72aXWYjaysEaaS8uaW3i2921XE1obY4HQRT2O+q9tmr7/OJZoqsVano1xJM6am10j2aPdwUJmPy4wHhhMK0CvSakTzXuLNr2nhwsQss5vamZmY/0ywekS19ZrpSqkhTHChyzO2N4h0WNBQx/pnkgYW2Vc7Z3ryXeHG/jb05Mu9/NPm7zUrx/2JtbGJlhY367tWb0eeLjw7W3emKUnu+nh5tv+9663EtBohU8xIDceOz8kmffEXO9euvXFs6fP2aNFOYSRVwzMLmJgyqBbXUWBrUJh08eWrfeIa7jsb5iUj6HeRikxqE1xMUlx8/PhMiIXsRKnM3p+jJDhU8Xy5hQob2E0uDw9IKIcbwJ3NCmguCgq1uZzF9UhrLt6UJe06QBTJHSuheSHF7K9PxGsTq7Xrniym4qm1m3rOL97SMT1bPIyUMR0poM9LvEplztpiclIlne13uPWBFbVPKq70XGH0GjleuId2tCEkbqcVq0h7AuIlFeu3k7KzV1u9JJorHFxTxouK7vrFZqv+wT1p97xExHvQJxJNKg+VkBqYkAlzC3DpNiBD19X+JXFkgLCjRyXPQCZY0aIEu71fu8bu3JiO5z4zqkGWuXtrTsrDI/hNjZfTgzRs2zrHkvAYo8KVjRrAllyw+I6kfbj5pnOYyXfsU87bEaJ2pugEBM44U4nlEZpfVSxlieKEhQu7MOczEDHZ4MzhG15I8KRM6OI0VhrHcdKufRcVr8Yc4SEoAlT6Vre004I5VODQkVO9w3Lpvls17gxFc/zpi3u0Gaj60Wz/dqZouqvc1kYXSus45+vV01RpXHbdO/0/qxRqfDdisCDaaSBGcfnP3ikWCN2VEk0dCZcXpgQL/C1nWrW1nOpviaAyTJxdr1D/Iad5uH28kZL288FeZ9RK4iYj41qC2YgPY0ivmixdVZ4V5afWvjTg33cbuMJzuqZn27bjP9b167vJNvbXEppXKtI6chbhcU2vo1kSR/OUQxYCqJKaYBSh91HWS07/E7Chq6Tz1+wxWJTrKlqqWqNH1801HhQU02WqqVM9y4RkjV52DESKmGdhreJeJafcsKNDletJyxcuoSvfM9J4C4lYdq2I4KaZxqzRMagNOJXu4utQ4EKFq+6xdXtL3T2bMB196rnwtao+yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAa3ikSBbHty6JFogCnvbh4SKw4Gve3DxcVhwLe9uJdciSqyEm4Co59k7anRLJ6fmdTUfH9eTRHDs9M07Ccf+K6PtszcKMYn3ttt2Kve5YV8dzs36qww22lN7xTWJ3zxN+E4P0meyfj2jPbVpaud1vdnW1t5M0vEREhXbcKFSSoedsONeLGLu3LKJK4WI2z4eQGD1x8Zj97O9jrB8Ix6nIDreNY1S+F6I3tsNkiOU0229rcoURhfuMRvaIOcUlePHm3k8TW6QL3W4m9+13KjGrIuJMvnjFFgv/bFKw95iuc9M7ny69sWjTx9dxhb1p7r68l85xLOpzkoHGxM4Tiz9q1uemtRK61v7vJTKfcjkKMWc8lG5Io0Kqxkj1gR3BhVUbczx1TtmLqTLxh3Fp2/U1Is9tx8//VV22otJzRYKnY0crGqf0hxJ9vsW1rtrGk0/suEVvU6njKac+0+qjuXSwyMlWgzGUk4kIwVA1LlRq1r99zuRzwlGswI7xuRbG0tuGdnc9U9YcBdM6DfRjPVZyaf2srzNVDp8flIqrRq5f3pK8gOt0juUzXV4pnGM2P4TZbTFPdcJFibHdL5iq2FHU92Rq1vOrw47e+c9+maa1mBrMfU9rW+b+to1MVh6Usl5UMlrid6wdZrrCrqabMSDPnzf5gO29KoCAjilHoMQahzFyTCHQp9ac0tpWxXKLGfagQ48m7Yb2ddL065YolI705Jaq3FN2+oaneRYyq0tBG3zTCjw5dPt73C8B+csI4ThOts09RC09YlcmVhTIWr4J0pUb5wl5LgLGuSBObJ2bGJoe7Q10+cn8WAQkkN3BMFtYFh9DrneYMi2Xw8nA/lxRSuoOJWtQtveq2p0uLyXEbKp21sjEwtMesFkb3rei9bhb1J8IW5uOJbUTM0JW+JreLTtsFwi5l/fRNWxeTVm+K+bmeCrNxZt7zjc9JI0ZEn2kgafx/+QzWnTdXEWLTDq+fbf7zUFkPyxrKiCkSyco93zZ6QH6lqy0UrJPLZ8nJJXrm/YMN7+JDjzahtiPzCkj51izUwMpCsOEE42E04bBmJrcmoNvmsdqn6mOI/GNJEqb5mZSyq4x1CaqVVieQsqDqRxVi4BRhgp1wvMxQLwLt7cT2ReVG4C8njmVR2s1Ee9e4/pBgLTJGTp+p6KZTdZzisqHKV9Ej6UURWK90r5FTvbxCmNeVTmxrDKdMFO1jyGnKpoCkRyijRXE/rNDM3sCOT71Un7A3StG7zfc8aNutJ9ZgQ5oz7eI27ap8al9tvgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdEikOBb3ty6bEIcC3vbl2mIQ4Hve3LkUKiALe9uStVYwE/Ejo5gInq99eTbLBbt7zr7gz9sYleurH8EtReiEEnVDAxKt54jJIr7YvusGFAo6a3F5V3hp73UWNBVxwxax9XjYptxtuSJDc21NKyrhSmoVNelNe7Eq3rW5ODauXCMulc/XkudsK7p6YS3ZDjhXBcgm0J6dhxFLesCfUCFSA3Nxoq2GvGEhT6SLO/+dZhv4CVZH6rbVX22JDnm0ztrFBP5IKlPJ1mYHqoWceXe7RMRKG4llT8MuI7U1xGaueysC4kixXKtJ9Q4sKBTEKJAiRJrWhx6+0fEaOxO47fPrNbxYln0tZ05RKhnfI7PgEz9X+pMxMwr/GvvV7MzOuXbUnxMUWTE7j5jqLxaRYUmKQpHUTDxtwvW0taYNbn08v48BP2gUi21vcN1HypW/MGZwgQZK23i9da3jLCxte2XSpZo0kZoYVC1F9NA3i8xIjkQFOsKGE3CgiYk6Qt9Gmc2a8WKwPWQ/C82bVUxRXlmFS7hQ8Q/fwa2TDIqNJ49kkuFloixn67c41HKKnD9OZSx5HqwrWquHqisys6yqkao06wuJwxFhigqU5X7ZhhcbNlaKui8+WJIVvNPfGIV42J2DE1c1a4r7WNwWyf+LaK5PMmX2I5jb8jb/gcXzmXdM2ibZbf6+YVnC7icBkPzrFY+U4YA/CawU4tYjscOJM4axae24jmzxLs7Y4MqESsGdwHGyXtaJfNPjcY8FzGwiVecJinChkLHfR7brbeNUXe4B/K5/HfKFWx9RlGb9GFQL8xJkgtGiLWdRBC2E3T6blVzm7xBb39YjYdEZLUeq1ROCOhNed+2NeqgKs72g6VdpPw7OLaxsSaY3JNrzLG0yP8yNjJmj1duqKyV9KxqZAuM0kS0lWNZ2738riC5Hs4ofHtS+3rBd3FjyRKRZ7QMWzbGnO0zx45uTZr5zBoogaMYhcZfBJ/E9NzLvGcyWrv21/bE13RfEMZBXyyaTDN5gZHF9eTMFlnbL+FuLSDqCrVdtxQ9yntCn3mfcdYzmN7eD8vFpMRXsjQi8vtxb7rBvNaLP4MNm10y9pSZLucZpUJuHZZILKuhn0vxE2TgvJAy+pLM0jqXUW8Y+Ek3qCA4r12tOOL5ljPsw95rWPpUD7YzklQluapk+sw4Ti1vtTPWc7ppXJUNzJfDyHlr3WuUSlGZkcKvdPX7UxoanI9E6p2RGsaIQhC2WdzfMm7TX7feIsRfLf3+83iRZZmONR0iEBUGt3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAG1orEAW9jcO3xaHAt724dbicMB73ty7lC4YC3vbkpMoEM2fyNX0Dmp7VjOIsnc8Z3/m0kLDMxraUHyNJCVCT8ymGNGZPrVpXPVdX0834u9UkcUFAmIRMcthDMBklrXJ369Q6LyOM8HQhD3j14mqV6nzWltYPFdYUy9a0uOm0AgFdWVR1fN9MERtjwmD+STgnMRnR83Nr6+hHy1CshnHikG71r1m2VllcB4KglJnLzk0JxmEpCCIkFUcyI4Wi84XzgtHTzNbxXtWy1zLCCJD7t60+BheTbM0gOi6tRlc52s2Wrf9vVvPNXa727O0YczII9U7s/uzOzRvikcOEM9fjV9BpX2qfXgwNX9r/6tXUKcwXPRKRY0/odputDWwxqwGJ/jwbu1Zl3NnErA3M7fez2FPLPMynUcM0LWP73fM7eWJUxUxBNKGs0xC+oG8RdxceNiSsKA34m2nTdZimMlDDQM6KwJR4ts6tUp+FMI0nU7FhYYVlealS0TQlZBkZY8M5YZPmyZthwr5vGvDW1tRI89UidR0xnyy4kmFdPhybmN/ReSaDdWixMUhZ3JnLQxQFazPrnS/L64wqPGY5UgqVxHNFkZoaNL84RnFkcs2tfXtSFj3y8zA1WPDlnpiJCvjFv8wdxm/U9FRZIoCna1ZjWCu37KfPfutx1ZXWP/hyiwVY2GUhCLFdA+nMahdFMfK5i0zAcXrP843GgYkiOn0LbK3OcrY5v8QnBPu5t3tnOPfb20rc5qcVJPjlLEX2uqRofreH5YTYxqxYmo3uDtmX4RztqHnAeBkE5TrCV5PxbLnWYz4tFUyJ2EuZu/a8RIDNGesB3JGxborAwT7tGzncBgYDuWxro9XHVernWelX0eDAc2yZXQ21xbNSOMeRrivbaex8MlpYs1ID2j+Vtxm1oz20fKuiU1I+b9O3skTG75rG3bH9vAtCnl26iTVxvdaPsolB8cKxJwYlFVAE9eGPVn8TO2quoX+LQYkzUf4hZ0n+TlhQofBjRGWNBiywXzNqtrWa4cVX0O5UsqApdd4a4Pk7EyPYW6f4zhkeJw5487xgVyebXrlj4rSaFSDrDbAhrSDnZ3PUZ6pGUmRUHsW9BuR/JxgDkKAg845BgCaKdWdPTN1dsPlP9Gle/jOpGpvWXR+vbdu3nNYDxsMCI4LR/nqumJpxeGmG6eR9mFEi3Z21ugQvl5PRteSok81C+teK4KhOLnKRermzHmRYeMzSfzO/ZY6ncI2Idpqbw1xLVh2xWubQ4UBvjxobq0F0QQD9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB26IwwHve3LwUUhgLe9uXZItDgWx7cNnxCJAhL25tM7yVmvQxd5a2TWNrjy1hQJ47v61q2YMZ25ML8n49y2qUvRlF4hmhBtEi2c41t6d1gVgQaPo1kuzJTSZR7G0vqMave1f4+veXGnJEzMC7RQSMwUHAis7t9NP72g9shopQsDe/cJMs08zY4tqXVa7I2hJLS8klRIrhSrZ6k1Mss10lczRfRujPm1ujKqqfVjex1PAyJNbl1T/bMW0losBMoTTOuYOKMEtn6BY1NGWzwh1isDLAz1Ph/TO9RIq8rD63eG1PYLDfdM0rhX1lhrqPvTYywfBa/DmiQLUzH+97xCy/X2KeNChzZxjO3OYCSOPVCFdDHkxIK47Z/WNaPr/X9vNPZdkpLYTEzasRpk/QiK+1Dw8u4SxmNiX+5xYcWdsiwXFS3lWGOrluaCxLdqutfvm5ioyEaZlWpl8m6AUUaJEu/jel65zHiYgzLrD9XxnVYdqKZQJAmQkySLkYxY0yXMMtWmGCbTzup9z7jwW9EulcKUW5dIHcJE9+5KKHDn3m8GDCYj+qapLR+rk3lywoTuFhAVlabr86mGYqXzjRtz2F/XwJoqVhnMzvC8QGNJqVZPlJpFmVUVseKaBtTv3OK3uL7d5vLFe4mharbV6a9dYkfNt4kJazC827yfv11aYgOPMFe2BapYMYmeZoty1P/eyJ988hHJREWjVWXQCRGB632bEyrT02fcxa/LxzD2xci1N6ncH1Jn6aj1vPumteVeszRFQeSHgqF41WZhxLNmNi8G0BhUa4JPEatHwzq1TKxUxp1taSqFC4py6IkQsqhaxCAPw+Ral0u51LLbO9N17WVhpqdIuZiF/mJpGp4s//Y2EcZbYBosjtmTay2MbxeiJXTcpoq0rd2bk+3NlLLcWNl3WB4KjVONQqSM0N8p2fd4F2t9GQ1uU+pbQPAbmPKsb40eJO7mxSBfwI7XJiMyUg3m+5YdvE7x/h5VArWMX6BDmDMI+ORvff/8G2hAZCYq4FtiYKoWDBInTDDS0aRKSTeqpHVSCUfeINqPoem6OtZxE1XNaw6bVSVjMypgHJaPXO8/6rvUaqzG29b5dqV8zMu1qR40JQ00oooa823UhUj0A4SVMaMlYqQtZzAY1Kq5IcOR0ptXYkUo41vr2rtzXaqwrEOXJlKDThAyx2bGG1Zm9qVLfWFP4Fd+DAhxoLfGZ3Bh+cMSkdx0U1woSvgRXByhxITRBZm9gpeNqSR5eHCmzbOt03mmGWmvSO4XzjFopZIEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcwikKBj3ty6rE4UB3vbl1WKQwF4e3DekVhwHe9uKlpYXEXXTDefE5L22MbFXrluRt3fGvuE3ztxJixOaOQshgXCaCHMWEOdw8K7bXBc2al3+YkTbyPvF5nzGhD9wWHVHA/WWNeSNr5xm9273ang9ChVLPAgQXuN0xBnvI7fI51ASUF67YqquEp0wc5+srIukNPVGnElSWNRxBpsKpZHNwzF1/JGx8vj3Qn3gJFhiU9n1vq2ZbVUjLM4P9tkafCO2rorWxu7qGFhlUza9mYltvQmuc4hP0SsMub69HPssFrrXx2xwUS6fU/3bWHjdSFusaFWLjVP5J85bvqm56/1tDbdWnkNB8YFAlqJg3cKBKy2S/80ZttG3u28Z1FdqI10KPVhHek04ihLltYYJ4xIUZ/VufePbdojhKlts7M8Zm+Oq8Yv4b2hjXrHvv47jCgr0GOuVChB4uEmfvFLV1itaxIMYv3a1xCqws75rTjKdCmjscNPHwl0bCIPMOArDrWrVj/Ut/ntbCwv8uNXJ9DLchUfGLbzS8Ncq1hiluNJvcnB7i2RwsrdEiYljuLcoILJmC22kfK2CxLjC5O9GwHrfPSCrFcunpLYcrXXKqYIUBzuxb3GfWkjahWe6tCj2l+ty17VqltzwsV1auLWlnO3BqsIVX41eQQTtk3rVfdPVs5f/M/1YoMJbDvGrQy1ghK0yC1GG5w5Dki/vZymoYVWu6paa1L/mbF6zaeUZDBZFY33tSK4P5IkWtJ9W0p3O8qmQ9cGQq2xxhYpfeaa1iBSAwsDJIzvZFdA2hCkLhGQpgdxz5c86LAdZ7gP6FgOSw40dKi08O+u+jObUxrzarjpThc5VvXzjWLWbkIJovIRhTvGbFqt6bqyLCyf0RkQyBh08jv52OjHZ55PqdYetsfNfCms2xIEsWrtjfPWbxNY3AyzXiP7xIGIWtTVxvUSle33vqkDW/jdMSQemRIBYi7oH4WDaJK5WvmPebX/3b4iRJqLpcYYhJTzLrowWZJS69ojgvKOri7SV5lT2Tb+O3w9UaH2K/dezUtH374kxFazxSsSrcnHCmcb3jHxe1vZ/GqtK+ZkV7jWbSnYyxrLKk4+DucIkE5zsKouwPAKyFqG+f2gwIkaC1OGJcQa2ZobysCPr+2/GUjxO2V7mulOsxqez+jLh/FU8QvjSwJ2E/b7s9J8Zc4cNlHIs6X40eDI+dQ4S5ssZqfbPOrWCS7xbdb3iXV4e6Qq4pAhv71vBhfb6Suf9Y+tfdYlKQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHTonCge97cuuxCFA1725dkisMBr3tw71EoYC3vbnGoCYz8wWnOrkVvC+61B6xXM03//urqJ6MiF1DJ2DJMhyLCi0SvM0W9pHGG4x9XlxuA1dl1DiwVIgp0PlXK3ldp5YhPm2a2v9w1ytOEqTXZ7Gq4o3EGPDn3Zu1HtWGhatYVa8js7pkZU1FT7nBVziXJ9EU6Lck4WrxKhenuW1UtijfTTX3Ft4tHCKs70uH2WJy361x8tjJKxqpXsVFVG3dVOpm5kV6w2x4sNwidgU0dijzszM5VxEowq1U3ru8/tCYoTt5eNdkiMSKZtV1ltu3wYs9YtauM1nz177Z+ZWHEbca1NaxWJa0+W55Q0MbUSOtjgZ6mums1rNWPrOa2zTLYulYUCLdlvL0Q5ckIXTSwNv8aCplIonTduLCfqp21Mu3GSrG1voEVgjPHBtbLa3a9ZoMRsiHzAkjR1IeERwnt4l5bwba71sbGBkcnOCrIcp5JdRF8P6IdKFpV+7UiIVJfzEYx6RbVSfzTKyPXOfURXq1nTTczWi0hR05BUL2TX+/DwpDsZoTNDwX9I0vpSR3OsZVPsbbaKxqiQrzv7Z2r60iqBCNssF7mLA08fNS6YmiVmfyZXRpKar2EhT68vi280qli31m8+9+0jU3ZdePG3u2POFACiXUMR0FLI65WKTV3NmXde3O6/GvSHekhJ0KXZd4hBSWl+MA6lIhdqx/Wdqhx73tuLS+YcmvusdQMjgrrbjH9PmFE+ra1TaSkfPLk+MsJQ2pPUORiu8tJXO+4tx/UTkNgVyjXKoc0yrD2VCHI8tiKunWJ8qiiIK/QwTRD46WclXGi0n3HiNbg0l1lJ+1bqx6YtVraf4UyjFpVzdZkht7Mr9IpeSrio0xCqrn+GOrLmDGxFbJZoWI1Ykiuhu40OHhypOrG9t04bxGUqi0411uLV/K+j7ns44fzQ4Nc6zDjwYDdF34D6bFNwsVi4mpm8B8Qrojt5CVbXEvW9awJ61xv0u/w2E7KdIHio5VGP9TNE8sOm472yIe2hQHLMkBW3grUSSnjsT6FVgkVyHq3WJ9fO7zxZUGk6pwlrnNFan0lrUhbe7iTwoVGKqfYIbpwfHWvJJxLqnzpJwcrXAUSdVqpF1DCO5Pk9fMqsVLhV2tRW1DHa7UCaQpwTCRw5tmnVtb3aF3I6iWrx4KlLkuSCiUMdyVp43V0s8sBHrlmYtXrJEgTR66YmqrlLZ/HZj/YX2n86xHP2G6Vzg9b2J08mfpVIU+40O28vcVzArEgUzaZubY76G6hUzmF8+Tum6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0SKwwFPe3LXkJhwHY9uXMIjDAW97cu5xaGAl724UQRoVEsopyoJ67rXMNkmywU3m3+YOIJyoSZz5fKU6RPYxlJVqnf2g1wuGZ/HtSsa2YLjtyY1JpzXThNZz8rtctVqf11nOJXr3a8xmWXQ/lyyuepL23n7th89N0vSmcXBFw0hlvSjK5Lo6zIVqRRVFtFRi5NTEh5J2NuYk8w/T19Je7kyry5VhunmZChFsiLvObQsbgNyHt7mRyNY36q0y5gJFT3y2K9zoiGePaE7iRIKnYIFoddPMx15u1euZLR8NV8XhRH9GRJqNQO6/esTQMxM38PbVp/ee258PNMb6+7upvvFL1z4HXUVKBhZjXGdA9qeszDSu2r+/mbsNVjohKCG6DcGozTtl5RO95ja2WRtUvziSCM5PVvTi1xK53FjJ+CzTb1/ilawGR34Z7IVZxeRIufTOIGcXtXezvSMZdrqiljVbEeuESWw00s3KWC6RKpLadpITXP5WPYLi+3fStXLw+HOrjuq82KOOb7G3QHO2fJSEzyqSKqnkjxXtzqytQn0j0iS4nVEW+JYmt+9NvGOkZcuUC/iyvMz6fZYLsxyLnbg2r8KZtu8gZvjED336y6zS+7Y7+1KS1Xk2O7ZEVJPiEcnQI85AB1ip63xS8SloOtUx9Q3DbNaEX4uacB8qFdhWEzfmkkruvCw/Z3mtzS95Aaomd78ZuUrF2zxYq5aKbe//OcXc/FZ2ByLqRyNZrMdL3jb14+qzopXHS8gLDbLpX2dK5wOxlo+aGtcHU2FgR5dLk6O1QPG59i9d6s1QYtokdPl+c2JMNzyHWWWn+bIxRsilRCvbGJWs0GMuHSrWERtzUDQh8WdkcolbKirTJ80c2BvarKyG/1Src4QIcdzgvqRXrUn48D69Z5mOB41KQ9zRtY0/mlo22YYr/OJv8Z8e4CUSnMPM30j90Bw9022/xD1Tza1TPxLCZmJszCZX4aLMoxTj6T8PVb7jN00WE2Q4uNQKvmx5GVeXskJ/a0sGkNbngXt6X3eBlwtLO0GghLk6rDmpCvrW5tvG9ucUkj7peO24Qx45ISo0m+Wo7mxLlCW8/zoKtzIK3wcqV7lwta+kmqj/Y38umGSOwwmf23mtIMFcH7GeocYLcfSAMdDIkFdMTtlbX7hCenWoWNcMTC+dQGFmiszmyOT01iWIeoGNH4ixVJMtMbEqqtN0pFPRRrtqa5j8hT1lheeRrz97pZ5D18t0WO+mzEafTO9zesnn0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdmisKB73tw8/EoUD3vbhyWLQwEve3LqcKhgIe9uZCunXTjrpByzYjDNWVxWtQuzwo0nvvX3mDV+7NYyo0xATXPUNI83T2SG3sU1NulR93qtTw6u8teoqsOJhfxWx/mM8QlQSNeL2vLWtY82FamTpPZDEtCi23HvTNPizW0HJC0++NwYChP5XQXbg3QznLqX9aMYvrKo1CBuC8DoPpYrqLGvvdIV48dFTnTHc0W0KRWW3m+6y3YIJ/HYhDiwwYsHDYTxCUUzscdjXo7pSM25I08Fc3abxtwIDx0oVzA1e1H8OWBKz1g4fN2VQ50vnUGTcsGOyPJLQa7j13be7104Ljzzbnz86j3gy5h3wU10k0W69GzYqsZy8n1bEea0Xx80+Yd4Er4n5xIt9RHN464M9WSl7OGrr1dYouMsqVcG9/Oz4srXHcTb2PWNPCtS1c4boFG9jhR29VGizNUOu9YjQ97tAxK7UavXLNMwwITcuVykTPVzCj1Krk4XYvjQWEuSeOQ8xYTbQtpd+PGoyRFw5l5R87AqWyisUBfEe3p9vct+kXdNE/T5loXD0nkGX97k7VQjm5shMUimJq3qpbVDE/hRmV61QsKBQImdC3yYgKuM5qdzV6RP9nqcsDrqz1ncm1K/F6a1DePKae0tSTdsfMaM5wdtrXBcs2+6fcNaEdHBYz6A6HkAx74kvm2/efWMfH/WZniPVjEnyeKlbZRYXapzHns2WiyMmafvocbb7bjlvamxUraywxn9M7bs4m3B+c2b3BzxEVLpdiFmbDxekeDLnFtYjwSdINVvG67xXP36+iG47FczpKdnjIpGpUYyHodo8nS5iTOa6jUvNeaXTpfbyft71DFSeUR9nWNf61tEHMXq+GNDHmm1nU7awqBrhNK02uCQo8cItJ4sVkniUzE0+hqdne63fDk+jQs52102rp6uUGu5at7TO1Xc4Vo0a1KUx6w65w5VpPp/v7tj/wLSZWktrE3AYTxObMsWs7n3fcbVNb94sCjcc+TmQkkBJDLZkMZ7TR9NsnvD+WDUK8JyhN7e1P4CrevoKmlc8QIjDd7uF6fMS64jq9ac4CfXSLeNt8YziHDbc+26VjK1pe6c1axSH8Z8h6o05FDR1pSnEhxJTkaDqJgTZXN8tF3BvRneHWdSqbnOEkKN7e7mntb/GJMvYDC/cnNcyP7uD9jVsFmYZnF04MalkW1Wstr3MV+u1tvbWZtTyMZlLZrb6SsjAcjcqNqd6yoZSAq3yrjR47Y+lvHbrsdst1Iz7Ua/xSSBBewvhfwUxjRiWTYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHS4pCgfh7ctnQuGAd725clisMA73tw77FIUB3vbiW+H7RvD6JjJRzfMfx3yK2b1Jf/eXP/8tyuGes6e5qaFwkllDB4ecmH4zLsaDHXcJVW7zGzas29558fSZboydWYUaF222d29MfMGNNA53MTgMA5X8m22X3dV3uSz1VrDSf8K3yim6WGp2/aseo2ZSuRwrBRrsyR3oFrL23suGuPaFC3aNWLFOtGnEiUxDNJAR/JrGs7jRGRDy/QG+K1sMVwVq6hLlTHSy3fMTkzMzEpvElZY2mat8NXZmY7lW8ntBZWVxgwawfNJFkswOU+/8O80l3Sj6FCj5nrr0iQ/lIu8bzbefGv6ZpJQVJoNxh7lkUDXq2/OnH4pn5t/6TRGPJ3p7SnAn1Qikmq1mC+v42ny/Bfs8W86mjwM/UFab9ddTSbtrEvt4t9+ku8tbFNpPqm6sXmq9dR/bFqVk20wqXVl4NaJNrY7tiS1yROSuN6xlLZgJgcQiyoVCxAZpYE0F621hNFYmnncX0OaKq4tqUz4NsdX2aJdqy1VlwynlVBdOT+I6qb2Fc+WKPWF7A1isJ9DUhuQ9XRqqSURhbT3Z1uz9wiPXGz5iZ66qyW/7XiFazcroVJ3HW6/X8KlKRXkSEwoJSFTYnI1C5uEj6sx7T7tAm9sb+dWxDWctzuKXUIwjAUaCVS3O8mzibKo7Li7q16eJdvs8Z0Sn4EZmcIca8TEPdfnV4m3CeNhZckKcz2bHeIcWts4xaHajKfBwvmdzfIxOM7s0DsZVQyrcFOGQ1qVdaURJCaBIx4EGVrK8ngQNUptvgRY7mhZvrpTHOahtOb/yz7zS6edrpZrDerta7g5qOdyU6sjrtzboLyd49ex93tSLeTw58LlPv4NK4ktCjs03pfakUj2G5TxvePt3vGM5jbvRii209fapurhDkxqLvGtZ3Dg3h1KqcITcLm0AQ+1Y+L7tAt4Vt5ru1m9kbV0xoUtnITgnJFp9bh+DSWGx3b/OrY14tsLiFAZ4ypcIrnNt/mO2woDhN803i0Vyb3OCzKw5jtfR4dIFr7p70quWCFolF3TgvObGoFg5yAmu5qIxGBRl7bk8kepQnwJsNoT9SszM/pWfsanYYCiZZVlUH4u2FeQRD6vI8vw/y5pA9DQXtMhYoiEN8Sx56baK+kisgjHZUvDfzPqQIm3csVGQpCFsano46aVliUS/GNBUbaIanXECDdV4YHJT5nzm1K5fNuo9XkO+s43lmcmTUreq85tv08fMBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAByiKQoDvw3DqcVhAJe9uWmYpDAO9jcu6xSFAh725URh8TrQal8Cxmx/y4jvXF/n4xn3tqDO7o5K8UJ0v0RmsB1FvCfZev7UpqNWSesZ5Sfl2lgWrGuUVjO9arXcufl/NaoaffIzPs7EQ3VjVW5Tdx1W1n2rrCnpnet09WU8mruNSXQRHbE7Ltymaf6PS6C8L7/ONXrdxs71l9Nn9NjWhb4wzIq0M4xKRW8ub53vI7OS10ZBTQXKs8cLkRgSdxa080NVoYfqtPZWccq0psVr+se77lSw1nzeeu1LnIdvYbx5QcsU0/W1+6uNmvVtY7xvZfZwu42fxq44zXLlN/f//yy5/2bLIxDf1l8bA3D9E38O0fUSXOPvWd7mgvrZR5RiwJVGBxHk2paG9nYo6lnb4Lv4iqhau8ZWxafxJIR/XtmDaDB3bD3GvbDiwtuYUGdZQ0vMJhVXxpqcrtdIu4bBNNmBJCU1FauFNDakWnHNai9TLkhK5ZV0wLQ4Ug5V1aNWsLRbVg9SDMbalGpqZob+MwstbfGMXlb4s6ejKgolazLdpHFdRsKGkGCwly6opDgxafblG3taSzEZSriN7ix0iPoGKagsj1gZqsqkQpPqqE1Mz+1KwY1d4e3zZ9WLNS0kJ9AtZ9Pifddaril22IuOFi5pctFTYStVi+qxb1zA18b/g4jRMTxzdgAHYsR+H6iVZLHiWx93cb6pmRube+jRnGJkD46wunUSixwPnevvPdtpUoEdz0e1QnNFp3HNn38nco2VDRCv3uuQt2dEEaD4RiqfCWnIQ4Hjq5eE4TEc5QX8c6+OvwzEuKsSCcMD+fF83Y+XL/N12F47WRRHhbegXxks6NbQLkloDeLTg+c9K84ugvRZVO8Iiqp/P0UL51n4vy+MHbdH8pVDaxxXq/n6Uinvtdpzl7d+ykVtnZmPIubBiDGW/EieFPlCvTTq+IcLWN215rw2xupKqSqFNGuiDwQhetWNr1pduhw4iMgQ3Smb3M/UM3LC1ael4kCE9xTNb7xW2XA9iqY0amIxNDua96j6o1R77xDtK3stmZ5ZYVTG4J5fShCiUqE8VcsrhOJk53O7CZA3BSYL6JEzHniysxcC7HCwpeEp4je5OLKpFhvlxj++myWy21v1WxvmQ/Gdub1e6uv59cHVFkiWziNAZIEqfmUJvRTxHnHYVU4q4xVaqlQfh1p9JxlJqLU53+HC1WpknzEd9jvGa5IltRH1d1kiPGOz222TWca9YF4MKbQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAdKikKA73ty1fCoYCHvblxWIQgD4e3DrEUhAHe9uRUKDRx6Cu0PeYmtbha3Hkh4+9/EHEGCwPk4+5lhEIIOAuT9yqw09PESTjTEZ9DmgP9bfP5LOSQh7WXCK8UzXi1d79dbgLbNHkfkhHIQtdOT57Ebd4xjW8UbU6X1awpVc7cTtokn7AW2jfhtajmczOPtOkJXZ4s7C9Sb5lgZmhUc6Qdtrpdtxb1a2NT3D60bdcWllhNyP55Rn2E9GZU6dKmjNJ6LU0M5UKV80fMFzV19KZDnO14MzEc0FWRtZo5R5csDlPS+YKtmhML6+M0jyqZmu9rC9Ysz7V4jFfXpZ1TbbF/xa1p6vtzCCishvLrwjiNYp8Tb3JfH384tuLlgoyvT2ESUR2l0ZGGNa3l1me9p7R3rLCjPYEOOy31TW4moMWIiWXHtb+24MN69xbCtSintWW2MW9K/eMsj6Ef8q8wrEZTQVLNcuT6ilxVSxDtRjETqEO1khRWCCzT0d7hrK5vCy52ixL51SDFk38Y8GDNFhXdQlIsrt7FesDOoctfvpFoqdYU1J7wc71R/GV0jmyKKZwYGFtalEuzpiKKFFgPmM/Xr5yVr6G9/k3jd61i69cb8Gb+/vFzR9O93oViCgpQkUFRiSD1CSookPO3L1nl+5b5/8/tJO33Sg5e8tp4qPIiCjV2di0bnt1ZjtSmx/HKxq5hv+Xdw3aNVUZDozOwoVVYbq1/3/95d+BFRZPnaoTiqfywtYj/E9ZH7FDbYLFBi1XUb3U8hnpjaMJ8fqkP1xRpgGgJAhqdM1sjvHl82jxsY1Ebj1RBbWKsVARb7v6b1nT9giqNRLtUNzFXMI99qrbicDhHhLqCrWSdrdwHeHCLJ5IKsjrpLacc/FYUSs0HyRMRWar7P/xFj3jVxrdMYrAzvWcbpiK2PJ4u2/dK4gZgOLigqMxpqEBqlFTq2JtSWeWrev/8Rsscpf2FbLNFIyCrYbnTevmNNLd+8owSMcV8yvnCAhj1qaGPNHFwVSNVEOkDGNYlhTM6xCo3K6C/XCr08iyMmK41reYaocZIUVXRnNJqxZkSShJ4fMUsZ6pJPk+SybJmScySxP1dRgjx9aiutHe1MDR7LMa61ATcfWs/WNQVbIrGGitQ5Jw7xq2g31O7Y48FheKB7EvmLePGu1KBRvU84DmWJIStQ+IqHrIrVpduZ1rhxlVC0zszb4kGe+7z5xEniXxX0pjdM3gvqMdGeI3e2Mw8b1CgmdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdxiEIA73ty7hFoUB3vbl2WKQgDse3LaUVhgHY9uRwKCSPs8XZQdSFo9PnDy7nF+86/rhshIdBajLK4UkdIojRXMBUyzz40+c23VY+I87gw3rTzrUi8eyv3tsxg/nJwmxvH1pzmPWBbaKUCHJhSrlTJi0LEO0+579fO3bAhislgxDjVaLnPol52lPOOsx0e0HSWEWI0C6myIA+HmuYafQuLWkDEa+rKxFraKRalUBhsGLUgV3nUDKlaELMpcH+dDK9ixFbDfP4EdD5VAsOmBcQmSiuVzm/cGGFPhhTLNhr149rRXjY5xoUBSTVWW+XM3xmCwyKiHXFZJsuESke+9x+/pmqnnmrb7xDvJVmYEBpU3L6CTibOPLqnjf5z8ekeRqjFtJE2C3ngdhRmSwPGpifZ8GDNEtRvncHrK4R5rtjyHAYduOKLqRuhqGDXWMUvAeuWI7hWKie/liXl3Hu9zNiW8ryO5q9P5k8BUMCKU6jIQSIhihOhKKhbUR1EtLeJEA3ELbUIbsKRQQqP1e3uB2HOprvFQ9uzK87G9vzGx9Xkqqz0MhYVpd1cW+EfWXianjQG+A8scjYh8Z0+iyx/tXL29rpVkuUh9ME0t2ZsbIeGVbnPxQIhkht6+n5LRJYvz3l4viQK5hV3F9KeAyR4z99Ixw9f/Gd/cCbsIEsUnmxjg2ogN5xLuu0+kzWfoX+baEc+QgEgKOxcTwbwEIR6VjcmAtWrLtF0d3fhXWyxP09W8NTOUE6ll/NC3iNS0dqe0w+ZjGuSFOHLXT2LW2a6xmWG4u4x9rquWVP4OqzWcheSenQox3D+FeO83jSLwlmhRBflhUxci+tEm4EtdPYS03G+XFFvoArztdKqFutt48AohdQ6UbGVL5OvlcuVRKhsWXUtWKVlU2lLK3ssVsYkVtvpC3MuzdeN1IMaE+7a98V5GvFRKMZdMsXX72kJ9GvqNXG40uYWNwWaE+vWzXijNevw3XtFl0bpBJUdXIaBvEz84zu93TrHTuN/7R2X1sIViUTjBwpLj39fgo80yw+81Gc1Qn+qxCh0l18Wlof7qvzm33mZheK1ozCcWlsc4WN/wI2I0LW4MPd6xJW5ufODbEYm430KN4u7iiTpJ6pGE0TzJIi02byveqFijXivYUkVHNzSrWyDEgTp2I2xMb+dVr1weSlQ1UuTc3Lpy+rND/GLfG5XyqVWY1fiN9vZ2GBMcW8QG2eSHRriMOGFyhKdwP1wVK0wKjcaBuJT4vNu0ta+u8ZrbNa2YaUvrXxeWntuFXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHVoPCAW97cu7ROEAt725cbicKBD3ty6VFYUB3vblMSF5IXjXvVZGRHLN62vI+pm3j/WIkV4hjAaivMUrCajrN5BKZX2j6h4vMwXfTRKsmHjVnVtWiQGSarJdwusnW3SxcU3rb58ro8SCsHEKku6KUKtgQZ5Jo89s0e0XDpSLpVR6tqgZzkYXzMkyfEpJ0bQ30qYaYUrEjSZKxcl6UE6HRXzp9EtHgVswItWHGZTKM870hS3kjyPZVwc66RLchMjahjTlD1JKp3bxkVbyyGH+xMD+esK87rq19u9nGLCbX0GtN5haiOt4vA9LqyDR9n3w1Q5X1oGZcVZ4l8vN5xAvTUGw8lDblAEYl4WPlDrg/wYm3iFC962ziNan3/n3pZeUhbFeUsM/CxjehObxVQ4avhedziP2RwmV1X08i6f0YXKO5aiXjsjfCcVqanp8XjxD3TtXtnS/R2wLrXhvsx61dbouFaupZ0S4LpgNNOK+u0AbhMSdFhRxKEuYB+ty5JMcKTP1ohzK3D1yo5vFAiYSsXbEy9GRFA3L+3sesZtZnJlMpCKK1C4rmT9FOPYJkW+iw4DfaA5py+2uBMwUwzvm1fTbUkz+PFT2nhNr5OxosdXQV1KuFYwwKv6Kx/JtmlvmNiTULULVvqmo99TQ2q0XeMwfXdNWmsLEpjjKfMrkRfAy3xiDatYe8+nz4MDctHBMJ8u4H013OydWoW6QWuA39wxCtGtjPk3JNRkcFYkWmG3XlvIy5t/unzEewqbeIsfQZSaVLpX97XU2s3+uZiZJOcqvZnBRTvqqqp2RE0p0jKOE41aTs4T8doYrSCGXIxwI7c4ZpR/jLe4t6pN1jbihJwvvavXLc9saZzlJ+fzkyuLgfsKGqlGWBiaE7snDOtssCX4vSDthh0ntCjNy5g1ba5+Hb5ruq9z5pml3Btevvukvl240Y41LuVIeNZxam9SQn9K3zn4zHtWPHgj4sJjYzMyodgZT49d61Xepf83bdx1LHZG4+RdToFrON+iXu75zpgmfzyw61rVlguTg3tjfakB1BzdtbYL+mIuvjN+/gINhisKoUQqnGHjG95941s3pZmcj9TCsVqLTralFt+xGbAZ1AnIg9SUdkIOI32hFE+qoJWCHFa2eOo2NWPG+OzSSQLuKuJ2np30u/qBad8p0eQxc2nW1Yt3fGCYSQdz2UcJiUpwJdsnrbM2myjYy5jothVMVvfsTE3K5SOSeUjYpJVIuZntGWXfh1cJ83dQGuesdzt5O9t9/bXd5qsDE/3b41XEXsgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB2WKQYEve3LyMVhAJThuHZIfBAW97cuoQ+DAt725KlJHWdkvuQHY8ROGraa5sR8Ztev/lvEgmSq46TENlJyTE5ENQtlq1+G3w+rb03m2ZG+LJRyVivUhtpKjDNaKvoTaD8btrO5FGqYWWLR4mG5r13zqDqTV8zw/ZlZDnam161Poa2hVFSr1l+lieMZ3EzGEaJeBYxwBa1SHYe501bnOLFs+vmDGZICuaVEpGXenOF8U1X1g3MZlJy0J1jcm7ERtVK4XD2O3tllSwq2DFUDeunG0z+I9xCpPdcEuV0av29hwWFKpGDCe/wpKTxdfG9VYZ7MEeej1/usKa7FAnnxmkXMGPT5xH1Hw9jgaaUisc6dZx36iPenJ+p1qnyv+0gZJSFcbBwGigrDSEh+vbuZpLE5ZA6mfw8m4FdPzTxWV26DK/hqe7cw/9drZ2n4fySzEd47sdnbusf/LLVixuvV7OxJ4n7gKajtLOSzCdh59LcYabBtiDWYMBdZv1cKbipGkMHlUu1VsbzwpbE1BUkjEMymrnYuwTTTlnmX8x/lWC6kRy95oAvV5qrfh19YxbwqZ3cZigywlteWSmpEb8gl9ePYwM9FmVS6NSl/ezOb+4urVhuNZSqbnpjLOkrWs9Zbxt5UHYlHJulwjnKLPLtmzdu7yr5Zd/f4XdVe3q66EEkW/pTqFtyKcXFZ4c0aFB/vPjeYSpM5EiyFuKMog7E4oVidzcJ5oWoUKDOyMeJbKeK31lkU+H8eMl2JyfO+3ubM/tJWtNVxGPhizlsZA+nifULpw8DWMQPv1ocKSPpdHbqAr1ncFXHy1OZ7xkXZdtZlnkJIaKVDhso09o6HSrgS53WPFgtkA/lKo1OhamVr1V6xS+86gp50zxS3wnuY+rrg9yX7ZE49VLmuVRmLDtM5Sxo602wpG1qh3O1C1ZfOrR4T+PV/mk8GI4qjag9s4njP7u5KQqaavAtG3vwXz/SnxFYoM8XWKwaQATto/HC3nNtqhlyL5sajw9z0znz+16R4iKQlJHkwzkc5tqOlmcn7Bql3zPI+grcVyixorcws6zGUMbTVmfd7XaX01711vEnaFUc6UfVswIJrs5R/ab+HWlnBO5uYR/pCRRrKiZVwcp6Ll0fDgprqSEchwjfOZHKoXjMxvFfHcI/ZnqOOg4z/8CJI4xHi5eaVmLY+vaVxc1JlEKezIpIsLTAq0g2xWydONJimmwO3KG+vvxGZYiH2nT+Q1pV6w0uTLI5wY+kvZucU8pVJKoLskS0SHPu+Z8TTy4V1d781tau8urIjtw1/vO5KKg4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdehUEBL3ty8HFYIB3vblxWKQYEve3LycWggIe9uVxylsh3b0j28SuVLRYM0CO5YtSJXOVGyp9pWkQhBY3YYLiPkvjTBVh9xoT96uXdK6vWeAxqaE9ZptvEU2OV6+7GdrlCv601rWdUeyP1Uh8UeKTPGfeMRqZxe76h/K4grgqVbK34YoMz4+E4yl1SxummrSe2T4aknJ4iOoQDYKZgVsRRTfU0TEduiOlagU0XBWECQ1GtMbcvpq8zAl1ShCiT1lZeja9OVOViq964M53pzcF6/gSvnFrYIb7b2srI1nEuKZxeW3YaQHC2lwxQvRc4t5ML9pXLUz3cnl3mm/LSPrK4e1evYDrhQ3FlQQLCpmix0KC1HDE+sRK6pl36b1vNmOGc5ppMrlAuyci49GIpkftWaQsuMJ9V43OS4jvuj0erFexZcmuPLJt5vSmW4Vfq+rtfb1/UV1zRRK8xOUvz75rNF8ZmgNkWY8kVV5mKd0qYJyh7MSIxVUpFET6C1CbEuHEIEVpA6bkc2HOdOWn6GKZvY1VPddtZgzLbhDpX4rPSGW6ExsKJTpf000Yil8P7eUlDtBSaVseUJXLDGySwmh+rIUFPTDWWXy9BeuczjRO3jOrzwW5VbcoKJs2YexqWrGguL3Dx7r6gXpnGo3yuo0aC44+calrLmDHE2xZePrb6TOUFrXzEdwPib63nOKtcsQ6VQ/WCFAKBYSNIw6mF6kIG4ENyve82KWgQZYmqyxnifVBvsl2ZX1Z3+4mof+9XzDiwoUBXJ5LA+lFGeNFJsZnhXpfVpbXfxqaZE7K2s7g5KSHlSRk4iEpCLI8RCFQkyxn+cCo8Ots2hyVzCW1YyH+4sKoJ1HcqwIt9ZpVeP9bU5+MMKaLaZuRS2jXynhVhJyA2M8fD2Gz3w8dZhQMtkNyVzjApJp5pyV14O7z5h3zEiZvjG8yyZzrcmaZ1Slt0gVzljhQse+vj6rSs9mpTB+ohZqzawVWvlkj4g4t9bv8VvDhJVEIaYA8hsH0LELYkXFxf2kbNszOrojJI8iq965szPrrl4jaq3Fp0zHcz2bHjylfW8SIwPqpSy+XVjQqB3Oe9p494dczyxezqdmmUd4y6bIpeFG9U6cala4nOYZ5okwzHAD7MhhBnx1uWHm4O1afjefbHVdM7kuojYzFhsyt7hrUmqSHJH0zJ9Doa0jHOTDcSFvdVbX65P2AqGyAnGSrkr1WzXZE670rI5eVI91dbc3BgXSohJdQLEt0+x3iPL2fRI+/CrBiaktGpm9N7rLGu2OrRMxn398W3/rEfawAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHI4tBgS97cOyxWDAdj24d2isEBL3tw6XFYMB3vbi0SFBX1r4ue/BWls4nixYFPveP7vZbue1wqkOXhvmOa75Ls7fCgUiwIOtRrY8V7XUGDbwGNub96aG2KyGYh1rQLeN8xpnK1qUimaGi44owSS11itc5o3vzPrCgUeq1Gxsx1ZBRCGIZAgOa+rR2jkQSGi6kBHcIciorMzR63lrne/ZXM6wsVa4LqN7UmpS3PVdqtCmWG6tCpSz5Jp2AkD+YqodPKytTKra4VyiaYL2NGjQqQGGDDhRsR2+VUuEksHO5FEzbmzbeZd7iPLvo1/Gh5vSJCfOLK9pLBvSmtfU2/5ouI2UKKioYKGxdistgtz4ef7mFG5HMyhu1+pdCwkkcAExCcc4IVsTzB4sPW/xlaepYXI43WI2XBxf5vJiC7bji3VttjHtAttErahy4wnNQx4m97gwbx4UaudpWExsSqjvlcpmZhrhC4xP1GW+VvesCuFmHOWEqgMygCQqFr24vYtpITlJFVE0vjtPqyR2f7z/l7CfOahQ1Kwl5VnRBYIunqnnisMWuTeRzioUa9ZVSw1iNzFBxjbCrm9kjM6kP58+Z2FxRqwr1Kv0eK5PQpV0zMKt9rYpPGjWYbvrxGVotusJ9Owvo0GK8+/emJLae1hNNAkPerhdgfnsLWxek0eW8XVff47Ir11GKc83RMy9hUM5ilycaPY8JyvFbVY4QN2hwqXm2/nVCigxk4pYyegy3UKh8t9/FZbx0Pf2jNxvMYbagVLlGvAZa19PNuqtJ+fEJi2qWBZUdD5NBhTUMyU69LbFUaVXyTjkBcq4nhmuKExpMbxL6TwWFUxi3FyucpGR/JaSa0bWc2qZ7YcNEqkXyieVUresKFeYXt1a4MivX2XKrSqLeOKegK+Ry+3kFROm5yrXMNufPnV9SbsxKKM5RYXxSNV8+ng0vXVPFn3LR7HiXYKwIVXKusWxi1t5i1USCgzqmIc0H33Dxq9fB+fTOILYxqZSHOf69BUZZI40HcF4xP4X73zu7Vh0iPGORybI68ub13JrNILajWuE8p87h4liKE6GN0p3mpVN2j1hxI9s2rWDdlsqllI3QpczqDJoDjfKOYnSujHMzKBbkJoH+W4Hi9Qp2rosPdMtUBVqm1WyV69jNhhHC6vGjWpqE2RF86YaonOaIcKH0eyPWyruOxYYm1P6YYzlNuK/gPXzglXOqdY1RNqPi+F20KlzZlEq1A5tU5xPHathQ9ska8a0asLd9QI+7ytc1L2iMbczvLYj6rmvzXNprAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABzWIwYEse3Dx8WgwHe9uHLotBgO97cOhxODAh725sl4hnCJ78q35DvS3Bqinr5m/TM39glHSt0FBGABUAKBIRVjLDlm/OHk6/5ldRlpnEKNjb2VQO4j2d7tpVsKkCn/zEy/zHfNlUmnjXQ+BGnb4mKet/pcJGAqrq18xMKags5zLo3U8qVy/c2RQNh8H0OKIIuUKqLsuFO3N8ONEw13xeDdnWzZirh44IdLWHDzjGV2uUElisRDAfsJ64unqiTbI2w/C03QMOcPbfFblvTivXnhQJqvEuyRM6w+iwXyrrvFM6gOXdRtXjsjhDcpGfMmKUgxbV1qBbb+8Rn06c1fvGqWtMMi0SUBas0s8iTxjXltWbF7/5r/mvhKKEn9iLH8JjKXo53UVg/jXjRmuI/f2fZmeObxVK9WxI7uEy2q12bmXTneP8/O4UBFoYqYeieKqO10vrObWxn51Co+2n0CpHSEOSPfHIYJ8luO0xlc4OL9VsZ6oULi0B3FoaD1tYHrxghs+S6MCpmjR4kRcR1LDgqGSm94q27Z0NOguirPVIl+RaFszJBZ1eusN00GdSRUJdxo8Zxivoz9cxn+jk0K+XN80L+ly1piAww0lNCcoKtZG5XTOLAyR0+p/uNRX7gYe/e96hYp4jJVLvHNPxGCrHf+sPcLcXoHypcLLMFrRQcqC/Hl1hz1nWtX19bh0qxwko+QY2EGN8rDUSipj+sXO4UfVIFJYVqy0u3t8R49c2aPA+IEdVxYNK+mPRtXep4+FEcySfSP30SHDznNdbhbO8yXR+MzhWOnnyvYWxvQ17MvmW3FsL+RalJuaTrZgnKiEvCWo+viHDib1BSaYIA/TLKRTnFm73/4lPU+XBOplzaH6pgwoT92/eywGK6xMwPm/dZqt87U2ZpmG45caOGZNQ4Lza/uFC1eLNuOqYn14rjpyZsT5tJC3itbworXeklW3FIUa/1FzuDqFPfUyHGuHXKCbwxzA3Hl1uPrOMav/93rVrjpykY3lsd9TaeMmcw9XaIsbDS0xHivb/qBBcVYpnODuE/gRIb5mZM4+fikfakcT8YMyqRFQtVxql3+ImX8O2LNkqvbViM1UP1W6kfsCFJZXrhCESTsnhHG8OguJATJbkOb2iK6iR69WKBRIGA3RGVTyKRIIGI5vt11nOm9cpVDD+jNjMjHivxEZUtGhWs9ezK6V09iRcz3e6f2bYisRx/HlSzSvMy1ZQK1D2NZmmvJEgsapix7QntI08akZ9SArmeto80fNP723As3wXWv7Vx/ABeAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAa2icIAyXty69FIMBWPblxGJQIEve3LuMUgQJe9uQMDSF9ys/Xndfr5e+bsnHfvZlEqyFyEBAkEBYRBobOSjVnOsKDyrPknGFXUTTE4MZiopWrpVSwaKKuoO//isGFC+G4+RgpVJMbdvbDE3i72vxDYVbItXhQly0Pn23F8qYVlS2ORumSTIbppLRhqZQoYomZ9Gv9b+NwX0ZDcR2BjiuKurWtbZ+YmXFdwX0JJvs2rqJaK3rmjCrIKsZm1xUsSM+zEnxfEGk6dht8S2YmbPZO7gxq11NP4Pp8RotLPq31atYr6NmNSsGFj5m+cen3nT2sKeL1kLGiwXjBV4fbDZtWf/7ud8XTZml1sMYgkkNB5OScRhJT2n4m3lRDa85c2vzjTFi80vxIjVuBa7LpDsxZNf4vmI2PlGrMQ3h+qmkGNeDVunrFfVtZjq4t50tClen8tKWJd+hp1N54qpzQ0wh/C6ifHKsjCJafavUqte1hRpYLMuVAdLkytMWsKIuYah3TfvB1mLMrW5oRLieywuma1rWivmLVo21AZT9KtsVm9dPHzMnlUXVKivNEFwbnz9QwFUvsq85J5XSssR9ZhmyyMTHNi0LMuo2Wp3Ey8itmc/NcOe6xY0etbTwrvcRoIFGD6mCC9LTnZDtp+lGquokkm/82+bNkRd5iC/Zz2VjcGgM0p17Dgy1leRJXUbW48uXLdH18vmJON6yzu16bEtpn+87tv63hXQYO2d6LmsljSEWkX5+q+NvEBlM1nkSjtkbYLOcCsYWU7dPl21PD0U8RoPOxfEOBQHUeMV5P6QPBhx2/LkkG9ZT66V5H1rnUb1xmkyMmSk8N/I52o4OLkyYUh0K6HcvDk61uJAiXisj3FLxduK8hrPFteJGhv58N8Td7t8eLEzremq7yNp/AtTOd4jw/eFuPPjwsX3befiembziRYfQSCm85n0l3E2vSF/SSBLr6rquYTg2uzNHGYyKNw3ywDwZ1FDZZI1XGyVbYbJCxpqY21+5MLAtmbqIy6rl5CguWYN3n/hwHkNPl4gR1zO7UDfeJPSLEtWFB9W92tbVyvPI/VqEqDoaVtcIUQKU5GJ7DMNOMx1HhsDa0F3hrb5/EmlY+2JA6FHN2GA+cLvDEtjUDeceR5Ca4LGwqTLmmlRbasTVG/a7YWxEMplIfGmxArZuY6tSmdvTmQ1tXb+TC6cGM43OY/Vp4zx4l5ZnClLxI0Wl7xpJMQ21y1mB4eN7e7y1ZrEgPNX3TeK5j8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHXItAAS97cu1RaAAl724dficAA73ty69E4AB3vbk6pEnuIeP1y29d37nJFvFxBj6xrHxJGd7immlBjhjQhJCTjERpb7vY1ad8/cM32/jOFZdwNRXp+K9CDfWISy3H+153Wfed1xuCX1imfIQ1CsVh0JFgWGKJb08XOasqOhHWwv25xYlDdUrTar5IuF+C4Migip9nZWo+SeNBPK52/1GfRr7xAira6ONFJU0DXP1zg5b/nFoEBcUw3n+h68nJHBqaVpxUigYVuNHiPH7FEi1b46+/Uk1cw9zn5EfagbgNz6dmYo02X19r9tQo+fizVhTZixvJumNQ4VI0a2s2h4nznOs++JLxqWgeRMo2J/E4flALVzrvmPiLuLCzau9+9r3srz9BplyL2dRKSWFYe0rDK804xVza8GBBclZZcRG1xvSOxx3r6BO33jp+M+tjPzvW7Oarb2LsSNMGRqjxY2LXn1m1MsLafUdPMSyr9qFTJxaqzIhzY7wNK9DznfnIoDqLkXYm8Y35ImsR4KROU8FRtgjyQYENmVZ9Plm9d5gb1Ipl5VQoR+MDfWfWGtvXWo7k6gpJCkfZ7AYNRokal5ZGBwYE4po0CLWjxcIxGuLplVzHGa4zb9PpYDg8VFtSZez+0eNu3hMEa240DO4eaz23jdK5+6zTYE4Aw6AxHEwfPCqSoYt4vm+c3v9U/8OHKiTYHeuFg9EYni1IUgU5DPKFaA5dwcNSw25usz1ve9XGAeJLVqKcq5hqXTFqfV/amqw0NgyLgvxzHWIqKSbT6E+fTVrjVqypEoUnIm1U4tq5SsWM0KVSyLKGrlskVjx4iC5liVhfhFn6/p/eWvgvb03dYRrtVHMX49j+STNu8K1v7UVMp8nCsMCNeyzOJyqiO6u9VrUdTtbb1S9UsGaJtXWi/ESR8XYr0bFk8KK9pDYd5xi1m5mfbm/2+w9e3zvdv81ixvTz6plvewc4tvVfBg5kjRSZUAY0BlxMHvCHKkN6p5v67npExXVK7b2FFIWm3B34STHesqaFHYLwXr5XPIE7mxQ2FhtdhZYsLcZuxqaWWiqcqZxf7xqjI8OFvykVYXqGyWi6vLqtZaY1BtHmUTE0KZRK5pYsOSmNJhfEugNrXDndt49A4TfNEusldOojzFk8X5gb1c/jq90yt6pTqdRL17rea1kfLqA5H8xJtXmufbxlb1g9MKOI7YnjUxvGzWXjK2uEzDI4uSHK5aT17KVtUyWS7trP1wiRWDLue0HcK0Zu8F7mtb3nx64ttts9iwcWj2eRK+WJb38KFi0JYUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAABz2KwIDwY3Ls0SgQGe9uXSorAgO97cO9RGBAZ725E5YYAuzFA81RUcyi3SWo4YldM0pvpuyJkPRFDhAwCczFyEHKhUPnnNZgyA2TYn0TU2cnWOJqYvQviWPA9FJ/3ojsu/z879bfhuXIbLwlEQFhmZlb2d7f392iINT4RDkRzlohFUenzsyNTxtSaH5sXSkJ4Mh9HAHzEBwJkUtHip37XpHXn8TgQNSoIwpE4cVW1Y2abMRdE4O3RLKZXgW4dFwoolRcfTsLycVyRDQxgcIJfLEaWF6DXjtxHWmtvroEYxOp2M5TPMw1rnNvutInFLFkrWJ6XaXuSzbXYIuXsLPtXd1xGy1CqBmBgudAg78G3D5xndcY0/zqBXWsXtFunlOfzpCxOx9m9F3RfxDxisJ/iqRsdz9tTjcx7fSR1RNLvUaBAntB3jdcfxsuny5Vz3wlUgW55Dg5rq2dwK6vW8i5saSofK1WrptneHSo1WyuTPFYV0voglpxCxjIZ5k5Gq5zSYgxFGoXdG9wUyfj0YU4pUOcI2aUzVr2vKc+TuinQzIBibXUFgw6evdQr3XL5cx0kp1a1Por9ihtM2aN0z1ic25lUC3SJRFmiUq5j0gP5W2FFV0C8tMRZlm1mtJTuo9nzHEzaWI+1eaAzx9agbpe8BY7bCSaDhUEwveIuPtvxYu48Vgnr6Y+M2jw20v0dPhelgJ6lEQZCcTTzX1qrbAcnU8HNH07fHjtjJGjIYwwXyjxCiK1dRvCzrWM2fLmtbKxOKF43OTPEvWetfe+dvVCbzWrYCp0inydnUyjGKoUqr0vCOhKtraZK8wkZPQV4xDxhISru8zG1qPAcro2z9TvrRH9/q+dej5hIIW4trJCZldGfqWdXJukqcORXduZGp3BUPWlOsN0dxcprMz2BOhD6uXtY2PI0RJs3gSMN1c2+9It6dxhPbW+a4rbV6XcaRr6u9pGi4zCtC3NjcXcBIYEqgIfuAH8Xu/Sbd5njnrWv8e16xTiPM7SWgGxzt6kRkkbWMTaY2iLBREeaO5SQVLVtT7NZxVj9fzFbozK2LUOWP9b8J9MXwsJ/Rm1UqKjt7v1tfMmLb7G4xYBosSbUUdWp1LOR6ksCuUx5Kx0nTnQpFMSiLupjuFtOVVs3S0GZy2rWBLoTlmmd4niutXiYrjda2gryiJ6so6qVeMikSy/U7Gbesv5buCdTUJnV8qShK2Zqhw4K5gGc/7i3P1cr3HTbAQ5pY5FO1tj5hVKiY2ddxM2nrNZ7iNFmg71iz/WdbevHLEaLSP/nMuoWM4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1eKQIDPe3LtcUgQHe9uXjoq/gQ97cNbxSCAVj24AgCaTjBCX0duF/ePimp2v2xnX9MwoVX6LRDecpFkJVyYZWxg3GzfDXTFokR/W9/XFm19hmMNWtp3N+25lcM6dU3fOb3Xo0RsonxxC5mSyM8CJSlY3p42Yb10oGxlxDY2dPMhyqQm64cFGX9Prk6GA2lQZDQT9yGeYidgob9WgyzuVXNdveq6qwviGIXEZJs0xW9Y8FsVxcDpWVchjFDXabMJwVTQaENhcbIF1fuDMrWSDMuobulGtn7fWJC3TTzUWNBnvh5Gfq+7cyR6408gTbltBpS0sFqtiRhxibW1PSPeHDtv5zTERujmriYqaJaMJjsNYnf4rqlbNf3qu641l9baJVpYpSsHGcJL1K4QaUrW7e1UhK+yuiwp7QoDEwoyHbDjGns4tk6gfaap8Z1XGni0da1DaCoPyC5R5LwZJJsyu6XouHN7ttfa+liqfPg3SaIs4mg6HCGXNrS7SXN2nDdRCrbGxi36sC89QhqS0NmsyKxzXaHsmX7vFc58eRgOg3kXGVT8v6DVeU4ujQUzaxySSno7ieVtYKsr+sdnSjHFbG5FtN/J2BrVMeOnEcjXcR4wqNnYVMyM9Fe2z71trjPZMbbcQ6QmyLStsZcM17ZTVd4+8XzPVxzMJGsDkuQgmE/31rbxFi63a+MSKduVZ0p5RHelB63NZBwthL/eIzQLxasL+DXE9HNlZmz0ZnDZhGufyNV09FEkuxYz/PjO9TMsSAcx/xhPRJXqFN8GSPTea/eoR7jxZlK3TH8u1hTq0gxNyiQw1rtaAXKpL8g1ahxoi6C5nA5sLyX0iVev07qAzqk+xAVWSlAmkozhvW/1/uDDLy8VLtJIJ7RihwYLApaqRqOqAzQm1gVzt7Ajty0+hbkZoN3EkM6djwq5aqx2W9M0td8xo1hRr/WbQcWguUKDvW5M0ntrNYusR2WKuo8S9s43Ggwp7Rqocc4ksJJUEyPM/+TO1nLTs2WrjtEjQSrgfr3w5eKbKn6UshR05lbWFc2hLzp1c2+ti1oU9YV5d3pX79aXgtS4gwIZ4wUa5V1uuZbWzbFqTSOK/AhuSdeOWW5ImQX1Fn09cGaz5DUpGTqQEVYFa9iR8Z99J5gOp4dOY7JHxCjMszu2rf6ziDSVgPJWwVSpm1krWd7SE/e6nkP53VygVpbUKLWG2yKdDDLvhtbHjmsrpjYI7ptnpGrGa3UrLWMw2i/53atrwtfG8xf6682NsOoNYuM1ri+oz1YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdQiL8BeHty6VCn4CXvblzaIv4GPe3Lu0OfwMe9uZDRwi+QS0KIzRVXd9ws4Xs7v/zLDCpjYnIDa22KKMVICs7WmnpGHah6729qWX6XC1u5nS3bFWrlhbrp9FqtrOuLpwvVdIHESWNnOK4en/AjNjmzIA4DygV7nLF3/EhZ3IbLcp2NNyZjLcZbdMTmjUMTSpTLxPJ5XlvN+ZCkswo1+hLx/qb2Z7+kZhhqQ6Fydhhy3c4+oOvnTDCO9xcmdP2iajQVerVbGw1RdqtZX40OR5ukVgkliyWg0okGAeF3lM0vaGp402fHlpAeOOJ/m8fT/MeJH18024YzDo8xA1O3W9KXxXO8RNmRmOBDhDnInUkSxgB2X8a0Wmqwc49LabIDYoGtcnOfJkqFCz9E2YlEo6XyyqxX5fvsvqyL609W2U6GQ8Eq6y9keXiQ9JNwg2pvO86s+0pW2V6b5NT9QtteazHxLGh/ECROQnkJeZXtnFwZVLFNFUM51mO5MFmVOvC2HIniUUP5yeM24kOPB0aCV1VRvmRz01IeZjdRYvNrebxmvJxTSOB+YS8Vrnsu1iPaseDBXandPGesln+obZtgsuVptTKve0SvZ2BgVlp1Qi7WZ4nxR7Ayzx4UO986eZxd7Al3Dit+tVf7rHf4vt4gt+oGmxdU++t4t82/25rDxJqHvd59YrjNoG26j4W05UADFCSOIdbEOhkVMlPaBLV76XtErDi2kjxrzq09Ybm2QczQmfGsfOrfG3jjLAgLYmQmhNTLgxotdV1843ZTMhLE0r04+cWddPI7M4JGGq2Dc6kojzeSaGMpCx2CpLrCmlq4y5hubyZ4zsygjocoVyhCXUkWH9wtWkiHOgjcUMORqkcFGmGg0zqUjGkVenFCq08qIrM4atGmiQZ7ZiQ8TmW2sk0LWJawWONNvWsWvPI4+uN20u9LEmd1rqa9vr7v9Zf6zaJm3vSeSUsNThFVVktxP+bTdf2ocaSJnNp741n1vCyzLgYRDU8hIuAYw+B3p9DHzBetG+dwi73bD944v9sb5gw+c25uWm2G6gvoL201tfcGuIC6cLYbjwbFPEWP3l7Wz6YiQm5nhH4rELUKvWEjDcIiiQqCmm+PpP0RhfTsLHDDQQk11NDxakaz5ILBf0LWkKTrHiquhKtKN8aLXEsjgyJlCyELJ5ryGn+f6WfaY46vl7V2eErG8y2ZoxptzJEW4l102s+EMcF1TamVSzBbXFcqDCy25i2jsTVaJCbmZzw16cW7UfrLqBWmomZ818KtsWjVz9R0esAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHgYo/AO97cuRQqAAl725dDij8BL3tw6PFX4BnvbkKiMNgziGxUemiQtf4TZPV9qBa+/uGwTzQHiTOIlxCDKNIWhWq9mgvtyP52482GFqJEhQ4ryHRcbivHhgoxQxLQ46iTsJ9C3nXzuB7ZmPg+TJM1CnFPxX1ZodNatijdWNOr3sGG3wo6GuiFEBNMgqHGuqVNCZaxiQsCIHzhPs7csKZxpZcyTwaTQFUaMZwUzap9at831TLUoytVy5PiOgFDCgSqE1kNP9QsakiJI98JdyWnk9X0PbS51iwocJrcDJ0/atVeMzbHT8tNY8VuzFvHkxFxDvPFjSxL4vA3rxqOUuJ4M00aGyPou67trNIcVKMqSPVM77trbZuubak3vG/a9v5cb1ESScVaFoBwgjsmlguMWmOqY9ZI8GFSZl3PLHftrk5SuldSFWkJjcXcO/18edjbVh5tcsqHFWyq6S+5afVr4pJbO4kDOGRdQVlTI8WEcx0DeWWR83sL59lJKsvpelVCiZc13Gjq09jjVirRysc3j63q2Nlt63rHzJLVO2Ry+6RxvLlNMUY7ToQpcx3u7XgMzLCZIzfWd/VqzuAtF1JQwp2ZCk4omFtckPbVNhm1AtFebmaqK6Drd5bXj5zHYY2cUq5a3TcWFD2yyR4hXpIqBKKCB6N+MzxN2c3Dd/6y5rmuq/4reGtPHpYE+f5IjIP8hU8jXJAiQokJtQc8eLaO2R4mtywmhWNChRTFUtkB8/U6H5vjPtu+bMt67iVej2ZVqDDdbv7euPAjq8y2c81t/DOdC3BsaEYXk0oqeLAjE0yNBJzpjKAwCnA0jAQpdPVC0RfXVLR4Ssqp0khjlEQZzq/XgTfNZ37kd595maFQ5w2dhdJC+25xZlYqUPQh/CtGVaXZ9Vc9303voaSUWIz3wJGKTLvWqe7fDcrMdoeM0dMebvGDE+48LG80ta1LyL3rDivdUzvWNUi3gI0nvUvAOH5KPD3nOb+v1Wb0pBgrc0wSQ/EeoBMENPOquut7+HiqaKYSc0r3D3EyvlJ/lP1w8ozs0KM/jSz5ia384mipxjgMlGU/FPMvvomqwd/xsXlQyIp1crbrh0iDwSztHl7PM/UOWSxv2ljcjETy+XMfbwaiT1DfRmed/PW6dU0jbdsZJqR1lgeY/x9v4ESRyRkCOokErH8R8rVVFbIs8V2kW40VGyqzNvAm7hCs9hDwPpgeN7GuEhAvIpm2q5XEXbqaOxUcojLEVFoEO+XBk1IwR7124RKYvaj+tp5I1v/q2bU+pBIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABzuJvwE4e3LWsGfwJe9uXbYq/AS97cOxRV/Ah725aBPkHkUlDmcwdvuH3qvKtupUz/L//CxM0zstKdZsQjEy+PtIex7ofwq1qC5jbp7OOGqfX1pR87OwzDhoUllwwK2t21jjZzGtmua2eQnkeNI+cT6Oh1jcBkkxfNPqTTGh8B6uW+PBYWVrkbEuZKniN60iGRyXB5xFSXNXklYZYkOXWv9R9sbilEiwoA6JqKJHuf+Kf4lXKvcpmNqTkKWPEeuCxNIlHBjV6ZXdmSCyVc5HBhbYrjC3l6ytCcfRq3o/lzLGpaBSsr/MXNMWpR5p/Gh2p4r2DWaNWDEdZ3SfH1q+731al4eSehd6DYJVCYt8Q+/3Sv1emr2+vaNJBfum1NHcRRfY6jiP2/c2pK3Z7ZnhPG+eI37f4mmexXrbSPWaHZTTx7V3q1oG2e2IlbNUjqJAvNe0LclN63LCtHTaHLjLp43OcNfX0YtqRqsuVzpZZ3FTqYfBcNU35sZ3SWqMWHE6Yz6m1ezyxXUXe/6Vy2t7QhrC8bVee5/2q/hsmZneIl4apZJq0gtczjWO8euL9rTEjNM57swVjQtP6KB8rIN8Swc1tGjfWtQ8XhQLt8ud3n3F1u1MxZ6BikfPDOgPg09X2/LpnKF63rUmZmKLErrVfrTFM2uakeGhFIaTNmMk/Ug9VkaPBi4YXOPNbsrx94sC0dwpDQ4cJ2Tl+YKISdh61xHz6brZiiPqt+zmJGnXaFUc21yf5tiW9dUwn0NhQ8vI7K4MJ1EvHyrUCxc8SZJ8YJCAcqGMyGk4DRLBCUCTve97Qawqq5MtCWlP2Y5oDlSLl9mXVaP2tMPzaVkdrZr1ZYEGrfPM/XlOgIc7a2sM7kwskdW6m86luZbLGhxs7zdcxFXBpfOZ8WzLF1mA5RXKG3QbT2ni4rJePEfPZoU7bNSBanxfOL5vaPlAZBsJyXl6nCtbR6axXVos2M6zquI0XU6kQ5WI0eDpHqF6+Z3LVosSG+WoL6G22YrsrRKpV9md5mbpp7SQGhTOFpfn11PDgxrNUKMT1uQSdiZxrM0aNLFvpteR4LJWaO/+WJPHKMQnyFDqP2OhRdTgH0ZYkyjOFLnCcTn29s9KXTJ8Ks8DRSykf6frzmcr3WY1//q7DKxm6jjzRKsVieYXsFXp2kKNDmmbi+wJKO5Ylp4LYzHKh5+sD6DPt9Z25R4cC1V5cNKOX3Bi7rE8+YOpa/LA93Gf2i07yrPNuJCguLdO5y4vvfpfNH0GbCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdQiD8BLHty6fFH8B2Pbl1aJvwDPe3LaUVgADe9uXEApHpWrtU6rMXSc2m2PllP+kzJMOBAOCAdD8BYBQRpAKktwsu334qFNiGlYY7v2u23K3K+tMzBlrVbHHVzdGiR9wImviArbXnby/mAXsxn0F63sca25KR90ixzLOs00fKq1e7hITEVNSsQg5IiqNJzaTySRbGduB8jhSc8dX2s8rBg0iMcF6rzTRa5cFAf8s+/ePfMBgUBIEQmFG9nV7W520sNDixtSEOLo+Y7yltx7ubMxRIsXDxwUjAyI2Pe+4bPeiwwMt733DhqeJJmvrFisOY7gyY15MeXES0K+PelMSy336QH+6DinDREEUPSakoLdFmZ2nWacmfp38wkGgkJi2wfHYvH8STA4rS6+9I3VRgwWFkMK9ehqaPliBI2rl7Gqu19+u3j/G95zvMqnU7K8uxH8mFcxPNb13KHHzrdMyRHisQh6wOCoZWGdXuUVBHGdbtwOVUOjVa3MdEYIMTeNBa1JAzZqalMllqBWM2JxsXWIzBApr/Ob6hqdMl/P+j5YVyFY7ey1wrIarfvm+Ic7e/pDgw5q7tudznT6+zsrxWM8aZWIQdDgqJ1qikhRYrbF28iYh7pWWOyMjxkWHD33RkeUrmt91hz3x83vTMOG/lVIipQMnDGwxFsL9a0xpzgPd6xr4p4ERRk6UB6KxJgtwGgu4ni8Rb9gktW3boTdChSZrVtb5I9m7DOwImZuWG9QxVPCi4mzCxWWBK9g2eQGwVw3p/H3S9df5tjyPjSPK6haojapXrkokOQaEQlUS5DlMrEWc8IWIuQkQAeAXjijqVXW+PCz8t7i9OVWriz1cpePD15H2fCsfxzGkaRemZ9Ca9wXU7U4xTR28aFbAjXexo1p6UX9ancH0RiZUAobqaPirq71lZb4iyRnO0z2FfvVl1h83X3mZ7Waa8nivYr2vxuFaTftZ9FexYtLSAsYJwMiAhM1LVcYpfFY9MY/x5YjGmzgUbJonZOCjQ5g73evmWeNi1cwqbs8gsF2ezBEnh7vJq+M3iVkzX43GhazGhQJtqJijTfHpv/VsXoyrpmZjqSMryBDhrllRifUp4o1hTK+pGRtLyQUICLanYl26JvVqx4kh/MqVYt+X6cHDWvT/OcMyeRyresKGvWaDi9JXrCwxo0PL1Qw39oMKDElgzuOlM3piOehrQM0YY0Fxj6fK46nrLrOIWMR9QbvcV+4EG1G6G41p5Nazq0j7cX518b1W296rFqCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHi4q+ARh7cO+wZ8Ax725dJiT6BL3ty5JD34B3vbkoExsijH9wbsFm7r7laWYUF/Hn4f9yIxSMQ49UtjeZYHGUvYIljX5NM7ndX+UlLd+5j2b5ap6nJ2HG5nJWu2kvhfFJFYMJX1d78b702Jxhfx0eowNxfDsVOWSAyQLZtbWqtZ2q5H3V7yEtM7MxL0BsW1Or02cZs1UZIxYAYhoJIRQSQWBDEcqNzs0kWubQYEBOJRD2FaesLTaSC23+sNkBVI6Kl0+mXGBntinTV2BtfWYmFCn6XT8kRxpXFX95er4M8JFw2NgkpAbJ3+2+SBI+pp4xY/rr5V6vzLD1qe76FrX1LePfy38Cmrb3fWnkSJNlDQy1vsO5/EXWftbHxaJ4W8apXGLMLw/FYTAnJd3w/0EKQ2C0LlkeR4do8CM4V1lx71cK7WYa3O4qBkUjA/w4VbIyrb71+K5bav1YoEOhr6OL0p3zvWMQNTQKTSbtuZINjY0NKnisiaUqfP9fVp0KhNOmKjISAhYoxbzjFPFLLGr1lzmYIulIpFw8UMivfs8WA1s7AqHXv85lo9hxlxEQlUJ5zadtSsSqcu27vSDHohdTnRECHWFXzzrhuUCgmZmt+o5oDpclvQ9zqjjIYKYo4xI0fcOOp83hx9tbHeG0v583ZIkTOtYjw3geMRlg+OH9gTMBLIofk3dOo3h6zhWzSOGt+u/nMVibIyDQ0/BJQIS6C+DLiLCYWIlaa1NA3nczlEjYvFriq6RaOZmBlxEbIdXsC2dW9a2ZpavzpZ81LizQJt41umJ7+sYmJ3H63P6NzdPFiR15OyI5Oqkuqsa2UkKHINDkcPNCYqiXSoc7UzI7j6ZYmlIN8bh/rDmY6V3EzArr23tKMadRh6uN10wsEJxVyswrVPM1seHk6HP5p1qAzsr+JTLC1SRz+zC+MK5ih0aFrfjOMdxvCxTXleP3ByZawrZfSvI/vT43SNqkKHnOaS6jWe7ZQkrEowEmYtaWZSX39e91JTVd599X1GZKnHTbCHMnixFDCcI8CBN2Gk990jt0dunw2zMuXF9SNJBYcxcK2PNeP7Y7+LhlYkU+P5xQTJHgT7tXddWgatNNFiGctrpxbVbNVyXl2rnx0qaMfCbSSiJUbpYRJUoSgeWK6juPpprRqUYYSG2b2xcqhrq4uUS29YxvD58pVdAUTFZhjKm12BvgfMK8SOoF26eyUjRNwI0Bugtsp0n7mS72Mrn8JVYduaoVirgNL5nvZ3qJ2GFBrdhiq7MJJR30X5iat30HcXEKFeJfVoPlEiRIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1uHvYFve3Ly0WewJe9uHfYq+gQ97cu1xZ9AZ724FBuSGuNrki7pLfcKl9LjGX+a599SvcqBVqJyuPwFiEcGGTghh0I45GWPPbEe7DeejzVKwPuFd3VqOgsZ+o+GnILWq49qUvf/fcrX6LHO4FQPQgFBLH1ErHt8Z8c+S4ssVtWFGhS6YH6PPgnCucEiStzJ4hB/lzJYZCAvGLI3G93WSlvi0OdTp/CGGge6Hp+RRpzWvNj3xk5xNy9vFiOq0NV7A4NZN4KVhj8eN86kOQvikdOc25WeE3RM4iS6gQ1LmHme7AwNVtVxXMssGPJC16RMYxijya8jhq8eBHxd/H/7de+IESJnzbGWU6CjnlGZD34y6RdiF7ahxWDv2vVd0z7+OaF1e0pEhgFEwBwwDmTCHwJoz+HfucrOh63G3EiXrB7K90/bm1Y1DhMicu/vb5xh5hsZDycpz8J4jEGj4caFqHeBqXfw3XZ1SuFw2P0oyr7+rKXc03sJIHIxk7VZbDENNpZirU6fY3FxxW8HDgpEMPBRR52NXzxGx68V88e/+MwVOo0kPQZCTQuCpFMckB+SdVz2Z4eE4sVOdj2/kyrJqQ2tznY1Gr1Wobt893isVLen1WdZjNBvqOykiSSQIMWI89sTxokzHHjRq3xDv/83ltTVX88ff3q/pSV/dIhBGgrWuw1qlfT3+saFqk2L7xrG5kk7eoaXozQWwNA+gRYdKjiH/aeE81LiLSLp/CzAzvt15WY9y3NqviOTJAfT6tPmvxutL1irpJ1XIsKigRIkKDq28ZpmBDPRBnAjk7FZFtQp5bOhnrFcFs9XG6cYrkgu+NYOIvxvR1w2Q8294z+LmDFRqKTpBi2k8HYf80aPEnz92c2tOmidNj9VTyNfvzJew2Bec4Cy2wokaNFalOwL6kvAixm3FEJIewWnpesbbE5WiyPoqme2fuM18TvFcwqZ/iWSO9bn7hGhSvLS5+4MGFFiRYer1lpDgT0nVFDjAmOR3lt3DXqvvFtSv/v8f3iqZjWC2Ri6gMZzBAAL54dLRY8r6a2qtkasr2zRGYYkC8Fyq8tWrdlg7NuS16ws03SeFAvBXBzlAuXzfBruu4sk+YFYDK8XMilT21e0J5OrhD4VI7PEXDM4IuC7JGoS+jpFxV7Ld+/eYrBoxohRITtMLTp8fqeXZvsDtxfevhwmFWrk7FEzKZHsJYW+r5XzPexQYkeAhSsc1Zp+9nbWJTxod5HrBBc1trkjWZFNpcL7o/U2/c061Sx375uYYDG8hZgOclftlaoNoVYM2Y00KD3lrxFua318er68KoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdhiz6BMnty7lFn4CHvblzGKPYEve3DnsVfAGe9uVxyBHdNe0G+8tArZw4ZGZ3vrNC4ZkiTAvCgfBpIrIeICgi5BQRGkrQSQYosbpmZqaGR9NNJ1HnCqjQariMW51Gi5XPF94x6fb2lNMaToPVOyvpqwb/GN2zuPZ2uW1+4tcGA1PGM3zfcTdO9aSRIDIP0mY9AxS6jfAtkvengsQ2SBq7G/j4Y47NBZVxGeSK9txA185rlvQscZ/7Pwth0LdYsF/uj+DEaJJl0sPJ5aVhten0CaDiLAYmqKkLQ27GWOPZ48rjF4+4jgwWx48e0kWDHcIvviFuW+tQIjh37nDu7jRGSBrEl7SPImYfIuCCC9QLco3Rs4jY9oWL3zrX/r4DCoEgfy6Q4hKfH+aKHN00+/HrmLFrWDZikdVa6yt8rc3Ya4cC+feaNHz973ePHiHYu48BSN0E/4b6t/T734tsyq9vqlE5IwMG1On36oLYbkAoD8WUmT9nSBKCVkyFOEYBaHRp3Chs8ejIciIZFS/ftr6R5Eu/ZJPulcw+/hqg5C4KA9yfoeiT1Ue2Rk0zsdZ58JyJTcOLDj3tqztVK1Tp9FqFlcWNVqxaW3cRGMjbHdR1takcHUq24avu2oMsOaDd2zxrZu4OETwHjI6qyMmo7++PDgaht94UCaImgt+dD+HoSs9mcbvXOLQsX/+NLuAnlUZcFXqRDz7L6JAL+PCY3UFExYz989rbWH0KPEtqDeBGkOuIikmuorNBff4zjWc1hH9F8JrlP2G5Ps0fWfW9txa5yijqOKmfVtVr3Tk4Ik6jmRapNGOuC3M5mBzFuGSLCJicMFDlK41treZXVZaPW2DrDcoTlca6/zndTBcS2jBJq9TyhXLY2zpVvc1cwutbiMsa08Zsc5IMR7GgQLQnJdO4rE5emfNmBuNSz7NYsJPOWLbewYuLbs+hRoUJ9bc+YNfCvWJPVhexa1rBtutoUZyGDtwF+ATdlfNvWv8+M5+/6tsjdGYzJPU+CmH8ZgfyfY414kr2JNe8KRyr7MU76ePSCyxWKEzWit2mZFKqFneq/GdQ1xdxgryicocVDYU+LW1n01XVX8BpbmJlhPldDq6jp5DU6yRlcX0/S4xD5DlHKhCaYZ2xS6jONdK4/k8ZRyvX25GI6n0aMxbz9ZgvZ06dpSqI0lpuLaXY4nKLlEZc1TCnrlqSzM8tJfcX2faX4c5+miS2eFPdXKqEwsNKOU8Z9WDFxZiYqWtvWcZy+hbguN9Y+LW9dQk8c0XD6NGzr2xa1YL3MLgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHT4W6Afh7cOvQV0A9725dvg7kB+Hty1NBnQD3sbiCI+b6piUJ1I/Q9xsuzUxXc2rnDWUp3Lcr+FnHXH9944OZ29jJXaDhC+FMgEtmreRdyYbtcu4Nhcm1a1yp9S7es8p7T6IJ4lG8wEOiYcoR4q/d7U9MUgHNGhOT+KdKeb3sOHaNue2sT+G9VSVzd7fFYs0eDuAwyqWGpTlSkzEplQpUSdyJVCocH14W4mZcVvuK+u4P6yLMKbOPF3mPIeqNRCOZX6yc0doXplMTpVQGWLZ62OU9m3TZSmKrUOFNJZynhbUm4d48OSDa1o9/fE+cxLa3unxvGa7zqnxWsKF7WzAVbnXfl0iy1VDeHOfKNjziTSbV6xvbjhvSmtKKzC8h534uqyRHwyzqG2k5jwANy6C1CLk+SsPTbBs8Q5ms+niqWErYSni1iryQvFYWdVMFIL2VHo6Hl3umt0wyn4ssbInH0BcqzLh8Z1azF49LQESzN6tiPIEkeBASD5hbnr2KkFdPDim6ooKEJsfUaKtL2IGG5tZVpXMTlWLEqy4dVq7z9ZrGj4TLOjzwhshpINicYmmBHLt0+juERmjuMSNfy4tCdMDKxdxakcq6v5d5e9hfravXLg6xiDq974rWaBvePHjXzCjfFLbzj4ky2j4UTQKhgf9v4d4A6JYFaotD9j2HznmyVjXAD242ITdvRen5Yx12tlOylUq6V0vC3COKCg+KqLeNetU818ofay/rw02VeexuyerGb3bMuk5fhbksDlB+nEfqcO9QnKTWNGi01rMLcJOv5rQoy+oE8+i4vnNq2n1CnW1ckVba/gPn0ezIkkchx1K1lnSyqbl9kNpTmaeZc42FExQo2Mv2uryDtXPnsLq6zVuau/b68F6im0lq6Vy6Yjmfbyyv7q2O9jXiQpdeNq+nqtVtZKsNYEKF7T5jwsQozlCav/aNvFPWl//iT5xvdv4Xt7Xxm2SYxNHEdg+yX9M8JdYdMaGTncA3Z6N8W8BNVs45ttl1rV8YkicyVahAuJfmQYIPxDTSL1TC7gXi6rIrm1hh4o3sM1lK8hZQxBZMWC6tbKa0xHY6fmcpNVK0UFUyeiJMR0lZerXq5jlbSZI0q1o/ZxfNOYRnamEkmQlHzvPQQk4SiOYklTiW/WuemO/qaPrRy1c9n/3J6czEp6Vg+Pmj8rEp/Gzly0cD1ui97omqWaaevhy9bjln5sdHNXXTlmsWHq12tWXa2nJvuTa3dlnr/M57VstaruNESUSxUiu9o8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAB1SDOIH4e3Lq0McQPexuXQYM3gw97cvJQ5vBh725EhEFqtGk3i1Q06SBmuHe0Ugidz04+UtgKQ3/y123BHLboQC2FlbjI2FRIsNsKULxtXl8Sjd25II1yGLO7dBVzsZz1upO0dD/J8LYky8ivpsegvoatNqxvdb9ZqYhn9uNZqcm5HQP4GW+1LY3Dw8Y8pW+23M7dSHWLHu1t+Il47qIr06dagX02zQp2NhhtlYz3dJcx8yY34zZGxrEaJW2qXiItthtEsGLAiKNSPMP47Ht7jECH4mpv84lgRIrO2TXjO2TWo+q7kf1g6xW1Ie4FNfH+cZnjatalc/W9639exPK58AJ2ZjJO/6FQTkNkoMoVHBbXYSYQsmfLMmErpgV8Z63RsWjQsw8KxvMI0R9iziBh+BgpMsYyjIT6Py+u4Q1e8cZFIo37ItvnrG35PSVGkX1HVIajuQgoGsI0hxS/Y8v5ES0JOikt3PFBfo3PXbWXP9jOONrNLqMUT45GbmEBwpTrZpdXzRFHlGAw5M6OwVjovK3LzpOI8ur2kkJ/de42xW+Urh2Vio00lVDsNCgzTCwzQjw6cfswU0ZYvWZX2drrBbA4OIlnCj7iAdFAll4wijtA9muoerG19Y2Ofiv9d6c681n/tPzaErL7U3Ze1ps6YkEfyUggMoHlRaRos0UKZvLK60ZH5hUbLNKnu4M+3Gz61IaYwpyXtiyJiMALUEOUAEQJUU59K1ubpXytjubjfER414na38JgitpvqFC1cPoYx1xDuOk6aels/3zeLI470r2QvuGS14EXUtPXObTupm/xNyvKRoMY6HrJeVC2BoZWNVnG/UC8eB69WRdbrWL3+pId7Z3DpmM4za3n41StZISTQhlbnDbxXVrp7FYby+sWN4NLxo7VNK+ixo0rDCbNx72pazXWB8bzTdMSfeLWxqN7Yiy6zv63vU+9eW96E6VQBHbi9iRQvAQDdiviXhUYJjRbhEmckTO9VXZgfR7VfSGuu+0MuIMeLvsK6ipEt6KHEMkTwNIuRqgRCHo8ukRyhRnaVO9f62xPYT948YWSCwmWrqsBwo9vkTqgOYTZC2Nsnt9QKRGNyP9XPFIjS3sFH0lN1tGpCvaW+qO6atJRT764VqHs1tKpUMbM0sSMViyiS2rlTXruLPeJLCj6Vt4b3F4LhAgx9Ra6tfFZIdqn4i8awi1ZCZ1CoO2xqyYklRWJsQNW1fVYzxUvVouqJZMs7cstVG+Mzx2SbeZcesSNf4zGtXe61t7zw6TZv9amzaGxx8Yx841Fkb3CxYFodgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3qKOAH4e3Lx0ScAPe9uW84w3Aw97cuWRRuBjD25yZ6FFuVc4tcrssP2PhpgtGsbkr6w9QRrt7WHLPKsSynYSqszmWsiLCwMdFwaEWthtkzwxiesX6eWu7Kbm61uM1rl+app92Vh65uSpXzmblcu4keaSLik/k3VKJWHFYoJ1lJtmtu0eDCrulqyN6qQ105T2jZguO1MhbKhxypTZ/KdGsJmFocR/HmD2Zzmb64g03SO44tWNmFFjNEeBifULcbNdVp4KRfQ259AdxdQ7T/caLLZdz6nxFxv/UHUk2oD5823jQJc6u3X7bAi51b/MK33au5t0zjO7/29MZ+vbcpA4FLS41bGa/4h0of1QVGM0t6FH8uXoNN+5l5jcni3FLt9L7CorKZ35LT1phabUo8G8QlrN4HKHCBaHOPRRhUMZutY5lGkIlmXS+4JbTWjkJRLieTuXKqZan8zHbLFhRtUtWFuaUwiWRmJyWXI3FWoY2fNiFHr7VtmJtec0NvFVrU7ajDLA5FCURr4RKyzJIt4uStKEHID/dVg6rR9WrKhStZT9fwIMKsJ7a1I+q49d3gvrKZ7Avk9IrJjPr4upN1gKSGysLHFnp6WpBftt3zdV7AcIkeadxZtK5S4s9iQqXZbWm8XOoUe1setr4pmuaZl1eAvxbUpn++96xHMvfuTWqAiog6lJDEMqPalLBu4KHQJfLJAMC7PFczKzFNZ3FtZvmeHyc6GqdJFCG+CpBuk+P5CsrL1gZmRlVj5zf3rN62pXbXN2dPlK1UVrk4mg88TFL/FLUYsRs229RjyWmPqPf+lf5VTqS1KYxm+6OnjbAiws4fx3ynjt7w3F1FdWm1b5lrfd93v2WJSFLu+/m3xTEr56zM6i3JHrAcWxmj48WelXub6gT5wydvzXMlrRWKNBzaJGtaPl/T6rL/n5zutKeXPpfF96h61e+b4i4uhCzDtPrU3jZ9sZ3fWoKq0EZShmUtVgITJVZJXVZNauL6lHYMqYQHOzdLAF/DKhw7yXTdJOPLH2wRbiiIOOjKqmxeMNthLe/TQzGKaYlNPG7uVypTYXOWm+K3PYUaaLGhvsXiZzWW8SzWkGSK8op2GO+3LfFK4h0xjOLUgwpozveHlJVOxv4L+8sSC68VORE6pSbtsaPfO66rJqsCsPMk2nXz6Y9qfdc53FnZWw6ZrsDrt6ttrVvmz1je3iVvt5ePCVkzVWd5tvf1283d89Z2OlsvKRN63a8DdP4N7VpD1Snti9Za5l3No/Jt4xbEX6rT/MVCq2qh0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaZjjcB+Hty0XHm4D8MblimONwHvW3LHcSbgYehuVeaZMDRiJ4N1mfi26hha2WaXOZnMwiU01iRfvtNr8JTuJPNLpmjVyYopMpckA1yLOkU9euXd25dB97X/V1n+tXrvaTSq1xiLO5Xr2Di1fvdd5i0vJjzNtcT+1sfevjWPqPfNvTHj41BfYpW+2rUerqSeC9O166/pv518bv/mLXGd799//X+tyUkfx1fE3NnLVv31akD6jQfB3PWu7t+pouXCJe183rfzWthyru2fTEuLfWoM+Ny4vSl9b8LdvfETFoBIod5L69Lybg7xqvxTG7xPXiqgpSMDdcVwHKyPx6ZYI71TujnZiZkFemordSt/PyoqWZgKTutNPynKNJvt6uVoURgbG5yrjlXu3u5ZVLNnCphSZT0HIbTkH7Uqi1n+t87NM8vHtaWeeqtre0z832bd25rblOrrl7UOaxrqdebUR0YHISiVntTNaTZ55qjvZNL3yZzpnbbt6Ott0SGCCQ26rLQ5r/bdqjkbsftTj2McreOFb8bD3uv9Ll7HLnRay5zble+t4tzNpm13ZY3n4qzl37Lrfdj46xUiptLM87OW/JikNOgUZlGM4uQicfZBtwi8x4Jd0baO2TTYl9tUzaG3zwpzkP4UZvDpCVFhRpLCbSJbUz22F2vRK6paNfNtPmHRseAhHKCRFKCePBPWOKHPOOi7QjhjVi6TqtOlntiPlq510ue1RzVH0i5+kYrE5MjlpsXiUhjWl0uv6+nvazmZcy6/n9pUuU5td3b307ujU4hLItx60bSlz+VDQ/udJvLnvY165+eaiEUN0dve39OmbzySFTDN7DoLuZoWhdyfay2qNnh9KzhhDhNNgz/ZyJLKX+w6/2TXL5nvX1Xkzx9nGPXVoMONacthGAr1MXgY5DTss7Vzbi83hwFXakaNGxDpva+rFEIIchgP6U0YNEAOfHs1SkEkiOIx44+SBcwWaNRnQxkme5HWaSJg6LNY/HkOYxJARByKBUQgGgQE4UZlmOktZUkfTPcT1+3c8jLUxoEpocmDJS7HDLZ6tXdFdzJmmsokG4gyZlmjRgpIuPk07ROn1baoqRyoqtI5Fo8f6a5YFpmwiukn2xS8hAyvg0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAFLY03ge9DcqZxZvA95m5TOjjeB70NyorH28D2FbgUy5mEPy5px7U6cWJFa5gx6NckuYdsa/+NPY7Go1tiOM/RfDnZCHoY6jwoe5KVbaRtarSBTFr+78G5YdgLgLiAIAoYkUO/mr+hz8eSz3elX/dxoOOnvi7meZ9Ku7t4EceSxw27Xr+Z4//0f5456mUlazVPl3FVVbiPlIsge1y45ozRjzTPPrTPXPrP0UzN1W99REVG+zUlewerDzKaL3KrdOyWe/bRAFM8JPNBQyDCQnUiHYlVrvEPdfWNams78K0e6rVZvSvS5jTN466wNO4NvAiTzv5tYvH3Hn1ChYLo7EX8RF4rzj9u59Y8msvZeI7ef9/+1s/7czGzDRt14aEGVJLFf9vGdsyqvv/vdm//+Z6rGbSxSRIvZE79e/Fbm92e92Wzb2ImiyvGOrTKd77NPyO2vXzs7aX4xvbbv8aEI7uw33WzfrYsCLGLpiiCQlyMeLYvM0qFb56+qkd2bdzQN3v//7WibZziViuS4XrqiuOlkm/166zaaJqng11XFrbG3QSCNjfVDr/6+K4iaqna9eo/442//+viXuK5anm6GsUtf/8f3x9x89f/9VQhi9CjINuRtXzCSvM208VFTNd0klxwzFOVZr3E6XNdvcxR3Uf1zuikzVtYHKz6RS1LjoV902xsLICBDBOYvbqpkzbVW8MN6lx6TmegvWcm0zlmExKGQTDUfmpRNgHllZalZ6lLXv8V9Ww3q9toBhh4eMxTjhVS2XQ1FCxZLmPR6aPTuyl1vS51SynVimIICweMHSmN6GO5GMP6rzP5kyOLjCCYuJnOcpZVR1RA4qqsxDssUHnQ4iggZlKdnIRxd+IERR65nRitM456udzpHuRAg7nSaxtNpHR9WETgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABIKDN4GPK3Kb0GbwPWZuUWYc3gS0rcobwpvAlZW5PxMG6+NhBtiKtCA977V8Wc8Yviv18Z1bauXDQ+WSfkDLucJoI+La1d1pLnWfnGdZ9dzTkOwTGGSPEBFWRt/KxZTR7a/p7HZU/ZyNMVWcyoNILiBSX//Q6JVv/ZjGOVCDxg8g3R3bo5kqV7nQyWmW013UonJQcx1mKqc4wxzu6PZrotnKHx7ZaxwUOFaAYWppnZRFMl7tTvGFnWH29r9scfY69v8PjcHoeg8kMQpiBUC6ZK2PjvPsY5r1tlzCyqDyWORXsathr43fPm47TGsf81mfvjt2/bfPbcrvk1O158Lwtv0yD7Zju2s7TMbndp30z//+u7VsowsFOPiYvH+f9tpsnZ/3flbNYiiV/as1cZ3ZqbZ2MqKaP8dnbNdmyPNfNNtdCV4jBSSter2mIRhTZSHum3KjviXUKSi4fZ29lTRhwDtGQWjIB1hWBcA5JMIhsybrfe6loLU1OtyOICJRcpyEQn053tY4gOT//OhX66ZCKZRdTsLkIUqoKGk/970vf/sjXY06vVb9WMtJ2odyuWhrnM63ZhYwitmc0rsZnKRklQhSSI7u89cCiguQbE2MP+JT78MK4pCCiJ9TReb8iQ1jYl0Mcx//xVQ0eBAgmGoDwvAGBQaZP7J99MYzdVyfaflPl1FyHKShb66Js4WLFMKHIv0stGdJ56Mki1O4coyM7KciGc7Xr55S+qr//fdh43I2utSOW2dXabHuZomVTCuyTvQ5zGbWs9xnQ7US15SlFSFUTFRJSHE/dj02pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAPijLeBLStydfBW8C1ibksKON4DnE3JWEEbwHEJuUgAGVZJw+S/W3TLWiii1vqSUpySLxeSHaNxKgnxJjlSSqU9X1siiitFspTFMHjGUrf9SNmcSf//lFWX+5SzPUzqHTKhg8JG5f////0qhdEe2rdGz90Mkf0Z0Ryq7iJVYphZruQhaEZSuyXPbesjlOEMyEvFHZCod1Kgi2jMA0UR5j3cm3bve1vVf//7RuZcEEKYOQRiSjbfdd/Dmt+Wt4NnKs3NUq/8wEmuVv/22Mb3qxjKzTUMBFKoCJLWv9rev/9LLIBCDfX0SpvYylPlWZGYPciKQtj2IilKpEK6MczstiKq2MRTkIoLs9JiFemjm2uUlA2WNqRo2bU2rI5v/c1HMd4WKmiKMKv6f//dqLt///////+v+rVb/////1m1+/r/m36NWdUlIlmZzTIxSPmEKitIjGZZbJXVjrM8hER1KqhEO7EU4OOZFMKg2WapHbNy7f/2R4p2AinCk/s/f/Z+v7f/f1////9Nv7TU/////9fVGf/R2cu1GIae0vc7sjzHKaYz1RrsplNRldSlVqIdkZ7kDAiOdMCWyrAlzKSLYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABYQC3gCAAAClABvAEAAAAAADeAAAAAAAAG8AAAAAn///g1/////////////WArVnQ6wq6MQSBoOlm3Bqs7DUJKfBoqdqfnqw0S5H//yv/////////////zoSnnHSzvYoOytOCpVxE9OqAxLFgE1EsSPEf4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAAAAN4AAAAAAAAbwAAAAAAAA3gAAAAAAABvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==";

var ExerciseFinished5 = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwMjc0IDAwMDAwMjcxIDAwMDA0ODBCIDAwMDAyMjkzIDAwMDAwMDRFIDAwMDAwMDRFIDAwMDA2QUUyIDAwMDA3NEUxIDAwMDAwMDM0IDAwMDAwMDM0AENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDA3RUMgMDAwMDAwMDAwMDAyRDM4NCAwMDAwMDAwMCAwMDAyNzhBOCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAADxADeAAQAAI0AW8AAAAB314OQGPe3Liz9cQPwxuZco7/i79pNQRf////8v/////////UD9f6P9/1nyf+c1JUY1Ews6XLvIH9f9X///////////6nf+r/4nD5Q5qDHybK8BYfig0sekcyDxeVFuHOpnFhQ9Ps79X2U8dx2r0WQtRmcA4DnCsWS3n24sZ8HAr4cppu4DxrdoZDdnIhF8MDhDeoezrgth0PU+txkMQxUMCGPFIrFG/kgFsRivRCER1OrhbDIVjxrNMXAuERvL+S9Rn+P9jfq+NFNNRx7028b2fV2pkw8a1HhgcL9gVk3y/Y0+o3C8ejec51ucNQVV6vV9prPJ2s03PLG/tl48gofP4bm8V6Hx/m9/t+/Y2ePiIwMkfNtXvjVH99wImqU+oc/pW0CI/np94x99vv8QHMMwBcDM86fAQsQM4Qt33yup2nE6WMfCpjLKPOwYkcvidUbD4VBMCuW/8XhuN33Tj0Xj0dZGg/C1DDMBhJbxxG7s2bSA4agR/5XDbO5JRS/d+MWL7sQJT08xLN0mFDD6EJBMTqzgQAIGq4SFKvwLgbafYqflwsMB2URALDBgYHkAkCQo9g8So42HKd5XM32DylFkK87M3cODxZSjjZgsWGB5OMn8UFGNbP168wWLK/O3fgUHZ+vP381yq9f863+zSnXpTqdizp1tf2ddff51xzrt4z83+9qf04vv2zsedNIrz03nK9M/uv7n/tPvBfcLzcAq5iwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAIDX+8gy97cusO14BnDG5ciRk1tYyAA9EkZnaxkACVrsj+2Tr7QXAKIBIO9koCa468UikiMSmJyUH0h6mJwlDzTxOFSJmcBfDbJeYAAEAVFQcBrEIgJ1nOSKpI5byUEtRxEunKRIIBz3EOSZFqJWIeh7w90LJRCVt26RYXCtPpV0Y6mqoEc4M5Kyvjs8Uzz/ZSFtphot6rWdJmEXN+fj14jF0dDAyIRZZUlXaPT6xpT22cjQxvk+aCzK1tjQfisV6nfMiROdRxtx3r2I3t00lrxZsP3kqqeadqiI1PlYpI0rBLO5sblEhRKOF321XiWVTs+dxo8dqZ8PJPq+9Xw2ahv48fMS0fEjyn/34+77pD1Dj434FtazIphqRXM+w+/O8gpx05KZbZesAtmSMesJQOsJF5DAltpkI160FmO2/SmC9HubZwHUWHchuC90q4aMyAVx+VSQOxCTO7RrknWkRtabAGow+v1s1+Rw5FYvfuvpKHrmIoWx3PxzuVC0XUMtls7HK5dQkkojQfA/dPwnDJ83uW1ByW0bdWCqDcSzA7N4SefpVig/ZaWHBoaWLF/OIk6+rcNUlVxhEetu1urolHM7Tv3jocl9889eqYdPaTx2fKG1+w2yh5a6zfeiepVhm7EV+cvRhS/ud/fSszkpOcve98vb8md1ivuZMIcIWYmLIIHiM8izHDkBsgt///////9Q/6SURiMO4hMUsOUAMROiBIDYeu9TNAOWYRQexaZZ8wQSzaKbzwGw9L8tmAQTBBLxrXfQu+YIJgglkwEGWbR/iyPBiimOOYoJZtB9g8uYAhIMEEBBlx065O4DOHcfyRITDCIMgJRgEkmmqaII4Ab8pyvmuaBi1L6OINYXYiuiumOsdicP5QwzhU6p2Jtfh+N9lDkLHXexNy4fp8pRGHLcty3Lf+X9qQw5blxunp6fPVSNxuNy+nt56pI3G43T2z4gB8HwfeXB8ef1g///wQDFYOAg4Hw/g+f///+D/SI/f//////UP+pSUlI7heRphiEAoIaPw+6w6p0vy5ZiAF2HMUrAIpiigIcu287pqZoSwKCYYpiilo1L3QLTmGOYopiimKGAh0F36QSGSWZpZkimGCXHV3PK2FyDHFMUUDBo/we4C7GuP5Ci8hkGGYMliATzZdNcUcEOe875zdTMkFK+RwwyhMQvGgHQfUHYm/dM7C7Ei0x1jsTd+N9lDWFTqnXezt35flKH8a2ztnbO3fh+/KH8a+5cbjdPT28qSNw/G43T09vVJG43G6enz/VTMHwfB+D4Pg+H6wfD//+DgIHInBAEC4Pn4nB9+J3///lw/oD4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAC/aQSgZWoABnkgjQwQgAJOpBWbiqAAKhyCnTBNAAFTAcEhkQKhQUAAuJQMbAYDBgLAzCFwGAABoMYAYCAAAAHFkDCGUGVI0DAAzBYQASFogsCABCxggEQDgSAMHQDQ8IQh8IJBIMoF1IGHw0AQAw7wGBw8HKlIUsG3CLD6OHxYQMBg4BoREOAwuFhji65eGbHLNTxFiFBqAwMZkoDELdAxcvAMNiAAIXBj4QgAAwsgcWFgGGQCCwAEBCwEJQA1oYw28OnAsAh3AhAQWtCUhNwZaG2TRLE0kViiYk8TJ80OF4cQjoRsFnwyMJyKxbDVxmeOggAIbCbmRkTp9aBDR2l13NkyBCEwzIYmC0QAYGChxCY+R5OnjhLi5QKg4KBAibLLqlIsJEGjB5h3GqZYGWHyaEOIqYkwUSAsUSAjhTEema0VIInCd52iPx9a0EGQahrj6EejoAwMEQs8HIiiivDGkBFqL5UIkdQIcUCDG5kMsVhqCUiXIw/HsnBeCCR81NlseQZBFjJa1rPJHyeLi3lc2IEs6o+m37r61rPXyCAxSg3VggcErTmdErSTeVVIc9EeKE5Ho0mjLZJ0zIiyIpys1XqiISVHM5wSGcxaO7K5z2OpEEOdoU4das3s3mP3fqdlMqMrtV7+706VVq6q1HVLM5GpsWj8////399tP/+s795///0AAKBgCBgKAAMBgIBgJCeLjRWEIohVBWPGnyAxFEuCMzMG6KmhjMAoWQYDHOACSwbF0SIF84aE6w5QkbuzOQAMaCDAMQAEGCbiJAErwM6hBtjnCvmYZYEoGA5guQLgSaFpC6IhYcq93ZMdgncmhwBaOIJmw3RaAbPCxIBYIAUE7JuaPwMGBC08mAFAZFiIDjKBUDIoCTQB0cDHgAuaGbFnCxCu+u3lAXIVBZBOMaGbkHJ8T0K3DIpmMyREmTQZZiBf/9y+QMiY55Fzdk0yKGkcw0HUPgMuhcEkxAi6RVi6Q0ZkokF////+RQihoTiLkXIufFzi5yJht5XkXIObl8vm7JpsnICZHRwmA2CacjBCyBAQFBQN3DSHUQ0igzR0nSHFEnT5Klw3AAAAIAAAA+vxfn6ZMTCI48AuBiBCgFUWPm/GUt0PzNMl3HueGYN4Caf003TcLgiIIHMHuTv9Bky4aSUBOxGyUBOwCXGD/5cNJptgZYA0wvAAFYcY8EhhBgP/03Tf0JuXDAS8TMpiNiZm49D3//spm/3mYXgSwbAVwLwQBllRoHPJc3Dnj3//////0EGNP/8eaCDugmSh0zOjDkmRS+blwzTQQWaKQUYGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgDjFQnP2ACvU8q9ODMAGE2QUgMby3DKT0p0B1JuSwAAAB7XhY0K4lnOLW8DdvfHcYjDsZfBYZDkPC53QSXpjN7k7fv47zrZW7GVujpqaVcuVX1RRWiAFQxUEV059JLM7koopTfmp+rDtWcmam91bmGVuU02VRcbdFiTMFuPbmH3jMqty+q6kqht+YupqsdxXYbGntAV6BbMallNjjTXYjGZqtnXs93rXfs4b19rKrVrVamvwrZdw+rrVqmyprVa0qGlpbMujOFzfL2dNu9juvjZ/G/zXMt2KXla1KcsOZZWsb12rS4a79ezUq4L7eWg5+F/HH9Zd/Xf1azuSl9WcuLKrXc8efa1rL8ccsvx/LXdYZ173N7vf3W9SQKJrTJsx1ACmwxNic0IT6qlJEXAgMB8SuXqKlPrZbJG1FaLJGxsmdIcDbAOOWdW6bHS8XkUTheU5iXj9IvF51qRRLpYLx9NEyLpdRUZKSMjIiJ5MfJBSBB8QtwxoyxRMThFi8miitEyLxeRRR1F5Kvro1JJJJIoozJ7KRXXRRWjR5ksgqKaKknWYsqkkXkk2uipJLpGSKSS0WSSSSVRRpJJpG1aLfoospJJdFExNSaJKOK//8FdCfSK/F82TzbwmyX6z1nQDrmmECIeoqe/UsY0+d3Om5M0EnRtMNYT63ceJnBcakykziZyizQu+5c/EIhKdP5Pzjp34uz5S8ejisYZFHJdeuQDOUlN21TU2HasvsS3DduckGEntZM8QJvoATIedGHozXhuYepschp3TmYSzRNFmyhNDBTMwOa0yPx+XTcvszkcqYUuqLKU65rX4XNXM7deW3LmGeMrmbVLnnaxywr87vuVHcpJaTA75KbEDZ0t+ltzWOV7CvRb5L8Msrfe442rP2K8/y1vve81hdmLF+g+5UuZJywvDO5/dY2Ln95rm/7nWnLVP29zDnNW8e7/LLe8OZfvLLDLu8tW8b/d6zxiOFXu6HPdhFgMMAWQQA8nlvPv57qyqpIHhVAfNYNAm9mbeXP/Dm/3c3Zwq8qUks5k6D/mRPSNTeHstYW93879KianC2YqSUmpyaPnllFyMMzpsdLpSNSWIOal01KBLjPEcZjnihBZQc4qjJEyCMiDGhxMrFA+XjU0QTWgtTGqS7Lra5xFJkkmc+fqTSWylpXWi6Ri6lqLxPJU0VKqMVV1vaaM6k1JLRopItPop6kTaipWovIOg6bMg92qqZSKJix41SRbfajLm/+H27HuWQ9jipQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIWpBRozvDcNLyCmQLT24hOjFEDXMNyu48qZCMrbkAAAEAfjl3PBiRQAS0uZEq3N1u75lhctwRFXIRnMiQDi5p2VfQTEYEpql+1D1qzuUzM7KpDGZm1DkAPcSgLmiCJIgt529hOWqeNcjEAzEzM2bFHW+rrVa7Rdszj8MrRb4jK8kMz0GU8VnIKo2lyt/otkrluj1NLRbgJKg8h+K7hFnKilU7DUrmc6WiqavWe5Z9nst1ZZWtXq963her2Jybyx5389dt/MVpU9C4ddj0PU8FSuS0dqzTXaeV63YtVOVL/ccb+eVj8amOPOX6Pv1ecv4fO1KfL5UjpD1zLvOZ4Y5fvuvs4Z47uVKuePcM9fnvDe8MMd73v8t4713OtnvljmO93oM5jaw1upVKIDRAFgpL9EeXr+/9W9t9JBIyQYehIvm9FJR3vf/fe91vmEvoLVmhv/GWdAV2gPhqVymml1/KZp8701WG8FufeHEhQs0iRVEiEu2R7Ro88ZyXEXCaxDT5/saFQj6I5jIyBYY2dsc2y0sR28gWg5+YOb01Ni2Y28vaVtvH+Zs0reuPTe/XfmZovzdzixmHETW9UzNm99fFZr2jazq1s6jwt/OK537xN11W3ky/iXzrG6e2s2//+LQYsOFqmP/v/5zT/G8Y+f8Z9K5/xre/WP6b38bjfvuNqqKkVIAiA1+gmbmNupzdjGnpKjOIYSsMRi46kHSIYtXe2WUsnn72sLfbOd+EyegkMte6K15QOAFEExgggwhP7Sy3kTnYRKtRCR1a8all7lFO5Vc4vWqRilp34eaf+JzuL6Shsb/RB7piPt0gKep2spjqZrbcZuYyJ4px1+PpL94yK/JZqjvY8rS+isTmOFWtlTyvOYu7pt7tV+yaatVOZ41+43c8Z2y9DFbdypDrwWLHKbsvmJ2tbpt6nbX1q1reFi7O3atrKrUl9nLLVPvLdftNS8q1rFRz527387FjuHauW8bW6mG9/TyqtnKeZb3/N97/NZ1LOffw/f67vXOUPP/mEdiMCIlyAbIAyAIvDf9a3HP/v53uSObXkIxzRrjTo4VL9j+c/HmNvl/l7PCWW+W4CVgMTJhz+SyLU1y1Dd6Zr0qiBQfasufuzB6ruyQShkTntpw7yBx1m1HqMSZYkBPBIBMC1koBza50oJbGJHjh1Fi1S2t913Ls7fCMJwhTHti6niYddPPMLY2kcxVax9U901O17J52RNvprIZFdcy32W50u5eaNc+Lma+qvnm6dvNbDbVf/75/kOoBcO74ufGxIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB+KC0qMaw3Kpy0pkHytuXS4vSgxubcNgxikAnb25IAAaAH415fD9AhjIDSlEJTiINIUg7DbvHHaKzjI3Dctm7ShmKbmeuqy6UHSxyJRH8c6So3O5HIE+H+TDzu/Haf25GrWAZDYdR543febOCJDHY9cjPJdT25TO3LUtnJJS0kfuszpZmllUzR6070vlsih6DWtvzEmPCKIOMiS5KY0AJWuC6tNXlvc5itJX/oIpN17e6mO92samtXc7Ws888941O47w/eeHcP5lnv4IkFi/ZgKrrLHHv516PPv8y3r/z7vPlved/usOcwz5cy7nnrv9r0kUtt17lhl38f7j///7738e573V1/813+Y4ZbvXLeNZFxFiN970B1k+jQAEQBQqEKn02V0M3v/3jrlDLWHgg45cnTlUL/C/389bzyyxr6wwp9ztqdgh1gdWHCQ/RyWYxs739uujRKtrEHHJUqmPasCg1WblJOqHmjkbeSGGx4biEXDo6x8VCQ7jx5+80Y5Obaz53bG7Ku3q1HzqOpKI4t9Xx3cmC1ys02e49FMdByNx6blbYSKM/pKY5DyFnqftWsOcf3n0Mf59ved7vf/7/qtYBnz84jOuEpkxJP8nCggF7rjmLcOxjOSOC7tLKWuwzKE50vThTRQOGYU5NDAKmLNZaxJl0UdJg0uhqGpp92gxmd5abKQgxIuoTXapGay3C/MBAHqYvnzUyMjxomcSQItLxUBs2RAgQm1AuO6ZOlIrF4oHDxSIu5mN0QmEZgokVqKimLkC65PqPl0sF88eLIyofCB/COaUZsimixpMropl0pB8alGzpIumkkpBRiRcrMyKT2HUPNaB5md00VoombLZJ3Xp1UjyDrUpJbuuki6no3ZI1WQR6LNv93WnbUjupu1a9kH9dvatm1GGkj62KsDQCAQJk4pN3lzmG6eZyhmukoFSgJJBYQXk4lF3OzTTHa+VbKW/flWONPJaWAuRQyQ5FgB1WexLHHlHEt0socWl8xtrOsTyxoT17ncDJGkvF8d7Ejrl+zxHsGGq0JbVe1p06GVgVwXDDpzZZLPW2rk4VgSxH1rQZbUzmNCz7QIT7fh7j6r7brrGc1x8TzJ5Z3qM+d4ki1tndoVoOqwNfN/7b3nG7Yi7rNb/fxnxvjGcZrErvf39f/+2NYtfFd1xbWq6+t59ta/v74+vnWa1x8Y1978n6NAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhajFCDW9NyzRGaMCdNbhx+M0SM6m3K6cYo0G0tuP5qQPIz4sFk+jKpBYcL61O2W7ltXHHeq0Zo6dpYUATBRA+ZGByS6UJgfKmgzOGo1DtA0q9H4nAVmZay/U1AzqKqlpDVg4aI2T2ocoHUkiqgoEQTJYJdvC5I7EYlsOvtYmqbFmA0ch+RR6UPLBV+pKYfwuzUktP9ZlElUpIgFRsK4lbYcc9WKKdi1uhq35+1SDpE6oB/8rfL+7GOVPTWMal+1BTdLeGdzCxhvW+85jKFuYZ8tVu3lF6v7tQqjzr41LeOFarnnq5lljrHLPOrh2/rdjHlruesO4/vv7/LmVfUCdp97/8//eOWv1zPW9ct5f+Weev1r+/h3PWvw5vn/+vyx3dy/PuWdPh2ar+7OBoB3K0Ktlub/uWdDnt3JcMgC25p5JMHUB1GaPlrmss793GxIJnC5JKfO9BLjUJh4CxIYiUM0z/0tmF2eTRMHayRWOpuZHUlnzhuMESTBEFMzSNzNRoXRylAzJc0LxTGOF3HqXUzAOcIYTQKUjkislUj5RZjMwKJomg6CTuhRUcsYoDbWmYm592SsnputadJA1HfnS6USck+xs6LoILWYtpHVJ3ZaKSaloqVupR5FNTI1qUXzikur0da1Jsp7eq3ZqOqvu+roN6RyTqQAABAH81TM9doZMTNCmoibEa0r1vK/3D92reDyRBOcKqTC4VvRN2a96xKea7I/gqiwrV9X5RIpFMU5IIWOacYqyNshZe1iGJI/4CczfOKKBXPE6akEoGRsThVHSHWSMyaOmJOlQlCZIiVSZNzpOLKo5hKCtRJTIgYeqIwEWFsFlkTMzhVQPl4rFBQQFA5MFhJNkEnZFa0FIsmw+g86nUmgmYqRtZAiA+0kE9GRErILKJoVnWyLLPreydaaT6rqN2Sd1bJL2rqY8ktnUOe66LVa9bWrVpL2/2rutqrq1+t/RPrV4qSAAiAO9G8G0kl8ytre+fhynjlHAdIYgIdGIjhfgKfxwtfz9au1d/bppZLJy9alz4EIAZTsRgSUUrowineprEh7IGkEPBw2JxnTmHDeEh8QSHcYMUXJZs5LQRTkoJZStJoPJHIYfx6DYsZKVq0tmohAwdplrR7HS76YwmbImpc5vHHcc1c6ZaR97GJMYcfSkS1m655i98zFP3bWRt//6l7bhtl0/z9/9/cO42RM8///xPH/////1Kr8NjQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHq41Qo1qjcuDxigQPb25dOjVAjO6Nw4DGZ9BtvbqgAAAAZdyyUyd1W5Cwxyos6J2Fu37N/na2fMOQZbcZW8oUn/NCSp/5qnsTMe/KrA1mGKDClj9qhmKevP06q6gBksKXTjTjTGS4xcYAgZ22evPHTyRUIiQJRJHiiWSqXkgJDyIkyK6I/JsuGpQUbEUUcIsbkWHSZjpDEAIgIvhkxcIoQAESBky4OAjLFMnUSqWC2TQ5w1wsUAQxDmCgi+RFFEwRKzpmpxA3dxySusuoosVmWovJoybEHJIooKdReHetZqgXUUk1oMg7o03TSpspWs2WbNUi/bRVT2QXl8e10Hf2ptq6kqCNH6+vv9+rdlMvOn8Y8SSAAAAOiQygwjy7H/O/9aI5x2qz1hBZoP1DKgvJh7vX45vufZzOvKZuXTVWSRqhoI1KsyAKMyPkBtI4cRgKJ3MS6MxG91hvmWydVEmNKRPMEBOssZQkMZ1fmV1hyeKlPu7J45jmO8v6CNQfgCSDyQ4FU8YHLUes02WFIG/ClkvGtnxY2pZL6zCVMSnv4k+7Y+fnxdbpm2IZRI/1c4K9uLFtXdfF3nL7NdwN5jfeL2xX53X0v7Z+92zXPp9ITPjWca18fPvnNvvNL1kpi18Yxn2+vjP+t////716/fxnTd8GxQEAAAAfutTjpL/iMtVoPfC9BnQwRdrWf39WfjcZjT6sOIAwRExxh8n4wFoU/FaCHcK0RX5tQKKUV2HH8yduK5TcQWFVeYlNDQlAsUcqZazTeYMNUFJKC4ks3LpaHEXzExMiacZ4KJJExaRBY+onDpiPopm7mRDBtmKRREcAwiOUOIiRTBqTA2poOiIiufVSZReC14BU0NIkVmiJ2pFBJaVI0UGRjy1I3SpIoaRFxSjWUktZGjmMopLd1KUipbutaDooI9Bak2SWeRqQspbrfo0lLVLhBm+9vdd2ZSN079ba76//9JfQWcUuEgAACAB2KoHNK75vu3/Lvb0Odf12EQUZzDVM8OlZEw6GGzZy3Lnfr0Ugu0EYtU+D+O1L4AWelI+IRLgYVa9LJVBz6X3RJh+NRCO5d6nhLZbXm7MDNDhqdnUaqMm8eO6zh7EiQ36sTZuJpLEhH2siwkKG6MsU+zJHbMwIsN5FY0eywIceNXUS0POc/NniEQ6b9rxM6fXr84j09seEwxi3bzBws6pBh31961bebe2betPX1zu+8bpvGP8bvq2s118P3K/+Mb/+vvWNfWfnNsxNV9v////r/H///z//Tf/3Jlq0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAABoRt0iM5k3EBUanUH3JuXpW3RoxnbdNGtyfQjj24SAABAH9578L/JA4bMINbA3fCrPc985upzKZuQy4Biim4K8EYlkZ7ZnsOzEtxjMg1zLDUfryqxSp2KjBsRQY5c1SS6SzSq4IBvV7hMk1TWWEjQ3MDVzEmxhmyiiNEuGKJkZLIkVCHmZVNS+RcnyIiFiIE6MmREG9wVksDIGZUYuEeXiuXCgH4iJGhoT5QMkVIm5gZpE4TBOkHOEADLBCGZfRN2Uiboa1EFWfGMEoFQvs5XQpIJmyK2ZAzdM4bGo55szt1bNs3/9t6ZgGv///8noBAAAAFCrhUPKHqY1nTn5fjfsypiKvAqAmPOB978XDKwZyWeSmXSa9jfnr8SgH3foXilLWLrm2oijekEYlnrEEghwljwapleX0YACOjae4hwnFZYHANMrkPKpDhrGRHERHQWjMdYhYtFokzMa5BTQgo+hPxbOGgqJNhvwjomxnhrha6DfQGADiBqlQZI2MjYvIFIh4uUA+BwoIIskXyuaH2WZmbF02FkkXdIuGBmyBoVUmWs1La0HL5igiQ8PVYzICo2PLPHzdFmY0RRPIp5ot0UTVE3MTFaSlvmTrqTZkjYwRdAvDw23W3shOKZkUWRe/vr2rapmdFCi2pSes3Nn1SmIAAAAH4b1Eko18uMO6FUmskN3Mcb3f7U7lKpbSLlHKQ/NH5oMovco5ypf02/YhOUlfPnJNVltK3zlKomiaUE1K0zF7sPJGmeA5kqwsU0my1cLZQi9L5x25dIEfHnilHLH3cB6XKU+0BIdbDKW+TXbnIWtyKKK2uryKRtEEWH2uJ/4zkNvg/sDKMgoEAIeCFY55sMqAxonAwIwtwWxPzA0CP+6EEu060477XCQFGl6JxqipJXUq2sdfrVDDUrehggVA2nQmTRu7D8xQzVLnbwp86eB35v4YyNpm9Y95vn4d1Sc/W9f//////////+Med5T///60AAAEADsfKAyl8mU/GOesOX4rKnCYOIQEIiUcqCxcVx3Dj0OSml7NXMMYNo5HOXn9yeaWvtTxaJr0MaDoSL4QAadlkEu3AWJIAdwXZValurkLioZAj6bHbm2HGsSxbn5PPFe833KOXVTaYF5DE+iCdMhPGU+irPBWS2l3EtNEUo4xqByLtzeRqZr48d5eXUGOmDw3X0xSmZNYz3ud40rKfatiUmfP7Qqb9c5p9am3v4+cy5zm+c5/vrO94zn5+7fGPi73Tn1I6YkezwM5nRNpPR48AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB49uUKNZ43CyaooUGy9eIzG5OgzvjcLRLChQvWG4hAAAAH5b+CU5BgIv8KqVASlQ/8nw7qXYYYYS2AKtRYUEMz7Y7kbjt6VT9NVgltpfLoRbvU2MNySkrQKPCOChWez7SXep68chuOP0E8xSB4pUrwiXP+m+CRiXTeaKyyLymuzbVmn1Mt+7l2tDEQ4wyEM+aSjKs6H4aS71Zl7bJOAQGMbYlKsovFI08L+plDQDBh4OiHcwMAEvW1c67QXa8xubtS2knGlsiStMgDBULv5VuXM8tbx1qZeyzfEIiKDlSXrD11UlXZtWK391uibZotSf+kc5w9fr/7//2tDf9z/v////f5/9////v4/Y///+zD+gADAAfmNoJm98Qxz///8o7J6amcVDkYJZr/lxnyZhf5M91+HNXO3b1vtSnxuRu+3RuZ6xGM/euaktstoCNVmjRWRzZHj4lzjbwo+2RG3f3Y27K/R5pcNSFp+JOyRHyOakm2rSMJoUyyxsNokBqboLmhJPRNy4zw3G0aNu99e2dafsqHxa4+Iuq13mvzFzhXFZWl13WFmIRDouTCrip561jEVIXWLYez196lo6H6v7k/Ja/1vLFVIKVNeOSQLTHdqDjQc/Wy/kbvz7ZGvrufpqjIjDgc6caFARj8veZrEbcRkERZ6mZIWoMkYrL4Gh2077kz6/zCQUYDiENNxLjDgYv/CI4ySZcgRg5qo2rFnA8OQuSJo2IPMlHoaB0ZmYs++UgRTb2XsLi0CAgFvxNUcsRl5G15AUDsBGA5KZlgwYFIk1FmTPhGDA5OjgDDgVYkm71NBNpMIYDZimHG+UKYBBBbltr89GcpuzEMIpalESwVVIRIYqNqwkLhFu7OWsKeG33mlA2+emNzIoIhJPSXOpk2NniA6P5Y3KepMMRUsfyJRe20RRlZGOuf3/5rdxlG/w5/77nz+45/z963zUxb6eTdDnsliX9l2PxV2ooAAIAbWPYN8zysGZf/f1/d0spo5eOBS/Btzydc1Ds5jU/mfKH85danOXN2Yenf9/3wMJBBSNoT/W5mLVGEjw2YsyafmKuGc2VUw/h9rmsZdTS6vYpZqx2htxWpjVyqfnHJ2VwTVylL/LMfzHDGvyY1J516waUM3NYU2t5c1jlvdW7+NqMRnXOc7/P1r/7hhzsOSnLP6DtfDOvr8t9+4woQc6wnSt9UB0seliLH26KuvT/twWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjCbk6DeeNwqC3KJCMybiN5tzwM623C062oUHzluP1f1khODCsaADOQwwsQA4umcBR4OAIrP2brdpa+kOTLfTZdEwljrBT2LtpRvpFXkguMUroI4wO15+KJ5Iery2WTUhUrC5xd5T5/ClMpf1i8tcJ94bCwBg1Nza3BMw8boLajs+ZRAosAI1NO3KatADghA9G8MPwhBaell2jXlDFeQGCwQqiYJDaUEFlQBCACt2tzKOCz0E6HEWAF/KtQ3JLMphowGFQEe/CAsLx4AJBP9Ur4WaW7yUXO0mbuLiNkg4eA8gl+cpvVNW68ZflsYYRlJUeAhCQ0cs+1p7AVBT62sMbOF6agZSM89U/1Tpmytt7985vuWvwhvn95//rXOZ/++7t//67fpgLaFxdGDGkUq0UC9VrO5OMhAACAHa05Jn9yDhnruONWvPyGGYdftDIn5IjVyP7A9TLDV/+5c1u79fk9ufxomYrbMqAICl0P8oY1k2MOPys4GJoY0jUBDHzqJx0lkDUcKSKZDVGZNsRMuplMtFomSsbJE4RhuSw7h6IeWWRZGdROlIpBYiA+lE259bOmut61JpkyVzNBVJG6vdOgOoluk6LrRfezKRrRU/9Tf/19tD1mLdnfT6Pu6PHfn+ftJelTU2swtCdLzL1KgCyn3a1ftN2Z3L4ZaQnPOFCIJ0EQldDuQDDMlhqJSxfFDNuOuhuGpVGXTi67ICrGSCpalUIHgyZQsMrXMO5OpyDAIyiNIeFMofWBl2MhaerOZATum1uCGgP3JFUUlkgGHulBUaX5E68GPwz2XyFuReGDDJCZ04lEBJPkUFyJusNCQ9D5mAQkCWvTcS4Zm2JQ4wwMMOJjGkUxWsMsAjBAwwIEUsZxKHAkEvmJK/9J12H3d4lETQDBwbli1y3UvStpDiu+juYMGGNDAKGGwoThYyduXSOYh1KtfEUu4ValSZVideCWXsXiDCpctbKcr5YZ8/9e/mHP///////+//71zv3jqVppcp1V1CP/9MIAAQApPUdCpfmCULU3/N4TMkturPtZC4ov2o+yOSak/4cv537sc7lP5TdjLGM1IObItkL1ESLSX9fuWzNFRIMY7xsTvI1DuCZ8HWsbVupi5H2aClr02pqZ7Gc5bVt15ZK5JYqxuVV41Aiaz2xGvjnh9bDsDw4EiqtkUezr65Yzw125d1u3RNpfz5zndd3nh/M7//MSDn7wzoNflhl/e93/P7d84q9Nrm323cXvS76xj97/eigAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI6nBQoznbdLPq+jQ/D26i2eE+DO9NwtaraNCM4boEAAAAfuYhGUgT/FnwtAkaN4RRdiMpkRBjDhwY7TqdeJljuvwqoI+zd5bx31qv+3B5FptIeeOK7h6UwTGH4p6NgCPjaSyICRyUzsHFWru1QymLP5il8BTl7PlIJXJc5I7EeKgkn3flsMSzrxBxW8sNRiH6zIoYfye95rctehV8KGh9K6HU50QILcZUj6xZLxnxlZIsyPvrHI3FmltIFQgwU+OcSQEOqBl41xwzYeF3ocjcukE3qIe76bhjwe/kljcEz1jPte/PUOYCBDWA9taOHysLv7jbYaWiemfmrEjq00z79UKqcuzkk+9krrTsXiFLII3cxnp/euWae5ep6mOWGGeuW6mPcML28O63bCADtD4ALhdpRP2x7yZwdbqQAAAAHpndYcCPHvSK1kAQFvDfM60bk+GMGCIRrUn3GN5bo9V9V7lntblHlny/qxt148o8MVSRch/JqxI5qWqC8y95Ep3+R86mpJekFd3mgSRJcX1eFmMy4fr8DTkipZ1pfujIqERrv75fwWs9B2AEapjR8R8ah2iX3ebFOwOMbGqf41j/WFyrot0wqfulLZ/1fdImpBAchFQuH599TQigcaAjgibIHijQeJnHtD+NdjrXZfR+O+yiq4gNcM9ssLHIu/M0+7XiJ9d5zLNJB8FsAfOQMrYKd+0ExNKoTG35gCjlEip062ExuGXVgV9tqVEwC4MFUokYDAMRBpiUI4kuXJ2EPdSPcGJsHSqOdgmhilM9YJTtJflyZdT13/NMTd93WaRfNTt+YlcyW2zmrSoGL5M0vSBlzulZpuEBzdpLVHdPQ41tarMjBh3NiTyxhmzUiWkYwW10kOiMSRCoBmItzCt7+zFmw/2yEANn2hQ7V3d5lTXa8KpY4Yc8cU+uqGWklDeIw7kzCjtPBZpeXabOoxGm24LZ9vVYn86WtXs1rl/HHsCb/LW8cPw7jrm/w/WXf3z/3/e5XtZZdyxs8/v6rZQFvoTdnmyrT1KAAAAA5v2GiaXeAOlHbv/rczljWfdn0LH/W1kfbFre+97RapNWrGc9T0lmbrvRQsACjLzNZo7+sbUffDOzdxqXMsKR4r9feq36l1bDtJlHtfc3OUlLuf1Zoq1LKK3KKYq08ww6pWy5urf44ic5FpxqSOUuWqbL62W9czq/1f1H9/W+Zfjrv5SVflTKSf/N/ru9WvrWdhoKBQefDRoBFkQVdMKTmk3JiqFuaO1rHw0+Bq3OQpbpUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACJ5ozqNb03DGK3oEIzluIwmHOA1rTcL/rOgQbE24IAAAAG9Y4zdoGDjLvBqIMgD0hXnfxsbLDETIy8nFgN933pnYf9WxDmnuIjQFlIQCrBOLBTuw25LZGJPCjQX9cBTz0RmikzsiwDyKu0YqGiQEGEgCWwhRrNDrJbue+pYDzGwGXyW07tyjbjTTQOmjxd+c4lTUinZm1zpS1kUKf7LKxDt1aFNJYCLjyQV0JJyckAAYvLqtydgsFKlNjy2EsoYNBIV48NS/I5QCbQABKNkDEyYQmPSVw6XKmqzWscOX4CEYkxZqA5ivT2beFavLIcwsg4OftEr+QRsmrU2pKzelm2Z77ruWpUy9qFyUNS63aWQxzL//+7/+Q////////53vKJUOUce/GDTWmhrCOtNkR9ZVkAAAAbuMhLAGedRIJQKdhe9vfM33u2FEqQZpNU1jUMO/G7ueWPblPT3t187lWA45cvzS9X4ggqsCwbB7VrT1RaPrC2KevnN/G7c+rbP8w3a1QPJS6euQai963vKT4U22+673Zu1LYxOy3sdfaWp30MqgCQU+s5JARUbOUR4aCXY65vXOfvW895OClZIMb3/zf4d3u68SwNi7EqLLDHP6DLfO93/8w+vz8crOhlNGs6aG0MEa3Xkgm+ceMVPNJD3NdMxYymOV+W6kAvoQmiUkfWcZsmdE428xdvgUQYksb8GhQ8tSu/6v0ugoAM2zMuVAy9CS4MDxJuyCdWN4IkEAX8i61k40cGCRAEiRYBXaMrKMmiwvBz0wkFERTdSuWLYbq7iVJgSEVdiVvbZl7xRZ/DK1mHQ/IKZyZcz4x6ltZEnY5c0h+15v4JUEEQlLteie6uoiaWiitOtuBlTXaJh8hng5IluaKPJWZAr0RPIGuRuIM7JZwMJtgIhBwXjYqR46fOxqpKpm/jdnlMScquGjqZ4a/lWMvzD0aMUfPQgVhiSGA1WjNmPpy13Aax9jn81JWtMVfGGnOzgx3H1////x13Xw4FgrqMNGAci5q1B4LCto4695Q0SVVews51bWdTIAAAA89maIAW+ISCGLNw7+OdSw78RC5QpFKZrsWgab+gv1f7I8+5Rqkp70My+mjcaU5hoSANNTyeB7Y9O7/Sm1NbuGBSKRNmpWEsJo4ko/RHdYY1E6eNUTMvHkS+aEsai9c0IwkziZgcJMlnC1BsZiyydM1l04OgCkwRoE4EGLii5vuo/Mz0gAs0tMtkGq6KI5gmR9jputDUX0UrqquyzGwOoeoqplxxkqFHjFB9J6PIKSwSVxU4y9CWuIX1MuFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgAYc6jWtNwwsp59C8YXiEd0zqNa03C9SgoENzheKAAAABrWW8ZSW6BQ00X8zak5g5ptzcAv8/pgj4dUeyu+cplyfBfMsFDdqiglHmvS9wMJiEI4KYNP0w+Gn7gGhdcRBWn3IUwozAcZHhi0wNqCFnO9itGMyBoplAbNMKeXzdHEvpCCC6tqvKMs6A2AZm1L3U0KAJdfnIHMeKduXQKVjpeCrIcNvJ6jwy5hFH1T3SpcUGtI1QiTkmOX6tJBrLRCKGuymRhLhozgsYgirN73hl+GtzGyqIMOTlFmtj23nVwn4vWlxUEHENupLioMIh2Gs1gM3Ld/H+7z+ZciVuxJJFugnGLd////5/Pl9DcPOlLjhIQFnoFT/gdt+n+y2osAAAAbWVL+AOn/rY344+sRq2q9ygbV53JBox07WXZfzk9M4R3Dcs3jOYxzCtSO9Y+UpEQl7UqlepgxGVxO1Sy5btBQV56/KLnI6gKahX7rKrlS3aCxbsxPkpz9Z337MXmIYp88K07K5fFbchpp2ip0obWGW5ps8rD+s0eBTuL55f2pnhuzjX7zByscccf1+t812UOSxfHl+9/N8xs1njICUAz5TvCqhtQbSsYBC6VvPC6Drwlv1Gz0K9RICm1h4Jlkj2AAAAB+fM61chCqWGOUGrkHSFvxE5t+IFjU2YNca4UrDCusoh5CQVHRtICjKIDOb/YlRQSyxQ9h1lbMjwo4bgtYiro9afYMjlhSNARVatRXjhW1lQVEVDxou50ci83NYzMPNGMMKc6UyuxfoHrNOGZpTwHD8MP3Y+9SmAC2X1vBhdsBi4CZ+SfyXtqkuR9ZKJTMRCtj9gzo8aC17daD4LMGFKQTBgbkLkjyGDIYrZ819r8ubpF3gLNL6lqn5vHm60qlLwgUgAx7nSYZCLO7z41IYRFMssccu1IOfN+m4SLskijQP/8f/ue9bqc1+v///9d538Of/f5l3P+6/9fv/+/+5QA3jBRH0dFYAAAApsZI2ODED2/OplDz7KdQ5fsfD7O4BekCGnCmwZrbfSuvnjjlTQj853OcmLkATFWSSp3ZOuYVdgG3FKCN6zwp7udirVx3jERE2V5/l3uT+WLUNXq8ss83ZbTK1Xlmn7tajFLRTeMVjjnfN2a6RUIpuXZmXKoRGrUas89f9Z6x7lrHP9xmU7xy3zf6/n5TUpREx7M8etQvjy4o8Ez/ziW3lVpTc0GRM9hZAEoSka1SC60PcxYxzy4s43SAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHyHJQI1nDcNLt6hQjOG4lZd08DOtNytopqFD8vXhgAAAAfXtVa2JKFrA42CZJpwsDUmdLGZVGmNGXO48iqReKpLMOAFbjw4+Ungm/JHTf2MqWpyMElcSlUF7ZlCMZQvlFQkXZ+Ij2HRV14w3ONX8E1JTTTte9cyrwwDSOZTU9XK3HAs2lxsUeL8VLNmTrBROeiLCqEG9eKOw2kHG9Z5wxKHqOgHWiYE3K6sblb7SYLPABmmlqjlVyaWVWpRSxeUR+t3/2vkWhG6Sc1ZtxiV1r3MZlYEHmkVE/0W7rcfiknjVXLn4TcqxkcRgKkz+o/9S7a3lzDu8r1fDeWerFPUq5Xs+/lzPDeG95c1/f1zCvq9qHvwjs/+uAgAgAc1KS0lArC9bVW1lJlxXsZDFKbIqBCCBzonT1K2U9vOatV6+MquY3Hqij83dL2huoAGE1ndxqY2LVA9k7Xq2pndWtEi9kL5+Evxyb/X17OVN/K+5dqvSyW7LK03frT1+nyuL83PzOa5aX6edmoYUfD/Yz76SLXO1OV8rtvWX9lEgt6w1hT3LOt93p9k1e1Kk5vmH3Ltalv77hzK9bsV8t4azuVbVm3rn8t4V7mOe8tXa1m3Y3vndZ6z7zese2OtGNBxwSe4oOHk7ALaLN02OX+qTJuC/CQFKIXJMj875EZ1fIBE/0Iy1ilKFhYOmiUFAAEgWHKgEI0ukB1wJNBBwwIFRRbgGBrmcwAAEnVBwsKWLHYAR8fVoIJCphogIodByUEFQgeYVQhJf52VL0OUZTDpSZADADHXOUAZytdNBzXVMPFSTfSSsvaQzkv+Y4ArU7FhicGTsOuXNzxaGKuW7AQRYGJLUcWyLtdi9KZqGMk1aAMxPa77JyIPT2IU/D7zJrAtOFTZojo8Dks1OZw9SXrVqrZ+ywAMK1L34WputhYqym/KgoDDIlFcaQpzS3dx2jgmTZd7TWqkpk+D6WpDllSRDO1j2pewzzqZwNu3hbsa/G/lhnunw5nv8sO4cr5YV/qXMPz7hvPDKxXvkcNI5CzLv/ntIwid6q04lkAAAAfV74vau1wPP6xu/hNzsMpqUlNGqdhCwAOpgRy4tIsaPGnsYRKOPRILU1TXpuBJRKI+7Efa8FahU5a4MOCwrw/1BLHkpZ5hWAJyogOFLYeITH3LH3F8eWdwrHlpGTG4EVzkzDmlXaqILPUpnFt759AIWc0S4jkTFo2o0alnfvbDxvjYpXEPePne5S7CXj4bodIsmJ8AsFXmhaeLlDbJwZFaVGwYHvhJLFF9lurFCiX9WYprAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACK1jzgN603KvKfoUNxheIy3RMg1rbcLyredQ/OG4/B+oxeegYAFCwCREhmElj8NFZIptJaVYymS0ypDQcTyTmL/F41omjLDBNW4ZBmIDjQUGBQwCqZyi6yRSEp6GslQC2Zv1GmJMquohBAo24cwBkOZCmlERuKmEComtwjZe02ImIMqftyFxQ6wmLMKNk2Xs7sKdmIQ02Qy55WGlmHDflvZWy2gaKZcE7U2ykijuwYGcPC6ddQsFhcPUdLbctwTZKYXsOEkRq7dnIlXZGNNXFIH4YlKzcTu2Pr4Ws8aa9qWo3BAuveq3LWVXda1L8ZpEI0AWk0spRHDOs4FHDEDY1v/ercmopc9chx3GHdys7s/lzW8snMy3Z2K5NCHB0kiGWLYEcNw7SdVW62vNKf/8/ny7/9tAAAABSbLdqzoOICKVrv/nQX5cwHOMx61LkOJkCvSHoXEJXORegsZ44yV4b1WkygmQXKWKui9NOLGSBnNZWIerPtAFqvDsdisZpYzbEA5flhKrVaXv1Ws1ca+dbL67r50sphFSV58vzX2qXDJ7rpdqkxUNp7mOdubdFv39emCoOw1v9frLmu5/ZrYfrmX/vfP5jKUYrdjMyo8HkrekYwTA20pXfPW7u4o/319//T+rWVign4CJFiSQjuhZ8agmnxDdmWvZIofhxLYqk1ws0LoBYAYMKF7hpn6yQKJJhzVmyzUDIyQHLHPj6AMKiiYG/lDBQyCYa0muhNNssSVOCJNkeQCKW06sJb6PLXAB4giQXB0zJJuGEdoGXSCwYrBofitDZnkdjCE1nNaPxaaXVE4IpHxEnWxKBwDMaCGYmawpYBHVasRB8PUTRoUvAvk65obBBz0GCqgsJRGu6UHxYUGhY2a8DEsZLBo+fGJ0t6xqpY33CpaQ5mSg1PrX/fs7pfnpa2EwESCG91pS7xMJ58mhkAgSFOLnrvf3cooObCi7R8zkDJr/733+5a3tSev5/8/9b5vet447x/u+fvHf/j+8tfq8L81+juUwAAAAPvM14HzBIER9bT0wjUllsMMToLjxrRXSFPTZgW8yC9EYzelkzPWaS0/kdeflBDscnX0hiDUKul7hZmJ0zIo3P1YrLWs5X6a1jDMpuRIQUanS1c9anGN27VnmcM2t/tETLGvH8oNkFWtIcYtKajwKshkxNllp5Fx0mV2W126gJkHLJftjlJ+f97/91ruFJGZ3nef/f/l6tcTvLqSnLLPn9md459///94Y6rXu6+xZ/zLH21Lq/Tf/9qQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjkdMuDW9twrOs51D80bh6liTKN703TbC3mEP5luNV60qr3AqSEhhoKQjaGJav1GaaQUsuibvMrBBHNl5kk1zGJiZiykYkPBywxAKBScbtP7LyECbPWjLmkQaBQoaK30jUSZ4q2nUzCgQZgomCEhFdk0VMu8FwlIEDFqY6+ACHHMG6VkNsDoIIl6HelZick2pRyqzK4lAawICUA4W405+23TMpph2UEwOT4enHeMXJVJG/BBjQWzpCoDBz3ywv1OIyCxAIwEyaLbrKkRHEgmmmVRJGAYEDsRHkCGJk6wtKWNfuZX8MKHnbnJU5IQ+PLfy1vDuu0kCUrokAWa2ANPhwhARYqpsJsAiLiwyuapnl/OVnGl8woqlHlXgVTjv/jrmv5vBGjnf5/P/f//f/fP5v//X//Mu9///O9pgAAAAev3a98NzwObX9u6j/yCUSmA6d0gYASQomkyTqWX+hyXxOh7qloYH3AEqqTs/T2aWjRJRvYtFJO4zoxOtDmL1KDQzMUhMrWUkCLgBFyfTabMmFwiDHTRAcotkNWQQT3MiKkAQGMJkumBmUDUqmpeFfLoWNE8WAiEHcgpAbg6RCQHTQ+pUCz47UEa6abucUo3PGv/WtRmPoCx0qJGZcqcwSUg318zZQD//0EAAAADu8fxvBcNGhQrLRoLOHAlXRnOxqxepXEZG9yyc01V3FUyMfDQMKhgFFWOM6l1M3Jq8Yk0sL9PErHM15qAGSyN+5Ga+QA0cM9BjOI9mCI8zASFz7QqNB2Wp9vYPllV7VZHCeI5OaCIZmrvH+ekzq5XGUri94KgHlnYKWSW4eGNKdmVKJkG9/CTKugJSQ28EPSiCVAYcAE5UUYHYQsAryyu/ipAueIRbH2OGhREQiSQ/nhr9a1vHDJMokD1u8/L/32zLbUSBhE1w51aZWUmD18ZWXVanMNJ1/P/7sue6NKqLivUNFD9///////S//9235FGSIAAAAHraeetoc5VALM2IsKfwk0qZAmLDMOPwjGSBIw2CxMdhAiWqnQxuUR9sjYa1BZlLaPG6kaisHTjXVmNOdkCgVAKGDIWFYcCWkNMafAzOlHIaDCKyVvn2kUQdNYGH4ZBci7py5c6+kZDI3tsMJcWlXZLI9TwwldMyR/0abq/oXNTCnMolNeNwwHXS8HQwhz2VM0i9eHWJomhXIGIvywwVLdub3zuOVBnUqZVqWTLPkV7PWOv/eU9ZiIoMAl4KpWjxWpvkFfav58/P9c3fuPXd/fLlHLM/VWzpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHv2JMozvbdMbLeaQ/OW4isYcsDe9twv0s5tC84bggAAAAbx3XopWVH1ynReAKTyma7NY5TuXJXJoBfRoAXAQQAigkY2WHEQBIAp1rWgJw5bK5tqdA877FyVdfVkTwMYJgSStKUBNeBhAYGWgZmytDLYCEGj5ECXmvCIMNIIGuwvHkRsuPBr0mTIrQZ+kmd3oCCxq4s9C6WEEIPGbW5pDVrj/uCYcCp/g2nQCOqvImBaG+zp0XpW88RgpOvyUmDiZQMz1inmW9FhYykHWkVAoFERMMPRL8dd7ljzPXZRDYYRSPWfP1/4W5/7SdhmwjDlshASgH/LIkEJdm3bf/r/xncq5YApd9DOyi////9//9oH+H/8u/JEIAAAD29IWM+EdwZVr5vnqeqv5DUHuU/C2CRUAVG18mUr9MBnTTa7gxGitT9pg1K6Ubwic+mnCWYvGlMvhII5AkHV5qzPozGFwaz0SHlUtleExfmodjBmiOZKZdbt08SEAb92oZileGoRQ0dyXzcmn2n0ywOEhuyrPNtqRjDNI8mfDsbIEF6ZV6ucbHCgGU7ENO2p+bpe38Pu/rLnasRcLPn/h//+sO3GxiW0/hjjz/m+Utnv///++9jt//5V/8ToUNL7lzn1b7Uu5RsCCI8VGEtw4JHYDqWELvRqzTbyeqmglhzdV+JAhZnNs3TCBBhKVLOl8tThpR1j0y37TQaEQ8yJ8IjIEUgUIvA9IhBDRUkLthl4SbOECRumclO2o0N1mwlzwS2qxuI2V0pGx9OiHFMTRzxSUNyuUzsRT1MaFEW6nYxULkT8etLaBQW+82yEmZlNjdqQwoNa8pQlzagF0XlTvd6CjAgZt74KHRoBn5C/UBwgxgjNjHEyRweBxOTFrYKHGbs1aXG3d1UgJ5AESf3fLutczmotKZaKhgKp2bXhkZIiaVVY6LAaeNdbeOW///jMIlgjClmaj78Prf593PHDO/rS4orNJSUDYQJueFjIIGj6zqxprood+KgAAEADh9NrmEw621jl/VHbm4Zo6HTxI0ISjS5VghK0IDmrMPV951Lbsyt+L9L1bb7XIajiJqbiQxpDFkFBmXuxFo1LHcQuh+flWoGnc4jKwtunvV609jigIkWcxO4tHsVa0SaZW7BrWKBhU9cvPxIZXLpVHq+kFZfwvurT3lPRWF1Bl47H4k1O7/f1+tc7+8ZSnxjjn/f//xs9rMZCAVe6gfX5UPdU3////eWP5bWAljtIgS+K0FFB5GKlUHEf1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACLBwSwNc23DH7DmkC1luogmHMI1vTcMdLOaQnWG4xwxu4xYGFBpeaW2FZBuWqxodtTu+YN1ibI17yNrJZ8gDplgMniQCDAiPAAOAysCMzZ46k/A0Ayx/UJqSbOItbcUCjMeBKgsMDANMTkwQmwkDxiofg5BMoL+ryZAtaZAgMMllZV8PQ3K3FkCm+rpqymr7OlhiBYw4JlIM025Nva/JeNwnBeZgYCBoo8CyzAgZLg48EMbBIEFQJucmmp+mfFK1kBdp/H3MLH4rPSyRzzAjASNEUWBCEmC4SPCsFUU/hr5jeGdu5HmlFUDqc/XMLmu2JyejhKFmMiDz1RgVHg7u5KFBmP1GUZc///KXRmYd5Al2DZRPf+7u/3eyrXVc5Zd/Wv/vP/e/138eax///+1QC622zWhEAAAATNY2DEiLnfLLlp+IFZdL3eSWGRRkwRzVxEvYunq6TxxVteZ85WbpGqG7BsXeFJNxpuNrqFQgXBkBco8QtYFparIdl7VBoRTu7RUuclnocnRCEzazljP40xb6zhIc6d6aOjj+S94znDrKbyy5RdmoRXi9LanohfBQV+6nbO3c6WUdd8b3j0OJ7PNY/HH8O/3DDlWMLnw5v////PPXx4OdsZwW1PmX1Le6v6//3zX/Mdx/nOc5c1///9rjH6ioNImyYv/p1MAAAADtWYiq73gLByBjSGh0OC+S94IUAeFxkwG7uqypLxoDIVRM4MCBDASI5g6MHB0iYZZ69z+P22WdibVncUWWtevPxOkBinXD0VgA0YJFFQuCaAQEyFKlsRN13YVuLxBmzGX2p4U4kAvEzhbBndy9YGbxkceWoy8xxVe7AKs/WQ0daghpnI0JmpmGy97gm6xhwl/5gmFsWWI8LO1Uko3lGQ8r8wwsiBuxLLrtPemaGRIKFUwECpw085cvQ/EKJ26aTyiJxqBQcCo4pK6WV3+U9urK6CecEWoUWS2VXy3VZOR7rrv8r5Ya1utRytn7Qa1exVsZ6wzyyww/3KAZFjihMCHbHzig+Xl/q/8gBDKUkgAAAC9toUKz+jV6wmlLMcsJ2INtNaWGTCFBh9iAsIXc+z3upDbf6k+57CNyZ04xEbaiiBOrEnrcghAIomJAiRVm8sgpM+GZQoeXbkN2VWYnlSyuVBAFiWH3lWEblRe2YsV5FLHFi0snH1f6euu2u70jJLPtYgOpOSOYfmN2C5MrqKGvPzmUdgQQJA1rj0LYuc/XM6/77Z13j7l6t/rWG+//b+6q2kk7m7yn+4dgLDC538P//1v4540vYzVEbZdM4apEL9CyHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACCFiS4M723DWa0mUG1hunymJLA3zbcNDrOYQnWm4z2nrSNRjAFIHmDhAEeZrYT8BQFA0F6rOy/4qCuy/ReFpZhA8ZSVmhRJnIUDi1gTgzU9QwTSR59YK9qWEGwRAYOASgqj7hplGfgoFJiYoNBAFvLeZwzlyG+bCSh5l46/TJIhOy523P60UETKp41HrME0TWQaRQ+4K+sqhdZzI3LHeX9TMtaOWmTSMHdHvdZrqcjc4ddGAXWcSHTBAyGZoRhxQBy3CUs5fgUEkBLmCpAYsCwmjilBajNnK9S2q+M1EBoNs1pderVebxprdLdTuKgPUzY2t6k1UR2nOQdvdXmssrsamU/ZNhN1Lt7fP/HLfK2bo+cYvkgKerUPLG8WDrUV/9s0QAAAAH1LCWPpwobN2Xhav9lkPPUyuebAKAzDMznyRoIXSadEbsYbTORTMcpo7cjsOTjdCEI0+BHdnGukgwHEDZDGnOsiFYVJGW2iJjwUbi0EyiWyhulNAYPuy3tLdmotNqpSyMSuc0k92QwfSsklPwyzWgRrl0Rl0HSCxAFx63mhkGisXG/U/lPW77rFTpoEnS15BiTWq+8Mcdfb1qrcdEeZZ3lq7j+8d44cpx50j+VvNvGrAfKbPv5Zb3zHvzV7p0qEyoLSxstWNDaBUuwWi/34JUDr5G7T0L6tdlIXDQ4RMeSxoVE1FWmfpIapss7kPpbOXJEx0+EFQYPTwILByCHgZYX6tRymtQBu6ru2i477WFvuk6AIFQYDlH3aWmYIFQVCRj4BGBQcGAFKBuzNV/vpH1NTDIilNWGqCIz7XYPKgAaBTOlH/iEnfSCGVsVk9uVRdZK4Yel9RtakMQyRCrqmIorlQ5EBIpisrmW+b9lcsMLEYnMBYKb7mFeCZQ5LBs0hzIg1/fhi5b7rmNazlT0EQX/PZ5d7/ecqXMeP2JKUXnXxb7meK03ltQ9rX//NVZBxNuR/M2cL36/m+cwx08WQpdxOJgAKubKgTbR//qIAAAAHj0GIbujY/LdX5W5JY2zCHpY/cKDCYEQmekGRJptCQFOpx31a/Myfr+ZSp/H/wieawz52JFCkDlAB4KCsYstWmh3U8seHY1eJqDk1pK7ctnHpfynNYXY9LK2VapeQjir9Sm7FIGdS/F4KlUp5K1rR8CA3svv4+8bl0zg9LqUoUEyKUq0ris5dolzF1RPoLAFh1gGOXK1/Lv44Vd4Y5PEvPX4b///v2cqzd1oY6mYXn/wzbu0nf/9f/93XvBUIuEpsUMqY386m+LsDzLehYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhXYcqDW9Nwrys5tCM5biFhiSoNc03DSDemUH1RuLsfppyGoFJGqpgvoBr4xS1HiZf9Ydyl0TkGM1Aw68McRvAgYFw0w9sEfcLGYsDsgUuf57FBVoP22VmzIgwAgd62wMBgAwEcTGq4tKNCF1jhkAXECEhAOgncJFRgLlJjGMALUGuQC11wZpCc6LmH53iy1g07yHKV3wIbWtC2WN9K1A68Ue6GFcP5QsuEi8fB0QSG4qHAZm20bdSIrnbFNmYBM2kINQLdvxCw1hylYjjiVciNqZ5a0+WP5rWFWvWnbXL+dp1MsLtJhnK6fCxOWqxIFMQAlOcdQv1SStbPaWI36lj8MP1IZWxlqdiV2auuZ2v/vPwxdNZxcEB6wKVGWEyY9safziX72Ev3UlAAAADkiIR6QaCae+XPr0kUl0Ps+pWQjJZothYRueERz7HJLlUszlX7UswpGeWPlD6EyCOjUBWtQdd0VquRFrTGzTBnqs7QdzpMsTFgfjedepzqGu+Uc5lBuHJXlJa9NVbSUIdu0le1T3sMKWZzQapKzWpHv85R0cCNIF+KF9nMwqb3z//Lv6qVn2z/DusOZ9/+bqIk3t3a367BmuZ///+H95uh4gzJNeoB+iKxSim7egWZtVwoVJh5pYZgxBT7QupItQuLCY1MR4SAr8IpkgBT8EQiMUig5AazG4gAIFZYkhNrxUk9TU31V5DBgUALdvQw7UgBIVqVmFOcEJ4YDZj4TmHB8GBWHhgASFOp2W8a+jq1+KPS6cjftKV4oWegegPdWbsymxCDBmmnQw/kEScvK68thcMF7ZiUPCWAWRlQUxFklzFgHHnIcauz2kggDHoYmGVDwiaj1K8z+iN+ZJAiaKPxEtRap5Ra5hhhO3LFJbqTaB9H2m5lnf5vffzjwZFfje0Wse4v5I5Q+3Mctcy+mzzlKnNmzS029dx/fMcMc5y2NBZwqDYo0AmlCxkIoBQ+ZtqS620Bp+pkAAAAK6EylFhcCxyP3/IJzpJW9cpa0gJM8AOemFhKRC42Uv1NPjEcKaL00st3qaxgnOzR+n9tGNCp5FYwELUu4qqhtKuNx5+CEpP44E0TRaK5qMqBgmJLG6FEoD+GKisUSsVTojMiRinIcWyyaCtSGALgR9GBqQ0tGpFy0McThJAOEolMchZueOGJeBoQAaPlEUKM2JKTCbKW6krI1EPGZRRXap9JjEU4LZl5iPKuiVzykPqdJcopO/dP19FrOztWkpO7LqWpkFpoHVOC7CkR65sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHomrLAzrTcNUNeYQvWW4hRacwjWstyzatJlCdYbjeXL+NMIBEDg2gRehR6A8P5ZrcoAuHh1+E9VWozg4Gacie2mJI0jn3olyxdejYmbxBNVzk+ZZdf+mthQSjk195pKaYk1kBPTSiDRCWsutZVJWZypwPK2+giUz92FNUuNGNzGpt0edLPNyV+rTMXJbWTujdLPyIeJQ/XcgsrSF/Z2Y8iOblucueFKC2XdobL0pwz9BXkMAgwKCvpQIBBUwJUeFxOM2crfdY8sRjOfgFEz7mXOYZ/3WVmqmUEC5+3Ba38OaaNqaof//7zeUjwehzuY3b2v/n91fuZ5Vufz///y3///5Xuk2tiAEg+9GlZId7evKaEgACABw+XLutgPl002f/GSyiIZPAvp40kAAiMZQW6nW4z7v5k7UfoqFzqjjWIKrzNKlPF2wbpQQUf1NV1ytW0xz4FSMoZ5Y4WLvJjW1nhFbj0AzijnJVKqe9dbHylwwzeRz7GVy1R2M24TSFDi6p32oaGM53ZBHBkanpYJi1bOtah9NYnvch2VK1PU2895VMfz1u/WpK9vX8/+6/nP43USKo85Lf1zb654X///w/95cq2+/vuH8z/X56/D+Yc/Wv33fcNfhyn7qwpxf3ORKQfjmV61PlwwAAABvsbjTSEhBESf4xZowqcTWI4PxBqX6g7v+2AeELUcmJs2tCACY4oZukPBysOyD0xG4RKGFXsYnmaKBPJNwWy+CBgEhuqvxhAiHqphyFsCKqhRKDTTRTfNmjOgUMjMrkEvr0rL4+/IIhgmN5yikoHcGA6WGIAa4sJCKvb8jRowjDsBwUTWfQTDYml/GHgmIpDNI0OtREIL5bp5ZFKRBoNNYJHkIx4edlMrp7+e85+WUm6eAEzYx+HJiGH8pKSxjvcyNBReVvXGsa8YqRSxe7KIYlnalJLKlIzCVWLfNYYYbxr4d/PdD/54Yc/9a1z9WLBnFXgDrmfnx3W3mCI/fhtdDw93u//2HqkAAACtZduwvgqDe7DKneTbvyOuveG1AlYgg0ZKKrt6VjuPLZyK0NaSyjbAcqkRn5a8MemGht0Ag1jCFgAFDRJdUBwuDYzm2YDEnHm6lWO08ujvAD9s16M5a51aHa8olFRkVPnNSiGJbLKiraig1i/IIzKNQTVhvPbd4pKEyLH9qzE8oCGoeVeCe722uZY4YYdz1c1qmm+4c/9YYYc5rJsa/LOclv81lKMtWP33/z7nvPU/6xOWBIzKHAQaWSD7wfA7kuNg+D6w/Rbsb/6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACSRwyoNbw3Ciaym0Jw9uId3DJg3zLcMcLqXAzOW4+Xt0LYtfQdLSmEHjEcwi4lLpTLvZ+zVI5ynnL/GTihkIkpuCAkoDAcLGHhIOAD4JcSN0pRIREAHiiakw40NuiX7L0oCWNNhlEflI6TFskwnTUbMzGBUdM0AzCw1sACGVlLmQca66LTjNSeQvtSvE5UH0DhuuISEQqkZnX5oYiFHSXmcpbIDRMOUCbi8qCWrYlhfhxluwJAz6gpTbamGyJVKwJoq8oZSWRY/hMWIKg8RIMp1UBVQBERSoZ6mv16LOruHotRzzMhL8alUqiMts3JVGpVlPTTPUuLObCXlppdSQHGoeh6mlUNOU7Lsv65L8yljWsqWls75lqtTf3LL6n5Zf+X4481lVx5lWyyy/HHHHWVa1kysSx0wxVwKnVCIGg7bxQUYAAAAHU73i6y5swTGJwqlxuUNBZkTuvZm2NlyQVZ/KrdN5Rano9wJt0KuXNX32kNJGLYRKngcgAwCG34j8ETMFP+GollDyunFhxCADn1SFJ+cdNNVozVFlrdvhQYV9jlcc7S9XzHGhrU6R1AUzrcKCpGMqggKNO4dseWJr4zn63ukDWt/X1r/1xv4Jrrw9a+rVg/6rW2P/5DR5v0I6wlQ3IzHYzKGdMqjxgISPCJgSsFVgPQy5y7nLYb2WW1kgYgJSs8hws+hyKorHggc3Ihi0AgkPJCtebnkxMdAKvoDGgTWIQExRlT50kJC4cSMjixGajykAAZMfBYwWG0T3IKoEUWCAPWekYBxVHDd4XJ3+YS/1DXlBsBMkeWDnQh2KXgc2t2co6aqn/BMIfu6Wueeq9RogwoFFT9RnZMZOw3G5ashQO2XNqypSSTd7l2LcBLh+LIYlgoQsK6ll+/Zu28atDSYSmWp+l9qfV/vPvfr8sKz7DSMg40mxdzjEgkUzV1r/1znb227QjGvy1+9awwm6+e86+Pf5//r9aw5/518//fP/X/nb6CGLtsS/4vIOijOmc9xlOcH9Q0EbXbdvPC9GYy4tHDDfIDjSkTHYQkkXegNrcXb164PgprN9c/ZyZgmDUq2gt5FqAblYCViDRKFjYmZN6o3ZfUZBNNuMUmVJb+NfQBzbTKalwl1PDVLdxllJMLTkMosULQrdPQzk0vCcp8XKr2soDlMoxei1ZfpzLeM7KomIzgWXFGnlzWPzfN3a+HOfZq52oKeW/r//X///vcALX1hZs7z1V5zf///+e95TXM8OZbzrk1423c0eIHKe4o6+Kfe7qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAirdkwDOsNwr21J7A3xbiK56zQM6w3Ku7HnkGe9uPrZxu5VJSUrAMeYcoCaaGhgW0VgomYK4d9G26y2mEYEs2XjCpQ90IOGNTZI1tp8Nv+XnVsLUBABciyYq2GZkGOlmQe19jQKDtLHko8xBxVa6k6RPRnDWEtAMRbd/3fgd/5e/1O5BRJrjDFBEhFNGUNYUBhe49QWHkfRyHbn1cQI5D+KoO4l7Qu3L5RFJZXuMwWdQJ3UubyOvT/K6fbIQe2iT2ZNDsxKJZUpJZDD+P5G5e7bj20aYDZ277+Owzh3L3alJY1DEP178fpY3F5ZHJiMVMMKlJT5/rK5Uord7mfda5YsZa1v+YVMPz7hSWMKlJL7dPT555528KlJY/8N58z/eeeeduxwEAxpE7+J8Pl4nAAABAMZoAAgAAAC2cWNTInd9C16WtZiiKxSlvG+HXiKd8sDua7xAcqIikbNZRlu71fBB30UgSGTJ9wXUDrJAmO+0z6Z0/E4Fw0LhcMDRiaQRQUgTqjQvrMXSTPIFs+ZmaKSDOmism1olEquyBsYGgI+bjrIaQq0GUguzOt0zhXddBBBD+YJvdNNCpBWpBNNTMgpFNCm6moIJ2Wm6CDMm6kC4XDAuF8vprMz4nKHKd3s/+n4Y1p9W1a9I0C01wMyUGg8gKlGSEkWy1ZIkGW2mKQAiYMsIrOkKrPZBpszEG6jRDTQYs/rRXJjCwy623UodBryPTDmSsRQ1XSqSbAQYGh02AcBSgeV3JSxlkbxyYOBPBTSe7E7Mpf2BzMF/nucabfqAHjVue52oKa9GmTM6jzcY27barpaSrbEm4PPba1As5F3/iFJTWWRwLeZ1D8ekVuvm6Ren24MBgWzFq7vamq2VWIbfeNw1Kaa3K7FeetVKkxfo4xHZVb5Vs43aTWOP2MKl+doqud3G9IatBYu538v1hWwvbt85cs5yzDdu1WuSrGlouVeb3zla5r+369jlzWGeO8/3vDncc88K+XNhSPiwyy3XTUHjnCqwAAAB6uCtT8CyYoGXMTdJFrULLOk1QGqAYkS5Ujbiul+BK5bh0hO33Laeb2NxFEPPEcVdr+YMHxB6bxsvL2zC4/3trwWWtM2xWFvbnjNIM0za4xyeytzkqcQ4v05bcLZcmFcK93pTDvJc1xWlRUcla+g/O9fbPAu8nvu8PGte97fc2KS4h0vD3WJ673nV6fUup/D3iT43/vONZr4PMhq1czCkjng7UBVxa28Kdn9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIVXnNgxnDcNCsqcQbGG4fcYcmDW9Nw3+tJVDNZbjVqMNJaPJoIgYEifYuK9KOMsoGGraQHLLXbSbfmHIDjSCUFnNJXg15scAzDXmwvFBrfPs0JYFyVBl4sWU4aVnPrpCEUl1opupIvqiswlmD6p/Ito9JPvKupcrwQuWSqkBLmsuI5zksCgOHGsxyHodpqFzXK5DMea1A7sxRr0NLBuC2RXzprCzj7Q1Bs/faxegF3ZFQU1SvGW7gM8ukSxY1S3Ma1el1QzkZdl+YCb5v5bKYw/M7WjWe7MpwqxGzLrVL2ryrMy2gpr9WzjrspvWss6WU5zNmzWyyw3a7VxqWsst01qlpcJdlu99NvHnfyx1a/dnHlbPVreOP/q/+u/jjhWyLSQNDgaf/kV0AAAAD1ZhlCUVRUoTNWpjctbl0vkkzBUBi2WbPjR3JvkXm7F2k79yzctWlkSLszNF3UC20QZZtDzMKOAsKJwiY1qdnqLOkm6lZNS3apMcJHSw7XtY1KeIWvszFqmq6naB/LtaLS2W4/TPpDF+g5i6M/U+rMXWjjzIpBkBQ9Y5TXfxyxlEtlMQi00yW9biV7Kmt2Znna0tqX7WNmdwlVm5Wv42ceZY45Vs8auNal5Wps8avOWfyy3u93mPPtGQmIRwcZSlxsmstWt3SgjS2S7tiNUbYk5UuW7EJ6sAYINPB7tCU+r6u5KGtP+CAeUwyyZxWWNNEQaYGDGX0wlAkQbaZU40bS1UdX4jKlY2rKX9ZQ+sgWDS3UNeVoo6AGQhYXV11mXlIOVHXYalwCAFnc2qmZaGNu3lAzqBrjtL6gsqw0+Xqp5l6X5onrlLxQNDr+xpm0pkFV9du02dBWoAiEB94lA5MMyWjX2ilGzBh6KGSwCbPMfL7MoBBc4pKMiMGXpUKr2rWWFLWppqrTalzY1MIrhamr+Vb+YX+4vq41+3Z7Xyry2/Vuf/8y/7PcXp/Le9/v8NWqXfd9uGVKMH0OYAWxZcswzFq3IstI9+kgAAAAbFy0oB0e25KuQj6p1hFrUSh/r8LlCAhcEyJc0Q8/MduCA9378MPeyBuqrKQmAZMekjW7k/AAjET0ukTXiKMSnwUBNMyDF6QrEk4GGxyGhwUZIk1yXU9amhcYf1+RKakkUViVC+1YqFOpdkuUWW1LcoErL21RQDD9VZ8unuMPv01NHnqR9n1Ub92ihePX15SmIwewbQUtiECBp21awlOGf02rVNTdDm5fS3fyy3z8dU2D+T1mu8Utzz+/qv3//X8x53W7/DLw4PKPSUZuW02ByinqGaWZEvaVRZT3VgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB8VqyYM7y3DejclUJ1luHaWnKAzrTcN+tmVQbOm4+zHLdK0MRkCQhrQEDpuoNzlMzO8rPiyJXTNWvMjSyMLCBGLGCAx6FmYCSlUJQ1XUwiBFKptvH8HjWKsobrAy+M2+JAtc8Cv0mWCgIKrphokBCEEBrX0GZwwkCdF64HIkiFzcqldJxusw7RmWPQ/2UlgynfabqxmIQ3TM87QwJHHIf1148UF1SsV5qGZXXDVHqvg6cPhjESkDI5dM4xGAWYA00IkbOnqSCN9S5518//KnxtW68ACwvM9Z7w1lYqa7qC4Z3rKjz5XgjudvWv/X/T7wiNbGY5hvf61zDXNfb5hr9f+89a/Wt17eRwCS7RGQgQaHoIM09nxhYAAAAuap0MIgORNNzdc833k1NZQWvhEZAiCBYKIGAwIbtbTWgGPS1n9Eiw4Ts5LNmK1SNzLYXfdaGFMRQISJ31InYqEhgZFuO7kSfiAgQTbSin5uHcIDn1lC3rbW7NqKzsoMUtoNqN5acN5ZyW2UgK9SG1YLjy/em2+r75cpl/UCWlNVlTncmcX7lIXcP1ttpevCit733D9Zax/VppIMCu2ud5zH+77qtDzyWfeij7hlJc8O////7wqYXM7f9wzz1hz9f/7w/f833X9w5/ed1UsY5/d3hUIC4rfy72s0/btUc9NohowCTxesPchGr3a1uCFdSHBxlUGaMtEJEwIs+rM4IZ6CUNAaf8+wGWMNSqSPgtL92X/l+bV5qG6F93QEqIAelcs1gtdjDV3QCpa5MVFQpoScvlkMSGWzT7ZSwzp+QzUPWpqrGUhIYs2atl7opUn6RTGtE4ZTU6CAcCS5sL/XqfsbjCQkMIDpNGi5kus2uMxg0t4AxFCyAlAPJav5WMd65UqRzDOfQPk+H95jjvf61uaikuwePK/nuX8uYf+v1//ZuzM9MTdPv/yy1czwww1vPP9/lru+fh+q2AInfEScUinqRt2PcF9KigACAB3AibI+yontOa/koppe/LcH5EQJpJBgwrMig6KRMUh5uLDlDFQxJcciea8vHGMwlKiPwRFG5AqUQSoCyzYgCVjZpDbWXSlj+BLU3NSeYjchdC28RpUieMunLF6NwYYAis+1nUtKo4007DCC8anpKw2gVNCrL4ya7NYzE0/nC69PfcCR3sb/H9EIAHpmPYzlFrDWO+8x/m69eDAcBln4b13v6/8brSpfUqR7X87h3Wv/X65yrjzWedTW+7q77rP//O33XO//e/hr+cxu18/wvdBByirK8XuE6UW2fCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfJakmFY2AAvctpe6HkACpGQTw5WoACTcgpxxrQAKlJNz8DQ+SPXQB0nKB2PL79ykygtk4scMiYZDiUyE0hCDDAozhSOPfjMQZpSX7xSKBljOgnixIiN4+0F/og6cUd9L5d66oBXkCl9LASajPQEiKXBeSA17RZ2kAJhIo+T8Nclb3xFramZbgHKgYHvtDVJFLkPmCiMAz8F2owy2XdoKJN684EsQT1xwM2+bO3yorF+hi4CCbowJu3A64oha3SPTDhIEGODcZZNDStP3L9TLGzh9BMTU9Daa2+d7jz9fvHdh9ZjWcRxq59lOdv8Of/P5YuYUlvG3+f7x3j+8cdZf39/vm9/vPPmHMLgpI4ZCI+tkd6Hfx3ErgADAAAExYxlnEAusrdtBLKGXsjft2WZiNZJMBGQIxR3r/W1SUdWA2+pHBlcnlUujEafTOA3LJph01Os0mEIXSR2ikukEUQ8Rwe2xKdfLqfr5GBC9cLlO8KspCxjzXs6nvq99eZl6qmcrf9r0YS1hyisLguYf2vK67IJd6wWH19YvGgnLBDTKSK91rD//n6w/8aiZ3/3f///r+XZa9340Hea7W/eP//f//x/+51MhQgY4aCWLixc2BxPbn36tYAAjnRQ4GAQeDUBkHD8BtgsGwMhCgDG4GAwCY0iPAQGQMYh0DPibAxUHBgmwGcCYAoOQMkGMDNidCAKCfiSAkNwM5BwDFY1A2gMgNNRMDCy4Kp4kjMBQZgBCcTsGqAMJioA0BABB4W4iRNhCBB8FkScWQJsFtHYDUACxAYADolMRyQIWyPkNiQOFEcgcgMsjoNyoP43Qs8NYuESRWZl0lxCQcBiO8nR9igxQQyohUPRIkPQgqVmLJSJNaYzRHivhcOGWwxQZuOMdgzBsIWGCMsaiumQg8j2qky/TWMmTCx4FbjJjLkCFwDbMybJwgRFi6GrUhcpOkVIa6TUKbrvbIOKUIeRMZcZtIZsrk4S4yhUIodIqbkSM44SCCEoeqMqZKFnE6Vf////J8zOEEGTMyfZbm6mJxCTZfm7uaXbHNJ4hxQNzYixOlUuG5tVl01ZegfVwAAtRgYHc0JcZIdsdgyAV4QF0Rgx2BXAex0gMMAeHgBlgGoFpMnSoGCLiUE9kp0uF9bHUR5OjIxKJHCBYqyNcnrMyx2VWi70TAvqQPGaaCzajUaKauyh4sbm6Z5dxvc+sxaimORv+v5xugp0GepSSX//2X1Nbs9b2SQais0bV////9Bb1IJp0L///RRUqk6SKOr/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHcGtNh2MgAOaNmcDsZAAeIacqDGsNwzqnJcGM4XjdK4L8pVobpnCIgcMHpCzxwYd1JcDSLpLlZSEGmEecBYOEa61A/RjHWKDxRBsIjeLLGYKaQZjCpcxBv3meS47NundJ3nIbDVvVGRFUFiBQOjvZd2AZVPUOnpY9LabLe7FXnECPbFbfbOMAW9WM8MqW5hRxK7cgKDZ196CVRqXT+NmtfuS51pVLnejEul2/ly5luyGxEaWzlqVZSqm3WqWsN8k2OFrmWWW8M+Y01qId+mu44VbPdVaKm3S55U1vVez+WOq8O67lVpKuONWrjhljrfalNVxw3llhWrU18FjMkqGjwaKxrjNOPyxYGXeSmZa4LquGgskmQkAUgOE0JLgnxqSIlJGNlw8AwEzWLORcaQZUwo72DdaM8oncDnAacZZEcMYFCSkTDrzsuq2dSabvS6Yh2GYdjMtY69D6FQhWKBolNUeMw3ZJitrP8eUuF5rOWWVNWtV27UVNrtmZ3Zyvy+zjWqV2zQ7ew3dwms/g6pBe949u2caWdQZUqkUulOd2zjhn+VLV1l9buP54c7jvL9Zflft49/uVbHHfK1qtWy/91cM6tLS2r/8138stZfjWtb5ljzf1ccd1cu9+mtZZWvUSDQuHdqgMHREDQKgqCoK/Vf696lDQwAwDWPA2REt33HmgwqXpck1FSEMSOVSNQMKgIWRzBaoxoYMFmMGizMxM8oFGEJosgUGhqy56YwpayIMAwwIwD/SV6ZWnsiI53xhRc25IhbFDYmQIqytgDQ39lr9QUJEItezjczGrE5NCPUhuVsPsUb8csW+0sQx3LbL80tqZQ2tMcfm7NatUtnKG6ehZRGZsUDS0OqeONjcBNWLxJlLz3dfWz59u7hn+EqZfll3HHX6y/eXIg9uGWUs1+Nm///++Y6rW8cMr2XO6//3z+95rWdXnNWv/V/fOa5ZxAQqgFXJOkxQibHvVF4v1znm47fKj/iJxtA5IZMrIXtLyDQ1tIPoktETCSKDsFcIXKrAEAvkIwRNUVjOCciTMQFGhMNsUNMcaypZTOrUdO/hSzz1JGPtK4ZiQCHQ+CgAseu9y2q1ZyE0EiAqa0onq1/OT7yZm61+XayzwBKZ2auUmpy/XfWhil6lvMHuBcUKqz0k3q9qmhmstCl3Xv7/W7CbonyWvvZ738P/+b/P/1KYt3+b/8sv/fMqVkglDBYYg+VryxNRUkwYeDQiWsZDh0OBB4NBeASplpI4NO1Vft26FgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAB2l1yoM6m3DwDZlQZ3huXTXjLAzqTcOWPmXBjUm559C3VTQQlK1q+dsJnW477FYGdxhrcQuBNKXTqh5/noS5UeUAJhJ92REyWDaU7T8Q/cgsLiF8DQPAdB5yaIwVFwoSeCxFnZHzA46BxMRmRoOr92n9gq1fdMaKZWrxUOG61kXAj0mC4fU7LDFSJuViaNjMopFUlB0FxZbDgSODITmx4jlqSTKoh6Q1TREiZXQMDElB+FnA2KIwh4uAek0jJnSWamqKMwMRkjVSdHqVZRkLLMmMCqtFjBX2So3L5mggqjrUpSCT1opOmkqtaSSjVJNFA47pmrrRRSWtfSZkWSNlB1YSNlAEQvQrsXsKf9V04YFTEASGasIe2p5Y7eLyaUy2lHQ0xsdVMz9+aWGWAAEKHQ8+8BVwz9az3Rmqy+iL3O4y+YTQkdI6uEBjggoTDjtN3JAglAgMSlDKjsv1iL/OP2HQQFGGj1FUuVaPDkOWBhzqVqbt+dyCORa5nervFjQVIk5Ny/EVzVx2s9ZfyW43KS9MK18EI4vPQ/LqmHZTQuwF2xyCbFXuev3hz9WcMqvG05ln/P19bDd75plus7nPw/PlTX/vWesKlzGrvVj/7ldsX95bx59zP+c3v/z3nnyzhar48wtYW8wEv54++Agb/vqsg3Wi0+sp/9VKa1frplNeVugtHwFhLDwjGTu1FoUxACnodkMUoUfnSWUYMseo9GlfX5RyxPt3S3XaRBofUMl0SlMlWTGGKT8y0o0Y8lVCgFkhQXcph8sbDblFsiFx+ltmxXNCqV3Apx5IvnSfVDbSgaIoF8plkulxMTuYEcTgjcyF+kiUh2s6RmRguJiCFFMTyN84aIGRNi5wbxjhMxGS0DR6Kz6R1jqaZNjIGiZiYpLzAwbJ8W5R84QSpMvqop+xSWbm6bpooUHTUbrQZCt01IJvd1p1uneowUmmimtalMzNTTUq1qbueEbgUXDydKOpo4gnWVuswKAlgraRAO8y+cjNeJSeffgxZKlkL6tYo44reMID6KFG2VwHEMb7sTRCDh2Bts3mKeHcXBmHNxts+Ax2BwUZMOUWO/6yobps5xQI2QWKYVzcxMj5w3AJsbBmm5XUR4NyiIOpCZHTdKLcXHJIY1IG0CZPl4rIqTMkSw4WSOiWj6kETNIYwFuG+dPjsWlRafdFBqBgXTS7H0UkTJSFZPC30EmSpI6bqaaIGdI0U5maHkzdazE2Trc/SU61rSRqtOMkYrOprQMDIuEwpF0z5ghWp+ip1IGGg63TWco4afJ+WJ3ff0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACGR3SgNaw3Ky7lmkDxBuIRHdJg1vLctIuSXQvUm57ybdxpTH4w4pCyOcIMGCctXCazevW/D5nccq+eJYrRVgCIGDkJlXp1IJMVTZp1NXQ0slvRg+XHYJGZh6rDwscHAIMFkQmHncbGbMsKoCJ4VjUaojL4S31HLWbBlp9YKgN+bUNXrjopMOpEoHbRv2sz4JXIaalsWH/1G5x6UKK1LGU6pxWuHqXCmwo/pIDW7LC7dLDyhjUrWXJJPyQtxyu/8ssTNFP1M8c5ybj9anttn7K4pKo1lfzwsWd8jrOLmrNFasWK1reeOOu6yt6orlWembVNVt5V7tjud29S6uX88fzvcxpsvpq+OG+Y2d41t26l2/rK3hfuZdxq2Nb199Pk0Uvz/vfL+ZyyiuG6QBAAAHJYsIMBCZwtbryXnaOdcB3HGSMDxPZFauMTziEdf2M0m37yyxnKN9JivWbCBAFSFMXIe+WyGjj1f4KEoWLe2d0kUwCc3amyRiGOGCdky67udKSDJjARFsManUmixQJBQzCBmo2SUxSUeD1iYNSkkt1pXXU9BRVJFkLdlr3kspmKuy9Kqut2TUtnrZaTJq0kE2Z1K6k0kLGFNTXSUipTpII6KJjUkUU4B2tXslaFM9N2xEW6R+QKpvoYkifA2j59WO0TysAWKa6tL1bm5TdBYDFAgQAg6mnSiogBUb1rPe2N+15JijAiUGZelsSQ1VuETpV9lYk9sCTruhFoFRYIdDEDJcjBYpWcVyPbIDAR1ae3NzEonJ2hLtLcnpijnad2AQBB9ielmoTurcnHri1SZbWuWdkPHin+4xmaT/feNrUhmchqL/hp8H2FFClFs1VrfLtTf5c1JbdBLasrpmSS2vckNJfqWLlPVx3GCIWdx3zLeX/U73H8v7+qluVVqK9Lre7epTlla/PC7lljjzvMsP+lmpytLqWzPY1crHcK9Jbx1rKm7lvVnWW/+9L24mhXhV3uzln//GYMAAAADlz12nzpUJFNhtH5VYewpIw/0ZsO2roNSEwFsUliUOTD11V0yZtcX4ryGms8fqRQ51TowBMkOIOmJAxSXtisvThLIfBo/GN32RTLqRfA+4tMqtzYAIx5c1NVC+TNzNAbJkfcZdITkVqZP1JrNiyoTmWkCgmlTKA6h/F+QhQKqaSn01OpFMxc4W1osiynWik9zhD3TMyd1Xb2XmCToutJlJudSZNV0XSXZaD2UZImpiip3PGU8Zl1J1mpeMWYxZdHv8pmMhzGF0Fr35rT//fQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfhbEkDe8Ny4E6JVC9TbmR+KSIN703Coi1mYHw1ucbtmTvNCnYbmFCE585n4N+GX3fRi4hADILsIH2m08bWEQmBxuY4WAeDAIS+zeNVnXjQGoIQYBlQQCAWB28iCH0Z43NU4kEt/ByHIzEhLPg5hApYDg1H+/ZYIyZoKl4MH2BP3SfFrk5NuGSJe+ellNOzsN6g79Tky9b/y27UYVcpoKGhu8VDWcmqu9SXLnxVsUoZFQeIiQxnhemrYNo0l3ojAL97u1N67n/KSVTdijbvvKtbn7NqX03zWN5mTh9q17GXM8cO9z3rme+Uu7v1rGW6Wz/LlvmuY/f3jr8Pz13X6xw/lrv8xst9Fj5HtavQ0tot+PnSf7vtv8ToC5AAAAAhsnDzklUQzs79Y/MM6lucZbCwaC35CqExcEv5UWg/0knm5RBIFWCHdLqs00mpa0zFoOmHjAXIKlA5QCCpETao7z8LWodsMMiSe+fmTxhHOLBBAPIRgF+yjcnAJVNywauocsiJuWEhOayLkaJ6TDLqKZRIUzSRcsjfKYeiV0iBl7RMFihRaj47iQNkVLepSKK1y6xJH0aSlIPXUZrE1NlomiaaZtU2t1u6ZoeRuidUs4pfWqp3aupq2ZabGKKKKSGggkZmaJqhZCjPndpyCSWw7AX60DH4fHQvFgEk9y9lUlsKYQ3wEJjIqRCawaDYeaA+xYARQDNOxDNwZyVJLAjAPWBIWY/DH8ZlKt5JB1bTXBIGUfRNMmAygaU0jbkIDGCQ4zaqUBEGK4EIGY+fDKGEPo0dhUKSumIJhL7QWjqGJTnr6izvxWVPu7GAOEKflLzVYlKJMY0K88/fnOI2WJTalq06bOkaJeUHhVLDizb+GNZeBQluCgOX8LdKISrKHYrDkaO2Tb91EO1Tt+3UuWaScp7uc9UZCkNFMn3rVLD+1qfeNXVomFZ6ynKKjmolYpdcz1NauW78ZhnKVTkutWqlL96z2rvLeNBfpcd44ZYa+zd7vV+UfnzDtrtvHOr9He/H8Nd33PnOVN/nl+O+77zf/rmH4b7rWs+5Z/hrX6w+0nkAAABu6LQ8cAOtX/9WFtVqmDyzTYk8Q01H2nsZZSVsD215f7+/nlllnq5XpQ2iyChAiQ7cMvTk7vJA3YSjaq+600VG4E6dZJnRH8Jsgg+aOm6y4kpYX1ATZTooVM5mSyAniSzV9alFEBGliB57qbZadaCjEuLvZVldI6SCa1tSZJ/2WZGDGKDOaklYsKynRu0uijkyk516ydGv//1/YEX/P92/Y7f/VBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJB3VJA3zTcqPpyas3D14j+hkuje8N2vk0ZySMPbnLK9TOA/jVEwAMDmgXo0NN62NTdYBmanSP4VgwCTjG5UtNNoaC6lBg0Pm4FSMhQuCvdTNJOLp4sjXaFRYhwYaiS0qVMuaY0YcAMEtcVTlBlYElQlhwtAgoJgSqdAOxWBnWf1thoLtXS8fl0nkgdyodWoYMowC2u+3E31fQupcl8QdzJ/oFct+HldJy3bb6ZjAgAxWajzX6CTQ3KHAaLaJAmpS0VVkn7Ka8yIUZzQSk2wKpQ5TZ0N2xXnZuD6G3Ec5IUBIrfjMUvTkhj0gmc7dA9LOL2dfdu5qYvZ3s+97T2quMxXlcxSbsfz8N91nXzsYZ1t3qfDO/hjjypbl9uzv+5b/mOtfXl+6fDlen1U1bH7zBnOfGnABRhKMRaE4GXIu3GwAQAABWkkbWoKFa+/1vPjnuvnj2HpTAKPAOPAkAczocI02SzlB+UuqX5VqxNW9cgIwldYWIXr1CYJ2aBegteYj+T5kzkeUSW+N2gELZd/GZ9x8bcbQrLfU/xl1TW/LFydecP59/PmOQpKw3l//92+//e9L2+fjH3v/67iE9D2tIhFo5oswgg6FjAcybBOXEACQMcQD5x7SizW+/fVdFItHon6CAAAABupL5Y+byT88kiYnBEw6kUMApCBOuGBIkLF1zAzoWjFKmGv0taEFYKCB0TNhoSb0CAqomKKXP7AzakIEkDG2JN6yunb5eygrWET1OGMGLgIyMsAKBdpjQU82hvLEoHaCsRkTtv5A0hd2LPW3MKLY+1mArc+6DlNegO81p/aJy100D0OizmxHJUn10vpLog5cZaU0mtLoYYtLVT4yiIxHOt2dhhDigMjEiuWJm5VsReQTEpprs/KK2Dvzsuh2AbFuWxKO8q38ZyES25nV1fpruOW73f5y/jcv0tbDdi/jzLuOrWXMs6uWHMtW8bmdnWV7XKftTeeW9YY7/7ussssf+5neptcw1j/cfwz33P9c3zXMP3/8/efMq+m3Pck4AAAAACntIqMaEexJVzlq6/LH61F+WL6ocgYiGZZLJupPy2Ct256zWsbzyn6S5Kb8lLzKpscWi30spK9jCvNMsv7pXetXy2nK31tTN7mTP3OsRc5hRorPCkpbuEZs1DcnGeeK7gJSeEqGOd5HbIp3DjYFzHjM8kSHHgUl3fzb3T5+d3zj/XziPql9fGP/r//W7YnzJBfbtrEaDS2PFfZ3N/978ls79tRsP0hAsTnKPuw/H3bb45/nu1sx2nO9cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACQB/SYOby3KdS5nJIw1uJJYVLg1t7crmM+dsvDG53DUPU7ow2tVIsFBYyrZzCoNTcp1ovk1IIComYmZHtyYQfTjbtaQpWFMGPDXFoFCqVCgrztydHFeT+joAGFyxQ4BjTrV2MP66icyY7wt1MOEiVPDBYwYbcJbrY2dq+iE+u0DFbuTEUbGyq2uXKKAyKB4DtwVSzs8iG/VFPTTptVrRafl6n7sPRp5XVQrkcxA1FIcoBk0cfKZBxEVsod5HXmYvg8ybwvCzWWyBkty9M2rmWviNO7LsN82Nk3vpKJRIqeNWIpbrdnniZXqap53lNWuUtbD7WV/fcu26sthqq/1WluU2VP+WGPb9ikvUdXvO/zPna1Pn2h5hu7awtWruNajq85ZvYW/x1lrWWdm13v/jvf475/bk6poySnfVNmvalAQAAAC1oYlSSgTn1LxvDkfSzu2aaRxmJI3F0dxG1zmdNJKPcOYVeY28b1bs/uUB0VFU1VgsN271v61O7PNZGx6uiiWu1zx0T4+9aidZSZgqo1Yfi+yRe9kWE7OolI2WikiXDYBPInTZlmKRstaqNZ1JNv9aC61m1aq9S2W/0HUZ2dBc0ZYRIPJKGoBM8Jg+EmXZ09fusWqhSZOjWv6TU/KJ9pgqBck6DwrrxSluNDjDMX0JAMw6oDiCB60MI93i14G2QYAPIEAl9tYCZ23B+GZBYPMQAotLNS6NtcXo/rOGDtYQSiAdIh5UkMsEa0qVk2EcX8oAvRhjNFILAWweiiHgV4Jzk8ZzoMcUgAWHwYIuiREwQsUgY5YiwmwUgwDtHsXUWEUhCzkCOHibioEkO9FuApaoLYfS4OgviXYVGVA/Ukp21KVXSsbFBAoyOnigcGJSCYDEbEoTtHrbItuK6VhcFWqz7aaPHC+E48WKMCGMCgUjvURrblAnFSpEe1xl21RYl6Zhyx555qatEhx8MDhSMzxlZB3CZM6lc72ewswIuo8e1Y+bUrjd/AprE+sQ7OFPhnj7vfetXv56R413OoM3IAAAAADiodUt3gCM/n6/I+jhY7nOakSqgPFKLNrmdbGgy1heudub3vm45XyHnqPv5YiNqns36uU3F6n4/FBSGETqwo1qZDQjLXUalMYpm4awmFEMSlJLMDvyoWUaGUku4gYwWLOY868NLV2zpR1mUfW78ml9s5OLH7rVdINcgRt0vPzRiO+r7/fKWqdttLT+FcuRY3BXl8zvfL97bk3vl4G4CIlmOp1sBX2jVYi+7SqwTaT7+7ug3vqgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlRg8wDentysi3Z5DcPbiQKHSoN8w3KzLSm0TwtufqU9BDcYnmAhAGIa4iZrrPm/UacpYZ92umHGnkELbWkm6wKABENNWLa8jc0yTSyDmdS2TS9qBKbbmr55Fjustxt3/a9aYUViZaDl6L6miw6dD3sMd5szNmWtNf5/U8xmkh6IYE1FRx+jmQZMB/izlYa6NIVEJ9DRQmBLx4HmdJVLxLhzJmKW1YZSEmWcJjEuOU8FhCyVMxCiiQ16XFcA04hzsC7IKmBCVcLa5oSliEmiri+kuRp1FxhMTirx3ExIEX0fTWYSYKMvCTVCvbTubzdhKWCnU7l6nlwdp8DtOwvqQRK4cFc9Vy5klklow3bb1VUR3pEsiTcD90kZbQGtehxH7xP1kb8ZhMrn6vZdRa0lruPTc17vaWzanpfG81+t1+t3g1oyaizwUVCAAAAKdTIOgZgxB4Wr/L5luTeY7ldmZRCCWOrhXr7/7mW84tO4Yaz1nh9+UpiLJkcrgfmHd5V5t+se9x7Zp0XTGvvE73yajQ/hupaTfgTWZNxpfStaPt5R00qupZuh3ivSGatJNN4uXset5tZmgqmPB8W8a2N0jarGravt/qk9b1rXWsWzW+o8X201fevSuKa+fT/GfjdN4zim83xrN8/cC8qAg+aPMSd3LoctznMlUM6N/jfbHK3BR/DCoxfIPZUUKlNW5Stl7HnJWDKgWOJAgHBB6YCeFpZgYJGpQ0lKy4wKEWLvLbYih2Vxdf0VB5ioXBAEV1Wn5OkdNwfRIXCwIYYPB4eEyuYw7rlP4tmEOSPC+Vddq/Foq8sjeAhFQ1uyWQ0sUk1NctwzYgO/Y4/zky2pQTMdGS0UG2JVjTUcOzkEVnehEubhIstz9WGWvj2rr7z26fKVSKeq4S27OW5HSR1xp+/TZ00pooi9kO01mxOuLNzMpnbVWhluqWxP2NWpzv5fGKbVaZmpX2xvC1nUvzFPXlOFak7TSrL7/a2OWE3Ku1rdN+VzOxlqmm5jdbOlps+d3y3UpsLW6vMbH5XcNY/jn/8x+k1vlfLmWF3ZSy5MEAAgAVLonHIxMWcCMC0XO7t0sdQEFZJZuYjr8KVnprsRmmq6/G7nnbpWWy+pnNTdLL57GAEEKdrbgBE9Ry7+TXOwDS1OPi5qQ4f3OmFRqWRddlJ11Ui2JN4B0bH2rfLmryAibPNVkTV51MPgDnKmrVRs6HMRrZC1umYvndLd87L6n7ayWw231UshvO1sKbb4WZ3XFO42ylNRC7nMZ3rNkFR1uaLXP25+RiWa96fN3nAdO/oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJOYpLA5t7cpxrGfxDDW5oGi0uDe3twrg655BnobneErt36lsFABo4hBJxErBUBsMgS+rcxZpaTIqCHNh48sK7WaOgIOBzCTY1IGQAGCCAkMAY3a0iYXkCgUgDc5TtxhUEApWDiNpjZWYOnGXAnFylsVKhoSTla6w+URRYdS9/UHDDAZOhtX/Q9gLgnETHELnIIhBdyVucAooisPxQSnUu0ujGRBrRuKBTKwTBZXJzoggi+IWY5fCZpYlJ/kvFmEMPBdmgleoBwGghJ6XcJ1YXBUXpFeKdQIYi36ITjEkWBIjrdr7PGiamU6vxBlxiZVx4eK31hsf+BTDe/onmKC4S1gw48ZvsrGSsrHj2oyMkeaSHLa2oErfDvDpiVXv+svJI7ukSWeTVdUiYhwsTUrvGp6wIETdP63hw47zVZ4cSn17fPiEeeMAEAAAAKqQQTVSSTB6pa+ssM44kHer3dW03Rr1PG7tjPO3dw3jhahfOYauWu/mtaA3Xga39f8OWty+X6sU6mUWopnDBqitNPoPUggipy4wxUGsggs3SN3H5bmRo1VicKaCkdl/9KivugzqXeZKW7qW603p6kVLRSUfLXFlgmAvcEgFZWiZy3cvOecBXmc/r3+f01vf7v5n/q3+5b8YdcadhwcASQNCA0gJT0oEiT0mmDoGojltVH0g14GXIZxxcIAgMLy9IyIGSgBmw2YCCJ1mCBZgQEgnJQB/VxKVBUCTraC0BlwsnIJVSsFpX6ViYDGk41ZBYTQCuXSQ88avVpFvhUFfqRoYpqooJElRbTFFdHACmMcL0K1TFiejJEmSzo91AZ7VGTp3ikk+RS5gI01o4hp2CbFWB9KQAuIc1AI2BwhjBpIeLaEpTpiOZ7EM2nUyKkxVYQZnHChpzPeT65slIXpkRKtZGMISGYE8fUwxmBRl3VCeTzC+bHaYUCOW3BmdPsbu+klZY0LbI3TXfqrThI5c/lurjK4O3FPRtoS2wF2rIsB6stLJBmdwsL71gbmJbq8VqmbmNk3t6/j6vEwqpXsCLJXeLSP29mjaxl7NaA9Zd6tjEK+N//Ooq6CAAABzvm0wgkIScghtX2myKzjoZY3Q0fgdRwq5mew/CpFi7uuV2dCoveS9sN4iDYbZn03SfwaYWGKeMHrjB7nABRFEgnw5TDxoOtSVg5iaFjicFEkjjjiRUYDYUOB8RWFySQ8Mp1AMhL48aRY0p00Vsead3I9KHPVS6OsXVXXwrVfEpNzJE0k83zL/DyrdfE002sfpe8xHb00i3NTE8E8HMfctx6m5+squ307H2gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACV2LygObe3Klz3nESwhuZU4vKA5vDcKpwucQ/C251NOEnUnOlMXPQBr/DAEZB9Bg8WDwVloYCXngRL1dgcFAYKMtnRYlX2gEQFFUbNPCC95fxDumIZiRDw4oO1haDuOEkUn4hMABSasYGCADXGePNEY8m6FQAUMkfxwFEgduzdFUrKirovoYOAQGg4/jXp4m2FKSv4yuZoRbYInBxPMRYBdlHF2rl0p3r1TygTrRhXx5mG67uYytSLC1INehI5lhQw+AQaiJ8f5ooay333iqZ2ecsDKhhoI4v6WSKkiuzrPVWSNuVXLGleK2Kr5l2tvnFxqw5gd5Cxps1HVDAyZfsufqCzQ5tq+zZPqal9ZVuHbEroapVFXU76mpoTSre43kiRGm0Wls0riPHjN7jE8LelfM++Y7hG3M+mtakGXVnKBBgwN23mTF9xR7IAAAAst0Tz0TIBbw+9T2aa1hKX4FBt/KbUYaMJlvSKvSRict40WV/lS9NMtn8aDXPoGHxJf+Fje+ZZb7AdB31+JoBySiXUBemvgZ1clQlBFhGLdnVNbns3/MXUUCMkqzLMa3tF3YrEx8ysXOxqGRaLEPCb3cJSx9Q0zbfWibc3E9+1q6xFNajHRaXi6S6mJrt3iP+eI6lShw4Sy8I2kQKrkyNdVFGqfUFxltS04KGxf0wQFwDhDbq1CoOUpYckrKZhmJc1DiYsun1SAKVFp2H2BR+mI4rdJCIA8I2VzJwv4nKmav8kAE3lggKSGLkoQAJvPVGosz4MLR0qUFXWYqBBA5Ajc1VYMfeWEwzBFlhaxHRduJ15ejqrHPSChqZ8bJLJ3OnlUB0tfN2njgmW8i1gqkl9HNT+GtdqOpm1bKHlkz9y1azpadFblM2W9y7NdsWI3hHsabCXsrYpHq7ku3WgeJQ23Z+49A2cdilHPy/l2ZlFqWxitcoq+sZXnqnvyW3Yo8bupXXyu43+yi5NxrDUvxx/578q+dFMcs0O6XeefLuVLLJdjT2eU/5a1urlqrMdtUu4xvdq1ZtUljLDlHnc5reWf4zE3zLn81+XO2e12mAAAB95vfdJt2LIPT/Wf3r5U5yi41eNyjCSEx4vY1ddp96O5ezy1Bc/m6TH5+PUlrl1d0FNXgiBZfzLWOqzDN1posYydIdtf/A+vvdK/U0d6aQkjtrqP/Sz0SU389koSPV3113PVbNx5Zam3xVN5qdFF6VPdP/D/m4m4iO75dHbqZVzVzEcNjbfzd2zfuhqG/6vpu6/juZjt9bZ2PfV3vnuuo2qQyLRiiLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmai0qDu3tymLFp62XlbiT2KyoO8e3KqsUnEaehudYRi4gEX2DAOZICgDYAYLg0dBkcYAguSAMnu9k9DKIi101RGLG0r51xsFwdfCXY0ql9FVU7Hke4xtWODaQUnjISKgwGBYmkqgOLXF9hgBDh4woGQ1aG4K9igqHAZJlaa9n4JhRWRdLlOKq8II3ukjIzpDlFzNNDkOGApFtUKZhRjkPtCDLIQA7jsZ3w6C2DfIEXVRGKTcyAYarblmDeFBUakUtTKftRdFuWPvLgyiAtTeeqHYg6Ui+xPY7XD7g1HO4nCwnJMeCqSk5qP2uJ5E9O0src7oxTPmSO4uTJDYbMrkwXaHUJXRolVqrc4QGZZhQ6R3KSG1wm2RwjoYo2DEqrc1fSekR42ZzvbxGUjQ58azhvo3bw92rIsz+rg+x9a3p57e2cRMaveSWHmLiWtry7m2RyCAAAAA/jvPPKzb5i0w6Cm8t4Z1vvNn8U557gnQTC8+dwUW3PNUiaiXq2NKueOPxgpTAQR3xbqO8817ltpe0TOzIGr3IQJUZB0is6HRRdAGfb4rFToEHyNGB1RN2q7a05ZN1v6KzHOyvpebU7FsRj2ZFshFtJKR3acw0OTiCnSS7HrmXP9yN0bVzVVX0JeXNetJiI5yVY0eu489alCvmTIeiwIqDGAIKFUaTUSdzT0YxECSDKDDnxJ9nXf4Ggkx4MTkRLKBOiqOhsSBrtO60tqTXC5phoXmlQGBhIjhALKFvJVMOc9gquS+Ji4GKsgd5AcEBwDNdYwX7dpcwODwKEiLMvRmFQM2sVjkxmK4OYnCiFKWdsTM5VuORHMd0+yqs6UlmOTVO3dQnArWGNbc1oWVIWs7Rd0q26PK8c7jCDdYlKk3PUJzc25lXonY1c+Jwjo7GrlU/U0I22RDHz7SNZYCrwzx2eFiA3YhUmkaWuBJFiNCssjFErYkeatpnja7T9/amWV3feJG2kO61GdUfZbITZXHeNjayvH+nO171iMuFPO8lswwPmWNZ+9sy4pW8Zz1mNn3hW1B8m65r/qkJbCkgAAAaz+7ncmKPCJMMNXBguf3rX9kijw8hFSKxgFYyP4lH7aJKBkOOStVuLIpmZQtxJHl4RYw1oSKW4uURm9XEcWNTIogmJgj9/UCHVXHcd7PCiTEt1HX8n51Lf/w4WVyuFSPqouShox5ofL7U6+db13x1X/rESz7aWvfWNiXz4eniIrnPhiqRVmJl7Z5qLHw7UlavTcqjJOyTF9rtFa3V2o1SLh7tDnTPhgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJWYtKg7vDcqtwudRTC27l2jMqDu8Nwlijp5D8NXHd/tI8zwrCus8bEQaBBjIQ53+T4QCzF2PO/qXNik6VAoJGk3BqpOnuFgkSnx4Gd6BpM+sgAguaRlhRbQOQTrNSXU4WpBUjTBXym6EKECK4S1L7BwSztLakbmmqVAkxoGYg3IDDsAvYzl98rdEzFdZULH41nW1YrONKXZi1FcciK26sjdedn6uO15T81Uvc1U7BTTKrlTN5aFPTWblJNt0WH3KYlC6WZmc/opuclsqj1SIxOHIRbqW43B7pOpFZPjVtVYek05cnuSakmb9ftevUsVdSKkp8IJrSq3uvTX/wyzra32gj2FHFb/a1fudPSzUTnZNlQWdb+i5Wm7kYvSKIz1rPCvW5yhx3dprW7lWml+tZV9369WpjX5zWr+st1tRnOl+thhlbt/SXoSSAAAAvU6y6p0iDAGLwLMz78/eqj4xTBQWenoWgrAt3HDfONKEnz9qnosbGt53KBSykrwUz6kf6X3dXYChunlTHcst8UgecBEtt/hvFdNuOlpijXZ1b/7i87ygyOLgxOSlfe2o4ffVn2rNup7qIZGymKzMVLLfxf0/Ut3fy2fv4fMtbHV/XcW9kQ7p03zDl4n3bdlsffMR06rqEe6nh1v4bM01bWs9ZUVUDem3V5M0ctTMZMu1UpgSGRiCVZyOshgcDrSy2bdIq1uA40g0IQSCDhYYFHhgwQCSJYq9IVGVkx8KhJgJWa/wGbnZcgiD4CWYlCigppEk72sKPGHi4cBhhUoeNDDX1L4y1GJLcQnIB76NSUcMyufh2UxN95WPBXvEbURjNfadr9Vp2U2a/LVv3EkFNnWpll652fq6rYV4bzmcsnngTuVy/cyHpU152q8Yj+NW3V+SWoIwxa9p6WGSpsNWPU8GzNnnI7AtWVxT5XSV7ViniEdxrcwxtYzdqtJZJBGUohiRbo6OarY00tpaetA+MOYXasx83jKK9m7bq8prFrmG8Y3asyGnmp+XY6pKX7V3C1VlN69Kfp7E9bl/yvufLu9/a13PCzn3l/8O5VL/aSjqdvVKWrqogAAAZzrOM1tWVuG6FEQnuOv/LsSjTgxCbjqSc9nzfK1+ceFEefwlX91pBIajYOAwEpFgsdCpRmgmsiGgw5gktrWWFCnbzT7upqa2Wfvu/0Jm9PupZqHAyWmpGqpBJknNEFGvtxM/ywzH82rjP4/QY6+lJnpaaI7VchJHRoc/+lIMljWBBj6AzHD2L1GIYNm6Abai332AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACVGMSoObw3Cfb3nuUe1uZJIhKA7t7cp5MWeRnDW53llT0rPXld5xWGqSMdJU6xxzMoLZYLCcibvHn/d5wFAEGhUNDoiBxLdIgRdbxz7YGFpuCxUYacHB+xwhUpqkzJIu7rQX9U6cJh5AOmLhAQWJToEgIBO2t19WcpDPO8JgQCDhSOwPKHltQJZxtDJHdZZGM6G3dS0p+Z2cH2pKtJSP/bnsIrTsMnZdZns9/qSwq/BlScc2iv2K0pqMbXtSRyPWamMYu17Ezu/uITkRflxndopC58MPo9kZe+Xxeng6nzp8rd6zCZTQRCznSVrVWvXoInfmHJty2G5ZLs6mdLl9XHK7YvcypezGss71jvZ7Uh3O4XpqfnLuGVyc5E5RU1R1cbNWtZz5hnl2mo7Fmxnav3ZvCm3L8Odq3bFbPWV2vu1Z5rfN5/vt3sORgAAAAAAALUyValUVCzQQoxb//l14aYHGJizl8Dmxb/OZtvh3R8MO40lMtseAxTGOZjo3sbxuutWT2fVFS10g6P+bstVbJ3XTUtBNGpGvzWg60feTh2qU2pF6NBT0kjM4pqS2vXWnTdKkyO7s3zFOgtJlVaX1rRqSe1mVdKydSqKC9FTqUmy0Ek10aTLQuicdSJqeZ91uQnGUftcshUu0ONNKJC/VLGGvBYCTBcPDDSnDFsKEhS/TJIo9rtO3RJvFgKRnDFoKnowWkQPKZuXSJHZH4QBCsZC6HlJqNyfCFbDGOv45aHy6aqRpiyWsG7a4TBQZ5L+TeKWwh5U62SNoyeUQ15JLTHwN6ExpnDTY7JedNXqxCL8dSoUkAzlw5PEHQTZpesrI8cokKWK9P5kgj/i1qy4U59CUe4XaBX1lEQ3Jqb4rIrDnnPBWC3pGZT0jKmWA3sTtqmUOVcXRTuMZvhR9ObhhtzAesUiPaT8ViXGa6ScRhaqNiGOS+1t22ZXIutIF3jfpfjxtxIt8r7DNHrSG4LUJsQmNZzao2p5lZAj0b2vrLna+qRYzW4Ujaix4s+cSP649MqSJGfxoz14S4iF77CAAAGv/f7yx7WlL4GNQ41Lrn75vKmdSfjbCiZEHZWNVcspLKcU+8rmWGuduxeksP+/kFQiX2cst6/nXZp9e6FJcLua39tT1M69F1JzB62RS5+vN3atFzIV0lKTSfZ01MyrnUmQSWp3aiy1s60E0lXdaWqitRmkt1z9lJvd+lW59DLP/adaBNOJdOzkDBF1V59bnBs3fTpb3d4pl+nbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB/GGyyN7e3bPb5mkUw9u2lnfMI1ljcwHQyWRvGG5IAAAAG6n42o9MyyhlL+iQYceaAsEWetS3EJqxLncTmchS0y4RCgOPd7nvvOwizAT7R9MUwsmO1Em6LnlE3AkimGlwmNtgEQGAhRKtmhf2AZmU/Wgl/G4sSTwu4K2Kyaw+LjVkX575sRvfvCwpY1XCdO6xHfQRozbz/HpjMfkxjVOWFEv5IB7D9p3O0VTZZN+LOyw1Crpmbx47pzcNs+Y+rurVbJHpzNdFzt5XXrE9J4T6GrEL6FIaeLEwq7c0FbcIdFe1Rlptf2c9QYT2sSPNaM8hqOu3mIGXOkBigvoe6Ug7kpD3Hgb1ubG3uaXr7Vx853q2LV+s/VsXmxzoy6kAAAAFUVzlJaCggAgc0sDCRE72et3ZivKWLuO6TWg6tmk7ducoJ+XQWVQZ09mVa1elMKxrvW2Omaiz/O5+Vemr4IHQPy9v6zTigzS+Pnr39t+HE3/eDnbNWP/auLe3x2DVGSfWrXgpk8pcwtvawq0gX92ZjzChNcXe8XrrOPEtTNNWtfEttemcV1rdYrYrXd9Mz6Hq1od4l75tmJRv0+jZ9tVrPNDeXiQJcqe0sCA3NdFMrdVrV94tH2X0tt1Zq1fW3Wk1SvFpaUpb7whvcZwQAAAB9fHe9YdxpXqKoEykMI2utQ02eu4w5NsYeowQBAcAEmgUtepWhmBKN+CEUbNfmnnaaC7tWGZm7H3iEmVFXJSMh6llPMcMq0Sk1ivLME1sCz0MMS2eDh6dmkFI/qcUi7cCTfm2fvZSw5LbW/Z57SEH9mF0eRuyyto8qgQRqL5Ebp5808tlc/evWz2YPbode0z3vT05ejJiPRuuVGRfce1oxHaMyPV0dYl3vY9OxQfWT7dUxl5+brr1nHmKQs5tP/M/N/Gb8N1qK/R3pPbp9fmowAAAB++Z63e7Vxl6CE36rQxmqW5ubqyiNwCjBLUM5GRhb95oput8EynBsYWS/rKpDSU9nJjDNqSRuyjdE0YU+Ye3E+xDsFKdKwUef//ZVjkHG5T3d48zdPL/y7S52Kt+Y+foZz5TjS5W9/+s53F/7kw4XMvv3Kyj6ll6S1bF2tlq12rutVuRlrzWaarjTfcxs2ccMLVWxcryizL71aVffx/9byxrYy6hezLcVvWPdqmnGvRWaj0tpr8SlsZuySKyqappt+Yal8OTlM+z7wKym5O00AtgtzUbmKOtPQ9nU7ytnKsa1HUpdVLU/jTfTY8t43s7eu446/DP+a/Oz6XFMVVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAZocMoDWXtxDc/JAHM6bls5xSyM4e3D0L0k0a1hud3P3yrUw7bjBbMsY0vYrLvnrVJI70uZqwkHImSIdE8RZ3c7dyafJ6igjH1NpqplGqT2NUGElS0M0NKV3kJSQEvfSfu3MHwafDt/WZMRqtgO9wTuHK8SO/WH+MVXdINnyL1WDWhTxsNs28202Z2K7A2hLnm9YcBFkezohqrNSsV+5wmCKyPZXOybmtW1YlbW3LnE97NT7cFlvG3//8bzmNGaorfWFHzT5hPouKPr1i0g1/1nNbfXr41dZxbG7f7bnLJ5pkDBkqqtNr0+lBne9cy3FpbKn2IQaMjIxxGjH4ATp1S2IjJIEedaRKGicFUiYg0W0zJxlFp44otJhqKIyGbaztIqw9PTcOukQiNOeypBYTqSniTJMERHcZw/zYZqZSLMcefqY48qyXGdBzmExvT7Tm6yKk9vPfZ6ezscdnduDVx3E3LUq5MYX6uMTefrmXYYgR8t8r3pdAomJuZOPOwPV5Vp8IxVj+NeNtica3Zs1sdYbxu0s1Wu/F8ICcqFRmdldfLGzezzsd3q5Av/qcr1ZmKxhlUXh2ZlVyXZ3JqxXltf7kzM3pdS1Mcq9HUpcNWKWQVr9avVistr43Md9zpaaMzNigy7l2zQal83KrXLXCjx1jfXhev2v1A5gAABu/DEZLyEIogWM91cj6MDEAJpbQ0/67GlrwTIZ6yhPdYiR5aRZ69SkcFWo1jFZfMtkljAnHdyMxJsccpaNwNPzfyGBQXgVT0vZ6lrW6sutw7hjuRtVijWxJEGgFo5UUVJzKIzUwp1xDUE9HNwYoEGA2q4kL217zuo7pXM0Uvz+xheBLLScs16Zu+n0tMbkrAxTFqQaPM4xvMXdn8mc4pa2873bF/rWbaziHTLE9vF+tb/tE+LV+ta3r23SuM/Ofm2dZxn6/tS8LMUVYQEZ5YqzS6Krp+ylEIAAAfbxv6rSizSUjRSoCOHCEnj9w5K4Ypq8cmH0aNPP/KTmAnva0zf6LNnNtlqsocNnFHJ2P3881FJBJrLMgxmKkxYCFBDT82BS2DLkrbgAk0b1V+pGYKgOCxp0MwxL6s9FYHXtFY9JZ6hgjL5Zdr/hyHLbv3rV3POUVZRN36Setdi0Iz7zCG1pJ01K778mK89dq0temjcotSylhyVZc3rDv/h+FPrc1WptZ87+tYb79bDD/xlc1dqcq9xtVc+xvLLPlS5U/6v65zG/lredzeWre86LG3re+fnh3WOWN/d+rvX65+se3CDKNw6DTK7+/9Oe9gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAGmGtMpT3gAPSvOUSs4ABf5kE+GSeAAy1IKBMUoAAhAAAAarajdhji6d1L4YA/EMLYchyO8PJFIhqEsI9i+EMQxDFZEV6jfsDUiEUoW9Xs7OqMHArIhbAVJ3s5kI9Rsb/e4b9xy8ViseTZfqxXuqqc/0PV9zcZ1en0PUbPPZ+/XL9jV51oeomB5qOxq9Xq9ncMNr9Xn+r1ezskCjajYb+IyK9Xoeo2feGBgf1rmkXN47xgZHlMw3795E1//Sl7v49739GNPoeo1Go2efdb4pSlKU3v/VNZvSmv6fN6axiA8eAgD4PvAP6cBg+D4P4IKZ+TKAAAAGt5fWr6tzszPiQAWjDkZFO4ct2qTNdzJcoWM3NKWnw/LaOgtt9t8nyeV4nTpb9/Gu8TqcpqEuQKLkCw9iw8cgjtTsBFBLla9+denjbsGILX5XM5Va0qaznK5fT256iqWs+U8rzj8jgGBLFyfm6eV089DmFNcrtHxv28tYP4XTYm77h268rf+G5+Xy+3Wl7/xeeqRSMUmH1JRGIchiWWNaqSzXM5fT50lixzOVw2/7/v5DkYscscr28K9uV545dyrxuN9udz5ynr6w3Xr0+q/2LH26fDn/zDfdTGGe+527ev+pSXsf1SVMB0c/9KABin8EGRxAgCikXxQA5g9jNB/S+YgKkLiJhSy1p5VQVaLkHIW8wi6DiNgtHECmTUI2Jc8j2JCcMdTqZbJ6tn+3t65F1F3Lcoma6Frq5PzoIWPOKU8BC20/U+ULKeTg9cY7wXNPDoMYRwdAtqnkH0NkV2Gy2cWWbDomwQwXhYioViYHoHQe6Gti7ZEUi2Ag2MOUrLBo9azqDkPAgg/Ih+Nl2CGpaF+lsorQld7QI8TTXvG9Y5zuCnXc625Q92h728rvFvuFvNmKsK1YWPjPvWvpFt7Z2wTR1A9fsj+PqmaXj1f7vSa+//43hMVLeS2cW9t1x6/Nfb//OPbNfr/7/+//////yoQAAAAAAFWTsp5GovjED7gqOAsNMeRyoehbJzAPmCQCow1znHxhCNR450ZkQUpGosCAEgiJCYXB0UOLYmOeIouM2HpUFJovFY4qF0TEotyyCoPCMkNGw9FUuQGIh5EcXIBwdFw8FsKwmFR6gzIywXYYj844+KoiThFguhTioFINhYFhyAw8wlKiKHo9c005TiBTZ7NmTEQmMc8saqMYsfTnQmOsS71azqhxzoaqNUxsxTGW7FzGpPPV/mnHO5xEv5x2v3+Yk6/u/6fwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACZiQToZSYAC/MgowxqgAIwX5MB2cAAq/N2eTnvACLpdFYAwBEUMA0bIqDAAHNagcMSBkCwDVwFhpOAehkBqUIGTOA2QQAh4YiAt0OUCyMgwg0yAeQAGQCkQsjEIw4Ag4lIc0d4BjgEoCYwNEAv8IRBioR6MmZjUIaUASIAcMDYAA4gGUYECgSQFi4AJhBMdRsViyO82DkBOg0hcgj0WUKUHkpG4yRmbFxkjZAuEyJtFCDHjGi+FrK5FiGrICUi2VTZAum63ImWhjRGAucckihPl4ih4zWXC4WzU6bE+X0zY2RPouhoMdJguEHIuK4K3GRFeL5DCmOAhiZGkOWixcqUxfUyaZUProEaQ0dA6yNGYGXLo5gz5VRK5gxMGKzI8OeO8xPlyWEllJdG6VbKq1/pv+eNy4bpJInETVNNNnSRSSZSn8+pFFTGKZofqXftTVb61DSozUaBIxKzUfiRNAigcspk5lUTCI8ZVC6FYWRkDSY6OeJALQXIUBwuH4iB+oti24LwXYGAwBfC5EEFGSFiMndypwgArFRUEonHxyKMTKsuYPCUbMQkRCpc1Jx6WOPsY49EERj0XEc484hKHHGmlCNzDkVZjaHTB+SFiYcLD4mNLu5zucymZkxkQ01OSj0Vh6PRcMyMeCLLlhbHxKYZkJNmHmIrLcynp//+4rGnmMqupqXNfaqfnno+89zv///eqqZp2oikpAiELaGtOdMRxujW4UAMgALBAAxLZab6qCMuX1AiZimqPIn9825o3oA0ey0YCGCplxA1ifC+H8iEYWEhhZ6v2DpRqmL5KOqKLAOio497qVoi+zDJOu+AHUdiBHkfy518WlyeftZxhnD+SSWWJy+87jvvuRP/Bb/40EkdhwGXuu77W9xCWQ5DFuTcprMRlc5Odke92781KJiA4Lp4tUlEQj1+TzliHIrAk1ajdNNfKOyy1VkdJMUlaVYxOvLqL8Ks/PZ27eU3T9hqPxmLQG21F3Wr/Y5Ndqy+fxlkUlkYr16/Lk1nVy3ruNntjWWdLu/XpZqUXfne5Wd58z/HeN+3v+6/e7+edvOzHS+uQvzo23tYgAAAAfO7rlaNhGn8gEewjlYCvVrXPExqSVy66YyaoTLjGKPFxGb4O48SnhTPXzY4OKMlWmFviRr5gtcqNg11TPtjKYkpSmr3m1nN7/VI+94+NUmvnO8UxTVMVpXXxildyOs4p42a4fXpu1rVkjatu3/+N4391+LV1j3znPrnNtesWl6waa3/Xeq6r97jb3669cWra2o2cbzEnl1q29SAUGg6dPkQ3SPGNH7CLZFl3oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgxgcuDOHtyqC4ZsD3rbmLmJSIN6e3K475mEYw1uPl8aTQSZLlgLUoEBASlSRxndmMwoRBroLDCMUELuVVWFh1N1WNuqeBvAGCLPFpkHlBlRQ+xALpZI3084zJmVt7FmusNTpZqwFL1b6yWgRC9ZziUKjzFn2eiMv7LFeqbQXTM1NrKyn7AkLkXVUrpDoy6WlCoS3TwVcpUJOE5S26qW1UoaaI9KphNusMKlN1CVawsU9WAeGcRa1gqEvqGoS4uNsw0SpZ7bVyurGYmZRPmGLKzM1++jXgUYlEop61bUNVsZ9PJDq2YisVptYqs5jSuUKG9VtazVeuM2fG3XbbrWKUiQZ8+8O9ry1x7b1rH+9U9dZrCjWtfPzW1rWhRrDVOBSb4Q0b85TG3aEVUrfIpx4x6Qttr99Cc26BHhDTCToa2qV7BOVWwEdTcseC2wrdsR0CZsOO63aPWHBiw6NZ54Yn0+65Ctp2HbnIQlbaa2Jk601NW0SmotRNZbW9xdot8ptGB6HfD4aela3NOsaxx+Hmsy24uJ52dzMbtqTuLbU92kobRERVU2HnjijY4i4c10/dwxh9dmcmVz5oogaQxpw51cP7G7WhUeQETf/6qXoZGQ58CoLoWuugqOErLAAVnlCQKGEc1BVdPoyV/m+iLciwLDgC6DAkjnCUmkhX9aNA7Xm6Egowg6WteQRodHfX7C3CvQw8aFzjR0BbCAmvJAe/kSlrussEQxnSaYGouzUd7K5mT0ZtO+BRcRm92yqZ/SNFiqFTJ7SebKszs+9iuP54yBiWjVy4WOmI0xI8ZtVUF+NID6piZI08Wtsfp7bthUrYfp0HU8OyFCns6jq1IzPl2oYsx+xFcywlczR9sKlUL3Pivd6jIa4nMp4Y+SxM02ssSuOqGxoa2I6TLE15bvCjWn+z9Op+0PVmNa1/aNBgynayRXc9KR77gvJrbfVzmusb3B3qnxfVv9S1xXPtWT79dbgsMAAAADXOZy6HpuJ6gWCWkBmKPLVNWxq53t41JS3cRmsU1/L+0m4ZvTEbjFbC3WxmJG8+G3SpXml2eNS/XhnGq7FfmFjFF4Oh0Xrxxp1JKSU+U2ROOmO+iieaut1mKMuWqdFQejcurWkjRpO6J0kWMSxkVJr0q1JOp2U1JJ2o7qqrSMy6hMi8xxdajI6yJdRSTc0SqqSorUoxppJoLROHkDJaa1JIqWitkDI2SZloq2SRRonloUiBj2sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI6InIA5l7crBPGXA9625ksiseDecNwlI3ZhD3obmgi06lSYFARIBEvXDgdDCCioIDmArRgdpz2xuLBEVtS+ABUUm5XWqRCcTBNgzjcdkC1xkITFaY46sTS3kjM5Zg+AxwOA4bQ+NWERLp1l1W7utBUQaULItqIgxq+TuXXeZUW0UzHc6bmZ7CtASTep2hjdqpbPdKKu91CvkEuRR1Vkf2zZ7LmYeqqscFfHzEnXKHBB1XCVqobIryOkG1mN9CiDJ0fw4BbyWKWE9dLvwJ3yGLtesxzwiUt5uH+kG+Cj8w3zrcO64a1chppD9MY/j4NPEWiuLAha6TxNFezPmNSs9qPaxH9pdQH0JyiKdx1mTLhHeR2i6mU79mg1e0tJExWeRknZpd2relJ/SurazTcS8CmcQ2KHHmj+zq0iD4s3uCHL1k9FVoHQSX31mu7Uxtqgrs/wvUap4UHPXJRq7DfMk4kbMXlQn4GmAUlOEUd9NsXYFrPLjfH90MoCMyiY+B2Lxw22MmizPKPPGUupv/+ttd1v7JI8KbrRcdg6vTzRhuRCWNTT7O7pux6SNOlImvUmHthtxD4dMZucfZrfXCK+yDK/SWpjE3Pmvg6020qk0N+2tNHuV3HYc5PTiEUJtVw8wrM88jTnnVEJf//ualscuN/H1DHCZun0pSZihgP5a1DsKf6vcvRKPtjGPw4lU6fgUQgBWOtbpl1ovAD6CWF5KQScbitpgbOZqGyjGSP+vszagqeLBopNOhEDpaAg1etlQEQDQ3K5FF4hA8YnI2ARwPL4nV7j6PMrnJuta3qBIxVgSXU7wQbGUbZ2pGoxrK3ygi1dNWITb7RKlrUlukX2XqfNoraz8GUuNmvJI7K6doUcbBAqgz7ufcltNQzu4/SOhM3a8NwibfV56OAXUkj9UWF/ufbmNNJY470QXNNxiM3berd5iT+P7K10xiG6SnYbQVKv8/O529aywvyWXRmdpsLWeNn6kedHcJlWeW7Hx2rjhfhnOWy38/x+mz7lSzXd4Vt/lhvmOe5yQdr5cv73VsdcAABAH3i+HuK1zAChEgj/2/vvVoDnFTIt93t9Yu3GDPueis3WFrRnIbErCK9MGseF9SwWa2ISWxrV0fNyr73UOLf6ivMpfkPQdD5//n75mvrxgVWJtx8JCupAstB+KD0if+N7j/GzcpULXz89m7/ez0zirevrCjl49zLX3GQaU0yo5h8TwQnz2E2R1B+TWv1DY9/2XAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACMCGx4N6w3KqTslkPwtuXHHtJAxl7cusv+TQ/GG5ye65m2WxW92ogqiFuE4gZciH56epoAylVNLwUgoyUIIABiSqYzkRmQu1EC6gBMtTqpEJmwc3WBoNsOurKrHGY2uQ5RMUElCpY7D3/j4hHIpPNASqYGYyKZtSuBIFWdLsSiC4sIzam91Wbbywx/OhlDuzMvypqSAqdDpR9txW7qx2OSicadeisumrF7KrKknwwFlqsrh5/pivINzFqw/rtvoyROu2syBJmHqlahjNSrlWv5yyWWZlp8We29GYf+zum7VpKCrL4EqvnAkUW/Lsvr4amIyzeQ3KKJxbkZr0lv8c9Z4VLdq/VfmVXaf/7Tas25VWgKzYs57x3epbWVnDe6n5/vHv51dfrXM/325v6/77het4MERyvSQAAwBjFv95rvwSFgRHDfN4/rVrduejsBGoVNha1lg+sP1rsYxr9/vMIk4/cpt9FHHvX1COR2zds/Wpecxg4ibOPBSQ1Ov8R7+tznnm+dTP0QdfX7JmTu9On7tEQhOfPINOS5uy/caEs2HYTUbdXdtd7I4WkuPtpsOf//MLS6lalnfKS0tqbNGUhEQ2YPU3ZG8yPMfDDV6E9Pdfsv3ajamyB53Ge3E6jc/1sL9aYgmNQ7lTW09DdczHhV25hygxvcR0UEgVGZlRN6/T3Xrr7zRCAiEp+HKSltzrkxS/tga/7dFRhr8VJk1oMHnH0fRxLV1sJWXR3uuo8GTTUJlCjRXdodka05jau2woqombKx46zKW9m3Rb/zSFBurXXXUSu7bhnoETVvnd4ZKVtpsYJWhYgP19Pvo8C97udLwNXtJDuuITgo3cTVd+uf6U8zlEn7ko47v4y2OTBPZsvKwvIudQJpNah2fy+PpXpyL80eYYL3fnW+c6YieLuXe6Su4kd5f0tE7TRV+HjnEToAf0ghgIAY9G6HBzrNrgqQMKVxr/zr8+rKKd0SoE49aDlOWbd1rT61J1+bMQluFnVlGRzqblIxwgI40lZrUiFHa1KZpwrF7lLcr4fcKtpNu1nn+K+Nb//3n8/jhYprsP1HY3vef8/69q5NdtTeWsP3Vmkoq1WrXpLeW8LXa1q7Xi8dtyKni+F7LlS7q7lhjyd7HJdynzpKTHP/w7Y+3hK43d1+NJzK7fxiE5u5hhSSzdmvUr77ncltazR508Qrv5AcKt5zlNDsP15+MWLN65d7XqY4W5RSVqK1ZrUtHQXb9e3n3f6u6cWwXnsZ7/RgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjviEeDmntypw45hDcPbmUSKx4Ocw3CvLzlkZy1uaCmu3Im/bdnEtMIEIZNQ1sziEUZISriI0la9Ll8gk8Y+OsFUMCCEnqWLS23kjssgLnDZAwIBSxTKXpotOEYJ3YceIHMFSPm/yRptEgUQDy9o6a1deC03Di8EroMQEjP49Uqgl7KiRc1hiYo7U3PAcD61obgbDMX1top1bEV79ViwuNMrrPfd8l4h2QKR2FtpVTSCnBG4WBzFuixqLnNE8/JzkvxxGRAZDeSz5hmVsrM+vuPLIdSHHM/LbE0rUNzu72mJ4T5tbDSYxbS2D+uftHPOyDFMdLVQ7UJYXFMR1bCy91a71xcmJyhYcKq16rUOZm1h1dmYjuJy4YlVM0JmkriC6bnLEWa2a1vLWNDta9dXezWrWDBe0fRsZkGChshBAYAWy2XQWpIxBViav/f71v7OrN2cEvWs7HauTOIpjq/nd3ln+DdJB+61do0gl9nK3L88MZp5b3/vUsf1Ae4v/37Oc3/3THx/umI3ntr0///8P5+//8Q1VusGvxbf9o193tD1XW8f//4+PrdrZr8/Ndf/21jeoTlnNK6/9ruP1X/1+843a1rZriLXWofxJCexa61i25X2zRsVj8QVUF19sSX8/+HV5Xso7Kp0Qg9iSxQQATBIkPJcYx2MmgxCchqC2kPYjevAwCWx8tBgnQVQxMQhEeAkerQ4sov4YNLo9RAaEB4Etu26MypE0kTE0XVHjOq2AZStoQC0QiYoB6W65ygDsDFik4D+xhuZggHw1nHIpffRQutiWxgd/J+YlVFadeBaanv34fpaGdllI/EQmZRYR2k93OW0mFixrHB38+v9u/crfTPsRKkUANihyBq/yi321XpqNmEcl0FvvL83cmqG9TyLPT8Yd5Yl9PaqVJqthrPtTGtYvZ7x1Wn5dTu5lF7l69H5RFMbkk5Q3K89GMPqbyxysX7tJelExlu1U1hUu093PPV6pe3Xt6yyuco4A3u5ez1Sc7+dbDDeeuY/zurveXt5bx79fte32wxKIDAAA/Dnf3X1nYhsATkxWNvDv3c/3HFaKkujguRM1v7UyFQlIazkerOcopo3xBpoN3s2xZ0nMcTlmStc/v4Qud76bk1NR8AJA8kU+odq/M0brPrTrWSLVGu1B3Ljup9nUwnCK0Umq70JibmRLpGi0WSZaFadU3dMvp3po21WUnUz0E1pKVM0r9BBzBl0lzNTIOdTqQ00GP6LU0061I9etVc7Pm24CwHqEUCt7Xz6PAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJPYrIA5x7cqpuOZtrDW5l7isiDvHtypvA5pE8LbvVJrsuWQIggj3DCcZhYWHddIciCxQNjBQElxQAGf00hXzLgAKTnjMFiBPwCgiLztMlMALvaoFC+ccIgNDgyD4gXET5YOpvHy2zZTAxXBwjlcON1MShAVCDlGAANNVkvwwOKz24HbweHzTI/WKCOvHY9dAZlc9ng5iQy2EsorlbOswHrK3ym+/P4/Ywu7Y9ncosSHjMaA8htx7qVic55KEjFqdmc9Q1Lt7m2+t1SwVOsyms9CpiLzBSC4WOdaQblXEiMQ5lV+UlBqrkZd5i80Bjgw1Wcs9286WDt19XnTj1cNrN3SnZlhjivt5ZIFKvNzuUqlcXlY2Ltzft0nE5RkZcdgmkpAo3xnjCxsUR9HnrCliSuWp8xtQbQ8bix6derikRzmb70mzlJVAAAAAB1/8y1dv41XqMFCYZVy/n7/86ya9riwb/yivVxyxTIYpbn7GOXa2WWIyOQ28/V572u/dxwhmp+G3U3rV0FOdCnb8mG9nZe7oKOOkgVbP6s2W1dBWYFFRocMqbJ0NbKMJo5r9GyF71IsgpSziNBWqy3OpppJJpNqM02RdBJFA0qM2umkspoIIKc2UX3W1BS3OpqWYHuKcUyRpv8T2t0ma3Zh8f5PVkmLdLLptkRgEAheFAMCQIMFhDM0fBKo+mEYKF2XWQzjT1ugyFUIAABreRmBwOpyv9NRn0680HNdmTAgON1JULh9EJKluTnydQNLRYVggiDYQj1zzKHEmIhUDECsXvI+PQ0cMBjtvS7xhAAOzK4qxLxbR/F4fnK4RG9ClJLDRRrTOmaeS/LFMhSTOiZRSksq1xIDUwyRmGRtYnCr5Htt6/kBB+OlSZ6GuTE8Wl0kYK9EQhQp1Ii4EBcKs0ZCT3Z0IcZlYu1zddzRV9CokV8o4smK4fzajTYP4u0p5n0rL4i7ZVYp2o+EfMywiYvotcQt2ZnJkbG9Ww5UgcdLuLlnb6a2J0Iy2slHUeK51aW3Mr5R5c2KaZumYsuL9l3uDSHeHF1aC2SufiU28i0iSah2CC6YAAAAVtUWFqcnALrCpCX9/993Ym1kWMoqnlS58yu4P0HHfjk7cv8wnM9puvdn9xreMmm8reolvDc3M5fg6D6jHgZvr/ez6ZcXVz7at/1x8cbeY+v0rh6jqa2O6h9eoyDluNOIWf3DmUydnNHr7vv6V6ZbH38Q1yz9JvDzl31NW6IhrGtQqF6pF6JyImDY/V3wxreWpTshvT4d1MVPJ6Mb4ehBgs8JqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJTYrJA7x7cpvRactnCG5lji8oDu8Nym5EJ204obmgzt17tOLBLCXeTCGAVMYOzOVyTAwnJNNmd9iT4xabXunWZaXpsMUqjbMDgQNAWNu+zB5RYEiQKNA2ADSsHCMID7tsfWKFwDDkdYGqcwkJQEX1norA4HkIQRgmn/WEZexsqilcTlqMiIGrSjL9lwMhCzdJmN8IEsP3FXRFTKW8upgq909hx5MqxkiUnVkA0myaaBEjwZn+dMLGtrpsXczbAb4oaN0+rY8DSnVq3dvnizGGsocrSepo0noamCbqjPo6Iyca4apbmhvfwrYzI6zSDiPaE8b8v3jY2KdWJWTevC3VW30u3sXb+XNq0krtxP9wdKTObyNt23T9VxWPCGq982QqTOD+sCJl5aBh4w4aozHEw9f5zPNmZ5jWrbpijazwcxbwqxcadBWGyAAAAAjeGHN6vc7lMkHJELR6z5/9/fIcfKalCXGPMP1vBrIsTHLet8w1fglsLb9qulXk0oyxw3BUUs2XWxz0r2kHgDV1/zwn/88cH/Xp//LXyv3xAn4meIW/i2uUh1Sarj6eHe7qb+Yn7nb+pvmLtbjmLuJu3WI+X/e2dbqp+Ejl4mImU6q7rXqO5luLtETpEq5ft7ZvXiU5cf1ZXsM9RUOBVdzEQQApgKCxiJJZlylhgMEKOzEXCaHDEVqQ6lsATkzSUCDxDmLBMpeWJxZ62+BoWIVAHwJqomJBi50Ml2rUb5YVqqQy1UiTHQeFqBLBFASIgCgeB1GmKKmBCbHh4ASU5nH3HdpwIS7toVLA85M/9zkmn82ixDcNSyeqTtNKbNmr19dSi5Yyxv4by1EL1WLUc9ct1qtuN2rM3AUvk03Rv1hI4xnDcqkznQXWeCZeCZhDzSy69E7MxmXwRBVPYlco3TRKOWLVJnTVZf2P24ci9HIZXuvFMJfjXgPCjlEZiGUEdyw1vtrOfx12G5mpnhZ+pM5ZTteLRu5Vzpt9zq01mtljK6T63ZyrqJ3L0xYxy1qn7by7rXe6wqY1ZRhW72xdzqf+N7RW2gAAAASupNBaKrHwIPAHwSLt9JRTFQWTYpqFlKmYuYIOIPPszmKk1lwZ8QEQQFwmLJHlrXLxBDxqmmnbRKyBsf/17LaT9y1XER8VHHNa//Vd1fLKhbrUpUaSKX1apO7btovFH8siX988XI224sq3S6joZa8388G2U1dHdy1PGo8doopN8svrvzM+0kXdHs/+l8P1fLQW7RRVZvyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACYiMSiO8e3KkESneUehuaEohLg7t7cp9vKgtl5W7IAAAAG+TesV9q5ppTAqIxhgh500x4CK4UAKAI0uSkYpFasJEArMDDMzYDkURoNukqN/4MbmwQSCg0AjCpiOOiASOJfNtFNk8UqmTs8YShJd0EAkyOJ3DaYNBR1WaNZUgw+GmYCgDMKABGhq8ih4yjyL64HkcQSQfpTmjDSLa8ck8zKNwRSLZFerlQwQYLHTqSPtye0vSa1bNsaC4qRjhuDFJMjoKumLculEwUZEo3pOGWCGk3BwMBxZyfVfNRpk2iHk0p1ZdsKnOSG9kXR/1WN3vR08i9cJdpQtTItTQLu30tmiZw+ojqzNK2SwX0RmZW55ATMV9DPRts47ZKsa7Z3sSGhjnltcYseRueuUDe3Bmng0g1Y6PoD5zkiRd4tSfFZJ3B+xPZ9VewMWrqE/xiVSWZQAAAAAAAEUqzB0WqjpAQhGE2///jY9ihZ8i1ap9X1BbR8hCi8aiYh4jYbpW48ohXw5Wetp4XqxItxx64xpZgMmF/35SVioR9OFv7a//+Plaj7tOpNVJrft1lhxoo8pXOjpA89HhLXSBnXHr0TeiMvFfzEjLu+GXs16JJEeXeoJH8jOkRbeFhIiatGofcHqt620y60zxbxa3zbwTHwMHzmI86t53aennngaBIl9NNFAmEU8GSQmAAETLyEiFzDBoyULQ7GDAzBUf4dVaYmUrvMQFAwIBIaYaCpFIaS9VAEASLBhiqfcyGLBCFLOlKNwy6oFBV7o8CwChQZmDw0GAEeVI0tnaNjNH3d8ZACwEorJmK3gnz2AwRDTSYA7JeJIDULmqh6FgtidFvQoGwMwBfCNhUBhiKB0CRgJ5PgVBUg3yrDnNgcClIOXtOKhSKE+2pQNrfGhLaGPHN4hD1Xv1Sc7k3J0vZdDwTZyQaKglB4LtVxZIzcrD/OskCdVU+MmWdyELZz2V8VgdN89MS3uqz+PBhY1cXwWxOtNr6lb2JXqSPdjvLWO6knvduhSsTY3HQwsxzsESC8rDmW1gv6qdMj1gzdz8KHqPuBE7Pq0fFXeKRJfLHpa0O2YLylYc9Ir/G5sgGYGiRAAAAIa5+fcKmPdYwUFKGmULnaBHtAidjV0B4rNZzjX9I6GEZS990k+YVoDxtiw4mMatqmb6jKDWTvbCZyEajBxhM4gKKBzgcwAFAceICh2EziDKe2un13m7p2KQg1yJlYyMpmlbOgxXIt6pIdkIIMVc6So2tdXopVc7sguQ6mINMpDqw1RhKu4kXei0YxCsH4U+ZQPQ4ZNU1/U8/J1IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlmisuDm3typlEZ/mHmbmbWKy4O7e3KMD0oETeNuf5clcD7gNCU0pfK2kxTNdCNrDsEgIEAIYKqeMCCRIFSeAQU4xAAioCZIJggaGhRLYFBTUqOYUuXyjkOBaEozuYN3yzVQ1/kVkgnWdZVV6YohygkGBJhgAXQicchdhpi0lRLtUBTVLihAAmuxFhUKHHOW5UDdRKscmdGEqQK0Zp9Kgcw3kPNEnohrMjl2cq4PJOuSdP1dGk+vFkhtTtSvMw3uou1Upla1O1pWwqzOnJgQ2OfyvRysN1CS3NrimpVOxsDigGuA0Xetr2M8XStZYzI2OLNWZyb4kNfSky4Ux6bQCvUbhZ62w9PWeFuOup3LV4VMRKXbnkKVenjP3lLsDBl1LBk1BmbfC2/tG06hwcx4UvvDpSNd5qPiBrULy5ljatuHWNuWSBNrN8w1ZaAlAAAAAAAAy7+88JDZz1WeEjMUYtZgwde1MtU5hQnsK29Yz3F63I4PT22H3tj2uxMZlzxIlLb/3Fjxkyz+tzTgJy8f7lR5+vZHvDOjmv23K3zPeNn/zu5Wy+Vu+Ym2ijrp+vJ+TqV5tylszPc1n95kt7rEXdvt9ngqI5f/73m1veeuVc53L/3drvtS71uO0y23Lshmyjin83v7tE/ab4+58/78oCY1Uq2nhjjqw84rLWLLdEROHF4ymD4OlgCaLKrLWdvfASVLME9zEi8WA/jUCreXAuOGV3o5KUFYWYSRH2hRMcl72pJjoC3TmuZ+phRERGYuBvHSJqMdfZdkPv+7siWcW6ACy9D/EMOU7WYl9T7iPkgPg2xJBwj/HeXYNQTNCkNL0CoJCDnFrBMC0IeIYTEG+cYwE0+WVqPFYnjUiSXnOuHbemx6JW8cZKIiCRl0qi7kHJASWKDMEwN8yx3D0IaXM2hVpwuyVCBuJ2E0aDTgqdWJ9TLggjdLAV8ZdqRvVh/JWVrW2BqOVmZ6s0OVxfMLHs64SoTzihc0Nwa46cuyMF3zS4n+3R2JQzv2u92J4uWh+7iudL+8K7ArMPK1pBxBdPZ60u6rCxEzJT4eY+4PbNfFdv4eNweMGeIgAABa3Zl0q1LA6HDL5bgb1b634bjlVRtVzvX1mu28AlBUHg34/kr9zrRmoxwr7bpnHziaCKRu0Of8ItKbINr1A/IX26f55///C91jhOHKxA2TBjhMhjLCO1nhnLZmIzkl8/k27+bZJwmv/nGKUjCf0iDRjnIT5QssvR+zfpjvrTF830fH5vtXyc0uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJgIrLA7t7cKEvOfRl5m5j0i0yDuntwrjAaBGXmbndyPRPOxSRpykqm5kgCA0TzR6UTachSwINXiD+0DbO/GWyKVq2JEmPgD7Siaf2y9qYqzWLlvlGwoQmfWJ91MZgXIUs7SHcloNluUXe8gB2fiAKMnCS38Mqkutli0sZc+7BZ1ShUAN6nYlOQWIsvVSrVaVRLSqL8Xq6NPgyqq5UrosRngpSsIMSZcC3FcnSwt0+HzCiWaVMPmNherUFDXRXUVKAcYrWqjeQ5kshKvMVxOwwm1jnOZiQtFomA0okuJ0xHirh2UlXKCkmWWPt0oYuHmoTkxqXTGbzXCORSMETaqw/XafuxwnjHCva8V7BesCsmhHYeyUa6woytd2euS7c2Zba0YoHB6xMSsRkeeMyw0PbYW9U0pIEdzhx4bJh5rWcxHUSlIkjV61d5lhwouFJmYAAAH8xp7Pe4/+LdhHce1g8Az0vuu8fMk6Oli4+N63XfOqAOwI6edd3pFxmKmmFXEpUDx9uff3SFfogFZesCf/+qz68y/rHadnp62/vj9v8ftry314qr97Dze3ffaJ74b481W5e78ZceHv79/zy95FfW7d4x8d4aHeX+PXrLTQLtOq+1D27QGIMuu95vjaqoqEMzB9eNuPcuMRMwlsAQhX9JDFjsostPdODk9E6TBIZDCU1zikQTYg0aGJq3wAwxHx5VtAYAgMYYoQZEmHC09EUGsITDCEE2EJDmtLVtQLEMI0v03Y9cxdtrSy0i2fM0XOhzdZU6pTBBlprjEASlAoFYZPNmDaPS4thuDsR6fOqVVuLWcaISqcXajQbif5O02uFweBzqJSHuXNVuZfC4LF8PS/lzUbIpDoQzMW1VehmoDpsbE44xF1uJP4zBhMRX6iVR5tmXiacGaAiFh9NFVjVSbDA2xj8dNkKFTdYysmpBnc4p0rlOm6zJa7d9sWITdCjx76i1fVmrm/qrm5tpGfSarnU1HCDqG4qGvj6i5pRujPKZ1My4iT4pn6pumNVvPNuWB/qBA1bdq3pj0nmxDEAAAP1reGsc9/h4jONVEJEh1vekCn08qws9sPIlICorEit65NJJA/kZiPI27xhTz4vlfT624NrPAuwTOZhBFFbk8bLKIZhMm1p6QRMc/JP19Qwu3PB09yIe955NCDDMz10YUZENZb0Z9fMfI/t6o/O7NcZeT4h2h4d4h2Kb4m21COKl5bb5se2/Ta23X82zsdvdtHbkNOY9vO1O8x4vfjuzvv1DkqZY5zNTfib7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACb6GTYOae3KyqupMYYluJvYrMA717cpaNihRh425+ehxfsTVUBgHLR0TZBgFQkwGADERvP0Tw0DQ2AkxIEqFTGmE+DKkzFHk7wFKA1Qw681xk0JcQvmvgpGCCSBNQYyRVXQMBqEGBDAYlLDHCQBEKBxf4DFxIyrIAgQEGqZF0BYW3MVECMCogyoehGOLlzAw8KiiIOVik3oYRgb6tTw6RjnI/K4WkgwsRbVWHKoU8CfdHiDmQA8ghYaImSGi4n4hSZBsISKSYiqE1N1sfItiL+epwmuWA/V336HQ5rw1BKllZNGa40ji+vhFyHYoUSpm1kUKqZ3Ha4VLDbTxPMaGxltWxorMzQawnJrcnrAmFXD3RdqvLE3NcKE8cZnrZnbzd7ea9MUeVfOUSOuJost4ubWmjeBAq9hW3mu5b3ppyzmLb2k+qSbvbWtf5rats6hv4GG0yvQ/QgAAAACwn1JXnhXzww7T5PAQpFwxJzhCcVmDJ1EV0I3Kll0T6509bdcOj4zKoHRemO3GC0avicv4+JpyKl4inRsISVa+PoU2G/NZQuQGkYsZQiZZVAIuhiSqPZZa/oQmeThFgRTZIAqyOg2JAdUUQtIdPI4J+VvuWKrf6rGtjBn+OP+VG5azjSd3jU4symzO1DYwqUYUPExd4LIQgSgI8Sa8NBAexCUEjjux/cCPQZtS8tqwqtD6HYdAAFAGlw4osBg8ASTwKAEYEo1R3w5MKQiGURgOXbZcIwGSDXQ3xf9iojA8wtCAWA8wOFsLgIhmsxrS6VXqZsrrJqMzL1ssGAMMLRiMGwCktG8TRA4BnCQWQBI2yZgqECK5EBJgSCKD6qyHVuT+sOHpAgnUpTpfn0XEWpgZ4L2I3J4lyiFtLyd6tISZJsgOouKGvWUziTRFpxiNyiirJKUOLk7LYq5VApldAjxWFlh1RqiVDtXQYdmWGxwWxNppZjP3isWEdJMpWBTt14LfdXNzkdT6E8j0iOGXCLjdVC2v2+yNvZ6/fO2tGUjQoCuiQFY8b3cWBWsaGwxVbvVIckWLDkheMotu5b0a4z5vhruslYcVsit9nk2oeM4r48l9TU1e8empb47jA8CJLEgUpPHgEeCCAABr98q0tvKvbzqNKf4SOE38NuL3oxR6Wo2JgxHWIuO+w9u3Vhq4hRLHu8xYjjSPaFGzMql6aC+i2jHSSmazJl2ZVrBgIw4WNuonY5eZRSZmsY24ZYoyrdJae6kzGRfMpgvM9MX5bdfrz6ZL+VqEw/5hpu/W6ZhoeZuxMYil6efbQ1yEhFxDqAqi2v262BvIk5X3mbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlxjEuDnXtymS/6BEMFbmTSJy4Nde3KbsSoONyNudZUDXGnRRyW7x1uiIyvUoTAgTMhyw4Zu8zfBcHAgqQCgiBgmXVLJG6MjUWEgAeocA8xSNsyJC0mAuNTAKAFhqVcaaSxNi6tjDRkDjBIXTEwPAECDQWtp0uy8Cvlyt6yRdCwblKoigBK7fWbiMYUJinQZyjlQSgUJbWZkquLYdqRWbYsIc+Hqb0/RD4UKbW8w9OnGj2zTFhse4N9OFIlttzPIqWyPPK9uc6uVcBc3JkRDGiU+ZZRsbar0ewnurFFGkepl2yx47aqFyzvnzZaO4sEGO0tpzKuKhyeT6efzNjFBjsUk6lVzKzLDFI3q2TPgsSdcGCEnHlHCmYtXqvVrkrXGMrkfZJQc5Ym51MyvZXzY/a64xBa9yYxBrS9rapFevMxNRbxIkjbSVujfz6HUoAAAClUkm5obmySRfEhBKF3Vc8+2N81hrKlxlzJ203+fc/1hMZZTDfN1Y5WvYZS/Wevq3a1nB9bc7+XDCZbxzV/ZXVlZRUWIORiK+//T+zMk7+x1VTlCCJmE2R0RDoyuUgnnJRqUUpmIIkVGUtlcahHdTXRSzGRtD1Ju5yXPeZyCiOI7ESdDsSLKpDJIqoaI0Rr9l33ttIWtWZqpWfSIRqSw1D5UBA4cSnzhszENCjnkpzBoIDAIAjB8SUbWcXcoVLJEyWZKoHBcHzBgVDEMJ0Dqzqt2UvVK7JfBj6wjCEOYwB4IAwwXCtAAteAnWUSW82keeqG2Nv6/ksCoKGDAAK7ZRAq8cS7QuLg6UD1OpS6qk/0WuWZyZJW+r14qmE70NXlBq9sxmeHu8uLQYze81Dfw7eWWjy6fvt04PNJ9qVznZCxcz/IG4sDk6LYc9jcNlCUcg8UVqmfR25iVhxtFHFdvJcQJsZY3czO+nwhV53jyO2xW18zNDnFYlDhzc559zRo89KY0XWFAiqOJG2uk6l2BGxsoehfcmeFd5e+5HGBWXMWl6bZK1h2fxH8OJaNAV7FSjjW0GG4bdx4MgoaWgUEwAAAAAABW60mStQGsCaADyYvYlHc5K7f/v9Vu8pXrTFgfPX73lyiw5UuxpkS687f1rne//f/tqUum79vWzTNsz/khQ/+5tiRZwz//////P7U53yEqTaIaqtX6GyJ0NRsjr+R1iV696ZOy1XyhZinLCO8QmRCfLMwJKYRX6LGUWUEDFTOWFmcrxUR+2SJZsoQhFaGeiB2IZB8oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJi4tLg117cpZxah43BW4lOi0wDPMNypRBKDjclbnX1IbgmK0FqQOjKnbEIg1F0qwwoOB+SAhiOG5gKBIOFQSBRfzwvBIvflv6iWiGQVBAwzMoxoCZOEwBAVg7YkeSsAkMWBuq2W0qeCBEAJhcIIUBphLHnSSakbDYPg646rAnoZySgQYMhMYDhCYFgCTtyVBbT/sXZYaoylbo8YtodajWmhQQpmN4W5eYGBSOT9GKuHAgPIca2IrdN7vWRUx7Kad+54s2m5D2zqtUNCNZnBlRC5XSHEHPdPI9mPNp0VaVQtStx+oeaKUzBUU24jWsszJO7jqZXMzBVwYDrshykVLXI9gzy0ewHKiyubyVeQNvYNXarcGOEro7DiJt0wyQHNUt1kSqaI/p168o3vIt4t54q9Nprjx7eE0x4D7cWJNFl3S8Nqor5rskazJ/asZ5C1LkYCAAQAAgFVG1epyiH4e5jUHir9op3+fzm7OG7cAUs/zXefrPDLtfVJK0gVr2p2Y53vO/3mecpd11rCkrt61OSR1nnKdUVBYtV/+3r3oVkRJz1lYClMjI+QioimQymMjs5ikoRELKmZa6US1aFGS6qLnWjGZJCKuyig11NjiGVi13VnaqChGZeVGKmzEQqkE2PM9iSDf5uLUNnf25mNN1TeKp5+RCgbO0W06WZQqKwAGxIOv1DsZt/tM+PM6W4qQKiAzu9zN4xTOXWjfBDH1YIEWe47qprpCwEj6YOIJpQ8GLggsSVOAyx4JC3ZyIFizAGmqUMnLSHNax119p4JlczevUlHaqQxEmyRuL8rSiLReRU9PYtUdqtjHsvwqXrGFepLtVPwu279+fvXqCX14Yv0tJi6FTK/Pum7S+ZA+Lx3oDhprErtsBcypUjkbxqTk1TU0UobHY/Q7u2LNyvY1jlKLUNUjlWsqSzL5I+0by+ITucZicrqYdrWpVMS6WS+ll8Umd0UtyymsOYwzLaajnbcpzxp84zlJZmzXrTlmVympSUvcNcpM6S98ppK342quWpjG3T7/VTOe1ndyvZzjYd1AAABAAAAWybpoJN1DCB/C2l1weS9+Mrz/9/jd3hVxlrDlMm0r9wxrZ1e5/nGrt9W6XZWv5nvv7z1XyrwaykBgwWLOb01rSqsRpjuhBhWd/+v9XKiCZEKt5UcgMORiyFVDMzHRhVTuk7TrdVZ9HnZSFahCqlGch3Z1eYioJ0GTXMZjlO6KVDql0QyKLuZh48YQUdS2dbGQSLMLjIADdB6ceA7pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACW2LTCGcw3amsWoOHyhuYf4tNIfx7dJww6h42SG5IAAAAF3JQPmGr2L0gFR4DEChIzGPTyKUMUB4SIIcCmmuNnfp3KWhbirMKF0zHRlNIUQ1EMBEEhgCqaFxX6ZA8SjED4W104gIOiALGCymBAQ0+DlKGtNXZRJWnPU/sUjDLnYWip41hafKotOdkE5STNjsfuW5h/lttDl8MUNLQYSypyhr3MJqNR2Lxu1eq1K9emlUxWq2tWorK47GpY/VmSzjr15ZO0shlMYjbvv5IIu/tK/0ukDdWBwzHJVUijyyuJV5fUleFmtantb7coquduMV4hWlUX5qflvLc9aqU+7Heakm9ZYSm5duTFunqxd1LnN40k9SxaRPpBlJRyWF1aevXkGU9Lc5fdzhugsUNevrHc1Yo+2bVy9S29YVcc/1Oam6mMzKJVq1zX2Op+QDKAAAEAACApPVpvQ8IgqIxA8KAu2u8/8N1Z/m6exAKnQca98rnuZ/d3vHnymZh9cyOKffL9vHW+8vWvrzXRoArLEG//8VyowyJrXWY572eLj+54nhph7hXp2WBlvVONuJJaUvlkt5XPipbdJWau+J4pfmY3h1Rx0YyKdV9mmor0sgbvcExwj1Mj0uvLUcskQiUzoQ7aWmXM3Ea1FHOfxJ1nyv0yjpACAAABn+PA1mrzUVkNM3AE8tuYUFZwa2nBA8YEAL/LVj0ui2oHVhykEibtB7IACRjPixBywFhlDqlq1m4K/yhrGPy+UShWsGAEw4RTAwiBwGe14ZdWeJiONWKReGbkVEISH0aKRfvGrT15B1ua0eAu1ghRaP2Z5bLDWtPAvbvYjnSs8De8PoseBJp5JFU2YcduezstLyw2JqTh2JRdpaJVvjpB7RxYFlkbXJ+4uWYUNWRqXk3NLLZwi6pCPxDIqu3fbhLhgYXjYvtrc3qqZziNlot3rVEXb+MyQo7atPLbtDfpHqp+xL7LC28Y4cGbEGBM2TXtZwmzBh0cfA3HvF9qS+aePF1Rji0dX3Hjv/BlWztQEAAIAAAF7spJHuSQ7QmIhIKEANEbJ21rnjas1YzIAF0gD7EeHisdQmVJzNbF84Q0E2GuRpupnZ3TTptZINQoL033/3/PImP6uGr6+/lev///+ZU/66u/9pq7RqiN+XOe+LSt5qermO1+4m9IhNphooqO0iIVpSZoencs6PLSvDDoVniu405p+2VC/dP58Z1XxMJL0kDW2wRZqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAiYik0h/XtyoG+qHg8FbmYSLzCMde3KmEIoePwVuQCCAABXWYu8+JisCCzjABzBUAygBSqgBxUPxgkAAIBAFAxSvn3OJr3lUxdtyVnpgCCBi2cRskYBiIERdVfjKwSBocAa1JXK7mcNMmCwAJZhwAmEQlmPoQjIAqF2H7lliJQFSy63WWEuiUIGUHYMdXTzLuPjvJUW5KyjWwNpcjgVEtbzw7bzjdLX09jKhglb58wYcGDSsmVI5R9t7fAcqwYSvhtzpDr2en/RXqI6EksREUwNGGRzWpmxpTy1Byye2t3jOeryxoL9/CTblEi95R5Djq216u2eWsPN3tHcVgezavFt6SWxmG9cYrXHneyw4VIW7QIunTzF/JHm9Ir9683u9933mHBiW1qdxn+qa8W08CsLd3oCAAIAAAAWldOr/QQwDDRf4GcQ3jVj+95+rH6z7nVjYo0RBhWFfcQkHO7w3u9IfbkMmARHEs//fx5ljvzoiOHQm/60n4kKC7rU/fz6K6ffS4mcxXql2ewuJD7GZyKjuV3RaKymGHRVmZS1rNlHLMwixjDFZFZ0VFECEQxVdyORSqUxLOxGY5DJuTceZmIV3MziA9koDgdYZsWbRinMfUQQAAALOuwVZz/LWMkn2Fy8LFMBwVZgYwiwaGxGYxg6DRAEi8dTKWwXPsSpaeNXpOh1SzDhKMXUkNiBGMMAcbmrUYKBkUClL4tXh536OHGFMTSJMFgFMKhRAycGJoNqYRldSgMuay60PzTbs6vY2paUAQ4AbQq1lDGzK2CaKJylRWnidOZIvGT4eL8HVnbcXSFGzDfPmF/HbIT9pgaviV8byeRWJ1c4qS0N9dtR5/oh5BOk+W1QCuFWTBUuDaoVhGnvIzy3wtO2+0sCDqJHZGljZj/Ph8pVpVqVxkcWRWIl6/W2RybkxEfNbO0VUMGFEU9ZXNGzvFQqnj+7Wwt121sV7fPLFUUBcK+Ghn3HYGeZtZ2NnYXkXT2Z5O5u7Pcaw/VjjHgSR/LdtYW54wbg5feDTvDwAAAAAIBD1XWFrHtv3pm1H/XQF0AKUhknO/+v5+tb3StjfckcBtz/NNkezLv63dq02Nx4nQUrpKf+ZYdxwxuGI7ncIGZ/SfqkxBJmVmPs9fQy+xPkKoqrCkqNZTIKKhVW4sUe4k5jmkvS6O1SnG7IRGKhLIYgs50YjLoZbjaB5TCDtUyliLldBEhGviKZUlMVRhCDxFM8jCHVSDXYRWTMdF8NLgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJU4tMAxx7cp2vih4jA25l9jEyh/MNwmHAqFA8Dbn892+51IhjUuT0EysgOgqDRiZyF5nbIn2zeBieRP1LJpN2FwQpbKZXOxuAHcMEggIDxgg6G59seIUQOPgNABgxdBAMnWP0cSjUEyiORJTRX7zGBxIZRXBjwBBwEXnbTTbrNu4yWVolFnMSpRnkgzfJIDfZz8cokZ4A7LN25Vp0/VLCUKNP1nh5ZL3e70SOPCYtV7FEalA8cIvZYEJwTqpV0JrTqLZLKdgXUM4DiFxeu8MDekT0Q840uT4zETvx2KK8YXNnamSRkwqo8BswnoV2FdsRUobBmh1eOKsT6juxrpQuJ/vnCszudqhwn7XOrWFl1NPCiwXF7CP9dLcR34O4srx7dqbodqx2GlJG36Yp5YrGxQc5pBX4PfXjVxt+xSzvI0ivrHfwbPB9DFEAgABAAAgMC25F11/VTA/dFYaBi8LHICk3eb1y//879PM12JAESI+G2tubzv8/ueEbr2dNiCxS9cnw/X5b7zpIxh1U//1+xmNDY0Nqyf//5qt7x/dtdtCrDZKTk0Gc/n4ETYwNzaEvSIzNp6qjQjpbPG3GOhkJjRkHoKFT4cjC6YnUE5cjdFTs8gUMGD3sMcBlUKKUdeAwRQJKpPwgAAAAPY2W9+5tmXjdDViywFYiYYcB5kINmGD+bnfQwnyJCsLYZDN6IR2Rw3VlcAFQHA4HLsGACYGNRvfXmYReJBIx6GgchXPfWy4EqppO7VmA1FELC4ooEjKpoM1CYSCDvxpmsafpuMZi0Un3cjNJFM7kXRHf+zKLtOID52qamnGt0sbnsO3ZRzLdfHOWwFP1L1fKalNPjEpfFLfPz5ubl9HWnLMF42tUN+ZlV6miMVzh11m6Sxy6as8+py9PU8tnqbGlq14f7apMZ69RzMphh3YHlkLf2fqw9IM4xXn7lqUbtR2V3pDn2zOT8Cz2d+isXa9PT0V7CnzmtX4vy1Ko3yhl1PhNVt0NrO5KZfYs5dyt4Um6ms6WjnLv0/L1urzWq+OdftjK7qmo89TNzdjknnAAAEMO5ptr0Epy+IEAA4oLpLJBzv/rD/1ljyZiEJiBrUpCuQni+Gfd9y1VuVY/XdplK6Ec7/Me7uZY5Qnojfk8ufSeH+RhX/////knnJn+R6F5w82610zKwzZQkQn225vmzmQcIs5VyIyMiEwMS1j61UiE05oe6i1UOINaGUymh00EPBvYKwTB6msR2KLhCoI1hrvwixcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIwoxNAfx7cJxwCgQPI25gQiE2h/Ht2qxD59BsmbmHePMpFhTm+zqAWwKghBuA4EMFQkQgIQacso5j9ctDUgsVKtBdg7iLzTXc9dlhMVe0DOkChWZql5kZvGNAaYLW6XqgEC3JDdnoy975y/KbkbCxQJBBaMvCBUsaZtFp3kkJ8fSEW04MTPZuHKCobFBSCAnOT6zaxptsQ9RysCkUC4XzoVmIb9DaJxkvRWMG2ljlgpJ5mDGdTPY7grJ4LnGXCxHbkVRsULNMn3JdrMY3FA4x4GF5WNq5gViPHWKMDJVbntAY4UsWI9kW2ZSKp3DixXFQxKTVcICic3KLO5vZYjp0rGaDf2YI3gVcGSddMcrMtRX8s3xD07paVliQ+55r7z6gPt3tLHzG1T53M87vxq1zSm4Nt/EmkomAAAoaEVczREjC4k8DO1KxEuyuDtc33t7efcd9s7rPirALgP4iIt6i/m8+39yHP7mLty8vM49zmGd/eOwzZmTmt9tdCN1Is+YQWg093/yy7WJ/EH/DOrYpLWQWEyvlnpoII4EmnMInlS2cSIGE9cvIsMqFVTzjGaKRAzq1n0SxXqZEiMxyEXBUFBlElA0zq6plgrkFZgf73RftGQAAAAM4btzq5XVVkrKuSwi2oAqANlRZoBAQxSxDO4/JkHUZk1KNs5WtPOVDVJORWGEXH2c4wQAzRG3MehEyEelGVixSrTzUsmIKoHRhmOpGxR8kZTBR1DA3B6OMemX94xHD54zhFhQaR1M0qBwRIOltfRmq7e+tuZhpCVyKZWZ8+YnT2K9gUpS3gzYsxNsPNZ3kaE5QodZ4UBPOMWFyxIZeEoT+fKFtgQ8YZoOPVjb7sElZtWctvYsWk2ZXtGlVwtQKw2GJCpDvmaS93ngzuouZt0xe0J08fVpe1cQ+5te7/wZJfH1XML1lp4+YW42/rFa7xi1dbzB3il5YUKmK4lasvohQAAMRi6rbdcNwUjG4qzMREMIBQdvWWv3Vyy/DLL7tG8Kgx5nBGgFWfibww33n/F7uq+ctlMPhcxLjG/3Vm6Ul7x1f9iop4r5r+NbPPanL/++Zet3Hl5xtqHZrpRzU1e2zwWCIVttUf1mtjPZVzrOzM1bDt/Bbtm9u1HRVXWKpu+QbMwSrW8abjOZ4LQyispvmXuN6/7TLqRfezM3Z8fbrPlbUTNOngKzjSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACVWKy4Gcw3KVTzn0GyNuaQonMgfzDcpgv2gQPBW4UnuGZlcvmpLSn48B4OIkrbBQCeUsC0wkrDl8AMrgotCy5gbNo2j5G25zuLiu07IwBl4FoTEIOMDT06lbDUqhTDdRz4+9FNA1fbLYLf+uquFgA4JcMw4LTNRkMFAR03rZyyl0nZpZVPSunkUNTb+4RKKJGqQgMjLl2CMrGcXt092d3jM18I5a25b8VfuW6m43veH17F7sCdhuUuVN3bVeih+V0EAVofn+y9tWctwdWOMwX7uVwE/uespVlL+4diEhlkqlPYBo6mVn87Meiu4s3GVymgp7FjGLu/L6+UqfGrbhuepqtuWWqavMZTVuRyaIyaDZjCnyr1OyymppfyMyqd+at2eyy9Sz3KSQVP5vPH52krX523X5l9Bawo91a9Wl3ymosqSW2NfyVVRNkgAAgASsXdZP8OcnXqRlMRfZQU9+HOb+e///eOVyll7OUZQ2kQLxXLmess9bnOVO8z1HILHAXn5lbz4bKpMP/mGZ4f3f+fZ9Ej///l//4Ow7mssieyc4M8h3SJ5TXIEypyl/7oLJGIFo5JSbuyfIUIuCWrCMM4qKNWHuJRCYsmj91I6D1GSQDxEkmPCUeyiKpH899OM08ZINj0/3IubOiyjZh2K4SsgJrCujUbAFjyq+EK2MQZ+vxrDogUCmBwCuZBIWcMAAAwCAX4WsIBSYrx5u5ECQPeVgbcEMFqNMs2YknOim3kCSyMOCrYAR4BhqoUj43BaUCxNTd13gZw/8RgpnDyQdk0hTwNOBUt7nDceUwAhDMAMW3JCQg43FAOim/TWHHvwty3jd+SLsa5A8xKJufm7dA7i72JwPNNYciw/D8RuNu3DDgQLQ23/dhyIIfCHX4iDdWluA8mt+/EMP5dcB1N2nYdx3J2NvJyvDEQdh/KJ93EnL7/uPheisMrsdila2xON01WadhyHxa25b5xJ3MX8fyQRNabE5c7D+cjD8bct36eURhy86SWTMTfubkMv7SQ5O13/p86/dWOU8Xp90/blTmN3KpG888JRzed/vbVzO9jrKvd1u4+OzG4AAGDnnTUjJqDEWeOs6SRYyS9l396w5v9UmFilztzS5gKwlNF+Z5VP/P7t3mVzKeymptJunvYzmlPkcqeRhIBCM6CAgHDkDgcOc6EPMedCNp8hzvFBRXJU0jK5tEFpkIbbJIiMd2IQjka1iZCRpz55LKVSuSOKXdTPdNpkLO7M73MpnO876u7Kd6aKru6I5RAxuMOTAmsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAiKic2Bm3tyzJDJtA9pbmCB8zIH7w3LCkTmkG0huVr66FMfHzxJsHx0XwahLdrPc9wiFzRudhcolcPRyMsWjTjNybYEAZZ1MVgLI6NuRYDTKr00RLUhFoKdWjgbTpPtYgmC6Zr0ui8TlqpDGR5ekVd2W1M3YHqKTriy1zdUTJAlIHEnJkk5HCeLUMIB1BujhOlUn6LiPShqedth1LtDUJgvHr1hVp0qlhUMRhQ1DVTFwxqFOp5POW7RoT60tGO9o6iVyeM2K+xiMnjmOplzGmg2YlczWjWZXGsB8+alEzRpVbp9a6uV0ZtP1WssKKzMzlGYXsR83J5DkOjqU5VC4wYt1NCvBZYsF7VujWzBiTxa4fPsvWW9a2tmbOs6tjFt1rjOc+0K2P61rr71v+XA2YkhAAAEKRSNlcVXgAPYkz5s8Q7mDCrUb+G6l17KKnyvOLH7VnGxThYFAQMcwCMdv3K1rG9TT0ap7FLjQxzsZcMMDIXT1eV00OJLYtPFXLJIjofPEqaFyhEVMuxrGJoZWTEwp1mvFlVlWCZKyIWPGJDGpommpQjiQqz2hJXJGrpVVVWGQNR2F3ONIrizFllmUkONNNbeSd4xp9sM/14J/L/tVPNji0YZSKUf41CTU9VhUoV5dMilWSnOacty45KTeSrPnjuyu6RXjGkS0l3OrWq0kQhOg5wMYxRJzrUilOt6XKiiZYNBjIvASOizhgwAnBBylYAAl0l25HCYGbE1VCWyWFxdVUw5BNQOH4aEuhk8PNYgVpdd25RnTQmk447/O2jKGLC8LMUdiWyuT0k3RyukoKes/de3EAddS+acSOwPGIcgKMTNt/JyG4fgCF97i/fK795P28EOV6epRX7WFfedbkVnqPGftXo3dr15jKWSyrQZ4RR9pFDUdtWtSyxP4fhc1vXeVdzXOdw3rCht1LnK9u13nMfppvk7r69at3KzX5T4563bxpNcx+xjzPC3+GPd1Lfea1jdqYc1nrnN58ub3jjnu8dSGH+8rSsEv8HE6BAAAAGrXmE9BAAmCBGVt2G2YuUuMeCRqlf+X29LvnpRY1TRuZsW6SAkEIWiG4fswocJRjXt6wileesY0Ve5YkIjDPfTy7tsP4SuBzvdIaHYoC0YCgkF6B4JQg4DgRBKLsHjW9nzI8YeRT3EPNT+UNXqHci4vqlPMGeMFcr4x9ZrLZnvNMPm30iZ7d+B494SGeJtZQbHF3FVVRVXJD9RRJY9Wh0QeOPqJkUhBtkFjElCrtCri56W62G0O6rginSBYroAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGR3FNAft7cuzQiZA/UW5dIeUwBmsNy1G7pkCdSbmz+K9ZnG9FLHilxH6xEGS+cZ+qZfJqqSTBMtgWaT2QDNaa023bfLPa9NOQYtsZFj6TmFRHcMwzS5XK9a5R50+FjLKOxkujRS+v8l3tc1gZiZ0qrwCRhdOb1qjMumKjFHeWjXTr2fXYqWhQ4ssV5eWLa9cYrl7h3J8VrX71F04eHaNj4T8DMHDZW0LH3XNqRa6vlx1f/0+63ti1Zr/G71xmtqapiNWu/q2fV5rVNYvu1dfdq4g6zWDmpkYQl1YaU7/71hd1H9Ie+8ucvdLahuxHql28SUOldA2iyzQmlNNZ0c/WREWApg3hGCMOEWYkMrFIoet0son41DFJRgmuf/bjBs6+rgzsumJXHI5TSWfwwcqlg1D0aoteldDSlArIk6WWPLJg+alYukUCGg2eGkQElieNyqYGKkjFzZzEip9aiLIJKNmnjh9zFSamMkVUiSUdSpU1JIKNC6XVrnEhlyHGJikcKpuXkrJuitBT1lVJmdNki8bH0XSZAsmpdWXzVBJRkeWieMTVk0qRidY2RzBJBB0XW1SzE+s8utFJSDuimy3prZk06K9Om9NSTqUmaoCr4g7/ISOc+0dDSYgxQ1rw8J3gaKHqyL8LaEI89EgeGons8VAv9mEcgGNsEf2tEXqb1ki76aGDJKD7rEB/J+FupJY7DmMO3IGidSioaaIQaosPHtUGUb1hN9wqR+kpt6rRPIcSqLcblFFN02GuY/b7Zp9Q3TRSOySihuMSF+JXfpMsPz7fww7yDNRPsvqSybysX6nbHdUXb1R972FjeeF7PP8anM+4V/w3T48y3nv8M8uaq3uZ55VMZF8iwzt48+vhjXv09SrlqrX/Puu/lreWPOb5y/+8svys54Vb/P/PWf4WgvvcHsP7+mvxdvpIlkZ00KUIEj/kgVeCDZXqdVliq5tJTHWVwEyRrcYTipZLDkttY00ghyH4k3Ucsm/dK10uU9YpZmc002Yo6lJ9merQWo4XbfithXZzpmbG7kUUsuIEPPAlYfcyKZscKpukT5ozrTZbrTLhOpoGqKBoy2TW9a1qSMB8F8xNScTSNCbMjRjZZgZlIoLOEPRMDVNaLU60kaDstNaaNO66TVImpigmnPyumfRTNpqmitNTsmzrUdUzU0HM0DqRsiZLSRWkmxvRo9kzKUbQC8hec5stuuB5feyVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACM9xTIMbw3K8rRoMGwxuIi4dKgfzDcqoLmXAzSW45eisEJbs0SSL2syUfHCQOXhFHGNpEAmEkRgBeVB0xgEMlXyoPhgoYeUGDGIAJBovMtHDGBsGhgkNjRoPCSYpADAURMDAyYgDB5PEzCuOLJFaIZZsplDbEWlTzDVAm5vBDrSpmBW7Rt3UmWxQNO0sORCfkFqFwrkGw1peLWoBlBmshU12EMOkriqKSV0mR4OnGoMbnNRKQPtPKhWs3djilzSa7FH6zuyfKQX+RycoZqL085hIY9Zg576t63SSypWqRjCfbHOUtNH8JfVv49t593Uv2aC/bwzyqSvPCn7udv8sxqre5Kt3pqZwtUszepruHbv67Wxyys2v5Zz1jjql121Vw7V7r7PSCJaT/2rGt9lf5oJg7RfdEsdPCAEAAAAopW9upcth1IihdmHoZjtIrVEZRDz8wZK3nisSlcYp7tNHaGKQuWDNkfJHYt2t45ds3KuWFrHlrHG1S6x/4IaNIbdefmJHSyEVz06XmrB0WYmUJaqSHJ8kLjRfEQZjiEgfj6XTA3tEbrDwzXrljdIE7mLH4lh+64871fip9Z+z7LH9LedN3HtcVVjivBW7Gxv1q9FK5b7K7q2rPss89C4uZcXJn1J03EuZYdaDwVARMJEhUYRv//6tQDoSp/kNEAVyCJkmxZwVMyOQGgQDIbsaMAkE4GigMQgABSIIlpWkM2ZY+y9AsDQcFW7s5dBrblP66JQADZ6eDj6hjD0P1mYUL6wi6sIo9LaXUpkNW/DQ0DYEo4Cno9K4Bcmds0rhQBPONCpxrAJaap1K+DXcoNlr/SlyXFsUtiTv7KXKf5760nfm/9aduSO5Ko1DUPS2nlsqhcMOfbxkFqrS4Xcrsqu4U8zWjboyuGmzzt90XFpc6a5fq00arYX/xs0tmrLZ3Cjs8tfU7q13DtBn29hc/KU42rtXOZu9tZY59yv63Zyu2P3/dWsdZ4X/7bxx73O1hj3/138v/v67zHnM/3/9y/8Mua/n9/Kxsmoy/kxQG5w8Uz4SXSSDUGNNKWdQIrsqhHhb2NQy0lS1PKq2NIVAa/thu0vh5/XqVlOXnDLrlZd1MWM+5SXGf7V5jj9WevuD/41NVlmaSjeIpxkMbaxoLaqc4pMrBUyIkQqjMhdMUmeoKaTZhOAq1VCRCZCymKSykzIDCZZE1KG/rSrVdVj/sn1klWZeW37VhLd8fHxluSvc2bLFEZZGNMUrcoOViUSkZ6GyL9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAi5h8kB/NNyuI7JEDONbiOyKyIH923K3bCkAJ49uU4TVJFWfoVYvTwTUZBD9CHCNH4q0vigsBQAYUQ55AlGIAjTJEqwI3qxrfSLaZXYy/kBrOjMmvO6SBo6hUzDwDh+Cn1g93nsZLK7Zc16oEjD9vtFnwfUwOO04Y812DmcurD00yRWqpalFDF3HijjSkG4zThI7QQxGKSmxylN2jpp7Op3LGPxSmzlT+S+kpbUhp/pr9eZs8ygNg0ujN65a+nqZU+WdXCej7qS5p6O9BMYR5vqsvdOjsyuURmtXv3M9xvv/ztzuP/Y1bpMqW5bo4zLd0k1TSi1X7L+6tw5U1P/j8qx3e+nsZ2r+dS3Yr8uflYsX7tztqUU/PvVsM97/9f39a7Wt2+4d7Z/8MO6/ndYdwt2sz1j4hbHtgVkAzUiEhcbLDFYfdbnAsaEAEM8AFVudqWvCo0pY+tXUXmKO5MQLpsxKBDlgdbu/j34XmqTk9yuldKnzpbNLvfpoT8tQit62qnohbTFj1FEJIB5mR1E3OF5SmUmikpkiaqZFJSSS03PElUcMkWeyCbOqpBJGtBa3dMxRZS1TM9akt62ep3c2SfUk6SlroemilrZ6kqrJo2varUjZ1ouuip7NRSmSzd0jVA0dpADIwzecXahNBpBe11Qb4xDPPrSPYD9bU8nSeMOAwHtqj+YWF4biCWJA4sdrDGmdMzYc67at2bq39BCYRAK5lqmFInnHonCRdF0WnubPINuO/7K4wLAs+q9HcU2pHVZSz4xAAJtowuZm8XpnDb2MtDhcZhD+SCBIm/6Q4IkSIFtPDyH7dLKq+t1r89ayqztdmd6pp9r0blsO1JdUu1bVJH5XJMl9qena+p6W40u6a3DcCc+071aWPHA0ccF2p194m4NujjVDjY3WpfnaaBd573e32vutnQYy2xZs2b0WjtmXR/K9SzU9KpHQW5TelU5fzp8cO46rfrLnPrdzt0uepi3c+xzdflq9+G8ea/f/zLHn9+rrePa2ss8Mub1ct40+WF3LGvV7nfHAMBoiPTQiEge3Nq55LmpTsRLA+MQh+DI7KMICZejA81egztckUtibMlbTAICOnhhNJxaO7apn97SU5MBIg0Ogp90OU2k1ZiStFFh+YXiawd285zhsBJB6WZN1e+2v4WN7x2zMu8av80ttt1f/OMZ+Hf39fNN0/rn6//zqFTW/mv9bfVNeuHu85+vn/F8etd3zj5+c31rGvNlE++Eu1NfgBEq4FARiG0xA0lfzndLPt8wrl7Oq+1YsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJEYrIAfzTcq7rqPA/c25k6i8eB/dtyrO648B9wbkr2VnXK+fSNWkK25tbeuDVfomJbDUOZg7OGlC2oZG3sa8jWgYAQIX6lTAVhG7RaUryaUouOhYZoZypxA0DplLBl0GsPDk/EWeUaBECOouGBGCuA3cLgIyWHYGYs1jJ/3jbHAy2XNaOsLG063aU2nn7KhUR/EfF2N5epp2k7hjdlF/tfVmVaajqY3HbcOyKpPUEOSaRxmnh2zfp1bYrLMt2pqtS0sG5SKX2ofluo65Cbr3QO8kBvfCGbSmhlcr3Vwt3MrV2JUne3aS/hzHVvH7mFaYsz9NQe9lJTv5bg+/PRCzQRqh+luVqGNc5u1jyh/n41bH3+39VKWVcyt4UNqfxy+3l3/3+H4c73udmx3Hd/W8ssu16W9vDVJ9yb1hnRao7UpIITBHYozxriy+7jnUrfqrLQaRFcWx6dgnseWywd+sKWisZOraiTppvGCz5j54XBZ5BckoPe6LTz7JjqyKfcrdqpqkJhCzGVT2vyUgg8vDpRqUpQD6iDln3QOGCzi31VsZzBV2qsxkmpel0ioupq3XRZJCu9JlLSY6pzyC0XZq0kygpdkNdrqs6mTMqLMeOUrKkt1hv8e+f1K30hOaPKoenQutyePkxbXuyfNPGf4p+lVbcYjas6OJTwprqpERoeFe2wEwOiIWRde0ZcZdbS2SuywCGXORNryaBFpNnWBBICGBRynbQDkQklrnASYiDcHeVzKFgi66jynoCXZDdNHQuCJjiAT/SxrMUa+ko6khZ2/Efh+C2xKVvpCYyW0PYIyzSTLTpiH5dHrOVLJeyuXXKfsueiT385+knrEgjFWVzEpuSnuUWqTakqeG5yWxStVk+olPQxE6KfjV2+sOoFGXenH/YQ/DtPo7sgxmolapaK1Xj0C19/SzNqbyrX72E7yvjG+R9/XBjs9KqOcwr1PmcYVNS7fKXsav3afVSnna1JlUz1Vs8wrb/WsM5BK5dGafGvTX7H5f+H/y5zeF7LDtbXctfUv8pLuNe3SY2vt4ZXavK/18qBYEgrFQyQOU5l0aCdY4O2DwKjwgbKWzKz7FeRXaXN7561Ba7hDVhriuCR0OVduklv24JUyRebPEa9jvFFGC5yxTLuFdNO+WzdJnULWBOEKpLRUmdNFMmldWigeW73pZi8zezOsuEshTta1e1dJaa0i0imhZq2dbVmC30V06nZBfTzVFkK23SXRWipei1qLuyaV7s7OtWy0Ey8YpsdU5qiutfmRHWXbWX/Cfbvb2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB2d0SIGcy3MQEUj0H5pu3P3PIgfzTcurxGRQzlG7Djz5SPh+qgjxfW5ydw6PB93lVjBVkMbghpcoZa2y3XCbg5jcqaCGmT16ciKtwIAJk2NnLi6rM/My2shYJI5yPwTHKZzY9NTT8y4wAABYZXsXBpZHTS/Ujm7MrjMDRqrTtJNe0FqsqdJ0aOrSWa3853uW8NZvhlnWq4Y0lJP2d09XDkot4X5jK/X/Oxnvn5fq3rG1nqEz9mPXpbKMrcM0tnuVnmN7n01bPt61nhjrWquWXcd8wmMOXq1Nhd1ZpNcpOby1jOY65jh//nln+v7lz938s886+Vm7VzzsYcHVwtfK5hdrZ3Rn32vHscviAACAABLKRFBAq4iBOUB2RUIQB3cIhu7yWxgjoGLAgoHKIBaunhB67VwOFPOg8kjdegm2ZJ0mSUOdyIqtzmS9Zr8K5ZtCXTbiJA4dBK/Y1GIMaa/w0HAwvRWIuXm+cqhu5B8risbfd1nelMbWFNfDOQBX0vpaMilsYs3Mu7ps8sddoWwWssqt7GkpL9mhp5nliGJ+kvxCvNSvfZyvuxzLWpfrk9XqNrPy14rEtfTlO5MplvbVLyze5nbubz5fzqcwwwq2vz5d3SRyk+zHpVYr3MYc1hGL2NNcnZBRavcuY3vzrfn3+95/K9rt/O7/K9fO3ytjlv//Hv83rveZf+ff1zuXe45c19f9Z979vWFrp7ZEGlKxnA6riIu8ZxRjXgRAJviQBA25GaggxOHGXtgf5pr0TEdbSAJY8sWpX/XwQikg7JlMNpGOm9LpvDGqGHKbjevhII99afjgBG0GRKnsSqF0Fylj0uZfpU1NKXixGAh1jbVpE3emlVHyrrOtTavc+vqVx3Hn02u287eNnXe392sO51qPGt36LL9X8sq8xOVonMPdYuWb9eCLtJLscLfMa+885vHHuG/5ly5l/eYd1hctdrYZzde3dz5Zxy7e1jlhTay13/1vWst7339fhjjjlhjjfw3jy4y6Iz3X63z3b3rz6SUIfs2oAAEAAKAihL46MuMHhXs604V03EKnvS0MMzQ00AFfwJRvBLliuNapX4jkCQ7AF6A2FEofMi3kwkH0/oNbnBcfgxm8CU0pIgItmRxj609AAJHT1QFLn4moHkhkXSOJ4TuYDLESIqNZYIBAHcVh4SXFrLxNEugipziTHkGWpMm02cvKc+mbol10ndZeMHTSRRMnctJTh9JIzLBoXibLA2jQwLrmY+C6TBtUb0TPWdWjUjZJBC1BCpBI2SMkEzMzNyi501Rc2PKRSLhNGCSjfSRdJJab9dkWdBG/syP9/1Pbbefo1JupaNzY3S2bUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlNi8cB/dtwtK6I4DONbiSKKxwMd23KtzwjgJ21uBKQnEd46W1VyPmyMg3qgJqVQeGAoLmmCgChkJmxAJjQbIipbLpWmoAzynidIpmpS2yYrW1jKlMBxMOJGgMswIBQEqmRY9KyJPPFoq/QQB9JNv49jdGlDAMGJw1kQQt1bq3R02fQ037SM2Uq3RtgbSF3QMl6ATo/EFSqW4wddSmknpZDQ9psrvI/2XZNHaFbt7tS6pHIhunprFaISSxQ+3R77VuGYC7OXMcas7VgS/AFrB4mWQ3VXs7jhXoPYhJqGXRCluRjlPdr3qt+tve5jK3nuW5TUzVf3OrO1bMu+kmas8/z5416aSY7j9HHozLsZmxjuzlYnN1b1bvbtWd+jtXeZWs9QxUwq2L/O5d3v/7n+f/hX5ljlzue97x3Yvbp+6x3uh3LrG9Y2dhSuaJ6RUxurd29rxiFwMosIlsBghDdxrFqXw+lPZ1PZR3N2InIH+GAQYekQQQoJ1GsriisJp8JloibyUF298MTbGMLktyxt4ouikUTEFNK2RSGKFKSY+l5MvopFypJRqy6En+pOpSSqka6CCbJu61LZB267LsplOtkkHVPIo0dA87q3VWqky0XW9mQdJJZkqiuyNBJk1M73etr0V1LSQTTpo1Jsgmk5qBiw8DDwlKDCR33/WYHsPfJWUvJSyu7OyaQXaR23sV9BQCCELCWYY4iYfCKSgAsmBowwZpbyIyuGt9nKAxVKNSpxnRMGwXOsQfMDggYXfWmyyfVWYnE6GASoARKAcCQ9ORBbJADwYizToJdlLOlg5rzvtQTWXK4rEoZa8+7ZEtDOHY6kWZS84yB0r1wqXw9frWs6/btWYvFgBl2s5jeUy8WMxLJiYkd+G6W1Ug2ejEvfqV1Z1+d9pbmGFSvnZYY+r1txnolG6eB1618JLM2LdPjqva7c3njbs3/+l5zta/Q46o79NHqP6Ogh/WoTT0VaOVpDP4wqnnt02FFTbtUmHMt5W5jnKudvG1l+OqketY541N4XN81//nrfc63ed3lhjly9z8u4awz7TdoOZX+3r+KYoGigg1tXGYRhdlWyKzRllpoYMNSr3Tjc6SjXYNAz/zcu3FZU9cemIDMBBjP+NPS3LIZuTL02rFmsnTPIsTtrlHKEgaLC63mf5qc1OUQ2qS4GWBiF4YxIMcQUnU8/RrQLrqu9aaJ9SmoN7LJTrrV3W9Sk7TV2QTdOreyKn661a6qkqLfacqdJDTpMtmayk2fSdCtTa0XWkpakGMEp9aDsk6Bkoy8iWUSF2X3n696AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJDYrHAxzbcJtJSPQ/c14klhscFa6ACj+bpAKfsAAjBWsL5dXKkkm5mhzuPCxgcAoUHpgUBGFRgeynRq8CBwNUuY7NhAFX+iWXzS+zcNarixRYVSkdBxI5zqDgMaCVBoQgEaA0hhl9GTRaAWyAoIl9WhQExOu6xhQmAZvTMupFpPBBMDq+1AToqQfdkFMpW2ytpvucicvdiS3WWP9L565nvLlrlNUutzSuoq01S7pZLRS3G/NSOpbpt0kcn5ZdpbVmXWsKfn08xLp6NclL/Q468CuG7kulshlbIoHpYem+2KmeWsLFvPedrPHmWs617/uU9qcv2K2F+RWKtNFZiemX7t1qeXVKX7uGN2McvWufZt3LOeuYdw7nekNerdxqctYWM9a/8P3z+Z565+vv/3n5c/LnN4XMrvcst0er17dLQAAQAABLs7DV7ncetcYzt6n4biqiZgkiqWIXX2p6sAA4IsVsdQZGI19K5Bgayei7CxO0yjn+523mxqX1vs/UJgrKJ8nXYlSybbLZSaxPJuaIGYQ1IRBM3dFVuggt1OmPbbVVrrO5l+o1Z0fdXs6tFl1IpHgqZfDBA3t2gBJloCB8DgmCjhINxQmWFCjjzjEFTUVECXyMgl+tPouUUDXclb4wbQ0rlWJzT61554jCBAZINE6MbxpOD0SMhBWDg0ZIn286umLJnM5cKDktIwyxylpl8CEBwCJpwQMpjMExbBB2NwA4jK3Ajbkw2HAvORtjEYgmlMATAEIIIDGISmBWfr+et+G5sQbBALgQ8zxVgMAAwIB4zyEsSERm6QjXoIeCBpujpKv3s6W9WoGcyLG7b3blUdmYnNymXS2XQVqcp6Smp5e41yvajPYpYp60fy+/hLNS5z4IvwxAbxzLh2KKljEml1LlX3Y5lhl3DHdumv3Klatv7Wepu5VxwnZLEY/bj1u/VrbwmYrjLMrH53se1cN7xr3aW1PbrWdYdprlfVWxukx7hVy5/9//5y9rmeufrVnH/yxz/HLLeH27HTmgkJJMrHCSH751aldwHj00VG4Biykkk2koh2np3LRViNfCpi0x1LLioZmCv54xkBihrk5C+/FGz45TcAM/aBvmHFF5f36WFfznNb/LcFWt4YpUN/hEbO6/Pz7+H57/WFiXb/f//P3e8ULjDKiNel3qCt40Jo2LF+9VuGk21PaLhcPvPtLkxm8mSECi7HC1jHPT/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJk5BLhlKgAMPyCYDFUAAlHgEkHY4ACqk4ZYOTQAESQiIsAatG8FjQ54zAN+C9gBIALCRQAApwCgQDMJwtBAwZYDRRBIIBpUZBYeBooZgKBkQoTgpQMJha4NgAQCi4BQg3gQAQA6QDmChAgAwOpolEhAmCARVwTaWh1ltwARCLlGfJsLKgMBB4QsRonohwDw2ajICzDgs8GocIATY1RlROwFREcLJiSpFwhCgLDUk3OkwalYHCgcodxEh8igRYQUGhKECFiKBYEpFxBzRZiXz6aRDDM2KJEC2ZFJM0SYnSKoHSGkTN59y0RMvm5mdMSLjnmhcNRzC4bEqTpWSJkmiLIHDEql01ZNO7popKLhym5bKh5y0osLKhUN2KpufTMjajMkWL5meIrVqYwQdBlUFJuy9TLWr00jOxmmedEya76lPdkvMy8paknU7pP2Zumi3lpUYljDzBaCki8wCmKgCAsgTgYEGYAYAAbgAgRySZdAjTAuD5ZBIIAoOyoFAJhQddPFsGosFJJdKSyClQgBMlAihExjygYE8iMpUgyJxS0SZMlGLzpvTTU1M+Wy8cSMS6VEjiRuxeNkENnbN0mL62c+tOkomiVLxuYpvqr000HMy4gedJZ1kDJTq9m++qzWuaNQqTKh5MxLpm7vSRSfsYmKkvUgyDWQ6D//WoxdBFE8ankjQ1d13uqh86ZJJJGSV1L2//2yxSo6i83Bfly0vEbnQXI3B2V2NIJTJeg4LnTQyqF3lTIeqYpoqfTaXQm668djCfzQ11oTCQFGhzecOKJiIMgoAw4uJ124NcYI/FWcSNWOxZwGiMQJBKZPCyKzbO3K2GP4/D8OgzR7X8X4xN9qZui9zKZhDhiVgBTRLuGlTqxwe/cPO5Yg1U67052JytEO3I3ciMPuGnOueNwPLo3PxeG4fp4XahiS1cI45D+Xnbcd/Jzn552oxGK+70sk0Xh+A37hNDD79y6vT1rHLfft42K/3ddhh/IYjFibfx/L1PG+1Iw/j/08xGIxFJROfSSjliY7K68ohuf1KKSkz5jY3lVl9PXy1rt3ueVJufsYc7Uzz7j3WsOYZ5/n3+52/qcz+pYMkoEJ214juSCVukShlOJeM3xWmuSkghKAIIGSTNSQTSNCfTMFMggXSwZjOgYWKA0BHkqoNWTRnQWPQ/oJJG5SIKigcOO5fJsvlcvm5ueQL5FyBkHHPL6bF82TL5fIuRcvlw1OmZNl8vl8vlwuImZmWTc3WpN3M00E6bM5xJVJcwrX1UEGaggrt9uuyFkEGVepVO1OmpCt1IWXdmXWy01pqZTNUghrXtTTdRgP0r5YRYf/5gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACRh2SYVjYAKPyAmkocgAadpBOhlKAAKFSCgTBNAAiGTpO45sHw5NO/g60/DNItJmgYkWYBVk76EMgBi0DOa77s9cSVrSizhR2cidNTKOIEDTtEwQPJgJy4ZaZLoFWFZTAV5pLntQYlGHTWWOoZELLlkjpt1oF1MSdhizlRpmCa6vm+RcDgIwEbMcREjFurOeBLJjqhiP7hCEIYPKAQBsgae+SAZraKqXyv2Zo+w4z1frXqjWlAn9cFiM1FpySzM7uQROhjNJ2rOP4/0voXFlNJGspZlb1MzkPP7jLaSld2GX9iTvXaGHbOpZTVeyqNS+QyuGbE/WmtSC3f7Uq4x7LCrua3GoemN0l2tGpV+eNNjZpamWqbkdnJVuao4rWry67MV5TU7SyrG1Lbk3La1XlXqF9J+gp+hTA3IZd4DkEtYaIYAIAFlZ1JwezM2YsDGMDIqZvekpBaLXOrcuDkAcGGqybTZ9Rx1saHZkpAjDdT1F1ZdRU6DqJkxMS0gO02SLxdKqZMmJ8qKTNCiixEXRQdkyiyzWk6Jd0DZM1NknRQTQcxOGpwvbMXDFetBa8sxu19U/lUHdlflCx8qhtkwO5TCFx2G7c/3/03Q3LvHnY2+ZBi6Vh9h8LkXIQcsLGQwOkF3A2+CYEDIBQTYAAJygBqRgavA5RcJAC0MuRch4y4tY4hzB1HgFhgLBybEBQQpCCCCItAX+AsECy8NUDMDMD5C/gZEJAyD6gKEQ1WDcIfQSET6MgFw4avEfhggJCQwiGrjcZUZINUCAQZGFKjmFQA0INgrkMHAGrxKY0xHxZRIKLPI8Y0sF8uC4iUFzCci6OeRMghOGh9SAsoQsM0QAcoXMRUZkipeIuMytyZcc0qDLiFxcYsB0kxcguQcAyblUmTxLjqFnEqYGRHkyRUvFYyMziBeKZqOUxAxW44xcBOIEwMoOAXGW5FxzxmTZaBgLmFzE2arYuizSHEGKZeMTBZYMkEjqjqLmpEyCFxBIwNC+m6zM3LiFRcNC+m9N2yJJk0QI1NS65iXTimSMjJaLLRLqSSuo4ZlVFS9utVWq9/oQAAAAAAAEGoYN9IUgIKFE6hwMMOrvugyAEIPKiBuIBjIQcDoIHkEnd0DA4eYuHkDdNM0OLNzpjTOFw0QNOgeL6aaBfM00UETaipRkbLToIK58+6lJHTqaS6TpHSRNEzM3NEKkGTWShcLhLu7GqKlpnzqRnL6ZimZuy6kGf+ykkrIus6ZK3rpaNb90v9dBv//3SRRR1qpUUVP/7rW73t///AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkFdskHY2ACsMwpgOTgACaeKxgMd23CsaFjwMzhcJfE3YUzgBwmfN1QE8MbAqgOdTAYyXwRMRZMzrj6V9MBbTCUVQMAqYxGWNSL/QMrqZSVWyvV1hAiHlH5kQCjiqslSjSpa5YwEmBApdl9ASEGIgwYBLbAoMYWGEwkaKeAYFXw8TzRl6AMDLqYWnopcsM1NjaYSfU0z8x+BARCpbFYJlURpLLgt7HnejtqGaKQyZpL9RKvNxmHbUBT1HKrsZh3r+y2ZkjvPs/rDbtLZppdMQ1EYzLa8OS6amo1RZ08th2/Lp6XQzlHn+hqYvRGll1ymoubwq2bW8+axwpu9xs8tSrLOrTY2NUF2llMtzlL60utYX8t6w/Kz3C1ytlctf+VNzCmjUutcq6ytS61byr449ytJQUlCmv/Yv2afbW38GtVGZidkrSKM+XwM4GFsrSl0Rpccs8Mq+8YzemeXNuAcgurZmZ3DLcOS6GmtQNDbWYBjWVNNwzurKYzDVBTZ4xGM0sM9rxmM0l3WWXNU2WU1Ls/rWq2WWdamu5X8O3N1p6lxpcaXeVNTU0zGb2q1NParUtnLtz8tSqzjjjS4TUulVLeypsssrVzHHmWVNa7vWX//91//+OP8/m6tnH8eayxx59YGgaljzRCgsW1B1aX/QHmgVrqsMWh4YkzAEEAyRJLcWGlzhFEeCwVBswbAow/Eo7tDQeCtQRh7EWfiMAY0QgK1VXL2qVsaLvDQZMQCwFmB5uG8YdgEDk0RUAFrMHYO8hbhBdXMXCwBuA5dRMVEIwSBg1EBcFBzLoBa66jRdpA0zFVkLShURiqVK8hU1NOvg4XY4/zEpqMRlpTwRKIam5ZhlMtxBoBTS6An9pJqmnIzYi0P55R2IWplc0eo6Kgj2WN+Bakpt1MbEqqci1HLJfDsTj9us6ELf+My22/rXmvVqOnrWsq1LztfL7krpq127SZ3buuTm68qtSG/VpMIFvTzuQA/Vrl2at16ta1QVp6pb13Ok5dw3u937v58v9+Yxuv/R3Ku735Zf/f1Z7lnrL8//vP+9veOHMd0lTePf7jnhrOotpEP5BDZUenI8B7En7F4FhObmkiYfK5rtfErVWSQ9p/ZymmL7U4g+pU8GyqaKO9SxGrKlpOpulslBH5RioH6ial8dkNmbjL9y7GzjjVx5k4PJQ5ENZav3fyxu402NX9X8dxK12VVs8Mcb2X6xx+m79vCv3LOrLqb/x73G7ha2IjBIFRVQNEgaOmDZh46fIizbgwsJCgbBo+EaAm5AoiEHp0nI0J2rAzLqu/StNYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJc4pFgz3jcqiO2NAzTW4l4iUWDPeNyk00Y8CdNbgrlaA36yS/yELTn3Z5MtczXLFG0KgAggSx4CASV51yFywMZZC4EBo4qZNq6iAxd7wMXQ4q3Oi5YXB44tCxBVy1DI+8bFF9DoBJzW4ATaLOluEkoBUOMHEEM0gnZw/sldl0GOtJWs01krlp1v4sAo8lsqYhGZzYNqCQGgWozD9pVdvGXWZPnz+08qT9GhTOXuyC5Lqbdm3uWUV7OUTdVPGK0Th2LdWGZy/LIxSW5u5+MPvK6NyMPO5MxXmpNfgS2uGNRKN2703HaaN8rf+8q2VW12VaoZu92/LLVvLLKmnJmVR2VS2GY5xe0EXp+rLb0Ry/eVLWw1lUpIdu7zlk9blOOG87c9S3LUnjdSxdpaO93DDu9Zf3n7wyy1+fNUevwqdxt02F7tXH6btzs7Wy6oDE0SHR6IqcdSqsk+ZUx081ICQaHVaLGw9tay+zNZBOTdi3jD97gUtB7KQPvTXrWWb1tQzzrA4G0YoFyrEdApZPd2apowvLHfUnVTUGg4AXAkKKkEC4iopKptZFUrFqqZoXRRQbdLUiydSnKygylrr61L2db1dJa9SHdlKX9qq1tS1OlZaNGy0ki6uzvfslS6Tq6nTRZXPIVMaMtFJFZgoeWijhwidHa9ATlHm9ZivddUCtNc55GrQBdcOG4cHBNR9FikOWQmCARV8/jQoQqsgIDgkYIu1ZzK17l1QsBKvjAEEDGg4jSsKAIBJcotnK5mDFqLGnownuyIt8jM0pcZegxVMIHKaRAE5sERSCnTazLIXAOb7T0MMtfIsB80rNzRgZUydpI6H37gCX1l/U8tv6k+FaAwCI1q/3kzPYWOV4b3TV7mFqWMLhOUopYdhygnrFqpSTudnUxlAMom7DzStynGZXFoozuDHzcV9pfSRN3Yxbs0lyU0mH54XeYYXqkzKsMP7nUlfbliZfyX1J6jmW6O078vy3WlUsxyp7UpnMcrOUxXqa5TYynPljd3Oax/tnTm2+W7eH593+GHe/2/21S6w5reefOVq1mzZw5qZwl/57zuYBNawkGXNsmMbWrMu/jWqDoVLnD+RfPCvJsM6PPOWPPKmwADQGHpbBD635RjSJvyarnVVQVQW9H9qUqxc/WF9nP829kJgIGsBVC1N1qUtjBFaDKPIaxN1tQRSQrTrTTUnupTV1mrL1ppINegml6HV9Nve69Oy6C3W+606lW09NNq3rf3ftPtdMi70QACzj4rUzSnZXWfWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACRKJRoMc23LJbNjwJzhuZlonFAz3jcqcr6NA/UW4F1RGXTUufCUtceCXQJD8HPrLmnCAMgULmfsccdGxbV2pVCGMtbUNDAnHmsNrBzRmXNcYeIAQY3lgjFSt6dytqIgYBi6qt6uS6yDaPhf5KVFxTZW4AgUwK9QUOXWeWBotBsw0Be0AskvuHTxt9mxAQSPqPgoCpmM6uV47VeqLvyzqGX0bZxojNLbL2S+ikna8oj0vjNiXR25DjvQzqXxp+4hJb9jtjDurdF9fWWX2rP4QLFcaWC3eijiORQTTb3JS+1yTzVetXpNdw/OzaqXak9GdVqXWOE3jTVMsp67VoaKZda9KbGNa3Wppbas36DDuW9S63a7/3t8u4387N3lnmEM2J3Gjud/H987/71/Mu9y5//n3Pv/+GHNZ0mv/eP6sHS8B3kBchldwfHXY1hK6QkFc7+7lmecdg+1yd1UhpgEYb057EubUH1JRCn5oU9W+cmSP8DgSUJs8a2IErk3yXVZS501L4rco5ZT6hp1J8VPEYlnZ+nmuwzHo3RRqht3rVDQZcrbzrVpu9WnqWmoJfO2qXmeUtq6uUtSf+tZ3uNXcfvdy12lqX73ebsW8eZ4dub/dbHXN65jha+zW3zvddx/fJ7X87nd5r991v9Z8/O/ez1jnSD6uC/H8WVYSybVxA1eT3G/Nz//7sX/g3E3F7RGI3Rrzavsy2NxOH6jc1BAUAZgcFRgqFpiXixk0JANAVhDgsrfcVAKEjoETkDoUs5c18izy1SQGzMF3QELKcj7kwFPemmupSThNq4LV2pISAUCDVk7DAEdTJEwg4R2gO/RMGaI8LCXeVUaBDqt9x5oaV2Yyhxo4fhAEYGIQMn23CCV5sxlbMYIhrVu/PUoNC4YPbE1nztPztX49yVVcJDSOJF6kRmopM/8Yo5fZp5dLI5Io3FspTLpJSxqApmebvDPvXA1ycgCfgTdfOLTEa3+dqj/Kb5Nc1f3nG89aqzeMT7PRmJyK7Kl90VPE4GsXLuEpz+R6vVa9LXl09fp62d7PX1ab/wrVsqkDzFLnrCrc39XLm//Gtnjj+ufrHW8N9/8cs941rvM/xws6szdMwmzhAX51XFxa0LctoNyhj5giChVWWYRO3UlLhXqC7jSekO+F80nUiLSx3McatufVlfuUYeRGhkVSSpuwVMwLfqc7k5nf25qYGSEVINTAVxPUUVmhxSSnR3ScWsaLUTqlqeZUFHlLVSo1LPIvZbVs6q6Su7o1K6LIrUvSs7u7rZXa6q1Jo2dF3SoGzCoSUFRIdCqAhcOUG3REGRVgRODxDKFz0V35gd6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjxh8WDHONyiku40CdtbiVGLRQH923KK5jjQP3BcCMcvn0/6R93Ja5Qy+9PSp64ObCIxIYLFx2vGnABCDhMoCuZdjwtaS6FgjEmWpcMufFhYQEUfRAIzUlAMTgFeEmZc9zgrkZm0Z+nXbJJJoBARRxQ4hRpugKp4tfp5dPzjB4OjD0ShpzSnHZc3wIAxhmJBhQJgWxRmbEIjfhUitQzZpMa1r4AMDAtlty1qxVr17v4Vq1jUvp5poci7YubpbGr05/zuduvPPHJr+ViOSqHqRukBRiZh+GbT6urDbv/j2mp79rDPXN8xuds1a3d9v449xyxq3a03y9UgOFYfqlrUtWixk89Xw3cz5Lcc7N3+73rdjCv/bmWME191b1LSyv9/vWO//X4Y/jlv+65ze/z+7Zu3s/7Tbzv9CQCHjSBQ80MlHzZi38fdXZRGxU6ZJ38oCyzzXrY+t3sfRMaQSg5psE0Kih6jr1K1qlc6in5SHCBIDNRsuWEGUDYXeVo/H7ePaLLY8HCBggs0KL0ka6Zs3QC8o883901aH0lOf+6mvra7pa1Lauh1br7/69dTaOtk5gBhz1JdrDzxqnC6deLn3jGzR5VfpIp1YoO9FohVJ+ZCnBDFtUQVDgKDYMAA20hsxlBFICLtNYCytgDKQwD1eoZp0FqVNUdgwAkzzB4gDTAkX8VelOtZcqeieSuQaAjWIrSugXGEAFFAMAgDzFdMTKIHWVQGyDJ9om7lynfzUMwSw9W6DRCBml/IkWLiTDbs+UfYS30MxmcltTVf6qfgYPRqkx/KtLN52sY1DNSrZhxIxys45LZJdwnKmM/ajMlsU9vT2X5unp4TYeGjkT6QLE35t4TzxQHDlWVRyit269ycr2s8+2+0VT7t+rrX2t65cznpmxHW5surRyUfZh+Xyyiwpe2b9zdI6GXdz9mtnFaHlvu7V7GzTxa1lcos62OWH3d9y53G5v8ct4ZY/zef59/HedvuscLV3Wv1ZysUna0IcKhWnKDJLamrb/+3qz/GGi6kbVrTi40sB1d7k2MpeqUwIXQA6KRFsDOrCpBaskwIkTR6ZA2+DUDgCYFwgXjJA4jKIuJ12dSDLGGJ6Hci9aifsldFuWB3H6cyPMRIiMPHCZ8XCF3XKaT4QOsa3R31v1gEi+8MvyyH2iqCz3hM8OFhC5gLPmOx1Ue7QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJcolEgx3jcrAuyLQnbW4k+ikSB/eNyls34wC9tbgHbWu9ibj+OvAT5v1FKRoNXKIMvY4YcAaak1YYagZFWvXUXhCA6LzoJWScoAmBBEAjTFyojgYWjAZOigE0JS5maqcqNQtaMOKKJGPI0GQlkQaEpcQFAMZvJCYbgWqx84jDMYd9aMshyBJQ6zWUVGzMtMYo86KTh4duI78POtRLKUDcWBJZcuUc9hBgWDCXW5TT01i5cuxu/3U3+qGou+tMblfaTsYk8/DtJ8bidinct5bFiVz9S3KH/et3G2iUGvu+cdfVq0xZjMZje86LHHLes7d7koy1LMuZWq1fGvcrUty32IKcTtybjExEYrO083aklaZpfkjgS292c1cy3jnnYpvw7bmIzezuSncppb25XlT2P3h3X93zv97+/zqW+f/bud/K1/c+Z1/yr6HFA0AAgAAGzZ4CSX6RykjSY07YxnTLAB7sZZtqV+KR1OPtFQ1O2FLg4KBEUboZkQBDzRN5WcPXNGbNSAxUIcImCGiCIkW/JcZTqvkvXmOK1mSJyEhHakeWjUPA47utK6UQyVdyfZjekgkmemB5l0mWdTlnTUi1mo00rr1qekcQQVTdbUE3ruqrp6utTKSWqZJWXQSshWt+kfrtvXZDWqYosp1LRrTUmeWoqiKRpZV0X7jlATQ7DFLE+w3MCvXa1SG2lUz8KAMYmgaa7RePCpJ4fcdSlgZZgkAoBB4jkyaB5LOQOhMIg2MHGGDjaoXqLvKXMscdDBCxWVXGTtvsWTBgFCQQAUSzU1EgUMynbjPnKIDlSAd5IxDbQ4AQbThToRTCkZDK0limJCEI3bctPeEuG3V3Yr3udd4C39ftuUbryDK7llhIpTOyrxAAF7WqSU1Ks3qtJpyX03H5t36RTjGlrvzLp+9ajr3RKHJmA1pPs1svO3sflMzansfr1sr1elu2vmodqWdUFi1nZxq/cy4/u5tj2c/K40/Mqn8ZqmrYRe5upNQVQ4fjM4561vO/r8s+23atfXi07rVfVi5jrDLn4d/7mf63/d/ves/zy/lXWsvy/l3eO8rlwSsA+E1prOuGQzuryxmwhK3lZ09mNBHEyqXsK+5muREoRUgKCG/lk1VyxrWJmTQizEAUK0SMNxH9/sN02+SuX831lqQSRB3h5e9Sx+dlPR5gXa1vLjPMnU6M3Wmgk60lUVum6SkGWuihpKZS6mdBFGZNpshe33uvfUvXrtczXpbUa1s6l6T76tdBanzJ4ccOMREKMZ/2PfoWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACXSKxAH943Ca6WjEP1JepgYrEAf3bcqtLyKA/c24EmMxoA7i43V5ek2eT2ImUMAE6DBgCCpioBx2KvRESSVrr0ScaWiXSOjBF1LOayWr2gnBADCwTGM6vGLAMF+2YI/vzLEyV1UqTrQk5pLAIXAouoYcAeYPEKboBYECSy5tXWlVO+6KEAw6uplMZYaYSAL/iARGxq4ZZByjbhL3diYlOLkshl0b5yG564sAHBqRZ43scbmPftcp4hc3iiXIYtm/M7ub5Vi1Lq9SS67EV1wmN7qUFLSP9OPrB0Ki0saFbmC+8HxC/TX6OrU7UsUtXszy/VkeFLYxvZYfnhlzGu/s7myN5ZupVlV6V8lMnp92MJPSTmD52Oyyb5nK8af8s8afm9OnO8pIzS1689y/ZlNbuvww/9VP39f/w/vdYb5jh3Dve/azqXPs58vVKmSgAAQAATRdv49pMU3qlL2ssPegrLXsp/J38KaXoK2aact4ytRZfxocAd0XHuF8x5b44FWZpLRMjZWjBSBxRVKCiZRMC4IGeiktZmkXgCJIsgz7k3SR1XkYSWtTGymSQqpIJKPKdaS6nWs2VU62PKVqepS6dFd5qd6BRY8nFZFk0pQhPMkzAQNGQOeFXwm3aHikexgsOIjU7kxv/WYRJFeDAa0SN9nW09tQPIpEuCk4YEmIdxFQYsAyBgKTpfpLFMpTRVQWEuBljQEnMvVWJHYwNAgx1RkMJ1K5uboIruk2VgL+KWIPuxWhgOBEwBAgiDQwnD81uFFEB9Xekbuw67MId95VK38a200WDygeMAnjGrcWMFksMe50Wfv7G6R/mJN9Wxhi3IRkQadE5yjv8xtVK27OcRdiHqV2V/Rm3T1rlTONU03HbUveqXSOAU8IzfqS2brQ9NS53nxgh9nQjT0sIJgSQ0ucjocaedq2r1b7NbC5zuPPs6y5r5mt2vKLFSG4Ew3L47jLLv2ZThqipMMY3BUuzz5R3qXPDuVX/qZVIcnst5VrN2nuz1udt1+Y/et/v9c33Hv463b/meWP8yy7/Ms+3Pt58t5Y2lGxgq5QTMDdu8bEtL3eZzCe8O4zMcrsotV33GgufzlfIjg3BE4yWjDHVd0djHKlq/cQ+cifwekBChCHostYXXB1H2XVtQYvzG/x3TQOB+4BdhhrsykR2GeyzM4tEV4+s87IkyyCloMzIpHGSVoMy1HUUkq0FaKqTqSUlQW6Lop1sv7PqWrW2jtRXR1JMbWM0D1VJsgKSYfrXKHlFRO0VE5cQPRcly1oP0p4SipkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAl4iUOB/ONyhwlIsCdSXiXeKQ4H943KuDbiQP3FuAKwdYsJHoElJtMyikbFs2jTFsLNmEBUZzrp6ixmAggtmBoslW3gNBDKQUIFGyqAmaL3gxqS/zCAINUQRCkv0wNW1MhKpFWQpFsyQHOKxd+h4JGAxKAAwaL65n4FpfRlQiDWxQa6KAKHIfcliUVSaZ6PDsyNPDf40TqYqnfGX8oEW4ZpC77XYjbnbV1YAODty9HsbH0uVbdup9DKJbBJd57oDlMDUsWkdi5nSRO9VkE5XEYHeWPTsCaqwBnN8qwG7Mii7WZ8RAKCXokUtlWMsob9a9jYzs45Xpdje53K/Y/PdBlLbWVNxte14jclEe1LqlJhLsOf+TMZbhV/57CVd+n7azyrbgDWG5zWrutV8MMa2t913/1+7F3fN5/V3rHeXdatZd7rHmGVakx3hVijVgeRrWsZlVU3mrOPMmiiROtyK4RHCGpAiNa1b+a+LpqGwjDQ1kletD3xjVC3ZblBSwYMARwa10YDDQRLJ8nbF4X59SVJkSoCdiCZ5VdTF6glW1AwGRNO8sLr11stOykfdJF7Wu99Jl1N+xtC45EZJT36lh0XeHdUy+vuU8Mp1lGHEsdyX23dSR1ENHyAOzlQhOkehalQhn1CCnVgnDBhrzskdzEcFAMBKPS6WYLVJgOAwADQKpfF7F3sPScZyXsMJxXMUERUyUsTTJgNadPpPMqTxZgi01dg7STAYBCADQwKDTQ4AcAazW5XaOMOHAxEALUIPaCoSylKlYiexp2LGAQcmukA90CZO6psx5+k+InXmqWLSIvsr3s7LpdLZq/q/c/925TAgqB0gaXshpZ+njFLO1sOSqMxGwIwCgOr5x6tYiNutLoDfW9QVXic9EBMlsDvQiGqalpLFjK/VzrZ3N2rdWnz/9Yd+9a+P0XKF7pyxOXq356xu/Ym6kpp7rIJddzz5fzqXNX88Pyq5V5br87uNTfcKXHfd7+pzff7vf/nhnjlhnnyz+eXLeGG9fh/P1lrL+3NzDcOBlYlzLFewo+6fLy9ToMBy9T3IVbdqnpmxLdpL17PKhSoAIqAIceGE4XxmpmlpqlNL0WZ6khsFDRYFYUYmU2KSWak9rKkZVf/JNTmJMgTI5RFTdKm8h5om6qSkisTqLutBZH2tu1ZWZnZNSCqab06CmM6qnUpWzOyjM+ytBkF6TLQdl+z1a2oItUds6rMkymdBdCtSDoWvXtQao1CjlNnF2BVgwkpSrbnUVyqFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJPITEhWugAotG2OisZAAoJkE6GSoAAtdIKAMU0ACahESXZBbjs3oFhFL0u4PgBUigiRBgSYA0nHYjGD4Ng4B1N4m66GcLGgAUPL1v7AUARViAjAELCmZfjwUB2kKtFyKJfkGuUkBqrSTDmDoLmCYQmI5BmIBDkwDTzYJA6EIksGs3vS6Qvc8L1hUCTC0JzM4bw4MGxP5Uazp6K1FFKGfi9BLKJwy6sOQReqtzYPA8QYm1+mdhyIpZfdd4cBssneWs+SidhiWXrEMORa9002M6mNuWboJV2cqvpTX7FePJPMug3UCS6asXZRLLHN0+edyJ26mNve8bc3D9vU5jK79FT2OVsqSOTFzCxUwrUkgsZvRLKSpc3vPkrn+/+dbDCVy3m8OZ91qrvH+61up3Dff7zf55f3dftSnlef585zDPdvDPwM1LsCAAABlz86wsYXPu1LHM991EBQi6qXOtqQcsfF8O3c5vrKyoKBynPidPdxy5UjbI4EuaxVYslnjIJNYy5jrU1b5n3+YYYp9UO88/1+cYpObzr17fZTnlhhjn2xXz7hhhhzcwEDjmMSaASQ1F2BybFCSOnaXP9lQq80uUB9qzZqAnFRAi1J3g/dvraH1BYgwcQmF0AGADhCphCQYEEnEGgCmB2gHfALOFgwMosA1RgAJMBj1QkYABsBgQAUTFlAZEsAcBC9oABEA6ACwgPoFwYgGmEIMUsJ7E8izRdAYoYBhgAYrGsI9FzDsIaMaKTIuQ4VgAoIoLFwtCJsZAh4z4thwjh8EOFDjYSCgQN7CzAdUS0QeiSBMFMc8i5ACwdMzccsfx9kBE/jHipiOxB6It58dh8XIajKDwRceBzSNIgUBlkCwwNiA3wlCoXyVFICtDREoGhuZuVKaJmTZPnygiRpxRFCkVR2EAMhmycJsbxGDgJohzlswJwyLiCRcYnDpfNECdNi2bFw2LxTQMkDi1plomy+gSpmblA2M0CQNCokgkTBUSNLJpreX3QPmCD6kPVQMlrUp7omtmszLV+mZmyCZmx0vm5cp3WhWjVV8V5GhYQ4vJxBj8oIciC9AEj0KwRcELJAoj0jBhzCgOEuKcoEEzKRcQKRsowRLSQLhgaOappKNnqHIcJc2cvqZdFjVF1FhLkox03N1oukgSiLukdMaJus3MyXMnUaOg1q030lpxyDkMFIougitPU1Bk93upaOi5eNzFMzoMpSD/9TaC1uydarKp2M01IpnzBJcoGhglTTdN0DcwND6CDoN//sitdaKlsq3/9azddakU00GXshtV+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJRHlLB2MgAKLL2bTkpACi0cEgDGstyrkrZED8Mbi7JWiLWTndx7xQaapbVV7RQF0xNQNBkTYFUJ/qGicaJBjlGOUBikIkN2HIvtYU+mUaYRmhLGAIxa9VOIwwupyVIkA5gGgp0GnGiQWWSSfGELWXSMzrtXAoK4qCqnkZZa0pQGdoUSX3blKnbHE4w0plTTpfGZp/YYlMpkKtrOZBF3FVtb6W5z0y/NM2FlrhMOa8+bWn6f6mjcNO06TlU9mXxphzKXJXKsVguDtSKPUt5+Z6KyVrrcV0sqgbb+tZXaqViLXX+dp2lhljISlBlBn2sT1SUymMzt+GnJYazlyWss5clyXZjV/dLVjMVkPf1crQ0/z/Q9l/a1NKqae1aw1+X67lnvGUymW0tLjVta7q13W8ct7xq0tWzj/6tU1NayeDQNJSoGn1MrIAAAAHqdqITSAwmoWDKVocwlRHFRSuhGRMDNaoCSOBoiNJ6M8gVJS4BjQqEzjcSUROVdhZFxSio8HzIqfJaZEiRSWJlYbnY24xpXaW2aTUEypxWMem7rPSXQu1kVEqqElZptQmhF2inWZspTjeTYajBEkTNLVWJxjGP2TSrKqFCqhVZlO8jeVV/0s1JbTwNKIsWmejQVBUNxFWkjBoGYiDrOWiMrdpLMcSrktYYFKompy+0MVjhcBwMIwrLwLZPWUQRuOgok+iWMgBoIYAqOCGcwYHBrTktKdckil4LcjWi0AZBKKI8pnNpC2yxKGIw1tNIHeDEAZCvCgZsuZr8Ewlvmlrxgx3mxxeAwJkv2V34xMrvp5mS3akFNTdqKQyzt3IbrSiUuGzt25I0iLuBSO3NyiVu+savhUqP288OOqz2YhvVBcs1JQ+8CPu37/QU7D+tboHXgKEW+0mc/DMrf+mlnNyvKALb+OJHWvwM0h3ImsJIGtu/WpK8/avTNeYiks5Py6J3Ic3nzPCk3rDdPlSTmGHK9PK86S9d7Wwr54Xc9/+rFftjfRl7KShWmgJ3T1VL0z0//eYf/bw4xRn8P8fyGhosbCyp1Itl6SkhpuvLH63M3qZ25ZMzDAoej9WlIUxCrLLsC2qCmjE/RX72qKKyRWLvL89lljLq3bVNXirWgcv0xp6Spx6hXsfEp1KJ8G85ZelhQrXagvK5+A61mqE1SkELVmi8w68+xVat6zFD8++A8zkTq9derj0LLNYrKVu5zvXWVviyX749QFTAsDITMNOnWC7DoGCYAcTZaTrCzgGp3Dv7OoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACjaAR4Ncy3KtKpkwPexeZUHREA1zTcq9LCNBjD24dxloWLAQiY+WPFDfvjqOTcNxm6KDjACIZNbiNK9MxB8yuRirCQaCkBha6FrKAQGEYMMIgJUQGASJ6lpcEt0/CZ6NhhQONhcNH1HRQt/gcCW8TChlzF0IjT69XaccyyCVSuArraCVLl50vn/ZkwarHYBtPqIlj2JU2hTZWCvaj81VFFjRf14FAl3LbZKwov0kKsNIpl/XIdZ1mmv01lsCumYoSXYiUzA08yp12IyBFZh7gv402q7T/Q9YaK9L6JCqeVWR+Z6sWMONS0G6TuVWErCrKWK3JPpiLowdeUyddSpkytqKMEF3nXWikLCk5VuqZK6dFiMVjzuyFuzrXYzLJVD1XK1jjjlTbyy5VjPw1Tw7lKaWpGr+ONW1zHLKVTb+zEO1KbOU1LWdLXs5d3+OP46yyxx////3z88cuatbJF5LHGjSrCVWHtcnlHOc7leJoyKBjTJllyOVkL8l6QaWrtg24RpWBzXGXgBYjZE7eM22i723TVY7M6QVsFh0yW1da8fVXfPV8ZOkdy9H2IYtaeV1S2RstXx2XrxXOWnmz2+U3WLoTa6L1CxexY+PC7zBiusfJWzU/cLh+t1g7NEM6SL1RzaFdVeuZhceWHbkS11g+rFANehDbpa2O2y9UiYDKyw0lTRsibGFr8q/3r////742/gsRISQlCNijOSmMNMKN53EwASDSs4icw99sQhaAXMGAMwANzjj1N6BMwqAEKWZTSYQJACiRZ4OAjVHAV9EUhhoBvwZtQ5b5p5c1XMBwwXCZ00VuMFBgEW+ii+hWHDBqdM+lpLlCCVuTTw5Wh1fKvHGtS5+K6hhifBOUL2JKNFY7FbNiSQbUhiMvHDMOwWIx6FL1S+IRyHo1KXahrnwW5MZpYfASZ91zLmhVey/uEOwVBkbgWZeWnVTa6+DWZC7LWYy7LKXFmpNuGIvGL6fz7T3Gpv7OvTyOWpPAUipn6n45EeSqGbNqU0XcK1vuGVB21FpVaxq/9Pco7WfaS7j8fsY4YWqlvDl/WqtTWXMq39yy/OrZwmu//f+3oFnFbuYtTbvWTfxsGNoU3P0+jyvUm6AstaV20E9HCXLHZyyFJFEJ2mJlhb+WK1XDK/lbl0PS6mpo1ahR/fOOE90/S2pXjesy6xTXZS9BUQ6s7Pamdd/spXFnz6+CXUioKAxa2vbGbT01vTDi3rq13tt4tukKeFGtG9V05bjd9qs0aNCZt4r91zFjeFNml66+LQmZ8+3uDCjQassGDS8S2I0N7WuvnOsQshueln0tH7kAqVBU7ESgM8YHIdN/V139QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAh8dMODXdtysi0IkGMtbiUB6woNc03KurRigP0tuAAPJA6goctBxs0LAG0TzLzQJTjlHSMcfaYCgLTTA4GQYFxgnIBgAC4cBzHHnh1iSnUaaUUAzClKmeIfKXJkAkRzE8kB4BVwI5sKYW9jXMW8ccqAOwVx7y+DCMBQSd5KCJa9Jh9K0uhm/Tv+ivD+ddgsMDIGZ7LkQi6QsFvz2xuGasDNzpaRu8vrJTocItfnaWrXwpLcv1vO1WpyAHh+pNRH9Y1Mv7jlZ78FKRx3a/eqt+t83jyVU863Retzc9hOSOR27mdDLsK+N5rlHjUwz3ln/17OeX3O3M9XctZWvs5Y3ccs+TNrm7+8cd4Vs9ZY2vwuZcxwwzw5znO/vH6+WV/8f6o0bScO/D6v3vY234iW70r2pfi3GREoiiSWrFlBmRPVPI7OdD48wX5h25LuRbtWWKxRemppijfQcXHNIk4qzoemJdfpeXWMvTJs5oeBJJg4KcnrsQ7ZxqVkfJbzSTmACYDeQCdFBTukoyJA2TTaTxSNlzde85ZJJ0UD6nQUkpVFBA3minWzKMlVOktc47rmSTuu+k660lonk6kE6SPWjqb2U66CTLZqTIsta2UyDrc2m2MRkEhw6UU1j7YGFrdvXGyoAGAphkZqiZloZvmZCXS5ccqigUOkLRR48LCYQBs5f1zCYoBgFXtEckKYNcdfYYC1A1zs1YIvF/xEbyjehwuLIrTjQMBDOX8iL0srBgNbK19/EySESGlBGRJcLgEEAN9oOmLc3TswEIEi0NLTWBgAGywviBRd0whK/EfiMOvZm0V3Hsiil1M/oVPoDbdimm61iQRl+8IfuWMZU8ZVBS7ccpJBXhutY3WuUEYtVC+jUt9w1O7popWma8hs02cdT6pIPmaGeiUQzzjVHWl9BcyeCM1JyYu3YxHKSWYzFiXy+3TwbOUmFmkvVpzX4WM79rszTY2LtXCvWuYfjjT39/dsU2V7nPsc3br7y1hYs16+dvOxY5vK9X52/gXTZyh7zyWa7h55fKXq6LGfYMlTlSXAOB8ilIcV2ZarVgCSldjmsaSvcgCVZ37G4/IqIPaoROjINSqd/e6915sLFZEcuEuGGJr5qxvHJ00wb2++RA/nKAVbR9+xA+SGHZzUfmQ2fYxM3jtj7uGSw0o++XILqHMsRfbJ2ahpWwkHGTbP2MqX1vfx7n89MNI3VsNzd705j6ZBpshjN9y+GfD3xT4q3pgRyAILQ+wMAiKv3E59DHueDuPUGL9KAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJIoBDgxzTcsRs2MEzDG5kFhcIDHNtysItIkDMPbkOCj21xahFsVYsHDwMK/6uZUmK7kOMoL5HLIMSg+HqOHIdUVUCU3fpQpXzPkxgEFRwApmmBRiPRUCgaGTBAFFQcCQ2YAAjdVYV4PQkbLFFldtMMMAs0OiCgHvGkI9sea9jcjMrT5bNDMJcK4CaoPovZDCCzWHHmnydmPSaNqVLTgTrIAgy3VfUGPu/r9PqyKStpA9A67mRyOylgq9VrNnirXqWUS5yaBysscrl9XUglFNM2cbep692vNRy5XaO9tuTVd0koib2W7ERvT2FvGL3LcppdwRP3ZXCZ+Wv9fh2PY2q/caaXPzalucznjT95lO97rlj92fw7hWx3nX+3vWed3Ozh3D7WOdzt7LvO75hzeuWv13v5b+7rv3cbVw4JpbFbiwmwCKxRTjTcWko5EktGy+K1blsQFmeb/Gr+cedTlq1FatgkQA6tan21eJYG5S402TgUca3HVsJmuZeldm33HHOZX9qzcVcXgyOoDMvOXfiegPX4rQ0pA89XvquOVl0Ip0oyUiuoH8zUK3Vz5iuMnqyx56pfgZ6fKxmisvIxNWQnTtFXOWl1qO9F8fXbx5lbPJim6nNDtEPzy0ym196z6mNbbZru5bc29aQTNtxotvA/HGLSZFqWO33bgbDYuJc7Vjfwu277yqag8AAUCnFUcBpOKLoJVKnedlpMWLXFtSQTHecSVQEg83r0Q0/SwrEZ1MBudJDBftHQYAJjOGmcgWCgMX8Q1YMtBu6/VL5A/KwS6VVp1YYxKBBMolAhUwsOLI7TbQ7SvGozLIKYO3AdCzF/0zANTofQCADxUzE3syhiNtdhlROWQGQBQ0vyKbi+92795rN5/dSSrUmBwLdWMUN+VV6WcprWq01CsPTvYrO2qSmuazwpu639JSqOAoNlU/KpZ819DurOW9Y2Lbg6sVK8pyyjvLdbWVLa52/utFt0lPrPOp3KvevWJuzljP5dxwv0vO5ZWu37drG3hP1uY3qla1bvY7+rzLLuOF3W+6/Hnf7jzvedwx3vHHHeH4/lhawXYimuVrO8IY6gAkUuDk8fFqVzT2VOAUSmix72mpasldHLLXZqoTHH2uE8UDypn0pwzuWCUUov3YgWxA8lwVqmMpyt/hEEaOflWQoHL0PHELGfbtm7brAStM7trEb51Z9Gg11NmRhxG3rdvnULerQt1+b4zXEbGdb9HJ/jWMwp75rjerXkxfV8Zrv4x8W3W2bV8aeXQ6wqLkFddxi0QscMaSVYuQgu3ch/RV/953+x/yt3cu+//QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACAlvwgH823Ks7HhwP01uI1ITBAx3bcp6JuHA/LV4FQISqQCYAqK4fgwjTN9DVehTIDtLMAk9jmGMDAIoCrbtrDzizTMEtHkhpkTpxloiKZkyEmRQ2AgWrK+b6ts0ukZQzhOEsvE093lQ9MbMgaTocBGuJjNS7NRSfi0PpEUrIHmiTQDfowSC20dwuGnDPtZuZNil6yr71Pu3Ywo4EiqH6SYt0vb1PQc1fuVr7Sw4StXcrXcvtXe51pnHccTF+3Lorc/Wd7V+tnKexgYEJJawmaLucuvdv5/3l6u/V/8N5dz1b3hvWWre7ese5VN/9XG9d7c5SWt5ZVd3c8N9y5vvfqfre+Z/+H42cbztCfcA6ZRYPvgoVPZFX+QgPIRIrQMKW5KBDW1Pw4rFlsvalr8EGaAunP83t1eY0SbM9Y+zHmqitMuC0Knbbqq9m5KqlhW5jtfCVGTFocyYhMUU5BWdF9Z01Z+3uMoLWSq0ATo0Vd2UXzVqx7i8iyVlVoMTVsk5w2ZM2U6NfdSKKJ5NCmkpmdnZlpqOJqNnTU9kHpJPdFlrQd1qRpLUqgtFnTWuii2tfRXbPoPNGDpEsVAQgdHJKPSYOsLojv3sgQLSyQ5ocRqQJA0lu9qH3CW++L+9oIYQBmGQ2HIyOkw3ls2lPPHX3mXBeZLx+Hrb4SAVNMYAYwwQImMou+JAyxeKLCMWfWULBqBmAAOoxrCQGOAYYBH4YRA8q3amS44abBItVi55YAVszcJQ6xikUd8tq8lbExoIXFYhuZuT76rzYCxWYIQMDW0FcrSjOLfV/OctzVaNypcCopfY7T9jt+rI7tPjZwnkEBEBUdDGb1JjXt36a5uruqshDu/FbU183yrb7lny1QzEht5YWdUWvzzv2dY2dSy1u3zPPvN7rfV3zLCjzxz/DG7u1Sa5Uxpe2+Vct9+vY59/8Lt3Vz+53K2He/hhvv3vuZ6s87vG/+Pd6y1n/81le6AhEI4wPbDTOeIiH72PCzJSJvLLKeFx5ya33CT5VoCa5Odwsx2GjkIDk2ns9dTFOSxhhZlKi7UbViSmEeMHkwswxqkaG6JiSoF8S9aIsw9FNkAJTTRrWpJCpAJqiykmSsidmC1JqOOndZ85UfUmlUlZDZF1u90kKaZslptT0Xa5u4AUEUufmjzZlZAwQNQoNnCJGPYvESoyliZ+YoovLlW0u2DiKwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAYhY0OBmqNy6a3IQGN6bl0B5QgGbo3Lx7qgwY3luUEe0heCotOlT2zttuxlAIzGPKJd1Jqlz0/nZjbBaavGJyHXCNWjL7xpl0VlrE5Hv8Zcvle0ZjTwg7eICKeNBHKZ66WQbxhK7K8/0nAIsg2AcRWKgbMcKSRusqJk6YoKBqBC6hNklKszFdSRkhLoqRtQddSzcxrWpjooJI+t1boqragcE8FZ3PqWszSZSBohQMFXTWmtaSaabTRSklNu73Wy3QQQ0Ec3M6Mue4S1AIx5U/uV/nj3drapDVISNRx8S1qGX26UiSL07ygzJ5ZT0UuiNFSSp/l8isId6ertFgqHbcpl1SJPwuqpt7JNGX+CkKzuEsHhh9WQSLGXT8PFQET6bi7RABm2lBkQlYp25RKxKZyekrCQ4KjcP23cBuRGhf1eEA0HhEpqf5OzclfGzNDJEWQS2ewyuZ01mrv5ymvY1VJU17De6KXdxx/fbeNVU1NvPPmW+95Uy7Y5MJkQrOnt54Vc6mNf9YVuTHe673H+dzx3a1hrWX75nr/z1nVz5hzCm19yz9+/ljuvv944flhhW539/z6/VlRNJm60G8AynwgjsV2ZkoVz/n2SqQFApDxkwNERZOUhSslLN3EAoEdSRKCuFDcPWWwzk5SsWr8o5ao8QiZh6UDRGdXRXySsi8rztzTHEIpFakIlmBYndmfosYrRv3YmZtVWX6rDOgZc+HADuLxBwKATpBizNSuiQ42PEPCBCFmScLik0yZfPIqL5ocKI70y0dUkZmB83QqmiAtYwZ5NzIoLQPl9ZeWoxH4xMUCgcMWLdjRJI0OHzVMwTTc3WXVJrRQosgXlsfWsxTMVHFKWg6SSc4bo0lnUuiiipJmM1KNkEnbSWitBT93Mk1JJKVTNEWeist0SnYg+NkTmf7dQWUXVh9ScHMQnKKdo70hbnHrbaAIGPfSi2rWnDgapDsZisoIhh/Y068ZlgXCTRUIOG2GqQUJqIcZ+jjWM0MhTsYyOEHNJoAECYAlUajeMZrYxOUDwRBcekj4nDCUCwPPyIBAP3D1Lukkem4X6SJktoki+mN63T52rmG+Olfu2n1hcsxqTlLbpt457rSXnG7r9s4/nzD86uG7e8ewQ/u9yi/RXZrfKv63j3CzvHvcMbPbuPd1bGXO4b/n5Xv3au8q91WrY7125hjveFjLC9jrX542fuZc7jvVvm8cecx3/d61d740voa5AFb791fuwmGRI3dAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHm4FBgxqbcsqrWEA/Um5dLiMIDGXty6NEoQGMPbkBUBdH/YmgVDLM49dp6Z1JTFOxoZLhqpsb+QfS0TKovL32o5+WO3SuGjaeYmDA6QD7yK6mfdj9qo8RCQWtHobKgo3qkKA2LxuKy5onYpVllhQJ352UC9BGQjzox5EgQGJYZlycF8fMyHnETAGxwh6yLIGKZPG6aR1RDi4ZEXJQvl00MTUyLbpGJ5MyMUTcgpoUmYzRMSqU0000E1G5KHzZMqnC6ssrc+5nY4gyjzOfROoTJSSk9T1GJss1UdPmKjQzRSQTemgizrQNzykVUmSWo4y0EFJLNOzXotQRqWktTpIu9Z5aq2QU60GMjj6zYPh1vEYAPJJRxGcbiNVsQ6dxXTC4QYKITY9iUdYrCpyzFr8raWz2BsJu9MFQSCtj8LciTx4qzS+N9u0joM5rTYqGH14jAExCCpffj+NLS0U2kjE69wcsBmCdSGPNgtPLpBTUtD4L6yfMFoBfQkzpNHFm6C01LRMzVaRHG7rScxTO5gigkqQ00WmpzY6p2WtSzJyaMnOKZZ5Ot3TUaqdtmZNdZoyLujZNFC7JqMzAtxAHaZ9xJEHJu5V2oA3+ETfqsmuKiVbdVXSzZowQsA7/1jQFhtR9ZNDD/8l+n2il3WVOSFhozI3tmXqqKwzkYchWmG5FB1ZwUXh61sKjFBIJGsyFQZSVo2VTMIJl88a5ghFe6Wy+dh+iieqR0kILFu+SAMlfvXIN9W5jpm92NQ4Xjuc2GA3v7KxwhMDIwQGvOGpOxoka9YDx5NCeVgRZZ7P5nOlK4eyZtCnlpiH76w8eQYefGm2/gbu5ws2xG+Y8D/OJZ6Znngx/eHist95jv3N+4RGB5ExAjV8KJmJSBApn1pe9sfftSm8Xxj5xExNqBv3+6/ctax97rutqf2h5vvOsa1F+b71iaiZ+A8R91iSmzUl92zhBkIszGcZJEhtmVzL3W9PbCIgx0eEteH4dmu2BvqlD8y5UcDJbxaYoqZ/0CoW7cbW2AzO8TYfyRXqt+eytw2iXPV7Q5AGFrXNoQTMGDO2yx29lzAPiLKytt4cDbBp5AiNm7YYaa3PCeRImqUiyZ8LdI9qZ9tR83mgWmkvTWLUmxXesRMaxNVzxvF9UszxL/0hx9Vf3vHn8T3hv4bGzsbOxqh48ZK6mznUCIyRHjyJGnpl5jWIHzfMfdtUgVvnWKUePI8OPDve976+bZ3u/x96vd/Hu8gUgYrj7z4nVruoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAChtxRlNYy3KdbRkaJQxuZr4NDBWsgAo2ICMCmMABOfAAAAKVCOQ4m8ZYkl6ZkmMCC8ok3MuHMoaM/dBIgFCR4eW0LuMacJnrdnVdtda7kIDbEQNRyX5L30fFx2swBGWprEbG3ZXEvjFI4DjqUMBYMBBIYxpXLksubxy26Oau9njepmIB0tFHVNmrK7YBAL+v9Jn7gCicuJS1kCSCP5bhh7PnFaupoXcTTUMZyxJgqa6xBCOLCl026QK49HDD1tPcBMR1Yuqok6lElwCQRgFDkYQJEkZwQJPEIwGBJox6sIgNM0EMAhM2QhMA1wzEARsT1SaByhnlmAwKpgUQWJaiu90G9UvLwJHpKKYqwt8/EBwVGZfVuRiTvJL4xSxNwG5xG1QR2VUUvll3CnlHe1K9zdDcz32pn2pq9T2K/6xrU1LbqVb9JXw3cq5c/ert0JGdx9sDdO/aqqy21UBx22kXKn0BPAAAAFa2Jvi6IgMtoCkRhCTwm7lk+8tjzJvi7lYGuf/yUOfLLJC771XBhYSsY9NzryimZnKS+dq4n6XYZRH6zbVxyFKjcbm/30cBIcwcCCRiwSxWZFBUFDZ/52eFM3Jgdh0GA7mBSLB2OBDKxijcysbEKE7G4svar/T9/7++ZvSk3y+b8/T5yZ/9brPQ45P5se3pRO3m6Vn1VO5SMbASihkqRJDIggQBQAQYWZcMWVAIeCkIiCmCAmSCGF9B1VOZ0FVi4SXTrICDJkEIYYGiCxFx4oz4MsIs0MnpUpR9hlPVTF+3fdhg5cNRBKNN839whJBmeTEZomJWZKuZ9muofKww22jDizClTfQhr0CPRAEARJsT6OgsM2tIu0HGPtGIAkj7NItyFxqjSHUaZmtCYfhsTSE5ETFSXnYlj9rrft+n4a5H1hFYJxwb0vf2CJx05O5c7CnJeiNUlH2pEpmWT1LWiUDxmLTdSTyGtBWVJTUkolEsu0kYpOWblWUayjsrkenAaw4ldhjLH8xr/lYlj/v/D8v5GHYild3HIlFje6uH09+veuS2pTcp87WEoqWLGPL2GGH442csc8/wwqVM7d/v6/lekqc/tiphYzuemlEGj9nRbQjNpwK0JXx0cxQDM8OS03VmFKYNDz1HLWmAxvDRcWrmGxRVltRtCwPQ4DJnYXWVtIFoGncn69a+k7IWbs1ucMRT1quzm1naUgaYytrQMROxUefjXPQTlaVZnZmz2WMoSmTTTQgiS3H17b1Z1mvr7//XXnxB3w9uufO7k6/ujh/n/+YAAck/d/8Q7/4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfykEymNgAE5LIJZMK0ACRyAQwdvQAKt6viw5jwAAAAQAAAAAFm5dLqdyeHJKB9MlwVsLmHkcwJMKocZABZw5xeL4WwEIBHRKDLGBbLobYF9yHB8gXBEuK6SxIkPNDcgYYjEflEmyLEMH8dQ5SQlxspRBxSicZggAs5xjisXi86RiYugSBcFaDwHxiMg5hFi6VCDDkhiEMAqOJlEmj5QC6YN4wy2CMIsUxOAhIKUIcPkSiGNguaC34hqI5RdWdPyZOIqNCUIgRcZtJ0EzU2IaMyRE1TMZkVjJJKpndXorIoaEyTRKkNJIiBERtlUkT5szE1bNaSbJGyv31+XCcPk4XEjRN2TSZZ9jzpougv5eSSLy0Wr6KqSn//////wABQAAAAAIogkKGIYAlQQRAw7CpDk0dqaKYw44xwqJq0TgX8OYeHuXiVKRuRptKIngmBHc8XDUujtTWeRRODDl8lx/HGOEurHqSBUgyRkigHPGAJQviwAAkDI5OH4LsO0eJmarWYFhkTgJmHGMOHCSyJoouF8YUD1BXgkQXoijxHugsopIhUUpJFM6boFxbGaZLqHsbGhiSxSedSdy6cSTRUpemYGi0VVpqHwumRkeZZgZG1Ny4tRkpFGuvWp0t1TAbi6Qy0mkMkCgX1D0YzUtHUt1frNSRZS1F4vGLVo9X/f////wUmO2IgA32LxDoCsRQsEgCtrc1XyF20GTQ/0wohKwrAmrMpUFUwZmwpRxuLIV8QO3RAEYuumqmAXqacRE3+Q2l7BYGYdJohBj3mDcGrdiICMAV/ymNP69biuTEIGe+QNee4vITQn2U+yl1IOjzzRCIOk06NVpBBBVVMdgSLR1xX4XTInGZ4tabZSzmkeV0V0sFswNLa1uefmDU0V+xdcrmxZ5GIwQ06dm2mxxTFMaF9f1rs7KYJlGGNurQQzEuT0qi05ao6POdxoJdR0tixJ61ePU01R2/rZfQSqm+LYXaXDtLN8pbFBYnpuzfqzv2a2UZuztTLPkuq3a1vuVr5r72eWO93/y5l3V+lx1v7+Wv/uN7HLWPctZZc1arJpP8aFDW/O2RT9D1lpknIdB7t7KmRqH2HCgUjMTCpWBmesTnFUwsZunS0MTWyn0wvXs2HrnG4cgojuaaxq6uw4w1nm3uN3GuKwGFRY+cbe0mcm95ttca1it0Y5Xh/McWBFono7jK4Mz07Uo5tawtq1gcnype4ULbAlJStqnsqdVMFxrC3SFusj6HvVdZrnGHvvB1i3tr43beq1xa0oCHNLA0TLBMFRgGIQVBGRZiGw6zArb3i2sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJUXbHBWcAAqtteTukLAAiQkFGGTiAAspIKVMU0ACkj0UiDaMsciHJBK408DAETAAEYhBHQPHuG2VibE2vv/Wdhdhf8GhMpzS02tNrwzSYbB3QsYzcd3m4aQ4CABAFxC8AMEPuiUth9/IcwoZXDcNv+/bWFhFSAwy+GIORRRthitiYiAQuQXILkF3EwEi1TgkaQ6Rax3Hpn0Xeu9h6w6J5d8tOXHR/UEWETETEYhAlC/8v39JDkssfQRhh7E2vu25bD2Hs7ceHH8dhyHchy9H3LXYsRUipExExFAFBFBEV1B2Ju/D9PaiDOEx1B1jsTZ219r7lu+5D+P5GJZScrxt/H8jEYjD+Q5LLGFjDD//WGeef//7zpKSxSUmGHM4xSUlJSRiMSyxbp6enp6e3n3Wtc/+fnUsYdDw8AEf4YAAAAI//4Bh4ePnEQEEAAAAQgBdCJEIvoiImZuu7n2PNzc3NzeHviL1+XvNCQgaEgLD4Uf//wkxlHGb3mhYaGhoaGhox73ppvuCQHsPY7x3jeHsPY6y+ut6ZuSzc0NDQ0OMYz/n/33d/MvNDQ4xjGMr/+mMNzc3Nzc3PveaMYz5e8mGhoaGhoaM2MYxjGMY975v/ZXy96ZuOwdhoaGiBxgJg+D4fg+D5uJHX/BwEAQBAEH8uD4PhdMdZ0RzJ0cYYPCyUL0mg+QN8wDtglYD34TyGkg2CBPgmAYFFCkOJMPzDAYqhCAkDIsjPhv4AYEMEFy+L4LRgtGIcOIfJcACgeoiLkHAKYGIg9I4ViIpmJOmhXDFAaoGwOgcB8bgauD4j5kdNZfI8ipmaizxRwbBAWGBZQURcwfsGRjUPaBsMVBzCkO4kR0rDxBaAG+DDGMFwCAY+BOgm0TialMdI5JDRmS0UhznTQTWZnBS5fMzMtmg7ykQATubkNIiQ04szKI5pMlEZVJjZzRy4mmfUxDxW5Ppk+T5BGpql8vigUSiRU4XklJGSKzFMxTnzRVOlV6bGZuaIa02W7dN0Lt9F0rrbWkl+tSSX/6P///gIBAAAAAArIZWRkI/MPBvEOPAFjS5cQZE0XWmeUiktA3HoUE01GxkmanzIehoySCRLEs5usxOqeXCUNEjRzAyLx0zNlooLRZBBRICWBzCXOE4cRnJZJE2Sl0zCRmxKF9OXzdRRGBExKZmZni6XTIlmdqJmgX002TvQN0zeyCl0WWXTbs61UFzMkzemmaXXrL5IpUUkkla1o90HRSZ7t6aFM0+222g3+pJL0ur6qkv/////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH3ZBMBk4gAOPSCYDGtAAnekE8GUoAAsPIJ8MOcAAjgHkcMalIYwDEYLeAASCABAAt0ArEDe8ggdKA8gQFATAEgVwWgXEJzFcAaAhgcUbDmi4BySIhnoN6ksZBvpsQMuEoUieHc5HE8J2D3CaDkSAnB3FsTcbECWLPFLuDdcU8gJPDkk4SYzQ5JVLqjBExHAHyC4w5whcQgFAkXKQ7Rjw7oogujE8LJOk6SJDxTCwLoZkgo9EUIsbjKRkjUnEC+x40LxAT6RNplowH8fRaKRNE+RxWTPjiJmUFl4pORY+tGkkiinNVILFmSsVCLGyZ4nSUTMjI0sgdNVup0UaV1XZFGu1S2zYyNkVMkydff7P+6Tat/+v/r9f///k8KxM8opiDAXQJ6FtJEvkmBEjiFQRsSoLuIwN4yTQukMLsOIdxeJAkjU+PYkhGxLC4dQMDA8cWMgkzUOeJQQSiZj6eQKamUMhh9IIwoxh3JmjmxIrWkyx2jUFoC7jYQy8I8llCBCVCeHRJjyY8CiUUkQtwcwbw5YwgjQLcJi5uUS0eBKj3H8gF8kVF0umBmsuJE8JEUDA1H4YEe44CabEugXEyopHDcpF1U8ZMi6SaTIjYbkqX3IxUUVImJdMjc8gXTVBnQUjd0dJS1N+vZ0ElpULVstFTKRratX1ezf//6////+R4CQYuw1aUQTABc2ISAYM8AalD7CApOjKA4CBAOCI2KOIVAwpUAUqBqC4C4IDFgABlYsggAGZZAHBwbEhc6F9Qv6USKGiwy2F9BgilRcwpUWaQ8SgRFAWAmxKyZFkggCjmEEJIXMGokBTNFmYsgcwZMMYA20ENJkQaFloDwgYnDlROrHkybJMQQHgi47RC4l46x0AQAhiQehxC5R1EeYEqFzBIkXHAXC4SZcPBYyAUBDFIdYMRBq4iouUMulgaRPGhWZRg5FCAEQIOkgRci5PiyBmCBDNCkxWw0iJEiM6RUbiDmSjVMoukXjFEnCfIuT5BCKGhuqaIM6BQI0UCOEmhpGx4zHCsvETIEdNUVspaRkkqtkVUP9N3QQZ9v88iWTxcMnRNEk6KaSlrNXSSrbrRRQWiYvqU6SSXVV/MhdBFYsNTAqNxFNEQiSPMUbANCgHkxogSDo+AERGDLJY9SRAakkHGMnD5pMsRSKGmNMMjdGIGQmGQXiSeY9xoQWTHx2FwwPDYmapg+NCEgOXU8Ug9A0TCYeKiSWaTInFRwecwxnMMPPmEHHhHFxMVigoPHGjw8UZDDTBqcNmY88gYx722iS7IaQKlzo+eo+5roRRFOGxx6DZTpjf1/+f8dlZz33MezTr/7qacf/Z9L/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACUZ4yIdrIAKqrPlw57wAJI3PDg3t7cpwKOOBh7F4lKjACPA0+d66JMDNOzjRQZFEaQyhoQFBCEEJgx6wBCioLMYVUpLrp8iMUWYEiAGkOHrBuMEBIrBhSCIyTGkNXBgpfJ1WRFxkwn+Z0mM2kqmJcpsPPJfM/LQpC06wwVEM0IDBO8WaS3YUVSFCkEJbFwy0sgUtfdU1WF8ZjLHpXa12Fv/Dsmyelks/CFgFXYQ040O01aSQDATPmbQw6Uaau9Go5TRaxKoeZ1D1O7L+4RqmmbENQRPwzOwYzqFQTO4yGVQ8/Wb+y2Ao416GpdPxJ/pd25NzGWFams7hq3rUipYzLeTHabCVX61ams5U2cppcn+zlVq/zG/NU121lnzHX47pu5U0zjWprVm1jvnf1drbpcdWsatn981ldxpsiOvbX2i2y/qiTKaX3iEyQJPQ7B0n6X4ojjTrgSpXOSdzWEaUdgN8OUkRksLY+XKVhK6fOo/3IxM0+4UJTSSx6PmpDlczb75VPGGJZ4xoa8VyHGi9k3XwoT57i8kZtanKFAj1o+rbeM1xChSOVpq2fRn3jdig5i/FrPrVzWve43Ci0g1rM+fPpGaNW1o0a+beutat7eDF9q/+uN29dYr9f23mu6//+DW2dY9pXumiIlUzu/DQi/KukFR4wAYMMMTC48weKMrZTfss1YjM2ZwIkGOkxhCkv8lATFCs5dMEhsw0kTGMKKTIiseNDGR4EgJrAuX3QeLrAoGHQBHMlUQwBSKQHM4dZ0mkthd9YVfs2/IqCL+C5+EQzTqrtIAnQdZImAJOosXSkrnxYHCQYTCQEbpcQTIuMIuqEtb5HNg9Rf4YWlBSxELLyYy8BeUkeZjWRvF6gGSrYMZmW3zJlDMRXo+T6VSVRbLBYnsjPF2uWTS6W1g/kdZTIchKpP6NrbMzN6iVSFQntcqVYUpknChpfS4w4SHRWyVhQ2ZyhMTLDiu87hYcYV4trbnVsKzkwxdZixM27duWbE95313s9bW3XUK8CNFxi9fuFwm+6AoKllQ+DatzKhbGL83vlllZ0UjkOgCEwUFRRiTFWoh3FpNwuRCluEgVbkgrY+o3Gv71fPlPSC91PWLFy+3rsExQIOMWBrhU9xcu/zFMPqcihMTx9U0zdy2WrK5qB/nq7MtR71nt7jqOuPLn3atR5sFmWTGOeyuVdztmaWtZ6tHs+daXV5r67NerXqrXbTZ0VPKeVAIaWNaejE1gEXdY0OhoqRKlm892s91XoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeHeUKDW5Ny661YQGt4bhqdeQoNag3LmDwgwa3NuWGI6gEOAbBOKOqyMybBW02lERigkmCjgGHGBEAIc/ZyQwmM0J3WaP62tKhTDEPM1ygtzWBGWED9wldrUYcTxdBskbfmeqRhBEugoGQxSgBN99G/z1LrcqsUsQbm+SBFLqXGQlIgxNjklcnC6gxmTRfIAAqRWLBPIpl1RdMS8X3OFApjiLzOiblUnS6ZIrMWucQLybHUzI2TPpUTQ8cNkjx0xoHU000TpRTPE2aF03RZRdRYvKWktIxU66ZkimkkuXUjpieorQek5i6kVGSjFBNlTJ06kUVovRoJMkn2Z12U60l2/MTV2ptoZtnCtXb0b87TQoJBoNQ021E4LgxJA1EszR8RhDfgwzQYsYNAmDEICdUMQA18u6pa7E8gnMIBRYFaMny5Tz+oEZAUOO5EIjbktBfh4qV3Z+zMUCcRhiGPMS6RwITarY0Gcps4yadbitQlA0DviTLsq76xuXy2reuzUrdgHWZtKoCtUlf5TXrZ5fQZy6amcs8OdrU33bNN9itzHPufb27WNnWdjVy/csW88NZ5YWr1+hv1afDPn1qtvnNZcx5Z3zV3VrVPjl2trObyxx5hhjvLf/vHeFy5+Gt5cy7vv8z/LL7DCQCSOE4uW109x0vfJvFKmocuhpKw6WJYDGJiFQO0QaHGTFOshEmCs9prXQQuOIhex+Xxt0DzJiwHBUbp4o/jxzBrS8kl8ANBaNKcnjsVq0vxTTS4MDSXdGwcGTegbfb1WU2+3Zlj6hrrWTqK0EDw01uXi+bsDSFROE0VU2QMZkaG5w8bmY7DxQQUiUUj5ktb1rOvME1LMFoF9Izmai4gxKn2WkZpNUamZwwKy0HRZ05gzseRZJ1FVbpIIqNKKlLRTQQZB0DVbxpLsRGAiAQMo5iMnjma3HbY/0ZDtK2WXn7381uIVClx0vLpCwkHATz1BAABIEBCgcvBy4w4h31/ltWGmEIRtRuxWE0cNtcfOLr7pZS1CUQ4+70GRksYcljUXep/ZdN0uWcD0cFoAjDI4SAnQMOCVGnkynrclpZvGnfdQdBlq86ieLqBsajKonzYmzMugggMwRYgROmabVGRobHGK6I7DIwOHUDOtkCmlQlFlGqaK2SRL6aSJs5QNJPpmlA+50oGpm8hheNlmSaLpGiD0EWLilqJk3U6lGCKVJnQOsZVr02oIH3Wg1FSGqvrQZBl0a0EVtZkkHdnWzXc0ZzMXEXT7vcsohx0dz+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHSnJCAzrDcvGvSCBnU25dCcEGDG3ty4W1YMGN4bmkUHnB18DKjrRxkEog6MAA2GoLRCHpeI5B3RLtU7zvPlIkKqeD8XjiEdgAqDQScgd0KzVpORB9wG79NRZS8lDpGGElxW2NHBwBT2cuSy/BGE7XehF6flsb3jXqT780dLQUW7IjJB9upet5Z1sKP7H1Mpmdta5hhrVuvrdrfJy3Zs6+1a7vlvWNvu6WtKqTGiq8y5Yt1rf3YvnN4dxp7+O9XLd/eeVS9r7eGu2rFJUoLGHLGrFe5nlnvLPn4fY7X5hazv4bvZ/rG/jvWeNmvy/jdxwyx53VSIZjbhDQPQ6kwZW0CGyd7V//tVAQvt5DCxNCExgEMk0gIcYQK+2HPlEG5iHIf8iy6nUHX88siZNg98BqD3HBYYSkzNonXYc5TnX0W8WY243K60DocDFgjW62mQOGXlglCKDWpqmpMuQ4IgBYESeWjrMTx1AnyHFwnSOJaaAJwJzYgBTpLLyi2xoko4UyWJt0XUmdPuVXScyNCSUdSWkmbIF+eTMkDEkSgQ5ZmUTRaDG59R83QGTNz6SS00kzqCaz7HVGSzRAyWpJCkZKWcNC0mi5gpKtaazqjGYVuxoYOitbqTdN3OIOrWyaKkkzy2oM6bGiqCFNBjubTwslpZR4zE//M4h0StdeFI2oixZay3nUU2gKnvRaZC4oDzaLt3QxhUVlg8CynkseSOZv6KAotMsljMBNmX2pdCmkTrRnuoHGEAaWTNfDE4owW3JRBjk1P5R/GP6npWtRS2pNpSsVXeghSzuA5wSqAIZG2ebEjU5NUlYMSDFOGRXw3CeO2u9wYbhGcYKmeyxZI0/i1mxq2KsbXP8JKPK3ML6sazH1ZeLtWyRtahYf1tiNBrPAvXW4UGSBCi3ng5efdIm6wtwo9YF3sGeN5muLnUK73GI+da8X4vmt9S6rCxExoorjKEEPX0hoZKscOVebkU9RbZcl32TL5XS4yjREpejEoAgmUyLELjQaZT71sljT/0kJm5ZDjsVLNCMBZWaOKxx0mzvW419Tqq7Dz1oGEQoYKQmwiyebOTFgJsihFBWqXuZ/Pw0jij7jXkOeFqirQ7Y3Wp82wARMbjeeOuU0/Wwu56ywluFBT2K27tNlVs4/dxjV+pvKrrdvO5lvC9nQ1d1dZd1nhY53t7GUZ61Q4Vt9yx7362sK1ruW/yy3+ssq2VNvWNz+47s/93Pn75lWx5jnjzlzWWWeWvyvmgpqolBXlDx8LFN8JLwNSJP3oCuAWv20v6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB4aHQQMbi3LsL6gQY3JuX1G3EAzh7cwFOaIRnD25g/B1nDANxwpcmZm5RSTnZqdXOEmUNv6yNyHdlAsD15+kXbFpA1d6AiRrPFfhDMUzJlY8tnM6aD31MDMRZCllCIwQVBhYMjVagylEASi9D5baF9lBbMEJ4phCyJpEccNA1gLogpLlQwTKxSMiaZk0DcjnQKpOmxmo+YqWbMXyYNyIUDpMmbLTMkVF5FzEyJ9Z4+XkVIoGKzM45fNUkTQ2L88gk6JOzQuF9j7miSdkjB0VpM6SCiZMjVJZaMpmZHTR1oGjOyJqiaou7GyVSae8wdJaCBmtNkk2paKD2ulNVJMimynQTTspU6gtmrRM3ZL+nBwh0i9oDFbohqCrzWLROxdynJcy8Dr0vkCT78wA7EX5J4aV7I5DA6s41Kv4rHLkY39Qsm0t8Hcgagh4VJBxtMICJancQDa0yYF1hWlfxCMUkiAIUs6RzRipnLiJ9AixDjAwCAgL8Rg7iqkgVigcOFQ2PoMWEllN1MicNS4bGikGYkEp9EzLiRZSQRLxURLKaaR5V3NXsWayBlE4bmpk5qkky3WbIIOdPn1upJBy4ZHjq2WzppMorsXVIpKPzRRu7JJo0UUGRZJ13TZNanXTY2SZ2QNkFM5iy0NBaC3Ufao6aDIgYHrLg7w2lAZW6TMVj2n/VeAAh0kaCByYASBCJykgQgdTDvhOhCEmA5beLrZmBYiZzRQaYXkJTjUzMQRxihaRZLU3Dfd2es/LttfVvRTfJhSrR4dbbLajZq0xjahjGpGLyCTcTlxoPVWyXThkKJGP4FR3Nk/Y2qI8mXaFq+kNuTRcz4Qkk5bz4QksacZH8kFXvlQu10eCnc1ZZSMrnljZ3kNQNa8qWmWFEhq1nUkSrmhjXCjSMkeI2RGo0FuU64+2OFFY21zxLHkltR5fMeWMyMceG2S4w9neVzAvmlbMjJPK/ve+6Xmvat83z6UiOPPSYD+h+j6j7VfUp/BAQtTpZyeSBgAAQAAKzSWlsrXWhWCBiAkrRNksEKGEedaoMMJVQe8F2EYx5DX3tWmucz9A+zRoO4FgDiQeMxIIZtfAgl0tunWztecjeMtGpupmXjaAyICRarqAxITM71yUTtPGJnKkjiPGMByc0Hp10hqxOptQP4TIVTNAiVbHBgYHFnh9++aDTUyVOM/1MjVGpImYEsFz1Bvq+E45MD1npDjIZNRPxns+ve8rPl+xuTI3vN4iueZIMJWWgoXq0OSrOu3KBBnpmRwiP2NzfxnSHzv1Yp9yNqrYJYkSf0ruJSld/V7RIb2M8hyVj7mebeV3Agt0WLZ7Givg3ghK27vThFqz//effMuqqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgPccKDOXtymCwIkD3mbiQ6Ev4M7y3K3TagwPwtuZQZ4htDiy5WsMJjyr7CI9CaaZR8wCZQUUOt4E0BpSCEqgIEzFOM9A2XD7CLxm4qhgSEAaoRApWAHMs6wxPJJ1dycyQcuWsgGoEblNn1Z4YlCG0SaUzCNL8jMhmKaznM0DLky32jVPATzt0nmpC2GjM+UwQOlrp1DYp/F+Opr3BbWVTH6hOFbHeIczxYTe6gws9XNuG1DVC7onnbqqpwxNiujSRqyVk1DfK5iisSSfJ2Jl6wwXqdvExBVriwq2LBfSxZ3sRrVrg2K59mCrYkM/XdX2Yjk3wH2reuLUhPs4g1iwXvrCntvcLetf43G1quJNtFZ7imbE/epFZab8+iF5qL+HKX1Pmw8XZpqhpgGUOEzDuIShSuY4ulGgSepWGbjMqVayYRapXT6+plQrlFtuUT7UAHM+tYHmikZNnMGvr4bPXNfjUlh43CMuhSJpEjKOa/mXec7+Mf+c/7VMyCkQo45Z1ovXpKvVUd3aiVEiVTM9/5+cuZeZw6u1ftr+P/9aZlm9VUoyCoaCZtYaCYSeDWp73XPe//fpSQLamLiaT4ELF3UTyzapBJYSSeMIdB3QXDEBQB8DCwBxlfhQBclZ4hCgUJF1VdIYt3aQlWmkagJFBW4qVBVBUaIuND7RVLL7jMuhuELTMRhVrOq2IGgIVDSYpepoGOMMPDSNHlhgIIzuvvOVVovNxlLmCJ6PyFGcBnS5wYfxxmo7JdTeU5nFWeTlaXZUEDSeM0mOrty9hMyST0OMzS/YgbLPOnllqHpuipJDH+yqvlSbp5Phm89inp4vuzG709E7VqVV79+/qVU1aZqyrmEo1BMtl92j3TavSD7chjWEotblNPavz93lWxct6pJy19/LGtu1OztPcyu4402fcc+361a/rV+kvV7l6xuvnU3lzHO5fw7lzWfMOXv73VzUxIouFEhugKKnNgmw3R8mYyEKZRxEqL8ojucK2/0Sbni7jzv87sOV31lVqfZy++EVjrqwFH68ze3bsTbREvYRTQCaARgmJMbs1d5ctw417OmuPSUPqqgOWtfVHYHa1q1JOZVMfDlX0lv3ObSLnOYcPPOtltH6bTarTpE69Nlth0zz/qw6ULu9du9Rys9dzEUj7N74tDiGna21Lmf2xlp1udNIRb5P9WrRPqx8LmeB+5lEfu6Ypqf13eTtyEN3sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJM4pBhWdAApFGWICj4AAhSkEuGSmAAzdIJdMU0AJUbgNssM0p0lowI1ZTdSYckWjUrQDnfADvINVsSohxmjIEsVSKALoYOwNIdFc2pAuQioxBiKu0V3GVvWe4cNytS9eg6hNTELKKwUqdRKPb1rDkNYch9Hca4yhLRwXbd914vG4vG4vGIafx/H8awuBcVuxZlb9yunoH8jEBuGudY6Y8Pxenjb6O5FIxDkMQ5FKd/HcgCUQw5DkQxZfyGOdjb/w3G6PmVSpSXqWvG3Ych/IxDEOSiphb7nhzLWUojcboZfvUowjcOQ5Ocp86O/MU9eV188qTCnfyHLG6e3T168YlEolkollBhdjFJr9/UuXKenp95556+nty/P9YYYZYZdw5jnnYuYVP53vc+4YYVKTDGkw3nT09veqe3T9z3nfxww5hhUIKJwXiIFxeKTw0LBYgiMYKpmWWp/bi2+4SLPteLTcvgbkhqPd8x3+1KdsQseX6fRW1/2gT9u3nnnnN06nGGGHP1hhXrZ/3fbGF+3n+9516eMSyx9fPPOnqWDgIAgaDCgwwIJkoXC5gUC5958+5JMPijowkGGMZpARF4ntHPh8MxjjYwoYoYKcsoIMeKDIPr1f/SVyBnRrpFIW8NTBsBHEXCuDZsQTDV4C3jJCxAAvA97C1wtB1gFwABrAKoWSHh6AyQyQuYuC4x2iA4yZEiKEiIQili8ZGINpk8I0EHieBmRXTwxpARzjQuoKFKEKRRiLkoiZk6mRUV1BRqZIG44AxOSRXGAZi4x8iuizRzRkhSw+jpFUSyREWaVAvoP4ssLqC0TYsgnS2PQnocQlQnoUsXC8Wyiam5uSRsmfTIoaMThOHnUgxmiRYvomhkZJnUKS0lpU9SyfJApm5FCyM2OAgh5RcWeMDE4bOcLySiLEWmReRNVqSpJbW1TQ3SQN0qa02XTda1IJ+3c1MS6giu6OjRSW2ylot9t16/3/+AQAAAAAAAhApRyEaD4F4L09QWALCAAcQCSPwKwIcOSSZdC4BVy+QTZZNJ6SBuYEpPlwaCVRNS8J4aEuPAxNI9jhkeTP1kuUFqJAYR3NlEsLJN1JrRJQaA5iIn4l4wYsi6MkdpsPcupLQSOFxEdBxjnGQ9BCXiSRGIPxDGAQJdMmHzYkh7ID2LU3st21picImZ6eem8kjYvL6KKqZmX3Q6mTdB0zqnZJBnUktFFVFBWv7K00Fpmi5ogaG6Ro6r/36zBJ1JJbe1Tdv1X////gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACHZyw4dnAAKybJiw57wAI84fAAzp7cr1uSEA/CG5cdx1hk85CNFoBSKQt+DdEzjHHJq2QJZGowaYyZ4fM6DSgHhFwUTk1wow48CgTEMe6hUi6rlpKlqDq6bbDVoxiNReEpUoJgrkDpaa4t9nana6rUYa8+0aWMzp3nKfWZf2K/Lakihm/OxhnTXpc6lZ5oeqJbLWcJ+l5N84UYizGkUkimvQ/JbtLWa9RzNC1qLvlLIao2QqCs5YC4rOVzSO7OSnGHdwC1p3nSkVqtqCoa3S47lNiMymM3JVPWr28ZThcypd8+t2/uvylpZbV5rW7mf6vxGzZnb9jeNbDtJZq7y1ez7lWv7w3fxxys0uOVNhlT9w3Vy7/5d5jZFAqgWK3FpRCrTgubrCgyFQEqOJ6c4zLBVKOXMdLJAU0uKFIk0Xj9hH8fjkji5CRF6TI8Tuunlczrolw/mZ7pwq+tGy1xk62RtQyaHvNuaND0+zVqPyNGtCvJHgzxYUGLEbZrPnz5ijsiHMzEwxasuWRiz5csKleMSHQ16LRylXSO8bL7E9tsV4T+N5IOr0t86vXEaDWL94+IVt2rT/6xv6+M1/9f/utLW+s6r6/GK4/v8bl3JsiDQNOTsQRUgiIg6LG00rf/UjaIyHUSJNU5b5qhG22Yg4suVZjbKTfHXQNiHWoonuSAQIOMygLjmAANeMAJBIhEwCATNDxgCMBwz0kldZRZRIWc3z/SB1ZE2zcobBnkMLvrbeFCYVC48DoZDLH6jUqoK6rXelM4+zNajFGuG3EypkuHmEiY8Q6UNioQnjyN5xUUFWEqHqP01SwIZIqDKMpiGMl2JDzUX2I9CNmapGZljJ14mlajUJirtlQlxZGc/ESsm8pHLEGSDtzVrqNJFP5HSLZ+ytsCSPpPNubwEduqs3Dsh9JGZrpmPaaFK+Y003WYaOadYVTHam5zfN80B9K4+PaaCwQrvH95sb1beJfX7teBbGs43JeusQq/eHPd7arWHG3b33GrNnXgS4gjo5Nxnb4RfT8FLEdOVzNMhIsJ6h+tcbEwt0cFfMuf9XbjUt6B3G+Kp1Q3aW5QTsEMtymqXL6akTke2U1YIHQlU9LnLO3auevrpU4YVraNFCU1SagkwWsGoqIqOwdBzQrsQHNDRFohjCh4sdYsJzzRpLCGIMTKkJVDENDphqSXKDUGrFMtOQ7Ne8vo5UOtQPZIhxk1BUGq0VSlyiOK0jTcKmd6Xq1Mj5E3cdI71UvJZnNRJUZOod7Xf7Qr53sd/7zAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAcub8EFYyAC6M9YEKxkAF5SQTW5SgADxcgl6ytQAFAFZYAYEuR92lR5nritzbi4zdJIdnyefYBBtaXPSVApW8r1Rh/oeITRYaQwMrtwGWPsnnfWzXzeWihsgoYQ8leG01hEWUB0tLUt5zv2HMGgpuewwt71buNIv4YLA285urerUspuWL/Px7DuGdW5OSjK3SwzeuVYZt3stWeXsZ3Oxdtzt3Cj7ay3c/71reP09zXL+6v8ysSjcpu9wxpaSxrPeuUFXt3XLPb34YWLOV65vuVazS55Wcs8sqnL2dq7Z5yr9THDf01bf9wx/9/9vHA7IZJcE8JQndWDxpWaYH2V0nB8O3fuTJeuhPP3Fkjndo0ArCbjzsQUeO0YL95ILjUvm2nuXXka5WXQMSgjx0N2ESYCZwytrFSR4ULAYLZQbWg018oTkNIVWRFuUy+3G87uduDQUzJbfKmOXbmE3Xr4Ja0OdWNcqXZTyvT0ti7dnbtezZvYdt3odzvaxp609nu/e53PPOar4Ts9FqXHOtfw12z+eH5Xssd6v9pbP87etZ/rHHdnVFljlKbNjWP9sb3YxxpbGp6ax7vLeWqP+c5dv9y5lzD8uWblTWdbWPbHM+VcMucx3zLeu4973uOWsv7V58pA06pLOhkyYjR78mAAAIFAYCAADIwGQ5AA1pIBlzJwhgNvgeCBPk6OMDTOAPZETMxk0AP+DA20JmMEzdMDRAAKCgMoSQqc32AKKAZkaHvCfDtDMDSbsJ3JoR4BkSIGXIqfdTn2c0hpYCgwLGy8BqU4ATN2rdlU1IMnJQMWA20H2AKRAzZsApG+9+aM6euwWUCFA9QdwuQ0FyC5DW6a7V2ZS0zfbQQHSNoLnA2YDBABGgXDiCY4wbaBqz///W/qbEGA2WDY+SY3A9RQswZA8WhW4uMMSE7////7+pv2//zIlzRMUAMwVS0K3JclBwGZOCzB2EXL5uOYQQnBxl83QwAAIIEAAgKgCKQAHnUhnxTGUTg6ADQGBn4uT5BRS4GOicBootKWJzMANQgkDJRWWtBMnzoGMAMBAJAYeDjrpm9SAAQkAxCEw5YPobqSzA0NzdAUuUg+QDDobAw+EzN9Sln2TqDxgKBALQw+ADGYpAKFbtuzsX3mjsWAbcBs4SIGEQ2Bh0NgFCP/oafsAUDAtADGAzQuAnxBAToWd1f0Fub3bQQEZiHhlgAwGAYSBAYUACA4euOMG8AoD////8ZALhxH6RNEsbi5BmCodIGRMli9/////////kEImTZPl0c8Zsfx3oFw6blw1J9aZfJxG6fgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlMdc4HZwACqW0J4OYkAGXd8S4Nae3CtLOmQPSluPjjyJEJoCShgFAqAGWBWEMMAiQVMBoAkEDpzCZIoUzDaRC5ASbxhGwSRciKSCVPVTVVjIU1bERSwZaylS1S1ilVds63aRsnW+16GJqfgVcs6oom9PQt/nbfdh8EMvUHS7gJ1HhYyofEET2bxxnDoMAhhiyrWuuC0tOdMeKK8T5RuZE1Na0WaQsAm80pOBM1YVu8cdVo8Pyuep3Li8qbg4EWd5kbvyyMzcYhydhvB+3mZBUYOuJn0ESmNsjhlfrSXphDeRakd9+oIfSISSYpHUk0zK4/G6SES6IXJdTfhOTsESi1L5HlcqU1FIYrHZXUik7KY9JNU8vypLF2cpa92nzsWZnKfo7Wu5VOVLlatlP0dbWF7dvu86ljBymBOgiPTUs/PbdCaEEivUn42lgm2P0xLDmAShCH4rtkM4KuZRCs5NE5DGIpzSrDmVTLSphK9RzkWkmKYMBZrNupYjTIj5imVRmUgKg9EjJxcyrFNGRsmDyyJEKlhECQDEQMiUKp2hHW2Wm51KDp6jbxCyoq6WvegqY/WJ6rEyy62Ly5+q+pZXvLiy+mpf7bO+t25Sq1VWYxZxlZEstJqVVHMnd3FmrLhRRTkJNaEuNarr///G9f/ygZp+i1TLVEQumM2oMMEDnRuAYkbhsx642sQ5Jw0ao28gzp4zDk1Rkzw0xwUwRIBHkk04Y3VVtUFhS/VMVzLWeqhkzSXljzLoHjL+w076PKgL6rCt46TErMNO0u5k1G6q+S1IBAF3mLLAhym4TouR/hDibJEW0xR6gKwAmAhFYS4hQKYu4CyDdNUepNEGIpoP1CRzAOwAGCUjmHEbrAJsQpWnK9kfl9E1MlSPzlfmioVlOtHTyFYU6GoYLEmxuiwsJ3HkfJYUC5H6XFIK3R+iSiYoS9P45mVsLcdUazWqYihmnfRYMViQ5xXSHM0NWxWJikP5RM0NW0Uyei4YmaChtYTNhPM0bMVl1d9Ggoa9gvaMUW2Hz60sWvfPq1rWLjWf8WhPt/wo2506wOhqCrnFen6WXwng0idGSDZVwukJeBto9YGAwIDARCBcQmQtAUsWQyiTLbSU4U132iVshCrkml2iriKUm0IpCw8SqpIiaRULTISGbCR04CI0C5KYCopZqMjapRqAJNWYISEtNn7KUjpLNVyJlpUzjC6AmUR1Bdm0mwtMvjrqeTVcVFLOfftbfxWNTjX3xjKVLNSf42qzKccvzQpE15G6VZlbMWceIjaxENOlo3hoqt24RKfEoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJD3JHA3nDcJ/KyVA9jG4fWb0SDWXtwuexowGXsbiVLRR9HR0yY5MlNzLAs45YM6eTJ0I1syMITCUfC6UAt0HzmJ8arBkHAlFYQ4HzIZj5tIl4g4FM1N5eIsS4alCX6aub7KroqP02VeS7WnpgNkjUtbIneh4X9UkmkRFEyo0WkC7TCU3LMsXLD0DNCdx6VrN4wfNIsvwpWs5tUryUFKmwUCawlARbLyItSlpSSgVCsE0doK41WMLnGlP4z2ZmnFjM1Qwy7Tuw/QS1m7KHTnaOQT1BTQrCU5SKMO9F7Nyaprj9ZagKL5XL8zOU/5RaE0+UTikNzUpkc5GYtK49E8pNncwo5uWdzpbVNumt0WU/cu2dZbrVbNTLOiq3rVNyvh+eefMKbPHWf97vPn85h+qoZEjQyuEt0gcZoiwHYkaZH+6qHQP2i4J4MMGyrhDn8hkk4HkheXWEo2VFlthQ18F030+W86G1H1mfG0lOjR5WTzwtmFkNo9adfYXwOJzBtYXx6dMzhObGA4FM/Egqh03ZUu0+W0fWXXQnD6HWJ+lOfdv9S+VIXF7kLFb03kaSN6jbTiR9pm1L9WZ77fa+w50fXyj97c9Tco/CATT0gQuEYuyVNBEOBZtUy5LlrisWu1SoEiDCjgSKODSMX5Ox3PgoNPePIpONhEAYETTXATBhDveCiiSZAUBqgQGWqRBGiWfposgXTKK6ISXT/PdHmwxaM2GJWoo21udaxG06U6UTVLR0JUxcV92au66s1AMANek6wz/P1Pq4oYJKRui5KEzjHPFFE2WEGFUaZDABUQ88eiS4n8iTFTyiRJ+I4V08jpYmGd70NUCEq15WrWdKpsbyi2raOV4lYm4W7e8z6V7K2OTC6jQW5mj4x4WVS9ewpaK15ZhhvH28Qq21T41aWLFZd+C9pau61rqDS39vvUK2deuLW3/XNbaxmTIaWFQEHoaW6Q5ZrdeWkhE9PbL8gUhragoiqNcRHIzUkbhkFR8INYeN0I6ZBvTkFOV0xKVQvqyxV07tBUzdWuI00yuliRWtXxepTmNJSr50sKpVyliNz9nti5JdQyaJR1GWAFBUVi2HoFiQRhBMAPR55Jaz+scwKjmFw62trSdNPZvLi6OpWQo1p7Sz1KtMu+z00u8vElhnp6c/ZrtLV3vWwX72WVvblutt+tO17K737O1muTaZm1WgyEhKxQeePAWKVjLYld72Nnf6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB4R4QQN4e3LvrfgAbw9uXWn7AA1h7cuqPN9BrKW5tKGo4mHs5kieYhbGphQYnGYGYOEjDAEmAwcOEpqKgBgSlqARKAkok6oFhsv3KnBhTMYFbEymDHXySJeGMUEkstCfb6kjS3YzH9NelRa0llHHei0SlzXaB9rswopLY9Goy7gqxvZjjOlwTNG1cRzlgnaP0/ap+Myq6WAxPorLFUt4kKMtOD1x3/akLbjuAyvHrbCVW4UKtKKJ+/vjN3ktoWrSwq2zLXN4sDT75vFk1nEWZijuH8KutYn1nV4l4bLrecwokHGpq2xndq0tmWbeqfd9Y7yWnve0PVbWz9V1vFb0xHuFGjZxTfXHUPs9bHKlRlSZhiBQZmkmQPpjuUYq6mdn5jwyY+GA5+MuPTJBIcPwcHHjKPRx8gaZ3LqZ8wdluKmLhIUsNg5ZrlMujyVzG08YFikVXrBT/SyToBxGEi7ckS+iq1KsoSzqApfbd2AYIebjEcoeyjoktpYdPhJlGS1n0XFGss9HImJ8skeBVuOlyV1bwnnrJGzTEvc/iBGi2hqmaSWDOwxXGTtUara21hxY8HL3WWF5l5d7XeqWrusLEe2HGBeJP82zPAjQdU36/GbZxiu9Rdah/UKt6y4gZmlrPjFK6za3pNT61S8IyruPcvVzBZEn2qd+twtO/fxdx8u8FwQoHBsACpFNTVPTHICAITAQITFBUDpgsqaFFWeslf5VZb4oKNROtN0jImPUb+Q+jk2FakqfWWLliWErlCmz+SiV3ImEuGaETIKt8lup25GYmkbqlxpO9pJcV2dqj3pDiM9nrY+c70yys+IMtlTZsa40XdXj9O2xM1XfWkbW2FAhNlG+ryZWwZ3Bhoindcztr+a9/JFb92q9iXmi6a4kjLLElmh3tWNmtnvpNqBJAgtkOJe+8UtHeV+9x8xZnuaZ0wZvP4dM59Gvftvdse0W0T/WK2r7ap8W1rGcSarSb4v7V2d6Gbm/suyZtjFkDXLj9xgsFPMxOlNOMOTrL6gSCZIkoMAAYBCSbWGSNUtfZPJZ6wEBOm19H+gUyTjb6UU6LMdGjJW2GTF+qC9LGkPEVbSJ1//VXOlQVrHkXqnJ2Hcoam4ZiKF8alM81qpRJwsOiIjIYHYiQkmoZTbEBYWJ0BqSzqDxLIwuSilo6ZQLIsaWM63Orj0kKAzCKR4UxEBZuKIvJq0bLmE37UTyBVM9dKai6sidfNapOWSrLKOOIoRM3OU9TfKEVPjaiHMy8lbNRbhOOn5tQzPBnIThcllVPBOUN27U5/kTRdmHwOA8zoU1NDYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAd7eUADOHty8i7X0GdMbl3OKv4MYe3LukKfQZy9uYMUxCg4W1CgYITInR7NJpk4FGTypJUu6H5qffGIWnLlCE3tWNVqaZvy7kMKtZCqGOolTL/NtBemVP4nZLYI95QnA6InJRSqniOdNhLZlFaH52HpWhmmmeBQFMnVYxP3jE8h1aozXItMqtorm1ujJ+ZXMEZ0tu7Pb0gxYFYMuXGP4ingMUrC+gxnGNRhlUbK8isUWddYuprw7tl5Y9ZrZhP2hzezMzCr4tozqSHEXFHytiyN9Hb3EB4/g2ncY2LPZmmDS2d063Et3uI1JWqNNGj1pnGcv4Etd0ra8eJnGaXtbFZHVgzPqv0+ZxraTG/h8XT1HgQa2bj5LKNaFKwyWRDqBSJujQmdN1pnPhyDcKSMKd8uPE70qgFuUvgWMIlOCRCbKtzdVBWTQTBzEmrDiVkrKq7NSkAIEr8uy8kjncYLjOnYLrTc7EroBKP6qQrTDyaD0fkw6WKx8lYnQj4eTGhaMSkbHa0nFxpg2ftzddq0yxaGtjw+ZaVQwoTrZdKyYqpS2ejgXSUY0OkqDR8ppS4vWqtit7+1TOnBklPzFdDFH6hYogW0amh0XbPZGtYs5A5rlEzPQGcxT9HqblL7y45P3nV9ujdgq/Gs6PU71KRTjw4Dh4pLCbRDDQEm4y9DLCnYeVOudZEEJjG3xc4aWlKoK4sFVpFLo9NPHDM7EINAypfYsNBsSOFVoDpEL7RMRqrlbfjeXZiWo7W4zPRI9rZUV8himn49ur2nnkDPxyxLLd5BCTuOKwtWfxIsRsjztjtDsOT+ihYFAwKKGrXkCVq9ozfaja2sUq5i2khwK2xO9xrUdmfM0NhpVvtPq1oMdff305QMytWIDHaAsQ1fVknw3x3rM+cJN97metIlKxKw83cIMSJLDgRH394rFDgK36an2IV2yNCpJd14s2vvGLQKSUy+vqe14uMxbT6tmHWub0v6Y+939LPaW+vXU/tBHxxI9RdPpeiWxirG/MNlBcFdNV8Hqi8NQY/TYnKlEMw2o9Sy2VPJKaOBbDtxgoEYwTC1XZsjIV7vJJDpAKoy919eR1pkLLrzMhk+V6ezvSJFGa3nS8KW2CSzQodIUPs8rDt85UfsU14LY9Vjp5isWJFxPaFGjbhQmurVFvifwJok9X8TVIL6AxWpXE9H8TwmNHsbe/e6eUj2kiafuVbt9oLlGh3iwp3uY7rVbOdNZiUbc33XcDdcsU8KdtbmF9HtPXUWsP7ribGmLT6HWa9b0jSy6he1IMa2oOsakzEtC977i/er1zemaagaNLJxeTtAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHbn2/Afl7cu0xJ8BjLG5bbfz8B+Xtyz/E30D8rbkkYDStGSDbLCK0E0+G8uDjmU8HtSfarHqri6GoX4o5Kr/C1FLFWqmok4RGyUeUljK789hYtNHfjUkYyFHBGOTkNGmKt+cwuW7aN9NX3lPQawnMFo5bbm5+zOZ/wG2NdwQrUrtjQh+pIkTMkj+NSG5xIjcw2i5bJU63SMtXF/O9YYeFRd1uzbFqf7koMT4fvG+zjGe50pYrrEZQvlZCZ4z2u4WZ2Sj9hbLSu6LTC4XexWGSW8CZqY23V4NW7bl47/bM4NkCLLmfc95NQfBltaDNus2bywLz1zqfFfnwt0z8bpJB8JMJA4Z+yyTrIp4xZSwKQyvQS9fTVxli0lyP067+XZZEpY6ynTozbfw+oDYtylisoh515qUz4k+QgFYEakddD3Kns3p5CazeaiST4zMVZyIensQzN5u7rCGBaavS1Va45ohJAHVTNnSNM4JCJl4xdeYcQfJj7GtNKnrrHW00ufCxGl2vHlm3Izo8vDRKvfeXuuw38onK9ana7FAtHkqmNCuYvPPNsNr2HvM0rFZT+5PVu42t6JsrMkgluGcLx2p9+sJZabuxuOHj6GuN1kxZBBWvLuR0tG3aPtnbwRrHaY7BO+03fot+lZ7JtOs9SPNcnb9a9b3pDOpMeoninLEdCpQ93dPwJ1crpZE/Vp6ZXKm3mhZuRSyMMimL8Ay6IRpE8qIIWqOJ01G8rVsNe9cHVuNUNZcqTkVMcjE9dzw7XgBIbLPeJ7wokYN7UrjOywaqCaPTtzq7DO+g7rLCxZnmrEapZbNPvHx4kNwi1YGZvzFixMboxRm3NYUaBh/SPrNYFs6h4tmeLBs7xul2yfcK8W+sKildvXu26Cwwo+qw4rC/3Zx8LFvFhQvrD11vGKUprdJ82xjfxnWt5+6Z+Ke28bznPzrHv91xmLH5obXUXhPKnEiXTnGEyn8a5fi3tK0tJ9Sx0KrI3+pnoZBttJtMKfdyliccr0EuaJLgcQ3ZmtFIOtwzqWK1Dmozlg+hxHhY0ejgOxLpZfgavg0QIAhNPtkpSsuEVoWSlXI6x9lrZ+noJJIWySS465K0Xwe0nIn0UM+5NViCb2I28kxRymmKikqOYak06VHjc8xkmCicL3VHZuS0pVfDrT289otWKYuyGhMkoMOut7Zaisa04uvuUalzKZHNqPPxd8PQtyUHnn2N5i/ub6q4dURstLqPh/tz0w9a+IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3howQU/AAD5D1gwp+AAXrZBKDkpgAOdSCVLIzAAoZKINAtkBPmWo1QSATQMATQ8EyhbPK4CXIkIpoihGVzl3wUwswXEUAcTbpv8jspYuRztQrl2Vw3DlFRYyV3xsxC9bsQhyKTmsPwyaDSTmNevG4m/7OF+2Mbva9PG38ZwuxdjOH4llinfRrDkP5euzd+GGdtfv2LFirPxt/IxFKmdPT5/9qpzGVxufuQ+/7vu2/8/lKKTdd/4fl9upKIch923/h+/GIYdyc7uVxuN0/zEYd923/jefcKSkl8bp97w5MSyG5XT3fy1rCvT51895973XMLGHP/C4hkHAwEEFXC4uqTNk9Js2BPHRamYoB+YyVYfhwRi/ljVaGE8E0CQCGHAvqNztQInImAoI1CPrDpDo2F4EHFcPxNw2kO47LHIiEYpd14m/7XGGZXZXFyZU4nHFJyxrmO7sba7IKsrjcPxuX08YoJzOnz3uvOP45DkP5LKSxUt6wsfnXyjD/w/f1Uw5u3SYYbz/868YpKSxunp6f69PG5XK89VMO5yunt5VJZSS+nldPqUOw/FipSbr09vUohxy3ff+X54UkslEvp7dvvKSYjENxun7v/5hK43T09Pnbz/PPPPOnp8+09Pbr555287HPzzr09PTyykw5uvT09Phz8889550mBEPD+1h9/r/+I38+QEAhQtBmJ5YTELYCNwwqUxlR+C6Yk4AAgCSgM8BiEAYILVA2BCuizQCuAWGIIBjYT+Ewh9CLEcQQDEoDgwEQACLgYxAJSBw2H+C/ofKJEDY4NAnSosY4MiiLCgS0KBQIkTRbRJcaB06WiNFmlUnlE8gfukxPkQJswI0vjkGZeM2YooorWymMR6KJXIuQwihuSpWUWS6dLpECkXC69GeUubDYNyDkRJocBFDQi4e4MeQ4mjYum6TmxNFIc5SSZk61upSI7y4XDQ8mpJpuZGjmZuxkkYmprUms1TdaNrVfSRm9/WplMvrUhb+ipN666l/9T/1K////gAAghAKGoUwx0xE0C5gPfC3kfYlEWoLJw54NgIBlJ0SwDEQAgAcILhhQpFQCsAMLGYEBg48JlEECHpoAZEAbDBsABDwbeAosDdMT0GyiNR2AHAG8546NELnRgCgTMUCWSOSK50nyCImJcJ0ck8VjYyPMutkycLJwxTJiUi7nUNSTookuYlcsmyCymbOmarY6imZoOdPKVTcdk3Lpw0KiI54wRW5w2d2SOJLLxPJPeg6SRisl5gxacwPouXygTh8mzFReNkS6YqdIxLrV/q/z5XPrvQTQN1NatO6HfmK0UdLZbf//////4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjAhkUHYwACu+nItOe8AOHmHQ4MYe3LEbniAPexuKz/QzDCNvWBMybMIHA3CJgVKIwrraYW8agjMIzI8qrtLTEU9FkmxIoUCrtsZMBfi8WQruS4YS8LCmIu8lmgchQtdShHh1ad81V5l/J5hjqMzYnLmsM4kEOTk3D9yHLErlcsxq5xCGKF/6aH5iBKFw3/pHYdyVNYgR03HjzkWbdfVJH2Hweyh1Imuh8VTxpnD8W43T40/77Wzl+UTdvTXJNE3bl9JL8qScxlcvypL9yHKsN25iMWKSxXt9uVPzsYyvOpYj7v2nbkb6PxH4ftxiWW7dBDE7DcXuQ5RwxFLsbvyiMcpKS7n+qmNPh3uH/++7z1hzdfPDP9/rDmefN565//nyvb1SXq9Pqn7Uw/8N57z7UsbtwEiPAgAAAAez5sPksIuRfRSV2TkQJDk8Yh+oMsbtTzPXA6WstqILk5uJwIcZZ7qwlUFcDmWzps2HKk0519mhW5dYeYc8BUTSt8aO/w8iQ388kOWjyrGzyMjc8qxv4DJEywRFeo7KyJe+5KXj2eSs7pXqORkmhw953d+z2ePHneag/WMaxqufqmpZMQ55HnvH8fcARHZWMD8yneeIQMh+Z4BHKD5Pf/TwB1p8CI4PgZpB4i/U5YQH6f///3ET7kj3ZNA7ImTISVglg1DVQqXG+TnQhbLVk3gE6HEBS7l9lwU8EilLp9OYvEm2XhBSXFGRHMTfSxY03AqWyG1GvFjkfWq5C7mdRNl0AsGcmwuZdUNtdYjEGdLtwrNaSyuVspfYbicsRgJc5Ik8W85VkvxpJ8yXsyhjIcfZKS4qBRHMdKGsLYxp0zBCixG8BmNYkImrrSeQqWFGi1XSHStqFR2WIpkKj1g1bXsRXMz96yw9dXWvFYldMrmaVlZcWfUfQo1m5RKU5ZzlWVMhU6lZdZgvZFMqnqtdPdMSu2pVTIzahPpaxcQrfGaXrjGfX5/zWua6tmtf/80xev3bcF7R9Gle2excb+N5tl7qFbMXQqwqXyxVKl3thSiCn8MJ3c0UUqosFxXaGxVM5w2XTipaO0UhSnDBcEOc1Qio2mtolURzLZ0uNG42T7fPp2HUR9e8lo0FaYxWMnTpdb6rWis6PROuYnuLj5gysUxJOCUWpnnsbPTo6eOisqKoknKlMJS2VrqYEicuQwSEZeWVsTS6E6PrnLuNPMtPaytgXLq2+tZtnzM8zMtbmb3Zs/bpyZ7Pra62llz2rbZbJ2cara39vZ82+a99vyZrLwlcCqVPDqiIBuT/kSoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHL3M+gxl7cvFPp8BjL24d6dTwDGsNy8E5HcGM4bnTtKpraRbJGG/wspCU3IRHDKv5Dy/lcuVL18va5Ema6ELP+8MYUjNOyvxp1JARZ5X0Dvopi7qxqaR2rjgwyyTb6vyJgpWlIzd7NqMV6K9XXardTVrsKEfyOpQs49ZIahTqzVW4jqZ83ZatK5jmSLxCmItyoNJuP4/m86VYdTgkDGZVU21wrWp69iSZkgvV+ZOus6iQWFJKKG4MzNeslPWLWm2XvoL3EsketHsVihQZpaXvNGtC38vY274j1fWtT5r9/N/a1syXtCi1rr+tJ8+26zW3r31eChJryJdjaUxzH4BVncLVSxFQIvLLQq0iYIVCEBRtiSj4CSPBWUuOKNOZim6lTFEa4Fd131DWSLIkd9dT3xVW5Elq5QCzMoS8YBhh2oeiTsui8l2jcENcGIHSmpdi2Cf5KrUZa9B+F9ugsCio2i+tR8zeVUnJp2nVTM9Tr2x1Rnz6eKxHVAZr0gNrRC2uKPl/OcvXv8sVmldaP2Vkju9s0WSCxM1WB2+ezq3csFliwppnt6xYqto/e4ixsbli1hX1IxPotJ913TXjVhP4v1v7tGfQ7SRn1cRswHT6LXdbZjyYviC9e1mvJDi4tCjfVYNMPvWDGjW3iFYNLve62bOjSQpKF0tKX0SgIlF1SesCoovayNesWfrFh2bP06WiL7aSLcJyGVg0D4u8TT5t06YLA2cxJuw9Lf4yweFyqtMUMCtBj1tN43JFBETl0/8ZEzKxDtHKUjzGBbFav9TKrlAQiZjO75jqzFOZZY2ZTjYjN6HbFq1RTb/P7DtePS6NU1BD1qtfljtd3NU0ttR6v2Va7he3lVx+7SS612/dxxw7nMT96xqtnf5bz1Wx5h3WG948tW62fatn6tnXaXKzj3HOZs1sML/cv3Z/eequG+Vuayxwx7/6w/L/xxxx5nhvf7+ziijbqdyUeN5f1kyVXb03u7VQAt+1NMoDLYCTtfpESLyV+GvMGdZ3mmodwUI2EuZBqCaTrtpxbnscVUo0QGvFKashMoQBiAzQwk9sxSTUeJSR5CESsqjHTuYsxQa9E9C1A8exWhiCc0ak1nPKajeVoOrA0pt0tmn0yetTfnjct3a+b+bo/vY/LYzb7ymjWr9rKm1TZSmISf8sKfG9bpsuOVfpd91Uv3rWG9Vcd3oxPWb2VmU75um+tUzvZbyw5+O8bWfbOO/tUuczupV1/M6vamdb+2cbti7yzZ+5yty5azyq1u5Wce58/LK7zdj0oX9MxxXfG9RSlTAoJel+/Lu739gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB5VwuYMbm3LnjSdAY1RuWlG04gxubcsUnpxBjXFwhTvA06wKgRwWEBVIg8uR1lzQRuVQqAH5HQ8WBmxhychkbGWq/usFMZBLLxlotFzWxAkST0ZYOjZpYQ55nZw8kgf5ZjvMIW6t14BgHMBWAoKD6kSBbnNRLzw63Zw3oEQiHVUUikuMXMhjkR4A5lFhKiOiYhlR4LzmKBgfkVNS2bLTM0SKspE1UgfQTNzqGXieNzyloGxcTOGyVSSZjLp41RsxeJlI+XkFoqXVRRWaoXYixecyWgt1nnWySRkkkxeJktGZrSQpl5I2WpS1syKnNVrRNZ5JkF0GZ3XpJGxSk4FcNav6bLZRXlcmRFU2XS3iv16r4LSSFJ2kti4qcKljKmnP84UOSqXT2ECFgSIRa0AdRaQY4DROsKgwCD99EqbQKBL9OAAICRM8XYJvWmAEuzSP2Ig+xITCBqzXiGS5ybg4QImDAGhwcXhhbaSOKEAAqF4/BOaBkPwuRZOgZtILgKxq5oWSIBbkb5ytRg6c1IuXlrdEXjpPZFanSWYKc4kXjJFbnTylpJIqMieNklmRszKYyd0UmWzrRSRRozzpKNjFzJ0a0UWdE4bMkkbGTKcxRQSd0kWS0aTI3ZNnmSZiSHgwWCs0mdlGnViu5R99dZf7c31A/X//k//9ousBGuGOKm6KTKURX2sy2HWfQ1ap6GEjhCYUBqAmVDAyBmWMD+wAxUMDIFlpMASoLBDlGEEYACgMGEJyacLJGmYKrJeKnZgw4QAAsMKKMWEQEcMomddA/FDIekW0IGBq3k6ZcminSWcHgVvodMCYYXpMDnAehifybJQvLPlQBBXpoMdL6JpIAtZdJRh1GyRkO+pbHDDydPr1psSKF/7//q9v1a2tqf/61stFFG/13d6Su9JV1rUymczPU5fklJueQ23pJhWSRD2IVi7PsN333+dcRC0xQohTZM1Eh01uwC6zWqkxSSp97EcKpsyBJJYFj0ZgjE4DhqCEYp+lbTOgG/EStkR2YoicBhEkbAFSygyjBZjbyyNMaBgfDCwqRqYKABxAFmEDoNIVsDlNTFQg/q03Cf8wQHjHYGSzbVzcJdUdOUqOmKi/BMMXqO7QUpgQXRiz3D45rCtpsmqnwdpndrWd/9dx/HUp7/8//1+M6UbXTq+rZo6Od/fpS9aVsgLBIyiOjIwcHEIEDowB0hNwkYHxwNonrihUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAdIkDeDPKNw59EW8GOUbl5qONwMco3LQjkcAY3RuXlHgjFfENAERMxlnkCrBsVkkqf2C7sk5GBUXgJTCIHGHhCsIOHeHW5GAwCNAFcLomDQPDJgUGNBMFhgkFxQLTAwONZAEu4YPKzNEtmUOepQYLNQCcii6RyJxuUAGF88adCCTokH3GIBMkMgc8y7FImRgW/rb4FRIiIpQc8WQBm3AWsDmkQIkWzczDRCXPnzVISwuqRLxOnEjYUqw5byySlWkYserIFVs7FBBSX///v/q6//b/2/b9b901Lfe7UkU3ZkFTJ91ukgiymdklJt1rpoqNlsgicZNSFTLUp01JTRF3UlugtNSLOccVYcueeRFTaX6XKz11xhQB+4XIHIeKCnJCwhMEgkcBYNFT5GKAu87zhQTGKiFcaWPFF7zBAESzMsHgUOiWIYBjVYDSyMHl0WBjd442RQ4AiEwCEUaWQmBRMclUZksmC0YGAU6zforqsVQfFPQwSLDOwSm4ZWaSpRIKMErCdgMf0EBkBzlGhgOcBo04LASeRUmNQkWZhCVpuMmmINLqkSpeyRWUOcmsvtpKRmlSn9vq7+v1/1f9X+v3+6/qe3UtrIOpBvrpKQSdBbOz02u601Mtkqda2RSPK0FuyloooLpOp02PPaJyH7oKgnxBljQNTYZ4ikyJWiMr2bs7tG7j5KNywQC0wKBZINNoMA5kM+NLcgLBckB70EABBgeiIVF8OGDhGSIoFEURmQqj8tAADmTBF6hwBLMWKY7b4GuLXnAJQeasMhhvFDASY6NCZ/GnlABJgCylLcuoaHAgsFms3zcgZgRQdoroGPnhbwmPBEh7KpOBhc1Pqc6I7IKXzpwixusvB2nMTWgLa2msrKTaTvVdydUcU3r+91L3/V//+ur99VdD/Ssj1KWuitB0VJMaIz6lGKlpqRPLpO6dakUD9lGa02RbSTUitFSCKSJmgtbUkji1VZjTdZmaISpZ972nBzDEsMnJVS5uE/jGoagaRQa78sJAUFEDJRadVAZqJMfcRV5nBa1htgMPsqBIghMMhcwS9BxeAT0yckYiYcwMcglKtv0xjEDowYGVhYwSn4N1DF30ijU0FgiYBcVcyOrOEbwgTMRN0vIm+o/lYhhPlEVkAB6K0JMiSJPF8mAMsPEHmp9ox5qozjlHTqI6Ijo/cxVskWllXLL9U0Kmur//+v////V1fq//1b0kkVOtbrXU7JLdarpmcpFzNtr/XAV5gKybhebPTFP8lkCD1wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeUkDcDHKNwx6e3AGdcXB5OJNwM8o3Lk0ebwa5RuVTgA4OeAvERTWcYEu6NKleeHFQOu6z8QNBKAkBOIRAswsNHPMwGuBVsgwBCTzaekYYeCNcFC0uMYNCgMUy5QMEibhpHmFToriGlFXWnzDzFMEC8OCq1RQQGB0CYKrAOWBACCYXsXCoVfISA7apACEbGeBwIAOuuUDdGVEFxSJEhpgaQ0JyICRIukTRLAOIkkVFpRkDxZNUhWp1AuiDGIxM2OET7qHYpDJr1LJQnms1t/t9f/3tVXXW7ezf9+pbM99ugugg11oH3oL0lLei1Fad3TWpBNJFFSzdSCmZTJJHUqS2p7ImJ0+lrRpto9zJSBi7zZ0IyhaeSIYQoo9TssqX49MCRqNsowpIIIAJkwpIAKypdQ6QeQRMUBkb+FPGCQEbC5cqgQD8Me+CNRlDZ+hS5TW70aU5IQmMsEOoQDIUMAbZTAQkOHKExEjQQA3fZox5y37CoAc1DiRB0xSGG09z90kkc2VQYQjZz5VavS+TSkUGkAW+59lOrnaZ/e7sP77Cdfhl///3vtf+r/P/XzUh8S/v/+6n/+03TGtHSewAqJxhsUFQOoQBYXPpDI1QIk0PYo4549RNIqgYs1chwbAbs0wwEwvFrjirCSeMKWO/QWVlxcEBYvGgkMpBmlM6kh/3eGRYZIHimrjBgndYqDR3BQFiqoFiGDSiZZGSIZgQkkw0T7fRnzIjDQfMPhUiGosBAuCzSpYMF2A2oAAsFCgLS0wQAYfUUghngEB5lAGxBx35PEAPC+IuJ1A2aoOBG2YEWJkqizQBRBOpMibidyfTMIs4upICz1G7qcg1qlEjLeOl1Oy1oETdZ1vW9T+y+/9dX//1P/9fW9Fd6qktJK7JLW7uy1GW7pU0WpZsiYvUgpSKamuYugpSLLRc0Wo3QZNdboMbKdjYUKHHzXkcpW4VNGGTGWuBwx6Wsu+4eC16Z5smxwHZGQyDggpmYZACpQiLuVEgoHDBQgXyX2DiDeAQcFQYZuQoACA0UhUPGYBO1YyoVHDTuTIaiiKZDGICcI0RhoIjwOPHicAjdx2wrFh4UADtIiydNJJ0HBkeAru7IuNwiI4yuMcCS0kydMTA8Q4hQMmtD6ukYuYmyJsXh3JnEhUkhCA87vtUbrRss/bWUDF13+7K+7+/r+///3Wuv/qs+rbp1/WhbZnQZbU0Gos6Sb0UlLQMlLoKR0K616a6z61LSZNmWYIUHRU7uipSaBkPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAG/o+3gzujcMquJwBnc25dej7cDHKNw6O+G4GuTblYyghmvCMkcnRBWjB0NS6AnOZvOQPyWNnFDYDTyqwZPtKCPmJuQFSU04vW4n+YACQ6ED5QKmCBgXggU/mAEJ0Q8zhMNIdBl+GtJ7NuTNZEGwIsKckCGR3wH2AYLIBn2HRiSKGus8wQQAKfJgO7XJYvFccskAweBCyIzNTxYJ5iBBfMnTU8qMA2NUFiyUEz46nKruYEs3U6amlJJegkXyBMyP9//+399upv+/+q/azdlVrbWyl1prVeiarekmdTRTdSCqFVaanSUpkG1qTXVWugpJ0NJ0mpGiSLo6VBJRg03hmAWNAlM3ZhJBe6mD/y1rtR48notOw2pUES9clMmBi3ptRE/rDFazRiGLpHApTYmYCJF3TnUoQgYkniAsM5CY8Cq+HWvNAcVVUYyzGhd/GGAg3PgtgKfgoTcdniUKx4dQ2k7LVJkQW5m4QXyMKhaNB8A14NIplkzKo+yoCLIk6CaaY1C+xdSKi2UOYgRNKil6jJ2yg+y6i86kv/////7f+v/19v9qlNWpGta2ZSLLdb2U08jhBsYbzog2FA5aDNJa5TTZYok1+8j71JasgZs3gIqKcaatNOuJKeXw9ttuGm4s3KhKBRRFQOABFiZ/Fr1PuKhc16BVfMREAJVRGCOlWRCIEoIaa5YHRogil4DDAalLY0yVMngMIIAyGDHUVyMh4x6czHZTFwAOBxAU8Kkm1DAEtovIKCw1ILGfK9nyqQ0wFZIuQIDcWg25iKmTE6iHujiTRMzgckThumeFBMomBZJoSTrNiL9BJJaK2I1NVB3IePLJoupvVfX///2t1fv/u/W1ra9JB9OtuZMqpSKK2PsYsdMGajdNS1UKk1poKQstNSKd0VdkHWp9I0Y8s68xdd0daZxbck9yEcOBDP5yJwgy8Msd6xII5FYZdGNtREYrMAAFEJDMFAwySWUCax0KwMzygDsxIARGBkXpgm/gmQCcwmBACByaVkQGM2ARwXlRpWlJDFTVMwg8IGiTpYKBoiPmCleBmuKgGBCsAoAV8oGJaiECiMBmUAA1Z3qImz48F0fUDn0yIEeTLhFBQoD/D4M1KPEWHhFRgbmqZcHLSHbZJq9zVAhzKSbWtkDRA4ZP9+3/6/t//Vbte7fZfX21rat3WlTRTczprUis6ggo8gpOcNUTSy0VaCnTWtSj6oBXKrP0BFYokzLKvscn4nAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1OKNwMbo3LnUebga5RuHMog3AzujcuuyBuBrlG4W0rEnKIqIGGW7lpcK6muQcu1pcfrtgYOKnBmIEjICqAOCTWkyGIfMCFjLlJSmPA4OggxooGhpiANTjZwECnh1Iyr4zsxlTRnSYc9Zi4sIQhIxqBKNm1qAAnTrgEYDlcrpJROlEhFmyCIwUFMhaVN3RgcdpkWQwwyoygHNBgSKnx2pKScnCFY3cxFClQwROi0l03WLdHSzl0nq65vLjSkf7KJk9Wt+rb7Vr/76m7e9fS7rVV7u9XX96LstbVLdSCSkWda0HXQSZFFkl01LUpaSNklPpTJlJoIM7reaIsmlRUmzsgfSNiO+Auk8Ms4CAJkBIrvMaXSEKwqvS2U9Fmot9LZazhipAMTEYQZGYPAwcBTBxSeZxCATGCRhAbaIewUiKgCN3i8wGS4fEQ9MFiCDQE6pbBrersgwKBEOhQKBEgMGhs8KmjBwOHoEIQGjarxiUKaU7jxmAgqAQCn5UkhHkTIqRpmQwDUFhpkyWzM8USfAyKMgp5FmI01M0pF3RMCDJEWMNG+ZleU9BtlTAvqSQ7K/evr92pfrq///q/ezKdqql92p02TqQRS0lprTU60EKK1OzNP0k5/psyk1TJKupSU3TSrUtKjP6nMEkFLTZGdW4EClUszY06hoxgUoGg1WSxx2fXXgnJS7wyKApdJAI0UpXgY+rxiDDBQc3o3cRpIKMF2GCow8MDgUYCPDXsCTM5EuLrmjG1VShlzjp7jIACjxKCNpei46YMzkYqokxyLIBEsx4DgRYMwoGMJOGJvZAY+SksLpkUE5gcyOFrYzBKl4xNDELDiolPJrXND4ryRmmNg4LQbqSLWgtRxym1nbdS03RSd7f371Pq//eqp/X39/1Kbb2XZaqkHW7s96KaSNmWmuiaqZnWmcWpbLdSlutkXM81WeVZbMuyKkEUmZGYDrTkQpZmCOBC8IJCF7xFEHjTjlxpPD6/WAWnCdNw3fX6QC8xED26qWCQEAg5lESBoiByZgRkCDb9hUSBwJNgGQCA8ICRgIGmmAs1AzAIRoHs1bjDjYDBgDCFeHA1W4wYLzuRaMHGYFJpRVpTqrVdeCG1ZKBA6DQYuJlr8FNIrCuHh2gDXyRJtE8eRHCAckFSMUE2IHTTRZJjIkUCKl2r1nS9HwhM26lpG7rRbrqVv/fa97/Xp/9fX/33QX+pG96B1kUqlps13WZUDtFBmTTSQdNB3ZnY2Sd56owZFJJbJIOYOiyakGapBRm9JaVNM0dSTnXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdejjcDG6Ny3ZGm4Gt0bly+NtwMbo3LdMgbgY3RuGnFQIrU4GHkAgyAxQFgiZ1t4F6u4ziTN0hpcyZRABgVCCwWYWhQtuIIFyLLIgdQQtuz0xlBCAlTYwESN/BjADE5w0SRMzIXxZ9YgBpKrwE0g0EUiu41EfMhnxK1UOUAcAQgETAwhI1DiwCDS6UBsUlpdE8jlB6hQGMA2eYYBBVsZFYdAW+l1TKWU5RUbCkS+8ZtAVuksxLTutSBVSJ0/I5DoseJdTPXW2t6+v//9Sur+v/6Xu1W6aFV2z7KZda1u6K0TNO7Mk6C0mNEzhyhWylUVJqd1KpWdk3RZZqt6KLO5qyVBJF0Dh6o3AANEJlKRpyywAFF5WJKnay5zaPZuRsKtOw4pYLTNRKHBwADgQYEKeHkcgoH7Z6jZLAuNoeHEx4oXIpiMuNYKwcIGMwAYALxh15lAgqcE2ERCyOpURjY80ZLBoOi7nqFhUAYQ87wNbU2HiO7MOYXRjCZHySYwgNEjFGLJSKDoHQMWQFsWtFyKn0FyKucMifSJ5Jar9ZVke1D1JJOpa//qRt+67ey/f/9f+pff7aXXWv7KZk3Se9NF6JiZJs60Vruo0nFOktkVKU62SmiTMy0VpIJJHkVpuZKopMgtE3XwpGayxNxycoeU1HRVLbKqIE2xWlswzepoxHBCDhB6yQzoZIiQ0gjYgzcLAxoyE11mTfJxmKE5QLGJBAqNhneIjA6YzSRMwA1PuxHW4JSiIXQTjRavlrxjwUKbpaVy1mxlDnAgGC1zo9DIOEU4YCPPDZfLg5Yo5YF+Bkr4uEih8yJuOkBYMOBakUh0JooJDnU0R8KHCaoGC9Ts6RFnmJpu9i9OP//16/91fq/U/X9al9aLXr19aK6nU90qkmUtBTLpupBaTppret84jWpnZBZpM1IutSTLTUymZ31oz5kkyZsgZ1IJH1hU8rSsZmsQC1WmVBqBPGzly5xgMMSyD3pcwUKTDimGILGgUAibH7yEkyYYflpYVA5YTCANBzHJgdMjMwECFxrIOscZkUFXPsvw3UAJBpoinGiIBTM++oJFwOME6lpscWDZAohBXgAWMjAGfyKQkwOojSLHhogadIM4PJdMS4fIcCZ8pl5F0BfJzrMbpHCAIEBTrNlvzdRLLmfbTL1tX3f6W9DV6/3t/t/+//1dJ6VkkEjV9kHWzrL6da0FPUg6lskt2QTWvZBNTut601Mg7JsiqimhSUk6KbLdOmpNS2nwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHL4y3AzujcuSxxuBjlG5dZkDcDG6Nw3jEG4GN0bl4llKwmvgHHFsVdtFXC2GGX8dxiUqht+pYFyMaImFEzWyUOmoPY4heZcUrMjbtv4AEZB4x0DFUkHWwBNjlz1Nky0CTGeFWNjj6lU0MyCkiRoGKgSbahmROY8ZtVRVlyIKogABN2XkoYZSAJWq4d8lBjiCDERH8DI5BRB5QUkTRSACFicUTiaRXWZzFZkZnCAxIj7O6aqlGkuqmTdFaJopL3/1rd/b//9+/rrt/qXrVe66rKqWtlJIJIKT1qWk1SnRNEp9F01IMXVsmZMio0d0V0U6CbUUU1UEVrUfQM7siyjzoGD+B1JoU5AUYGVHv0o9LlfwK2dhTqS5okodycJRKZRCyUyBokADAwSbSJNJMdBOD2UrLkQBDhCADGiDMACIMPRhsQmfwMwMwQWigHQU466lVgQWi6TnMqLonTg0YYUAcnHQVNVTUX+15pNAIQsTEWkl0YNE0RzyNFpA0RUjSLlUupF8nAMAYGSKM8cLZMH2Oj2XjMsD/H1qPdyggog10fdIsk43q/7X/X+vV7e999f97v9fUupTsutSaq6Sdtj6Zgkky0L1rSSLq1ULqWkaNefUtpdRZFzi0zYwdlVu6LmFS1qdNaZogeIZwkYbVGWbkCnEiSgb+Q02jM3Mjcezlb5Dg+CitAiQggABTDBxPtQcICTOQChXq27JAMPDQgZEGAxFDlIQnpzpUyMaYE5VH5E7j+GGEAKaWdsuT1OWii8wQVKYkQI0wUEm7Fz3bcsYFhUIZDOuqZjvGeEmLolEI8RokwpTF80BvCMVBA+ZE4aLPsRRFBQ0lik0GRT0Wl9Mnk4/vWp05omkzqp+v/Uq9+rXbb1f2/U/3XR9HfWyrooKSXoImjOpaS13ZE7W5ikt6DrUfQQXSM06CRxlHjizRzMwZRq51a2dSlpJseQdSSClopLmbAmCzgap91KVmLHcN9nxqKlmpDL3TkI4TmIk7MygrGgAxcXkc4BCEcBpK/pQKTiM7wm0sBVPgi3MIKzXCYMBTBwtAxnjtsMdcK4wGgQcNLrCpUezgmRrQ2ACIGedPJGqOuwyTNPowMjT6kFMWSmTY+B3CpAZ9IblgljFEjDULWhNCeZBZULRmmgMopNIgx0lVrUeXywyyGp7/WS3fS6ff/b/1I791df/b1up9WrXdbMpmpoOm6kW3QQa6C9B1mqTIJorQQuptMydNbJJJsnUgx6fSVqUiYrOjhGMdfhKQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABweQNwMbo3DfUKbga3RuW8443Azujct+xVuBnk25FSOoUFJQHWwMym++Csr2txisehyGc4nQvkEG0EEQoPABhRKmBODA0Y6JxdpJVBm/C5zBxiIiFgkrKxg1OYOlaCJffZ0VcMRVILC7G3vWyCR4x2zMbd0D3LjDHkW1NCQAnJSSh5IKsBhiGS+OkvjMnyuBosxEzVMqmRWWGuPmtzEc9kz5sWUseI2SrdWuovLJ25cfrZI0SV9b99W1L6K/b/ofra/rtS9Ds1S1qWhXXZJNNSC2QL6kUjEwvcwpInlMyN07qmJ6nUpFEyQQTdbrR600VGyC1rrTNmop2Wis0ROOoerGOCQeTN0UBS8SFJbWV6vErxyYmzKo3GbCwebGBKomGBymhjAdFmxChCHCq1IiYGBqhWq5BvxqOnA13ING0D7XR0TVKw5V8xLDASw4YAKApGYLoJtu0DRknDBECQsoAC/uobcgLgIUFDcSZiTm8mBNj2OATaBgGZkXBmUycHPH0EiZ1SLIjrKaDGQ5rJHBvR0PQX3Mk1kOUyPVVLtf+pav91+r9Vf+v2+l+v36vupa1qUyLGq9VadTOtbMio6bqXZ1Kutaak0FO52tBBaRmgikpTJn0DNp3jcEIhYzTaW6Rgz4DaxWUO5o3setw7T+P22ksjMFtzJBIMe11GIjqj4QxLrhlAQYYGR1yQcKuMUBqJREMFzCiHMCKDqDNG0EECiDSlHrUrELuVgYOF0BwhITp5owSTB1evt4VQDga0dKerLCoBhms4c/iXyIEoIWIKK6Bu4osBDDdNzU+Kki7VEBSSNkxzlJpEHi5tMtVUrOUKjM/VrYrbd1f631ev/t9brV+rb3vVUl92ZKq3dJtBFdKkiZUKStFGZpOi6KCkbXRSZBd1KY7Sc4gpI6i7ppLd1KOGFSjM4utJMy3EZCy8tiajoM8NCawny/jjNDpmxts/Lzszk6Khj0GpoGFgOnCY1DNpuAhDJnMSriVRLYRAqgBWI0mBjBIOFmUOiAIMcNCxER+EIEgOLvAYdF5pYGiEAPWYAER0o6mGAqVmZlSpHeQnQ+ulp4sCBgOGqBAAgLOaLxgTpeMjoELDnE0TyzVMkQbkDSZJE2J02PvIk6ZkRdY56TJH+tJKRrun62Wk67er69l/X376Pf/VbWq7Xr/e/snT6VaSFmY6i9Fc3Wixm66loo39nV7M7vqWpOWkTqN1XzGm6bOcTFSirMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAbVj7cDPKNw3nFm4GeSblwGQNwMco3DX8Ybga3NuSqGgOBihCcZbJ0kIiNARGj7cXVZHL47L2wumVAsYDAijpYFAEAIkKHkg9PcwyFXXfoWIbOiUXMMIgshmEJswCRjRY/SKCw7YvVZjGo+VhZ5miNDMBAI5EPTIBUFlci+xV51QLDoZUbiwyRGB820kBFh+Ph7KRmBuigfdjZNEroCedrj6KxmlIChWQyPnMDf1p02kxfskYd1/07V/b/+373r9Xvez7XXdVkPpV0VO1M86Ceu7qUpJNSSZqitSlsnUeXQMGakm6kLMtIye6VI7TenN6kVIM6Kls5shDjdkOQS4ZMoTwhlZRGTFXQoYxWmr3HBaEKCAyuDlgBoZJ0GQBo6DUwADjBZKddeQ0KZ4QguHjQwSKojHms4I0moAJiERARuial/gooQ6QtszkwWEjr5fMVkkOXIgAjBXOS3fhm8vYkYFFZgYuoVSm4YEOI4e0xmgCNJAhSSMbpEmTqj7x1KUuRBFblBEkGrS2Ws9HRsvbTaz//6///v+rqb1f7KrrUqtdklJrUpFmppOoza9FJekkpk1MgtFqk3XUtmdNToqQWx5mM2qdmROsgtamTSTUpBNM6mUTUoMErF7G3hvVOne7In4aQ46lzB3Ki9PTyFrZCIBIVq2GNA2igYCBLfRFrBksDNDhsHBR/zAoHUYXSBRyNPIAh81iIkFjARWhi0+znSshGwQBn4hCYRzEtmQSkPB5cDjOUKhScYjQwCMgkSTymz2SAjCbKouiGkHA1o03IEYOamJKiik0y0UCMOF44gQYwMFENkY9M/82o5u3d5oy/+vqb76v2u9f9Tv/0vt3UpW1T3SSTr6C+kukiozd1MtSKnQp1rN1V01Opa0k03RPHEZoYo1umk5gk6qdaaDGTIsiZWmpuaKONBDlRjZhicaTLQaFsUdcWAJ1us3LoLZOKGRj4GlSBhZNAy1HcdGxEoFnKeDUjGwWVpc0ZuZWIUsDWQjGSESL6gQfWPEkmX4fYwSXFvFZ6ugoknCbRgtSHMKlCfCUL60y6JMneYMCnBp1qAeFUjS8Q4dQ5AJwHkqHDVFEphuS2zozpigmZEDSQQKscp6ldZ01j7emr2WbVO3/9uvV/1r/2+3v9tTK07Kq+y1trUuqkkjWyrKRUzH0zr13ZJFJaKSrspqzSuzpKUutj591aCKK1ouiiZvLWnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHGJA3AzujcOXSBuBndG4cLijcDO6Ny5hFG4GuUbkQgNq3hkGI3HCI6zfwHLY8zmBWMPRD0Qb8ZGjFAJ9gc1v2DgqYbK2cxgsTNWsYSGq+EAyw9NIxlzFuIRIZnhgnaZ6ftli6tvxAAMQqBMnUeChOdZpBddHldUrKkaRkFgRWKJyMt6YUPNLhEHE8RrDLmhNAi2hQEUDY1MjIuBdc1dKolyqykhwso6OJyPQoq9TT+eq1KMCWrf1f1X/pVv+rup1971//r6kbaCk1oVLZN0moVsikyk0aSTKUgyjCg1ncyTWg5xZsgZLTRQqUgkdWgiib0KmRQSMkkTJ5rUgirWhMk2vp0Fg8AoqVg+NyFQXXph9+l014Gqxlm44kGYgzmmMAyAEGJUjcQKk5saKxZhZgw8nQSgTYzZFgRuYcjGFAIZKIWmBFiMLXFQQZOgmbNYBWWBUDABoe9imEaYGL2BqIL2Q6P+nG2BbRCAnBDJEOS6IGBikRYui5QMOvN0zVAxUahAGPpufcjmZSyeNjhgfRH2zOe61u5GJLMX+tOl+pvet3ev/q/6ta6v6P+vpX1rostGtSSc2UtNJFNBka3SUtkmo6SCDooMtbrRY6tVJkS89UwNlpJJLdaDO60mWyd0kVn0WZaZkthbSwqaFZVBAwcgCTXaK8UqblWeuvIWtO2KhCqowAhQQS1T7cxtAuNjBzSocTBwxmwACE+jCgURxJN9iwINnqsBqxs0yOvrFUeTCSgtyoEp2ICgzzjJmQFV6E93SYHSVZ1DGEFgUjMIJ+uZAhsRpDCGEWHIAz8IMEG5Ei+dLpSAaAk+bJOmOlBRhIMpaJCSYTpFr1ozTP9S5STrf////f//etS+ySmqr610m1LWy17a1NOtpKout6SCSCzZnWkplKqUmbGKqTqTSZAxScwWjdjZkU0GZabKUbLWgyJuNhr4JuDoG8GATWBR2ULEl2skxUtc9uUNvw9rZ3/XuSkYuuwACgtKgxYQYqj2CAcY1Iim6HAw4G1eQUkoY1MoiNKeRgECAwIq2GByKrtwWoSEkA5gVsmFQuxOXEwDOhiYGIkSWaHqxYYYc8itjhNIAgdNFicWC8RuFowH4bo7heAahIOpAh5iowSC3ZFT6K0iPLSCLDxWo2TKhqko3vnGl/Z1vZazeptfV7f1r/X9lWb1tqWv3+ur2dV/101sj0zhibronloI0FscdBJJFzy0Xskp0XTbNlXRTZE8mpCo9ZS1VKqTWZlw1D2DgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABs+MNwM8o3LX8YbgZ3RuWr483AxyjctXRJuBjdG5h2JASM1ClLC8TEK0E5u5CIfbDQTMAPWwMwsAFDDHQJRYDBI78YGAOYbCk+twSPq9ACCG0FjmFU+JKIlHQED7gGbRa/K28IBU1EQVJi2lirYCQ6cFTxgE5DRqgl6VNEQFXMQgJ9QQFRGJpuf0SZuTx8eRIwa4xn3TMyigdHcRI+pJRwrLNWJFsg6y27Mt+s3SN3WivrUYJIq+r/Zb7fp//3792X+v1Nez1qXtWp3qTpqWtBS00HZ2Wgg7rQqUiii1BJFTpNZ2Rd10jZndB0FIrUpFU229M1gCp+amMFhUEFcgmAuymnPUiSkBMypZBBU9DLLyFCQFPGAj57zOTBpygqIxyAG3rBghqiqXqU4JbhQvS5WaTLbGAAfJhLRL+yiNmcQIdlrFSKMAKT2IQQKYZ9oEXldUvLBit8jixgAgSpEQqywmzciwujQhgG/AhvpeTIemXSyKVHpTU2NkmMifso1UOp1LNtalZcqMH9jqq2bb/t//6DN/1N+vpvs6ba+vQe6tTZuhdJaa1Kd6VBk9FLazKWt0FqMk3utE2UjQZLZSdE6tcwTQQUiixxI6o3xZOCUb1gAk5C4ETB25FfTF7IJmNMeicA8lpCDzBgBQnGKwiQABWFyH2GAMEC2mR4MKg1rQ6C0aA5AEibBRLFQQGP9S4HOB9lhW3j79GHhMRHpzYSliA0iDgEPD9o7OpaXiWq0OONiGAGZMGcFUssNC0iQ0vD8BolQcGOaVmOl0rB+xfr2dE0YibqWQyRVGo29A0mmbPsumV0Nf+ttv//bvr9XV+vW367/r3ZVXZ0EXdaanQTOrW1I9VSWtC6qTGdkFILTZmUtKzUNZ5Tpmj0lJujZE2daNRxxbW01mViHBaENbLHBlkshMik1d8pFNtDIDwrBlhTAgBPkxwFZi2MQlJrp+ypHkyIOYKw5mBnTakC54CAyzTGxJSTVZG09aRd4wZEJqcrDGJjhgZZcmDF5OFioSy1ZzpMTQmbZS25oiKy2c4dLJFRX1l0EV0h5IGxZUXCYASGaeW6KalpE8tSlxn1Os19S9qTVXWdUpfd+uv1f//1WdWh17v3/9ev66a1uhRoNsiumtJ03N61OgzqXQSM1poqOVOdPLUyKaDLrSSXupNNbOgpF0zbE0+71RYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAa7h7cDHJty1HGW4Gd0bhnOJNwM7m3LQsGbga3RuWgpfGSoZtCSMuWQwRfE5A1xWqFvZKo45AqHX8GQKYZDkKAQzlbqRoDASXLBmEQY+oUBKrzJ4VIEWLCIKiMyeEFiGTxUlw4jrMna0FjcChs3iioNChxNLgYAExXkqmbfjAHWYipKGdBQFgYbPzD9Y+SpUGWImYAeTB7hZWdOGxKB8BaauUGPVkEQpDmqMj9Z7ql2m8x/Kboq222Zld/17/q/6vfV+v+r/S9+t1IIoIXTuixqgnZJjBJa2SaaMqqkktNnTZBkFIppOxkkmmg1JabF0bhVki99LLF7vMa+BjIoA13scTAcaNxpl7+NajroQsVKHpkAWDUvBwAvvGX8NhNmTioIYgNvLYaWbOoJtJRM0ElBihmxmPCbFIGh5GwRxg4DRtpABAz52oaAib6HAOPsQRcp2kvq8SSJupEzeM7NEiaIoYqA1oA4mcTN1jlAkJQQWqizLTJasyQkgiq2up1voN6lqr+rXbf+r7/21/ar9nurXvrX/WplOplHlO59A46loKVRWiimp0VqZbJsg7oNdSlupA4iiiisxOoNZ3TTZFSnemgp1sgmYm5UUIeQZBHngDIqKOKELGbli5k+5kpf2anCwOpq7HqVK0yAgTBghQcoSV8NKBxjEBAHS40IgBDG1IQE5pAoXNMoQ0gUyGUSemMFXDEAZqbxEpqZtqGCSgQTM/b9WlmrjJXvsvlMUOoJ6VSZyKkciTqwAIh2T6VTE+Rc8pFbFtT45aCDjSUZpMyfy26tW2tFJlt76tu/q/f/t/3q/19tm362RUtNBbqUvQma2RddJJKmaM526mUy010HdF0FILpKpJre52kyDu6fSQY/3tYBkvSmVDRCXNNBLyjxNM1pbfNxfKYgvN/IGjEaEYEY8EREWC3xBIm88dHQ42YAZq84GfsFlz5vxCXcTjFQQwIXSWMHWEbm4RKnRMMJWisYSSpAQBn+BxkzoPYSCNnd1i7UVgrKfwAHDGgZ5Z+aJgxLxA0UQNYLOucWeWaA0BJMmjKTsmYGa1nEUBlj9nr0D01029FFGqv/19/tf/X2//9nV3217dkla0NBaKBxlJuk51F9SU47qnJ6g7PWedk1G61n0KDH1rTOoqY/MPMkL0RZYpxcCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaciTcDO5ty0pH24GN0bhrCNtwMbo3LTsgbgZ3NuFJ4hSEBUAUkAB4Mnd5p0rYMle7EnhyclpUD3aJQoxMfHBIyAvY88bQTWwty1BjEwlf4jDl+Ggn4AN2NkoAGaLNTD0RpkGORdaAYmygopLbKlCgoc1YkFwHKDYH+TyIARpAKCJl0UNyAVadunNysRhWMhygTqHBjyZroGghcxtcgLutY5CMxHjbS9RhSqf3qKqP1/q/f7L/q/1LZfU61f/u9upqLukpSbOedNa00UEEbug7IpJPWyZopBJVn1MmpFNFJ9alpn3TtRdJmRd1ntDY5i1q5TBBmkIWnHCgVO9UFbbHTSrOOy2Ariq5hwOxkUBErDKCpvVbE9zFBtnj+mRAjHFoTw2FFYCTJ66gyGbKYqUr9eiq9MYBoWDlBA9uYqOHHuZgdkHKTc37VrHAuJu3G3+C4kEHKmliaNUzUjjMgwGrLDeNTQ1NC4Sgssdrn2eyRs5F3dSo3bKaqhTn9Fn7Jo1dS/9Gh/36/ar/V3v3fsyv9T1600Xukp1NatRpQTSfWa1OgydS3Z3dI46SC1OeQSQRadN1oGal6CDqZJaz+6CKLLtNnGAyV4CH55OX4SqWm1p8Mb0zP0uEvkKtqUpcM0kQa+biLM7gsqgAFMF+sxMdGH5FQNYpjiQFAMiAgYWAgTW0CD8WAJOy27LTAHkICnqlpds/1KMZRDZgIYBmPQcgDbUs++DZBAEAkYkOMuNzcihBSsUgAExNGLnWL6YyJLppqjqQnVj7oybcoJ3Pa0VFVlspX3OG/7fbUr7//V/qV/+uytd9Tv3drKQT2TuhZBFJBZlPqWqy3uzupjBlIKRUykUmTqupNGk6mMVrquikXkaRmcWykWafMBrREQYbxCUc5gPAdlrjPYk1uN0cNXqO3LBkLAR40YyAPQYMPMetkLuhzNB6MhYD4FL/pUhnIFw8WXgsGgIIUpMqHld00rnoICwwZ8BJnNyEY2ZLHCOQUyexPJvEeFMmMS+ibAYABsWockjh0hpOj7A8HENLSzE6mgDdUz582QQQWYZkecdDPW+yKVDOv600Kr6/e3t1fqX/Vf91fZf/v7o610aTNrWgtAwdkE1Vs6SK7qMWSa63ME0EFoIHEUjBNNCkgfOoWfummmi9FbopLvdnc2vm4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGrJA3AxubcMSQhuBncm5ZafjcDG5ty1pG24Gd0bhWxKlTwEYVIJ7M8ZuuuPVqeSShypypxugqKIITRApOEBgDJXAVea4PwLAIKaZUIhdfxgaWXYBRuYWGGogr/A0IYGtFOWAY2CB9RmLsSEAaekTBQcIwFDpATgiABXODASDW5FugdCsFkMacfJwdRdNQNfzMj1G5oouinGGyyPN02WNzWUmJ9Kgnqrelps9311N79/+tdar/7f6+/vdX1Xqt9V1KvRapJJlPRe6C86uqpa0jGyrVJqTNU6SB12TSNnUp3OoJHGNEUjdjiaaCbVKRSRUnXLC006clMN+w1P1h6xMO78CwujZfOYW6aUCMhAwusoMI4+YOdKfcYLAAQPQVFjLwiPrVU2NRLxGdjykyAaaHMMZFWbtillOqoQgA9UqFN8WoOsSTCKgMMICURfpQ51FH5a7CThQVOvvAqkwkUECcADokEz502Y6GjFZGi5RXZAnXqTUW3/rb2dt7Gn29bb//sr6v3bU/q/297ba6d+qtDM062SUbVWS6NJSloIO9J1rRuySVDMEmUtjNBBdObFXGznVH8yBFM1lJgCqhYyJgXikIz1+JbLHme+CpqCYvodBAANkgIYcMpKGumqolzhQJNzEValAEf2rhQQTDMLSC/hWolQXA1NA5jQI1xkcPxuuYoEDzkuh6wuGGzsIVEB8sEAReZshwjRCDwzkiKEJ8soX+MiKJizTIpAeIEOM1HUpuMsPK1pSGPSRIbZRdWRU9d/U6153utanrZf9f/t1/1bf/1VNVf/u2pJXsulUgzTZbomdkWTTaqyKdJBSbpd0Fosvd3N32GZRzRplFqXzEd4nxFhUAQsAYyphelNbHGJStsUCtxlEphyaeGHCEjFAZAsw0IfkygrZxOLBDQ7AT7hh5wkCoBMoMAImg4GCgMOBrIDGhJWJhzCGusAMFGQVipFSEtseKJmOyA1QJSLjcdPdlqqE46DajxY/dPJlOXS+VxxgYhOLjNWrLEWsqu2oyegRJaSlLJlC+1zr09L7nDyv1f9dVb9ep+pv9n1Vv6/Xs/W/2SfTuplrRW5qm6mQTQTPpJVLZUycxM1OhZzq0JxM0UigyJpNT6KaNNOpS6lLSToILqOH0DiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABpKNtwMbm3LIMgbgZ1RuGeow3AzujcsqxpuBndG5QRxARiLCzA5hRf94L1G+szDTDYRMOxRK3CMmecomlNzOFZ+bIwKEJ9S30incBIc4hnBeShoZLDhiY0MLtMxBXMl79wpwjAUgx8ILlsuIREx9eMbVx8hEQQ1hkqITUQqDPis8hBhGAPzHqZEixVGOmgH0ZUN6zzohxLKVl80ZnIEtFzZIaz1mjJfbX+s83V/9//+/36Ve39/stVDX0rKZS1JO6qCFSKSC3SOn1+6RoxxbsyS12dJ1LSetBBSRmjWfMnqW7qpOYqRVRWyZ1TIrWbhmlFK6lBDCAaAipnLN6zGqdxoFwib/w/LSA2Co7klGFMU3qhzWEKptbd5UwyBeAvmqQxsEkurcRGExbXzam042uPUw9nIB1gKyxR6iBCdjUATRHER0WM8i6YUpjLYrOm/GvNPWCoTZBTxeIoAloOA8ktJZNiEJL0nQRd1onroGrlhn/1K0Pzh3//X96vd/eutv3/7N/19bd91rvRPs5tSTMl55aCSBxNV7OpkVzRJToL01HFOZWRNKGtda8yWyKlqTdCgk2kipTnFNxYkKFmYeAVCMNir0L0mpI9bLaV+7tG/C+zDikcCTIiJrBhKvAUBiEIN8EWKQWhJfkZG3LNJJCwfj0kqEnAGgGcFKNbKIHwpzAFhSCP0Wdk1I7Ga8e2VHFqPCIwu8gJZ+2jvgqFjU5bRJtx0ni4DoDGKCZks6LiSRUyicc4gxFUblSOtVJH1tf/rPIrV6Dq/6alfVUq3/Xra3/r/Uql1V2up7JsaGVaOeWnqonmddNFJF1sgtabrSTS7smcSXSaiospre7tZdSJs9SlGDY2njlKdmOmiqY/g8qvBQuTRWbsRiMTTlQHeXiMgiDAyArNM8FbkKfciXp5YcFFzDwYMt1HTAKqoOKBEMmAii+TNCq1H6GXPSYJDgogGg2SjAkbc0gQLJrhN6HG+Rm0qtQQAiyCCipYpCoZkWIkakNAqlGRn0jJRRDJjJFPIxtJJakD9N9P2Zaec/UfV2S/+/X0V/7r9ve2v/erWv1PtZ1rVW602SRsmpFCsyP2PIKT2QTRZ683Z6aGm7qdGikzU1tdNnWtqTIre6CjtiqQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaFjLcDG5Nyy7Cm4GNzblmqMNwMbi3LJccbgY1JuXggJk5wopUIQqMLhiT9ujTtSjUqfm4/hVASqRKOGRCK0QapO3BQXAzGwtXzRS0zKyYIg80gPEDGHHRKUGEEssM3PK0SYRLYAMJQDKgBUMHLyEp8GWIKYWiLhqLtV+hOl0NNzHnuUROnOlkukOLw+gR2aE+kdQUWByDy2uT+yyedBy+iRBHdXrWgp6bJ84v9bUtX//b//263X6+/QqX7O6tbMgtDZaek6KCDospNmRWtaKd6EwmJxKySSa3RUt00jik3ump5nRQeta2d2eiZ6DIKwahooIlYkgQFZc6DftduQ317J/J/76bgGU1HTNQB+DLxyTwSKghgAFKZKAiyQiIWTmMeQyQ5B0gghB0QtUzUrbnC2zMBa+DWVrzj2Ufwe5GIlZFcI6OziwKErpblQJniEpcjU6YEwxDzcmwMFhkiiUmMFJixksmktM+itk2XUaS7RW9Wk1B6m+tJ/7/6q7q//+v/+j/3ulst1rtbspp9lpUGVUm63TOPSUX1MpTppMp01IqZBFGfqZ6boJGSCaRnOmxUDSmlJABp4BHUolQ5UTsJ8HSPLDKhruxaWN/CY1Wi+CDYUJWxDy24RlCexLaIA9PSNtULXaApA9g1PjLXVCoYRcauzMk9H9iVaKyUEl4ONV+u8k6AiQkmQ4JiBQAwASBTlIJbLQAoCGRADlyaUHzQvGqIxwMwqi+zIubCWmaS1KNU00TrcuIE8qih6m61V+orKVZVXb+6lX//7LXX77e2u3316upS1augZoNWpG6S1qRTW7qPpu7JqWeWgyRog9a2reyjWux1SK2OJJJz6mZdbqWYJVRURDqPCaybrm7JcVMZnqdTR5bK2uzkSlkFxMcJFtEPTKDlaDaB2lM8RuJuryywGh3mAoB+TmqgIZH3IgIGUHwQb4staAXthbMQJTHr7EZEICJ/KQJ7h4FfTDHkIAMXY9GoU1k1JKlhHmKiwQ5AkAN7TY0Uks6LldqpRPbF9dRjOVL6qtLW36G3/6vapf/Xbr1f//qv3/XSagtrOktSTKZF1Mgit1MkjMHdBNBFlJoIIJsySSbuzoIzBBbs72UpGzIHDJZ5TNsfqczSMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGgos3Axubcs3yBuBrcm4aFjTcDG5tywZFm4Gdwblqa9S+ibpisgtuHGdyWA3jhqDqCehiiSfEY4MAJCJLbNZMlvw0KCRkA8zWGGFy8Ci6jBpQQVU8BGhAKmPjXDG16GpBAtFDRZlfUEUkEFUBMLxQEXvCnxAKB7JVbog3BkZgYat+hlh5BInjcZgDmcezRkzNJFIkrVGyTrWpBFRjJlGkv1HrVKalUpSVWv1///3bev+39bqv6v7VVVWW9bOpVp52zNk1z9F1rrZFCZnmWg7IJJoJpoqRTSSpLtTTWyKSC0jFaBqznElHTM0Uioja1yMwBJk4a8xicmJrDLdZ68bnUW4RYeerAYoRAI3YwDiVcBmYQ/M2IwUw0Vi6mICEoHJRNdBsgqJBAlWqXA6LdgSe2gtlgvDEREpmoLSOGOCxiTuDIUSKbTHIUzibc2utNmgQMt7Vl5WL5wsnSfAuBEkTFq1B8TLbMzZby41jZZ3ovt21tTXqNVf72/q/9/q321f/++u6tvpMq6amPWTUgg5iapITzrVRWdu6K00TDSp1Ghsq61orpJKTdGikmpSBfSTRZToqQQUtFlJWc+m8Lakn0JS+UbV3pZpF3Xjexu8gpajvShR0cGWuDRysQ2YFiE0uszoZkM2mFEwIIjQMaOWiAxHmxJcMYENTAFeVxmAoVDZgYC8SXD5S1EswDLA2WIQNqN4QCLhwK+jORgGMXFIOprLJEwOkvDlAcgDFI1aaTnBGR5dllxS00i6tKbSOes/+p9P7JId/X//6l176v/+/36vtam7uit6CkU6TrZBaGdaaImVSKbJmZxJ0Kkmu6VFlosmgtSaZo6k1JKdNzBalMboMY3TUpBqGXyoYnSmfoLumOILiNu47uagqCLEspOU0zPDpIAjBnQcxMoHnCENHcUIasWWjxA/CcKl4G7iQyDm0RgpiYYvYzQjak0mBpTOqMBkc5uCS5wZ8KJau2vtdeSHnQdd/W6O6DkOLTceQJUwKCZYAZikijQTQFm9c8boPLPKqz2v+qqtfVV16q+39dTfbfv/2/+k3/WpTV693VopIpLRdZ1JdTrRnDBJTNTWmgpmU6SCDtSZ3u93pGaK0zZTretkj7Leg5h00dUJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABliLNwMbm3LMUabga21uWWI83Axujcr+RpuBjUm5aKo2YhA4aTSGrtMnsurNv/DE/KrFiJUpg4ktgHG77G4g7n4kgmJTa7qAMKH6EBAyYzI2AgGLNqmhggK14RoiiOEeiMEr1UalDyPIJGhlCCEmYhCVSwEQAD1RKRtMUaM4BYZry0xMywOhQ+APbA+iaBuXLiEJ5VJRsylOfustLIfzTVVodrK6P9W3/Wuta77f9f79v9q61X6l3rrrfQQdkaTczPuySjJa60E1n1oWZdak101KRnVJ0aCzZBNOkYKZNJj+ykElH52hcqd1ujgscWGbgKWI9NNqxiQxt7cozDz1RoqihQhMJMAEG8ASu1ObJAIyYEqvCDiPgXCKE3AQJFwWERQHCIBcJm5c9Dqy2TsqMGIB5SJgCfX4dAAGEEIcbwa6llsNK7mL3oCjPBRpkmlhoaF4nuoAEpTMUUj6RoLiLINIlFaZeXUmtT1O3Xq/97LX/b/7++r/r2/+zL/V3VUpa91MzospFZstkVsbHmstSKjNabIKW6luiy2Y6btdNJaaKLOpdBR17OjZFaSSLu69JBRhUyXZA/4KUsGdCmQzXmBL2l87GHg+pJpdXVkAom1UlHFKTTjKBJeugCkCgqaRgom/QCBkgDI0FeREsJjI/OkKjc9BTgT7cTBTdmT8Oq9xk4yKkBGTDoLKX+R2ahBdM/DcAc9vNE7hiYkPI1EV0CD8ct0EFsiRYvdZDXQTWaNcvyojdF/1sz3/73//+vqu31NV/rt319umrUpate+pBJqaa1OcdbLr1JJMgg6kmRppGamdOii8wpKVOn2dZmozWp0KDOpNSjySCk6VklIzkVfK/laAHlBCNlkTuOpLn+pL8oq16s+Qgh6DBRQwUtMkMl0tFQZnhbwL5AgaPr5VSOWjCsZH8ZFGaDssNQ9d9/34uPEMZgwksWJio48dUGmSKU2Go8z10MPy+Ol5hELdSxRFRSB6XgIwYJoGz1DLv2PstCasuhO/69a6nu92/6v3V//t99f/+99dDqvugl60q10FWN0mWhQoJIMtbrZbMmktCkpG9l3etdaNkV0U0V0VILQcySTdFSCJ9Sa0ywm5BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAWBireDGqNwpe2G8GdNblT94N4H6m3KgLWbwY2puXaa6DIJzpvvi6sFvZLJHQwNYq0sUp0CA6SpAcRTIMPFgjCZNkJb1mZgRUbJTLgmGgNEDmr8Oo+hhgzTom+lCvMRYSZcxTJSkQKhkgU30O7zziIcCO5EmBJ6GQIRXllBExKqRPAAJhSxrrZAhh7dzJ1aeiYSaff+rX7Vr////1/1f//9v9vt/UpaSlbt9STU0k0mUylJUkkXuuqt63Su6a0urdSK2pIpKnlpzVRxzh8Q6dBBoHhCO1JSvDsea3dqyiTQzC45ff4WbRooTwAhzlNVMUTJttwIA1K7OzJMkTig+ggEjbADDsLFSgnIFIgyrYfgolFmnqIBSKE9NeEPpATuUd93AMUobllncwdIAsxILUp1KEpSSoTq+bIOpGYfVragqr9Tf//1f1//f/////Xr0aCDpukp3RZR84XEZRJGPLk/oPnbgcyubcE++SNcI2sFXohWCtGkHEGaDdEjHW5pxQZYcv4WdrSyhAFjoCPJ+mfgO3cS3ImcufkMQ0SZqSQzBYcPKV3OXAYkaij/vXLn3NECGxbkx1Qw0iMyWwflJTtfi6crzPjuD3vMAJs0txNTEOJkckAs5CH1UGMxXT79Gy6StGU1XV63Z/37//+r//////1/9Xuve3vUp1Pd07or2RZTLSWtBfWxohamXl/pEhHkU+cNGj/b6c+ROV1vkoxHQlc3rWcaS1TUz9RWewkuab40OqdjgdcYdMO0SBxYGHBdoiCn6sQ4SkZIDoVJhiy3GyAvtxKUcdkRja352XoTDiiUwIeJjtmfw++1x24ImU3yUBcqk4hGxUiMBIsSGMerCUYvKvnqZnTtP29G+j/3/2/br+/////v7fX/M3aeSdsQh30ufH3WJmYTGmGJq6lOkR76ujVwgPrg/xcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAFmI83gxubcqfvFvBnbW5VUjjeB+otwqNDm8GdNbmhcAkIMlUVLhO9ZkEst1MbU/nqtNooPWXgTANUIXIh9DAoD67wBAPDRCGUxgaE9IcAvaRByi4IA7UpqxZhQjLAMXRWjWma6GCGqBydALT4kh5F4AlkvcQON3+s9TN2I1EmwDwlJaNS0RZTo2UcU1b1uflxtv7fX////+r/b/1rb//7f6Cqndb1pLSpV1zq3OUTjILQsnvu9KcUikg16Ck6TGboqWtSSSKWpSCb1Pat60jN83UZel4NsAlhZUzD0SpNSKUXuZUHEnQgqjA8UvynFG24KBBEy3sTT4htu6+zAxYVIw4AHAdE6bAAovbGlf2jAAypGQUqYxy42FTAWHrMvpmf8gCntL6MPCJH+K2TLyB0G+POeZ1OJOeSuzO3VY8sxbXt/W31P///9v1f///7rbX+rvb0nQTdT6Kb3Wg5uyOinZBWtVSnZz5M5iX8UAXIayMWsLgA/58xKIsUaOCcDHCRjKMtWtThMvQa8uSpDm2rgJQTpHHe+cHAysluPp6UCV6zDMMYyy1NMv1ARhAUqlFPQSIYcBjiCXmnT4GDB9k1H8V9Zd5+G49jSDAUGOT2shcoJGYE8z6mKQzhq7VlmpNaGtp9KpP7U9/sqrv///////////pO39V9KtjlKyKKlpOi7Js+pBJNaKknWkZmK3s7JrQuea6lrdluhTUiiqnetZ2lBCA2plDGVWWyIgHkaQ9MzLr0vim8Hx20kwwNuQ8jqCw3GJCok0Id538d2oyCVGYBih8WYKKhExpqP1A/05Tey6Iwc0YcEm8wEBpPqTQp7WIU0AwHE1EgMlx7iyZktSYBcNktS1hVHXyp+j1zDu/V9av////////t//2vq/d9q1KVvrWyqKNFbrVWgzKWta0k6mdNOqpbOtknU6VJS6DJdI1TGqJun4ISkoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABTONN4H6k3KksTbwY01uVX4Y3gxqTcqWuJvBjbW5XzPDZCsFhL63uJjImOuGfeaSeqEgeAZQNEmknaQNBjyaRMhwegvjERgXEzQqE94gpiGFIyLQ5C0qjwlgBDFHVuEVVWOfJHKAs4aIx+Rp+22ZagxI4qC6+urRWU1pAXEsO9lrD8WXqMKmnaqco97fXt/f69f//////+3/vb7/V21MtJJnXsySK63QSSZ71tZqlb6FSKTIVsjT1LQZ2sjWpN9TWMI64A1tohlAEKBrRokSjzc3agyftfN2rWDIDMgJWMBHVJh9HaagY0ZDdGqOGnWdQWdCIaRSCQECoNwQiexCtYkBKbwsQGKCjjWRAgt1Zc2ddUpblG80Xx51A2eLKTSQMQT8sZHQOiNGvu2p+k6b/7V///13//9f/9f////sr67PbvWx01WyL0EGRa6TMmik6XQZaLu7KSQUq7MyqkNWtJ69NR5gI5Nfe0tJsLLGMG4SRSmrNniisor1/wltqyVQ6km4ouN0N27fq4hxSHgaPDQeCi8DFjQESAS9jKCJq3EWWyW/Ln9dExMcogxPpUDkF4q1iLgsBA0IdyRMpzlS+E2n6v5HUzEoKQALIun9nRGWN+mX/V1Sx279X///2////6v//9/bfX6tS0aV7IM16lpprqdalopHElNQU9mpVpMxxqaakVM6a1pIvSTOsmoJ29gV0CjMV0shHmBa4KLALFqafjEASKcl+pu4koWlkKarqkQpFazYBKFnaqKELUdf0HDhZwoURUAMnAWJA4Ic+ZqWIZMBS0L4/DiuzkxYwEiEgCGI3RMJ7H5fg5CfUsnrKaaSa0QSRBkNaASdPrXv9lo+/v/erf/rX//+r//////3qTo10aLU0FIo0kkaCVOqiatnzQ5kMkgWNjpsQAI0LrSTLWw8ditmjIRgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAUBMjeDGtLgpi9m8GNNblc9ut4H7e3KnsYbwZ0puWJtZRrAU1hWvrhZFK3Gpa0hzpJyfsDAFQeWDx1fJiplLGK4ORW6dYC8IxT+GnBCEurSSgEl5QEBoRNyaEwGYJ2DidND6Hh3I5hTw+YWQ8UXUaxZdckFyHa1zDv26/OmCB3Mub3+rHO/z73//91/Mfr9U3c0r+v////11aorSkccU44KLEIJ0BQwJQfQdJkCwTm1BlpFYSbFGoLAYAklkhPBKt8IBSTQsaM2GN1HKt2X+uUM9naLAADBo5B86NE7PBUSYMO0KgWjXfnMw4EYQEz0vuAqUNAYdJ7cMxWqYpSUV3ZuIyn+RPENIHgj0miEWhq9SOkhvTU+KbKMqAOtFNeywVgpNzqrOhXecf+q2r+t//9v////6l//+vv+vezOtV2sk6lqoKY4rRdaCSaDOgimyDJJMkiY3q7CdPZLZ5hrk55fOOd+xgiynAYw9hcS/rTkj15uVEtucxQ6hwVKiIjbgYUmwj3qHhCzSMBsg0DX6HIJUHSgMpiI2phEFxeloZBC0WA5DavIHXODBAuNi0iopPcfuy4s7fZ6NBc/O1sSZgZoACvG+t+5uz6/xb/5p//66/t//9+n////+v///////8////////////////6/+v///////j4+//9Y/1nPxT6+Mz/Wp6YlSQeLArLm+VoWAEvGdLWiL9r0MS4l3WQS0sMuSADzHmDB3EmY3Mw7DcauSupbtkgQlA0ywzQAxRVj7eg7VA9tOqbd6UmGEECwiMigcBRH9EQGdaTjxsi7B5c1aPlQYZGOIyJEteKchVBKH5+lliAyRT3nlTirEoLF0SigRFn3utl1Mkba6eu/6v//+/////6dF+b+jd/9E0sYYqo+5xyormMhhhxk6xzsh6MrJmtPLGnHH1oYrznZ0XZ2ZiJAewmoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAX4jzcDGpNyqJCG8GNNblT1+N4Mam3Kk0abwY01uZE2RIZWoyDMAHAlEIrztFBE5BuFDZTlL9s9FAyiZxZjz0iUrMaKOpnu+CBLrDTsgMkyglCg5FIxkpDUZjWTvCJYNMm/jCep/mAEPlIFskORVPWVNt8NR0CBH5z0xueKaBDQMpJdSWsxE3G1Jc8tb1st7nOjUrenpfqer6+3/39/1/fq/9q6/3+venq6SLqSpNcuMbJ1KdBNF1JoIMg9aJxM466kEqSKKaCCC02QRSQPqrukoydSZpRRY+gZscRyeKHUcw1wB43Bg8Li0HX9ZYx3LG2WBA6AlSxWWAYvfp09C6k76/IlKYWYUSQsnBQ7A7DICoGe/GX08EEBwOZNhlie5xWQ6dKDr+SmDp+xDVqKQ2Dhcxywgp0kVDhNFHl6QUK3XnHdazbozRH++r/rb//2//f+v/////V1NbZTVsiq9EzdJbstaTs91JMimkt611MnZBS9NlpJUHW6SCR1SPWTkkcXAqUJSWLBNIC5mXLfZy2rsw7J4Ph3Oku1cZ1kUwWtcg6iN+argwbWglQSMCgaXiRgkAkyQkCjwDEgBxGcprU0MIk+2/iJVAGflgVKNTW5QJFlOrTmXa0PgkHE6lhEsomDk8AvBI+g1SR49bS0/pV/X/q/V+3/////////p9P6tV1MqyTIqTdNNtBOg7Mpkkk3SZehdSTJLTdJ1sYpggmRDJyxRAKnVBEGACPiJ2MAXcSKHWhDXilU07GdA/1fLlNRkghZNciBwKDgE5Su0wGWwY68WbpNiIYOqELyAQYsDGiEK06/D0jhgZHI5MX22o/FGE6oa0MVWk08IiVtpACEPLlZWZIXMg/EZ0VvQC2G3pdZ7upL/vX/7X///////////9f3UpklLbdBnpzirpILdTGVdbKdB3QRnmdlKZ2pqRfdNm0boKZJ2YwrQU9A8ug0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEzn43gxqTcp5xZvBjLW5TXf7eB+mtymFIG8GMqbiOPCIZAHZcNw6ann4fxsY8uzFTrMJDMEQq0JwmTaXI4U97wyhXTQA4HKCYzGSZ5Vdlf1iaqXh4EnBSzSO5q3gjsjQ2CpBCY9LKPtZ9UPK2eLouksog1snT7KzpH/MfN+1tf//6n7t////9f///7f9v+mlarTWtaqDqWp3SUo8ktJdWmiyCBygzVKakdvvJYuObJCosk0vIfArGVN5SIJDkFCJr1M7l7l3C1jPYyMgUSEmQcA2hfexuaeexEGJU8WcgwDx0orDWuN1S8GISmWVrtE1pXMnpyEI9ZSGlrdPIbTVLr5y6JNbMoW3W6mkp1rCTmqT6nHO3rr0+1H/Xq////V////b///+vX1VvW6+qm7JqU3uYOtI87pqRQdKlTzjJOyDILV3TWpF2UyNF1UGVTQVao+zPqKuJwhQBII8aybIU9S6FRmx5r4yTOUMdg13msnUJOLEUtkRLM8v520p7yKCqRQNJAREdxQaxl1fCAwsTQlx6RuQdo2YKOHB3LgW63OWyzeTIS+sovcY451IyANwjq9Q1L9XmnTpal/////////////t/9vq9Ky1IM7q7MpTMp3RU6TnmWta01JMtlWrWmpFRi5VP47V8YffXZCthHJJLWOnlpbhb7wRas/0sq2crdLHouQrN1gAkHiiqE3caw7vbDSbrRbhlhKVExw4WOiSUwTb9ydp7KR4kTyOIvmfQSUj0bp4zs9ehF6VqqgbK/e0qz0OAEE57zphL9f/T/6/+/+n////////1b9+xt+cy6umYclbuazmNZpzTFo6OecjmUrno01aIqM5s4uinTW1MVD3J0PmlgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABOF6t4H6a3KVEbbwY0puUvog3gflrcpRR9vBjJ24HG/LcDmE0NA8kksO4aqWNXxmrMEoQRwoCOAbdfB8y2ISE6lSQHG8bYv2ShFwjIYyYGfBI3tLXuUwMALqpr0DgeWSHyhXActrRXLVWiYyTFoXj6CaCDJAUYgLUlpFE89VfmfVX3/9f//////f//r//vVq/6+6eikjWtBKtl22QZNaSmTU7JKTWmkymP4cbLCFnSUspoWeBbAK+wXtrBuKzMbELCZ5J8ZNZlmNvnK1iLkowBJI6HEpS3G/TqrMuv+31HKJwSQvAVi3BK2EUBQTsPTedQRAUhZyQsoOYFAgUmlvjZp47m/fZqLBkSBb/uYhEeUA+c67OFxXsvX6/6f/0/6//7////////0V73RVsYdSpGxx7VQ8w4x7aV1VvSqSFFdDnSXSr7Kiv2VJhiupaxMLiXthBoBsEzPmOeTXiOyVtaysJPpQvgXzaSYHEdsWhYKGaBd8sT8vp0EgjHFzidTjCzj5zNHMTRK41axNJkn9YFASi945ZIH2pqfksj6Xl6xmpG7IglS6pVse/znnOv///r1f////t//////79V1Ia1WUtCg90kk7IooUkVvvstd9mRWkyZxv1qSWydM41qkD3SNFC4WKKMxlMnIoCEaQt2BIF3Qyy5bv1YlIyUIABx0OUbRfkorP8lh/GWVHawDk2XlAQ4IWhhgIHnKlFN0BeeKQl+VDj7JTeKNnpmb8zH340+zZTPRi2HmnOPtAMNo/Bf87tbzP9N//////////v0///07I2dpOvohc050Nd0eP3u+y0ms/OQ5NFNVp6Iyqe5VGNa7Nz1qYakmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAASZLzeB+cpgljC28D8NblMeON4MZa3KZ0NbwYy1uQ+pgrwmAtAoD5bj3bLGpBQSj6kOEJKjEFqZMwMzO5T0y1eZpnR9/nsYGrc+g4WIgpUTPUlBhu0ITA4SFUqdhY9qD1cB2YVjZmtUii5a+Zq48+7jrVmR//e/8Mf//9f9/93793//3f//1I7230mBJaUBMk8FBZ4bIFQxOvAxw8AA8QItCwKmwM8MPOIEAnDr3khO5WUiBuHYA+TsZy2v1DCb2K0G3Vn15A7CygoOMhD53lsvnczUDn2YxsHAJUvctoNvFh4GMvqapSTLtResi6M+TKK8vjbkEMWo3hSqqGmk9at1nEEIpI96yUP/9vv////////////9///22U1akNdFSDMktaq1LVTUtrUEV0lJJKZlLRdSTspFVFlLUzLRSUcZfj6QihSaSV0pUZCiqhkTJmUNxltTmNXLvLFISDq8lI0a0U83J/CCxYuRRkiAnlg5am41t1Guj9kOhgMhoLWFCqcrOoKVfZ50OkNTR2nswHyS4XHdFQu38dklHAkitSVxxt6Hq7W///9v///////2/b/6vq6td9a9TaTqTW9JJlm2plKod01Oky3ugp0qNd2ZSKSCC1OnmrqdJJFNdzZXCm3beUyrFEqjlEaft67Paud2rMZStDWBhquJgpCzE5Ih2tULpZtUrJhs5gRVcFTSsODzlcpu4DCaEb9Q+yg9gwsoUbvXP34tKJRXmHCNwGdpvU27B5N37LJ3/p/R////////b////6//11Lqqu1023Uyk03TdToqSQTRoqup2RRprTdSa6l2QWqySNlrTSSTvWtAxTODL2ukLhYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEt3W3gxprco+QBvBjLW5TAjbeB+mtyj++G8Gcqblfc6DQgi60kjW/d2ZlljsQt28MsUC3BghicCA8i9knjie2F5a8jWi2wqBQ7kwAsCDEAZSNBu5aswyFV7uwTI3RN0BChYoLyu/bnOyrOXQGJHYprddKiFmaupKudfQWmvr71d///////////////Xar1670nQRTQpKpaalnGQUpaLMibNXh+pjk+IyEAJaN16qYDDP7lkurQv4I0sRRADxS15YIwyitHlS8zqNVHjGfhQCTAUe3ZzDLbNpSNI/0IVAOARVD0WQmR5WL1bdDKkeFapJplQLnJMhobON07VcZv/eMSbda97oOzLCO9+ocf//of/X////////////+v+uq161r00a+pSCDm6J26aKTMpL3+7ILUhUmuagVMjBfplwJGjq1GJrmTBBMgCgOY+EOXLJBrZomiZZ2VZXwlahUiOKFebbPwUBppS1jBDhKkXEXyZKk8HU36CDtHTzmEfABle1X44TSxUs1KxR1s7EM4XWwpj28b7oJp3BOSmprVD4/nvS+vt////X//////6////1/WylUa91u67Ld1pTq2VnV09dnSUtK6mSSS6kEmdSp1lrZborRQpsnbRmZFPedFkIgSBMSZnX8lEtpO/PZy+ppu9RuBmBu6MCVppqqAOXYrvn1G7a3yolyoGEywtNIJvOjkgjAX+9s0o+YzQrQwSWRachyfpMqRfAQNZ7j1Y8Ej/xEP/113/+n////////9Pv///9dWq+c9mMeVMNdzEQ06zHOhrTWMoxpRlzGI6a6t87XdmeIWlcMhZpCUEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABJaHN4H5a3KN0gbwYwduEkYM3gxlrcpGxJvBjKm5TygA3FyAUh/MjG+ex3Bvj6334BfG6XQdE7pGa5N1Fqp6sv2kVM2hADSEWiDYZ9GjREfKZo6aeBgBE3OX4BA0Ct1mraq/8PfaaQpRR5dqZSoEquq1ZN+/t9H//////////////p/33Uv0roNVpulNLLugpbszrSRZ1O7ord6KmUkya1pL26SFBaakDXKC2uMRREIqNyJhIKAlGVoZTAUvrY2Kmd6VV+R9WF2hN9cUPCa7+JzVZlr2DOIHQGFWEDtineiiZzurFRVCMPZmwg5VIYEwJRJ6N0uR+/ko0ryird5ijUA43fjZv+d9W//r////////////29Lemjnux63c41JrmtYxkOZrfzjGsax1SJx73apt7u9VQ5zZyv3Q2a6R2A6Rbolq647sQVXblY1ft8y31ukQeJba2gDnNdUUQc3KmhysdHkqYw4IUaEgYOYfUwh6tufnokIuG23Io+ZoowFU1T5V9vzus+wKFw5t9OmBSsl7Es/t7/V////////////////0FNdSDJIstTMpS1IspVKqtNRxFZuz02rU9V090lKqpIoOaITSGF4WNS9fpirTWNyAVaM9ZTMTNezyKze/u2KWqu5jKR0GiMD6k6JA5WEuazKuIVlVJCNsSZ9oqDVL1qvfEAT+Qms/4PqKixExAEvxguzMTNI7aj9Hh6MefPAgNtugj/T2+n////////////////ajLvNafNS7M6HGIqmnFJzolDjldWU0xknGKRmIYiVPRZQ47NOSyE+lDArpekAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAASFjTeB+VNyjRFG8GMqblF+Ct4H5a3KMkabwPwpuYrMogHkOMbS4YLuLe2TO8YXLbGn5l5fp0zHujeDtJW1L8m6nQ5yEkcaJoYwLcxQKjXNzVrAw0CYyeuPGYRhAwmxKMrNbJ7sLTcEB1zHq0sgDx73Vo0+d5btX+3///////////9P7J+7q6pOOZ1nIY81nU81CQ52bNnMZspfrstDTzl55y92syIzUst0WQGsOiMyfZ5hVTJVboq58zK69Xdur3tXB65wahnS6t6JKPtvIqVv+xOMl/BkomOj7Jrah8HVO96QnJmS+mhk9gh1Ie0gyVWZ2/Q1tRUvllr0MmM4H2+wUH//v///////////////T6WrVDDjtZzGrY9VPVEML3MmIzMrKcs0ySpU5zqJZM02tmNVHvQubBTYV4pFFsQFgQ8ti+4Mbqj5Xa+H5NkbyCYw2A6IYpnYgqe5F44KiQ4jkVHh5VJRhNYUFneVPgEVfVzUq0AgJYMUCSTVurk9meDRG9ncuugkk7BWu+1bt6Pv9tX////////////9X/3/1tUy27nluyK1rSWqt1OzIoJotbRQXorUhq7Gy55GjCqqs4vyBgStpFkJGGEpHYd7tb0swsXiRs7HWyPo0ouO/zpVPkw07CI370RhpHVpRWeC5ZTLoqTHcuNETYt3V9HXq7ynL4YT0BfHuclZR2K1s3rU0CEn+cF23/b5v///////////X///6+vocqM7S+inGHIeexxi2506ejshx7qVpzkVjlOarPNMnIqocVe6GMY0lqvBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEM3y3gflTcobRVvAzBW5RRh7eB+mtyjE9W8D8qbl4mRpA6gvUJYW1UtcRc31TfNUFDMJmSc+xpHQ31GMI/D1Uvu/LTSFxZr7FZ8uFRr3xHkyFi04qb5sDHFUFKGmv3qmEP57j1+dx9NWQMlv4tt6JzPv3////////////1/+3/etVd5murGozKQptSZPSpqHOiItbHE2idY03wtGb3NJsnxDU4aJoZkCIMBOPRxe1mBxuli5mtiWPGGGgZnvM0/FhJ28kxg3SuXiUfK0zi/Nr/wqVMMRkq4Zfgz8A4FakYYh87T2I7ulSfLlz39qfMHh7dYAv1T3+n/2/9v/////////v+//2YxnpnJd73JGHZ2Ym0rZVk6IS6IdnPIUgmhzPZBI7UsTi1JQ3PQ0GgTkBxekTqGrrtUj/G+3e2ksKBCvQ+Ag7Glz+lahml637zFUxOMZSS6XNg7GratiIErXF7EpEhq7GOZa/u5B8YdJ4p3PB1aSgrTZ9ssf1/+j///////////////+2rQZK9N1Mg91rRR0XrZBaLpsutFbvQQWtW9qTqWgupaFeg1M2Sxz4AggLpuIhxQBDwd4sLGeS4YG5nixn92pmrIkzBI8ZPMinaj9ESOMScO64dQvyVQSgKSPLPubjq990lPqwPjABzEiAtUNqct435VuxDJarfMHRFnCIM/DD5v19f////////7f/////0X6JutkMu7qWRlYw487YwxDjjjlOmte6FnTIqgQC0nrDIgckbfXpNxVxYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABEaOt4H5a3B/rubwYyduUOoQ3gfhrcofRZvA/Km5UZCBIzwFOGI0PW5q76C5XyqZzbnR1fD7HeTIsYDYpS5UOBYAl9EOmN+z1JjFYaxUuazKiUkznbitan1u1P7/w/nyJMzw76nqcwBoPL+ff1f+r///////////V////969HWpT1Nd0aS01oo6SbpsimprIO1B1WdBTXRdFVqfei90101ItZkXStMM41KiYii8Tq5cqW7NW3d+5krMnBJIi8zMbnImivWrs6+AZhJohHUKlSLeS0rNfHviiKr8JTGiNMLmxXU72g5O496Xpvd50RgA204P29H/7f/////////b///3/9v/snMYw90Z0fSx2fQ1c0yPE7cFTaiDPULAznc7bYsHSJfDIZGVAojMDSEZeOTU/kbH1/e/BsLOaq/XhOWqXmn3wqv1LHuhM+SgY/UUjprNitSWKVYYeBL70fpkyXN7rDeFJVsytlF/XU63ZwGOtX0m9P37V/////////////////Wm1aq3RSTSZaalKbUl0b9J1MpNloJtautbMYVLqRPKNXXJ6e6aWspV2FFcBoCOA6An2xgnjWprcPO5TNGGladJpz1Nsa8kLfZZNrIIAySZKg7/N3ZV1KXtezaygMoKh3jomcIVJVX3bFnO9f1nMlYc9/9Ugof8Ll//9jv///f/3/////////+tvqlda73MMdGoqs9zjmPMc5XaruY7nHKrIrnpIkoVMoe5i++Y8nPRz/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAARckDeDGGtwixFm8GMKblFaNN4H4a3KGscbwYwpuYxLxgqh8jazbtdpc7sv53mGEAoVUl9uhY3MYSiU24guCqn7Nvv1vnwd/FTKczpb1KVFkwKbK8mosSEX8eZWpXWrytrs/j/OucBCCl3zH7f72///////////////67feknXd6ndJqNboGL0qzi610Xekgt2Z3QNVontJ1UlVWRutFanZFJLZFJ76KzipXAbCF2DEoegimvTFPnzPvJRajy6JKoBA6dOrMFC1KW07+E9aVrUVnKVRioqhy7Xy2nIRDkGbdBRIWWTPichvzed6xfephljD03VAL0T1Bj6f+v/////////////0/+1712dFMY2xilZzmc4w009jbsfMutmOsyKux5zVmHmOYY+jqxioiq5V6J+KFXHaQQJUAvHQnnJtdRmq9Y/JXy6nruVQ2a5T9SNPnfoFf33EhTDF4xjiheaRO6+rNUsJgX9XE50EStE1nf1y5auza4qff1TjoAvIfnH//oVf///////////9v//6tdrrbZ6V2MFNSQQUm9kEFOzpKutlo6ka7IoMm67MgupJNa3TW+mutlKqn3aDQSxCHgQThcidOEmqy+rXxw+3rLQtGo5tG06viwtP2mlbtXX1yTUxv01DkzP87XdEolLozhNgrzcyh1DjhSd3+niWLe/6OqIGh33EG3r/6f//////////////2f/XZUnK6Izz3saYtSq6yE5FPRHOOUybNc9pyobOOc9jmOmUY1G1n2V3OLGWHgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAQZiDeB+FNyg7IG8GMKbhEKMt4H4a3KCESbwPepuXUYwwTxyHQpJta3Ctrf2LsAFttyjh2PSYOgyzOOvVTKHaXWzFQiJxColV+7OOKOrH62ElQnLTSwoK3K96rl+oIx77vPkYAE9fp8z////////////////9W/bsZVtJxpqK5uxquec101V6E6TDbIe89TDHZEWp7mnnIps11K2X1ZU4CHO22GIP4MnY4/U7cs1c7e+fUuSuHJU90DymtXhA96fvNri+GSk4DlnW+9ulfK1lULBnyx+lHuOyVjm+fTYcx2+i9r+HX0oA0Z+Wf/////////////////Tm2O+ultG0MYyfW6Ih7mnIhzIqq5iocdVLZ6tRUozsyO92U5j9yqu6O7qa5QznAHoHGb4MHzY38vvrHe2wJe4Q5XF9ReURtpta8s280uQMsXgixgnjxN3PCrnfUwKBauxAIqh6uGpY7j362DxwDrnrdSFQOp0a/+/+l///////////////2V9H11O90FpMutbu6CtRr0HpqTRXZTPRatOtJTpIqdFlOuyz7JukykUnSXWfgy2kNOM5gOwIyo30F/Ju/zjVohAw0Y5MnZoZqIIAUPV0g9J6IIRWVwBoVKvUGPXZKisWqncBPqQEs3+Ou9Xzk9jQrbd02AlaviV/2b////////////////X67sk5zuyK62Uwwoqs81j7tre7pU+p6mTTVOoVnqdc51YxUOlCWCMCJawdcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEOIg3gfhrcn9Q5vA9525PkejeB+FNyfs/28GMHbkn8cyxZRYzChsru+39ouuVL71JDVp+UhrKTuh7dHcZPismjXWOGShbtEa68p/KmtVio5yt6lZHNDu5mrOv3a+vm1fDn7uidDH/V/7///////////////9bWq1fVWgpFdFlqWgmkpJkUVqU7JPfui51VCnc1UkpttKf7KZGumio3XcgZEC1jANJLYtpzD4EaUkaPG3PLak1Jg+zMin4zk/nbH4H3GoEUo6DfPZLmET25Mpba1DiES5yIsARAhBVQb6pb+AtikvLfS7gu/iFv+/0////////////////7O7LRUearnIxpyIlc4+jmtWrGzGRGNnXqebSxioaOszOxzlTmGTrhnHlXSmHIuQj5D6QXk2ocOa/97WUB7Kpo1lt4sgLcTvwZfZBFnAIHMVnkm5ew2jwubqEKkgKfkpOwiwWQ5WLOGr31dWMeelTcBz+v/+///////////////2/+2lUszVc09c7ZWPu5zoe12V9Fc4ru80OMa4swAKSEsTBCtpxvKYIgZa4eNKRuXYcszWOOfMf+8n6oDqHJWp13KIt/WmJLqKz6jjxM3rkV59HXLHDH0d3Fv9sFISREDY5duZb52ypO1z+08If2M+n////////////////+npWt0NbqymOzs6GqYqI5jkkc401F2c3RB2t3mDg1EtZ8IxXffXJE/BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABAJ4t4GYU3J+EcbwPwduT13M3gfhTcn2yBvA/BW4IA/kuMPR7Jx1DA/S81wqY3FHqsSg0URL5h3wUm9Ud240qKPSSSrt3Z1fbtf5UsylBOp6/XbECYkKYvnetd+e7jHXVz5+iYD/9Pt/6f///////////////9+zIffMQ1nPZjnIHNRTDUpdWR0cuTnLGgkkBU/El0if/T6i4SHZV7WXRyDBC4DLPrNbOcSDHl3y9YUTcLKNaUByyzqZU1N2Gqi5W5reUbYRtF6i+xeulUr91tvUDjozSDDvcse/vB0rX/txB/KN///////////////////VaeyvelFNrc49x2a57mOrZ/ubfdnJsSZ3UyaYrIx1p7Irq5ZlQ4ejyQGcmQ5AapWriz9S714l9byxrqU4N5MBQtJm3UW/Pe0PNfdmJENGh0o0SyxPPOzuZFBzt/Ju5lYVWrju2aK785/1Wr63/3AUf/9P////////////////1vp/Xoaa5iMVc0o7SR6vkpvXyva/yvZ+0/YBD2yIitqYX8g1oW03LtXiwhpM7XqkC8G9s81YYSz+nZ1cYdnq69tq3C713jOknaaQlEKJLeTZ3t5L5dekqQWXOeKEXL96bw7lq2+v/6eoTb8J//+n///////////////volL+jLNccRcpnOqq5GR6mdV50uzo53lOcrzxd5ktIKtbSQjucs1yHEQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAQTjzeBmDtwdi/G8D8Cbk/SFN4H4O3J0b8bwYwJuRNRAzACRxKD6nX++Ww5yJsKuNPrgJ1fOUI8fNySu5MjnCViWbVEwby/Msa/cmIOdObjAPygJKDzd7uN+3rtZ5Py/pgH7ev//t///////////////Vf60taYacc5NUW7uWmM6MSVKyJx6zBw52NU40xmqpiKqWSjpm2nD7qpquhqpL0YVKGAZh0l+Zlm2K5nkvv+QSyK65GDObXYbhHa8OaqX4ZKgYq0ZuuTiZXuYX66/72MoFup6Nm1+VjL+4zcDc//wDfyP//z///////////////1/T6FKdmq0taM6oDVlrZpyu93dYJKNvBIfInCNYXi6haLPvC9ZsOtkP0M0W/N6380+c/lyOtVlLKqIMrYwow4vNvzaUavueOiSzeIWvLm2y53ukXpDRblQfd/ysNDjlc5Ocz/HDn9cGP+n///////////////2//r9jVppnnO5rnuc6GJypzMYs04yxhx66G0U5zGd7bntONOdyGbHEbKntHo8o/7OwcdmjvRWrrG7V5jv+8wWnqMYru78Gs3/l3vcH6KoW8gIoPahd7H8c5lRnPGVBo2HK0TGux7m/y2+WHf/FN+C//9v/////////////t/f13torPq72U85iG2Mlau0xt29EMqpBCv4DPmo+XNbwavXEmxIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAD9I43gfg7cnaRJvBh4m5OvjDeB+Ctyd7EW8D8CbljlL6iEkQCPArK9rmv/Hsw2DbNaQifT+2F78s6O3D8sV4m8jEo+XSrx3dbD+O03udxsoEExkrLQ/O65L9dqT17nOlA1/T/3+v///////////////Sl/eetprIlbm1RUOS0ylDWPMdkoeatZ51hylkMZ3U05rnEa1dUmTprF2cJmNLJDioJma156ds6r2uf9bgDKkboAsNIa6Fi3lXabavQloqDvFilRk0e+7nYFl6HuAeB3mLCtFb601ldoXj/vlb8H/////////////////36f+6Ur53ZnN51NKgg7lOV7spjNWdqNdT7NRHqlbHKcWCYv9Mu8Xr1PDmgtKszPC1qFjXf69Dh3JVLS9H9zYvb3FMX1p1JukRCbqLInGUZVtY4oI6Gk3BAIG8hNOP59r6pP7cgXHX68FP+f//////////////////f7N/pexmcr85Uqz711Yx5p3O6Ka5HNS96kWtSIyvSii7Ax6kimI0lRMxiy2p9319Za7WYXi+2Cru6lSJF74TyCsqV2VGHxVBtgeON/XRwTHuZvAAmspp8/7Z73/zl2v/8V/Bf+/1///////////////6b5aFmoyTrDJZQZM1nOy2SqFWtDLKzI9XUhisCMaLO5CI9ZBbiU3uFncAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA8GEN4H4O3Jx7mbwPmVuT0oc3gfgrcnHxxvA+J24SFCjF8uC85zPesus/vOtGaRnC5QlX/XgejG5D9aAJ9Sx41C3QFk2Gz2N83XQ9XvIeWwyxAgmNQ5/e1X33Kfz5/4Rf2////////////////////srIuaXOSnR01mrYhPc1DXHkWs1zKui7nnUqrDlMIqWMHmeCbA9LzsjBiAjK7veaJNWtLWTYUIwzBqH0ZQuxHKSRfcmzxeKgeEjA7MPQP3WoITG5qxWB7ifdWcUpc4TjP/AV/z/+3///////////////0+uvItHvecax5qrkI6s7ic6JqoIIDg63B+Jxn2/JQptiND9ImJ9YnEdwg52o6PB1n61m31utUgmq7lKqtbuUyQNj7V+XYJjqOtCY0hX13e47/ruJ581MizCwxcVW19btTf1op3/+oW37//////////////////1/pq3R0c12Na+xSks5We7URR9xcpjsJuQQKcphrLorO7OyCg6369IgoxzDUYXZeDKbHO2KZrXSCTqE3mBWPCxpJkyD0fWXlkNTJs+J9H0LLTEftSZQrYT4apDVAHAu3qZTLemSP/CJv///r/////////////////0a6d0odVqorO7K+5xzGmvZnNzGvNbeiy6lVq985bsqyb0LoWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAPLjTeB+BNydhAW8GHnbk6aLN4H4K3JtrgbwMkJuT5bhFC3DfSunPc29Q6ff9bstTUtolNbGcdYnavYYx+ynIxu1BY0q+z7u+99Ds+dnlYu+Sotfb7vlf/3Z3//l/r//////////////////f+dVZdFZUMRjkJS5tqFLbYG5LoWZbkK5TOUrsVWIk0plRHREYyOaUQpQsDyidgQaopZOXc6lPjnjZ7Wu6E82xPVBmp+CaZjuOlJtFNxqTiijCMR8a1kzTV1k9AGUwTzl1tv9v5YO//qIW/O//////////////////9L9E6q1kP2VT2Rnnua7mJR551DFVENtPazmHHlj2b7leRNUloaFqIkKkUyHFjISV0r/WN3pvX6yj0V1FsGLa3YZ1lyv8zpYNotRo7EMXrx5f7skBCLOElReJFPJhf5d3l/9n9c/8IN+T/////////////////T/ZP0aqeTOZ0mcyHe5Mh3VqJVTIhT5IwtzE3M1WdmnRlmcXMbLckBKyyuGwaIonev1drzO5wZ9iUNSvk2FzLTdiLGgs0Z4bIz5AlB4ns6IaOPB9imAySxtOtjzsgpQ5364B/L/////////////////+v9fXVZO5yMdKIwpsJoDhyVixqVPjXOqW+DYNwBu8F2gWR5FJQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADoYc3gZgrcmxORvA+Im5NbgTeBDytya69G8D3ibldyUHioJPvuXyd2n6ytLc3fxbzvzTQbHaT5RbYxEaKcJi2HQwwrbxVSey19RACQkTwqWu4dz3y5Gv//qA/9///////////////////b2ZvkUxnWrso0pCOUpVVm2RBSqSol7ks5EZ1nZzSueeQV+z1jA2fsjDrYMZLIyE57ta9K3W1AZg4WkSIvHSHbSOliP6IhMbHiZEMREaunrC8SLpSZBHBnB6TVKV8yFtb/A////////////////////+29+m9ZnNKCZ53MMoRJ0KvD5oA3HWWnGZp+CnTkbvN0Oyz5KguwUBwFQpCtrGvxiGqbwJDrx1yauvF6msOVWMphHrgu81oGakrNr02BSOoHg2W9vj6vB1/+GP////////////////////t0dqKiIxX2vbZIuSkzSSlRnS0ayrK6HaqCBUhNrNK4RxU9GhozhWVxuD3ewIm8W3T/WPDbem6oVvLYd0PSx2WMQlduC8TWIQbWa/iyjbxldBD1Mt53u+f6Sv9//gH///////////////////+pu/9HdnZHZ0UlJUU9SUfK6ldQbQ/lepD4SeEBgWJY2R8ncxmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAA4yDt4GPO3Ju0KbwPeJuTWXI3gY87cmYwJvA14m5T2EBkKSCop/z9a9vHXaAxBlTGu2il2st7fzCTGcq10FvHbN6+shLYONVBqHqDxaqfOs/6f7//Bc36//////////////////9O/1eyo+h7nGq1zWqioqIymLPV1eccx585jHMZGdFdCl2nFaAClYSiRQvFWQ6RJWrG70+fq+caa0Igqap9ZpGGbEgQ+1ZGMi1lMF7uLrutcWmG3jDeEePSfV9Rfv7qgr//i///////////////////0/1tpemkxUIk5rIdDJQiUY0d2Qj1KSzpYQQkrlUyyKOd3823KU6NuI2gVl1Wkaiv1bz24x2uXG9nL7qQ/q3YOudiYnsWqLQ7qzXz7KBLYzIJuLuHZJrcv+Pti1/+Bv9P//////////////////63MrRXRjGQ9qyirtNNLHEt6ahBgcWR8Y/MmDrJKuFWQ6a3eHX1QZlSwnYJ8kaa2Wv3ujW26QNEvuinXP7730RDelG8Z1io37+xgEVf6A4jIif7k+fjDR//xH///////////////////66X93S+VjqRerGD0KczVuzK5jvW9bJcnUbsJ/hq/64XQGy2kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA354N4HvO3JrEMbwMaJuTdIY3gfArcmmxpvA9pW5y8N0jDc4PrQcW3in/8rq61HKbeowdlcPcMEYl0Ya8EamlHrdr2Gk+tvJMAd5Eya1A3n7uof/+Bj////////////////////oj3TS7srpOOOcxH2NQxc1UKGGJc2V4YqfoZAMDQIULmcURRj5Futz6S+rEwDxDYPL1/57V2KyUOGahOFOYg1vPUFBLjHF4ZxwIiZ6eHwbjKkAyxAheU9d6ljnf/F/////////////////////qftVSojVqzqlKLQtmqpURT0UyIWyXYiqU7kdCnLHUfvMBeOzABsPTxC2Uso9Ie823Ez0dBI6SB0T4isfxQakR6kOPDRI8QMWCKsSylPinEi+K6Ecqz1JqUxKyX+A/9v//////////////////9+rHfO5kIynIqijsd3cjKRjUlZkcq3YhCrTOh6TO26jNhPGyS4XXEmbVu4xxX1G+baX9vqjZWWrE6TGDrHwT6kfpGocwkRaohlYZD+BsPnlFYRRYtEHbas4MF/wT+3//////////////////+1uk1ZDIdEOrdy0t2LaiuRSruVnnVLmY5HT3OSysYUU6rI41GfQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAMYJTeBa3pQZ7HG8C3ibkyglN4GLalBlsObwPaJuStINQ1XDyvO7rqfsoWgkqCmyTgB140bSekGVZXyJux1f4zpPuFvzSBIreZtX//qya////edP////////+2u5KjTiUPPPhkaaKigeGwuFgEgAgwB1mhOBXBsLEjcLh0LIaFx6EGjsEh1Evv/rv3+YsFCKnR8Ph46zJ4eEWpDVXTbh//b8XZk15B6WBAY+/9/Fisr/+K/p///////////////////Ktf2sY01RaoUqoZSohVeRndKJs5raYgfctmKFq6mmO10VnImJpobp8BIKyOIDtsvTqd8WIj7IZMCZ+YDBsJyi4yAiRFLKThdT7vWH032EpBKh7OtRdWdJv/N+j////////9+tDTjSJOSWAiTwuGouoqDB88wsDAJAuARUVGgwIEhUFSDGDFPBMVB8BQtIop05u82ae+/Rq2LTAerDDvKws3nqCYkwhiCoV3Q3XH4RDs4Pw9xEq1WzMYd/8T////////////////////+zGol77KYiFPhZ7buRrGLsd2mVEqRFahySKdLHZiOPUie7N4m4kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADVIc3gW0rcmVRxvAtom5MdeTeBbRNyYI3m8CWibkRGjECwIJSlX1DPqciDwOmCIrIKMx259AakBgwgykm6grldyVHXUOo0hHOoznoj2/4Z//////////////////7dPba3u6JOjkMrIRLpJKpb1tS6K6o5zHGIhrCqJVUIZzklIIxXpZt7DYEQxJBLcClvfVOj9nrWkN0dlZIBzk1G84gIyJs5PJ1e9RMDgzobgfyCqy6ew7m/xX////////////////////72QntzkZUdlZ2BuxXLxy3nOrohCNO6IXcpHIZna56qxKrM91MCbpEekBcH1MhLOTFaHNTmRKqKJwOe6LkJ0TRZJmo9BVNkWiFr40DcuxKMEc76l1F3/gX83/////////////////p/897HVh3VzHWrM7LOh+RJEebhlqj88uCBa73f6F0rn5pCpyLgfUQAIcKeUYfK/1McWXJW0nCIZI5TRDnDUWojZLzK49xEpLODFD6jZ9txgW/xP9//////////////////7/+laIqpRSFYMaFSgzHT4jxyjVDVGPC2Tdt0Xr0GsHIP3geAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAuZ7N4DNK3JicEbwMaJuS9ok3gQ0Tcl9xdvA1om5FkSY4ytjz/LeqdLEi+4xHqbpjtPjjGnRi496hBD+o1EkDWdXX1yE/+Ef/////////////////9v+/3qqbK89pXnoVWzbmKpTtcl13Ee8g4Pp3IrSDLIPwJrFxBpNDumASFZpe3f2/s84UVEqsnIqTLujMXEpKi04Ssm1NWLpYzOHoZ01o1U9Y6v/iv////////////////////qr6LoiJqZlvVZGmTqiJu5SnOqXqdA6aKJD8T0HhthY4yclbAaS4NwHh6j3p//K2WS0fc71qJjjELq6cZ6uPYgJNI4HwWy3o+gaf8F////////////////////6UV6botVoZmc7VDKqnQ9CyoYzoyVR0fSsbIiMRGlKpWOKDFrkg+SoSEgkUQsgxmi07f7ljjzTLuib5+YOIpM+cG9x+9YqraiF8GctW3VqLn/L///////////////////99uVtWM6z5CKyODGa9lMREZUOqzOdH3ZXuZN6GR0cxCkPpe6x77HFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAKvJTeBh2pQXlAm8CFCbkqVuN4ENE3JbUCbwLUJub4Jp6Zn+bOz2+ISzBhgtqM0ycw/kw+mlJB+sQ5BZlj0BRG16vcx/53/////////66Ulhr0gosmEgETBomBCTzEsJrCQYaWUaFRhoKz6hUMAIoF0EGIWGCgBzQhAlVw81f7DMTFIJbQbOrSZgODGVFqL16iBHTJQJYeilda7j3/m////////////////////9vzfeQztHOkiICZTohVWqTmIy3ec5VOR2hyoMna4pbPuJb82YZpwqFHuHjv/5FTUX0hwtWreT0SITi1iNP/GK+oeoqFBT3vzb/hP///////////////////+zfkLVrFed0BqQ70QdI6v0z0XiabucS9rLt9U2rNd+8raPIeQwNqvv642Ecciyo61BY8hQC+Yo0sk/FQdyoFJhSulOTP/l////////////////////T+qqzlRdGuplUqpQiF2Sxyszto5HMzHRsyAlZnZ1q3qo8JQWRUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAC+pA3gK0TcFnQNvAtQm5LRcjeA7RNyTkQG8BzqSgJBweYIAYbcn+Vm0vJiVJ3NWs5i4+qKZwxZHXsbtWMoVBsU9dua/9////////////////////06r+7TXMesr3VFS6mddToplkdCtI5bs+lUUp3VJZFVkOQhjSOUrnUoaWGo0idaa3f/mCOSxu4UjTxZyaig2FCxhLIvQKw2ugHRgOr687/p////////////////////fztdVbdjKbTU6OxEkdmQytcitq12V6ksiq4q357ToZV7cOHoR9QvFYi32t1zF2PRWZ5u9cmOSRmR1EOe9QzILxKBZC0U/9/+X///////////////////72ok+j2KVEYq7mVznHM5SDClEf5V4JqCN1L5P5Gh6EJiG258CKqfQrUiBIISKbv0awhdRyAfU0GvbQK4uNOeL/hgXzgPjId605b1//////////R3gplkOl3F2nQgbCpgi4KAqUCzVKHmSaB5VDYSGhCRWRFg4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAsd5N4CqE3JKQ3bwGOc4CzXs3gKoTcknEBvAk50oKoFAADhwqN2+wpQ04CN6DzOnMIkZjpUWlG2mXHHoF2XBJNPmf9P////////////////////6uiKzO7Kt7OrbIqDra9LGMdojyV2EXptGGQltxE6VPP1t6q8pA0DP6Vm/YQk4tUIMoKN6qEQmy8c3wOIZUBAoL7qz/s//////////0pFCTjRsEyBcJB1L5s61BEyEmEiSoCK2EIyZASSoPnlGjAQURCwjJbp9MueCwbPFnZSsRQjkxomKS/D016iCEcOJ/dv+f//////////////////0/RKUS27ts7q6LKhLMd2JcIxy5KvcqR2dqJO0EAYHLMQK96r04s4ZHSlQyKJ1H7+rCcnJwh3Aq3aDkQOeZP+PDDUAaBj9PQe9P//////////Nvc/OGFHgQQkDXPcJTwHEAVafPCMAOpQ9JQexwVMC7VmgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAKwizeA5xNyUM3m8B1CbkqCIN4DnE3JPrgbwHOJuR5gsLx9dr/5dRogG6i7WY4kiFigZQe+KSWgBohDk/3/7f////////////////////0f7HVjMk2RngmpI13KTKRDUIl2Kx5jNV0rckhLqjOQ6h2V3KWwoFglImO//lRspSIrUnfpEMRF7TX9i3BUMm/4s/9v//////////////////+nrr53WxmKzykVDsL2oikGryQ/TauyeifNO20GGyzGYKyb9yXEqaoTCxj6f+Yhp4DtEzpSLhCWKDeJ/sX4NA8YT/If9P///////////////////uyemtZn9ns3UlluiSKQ87kYqUWRkJKSyMWVCM5iUSObwS4ByJ4pJAAoZDKUX/UXyMa7Db1i04ven3M1CQcLf6l//////////////////////7S7I1chKlLKUitcSEmMcBPzpBQ6oSEJZ2r4fAMPbrWMheqoW0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAACoXw3gKoTck6wpvAUom5J7ijeApxNyTvIG8BSibicBBUggh7/8nk0KVtdp7EovHDxOlPi4m1FgMW/1P/6///////////////////02rR/TVOfcKrqx1na7JVXGRCnXRmsZB3ixRZ5DZSaHJ9ErRBYWvI8PAgDujf/Frw9wXasHht7fYc1AsYO6fJ/1////////////////////VPfZLHqbYyyN5qkhLKQtEVjGRzOinRyvZHfZJ0GKq/FXKCPE6+iaBXG7/+kyDeZ6y6jBUyvxAZoJxS//O/6f//////////////////9/tVqrfVmaQxkBOzMGOhyEW535EnVKSmIe1K9qpYrCHqyOZg+W9CchBFGBELHk2/0B6S6g/pFI+l/q2oGO3/X/p////////////////////9dPQ7lcrOr3MVGdHchnPksRHTKFuyPkVCmnQjmXeVWZ9y1sSFMkWQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAAnyKt4BHE3JMEGbwHOJuCZY83gEUTcEbtlvAcQm5WGab/9XRlCTn6UlkLKHW+PFuNipf/lv/////////////////////03RmquxG7HPZSLpoxzslJTsdgWKqapLlEHdSOUrxDMZTEjMwNHc1gVRHE4WJM3/lDrTtB789S9pn/hxVv+d//////////////////////rbTPcxHRSM7lM6kZkLU9b6WdCoLfIEKfqOjMYO4lBzUWwmCyiiEUSGCDr//j0D+hte4xkLf4mO4Ko//v/////////////////////5K6c3Wqoe9mLlI6vU7Feu85bTGe2ayKxUQqKrOdNmJLZjI7rK4JNh0RgiNt/4IXeXQTtyK/f69AMH/7f/////////////////////p76ultlQg9xCAQ6VZFObBeaVYWWRq8D9wtt8ngOD+DDrdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAh93t4ClE3JGT4bwBEJuSPIs3gCITckHOlvAEQm5lQLI//8ypEuO36IyD5fhHxeP/5P/////////////////////p8ljt+7KR7mTPTPZn2UEX88anvjsitofu/Xa76dd/UdjQUf/wRqX1P+qveX69Qy////////////////////////92qXyKY7ItGMrlUjuyKzoQyVmVC5WB1CRdqbaJz7MM5Fd7lHSY2J//9oDqf9Uzf1fkR/+3//////////////////////ZurMzkKUjLWS4Wd6mZalRDzqzaaoiMVTNd2KYhUWystkUrRoE0DVRGFh//oeX6fmvzf+J/+//////////////////////9aV9FrVlRqbFZCuIVjwTHXamj4YHL6S7Dl3xflL5Yz4KTOIgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAIbejeAIhNyRRGm8AgibkfF3t4AhE3I8zpbwBCJucm///eK5v01b+nqn//////////////////////09rZL07JJIhWSLOcjksd2WrKcdqviOj3r5jELGQgW8qYaPGF+8gs1h7//lv6/D8P/j////////////////////////+etGerpWqKVrQbMquQ6rdTvKjEBCVerIzFazoRZHdd0RVZpXcoe2nEd3//8PX/r+Xi////////////////////////+jXZZkvVbkZUJZzEndzIRSxTA55dU+s01VKv0fIfH9OIyS97X////xf/+X///////////////////////16eqcitbOdLHWYplO6qKQndi7kk9q/QdJKQhz+n3A4hOxkaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAB5483gAETcj8x5vAAIm5GsgDeAABNyMAAW8AAAAD/f////////////////////////////f7/VCqqXrZ6o7KpdGZNXNNShs9YUiopXcgaw1yXOVlsEOheQ4iP/////+v//////////////////////9vk+jvXNcyqzPIxGNOyCDo9bx2Q9GzzKVUUrUznYikRlYspHdEMtRMJ/////////////////////79+15HUrNVFRaqhWW5VB0Kx9amVUcqnUjxZGatbjYm6LJMUMW3P///////////////++lrSrkzhkFzr1HwGVKpKUBkWDxQKjzD0jXgsHgYB8y8oTPmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAb2QN4AAE3A1D6bwAAJuRpXC3gAATcjnRxvAAAm5////////////////////02p/02MSzrMRZCMs9ndTXGQ9UOc1ikOys1HVedUkQ6yVZWM5JsdE3C/////////////////////q1n39tHoqOZElurnJITdnLkc3MqHUWshBmDsvEaD22It6VbW8R/////////////////////2Rk9+VWmMW05WQ6hjA2DFabGJ2Rp7ALHVg5xL4cP7octaakGq/////////////////////rv6GOy1XdaIqYQfdXmdERVch3WiIYr0O05juaokjYYKYh0hiE5Xs4MWXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAGCADeAAAAAMYAG8AAAAAad4t4AAE3I5kebwAAJuf///////////////ouQ46q8IohcNPBMFCR4KEO1qXXESCAGHgq0ckeswI0gcCk2hr///////////////7vO1l2FSsOhs8KlDwFC7YkOAmNBgJAcXPEyQuOkyAUGz6j5MXiD/////////////////////7ulTurmoY1XSZygnyE0PNFTWhH1QyhXSEpD30V9CUNDRrDt9Sf////////////////////au6WtRUvbGq7GS5VuSRUOR2Yz3Rkcrucxl1JHSrKZ5ZEOhN5kM7tQoJOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABPgA3gAAAACKABvAAAAAAAADeAAAAAAAAG8AAAAD////////////////+QyQdUhJWecAh0NUHkPPREpTxMSfeEiSxsRZX////////////////8s+HT0Gip1+uRPV5LlgKZnXMcp3yxIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAAAAN4AAAAAAAAbwAAAAAAAA3gAAAAAAABvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==";

var ExerciseFinished6 = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwMjM0IDAwMDAwMjIyIDAwMDA0ODgzIDAwMDAyMEE2IDAwMDAwMDRFIDAwMDAwMDRFIDAwMDA2RTIzIDAwMDA3ODcyIDAwMDAwMDM0IDAwMDAwMDM0AENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDA3RUMgMDAwMDAwMDAwMDAyRDM4NCAwMDAwMDAwMCAwMDAyNzhBOCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAR3gzeDD0NyiJBm8GHnbl5uMugNZe3L7MUcwby9uVb0624JtmULU8csZZz885hWHIPQZQ4Iisb2eP4byJ74eaxTFNbu/tTX///pqmd/0pTLx5VjEeEIpET5/shJf4rd7RN3RN3fiv0m/5tE//+nveBd/rTdESbSX3vl3hEhK//+dK+Uqb3tP5e4/+X+K35v97eXe+b9//d9P0r/3eEm3j4mBKAHEw/hEPdHf/u0EPjjWECJvaq6KxfCpSc79RgL4JoW4TBkUDezs939KZ3AeRP//TMeBr3x/TUO2tQ90pSnhvNQ37mDhCYZnv5jH8xjGo3zK/P0bRsxkaee7H57zD7UZT9vnueinv21fmGfnn6n56GGTNPTT7oY3V135jT0MnnvPdLp9DG6OZ0UoDgX/+Z4fmWM8QNEjSQDUIjGDyUMme9EP55wxGIFfpliY4IKSIBshhQiZ5lHDxiJ7WmWQI+kMuO7ErcuvUcOQzUHRyQ1pJYwt3K9yvcxyr3KK/vO1OR+V4XcJMuqWbFayWh53WzfPa00G1njBBiUpbw7xIdbvIkseOwSsEzZEcN5tRjfU0yN+39p3isi62322rHktoePN941WTLys8ONSjx5C+Y+NRMVhOD+WSJJrMCuXk0Ozer4WaYznV47fHvmR7PArI4RGzN494d9YkiSx4c9cZrq7/cS9KTXlxe0se9b3h4j7zbLPTN76jABBpxq4xWJV+4UzjEjhfye2sDww00JGMgHDChswwuL9yOLvO605ZsS5zC+ZgJJiGbAFtw281FhJgLhqXJ0RRcjqsvaQ8bL4vDk3ORyQWodgJ2IchzLs3P38bFNKZ29PU16vhM4RPcYhxswwTTPIe4OHjA6szzvY8lbPG+HDkpL4cCkd/nbyArGRkgRGN3qnki5uq9SQaNbVO/iP6StUS6sgZpZ4yUs/hw7RKVeSb3XFssbvV4b+PCiucCWt7+V+8pA+mtmYWd3rEbPpljklfwWdspWykmxCpnxNXxpQU1EY7x3+vSPetMyekCBBtDf41SkCKn58TT4jzXzbcwB28pjTYoHUDw49qxrICT9LgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHjYo+hWqAAu6QZ9CtbABdDkEgWToAA5FIJAsnQAAlTEINKowq9BMa4kaueZ0kLRDRFgaJERAFAQcPVvUDSrRrCIgD6DwPTLAz4kehmA+AWAwGoMiZMRQuHyIjnk6TRiUioPsZctnC8R5XmCDE4ZnjBZ0mzdRcQpMYJIuX1k2kXC4XEC4kaGRFC4Yl8vprTrZEzL5fSNEzdNEuHjCmbmZunQZNnZN0S+X1mBsaIUGUhMmmDIOgmZm5u6kKzMqHzRaSSDTAuLRN0FIIU00GTszJoLQVMC46Z9NSCabpLTN3NFMtlIGDOmgaH2pvY4zIGi0moIJrSQNGTsnQSZaCa7oIKUsmw5IW916CFa3UgaMaoZ6ElWiEYFqrIbI8ZeGZ0EUKTPDDAiQsUEhoQDT3Lxl7y6YgDgkgNfSzHQd6FiKYNMlD0OrLtQxDmcmi8plU3TQ5H4bv0lNd1SRi9SUl6kpLH27l6kwrbz1dp85XT09bDVT/lE5b1Y3Xp7f18d/Uqbt57w3vPKpUscyr/3WGG8L9jP9V6+erVTf6xuWPysV+85nhX5T527f6w+kxrYVM8KmFukvYbt27/5587+eX/nnUxqVOZWKfedf7l7ve4a5n+e/wwx7/cdWK+WGH561lv9UlfWeG/1dt63zPDe9Z5f3mv7zmef1FovYYAf24gP2AAgpIALGQYTVxWwzAfoS4hQwAIcAWQ3YkSdDUw28BBgUACcIFCoFGAH9qkQUsbJFFgiPiEYGFHuybueNWAaFgYcOBiQoIganvN6dQGVHgKCzIDIhw9at67MaJpGYXUA1HAY4KBrSIG3RgsTp0FVm6d1u4uAAIOHTmQNzxS6Ts77W2PvqWFwYybiC4pdISmLjJ9BrX3Tdlu96VoguM2XxKZE1jNjnlcg5F///vb1N5XMyLldZmfLh03GYPJiUCIf//r////51v8vg3YLNEAx4FbjJokDImXy+bpmaZB0kSLmxoLLLxOC4z8ABAiQAxIkVFh0gyAmwkxChUAEgAOhNAkSdDUw28Aw8G2A1kBRoBR4B7a5EFIjBIoiChsQjAwo92TdzxaQAkHAw4cDEhwtLU6nc/TwMqPAUFmQGRDh61afQ03MwvoDUcBkAoGtIgbdGCw+nQUqbp3ReMwAMHDp0gbnil0u/3Ux97KWFwYycQXFLpCUxZZXba6lUbJu1NnqiUxmzcSmQeM2QMkxzyL////q+Vy+Rcrol83LiJuOYeTEECIe//9X////V/0wbsFmiAY8Czxk0RyyJl8vm5fL6ZB0i4Qc+aCyy8TguM/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB7OQTQZSoADXkgnBydAAneZBXVipAAPfyCu3DzAAKwjAnRLjgYvCzAgiAwfIIAE2DBorUwEAzAA6eRMCANAwuABHoGNA2CEAA1TAf4Y0TqDY0Q8nAMQAgdg1QtGGVI4NmIjJovFU2L5eKogMJ+MgxUXDSkXyPMlpHxnwAQQAaOwABcFoQgEQ8fQJA0AZQB05CEAUEgQBiwIkHJMdxsOodxeKRFj6SCrrpIvZI2JorEDIsVncmltHSO10kkXsieZd5kXjUiw5gsgsl6tbKcuihhiPr8pD6JY2W6RkdZSK0FostE1cnf1N11nH1K/5kTpgICkCJkqlIxRMk2ddJSTqMnOE86nn0DhPOz7fV7XdDu5l///t4AAMWgqi+OCMw3wWSBJZAADvChRlTAXGYANrK4IAYDCYXCBqAYYuAr2FeHSLhDExTKgGaBE4UQ+YgJkI6J1ArF4quWTY1FnDSSEFjBnU5ZdNR8fwbSAenAQeDVwpYjyOBoDAU2ClyWLiQRAAZoOXyuRI2IcSRsZE8fdBV10mfUkZGxNl42dy9aQ0q0qL1It3pGSJPEUGYOmVaNTojPEI+vzIpFpJdSS2UitS0a0UZr+pv1Pulto1qMjVAVqTRMnjIxROWfSUlpOcLzqefY4Xvt//f3pf//7foAAABAAAAAOBwOBNUopENCEaoJ5EPIUrAXvH0xeOjki2YzIarJ4GlA1AYWuaJqQRYmh9/LgswcAXADsIEbAR8DdxAHUb6YuQcxRcIoJ1SJkVqOcQ7+VCDpE4LLHG5RJoPWIkXxKQYqdndn4YrE5mAeuXjQnzhoKRAeAFvAkQnYvkOIMTPrUj5gRQ0IoaWTcvm46iLi5TMompTWRZAvf/90ybNy+X063NEJOIFIhgzIsouFwsGZqxmUS6ZmP////y4aMaZfN3IuRc3Fxn5fL6aaadN2zE4snVFQvIGA50oh0wnYkikXS4TyzUyMTVzqFkAAAAAAYAAAAAcDgcCaeUUeFhUWoGyg0gjAPePpAvLE8iiYuELmyeCCAETCxUlplRNSBVYmhr/LgswZALgBoDqKwEYgYzhl3Ub6YsgcxAuEUFamQ+RXRyia/lQg5kTglMcaRTGMD5iJEUD2gxs7O7PwxWJzMA9cvGhPnDQZEGpgJXCyIXMQchw9Er61N5gRQ0IIaWTcvm46iBi5WIiVTU0JpZe//7m5Nlcny+nW5cQk4gUi8LNE7E+Zl41LqzxdJ08Vf////lwuMaZfN3IuRc3Fxn5fL6aaadN2ydSWTqBaMkzAgSjUOWEFieLBRLhFjpqUjpqfOoJgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAf2jFQHQ2ACvI8q9ODMAF+CPUqMbw3bOb0p0H1JuaVVEQEHormpqWRgAvEWda8tTMtlMcpxADFEmdsHiwq7tjGdv38d51srdjKfo61NKuXKrsooq2gBUMVBFdOfSSzO5KKKZvzU/Vh2rOTOG91bmGVuU02VRcbdFiTMFuPbmH3jMqty+q6kqht3YupqsdxXYbGntAV6BaWNSymxxprsRjM1Wzr45b1rv2cN6+1lVq1qtTX4Vsu4fV/VqmyprVa0qGlpbMuluFzfL2dNu9juvjZ/d/muZbsUvK1qU5YcyytY3rtWlw1369mpVwX28tBz8L+OP6y7+u/q1nclL6tdcWVWu548+1rWX445Zfj+Wu6wzr3ub3e/ut6kgUTWmTZbCAFNhicTpxPqqUkQMBwQF4lcvUVKfWy2UbUVoskbGyZ0hwNsA45Z1bpsdLxeRROF5TmJeP0i8XnWgiiXSwXj6aJkXS6ioyUkZGRETyY+SCkCD4hbhjRliiYnCLF5NFFaJkXi8iijqLyVfXRqSSSSRRRmT2UiuuiitGjzJZBUU0VJOsxZVJIvJJtdFSSXSMkUkloskkkkqijSSTSNq0W/RRZSSS6KJiak0SUcV//4K6E+kV+L5snm3hNkgQAAAB+s/r3B1DiEBIVZuDEB5WP5//LW8ZVGiEBFXs/cFDChSygjFeZlncscdZ6uWrt+ko4pAd+Lt2XuTORESOFQT3NRGxSWu5WrWu1bcslus+0U72eyyboojEASiHn1h6dvTdyAoNk24DpYS3iqrbKMVY83cH9cSbm6abt2bEcuYWdXsqXL9fn25q53teU1su26udLas/vLHX753f5X7mEtSh3yrYi2dW/Zt02+3sM72+W8Mss+9xxys/hnb5a33veawu1ML9b9XLmS5YXhnc/uscLn9/XN/3Oteyp+3uYc5ruPd/llveHMv338Mu77rPl/u9Z4zOGPfu5xCWAgwBdDZnoggf/9/u6sqqSZ4U1D3qiY28tXPLff1vPm5jdn6uNSxLPydB/zInpGpvD2WuZ7v7v0qJqotmKBkgmpykfNWKKZGGZ02My6UjUliLmpdLpGFYdRHGY54oQXEHOKoyRMgjIgxocTKxQPl4qmiButBNTGqS6K62ZziKSKSRpPmzIJpLWpaV1opOddS1F4nkqaKlLUYqrrdmmjOpNSS0aKSLT6KfRNqKSrKLyCaDposg92qqZSKJix41SRbfajKrf/D7dj3LIexxUoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAINZBRgzvDcNCSCmQHT24ibjFEjXMNyzI9qVB8vbn8cvx9iRWAS0tmrSQlsgy3h+vxqX5RIX8UDMYQjjawy1aMCCWDPzNV5NY3lhruNPO8nKWZ9+IYgZD9zBBEkQW87Zp3tynptSiAZJdu44Uc1lu5qt2x3lI/DW0W+oyvJDt+OV5DSR620uRw1FrSmroPQ0tKOAkqDyHsO1YRZ7RRqdhqVzOdLO2Mr1nuWf2tb3KJVavV71uxhnhLKfLeW8d87X+YrTT0Ld1nHoerySNyWjprNNdp5Xrdi1c5Uv9q4288rG8cMcecv3+/V5y/h87Up8vlSOkPXMu85nhjlrfdfZw3jjcqVc8e4Z6/PeG94YY73vf5bx3rudbPfLHN47vQZzG1hrdSqSQEEAKCC/k11/d9q3s30nJ8kGHoSOyteWSjve//9/dbPXJfNZWZm/8ZZ0BXaA+GpXKaaXX8qtPneiVYbwYT7cOkKFekSKokQj2ye0aPPuMvRemsQ0+f6vQqQ+iOYyMgWH7O2ObZiDEdvJLQd/MH3prWN5tvMWntaFn5mzAreuPT79b+Zmi6zdzixmHESm9UvNm99fGZr2jarq1s6jwt+uK537xN11XGpMv4l86xuntrNv//i0GLDhapj/7//zT/Hxj5/xn0rn/Gt79Y/pvfxuMCAAAAP33HtUZIqQBEBy6a8CSBMQn8NYYcp7FZyHQWIYhFx1QQmGAEYrJxiUPs2nZFbs1MJflRbo4rJ5qTS184rXqDgBRBMYIIMIT+0stxlchhES1EJHVtxqMXuUU7lVzi9apGKWnfh5p/cTncX0lDY3+iD3TEfbpBU9TtZTHUzW24zcxkTxTjr4wxL8cZFfjs1fvc5Wp6KxOY4Va2VPG86l3dNu7ar/Jpqeqcz5X7jdzxnbL0MVt3MIdeCxY5Tdl8xO1rdNvU7a+tWtbwsXZ27VtZVakvs5Zap95bz7TUvKtaxUc+du9/OxYzw7Vy3ja3Uw3v6eVVs5TzLe/5vvf5rOpZz7+H7/Xd65yh5/8wjsRgREIQCCAFG0+oXN46/v52cZHNqrCE019YaaS59y1Y7/Px5Vt8v8sZ4Syf5fdJLgyPlhnYjEDU1Bahu9MyulamxsjwZncfe167Xb7YFMgma9dRleuaqN9MzUa1ZsxDLL4dBabYhu7dvWxX0gQo0SLBpNrNde99febeLP8QcP7QNUhwab1X2ziFvV41HHHqm2uHBpetYcLOs+t4mfn0xm95q0xExr63nNc7pu1r297vK2vi2c6/1rfzrO6293uNRrWqs7W2v8h1ALh3aDc2iokAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACESM0YMaw3Kp60pkHy9uIQIxRIzujcLttulQfT25/es8LpA9rZ1qQmQJVArVCHK1+OsZy3Xo3GUUFcJ1d6gzGjB1mgS2m+l+7SSRmd2elkbl+cAPfF4F1xeRwYRoAMmbxodeYcbkFRWOwVlDPItL5fEZbWo4jOxKOwxHaVYOWxmWvtEZFrTOo3DsKdp6VzuLDShQW+AtDTWcl3mQF0WUsll1PFc+0E1BrX4IdSS1+51KtfdNVqVtVcpVUzzzt1atS/Zu4dzr4dw/G1nvjdIRSWpa6VLrLHHuGdPPfnnzLff/PuOfKfe7WWWt81ny5fy7nc1ztPGIpL1k38sMu/j3LH/z/Heu6s5bx3V1v+ay3yrhW3O3Kelrcy/XMt45d5+X9/lS19IXolgEMAUU1n+oKi/vv/vH/oZaw8EHHLk6dNG6PC33/7++95X7hqvu9TTsEOsDqw4iH56O1Mb28c7deXTFuuIFqZx9UzWYoEtuO2s1fd5aDu7Bh9GTyUdm2o1RBNZXWn3SG89pc+uMf+2qV+M23uusfedSW1bG84/1v4+/dqm3mar69p8apbETDiYq0KihQgYGqgU44AxEXQCzoFjjaF4oM3pvZdfprMi4IF1EAAAAD+/vC2sUWLK3BAkcINcELq/nM/y3VppPDkrfAQhICAT0Vot+sKBSgxURaFYof7nMafyevQNGcatiUwxP11FSUUJJcRBNpuD2YQVI6Qw0BsQRKz5aIsXiIEsVkDQ1J44QIqAY0OOwZ4NlUaJl4nydKBEiLEUMCWI4gZsT4lYX+C3YElogqIEKIlAKCxprdy8TZUQL4gqFoIG9HiFSZUbGLooGjmSLTcmSOBuWgxsiZGNM2dA0SMRc47lsYpOx4V4YLLLhaY1SSTNVosZsigbOki1N1KLxaMD9JR9bvWkyak1IouyRrFyH6LNvrs702ZKgiybnGvatdmMEqLLXZ+1bNqKHCgNMoBBgByhyM/s4sBv/w/6eU5Smum4Fzwb4GgjMncnrv7/ndb+tes1rlbdWVymJaihml6QD2vTNY57t1tVZxwabQ5Vtxzu0ksWuYmTCaa+O9iR2t+/iPYMNVqFtZ2tWnIyvHwjEF7Hp4mb3u2Vi51i2K538+1q4zTFs6zu+q+31TGc1x/uZPOv40JzxiLW2v4Vs61Svzn6tvede31v6xj/Hz7emM6+Yir3qfwp/YOMLU2m+O89r+9mtxy/PyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhzjFCjW9NyznGaNDdNbiEqP0ANbo3C6sYo0K0tukwAAAB2xy7boBwUlcZdYJDg3e6wASLOs9/8cpqUz1O0stSYKHHyJAORWFNHNZFmzxqa/C5LbDcqsN14Cwnn1kUeeZ3FgS0hqwcNE7J7UCTDuQUsAKBEEyWCXbsXJHYjEtfmArE1TVWYDRyH4tEph5YK7UiMbwu0Ecyf6dlElTlIgFRsK4lbYcc9WKQfFrc3S35fnSDpE6oB/8rfL+6mOVPTWOVLVqCm6W+Z3MLFjet95zGULcwzwtVu3lF6v7tQqezr41M8cK1XPPWsssdY5bzq4dv63ex5f7nrncf339/lzKvhAnafe//P+b5lr9cz1vX28v/LPPX61/fw7nrX4c3z//X5Y7u5fn3LOnw7NUSgAAAHrUgn9QD4ZI///nQ9uu5LhkAW3NPJKA6gODZqPG/z9btZ1bEsmeXI5T9sQa40yYeAuiGIlGZU/9LZhdnk0YD6yRWOpuo6kibqPjBEkgEAUzNJMzUaEiOUoGZLmheKYn4XcepdTOBzhDCaBSkMkVj1SPlFpmYFE0TQdBK6FFSlMigQXTTMTc+7PZN6brWnSQRHfY6XSiTkn2NnRdBBazFtI6pO7LRSTUtFSt1KPIpqZGtSi+cUlar0da1Jsp7L6re1HV7u+roN6RyTq/HPVLEB04q0CTwsrBKalMSaJhE/j3v52rdIyR9AuAgU/MPhUCdsQCYRSQLYfX8fefFok7LKabwvxiBoPiEbIBJB8zsYRYdtVVTddjoQY5ZlgPH+XjhGEmaE6VRwImhNFYiBIjGhnRkZkCKJRIiSA/EBHCSI6SfLJEDpERcg+BCobSUhlwtiGLA0wRoHzjjMzhImh8miSIYcCAeBoDAg0e2QNnZE6dLhxFkzw1guMk6jdAzLqCLs7Gg4Bn0kE1Miw0R6QTIaVCSdZ5Fjput1omcxTSfOXSK55J3VopLZaLrqY8ktkzAXObrosyl1uyLJNWqtI6pTK/WhWyS2quq667rdl1IltaD1HjYkgAAAOpFc+nMAHBw7/5+HKeIUcB3jEBDnxEcLbZJmzhf/n6yu3d/nTSyWTl6miz4EIAZTsRgSUUrowineprEh7IGkEPBw2JxnTmHDeCofEEh3GDFFyWbOS0EU5KCWUrSaEkjkMP49BsWMlK1Vls1EIGDtRa37HS7qmMJmzmpc5vHHcc9zplpH9jEmMOPpSJazdc8xe+Zin7trI21H/1L23DbLp75+/+/uHVGyJnn//+J4//////lV+GxoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHtY1Qo1qjduOxigRHb27cLjVDDO6Nw7LGZ4D9vbkgAAAAa137fEqkLDHKAYBD6iloNYs5pse/vDDkGZteXOUKT/mBJMFQ5n3oOa0kpj326sW67FBylj9qZoJfXo6dVdQAyWFLpxpY2jJbMXGAYGftXrzx01NioQUgSiSYolkql5ICQ8iJMiuiPybLhqUJsRRAsEWNyLDpMx0hiAEQEXwyYuEUIACJAyZcHARlibJ1EqlgtlIc4boWKAIYhzBQRXIiiicRKzpmpw0TdxyTdZiy2NmWovJoybEHJImKCnUXh3rWaoF1kjNbNd0aaaaVNlK1myzZtF+joqr2QXl8e10Hf2rbVrUkzNR+vr7/fq3ZTc6fxjxJAAAAASTRUm6CWo6CfHal/f+tEc5mqz1Rws0J6hlQXmv9yr8czzz7OZ15TK4tWqx6NTMxGprMgCjMj4vTSOHEYKhu5iXRmI3usNuZbJ1USY0pE8wUTrLGUJDGdX3y6w5PFSn3dk8cxzHeX9BGoPwBJB5IcCqeMDlqPWabLCkDfhS4vGtXuMbUsl9ZhKmJTGfEn3bHzj+Lr0zbEMokfurnKvbixbQd58Xecvs13A3mN94vbFfndfS+LZxvdtVz9fSEz2/xrX/z75zb3zS9ZKYtfGMf2+vj/6z////9ev38Z03fBsUgAAAAcKXL6ClGRWKhpYXiMpmVGQKTJzuXO67G7NM+rvEIEIh43YwHBIxgZBQ1DchyjPcqraYLDSzGvDkMZQ3FdXYgw1cZhkINBUCzj/TLsz3mBClypKC4ks+XSoRIzOmJkXo6goYkmM6KCPqKhmYj6KZu6RDB7MUiiKQBgsgRBisUwhGgasoJuJ3dS0mUbBdIBkEPRIrNFrqRQe9RooPiPLUjdKkihqJ8XA2pJayiQBlGS3nElIqW7rWg6KBjrQWkmeSnkakLKW636NKvNCJN/b3XdmU1079f31//6S+04rCWqSbpLjPt44Rkr9d73t6HOv61gRAI6BmIsZ8OCyYSA1uMdtztbDPVeihFDNQ5TSvB2HCi76KTJABsoKszDgFiUsiT5OBPOCRFcNPpBOXOjuElyCsG4ykZocNTqtD1ES28eO0Q7QXkRvfqxBE8SiCGCMNKhyi5CSidhTwmSO2ZYGWG8iqc81S8hv41axI0PNZfeE8Mhr1ulocTPfQ60zaPT4x4TC+INvLbIqaUbX99efVI2629s2xmng5rmfO8WpPjXzje6RtZrrWH7lv/43/9Y3rGvre85tWJqvt//n/Pr/j///5z/6b/zHkluRXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAABt1t0aNaw3DOsaoER21uYc27QozrbdNdNueA3j24jAAAAGGfOY1yQO/5hg7PBMO14RImXVct/l/O0OUOvoCiYxPNWwLXRqGfxntdmIrdh2c5rKxqP141LJakokGBVhQYZ3NTkagmVJbgALer1pTKtV7tBlYt1LN+rK2pz2oi3tJVxrVtwNOQHTyGzG4bjcOrDRSWtvFRkY2WgbSvOXqSC5VI6SOKGp/UliXyimx1Zn6k3lLIhLYfuQwg4+VeV1bfPxt4fnvTu532kLokFPzsjsflhnaxz5zCvfr1qaddue53n81r/5z/5z//////////+/nUDX/s//5PQUAAAAGUdpJKXUs4EoUOHdf3uNZ3XkUzMKQjlVJWFfj+vBVtTvMe37VNHbsbrx6q/m4OylLA1/GBQbuJ8RJ36FrV54kJERtSInDArMh4EM3MzUnD8kcKI7DyY/jDHjxuZj+SrEqThlH1IDaZhZCXGY/EUIqB6gkAVhFPDyPmTpMZE8eoAqEqgqySZug7LTTZFxhS+6SCk9jVXRP0KaKDE8ObOkip2WzujsgtbIr2W60WWmiit1LfS6nbSQ6RQ7f/ZXRRZHf//9+j1V9M2fVPCAAAABvDHX+nqwYZqFVzRUpTDSImKex3D8sZ+JPqm4ZIUcx4HllvIwyiQ9kVFUx4ve+9EYlEvl96zB1LDtVizBkPTQmSgxQVo7A9C7wiAmbFMUiWFiVQdlUuGAgj2XofljK5dAhbxm78SOKOGvBorDlEVWFs07FMV/F+15wKw+BoEQxabx5H/EAKHHbECqA3Yo6bVGcusgTMMAjBx0wB6PYlDQAsSRzDARRdlLCmmt82jX2QN1ZU20UZesQkDxaKfd/pDLIblEzLquX6wkrpRNniVgFDVLntg6H7rvxCOx6M25fSS/ONt+6s/hZgdam9Y95vn2M60Yw7lvD8P////1///8/GAr3r5T93/+2sqzn1qUz1ueB/BqP8z1Y5nAsaZUoOFwYCCgdgBgCBrB2lwVFIZlv1rlSq9M9A85x/ettLX2p4tAavDIBGDDuCgTTrogl24CpSAC++M6q1LHVyFxTQbI+lI7W1wXtYhxbnJO7mbdG+5RyYn9MwLxoH+dg9SsHwqTaI2XhWNtmu8SE6ZD9EzEQBiLtzeO6XrpzjvMwdPY6YMTdc0x6eTO/4Or4mTmvtWxKRHz+0KBvVa5gfWpt7z/7w7+uc1l+L6/3/vGfu2MY+LvQVTNXUXi4iV+KU6bwMtJMkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACPKMT4Nbq3C5i4oER09uILW5Po1vbdMGLifQ/WG43+/s3BQYkGBX5d0J0KWmBgiSGHp2t3C5SRluANETERs5d7NqTVBkE7nwPH6kPSO5Zg1X1WLN5W3HrLtxyktO6NDDAQwLNQMVysujcrgB94Ib4DVsIdeBCYKY0CLCtwTAIGAySAcDxYhkSIDvIaUxByjUn1ENEPEoFkvDKDkGgZcGIH5B+oEAKFyhkxlgJAdRVImIOBoBAMCBgO+GWiLGQ4xkBzhaRcoIQEBIJgYAUgHrFGBhAEA3VEGiTGY/GZTIYsjysREig7A/cOiBsSBlwjAoARZZkXkDB3UiylEyKITpXANGgMKJFC0XBayyCQDFml40MmN1HSWEbB/TAk5FBJhC6S1b6nLwrek9/9t9+fbb+cU/V6/////1fM3CetAgAAAI1Uk+udCXLr//dZR2FRqPJ6iM0ZESZ+WBgTZlkX+Sn//Cx9B2ZsU+UxT1aCH6NnjIzfqmLU9LPwBa6zkFBsZdPRVA5qxkfDiWbYhR9qxG3Y7p9dZXdGTS4XRlp+I5MjgzHk1Hu2pY4BaCHJVjYbOEBqYm1bOEfIashM8N1iNG3Dj69s6mhqE54tbfFdVrvOsVi+RPDarTa7iwsxMe1vLfdszfdZOeG1FaiXboUo9f1+h///w9rJAAAAGVze85gqmHeMoUERYzh2lEFESFxy3rtSklU+CSU2fJOJojSRowYPN5CEfNT8udCVvxJKR9VeWZA9j808PS3F+21kTzlmxgEIQM1EcAQQoHOVHEmX8QRmdhrbYT8sn6BeOEjMyWELpbVl0ryoljwLbbvPSALAMUrdpFgcKduRbtwRwOpbrjCQBKnteJ6hkCFm1N1EblBnZtUNZdQ4HmM5R3K+DQBHmBsrUtyu4zGpzKpTYMhIRYxpNZxI5Nb3YtfTyuN3GHwNBNPVHBIWbpnPDUFvApdN5c1nhUclkkYmp/rYGrs83rn9//1u47Hf/n/v//97/nP///7lv/kNFlX/u34qCAACANVpenvX/3IKV9e5a5lVlshUSMIFBBUHDDnsC+cSfmKWZjPmfx/WcWppBYoNzr/RX+tfbIY62Z8Cs5rUviLvSxRUaQxyMwiRxCZpM4+Szd/D7V65Vh6mjVexSx6xfmbcJqY0tqk1nBEhibdatqGXKSAaxVwxleMxqD51u4BeC7wVYlW95XtY2t7pa+sb8OQ7rXOZ4c/Wt/+qn9fyGcs+0HZvDOvc+tvv3NZ/rX2f2OhtZ48qlJY3Sef/1f//gsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjtbk6jfONwrC3KFDdTbiSJtzyNc23CmynoEC1leCAAAABf5luNzBe4WEDOQww0QAYulkYISiUfFJHhd+YTAMAkk1vRTAQ6GAKGBEwAFDFYBRmQBpntYj8gf+CqWIIkyxsT2zkMPg/S6XtqRVeYVBiAZj5j4CkxlQktDm3Cgt4wsADAIodN24JqPG7CyoNnzKIFFgBKo8/8pmaAHBCB6OAX/hCC09LMZ5eUMV5AYLBCqJgkMpQR8kAQWArYs5lHBZ5f9DiLADKtKpLcjsyoOiwYVAR78ICQvHgAmc/1ybqWLN3dTLtJbhxbxskIDwDhEvr0uOH384y/LRwwjKStYCEJDRu3frUeAyCn1v4Y2dYzUKUjPPVP21HmTK23t7x5vvf/CG9a7zevy1r+7///v//9ztP9Gzf+v3/cnGMoAAgBFI1Z10+oMAtvO/9WvfZQmK8rfl5iMiRGVMH9eektYatdy7jlZocbuEW3P4yZfKqZkFAOFSJ38KGNZNHCDdqzgYmhjSKoBjC2dROJpIjLnCwUkTMdKimTbEHMTMpksWiGk8bJEEHwbksNIeh1llkTyKzqJiQ4jgFhgLwSJtzZc2TO1vM1LTJkrl9BVS/6T1DPEI71OimtFLex5SOjf/////0TFnf///+ogAAAAY71XuTYhFiQUzDMLITTnnfCg4nHwxU58uaiAROZnlJk0WF7UOLBSgPg52EwBXY1x4X1+SQFVbI++o3AjoLsYlDsBy9hkBSwwkBUjSqBA5BkwoUyVrlDXOKADACMKCFIeFsAdF812MpcdVMyAndNrcENAfuSKopLJAMPgJ6o0vSG68GPwzGXyFuReF8DJCZ44CiAknyKPydusSEh6NmYBCQJaNNxLhfbYk9jDA4w4mMaRTFawywCMGDDAgRSxrkw4Eml9BJX/qZOw6bvFUTNAMHBmrF/DOpelbcHVd9HcwYKMaGAUONhQnCxk7cukcof1KtfEUu4VaSpMqxOvBLL2byhhUuWtlYz1hn/4a67mv////////////5+7zfu6v//6YSAAAALJOq37Oll3/5+EpfpXLJZGw0KiRMmm2tOCsIX/8v3aP49f+X1pux3cM3IQp0qiDWREyyF2X7lspnZCKBczxwneRp3cEI3ytY01upizjdLJJTT02U1JexnOK1bdPFJXBFiq/8arxp+EcnNiNfHOp2th2B34BbKUMij2dfX2K+H9uXe7vyFklrv/zuv/uGuZ2+9jkCWP/DOSeoEklhZyyn9f/WgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI52JOg1zjcLrLeeQPWG4kCdM4DXNtwuitJ5CN5br8flMonSQ7GhBGEQ8+wJboijEaeyziMyJkQiCJmmGmc0cAheJAXAuUATmZNO5axpaKMSYJOR1sEurIE9vS5qun4n3CQSBgAWpFYfBRKKoKYYZML4kC5Ez+ZcZlkGBUEGDxcX6YK/Ey+NtmDKH2LA0EgW67yNcnZesMDjOt1pT6O+/ZdZdkOUcSZc77qPoTCOCjGYDLjcTfEACZuspHyE0BgQEJHGWS0TAyNpYU7Q26NlaQCREYXPxxpJmKAmWfMCgcWB6grjvy8FJRzzuQmCnQqNbIAQZKFa9HTp5mX1IxyX22+hmgMNBA1QK0WYtCyglT922nrAryMJrTUxanMo+1xcWRABW/wZ9XajZ7lr/w7/aZp+Kvo3L5zR///9SJAAAAMgbg3eXyDi5//qgboBisWvUKigEPGtYA4+5Fm12Rb+mu0mOWU491qnpJdSSzaObMiUMFIIOQpCKkfacaG+DkmGB16aV0kspMqeVhYczZ+VS+ilLP5fJo5lhM6l92vEr0udmAI+z+hylzOqesxeSzivIdWJGuU+PK8BsLUeFCHWa9YGi9S/j+872eFelyv338cmLfhl3+///vrcXKpfXw2vN/MX5XnX5jr+fataqd3vV3H85V/sAv48p8Lpf0WPmjdlRgchSygU7DYKnTRVPImTGDDMD26YRCaFBEGnNSHAwNOTqgmJy5n5daXww+zMoGbumtlPxWkpYMjgNAg8GWUvtDoYZBAGBoYmLGowB1kVIdeyJwIpcBka5sBPBYarAbiQ0naYGksBirAX2hUEuWaMUr/iquG2e4kAXNd6miyabgxKRhwgp2ZgphA7xkpMwKYPcxaNIcRkJEAEbpKoDUljFRVbrInydhOJcZLDGQDbXRw7C42NGUF7ls1NY2Xdj2NhyqgyGBoOl1LaXGrLcqarTL25Dhi50bmfobQ6nqUN/bPrQp55fFJllvLOUJExrrSVOcmiRCH+c///98x04n//7/////////+6/8f/9/b///e73////UQAAAAB6j4ltP8QwjfPvLtoQhrmX3iUzQ+XGHlKBrb9k099Pnb+Dr8QyvxiXwM+8YlsB06fjdwsAGDJaZyKrZ5FYqwpqqd0/SzONJSUtLACi0/E6uFbHjvWpNm/FM2DC7U26kUlszDdyKt5TP65ENTkHNwkr9vAXClFy5czpaeKpcAkkbqRygRmE7ldv6x7lnZx3X7VHhp/me9/r/1nr3rGhKLBn2POXd8pd58x/HLH9arXvE57uv/9QVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACN1hzaN823CyS4n0LzlupDmHNA3vbcKnrOfQ3GG4IAAAAFmty7jFgoKEQ8ZcGEIocWJprDE8HI0ZFQAxJZIECBhipGcgqCgcvZoiHqY5YJhsoAmCACh8tVcyU8NwK2JzmYiQEnFH39gqUyGDnhEgbAzqtaMShsMBwKIhkcCgY8z6z5gRgNf7WSQMmLQXG26yJnNS2yGjjwCeR4zcWffaNUifplqI4T8qrNncrK1ORmbRAl0AukAgeABHIBgPB5AFGLgsuxykLxmRgSAI4t8Jgp2DMmhGhutJPQuIGBvxhAUgWQI5kYcRHUFrTpb9+ZlXKtS9fgoLipi5U8cou65b5lXijqY0oCFzqTRGuBHLJoKmwkqv4zE1g99ytZfHldrcuQwuLrCocdCz+///3++OOuyy7VLMWO1OX0EAAAABeXuzlu/eRQ67HPLN3BYZy6tIn5SDOZtpqpPo1+N8z1jfqS+/allWvQTMBx61flSvXUgwqwCRa1561cbtDzxqA2Kev2b3K7cjTlo+WMbWppvKXT1wjCL3qffYXha20LNr3x+mlsYnZbajr7S1DvQyp4JBG+ZwVARJCd5DdZqXWdfvLDHHH928bTSUBkgxx/+f/97jQvEobeqwFIcsOZ/MZb539/9m9uvz99s///8nU3uw+sGCpYgAMxLDCSk3EqZuVcAiIuqGBA+PCZgEAYH9mfAiD0XGhceAgYKGUpJlpCZKDlnVMW/dx+17u+/zwCQDONlj8fg5xIYAIqGBHVZiEDGSYdRzLgEwxbEgRDdKuTJ2NxYgglMJHoZZxBrXdP+3Z+msGSvSXzjwiNMRjSixjp6vWBiAAZ3HB0FXUv96UAgWFRYDT4FQFHJ9TOXMtNIV7mRgSxZMoHB0WByAKgJmjHBqixq4EPMDbXI3ACxyq3AAjYwPDhrqwzKGGly/Ok5QQ1Xys0MuRNHtFQijpN8y/+w601+oaMWLzkDJEWAgYAC0FDNl6y/tOyBYTOxj+OUfWGVC2OAmPdbEzh0f53//HW9Yu4a6vVFzCh+xyv///LQkAgAA3RWylX6y4GdeeGDxlxovhYcuCQakGXLAGWxZ+putJN3e5yfuql+5T3nZi9NE40oy7QYgWyi08DmxKdq5aSujVP9Sgj0rnZ5WSNVstX/xebfHBpbtFZxr017G3Ug6y1XKcjkXuV6lyRyDowKmrs7ls39LceARbF8KwQ9SVKTD8//9W/z5t2GUznP5rn63vXLrsKutWatvf/j9Pj3+6//7zczub//+kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAj+YcyDfNtwuKt51DcZbqR90TIN723C2a3nUQzluMe2rsvmQKHCRqZA5mHGpyxQnyM7gcdvs9aKJg0AmPpEbzIgkG0ATzS4OBgOD4oNDPJYJiNJEUo2jI4zdHbhC8BYBxZpcvm1H9OuYADql9At5GYx8JQuKzHgFMGqxcgcClNpQXlZq7pIATHAZQotRt55ufhrB/Bh/VhkUdhjO7MGzDyB0Vk+ESCwo71G2Zi5l5MoG/zJSsqd814LAR7YEASLHkxSNMYCIQkGA6lphLY5T0gqJIliRSl/GjoKgkmDPICgBjlgaeiBCozB9Y/3HVr9YYzE2QERjpjAFLf/n294Rdv5qHiQiOIQ1YIGICgWQqTKuIAauoGu/Grf5nqCVSPuuRozQs3wdQaAreu//7/Hen7vWm7qVOqN95Z3u//8WBACAACkUEVpsmqzgaAReV2wQjitLGqBkrN2cmFozFYVwXIswqU3JnV2MXpbGIjSSympGtXrzslyIOhJapJEuLAMBvHavRZJmUR6hkV+MUFh6QqItynv4WpTlSzMklludffkdt4pxZT87A8cciN0+E1IY3F4Fl8JppbIZWREy7C1Vjy4obB8qvGeKJu/Xrd/K3huz9fuFhl1Xn//P/fMOyhhqef8p5zf/zc7W/+fhv7X4Y9/XbH1f/K5X9zcogsQjJEGGANAiHDiiFOAK5ARRtKg1micxzu8KhS86JmaPjTjCAYqOxtT8LBQUDkArrNza0ylsLyueLBUfJAVx5a2684WFgBC9rz9M6NLByqshBaFVsvAhAg1RjINBTWSEHDktWpsjT4bgKZhl3kljHiZLKGXbpJHHlUzVyBCB/2ZsTchk8CZw4/piwzFVyzhk4ClIZLACQ3PEIUAAWTw5HHjFAcaIkZQCwvHOGhlYcY3ZfNMWZmYyPlIMgOMJvjDAsSYWxMomp+pWwi1itZt2C05tIk0Okr52N44Y0z/P6sCYeYHGiKeTyCEcGg78sXCbMvxtL/Kv9+YasuNkyWjzdeqBESO9///+f/wx/8///////////X////6/n///qjkgQAgAA1jIxQQe6LhGDTn/uK/ZFSXHfSLaSp2ZEJ+0o5LDrOicfuzOt6eyt29bhEQlTCJRdgiGmWwpBMF+W40bqQU/81VsRubm5NKaGrVpXhCkbt28q1/LJiFFacqilcOWeXbKvJdIpXDlxl8uydiIyaP2XFgBb3Y/OzYCCbyVXqGCYeIAnhoZQogv+vlrPWPcrmOe/d2M3d5f/73+G8oKdkMUs7gG939Z6yu5/l//+GetX/1239YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIsXTMg3vTcMRLebRLWm4kEc8wDm9twvquJtEd4bitUysSWnHDNdZoJSYOeG3lLHgbOHSgrtP6o4HCZ7DGUGL3ORD8XYaFyYwUEMslRIHh1KBS9crvuVMNo9L8YuY77cpVAb3g0CbhF3oEAaYoJBZbKoWYMngkGVKj+qxHd3smUhBgp28UglbqUD7QCrYZtwLDGbSV8ZqRpkGOksBl7eNXf1MCK4Qt2gqSa3SJvkI56zP9UJzTUqw6Xhfm5eoImAVAR3FyFTczTbVD612GlpPyZCeah4GCTMpjtYUFZesiY3c+znnb5bqDBs3QZ/a3545by3OPJjGQsbO+gbewmkjFPa4krIVMnnzx7+tyRl7fL5Sehy3HHAUHtf/P///9Rn/5//////////+v/////W///+5f9ZAAAAANWZFBOq1AIYCnKzpaVJqHvhlmiljlS4kUGG1EQZkbvxB0rkDano9L7UE4vVasxJJZtG1dmaDCSmbsGesAJElbRQVOw5DzxIkPzH4BkT00sEvswIxBpRml1k88prDwepaicZuO9eoXjstOiUpeFnsy9mVePSp2rcro30Dint+/PDAAW9lmVE3B0CqNPKGkEWQSMWp+5WNWOZ41r9rsMPJ/d713v/bt6jylQCMyzKUPlj/1c91Mc///5jf3n363bn1U9f7UcjYICo8HzJgRCgnNSiBY5gEsDYPUlHWWAmDMtBUKoumHAjEoDIA0EgB3aEZCVCwQ9LNV4T7OXYdWujS9pc9508Xyv0qU69Y4/4WADRiccYyJnNHegMko/yjgVBI5DA6Hla888Xd63Ar7soaCgWZXVo15xeL0jisLMyJh4OnF9S6OFl+vTQwUYgS2X/jplQWvM1ILAyCtJAKYABQ7XaNBDSgUQpUHFgiMK/wcDjy3AmcPs4dtUpvxi4xhK6bUziSGsG3SWYzXMYcz5LLFsLARnwS7lq9r95fcpX5h5eRhBWbgHLdkYWBCgar6wbi66Tq3L/O75yu584vBnS4L8FQIoln/9////zX9n//rv/+v/////9f//3/19////uPQQAAAAD1SK0FMtnYMeCuS5m8EWp5is4zTnfGAgLBhqQimooOyJr0Uf55Po82bU0epX6bE9GLhtQ04TPy8DGS8Rh8ATFk62GMz0611ogGD38p78qrS6gmLB9cvyjkNi3fpESamNDq3Gbl+7TSG7NQbKIIUSlOFl76CjfedgNnq5gEWjhBEqKWLlSBpwEhSKkngRlJl2/z8+1afDtNjgxvLDWO+f/52rMpEIBM+W3Ss4fqg+UU+v///VfCrvv5as8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACPF0TAOb23Cui3nUNxhuJXXTLg3vbcKFLOeQvMm7xqWvlNAIgoEAIwqVBUbmYhYjSYNEJGF1CoFTTMRtzLxBpsWWMzMstAw6KgoKNFSDCREwMEDAt/oaVVbdWaXxyh9FhoTrvY98USQWlRs+ViNxDzADMDPQMyQcYOuOAEGFwWxRYYCzcR1rUjlVh/2uocWTJVG7NwYJRWLw7SR6TGhoRWCQ1GnWkSrYPex9FgzQRxpUKYyNT6qhjc8NHbX1dAY5hu/Pwy4KZ6tptCqqOwBjUeUqWnfiOOSjeGQKGo4+mZAZM/r7ryyU2uX6HC1SUFCFQox0HkU73+633Cfi+pIFwo0wbhjAhAisLw+aTke5lC/sNbx72Zas+UDKPub+nEUF//1////1Qjnf7//////////r//////D///uYSNIAAAANDFSa0LtqLwDCbc02DtrCnf1pUuZ0FqnqYcRpzUopM2p+hl0zU03f72UszaKx2SRWwwljb3h7g0r2RnUhh6zASyJFuzT2Le6J0QB2G71a1u5K3uqUsp1ndsYdlao7dLEW8lDt37NHEvtRmp6tVc3kkFKKHh+Yym5XBqwKJawqirPmoUmWf4fzKxrfflMqwx////3rDe4BJxUdiZsf/9wt2P////7e1c1+vv1rE5PwI/hVQFLwC8mBEB2hGWYMFtTwzIHAbTEbzJLsMZYoyxQlTAFGAUCDDQ8LwRni2IAMwkTGh+GFDX+eAqAEDxB73aAQW0NoEYd+DBCHK5UpyBgSagiFQDNbFTSjABACQMbQGgYSjSI5ghcQMDcXlhm64LsCoNClcnZghQQu/AszFYHGQIxBrYjLoLf6GkronBEw1UIqZBDAwGmVCSepptuVAxgq4Bojd6cTuaEmQDgpe5r8RAjVDDXYSJoJlbhNnf4QFgcrLGMAaRVCFmJnsBxmzhTTFje7kxwVBzORKL4b/mdnuNHD0taKYSQAqjZNEWJERPnYjwjCnkb5gtvL/7u5IXNYSVAeB+bhCsVv/y3/8/8UL+8/////v/////+u/////rHn//6veokAAAAW952WdV7AXBGnvZVKsbtzKA2QstC2JosNXcCWxmW4Riraxsdhi5L8bktmJ2GIYm0rraGQ0bN1mlRufxltlyeWqZKTJROEOAhww0U3SUaCnm5sXUUyKpLrDfEll8ppD+VETIqok8TJwfAkhFQAHNEh2CZmDnS6ZjOgFASAkJBxgFynd90FOowLpr/sikcD/ha4XUkk2zropv+g1I9zAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAj4dMuDe9twqEs51Dc0bmIJiS4Ob23DKK3mUT3luK93KVQG/AJFBIIMgUhCaGvm4NADBrc6xSQVbZwDGsxiL4v47YqBLrSKMRETFlAxIeElhdAUCHbaVFcECD3WJY/I0IqTaK8TzVl4K011hwsEGZKJgBARW5RFTLtBcHThAxSpusgAiBzBulZAa05iCJGVQGWsxOSbUo5qdicegNYEDKAcNYts77bpwVqRwUqgcnw9LHeMXJVJG/BRjgWzpCoDBz3xQvVOIyCxAIwEyaLbrTI0OJHbVVUSRgGBA7ER5AhiZOsKrSxy9Vs7HK/9rWY85IOfHlv1tfh+s6SKUrcSALNbAG3lhKAixVTWJkAiLivqubDuW/+s61PKFFUo8Lr8rg73+//8/+Jcfz///////////33//v/+u///+73qRAAAADorWpN+tQNIIw/8eG5yalbx13SBgBVhRNJknUsw9Dkvhubyypa79zD6SqpZn6ezVvokpHsWkFG4zoxPUU29Sg0RqUhMrWUkCLgBFyJpso2ZMLhGY6aIDlFshqZBBPcyIqQBAYwmS6YGZQNSqal4V8uhY0XiwEQg7kFIDcHSISA6aHulQLPjtQRtWu5xSSZ41/6a1GY+gLHSo5mXOYJKNGb95m3M8d1bGfAaFysLFCHMHgM1CGB4Fg4cDbkFhIrGFgQEyLL2FNyU+tGiDgFAEKphmIyYsDg4SbVkigzrPAvpfzkSFugYFP2wtpL/yR2E1YHbeBzgzIAmhqokahhqqBwPJXSFg5pTfMSDxtWtir3wJMtmKgAypnxs8Y9DWYlQ8cpupl6MgMmI2/d4EhTQZC8SOoEBm4w0m2ZGRDAEavWBylXBgKHAmLMHeiDYUJL8GEOCF0ODq8JCk3Dkrawg4CTAdGVa1WGamg8OPg7+eFT8K2s6uHR0CJBGa7z8v1vs7FZc+wAHzRhxksqJAEiF5vkrAgKrXKFo4c/e8rsPNnf5EBFqxH5M49rv////NaUnzf6LfdkiAAAAA6NNNt0lpBjoV6XfzZlMV4clcmlihZIFGJgYv3hgsyVaj0zEpbs9NatjDLmyqMSKWyCw4rNHGfUGgKQocTCw2JALoOo48icpjEqDjlxYGfaRRB92Qw/DISg16cuXOwxGQ5t7bzPXdss4lketwwptM0ENp83WbSOamGryilry+GBKKXhCsgedwm8i9eWtfS9C9AWLh1rAyO7df+ZY6uZ1MMq2NExeRcz1jr/5lasykYCBRcepWxxWp3ke+1fz/+///fwevP/+4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI7nPLg3vbcK6LOcQ3OG6lVc8qDm9twr4s5tBs4bjHn44QGQGKlJniGYYemlGgWAyWcMuh1FnZAI2cekJMt5H1LFLAqEmCBIiIDL0A7qwJAsvmmc9DD4q470r/kjQ5WYIBreiMjaG1hOwmFHpWkXdOEEAolGghppz1DLCB0QgseGLzTgoNG0GS7W/pbLwy1dbZWimdMKrZHLJTXsNyBiawWRPPLW8HRN3ZduAgcCsQa+ykxwPKoCAeEBADJUtiIVktGqZlLPUomfGHnaZkZMTISY1o5yVzKzQ4uM/E0jioLGPgREYM8h+7rvcsft3MqR9wcfQvDPX5f+FuX/aIAI04fa5bHQsmG9U2RAPQ9mtr//X/uK1psqB0PcksViF/9a/D//81ud/+f//+f//////8/9f//////911v/+hAAAAAGyVBXXrWBimnakC1KSanotKG6EhIIYM6pfTN10O86teGZmcyv1n6whqX8ic+wOTOjAajzcFRAqxUrc2NRB4ZHJWwpJzVLT8qX5qWygDGhFWmt27c0hNi/ZTOZw1OXb+p+vRU791mY4Tt2mz3A1RsDqUCz5bTkhm0yu45y8gAD1QxGobbPXx73n3f1r+4zL7Z8/9f//rXbkFjXqPmOPP5X5jj////++5TN+AZTK6TbM5eAAyJDYwWgBwHGxA6TBgxGIA/PERTL+A19OcIFFBoBbIkSl8CAFQQaAQA6nAf5hgssCgJUuaSzdrC+1Xuix5yTBQxlzWmcsvgRAEAh1ujPRCEGoqoVgDOxU3kODkdC5F1eosTypnoVBQDAq/aY0dwnvU5SsgRCSaqkJdOHDcM3o6jKZENEQPRahikLMSN4upvAYXcObWBJn5Oo4y+MQE2dJUIG0z6txb1Du40BGEBjJ6MDFIsGz8VdaA3kMgKzcyRGUcJgUbkx63SS1aWis0uOMzjQQU3hjQFy/z9/rPcqh6MxURiQGx1/WBkhIjKJYwyJBaMN1RfeWevx1Dr2SwVDk4NvXFH1v/+//Dn7yVdz/x///////9///z+//f/+f//93/R9bAAAAA0y8nMf/yUEP8kn8L1nCCdN2S4LvGlyrBCVoQXKqKLXd9pL7syuKU8tvsLfa5DUcRNR0RWNIYsgoMy92ItGpY7iF0PyOVah6dziMrC26e9XrT2OKAiRZzE7i0exVrRJplbT4tYqMKnrl5+JDK5dKo9X0grP8L7q05cp6KwuoOvEY/Emp3eZc1nq5//vGMp8Y8/////G92swkIBVy+B9fqhv6rf////vn8vwF9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACOVhyoN823Cuizm0FzlupE2HKA3zbcKzLObRHUW4wo90MBSoCDgsbmXtYNVDSUcGggIZTiOgFBsDhc5mpAKgKU1rMTp3HBIFHBKZkFJ8MBgQKiwIFgcnQIQAwdyUOsueN3FMUPVvtUlbV21MAj0eCqRL6DATMYlwKoAgEhjYlgpPLQLUqrKqK+oQIEjLZoUKhqH42y2cR/sR82ZhS65KYAgWGGkmZhi1akrb11S27KmsvMucwcChDwJvmFBSIh04QZGFPIIwZmcJj0/TNhQ1XgCgJ/HTMPKYdkUYhciVuMHKxIBEgwdMAaGkQ69U7F/7lMZ1K9PlHmlEoPQY91+GGHZycnoIIQ8yEWeelGBsaFrtWPgwfktIuTLmH6/KNS2CHeKATsG0k9r9Z81r/3mrkLHjkpP0Kt16//9BQAAAAQxDipvqEg42UckWqSpDUriSdw6IBnj/mJo2hrAwE8c48v54bvtwpqszBsjeFWN3puXsSGQC85AiUwSNfLpsch2XtgHgLb+0VLnNz0Ysl9m2s5Yz+NpAdewnc6eCbd+b60+W5w65PF9zF2tIK8vpcrUQvlxr+1UaLedWk9/x+OgiiwUDYd5vWHe95h9WWMr1+9////c9fJBJWxuPufz9VL/1f/////n1O0fL5z3Liy3YHUZhBqh4MjZ7IsDgswAwPq/QUGGAQGYBc5k4CpstYWTBa7VrhAUMMCgVMBxI/GBwuFA6YBAbHYmvuJIuu7ByMMjFQkkEwxkrvO6QGkWA8caWmgaGEoEUhgQGmgiQJJrAVAE2imtARgAwWCgVkVaWnOVKIzLWYRBbBpecPDDbwLAMpbRlxkRnAzwM3cihAwYsZp8jSdGjmYiN4Ciqh5v1mHFLyuWLGy/nUel40bhoLWSDR2ZiZjhGRD8YlkBrDL+DhkBTCjwhVDCh8mGZE9letjXt2a9NT16B3TFQ6X1d7/9f9WU1pcnqDqxzZcKAJEJvzWlQEAlOZtidLc/LLv1nvjaHdKHUG2J2i1r8v7rn4KBEb3QD1dZbXW5Hd9amgAAAApN0kGWvx1gXaWEEX+UtSNTVMu5TYYBHmFIWMOfCFwJfgfU9jR417Lp0lLbWAURux6C3YSWTBAwsWGtvLJpZ8ZpFg0U7P1jpmx0vkWBsQLIQM0j5scDAKCaBbQHCS5gakNIEW1kDE7GQXQKJfIYQ9FjYuDpKbhcKdMBCEk1pqIaOwCDAPyh8CWGTJ72ZBkE0CHhfZGr9J2REuDfzJZ4VLURzKOP/XLGn5QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACIBhyoOb23DG6zmER1luI82JJg53jcL3rOYBLWm4pZd2klMOGAQoHDgx2CAuPTFQ6YKJAY56RhYfCgGYNmmagqT7IVuMjlZgQKXfMSLjRTc2K5NXGgw5YAiraf1qsBt7QOzLIk88SgZhUPmFAZEhQtdaRxrYWYKeESAa2EJnJNKCK5Zwp9kZKNmjlbWliQxLIGaWx94V9mCaKY7DpdOO3DqtpgJsx59VVsoIAIM8j7yF3lxwEsVfZhIQhOMPoHHdZW0tg791pNCmsuiGTDhh/YkFxgrCZTOylYVmgiIgsDrhEJkZIHtBkbsU1atVw7S932YgISJcK3Na1+ed+j+6SgBUE5RmrOkFSdoBGCTmD2d/n5fq7D0pJAGBcJLYq3t///+9dzZD/uVbo1v/s+sgAAAAIVoGTLqdag3IBGHLzeqkuw519GHxpugoHMY1O/ZHhgYCZdDN2YZpi903Bl9/a0lfycZgSimbwhrsVYiQEgUcN4SYM04vtUUAh1p0RMqIduXPTLIrEG4UzxgcdkudLbmpdG0dqCKTc55CBuEwfGVeTOpS0GYGh5dEZ57YEnXYuNHZtDIFGvaYOx/563abYqSmcMj604UCe21bv4Yby7bw1vjokTE73/////1rCnGlp/Cbb7HHF07Nab/////7+5q8sZ8vEHHqRNmLOQaHwMLTHB5Gh4AuqkwQBU7YUmgrvMSgeBydgkFXhh5R+AEF2smAgAmAw2nI4NmOIAEwataS5LoF5kODSG+i6Qc+WAAZewAeAtkTIDAITAEGxKALXgqCZgwJwBCgxqBQwPCQBA6UAqspLlC9wH3LsmGYgN7Vd52HhkamrHioDDNkEX08NR9IPZA2BVdEmD/iTByAAosv1C5Qs2IOw3EiHLJTE5zVM1xwAgutq+8EreWenO7hh0SunBAEDykt1Kdnr+LCobU5Zcx8H2c5somr+dzd21O4S+YehA+LU+t/3+5TFyreZOEJJ151qqouZ8Qnr9jTvayy7r8pl1MiwB4H+DZ25Z1z/3rDX5MKyIINrvXeQ/k/6/3b+pqkJijayy6BwpSm6eQ0M2+kanIPiwYTBCEzEgyJNNoWAp1OO7Kx5LPdhzsPQw7+obzWGfOkkULFgSgA8FBWMWWrnQ/Y6pu/sqsk1B0bUlfeW2HphinNYXY9OVu0FS8hHFX6lOcUizqX4vBVNM8rr2joIBvlfhx943Lpnj0tpShQTIqVWlcVnLs6uYuqL9BYAsOsAuCgrdud/HDHeHMnwXnh/////8s5Vm7rQx1Mvfn+4Zt3aTP/////3XvLG/UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAj4YcmDnNtwwes5dE9abqOVhyYOc23DFqzl0Y1puLTtZylJFxxES1XAFIGASkYFI7VEqTqZ/WisMYYkRjkFJiq3uusCtAChkGhYwKDzBakMEzQx2AQ4PoBC6TOoQgNIQArtsakoPL+L+j7Rk7X8MEiotk6jklQAGWBWmGZgAwOABjgBIBwuAV3FsGutaLjGLAS0B+GqsRYjAANAmiqeOlmRJJTGhM2/FK18wQrRycdejTsUh4/IHXmEUGAPIyYFHbDzNgIFDN8hBAElr+a29klVvVmmTJgpOKWgE0Sxl0MSxgC5kBxsYqhqFU0zBBZPYciWbxu450uWVeO0zJO/nf1nz/sXqaVDgeYoFUvYiLBe8KqHsblL61t9s91c09uaSqtfIJpaKzvm/3+v7x4zAhaKTVFSejXv6OzIFNPoIAAAAC0UE3QWgnaL8D6ArXGNzsfpNNecchBOCiCIV5tYZgDSe8scGV5vhBNyURWdncYedy5DiOkssNYYYRQBQciQFbYGBl3mmxlUjlRoqgzalX6jruxKmwhyelpnZTJN7m6mOQCM3bEDzlM0WUXnbnmqyuJS1SEMDpKN3JXEqeTc5FYNthclLJcj02fHdeGJ8UNG0JqwPiypPCkrc3z9fWz1hhNLS5rX//9/e/3MCymWZyWVc/2iZcl/P///+8+DeS17KdfQqgDMACEOFZjcvmBwQNadGJO86oIB4TigGMRu4zcECoAh4BN8hoDgGOhUFAAwQKjGpGPAJMyWLjAYVREDABH00RIDNgTPlZMBI6YDBC1aJu0WmAKJYElCc1CCm0IBaZYG5jQtAYWsqHAY/qMTDV+LXGAO1OCGxsLgdnZUBWZN+cgOgoHa7H7EO0jeGFlSuoYZQ6DfBQHWvKWpxACA8oeBopCHVzIQikl46CmMhi37jqMXWBjDYDHQaGKi0hociT1WWhM5C6yZAaFnRAthRDJg6G4xlUy5UkFbly1MbEg+T8193//7tPyu2IHNLiZ8IhKrbyaw98ofbvccc/+XU9uIps3qGU1u6/X97vetSwLIGuu4xyKOv+V9HpIAAAAGWWrdTWt/vlxTs+Ti9h6ZPBsByh92j3myAwOAsB93QcdLSJRq2tOmm6x35VA8efmfsw1O1C96kGnO7Dxmx6LRWYMFBEhbqoebQFw3ATXCFFT41IlKpBI51rJipL2y+k1Sxx8S70WjsKitCnu/VLncfafryhgMAA0S8ViKwzLLMNyFuUUkQUK4ytpG6e9QSmXDB4IdzKyWXp4yjeNzu9d7jzWoDYjj+//+/+WWNVbQQDl3ILlv/yRzmWH///+/5yDeyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIf2HJg5vTcMsLeWRrWm4j0YkkDm9NwxQs5YFNZbiVX5yeQBy0CBgmDwOXBgQqmESAoeFAUcfUhiQCItkloTuIFCCIOe+YGAMWBRkJAw+aSNnRwoKRwuAMDokMXHDhFDoUAzRB4JqJmMloXfeZCkwIbBwkut02MmkFSmJnwWaGNGhDapXGnQUCUygJQAhi21NwIzPSmjTslSqR4e0apaOZkMDKHCwMrCRCo/sSJQztw7I3mGnTlxtdhiBdIYILOwB49Irw7Xh5fJEQnzCBY7SqPjQ2RzU23rcTBFT1ByZQYZeY9aLL33cmTa/Kft3OVO32wgQFZuZ1sM8sdVp6zERkIZUDB/W7kQP+3FUsJVH8t/rPl2mfPTCFCuXaW93+/n+X73hGiFVibNytP/6PHkAAAADLDva1Hla/fK7IBBEY5g+LH3pgSIWm4Icmfl6DFNDEckoS+bBnDaxKlhnhkMyx6+sbj1R+C2ulQK67GL8pMAiayHAWTlINai429EQChkSKYITskvTVzPF+ZpogApSOTRqJT966xvkZwqXWaMfnL9yenoxmvCaDAjBco24U3JX9zmYRAAqQp4y2WBq2cqlzvl0idGwxyUJ6iE1veeWG8P/Wq0Afby//7//zm+L5CD098G0fee3HOpf/f///z/mZ/+ff/T/////VTyPU+FAaqIlJiixkMlCMChmwEgQBRCagyoYW1ARm2MOXTAQESDhoFUtBQJDCKZKdmcLBqecTJQYrAgOcktovYWBkxB4nWQJAbomEhxEAuHTtTZsICYxUBTLYISAwARRkNBUyOgRhwGDiYQDojBTBwNKMSDC7xmg4p50XMbeJr0aGyVW0ymlgM3g4FyBoEMMncmGI00WJPXZryRg40gicZh81oC0VgWvaS+Aol95hhUNNcUpfQaJwO2MEqVu2rcthFIBTR9CIkAZEHOx6W2NpNPhWt4XtVaSUYI8ApjAlvDDeOtY2LNn39A0J8+KysS/HUPwncOX9dxzx5S2tEgJqXJm9az/fNZ9y7vcA9BkssNMrGsDjF1mdNyrP9oY+weylzegklWZHwMntFBwQ9cPTMDP1MoVsTBoAv0Z8UZ7mXTUdLxp1vy/Ehg2meOIZqY6lDww26rMXqfRZ6hhiEaTg0YMUeEmyKTS3vYXDvVwGbEMHgugmY7L4ebDOGXypxIH9rU2NtARbicoqVkZs9RqgfSGZZbIgYgW2lknexyYY62GUvvL66ZcmlA4JhzKS0EKLYgdhmqMghFY7TWbV3vcP/uGqaXQXP//////MdVlU0LJ3UA38c7kQtZXu/////+6lGol9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACMRhyQOcy3C6Czl0azhuI8WJIg3zTcLFLOYRPM26hqhuv4BBE6AVEgkARAezABEMbD+QgkHGdtgYnCiJJgUIFKDMLB6WrBQEuNLMwCGwaBQaLjlzVAQ7T3FggQgWNJ6gYCmAwGmE6YkFoHMABNJAvC4lGxEgHiXyOTVSEAmWRoFRuZYB5h0UrcMSBMqABRwBAiKQ2iMZdJLyqdP7FnajcSaew8LpFZL+UmTiv3XBEzzOE0KUvohOexkTx1C5sWlVkWgf4WBgSefk2RGpRiVOIn8gATJTAp58yC0m6ksooIe8CKGm2gIHWDHQGsoNq4ZWpZbq296qWE9gkuL0vMMu91zGW0ccT9EjL0uVTbNfw4o/Vztcxz5/cqsg0k9c/diz3WWs+81+XZIrsW4xmVrSeb1gPo1X3KIAAAAFnDXc7eWXMe2ZcZ60/V+ZWZG6S3C1iq4mEZwaEGDP8uyUqGcttenpfxoFKsBKZVU+eWk3tI4EPnGJL2njiRcxy2IMzYRJWjLnPYBwI/VlNi9DNamNVqnL2pjtKpOkpYI1jAD8yW7L3xmojWm6cRBgXGmZvFYafe1H2+kTGascdJ7M61VuDpovAxbFVZhQb/3bHNZbt/rP8O44Uetf/9//7+7iQPOx+5h/yrk3l3//f/3/klqX+WapKJ9ohgocUEhgIyJHBij4YGGAejKBMw4CPTlAmUIhEKCk287zfQiMCAFA9NJTALg0lBxIRRoOHkzQY5CJgMZFnV1LTsoB2gDwPTJLwZg0JEwIavPQlSAVFSGDSFiLVGnQYGFZlwSGFxeXvWIKhRJYFBvjVRQNFUqLTjcWdJHVxoNhuMGoFK8Zq0FgECupZM2BRZopdGqJF2DXVafLwMOeelaIZ0W2xjQUXpFjkRyKvu+8VRkLhz4IC3YaQiHg9FYm36qmBWHYTBQGSFAaqQekEin5bX1hnnVzwiCT4XDW8u583+GG8OaiQclk1CvGczvZRl847ZrVrGPeZbkNlkT2du2Jd3fL2OWPMNfXxNFxI5qos8QgD6rFXp6Pt39JAAAAAZS0DA+p0M3IgAfMHMi+D3wujlsOz8ON8lcZjzG2YKxIrR925e8rovnEnd6zvOxMyWSqVtq2kuoB9FlJWAPApwPUz6DlO7MMoNmarDFy0YO5NOWAJPFwJGqBNGZFi6dRLhcMBHZaJhAsjaTKZRKhSFIFQ3RFzGaSiPLpMIj4Ni6RIbBus8ZFMCqAFdkQGTC10TM6gpa1NstSRKDZTt+rWRgnN1ooqzrMv/qKTVfQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhKXEkDnNNwuWs5YGc6biNdhyIN803CsqzmESxFuojA0QiIFJqSIqORIEmMxGCRSY5GTShgImHdqYeCbMGLmMSIccToCOwKCKkWXCMEtLTkBhmN9JQmFpMGjBgEhyXUqMgqGxIFL2GhK5ZKFVIsxTNfJTBV4kBVdLHKoKMWh8wGETIADFmIZEAZQAi17YyQAQRGiUFGRgG0SQM6eqepE9qCZCQb+xB5IYfmHnKMkDbay/zz12atPkUMy4OINdop8ZFOyDC7+yyBHcfnr/xAYACRJsAyYc2BC/CjMYsZv4uwAATsD06Bk4CQSeMqnsbnL1bC9d+rlIA5zIO2d8/W9VsseOApvzBorUZ21WbJPYUe+fl+s9d1fczmd6xihgN2to+9CS9V3/r7rPcew3nzK7QKPiD9kc1VWiPFz8PLmcQv4oKWrMM83R5E/oyHEWkWG3ZHekijO0QKZ1pmW0ohfWvSyZ0jpLZM8JK0gAeVE9mid0Q6r0hYZHnBVmXW4dtSsIQWLGNPP2Z1YapH+0fqqyedm5a0mLS6fc3BcbnVX3ls9jhqJwLMrzq0SwLTe/GHWgBtAOTf8dAp6psze+c1j+OfccuRJX89/87////vD24V9XKPf/v7lr////+b/K9AP1SiEXILMGRwMlmAD4YPmmFpjhCC0QoEAgXOiKQG/jQMHgqIhmZVgR6NwmUymYzAZhYDhwDHQyYZFRi9GmmnqKgoxoEl0P+tZ/C64hALyFuh4J5AwCQI/NV0GsocCYENLGgCSgkxWKiE1mPAiYcAY8gQgMoAZeIwy09p9OYlADRIW0NotXNuPH6OpVQidCT1LUUZ6ARjrNs/0DTCg0xBDK2wAkDFYLTSHBOJUUP036hzM4alqw7KGqNymTCm0+XoMGEb+X2HxetdoJFG4KrACpgQBVmyi1ev3bHLPfvWsiqALd4Y63vDKrlrWph6VOrObd5Leu5v9OySxjer5/u5WntwW5u/1b/msMt5fvWVQMiiVVsS5aLvd+/6av6SAAAAAbJuiZoV1uibAeAF3YZ8WinozTKmZOoeyQ1oPqE9XWlEHzV5qK8Y/E22xidJPQ/ftF1UCcrkUfBDlV0KQU5pr/MZn3pj807BmHK6OqXDBM+5eALZqbF9Zo5DijMC6V0jEca0CcIiTxxZaOhi1M4USWRLp4+VCSJ8aBPJE2VZm5QGeAjQbGiAi5RPwhya03rrTVqJUaif/u5weFTpcbRej/d51qf/////9YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI72HIg5zbcLHrKXBTNG4lHYcgDnNNwtKpZdCNZXq7ed1exiI4CQ+AgGAwyMQlwVFRjQXuSMgoxNjDGIAAAbLew6TCIyIzTqg/PT0M1CBQwoAoPBAvMlGk3mGkgTCQMSvZyh+/oyBgoBTA4Wio0RlYjAYDkKaCzU5ZKp4WDLA4BTNMqAcwAdTCgPMBDkxcGx4ClUGDwDEYSdAvcj2YYCcLh1ra338ftdDM18GIvCoXon5x3cmpJ2w9OOzyFsplrUZbFlTPvRvKYaDPoASGKx1R0vVFaeZkilaEueMEFn8ZiglaFKLj8QGu0ZGTnTlJN+jCg9r7/3qSvlXuXcLGGc0440XX7Pfwyw3hu5u3A7S7tiSttbzutjorVXLnMu81q/dgOTdq/Y/+d33WHe/TgVyuKvsmPQovYluPtfTWit2G6fRvUmLwCqoMURu98keIkDYM5b4L5WUmWEuiwyj7zwA8dhp7M2OQXFOUsonZRfxFCGPcgmGjIPHF0IAQuRBJjDAGSt0AQcvoo3hd+dMUiIFEnCLADHCwblVEwNzEWaZpGhecWgvmxVIwyIsYpDycEBCusjhVLLJqZCeBchbF8fSDclt0yVJgnQagwFJgqIfgHpDCRWktlKS9MdAcag6tX6x+IulMCEbKFaH986+7qm3va2jIAWcZOBgJGjnGCzeMhoDRMiAYWAxj+tGpBIUCJFVAKFw6CAIZBIxk1VH09cf+qxxByGnAQLGoym9jQAICByt9TpS6JjAHAQOAQzAANAACVoT5Z6vhASGBFG0GidKeBRUAjIOMcicwGiwcAzLJJBSU4slFAwYGVnq3pOmTxEhuwRk2E3HEiniZ2OcxoK4juw/ZiMFMhel9IHhFWULDQQzSWtJnGdMfAQmGDNCmZ3eCxCzA7lxchAgYU75kzbTXJLBBZ1TsPy19DCMT4pnFCpMIOlBKZl8vr4TuHZyr3GVJulzIrap+55Zay/HLFlKm1ufjNu3q6/svpaT+WO7yqWbmDR7tSlxq6y7Y5ljzH8pQFA+CYMBUVJgkp0L59iThp6+kXp0uQQAAAAFJVxEC6V/GJhQaBsp7vUvm0UUkWqkoUxI0ywc6a+IJrw/fmIu7EOo+UitHvfNQ3Wl0kQ+lUunneJkxKRRRMsgFl1yteYo4M5EiwIYxEMZU2Wc/EJTCSY6QU1mapZrRUCfjde/faNjnOabb52Uy/rf2r+nfl2VNWoF0zzVb+d6RfnM9pQIUCyXtWCUWkVnu9Y83zfP/loWHt8/////+91Dk9z49Le7+/4vqyf9P////+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACQFfSIOd03ChKkmFNzleIi1vJA5zTcqMp+YQ3OV6lUuizemQwCNQ0wWEg4MGJhUFA+YpDi51VDEKGKQ6sOr5ujdkokVACBoKEkyXTA2pOw3uOk23VM4KH0wRE8wjA8BAChUno4gVAJAYYBA+4RMKDFE9Fg5avC6s4gAUgAEBAKlMBQBBoEA0gzB8HDAgMTAAHVrkoB8MGQOWi3V8xocHmjsm01x91KaBkRloT0MOiftIl7DpubcV9GJxJYCs/7aQA7jqsnegrI0pMfYNNx9H9/oHvx2cZ+44KYOFAiZciu8aSz1VQAmQVAY+iCOEGLQzhnnbxq7xkta3TPAEHb26LD/z3vC99xsb68ykcH4512fVpTL7u9f97O3hagmez1+u6/LlrYKn23PGLURAJEUTU0upySkIvi1EzYdFhWn1QAAFVaAUDoe2ZdBJCdz98NVZtsjQ3EMFEtAIPn/dtk0pmqWDcWONYhnJ7f+5K8ZXD8iljWUyCojEShdQ6kSXh+HJqWTQgDil6nxpfm7TYh5WBreNazyoWrhNqny1E4rYs8X5vCVupqQ85XhWf61k81xmGW6aRcq7l9UVIOEmLZvBe7/f/9fr//KIpeY9/////+/qXSDm6C/r/u31XDjZGrqnorDSMpiV5mLAKWjFg6PDcQgEHIh5NgYBgsMQc6hdoqhpYr6MmGQQhNMDA4z2fDTJcANtN/OAyicTG4sMPA4YBL4I2vWBA6pgKgN7AMC2AtOlDR1JPKsWYeFhgcgTAhXBzWMkB0u4kqsZuqIrDWuiEImNRDG3sawzl0Yk0rUOGvXuzEpPEo1Ab6llGuUUIrylznslEvnEMcn3d0OAaMENaA/SnblSGvTv+7hbB/AgU9sNAwRLp2jolkwaBhh4A0yjYOimgSO/bndUnLOGqn2Y0HC4vhzLOx+fPw1XoHUnut3tY7yn5ySazwy/mP5XtVZHzf1SClTdVWbv3Nyd//18sK3O2yz5fS57j+5+6fP/5rcpAAAAAKSeFcLR3VUuOCoxMxvU1AVjOijkVZiCiFUzDiLilp2F0lNHXaYQ/MIfOjl1iAfpZM4k3MTkBBwooitNItVR13Up4ZiViMCVVetfyp7MQtxIzzmg2rGGqegCgbf5Z3LTYccrEoXXTX6r+3HKnuSWizubqXJZ6meeUMW+b7jGVVg957sb17LWXP/8df//HErbHf/////+biVPh9zDLPkVLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkVYsiDnMtyqSpZhi8zXiL1jSQN703K8yglQY1peH0kvBGBzEVBM6hcqhN0zDQfGQYYiB7LEEaTIa7QgCy1xy3SNkccAUBiuRQBCwCMeGI2GhDOp2Njxw73RjYUFOPrEymHQSBgcAQwLA4aiybhSnD6M0buoI4ykS/CDzkp/GSwqIgGNLYyyEwgUr5XAyNezZ2nGAAGYDFDswwuhkzQ2IqB9TmP4pEtuDvUjoTasZovtLlzGc4YabPxt4IcIQpSpRTAEWPCBq+7zD1PcqSKHKhmD8GI5HFk8oxF6849Lyipx1UsUUqaolg1icl9b607vKPTEouNlQOldLjNcpN1vt1qlI5Mcs5uDZx3nLbXcv12/zeqmPMJFhj+WXKuGGfLV/PWe7STCv8znMHNv/TyGCR1mnrqx7BrtTaDIMjfN6eg7AAAACp90B8IwyL52yYNY1jqnlm6dub9wzBojMdstpAqmCccQp4dVkZIyNqWnZznpVPQxDUcv1ZsmfFSVrmUgGkj6DdEEIkamoiQWYHJPlE4gXi+YEBAMyTJkTp1BEmQFkD0ZpmCx0kKiYuH6JmZDxkkw6pURNBJFKzpmsVwrKEZKrooi1hICKRFdL2q8yDakv/rKo305YfmUHdoCFGKJqfEtqEUVf///6og71tV5mROeSBmGAKTQyXF5AMrv8h3MIdDmA8LBTowYQBRQC3U7FNluCARBREY3CGsEJhIOFAYwUQNLMDAQk4GuOIODFgAmCUJAOIlyoSmUPFGnigsRgbJXXTGa2YEUJCiU0YMphBM3FOyAlLYU3dqZhgmpg/ztvc1CxHoFTSOCuIhsRoOvoqvAgkYVrxpZ2KP1DNSLxhfLaxuVpbR8t+u6lhxT0/I6zzwGNGnGGCUSiSsEM18o9NtNSVFtZfKQr5aDTzFbt61jvO7zCs5KZkgtVbtjK7lruGFRnfO4Xbdbmpqkr451edw7zPLKY7vf3t7z5nUt7r6uZ417gsx8H3HNOwtzzu/qf2cRUgThromBOYJACAjtXt3t4VSqnHKrlOZ6gkcLnQDv5ukgCKUb8PYumwjOZIaY465j5q8kpe0t4t4lAPs1mOT6w3z9uiitSSxaTtzM4AQdHnYygDBkYVXhL2yBsiR5pg6/KOZzrapYPlRKeY/TSnH4rFi6b2Y025Uvh+qGX11sy6U1UaIIFBD72oKbnqtP3YNgOdXbT6gRvLHM5lpzmB6BRiIxW1zne8/vP/L9QTBFn9fvv8/n9uR2QZ8ykBUXCZDFWDns6sOf///QzWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH4WHJg3vTcL6LOVBDU24jMhEkDm6NysqoZZDdYXrBwnRXMZhsHSgSaihQjE1FQgidZiJhpgcSurNeliacyrGESh4kbQSAstMdGjxlowIIBIUxdlRACo4mOgQCqC0AJD02INa67s/KI6/6aKAJ8qiqRjhOBBAiMgqLDw1Mtblqz5qGMzAAKQQ1LsaeWXqaEmOhuJLrVarQO+SmvuwzPOywmdpou7a/qWO0ipY2Wxby9HH/pcscqNPjRcO/XV1FMvj8AwAVCogKTMsL2yvCvBFX/tavfUw5BCsNan7zPt+m5uxjuCX4x1Wnt/9PYp+3cMud/9f3Wt46z/v6z/W7W+2RknbOiJalKZsbSXwuCRpo8FSodAakCdYrHoUitkgaYh63sicI8RyAwu1ZnrUgrvu1Jp5eBnxWLO6iCCbtQw0GlcBgC+nYhtLiTJyw/U1WkLS27UkrbgBSbBAdDEckeQp0oyvnUtPcVBJFWi8akxIpk4nHSBEI9Fw4s3JknA5EZMunHMhSRVNyqXg/hsXiGB+6AFhjLF0iwyxicLZPEaKs2DFRkUhKQ3q3MxTwI8A7FGQHQWziCNtnQS1GAjU0dv10lHBDKcqvWYucTU1XvOVJ1NcIkft//4z/W9NSCSUBBa+GExAiA8wcDEbwUKKrwEI5MqogcA0EiccNhAXIIynVBqqgkgGAuJgViIQxAe55fNzE9U+DBS41BRNUODDgMEAFNJGst3uQ0DAoGg68XyR7A18DVoxUQiY6DoPxFdavFmuMw4kEV7S2jICQcZsdyZGAElBmifIMVC2OkmgAS47CGMQAzEJDcoiApTEwICUxyQWLGQQkjc6LiFmFA2PGRCihSFAQGGZHyBQSakfMyYFIg3lBGQKIssNWifyDizhyzUxc3TLrnjx5w0OtEpu5spkklKGCCIIaykO11LMF1mNZiqumtjVaSmTYzRZFJRonuhQ3SZNbLQSVaza79v3t662TSUlVWd5oiySaBqcNVFyQ43XOkAAAACjSHKDWiqfbxDmHj3vkNfO9jAUZnGDAECAShpw5QAZe3elaTXbdylM4MUtvJPU13Olp2QtblDxKNmLJFQUBk40sTxhxQx5oJi0/DhsN+dmOy2ahFJgQubWpZ5S3rYEJlS09PjTTuEepI/ftXWfZlnXlrXqHLnex+XTMB43V4zueqepAaUgaOFPBAMXz1n//+Xefrsqif////////zT/4Z7se4yBECmpk5Zt/////6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAABzdSSYN7yvDyDDkwb5luGb1BKA3vC8NbKCUBvel4l1aJrYBPMbUDOM7iZzTBYJwlxgASccMBgzSsNXiPD1drrYC/IwAIGGQAJ1KsNMSqLhM8awy603dBoFARn6UZCdmHhMQlMspnwKpErle7bO6LaggVgEThcpGo0k2lP6wLGVsrFrNdsw5MXZm9GxDa/k5nZrTtku9Ka8ij1NXjtSQySAIYmZ8mFgJBFrKQwVdwv2pCjH1hNJXbeF1LkzATxLmBRT1R9iDzRO1qN3tc7j3f94wax+t/n3ff1zU0uvLViBeZY1gCNQ5oaaE4x7gMkJNDL2cXNsFKKO3HYxbTx1rBWDYWjs9RSVomtgA6hwAM053EummCQTciYgFDcgEmFjtvai+VhV4YdgZBkuwBQkSCE6CA3lVRSuo6B/lJyoRARS4xqVDCY5MBgStH2oxmECocFga9zDmFlQLFQGGIgKRJQLgZGlOlYyY95rIECxhsXQI+lynjUssu5LBA4wS5TXZO7tQDcPdcl8g2zLkEUkNMNmNR9TKJjscWlriRmrUpMIggTsg02Fwt33mpPr0sFsoBrMkbLSUWrfI3RTG+/vncrq/Ocrb//33vefElNdZ0GeeXzd6pr/x/n7s5b3v97wy//y/+fztUHDZ1ykIFKX/T3/I6lOi9LNFXcvawYe8CZY47mrRhbB7VIjcaWrsndWN1liOrFIDAQFBSVRhZIckWNbHgKRwRLJTPrLS2WDFQowsgFpdt5VMyXNlw0AoE7qwRmo2OnwgC01ClTDlTwIwHB9Mx77p1L1JI5DST9OItcuRvlPWsoUyS9dpKfGU0WNOpvuJWEu8l95V5p5eZ1s3oZdxpkz1YFs+WqCSUK5wMdyYbUWtWO4VI/nqpu9hh2hbNZ7/da13/5vr/rO7hTQIEgG4FirXIHw/a2HZLs+3/hr4z1RMVps7kbWDEV4fQHHb1aLnMntyiNG8n664TbYyo8/LKVSNedQGgIWPjvEYqgqEtkbSMKFQDBJpQ0YCjCyo18TeeNuzYnIGQNXFI0/jJgdi5kAKYuXIbu+KhmVtyijuFujrFVmaluojHJFKJeYc+xSbt3JHQQSARjiZ2pZlHrNavPpxTFHJ182jBCojfhqD6XV2JbgC2BBVPYkFHTa+P3FoCzZqcdiz2VMucob+X/hh+EecnDX97+u/38dxpUdrCp5cqH0oOnFXraLk3kZtqBcUn3jv/b/9SiKKQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACPKFSIObo3KyqklUSzlenmFhIg5vLcLJqGVRHWF4h+GGzt6Y1MYe3AEB1QDAETVDBFALRhgBmqkcjfClxtwBgC7iyV4mAAwkZjx4ZmwnGNoQgDQfBSFNNKU9YbVpEAaYqCKFCQwLEzRGTu45g4QmIAqmTQFtmrlQXOh58JkIWDmQw+5OGD2NuaiAP+zx0xlCQEEh/JoTyChAVoOMnibJ8okKBiUImhLniKFgSmPA54zg1wFBhAjYZkAYETALCiHEBKpkRQvmRMCewzI4AMWBFKmAFAAgY8XlC1D2K4BgBhLDrFfGQNSeKBHDiMzZErqQROk+GMzianNEE06LHjUQhC0Q+o1FtW00l02Wo3NjBNEvJG6Lsp00KKLLSPoKQLqDLu7KU1vuhdaauvZX/S961JKvf2epV5sfSYJZfwgAAAALRUoJwTjPNlJ4Eop1sPzRdrQz8ibVKhQBCoEGHyAlC02IxF06dmDRYEZ7C80v4xW3RPmsBNP7QJOms4QdP0ZyCo3VZq/St0P1FDgOw/Ej3cleFNS3zRhh/G7nyajowhKKvL2b80duvHYCs1pWlBikxDv1L9ynpbz6N5UTopJvUK/DCJYQkHFOxFXil29/3959///dK3t79/////z95Nm5+4O//uq0Pj7d11be///XTxqBl2mE4eV3xIeOl50V1iUWi+xh1jmmhahsBlgKFndL9xl4BguFhoCCwJaT3x8tyIQVSTQl9xxVZjaEwIJRQHgswMAEgKVQ/jbThRJDBibYCBvgEkgOoDIEhMRHGHcmWZwKwgABSws3bi0ASGIPw7IGGXA/0xXoqdfBgGL/tQNGa7q2NSPjC4thMr1pzAHe248Trz+5bTFUNpcBpcPrEH+dfVJQNUaUIIif1jt1KurVvfVocqTWdXP+yxQTLn8zv61rm+1IcHlaLcdzy/O/hy/f/L8rGNSuIh5ufJHypgc+beFVmbztGb9T+mfdsLUirFuUwAAAADbWEoJgtaCXmm6PsULKalgBzpY/jlPq8i50kgfkIiCwUFwE7lZfcErdYGUBMGo3YFlU7dV1TsEnk/DFISRcCgJlRMCRdR6WsxgKHH7MfY5T38Ksrf3K2fOUWGX7ylxrO5urN64wqnp7tRjtB20yuspdLvp43+s900lqKxyGYiGeXc446T1qPvbKKLeGHf7/Ob//3lI+//////95dkkB9+7LfeGUHGsvJ/0/////5YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfbXUgDnMtwuqxZVmdTbiNFixwO823CwaflWR1leGjwDEEdTEfTOyBstVD6zUkBYA4Q2MAYyldh4VJIvw5oGAkMvq/yAgvwTFsxIQgGBzBYNbkxVbbSZehJVXLQFmgQLVRImN2ghl8RhbBhYOjw7c0dAxkMZmBQOAkSYDIAODJftlS6ZAzuWo9mABW20OQmMw/BERla+xxeLSuxLpC+rN67+XrU4+r1v/S2IYQ5Tlx6hJtnRIhGclts6pJZc07rGJQmlKJIIDn8+gvRKXgGJZLOoBaSzeW1aaYz7dpsKWk7Zhpgd6/3v4Zfzt/VlVZkeVW7hrD5nu6uOtZ85l+tZc/WGXe1g6AZIMiiLxXSeFjWxlP/2ZpibDyB4gAAALHm6hKMnhz/x3+cpPt1lsp3uQW6VsLNoLd0EnzGwS6kuWhDUGSJuUoUJbk9EJZVLbcIqzDWYegyYeMBcgqUDlAIKkw9sTvOwsahljKDIkm+xpTxkw5xYIIB5CKov2UXyYAlU+ZFrHLIibnExS5uT5DRNyYY1WblEezqSMsjfKYeiV0hyzZakTBEUKKGK5EiWd1dStemsej//osdEyN5005xSVt0n2Wt2V2bRfU6ZxACXEpv/u//64pFIKXyYFVOBrBQTTpZ4wBBpPu2w5hpniusAqLJ1r7AxOXyn0QAEkDYkHjBYfMjtY75QEwBoLhAEZq2sCg4READKBQ8ZicWiwOGgOlDHmHvpElrEwsEQPvEIZMemoLnMzUBwUezAIYQBJzQSghaAysYA5kUBIHzb9vvSug2NwIZMUBkRmur+lUq+MGPiql7QrMhsBQIiTxyKUodXim4OT8fgtO806+Q0Az87IaZGQiVagWE3HlhgIUUAsqsRViraRo5UnVqVwMhU9nq7hU1Wq5Wa248tkBAWOVXHLOimMcvxo5UNE09qZ+ctdiFjmOqtbvcNY/au7x33HeO8e8w3rPC/V5MlAwlBwVNIIn1ggQY/1lI8qry9NCzdUAAAAJlJw1wVjJsnVyeOMHWvOT1WR0EopE1XSUSJiptQTbSKNxSmrNhVQV7D7bOY4uNDU7TPFOtlduKm+ADAQieAREqdpKds8y2dbxHYDkxqf5/3avZePIzfLV61VbmXmlmF/LGczzy5KJdTTKXNIsrWVWpytZvyt3sF4U2MZyw7jqtAodC+V6cy73v//f/+/27FM//9f/9/ndSmGPyqnTzZxMqATbUpdCUTB4KStzOsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJGmPHA7zbcKTrGWZnDW4hmZMeDvNNwssoZVUtSXqmjNl6DAmpTWYJEknUR3FADRag9poYCRpghRjkAERARWEQNMlCtZadTlpHGLQi+hi8knipmYHGwyDyYFxFYdyw4AppmDg0YUGhh8JGHAAHBVubqx5+XAGRGECUYDReNAIaoEIiR5kICmFi4UB1FtG93W5I6MFYELE9KNdj/Po/KPSwFO9hiZ8hMXGwexOrlaCYkJPvSTkPVUo3sp5MytD6B7S6lG7oIF2OTjrKX2qsvfxVQqgLchQelTIUOpMGQffazNQKAU85UaEhNNolAnMlVvtilt2Z7CWUlFNQwUEsCW8OZax7+N2VYLxRMpc4nKPynLX/hZ+taw7fyq3u59x7lzvNcu77jhzPDtTYjUKFkHFlTp8QMQyjCsWDQoJlj/RfotpgAAAB87l1PwrG7+VL3mbADvWsRPVFS27OTbM5XiADHdK1GfTm4JnHaT8gWAVnxF3sLcqysQFStIjTPjrtWIJYAv0VaGJc17Cn6HLmZ3ZxNjlMBHFAzVc2JAA1jAn01IkN00nIBUccPZ8QNSysbUEGk8eJ0CjmaAw5alXLAigEAPE8kE6lMvV2WYJq/7qVE5Z1oe/9anmgpDEpHWhIWDa0od////VHbVSPhSZxKkaJvWGCAAog+ipzAQDDN9XDZAQDBEj0IAAQDhVJzKJGEhDQYSzFh/PwgYzKEAcOVWue1aCFXPWAAQW7MDA4weJwcJnBgeH1nrlEABYjGg4DoIjOYhEKDQpMbgkeAEEN9BiKt9x3ZMBAZDbsKclc2EtrqphSq3OA6kFQ/DEMI9r3bDB0fgdlLqy2DGNIOuZSSQvU0owSRt6RYFd0xacC0sgSPL7MeNsUpKFSBlMqhi4sgwDE0xZki5lFGOzlXOzh/2M+2saz7IB5R+v5hnds5d3k5BEV5lM5cvXpnK1/NY483f5j9v+bvZZZcx3/efvn773f2joQMEgq98veplqFN7DSHdyv0wAAFd2DRgqD0TJRnKGVmA4iy9+JFgybcgxqR0v6I1BnHylLEJiCYxL3FSerLibC20snZHZmrUGWrDbo7mNTDJUmYmEHgWIW0dRRGiWzIT0AFhTJ+kYGy2JkLER8oHED5ZYA6RbzYnlxmXSMjosaBiUxQCxonTIdBAzauP4qzILTCeTGgSakUDAh4TYAMyKC/IIfTXutbX0XSq/+TQ41Mo0tYOrWMeQaTskHJD7CjL////9IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACNRgRwO703C1KglRS1Reo/2DHA7zLcMIqeTFjeF4nLkMpzGGEymzQOFQA30fsGgERAY4IqARgEGZj7MJsBeYEIK1pjgJSEjkoAnECoMjqX5MekDyMYywBGhcDCKuk5n6Zam4WkMNBTCwMyMuCCVdS92ZKxO3t6BkDIj4qipoB8F7EBLRkCGX6CCmVuCYGAIZQ4WpNHCVaIpBEKfR/W4uVTGKwNSklO7kafWATDlZHBEjuQEre1qTxplRQSe6R7TxojJg1BozF3kqRCCYwzpByPmkIOxTlhDT08/yMuWMjA3SiK76zSgBHKDd+tYv93jhhSL7BQKS1NZ3s6XdNN0164ncifaryuQcy7T8lVen5lyzT4XcK/O5YauV9d+raysaWIhO0kwoAhUsE0KQHq0VI0UJEjXoey8koAaNAMkCsLZI3WlMsiNV+Dk1LKom9NLGYaYuw1aRhUBrCcyka61JUzd5jDvvuw11XRw5PR2UP9XfVcbKDhCxAbBTEVMDlEePswHPNCHC5ws6iXy6aGrIlBZBR3qmJmgR4W6GknTYV5JRsdHQcZIUCYB+Q72LxFlTiyikahZszOjDLanMDpIEuA1SI8Y0c4yQTvqrX0TB6t/bWO7MjWJpRQnQKn3C4JAYuCT4ufFBGmtX2ff//JXX0cEZAAEP2cpBcqu2eBRkFY+5aCAAgmZiLKeZMYOAgYCxCBTDhXBoFDAU3AwIDAuBzEQAGiOeIJY4DEg0cEB7c33bqk8FgCIwYYxCACF6MkjnVWNygsuCihAJQFR0EGJieYGSJQywECAMIU1mEFzwQAC/i+gqHDCgcL4xikomUw+m89rBTV7EhHblkOROQqUGN05kuh6cn04JRLHugt1XvbV+kF4DNp1SL4x5mtBadKXp3qA0pwhwLQIYot0sbiD8Fuxxo1D0GljiAVbtSUVrV/Lktp+V7PJSRKSHPHLH6+GFz8az9CzUr5i5t+luRqxdsVdVa1qpvDueGeGXM8dbzv563YxIEVlUCoOB4MGmBp5gO2KszNjZkTrtr7UsQOAH8dXSBQ+3Pf2LeEbVsNLSjPAKNxCAU/IcjTxp8NETOMAJjiTRaDKF/RSL4P60R5lLXlL6JuZP9S1qeWxCy1hnRsYGDS8DAjRUeWzs/fa7LoeX2hfKr0Rq15iw79kcJO3r8ttX8kLqu5TfwlMx216wtmkrqimxCWk3ejdelu4V5rIaZPWFeSfPLOU1xxLWovEWXQixXy/vf/ne63ckPf7l/95//+qsI79zev3jv7BIogqKC8DSqBFyZgUV519bP6v/UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAi6X0cDvdNwtivpWU9zbiHxgRwO803C1C0lcT01uKJ1pA8xgE24HUwvw1J6kEJQC89KF5AEOjmkKVcCQDsBEAPmCIGr0ehENXRgIFgUIMzVH8wfCAHAUKAVLU5Y2kMQgEXVMBAUMHQVMARpMBAhjTOmR07NrCh6lxgiCDZDFUCDAILTHkCzAALxoCWlpyRlh6KqUam5iEDMQjd5xpmGVy1VUgU1Y/QTVmPxBzwShWq+WbiUql0VmpiIodMYFgdHakBLSHrTkJR0kthuytlCKNizF2ogzJRG9T0FmyDSRxwbQkl0Mc7NuzlPZX/y7S2arpL5pceYb7a59yrhdaW2DGpm9vLdNzlmZpNXKLDeXObmu29cz129/cZ0ooeZJKCZATrCB0iBZpS6BQ5GiVJEIxltaSF9euAAAAAAO7QkYKEQXLFFIogZMiUpnndarJqWUrvgVkJgpwcQQBArAjc5TuvIoCfPFia0mI3sNX7j9xyUv8raY8NCIpT7R7Egd+H0icnl0XXmDgKEdmVIoplxALEyRNKSRxw6VI2mzkWLhsmgLmNrCowuAIqlIlqSM1l0CQjVQfsXFuZmBOlEBlhgRxNEsgpa92u2oe3/7rWo10q3Ut7trPJHD6KZjU60qC1zFM41jRGMJgM876/9cQhpqCeRiEeJ38Hw8ArttdwJgCppMlcYgEgf9DRQClAkcRCHy4dyD2HDoPHAeZELR8M2BcPgYJIyqJLBe4RAAJ0ZCwWCwjEpi0AJGSBVihrTlKFSsFBgGEABBw4CgADFMHK8IBJf1WVzleO+66XJmcCsMlLhRmkpHIiywAjWMbgR/X5ZxKWCK4rM0wvQkcAudTyyQFpY/CGmqYwWAWr6XXeeKV141TxhlDKDCgGaQMFgTNuVo/AztgkCcUAz8qg5S93asxyrlvmW71DjKUzu4Yfu9ez33tNWfkaA2M4Nxrawz7VmsbNNq3jZvatav493T46/DPV6xo+0cGS4AeaItNzUREBbnadzZ1jHYU01FS0AAAAAAAA00mWEUA4Kl0mZy0Br6Cxv0lWzNQ5Ubg8KOANJnWfomMpno/qu7mULdtnUHosTHa+o3ALjy521KDAHxQygeZ5s/TV4exh2S3Y2wmKx7A3UmimVggCXNU1H5WCaKB0+kwxVmrHx6kgcPiZqANQ8pWaaajpSJ4AHXRHKUbIqGODgADSoaCRIyrd6q7HS4ntb6kVGiFXqUtktJKymdZ90mEnw2Bx70A4RQMf/TXV//t/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIVWVHg7zDcLhK2UFvdG6gWXUeDnctwrQnZWUdwXiP5roDAHMUDiCWlDA0T7ZwIAQl1JKFhjCBrDhZgCwFf1kIoTQuAW2YYBgaCAKXwMVqo4sUAMMRkFBAERzoKj7IyUwWDxhUIggPAAEyB3XEg2lT9Xq8AhAhgwAFYKJAwDkcDA2NBVqUTf9q4JBENJeGUhA12HYpBMcsNUdl2guFxYhGOxSdl5CqEwDRwK+KZUWfaBJUXSgWxK0aogcnMxl8VeSUX7VI+JRG0VIxt+y70HVaWs8sVV4X4clJVLatzOtV+1Ym7NW/YrzL8T+eG8sr+WeuYbrS/GcobNvLCxQ1r/PqXu61h93W/v49z7zLWu9qflhzPeu2eh5JFTUOSprhLrJa+hD8axv1FUgDveWJCDPXTf8G4YypkIJuzDBNX0t5HK0ba20WNJhgBBOjCn/Zm16WS+q68zk6MBrphEUlutcZgxKTxGuZqECMRAxeDhpicbY3KLreyp91XuvLJw2MS4UlEqCwcbyBkUnRH0IxNTyTlwXjomRmRB0iuIKFkCAseWMBsU1JG5eUBEIiwhMNhcyOl0L1ApLKQ/DOopMr01vuw7fv9lok+mipdWmyr3NGWBzIoLlJhJ0wMFRqko/pv+jXKXDaQFwWYe/h7Y+gYSJrxwsBSDn9XciqZVnxwGXYMCZzGjGAAFtlZq2cSBoAgCIwCMNQTM4CRMGABRSJgAY21WSqHRamViAwdqDBA6vMtduzS4dWS0nMQAIYHAGYSgqYDB0HDMYPBqVgnGZc5EXZ+5JgWA5ggGLDopOva+kxBMOPgmDHK0D6ot1hSe5ahiBH+JAbEbu4IG0srmXUvD1SuutklNins32eqV1iEZz5Wu11NZ1nwoxkQNRnogr5jlT69juXfo9b59l3bXd/3vMtXe8rSJj1Bdj/NYV5irPztJ2trljueX54byw7n94RkQOLBokFEkjYqHI0xcyfo7MV/3dorgAAAAAFTmIZMDK61Ea/CXmDQYGJn7h+WQqW0zqOtALATDgwykQQGsig+IUO34oeVm4R4CgtPvHGUsKe726qhHlRXI0VigiRhkRQnyRLw5w+w9A+mikmZLdMLMlo0Uo3WYiChxknRIGabEDSRKArU4BSLM+RehUURvQx0tJB1SrpJqG6DYpEwIC9b91q61F/r/VmZeqNFhOIYZMKInosMeKEg6XlGAQhM+n+//9QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACEZeR4O9w3CjydlcR09eIn2xHA7zLcKIq2Wk/LW4dJpKiwiBMwXhAyvIsRgItmsWAAae1ZWoWAQw/H08fCAFDGCgWTNVMYBAzEXlDgMRUAIKGAQnmWYYEwFggAh0AUikyIWtxpzckPzBMAS6YKIZ+X0fyPNaT0am0JbRgCAgjCQLD4LBmCQNKALrR1cLOVksgmTDUHqaAK8BzkUgZ9nEWdx+4Ol1x+YdFGJxQc71DG1gIenqS+xLOcljL3jNWXtuO+p+t81JXrL9QSm/G6i94Zoqlas35UkB3vOgUwdjkxO5zE59S/eq18rFR5/z/8dXcc7m9WL019JO4fq1Nyrffzr58qc5yp3DmHc8ecu4LEAwMiBIDGzS3sFhd8qXdROaizRF75F3roAAAAAAAE6qhngrugfSxlwo9MYIeR3qWQRmxGmUxdHwZFHcFq9W/M2KWdf+q+WovNiIpKdYZWGeasPW1owYVnwQfTMPp8uspt0k1UFXVm8uY0DEQJMqM4pHmkF+0b1bSs3bfPbNlaSa4sbNqrNnOO3oXCYt6fWr/EUmg81SKpd59vn/ef/8s2//n//P/6axcwGFMhwRsZWULNJEwGblxRDTP/6GnqCpJAYGTG9Djy8twwliYBFvIFMGfQRgGKA0YKuWfPYRikVmBgEJARMky+FYHrEQSJASgJEYOM0iEAABeoJADSnemWfrAuQQgUxIBTJYfMHB9Wpn0FLqgsYDiUE0h2CopMnAUwCfkiQuHQgNjwNgOEwO5a7wwBA44M0dB55YxuG9u7Kyw2Dg36lsojMj4n9Dr4O81vBHuGpRHuIg1OP6pdkI7G3hU5KtzXJ94BYTqXFHKyAdx9arP+2rQzPMvsaJB4rhlZjXdX8a9Tf0llrlu9u5llnqpq1nTRliuf2qut252V1f3Yp91bF/ut8/93O58vd53Wf4/qt3X85+ufvL+/zufbngg14dexmIHSy9vMzf2MNYAAAAAB5pft4jV/mFa+mcJgIZeWUzD1T+cy1t0HkbEJns3eWQTNazHpiBbs8ywqkzlvK3UaJAmdEw0wQEnh4tDs7svneTl6kegAAZTt5FjRM2JwT0uppMmsyCcm6ZobJGy64lqzAzB8KwW0oqMyhbWO5Y8lLEFLaloHxJgJYYjvSP7KV1K3WUPf/OGqpx/9a1n2IDg4KGS58TKIpJi21f/R6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAl3Y8YDvctypgs5XFMNbiWttxgO9y3KoaulZP01uGY3C3ZgUEhjS9J8Wrxi6CIOBQDAWW+TNULBwEmB4BGOjDnmEiGQQBkwHINmAoJGFQnBwArBDgJEQIMGBIRGdwLILiwcmBwKtYZGwVWxaSOKHYHCy25gwEYkUajygyZ0kEYXCQar3XwMgaZUg6CRYHhlCA3MKQMAwIpmKZOSFgLXSFwAMXwnh+CYs2NsVJG8YHMCpC6lgSXO1afssN03I6zZSwvYki4kYWmZIDLpa7K+bZnysuuxOBcqkYibMi8tQDFQ+6AUIc6F1Jt7FNC9ILdiit4MJWfL5mzVpcLF6WUtrcqyZDP561Uy3la7rPTXobsWJyD7HcLe5PO509zHPuOd/9cw/PDXa2613VW53mVrKn4KEX1kokEEAcDb4pVxXhen7+MMbh/rbOvd273USQAEAAAAADQTWpECwQ86KnqRCTQ/7YNZqQHJ6adjkriIKIFKNPe+mnvqQCzCcygVmqlKnNSr+27NB1mtojSInE0xV7avfK6knxjLMzImpd4dZNSJkEd0aj7Ih2NkKky46bmReUaOF3SBxH6KKrrUMlAROHQtZa2QCsCcmRdHk6nt7b1Jt/d9aQ89XrRQapmdaancwRJkFpDYqdJrA4dFw8F/U/r//9S5VKi1JgaExi8/J4wzhjIFIKBJqyw4kHa/y0ghB8waMA3OvcwuDIuCiCEBIYohayFIIkBUEgOCQdCpGgY3QEBQGBROpireSZ91AB4FCwCxgmHceCoEAIuk1y0Uja2DQXEg5rr6QmmKAnCIbgMNJcIDCmsEk89USTkewwJAILigtR93tgyXwuJOsoYAshJ2MOhEZIvtdoWMdK3atMbXm3sKhFMRWY01I6kPlECuY1ZgirYpqFDgGVTCNMajKEuGru4llPgloNpiBUHTdIhpLXlud+jsSqU2sqDsoVqn897u53b1HQYbtwFD1emmrUsqQ3yeluOctnMbeE9erUn3O4Zds/lrWWf63Wwx7Kt6qcuZ81+X1MNc5n3X3j5bntNW3pmPX7+O96LepqXdwmQlsAAAAAAt+0MqBDXnp90jsgNc86ZzrkskDVrcjkD1KaNIKFi1HfhzCL33eW1VrNJyYW9VevlmxuMX6d/gcbHTTrEIJRnHKtIY7bdgBHuyi8gfTJFA0ASJRRU5sggHLPIO0ebGpmYpGJwfRqQD6kggUWoIGI80g5yDkNBqSZID3AxjEqHshXr1fWWt/U2pFJ0Hdd0X9BBNZwFBgbEjyhx5YCh8S06H6rf8YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJhWfGg73TcqKsqVlnMG4h5WUcDvdNwpInZVkszXiC3rRsMAQhMSjaPRmRMPAaMCQBLwBYAx4I30au00wHAw6/VQxnDsCAQ00wNAIxWEsoFOnMBQGHgYMAgrMHBRNFQLMNQKFAAMDQKDhMbvAaRxIBxQCrUwURZgSBRgQGoYDC0EODaxUcB0IAWzMiIDBAG5gKGRh0A6c5gGBz/p+wK677K1GBoEGIgXsvhylZLH7WDDUpSSSsW0/U9LJYy4u87s5IIW2NHyXv5CYHJieGL7OvYMCOb+3DDQaTluslMNELAYCltgEFKXuH6esYBGPGw+wERgFaobyrYT+V+zSZat4zdy7ve8+VLtWlwyqwK+dXlSRflKtWq+saSMyammJ2lvY8yzv4Y4apa8ow1hYsfTZfXyy3n3/+oqcrbEjSHnHn/F8y/6IIld3/E3jXyWa2tgAAAAAFvneO2Dw4P537Ot3CBs7ik8KmMccSBLNO9TJiIc5FS/LwwTW5VcxqkLuPncWSprUx7hGY7zJoqIQ6g6iAZX92gsyOllqsxRh+Wkz6JcLxkADDYPmKSJ4pEy6j7GBdUlWSzImouFY5jLMk07OZFtY8no5BpZVIRUXAxHGzWX1fWiaNr/6JUXu6SP2fuf3QVZ+gykVVrVqWaH73o+xX+uXNZXsHAKYbjIfOm+JHMRBAxNJ0wKBJ1VKyqAxYHM0kkMBPGYCAulgCQHMGQmKBrdoeAVQJaBhsIBhCRBgcCJfwv8xFfrqOqIAEFgJJQNWQxWCyoIyNLqsEaWMAamGzaXKpmKIHGAwCg4dDA0AwwF2cBQAYHm5eqiKASJCeRANTxqQTmnhlMWDGAsPhlo73u2273DB2Bq7uvA/KEb60sFRNAJO36B2psZIxCUyqV28K1JDay66VNPSIHwi1MUr3NKgYbDSKBC3Uq3j2/3Otymyw7rJpk5j9S3+f5Wb16xN/rVmatdrZYUGWPMsa3e6yp84UcGgVSJTbUqCCoYGEAFNDDDhzYJu8lYUSMVef9DFwAAABrrOBIQhwzQrvy+KBmUeTGs7lcsanSxKPzC8yAE8S1vO3LYfiFPA77Nnm5FWUkIgKv/zCjimLYA5EqCUpEANRAh5oPBdIoRYGw5k5fQSNTculMCmSDuxgX6xcCqSNReSRY66nG05bWmcK9eoiCxZ59QzbajREXCBLBaKSaloK30PQRrW3ZDWs4YoMUwOEw4KAkRD8NMCCBEk+yten/6x//9QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACVRlxgO803Kc6dlRU1NepaYLGg9zLcqHpyWxTU15VlT6TFAoFGExDnaG6GUgLiQHN6rIYLA2qwvQnKAQ8OKZQ7qVh5AmAgAAAeIR6DmmAgOShx4zCRIBQDPTA0aUJh0FxUeFwOCEkL7CMMI0zwYmFSCMTmAh0AQSJANfiGhgQAPPQukIAGZwCg4JSZYmMhgGBoHBBVSvbZKFACnIYMDDLpI2JujcJiBK8aBMoWCNmhluc0wyHws2c6Vxl5ZEXZUFac6kBCEO/z3xhXtGYwQv2ISGBqbPCGFEwgNsUBRbyYaxSMbydmUkKEyYRuCdyX0Cz3JbOyye1MUurVfUkazLNZ2N1/vY5frKXyvU7UvWd1rdJfp5fjXq297wtVr/8zpL17/z/tNllbsfnhf1UxwuswRQkKItofxROo5C/3Wur51/9XwE21pvUyAG9MigBV0diaB0zfeS+TGcUW4djMFpK/dXfGlBwAKNCKxgK1ep8H8tOfQxiPrxUon+VKiqbX5ivKxJOQDlOAuOIAQMupETMFjKA1EO0t6lF03KQEMGSjNEyOJi40UVZcLxoVzp4zQRIo45p9SJWutSh2rHMSWOF9FGIkFnTQ2NU6uplJ/Kz/6uorqsMM4VWPw6fU0XGCZc2bNim/0qdyx2lomAKC4YlqGIYCMRACydwh4C9lpQAE2MYBCMv9Y1EHgcPIEEAFUHMIDRKEmALMhgCGI1+IE+Y5AagYVAo6J1Q11QkgQXAOg4wQBXChJUAIQLSYLLCrEGRQpimHBZUAhh0WoGmTAIY/GyUD2qPNYexy2usDMJAtl7bs1gvOUSqiiorWgbDMOvQoC1pSQBBTNd+YavC0hqZ1GxUoyJHrVlWuoZJTnclTTM78qqLbuylIpTilBw8TiOrbswWVgBGi7WVP3O1qmFfk5lnUu2JvOeTz+9utfu1sqtW5XvzL5/v+YVY7S5TdrG19TuFzWfa28f1j2k5jYt55XatNjy1lfy3rLvcafDDDn9y5+P45/l/e8/usP/ncP1/71//v+8//x/L98//uG8s8DfqAAgAAAAA7KrMgRU02dFD2xD5iD4Zzhyq3eQs0rObDbvjpYfCIww9DkQktaJw3B+pbPvRbZJXz68Kec7YjoOACoBWldYn02LyycMDxJgEDNz5fN05kiagAlGi9kVy0lQVI40NzVMuJpqKcdBbVNOqROQ9NEg5bfnR1BUypaS1VIq/RQ910ulOmzVtt7Q5zRCop831AOwMML2I9Ze3f/u/++7gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACYpmRgPdy3Ksq9lFU1NuI32rGg7zDcq6rCUVnUm4ejBwlbQMBmYSi2BhdAQIcW6ZDwFhgFAACwCrYAaAYYQw4aEgcYrAc2pABDIjEEX1PkwHmAwCCIKTEAXwkAyIIggAgaCoWAMwJBIOAUOAowDAZ6Ujhof4uBQBMIAlGQQMFQOYi+wBAEIAlTF7EPzDsKDAUJyYPDCwHxEAbtperSWnk05ENLqD6gsBbEou+jttbdo1D1Y2owmAmMO+zIRwq/avGXvjCVNSGoi2iJtDD8NqQbuQWr0g6QPrT2aT2QxeeBC9q8YguuU8uuRIZQOAmDHrfGbpZ6W0lnOUXqv2vxdFukpr58rS+vbwuYVJc+9JQY0luny7Ku09/GxPvtIsd2cqXuH5Tl/LKcqxDPKphljUv/d/urFW4EEhzPAqFaQo2hcymXUev8Xav39wstv6a9agAAKmXWAVwT1IppIi+AGo3oSQylqtGvXbfOu7Zdo3geHYAsW6tHHHrv1Ks80VG2JY58clQrG9ABCJgYoEAkO781K5bE612HAdCo6SompiZMj4LgK6CRkTS4py2TUdIGec4XyBlNKO5EiZeRUXUK3QLChZjRShJNSWYh1wtKMyyWEFvukzX6C3s63q/KiG6dme26CC1LQTVqW6jiaRq8kt633BoDaUfr/Qt9P/1OyoEmqDgeMTAzNge7NMg1DB2FgAL6F20f1Bo2yUwzWDcJtEjYFQUBAaCQgYWA4kQ2YMoVqMXJYyosA4et3CocLUDQYDBQNAhqShaM4OF2BelhCCEUArZ1L1KUQWYxpwAxaiAimBA+YOIw0DgUAC2sPu4vqHi0k9FOWkGJbALySpVYK8kcpo4AnoAfszQcd1GisqjCgTlROhfBMh1n0nI/NGCz65S55rfZu5OwBdMLpbElJOfOV8JH4rQBjb6MMi7Yrdx+ZtUVjCV156WKwzt3dypX7Z7y7ruL28wpsOxK7SU1mvaxpp29y1er1vv753LeeOPOY2v/LC59r6bPPXNbq9y/LGwlbJTZXaR+vrQqEx6aH5r/qx9xL4Q+mmAAA/vCuqgcKyEFPzkiuYV3oEOgzYJvKeWz6FcBuBKaN7xpyy9x4pE5573hdG9WkWbxXrN25aT8YtLPgMwoSGx4IXRYlBLt4Sj48p0jRFc5afOIEwcSAVo0M1sZKMxSZkbayKmaFY6mRYaKI5p6gV61JJkiwudjgjpBNSSkA14WUGpGl5nUrqst06SH9HeyBqqpNevqT1rm8MhFM8IAPrQBA6C6wqka1vVd/dv9zNIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmxc0YD28tylMtpaWMSbiOVwRoO7w3CqK5lFay9uF4jgACIYUAUMBkF8xIEnzI7CvMAwB4CgAo1iwAgJAccRw3dMZkD89I043JgAOIDDAQHG5l4QEDqTZc419COmo0vQCImCqoCAgcBko0ysWBB0SAAODkhrKg1EHBxhI0megwIxiaaA4qtxrZWICUHARkY0ZYDCwkieyeQoBHuJQJTN/XRWEZf164U2BW4ZxUQfmdo4LdJY6QUIXm2FeUAtLdi01xx0XYdYDao5CGRr2xemkg+zL5awiM2TGXkEuLstSll2Isxjhe8ovXGMAKPQjKZpZH92rWltetlbvp943rs5L7WWMQjMD6pcI3huPVvsYw5JZXKa1vcr+/PXN2aeluVZdYyuc3ZxrcprNPzHHuG7O+fhrLmWs+5Y1tW+77lveef73W1qpYuqZY2lZ0/rTiD16PI/qDAIAAAAFzvMoiDcpmz3Nzk7rPEykQsdOI1rdBIm5zUBMcLrwJKIYfedonKiMHV57rszEjs/HmfRai7gNRVTY65zn4RzKZ3ff9MfH9pHDFaCAXJJE+mkarjMPoqTdFaiZY2SGmkPi7oVZmV5UTlotarmoL6ggXzykl9vXUn7+n5vqd9bqs2mu9aqLGgnsKKFjqsKWnf1UzXGJlxDBkHTKxLz78cTCIDAcBaCcKAkYJh6RAbK1kmIihy0mAUoyUJJlYuqhWRBoCBxAFSMHGJN/IckpBAJnHIAMEQQClqVAiywkIiwjAConJXSgeJBL6EgJMJquohzMIOh0DoAKsgwBZcBgp02LyF3nmbut11YaTqep3p2B1ggRDm5uMxyI2xCmFNu3FxlcQE99HP2S90hl8qpXLMi8buonbtRm4vqRSQGkyqBeGPat99XeFaoTJYyBuDmYUlLNd+lwt2t4XH1eDKvver+eqlNjb+1zDV61TX7d+Ock0gvW6mrdHLsJ7Lk9RWZZUpfw5hXvXKtiUY9wy5+dP+esMOYZd7Sf3He89f90rYdPB4cKwKqAaLSRwrfY0+qAAA7yq1oJFMoQruZ/uJc9uLP2jKUSugy4rG0qI2ZkB+S9nTbLPchk0M120duEVGNWX4ppXTLYlktpbQlOMnpIhYJ19u1OQZWicAApq3rHsDXCfQwSzL4+aUqXqvxXac1i0uPmVqhqO1ZHuv90fUZo1FU0YxS0MmQsMkZv1nVdfOvj/477/O9f/fz/mF9/ft8a/zr6+dY/19Xze87YVLAqJNSV9uyQ9LdrS4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIoGhGg9vLcp1LyVVnDW6m/g0WD28NylevZaVMNbh/3gftNQwDQCzCcH+NKEDEDAgBAAagchFQeUq3SZiCjlA05ckGq8wIXUahKLUOqVhcBC6IpMxgDbiCQQzM3Tu9ygUPOaFQZd73oBbFMDAFXZQEprkQim4wlKYzgzEQKtMygUX0ydaqgdI37SV5iMDWnC6W/D8BU807xupxGifSbi1q8BIoGnGftAdtdciwXlUQA2IAlTfu0SoRavE3W7ZjcUcKX3C1Meiq2XFldh/a9Mk6PUyllbAYd7TVLGpJjbzz3Xp6qvZ3KvQazwvzVib3jGKXsqklSkp8JbjhW5LL07hY1Xu7q3qtNTfW7WvUmGHc/r/Sf9feeeOOffum6R9goWjUznq/weIq/IZ75bPee7btYf2AAA71vCmAk4v3hnvlyTajozUQJHAKc0nXRfpnM9TlVppLI6fXaSrC5idjkC4PXOyethyCHstZR0tAMJ2sPSS1u8gg2tWgxEiz3c47oFIAJJDRZOo4JaedBkDI1Y1N2UdQJFAYpRWkU1rdjhpdBMQp5V2YuAGOUjhPfUnQ/dRZZavU9qzTd/QUp/Wa0daC0ndFj5uVjhGWL3lB3/u6oEuSWVNTMFJJ43AQeRAAA1t12cCMJseAalyjwqAmtlJnA4eWYlAyNGxg4MiOtYwcRAQIYqlHgLAVDy/rhmeQYEJDAA5HNCQyZ1w4mbYKhzgP+gOpEexUjSna3BiV4DLkOYBBzLxoxoFftVZdQsJiQ2qdCg20Oa2p/KUWIrHoFXkA+O8r1p7d1YrjfhcqhD0N1QCL/LMJqvlD1Ekk3Fr0jcimBM2vSF/WWVMqatGm+8HCkeBISTZzemevWj4IwvqSBQ4z8Ox3GtLpx8obxznL9WeSDpbGo/S3qbKtE5nKexhuzKnghb7y3mMdqzku5nFJ6hx5hDdvdDP01bOlt6ppTe7Wp+yjLVyV0n3Mvr6wufrn3Mcrm71fHeP4Z//7/Wu//cse7/DLf7/Ws/5z+f3vP5esoorAuAltwCAAAADKXZQCQYLg1VIlMeFGKPLrOahfdrz9JL32iKuA81bGPuwxOPwLGKXW/mMeYSm24b29rwUh1Sno2ARS/DN2VXKR93Txy4tSKB9AANRtrNsWRpQWaE9JzB0E2kJQuJ1nqVSlyy51PUmkJOAYx8wRTX1KR/p9LbSXpGKKps60utJJVBSC0aFVlKTUpA+90ihxxrvqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACcZuRYPcy3KmTIlFUzFupd23GA9zDcpjsGVVnEG6Z48LFBYAcWA0MM04w4DQgxYG5CiTJKiEI8wIABIBWGBoCBAlMdRIweggUDAuJkv0oxwDAYDhgNMZi81QkTCIGBAHFAYNDcz8I1bCgAmBhoIhQWAO0OVmABHBLwITxYAoAACAEqWtMAAAPM+DYEAYWA4jMYcFW4lpErhQEJSu0m0Y2AFiW1pW9EWpXCgA4QlWvblQtycx2QSTKLL60Sby8FcQlpLwzUFtxfZFGnAwj+SKYev6CVUsRgWZXK71pG9Ri5uMUrLE3gydq7oqZwNuMyC5K4TMX8s79+vKWYYT9nec/Szsvp6aN1o221PNzEsvzFezGIlNS+nhmmmZmzlJ7URzwzoqW1Wy3e1+FFXqWfrZW69q7b7v+VK9nudvkzqk7f4IUTjfaEx7iwxZFHLWKQe2lwv9zTNV8gAALpawHGQfCK9R8xFUw1kxBIcRHKVQ/uPWIEosWlAchTiX1r6TU08z6SGji+UZ3X3bwSflv1K4OWJQV/oNS2+9F5lNPdbGz7f1ErlcuGIDqZnFrUYJCvlVJSjEh5fWfPFVlzREZdKWF7SwVlEGQcjSu9aLDkh7h0pE4fSZlpfvQSqrqtspc+9S/R6Gggit1qZlNZFlprdI3QRS0jVQDCg9bE937eiStzQGGACACYEwEhhVhQi3g5g7gFmA0AQBAAgCASCAQzB4AAZbLkpgMKDEZ2OnD0mEBgEMqhaW3EwUChgFmEiWb3FoKFynpWqoYFRBhoCmEgCCAsYDHJZ8rCDxBcKUi+oyjMjimMk+1NXIiBggI5ZZC0LAVnTN4CaksQVAoYGgEAzDYTd6ljDsUFSNPSmWlu7rqvI3Vr7rUYWNDj6Ri7E4BfWCIHe1pEFQ5ImvaBQsq8rWfnKr3Y3G5t/6a63GHLfY1Ds3RofNCTcdps9+ZrVKmcBUsridbOlwltvHve3tyyZrWLGcjjX1Jyz73y+WyfdfHc5cs8llzVyl5Umbd3HVi1Wp5VcobGq+e7WH/b1+6365n2m1zmfKtlMjGwRvxJGG25HFwvvgn6IFMu+c62UAAB3vWckQ6hNUrw59SE7gxNJwgugnJLNTOn2kLRFKx+DFZXSNbSlcJrkFOtSz23+5zHmDPXuqVKUrM1la7dbOqekl1uxBI0m/n27sbGQIZA9WybEBN2dlmhs6luyKlrICitM+uu55RAUUigW7oYxgdkuGxo9fdS9uv9XrrNqGtWr11rTdBS1rvqWpaTObIhiBYlIBlf/+v6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAnAbUYD3Mtyl6r5VmMRbiYpuRgPcw3KhrAlGaxBuGeINiAAYGgQmAYDoYQZuJpMjvGDaCqYDADRgCACGAmAOLAmGA4Bay6iboHCgqgs6WIkfTAIeLpKowkBBclBZjYlGVxMYXBKXAsFRwBhgKNAB0tkVAEYFCIQT4eSiJQq014ZIygRAOBBIGQckIMgEzSHDB4RMEAIwKFH6fiFv4XjKBSChupYYRCzKX4gZitC7NG7Dto+QFg+7o5teYmQEupuDnlg19l7W2rt+xWC4YhhQm+SHuRbbq3a3civIJWddYRKrSf89at3q8NMsBdEUIAFZuUUuyyyvV60ruyWpn79T2OfO27NiA45lanqkhqyDDlqfl1WWUt3PUj+etU+p2iqU0WppfWx5hVlWWp69MSmzP59zq491jjzO9nv8srOOdzGMkWzjps05bAScFvr+1Pu+vX78w3bPYAAAAWscqseVVNhJTr78on/uOVxpSQdrdqJajcFELzDd+Zm/GVVRZ7tvEw+zRWHRxz33OCGhXcY4hvK2n1qOrBOMw3OdZmn3zdx3pGpRCGoXMVJJD4dnSUbGpkeUXUnNS2kNZ3RW9BR1NIg10nrVUMcK3cjzR11Vd9lLbr99VZ7Vq2r9pswdJEACoDhsWgy4Y8aBP/9X/9Rf4taWeMAwBEwKwUDC6LPNcAp4wngOQUBUskwAwDDA2AMMBcC6gsgwCiMHkgwNAV80iDy3AcIloCACjgLawYZIRqwVgoTIgx4eE4iBhk8zDgHcsIFYXEjbp+mBAAzOSwWwxVYhBhQDzCwEW4raaIDAqORCDDCoJVA+zIZAx0RAJCQYbAJmYKqGtdfu+9M3Rv26yPbInjdVxZdAD2xKD4tbuSCBGDNKwZ1HGnOHK1N4kIER/KbYphH6StNvJMMRrS6CGpXNz03KyVR0LBCHJUkhoKSc1S4WcH/5hRz8SlFJd+jrV7l+mqXcqmerO5u9TxnC1O4RTDl6R46wxy/LCcvXbnbuWVTHPdvG7dysf3f53M8cc7Pe933LLeOFfiw3hdx/pS1TFlcYv9fXY5Tx5JH+ikAAAALvM+T4wWE7jHJ+7cj1N92LtReI4PYvJdUj7yV2VFwL6QQ1FpW8Idlg2mntWgWaeC/3K9SPUv69hNpbRFbz9S+zKLW47G3UWEoeWGSTNSkkA6PorPIWFJl9uaGqyKsQpcc6qLPUyZarss2Myi0mOhOl4NCK5Gpvtq3WyVBldt/pHtSNHqbWqtF0ndBa1LdNBV84DQBMxYscBd32aPvRrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJWnpGA9zDcJzJ2UJnLV4l/csYD3MNynWvJRm8LbhbaEgLgAmAMAsYFYLphJFFG2AT6YagMRgagVmAmAmYCwDQQDkYBAIb6R6OighbIaMexODxoAEQIl5e5DmDhOW0AoQIhWnYoqjcFgS/gkXBGDhoRBcXlYLcxIt1IAcibcumLygQGuQDAgY9I4MHIOB5gQHqLp1qNSB8wSAElQIFQcb2dQa87uTFPI4jbXhXjLAaSHW/hDPKSmbC59iGoZ23NWNwYq9s+xCcTZdaWXXHtS3D5mO1i7UcmJufs91Nt1VuBX2pRJqzq5V6uvsxmmmMY1AMPzVXHH7+P/Oz1nLHLj3VafLuNLytlXpcM9YyvKzzPKpKcuflr7dfKkv/nezw5jnew7U/nOZ93hhj/8/WOP9u7y/Ld7nOc1+P6yyz3jb8DydGtM200DCRakAAGxy3QQaO+DlcEV870jcfXqdyGqQ7N0d2ITlehelgYMBbWA41TwUvJYduL9PfT5tznN9uVFUJHBeMwLCuAlEstAlh3MkYm41gSJ1NSqZxMyBWyDRUimcGELammynNC4RnMzq0CMtSKNlWQRNakmS6QxQ5DoGzqfftUvPvodFS9Sza1CQyBhIgcoeIlQfPRoIuCwqACaWtt9n+rUtNVM4IABMBEAAwOAOTDbGUN783Ew9QIAwGQUAOBAE48EMYAIMChMeUOGAmJFowHpgdvgUABIDvwRBgRAeNFQEGAhI3BA+IjAHQvBgIHQULBAwqACoKwca2cRh9bMww+jGQGTBUOByRYjBph0mGAxGEBcBAJeywjB29YJEwQDDBQIMOBiFrPjzWMakKgpu5pnjTtldJxIDXuDE14YU3gZiDgxeGHlf2Mv9HGwMtoQsVtbOLgY6osZh+q6KOdZuz3Wq+VV+EnwNJb6BaPMk3nczyqVpuV0lWrqnbazjcpeZ/K6tBlf3fhyza78drTU7TbrS23QUOd2rbwtV7uFmnqX8u5U/Ndq4552sbu/pc88OYY8ufjna1+P9/n475/7+8j96y4AjV72V1iT85khuUeAo3AAAAG5ny3DivikyTjilJN3XY7q5BEPAExR2XSm/M12OtFLZ14znM2IFV0zOeeuerxinxmucUOnLUrzIhsYTiWZP416KrWlMbv4YYPUasxpbVJpGjj47vZSZTSZWmZoQw8kCUvMRz8v74pb44IgMsKkqbNX//zyh/Tb3z/w9/31vrp+22xsriGvZX7VCA5CgufCzD1LN2z/L9D69P4wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACY17xgPcw3Kg7LlGaw1uJVW1GA9zDcptMyUFrEm6QnFyR0AQcAhEILRgPE3mEawMYIwOogAcDgFAwEIaEYMAUD0iANdB4x0DhxKMayo8aRyIzAoKJNwhbgQEAQEjDIrLJKYMhSATGCAIJAsw0GgcNxEFzBIMsJ6Rp1Z2zNlUIsPMLAUrAyahnQUggVixjRPRzYuvNz1jtyEIALqmKAeFgJMu482EsZ7Ujg/kmG7ksgJiL9S5C6C7b6QzRwF85HmVF34ffj1jaIVV7UpcnHOJbgiUYrmt1YAqW7v09MMpNwKFO9wYtf7OU1atEaCntUVeZwYphVqXcr9z7VrCpdlj2536SfpN5Sm5Q2oxO5XKlmks0PefV/G9hO1MLNL25Vx3NZUmrWV/Vy9+OP7y5XzzwudqZ77nUs/+fc+dv//Mf3nnnrn9t/7D9yGk349vCf6kAAAALtnKrEhwic6Yr2/ume2R3tt2vTQgmNBrRabnpUwF0jsqNYS6STE/NrzyeFgmFPPUt/diac+liGLsIuNnTecy9HfuVNPczSd+nPmBPJNi8ESNyCRw88Q5/ZnSTMyacNE0lKE3ZdldaaiRSYzRX1iODfTMjBmr3rWroGu3/oqqQtU7VddNrod2ZBa070E2oq2qY0IpYzQ7fVd4ujnrPogibT3BABhgGgZmDUI8bkit5hHAsGAuAyYAoBZgIAHGDqAyIAWwgCNTpPUwsAi/IjJp7NSCQrMBANarUHBMKjYs8JMVMZRFtH6KAPLQCTAoHDFoSBoAMGDlU0SlK4X1j06g6nysEosHA80WB0iR43AgFBwLeFZrQ2SUUUh0xeG20U6WM3Szcf6HWyGskFU1h632hiUKwsndla0tbDBMrkMelMhfSSy1isEll2bXtL/v2PqRKU3Wc0+LCqSitbwgNDgGxjDpwt5u9u3atuN02F6P3InQSvO5ci/OY4515/7colczDeOHOSyalmE9NSa1bm7dyM0dixazxpL1LllWotc5ZzsVsMd6y/OrYsV+2d58y5rHtngREkLuWrx+qwFDRbNGXd763tv/Nj19AD+GdSCxgQaLG+lPbvNu4PeUFWMuZ9ydksci8DpSm2rm1qK9ceGPNDfmUOzemrtJvWSekvlF6WN4h0fqPsllEc5ytKcoak1nBFItoLMgjxILSM3UYiuX1MlmZqWj50rqIBemtes+opKmP0TIOCSRsykvQ3Z1H9Vv9jzKU/VXOdOkX0EK03Td0Kk1rUkpbO6ndaRkos87R+jdRdGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlIdkYD3MNyrqv5MW8zbiN52xoPcw3KcydlIay9eGEKvbRk4QAoDgojhlPIMDMBkwCAABAAAgnMEIDQhANFgc6BeRAI0AJgYOnyDgZ0BBQCGjuYpHAwOEA44kwJTTVHgsI7AiDhksXl00QBCKggZvI40bX5PuCMgV205SoAjBIJMrFAwwPhoxqpkwKjcOs+XfNPuh4YaETXkrGQt3o45dlrplr35mp5y04GUOqQGdhu24ZjjPKkgq0MMvDIHSYu5KdLa5ymAq+9Z4M2pGUWco7AtLSTG4wSkBz5JGFVo9Z1ZnKGhpbtBc/K7TRjVy/dwwubjFvudankVWIy+1fsy2KUtBP/EaSpbqSS52KxSmmsp7lqrllNV8s4bsZ8/O73OtcsYVe65z+5452t75rDmee8dfhzvO3t6tFyrFZB2hu3mWkin/9fwwB/PDOMFzznVZp8sqU7yNg7l2hkZIQRGNcr2HTmXFbQD5RbOWWoLlyYquoAhlb32s6na9gsBNQoZJJG7kITUHLk1yVWbfM27IGwm11JFAvMTIBPSGrTNyogcG2VE2SUUkFqZiaQWUkSFSVPO2t0xy03Ov1GBHi4kjMsot12ZmddbtVbtqpJrWpBV7tSdqCKlpKW9FT3ZSlJm4MiDNAMOgHYhN6qcVecKUtFLWaN30Q/AcGM/IQCAIEabbRfJgigDpAOA1UwJwMSoBCPA1tbcIqBxm4MKBxEdmKgSTBkBAiSMLYIYCAJjUNjwQfCGn8EYBVUTPUFMGCe0DQgYvAac0RfaGepVIqvQzu6gGEQ9GBcTB4LgWyt5fzVWkZxyGzDgPTOX7DCtj3SGC4AlJgC+cseKVvfAdxqsHMqdGVShj9SbfG9ZiLgZskiQqZ88qr28u4fWnLjX+VX+3jlVzyaURagZ4H2pMNVamExTymWfPW6lednd27FvDG1er44Wq8o7McjM7L7c9bq4WrFWtKa+FNurcta5W1SXt442Kaeyys75vv63jWu7z5+XMPsfV/WeG6+92u8/HDXdfnuz4D59OLl2lbd+7udq3XfWAAAAH3Wt0wwBP8Zd3LeWdPe3NWp9/jpFprM7NVmtQUJ4R2m1lJLqn3x69qs8OQzb1Wz0/TQaGVVVCmRMcWI9YW2SmaUQvxtVmy26fgABHV995kN2WuL3g1tbTlar6DtO1+Hvr/A3hk38W/xm0xSe8Hf/99b/+9/0/+cfeP//41gmVEQiWKmig4UTie8wcUScAlHiAGFezd72u7O1QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAIrGxGg9zDcpiMSUJjEW4lBhEaD3MNyoGrpSWcQbheLdF9hYAgGgUmAEIMaY6YBiBAuGA+AqAQAzAQAQMDICgGgWiEAqJp7qAslWKYizppcbgAAJvuM5zqMhCoGAoHTMoZYnes5DMwaPDF45MLgsOCIMFDNF1N/HYAmWuspYi5CqJlcOGBSEhgYICTJJa/rpuKzW7Bw8d5hPtu7d7b7y+flxhA30C1JXhJWfyCSxnNwpW7NerKojS01uwqyAwqOGsJJI8qWmxlcn+ku1lG91t8mbCDYkKLNiwila9lKq1SHMdXbHdYybeGu81qxFNVMb9mEbyuWp2zezz1R4SzLlHhasTusPv54WOawyww7jYxq7ua+9h2n/Pm8d09j/19/huJXuY5S1jDz2bwVczv++hX023usAAG5rO5JSwI/ieCv29aj85/YZ1RAIzEoHiFFTWQK1U7sSuO4zUtYooI8dV/W4vVLs9fQpTtm3ZlAlShXCsd38O5dv6zT4q6pkjRIsFAh4KskXppLWLMSVRZFNk5UXSQUPrY2a1TrIkymT60B0DRrZ/d+yPX7IUGs+100kVsjZBS3sylJut1Ka6W6TWfMQXdj7PuR9byH/QSX0qqhyIQCSqBkQB+mAI06YMYT5gCAQAYAQaBLGgegMAiDgnGgjIJBgBcIuMYwCZycSuKqQaBLsJDgYBhwMHQEryFv6tuRLNMHB0x4ZmlJdGBQoYaACezkNpLHyQ/dl3KVLUFJ0RjQWDpEF67WHyhpuTqPyIAMYqCkQbYtHLrb+ytyZ5QGtS1aGKsKgFUcH0kgsO3Gn1gl/4m/01MRJfclL+SCtllOVMpZNxSq73btR3rf/KaZDiGgsS6U0t/Cdzt2u1L9mUVOYV+3M8qvKvyeN5WreHKnyfHdSzSx6xYr1rdHdwv3a1+mv2a+/q3KTCpyr9ukyt2K2FW39n/rct18Kvfw7vCvvmH/njlnzPW+b/v5dz/m/z7/44d1zPHn/3X/zdb7/RqJOtAAAAAANl+sazPQlJPm1utLJneGcUsx0JU5GnZkUsh5OAbk7s3hluo57SlgYIcxojbxCz3XEPZf2UwAWfnGONHpqaapct6bmtG/i/hOIFQuomIF03Z0TVJRXPPoOZGRskZuxxA8X30mQZCyyK6vTQHUT6CZxL6SX9L107vVQat3UjXTW6S1IHkh6C71E0gYodFTgEF3JMtON3rY5XmSdW+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJt33GA9zDcpmLqVlrDW4lOdcaD28tyosypQW8RbpmLWmChwAwOA5MF8BozxEEDKNA2CAsAYA0IAXzACA9FQEDAXA9ddMVQRyhgFGWyOfLAgKOyg6CFRAgBJgoKGNAkGEl2nSrMpLguWCQSYpAhn4OoljAIMFBtdzGVuxmCREA4HnGMI8GFQWYDKBhoDImprJIqtiMMslg9LIGCMsABPoKAVcD8zK/HAh0ywbWSYZRlsTTk92aqLxp6W1eaM3W2g13KGJy5XLd06oYp71FL62VyO7lLAZfUxp+6q0OEoFw0MAs5ktuplOR69DERmtWpvKXxbcrqZ18sK0Ui1jkhjcnrX837kN2zT00/qRXsJdydllm/urEpfC5qzhbqyyjzwxs52s/oa9WHO97hj+HMM6v5f3DV/9X8O4c/6m97/XMc8e1refOdxz/uGqsctyjdH7r2LFbS4AAAAABfhrdRbZjrIsbjFJE5Hdo+5yu8vsLNeu/S6gluzAAPCM4VN3p53KyITj8hov3PWc8dymBv3MiEDxr9bhyxljlfr0qI1PZmzU4YHjyAAbigpqNya6qnNXQplytIcazzbO6qa5JVr7uxwU00TL0W3bT2/XR1rfrU17KXrZTqSZR1ZkzUVHAt1AcCsckPdzWdm61Tup7/StFlCN4gAKMAEDEwKAxjGfZoMeoNIwLwMzAVATMDYDABAIDQB5gEAfRphqGrXhCBGSH5tmMDAUiAygFV+FgIlIzSAEqgrzwLNTA4GJFSEVTDMB8rGUxDKTgeIGdMBa9JyoAFnJa0RGcxEKC48Dn0EkkNMMYjLlMkyl9t6ARKBnZVWAIal8TZXDcrC17J6LGRy3TTmSwVLohDrCnipYW+3H3lFBLJTWEAb5fYjfLP5XbHGwXrTdorl2VXoDgpU8xKZDbzzidemvRLVmvLX+tZyDlW5Wq3qapYw7bs00owuXal2J3MaeQSy3byuUnKfk3X7Iq1+vN42d2s8MrOs5r7tWgyrzmvu4d/PlvPmfLurf71/4d3+8P7/f+yGA+rFZfpLa4HN+FbrgelN0AOOWNNEUORnUkDgaW5P7EevJvGrcmSDyeEqnZc/8vLljtYcppbcmoJa/POUiOx6Hiqp7N/Y+AGz0VWYB2W6urFpZP0+HLuow1bdaWl4mCfHekmBCm+k6kSKLrc6cWYGJuZnUTMyZTupFGpk2kbZaq6bsTyajJt6nVqRU/21euzp023rZb887ppprVPKUy1LrQWuipTMxSM3CwS3URXseSiw3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACE9mRwO7w3KbzLlWay1uJVXvGg9zDcpYMGVlrDW4cpThSZEAAcEYkRhuimJ9QCRi2CpgKDoIH4EBI2UwRDF9V/rf2n8IjI4zpJgdXyC80jUu0OP0+lrsOeegQ5S1mxiJQPGRiIEqmCWdCamO+UKmWhhADLpVEwUgggUHnAEgTVoS40Ye10mdsqLoxSRKOiQl7RtqUFv4COQfDFX4ZrxFlTYJCjkotB7YX9eBZFuPU0x2T5puVNUs9Xv28JRXxdHm/kF7dSzi1hPqX5xStnUtV8q1LRWq9Wkv43dcuXsd6yt52cPpLFqVUvbsryldyNa1qhmpmerU2V/G9avZYY1+ZX7VTDv/u9jhrtzKpgSAYJ0UJG1N1p+PnVcBLnpiGrXvbXmdvPKS9vcAAAALeGeFOnob+oGdHflbcJjKB/uRbUZdciZkEumJRBbKQk6xKMbNerEI/Pw/JJMju0HO/+mwPdrO2VptzlqY+M/SZd/KhsZ6jZ40TIKagIxJS0LrHu6aJmedMnlFI0QdzVZ1lGZ9PWtNAfNeuugUKVlNsq2tv/d623enX2vrRsuta7rROugtFmd3WpS16E4gTXRQKs2bu/Zro1N87KEoKACmAOBEYFgS5jHvqmP8HqYHIBQwACYF4JRgRAOFoTAMADKAM2GOdFGNmESMbjqhjQfRsGglDBJ4cCwkGHcV23J3GewMRBsvEQAQwQSgsC1ZzCQdMMA5tGmM1gURhkIBr/SFRws2IwQUFhXJCBlds8f5x8HWfkIDfHWfpLV75JTya8bVvbcoJbdrReSy2alTcb7/ttB8OtNdPcSpnluphxaI4WK13eNNfmmFW+yWHb9urNvPKEmPgOxDdPhRWfjFW78zQU92Mcot52bNa1nTz1rOPU2P385u1nT542JHTR+akleIbxwrW6mu1rVJS01+W3qeZ1Y1X7qthZxvWLO9f+/x3hc5ja1rD97q/njhv+YXs8MM/z7lhhrOpjP/Zq+MDtTtmwDKsAAAAAAu8yxpnZHd4t5k9du1T4zbrfjfUWCDw5amrMgT0TQocKLe+SWUyhqLUMhgKkK1r/UatfqDQhCjdirBdy/jrd2rZ5jSmyyRL5XBPzy1I6hyJVoIMXXLxuuyRTTMlUUFIOy0FEmqr02IhRVX3bd62f911V+lq+27O1Fta3VZjCs1VYyOHpYuhRZ4IettHWn4CSr6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmhiUaD3MNyoKz5QW3tbiWZ7xoPcw3KbDRlWby1uHwa6m4IwCwoBkAQjTESkxM8cQkwFgPjASAQMEEGMDAojwBAwCogCfxlLtNKBANMf4cysMUu2nkQqa6BQWZ6Ay31dvuy6AacwMAl1I5gkHlgDDgIJAKYoHKIagq+WnBYRl71cXnDLRBUMgImg0JI6xqHXadGbeJj5gIAbpp1gy7mlK7cqFiUZDHoH3L5Teb2Ex19mvthX1Yykkr7bd/K3POK6LccIzeqSu9PczaXOWGw0NHjawo0nELLLY3+7TU0rrTU1GrVNS5XI7FbktvVZ7uFWU01anrRanl+c7Oy2VRirSSyG4apbFW9NSaXyi5hXifNWscea3exu3tTOtfTXbGPMNYXMbH1aXXced+5Kvvds/l3f7/mW6fPX93rDWsOZczx3v+fh+v/72e8d/j3//93MejegDrmsazomEzIKAYexjTyYMK1uBpcoeDMeRnGNcKATF5XcOBt81uZpWqTwC7CjTwh7YeZXAHUjKPnRTa2strv04q9TSmh41SLh8E8ZJ3TePZmWoyLp9aUmMksuLP9FBJNnRly36JwONNm71O+urS6qnZlugpBda1oMzXRTWpVNJBVSnXqTpOkpGfZFNB0ukkxypeVLKCd7yT3c80P3I1L26qZz1iKnMAIAAwPQCzE0WNNrcLEwMgHjAKAQMCELswSAE2kCMEgSAgYbMS99FCjMF5FqMEApCwswtwRDMeOyPTmPtK5dGTAoAQNDgMgqYSBYQE1UDFBCKwi0yR1RECRYBuM3juEw1HB2TDQtuYKETkMPdmNvs5bQUQY9i/0pdGBnmdWIkzpPEpmEy1w7sityhlrFWtr/XrTTcESuHJyAIFjTGLVy/H5reWFjDF2LU7KWz1KWznGUnmszzwu/elndc1hGMqWzrUttympV1Zxw2+uE1nT3Xdl0Ny6p87Nzksu408NSKzSQNBUhqwintzExhT2rFipnP4WcZq1csYfhljnR5Y3rGGGOHMNdu4VtfYxqU/N77l3m9Z4Z9/DO13P/+t3aVZn29GIfJRMUE3IAAAAXd6zuPSSX4Oa5qw/8m5qiz3jKXtM6gaEsx69GOv03s3nbw1KZXSy5l9G86EyNcvZPg+XeRMIGW290Nsxr3N3sctRW7nWkkPVJieBKyOyzXUO9HSQLhsggiYmZ1RPUYsyZspFOcNll9Uwb5mXHX71P//62rqW1X7rUzvQUtSbrWtlKes3Utepk6dmqa6aJorTq+11vt/TopAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJoIdGA9zDcquHuTRvOFwlFfkaD28NylcfZRW8vXBR15oddpRUqgSGBUjycO4HKh7xkIcIOCRd4lBAFgQXMb5xaUkAhg6FnHQqjkYPBrWy+aEBo0bJoxWJs/leAMAwKDK63YMEBgx+GkJQXGBjEGpj2HRRtGgO0BPF6jD4DIS3GjAAPAgELvyVq7kOw020/jzVZ+YU2i6K8NNUBzVEYAjEonWuUkIzhh32VqHrDwxIW1aZDjcIInKk4nbKKsKkVLhWppfFc4BlkvjFNlKbGViBxr888DW43VnYanKkBU9BAlyc0+s52LzF7WVumt59txqZvRW1GY3PxvHs/UtyqtHnvtyiKW4EuYzt+3OVaPOf+mp7eVFdq3aS53eNjWfcbXzm4pn93t/Lte59DZ5X13m/x7l++Z1quV/vMbW7NjLD8fxt71zLHueXbe8N4VqvVlz+EyAAAABvfN4T5hWKEk8xgstoOD0PZU3ymhgBXhNkWfytPQ0KC0skoqDKlf5/5TYZsrx6CoE9n82zx7cZyMkZVDVRsjXOza5Yl+OUNOJUv5f2UxOkggGGi2uZbtZSHe+cmKTGn/cq3arU2NT+6wx7n25c+c/tNz/33POTXgmOJGyIhIHioouyGpImOMrJvFAyyTSgUWLF3g2H5WoOhxbXVBS72GV6DpOAlRdSfqhL9L5TQC4BpgDArGAMfWbZ4TBgfgUmAWAeYEAR5EFwl2OAXIcYdjEZZqisYZAnJVBhQOJGy8RkACogcYpGEh6ta4Wtsxpi/ZhIiu0BAAwQAU3AQgWhM/IJA9rFQoDK6ch02YgQCChmqNDZCcY2FNqtde614FghA9+5itLaWUNyoo0DdTtHcpJfDsQbNO7p7zOWANQhxpkHQzMReOwmcYRZp4NlszrHcdtand0bRq2VeYtUyyW+i71O/Ut3M5qxenqXC3rGvnG5fXwqSu/RUuU/V7nTUVypT2opZnbdzUauXZXZ7Vl921T0Eqn87Usna1XXcq2Vu5frbmsrWP9s37PM6ljDWv5Ws4/hYu41qutfrX8/Xc+a+/+fMN8/utd3ZrqoT1P9zuvd+EAAB/W8rsBEsaGeVPbZi1HrMHMq1Mqrtjio+5TU+FZ0UK2nZW8t5xXV66uV3q8EKTzz0ri8SNqSAhpkZ5PVyeEeZk1ZcIyJXfkYYkOgJ91G+MxbqrfxaNBnb82rh9uar/5xiDmJrGaz+2df/P8TVZ6iLanXT7WoU0XKpDCmLA7FLIgMPLQC5Vhoi8VqI6MWRo2Mf7FeLgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACaF9xoPbw3Kfy2lIaw1uJpoLGg9vDcpgLmUBrLW4u11ExgAYQgPiIHIwY0mTMlGeMDkEswHwEzBaAbFg+GTDIAA8DXEoBiTYFFxIBPcuwhPFAh3U+TAR8zIvHCZ732cR+oGQmBAIm4QgRhogJQxjIEDBELIYkB0kOiMGgt+F9v0IAcRD4KT05xgFJQExwIZPSJyLda8ijGpbD0MRq02GaY4Veuy20DwI7UNxVkznv/NMSo09XVadCZe2lWzA0Cyxb0Kmff25jcncZbNU1mxM9rXaP55sbQJ2NQBTX6Gln7FSgna8vmXyopmLVc34v3bc9nbytzsrjF/UXh/KghvOWymft4yuYv0ErgSgqzlqmmJVXl0EXsJqgpLVLdxtWK2E3q1nayzvc7dp9Z1Lnd3Nb7Scxsb3e/P8ruGeervM+4ZYbzzxv73u+o++bcgiNz2gkRRAAAAA7w3coXqEXsy46P23lY7p4oZzx5MtHECAFV9M9UWEeVpuW88MoPls7LlytWZpNuJTd49bq360BonRBcTCpE/EB/Ja+VhpfO6WkWkmxKgum6RkeNkGJY8qiw7j6J9I+mZmBfob2QQM0zaUV7dVyGjU99J1bqbZFSbatekz37pLXU9GqiuYpJpnoImiZQ+Ukd0BsZ02k0eUKsrrY2nQwFoSlKEowAgETAjBQML49M1aCCjBoAtFQEDBkBAMGABEaAKBgAIMAiX61yBYk3NME/eaMRAhkBbR0DAhMHfZi4y2tBIIHnEj1Lks3+QsMfE8BAFgAvDDdiT3LLevJjbTggGJRsOW0jwcEFgKBgKiono5UGPyXrTF3Zl7vUldyHiADH9jsDu4y1/2+e1mlHAjKZpsbE1X3mVQK3aAGWPpClDZRKI5RzFJLM7Gr8upfmJ/vz1+W1GayjdbVWN5wBGI92ho70boZJXjNSkjGepbZjdHYt1ccMpJZygmRW6SYvQNQTWc1SvHG78juYRyYoKGbhFLO4TGquFnGrSXaeileFS7nX5u9X/ktt1LnblT7+rV7eu3MMqu94d/uv3M26/1f3jbv/h3+Z5Z8y/XKgLhyHiIvH/WOW61K6QIrn6JN7ca43tqDYVP8+vSEIgfW91aFRJlUcf6xj2px+JjkektArBBqVV6xfTvs6v4lBrPG+o37lcap92qtlQbHG06aZuYkwFUyKRgaO44XecRMUTSeMy4cY4kbJVOgtBlosbVk31TqS0O6Lb0F/batHq7oLQ31oMt1LTXe91upNI+BDd7mJO+1PDNDkWZQZX+aGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmRhkcD3MNykCepVG3vXKb6IxoO8w3Kla4kwZytuIcWuyQu2AgGDA1AxMMYWI2/gsTC6BEMCgEYwKQKDATATVUXqVQGV5x6TR1chCLzKVZMugEdBS+R4CF9jDAiMKDcWE7s0r1wIndFQgLQy04tePBwwSAxUImMhE7L9s9j0eh1YqkU6BotoygYBr3CokWYFgJEGFogMAa069NPOvTu1RumTHa7DrixDUortFm3d7G7dBAz/PZOQt/XDgilp2YTNLBc9hnS509ahhM5hYs5ZU96ciEP45x/KmwvwBqxcxpaadpqtNW+k7Uq9p6t6pOSy1ascvPTGZVJ6TF/4dhMBT9HhKrsN5UeMKxpZVGIvORLmeOr9mrdq0NHhSZ41cc7OG8P5Wt01uvWwrYZXd1O48z/mGru7ue9ZY44b336/MO71/81/f/m89c1/7vIvjoiypAAAAA5nzOxF0AAacr0hh9q/bTwx+ubDWAmhrrFoKoL6IruPnO2d9EjF6IIFah5RKee4d6XpVdAxyydtSGMx8rb9zeVLi9991jRH0pi3+pMQNW9vj97Bx3076Su4NK4gYx9Qb+/pjev8+sQUCy55BZt0mnO5V0GT6yDnCyhpEyevUiKfm2DaKmUcJvcjlen+hxmWqLEAAjoNGAA1mDvCHB/GmGYqFAYhy1GM4ADwMphgQNm5QHDD/JUkIdM5QwMlZgIAuE1BHcwkCwIFyg1w+u99IILqoeGDAY10Eg1dw0fBECkfzB5NWu0YkBkMt7EUtEmhAKCgpIfNzXIFQwsC5TsJatOCA7D6uqansXXxgBj5gG57Y4df+XqbQcseM1ohOUUHvLNQ6pZTUll9YInWdSuMySMy+9Tz1rlLKqWiryyWcir7dgtv6HC1S08qgCV0kYjdiQ01+bm6DufMpfq5blsX7D+UfuZ2Y88mNP2dklZ35VGo3qapZbOalM5WkHJmtJGwx2L09zDU1Sdwxllq3D9jWFTue5/Vzd2ZlV6ze7hrHermGscauv7978ddxz/LXMs8s6ve5613l3DD8pnePMctfzP/uTjm9Y9u3HxGfDk1gy8tZ7uRNXeOGHLzmmVKPJwurI3wnxEGr+LVJu3KO3o/Hkll6KUPmjZO6aynnS4PGhySmnnhnMW6v1Hp6VTT325yztLIKMLlzkzc+fYVJcus6fOGyZxhq088om9G5e22X21G3b2MMBoqe7ZuZTmf3xf7LnbelD29xLZ+s/38cNZc97tqRIgwy0qoyPc+k+Eb+uI7TDx7cKuluT+NSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJN3lHA9x7cqIsuURnDW4mGfkcD28NymOe5VGsQXKlsLvL+GAKAKYDQHRhXhRmumP4YZYK5gZgkmDQBQYDAByl7XTAVA7FgDIH8pnNKgHMRxQu0nIOAFzVFRYJoJyoBGSOcsZjyl0aIQ2g+yNR0xCg3vCAUIAeYtAKjafipHsjckaiQiQeDy81MVOVJp9FyEx11rCDQGiKt8bZlfcTA6k+BNE2jH8S8kh7nQGSYCwoDWX0vBLqaYs5lpFiTqwjyMx5VHq+Y63hW7JK5w1ynlbSE3sBhn5RivCjvHNdt8RwexWtm1LDpXTNLeM8amCC4stWqNCgIXBUU8yJfNiFQYr1lfvWWLAfPF31vzxV0rLJx1B0/pEmg1W7xna8x2xSeW3pHi6eP4VY0HGNyZz/TOnmcQc4vi2ICkhfLgoQPwdCel8Nn6eqUAAAANc7y/eGQDxMceVu5W16fGf6uYP0FFJrW9vY3NIFYVr0pvXoxKbsiuuw2Q1hWZDats5psDNsPnBJKdkticqs1piMyrC6+mEosIMZD6SRqHkjoG5LkgyRfXTRUgoyPl65gsoTd00k3QWyi9UpRhP7rKjdmV0m6Vf+vWrW2pU27uy1PZR9upNTIVLRWqk6ktWgtebvRRCrBah2xOilu71IhiHnsYsPAAgYD4wnALTa2LOAQxBgLAeGC8BOYAQCbDmemAUAOJD8MPDebkQhIxXHZo4OI03YALgGXg5CDkA6vh6GZvajDAKsIkTtcZYZ4NmJFZaAwcJMTFGQNJGgBnMah5cxAQI1MLWGUXGhJD0oJVFWiITh4ojM2W8nXpqNniVKSNkUELBRJpDs2Zh4oOgCWSunhjNjzAmK00nrQzSwVFL8q+ewpakcpJQ+dJZtdtfLdXGwrdjP0dqej8plMsjd6rUllS3dmZRyWVMN5TErnaO3GLUvzm4YwnYhG5ifnbV9/puN0tNlheq2rU3Lpm7SZXJblJoRcucz7IbG9XLW6CArVzlnDC/Xz+tQ0OGNix+Oe8N442+feo+85vfLPa1jWt833C39A4Oe3HagCJviLDUgAAABlrnfrkAgNKN5KI/f+ordIPzuX4WCVN0kNqcU7h9xUYJv61mtNvXhAl0ENS9d6YVAkGOOi6QK4oYZAcgZk6RUjhkj5fLRA0mI1S2LB8mRbzZIwOGhalFNS1MdM1FUtIl1bmamWuip0WUyzzMf/THpzs0Vehz0dMglLmvtYVvKTKwgOIopeL1h+uUSKIT1T69pcIWpp0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACbaMRoPce3CR55lVaw9cJVIpHA9t7cpVHqVRrL1ydd1V9JKioBwIA9MFUfwzX2EzBnBGLOgYhIBBHF0VAhwFQmDT5M2qOqqUwWUjwYJMsgVPFDMQgwxAMi5oIHUWWi0taIcD2yt2DiXGUUjB5MMPA4v6DA+ZABLXSUDvw2GNO2IgEIB06i4GFgIFhgyBQjAxJRCSFYOHBtRR8FLzFfMbij1GECPhvGoOg3DjVxBywRoJ9l6jwqIEvA3VWyDqa1ezKKEtXkn0/bsRSjRx9KyFhcSuJXp+NGmVUePpoSsKAoYSpS+0Ljphvcn6sy80nmJkiJVlfKx6o3NdpZuXUZxPZaOQ5YnfQWJ+m2V44K9c2fX7qJBloztd2u/xjECixZXKK9qy5pnDhCY40Vtb41ok2d6zDrLPe8SNfFol7xpNQXm/bdtbn3Sma0f2/vrM2df5h7hfU+4AAD/N8zvLSPGxY/K3Wy/SBc7//tuIxRK+zexXil3OKc2O6t2YNjsurx4dBJO7UzVA5li+18G4ZiAOZ80HjEHXdsVikvU/vBzrD8fsl3jqaLDbLV9XtMT12/yxxoXvjOM69Mf5nkrT7/ziUOKeiXYept1SDiIpawHalNiqggWBoikihYhHJPaFOVxdZSjihN3/VDsIeNWxBOYAgDxgXhombmtsYBoHpgIgGmHQA0LAYK/vA0DIWBHGkUooYBKpIfJaBxIJBa50AZqASKAZIMDxYypuL4IBFU3JAoc3zczCiwyQOi4YJAk8DBMVD2us6o4BbGQkA8ENaSMSwBQ7VBpIlwjiywaFofcRhoRFEewomAIOS0wicsaYO1aHwuC0IOxp1ys7STkOQ/RAiTnS/ZWlgO9qcmpwcY0uWprWWeO9mhOa1Yx2De64tqIl2E4oF2p6uXmXB6/bnnbm6kNtVqmlYWWZ7BjHa5Ig7rsa7aX9I2nKqvgKZobW1wb48Nc5jWeq+MzQ8b1M9iZzOp4FovrS9NRLtudQdQI8ef7xbW96gXhV1WfGtS7tb/dvq+/qnxS1d4rjWae2t594k4QiAAAAMMeWuZMgN9gatUWbvLTMYv/NalBUgCY5F9PIGDRFLWf5c5am5yWPfNDgDOKeZSoZWNNRsrwip8GIdr9jhMI/H1XavrLGrvE1aEuSuO/08uzwbUxi+s0fbY3mHH01963TXx/NbVtf/17pzyb2CjFgDTsBBg0WaMDgUy6CLD6TRRgBKm14hZcne2Q62DT9thf/8qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAk1iMcD3HtyrkfJRG84XCVOLRwPae3CEBilkay9MGqQ1TxeWF2jAUBBNFpUEkAGYYYXIIq8YKl4iBGazjP8jCnxwYGo4ODQ6tt2wsETFoBScCwAGhzWjrlszT1VKYACpQA2JJNGQBSvktGFiIikCgDTNHiLWF2CMNEQsgRmz4q6TBCoEDEKCAIu4KA1r8PWRb1OqYackVx6l4IyM8MxDDIS5Vk8UDEQ9nmR5kn4P1CDfRJ7G8QqNGjHjGktNSSKunNwiViuNq7aDyc4MtY0JuvDP1RQW1jV2m2DPI4yS7f0baQD9o0Hir4dp0SqIVErk+0JLazn+tpp45ssi4wztsd+6cmPbGoVhjcWBgrDkzm1JMKnfZdbpmLe9I8sCXcXUk2savf2vpwtNEjbg43WJiXOIG871ql/qbO97jYpukO2beQEMFMgAAADuHcdYkIUZrMvfdRKtawRnaHhvDGmTyPtqVzvG4LozgFqVWVVJZdweumwgYu7FLK2m8kEJlfysSU5annAv37E26TzvXBjvYXKko+Q50ukyZfYic9WvaiPK+XzljuNr6aZoaussvz5d19jeHPv5Vc/7j//SWKmjyi6ziWCNVIggm4H86DZQAuGpj4cBUSihEXCxxoqAD5EBGU4HDITPjbmC8T2OUVferPfc5dG8k02VZA6AuAAxjMdVOMDYCICAHGE4BkEALLdcYRgeGrJzsvvPGyUDJjwUibkISCy28MSUWmOjDFlZU/bK0vFgU8RgcruCRGSBlgoWFQcXuDwDPkR3YdRpDC2jiUBwHmUMKB4KFGADGXQoBlgSZGsS3AI8ZmvakSRIIpCQNxzG0MMmRNW4lBK4xZmGwt7Kb0ckgJBKESrzPVicrCw8suZG+EqobIXxRPIkja8wgDocGG8aLAYnJURXCJCU6GsDzvLx/R0uWN/nyrhqWocFk06jNUqHssRdw1yp1lqs8hKRaONzvR62P40BtSMZehKKC/f3nxuRhperLWFEvu8eHaJFgsceks7+PjN9Z1bcBmmpChy1xm0tNUt7YhVrXGq0vbdrVtXH9/qs8XKFQAAABvD8NYsyMB4lmCvcvyZi93/qzYQmnAW59J2/ZlFd/N48xzxerDaegfSELJgB2QItPBBEJ1KsVJXSpjHMrY6G7x/rNcSB8QJdYdOGV1vNMSSYzvT5jeYiaaDygiWewyMxGEjyZDH3+xzbtEaYIV48oXNJBIyqW1N1s1ew5fZ+Kf6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJfYrHA9x7cq4o6TBvT1xkjiseD23typUxJVGsLbicrPG0RO0qAKAUGswSlwTA1A7MAcAkiErGgHYUzVqYOdaLb5RSlj7CDBkOMrgsKgpjzSzFgDeuLGDRdecWpDrBVLCEJCwDpiEAGHwQYaDxhYAiECmWQ8JBRnjX5Q+61omTFBukHuoIQPFlEhgSlADQdQtgl2IkvkSq8p9nGvKk0LOpbK43hdj7iqYcReSYq5C4jxPF+UQVpYGgnDKvPoV49oMeNAbp3FXIFfiHJSOprrEcnkN9O3H+3L6w5XkMhVQarU9XsGAzy0ZpWFlU0XTCoWbNXrcrkITsq+jHFlTpizRGuCpEo8gP4T2jfRTMUVzbbKGz+HD3msWG+xO2PKwHuHkkPcWJM7u35j2b4FrVx7xHk9IGKQ4VaYkh+XeoW7b3XcmJra1bdo+aZ3eNaDyn8/l2svk1+tWrcQWs95KHEvY43JlOwCXgcMdmBnQRilEOLl+hsRzKzKKtl9Vak6WvTYK5WIy8VcACNJpVPpVvsoC/Db0h5jQG+kCPH3vYJtltEZqu29D3u/BcqsusVftRvR5rW/1v3j6vH+ceWefXxmz60bWPb7pjVt41v+FbvtzU1PQ0f4niOJhuBT89D2QqGaw8pqcc2XzPfM8Fyd7jAYuhuv5w5r/+h3/vuv3qXR+HnJVuBgA5gKguGN8kQYOIEhCAaYNgIYYAEy12hQBMQmy2aarfaYn4YvyGIDy9X2tNDY7JRRTTzdyTM6l6zEdiIqjz+g4XBQaZYDIHBRJAR5Bt5ukVUJQRl+VMqR62RJjjQG04oMmMiQM3ePPKlDqQ5rmOgaipYRqC5pAfiwWR1jgMcij9OJdsBovUwTMno9ZSJc8mKrYwPHbHBhL0CJEcIimy8XMRbYWO7FdROWnJlYmtWquEbxqt15qPlhsh+dbbG2mXz5sZW+ivXKns53c5KOKoskFZBsqLryhgn5Dx8t9aN798r5HmD/XGN13BvBw1M8+9NmMagYxfw4+6QKd+8pu1/rV5JNxb+173pLa9dbzHtv2vfWNU1eaFe2b5xuepPaYAAAA7zPDOw/Z0lxEXdNaNzftgZL+t44xwJeRwldl0GCQDHFkTlbuNz8IV9RYdDV24MT/guiq5UKhzd5bZxyqzD+VYRapKmE+1NBtUAxKyI7y4oRI1vo6eLHI2xp55tR9nVMYbn9tNvlRtt+Gsi27Hw1lv4jZ7Y/m/uv7fNXzxczO65W2Vsdzz/7mTHzZ1aLWnIMWsQNaxxhyAKBjdNr7nXsfRdUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIioPIA7t7cpAHuWRnD1ym+i8cDvHtwlaxJZGcLbiAaO827eKjMIAHOgXHDG8MBAuMJxUWBd593INOG16xbOrEosItIwk/LnOC00iS3cecxIOKxvUpZi6DQZUEBjhKYpOGGBhl4CrSrYBniLQ62B3UkyqElyY/ekLpo7ioOPAQiA1vqwwuWO+24kermME/DgnwDTVA5tkHLozNbWqmlVPYrxKpBEzptFHbHW1ZmC/fvJltgbHu2twy9w+Wkifz+RqZMx1dqaZ9mREQWFt2sOUVuxCZ6WxI9gQIUC0NiiRHzZBozKRibV47nrkrW9xWlKerWpGal9bhw4rrEabwnskCvvfws106mgwW2+L2vjHmtu+fi+q6/i3tGpSN9/eM63WNrGd1x6Vz8R8hEwUS2sNIAAAAH563hK18HD0HGOBBlvnvUt+/h/6bmOTG2VrEPN7qvA8HZapvzu9+B3tYg7EdqW2Ni7AEFROYk26QFhkRypvSO1U6MxXmt8t550e1XW5d4gwa4v8xKxd/Ft/ec71fetf3+P6/Djol7RRIhZun1STUBY+bGHYsLCFiHGCpElii1DZHdL5PVSfTlbN2lWYsPw19digZgAARhaK52lTZniKJgyH5gCKYkAig0NkgAGYQtDV6YeR+iyhjMzHrUKYfB5EBEOwCBUregwmSgMj2Z0rAmlQC7xgsKFAIUuV4YfDRkUKJCAEGGPy2z1bkAUCSgwDWGrPtO3EmigYGgoolxAcS1TomOEqiqVMGOaaVVATJpMpMhCi2GMEbK0jzJLiDAPhSD/bzKQhD8JUsCHrxfmBiU0SynlfSNje2MEWRVRpn6cVkU/2yIZT1WQKaVCT2qnc64J4yR86XL5sRsrBDYJ1wz4jwYrYlGCza5szFDUEZiuwJhYP9XPZ8XS10itZWJdKhhY4R/2S7AyMtoD2V7HftsV+9o1x1e2vFy5uGIMbX1EnjZt6VeQ/FhYkj4rrzyajZrrGsZ+caxasC7+lPvWc2tqHebUNgAAAAb7+vydEwdx5WCI5ZyxvwV/P3yAS/I/yE3I26NrTG2gfqZ/93M4Yh2Jstj0em69nlZKOC5uO5fq9PzL1wJMU9ntY6zraGPyNho04qaxBuiigxluScdfTGvdfc/bb+m7fpSW7/pjKmu+Pi+Pn/ir49ld989WyIj6vrq39vv+5dMWuhPSmsPXqAJxDNBd7K9Xtu61AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACYuLRwO8e3KwbElEawtuZWYvHg5x7cKosiVRnC24kUpgJ61EhEBIJHIyv6oxPE5EkWEEIBpDVd0+YuIaI8CwxTwWKgQZLpjyVFYgFgElcEHB24EU5NHg9eaz0mFrXrqd5MOIOS4hgMJSNIqCTDgnEkOlbI4eThFAfF0xL0kjcRAgKL+AYJDAecpK+AKqbYizH1OvAB5QsqKFebgD9CxDhwIMtzkHSVh1FaxoFikPdPi7x1GmGaIjXs2I86v0xUZ3zclF1CJ29ZUapTrS6nUK5UsF0vvDeexkyq7uME61+0FVOmx6+etkOC7nTTIcKOYUPkouzfVKXQB43XDGoUxW7ttlNAvzkdbcwPW5hZnOfa0qkvFgqjb5++htkfczg3PplE+YIF/fc9q1riLKy1mmzajf5Ge3kgvbbxNPfUWfGK01Hi4lxnFJY2c71nONxODIgAAAC7l+s6jpmW2hC9kdDYz49LjWO9y1MDIjUWLO3MDRqOspSNAvVL+fajkz0XhETmG+huD2r2exFTSCZl/sKvM4VddlPF35NQ3VmmYBjYA01rHrFiA2l1USR3E8y1HpqHl02N3XbZu6b1UP7jUdBd5+z19vtqH/vu+d3/cW+GNh8Ty+Ia62/c1VVfLZ5m4fvpZbS9f0ZpKKA8Q2coc7lW+7koSH/nzPv52t0w99O6ojKJx516J5hAwOGh05UEDDhEGRQn+wR4VGguXi/nJFFHFkoqITM1RCB0FAYShERBdvlViwCTBpQUBUCh59maRhXBEOWiM6VpHRAW3ReMBkIFNeAYu548ExkHr3fZWB7YW6S1jBYGEgICReBgY+uM8uFa1i0qxKAB1T4fHODNDOOQmICQjVGepPCSKwcJd3bIrj9XSvQhafPUW02gUjwsKtKRY07MraIZKtQtsrarZGqe0VTLtEQXCG1mAq1IW9yVVtzxYtp3OV4qqOJK2dhev1Mri9F8hsbk0otvUDExLnminNLCwjC2PkU1YVTBqF3UGr2rLp7H3m+Nx22y5eQXKtpX76uINdvnsHLz4xmS1n181zqtZM+FJuJa2N+P7a1PmfFaSX9NWxbeN7iIgAAADe8sO3osCAh+dYOCa2PaFVWnw/P482QLOqQ4+kchEvT8UBoJNO0OdNFoHvW18vrWv3lx8v0DcZmvDefcNx6akSP1TK1Vz5wK5OCBuoVIUZuIJOqt65s5c5cPOVUO4jMVoZW/dXbZeybVOxUv+rZf7Obra2/7iK+T9v9lQxv59vy5m1ybrVlrph1VW9vvs3PtQkRAMiHYuKlAPCyXOQLUNoLKSOp/WOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjAfsgDvHtyoytZVGsobiTyKyAO7w3KgS7lkawtuoharxJ0UtgsEJhnPpg4H7Qy3CTMDR1fBg8GixEppVONydVWwx5GCQDGHgGFACUFdgUkQLMJGtGtpq3FzxGBngBQHcNkhYADKRYABYCpfGQwk2GISgWAiOqEcTf2/JmHQ+hoAAeXlVxBDZH4Va+0F6JdoGFA74vrOTNoSoOdabSHx19uMFEOdrwVywoQaazIcFpI9P3BxgwLW2o5KKeFRNrCMhdzVcJOQ4rlGZmdFp9hUSVgvY+IrVN2549tLm7FHXTxtgw1QpLKeVQLTfiM6hPcOmJUOLSkFMrHCLaaaG9yzq9zlkXoystEh6g7nnxi7nua7axS3xWTWX1ZIj/Mdvjblv6YtE/hUpqBXG4c5VumwMAkrEFBpNtMAAAAa53f4yoRWBZs6bv1v+2lRTZZ9wmkOhnRwM02JowWad4kFqmU/E/zl01jOQC9UOthehpGNNmyaS6lNz7t6l98E1Wb544pgpEYLGgBqoYaHQiHg+Fbgcg+rGjlu3hIL52d5siq5v44WhRB1/aTe0xv6DajT7/mO5qY5+ofpaGpfX+NsiHwrKCinODjGDkL5necEYVfmDMgB3wac5g1SlI10con38ZGkYAQBMWpHNeRPMCQ/MCADTMd+YgsdTW9fixEH0bZMU4FsB5bKWsAwELmsiYQY5IKvg5/4KeSgoUKFjP/F1fmMDoKAQaHmYGo0Lw87CCdnShUaXNWryyIPku0vKGJasDS1ZX0ikem1YoUh3l2URjLdhJ844SwNI67P2mu5IGfLrh3OYjccnXdh1+Ow3LqGvjT3blqCqszSyiW284jU3E5mYoJmrLsPjWc3IZ2ipL9mxZh+Lz9WdpKl6kqSyV40839uagWORKJboZfRxe3JX6ikkor2N63uxei8QqXNzvJRu7Zu0vL+dDjXobGHe81jy1X7l+dNYq5T9vDWH4SzWXO3N527WNXH+ZZYc7Tav4a7+sruscf1vHk73mOG/73Xcr4CHFAAAAD95Y6uyQU2IKUDz2ubwRmZpvuHzZUACPM2hU2u+H78Gqp8+xHebsQ3hTx2KJF0UuLuwvHF7I7fpId/XaDLcKeKfj0uRPZNHpcdvzgeVeWD1bCguz5002UuxkPt7mPY5Jl1/8x/1bNksiI5r5+O+nV/3N8NqIv6dczueyu7ZLGS+Iu1MI4KjASIscdKjBe5+HwOKEm1xC1KhFZ9fTUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI5IRIA7t7crOOSURvCG4iuh8gDu3typCvZVGsIbiOzHbL7tWCAKMbBPOFQjBoxmBQAwmISxu5UXRIDfnKo6rCiQNMiuzsB0rCWPgAFaUv6HjF04FQkXeVaMqnHeHRhuElZCXLMnEC+xWAGCpxdKQR8LhSsBWAvygzVj8YgBraVaBAGBJIByWiRyCVhCSUoEDUabvW+RbD9WjrMcXQ8kewm4jZ1nKgPRSNycPg0l0d0FihzzQXNqW72g+NiC4RbKh9G1I2uChWZVK5SsqqVTtthStT6B1ckt6fObPaC2vc5gMVIa03shwJx4wx3zx4qrw4jIw4VafkWGeLFlVkVrhQbyK2O4q+BCZYMPG49cVa3zNt7DknfLFImMe0aaL3kSPSFufOdUtneNbzWvrnFN2+LwP4AYIqYCQ1oDYAAAAHLeG6ld4ADNAagUUalPa3UUrJgZ41vtPgeSIsv2/BfJ5ZqKF5Vv35fHZZcjLsv3PSmOAYDzPSO0gzVSbzk74QFrX23zvzi4XAuwyE5RQNRKgFXJIhhMETgOWizSDkD4crOMGI6Cl07CPM27e0dM0vajuVgd16D1Zr0e7eiEb4ad1pIj0hJuckakxDbtSY7i5aVmr97LSobmL9N1iNdt+q4sZGQQ60itNKmgLnryq1jJh7ZBM4Q2BAEMOQyGxKMBg5LeQPJ5XTjC6q5y7TaPxUjQgMT9BRWFMsWH2zMiTRGEYahYccltENb8vLnKDs7n0vTKBdB0CCoqEGei6zn5Ehmszd9HVLeTs66QXCExi6RgwWAAR3YeIo4ly3vD1G/OYMuT1W1CIcTgXahul1JcnY6Tw2HIiTIPqHGT8qnco09p6y6bGtzy2t1av1UulCobrTRSZrZH6tkfMVHkazOkHKI2QHFKN57wNta9GZ7MKRg9OqCj1dJtgkuzNSEtryzbCcYEFcrtjbFiA7Vyhh3fXhUkjK5wzhNWvbNP9f6bc0eXva165pjD3OIEWtb+uqYvuuMQ84tLuuIedUrjV/recat/K3K8dxEABgAfjrPDtEFZg3EScbbHPLyqVTjDdzcYaqSFXTDkPEyZLIoCXmoX2pVx1I5ttqemgILhuQ7IXDt1Xzwo3plU33PdWOwhqbvy+qSSEYjg6D4D2J1NcOglsbJAdBQPr0WzjOGW4qy1OR15lf/3S+b/mOk9Ynq/qovWXr97SJqvK/tF1744mKl1lB8yMaCJp6Bx9cgTaRY+OY/bPANnY4HC9OtVYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACIh/yIObe3KsK9lUayhuok4TIg5t7cpWHmWRjL1wrTssh+GJGXkMPtk9SHDDwLBQcgmWP2+wgNzNgZ2afTywQ24gJDqDNKqwqJWBOJ6gsSG0mI0Dy2C4ch7OkBwVK5Qh6s4EAIAAXTMRNl+SkWF2BSqCeioDLpqCkvmWQSnkFBlr6+ErQnzKxD4ORrh4zOcBmktBkDoOwkrSSEfR2LscbGjlaq9p9lblcXhgpGu7hacGBnuno3bVuZkkvR4nI7/Css/Y7vFyxo5+wUn1WLaHBq9iNy2zwoLcunyNhUgQ5VPEXLxXmnBUqr2zOeVZHhxH7g1YYbTO3j+ssZ7AmjwK3e7h2rBxR/qLD3ET9IWoF9SwpqajQbVtiBb+S3k34O4cmf9UxWMpQJSDT0peObwDJAAAAG8P1vUdAIwPUqPO9S4fmslvbP2uTT6gxMDpwNJXpfp36adBREUr8pd0cpdixNTCuHRp24orUXXkqz85bf7DtXGLv4wxGydfECZIhC+HAed1MB0QKBlyxajgah2SQwx7i9YL6IHuePHNRFTfVTKUmkRzfxNtzxfxdzMzbeZEKZFcUhVS9Pf89NP7WpedrEYiPmgYbeoabk2gmtIZAyFUVhweSOi1l+mi5McnakNvAquDAwYFyZl1BGGAcHHRf8Jn5tAw2IDJgCQQNTyOHRCJHhjssbIPBL8wFDLLzLFxqDGaGH5C0iQhQPXVBEBkQQKFjrlzDARUmHGqoYEAE2B26ZaKWediYaNDDW2VhAUmUHtyLsgFlMDr02s6JbF0YYjZOgPxHCcOjQLoG+q0Q+YUG1yUT1HT5NXrBwxwsNtXzLqsWPWOu0OcH26RG+Y/pF5g7VZUrmLdWOErqLBaZ3bS5pddwob2LDeuquMKGuYa/WR/s9jmeQI+LN7Fvc+ozfhVKpqiUvE+bxtN3u3Q3UPdNSYrFit/mpb4vApT7t9YjV9b03aHe2NwLRY2NQdbriHXMtfH1E0tRDBbhjp0QAAAB/OaxrR0giDox6LWdf2P26XWvtw8g2cID2SBGr/sTQ4HE7mFSrz3DqbqMrGlBQAJurcpcubVm7hvN1atltYhmw1VU/KaeI7N/F8GBiKy7U+4MNqq91BkzW+MYtfUu4cWbVa7x6218TgMOD1SQouyfco4t95PBcwADlagkZCw8g6urHm11nw304uc71FUsHb2K+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlQjEeDu3twlqupZE8IbiUqLyAO7e3CbJ6lkZxJcIk/OVLB6joJAgQPqeKHkYCisYmAGW2U1hyyFwA3VHcJ/VMp/cCuEfYbLNUTVygLaK3ZboCegyAHgZujEG7vxOS0WH1Bi3CYIAMQsGA0BJAY0YGS8HAFNBBLBdM+KQ0UzcN/lnFAAW8QMb8ci2do6EQpElBYkEo4zi3EqIt+CqFnGauIiFJFJGQUNlIjLHPHlJig312aeFHjM+m+Bm/gPVVGPbKmQ6OynG2o2Bd/FUZ+PGltUsZjfvXiGxHh3p1Jv46uZns6OlXmaAqzkN9ngTPYLga8Ix1M8YX7tDjfg5TD+dnlop0CXPceZmj2iQ2CaNGYkezUa7x6RrMUBwkd1piFa8We+JYytxDbtX1ij+Dm1MvGvcKlq59dv4fli08GBAhal3dwkmm8CPpwAAAALNUjO7AnsGHIATiO8ARCxUx+5xVUI7Mv8/Evq9dprjH5bU32irNxn+/gvGDIPU1lG3WrUePaWQ/ugoYcb+YZXDw1buICH8fakCoxCREE8PN1QuYkRNRaSMc+HflaXuXpLu7p79oH2//99x69Ss/PGjcVddxSXpH/QyJWRrRgWcVMBudS4c9YT6tJEAOr1O0L29VUrbND7XFMy1BgWCJjkNB7oS4KLYwNA9tJS6cymWY4yFAg6jQZDNP+lId7bD0aCQNAfFkFFGUwhFAkzouRUDkNkikYh4eM37eamMJGgcss3AoUFDceCwcDPs/jBHmdgKBa/6V/216kVGQSOK5YXEJIiDDcV0QdbcVdFguhohzE6JcJMPQjVUdYkwtrWhpfDwmuwRVWyPou4DSrIa7r4FVqNDgRI6uVLg7eMbjC0lUZARTHPGTaGQGxC2l+t+HHiIuDDUSGNr5/AVM7lWGnEyiFK1Gmxmi6Ua7MOCerPGbmXsapguT5phw6VVkK8fFdLV6wYjFDcpnG6xuNuFChO22kTNX8jr6m3e2HFZh0p4WsNU7zXpAharqudyQc2vLiNvN583va1JYOsy6XKAAAAN4dx1jNDD5yFM8b21j3T4Oj+GfdZPsa0T8NNmxhyxFR1kDWLu7mOpXFs7kVGSGgSAhYFQLQxDQrH2RSZNBNEdhVEFQ48vOQQvG6Q+jNzFJFcwK7olEnzdE4xeOLJzUYJ0WZFA3M1Ip3oq11mzUCQUFy55qT9iXgo4y7S4igVpgIJNMINCpclDNp9ohT7BBXkD2jX6HN+qkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJQojIA7t7cqYsGVRvC24iyiUiDm3tykybZZGcPXCkda3JIBUeBgAmEZ5HDLXhgwmIoHBgCqmeF3lymJt7axNQJ5bVgABpolWdEFLYL9JHOA9LXgQLnMCziMyYY3Jw8lpmHAFA8DzluTBSowYUUoC4IDmsIIGxMsfCSv8/aFUDxegXsrcpeIQIMMzgYxgKg8TxYg4pmJ+tnOajEi0JJBQpR8KEudyWq5jGC9QyErlPZXLEFny2QcPnzDAfYmYKoXZiWLL5ypdtRMFPqhuY1Y5F5Ujgzq5PI6FAitqIW3N5AeRVOwwjoXO4UeVUOTChS4dOKGsiHPWhILbgnYTPKuYFm9wX2eG9VEOE1biej2BFeuT9vyxPMw7Qb3fwIG/iK8rFnjwtS2xWjbm8WS96wawM/flc9X1/maJqFAtSsDPpq+HkENBglsgAAAAfhnhnSRcCBxSWrOj9bHmc0hwkEs13GaXaEhDmP7DfYzRZFQx1HLs+5SPOy6tv5c6NluUOwA4jtwRJ88MrE7hYq5P/DUtScCJUaDqJMm4em7UzrlFFU0R+fbDBdFybmzZ9qnqNVOWpGyo2eya5ZXTYrcy5++v//5Z9sp9fPDXU+X11P/s5idk129eGmVua8FDJRCh59MDXwo+ZxE4jHbhBn101t4xt9GVkIAMSrc9T4jBQWFhgv53Yjx5jKCEHNaAtstJavDQEFjkfRB4JQkOE8K0EP1EjF01hSesmY+/0/EhUMVxEptgaN5EKhAOggKK9MdL5blM2Brr/l/X/3OwlbssSGMMDQGM/jGH+uhuN4wDrHHBU9op4uWSEjyHrMtUIQiU4hZ2OSfV6vi3ZrrnLgyRn3ckKUbqCyRGpsOR+npoc0VcTISq7ppmPyC4biqCSKqYrXW7UhCscNQqwl1ZOnHqdSaohtMvla/Ti6YavVZu6xJNBgp+j99BcUhBkbpJ1cxoStfb303aFrUasF0s11e0j6Na+cvvm1/TVNWzrFaXlvS+N/WYVbRdY9K+ufXHnxbV58Q8r2GsgAAADeu4buRMsbEttti1m/j2OiEdnC5vuTBlHkwfi/atPQRczynLefcuS58Ln4s53P25JHehyIaayx6NkXW6sUYsA7zEmVS1MyQXl48C2bVziz1sbKS2bcRb/GNZ3a+rVs+ytxkDhcKBtp8NiECBwy78coTOYJjLnAcJMFHZgq5wWSStLtelBg6gkW9NDkUcud6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACJaFSIO6e3KZi1lkawhupjIbIA7vDcornqXRnDFwoYxlWrypxjBIZTiJrzAYSWWuBEIddt/iWwPekQ3HjUvj6+QuoM9ZUyWiJEmcOQsIKATDVTlhWJJqQS+tNSqLBcLDzQGGwGCAyTSvhAXHpy0VBYOia53pYijFXux9PZOYiBRkE2S4uJez0ZiAsws4tkE+z8b3yeP0qT8TBWBBW5Hw1UfiGSNi3TFt5cNxoO22Il2fV5cZiofAVDnTDKrIjU9Y4rt/O9TKWkgP70VkaE8V6ZWHr5CkbhS1QKt7PFc2FTQHWFQwq5LO3FgnMjLIfq6RucYgVgtd5sNji8hT+JfVYD6Nur/GpJWZ7Es2X3Li8kC3tBnxPBxqBXNLam+d/6zXe72xrdN3xb1j4hxQZw9B310QAAABjr8+dvDJ44pSJutZy3qbCxVR0+94/DKlR7HJ4ApKavTM/KuXVl/LM5uI1pXluQ0zSJ9uCsjmwBcwqZVsoE5lTUsfchuYdh4A8PQ8h8sPGEc+xZ4GFkyGxTpCh+ss1TCowulFXKVF1cInSrcXPxfU/3XXXd/LLN5vX+kVWyNffxsNckYA1QjYbqaR0pV115dEUb+8zWTwuU9A7a7B0ATBgGDcWvDK8TH7ZlXmnmaCYKdHEhaba9o3TPWwVJ8112LegoDWo5TFmShAMz43EKWcQAaUKQD0xKlEIc/dl51NDARwwULReBIUCRgIFXteWYjDesjCwWkm9Una2uZo5e4WkXmXRGE2GgpvR1oqDq0JZMOpBETjtCqRfbLSYaeDfuLZY2kc8rqX4Arz9JDtLKJ52o3vdeE347Lca8crwQ/8Rprkrv6n30l9uMxyN09I9T9+70h5MV7sVk+cRsTcKsvpNS97bcV9+pJDs66cUnNV8YRK/3TP5dZPbgaXqcwxRTti/jYs5RSkgOe1TVKC/nKKfGU1sMM7Vy/lnnO0f45UuFW3nzC5jhc1W1j3l2zn9blXLD+dwubuffvXtb3cwqazz+z5OHFaAqmgAAABrvM8M4hFzxLUskFr9duQ2UCzsd1qGlcmGzmvk9tDjbj6ElrFFWsTvcN9ytPoYaMDNBHMcqMa7fkaiGrzLgGUpoN1Cla12rUlq2mmUbSPnl1lKPJPpu0nKzTWJyd2Z+99nLxhE4AnQGirFdTxM46ICT6yZk05AkAzBLZpMlwpbTI1d1P/yP9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlCisgD23tyrktpVFMPbiXSLyIO6w3Kha6lkae1uLU1EH3dBaYgAQBgPZhDI1mJkCAYDQAKgSmrRpTDw6FnNiCAxglLWvoMFUHASCGKDPhYSYyylyi+ghATkBUoHwgLc92YhIJWqgGBb9Rcqgie5MXlYONAYFQVFZLLnWYBB7uMxMABKKZaDE59gpBQqg6RIA7FIRkrz/JYPcnhfV05rgyk0rCThlEC0O00WhPm0SVZitcV7pmhRKouSJdjVD6kR8yQ2B4zMsy4hKqLSE/8ryh3QZ1mdONavUkZkVaKa8KlSyPEuprqR/8My0QhveUjuD1Rm6n5XC8aycczwXlwj1K4Srrt8d9SDBm3D06uzzxq1bIkCSE6fxZd6ap4+4kfEaaWPjUeFT4+Ycdss6cIMClKWiz3t7fc/vAkvS8W9cXf0m98YnJj4wAAAAtTIcmgPUsBCFIsifbQNhYxlZ7lbmlln5q1YNmq0am3TgIKBnqW5dsVbt6/esvqz9t1/r9bVk0gltjGkv1oz394QC4bCwAUzeZcNbTbBGXN5eWetobpGMMJ21TV1ebxppb53a8a1r1vJbeKUzue+d5i/X+vjNsY/995/+r/eda+sU9NfcDf+/nec/7zrerxaijg2cOTrxOeQG9z7sJC5kLblFhupo588h6euryQRt5FTlnB4SzcjFjPokzDkFgwCVTTrrOCh+eYQVQcHvxnJJtYU1EoEkUJJcZULgA4ONEx4KZ3EccuKA2VN/Uh1/YGS2dvNiy6DCCV4JPAAuRjX+dd024RZTB+GjMZa+zd6pUhtOukIxNpBsOutB0sf5nK8V7zz68h6LvCyl9VOFb0RlYYBcVZzObMri0qrSe9zHG1a+9yB4c5Um6eALN6UReB4Fnq0Zl8qpJmHIvMPvAcWlT6xO3L9257OWagKKS6ipe0WND1uu69ulmJybkkYpKOWw1N5y/lvGX3qGFROJxOc3Ip+zut2rbrUu43fv08/hnJc+z2f6yosaCnr0/yrG3X1XoMb8zTUn2O3vxy5c/uVJlndv5U13K/zv9x/Les9bz/DK73LPKv2riMJAAAAH4bwzpJWwA6sAFTpblzLdzCBgq2maQYK5IESwpjIVkZCEqcgV4RbbEct2pPDjR2/mCI2Xou4QY1Itr2vPNEiTQ1yoCcO0E6DjJdMcxQUZIjIWtJ0WSUYFpEMHUTzJNGaKU1JkGTdroI0000krUK06l0Xprq9FB7W+9Pa6dkqlsj1I3Um7MgciRM8gXEDKLNZSvAdw84saZUp3u6d60gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJV4tIA9t7cLTLuVRvDW4lPikiDu8NynkpZZGsIXjDH6SG1hC25gMAYGJ2i4Y64HpgXgFEwBDLnJjLtiMCMbiDVQFFuGaaih5D5JYxw4BQGRAbT1kmECLruy95qMsaWKo5TODXnu4+wcDQO8Kdid5gBmYYGhhSY2JGmiZMIxFiTwxl9LF1TZdUS1Oj7F3bAFIATgUD8ZFoE+nzSPBRnaMhHtzO/Li4CymgCUJMu1A1tqkYWhNP3j6Awn40ZZIDxSsLAvKVsn6JjrcrbDgQlQ1yzIhIMsKyNczzTOZm1+pGxZnpCcJFpQWodShe3UDBCdN+m8kKvcaJKAxO4Ekx9r0BS9sTK3Wr+FO/+YjIzXSrhAfOtMjNiDmHBvjM8KKrX2GyNBjamzqRdt0GeHjMKk8DN60le03e/1jW8WpR7ilL482cekXEd9FvMEgAAAD8dfvGtApl3WYcAK5jVLljMxAK2WvTY5Y1VN3lBwolPQbff6oxpYq2n3s1Pmrd21KO3XacVqLT7SgaeL0W7Nupre3tu4atEskVCEBXx0JUzYlymbDipl9BbLSWbmA90STWbsiS55a2SlZ41TWtTmC9FBBkUakmZHRQMtSF1tup/UpSdak0bLuu6aC0d0mUprqRRc0JrBoPMMCcNQsXcLMOJODGl4mBIosESrU2hj+ijG09yxbhiC07AaDJjBGRsuKgjBFK5XsFPrpRtUwt5tfjUtqM9R0IQ8wsWMSKFIrvXaQgzqiQQBA0lCTtQkEgbmR+kfOLXm4iwO1qYhZKAmHAIGAQECiETMNH0K4JiTGpS8kdZ+XrlMqwba/GV4JdEBRJcCNxTOgGVOm+7jyGhguYgCHYu7UgfNrrhJnLAVp59pDD2Vyh7csfZxpZVPzkMbwk05M1Y0/GNfLOQTcosW8u2Jc7sVsO+3TD69SdisZrzMuq0VmWSyKdtS6R0EaiMzROPvOIWb0M/RRukt1pfXl0omKavVgqmmJdfwr2c71yip62GF/DC1lP27GPOXMMN3KX7FnLPGmrcuXqXDljHl7nKk929a3zWNTPu8vxz3rmess/73D98/H7+9w2wAAABv9Z/3i0gLlE4HK3/+M8FzE2/w/kAw+3ZKwFjxppqnjVaGGQLsnZz8Zd/LciuT03bjzIqeKoiCKKwIbKIUiw9hc8k8KA3AeAYwkeOsPBwg9o8sOFTmPFQ6RdKry7ajxyNCWrRGeMyVimm647tuZtPr4/7+PvqKyZFo0oGJAs2JTgaQy9wsPPqKoJXqWtTKAvWSz5xzmC1WyxNigAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJZIhIg7rDcpKmWXRrD1wiPgkkDuntynUppdG3tXiU418pXcVRBgQGGcXHmTcGMwPkQJMFbhGHYUxfE1TBEipIaeVLIEY0aUmiorDo5rmRpZsGAWXmCFGmxnhMxhoLcnRg2ROWhiptFLbdUMBCOFk5kQhgg5jHRQVcVmzeLqstfQxUQbPNVYLdCYUMYqXYDFu1EHZbpInxYyXtVQirvtzhM5SRyGXewpVkQhw4vhBbxVpRTXd4fYh6xEaeLVp2TU1Dd3RSrcpt8htzaehgCmxt6mI3TOxFbkxbxu50sy/UnicEVq8KsdjsMSiQxZ2nc5aiFmFtZf+IxG3SxujnpNAUkoc7sOQXUgOxbtwjVmkq5TmfMKWmzz+rTYV8dc1dtYYZVcrVrG5vG/a+p25laxqY8ww5lP/h+OOfLOee7eFnuvuZY81967kFQbCWwAAAB+G+dwzxC9MHgYcz7vf3WuLms/nqRxN2VhzWSZo69PgxKXTIqHnMd46w1BXrQ1bDTJ0qEfQGuV8mb7ezRmJkljQm58yPTlOPbg9fYeZXn9tNV76zrWcQMyTbjHAADogCKgKWcSChwiGaCDUjItag2WA1EWEoASC0sSAaj14hiyjZMDWrc9rbX8U1It79f/RBFe/LI07C/0aAcq5slX5iyEgYBIkBTDY5EUOiMpjzRsgDHaeWyCxBiE8xiMwYoRiS+gQFiAUFkoNGFmJLSTMiiv5RAtNVf9P9dDdWpOAmSQngMKS8QBABWCl8GzrN3ZkbVHSYU7kjclXpxORDgjQEct5D28+BviMCwvR+muXs6n6w8Vzb1EyoltuyG60fDfVrvaHWG1sDEweM/acTuLY+iXO8z5YLuVhbn82m1l1CdRlfDkWn0y8+hs79jT8lIckBtfs7G7cLxm3SHo54rpE9lubHh6x7xIkWzvUz9yY3VG+D9xoPfbtmJnNosKl8Twmy7M20xjOP4Pn1nW76vfcS9KYtNf5iV39/EHMQOV1lOEn7hAAAAGt91/9ekRQJnY240pnrjcpAjLdW/TqkWQ/iQDMgJ9mlLGqVCDNKxHw2LPrd7E1K3NbcNM4SDhMAF88TjJy0oIl0LyOc3RQNh+iTCZEcvjLYzQWcYvHjyBzWcYwSUyz7o1OeY6mt6jOhai6lM71pqR1pOj+p/Wj1MtD00Vn0DjqAkiRCjpCgiIgICh/q2zQrQ2RTqFHMr93oSkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACY6KSIPbw3KVK8l0behuJZ4dJA7rDcpKGyYRh71ypudkEWchC8wDAJDBiCRMT9RQxRgeiQAUEgAJEuE3j/t0C4cHgqNkYmKzAkdk+g4VMeUS06qrJSYJBRkDgEMD3ZBgwZ2Cp8NfwaW/1Z9VDVg01E4JQ4xgA2XeLJhYMXUZ6YI8uylxHmtvPMN0QRKrv/AM9OypsrupGh1EI3LcOGaOOyNkbfKHO5mzWUzMim5ZOvZVg1xoNgLHk/RUmfJTJZdampbjK8e3pynq4yyZl8sfTGrRT927EpZC78P0c9jEe3IxXt8sVuvNGY7cuSCTTH01+eudiOGMbiUtxuQdIbU9D0HyqxKYzaoJ2H4EpaWvSc5nyNzNS9fp5/HfaS5nvCxb5Kr2FPb1jh+VvnLl77ufL2eVXtXG9hhf3Yz7h25u3l3t7Wsbuql/7G7HMa1zK/eZgAAAAbz/PDOYZGYcgi4krXLe4/jL4FzJm+IcBDDmDMA5l83CUYaDHs3B6iKVCt3NTGMP3B5t4iYNH8I4YEPsOtd64hEEAqMg4aKqC0A4Lz0kVQigdF7u75qh0sMaq2ozm34p44/Rvix1evr79///3d8a1ET3LzO9J/V/9JURdZ5F6UkkNBec7Im7NDFVGlLIV0aN+lHM85RDbSAuAZg4RhgwVxoy3Z50PgKEMHAY7j/vY+wCDCgA3tA4A5pscpVG40qqucwh0yxMFLzAkkpAUHiBcgSEjJAwy03iE14lo0ExKo+d6lgRuMErUWM382IwqhiwBjSRx3JmTIkPgSArcufyEShIxlDyVo5SRiONHBC1Ugwi5m0f9y60uXkqZPiFSnK1KInB9PDUzDMVneUlJH5TlEH4ndR2L1eWrNZ/rfJ/WdHY7lFYlAMq7L5C/0qm4HsTc5bpJTM2JJF/lV6djOUzXr1KaHpRKpPPxqnmJL+qeeq0NLKJqI0URnLnKDPWcVvV43frfSW9Z1I5hS191qt7HG/ljjOWKn5au45bzq556/KrO95nzWFFrvb9m/fxqYVKmv7vHXea3nzf2seVSgpJkAAAAY2+Z4Z0j/hyC0yF9JelO1qeCI3DtWSkRELKRBeNSdX2RkeJI/gvAgY64U2cx6aePfFX2JNpI4XEjIRwyIlY7XCbI2DwxTxaY2nUMQufH1T6hxH7JWvz7WvXOt63ePRQqWcgHXuAjix8HDjfi7xRaiJYaPFktY9hJB4AGRg8KWgFgsdFh5IpTv9b/tnXavoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlHhcmD2sNyjGcJlGcMXKLGISgO6e3KWhrmUZe9cK1qkh92FAwAAcYB4AZgYhBGCIJeaLgchhAAUEwCbtNPiElkawr/mojkx6DpfRQHGl6rPTeBrYygZ0hYgglf4wIdGd4kZDM8DUBAwJdn43K2hyyJsRR/kUPwYzUYCiIejESEQM5M2WATief+Yg1lspeCD2WtMhiMz1Jpr7cWsmkRfByW4MUiT3M4fpL1iim9HPR+phP8wiMXlVamebtSpRxupjfwyrTUzLH9o7O5+7nNz1qGo72WS+tZywlM5hXvYy2joK8Wid6N8uUE5LcK1mkylz+VpmGJZLKXOmryuUz0rsWKmFmxLaecltJu3Z3TT1WjsU9/X4a593tzLOl3y7ezoLFe5SXM6evhvtJz8dfYxy/WGGGdPzXcdfznNcvd/+9/HtsskUXpHNgAAADfMf//mzDIPrgWbllrmW6tFQNWrc/k1Nw5F4Bsyyhlrp15JZnIW3cQIUsk3dXQrc9Y+T+lJC+LgRIAUkeGG50+keEYpnjHWaotw/hiy8dWPxqFIeds70zX8y37+RUJDWRGQFtTQjoz9ozQkYIYyfmGOFEip9TTBo65i+pqi70MQre12/vlX/TlrsvsZ3pWqgYEiUYBg0OEodz1qYrh2TAEx19pA5jMnEWaInh2T6B8ar02b7U63SEMYVSXbXYmOKCguGSFT5IAaEo0bgEKQhfDEButTSC/nH1NUr3ycOC2XsRQwQ7KXmCKm1Sjwdu7L0LgOKSajuGiYRLIulY3H2yhCg5gwTDSQ/TDRKw2PxJQ4DdLG3rTXiLBvWCq3byqm08wpITx4ywIbezUV1mxNPnHe4eWu15Eep1faZzfztUfbZSM8gbXoMsZxiM8zG8ht9rKVHMDVVXXb9rMNtR9FKha3WFGwy2vl/H25wJ4mIkrVSloEDcDMHd4FXkZ3a9c6tWPWW2vfF91+I2qWxjUDWYeP/92zCpjNsZ/xuRIXoF5gAAAD954dwp2AMNOfwfef+lcY13TILnHviBH1tCms9YEBaWmyZ4uUSbAWYBQlWe7E4YzCcHjlLEjKFJRkYOYIMdisYK4fTzQ4ynkiUpi+oqlZY0CrPGjzy4ftF6Urrfr9Q9ga5bCwhBwqUBY+xyiZCZepwYaRefA02EAsVbl7x9bigIuWsPKRc1b0AlFz6WbtDlv9TfUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIqoHKA7p7cpnLmaRp7W6mhgkmD2sNyqmt5lGntbrD86kNvU3hiMGKmRgASZkPWJvSIJhqEKwztylItn0+sOMChk4cU2xf6aZi88pq6IoJMsbNWDLx1UalaE4EUc3dMmCNHAMOhBzSzGozdtNNbhEmwoBFcRp5U1EbRALHgqHgIEgISGN2wnaug2Vh3RX4DqRgNQSBIPCUJpD1GqQlwZYN4lSUbS3sx6GWcpOnyMamSHDywP6tF3jgwSwWKsGJNlLSJx2uFejnNubXCVnzLAbz5WXijZG7wKPVQuZmGSG+cYbtiYH7K4xnqOessOrM5Ma7tSJnO30ZBNzErGeaG8u2Sr8t86vrcZyj+rBPeHPf4taR5/6xcUhW3q2dywJvJmekDO8+b01nzWzqm5shgnBSec3umgAAABrL8v1Qv+KgFLx86up7Z69ukJ4QEHqmlvVrzxcxawC7FgcNIija4t+CegYQP46K4rjs+54rPeLAc5zAcJxFhCwMgOw0Mk3SKNiRJhQWhU6CCRNPEBE+ZpIIUzVFboLdjVZdSs3VVooVso+9nPIO/t2+7V1L1XrdaDrs6k/stNbGIJsEZS1NLw6Ag69Fhd/MX+xm25n2Dq2euXaEwCwSTAMAlMAYAswWgWzBUESNFQk4wzAhg4E0KgCLBsVGhTjPSukFChCgOKpRLnaNxJ6Yf9FZuYEWmIdGqKDpMsBEejIHxkMgBLylsDNhjUXTJkhYa//Xmla7q1aAlxokF42L1lisNSBsq/CyU5TVUNrQUMaPQQZD7+8e5RwvKIAJfMouvNHJbrJnLlRll0M1lhXYeBx480aFO7EILht462uxqcjUR7DdHrkJtW6W8/sOSGH7dLUl0VkMgpfnsKWPy+jnuVqbcO005TRupnuH5FNWbkX3LpuC4xMVpt/bvxDb/zdn6li5G6WV1rWMoqU0pjshjkkntXMZfF7dyrZrdrVrlJfzlt7du5umpscOferawxt1Nc/uOrmOsKnP/+9x1nhjqrjcvzmA5bQClT9TMgAAAD9/3mdyDEphAzOOkO+/Gi8OSuq7XS8pC8huOcaLmkRy683ohCh4s62rJyDiaDhNVDxwgNrMs7xlcQo9YqYjRYji1Q4ikipMTgElC5BeCYXB2FJE3JEYUYRzpmkgmlWXkD54rRTYxMqi8fZM6bonDetk7d11rZZmbqQZVkE00v+6al3st9KrdP17fsZqEhxYSHLCSGhg4g8UbFzyO6gsq5iS461yu/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACWuJSgPaw3Ktp2mUa1hcJNXtKA9rDcpVGWaRrb1wm7eX8aKYDoDBgHgDGAUACYBIMhhYhYGMypcZjgbBhLAEF+0Px48tBxLi+YQhzIVxsR79V3Hct5469kZYK5Rjx5uSqB6FKuBgGVRCmaqUYQFmMbnOqhm9uK4ow3B7ZbDDey12yUEQgWLNmfZy2kteUm4qIJqabDGZwCgmJ76PusBUWEL+gRYQEHPd9nc9LJNMS2xTQU3d+IQ9UNR+Gsoxhp+sLU5HKX+SqV15dMwH2PUlyU/nIozDsmrTMiib4dq6l8zXzwpY5lYnt25ZTSmK3Nye3+PbV6YpOwK/25Nqpeypb8AQNL4pCqKiiO71izUt0/a1fde/dxy7asUli5/e9mLdb7dj7eP7x3nnq7a7jh++Zfz88LmOstZdtYat3OY6/v3vw1fz/9d1hjhdez2AAAAKlPrP6/HlojFATEhztbAGDXRN4WY58+wKTmDCNHkWV3v8p8bN6NLBOX9i46bZHxX6yN7qcKDL1wPfpY93V6pPZRmNYXZXBjlQDFLq/S7qcKlkQjHKlq3etzLoS6WUlJvWP61rC3SYWP7hrl2W4W6Sc1/73lW4arChOEgsLXO2QZUHmilBgGxE2PKnAeeUKPuHWAqcFyilKkjypEuKNIsllPY2kFm0FKFsmeVrf1SwAMEANMlMAEAIwFAkzAaAHMKwg40Gz5zFLCJAgCC9GcoT0PwgIkYw5iwFACkJK+MP7A9PRM/jLtOGXhQRAcfD6hSgMtWYl6HQmfmHAjw9Ck2Bs4akBJ18WMW3fWVx+HC2QBBJbhABxGaVGD0E4hJS0C5A4wot+mQszdZrDdGwrzaE7KKo0Au21vN9HyznJLJZHKofe5+IxCL9/czSxmmtvLA8sjE7atW85jkUmbl7VbC7hhVpZDN0FelpKtDQ1MK9Frl/Gjs2LtJDlHRQ7Ym7di9cxpuSPkpxuW6+dLDOMc1G8b1SP40MbiGNuaqUtJet4XuXK9TedqzZrY8/WdetqpV/W8+2rGfMqt7G7qrVv5Y/zWqhamsONFwYarMozMKSUTPEAAADXc//CXR/FohhhomMO7JS9diP1rdnkWhmNNYhyf5ljlVxq7uVmYwFUuT0mlkbehuSYrxglE6cl6mIl70jXg2e1jP3Ffmc2SQP45ZHXhxY+7Vw3IewMDJjdKX9MXkqFSagSQTaEyTj0C1Q0/JddS6BSph5LVQkOWAgEHGjQLSUPQqdfU5M+LNVSZezupYw5rq7kgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAm5icmD2sNyiQXpvjcvTCYOKSQPbw3KUKFmkY29cK2WF6bTRKoARe8FAGmAOAEYQQD5gogOGL4TeaYolYwDICAI8NDARMOZawxQZcSYIQSNqYSYZzF5mMTEQeeG2ZQeYI6RgQ4umost8GbwYkc9phhJbJDGFAm4bw9CYs0xTO5J2svO90mXsHCU+34lbqvy01tV8OgrGKJO3yCgRSUtYeF80dVV84HXujyCoiwU02GMplT93ZfdjNhlUFtIjFynv1d26Zv6kflNHR2KbOYwiMtxxf2UWn/7D9DZvXozH5ZAs9RSaim43R2qekrR6tepYHkd2fs5TFnChh2xeno1A0PRjdjK7TVLFmmv16OzVh2cmbFyrJKl+zbn6enpa9zlv8/y1Xt9pb2MqxuatX/t5XbWNXP7PeXLXe4XrN7K9cs8wz5fw729zPO/a5Zzy19feP27GfZdxYAAAAAAAAAmyWdKnHAFgEBgVJQMbHh1+5Xq1fmbkYdJuLXrFmxzHu95UuNT9hwoMRZhq6EfpyIBDoclaZt9R7NStgRoDezXh1wqlL6k9HwrJs9/SBjM0J+q40OO7EQEBE/JKDqWtYDUePH6m21YHfa5SGkQhrEalT4VULihxX+R6f62Ee2nfrRdi+N7bqMnTQLZGAwCIYAYFphZARGNGH6btIGACEmAgAHHyeaAayhA7zHnEaSYQAIDWRu/IIHfKDm2elWZkKZIJFBbqZQps25cd90xUTC05hwk1F+yQQNflRILRqbkj+sx/nLemX5PyXaTSoat5+ILb1+b8N0SVpcIamG8Xqq1wG1Zu167BzZYqXmMYmXtiVxUlFNfgmS0FLZmX8j9JLbOVLGpX+VmNR/KM0dFnKLNn6kq4zyIUtqVV6lWvlT34/ZmZTR1OYU9PbmqaCICpKWCrFmUUsYj+40/WMrmIZsurdm87cesYVpmYiGVqkmZddrW6allk5V7Kbkzazzz5XxvVsvoZT+VvHPndZW6Oty/Q5Xd/jZy/Wdn7Ffm/5Y3jupnuk/uvz/PKp3DD+/zVcnrF6gAAAfzeG9Z1Y0pQmKDImN0gQLPTD0zTPf2rNTEWhKzJnLG9hqvrPljKXux8ur0MNK1EGmoTwQ8voXEsFjpa/g1nZm3M2NvXT9jXbfZvTorqXvq8alfe0RrYY0CbWs0vumf3np7+vx/reKfGc7v/bHm7eLpX6HEjbFOhB69qzqy5kalEHWoNW1fFEIxdL7EsbHLq1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJXorJA9rLcqdoSYRjT1wiXh0iFewACnWxJe620ACpLvv4L0ssgZUYBIBhgDAamBoBEYr635k7kQAUEsxCYqgwQBYDTS5qi2WcI0BUw3zovM4sGuAypl8WlDKWzIygsjFIPmHPZ4MEAaHMCTFjJCLMIDMgBP5eKDbrloXQlbZG3i8Ve6GF/M9kNbubu1WPv45zAnQ8KQi0NtE5hMMMjf57IGacyWOJtDQTwwIznsXlk/RV8eyLGU7l2624GlXLVaM156axprUq7cwgeC5y7IJi3W/e4/TQ1PWrMZllSvbortaXUkehyclM/PTExS1rkC0sewtUrg08GX5VF5bnL6TLPKPat2L+FNH8pRT2r2McppVe+rhuvq9jaz7amLNnHCvlcy3ru86uOH/Xwy+ezypvsVLuHL+sLWr+GGqTPf7xt/veu3P1v+2ayu9QAAABlvPH7lLNUUBD11Yjc6QaLTGlk89c/fnq7Xm/hyD1XZ4YXLtXlNUv2IFc3WrdDDq6ZypPpAHYEbAxJWd861DcaXbokI7ZIMKjK9WmppYlckm13GsySwK31NaIfsjNi+LXtX+9nuaf4z/8Qt51b6+f9/GpAo9C77YvUReg2cB0yKGgzvCwgDpQkaJsBkShcxn5rRPAFiKBUvQkF2JVOBdbW2IrCNPqdzj6DJfMEgDreVuMDADowIhQDIgVlMWYPMwTgFwgC8wGAGFRNeTzBAV7q33Bo69wxTOI5AlLKoo37+KOOytAybCMPtA7c4hKHlHhBazWGSAl5keKbQcuIJmV0sAyZ7JPLXvditT3ZdA8suxqJsNlqXz9LVYLGoegB9oHZzFHvmoOXy9tqHcoGt01Lbt5W5bldyxvUNmdpPo+1L+dWrSZ0tLjNdr0stu17mVW1WoIarXKmOVbtNdt8zpuUVi7WtYbuXtY3oeyrT+NyrOY2dax5NWKb6tLlnuzV3+VrLeOeNb+75vHLK5arVss+c3j+GOGXef3f4493vHff1v8t5Yfrf5d/H/3j/e/rtb9/f2nJuuLtAAAAAA18OfurnhECEBdULjptlaNlYkBr3ldGYIlw2JQeQmRIhdCSJUxSQWeLqR40GMNZjLpibDIHMFsHOLw4AA2iFDhHkVrYwTQNE0h7DmPmDskpMexNWRAqwwZeZaaKBw3RrMiTZFNS6SKm1Pt3VZBkWZb6SDvWk//1O+1e7vWzW6tLZH9T1s9d3VpmoSER0GjbNb/9jdpZnyO7UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAABemQSwZWIAEWUgkAyswAGMYNHh3GgAPxRKLDu5ABRERMBaUSNERAwKWg4EBYUGASFwH6wcGKwN0nYMtgHMEHAQlw5M8HSBjIWwQqHSqDPCBk24wj5EiMRH2UhdF4qOQYrGw6RXQVJFURyiIC2m54dIhCK3TROorLBjNS8mfUUUCMWXi6PgnVJF4mjJIWAzTNT5pHCeYyLuigp6Da6Kka1ana9m0a2TcxQetm0dSTK1vQrQRZFaa1o1VbvWgZsp66q0bUU1t6tbbrXb3dv7fr+pf+tbdL19+mpv//nhazcaqBRDIAGE2CAaBgMpM0LGQbwAdxgAGFwGBkYfk2Bj40BewQWETC3oCKxKQXxAxrDwFEMigiAT4AQQWC5oI4BaQXvFahaMA04WknxN4hwkQNIBkEAP4foQ4LBigwxEJyNQQGAyLB6hkidJwPaFyiOh9jHGIo5LEiHqCCZOiliYEEiXIGbFFFAsmJiLjI4niTFmplwXEVz5VGaNjAumhxMoE0TZeYyLBZWaGZxFaKZsbOmu6jRFy8iyJTd0jdjqRgaVIGzHLaaLpIpH3MTJJ3TNFmKCKj6KRUTQRWtmMUTJrslNEElvRQZJFmbTWueRSZdlMqimt+inSWipZuipBSlLZ1LspT+kyDUZkeNDBBta2QrW/ySmsYTbCHPXIh+MC0wWNjUY+EzmaMEIOCrcViuaXxOSYLIeRID6A7gHeAYw5lJHFGYwg7B1EvCah4GZZWJ4E3LgANTgA8EMKIAEoEGJAeJQJUcRLGhSNBzjxQHsWEsOJAegXo2JIYcqHMHKE+LUD5emCdROUgieTdjqkqSlskUkUkFstmNlopopPTs66kE6/XRS6lupNVbJJOi21HZekmtBNjM0Ro+tfb//q/7P/VpLLqCZdZEurNUkVpLraq1m3qzi8KrUJu1bNSVQBDUZYcLB0YkBcYlhea/wqa2CUUAgWxVDH0Mly060lgQqEtcvKbJig8VsU8aoLDqRN72YvElbOPa/KgkKZwsIxMElEQZUDNKw5yS9DSodoozM08NvszJiroK/feBotMMVZZBzgJjS55mmvzBEKeWVW8JmcuWZdLXsmcsMeXN44YXq1aV95+P0tWbsVce6q45Z93n+OOO6XH8tZ67vH+Xf79rL8u93hl3udrLG3veOf7qX/q/hvn87/d61rf/jzH//H//X44/zf9///nMu/r//uOP41alNMxWtXjNNT1Ktiv9613Duv7+t/3fN67lUx5zu8O83rlvAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAZxg0ULWWtxDbBYYHdRblrqDQ4OZa3EAcGhQezNuQCdtmkqoJtmKdMjHkJjBh0YB2gJ4FBw5ojOKpuwuWBlew/IHFU7XKYoxzoA4StI31po9BMPueoVEEaw5ZlfG7Na9LqIgkYdCUfVUEgTNRXTBEdlUtnYJn7EOrjj60XjHGPQphbhxjyE1NB8DhC4AG0HOLpKFE0LRxlSY+S8Qx5miRkeUmmii5utJZeSWkxiYIGTmxktabN3QSdZ5G6kloWqRUk7bqU63QSTpGq1anQdaTaqKlaqD6q6tu6Le/X2X7+63qv+qjVq+r+kf1b0yWrKqHqdrXSUCAADJgEEphgbxooKxpdcZlMsIYPhgkYKOM7CgJANArjBy5RcAlBAGBQ0xoJ2ad55YzBrTc1TJjpghBQiFl0lNmfI1wwRJ1cBJkYKGBEA0IZ52bwqTFWKl0W2U++rQWmQCwBHuzL0+xcg6y0QIL0hZCH5g7hfIMhgTINqiSEGKROCzRzSQJ8cKyKk0PBTJswHONyiLUO8mi8bEeT5MEOMVFs2k+bIpFArmqDm6ki6ikiZG5kfPGKazFZuaKR00ElTRJF02dlTqLn066lGyZ8vGJks2TVTRdFzqU1V1mNaSNsxTnUkb0UFtd3U6dSNTupZ5SkWZKilO0U9rvQooPPrS7au8G51gimEOzkclSj4VB4GCwUGptAFGPIibYYhHGy9pelOhljZk4loqPMiXkQkreEkQw2AY1E+0G409LzyBWhba+22hLF3oUfLiBcYtApIqlGIodxrS36YbRQS2sNPC0hmavICTucsS0TAyH0YQd4sxNgqxJB/A5gsy+OZrjSggXh7DuPEsUi6USa9BE6kgzIombmbOgZHDJSB9I1UjNkqzrE2pOgiyK2qaySToOpC9FJ1z6l9vZFlvSVfZSatHVXZF0kVO/RRrdTUtaupL1b1brqr6/frxnQVn5THKQzjxumXuV8DAFzAQAzMKgRMxGQ3DBcQ6MpkLYWAZQkhg4hIYkTBM6YQhPAyQKKT6ACwQBYhqBbz/zqZDzM2pUmSyytzSlnjSDzrVUAM5BcA1EIVzf0PF2CmoMoc5sjAXGm10tIQehyMy8oGAx4rYO2DYoExB6wmBABSAHA42CYImNEfJeHQLKH2RY3LooQcZUOkyTRqOSpjMoEcUSZQPIoOkZGaykVFmxqok0zFNSKSBkkdUbO7pqcxZlps0zoOyXWktqS01OrN1LQWnSTUzqZ1td0aa1rQM1nlqW6SaS6kEaDKm6Na3SrurWipTrXZBaF9lO/aiusjVeZeQ1tboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAHW4PCg7lrcOuQaFB3UW4Wxg0ODmWtxGfD4IHdYbkhBIQgDOOBAr7QcWeLdAgJDM05DMEOjbPcDhEITAEAysR1yEBxY68CghcpBGzMRIl/3Rdppr/St0bSq6wKtTDgNKPOI3NKVXS1ghDMOHEmlAFQg6IigBZbmvpQSNxYKZzLnSbKJJuHZf4eQ0BNh/C4DmBvBfgvgTUOI4HpESseQszMlS8TieSROHYUEDqzZMyQOGRifNTUxYwSMk1lSi6gtklFBlopUDZJJ3UySLJJOpTqSWguu9JT3RdSSWii960Kq6noUlpJdPa9kmu3dlpak2U7IrW2mpLrU6ndNdkFaO9btVd2WShRehN9HZS/kN0DBmGscUWMBxKMDBDMpTYMneMMSRPFAbUOak0BWVuTXxACStMYLULMSNDwhQXpGvU0fZDK0d2yK13Iy57/TMsVcjuFw4FKmaFJ7K4Cgk4AQVcqjgeDn3a9IWIxhrS0nWaU9LuEKMsOw+OYLODHxhEPHwK3BBCQQGCRYsksYHlFNAxFiIkTCkTyZBDU8YMYlExTcyK5vNkkrnzU0N0mXek6npsYu55nZaKtDWkkg9BN1MpaTo7pm1VBJN0EE2UgeRZFaLIOtlrUlUirpMkpVbqZa91JOq921Jr9lOmgzPey9ns7yhAaz1bSkMKO9lTUijSio6FjAySGmAbDfIHkRETg4iHoRi0KkU6ZsnuykFGrqWdMxydjlWpJEZXOgpEZn8ZhFZpbXGGsPRXZUi0oMRxg1lg7wWK1uVVprsUSUpN5j2JMlBKDMeoHcnkgNYW4kkDUjIok4tWcUXxwpD+gkcLqRtRlq1pOdWt20aCs4XWU1qV3f3dafZBf6ezfQtpqTreqvdeju+q/rrTqof/V606LPXrv33svV+yvH5Ml6aWJSh/I8oEqB7DAsOB4MTDIZTS+ZzBjwjzELwwizBCi06PiQJfJPgREngMmaHoBMDAS0QgnfpWZNeZArsLBMi9SqIOLl7UvH4SEaqs5WUxr1TUzJswQMkaGLClXKGY1K4wylJ2nZXBTtNCXbALxPRDbtugvdkKz0KE0FMlLyoNLt2XXkFjCHojJssJbDUidmW6ltPUgamjVNPw1VllqtJp2kwqctZSrW+Sl7av/Zx/HPKm1zXKtzd3LHv559w3vXd7rb/vN5YUXM7lJhrdvHCtlrDKx96/UvYauduaqd5fz3Y7j3lbLn44cuZ1e9xt2beG7t3DPCrjlrL8eXqPXPv9w+pZ7lzmH49tatXt/e/5HU1nnrHD6+KQFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHbYPCA5l7cufxKFBzTW5cng0KDmYNy5bEoUG8vbkUACq7yOJFZlbpMAwcEjCI4MeDosLswbhzscAMEglO6fWEdlSxVOAXlAJA8aGFD0ZFDdaQuu2o1SLJYay9YMHFOogvKIaS9atOp4FA4kuNZK4O6JK0fvUXfmfcWOxyVyqNq2wRPuBXTdAJ0qSkJEwwj8JetRixrm06vuyvIa3WOzyxHd07JH1SLuuoN/WmLZlzNTUJ3T7pqn1nHzW1/rdfn+9L7vv5v7bzu29/W5Yt9YvbOb3pnOa/Oc59d4zmvpXH+N6rrWN5z8VvqnrmTWt0zjfviPulL6rW2fjGbY+6fdcbxr/5qk4XtnYw7Pk6qik3sj0HUJfYSAQVA5hQZGWC6bPHRvH5m3Q+HA1LWq9bypnZKKJ9KJMGIiA81jMqp1333IpVyKzqWt0eFhkpfNsTuaj4jFEgDqmbAQkCVAaWMBQY88Whx/qSVw8PMZNUdIYEbDIkURgwLwlBlE4gCNkFAQCPii0lVGZQc2LxygkgZGZoZ1oKTWXKLudR0Tq0xbutdCikkhqpLdtlpppPUktaktbMtSnQVU7MxgzJ0U0EVspbM6aSlKrUtSnazsrQNGUpRkix+k7puyJ9rKTdlqS6SFFKhTdJF10qSpJpMdTqZbqZE52eVW5eK1O0knlj9oRBcZGaxAYHSJtLDH7ikYSBLfLFizquK9aYi/1DiQ17WlLll0gll6PvasNFIlLx5iabSQrtibzMAvPGLDshEJAEfMBwnDeuHtPBXo43LH2GkqKVOETpeIwmyHi1hKGIRUyI0RiikSLzc6bH5qUjEn0D7lJiUd1JqWkktSzZbGKkklPUbuta6kVXNVLfppqSTopsyP1stalppGroUDBBJNS0Vo0VuigpjlA0W7O5uutSklKTU7Oimmk+kzMggggg7rTTWZrXQQUgrQdk163WmpBBGynJxFdOuPcgdQyqhWY7MIyaC4KLQNGDBS0wVZPH5wWLJWP29zmRPJ0HdcVE0DJKRSXf5d13dFBUHpHrJYp6fTS02n4jE/Os9JCE5UkWDKmO1EgJZpTSx7mx6a5InhdtAPI4VNKo51UuEoyiJOplg9kcsrgueYdY8N6rct0KJqf0nb8f4zatcazava7f7/X4V60xb6+t6/3m3z8Yp85ziTdt0tXft8UzvV913aLM/q8xvP3nObwpvHv/v1panvT/O6a3W2pYePCznU2PamvnH3fGZ4dNxM5vnHzn0zGhbpj01JEmqy5h1ra/3XdPFXVzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB2SIQgOZm3LoEUhQcw9uXRoZCg3l7cuwRWGBzL25RfLfzVK7lO+7QkuTAYDEBcIiSZj3p+ZMkwHWi0J5KF/W5w4sKnoFgwcigynFauQJeeGNKAo7P+wAINUpiV3TPo/DwrEViL3R+jJzmGeMPZWnvik/T5VX0jY07KMJk+YkBSLhDwKzGdGwK0KZGmi2JJy2anUU0y2bqNzA0NTEzTTJtJIvmpqUC6um590UmU7EvUtb2UtNRmnQmyjrKSQRZBCnQOLRNNNqTGqbJJppFx1GR9STNU9T0jJ0HMFrUna7IU13QcyNTAuoHlOaJXdJ610rHWRpOZOpSpdo0bJuYsmbNj6K6emt1pJmql51Z2DuE3r/Rmch5ZAcGS6phA/mmt6c3JLDH5kNi470eXe5DBF5DKx4QcuH4RJZjKqwqdShlLiPco7Oz8Nw5QqHEQGSwwxsQWEKYi7kHPxJmzwTQy9Wwzkj1BHZHkFvcJQ3WbdEPHW/qZN4c0WubxXsRlte0XES/1743fGMRd0pfOMV1BcN3/z949M4/xvPpjH+P/jH1emI+d59dXkp8wb53XWc51ndselXmO4181dzXg7gv71h2xPaa73WczOV7Y7yl5NUzr3pqtIOdatrb+PakSuNSVfza1bGYHiJjcG+poW7fVpJbwIg+EqRgZ6a0tepYKTGGAZg4UaKnGb8Z8iw97vw1OWWkQIwxvkApMHAqlTEIFv14efCAl/INK7TeQ3U6WDp2VROCsEfkWX4Zcn+RihWQMPdOac9RXj6P8uWhQrXtGG/JYV9TBbHwARAc1A5omeAf2avrxJJ8zeHid0+zqbxFGoUkvxYTnD+YkOu9b1TcfMKv1resZzNbGfiBXFvW2M3/zm9vjNL43nWM2hx/nHgbrS+sSVpiFA14ttN1KR/Gn+fXXpalK0tr1tT6xWtqQ8atu2tU39W1n698azeX1+rb1821WzHjV/fyPygU9ykzXZHAcqkEMN4/qhpZgxCMzC6jH5OXzW4w+kgyflc2o0VRU9Fqo9JGQjb5uU8LYmcqrLddpTFcjSmUs6YC2zw7L0vu05pxxKjiabqAGJNPX4zr7cCNaFqXKpGsm89jKxP7JcumvCkRTOxlFNVVOOG/eoWmbMGk9X1rXmxeJj68Kv+fqut1SlNW/zj1z8feY3xvV9Vz4Pxm33nx8Z3S+3rVDifEK0Gts71Ci0eYpBv5r0h5b/TVM439W36ef7vrdIMGJaFF3ustdUzW+fStd5bLX1uTMbetxtU3rOsav94fu6Qt4zXd933nN38dUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdCiUIDuXty59FIUHMvbltaLQoN5a3DnkVhQcw9uWnrJglacuryNqrOQUF5ICSgJgAFxwMB48Drfw1NUKZrKsXlQyVTcFxFwKxw9ENQFUVAh4hXAI81TSN9HsdV+HVJXTABYq965gV2IdKZlrl0scoXds4Q+0x9Y9G4CuhLrNwiiwL7pxUblh7M9m1Gh2lniYgwcZs3YtGa60hR4EasWnbI+NZv6YvSm8U+PrdpLa3NTU/iaxnNbZ829YtfPj2vjPpnd8xcyXzumK4+811A/r5X1teusXtmBvb/4+8UpuXUWFjd739abx933e1Kyau/1n6h7xX519x65hx9yxZrW/g5vr0xEqVgZwZC0l95NAfuSFgAFQONFEyNXTHKiIAC0aAbD+OfFWGNjlUplKngVrRcs2I9PJjJPK9hiM7eNwn8hq83zlpQRqgX0G/mGGUNNrBsh3WgOIyWAzPFe6l0+WZnseCIavuoC725Qx9zT0x3keszY4W3dk67xBxXetf6xelIWda+pqVxC3jf/1bed7xqm9Vvve66p6Vnm3reMZzamYm56Z9I2613reNVpqLvMXW5MvNY9f5otc6xnUfeIuIXjMONX3qbOvaDe8GnvEh71a+MY+aRMy4o/jUi0xiBaba7mh+kK148bW81n0lUazC3fcaXV7FGUAKUBfQ0E9MXJTsFlO6ZgiG428krmoKTBZC8l9votbkPIJpG3YEPDPiuyq3Kcu15VZJAUk5LAEbBIgxwuh7ZfWgyrcma7K1acrsjSMyXJFkwAcrPGpfRSOl89RTk1FFSjQyY1PzOmx91syDJL02T1qMCjoO6KCLqQTRXVUkmmyLIPSZ7Mxuz01prL9SzrrdJJGipI+k7ppKqWtVSBky3SanTWdZa3MzQ6ZsyzQ8XkU2dzdNBzVB+aMmaKZJNFBKatS02Uprj4p1J10jBajVbOYsiHWy26aZgOD80qRoDDQAMEgkyfDTkgPJhioi/M9BlNPSmAYzIIJTRWHt/T0Ffq9UnnysNTvOpUgp4cnAHCqcbf5fZ4ciqPam69rGLy6gmVVDGiegitCjXtVsKKsaFZWPqqid/Rrgz/WbfNYV8Jz/7+t/P3ndMffp/tzzCpXWd6rr/ONXz70zSlM33m0TW/FzauX8OJ6z5putMz+aBrVIM2vmWHE9t6ve+Z8wayVgRIkOz/FKPYd/quYe2Fqs+k39eA2OMHF63zPe88SJ4sLMZ/FbYUVkhxo2WvckG0TELMStotX0bEtsZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHb4pCA3l7cuqROFBrD25d0iEGDOXty6PE4QG8vbkYCHeo27SaSuraUDLaGFAJnQecYbmDgS6obmXsppmDJVLlaq0Mx5nEbmnvibc5SzSoJHcKDaQqAzdNFmQRIGDWm4R9mRGIKuD1EEPdCIbmYTGaq0V/UERizPInYUGGTY1t5u9vmNNrPpWlnJSMmYveWi171WQI14rOzwY0GNNr0hZxumc0ebv9ah08t/SLBpmePGtDiY1me0sLM9q707hRttmqQdPp82pZ9Nn1i5t6/UbG7Q7VgU3S8mZIWqxcZix4t4saaDAh6+vqu64rb1rWFFlkiYfwt2+M3zTV6xvfHjXQ/cWD7XtST51Wsw8sOBGnyOX1rE5L05y+BlApj0R9+hrIq5H3wtwVg+rxPs15qWl2kz4XIZVHVzwh10XoaicBP+06llL9MAgwdKsyKMtX0ZKpuDT3jh2LOxHXZuTEuA7WuxCgw52coMEdtsv4jdSVCnj+JvGMxYN4eMe2HeKbvmsTFN+1N7pn53SC5eFq96Ym+f6axfNdYtmbwcUzfUOBDmrvV4cCsGm6Vrmn3rGM3/vbGbtvbI0D+JPS+qyVh4vFjb3G1JVupqaPRPr0aJueafd9Op8XviHp8231C1jwoe4LdLv2veLX4jrpaxq95YM+MYvCnjko6dSPCl09ALVJc3Vkg88Edm4uYWQH4lO5a+jPaS3NPCvJxHjlScsvmXIgJfEWa29JQGvpYebJBIlyGokvgqNTrbuqw41TQCIUiRChomA35HfrQgSIlk9hGjRrX2AKFMxZupbYRs+a08DMzGnrwX0Vjs3Zj3cd7fUv/n1nmfZrEiucHe969t7xeuXLcOkfUvmg0Zq4pWbVYtcZgTWgvY15fqkR05u/Cjs2r6xCkgavTdqXmtrEu8P+1zR5q3h7iwoEL0mjeD9x/XfrDpXEOBDg2i0mxnMutzvq4neTbkzPPq1aRipcYVMU+Ib3MwQBhLSgTAl/NOkUMfDD5IZpxGHKIFMx8eUZgW3g9FqPRhtpbXYw9DGI/nDkBQFKluKHUFEp6WMJlU5GbF0QDvS7l1YcJ2QYFjodfuQVZRh2JsLFr8pbLnz+R5t+EK3PCiy1sZseLrG2++WA9XX3Iy5Ts1a0+a/FsMudR6fwc4vF3WmK61v2/rn3rb/e/PresQsRozVembUlrrxK5vNaHqDimcVru1add0iy1zeT31mNaHCtE3jWcQlf4OWN9BwwN6qrD1mR9EjYvS0LMR97Qt7zmJAZGqsSPHpDtSkXU94qn8260tWR9aPSBSQBrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABu2JwgNYe3LVMUhQay9uWX4NCA3hrcvGRmCBrMm4dVLZ5nYhdh4rcCl6SQaCC4GrA+A/M7Zi03TfGZ9bl+YpyI8nuwzSxq8/xYCTKvpdcQl3fpn+g5cb27fxnpKqEk+IIpMGxT7y15pZaYstnLbqLVuuuQa6VfwoDHipvRM1/zB9r5w903Vb9XandvM1bta9NPdU3iua0kt//96xqSL9+udX+db9cbxq2q2xq7Jret1j01jMGLCtPFzmBanvjXx5tbpTE995tqbcGZ9LErikHGpLySW/8X7ta1aXrDtSkXdYOr4xfeLy6vnEsWJB+M2TkXNbwa79N1peW2E0OtkZMxiJ0sxJ4cTtBgURnQsUB5Z36l+XPVOVaeo7WvbZPGpE31p9W1L8Z+gfmUJ/Un1e3iANNaAOtJOwAcURajdHjH6bWdWAAsBFKbGf7ntFEHzme27aPi1Kvb7tuNTVZsT9dbx65z86v27G86/+6Zc7ZxfH3/nP3rPtvHrjXzbPh41u0mr6vemJr/W61xTdfb/Op8RM2zPbVNV1iuN1xm9b2gyR7bt6UnxasPc+9QK0zXea2xNbEK9ffEG8SsG2J8U3aSHP66isM3hatTdoNM+sanQ5bTgMuj1NJsIYa6kOXBMBBTGEgTAW0m8q+dqmjtMv+D3TaUrjKVS66suXURClV0dfidRQq25BS9KsXJfmUs8NwRCcnTHKTONTr396xtb93HR5EpmaSQAPSGmxkTVJDjNaKa2bY+tJRqgTEXWXkFLc+taa3NnrqWgjdSDbLZNarLRUggzMpFXZzFlqMjiaC1UWZKx+inc2Y4pms1SqqbskgaoIJn0EaKbJrrQY6mnd7ostS3RPXfRSTZV0jySSlJq7qdFaSbDiTJYFzHByLiqDNotRV4JjCXoiGgkWDFRnLZiC0NzucugJv5XnnBMoel21dqftQM+tl3l4MLoMk2ZehPzlvMqyVo8lE4kmQYdoVyh6I400ozjmUqXWADXluWjZAqGpuWAHQbF5AvGZ5Q5Z50XUgmznzJRu5cUOtTn01LQRRqI10VrQVSUsvKRSMV9FNSqZyp0aSRs6R9VE8aFI+7mJug7J0psqo6XVHkFo0WLjl4zUbKZNZkqkaKc2RPGB1S6bnnQLzlc4eNC4eOrNDMuGTspNSKJhMCipz6ztiePHkWLpdL7nGNFJOYoGYuj6y6YoqMEWdFS00KSR5YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeVicCDeZtyztB4MGsRblsKLQQNZk3LqcUgQZ1JuUJ4kCvK9sPO1qGbSp08SYkM1ogScu1H90Mob6xLI8nRqBZ4SNo86K81CNweSzqSpVe0AGHxm5TQTYWFEnrcpl5PcI/xrVuk5Sp7y1vJZZaAAhIjI8y8W0ikViwATQlM3U5iLJKx01Rn0DjIk4zRpGxWMnNS0ggko6s6tJi69BNNyky00mZTKoGjLm7qSSOspbqWeTWZO7FxEwL5xI2MUEkDdRucLqzQ+cMS8fVPoGiRoZLSUgzKTmKSCKjikGUYJMdYyNnQRdRipqKJoXzc6ks2QPLZ0rKcvpIJMfUZJG7oGrIHjF0DMS9SpSSRW6K1zBSNEztGm9CI5LrWLqu8gyWDxVrkZV7Z7C/lDl19Xhf7Gu1xBNqy6tirZa23dvILdiqkZJvn5+LDCELnXuLZOuiWjNJh17M9c3PZqdh1n7lcPqUcMlG4AtWaJMgth8m6LUEE3VapzFEtXSrRW6dRNa361HVXWbrrZV1Is1lo3RVVSZS7LettOmtRot00GSUtJSKC1oLWmtBaK1mxxEyoupNF001utRkkiYskfMVIJJqdTsifZNk0lLdaKlGTNZIxc8gkYLTUybsikfNknp9jxhozS1FSuBGIRP3I8p5shd4w48UjHXCLell+pBFLTxqULbwfN4VRxbcN1lFqkIIG3EoGb4IAJ7PGWRxSwaKd6YfkBmCDlwZ+K4wiD23s5w2gJl0ZjKBwnysxRAhJRMnY+7D6Ug65iyKCRdqRJBZOoKTTQYxZJJIpKUTSarIrMjN7qW6KlqqpJJIILaq6V3dklPRoqQQTd3rNVZsuYJ0zVGtNTIOYqoJ1JIKQdaKJhZM1W9SCLJpPRSVdJ60kVm2pIyepaCKL2qdlJuk6SCzEih5TMkgpKgmpBmOvgyR2X8cp4pBR2mRNDS6GCTRmNgeWT3LluXy23XXbXhb9Dzm9aee1BVlSh61wO4njMDgWbygaHawhNLUlkD0BxAJYYCRCUZWr8zC+djgkcnoClxPJFIomxcA4ge7MfWWBGCJo9ImjE0ZaSKK0lkCNkXWjoMe1zA+tbnXNTxx1nUkXoWslXUlXUpNFSVdkUTZVa0UEETSpJaKRqkYux5FB0UWLrGxqZLTWeWbzxVSROpoOmZKTMJwzPnnOLNUbIuiborQROJT61nkXWbILPpsVjdAvmiZfQRUgYLNExXSqgXjFFMzdZdQY2N1l2wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHWIvAAzmbcO9xWABnUm5eFi0ADOYty4TEoEGcSbkRiIfL9XDBEjtMtbI/AgBDJQIOHnT85T6bI2eO/TlupyWtUQelNV+s0q4OhskbIlJStaJjR9Li/cWbkQ2BA0fjaihy2jiqk3rZbLlZqjiYxSiCoDf2JgmUB9l0yMgIWJYnWMjJBAgbH6VBNE0SIkmyybcjk0jVTIOt2MTE0SNaFqqnRPpqZNCmpFSj9M0ZBJ1Oo6hdFazB6B56LqcwSSSTNzJAvmpmcMjJGyN1KWgm1JRq6R43cwMnMkndJbmqTu2gkmtMxSRZTLRU6bKWYTCfdFSKk07pHEqK0Vomgno3MJikgktaR1kmQcySHRkECiDeNcmoAYavKbYaicF2gWZA/w/uUtm41GXLqjEMq3rTearWlspwUXeAmANUVPYKop9o08+6RORds9RpVHLBhccRTIAcuHonbgV/Z2Lg4zhC6YwNy4Shw1ADsmVn0Uj6QzZUUpNyHmjUlmK2ojXa5ouylmqzNphdkVLOH0VMlUyaqNFS2RRqoqZTOzThuYpOikitNRs1JNaKBi51IwTUmcdRgcospZTNjZNM/RLZqarLrF1Om6SCSiWLpNo01omB5A0TTd00WUalNZsdMDNkklorOKRY1RTMS6dcqGSB4cg1VN0D5vXUggozWKGjIYlaquxOXMoVUjjDGkF3lYTBoSWhx3HUlMebyluwYDiXQss+HqHEhhtXjR1geOIylCM6kxiTGwbMS+pYKty6GQvm9JJcIXUo4nIZ2B5x97MCLKB0lyY6W0WJQqnQO8kTRj6bKE8l5kk3OKNGQJwxQTJpRHutBknTUgZmTNMqlp0CiVFqTTQVagk6nNlIH01m7GySSRuyXZFNdIw0DBBaZ12UXTqCaRuicTTTst3Y6ZpJmKToyqy0i6mowUYHjrrSNDBZggasfTdBBJBlpmZNspE4kgii6aCaRoggt6mUfZbLQHWbJGjIXSMFG7TRA3SlVvAxL4r5d9/GcPxFZwOBFhAhUPBhx+IxhSSKOQXL2Uw5LGWi0pp2Hk1H42pUn8vWXlYaYQjjNefjUySsiUnmE/wBxkQvRyIasyGRX5mjfce29/JQZl46dSNgVErsYKWmfJlF0FJLL588mV2UaGiJQNFmaaaDIrVNHUx5qlObE+kgymZFNN9aCFzqamZJBq3qQTsgya9lJtXUo6gZWMWUgk5cNGWdM0zI2PrMkDG82SpMtz6Js1M3SOl9F3dBTJJsmfTQZBSc650vroJosqs3MFTJjGpdx1GxhZ0ztaKCBcpGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0KLv4MZm3LTULgQPxJuWn4NAAzl7cu9RZ/BnUm5LUPFOqef9YCB30sxprQMIqEp6+k+37+Qp8JXfmBaenrLLIQYadpY8uCgD0qwrEIlY8sViA0PFpRAVeiEKwtTap1ZDc1EVI920uxTo775t1HSMwmhsy0vkwXRnygVgJoJcnVMZswfkfPXRKR40Y0N0nk7HMZI6VnO2n0EzJRjUzLWdKlSLUUFosyOzuki7WZJ6SFCkybG+mtdbHy62aF1jZbKoo00HrOum5NsXVJMtFJExNTKeMDBJMuzQyUbGhw4mx2pBFaSRk6ZogufMi8kuZTFSCtlmi6jzLHJazJOcMkjiCJqySJ1YgTQW6IXAV0qkLQ4sJmHajxCA1bdDLl1nqZpE2PwwxKz12oczpI3AzYKVYpUBLGyt0mi+EKuVpni8mu5U6yDw0sBKeQ1al7hc3Lqihg4ivasGxsk6R0A8idpUXRF8eWzpJOyKRVLqLJJEmkyl0rqqOpsmi3plZqlIKda0V0larLSUtE6t7MtJdSroqMEE1JJsit60VoK1KQSMi9c9SRQW5lUyqkjddaD3ZakHNXmZom6TsykXQY4YqQTNjpiySzFFBOozUcdG6k2ca55GoyRLAMW9zlBUREeXx2wyOtLZuFMzmQkYiJmJHL8YJjrvQ/gEMRXOPl+ovVeKlXdBzfEgjiv0xa6+mcASSzUAQaJMMV3DPNhySjJ65bLGIT0B3qyNgcthIOZzlsjNgAKeV172klrjGcsf8tprfbvs0K8H5ritKfX98/e6eDXd9b183v/i+cbn+M5+Mb/x76x/JiudY1PeauoEsHUtN33nN87+6bnvvWf/i9Jrw4EXE2poUOWSlYcu8Y3ukKtKZtnV7X+ca1befvf+K5tb5rf2xusKqIyFgjA4GR6Y0MkDQ6v4baa48lmWlQFDwhEBl4ltKp+3QqoK6mZNYeSXX46pjLpVGJ2fto5Eoxt/IjsMgYfZooVSU2lyT1t1hMUIUY9BfCirvjD0Xf+WpvGeI0GV9BZdMyNMQC1J86XVrqAqLuxqmkmtjpsgy0Fjkoq5stVNRHIMUd06ZZKjKUaJ3aghWzJIrXRNnmKzRNSN1sdWkgt01uitR8yNlpHay8keQU54zRTZBkiiarQPGF0KKTpJnzUyUs6kbE0YGJutIxRWk5mdPpLTRMziZlWanVJnloGR9RmZJHDJZdsZOsvjmEFY6aIs5stZwzUyCjckAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeOjD8DGpNw17FYAGMvbl2aJPoMae3LwESfgY1JuW5hbTAYm3FzbLD10v1EE3C4i6Y1JW2srbR+jbZIGMeHi7/NGYhHaiZtKVQspT4JQzJq7fwpWejxpcYZETNdMrhcOBL0dBEzt4X4vp7RCVwxFxkgLHYYq0LpsZk6SQC0kIcNVVHRSp9TLk6oumBuTzHHJxhemq0SqWVoOpFzdSjVmqUiYFxNbJpIOpJI4gutbIOmbJXZ1NpsybJopGZq7LYwNnLpkmuZOgapKSegmXVoutjh1i46zBay+ybGqZitZcOKc2MmK07mSalpOcSRVLzsis2c+aIpukp0Tik66aln0I5xsbIpsWzZNIzcyOux5I2eXiAz4wIrdd288bjTAjKBAG3TdI81Om011+oOvsGt0ErYNjZnuXr7eFQhUbclH4sJMRqSVZn0/lm0saUTMggglHjcoEnIxPQzfpZYNbP/KfcK1kmwD+c9avnOiCLWNV3AvfOIOYdr4Pi+vbG/rz9vx/vGcZ9HVN5pXXx8/G/j6x9/+bH/3PbdsYpjftfGbR61hXva1fH35d0tvNs+Hrw5rb+J6V3mnxqPHtBvEq9rGmltuksDOc2rjN8wc7peut6zmmcT3vmBSNV5T4ptFb1XGt3pbHxvcb1MMUXVyzOFx+X0Vis1IgAV1YNPUVeiQLaq7iXMrCxKGrjcEkIZlSTdpirH1RorCxeJq7rCgyBILksSkBMFHheWbpHpFlzyJ0/8RwXnAkzQdQyAImB3RpmZnsqLsg1iKZM5vAsDavu1bMWly9Z0pNXCfwdjDuC32tGfM7nv1tPa/td7CQv1trWa+emcVkh31fV/4vpPXHvakunsTeLwM517RsY1p5A1meLrU8DevTOsQYdvXU0Gn1ubLjuLBgvJdR2PefPq8Rxs9zusHMLd8X3fUK8TGu7tilYVPWtM0rS1bmbnEsCXGPh7M8ipQ4cyhr7EWdudK6elsSyXMtBhyIM5QUU+QgFDq616yTL7U06PBKtNQVJ641IhLFCN8xY9D5RGcSMz01DCLisDw2FkGUMjEVbsPvZK4tS24ZlSwQKeOzBknNiKmZA1kcB049LyiTCQZGJBFSczRMCYNC26EwcZcyeaJIrdZomQx2RN2RRaShMumikk+zqRqU+tS2UkkyF0lqSNnM60VrTTdE87qTZOePG59Bi+gxipzBZggmtNVzM8bLN1OYFa5igZIrMndkSYOpKNnTdzJJ1JOo4ZmZxZmjQMS8XXZMxSl1ExrUqLWfZZoXzRjMzNVH0ypWOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAGzoc/Afl7csqxR/A/M25Z7gz8B+Wty5lD30D80bkuY0m1IIW0MakcIaTOwP0eFPv3Fsix0Sae/wiL7ecNiNSHYYtp/UKcC6xppuMASkAkvzV3TvAWLnnjNx2T+qAgRFXBtPVXjL39yiRVEATU9YpZoWWdzYgEhRUximpDPi3xrsOc7kS7G8eLiKq95gYxH9JpMbz4O/bfxAZt4xj5xqub118Y1murbtbFte/1neM+n1StKb8b3kx60tvVKT5trWLU39T/d5qT6zCxjVqYlzTxsWtn6rnNtfeq/F8Y1u2setNTY8DW82zvX+J9fOokTFbZxTcZGNonwWiqMNSN6qzI8Zz/L/IqfYtUasiasdfTFPLd5w1435jKejspZIgKKy1FWYQGaQdutfmZVHigVyaGXh8xLeJBxmGZXnOap8LQhNtVMki4VSYSKAANi0eNTdlqBqNdTIFFPksVSJldctHkHZV1psxmyZYSuhcmi2tNFFvoVtXQ1rZaaa6WrUpFlJqQdF2Zk3dCtbJ01mCzBkXSvUfQSmqCTvdD2dE1rQZBToqWzIKZSCCqrsy3W7Ipup01KY+tFJmRUXTzH61LSObzd6+jdCsVCFOaHw4ipYUJZDlHjq3nVglz4LbZ3zLG3fsCUbvRhXtyFyB+xktGNwBpSCAExKKSIWIwHHkxEZj6jxo8kjBEVjSxZskDyqHpOm0TGS2zaJxJS4eWAGQiCmkzumIhzTcfi4pJQ9C6XVGJKkqcNT601lxnbdjJK08yRToUKSamvUkgxdSd1VJupejTvekylp59dGY1LQZbsy90qKC1sgmgt3TPnFUDJ0k00FMuqtjJs2RZTIKWs8yK7spaSkUbrZlmrbL6Rs4ymFbw8qt1CQbiUR5fGvcdZaoywWxGRaGxRpLJGULaSAWIwtPGNTSeckVPFtJNMrJnn8IrH0M9iURyYpo2/4kK9M2sk9jgIeTbMDk0EROfrVqZJ4xVnVqy8nkSuQqjEByctKPGaBqiAsAHcZppuTxsgYqIOkdPFksCyibUp0ZXRRdAqOsyQTo0jg9rWpNmUtaaKl1uktSGtE+69JfdG6kU1NafQdSc6ZrSWo6pZsidUi61KWopzJFzRZ/ZNBE0WiyaDJmdc0TWbG9aLHUGUsyRRdlsio7QRUiZF1zdJNJBNaYzxucW80ZZ1UUG1dQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHbIK9gfqjcuvRJ7BjNG5aZij2B+pty0XBnsD80bkEgFanC/naa6pYmKZEGQL5LPpm7LmMEzqAUrI0bYHLJ8YBCgyq3JCu6mXBDaiODGhECLMwUakK5kSrRF2SGm3F/IuWAJl9AJKKFxWNr9lb8o+wa3JiQlSk2qpoUTEiRdIKAYpI8pG6JsakBD5i5UiYj+xsboF8vIGQ23H0kks+QInSLm5szkuksmWVRWiiRRjjo2SSZ3TnakXWt0VJuySKtF3Wx5J1MpKgz1ImRgtbIJoLRWl1JsbKSdklGlBBjiKJfZJNNFaTrdBR12c+6bosgYJmrskkktJNk1pmaL02Uy6lLUXjYj3MToNRULPCQiAWig5qjzVss3z2zhuE3R0UkiyOwGBvRd/AU3PRhRxEyQWI1Drd6xEaSllBShhc2WmFnSUsRl95XJEovyQJOAHN/yPJN1msvXg11yZqlZubiLFeSIxJUuEFMh8BAuHUXU6ZgWAtCGIbJH1GaJdPG5PHUTE0cRVjFGbkMLiBoggXrJHloMtFY7j6DqWybJIs6TUabKdqTnFpvoziDvRTTdPTZJSRsyaLooMo4gYssvJIpqO0nRUb0Xd0nZi6go5QqVQPmjFV1oGCSSLHzNKapII3JmfSdkWcxUZpoKOzKmRcrIMoxao3XmqET1CnAl7xSjXezvm09EKP2P8aeLlgMwd9khW+Dw73zrJjTB5dD6Q0XVLC0rySKRKFtD0tyx6rK6aJ0F8tCTQ2oStHQ/UEEBF/35p52y8Rbk7C55wXljNU3J0zJsixEgCMB7xGpzdRDg+MbK59RQOmCSywcdiALL6TGhkkbF4mjY8mYpLIc3Oqc6zLZTrXVsupbaKSupRsvy6p/ZNqk0WRaYu9FqT0VaVaWlVpJ3U6Kl02UmtbstVDU9JFSLupaKKCklJLRUik71WWgz1situt1utuibVE6iE+B8rzy+VTCapSRHnrGajbRgABdZVKTAEgfjOnjooo6lhmMbElx0VVyixFk5QrVL5fHoo7JigrCqayZO8+5pWP5sLfuEMHiNPA0eGSTpE46uBdKKyeNEQMWxJAuIF8wTLwNCZfUumYJuXpBU0DcnUhZBdSqWo2nC0idzpqyWkWS8xxW30vqs2k7LZFSlLuiupSnZFanukipBzpqtBFTOZOpSKLMk1JTstWizoGGx1F5ita9JZq1J0kzGy3200U1ra1SS0dWozHJXde1SFar2gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB01zuwH8m3L08GdQY5RuWsD65gxvi4Njn1yBrXFwJSegIwLwxR+EuL2dUj80sseORVyyQVGLQZcGi8nOaAJikYNFAaNKdcTDy6LRCUKL6AxIMAHMmaohEYOZTTzIIqIgIoqXjd5nRhRaBi3bA3peoNLwQOxILy9f7dmmy4iDEEoktOFhMRACVRMrD4GsXiXGcA44CiRc5By8SqxzQDsjCQKKJYFnrLqBwj1E6ZCbzogKWkTYT6eqSKRg4+DyhQraClj5NElI/rbsup7rVa/0Wq7Iotdf+ikp6n19SVI2XoqdS0UEkki6amKKSSXRRLra0XRZZkbehBYrH95sFg8XryhBSWhYbk/SqMdBsmmke0hHYdOAXLy1KXCr3ICpWZGGhG1gwkCGSGBw+rySsEAIEe+HRoXwOFAtEDHgiBIjZEMg8BDaCQqLyIAJjxNLVuJgBAmRwMx5pJgQKHEAyYiNQdSxEB17cAgVUvV5CVLUBpk4Hs0g5rhAS8biCJobAbZ8CgYWEiA5ZqTY5oGQhBe4yTWmQpokaGpPHHJsScoA2kQpioeS8bMyZNsOQtY12XVWLskTU4VTWl/VqX0aknRRVU33akpJ1JPoqvst60TFut0VOztdaKOgnUrZaKSZibJS9Soo6nWy2Rq6LJJ9Wk9EySmT0yweRP/ZQas7f8diChDcwfAwDGxi663wdd3Iy2Zj8okUNs3HUIyInJAEwQGEIkajZo5SsGBBhxtJVg0g1RhhGLDhnJGOqYDfBVZNYSklTFJmFQ85coEQABuKMTBpPtCcKDU6kvDDAzKHGQgdURcVQxfRisDv+psGA0weAiwAV9Sl63Ag6DHpTIJDOHAVpzmw+309PmHQ1AEptUm2ARp870sYZfhiuXeuDAAt5uA2/d95QQnFu97JjGX61QyJ61R2JqY/p/////2Dit5II3oIMJtPLLOUwlUaQ+87XWuJLTKYZctipjWxiIYMByh3YKlUENrE6eJPZBzhOOcpYIwBgTqmplUjW19jBoMDoKFgWJPIQZEUGDDh1SgQJEAsxMYKXCIlb7F2Y8jFDDNTN4QdtOEwaJD2bXMJvo2KFhED1AwwFAQfKpFsmHlnSAQmtQsKAVKR6IfrQMRAabTxMehQODDiv6zGEtgYEPGYSBMxZp9L8feWwU+rd5u85JfjAqh+KY1HP3j36CVVlDd8ZDP8/LlI8MM5PHGXfo/u///2KxWxrq2sICOftZErDy6FEiS2LhABjHErhQPzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdaPziDHOLg6cfnEGt8XB2o/OIM74uDlp+cQZ3xcFL5+Ei5SCRhO8ixnlRdhKelZ/Gfu+5C/hCQjF5CL+DScAgPMvuwOB5fAKgUzYF00YcAyEY2KlVdJkAeMAKPSYADAuhDBgSMOJwSBSqhdJOUmABlOnG5gYFQADgCYCPAioZjxTBE3AIJSFHgcikgOMPApkJhoKGDyCa+KJgMDKWL2kbWS8iZK7kZjGRORLf2H3fuQEwICA9hcPSOzEnTp52nghmdHORwFA2gDAG/1h+ne3z7l9z7iml7ay88Ncq6l7SLffvOnPOfp//8sv0Vu6mKYcFkSJ4o0MHATMMGhBBhq0kWnxMKB+KIZQadtS59DhGThOyKEuRgKpXCY3WcNvofXCtKDAqKmCIaEszUyQSjQY/46EhQWNMCmuruMOB1LBCYiIXLCkY0uJJgoMOyAAMIgmCIQFItlxe1rYJCZq0MGBQCMg4EH805pBBOjF4qaQJBIaFJWFYETsRJGQAMB83EIkxFLGzQFdaoyxgpc8weD29YMtVTuXK3zRjQziwDfyfnnISulk3KIYapR3palu6RgYGMRnrUYx7+oMwrIzVsH/fP8/uX1Z4EtvDBu/7/2f93/1lk64CSKlRQwLHxYXKzZg0QF0iz40UF1YsPIGwASKBJqhZBCrODSztQAQDNEVoAZTTNadJuzau03R12LgUUNGPRwKMRJyAGPIuVyMiEJyaGNtAFAAy0hTGMgHjCwYxkzMSQDuBcA0BhTWMAhj7qHACWwJCDCAMSApn+Jm8guRB5OgwSITy7yMRxIFL6HSYJJCIglpzDoXTjGASOi0FY8oCyhiTTcJbD6xGghcCGcQajVE5HBcpgyoYSAENYw5jmXsk0al9C16BH9mCsGvuCgKp7N4Xy/uedxz7iw/ayMlbf7uyplD13rspxR9R3//939PIUjI55x5NwHSoAFVhAVQTFji1izEARS2B4amtaXUJe0v8nMFzTU+B262UUl4rnXjRKGutJI47rmFUlNQUhQBMiBCgdGila6aJIMmtCa00DwctrwMYCEqjOEkGQxoIGDT4w47aABR0wYFFAVQdp8OAUZm/QKYhACgZgw+HwriIFcGMBFBQIIEZhARpDgIJlxiwCzEZHNIoUeCWaP0VWPAqp2jqomJBijG5VeCZXEGAjBmU2gGB5DSMR+IQu216URKNo9RAHA5xr8faf3LtiVOPaIAD2q6j5/+61qOrU3djd9f19v//93qU9bIlmDbAitzj7CjnEiwqmrCKuJRIaCMeoPvHIIgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGrz85Axzi4NxH9yBjfVwc3PziDPOLg6yjnEGt9XB0HnDkA2o0kB4SzW4ySmvNpVmHzlbdIu/4FFyd5jUONVNvmREZrigoKQaYfg0KN0Ao4aUIRkYEERE7DComOIhcOH4JDI0K2yF0INCgFGKmZeArtCwOAwhPJA4xtJi9zYUL2uiAAEIBMFBZVIlBYVBYVLyNsGQtk1pmLO1tMqMmB0oEcrc6QO31/w4rROGb1uIl74Ypp6PDwBtwxOFvJwdAli3AEhw13dBawZRr2Jzve/cpGtOpzdD3+/9Gj///tytgSiSogHUFHvcxJNz8KaSqayMze2aQnZRsyEQgTwyAZCpooOxCyy1xWrMLdRyoFKhGZCdjgMPJocAmWgT4Q+SEpwZaRBSb5hAwxExEGVlNrRjD0ADX4wLHXjoGGjFlMvUKAYhCZ1cxhwaRoOFwwASIhhKApyyFhhWSRk8BwwByG8AIzFugMCCHxbcwsB4xSNZQlrTvw5tdjKoslSAQiYEyRkcrnp6LGB4MjwGz0bppSwN26SCZaziil8sTVsAwE29wwfzn71VW9bSO7twp7/u63Zjtigzv+34h/////qvcaxqDC734eA/QsxfHoQ5cYiyhdcXZoZpQHJGiTCAWo/qpZZg8aJrB7UTn7Y6DzDxHCgDBRsMHAI50EUzaZGYxsOlNUnDDgVXGYRHI8FTBwxEYiBTFMEoU2iWkRzJx2TYZEPAV01emTrWZpGY8A4FMDlA4W3xHtjVwCKgQDBWTAYGhGVgEQl3lnA0XmjhiECh/n7bqks02OOMnyZzWxEGHvahm1+LITBIQvZLr16fRodefdJsBMFoDqOgkfaIQPLPd9m/f+rMPJxQOxtiFjPfKu6SVy7la/f9n7P///UtSOKCbSK4LuJrSKAUc4WQDZIkHT6l0OHMGhRylDHCuAYqWIAFTh2mnZqOAXmbfBZMAuBYaO8iCUyBGSqNVAS6AGdHVjphQIYUxI8wyYERpeihbHyugHUQe+zAWM288cIwCaSDXytNl5gCBxh09g8f6tA6BxgoNpwQoQyLwKbgAAsgGIgUAAIP0k7ES4ZgaChmEcKt6RcbeGAUETO4Eb4OI1ULjwRHXLm3RMHA1TDic9GLTiNv9JD6AvHdOUAc+wiBpr+VA5OX7+7FKqwPKz+a73md6CUk5+DKlH//z//////7f/kqP//5OmMQuFjFzgAREwPHlTZE0bNTwpIAjBVINphNJ8qPE4fUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0s+uIM84uDl59cQP3xcGsD45Azvi4Obn5xBrfFwaPXEDB2yCZxwUxYSGmFJx9VB12VTrWoEl6HMxaRBQFGJAeo4cpM4KAytgqDzNxFS+dwFNJnZgYWhUDgEZDwWMnAAwkeTcw8BwxMqlUWAjYQoCVNlDjFwrNfgYCglK4cF5k+NGRZscoEAMFxhUCFABQCOwKAxfLahUYm5QuBgCvJuD7uJCV/MpHQyYxfJbNdUpaRVqJ7mDgfIZZlD+KKV67KpAWgsxO2jd0tRZtOzAWGt9m2g+1ifuqB2e58mtOC4lLWrOZ9H991///uawO0Ctz0Cxlgs2D4QjsmWuLvKCwLGCI84DpkGXONjvMkWMPwAvLaEdQ85QvCFC2Nw7TXXGwBgcZeVkAqYqVA4QMjGV1KKBAecULqC4hx8XWMCEknDfyMLggetmMFZ6RwmaZHUruQEDwUgnBoOMe+40kIggkkAFFEUYi1phsvm7AmKAxUA8CyIbl8RwIA4EoIoZNmlgBDqgX9IJa9T4TbuGLQUkQr5rkFsqh9VEwiOE6qssqQpJ53HCcijapjHplMyMmAQS412UPd3H8oLgXJn2FxRaQd/LCZXm7Wd+kPUer+3//6EclOVCR8TligsXBhRyt80VFztziwHOBahbGitpAQjxZTB/gMMY+iNJI4j5AbAn+gZ+ozEKkNNzktUqnMuEooGCJ4lIgFbqBhU28WTqEQCBkRIwCGyaRnQ+MFYCdTBBY9InTwB0wgPWKiGRBYoDjAy2MRhwBAQaC5gAJG+keMmYnGIjCyJTUlFFUC2KDiF4JABtA1MNbEyyOUMhZSw5Hkz4rjC4EbrA8muV6pQM2PZZ1LLTX2fy1SoZyurxJHidcS3NPL+u83I+0+GTZu5f+d963yt5o/v/V///91+TrbYtYaUt8aEFtHixR5lrFj1SyFODhM8t4CZYXXXabmiIg4JHjoFVjmsidiMurOuREo/FywNGgF1U3gDMWAjKjJAetgRG5mJGXqGAkxIUUoMBBC5pqiIDE0XUjBlo85ZKAEyBuEhMYCFpO6FwAYbgRv4BAYPg4GGCSGfpkxi9wg6cEIKnSgQmAhioCBAmiyGAcw2ZgdhE5mJzjsNfbJCpY10wEJwMAYk7tLKqR3mirgm34q7jdLP17i05irWYnPhwNdXVqT4//Z178mU57Z+9mX/9K8pECOx+Y5/O/p///T+eVCxoXrDTwagYcAhOUePy7gFQsXJhQ2LGxA1gBQCaQCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaUPzkDO+Lg1afnIGN8XB4yDOIM8q3LtR/cAa3xcGdOQGEEE4XIJFXk6st6oWvmbd12IVBLSwYPGTlyHEEDg4LGN6qN2AySGwEi6EyCh4kABAkzQjCCrKJLIqzBUtamauCL2WbGnTSoMboww4HRICrjMCgAHl8w+QjnAAGBRK4PtposKaGzMwWNxCk0jlpxKJOoo4jc9ooASiPjQ0VrltWK3mYA4ESGkn+9UqxiFbFlE/KLiz5eXBe3cddfuet0EOVZVv3nt/zfK8Qajc+X//f+j/2/9XUlxgXCCkCyzyTmeZJ3vLCx9VzVlyTZ5yXucXWCgBAMb3gP5AZT7YYGc+62Z2XZkEIZ5aIBAw0lHQQx0VAQgZaMtEe9cACfmnNNMMCWUgwLCAIylDIXErYzBzw9E/LpmHp4kBEgA3ZALCDD4kCOaGC91jBQTP4BwyIjQUMU4k6GIiINNPMGgJTcuWYCBRoIWjQMls1C6CneR4V/hYK9fKVRGngedFQDnZs/t64/LZZQs6ypIJXdHguCoP3M6//yeBklR9Mt1Z3+b++xp+fjta9/f//6/+qsjQptjKlBUXtOnLCoaULSLJlzYwcLqmEPSgk0VhohIFEhGodRSs6fUAMAsQa90Fvw9r/sTFCQYVFqwgcjRwRmnXMmmrAFwmYqKMsW0Y9CbXxkatdM+AYKqEoYghFxscKmCQCHJxGtl7hjgDFACYxIaVYMATRBQPm2kMYTS4LeIwNgcBC+KCFO9L1RsZEJgwKmqS4YVA8NQSOUHpDOBfkP1CABgaKOYCgJEHkDTFWbC3gBBlMxPmjggApBR8EYYCOzUvFUQAIIEIOIOTRUIcmp2H0TKAnVaI2UtNZ4XwyZfUXze3/6H/+////////Xat762dWtf3uu6m66CNJ67WbRbrvmzCbJ2su+2Dadm+jSxwWYGUakMLFFACgMwh3n/bsyODXgZpSKrFQUN2MAaDk1kNDhkxU5L8GIiBjBAnwkMYCCK2mBECpR1wMLkTRwYgRz2U4lATPnQukkoEDEArUMTqcNPAsXgYCzCJ8Ow18zC6zCoRYGLAgoCwGAwoAjAwDVOYMBphs0mMxaRBtMyXt7NutSv2hgYWKT6pRsHazI+ukAQg16ds/HUlZdGJPBKBLm5tIGIjIXklFcq49ywZ84PrjsU7Y8s/3V9WRC/eM9RYM/7tbqf2H+z7SmM0qFxCYHGUu2w0g0kY2ZDqQyJDIoMEpNBkImgmtQIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGST45Axvi4OyH9wBjfFwdhP7gDPOLg7xF3EGe0bhnjY2lGMAZxxWUN1UraCxC9KYA7KpQx8qIwiIlZg5XXQepGjQImOXwA3MPAS0zBg5QYKBKG4lvhaDKN0ElJyYgiMY+dTa8RUDwaWY2BhiMNloS/IUGRiJGmF6aGe0KhgvQwdt2bJ2w8mggCGrwuhmsCO/PM6WEnoAMZipCNwuat0U+YVBkqq4WZtDtcppbQNNv26zc8S3cPXpfCf5l+WdaRWtP1n//qq9SWdNgT/t/T////upVHLKVLkUmVTQUO3GUXLHblVGp+8gn9oqAI8jrS4DaFDm+gdhK5GNxV1oFTeU2KokYwHoCTYgQHFBoJ/H2eA0PNmCVhmkBAIugIKiYJM+ezHaUzECEDSeUjFUDNjURYNLXEQokqpcQ405QE0zkDAKfTkdWMJVk1iFQoAVURoOBYCv2PB5Zi30ijr4WSGa0w+KLYd53KFAUZXF6cLXnHilM0KaAABfepD9SLCgAXVSPl1JPcF3RIBz4ABD88ieX5d5cUZm3d5yIdxw/uLZB4D001T3tfp7U7n+9fl/rQhjMKABB8VEUWzKS5Y8dCRswGQAKpeCpRJcqdBd7BQHkHEnhYCSN3UFDoROBgFAPIpgwWjXo0Rk0OQ8+60lfjpcLAPR5EAWT3Ohj5qTZh0mGWBUvEqgIwsC25GDCg1gBWgKKc1oCjAB5M6FAOAhgQ9u2nwlExQGgwlgxgsCJjEwFIgmb3FBU6Jq4PjAIBwhZKBAI5iLbwNCMSg85Sfx4NpTyWetQwXzfhKoyoGw4JKMsClFimXkAibGJdRX7YhAr3RJWytAM9YkbDpOXpc3kOyLesNyifzjWFeBbPO/bwyXNnlha9Xy363f0bfGubTQKKEb0tHICyVCQFhdo9wwVDhdSSSVNXEYCPjAjPiADtE74la2xEvkfLJnbiF1dL1S9SEnqNAbV0nQjErYEPFAKgcYFB6JAyYJBkyd9QCD5i6HqDxewAAOrwgBlCWYyiMDDDAQKGCwaGZwHhgAGKwCsSbAgkoVMjCdUTFoNSADGTmDANHAhAmNgIhDbg0IVLWZJitbJghbIFgDIRAM/hwGhNTGa8M4OeKFGqOaJ+A1wINjOCrMBpEqS4oAkjY2OHQv8RhFpdHwUDQdIjBAHAzJAuFrrKQ4jUQgNJD0+tQp4sorolO3////////9X/q/7/XZW7spFTMvdBN6SL0Vp1Uq1sh63Z2ZVa72pOt3UrU01HZEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB5JuOAM8q3LKZ9cgY3xcHNkc4gzvi4MmH5yBrfFwgFxxq8KOGXIKQxAONSGWOy9drKFmxKmh1/yAvGMgcoCChADgac0JhgYCpjgYBmHBffLxg5lxIwyGiYQmuxyFS2aoCJhIWHIA+m0YNIxQDkFlRspYUYPWQlhAwiv4AA2asNAh56DifQkOBoGjwOZCCACjgWXCxIMqLoDCtX0gIsMYFqguQRcOgAx+hAGhAKWImQYZUggWXhZsQ9EyKKgCAAgR45iQesOaOcgF1ioBUHD2ZFtLykUkSKFphCY1tQi1iolsxQfb/5r//t/////3/7+yq2raq150SOnTmfOoTztjGz7EHrY7KIW4g1gNjVSub0QgGRFoy/bQhK00mG3tA6rL4DmYZlMEWpWHKCVxp4WUAINJaNkYoNG8nCTbpAIyroaAkEOITTCm8euTCTY19FCoAZ6APA0uCWmy8w9QwEZ4EUFMGjw8OpTG5IIpMKgtgKNQ6AG5L3THQSmBxKZnT7cGqs6dmO0sdlSCQusqGH8/huPS0BB6E8/lNBz5Z+/ixaCteZTgkLAur9P//uVy3FW+z8Md/WHcpttPzuvb/////06+mkXQ1DS7yook4Ajq7ZVbmrQ5riUYppRouvB4DGlIsjIGNQxhKABosBRSskPTxuGGwOUFywxEBhIhARUEPdoUAynZIAhzMsctSaANMjEK3ZOWVjDh4FgogYhVFZcYIgBwgDQQuxFDAAEMKjI0IHwIAy1ojDwMR5gPymeQ2DQeEChn5alNsaCbbF7zBYHMjKtGxnMGwO0p3mdO0k6FkilayaBpG/E/LDAoGeyNXrdIXTnJ6HL7DYYp7TJ5KIQLDXIL5/f3cluLc8bj00X67crWVeVcNd////3////9/////nPZqWtFLwiogKMQxYsLIG3KeSU9CDgJIaSDylFRxoRS1CxAyAU2zQYnKld5Vzhsfd6Crj+VZQ6EQJQESdUQwUkEwASE0oXMSlhyRAlAoGrZGRgkaedeSIMAKhSPObKl/GTBaTK2UUYwu8YZIKr4hAawQXLJj6NGBB4HRIYAqXZEBEZIgGAXMCgsBAEzalkM3eh+PurL32hSnJgUQzTfTkpiMEuEYaCszT0uNtl8m7hSNelW4bTiuIzbysyr+b3JXPuLMtanr2//mdIxTDL7//////9FmxcSRpswG+973U0hRE646hKe4VQ/HgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAdehriDPKNyzqfnIGd8XB5p/uAM8o3LRp9cQY3xcFpJkBxZxrhgqF6jsOricRu8uaGy+HIEza0OgYiREfLZBQQmZmsBADAyLhhgFLNIAEYcDLaGJAQJDI02awsajKgLMHh4FaceCZgQ9qXuUrAzFdBj9kgZOo5P+n+apHxirDnHwiFxOChakgoMmOTBVaoXCoOEhwEMJhxdUQzY9E2HImAfkBrtRDxzxORSJYig54GGClUxRN4IgBEjQumBfJ4uOOYQMOMIiiXS+uiyx7WOA2SIxmrl1hnzZRg//+h//v//////X3vdOhpWoV1pUaNVa0aSFV9au6TWfUpBWzbpOiukio/s8bNes5yaYlYJMNKNA42BE5kkXAlbmxCZhMO17mAqIiyiShBlRKJAJg5itFyQKQmYH6nUHhBI10w0bLoncAgJQBIxHEMxIaYQGFdMg2h++zbmSgwa9BiokBZhYYHLmWYkSRRKgqBWJLXFQipiPA+BErDBYNN9HkSArRXfhhukFr7c1mYhBIcD5bKn9vyFopgEKSqe18vQQvnPWKsdtZZs0zXnTc+Q/+s+SjBb1ndDzH/77PHZ7cmu//////53Hota9b0n7Rdtfa2KIvZApwRGYPhi2aLqdsuDITyeOMNqKANoyQ6pZQ6rKIYZ1KFHHCWkYdAShg8LDBAmMwPtCdD5a8xAF25gwBFCOTuMJmAmBppJTCBQFwSqTzMYwWOYRV0Mlk4dlE8Y2gJi0OgIAI9DAKN0AcyguwPOwKQQgEvcogrswKDVB0fDB42OFIQKANd0JFbMM4LOEYiwgD0wotFvKw7ycIGKBAyJslycIuXCMAaDE4YlEhg0CsRc1GXKgWREWMSPIotnWalhEmkTEV9FdZgomhKTKLjf/vR/6n/q///+uv2/qt1Wp69l0V9kFIoKvregtB0kWbSrvuZv6uHoSkBvtopBTwjscdAVOeViNogOtd0YamI0vdwOwVDEMPkMlbmoZGskKQJlSImYyMaIQ1yam2QxUDh8wYTUzO7RTETBEtKc3oFX6YAJtDR5LNqSC4SMORY0iDGpJ8kQaE9OMzIBDpOUZArrgoOSYaDClAgBJhAHgddkxbaK1+HHHvSdgTIDBRIWs2eexrtZgogAsopMZzNKSFYSGSu1R1p1r8rdGBP7Oc5//Fdq5/5m/v/xqKLQrtygPf//+j/t9dJ5amHx6lKGOOXIk8Nh1rxcLhMPi5a5V7UjROSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAbORriDO+Lg0efXEGN8XBps+OIMc4uDuj7cAY5RuYdiwViAsQxGW/QfjTiz7g1365AGdO8UPmVCsDmOh4wCnq2CSdIQio0GutPhBolOYenjQYZzImCvwsXlQxOGHAUCmJu4kEuSVgD5l0hkOmzQCGB4eACg5wkejooI1sOC9QdTZC6G0FEtW2AwbMBKdBA/MIttwgtxYilOYoK7Up2AoVT4SwGCCD6XeNOXNyorMSjVWP5xrNSnmWLVuZf+6XkM/yBO/lvKkzyxq75/////////3/7v/0/GJ3OhZ4mYs80iXJNLCF1AAYVCtxYQnhw5N7TMlIiwLJBdW9qJYaCMgCoGk7cOuypTDtJWbyCIvJ1wFQvDgkZBwICIiCqHBrxAwwN8QmgrBDIU7ZCGAIbOMXkUiIaMGGjLgVvRGpSBlYsDQESgQwLXCgfJRJLAQzm/HgBYIZ0CQWAAcGnMBIEbMBhu0IEAEULRr5dA4K4S3B2ZO60mW2YzE4kFZe92FuBWNjQZh6drcqTUzSSygYpU1Mu1xQyX/EIr/db3v1zY/Wo//XfUck3Mqjv////uv9+m1hZAlYZAJRKzIsQUq7oARVDhrA2xdhEi9bCUBaVoUANYzgJhNMzZe0FOWx6M4TzoKdIzmGwctswUFkoTgxXS4bdO8WVWUAFq37MRBcDB8ZUA6XhZJmAAcZWEaHYzIjFmImxdqTOjARCM+g5oTvIJTczKMTQAnPRKKUA6TMhXIKgdJVNExMBjNaWCwNdBoUKpmiR6HZOSGJ5aZ14VYwpxAA34p8Zb7KpFqRTLny3O3Q3U7LHYMf///7D33IA5qFfr+6/BJCdzP/rOf///3uqVUp4FDJWLB88t71OA70vYoiHoNoLNO6CCYZB0YDSVEE0U3Chh+wYnjIXrDARFW12WMubCGkU0FK0FQhhguUwMdDUWCpg0dWnQMHjE0sX2tLQFgy1AVARCEDIZ7MIiUSCZgsNGSQOrCQHFeUIKwGsMjIM2YzoIEcG6gQpG7IyKNAezJKFggDFvxQDoATAwMRqMBAIxeOzYSpDgRGWvGguQqDPjIj5AKoAWAEmJTHMHLIiRUDKiBBAiqSBSEQIIT5JlIFA6CJfHSgFsxYjUnhb35sYLDZXWTBtqsIkmkcc9//t2//////9X/1vq1a1tey3PMiuqt1Kq2WpJnVRakp1ajqydjHWZ9F7xuMRi2/DgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHQT84Azzi4OtvJwBnlG5aBPbiDO+Lg6XDHAGeUblYCDBS4C0jM44WnukSXAXi7rFZfRwNPSJmRADTAQHcQw0I1DB8ZIHKUjIOMTBJMVRciG6piA7GAwQY+ZZg8RBiOMIgoyaEVLzW5xLsvsypOokARgVyGDwMsIlwOjAzvJTB2sN8hYLhkMD5EElH4IBgGTTCAAYnAxuophwlgdpUqfaFz0VHQCYbNKzZ1vofa5RwSYVB6Z9NaxtOZJ6S1UGgBNSr3GxFQDOcp2Td1+o9Mervvzut/+rzVFBcblfP+d/T92x9Oi36JqIVG3hQ+gKNQQCijh5ICQLGwyQRYIICDylsHAxLFAGKI6QoYgCMRBgY5lMpmxJqdE1ONwS4VZ91mFUegQIoTjGYXTEMYDdgkcBgfNwhEDApdhisCuUMAsRBEwCijDqnDA0BAGY/AS4iAgJ1FlH7gBBgqz44gGFDwoBDC4RPckQwughLeAgNFr1BHcacCQySgQRgExEKzbIkFg2wtRkZAOoNMRQY4MIgStBaKLPLCR8nSgAgmLNWUDpZDoyqsixfDcHjUh4pZMLIS7MSlvURGIRGzEcf6ShSQmaClt//v//t/////rX/bvXZl6ep0Fos160HZNJkFIPpMpKexVdcJIeTc3kDLU9v473b3Ef5+XRNaYlXHrHqd1TqLMYgbKxewlk0raYuAN1CFpG08xkRxfwcBTUgFrmgEqQSPG5WBGtzgNRTEQAtKZaIJhnLHzDhgAQahiKmPR2EBgwSA2CDIdM1vQC5Ix6FILJhU0wLAJkQwBZemCIR6ajL6jUUfqljUhcF/krjGxYai8cFROkvPAYQHUj5nywplYnZh9F3z12o2uKxKusYE5/N1puvAHdSrn8xucuQN0Ij/0/////fyCgsp4eFQYPiA6uEjAs0uMnjqSJZS66iIoHHpi9Lzv20gjjOXJHhTBAY2aVTL0qkcl6nUrOKKC0w6AkhwwFKqGMxIgMiwIEBisnLtdALiRjy7lOjMxfHFiY8AwjC4YLAIATB4YY2OgZT4kA1CTJqoOzCZCtDoYIHZ25rGAikb2BRgAKKHKtUUZMIgIrY/QwMjCwgghvIfKAy4nQPXNRCUDgNQJAzInDxBimK+HyCHnSodIuKRH8pGxDAbHSoZEySJYAqGPqY7ZbF4tpjroFxDUxoWBSzua/7L//+//3/////1ba60fUugmpSVCu1Sa6SWjey160EH0XpUaNVB63mKmr+GvmtFdsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1x4OAMco3LqLibwZ5RuXNHI4AzyjctwH1wBnfFwX2reZwCE4iKY3JlLodtZz9umqpJmuQ69byxAMAgoBQgEjAENWrMHAqAknTIoNY40gwiF3FBBhmjRSNMCHUOChYAJmQAAgAGjQg5rC1GMUPREpQIBxofqXgwNHFGaId4ZmAgwBCITJBOcjKXOLPQIFgoYuXAGCqvIFGQQE8CIFMLKQPKVBEZFuIQzIaLkC6sGoMMKF8oGxmBQKXyLGpkRQhyJMCjm4c4gzEcUU1OspEUMSyaGZR6KaMi55JF1////7/9f//+v1/feizaq27U3SS00u6lWU60F7nVTuF6Qx9zAFk3fZktJfj3OcPdQtqQpFBRDaYgAcqpq9zDoHgOBXEflyuvIOCsEhGNGKhSWtCwPf1Qww2AjUQLWa2EwQE2LKlgQ0qMhCiRKUCwAGjygwZqErcguBFlKgMAAkza/w2EL6MAAcwGbBHZzLKtIzCKiwuAGB9FNrgiDagLFi/Zm4mqAtdWmQ0Y0iZFkRjANXEDaxyTcjTIukQAwohaiobOTAwi+gRcHFigfIaS6IQhzRimVLLdAnnHabMTxU1JpHRsIontbf9rf/9ur/qrt21f6v2Wr12XWqpFkHfUp59bC+m/5DIQl58qlNdSwyDsxQwmMdFwVmJKOtPMZEaEMMQwpxQFAVDzuQqJvG/j7vxQOAMgkVAL+AIcDgJMmM5edFACFcMs4GQMr8wgGhIVmpyUFjWZqBA4LDCApYgZaJqWclSlgC2YwCQBAwoBUjAaDzwZ4Mb3Q3cFhEHhoTtKYy6YOAKHzQTA4XMyKNkTSXlMWFnh+JUCxMDpfwCjZWFzl0okDENAKficS4mblwNwUUjc4LJIsQQuigDoX9JFNMknXYyIiiYY3EEFuyJVNGdB3/2///v/+3//9f/et92dVlKUmgy6kU9FSp5Dq/4oHc3+lu1qK+cSKO8+r7diBuCH0PCopqOGlqbbrOUv3CWbAkPwY4NnC25QoGmHhDOjDwlTAQDDeN4IRs0sdZlBYKO1Y1sREDdJgxeLnAJABCQqGm1oSXo6AA4gUtGAGK3UDYlFdngFIp2F6GHbiasBpYAw8ABICpevSFwooGtMdA5nEIkwHjbfw5g6Fdt24lA9IgDI36fWNTkiTMis9Vt1m6cxjERUhU3BsnuI8S3OYm/7+ta92v+O463/6mnl/C4r30r///42QzgvHLOABCAoJiBd54DBwIDxwIBw8k9FhWUBtZ02cWg4tISSQOJQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZ5PriDG+Lg9ifm4Gd9XF2F3N4M8q3Lurebwa5RuUJjoF1y2xoIDCPZLK7+S9pr7u09UHwA5BCUgAAb8yEdFRY06xbottyAMVPPHgAEwQYWNMsOKFzEDcJCQKBgMzYMZ2GDRU0lC9myYQiSgCAA0BFdgYCHgioMtQ4sABgQFxlyjAFV2nUXORBBgtM1l4FA92JHRTl1zI4jcIk8xiGZPXm8F9DQtfW3hVyWDl25XTOhvWnpuKPY93U///Hmorz6Hn//foJXhd83/+q//+7Tryz6WrItFyIfYKOtdaA6zC3IeaG3DBEXQbAcs1IsCKAsFGAToCEnlsaIgENQAPOiTAfVIK1Om/i+UKwoNEI3Ex4tWEHWVSiVmDChmIc5ggBTBixc6qhQCnQgQGMRO1LnGPjQhBzTm8OLgqAjw7dRlMKmpMTADEhCFgHMLgMOdgjMamlMDAPbGPCJHAoAiCMwIB1ZYsBRg0DRjOPxYANPlt2wNkaUplGGZmG4Oqlkb7uzEXphDBXSrVaTNhz6bqQFAdvcThyymvWxtwN3/+rj7DcvtYf+8sWwT+8KS9/2/3fT+P27f8H//t9/6vav/+58k2rvLVoH+EC8scByoYahSgodnd2xr+ih58HCgfWfmIKLCfThpJNYugItSgRKpEdIhC6URNe7lxKCXGpn+W4SlEAB0VA4qLAKAzgqkIhmsA7RExWAKXjxeYMIRSXMNYiMsAI3AEAuXTHZCUHMlBSHqcAgJ1mZGNVgliNABbZgkYHn5OY9LQfVBQhO0NAoYDy+0wYGHgMiMbIIiAGApwY0cwjQv8SwAAFAyqrwMGAEYqJuRUvjmhvYsggSBuXws4RI0K5NDNmJFYzxTC/5xZeJHeU0zAvs5ADTss2KDrS///6kG1f/b1/bf9Se3q/spalou63X6Bm7q6q9NBCjmSnYChR7sWyEWXnU5LWokYHGpSQzpIFKA5iRR1TwyIMsPZSlQ5Shqc8Or8diIXrCY4IHxhkWJ+AgTy8waTksIwYHDBiAAMZtA4wsdMCh8vgUWwwsUBaipemDAa1Aw2olCUwlNXAaeYGWYKVwCNRCCzCZUPRwcwbLwEe27iwpDgcmskyYVA1GqoRAozYYxkAPTAY/DPjmBspOIAbw2H7kVJwpqMyHADJxxlYvllEWkmTx4niOTUSAy6QdKUTYjTStJRKm6Qzy2H9fQYlCeps1T//b69Vnr/+ur/+39XQVep1L2WupdJSnayzRG45GZ8bAivehLG/ekZAOK7sOE9ClUSCHJqUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHCD84Axzi4NvtZwBnlG5bQPjgDHOLg546W8GeUbklbA4h2c/lC0DlwzbYldUKt71N0ht/oiuEKDscBjODIAPLOHBAuLABuYJBJmMMu8MgUDBhNUEAFBszoOjAiQAV1MCAs24AhIGGKxqpNf0CLEZgYFHpiQHKAovCg9MvUox6tQl0FQcF/CYErXCAQicztQcLgcx2dQKAGTyZtYai6NtMjUZ8IyLbcd0NW1EASCZLaxrVF1zt+N4vFcxsOLZaBZ7MyP//5mf1/eP/jl/545R/WFr0f2U/9P9VmqgjaWEBVZOwGjAhW8SKacUsNAUFXsOCQ60TC5sa8QzIcU0LIateLtQk9gTNVX60JvmnNq+0DrUaZCYef2ByQcGGA2z0oJ6AYxINY3LW0EjCmsrcYdALFjAwDGg2apEJgE7CTkVSSCmxQwtdQRtq5icZhgvlYzfBPYVKZhGTAGRgZ7hUApAhwJKgLlACBrTC2AKAhscEMWZS75iVyiLOHGUgNKQFbEsSpikZigAMsCKCzZBzYwLpqXRxF1ZKixFAQmPqKR5tIovK55I8f63Nhb2KZ1tX/3///////+vetP+vRvorPm9hrBsHr43ru9KqE8EQ78vw+2CZksHXSLthkxBMznh+abXAwYcd90xYedZxYqyfcuiTtuaFgyIweMgAxmBxCEDb41LxPCYCARgsfLtZ0YOBrKhEBFTGSy+YEgRpQAkheMuEcwIBAw0BAWf5hW25gEYkRRUqVlEBOOQSUZxoPGJCGggOIbkgRSpU9bTDEAeMrmKtSOrIYNliHZ8nAM7gAOArfQiO2cYEMGAaMdtdzbSWY0d5OWLXOyLBW6j7YoN/++Ufxrnw7/9/monA2dQh9v9f//I1J0uYMtSeWKKTCYKzDhBNg+RA7iiSzVICAcAUJjX1OYxYXDD0JXmQAKUHLyLHqnTGQ8d+ffSUxFxHuhiFEA6MNDJQUx4ClBzM4yl6PANCoyF2dJGjAWiYiGjFjXRyJBsAkyqAmFESAg4Qvh2KNeLhhwSEmG4SwJg4QHaH2ZAdJv0BgERpcolF2EcwUJlMUiBwmGkDgLEWiekvEXF4LSTgpYHYA4AgZFSJlxArgSVCLE8mampDSuaIkwMEuIJDELoeykyyqtnUxIJkemspn+pEmyCJlkz1/Uv/V+///9f/V2rqvW/dbv3RQWuyKlOmxknnqNBVF0z7SfLZHHXtGw3BhY6guWs+DMuKsHzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABmc9OIMb4uDZsOcAZ5RuXk4o3gxyrcuhxZvBnlG5oUlyAzsJFDopdJYvGpdG2WxOmjdmEkASYmAJPgkGQIm5LyrYgEA5uAC5L4goqYMDQJFExRqEHwUSIVNDlxeBg6LdNjruSBaYXEqdpdweCqEZ4kqGCbuaUA4wChoItWRYQ2mlzuAYCExjwfwOpY78zGaVR2Tx4ywU2Uw3OVN1YsYFBuNTX2GT1r1PaZVP52oRtjeGNeBf//mLGPean7//+sKr2Fgn/++np//9DbJ0VdWgcBQuLvZFxd5Q65YyoAiObFXhhQqJygsMS8TmkpOOUBkznXBDIl+pkxNOBhigUVfTBlD9RihFQgY0H4hAhAJWtmQhCvRr5QBAVLp+SGFAXFQEC0AhmlGrmKBQrcYzAaUwIDbHXsruQ2Qw4UDEICL0KMJrHgQEYOBRRxguEUvVgC+yzRYOslWBEIAMQJcv7TxAbhDy6NwuBkADPhgUKEUODpPEmOQAheOWVHQODoczQil6jAcahnKBgT/lBFEaymKD9JRRGipnev/9////////77et6n6qCtTKTRqtrtfVsqt1U6lHUE66qCGr90E1qOHu+vZfj58Hcfcy4DQFuzeUcIxFP1/nEj8FNNjFmQy0gCqL8GA5IEAKMhq1UcDEAZMWhFwVqjQgcUwKE1bTC5jEc0StMFjk1SLkgwc+BIJqVlrV7ofiFYhhqGgikiDBWeoQxh7umBAawkHEwoAgNFEziyNrRgkbB0mKwO4rtiqE8ETBuoM8OQBldCAiAJuiTxsSo3gRBAOcTqKahJS8Yk+XAuZYzNCymMoTqRcGmrlgnVjMpLLR/dBQ6CKrTPJ9v+vb/9X/qtq1f//269mUtOii6CSmVRRQW1B3TdqkD9KymdmRRWZuqasy0WZbKs9ln2rZBaS1HfR2LxcKZoI5TRDO6YXCJikq00WtQQuRll9pURWg5igZjwfAkBmaQkRBcDG5NWnCgyM4F5hag4KJyxgYESEGmLlUIggJFkwMFwIEFNTEI8QAyJOpnReYwagAADBQApeDA/OaL4kRQ9ogIDYML4o8wgmCapnQT5FUIX7cl7C8T4zY+RH40AMshAkFHIJoi5TJMWsAB0SRdKyCJGFAnDQukMTPojuUddE+ZbyMOKEJUZv6lmQtk4ZP7ev////q+r//9/13tbqv1qqtaqhO3SoHlIOtKkuebSra6dSnZB0XSSRUa0HU5xTLUs2XzV3kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeQjzeDPaNy6Q8m8Gt0bl4qEN4Mco3LQLucAZ5NuSEYtyI1DlPMV0aUWYn48rby9qbJIBlDTmzPWkKBQSGQCMGwbR3MFy2VWkKhBgEA0UUoEQCu+YFBClGYQEMYRnUNDeYGCqY7BgmiAi6iLd0EaEp9h4jSgth4GRUAxgXjHlGxiDzMEIRCDZQIrLgKApcl2HyUVIQgMDAOR1WU5rE8QMXORAdIGs7g2xPC8NR3lUhQHjCfdBE3EAlE4Rc4GMi8ZmJGF0VstI+UPOHFD4yLH9aTEYNI2M2TXUr/9f/2//f/////2re9kkqbbVM7JJm62Z1J11TLRdFBVnNXulRc+m5mmgzKUpSbqTq7LoqdkTQNWS8xjCoUCgm8Zo0mMkmzNgy7ICk0SikUfZmgjKTUDcRBZpBUhLDDlramBiYybswqgTHDDRvwsLBYGNAlSwGEx6pycIDCQAaIvto1xAUnNCzD4weoAxCU7HDoEfIXKgWlDAemsUBZfdNMmDILVWCoCdMSjQI5U4PgTcK8JSFyCtgAoQgMO4pFM3GWJ8AYOH1J8wTURYnTMumwnEyL6Y7GKZ5E1O7uRyJgMcgs1UvYzKBixxX//91///f//+/3/XUknspKzJputSC1MpV10FTJNFN1uggtncxwAfofPyxAq1QRBqTts3V+B5J3oHR1YOf9rBILKDMjaxFmGt2oXTl7xRF5AYFRGCTGIgGAgaCTpQBHQAoSLU0Tgg4fK+BgiLZGBDGYHNhj8BGAgAbYBo0CDKgtWswxItHoZARgpPGQQQ01IgwSITf7IMXZE6WAwuLQcFRIChYKl8lV2hqYlAHRBBwSbgw0hCNDiRGo0xLAMbQEF0SgWSKEaXw1FMzNUCyIIl5A3NQ+p1RsQFIapos6TOpzIuqM2UOQ1q5HEKidQf/91K91///q9v///tqvVqrpPUboLrmaKNF1LNmW58/RWZWWbs7PQdk2WktJNlqZGiYp59Qehg38aNGo0t4dZkaFQuMNgKrS6WPw9eUe1B7iyprhCHTEwaGAMYgEadSL0UXOCAaaTAaWcMhwpYkYBAa6TPZOMEh0ONIUFxVHLjGKylLl1O2y9sIwDh42mCQIv4wGJzgqEMIJgaaSS6Pb5JevO76eKxxAIzF4DaI5tsoCykBWTgxgHop8fBFi6cGbJsA2YpdlHHJtjM0QN1HThD5BEXcyoabxrs5lq1KHfU3///6/q3//X+r//+vfbqrRs1NSS32v+talHU2Hh8K6vvxpmFO6mz72ejXudKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGjj04Axvi4OoQpvBrlG5eZjjcDPKNy63Em4GN0blRdpBK8DEBhBo7XWnL0gOvUsuFqkgCTCoCYMEMLNABiQFPFSA4DZAqQieVhGzCRQ0owECUxMnQBoDASuDEwwArtGumilzhve4kEGKQMYuCzXFNwwCHHgmZGGoubwaJUBsaMAARb6xGzN+YQDJhcdIaVn7o70VaFGIFMBFN456GINgLUdYdT832stKQTVLqLVcsIGyjmOVyD///+59bm5Fz/1z+RoeHf79H6vyH7sp1xhm8VE51c4dA4wMAQ0JhGwSFR0+C4hDxU2LIKPJ2uE7A0JFcusFjJqVYrFTmS8YnQKdr/h5qNBDTtRpZhYGowJ1VwM4hINGEhG7iw4IEBg4lDABZ4BhHKzAAXco1USRwVjypMEhMSvyojBhnZw5DwLudQwGGSY0J6kwGMCBs7wRjBk4HQQ/yAJ3gYGpc6K1Fhm4mIwkPAtSMPmhERZghMPkNRALFCCxQFxmZqXxogYZAI+M0E0iGma2UKkmckCWNI2ZEqtpll1j6umzWoDrFW6aNvX//V/+v+3XX61t1dXX6alV716T0VLZvW60UK3SZFarqQRM1nk2WtVjqzjP2ZJakaRiaQuS2a+W9XWFBC/SygEibHRknu1BblDIMQeuBKdfDysYnBUVmKgqIggMhkticaABQGIgYLFZkEPreIQIYBC6+xCIUmTFxXMBAtPYCh426CwqADTxnJgPbnkoE5xIIhg9Q5OODRwcjRpg8lEbPKg3jKQQBEjJC6KYTKTCI9M/GVqLDn7SF4XxIR6AqGAyHwgAkpw0TYsgKBDUtlY+sNFKpIlpITqiYIjAMRmzJMslBfOkjIfkFazrTYxVVpfW31da/9ft+v6uv1etVdVlq3Wy12W1adB1LqTQoMiz0DJJNamWpChp3ak9bJIJPfTU7OibppoqTZtSSrPnUUkylS2EOp9CXxUXa6W6latDSmDJjQ/dkM0qAhOTRDYYHTHEJuJk5RE28Jg46ITeRNQxgAipghcgsEu4qUE2IOI5jTEq0wZ4QMbArYuxN4LrYZeEwY18VUDy/M1HAJqgRAyFSEZjIy02XKMLTQcMNHkwlaKM6YDHBiM4KCA8BcBgMM6O4myqRIewMuBLjsWz6BFybKReC5gyPnCCrDIJaWo2epZ03WOukavshG6YLM11K2///t/+yt//rdX9X39WpXRdjVA5RVZ0zymzBTJoWRdbUVJIUNNJFRxE6kp3SSM0rGqkWd0VzymvAgeyvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1qMN4Mco3LhDybwa3RuWdT04Axri4OhwdvBjlW5amrKBeiK4yxWxTItiz19HFU6eB3cYUsiDhUYhgmT/AyuMAgw16XxIFvqGAEx6HMWBmEwNLDAAVQ7GCxkFgQiIOkM0iIFvmdTkqxqDOhYCKbDAAHgSLAlVQUD5hVUGBBsLl4YFKeaJIFCbaplK3qJAwXgajOQ2jvEqXiBByRMilANmbDYR2GrpmRHg4sKIkmiowK5uQVQox9SRB1jhMXQHltkSTWYJqKydWgfJhNSv/1+v//b/6v1Lt/0Ff9PU2myS10FKSSTRpoMmiySTnkEV1q1TBTqd0U1PXUlS0nY0SWpF6bMtFrHUaorEOMtwQdDthVhKYGACJmQaRA6B4ncnKemgJhhULwKXhYENsERQCM2G5AxYGjpio/IkZAQG1TGw4aCTkh4YPCasBwIA6UvwYykiwA6cIZgrcKH5kwSJCqdwNRTpcoQHA9MBQAGgdWkxINVrREaG0wcHCoju2xmXk4M8H+DABGjMgc3AFpg2jQrEsNcQkAILh5y4itAmDYpl5APnKSKyJMGOGdR72OSguUm9IfJLMt3qv/1//V///fX///qoLZehf2oIOtNnTWgm92TujQU6bO6ZigoDXR0r/OJ1YtovD9jfQl7gJF1mImg11R/QWYaiLKqr8w6z6Gu08fe0YUmQDpCm0QDIk23J2W4LdCCjyy0iERIKDmdGOWmCIGKADsM7h5CabzKrDxMdkCwwUAgcIE3FvCADGnC+ZGhw1xhUKoB2LAQJqFIKxpEFH0AAIaBrQn5qQxxosocoxAB1/yuPRrO3OAwE9/PDC7K7Nj383ulknHitfWgfL/+5Ux//lvf/954wk4//o/9P/p9qBzFiMXKg2IzohJnjjQ6Max4SAI8Y00gPip8yfFzxA64gDIMEQ4gOuukSDJIAhoJNR91uNhXssNNRCQSpw7EAFUVmHhAOgIzKARUCAZHMoYeg4PMZ1kMTFoKYuIB+ocZ7MIWKAOEpITjA49XIYkIyFi14cf5O4ADEFIhAIt8wQAjtQXMPKASXrGGHLfEIeaykewJr5hQXGVQgTAtfrFTQgxgK+QENaBkBCi7HILRbOkYRUDBxGHMNUzRQ/IGhSiVIGEbyg1eVmWfqdki6ogL0T3UkiSLoO/91/av////2/t/+/XWvo3Zbrdnddk0KaSlIutS1KSXUt1MpndkUVIKSRetK7VnUDRbCZY2YJqMqqVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAaGfTgDPKNy6FDm8GOUbl5uINwMco3LQ0DcAY3RuYSk0YLIjgBhZjIt0kK+2g0Eqh2C7sk5LBkSgpFCgIMMBthg4ZYddIsmjS1F0TBIDhkwCCG9MDhIqCYoEJgIEAaYoqGCyQ3iezWHvWgYFLQKYDC09kvgNjjCNoNDgpVEWCb9EgeUCS6gZnCzTHQFf158CokToyBBxcgGVXBsBFScJ4tm5mG4Jdz5qkKYXVImRdUkkLhYgbyySnpGLHqyBVbWKCCkv/////r//////6r6+6kaSl+yCanqvTWldvRSRrTzW3p8pXfsbE1h7hGrQiSNxVzlzzyIqbS/S5WeuuMKYQPC5A5DxQU5IWEJgkEjgLBoqfIxQF3necKCYxUQrjSx4oveYIAiWZlg8Ch0SxDAMarAaWRg8uiwMbvHGyKHAEQmAQijSyEwKJjkqjMlkwWjAwCnGb9FdViqD4p6GCRYZ2CU3DKzSVKI4RglYTsBj+ggMgOco0MBzgNGnBYCTyKkxqEizMISs5uMmmINLqkSpsyRWUOcmsvtpKRmlSn/9Xf1+v+r/q6v/6v/+nqUvZb02TaarepBS2Ux2pGgkpTJ0loqZNC5opZxlqVnUGdFI2UfNTEdMmMLoioJ8QZY0DU2GeIpMiVojK9m7O7Ru4+SjcUEAtMCgWSDTaDAOZDPjc3ICwXJAe9BAAQYHoiFRfDhg4RkiKBRFEZkKo/LQAA5kwReocASzFimO2+Bri15wCUHmrDIYZxQwEmOjQmfxp5QASYAspS3LqGhwILBZrNs3IGYEUHaK6Bj54W8JjwRIeyqXAwuan1OdEByCl86cIsbrLwdpzE1oC2s6k1lZSbSd6V3J1RxTK6/vdS9/1e+v/1qV++pbW629FltdSTrRdbMp3ay6S2TUiYKWpB1oJspzrrWpJlMkiqkmtBNqSkEaLooILZaBlBv76eSBXPvey4OYYlhk5KqXNwnYY1DUDSKDXflhICgocZKLTqoDNRJj7iKvM4LWsNsBh9lQJEEJhkLmCXoOLwCemTkjETDmBjkEpVt+mMYgdGDAysLGCU/BuoYu+kUamgsETALirmR1ZwjeECZiJul5E31H8rEMJ8oisgAPRWhJk8iTxfJgDLDxB5qfaMeaqM45R06iOiI6LdzFWyRaWVcsv1TQtf///r//////q/+/1Xdle6NTKQ7IOynUptatkrJoKouyF0FJM6JkpHxhcjw460TAQkRgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcCdzeDHJty0xDnAGeUbl3uJNwM8o3LIB6cAa1xcF3ggYYcFSRJM40ODOo0u2Fxhbj9utDkWjqVIKXwoBzCAqe8ygW4FYSW4Fme66qhhYF1wgQoLGCQcFEcykFAomw6lZg8xMEiSyX6tmGFSYEE4kDWSjAYMBm8wNKghKEAEJg+0MQg+DkD21VAIxYZmFwiALL5gfxzRQYs0rD2B8oKWIqRI1ImiWAcUkiotUdh46yQyp1AuifGKCaRwn+6iIKbJr1LJQvNZrbq9vr//tV9b/U39r+tm/X1uipnek+pN0qboLZaapm701Vrn3gW9OdomDhjaraPBXMFxw1FohwqnQjKFp5IhhCij1Oyypfj0wJGo2yjCkghD0wmBSQAFYVLqGUgPIImKAMiX8KeMEgCNhcLlUAgE+GDx8EGowoGzPQKXKYtN6NKckITGWCHUIBkKGANspgISHDlCYiRoIAbvs0Y85b9hUAOahxJg6YpDDae56y4SgwSaH4GrYYZNGx4nyWJkCjQdCbpuTKjjl4c11mg5sSHQS+em2o/1SkSNaP/7////b3////X3Uq1SSC3ZlrZFG1XU7tdbUK0FLV966ndrM9b0U0raWpzcxVRjkTORZZq5Dg2A3ZohgJheLXHVWEkcYUsd+gsrBxcEBYvGgkMpBmlM6kh/3eGRYZIHimrjBgndYqDR3BQFiqoFiGDSiZZGSIZgQkkw0T7fRnzIjDQfMPhUiGosBAuCzSpYMF2A2oAAsFCgNS0wQAYfUUghngEB5lAGxBx35PEAPC+IuJ1A2aoOBG2YEWJkqizQBRBOpMibidyfTMGFnF1JAWeo3dTkGtUokZbx0up2RWgO91nW+9T+y+/9dX//7+v6uy9tO1l71MltoKNXOJ1Opkmps6a0Voqekjq0jqCaCCkkVJ0FrZS0KlpJrrNUT0kxDMdm/y5hkkYI8ZCYJAHpcF/33wYPWebJ64nZGSYQEXOBky7Q3W/0eCxQwhhnqRwkx4BigyIO5zBAoehDJY6B9sxxoztqzLAOamqY3FIGYI0Nh4EjwGOth8Ci113pXbGkQHaT5k60lUQgIokw7uXwZLYvPukQCOfltXC9KpOYNEa/e9q9q2sbVNFs9ZOdkzC93vf/n6t75/77//+5iqPTpVp//+Pb/pRXLk55J4gZUu4ExKKvCxR7AKaDAODGgUTpEj0LYVEBxKgiVCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHfog3AzyjcsZHpwBne1wd2hjcDHKNy65GG4GuTblQZIg06BCaOYigKlMJfaXPE1Je848/Io1cUIBl8AJbBC7aUCpLAbkAkWmXByqxJ8wICH5BwrKBCYICQNTACS5gYVmvBMzhFNCWMAN+GHJbM3Jj+RBV5FATVgKMVtw4kAAIHi2ztDoggxHVtm2BwsMvgMiBdeuQheK4y48A1AgLaQ1MumhQIkw5QWTkRNS0qKgbGqCxOqCZbGOcqumXCEauo+mYM5SSXoGRNkCZEx/v/9XZurfUvU2v9/7K67OvW9L2rXWtSmQvZVSzegpNC6jBnMlJoupNJ1pUNJNaB1RlRoJOySBrWkxoeQEeJCxa0uoZgFjQJTN2YSQXupg/8ta7UePJ6KZ2G1KgiXrkpkwMW9NqIn9YYrWaMQxdI4FKbEzARIu6c6lCEDEk8QFhnITHgVXw615oDiqqjGWY0Lv4wwEG58FsBT8FCbjs8ShWPDqG0nZapMiC3M3CKeOTlFYgghHHmm6GvOwXODQyxfDPPN6KflLlOb5p/MIvl+OX//6rd5/zHf/m/1TDj3///Qpf91dDzA2kSPCYBJESIKgcZGNJnymQLSAWc4MwNHHwbMjw4wsgXB5PVpDNnkBFRTjarTTriSnl8PbPtwuNxZuVCUCiiKgcACLEz+LXqfcVC5r0Cq+YiIASqiMEdKsiEQJQQ01ywOjRBFLwGGA1KWjpkqZPAYQQBkMGOorkZDxj05mOymLgAcDiAp4VJNqGAJbReQUFhqQWMKXrPlUhpgKyRcgQG4tBtzEVMmJ1EPdHEmiZnA5InDdM8KCZRMCyTQknWbEX6CSS0VyNTVQdyPJFk0Xt6r6/6v/rt9Whs//epvorWuytTWdJbrUzVsm7IGyaSJhda3TpopGhpMFJrW6aKrm6Claa2TrM2RUo451HjfqUc0s2lbknuQjhwIZ/OROEGXhljvWJBHIrDLoxtqIjFZgAAohIZgoGGSSygTWOhWBmeUAdmJACIwMi9ME38EyATmEwIAQOTSsiAxmwCOC8qNKt0kMVNUzCDwgaJOlgoGiI+YKV4Ga4qAYEKwCgBXygYlqIQKIwGZQADVneoibPjwXR9QOfTIgR5MuEUFCgP8PgzUo8RYeEVGBuaplwctIdtkkK6pqxDmUk2tbIGjHDJ/W/b/9dXb//t27+rX+/X2RUilpJtRZHbQY87qSahRUsxTcyPqzdkTNkWXZRldSCalOkykWSMk0lsmiiqYr6N4JAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB2uPNwMbo3LsEgbga5RuHOo83AzujcumxZuBrlG5W0rEnKIqIGGW7lpcK6muQcu1pcfrtgYOKnBmIEjICqAOCTWkyGIfMCFjLlJSmPA4OggxooGhpiANTjZwECnh1Iyr4zsxlTRnSYc9Zi4sIQhIxqBKNm1qAAnTrgEYDlcrpJROlEhFmyCIwUFMhaVN3RgcdpkWQwwyoygHNBgSKnx2pKScnCFY3cxFCmhgidFpLpusW6Q1Fy6T1dc3lxpSP9lEyerW/Vt9q1/99Tf719266v03ZW/d1PW+i7oIa0bIstRRMa0mpnK0mSSNaLIKmyF3dalU0FVIppoJH1IGVnQoGZtSY3MHWykkUGPBMMs4CAJkBIrvMaXSEKwqvS2U9Fmot9LZ1nDFSAYmIwgyMweBhICmDik8ziEAmMEjCA20Q9gpEVAEbvF5gMlw+Ih6YLEEGgJ1S2DW9XZBgUCIdCgUCJAYNDZ4VNGDgcPQIQgNG1XjEoGaU7jxmAgqAQCn5UkhHkTIqRpmQwDUFhpkyWzp4ok+BkUZBTyLMRpqZpMRd0TAgyiLGGjfMyvKeg2ypgX0EkPV+/XX76X+rb/+pVv+370F7qoOaIuzOovorPq1JOdRMkU+mgo+paaSZxkDqkWQSppVPQSdSdSmNk1opU03TSsx5JkEmOpOBApVLM2NOoaMYFKBoNVkscdn114JyUu8MigKXSQCNFKV4GPq8YgwwUHN6N3EaSCjBdhgqMNDA4FGAjw17AkzORLi65oxtVUoZc46e4yAAo8SgjaXouOmDM5GKqJMciyARLMeA4EWDMKBjCThib2QGPkpLC6ZFBOYHMjha2MwSpeMTQxCw4qJTya1zQ+K8kZpjYOC0G6ki1oLUccm2s7bqWm6KT7d+/f6v/f6v++q/WvoPap6l1UKL6FBTKRrMkUV1pOgim70VLWyCm1ooLU603Ukz3ndBCuySCk1KqToM1BIwSOrSN0Y4ELwgkIXvEUQeNOOXGk8PsVYBacJ03Dd9fpALzEQPbCpYJAQCDmkiQNEQOTMCMgQbfsKiQOBJsAyAQHhASMBA00wFmoGYBCNA9mrcYcbAYMAYQrw4Gq3GDBedyLRg4zApPKKtKdVarrwQ2rJQIHQaDFxMtfgppFYVw8O0Aa+SJNonjyI4QDkgqRigbsQOmmiyTGRIsRUuqQ9Z0vR8ITNupaRu60W66lb9Xfa97/Xu3+u//3/+zd1dM4m6CkEmRUlOumya3PrQWhWmtFSabrdE+myToOgieTSPoLUyLIrdFbLo02Umc/MUWXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcxiTcDG6Ny4HHm4Gt0bhziMNwMbo3LcMQbgY3RuWnFQIrU4GHkAgyAxQFgiZ1t4F6u4ziTN0hpYZMogAwKhBYLMLQoW3EEC5FlkQOoIW3Z6YyghASpsYCJG/gxgBic4aJcmZkL4s+sQA0lb4CaQaCKRXcaiPmQz4laqHKAOAIQCJgYQkaixYBBpdKA2KS0uieRyg9QoDGAbPMMAgq2MisOgLfS6plLKcoqNhSJfeM2gK3SWYlp3XQKqRdPyOQ7MeJdTP7a3r6/9X/Urq//+u/d1LUu6PqqpI1sxlW61U1Ht1Oig7pUGm1l1KZJmUzqU9lmKJkZn2RdBBlrdHTNoDIwnlK0ozMpSNOWWAAovKy5U7WXubR7NyNhVp2HFLBaZqJQ4OAAcCDAhTw8jkFA/bPUbJYFxtDw4mPFC5FMRlxrBWDhAxmADABeMOvMoEFTgmwiIWR1KiMbHmjJYNB0Xc9QsKgDCHneBramw8R3ZhzC6MYTI+STGEBokYoxZKRQdA6BiyAti1ouRU+gtiKpnDIn0ieSWq6tZVke1D1JJOktf/1Nb912+vVf1fr+3trq6mXs1kl6LIsyDJUkkVGLpGajq0FOdard1UHTUnZ3R1O1a2dBkDyKlKRam2ZIumbMyR9SjRaGssTccnKHlNR0VS2yqiBNsVpbMM3qaHI4IQcIPWSGdDJESGkEbEGbiAGNGQmusyb5OMxQnKBYxIIFRsM7xEYHTGaSJmAGp92I63BKURC6CcaLV8teMeChTdLSuWs2Moc4EAwWudHoZBwinDASB4bL5cHLFHLAvwMlfFwkUPmRNx0gLBhwLUikOhNEwSHOpoj4UOE1QMF6nZ0iLPMTTp2L04///Xr+rq/V6qntq/XfW2g/szI9VSataC1ppPQNFJmCk0zA3WpKhZdOm60zG65pNV3WaqXWqigp1GJqx90Fpsma1l0OB9pZWlYzNYgFqtMqDUCeNnLlzjAYYlkHvS5goUmHFMMQWNAoBE2L3kJJkww/LSwqBywmEAaDmOTA6ZGZgIELjWQdY4zIoKufZfhuoASDTRFONEQCmZ99QSLgcYJ1LTY4sGyBRCCvAAsZGAM/kUhJgdRGkWPDRA06QZweS6Ylw+Q4Ez5TLyLoC+TnWY3SOEUUQFOs2vzdRLZn20y9bV93+/9Vf/e3+3/v+pW+rpqWurdalK5qqmgiigo+ozW7OnZBNJ2ZFM3NLsyKbJqc6ggYOt06SFzAzTMlYnICW5gUiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGuns3AzujcuNR5uBjlG5cAhjcDG6Ny5HIG4GN0bh4llKwmvgHHFsVdtFXC2GGYcdxiUqht+pYFyMaImFEzW00OmoPY4heZcUrMjbtv4AEZB4x0DFUkHWwBNjlz1Nky0CTGeFWNjj6lU0MyCkiRoGKgSbahmROY8ZtVRVlyIKogABN2XkoYZSAJWq4d8lBjiCDERH8DI5BRB5QUkTRSACFicUTiaRXWZzFZkZnCAxGR9ndPUo0l1UyborRNFJe/XXru9tv/V/fv+v1+r/96lJu1kKkGSe52uyzZqtBLTdltdndnLr0BFc1QKC9kzMJrU8gZyI6QFNCnICjAyo1+lHpcr+BWzsKdSXNElDuThKJTKIWSmQNEgAYGCTaRJpJjoJweylZciAIcIQAY0QZgARBh6MNiEz+BmBmCC0UA6CnHXUqsCC0XSc5lRdE6cGjDCgDk46Cpqqai/2vNJoBCFiYi0kujBomiOeRotIGiKkaRcql1Ivk4BgCwyRMzxwtkwfY6PZsZlgf4+tR7uUEFEGZ0fdIsk43/+1//69X7b++v/v9XavUuigtTsg7IpMcdWxggmgdRaannUkjTZT3VZVSFNNzJdmWklrUigkgmZKZSkkdEupMtExeRiCRhtUZZuQKcSJKBv5DTaMzcyNx7OVvkOD4KK0CJCCAAFMMHE+1BwgJM5AKFarbskAw8NCBkQYDEUOUhCenOlTIxpgTlUfkTuP4YUQAppZ2y5PU5aKLzBBUpiRAjTBQSbsXPdtyxgWFQhkM66pmO8Z4SYuiUQjxGiTClMXzQG8IxUED5kThoifYijIKGksUmgyKei0vrJ5OP713TmiaTVVr//Uq9+rXbb/3t/f77VaKnW1lXe2mrRWYGTom6JqtBVHdzrUWZBJJ2Re6bGjsgyjGyLJo2SdU6o3eCVOI01w2BMFog1T7qUrMWO4b7PjUVLQSGXunIRwnMRJ2ZlBWNABi4vI5wCEI4DSWHSgUnEZ3hNpYCqfBFuYQVmuEwYCmDhaBjPHbYY64VxgNAg4aXWFSo9nBMjWhsAEQM86cSNUddhkmafRgZGn1IKYslMmx8DuFSAz6Q3LBLGKJGGoWtCaE8yCyoVTNMwGUUmkQY6Sq1qPL5YZZDU9/rJbvpdP9tW3/qR/dX//tpqf/WtadaqlOimkgmktO7IpMmimxg86jZNI1MWstE4zJulWo3SU6CaE4pnY+kimplrWtCkfVQRorRWfWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABwqQNwMbo3Dj0abga3RuW65A3AzujcOTRZuBnk25FSOoUFJQHWwIym++Csr2txisehyGc4nQvkEG0EEQoPABhRKmBODA0Y6JxdpJVBm/C5zBxiIiFgkrKxg1OYOlWES++zoq4YiqQWF2FvetkEjxjtmY27oHuXGGPItqaEgBOSklDyQVYDDEMl8dJfGZPlcDRZiJmqZVMissNcfNbmI57JnzYspY8RslW6tdReWTty4n1skaJK+t++rb+iu+3/bvra/7bqer6mZHatBF1roMkx1B0mZBaCkVoKSd1Jzy0kVppPWrMl0E3QWpkklM9jJ0k1pIIrNklugjQQZFCfNkFD1YxwSDyZuigKXiQpLayvV4leOTE2ZVG4zYWDzYwJVEwwOU0MYDos2IUIQ4VWpETAwNUK1XYN+NR04Gu5Bo2gfa6OiapWHKvmJYYCWHDABQFIzBdBNt2gaMk4YIgSFlAAX91DbkBcBCgobiTMSc3kwJsexwCbQMAzMi4MymTg54+gkTOqRZEdZTQYyHNZI4N6Oh6C+5kmshymR6qpdr/1LVV+6/V+qv/X7dd//r6lNppoup7Jolx1tWzppHEZukizHFn3RMEk0FKpstDZN2ZTIIrZVaaSaaFkk0bKRzGpBbH876S3SMGfAbWI5Q7mfex63DtP4/baRiMwW3MqCQY9rqMRHVHwhiXXDKAgwwMjrkg4VcYoDUSiIYLmFEOYEUHUGaNoIIFEGlKPWpWIXcrAwcLoDhCQnTzRgkmDq9fbwqgHA1o6U9WWFQDDNZw5/EvkQJQQsQUV0DdxRYCGG6bmp8VJF2qICkkbOOcpNIg8XNplqqlZyhmZ+rXK23dX1a3/rv/ZSuui3fV/31X7qrZ60l2epmd3dBBabJJIOkmtkWdjq1OrZ1NOqd7uqpS0EF0UFo6B9bmaGaUlqrWtZm+iashZeXBNR0GeGhNYTVfxxmh0zY22fl52ZyNFQx6DU0DCwHThMahm03AQhkzmJVxKolsIgVQArEaTAxgkHCzKHRAEGOGhYiI/CEBQHF3gMOi80sDRCAHrMACI6UdTDAVKzMypUjvITofXS08WBAwHDVAgAQFnNF4wJ0vGR0CFhziaJ5ZqmSINyBpMkibE6bH3kSTTMiDrHPSZI/1pJSNd0/WyaTr/V9ey/r/vt3/9nr7f61PSqeg+6CVbIVKu59WermTIrdSKzW6NSRupKiYIKRU7PpOi9Bk32Zz5q6bOqzImx8EOwJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAbhkDcDPKNw19Dm4GeSblwiPNwMco3LbcZbga3NuSqGgOBihCcZbJ0kIiNARGj7cXVZHL5LL2wumVAsYDAijpYFAEAIkKHkg9PcwyFXXfoWIbOiUXMMHgshmEJswCRjRY/SKCw7YvVZjGo+VhZ5miNDMBAI5EPTIBUFlci+xV51QLDoZUbiwyRGB820kBBh+Ph7KRmBuigfdjZNEroCedsfRWM0lkBQrIZHzmBv6062kxfskYV3X/X1/b/+3+/6W177/160Kup11pqVpJsgidSSSrUg9VSklU1rMXSUyFNa1smYIrc1ZNaKc67rWkiitklUWSQrUplJOs9DjPkOQS4ZMoTwhlZRGTFXQoYxWtXuOC0IUEBlcHLADQyU0MgDR0GpgAHGCyU668hoUzwhBcPGhgkVRGPNZwRpNQATEIiAjdE1L/BRQh0hbZnJgsJHXy+YrJIkuRABGCuclu/DN5exIwKKzAxdQqlNwwIcRw9pjNAEaSBCkkY3SJMnVH3jqVXIgitygiSDVpbLWejo2XtptZ///7fX+/6urV/+qvV71KWitKkmkyVBBapxZumYoabuymSelukfQSP1rWldVBSk0aV3W6KOmtRw3CclFtHNCxyVi9jbw3qnTvdkT8NIcdS5g7lRenp5C1shEAkK1bDGgbRQMBAlvoi1gyWBmhw2Dgo/5gUDqMLpAo5GnkAQ+axESCxgIrQxafZzpWQjYIAz8QhMI5iWzIJSHg8uBxnKFQpOMRoYBGQSJJ5TZ7JARhNlUXRDSDga0abkCMHNTElRRSaZaKBDDheOIEGMDBRDZGPTP/NqObt3eaMv/rvU3+r9rvX+93/73ZlVLup22vUldbpJKpLXWip6LGRsjSvMUU1LY8tFS1Mgtda0klaClKdmOpOmfSpO1FW66SnSOJHzqEyjjQQ5UY2YYnGky0GhbFHXFgCdbrN00FsnFDIx8DSpAwsmgZajuOlQiUCzlPBqRjYLK0uaM3MrEKWBrIRjJCJF9QIPrHiSTL8PsYJLi3is9XQUSThNowWpDmFShPhKF9aZdEmTvMGBTg061APCqRpeIcOocgE4DyVDhqiiUw3JbZ0Z0xQTMiBpIIFWOU9Sq86ax9vT/WbVO3//16v+t/9vX6n+1epqfXRZdFfUtNFqz9Oig1IxXppqTZTOnRTWmZ2UkgtFNakFoJWoJ3WXlnFLNDetzVGkaLOuf0KAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGvoU3AzujcuJRZuBndG5b2jzcDO6Ny6JGm4GuUbgQgNq3hkGI3HCI6zfwHLY8zmBWMPRD0Qb8ZGjFAJ9gc1v2DgqYbK2cxgsTNWsYSGq+EAyytNIxlzFuIRIZnhgnaZ6ftli6tvxAAMQqBMnUeChOdZpBddHldUrKkaRkFgRWKJyMt6YUPNLhEHE8RrDLmhNAi2hQEUDY1MjIuBdc1dKolyqykhwso6OJyPQoq9R6fz1WpRgS1b//qvspelX/V3uu/ev/9atX+3Zl6nemxupa1LUlWyBtZNBkVs10i7SZKkmtOcR1MtmZk0UXPo9SZYigXMCiYJmvp0Fg8AoqVg+NyFQXXph9+l014Gqxlm44kGYgzmmMAyAEGJUjcQKk5saKxZhZgw8nQSgTYzZFgRuYcjGFAIZKIWmBFiMLXFQQZOgmbNYBWWBUDABoe9imEaYGL2BqIL2Q6P+nG2BbRCAnBDJEOS6IGBikRYui5QMOvN0zVAxUVQgDH03PuRzMpZPGxwwPoj7ZnPda3cjElmL/WnS/V963f/9XruupOtf/b97dK9lt17Kd1PWybIpGKarJIrUtmUmimpNCmy0FJMplTObnUTRNkVMgkZVXRatpcY4yzzA8EWLWYW0sKmhWVQQMHIAk12ivFKm5TT108Ja07YqEKqjACFBBLVPtzG0C42MHNKhxMHDGbAAIT6MKBRHEk32LAg2eqwGrGzTI6+sVR5MJKC3KgSnYgKDPOMmZAVXoT3dJgdJVnUMYQWBSMwgn65kCGxGkMIYRYcgDOwgwQbkSL50ulIBoCT5s7pjpQUYSDKWiQkmE6Ra9aM9m/UuUk63////+v/76vZJWqv1/p2+tHTWtklq1rMEGd61mypw8tdA2TRQTPpnEE2ZTpOpS2WgmoyMkGdOvQOuq7KPssxcymry+RHQN4MAmsCjsoWJLtZJimq57cobfh7Wzv+vclIxddgAFBaVBiwgxVHsEA4xqRFN0OBhwNr0gpJQxqZREaU8jAYEBgRVsMDkVXbgtQnSQDmBWyYVC7E5cTAM6GJgYiRJZoerFhhhz2K2OE0gCB00aJxYLxG4WjAfhujuF4BqEg6kCHmKjBIL1kVPorSI8tIIsPFajZMqGqSje+caTex9b2Ws3qbX1X2//6+1lW+trq+1Xdd6bv6lr6q6LVrQUgpRmndSrJIoHls7WRQRTMUHTUylsYIJMjQNUFKZaZ1kE6KKDO6FlLrXmUgSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABtqPNwM8o3LWUYbgZ3RuWwIY3AxyjctLxBuBjdG5h2PASM1ClLC8TEK0E5u5CIfbDQTMAPWwMwsAFDDHQJRYDBI78YGASYbCk+twSPq9ACCG0FjmFU+JKIlHQED7gGbRa/K28IBU1EQVJi2lirYCQ6cFTxgE5DRqgl6VNEQFXMQgJ9QQFRGJpuf0SZuXj48iRg1xjPumZlFA6O4iR9SSjhWWasSLZB1lt7LfrN5u60V9ajBJFX1f7Lf/p/Z/37966vX6m7a0tN7qVTdan06SdrIUTJBM4hZJSB+ggt11Jomhw+9aCJkgt6qCBxFkkls7sgnd0606FGYpVMYLCoIK5BMBdlNOepElICZlSxSCp6GWXkKEgKgMBHz3mcmDTlBURjkANvWXBDVFUvUpwS3Chelys0mW2MAA+TCWiX9lErM4gQ7LWKkUYAUnsQggUwz7QIvK6peWDFb5HFjABAlSIhVlhNm5FhdGhDAN+BDfS8mQ9MulkUqPSmpoGyTGRP2UaqHU6lm2tSsuLUcf2OqrZtv+j/2/Uyv+rr+qv/ZfXdVV6Cl1IIvU6lmlFanqulqMnQUtBNNaDoMjY2U1XadWxqt1roMikixo6TIaM2shpWRvWACTkLgRMHfkV9MXOQTMaY9E4B5LSEHmDAChOMVhEgACsLkPsMAYIFtMhgYVBrWh0Fo0ByAJE2CiWKggMf6lwOcD7LCtvH36MPCYiPTmwlLEBpEHAIeH7R2dS0vEtVoccbEMAMyYM4KpZYaFpEhpeH4DRKg4Mc0rMdLpWD9i/Xs6J5iJupZDJFUajb0C5NM2frpldDX/raptv//vr9X/r7f1rUyaKkqup1V2Ux5EwSTQZ6CRq72WyF1IpoIqWzOmySmTSQTo1qQZSrpo0zEpHDS4aeJvDna2msysQ4LQhrZY4MslkJhUmrvlIptoZAeFYMsKYEAJ8mOArMWxiEpNdP2VI8mRBzBWHMwM6bUgXPAQGWaY2JKSarI2nrSLvGDIhNTlYYxMcMDLLkwYvJwsVCWWrOdJiaEzbKW3NERWWznDpKkVFfWXQRXSHkgbFlRcJgBIZp5bopqWkTy1KXGfVWe9S/SapqzqlL9+uv1f7/+rfofpP3dJvX669m6CKq1MqpanSoO6FkkVJronVTRk3d1M8/RTehOJGqmRrVTVoIIp2Y2OphHMI+rgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAbqjzcDHJtw0xIG4Gd0bhjd1NwM7m3LTkQbga3RuWgpfGSoZtCSOuWQwRfE5A1xWqFvZKo45AqHX8GQKYZDkKAQzlbqRoDASXLBmEQY+oUBKrzJ4VIEWLCIKiMyeEFiGTxUlw4jrMna0FjcChs3iioNChxNLgYAExXkqmbfjAHWYipKGdBQFgYbPzD9Y+SpUGWImYAeTB7hZWdOGxKB8BaauUDzVkEQpDmqMj9Z5vLtN5i+uospoq222sr/1/9X/V//9TvqrUtXSaYXazNorZc1aim7KRMFJIUE1KSdC1bJpqTdKp3S3NlOpKgigmtB2Wgkbpm6KkUlqqSN2WL3eY18DGRQBrvY4mA40bjTL38a1HXQhYqUPTIAsGpeDgBfeMv4bCbMnFQQxAbeWw0s2dQTaSiZoJKDFDNjMeE2KQNDyNgjjBwGjbSDAQM+dqGgIm+hwDj7EEXKdpL6vEkibqRM3jOzRImiKGKgNaAOJnEzdY5QJCUEFqosy0yWrMkJIIqtrqdF9BvUtVf+u2/9Wvf+2v7Vf91a7v19uvdqqC1oOg92c4pN0pmtJBRommmp3pVoqZaSCmPHElugtnUk9adbqNUbnVNSN6F1IrZaJ8UIeQZBHngDIqKOKELGbli5k+5kpf2anCwOpq7HqVK0yAgTBghQcoSV8NKBxjEBAHS40IgBDG1IQE5pAoXNMoQ0gUyGUSemMFXDEAZqbxEpqZtqGCSgQTM/b9WlmrjJXvsvlIkOoJ6VSZyKkciTqwAIh2T6VTE+Rc8pFbFtT45aCDjSUZpMyfy26tW2tGy0ffVt39X7/9v+9X+ur2Zd1712UutVNNJU+zJ1o3rRqTRRUmao+IMe15iIZNz0BB9CFh7xo26hK4GmVDRCXNNBLyjxNM1pbfNxfKYgvN/IGjEaEYEY8EREWC3xBIm88dHQ42YAZq84GfsFlz5vxCXcTjFQQwIXSWMHWEbm4RKnRMMJWisYSSpAQBn+BxkzoPYSCNnd1i7UVgqVP4ADhjQM8s/NFwxLxA0UQNYLOucWeWaA0BJMmjKTsmYGa1nEUBlj9nrugaTXTb0UUWVX/67f2/7r7e1/b2ev9dbW9lX1spkKbLqTdmRdSTrQpI1LOaCKrIKTWky2OsggtFSkFJKQdFN3WyqzQTGlgObl4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAanjTcDO5tw1HHm4GN0bln2QNwMbo3DOUSbgZ3NuVJ4hSEBUAUkAB4Mnd5p0rYMle7EnhyclpUD3aJQoxMfHBIyAvY88bQTWwty1BjEwlf4jDl+Ggn4AN2NkoAGaLNTD0RpkGORdaAYmygopLbKlCgoc1YkFwHKDYH+TyIARpAKCJl0UNyAVadunNysRhWMhygTqHBjyZroGghcxtcgKbrWOQjMR4s2l6jCqp/eotI//dL9/t/q/719S7//d9aOq16lNZTO50zetJFVnTWykkEXoJspRkgaoumi70ab1maSa1m67Mu51JTMkk6qjdalGqFoJSmCDNIQtOOFArb1QVtsdNKs4JlsBXFVzDgljIoCJWGUFTeq2J7mKDbPH9MiBGOLQnhsKKwEmT11BkM2UxUpX69FV6YwDQsHKCB7cxUcOPczA7IOUm5v2rWOBcTduNv8FxIIOVNLE0apmpHFMgwGrLDeNTQ1NC4SgssdruyVkjZyLu6Co3bKaqhTn9Fn7Jo1dS//Q9vfr9v/9fa79qX16D1a01V9N6Joikk6KFTnHPMpCgpdN3QSVVe6BgzqPGCzFzp9BaE4zo2RdbrManRSZNJE3RMJhgMleAh+eSl+EqlptaejG9Mz9LhL5CralKXDNJEGvm4izO4LKoABTBfrMTHRh+RUDWKY4kBQDIgIGFgIE1tAg/FgCTstuy0wB5CAp6paXbP9SjGUQ2YCGAZj0HIA21LPvg2QQBAJGJDjLjc3IoQUrFIABMTRi51i+mMiS6aao6kJ1Y+6Mm3KCdz2tFRVrZSvucN/27W1fv///qv/9/3da+jqWzspfXRpIM1daa9ZkmjaZ0qSC1seVZb3Ug6KmVrz61PV0lJprN11splIKXP3O2iIgw3iEo5zAeA7LXGexJrcbo4avUduWDIWAjxoxkAegwYeY9bIXdDmaD0ZCwHwKX/SpDOQLh4svBYNAQQpSZUPK7ppXPQAFhgz4CTObkIxsyWOEcgpk9ieTeI8KZMYl9E2AwADYtQ5JGB0hpOj7A8HENLSzE6mgDdUz582QQQWYajzjkM9b7LSoZ1/WmhUvr97e2tX6l/99v/b//d3Wvv9mzq1vWmkktZsndkUEXNdBBFTqZ0bLUk6rTZS7KpqRSSZF0lMYrZy4gRYRvSMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGm4e3AxubcsgRxuBncm5arj7cDG5tw15IG4Gd0bhWxKlTwEYVIJ7MIbddceuU8klDlTlTjdBUUQQmiBScIDAGSuAq81wfgWAQU0yoRC6/jA0suwCjcwsMNRBX+BoQwNaKcsAxsED6jMXYkIA09ImCg4RgKHSAnBEACucGAkGtyLdA6FYLIY04+Tg6i6aga/mZHqN0FF0U4wXZZHn02WNzWUmJ9Kgnqrekutnu+upv9/7fVf1//r7+/91K1W7UqVbU2WcSSd1JLUiaMpBdBdaaBubrQqUpHSSMVJJOkzmVBNNlJpu11JpMpZskhhpE0fpHaadOSmG/Yan6w9YmHd+BZHRsvnMLdNKBGQgYXWUGEcfMHOlPuMFgIIHoKixl4RH1qqbGol4qdjykyAaaHMMZFWbtillOqoQgA9UqFN8WoOsSTCKgMMICURfpQ51FH5a7CThQVOvvAqkwkUECcADokEz50+x0NGKyNFyiuyBO6k1Ft/629nbfNPsv23//q+rV0m1f/3rer//bm611JqUtTJIJLXSSUtNN1IJVXQSd2spa1qe88yzNB0J5JFLfPnEUFGRx2prYxx9rKTAFVCxkTAvFIRnr8S2WPM98FTUGxfQ6CAAbJAQw4ZSUNdNVRMPCgSbmIq1KAI/tXCggmGYWkF/CtRKguCqaBzGgRrjI4fjdcxQIHnJdD1hcMNnYQqID5YIAi8zZDhGiEHhm0iKEJ8soX+MiKJizTIpAeIEOOqOpTcZYeVrSkMekiQ2yi6sip67+p1rzvda1PWy/6//1V/1f//UpHu+vvsvq21pqdarspalJrUZnmqqQOpmiJvPpIJJOkgtdSCKukisyTWghUZUFLpOzNfMKKCq2QdjdYVBYWAMZUwvSmtjjEpW2KBW4yiUw5NPDDhCRigMgWYaEPyZQVs4nFghodgJ9ww84SBUAmUGAETQcDBQGHA1kBjQkrEw5hDXWAGCjIKxUipCW2PFEzHZAaoEpFxuOnuy1VCcdBtR4sfunkynLpfK44wMQnFxmrVliLWVXbUZPQIktJSCyZNL6Fzr09J/nDyreq/9dVb9ep+pv9n0K3/6/a3R1oqdbMt3rUybzlFRjOUaTIUEGN7ppIu6kEFJnrzVSTLZGloImTMg9CZJqU6aSaVnc0MnNjMzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABnGPNwMbm3LLUebgZ1RuWWYc3AzujctBxRuBndG5QRxARiLCzA5hRf94L1HAMzDTDYRMOxRK3CMmecomlNzOFZ+bIwKEJ9S20incBIc0wzgvJQ0MlhwxMaGF2mYgrmS9+4U4RgKQY+EFy2XEIiY+vGNq4+QiIIcBkqITUQqDPis8dBhGAPzHqZEixVGemgH0ZUN6zzohxLKVl80ZnIEtFzZIaz1mjJfbX71nvV/93/3+71b9/q/7NrVVX/90kluipTK0FnEU0lrpsgcZKm6adHRW6KJpVd2RZnSXrU6zy8yQdCqgddk3SRs7zREopXUoIYQDQEVM5ZvWU6p3GeXCJv/D8tIDYKjuSUYUxTeqHNYQtty3eVMMgXgL5qkMbBJLq3ERhMW182ptONrj1MPZyAdYCssUeogQnY1AE0RxEdFjPIumFKYy2KzpvxrzT1gqE2QU8XiKAJaDgPJLSWTYhCS9J0EXdaJ66Bq5YZ7/UpWh2zh3v/r/vV7v711t+//1VX2r/Un7turTSL88gaTKaqpprTTWrUkkjpKSQdI3QoLoXUyCS0k0nqTSWtFNSdabI02MdSSRm03FiQoWZh4BUIw2KvAvSakj1stpX7u0b8L7MMKRwJMiImsGEq8BQGIQg3wRYpBaEl+Rkbcs0kkLB+PSSoScAaAZwUo1sogfCnMAWFII/RZ2TUjsZrx7ZUcWo8IjC7yAln7aO+CoWNTltEm3HSeLgOgMYoJmSzouJJFTScc4gxFUblSOtVJH1tf/rPIrV6Dq1/rV/9v+vtb+pdv7/euvXZF0aVJFBNbMukYLXdl1qZNS2Uiqxskgg1lpM6bHK011oLZltTOkByzPCWQipylOzHTRVMfweVXgoXJorN2IxGJU5UB3l4jIIgwMgKzTPBW5Cn3Il6eWHBRcw8GDLdR0wCqqDigRDJgIovkzQqtR+hlz0mCQ4KIBoNkowJG3NIECya4TehxvkZtKrUEAIsggoqWKQqGZFiJGpDQKpRkZ9IvKKIZMZIp5GNpKWpA/TdVP2Zaec/UW1el//b6P/fb+9v/u7be6loqr73QSQQTrdSVa0Tc1SdZqkcTQTQRW59J1s61HlKQdCkgZtRdDSUiYHkziaKKDOjY4AbcFNhoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaEhjcDG5NyzdFG4GNzblmOHtwMbi3LLsebgY1JuHggJk5wopUIQqMLhiT9ujTtSjUqfm4/hVASqRKOGRCK0QapO3BQXAzGwtXzRS0zKyYIg80gPEDGHHRVKDCCWWGbnlaJMIlsAGEoBlQAqGDl5CU+DLEFMLRFw1F2q/QnS6Gm5jz3KInTnSyXSHF4fQI7NCfSOoKLA5Bra5P7LJ50HJ9EiCO6vWigp6dPnE/1tVq//7fV/7a9frV71f63tdlrWim0xQOsgasizqSQTs6CaSLoshdGzII0ltTW5khZTMbKM1oqWtNAyV4dlKsG9JIFg1DRQRKxJAgKy50G/a7chvr2UeT/303AMpqOmagD8GXjkngkVBDAAKUyUBFkhEQsnMY8hkhyDpBBCDohapmpW3OFtmYC18GsrXnHso/g9yMRKyK4R0dnFgUJXS3KgTPEJS5Gp0wJhiHm5NgYLDJFEpMYKTFjJZNJaZ9FbJsuo0l2it6qlNQepvrSf+/+qtnV9f/1/77V+/XulrW9aDOrZqkEkDySkVPZ3Tc66SlKRVQU6lKSZJJFmajY+yTutTmVzqTspWq9bHHwXKB5SlSiVDlROwnwdI8sMqGu7FpY38JjWUXwQbChK2IeW3CMoT2JbRAHp6Ttqha7QFIHsGp8Za6oVDCLjV2Zkno/sSrRWSgkvBxqv13knQEQEkyHBMQKAGACQKcpBLZaAFAQyIAcuTSg+gXjVEY4GYVRfZkXNhLTNJdRqmtE62ouIFZVFD1fSr9RWUqyqu391KU9v9f1rSX77K7bOz7660f1X1oNQRUpbHmqqoopJMeQWpOkzqrU62mKS1oKO0mUyLoILQQUnSUybm8KSlua/NIdR4TWTdc3ZLipjM9TqaPLZW4s5EpZBcTHCRbRD0yg5Wg2gdpTPEbibq8ssBod5gKAfk5qoCGR9yICBlB8EG+LLWgF7YWzECUx6+xGRCAifykCe4eBX0wx5CADF2pRqFNZNSSpYRsxUWCHIEgBvaaJcUks6LldqpRPbF9dRjOVLqqqelrb9Db//7VL/61Nt39er0Pq6te9adVdV6bs61VTimZFSa0U2TRZNZxemYuk6SC00F1oskjdlPMloLO3S3c4miykUj1FkGZRmgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGPo+3AxubcMrxhuBrcm5ZjizcDG5tywpHm4Gdwbhqa9S+idpisgtuHGdx+A3jhqTTE9DFEk+IxwYASESW2ayZLfhoUEjIB5msMMLl4FF1GDSggqp4CNCAVMfGuGNr0NSCBaKGizK+o5SQQVQEwvFARe8KfEAoHslVuiDcGRmBhq36GWHkEieNxmAOZx7NGTM0kUiStUbJOtZkgtRjJlGkv1HrVKalUpSVWv/71/+7b/9v6/V++9X9urV3rdlspNaSB1LrRQdmQVWaM6CDLTepmPqoGSaSkmTUbv5gtN3VUnXNUVaEwXIzAEmThrzGJyYmsMt1nrxudRbhFh56sBihEAjdToHEqnBmYQ/M2IwUw0Vi6mICEoHJRNdBsgqJBAlWqXA6LdgSe2gtlgvDEREpmoLSOGOCxiTuDIUSKbTHIUzibc2utNmgQMt7Vl5sXzhZMyfAuBEkTFq0A+JltmZst5caxss72f3tramvUaq///V//fV9mq/qfpfo3Vta2g7JOpbKUi9NkVqRW5ihZzq1JILROpOmpFNaCkU3TQRRVu7IGTsiyKnntqCXdTGDPBTDwtqSfQlL5RtXelGkXdeN7G7yClqO9KFHRwZa4NHKxDZgWITS6zOhmQzaYUTAgiNAxo5aIDEebElwxgQ1MAV5XGYChUNmBgLxJcPlLUSzAMsDZYhA2o3hAIuHAr6M5GAYxcUg6XWWSJgdJeHKA5AGKRq1pOcEZHl2WXFMmkXVpTaRzus/66n36tJDv69f/9Wv6v//+/pe3fUtrMzObMykEmWiiplopqdNz8yQQWkkvdCggtJlprrositR172ZA6mpTJpJLqqMlnEKD7KcSmfoLumOILiNu47uagqCLEspOU0zPDpIAjBnQcxMoHnCENHcUIasWWjxA/CcKl4G7iQyDm0RgpiYYvYzQjak0mBpTOqMBkc5uCS5wJ8KJau2vtdeyHnQdd/W6O6DkOLTc0gSpgRiZYAZikijQTQFm9c8mzyzyqs9rr+qpa19VXXqr7f11N9t+/19H/9vtutC1eizpJOuumi2j0jqKCJqcau6CO6a1IVs00pMtnoLUp0lp6kWTWboOm63SqTSUknWtziAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABiSFtwMbm3LF0Qbga21uWUY43AxujcL6xBuBjUm5aKo2YhA4aTSPrtMnsurNv/DE/KrFiJUpg4ktgHG77G4g7n4kgmJTa7qAMKH6EBAyYzI2AgGLNqmhggK14RoiiOEeiMEr1UalDyPIJGhlCCEmYhCVSwEQAD1RKRtMUaM4BYZry0xMywOhQ+APbA+iaBuXLiEJ5VJRs1Tn7rLSyH801VaHa3o/1f/111+h/v/f/6t67P7aWuzqdNNS1J6KCKJmpVS3QqZa03L6lpI66NamuasfUrUplpoumms+hqN406WKdFdbo4LHFhm4CliPTTasYkMbe3KMw89UaKooUITCTABBvAErtTmyQCMmBJl4QcR8C4RQm4CBIuCwiKA4RALhM3LnodWWyJlRgxAPKRMAT6/DoAAwghDjeDXUsthpXcxe9AUZ4KNMk0sNDQvE91AAlKZiikfSNBcRZBpErWmXl1JrU9Tt1vV/761/2/7f///qf/Zv2Vo+n3VZlLaim9lJrUky2RRRQol1aCUxW7KdSDI0lXoudQNDFTOhzZJrKUm5og4h9QRtwxkD/gpSwZ0KZDNeYEvaXzsYeDlyTS6urIBRNqpKOKUmnGUCS9dAFIFBU0jBRN+gEDJAGRoK8iJYTGR+dIVG7UFOBPtxMFN2ZPw6r3GTjIqQEZMOgspf5HZqEF0z8OgDnt5oncMTEh5GoiugQfjlpIILZEixe6yGugms0a5fmjXRf86zOz9vvf/9Xr6tl+pv/Xbvr/r29TJ3dloqrRSpKWgynNzjIuk6k2UtaHZaKaTJIIorNmXWk6d2dlszKWtG7oUTVlrWzJ0VGLlr5X8rQA8oIRssidx1Jc/1JflFWvdnyEEPQYKKGClpkhkuloqDM8LeBfIEDR9fKqRy0YVjI/jIozQdlhqHrvv+/Fx4hjMGElixMVHHjqg0yRSmw1Hmeuhh+Xx0vMIhbqWKIqKUel4CMGCaBs9Qy79j7LQmrLoTvf1611Pd7t/9vdX/+33///v7dC+tldlpa0VutFBSkFOtNI+b1G6mrQUibMbHlvQW61oqUtM4kpNrso8q6S6zFzZLNRmOELpR3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAYYjzcDG6NyqhBm8GdNblY2Ot4H6m3KqkFbwY2puXCZaCLIZoc2ytNetzJZI5K81irSxSnLAEOjUoAw6hwMNU3gwmTPA9oK+zBQ6GyUfayYUnMIDEVxHUfQwoMZdE3Qj6h4gcyY6VZkjaFjQZFikHJQNt5wRgLyNchpaSIBiwtFeTqBiYk6kTwGCXCcidWy2MByD27lJ1aeiYSafP/1PWrdq0////9f///9+1/q7PZttaCkLJz77nXUpbqUtTqvreguzO6SqmSTSWtJlrZSCKC02SSSUlelOshPWQTRTZ3PD9Ogg0DwhHakpXh2PNb3VlEmhmFxy+/ws2jRQngBDnKaqYomTbbAIA1K7OzJMkTig+ggEjbADDsJypQTkCkQZVsPwUSizT1EApFCemvCH0gJ3KO+7gGKUNyyzuYOkAWYkFqU6lCUpJUJ1fNkHozD6tbVKq/U3//9X9f1f///9f/39alO6+yLqfZd7I0KmRUiujRdFN30U0ElrcxU7pKetjF9XD/pPMpeKNpq5pBxBmg3RIx1s6cUGWHL+Fna0soQBY6Ajyfpn4Dt3EtyJnLn5DENEmakkMwWHDSldzlwGJGoo/71y59zRAhsW5MdUMNIjMlsH5SU7X4unK8z47g97zACbNLcTUxDiZHJALOQh9VBjMV0+/RsukrRlNV1dS3Z9+/f//1f///X//9kurX/T11MuyaqkKKr1NWpFls6k7IdmpupFSS63tSSSUfSOm6m6k3rWjdqK0VrZK5jhXW+SjEdCVzetZxpJ6mpn6is9hJc03xodU7HA64uao7RIHFgYcFwiIKfqxDhKRkgOhUmGLLcrIC+3EpRx2RGNrfnZehMOKJTAh4mO2Z/D77XHbgiZTfJQFyqTiEcqRGAkWGhjHqwlGLyr56mZynafs/t9H/v//2/////7ffSs9zutqULWWzmGOYlDVcxkPMzz63VFYyYjuaepqHOYhpjTjiK85h3Xz1qzMOEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAFho03gxubcKrQRvBnbW5VaiLeB+otyp/BG8GdNbmhcAkIMlUVLhO9ekEst1MbU/nqtNooPWXgTANUIXIh9DAoD67wBAPDRCGUxgaE9IcAvaRByi4IA7UpqxZhQjLAMXRWjWma6GBeqBydALbxJDyLwBLJe4gcbv9Z6mbsRqJNgHhKS0aloiynRso4pq3rc/Ljbf2+v////fq///Xt/v/+u2zd1LQp6da1ou9VGrupqls6TugzUEUmRpupSLum7ug6Luuk7JOjda0FVJG7DqXUZel4NsAlhZUzD0SpNSKUXuZUHEnQgqjA8WvynFG24KBBEy3sTT4htu6+zAxYVIw4AHAdE6bAAov7Glf2jAAypGQUqYxy42FTAWHrMvpmf8gCntL6MPCJH+K2TLyB0G+POeZJTiTnkrszt1bLMW17f1t9T/////q6v///dba6fX+pd6r7r2QRoHU2oM7qTRnFLWtVaqmTmKOgpl7LSQSzNXfLeDEywr1N9WRYo0cE4GOEjGUZatbnCZeg15clSHNtXASgnSOO984OBlZLcfT0oEr1mGYYxllqaZfqAjCApVKKegkQw4DHEEvNOnwMGD7JqP4r6y7z8Nx7GkGAoMcntZC5QSMwJ5n1MUhnDV2rLNSa0NbT6VSf2p7/ZVXf/////////9WtNe6uvUy2NV0Uqkbs9NF3WyLLautS+k6FNabKVRTTc1TWtRiuutmoozJOllpLvvSEB1TKGMqstkRAPI0h6ZmXXpfFN4PjtpJhgbch5HUFhuMSFRJoQ7zv47tRkEqMwDFD4swUVCJjTUfqB/pym9l0Rg5ow4JN5gIDSfVFCntYhTQDAcTUSAyXHPFkzJakwC4bJalrCqO3Kn6PXMO/q+v////////9l///1eu6Wy136T166npKRVorSTSdSR2i7qQPpoupOmpFNTIoJLcyV1d8BenFB+3yUZgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABT2JN4H6k3Kj8ZbwY01uVOog3gxqTcqmwpvBjbW5Xz3DZCMCwl9XbiYyJjrhn3mknqhIHfWUDRJpJ2kDQY8mkTIcIIL4xEYFxM0KhPeIKYhhSMi0OTNKo8JYAQxR1bhFVVjnyRygLOGiMfkafttmXwYkcVBdfXVorKa0gLiWHey1h+LL0jCpp2qnKPf+vb+/+v////9v///X/an/Uy9tnRp3ZloM6Bkt3vQNlJtd0E0NTrXre+tSKl2ZaSnQdc3PHm+HAC87W2iGUAQoGtGgRKPOm7UGT9r5u1awZAZkBKxgI6pMPo7TUDGjIbo1Rw06zqCzoRDSKQSAgdBuCET2IVrEgJTeFiAxQUcayIEFu7LmzrqlLco3mi+POoG3iykzJAxBPyxkdA6I0a+7an6Tpv/6///6/////9f//6v329/rrfdlVM9PSTup1MtkaCK9Nr1pKUytqpm1NFnOsau13Rd0K0kGRTMO3wS0mwssYwbhJFKas2eKKyivX/CW2rJYDqSbii43Q3bt+riHFIeBo8NB4KLwMWNARIBL2MoImrcRZbJb8uf10TExyiDE+lQOQXirWIuCwEDQh3JEynOVL4TafruR1MxKCkACyLp/Z0RljfrL/q+WO3fq///+3//////6ur//t7MivZJVtmp3VSZBabMplqTZB1IOtBTN0916LJnU3apkqC1HDw+Lik2KnZiulkI8wLXBRYBYtTT8YgCRTkv1N3ElC0shTVdUiFIrWbAJQs7VRQhajr+g4cLOFCiKgBk4CxIHBDnzNSxDJgKWhfH4cV2cmLGAkQkAQxG6JhPx+X4OQn1LJ6ymmkmtEEkQZB6aASdPrXv9FaK+/v/f0v+tf//6v/6//V/+r176DLorQUpNT9TOhUmmklZBFN+nspanZbpqdem6rtup6Roycc5m5Y+BPDJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAVFhzeDGoNypFDG8GNNbled1N4H7e3KgZjbwZzRcGJtZRrNIVhWvrhZFK3Gpa0hzpJyfsDgFQeWDx1fJiplLGK4ORW6dYC8IxT+GnBCEurSSgEl5QEBoRNyaEwGYJ2DidND6Hh3I5hTw+YWQ8UXUaxZdckFyHa1zB5uZs4HZxJlrdR5ntPe6rI03qX9q9f///////////9fX1bWWh1XqdnWtKqm6Ck0a0qboKWyKKSaWzrSqWvRQW9Sk00UndA+mbKs2tF4TJwSrfCAUk0LGlNhjdRyr9l/rlDPZ2iwAAwaOQfOjROzwVEmDDtCoFo135zMOBGEBM9L7gKlDQGHSe3DMVqmKUlFd2biMp/kTxDSB4I9JohFoavUjpIb01PimyjKgDrRTXssFYKTc6qzoV3nHt/b/1v//t//////////9HupbWQVMnoIOu63Qda0El1LTMmQVetNFBmemyXQWrMVrQMHQnB38TyGVjBFlOAxh7C4l/WnJHrzcqJbXuYodQ4KlRERtwMKS4E96h4Qs0jAbINA1+hyCVB0oDKYiNqYRBcXpaGQQtFgOQ2ryB1zgwQLjYtIqKT3H7surO32ejQXPzuWJMwM0ABXjY1v3N2fX+Lf/NP//XX9v//v0/////1/////////////////////////v//////H//x8ax/8fHxu+NYpmklt79sUtmua/Nvj5jVB7nTlNuRuoY8M0LrNlfARv9zH9pYZckCHmPMGDupMxuZh2G41cldS3bJBCUGmWGaAGUVY+3oPqge2nVNu9KTGIILCJkUHAYj+iIGdaTjwXQgoCi4VRHhIYBkY4ESILLRnioPRYJgcMuk4FlBJFamdSOsajKXUqpYtx597rsvWhM3Lsrv1v/0/+v2V4h7EN30Kc8+BjYnONGLWHRUQDzrRSXKkCJ0aWMihssXAgLKDJYH3iooAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAURfjeB+otyo3FG8GNNblR2KN4Mam3Kir0bwY01uVo+BChrAAkAgOR4sQ3GZcOC/hQ2VbUk2wjAJTs3MB56RP1uN6Oq/fsKA36Hl5ATJjhKBDC0jHR0SlMuyfoUSDyZ55QsCepMDC5RpfCMS1VWVPN8amQYAgXumN2M2KIAFJerWYikja+29bLfOdH70//f/7f///////r/fb9Wp1pJdrb1LTWzuq6CS0UHW/RVXZ0FG1JE3kAN1EBP9c7/f5bkLTxP6jmGuAPG4MHhcWg6/rLGO5Y2ywIHQEqWKywDF79OnoXUnfX5EpTCzCiSFk4KHYHYZAVAz34y+ngggOBzZsMsT3OKyHTpQdfyUwdP2IatRSGwcLmOWEFOkigOE0UeXpBQrdecd1rNujNEf26v+tv//b///X////6n/1PvRWtW6Sn2QZtSWtNP0ls9Pag/6loqTedTdE6ipJSbKdqJyDrpfQIpYsE0gLmYMt9nLauzDsng+Hc6S7VxnWRTBa1yDqI35quDBtaCVBIwKBpeJGCQCTJCQKPAMSAHEZymtTQwiT7b+IlUAZ+WBUo1NblAkWU6tOZdrQ+CQcTqWFllEwcngF4JOg1SR49bS1/Sr//1fq7bf/////////7r9W6TdCkp61opXdbLoPWtdaCLOkgikuqj11O2ki6kqnoV9FSanUszaw2/aqdjAF3Eih1oOa8UqjzsZ0D/V8saajJBCya5EDgUHAJyldpgMtgx14s3SbEQwdUIXkAgxYGXEIVp1+HpHDAyORyYvttR+KMJ1Q1oYqtJp4OiVtpACEPLlZWZIXMg/EZJFb0Atht6Xnu6kv/r/9r////+3rr//6v/9f67qU9S7VKVTTTdaKClJV0Wdlrc1p1s1mNmZQ3nhocSigUWy5+S1tiwD2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEii83gxrSYJzRpvBjLW5UIjDeB+mtylfHG8GMqbiOPCIZAHZcNw6ann4fxsY8uzFT2YSGYIhVoThMm0uRwp73hlCumgBwOUExmMkzyq7K/rE1UvDwJOCloEdzVvBHZGhsFSCEx6WUfaz6oeVs8e49y3MkIuW3+a/9x////q///b+5y/+R3f/6/3//z4DsIDRocBJo4uI0AUFQk9ClA4o69huE0EBLYtDkqQISgwCGpU3lIgkOQUImvUzuXuXcLWM9jIyBRISZBwDaF97G5p57EQYlbizkGAeOlFYa1xuqXgxCUyytdomtK5k9OQhHrKQ0tbp5DaapdfOXRJrZlC263U0lOtYSc1SfU4529a16faj/r1f///q///t9v////67V16PVZtTIJJoOpBals61rWutFW7oVroVMigt8zZ7KbutbNQToMy6KzJuzDROFEASCPGsmyFPUuhUZsea+MkzlDHYNd5rJ1CTixFLZESzPL+dtKe8igqkUDSQERHcUGsZdXwgMLE0JcehbkHaNmCjhwdy4Futzlss3kyEvrKL3GOOdSMgDcI6vUNS/V1odOlqX//////+3/////v//0nrVf1Nu1kkKLJLSnKJ1kUE03SW63SRUhW6lIKQsit7Vs6NSlIOcXdJ03UiY+lejgydY6eWluFvvBFqz/SyrZyt0sei5Cs3WIEg8UVQm7jWHd7YaTdarcMsJSomOHCx0SSmCb25O09lI8SJ5HEXzPoJKR6N08Z2evQi9K1VQNlfvaVZ6HACCd3nTCX6/f0/+v/v/p////////+3utK2/uj6ncw46cXcww10a26HGTyk9l7FGK3zqsxhApz0SqHrMXSzmGk00AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABMZwN4H6a3KWEgbwY0puEm3A3gflrcpdRJvBjJ25FzfluBzCaGgeSSZHcNVLGr4zVmCUII4UBHANuvg+ZbEJCdSpIDBvG2L9koRcIyGMmBnwSNypa9ymBgBdVNegcDyyQ+UK4DltaK5aq0TGSYtC8fQTQQZICjEBaktIonnqrvmfVX3/9f/////////+//9f3T7LS002pU0lIoJpunc54lZG5+h2KcxnBdV/DhSm9BsmqDikCVWdYNxWZjYhYTPJPjJrMsxt85WsRclGAJJHQ4lKW436dVZl1/2+npROCSF4CsW4JWwigKCdh6bzqCICkLOSFlBzAoECk0t8bNPBO377NRYMiQLf9zEIjygHznXuFxXsvX6/6fv+n/X//f///////+92fbMP2N2Y33e6TWY0xqIQv3nVOR1fPdDTSSax80+eabVkvOP5i5hYcJY2EGgGwTMzY55L+J2StrWVhJ9KF8C+bSTA4jt60LBQzQLvlifl9OgkEY4ucTqcYWcfOZo5iaJXGrWJpMk/rAoCUXvHLJA+1NT8lkfS8vWM1I3ZEEqXVKtj3+c851///9er////9v/////1e7+vqWpTu6nUgy56p5s2s83zIyS473xXRgSEjFk3pV41CYrqluGFsxlMnIoCMaQt2BIF3Qyy5bv1YlIyUIABx0OUbRfkorP8lh/GWVHawDk2XlAQ4IWhhgIHnKlFN0BeeKQl+VDj7JTeKNnpmb8zH3499mymejFsOGnOPtAMNo/Bf877eZ/pv/////////9+n/7/8yxqUmsxqGz1V0NebazLQ426H517nTZQ+xp5dzzmpo841bKecWYSltmflUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAATBijeB+TtykpGm8D8NblLSCN4MZa3KUUSbwYy1uQ+pgrwmAtAoD5bj3bImFhqYOVIcISVGILUyZgZmdynplq8zTOj7/PYwNW59BwsRBSomepKDDdoQmBwkKpU7Cx7UHq4DswfjemtUii5a+Zq4tKmohEN98Fnx+uV7/b//6///b////X//t/9Lsa+mkxZlHYzQ453VnY2YZacg86GXKsujIpqmI5A9i5yobYxD+YYYXZJqCxiB5SIG4dgD5OxnLa/UMJvYrQbdWfXkDsLKCg4yEPneWy+dzNQOfZjGwcAlS9y2gm8WHgYy+pqlJMu1F6yLoz5Mory+NuQRC1G8KVVQ00nrVus4ghFJHvWSh///v/////////////9f/Xq6mU/u3VoMfuzug6WyakaS1spBVVFJmSWzooIOgpGhVe27H7a0U6aB1nbDpSoyFFVDImTMobjLbnMauXeXqQkHV5KRo1op5uT+EFixcijJEBPLBy1NxrbqNdH7IdDAZDQWsKFU5WdQUq+zzodIamjtPZgPklwuO6Khdv47JKOBMFanuONvQ9Xa3/1av7f///+3////qd9///T/RTqXRu7LZNZ9010FLZNO7pNWgtjCtWykV6lHU0MwSyRfTFzuDypNbdt5TKsUSqOIRp+3rs9q53asxlK0NYGGq4mCkLMTkiHa1Qulm1SsmGzmBFVwVNKw4POVym7gMJoRv1D7KD2DCyhRu9c/fi0olFeYcI3AZ2m9TbsHk3f1k7/0/o////////1f//////1f23Sa7qZBToItoqOstSkFTqqCaloroqdaadal7o067JtWjepLWZbZLIBqgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAE3oa3gxprcpcRpvBjLW5SedzeB+mtyjrDm8Gcqblfc6DQgi60kjW/d2ZlljsQt28NYoFuDBDE4EBZF7JPHE9sLy15GtFthUCh3JgBYEGIAykaDdy1ZhkKr3dgmRuiboCFCxQXld+3OdlWcugMSOxTW66VELM1dSVc6+gtP196u//b///99f//////q++r1Uuvay1Oi271Oip6kLqXRZrrqTamtGqutjqakE2dNNBanTRWYxlcg8ztuppt/BGliKIAeKWvLBGGUVo8qXmeDVR4xn4UAkwFHt2cwy2zaUjSP9CFQDgEVQ9FkJkeVi9W3QypHhWqSaZUC5yTIaGzjdO1XGb/3jEm3Wve6DsywjvfqE///9B//X////////////+vXb9db1M1FSKS1WRW7sipSSa0GoNUrqQda03etJ0nUta0Hugtq1LUmp0lVtdM/V8QyYIJkAUBzHwhy5ZINbNE0S1nZVlfCVqFSI4oV1ts/BQGmlLWMEOEqRcRfJkqTwdTfoIO0dPOYR8AGV7VfjhNLFSzUrFHWzsQzhdbCmPbxvugmncE5KamtUOx/Pel/2//////////////9qnUiju1tNa3rdZx6FBVmZVNSl0qlMeDpPeBTKzBbaLoPPZ8kmD+ky1CW86LIRAkCYkzOwxSS2k789nL6mm71G4GYG7owJWmmqoA5diu+fUbtrfKiX1AwmWFppBN50ckEYC/3tmlHzGaFaGCSyLTkOT9JlSL4CBrPcerHgkf+Ih/+uu//0///////////6//9OlUmZtzT3V0ex5x5hzGJXdXei0R2V2ORXsrIhlrutjzjy333FluVl6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABIWJN4H5a3CN8ObwYwduUhYE3gxlrco/RJvBjKm5TygA3FyAUh/KxjfPY7g3x9b78AvjdLoOid0jNcm6i1U9NL9pFTNoQA0hFog2GfRo0RHymaOmngYARNzl+AQNArdZq2qv/D32mkKUUeXamUqBKrq6yb9/b6P/q/////////r//b/9t6tunurUh911vQ02RWy0U11upPc3RemkgzulWgy7LWk62dNnPz0zSCShLG5EwktAlGVoZTAVPWxsVM70qr8j6sLtCb64oeE138Tmqx1r2DOIHQGFWEDtineiiZzurFRVCMPZmwg5VIYEwJRJ6N0uR+/ko0ryird5ijUA43fjZv+d9W//r////////////9Nb6qls+e9ZyI6Kc7qaa6KqzqsaZOREspY+yGsqnb33Q5KuUXqmG2mopkgOkW6JauuO7EFV25WNX7fMt9bpEHiW2toA5zWSiiDm5U0OVjo8lTGHBCjQkDBzD6mEPVtz89EhFw225FHzNFGAqmqfKvt+d1n2BQuHN9OmBSsl7Es/t796v/////1///////+//9XZF3uo1uhdmW1SC3spSkmTqPoOtJjGlWh0mXWi7JzFCe/5FzksfWGaGBQ1jcgFWjPWUzEzXs8is3v92KWqu5jKR0GiMD6k6JA5WEucmVcQrKqSEbYkz7RUGqXrVe+IAn8hNZ/wfUVFiJiAJfjBdmYmaR21H6PD0Y8+4EBtugj/T2+n/////////////9bden9TT7K9jJrHLqQuprNR0OehFZbWMMMVjaoznoqoeahx6o7z9zSp5pHs69QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAR8ireB+VNyiJDm8GMqbhDcvN4H5mmCOEcbwPwpuasyiAeQ4xtLhSXcW9smd4wuW2NPzLy/TpmPdG8HaR9qX5B1OhzkJI40TQxgW5igVGubmrWBhoExk9ceMwjCBhNiUZWa2T3YWm4IDrmPVpZAHj3urRp87y3av///////////////T3fSu7Pa7uxymn0W1jdVUiNQ2Y5pl1JLKjMt3KHyVd0RWRnsqGkC65UT1mT7PMKqZKrdArnymV16u7d3vauD1zg1DOl1b0SUfbeRUrf9icZL+DJRMdH2TW1D4Oqd70hOTMl9NDJ7BDqQ9pBkqszt+hraipfLLXoZMZwPt9goP//f///////////1///+/bnTEzldWRWzFWqozlVnuxqtVTDGnLdu7apaaaXIG+QtOFxOu+tIotiAsCHlsX3BjdYU0a5+H5NkbyAYw2A6IYpnYgqe5F44KiQ4jkWHh5UMGCQmQFClWYR0gV+HqmBiWAHJEfBQhKKNzFIbCaApgtpVSd0EndhPLvtW7ej5/uV///////XmS973GB4UYTAiVOGlCDx4kEJEAAwNC55poMMqFFgkHwix6Ejiqy6nISMMGiOw73Nb0swsXiRs7HWyPo0ouO/zpVPkw07CI2r0RhpHVpRWeC5ZTLoqTHcuNETYt3V9HXq7ynL4YT0BfHuclZR2K5ZvWpoEJPbnBdt7e3zf//////////+v//19e1aWW9XUxWRUMPdlNMRzyCZZzpz0VM6fORlN1Y2jmO7HtPqx6K80+iszIW4qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAESo23gflTcISvtvAzBW5R3hjeB+mtyiREG8D8qbl4mRpA6gvUJYW1UtcRc31TeGqChmEzJOfY0Lob6jGEfh6qX3flppC4s19is+XCo174jyZCxacVN82BjiqClDKr96phD+e49fncfO1ZAyW/i39E7ffv//////////////b+7JVDnVV2PPPNVVY1FOu6TN36s6ynzTdTrox1WZXn3PNMMus+iKpY6sTQzIDoYCceji9rMDjdLFzNbEseMMNAzPeZp+LCTt5JjBulcvEo+VpnF+bX/hUqYYjJVwy/Bn4BwK1IwxD52nsR3dKk+XLnv7U7TB4e3WAr/9/p/9v/b//////////9/p8/ds7UcXpHEq9VNc50VJFZEoRru9xLguVjU3xlLCEgftfHPLg0GgSEBxgkTqVXXapH+N9u9tKEUCFeh8BB2NLn9K1DNL1v3mKpicYykl0ubB2N21bEQJWuL2JSJDV2Mcy1/cZB8YdJ4p3PB1aSgrTZ9ssf1/+j////////////2//b/bqUtTpqspS6TKWtB3ZS1OtlvTTSWggldE6g6nXZ0EndNkFUHuzJGaKBbwxqLFTG9iIcUAQ8HeLCpzyXDA3M80Z/dqZqyJMwSPGTzIp2o/REjjEnDuuHgX5KoJQFJHln3Nx1e+6Sn1YHxgA5iRAWqG1Yt435VuxDJareODoizhEGfhh836+v////////9v//////27Hv0mWWslmolXY1jMw5phVKJc1p3NYsxyuhkykkn1y9JJPL56TEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABHOIN4H5a3KDUCbwYyduUJ3c3gfhrcoOuxvA/Km5UZCBIzwFOGI0PW5q76C5XyuZzbnR1fD7HeTIsYDYpS5UOBYAl9EOmN+z1JjFYaxUuazKiUkznbitan1u1P7/w/nyJMzw76nWpzAGg8v59/V/vV//////////////16/vrXZddlK3ZLTUiZsyeutkVpovdNGpab2VNaKDIrUuyKlGaKmUaVHTy2Iip8QC1RnGpUTEUXidXLmFuzVt3fuZKzJwSSIvMzG5yG0V61drXwDMJNEI6hUqRbyWlZr498URVfhKY0Rphc2K6ne0HJ3HvS9N7vOiMAG2nB+3o//b////////////////vqnTZlzZ5ktPMdFRtlMOKPRrOtkVTzTVmqzlLgOhRdZwUQ0EoYqEaRlQKIzA0hGXjk1P5Gx9f3vwbCzmqv14Tlql5p98Kr9Sx7oTPkoGP1FI6azYrUlilWGHgS+9H6ZMlze/zeqSrjK2UX9dTWt2cBjrV7JN6fv2r/////////////q/+r/1+gt3eyrpnHRSs7syKqakUFJuax6ru7BkZ5vL6+EQua1hFgHY4IeuA0BHAdAT7YwTxrU1d/ncpmjDStOk056m2NeSFvssm1kEAZJMlQd/m7sq6lL2vetZQGUFQ7x0TOEKkqr7tiznev6zmSsOe/+qQUP+Fy///O///9//f/////////+1b33e5hhp985mZHOc5K0byVHHCfD4KPU0YAK/80UdNOSUzVRhk4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAP3KTeDGJJgi9E28GMKbk/Ipt4H4kmCHsebwYwpuYxLxgqh8jZTftdpc7sv53mGEAoVUl9uhY3MYSiU24guCqn7Nvv1vhuDNohl4qJl08XQlYOAvJHgxgHyDwfRZI2JsyMybFkldH1ucDLBW/MdHvd///////3anz08WE5ZQ9gWNsF1LFWsBs2HDrljQfKCxwArWdCZgaCocJCdxRFPAbCF2DEoegimszFPnzPvJRlHl0SVQCB06dWYKFqUtp38J60rWorOUqjFRVDl2vltOQiHIM26CiQssmfE5Dfm871i+9TDLGHot6AX/qDH0/9f///////////////q2r3VGZjlQ+accqqYeZWYchk9jD2NzENR0csrnKeZopp50w66Xznc4ySba0y5CrkSQQJUAvHQnnJtdWqDPGn5K+XU9dyqGzXKfqRp879Ar++4kKYYvGMMHBphc6mZqNTEJSO2o4HJg3sHgKSZ9THDY6UxAxfXqnHQDtIfnH/KK//////+//TGNDYiFxQWKioqwwulx8LHUoJIB4YfUNHkxELigPBwsHxMEhhUJ2IQ8CCcLkTpwk1WX1a+OH56y0LRqObRtOr4sLT9ppW7V19ck1Mb9NQ5Mz/O13RKJS6M4TYK83ModQ44Und/p4li3v+jqiBocnuINvX/0//////////////2//mrnK3OYrNNZ5rkTqa1XY7NMRjSKrmKeYim3c92JZrzlTSbOMdvMcgMPOWSuWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAQSjLeB+FNygrHG8GMKblA95N4H4a3J8sAbwPepuXUYwwTxyHQpJta3Ctrf2LsAFttyjh2PSYOgyzOOvVTKHYLrZioRE4hUSq/dnHFHVj9bCSoTlppYUFble9Vy/sGVf93nyMACev0+n/r////////////r////RejTnz7m6obno6mqh6sa6MzHH2PdHVkWeh6KYrIqTEOU5WSvVXYlq2ldtssQfwZOxx+p25Zmc7e+fUuSuHJU90DymtXhA96fvNri+GSk4DlnW+9ulfK1lULBnyx+lHuPqVjm+fTYcx3AC9r+HX0oA035Z//////////////////9/2elOaqK85EPzn1WYhVzHNqiHKimXPnsfMa7KSVnnIq6orIYp6uSTWJ6NGc4A9A4zfBg+bG/l99Y722BL3CHK4vqLyiNtNrXlm3mlyBli8EWME8eJu54Vc76mBQLV2IBFUPVw1LHce/WweOAdc9boIVA6nRr/7/7////////////////qfq+kuzUlIqXSdL0FMmjMk1UE0UbKUd43OfQbOWeGozh3Car+0N5w50NOM5gOwIyo30F/Ju/zjVohAw0Y5MnZoZqIIAUPV0g9J6IIRWVwBoVKvUGPXZKisWtHcBPqQEs3+Ou9Xzk9jQrbd02AlaviV/2b///////////////p9v/Sq2Vmfc409meZmHse+pzu6u1j3qpi3Zpekj80C/x3MDWC+GiQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEQY+3gfhrcH8RRvA9525PNcTeB+FNyhHHm8GMHbgu8cyxZRYzChsru+39ouuUl98Ehq0/KQ2FJ3Q9ujuMnxWTRrrHDJQt2iNdeU/lTWqxUc5W9TZHNDu5mrOv3a+vm1fDn7uidDH/V/79v///////////////V/Zb13VQXRpsmbLqW6bOpaqj7oKrUuvdbbs6S3XoOtNjZVnZmQSRZ1oJqQoJU2ROpJbFtOYfAjScjR4255bUmpMH2ZkU/Gcn87Y/A+41AilHQb57Jcwie3JlLbWocQiXORFgCIEIKqDfVLfwFsUl5b6XcF38Lt/37////////////////e9P12dGsmx5xyMlDjEdGOY9FYlTPPY93bRjkOtN5qGnNYeVmPLTsU0jMzpTDkXIR8h9ILybUOHNf+9rKA9lU0ay28WQFuJ34MvsgizgEDmKzyTcvYbR4XN1CFSQFPyUnYRYLIcrFnDV76urGPPSpuA5/X//f////////////////007PvSjGsYYlnOsRyhGc0xuW5ZbZb0704Appu2k49w3JjwOCIGWuHjSkbl2HLM1jjnzH/vJ+qA6hyVqddyiLf1piS6is+o48TN65FefR1yxwx9Hdxb/bBSEkRA2OXbmW+dsqTtc/tPCH9jP////////////////+/+7bbpn2OmGmo5ioczGlFzVPMY5D1NOadnMYiIp01jS59Vc+iI84xZptZ8w90IVgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA/uFN4GYU3J7kAbwPwduT/YQ3gfhTcntRJvA/BW5IA/ktGHo9k46hgfpea8qY3FHqsSg0URL5h3wUm9Ud240qKPSSSrt3Z1fbtf5UsylBO1a/XbECYkKYvnetd+e7jHXVz5+iYD/9Pt/6f///////////////17VMpTszIjUc8++ujHkpyHKqTknyzNaqtc2zHtOMIJE9eaQi0Lyr2ujkGCFwGWfWdWc4kG8u+XrCibhZRrSgOss6mVNTdhqouVua3lG2EbRenfsXrpVK/dbb1A46M0gw73LHv7wdK1//iD+Ub//////////////////9du89FNmGHIzoehKe8yiojk9Tlcxauxr2R3dB9rnY2wYoS/FeCdjIkLkyHIDVK1cWhqXevEvreWNdSnBvJgKFpM26i3572h5r7sxIho0OlGiWWJ552dzIoOdv5N3MrCq1cd2zRXfnP+q1fX/fuAo//6f////////////////7/f0ab2R2cqY6JdTzGU9jXqYep81Tl2dZqmKS3WrqaVQitVWvzS6V2ZiFuXavFhDSZ2vVIF4N7Z5qwwln9Ozq4w7err22rcLvXeM6SdppCUQokt5N29vJfLr0lSCy5zxQi5fvTeHctW31//T1CbfhP//0//////////////+mn952T2WjOe11OjvVHdDvMW1rsRGZDjkqxUYtV5D5T2VxW1i64QPoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAPrhbeBmDtyenFG8D8Cbk+OAt4H4O3J3EXbwYwJuRNRAzACRxKD6nX++Ww5hE2FXGn1wE6nzlCPHzckruTI5wlYlm1RMG8vzLGv3JiDnTm4wD8oCSg83e7jft67WeT8v6YB/9f//b///////////////p+avR2mI76Gss04x1Y1Oeaa5rGTtD3oxrH2Mupyo7VZmHDRyvln0iY1eFScgGYdJzMyzjFczyX3zkEsiuuRgzm12G4R2vDmql+GSoGKtGbrk4mV7mF+uv+9jKBbqejZtflYy/uM3A3P/8A38j//9f///////////////T67mz6TjsRFaVCoUg8lmoRim1MeVshndHK5SGkQ7lJqpVsoJE1LcDkNsOtkP0M0W/N6380+c/lyOtVlLKqIMrYwow4vNvzaUavueOiSzeIWvLm2y53ukXpDRblQfd/ysNDjlc5Ocz/HDn9cGP+n//////////////////tRrK1kONZH2MORUcu1pV1bZ57NOU5WulT2MMmIeU4MESZa0B1wXD6lEUf9nYOOzR3orV1jdu8x3/ecWnqMYru78Gs3/l3vcH6KoW8gIoPahd7H8c5lRnPGVBo2HK0TGux69v8tvlh3/xTfgv//b///////////////9mfXdVPpCO0hAeqtKz3Oqq6LlLRFWdVoZakuyWuIaVnREs7kBcsDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAECYM3gfg7cnPFJvBh70wO6djeB+CtydXH28D8CbhjlL6iEkRiPArDe1rX/j2YbBtmtIRPp/bC9+WdHbh+WK8TeRiUfLpV47uth/Hab3O42UCCU7Ky0PzuuS/Xak9e5zpQNf0/9/r///////////////+q6Kl2mPVC7z1cxUNMc9KUZDlPRmZmRmUwxnc5FNdSZqjqOUmrnbTOT/bcEu3My5ZIcVBMzWvPTtnEONr/W4AypG6ALDSGuhYt5V2m2r0JaKg7xYpUZNHvu52BZeh7gHgd5iwrRW+tNZXaF4//+/66///l/////////9j6GgQOgyVUTAwNKD8UOBMtB4NiUWNRU6oFBVYVcMEDlMBgWPBQPPXqeHNBaVZl3C1qFj//XocO5KpaXo/ubF7e4pi+tOpN0iITdRZE4yjKtrHFBHQ0m4IBA3kJpx/PtfVJ/bkC46/XgU/5//////////////////3+1fat0OUpKe+Yxz3FGciqNNzCYc3n5JUg9pMv2MupZkPVBfQySKYjSBEzGLLan3fX1lrtZheL7YKu7qVIkXvhPIKylLsqMPiqDbA8cb+ujgmPczeABNZTT5/2z3v/nLv//xX8F/7/X////////////2///9k7UKjqkiKVqFZmVrEWjQSter2S12VTlOqkdT3aVMhDF6Ixq7EcYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA/SON4H4O3JzL8bwPmVuT0IW3gfgrcnQPZvA+J25XFCjF8uC8/M96y6//nWjNIzkcoSr/rwPRjcf+tAE+pY8ahboCybDZ7G+broer3kPLYZYgQTGm8/s6r77lP58/8Iv7f//////////////////XWzIm+efZDTTWMMmTLLPMOMobZz5pp89UV1RKtKJQ045zjXVLHn6Uc5zChrEZeaSMGICMru95ok1a0tpsKEPDMGohjKF2I5SSL7k2eLxUDwkYHZh6B+61BCY3NWKwPcT7qzJSlzhOM/8BX/P/////////////////1/7+ruR0oSkqFZWYOFR0ox5NFVkZlqqkupRhFfM5v/JOnwI1k2VXMMTiO4Qc7UdHg6/1XNvrdapBNV3KVVa3cpkgbH2r8uwTHUdaExpCvru9x3/XcTz5qZFmFhi4rtr63am/rRTv/9Qtv3//////////////////7N8rVba5nRZXKcqNI9GV2K5H2dEdkYxEYhTGI8zMlzkOInhN4MTJYKMjmGowuy8GU2OdsUh1rpBJ1CbzArHhY0kyZB6PrLyyGpk2fE+j6FlpiP2pMoVsJ8NUhqgDgXb1MplvTJH/hE3///1///////////////9e1dFz7M9jTTVU845XV1M2Q75hzUSRUmc12r7YJzK5wZIQdoMxAE4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAANhIDeB78JQb4Sm8GHvSg6SCN4H4K3JxL6bwMkJuT5YhFC3DfSunPc29Q6fP2YQxMMroTGl1yQueamMfspyMbtQWNKvs+7vvfQ7PnZ5WLvkqLX2+75X/92W8r1/////////8XtYcLLC40yHRMeCUYeCw+CI8HWGnhYDBEH2uEwaEgKBM2gkZNzzB0onYEGqKWTl3dSnresXda7oTzbE9UGan4JpmO46Um0U3GpOKKMIxH+tZM01dZPQBlME85dbb/b+WDv///5X3Zb////////7+pbVIB9Y8DCIsISzVCdo0PJcJ0B4SnRKs6QHgzABYMgggyAjkGjJ8TMCmQ4sZCSulf6xu9N6/WUeiuotgxbW7DOsuV/mdLBtFqNHYhi9ePL/dkgIRZwkqLxIp5ML/Lu8v/s/r//CDfk//////////////////79r0mrV3XK9WuaY+7izvUzlNVqnK7OqK5ZZUc40Yv9CZWAKW/i0rassrhsGiKJ3r9Xa8zucGfYlDUr5Nhcy0vsRY0FmjPDZGfIEoPE9nRDRx4PsUwGSWNp1sedkFKHO/XAP5f/////////////////1+WidvIdmSscSZXapxZiMpDFOKahnuyi9DDzVXunvr7aAFZjmNLLpwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADk4g3gZgrcmeEpvA98UoNsgLeBDytybDA28D3ibldyUHioJPvuXmd2n6ytLc3fxbzvzTQbHaT5RbYxEaKcJi2HQwwrbxVSey19RACQkTwqWu4dz3y5Gv//qA/9//////////////////9fp6mqu85ErjTJVVKd0mk1RTGemxpjEEHIRZkJjLntQOF5VsLymLMOuDGSyUhOe7WvSt869DokdVVO+iRR2lao/oiExseJkQxERq6bVheJF0mJkEcGcHpNUpXzIYLf5f/////////6+7D950KioIgmDIASVBiKAUAqAsAqQ0Hj8WESjBoHwofJAQOFmSYJoLsFAcBUKQra+vxiGqdwJDrx1yauvF6mwOVWMphHrgu81pM1JWbX1sCkdQPBst7fH1eDr/8Mf////////////////////rIztRDO7M5UOTIpXnV3M6M0hbru7mKUhSqSNco+Izr+7jW/kGmtGGwrK43B7vYETeLbp86x4bb03VCt5bDuh6WOyxhwrtwXiaxCDa9fxZRt4yugh6KW873fP9JX+//wD///////////////////S3+tpCNRlMnmIshWRN1uSejTIjO7vZGaDZh1k1aLsMe8GpHEKawAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAA42DN4EvO3JqLibwPeJuTWXg3gY87cmVu5vA14m5LyAIqBkHTEN37GObx12gMQZUxrtopdrLe38wkxnKtdBbx2zevrIS2DjVQah6g8WqnzrP+n+//wXN+v///////////////+//X5+nOZ2Wqoe59qHOp1Grsh5+Xu5iMpqDjnIe63dzWx4XMKQ/EfqHTRbXirIdIkrVi16fP1fONNaEQVNU+s0jDNiQIfasjGRaymC93F13WvtMNvFm8I8ek+t6i/f3VBX//F/2///////////////////b2+V0u63Vx2etBSkUoSgCa2umJ+1lmCW5uA+A2Gf7ZpNsI2gVl1Wkaiv1bz24/a4ON7OX3Uh/Vuwdc7ExPYtUWh3Vmvn2UCWxmQW8XcOyTW5f8fbFr/8Df6f/////////////////+myN0s9kdLKcc75lDaM7qecqnIxdDhfLFYXKhQC6h11ta2tqLZM0ZlSwnYJ8kaa2Wv3ujW26QNEvuinXP7730RDelG8Z1io37+xgEVf6A4jIif7k+fjDR//xH///////////////////6/ftkIpjibuXOWhe5t3dKgu16ajC/gToMs/MD/nRJrVz058AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA3iHN4HvO3Joj5bwMaJuTSm83gfArcmuv5vA9pW5y8N0jDc4PrQcW3in/8rq61HKbeowdlcPcMEYl0Ya8EamlHrdr7Gk+tvJMAd5Eya1A3n7uof/+Bj////////////////////polD+ettDXONc015VTHo05kN2V0pVTjKu6UmKyVbQ6rkVDdt2EQt6S+rEwDxDYPL1/97V2KyUOJqE4U5iDW89QUEuMcXhnHAiJnp4fBuMqQDLECF5T96ljnf/F/////////////////////XRO2x5yudLvOd0ZDGEXfKCU6Kt0hD5FiEPIRRVGBc55qD4UXu9PDjcSyj0f7zbcTPR0EjpIHRPiKx/FBqRHpyHHhokeIGLBFWJZSnxTiRfFdCOVZ6k1KYlZL/Af///////////////////b/RfXMVGdqo1hd0yD0cSII7zorT6s7CKIYAUoMNand2bHQzBrW7jHFfUb5rpf2+qNlZasTpYwdY+DGpH6RqHMJotUQyoDIfwNh88orCKLFog7bVnBgv+Cf2//////////////////9FX7vPYytZynlYriqcc5alPFERVpcjEU6ZxdnWJ46nLLhaMPgPihHyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAM7gDeBbxNyZdB28C3ibkzSDN4GNE3JqEcbwPaJuStIDIarh5Xnd11OPdsmwwyHfTMQl2+lNpPSDKsr5E3Y6v8Z0n3C35pAkVvM2r/P9WTX/4B/f///////////////////qsr9XY5qs9nomUrWBXWpyVl2M6lZ9YNY7VbrI+aAh2RvNLVINHYJDVEvv/rv3+YsFCKnR8Ph46zJ5cItSGqum3D/+34uzJryD0sCAx9/7+LFZX/8V/T//////////////////1XVHb+9VaWQjSys5nRDqWvIRkKlCuRJmeahFNHdEI/TC/CUxQe6fASCs3EB22X63WmpxoTcbjML0nKhaIqL8ouMgIkRSyk4XV71h9N9hKQSoezrUXVnSb/xf//////////////////r/67NUk9nZGua7oc90dUIrGdsuZ0+7TVfbKQb3x7/3tJlzhLULR/EPTm7zZp779GrYpGA9WGHeVhZvPUExJhDEFQruhuuPwiHZwfh7iJVqtmYw7/4n////////////////////00sk+OVEPcqOQ6lK+RlU1nK7OqmQh1VkRtFRUWqnhmPOOwUmbRjqMfQQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADMok3gW0rclikpvAxbUoMXdzeBbRNyZbGG8CWibkPjRiBYEFFKvpjP3Ig8DpgiKyCjMdufQGpAYMIMpJuoK5XclR11DqNIRzqM56I9v+Gf////////////////////0XbIz7IiLR2IyP3seNdXmUrW1q7oK1oZT2ZCuUxj2HkQRY9nAPQzg7sDn3v3Oj+r5lw1Y8ckgHT4PziAjImzk8nV71EwODOhuB/IKrLp7Dub/Nv/////////39QYXD4VHhVo0IvERREIGYKAWKBsydLhoBUDRYG3Bithsg4Aj0gLhFVISzkx7OVqcyJVRROBz3RWQnY0WSZqPQVTZFoha+NA3bEowRzv11F3/gX9//////////////////r9PtW6W2ZmrdUU8hTlOiIpSlUGyP+N1so6B53hiSX0y7xSX+OpG1EACHCnlGHys+pA4suSe0nCIZI5TRDnDUWojZLzK49xEpLODFD6jZ9txgW/xP9//////////////////7+y9UaV1Z3akIGoZCcynd76Ml3ZJ7NKzXOpgbNU1naVVzOYzFD6lZRgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAuh1t4DNK3JlcZbwMaJuSpSU3gSdqUFzxRvA1om5FkSY4ytjz/LfnSxIvxiPU3THa44xpqRi496hBD+o1EkDWdTr65Cf/CP//////////////////0//9L3O1DXZjnOUzOceRKOIOIa1BHtVnfGvq0WFY4QBtCMd/IoOQ7pgEhWaXt39v7POFFRKycipMu6MxcSkqLThKyRqasXSxmcPQzpraqnrHV/8V//////////////////1+2t+l9KoVEMxCZRRJjnY0iFRFRXMVkcp2yo1t2czTXJd0MffZKKDLkdqzFYLksN3If4nZQfQrleqiY4xC6unGerj2ICTSOB8Fst6PoGn/Of/////////2VpLEHkDoSAz2Cca8IEDQYCDTglASFmGkQmcJHGB5pJiAu8DBMsSJBIohZBjNFp2/3LHHmmY6Jvn5g4ikz5wb3H71iqtqIXwZy1fq1Fz/l////////////////////9fdaaMTNdz9kRgby3VHBMRU0KdnVmZKlSQOR+lFVmekJ0MGP8uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAMCizeBbRNyVeQG8CTqSgsB8N4ENE3JY0NbwLUJuXwKy0d5Pied9fyKeYgMP2stqycw/kw+mlJB+iIcgsyx6Aoja9XzH/g///////////////////2T6/L1LmSrMllQxT2QjIzlaVCOx9aM7OVLglIhHsZWVlMRjp3YcD34qUaWAOyJQazanZ/YVhhRyW0Fzq0mYDgxlRai9eogR0yUCWHopXWu498t//////////tTmCwwkD7wO8MAyEz6kHgZBcysnBtCAOcLDybFoEw0EGDjaQfJmiwqFHuHi7/+RU1F9IcLVq3k9EiE4tYjT/xivqHqKhQU/82/4T////////////////////f0dzpqtbL1VvYM4t1McUylSh0qxByf7c7O6WV7XPSe4TGtvVtHkPIYG1O7+uNhHHEESo7oLHkKAXzFGltcVB3UCkwpXSnJn/1///////////////////0X/q1EWd6q3IcLqqO3ViHaqPal3bItmveth2K7hGsBEJxDaKpOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAC8o03gK0Tcl2Q5vAtQm5LFh7eA7RNyWA9m8B1CbkJBwe4QAIbdv8rNpeTEqTuas7OYuPqimcMWR17G7VjKFQbFPXbmv/f////////////////////6qZEVaq7Uqk7s3ZrUOtfOr3Oyo1jKZauZjsQ0sqNDMrnRXRhSMjVJYajSJ1prd/+wjksbuFI08WcmooNhQsYSyL0EobXQDowHV9dDv+n///////////////////v/fvazsdSMx3UzBlKUqMZt5GiHORERtDKCSVCHO93e7uSNLruBDg0HH1C8ViL2a3zF2PRWbN3rkxySMy1RDnvUMyC8TgWQtFP/f/l//////////////////7/2Tp1oXnaqE2JsZzFUqKiLNMqJM6FdynaR6ma8zqR9ywfgdnl5JNitSIEghIpo/tYR3Ugg1upofvbQK4uNOeL/hgXzgPjId605b/r///////////////////+iadq5qoiq0qqVqrOeSh71JnYykCl8y8dXTr6aKDfjSiQX5WCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAtSQN4CqE3BLQ3bwGOc4CbRs3gMJZwFnxRvAg4m5KoFAADhwqN/2FKGnARvQeZ05hEjMdKi1G2mXHHoF2XBJNPmf9P//////////////////7/9Xs2vYupFqWfSuZmGQepS1MprLM5tXVNc6Il5iMhHQOdnRWZ3YaUgaBn9WbfsIScWqEGUFG9VCITZeOb4HEMqAgUF91Z/zn////////+3q7yLlFmjnlFuHMDhFRseKNeBUqMGgRdU1YGEQCE4qgm5gDEOaBgfjt0+mO8EBu8m/Uq47iKeaQknf/ENvyPRFDjOa8v//////////TucaD55oq4WKzpQ6LnQXPm0CMmNcVW1ENmBYuAhxQKJAp8sxYxkCUGjwvf19WE5OThDuBVu0HIgc8yf8eGGoA0DH6eg9/3///////////////////v//u7qyLVkBMR1nYyGUqkZiu93W0zu6Gu5d7ndRDvKfIZVRiCKrzl56gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAKgdTeA5xNyUzCm8B1CbkqWAt4DnE3JQsObwHOJuR5gsLx9dr/0LqNEA3UXa2cSRCyBlB74pJaAGiEOT/f/t///////////////////+328qq3EMYrkurIkkGzMwakwQvWIQB2Wh8G5gHJIzbtfvyTHkKBYJSJjv/5UbKUiKypO/RxDERe01/YtwVDJv+LP/b////////////////////tu1rIjL9jo5D0HsZjEkqlR0d3sjykU2yne72RBnp9N4WAOK6wLKaoTCxj6dfzENUB2iZ0pFwhLFBvE/2L8GgeMJp8h/0////////////////////7eiKjvOMdSyspUlIQllOQ6kVTv+GuVaD2cg67OcMzp0RwTOXxJ9SQAKGQylP+ovkY12G3rFpxe9PnGahIOFv9S///////////////////////0ZzzslCzVM167gmdXVKOzNQ8ri5KlRVyoM+Urq5sTSZYZ6xTWIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAACURs3gMJRwEytxvAUom5KOkDeApxNwS24G8BSibn2IRgxrv/xcVClbXaexKLxw8TpT4uJtRYDFvE/r//////////rtUcoWgYF0BkNoBIjJBw2HzBNjQuQSfCCgKdAUFyBYQGSZIuJjbw8CAO9v/i14e4LtWDw29vsOagWMHdPk/////////////////////9U/oyMh6jkK7q5x4Rf20QqQAoaIWA+W0q/YRWBUeYEeoi81vBuaArjd//SZBvb1l1GCplfiAzQTil/+d/0///////////////////2T7q15nUj2QrMgJ1boqIWtkOxp9ysRERCPMDXilIxUQ/dXRSsd0Rp6meCZnGBELHk/+gPSXUH3pFI+S/1bgY47/r/0////////////////////sv00ZTEc7NzMymiMkRscab7Nrf3HjQKFFAnBpDbVdd2IzYOBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAAnCJN4AnE3JMkAbwHOJuSY3u3gEUTcksvxvAcom5OIER//V0ZQk5+lJZCyh1vjxbjYqX/5b/////////////////////6+1OyO97qpAVaQZWIZSsrvdFYz7sjX1MqXQju6o9WnRR888pLFUHRHE4WJW/8odadoPfnqXtM+rcOKt/zv/////////////////////qntRiser2OcykysyK6PIh7GkVCMSZaNoko30UDTlSw4K9hoJ2IVQ4kMEH//49A/obWlxjIW/xMdwVR//f/////////////////////+tnR7KpTtZT8zGOwJ7lozGMVUtsdrKMF3zYUKVJLYqxJur7JeaxYdEYLG2/8YL3l0BduRX7/XoHxv/t//////////////////////b9wxlOlmYaZ1ZJUMRyOpnMzlnLTYqqR6BtWWa58UhXT+fl5THbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAl6NN4ClE3JIsabwBEJuCI4s3gCITckVQ5vAEQm5lQLR//5qRLjt+RGQfL8I+Pj/+T//////////////////////Tud7oW5EbZVFPWuDsUikPQbWY1zskzFREohSstHRTUdSiUU0gLG1GsaCn/9DUvqf9Ve8v16hl///////////////////////6f8qJqRDXRDPIYzuykmujmZ1VkkkerIRpmWys4xzKXZlmRUOp0hGrXjYmX/+0B1P+qZv6vyI//X/////////////////////9vp8t9mMrOaqHbtVERJLu5nZKERmfeq3RZbkZyOZqqgW5EQiUIwsJ//oe30/Nfm/8T/9///////////////////////pVJm2DJdybMbpOzEYpVMQ5XZzr7uzFeVGQwzMVFdwU6fT28aWGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAIhiTeAIhNyN4BG8ARgAAfiGN4AhE3JAz4bwBCJuchf/6bxXN+mrf09Uf///////////////////////6Ki9aWZUvdCqcydkcjHR3MqVVJC1ZnVtKqRj1tM6nsolx9s2Z95Tgct+xOjnc75f///////////30srQLuIj2ggKhJ41CQ8HBUNGZkaKmFCxUoIAmKliQ88GUJWWMff//w9f+v5eX////////////////////////0dEfVDuWnPl1GUymqrK7oi0qQ5JrEefOSjkMaMsJ+XpoWFft7f////4v//L///////////////////////5Cdroal3TYpEUWVXc7IlUys5jMdnXKgIlegODr6JzipRn3ojRTb4QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABkwA3gAAAADHgBvAAAAAGYADeAAAAAMu228AACbn/6f/////////////uTajKqOuFjZEAmjRY8YW4PhMvcweJBZ4ME2w2UeZABJaTAEGCAZ////R///////////20boSSSIIKCYawsTeLiaITAAIuNBMBAmLUGQ0AmzL1HRYKAArFf///////////////76xVprmyxwiMaIgsFEhYRlnGRMFzJANkwkOJh44oXNhwF3rGBQODf////////////////////0tty61Op0IxZEFMpYQeXm4p14W47u9/Pe332WUdgG+CePS0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAZ98N4AAE3I0DqbwAAJuRsog3gAATcjEgFvAAAAA/////////////////////+2raNyao5DDbq91MVNCuzOzGR9lG29NJSRNubI26QCUAqt3E/////////////////////9OrIZTlsyQyVcQU98majsMysEiw73H352F7nBp/41tkuKgsi3////////////////////9ev9XtU5nZVVXSxiqp6TmRZ3QeQOdmkdCIdp1JvJmaUPUo2zGw3j////////////////euDo82UeEHihUmDQQIHSzwisYJANbjiYsNYsHih8TpaDC4XMjwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAGrjLeAABNyODFG8AACbka+GN4AAE3I0z4bwAAJuf////////////////////9Oqrf0V0rJNK7HJsxg01lqnIxUdFWRWL0VEVXIt7I25QhkHU97f/////////////////////2NsnWm0lTi3VGMTYqVQ7A5HkQqmFnvY7IeSqGRpDnZ2IV4IpS/qrxf/////////////////////Pr3vszIQjuywTWZTnRr5kdikdp3aXM2VkZkLaY4M3atx7f1kDJ/////////////////////71+s3RULtKVTsUyhddyvUtjWZHRwmdsO78G+FSCQRCo+AUgASgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABOwA3gAAAACXABvAAAAAAAADeAAAAAAAAG8AAAAD/////////////////rASTwqAmibTEVSh4CeMU6WLP5FAVFQSYBcO/////////////////wDTWeniLg6VGnZ6WxKRlYivGKNL5IXCRZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAAAAN4AAAAAAAAbwAAAAAAAA3gAAAAAAABvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==";

var ExerciseFinished7 = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwMjYwIDAwMDAwMkE4IDAwMDA0ODA4IDAwMDAyMjk3IDAwMDAwMDRFIDAwMDAwMDRFIDAwMDA2QTU0IDAwMDA3M0MyIDAwMDAwMDM0IDAwMDAwMDM0AENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDA3RUMgMDAwMDAwMDAwMDAyRDM4NCAwMDAwMDAwMCAwMDAyNzhBOCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAd5hziDeEty5rFXMG8Lbl4Z0QAN4e3MA0OgAcw9uTElUm/zknwzGXMrlD1pQzw+NaOHRMPAU6FB09FLFKFuLvZWW0UEaY+8iijI36f1WBy9rDukyR/xEBGBXJvycTm25R85eJsmUqG7BBAAWBB5dRs1Z9H4oZHGJXNUVP19HnmXHdAlPqm0Ek3wKGFgwQAbobH2QTOKtCdRNpAxe3DqORyjJAjb+qZJicMnOEMLm9gjkxWbBdtQu+MlWh8UCNE6nSZEk1L20ewkxcmF27bzc8MhmyQRRtz31tkbSCCCLa8oZ66jEIQy/57SCJOs7YZBNGkxnvdydMfwtAu3V7iNu9hCEIKRQZ/4Rb3qSciGGvxZrLQfNWGItpiWIe08GOGRqxk1sxcLYgoOyB1HAaKj+1tABCLr/01iG6aMupG83DjUCP+jIowsU21NpTTESUdOCUTWlHNiBcxJhyi0j2wAzhrjv0clgd2J2aZQ6mETo7JPQVth9NQ4SDpEECNYzAkIMwOrnOkGnyQcZX74rZNysbuNK0K4OJrsYynnNBY3cyKe449BhILHLrDeTz7JhpY9CUz6BZ7HxT5ut8M2Mm7ZFPQOfL9lfycpM3QOMZTGMZN0nZ+KefiuTRr7YzfexjKe40ZEv3n3wyn74Of/L974k0WfzBycxEnMLNT068RkZs6sJYBUMBpkeJg7dGmTJe9qT4q2OjAj6PlG4AnKJ2wqEHQYJpQB2IowsxjL5s/UfHWEYAKQHIZ+YhLBrRXcgoAAKzrXZ4mI6LFGtpfsnbooI6joMMYO78MP/U9CwKdpUaQHocbNguEFrPo81aj4d2ekk98JxkpSGr1AyUzA1nEBnkpTMOeHfGoGt5u/bGeEySPIGrx4bGq1Ol3is0pGdneQJZG+SDLu/3/j4h79879M7vu/+cXvDvilN43n7vj+n/zuBEpnN9/WM71TGsW9Map9R83gMfxBPXHWSOnLCAxVTUgAXDwBQOF5g8OnFYSYBJZvEXjSRJRsRHRPxJNQxBx7QqBU81FU5lIM4WIvx/5VYnH/QzDANMwZxEIcU7MYUF2fqyiOQnAyoNhk6TIQvenqgiNwjMgsBWMWUToWWlyYymVIcefdNl79yiFymRumrovY4yrXAtiGq4ggDoaJuMyPMh26V6Hx51Gn3d38kTV6UpRgiemZd28Bk+b3h+E8iQ396NaHq+kjJl+yQJWNC6qO7Uq0/hvjq+HHrNJW9/vUCPfwNUh4vf21ilKx4FbQ48f+kOzz/Gv+8rbevfOd016Z+6Zj5j2pTV841vUu/E9M7pilL535Y+7a1j+Su/mu87vfECIII8UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAKJlXF69zK8LbqWS1vD15q3bExtY0AIlKmZR6e8AX/////////8GAgCsMjnmayQ0YOoT5kWJMmLeBSOBQmFICeYDoFxEBsYBoBBQB2EBMwWXwMtxCP1XFAqMPhsxWDgERDBQEeZWABB9oREnTEwkLcrCtHboYpEQGJJkIaAgMGHx8Y8PRhIlAqSCR9MFC0yXEDTypKwMaID5p0VGGR8Y0CRkoomczYQEYwYdTFwGMBm0KaHxAAEjJbM7VJdXgcYYIzDCQdpa7mruiPEBAxrCCEJxxTk4STXaNIwI0GVAdYXebsIDloJgAgBASYYKqK30ZC7JathydCuXzSPkifEhYOre/z4YNTZnGJY6FJCnceV9KSAY0xhlkJfNOdQBgb2o+N1Z23BtbEkWxDaM5fsu2LClwFHUNHFQBwiMsPVsLePbWdt86BmleNxu9nGIdis/bmY1KHzhcuxqnGG3//Psu///+v/////////8IrDhAc8Lo+DWsPEKHJ9ojAs7GIpxjr9Pq/0vbBI52mswPbeWWZ/b1nh3mLtzbZ3+l4iKGWaKnWX4ZYwdEdHFnaAqPjoBYRljdJESpUlvLUkqfPM5W08pmh9EopFwlYpxNJtEjUbcXjWnrtSPkpKg4igfqNULa4mhs1HGG5P1fR49n3v7raunPLjCY2x0uUe1MnmnUDIuWtTacFdDhtjec6uNBCG9GRb+HulKY87xFYAIEu2mv2rdjD8D7HQC2q0MrEli6H4ik7AK10A6P6dZiBwOAPkhPMKLMSFMSHL9wqC1DwqBMGBMGBMCDBwN+4gXvMuFMmbMmjLUlAIHTxGGAhIyJs0qUKhTDhRY0jOLE2OAgQZ0WZUyZdCEG3aMACMMIWgFBgsKMEaNAyNksJjpnXJy6Jx0YUUHn7nzynRimnPmLAiQ5CQ6gCIGZFmNDmNKmFCtFS7VsXQW4MKHMODBQMwYNa7D3qXYl4YkOAg5f8vGqdy55wGAILoPoB0JaYbX599FhEA6D7O3Ld9343lEFTs7Z247jxu3g/jE1zs7l7vwPY3KGvv/m/8jhuG47JInNxeXv/G43T5416efm43br28+5y+NyuG5fbjGrGN+XyuA3fdxnDuQ5GMZXDbW1BFBFiMQdy9E2VpDlkCzFJhuvT283FwfB/B8H3/8H35c/iAHz8EATB8BQTlaJEN8BHjg+TjjXzve8Zi0iaru27++Mf/3/z/nEirU8VvbYBPGNXltS6GK6COhXilPS3l/HOxKgljfIynIrEqvtSciPnSlH4gx9KyjWjoRzxn7+bcz9sYZ6K+E7YJ2p7Zk3Ax7YvNXO//SlsagPomcWp9/Fnj26s9qyQHtGTElpgGigRLODwVvcZq4hLtY5aciuAAAAAAAAAAAAA//viYAAAC06QSwZSoACO8glgx6gAJhpBWbiqAAKVyCnDBNAAAwZQLHgMKhAtpBq5AyJYA7IBgg4HXHhiQDopgbaAIBjKDiIYRUfwCBCCwMBEFRHwewRcGgSCwICgRAeCCHhqkEgYSAZFAwmEAsNDGwAIYDLpMB0QsYopABqjsEEAMAgABQHEWAwiDAtGKgeuOAd4cWSAyA3hOYYPAxCMgMIqEDDyKAweEgGAkLPCy4Cg/A2gHACg2HhMCeBMbAaCI4nMVML7C5gt0IcLiFnB8wo5KEIRYtjiRFNIaVFnXK5EhWwtwZfELDJFs3FBF08XQ4kRq5kZF03JtiySJq8rLIcMsOaILBqwGxgXYzyyVKrHCsOaCYEDME2gs8XjSoXgdYVApEyZlIgRGmhSIqYkwYkyxRIqQVMUqtaKCCzAus7nVIko63NENakNcjhcJDAAAOGXhHI2Rjh0kyOo3NCstRNHCeN0iBGw+BZRbLB+SZoPgXEmifXPIULKXWtknKyC3m5sTVaj60Xv67bLPXzJC1ALgQcEgETG6o0q/iDB1eObmOafMKkRYw4symqjlRccxjiOaLyUeDQXiQIchInC/AbJBseP3PcWCUWC6OGAyJUNUsPTi82PCZzFLONxFGnMjGIe/erO/V2MYxc8ke72lDbOdY5jDmdiBWRUMIyc5lp6sqOnp1qZr7VpuYr/zf///nVdtv//+fn3sn3/+AABQGBAABAABQOBgOAaK6DAgCUIRRCngrHiIe5AjS4IzMwbomRpDGYBQsgwGOcAElg2LrIgXzI0J1EcoSNaSKCRAAxoIAAYgAIME3ESAJXgZ1CDbHOFdUzDLAlAwHMFyBcCTQtIXRELDlKUzuyY4BO5NEEC0cQTNh/FoBs8LEgFggBQTsmkaPwMGBC08mAFAZFiIDjKBUDIoCTQB0cDHgAuaGbFnCxCu1Mxmo1vlAXISAsgnGNE3IOT4noVuGRTMZkiJMmgyzECf+u21y+QMiY55Fzdk0yKGkcw0HUPgMuhcEkxDi6RVi6Q0ZkokF////+RQihoTiLkXIufFzi5yJht5XkXIObl8vm7JpsnICUjo4TAbBNORghZAgICgoG7hpDqIaRQZo6TpDiiTp8lS4buEDqHX3F+/TJiYQXHgFwMQIUAqix834yluh7TNMl3HueGYLICaf0zd00wuBiIIHMHuTv9BnLhpHgCdiNkoCdgEuMH/y4aOhtgZYA0wvAAFYcY8EhhBgP/03Tf0JuXDAS8TMpiNiZm49D3//1M3+8zC8CWDYCuBeCAMsqNA55Lm4c8e//////+ggxp//jzZB3QTJQ6ZnRhyTIpfNy4ZpoILNFIKMDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfkjFQHM2ACvS8q9ODMAGISQUgMby3DPr2p0I1JuaWVONDyChRVu1uw+9S9u4xGHYq+CwyDQ8LndBZemHb3zt+/vd2myt2MrdHTZU165dfVFFaIAVDFQRXTn0k5nUmJyZvzU/Vh2rOTOG91bnMp+U02VRcbPFiTMFuvbmH3jMqty+q6kqht+YupqsdxXYbGntAV6BbMallNzGmuxGMzVbOvZ/etd+zhjr7WVWrWq1Ncwra7h+OtWqbKmtVrSoaWlsy6M4XN8vZ0272O6+Nn8b/Ncy3YpeVrUpyw5llaxvXatLhrv17NSrpfby0HPwv44/rLvdd/VrO5KX1Zy4sqtdzx59rWsvxxyy/H8td1hnXvc3u9/dbwkgUTWmTYjiAFEIIibE5ohPqqUkRcCAwHxK5eoqU+tlskbJorWyRsbJnSHA2wDjlrW9jpeLyKJwvKcxLx+kXi861Iol0sF4+miZF0uoqMlJGRkRE8mPkgpAg+IW4Y0ZYomJwixeTRRWiZF4vIoo6i8lX10akkkkkUUZk9lIrroorRo8yWQVFNFSTrMWVSSLySbXRUkl0jJFJJaLJJJJKoo0kk0kq0W/RRZSSS6KJiak0SUcV//4K6E+wr8XzZPNvCbJb9J/eTRiCDgDiHus08rnWQRGG43KcJe7CPa8NI2mGsJ9buNEz+wVG6aQu5dmKKrG3Lo4xENNgcRx7Dx123gplw1Rkxaw6DJFOUzRXfZZNZ9h6ISiMTsvsS3G3yincoXWyegmDeACmQ82F7qKZfegeJschrunMwczRNFkyhM3BTMwOa0yJx+XTcvvTkEVMKXVFlKdc1r+XNXO269LWrYW8ZXM2rPc+45YV+d33KjmKkZJgc8Jmkganpb9LblXNXsK967y39rLvb+ONqzqxnP8o9973msLsxYv0H3KlyspjC8M7n5axsXP7zLm+9zrUVqn7e5h/NW7vd/llveHNd33uGXce4W+Wu71njEcKvd0Oe7CAAAIAhgmHaOKDkT4Lv//59mY9UkzwqgPmsGgTe1fy3/4fXz3c3Z5Q7mKSc7UeBh5j0EXV3FstctXqPO/ZLpikWzEwSU6DlJzzFFx8HTpkdLpKGpaIOal01KBLjPEcZjnihBZQc4qjJEyCMiDGhxMrFA+XjU0QTWgtTGqS7Lra5w1SZJJnPn6k0loqWldaLpHXUtReKyVNFSqjFValuzWapNSS0aKSLMfRT6JtRSVZIvIOg6bMg92qqZSKJix41SYy2+1GVW/+H27HuWQ9jipQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIP5BSAxvDcNESCnQnTW6eZjFIDO3tyti8qdCcrbq1in65/ZleBcwd/YjVzG7MQ1AsX5hUl0AFQBhKb5jRobvCPqvaRCIKXRSYZ2oapm7zVLS1ICir6to60UlEHoftQCjfC37e2TZ1pG/zW5DHaClmcJCw+Ofj2U4V38uYzr8M7SDmhEFakZtQZPynUxadOnf6RZMFgCCnDULiSlADPnO7kFnK9TTsqr1c8aKpq9j3LP57W9yytleu2c8L2dicr63zv567T5XMpU9DHdfJIerx6nm6PKzTbp6fL6S1c1hf/HHvcrH46xq852/l93Dl/n2dU/fmk3ItrLv8zwxy/eWX44bx3UqY549wz1+f63jzmOO98/LeO9d+t3fLHMd7vSTmOWGt1KpAAIAAjihjybEIsxDdxOU5f/7w3BEgk5IGOwcZjhIY/T97//8xnlvmNuPT1mZ7hMsGArNqcSrymmpqtmV0+d48YmJuYmxtMzAyMDFA0RJYdhDLhLpGxu5sbEw1URlGY9xxkmMoyHQViTD6A8F8vkw3JiR08WmhxIxXWYrTQZlOtJ1mqDJVa2WgimtVB3ovPF49WmbomxIqNGdqzy002oLPJpGzIskktjc49akVvTQdFkVVLL6CdrqpMt/qSMUTNJmV3+hqq16tBFepneib0HeqbY+o6wzGlGCQoAIJn7rXZJYlD6KWSKzYr1ofcWiWoYqOH+CJMMtDZCXuTg529cwyhmfzrSajtSZaTzzu4YXKxQxJUBRdM09FOZwywF+K1BL4dW49jIcXF7bPfrt0rIsc+lpmMwnazRSKxSyLhNwF2iF1OxoaPWSso0KO8MZJOKj0rH+tOW2uSfVb4jzTTaxXFob/MCXMLObX26hRsavqHvMO95oqYMWPiA9bKU2+7+SaFu3pNGvGhW1imYua7tmBHrbeI+bfO7QdQYWqJuLB38xKenrbObZprOfHhYzB1b//O9/4zSt9/Hz8bz9eXX/o24MCJiAAQAB6KGalMZEnzL2deex7vuOLt7ZEKhmXHGn1uTkiw7j/41qK/jf5Yp5TLLfLcNNWMKxXTiRiLU2FqR4Xa9lRRBN6xmfuzC5dVmhKHJd1TieUyTz1HmKmliQE8EgdAcyUB21zqBuxjnHDqLFqltd3V3Ltt8TD3Mpj5Zf8TDn088xaNpHVVax7al01PL2cT1E3NSyGRXX89stzpdy9jXX3M19VfPN97zVh5jfVhBajpdryqY8MgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACFGC0gMaw3K+TApQLy9uYIovSAzujcNLRelA/TW4oscRJs3HFbY4CVjIlGIAklFLk/2k09mrZi6og4EsOuYZonFvq6pXZSwYi1iMSXOUvhEFM6kEPxdWs47Yn2h+ZfeCi2RvXRoBa6GSNnh++oM4dts0dbFEo3Zi9WloZbhuMuxBlLUj9dW+GKjurBNmh+WVGvRuMwt/oNZW6sBLiEFwU4iS11FZ0EcWUtNl1PDv9mJqCX/kkUoc6f8LNfGmq1MtXbdqtnn3O7dqds7w7nnh3D8cu3cHohFijir7Uv5Y2c+V689n3PCtvXMed3nq3d3fv5cx5rPly13PPX77T0kUn2e55YZd+z/cf//5v+/jlnjurrf81l/KuGW525bs1kWSKKFec9AdSn1cODd78EkN7qeDsNYa/HHVKxGWrnAih3/NzlTWmtQFR3/zyjtWWZY1/jMQ1bltqxNXDbBEoF3z8G0Epa7Xnp+3K4MVPWbZHkJ54D3ETNZh2Jedbb0dTF2SE27fsFGaMcyUdm2daglK5PRp7+O8pGh59cf53b0r6a3ueDW3+dSW8LH1Td9b3j33lqdbzNFfXtPjVLYiY/lvJnObZkxgEKM/pKYwh5CzmF9qWw4UfXy1BL6z7e871PfN++Zq1gEPl3OwAQGGKBLDEAoCxBgAeOoXcuwmKg0QDghtWu1ZlYrYUQDCQ9L05s+Lvvq38MLDrqLotBlK7mJO4wJdVqJS6An/Zyul7IzC2jkggVXFASwagYa/E1fjwKB+yR9ioWSUSHwXCfOE8XCeKJWIgBgwI4CBCMTAh54ipdOFgeyeLBwumBA3MxdiOg9sFCIhUTFYuQLzIOkbl0pF8qsURWoZFA04UZkoqPmqa2NJlopkyRwYjUcNqR11mySkFGI55WZkTBFjwxw2WWaEyzJKTPLMUTqaKCTuyKnSVMjVTupRst3XSRdT0UXYyNZBD9FmWp/Qd1ps2gjuplbVr2Qfauyu1bNyhpEWMXQiHp8fghCOg6kvBwbjA/Pr1aaKXS8ghPBvgWEMydx/H3eOX01TO7nM1LO7VztySwHhHq7WTML0wH9dGCsatynhrGlssWmxuTSTGw3RSMkTU7MIqDqUFuYnjcrL5fNDVE6PMcpNHuVj1EwJUuEsCMF1E3JVSi6dWUjRFBbGSSjFb1rNjJFSRgZGzzO7I0rMpa0VJpHzw4ix5sXimo4iildIySXZBtelTWg6U862VvUulUpaC0TRG99vdTKSTUi6KkrItZ9TNWnTVautbKaprvOSwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhpjFEDW6Nwraq6VD8sXiASM0QNam3LI0YowP0tuKbVKOI1WuEVCSXRq3QsCF47YX9lP5kgeNHDwYVp1+mTKJkxcYGEHjHAQgw0xGNwsw0de2Xy6NTsodqLvrEXqzrthdaUI9OouUu4aMGDQ2uq+6LNH8jzIBQEjMAxEPuYS8algxIKOsumBEigLwFCA56AtRcLAzhsRAxImVDdIoGRAjxcJUMihdiA1RNRCpODfEAiomTyZ0xNisbIA1FgDiiBmR9ibTLiLm5ePMcSNiOF4fZNBBE0OqZ10SYEkNHYmh3nzUPzMUUT46iumZomiaKJeMTNOYJJGKBdUmmYoObqWaLZ3qQdGt6NSKRmgSB9OvWtBbKVQZalqn0tJNPV6DvVZ7dV0VnUru7l8pQLEAAAACucmErHzG2AmezZ13DGA2/zzq54wxLloJjmvinmw2tUcNWB5uayzv53rFiZ1lhfttZjr9RkA1BQcnSJcVzmpu7A1Ec9dDR3zMl+Yy0dSGiNKuveXFp65c/cXPlcQzl3cHYhDwEKNnVtvdhm9FNL0/Mn6TOQT1eUzf3bxz0zN/n/2dZgpVPk7Vlqz3h0NggklCpG4FgcEupALkHCxcUZZXiqnuqR3K/upY2rmMuEQs1AaMCEckwZaSIj4hLSt2oEoYLBrsiGxKMYZ2GWJVD00QrTB32LO27MMvoYAShfGI1TvPXgKAIzI8aeAYpfibSaUqiFdmnGK0P2zFNNCCSR50zNAXrs2A+pwrmBqXCCGpAR6MyCE6RoeQ3L5CEVIqWR4I4ipIkUIeblkqGJOjmEYK1ENMiLhqkSAQILYKDImZnC0gfLxBjIwCAoHJgyJJsgUnzqKCVjdEfg8Tmyi+gmYqZRoZnzQiA+0kJTFiWsdpJKTI0iV0UGZZujdAzoykm6arqK7JO6ns660a1KZkrOoc9BdmZVSLqW1q1al1Vf2rutqGq669fqRPr3xXecHcuWLuwBU1TeJm1A1hTmr9injlHAYsTMMCOfCSsn4KnqQVGPJnvDDKrM9wp8piQTuC0pFHB0AQp12upKIg9b223qZROZQITiIPCxsPxnR44aG9JD4SCoPRU5Q+Vkq0mIIvkoJZStJoPJHIYQY9A6LGSpaZw1g1EIGDtQuWx7Le6KhlEzOQ/lzmxd1dxv4H2kzpHl6BYbMo4+lIe1kuueYun89P42s9vEd/Uvm4bZOV75ib+e/du/ZEzz///E8R///H//Kr8NjQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHyYxRA1qjcNyRmiRjbW5a3blGDOqNw4+3aAGdvbjnJqUgR+hWspWAwagt6LtGK5q5bd0SWmiPdk17N6J8dBBUyTIT0kBJVG4aoowIFzEtRp68obcCCvf907EohqljsFS9fbEDFUVfPtca6RCbGaDIGXvfVnxDyqbE4SJFi4SRVHGUTU8UgJBx2lEPTEfmZaJ0wUVhyCcMieNyaI0zIaJsC9o1hxjhFoAJCgY0eGmDlF8qrPFg+XhzhuhfQBykPoK2NyRJVFSza5qUGN1pkatZMlQppn0UZk5fQJsT8bIrMRcDKSJOouiMS+iozWzIOktd1uUVtbdJN2qReq1mVdrILy+RNfvT7tqT6Vmo/X1/fv+7a7nXi0yACAAAOd5aRyndaCSxvuVaL/aJAxvqtqh7MzKfoqDIpDa4Y4A4OW7UrBoizXudbDGblNetMTOEStUEG3MxwCMiKFm7guYadH7WCasxT7HKiZF1IkSgcOmhIEkcNC6SqQ8Q4Dcvrc1QKSBRJM+kSQ4hxD+J+Qh0DmAOUGYewFGQLhSYzWeMTUmj4MdJak0qM8bIrOJsikQWQd1GiTqOMgguaoOpRLpJibDzonx3Eg6JrW51BHWktTqrNmdnZJdbra9JPdVFfYcp9L2q61/QWiplOnq1dX/9JqN6sy8N3L+3H6EDgeOk+zWMiFQxDZjOPKZRQLFxZ+6cExevfvN+aMcVCB1EC+Hpe6RQ4YkEVgLc7EJNLGdUUG8ir4TczCZt+7LPW/MJgSyopNAyoXZv3QQIuYUgjQ8mZlE1J4zNT5SSKxDAYEKI55ERyjcuGlZSczQSKBJouWSGBQMQInisZhMGBmxAs4q7pLOIpGwgMBKsSRVoFxNq6qqaBgK2PLNz5gmgel08ZLY3HAhlAaKMskwjMhZhWdXrP12UyjRtDslZdWj/o39AiTsr2mrgOT/lPcps4zFr2FajFEZumlZXHGJ/XZmBaclFFYJiXQ5qWwAwEyABMDRTp41lTOpQ+TtmCDaTcsym696QbjkspqG5HIen2CL/SkekMfwcEv9VaI+boX46RCdNKHxPJb7nZbL68Y9vHKGr2NVs7kXGE/huMHC5eahx1Y0n4lEcT0n7QP0uRKSBh32cJ4F4EWVYisarZYF488WsS18+98yRFBD+3Wb1Y7M0OWLfEfW7Snk+g2NLeZU+qaUgw8/01S0au8vs78H4r659/jep8a+cb3iNrNdfD+e6gEQPMNIvWFQA16trRx/WlwZpFa0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAAB65t0QNZw3DRTcoQY29uImG3RAzrbcMnqmhBjeF4i2FC3QGhD8kwSTlwVPqKBqd7p21GacxoCMJ6Y7d3GZISBm8EZp53Gq2OpOP6yMsavXhXmochmHZTX1blkuidC6S3MEOA0WCdCtJg74NlVA7MFJpmAXIKsGLvlWqG7Hrkw0ZsVWNWHfU/ajysLFYxLcKlb4eeR96eQ2Y2/7tu6oE/EOs3fkVONxlDJK8svSh441I6SCEdUpqSkh+UZWdUsXsTdqHIAir93HYLwOZK5fQz8oratzFNlng7t20yBEyQy/G1I7H1oGs2sc+Y4Td+nuU065c993HvOay3hz/w53/v////7/+f3P87BJGe7Nn36zvZJ0Biz+6qbpaCQSUHwlcow5q1ElzEwJMfjRUDurAGGg5ghwcCgKnU4lsQmAoRNtex3narTOMb3EqWMV4danDLpuMAG9yFIRp/mhu1dgpFSGbUnUCE7kVDuPDRMZdUxMpHsqjP5wpHht8XUGEtR8UStzGP6G3N5KRbRiFAuZldu1rZcIatCUMtMVx7x4m9eHetYyhj5+KZ1TWsw5qe3phv3SsNCc5bXUbX1e9fWmvmmdY9M2rXWb1zn4+f8b/+9fdqf4s4QLIaFnoBAN/olkJQVqy4dQvGxQwAvsD0neLLgZ0I0THKVtdek1HCpIbpGaOX24lFUjDPAxxeHi0FmKO5MzRjBCsUUpZlp8PNybSD6GC5l/KKG6q636f5NszJUeIzVkkBxOUv8hNMmGahEo+vamk1zeABAoTD8F1G500CIUNTYBLJNAbKG6s6W8twCgaii5WhJJsjhLW5PFE5Wm7hENl9RIvZwlPuWPu2RyYGTyAQYYGLgRmO6fjNAcWNzCABZbSW7Oq8zqO+0h4WlPNIHHZYSBI05Om7UhjEN0lLTWdYWKklfaJt0UsAoSrqEyaH68PxCS24znP4U+cvdd+beFmB2CZ3LF/DeP4Z5SjDv48/Xf///9Y///zuMBOqXKZLu6eUfr11le37WfoNtmjRnPYppf3P8RUDWrDF7U7LniRvMZCBwyPeCkfYvE4lAgOElELeVBUqx2jzpNS2vA1FElcT0bZoZETDe0cZGsBJ4vJMk7cI/SYzOVNI+Qxclk9KLU/chcg3lnELV/lX6eezgGVcqXIxK4g/1I6EthD4wikq5Z/hqOzkpa+1Bgk3bpLWs8eW7dJV3zG3JIR2z/MNd/LuOfN8/8H8x/tLYw5lLgacVOsQGVtBcHxo0JzXFUhRSgdBUjU/kayJL72F73uyzyYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB6hh0QN543C5CnogRy9eIwIHQA1rbcK9qmjQ/OF4k2OEEvAYCOHIhI8JkhyqUWhISFQRICLzhhsCTC3Gr2p2OTZVETLBiMTZjLYDltQ0SHUiU3k5V+YllmpJJbDdJKnvU0RIf1Gs7l4FeafWBiUGyh5g+Wii7RW0m4paf9R8GilDdpMZop+7dfqWQA/tJMuvDG7mDXL7KJM3ZwVDV7T8PKx8vS91lUAYBmfs6psofikqgGUqpI1hQzHGDKBgIsK6r308xnXmMJu/KaScfdrSlpjYTL9h/uuVNW/v0usZmEUt8RhooK9JewguqorGdRrLG/+6J1mw1J/6R83b13H9f/P7Wht1gk6OI+ypKD/9PEPG1Zc2eoviQgKwc0JaaHW8ysVyAeG4DwjsitSpEEABAUc0dUinteDKZCz8bw13v1vq8p8qlPKZhL+1ADpnW0g7sJvLhmjmiCe1GbpWSMyPHxlOJ/bhX1EWdP52Nuu16iUYGxC2OJOyRGZVNS7YVpGF4NZxfvbRIEkJlc0aX0es0d3cMbtvN/u19RZ2VPxdbviLXcuN5t9awzHhXF2+sLIBLROJiSQkLGiYbYLMWdL9NwqRclwmub6W/0c36+54OmzwuecoodkSI0gIJGOPy1pJqiYsbioVejwGGmBONG5qJEhRCUXFPSMT0beNu9KQoNIgEOQTNuhCo+wSBb1ylZy6TyuwPBUJYiAIdzklAMMeOnVE/k3KE9zXiXmsEIWH5PWXjZjZlSUkkxKmlzY4xij22kYcONu4gJikawgln/M3iQzgEgCrN1+kDJqDoKgxDkPKqsqXXKDfKarH2vDgSYnWHPqJdZTGHrMnq9zq3NRjVTWnRKogYogtct87nO6ynrEbpnDkUfu1SQMFlqbzwygt4FdQ3Oc1nhcd1pksrW83wau3Sprm/1n+u5Qx39frHf9/975rn/+/+pb13n///v+a5/f///9fnv9f//rn///90tqRTWpEAAAAapmP4gZ5JADlnxh0kc6e2/L31YZqWaWjlZiApqHGky+tLbFQQFPdzu6XnxfK99ztLLmypBX4fgoAUhk2/grkzLqjdUmblK0ixSVcLtdF+N0t6//7jWpFjhS3Odu5S3DmPcObmL1eO1e1Y00CGMdbr8qbnrMfQFiR62Fb965rdrPeOfOdpKXDeOGtb3zPPe/w/7Ep/v3O3cLVtgrFLDB8ZYSblulKcsrs//1dYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdSYdCDeNtwvEwKIGM4biJ1iUANa03Ctyoo0YzheL1Tsc6zIwEWOXAwwKLXB0HA0AAkGMtGAjg9WBn/5DlFS0xJZQUQCBV3IavIrGlOKNymtOI5lLKnRdlzG/cRrkgiTSn9QIMub8FxJyLtiaXE1TytWwLslcvRUiUrmHwm74QlrgX9YtU36SAuN2a3ewa92pNzsFTVLeLxNhBoG0CZYwqrJM7rTIWwNmK/MssquGWbX2rBgEA/oeB2gNtNXKGthy1qxr7P4PMBtZf961S0tW/PVpnPGSjQk82WKHIiKu91fwTeeuNzvOfytPOrakl/cASJ9bGdnlff9w/5WorLemUSysV3f/iRenPPHGvpmIkgedSX/6yFJC0o9J91Zufk0MyaC0MifkiRXI/LzxBI+Wdt5X+4zP17EruxbFN+fssJYWZURb6Hn7jVPTdbuGJ1rLvu7eq77eCyI3Ld6zv7f/ClmJTnHdTdPnL7NuvRXpTPWsoxHLcmgaFQHQ4Y8x3dxuzVAXlEKtU/bWO9Z3eb7+9bzlNHb/f63vedrXPyz3lBUg/v6/kxUzy3+Wuc1jh3PWdvvd3Nf9dTgHb/Khp1fX1f0v1Bq927KJXRCEudCucGWKITLjH1mHpLumYcgq850KmpFQ2WGFhI2ceJCahIGKN0UVd4dARCL3WMQOkRF2OSF1pS1pOdqjZmJtcARWASEMUXyI49SgSA2GH1ZAtowhNQfZdKUydrjosvaqZIzMrXcCKPNEGNrKUQSTbk8T3xSxLI58M1519lBYAMoWduOTA0vtR+jgmmGhUvATxXqKbCF6Om9C+jBBDCFjHLzE/gU0AgItgvRrlJEJynmLrv1K0OO27RVDmsQOTGvle5iIUEbeiHY2oeAARjhgQEbGqsNFo3an6SWrTdjKl1VwwmWTQ/HXfdeYbFWadNYW9a7zW7/YxxaTBLObFhOwSvKAU5ZRyj0CgDbYkJkAAAAC/zW/yoF3BCKDDLen2UuZZhepMaD3dn3JQnj6bR3TmsIfZt3na/c6CPZbymZi71YF77EcYSKsJQwS/s/S1YrYUMuX2I8scppbpf7+2OZZ5cdjKkqVbeXaah5Kc53G3XllegwxjdNnTRRg0HTNfHPD8tdi8sD0sdnprPPesM/z+5vvM7zqW/5lhzHHPn/r8+6pJzn/zOgyvBw8o9CpMIuErW6UWdl39P//woAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIzGZRI1nbdqbqClQ/D14h0YlCDe9NwvSuaMGNYbggAAAAOrV1RSqABQCXONjUUrHtFIwx6WBIQGslI2/gWDU2jMEg1JQuYM4mreuxrbc1eFugUvALMG/jTB1dLySrTkWo5aoF4K5WY2FVJHJpy8DeTXW9cdh6RSB40BQVKUlOqWsvleVZnHSQOUvgelmIpC3iGh9rqtjWHmlK8lsPLHmpyK1AsGK1dGhNTaWrnWAibvM4iMiTkbEZCPL8m4ZoJXDzpugMgRgJkcMegoRWHRXanGakAy6MQ/LopdqVNw+o4YwFw5JZfNz97n19T1DmWgNKCW1n5eVgtPnm8NWzM25dUn7tNM8gauwu/XklO8kzWsy+Y3O09zGjt565yvc5buC1KkYCkkqTTkCP6Huz95Df+/v87H4qRmhAAAAEbWcahx0mBBzbWdzkBpOuvYv3Jt+8LEWS0MImT0lWRtly5vW6ktt2MZ+pF8Zqgpc2nyp0iBYmqQSCgeOa4UI/ZpEKea1iHy6wZqWf0q12e4pSL918LMZ7h+301GXUs7tr6oiqCe8POYcrWuDABzqmePjeNQ/TPvNinbIu/SmLY3TX/bWavXDLEAqJxoEcwAPHCZkYtucRSInHCjVOccLwIn/9Lz7+zS4LAmDgJDHmBCBjgTFdVRURVaPCxio0ZGBsSiYiAmbzbSEkUDTiUwrB30UOWkrcj1BrFHMcKLOL78uqXtAgIr1I5TzuRqHzHAIvIiIYgtQUxZUjSXGYs4rrhBbAmoYax2jpI1HRGbZi/rOXGprzfmSBytxYOlbGX/XSMgJC+zd2muXVSsg0xh1ZtHFCsc+kbp7a+VlswNdBZq3Ytm9sefmkb58yVwYQC7pIPFQKTURuWsbmuw7Uq/NYp/C2985TLcbcswl03OyK9QAEga0i06MvCUH6tnN0M5VKLEppLs1245NbcAvfjHsu2JvKvZuXu1edinlhriiJhhYduNhwRMNHRSKRNpfnqApO1zm+91ng0wZkpO/hrJmDnPyl5jdvSuzTRBQaLj4FtYfkb6vXZs5X7Nm1U5fjztutBPKGZhiLtiboKE3OZbD9I+m5PMvFnz5/dStzB9q2eFy5duU09NZVIk8FTdarOUlFy3qzOVqWUVr1FHKWvNMOqVssd427ziJzkWmnWIIxy1TZfll+v3V5xZ1vWWf497+u81Qr8wyj3/z+az5lTbrUvMef9bXceZXalZJc65jk/Wl5hYutx19PuXZQmmixygAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACDph0ANa03DKrBoQYzhuIqGJPg3nLcLmrKiQ/Em6h7mty+LluEqjHETxozkgZ6dpi+LjhQKnKIYQsAewQCjOglzDAFH0cQHkGl+GIKAtQYxNwcsp3WOzkkwjT0MpXoWxJhoqDSbm1aDJj1RJUBzcISvC3JSxnbU4JLAMHD4fnn0ZrINSm094YlSydSWvJKYdpzEmGHOZIoUoqpomEmK70OuA4TuxpTeXDrxg8vSkLt5Vfsx8OFMuN20Y9KDFKG0ksoyt2Au0SEbGVC4KFFAKIxOhr1sb/KuWM9YRnAoa39+NWbWGW5NGMLiYZyxjf0krJk1/Uy78VqvHYjFLf/dx/4EqTED5wZMQ5OU+9632p/Pl6lp0HV5sBDGDu4Do/8Lw8EGLYdrnd71uxXae1wKChHe5sqvZp7AAcOHlTO3RkCO0SGYTPLWAeSlhc9K/uxOYp92rE3GpdLmHt0jFpV6/I04g4kiO6z1T0MNkhUlZDe7HZuX40/dMBy7hjGuYPlezguQvQ8dfs7fkdm1p5uP92hynYxenezMSpVU7s1AE5b5nQRIqTPoHhuU29cz+xvW/3ny++qlkV7Y5nU/n2tZ0r7L5xxj07l/c7dBWq157+a5zDG7/7u9yqc7zuGNrYQXRYwRbWQ+XWMUFMz/28/tPVQJznyl8CoKGLB4hBjBlMXE2PYWhCTPAoApcIVAG8CuBhQpPFk0Ni/hktmGODgzKTDJ8XlV++7c1AmyEoACfYovlpzmqwI/lw5MuQIeAxoVaESpMSYk75OWvFQ4QAMBYEu0KgTD6N8tN24tATtysx8IHtq4tvrYUSMNd3Hma03zEVSo1NjdZYiCFj8JX3FomaNrKqR/ww6Ha7t2bY0QyMzJYbgIM+JmJdq3qNlWwUDgxPA4YHipI/azpL9JlT1rEf0+JGjFIHxvyirG+S6WwzblAALPwx1Zpdg9VvV93aeHHA7yX2qXc3DzqzcxC7UQjEppJ/+02FnDes5ZpgxfQl0VJAQGwidlT7CtxOUruNMLCedHA/i4IAAAAZ/6X6nJEok2BQr8jRq4Rm0VVOpLJDTx9EMRHUafl22TxunjmeMznXlmcxH6jnwJKbdd2X2oWQJAI0qcxCfpIZpZ2206tclpKEMJg3YnheF4/c+o1J48kQ0unCxL5dJ5G6BLHh8ueKBXVQMCueh+BkiOeXTOYoEYCCQVAZAnjRAwQZOpG9OdIAOSVKlLc5Y3SRMyYFSUx1NFlnXTOpOgytJp1EGzJgHhx+w7Zer7Lb2O72V/9/qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAiiYk+DWtNwwguqEEcYbh+hgUAN5y3C6LBokYxFuHl1lbpqJHoOTBZOAFJnNQ0ZfqUmFDqarcfTgUBmIbltibUi0yhdY6ENGeUKf0tIY8Sq9m8sfFKuMqfRBMEVMYWL8JcMFRHVnavCE05Ebg6Yk+uklhOAx+cIgzBX0h5pIKMwmq5yknPnNS1+CFW8sNwLUmpmBAc0f93oahh30oIuPCkoWyGFBNljUyRAJ4Oao05J6iwDmNiAWZrRdUKoK0yPHSIZbwjFC00VAD05hwEgGVIDQiGJTM36Hd25lnnUpyoAAIeGJVQ27WU3u9LpHELRVAGuHwJRlQAhdbuZqyS525FL6WX41KlLDFepTSfCOfD1uf1ZpbO93Oat7STYL0GGNFFrmzwDFBpZFrnX30qKilnWusiWtGaCNSEUAfSeRjQf6D5TVbsRGZY5jNXflKCdJd9Z1cjryOU63HLdi5QQ2+8280mkENaliuWjLYTxUCZKxFu8Gu/DO3XU9JJJKcsJZQXM1Vnkpudy329djFnUw0/OQyKq0K52zbqSyvnhas279FnFcrM7XXDf1ljNPnTi4Xkghssbr5b1rWscfzr7vP9VxrdqYcsYWMK9x/Wz85bx1zl6ls54c39Xv/9TX5/hv7GAPG0Hx17Vdr9xwZHBN//dK+Y6G/t8w1xLcDFgAFkcDMoErDGLxkDBK63XvQK0pWUwkgW+sM8zQBRw3oHKYQqJOUhKAxD8xhXjSH2hteKqxllABMHBqfgCMuCylDocoo4qHCGAWzTkNK8h2amoPT7h6XzrU5zCM0z2F7GvSnkQh+mjIKenb82st5XBkCB8MzqDs6zm2l3HALE299mSwsv7qZdFi0RGWY3gAl1Q/llIpKhLKR36EPSpSIGJRi5vlivawuckkWcsMun85m/Zltvcd5auwWIQgk+B7yZTffU3nDkgnJXNSvkjzqUUipo5bv0liBKXOxfyxv/dWcL0NU1XTPnLiZlLXLndKOLlwheMegMAAAATn/hvcwyeRSoVg0yzca1SUvPtw6BAr3feOwGFCnM7XoNdeno+b5azormUy4MSmpyCMus+a/OyiRiGbD5BBkjh+pKY7lNxDhVWi50ogUpTNzzmybkQNDxFjiaJmTikR2JFZZcURM2QLhiWjrE6UB6mZ4zD5iok0xLwphROmA3iJ3UnRoKRWixdMUVJMimgxeRY4UiZDpGWYsupSbIsYmFBJ1Lqdqaei63zCe4f1J4y1sWSin6PVSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIimdQA1nDcq3rikQ/Em7k0dc+DWstyukvaJGMvbhvs783TbQ/AAcxYELgjHuTzLigA/wXMRynk0Ul7KRiY6yHYwQaZkAJ37Y4wSw9AFDMYBbbT3qbR6WaMvXcrcFVAAkWUhrbcwsGWmGGWkiA0FBF4VCnPfaXYSdWCA4m/j9S2SRiZnAqZxIalEtzf5xhA16X/mJC36qRVAsqNS5GZmcGvutiUgnsBR2Gx4c3vOvEKR4joBtomBNx+Zp68NSELPABmWlwjlVxbMenpZjL4pKaa1SZ0rIRaE3KLFWpD8gidJS4Y1VUQWaXUj/QrOtQwDAkjp7Dty6kxry67J4y+3KfVBG7NWg5TUt7LuV6vzPPO5hXqVcrweqBgNJKMrGQB1SaI3+h26W+2+/3wOqv7+7KAAAABqVpX+GdUSoyhzuWT1q577qVXlGm0pslZBhkKh+e/6t/8bmfd44cbrMxKcx03ziTOgsZ2pW/NvercxIMcKE1LK1pFIQEK6bKNzUyHupzpoUDpdMUTZBM1LKzQyWkkbJJpHBoT5imLlMaaBkXBdgjZj5ACtpIMnRTU7uYGiaFI0dTL7EOFK0EDRalVLOHUjV1I0Ddk0moJmU5tCwYGXvBGBl/E2fdzv55/35AXKTUFOIh6TbhYysk0IAzveAVVBlak2ig4KdCmbIhhkEEyZSxAZCo/AMsCSg8QQTsIcwKhTCM0AhigimLF1kJ4P/HkoHpLamkcmnDtEUAL6iyQLDwMTMCgWFk7qr3XY/KscgJiiVCoVdOQ4rF2USBgIF3STgp23XWwXhRXATC/2VXmJzj1rBtPv1kHX9huYDDXDFoUrYIVKziKQzNRDSatIJpSGH2/RL7QSKHInSnEDLwuqbS6Z8dj07VlUos38s6SrWdgOJq1aWerzssu1I7LZXGi8odpO1nQaHyvRTcWgOBKkfllS9STMnuPRKIzzKPUFTOxWyk17LeuyLfcM9c59/XM8c9c/nO6/DmdTCvlh+GOfcMu2PA0m3eOA4F/9N5vj4a6TbJIAAAAlOt/+81wUt6JDKocstgqb3y3QSyXM1ts8XgGOyFp9+e+flsP3MaaUSi9TPtGoMVEzSUYNOVogFwgrEt2pBLoYVbMoa/DFPEX1IW4ycA0mSSJTDm4IaxxYe3e2CPmeJXdaWXvTTla8OJKu1UTm2TGiwe+hQC3odTYwMe0bUaNi0+N7phjjY1rGcwolviU3iHz4hZ1q2PjOYWvvfzrV8e1abjZvacQQ6knfFKuLDSClMEY02z9/uSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB+ZiUANZy3CkC8o0Pe9upMXXOg3rTcLdrehQ/D24it6tMVYlDgMCAkMSgzIBDASxonDRgAEPwh/n6d6LClxbYExPg4b+mWIlKuKul6zVhpakxvw5RuD9xBuzA1hZmJQUmsCaDHFZMGJFpwsSTHEmqvOL1amkfFnfVtBT7lTDx1nvvPG8TCjYUZNhD78vhBkjMMaMwxFI+yiOkwL2UkEg4p4HbcEiTlAXiWfbjS3bVNfpcoflJqHz3qwpZV8b1NVgMiJjJUZQNKC6+GPJfSW8+ZWLVKyJNeryfsSqlmbVL3uPWRA5HCpATnawjUQo4IhqxPyn95dkEswjt69eikO75hzXLOstak3BCCu4uuVJbA8EbzyGrT/0KWw3rBAAAADTv33qRPxJpwlwTFU3r7eWYNrIf074SEBNLAwO2x/EZ2BZ+qtcWJSBdEiSrzIeBTrvYXQvXp1tsjc2H82aU7RBcXsVhuFpf2xCjTs6qxNLRvY277yq7zQXVH/rGjbtBxRN5DCicdseTx8w0Sg1akV0sU984+PrHtp7bVcVpbet6vvT0VV9Zrjdd5zXeLf/7ra33be7avud9MFv/3dX//+qvJ8O3JcICAyAJJCUv4Z4BmBEJxyIUBocjJAvdHLshd0VaCzwGAgVmVRJVBhjrd31Zy+1K3SUCAeamscwwj665e91mIKPS5Q5D5KowrA1qVY5rBTISJMYoUuRljfoiJTOmxoGBCBAyFwmfNnl8MNkYc1ki7RWFv6+0tg9QYEI2gzs1TvYhUWbWFkUGjzFvntUVBQSImVhp+TraJZwrGCp+CFjS8zq6QRwKplRSnsEd6SBCIVKhEhJRxMKoY/a5appzD7tmnkK0wcWjeqaj3LHIl2rENdoRCCFldHyeVrodStQ6d7SQ65E1R5dt0sJfFmNe1YvNnnp+mrdzs4444vPvDncP/n/re9Z/vLX/j/197//5n3PuXO42g/eQoPm2Y1YWgJSwgkcUAAAAGKm4l4DGL5ztFIEATqoms9rOpus+G5Ezd1RTJjM7zuSClq/SYPjG7nZRq/ap4Z5LVKUQH6DHV2XIQ2qF/IHu4uLdgGmoZubLC26ggdFuLXVu4Hvd9EgbSs2JuTTVo8Ptc0G0WsaDI2GJFBM024JeTtdeuQjDo9WdNU3/e1/vG7ZpB1n49pb41FhYNkfEHG94xSDambR601XWNwrarukQFAwGIGCjHvrrQjstaJO65t31DvkgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgpYk8DestwqCuaJE8RbiCxiTyNay3C4CyoEZ09uErP5+6QvMEI4MECEAMZAYCNLkwUFmHDb5zssfXGIJSEVxnYUUtRCgwv4NBEgFYIXbjbPkti+xgc4QvcpQ1q7byNdLyOY/rKguOJkZnC4iADyYmNwPL18jAcmG2piJGwB0cGrB8nLbYZXOHYrB7O6CI26d5RIRqUIgO64JecKASeKvshHSy9rRauFB4CPtpvlTT+ne48CzHxAEsprSCxX7lA0MMsIrIZGAQClEsreVye3zdf6fGJTg8JOUffn9TkahuxZsXWii01HYg1Z1NnIVb8YzI55PyNdvXMZ63HXZe+5L5l+Ksn/Gpe5Wtd5AnAUL3pOvqiwCOWgyFSQiOULfH/lgmzCgoAAAAL7J1TEThmhwCMBoCkr3cdYR6X15uCVACoNrK3rmdNYzu3YZcCiq39Ula1jP9lLMYPlTptnnLkqeGzVvSqHnGsRB/CizOYG4XVpu12WLkUi83KBXOrLhD0lF0uKJhFFAzQY1RSKaxWxsoSo2zAoGJAArR2mgrc1QRrv1KprQXQWpSazKmpZSDmmjrQRpoLUgosrr2mSaK2QOpnskEqX/9Xmq//+gEAAAAJw/j9WQDI8cCExdNcHVlfnghC24kXPJZ1PTjxDJkMcRlIkoulUgWXZyzZVsmklO9jEpQMKRNG0tG5oUJd9gTEIFWjCl/AlIJVguKDlxkn72P2wQxICBI1A8bDqbX1qr2mK8mbFR5GnRHHradyYoWugU6BIap40QhrBFArfWn3Zw4TNlbyzT0GjoiVQqqq4gSapqTbkzgo1D1glUaBVnI7LH8HQlU4VOGGExS5b+/Tdzsd3lcrPEtm5L6ueOVFcl/MqOVJag5SW00Esep6SkXLFqad4tObr59vWpfjEIVlaikPz0j7njnlnjzkL4aSY/UaEwfCR4IOEqydCMZ65NSG3DgQAAABB/e9yxkjXfxpo6DcYBUfkeWVJukfOQWI2ponWRo2bRaWXcM6CZrM+fLlLqYmsce3pDKyyqSboq+XG6swymu50qkmDFYpPRHckNh2nQyH1aUyvQx5101sKQNVogbiKJ7Eyje5T2gLe67vQX1yaxHbc4T5yzp0GUSF6wGHDzrNs7kzT1+cLe6ZxXG5aVzaKYBL5KtcWmawsd/RcQP8b+J4YkAZBwgcTT072dR4UwufXZp/93SsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI0nLOA5rTcL1OSgRnD24kGcs2Dm9Nwn6uaFGcNbiO5UtaGJEMAkHIEwwEwYCzDAGJQAYHnhhYHGBxahTFsm6wzcJVpGhUPTNMfGJDR1qTRU83KizE5K/DthUQKBReiNI0oVjKHu2NFU5mEL1WHyYwZU0QIAheZxxOOAmQKlRIbA8aTcNIKa5VXq/sfqxecgMyStzLcFt7BMLbsIDMVc6JwSpWtoSNK+k0LYjVbrFQUBYyI866Ja+C9ZD1/o7H3OkgJIuZSgkKizcsy7cCoXApO6SLgkCShlFrDOtfn7P3cqeNZIHajH9xnrdXkWldvqnRmAMOX1U1R3tzJIAv24C0miyamt7pJzthVKezvXZM9FNb+9YtfzLsJy+vlz/y/8P//1/8/mH8xyz53usLeQvPvqNf3BRNbYgBAAAAEo/uHfyUKv3aSnCkItewyRYd1Sa661SAHDEAgIyJQ87kulu6uME1F/WJ7GPReT1ad96KOr7DkSx5hYD+xtmUQf/szKW3nYNga0DOGGAEedQbbjzyF1fwK0aEgwvZ8bzTLnZE7mhwr9ywkFRIj6xxkKj3ibjkAAankJ+031u+vn//1gsV65prG9wdb9l2E1fWv7YvrVbPmX6/v913jNJ5c0p9arf+2vj///H///////+Pr68C67b/o7KysA6uajVp6DHYXAoqWQBki3pgWZE0oMNB0eF34jjtyzoMJxLIlKzVSGjD5li+gILbvG1elc5sEErXQoMHigNLpjPWl87YOELi2kNFVlRMHMIPzACQxUHDEpA5wlDyQdIhp3oJZ+KlbdmQCwJlJ6OGIlIDMlmbT7q4LEZc9ZZhNdo8bjrCHyGvzv1YCWvEYmwMrEv0bCQg7GmkL5hEtpZC8c9QJgT9Mjiv23OyONyYABTSgG6kgJJNVsxyktXb1rK9N8+mnS9H1rfJuXT1/DCe3eS2Gncn4h3TylUN3WTt7MtFfJaTTscsalLFYaVQezOXzUzDc7vHCvcvyzmoG/uP7/8f3rn//61zX/3fZ2/n+G/q6WLih6oRvZM1KLYojAqaQgAwABCf3zH6rLOfepE/SMtmUg5hq9hjD/aBxIIBiYEeV9JvLlrd6nbjIKvb03A/wXljegjFuDpIoNcfqLtiz/Cw81905ObJF2dIoCZemozPJhyDZaB5yTQRUZEokkTSQUPzqYelN0jJahMU1CTjaqX2UOYFmYnTItT9bK9mGRvWivY9UPoVReb7rdRk5iWfU17IpJGxF7Xoq+j/f///0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACOxuzYOby3C6C5n0ZxhuJG3ZNg5rTcKgrmgRjL24avZu6qxaXmIRAYLEoyEjB4LXyCYcYmFZCRotKYBcd+XpMTPTOA9+Ey1DjUB8Xg1siwo1dYBl0DTbTQQCq8AosNnYcNrQWMjYkm846GpEl1V8ggeEQYY0MEIQYILiRkvIcERIDQ2gL0lDGx5lywij8fovi9poZvPuthOWIizh4Qg59WuO+9rFAICvCczetrzN0rGMqCNMD+g4KBF1NJluF/+ObEGlUkbCodWglj/VoaEIbqt4SjNLXDTdu/d5LLtzLGVyF9mE54Yc5HqbKfh29T3lHy10/Npksfuy2FIy5zsim4elmfOQxNR2xOObqdnpunk3MpJZn69Xnw7l3PPW///7+v539d/K3zmVMOJlQy0LvoiGif5sucWIzSBSgEAAAAUX4fzsAMpvYX6xKiR7J7ybtap9Z4MqZsSSyVx7Ui2t94aCV2Yr8Ncsq0QxfuvC/deq57/bC4ygaQy+0lSklO+8MMcpaeAF+W4m9lXle1hSsikXO9pqvWncpb12VQHA319QPO096M7gOpnhSX7+OXanVjd96b286XX05OOpSQFPYa//53Wufq7SP/re88bO8ddr67UUjz68n/fNd3e1epdd1veGq2XPvYXrYaFkBj/r/kmdP/6emNVak7A88OAQoUhhgDMbBSSUNMHrA42UTC5LWayB92asuaKDMqEhkzqCAQcEMeQ8HA1H2kv7E4Ah/FLuKpOniMJTMVak0loTEBVK5btPsjscICCZiA00gweFLyhACKBguGGeNSGwMHJpJXuM8lDHpNAhhYj5UcOctIwq7BgVxlcWdKImCBjyOGYk7qsLaL1hKY8fM85T5qYoSpc1yAX/bk38mQ/t9LYrPjFJD8NSNmoscqDpBCS3vyzHOXzFWN1YvQR+GpxMavEJHuV156V4Va9NacEmQWMXxY9TWou4D3XZW/qRirccML9WvBL0vLlT0Euenconb+Osuc5D28dYd/Xd6z7lhj/6/fe/lyx/85vnf/+a7X7KG87fFHgs4AJEbEHWUEgAAADHLeWHKyTd/e6Aq5LPLY1d/eNyC72UacpbQPMas/VafsV5/dTdZt6/aF9KWu8D51cHGT6jDsqbr9ht4Yat45vuy/8X4mh/7XR0KzV7SXajlefN1A33iRG2FGu/V3PyWOwN+KR4EWPk0c4RMfHkgxByixYakxjX/zn/H1msMyr5x8f4rjGekjjp6LdfiTXjZa3f/xjGJPrNaybS6cV/Z92hH/7f6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACEtiTgOa03C6C2ngaw9uJPYHNA3vTcrqLCeBjGW4lt+AbMgpRkFGCwaGAoRgkKARgBg8NnIxwYCEikI3BUOSt4zERQaJTpeYtYNADLPwg0y+BYnQT8zL10q9aMbd0GGIiyKYToedW1CKFPOYlImEDRA80DjTftSGRQcUSKefJJcxoNqTLVfP3atwuMpGjkGH+2IhJWOu6QgHpj7xM9QzTLLywG2mp9JJrMbU2ZUF10qjTswRE7spiM/CdoCKtxRZoedSOxmcTcaTIB0EgNs/U+mor2WNnt25WwWbarTVzKZxu2aexjm8Snfasy2eYpdPF8udxozRpj88q833F0bFBJLNPLbl7GWXa93WuRG/FEWpDSCKgi4+BxGsyUC2ABj11okVnGtFsfF+fruD1swywnchEJBZBYN78d3eVmBwNfjzIQQ095aC+0upc8IpdgbOy1mX1rshon8Uelc4ygwFTTQQP4DoQ1NJyOOyyktYoLVWvP6rK0XEJeApq3dcqZbjndJAfqRDD0OqZzyhDLSVZwY88Gzi4QGzDWlno+psKtN43P2YB/DAOlmLpF3u+tZ+7/wfKQyJm/zmt9419XIdvErlW+YesQ6wfv/WLe1ctdjgbLjAu9jOj9rkS1LO/9d+RS2e1XiNF4jFQFJBYdgIIoUnAQ8nhRhlaDNOgstusedcw46DlZPJyEVTGUUNrxo7XMXRg5kkmoFcuq11wwK7lAyKgSf4KA24IShQER+aqsMXPMiDkGgh0Wwt1VgqOKMkw3SODZAINBKMaLD3S2XRlpxIGMxYlT9QLKH1VuVQdtgq3m5EgEGBxwGGGGxthfxQFYqV0Mr9xAp+H5a4gkBpbszfkT1yoKgaH09JHal05Q1JS/WTpgYrVymMssMKLved1Eo4/+Oq1Dc59NQ2qbCzCx4tXqStx4/KMYJpZc/0cQZi16/fjViQz7Me4XoYlszjIKWVU9WYu75Nfetc/X9/eP4/v9Y6uZcwuX+a7jvPDHn55YVOb7+t4Z8///D8+d/+4fq/suMhUZHbgbf4c3UKyRWduTZAA6RL+d7cp6tA3Geq0a/yqEASLvs4aA70/SxvtrKkZhFscm8celhq/EGBJlJxNikItdPGNtxd2UxWLUpWKrGHXr9vTdJAYKJkVjLs9OZvPM6xj0evTtzK5aylvZdiw2c7Uzr5b1MzmK8b+4TCudt3o01kjQbSNwRB2su6y//3v9/NRPn65+94fzH9TcQ5rdqg/dXWVikj17LXObrAMICcOipA819Hp/4PUNfV1/dQsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhTdE2DestwqatZ9GcSbqSWDTQN7y3KqS4n0PxFuFmU9SpSVSAhMuChkeEYUWAWuYASHlMpoxNI3UbvBEbqgW4hoyNORPcwkodsIJ0u4AaFfeSCYOX/LUHzDRyhM1Jpa2EvXSVmhchcocbmQEuQRXXQTUhsLhAUCbFFXqZclyvlGyUzsttOlHb52zp4xakgCOPu/yVLvRrdIYRLWUy3+hV9/GUroiS96osAxWgXchXCu4TMNxynRwkV5BqQ1p6KRiNQ8GR0pKSBBZ/Cx+ff33mvyzykF/DLU92vnYvTGUw2FTTHsdkUhoqkdlNiC5uLyvtFZk8IvT8Rkcrhr4vFuVPqxW7+X8u2q2GsP/usP/+/r//u+77ay5zP7u9/lu4Vxrqg/0pc5FbDQIAAAAnv/HXvQ7dT7XHaK60F8csK9isviTwVi+qioFKqpS37OWVBdvcsN2kPJp4pVegyxlYIGJmNGlxVe77vPJALmZV3xLpyqhx2NJBQF4KilrRUkI9TRPmIrYdJIKMUjp8+iRAwFOTQMUlsymLKYnpBRAi2Z1mDh/AbEkQMykSCCl/UvUomtBkEKq1pOgJKhW7umZJOcVVegmiy2UYhgJNEz6Rv//26v+kiCbd6ZlUfW6Z0HmCjLGBqOZWYCcHvmICqxYRiU/LKj+gEKAUiW/iZACGYg5xBKDh4ue0Vrjttxav1ckniphRIDmJgi5kzkJsPpDww0xWMws7Byc7pkgaYUMLVhoteY2IP7AM647DXbZ62GD7cbbHea2CxWnxGNx+cXJDIjEm4I6g0ICzEVMkq9NPwkqwdzVhWQUperGRq3ryeexhJ5bXpkcpZqVMUpK0O2qo6mBAmckCZIO2fOpq9hhexw3y7htt6fdbHKzrGrdo925QPCzliZaE9GEjsYvoqhArPpPUxuwzK6kdjsnlF2OPA/UVxq4Y0shsb3h967/9z1+8Py1jjh+H/zPdi5hhjj3LvP59irV7/5d/e//9f/P5//rv9/O9runSP0WAAAAI2qbx5wa0l6yBTgdB4QfvHOvHIazxlTop8HUTHWISeU02rtWN5ZxuDu0T00GnbikuiiGi+W/cwYPA9lF59337NWFZtRR+GPnkjEjAHc8kgpajEc4njp8nSBCE5mtOZOfSKJwUmZKNFnkTNi8aHxGK1mFNnWkHcD31lEvkih9/UpMu9mfd7IkoONJZmiddToSyiTqmqUhdbromaJ5aU///RS3jN/X/WAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIB3ZNg1rDcLmLidRnE26hLdc2jesNwvIuJ1GMRbpuOX56rkpI4YMWICg0GgnwCrs8sIOwr/gGWxSu6Ihppgw8z9SsswatCgLUwfeagmfkLlKvgdyAvWCAEbxQlwM3jVXqnmfmCJiQJOwrJFvggS7aO5YIJqSeBcFXuUtp1nmp6aMR9VA42pohKpbfgeHGbvbSSuHmWgWKReMOT6z1NZDdXbgzmglbsqev1d9lrmWl23eR9vaWbnb1CtEXKp5CajOxe3S81bzt7/m99qtY3czsYYa/KmryzF6lr2qbsKf/VW5Wki7s2wS3P+UuovVlEn32KQPaxys3Z3HmP/rtbfP/+frn4/vf/+vx+ryzz8v7Y5/5f/LfywWZCqfcG01JJhgAAACi53/ybCmBvK9nAg2ys+k783UuOuxyDJtxAYQGcgSA4lK6TCmmbFLRrZkWm7NYym2wz802AiUBoQzBr5k02uNHZm6XyuG0OMtnXlPIonkiDgUgfRpLMkiigYqJgi6JSQdSBWQSKBwUoRVA+cMVl2mgYB+SaJ02SUpI3GSCnyYLoy5CK06t+ooLdrtXrVYoiDnWdPkYyRMpoEybkVtU8wc69RuaLjjz7G+lPv0AaLETmN1dexFdIYAAAAbPfl9aUMAjxkooYKCJhjTQpgBCc5wQMVLI25dPHoYbMOZ28h62vkv2YlcnmrHD0NOI8EepSoIXk/JmVqFkuWHfVV6+lsJhv++yGKzZKHKWMLphaDYEQtJkcCPsj5GMpXP09l15XIBhtd/5yYlLPmqKKvzDGTFUlATse/G8Y20CHJAypg0rdf7sGMxn5iSXJyHaR88ry25BSSWlnOLyFuupcUmt+lq17dqvbz7YqdtyxfuHOZ6pIxy5zmdJdWdP15uVTNZ9JRLJuG5gUHSatcprEpjkctatxizhzf4avQ7+86+9/h////zmf4YYd3/P/8cOc73n5//e4WJqlGLreXwOB3BjfjwQAAAB38d/nKC9NjlqbLAi+6NtexqvR34i4821p+h4wA697Y3/jdW9Z5BczNOBH/iDbQmW1Zqkk6qQMK3R9EeFXO8/LfSvHkVQ2f9sEsRMU0jEmQK0lmMUjI8mMo6zAvE6aGaBgYFwxPFQbJgLmQNjzFxiyiZpx9mhgLRSMkFGwuUEQKozgz5adnZqHQZJI6lZJSVSFnSI8aCLnUzhqdQlAuJjqsu0jlqdBaZs+Hz1y+mX9Ifekp+O/W7vxYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACTuITIN6w3Ci64nkYw9uIv4LMg1rDcL4ricRjEW4bPIphltd0VGBLtBg6QDQIAYuDEI5gxMYW3uooLWMhKMOAMx3Ao1CBNYEgTCJD7S0BwQNUtVLEXRbRuKNsRIgRxi6K71O1RrxV6WBiVCVyaRn4osSC50HPQUDrIBVAANLYBDNtgRlRKezLVMoKgKXzrdlDEJTQqSvWvOS3VGTcM09d1wFNay6J12V2iMLVoUvSmgWS4suLjQNhcjztN6+raY1UvYtH47appOoYhLfRPZOZWq3lrVep3GrWudyjyQc9lnQ2auV/U9vOmj7aaparu0Ems3YlAcGIck0GbP9ZiMEzbZb8FdpXWfRusarawlcgt5c5+PzWd7W985/f3zusuZfjzl7DuFrdrHO/rev7yW8///msv/e+/z//+5frv58/96t4f3ljWQAAEALH/3t+0RDkeOViHimae2+fdwqq7i85uC4CX97rZwZv57trOQQNELtyW1J6JUuEQMDkfoahawD6V2V1ohjMSsSZLXioc6mg9aCOfXxi8zPAxJShSYvXyyZmvs3Ymcs9bS2lZtr+pG6bEj1shpIfLQujdvXX/rn/eKY3r/FP//j/Nkbr51net+t2FXuNd/+TWP63hawIyxv//tn9XT/e6Va9T1Jc+0vEYoUXiA48RN/dcR3DwnzG6GT0E/J6FZRmKQuGZC7TMTSDz/iggMXKYC7cPyqH80WmAqcHTVKOKNEIRu7TGOIdIFZo/A4nlZiiI8QCody7jlmfAJj3rKjRUFMpAwd7rcdl0gbkhuEEhyAYYgqlVxYWvAtmldsLbLPBD1aYBlbtITC2ryJXzy7uQAwtali3ndsQW6zEd5QM899/YPtcRmBWH9aIrM/17+zFy1hv+Z3bMAuln+GeX/n+VBVq0zQeW6sMNtT4XaOS3nDV1DH2ZTPxKYe+gvXYdpmUyapnnAep6b7z6/Zmpe//5+P/z/7+//f93hrf7yr44f+HLuV//1hvH///7r//uv1r+8yvUJELGnkEAAAACd53DHbG0UrefKQlKEKFCxTuF2/EWcvnMSdiQEA79ZUTKq8btzsfrSqyy1/6vHcgenduinGxQAUwddejFW0lEu7BvJlmYJDKFHtKTQNkRshe8nDJFAyHLJ5HNCYFzDBHkyUiQpfLxfNFEMPJmBPGaTmbMYlhI1LxIJsaJGYakBdniJikR7W1a1dqlGRVqWvq3aYDjeidKqSS0TEyKw8ovSQROmhlUZMTSbZIg+R+v30oBtRljoW63exmsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkRhk0DesNyte0Z4EcRbiLp1zYNaw3K7rHnkYe9uGT1M5vU4FwkBWQKCxkDBwdXEIYAwIwBRbPADQHfYmyAyMgBJEd0x1RmrEHQWBQIojDkbi7/4qHuE1gt4eAOgFflIpQRoz6ypxYGZWIHSWQjCCREiOhwVh7SggmyJ/H0WQGBVTpJ0cufvKPUbtPfAjdGuMAZyspdjDZHVls0KPT6JnPI/cPsESqoZQ1SkYDNyqB5TILF3UUT6pGFXtwiLzfJfX06IZWcZE21LqpYmJNYlEolkvlcTh/NesfhuNwJKIYllj8OyzsxK868fd2H5fcuTGakXTtzmqfcs7Lr+F6C4lNu3brfyrKIHt5/9XWXd59w1hhhSU/beeee951sKljn5Xf3nz99r287HMMP33P//Lef9//3+H7/Pf/ved3c/MNSHt2kNBcHkluGShdgYGovwz1bKoLUYjLW1N1L99gPOpufodTE830EYdjV/NbcvxgoUqXblN5hUOUjGWLRyphIWFTePUzczMXJ4XAXDQ0LhQJExIsgyo6BlS4gZrOnVG54wLZ86X0TZBnTKqybXKJVSQNDYwNAV6Y6yNIVNBmUjanekV3ekpBDtzBN6S00KCBWQWkg7rooKpLLiCHU7eqg1b0EEEEDdMHwfB8CAhpKELGyiP/p1RRe2EAwK/T/EBkqjAMRLwhkAZDGJHgssMTJKiUzFQFI5PJso+ZVtUbR3MeHMk1fReEWisNQyp24Kj69lpG9CqKPrDS5muM1ZyvVnKghIUJiYoRThLiqEQ6zwGFmetzbrCURoFa7CL0fwom4vEAsv870PU8Uexn65otHpVFkUwaQfk1SCYfdNXMlYmwGOPBC67vKhwl8Pyjk9ZaXFcXKl8klcXu4vshrm3CAYrel12LXMsstyjcN14lVrZ0NaV02qlS5nD1JN01vCzZjkXsaxjD+RJZEInrNJKKP696cuw5LX9hd/LtfCjjHN57/DDOxhvtqthW5Vvcpfxx5+td/O/u9u5fwzu7r4WHOTnD+bhd5o7l/VFQnacKBAAAAFnvfqbgpMWpK5fTVR5I4Oa2uzVS2FWk2gJEAxHafeLW04NaQq7QiWBOdqquSk83qeL+BWLGgRxVw4jHey2iD0w5o9Lxoa6PkWt7a8FtgQs2xqE4F9V980gwHFWun5PZW5ydUhxfp9eJbLkwtj+NpTEzJdBiu1FSdWvoOM719s8C7yfds319e9953NijX2+m5dyvWGDP86vq+pdbh3cpqf23Xdca9dweZMWj7vpDpxQwK7Wtngppp0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHKmZOgxnDcPCsqdRnOG4eZdcyDOpNw7O65sGdTbjPuEpkt5wB7qhzYmIzYifOmE7LYKbaZlNkRpjZL+ULc0BqurcUhqZg2kk8dUUj6e4lE67+vLAzowezh3sa1C1Ut2zVBmM5q3F93QpWwMmRGdNcsad2grYz0wSAlMopoy5T/ww/vZ6d09QoQONZpaj/RJ4cJVKo7EYIeaH3JvVo1eqUb6WZS4NHcyx1KWjuHYj0VjVnWXcaXV2xLYzOQ9D0zRXaCW8pp7dWzjqdxzpvs43Z6l/la3KIBpf5+8MtXccfq3Z/v7xwyx3+GeHd/3HfLSwweQw8WhMsWFWrItoLHmLVI3/kQQAAABS7lDwwbLWkC6KdzYmG1xhcmKM9VWGGmnR2IzghRH0ZNbW2lyEdNRoI46NWkqWSECXl9wzZt3JkDT0rYW0mPXogwcW6SiksFKwtJk4qDCJtuTjrUg1xLUMxCjpJfTl0ozLJPSuNMyrtJ3C6qoshAdRV9xqMPTPw9fZXKZiXttKbFbKA5f2KXqtJrsxFq+NwI/I667bG9Uut493jurKbE+0LdmzVvY1rWsccdUNnWX0f0+69LMQPADYZ3HDK7OwRNa5KaalgON61lVsT2N3HWWW6etljZAQMhsKhJz6AnUDwlOpFnkjJ5cwmFbtWLuZlchmE5EIRwliMN6iaNyipKLEA9Cml0bz6xkweszAVKxhoXJiTk2ogOEx+ZhqVS+daqgq+ownTqUvhLK4lK4u9V2UU7PRIGDTq8WATzcRCLGhTXe00ACoKlb+dNkzYsCuClgCVJEvGJmUSBEUEsJBysdDqAE0FlQ7ioiSYlMWEvjmmo5huRw0SZLqZuZFkbBEg9tEojUJMyOkHoB0g7CWJIZQaSKSRxE0dJJAySMjMVNNFzBJ1qs6aRUKzKL5qm59khrkmQ5EnmonDEpFwxdMopJj3ZZueMkEmqap//Q17IVOrM3U99cxSoWyfb1SehCHlKXNtZSnkpHRDpRSPgIiTfoqSorB+Eszm6HB6RDLBx3GGleraMUuLuqXSqJUdiCaFlL6iNGps5cOxNkjEXXZjuKp/EUAoTCwtk5hxosAjRd0oBRWvdVlHg7d0TpST5dND4rAakBUJdNTclT4ucdAv0y8TR0RgQwL7F48YkVEpiURxEjFKGJQHklidOrWSozxeIuXUSOl5Ag04FqwFTFIX4rpb6kjBTtUeQLonBkkmS31nVHUnUPtIrGx80jXJdERYnjSx8xIcRBmTI9EwFHasyNUlK0K0PevUtWvoOp1abqdDTRrK3dQzsLE8QjirEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACGiFzANak3DFDvmgYzNuIS4bMA1qbcLTumbRjM26YHPWNV4aCpU66hLwqAS70OkE1Qg+Zl+rM9I5VFgOEKwtIgGaWGQDvSx1GXxYq58AQh9nRVgiAI0hwt2Ii4rkJqyJRuB5XHDkrlgzEo0qiEOX1ixhCi5ldTMthsmIKPqxQMUSXTIKIgIYCDCaRJcX5gDdhTL5VJU0JcEwBPiLEDHYZFQClihR2CjMJqXhyhRRlS8ZuXCVE9kXDYFGg60iCkwZnSABkMMKDNCzQ/ArIoSwkkhWio2NigINZaismt7JkUcmyiXVuKFIuXyRJ8yLwf01HSFrQ2jzmA2TcZ8qk7NRTisQMYbIIiXoqJdeo0RN/1vaar+Z2drmr1mtZmtSkWqd1N1K31ataH5x9pWHOfuk6oYP1jGss0/kWQOC93lTChECrJmnNjSNQMEEjnxFp1LcswXx7JU3SUSHCJsPc6zHaeevH8u+wiHm1EWZTYoqmfKMrE0iC+jNa6idk2oXwIkkGPmpkVR1kYGAyWUZoC0iMyqTi2FgI44RMdiZVomY7k7LMiJGgzjomRbNizJ8xBCAAM583IYaut02+t0iiICI1ntubVE8VGmTmB9A6gmWzAbzJa0CgbO8vrNCrugpdLOp2/+/7/q0ktXfnr60ds/7K0fpdfvzcqER89g5f8Giyh1SSGoaeRpZnolII+3Q1tYiMQxKRCpLUm9HlZdrqiU60eflK51YXgMQ7DqbfLvhMOSB362VBYN4pMkELBUOhg5bFG6gVYlatWK7UXAw9WV4n8GMImTRKCE4NjoApTUqGxOF4MVkCFAMREiI6AgUAKwN4NDApCzRCcUuQUaBcDLqxeDmlIwLKBPkQGOKInIwMhHBXGOIsajpMRBABvBAxmBKiQU6Q6DVaDKRctqMhY3sQR2qrJpSJwqJGBMl4irE4mgK3DgTE8UVrHUMqeNS6apk2ISlQwJtSzgzClKbOFVFH16W5v8zMV01LUUH10yPN2V9v2+/2V9bn30ggAAACK/hnqqi8l/c+3fY0twyjw5u5qaBhjWp1uKPjvEoU7SuzhamY08EmrNekFHSPC7FPedi7ciBwuLCkgcNrHdCHgQUkFVlUssDRU03k+mmXSgUhjAMoCEPsiyjgbKPbusgYoE+pkBcZkpZMpDnGyzFFZxajh5hW63Jhy6s/LopIEbiLJs262+tCWBOqFZv+iuTSalqTSdanKI9KWc0SspJTugp1q13r63/////9R7iP//6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhcdEwFa0AAzk55pKxQAKmCQUAZSoACrkgpgxrQAIrRV78ALCGAGHkLl/VAEqVNyBmFQRtZam6u32jcLbqMYVaGBsiMENMcYN22DAw0GYHHpHD7Q0X3/QQBSkLImKwM6Su4EeKOO20sCgTgvjDghYANDgg+nilKASpQVadceJMUVAOQ16GpmesuOOg3vGjiscupotXUegFBPKa8ltEI2PpwSyWyhRpjEuuM7qqoSlokfqWcLVyOKw4pOyufg+kd3t6bpFHAEBdmBotCP181Jsea5reXzb9bxn6/db5lhKccKWpzOAOTnMaWSrzWZJrdbLGUOXy7jYrSBWKm3hluu80h1lze5uc1///9///88uf//Zpsv1ru+4b537sfxCDqMs+k7hZ1Yfe0uRIAAAAFi/r95uEU+l+8a8PKahaEORTEoLHLBxcOybkBEjBCGEAw2gkBkCDOgPIfgaEPEFyoQGUhShEjQixDB0BlgDZKQGjYEQIj8DBCA90WcBhSAX0JgkCREuFgHyJgRHLZfNhNAHCyPK5ixcJkxCywiTOgNwc0baa0xXCydKY5xgJ5JhEqDAUhTTOuM4bRXpeWpiPEBwww5hcKuqv7LaZCNnoGDfUy0SSsWEltSUXy+kyLOZmTVU3NWS6kFV9j//7N//T7MooOTTzX6cUfoJBIZUBIcOJIEA0nG0EgAGeLADMwDXYBgQLjgDDAMyDA318DTEg7oW9AZKEgOJAGMhyBl40gUCAnYcQEhGBkYFAYVDoGkA4BmZdgYIPQxoQgQTAoAHBMA4JhjAWwDAoQCwsMBCCxmCYXC/hDRgilwsJEHCYhcQMJAUCwQA8lxWpNCEhLDXEbGqx/IoTgj0fBwXAQ8bogMOoqk8QEm0iDlcahOCuDvIaJzFzkCIqI4FwjljuFkldGWCubOOcUxriC4yYgomkT5IEEIsOUOYQ40HJSFjKaCNZim90zMiZxZUIGRMgZNEEJMjzMuF4vGIslAip4ukygYlM1pFhpOrW2T48EFK5PkTOE2blItkUPFw6TJuTB0myCkUGVFKjmqSIcXTWup7LO/9rP+nSJwd6Z9Bbp5caXzdSaTofIqXiaMCu5eKpdNE0qtFFlvZ1etIkDhWOxxhSXSCuGcsKx4ArQhzEXhvGACZAGoxGxhKDQcgEHAKIFZMkzY+YGC2DmJ01AwEw+JywcoRAjQ8y6DfFYegkSYPGw+O42UytZPLFMhTNU0k0TAvqRYzWYIn1nVKNFNRsoYFjc3NzVO4t3dMxZSJmORH2trV5gh0FOgzqUgp6bUP/2p172+t3ZJA8kimaNq/1f//7LepBN6F2fb/1UUVJUkkkUdXX/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIUYVOB2dAALyMOfDn5AAfshUyDWptwtpCpsGMtbho8OspdVW9EoFBn2YaYACdMBMLCg8ldwADTilaCpkCpkhppiYGFsFYYcEwaNYY0AaIMLAAScMOGQVMkHMEDL4r5d6+JSIlGZbNiwCJTMA1XoZcBv6Da5FOWeLqiZMCtxe7Hqz8O1RV6HW5K2VThDjhYzygKE7aJhKppsT/tWkMozp4KLe00qq2X9kDx3Pp+atPQ9tNA9q1LohC+1aumit0oK0M1avMcvrWqvNU3Ncnd6rWe//day3ansvuWrf3LN6tfjPKDLH47WzwzpataFYZy3Ltu53H8cdZ81/49/Krjyray7lTU2Xz2Wsscca+G+//flv/+WX9/9ZZb3/4////6/909////rjbSsm8Tt5gqEF4SFXH2qyXE7CNLx0mWxpqTWkOUOxFsbNVVQg5X8Qa6oLYh2ggLHO1qU24+y6evTeMdfIFkOXi0NJ91X5QAP9TduvCxeGabDm8NbvxPfNY7t4UtvHk3D0i53nak9llN8i8qpssst467PX5VWyl2Fa1+VpaTLZbZ3zWWWWssssvz/Hl7+Z9/LLHX9//pO49x5jvH7P3u449rf396y1Z/uP/+PN4/9XFLXiKrzr0inVyQlih6ninS2KxSQOIAgCFBRqZ0cvxXo0AbKVSy5x92sMkM/yYzCESjiBgaALjIrmcNgkaDF5EHBgNIBIt8n+pRwDFUlDJjYadrIgCBg29MKOQp0iA6IDhNSHSiDzhtFZeDllqakNPxjL6vbTmRFWi2h2Q9o4XjdEdQsaYbOamRDA/gXPiyhyiuQVEiIB7hvkRFSLgfkRMqDnGCSKB4ey64pAurFCi0EK9iiMaFMEaXyAldOgSKV3qRQrHt1kcjQesvlpNE0GgsTwUmZCoqhb+ZHz7zUc8vLUpM4REYSL6iAjRVXW6lq3QR11UG6ky6i1lpEUPP1pmj1/9f7nvmQ4NPSLpGUTV7+UMwynQU4Z21p0WSrRc0rxBz7SB6I0+4qvEZU/yP5eYSPfSVyuhdnOXtiv1nM42TJRNemNd2eyUsJGbGKgKOJrjQDqu4Cl8rvbVIg5AFHeWyjx0hAoiVY1opJgkiSKYg7ImqBsozHLWNSYRUgzy6LpJFIxJ7LGKijTOE8RwGObEwmm9Tn/3zIzun9zBWZF9RmboK5sMMi1tBTo1LJxdt1Ov1o//z/6vopv8wN1f//3+mf/Oa0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAAB3WFzINbo3DVcKmAY3NuHw4XMg1qbcsKQqZBnMm4gWQVYLfgRgCUqB0jWKdbkGucXVN8qVzfguH3alYdNvKxV0BCJJynCgQqCNhcq/RUtLCGrJbgpae6X0JIDNNjEqHQZtIIZoArkHEBVElVQUEsGnTBwN9LNJeVwi4u6xDRgiZFgEhhDSGjwXiJoKMFhqw2MiLCOwRcxHxLFI6OUF+Q4o1MyIRN5xE8emyDjKjbcT2bLJ8WcVkqlEcGWxxFMnDZbnDZ1bLS1mDKJVBda0xqrPKMimeFOIAmuovjdDBRBklqRKZQvrOiCZefUiNZBPXmrdlP7ot1IKKjvpok/bzBn9X63+pvWgT7s9OV1USe3yzGJWVHMbd6ivxpgDAjbOemX+wzeIwQodqEzzFUVDOhQIC5+QxyYo5ZLoPgyU4Jv3lklAjW1GHmjJcM4cEBxSMBRMLGHgLE1NwsEPC/lumQTmCAN+njrMs6H/JICMSsamCCBJohQZVM3RBVguVaLIivE6svCcSwEhS2Zk1Wm5Dz6QswnDyR08pEpEoSQWqmROFZaltXbNVY2mRNb1WLx7jalFI8pkzIjhly66lzA61WocxTa1HVIdkUn9betz/2+pIuJ/Jott9/qb626snG6CJ07Ul+edvr6cYUJAt6mq4TJ5WMDSoCMU1dKPx+XQ/dB6VezTmxF3SE0ehAq993jgS5i6jOn4IS7EpXLL4qEkt5wJczSAxg4YwuWrIQwGAjIRM9+yQVAcD4P45QQJEAe8/p8d5gRwN5g44nyWclkifIoWxqEUMygCbQAnDnkqXzMkjMCeTZIh6AlA2Ic6mSNiUDHCBJh6CaJASJGFaaZkBYY2ymOU1aT1ummgjUgRFBY3FXbIY6mLYxThQGixopJIPbIMRUm0kGKAwUElupQgAeMXzEUOWlU3Wk93qa63Us6a2oLcrm6tBAoLZ9Ruef/979A/9yLLfZZ5IRsjTflVqV09g8+fls3prTRzHOr1t52NmWjALlUzkJhhgbIGvRCjw4/745UDV7a5LVETGUNPKqWVEE4UcDIyApOMGAvc3QEDxCCZufdkI2cqrGkDhiTo3SZAdBXMDNZkXzgYBNzA6JAGJUVnjSWRRjAqDuhjdRqxEXTUdYtxX2TJUrnlKOHRjxKI7XIwt9vXTedLiLl9T6pK3nTjTc0XRTIYKmZJI3WV/XIubJIcsO3/2/m37V7ppv9b//2/b01mPugcCeKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACDGFzANbm3LQkDmAZ3JuYRYXLg3qjcM1wuYBnUm5RHt/Ygpr5I6ICrCmuhgJ1wAEQrPSWYPAEOPk2eIGtjDDZIxdWMwEZMoGwAFs7g9vYhegFVTEZJUYbFigIQ5A/N+UGWrSRTIXAzIQIlCA4EKAZm0OAQNaNe1GHXEiYYDIejZaHeRZMCKyJCLFw2URArEBLwXTPJEyErgHcIubEmRYtA3kAU2bFEcUaRMibSgjPpEUFxkQQEEzyQxgzbG6Jw2LAhQl0y+aMiifWtA6zGaqZJqRF3SMtMhxVUiXRzDMh40ScPKRHwGpl0fy+ZMbFBM0RMUVlAPTUZGFNIUAkho0zzdaH1uard7ImzrWo4gWbr5VdNn0+z7vVuW/ZEbJxnQU5sjbVTqYfj2wMhhq0Xn5bYY27gTDILd3mGBigdZXIxBHIQAAQfJGQLQ0MTvug0WDqSObcu03AoHZyLNilDtr9B4CYoEEI5kYECMXesDD0PwVK77dg4og36JmZIWYToGemaEzKBYKINCNE1Bogpcip9NZZLxOViiIiSGpPKNlJl1Y+CIKFkIF84V2UxSUWgtkQQnSOPrWplJrRVfRHaeoejNUtyEUx8qutRZLofY4eW6J1JN1VnR+Opp8vor9V/X+tL9m65xX0Foeh/bXs35WLfOWv6fSwWdWUV3FBokcKAorv/X0JASAU3waVZckj+QSvs71GLqxw4FgBKfBa9Jkv/RxurNug1puYopbWSZQ0Sgh5fZnoFlrwEjMVWEUgdBCxwAEGuQ6YcgzCFTFFHExAqBxi5JkcRQpgOKhdYR8N4csqlUgBARghlwl0iuGMQJaA9UZEfJJDmCWgYEIYIDmlUPhIKKYOUSZsTKJEgQATxNjgOmhPCRmLKKRNAkABQqfMRy3ssqKZTZxaaA5jxjE78fzU2c0ElQJUaJOsyJEhAULMGRwpopHxJiMNlqSSDuOigx1EehwNqpJ+yS9eiaOpakjImarJORRJ18yMkfX9f9aDtzw06SC0kjNbYNGIZ5lnboCwmXArWpZOOQyo5w4Pxq7rQgzIGGojLbrJhMYnS4F2PRis2N628jze7fihR0JhNJed6NOiSoBGlMAJKpRBUDD4pDZWSfWDcpqNg0TCZdkaol8tCvDvA4g0MDjoF4vA2Cx5UakCBRxyj6aLjyamaQ55eFLFYumZfRSWiWzNQsZaOFxzbKBDiVGuSJgeWylP+iqo3dkqPPEop1lgm3OG5olUgQcVMzMUKmJBdKjHSi/Uybfb/6nb1t+iZt7GH6r/X9T+mokK9bmrygAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgHhcuDW6NywRCplGdRbiJaFywNay3LGEDmAZzBuW9vdrQuGAqrPuIZ3FU1YoDApKOM7FdqcrUUigk1Fgc96HAXSYAEE1eg9Dj61aWZVVf5tiYBSzlsulDSihHv4zazW+LwgsUBoOoGREAXDFqvcEILuWKd/WloTSIAo3oGWRMDEAQEHKhxaR4+YECJIpny6XBnwKFgGsI54uclFEYHcBSCTpPCpl4SwiAsJTJouKNDAMcKBwmlKE2CtSuzGSYXqFpG0UzpX1Fpk75dRWZEPVHPou1Q6STaTRD0w/MqlwyTPjVGNBYQPxqedZMjgWylG5QFIlFzJbpiErlyt1G1ne5k3qOp17oE+Yp9IcevRM0n9f6/5a+mLAmmzsxaRu4UCAAAAL/1edpmAkakmyuUsDKOjBlX8cqWgDmk3Fpt1RUOCTrQc3Iprl99qrVpVRdf6qVQC9ataUyKELXI7QY+HQCWAoDW/DRM3+Hq9yGCyTLtR8uoKJ4i5kAwyWTZRhMA2F1Gg1wfiyVU1OM2S5uYjqTFmrJc6V01LkNLaY5Kcmy87IqYfI+nKxafc/9Z+tZWenW13PtrHpyMTZamODPnzE+9Sk+tBMnjlHnG+v9f5xv3+s0+6Zr/+r+/2LautZeHVIk0n1JlpRYpmgRU9PIXlFRgyPPTASvj1DQQZDZ2P8paOo0XdMG4PtcC4fNij80s415D2GhCkT6vQqWPCVp5+Vw2uBZYicG6VjJolMkxRC9RZO40oNPtrNJH4dIgRjQzyVrVWiwEMC93YlUy705yVQekXD9xfZYuDpUxKrj7hkhGQbnIzBlK1ukalStrYsTlIydOCowm3guZlkunfnbFo4w2p0jYu/9BhrWv/C1+pK5X9ZZX/X9yUe1Qfk0KYVta/PT+rMYiQcLM0n58lzNb2Wq2p1ANLJztztdRa5vLDmFj995++8//1u7I+9/9Yxbl7v4xO5j+ufyI38+///3X//ce91//Wx/v83NRnDn7zqRne8k8H567y6MFBIsUmLVt2WeHIK/GesLkwTj8b2CmiJQg7ZjVHbpK1aAW6MVlcr93dlQh77U1AWcADupnsC3CDBQyIjmvp+gZCQurx+HiDHW6z21sZmoprAslOyBNFUfYdEXGLAeUNqWks2YnSkbHRPpoLU5URMHMkT5eIkwxiTF1JToqSJEFUeDxok6a3+ts6VHWbKX5DdRdLiy8mammZiJlBSFSllbZGkNF0+gUVv9XqZ/nDzdb79D+iat62+pvrb6Zl/IKCT4wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIkIZLg3qjcrWwmaRjTW5hshU0jOsN2yrCZtGMNbhBems2oxTAgFBY4xWSONLUO7siYYxWHncdxrcNG98IVuskU4gVAnokskUXbqztx5qHRQLGBkrBFVgscSXIl1LBSqLeMtHRB8wolBHDYkFEAZzUizBBoYi0uj9M1IQD3dnx+J8dxaCz4Y2Cxohh8XOXXOkcISIHyGAIQA40NQWEhheIgXQUpCplchpQE8kOE4kUPueMy8HSjKpCQGBRGqLkzGYgmFBZsI3KA+jyVRmeW71lxM+gMGcE7kw6CDnRn0U0C6QAoEUHtR+aD6FqE4kaU3TODPE+fKjVk0FmSDrUo4XBGZOnk03SMlK6n72Nyv6Z8q07pFwmUVdRKGyt7+mtbrfWcPspqi0PZ9OqZk0bJPYpBAQAAFTmXdVSqYunSWbc9TS4X/P4Y4XekSXUPWX1R4BweCGsSjkzjEmMRWtI8I1glIx7LkqsyovqdIAAQ7NhYAXrlroCADlD2GOCz3omL1BEyLhIhTGhmpJRqXAW8lXUDjIBCl9pdIDGxHj+ifOlFBnYnnliZmaiXLyq54SwLA0OmHX/R1PWapv1lT8ostFtZ0R5GONzqr6kRfPIecV9Bf7/QZvU/01N9a/r/U31t9R6vnUM35ggAAABp2rc5FpSKNHwGyimkC7m4jJB1xr9TiU7R3ZRCjIVZW15ujFhEJH3xZ6TLlb57WvPq3VvU2rl16pYMgSgFL3eZzeccgKmpKAo2ShYki26i7CELBbHKCjkL+EIiH4cgaxSxYgTDqAmBnBmMso5Go1K9P8loLekTLYhBm1soSJVLm+yVUquNL5S+0RwoFsOdZa/jUmd0WHb0oWSvStR1qmeF2/bormOWq97LUbsWnsmdZ2cqGZr18bEgpYAnrWs87kNNAhFF3mqSB7XO4/SMnpKbuNyndCgv5cy3hzX//d4fvX8wy3zX7+r+s+4Y1sP/+fXqZ8yy/n///vmf5frvL/O/+r9JzXP/t27bIIAAAAq/3DK8/xTuN16+UtekECoqaZq1JoOlhrBwRkAIYsmWWJXKJfOtizl9az9Ip0q+mkdSaekqOP0RGZGdLBL1kz8lmrc5q7KmWP/jEzdjRMiD6JaT2SUdNTcKqflojwyj+yRsXSOmggcWQDYejGZsQT581LSYJwbmQ8CTLS4fJhqIMDbHoPqZsS5w8dNzA0W6z6F1Ndd7oJNnDfQNX0RijxT1Ms0ZSaKSZIO3RM7WSW6/qfUugk//rUt/1Va29tr+30U3fWYIZYgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACHaFy4Nbo3LJ0DmQY1JuII4XNg1rDcM0uCcRPL24W5SS7PFspC+NyXe7r/uM1khJmpkNDcZrsBuS0QwWISTizLGOhQWMsKmYvY5NLD1Z03ZTwDA15Y+wWGhkTHgKnh+1KI2FiU3gEBQYOkazxAD6SNMLDmtu/MQ07ocBhcJpZ0mxxHSbBvAG+ggGE8s1LhHDYOikzY6YAhAgpuGbL51AgwmwApaXCTKhOiPx1CGk8aGh8xJkMblxENsJ1xExZ48sbysJ6AshMzctDyyzEvVa59FAmxxIMLjNqnY4K4ZPIwgZkHEJIprWQMSwPqNQkEFpDrIsX3emTYfoPBdUyBiI/Iqt3dNCrnTdq2Us1UtF0qyJJslQQJlvTPUX627KTfsoxNvUYDK1tdjA3tnBWn943N0hCkJFT1ZbOT7CDUuWZ6sXbJlgcNPO/sBA0MBjMIbHa1yvKmyPnTQdqZstUKw+cs1LodC4gBvwxSKAxICOgqB9AMdlkH4Vo2wGE0dGgVFoFcvFUtm9ZTLR0TcfSNjAGEUnZI6UCJOoirDPEXTMi8zLc4aoiNzM1IkfM0XRLhbBVi6dJ41TROJHUVOim1JtNGyN1kq3K0pnEOUCVGCUT+pI1QutSBHn1WqNEu9ND1Id1qNz+2nb0zLfZVuvb/1uj6nKSrg4fqfnD+69yic2683Qz0iawCvryQqtO8mx2DLogrfFVNwzSyW+tSTyGgdtfDuMepLMisEAWFzcoikmsCAMCtqxSAKjG6lC5BQMhmGpbg/TWC3kxAmEYjDkEIIHYfjK45t/J91FMI5EWwEIw50DuZA8HyFZSSbwSl4oZf2EOPSNYkMosOxIZm8885GJNYlkont24McmHq9Wc+5epKSxhrmFJYqUjuQ5MOo/9u3Yv4wNOSifvye3Lp2xr7kZiEVyjFipSW6Kxu5SUlI7s/X7N3OOpa13edfD+a5/M//Dn6r8w/9YXbW8+6/Kj1vmefbWO/5//nrWH///vWGG8M8//tae7vf7wpfZMAgEAAA20mUGcgSAYqPMeK4PFf/HG5oDFXZz5cnoBrmxUVNZ3cs01rVnVBqVJs/njuUCpoDOFn1E2uYvrPDSer/K1DF4t+PmgYPeCdlZXKLO2tyHZes6sIhUtzfWsM6IDehyyf6ch2XChc2tMJHOE1iAjLRLRosYzWLMrEsatV3NbW8fV82dY7Bu8GPrFKQJ4dN639Y32NZ+70xjL+HaK5yqKE4Yhyajw/rOt+PnHx7Z+cXkxPTer5vrW87zSL7wIaFfNgIFlGcqdSZOtxcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhMhU4jOcNwuyzJ1GMPbp1qBzIM6m3LITnmkY09ugQAAABI8KeYjcMDKIG2humh25Di5jlDeaPVqGrHhFxFm626yToQ2nY/VJKJ3CVKOYq1YP9AsuQ4u/TO5br2x0oILTivDQbY34dtY8veSTyCRP6rvKIw9TzErZXKr3LWMejUMP23OES+Io3qXRykmn8h+Ok1pbBFaLQFdjEM2cYzL5a06LSmQWLcNU0aj1LVltA0+em7FeGbjs1n9ty21DsttRmNRmXRnKR2KeVRGJTMxdj1aJzlC8OeNBdjuqv1Zn+VqkM0EAzEpoJt3sO7rXdS+pv6vbt/G1y/9WxQ3pTyrvOxXyzw3yvjrfN/hb5vm+Uu+b3/cO8/9/r//vP/n//P3f/+4/u+ilKwQAAABe/mXNThR29rWOUElvLOWPOYgoPyullIqAH8YbYu18/7u/hnnN4bW9jzPmiRoRhDRO2LxN16qqmfcKebcaBe1Innu8in/ExXt8bb3wqJBQz9upaA0eRwjKzceXFK1oxblPKaVXRLN0O8V6LyaNCiTYm72PqWbV9SqmO9w93a1NxHLWo1bVtn7rqdcqmta61u3i/V5nVojV91pSuMa+bUzqSu/HoOBx4+TQFhwba8sWUg1rqme5tAu5HcewXkKUncRDstdyK0ZCKYtUGu1KoOsx0wuNpjhUUXCgA64Je846M3O48UWWu37yTL7YEod7MaWPbmpeLrm0chM8aFxVmaM0jfKllbWSYOUEcIIHcbJJBso2RIqJuVUCoVCRRRGqCcxkjpVIqVieBqMMiF84USyJGTg1yobJXNBCpcl4qmxMFepJaJFw2Ilzrp9q6zyFKxWSWOQpfQHKUmkxIoEiSSRupZcL47SwTRePGxHHjzqdRDyAGhskko+OAnjqTqooskq7upJSSBTpPWqzMtllwkboayedbVVt7Krbot8vmxVfOX9AAQAAAAt6yz5fJDBkZRhfv5tEAh6TPHHtQxIjGUSl5EjzRE10UNT6n2Zn8Zd2cxgsmBU1+Zl8LaAUrAsDJALQzBEIvBgKA2LtiitQTLsJuLTdV1ZAP/iNBdwUFNWEQBoa4sKLlWMtMv5DKZp5aa+dw58j0vtssCCy3itaIHzNCgzVpCjWtrOvbHvitY+Mxf+4++da7fNXH7afLjLms+Jbbxn1gQd11bNX+oVfbefj21i9fjf3JG///3u3/3vH//g4/b31EKxMHkyYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIO4VMg1rDctGQuaRjL24h3hU2DOsNw1a/JtGMMbhzLNfPU+x0jowywxhkRdZYQ6gNvK2biRCGTCWqisKt6RYNNArAXBCgAtBLLz+LosJJriltR8fIB7HJ+KTMRYAOGQU+h1jCUUFu7UGlMCuPF49IQcIFg0U278xLJgkBJWd3H0hMNv/IKkFamJAKVSbcahtbmG5j9HcpKaw1yMbjcw/k21+TtyguTvrK4u8SxIpXhyd+kYBSS2IZ2N8hyxvWGGVJep7dJhhBuE2/+WNuAb3OZ27i+tby1Xl03LZfXt/lcypNczwpXtu8/u7lDY1T9qVK2HdfqxSa///sd7vv5/Jf5hnnTzU5z889cos9c5/8/usPy3v//8NYf//9WX5585huiEIH+oCAAAALeuY54kJg7dBXl9qcl43qf5y3brGUXK5XKouKHhuTlO3FrFu3F8bFWzyXcbGi1hbqRp9xyQFeg45MtLtk0rtDU8a1S3Kdt4ZsTjx/uy7hH3BftSsZHNuScO+yiNpWXvA0rC9x8IZUdrhrMR5Ehq+RRzlFW6mcIt6ep3Ae4EJr19btndP66/pFx3mfTX1v//d5rfPzUwXeN0xTPv74vCd0v/8wr///Of/96//+W76/38/f/pq/pilPHv731fevffzj//+n+/8Qpv/jOXd6k1/nYtYmRRI5AWSvQ5chftOY5S1OWWwWxNsDPwbDXcqNTVJ4OJGUCkoRl6AVqERYU+6W6UygzzyiW4DoVnLyyDtplwiJiQxp7GmruDG3oL1yOHYCdZhcpSBbi9vXKsylw4zGGdT7suK6c9Vel/qPY4dZ8B2KPCPq2FFJibxnYVXcGo70lZbCFzRfJl2T+vE/Uud11aWKX5I4mEpoXynaku+HbNNZvxLOSxSRYUOMuxeFwHOkOLLrFPH7FNTM/+5nclk3MUtfDv71Td1j9ar2Xd7nnc+ev/KreNLvDuNbuVLvlXDfM7PeY8r38t44biVHzCzWyzw7ljnlzPn2t44c///8t45d/W+d/WOOuWHsTlQQAAABh/bPbknJ9RavrKkdEFMlsuvRC9KjOKdnsXJQ0DBLCw1D2FX49AEtpc78R7HVvZ17l+CRnwLePIiqeajskaOkZT1Jm5domvS60etoXnLwBR9IRRsYMcPlsXGREMVrDzwnjIyXHPhJpy4fPHJjATjA+Ds1aPyqhjos5fCDKi29HmUl2V14potjlWpepDqqkqH1EU/S8RS+s23Dg+m02r7MFbbeC7NK/t3K//XpSdyZ2ZvMzO9+0n7zuZZpPF+rphd2Deotm14ptvzO5NuamPYGpUPgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACFGIy4Nbm3DPkJmAY01uIg4RLg3vLcszt+YRnTW4KAWcSa84+QNhHDKwPaftg04VSplWi559hMufaHzBIBYy/WNJ7DgOBlYaC1LFHW8mMX2QZRMcViVPK5IOi8Ex6tHrMFCIFDqlLYsDDbMJb9HcwsEzfmKwAzwt8TGULiyY5pqPQXUjtJ5MmjZxGJHk6KYS5ZLYJTAtsVoYj2RxVCWgwCZkDJ8uhspIkOI8nzMxTc2JIjyNZRJiJuQ5kCfFMDGaBKE2VDU8SrOgZJJHFLUkbprIgbnVJmpQECqMVlQ4oPkMymbrOFod5aOl9jxqPyajRBAwLJPmiBmXzpRJMwNHW7kSUrqTVooqH5Ja7pnU003QcjCXX3mzoa1am6dSuztqmhsm9VRr9M9COY/VjA7MFqj/ZTYh9NozNgSXTUoldgywu0+sPNcSWBWVqDQqXWMticFY5y/jZKsAoE95RCs/pboj3ly4IDg7uTjCAx7Jre4/G2xsVmqIzSWXBxGobQ9DpocHEOhOE7NC8ovA7B2LNU0hrHMo1GCWHPJIzkseRPIlIeZkZMtIfkVLNCQUGVyKSqTMp0WSqUykjGikOqGtIvDzQUaolBhjzTQMg0Gr3dyKii7utZkmmpSkDV1qVo+uj9ZXr51vUZt+evVtv0fam3rWat1mZh1D+Z247dbMLAxGPqXQTAb0MPS8N2C7NO0Zvbqf5i8uFgJZzTW+doHDYgCVkqrM6kld0UlgIAwOrijgp3y5qzWZTTGGmQ2YEMGVEarBGISx0Wnr9MOCyAAVHfxdoaBAgVjTKpqpbf4kCcJmbz0kB7hhtn9oM5PKmViww4CiQ+zgwIwYTLqdl1lWRYN+IZppZvG45bUb8Uv9eGRRaV3871G81iJPjj37N63z8eXMMecpMrkd+1vPGSPn9DcxsRCa1DtNvGoyl23YlWv0p1OPhQ/jxhLB6d/fu/Vcd2pvv/nS1Muf+8cf/X93zuGt9jmH2NZ3Ji5d1/6w53Ox+tf/5//6/Le//Lme+b+vhz+Y3RxTsSpgAAAAbtb7nNDCIGwgHKkltaHxNrmFDrODDJknpht2Io9BEzWGdSjiPaeAquqWmxbnt2yINN34KluhUmcU0qZRYiBr6f1lQkfgOpV1Hi0jtSaDTFE8w4ymFVZMyURSCcC4psxKh5DO7F46ICD4yIoJheR6F5yxOkdIJJSkhGKT2SWgbjuBYJk9I/qSb606J5jpgzO7omjoUj0wPmxrOIJjwHegtKNJfNVUkicMAslqpw4s0q3dHzZ/pfrf1la3Pa4O0lOUIldgTjhCskowAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhchkwDWsNwzdCplGdNbuHGIy4Nay3C6jemUYy1uFQWNXGcYhdmbkYmO8M6sGuNAo7Zt+7M8zRx2QGswKMoBFpww8xQlCwBo7/L9hWL8IYLoa0uGNPrAYyFKBDwZM+hM2MAjvgUYlFGmVGnNhKzLb3pdSQ+GAwcGisUhFfGbLrLGbFEoXLKa+6EreuiceWgWJcRZ7SYw/jvvMoY58HReQMDvwLIKXfaKNtGjNeLZ3H0f+ey1ucsrFztxG/zPCxzLHLGz2p+d76dwprdq9awgfef5Z07RJRY/G8+6PDrUsC5btQxar2r1Pxu8YndZ/bjcAVsct/zvP1u7q/Ws26Svut9/mf3a329f+FFXx///K1njjr//9/nrtfm8v/mv///71nD/7X/G9qGHrAAIAAFv8c86NphG66kQqXrDYTYCpa13t2sYQnYlFPHVBC+i55XjD2NSbqd5O8dimbujHN5yqBZ5Q06gIWGkABcaM8VYEJHMb9XCbRtmalGbnDZAepKkIxpsXzUyGM5MLgGgYUWhoiiXzQcJcYc6hNjc3spS5qSqyCmcGITFuzIDQMk2MSkp6ak63ZNJFV2Wta6lnyQSXlOX0loKcmDGLpcPrQYxdJamoF0yZlMozTVVs616bLUzs62uzoPQ6bq2qUdQb39qqtX/SZegaIFVLa0FtIc9gQ4/O0ScVbUBNJfAkKiB9F4szvKvBxw+K/FK23aqMkRYKXWYo89NMdkwwGS1fB7uN2bKOiyJBYvytkrOConOucT4KghGmBFrveDjlepIZlrBKCBAWGYnO26k+I13KYNO1YCwfSGok8FNCGfjpJRw2OKTsUm3ADRXFscygSEQ1cva7lxy2hanc8YbgqD561lfdJiMnguZnu/MU28dfn+WPdz2XHZ/n5fp7cbdWtqCWDzu5DjTPqpkpJusht1L9WBrtXmOooqWV3v7qibvOU9/9536beH/rHDu/1dllbvf3jytlj3+w3Lsuf/1KXeOP7z/96/95/z//eu/+tfDFHfz/v2Z6/3De7eRAAAAAl3dVfzHFA5MU1atylRoRLlmNTeFQxVpH8FP4+hWEyVx4pet/FssNSncD1k31a5/N8Yw3MRSH8ekGOhO8oc676Fp607zV5AdBFyWPMzESQuhSs61jvJVx3sdMgwCnumiShDMjEnRpTZkanWZG7kshNlKtMDcOcicLzZ1nvqZLP0TRFetAl0NaU0dR+icC6EAwLWWgYGpxLWTyWST7mC1aql/Q1ak0bdLfmgbrPh13qb6xd1QYMDlAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIWYjLA3ujcNAwqXRnTW7hNiMsDe5twuLC5gGdRblSciq8i08iILqK9V0OEvGbCwEb8Pt450vru9ZNOkJQ3RZiZIWAw6HMFEZ5aUNWKj6KDCQ865MB2718RCpWLRCHWes1oxEbmECQUAxkEShxiS8DAhPNa89x5gwNMJHJxnoypgWD4NgwckJAzVyiVQ/whpcHcVGFCgIKgBVT4wCaHAMeEIQBRiXDItmAhMKGGWNCogowOCkB2IDiRikBWS2kmtEagbONMsjqKy1lgqpP0k6k1SbFuKmtjATI4gtjMnw+UkzesyHIKZMDuYslFEgZFTpb0Ex3DwTipwtj0UEUluxOnK9bt1MOplo1pkCTNHdkDMnl9RkSRi3pq8xV+z61S8SF7KTJdBbUzxqCAAAAJz9cypR1IFpw9fn41SNLB9Vuxj2iyMgnpYnBDrJxmYDo+PrJZZubhLwSnUn26s8VQ6cVuXSnFuojmGfGlzioAdxUzZ0nQ5tT0dLcXkTGU9ZPBBkbMeHMPIAHQ8FXElGUZF1ai8DeAzhtNEnQE9EUdRGBjkMTUyT01kApOQWjgHzUgZCqJYUSo2539j2i0nE1b9yQPMpZogPdEwp0xGh4F1zJKXEmbXKB8300Sis/6vqT+omp/Ve2kWN1oGm2r9T/Wk3WmXT7paiSLqZ+4lL7leVOGIE40YZdSkaEteEl7jgyFUTmyGaf2LGqxbKGStpIAIEAkcFgxMaRu/izNxUG4CemPbbFDQyFkRRWg1/bzQgIEiXQqskWRAKp17w2TJ0jeS2vuGUSgoNz0WFzmI5ZMgJAQcNgG0QEql0g47SXDrlJROAgKCNI3jUhpcHWEOgB7ilkiJG4hGYjlm49mpmbHBJzrkNdQ4xOBJIUjJIFjD0aDnJKOj4MU3rqSbNE0BYOyljYLxx6iYDOlnVOblYP1D1CDEWYzPDjIueZNjIiYy5AUUEjAliAENM3UimTT6qi+j8pFpNtRkX0UqjIujYT6mJw8bt/XTX+pmupiwV61zp0wMbVJm89zHHKwysfyk92rUtNxOICBbXd3bhiTla3LH3WSBl6l8A1dVMIHapJ69/J3rpUArfs1qs+/IVBButdqeksVoep1Q5xyKYxChTDYVndLhghGNg05F0lJEwPaJBFpJD4NxpzJUX44DWSSzZSlJvouTiyBpyLmbVMsioWsEscX1q+kn11kuvrcpvqRcgJ90ZgiOsnUWqlxC9THiRMlLrTK6letX0f0T/1fWYH/dy8/0VfX+v6S29U+lvosAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACBKIS4Nao3C27fmUY1BuoTYXLA3qjcM5QuXRnUm5h7DWdI+oVbHZHsmlbru/DBKLMBGazGpXOSRch0PBddLx7EtHXHzIiDR9qDaUMMw8pinDQpMWaeGkEpMlhicdjOOmERG+QoUJuqMIBI0nwClippzOGXqTsEZCNvGWC8URyQHiRkwwYThwix0XY3iJCQF42SAYCgZgEGVHYTReTC5sCU4hrFpY7BPZKF1zedHQMEwKxDEljgUZmjGMV8PSNjhebOG6FV2ZOcRoDlopNcoEWrZSZSIAO0mHl0fxQQgUg5Ropi9JIi72QQDIhGH0FHCyMmRArPc6Tpx26k+tMipVvukbH30yiWUH5mQ9BTd/qZld1Ir7E+Sa9aJ0umS2nmPaSAAAABf5vmdQlaClUO52kuqdEj6bHCvZkoEN3HfqOWgkAw5wYtqj1QSyJQrGx8M0Kd7Qt2nrh+UCMucEkgei83qR0skQJE26PnIwzxus1UakxACcCCpox1FcxImi0ZoSmQBqKJaElUiaSZOWNtR06VVkxl1BTVrG4ICmiSKetn+fVn6ZopupB2sfWUkl3SUKBMDj3WUjz9NiVTPV2QSR6n/f6j59vOW84plADd8jr0hp0GA4ZWJ1OnT58tO4BQUPUkr516caUQAxuBapZHojAGGZ7eLLlcOpTCNSMHzDl3FdS3In4nXUFiLdl20DdKih5NAnogn9HVyhdgeUWGG4okyAQDQVDgKJiTEMIFtsRGTNNABfLZFCJgEBwxiGLR5GOHNWKaLiYkyRNgxwCoIFtgqYucgYrUiQEAIGIBGhXHeWBcQyosJqilKY/CHHj5PFVEd7pIsnHAFvg7TZNlVFczrskfvJNaxXknY46QhdFSDF9EOTLREE3Pl4ZoPAUSJppHh9mpcNJSKA1AtZQKiKZcKgcw6T9R5EuKq1pehLZVW9bjppoVqWO5JT1GJDDTtT18z/PNrXIqXlNWbmZLnDtiSAAAABUw5+6YcRBbE5bjFFgyM7wIHx1K61cCrOPJH5eMkBrYCgDWnyjEpzm6NvsJ3b1YkgVm0zXiLF4IFE56BgYYSOW447eLbGR0P0mGc8CAL6ZUKB0zLAzxFgARHk6ZRuE6iXXQKJBAWstHlF5EhhDXmaZDCJH5URzpFCvJtM6Qc2bQMyHAvap7ue+igjWg6JmzV5SVrSqQdVZ4OLPE89BZSo6JmZDCMT+m5E1IVupl+tD1zU/7Kf00jVFumfX9r91K+/3KTL1IHDyzrEqwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACFiIywN6o3LQMLlwa29uXjoVLg1qbcLpwuYBjTW4IgatnQU7oCqmZ6OMPbVmrXYdL/HFiKI0OxRl0veM93RhcPr0UVBgcp3KWIlMogSQSiNChRPlwkW+v3thJM9eF+I2z2GwaBA/4FBmlpgI2zLRQM2fFft6PwCzILGtucTyz5FggMFwSigiMY4lpNlUVkzK4zwEAAKYQy2JMTpOnxCgO0om5OFEREjjQnEKmMA9EtHBZpecZkgZbQQMEhrCNCWMSynoldTKsrmJgsxFwosgy0RSCzZRieREekkUC/LJmGARmSAESLizQkB2jqdA4YDlC3k06CzxkQ8kCe3MyfOOzrY1bqQI8tUVrczdaKCkSiTiNtiVMEV/TvUg99lV+Zn1KTdzpyhWeY0zfLnM+W05BsLAkalWsmQgLI6uWdL2gABXp1pfL0xgUeuW2kNzc1N0Dc56xjlHbxVCZ65nKW2nwQIAMNQEvukysuD6QOSYEgekuUgkNLnqQLn6bSZvwOEd4/6KVF0xqkFRBbo21t9RkPzlm8fM/r/a94Wk5rCMjTWtmCZ4248GSn/m///m+KZxmBbH1jStxvF5sq/Gca3BIG5S6zbD+ev+bwWB7jPt2y+f9Yp//je///4E//x77//8md//+SH//9fH+PvX/+8//51Sb7/1WHxdEjXM8fuxIRNzwCl22HIYa9RUJmEbNliUzC8MDt6X7eaMXQYSMAaIRTiRGcnLD2DpxZ7W22zabJSUCUKZbjRP7BQytNCADgKZLsoTH6YSEQHcfa9NUkUEZXOqThRWQEMBkCFOL5Ml80HMHEdGMNjAjwuGAt0vC5kiIjmgUcBdpECeSMxZhMEVTLWXywTRxYxyDk8KcYJsnF0J/KizZbThWXr09RrcaSdnlAY1k1JKWHxOYmiBw4NQmBrk+o1TJQkTZCmZFAmCeMLmBokdT0VkQZ35jZ6o6b1poFErbKWR5I+6i8rb/p/qbqnkXtQLKIccDxLTn3W6lcgoCkxypRy6qm0StjlW5S1egFBMxSlo5ORDWiwNFO1uTajdipPe+1kqBb9bJ8IVVFIRogJe541CGm3FUDIhY139vg0BlG7R8wcnEFgDGZJkxxlFYn9ahLBMiibqdIzFI3NCVYuoqQP6CyWLER7scE+JqalKUH8JwmYpNrR+pvoDxTvrHlao8ooKSTUdUJwUiYpaVZahsidMTq9aRR95/6m/MrdZ1/UYP92//o/rfrmTPqTY+idkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAg6iUsDe5tw1TEZYGdTbiBeFy4Nao3K2MJmUZ01uCgM/VexFy1Aemr0gJ4m7wsUBDeCFPirDb6ZYm1QkAKq0cqAwkYsLioz8odf7D5pxEwe8a3K7n6IAcrFNytTqGmlChqYgEA4TbKzBWJbibxgAey+UYQ4uSHSAcnY2OYZEyVg2Bg/pIERN3CARHHCiQQvkACFYLwEomxHidxegnwMHlUyL5bGTLAoxFEUkUjwyxPnRCVkRwhjdBA1dRDw+c6ShlSkobLunn0mUV0SiaIIIGrrDplJm59BML4k+cL8g5IjnCABTHwTiBbODtMzV1FosCikMMUDRJEYZy2om33U6D+gUnTrokoSRopBZkYkgyTVKN00+m/2NPdSLd5Fk+aOUXQR6z76JH+HK0pHWgPfJ6WNyeQMDP0Bt8KletTGGX5MLlTYlPF/0GLkFUl3UENJY5Zl3uzQFQXA+pI3aNNJEdw4JcmGIzq5bOtZO01IijlNTJc6K6fu6hfQSRGWcMKmhXWsOqbm4yhfTMwzorHzZicMg6pGOw24+JCJoM9McJ9yomiaDmKd0XPAyCCBfPZ1vUr05kO/pUhoNqL6hmjRaSkEg/YqKRL5fPGJLoJMxsYGyaSbso1W3mjVNY2b5RXqqMXe+UjdlvqNUW9vXfqac9mLLJKugZOmg65xa5ZFKK7oL7FIxsi6gCxG3t0aCI95VYanXwrI2NeB197uMjdBkbQSI2W8c6mabqo/pUEw0/6nFuilwyFHjl6RMwe2IDAcpUl3IDiwyDe1sYtSYvKJPT0kBChOK2CKkmUSoFrwpcQQJcoEmTobMMaOcTxKkCHPBCJCiwZAgZERbiZBMgC1shSgUSLCEsdCaKkD5FCJpIjLHYrwkqjq5fF2VESwzKWPg+6ltW90aUljampM4INUdTWuF+DdEvJORgZKiTRNqMki+Ow1SWsmSgXETU1SNjpULLKTROkxe1At0WXQIw0qWzGCaO6iaJHbSPKXuvo6jbVatLUuaJIKZJIxPHRY+csBAAAU2OeXcGtj8T3xub17SQVpCc72t7AJbtreFUOSNPoIvavX5TAEhzlmqDBF1qfdxzKHS9w3fJg6frNWGU0ZDnE7W5frJrPFatzQxODWYBTGJomskT5uPIuqWGAhl5JZqgJqEI0uOS7G6NNSKBTdA2dN03ZSkx3DlQcz1ps3s/SrJZvUS7PpOMVqM+dKY2IqXmB9aqSRk1JKyy1/U/536ztle/2NttTpNXV/X7f6aL6LG72SYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIIIVNAzrDcsZPuaRjTW4gchU6jOXt229CZtGMvbhk1vLGtERV4BxxudjcPOwWAx1yHGsTUvqUxpol5vqlhmTsL6pHqkDvwNRFUGpZGY3TPZHRkSmxXjFJORpBANWUUYnDDLKdMsuI8MjylkTmyz0vdB2ORvNYGMROlq35lSunqQRch92xWZQCQT9x39Yjd3npIm5bvS97Hcjr91qrlutT1p2nh+nfqVxfG5KIjOU16P1nLkcxQv/PRjm5XF5iWZ4UmEvpNSikxvtnzp7GHNNL/kowmLtqF2LsruUkB0sbjdPG681O2/5YqSiKYfnrDU7/7zw3hh+etZzPNVOfSRDnM+4czsYcw3nrm+4cw/v//8/m8//POt+H/rDPH+frdf3aDwAGAABRc/XbhKkMNXkdm9tjAoOpvnK/mAG4yHK+omoO+svq7wrxZ8N6lvzfqPtTs1Jii2ITYPJQQtGVuXdSmQ6yib1lEGgOTlK3RTOD0MgW0vpoqFgbHCRQRTBiIRLpuZny4GUzUYm5ieLyBuZqWZlCpSaZWUS+7qNFhVzZZJpF9JEzL6TGaRfPoLcuMdKCai4ggaEot3QPRmpLTRWFagmm503JBJBBmom5o600zN+mnSf6vzl/U9PTSe/pIf/1fMeG7yAMZMEAAAAdympyfiDjlM05FYy9TtqeFwcYzMTsZoDLpnbrhSmorSiC/zjP67Cg0NtRcWipnacZnLd7kOz8Mv7MlggMFb6XPu5T+vogNh3keguBW3SJpn2sqUUqlYtOD1XF+O8lpzKM6o6hYASbe3lxRTgSIJeG+byXQ1ULTEW5PnSex5F9WW5qQ5beMSFJFhYnq6VahYFEkTpOaKc0ctrgopUNYDlXCqP10oo7Lh7AZr1fLiDErJCjKyBChq3OyofPYuJYLnvT6P7NzuFetstl621mu74tnVcW9aRs6riF4MCNDcXs0bMGkDNc1hWi6tuvr/rH9d6xv1xuu66tuD8b/1LhL5yJMAgAAXsrOWORIMSpM5XsbVOJmn9/j/mGNjK5Vi/CZzYsY9bsVpBantYZ1sWetCz7K52MDtZZpTt49wZLIUVrwfOWux+A3aqVVqLRuV9SFRNu4j5CLtUaLoqkppwpVmXReUld/AbstUr1u29ldvmKWBIebBBVTSuFy/LcdcRKnnGUTLBkc4KNfRVFBVrc7bXnixrxbWg99rFeu7W1ikJejTWjbpA9o2sbzEh0pneYttY/8H61/ivt9fN62zrfxj/H1CnzSuPnH/r/r/5+Mb1uuPr/HrS2cbtmsIrSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACKCBTYM5w3LQTTnQYyxuYboTNAzrDcMewKbBjTW4lHZhF1CoFCmyqDGDPFBxx7JGmGJSAd8ZCMUMzBi073IGMmN7pcbosmRlSOhhL0u0haptAMEKZhZARAKyp2I7s+laQChrMETBCG7UiEBBtjuSGDqkTlRHAAAGnRsVvXhZZQ0wu02kjnJRO00pla/pbFpTKrz3fBskmXoES2HQxHIDjcGJKr6isAPTHpLEYlBccicESt2MpupHa0vvPFjT3+ZUz/4SnPO/Xyw1ezyr71hc5hXw/OxK603ADd5RE5mmqwVTvpQ3LtWYlbiPvMZ1JmAbkbuW6TF4J+V6t2KeIT8Qq5/njhjb5nlvP9Yb7+VupnzPKvhrv8/PHuOOW9b1dy/et/+H8y3/87zvP/n/9iCUcSF8z+5QzTwusRwgdl6wlpkiCcBMel0JXTxi+WVgeQyOUw0tRpMjkNNO3InQRKOwVBMuicYd+AG6N1zecQDgsx2FK4s3By4Qig7EFzVPDDwM9jlO1qw7wqA6xG55zDSFW7GkUs/F1kjbLTLSdLlWiqdJ0juptaXsJaJ71j08YvZ9+9P617ZP4/R+J7oo+fdXc87FHz6hUtXOu2aaWpjlpurSeCFInsvbYXsN0TsXfcjiRuPxRxurnXq2razLVaYdHPl/lzaq6bKqrLLP3/8qpktTaaJ8iTB14sFBDp7MJuGo2arhqkokAAMAUJuCIEkcz+MrkNK9l0+3rOUeSZOhsnKo6vdlaG5f8vUqRPhlkASF5UG0fMG2YuwNuapzjika38XQ9LkMBLSQ44PKSYZegNnWmSCchiqi/KXbr/NUbwQBFMoRROwKpfyMTd+N2ltkZYrlHph9H6e5/3fxpKJ9JTfnK1bGUxexYyn6+Ufn5qpUp5vPVaapLnL9S9LJZLKlaW6rcvXqCOV5/Vzum5/fu5TFBS1qa1ndu2ovQ7+12afmfvZVt5Sm9Tf2/T27lSkpM8+81r96jl7HnNamKn7z3nqj7v//6LD/1//3Pve///nnnnn3mv/6azrPmGql5QM1j9Y5V4i544oIi3ZjrjxpSlRodG4sEz0m5wAiuy7GDHfTxZbL4x25hKLGcXzn5+KtJXFDVTsNYAwAcoCkhbeeZjcQQ9+TymrNtBv0tGizpD8bCGJhoYIFZJnTyKzMKBEvGpcNzccQkZwwLhKk9FaRkYKNUjRA1YlTxw4pVMwHRRsyKTmJuXk1putAxpNSJL61opVvJatlJpjQQS+Y3SRQWz0lkJR9F1pm62ZJJ000122SqUxmmt+tbIVKft3+m60/rf2bXnT1pplYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgehU0DWsNy0/CpkGcvbiDSFSwNbo3DYEQlka01uHet0zcGKqbixknioKN2YEAAb2I+HABr0a0sE+jrNZMxCgVmMzEWgF0i/6gyNzTnKb6PxdocYgae64w6LSZl0Ov611/SA+TAnOelvJ6deISQxJ7so9GokEAqLGxV31LyIVN8ltLHpBDzw0taLFTcCO5OzMuyUoJyS2WxWZjOUPxGKxmMuzYd67zVWlgl3btWmy3UaZP4Xv+rOxmMy3HDvKWzyt3USk/Msq1qmdvHG1lvBpHbuGVu+8z9yq9My2znPUndY2bUfvZ75uY+Wdyy3S3qXHn7xpec/vfldnn//b9nmv/dSj7/7/LHHn/+v//5vdrLL/3zDetZdym8sv/WqDsrbjgql3uDMo2QGBFc3H789JIbExnm7QyumpjITuU0/EknxCC4EZfGWzLWYZnLVrdDbmVspnawqOtNkHha154+59JMx0bHhuir1Zlt35i1aXEZ8j2MZcFlxbLM+bKPsAymRHvaeC1kPexd6XUFxccvc104XsqvLXdFzdhwfyH0vi8aHFtur2Be2q4360VMbe95ri+s7rBXN4Gqt1h3qCWH73xNfFs+j7f1nF6Zxrf+9/5t6/5rrMDf//prf+LXm1//nGt1rvPzXWfX///cv/+O2fOfmrXEIV3bOKyoIJQYMmHSMq8QLvsvf0VLHpUvPH3YdXJsRkMjDj9ymWJ7BxiDAyUx+cyizxhcZiDVp6C4IiJVKXV+AWxTMYFUcmCRooVnb514iVQYxMFhcCZSF2xYJBSC8lkUcaBYL4NixjBlUzpASXD9yRLyRPlIdQNFIBQslkR9E6sEJ4Cz0oFsvkSIILsLlmJVSl0mxQCCJdZ2DolF0vImZHDZLxSLRqmcTNUErOWENSDIFBJ1HzIdYnY+lWiYB+ZdNWQNCHha4Uhek6gTRmJ5ImThtMSoImbmNzJMU4nzFLdBN+tM6u+iSzdli0rZO7j8ZLbqJZZ7Wt/dSH2L91aQuRr0zQ2RIrZ0kAAAACzrWcPQ0scnXvO11uMoqpOmoHSGHrVeUxM0Z6RRG/DLMwuOWDuTcus5QwrI8+FJLoMmFZygXUmPfqPjuYFr1KnTdafkZVHiAlEdVZfi5CUVPaJUpmZ0OaSYDESQNjwTAtREvWYoiXAmB7IOm4PYUx01QMRxkwWjmprUYDOfTMUUioaWdbnTIMxuYp1WP/Wjszj8PPrWxBSTrQYWR8zVMycFgfIhss1RGMUE2SScZjQ5osVnvzRT9ZLfUQ6vNm9h/Rbsdc2P+grqX9GXPuW32MyK6WqZgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIHojLA1ujcNdwqWBnb25fdiMuDe6Nw07DJYGtvbhLjunRUCnBWYdEq/zTHHe97RkmbV4/8kgupdzAE8kxL5JIn8Z8JDy/G+fyL4wyXtSwfuFR6L5igq5z12I29siBg+aAMIvr5k0PwK85j4g5rB7/FdpNkR/GoLJQhpMIhYAhgzCRZIEbhkEWMoEcWSKDljgAtbEFhmyDE+ZBMwBIyO80LRZOjkjcKZeMEyqXw9ExNiDOomwweWzCm5wcaSKLOoj6CO5kz2qSLKNcvEaG8Gq1pOQwNweIsVKZeEFgxgR5QmaRSGEWjNMxMw/pQJNFzhqOcHvkcyDNVqVTL3pGaZ5aGakYSaCC1miZVX7kjvUt/qTf1upPqIkWnZBSyyTiCWsyqi9bCbomlDr51gPNK3FgTNJQ1l6SvY7TVTLBf93YNcNBKng7dNG6X4Jd5j9yV0r13YJJguGPbhA0dMBLjpRN04EVe3GIPyLSsIq/L34XSnBVlWZI0ZiT49bjI9iIcjMKyN8BQQSixStYIiqu1f0iQm/UHOMULF819LIilfu65Nz4t/5Pv//NP7R8Qj71/4NlHvGtbyd+8x/LALFFhTe2lOsbxjGGJxrjWdwViX7+8Z3/8Xi//+kSP//uD95/8Wff/v6at/8TZ//+Mf//f/+dIbu3+cKxzpPgtVsXOSKGUriuNUZceDZRTsEDO1qLrxF9K9GF4NsEduxN+HAEAjD7bQmtZgocCoFc6tKb1UhD2r2qaVxSHy2ARcppK3taj1pkhEoSCQV4DfxlAcUROhJYyJ8hgXqFjGu5oR6h0EksmTxMi0h0YIo4rUY4ckUgfBCSAaTjLGRdMxnTMnDQ+TsolgWQpydZAwEcFY1NaJHi4yuUS67SNouzOqhd1lAnFaaSYndEsMsyL4j8nS8dUkN0EAEUQc4j1FxQziBuaLQikRompQScxMCOKaDVoEQX7Fr1sX2STzBI+5vUYF4k29M+6ntba6Zz9FBV1KZaDupM1LSS9I0amzx7jUHEJpADu4RSdwgcfDPNYrV7uJlIl8fznXjSHUqh2X36moCVTc6do7UYp3gKA+xSvVQv4YGVnViBQHvws93JtYxkofMVcoxSu8v+CK2YMBrMFZve9KlW6q+u+bnQHBvj7XdR7jMrufCms5Rtb9tKGWtvnCTpbfw1HhNCt/5NY/+cTV9aYhvvreq2TG9e+eXyN7fO0+0S78sJM3xvGdR3cKXOrXf/e847v//+3+v7QN6x/es/1/22mP/usX6/+P///n/////5tve8/MC26wHinSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACCWISwNbo3DWMRlga09uIAYZLA1ujcMFxGXBnUm4QHX+1Im3AKyzylFjv202BHhHSRzWLNoi9laiY2BYqGH2oqRwFdjg1AUiicSh1+CqLI1ufII1SYlQhRjoILbrOvSVDYITRIZVRVfH3TFQwYCWzvvjQwGqExkHnsSoThdPgVEjjFRHcXDJIRAiBMkSLh8ZMG2gOtjIiujvHNOhboC2MkjM4Tg3DgzZgXS0iiWCPqJ5ObBq9JFBRsNcPkJMsllN5ZN3ZVkE9R5jIg+zHCmKAUlY0QCgAuuSZwvkwJ4JUiRJHyIMNQaKZ1zA1HWPZfWxqeSKpMWZZkTL1WUmpeiYDhufUphZjUJ82H0W3rzqK0vfbWntzN9eQd1mjsyTHmpMbH9MC5fnyfZKUqH4pI9VlSHpmCD86l/aeOGwHzM9auvsYoAnfKZ6xTZQCgRpLM5jK6ZRooH0souO+2AV2mRFTifjnqZMQHRYCfRuYtVp6QqCSi/efNS+QDPW87yXVnovv4MwScEc7hUhZZQdFcfaZ7hXz+2UHrvceCfl8fdUwS/2k1/J9f/ya/8XyJS2v86ZdZ/9zrxeJ5I4ZsDOKOfhtOse8aIyU1u24K1nO//J/f/y///uX+v/JP7/Wl//H34Wa639f//+1f/9Ygf/GaRd6/xZd73PvW5KLg6cyuR1mQirnCKQ7UbRtYgIyp0VjU4jFsIwzwyyJlVLeblLCYRAQ+11h0Qls7QpXjwVDU7UxjoiESIXuXH9sw2QoTHB4rclCN6HPTuDm+B6bUmX+puYEIPy2EihPKIOGDCTE7GRAyymGrxwlcnS2M2ToCzwLuIQlyGlAxD2gUtFcxLR4rjrDtupMoGpNCD1pF1SJgHSGyLqOjoGgks2fUbsp1JmB/6iwpmSSIYHGmD0kyaDGaSRPJFodQYSKpeK506alYeWL0yLIdchiCCJk6hGhfZrGBerXZE3fXTGmnqScZtA90CeLl9zElzBPSXq60uqxz8cCab00SmbHaB5tNNrPDLUfHGAWbFLkWnq6hhuDyDLH5L0FWqegzjLRwCFSsnpTd7Xh5/YTepd3NqyJZbzbhL2yDl8IyMlTuoH1lA4BNkGfm58GyCGl55RBZdRMB6MAgAtKSUJsLyx0MaJhBJE0jcwYzJgOBzeTBgSFNS1GIzCUyusibUKKhipWbdvq6k1lAq31uS7q2k5WaqTMRSTJnlJJMW661D4JFWjOldDVr9ct/YkNdpx3VuXU384z31NXq+tnT9TE8qjYvEUX1zJgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAdHiEuDeqNw2REZVGtybiBGEyoN7m3DccQlAa3JuEsb3K07IgoCi4g2lI9EMy5Hk24CVpnrcugCAzi6HKlkhttaXqBhq660TitW6On3Q5F7Fi+/JQb1Kmy/Boq2DhaDiijJpW4yHcxIKBO8fuPKqCIL8YIMTOEwY0CvPD7J8OhJIzGoiZE4AaqCgw2Yck+UxEgo6L5kUC6Q0UKJyPKU5oPsZYrqMKkBP7orOIEoONSBktOUEl9AsPuqotG1lLH0J/cxpmRdGsgmaoIkXDdpmZwtFZMXbWXYREvnTFJi4kMRBCtM4bvqpl71oDgX5fHafZrGg3V19At36//XzX8hUqmUyCS13YxQAAQAAHuyzxygkhZGdCyqpF4VOq3Acm1K9hvt0oiYS/87KYECEpUVLOSjCo6qHlXKft17ZAGLe3LUpntbEFGMBmjuovPzJXxIBA0YNgTOkjEwwVW6VysnTJkhoE+Av5Mm5wqCFiRciZURPh8oZosJJnkB0Bppgt0iJD6IjPLU5QFkush6Z0zGxVdRTFxKTMedv9tbx+0tjE0TapaSdJ1pmAY1NUk0zVMXiSdBJh1DQMEkU02IV+y0vrNPrHe/oJ3e0lEm9RxkNZxvVfUtmS9SA5rdNxyjRlWmbFo79ivUdsEJRyAipZDDlN9AI6TDKLHKR4ZPaRkOMfUzYZtwmOpJhcegTOLV5DdDAVCHfeQ1LxEGERFGJW4OUNjqUROQ4AkIMy9SuLJSiS48tablFdBkIPnGgknykR5TAc4XILhKBDisRIEgEkfJ8nSgWQGthWAhMOwfBoWQKSBfxmVy4VB8Bg8ZBBJAuKWFyCeRLZ1zogxSNZwvCPzY4XkcvGjeSiCVaCiwVHrrJsNqWVHWgRgaaaJskiQUPwK5RIqs3jQNj7rWURZJB0k3c4OeKhvWkSamXWgPDdEvjnq6zYUEpkEGNhoVqvHQV031J+1BP6RXfeobKKdFZkUhRIFOa2uc7y/OhUIJ72pzcBz1AVBpVQU9aJbqy808Fi0qoIVAAs2FzYehzsoyb5W589xbKzWJRqGJXSNeZq5QILRO1c9rTTFbGYiMaNFD3alM1HY5GiYZfWWGhiaGpJjlgYANomWRDPy6ZDpQMygA7BRi+ibpOTQgVSBmmQEahJyrTWcDzrUSDoGQqe1zUTQ1mL1sn2mbakEx+PpPqMR5U9zaW1oLQl8LPG5sbMgiRM1UykkhW5LLPKyYIXqrQe+kTv0CCLZeia/RLdtlPtznuv66Zq3ojNJMvMRT0VpWUUVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAIFYjKg3ujcNyxGVRrb26fliMsDe5tw3VEJVGdzbgu1hvGabGQtRh429TiPO0J5C75y4Qlm+Eohu40s7U8e+B5FGHbh4QlM678BO1IYeKhgy+s2uDw1ioVK+tX69DOCqMBpcFByHZdiKDzjgAHNLsO5yKNWSDCCSQNgGVK5cIsEhpLiFieRI0+GMyCGhLE6M4HsgQgsQAPnIgXR3BCaBQUaFVA0G6GHBwAzIMaKYUwNtNzdjyzEh5kp1MOsUxzJR5Gtbapse7LLBVd1MgLsaSJu62GoLSgZn0CbUGqySJg4sprJ40M2RWWyBG5aPzAqDpHg8+pAYa1rrLBO9abCxaEzUMjd1TgwjSynk0t2533SKR/rrSvZMpHTK7rSK1me5u4IAAAAd3dzluICE+C1Tvv/KZyXsMB5Fs0r5jlAJmg1CJy/wRgq7yqAUNDV/2oKp2pmkxoKhCEIsV6qj75SpxBNsFhR63VRXfURgI1jOvSX5+D0iAgDyjr7xWxwVoL9ltig3I8qQny1AExEoXjO4tEDfM/SSSNel9/C+ns1Zviqo1vO6LhU+v392///g3/+ekp6f/tV9Z/pd9ndLYgAUXUO+IGD9vT/EyG33N77Pbf1/vM2P/5P//jo3/PxiJ//9pW//16Zm//k/39Vzr/4+N//GMpXX/xBRGb71jDVhptL9amd0GlADF1dvC7cnrCIXNELnVlMSkkhdkNSVqrEpaVd0QMCGIgx2X2pVGBYHHg6ancqbx0YTMmJqW4PIKkxRHjwYQAF2zQkoQju2KAaOBpwvAkrpk5PTc8CGBFh5JggpqVwxKZkMRPmxSAUIFFB/BP42iaHGCWhqFEghWNxkBcoOQaEgmZFwdQZtFTstEyRLa0UB0oMZLZ9FdS0DNroM5KIIPUgNdJbJomjhlS+VmMBzCNEeGI5aSioogyBRTWUETEiRQUmbFQvny4/WN9/OFv1nBbGQrUgS6zBdJEZV2Tqkq6Wut/pH9d1nlK1SXW6CywxdWU9BZcdtQABAAAnu58uyQsclQa/KoOhFCOiHCnD2NWrDb1GNlsPV7kuXSPDxUAZXBFi7PuO8kJlEV5jONaKAynrp+08+IB4jZS57W1eMjcIqkpgIk+Mu3DjlqypHTTyJsYGYy5fC9qRWNjQYRoXyXPFgogVmMiaH2RUMeVThmasRc2E1TSUtZdE0VJ16iL6nURxRQWp9f6Dr3URyDa0zB1oKZaJpZkimZAss2JhmKaJcN02UZpDqLRmykT5KFRJt1lpuyn9jpE0l9y3qsoZZuufWg3/21KZR/1qMa8zTLKkLrl9QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHM4FLg1ujcs7xGXRnT24dVhkwDWoNy0hEZYGtNbhQjDfOxAKmQf6TnhboxiVigw5x9iD9y6l7THDi8iYjyvIV6Fv4cYvjXmHjKg+5EGwNjH8B0CJgiXT9FNTJKEDUsztOxszYdvsTIblSKR1I8oqHDz/8MjMnTYEAeOUcHKMDgYSNCuVy4ajqAWWCEw3zcfyGjuCEoG0nS4gcJIXgMAGBVWZJDrE5MaF1GYFVFJdUSVFFFLMkUNbHXVu5kyHkqOyqgfH2LIKLscK6xQKRLprKBwqMZJLIxx0k8dZaiqQEiST0nkKr3LfqMyGqat2Kk1VTcajpeYn3f31q/57qeTkmg0aV20EAQAAIP73LdYUPDdHYsyiluJvm6JL5ZzOpQghBVi1DBToA5AxC1He4VX8Vkjc1T5dso7p43eYz02KNA/ykc0tqLIIkhiJbHdl2FPEVLhoDEJFrF6MEokzjL+Slzq9vaCB1L2kL0tVI/E8fMRfPvP+ctih3mFvw4WdY3rBrXzb/63//5N//WGqb2/3i+/8Yxf734mQ5M5+K3b9/4lyzxa7xncJx//1mb//+f//dH33//N9//KR1v/5reX//Ov//9f/O/v//3cs/+lmz5x8+LtidrG5XeAhemREKr08CwJEUbjsiWPS+xP1WwnggMcXvBNIwtNUHBYWmpGaO5YR8VbSc7YqMjJhMbtwVEHTbYO7q6eJiqj1MrKGDmeQ/95rsMBwyWzhmViOLAFQkw/snVmoe2blw1crCtAbDAWBzRxiAg6yHBwgRhaNjVRNi+DmmZghLhDRBhkapNSJ9MuJ01D3TbROrT0anXouggprJIjEZSmSYUUxJhnJ0gYfYmx0IKJtAm5cZRSJwfjIoLQSKhkVimlscJNL0T/zEekl6KZJpp05wfLN1HEkPU/ec/U6D9R1kKaJmis0bsHsY/WfI2IgAupYhMQ1T3FogbY5ms7EPvgFleoMr32VjgdzsKatW4773Nnm4G5WlpYHubYqRx7sRy4P7A4i9cmpaUqCgVxhndJdgZrAcHnoWgUTxmOMugNVIvKOBoMEC4o8XwAoBnDbdM4dE3JdNjKgPo3KWumcErQcka1jxoqe6aakur9TKqx+PXVZZavrc3dN2PlQOMvEmbx8YaFHXTRJcSU3TZNZ8fTzJ9Z5frf2OEFF9zBNXWmRFINXU6C9zrW9l1LSsvamWWqSMCRQN0FrQL1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB0CFzANam3DV8RlgZ1JuH4YRNg1l7ctHxCaRjLG4aJnjlVkgiWnKBM5anDEhjxCPMCkibMJFVkjAjixWxMEn9yxC8Aiqdzl6y6UywqlF/1oE1N5CoVPGN1IefiVpPjVp5clwtXjSTosQtqS3fc5riW9RwVlQh5MAQGR4ngvEcNdY2Dc1IEXy4UwH3DlC4KXJAySE3BQLn8vB1CRRmqkR8CiqNzqTnScY6pbIHna92forMH63SPLatImB2qMUKBSFvkyi5EkxvGpKzMqqPMRzKM0SLGRk6SZUH4rO1S1kkgq6jNC+xwkKW6jRaqKmHh0l1yaUbP1f/u7po3ZNJJ2SSW7mxkXPa5LvWdSPjlRrAwQ6kik82VAgojMQ3RYPrHzHppW/s1E46DlSuZQvGFVdQAnfcq6xlkpIB7fxjcci0kFOQDKkw5h9WPxERkjIgb8HWMH5dNRybepAtlIxHwPgOE5iUmFloGZfMEy4DWiCuRI3OudLazyKjUa6TulYpjSN1FBqY9u+koii1W1t92XU6JQLSTqomxss9dJaDlKxiYiJFchjmBfMib3RMEiKORp5bG4+zyL6CzX6KHumV7bULdZXa2t2V3O6K1rW1tkbKsm5fouyKBFJjUpRfZFfm7e77ECkbDsENwchLxJADZQSGlGBAgUexpQkEVMjnmsP5VLYFpUj0A71O57cFb2lPJOyumlAoHE3/lK55e3BXA0++8QXBDDsM/RJkjiR+H38aGoM/ENlzbjobQyno9a2diMYzqORhZGFjYgRJKC7ljThlogYJ2jjRRLG0uZZIeuEIlT7mTCLJ4+IjaxxoloFY8Z5FveK/hMErO2OD+JKz4YJmOPR/Z5Mp1crM3rH8ZPMkN/RjU484Ta5UgR2TTHajflwYIU3u8iTv8Xxh5HtTV9Xrumb7bM7pq99bvTMPqTeb4+KazfH397+KZ3JvGv//v7+K53T0rDadxcAAgAAZd/eWJVUHfl1W3WjFORzafTRiL0zSAFLOUfaSAGIPtnWl9itegSxck25Xg5L3WMY9ahgk8JoXIoZR2kbEUZWpBufxtqcSyZXvrHNuHd2Dhw15YYavXgBnqCW7Ga48qdxlx1ePJLjOHG307k0bylFlJmnQO5Su036Ub+nUpszTrd00pr7m33+bxy98joGMUdJ2FF+Y5j5v0V820V9+9J6v0pvbr9O28x3gcbfgc2k3/lDd8v9JhvSm0682pt5vnT80m/b80++djEFZyuy39IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgihEyDOcNyzNCZkGcvbmMGETINaw3LIsPmgZw1uHU/CV0cGjkwbLBURfZrzJgLEATUjURWCFuVIjghzUxhG2hZqsYiMEKCAKB4DmH2koMFZzBDLoDazZCgCBzzUi+X9pByIamai9bKIFhxbY8rADlONDrOXxYPGrlmM8jZWSNQ6+sZqW3BijdpDTR+EmdDhMCkLJXlbVcjOpTLakuusnfWljkapsWqTXa1PS4QHFN4Y/WoG953u8q9flrdLWpqlrGl5WtfLd0vMuymxTf+HY9RXJ67S1mQu9L4lfzv5tdwu2cK99+ZZW+39I41vtn+cyv613uqmOPP1/bW9ZZ4zlrve44vRlreO9/Z5zuv+//P1/475/f5zXO7/n5613eVhvelp//u5zrtEc8H0285InejpdgGI2bMaKPovbv0jxRmWy6GpzKU1H27MUu5Rg0Zp3JqJfOCG4jAUrhm7ahiaGurueNDSRqM1LWaTUs1JCV7F0zRtRomXoLVmYLq2O9VkKdWxI0GJifLdPdItd6tk9YC3qtt9iVda/2tmv+tWtG/rq1fr5xZtrTeffOvCvBy/gwoMWmpW7dYNZMu7Z9M+Lr//e8Zxbdp911a2YOa/G85xalrZg436/0pfNfu2vr4t6/X/zv/H+Z8Z1j/c3qzDGX4XrczdIGRZt5dPPal8DFKt5njuQ09rLwXGUuVochw2lq7HQsqfxmzaN/JB0Y37yu/XjyxBGSky613xutMEjBqS4VZYQ4EJSXHmEAt9u1BLC1nO261DDjK1VFhccn/ksL1C9M4izSIFWuAFucuRWiWKRedub0wGzdWxs2lhXDYnF3Ak1Z0KKes2sKjdX9n7k/XvuBXquXDFJB78XJyX0jtvRB0faQ8j7u/BTLI6+7+vfLI5FWd5UECTkbpIbhE3arQ5kzyks4zcsp7EBWdbpqWalcbp+Vaa9R1KG3uN3KlNSz+FvCV36TP8MaHV6N3LNyOW87eWeUcot9/C3qd13X4YW9c7rf7wx7v/sby7z/1zv536lynkgLSc7hukHRRcKLymlvbihFTFMuZTUAmYEtp6tJuGpqMxO9jbpWj1LkjzlemfUmGExYvL2J4JJQDRw3doCNesN2JVKJfXsukmTCiS4cs+cRTLxcMUSQMVATIcBQNUi0yGIal83UaHRoNS+6CLk0pOiboqkJanZNj7j3SYvoOYLUTy8eMTIlGL5TJA4eNDdBRcWfTLhwzSMUmspxZl6pZugmSqloGKSzBRpSafTVQZNlqRTavvdDbrX7nar5k/0mf+qrq+z+nRVWyziwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIfoTLg1rDcrbQKZBjLW5iLh8wDWZtwwxCZxGMLbhh2E1E78ZFVQTPYk7jlwfGColHEC8WiSeOxZLU+iQMAsvm4nHBIsSjKB2r7tSqkMCPgavAsOuDUMWBQhaTPS2jdgEvg4IqNDvfVLDgqLKLrv8l0RgVWd2o+7u+Q7GEYoTFa8fkL+sssySBa74OucyIzwI1CSztARMVilLAYQ5TQi6iG0WpX9lWcveSxO/ng+7ZqGGbV2lqNX7KaWzVwlkqtVq8toI7LYlD1DLaB2rerstuP9L5mW5VqO8+uW7P2p0gBO0FDZmOxyU02XMaKjp9y7m7UpkFu5jWzs3rFrPn5VMcd44/U7W7V3uRfvLe6sbnO93386LuX81d7vX/rVr8v//v63/8/8t5fh9LoF6H6lvN/jQEO1MpmT0tFdSkTfpt6yqtkFC6C5cyyjrLajw2LeFM7FmrllWtS6EYclFiqF5wzFWh9ZFG7TRCt/Cc+mppRbwlyKzVEpoBNEqc1SMiw4fRAMElBNZJMYjnKK0VGyh7oPRQTQNtBaJkR3LpeSROmCSVF0kHRU6KBdLrGTrRNaS0WSLUUUb0aToomwgpu1zsrIzPposySVk366ndH0n+976D/RXbmDqVrV/+ujVXWb5fFus9ZyIpLJy2/iY5TXWPIXEQkKkVAE0AcQw2TtzccUUEfcaWALOF4GUEQIBdQrR4VsZwggMYYasQANBL3obsgaAFp0a0vEc3gXmiegTJtWJl92vKXwEFBQeKXzSUV6WXWGLRoSGgy8gjjmDkhxw6xcRTIwoEqIDjGEIMoP4hOLjAuEVqGKyRFki4BAADCQiRODrFzj2UQamDVBOk+o1GXDZxzycIAMwOBEfIxGL5BDQoFQgxcIoYIOYJqaYM5ommpBkzE0NEDAoHkThcTLikxeEwiogB40FvFEMC4mkRQWYVjxmfYuIDME6mmTZ9hbDRTMnqap1HfWpPazk600ZCM6mreWTRaaGdfsr6tKnV11LdMt/YvAAEAADPLDfLhAMahutSTli0TSrbt51KoQq3UjGGLrvdTQxOcjD8S+GJTN9qWIDlkMT9yZf8YvDb/26arTNwHtzzuR1345TQxZoygmU8usdZylj5gOxtDeXwFx3mBIOGhWVw03PyfJtFZvJLD2ZrsYg03cumO8mGhocOMpkoMYgcYcmz9sp5+Lez5ec3vqYNKfFScNC5CphBo+S9A0mYZvtkvtlMp7qe/llTfL3yz+ZdL+I4/mtRnUVxX///P//7P/1vKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACW6ITYM6w3DQrNn0YwxuIvohMA1rDcMTwiaBnCG4XBlLGaxNWwQUjcebvCgyxUWzcuGFxGAM4BBwslGmHIKOh54EFCEGCnwRIMOnNQZFo4jWMOBRcEDE8lLjABVdIqqgLzBgKBzGBjEglBhkADhYkJZ8YMGYQWpUXoKA7dxkAMnwhyIgAkWMUTL6BxJGZSZWGVmn12MvVRjzeOO7GLU1eruWM0m2sWZdIOm0BhqRU4v5VMxDYc/LEX0gaJtq01frmyJdroyyXQHNOnBbuu+6jwxGpVf6J2N15ZQy6UZXLuVNS0lmxbv1J27Go7UvWqeZrSiU1e40kam5bKovGZeSDtT2NnlHlPWaSVT+M9OV88K1qvAlbCisV6nOb7vWsN/++Y5W+buXfps7HO73MX/x5+sfxy/fMf///WGH////N6/////u87t794f37OgACAABf1Xzwm46TUinZfPPw1VmUVgN9IMlkDiSH9dqQtzehv2cSeBoRL4anWWyuWyyGrUfnH6tOk8cgmpXF4HY0+9K4yxFJr6ctTVwm+Uyg2HZeMzlK5X2zpgvlQ2PxsenI7ND7AJUnqk9Qla1Eq/khBNZPx9WFa7JwSXTUfywQUjC0+JMaAZrC7dqqOr0S1NkDy2rDy1xbS63kda87zV1tFzNWUJ72eeupb2BVtbRrZ5q3UtMOM1e11r63rWbs8DaxoSEpiswiPQBW/p4hvn9SZ9ReUDp3DoICyQQAfkWAJJKNJEjpIN1iwduhANQrb5wj3BEgFlI9qwjI01ZotWqEiFrnVBCmAlkYdfW6+sRfgBFi6KnEvon4bZDUohuknURAkbXBCi8eOtPYgsV+WRCIKHANOstFQF9E5VQQ9Dk5D0en4ZjOckf5rTnr8RocaVyBX8AoNKwvzQxV4oeQwppBamoe7da7DzXrcYkd6xTP9MX4zKZBVxvU0trWqt7Gls9/m6XG5fvVtU1repvCm3VvZPFWuT1LUpgsaex3jMWZmj1jjy68KnrM/qg5JXMwnKbDtzHv/qtjnv+4443O//P3O2f5lbuR2ezy7+rV7X/nutz//H98//33nef/63n+v39LY7vn5V6PsU+rZmYBLABGLHaeTxDBoo9RMT8qdHbVAuWgf5+3gpqRwn1YbIaR/YhDz/ZympLrkASeVXnj3NCDjWGawA/UWdIdsn1NKZOVK31cp141DxYqaIgBTgiFRkiokFc4WDkRSwZAEBVYiio4OrPBqELB+cx4rVqgNTA6Fg+xCD5xZodSg+tYZpUk1ilpma6yqtuRJE1Er/E0NB+5qZs6yUa7CQN2qiCsD7mWZmbv2Vdr7n/qLv/kiv+TeY///4/47rr+E/jKPqoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhIh8uDWcNwy1DJcGctbmHCGywNbw3LGUMlwZw1uWZY1H0daICJ2JkIBTEXctFsQhTnBKNu19mLTl2iKQxb2GBg8dfFORAwukv5Fl53qxtlnn8qyezapgJW6sqb+q+8QHahI6ERhPJKvgAbRYbKzWef+KEqqSNC/07GbCq7XZW0OcbpR5TspkWETcwVCBjo2CxZYQERGbqiq/Da4UkqicFwdCrMpziDqTlb/sbke+4flqDfzx1z88dZd7qk7rL8cLHbuH1cLsq3+q9mJwzrlyOWmYK6kMPWsqF8XDn7n61E2yvLXppjGPMReXKrn+qbWv5nh3L/5zeqXDn7+3S1P3+eo1rWefae7y9zf51ef/9y3rf/rWXefnjX/uXM8a1XmrdPvPlppyiU5arSqVkFwRTI2TNOZ1LyAYFQ2ZyZyjae51gSdyLMSf5rLNMGiSGhkddgPbc9lLcG7WZmQsJo7xjrIkqDwFPuJFQbQ0+PU8o7VdhoVZ/TVM8LhGLgcKJnUPFyhJhuJIE8HeA9l0XSVIg5Uy8kisxNE2SoLL5uY0VnElOpaDqQst5gl7qNV9lG1bvjlUhugydZnRJVAxecLwwJ5GuXBZFI4tNA6SxsytRq63s6Dq6luvsgl+uts0JJGvWn9kqtNb7aE1XUpaCakGMgNlMyQ2o9NQQCCo/oa6me8TqqbCJicgw01kFt9VYEFziw5cYQAT8MKEqCqEbLJQW2Jf8VEhWdapLr8ujwXLJ1sMieDjogkhUIiCwCa7YpUoEs103Elc2p0MBL/Tb3T9NHSQrbN3g3B25NHXWpXkjbxwIm6cnCMACWxRH1FumDgQU29qtP4qX18NUnJcxOks8zq4tpb3Zx5Mt1k+/x+zM2NWP7ruWXP1qY7jzVb7Mvw3lu3HY9ewwr4QYCgy+jxt1Moa1LL1mu+Kgs/a7W5Qo2yaIcxz3EqWrjq/hzLn6z3hZ538s7+f7yx7SyDG3+t/nzDnOUk5z//lmky5/55Zfd79bVzv54Vrsrtc1ZufSO3yf3hT51yrkGPzTyT7vWSEYHNy6vlnWIAgPkCvvLZ92pUuXNSukjtHMM67HbfJrMsDxqXoBc+Os1V+0pjU86L6rGpIa+5y6WAW5jFRqcEcw+FNZIHzg2ueOHHFkBTiCjuPkmaE4Zc8xsyRgpJbudJBN+sptvUTixW93X9d1IrTQutlul0LHnVpjQFyQSeZkiNiJu9ROEqKDJopR3OuktzF72daa9SquzVbWdJkLqSNU1OtRmi+qbLW90EU6TK1vutRgas6RfF8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIc4hKg3nLcszw+WBrLW4hKh0sDWsNyzjDpYGsNblutnteOzoUEBsJWIsMvKfc8vAElrUF4yxzF6CK8+pn5BxcrU6WFdaMxMwCZVTsfh4WblDX72UV8YlbM7OnqdV/DeOd1rqSil6AN6wqOnCvN1Z+itt2oXZsS6N2BADXaXBmbY6erOyR1cIy/YqCPuw8NJMCTjSSWAQVjbtVbEWfR1qentUOMTl2chxnMs1/Za5Zu124U1jefdWbOeGvzr4//1dW+UNj6fCDJfv+0GUE0tj9wPK0ZFzRe9esW4aXDlyxK7EMt/Azy0ccib7s75Cs9T0xLeVs8fqS/mPN63l23/Ma9NR1+WstTn4fnlqWZ/v9csY//63bs5/3Wufqmy5vPWsdzdi7Qd/DLDlq1gH4a5j2MiNIHl4fiMTkU495Nio5JXtT6HA6BYREOWYDV6v6NLEr0j+V2m26kgxm9JCWo9yINtgCTmDKhWxOyiUkCNPAVvCjiRABAkekTGCyGgRB6qIiBkQJ8xMy4HQEaH8CcJpPKMIZA1miJPWyK1VFxzZN6htZJ6lHU1rQqRe/RfqdaLOtUfTSrY3NF5IOThM0FOswHYb0nQTL5GNTadQJAoIIVsZl50d1qS7KWyGtSLKsumiupazZDU63MPY0/TSWjUeRXVbPoumZpsa6CYtVqdpZkcbBKl6GgvVDUTFHRsA8cU2hpu8tVhPABYoipivpyCgEqN2iURLlH/YagEnGuz9yYZ+Y0VfYRKKeBI2alK68EraUqadKgcUatXe74KbddeUpnH+oKBNypKW1ut0zgG9MUcBZwsYGUZGRsvR6BabzWiYkcVDx7rUSh6vLsZ32765O7lX7kOeWP62vGiw7z7ly9j+X1579/rVXD6lnHupjtnX3qGJVNcidiVuuqPkVtW5xZkR3PY3rUWZxPS+thRMofu/qmpaO5GuVd4517eX63zOrl38vu17/5WMZimrY6x+gxvcx1zOmtf+fJvX4c59zXcvp7n2ea1UuXJ69l9PS87eD97U9+f9spHFLuXyJ679gdHhianlszNSkhUE3l0F5S1o71pITrJ5yakMSaHf6+WM1NJzzs3bWxbuFlWPkx2eNq9s+VDqurawoYAQTwiatl1NMQp82DiMitRmaqckVHgrg9BMARC6SxuYBfkSE6aKBduzyYyGjJhDVVxzEdfVdVdSFKpFkHpWlaL61Gq6zlAZh6F8/pBVzbUkeHgT0DBO490GRWgxijVSoNeg5gki11KUzaS2WrnUXrugaGq+gne7Ga6LKTZV6aazWjY+kaJmX4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACE2FyoNaw3DU8LlQay1uXZX5LA1qTctkwmUBrTW5a5y/9yyVKQlt9s7xNOlpLODkcDKaw1FeCiQXAPqhXg+6jSGBQnqCoGOKKwOxgIW5L6wrQt2RbbIHepmxv4MkVAkK12FUEo9HVpGDRxiMPdblbPhEAsQ/E5TJoIVtaDSxCb5Kaadl+Gb3PCF0KWktQ7AgwWiXqtiFQO6s3SxxuuEpv4WuSCkr6+I9huR5Z/ht64Ap//uqb8Mf5qi5r9bxodcz5n2tZ3PYyrCM0k7O6nZx4bbf0GVu60pBIt+r8ppZDK1u52bWmJzTvS+XX9UFNJscN541r/e5YZ7uZ8/K5+NTWGOGs8tZ5d5zHD+V71TX8/dnn6y/C3zfL2s+Z93lX5hYx/GZxPRV71TfP5nYGRo3Onpa3WlyKqGGOU1W5MtOJ/o1DFzFbK30LbLXbt+DoNZPdsW6tDAatd+GbzSoqo8MlJnJWMwYKyZbYXqkVuxerSBGmvMUii2Pw3FQ5So8ZFw2HYXx2D0QEBLwCwJONY4xuJcuol6YHSWNnUbs5kbqz7GRc9Q7CROLXqS+ku2pTMipjVZtQX00npHTcjmlaCRKhO0lMko2LgtklosORMlWZFqB9JdA4Y310GqRZr91pnEVqegaqZmQMk26Rmr0jXUmmpmZJNa7KSUTkq7CeaTY32xyySwihrKr0cl9khZETKROM/b9Ugo2ExOb8XZTDZiA5ESruhSwzB5AAQ3sRveoooku36W+z+qMmy5E84aBTQJJLgCSqU1y/6hioX53XMTAoBjcskCKZZYokasZUukYTIoUAAQ7QNRB4gRQWUOABqDceWMS8WB1EDNDNAzQLpqZ6jNz6lVsUx2uvk6fSVTQU/a56cQczqWpSZQLxVRZZgTBdE/D8V0EiBh0IgcdzGyRYI4ckeVrSH2QUjC86Rwpom6LMmgXjN0bp2dbJ1rUyNa6bUkUnurLqLPrOKepaqOpIigFaLWnXUCl4rU8vzzqDrEThTdG9M50qp1Cb07UqWR0iRjs6bHKDi9zFZpr0qks4sGzeirPf2OIfo/XOYwbJklBo26yVLwNRctD8xw11b8g5VRDaa92qiRi4NBkVhPiQUVGqRJGRHNhmGoOEFEBFCasPIfzx81QMTElS46dSRg5hUel1Bl1HDhsUWru3db2qrSSUbqoHlqrZZsgfWoxHeXxkjtZFx2COFoarQmI7SSKVCNAwRKorrMHUkk9zGyXZ1K1JfU62etS7NUgmpJlVF0xZa0FUuszSr0lKUy0DZKawRrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfeiEoDWoNyx3CJRGstblwh9yYNZe3DbEIkUa1JuERYHxy1GB2UNaJdXeCR3iF0HBrbszEbohHKNYDbrH67IUjTBiRY1BbBoblcqYcTFpDZpp+Nppsol8ovui+5AxAINsFMvJvJMytMV5c4Xb0ShAwjnjiRxBxdC4hhkOWXx2h/zdIjllInxQoNjokwaiIxC0ILmgF8PlGGPozUxEhyiaSJAznSo6RWeRhePopVlgf1l6o6UigbekbIdFS6CLuTsvOipisWyzTY1FuHEQEgJpLwskXAQYpOUUiSF4SpDXJkmy6MuSJSeQcvFqoxY0Uep1qoOdqTRO1tQSSSRvMk1o1HjdSN6klOnpstlOowK5xJddlLqWpKizMfmBAIAAD3YY75kVG42Sq8emi6VU8O6pu3siRcXyrRG5NQEjwpxbpZZyModYXRR2NWINKgM3RU+6SyKICRyw4QVDajDKBGOROwVreHpKopXN5GJcJpPKJWBgmxsMxeURVDhWUxuJUyE6NgW0TQS5FaE+TUN2qNnUeUbImpj6ZkXDRmSXU3Wz31qRu7H7XWhZJJVMeCiYSz0DMcZKsylsNZOMEEjhsSh9egbpq7orfrp+g6FVa6K9H0uujbWlVoOqvUpG3SfWci/dKPFpFn/ZgApBtZD1KzzKwF1A8YykfYenR5YbITzcijg12RCAUH2a7dIbiqwDUpNUubgUgTJge1onpv0cR6puTnR4oAiiIJMBQ2msX7j3M2pLNEhsZLUlYSwQIiQbt1cGFDhXgcggQI0BbbsADoIceR2wYWobne7Y5xW6t6b0/VsFip8yTKpqm9ZaRa5/zvHz/T41afFq7xjfXavi6l1tuOd5Mw6fuIpyjblT6tTMfrC3+C6U7y8ldyKeLB18XeT0xjNcbzXP3rFv8b/xi3tvX/xeFHtn/4v/97/+P5W4i2rRQCAAAAFub1l+QWij8KHbTVZNTij8eL2OZUUyX9KRz2u9SQQ8TPSILH4dhvKoOC3PsxliuDcl+KSvU8xBkUC6oZKQWPQE5VOICAAdWWks6naWTJy2d5FhZgej6COGBfKZAUVxTDEQFIeNgP1FyF4iIbKIImhSUxaOkNZk1JFl0Ek5wvGyk61klMi+xxR1L6LMrmxukggtnRZdGzucdimM4UTIiSRcJoXpMGaVI1WQ5JBnJoyL9b0kEkn1ps/VRUkq9dVba11o+6zE1NW9ldTIsyNRw2Tbuy15YfItQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAILn7Hg3vDcM0OiQBrUm4fTbUcFa2AA34vI0K1sAFE6P2vjkdMJHylVmoET8jUpC5sVokYnGMOy7IoynRC3w27kFvmDikSI4ktq012QtgYO2aVxSWw8VRNBezfhpShUyqxjII7rBn3KCBoBAAPC/zWIfiUbKgK/tNXqTVeDl7PBBNHckz9pyO880gbg8aV6eC3WQkToEcx0EJcIaZB85RvBnM8p5RduSilmNcsyC1Z5QW+tOyp5y93Keu97d5qxh3usKCVVv5ZrZdt/h3O9FZfUpuYx+EO1KZrLrCIHwajZv7n4rLqaRd1AcDNtb3yo79ycwxw3DGfaut41KXH8t/nf/HvN3d7xy13Pn/z9UlNzW9f3Heu/jl3/39yvZ62VGWujjxt+Zylxu1gshK8N7rY4raEC8rS3ZdX5Khg4Nn/h1/aywgGLqQkrq2KegaJKpbEGu4ytMqRZZ4zTZnaEYNwjHh2UsdbeGEAzWb+6Wcbo61rCwblgzNTM2AxkcJbJgcsnTEzGXJoYwcZEhxCfSiQUUmLgJ8+aqNyyXFVOkdM5mVp4+iWXRzUxMiSY4geVoa7IVMnWt0FJKQTXc2Ljo3PE2TJSN0ZHlxZPKao+aOiyzIgp5DnFO/T369NepV92QsuyDr9Zqz4JSbJZYa+oMtQSAASCLXZsBCwJTP0PL4JzStbDQBlQYk+lfElSIqJumBEZyx+q98KBdLtOoZSHP27MBxqHy9xQGpITTZsomFhFQbsEzqMz2DIUje7I0AhULFhVK5/jCQKo0h/uUKmqJT9T1HKXkadPR91VWvm8cGw1dYjHoCgFTBYj9spUGjTUkgGhw2/VNhcsNCo4auzkbpsK+uY3cJqatV86V/aCR1/uZbtbz/+Z65zLv/+GVb6tivluvZgyW7r91j2Aq1qXU1I5VaN18//leU3OfSZRec7nZtyyT/l3VS7vH+46x5vn4Y3Pyyrf9j7wmFwEVEZEk5ySI+h6gpsnVPFZHSxN8q+UBrwQmgvk1+Zaq/saBBMwoKTQHH7qlAiRhcaUDW9HMRwCFhgIGc3efyAKCAXe3BCF8bhx+4AlGEPoT08EqwxBAwGYGQEgOhYpqg6BgmDnLvcltOvCTXJN/aGHYm6AKFGDzD7YSKXx9S182qyWKyVqNK11S69AU7nvVqcx59mxjVrV7Wc9+olU1rC1yhpLF3l78Mv5rf8/+454Z9/VbL89a+/bvY5fqzEc+2LN2MzM5hvPHK5Wx5rPmGOOv5XBse2OZ5tvgabf7Jcov/EClu/3hzcvoXH79fLVz3X4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJz5BKhlKAAJjyCdTFKACgRbsiHYwACtGupQOe8AAQ06LCUhHoCAQgKMwGWBZ4ARMDDFgQDBcQYmHSBjDAHckB1g+4DQMLlAbdsBsAAbsScmBJRzBBMDctwMArDAw3SWLRXDFgZYGwO8DCkQkNFzgZIUTZAAwiHqlomiDCRDLkDFcDOwcPEEguSUCXNzQYTEWHAVCQHWKXEPDlw9oSQqB7xw8s2J48iZh85HqLjHgwkNoToFgwEAQs8CIAYOd1JGCZUJsiZkVDNRRTAsICwYkAdEHyixm4pAvqVqbUkmVGL4uAcwghoOWS5XIeHKitwuQFlgwQy+LiC5gOIC5IuddamTUptXImZEQTJssGhZIObFxbpLD0A/IMGifxJhHAzYyo7hjCYHCbEGHM/1///6ZmblRNOYGldBNNBBnUgmm/HPI0mCKC2kFLxNHyBqTNCNPJp0VF5zRFLggAAAAAAAOVLscYHjgVVDYYFWF7guA2FA/QbA3Dwoa6Gx+LLoh6GlGUflSMgJSUIWPGRQQjuRi4VzGtUuh7IhZTzzGGxdXSuxd/KHGE49Lix/N5994qEI2ICx7Dwz/9XM23VlHhckKshAWf//vbRlP/ICIek5wwUsXKISnk5n////zz3U+Yzef8z+eSnEDGnnsazmGoi2SqfFx1kymHRpXUNCfkODOUcS5oAKZJl+DG5GowiOXQcRMJvoyh4qJFcOKESVCCUGdSwa8UxYwwN+mS0sdemBS8quVixZsTJpPXf1tRRK7WvQU/DSn65lDrKYzDK7Wuu7RVo07VhXtqXUszZxrPZVh2ahqPX479qpZq5zsSYcnNSxKHn6lVM6LLWuuFD1NytWuw7S1aspu/UvyqVWqaNRatDUahp3pbWf5/n+f63MxmepYdlNiNR5nTWnVtWJr5S+s5u1clWqaXdlNF8pltXdy1TU2Gr9LZx/LLHPHHGtTZf/dVceU1N/Nf9Lz61rVamrWqGsYuRpOnpM3////95Y7lTScGynh9QYspAWxy2rK3O6JDZl5SxkUfbItKxzV4kqHNzm6a6N7jaCrOyVOl7i6hTa4hRgKZPYy+1xbxYvvBfPa5zXV4VTan9IUaM3NcWFGtC8ak31Glmo+vBk9n0qdZXr5ic2F7FTrLSL8xG/WcMVI0JmYldvOXzEooz6NCtLPm2IU8KNaLJfHzrMXMln281esL7eavXsWtsZexYtQ0DITCRYJrASgael7iw1IiKhtoSLUpS77/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB7xkRIVnQALI6liwrGQAKrJBLFk6AAJ8yCbDBKAAGRoFQEERZZ5k4VjNdJB9GVbKAQxQE0gcaFBAqYiu/KFAFBCRIIQg0g+6wTEz4DC9RigIcEQ2l6wSlqsyrWRqXMFLerbkza00UJRw0CcJK4WAGKEglfGWLpOROHnghdyROSya9TwFKo1BbOIg5ZnTyOEOyXGtGpUmsuiTspb2ArUujqgr6vtTaqPzSqH3aK7JpBaxksSg3bp77T2effrXJQ6mFeAYrvD9b5nzlNa3e/9U+dXle1TalVapy3Ds7yXVsqalzncqazKc+TPc9Zay3Z/G7LcLn//Oc//7j+6t+YhJ9SbpQq/jwlX2raY8W5/Pof7Jv/32eaicvgpy2ps7HQjbU1ZbGZY7UNrojMVYauZ/mIIj1VaX/lLBD/Ka212Vuq9jlrOt0bgIq0imcplNLXfwKDJBsuctBs3EkZW4JUJtqEyChi8TsOghXDl6Z7ypHIw64Q8/kmmLVu3DaAWB8qavTSfdaXWpv+Z4ZySturZqZVsq1nGK/dt444fW7BTNrt7nedwz5+WX5XLuOOV61N5Y1eVsceYbwwv1d4YVpmzoDgo4FjRIYIAqKEAoCj2SZ2DAqlaSp1h1NLUu7V09fQAAABhgNAnhYUxMAwYN4myIigwsvAqFFIroAcwBpCJgQQcAQAwxkQMHATAP6JoGAAocBy0DmoySLpWWLAFvY5hBANkuAl2DE4akT5YSIiiILjUDihxlsDOEg6UAEmBJgBEEcPTYWbIoaF0mxNxOhawBmBgIAYW2BQ0BIocJFdNSQzZFhsDNhaWSwpcAwMCJ8QoG4fAc9EBmEoBzZt+miJzKY4zImGIGRM+A0HAxokDABgJBhc4/AFOwBAg5y91MuguTY55uUyLm44C4aDnkmFw4WgFsBggAYADCoIggZ8AwEBYIEQibMtSa/1S4SBvGYJgnDcwNCJ0ysWg40CQUG9At5AaKgsLC9gIjgAxsOQDSQMSBBsIAoAAwZX////yfHs0L5PmZPzpupae7Wbb4CwQG6QIRInoEQIL+hoYgsG+hv4zQrUYYtxIjvE5itCBmZACLlMmFtnM8WoCw7meiyLOY9VHhMYIw3MFYahWNQy56wIBbJDh8QBSmuLxGLExwXhMDWLBIUehLICSo+jcKQVyAnJFL/kzOXY8LgYEAAAAMBKFN/z1e3YWxFioRFDALwoP/1PdVcwyfIShxpEIh4NBENv//Jz3efa/gUBaLhcCMFUbCGJXFYaDc///////t//85DSc80W1MBvFUmUqcpY9zJ5KeZwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgTkE0GNmAA0bIJtME0ACimQSoZSgACtsgmgxTQAB4DuHoSI80h3iNGovFZSBTSovizMDIkhyig6iNC9YuMG24x4ucAQqYnMXQHJ5OENEZCFSsdGODbz7uPoUwZlimOaREcgjRmTUoCFR5MRoBxI0RpE6MyNEwTSL5xAkS+XSHHRCILJQbBIWXBaCBkCDbFR9AlFls1YuFg4aGROjTFDjkjOhto8CFSIh0JSIkVFlI5rRNiZNad0hAYZIbiAzwZGMhygukak0gZmRukpI3U6FFa1LZ6JdGWcumRFimRhDiGkiRxJEVEJhz0UzFB1ptSRXpJOaOiilRRUmgisWSTpgTKKSzqiZNUy0yzFSi8Ys6KraTIrfdlaqv/6kWW6NX//+QAAQQCAAAKI50ODUczA2mcY1BjCgRB0EHSGBH0mBYjEHqTCceHGdNTYOI4gwmY7iEeKRWTSSRUVF9NZiWkoO0nD2JEpk42SKzA66bJIjyHaPEiJjlIqZONUVF0ool4xLiCSyozSJEgjxE4IpKmQ5jExMCWMTMrMU0GXSQcexfGg3JEeSZAPuXDY2MlqNVJOyZigmpJ17mLlZdNEEkkygaIqZM6dUtlGRsy1pMiqpTWRerOspJNEnLUZJ1IuktI1SstalttqZJ77N6Xt/0W6rf//xxmwqQpAzAiMFzDRDfAGjAGHWgYIuVCBEXSBEcAw4EnxnQ2cGweAC1Aw9pYb0KoXAAMIGbA1gYDvPwxeLGO8fkiqFlAaOHLgGHQMQDBEsBEWIqOgMQETIkO4P0DbxeEEAzI4IBIkwogoUmiRJ4ri7Nkx2E2O8OgRIwQRAsFK4g4P6XyBnjM2SSNQ+MG/hv4hcWMfAWvAYIeIYAuEIqGoA4UmtykfmaReEHicCAhqsY4WAnDpcDCweIOTAqED1hqkXHOGPMmQWkpdFI+LMGQLg7zMiZTLDDsPoFEhw5xEh4FymAskqomKJ6tNFJN0qJkpiCE2YEwaHCJsXx9jjQHMLJwnjU1FmjIDJjiKA5Q5JGjyXX9CpOrfd9/83N01miRokaILPlxI6o4gYGRqm5ovkclL5ElE2UEjU2NUjY2MVqTQYmUkkuxjEZCKrMXFsMAJjnQ0RZAyZgdFwJCVi1Jw0uSABtgS40MSVV3QIY7i+QDMxJRdkx6MoeI4hhSwyYpJUUThSMDxTqHsQy4SpLNZbo1BVCibkoZpDFGsFpHgMkWow1KlT1n6I80kGUxSKRaPYvHUXXUql+tNdTKUx9i6k55S0lJO6v1X16a31b63qXT0XTRd0kDD////+gyC5umboFxkU//7H2TWpZ1jJFFVV3U3bwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI43lHB2dAArBMeUDmSAAercUWFZyAA2w0YwKfkABdMFqCugCljOPMpESASJKiZlBnQ6eCKqRw3HzscrBmgJqJzEwcCjE0zTIQMZMjWPfSCDKOhmyBjyRkQiaSHEWGrmRRa60xlLNmnLGXKtWuMBdy1wHrAopAoiDV7cUjMWo41xZS8rsDw66tWHWsy2ZCwaXsKam/MWm4dhlYrhRNyIs02mmHla0576Os7bdUAqdLLpVSzc1JHapJdT2GctdhllNFALi9+dkTmzszQZRGQ1YdlEimp6U8m52tKa2Wp6vevyp3pU/zDoepaXDVqlxsZfGYZltLZ5nZtdppdWjXca1Lczwyzs1u4b/W8vs5Wd7q3Z368tjVNTZb5v+ZS7LOrZx3S5ZfS47q2eayyrfjS4gwL+/i89eChBfX8ba7zJgmPkqwwLg1WcHkAoUsmKyAkTGMD4hyhdhqkBkiNICMiLNHkqDnkVLSkSRImZH0D6RuXUkjhHkybF4nSdPLTWpxJTVJJSU+oxKBqdKpkbUBjnWTxkxOFdRcLxXKSJ1ZdWbWZ0JiiimTqKLLZloy6XTyJsZLRLpoXjZaKKT0lO2XUWROJsXmrNWWqigj3dFnWiYomrVOZF4vJJa6KNSSWcRdGD7x1edFCsXR9ud/Suldq8kegdMaRZjLgNmElwG9ZPFFGG6OeyAv9IU9mvrlL6g4VAaBA2tk57D2CuozxORExTyzW9bm0t/X9jb0wSutgiAFmyoWSF0D4JQ4CwVmH4bm5XGa8Gw+LWuQ/kCSy7GI9UzAQb5T8rcOC33dZUkSnLDNIo7kNUtBSzNPA7lyWhvMPaXJ5dYu3KWGYnRS+fl1FTcq54XHgazftxr9XLN7DtbK1hjepKlTLKrbtY16vM/vxiknLGFmiqUkbjcrp69vt/G5vHHf4d/Hev+99zu/3zLurXed/X/3eOf/3n6/HW9/zuPOXwuvKn363UA+/oUggfNracK1mOYcZ0nABRIa8LkdaGMrtGrEdlD/rFZakLSCoBiiA/1tKaWxWDpaxB9XllC1+wmL09+Vv40GH5TDLhiRVh5iwC/8pp8ZdblEBjVcu73VJLJZYiKd9FL5fD8/R0yLszG4jDsVmpHbpKz+0s9TY1KWG5Xfl2+286GX38q1BOSi9N1KlmhnML8r7vHGrvPO7TxiMSzDnc8dU9fePP7nnSVMOfje/87uP4/rLnc86+e/3vDWufzff5lhhqxh/Mv1+8e58zuixBihqxcoF2qe0BicL6GILge/ogmbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACByQToZSgADckgoExTQAId2/Hh2MgAM5LaTDn4ABLIx5iIwMiHkuICA2KDoxSI+g2wvhImBjGIlEVoBpDQGYNAOIALijUG3gDkgEiYjABC0DPngo3CEAGOioiwAYIAF1BCAgOg2PA2JLYfCM6To5IZbFLjuLBcImPsQGFpGVJ0nSmUlFozMDQc8Zcck+YkBGXHybOYlUukNKxmbEgM2Rg5gpIQlFyieRSBgbGpHF4ZwgZBh3E8ei4DA0NjA0IqF1IXMk+5u02LhHmRIFE1Iw2Mq6S5ogtzAujYLiLEWJk1P0ygtJA9TTWuaJKQMzM3LjS4gyaZdTMzqj5eLpdRZakVstFNSTq+pJ1IMn9kL6b+r5sgpFJKtFv9JFGtvfsvq///JRCAAAAAAkamGkROQC0w/ICQ8QIBVBaBXAWhBExJgyB6D0AyQvQmZKkMnHgvBKMJKXxMS+bki6JfJObukZjuNSVZRdUpBOmapmqRFHax8yPMikXj49xxlM8kgPIlFGpIEoUDY6oqUXiSJccY8xMEGNy4ShWJSMgf0yeXDY2RLp46XRyj8SxJDnHubmhoaG6dljwGwjImqK0DBZqgiZInlpsmi1BN1vU0uFw0HuXyVTdE3PksiYoqfMqzUurYxSSf7qagggm9kL6b0NSHkkYl0upGyVFH/UtFv/////f6NOQgSQxQhByICDJBeRFIdebihQa7ExSDAjitYtiayJmxCBMbNOhsyAlhxgYLFmQYI1zmdL6qlQhWuk8slSMENaeKAnWfdlyDUUlDZVygAQdMdl45K4sIZSw2WuU7SnVuvKIGeGdlONVrUkZUy6bdi/9K0lgLNWGxB/26zKyS8KgMIrwzF4y4KAZQJa0MytlsVmok7MZgHKAmJKZL2szEliELhT61ZtrtNdcFxaWAp93p6pVwuylyXdh27WrwzDsMz0qlUulrhOVGpq3fhmHZ6GYZfl3Z3Kzrf3sakutY1ZV/1squP65hvmeOP/r+719a1jjvDP63MqbmHcqamrB0XAoSJCAOiK5hXlgLNcRRcWiQjrORVHyhRbWUvomoNFDlOJsxVAc6zYVQs6ZShiHBDNQOqmWlAzVSwIqtF4sxF2HKkculVqvTQBOZclzYYzJ/pcbNXdTsfUps481NymHbNqJWJdWtd+Sw1frRKHmtU03SZu7GbDsy2CnKf6rdlMZjMtltmgf35nGdppVTU2OUai1mM4ymxZ+9Eo070ai3dfTWrn6rZ7q4673C1WvWpTGbmqbPdavS61TZ4/rHDVr//v1g00EGWNf0rFi+5bXwuqgoKDffuL6H/7r+/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAd2bsSDOcNw1yz4oD84bh8Z2QgM7i3DXyqhQP1leFuoazJYFTOM2E4AygBK13iJIzgzNkJwghBOFB573SixekypTSBCxIQAkmDB34MUtLCYBALKLoOWo8VPJAx5AG+zvT7TZxGMmIkW0pDUrEYxMhAMnkV92p6XcawKEwiSd3O55TTsiAczSu7la+WqCUlG7udmPT9aDYZxjVqOSmApHDtx/YtetSSfna3H+i1aGpqgpsLNV0ZqxWtY6rRbCXXJVbs2tX6WU3r+617cp1u7LcK9vGtvKNXZThvuctlOt8y/dmtTZynCmpd75zLL/7l3LPHHHWv/LPH8e7x1laxwzxy/VrYapIi+lLvwLu+l3BTgf4Ugc4tIJo3nApjkFhNwsT7Kzpgs+fuDmuuquJzVMSBI4BC6rowAyd0GXRFQ53X8SwiSQk1lPYTBKQ6kzKG5m2AyomKa7Ashu1KGUStgoLOhU7um7Xt6pQsWU0sJqVZTLUC6lDS09I+09WxmrszKrlLGm41PnHmrU1NuhvyBwtU01GsbN/HliF2L81ztSXVcKtirVtVr8ps6zq3Kl+l7vnd93Z//pu/qtTX8auFr7WF2zl+OP4547x1+WXdd1rvMt473+u85uqVDQVBVx0V1B3Yrf9A8BEkAw0maxQMtB4K7QNcJOIB5EYYRiCohEIAWvBgGmmy1YBLoEAo4FNdTXChGaiRrvMCAUVICZc7IOLAAHJYoNJFv8BgyRaf1uLYxljQCsOrJznNkS+yJVRwfqcXi1OHJKu55DHxxqzuzkyJkvlUfIJQRuYk0Q1A0GXAzz5OFsjS0J5LZoUiVFLEkZFkN+JUQVOObDiNiJlwh46CqmMsWi+PJ6YJLSKoPBUJocK0kkSapmzF1BJI6UHWgxxNOXk7pmJqaoaDoKMy6o8s7rRWp9AzMkVopKd1MyknSqZBBTJO1HUktdFtJT0vRSS0mNoCRjESLL7ZvVMFjXG2hJi2gPIGoQ4vbGW6G7Tuvg/0eZhBUvXAzlByCBUIaMaLnBIcw9sD9OFTBAbCG0XEiYSLF7FajnaqA4OAs7tsNCYgIBCUdHRl+1s1XfxfsQhBPCsMAW422CcpLFkZSkVjOltXIqi4/cxMvrOROtNY0rSr/NTFInZN6zqXpXUmZyNWlgZBXu/S1tfOU6zr1PWnam5y/crX91bnP3Wtay13G3Vrfnl+sPsWP1lrLG7rDt3y7xCIgGSC4YDwIDHg2Aqw6ZbPCxIY8i2it5vbb3m4ylK72IQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHkFrBgxvDcs6reFA/OG4edYkEDGsNy6myoMDNYbksDQCtDBqgccM4W9FlIjOPSQK90OuSzKqv1crcn5m16mUC5cwLhRiQMaScEQc0tRO6qd5gcRkpNSNaIj6sDguFQG7s3DZhCKHGcsfoLBZ1RIYIRCyqTDjlwlPSLqx358GgAWBWXu9ykqyu5TuiCNL8hb6R2w99hBiNyDWc8o5MUlO/rFbeURZJFFgpLbfBcL/RmmjVyKeyGnmneitu7dvZJKESaWCZZdwqfuV7q16+Hcc85fl3Vbe95YXM/taywx1zVnmdmpzeXb/933l7LdirWpRGQw7dLi+RSnQFC77oneJfUy1rr0L+VSfb41VfP/9NlI7xjXQZxlD8P04VXRRmK2vKSxXWVCpQuPoWHg9UgjnN1FUUOtNxemwRGunImlB2brhAsi5F7EtYiUHvPXJQjnpHMikcwxrUPrQoIhUo1gTjbh7UjwxvclTxCiXdo7PK9uClFoRWwpMW4bmrtNKbeso7tnf5yrlHOS6VWIO2vK3ldvU+W94QarBVxrTn3f7S5/lu7u3nnWuY6ucu55ay/PuOWWOX58w3vXN73/95vHDL/3X2hRYLgIVW8HiU8cQYgM+MOPxa9adT1dCm1R9orJRUSwbswOpVI2ZwUXNaA7z7QA/3bEaiLR4aT5h83oJfTExASNoUKwLuKKOrVi5iixUPIRlQKEJpeYQc4zc4EnaNVYDfoWxMhPGZ3mVVD5gaFJPKSTiYonw3GDGUgoxQ7hyel8rmJ6ZOPWu95K7FJNs1b2jjEj1PxPjszDQ4zQz6x6r75Sp/33d6m72nf+XLIjUdZjKaXKZzzSmLTzUFzednuGrkXtSnGrXzq5UuNje7c3erWctZ5ff/fMtU+sMcKtvHnLNS/nd5resLH83vPDu/3/1tCiyyXh6fT09uQM5usxRgifFrHm9uJuN17bBCMfh0+g0CAQw6Oh6OE9jQ5jdiWzly6rMyTFyoZByJkCeKAkJDvXHUYnXQ4woiZsbkRIFBTqNmJHSyMy+9EgYsaEzuSFUSa2EQaiacFB6p3Iac4jWXXaGWgM+2h+BaOu8cp52WDQmTz03hhhTBR9v7NyoyOYgi9ba1eu1Ixg2tFLpK2eF/lVuS2Vq22ttjl9fDGfjqnRWqMdgu9Yr2tR6nuWKOxyza7unu6wp7ti/zVTfPlfMOU+WNn6vLuePNWLmedXC5j/1K+sKX9Zb1d3/83qvlnexycUHbJ2BdW0NFa1Dxl2GVWn93N2JN/Q3x/dgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABxJeQYH5w3LTqjgwP3heHLWPCgfnLcvQO2FA/WG4LoW0epBH2K+kUxBh2hXxNndl8cj0UqThTo/6woVYPop0IaRpdYgAh4BIsCJjiQ84BnFKrsXnbkZvFT4HFSyVEIZLEMqE4qEhOJ91VaqXcEtKYqEIwznqXYvG7eE8B+oXzVLbicviJMJzv5jcdy5qW0TIdXI67FyNcm4LgKvSfeiDbU0zTxutK6meeddhQkuxRSXPOr3DPP6e9TX6beU33ePb1zlzlS7utdvZ9t7yyz7jjhe7nSbz5az1Zy5vWH4ZaqHrynT4EFU1JfJk2pGC6MrL0r0rn4M6vkF99fb3uevoppQFhEmKgnYspOWxTpZ9eU4bxpdrZa08Cl8fa4IQF9QcDmkH64YPTlgVTOwYuHiEEQJvtDcoAQVTQ3I9YCIBDjudkwhATlzoGv4kc6feBFgX+j8MQ6FEguTJsIhhBUzL4zFhBVb1NEa9aVWguuWyq/Xx3CJdLpxdWVabZVXUp1dv5/S0247LPZn3KrZ5f/OtBaC0v3IvtW+42rv5b/+fY5nzXbP/zPHPms/539/y8FAYAKDQLi4ADAOBljjcMjhUoweOJix4WpptSyBMUQ87Mo0MIz/WfAtxfS2FIvYLYQgl6PSBcDoWKWN948sGRSYBU7cHVSlQxgSLTk41qHQgZmakkhBOWUkgDU6OPSWQjRyOEN07+AuEKPBlhbp3KOUw+ppRQEm+r5rz+SiW15fL3/smjI9mdJd/ToIEM+2KScl9Je5Dj1Z09eO1Mpf+TySzDmc1Jso5YzlMnzzxlfZUrFnW/PmfccKmF36lJSf+VTDHO9azrUkYpLGe7tPP26enz5rdPnSUljeFJSSjDOnp7+de3vP/wwzy5hrOnp5/CifER145q2+PqXtLAwwEGR7Xv2ox3X/fD9CHegRCedE4LSEyEoEwE3S64LYXBoziebwsvnZRFEyF+xEYPhDcWBqNRjTaw2ACDSkYnUeZrYiDufaj8jqCgomZvvF1AQf4MNDS7S8jHFULDMqz+N2LuQFDFJuC4/Ac/DAiI+cq1VvXpQm9nzlJSVbFmkkDe451YFwbpP54U1iphhKZbqGLe7t69hnnnH0gKWgx7q73DljHPuFSkw3Uvb7rDDH7lJSYW+4bz/POnsUnK+cxSUmGEohh/IxhXp7e7dvPPeGFivnlUpPr08bpJRhvPP/1bt9ww33f7r09veqlJh+sMMMObzpKSw42D5imJDlYfcoo6cmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAc4ZUQB+cNy7Y74UDM4bl5ZswQMay3LvbWggM3luU+nyAD1j3JYljMaVArCnXaEn7EXTcpe6dAQG2sTTkLqkQLAUGF0vrLn9lMHiAFhacadyTrLEAVJCsZYzlhkth6AVZjnVa8lCyLKROFKm5uS4qi5EQ5V2GXZnatSalIgPEnazvYSqjbLTZZ4S9zKGhh6XfjXtPdl2rfzz1jW72tbgbHGg5V/62UGPzIZrlXuFNvLPDvfzpYzh37kqnaWlxoJ78+Vs8YzS1aWrc5ulpdWt1YZlVNXjL+u7LdVqX88eflnjrLL6sZs43LO6t7T/7aZo2EFFFzpegpwKhBf9E/E7//+Hf0b/GRWKWCkfrDuztVjaqlJOU9iAYYZtoAEQ1CwMWK7piwwuKbJQZSDAnhWqWAC7+Q6S/EpsTMFiLkoIi0MJTkjQh0G7G4vbMIJJE30zIF2u0/sPR3Uqh2VylwTB1stbGN3KG2XNhVHhNyqHKfdqXPzer8hz6TeXbta3hytP6y7S1rNLSUlvB33Ozx1nS1Ozsuq3LurtW7O5WbX4XK9Jncq2KGr2r3tygrT1bmVat3l7VazM0v/Wpu56tdtY63+Ou/e1cyyraxpsa1/e8daz5q1jreXe1aWlx13ePO81Wy/WWVr28Z9MopRvPpIu6KGZcaKSGbuFgwRKIKaI/bct3ZdHJmQxdpq008+JptJBo90HsAzsxC9p70L1lUNtHNCeIB6QS2A1HFgMNdZlEMS6QgYdE9vAMkzL5DK6yYizFrDmodb7GoYmhwackvC6Xctl0spe5lSZccE9tSiWv7L56VV4/TwuXU2dmfl1FEWucg2ajVeel1BTzliLVVbZ+rQTmOFTl1eTB5dRv5e/Vaet444dz/H+X/s91TS7Onxq6s5b5rC1Uyyxq0Ges/q3cvt3O8u4556uZ5fzDeWtW6uOX59y5Y/WOf/3LHeP7r8u7X4AO6mY3vKFQN9h6A6wgm7uv7t48qGBkOAnqB9GK2p6y6XUs7DUahtQmZVgYwOj65kIzKig4EOCA9VdkTT1wsSGRd/kLFPiTtA4EDJrB/ZTcCxaJDbkNqsAaUPqxCWot1MKhRaZKoJKo4n+Cjxm81D9anfV2JmVmTs/0Sp6WkpIZBqUNZ8wlL908Yt+xa3S1nJ1Fn6rYxaRZXar4udYblSYuRNTmrl2y3UuxjcldndXDV/DWPe1st4ZZ87rn4bxx7zvcOcv1stcwz5lds7z+3fqWLFbH8+4fb7hvv0uPf+rvPPfeb3h21ZqfSZ1+PYYLc7hkvpeWxM7x7WpOWj4/a2n9Kd0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHJHRBgfqjcusvKCA/cm4e7fkQB+Xty4E7IcD9PblDAsywGAp1MwtTCmX71Rvm6flN1WWtDsWU7AJjiixdgyAJC6tE30IQUUKECqa3CoVBJL0InyhqL2IivEOJNdcVDgaxOANIdJTug+jQ6zymcnsIollnnldGfJspEuXR1gITjNlIcVNQ6hBYb1EiRiJ8MDQ8saBfM0RvolMoLTFscwNDNZPJnTKRYlilqKJABaTAg6LLpGyjNTLmxkgkTs2W7oZxjZBJVSVFaZnMVshOIKMTRMySdSSbu7XMGZS0qd2eyCTKc8pBBakUUkqSkGdbqUyabG7dhYbZsB+1/992DWmsbURlSOc0SZDKMIvqkV6lq9mxCrx2UyVr0bSbgkvirZAAySnasYGT3BRGYWlrGDLBURAJMDrDiwdDyB0jina1cvoNCC42XoSDqBcxIrDMMRDtt81UmruS+l8ECABJms7kKJBi8ZECH4A2A4wYpcPpmpYAoQsRVRMTcghcWUYyZNIoDVRH43LZkWaCDj6KqgzxlihTFB2dAS0LuImTJYUty9RdSLmZolN0F3PpM1SaSnpvMVpuuimcRTMEXoJIIIUFpPQZTIqQWcZBdkqka0Fppon2MkF5oybvQRWy0NGyq6qDHRwq9RlRJBQpgC+VTh+uEg4KcmBWi5plyL4fQ9ZgNdc5dEORt9HViwsK3VWOjTXZfEnEjcXkym7ltNeMOwcGG2uQG/csqJGN9KKJ2ykIkHZY+jswthkqaRMP4/q+Ym6D+nmShOuSEKQGUc7E4P4UWcgrQ/UitOtmgq9rZjoP9VNCHnYcigU7t41s9YVXC7FFhMupJoTgr4yivM32cz8YWfF2+0TECl77xmFHVje50jwKd+vNCvgRbUxesNnvv0xulbPPAmh5hODHGZKyRNP8Q4yslhOmDV38e99/3fv4+b7zNtgrHxmE8hs8DUel7RWTWNR/mP8av8U0/2kYR9TpDOTv5npgbXR+HAnx8GKLmmWkvh9E7Ph3XmZY4EXvQJL2FRloZcA4KpKJeEIicEZCRpgbN3bXREXpdivI6kkZOTAItSsqN6PHBRQ2fa7Cnok0cwnF1AYzE4MjKPNxwV8Cct5cVEyP41X5VIyO2MqvVTJdvc0Ma3aoPNumbL7gavulHOGb80dg+bRmSU705HzDjP2B6r71j387yJre4Etle2QWfF8as/boj+Sb6/xm97f/4zumsa/3/94xjX9Pj33ulKYpApjOsfN/jGb3x901uk0PFd0viPgsyRTkZiwHfpFJhv8/+cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJ9m9J+5nDcrKtGb09DG4lQgEeDGHtyvI45JCXpblVY0aUEAAAEXticlXMFw2YDHwQ1AgfpmAYqGSgoYZFIKSZsJWGHH+clPBwTkbbTg49zUwxEEEEFx2sM0Aw627aWi5Yam4g+r+Qc8EFxFolO0Ceht036dStg+tHHngVMr10oBgeMXofkFmw88CvpA7+yqFue0mkkd3GesXFvNhTELXxAvgWbcdXjaodH/SJCokVYFKHMUuPq/T+RGAJLWuSKEv1B0QhtrEGxZ+rKKIOMWdacwwkKGOTyEnG4olYKCQEo1A4BrKlulEahELwEYDQgN91Ol4A4bNJhc8gZk2r3TadwydVRryYqn3kibksfZJBLQ4Q78MQS1Zv4S72ctfaG12NMiDB1eNDgxlq94ckUCtnc2aXWpZC2duOziGZHDEtm4DkbtyKxXub1+961XubLRWojZXsF92r2931G9tuff/xAAhL7/+je/OxOlySiJF6GGji4GeToNMLu7EKI/l3fUzvFQv6W8jNJxUaZZlokxMPGuf1rvs22Z+ZBtESG2yoIa/FBeKaUPh1OANjp7qv3UaG8eKjBDXlJREIZ+JdnB3O1fMjvZ8fFRwWDsgHLJmkduhFlBWHzOWZt9H8WF84seq3F7J+xFHEvgdPLxR3cjbOJgM1BRgNTfozw/RJBDEhWJYlmB6rpR2EzO41s4t0PTdfh2m8QEyluMEiJAVcmklwiBB6xFFJlMXanCvVbUtiokOKmimGKkZIXlVjTTa7EF7qZlvE6GnrnVvcdq7T3pZArQXodySxYRHL7l+nkWQhwUwTMZJB7rsvSIdB2GSD4IITglAYAc5dk2TgxEQEcEMCOAxybi5gtzTMckxYEoZoGcJGATiZrYR8y1ohClLeN8BvCPlzLGhyHqs50PPM51tVKw35Ww0BuFwWC5j1lgVFJV9nfKRDHOZUKSWdRn+caMZ0PVcdTp98yYxDm3uJD3Dvs/C4GgaDgpy2Gg4MajnUhyF8LmtvFAoDoTioiqxWMjJqGxx1Yc6vjKBQPL2bXkGFKr1e/csY8N/uE8lVbx5rcS8+sY9KRKZvu9vm8fwHkfDx4ZAQCN/8jvEEAAAADtwLHB06yF8No2SJHGhvIsaGy0QF4TpHw2DeHl4qQb3NL3U0SbFYZ/P90yQ4q3kZ8xrvMaRuYI0djP8ExOTk6NyAVgHAGAMDYrRso3tisnA2CYrFDK5GC4rNisLiQURLrjZOjTptpsj04jibdB5aSmvnyCCsfkq7CmZSkIQqoQ/rYf7fhCsgghDz8EuvcLX1umPP1DI39hkeq6M05pQpn3JRBnnOthq6NtIgbngSpDBFh7+df//m33QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACQh8SIU/AALBTvlEpDAA6y5BNhlJAAIGyCgTBFACpAJ8sChPs8GIl8Iytoa6DmLqoZKCXS6geGQStaMIhK0oaeankL4RKcbomEChFol3P+w1zIadFSlhscjrKWPsUV1FJl0ZRGWctcdNaNCpcqaMKiYc6y8EV0DlfkJAca+AlJzNdUKeAmG1ZBgvmwIKwUviAASsAwdqJaZTNipe5LteaCruLJUixKowJCU/LKVix6HpZBsp5dkEfjspsd+QQw5UP0LLYZlDtW7FNPfGcoXDstvVYy/rkuTBTjUM2/NLyWRqU341D0vfmJv7OSO5HtRSXz/cKt2SfSXdzViXQNKKtFftR6NXc7NNS0tXDLsuxgGWQ1nQUcVppuHqGYp5TSdlsqsyKK1pXFaCvZpe8x7+G8+/hq+1eZwVkMm1iri92gCAAABpJQvjiwzYscU2dc2/L2R2XPLE7ruLt44psJitho/eWkz21Egg2Mmu/1lvoJNySttGsjQglLpVIvi0nJicJItXhycmweJDM0B1aiAariPPduPLqU91cjWiTS7B9csmzUZ7Q7cslKRNL12bbl3bNXq7XkdMU+1eW4HEl7wUvP1gZ+aLoUj9uhy160TMLqrflpDdZYvzztFcXtNIeNLfu+ipHrF/z6dL2d/wraX5dbF1N5r8iZIdDE6y/2X/t36SPGZWG6GIZBxvDHgIAhYmmgASDAkHAzQ0ECYnzILdhiMDjQTQnBc5ExyxSYnsWULkIcmTYy4zYjEWIg4cqH4DwIWBCoN4BcAsgpCzAt8GgbByobKFz4AQhtANFDpBYAbjC0cOXBsYFkAgEMBFsQlFuGSDfgt+E4i5CdHwRArkMFwBcOGqxxiziNRHCI7I8QlJIplwTsPwhYQCJkXOQcZgghOFswNBKQZGFzDkDLCghzRcpASeHPFkouTLi5SQFbhq8TuJwKZExQAoAXAKXcqkVLQ9jlCtiPMCaIeQEgJNEkXjMwYvEPNRymGXELi4xOhOGhQFaDICdyuxAxc4uErLLhgKCFBEPNTGTIpEcoZopl4xMESwXkDIsnDM1cukTHMJw0Ni4VCfTdZfNycQQUXDQvm6bJptjiTIcOUal0mXMSZOKZIvE0dNWRLpdSSS6jhNk6ique61Ve/6BAAAAAAACPSG+m0KNYkOk+tiodPLQZIQcQh3chEHMHGILnOKVFxojjA4KEFDZGFznQPnOUhRaqIJCyrITx490RFGnMszmGgKKHEzkJQjHgQOCgfd2KVFOPGmE5zlOJu2hGf+yGNYrxqJvW+Wr9zf9yN//+7qVelJSo//uqu97f//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAileMgHYwAAvg1pUOS8ACEZ2xAM5w3DCy+iwPw9uKr0uQXvZ4ypbTMQsGWGeQJgDvP8ZSKmaccrnuR1YXGW0XVLKgaKuYrDSEos8l8kk+qElFVeqpn1XqzSAFMknUAKIrrgyJkWWhgACwPbA5SU5jYb0GsCkjEdYkqdZ+XoASlBmMoMIbISnOWBQ2Q2h52o/SxXtmJQzMw6uVoMScaCaN2Z2WwdQ00NU8Ew7Dt99pdff7j+uLbcWQ7lUNOk/rDZmM2aaLVIajMtlszDk9GrT/Tm6G9GY5D0alUZ4+ztO9Eq8RltNNRai19Shs2qt3mWNSmz7KaXlqVX/lMuy1lWqymM0vZTLccv/Ktj9TLLmerW8ssrWWVamxwjUah61Vx5WppVTWu3bNXuVruNXE6Ilt12f0+UWwhNcUkxMqj0bgCLxRqPQ3WWDaPEjQ81OVxXLxu716+jN8XUKGXBRF+FuMYv4rpdUOtGbUNy2qU5TmXSuvBP06VacsaGhqGvYtH0bUjM+sukKvSFGhWjbhMTW+cqbklblplgstXubPmJiUqGzWfK5yw3K1ltGk3GhK569exXtGJRJ5WxYT59ChRpIsHVnzEzbriN/vVrf+ta6rXVXsWuYOoT6C9i98+ta317W+dYrnWLWhG1FgaEomHHvK9eShrFBZVby/gpIqQwjjSFBUqqaNphrACs6hDJQJk0OoUHDCUPrjI4nSNRXm8LLY+9C2C9zthcRX0FQIyqHH6hxu6DTNQIIRDl8WgiJMlGTfTWSlQ6I9iQqRq9W3TRV65at6XDcW9ZVutM0wEHF5TFXdszj/R2rdlTtO9EKenhyrhBr82azjN2ZzKHql066sYrP1PfeuQ1Sy6OQNMyierUFqrSZUdarZsS7lBFpRTU81flVqxTU9aGqbGHoavV8MO0lNS5ar2t3rO73betb79LO1/t7w+zc1b/LHC5n/95jnzta5PZZ49q85vHf2f1jh2ky+th3mua7ld7lWIAAqHWmhczY9VpuC11FWRRlCKF8hpykgGK0LuxxjxbWSxR/lovK0rThRrBsTOo8+sIfaDMq7xUVMv+Msof6mlNLDSE5klWrFSvDLScUEL2qv7BMJlslclXb/UtmK9evYjcK7Fu3uMlo0tLag1T0VttuNLqW9j+Yn8SsWaNW1YOWLeo9IcZ9HXKiZvqLPusF4+lpGprMWtcZx7Rs0tPFxNqNmLTerY385pvOM/ea6xrNa4xat9xsiIXUARI8EhUAtTNTwEZMUjyzGocKpuudnU0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHXG5DAxnDcs8uCGA/M24a3X8QBmMNzBHB4QD9ZbiSJ6KmTAMagF1s7R0qGcs4lgUGvWUBYdVgiBW04zqu6/yQEExlN4wQGbwqLbZs7KRzpEwbPhou0i2+9SG6WkLFCkmu24cOg8wGihN1XWZs+1t0GJPsqkgMjL/TVmbpKj/UgXpFpba7jnhe5jQU1aG8ssc8aaZls7hDV6tPX87FjtnPdex3dLrv47+Hb3MbWN3fO2f7ZmpVf1GvmIjerym9bwzzou9+m3cprW+d1lzG5l3f6yw/OmptU2eO8fwu46yrW/z3zL8t7wtZZfvuvyyw3n9WxvIN++4qHxrVcnrPfwb+Tzum/z2KPtNxuROsaPG6EdSYtI3Tkemkvni7duW0Tg1HloogLAx6aSOFiXUmn1jEviitD0PIp2pViWztS7KlsiEEolfulX0eK46QR3s6sy6o708+1pQAKmRHLRsVi8aJEoE5FQ0Z7HBZhqsvHHOmyaJdKF1F5IY8wdMumJogis3SQQSPGpmukkLSKIanDFN0U0WRQRZE0N00mSZ7rsktB2VNZknVzVaF10DapST60TVbnE2U6kT1FRv5w2P6SSSCmUkmsxayR00DqmnSoKBU6dfU81h0Re4rSQEEsp0MAwDTFBDADBvQOSbSyl8JFA05C5pM+WSh4iuzkPLDrD0M14IWszZdOLDN3jFIsOokuBMBbzXmgJzrKIhCuGXMnfCTQ9cjcugSAFM37yhyvR5X60vJB3qS9G7VSw+9PNRSN0EJjcokdS/SXpfXrxGbtYRCilcvrz9PQYZcu1Ll7LGpUi/3c6TPG/hYwuYV7tak53vN4fd7c5jbt6t587+ud3OU+evz5V7T9x/90/cO/3DWePe/bkaRMajWdHansQRxxg92lt1vqVzn+/2///3/Pd+oTkoSfm6MSCY5dk4mlCw1dvrrOFpmw5RywMFv/EU50aYElS32/Z+5DQ2jLMcQrNR8DCKV/1bGosEC80iAwaydZIifCJ0HchkTAkhaJlSRx2FxmWK7nK8D6qOxROAAYWZz3H7nKmnjchrEpfuGJDHoEfTGllFmnltiBJ2mjFSZjeUzD79xyX36GF2KCdxmaklZrJpvVihf+NNcsZ27UYf+m3fpPmL3cpix93udScrfY3fuU+decldaMTdqWVb9Pb5nfp3fv4awxlF6vrVfPP6+dTeWNTHPO5Y1zDlP25et/vVPnX7fz5T2/1vL7H593v/1zu8+Z55b1hvu995r+83hdPht+1IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACEVxRAH5e3LtbiigJy9uWgW1DAZh7cwUvmDA/WG5SRvvDeL0JMTEvLELcapxpUlJCndV8yxVDbtNq04iEf9YZRUBpqvaAsldhAAHDJvpuxRLNH0uyISkdR4E2wgImIQQc6ZJhC2ZQBkhAwsRtJxI9FvxYF73fYoyaw2VrjiprLROk0mVHQhOCMKtYFzFoNaiqq8EmG+GSBmFdHIIEBiL6rrrnTo9leu04VR1ktcDKOU9EILkW1qaz6R6YO1vYF0iWxbtAg5bYXzhth4u1QYEBjYmRRtbVCVasP2E8TcK7Uf7ht/NKp1SzLo9VI7WXKNNuLRvcVFaTcLbDrXtGprWMYpneY9M4i0pq9qS298WrLbOdvY2zbjkjmlmfY9vefcaULQyzPqb3BZQbISJ+KGotsMk2E/haj1fKVskv4Oi2eRUsO6jkPNAYA3j7MNkCUcVdxq61WxhYtOJL2AlBjaPIYEYmtNzlrvR2w70Guyi09TbtquEeoFfy3BBEuuDBM5nccoepo5KTuNM+jSPVbWFrUsKjFVjblMe7QukcoUOTCjPFmVsR+xGSwwGpQsCPwxMsGCaS5e6mjN0k7CwLbhHmoyM80V+rHbU22qxPYVZZNMLIzWVqmliT7xeuGt4jqW9twde8m6QdWfxNt7m6ht0VXqyHPDgQ4UXesbvjVqa3NGub+mjUg5nrB9Immy20OitmZMcqjsCUADi0JYpAUU3h2P2VQxlfJRIHfjNFMFx4+/pIA0Ic50XXfhW6gJmqy0keVZTMrcJvkjWuP6mRA7DWuuQhCIiNAZ42FtbWdHOsOcpSmBsHST7JuHCRQX82JW5XSvYTNPeRyT1bRI0DMF9Amj7UsRziH8rrT/uFqwr1tJeA5UtBxST93XG4Oa6g7z9woNfh5NP8+3o+jag0dxsXpGhRsYvq8l3GNfWLX19fVq5t8f0tTcusb+q/eJI/x8QbLjyMHW/VcM44ri73Dd/e5f7fjK3KM/gfLcLmaKHKqIaSmU7cu7Vu68aKNpJiHEM2pwEgFBIhfq8GBzqwDtFyyAQ0FdxQ2hZEIsRay42IotBSd0KZzz8hgDyWIIQDv3FZaZmFiTwEPKJ6msXWuww3aXYDfndziEpnLt5qO8J+pm/N+guRKNY0udiWvHcm7WeENfSUDeTUl1x/soZwiFC8sMvPlSyWirTMsn60um5BJ9UtnUqpqstmKTO1fpZ2hnZql5WptWMp6/nLqti1bzwpOWqlSlik9EeYW5nDs9YpdWc7tWUWq1+Zq4XZbHpXjnZprdvD7WXK1LWuf965zWu71lh+OF7uNXf4XrX9+rZyHZb/vI7iS027uqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcyb0GB+sNy605YED9YblotgwgH6w3LgLWggP1NuTZE3I8kJPkicKsOlVM92l2qsKTCJLulCg9kUJP41tqQeFa23NTCNqrzIsOKgBklKgc5TWqbcl4/SJg0ehyRxk4ggLcBZ5BVaUwieaXagJD8BE2TztqWXpqzKZCEMs2a9qV52oH7rOknoGoqbKs/s/uYgfB8sZ+Vy/stmsbdu5H90Wc1UytS6tNQNVprWquNNy7+PM88u5RrHmNbmONLu3VyyqW7nd7/892NZ44477vWeVNrtvmWX2auN7O13W8NcxrfnjvHme93subzs2O/v/5WtdBsanMUMfNzeNHm/XBO2Pq/bW2ZCYjjDSUxXEZHTBHTRyfNKmU1q5FUPmexFcbkkQhNXZaIuQhWykmE1lHbhnxZCjnCEUYIHfEgmbxSKGYwKmChixaIohHzVkhseDMuVhdtYelZ9m/qSgGPNZiFWc1L45Q1z3KVYxe/hRxpuNbC1KK0hmZVTWq9HfqQrdqN5xOL61TTdiXYuXhjNW/wxyqvQ2azytrLDHmFnu8qPuF7mWPMf/VvOeq7v83hUprf7w3ja1h3uq3ctd7qtb5n/buOGe+2ufey/X8vXO1sdYfqx/L/8+5lvDLPLXMcd8xq75fB3YH53/BNe3e92Zr7drgi6JZ4haqZ1w6namRmk3P8jFAw++5UuCgeQRVQ0s232TJeNZuEQkcFUjcZjj1Rug7XlBUZOJOzVMaUyYOYLfGOU1G6V5uFLFl4gkBP19U2rH2+gFsi3btWa+bS5+xq9In11hctS6myt608UqjGVe1OWuyimpKS5STFSrlT0OOdiUc7V3bv4Wbue7NznJzPPdjWVPhyt+esP5b3++75+edvnL2fMNY3bVTnf3njhu/+u7w1fUeoDD8Lbd7ql0MCYSHAE5Vd6U9xS5RHNzi19P9/rQBZDSqhRpuaoRqveGqnkMf351+FDkKp5UMXDi8BNYLaDzN+m+g+Xy2ZAgwUGrMYQHR40Xqt00BUMYZcNEYvaQ6mSiDJ0oHCoeLQ4rbG4BsP0tIHJZBO05uVSoOfNAN2yBEVdI0Mx/C4AvuWDUlz5QKjHRyki4ogiIvVFwmTMvKN1InjQQkUqx+pEwF8M2WkjIzU5w0RTW80PImp9M3QUUj5QOzWyCSzJnWfQl90Thq+imoxdCit7p2Upk1oqTN1qWmirSTordSqRoxY1+7uit5/tq6LSrb3lK47rP/1v3/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHXnFBgfrDcu9NqBA/WW5dEacGBmsNy5e3YID9ZblsELwuT8PlFKpXPpWiIuGu7ch6PQZgpZBJjwz7Rh2CK/FmlNPlyyJeLGxww88ylhLFy4yS5DNgAhBYxI34W2YZslmNpBwIxKEuHZXLEZTAYKQyi9LconQUsutmiTnVce3tWFhL9DTW+UE9PVKtNMZx+U34Lylt957c1OSqvFK1SrhH5y1ZszfKZs1nudHhS1a/LPzOu/uXU/bvcrGFjuqXmr9Hb3cos6btftveG6e/jnlhUysc5YyuWOdtf3LWOVX7OFTdfdPrWtY4fq9uznvDHdTv/3L+3qhnpQtBrOaKrQfMymzT3raPZZoWouSdPl6EgbYSHHU05UqPSU0bmJEz4vzEGtwCYoNBLFxGIMkAlDbL6bo2KeFQ7TSZAKgQMqpw4b76SuU5oMkwmdhkkDG8kiJCTK5mQxZGaYZVE24JojS65AXKkfoK0rsmPk1yvN17s1NkRTmWa2dp/Yt2QUTTbNilg2XKUT3Ld+/Yt2eQrJrer/3tZyCYnKZj1rCh5d1XqTWWN2lpL1WYnsd1KCzYlM3dt0tyPT2fan7xwtZ7mbOOfZ3mV/K1zDuGt1cO/e5a3vHLHDt3LDLDv8/X/h3mGu3O/2/ws595p5wupny5JXWA/ETvhjDFpL8XuDcUgxHAsR0dJ8bbZMUcqV2MP/EH/kgKWtwgIkKGgYJizl/UNQgFFBwwUCmjJ4ypkFqniF6SjKEoEOZAKHhpmJdUfMtKnIXVl7Sq+Kt4sPgi7K+16kGalA99s1e3TZ4zcNUWdDyluyjeNJDGozdhrj+WLmMGX5p75mUv3PwLNRq1N5RLGrQ9m5VGq2F7uWqs5jlDVSrqX2rHLl7Cre+g+rnLcvuXM6ezucv2t093eXd0l+3hfld7OrzeOdevzWXMOalue959qY6zw/W97u1kEscjCvcqcHbcz7gHQOeM5AKZqkD32mEB/8uPknoxTYSr52yl/VbyLI0SmAKGGmQS1Lt+hGJZkqVGY4g1UUPEwjVPOjoRVBXqbosUvFxpZKYxGI+IyaZs7GGvn1HKZlBJgUpmGtx5nMOWnAQumrVD+F5/qWViu7u6s2KkG1BgOxWrztPNVcb8oe/KrlHp1r8q5djNfKXdwlFZ+M975Z3h3C87n17tfKpWytTeVfHHt3CrjlyV/fzqYU3Pq4fetWsrO6Wrlz86m8d83rf1sM7mVrLHn4573rd/v/lWwx/LOv+rGt/jzLDues/q5MWCkeX0wPFxPGcqqvSd+9IrzepzoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1VzwYH6w3LvblgQP1luXbINBgZqDcuvPCBA/UW4RaeJCjjnUOnl4M8KFVorSrTRmmW2LXxZHH3QUmahXHc5bAzP4sDh4yKJkbck67qScvlszLJODAqsbTZY4Z1RxZsfMNo8sw2DawsVchdgKFSGrV5XqwzrMBZo7sg3S1q7S7F29axj12fufOXLdLRRmNRCllVBJMvppJWuRKglz11pTXyl9DNz0QzudobEzlcq2sO5SrDPVv+d3hewz5V13l6d5lYr516G/Vr1Jmkr1J+WZWNX6XCtv7l3GzUw/DdezhjW+z/M89f/9zr93nnz8P+v+eXNfvlvGpsmq6ov6EEpS6ua/eY7vza3Muxag0U4TEfKEuE6LjXaT9VNND3JtBWMpYuSKhGNryTkBzJjzxpX08Yn0VUPnumBp7DoICyuVPlBzsisFZzqRYvKfhAYYYPBgqJa3NujBbWvp36DNCnqG7ZudjMBWDCkda9erzdaJoqQNKd6u3681KPhi1nYgXNtZBS0kny/+VIFpIPq40MzvP90VI3tL9DcmM5Fzv44zGee6l+ku00crWMeSS5epLfMcP5nlRW+4U+dnmf3st/fw1nhXyu3s9d1++4dzr3cKuNHhl9m/jSXMrWdNhUywx3n+GHa/d8+5nOiXOcMSTTvoMdt02vqy+39FJinLpVeJIlrzhewfojCgrWIAf2dXZQgIRhAL+h75a9lq8zDsrAQhR4mTM9JiUvLeWs+SqCiAUDh2emQnOAAmmNiS9j+TsKvNOwfyuNIZDa9IvrLiRKAfE6gbFwwLxMidCbTJ42TIeThNk6UDUplQzMjos08XDAvFxAqFpi2cIqZKZIwLTFMoEqRU2Issv5xjE4ikkZFIwNlpOcWxiggiarNVoIMicQRKhugapOWkjhduhMTrss2Mi8aKRY6YGRddE1TTdA2dNzZSSZqb0kjhspdrI3VU6FWuyrPSU9TNZTLU08zLui59Gov8aNTuYwUsgwUKTXajT7M/hub2LKK041V6HgTFawKBXtg4ADjLkJ2CF9UcStonN2XWVACMr/INZvu2uEZADMeV4QGSCjLxRGmdRNRWqBohNvbVcgVKmFFxKdkh6RAgxHi5ABSKgTqRgtibB+LRoaTYgA8lMmTQbDUSFNhCY2M3JQ2SLjlJEwKKKJUL6bpqRJQkzFFZeN3dZkixdc+gZGRqmXi46CSKReOma0zSbG6CCRdMEUS6qyrqdVbGx9BaSaVJJbLdFzE8aImDJqWitJFI1RYxQrTpJMjZ00kkVoVoJOpFefaYCzT2TOMYxRkumTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdpiEEB+4Nw1C2oED9Pbl0CGwQGae3LuMRgQP09uJS5iElhQLQwn85xGWY7Y1dWaSXJqVn9gAqgck2BAwcDocdOBIEVkmgCCu8VjKU6JlEXfkXY5KpQIRxUEAW0XjHTEUjwccohKcRdutOrmUQK3cHEcvlV06kapHiCgntTRNScK5oXDp1iiRFjAvFgfR06tA2E9JkcTZigU0TE8TpqQY1QNVJOg5sYknPImSKzdCcOnzqJulNkHZkUU0Ej5spI1cyQNpqalVRqXDVUyRc1TTWzHUElqNT6KKClPUo0PmiTtM0jiaa0loMpa1nqbmrKprTaktBBmUt3PXS0Guy3Z2RvrfWi1lKUiZDR9D4a5ilBMhUVpSLtCJ21VPLM7DC+3VoRoNKkxomhqYMMNuUxaVGjTcX+fh31XsqFob7pVw7BMpj001kezxqXDoE4rJE5PgRglXyZulhp16aL6mVJQD2lvNtrldk8SjfAiQmV2Bl0/g6gruK2yNx5XvFVmSz1a1bT401Od0VJhi35qag2Zs2tbya8WNZ/G+rs89LSWmvfUk9r5raBbf+tQsxa+2Kbrjeda3ndLSYpr/FN7lrrOqwczYxvetbxnOPfVJrQe7vqPaQGe2Nmi76/3vn5v6qMRPKg5hUoVpS+W0NdR2hFq34u7kMx9S6UF7nS0WaNkHYI/D+3Ot4BBDRx5M2YmiSmMSeYn4u/jNhYY88wo+ZFYBMau0v1u2H0lzNpJTw+BgESnrSvvHgQoJhLcq3DfvsBhxYLO/uzuUWM5trXtmpon8CtlZChS4YYEZO92sN8ZggWY2+Due7BuRvneapl9RecNuEs8O8isVECR48ePN0pGziFZg3Bj1vSSkCmM0tqWe7ykTUCJ67hRIGrwdR/5LTT0zWkm97vrdNeud439elM+nt759Mb/rjNr71vePX736//Xxr7rDc6msgeELMszFUn0eTtoWYqf242c7bIYabCmpByOLAJAX3AxGDG6Kbx5djsLvKoNYySpcqToBYGjbpzb6EoQarMdfpoAnFMEkVC/VnNh91pkCSlE8BQXUjU2z1Vz5gdAz0ZBa1224iiRVbcv48r+HSeA9hwlbQwKZjSZowz4tVM4s1a+pcv8nj1xM/h6eZgv3ur+bWMucdnfqRkcHjBTUmnkSloeN4gQK7rf4ki/dKwIMffdSMl4lY97xHmsw2PLHHriWPe94celI1b/5zvMCbd4cf2t65zHp6+ks97++sZvWW//vje7/f+c/ed73aJtLkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJC4RDXWcAAraqSJSmYABpFkE4GToAAqjIKAMU0AAQtVIAAFGXESqZo3NL8eCmAIIZ5p/hiTbGDAGMpAyCFuAUcyCNQi6C9WRo9l30K4OMIQw8dd5QBXC6IJYSjW96wtKyKSOQ8rlpiQJA9O5btEGTKtpCGau5FxyGSQJ1kaNcsdiMY4xirL2BtatUbwMsg6GLEggSA2VtfyjEObgByHAkFVgaYbbuwoOseHmsMQaZOSt212NcjF2n1ORizGIxSSiHIcnZRTw59JZk9JdjlJKpy/KJVc7A8WaXXidqWSqCoYl7uNcnL9PDcP35I7cvqWafedWnj7vz9SWWYbo4xP67lWjFJY3rtykwqSzmdJEJZq5+WWFPb7hUwy5qvX1jr+4fl+v3+//X63nvuH/n3eede/SRuN2954YfhnX7JdxbYAIUYAwmnFDyA4cbMA8UisOy3UuGFu9Tx6kc2clGS/5y1K6eDb7K7UabA7cbm7edSka2IQqgiFJGSigwtj8UimFNhLctQFL71vP+YY50kG188/qY12uSyxunldPL7kPy+mpKTdfsYldPfqUlJY5uUUmGH471zWHM7XLFb8seflVxrdrYb+13DDuGHN8zz7rff1vPees7bRn89+E86hvJa+Tr2UGfEQOD34v3nDPgZtB/sx83/n/7UFiDBixML4AKEDhCpg1EFuBDw90Gz4G0wG3ACxwt/A2TADXHAsSAyK4BQiBgDoDAwAYuJ2AyZgA4KFmQMATAKiAsIDGAWjiAaYZ+LmE9ieR4EcAYwcBiAQYrGeEEBZQ0CGiujLEHIcKcAMIDhAMBwsKIuMgOWbEwYD6HwQ5yo4UEBpYWYHSHtiD0SWJgvjnkXIAcMS+Wxyxuj7ICJzFJiah+4g9EW8+OA+LkNRZg8E+PA5pRIgUBljAsIAKAA3wfioT5KikBQBcRKBobl8+TlNEzJsny2UESNMlEUKRVHYOQZC5ycIeNgjBwEOIc5bMCcMicQMi4xOHSfNECdNi2bFw2LxTMDJA4tNMtE2X0CVMyuTBsZoEgaFQ2QSJgqJGlBNNby+6B8wNH1IeqgZLWpT3RNbNZmWr9MzNkEzNjpfK5cp3TQdaNVXxXkaFhbF54rj8oLbhegBR6MgqYK+XDUekZYmBQJEwU5QIKajRAlkFGCEkC4ggmappKPvUPSS5s5upl0WNUc8S5QYxN06KSSBcRekdXRTWbmZTMnUaOg1q1vpLTjkHIYKRRdBGnqagye73UtHRdI3RTM6DVIP/1NstbsnWqyqdjNNSKbmCS5oaIJU03TdA3QND6CDoN//sitdaKlsq3/9azddakU00GXsrb/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI9XjLB2MAAqdL2aTksAAkzf0aFYyACrktJAKe8AC7MtgYMrfDkLQQqwl4VvtFA1TAlLkKNNBQEkVAYyGshlMZUAoSQSV7Kkp2sNXUOAXjSBdwBItYs65MYa85KvSAoASCqg1RtIXKTWg2KMGe14WysUVK7qPrUVDaVuSws7NpMwG3KGoPgFymlNacafjNZ/ZRKZTJlbWsyCfcVhrzS3O1MvzTPS119mtNefNrUPQ9anoadp9nep70vlTKmsuyw1drTcHak8Spb0Cz0tkrXW4rpcKBtwy7LEV2s5ay/z7P8uZiSQyxljPtYtVJmUxmdtw07LWWuu61lyXdd1/Y1f+lqxmWzvf1qtDT/Q9Fsv7WppVTWtZa1+X6yy3vGrSy2lpcatrXdWu63jlveNWlq2cf/WVNTWhuQUc/4Q3/4CAAAAPS6aBCaQGE1CwZStDEZWrkJkmtnJdLQtz2BKX0RlI9S+XZOGT1DEJUSi1Ef1LL1GYuTLpMV2IimamUdl0K5cdWXHzNPrLn7WsFfxr7wPUhSpma1mGKWo4GzmKN0yMWVpi7j6wypWLzH3buwXrvXcXVougPnmst0Na1rP2eZdZWrWVrLtr71d7M2Zxp6zXngaURYtM9GgqCobiKtJGDQMxEHWctQytrwGuSpBbAUlAM/hAiCCMKGDTn3iw0FFQlEQBl5y2A4CiUQjDyJhVhRRD1iQGWlilq7mvNsjw47YkiVIg0gsBF0S9TJH6aTQUzwLnWszdEFOBNB10LkZn7Zi7rJk90PW5NOX3A9+beVubrsobRDNndI9seaw6CSavmcMlQltPbnI9TL7rvWHeJWyBlMJlFejYZMwNHr1mNxKNOPi4q0ZVK4xQW4/lGH5jGL9Pm05mDernjzJ27OZL6+qOtGcqGH88KS9yNTspsWLcuj2b/uBST83D8Pz81EMIrZqTsOSimi0Byh+K/bG7Fi7juvPzFjlzPmdeJxuYszedNhXt4yvK9lY/Cn1OV/r01jfcPw5hll3+dywtc/edvuHcLEeCHU2/V8BF2e/biNnMWMfx+hoq9WsqhTuLrk3GWG8Oqq5mhH+oG1qHMol9rZFczQ2SpwuTU+YJ3TnNI6Sp6IL+d3PaIxNloT6HNWLM+rS0KNts7K3YsqlFMwpnOcxLQ22G1WnarP7MV5G7NatT7HhSwrNS6xBjWYNOKtrPJAfrXsyQNPYuYVKxZ6wXsGLh7WnrXWqU16e9/b1rXVaQgVEg0qVVFhKWBkkcWBo9ekQxzOKP6KvZ+sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACdCQSYZSYAC5EglgxpwAI73FDB28gAqSKeMDsPAAGwAQFCEYBhBQNBAGJNgZOGAqkA5oQDJBQM4JAzooDOjgM0OAxE8D1SQ5ADHhgEsBIQWQjSEFkgq8LQxaAvaK8FopIDNBl4nw6oYKAYIGJxOIgINkaRaJAXCOkLmxxhcIFrpBhRyDmY6BaB3EUIqTg7g+xOjoE/hiQZ8kTAZ0mxuDiPH5DyGiCAasDG4g8W4SgTQZeNSGCCJMkXFiKLnT8qkBFMDpSXFbBb4VBSg9ClEhnlj+NQWcXDAco1QRMymRJEsFYLeAuHOEKZhqwOIEoj2FvYNoEOGkTqLCbo7BZo5pBDBEsKUXTMwMi4fDHwbqhwYnAZgXGPgixqbny0OeTJNIk0UyoRxXUtFFF0EzV0C8owSNU9VWYnSkThFDUvmi2QXdqmQp00/WmcIdMn99SVSS6O31Weuv//8nkuPomZFG8W5KBJBzkI3E0GQJ4SovnR9x9nYcUkTFoPBwiOKPqOnCETlzIypIoFjxHKjgCxJFxQbsWMFBimF0YEZgYJqWc8ZUTiIK3LjQwcUfHTDCbHk3Y00UC1UJGxeJBYupUTCQNBodPaaOHCokOCOREthIFxYmI5w1JA4LCsHgjCKTLixzzmmjo+po4QGBuSPUxWnTzEF5hJXZWqa5hzD1DTn/95iMex9fVX/888zO3///6f///1bjCSoysPMDazPzwwWUODFjeg4xI6MpGh4xMve0LAudDjsWTMSCTMCVHQFDJWyhpQQEgOHQBGMHCJpOUhE6zXkomeoDI3isku7JU2i+VI6+S1iJVp60W4CZtQWajVexBL6r1szCqqfMehVqlrPs+zlLlRMflrLkurKYItwRDGL+wzDsRZywV6pXHoKhVBL5U3KQ5vi12Hco9Muyl8oE902/rWanI9UmYTuBXpfnJpTDX9YasK7rWWUu787S0lPDkHxqJP9i99LVgGjjENReGpFuRT0eluT7OzLa8ZlFPZmp+3YvzGUq7QS789dv3KO1vPmNXm9Y2bHaC3rVr8McOVuVstZZZfnjZ5KrXuTeCrmizwLtv3ihBf+0TFCmf812AXgVlAWWdKxuaelguyY6pU5UzQqB/mXvy2N2IOsRrMK2zK58pkOuopDKOZBxpXz/VKKJ7t69KIHEtVvpt3fWU6KOv+fBi+CcD7dvjGM7vreaWxnWa63XFqWvSzk+taN6rpyjRsWrWlmaNa3rjcWDF3aFFrTdabriFGfPtxqwnz16ywZa6pndocXQKhMPCJCi1PHp1CwBCQKgqwJD0kbKXv/9PUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAixgUCDentyu61YYGcvbiDh7QYNZe3LSTYhgYw9uSUDEI2BAk0oPMrDTZX4xnBPqezYmU7FIUMM4VRIIMiBwQHnAZqAgQcpo0VnFp9S0TPnkgYOwwqJRB7k5niXkQnHHj48aUyRD1QUsteMGryZS50dS2PaVIEgs7p4XlDEDtNkcpVOZcS0+zFqOS8+nbANMZmlRZh2ZQLt11HE29ThOlp0pW1jcE5HQtkgubxVM5+vXzuuNuKsfZ0szo1KuKqUkze5QLw29zkqZrk0LWlCyqxuirURlLEm2dSPzNQ7KjZUJJbKysDZDuxS7or1TLC21MTCy2hzvI8aK4xoj/WfEZYrjd/ZxmrEfMckar6PAjPpZfNHpV1FpPj61vO59Yg/+9IvxndMwvBrun1vwzujXpmmzxW9VXaioKDDQE5iU4rXFA0zkASey+osKiLeduKxFxbkW95s5TFBIKB6OXZWqRWHahcGojS56ItfxwxQ6vHLOwQJMkkTaVKO6+lui5UmgMRAvPxbVPABjLH9viEckbOf5cbz48uvP2r63a1a7tvECNjG6+I/7y1otK7hY+N2zWsk9taktu+cWviFPD9LZexc6xJn2r7etf8al9sZpvOokLWfT41mmc11jUCeW0a+908glpKONoIJjsQ0hUh7aaVsgAEKFTKLzeGTSVzoOywjL8tTICACNPyo2DiQ9EzdrsNMztu/Hg4mXt2aSAly46g8YYIxlgbXxEsCo0T3LVWMQpzIKkMlcsRQp2rXdBD0CUCKpIJ1GkPblGH2uyl4BUieppWZbHDXafQwVjKxx2xOPV2SRDHF+1IwviRPOmFPCiKhlOt8hbVEmcmejheygaG9D3zJlm6kYLRHDGocXDq75USPcuEaAw5r4dF3Hnk7exOUJbgQvG22NECWVWIhgVkSBEV6jfucDUTW3jjCcIVGylozPau6wLwaP4UDFa6f3hzesKR1fWYnvHh68lIl7x7R8xKazbUPXvEv7YYnXR1OfA6Hp/gbmw284ouDU7VNAoCs3JyGTUsPOdEqO9BsUxmKsOX6BfEBW6OWbgOXsWiJQNsrFKCJUufMqeC2P2JZEg8ZDoiI+lrOCopjVplgwMmcu26U3XUwNmLp/HvAeLacZNR/SkTGq23EeMaH28eBHjRcQLxFZqPHvZgcmpkyqKv90ruB4CGRaRDkVjzO6f7gU1WPrv4/pjxs+HfTxWSYxrvE+r38d/e39IEjBSmIlPePLDo8/w/Z8avjW4b+fFMYiXInZ4YIGM6xNsz0/YD1i8efo98B23b/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAINH9DAxh7ctvvmJA97G5Y+bsMB+Xty8JD4MD8vbmZXOl4jQGPHXMriQITG06Y8kTFHZZoNGDA3Iaft+H9Tda9KmHKxM7eJTIFBLUqwg0CYSTTBzQMLyBvwVBsLTW5SQUG2jdk+4ECcjpnMguZb2CnWlNJOtzQpbM+spN6+VUrE4MdCDn7Ifqm0zk+UdoyoOM5RzJg51ChRukiTJiJdqL2bSkXyUFOOkYxrKk0nrAqictRpPtRoSu0lWB831zDs7m95G6JHZWJzcY8aA2LtAR4ilmZrT0ZZI7DFymFW2q9KuatOqdQrrWn+4quZkbGZY8t5b31JW2fNE8OL6bpCzm+Nx/73zuLS9PuDeS2o26T5rjWfqNnFr/cur435UUzRWmsl8XJfbkiTNlHihydNFCml+4vqwHNlXNL1qpd3RQ6KvpzxZXjYdpjRxikyBGVwywX1hXEsc2TtCEB3AlHje4x40WLDRIP7DjALVHvTQDuJzj6tE8kJqs9sywVUypczSN06JJwvLhDWMMiYPY+AbEssG6k+XjqdCUud5I+emqtMzWfFQlkVpeMgpWIZkpobUcel1NHei+Pr355lbPJim6nNDtEOx8eiVLT+xPKzVGe2v9dZo9W1braQTttw6vBMc0vP1mu1ptPbrtvpbJ/a5/TW00z62hpEOxGm7iXSu6Kl2uwrBkCxErmM4+R6TSUTWrWaFjYlFycqzEuprvHgil2GYTfcTKK3Fanqf2XRiret0sebs6ta/TD54jAUYjFDZr2oGs1YNXF9NRstIL3PBmLhVSxYG4Ry59syO3tXO+sbiJ10wwIV6PJ9wG2z6WLNGxe0j7W9ea0GNj7w+vq9ca+1dPHiZktW+Zr/dI9YuqXg/wdbhYtWNW2ayRr6zreKf518Wrb79tU3XVrYteFe2t0nt9atCCkJc04NpM++362q6/e0OoGPdiDJlKxQwQMo1TmFuPI0jKhqZHMUul1Zjchwl1eHpbVaOm7NVKTN4nCUmi6iW3JPt0h0SGaS3WlBLM6D9V2YG0m+ZSS2KpddmTyOvYYAGcTurUWSHLtwCJak9GbcW2dj+11bRujSz27ctXX3SeQ5ClayzVy2E9alc5OLt9iWKrncVyfeLi7HiC9aktbLjP2BLK+FW0FujS5ZcOU0J+1WjRI9pXt9QpPiFOyvoMKLpVNLfNLqm4sVrbc2jRvLFxWSK3Y8OI5yM2LYjUngQ7XizeLFixdb19PrP/nckO3vn5l+vnOs18PWMRrfwfvFs23B2+qKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB316wIH5w3LqkJgAY1NuXSYHAgfmLcudNh/A/WG5RIs6pGEDGL2K4N4yzveN6Igte5+chm7HYrKkDYOvOAURs2oHtijDnUaUKjjUUTEkoPAIsZgxsXwKTDkQsbkzPRC90nobp78MYvtWm3iRvLgyyQVLFSgmpTYK2scrW62MppV5Y46v9v1ua+ltTlPBFLBPaSNSf7U5Q01a3h3O7lbpsZbZs0uW629XMbOVi3hdobfLWOpV2Z1XuWPv4X8scLdLzPdi1fr1K+dbeGWXbtWxu3nrVnlXXave2d2e65Vyt4VOz2scc86lbuu0vL+sLHaXHP/7vmWe+3uc5/458/mr+roIoWO6OdxI1HIJ6zh8y6dYRqDBOEhMBoFkxmGfqQ3b3Q0DPm8gmHX+gaMShcw8p7J4dsSp0BIOy6egJltocGQLK5BnKSVKVh4RE0Jp6jQAgDyaVvdOLZlGF2hZAYI08lu+TxifJIxPBDMzNzMuIrKIbgrmJomZkq6aKyiVy0bE0oXhWUppqis1LbjnKNiilSKKSUb5eTKR5bl5y4Xki8ZpJF01LhRJ1ioUTzrTWpGaomak0NBkjEtpmrn03N1E8mpkjiaTp1oqmq7pGxmtAzNFnnRTNnUcdbu1NM/RNWWjdJq2RdrUEkFOyK0166e6Ds6K7nts6bG1HYLwoxPlcO8uOE8hUJGrlGVtdn6R5oYg/STc3KWQIKTc806om/ZgQdXKCnjXZOAYSUbvTMMkFcglGLPDqPEKJG62Cmrv9DjQ/qpPjQ8fu0pidJsm2cD3J8rGtI64x5LIGVM0JFAsLIMtFZMnikovE+ZG58n5mUyTYvoEKkRdJzYrIF9A+geNHWblZIymhitE4s8ZpHSmnSTSLpobF9I0dbIHS0kyzczZNkHPJLL7HU17ueRW6kqSSSCC01pIHDik0Uz506frQM0EFGzmC1slSTMjJDdFKkzJoJIIoOtbre7OoxrAVUmD30dOwFoLmcxVBzmoskqItihRYj+kpp9mC/4Ye67EYBaSvFBdi8241BTw6XAVTxjhETl4NF4RODXnvl0RZ1Ty8kCGhmiGwt6Jv260ki0ehccQDmMQsU1Uo/hh+b/QZqnl1r61msvOzhnK61J9+kp5V3HOYzdut2nxt6tWOW7Lw36teU4Uu8KSPz8vp8ML2Fzn1qTHfOWe3bO5Zft3s7VqktbwsWM6fOzytY3nvmrOM5S61v+2e17eFXms7u95WM+Y8z3e52/U1jU5jln2rn9rediu/Q8c2FUWgXall+BH1LDg0KhlHE75kKvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcwfMEB+cNy6e+IAD84bl095QIH6w3LUjUgQP1huXYxy9GcuoyGn4zaU8WDCW7nPxnqexPKYS+YoxYm3ffjF5IHhZK+wa8s2kLR0Mrs1p8RCjRVd/porzC+41a9FJivuWt5YqvaW0ktazY5UjE9WBsJV9y3jOYOTWtZY2sqtrDWGFFjA9a1KsMpDZt546q9rbo5TvPHC9VlWF/fPx+3d1+8beFyzjfz7Uq5y/uFSkov5SYc5PZ16fOrfp7eeH0mGGVzDuNu1nj2vu7fw5Yx5hZ58/N/y3Tzee6mqlvty9hY3Vzqd7X/+YYd5+sP+vbww3X7vVzVfeOGFTEcYXK0JsrTgn3WZhEyXncEOT8FxWEs1rDKpkvUnKlVcFPjbZVajTDAKBO2V+0lWVpfrBqQglWx9RQJ3ZmTyOLCjQ0s199klzr6GcEzJyFyGYzsT0TKoIK6cfPGxcoI1V4Z6x3C5cwq1Wx27+uVLFv5itlWs41coRTYY0l2xZ5M3aKNX6SrjXzt44WamOO9ZXd7u0F/f4VMMcKerK/od1LtWphcrY2N56vz2et27tXetWNdub5zPLXbes6veWML2sMqlXG3byx3Xq9+zYwv4XqmGs952N1898w1hb/lTn5fdw1vef7ww3vuV6nuATroin7a6Av0VIyTxRuouoanxpZYWRnlEznBFmnhWKdvLr7oHy/F36iO3IwQIV+Vmb4FvLcByumjyfAcanspCbQQFIrOYfk2MCwpp9ikhsvrJ6K7duTWeETCz6HOvZv1cXS1n87hVnPzry2/hK5DesU85cl0RvyG7co68xf7Sd5csVqepXsbvzUov4ZZ/ar9xywu4VqlLYk+dmWaynKa1S9pLdvKnzpaDe7vMbPMMqti13tW3S4VMOcy7l2nxuUd3LLdW538aXGl1W5Yu61fpO/h/9zxxwrU+OOH9rV6mssK37xsiZjcriZQ1YH7mw6GfnXw+QRs2SbmgSx5EYY9Wg51Y5fEdzMrlcDYM53KYaGmsZ689SauqGPWoTDiTM0OB7tqT51hCaZxOSd/DkBSBUPGJJKqfOHabmcACxyV1rnbUqmb9MaEP3uixwtzCyMcN5WI5S0Vunqd/efHSyr5Um5ZzCclNu1vW+1qHnMsb1XGvjjlurhdz53+Y95rKzVrb5Q41N53/xzxyzw5Z1nv6t2plzeGP/rtnHO/Vs1e6rXOfzLWG93dYdwvY67zeNntanHhcHUARQXQ+w3oJv8E09Kn/93v3gWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHOX5Agfmbcu1Qd/A/U25dYicEB+Hty9DCYID8Ybl6A2IoesTZMpN9HjMSoirOpJT6gKLS+dokeqO2zxIqnxjVZW+QUJIqVhTbrVx4fdmN1ICJYEB1+nYwbcIwes+JvLIlHKz8Usslhf57uXDQzLJ4oFICkCQWtAvGpTHWVDFArHTctloxSKzrRJUwHUgUiDmJdLpqYl0mium81NzIumqZaSJpmOomJVKZ8zWpOfPG6SZInC6xRM3PmRZSYyPGqBogm5qYoSkpJJNbJXSMT7GszcxSME1pIJ0nQa6zibKOvSY2RQQQomClUENl3WtlqZ1LdNJJ71LskktE0OmyilyYvGVN/60eoYgzmw7jaP9ApVnhRHFxiw49cxJVPUzmTqm0ujqCNOdm0zHIhK6ZLeACgSvpOeYISEW3A8t9ORYsKpUjjshQSaIsCnULvvXVfl+bLhg5LPResZOTo6JoBzGRUzZEoG5fFlkQMZFiSIGXjBbk6s+eMTEfZOl8rLM0zpePl06RroFJM8bJIzIxK6jYrHUDdIxLKRiTRuyTlwpMmorsYpIHSkXVJsffY6b0zA8i59aDImJoyzxTOGZgyRvRMHZaakE3Weosmm600lukrUxgpBOpa0jDWgpFbomKSkWWp059S01VoJoOpeznvyePStNlAGOeBczRUh/vXsVXIQwoZElEUrSOcp4KwSRnHQaQRNa3Pw7tgMijiyUmZlqMPowxeIcpp8h1FI7J4DJOCGKn5bT2X7nH35OMyDmVLduG/X2aHBAI1nKnY3N+/OHtkfEF43s9k4qG5OKxcNinls1NsZwjbrIwQItmCrZFy5R37jPSmcONMvoTtr8LOr01EgSw5e5TXjwL5jtUtqRtVjwM/ySz6+40GPfUPwZY97x37O/cHjA8dUiRq7tEq8o8gUz5dbv9Zvneqb96Ux6TU1Sm+/96/Gc3veeW8t6f4h1h3vSmqVzjO9Ymgd8+DaOc5DpO1iiRprKRNdDKQxGIxD8Xl284OkDoKsKFJ1y+CcsZUsEok12VolwOIQ16TlqHyEj3w/IlZwY52ieDgSfczRz323bIpyeX5U9uV0NugHk2qsrr09PTwdzCpYry2vbp6l+Y1KKliIdy+rhzLtaksUmOGFm5vmX1JfW1V1TY28d3uds4fhrDKpYz/vNWNcysY0dbfM8OU0P2M89YV7eOMbzr0/eYYZ16enjcPyuXxuHKSMRi9y9veFSUSycpIxY7R6/DXNUmGee8+65hY3n+OsMKSxnT26enzr57w1/c/zz3hvu886ent0lJUpHU7gCPnwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACo1yRWtZw3KlTQktMQxuZCoJDBWMAArku2JCnvAACLjUAAAAUjFa4qsZIcjyZUiDFhgDYO3mzNmcSGr6mVXGmIh1c/sgLOYZzAmks+Zq4aYaphYQ1WwsmHBKQjb6PS0RtXghlj6YDR2ZJ0RuGJxhjB0MFbV7IBAoPEk6V2sSYoztnjHVB1kNRQgLToIFkqZLhTrUodFyXKhDvuhRMPgKWqqIGIbgATC19MtY8igBAIT0ZF2rqUtQHpiBVotUHLZg2rL5FDDR1rtIQkOLA6RhIEiEgYYTjBxkhZkmUAqAlYjEWhKNkYwzBvSDJAx51AJ4AZwEBNBVVPIIYbTgCgy8EgGgp4orrAKhCDmggVSOILchwU4mCMjbs7r91Zh/HzX467sRl01KFD4jTUEdjUmi8su4S+UW+zFPcuzdzPduYr9mLl6N2K/4VZqVUtupKbUsleF2gmcse54XZutiE9g+2BunftGqsttVAVOyLK4Fn0LSWRgAAATavLIAA58IBZVnA8OigQQZnBZQ6b/vLYenfHc1A1z/+ShzxLqF57quKLEFhzzOdMopmZmkox7N0R/S7DJqWziG1ccbSqljd72vo4CQsoIBBIw+CWKyURFQUIZ++dnhTI5MDsOgwCskFwsHY4EMrGKCsgZjOEpcUozw8bs6r6fv8Vt+cfWZN8vm/M9M5Mz+3rPbPT87+3pRtuzW3dp/6I3RlhDEi4bRFlUiJIXJcMXECjgrIwMEHDmNu0tnzEFgi9ylz/JUGXwjCGDSNXa79K2ey5SZUpWKpbEVDVSw+/cEL3LxskXtAMFAcyNtMoIzRQCs2rKn2a6h8vWA3tV1F25PdCYehD4RiISp4oIhhnTi2HdkMkwiEkiTgZzr9VHQeR1LbIIIhD1OAnIl4sTj+Sx+2Xu/D0OOJNtcZZYcHkvf2DJx96Ny6KRP7BEqsb7YiUzLJ6lrRKLy2em7knltaSZUlNYlEoll2kllJjZuVZRrKhlc/76Ow4ldnDXIc5X/KxLIbf+Lz+ow/kUru47FJY5vHDVPbr3rlmpTYU+drCUYWMMeXtcw/HHmt7z7hhUsZ9739fzOphz/wqYGXPfmYTHr3lXSLeKgha6W6KZOuEhXoxhkY4rDBbTobjt1AiRoWITyZtoxHlc6LxHUXTemsysZnE8Gs23bXGCrYjYyh1OO8fVYW7lypKwv22DDTjx1EmtVx8mYPrSjY+eSVtCamyZxiUZnOdmjQvJFiVg6r/CcsQtxbbtXdt4zNnWLWpjWM6xv5zne84pb6+PumvnPzn6/1nN81j/GqeXdId95zfO/fP1nd92/rvMOPf+///93jyIcCByB8CBjf+MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeZkEuOHiAA/jIJccU0AJ1ZrxAc/AALf7Yhw57wAQAAVc03QRwWix3F4jgFmg+HhwjvHIIckZE+HSCuCziMGWQK5oHSCAZHCdAxMVxnS0ak2YG5HigyfKZNlIwGVI4izlJ1sRMdiZuOwwIcsgRfKRNKuugmQQVoSwssLLA0AgyJMCyhZoZFDEKC0zE4bEYDcsGx8MtguCDFkTgISClCeGNDAIW/A3OBusOknSLF1ZdNlizTJEpJHCcJsi/TOl4pkFJEun05kfMkj5qcUmtJVdaBFDxMk0SpDSXIISA7zQqOkiaEWdlueWZJMpJBfre67qlw4tBI66jRNMwY6bMedNnb8yekiiipJJbL3U////r//4AAJ43IRVW4vAVFh4tiuAmaIYVg4RgxBAtxkZG4A+AngKcRA5RgWmoAgAD+OICiArw3BbSAbkmUDcc4J2C3j1Mx7HxwifBykjI2SSHGE4LhoIwJYHKNhPhzHzZN5ilEoMxiDIAm4ZxOB7DtJVMeoRUD1Mrk0ljc0E3Ao4XsBkGRPDmBUBgB+JM8JsFWBTi641F1ZfdIvIIolAiDwHGJmk6CygbCeiYkqgYl1jIlkkkkloqf7Jkw0MSSH8dpLDwGFEUUR4nzZkTJFFBjG60TI2UlSU6lsijRoGg2FIYAlDIgEmfLiZvY3QPVougv5eMi8SS0WmKKVFSSSn//////9J9EFnCFuKlEF7FeICnzHmXcSMxtFvQ5GZS3R6bzwSt2WyN/LHSgd+W0h6Gl70UERmHaeVXoFnpEyqBxo8ranKaaMzMtcmYl0beeR2atexIn9fyHXakVT48/1LUnLUFSrCnh2Mzj8w0/Uhf6Gnpd2kfnOxGaKfk0WlL4ubG2ktmhbDX4fqVOLYh5/Y7INo8smjO3dazAspneTWfMsozNU1umtWcM8/s/ZtX5TeqUeWVTKtfv91jZuVqarlWz/n8z1j9bC1Vx3jZ/HLKW3b17/5lj3L9919YJXzF2/iUlO1pFFjU/vX793/s5+pVKbA908LkZ5Wl6EKaD5PtIGOwJ5HIaoXFImSjFGOZuJyu1BtFP6lAIsI0/D0dQP5mohRlRWo8W3SuElBwwYemFfVNIDMqh0HMtOnJqaU64QDpaXmGJPPp4SNXnbghyrcXitb7DuNsuqy9lq/HpOGMrn6y5F2VapQ1hiQ068WI6KRyehIamE8dxxWu2M0juj3V2GJB29hQFVJGjM1otWJ9bFq5tKxQpN51CfRsWxI5arBpestXtMateka+sza8XMWS18RswcX+N4hV3Sq8YN7N9hlEVzWRSF4Uv/fb+V/22AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJb37GhT8AArGtaRShpABlLkFCGUkAAx1IKNMU0AB5AQhOF4LgaCgWGNuNwVwFIAJAAgA4GJJ5W5bO2duXWcBYhdcEjMqzW83tNZwEdAGpfAHM5uS7uuGieYAGARaBBxQRiDKIrD7+Q5YoY3Db/v+77kLsVIqRYi7HEoo2zhORIQu4WwLSFpC5CRCK6Y6K6K6Ram7j0z6LvXew9U6EsuWWbLRo/pgKCJEJiLogShf+X7+khyWWPoH0XexNnbltbYeu9ibjv4/jkOQ5EOXom5axFSKkUATETETETETAQfUHWO5cPy/sQYYmOmOsdibO2ds7ct32uOQ/kYllJyvG38fyMRiGH8fyMWMLGGH/+sM88+9/950lJYpKSxhzOMSyUUlJGIxLKS3T09PL6e3n3DWv5/PzpLGH7zzzzwww///edgAAAAR//wDDw8fOAAAEAADkSFEX0RAAAEJctnNXchNGRkYrJydudVun/c10AgUQIIAwU3///+i0IMQh5zQGEAoFAoQIGG5o0aNeahACYJgmCYJgHAGBsnz5k0YrFaMkQIECBiEPfu9v+E5z3fdzQIECBhiEM///hBRGjRo0aNGjRoIQh/c0aBAgQIECCHqEIQhCEJzne//wz+5zmjFBIgQIECAADw8PfmHh49OI+OPW//zAAAAAAM//4Hh4ePMxjzodDIqLjBMGAsBBABNBqgZc6AErBAgA06wPxBEFACgPcECAQERiOokwxeFhYmIewPBkR4tYWbA6QN4DI5PinA2yBtkQIZIapMAcEG+GooAZARALGgv8WCSIKWyiRE0K4WiBcwMAZwXAVxWAxUGAj5SLJVYvj7IKUy6KTEbgBQAMADAEaKCDZgtCNQwkBmhIC5COHcREY1YcEDagW8CpiuCPAxmNQQQD9RAE1I8ckWaQ0WSSJSGWdNBNZmcEfk2XybJcnBpk0OYIJk+Q0do6TizMjRmSZI0VqkxsmXHLhmmfQYcsQuQczIuT44GUbqYmy+HwolEc0yJ5JAyMkTpimYprLZoqnSqX02L5fJxDWmgt2rppml2bzV0qS0a1pJfrUkl+2vR///8AAIAAAAACLIZWMx6PzCMFsQ4sABjS5KGjIlA7Ol88oxNloG4whQTN1FIkjconzIehKIJFwyHMPZzdZdK1PHoPQoJGiZcMh7HTM2OomiKLIIKHYF0CqEuVD8JcT48jI1KRsxdMwKObEoS5vL5uooiUheSmTyeWEqSpkSzOaLRM0C+Xzdk70C+mb2QUuYsdJE27OtVBOZj3L9NMuXTzpfHqlMTI2SQUpa0a7oJopIPdvTQRTNFd0NttBtvpGyVelul9VSX/////gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHYJBMBk3gAPTSCWDHtAAoPkE6GUoAApLIJ8MOcAAsAPFDLpQHQBgIGFACRCABFAwkAykArZOBYiBEQxoAuAbicHYTYvZuAShDRZoxdTITpfQ2wfKzYYsZTvFM3RlVlQuRlDoYj9UsiWd2snsnOccUG2Z6tZlasLaHH64vMYrBUBcDrF8TskBbWeAsn+NExDYgyGjKyuKnMyQ2FCqUsrFdHTnPKKyUf6miQlLuzHeaAvpJ1CfM7c5X2qm3tnhN21dPmvtatb+uKZPzuTgzRrzPWq8KFT6pLXO8brX2+8feq1+fr4+v40KNnGrav8//f//1v///dv/j/f/////////z/////////////1yOzM1GcgQF4JKPlOv2MEShw9idkmCfheBlicmhIjeEWHEJ8PYkBxFEvj2JILWF0JQrMCYXDUqWJQbFEKuFwGSO06Pp5A2UxwShh9IIjIkwnxfKDksSK1pMsYosgWgKmLQbySDSOZQbQXISw6G0eOjADxJVJEJsFUFuFTGEC1AUYLyfKZBLRgByjDj+NhfJE4SJdMCesuJE8CjEAmGo7g5o9xwD6bEugXEyIUicbkIuoOamR5F0kzZkRaFMcpJuRicQTiJIkiTjc8gSpdLiDoHEXc3RTpKWpq/XWx80SWlQW1bLRUyka0K1fUvoM/fvX/1////8fYCQouw1aUQQggtmIUAwaIAlOHOEBSdJEHBQHAwRHw9cQVAw5cAEuBrDIDwgGNBABLxOhFAM22AOFgHAQuBC00LXSyRQ0WFz4X0GCJxFlClRCUh4ggTiAsBNiVizRQIIAouQggyQrYNRICmXFmYsgcwXGF9AbYCGkyINCy0B4YMThyonVjxmTY9hqgeCDjRD4xLx1joAcBC5gdw4hcozw+zAlQuYHki44CYJgky4eBt0AYKGKQ3QYCDIxFRWoZdLAyREioVkThgfIoQAiA40jQi5AyfEoDMDlDNCbxWw0iJEiM6RUbiDmSjVMopJE8Yok4T5FyJkEIoVCuqaIM6BQI0SiMiTQ0iseMxwrLxEyBHTVFbKWkZJKrY1VQ/03dBBk9v88iUTxcMnRNEk6KaSlrNXSSrbrRRQWiYvqU6SSXVV/MitBSxYiYFSYimjQiSPMUbAtCgXJkECQdHwBiJEyyZ6nEBqSRGMnKaTLFsUNMaYZJoxAyJRcH4kns9xoQWTHx2KxYg2JmqYPjQyQS6njokgaJig8VGpZpMscVHB5zDGcww8+YY5w+LiY+OFDjjTh4oyIaYNThszK5hjHvbxJehpAq50fPUq5roRRFOOOVBsp0z///f47Kznv2ezTr/7qacv9vv/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACPR1yIdrIAKnLPlw57wAI/nPDA3p7cqzLGMBh7G4jqnAGLBU2dSmLKDLMzfPQo9FTxjiwiICMEIyhi0xfpuRhBaPKVafIqGNKCwgHGIDVg3GLpJjBwSZQBCXM1IKBobPy0pAEptGmtKmbyVVJ5TKXK3NHLiqA21hguEAki0TvFtlg2fFURWpKUuS6ZcmcVy+6xqsj43GWPSzlrrtO3Dsmyglps/CF8Le5DTrQ7TZRKIwU3Ztow+0ubPBGpimi1imjTOoep3Zh3CNWpm9Go5PwzOyRrUijs7jOyqNQNm/stiUw40NS63Eoel3bleYywrU2O4lb/56ljMt5QdpsJV2tWprOqbOU0uUPZyq1f5j2tWu2ss+Y6/HdN3Kmmca1Nas5Y7539Xct0uOrWNWz80KLTZEde3/aLbL/UWymlxeIXZAl9FYSVOnMYSFq1wJUroydzWyHR2A7xYSfHS9bIy5VMJXT51v7kYmafcKE+YrudIzUhyuZv3yqePYloDGhrxXJ46Xsm6+FChPcXkjNrU5QoEetI1cbxmuIUKSNaatn0aN43YoOa/FrPsazWvi/cKLSDWunz59IzWra0aNfOPXWtW9vWL7V/9cbt66xX6/tvNfX//wa2zrHtmLpoiJVM7vw0R/Q9AFIAAMGHF5hsyYPIGXtpwmma0TmcNYASjHygwpYZuMgpoCLJ2pGNWDQYxC00y0aeGbQAECd4yKgUVkEwGDDoBWsGB1LU6kNmIN88TOW6v+l6s3N7R0Uvakhpr0y8Rb50G+RReiRpvBgJ8WrwMCiS2i/RfSEgTosLESFCYMJVMBcjDfhqmqHAUZYTGXgEpOR5mNGjeL0vmSrYMZXLb5klOiR69GCbSq0f6pgsT2EzxdrlkypltKKJHWUyHISqU9Gpd8rm9RKpClU9i5UqwnTJMk5S+lxfwkOitjWwobM5Qlc4w3rvNoXcYV4trWnVsLDkwxfLFiZt27cOLifM7Fdlnra261fXgRouPeutwsFTdpgoKllQmA2rcyo12LyZ60v0DIRGAkIZyK5AYSsqAVNQhGlyzBiQuSDbjVTsokrYzRF0V/u9Yn0uHrDNGixXuX0+toh1WSMLAvyUniPn27oaui8t6VJUJYeqaZdnLWarK56B+J6sM6mj3mntrx1G7Q+Mn3WWn8ZQrMskl6aYzjK3O3upay56tF2fOtLlvNR12axVWurVrtpsttW0zb+1mtWeWNaPcAk1gEJnVMFw6ColERURCXeRVtPedqezQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdqekGDWHty7e4IEGsPbl4x/QINYe3LqjwgAby9udqJmJGmH4C7I9sA1KU5AE4GcQlAe7MsCARYw5AxoAwwM5AVpUcMs4ZyyWyGFeCNKRoGitmhqVQy9ixVuw4RFbgp1F52mqykRqSAtxVshKFpDQ7daHr8SqWajM2gxWafpmFyNJTp2OhEHX2zR4aZVLc7zKyyMra+fztTVDUzlF8WOqVS9apbwfSfO2KWI15fPo8fd6xNbjWiysP1B3eHNLBvEvEex4taMNdPsZhQbPZLfF4Vb2fZy9hSwZvXNL53uDuTWIWINL5/ktD+INfXfrmmNWv851XedUxve8/XxX49YvXTTZYulGmxbtzO+esIBZgSqHU6Xc89QzqA4W81zULkDviQGgMuaDjSzjKgFODFF/wYNgrKIeBpTtESqm4JJXM29MoNEG7rkaY/7EU8XEWVnS2npkcNF+nXf1PUGeKiJqxDXym9SwiOqUo0RWBunMJk+hmir1GrWGJ3KPsbuE8rlE8r07DbrvsLiPhgUsKPSaz5izKyvtPF3PWPe+4ud3eyXiSRo0jxnvExWNAc3UdtjwXe7zeE9fxawrVrRltqksBmwxxcbfYu3z6i6pSLW0ufmstJGr0xmFqF/bHvqNbzf61W3xPJkueNpxrj3a3Br4GeA/PyVtvF337YSTEio6YM74LCERAghca9Ev4ILA4KjGiqoSqVsTR2eoKvJDTQgEVubRHThuMQAzuleySQ+zxIFKRmNxZcsyjVDMBU5MmjsP+ezDqGPXa1ilmYbtXYLKB081V88eE6mF/DjNjvFm1ZgTwXPTBBw+cI8jir366cVJ6VXL5pYocO26ttHeGxntKpMwFHtrhMcJ1A0Z7lRvjNcamaOMOF41YG4tY9+wV3M6rqFvCzDzGgPbPKTWhZiv3lNRJ3jLnfjTxbWzLAiXgRaVrS7zGMSYrGmzPB3A+tYvfO7xLa3v0vTHvJneq79v4+Nr0n01MkigKtLsWIg4VAQ6cu+FnAqBmIhBloCAlYxMWdtWowYFVYChX8TdeNWh1WcPfXUPkzSVGKaONDlruShnKLjrtUazqC712RU81BZM2/XVHDkbRcZp81PvrLYnTS9pZeOjp7LB4c8GCW1jcokeLFuPaNGlc56ZgWeOTVVno2Pmxig0h/epFP8yQ4kaSJLXOtsLPeNtyniOGlHtw8Ce7e2PYdr2gRq2vBj4iU3ukWryFDkUsfUeSkCsntTcRvoxZrWupa6gTOW/ibEuKb1T5zjcN5WmtXzqXGs0z67pb03L9Y3d5pRm+hcHC20f8Be4fl9QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHeYdAgzl7cuZQl/BrTG5dIeUCDGHty8XBn8GMvbmVoD2gkuZrFjNh4qFhAhSMgtQEHBQFCmHQ1nRT8NQ7Fp4HHQ+805FqS7AUUiEabpEFaHvHo7bpu/BUgp4ZJV20sQPofEFDo3S01SMS94JRdhtbHcsY8+r4uP1prLqH4KXdyxN2a31GnuGGyEocs2pppsQHNvpdyzpxzFe28aNesznCrPdvfsSmYKuLbWNSI5q5/rMN+p/ur+eWuGpzcpb0gRIG49KWcmRWNi84UiuGHTfJez/MK9d08TcPVGa89MzP/iDPXOM5iw6R4sGLEtX7tAvSJX1p6YpitK3xbPgeBq2r53atNZxrV93vJ7rCUbP3/ZqYCSZxqY4QSBC+xhDhiA6b7XmmPI50eeaIxNW+HHNo0rtNngEeByp6WYQLWroPLSXHRjRe0obIuROnoREOCG1Sy94euEYIoGRzKpJItDEokbXAoQmMsa2MHm04dGCjMbmoF1EKfvWn1EFxRaCAx4h3rbI4Y8UvNPNV3IbN+2jYM+UXXUKfJB6udpXNpE+rs+3Qlvq/prdm28vqroaQVcxpmBqlVy614FBrfozjGvvr9W8W1WXv9HDj2YZ/L3n/apKaZrWa5a/c7rlPvzn05insc3fbZ9LX5ie/Z617Raj9lF60zYWvsHLchCV1F2lnKWJDMuu0sPV4jEM4NZDQvLEB7MtszTLKS07Nx/5a5LtMdWWXqkalFiPRqtTha7E6bKDDKMh8nhNS/KC9wXjagtZscppmLWimjUAnlmlI22bDx7RlpGbGaSBqWA9ZYjEo5XCO5tbvL2VkZnGDAZWuLCjOfiwZrVfYrdvj4kRU8rcubVjYY9RILjtWtTNNhuw/9qRqxY0DMGl4T1qgQot55bvNTwIm8xtsU8FquywYz7uK7dVmfXe0s551qz34vWLukuqwvWm74z9aziufV7q6+gUC8LRQJVQmoGKF1DtsJTbXGIgmAZeIGoDTFvE5pU0mCYev2X0mY6phEF1wY5tWDoYWhFNN1vROhKwlgla1Z0frZIBlSSenowtorXMSpNE/GlUiJSGJVDE5l8dp3+MYm1lKWV/IxYjETNqez53g/X8Vt1d87kgQW/Fpo0JIM7x9ltZrKV7By2y2ngbhNsKCzv31oMKaHVtq9kjb+4DJFvHcXGrbmA3vE9W8aDafTdiIxMzNGlrCtDph8+hPlVLiC3a3Ndlp4e5sQZoTFB1W73WpMSQs0xiM5VxBy9rNeBvXz/ik9YO8WzF1uXGIsm56U+oWt6zn781CsAA7VUSL8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB4mGwAMYk3LXUKfwYyxuH4m3Dgzh7cveuaHBnDG5jsva83Mw9HCgQNfB6pVGM8pncql9Ey54HluBn7dPkmDKtreuvTLmxSJsywI0h/Uh52llOUvdkmVK5qARDARyEwQFLpiamHgpLD7j06SpYKxcQcukeCGyLpIJGpfWOabJKLaRNGRSPTpgbm5qgVSIl4sqPmKBmXjxuRQ2LCJ4xJkm0DpmcMUlLPmhgT6y05kiZGsoopmSSS0i6eSL88XFJF0nUzQuGaJs5ok9kjA+am5tdRoxFTI1TWeSYvmR086KBpSPF01l1FN2NumnWkswPvUpNad07PonjZdz6U1UkxiZoJWN03ZJVFBbIM7Ga0e+x9Ch2S6ecK7L3oCVpqwvg9FBnGYvNO9k7C53ZbBDjv4WoshDam3uuRCYRHh4iPckSQpRUXCpJ+xoQ8I0Ormh0FLU9yJmmwtReljk5MXwxZ/s9RQUf50fmF1Mle+HRWvGu1CgQjR59jtUSV75E7A6ssoyCWFzXXZbOLIeU6yzrs/aLK3advC4lyX16E+tt8VoOhvr3UxK8/v2tT1jUTe9WK14+w/otxm2RyxRffmn6zlZ6vWm/5ed207W9I7d+0eynezVunz3Ts59Jzd6vz9bdedvd3zceow9GTc131nTTzMAIlLFhgcuAFAIic5YEKHVQedUgXCUAhbaLrZmAZiazVYWgXMIVjVzQYZOPCLMLJaG4btuz1hZdtx1K0N4OY1DFeXYrpmFPSqYxtQxVlEsvJ0bicuNBhR7JtOEsUR4P4EFzVjnlXtTI8iLtC1fSG3JUnZ8ISSct58ISWNOMj+SCr2JUN6mPBTuashKRlc8sarYIagb15UtMsKI3q1bUjhVzQxrfTyOEeI2RGo0EvKZcfbHCisba54ljyS2o8vePLGZGNnhtkuMPZ3lc0z6VsyMk8r+977pea9q3zfPpEiOeekwHmB+r1H2q1Uh/hkBanSzo8GBhQPq1tlaxy/YIGICyhIzwwQsYiJ2rgw4sMgO6XgjKPMe97FprnNPwH80cDwBYRAsHnMiioceeABLpbdK9na85G8ZZtTdOcu20BZSoIbo3jDlL7vXIhIaeMTNakiC1MYDhYND0K8bMCSbjovQkR3ajmpCwcGCk/b1euQATKxFCscysPojlRzWENlXTr9fCQqODk/o28JEThLeWv9N7wn+rztUTE8H46r2BlowXMjv1m4GT8vqmGY2NQlDi87P17yIS415gS/gOR/OIXIo5YrG5Slfnr2cXrXljcFX/iWesr7DKZ2Ky16rdJsEJW3c9sItWf/7B83mXVVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAatbsMDGEtw6w44MGcpbl4qLQAMYe3DtkUfwYw9uOpJApKTRMUgKu2GEOrKQE43iCLDiAE4WGrAo21RkxcoucAhBqlTgqrRE9EBymKxGnMNdBfzVYabtCoeXUsaaXMwaMySzKpU/w0JwlQTtnW7PauoVBsuymYLSgKkgNgzBOGwaihCoIsnCImT1VChaOmeQzQIkbNJujWpIitlQCikTLBY0pMliKqFRMttLdLF5EQqoiIkQpZjFDGJDNiipKyqKWWUW5uQTVhSJLxZhNDNn+GtpEzLMYxzPs5XFCyrcVn1KUtz+UpPBVzEnktauN1Vvm3sZMzRnjALUyQRZ0QFjzDbAwsvqAgj9iGvwoMeMQBBIiVVUPkagqgaZhsyH2EkWajKRAqMaYRAGj4pcyF7VvqGrqUCFh5TI0VqrPGnRGXEQMPTUeDrG4/Q0U0+3M7umtMcZ1DVtgNIxLRY+bkBoRET1zREaTLACAMGlZTRskQ2Gey+gNG2VkeW1OFLlk/AhJd0MsWlSTUYSKuQxucmmSGDqVUehIVUJDdbC4RisumQszJTxUKnjgqaVQilAuApNINKsnyrusJluRE1ESKMLyryvu1asvle3XuVGpPDH1EhTjq+Ngop3G0IKFFH+x7SqIjyWVXyGxKo17tMCFMuS6W4ESU3UURzWquZ1kdX9hhE4FGRVgJZLcXqd+Ru/BNKvRAili+wsd8Wg0+X4SFrduQXKEHMSXKcvRIKWU4VePW/pfp+8q12KEr5W0E6yUa4tYEA6YeotLw3kHxLumzO7N0jTO9hQaPbYjaYFqHFbZYMzT65liaw3zTLLG/kvp5uHHpffv1f9Q6Rn8+HKu48K09sQavvRsgKWaPrcsfHZPGiTzPN1ew32I+feJAjx3k0a29UhXnrm9NwdVvu99R9yQt4xDpEh41vOcxNX/+N/FtUvNnevbdMYzFrj23i0beJ0p+iHZkiBki2E+y3c0xZEZrIKiTOTvhDW3VljW1mvqr8qATWiK/mQw1IXDijpv5KWMKLtgbuPGmVySfKc7GEdyukjjKhx5yF0xu1IJ+5HH9vvqtNncvq7rrNYTwkDdCbYsJqo+h2j7XLbe8bWnrySjk2wGaOwzXjbo4xY9twZ6zW9rxp41J4X02TVgPs4rBjvsWtp/lyy9vBjN9rQN78Oq6hSQ8yYzAxK9jw56yeau7srM+pbcPd388PUW9swKTbexo0u64iOr2xbO4WKU3je/u/tTVaam+dxr0ziPjcDdt2x8a19Ut8Zx/bFf9TMQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHZ3dCBT8AAvGtyECn4ABfUkEqGRmAA4dIJgchIAJ0gTzMJLFuO2SIh6XC6Jei0ej1W3vpAFJhDCBsYdhyFvu278vtXn0fZ3ZK5a9n/eaNxNy2trsUEhx3HcawwkVOlBNSiYpKk5GLFZfsbp7dPbt53+Q1SSipYsUmqbtPL5XT2sM7FmJtfa/F5fTw++j+RSkjEYhyKW4w/kYpJRDEOSjGMSjnaeXyvO/vuGsL1LvOkllJYmLGsN95n/55duU9urn3mGFPLJZe5n2/q5Xzr5/lY1nSUmG6+du7XpKTWFSxlrmFjDn41Mst575jv//eWfdYc1lr9ZYYc1+GsKgiyc9AAIRGw8fDD5632/iyQg0ksex8XXiJGOOsRoG+c51rarU8OPxLW8dCINcZw/EzDb/2444CpGKRFf6w8COmxOVxt21zpiJihkF0SBuYFAlqzd3Hcfx/H8jD+OA5BMd/3/h+X09PTyuMdhyMSykpOZw5Obl9vsohiHHbcty3fh+33mGGF6ksVMLOdJLKSpUpJRSY2KTXKenp5fbwwqUlTmNeVxiMRikllipYqZ9zw5rDVSV09e3vVT7dJY5jX33Opnuvn36nK8YlmH5559zpMKSxUpJixXlmH93lhhhbp869vPPX09PT51YAUt8w8A+seOISABjsw88DD0/vwkAABybMSPUcHsQjC31JArhaOLGIDgQozRPgCnA4vEFBQInoG8wCkwsUIOOkP0J4ehxE8OMiIoMnySJgiAypBkkHDbywNgaYxgrUWaZENLpxaaEdhWLiB8YxEvmtZdWkeSZMUoIBkATGZFnh66hSIgqK1GSFGIxMip4zJYXKWgt4FfEEwtgeL4sgqnxxCERPB1BCIT8LgKQ7yyThXLY4hzpBiuXDzE4XGepEvjYLxFzxoXC8mZqkCPl469bLUsnyqTZXIIWRxkEIIecuIsoomRWnDJJIixAlqOMiipK/aiylWTfeymTc0PqWtSCf+maLMUF7o11o7bf1fRev//8AAFMm0SVUZDvF+GIRxIHwuHEHitwHZJEWAeIHNh0BKCsByQCngMAmT4swniDECUQckRlyDmxOF0WkZIvJGIavNhYBYx0FEgJOkNJkroGrKHASZckXPopk6snRnUGRUpIqCFx3nxcBcTGqWSmalYixHGJqs6TpGmguA1L4zB5MghqfNyOIsUikTRubJGJitZmimYmpcNGQNGepSyuXlOgkqtqKKNKu+blRboHSfJwnGQNE2MGUk6knUXi8oyLy0b0Ukl9qLrQTUgbqprTNFpretSD+3SRRNaKP0ev1LX+3///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACBZsw4dnAALCzIiQ57wAIeIdAAzh7ctBvSCA/CW5rtusMnnIBoNE0icL5g25Xxiik0a+EIhQQBFLXE1gLqoELi/qPSl4WQbcFzTAEiqr9IFlrorVSJYLbYayGUS6Nv6miicttnM7FZ5nbGWDX5Y5UNRpdzXoegx2Zl/Yr2W1JPGb96UM6a9PRqmgaNYKHMGcJ+mZN8+0oizRkilBnKh+Zu0tZxqOZuuVL3ypI1RtJWK1llLutZZVP3ZyU4w78Au0/TpSfKtqCo19LjuU2IzSxm5Kp61e3jS4ZZVcefc7f3Xxs0stx5rW7m/12U2bM7fsfjWw7Ys1d5a5n3Ktf3zfceZWaXHKtrKn7SDPyWFCiagWK3jSiNtOC5/6gZLQEqOJ675WwUaeS5jnkegUo4TKRJcWBXp0YxfHJHEKCXDyPkSpnXP5XZRQ4g6lEw6VFWKzNDb1cfiMtNDFIKt1GiRoemLNV0XxmjWfXkjts80kGLEXLqzMzMSec1QaSqUzCy1VuWRXZtLlSp1kTyHN6840ZmtJHlhyqxYnttPXfMcbUkHV6W+ZrxbRoMWL58e0J9uFFpv/WN5rvGa/Oq//daWtjWdV9fjFcbzelty7hDgeBoOKPRaMecGBYGh5F54NPJv0+yiithINOfhOk1RmXmmIa65hDjyZBAa5CyyqyDpTYl51g02wYo54QBlkGnGA4NMhIMAT0tDioKzVg1tlF5KBkzQoenXVjUPNKiCmacbw9etEAq3Qvj8hnIejVqYvyV3qsgjTNbT7dxI4l2JukhLmXR0obFVCuPJFOKulmJ8QpOoEyFBCVCFHU+JMtvkPSi++PQqz1UjMy2TrxoVqNWZl96oXF5HTiJaEUpHKBK8g7jq11GxU/lVCW0TDbYEkfSeg5vAVW6sm82T8CR810zH3EhZfMaahWYdObCwqm7U3OcZvmkfZcfHtNBYIV3j+833S2/n1xu14EbGq28l66tCr7Yj7vbWa3je287t4mf4GSiNkNrYHTO+HyXwQMIaW2OTsTEK0qQRltGqKLuDgn0rp20N2nRmy37XtvwxJ955FiSTr0K5ylUtmpimliHyUMzStgGUks4zbhy/M0tv/rlzaTCtsqqCEHWYq5SrAq0ERSJWJrBYK8l7ShDiZK5SSBZ6JqZELm2TpDIuQ1acVFI4cUZImjsLXmorBONOlGMyk5VvnGfg2trcXJPlCqmlHpLUzGVY6KO1ITQ5Bq3wixrX1jajLGlJyUuT9vITnmXO14f1uRhW42zadDvCO/2hXh3WMfkvMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAc0ekCFPwAC5a9YAKfgAF9KQTO5SoADtEglpytQAEQCNpAgwjhvlkhxAS4k/J6ZS4S79EYWhANNTPSSGm3teKcgKJQbegR5k62kLUcJFu+qjK5/CWxtCe2l6Vv+jkIolC6WW1L9edysw4NKm7WuW8/t6ZBR6zrz269LerVZTUsW8fxzlOFvGpOSjK3KX9vXKsM2uVsLPL1WdzsXbc7dwt52q27nfsWt4/L7n8v7q/zKxKMZTd7hjS2LGt71ygq9u/hZ7Z/lSxZyvXN9yrWaXPKzlnllUvXt2rtnnKv1LOG/pq2/7hj/7/6fHdTL/yy/XN/jh/5c5ja+fMOTF2UJ4VcSGzW7s6RFTshHG5Auk65gLI2XRjngPURaUcH4gGJTc2ydy68LTlZ1FuzsrihEWAl2MDaxMRf5XE5LACVhNN+5QjwekpSEw4jL5+G917cbZeBy0NvHDDueGEfp692rb3jDWGF2O4V6elsV6uN2vS0V7Dud6Hc7Osbdaezzt3sM8890FfCinotS45yq/hruP54f2zlveF/tmzrnb1rPescd2dTtreUps2NY9+xvdjHGrY1PUGPd2ruWp7+c5Xtd/DLHD8uWblT+02udsYZ41dZc5jjzLeu4973u8tZbyq8+xBx1WM6F3ujR760AAAwEBAEAgGRgKRiABrMkAy5k4QwBIEDzRlpE6OMDVPgPpKrGTQA0OBQMeEZBBSZfTAxMAgKAoDDAWQpTfYAYMAYbB4ccI0RlxOYGk3YR+TQjwDCYTAwyE1Pvc+g5pDSwDggDcsngMVisDDYBW1N6qakGTkoGLAbOD7ABCoGHw+AUK+9+aM767BZQIUD1BpC5CoLkFyF3ddvqWmb7aCA6RhBc4GzAYEAAjQLQw9ccYNnAyJ///rf1Nh7gAIBBsfHsbgcooWYLgPFoQnFLhiQiv////v6m/b//MiXNDMQUFkFUlhCclyUHAZkEEJBoEXL5uOYOYTg4y+boYACEGAAEBAggGdLwtYpjKJwcgAkCgaGMS5BRS4GPioBpIwKWJzMANVgsDJxcTemRMzAxoCAIBQDEQedeb1MBhQAAYlCoYyDjFKNtRobm6AsZHBqgDD4dAxCFTr6qz7J4b2AoFAsjDVgGNxWAUL/7F95o7FgAwAAHAAkQMJh0DD4dAGE//NNP2AGCAWgBfQZoXARcPkEoFn/6C3N7toIB+Yh4ZYAIBwGFAUF7AAgOHrjJg3MFAf////iwBaOIBpE0SxXFyDMFQ6OeRMli9/////////jgImTZPl0c8XGP400CYOm5cNSfWmXycRun4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAl3dc2HZwACmIwZ8OSkACVN8S4Nae3CsDOmQPSluPjjeIOI2BzhiHAKgCZAmUIQACwVOBIQkEBrzEdIqUgDiYeEIAnM4PGCTKYIPF7UjU6U4F4pIzkRRYZauVNVK1ilVUs63aRr3W+159JqfeVW2dUUSWnoHf523TXPBDB0x0R4CdR4WMplxAv+v+OMMdBckMMWTxYi1lkaPaK8UV4lyhOXk0NS6HmQKGJLNKSYSBUxbvHHFaO/cTnqdrcXhpmDgRZ3mBu/FIdm4xDk7DeDvvMvCotdcTPoIiMNsDf1ZrKXpexoEWljlv1AD6RCDJiUNpII7K4/G6R7I1EKCXU34Tk7AEMWpfF8rlSmk0hisdldSKTsZj0c1Ty+1STl2WUte7T50lLM5T9HaudyqcqVK1bKRyem1he3b7vOpSYOUwJ0ER6alD4+26E0IJFKKfXpIAPkjWFYKpBoEhMRrjaQq7KyM5NFjMbIf1WHMpstRMJXqOckpWhhAVPzbqWNponmKiqVlQmg9FNGfM3FNGjZMOWk0TSIhUIkQlMim7VMt5Kc/UHT1eeMxSjm7uqeZuunqsWWXWx/c/Vfayv8uMX1KX+3HfW7ctq1VYxjmYs0tIGgoQMBdoKiiSwoQcKJCijbzYqv6/FCOosW6ZaoWIUhmUxiAgk6NsBEj8NmPWGxhHFMGhUG1jGbOGWbmoLmcFmMCmCIAY8kmqGN1VbVBYPZqpiuZaz1V5M0l5ZIy6B5S/r7P+jyqV9V2vI6TErMNO0u5k1G8rMS6oBAF/mLLAiYm4TouR/hDibL43TFIMDOAIgMxWEuIUDaN8B1CMoEepNE6K5oP1CR3AZgAcGiSIcRusA9ROlahr2R+bompkqR+csc6Va4p1o6eQrqdDUMFiaSCiwsJ3JY+TJQLknS4rhW6P0SUTFCXp/IcythbjqjYlVMRlmnfRYMzEnoq6UTNDVsVifSH8omaGraKZPRcPmaCoawn2E8zRsxXHV30aCnXsF7hii2w+fWzFr3z6ta1rjWf8Ws+3/CjbnTrA6GoKucV6fpZfCOD2LcZIR1XC6Ql4G2j1gYDAgMBwIFxCyFoErFkMokyW0lOFNd9okPKilyTS7RVxFsm0IpCw8ZVSRE0ioqmQkM2EjpwERoFyUwFRSzUZG1SjUASaswhIS02fspSTJZquRMtKmcYXQEyiOoLs2k2Fpl8ddTyariopZ/37Db+Jxqca++NylS0pP8bVZlOOX5oUia8jdKsytmLOPERtYiGnS0bw0VW7cIlPiUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJO3JHA3rDcLKMqUA97G4jcc8QDesNywCxowGXsbiVK2o+jJCZQdmUnJlgScsvGgPpk6Ea6ZGGKRVIQuoALpBWcxEIypgxRICk1MDQITEG4+ZomXGDgqQKby0SIS4aaCX6aub7J7oqP01VeS7WnpgM+uRlsCT5AAL+pxJpEQ4mMjQ9IF2mEpKWYwuWHoGYs7j0qxN4rvNIsOApWs5pqOZVBKU2CsLWEWB7ZeRGKUsiR0CoVDmftBVrVAwucaU/jPZmacWMzVDDLtO7D9BLWbsMcOdo5BIpJTQrCU5SKGHegezWmqbT9ZaeKL5XL8zOU/5RaE0+UTikNzURkcUh2LSuPROtB2dyxRzcs7nS2qbdNbosp+5ds6yu1qtmplnRVb1qm5T4fnnnzCmzx1X/vd58/nMOaqhkSNDK4S3SBxmh4sB2JGmR/hqoNAWGi4HwGeAkqIJExyFhQ4mTYpn1jSWnJUw2xwbttV26el8Q7altRzYMeO+bWJKOTmhaoVagsvvlbCiv3j+BQdkhOeEMVHpLOE5GEgJCmfiQOIFm2lS7S0e0Xnja5DOH0OsT9KcrU390vlRlw7chYq2xvI0kaqjbTiRe0zaj/Vmetb7Xhhaq9zdKPvtRPU3KPw0r/fM/9NvTcndyZt1f6m2iCwtVMuS5YqsViynaqdFAYCHGFjABEDV2oxebNwlTkDwzF4OCNzXH8RCBgDOZ8DmEhRxVgIQF0xwkaEEABYBBCICNGVtl9VoJgxCuhOQOcpzoCaK/T+2FjS6HF/UcmcGSoKoalqUcRkQisAgLtrNZa02JN1bouqFJDOU40jhpZN1W1L1QZ/WfMfZq6Svoo36ApnaoDGJUba7eFiLpPCxV/nebi4DfI8t812JRGjpfcl3HFh2kq40LXYrk0p+uw7Unq85jY7NdrfnRS6hltDMSKUyC1SxKXT+tdmqsOymU1ruEM0mURm4xGrWqbHLDD8scqGzZjPd1ZTUyx7jjV5Vwy/7X95Wy3h9LrLLv/jjVy5rdzePP3Wu8rZuxdNKSNn/wnu/+/1HVkhtyvbL8gExraYIgwNsZDY0VkJwqKtsIRXON0GyXA3px6S+tCmUqGsVZYq6d2bVM3Vg0jTTK6WIytavi9SnMaSJTJksKpVylcG5+z2xcknqGTRCKyssAKCoeieHoFiQRglMAJI88cWs/rHMCoqwuHUNbWw6TPW3lxdCkrISM5JtHnqOtMu+z00feOwasM9PTn7Ndpau9dbBfvZZW9uPc9Dej07Xsrvfs1rNcm0zNqtBkJCVig88eAsUrGWwVO072HZ3+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3N4QYN4e3LtjggQbw9uXhn7Ag1h7cvEvp+BvKW50sCjiYi0mQKJi10aiFBycZkahAkYgBkwODhwhNxGACA6ZIBEoCVRKbQLDaB8qcGFNxgVu0bgp58lBYJjFBErLfPtqpfzaPH9NejRdkldHnel0elzXbj/Xai+JbHo1GXcFWN7MjzpTiZw2ri5yynaMU/aq+Myq6HAfPorLFUt4kKMtOD1x3/akm3G0BlePW2EqtwoVaUUT9/fGbwJbQtWlhVtmHWW8WBp973iyUziLMxR3D+FXWsT6zq8S8Nl1vOYUSDjU1bYzu1aWzLNvVPu+sd5LT3vaHqtrZ+q63jN6Yj3CnDZxTfXHUPs9bHIio2JGgxIoM1SzHoExnOMVdzQ0Mx4bMfBgc/GWHpkgkQIIOEjVdIY3+QNMrmJM+YOy3FTFwkkWcyGYa8y6PJ1NHVa/MsirJYKf6WWq6E8ijqLMyKp1bygLOoal+buwDJIG413KHsrn6W0sNHwtyrQL/BOUayx6ORMTZZH8CrcdLkrq3fPMVkjZpiXufxAjRbQ1maSWDOwxXGTTVGq2ttYcWPL3ussLzvNva71S1d1hYj2w4wLxJ/m2XcCNBpTfr8ZtnFK71F1qH9Qq3rLiBmJLWfHpXWbQvR1TOtUvCp205tzveXJKmczk/3NFFNe/s0yXeC4QQCwbKAqpH01kMySQgDEwkCFxQdF0JKYzFoqz1ksPKVKvQYjUTrUMw7Uno4xD6l0EsEpn1hxgMBYSutPu5KJXciYaIZcREgq3jLdTtJGY+qrqW1YE72A1XHzGtHvR+8Z4TC2MS3elXFnxBhwlTCXDXGi7q8fp2FJM1XfWkbW2FAhNkBvq8dKFtnZGGiKd1zO2v5r38CKx7hVevLzRdNcSRlhuEGaHHhVjVrCe+JNRskgQWyG8vfeKWc3lfvcfMWZ7DpnTBm8/fwM58Rr37b3bHtFtE39YravtqmsW1rGcSarSbWL2auzvQxeb+y8adYw0UM2Mjh1AKAJuBqawommCiV5fUEJJiwooEAAsyxES1hkjUrYaTyTPWAgJpbjph0DEm/b6YjaWMyNCRN4YQl1JJ2kmK5VjIlXf2tM4ThmMeJeqxZh21DVLDMpSbjUpo2pnSBJgWM6XIYDcRIJF1B1MnEBYIE5Q1JZ1B4lkYXEopJjplAiROaWM6TzgmrqSFAZhFI8KYiAs3EiL6atGy5hd+1EWQKpnrpTUXKyJ18m1BNaEksso4PImImbm1PU25QipmG1CH5l5K2ai3CcdPzahmeDOQnC5LKqeCcob52g8//BOOLWpeGQS4rhUhVDmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdteUEDOHty729X8GcsblzKJQQMYe3La0KgAZwxuYAVtCw4g3EAYMTInRrNKJg4FGVdKJU06H5qfg2Yyf+kWj2rGrlNHb0uxiDUW4s1mVJSmVOtBeD9QUo1LYI46oaBMoohLZVTzO6a9O1VTS+zD0NoZppohAFMuVYxP3jFAh1aozXItMqtozNrdGT8yuVkZ0tu7Pb0rFgRYMuWWP4ingMUrC+gxnGNRhlUbK8isUWddYupocO7ZeWPWa2bP2hzezMzCr4tozqSHEXFHytiyN9Hb3wHj+DadxjYs9maYNLZ3TrcS3eyRqStUaaNHrTOM5fwJdbpW148TOM0va3rI6sGZ9V+nzONbSY3cH109UDQS2bEI7KNaFLYyWPFpjSJujQnWbDTOfGJLeuRhsuNx9n+lzdX0tvzGFXPqkzSsCdFdLToJkz30BIq4rSrrak6gwrArswJI5byJw7hDCX03OxK6AZH9VI7pi+aD0fkw6YViyVieA+HkxoWjEpGx2tMio0wbP25uu1aZYtDWx4fMrlUMKE62XR6TFVKTz0cC6SjGh0lQaPlNKVF61VMVvf2p1EcGSU/MV0MUfqFiiBbRqaHRds9ka1izkDmuUTM9AZzFP0epuUb3lxyfvOr3ujdaq/Gs6PU71KRdj1+pfLy6koE2iGGgJNxl6GWFJpU7O1sQAmMa+IThpaUqpXdgrKftSSaicZopRBqKVPhYgWxL565E6Rf99Wh8Y1uWby3zbCrcptTQCnDRWqWVrc1vfa9pXnccsS5u8qSOLisKln8SsRsjzyTp7Dk/orWBQMCuhq15Ay1e1mO1GttYpVzFtJDgVtid7jWo7M+ZobDSrfafWLQY6+/vpygZlbMQG+0BYhq+rJPhvjxX0Zwk33uZ60iUrErDzdwgxIksOBEjf3isUOAy/TU+xCzAjQsSXdeLNr7xjECklMvr6j2vFxmLafVsw61zemfTH3vPpaLS3166nyB30TTUXXsvxNIwUjbiHwi57Lbr4PhG5VBEPQFDVJKYbapVltaQVZfFbENyxWh6lW3YZxWC5/KkpVRanJ7TpHMZKeL1Z2jy5nnjPLprbz67TdsFsTTdGm5fZS+ueovXRXZSLThQszonHcj+zz3tNIdUJ2+RyxE59V7nUZXMJrUrkdF7ktHZbO069byyj9oHOXqq3T2ZVPN3da9br8XVsrp2uUS7f6+x9dOo4I0qY5eftHXoqtz9cizjrlzdYr1vR6GHmptRl61Gezs2lmpvf3Z/r7t6bTmONLNi8naAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHZH1Agfh7cuuxN/BjDG5d4iEAB+Hty7fE34D8Mbku4DSojFCHlhETBNQh9JAx4qng9qT74zVWM9Hiw5PR1v+VpZYxstMaonjK0gKR979rl6eg2c1JGyiikyyjj1UFe/RXrlvJgeVfd1M98JnGJGs3Nz9yc0+2Nsa7ghVILkxoQ/UkSBmFIxxqQ3N5EamGFFywQU63SMtXF/O9YYeFBdw3Zri1N9yUGJ8P3jfGcYz3OlLFdYfKF8oITPGe13CzOqKP2Fs3K7otMLhd64sMkt4EzUxturwat23Lx391U4NkCLLmfc8OTUHMGW1oM26zZvLAvPXNJ8V+fC3TPxukCC0NCEhYP9PKZNFVRdW0nqkM00EvWCamOsVWXJAzrv5dlkSjDjPhBM3F42zmxblLmyiHpfQXcxoaylwxqX11k2r+NmXLRfualTCx2BYmq/PCZr08O5blA0ahpaqs6MXEiQdqpoTpGmocImXjF15hYbxjojY3Gkb1zx1Omlx6FiND2vHlm1kZ0eX2hyvfeXuuw38jnK9aV2uxQLR5KpzQlmLzzzbDa9h7zMusVkv+eZ1buNreibKyGSCW4T4XjtT79YSy03diccLD6GuN1mIsagrXl3I6NPt4/0M7eCNY7THYJ32m785v0rPZNp1nqR5rk7elr1vekOrMlCDMNMsRCC8mmlpTfbJ08rmuFONag2Xxp58hpcHw5GHCjluDZdEI0oGVSKRaIy3KBKlbDDCDZytg9RqaSXIo0kol328L83KF3ZU+cjuPCiOx5YbWV2qYNWSZzgYbnV1bOroO4MsLG1G4RYiYhtdk3p+5424Q1h7BTjMu6xXrJJPRickTerc5PJGejPTNYFq1fyPszssGM50npDXE8eFHcY+sIRSDthe7XUFOvo80FvZVKz7jLOn2LeLCbvrDCsbxiBSmtwJ5bWtvwM61evj0z5KahT43mt831jMP7rTMWPiL71zfOL3xG3m0sLZIl0QSMFkpTyJcLMK+eaDQRbzdWyxQYHa9GpIvjN5I+qaB2uSCG3QlfYeaJLi6DpOrRSDN9M5icrTNVWqmpH0PSRAcavAdSXRi1A1Pg3RAZOxvNyFdKmMYxMKEzMNDdErY9zD/n0h8uOI2GTF5TZN5yvxVdM8yrWnEq1ydO4kTr2Dn3yTblFaiewUtQmnDEmrSEfGZ8w5UpJDtpXG5Ee1+E1HmG9mnzuWf34y664XYI/GTScksUUve/W7qVwx5otR5HClihXMOLMmGNM+f2u9NH0l3kzCptW5WYbWp37/91qWpmfS7XUtTLX/mfVN2vFWhAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACY19QsVjAAKXLhipoawAJrpBLhlKAAL3SCZDFNAACAEABJYpawBQAxAlCc6G7T2IICAAI0CMQE+FG0r2ny9uAIEZiGQBehsIFGaVnJxwgbkAIiVkdTnQfVeXYRUdB3NblbhrvUEWJFKGA3LKLJLtfa44kUsYYfVf9ZjXJ2PuW5bX3LZ2oIySKV4nbr07/rsSEQCIBEiGCO5LM4g1hnDXJ2Vw3PMoSLU3kcsjEsqy933IdiHKlunp6enjEQciWVXDZ2680ztYdMdQNU790DsRivDa713tPkb6M4Yg19nbO3LtNYWEU0hExORt/3Lh/J9GcKDqDrvcen1GH8fx33/h+nzqSyAHIYe5cP195awpH/f9/3/jdPL7fafv/+dPb7Xt26+eedPTyyxz79evTyuWUnMbtPT09PY53PPeedeksYZ527Y9weXfDf1uQfchAAx4gBgAAEDMPWIIhU3Aw7mYWV0z71GMy2t0MkeCA4PvPdMYmbz1nheHLiqiOGOthw4cqXsLWMZy97GMQOHKlMdg7DQ5XN739Vyu9jDjN79hufXfM3EGZubm59e2INe8/L3uQebve/fe9N7/l72VXvm3x9cTvYzniPYxjGM44ZTGMYzYgxjGMZ/sYxjDgPh8oCAJn8QA+9VXqLAY4PsCgkuhQYBjgAEh4BykWsLDQ0YDAkQLEwMobAyCkeQhBAaBABjjwJlgMaQBABD0QNsQA0IEG8ABoQCRME0YCgwaZDhkANEuA3C4BhYBkIIGVNAhXgbqOCEMBgCICgkNkAzQoOYXR4LIzAGGCgwEDbEmQbhKYhYc4bZiMmHSGJGkQGNC/o8jJE0OcWnWnPEXFwDPkYNUgYhImOURrMPk1XpGSJMiZEaO8Y8fA4CfFrHo2I8gpZIiPJSQKKnMTx5Sz5sHuF8XGLhHKFKC4DUQXBQIF/x1DnFYxTLxeJ4nhjhKSRsmZKZN1IoijlwgBoSBuXCSRccY+BwFsZcpmBAiLFEipFVJHyiRVFJaNuqrZSMkyfLa7rZzQ+YIs1ZugkaKTW75MsYo6S3QWytH76/UpTf///mFAyKDcjFgL4XBTCBC4EIUNFoJYl45yGO4mFYw4cwuHBkDMO0ah8KAmZ80L46gPQ6oFwc4T4OekeQQCrDKLrkokTCXMkEDhqm50voozx9J1UpuzsdTQM0y1CitlrZValoGw9C4bIuyLrRHoSQ9DR6B81rQSRNzc1PlxJAuDgKBkcNjU3czckkDK6anT2SpoUHWmymYzN0EC8iiupSaCJkpN6Pb+7MsoNs6aFBF67oN/0lJJMujS/Xq/2v////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjIhsiHYwACrYmpNOewAOJaHRwMYe3K8LPkAPexuKz/RmGEqbbImfNmCzhDhCQFSiEKu2mFrGaIzCpkvVK2tqCKenkzxoJc1XbxjwF6L5Zi15JBnr1s+Za7yeaNSFC11VETG1p37ZXQOJPMMdRubE5c1hnEgjE5Nw/cfyxK5XLOVc4hDFC79ND8xAlC1t/6R2HclTKIEcNr8ecizbr6pI+w+D2UOpE10PiqeNM4finjdPVp/32tnL8n3dvTXJNE3bl9JL8qScxlcbypL9yHKr/25iMTlJYr2+3Kn52MZXbqWIm79p25G+j8R+H78Yllu3QQxOw3F7kOUcMRS7G78ojHJRSbz7qpunw73D//fd56w5uvnrP9/rDmefN565/7z5Xt6pL1enyp+1MP/Dee7faljdvQkQeIIAAAAGdxmxMmSQpOklazlFqTyuPA/UuWNWX4nVAktiCXBGfRDoZDuQ3BCZLgLIxFskEkvkixdVNTQ5hluNg8ihb+6/Fjja+OBu9GKnZ/AeNLKr32DymrHDMt2WObf4KXftSE/RHZPgPObb/fuvX2WLFksdWezOzumep25N34KTd+R8ARHZWMD82u/9sGQ/M8AjtD5Pf/TzP+fAiOD4GaQeIv3MsIj+////+Sf5M9yZ12BMuLqp7Jbo6pMp9HGkHwIo61BJYBSfwvcw5YMs6mYikpdPqVF4kCy7IGazkZIdSPnLFjRd+UtkB1GvlbkrU1chdzOon+LhO7YXMrqG2usRiDDli4ZMqSyiVspPWtlL7EYB/O0SYrecqyX4tyfMmDFUMZDj7HyS1DFEcxkoa2tjGnSgDVFiL8A7FcSEQ1xqnkKa4UZxirpDpW06o7K4KZCo+oNW164MyufvWWHrq614quT0VXM0rKy4s+iM0j6zcolKcrs5VlTIU7Uqtrd69hKZVPVa6e6YldtSqmAqqQn0OsW0K2cZgR64xnFfn/Na3rqFmtcf/NMXr7W8r2j6NKy2excb+N5tl7qFbMXQqwqXyzKVLsthaicn8OZ3dDVMtRYKyu06yqZVP2WLVhpHSSOU44Yqud0STNpraMqpPR1DFo+y0vmadt1EfXvbcaCtPXLHTrS621WtFao9E6TFbjS6hl5fMTgrG0zz2NrTo6eOis8ciScqUwlLfddQgmLS5DBIRl5ZWxNLoVx9da7lnmWntZWwPLq2+tZtkzM9Wea3M3uzZ+3Tkz2fW11tLNPattlpnZloNh1ynh0qkOsKlhK4FUqeHRRIBuT/kSoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH0ILCgzhjcsavOGBh6W4jaij+DWHtwt25IMD3obnFQIUBVQMsUyDjLwBQwdErcICwNalg0pEpWFazd09Vyroa2vWNNbTdeyBYGgFsDFnkVuQTJJNRbDDLquzKHmh6VMpU1sU8MuyTFZQr7O/8cp71NXcl2oVTV01hUHyypau6mVHpJH10mvFM4gcKrmgeXtFeA+KwAxYA80PQ9F8PSoOwkFwIiSbJWYiaxVKoTQni0cSmWCr7dlFSSKhGQywbE6G8U6tPVrHGrqpat4qsH5zQ9k6aSokqEvu4ZLqZe61VlbK1q5/qdfbvR+d+08urBHZMa4timucrpT7MqYti+213Lfvf3WtM7G9LzS760mZpa1titDRwludYoIy5zjJzA0gFAj+ipGFVWmLWbvEjRkT0FiYH11FMxKo0YihJKrnr0uU596OFQnw/b4uYKtdZVr1fMEx2vUaDFq9rFhUtBtYm3pO1XEJKhgmqwaDRMsiLRiXMjLAFcs4iKCJFMhMCpCcDqAmVxEhSizUKaTWTmSjkWVFYpNTVS1pkiYqq8XqyRXcmq2WRZWqPnHtxvETeXGU51PNUahuXluVrJ5H9WUpszrKjCr9XVItnBdjU8VZ+6lc2fJYkdW48Ihj9LGUsXOGQEoLCoICjgy2YAWN0IdKHDWS840JTqFgzHy5TKY28rdnxUbEiM2L+vzKnLZUhlPs8XUlG1ZxGsqmgZmkMvhUcrB6XUqU6jhnCqsqOV1ZPX7djsM15bQclseE3YjMwuENhV6yys6w/wopKsryG4G7U8IqPZmQ7yVEJISdZvORci5KQsSObkUdAkzMpSgQSEq4uhpv0lGVUBoLk5HK1wpUMOLbuEmXB64M8EgiCWViR4pY7gr1rCScMqh9NbNYMVzV6iY3adZbttXrmfsZwTsKC3pNDWJg0rtuUWCpWRvh0TryzpTOmpmhtilVUfE1bx/T3baxYDyHB2/w9w9mkzGteuIlt7peHmFHj2zJFpGex40eLEvD3uSHGm9bEklAPpFg4BNSEElHugDTTsGChKmUTZHhJ9hK3LNY8pcN8V/c4W1abjj5bXKFbEVuj7tlDlKKtr+nma27ahuvtFtMoHlamoUU1VSkVCDTA5SjpEMRhUdIkEZqgPj0xQGzsPFA9YQiWBsYtUClLMobRQnk8aqRY9i2iijrpiWgakTFF2sMPjl0RQ9K0YmHU8agyULu7xzw5zoN+HqqQaitEw+Kruh6EjdXRAwuJ1iVN2x6/5dd2Xf8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1GIQIVjAALb7rgArDwAXbJBKxlKgAPkyCRHK1AAh9gTX1DHWPDwUEcEgiYA1NiUMT0Skfw7bi111sE66eRce/GbiV+xjAUsrP+y6XrDa7TWdX71TOC1ZlyFB7FJ2ns8lfIZW9O67zf1MLMbvWN6qWaLO9Tdq2KneUs7VtV87PKGkwuz9yco6S3Yu/+7k9L6KpvDvL9S3l3Xc6upbYpaXWF6XRGet01JvHVfPuquO5yk+/jGqa/W3Yzzzsdr/WrTGrV6mmZyvZ3WpNV5d21XyqY1+WOf2zveNn7PcL2eXN8z7nhhWqWtXNY5bs/Y1l/db/8M8td73WuX995vLncuZ4d/mu4ffZWIsKT2StEgr6MjR0LDElGxRZVZ1ItDUnxgWqjeHiwm69PI/y3zSqlVG86DsOw8F0IjAU+ofmoi1SrGMkYAuL4jLawy5pe8BEtuZp/qkCGPUpID2smmWa8bFbNmtzMsV3Du9lfWhP49YsOS24dMXwzK6SLDvjyXfSONIyifPpWJzmpJEfP48WFErSe8W1a4i6WI8KjM9fsWYOZXr2lnTY+mhbfNUSSM9q8xHtaD7YzF8aat9zP6xtN0dhi0fzxYUKG9ezZpeBGzfFrbtmHFYNC1tzNA1onOFuET3NVmIQAAAEIAAkF1mQtYWfaThVAyIcA7Jl4ggGXlgfODkQcDZykA0IXn0FFwAYsAYOBwWE0VzQnHgYLAIGMAwBIEHcwegsvuiAQDgMQCIDDAAAIEAGPCN+bm6mpgZACwGSxqBh0BiAYZgTv/c3U1SA5AiAAgEAkBABQGBgcAhZX/zTQ0LgYOAAgwxGfC38QDDLAZYHB//3QRdBBYAwAC4AWAVuLUNgMBitiRAKAAhX//3U1BkP4YLBsYLpfC0cQDJsMKFkrkqVi4MmQD////7/t//f5oUxW44ycHIJAjh2E4RguQcCaZmRBErkAKhgUGQbEAAWi5SC3YGBwenHYSIGLw2BmYJZEhcAGKTqBq80oKGQL4HJnYBr5Fc0SLgGRgMBh4OAEAl6EnCouBh0GgZIEQUBIYnWs9lxZjRAwUHAMYCwDDgCAxcTgMzGy+jNyfUykwMvCgDM5DAGH5EwbpgFAe/3N1TdRoLcAACAMJCADEACAxKIwMPhEA4H/9C1BA0wMJAILRBbAAQGBgkDgMAMPUE6Eh//s7M6CEAYAA2QHGCzwssDCgGDwWGqhsAHAAQl///1M23hy4XMEQYMtjTRGQWmXRlyJuXP/////v///k4ZDmMIXEFx7mxoYEAIgQc3TJ8i5uxfNyo/gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74GAAAAk3ekwHZyAAowxJwOYkACKZyRYVrIALByrjwrGAAfxYK04YDaKAAQZCcTYNQM2Q63AxYxlzGnNws12DDXPOQYANOABfIJ06QIWEIoAWJFzlJPzHXRaDBTQnbrZNEAIAGGMUwDHFzi2reyBrSqyFUaaUhk7iCcvbApbFEVMUs6XFbstZvoedqNs5XKgFRWVMps16+yJiTlLGa60lIlTVOVAKjyWpMAUtUWaLtF3kFnGh61IZTKX9ZTLYZlstiM9WjUurP9ATvO1S7molPZUsRdl2nagaZjMtjN7t2MzvyqNT0ArCqBKBKDKBKDMGzdlyYano6uVQFTWK1o0/rutZd2M2eVst1o1D0atVZTGb9LS2f/KmyxpccJqNRqmyytZZdxxq2d/ulpbOOssNZSqNSqXd3Wpu813/q5Zd/+441cgaPfEXiJc+2hwsEmIWD8Pw5D8fgiOi4xESwBqohiOx6KdRVqDa9Yk0iDSQ0wlFwiXeWHrFOIyWxCBJLpMqKmpaQhl6T8pF0V4rGIpDIVFIlEQaFQqDUjVSQqoUMVYRm/yvJR2UF4LTZj0KsJoY+Nbv8rjcYyarpbK4y3oSEljklUKFXP/KWyRS9xjcc/2tlG8lJFKHQaKgq6Gix4RA0HSom5KJRoKgs/8tQu0KgDGkDLFghmFXxpyIrWMQvUDARIOGAqkYSAacGIQYFHI+A1o/6D1gJwAFGW5a2XiQdWigNo7KpVgQEKCgWvoGyQZAfdOlrzboTkAKkYcaWnKAATMLRxAiZMcSjDyQEJMYtLQs9RJ9g0gaODhkAsBL5VKnSX9YkzptsKd7H2X9bacwKBolBSxmvRGHWEJXTbOVNb8eeeCIQ7UPP24MpsV7OM1jS0UdlkPZxt+bytzTuVJ69Z7MQ9Fqtzt3LVNapdW7Ni7SQC/Nmhsy25jbzwxiUahprVJ9Td7+bvfWpstVrX8s49yyrU2VNrDla13eNXWWW+cyy7reNWzzPmWrWXKWt39YWusoTMll8kw3v//47OG/jnuEo7iMI0VGhMUSwq9uDDV8CiRULDIoDhBBXAoF1yeDV8vLQWo24s5TSrHGMOCy2HZDUqx2EzSwr+xCN8mH1wdmwj1L35eGWyWEwFSS6pHcIzEX9pYjLb2pdUntP1Gp6U4zNFWpZqTSmzN0tJb1biU/Vs3cak9Kc6WU83KoatVrONiGpdqzKeYW6XV/HHHfbP44/2tnuUy3Vy1l/4/ll9bL8vpct///SxIRR5t8uP6ipd6F34vyTeE/52P48O/2buFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAn/kEkeVqAAqVIJQMa0ACJaQUYZSoADHcgo0xrQAAAAAAEEwoC6DbxeCQBAABwJDcL/ASCwXeF9AMoi8DZJJFxiYDNi0gkUwNWmUUYZQYRPAa9HYGOCAOcYqWmbANAEDCQNAxiCRyj50jlF02SAwcCADQEAEKAuHYmSQLpmaJJF4yAwIAQMOgkPQBQVABBQiRWUcSWaHV3YNXgYgAQWfG+BjsKihES6sycvGKaSToUEQMJgEDAIXAxGCQbCAYGBAXsVTUl6DrU7rUgBgwDAHAAWADGIhAwCAgMLAAJgwDFQqAYEivRRRptT2etSMDFQUDlRAMFA2HGgHAsLCQDguHyA3ABgIFJOz7s2l0E1qqQZ6XRAUCAWYASBQGgWBh0AgIAgXsAGCguAcAbWDcgQYAUBA6v////////+Fp4zZPph6gocQDEJw+cd4pd5GiyyuHrk0QQc8tlwTmMYMgTmNInxFFmVl0pj2E9MDAPZeNSkZEmDvIRLGqAAriMIqSvIAtBG00mUglnyXE8HgjLyReSpoIhYCTkcL+HITRV12VYSgHYO8pg2yXSRWq6L38plMfw544BhChb/9fHoeNwL8T4LgIABeFH///wqh6SAsw3wQsZQwADcHD////+JWF7KRKFponJAeA5ETcl//////////NFm6JfNxzvJdTG5IFAch5M0aXESX4rgC6EP8EAUfhDgMaIAUDADEQJIwxKHugbmuEDYUiBoFIaMA8YBoEWAZsIQAQ1FaDdEaAKAEAgLgHB4DF40DAgXuBMGCNB4HCJYGPiyDopAvEXNiudQAOAIXNEwCIDCwDfHIExD4ScLpiM8aF4N8Dmk2NIOSIuRIsGRiamZEjUwSPxqEwKaHoDtE7jRQTQSJ4xNVpqRQWxJEUGUKgauF6JuFnidTpIkGKRkeLpgT61rUbqmyYyqYswT0KyIUDIopIfJkfKR4sOThobptSZBJ1NRZUZ8nx5GWIEMmPJDTJiHF8urJ1ExrQMUfTOKTdSlU1p01KvKCCabk6bGKSklzqB90mZJ1GyLarrSQ22f//s////+AAAAAAAACm5NJ60iUHaC2lATwOWOoIQXzgSglAbQtQtRfCzHOJmSpIBFB6pDnJxLtc7SOkVNA3TLpgYGUujnMDAly8xopEnkq5w2TMkXSQNFKSTqMJmSBqS5okbpLZBFNnZSjp9E4gSR0nD+eWpzI3IwmIzCXm65gmYHiSOmroF4lScSpLGKJdHsPUmFIlCXLa61upB1pKZOcSUm60GSRrSTSsm1VB0WRMjial0mU6HqzRl00FXdLuja2pFXZG+r/+3+pX///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI/nVJh29gAraMCZDsYAAkdecYDe3tyrwtJMGMGbmaaUvcwc9DikSJTVaIKpQWQDMG82hzBUSYwamLloc/EUwZOqGOs5rZIY0MGxtBq40ZwwmnLJ1SOCAwzcyAySX7AhKDilRx3mxUcBOTGlMXJd/rF3hhbyPIvRSyBZYiwzhcqTa8X/YLBS7AqAJjMO9usZf5xn+XVrJ6YzDULkUvp41lK3Jjspyfq1L6XOdi0/el0ad6RPpNMKf67DkumrEmvS2XshkE9fo6mU9fjkTdmhlszDtm4+stqy2rTQ1R3o1hD0NZOLcu368in4NobkooJh/n+yt17mV7nblamtchmTQzDsh+7Oy6m7dtbpo1GrlNlR7ltm/Z/HHeWFa//NVaW9jvfcq1bK5zPVaUy2zjjlla1yhiEd/ur//xJFKKLRfswRKi4KVqxkJSQTQZUnNBRnMmskYX6ZzEWSl0guRANHi+JAAxoqRFxZD3m5bMyqHspVfuymU01mzY1hherXJuIw7jcyy+9Xq55547yzq0uGOH43sc6a1lrmPObxxq2caWlxyqXMbNnmO8q1aXdpo1LrWNLeqy3Kh5X7yt2zzfM8alrlz+91cywy5/8x1hzDWuc/DnMNYZfr/5zWq2Ws8su5ZZU1NjZ4gqsUIqBoGaNXud0GP/aqVJeq2mpHoEKjArY3XyORSjR6ApMESjFxYZYTNGs6CXG0A09WAgGYIAmTjxl4MYWCGLB4MLDASM1FiDFpQudclppbYtGTAqhyv1dQ3CmeJVLeaTDTQ2eqzKBPCyJDoieXJglR2mblK1KXAfptmpNjXi0hvhyiSkJRh6ixNZ2Bqh6mItw/lwoYtISHA2jynJ8S1QlxJrEQokJSmYmlNGfk+QpbgPmVmYkdWKok9s6WpXdqNJ+XF6rjSMqVhu/etuYSufyxKttW692FqVzkr64splE+fRpqwk8okOfWUxzIVWLhufQEOQ5PMKGq3VXyuYk8y4ixc0vJdqvR85Rd2xatt3m3C3BmxZ8+cpHK1Xv3XVqf4xGtCfWmayGwXYu/Q2E/dsmhv9ni9yGq4SzplscTLlLYoFoqq9hqGGHrtfMVEmunSwRS5t4KWB+ZjGEur/lu1lzta1QU1rcNTL81pG/s5fpq+92d6luFmpFqoT3NI1wZIkcSX6xLkiW4dMznSNgGR4lE5cacbM6xKnKGih2HAIeiYGJJ4YcujppL+vLefSVHBRIiRRme1FY1NrUSJZ59ZztBQXIocp7ujQoKTQf+wUK5kFBJO/Dr78Kbd/2//dfwoaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACRB8wYN7e3KuiiiAZwheIK4ZAA3ljcsqQyCBvCG5cowoKMnBTKCk/i7N/Oz4r82h4OOqjTDwzRAOoZQ4/NSRgUrGyjxrpsZTAGBEhma6ENJiJcUNxgAmZKSAYLASooOhaAhgOAlKkVXyV0zZW1Yz92VjLiZ0ssIEU2wQA1G9QVHAQxMODgJYFbwMB0IZUnFGnVclMVcU27E0hzksHanUmcLVDcVVWE3OKGq5RO4ira07K6XTsgyiYTgHqioSX0mKgIMWI/iFTra7ZUap4b6zlRqtHb1C5bXPcVMpkPiOlqNDkf7iPk7Tb5hvGVyqZUi+3RilcIyHR74gz3xEhwbStrDiI9zeVt7DWDK9guTba+Mb1GbmbEauLP3OPSP5a13a+rborqbe4ibrrFtUrWmPS2NZxvWIwBdnKgV7ytdJqbKZh1fAIPAkBvyGMIRAiEBIMW/GlQs0DJOWTQZJ8xRUxSNRxWDTIDFJVTDuug/UpoItKojILF+XUfakupoappudqS6Gpc6uL8zQfN4hgtQFRLWrFTKsfKmitVFYloWk1jhpUwI3KSw5xVaDoep1ybSsLD6ZCqaLFiAFh7EHpbrSHT2TPfJK7q2tysWUTS+HiRIVBQKpAY48AgCIgdnXPSWNiNUseqvcheoCxR8juZk3dIgUzxMCMU7FKOimTMNE9TBLVm0gBqZUa2dGauBmJ4aaqEpxpLg7A67DTCBLCBA6SBUwzyl+HMTK3Mh17ngZdgpB9VNnrgB/m0gmUxWOOjHF6trLacaEaM3S84MCP9IovDTlw7WpZzDXTJc4OJdW9E/sF0KK56tTFLIzwcwwSJ0N8fqKTUvKkq0lPWjLLdUJovno6vFQ/SP6esLasHB6ZFk6t5JKUKM7ZdMY1R49qHWK6k0dO4dgX11vly5awpXw6kuVr2XnrdGq3eivFDfsOrez1sOnoLqlziZ/qRuzzjLT21tlvj9p68G3d+269P2jeoznuqqzs2rsrbTNJ7aQtBCCYLO3xTsYFwaVmvDRoiWYMcHFmgdZLjBxmiEzZBEX8e5nQ6JOhW1uLIE1n1lxdqSQDAr7WqtW829aRbanlBVa1fxu3JBYq0y13rfi1Zq6rZ5Z1NV8LBtNaYQvIxbQseOkYOiBAeVEQYIZp5JhKZFYdTVmQTE9CYaIQjnCP04qUUwwPhgfRMi0HrVTMDjJXKbUunOZoZR5x3MWPgww6XynrNlRgvo0XA4t4uYHLBwsMXtDzVjX5aP6iB73jV+6vbi4+p4eZmPuPllli8oIm4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdIhUADT0ty42838G3pbl4SKv4MvY3LxETfgZwxuW5IGgFQbGuZ9OGrDsgD4wh9caUgChqgKVhEAMYNPkegLtLhehqVQb4VQ3h6ygOJVsCvgItSvmwi4I8MKuLDbYMSqMjZ6fI2cLdaEwYiRW+ZkWFBIYphLRQAJ0viiynMHAqQDoqKkT2ilokSRADBU+2K4EmKW4LkEA8KrasqUERBGaTLDBdh4kRo7ONA6iIjkV0cG10IntdNEQNKQtVpYwxzKAu0zQoFK6NZokbZ1EmWgjuLi7ZIu6ppuk3O3Nm2ZNQua6hJnrVDM7X33FLdhNn3c575svlKXn4Rbd/k81epUxLe2nwsQpXaf4DCI6qA8mNtGzBhw20nOFFDDVE2MYTJDBERBgOBDAgsmokwN8dYhIC6A0ljH4YQ7wgShqwO2Rj2EbTj8zCWqQWaJBbVayJI4nNtTgG9QOSucqzMF3F+1zulRUkceqHEMRhBjEGQsgUiohJraRaHkaTa5RghR6XewuQHk1zkHNstoNYhcbk6LRGaJGF4e50qgxHTMcZLmyhOvJBKcUaGJI7HxxueW5qBFGpwQJtwgdiRTufijZlNVuSyxBBG1Cba01G5eKl/5kV4zvZSqEJw9535NHJDrgAIUxoYLaX2/8S+m2Nz6gQMBCiYGuEBhzKlVUZZjiv0glzN1VIS07EoYRPjmK1YJTHhl9MitpVhWuasOcpkgJXTKk66Z3FO+K2qKIGzBhxJJaw4iqho+2esWQ5eEDt6r2kOqyKGmvmsa3lw8phqu8dHhcIRZsfJimSD9wzRFuMmDKgvnSchr0yU8EX3EE5rJ3Xj848fFaN8u/AHA4VOa006ajbjesSHD8plwzOiUfcdqXYEywf2G1yJNVdGsTOrYoLrbqLM0O8dWHK1pdYrFeWXRKenoG2H3mLt2R62t2tHJ3PxpuzqzL19nZim7tuZ22XgyuPbXWctf7t63cL20cdWIQQI6LDI3nlWIQj/JQRp/rHQlI8sgYaqs3qznSblAERh9w3Bf11IzlXkMmgtQyNPm3RqW1F5nPCnongb+L4P+ClNEkHbPLFJjyjiEupqSWpl3uJXh61xK3zviu1Lm55Aarmi6uK12C4YLmESnMgdjWxnJ2vSoOWhjaODxqNDcZTPo1p81Nnyk6t1VAyYPiQkUPwsQlJBRUPoasafK7I1UbS7TxaXHTmCbqi+uRO+yeI3cONMceqsrryG5RF9lzy1drdbfdSuxqjDLLlmYH9gtSfuubo992bZRtbSzrB989Vu1eys7Mc27K5DOxmkNgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGr4FAAw9LcvAxV9BnDG4aRfkADD2Ny8RFHwGcJbln6EldaZRlid0DPDWQZC7auYg8TiTCvPwnM5ejKZz3PJTTsDi8kZ25ESuR7mMuCb2VWKxsvV5URLSkLP1aexJW13TvqPtT0MMeExSIoSfGL3j6za6NJGgJ7T5OQsmZQBhIlQLFSybAkDT2szCUmdIxAyRiK0MVS7CTaqKl5SfNdaKBOJGysq+AgKpytmcLNHpdOTerUeZM1bkBtRGaZVwnUauSc1TzjclFlUk07pldIt71DDEk9xrJQjKUdeynUmJeVecpRh4fPvlvg5bIILCWSLHIoZJPDoUDTHQgOVE9SgDcm0WWbKWZhMKbSDWrqJJgwwikwZvXxfSRSd9Iy7EUeGtHryaMSbZ/1nZqdTNTVHdZ5f3cpCMiHBvLEqq1bfbM1NUX08YU1pA0tEE1OmneoXi9f6lvD+AZKSymRsqDEqKzRc2thYRK3xxibWJUO2s3OmVPuLiMqpuD8dDs6VcJCtmja0fVazS/xZSPHSZNV12zTzupCpYk89T0irdhhgTMPoUKp+A+QqOlRCOaNomX1kB60tUNsqVe9KOr506hJ7qKwLaWvSlk/s83DOMqN5n9tH1aZ+7Xa7l/ydpNq4+5m3mtb2ipbKnY9SqwYYtUu1rSjTOZZZf18XkiLpwVLG22O1OR49zWSjYzPXOIoEWli3jOclhhmi6xM4wMtYajD9zhTUwr54sBgzGb9qujhXA6v6l545YyW7HTzjtViopNHLykrYhJD5YnYofcrRYzVcvq+SUfYhttbn+1CbGDKQ7eRzChpOXUlE18v1g7aR1xYvq6824/SnMVXTkur6p2rz0Dv/VYs/4WH6IUb0UOrmbe7y33o9s7escMdrfTpp7Llov6rrlunb1b2rbkxfLK4SWQsVZWYDaNNKMpIWPQYOXwJLakbIAKGAALsTxfV11cQ6ntAq5XTemNoMyWNy+Pue4sNU0Gzd9QJkSo1pr0vvdDNTKPQYWCNQdKRwEaTo9KEvFTUV+Kz2GNHAdu1GxGVaPkyIClyAmRBYZmTB8LikhkWKGXooJRtYQh6KJUiePoG8eyLEq1EMGgw8KIkB0dff4kR0GGZEKIhRAaTQgQsRLhoSoWpozZSU3B5Cq0aJUc3mVAeYMN3JtjpDSzSAipZi1sy8Uv4lKyqSpeL5ZGU6ihpuTazpTZ6hnGJQZT1Sb1N68/mIVnN9aLCcqThnnGrXnfgrql137byIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABn2EQAHvY3Lv8VfAYwxuXTIi/hT3gAOGux/Cn4ABM0G0LSWwXwcJLXCVaHyXVdOZy7OhSK5HqRqRCr06VyPbtPLG+4t/aUyLREcoGYCtqrvLKxC7j7Z5XF7PTUzmxwVbR6/ZzPuKKXlfE5JU2POfcssocLImJxSzZihTOD+jaRWiYsula4vSncalmFhfZ+YaUS0Iqhns9YtPVtbvXmvIVnNa/oHF9G644xdmYaW22/RtyFDnKso112FkGX/I9xmtn/okWvv2q7fz7v6NjqrK0s7eaVgvvxvUz75iNd0W5/1arW0Ez1NmKqM8RCLc5HwywKCmICVIJ0qWupsuSiCyFyGbqA2k6HiujwnQgxuDDpxmrvwe+nJ34nFUIWNJx4pc2ZbUmohIbLKkaJXGG5g1jlpwyDGGaa9Vyh7SP1jdtDPjliyIETuNEhKYrqUsKEqLz7x6kPPaQrsRPlZcf0QLY+iSEtW+sUE4xOXV8K1v2WlOVTGR8hPE+6s7QENhDWauZcZWK3kXOO8qiKlUaxKhMQo3ljscxxtPvtIbSWjFLtzLDTtoYmDzWLMKIj1G5fHHkh0nSVyKGGcrNaZHd+2RN57t51l73X30vtTFazGdlqtbW3/2LcmKdrbpvjs5MWcvgph0imE5bzFRBmlvRsRwLggEMRr4sZ7Py3Ljs7eiC8NiVgznkpzqRzALC1pDLF50LKuDtVk/AWiCnnePdTw40Z5ENthu4va5khvjngMGpqMDPVwpeMwqeHS7in3OrW/lVE8lGBQdUMUGqYZ7VUruEtVTbPlKrLJ0awzLuK2TJyK3ai2lVlYcjlnTPGhZcIjB3utV1V93kTVoNd98p95coKt/ZpqWfTxqx4zdiBm+Ylok09Y9GGKzUtqJeHmHTxt7mqz29I2L0prEa27yZgQJrw7VtS+Y+bWpTW424uPS16btvWY1ZANIMNQD+EkAmnTE3qwT8d65QxKFgJocizADfvVLIKmqK+0dvnEwikzD8LTzf5v9udQ2L9qvk/7lqhfyJP4ENgtzZFfp5Hc1qigBZlmYoqlTep6kjFBKKeiwu7lVi5lT4z/OZ09Pbp/yqY0HMJZqxZuWrk5c5az3Vyo8Offo6n027NNlUlmGWufc5jlOZW92c888Ob3+88Ji5zKrLKTVfDO/3le7av65Uy729nlZs6yq55X79fnKva1y3zKrjhlXrZYW7t3uO8d933u8eYZf27rXc790k2DKR2Igqix7jA8lpIm3IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAn4kEuGVoAArfIJoMgoACI5xxYdvAADDSxjQ7TAAA1gNzQaAIDI53FzAYLKYAwbAxKDQNKMQEz4BqYAAZmLIm4eAMCgsG5QEREG9gWDhiAAFQBny4Z0DcQtguQkQoICg8LIQxqFuRRTcWwQHFjEAwKCwRBADgxFQtBE4gJAB85AhkBcBTE/gLhAKhxmwRECqAKGAXEhc0QEiZmRcrkuRQT8KUFFEODEQe2PkY8uDICEpcPCCBIG4nApk+IVFDibRDRNoXWFWM0TYhYPzEJg/UWw3MDQgiJusvuPAtwvRc47RCguUfBPCkRwDNEOIcMmK2JseDfWby2RRjSPxDTYlR0DTDIwz43iAuTJUIsXjYnSK0jI3poIGi3ZN+m5uUC8Rp0ipssnTI+iXDUmjFlmDmSqRko+iizU3N1M6Ft1M2pqHzp1ieJorMZG551qOOi9FS0UW85Se7NqWyKn+r86ZEeBCKIlxODgDJQvqHxiPjNyAE4US4p4UIyIhH+TkBpkxqjdhoUQQQtmLeeLBQLgZgtCHAZC5At90MLCucNyIfCqNQvgbhFMhjEmSisaKpGNScPRDAujBSwtdGc97Hni0PQbBEGE7oXIgugNj4LkLj7GexPIxkPTB6cecKo8FoQRcekI1Iihe3/9nZKaZh6KYYaiHLOU5SU0l0mX///+5CeSo3++1/yKd//2sn+Sf4sCGBDYaNGa5AHlz8nc6McQRgaENfZBrTBwGZMFDwmYCFAEeO0UzBqaHYt2GERuQeRSR2BoDShH7Gy86jwcaXX2eI3MufBnqmoKC9jbqrNKWNKmHTlEs6C0vZYjcmFF1gxoKjym7IYzAT/QG2RL5dLRkhnPkFI0WJNbbacl0B2W5OVEWuxpw4Bbo8zpP+l6lamFL2WtrlJWcqld10nzh3cOwJ7ckvoxPR6haSxGJLubaJRbG9lfx7ZqT9LZufcpo1DtSXXYlTRqq7Mu3lZty2xDUuvY7v41cL9mJRbtLS2e733HeW95a7v8cMsquONy/lzfLVNTbx1ruP/r98y7jj+rPH0HgaHhIe9t1wdot9lNWheUkAgkkc6OcFuagQf80UDjQMxreIwpVBJ1Klcl7BwAkvEA7GJRbZJawkKQSVikeBWTm3RyJRseklYfUWmJgWiuhRob5jIUlnDZ7k5jKs9PdKolEpBLJeEJtt1QcKqtKHjUuHq1pMbzAXQpHYVXcLrEnokD7AmNywXlXmA6hK40JKhMZR2mJKi50+ctVnLTvVZyzdVp6YqGXWeu7n9s4uXXr61c0/Wq0YWNRVZUseKhSsm6zjMyCjyKw24rZjXesO/UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIYW3CBXMAArNK2HCtsAAhhkEwGSiAA1vIJcMecADSlhdYwQTzUCzMdFwzKijxi8OOvA5ecjWLMNRsgwSMzJgnMkCgwWAhAAwUGYctFQJumDFk1IceXJASwUs9RuM8zUkJzNomue4+iYznLDK3ILN0eOKNKR+VOCqqU5OS6MhcGHXUXc0l+3Sjb66ZzIGJUy6oKXUzpT7cYrKICryOHZlxaeHeT0cdWHKVnMGzcaoXqcmlkdqQvztlTrPLQWKa3HmlO9Z5LZRWk/Zu1q1Ksp3C3nu5Tzd+1RZZWrVqdsSuzhhJLeFikpo3Q3bt2fqZVst50OVHK+Zd3ja/eGuffr2vzz3jlr7lrudL3nP5j/Lu+d3h/3qlA2npkAKE+JZYmb+2nb04h+cRfTpd4OiXqARmaQREyYZABGtaZoZwYuHCoUaeKEwelaGAsup4qUTASheYHx8csucYCUWkb0K1tluipLZpDbPLHWCeKKRTAmJSui6Gp0cuvVYehtJwqTkmljIrQHzZjtEsReRWxlbcy9YYux2TNaJRkXlTsVSUSoUzj5jE80fLrJemGtHtpvfaltzPt+Vo09POTa8zMz9J5+39DKQCncXFkmIGCpIRHKBdRwocLWAhPvehInUfVb0GAkJkHtuQoKkF3B8Qb8HuENHNgYUBJCJBiplB1gGSLgHOROl8ANhkonYWstjkpm6CAWkAPAZZACYm4nTAG6IuAwJwZs+Btg3IFRNRqFcbwuIqFVAZsn5E1EOE5D8LgGOJwyI0ZkhhkkxFxlxky6T6hniLON8QWD/CtnMnMzFAhxeHMNFIJk4XDQTAaRJieiaIUZUWcOUTRZRKRSJ4zQMiJlw0FzjNlcvpMRcvlAolJAV4UkLCK2HKIsLqXi8s4WFrXUfGbIu5E1GhBy+6C3QQEJo+BAYupk0gdJQgKjAnSNLxmpSSb6lOkl6ZozofQW9TNv80MSZNaJikxiZJLRZRkfWiylP62RR1M3///KNkNKifBLwmlsMlUx8Jxk0xMgqDJhCzgPGo8Jyy3SLAFBkB4aLHgJIWPcF4CAlIHg7DJBhIkz3PQ4kKhIBcWMBaJMfdnHxuJA0IIUQNg+AUFDx9CKjURg2IgkFBoYeOEACDwjHGHhCGiyjUuIyhsdIjwlvJoYTRjzxcOnhYHyGHDw8JhqYSJGEDyhBncHZMwJ0MB2N3RXPPAkPBYAYieSHlEYFqBEJIQlGoiIZMR03U8mQY8SDTxo0xZhnzPMGo1KDU0dPLDo8pg1HCY2HTFOpbzabf3//gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACP52xAdrAAKnK9jk57AAodX1Ag3hjcrcu2EBhiW5mUsC+7BxQwRIjVTRGwRXErwABKvYgo+BCqmpQAYyhU/UjbiFCg4LMy1Lilwl7KVJzInmYpomDBgZKE0vaA2xmhSKZ6/EELMWuo2kQw6NiERdJkzkuo0lL5CVAymTEnDgdnLXV2w7GXZhENMB1O32s0zWs3eopqFtNmYFpJXCJBSvq5NWGotFK7xPs6MVpIZfSng1rz9Okw5TZtrcO5zDtP8zpiT/RqN379mag2GYrKsbk9fgGMqla6ylIVYrXovTuTDsOwVUd6Mzm52PS6NPM9Tiy2NVtNKeaNQTN0sO5dpcYzr5qtLsZ2XRnCap6lHlnTa7/cqa1lvlNjjjV5V3h2mptaprWP5awxs493Zx1WySiqTgWL3XSnH4m35B1alQAAEAAY/O0uodDgWJTJj2ULA0wIU6Ovk0+gS8PJmtYPaF1AVQRLhKHZcSzSxiNJrU94yEYyXO2x93Ps9ta2vZlats27R55dd3ly+LZtBZr+v071Tp5a1PNPQzLSYdiUZZq3vaXFrLpd613ctT7bXYkMmuwko+aez8ZrOLrZa0eUtd3pZrPTW1rbNqz316zTyYVFwEJXCoKjoMrSUqTyVm4tHAZfe0S9CigXCkBQQRjhUYEimZVZlTGZQkgYSMBDx45DgwoCx0CcPalK8HOixUEZxGsyAJGMsikuXtCAspe10GtoJVyr+EQVDEVo1UVWUuZcIRFwmXrpfBtgwrgtX9OqKP08ND8OR9lr8xeWHp0qHZcWB8aJROSnolPkJaIMZyRBLIRaSqUQlg1BqpMg6D2NhKUF1S6YrmiqJVDIvoBfOzwyVonCsdlU2MUBcUe0/OiSOy90vHYIgduDYdickXtnyEPZTLLJ0SooSwubiSuGT7fJFrRyeuWTHy5tt1lISkdTF9Rketcwfv7TlRcjStvyz1jJs91k9XZdmt1vxWem8Kz/pa/Xz4P6c1/YY34Tetw65n+FJtO7mxQvarZGCoMFAKAvPFmRNCYilKTJTOUg7XJ3lokl4cR1NqiVYpEtepNqKXepGSkNyqEqAZhw761pLZpra5rEkX2Cy1sbk98WcRSkqtSF2N4/EJwy/SVATfXrNs3ALJnpilmSyIuzN5d0qPpp7HLVylUttrzSnUlpxVkifHVGmpx6Kcdlkk2PO62KrownKrnUpVKcG7r1px+T8LypWzG4bkf7jGGZs7r26uJaLpnsLvy1f/8b3gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAdKij8DOEty55BnwGcMbl0aKvgM4S3LvUTegawxuWRIJWcGGYa7xxrBzRdIYJLRJdl2YlOxOvWjT3Vm6yp+o27UvqzEkkdBKYjLljrA00fe+691LORqakzPIPiu4sDpyh/7UZlONH3G3jFq27D5KsETg0ShkUqNKrEKr1UgsBSIaFhoiFL8PiUlmsUIIiEmlAKnDZAjEwWRLOMoQfhzLhk0VZRRQI0QraNsJqomCGEsxARNMEyTyKd3babM1WuQ1rJVRXCiTSjaFQqXnaSM3FgyuKkkV5T4LYQqlES+vZhJDkpvQZPFaSag8/CW67xyFxSfBe1ZeUqbtlmFVWXmSzxumqzyySWlU7jADFBCYYxYoSaawYkHZmyAHDhQFiCeCWretIjDhQXLYDcKfd5y35TCsQ01l2cMkDoYyrPLXWFl/LcVhKBCmZTp/wjVMjXL6tmJQfZxzqJdRqvKasNovPB+QFFXTtfAnfQjlQmD5ho1SS6+QuPYoqCYXNbMnrlNCbPTnOJIil5c1cmrNXI7y86obVcWXTl2OjrTjKNRiNpytqvfZx+6/FvWgPMv01p1k22YPlvFn6urNehhqv9fi+qv4sXehZNY/vaj8EHLpr/yt282o64zX5pFB25rWzddlv/2f/nKbbtbggoYt6cLomB46o5JrrHQPCjKJS1XItJ3nVfaF26kraPCI02s66kttSeE95OXq1hdjG7z4skus5mYleqQAsF+pp8REggBBFfKijFPXjOocZpbpqRAcLJqJgKZXTHl4DlMqsMLWGiYwSZDAoyZJx8qbEpDHQMF4qaRkeuLCdGVjNzTRk3MnciUZVtUPmnIWEAlcOOPCkR0SRXWiQJwZIzSvJSEwOI2ypQjwZKZlCVUgQLkEyrkU08iiWtDLTpaA0GHLox9yaJv2mjKwVUgzCRVJdSKPGOlTnSYaZp8fNlWa/n/PU4SyFSln8I+FV17xLV4ULLmxGIIkSY5hFCAvGJEV3p7RRiLKmpzrwPfcYhTP3L3xzn2nJQT8pS6iFXg82IWJ59ZhN61Eq8sfxI6HZdEqUjwIhJ5V7VFYm5iO0DIHUma1SCB5+LgAU8p2U7hqTPM3HoF5kflk4LPeWHFKMyKqRbyVYMW6oB7CdnbatNJ/p6xKDjMFnYXz8fW3T9hyg4GHNGh6aH4/u0Xt88dRvNQsQss3cU3oYpNaM4nzPjUSXHJgveLk7rTi5mC2Ws6wdOVeswzSJdvPWfln2tr3+nid2HnIG6ra79ovggndjo7sNZt0ztfm2fn0t9OvA1YLCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeRgD4DGGNy4vEnsGMJbhzqBPoH4Y3Lx0CegPwxuXjChUbW9Q4h0VTNMSGlMhgh3o1bgvKXw3lWdfJdMui15WOtPU9yVesdpMbplGIZa18qoYcwVXkMoswQYBkpnk5lWkl6Qxfd+Aa07jWi9CUxpXmVi2JcQSnCwZNiS8N6kpOpK5GEYgnK49IwP4nHNDOIToRXFzY/lyIkMlXRPJ/H56ytVGDTlECzLGHRmhk8sHl0Rivh4g6XyicssvE+pIeO2URVNS6XLPRHb1rvnaQ267x+X0Ewqc1cXPo2mE1+ZPILUPdK8Z5fCrGlHI3aTIaeKCjBXH7qnk5Va5AsptKuPxWrbcpmR3vzFohbSAPBIFqdoFmQ6dMIFUg6rPJAjdNSmMV7GEfj12SyaldrNNS5PSt6ZjNvLH0xMbbby5Z0RYfM01eGLENvJTV2xAIZCpvrNNWmbsdo5qJOrDlL2DDyCLQAoMnlU3qhdCgRNlSYmMCI/EjHxcuRzBVsLs5C/EmGXpCNdAiQtxEpuirbZgE1jA08YHSNUnkYbZPoGMVG0xk6D+DJ+nZg+kwiRyYVZQihZtO6rFUZFa8TSKewcitxI/7OME2ILtQi5iM6tvzJYVNKElUcGkEZEK8Ecdy21KrM2W7c5R3UE05X8/XhHa+fd8ILB+nQuC1dskIU5+AeUZ5jc1HaalzoV/UivuT154pzF2su7aRn71RnJuNJlM60tnKvhKw6TdlqUmrNW9TzGUolVDT218POfcOKx2u8VtXMKjOIc3ErpYPDUpEoSh4HgQCEZqzYxKRWJHoMK5KmhcqoMb3shS0+Zl1+jkZoYFs7HBXCU6nS8noZFPkRPRsL1kDDdzFEVGy0NUGlhY0IpibPPMOkxDHdYITCHcuwvsol6QcaURJDCNtbU5P8+Op3qdbZd1L2P15zESnFUR8pR3q/7XJK9vvu07nYJrkN46dacmzGAQuzWvBArZaWQEQFUK8JkTIlS2cCwayAbGCE/0diUTbSQuy/jW78PRFZ1JGJbjfrkwH/e+rAltglNTT/ZQ2BSEP4NzGUFU0ek1NSTmVTPssgGnleC9TOPrxtC1B9zpOteVEtYT98RXXHYEwnEgkCBUD9CkPJqQjxUSqNMkU6LjS+ho3VM+anZuZrJhLixANiSTGmyuSVioolUmjIQQPq4jbmNloST1gpl4ufZxS0VdXH1Y7oDeqPTHrtYMeOUR62pxLAyw+cuoeNrmkO6hcworVlWXWqPLalfFUtxabUYcjdvlrRbu3ehq1TOYfu1eKawmw4GwLZjB4X+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGrYHBAS9LcuKPB+A9725ehgsIB73ty7U54EGHvbmUxQgGwLw8UFw8OCs2s4Mdn77Ti2GI2IY6Lwymmp1er1YpbKN85/EDO6R2uHIhjCaqQNpOMjXZ5NOwNo4FhjV+1CEEYJmiAMOAOBZQAZMCBUNnAoGFwePHQuG2Wxu9E5GdIyZiPQObTTRzMoxQGDyM2229htJhazCsmEPsfXg6cZyUmuakorAkUZUSbG0ZJDoyc3zBY200SMMtsrMlDDpzWQHsYSqMEcqJ21N1N7eLxykHW8yRBCxWb9b5yyMZzlGezWYUjOEI3uXPzkxlo2wg9m+Y5l6imQ1SPgeply0dLSKVB/rdnBvjn+o4SjXj0ajoVB7NBbx5nOr04aaLL3IgNK+TEttwjFkORkBug7EIYIGYTx7HUjIuEMgw49cUvhnOtH0ORSk7QZvknUiEi3kvdqDBmKCKk0LljK9jiO2uDLeNGjRIkjyuZfEY4M2YVG1X6b/myvrHb1O4Za7qfa+p1+Rugbb2lpjN+HCBEZIW2u7I8eUiOb9tfP47u2ZX0WzXa9L5x/r7xbPxHgdvf3o4RKvKZfv480CIzx4DyJWP4X3neY3pnO4uqxzwPYlYDkP4I5rP1B/BKzWoheIWSUIpkJ8S0kgOYBdF2HCDCCAiZD8AXDxKc/QVxDFpUiLiJD0rCFMJflsmrU+QqBCY1IhqejJdkZVEc46XMfw6U8pUJarnakH49LWS1oYo1o7izSRS/I56kTUIUhzYN5vLCTpPJ5TrDjHNF4c098IpxYV07cS5PZHqprWDI9fL71zUx+zM0VmhOb59H1aO22j6jXy2WezvtxNvbtlvfy2ewocWK8q2vYumZ9V2xPn0d7rwpYT6GyvWJ9mVmj7i7g49uxRvqDNm2Z31s6pWDvNXr1ifXm/fX1b11Bp5LWrXHzXVvW1sQrQYtLRuFW66CoNru8X4f9M0eNZaUzVpiCYuavpdJfYICLElABIcIdZ3gSwPZRGKW8LoTVKrydJ8zDploX5Znfrg31wzJaKXlaVZBSHhVDxXUNliLaRUjMdrFBVtMd83yPTBShPnJXCOpwqiClAKUFpORTFuNtGtjkX1oYo13sitdvdMLhHgx4X/iZcWZ7CnhK1TNqpzCcY+VDOrsqGAraN8qpfK2I+s8dsKdcMYfxp4UFsnrpxtfcF7NbbNBrp9ql/iXdMWrusDWd7iU3e2otdYjbg6jvdRcSM0b4VzNlhi33SvxfxooDCFcfxtFNHVVRVlWffzXTcgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABrV/vwMPS3LTDjfAYwxuWmXy9gfhjcuewx4A/D25gFyYYkDpJUoqqExIKmEIi06dLtL6C6eCvFEAHh1HOBlDcinMsEqUirtjapQ1SoMnp0IchcRTQ3GCbBOks5Pg4iRiUXEaHqA3Zsnm6tN7Jum2hefbJYTJVUDCOaiKeb9nBCiYVIpgFJNd1YBY2aXM1kSEjZIWcRUifiSjLKrMhGKtpJCi1jq110bl8RKqXK5EUisO7Z0QpNsLokjdRi0iFUq6jRohaTSWNQmg08V2EruKcrU51qpzuEFVe3KZpFOUmlKdcq2E1F/5b9vfudquEuI3E/qazuN1ic5UUOQ3RVlL3BdRf4vfLX9TsIhPQW6agZTKvTNMAYRZgJyW+kEFy3Fur2uGnbWss2a0wfUspdRlWeHKOtI0BDtLUjE/Sy2Uy2llOLf38q61lae6VhV3T7y0SbFZ9OYnBlaCh1HrCXJ1cjJJ7ZjzbViv6raQU9NMralne96jsF2TF16FmrCH81WQ5MNuOvjhciebs0fPRW7Ga1Wof17rOWZpeZy//SDsWrYpstdnaw4/SYHa9aOfRtTtJpf6ZkQFma2IlK4OwshE6+Lh+gGJ0y0uEiLCFSejSPlZTBdUYo80fX5lxcHhj7OIaVXzxeIaDe+znBeKdSna47xWCyumnuc5dUUqS7OqiiWEqEzVzcznM6qWmO1suxL6zzo2rMwPS/OnO2tX1loapfO3I3vYo3l7plzz6+KtD9piCOrrOZFC/eq1huizmFyJ92KHmZaqWT31uQsFVL7V3rTeW6IubxstVWWPdefUlKnvfrMVG1sxOsUUtUuupknZ6YHiFMR8vaTUpV+rEdItYWWfSHSxqBmG0vLIdPXq7vtoXRObP5123LdK7mCpElFtBIJZhU5hhVjcHm/dRYLdlhtLBE1AL7KW7tUzFo1G2vW2w1U7iEb5NhdKMooV4lhfmxh7qSHcEGpLglBICtdjk/WoMKJYC5nSdjgwoTCQN7BpZy0tNUbcXxMOFqPWVhhTwH0K2cRs7coO4t8wqMk68+gwo8G+YV3OeTDdBc9MtmQ7KM0ClZm20SVQoTVrruI2vcYc2qSr7M8Rwmj72+3S0WrxxYXkZytb7tF3mSDbO8vbR3Ua+bTQ6+NDgtU0H11J3tL39H8sDNp4d4WK3/tT6+t1gat9a3bVquqU/pfcHMl0hWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdjgrwB+GNy7I/3YD8vbl1OBO4H4Y3LmELdQPyxuYadGMHAMJXp0qThT64RUr61avYlbCppXNUlBfsPusemicSlcUtCwSQ7bKPMB0XezqUEIpkylYJbjfJhkHVe1rMts0cqyuSlQuky69C+36QP3Xm3qZ3dKEns/EmVNFp5CPaHLrCZdUviUqxyjzBmp2G56mbuuVtyu49wu1XFr17AkrzD3lI9nMQ1vWO7vJ2lxCQi+cKoKNnqYqZFikvL1C47dYPTNUWT6GJLCsZjcMEh3qVMsRrEUbb+ITNE5u2WFxYOiqlTtHlaV1lOTEyd4+r10z15qkSzlX/bZrl77tb83L1Ls1HGiyio5vPrauJeCqLYSpSthKxcUSZh5sMJ9hDdSSJdwChFYQBX4y0pwL0TUsqrIh4EDlUEeQgsaIlpZuJ1qR8p4dTlU3Vd8jaQzJnI9M0sqsSmpSQ2nfILmTFnf3cfD+I2vokeZyiyvIdodGqO9jR8aeSuNHkJva4jdCxrE0Z6ro9o0SezDaLpSTtdor27K5467VkJV6u3trKh8COt5gR4UZ5Z+s21E0wvn08GkOJK8tPazXV3bbyTHrqBfb3xbfbFvWZ5q63NpgfN/j5h6kvnXt30KHO+3Fzn6paDM2x4NJIF4H3mu7QtzbiY6hZeSFkSKLEkwjNIO5A/S6MTUiYOFw0xmatnjBbCY8oVkDCy7OYKDZ2ZbaWVeIllhvsiJv04ILI5dbq5qpr9pcoiyQk27tSQ0D0TERlNI9C1JfVyjY72VwxJi2j2R2MfgWtbG6sfi96BKpL5XL5ygerZOcyaVg5lJJk0vXoZ8WYjDSUZtaiL5SaEUpr2DZyM9UGKpxU7dKUHl7SdtDgObGLBWNkbBKMyZKKDE6mxlaE+L54su0evVMkl/q+9Elk6ZPWTuhJOWHTyUNo6dPHnFKaItHrmvVzfj6rLVrsHVotrRnqZRlx+H6O7FuiSB2Lylyh2ijNFvDlALUJJFV2xzv3sBVUl2IqNOBEUiIFEiZqs/xQbO+wOedLEBNJolaS2EicAhCLVb9ebESJWHHb6wJwJDr48THoxDD04SKbl2IQF3leFFBb6ABmFXbPHx+pux6F26hS6+wu11u52tWwo73WL7yy5/xHdEjLpYdvCSaPnyl9l9xetSuL3qH7J4/c5SLavllYqsfr93oXXFhOtYnQQvWhgRrl7h2vMD+KKu47S7LNezG6NJXLtnzi9aovtnoqt9r1ol8V2XqfXd72l1b596v2mX7/DS1qZ3fOzBfLy3zUlSKnK+T7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHSok7Afl7cuZup0BjL25eggrkDGnty64/XEGNPbl8G0lFaJIXrc+W5ibYUSTWGMyqlBKnUrATUvlTCEVJNcgPNec4JGFUlXjR0VqQGnfMXZb1xYa5VrQCI81nxmTS2L0sSylFCw+jt4SRaYtQWOXM0FqjVj2rBjxYTFPfDVXfrCQ20CGtL1LyQa4pHh0tdWMDO2Sx2F7VPvnr6M+pluj7q+gW3TVn27zNzjZ1eWA7y2yTvYkV49+2XGWSBSWXEBqaYLF8Xu9jXxCpLGkh4gxcXVKuhPYXy1O4W4lITXtyeQY2++vpvpuF3zLLEkvTHxG3r03SFm0Wt6UxiWtLaxLrH3qtcXgFw2MoNJTmsYUGveHpbetRqtfqfNYzZIAjXMJmywOOis8zNCXaf1a1tR+IA7lvBrF3haOGCJui5DctxGARJfkfT8Bk4xambSwivGKeQz8fkyvZDT7tBmzdzIY5QtZZNxVFFkgv22sd9ekTVrQtPczWbosO9Y17R2qNCmfT7Xm2bTVdu3mPFbJH0dsjOOMSbzI+jSM0OZsg6lrWJD72A5VpFq9j4zB3SSmYLhvMWK4wt7rd7WtYv1BpG8XNrxYut6e4tq+r9/qFFjdwjVcsYzFZfuHCy5JQdySKoNBcwjEXeZEjCBrdC7u+1eXIISw0z1pLc2bvu4NE7D9xWzKpdHHRIAcUJhMMBmGCrrzmWCy2ncr0EK1jOjxgiNJG7jSBgogT096tTzaY9Z3LPWPBbaGY1V4F4jrTzkw/qyAEGxl1FXvIckABgSzCqfSE1JL0i7jMULUZSUjq6zuCio8r1nYGZbdxlcxNzk3zSsD9uYaKyVxu+vGzR7DeZYYXs6WYr3xb3kvFVr7bE+ldTuD7M+qRc2jXhQvl7XWvBo8atSMTdZ9jc3gOWaRo9N2z4sXclsxsNsHNvuXM0+XsXNZb1rBg63u+ov3S+L7zv/Ft4x66tNmvjToam6/AsLzLidt0aUFWg4wth1nTiEoiD0VpylpY9dqEo4MGS4aXQAPOIg8cVEmV1/SIRDDat+GiiAwRMVDwEGeYzA2D4jI5TStRGp0m6vM56IYUuO/7uyCegCT0sEQ6HG4em7mFy4PLxBSt0e2eRICdp6wZWy1IicjwrZi0s+c1bWA5M33SFmDWJPAkcYjFiNGjvcaxV7iP/A+vChZvVsgw4zysKM+3utsYi5i6zLfMvzXed5iRo0tMWtq14mr3390k1W8aNjwKUk1i1I30+tDi3i1r6xpM73NilvBpj7vfXpjPnr8SW3PRsqzL1JBRIUoh1petAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABqSKOYH6a3LSracgY09uWqHQ5AfqbcuWRBwBjT25U9AYhfyHHCpjjvXCfi2brN6mxLnPULB5oMtyfafo8zhqokBFhwFDxjBywpEdiiYsuISj53K1WZisEWJNLELDDFRsGsG7sqbBHpVPSyCAw7Q8sz5eJhgTAAVDITnzVI2GKxqyjhugtNU+paDGaJeUapny65lSUmfQLi5gkeSUSqboomKlms3JyKDKPpKc1NEDYzMaCzqLrWdMWUp1PTLySdBJk62RXR6D1KZak1JMj06mWu6CkXRQd1NpOaukiuyaKVNGlpKRul6ep6Vluv9Tou+xzjpn2bIX9GGGPTXGBQzPSych+xZvSqVXywAJiUGl5IoHG4VNqOBBjdChXTKHdAWwqKlQqKjTh7TKjpJO0tuJBQMTGlPU7yBqQGCRoPNyDCCZTLL9GyozACQUU5Sz6WTArs9dWz4C4pFtjEL3g4jQ5s51Zrs1V+5YtdwoWa6rjdcbpStaw9WrqbEfH1elt6fVrW1771f+sLfrNqNjGd5ge33m8e+/m2s0+vi2vu+fimPub71mvza/p7fNcSarftxj/Jxydu6Bet4zVepGxVzN9AP+p34YK0k49R7gMIXiHF+QrD1cNkfM7a62AvvBpKGdE0RKxK3EEYhyW7F15coM2hiTb7ERhnTXo8Qha1aGLURC5WAqSWzxiwZCGJyyy8Y0zKDqHKclAkzkVDYWYmaJiOkGmSms9ZKXjdAzpmqkDYzWgTTGximtaJdRRcxdAxQL6Z5mRLp1FFaDJVomybJIHLOxqkqbJLTSTTSRTUhdS1t2WtkOkpaCK9GY00FvRUgkyKk2TpanoOtNJJmWylWqRU63SoJmPHyYC1YAJUrDLw8ndmBaP79a7zTdqyq/ZIEdbqRNl0MO5lTUFPUm69PfTuIktARFGWmICT0RTLMgBgp0QoAoXBYUbEmF1y1x0ABjLuGYUw/G4coIKHJAsCa7TjIQ4r0LjSZdBtJA0F1ZXTxFVYUAxSxRTfDy+wGZ5rV/Gor9wL31bVbXi4hagZb5YOINdXg+ua1ziPmt9ws5k1/NLqS+5vPmtaxLRoUbONb8lYNKZ1NvFt2zEzSaLi/1vVPH1rcS94Xg/3/t663LjV7Yt/r33q1sfOqbzTx7Wtmn1n5zXNc+v//1S33nEsbGvqmK417ZvjG9+JFiSUsIvFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZZbziDGpty6bFm4GdPbl5uOtwH7m3LZEcbgY21uazORAJna25XDs3FMJ+y/WFmzSW1ZB0RUL0r4Aq+SYVzQAYS8YNATZCLiIAWPgLGZY/EcLIP1TxDbdxSGTFmodYCKGiEMUn1Z4veVXlkOSpwl4GGDS3Gypk0UjYAyw7iq7mqLEYyDMxxSRrMbKcrGRiYsfLpxmRUmiiaTZ0TZb6MzUxhZ1KPLSVopHKDOi6KZ5npoJGi2aybIu2zatV01LZGixsY6PuzOymRUik+1qR1lKWcjmk3AT/KR+i2iSbGV7vkMzd6dGjk/D+1wCtxEIDpDPZAJD8OwQu+V0scpIi90ETztCUZ/is26BKDuzqJoevX9UBwWMW13mYfF3isqMAA5OqoY11ORySSx5SIclC78FEpE2OQuSRVnpm3ydBwnEo7bkGQAR2pS6w7XWYQEmVsWEzVrosMangarSNB+6ZpDdxKwdWvA1WtPXWtwN2japuLf+nrBxHgWtG14G6vKd7XUuIMZ79z+uNVr86291S9M+vtreMxrb+c7pq3/xutcVxmn392+cS/WPam96/1nPzjWs73f7r/S+81pvFc6ze+dz2tvF6VtjO75rjW6bg0ruFT5F0ZqJMAvBAQEUJeL9NohGbUsGPCtyLBN4LBMEmLgSUpk6c1uojOPId9tQgxkKFqFQynqZDRyqZnbxhxNDjlvXLnDMsBBana7H0tDLi0xqAFu5F9r8XQSvM2PN82hmCBs7ZoCfSSHURUckAeY2D6SRgs3FIm6jFjFi8pFBIyNS8iZD7Y1RLB9CaG6ZikiyS1GySmRUm0xSXUYO6kjFAuomK3m1qK0mRWrdkmU63Mn1spNlupNJM6ylIPWiu662RdSkV0VomKGtlMgozP01OiaqSS7PTMlIJKQUk9BbqNEUDJVS3MklIrdLZztZgnWpbopppOePoU+i0KhCvCWjms53KLUqjTzSGLVIntDuLErGRwWmlMqR2iQUJSBgLSh4SfqchwlKywGhwEimLN8TIDmjgKGMXJEJGnnRQ+FgA6ItMGJiZLXn8PvtccN6I6hzIQdr0Y4kmo6TkAyIFBBUzcakEFoonTay1mSKSTn6NB9S0XdlKZb9J00WRU7KZWzqTZmdaprbr6nqSUklUmyloIV3Zddtbukv71poqSQUx5aNzI8tJCyaJlUt1up0VJGrnlKRdJS2UpBNVJmSRSpooZhOI0VvTNqCTa1nlKrMEVoQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGro+3AxubcM8x5uBnbW5VCdreB+otyrtDm8GdNbmPvoQIIWpkllnGswJFLdSzfi9vUqiZdhsZbRFA2Qpa4/ZbgoG6duAOD4aIRKVGDpzYQwJb0eFk3wIE2ozVh5VIQmxjoBAsiTTNvEgrjApigFk77DgFA7wRSNssDEd2rPUy+iOlEh4BbSaWi6R01EpOzMoyoUndazZImEEWNUdnpNrWpdrO9nVWzoXetme69JST1alWo1aK1tWi3uhdlJ1V++layO7vbUmjZlsYpuy1udQMaKSjZVSKR1rvNEUi/fVRPqWm2iis+66Z4u0nomjuybskpajZlig6Kg3YBYFFo67zpRjkKjE7y1MYEACDjaHB45dVIJ/2YJDAq5b190kIbZ+sGYSPCMtDggYCy60fMCHFJUsZf2eMCH0gYpSoSjryMEngkVWYvLl98dCvaWUYqHQv8TrJkkYE0DuMueZJThyzyWzJ1JVUTSdZaC9tdSavXqf1MnSeuuu+nXetmqS1K1W3ZS0VezVWapd3vVqenooruitNbn86kx5TJu55JVNZ50zqSzd3ZTOii60dazBGmkyb0HRdKeSopsozMUUaa7LZRosQVYqkcFgG2EjGUZatbnCKvQdY3JUhzbVpCUFERx3vnBwMn5nH09KBK9ZhmGMZZammX6iRhAUqlFPQSIYcBjiAXmnT4GDB9k1H8V9i/T8Nx7GkOAUGOT2sgtygkZgTx59JikM4au1ZT3W2s9PpOgnt/e17atn1fb/+1Ld//6//9mvtslfQXqQ2ZBXrdFqCeigtT2SqnkJ2opb18yHBVjral6nEFs44KTyFkID5GUQZVZbIiEeRpD0zMu5L4p3T47ZCYYG3IeR1BYbuPCok0Id538d2oyCVGYBjB8WYKKhExpqP1x/pym9l0Awc0YcEm8wEBpPqihT2sQtQDAcTUSBSXHuLJmS1JgFw2SVUmsKo6+VOt6PW6Hd+l9f9X3oL9H/////b//tvt1p3fsvVUyVJlrdA2ordloMipSborWut1uiyFS1VJOutSKS6kHeipIxXVCjG3pKs5gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABWOQN4H6k3CoENbwY01uVkI03gxqTcq0RRvBjbW5SJmhshGBYS+rtxMZEx1wz7zST1QkDvrKBok0k7SBoMeTSJkOD0F8YiMC4maFQnvEFMQwpGRaHIWlUeEsAIYo6twiqqxz5I5QFnDRGPyNP22zLUGJHFQXX11aKymtIC4lh31rD8WXzCpp2qnKPf/0f7t/q/////9Tft/1+rbvUpqLr9BkL1LetBTJLQWmmzIKbW6DNTTXaydTLTut60rJqUyC01UDJSSl6Ca9RiytuhlAEKBrRoESjzpu1Bk/a+btWsGkGZASsYCOqTD6O01AxoyG6NUcSdZ1BZ0IhpFIJAQKe3BCJ7EK1iQEpvCxAYoKONZECCnqy5s66pS3KN5oER51A28WSWpAugn5YyOgdEaNa921Pup03/7df//rv/1/b//X//+r/+r2qrUk9V7II0UEkFoqpshUpTJIOup2d1IrNUkz10E61qdaLoc8+Qax8JsyFklpNhZYxg3CSKU1Zs8UtlFev+EttWSwHUk3FFxuhu3b9XEOKQ8DR4aDwUXgYsaAiQCXsZQRNW4iymS35c/romJjlEGJ9KgcgvFWsRcFgIGhDuSJlOcqXwm0/V/I6mYlBSABZF0/s6Iyxv1l/1N5Y7d+r9X//t/6//3q//6lf+26q1KZu1dJ0EK6CqCkdd000UXqrdOxu6zBaq2SRU9aClIoPSRWyCSKknRXTWbLfPn0p8esxXSyEeYFrgosAsWpp+MQBIpyX6m7iShZWQpquqRCkVrNgEoWdqooQtR1/QcOFnChRFQAycBYkDghz5mpYhkwFLQvj8OK7OTFjASISAIYjdEwn4/L8HIT6lk9ZTTSTWiCSIMg9aASdPrXv9lor7+/vvrpVf1r/r/9X/6v//r/6f29S1Mpt3ZSS0qVBnTSWbqaipaC1JVMigk9S72ostFVkHpMiglotm7IuDUo4eAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAYakDuBmGNxAVIHkCcPbhy6QPADYY3EHsgfQMY9uF60tgPOX1K673ZX6cz09MbwajMiJHOZs278o23KkS6X3IYKj+Drc3exujA2n6zgg2FTSKIRCtbknJ7VjV7+6zbz2Adn6deaZ23zt/PybzTbzfKb9Ov98pt87fv9Ov9J/b52/nb1/pN8ptNvnX+nU2+U29Op1/p15plNvlN/Pp17U2+Xym/Tr/e1NvlN+/06/06+3ym/lL0v9K3s5Vzb5S/05yt7U1/KU692Ob+lqVX45Cvx9iJe8cOiW8JaoSFJLeMGT9NdwIgBEyaOn058ofXylTvUmecH3s4Da3PVJTX5g5bVGow2vbB+rerO+Kqqc3uSUMxMPZSbzqYW+0mre6fUTMeBqBLD3ArHxRgpmPAiQ49NwNP7PMv5H8kSHPA0/s/s8zHkiQ48OeBp/Z5WPmPJEhx4ESHEh7eVf2eVeSx4ESHO8ivKv7PJY8CI8mfzvKv7PLPJX8CJDjwI8CZ/Z5BZ7M8jhDjsEzHGV9mSCzyMkOOxx2CZjjPKv6v5GSG5tjJDcGOMwRVfCVkFQNbO2ODG7YJlY9V8JWQWdscGxwY3NgdMc7BGVkFRtyga1G1IWpFg/1ovipIOqhN0cPQjSDo4nCdQsFNUkKBS6SSrqrceZR11uvfMCg7PJp7NfKeP/OrNU7e3Jj23Rtdq3s4QuOfs3xdS+yYsx+r9WzrszA+8MtrlmbE7mvrS173dy1ea9r60truWx5nmvZ5rHtdx7XWqtezzV1tHce11p5nmeXXW0e11l1p5nmvW3W0Xa7A8y8zE162i667XYHmXWo13raLrrYHmnmXWo2eXUXXWwLoXWnWnmYl11rC1hdCtaeZiOYl0a2h82thWtPJXV0Zzc5oubPYD5DXJXTp45iMl5k2YsGSGeplRWVElEOSsQTwEjwEi2BEsASJ4HRq2zJiEx+7j1vZ5q9aPJH95g8ZrAMnv3l1ywFhZZJjJy1dnquD9VaXAFl8i6608y61dbRbi6V7CjQYz2Z9t7R9DZpXskaDFhTvrvaPrvZI0KNBiwp3sz6j6G9kfSxYUWFO9iPrvYD2R9LFhRmGZhiPrvYDNKywYsKMwzMU7Dd7AZpWWRmbYzDFYp2GIroauhssjM2uLFOxTsMRXQ1bAZoTM2uLE5MMzFEV0NWwGZrZW5lYnJhdK6OrXitgK5rZW5mYXStdJ6OrXiuhqFtZW5VMLipnadjp14ooahbFEuWZcqlTLSddJ5nQ5+hrYdS+hK6Rx/I43UqW5LkFRg3lQLceYtp4C3HWLiZwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAVRjTeB+otyoRAG8GNNblUSLt4Mam3KjsWbwY01uWk+BChrAAkAgOR4sQ3GZcRF/Chsq2pJthGASnZuYDz0ifrcb0dV+74UBv0PLyAmTHCUCGFpGOjolKZdlDwokHkzzyhYE9SYGFyjS+EYlqqsqeb41MgwBAvdMbsU2KIAFJelrMRSRtfbetlvc52670//f/7f/////6//1/bq3S01J6muplrd3p2QTRWdZlrQdSPRVeinQZB0VLdJrrTVu616LPQWpNkWnuHVwU7qOYa4A8bgweFxaDr+ssY7ljbLAgdASpYrLAMXv06ehdSd9fkSlMLMKJIWTgodgdhkBUDPfjL6eCCA4HNmwyxPc4rIdOlB1/JTB0/Yhq1FIbBwuY5YQQdJFAcJoo8vSChXRzjutZt0Zoj/6X/W3//t///r////++3/ugy0FVrektJl13ZOhey1GbVaFk2RZC6dTzqvhmt6hxVLf5wSeYxLFgmkBczBlvs5bV2Ydk8Hw7nSXauM6yKYLWuQdRG/NVwYNrQSoJGBQNLxIwSASZISBR4BiQA4jOU1qaGESfbfxEqgDPywKlGprcoEiynVpzLtaHwSDidSwssomDk8AvBJ0GqSPHraWu3Sr+v//q/b/////////pv06+72U1BnqrRoruitaSlOpaCq3UpF1aLOpSNFVjbVXdRqxu9C1SjGt0HSSUZPNN9CdjAGJEih1oQ14pVHnYzoH+r5cpqMkELJrkQOBQcAnKV2mAy2DHXizdJsRDB1QheQCDFgY0QhWnX4ekcMDI5HJi+21H4ownVDWhiq0mnhESttIAQh5crKzJC5kH4jJIregFsNvS893Ul/tr/9G//////X//////V6Duy61uqi1SLr2dk3UfrbpKZTvU6Ot3Zb0D73rQpJopKUzJrZalsaqbvI6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAElS83gxrSYJTuRvBjLW5TPhTeB+mtyl7Cm8GMqbmOPCIZAHZcNw6ann37xsY8uzFTrMJDMEQq0JwmTaXI4U97wyhXTQA4HKCYzGSZ5Vdlf1iaqXh4EnBS0CO5q3gjsjQ2CpBCY9LKPtZ9UPK2ePce5bmSEXLb/Nf92P///9X//7f3OX/yNLv///7P9qRpxa2J3pWZOtMBxBw8JHkjYIqcPA4YMIUKgsDANtNhELKIHVSpvKRBIcgoRNepncvcu4WsZ7GRkCiQkyDgG0L72NzTz2IgxKnizkGAeOlFYa1xuqXgxCUyytdomtK5k9OQhHrKQ0tbp5DaapdfOXRJrZlC263ppKdawk5qk+pxzt669PtR/16v///////////+/7q9b9VfWylMtSa1oLSprMU9o06cfbZmivT+uUdMPAMjWkG+06VfsThRAEgjxrJshT1LoVGbHmvjQZyhjsGu81k6hJxYilsiJenl/O2lPeRQVSKBpICIjuKDWMur4QGFiaEuPQtyDtGzBRw4O5cC3W5y2WbyZCX1lF7jHHOpGQBuEdXqGpfq9Dp0tX//////9v/////////palJpJXXXUmam1To3Ro0VqUm162dBTUlstmdc+myDucb2EzRXg+I2bXBktY6eWluFvvBFqz/SyrZyt0sei5Cs3WIEg8UVQm7jWHd7YaTdarcMsJSomOHCx0SSmCb25O09lI8SJ5HEXzPoJKR6N08Z2evQi9K1VQNlfvaVZ6HACCc950wl+u+/p/tr/7///////////6/0S2atHpMU9kmqiGKp7GGI5zHHoqse+cYruueZujnnTEchUWq0WUP+wCLrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABNV6N4H6a3KW0dbwY0puU4463gflrcpPupvBjJ25FzfluBzCaGgeSSWHcNVLGo+M1ZglCCOFARwDbr4PmWxCQnUqSAwbxti/ZKEXCMhjJgZ8EjcqWvcpgYAXVTXoHA8skPlCuA5bWiuWqs6xkmLQvH0E0EGSAoxAWpLSKJ56q75n1V9//X9/////+///X+///9W7rWu6K3szOjXQUt1uulRSX21zqaLH8CGi7vyw1t4LADvMUXAZvirBuKzMbELCZ5J8ZNZlmNvnK1iLkowBJI6HEpS3G/TqrMuv6b6jlE4JIXgKxbglbCKAoJ2HpvOoIgKQs5IWUHMCgQKTS3xs08E5v32aiwZEgW/7mHER5QD5zr3C4r6/9f9P/6f///////b/6f/tR1vpmtMqr599jkWxCcaxjTDUbSlnLyFXqa1nLMa7z2ZlU5rIdVFs5WGi4l7YQaAYhMzNjnk14jslbWsrCT6UL4F82kmBxHb1oWChmgXfLE/L6dBIIxxc4nU4ws4+czRzE0SuNWsTSZJ/WBQEoveOWSB9qan5LI+l5esZqRuyIJUuqVbHv855zr///69X////7f////9/el1erdDdalo0E0HdJ0bI7vRQdBb1qWitBFA+jpJOiklTapGgy6lrQW7Kdarrd53JmMpk5FAQjSFuwJAu5uWXLd+liUjJQgAHHQ5RtF+Sis/yWH8ZZUdrAOTZejEOCFoYYCB5ypRTdAXnikJflQ4+yU3ijZ6Zm/Mx9+PfZspnoxbDzTnH2gGGqj8F/zvdvM/03/////////+/T///M7I2caucrMxxp7nMkkphzTrsOXEIVx/WQwTTNONNCTc3GrIcsPkw4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAASPfDeB+TtylNFG8D8NblJd8N4MZa3KXUgbwYy1uA+pgrwmAtAoD5bj3bKYWGpg5UhwhJUYgtTJmBmZ3KemWrzNM6Pv89jA1bn0HCxEFKiZ6koMN2hCYHCQqlTsLHtQergOzCt2ZrVIouWvmauLSpqIRDffBZ8frle/2/////+3///////sqr9ey8xueYmcPs1macY7MjlDDTZiM1luqHETbZrFaf8cCZn1MViuvuy3lIgbh2APk7Gctr9Qwm9itBt1Z9eQOwsoKDjIQ+d5bL53M1A59mMbBwCVL3LaDbxYeBjL6mqUky7UXrIujPkyivL425BDFqN4UqqhppPWrdZxBCKSPeslD///f/////////////r/96lVsplXtetN0qaTdNNnRqUk62XV1op2MGoshRSWklsp3qZ0lalrUnNlxnd3mAOlKjIUVYMiZMyhuMtqcxq5d5epCQdXkpGjWinm5P4QWLFyKMkQE8sHLU3Gtuo10fsh0MBkNBawoVTlZ1BSr7POh0hqaO09mA+SXC47oqF2/jsko4EkVqe4729D1dv///2//////////37f7Xsp3qRrrZ2MHUtSKkX0dKy7WVrZalrPI0BSoKR2cGSCKl6Vfg+P3F27bymVYolUcojT9vXj2rndqzGUrQ1gYariYKQsxOSIdrVC6WbVKyYbOYEVXBU0rDg85XKbuAwmhG/UPsoPYMLKFG71z9+LSiUV5hwjcBnab1NuweTd/WTv/T+j///////+yv////X//q9trOlZTqazqQs6kVMs1ps7PZVbprecRsjpoqd0LrR1qRUpnRdkWVUnWqyNdBRwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEzIM3gxprcpWwlvBjLW5TikDeB+mtwkjHW8Gcqbhfc6DQgi60kjW/d2ZlljsQt27GsUC3BghicCA8i9knjie2F5a8jWi2wqBQ7kwAsCDEAZSNBu5aswyFV7uwTI3RN0BChYoLyu/bnOyrOXQGJHYprddKiFmaupKudfQWmvr71d/+3///76///////r+3q/VdlLTS2elTOpqvRRRbVupB2ZbsukuyCVFtbNSWmx4hKRug/wlk4zfZt/BGliKIAeKWvLBGGUVo8qXmeDVR4xn4UAkwFHt2cwy2zaUjSP9CFQDgEVQ9FkJkeVi9W3QypHhWqSaZUC5yTIaGzjdO1XGb/3jEm3Wve6DsywjvfqHH//6D///////////////9le60O9JST3Ut3RQSUtqbU1HVJO6lrsnQMUnTVU61LRXddFS0UTWLHjsLRVkS8EiZMEEyAKA5j4US5ZINdtE0TLOyrK+ErUKkRxQrzbZ+CgNNKWsYIcJUi4i+TJUng6m/QQdo6ecwj4AMr2q/HCaWKlmpWKOtnYhnC62FMe3jfoJp3BOSna1Q+P570v+3///9f/////////9/XetS6SFloVou6lPTUkutCqtKbstNPWqyDKZjhizqooUFqSZNFJrum+pJk59bsmk6mN1XnRZCIEgTEmZ2GJRLaTvz2cvqabvUbgZgbujAlaaaqgDl2K759Ru2t8qJcqBhMsLTSCbzo5IIwF/vbNKPmM0K0MElkWnIcn6TKkXwEDWe49WPBI/8RD/9dd//p/////////T/+v6a979nX3Z3VSrSNz0RJe93NmGIiOe7K5lWoeeptDDDiqVZW2dFsxiI0163LIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABI17N4H5a3KLsCbwYwduUkYq3gxlrcolNZvBjKm5TygA3FyAUh/MjG+ex3Bvj6334BfG6XQdE7pGa5N1Fqp6aX7SKmbQgBpCLRBsM+jRoiPlM0daeBgBE/OX4BA0Ct1mraq/8PfaaQpRR5dqZSoEquq1ZN+/t9H///////////////ZepJdb1uzu92W80059NJNSk0mW1BNltTdbJoudXBninU6ayUEQsI2KmNsjuVxuRMJLQJRlaGUwFT1sbFTO9NV+R9WF2hN9cUPCa7+JzVY617BnEDoDCrCB2xTvRRM53VioqhGHszYQcqkMCYEok9G6XI/fyUaV5RVu8xRqAcbvxs3/O7Vb/+v///////////0+9vt7Kat2Y4qdMo6uh9Z5/mVPqyN1MYxZtUYffwQXpLnSgaiVHSVQoDpFuiWrrjuxBVduVjV+3zLfW6RB4ltraAOc11RRBzcqaHKx0eSpjDghRoSBg5h9TCHq25+eiQi4bbcij5mijAVTVPlX2/O6z7AoXDm306YFKz+xLP7e/er/////9f////////9vV27O7pqqQST2TTVd1qRupC9Cuqgp02UboJqSZbKNklIJPU113TalzpePKHVtY3IBVoz1lMxM17PJbN7/dilqruYykdBojA7UnRIHKwlzkyriFZVSQjbEmfaKg1S9ar3xAE/kC1n/B9RUWImIAl+MF2ZiZpHbUfo8PRnPuBAbbdBH+nt9P////////7//////+qbHqqn0MohhCjC65UxIZOerrwxtgjdz26oAzmttw5/sf2ZMA1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAARriTeB+VNyitBm8GMqblHuEN4H5a3KNsMbwPwpuYrMogHkOMbS4YLuLe2TO8YXLbGn5l5fp0zHujeDtI+1L8m6nQ5yEkcaJoYwLcxQKjXNzVrAw0CYyeuPGYRhAwmxKMrNbJ7sLTcEB1zHq0sgDx73Vo0+d5btX/////////////p//Tn+zsz81TN2ZVtVV0Z756VP1N2RFki3ZTTnPLKeYphx2eQ9p/Npcivp9nmFVMlVugVz5mV16u7dXvauD1zg1DOl1b0eUfbeRUrf9icZL+DJRMdH2TW1D4Oqd70hOTMl9NDJ7BDqQ9pBkqszt+hraipfLWvQyYzgfb7BQf/+/////////////r7df/9H0SpptnmvnKYaczmZhv26o6IToY5rmOaa5KbVHKnZisTF2IZvyeykUWxAWBDy2L7gxuqPldr4fk2RvIBjDYDohimdiCp7kXjgqJDiORUeHlUlGE1hQWd5U+ARV9XNSrQCAlgxQJJNW6uT2Z4NEb2dy66CSTsFa77Vu3o+f+2r//////////////6/1fqZSmVdFBbIIWVWlXUtqK2QugtakUEnpM1a2WiutaaKRszDuk6cRm84EaRZCRhhKR2Hu5relmFi8SNnY62R9GlFx3+dKp8mGnYRG1eiMNI6tKKzwXLKZdFSY7lxoibFu6vo69XeU5fDCegL49zkrKOxXLN61NAhJ7c4Ltv+3zf////////1///////o6bIbdWKsjHmueQIZc1HNOPVjHarM6KzIzKjOczHKZozs78iOVQCmyQGX4n6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEJIw3gflTcodP5vAzBW5QicDeB+mtyic+G8D8qbl4mRpA6gvUJYW1UtcRc31TfNUFDMJmSc+xoXQ31GMI/D1Uvu/LTSFxZr7FZ8aFRr3xHkyFi04qb5sDHFUFKGmv3qmEP57j1+dx9NWQMlv4tt6JzPv3//////////////zO3bT/RVo7PU82yNNvs7O1amttPa79jiDWqUVOYedORVlhVmKBNDMgRBgJx6PL2swON0sXM1sSx4ww0DM9wzT8WEnbyTGDdK5eJR8rTOL82v/CpUwxGSrhl+DPwDgVqRhiHztPYju6VJ8uXPf2p2mDw9usAX/7/T/7f+3/////////+vp+um11RlJ3Jd0IhFRUVFah1Kx0PKZ2Zq3K6DyjgGCRw9qEZ1Cu1zCgaDQJCA4vSJ1DV12qR/jfbvbSWFAhXofAQdjS5/StQzS9b95iqYnGMpJdLmwdjVtWxECVri9iUiQ1djHMtf3cg+MOk8U7ng6tJQVps+2WP6/f6Pf///////////7f//9BSurpLWt1UWSTZNTtPxQd3C/3t9maVCj13GeFLkNYDHjL+n2kiIcUAQ8HeLCxnkuGxuZ4sZ/dqZqyJMwSPGTzIp2o/REjjEnDuuHUL8lUEoCkjyz7m46vfdJT6sD4wAcxIgLVDasW8bUq3YhktVvHB0RZwiDPww+b9fX///////////////mddV75702VmJGPU41Hcsxmc5rzlR1myh5Kt5+obqzoqid+SbH/qbCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABE2FN4H5a3KFkSbwYyduURIo3gfhrcoexZvA/Km5UZCBIzwFOGI0PW5q76C5XyuZzbnR1fD7HeTIsYDYpS5UOBYAl9EOmN+z1JjFYaxUuazKiUkznbitan1u1P7/w/nyJMzw76nWpzAGA8v59/V/vV///////////q////9T7bs2y6Sj6Z1NS1osg1R9PTW1BnoG72UlVRoWW163XUo3Up7ljLGnKzBGcalRMRVOJ1cuVLdmrbu/cyVmTgkkReZmNzkTRXrV2tbgGYSaIR1CpUi3ktKzXx74oiq/CUxojTC5sV1O9muTuPel6b3edEYAM38H7ej/2t//////////////7dP6p3Syc8xXWazGqpyohh5jXMq5Eycip0NctdWmI7Hqhh0xGZpOJCap/RGUMURmBpCMvHJqfyNj6/vfg2FnNVfrwnLVLzT74VX6lj3QmfJQMfqKR01mxWpLFKsMPAl96P0yZLm9/m8KSrZlbKL+uprW7OAx1q7Um9P37V//////////////6//vqX1O6KTKSQXUlRUySSlUb1U1H1qs3qQPKeYoIaltU+6tdanZR2W+gG1EVkGQI4DoCfbGCeNamtt+dymaMNK06TTnqbY15IW+yybWQQBkkyVB3+buyrqUva/LWUBlBUO8dEzhCpKq+7Ys53r+s5krDnv/qkFD/hcv//zv///f////////////teiPNqdPZVmIecqTlc82jH6Hqmxptqmmppz1MYxs4x3RDyVVpLnciTtEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAARyijeDGGtyhHAG8GMKblEiEN4H4a3KF8cbwYwpuYxLxQqh8jZTftdpc7sv53mGEAoVUl9uhY3MYSiU24guCqn7Nvv1vnwd/FTKczpb1KVFkwKbK8mosSEX8eZWpXWrytrs/j/OucBCCl3zH7f72////+r///////2/+r0+rUu6SlIVrZndN1tsyq02daZ1nRa63WhqZ03VUtSkHd0bVIHmQWkit2WaNhSrTmilcBsIXYMSh6CKazMU+fM+8lFqPLokqgEDp06swULUpbTv4T1pWtRWcpVGKiqHLtfLachEOQZt0FEhZZM+JyG/N53rF96mGWMPTdUAvp6gx9P/X/////////////3//tqjXve9Vu5V3WuiO5LPVz2no5iJzc02p6ITyn/cguWaWSUGv+0quRJBAlQC8dCecm11Gar1f8lfLqeu5VDZrlP1I0+d+gV/fcSFMMXjGOKF5pE519WapUTAv6uJzoNK0TWd/XLlq7Nrip9/VOOgC8h+cf/+hV////////////+72/9f9urayqmRUpBTUGNqkFO16aCCdTprWcZS3N0Xsp1stmW7JH/0qoDz0f4MJGWIQ8CCcLkTp5Jqsvq18cPt6y0LRqObRtOr4sLT9ppW7V19ck1Mb9NQ5Mz/O13RKJS6M4TYK83ModQ44Und/p4li3v+jqiBocnuINvX/0/+v/////////////1XWrJa57Vc657KaYc56uYyy5+hDV1dVox7Kpu6IY2s+dcjatUNPNqmYURbIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAQmhzeB+FNyg4/m8GMKbk+FvN4H4a3J7LnbwPepuXUYwwTxyGgpJta3C3rf2LsAFttyjh2PSYOgyzOOvVTKHaXWzFQiJxColV+7OOKOrH62ElQnLTSwoK3K96rl+oIx77vPkYAE9fp9P////////////////t+hhqXo593NZ3S5MzumeyKjuru5iNNWyTWZJhjMx1VMU1WPPuhpBdM1hFMkAV3bbDEH8HTscfqduYzOdveP1LkrfyNPdA8prV4QPen7za4vhkpOA5Z1vvbpXytZVCwZ8sfpR7jslY5vn02HMdvova/h19KANN+Wf/p//////////////t/36Wr+7GKtHOPRVVDzzDj3pOT6HMZMQ4w41TjasaSU8rNARzFwY0UQBhItJoznAHoHGb4MHzY38vvrHe2wJe4Q5XF9ReURtpta8s280uQMsXgixgnjxN3PlXO+pgUC1diARVD1cNSx3Hv1sHjgHXPW6CFQOp0a/+/+l////////////////163arelru2hrPUjOVN6N3Y65yEdadfSDE63sh5JlcbPETLIacZzAdgRlRvoL+Td/nGtxCjDRjkydmhmoggBQ9XSD0noghFZXAGhUq9QY9dkqKxaqdwE+pASzf4671fOT2NCtt3TYCVq+JX/Zv///////////////t/p10djFJTzbz3R505s2kjWbg2SFvow/cdgAx2SXOQj7OXLCbiwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEQI43gfhrcnuFJvA970wQBfjeB+FNygXHm8GMHbku8cyxZRYzChsru+39ouuVL71JDVp+UhsKTuh7dHcZPtZNGuscMlC3aI115T+VNarFRzlb1Nkc0O7mas6/dr6+bV8Ofu6J0Mf9X/v2///////////////9X9atWy1UE3upVF61IVsumgfO3Rpsy0HWlQd0kl0FH3SpILosyrO5oilQMWTsxnxzSS2Lacw+BGk5Gjxtzy2pNSYPszIp+M5P52x+B9xqBFKOg3z2S5hE9uTKW2tQ4hEuciLAEQIQVUG+qW/gLYpLy3/x97T3///X3e////////+6KIVYKBkMpNAiJA6fDgOnB5kFhAbERwCwAGwTPiwmHAqOF1CM0JkkjCyQ50phyLkI+Q+kF5NqHDmv/e1lAeyqaNZbeLIC3E78GX2QRZwCBzFZ5JuXsNo8Lm6hCpICn5KTsIsFkOVizhq99XVJjz0qbgOf1//3/////////////////VGrXq9bGGIchqMiHuk5GqTlkYhd1ONdFQxXJ/BtWUL5E3lDbYgK/nA0EP0tcPGlI3Lr8WZrHHPmP/eT9UB1DkrU67lEW/rTEl1FZ9Rx4mb1yK8+jrljhj6O7i3+2CkJIiBscu3Mt87ZUna5/aeEP7Gf////////////////++noZ/zERWZmdTmOWdv1NMV3NsbOs6IiGPmuYyFkOaphGqLP0RTWZjTVOKMOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABASKN4GYU3CBMgbwPwduDz3Q3gfhTcnvRJvA/BW5IA/ktGHo9k46hgfpea4VMbij1WJQaKIl8w74KTeqO7caVFHpJJV27s6vt2v8qWZSgnU9frtiBMSFMXzvWu/PdxmXVz5+iYD/9Pt/6f/////////////3/ddU/vRjFMmqY5iHmmL3W9NV2z3RVVnZDD23Psr3Pc15h0mMqRweN2lF0cgwQuAyz6zWznEgx5d8vWFE3CyjWlAcss6mVNTdhqouVua3lG2EbRenfsXrpVK/dbb1A46M0gw73LHv7wdK1//iD+Ub//////////////////VkVKtnc1FZUHnQn9ldEPVjVcw+85zD5jGGGmmuqHnP2azURrsYZNLq0xkRHRyjkyHIDVK1cWhqXevEvreWNdSnBvJgKFpM26i3572h5r7sxIho0OlGiWWJ552dzIoOdv5N3MrCq1cd2zRXfnP+q1fX/fuAo//6f/////////////////96J6zUROphpiGWLmItWKmMbK4J4eVSGdO+XPRieDt5m6am/lbl2rxYQ0mdr1SBeDe2easMJZ/XZ1cYdnq69tq3C713jOknaaQlEKJLeTdvbyXy69JUgsuc8UI1fvTeHe6tvr//9Qm34T//9P///////////////7VftUj0+iDVu1roiSNREO0jDHRDXViPcQUrWZFRoizkVR7k0KyeBWPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAQAkDeBmDtweNIG8D8Cbg+KOt4H4O3BuBSbwYfNMBpRAzACRxKD5zr/fLYcwibCtNPrgJ1PnKEePm5JXcmRzhKxLNqiYN5fmWNfuTEHOnNxgH5QElB5u93G/b12s8n5f0wD/6//+3///////////////bTdJ1X1rY9OqIY7MWoaeuqz2Q6a50xFaczrOc050NMMszqrmsahipMR3XqQwqUMAzDpOZmWbeuZ5L75yCWRXXIwZza7DcI7XhzVS/DJUDFWjN1ycTK9zC/XX/exlAt1PRs2vysZf3Gbgbn/+Ab+R//+v///////////////9tusno5DUobykY5CFRcpTHMUz5ndHUlIY+6luUl0mYj0RnMrI1XKJbDrZD9DNFvzet/NPnP5cjrVZSyqiDK2MKMOLzb82lGr7njoks3iFry5tsud7pF6Q0W5UH3f8rDQ8yucnOZ/vDn9cGP+n//////////////////vp3o7s+9ldjpqmZ9zTDLOxzNNR2VEVjTp6HnIedcwx5x793Z0Wp2pl5OP+zsHHZo70Vq65LLrWfvWhh4VlR6t9Mk3+pd7ohQJMxB1BQ5sPZ5GimUQ86aJNAMjELB4CgpyOZdJY3kH/mzfnP93///////2OJ8NDDh9iziRRZ5xImRQUEywEfAKVjhwcA62FEhNBQaJjxYuAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAD1Iu3gfg7cnox9vBh4m4OIJbeB78JQcO128D8CbljlL6iEkRiPArLFrmv/Hsw2DbNaQifT+2F78s6O3D8sV4m8jEo+XSrx3dzD+O03udxsoEExkrLQ/O65L9dqT17nOlA1/T/3+v///////////////0+lD2WjaZzu5pqseaarq22pqbnIZTmzEPVa12dlzbmPuaaUTo0ZHmZcskOKgmZrXnp2zqva5/1uAMqRugCw0hroWLeVdptq9CWioO8WKVGTR97udgWXoe4B4HeYsK0VvrTWV2heP++Vvwf/////////////////6/+nrdDM86Oih9FOzujOrMiDoVWupWlU9pWRVPJKQ6ncjHZWbZaldGYE9ep4c0FpVmZ4X8LGv9noX+RiZQJT2uQ+PlUYvrTqTdIiE3UWROMoyraxxQR0NJuCAQN5Cacfz7X1Sf25AuOv/9//y3Pn/////////9irYueAkaeMuVKBhpelKQ6Ay6go9AADgCJBAJh4AtBIakuKgFUjERpAiZjFh2p9319Za7WYXi+2Cru6lSJF74TyCsqV2VGHxVBtgeON/XRwTHuZvAAmspp8/7Z73/zl2v/8V/Bf+/1///////////////6eyU99iVKFX8q5II7vGvH4yXdvaA1ppDODU4UwCY0JOVQdkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA+mDt4H4O3J2scbwPmVuTso03gfgrcnAOJvA+J25SFCjF8uC8/M96y6z+860ZpGcLlCVf9eB6Mbj/1oAn1LHjULdAWTYbPY3zddD1e8h5bDLECCY1Dn97Vffcp/Pn/hF/b//////////////////67LXfLVsZZDjZp6nnnIag8dQ5HOmmsjWUw5kNOMU5o66WJnK8y1h+XEoROqvOyMGICMru+Zok1dUtZNhQjDMGofRlC7EcpJF9ybPF4qB4SMDsw9A/daghMbmrFYHuJ91ZxSlzAnGf+Ar/n/////////////////9NNvr2oRUK9lGM4uzked9SnR7vofV1WxiFqcsqNMRLmZhRj3OzEZaGGJKVYnEdwg52o5/B1/rWbfW61R6ar+Uqq1u5TJA2PtX5dgmOo60JjSFfXdv47/ruJ581MizCwxcV219btTf1op3/+oW37///////////////////pT6fUzvewyVkSzM2u9HUzGIsRtMymVWRSoahlla7WRXViY15PLMNRhdl4Mpsc7YpDrXSCTqE3mBWPCxpJkyD0fWXlkNTJs+J9H0LLTEftSZQrYT4apDVAHAu3qZTLemSP/CJv///r////////////////2tauc7t1V5k5zJYzpuhj3x9c2xbFykWIhm4ffw9okmU6lXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAANcIDeB78JQa0Sm8GHvSg6mDt4H4K3JsxKbwMfJKD5bhFC3DfSunPc29Q6fOtncMTDK6ExiXXJC401MY/ZTkY3agsaVfZ93fe+h2fOzysXfJUWvt93yv/7st5Xr/////////T6YaAjQpC7RMQKHyoLoW9IQF3oOiRRNcVBskSSCIbPhY0UPAoKhyUTsCDVFLJy7nUp63rXda7oTzbE9UGan4JpmO46Um0U3GpOKKMIxHxrWTNNXWT0AZTBPOXW2/2/lg7///+V92W/////////6uMNAYGBQcYQERwGDR4wIQEtpc2EARwqIR64irPj0hFbjaxhFSKZDixkJK6V/rG703r9dj0V1FsGLa3YZ1lyv8zpYNotRo7EMXrx5f7skBCLOElReJFPJhf5d3l/9n9c/8IN+T//////////////////9OfWrq7slnYpzOlWSyISQ7pIYpB1HZjDn1dju7mSo7oczG4cWh720rLK4bBoiid6+q5rrW9yHfpeiuf7GEZ137EWNBjRnhsjPkCOB4ns6IaOPB9imAySxtJrY87IKUOd+vLnK/////////eruLMeXLnwMEWAmSMGxcmLUiRRkuQB4VCpoEgKDp46Hg6koEmocCiRYcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADjnU3gZgrcm/QBvA+Im5NhjDeBDytycbEG8D3ibldyUHioJPvuXyd2n6ytLc3fxbzvzTQbHaT5RbYxEaKcJi2HQwwrbxVSey19RACQkTwqWu4dz3y5Gv//qA/9///////////////////p+zstqq5HarnVBxWeUcp2qOWLnKEtlMyOANKYv1CNo/xTfD62GHuuDGSyMfOe7WvSt1tQGYOFpEiLx0h20jpYj+iITGx4mRDERGrptWF4kXSkyCODOD0mqUrtMhgt/gf////////////////////12LW0plcglItHspisyXzO2WjOVDSlQxaOFJqGCnC2V0jN1O6HylUF2CgOAqFIVtY1+MQ1T4Eh1465NXXi9TYHKrGUwj1wXea0makrNr62BSOoHg2W9vj6vB1/+GP///////////////////+/rRuXyMViKSW+laO6IrSIzMZTo9y7yFIS1TDHJIpEZDEdZBHK1kELCuNwe72BE3i26fOseG29N1QreWwwoeljssYhK7cF4msQg2s5/FlG3jK6CHqZbzvd8/NJX+//wD///////////////////RPpRF1JZUdSIPOrEOaz7qqIjlK7OZNj1M90VShDlMdyNZ6o4pJumP4xIQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAAxwlN4GPalBuDybwPeJuTmIw3gY87cmtxRvA14m5T2EBkKSCop//dc63jrtAYeypjXbRS7WW3JM8CTCGHmPwFs3JjtZYD6YqZEBOCxAXSpCtl7F9/8cTtf/////////lEIbMoCREaLJPTN54rK0mTVh0SioXBAJg4WOJFQTho8MQnxVkOkSVqxu9Pn6vnGmtCIKmqfWaRhmxIEPtWRjItZTBe7i67rX2mG3izeEePSfW9Rc7+6oK//4v+3//////////////////TyX3dqERSXVTlOLehJCoec7qZ3oob+sQVXkxXWwzc7T5IDVSO1mdoFZTVpGor9W89uP2uXG9nL7qQ/q3YOudiYnsWqLQ7qzXz7KBLYzILeLuHZJrcv+Pti1/9QN/p//////////////////37tWf1RjbTnZWdGYw81DHNMmMe6HNRUsrmUWzocY7qlWOWzHmKeqTFOJkBSJaUzKlhOwT5Roqtlr9+jW26QNEvuinXP7730RDGlG8Z1io37+xgEVf6A4jIif7k+fjDR//xH///////////////////9/0d6PfaqKzymVqkCOCciIZVVFVynp3E2PRzGZCupzmO88ilEnNuytkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA2uIt4HvO3JrUYbwMaJuTTH83gfArcmuwBvA9pW5y8L6RhucH1oOLbxT/+V1dajlNvUYOyuHuGCMS6w14I1NKPW7X2NJ9beSYA7yJk1qBvP3dQ//8DH/////////////////////93zXuzzUPZ1ZUQw53Q6bXObRLHrOvRkZ0WzMqsh6IxWIu3rg0el9WJgHiGweXrP72rsVkocM1CcKcxBreeoKCXGOLwzjgREz08Pg3GVIBliBC8p671LHO/+L//////////////////39//YlNrOmZkM7uQ7lOyPRZSqZN5L9DM6pQyIjOyMcShVnPltBOJMb1p4ebiWUej/ebXiZ6OgkdJA6J8RWP4oNSI9SHMNEjxAxYIqxLKVxTiRfFdCOVZ6k1KYlZL/Af///////////////////v/9karXvUr33O97VZJ5XcqolpHLIpyiJ4IkIvIjkB+42szfAxrat3GOK+o30Gl/b6o2VlqxOljB1j4J9SP0jUOYTRaohlYZD+BsPnlFYRRYtEHbas4MF/wT+3/////////////////v0+/6qqMZXaSYpFYzKRDiinMromy0TU6MpUYpxSXdZ+FYEDzCXqOdSUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAANlkDeBbxNwZI3m8C3ibk2qNN4GNE3JmL+bwPaJuStINQ1XDyvO7rqf7tk2GGQ76ZiEu30ptJ6QZVlfIm7HV/jOk+4W/NIEit5m1f/+rJr/8A/v//////////////////60X20lRZ0ZSuRVVzXVwTNPRUupHRSKU7pIjlQqsqHKqHZq35WZ3q59WFoNHYJDqJff/Xfz8xYKEVOj4fDx1mTw8ItSGqum3D/+34uzJXyD0sCAx9/7+LFZX/8V/T/////////////////2r/+1yu7ogfFmcqAkjgEh+On8pE9V/LiCDJdXmPVAAT/JZv6BunwEgrI4gO2y/WraanGhNxuMwvScqFoiozlFxkBEiKWUnC6n71h9N9hKQSoezrUXVnSb/xf9v//////////////////+vTZXZaJVzPMyF0OjmJd2BtMhWU2Du6uZkZmRi3OquZTCWMsmgYZHyJC0iiHpz7mzT336NsWmA9WGHeVhZvPUExJhDEFQruhuuPwiHZwfh7iJVqtmYw7/4n////////////////////WnMz3o+V1Q52eYi0IZyHq9Tz1VnQqGshxbiWGUoJCaVqNhP0dSMoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADT4k3gW0rcmXxxvAtom5NLjTeBbRNyWkSm8CVNSgPjRiBYEEpSr6Yz6nIg8DpgiKyCjMdufQGpAYMIMpJuoK5XclR11DqNIazqM56I9v+Gf/////////////////3/p139t1I6q7M6s1nZqsdDs6VVxhjvEFrZElZdGllZHYzIrMoiTn50oU2YkgluBR731To/Z61pDdHZWSAc5NRvOICMibOTydXvUTA4M6G4H8gqsunsO5v8V////////////////////+78uyq9nOjXOzyloqEaxRLMxHciEe7MuRkDknsNQtdFojioNSsGdhoekBcIqZCWyYrZytTmRKqKJwOe60yE7GiyTNR6CqbItELXxoG7YlGCOd+uou/8C/v//////////////////t197mNXR1V0mdSmZ4pEZrozojJfItySOaR3Kxiggl0IYynK5Tq6qroMcnEjaiABDhTyjCyejFFHkXtGQQMcUpohzhqLURsl5lce4iUlnBih9Rs+24wLf5r0/////////p+t5pwkEJwYAROgMC7RMFGH1vDRoaoaZSMUAxUiJpiJwQCrYuCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAvuLN4DNK3Jj0gbwMaJuC/o03gQ0TcmAQ5vA1om5FkSY4ytjz/LeqdLEi/GI9TdMdrjjGnRi496hBD+o1EkDWdTr+Qn/wj/////////////////////alGNRVlZztu5nK72VWJZSsrupWOp0ZGYjzMbUs6bzqQ7s4gunHSYod0wCQrNL27+39nnCiolZORUmXdGYuJSVFpwlZNqasXSxmcPQzprRqp6x1f/Ff//////////////////9U/700RGZplcMdmTTIj1PGK5qbb50ZHCHkW7a3MUGyJZLmd3nIimFkuDcB4epd6f/ytlj2j7netRMcYhdXTjPVxzEBJpHA+C2W9H0DT/gv///////////////////9HsTRjVId1qZJWU7a0agTYy2eY1a0IqhlIpGpopnd2McpTOh0jHDuP3ISCRRCyDGaLTt/uWOPNMu6Jvn5g4ikz5wb3H71iqtqIXwZy1bdWouf8v/////////////////////RkYxSzFMV9waSz3VDM6MpyKjLSZ6lrKY5VKkytc6xzBpySNAi1/UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAL+iTeBbRNyYZHG8CVCbgsx5N4ENE3JaD2bwLUJuXwKyaO8nxPO+v5FPMQGH7WW1ZOYfyYfTSkg/REOQWZY9AURter3Mf+D//////////////////p/p2rflZHZXvKy3WeefdmdiIehczarMVkZiDO5UStULZnKwgYQVOuOUGlgDsiUGs2p/N/2GYmKQS2g2dWkzAcGMqLUXr1ECOmSgSw9FK613Hv/N////////////////////Smln5zHdJCVKzs53QxDMyHmREazaFuivW8+jnRDqypQ5iM9THckESMNFhUKPcPHf/yKmovpDhatDeT0SITi1iNP68Yr6h6ioUFPf5t/wn////////////////////1KVFNd1XMqstjSkctlszUchDTQSE3sZ+9FFpKPnwmfs7irsJ7aPIeQwNt1X9cbCOOREqO6Cx5CgF7Mo0trioO6gUmFK6U5M/+X////////////////////tdFMezOl3UjPO1rNVGS5mdT5j6IDfgdCxRiO0/UTunIbdO9MVBQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAC54c3gK0TclVjdvAw6zgLdkDeA7RNwW7FG8B1CbgJBweYIAENyf5WbS8mJUnc1azmLj6opnDFkdexu1YyhUGxT125r/3///////////////////Xv++nO5rykY0js86MUjQbapXBKV5UhLZEnRWQxpJWg0VHMQGWp2ijdFpFF8W9O/sISMX2ICt5N++JDwosw7pf8EEXdwDJQR52z3s/////////96U4aiByBYDuHtBYaHBEJRcChkVHk5kLlQEHhECxAusIkhQqAVDhMAw8Eh9QvFYi9mt8xdj0Vmzd65MckjMjqIdvUMyC8TgWQtFP/f/l////////////////////23ZlWy3plRHIxuU7URTA1yHRysiMtwxiGQUyJnVyTs7Z2ZNmSisqlcUorUiBIISKbv7WEd1IINdTQ/e2gVxcac8X/DAvnAfGQ71py3/X////////////////////9K0Z1qx8zK4JlO6lVmRSWPbY6SOdDKrymOd3cwlEQjOy2MiMLTSBhcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAApEbN4DHWcBT72bwFOJuS1JA3gKoTcFawhvAc4m5lwkABZks3/YPRnAbvg0926h2lZmqTpLvj1zK+BvXCzFZT1f/////////sqDzIdNiUoKPYACQdKhYOJGnwMOOmhCqCJAGgyMOHg28XB6JBeFkC4iLAMwEzWb9hCTi1Qgygo3qoRCbLxzfA4hlQECgv29T/+T///////////////////+b7v9N7nR1Kr2okpuhWVXMiy3B7ui6iUUylnVaBCq0A/5TmggoiFhGS3T6Zc8Fg2eLOylYihHJjRMUl+Hpr1EEI4cT+7f8////////////////////f7ezPlsXZRTgnaglTzSqZnOUiyu6FVu1XK1qLSfZERqooV1c5D1nuIKHIFQeHobfbrE5OThDuBVu0HIgc8yf8eGGoA0DH6eg9/3/////////////////////yIj3NsVI1ZDaEufegUzHcvojEVnWUKpWa7nCLe5KQ4CeYjJNBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAK2hTeA5xNyUjAm8B1CbkrWNt4DnE3JQEGbwHOJuR5gsLx9dr/5dRogG6i7WY4kiFkDKD3xSS0ANEIcn+//b///////////////////7N/ah1a6NcfezMtzudanXs6sspWKjohCo5HoUj0UdC8YbYHy7g9JCoFglImO//lRspSIrUnfpEMRF7TX9i3BUMm/4s/9v///////////////////+ym09UndSrcqFIbsxSolrlVu6q57KhkZXRBD6SWL5okvGSyzKDimqEwsY+n/mIaeA7RM6Ui4Qlig3if7F+DQPGE0+Q/6f////////////////////82ZlLzkelSPMFRhZnRXnRjIeaakyojXPKEMWjjsdrOHaVHSRiFDH9SQAKGQzov+ovkY12G3rFpxe9PnGahIOFv9S/////////////////////6frtelq1cj1Qyvs5S3ZLBnrSd3VW2ZleIISWURJk6OfIfWh+xhEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAACqI83gKoTckajZvAYRTgJZdzeARxNyTC+W8BSibmcICpBAh7/8nk0KVtdp7EovHDxOlPi4m1FgMW/1P/6////////////////////rXt9UIinU2xJWVe1Iy1tcxSOQ30dTse7WVDsZXkdqopSTFRiMYGQvgwwH1s/+KvD1ILtWDw29vsOagWMHVZT1//////////1MqA5dp8GQdGrFzhwJRgq9MeGSwN2sFBEHygiAwqJzoHGKSkusB0gLg9//SZBvM9ZdRgqZX4gM0E4pf/nf9P///////////////////6/vmW6OYiqlWrpWhJDIZIVr1Kjq+4aZn2AJEFQ6qPDxrXA1s2UYEQseT/6A9JdQfPSKR8l/q3Axx3/X/p///////////////////6dN3RmTOjaEq+ituItO5s21z0Y7mFLIRiArf6SvDBY+5wDeQfiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAAiQgN4AnOlBKz2bwHOJuSaoy3gEUTcEvRhvAcQm5OJRH/9XRlCTn6UlkLKHW+PFuNipf/lv//////////7dKGBoxIAitgcEoTFAEgPAqHRMpJKoTj1jCTjh00ZEQVEYXHNFERxOFiX/5Q607Qe/PUvaZ+3Dirf87/////////////////////0/7dWmKxSFMzKzHWhXRnRDI7OipUKVK2kMsljsN2/v1s26a24OQ4kMEH//4+H9Da9xjIW/xMdwVR//f//////////////////////991l/M6nUhXcysQ6sRHotzIdiMVDENUxaqsxGZHYt6kM89jg2BKUsOiMFjbf+CF3l0E7civ3+vQDB/+3//////////////////////v6P9bXOiGVopUVpiuvdkSxDIztV3KqmQrlcyjuY6nnq5FgyNXZmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAl2Nt4ClE3JHj+bwBEJuSNX23gCITckPvdvAEQm5lQLR//5qRLjt+RGQfL8I+Pj/+T////////////////////9/r9UWrGLLo5WNVCqJoSzs6FU2Z3Q7ohZLCZ1aZiNOZSWpFNY5issOzY0FP/4I1L6n/VXvL9eoZf///////////////////////+lqULMqLu6noiHc6lMqHKY6qzo7ujERCMqw7lPbNFp3Ybnf9rMY42Ji//2gOp/1TN/V+RH///////////////////////7/OlVZqMV6owy1dFUrqUhLkMZXa0jHdELB7uHKYVqvU3EQzDa2yvCCFh//oe30/Nfm/8Sv/v//////////////////////Zf91sTlM9ikDnY6Kcj5dnVnNVgxwDougleuUm180scJghjIfKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAInkDeAIhNwQ1Bm8AgibkfuFN4AiE3I1gBbwACAAMhV//3iub9NW/p6p//////////////////////9fpf5Vbq7lmpV0nKdZHneqsqXeiKqzyUKjXZ7miiKquZrKSYpZHI46VQPf/8t/WuH4f/H//////////////////////+3/V63Rn7yrIMRXKmisjmRySLIzymdztZEpZUcEZo3I8LaYVcKUtL3f//xPb/2/p5v//////////////////////p+tEu02lrZltb2IisjkQzOznLfldme5WoydToool/ntI8YGmV5p3/8t/s///////////6OIdJQRrHCrXkhg1oqxinguBUGlAcTg2HiInJGQ+WEQHMLAcJgyY8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAB+oU3gAETcjctxvAAIm5HCh7eAABNyOhHm8AACbn/f////////////////////////////TTshnSVWojEiTtd2VVYZzEe60Q5k3ZCO5lY5qqZEVY1PEIeNY+xQaL//////X///////////////////////b+7euRVWfHTRQDndQSfbUPGvPLPhiyMw3Q22FvUdqH6v//////////////////+n/6/7HulbIZCFMJNc6WJSRns1CqtiuiEYrMd3RyMZXPQe4IkVGZKwRS////////////////////9/9W92OmlKhHojOUhCHYxjGUg+dusrFkY5aKOdTuirVn1WxSoGQ0qPMg4CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAaSNN4AAE3I0sSbwAAJuRmo43gAATcjWw1vAAAm5/////////////////////+321XageYuVMyIpyPRNZUKvdmIrM5m3qtCnh5U2OVzJcUieEV//////////////////////X0ZrJZqgi2+dJzkRneZJ2IRSI22dZUU4NkuY1DUnHWH921OM//////////////////////6M5XT2177Lu+pFMdWl20IqNBodCFZ+iSVYyK2SZlU5zQdeX/////////////////////p/0uhmElqcS6FpVboxiO6wRWNVmnVbs2isYhWoQkIljt8o4aNxAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAGYdTeAABNyNhCG8AACbkcCIN4AAE3I30MbwAAJuf/////////////////////3S5nRFZJ0t1RSKc1JSscfTV6vvpUY25a3JiLfAu87PaXHIP/////////////////////1ytaZVurszyHIyFK6veeCZy6SLn2U7qRjO6oiDPNrtLtSDRu/C/////////////////////6brs/K7vfehUI9jvM92ObVymMxzsachGvZFd1M09kKVFBLODcBsRP9/////////////////////9O/RKopi2Ykp1gkIRXQxmJZmOyyqzurWd0WikKGRr46vJxDmE8nqlwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABLQA3gAAAACxgBvAAAAAAAADeAAAAAAAAG8AAAAD////////////////ytzRKKuWPrBVh7doBrj1g0/yxoqS86VGA1/////////////////J1AZ5YGh4iW4Y8NBqJHnpI0FQae6TU8KliqST8FjQkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAAAAN4AAAAAAAAbwAAAAAAAA3gAAAAAAABvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==";

var ExerciseFinished8 = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwMzNFIDAwMDAwMzE0IDAwMDA0ODBCIDAwMDAyMjkxIDAwMDAwMDRFIDAwMDAwMDRFIDAwMDA2QUUwIDAwMDA3NERFIDAwMDAwMDM0IDAwMDAwMDM0AENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDA3RUMgMDAwMDAwMDAwMDAyRDM4NCAwMDAwMDAwMCAwMDAyNzhBOCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAACwALeAAAAAGOAW8AAAAAkGOt4GhE3JG8IbwPCJuf//////////////////2/p//+D4Ph//////////////////k/yH//4IAgCAJp/RfpkgM4ygkZMRS//8f7//////////////////////////2011VK1UiXkdGRzXczMGbc6OdVymdWq7NZ1ZqUB3d9iJuRUImDOXv9f3YEyjhxtlbf//7/f/////////////////////////bp1d32d1qrI6JW7TmV1RkvZLHyIRmyIpNtLnPBGbtZkxK+MRdvoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEYoo3g3JrcoyxBvBuTW5cjRk1tYyAA5GjJraxkACYqwQ3dOwgDzKTM1mFMxcj77M10DQ0ldJmpPV6aSCZuQAsjnnCyNwTyBwAxpWMUm6DW+pvvTdBfr0S+VEojqZfRL5wJuDbJiKvWb///////6kP6m+3//+pv1mbs9lrReg671U1JLW916dkLvTUy7Ju606lostSB5Nnn0kVMivQWnRSQUg7LOIFQurONuUU8AM/VkHA0ykzNZhTMXI++zNdAUBkbqZ060m60kFm5DCyOeZFkbgnkDgBjSeNUm6DW+pvp03QW+rsXyYSiL1IL6JfOBNwbZMRS9Zv/t/////9SH9Bv////70Fpv/XVSqPM6FS1spSk6k01pppMtbrSSSTe9PQWkk1aVNlOjQU7zNFTqZMxewpAiZ3gizf//////1D/pKSkpIcVUVgOUAURMCBIDYeu9QNFcswig+St5Z8wQSzaP8Dvuw9L8uGAQTDBLRrXeAs+AgyyZZMsmWjR/h5HgxRTHHMUMs2g+weXMAQkGCCAgy46m8ndhnDuP5FkbDCIMgJRgEkmmqaII4Ab8pyvmuaBi1L6OINYWIiuiumOsdr8P5QwzhMdQdd7X3/l9+UOQu9d7E3Lh+n1KIw5bluW5b/y/tSMOW5cvp6enz1UjcbjdPT0+eqSNxuX09s+IAfB8H3lwfB8P6wff//ggGKwcBBwPh/B8////8H+kWb//////+of9JSUlJDiqisBygCiJgQJAbD13qBorlmEUHyVvLPmCCWbR/gd92HpflwwCCYYJaNa7wFnwEGWTLJlky0aP8PI8GKKY45ihlm0H2Dy5gCEgwQQEGXHU3k7sM4dx/IsjYYRBkBKMAkk01TRBHADflOV81zQMWpfRxBrCxEV0V0x1jtfh/KGGcJjqDrva+/8vvyhyF3rvYm5cP0+pRGHLcty3Lf+X9qRhy3Ll9PT0+eqkbjcbp6enz1SRuNy+ntnxAD4Pg+8uD4Ph/WD7//8EAxWDgIOB8P4Pn////g/0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAADICQSYZWoABVkgdwxRQAJPJBWbiqAAKDyCnDBNAAEnAQGhYQKhoSgAkXgZABQGEgmBnMOgKAgDTI6AwMBAMBAsQUFWOQQUgIGBB+CwsAkOQ1cBQDCjgQFgCwPACFIBooD+hjUGgaC4gXAgYnEQAgHDRgMGigMYkMEfBc0HmKBgfE+gYHCgDAuGeAw+HhSROpk8LjHLLqJAh3g1BIGPS0Bil/gY4bQGIxUBh8CBasGoEAENIHQBsBiECgoCAyISgQl4DaB1C5sN/AkChpAVAwIgMHzB+wXBDDIsPBNOWyiYlYnT55i8LiD0g94G3wwEIOIkVgxUXy0dAgBQtJTJopERPmJgOkeS7SKxmMsIDCyQtGBuADBgAEjEBjcfZFTQyJcWSBEKBQOETZZdUpFg1IIQAHADSNT5YFzDVKhHDmmJACNGVPFEZUXCmHKmazVSCJYJ3SO0RuH1rUprKbRj6D1RjAMFBcG5QXxElE3Cujmiei+VCJHUCBFAZo3MhZxPC8D5iXHwW40ycFMDVR81PrYtIMYIsZLWiZnkj5Ei4t5XNhylnTh9NlX7rtWistX2IwqlwBYWnVGIFVTEeHiirj8Y5RZGUccRJhNsROjX9M1W9v7T1t9X7bbNVf/27Xbon/+v/06f////++v2X/6M+v32a7+jX9F1nbqyP2q3JdfXWjoTdEAAKBgCBgKAAMBwIBwJCeLjRBCEUQqgrMafOORYuCMzMG6KmhjMAoWQYDHOACTAbF0SIF84aE6w5QkbuzOQAMaCDAMQAEGCbiJAErwM6hBtjnCvmYZYEoGA5guQLgSaFpC6IhYcq93ZMdgncmhwBaOIJmw3RaAbPCxIBYIAUEfZNI0fgYMCFp5MAKAyLEQHGUCoGRQEmgDo4GPABc0M2LOFiFd9dvKAuQqCyCcY0M3IOT4noVuGRTMZkiJMmgyzEC7//cvkDImOeRc3ZNMihpHMNB1D4DLoXBJMQIukVYukNGZKJBf////kUIoaE4i5FyLnxc4uciYbeV5FyDm5fL5uyabJyAmR0cJgNgmnIwQsgQEBQUDdw0h1ENIoM0dJ0hxRJ0+SpcN/r8X5+mTEwiOPALgYgQoBVFj5vx5LofmaZLuPc8MwbwE0/pp03C4IiCBzB7k7/QZMuGklATsRslATsAlxg/+XDSabYGWANMLwABWHGPBIYQYD/9N039CblwwEvEzKYjYmZuPQ9//7KZv95mF4EsGwFcC8EAZZUaBzyXNw549//////9BBjT//Hmgg7oJkodMzow5JkUvm5cM00EFmikFGBoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAf4jFQnP2ACvY8q9ODMAGDyQUiMby3DNr0p0D1JuQQAAAB7bx6jcSznFrentrPy1HYrLWxLDINDwud0El6ZbY1O37+O862Vuxlbo6amlXLlV9UUVogBUMVBFdOfSSzO5KKKU35qfqw7VnJmpvdW5hlblNNlUXG3RYkzBbj25h94zKrcvqupKobfmLqarHcV2Gxp7QFegWzGpZTY4012IxmarZ17Pd6137OG9fayq1a1Wpr8K2XcPx1q1TZU1qtaVDS0tmXRnC5vl7Om3ex3Xxs/jf5rmW7FLytalOWHMsrWN67VpcNd+vZqVcF9vLQc/C/jj+su/rv6tZ3JS+rOXFlVruePPta1l+OOWX4/lrusM697m93v7repIFE1pk4Y6gBTYUJxOaEJ9VSkiLgQGA+JXL1FSn1stkjaitFkjY2TOkOBtgHHLOrdNjpeLyKJwvKcxLx9SReLzrUiiXSwXj6aJkXS6ioyUkZGRETyY+SCkCD4hbhjRliiYnCLF5NFFaJkXi8iijqLyVfXRqSSSSRRRmT2UiuuiitGjzJZBUU0VJOsxZVJIvJJtdFSSXSMkUkloskkkkqijSSTSSrRb9FFlJJLoomJqTRJRxX//groT6RX4vmyebeE2SAAAIAH6zmJZGB1zTCBEDXvyyu/rm86b5mSSdEEw1jPrdyImdlypZbiMs7ljYyz+pTUNPSSOKPHfi7PlYx6OKDBkUxIr1x9ZyUWu01NPa7M25ZFfzzopD2RWsmeIE4AAJkPODD07ej9x4nxg7N96WEtASNZMlhMwUzMDmuJH4/LpufnZyOVMKXU7lS9/Wefbmrne15TWy7bq15Tas/vLHLDPnd6yv0GEtJgd8maSBs6t+lp5Vvt7CvRb5T4ZZW+9xxtWfsV5/lrfe95rCvMWL9b7lS5knLC8M7m+6xsXP7+ub/LOtOWqft7mHOav493+WWO8OZfvLLDLu+6t8td3rPGI4Ve7oc92G0AmwBDgU5/zWzf9/91ZVUkDwqgPmsGgTezOeW+91++bubs/VxqWJZ9Z0H/Miekam8PZawt7v7v0qJqotmKBkgmpykfNWKKZGGZ1IzLpSNSWIual0ukYVh1EcZjnihBcQc4qjJEyCMiDGhxMrFA+XiqaIG60E1MapLorrZnOIpIpKNJ82ZBNJa1LSutF3Oupai8VkqaKlLUYqrrdmmjOpNSS0aKSLT6KfRNqKSrKLyCaDposg92qqZSKJix41SRbfajKrf/D7dj3LIexxUoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIcpBRozvDdNFyCmQLT24iXjFEDXMNyzc9qVAsvbkAAAgAfjlpeS/GVFYBVpfJyIxYrw7I71/GTRepSRlrCh5kR4cTOKOpxS+81iMOZnvt6k/685jepaXJ+H0eYdAW9C0SUBcLb2Ky/tPLtSiAZqvdxpJ6tq7WqVs6T7GEOM7Rj2jK8kO2pRTyaMSSfaXF4al1pTV0IIZGi3ASVB5DnGasIs6oo1Ow1K5ndLRUlycs9yr539b3KJVa5dvW8MLeEsp628t4752n+YrSp6Fu63HoerySVx+jprNNdp6fWdi1c5Uv9q4388rG8cMcecv38vq3uX+fO1K+W5UjpD1zXeczwxy1vuvs4bxxuVKuePcM9fnvDe8MMd73v8t47w7nlnvljDe93oM5jaw1upVKACBAFgpIvoyf+933G9t9JBIyQYehIzG9Dkov973/7+8s9cl81lZmb/xlnQFdobxKVymml1/KrT53olWG8GE+3DpChXpEiqJEI9sntGjz7jL0XprENPn+r0KkQJHMZGQLD9nbHNsw2xHbyS0HeMwfemtY3m28xae1oWfmbMCt649Pv1v5maLrN3OLGYcRKb1S82b318ZmvaNqurWzqPCtTOK537xN11XHky/iXzrG6e3zb//4tBrDhapj/7/+c0/x8Y9f8Z9K5/xre/WP6b38bjfv90AsCKhFXgMgOWvpY9a9T0owB2TzlyPv6NBRYRrhfAxGLjqQ9DigpfFYw+xa+SxvK5GpuzjbkztyiDoq91FEaAcAKIJjBBBhGU9Jp3GP1G8jXwxL6fOLSixUnbOWNenv3KSlmYo80/2noZmAJh63ech7qCPs8hqNZtdS/VvWDd5pYyJ4pY4+4Yl/8nux2PSKix3Wp52xOY4btZSuN5yib3TZ4z2+0U1aqY95T543c8Z2dehitu5hDrwWLH02cvmJ2mt1t6nbX1q1reGF2du1b+VWpbxyy1T1cs6/bVXlLWsVHPnbv/2xYzwzu5bxtbpOb3ynlVbOU8y3v+b73+a3Us97lh+f67vXOUPOfzCOxGBEQoABgAUE4L0FlVPuf3871PI5tVYQmmznHmk4VLWH75+PMbeN/l7PCWT/Lb7JcGR8pk5EYgamoJ6G70zK6VqbGyPBiO3+9tWW+32wMSCZr1mfK9c1Ub6Zm01qzZiGWXw6C0wxDd27etivpAhRokWDSbWaxfePre828Wf4g2f2gapDg03rPtnELerxoDjT1TbXDe0vrUOFXWfW9M/PpjN76rTETGrax86/pu1s2+bvK2vi2c6+ta386zutvd7jUa1qtm/tr/IdQC4d2g3NoqJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB++C0qMaw3arrApkCy9uIcYxRAzvLcM7xikQLb25IAAAAHMdfVKiSqV2zStD5cCd3KvLURQkT9m9kpUWjcpfA7FNzVGDq+HzltO+qVKk7u7EBP/Zv0kro5XJIPi9FlbbkatYCktFAlbdR/sYlIY7HuwzGXzp5+rel3ZTeiWbWKXFn8tpZBHo7Fq0qh6Xy2LP9JWdw7KlPiKIQZIFyVAnQTVcF1bVuW59uTUlf+YilfO1updr7tVamWquVa5vPedXHDLHfNbz53DeOW9+9EgwtWYlV1ljj3DOvR/3fMt//59x7y3veXctb/We61rLtfL+dr0kUtt17lhl38f7j/583j/dY5b3urrf813+Y4ZbvXLeNxFxWKNc96A6yfRIACAAopZm8Ez/7b/eP4zcZXeCDjl0f9/IXrC3d7vve97yv3DVfd6mnYIdYHVhxEPxaUzGN7f7t15dMW64gbgVx9U1WYoEtuO2s1fd5aDu7BR9GTyUczbUaogmsrrT7pDee0ufXGP/bVK/Gbb3XWPvOpLatj/H+t/Gt+7VNvM1X17RsapbETFN53jP9syYKEDA1RQCuGAGKF0BvAscbQvFFb2Xsuv01mRcEC6vzy5sUFTDFiybgYQOENHuBct40IJDZqzLoehkwsKhoZCSyJ6a4KgodoSyH5XWHQEeGqGxMe7FFZhUZxltaUwxb2nqQihJLiIJo24NlsQZI6Qw0BaC9Ert0UXZNLJBPXpS5tNcjVEAm2gPUmjTUVH9PLY5Dy8ohYk0ehu9L1H0ekQxK1iLFJliBQXC5bq/KpXRYStdqEk/T2czOrWOVnVjtbG5+cpjxde9y1jWq97a7ykyquXA383l3l5pTm83SXr3O5Z2buPK/MdWu5Y8zz7rK1RVL/5a7vve4U3O6ysbx7zKl9yL/Mf5/9/m/5fzxz5zL8MeZ9uc/v8/ef85Uy/Hm9/zLW/x/d7Dn6mPwoDQIAAAAoZGON4G3/2OfTym04tdJQKlASSBwg8TXJy79Dax/W91r1mtcrY1ZXKYC+BDIjkaAG9bDLsc925rtWWODTChta2s53iSHFr3CpRLdfHexH6+xscR69b1WhLaq2tOmgyqx8ERBex4mnkO8e7BVxzXFsVzv59rVxWJiNnUto+q+31TGc1x/uIhzRvxnzniSLW3z4VpfqlfnP1a9709ta35sYhf/PjemM6zmJre/v61/8Wx/74rmuLfVdfW85xr/3+8f/PzXWP8a+9+B+jQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhcjFEjW6N0zTGaNBdNbiDuP0KNam3TU0YokG09uCAAAAB3D/pgsIBohXRkUiQwvLVzjlnhBYMAIZ1Ws1xJFmUBJgIUeMeGSDACbWuQPadJJFZ13dmxD1mVzcSm22iM9NPM1xnpcg0gIHhtm8Gx6s/kFNwEARDc3BI5ZDBslc8ThOjsLRETIyRJQHGDMkiOLg5pcWTBARzy+MqYEYXiJFUuFMPRC7CgJ5FSEBSKDbD1iWYnj5TMUyus0BMWAOOIGo3YvucWkmWDU1QPmQ/C8N0FueMGWxmkqiXBRDR1HzJM1D/mObD0Vk02MD60DIxP3UkkipFJNMuoOfUs0RQPumZU2N5tXUzpyIObrXUmtlsplKZNS1TdLSTT6rrU7q2ZbW6kVne7pmZSgWoAAQAFVSF8sOpb/n9Z0PdRiXINFtzTyRoE3HUtn8ZvX/u1nVsSyZwqRyn7eglxpkw8BdEMU0ZlT/0tLIseTRgPqKisdTc4VpLN1G45iSYIgtM0kzNRoXRylAzJc0LxTE/C7j1NTNAOcIYTQKUhkiseqR8otMzAomiaCaCV0KKjlkUCC6aZibn3Z7JvTddOkgiO+x0ulEnJPdFKYpmB5azFrpHVJ3ZaKSalo1La6B5FNTI1qUXzikrVb0da1LZT2X1W3tR1e7vq3ZvSOSdTAAAAA/H8sASUJSzFQZDJVoJOFAqm3r6wYZj9+mUrMKJFkLdC/4NbmD1mZaiyFrMRlDiApFA1XGLPwyqdsWom/M9KJFLoce8kGJjmvJIQRl21dsMaQ6Cq5ogclwjBME0T5gSJfHIMy4XifJwcJGhujIxLayiQUqkWGVHaXSdOE7J0qjmD4FAh9TAg4YxDiA4EVAUGOMvnCRQPk0S5GIBAkD1IUqS5qkTyjy0TM8kZopnh+DgnSRNy5Lqi6ptAdg+1IJqUjHaSSCZGmhWTWeas3umiZzqbuylXSK6Lu6Dsi7ImSKkXVPKWzoDNvosv7LZ2WtWkupv9BS0HW1V2VXe60+pEtrQepjaIAAgAMed+hte7Hb2+7l+F7NuEKeOWGOEHhoF7JPAUvpdwN+OOrl3Hf26aMRScvT0PNkIQgyxWLCIhSuDAnXwYZIewiqSUjx8oneLUiP6MSoYGpDmqkKdjYrQvAgw8tjG2zZYFKllpHqY4limW6eWJNt6fBSRdUjzY/pvNvXWojJ6Yzq9rQfjNt7xrP3nw2Vp+YESFApEj0kxLFpm276zJv3znGr+2K0pqupN63b1zeu7VuzS/eM/O//941vGNY9MZz8////Pxn4//////1/86zLewNjQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAG94xRo1qjcODxigQfb25dNjVADO6Nw61GZ4BtvblgAAAAa7/ZIXBZkqAwhhOEnOUVrGs6CPsCyWeeBOmNYP0zMiGHtSApM6OTS02lLoevYWZ7KIXMJ2ny3AF6RSenZGwwwkNez/Xoo5uUHpuhCN77fTqJ8uE6RZArIFEmSqXlBe9Bx8jJlMuLOKNyKGReJ42SKJTHSICBsI6hxjhGcANAgYkWG8kCOk6ieLBuXiLEeGMAHIRJBzlGJlOTZboKNHdIhp9ZipbJakk0ZmLc7LUqpIk1rRQRZJNbMp3a90q9taS0mqRevujWvoLzMk9X7Vt+pKzV/X1//1f869UywAAAAEPNnhpNhO/3cv/ciM/DNKz1nhZIb2DLA3TD3KqQFb33tFnXlMrh65Vj0PUMxLprMcCjMj5CmUOnDL0Q/WxLozEb3WHCZYSdVEmOrE8wPFbFclaQxnV97usOTxUp93ZPHMcx3l/QSAH4Akg8kOBVPGBy1HrNNltSBv2lkvG9e6cqyyQ9ZhKmJTF/NPe1PnH8XXpm2IZRI/1c5V7cWLaDfOJr5y+9/Ate33i9rV+bV1i+7V+92rXP19ITPj/GtfHz75zb59L1gUxa+Mbzi3r6f/X///1/r1+/jOm7kGxT95ZIcB4IRlqtB75iuGI66VWYaw91TctnENnKhTYU5hwGAg8cUgJVN6kWzl8oAcnOtLVYLygUIlubuOxGoDfL68sS9V+YhNCQk/riw1GWs1powYcjVSUGjnZZLhCnSKrUozFeBRIZDlimh8RJsQQzKIzxZKJuZFAe00iNE2AwiMcM0QYphCTA2poOiKufSWgiYF4LXgFTQ9ERTW5mbTFBXmigyMeWktV1mSKFSiLilEdSS1kaOYyikt3UpSKlu9anWgY60FqWz2WpSGtGt66NJS8uEGb7s3uu7Mprp362131//o0k16E4pcJeCtA1s7kyW79pc8u3oRVdlrAiAUEZibCfDgppLmfRfucVrcz+vRQiZmocppXYchrUXfRSaHRsoKszEAFiUgoHsdCmcEmL40+kE5c6O4SXIKwbjKRyfw1Oq0+jiW3js7Rez15Eb2dWH2TxNIIYIw0qHSLkJKJ2FPCZI7ZdgZYbyKpzzVLyV/GrWJGb81lznDwyGum/aHEz30OtM2j08LHhML4nW6tsipxptf319zUjbrP7Ztiv1XOsz33jep5Me1N7pG1mutYfu7/GMb/xrG9Yp8b3nNqxNV9vT6z659f8f//Hzn/03/mPJLciuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAABpBt0iM5k3D7sanQD3JuYVW7QgzrbcL8qugQXmV6YAAAAH9/BeVckDhswg1oDecK5W5l9megTDKIw5DLWDFFNol7IcllLR2Z7Xa0O7jNFzDLl+S1ZVYlqbikwbEVjOXWnKaSypVcEA3rtYuk1MzpSSNDcwNXMSbGGVllEaJcMVmRksiRUIemVUS+RcnyIiFiIE6MmREG9wVksDIGZUYuEeXiuaFAPxESNDQnzAyRSRNzAppE4TBOkHMiABlghDMvmJu1jdV1qIKmfGMEoFQvs5XQpIJmyKbMgZumcNjUc82Z2spWzbN//+5gGv///8no4DxhSPAl0o2vy5Xv0sqXarwKgJjzgfe/F1ygQclmEzTTt7G/fno08Ndy5t4qVrFO2a1AKVaQRiWesQSCH2WPHU5rK+jAAR0Z6FD6E4rKQyA7yuTZVIcNY2JQiI6C0ZjliFi0WiTMxrkRNCCj6FiJc4aCok2G/COibGeGuFroN9AYAMgDVJAXEVjI2NkCkQ8XKAfA4TBSzyRmVzQ+yzMzNTU2FkkXdIwQM0EDxqpBbon0UFGZigakPD1UTpAVGx5Z4+fRsxosxQRTdbLPnUTyJuYmK3SWm8yda1JtSNi4y0C8PCtldtrWUppqiijv7+tq2Va62o9VbaZs+qU34bmGAzierBhWov+ZKkTub/eU1OvDnPQ82sOImij0Bo0zkmH8lNFP0VJhTMXvtghyUT9PZpXyhmHZSzZiRIBM+bKDsxWjr9zLvCACZkUxyPYXpVB2VyaMBBHkvQ/LGVy6BC3jN34k8UcNgDRWHKMqsLZp2KYs2L9rzgVd8DQIhi03F5H/EAKHHaxCqA1Yo+7VGcusjGYYBGDjpgD0etKGgBYkjmGAii7KWFNNb5tGvsgbqyptooy9YhIHi0U6b/SaWQ3KJmmx1+sJK4UTZ4lYBQ1XT2wdD9134hHY9Kbc/SS/ONt+6s/hZgdam9Y95vnbGdaMYdy3h/////61///87jAV718p+7//XWVBAAJAFw0aLIzo1O75jvWHc5bKnaZeX2FB8cCCCDsPvvNRSU2fraqYwTbl85yM9gadiVPFomzQxULhM8vjTtcjsNx7FJ35LZl8znTRey/lS38xRz8xA85njnDF+/yr8B37boyrlJQP5E4AcqkcCWvk2N5JRdyu9wyvWIiy9jiuJufpL+t75bzpN48xtySBPx/DX4fr+/+PM9cjHP7KbGHK1fKsGTATOOMj5cLlRcJz98VSeFFA6Cqb/vWR//4GpSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACPCMT6N6q3StC0oUDy9uI3G5OozvjcLFqqgQPWF4IAAAAGfeQVCqYUDEowKelQXDwBoNrmW9ZXFZpRDrZJTUSFMEnhafqUMjj9iNSOtyDVrRuXNpPbmrLtwRKJE3o0YYCGCzoMVysujc28D7wQzYDrYEdeBCYKY2CLCtwagEDAZJAOB4twyJEB3kNKYe8o1J9Ahoh4lAomQyg5BoGXBgB+QfqBAChcoZMZYCQHUVSJiDgaAQDAgYDvhlogSQ4xkBzhaRcoIQEBIJgYAUgHrFGBhAEA3VEGijFkfjMpkMTI8rERIoSAfuHRA2JAy4RgUAIuMyLzHE3UtlKJkUQnSuAaNAYUSKFouC1lEEgGK1LxoZMbqOksI2D+mBJyKCTCE6S1b6nMhW9JO/723359v/OKfq9f///7/V8zcJ67EAIABCCA4/8LXv//6ksippU4qHIwSzX/LjOazDvJn/7hh9ztDYt5VKfGYjd9ujSz1ib6npZ+AMs2slvsZdaisjmrHj4lzjbwo+2RG3f3Y27K/R5pcNyFp+JOyRGZHNSTbVpGE0KZZY3tokBqboLmhJPRNy4zw3WI1t3vr2zqaGrUPi6x8V1mu86xWL8K4tK42u6wsxMe2/m+7Zm5VjHVFaiXboUo99fof//8lrIAAAAH5brU9Yq0LqOiYuqd2LoTeH6/uEvU0Ze5T4NUZkYcDnTjAoDGAgzQIGcCG3Egiw3VHCAHsag7MbfqHeP+5MWaGYSDiIOIQs3MuMOBi/8glDBJlrAjBzUxte1SRw5I4MSN5CzJR6GgdLZTLoDykCKbez7C5dAgIBb8VqOWIy4RteQFA7ARgOSmZXUGBSJNRZkz4RgwOTo4Aw4FXpJnZl0E0yYQwGzFMON8oUwCCC3LbWp6W1puzELkUtUkqwVVHRIYqNqmELhNPdpLXJXDb/zSgbfPTK5kUEQkno7nU02NmCA6P5Y3KexQMRUsfyJS++xhWtZGOuf3n/rdxlHf1z/3/f/e/5ze/7z6C3o8nQHNFiS30+7P4jdqMAAZAGoAHSOvS+/v+6wmqstiMnh8YEhwQ4aZH+An5nMZjP8/ocs5dTSCxQbsv9Lf9y3wMRNA82LO1Px1+qRZI1WOUsIn5iZqZzZVa/+H2uXMY1TS6vYpZqxfmbcJqY1bVJrOOTsreGralL/KQdirhjX5Mak869YJWDzx7CVfvLmsbW90tfWN+HIzrXOZ4f+tf/6w/sORnLfaDs3hnX0omoR2Hdjp1Z7pljdJ5//V//+CwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjRbk4DeutwsK26BA9TbiHdhzyM623DBq3nkF1puP1a7XiBaoWGDPxIDC4afq+itqrnjzryosRiZaFGwcFMMcNqFSODAavWsR+BHDbJSwALBXgbg5tR3I1ch2KTUHKHg0oWmXGcwSRfS4K/4+yqA3jCgYwrJu7W3hiDc3QUOgmLmMIFiQEQ1EnbiNDNAoHHXn3hf95C309FKWjWCfSvIDBEDklTA0ISIAILJAGCwEt2tx0vQqMtWMAGJAZarU0dmI7MopkwCGDoDHAILBwfjQEIRO9cm6l6W3d1MvpLbuKuM6QWHgLeSXyulxuffrw66rRwgVkaqOoFwYFiGzt009YFQQdG/hjS6xiTzI0y5sUjvqzL2TRvb3jhvuX/YdvWs8d6/Wtf3f//9/v/lnTPyVGzN/r8/9yaRjJAFAAzEqd3wZYJ5/f3jH5HIX1dVtwqCI1o8lS8a629Jlhq13t+zqlocZvCLbi9mTKGpPmWZAYlFnLwoYetMbBye1ZwKJOFGkVQCJFssonEzZEZc4WCONTMdKimQNhxl0zJsli0Q0niskQQfBuQgyQ0hjyVQMTyKzqJRIcRwCDgJsZE25subJna3maSaZASuX0FVI/0nqGeIR3qc1TWYpb2PKR0VP/////6JiY////+RYAAAAFLPV+YVxUsWJNjUKWm6s4M1XpK9bCVPU/dSAWUI9ywoPBOgiEssdR4YdzkkBbbo+9aXwiSUkapX3l7DICpDJBUjSqEDwZMoUyVrlDXME5BgEZRCkPJ2AOi+a7GQuOqmZATvGyuCGaP3BiqKTyQDD3SfCNL0ideCn4ZjL4q3IvDBRkhM6cBRAST4tH5O3WJCQ9D5mAQkCWvTcS4X22JPYwwOMOJjGkUxWsMsAjBgwwIEUsa5KHYkEvmJK/9Jp2HTd4qiZoBg4NBYv4Z0l6VtwbV30dzBgoxoYBQ42FCcLGTty6Ryh/Uq18RS7hVqVJlWJ14JZezeUMKly1srGeuZ8/DXXcOf+Sb93///0sgAAAByOJqszBYIV/+c+xMwRL1qxdTEClQ2eVQKab1ae/HmN+vJ8IKt6l9aJyy1VdmgbMokh6AZQ81UpYa478wDIYSIhVjOzYit5/mu0gsPatPY00vmMVhNy2CIzTy6tEoJzdnOBZmXyt+IbbBYmXLhqVv82gYGY68Mrq09JlWqdbdxDhASYK9zxW5XrVivhrOgu37tuEp8Wu8/DLXf7hrmdvvYIeSx/2M4M1+WFb+9yz1zL7u6niyyi/+tHv0f//6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAII2JPI1rbcLCrefQbOG4jXdM4jXNtwwGuJ1A95bggAAAAZb/HVUgK0widCg0ByF+z1nu/18zKKSTPaxxVIG4ze5S7Dc06bjuWI7Blusozdjr2UEU64SPCAxkkhi4Y6JQzWDfTxYHRt3mXea5QBcIYlIms02HJl67TdHYhoqFQkBv3AjuWZ9hwQrsVdKGH7h9BMwyMWpU06H4EhgmF48AlNFKwtsvo37ClNJDQGAASexpaUTAkvUIp2/eB8W4A0aMPbD9H0yANLvmAgY0DrFfuHYApKOefiQx59NOWSARnxGzR968zL6ks5T23mhmgMSCjkCFKGLQsoNp/dteMJgRntatMWrGUfchqWRAAvPg2Ku2az3LX/z/7TOvj/6+c0f///VGgAgALwDsvdblzj9v1+sqzlwNZrsIBCxyzBC7kWbWc9/012kxy7OQfar0lNSSzasbciUILahCqgC7H2sOfBTugIWvWp6k5SZW5WXlu2fpqeimWxy+imMsKuqfecqvS6GYhQt3u5S5r1PpodDOMkh1iEa5bx5nE2ftGGAG9rJYtL8L+P7zvZ4Z1cu9fx/Z7mGXf7//++vC7VL7PHV5/1OyvPfMdfz7VrVTu96u7+z/2GmAAAQBjjzOkoS7osfNG7KjA5Cl3JvX5/zVuaedRRTl9EJYKApylTEROYc8sKsw4+zPoU2NNbGH3lhyGY5HAaBB4KspfaWg4yCIMCwxMWNRgDzIOQ69kTgRS4DI1zYCeDjRYDdyGlUTA0lgMVYDDUHwS1s0YpW/AquGTPMSALmu9TRZNNrMqkYcKMZMwUwgdxZKUMCgD3MejSHEdCRABG6SqGqTxioqt1kT2uwnEuMlhjIBtro4dhcbGjKC85bNTWM67sexsOVUGQwNB0uqWlxuzuVNVpl7cfwxU6NzP0NodT1KG/tn1oU8iXxSay3lnKEiY11pKnOTRIhD/Of//++Y6cT//9//////////f/8d/+/t///v73+3//9TAACAAQGLlbQs+GD/P94R2VbaUlWOgitYasiQKyfKTS7lfOf97b8AVr8Yl7rOnDEVeONoFM/CgIYUto1F3WryKkmYUp2h2kdLM40kopaV4EyovAdXCtjxxp6TZu5TNEwr0m20hyHZl27j8tAlT+tchqWPazCCXfboBQIYmLly3SyuKoiAE8X+LpQIsiW5XbWscss7OO5vsyNHRfme89a/8M9e2MWQk2DCrPOXd8pbu+Wfxyxw1qtRfdztbT7/9NQVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACI1hzaN723C/q4nUD1puouWHNA1rbcMELecQPOW4QAABAHc9xCKUAWEiIeMyDCoMHEiarozPRilppuWI7pdsoa+XIHAkKgogTjyAcBCqOy9VbnhiLutib5mIkES1bMCx67AkCOiJBsWdVrRkYuEBwKRDRwUDPM+s+YEYGv9lJIMmVhMrdGTs5qUbAb8kATqPGbiz77RqMJtmVozhPyqs5zlZZTkO0KEyXQC6QCB4IEcgHA8HkAUYuCy7GtIXjMjAkARxb4TBTsGZNCIjdaSehcQMDfjCApKcgRzIw4iOoLWnS37UzKuVcLNqCguKmLlTxyivly3zKvFHUxsgIXOpNEa4EcsmgqbUlV/GYmsHy/lfy+aV2ty5EFxdY1DjgWf/////+OOtzNfVERxY7U5fQQAASACrhiEG3mddudx3hm0uvDhUASgRyzWoUOzgMTf+rjljfmI3fpocq15JEW7wVao4kiK0xshVZBh9K+RT1Awpxm7l3ZyVzfYDxjc/Cy9snvUlWe1Hl+Utxo7yYP3el+7731J7aos2JfAcairsSGHbUEtKh0lDyWGmYQiG+W3qbkQNTiklkx6HrNz95YY41fzt1bStoOEQjGz/8/+ZZ40LMhQDRTLdoTWw5nuOU1W939/9m9ubvfjas69zKP+H/zmX4bm3AZUAYAbNUAQ532C/5JK3JtRKfnmfoxpf1XXBxICDDSyzSozShwQTR3aEziUr/deHm6CwlwGsvHjAsCRgAlQ4ZiokOgxlQVY4CumKtiQhDdHuQqoN1ZYglMWgf1nEla7g/7dn6awZK9JfO/B0SYjGlDjHT1esDEgAzugHQVdSz3pQCBQVFgNNQVAUroBM5cy00JXuZGBLFkCmcIkQOQBUBM0Y4NUWNXAh5gbagjcALHKrcACNjA8OGurDMoYaXL87GFBDU3lZqzyJo9mqEUdJd/v7zjLTX6hoxYvOQMkRYCBgEJQUM2YLL+07IFhM7G/s5R9YZSLY4CYt1sjOHR/+//81+GLuAT/VFzCgL3Kt///yyIAAAA7RjkOhCQz//9x2ZmIEWO3Uw2zCxLCCYLfMmgPcFZzdrN87+FJPzUbkK5X7jTtv8VhsqA1AaCRNL4W66UhlOVwHDO1L9SiDHihuKyIkCdqatXJ7dlf2PFoxmhk07jE4anasvpGrTqbdqKPA89BTyige97MxEhD02mPDsTxjMwvgKah9hfhr0YlEsw/Pusblv6e9mwxKmBMd81z9b3lyhYYTDT1mZn98/HKN0uX2ta/DuNWI5/y1aJeVcv+2k2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjeYkyDe9twvIt5xBsZbiR50TKN623Cq63nkIzhuP7XhMvloJDiI5MaczDgk+Q8EgVr1mpLZy3BRAAq1oxMRXcJChhYCQmxvK0UJSZJiAsulWx6meOnJmEIHvEtuX127zzvmBDqu7S3hUANAHxGWmeAphtYuQOClNpYXlYrDpIAmcDaFE1K3vu08SyhwUf1ewNE387SzBsg8gdFZ7CJBQUd625i/zLyZU8PMlKyx3zXgkBHs4IAkWPJikaYtEQhIIB06TCWxynpBUSRLEnlLsNHQ1BJMGeQFADHLA09ECFRmD6wH3mp761i9NUJIRGOl7wSme3hnb3Ukbf1oeJCI4hDVgixAUCyFYrZiIGzUDXfjdv8z1BKgkBrkZ80Lr1OoNAVvWv7hv9/p+/TyWccyBbANgOQR23IR/+sEABIAeYku82jBnrK1jq7uO3JIr1Z67TLEVuoCwFMCdhUdrTOrsOcfmMRGUSyapGHUV5wSzD2PaCRIGgYMAvu3OevP0RBlEFR+RT0MUE49IJITwld/VqU2qWZgyKT866fIBt4olZT86/cAORD9PhKoFht+4Fl72xqKwmGyJGXWLVWClan3BfKZi+EC3Hr03frW6l2dxm+4TjBqvP/fOcz5h2ILCpR/el85nz+XZ2t/L3MP+19THv67Y+r/4lIAAAAGu/lEpsQjKUAgaiqlHYLqYkTw3ne3Uj40EZ1PpeOMYIQWOx7PgsGBBIgIgoYyuVMhbK5k+LCqpVAqx0rfrTe8LAB4Gzp3mvHJCliuEKQvbQcQgQRXxkJBTkkIkMlq1NkZO+8FRmAWvJtGQEyeUMu3YkcBKpmrjyNDtsjYm7DJ4RnLH9MUGYquWcMnAUpDJYASG54hCgACyeHJh6xQFFiJGUAsL1yw0MrDjG7L5pizMzGR0nBkBxhN8YYFiTCz5lE1P4VsIterWa9IWzNpEmh2K/cKu+Y0zvP6sCYeYHGiKrnkEI4NB36xcJsy/G079XffmGrLjZMmQ93XqfhEj/1vn65vW4xzuf8z/n////61///6/+/r8P///CjiXo36+/qaIAZAHaFCqV4wNb1PO6387p31Tui0UxGzzhUuYes6Zm86uv1B2VNZtyCISpnlJdgiGmuwpL4Q2ujffiCofmrtiX169FVoat2lgELbhvPLK/lk1yitO1RTcOWeXbK9KaelcYuOPLsn8lNFN2X5gBi3Y/O1y2z2U3Lsdh5Dx4aGUKcM3r61n+PcrmOe/fmM3d5f/7/9byj0MhzLO47zv63+V3P+///hnrXf122AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIN3RNA3rTcMILebQjWm4egYk0DW9Nwxot5pD95bjL61jGuQFOjOR8wU+OlDIYjNqZy/tBSjoZ9KCLLtEJ4CgjRf0D35RxMERU3mX2rPK8L8WYOctiUim4HLdPpPwYIg5jhxJNJApgoINBM5U3XAou71M5IcgbHAUHS9+MI88LADJrBYA80peugo1FDEPWs5xRs8OqaRXCTvsIRjl0iyyUU9ZmcaRziqZiTvDtenWIoIi4c5Mlc8ZnLq862MaZFDpioJoGAcBMieOVRR9p18UH3Ps516fG3UGCZsAUM1rt3mX/uxAnxkQFTnmHXwVWUKntcVRnVzQP3nf180197mYp3Q52gfRY9Hn3He//uXJT+v///+f//////r////9a3v//9X5P0pAAEAC1HEmPLWGAVsmn443ZVWkrUVYHejRAoMNqIgzI3fir/ZQNqjiUbtQTx0rVmVJPNo2rszQYSUrdgz1gBIkrb0FUUOQ88SJD8x+AZE9NLJX2YEYg0ozS6yeeU1h4PUtROM1nevULx2WnRKUvCz2ZezKvHpU7VuV0b6BxT2/fnhgALeyzKibg6BVGnlDSCLIJGLU/cr2VjmeNa/lqGHk/u89d//t29R5SoBGZZalD5Y/9XO7cx7///43959+5258pretfVEAkiDm2EhZGe3WBjcEXaDPDtScaUTDcUgV9xwDT2OJKjFRpGiun8HH73u68EC3VmyFKuB0UXftYqPtrUhtKgzAXHEUaPzLVgILWJ2LyAqYsEIKUQtHbi2c7NuA8qj5m/qsep+nqQ63c0BZC6w8VqYRP7BNeaMMVxl9CZoG3M3AEIStKUBLgS2u9UcgIMGsAA8pcLboLkTeTZy93I2zk7R+HjAwTlSRZO3N6KSrW/GKfyxevoTDUAZZbvZbu9/VmKy5uRgDZ0Ajez6EwoDZ6wdGB1stA7zv/+cH2G4O01DseijVO/3n6/v6233//TvyP1EAAAADGsVzTFc4EWcN++G/yjckdJvldOOMBwUEjYhdChFNVZl2TvPZjR5q+rR6ld5pT0WWVsUyZUwstIo2WiMVliY8nWiwzPS1lqjhhoC7FejlU1D0xHKQ5VFISeQ2J+/LCIWpjQ1rcO3KO7KoFuzT1yh6ECozYnXPkkndudfdhKmRjByeEESUCWKCo80sAoqAaPeAEpRlfv8yr9qy/C/TVcFH8sNY75//nasykLiB2+W25S3D9UGpRT5f//+q+FXffuasnPWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACPhzzANb23C1S3nEMzluJH3RMI3rbdKvredQvM2419zKWRIQEErjK1BC3Be09IVxqXXbXZqca+lqnAWeiw6JgYGNFSDCRMwMCEgtxy0pioGx5PyUxKSzBMANCd9dKEcISQXlI2ZLWNxDTADUDPwUxwUeP+MAUFFwWyP0KBZt42zqH6DNx3FQZa8mkbs3Bgk/s3EcJJFTQ0IoCYalz9SJWmFPY+iwZoI40qFMZGp9VQxueGjtr6ugMcw3bn4ZcFSatpsyqqOwBjEiTpTTvxHHJSPDIFDUYfTNAMmf1914xKbWPZmpahyamQuGGNg8ijOGPfy7Yn4v2PBcKNMG5RgQgRWF4dmk5HuZQv7DXMe9qtWfKBlH3N+s7ixf/mGs/y/81CLH/rX/////+v//13//n//8/H/+4cVatTP9qehgABsAOVy8NOt3CsiX/73O4WuStprAosu4KOnEyGGMuY9AjgyeLzcioammf7nJVLK7GVwwZDs4slRNzwj4IxeyM4QLD1l0k3JFuzK7FvcmcEwo3/vTVNdqQ251SljOq92xh2VpN26WAWgQw1u/Zo4a+1DNJ6hVc1SpBSiI1345lNyt8U9SINQFN1hS4JRlnvDnMrGt5fDMSwx////3rDe31JrqOxMzn6+3hbsf////29q5r9YWyAAAABj85bxoCA0eMCs4AHDmlMykkeGp27q1jckCsBjg5ZQEBDEhwbuNlPLymDFixOAE7RAeYIgQg+o/cwBgbfssjjMIAEYpgq0cgoDOE2VnOePN8oLOIky9JEHBqZPswSQgoPq9sM0roxAZApEuk5sAKBR135mZNJ0ERhi6zmNQa/0SUuicETDZQyNikMDgOZEGLAmgzpYCGmqeHhuHrCjzfLABAEyc1F0gRsRg7ILDURlbpPdDwiIhJGYkBFkZNhZObDAcpvYXLlTmVS5wdAzLQyX6z3ubot45S6lbqYKMA6HadEWvEQ3vlAKgz2Pc0233f6+5IXtYSVAOR8ryBe1vL+71//vFM/vN93j///77/f///v/+v//3//v9XorX7H+j9KQABYA3ydlnVYfQYhzc7+Nzd2pK3TWiukLdmvAp9pEth2Uw5GJmexnLT6XJf81GZiQuxDEfQHS8vcNMxOsyKNz9WKzrWeWqY2cmSZOEOAdQYqK3MkjQS83Ni6imQE2XWFvCSy+R6Q3SQMTIkTEiRMmA+A7BAQMSycSGgIHLjnSdMxaQAmEgH9HGJgXKanfdBTqLhFSq39jVIyDdg3IJlJJNsxTRTf9BlGR6pjQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAj+dEuDW9twq0s5xCM5bmDJiS4N723DbS3lgM5puJRVnp6hgAKkBIYaCkIWh2c5um8kuWb+6C+1lbScpobARDbcjExMxZSMQHhJYYgFgp24MakmKVQBodyknBoVUm3F4GdLVYQqGupmFggzJRMAHiK3KIqqxIQg6cIGKVB24AUSOYNUfIDXnBkBSMsAMMsxOSbUs41JoDgKC1kgZQDhbFpz9tumZWpHZR6ByfD1h3jFyVSRvwUY0Fs6QqAwc88UL1TiMgsQCEBMmi2YxpGhxIBpplUSRgGBA7ER5AhiZOsKVSxy9ZZ3sK/37mMeckHPDa502Wtbwr0kUqtxHAs1sAbeWEoCLFVNhKQCIuK+q5qmeX/9ZxqeUKKpR3q8Crg73WX/r/y0lxl+Wu8/////////+//////f///71nq/rRAAAAFKrw9/0ABvvXOUHI88dNF3SAghJSXVJnm0su8/Eicuh7lS0L90DsSqUSGfp7NWjIgUEaroEk7LmkxPUObepIp9ZikiO9zWENmeHF88dWuZl4MOXbGD7SeI5v4vP5qMv5g0iM0tSvMTshpaZkdKW6jVAWCHmw1UbA6K5Cd1SMULdwLhj+P93/bmsrdiz//////nvVd6hKmc7N0n/9TLCxzn///zvzfOI8MKtJnOAkZKxYegzDQE6EQUeq51KOUqoFQAQSlyugghYqgal8SpRl4yYsCgoOclajEmFOMvJRl9HFlAYHQOvuI132eBNWLtPkZwZkYCYGsiBqGGvAMB4i6QsHNKe52gkbURYq98IuuaVABlTPjZ4x6HBj1e8zpupl6IhpTRt57wFCnNkLxJKgQGbjDSbZkZEKARq9YGKVcGAocCbZg70QbChJdwwhwQuhwZXg4Um4clbWEHAaYDoyrWqwzU0Hhx8Hfr4VP5c1nvDx0CJBGav8/W/3lZisugIAD5ow402VEgCTC83yVgAFVrlC0dfz96uw82d/kjEWuSWTOPR//////3FJ8//+S2vvvu2y1nhg11/yyjj/rofeUL0JgeOCAxWGQ15gYfJIoDFHX0m1lMJuSSzAK4X2dx+nVfKcXSmYuplJgMHllQUUg4jhAdWgtRa7zLGSkcoHG1WFmzKoGdBkaWrjuCcoEoNIKCgvtYdkFP2gziirBZamJDjxU7gFvo7BjWxITdUk98ejibMMQzNw+7AROi4CevIzdTJXj9zb8qDlnQLIAB1xVABGXZXE/xyq1pinmKmUqpYORLhV7PVLr+42p6dfUREjLh3qlqs7yyjPF4vnr9vn5/+vo6jR6/O8oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIhnRLg1vbcMmreYQPWW6khc8qDfNtwpUs5xA8zbi5jVu4xMgYqUm8hmMdnIXF8ZJjcu1IlBfHTXQLAANCzBAsQERl6Ed1YFQLLXolPAyOQP/K1vyRi8cMEA1xTsthbcE/CIUfFaRd04QQBiQaKFmnPDssIHRCCyIYvLqCwwbMZLFc+ri8MtYO+LPTOmFUMjlkdr3m5AxNYLPPPLW8GRN/ZddiQOBV2NfYaY4HlUBAPCAgBkqWxEK0N9UzSWepRM+MNO0zIZMTISg1npyVzKzQ4uM/E0jioLGPgREYNEh+rrt/LH89ZSh9wcfQupn/6/8Lc/9ogAjTh9xLY6Fkw39bIgHotmtrP/1/7itabKgdD3JLFYhf//////6tzv////////////8/////////7vCAAAAAKahJ6hVSn+9ZUkCQVAzXmmJuEiMwz41loZBIHlxFNlYa7DX1g7KftLWsMifuw6cDl53yT1ZmVQiZA0KNwKLMpblUA0hYF73xUVDDcaisN4TE9Hndfw2TmOQzGp+fl7xAw1x7TswJTuE9klk9BF4/CY2teVIg4QLQw1XzXtKE7FYIKGh3dh8ceS4rTdXN+xRQ9yGsO8ytQubltq/zU3y5l/ar6sCt4/+H//1MO0DCw1aR4Y2b3eTeNLO9////xyygGj/+Uv051JCYCHmIgLngAZHj4weGAoEeMOkQZBDiVX8eNIxCNBJOJAIDmmqQKASDDuZ8gJhQJKLrVbZRtkz4KosWjLWn4MAgxrzAmkQS4heIHCFkDRQuCDKZXCp+Meg8z2DhIhojIEWIiwnlDVQaBQCf1fskZ+4T5qco+QIiqaqkJdO3L3Z4+qHEyYcKAKZfudvlmIs6HVlAYTeOPqKkT8mEcZfGHCbEkeERaZ4W4t6k+60BGEBjJ6MBFIkExeKus6byGQFZuZMjKOEwGNyI5ZhKaWrRUszjZq7oIKbQxoAwy5+PPz3KoejMZEYkBsdf1gVISIyiWMMiQWjDNqL77vn/qHXylgqHJwbeuQOjf/+c///8lXc//z//5rX4c///9c/////+f//91kAAMARHABKlcp6F3XcLOOF3B4lIJDGZavSQsAj81Zi1fHOkvwzTxi/Lcmfw1clUwoCoooEZgRchYzjwxIpVSP4nFG5+mURIquQ0mwHTL7GaRWRRC+BJJmBVRF+aGJkRwuBKP4yhwUMVjjDsKpfNiaI4zUGJSuwYHECvL5aQE7ASWUSPIcMM7SZSaldaJFRBiLf0WcyFNBsQi8iaqjrqS/rax+AvoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAABvFhzQM7y3EBbZmUa3luHO2HNAzvLcvLNeaBnOW45jejoEWyVUVrALJgSGeimz1uyY+crvyxTe+8y5UE61o8kAemNGJiK4l9s4omLsRdO+6Kl8pg6BpJBzx0IyGzz2VVZTBxgRlSvjBikaEI8X1e5el+A1ZjAxx56WZidmZgexKTSHX9Zlcou4VQVVGbkZnWSL7nuO/SJnRWo4K9HUKai+UgZFDu5+V2qd8o4DhtTYhJiuX17kaC4YuOywkEe+KyrmdTmGX9x/uEQT3qcxvd5q9lz+yhsa6O4pSqFbxupa0+FJr////KzUmns+7Y1/91/6/+fGRBnHF5TP11hgokAD7NE0kEKnyEQAmDmZkmUzGhUlBPBfRbevG56Elr42+6tBCEhUFFBszoROLJzBBmsmMtVVRCN5255NxR/f1ZMvgqHJU+QhBwcEIUxBPUCixAHEgoRBI9PM4fJQ5mzJorUMpHJE70PyediETf+fOSu92JxCQzEZTjmaaNyZNSB6kHQvrCq0MQ+lo6h9gBwUONKd+xLJHuIuDDCgMsro/15qxPS+JDIJPY1YZEKoqcMas25jncMMc885JIoF/WM53DVjt6xnGE/zbCgeyqjFs8ZkcBq6gDL////Ldyjat27q13/1z//XPgX+a7+ua/V2X7xypN4fqveSQet0v/9X6c8LUMBVYmEIRnYMgIFLniWcIMjiSblHTzj0onQStoRGgKFUOSwhUJjoDIRAap5535AOgqn4/f0qxv3wo4/HXhoSAJSyemXYhh6WC5G0MCHfbdnzN0+5yCmDg5ZhFaVYUN25Xa8F/E+OxV8pPUiRiHsgmKSpKCYRr2cRSdUsuY22LyU3oWS08uXHanK9TrT5KKB0/AQGv+i5uvOAgNECPEKDTWgUk5vO1Z5h/87ckoOGr/TXcM8K1yrb52CigGx19Va8dVmQUf0f///+9W85uTbq8q8w7l3vf/7sNIsKnKwonF3bDPf7/7nYtP4CVCZQhGdgyBDJJPMk4wYXHlDKOVyx6S2T1vAMRBCrXCg1CcFwjHHQbZnGX7QLeaC5DMIiPOzCFOA9fapC23jhx9ngGxHFlEToSEtoEUqXO5r7RodAG/JRTZ3KleCL1o17oZp3kajanKZI1n0OVoE0hRBkrm1H1aYpyAGMvCaWrVrDlsGl1iM5tye6OqjppWwWF0li6+zzpKC3M0OjCIFmtJLLvcrGX36beGoxIL+dahsZ4ZXKXHtMtkOsndQTVu9yfiT7lfPz///7+bY5D++Wed33efP5zCNYZawx7rVW19yhqfctdsZComLPMvb/9IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACGRuTINa03CwaynEPzJuJAmzMA1zTcq1tGdQ/FG43jlRAEaPRC4REMAS4xEEGAD5QF2PqIQ8cpsoSRIWpMzMOOHrgsBABIz5c2GkelM2hhYWldxSMT60QucnREp+YeqWruLejxZEqUtGBU8QkA4oCrzUmPlgAwuMQfH0lzOj5c6kcrwFK3ulrohTiy+NS6C3uqPCQjkVHpaVB7ygwRJ8GWv+mfKH5bCmspUCaTl23FXZF9vDGWhO5LQACpbgyCVqlM5ZcGBBwQsC5oyUAxWKOHFLtqcocc8eb7WmkIZ/t+HYKs5fZjk/UmWFId6TrZWhVMMFgqTk5l3f/+saaqwmz93e8auX/9b9ZbiNjL6mNrPOpK7VvVuk5e1fqby+9mlZ+Q9ynJnZSmudbogAABAGaZwZk+d4N+hNd97rvc63xBxqaDFDQQydtKrGJP1KatltZ+RXY5bq6qxCdkibUDyGM2X9JAEKAFg/UWaV1rlLFqpa6ntSU0LpgQxIpgNmQVMuzhsZihjAwMzRIUM5VK5MjIGMxHkwEbmxRPlUqGpMKH8dxdC6TKHGPc2dyJBGwbaCdSJCMCq5u6Gp06C5DQ3g890f9MN6N2OkkvJtkl/7zjnR1GGNE44R59zfL73QQSI7aAEuGX5MozMFOB+Q1PA8ApmYgJQdSSFOwweBWJsTboYRD6DqmIWFYHHZicNjQXZssV/CoGkGkzoawAoVhtU0DvAg+zp2BAHhILkQBeBO8ABgvMY+ABgMBI+r8RcYnKn8fdlBhEIRmxGpbL7720xfY1niVTllUz4zsYZ0VglFH0k6NREQUAZVXTAduBYpBJMNiJhV7/RB/hYrKY/VZs48TmDBiaGOCII703RR2GbECs6pVzmSBvjYdSHKOD8ae7LuVu0VxZ8urzEBvxZmqCX0lNfoZcNMrdmDYVv9OnCcpdzDX65u7Y4xuvlM3r2XL3MKO3rl3CSXr2+a7uthqxqDu516eWfheuF05WyEru3/D73vXf0mZ7/IbvleTjAAAIAzrGD2m+eswhlLGX385Q3pRled+RJ9iIZgsW3bgzV3pfKYPge18xqmqU+dPt9rdNfn2bOA0ESuiTE2NyF36XKkK0SnK6U0UCyXEwAiI9IHFnDjC3ok8is0KxIObmBsdRTIkdEBS05cKZmktiiTiIdCbIjeIVG7ECFagtkE+EDHQQhxJ1NRosplFgdatX7JJEeOhlHSuusxdaH+qm1bLrZlurV+pVe8/pj+sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAiSbMyDe8twpospxD8zbqM9nTINby3C9LOm0PzNuLH5TYiPxIvLAi3QGmgJJDJg9HABmi9IPEhSbpqBkAKG6STlUTMINkiQCbAmCBQmpuhu2eG1pL7cVC+JqOjgAihPUNyghQXAn+T2R5U+YwBy8oOUdgEWM/a2j060B5MqDgl+IpNyHO0tKuzU++SIB6Jl4V6tkSsEQqJzN01C4cEqrpyrCBw9MthwrLJ0I4GDiF0ww2AvXPSukm4biHhgkDYjIz2XL1yOS5vgd+7oqmYiKp6BuMMR1+4zZvzMs5lZmn45PUtebj+H9oaWpaWSihv6rQ9ftsO6sp1v99/WpzF6YX8rzsVdVb35YZXuY18aTuOGrvN3KCWaufGq/N1rXXjGjjsa9mec3XQHCSzIqtYbqGpRAAAAG9Y2ukB9XMLFhmeXD+XcLEul8EQluI6KZqpeRu9JKc8oKhl18pTIav01JWqN0oKsQhgoEUUbQdjWOzqMxl2JJk2MDN01LSmSUuJIgYcEQamZIm4XU1E+yRZOGhukSqZkiNAwDRjdBMyTPMxqdTDCSBsMsW1rWYOFtABsjgLJAhsHkF0OlspIcr1f1nA0E0nTLkpZP/rOuD7EtcbldDROPutGrnblmVCJOIxQUCoRmNNl/jTnTDljj6x4m5IoRiQvTwwpkYOcAJUdNVUQqIWJhEEHNHJh4ZD4AADHysHEbpqnWqjKgEUgz4HASmq66aaf1NN9Z5n7qg5OFAsw4PMGFkHXMFQAuxBqpV0tnT3gezH27u/G2QwZaAcLH4AyhxuboRkElNfTkiRZZIIKAp1IaQ2+jMXyi1Em1FkfoFX2ttAE8848LT4NlFMXadyxATHH2fy3F6IlbBAjSRxscPaG3OZh+HcpNL6eZ5IoxDFht4GltJ9yknqSxa3G6e0NI2JihXFu/nMUdStlyv3XN1t7xfPCls1rv3LH4Zd/HmtYfXpMredDQYhsXMh4BhBxAhS356GKBcLm1zKBOTmAjQAAAAH2cXSBaf7biFoohO60XfoZuAXfgOdfpACGMHuwkCsRp8OzVyDYZeGCuzUxX3Tc9c7TJdIYsBh2LFBAWbW/KV8cZHN0EwQjUe8DIyPG54ioBHyqZoOxgUxCxPGJXNVivmRmVTQhxusuDklAMDlJjUmTREmzUhxofAoFjMhi02UYmwNDAWWdGdIOME0slWlUiipRTIKirX7pIojWD1zaWTXm6Cvb8spqRZBNAyVRZa1LUrUzpugbs5n3JAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJAHJMA1vLcqYNCcQvM24k3fswDW8tyoKzp1C8Rbiitciy3B+6WQViDIAWNmV8LWNhAFu72IISshqNiYWSlxhYjiq0LFJ0QwBro085DAeIu2NEosl0zmRhTcFBwcIzzNIdYxF56uXtEYk+b7o8mKAksXKBiYxQBhKbxgwCrBQOCy0xEAgiIS226Mibhg1Q5cJRAUrd+Bi7r0POyVrAUWUZgBaTC0nisCXpRSK4nyhJolMX8WEkREJjVbmzaUqsoUiXLuvWv2DWvW52IoCQOqlgFiwSWhemW5VaX1rDMLdTuMWkNCoBVjkKsXPqP7Vsfm/iqyFd/OC1xa/B8LOVD/MO9y1Wn9QQ91erV59uP51b3eZa1awr/utXkmXblh6rVTPOhtfl9Svzm+3+f+d05+E9qYZT+UbICNZsdLd7NeqEAAAAdOkqBPdPACBsBr4537tiZjEogKCUSQoUCJIFbeXL7imqahmZTLMIewhi7uy1WLxzLoiAlLJYuUNRSFwO3Crbd8UBnPyrmpwlAKUPoJGSaSyVYxZJZIEuiaqSdAzIYoUoRFSZNLOl1NZoYBqRuiWTZTpJF8XEFVkUJkY8hEk9VJD0jC9vVbkaHvH51+UU1Pp+z1ve9M3a9B1auqq61mfdFtPovbyj5YQGFNjpRxjHkmZnMppImDxHpJteMALhYGjVRnIUMhZ2W1DTsGWzBtwEZyiDxMTBTJDG0xAVCnmqt0S+MDBDDQUvE7KXNfsWIAov+6b+NEBguhyHiGAENWJCgJJ0k4PZo5QCHGNNHfu/NwdA8JsCCd+exN1REYw6HhAHDIiWl8XrQGQDmqI7uaiEMp1RYSOoGpplSxxmB12xrqlUshmSpRSKqKhw4+sZq0tZKoJFbSJIHo/J8tZr2WjMtpcc5U2WUzrkI0vBf3arSi33dJ8UsWUDrUsguLawuV7H3sL+X56t2e5Ngi2d3HKzPU2ss6bLu61nPeHw3S2fvR6KxneUF01r/uUtbv6s93/N5d/DXP/+8/ff/f/rX//6tawBXfe61TE31QgEAACmdJiC42g3iiQ/NYfu1TxV+5W1ovMTGAH3Xkr9y2lsWcbt1u1K+ty9VzvTMspJHACNscYohgqJ+pLJ5uz2KphRvOos6mkWWAfyWYuqL645CaZspQz0qGSjA1LiY2TAXMg5oXUFllEzTWR55AWjdajYXKCIFUdAr5IJXWpbdCkkZp/9qiVHYioxfmCVl+tXUf86/d0tbq1uzZnYp36QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACV1+y4Nbw3KwjNm0Nw9uJWmvKg3zLcLQrKZQzM25zqYP6mEe0EIQSWIozCxAwDh/GLn3rF6TGxgeBJ5x1HBRODndZ7Tn/C6gdLIGTN48ZQ6HCBniWzZkL2szBIJYLjFQIMZE2FiwDDnYZHRgeFnWgNuZjYgCCkFJoFA7IEAwcDhAAwSX4sCMbGZYwJDJtIYq3IHfsdIr+QW3PRKQsnxAhugV5CHSgR1xE8BAaE2ZiL+jwaNGiPLhSnhzMt9D7+sfg54H8UVU0mZeia966saSxmMGAoWkIfIJjGaHITfjTAn/rY6vsSkGMaElw3CJnGUQVja/Utg6o2VWDVPAch792DcfyuZ95+V/l7jYMMeb0/1Ly/Tyn/y/OUZ7w7ErO+3W61qTOZnbesOUHf/8qPXMOU2O//fP3//rv/z8q2+6/vav/kPi2sp1ZVnrAAAAAZVIrHhsgFI5NEqXK72t8gPjuvxccsAsK0xaHNs6wtxqvayhDhRLdTWrTpQLhKKcIlLouQAYBL2QROCKGPPuGwllDjB1phtYAOUrrESeCecCI+xpscVbmO14XNpbjBZdWR72Ex2b1qdE1kUzq9pVIxlUEBSp7DtjXia9r7/vnH1je8f////Nil14eMfFvLvP/+cb/kxXWtQq/5lzjWYNtf1pr+sRooardbT//ZW/jYlFxwGMSD17IfmGAhhAwYMWmhjLBAMImRQZtAingomXATEMChQwiCDC4SLsjwnCoOMFkUzIvzrJuDh8DRESg4FGoHAJcrI23hb+rwDAEYDDybsSy+QgkNRhtWkMwDC4OAcxMDgKFUQX8fAeAhf9U0DDoMHBM3WNv8rc0fCVU8mAyj2LFabCEiUMUkQw9PlnACCWmEAhYVQEwg01n/WdYh5rQKLlaC0GwiB1YNQfG7DYF3x9E2zLmbK/ZzILNuyFUDoKVVQICNgAhOE7jWVhlNp7OtDT+v7U6wlVaHcu2v5c7eqy3eUqQtqZwDzLHk7R1d91/5Zfui06U53dLVs8yyy3l+OPM9ZU1WM3rUqpu95Kqamtc/6w48REQNBoS/SJSpVyzssJb3XDAKwAAAAHrbUcz2j6sdly6Ia7y3eedd/Xdl8IcZJIzjh4Jsi9lBqGA5HAslk8ad2aV9bsXZLJVzvK/EurD4rSUsUmVuQQ0aiaPIaVPcxz4xSZGh+TTmAFjjgMkVEWPkGY7KBgYCE5ULCBmNpzM6aGQsw8msc4zSSKZdJhEfCRdIkPBus1MimCEgDKycHGF0RVlM8gi6VVS6RKDyft+rWRgpetaPWzLr/ZRYdSKb/LEFN//ChpMFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhzXEgDXNNwwss5QCc6biG5hyYNby3DHCylQJzhuH0SMFhIEYGXIA4eInI0YOmpMbFOrQVtEKAKAUAJUACGxg0DKXM0Y4YcAJf4wOEU0gsETDSeOlMoaPoYNgQGmBNHiiqhCFVOVgBIip9mABOuBYFC1iriN3BwdQHJDlQLGRRaYND5lwFh0YMxA8OC4KCb7kISbpEh0NGZgeopFIUz6XxgRgIlJQG3a68DQWsUTBmZGgFutLXCb+H1LX/i0CuMEKFSxSBxGWayYBO4sOO4/Dk2mtwAMCAxUxgRqGKPwHECgHDnM38TEMMLP0bL4CqowIomCQzUfq1FbNaxYu8paaQBFmEW53Gz//qtTV+MAQ35SKOqcWb9AolLqSLfz99/6mep5T3d3r2HyflV8i3psH0Ps2KXxkREAzet2NypxlAmKAQBB0wSTDdOleHnZEZrkrQnFvodZfBBQFAJdSHGTRGHYJEN6OcphLIj/XUkzEhsAwDHQaCvxDs+nUuRmhMuq+FmHrbuy6NgZxOTmNPP2Yqitcgu/P6SNhc7E4qrbD0akbFaihbUplpcZnqWk1AbqxFI+rRIMrVv7dhpzoL0POFcsVEoISgPBtXnP39nfauXICS7k/653//8f/D2QV9VJPvf1/oKb////+f+VFAPy0bULMUPEAoEvzprTDjS8BqkoMVnaCxJE4MHqUmJjIcZrgW+kQIQ4iGBGCqbg0FMPGjM4k37DMXATGhZCgQhY8JoCEQQaFtsOARbtQcwQES4Zo/kidGBm1XOlCgRMZFhCmmVAICCShgCwSMgbHyoAsjY+1wDFz6QO98E2Lbw3JcfXavoImsX6aYz0GgOepe57rtEZk7DOGXugXXpYDYcjLICRa+wdnzP4Pm2JuA2BxqUAnsFhouM37t0bY3jaaIQjmLZAOkIMtRkj+TdNhYfe3nSY5aT+UzjHNc3h2xYwwwuQW2DecFx3H/hqcmv5vPuG//ucfhOf8t/r////ef1OoIAMMFDl4gdPubmf/+XKaKAaGTRIoRrNIGNE1fnhNOPuRPshuOgoKG+4fbwWBYM4D9PpKVaE3bD7qiybvDkWceetGAWUNRN5njMSQQgg402RFLWtIcYfU7guCFMDUThuD5bDkxft9pjqWzLo3VnL7hQTnSRmF01KzevhDjuxqYqyGbGC26kEvbZlsmtwh5ofX472UNxXc3nEF9BW5rA4KxUuiYV2rn395553MO3HpYRf5n/65/f3nlNNA19DGMP5V7+Of////e/Nuae6wufkD4qfif20SYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJxYjLA3vTcqbNGcIfEW6m1iUuDXMNyoi0p2CsPbh8WWxWXPiYZFCR4nkYKTDoAZAng4+ZmpZLEGTHlYmEEo1Zy4oINzSn4DHo8Dt4Z8xnO0409mLjaoTAgkwIXNVCUTTBQN72RF3wUbpVwFXbKoAv9pahDWiy5hQkRJpKUrCiIJEQyhYwYBAwNBAYFiRUoCJANqUxeFyCNww8ezAsHh1ASwal1mB35XcpFJOPsGiLkAIOzR9HadtlE2gs/Red9y7ERWlGHjWAj8BunaTQQSOS6sqirPG4SZ+SEGcMi+zrl/YHja50EC/GWSaDWvN5T7zl71KSlGEdj8a1W+bmKTC/In3tYXYtXv24/j+G88/5KLudPvOdzvXrGPf1/4557+vlhhzPKksWLkB2o3T02eHN8/Wf/+PNfnv9aww1n/c+95//////vLn93///7339fjfwwt18B7a4AAEjvNANL7CEHluVHeqVtuk0uPSmAnTEsOBBsnqQW0ivBs5ds6wuY4dwWxCuVbSElD1tEELNn2ZBi4VMuyACgVH2wuaGKCQXUHEzWg6JMzru5GJnzxgo2qPKIAmmZEstaKRGEUclLjVP6KBqKHBHCWHQQIkmMTf0kHXlAaLbJ+vWWE9Ra2Q6m2QRVlk3VdmqeqmmnNE0jY8UxyDUmicKhJlRA7b6cj2mqS9rpp5pvAjFhk2koacKbwGYMEPHGcNHAISMrk8OCCx1KgoCQMJDcBGZyQAUwwFFFTSE9Ogj1OiqhmYUE5iwgmWwao+6bXEwDBgaSYfSXxRbYUAykZAOAEHA0QgswID4mYRBYsIS1JgAQhxrLktLQEl7TC4IFgRRZ2KdwUsoYl5L9powBdL7tJfllIXipszJg0il5pWj1AUO9cFYkieZ1ayJiXb+P83kZWypJ+o280fhbZp9aT30q5IjLYECwz2K6w9oK3pTIEb5iMv7CWkXZurjUl6pN/EeuzVq481F8saWHq8ss585uv3evq28c/5BE5lN9xj9//5/cf/Hmf6/GZsfjrcpjdjDGXMvnt8/f///+GP5cqV8tdx5n+99t6///9/////j+t///+PN75Us4frKuXFcoAAAATWZUBy2aC6XN7qwjVvVB1p7spjoonkLhF+JX3ldsMvkGEJ5SfX1lWeLLtqNKuVnd0s4v+UxpXEp5p6EjGmdyt54FZiu1fWPCwYTJu+9sX3Ew5Urm/Z/vv7W1jCp2ubb1G+a+orgEWKuklG1bX/zT//7L3v/4//+v4m/uFX//5/l3r/3/zv4//zTX+sX3/WtM1wzM/zrvYDvKf0k///KAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACXh+zAN8w3KcbNnUKxBuJmojMA3zLcpLO2eQvEW4p/dyA19jE7DLSAEICIBMBBgKzGDChjIm7TZX8MTFYvO8y1FJEgENIpEwaDQoEDCR8MKm8wsdzcUcKFigOTofZ/jLIOdxjpQCSADBYDCwRgakoa7lMdm5psa8hkTgwCIgoyweKA8w4DwUY4apouRAwYA6nLRnliU2lsvSHgIaytIqjTrhFJIIZGnOpKIHdtfp5G39LKJY5KxJxi9lf3QUN73vf6UwAj/PQW/6gDK3Ig2f3DUOPvASh6ODjKPtag+3GmZF24VWwjzjOhOfjcQpdiQcppRqH7mHbModiM1b25u1hnjYlU5n39zUX/mVuTQ3bxw7lY53HG3hzuWs//usfz72akTuSP5minrH85+8+6wxwr81WtWc8tZY5WObs6///u9Yf/3BfNz8xWynIL+QhAAAAEyqBWEzuDjn/1FqbDmdIlJALgomELIPBAW2q6xbq1yQas0DqYd1nyhztYRl4FE7q43iwetfdTVSsyF2e5rRmbkcIaVnQUzKD9xwIJqmbIIsPBiYJlRRrNFn1zFJIrKHwkeUf0TdEPyAV3UUGSu2pSSmzEZRf2+5saNOP1rd62SfqW/qbW19Ts/RUhRLoqAQVAb7a8sC+OpE8/y1NKdgyVBT2pwTATlixAYODAJcM7jAc+KBpeGJyENGp7XogxiQZBQgxLlMJlAbC5hcNmwcuTBBuysLOmCmYg2jayJga0g4VF0pfP5uszwOCcip3AHgqFgeEAswUA5FAdGIwKNJZ96RVMwSA1ZUY3iUfbpONGGjIcMcOkj0HERcsn5c1wR0wXPSCYl5jPkR7J46126oO7ruQCpjcBhUfgx54nGx0iKs4dxlziFvU0JyOXqZCOJsEEvJviAaxbl0bKgIkJX+b3BEtubqMnjzyU1innY7Pb3ypG4pet5yWV8xuZ5O1Zz7j17fvaq2nar2t6uXb3bFvtfm8tc1hnzC7+eXKR6J7ev5qxreHauX9x1BHO565h39a7T/n+8Jbn/5YVf7z/raxz/eXeYfje/eHLnGOSNAAAAB/D9w4v8XFptX7eGk/PmDA3JWESOL7Q4F1Pz3u6Z4ZNlR5OXaofx5KMcMKzJVsv+/8AT9iDXMy5xOKC9dUmyDmQXDEi6B66hHJBz1TlEsuyBB0jNZdUXnMzrVS0kgsgczMHa6kRygXRbZmd6vrPZgOFuqr6zJaqvVb7fV9f/3+Wt89639f1eyD6pi+U1//QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAnWh8wDfMtylk755C8NbiYeEzIN8y3KRjMnkHfFuKPK7lmBGc2kFlaGLSAcAglJByiDXs8w0ZjGTB57MFgKEK3QyQgYw3AAERErTChGMcKk0yBTeTWMsiAWAivoccoyWTBoHQ8VgGJspMPAswAAmo4wuPCAAPVhNBAbloYcx4NvY6MaHQmYIEFI05rJfZN19pRKWYl4UhhZV9g5CGrkBDWdVsLnlyyR8WDYPEqsFDAw+OwOVPF1HVy1Tu0m4/pbJFh3bE5OjpbgpM10CN8EkNYlMZgXBGGClFgEDJr6EDOJuU0MOAYWmoKk+9Dr0+MRfuUOzjVn5VQw1TVsq2bmyzl+7BOGFmruJwjD8cGxVqSiszsT5zDmdLn21hqx/M93pf+GHMKK1cy7UbNTVP5jvfN65hrWWExLMNZc13eWuzesO85cqax1rmu95hvDmtZfz8/x7h3dtdHoHjAAAAB+eJKxx/nxpCsv79icwx7K14xelTKL2tMGaxmLZ9pU7Ktej99XdkdrtS1cz3muNfdGiY9taCpY0Gi5BTyR2KYqUbLUYgSlF0TymRDYH8sTUsxNzdFx2TpfKUaUDFyBySZOTD5gO7zFZPEdo3Vv6jXUN36k/rLdXqq2//1f9VuigT1puk6a+6v//U69Sz7tU+r/67+t7piQvHuO4gibkXrGU0SDTABc8qNDhstElOJEIYOqvNETA4mA0xGgmKCIwMITJBfNA2wxUEWXptO4IgODTGLBJYrlTLRiAHF8SgQue19w0wyYAyN/0GH1MDgEwUF2DTTShgDg0hqWR+fR5YCxFvpNKqG69afYRE+srZ8DEFj9rNMbKaAI0E/sOweQgCOpIaWwDZsJqpzSl277GxCetSD5+eeweFlcWYRK2ZjoLLJFhNPck0w0iHe6lXWq5l1yZpmLF4oNw5WmIOi0hgTCOOpCa0/UoorrPfY3Ty3HeE5At7LLk7Z5atdkcKlvcuUVFqfyzz73WPNc7zmFSx3PHKjl16/amo1G5Z/P7zmtYYVdcysWLOWOv3/dfjjhlzLmsanP3+PO/zHd7//O5n1RMMy2wAAAAEN4hBnUQhwQgIi2TDhTc0Q/C1UototoSUowS0TG3JTJaDS6mhNrA4ao9jbhjEVpDxdjwoxvDCVMJTh0uKvmWrPpCVFuiWaKRBy6QE2pFBI0WsspS4SBwZxNRYM6kzpHmbF1N3LXk8eB4LSKKSXq9z9ZxGl9XUiedrfu7P3+/1ey/oMqtZw+sTfu8dWLfSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJhInMA5vLcK7u+bRLDW4m3iMwDXMtykc0J5DcNbi3+WMbEAPHoVtDnH1GSU0oDwqCjHcGNVBV6mBMI1Iv9L2HDAKZjsgrRdMwUINSKhQBNbMjEkkiUlwwei6Y4uhB7H0WKjogEHb0QgBiIQCh9TMQBsatPgBAkRAQVHkOSXXX9aQZwJMedy2sJKEpqe5YkN4yBWAmE+ggl7ngKN4o5RpLJfn6A/FWs+owQaj7IW3a1jB5Qm4tRyYZRnAR12dnphHYWXkFeC6dVcOWls1akowCrhDqjpIo6OFxy3crQCQlrc7e7nJIznLIFlcEyy1VkOMAY4c1hEMMca2pFOb59SJf+PbD+T+HcbcX5UpO85nKrOWdrK1T6sze+d52Pbwyxp3Gx1/OY/rWsa+tb3Upcu/rPL//DlFhvP9Wfu5Z43u87qxj//vO1n+vqb5jy5q+kkAAAANZKL8bL6xKyWLAQ+0+sp1q9nNxolM7ESU+A9I9mxwuOZqah1beW4EvPrI8O24fh+Oa3MJpyxAeQxVbFXpl6U9yfY2UKzhHDVaCaZNEDKbKJRaKAnpLiZaiSYYNFIaHMljvhfy8gal6yZfLSO4wyjo9izrHCA/AGCUDAzNPnvOn6BBZep5Wh8bOy9dRo/ov1KW+pqfTbqZJTzQbXXsQHbp/f3SU70VLfMUCUllzOrFjBJAX2irTGUr8MFDErbFQSUONhcBBcxUSjFQFYNFJCnGZUbYGK4sCBGKyQjpiiPjjjOFgkHACMQUYCP0MuEvWIKVCwsoNuoFAeFwIFwIuJszjjw2LAmSrctfcPw2VAEY/ArDlpt8vlNwvzyzGZEp0PRQ8ls3ZCUBh1MoHbSVl5xDuwufjEeeAAfAJqWQ3ZtKCMmV/SqLPsIEZZUuxywFkk1p2mYY8AkYp3XpZc+BclnLok0FaVBgNLLYIuswGnXtl1fKGGmw7TwFJ4LkEUp71aYlOHb9xlFI5nK2Mfd2xzV23Led+keimx7XvR2x3mXa3b1FYxwxq0mFrLfN6uRGdyr1IDaDLe495+s8uZ5Zcws5Ra3zXMsefjv947z1vHut81jlzDdvnNfjz88e/vX551NDZGAGAAAvxZmupYj00g6uFYlVrmNalcaUOWtJJNyQxSwj90u5cxDO5S4SS9jvlRy5fhcoVMmyK/YpIcIg+7bW/wZxMP362UykA/GqCCLM4XQd5Bda3Y2UpbnHJ0S01OV1pF1brM5iSLdZ0Zgs3OGK762fWhpJr+n9NSfbrUgr1ff1v9vv2TNnpZ9qAef+wrWDrlBEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACWKITINcw3CkrtnENw1uJfYjMg3vLcpstKdQvLW413e40FMweakzbRx7TCICinKHpMxOk0yITCJ+Bw/TXbRppeYxM6C1UqBgDBz6MMgI0BdgCUDTJYMwBhYN0gaZ0fI4v+mhgFBu/DvIdRECDajW/0yDhAVAoEC8HBVWJ43cWyPKZi9E9jRhkBPPvO1bZgRPlrt0tMghInISlAZOnQCKh44HweBpRpwGYgCPVI4IwOI8lGqvfIYLsjM9L5gQrh9odpOeAC47L4elkCSRGt+4MTrpJ595PDL/TLIlYZqjv9gqZt0t6UNhkEqt09y5IPp69d2oYiNvOmdmn7/exHPXMLb0y/WOFyGrOH2MbnO73yznqx+rGee8K0X7ljYiMJwt7//7zfN5585yO9x7v9Z/hrDHlr8s62eWuYf+O/3r9/vWOtfzVrX6zuPjWACAAAg/FU3auPUb1iWMBomf65lvEUHL2utMOgF/mTL3BUSanJQmvW1R8bvR491lHVHIExsCxVUF/F83/g+NL5Us51w0wY8p/NBk1ppgP7so0RMjwpiAmbpJGJVZicgbKGScDQxPMzLccyOOw0Nvl44bB20DZHu76zzZSZ/Wu2YpltTI9U+3/WputCvpp/tYxUzKplNPo/v6t8xW/LrxQRP//ksjf3qzAQghhZGsspqMSECwHATwjgQI405liMVIwMvFBAq172Om4kBpwEkGKjRsRAME5/tWNYJiRqctBgKDBgQZUuL8ka/4syADBEDynGdYcPBxhJMNBDABUFKoMNFAhAk+4mypHkx4UeOkd4FBKwwsN2pJL6dc4Y87888sTC4IcFLYPeqBBGKDwoElc7GF4jZr0Q7A+D3pms7eh3I+q5FmFxypDCTKcT9UimDWEkWn2KuL8Khe/FC+nxQ5Q/ZhiJsvDDqK3YuU7lTd2vCX4f2duXN0lPhXvTcQm3u3e+hmsvq143Tb/9ROVVf3hQ2L+GX28JXVqYdxys387XfzywlE/yrhg1qvfwy3j/P/+Z8zwvRbn6/mP/3/w/Xf1lvHf87veWtW//mf6//z7zv4/c3uuIBgAALO6xaQ/PAoEenP/IIBkO/qW14QqAGvq7Z4OQT8BEgrN7bNaLOT9fy9rW95yyDZzMiDVQddUsWuR+GErfrUo0VDb9fSRRTgSg+pRrUwXUd5sjWs4aoTFZ08UoctJFyytMay4fYd6JWdfsskxhSi5MPt1fMdaCLVtt9au1V6J5/bqZ6qlW7O1q+yZWhSWmWH2lfozDxcHqiwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACWeIzIN8y3CTbQnUNw1uphYjMA1zLcqutWbQvLW4psdV3oEccGDEraRMrqMFPhI0zZUFBqaqbZjlIjwddtlseHQOZOaphMLqaGAQmYcC5ICTrAtBIBGAUYXEgtUm4GMSity3CZlugVAcquzFIVAKpg0gwGDhYSAIHDoMJiqnmzaGaNRcMRDy254eBSqokGmPSC/NqAo1wS0CGJWrlNeOx+AUTzCiZvE7UVhsCWrD0r/tMtl4Y65VC9z/jSsJlX8Z8NNuPAtZy19IRu1P2Iuqs88j9pFmZZpB2cW2MBp16tY3Hph+xRU8HuvB1PL5T25OWcdR1+5mHO6qwJYywrXZjDWedZ+uYWOzMU1/bVf+2q1e/h3LXKWty13fcOc3plT//b/8f3r/xz//1N3v/v/l/63y9/NZfnnv7uu719qx++/c//3vDvcdataPUEAIAAB0uTRvprUH40rj8SZxe/79Epk4kWZALGihhjnP30vnEW/RY0m5fby/l+OU0daS+6QhUFB6pJHZsqLSq3YiSQDo2+KXs4DbT1VLDoRrNRKb1mTGiI2MNiJsp1JmJMLhoolFFNz+o2ng5xgak5Kv3zitjyOrRX6M9z3XPN/3b572/X1nPWaINU/dp3SqN3/9el0Jt1GbssML2B6iNxu60AybUSkwE6YoBA4zAlUEwNbdiEBv8YodBgMWLCFgMlZFMKDc9Keg4vKACEPmXieYCCoVKytMtYpEF5goVPdd+o5I8MU8GMI5CxBJRATDgGBCAIS7KDwOSKzJZDSWi7RoLQCgBoH6AAyV0tam+U+IFlzV2FSxLkDfOdJqWAGBhagu9F2rR2AQ45vpBPvK1gmTYtJ7sQHQW+bvDcExRpKBNk0nxfRMhQJpydhEjJqdmLy14i6yRN+e7ZwZx2znuAGU7t1ceRmrv+2Gowcx37tTufd7oIFvf+cMRmdw+9PRW9jjUv6/Hlrmv/e8P/8O3Yz/ZXHILgKmwll3WPP5j3Lv6mbU7zLOtruP87jznPuVt5d1+v/fKf+/hjay//x73/ww5Zu0gAQAALfvx4GU90Pw4tmaO8Yu1r1iXCIOUxt+h8hsxqLZfFS1KaqkJN2TcncrOWPJFFpqSwAW5LATsop2LcqQYhX8l6abRYvkkimas4AHGQTR3AmY7kmRUPxZsQVFM+PdQ8jYoop6hkoHWHmXXMHeiZEkTxnLDBmZVaOzmXn2R9BXUfMjPWi3MD/f6amfu3sqyqlajE2L2gYl41atI1dS+QpBJ6AdOkHv6f9OkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlJiEuDfctwmc7ZxDcNbqPWCTANcy3KSzPnENw1urlaVQuEhhUPgjU3slCaIIewwHmIYlKGpiWKwkMTOXZkSq5kWapZVCMCAQEF1ARwkDxhABqm7YgMJQMAoyYDFb8PNmhpBCDgcopfnPIEBINWzzrdjA0ARCCA0FoyBTOWnMCMAwxHiFyjLziIAxADyZ2EutuwYaS9MWe1ofMdGIRR0XfdQTpYbVlWKOhzLtJfR94aYSjg/LN5cn4vsomp5dO05VPirBa0hrLCFAS8LU5PlUR/JckdEetJgmvQUNkEiQVa39Vg812vi6aTVbuX6kWvzqx9vYClePKCjtdw5Wk2WG7DRJ+ls66+P83+rG/5+7+ufr+6/evtVst1bi3ojS6ym/73X49/8cZZb/feyv9d/8f//yu//753//7uWP/93DH//fef/Zj3yCICAAAR1KEIUr1hRmtd2UrHsY9qykhBfxTLEKW4Gd8cywhT0PXB1bnZdRZ3t6lOrGo6LKXkzRVVz6CsSAklvsoTGgiR47GxoaAZ5YmhpoBYjCs2ZmaapLnT5iSSY4VGqJ9NRwoHT6x2mZsZpZgqTScmXj2qv5r5sn9vVWWvX6ip3/6f0V+/29Zoi2dZLnG/+3pX55bp37v6zFetXo05Jh+oPQtelV9qZnCBNCkL/tytAVHoBFm125pXmmEcVQY7YVDhlwmEAiPYtESL7X1B1aRQPGdRGiQu5+3/f4rEECT+WxkCCQMXI7jYwKBFrEw0RjZUz5ghYM5ABWL0cGotgIHPbB92niAgVopA1y+0sxAnInH2j7Sg1docH2n2FAiN573JnojEx4l/JideFmKUcF2Y/HhEK7dGpxZaKQhTT1PJp+004ZldsIntPo9VSNu3GhYlxLnJuah6/hUnH3/PD8/o88+6jMIqPNh81Uw1lUg27f7qpAdSxUwux7LDXalvf/+//991///7+7uvL26RKfp7dJLc//87n/rDCet8w5dqf//q/3//7W//DH//91d9/P6vv+zGZd54pEAgAAH3WuKhpZcYUj9ys2CrrVSwh11BjURZTcxyErlmVmOprQdWt/O2cdflqxlT8FoOgrQjJG6sEsSajckEBJIqHa/mNMPK0HZ0SeJ8J07vY+nmhmyxkoD8ZKoKQM0UzaTDlHd6jwSpQRQ9XrP9Zo/qb1Osw1/Prfo/b59+v00kOxmjqQJqwwGHv91pip8c/0/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJVIhLg3zLcqwuyaQ3DW4lFiEuDfMtwqzEJpDctbjDChlTPSrfgoJ02GCWRBd+TQlj+RVrxkYwGAgSn06CwSYBrFFgQFrSBQDMwEURik5JmgwWNyX2XxBAJMdl6GH5ZdG1FAsAaaeq4LBLRcZ/YYDByVQKLEURAp+X6l5gIhgZBw9H9p5FQPy2HqkZtDED/QChObpDRhryV64OiTeAjZQBlV2WMjNGJsUhfKPQUWttx+GGespHjnmi8dijRSJuLUMcYQyoaMpZDB9RhqEcGjoodlA8fjUtrdbAXaXRTazoGcxurhg11bl3eufNWMatnBvaGMay7Jv7v6WB7+9/GG0nMLWnR3/N41tf/7xw/995ve8s6a5azxgxY7mSGUy2Yo/5j+7HOf8pl+H5ZVda/W9f//u5hv//Wv/7ty9zePLWH/rLfe//J9fQwgAAAAJ0niDC0eioFAUugoGhT1XPHIkNMwCjwDjw4aP7pZmipy/lLjJ+RrO3l3CtJrGo8ASusgYgPvVphO9Zk7dxVG8bm7QTYnVhLHloKSTQBbwuCnUibkzlih4Rvcd5w1OliCiaPAxPIhz0kCXPvJrmolgeGdBakqKklKnENSzjem/UlKPbyb1tVvWh1oP60Fak6tMsRRRRRMk0daDe3pN6SGlMghLHPR/hzJbqTsw0sCVZoYC5iaEpjpjY0TLKg1Qu4YQFRiU6GBwMm2HA5WAWA5s4DhAiTGAgbIpUYJBRvXWkQBQtizlCgONEDcu3H6KgbYmH8PYxCccgaHzzQ44AKFahqkRIH2Iw6RYHJEg6PtVhAjB6tVNDkvlINQXBLBgmajwKZi2DtUkbNWtTGTPi7yhhvRkwMkc93ZSLNOc7VtBIvsodgWH5PSiMVtLan4ZVOWAEmY7Ecb7eoHP4gygpeeGkeTVXQjLYjO8wqKPU3crzS17W7X/qM2Md522PUzm8+pFsuc3Ad+3jlUsNrj3DsB3ec/O5h+v/Dfd/9zuf/yZorP5xtrEgs8zp8P3/4fh//E6XDfOyv///uZf/7rfz///5/7o88ufUx53/3l3v87ZfBIgAAAAKXzcSDtUEyIDtlRqO0XZidlZf+WuSMjABBhJjyS6bwjc5H8863b1q/jW7HMZ2+6YVGIQUsUErNpDTIc0IcbEBKkTLmdKumyIVErmV1sBRQ31pLWSpnSchqL6x6SishFRfzgySaQkguBOcoG+YpHQiAKGgVlB1tQrbL6PUb/Q+aqN+3plHUyH028wS9D1Is2dNj75wun0tBFv+g/nG84r3R////6zZkgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACb6IzANcy3KoTRmgKzFuJfohMA1zLcpDO2cQ3Cm4xrShzV1gSGUyoy7T/JmgG2EIYeegvuZ1TJilIuUnUoQ8gjARl9ZDw5HgYDAgYmDAXGRsbEBwuSZC4DMhgswOBxp7JaMmhEy6JZStB1u0MgEwSBFppuEwAAQEKoLHgugJfNqDADAYjBSGf+09qTa0yIFsbaZJo6VSSsSMig0yzoRNOs3rwxN5gU4TNSmHqNdwBqazA8Ued9hIByojTtPigiBhnByH3fgohdKgnmuJyLDqq2qKJu+hFL3SIlcYNgKhyyoBUFS6L7ympe/OqS/TNHqy+9Vl8EX6LWUpfh/o3jrOSX8fzwgSm7y5F3Fwyxwlepf2nzwx3nvP9Yc3T28dd/sctzutOivOLSHWqufOa/uWOH54TtX+54Xv/D+Z77nnhZ/nf33P98p9Wsd1sM//956z/d2vq+wtdFCeGuhoE4av1BjXIrO2asSW7F48FwgUi+plXv9ni0qeQynsoRyrOY9u2JqV2JXHAikgDRFQ+rV4LWSnhapI2w1Rd88GZZjWXS3M6bGYrxDSst1EOKCTrMEiw5FUB9FcsOXkkTAmzHE/pm5JvWmfY+CuMyZKXrvzqWxy9WZt5uibPV9i6rU9HWzNugtuhda0kH8pqPruUDicc3zbILmS411DZD+rUGXLy3WjEKMUaJ6UsjdK1sw08ORvlKiQGiSFNRl0wsI6WKy5SsxM10m2EMHMuAsQgg3LXWiMpHAOZKP5kEEmYBNFmrS+Up7Bgllkpq5EAFHgZYaMYJAA0SC5JWH4EcmgccYGJEYoEh9mS0E+CIBL5QCqTf8gZbrDaCeDoBB0cYp3ChxrB0hQHDELi6MhsLuLDE9Mr6XfD0P7b3o01UnZdQFQZWGNym2y8UEanD8DVYs2iz67CF0x7GJ0tyhmC5EH2r9mlZbcq3LkmZ5fqXuTVLnnytBuM/A1vCnkF7PeEknb+9ZthvWrPc4j3Kgy+3qey3umn7+6O5al+eNjkj7+fHjfi/e1Xu3/5/17PMfwmMOY85Xvd1/1Mqm72dvm+ZWcPy/nMP7jutbwx19n99z7dyvgOcAYAABoyniPNbqWGlP9abcsrmFq6oFKIsnoB3WTLKBrGYwVTRbtHKLPyTHLH/3PfdpRbaO7uXZTauqLtB3qhgeMwfxzEMPhUNsa+JwNxxVDDT1Oj1Bw8bHhRmDWeqoNj8LCONHyqwxIj1HzNr8zzS/09Jpbt5A77r89vO+ezWV0rPO9CVPLfb11zH7FN7d//qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAm1h8uDfMtykMz5xCstbiaiLS4N8y3CK7JnENwduMt0EAtKMEngVHUuEAs6MaShI6k1HMK3G6bILMtLGBn9fkwm5hIAF6BQLmLwOIjKZVuBKAXgeQwOCRIumIh6yReb+WiADMPi0M5UxACxII6jbiGDQIPCEMMZIBX8ht/jDg6GhtDsuni6IVDVNNSGHYqMJPnTKISl3TaAYrA0VmSA0F0L1d93IWOnD7bnQ2+rpLaJg6Ggnkdm4Ew9iL00FLDMsceD7jmF2pZFpFHbxd6YlTIhIfB+52V0mayFB6PlrFsrr14jLIeYzAkner52Vape1bTcYpT3O9lOO8vtRPmeW6r6XLvZmPw1hbsymN3s+z+7W5fepZrVaaxpLn7x1Y0uWP554bhjWGOuTmNXKzcnb2W8K8mvf+8JZqk3jczw1n3lLrDdSZz+/ljTY1+cy/HP/mrBN47UAFAAAM8HRvPVxMFLdsBSRf+7jjtE2Ux0RjAcxqwK1jO+wWBDxYeWZW/r2/13VPTY8gEvgVAZfDbr2MEPYfsZzbjKKWsaNJCJOa3vWMkWrWRMkHdi8TmlihyLPUsmOtaIlRhJJBdSCKwVCkEjzaHrPeX3ratvVt/m3rV60F9Z71u2tFPzq+ov9u5vVrdV//k9OFPcqqdDt0YEAQ3am2yGEtAYSP/i8wEAph33g5VjwdeeJJ+jr5MBgdPsAAI0CDC1h3ykozJhxkuqMgI0CPTMQYX46uSAoSH9Z5btZcpEOJmvMrkFQ4YxFxj0Dtfd1uANNwcAJfD8dDguMguHIHkMkkxhpotI/oNWaplrv9GJHKGkCCF3vht0FpgO6WcbV+bRM3IJBToztUHm61SJykqgoiUXZV0kLnW4XPgIcHl2cNjQ1eKyOVyiakgVGnblyvi16Hct1XGVB78vw/lyXy2rd3E2o7gW98pn94548l9jK1ixux9u/LX1q45VaelqRqnvfJLlyaqdl1bfPrb7nzKVLPp6W935zdbeqak1zdaJc3hb3HbXP5yl1vfMqal1vHnKvcsbs9jcyxxov33/13mOUd1r+VauRYCAAAW61yaOt1qDQr98ACBGumxsVC91K/C0zol4Bu9//mY68gkCK2vsT/71nVkeWcGJapusvBBLVHaljH73bcRic5p6illBh67uoFgXvxS5YyaUPjdAdHFlbExZXPABPY1sqg+EAAqDw63X5/Vk9TPR0bv5V2vVvK/Kv963f1LqtyOe256VDe//+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJfojMA1zLcJENWcQfLW4lqiMwDXMtypK1ZpDctbi1bwh90AD0B5yH5qVOyY02PRZdDa7DAIBMsI06KXzDYBdKyVQEZQZxABHrEYeMhAQgBx3F/CwMl8bgFKAxQSDEI3BwsXPHElSz0zTZW2AEw9jVq5CCEEDwLCgJMPgFEeAAuPCIqV8IcDgQIgO493OURFBKX/ZUJFu5HwcQrG7Mdup2BfBPiAYzi6IHUmbD0v1DqMkMvnRLEbCHHQdGbGT+hjkpfK42NHV4olheljMVfvI8jyXX0jlHdpJWSD0lT+zTcZfTYROSM3pYBp7W4GjG89Yunau5arz3P5/XvufrsGwm3f7XiU/c7appdS3aKxubxuXrFB93HWfKaUVbedxmUH1u8u4//6+9nrmWpN+/1qfw1zuW/3lqU5b/LuGH81vG3lrmd3u+7xx1/MKtTlZogBgAAJ4oBuqCUCD/ki8kqpD3OJjgNPFxgUTKmwii5zUy8CjAhPce3ha1j+vqRruGYkEzNWNk0btx9oyr92Lsjarng65xzo6nrqscJoniKeYHqjqE+5cWIKaGqjSsqRfE2RQLx6y3RHcDOpA7bV8w81MVVaP0Kff0Uvt8/6T379aL9aHszef0bXztxGsn/9lQfnb+N2iMSOI7EXzmmMjmNecxjVAoFER6MrOM2yOVpPrHzTppMCAl6BoFmNA2yU7NAZbBEC1xkEGHiWYKCplY1mVwq0pqI0LKKHqksLAELlwFWlyY44Ch4boyjADBAaBQIJB8TEzOWQ2ghVlVdH77gUYgSWtC2AhQMRCDMTHK+UGpvmLbO1pPNwGHv0Eulzuw4gllE5ONOpQ5ic1dqJOCwOFPLpcstSDo4z+LG1CqV2lI9eiUUssorYoK28ooa88+luYwq2WSw1MS/GvDN6ZqVMnSp6bL9yD8s+3abmt9guf7lhLI9foMsc71alqVKKvnnW5nF71zeVqJ44YayYTzHPP7+Ov/7+fN/NX8+551aPX5/Vv3Nfyru7r+Y/lzH6DP+54zHN4b3lvef/M8dZloAgAAJoKqD4QmVWD2UX/JF5iEd8p/KWDA007KAQHJOKdINHMXa/VbxAGJWJ90kM2b2+Yx6x/ZkoQdlLNMmDIHsMaRi3lMxhWVz+U1KphcTA1O3VHAHPZJcvl7mZqWIEioKxMhpJ2UN5mUXFiiaCxRzqaisLkixi/SbzLqTMPWZLX1pq7esoIv39Z/zB26LVvMPktfUbK882l9DqBrSOG9n2bdjVgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACZmIzANcw3CqDumkNypupZ4hMA3zLcppO6bQvKm6s3OTUZAMUXmy6dpnDMMbJp8Up3GKAyIzeBBecbLxVBa5gqBTQhfBROdolCJiUACgsOL0QHER+V4dGAAZHKkNobGO1UZYCjwgIDwRSSaYgceK0khilX0SgwoGTP4bZUMgUCDYwoA23j8gL1O+TBOboKZxAvp+HgeeWuaWInYSkG6xWHg5AdOLWcWBnY4suMyPKCBCCTSuVMpiYNTI7sjjL9CW7LJs6eWjxZfTde2Pt2l7ZGX9Zg7sflckhtrZQ+WXakLbtSXaO3WgCB43Xpb77Xe5WrDR6TW8/ld67hjZkN/v7pXmorMowyjWdTlrVStnSU8ppZnduUXsMrP6oZHqrrNsjeSjuHf5+F/VTef/UklrLuW8Mu581Qfnh+NTXddzwyx19yrnZ/eV7LX/y9+e/lXTNAABAAATu6g0KqUmFCN6C6kFugkibgjmX9JDxWHFUgkF/QWA/fcKkbTkbuyo0zh4iGrf4ZYxCl3uPKBxxg7qUlBdcYmT3do3DelcWBtzXMCUSOLnI1g1gURPbMGJPcXRuSiGUGs4QBpNxGKi2cceQneSEENWGJpOba3qSJnI3UqZ1KMOaLpkZ21+k5fJ5tnc5ptX2ISRDmlVXMKN99UWqazNB8WdBv/75UIV197jz0g2JCG13rFPABgiULFUC14fKoFMcF8xcOTZk7NQjFAcXsMhthO2GnQHgcn0bsrKXlZ75ElQZkFNYcDJhARGMFyZfDINAWdiRZpKg4CMRuXBYAtaiTP4Pf11QYMkEDAIrKk4X9HgVaqzcSFTigCs/8PQWQUvk2EvY2j0CGyHoHqz0tM2RxqKBIJhhE2pGuIuLzVSg34rSJuq4oZDHn8SWaHEa0quKyschiNNaxaJHcoblk62ZWuQ9lVR9pZKZVDkcbZ7akvnK89UtZZcciZor2WMhz3zHcH8wqYySQd1u/Bdq5et01zOrU5rLCW4Y/hU+peznK97d31pVLOfL1TWWW93+f3tBKatXn1u6zw7zDuW+5Xqv448/8dfMY4Z/+tf+vu2MvzxpoT6WyACAAAk78KizrxsHNXcjinTPjTZfmfupCwFLJITJwOTfzFPluaardbuQChKKfcoz/vI9PX8LqwzRm3bFS9pXxRipeTTEIBc+9mXQRLSI8wjOClCYTMdcXKrD1hxQsKDaYVtlApWIpMhcSXSpZxWBQozOJlpboM27H6ZLrk6G/6nbUb1M+7db3ne4vbsWv1T3/5q87La3Vf6MroAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmjiEuDfMtylK7JtD8nbiYuIzANcy3KbLUm0LypuILtVYKbKMWoGA3qp6FaBg7IGEErlC1Q4AABRAYBGGCmc5IQVAqPZguApgK3rKCConQdDs0MNMrxBLY0aB0NHZGAcYQDhptIGcgMsPqei0CCxgeWOcIguo6UAhp7bQzNipeHQAFwqinDwQCxwADwGp7bRmkiraTFxhVJBJkPRplNEoCw0ZzZPLuSt+jsbnqRrbzRIiPkdFbWm3Eawmq8pmloiUECdvW0GmL0kvpLyOsIoJlVlWjeWXxG7aJUHErcn5hgNPjJplnqfLoxqV0szLKW3Wvbd2/P83TTlS/nu69+fO9gqdrasbdGRT9yevU12axrzM7lhWv2b9yW9/cjzwzr5rh1jlvOd1nytV1lvWU13X6+PZds6uW/5nn93t+3ly1reuZ17eeet2e67/Lf7wwxsEMxpYCAAAi3zrrpAb9cDYxnHxmH58RLmQBB1wvtM1WIKqSse85lzCUpjRD3gQDBp7pz3O51t5fpPFNxqa27N/OUpByzUTUxdBz+KzpcPz2OLEgsAWiZgpo5xw+4lwOcNnrYTGyKC1y4UfVoUCVzSVNfYh6jj7yb/l9G8dbzm8d7yn09Tb6jxnQ8zy/RfT0RdLjqo9v/9OirvcodMwHMPHupG6aHTKmyKDFpaz9PAHJMw2ABQOmqH+adFJYABmpXBgLVXJQCgYBQ4dMiIQJZS3lQRA8x8OIac1WQYAphQKm3ACAQAtyRU6LgYObcqlKXkElAQep+8GGEJSBwQZeXFCBGBgIWAI+cWcSPQGCE0c3bX9Bzygp5tIzLX7UOFGniqS+kWDPMRSU3i9jY1BJbKKeEpuKa3X9nMWxESshl1BOFQJtrVuRziSrj0sSaDNM/jtPfoNIp0VNTVLjYr0vt3cV7TUWtPfaosr3a0ffOLa/kxf1lnVlMKx7ylgilxr1MbOrcxa+zjT8r4Z27f4zWFfPWeVirnlnJF/ynuOOFv//8b349vTGWPdVY5rv/urhj2xjY/eu8xzywx/W+frU/lnzv6zz7rCd4ZUyAwAAEWXeSw5x0HocX6quDKH5FJ1Y5OQAx6HIgmxFAketh3VMlx2JVnjMJ81GERLuvg2WbzrLXQ7TzdoP5m+ihe5dOKXJOS7l3NsCmpruawlggNeeRXKnFR8oyYSSpyNi4bOToLRjlzNVMIwpjSAmMXM+XTkxHZcxvLGv39Szap8q/nf2nqnoPepCTHNleE65MuLuWHkq/0/J5AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJo4XMA1zLco9MqcQ3Cm4nFh8wDXMNwkGzpxCsNbi3y/ee8xAMplvJR32fjmVmdyna4j2YgOYCDIEBRgkQHcxqYTCJpc4mEgIo+h6GE8weATw7CIgez2pERQHGOBy6bblphoDAgBGXTsbLR5jsFxCyOgJVHVFHktVzjwhkTxYtcGB4LEGH3LTJMMCEiDydE/Jo7AAgWc/iaN3pjHye4+zrRYQvq5U0kMkagGyOXYhmXMMFhaarSOErMiXAFL2PLKIkYhYxgIYAddsFWC7bUHm+o1+PwC4UqrUmRfGR1LONl8cIpU3aajTvpbqX5HLL2eEscalv3KkxP6/fzMiwy+cgqUVa9bCDJqpS0FnCzMVJy1hSyuxcmrOr2GtSnG5yXv+y6npOZ1rX5YZ3bGVP2pW3c7vHKi3392Pw/G1f/DOz3Xcs7+qXDu8863/zd+z6tQtG0smAgAADZdKLMs1LDua+NZnl6NFg4sayjplInPLet6C2Tdzm6R16e1ng0yLgor52MJmz+VC8Ss1h/ovusthTnGxKluMak3q7JQAsNJToohyg/Pmkr1LGjij2SGlvKDqPLGOQN6COLDET+d8l9k2Yw1Eqea7d/Iy3MROhA/kKaWmLMXq42Yatzlui7rPq//+rRGopT8bsYjMHgozT2WtGiBEx5+Zt+IeMBHJuZYABVDZjQhGTw2aoLxc1LgRAIwGFDEApPeCwDDVB50XKFBMNNJVVX6iytqH4QAzCRjNNghaK6AsCm05bdMv0QBVJld7T3kbCYdHqNMDQSpSW2MQjIxMAmKSlrY4BLe5DT8Ocm4JecO3feZegRZuNNGnUQHCTXedd+n4WfDtBUrwSgs38kvRt9FbYAZmw9+m6V4w287VY240rl1tNmPy5/tW5eKAadf1bweumyrySUtfllPSVY7J7d6h49Gcq/K/QZ4buZSiLZ5YbjdLnKbkZfvdJycp7/278/LM6uE/rDcek2F7mq+N2gjL9RvcllTOJd3Hmc5/MOdr49wzqS2i3z+2cOYU1evj2z9XPeGX75zHHXPxt3s8d63nnWxA5SssBgAAHTsHT9YNo7867+U1LwFFcae+pW8IcdRYs/SbqagNX1v8rj3O2ASArbz16+OGNRkrVOPZU1NpjYWMOv2w3dupjNoKE3sqixdNlpomSqTqWZoz9zFr1lJc0l95fbSy6FItBa1U0fR+Yo9XorVr39aPWmvzL6n132z7Op1pPQWPc1Y8luz+egdsoz/+IUUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACfODywN8y3CbDNmkNw1uJ6YRKA3zLcpvs2ZA3MG4YAutFEAhACDTBdRLFjCt7E0MDHWgug6b+O8oKY7PIhAgKDRi43mTWMajJQWS4CExMDxYAmagWYUfxzZig0IPG6CmIJDwdKiABzYQAFljIEFiWY2JZpxGmPAQEBVB9ULmPswEHAwUBjFUBFdoC0TBQ6UVas9LIGKGHwUWXBQFaAqZhRM3S0aHJ4hgYmSlFFLGEhbJk9yglmYMnkb+wVPPuTAS69RdXgVhfB118m5IE5ZDcidIZEdeahyg2nbyVaaq7zSLVSW1n/Boc5G8cadp1aXZymC2nVYdpIzNz2Ou6aJLc8Muyq5llu1D2HedwhzPvIi0mglWdnKnv6zluVjHKrS2IM3ymzxrY4XZbTp1Ustmn+jzw67vGh3/47+3/7xynO87yxjjruq1r8scctf+taxx/HVnLLLGvUaSWNitAABAAAN0lqOjtHXWoIJL/2aVZIucxEJjIBp530vAgTrD/rWOW2isWi9mSXoBhp7klFdUjZYbub6nGqg9ie1innBYOfLlAsEPDlFpbJLcyALiTtVTL5fRZSx61utj1E0kiUq3nUmlGSB+SudoxZBdS65qtJR71n/ct/bnaVP+3saX2LPt6n6iY9TypbaAnAelqG6XQVzGe3/15fKx60+rnJ6GdsQd0L/jEkKgCZHDjQzTQS+k2ZGSDNWrGCgiYgL5hcsnNUAHAYSHwhHYWIpinAHpymLFJCF56EGDo0yCBwBv8y1DgAB0XaEYBMTANZcYBwdc9t4q4SAcRBkoAgFA0HQowcJDMA3dyG3drEoXV1B967HAsYURSmqSBsQKsSgdV63+cgJHEiIVAkpQniNhercnfmUQFh4hTwPL08lBYarzi5C/hMHCKGkbuWyczJz4cpEVJZ8rdVWhc9aG51faaZbrkottLWDhGsLd1VGenJ3sMRSexxv+1uKZ3O0kV7hd1NtRr8sbrRW3bt5sJnL287dFa3z+z2HfqTEr1hn3stwr07W031PUkdcRnBAA1K/hcsPr3PW/mtfnhhDu9fhU7z//+f//jl///f/DDCrh3CpT3O3voWjO4iSqW4Vg3LeiE/LP9r/7fjEN6FpZLXJRCMQQFhi0CXJTdSfb+X8ouvA/UDu9IOTLU72EynQqs1Bx4TffYiHllydlQwOs6l66ajKiFnyRTQ6yOSoUykzvLhjmchhtmiyypp+brRJ8+o9plIK5Fp6xkf9aHoq7q+g9aWr09VRq75xtVbd0upRv7l26CiULr5OUdLnpB1T63UP/qxZQwiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACYyHyoN8w3CrDPmENw1uoy4lLA1t7cKLs+ZQrDW4qZR2UDAGZDWgJZf7uD8GlGzN+ckYEGhk4bs2jYXBAsJDDrlVETBx2wsFTPYkMxfg0uTgcA0uG7DgdMunwwqApatBGIYBgOCbMFEUBTfCACJZRjKmbQqioOB7FC2KqIVBIQfmQKcujRlzEFKtXkYEQENnvpdKYlox4sci81EEW0y4Fkz7orpyq5mH1vrQgaX0tE/CPilcUuw81hm9NhVmmToUpe5TaqrQliyCu+jSF0PbalMpjEhtyyVsTUzfSe3LIceRl0/MSiGG8gXCvXicejV+vUlFLZyqVJa70p3lx95bZqVI3DEao8/ldzL951Od5hhcyyt553Msq9PF3to7cYdBReAWszNHXtZWrWFTeOO928Med3h3+953n/+t///zv//4Zb//wtd3///4cu4h16agACCAAXGrUDiPOzqCMtSOpK4l27BkPIvQl+4DVMEpBFWp2a9BSJCQ3nLMaz/1IYp53kZc7nzCHe0owsHbrsIfqvWj65ExuznugmX8BOJsqtZkOxFk00TNB6i+t5Sc3SzpxJGoqLo9GUPA21URHh6OmKCkkv11vUta0n1KWi2ttTrdVaZuatUm6KN7o/tUpJJNNNSTtJh01RNz7g1QHY/QNJ6m/+zjiAuLicGbWefGZAtyi3jlbCiQACXc3lKQCgLqZw97RjBwwXEEX0iDBwQRBhom4ZkqkxA2zKAYKGCMJmwivyGGll7zFwZez3sFaCpbjSyuWKkLfhBiQALARAAA0HR4b+cZmBQND4tM+TfUkYVcRey3n0J83qzQ5yiL1gOBWBhlaqj3DDH8E4HKmnbOcirOlWB+J40Q4i5MSoJ+XQvTK0GUhxKav4CgQwxopGi9qNgciFgLBDBnhMyK9dq5SwV2o3zqE8OBUJxvmankGEw0WZqaheFChvcOTNaDCtqWJDiQn1s6zDlpnG/9br7X9IEuFQp3qOOZXHGr0aulc++faut5vn5185rW+f/9/5pjWPb6+/vGfjPzT6+vrcLwNbj0QpYABAAAFDbAPlnZRIDdPN46XfMHCU3llXcjGkgKTNpzOVtPZbM8yl9aNcrT9zJ6IVyv6K1Op5rsPNZiO5Q+idBd5Zkt/Zkk5zAzqaNqx3ubovMXPIscTdiisus5qbrWkyRqse6mHchUp1CPC4InaaBgif1uyLNVWu7bqvdTd30VKZanWroKdS1f7OYpJLSYuHTUxSWicNnc1osKGWsHo///amukAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlThsmDe8Nwl0zJhCnxbiWKDSYNbe3CwrZlgPy1uFBKucy+YHQk+o3fgAqM0ASOiowoIGlFKYjoNaJAEyWRNkCXgdsUADT0k4KFAhQTCatj8mFwwCPlA30zFQkwUKcePOU36cz/SFbFotQYyALGMTAUpSQEMLKmNbXwFwcyU/IjV8V9VXPrVNzFh2FjUBCOdsTELiMgrtKRWdadbmWnTVfVtHYZgkTTzNp4E6Ba0vmHDTTRWfqbitZpjTlKYrQL8cGMx7kBv/H1JPc+DEi5tM5UUWEQGFxnexvvvKIV3Jc7hODclkw4kvvapHQhmrq3btUtnHOpHbHK9Pl/81LK9FzPO5crdzrR2zjvVuW4//L8Zmn0dhw4ErVnqhyURagnMfz/DL8NZ9//y73DvP///e/53+4b1l+uaq5f9yvz9/qZpceValo0JEVAAMAAASeoXCu5wGAVfKo+fQ2DyOduUxSAU9QWxqOCdcQXUs+U7I34rIZzk9i6BelWXl+gu2SIoTGirFvV7FvdaLB7pqnU2QA2WtaeipAuvck3JjmDPmZukVFzx6rc1BcoIHyCDhKt6SWztpmbabo9d1J/73rUktZmcfp7p1siumXUUEETJ7u5rBIOnYFcTaCCW///dw080xmRRFuxAhOUceNF5ESAzUhVit0UPbcRlgOJgQAGNhIiDDGDY7KKB1gLA4GEBwMNgWxZqDg9BOY+OmYmJpBTByGkOqL6hKKkXpzCSMIF5YriHgYBAoGaUywwAWQCmJiQWHWWvsFhAxAnVwrl7pQXLSnfBzDrqfA9YdYfgJgTcR0L8TMsZBBZxYSUISAdi2rkxSDgfzyTRAkMM86mI1wpS8C3gqBMAUg6QIagQ5NqQvxzVEEgqMuh/MTEKa2MCocFKngfBVhEj8SZ7KlGtiowqMODKmGFRo1YhsEZtewp6yeWBBpCpe0XEbPrDe13iuq0gQ4r1jk1XPnrHv94baMaiVCeVp2sqGKlTW1nOLWp9Z1TOvf6+fbGdf/717f79a6peBfeKUjzx7oQaaHH0FA8pZsLD8ayQbf8ONwzUoHUZGhs7j7TN52wkxz2nPOzzOtAspgWG5yOPBRtccTPTPMYzdnxZMZFT5QEQPg8ClaoZzjgBi0O4cUo8cXA5F1aadmGCZ0jRAkKdGyCy4iS73Lt1LRL0pJSkUXUpIzE2CqnDMds6S6JtWgizu2SVbIvuipVk0n36lWa13Wmqp3ramqaMozm62TY+ZF4yZkkzGpt6SJqkSDrkkX31XfXoGe6kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJxYvKAzx7cJ5siYQvLW4l3isoDPHtykq7pgB8tbhx21eRbINzAarQX/mAwVM8LAqwsJBQatDzLnX6YYEZiI+Hv0uZ6EYsDgMDxYEJGGAgaBQuYOAY6AUPUwUf2dQ07LkI+LWbGKgUzceDRo/LQJwGAQbNLpdKUBARbRBGNABaKDLviAALvWq/7YwqDzChQHgRmbqEi9JCnizFjZzuFKDmJ+YIQUJYFAXJQiHASxGhVCuqghJ0vG58eTYI8IUXJIn8hphKKIMc+mM/XFUG+ypLbMnUtDF6r2c7ThLakSsVSCy3xlAxH44FtTyaONeFskUB1vYcFRUZJU4qL3spN5jRKR4cB7BfKSJM0r68qKQHZ+2g7Y2+C/eK8/6NkTT5kh0b1mLBpLBZrzWkifv67+n/28/iUiXnpAgy7j48JkrfOoceB5cXkr4+pPJmJAtuTUu5HPN6/48oAIAAAAjWrFijpyDJqNQrZwuULhLZO0BYF8ZFaJQy5ceksZs0mb9ZTuU7qJwCVHAiSQUEQk2dq6oIkr1r+WGdLR3auS4IBnsVKWmiXgQk3RR1OO0uJsxokipBaKrGMkTVp+upBClj63ZkAWZ9IrQQRf2/Qaigi67ILT26t9Tqoqrv7WWt7WPspGktjFR4isuZawufMT6CiRp8g6K//5WGbEsiZkZrz1NxEFTVpR1ba3ophMiEEIkEwTNGVox+FgEIkOI8AAuBjEwEIihDELZanKLBaMR7JazxxSXEAAMOnw82NC3JZweDipYcfiwJDZ2WBl8lQs1xfiFP+jVAiFauzQRUMSAImotqZIOkh3FghERZOqknxfyXmihEYxl0ckclCpgOVHKV1c75mVDaIselTKY9hyoWdTGokOQMFTLx6wS+J86lKmbrsxGBeS67V7xCuZjKW5Fqc7i5sKLRiIVydrttXn8NgfR40OWOzMkGC43sxvdrR+ubDHcG1THMljlRJPdtiojR5Dtdq0tqGKGdSsrqM9w7s+ZrudaahMFH80SRtph/aDAzi8OJfMDvKLzGx01Dcp42XbZF1DgR771FraS8CJjd/BlvWt7RFhQEuXI6Ch0ZCfO3o7cU7HpEgpVGpS1wOSkfMqsz8hqcrXdTWKqRjwo1x+LwdlXjy2Vt9aRLKeltU2coht/5UseR3oMsC6NnZew/KTRc6y0tVcpSI9bVanUWZ1+tQ7wVRfQRdav/1rUp66etTpIq01vZff/6qqnd2ZlMkkydKtVHtVSRQVqQWjfq6bLZ3PrDxkU//qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACWGIygMcy3KW7ll0Iy1uZmYpJgZzjcpmOKXQXLW5d6Q3bZVwlE/tA2BSNmS33Bl03MNHWjEmIGYY0bHRq8F6qoJhmGg2Xtl8NsCeJi0YaN1YWb8sAFPQwiJTMkNN5LQDIoFAV1JPdkoGEkAP2Kgl+XaqV4YnpRWVAnIYvLBkwyhq6OEF31WwSl1Ar3MQfWFOi/bhzjMnCrVoDWJGJff3nVuS3sMTPaWKxCXQ++0puxGDJqHoD3RYUFLhMPfKJTVld6V4yau4LauXLbVa/cga28T7KWvnHIIjFTP7HNQ1P40lNvt25aufYq1LGFbGdmYdkLS9y6RXJujporauu1FKryUFWnlsNUEsic9XnJyn5ep92dTPeY3LVyiqUcct4ymz3eP/nvD5ykopDG5uUS6YsUsg1Y+tY/lWtlnflVmlr03bszrHvKtnEShFggBAAAFo68V+bFVn2/n8v2CSYHl3+cgIIgg61nSTeULkl/5/dXV9LArjfhNG9vC6XqUfedfVLfgitLcasAvtXdlNkvvedBHUzi9Sh3mrLmIko4Cgmo810JJpVJ+cNlEs0xP/HaF8WZGjrRVr/0ls96ql11Our/X/176qS6LqTapJlrdlV+plbepNzRbIosiayzFUtUqXe4kCN4CsD7QlD4jdMm0dV+YzNXVopTHf7YCmilmlSBAOZRAZMBmUEwBQCtMf+LtUdp9WOwhMhnKSpjolmMpmcpRpML3NrvyosMAWVMFWLTxt5Im9kWd1+gwJvIIQgY9SRyUXjwIQBLpXUpysPA0dRQfpsj731iStlNNlhLGyKFJJ0dJnrUuwZVKKkerZRvVPEojHad633n5uVcjMB0jxN2sQw/z7RDU5LZLDUjfpL6LQp7lltDa7LIU/Ntfz+SyZjE/Tw5NTcYuQ/XldajsUOVvCzjesVKlqZcGGKsEt0dx/H2klXNdN2A3tuWYLqSyI6n45QY409X+V948wpLGOrt21SUFzeXLvc879HyxrlLjnupK7MarT9mUzl7epTLZDjnu5XvTVfnalN2Nbzw5Q18crofkAVUgABAMYwszKSnf//VWUQwYcy9Lb0NLImHlt3rerr+R6epbWpVjBCexgOoGurI7mqVGF2W3enmV+9PY5SVJmmj6PIAKByIKOIAlkGTSZ0SRSSozU4MGS7n1VLWSK6Z/fPKJFlGB/44ApUDY0Nkf6X11JJobts6aV6+v7fWrd+tNJ1H6STetPSsgpa9l9dkFLedecLo890BvQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlqisoBnNtynm6JdCMtbiXuLSgE803Kbzql0F01uHW4kwLOQQT0Znzjj7ZyikflaRggSmJPOPPwiF61UvDCIABQDdF4HegDlHEF70kmtNzYKkgYPA4jBZg+KERXAwccGCI2DhUttrjEpmCYavunG3rlheZ73YTtMeVTjB0z8XX/LVMo8rtnMSfiUKZP+smEQdy3jKsqGGoXM2rVSEVGE0lefy5LN8isF0k1KHxRlJAZLiAKCnlcmRYkDwUFBfmIpS35ymu2oBQSrYSscR8/dFcsNP7amYnL6WVymYq2blqMyntyru/G8bdLcrXpilk0ssyHKLxmCJxgkZlECu7Q2oaxlcTkFaWZTjlUWWse3aSX5Zc5nT54U28869Hq7jYyp5qC43Wuxy1GI1RV8qsx+oazwqVs5dKt0+Mv5Xpsblqzd19Smz3ve/u3dZ6CKroAAbNWiZva74Sdf/5aZ0I3RqCNxwdFBJcZmb9q1uVzUD7sbeHCPOQlqbuxzEU89jNK7lb91qPGO8nO8gte/NVR2At5czECHQpOiuNDotYyTOukeQz8fnov603JaoyTTXpDGEvcmof/rr3SvdfsmaNZF/T2229NloqQqMlMi9SalopoP1UFKSVdPrZ60k07pmSzdIBgYcc2tgH/lULSooD7GKUPmINDZyG38mpZSrCAEGmZFSfsbRlACL3JQUPF0SAUhW4xaPUUaghqU1I8Jx+kECCRxjEJ6O5n40oGAUA3QjoQNB0CswVPKYLpZnCYe2Rhglp51dSVJhTQkOPK7CC6FbE1NJY9yvXsu0TVpiJu5+G7NbHG8/dHWn8X05PTEsfy7OXH7m3wgWG70VvSdJFHx+I2tJdM4+0ouU9ezYh3ccleUOWZ5ykPXKYc5zsOZAUDRm5Py/Gct3tS3vd7hmArsN37kolb9Wb88+EDyOnlb2OLH4LfS/WaVArzt9BMggKXTUv5IJDLbWFFbtUOe6eWzVXLWqfK/eu02FzLCv3udPubzl0ZfSHJ2VTNTeU7TdmY/RXO/K5TYxrU9Jc5qjwt39VuZ58z7vLG/qVpQAAAAUzqtv///91LYWEhmh1Ii2MQirEqo7WW45fhWFn5Jd07S6mYGBogJu916uzKq80ut2cMre+1XYu8vD6ajlGAWcAyDcxVudEvTSqUzKRWUi+fWqO9Vz3rSWi0w3da0gpjcx//VqRZVnuyrM9lt0UqepTr/Wza0VmKjRE4mitdJJNNSluydVFC+vRtqak0zSN3Y0WXDLP//FQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJPobKoTzbcqAuyXQXTW5ldiUqhnNt2nW85dBdNbggAAAAQyMItsmXJGERtISymM08TkbuEIBMCCQ0WjzVwOBwjQmOEXTRkU2a3GZyzNPdIYXSxuDlB0912BYFmUEqdyE5ikCFYIYkFQOVQC+axXU7O1r1SQqUq1M8fph7eqKxMRBR1rOZ4JISZVN0ckd6RPu6kncPO1jWyv9r08zCWv6mYtD2NSmk9bO7Xn425UzAsthuha08K4Hjmmz3qaW0mFWvYu2Mc5Vel7oxZ42UpesKUsbm/kbtXYzanKsWx3V5Xtz2UgmtQFVlc92C7Upr9h2Oyn61HUxm38h2Yl8pbWFy+L0MNalnK2EZpvpO54cu2Mqatq/2x96rM7v4drfnudxiFy1WrwzGopQSCaot02VLEbdT8JJeprFfWNLvLW8u5V7bJcdwHVMSAAAYNBxUzlezJ///uf16BZmPCIbhtHl+a8ur7wiMlk9SnxhvUpgWNLKMIlMhaEmkPyhWGGGPN31flX/nXya7XyuTEwA3grBLCNlimozhIOpBqTOyzyQ7jzMWLsj9lo6TVqSUO0cDoG3ZVv82Lxibu5uyCKC1afW9lUmqrt+u9btafPIGlkne7szL7spSS3bRdHUpVNNay9ol2G2n5fiAAAAAFol9YpXYy544u5pTTfWljeS93BwCmDlSfEWgkZU2XIdSMvQsq8/N+NM2f+NRuWOy4z+OOrscJRkVxHhX+ZnDrSAuAmZrrdeduZzj8QDDsDoCLK42srVm16A4PMMGzSJk1khdprMzlD0bjLs5RiR5Wsbsvz7zPVVojTGs0kzUkEajUYoZ2mizqQ1LoKl1HdnqBlUPtKmZTDN6ditWLWY3Yoa85O0MfjL/yKKSItE/siqUV6dlE9jM2KW/Wu2+54YbwuvFE43jPSqnmKWvDL82X9d2Jww/kWv0UEXHRhLnxCQU+dNhbvWOUlq3lq7zVXedLL6Wnj/LVm/TZ0t29jKbGNPHMZBXzi0TfyzMWIxR5yiz3OmsXa2d7WNJ3O5NUtPhemr2F3ZBAQTETCAAAmILmtWqf+47z3xu4oLCIjmvWoHdlOeGtxKPz2M9ucwpo9PTCqpiD58AjDKJb70NCby/hXs7rauPNrCs1MdoAugcx6lNFa2czJ1GgxitN71EkPdRJH2pevezN7GAyZkZLX7/1qZRwom6062666r/0v/bUtaa7nZksuGilKv0tLTXspbrTTWmjSnlrRay3ZJBBFjdj5q/9e0aAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACWuJyoD923KVTil0Cy1uJmoxKAT3bcI/OOYQLTW4BYLkc4oRHhoLigsGRWFJNUwa1L6y+BIBzA4DTOGKTJkJUdkP05zAMAmKROGo07uLfUtW1QQczyBnjbZgxhmEBgYG5qaJZhKBYcDLKVXQHBNHT3mDRqXv6sKtRT0SVol0vWqYACoXGq4hvBwLDkLl0zGpJEt1qbKpbnamFSvUrV6BvlNHbgaw02m1MySbiFl2onJKWW01qMynrwr8huJ40NaCYtfp5ZG+Sy7yIRp0YQ+Tq7fduilT1u/Ut6lmVbKcn6K9XwsRim1d3Wo3+cnKGLMNR+UV5RlGYPjdd0auWUc+jiM2zlmMGSGmu1Ldu3Yr4U/a1r69m5MXrWVWJWK9apZv6xs/2fvW7tampsrUggyM1Y9GbcvlksuS7LGfw7jjcvd1etUt7lyt+GVQvWJGAGABcrnZv/8f/XcpqMGOu8b/AYy1MZarahmCabdjLOt+PJc/02IuAcTKH8U6g9mUI+h7zHmrO96PqdEiAkoDyG+bL1rIqTOyqD1urRJEnm+z9a5drM/rH4YNSSt//0VO7mJdLxcPH26mdq9B/uz9al+talWWtnQSSPJoOi6lXb+ykdFTO868FSajoemxMthx//MtSLK6cAYMrqTZByRxwaysPVSTLxNsikw0yMkc7VNsIHIaBkwXBkiA1sym8VeWH4699SOw1D1aYzYc6wgA0SBEwcC0zGVc1VIMxZAFPFA9ZEWW3Cqe9AcpXiRAG/7YHHaIwFOKwniowMDAKgzunAeOVrwJKm2hEdhMVkuVLNXKf9TNNeq11jFpQUDq/ru3LtQfvk83sIoJNHKKGYb438oXTXfmo9+Ffu7c/YiMol8xcbPCW4S+KP+TAa3ZypDLLHHjeN2c7u5H5idu0kNTtreVNOTteIz8hXXPULkxiGmU00w5DeP2/0ZoH7izjXIdrSCD3heCA6OV2dd7hzCZ5zv0m+yi3jueoLtu7ulyx7Zl0Y3jDmdezKO//I5MQFL30lkbprlvPtzmd7HLPLLPnf+5lrmHcLyijDAAZAhbPfpb//e/uU7WhR2Dl7AwSBkNi9nurLpneFnLW9flVhiUruM3ADEDFFOqa7FalT/qY1pVhz6SjhfKIGwCgBVzJk1oDsSW6mRdSa2ag8uGSf63nNf2UJFJU8//7putSCnWiXTdNW37Kb/XTf2empkVLQRRuy1JGp9Gj2bt/6kzdEkbB4TTziWv/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmSi8oBPdtwlGmpdBdSXibSHygGe23KUTvl0D21uCVHapxC0ojIROEZYZrzUV5EI+rsuaYEgoYjKOZuYsZrAAYUB4EIAEBi06jd+V2sWb2JFHZdVp4bh2AIuYAAXTiAXTMQgjK8MQQCyFy54kivIoVCIdc5vkKGBrMg23WWbFUeHdAIGYUKmVM59UoZwDM7qRZkHIbl3y6523Jp+zlVmqCq/tIwFDkhRJoffzl2LUMMQfFpfOVHfp4w+inTJpVLIak8Eyqxu9UhuhgLC1R1nJgaNxp3WmzcPxzGKRCUPfI61bK3jWyq2d1pdSyyevYT0Yno24LJW4S3Ge3JqtJL5HWopDQ1ZHDF2Qzc/Nzdu5NSuN56q50u+zlvCz3L5u5hV3Y/HWGrEloLVPT00fgmknrErl92Uy27yH8bkYk+V7ertzme6tLX5nVy5j9m1jqtgg0xAkAO4mCMymr/+X6/ffzkz7kgU6kgWMAZM8tWpndyfnmOqPcb3lvtA0RiEOBUcUBhIYp1II2eQMjyajUlBbSo7KZi8zgVkgwNg4MBkuhQJNCeUkcrrZSlqlsyKRXNH/JvW/qMyJOmdpIf+1rO+10S6W3Ih1SHXdcMVkpuEQ6iJROFxfxIkzGAJQYCriQZmFZ47/9QtelaXinE46h1apEeSy3G34Ys9r/JWhwAxgfArmFitqYdoRpgKAEGACCoYBwA4qAJAbSrmUlavt/qtE6sGw/E4s3ymT0DABRgTghGLKG4YQQCw0AWpWKADEQADjUECvvDTTS7NOpq3eLRF677d5Oh61IABJj5YGyKKSrHfcedfeBufjenYjnZvT9d/LEGRuipoBMGAE1KL36lEYiLiu1OYvA+u9xB5l7Rp/K87S3XhhUvlM3BVeEu9TU92G4yx+/CIs9E/FrErsROs09/MMvk2f2KuqbGbszec5nffV0X4gF0lzNEbSV01aCY9+NS/AHewfN0ly7Ujc1QUfKCnnP1rV2rauUty39yXUne5UmG7s9YuY1NzUZerOUYSydpdWc5bPUVLeucmpVLbmr/4cpLuX58uqYtghpbYQAEDmG7alOf/r7vcMbNpMA0mDSZBSIwjdy3U1CpjHdH9FlrLPcug5x48nkDBdEp7Hcoae7vWt7gfHu9NFR0AqHxPQCSBG1uodqbGqSltaf6ayRaiMKf6ncuJVfSYbLmL6/+66aC9GpF3WkkYdv/+ja7tep6l190UWNdboqduqvpaCq9CtZix2kcTUZmUm92r/0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJl4dKAZ7bcpdMCXQPcW4ldhsoB/ttyiyupdAdybgANHXlBtfkpuldq6cz9mXvThPx121imAeAkYfSZplIhYGDkCgYWwG6WzP0spNYtzcik6uWkSt+nsjEYgGZZczt2jAEBHMDQOMx1gxDBMAaMAQAZznHajelL1vM4QsA8wtc0ugh2n/ZjE6ViylS00eDK447+PMzFVRsPa3VpKfP9V5VjVofqRGGWwuS/UUpkygoHhwPPRmoxl14k8Erac6MFVY2+sfhUxUhyAt2qaXvs/nJmPROXvlDEjVNm2lHK4KfqV1qa5y9F3Bf11WnxvdnDKc5nqtTyLcoswDDjlSiT5uzGZQyF4F6Uch1K3UpIbiEcswfS4R+Z1cy+xrG5XlFjlXd2reyu51c/xq3Ob5PYWOUUqqYXpTKO1Kl+3ezszmdW3vtWpUnau7OO96x/XL5BYjmEqukAAN3SGrXXT/7jvmVrcMQ0ZhQo2PEiT2h7rGERztedyrXdZYVWfyGUu4miYMKBh3ArX5uxn+subXp/PsoyQMQ+5wjRHQqYAYFKIDodBeitaSjy01myiU8xJzU8rdfoFAkaN/f31oo13ZJTIKvWiXTdP2//U9kUUC+63oG840SSDjZmOxKoJNWCg0DA8TcJBGsklX/9YEaPNR/iPd7LCXoO8QbE8517X6fyXpwmAOAAYPw65rVDFGGOG2YGgA6KroxmRYS6q91d7qsekMhvvpHXZlMMxEGgBmB8AKYIYhhi0A4DwOwGAmZ25FPVtxBGRCQ5M/Mv0vGeS9kUOLtfp+2SrGMSRTMKQ0YOR6bK5MO8wwu0tFhTY44v9nLKW5MRBwlzLyAQGxaHaB/ZPIaSNQVQX5fTt1U9LuSmdk1HKJqal7+x+NxmbcDj9s0mWjUFJLI3lzGWWZ6VVcpVMxRh8X1VnaSpjYrWsJDT0tK3CT0lmxT6e+MvqlxBschuvT0XHpu7lNq9Zz/LdTDV3PDOvKJyxjf1Ys3K1XnblbKzu9hbkv6gy3bi2dWb1jUqXsvzpqarney3U+zh2mwvfuwPecWrEbBhACAwDd8iRfv959sZ+yIRCJywyBg9ybtnt3rzx6jqTt67znP9jN+U22lJXoGUkds02XN7xgN0cta6bLDjT5GkBIeRoEZDBZDyYUkm72ZJNSrTNXpF40qWXdVfQKRfQWp/29e6m6lrobLZSKBff//V1dc2OBA4BiDwn1tehw5C1qMGAAdWSENlNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJdIpKAZ3TcpRO2XQvcW5l1i8oB/ttwl4v5ZB9RbgEDR2CJQypXJ0pMO1LkHReHp1/lzvIhLBwIGBoKmKhlHE/sH0ZMmHINAIJUKpfKntkdqtLmpVoGkrF3erQRi0uZWyyARgiKkUaQqKYUCFMTLYHphb7QY0OTq/cqnikiZApWnQulRSytZmKfQKCjhoGfTmFGzunBNXDOUXsrsmq0ecgsuk/8quUtDBsywUmNw1RQ7i7MWtzT9RKiu3FYZ2vFYrWmcZ+pqZhlm76S604zjuu5CxWoxN54zPUFrDdqxT5UN3UzADE4EpfqY08biNWmrOy+2Mvj8xForEbElsu0lsqJHxk9qzbi1eESrKWX8rPeawvZfjvP7sZldTDuWsZVVy12/l3Km7XiV6XRyficpr14fp705K6k9uf7O6x7bqX6m88b/cO49x39zG1MOmdzCAAbwxZtPbDmOn97/fc91b0GjoQZ7NBjGyaBa3MPhytarS/WWG/5lSy7F9aFVJxyzqAzKx+HOV8Vfd5hzBagy8WmJ0gAz4BhAFgYzNbLmqSFZzm9u11E0Uz0y1/ZQ206Sr31JeyjSk6SCrVrbZe5km33+/+hROmpPml7KXWtTJ/bXqRV0kkUqlalJNosdDKPM30kBCY0RrZ8Ww2v2B1C1F4rKpBKZiXxhVcwBgGDA5BbMJQIIaoWMDEBskAETRV1IY9/HWbm8EQXhXmI1lBUNPo6LPHfEYAw0CeYIgmJigiFhgTbeQFbfGOvk6Cj0JTnetpMmU7eJVZ3UXYy0l7nnWU35iIWYpCizGwyH+cpqeXd7R4XblmUPThIat2MxuXRouqTDSfEekENLBQLYoaOUO32vEpfKs9zWU/EpvUFwC1JekLcpcrDWGOxDF6kgS323SXOb39W1h2krMBqTfb9NL6SdhEswjN/GVQA8kbpqSHItIY49siVkUDgefpLtivPyvOkrX+fnax/WH6pcateUUljCxSZZdwwpKmdSL6jVJViFa1Yo/klWT6rfv6+FTCUZ8+VZ0WOs+57xz3+NLvn2OhSgAAACp6Epymf///v8t4WpIVQZnbw3mgmJRmarYP/2erwrPWFrPDsQc+pXfQHBWfgIgRKH4r1/1rOo+W7mCqSaCwvym9M6UQEEAGCSldrF5bpzumk6Sqkd58gJXKOj1LVL2ltq9nrSUySmrXTb3W7UEjF17vV/st1NrdEjTAJHQfLBhLH7yQbULOCJOCIMhcWBwtFjn/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACS6GSgH923KYDClkH3RuJaorKAf7TcpSMKWQrVG4GWjp9zKxgiWiOD5kvHlkC092in5Qzt4hCB5ggCBio0B/psxQ2hEGSA1e6xL0C3G2nEuZLLZDJYxclMvajWcpU4YAhgGFpg4Kpjsnwco4cDDT7L1zK+og2F+oCf+aeRZ8POTDyOj7zDWWlt67JgAmIjg9dNFiOGN1rdjDHGxvVW1L5RNUkrpcY7EZ+oKAYKPUN7M9jDUQjFFDk9IJ/LuM1nulr3bEzalMFjgG4Fl/o+wGHGaxp+oxu1TSr7PJZOZ/cvT+EdYCoJIKWrjZjFyUVZl/pVdlMrktPAEDUMayxjU7GktnMxqSKa1VpZv7eN7t/Lu8sc6lLju5Gox3mNNYzy7Uv2McbfL1LMYfAFFytlXlV6kkmFi7b/ePMu18v1/8tXiHh0BQNNogAARMFjlEZmpN/3+vz5bsUcODpkeswDw5D1L97cMXZ6ZnMaTm7/dPRFu0tsmG50IAg4CSAq1Ndw3T3v3hoHjZQZIqdWZHimCRMDQCBiG7LWpTKONms62f9aY+hzGr9dAqLStr/c51JJP03dJSSvVetEwb/+tWzLRopGJFSfSOmGiooL7FOaHTyhU046FSQjn0Trf9D6iYoU9y4p+G/s4XVNruNFLL2EJtve0tjSS4UAwAwiZmaoymBgCyYD4CBZFL6OwRMV3feKDYcgqAY/LYEtKptBpWQwAIQC0y1dmDOH4Y7YZ48DcnBIpxwnClySUCLeVvgZsreMAcN2ET29pYLZEtNI1ba0jRJD3k24TfJvGT6736/cYpXpprlDvt+1QPUIwQtGgt/4vFLUspb9uVQ7T14zjO01BUmcJu7Rw+4IEGswdGKM7dBn89Jp/djmM1an8a2W7GF69hdjzL6lLq3NUkvisPS2KUl2lp6eWS6lkrtySSyKvGFVlH4vUryzu8bHaW3l/cfs5/hjrH8q1+WYYar1bmpdjN3aluer1ohFZFWlN2pZp5qIyefv3Ku62Gdi5h3LKkr27Fb///+5YEX+AIEVQTAABJCVTmMVvp/56ywvYzVCyAwIM/f9CmHpblvKZme8g7sN4933JjEi+tHQgAn+4JaxSmUZa5njjLf5gg6Jukwe2zvJg6VRDQTTiSE+hUyaNNSEtuc6vRY4M6fQV62LBrrb/0iaZ1oTZVJfsp2s31Gb6//61KUtTKc6VxOFXAEf5BQuePILnkmA6VWFgmzfX/sqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcwgcuhHKNw93CpZCeVbl15+yyG9o3DwD8lkP7RuQACAAAAAknZB7OiEDIip3Dc3VicYZWCAEYbIpiILHUuOePHoKCC15Bfi+FDIqZ98c69alpa0pr/an2wgwBtWAoGELyDBpM2KlyrcjWEYskTKA+CuZFAQQQIwxH2dLhNg3mGUAZTDnmS0j7KROa0JaRTN02WXUkEjcMghqwqk+m5sktygxuZ2QP1LSSUzMUQvyMkVzFimXS2ozqTpHk1tZegmkTIuUg9M1omx4+iaMXi4TSZ1FJKaragXhlicdSKDadak160altVU5qkgkyLOtSkklMiasi61pIL0C+mgpqRlhRKXaXoCLTSAAPIzu0oPol4CgKDEEoxbjFW7MzcOLnBgCMMkMwoHDo2LPBjcHAxa8Un43LdSe3C8XbmalLZ0qjG8etbVmEADWon2Y2ggKFlFcqSSMy+DMIYpRxlIag9mRQFylwfCIx7F4iQigdEBp0AhaeUFmDoKWt6dQ8GJubn2TJlJAmi+CABg2cJEnzpsbJLSQFsK5mkyB9almSSmZiyBQBiNiJl00I0nSXSM0nTpILZuqyaRdGVInTNaJePH0UETYuE0mdRSSQJ0zQkwOcI+Jx1NZSndb1/2utCadTLdFc5RNUS6ii6KaRotSjAnzNBVkkukpR+EX7RsmAAQAAAnCnmps10FHU1Nnfpala9SxyUqoCormCIemDkIHOYAgoMUs2Wv9II3BN/N7otJs+SrLGtS15iLjIAMTcVwTCcQTJ4AmPxS321GHRm9UpOlM0LxFEBAc4XzEiJNmgyRSDiQM9DAUflAxSnkUDq01J1LSPF5lzI6brMQSFjJmi0kkTY0SQRRSup00zVzI+kxuNUNNHsuG7nDdR00aiigySDIOi6SLKPinEg9Zu5LOmVj5AiZQPl0xc+X6Ro5us1FmlddOp3ZFqqKT0WRWta1KM10zyLqUzMpJ1rPMmgbJXsibOKJKkl1drEgBkkAAW5gnrWNF36SQX9Kdv0uF/CrNP6o4IxHMCwVMKnODQTDAhVc02GpZCsbVWipocu3q2VWCXfq0kNCwALqW4rgw5CIyqAxt4xbnspbBdPhGSdLJcNiAGAtBOE2YkVHLJwaQjIMtgbp2AN7GUMzjM1J3UpIpJuaHEVzIsorHkJExkzVaSSJsaFIvmqJs7qdNM1cydJE+L0HABtkwbnzI3c6pBM6tBVBmr0WU41C1rN0iWdM2PkWKLOXTFzYm0HJxMzWTInErrY6tVOjvpJoooV1rZRm92WtRxBmMkkk0TyKZoVkr2RNmjnk3XNt/c+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJqInJAf7jcqCMaUQrdG4mPikkB/ttymw6pREN0bgPKtfs0il3OqkObl9xXD19nShmGnki91bbzLBgkKMWFrMJ1Jg1hwq0OSYCay5WhKwNHi8IXTPOPWxfiHaFXK9oYd9TRK4qASs4EABZgRBLmRMCEUAGNLdFsjR3XcdnTHWPMQaI4brUHIpDzQVPL3X6/NI8wiABgcjHGxGuOWU9LvtSUU1JSY7ZjEvnrrtTlW7UxfmTiAQhw2eOj5OWIAv0bQ69JL5ZjnVsTsR1XlUNRiTWAaDjFoLQeeN/HZhh/csKGxLsLPLE5nR/WuXs57OdgJUNfWfGmyORzrySp+arrzz4qb5wVLJTOOXH4AuzDDhYD54ZyjPC9rHHlndXco+7reEr7T56xl9urftTM1XsS2nl25W/1yG6l7UQhjCnpLnwy89mQctZff1j3HD+/aw3+N3TkI0QwAAAAAwbhVGrZnX//6u5XvxwQ/pzDSw9EDiUUmqupqP2bsun6me+4Zt0k2sZkoGUbVvNIIT8mXrerWdyPRjndLWkYukAgAktNIzUxOE8BgDYB2Qqn1spTk0+XlnNvnEFlQZ4zMm63WSzLv/9bjpLhq60rs9Vehd/vy1/qt0KSbqcwQRUmTJFEQAAnMOtcZaD6mtC4dDQFFhoQCevUc/5ME8qNbjsD27uM2KKdOWnYFvU1WfbA3NAQVAExUGcwVQHDCrH8NuUKMwfQCDAYABYe6rE3TUfi+UMrxbxh9p3Kr6sMkVWVxJpRgEgMtJUHMCAKoxogpzAOAKUHUep3Bh5z28iEaV8vF6oFc+wX2XiutLa6nZLYiukvoAS04+EUpj0dqU+qsvzyq3qaMUEch3lWJ0+FDQTNMrKRPkFSiVXbdJWd2mkLvTNa1XmZR+NSgj0YtQFI1hhU+VY39PNQm9RT+vgHVyc7yvh9jUutV79W0rc4l+9O25h/H4vQVykmYAikQswHL5/T8yC47lBRM5XvDtLjjdzw3j+d/eqbdTHO1fkedygrSmczwtbpqe5OS/n1Jm3KYjX1hYsS2pd5ZgnGvQ1L+Vyzlh+tZ91+X81qVNAgBcQIAAvF9bu9mSpf9c+kwyzrR9hNgxUJJ+dQqrnjTwLSzsy8k7I8d8/kNPZjuCkA7XVEWMAUbMEDodtWcdRx5Ob2g6ByiDd5UMkU1uiTxNhi4DTDSYWYPUsxqY1WX/9S584LEij9RpRTV/9GYium5yp3d1t7uv3+k3/0nUlQss2ZBOslUX7qZ6uyVq911KUgmcSpIm8Msin0f1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACZGKSQH+23CczjlEN3RuJbobIgf3bcpaOKUQjdG4IvTi3TN7g/uyOMBV2XeVedlsmkTqLnLwGAiAiYJwC5hJAVmDSVaa2IshgygYmAkAArGyRoTAFE3+fWB2bO1BFh4nbgNkWM3WZCxpS8u2WxMBMF4yAwoRYGZZsHzi39rFU1nIsrC7zSXFZ/FCwAuS2WWy2A4OeRp8ZCgidNDqM3qGmx59JzPOXzUq1NVrN2jtROnxq1l8GNkwsIQPlG3Thyu/rsSaV0mNiv2npaaR01HDlBQMfZqNBQckRRmj+yiBpVKs+27VbK5hN2K9DrG5F6ShtR9RjC7e1KZ6bisvl1O/NqHn8wl7YKalizkxSV17UbRKlle/jKqtTLLeOtXbmNFnn9LSZ8vVNzeGGG5qV4zGMrqZXY7Pc+5Ul3a05ztqq9t+7YvY2rWGM5zLX8/9czpehlQBAABwHiizsrX/Wubu/azjEXW4ECIhgTcTJldBN8vvnh9I9t+EVsMMcXjfLuoNSKmFamZJ3GdBLyW885zjt2v66CZ1BMOaV2UoyyLFwiQGvEFVSCuq6j6zy9D5+VVjGm7as3JNC/b9tnHQSa03TnVOrq1oLX01XOnv/1o2UZougbJpJTpIdbO1VbaFSWyFfLqDiwJg8ROs/b+nJFa4R47+Azw6WVrK33tSQLQSiJxekeZqBgaABjsCBoANpjd655dRhi8L5gyDRgECJcpfr/qN0stljiy6jnnwjVO48vrNyqLlCgDiwVMPBAdmgjFGBQEtOZjRWIcX+0WAHeSMcV5GCx1hymDrOXDLtL3YTCV20IgBDReYIFIvNWpim+ZrZzk1xsMRlMImqWWUE7Jnf5LIJAqiRBsHx+zPwFJ4CgSET71fq5jO6vVLFqFyW3DsMjhGJNFPAj6Ts3T3Mbl6axu5XK2f4bpbuN76WMKw67exgqjhx9ZBLq8olj0x6NQzCoKiEdbt9WW/tSybs37FNZv4Y6y3rkx97eG7NJ9NLsasxcq65QZ3aSejU/jMzkxRXL87lZr7tWq1Zn1j56r9zOtPY/U1NbK9tjfoYkSQAAHOJOmbVNJvv/5up+Fa27zEBoJMOXTwDRA13pTNWX4+rNReYd69zHeSd9mpuwRBjVHOrNGBUW83KnceKmz5pNJamUHrPooGCRFY+wMwhGmgZqqYx1ITJ6l+tlGyh0F9uyjptOfX/4vi26bKZSrVbq/+xa9XVXstFJFaaSL60SZSX6v6qOpFVSrF5DAcWtpFN//0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAmDikiB/ttyr26pJDeUbiTWESIH923KY7jk0I3RuCB6hXiMz5ttZ4xYdIfTyncaopZBbCAuAGIgLDARAMMCYDEIHxN4YFEwwgAQgF4iARIgCmKsCh15LEZYtJKCLPvDb/tzjmLrRBTmWCwEYoAKMAaGC0M6WoazCmHSWDJiXKeaTG4q3kaf9y0+5luDTdOjLYi3FthEBma/ZaGAqXt+xvu9UE3uMSGOX45ai0dv0cukdSGxAnjQvDlD9SGezkflmUZlc7u1Yi1aVZVIEuVbsFkAKUPL7LSiMhhmdwy3ds2avKarIsaavT3t9qW3Qf+VS+mnnonYlAMed5+KSJvhEJM/1FIdu3Dkfob9WPLnxn613VjOrhj/fwr439Wa+VTuF6pWo/yv2b2NS3YszOFy1G6eGJdOTEcrZWM5RSR6zlb7lduatVd4YfZzzy3u9fKhFJAgAEeNTQ6mtJ11qf/H7tPynpJY4Cr2nmECMcuGo8EHXnZ+o7+XetSjbcf7S7wKgDanLKsSAQLVkdZjUcMeCyHbV2reuJ0426Y4ozWmiH1QpoOhJ6KGAjGH0tFaSln9IuuRrVqrzrTqhLjB+6jEnKlv6X+gLwe1MlTZ0la11Le/84m/60qmZ2Ui6TmCzJBBTEWT0mWknXd7pvZ6CmYwcs0nZkz5iBkoOBdexX+UpGxI929XeJmXDRGjtWat6nlE3DFtgiRZgoAxMfZmyGxgx1R05KJgwJg6C4iAZL2IJyyx7HuutBlGEfhqO2k2oPlNK/6ZAEBAiCJQwwJEE1/S4IEtbkEvE3dyi7MpUu9ThfjSpA0ZykFXngN3HPht5bLLpWKgBzkwLE0hmsc7vZ/Cvcyxi0eik5p+7MYwj9SPxFrRiggPG0SlMZuVaWchdDempm9SVJdc7qXN3duWzGMFiMTKFxOR05E5bRObl2fZdrW52msZbu402PKOxAD53Y7WjMWs77UmXwi0xMPPWi8NV7Vas6uFeQTLpWsbdWY13L8r+VbVNztm7d1hevf9eze1h+5nCP552JTKp/7NJvmPyi5G8srrp4xupTbmbFJb6Dq0gqAxGqEWm0AAgFT14tOe9m5v96/LCXvylGAhoEwRoKasNK5iI5QxrsfntQF3PefXBVfzJ6UESS1M+qUgXLaTO5vuT32+de1BhispNS1KMECNAyKsaLon1Zohl6WF1I+tOqWyIp9SiwPDLuvV/4uiXWkykXXWy1PW/0vU//X6NBFBlzdFBNyrXsl7quplKWtalNuYKoSGDIRM9uHP+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJR4vIgZ7bcJWMCTQ3dG4mGh8gBPttyqw5JFD90bgWmPsMmFWfejJj8V68GROpDlLJ4BTmBACZgXgcmGGCQYYpkhquiNmD6B8YEQBZgAgBI+sTpp+i+mtuDt2Ii2kCNyeSJ7ewuaSAABgBSZxMB6BkHQcCqlk7ManGvJNNZo6kqcZ5MYnDSZUB2ZK+kEw3KoLoEPz201xLuMzlR3a3NVsa8dvS6X1LVK6U7eivX9gAxNChyGMK73vvGIBpqXCam86l6ZkNWVW4bvyqHr6+wKdo0vTEqKUQPLKCkoLeGOGfdd3X+bsZ1aCtDEilFn4tHYdxjfYFudiuMpfyaeag49E7HpXFYVXkNr+36Srjj++56tWLt7DLPLueOWu0dzPPtSvnKq1NKsJ+mx1UwuyGW00qzrxncCWcr+O+atY6t3sPqX/z/PncMbwaSCQABlLiZmfRXUqyq+b/V/f1Y5ALcUohCPD/+LAzi02F+Ga9+bhFl9d551qjPFnczoBIRQ4TsbR3M3FnusV7meDsaw+p1qWKVNmo0FHUCgBojRXWc3UX2rLUzetL6SzZMXpg/rLBf1d//isIJIrRdTK++9df2q/20bpqRXOmwCEhFykuW1KTCUNPDyAxQNvDRf//qSDU2HohdGYRNkzJ95DYhihppBNx6AS+gjAVMAgIswCQKjDnB5NxcIIODOIgNU4lYKFisroY/RabBDsEvHeceNKeorDoFAAxgKgEWRwA8wAhGDAOC9GACGl0UnXw1ciAcUwjMVWbLIapl2s6WSwRgsZjTQHakrwKGAQbPcgkeYCgG1R38qW9+FHSPVyUybtFT2ZbKMZPJVDDLDtRh2KaGozTxp2Wo13Oj1PTW4tD2VTlPMvvHItDkqKFFp7syh/I67z+2707RZ3cqssmbN+rlUws3ZixD1PE8KLb7WLUNunbiFJDMzWlNaDdwqpL7MohmfjdTGL1KXmt3q37n8Lm8/1MYWsLdJhfzt4Uese77hu/35fEYrLO2a+q9+n3jSyicyxr2btexha5rPl/dXFFoMpFAIssgADGxvYV6fH3je9b5zO5lvDdLGy/pZUwmDP3KF755XKr7OnP0jQcIC1jXv8IAqe/G0LGafyuFgBAEmtADi00x9elXfvLTpzBNhHxsfdZuyQ+SBhMIBjVJADNS3dI4pOX5o1SPZR5iodFqLb+gmMNa61P/fWsZc0Q1miSmVQ7LZ+zVVp/60611tOKPOkpM3RVRUz6kWZep09C7OgpzqZxbxM9Z0yb//sHgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACTyJyAGe43KVaSkkP3ReJWoZHgf7jcpmKmSQzdF4JgtdSwqXtw+5jD1JPuBfgiWzMsidMnuYAgVZgxALGDSZ6a7YPwYBOpY0N5ZQr9070MyWMJX07rxWfqJSwmESNi7hmAOBMwULADmAaHwY34A4YAU/schLSHeQHrpeDkWaRkppKnAZg8F6LtIQjmpKtmJmHEscKH5ECG/gSfnZ27I97wlmpfb5KJHWlL+bkT+cgFtwhjMHnYXKcKC/Ae6t7udJfkeHxe5lFaTOLO8joJENTz+uTHFyyqlztblF3OrINW71LZlVDXubu1Gg8sRvUzKrMuq0LgzNDEaWMS3CnrTGViB5JEqsqtXJy3+8vzwq4fhllfv6yxzqUOHblLnU7jfxxtV90Os8ZuMZ3a0bv1pFdn7Ny1fr/hyY3qvjewy7U3j/6yuPVVCCdBAASarjm/1jWbb///XblH/5RbBHUBCphNWEaT+yrl3GKthykkN5On3tbHSWzez+n1MCAGFNAXcBAgAOJKqa3TJwUgkip05fpB6qnUxcRWLQmA8CAOeG0VENlndM5N+/05sUBGpOflkpIr/v/KZgb01G4ILdJUJF4uxfujq1nBdwBYpS3KzCgcFgSDrQ2Hgo97//1hgoRHoyqSasBRq2d3BZsM4lFJ6gl8hdFuANDzAQhBgaJLjWQ4YAwpvBsWbirh43koG2jaakHQS6lV3SqATXqy2VEABZgHgJDQACAYwSBRDG9BCTJfShbu6boJXLBylOV7niftlKW7+MPcaL0z+zd+Xv6KgIxFYANZXOmJdjjrGUY8uSvJ+dVHxi0/10K/4yl2iYGhCKiNDE7kkktzUPw9LY/KpVnK5VWl9vG19iEs+AgUMMgCIM2dBxGkS2Ix6tYpIxjnemqe5WvXZyU2bdd35DW3R8j0KpdS/UYryrsmqytrcFyOV3KSF3MZdGc6tLf3hexxw53u72P4VMeXfu2eapZR3fKLOknZzGX26erO/LLkrouWpV9Hrsvq/atdx7bvXLmV758AAAkOGLAlRAAACJZe+La1tnf//+vuXsf3RVBkBIhAwOtA3m5FXCx2RQXOZMe28GWssKV22of8GCABZkqBooTTBSQfoIKKwhOigkgpI46AauLVBaLMPZdCKEBpUaqM1spaWxrPa1dlPLQ1iENm6rEiaLf/91keeXTRRrQVZSPdTtZfM6/YeQUIBgPJSpHaRGoYtZgHQikUUFBSHKf/stWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlQhseB/ttyli4ZJCN0biXKKR4H+43KWy+kUN3RuBZYGoioh1jwlPZag2vNM/sZzt+NrADIApYAKKoiZgeATmKkQWbLoMBgnAIhAFw0AK2dThFNpLNK7XnIZfMyyJtkplVVxabAtVKwt8mIQAeGDETEYN4HxfdnEX9Uk6nq98HJktfkS9neZQ06NSKE4r6Q5NNZsqYABp5p8cAFiQU/MWnZHesVcrWca471HWnL8pyfjtTebyA1cIgLKkq1H5lM3Zfp9bFycwpc7WNJajdSs3fiqYGMrEBzrbppRHCX43qGkoana1J9fDDHVLOY1G1ylkzBUvhix8tj1DjKK0Aam34jkQr13ljkP6t1qTOhoamWWfMbnL+GfMLf3+48yyp9SHX2MbeONvPC/TT967XoKvZd2UU/a2Er/udy1Ofv6lXfb2Of1TUL0KcVtQgAAA4PD+kqo5tv/X3Na3lG44ShKghjT2RrcJkd6ms0lWQSWNabrnqrfp6J1c+Q2Bh6D08WICw2LKMNWM9V6Bd3O6QRRWuBQGW3edPmos0WoDLIAcKJ1zz7O7T8y6PqQUVxSZVMfygaMpLX/6i11IG9etT7//QfrV1ddG7pqUktBDTvZr9f3U9fzykBFoTUeHCv//WMCSjii1ZPeE+XKwz1gPXWrvNIZc5rTmgBgCxghBNmBSGaZXDUBoeiNGCsCCYCoCwAADR+Wiqs3VtHdmom1Z/5hgcVjLBEs5GwJ432CoHAOBBMAoDkxqwuwgNFS7GZcK3Gk8oBcds05O1aFCJuSuJJAEpYEmm6biOWBBwc6ZYkJXWlPaW/ndy1lyK33j7dzmZ6glz9WexYEBwywDVwx6mtXqW/QRvKQ14vYr52s93JbBGFWbipKFVmxV3GnQE9coi0Dyqet03bmrWOsJJcxzra641WxhYpKKLSrmETlVuSxmzKX1iMqku4FwgmpNv7Ku4xatH6v5Z5bxrdz3zK9+N+9jjy7hjzWe8alSphqpXmLdu3nhjhJq2FrkVwpau8ancJznM97xwqa1llrWF2HIESCAAAriWUaKa+pl/7/Kd/mqCSDAGi6bFNHKiCgsBUtPjK8ZylU9VbFnW5lyDIRqrOjxwslOGjCy2sWtjMY40KgvNbRXMVFgGgwwdORyB0WgUmFQ5DHQNmTzBWaTv9ak5Hk1V9ZYL7HFf7eUFJLWtNdSC1Kb9XVuj/+iu11oKNiwSQFHHp94ZucJjsFQUQ0mPNudp3//SAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAJfIrHoZ7bcK+OOPQblG4lChccBPuNymk3ZBDeUbgAMAAADB1Ld8S74tWpVEsruxqW4wA76pETwQAEYCIFJgmBRGCWCOZWLhxjjBSGCGAWCgAIGdV3nhfd5KzXZmDLMkft54aSMbZ/mfRFIYwAgJQUBKYDgFxkaAaGAcAOmNDsMLyvOirx+mTe3zs0LwTzNX6zeNy2+tjQXJYLAFseCHAYSfmVSnk9rG3++T9akltarN09STUNA7TqmGjgsgyOvQ6fqikkvn5ytKuZyy3hZ7dxkOVLOwAGBMtgtiEvUcUGqwReoJbS8t2rOHMv/mVmtcrvlq/ewtyGVV7V2PVuz7eP7AUpjMEUzvU8Zl8tp71W3Sdo6W5l3Kt2zz+8x/HvOY387l/PKpWrc3jzmOX37lXVnlezY3T1qlmlr1qmWNJ9n6blTe9Xcb29ZY/3l1yAgSQQAeLWRLfdZ2y8/497c7OS98ltggDI2mY7cY8CjO4EzmdwRUvQArm6+/K1Te445mEy2IwqD1yq0ohhQZIxxG1y7dfVM61ZwQSUkXVgYEePJs0xIhFngPXokPSWaou6BmzKN6HeuuVlh3zFjujrMiSYyQ1er1ls8kmmcPOitC1I4ggrq6lnuybepVNBBNSSbIqNkHMK1UVLR/bar6SzJ3SMIUKhoMgECEcw09/pFWgbOlogQywhVkZQtzqyi7DMPyx72uJBAIBAwMwBjC/DKMr+H0xwAjzAbAeAQDKJz213wzVpehxHEabLYcdK5I1UoRRyLyICQwIwCwgEICCqGDGGeAQCk02wWYlJV+kQA8eeNUslycF42fPKnjfcuKPY6CkmdDAOMdUI0WAlN4Ov1KO5c13lWvUxe6arTUA0MYfWfrS8UCxk4eiwJwll+lwjuVulr1cu00dsW6fW4ZorPZMIglATT4Q47vI/yJrNjOSVf1MWb2evyq1r2Ge4DnKflaArOVun3NyymlkdklySyXKGHlb+S6rvpFec1lhjb1nvH+bz7nzmO73a2V2hxzxp+2cd9+3WtVb+6luL7xj9qah771rLstl3bHKbL8LmNj7Fy4o428xmlRVEQADsHsZorqQqdHV+v+98/OwuHG/MChg0fTTHgDdqluRC1EaDGPLjuO5jcw3dWDcy7ebuIQgMgFtVhDFQLzuZ/rcffSr+SCjcxpA2IJM0WgdI1hzQQLwseKjspC7pNqSME9D1zEYw+osN6jpoyaLK/8zTayJeQTzD/9utur/7L1pHlVLTra3/X+1Ks6EwXJDERIpDlOb//pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJq4dGAf7bcp8uOPQjlG4mXiUYB/uNylm3I9Ct0bgDQQxfV8qFq2RWxffuOKGxYlsu1SvoXVS0C4F5iiA0Gvw+QYUIFosAhF1eJFrEZC8CeMFMLa9BFJDz9swjiEuagRiK8jABADFAPRIFcwYiTjHTBsDgP21h9/l21mqoKTzclO4dXcy9OR6qNdcHLCzDEGuBhMmkYeDn2x5j4ktd+MZRT153OQ67jMxFwakpqw3ADuwhicjUyMcjAM3MmkDW4YhqehmUQqCWJUl6p3GWyOmuuxahqtK1gxo3bSAGWvVKVrYSORzdO6FLrsq5Xt4WKans2aaWQrvLleHrkPZUmFZ+nNm3YsSl27ExLn3lHJO5K96SX0cZxiNmgs5YWbnLGHcfwu45ZW6KtrWWVNQ4ZfYz/DO7f7SRWl+5qXTdLXwt61Nbv4TNTHeOOeeedjLC/kanSvgAhRoAAEEPNmmZarbn9c3r+YPLXpAwMHMIA1+S01mfkD7ZX46322t3srOsxgDxetahgxABUQZcOgamTyyx3Nbm4Ls7yWyjJjgODoJqUmOAujPBAmEJSWSlmusmdJFA+lUj2OsXxDUnM/uWBNDU6Yt2/mj6Jmy2UtLU6nfZ/Qf/9vpUUHoG5hQQdaVnatrNbWyrtey1InDwdAQkNKPf/9ChaXjCkYqEMkjQ2sURxlcpDQ1fkMPsARXGABjARAXMDoHgxaSLTHfaBMGAGYhAPSyetqbyqmjiTLwMem2PyNl9e/AS/ER5I/bDFdCQCJgKgImB2V8QAYFABSmky5CJTOpbGX2tyhGd9JzFrqqgQHV7sRdtmrSwQDQMDDHbxOzmoaD8phd6Vc72pP2tUsPXG7TVBSXKtHguppgXBI09mEQHjHrrqvjFY3KKWnlc7Upaanv73J8MrFGQAlLKPwG/qg5dJw2pu5duvPKK9yRSzKx97Hnd3bjfXu6prFNWpKaV15PLKWQymk3LaC7jF60iepnDfx2rMc1hV5/MOW98xzx3utjZ3cmKSz9e7+NrLL9YYXbWGVrC5uN01PhjK6uM1S0t2zTX9Y4U+V+zW7/fzw/73JJyYQqYgAAVeQHTFQ9G/e43d7vX4PzTsMhQz1ftO51cpbK7zs1c6FanXA3V/t9/Wp2b0aGkdO+Tl72HSK7qpZ3MuFn+KTMdScLtTmU4TSYN0AOYLEltQS1GT1PMWz+pazAWajWaaqkR9EPUtf6vUjU7HlKrtepf/m3/+prO7KrZEpnkGav6qVXX62MFT5UiBwOcARVqG//4XAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACW+HRgH+23KRrAj0I5JuJrIpFgf7jcqQL6NQblG4Jq8i2fM8K7nDbXGBA1NVq8w/7kLnLuBcBEwFgNDBDCJMXoPI4TzPAEQEAgaS6TJVb5Cv14HdlMLZAu2ZaS/XxUcACXs/cNxABAArBmB+AqYY494QFSUADQx9tvrCqbEn7fixNMkgVvH1dowkOvuvMrDuEIA8QDJ5y+dSIBgSpk/MNRmpnSUtN+XyaZaX23SVYelcaYS3AwtjDCp2YIpYIdmHcaLLV95J2lp5bNYWrkUrVZywIQMFDTlzcIdVRVvpqBtvNGodoYtjT49+1nu5ctRt9rX/cwv8mcbWpq/R1qPc9blNmVS+UQzFW+7OxuGcZyRVqtrOrv88u65rLHC3rtzCtq1hjn+Pe47q27VrHtPdsWo7dr2cbOeWv3TZ3qC1S6oP5rWHL9nK4jCzEq4iUcYAAkwDRGzYZ1tZQzv5/aqS+keV2ASCzFxWOHqAODcOWr2ObrXZfEGW3HD19ut6ejZ8dPiYGAC+fMHCwSAkt/du7XjjB5zm2Tlh0gvcpqSJDh9AdiG8FcnVLTradS2ljoe46CeNc39SikO7v6/+pZ52vX//dX//9tnUkaKEkPJc9eqKCiqxc6UfQyp73/+uoMpslV7grHN/nB/3ZGaDnLJRlZdiLqYAIAMwBgEjBFBNMNJewwDBIjBeBNMBEA5FVXymDOln5NBp1YIIQnO47DywI6iGSTLbvawMOAuMAkEMwXAxjH5DsBQNTUX7h1aUPQYsA2jc0xXBjb0MiX0oOo8YADamTc4w3NWRJcw8SD5r0Ek0EAWfhm1OZY85Kct3W/uwxGMZRE5+5MQGp4ywShoBwLnWR0mHdk96Iz8UZ/UlcEymbnLE5br3aeOjwlg+Hbz+5us6U/EG0hqNbyuzVJZ7njhVx1izOkytVblejm62Op65Gn3uwQ6sbo43nM6r0ih96HcIRRRjC5bu51L+Oq31P1rPV/HeeOVvLvdZWc8v7r6SvhUywie6/OVZXhYs6sY4YZ1su53Z7WdfHuOePPzwt9sXaAQ0WgAL2gq6e3aMts539W901ApvJU7xFBjgQ+DBinUx2VQxNNBensqWfgyj9U2Vwqga5OX26BYFthBoFLbhABpqCtUq2pQjRV11BkyNOKCw1M1RQWZl8DbCQoEPpOooIqQRLylIIqM3uvygLEkb5dvXUdKyzhyrf6263R1te6K12/M2+6/1upC91PchgCWFw8wAitD0pOvTYssDZsOPFDOGf/1qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAc8ekaB/qtzCZDosCfcbl4F5xoDe23Dt7zjQM7VuSbstGuF7Yi7i1vX1KvN/m+U2jIwsQAAGBwiQZCgK4QABfhyndO7xscmuyCfW3EYhI6WwzJLB1d10OhYABMAwSIDB9x+BpyVROV523xl0grkNHYQ0eDBgBQYWxnRzyYLIakBiBjAYfCAe6XjFI8my32ZEnFmxqxokXlmJmGBwBiikSS0xb0FqSdBReNTNIyNEUSa5iDe5ofPsUxxGJdMDo6yybomSjaZqostWRJa03WzsgnUbuXzjF9CU2NETqysu5cdJM/Wm6CF9I2Q6CCNtSk013RZSGaIVJ6kD4arNXPiv24ik6Bv+7A2GWSpFGSztQxXjcopd4QnKbzgJ0U0jBmTmAQwCKDavhPxOVoGKKTsQQptM5f+UReO5DgAMVdmSzpQC69hgUDTGFKA+ly8zsWqGP37oQAJAj8SV9X4hl5Y9LUQIW3Fr8cfElAxjqUGTwMwt0pbakH57rbfr+Yyy7LscLG41nViYVCpj4Azzz3a7B7G61q/SRJWq7dylV6lsxrndVRUDyyRUdmJuNEZTHo+9c3T4yrVNuvrlnm//cPZ7z7nzuOGesLfZXU5T4bj9icpZmw0K792KdtVZfreeeGG8+813/1lhrXea7ru977rLn/W//psrd7Gxen7dnDLPlfPPLmPcu45/hzDeWsqm6e7C40kbW7ZEC3depT3Lssp5I5a1ASASYBgLBgHJDGDeEmIQBl0xqD3npqFRt1KRtNIYT1JBU7RsDVDMTcYIQAyIAAwjQqjCXAmGgBWvRiJSqjuOhAUX7Yjb8TsDxmGRgNktu/hDBCInKlAcXEwDXsTWNjL887381M5Utnf3rWdRsIoZNAysVIpnuz37O6WlsYZ37O93u6wrq8sbr3XrwlNJbf+pKe/9rHWP61+eph1cuf3Xc8KtPnjrPDDVjHesL2FifgXuGtaxzz5U/vd7z3v8t/r8stY61jn+P485rmGt9x/X9zwzv8L2rQcaABY79j0hFbHm2o/lakv/7ct6+KRt9HjL6AUBTA4Sgr+RmaK6mkdkEPQPLlL2jZQU89SCJdjEuUzjs3eCPt0MFQHAAEGQZxGUoGCQAs6pJJI4tBTVUtbdqkIGMwWh3kyToXrJUtk8oVoBUQgbBEIGHQYFAImVCHTJK6ZINQKaBiy1ObOYDpAEGQgQ2JwwIgSSydTWVTMukkeQUbIonT1JAzDpDRMzOj/JkmC+OeUi69I2MW1JajAiKTandBZutFSaDKNEVqQPKNCaE4uUFKZFNNRggk6NP2qunR2Tdkn90k51JJ7sXzZo/T8fM9BUTt+8maF1QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJsoTEgx3jcqBMeLQjdG4mai0SDHuNwkguoxCd0bgOfMvTAT7wBN14lfn7s9e3Qwucgl+GVrCILggADCEFTHwTD/eZD2spDHgNzCMBjA4BxYDnUbOiYrOkCvBoT8rHbR4mDSuKEgPt3QgeVVMwPCIRjMaFTyY7hCymPL5eKegyXOgYBgY6buO3K4Db5v3LeMwAInHctjSi4wEBGqT1h4BgACDivZ1YVLYtS5X56F4WcWnZx69WnpTNXpKYPDpnIYpFN5TRFNaX8jlLGrG6q4LEogrc1TxXd/BwwSEUWcpVVhl2pe/MzI2ST9yR3Izdsyi9Y5y9bfR67N61R0Nenv40lTPvcs6+6+6eigeVbfYMAtWZtSqVzcZiE/Nx2XdsZZd/WGt0uOpu9+VnHm/+92iz3utjTZSqny1Y5qxJ8crXK9i1X7hXpdY97vOzrDtsbIPjoxa+wQEgQACkww0UuUh4W6vWt1Z669VOjcw8vIajfAsKUtlTaX8bSx03WKwQprJlz3K2GOSwbiwN7YFD2jgAQdKEamu3bsJngxBnccK6Jw6CEESzGJgPsEiQGzFgYEEOI5abu7pl7qcoJP6xfk8zGi0SlX1TBcp9/dfW7c1rZv23Q2d176X/1rRKZFqmZJSjHNhjm3FZrFUjQysJBQk+k7//YQEvT8zH3Zb/t+ehullNLu3KpdyPw6/jS0iBUAMwFAJDBTC3Mgx3kwKADhoGhPqhd9lEsQZYyiS473t2R8XtEHAh2MlgA9JNZtEvAwWgIzBNCbMvMLgwQAIQCAkmLPT8AQ8p1dDgTYaibsPEtd3oehmImCQK1ZR4qgFbQgGpr3InLDSAgkFAAuGH5b9FUmL2O98xaheid+plI6WcCwUMtCdCF0JfOvzXeXKvJZ2XbbEuXOVx6zbjvJfamx0DoHUM5VgqAHSj0MOs+Efgqfzva7ScwvWMcuMKnrfMtawsVcLmsf3lTTkxKpBqZt4o2F+ZDXpas1unopRlLK26+NTDnO1bG/3hfz1rKz+W+91V5+f91WuU1Lq1hd/HC9SZWO1O9zqZWM9Z9rU1TPC1jj3LXcf/PGzwEBEAAB1U+fixeSuV595v94/CM1ixBSsyfrFiRTWLSu3LK7sNhajTL367m889aa689HZgMaDlDAoGF75fer8psKV9xI3gbWazA8kiOkG9yqYqTH0AImAGjA1Clk2baq5BUqB5Eh7VOuscgxM2Uqd7qlkqZ0/+n/dOytvdTL5x3///7zM4KCEpW1mlPTYWubWBCqgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACYSHRAMe63KHy7jEM3NuJvYREAx7jcqJu6KQPcW4Hnzs9PUz/V5HBdWQXcrlx9KaJO3Lc4mz4tOIwIAQEGYOrlxhGAoDwFsTSgaSofAYXAAjJQACtF030adPMbW2vGoFgEF1voydbRgzgOgEc8xmQTBkFcIApcrGUP65FVnoOAriuLwOsu2Pv+y51y4iyVB4ekRgoMhwsFZg4DbDzBACXtqy2tLrkolv0n7pmv7fGdmKG9aUAMBB0HgRe+Ps+cpl1SUW5ux+pW8Q0A0jzi0tksLlFWo2MRABIqWYpnbmfdd9GcR2tO8lT34U/1LmFPldVvcX+59rZ59u5Zd+Z5VpLkqjsbjU5XfRLuISqZw7Uo4jKe3KKmz53Xfq3tc3vLLlbDLGxnZy5nzXKmWGub5NZZ42vs09PdrX8aT8Msa2ssKa3lzGr29qzhzKwhuTEaBBKLAAS/sENcplu3O2vv9yK5+C3qaKmtRBi4yva1Isb+DZbrex9f2n2natLqs0aXVKKIhAwh4ABVTqFTtnPH8U9DDAqE3M2TROsdDQCTWgtMDnIc4VwcSPdFWVkt5OI6sh5EWKzqRlLrzEbClKP3896/v/98zR////QJ1EZsmuvqV8uHVi8QqDjwmdj0UcCmrxe5f1G/pJVFooou0FkatgNAFMBYCIwJwQTCYIUNSBMEwpwbzAvArTuLAAo6AVAsQBwAMEEwBttXEQdR0FvvnD0QHQKC1F19iAA8wHgejFEFgMNEA4kAnMBgB1EaGX8qNpFmsFgAKkeduTX1Eo+wCcrAYBRCMtqhkZOyxoYdteZCAQUjXFrURlM5yfyl1XHr7YQBUiESuP+SgQw2QSgEOvA0ANChdK+U/OTFFVpF5pRVYas2H4pddj4XB6XNq7KKGMSt/oXapm8dSjlEOSqc5YqfzVVYOgsVt38MOb1e3dr3KS/lWnpfZr/DUFoBnP1SWqeRRDG9TQ3Vp7PeZfU/Pu8/x5rnNY43v3Zt63Zv3uc/uOO/qy7HHVNJp7lTeFrK3v8rufe549/CyJcv+Ur0oABQAAEMoArETZuVXu/xw9+q6kGiiA6NAoTkwZUT+Pbcp7LPoMe2AWaYpvy76a/QDgNAlmZYUVBMw0dAxczKVZx632mljbmEDti5mopspJwCcsnzQzC24NvjJByRnbLqSSCy4jSQUQY/Y9MBOJ5yoofNC2t5wdrJGCX3br1qpJrda6e+pZTQ///+mpNk7My62Qqf7/X6rdb01uylN2mCO///rAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAbPdsWB/atw4rBooD+1bhwiCxQE+q3DwMHiQG9VuRrywodJ9095r/Pu1sI7FrMcclRkEAiYnnMflhWYjBqYlgkCgZLXLJZVSvOzBqEQRIqxilapDEgyTmJgAv1sQKBZmyEytylqw0jgGzS4X3yGgXj05IyMKqZMsTgBAJJxMUgDQJgaJCQZcDnB+o6BmmdApOhWWUVKLsfa0TIvj6AwEHAGBEVy0kmYJuWGNnZS0SXZI4YHlUxXxkk0Fo3SQMS8gcZ0kjZ0110SmSCarralfUqlQdmWpioQiKLsqx1mRNaKr6T9lW1eg6nptsr1GCSQEdWQ2IRcCO7UPOPlq1rDzV3W6V9DcqPjKOU7stECgKmIaIHv4wmAwpmKoNBgKpVJ6teflCr2rTHa6C8Ft0fiQzIjAFVtNRr4MGA3A0zBgONoWac+GbvJXHmtGDgEvxRSMjCpIiomCEIYWRGANBCAVcwJDwbYewK8LmUfmaTJzJsuqHOTRUWR9AYIEACg2NycKRmOSdUYObOzokaTlIpqPIUxaxYk1HUWc2QOk8aGCM+XjZJdrymXH62pX1NSdSTHlqYnBol0xSROIolFjxdPJIqZNa3/1/+p/VZ0lFwvXZKqipvS21MjOBqiXpAVBqFRPUrunxq88MscYYf95EUhoBgwdR4zQdCsMCoG0wDgDJ2hjUajLoMIflRpucLcqmrVLkMhUBNYV3p+WmAmDWVADGwuw4LQIDt3NxZnxciBbElIqYDkmRAx0BxQ4hzQ6gCAiBsgFCBC0QMiwzBq8j3UmmT1BMrJEwg8zD9wcZhmjFBRmdUiiXDZlGaBiVFXP3MjopA3RdRZZ0VzylubmaJsgx+pIoC5TVTretkXa6FTqXNWWspjvLSClvoOpSqmQdTUfTR6ns7bWUtmW+6j6K2oOyVlsrqW1bO6jQJ9uYAWsRIHpGJudvx87FxsdLLGbwgeACJgETBtGRNCMJYGg6mAUAQ1GMw9JYdRhXg8tO0N50BjvSqUS50SwA677RIu9Rg1hUgICwmAIXyhqnhPW3YymHdDAMpdMwSREojGmxAxnBLyDCzQtoAQIwGQ4FhouYL9jnC4Cqkbs6TpmbJLIVYvTBJImwt2BJFCdi6cKpmOpI8gUEjRRRPloQ1zh0rrl4lRQhXRPpFlk0VseQOpG5ixsgePruXBzWU6+22hU6ly6y0ymNstIOYpZcPqVqQQpNboItb+/+t91FI+62NEmSstFStS9bPMDQxX6rqsHYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHNILEgT2rcNTQWKAjtW4dwgkQBnatw6JBIgDO1bgNA2sFlkl5pSUTSrLmWfw9lD1oFAKIwDEeInk4SGFJIiw8s6RtirZbrwrBP87RQCbrM/0/93VEFgNFgHtxJN8wEMsw1BhwlDGHy1hmcv3IqMCgC/0SyKiysT5NDiFyF0gwXRAyKWwNXC0PWJ8WgcwcpBBAdBop1kitJMlmJ5aB8sA2ZAaFRqYKKq2ROE0eUpZomTAmBqiUKmI8LExYUHRTdmNHQMEy4bHTdFkEGTSRFeSSTre76k6kr1n2dFRFCLIJn1op6CaVb1Vqq5gbX2rWpLTUzbM2Zl6yd0Vosr1d1K6ZPOy7UODgsMCxxzWmRLJWXdvTcuwdxZjPxHCp0uIANFkeEldTMZbXrpxp/YV4xUVFOw/Yy4MALBcmeIhA0wWMsrDkOCxJlncInad/5u+0ovhWlVgqJEuVy8VwmAC8TQZBAx6TwNWCcP2HLJ0uEOUcUkgipE0uiXEB0GJoZlgAwDgSCxqgo/HJYyJpkKzAzHwTLMUD6mKYW7Gig7J7M7GCZgbGZuuggpakS9Vr/U9XrPs61FovKTPpou6JxN2Op1UVVakn//6rWXrIw1WmikjWykqnV3V6Zefd5gZp2yzAf5aBpF9Ku447hptZE2Zf6RQQKxq4WZ5WBRhWUJgcIZZZ62nMhcZcyjkHqHiwJMXRmeR/pTCZQVAGHgGkUGjIKGRAlGG4VCwEtLaO3V5opRRuLQIIQIq2JaT5NnUljyFzZExawQCgDYy5AkIROxHiOTpgs3NCBomCKieWm5PmRRWkRoWNgYpAAe8amKJRRNUUiHosgtZiLwZlBEitaIXrHRUmizKRSTIimVzAnVnkZgpVZAxYWqWldSkFo61UUC6cWmkOpBJRxA2R3ooJMv/kwevpram9dlqqZbvQKqa0kL1UNa1dX0zy2fqGT7xfvC4utApsxNd3ffd9Y0wVmz+mD4BGjwMnTYeAwfTAwMS2y9X+mI0EAAn5L5c/sKW7KXepX5sppqF0DPRCFBmkBhjCB4YKKGTgqpyPGglNIucwCAGirQkvmTldY7RIzw1wIC4DaSvAkNRZQyofkakwYG5qZHUUzhZemRdRLukTIFQCBiUDBziqs6s8Mcdc2KrIOyKAcebomjrRBvcWc6k1oMkikmTqZXOFV0GWhUyyBkR1LS9qP2QLpxaaQ+lJJKRLy2c3TNVOpan67LMm1KX//UjWswIaapqQRqQdDWtXV9M8tmhmUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1OBRADeq3DQECiQJ7VuHbIDDgf2rcO6QKHA/tW4BihB5o04CRy+Pn27N+ObbAzNBgwCAGQYEUYZiTBiOhDGBcACYFAAIQBchC/S5IWhq8Sr07QwAR3Ut24QxDEtwGAElnQVQgUBUOHmAIAREAS1x55fHbLf40E6mrS0dKgaDdImbkwCIEjJCRgOMAG5QoFmiPK42i2iifSIokplkygoxLijJJEvAGAEKAYnVooFYweZlo/RQWmRwn9AonVIDOANAEusvMFXNHSMSwYziLlwqonEUBOJrrQToUdWt60KFRcKrOmYG6mOJotrZSSLop2TL55VaXdTbtqekplGBdb/+kurXrNy6pv9IJhlAIJi1Vkp2vl52c4jaehc6wAyBIMFoxQ0IyfGYwkBMaD0aBJXPx2nQfZE39y3GUxm4TVJukXKhfHKUAg2aaiMYEg6hbjAMYocJuUS1mKkpdasGhQI0rGZcDoRzhSYBBoAtWg0I6bB/zV1n10EklEGzpNJkBUiXgHAkOCNTNE6aIFOsqstEwTY6Oc5RTUgPgLSTrL0FXNHSRMjFFTJmh5lUyIr7f1fWhQqQNbpoFtSJgmieaigZKZ2ddRm3fr/1VPzMiSWz+rrfV9Zuaqb/SV7LDq4RG6bLxwpfE3e16smjEHtdIgzMGhBPHU9M8giMEgqMPxeXitZnLlUpdJ6VrKYEwit4MAA/7wzUw9qQSdEEsgMCSvEQjCEBggEEQrktb2NupnDy+2+a9N9OHzjivE6BgULDMgUDAGToQBmMBBqsXIVg3ROuigog6CDLIc6LEygfcugVAYGHwUI2RMjApEscJRJEiJWOpOswLAnYwJpazACAKIklZNloLPFZBzpRUeQdAlUUkjMU0kdZ1alq2ruizrQUmtRbOutIrptfspdT07UCKH0LrXr11Ke1KkkowdX1VMvQ0NfUZmpldQx4KuUqtisVqUdUjYg97m6LrxmLOSXOMDBBOdW5BTsmAYNGIYfN4yZ2YrFwsAzclGYo+1VOVvpLTw1LBEARMCTMUyDAU1zIQOgAH6tSVEWlqmFd9pdQPEqRyq+BDimiWRNxOBZYM2A4NAZImgGUw4BYBjIE2HtF1Z0wTM2WgYjtueHaw+EjUCoDAw6DhJkS8cOk6kQw2MTVA6XkkGMQ9wuEOTWYAgBCzay60FnjY0TLJMpHkFoFFFKdFmlVVa6qu260a0EE1ysdSW5XmrvZbW3p1Vlg/2639XppPlMmkkrKWqpl1IUUGo2XKZ5ntsyYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcyc0OBPatw71AIYCe1bhohyw4H9q3D0D/hQP7VuAfR0cLwMn5pOcv06S5ZidJXiDdQIBgAAo9oJEw+CEt+YHB+sxFKKpl0iSLG2/KgAF54ohXhLY8+8tCgIpQNeT/MFT7MEgLFAaGhBlzeOsti2y+GZAo2gSlsPw4WCgL8mzEZkBAbD8QKggDTpVBoDBAMfBmBAAmaBomcIgmis0LqJZMS2gYIk2DURi3lpkUjpfOEHMEiHG0wQRSRTNTBI3E8B6ZompLUpjZnWgXUUUHLBmmxmIRkSSegbXfVWvQSW66zpPOgdMytVSd3ZBAyU6la0yfNf91s9NnS9pcNukMu1agSsfZ6ELOogPKQe0gdFH16mU7AcFR9ZjMX+AQAHnAbGKQEg0ODBgLWosyjEBPEVAPfcaAKXObRBcCpU/uT9wAOBE37Xh0CzDFUzDIRQIBoYFamUsaExOdemWy5S8aA2SQ21ghhwSMyMyYEAhCECoYA1mfQssD4xaDhPjtSKjGCKbMiO6kZixol9Q+wIjMulVmSRWoki4bOhMKBkMYJKSJQUbh7Ad8qOpLqY2QPrNCdRMTRZks3ZMWs2U1nuq3XoJLrWszJ50DpmbLZ0nPueQQMkHOJPW5DzVtXpr62vWuqUzyCqnW6TOy3Ut6qVWYJHWPQK1aCRxntGN7ExFxApTde36j/xmJNZUOIAhMHx6OvULMIQWMGwFMMwEFgKTpfpprvIlM/qO0UCPIkzbNa9GpcOgCveTF5jIwL0yBUGSgPHJZlHWt7dipgn6gPg+Vxc8xZMDhMgRCwlMConA1KGBaygYENDoisylyJpoJuS7sseDxukJGCAFCpI2RLJWTPH6GpBki8QxU1NwSBAsTr6NaKlnUiUSM0XL5IsmsZ8nl1KSVsza9dekpRUey0HVSQ9OrMEM4Wn6vXf9btqLhs/pVve+1P/qI2+hqdEIfF7y8CkG1b+epeyeGFV2RDgEmDZQHW7fiw7mIAPmH4GAoDi2rxSuqYAgkkqoiyhY9YgAtrM1NOFKgSBjNIyYCgMZvFiYohUMBKPCW+7EIDUBeaRzkpaKYWgLQOHbIKaFYi5KERDbQxuEIhA3mKg85AikWQxaRM0Y6iZTc+mRFBAskALRMlQP+BgIJDDReYmBIF8UiSSBPmLpGCBsK8HTmxfIgbBAFBHxbW7V0TVSzqQ/JGZi5NlVBNY6x3L1Jf6/W1JSiQeyzRSDmTOyMpppIrOKqOEAK3r1r/1pq5mat1ooZtU/emp9R1jZ9nH0agAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHLHJCgZyrcOpv2FA/lW4cufcIB/atw7E+4QD+1bgJzdgOJtbn1+NWyDsbvM/iDI14BcChYbGP8ieD3BikQqBg4uhAwGgG2qDWBMDFO2gkgLC4Gf8vU/kGReMs1Y2HAJ2RCLTjaUMIBMEE0WFrYJPTKo2mH5VExUwnPqz5gUSaJclyJgGB0IQcBmxhADKIcJMFMvCgh2XPojsQNVLJY3dElyYJkhoAodAaCI0HoMs2dFFRBiqieN1LJwWaeMzELpgMA0tOhe7VH0nND54wPGQ7TSkQ8gBs7M9vdTrqrPWdyLmron1sipRm6F20Jmi6SZNU/R/6qk11KIYW3oEXFWq1Htn+mztSoggTFK9jSwrWxA+J6j8NMPZUgnMHAwx7Rz5uWMlj00KUTCQHDhATAtaLYaQwoBU9VXu2nFC1dQ9DlqUtZbAlA9xgEinS14CkSYIC4scxQG2pc2CFRmIXy5gVBkFw5Ok4gTxFh3DnB+wBgUAzI2AMvgghozBHpBxBBjzoHS4eROx3mTIEaRQmB8gChUCQRNE6DFIuuJUjH2uaO5oL0TI3KLB+4CgVLTs7pLakfNnMDc8YMkSO5NkONnpbfpdS2ZF0yfPOifTZapfUaMs0SoMdMXSMyXNb6//apPema/62bTR1JtVUbDv30jEZWJjVysleMjXEiQXPeXbzCWzzj8MRLWGCj0nRAiBAujwNFgDAUGq+nUc5igYAcLVpVVGhwYilhRxaDWxvaMAoxZDgFBrHpRDiDKgOo4Po0mLMMdZSimkECp2v7D1QqlUgZZMUgFwYBEQAadHYdEJ3JwpQbRLpgZGqQ0lpGB8+g7EQJkWoPYAaKouUnVppOYjwxeRMBXWWs6pZZE5Hzo5AGBgANl2dT7my0ZsQI2SUsyW6KhISRspNev3VtU70CcNkbFwrKUmt1rXZKpWyY5ZIt/9W7oKepZDHfo1fb10tRg3en+Dw/EtEWU9Ei0ZHcSaHPut/JljzYWkKqmAYLGAjknCgyAIbDG8WAaBRMHjjOYwikBQjMjTZbqrRSiQAtsyrTYX4QuHghC4BGBw3m1wjGJoYkgSFA1Mqf9l0FRWOX39LlGDwEx1xtERKpXGXRTANAoFBcBos2heoR+SBkYiKEiWCgUVESLhkk5EHloZIjSDhiwAoqilUJupzAl2D2zVBA+ta8REgB8xHwBgQDDZSuqpaaS1ufIckkgsyMXY4Myasy3/3VtQdKgVHRsXCspSZmta03ZJlKUkzjPmrWt2/rUz6026k9BfZ7dS6jBvT99IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHb31BgZ2rcOyPuDAztW4c+fcGBnKtw0u+oQDOVbgIi4lI4TmraCcn/Ltp+5f2OrjmIvQAoUh1kTvwhTBIA07DBsMi6KYLllgCXDDgAWAIgYHAGMHAHy3A9MyN8YZIQ0k5QABgiKpoUBJikDw6JKfDVoYhhEJxEy8qKGyYJn9gSVFdAdI7yRGdAcMQubA2WHAYASIlU2RBQBkGKZYRPC4SyeNGMi+mYkPI4bQDhUHukWLdNNAlSfWP5skVjcyR3HLE7k6aBowWZKSVN9MwRZSajA1RPGZImxmcFmCfn59V2WpVbNT3dAfCKSalpLUicSSsta71blF1/79Vd6lUzMu+vUv0H0ldZw79Tr8yNgYHxaBWpmfIZ36OWW79unr00oWLDRQAI6yZzsRZgoEBiMBZgCCwcAK53adZyRYVEP1apaTAbQFuqN4ptrsRGQZFgUeQBAUbRDKDBWEYVAoUkkmcKcLD8eF96iHFY0zuJF0myqP47BggYGAoRAgG7xAIBFUmSOLwSBY2ybKCjwvUTQsoEZQJs0I4jQCBcOaTxfUtakjBYjhJx9lsvIopGArIcYeJwPaAaBpNKRTfWgzU1FQ1OmiZaNjM4IQEupJmb9W293dAdC0lqWkmgzH0lGpiiYpP6jQnt/q+y30lNUjUvtdrWfdVqywj/r1CeRD0IAbPW9GewXY5q3Vp6Bt48udP4xYHzI//PKENJQxiLjCoeYKppQJUNsBgWIggJBUZBAYP1BwoBkYJqHn/nC4RaAhB5jWNmYAuYXHY6bx4Hto5MvTTaCmVSxZrBgoJLgeacJIpjGF8nCaAwQWAMXKQDIIGIe5DT6YNmCuiYqWOIxKykTykzcgxYFJgKCcYBWVZ6JNLHw8apWR0XHyLMTF4DdEhDhbTZ1LQSRNXZEkUUDclnSTKYb0bM0/rak/bW7WKBBVPSVWtBkkqPSrtTK1VXoatq79RqTyPv3b+rWmXzX9V75cOgwMCCXz9pm5Whasywu7Z3MrPh5OthQXCZiXSnDhGCgEVQoDQg3VeT2OG6RhkApKvOm8ki65gIJwLKtyO8KD0ugKBczTHTUwDMpB8QBImEyGLiyJwYtA16aSPIgS/j/Rgtj7H4tpk0A8RAYkUABR2Jk0I0rDpCxArGpuixOm5zIfTUUSMD9gRC8dhsZWeYsxAzzFAnkakSugL1EUIDbo8mRbTU6l1MikyJqaqcqOk5QFH829v9atigXfVrZlJTF60u1Rs6tH/r/qQf//76qZfNf0+HwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB2WJQQH9o3DhMSggP5RuHeHvAAxurcOkxGBA/lG4CEHiYe4qkfP4dd49G63busYQJuw/JAARhyHZjhI5hYEoACASLRKsv7BVAFQAaAYHAEQBQUAammECsz0sBCxWHoCtwGYAhqX9JQMMzAoBwhmEYjAwWygY3Ec1vFgXHVLGY2sGYKBmxGrXNiiVw+YhA/oUVgY+CGKCBkwR48k+HLk+i6ouUnjRayLJUhbUgECARBjFZJqTdyUGywyqCAvC29JaSAXJIYBAUHLFdNl61L3UTBkbpmhrMWJgLODS1IOzfU1ltXmBRZ6jyL03Zk+hSfWkTz1OjrV2V2foEAKz3Tbrp/WyugVH+3+/9RqwmiEqchDc3SLtW5jNlKxpu3t63Uex5FlCoPM/fUxQNTCAAMVAdRRiKgt95IiYQCzTbSbwGG6yzAIQZt7OHm0FRygPEIEOPGdXYZIxCSB4NF5U14aKgEiScsER8RgsFF+XfqakTHohBWQkeAys0G8A1SgbjwTQeMeSsgsxLxSPKQGWom5Ekg6ALKiqdLUzuYk6skHMDZN6Szg5YcGUgKEBHxXTZbV9TqJgyPmZoeWiyIYMIlZzBI39f/zhn1Hr00qKd6CknUyz5En1otq7Pt1qnNfq29a60OYFp2t6lo//qPOkIix+DrjeLvh/kggmehFHS1rMorFUAb5/GcoIQYmH5eADXzCAsysrL+uSPA7ERCIrNMPDxGlNNJQ0xYGSeBpkyTbvqqvWYYeiSOIEA9k7MDGDnDMwI5Et8KhJQIusIgaD0TodkqEwz0kSygWUFAdYtYYHHoSwDMiIAUcxKkGHoZwzHgOIIuU2ohapNNEnidI9ikKsugKB4PeJBzIvG7IEoUTYZo+gKafXWYFoNYOQJ4D9yKJVJe1JygXTQiRmce6xlgwqqgmerV9/WvOjlFbWbXU+k9u/mBFbVN3X1b77EONX0ev/02ustuX2KY9FVamU4k48HIccNnest6Wzn5JOt3SyehYWATCoMNPNQzeAwcODHINMFANJcuNIV9RwEh1LRcYVAJhsAKNCgRh6jgRrr8lUmhwrMEh45iAgUMzMBUJDkPA0RgpezapDt1TOpIDW4YWEDiyiySJWI0QuTI5AGM4Ad8YLnMC2TBuQ0AACakaWnQGMNi6o4LaXUDUiBTANBEKSBsmZOpJZWUXpsK0PLTWorC7E4ChBLyCOubOvZswLqBkmrdYssL2nlKnlq9dVWvrIcbaz+p12dqt3rqIK7at96uv1XNV7Ov9b+/My2h6fV9+u6zA10gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZvb0CB+6Nw8G9n8D90blvpYv4H703DX6VfwP3peAB4PMzTlQKfUbguIeWptznLlpO5W6ugdJDAgc8mYMlBAsBGkiySo0Auk8aKKvzBgoVOEI3UFk0OAR0XgWvH5JfMMQBp7AJic2SM0OFBwqZk2mIgtYtImE5Lkw1NCoIJVCkZRDBEkBzAwcR4kAHV0EHKhaNio5AgyAQhstNg/MeCufNx3mTyCDrAGAmhdTHaaqeRhPS6eLAkB9KnKotQgmGfDSN0EFVWXrpnloLXyMDbTV60tOrq6l+WT16366//UgnV/X//TKq0dHTKGv/WJspkMSRkKZC2Rl6jXT2kenidRuMJk6dSpzFAA+dsBpUAQIxIsWcRDK4kRVZ4fJSQRhQkJBQLMuCEfRGULqZG11xGIiF7NpATF6c9NIEQIaREmGtwChBkAb1bwEA5WUADKVOk5xQdcFypglx+HQG6FbjsA4eINjHMJE4SKkwMSKPJmzmQuYaJETNEN6KhNJi4xyQu0XMOEyHku0FnBRExCc2KA4h5uU6iGgNGAhCCT0LMymTSrQc1SRX0ygAwFIi6Mnnc0frU3T3lkq1KXvWy2q79JRRZB6P6Pr7pUzWz+6qrNepDZZcfF0R+9s9/h2/GCYDIOBUEZhLhWOLyE/iudK8PVk/kxXZREYsZqDHEEo8AAg0MPB05KNejWiAgcIAi4qaEw0IwQOB6cx4ef6YaXDL4GBxAKKjHjMI4gIEm9LBhwyLp4UDUI1aSwExFU1VvVkGKkMN5R69XghE+JiIEez7agSKxp5q8qQbhM5a+aZBaync4OrWqaCW5goBRVqSH88M9QVe12zfa3hr97pH7LxODCM8+b//3/O6y7+G6+u4VXKua/8M9Y5Y/rW//WP///+W9/y0+yt+VDo8+q1samwSliD3cYxLloqVk0SXSRqSowEaMsd6Hnk5sLg26m8LGc9R0okNVWav0YCLm7GoEBC9RhhiXXWkW7a0odEDBCEhCB4nJQAmiVxggbdxIdhbaykyAcB3+ZVSmlhpVCTy0oeAhqgLrt+xAhAP8hfK0Tl4GmIJrw1bd124cl8BpyHMbq0ssey288zEEVYpQY1us9xvxey2k5N0sSa2YYC9mHJLvnd0Mz1eG83Znd/Uwo1FCIqy2Cbf/3+d3nj3Lv/rtf8/uwqiyHBFR0g86wceoaJlFKtajwNJjFMIrqsP1IxV+lq3Ob/UYfUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHblW+gxva8M/JN/A/eV4dFST6DHNrw56k30GN6XgDaTlqq+Urfd3KKpQvtBVBMVKj6ZOkXmftAlDJtAgYKILFMHUDChwSBQMLII1oBwGTCJgxAFxoaL1FTPRgWCzVS9iqwUqdEvwYCuGhABUjB6DBgYYvQmNTgThp7WUukwW4LRZ47RhRQQMw6AwS3SdU1jS/FfDpwZnTP+ryWzcutSEuo/NPSYTJf/slh6WOFAl2o7TeIR5fG4Mzy+eu1cpbO8bTHWtW+JOhAZzLlu5lh3HmH8u4Y8+N5Yawqt7j3vc/785/97r9/znP/75KFIoHwk2Hai0B6bjdxM6k+Iy0kLnmukUv6gIgq0TmluYoWAcJwk4FzP4wW55Hs2SrLd6Z+IMxyV4qmIhoRAZf1Bw0EmLJoXAoOgFu7smLiTriSuVRYw0RTiC4g3q1HnkbMAJBGqhRmjEZGAAQLPKHjEBgitEDSYZ+ZpXKkIjDQ0ecTKhVeApa0GAX8nyFYerfuBMNw9Wvo918J3POhs4Z0EByqlzd1mpCBK/m4tl/dy2XcaXjuL44a5lmh8nHTUNr7n/3/5hjd/He7trWuV4FOgZSg7Yp7omKXuc9qLLolcIl71WLt2aiGq65z0vhgetYwEEVXgV4Geum48PRKMQqln8ZqPWaTEwMAbKNb7CyuLLNYFgsaeApdFWVGZoQoLYcAgZR3BwCIAGYUFiKZjoJIZlAEWAg7AxyhQENDBglKAgFQaZlSxgCHBE+MCjdgbXBEJUecEM5MNEDEmFuzG3Se7lM/0wTDZlNGoC2kkdx3Jq0IQ1UGN63LVea+ejzaRiKdf2qWxb3OHYrZw3uUwPjCr3Fd7t3+zO4ygSajK6mrNjnd4fvKzS444S3mdvktcFDIqIanFahCkPsm3AxeiTUw8tj52aP0GBxEetxlJWmSMWhI0ygYtizUUQPshcRcIEimLVBLJyXv5bqS6AorYU6DjaNqxtbAo0QkCLwiKBbgfsEAokeNNJAdyjOAkZKxZuFQE3McEgcxMJSiUikVQN0MTxjITQGAYKFQKVGyy5i4EEcoXIEW23U3jBd+MIggYgeU4RB2vQlh8APM19jwYjBThQxiERbWCopHIGfOnvV5TDM/HJ/q6pXQVmhWUEcupY7CMbGNeIUVAsSlyYDL8r9rKneIoRz0oi2quHN6ww7yzjvlSi1dt8h3ABGAIbY+bARyAhZDkvJnE2ONOT1LQO0VJQEkPWUuVLzRpJRx0GextgwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABuBOPwH70vDrqqfQY3teGU0m/gfvK8OfpR9Bjml4CCCUVxfD5JQXo4XOEwRKaamZV2tUFQBu68lUzRkwWL2IjIyeSPhg3WSZW4AAZC4w0QTbTgSQMcBWKEyGtxPdaq+WimFSIXMDBQFSUAHGIoJ8AU5FrSYmwdHNfrO7khipx4TL4U/D2NlfVhYoCCCRtLw8bVghTXHipniQLj97c9bZdKtW40vez25G5QOgJPK3eje+ayl7U84BrbZbfu5Z/SNgaHejt+j5zX/j+7+OrletXvYamres+c5zvcb5oVYjCo0ecAoVvOX2v7ithZyqEBcuymXsFu2untzialtunGmGCpmSS6Sw9S7zrYS2/BMKScQmsKS4uAAsEg97gCCHXlY6FoCkL3QCwc641BAlRFkYgKwoLJemcECmKY6ZzatJIXoCIxrJOw4KkJysUZLBhEigLwXqX9aGpQzUwACQ7BoQxGkZKxWJTSyBAGERGLHycLiRN5HqgBvgwMp68/2XLIl+cF5NZobc7KMHMe2O5O7V3u1EovWUDtZvFPzOW7jwQCrqvrd/WOsscefbs3Klu1XxsaiVe529z+a5jj/9/X4Yb/v3PWuB1yJcHQfcfx60JQisAH1sYliQi06kepY2dpZIQgwZLtC4fpok4HOoWttcYimZH9LlN1YvWkgwA0BQMQgxMIGg+HzCgoyI8ircCy7DhCGM4MWDVhE8Uekcn8CCV7422ucvCw+Yi7BBtK2VnBgBLfA4gHR5Wt+E73ZYQ5r5oEDyPYnDlNKnVo0bgRYLNH2e6l924duyaunhA92ty83mMqxlsAV8aeDsEj9VZTIuYYZzLuVHgwycKe3lqzfawlHJrtq5zP98w1vD9cpcbHLrl1bmbQkYfINpOgiclWNalFUWr+MRdYU4uR8+/9TfkVYWAvKkeIlpIcsca9IJPuM0+MG7IQMDhVOln25mBxtD4oCSEeAJcBAiEYFQlLGRGbUygDh0qhwOTVHnIrSYhCLK23cJW1roqfDKCcNSgBNdCw4AIzEChXaUAlrjmko5sZdeEJzLSM6lY9Hm+gO4xlXwAgA6MbRHk9qY7WZfFI6mtT0dBKJmTwdbqTr6S+rPMt09FLd5A/MLGeUKuLCd5eo6XL7cLe1Ljk3EKTDPLfNfdy59irVwsTa54zQVeGkKQoJhMAAEopKUrWPeRAzgODYoYPALGJF3LrQy5R65YndZLKj5TYLMFtIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeCVD6B/NLw24qX4D+ZXh3ZbPoH703DqjufgP3RuB6xET7Ocn5+rzQgFK8Vsi3flEgnmjGAQA2QHBN8BxSAYYFpw4VGuAGpuFwWFgYzMGg9koCNQ4IiYMPgNDIvEikoomkvFsVwwgJjNrWMeAAWAbemtBwYQjgCZCaTN5auRtgaBfpfQ6lNyhDg6/XCjkApuIEThnULjZEKWkbHahcMwOoVasfSZKcyCMReUMRr6fRp+aWERh6JWNVKXlC6ODA8+xid3nWehJmqn1DuTzY6s673W8e6tbm71mnbu7nLFPaxtf38/vdy/8uf3uFSQtE95kEhYVsiJ6h9ilpehQZtc8+X0qCkSlm0U0LFKZiaasG3BbT6Am0JVLrusMlPXs4TM2SghDGIjQCnDBQ+IhLKDDIOMFAoSB6GJEHLyqbkGOQ+KkFfoqJDCQZd4IEjEBUBQqKslEJMMnRowiDFKwuDjXpPEAvHhMjkXRa+gvDKM0+uUREHOUnS0h6K0FxBo5+0kRR51OVfa/Px6Xw8smRztHUuxWW1NWY/avTDf1ZdA9NXg/WrGWEWxWPrCJVc8+uglywhcM5VjVLrmu/rn6535u9uuz+COYZ2sb/933//+f/P/+as7AMkh8jAko/o7dTOVZfwLbVprQ4V2EgPJW5M4gY8ls3F0zJhSs6zfs/TNcGQF6QCAREwdpHkFmJUHzJyEmFoUPEsYCwDFwh5CiMzlhKQzc00kO6gTkyBWwQ0hivKUKMPMeOLaTN+gByAkOM2X+OgDVhgEmWPAwNMfKFdwppUNQM0YYAnSBPoaeWjm0iZlj5ZvcXvS7s71Lkbae0/kaZtEJc02ALCAqNz/xXd2itzrhYv5R5syhy/jGWlPLx5H8eiJ6/usMNXbXNdqV8ofpEqZDjvHLP//etd/vc/x/H5il5/6738f5+vq7ioso8GSIslsXyqkvHoEyFXCyQ/Ze+Qik1zDGNgRUJAvxejJH+45Zn1mSMs3qffJAQs9AJMGMZNFKRYEY0YIFET+qJV0WjcOt1MQKAoUkQSShAKr2rgombmKgDWKV2DCQM4uzFihp46LmZQwNRyZLC4630mLUxdbNxmwqAGaBMmfieIkkK8CZEDgFA+QDZQRbhmCgXCAFAXOBhBQ40Tcrl4ctzIkCmK2L46B5EeFMMnJlIomiaZ5IjyEJ0MALNyMLBsakVFJEIGsD1ycKRPlS6TNRNlnEjBajpMBkUnWRRUn2Sm3enzBFtTuu7UKPVWgowP9Wu7e2vt/1q1Kbr84HHTW3TFHlizqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHRlM+gfvS8Msqd/A/Wl4aYUz8B+8rw7qvX0D+bbgD+dzScwih1LlmUilcVPANyK26aVDgAXmsCw4oCFRsMBlMEJAPF0/BUABILB4oFNCAz+QKgsFqoCRg8AOEWdokF4IbUSMxLzd3oML0KCERM0mB4yB9oIC4tEpEvvDoIFthZymWcgq7j8Mdmpt8gaTB31OY3koaBRjkWg6w6oAELOl0gs9ZlJ4KopfWzYXZdGuh/TVcG/t1t02lOKsa3cZXIMNuAgbGbiMEJmv3+Grvd8+p2k13OUKGMmt2+0mfeYc/mu5f/P1h92eeIBa1oLm0CNXc9x1NcaHkPkAXYcq6DN9pXJoeRRTUSJ9GuIEH05vXyerNGn8budTaBQOCxhNN3QOBZWq4KkjQBExH6fBwGNNaEI9gJQsL7mpEPcGJXfTNYo/yaQionCuJluyIiR1tIUZjUOHXll4yCjDOpesAXlFpUqgp+ZVRxQClwNtYQYuUsSefm7KYa2PGnUl0sxzfW3uW4KWzcN0T02kjJFvGznruo/F9qZ2OS7WtvolzYhpLLWE3e1/7/+fhlh+esFgHmzzzqf////v//f///na7CKG6YDbfQ5D/1d26xa3dXRDgRrsXLgZh/kIX4ThRjtafs3NTVogBEq26O+tAyI4QaUOHEQ1Z4MQCYiwp/1DoqZkCBZIIkdBoaIZUKA02vYaAHdpDB+c+IYHgRuI4JGzO5hAyRsIhAGGL/dGVlupdUBJIPXUAkEfzqNeMzUvC1wH9pYvvKZbXbo76PUh3Lal6rqHrOMQib9UMqtJUUtjGguZ451ZvTu/dxs5UCz4RjizneHctXefrX6581jzUMNDyu3fw/O93n/jl+W+5fzUzhFkNFBMOZqO6jEqduyCaxrf3LqfT7KVJ1gzWZDQXKKLCoo6ghwYMaGxRF4JxaSExupQI2JGLwUCQIBgKFQoaYGZMClagcQH3mpWKhggBwQESQJhBYumGQw5LKlWvpDQhN5zwEosQ4WnN8jICgcSKQjAkgkhatpCPKpG2T0Ehcyh0G7y646xjSuDg1nZgsSwWMuC5M1HnSCgzL83RnMm7XZVI44k27fZG6XFR0F6zILm7O6WGME+M5vV7KSJdvb28tS3jJb/752trmuclWOGm6LXrV8dYY53u6y/mH7///D5n+d7l/475/cv1r/uf/1qVC5Vv2N0jg08XWmsOptc6iLsUtgBcxy6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABzZTPoH80vDoClfQP5peGpFK/AxvS8PLrx8Bjmm4A+EjOUwTENSErp3qndwVGqWU0knHQQgAl6BwyAgoTU6RgACwnM8H10W4NHhSCPIxqDQSPA5BjgGAQzzMMgNTmQl6FukgDMN0Uz8NRoEw4hPNvkAw+FxbMIkJcwwQApOYAOpqgEAgQ15Jes5GZbDoFPg+kx9zzdH3gfWhrQC/0WQfjleWV/Yxem7mEqdSem3VqMfl1m7AlnOYynG+61qc40fvV4PbhGWZuNZw7+Wu5V+bw5Q3r+e2BSL+VdYaq5/vuuc13+f+qlr6wMQQwPJPQTZ0qSsYmRTQp6qGKWeW9+t60y8a112oYSVQkRkXpYV+JF0z77SUszSSxyzBQBf0SFiRA8gS8ohAgEAxj0GIjQWAg26LMH9AQFEYWhbBBpEtqYIDcnS2AQAQtAAFMnwM1IG1kN8YAB5twlGHhUJDIwSJ0h3DS9eNL61L1dAewUBYZp82mGBPn5AJRQUZacitKYvSvCypiZiBi9oZgjOvXxsUkpZ5Hcbyzaqmst3QU1L3Wp17aBm85VbLd9YB5cL0cSgvbj9/v9yr47w5N4Ws6q8otqxS5YYY2/x/XMef/587haJWsJOSs24oBBeY1GmnKpzSpTbnHHXLVK+i/lmWoFku83Vr8ORql1L5XYpJ7tbdaaU6VLGUAAhATYQxEZOVdp5YUDgt9SYHeFXLLzJBgVCiZ+IQEoXrRiwVOpijIakMBQY6A/NJAHNhoLAZ2Q4Yjdi56YMLKYMlX9FQwFSLovg763s9J8WlitUWrRluRnzVJSxq0/FWWoDIb7f+uzOHcudlLf2KeF7VVsd1P4YY/co82A71RX5lYazdsR2rbrc7jzD9/+v7zCu6cO4cz/uHeZ7/fNa1+X/rVrSSh8nbOWCZ7PvO/i77g+lBG1kZr4trZtFq1EHGdNLsEHX4rHbrwugympy1SxigLAFS0USMAA1pBokexpWkwsOjH5CcVuAXAkDwE35gUCCMAFxxGHgsGU9gqGG8FACWAi2JdZp6kmUQWuhmY4LjJKhMAmJFAFBgSCy/l4PWqFuqQgNH5iMXuF7bQlkZL7OaAYSoAY9OhQ8NST2ZXeIpzNaa3ys2SzMcuqhi1NSrjrFzq3bdNzLHty7m7NqpCL8lQlTv5MYee5cpp7e/+73D/7eqUK835qczyv0md7P/3/5fn3X54Wu4fz95cy/H/z1r9Zf9250HahiIZJJW0hnmTVKWAk1ilAJ2PrEXovZIgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdZUb4B/NLw4gu30D90bh2ddPgH703DNy5fgP3RuAjhphxKgDimThXz+mL6zyuxjG3G2z4FBSDHJC5XAwOgydMLDwgJCdCfqkVPEgSkhh8VyImVwXDpgIHKqGFxCoHKBAFnIBopOkvYhAyODIx0PGYUeFK2ZkCoJDBElVeMBZ8FFWYMFSlOOVUzZ1HYLGBB2qAY2XawElXu606de99HciLPmIQ3eyrv63/bUQScfPstfiJDoSL34bhV/WFj5BipVjjLpOvtkuVTKZbexr7d/u+d1/262+Pvew5nhLaPur2u7zx/v7/8sIsFGIUpQ80iHA0cLzJLpcsVgK0xPGMrQplbAmWpaeJ97soHSkEQDCGoQ92brgpqKePRWZONFECKYNkHGwNPzLTJNMFDpjY0JrJgQG8o0OQ+mi15ajGyIPSqB0284FEV4uCW0XQIyk7ewFvKs/YVEzi2gwcIDhQLiw8FvwnZLFJRh0gIImbmSqLrw6QMCgIDnUgciHNGGGqBDRpjsHeQ4ghQAwwU6OeWkkRly+YmpFhYiufNROiQa0qugTrpMgWCFWK8gogyYjMTikaGKZJGJYNi2mug+gfSWiQ9DTQPG9TK3Ru67uovPqZtXdbsrWlMWYaFxELH84BbL5ZCdlmeeR7aWv0UAuBNj9wW4wuvs23kN5AYLU1MVlhYBMNABxbN0Fl5O8Y2MHIHo0EM4a7bSjY6YwYEISTT48Aj2o3VCQ0hryQgGCTBHEP5RqpKA7ERhZpMAYt8goXMDERYdZYiA2xMLvtL1OTHhpfTEmkMDGEBxzroWVg0GkD4NfqCmf7pwcXZy+tqvuVttO4UyddivPtzpS88xZhmHMN5VasP5LlnbEcjyrcL9DQRmrlnWsd7la3vl3mO5prtizdsdp8MJjX/yk1nzPv/Xl29c/+d/vP7+eu9z/f4VPDlqWmHUoUtpp0+EKslHOfF9QSLjS4d6MCoEU29GGEuTyHoe5MkV/qLCy7SIfsSXiCgwLH4dUpeNMEIWYsJ21Di6cNLAQ0XLLAmkEQBZhYM1MBBsUX/BxfEwQbH80Wb4Q6zBAWemHISELUndlCgcdZK8sAgEDM6DVYHGig5YFDQGpMj6JEfYBIsdZ0unxqmpEQaiBySZPmaiCk+YoF8XMx1QvSKCMDFzN1UkTheOjpWxGEwIbN1pk6JKxSMFVJPXO0ZYGZQNVoU0FHFVIoPb1mTdPdbal6qtRgDSr9fWzs9FXTq8k5rPjgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHgl09gfvTcNRKF9A/el4c2XL4B/KNw7cuXwGN6bgMMQwGwh5BGcty6iMqGvUPjqC1VghsZQOSsIDBVfO2BVoprrJNdJUJTXh4DdMkFY0YmdkI6LPwNKjDiFgJcImF7pIGKIGKu58lSDjEvc1sQBB6CqK95qYCYMEpmR5HpdAQIry6NAxrI/PutPtSMVAOiQgN+3YsPEyV64byjrDEArvxmcz0opydkb+luqTC/DXC9EZ05Ul1yg3Ufa4/WFt0lUJDrnMpGziWZ4/rO9rmOf8t1mYSLHPsx2xjKqWtay7z9461+cB2d/nl3/w7jjjvP/xs7/ed7zjkBzJueZrOuGV6TDFTCi4tehamxHQFEooASGQ3gwCDjgTyuydMS1PuU01XFKdW9bBhgCQoZM+M2T3FBMzAKb5VURgE8kM2hhAEKFKsSOo8yNRBIgj9BYjAICCo0eUSB0M8r3A0SNpSzGVIiZEcI466PLjt+/kCiAma8Gn21yXwow0I4Iint05gljEIy5O4/laMOLabP0X5vNTVrUAurhhccbJk9NnGv1rLlW9SPpn2XLAS3Llyy8S/cK05//z8Ob/nbjwT2rfaDPDlNS5Zd/X/v/5uudp1mDSzI8ClOdk76J61WYWHpyn3dalfroCWIwqEirEcmk0nU8tM7dGh0cOX3RU4hxYpgtJgIYsuLwjAMMSjhQdlTTZAXYWuMC4qiEWFw6AgxtvOAhiwiGYbRkMZwEyQeRkBwVK1DjZIXELjBUHT6VDaEYHrkQCfQu0hIMDB5h+VMISgZ+UMsQIcI/hc2IXHJJQhoxw+ROYNuF8jzc6WRA48URQgdCSKR4aJgGCi8ThfFuRPux8YJqZppjkCkUVqTNiIBZlZoZMiklXdFJIhhH0WOmjJutkXOs2vlNLbt9WjTrmZqirsF3pqIzjij2vNCsUYbotciq1yaSqYuUAEyhP+EPsJGEA3kobExTSiT/M508Mwyk6iMyIFI4BfTHhFjRUDREOmSiLwI8F5WejAXDpiYaOHIYGEoUZEA3wCKjQAkKlEMghqdaa07ApiZisEMk5p7UYGRjUaOjDyNQHAyOKgfV7y5AXNGryulayamo6zLnsWBNC3sRmUTLjNJbsGESIXfhuvDdmvZxlkbrXqRqOa0ZTKKa/y/luDYXcdfG/SMBq1+cp2wM3qU1J+NrLW+Y4/2IUP75d5Yz7nYx7d1z/7++71vm+/+9cy7+v/f7/P69nxj1iE/NINyIsOLSdw1do2FaloquJ3me9qNRsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHXVI9gxvS8MpqF9A/el4a6UD4B+9Lw10n3wGN6XhGqRo6AIkvcOPWXZgqaq15ieksMYyIiEYZTDMklxZDTBihiIkb0KoQ8DhfpCGKkMGLwIGqvCpOaeNQOZaEpY0qIYkAncLBgQkCnJVs0BAk5x4NCVwHbhUlLwwkIArDpAva18IFmWJxlpb/AA4e5GVgIBjkDkxhA5+Y08zYr0OBBO7rCpFE9a0zbb1k2+Ps0O+jbLK96DrNzXxON8dXOkRcmstXPp2ZOdFsaPWeWXP/PW6rtX8qlWW3tTFjDW6l7995f/9UX/hVJSbRPKDxOKmgFyp4RDHgjdvU1bxUTnY1wFLnKXHg7U9KVpTbS3qUcI5EJDeRCirDX8zGderYnVF0Rk7WtGJIpEXu4w5rwcGK/ixEHxdkt8wYSGCsaRRgADDtdRgQe+8nSyYCCxkCtSUzHGpFuDtBswYrDDmNrNkTUl0NClrbpZAPy022y4KEDwE0mHRlkNmeHO9K41TxKHLAgNTGeqlhsFJVmJ2m3yCHXqMKyvzNvlz89yj4r2wviey3rPd8mF35m9/61rev19WGu6wpbPPoMOZb1h+//n/974WWK5+RQHpQgrAUq3Z7+xv9mW9OKegBIQw0hRl6BjK1SqW0RvpsbUsgKZZAJAj6kgMZdCBy20FnRCJggXfqHFgoJEYCr0wcUEQIkkFBU1YGdEeFWDLfZMYCXmho5IlDxeuJpZUFAA6gBsE2cYG6Fkw4MaMoVm0MlDHjDSmeeAEViZa/d7T2kL4oC093T+Xn8XBL4hN3LMut+8dD2zTWY5gm1cvzGOe9W6ku27VSCFl497drZyqXU+dPzn6/tvX4PvOYdyl9mty5lluvn+Wv7/dV+OQkQPWFBVDxZ5Fy60cJO9GKmhYMt1vbomqPSoWZjAi/XQd6HZd89qZufK9RfBcrXncHjgxR2Dh/NBYQhtkuM/jIJtVBowBLRgjJlhBOJHSnzAxqHHSUuFSEI6zA1IxIDZ43ULhR3KqYKSlBg0pajllQPGEcHKcEwYs2q9PKqyoEXg6K2dwpSyEirpwwuW2X8lEOGLHtmoJTLs4fopU4dSKY3L7sVVp1OzWrfMM49Fc3K+CEt6PHW7mSd7DqeC+Yc7rW7+tYPvO8yyn5y5hU73eeeffz/m+3W3QyMEwiuuLCsW+g1b77AiqF9s7a5x3fpZdYgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3dxPYH7o3DnisewY3puHVXE9gfujcM8JJ8A/e14C9NIlpKR4Cbv3JVnmwKG663L5XK19BwTFkxTfTUwoYgBO8VCQxCY+OAIsGvMKA69zGhUEHAYDjA4a8HslBIIulIZ/gsPnQiQEqhpULjsaEIKdqvGFxhzIQomge8iSSzVWszpS1wt2yCkTdA5IUHQSDj6FyhhMDN9yWFKGpkQIiBDxzSXJBItmJFSmMYNI2GyaHCoOSZiMysxGkkYGZ9EyFRYljQMgDJG6J8+YHyGBoSJcOuyevePJx0zUyWkkSUxZaCC3dNaDJPUj7WUzo00VNNdFdN9/Xpb2tZmqq9XdU+AosqI3sHOadI13PooAtT/xxW4aiCQNcfz5/VNIr+GGFvLIiFknjGwk2NBAQQicOhIOCTex0MF1whYFlyZ7OQSXIWlEYKAYOJG7mBFauVHmEFtCb2MFFg60VasQqloUlDBZFElO5OFfqCia4qAxBuJhw4bGtKYs2HAE6Zsagtu0eZfI3xFe0Sit6SPzD5lALU5BlA1WU0UQlE0/tNcgpluTFJb8A40lft2thgy3SZDvQPzudu2rKlBuCaP+U+91fy7yQ6/O9W/vZH9XWdz+b/u9cy//x/uuc//svFzM7DzNFZ4uflK8PtdLqrcOsZqO7DJMuzFB6FA0i+o4P8QIti7ZDuWsKZcTt9i5uTgoMlyxjjhYEDrjKUiAEMCBHnjiOcDEAYrEZOACBKEksVIjSRd/gYEui6DlGMr5qoQZ+NDVilnpMUJuDEqom50e1a4dIBmHFAqZlhKJgaHXG8qegF/Ae6OeLslBcwHUqBoYyJAUzFE3C/RYIGVCWYWonhQhSI4ky6VIzRsMqSCRDBkFnVJnBO8nxnByRqn0XRNkjMWMqkcaF9FGi7omAyhqlOk1RTMj9RfMk1pFDdRtqR1WTQshZNBVBkaTttr9a6lM/1XV263fmbsNRIjUbh6xiLlbWLpCDH8uQyx6h0IY1pyG1UnL8lkNDmo4uNo6Pxrg0IxGC3nCwcYsfPbTBAsxZTGVGHD4MKg5dZ2Vgz6hUaitqXGGi4GhkJpNKtzeMCCR3TGYVLiSWhzVbPCEAaglI76igVBjohFLBeS1Ad0LVmoAp5cY+MO8/MtmtyFsYyOPJJZyixaLPOhZlbzVrtI52S5otfqUnd/dyosn+gCIwRR1f/8pSVgGHJHv8fx//whjmX16b8d/f8Gx5Y4lkVeUap0LSGYsSh0+tlnt7aLvsAuLf0rAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeIWb0B/NNw6or3sGOabhsFMvYM7yvDsiYegZ3teFyhRDQgh/hGxTAbkg+EAPsy7y0j8T0dBQlcMKB4y+SzGocgZShVImLhd9p68mZBcAKgIjIFygJJMQg0zuDnHSaf1TUCgcxA4QwsA1gmNgjXWFHRYaBMYUiwKMTUQwBr/BgKY+CgrKnIHgGYKAyg8QERSOIJlkVcKmTEO+IEmF+Kz0xDlZhL5alGNyXxRh+UBQfYl807t5bUn+mzz3nfbExLCwsq4yC/qrr83QhjUqhyez1+t/qOWctYTvMudkN3Hct7+45j9nO1ruGHf1///4Zf37OOvuPFRrkemZv0LDGXIhMHRZcwdcYxo1bWrTatL4x+oapSygzdDdZC6J98HNdOfzwiEYkY4DBoBM/MIA4xiPQuDrA4BA4FmqBWRByAVmw0lo25icNDJIEiKjoDgK9IFEKLKiAVAoFXYcNDBYnBR4Fge0EukcfDpAcwxfqqqY0ghALaKJy9J0Ggk0WXSIXPwFiYcwDGJeweBaIyydtYVCLUspKcwp9Vs9c5g4E8v7K49tavcV5gi/Y3KrlvHedqd5K2FVno7hzfasw5OUESvvefhzWExO61qd5j/aLd7d7vd1ufzuWvy13ff/8P1//9mqKTIpF0MW22pPYxJ5IXOocpVxttldbHPmaEADfInIrmUiDMBKcIFZy6a6XVf6Hr2ENRVI8WHH4AQ0ZCQCRg6sAUokPNecIOBX5HQudBRuIRoisiUbMiDIqIxJyAsIiIuJVAzQjMAZy7b3toKhJqa0O/BkAApoRDwySjOChE+uAVNA7rSldJHMBcF6ZS/kyc3cMzF3CCc6N27k/M3KsdsvtLK0Ma7Otnutzws3nmtZb3EpNtospsyPCrzWqzYF63rsOd/X/zWWOWXZjv51KXHv4c/lyriwQpYPUVVUaYHq3SW7XfXupiEwLm18Vejf/yjmTQkgrpcwIRNp8sZB14GFR9W2pq9rtNaguUv/5VEkb1kCxuZeUAgVWK4IFSzFy9v4OHQHNg7JTKgMhWA4pTGEmOPGNBiJwWDTEiwwAqMqGzCGUzIJIiOPhQ1OusDEB0a+xUHjKkRABp9o9Okl6YUfG2wCFRbJHQuqnK1mOTSbgBLou/Tqw7RPJIRYcZvG5mWayjlByUPdT4zTM5cDADHOrCss6t27ap2YxmQvVRVcOZV6Zb9aDLNvPmsfy1Z7rKY/HKpZx7v//61k6Hpp4xjxSB5cwl7khFBpLyV/LAV0vdJgVo400e2KVPdsUpwCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGqk69AfvK8OnJx5Bje14bcTj0B+9Lw0slnoD+bXg/lGEtCsJEnQOTLR5AX5+avTcFREhCS1rsDAuZMBGOhbbZjAoYUCJi7FhaUBQDT7MWEE8xLWTUNeAXZBiTFyoBmFCo1PFzjIDwODm5PuXsF30wHaOQABEBI1QWAg3gDjX9IQxE+D0o5EUObkxhlc09loXCGmnZqVYy7MoX9S17FLjHWw2ZfMPDP1sWCVGOy3Cs/G7+9V7Wo93N3LOG+/7GJHjH6l7eufrWsv1l3u/mst71O85u1l+873FG+KVt/Y8Uz2fQtqRiH2TNrSdoo+6t1l+y9AUlbQmAEJyqIAgCHRWCn/lMG0sWl8hoHLHR5W6nBoOBjABHxbKBQINgMnRaagFQClIANqoOVjA1xJskBwKBMrMdFmWtPMaBTVwRQAxF9HlQaBSUBBB0dFngAeJxsQibHR4CGBR+0eVhgQADQ0eoqgYhihACxO3x13ZgIwIrYM/FaUwHONFMTBHIgN3MbzdmM0diq989Ul6wWk2Ya5SWt554YQvat2G5qTcxv9mGirDdj0OX+6/Xf1r88r+t4xLL/7Zx/d/vc6/GUjEgcdNknoayte4NCJSKiAqjWxQkPQ7iuf7DSqh61Oj3gStbLEDILuQUFgbytORtYG9+MZ+1TygcA10S8RihjASFQZ627KuMOG2dQWW8cILDSxgCCggdGrsQjBhImsYwJIYMiSYCzmRhQXBBHXCwQoFKQaOHCr5lqoTrIiEnWdsCD2LER6A4LTUOQOWaXXGhUw+ld44fWQbp0saD9v9empEXpgebs0taYXtH4nYYlWptLvuJHRe7lAuv3qZeTUi3k6+P/zt+XwH2bysfh39a5+uTWffqzuf6q8/6Hmu/e6xzBVRA8LPXJizS9yRerZXr4yq81at6TZNvvbUsatyhSxXUQANBGguEnK7Q1+0bwwn+yIlCzNnjAQADBSJAmTqpEoaFBItFla/I8QARtwcTBGMEBycpETZEYCELbpWhUujIKRyERpCgHGgQ1gBAc5aRAqVAcwkTUh4qmswRQJ7V3gElOhB1JBcHFgrKUv4/kyzowVKuUc9QPxJoHGBWB4nRWclV3eqbp38r8qKw0oMAXlxl9F+f/NSLScvfm5bv8cKaSuLjXfS1+u//OZ/9z/1nZ3+qv/908tnqKIx7J2Teki8mp/jf7lJf2a0/YMRIEFLmwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB19NvAH70vDSKbegY5peHPUy8AfvS8Mxpl6A/el4FgRisCJJUa6Hnac7gzSy6tXlcqp00X/koUFBokAT6rAkaWwFvMSFn5MKC3FMDBCYFEIoYCwgruS7NdDFjmgprSE1zFc0ycXEACLSYdIumXwJBcxWmbmH8BIIQcugUSJZCTGAxCCMexNc5DgIAEolNmqqUKGPq6obPIks/Asni/spAp5WBvZfy5DkNYW6zQaOmlKs2ZCDlEzHlR2+6+S7dCI4ZMFv5awu15vCxetXvx1r+/++TvN0EZ5luAMv/OXd1nHbIHF1QklcfGoeYExABa2niwOkd7SU/IhU6ggA2oqIXg021QAMErxfC1KmT8syGDCIcFu3FH3gyen4Cmb0ppoWSgorAFOjINAAuNMZmBQICki/LWwQAX6ibuGJQGhEvdEIDAV6CoPmUFuzBqrAIVT3ERvKxqTAiFGAgucKMBh5XBiOYGq7AYFwFRRlkIoGNNcUgWBJMCfOZmo1fsjs1lcrzgCXS5wRwxIoE3U0sC/cpt5NNp71Rs9oqgKfOpZ/DX61ACVWHZLY7rmfKdZ/Jmgsfz//f6/ln/1Lf78xr/3a//q/qzZ1D2ua5yiqt9/bpFWIZ8wu1yld9Gm/uesdLOJ0EGKMrURAWS6Hsqbty3bnYnOJZuoWSEiQFObX2RgAcMuFlkzgYFUQqcvyUBABlwiqIA8xQSYoaccN6AQY6RkBykMBJhGu6AYAUJUGjynExdzBdiMCi8GNlkksBJ2/j9iNqByaSo4eXu9j7yJI2HXPO9VRLZtDs1Eo09wFHq9nOy6Ip5WLkjl6vs6egRRuJCPzqA2lV955U7oSGLy+831vedataiDo28u3st97n/7uzvN7iVbW4nO87dpMv3EwqK2gqlpQgUUOEqHpcDpQywbvS6LoeKpxc45a0F+tzXE0LVyAu29IrFYZQDuIaUzCbsRIMF5V2nsxyRpvEQPGkYhYFSpiKMpAAmIhJEHN1WtHWxuyYYIFUXf51BZTYmYeWtdRqNyAR5WVOY8KmsgD8wGSkhq9eYHiEQczNr6/m4Oe3Z82qGPGmysjQwcMNtGptpCXPYkZChMRqkiUeuP8FQM5W1cm1TQNb5Tw9h9WWVU05djapu471Xj06mjv6vO7/9Qa50/M5Xsu/++/+dnfNzXe7oZ3n7ud/dd19z2qEMsmPedtp9dbvTVW5H/ceeKamUurAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAd8VbwDHNry1omXkGN6Xh29dvAH8o3DrK/eAY5RuCwtJmla8nGlU+shdJ37U1GcpVKoDjqnQcFm6hcUqWmIBJE18Qsy8E2LsvUsa+LCgiA5QDhldgIlSEBF1chkEdvwBRWcJDyuEvzDRLMzgZ92LIShcDGIY+agAZAEGQNNApOlaJFC9I2PEpoh0wQIKWm5RWB1NGhOkZrDKdRagmoNg2HTBgFe2+XlU2nSi1ucVgnLVYmBurimuSxZtntr+wNyrazYLa3u1dvqPQLY3dsd//w/+7s718hxw5FMcc6+P/Xvc/nNb/8f/f//3/fjefdd83+/z3vst+WOyXzbCZAFz390QZdy7PP4u7J3/Ky5gLJn3kutYjb122cSuUUtuN0cg5T0YOEJKIyVuYNAowx4wYEMpMnFhkIGfYbmYOKiomNECL4IEE3TCjImASAVPJel7L+MQejRQAHBa0gaRnL3wNqAMgMoRiVbEpyQsGXOSLT6nEFjJA4OmMJ5lUCuucG6rbLItUh2H4+OB2/gS1tN+IW6tacilyxWkPVWTPKG9j+9V5Vgua1t67XOfy++L0b3E7GXOfl/O85/NzuPORizjndx/69w6IHjDrVXqEuPE8uOLnltQnu2VF6gxgXW1nCSK0U1ZagBWHWRgL0tCLOcniPQtmcVM+Yex+VEoEZzFjBQHLtEAvhuAh0BmPQSlFSiEAtKAo4dQeAAiVoGGj9BA7fwx0JkIjAQZOlDxUChxjIDGYQYvZ4lqm7CsYkjZgwEoLowSkiBg8AwcH3VjJcswgORGIE+KGJ4EwJ8igd0DIdQxSQKTpByeHyA8UUS4W2ElEZqMSIjqFImBNDhC3g1DIo8oFIaZNvcyLpiHkNEBAZ2dZk4e0K+W2LK6K1sgp0muTKKSRTZJ0HrmqNlULNrSbap03qWctOqes2eQcQDqjJbNK7Sryoxxi1qkvlbFgt7bDEwChNPR6HlCFS3IvOWotR6h6YjNPIpIwNEOMowoVGCAW4ctQaNMANS1lwsC48jNETAAkFQOUFFKwSNqjgEKKuzBQOAahHhA0QwemgUJFLGPlyDlRXMBMYBNgqABUyp5ciqr6dbcYARmwHFUONUyOOGqAwCKWLAHatBaeXydJtMnh+AMQFksESMg6UPaHaeL5mQI4UDQejgWeJJmUU61GYhpdMWTIgSSk1pJkiLDMiPO6zPpJI5dMXSKJqlQdeiy62orRZ1pXs17oKWk6pnqWXk1qNUgw8TiwmdoigcMiFIsGowkZ0C7yuQ6XDmkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGgVs8gxujcOksh4A/lG4d6WruDHKNwzsknkD+aXgzgXBH0fUjm7wNi69PKZVKq9vGIYJ/DwVmYSMPqYuRRdwgYEGMikAwlAdaMDF0mFbxxvKHxQ8HAzAwc3vuY5VHlH6MhUBgTKGahk2+44LHAy4AZRY3S3FgVXRCOQUW8lK1IFMXIg4/UYrERHwH6i5SgM8BhsgfQgpFSCDiZMQHIiVnKwXHIYNskCWKQmRsU3EB3D2jdRTJhBJ1EMHYiNUkJFWdS3NpSPsZva2mdSrc/rS00rezu+vr3Vqt1tubQksN1PuY9Wi1ymJ6enHVt6rEAAYVBAx+AVCwIWPSn0NdNi0trqim30TJGgJLAKBrBhcEPez0CiswCF0KnVeqKNHhoLiEYAQsbQaEDA4JWCKhWS7MNNoz0PViJ0BQOGAgazqHTAIYOCjsw6aAioFQGM3fpBG7qZqfLZgqAzLQlDBnYgIc4pCfQxwwGZA7a8UCS5uREtkKOcFlYsB5ZEwoOD0yQN0CuQ0qk+VDUjQaBSWY6SyFFRiLhTHLdIY5S1I1C6K6RkYn61oPZO1z9SzZbJmz/31ooVI9BlbdbNc/WyGtJBJSSalzWs+w8pd5kUrfawgu1venZeeiCyTQAJMpti22VpeOs/k4+1NSurAlPD8UlKiyoX2MLB9BAZMEdeAwKCBp8K9UUIhItEwYLS9aqxgAflDATRKC7EyZcrKEVGDIghE+g63DCAGQApbEILBDeMJqMaN86qxVpMCkmAqA3NL0A0PGgBYRFRekeLBuLaH7CFQ/oHHsgNBSGEaPQ9luAgiJySTGRDYh0GbCwoB7hkVCmHRIAhAlhEmB8lrTFxDpMiIuiLONVooSgHsjRL5GGZuigulejMC0q6NczNUEEzZWyFet2SuozatL+gZRPCioda59gZj2ZyVYAGJPpEb0V0djw/EL9dgadpJEynaBOgB8sJ+nM6hrx+w9zOkqWtEQLZ4YQDMFBAZh5sZZkyeBFvzS9Z6K9MChgYEwQLWfjRzhRhEfr0AEEEgAt9yywXkATT1pDglMYHoVAglHBQELmflirHmXNQc4Rgx9eUGW9dKZiT+shompgtS1eMw/J7UrlTTYz/Yqv52bed66996ZpJNihMs9q1b28c4ei2nAz+9Yzxww1JFr9+pa3+//9//4Xv5jj3/ruLg1IkVxFFXLqc4OjQ9DETRay7xVqEBaQzv8WDdhhZL2BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB49TuwMb2vLeK5dwZ3RuG/Uk7gxzS8O4rx2BjlG4DouyDUtRQJwEoInq6rhTk3G32v50kViamzrGXgyQQeFO/BYVFSE3giXGJhLOjDEwvUYkCmGBQOsRUGARKXQHptVM60UJzVb6UJkNQRdt93xgmOk7zGsM5sHC4WrCuIVO1b3kmkmAKFGzHocSo2uLKmYwak/DEpOABhYCWa6e6eihkZIl/WYBBoJFlHnMeRwYAZ3SUvEKZovBGbUbi/MuxF2nm6+dr3BoqXlz6dsKhFNKrN/u9a/Krrmdu93PDWsPvf/4f+stc1/e/zXe/WTcfx3RiBWwn2fyb+/Led/ToPYrxJlbJpO09/vbnevaU6bc62BcNszIV1GBHF4dks5EPdG72LRWIy4cBBoFa2NTywxjoNDrdxEDAAKfmiYzH0/HEMkESFWXASioiGoDNAIo4b7WAboBQGrKYCeBATAyeYIHjrIkLJJS6hcEbEn2MhT+whN51woaAiALiulYELDMmYzgvg1ED0shBEWFlm5AiuA4kLAdH8AkEO5AiY7CdWGklIuFItlwLlkONVE6hNiZIcamAipmaETNTzJrUMeGCjZZHWM0mU9VZfbTSUqhZkHbT19vOPodTa0lZjYCUN0VVUUy6Eh54HCA9PqoZ6PrQ+kwra+lS8CwiHF5Iu+kL1EoIl8SjM1UHQGCACwsFBxpJmoNJIQQXlMhhJWNF8EgiNGFwQRAwmEQwSgEKQuBCIZx8EApm5oqFhgZdFKAyKOw5GrclgJAZudFGDAKURsdArSVyGIGJ9II2zKoGKWHhbIsWJTkmc9iqj/IMHDgNYkEmwtuk7TGWm00ZGiL8qVymNwTTUVNj1POoik81PDOX7uw9DVJg4nft7/93LEAu7T1Zy3nV/P//etRXn6pfy1X4gUeY1n8JqOz6CUiOS9ETdgdjZV7HYsb0KQ9/0M9Jp9UiDWsRLAS3Q+hWOTSeOTT3Sq1hLaGSNPEQiMIgAUB5iIIOqYQALWmEMvMMBm/GIY0let4xeDhUzBADSMDnK0ky6NVomNqOYcAbvNYS2AAWhXQwLHGwkYVWIKqIqDFYXrAoRQWaGvN/AaJjUhHGgZJXzIQQOKVEKkiHwgeBiGRyoKKTJmQ4+Bh4JFSLC0gshKg6iBjjLBgLEVkSkPJmBACPLpm7pFEZo2JswDPjaKRL6NaCAkIdIamBYPJFF7Ke8kWpGN3M0WWttkHZdlW2ordDXdejXZJ7mVcXUcMqN79RhtUsPIXqbodZaOao1OozCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdwVbsB/NLw5kmXYGd7XhnRIO4H74uDxK6dQY5RuBYiraw+SsBcG4o2pyZ1Y/j+36scdghDZiUEF5AMXEyjLpPgN2xkKAYSNLUUBxRVKQj8v6EDwKkYiDbqEQvSyFBGYNFpuFWCxLWYsKYAZIYJYbXeWwOdCMGjQih44BWcSsEoEfGRqGKFGFzHOahAjCkwfencexDxmJ5MFgKFVPpJSDhrfx8Ki1I1FcxOFyiB2Lyygn1NK5ALimpU9mPWx/nCZpy/rP7zf9tU7cHUjUfqX9z3/+etfT2d/MX+/qx//j+f0n/39c/+/+sf1u/90LLJsRqNteNS+ujIoio1R4O1MxY6MHpSgWetb9bmtctor/M/EqTB2EhouwZdy8ohDM/GpW/tZcY4eGFBqigRMr1MbBG/urJMbCJE0hQq2vzMiNRG3GVgZCLA0nQOOCHDDSs4O+JltqClAXOAxplqgQoWm4NxBogrZUODgBSBaRVxblk72paHcjqq7NXWZyy92V8Ow+ho4Uq+kxoZS+swYgJItQaCRFNWXPBSS+Nw0xHkRuQ/KiwFQ/ZoKbL3rxm3OxTLwu53//+0cQTYlmEze7Lv/Wfe/nZ79znda/ff/941FD3X3NPNOT90q1T5gcE1vreulKo5QxNyCYpfVWlYXvelbh7GekmCDDnEnGewpdcMhzObM+kxKvn6hVFxkFFCIDIqmZhidFmBDAAEFjLVMhIvg8aFSIPEiMwUaAzetkIJ4KAiUYIhnaBBZGefQmLAYW2cWUQjg47MHhcaWylb7w4FwOjDBbYHfBoqMZiFC98ovJ4648IcB8CgLEwObNR4P1BEhMGhSV3BYIRna5oxE7OCiFypKFb7SDEpqQTvu4c7NyPs1n2Nb//v4ukmv2S1u1Nc5/f/D/+pdvfu4jU5XttqgiLWqb3UI/Ed/Rb8j+/MZQxeXU0d5fxPMS8vhf1C5F2Myuclz6V2YLiISIARQOCAwKCYdDjKpsnMwEOTjNUqnytuM2hQKgqkhZxjQDM7g5U4KsRiANnJgwnzNomAwjGJAMDACzkQDA0EkwBEwwqqfQsYeNBIOAKz1BUrhUcGhicFgG1p9B9F8XODdcV4QmA8VkFAQ0Ehrj5EKEQAyZ4LrEUAGYEPMyJjQNyTGXDS3NFE4bgEhSBHkR4sNBymOYsNkUoipLsgsnjcNYJRWmQ2UqnZ9T5gijWZNo13RrSbqf2nbOtT1I63VmB4Veow5thldqtZtYVQeerHsPlO4v0NDwEGCtIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHiFS6gfzS8Ntph2Bje14ZjP7sDGtrgzufnYD9bXAJCdKcEcBFipKkWRD1QrD8ZzL4tdfaHBkRgJZEJEEh+XiMGGmUNoCQSYSBcYMBAMEAKAR0YP0LGQwKBTOICEARKoIbiY/LYECpugatNiZCBAq2B4HJ4vEBAOcKZRjYiBD3RnnmCgRGkmXZfpDIg7HhaPNZciiaJOtbYmvI1DJBbKHIKlVK0gdHvKQBh4jrBnMru35IJA5JOXVMuKxvdNVK3I5CcpmYlM/nm7OXMcO4RBK6LY01ii//7/fz//mst458//taxuUvP/DXP5/f/v/98diOVim1tDoecKWgJlLB59gxL0Cd8sPU1ZygnSOyxMQIVpa8KFL6KHsCdxrzT2l2n1kVufnWtP2OlRkQqODRgANYJmKhUgDQ8AD7fskgjawN8SODDzQo0xEXigkgjN+SRk4OwD6BkKlyJw1KGBALPUrz5RIV0wE3pKqRdlQV9IAYGygkIDB3Flz8Q9dj0hWEk7MDPYZRhszNYfxgOGBCkyUcBBYdnbLov3exlqTFmJS5tfTYeWYpLuEckO4DgWdYHe6zye5jh+Cby37cfq6s87+Wv1vet1su8zx73C/39WbBu/PPTba+1M3RumE2mF1++fmLoq1CqX2MTrYhIJLHmvNKZ2oHEYMg6DrzXGzZzMScN3REBHhZUSAokWrOrKp6JFg8pFMJbQYlcRKNigYPAtci1FuAGoGAx2kxm+oeFSef1AYaKKj0AlSuUhGjY9cVfDTQBPd90ohQORHXUtZMYlSCaRR9dGCI8+0G3qz1mYkA0GOHHpTaszZEMPuW/XDlaSWmK1rSll6vaXrUVLYu5PbjDd786vvZz3C7zfbtaJN/n9+pw2xBkYVItOqUWrVJ3rNyVVtyNpbm3a72GqUbV0r6KHv7kM6VqjSnCJuAOAkI0h1H4YpwNkfrSaXyB8yVAYI4VEgkoWYbQJOs+IQIS2YtCyge01iUFk0IKiQ9MnQRyBQAc/AaduB0Kxl9w2mmBmFF+AxQROySjHFkHf4VB3VdSFyN4qrYAukGesBEAwS1KVTsvT77DphUe0GHHsgus12dMQLFXgIHU4+w2CXXIzQKn7drOvMBcAo87UH9f+znM2/gTfulY/f/lASWVHKa0qc2Mzo95c88OCpvUTizKBVZd93HWW8xLrOdbnG1Z6WYJKyM5rv/UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGWT+7Axva4PDpN0A/e14djRroDG+Lg7YknQGd7XjBS5eAyMKFbZalPE6G84VuJU3aG0IgQeohCBGSADhHCELTGzhQiAhowtDIxUBh8Qh7gI4iOXWCFBoxgXWQbaUmqKYcHL4ZCnKM3aRqGjfio2aXxGIoAsVzi/0oGPM1Awyz9NIwUBNtAHkkjvww9MBwuHWImINbRYKh+rLpMyEwcCdwiFKvx1VOdv28nToKkwq+0tr796Xzc9W+pJutvli+vNb/OzMtY1qVzvb75+ZEjZLforqfYNGRZL/b9ueahwsLXmWuvb/sY1NhVYrhlhyAD0DUCHFsOkgpJ0LeRKNw8/D4QMFyQzQjCoYJBKEg0sjbZSgYFjDhxFV8Iu2o6E4jTaQJIs5FQWMMLWoGXWZnGmLAbNV/PyYkBhEgNDCdI4PGW1IBBRdqFQ1ZqawWEE1UvVhndMPMTbFUeGW5LebG2F4lAXKQKFJ5LZyYfvx2KPUYyODwiLFkRt2IvT17DruM8dLGX88dEY5nM24DjWrcofjBysNS57O7wy3K0grUco53///59r//etcsa393NB9AWHsSUQCIuO2LMlngc2WaskTCwpraZHHp8VIJwuytMa9hUulDRaxN7yIrResHGhaC6N0tD3s5h9tmu9ijmQzHoKZi95AfGFgphI+ZMLiwMemIlAE0EMFjij9k6w5iIo18BCJWBmOgYpsj14IxQDhZbM5YLN3dF1L5poWYsEJE+xIMv2FBIdaZph4bDwfeZogsByoCdjRPXEIQ+YlAAIA4kCWSx923FgN+2DK6MOGwIES+YDnHWvL6MBglAYLBWae+oyCSyS3RN2kkvxUAutfiVSYeqW9x3WlteTX/WCvfljN6noLsVIzz//v/h3f67/2FrDt07uDCZoAsVKQMkg8C/fqUREgomfDqUumWRqggpnevUgeWFg/a7WRJusISgZKOkPzPROGm6RuG45KXguM4c8dDjKCQKl5ICM5MqNlR9LLCMDcFSCBjVhQDVjNNCRCdjxsIxoMzizwBkDDY4oM0ZEkRAAmcl5hAaYkDlAAIxs7+MZWJt4qHp9pqAIXSpZenEw8zEvOLOLyELyvy0WJpjPlDJotOq13IdibdKd3hAttDJh25XlbsW77tSxOnO1B7qxIsxDtqvHpba/kqXD166LB6YO33t/JsblXnqkFnmWGv/+9/8/5rv9xtPYgS5kQDA+9To5TkKe6Za1yU2Ke1wuhLmm0nkl2vCLZVcxYdcZUVrm2IydQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABnI+uoMb4uDrqZcwZ5peHQUg5gxvi4NTpF0Bnm14adKBEJVk6sRiTB2VWX/swzdjV3S6yQ0M7EjDAMiekbzllpLmCRgRFsdM9W8IAVOiUaVWAS4YREkX6KloO6l7mjnh0AmXxLJyJSow40AxttUZqXSCV0CiWGCOB1fsyWrFhoQNhMBA1EoWGxMCIk+9M9DdrkXZgYXEBWBmvv/LnpvuyBhKCQK8tLus0v7NScgutDNZYPNcshxtMdv6/c1Mdei96+b3P5q68M5ySWZC9ZRqYkepJd7tk20/fRbV+rb5ZZxd6Kiu9HX6pa1fXeMRbTBAsEVK9S3DKGRvquuXvy9b6T9Vc0lS2MUDUeGphgIKQMIi9SEdVIYJBjL12iRPecCCiUGWBoARumkQh8xSBmNkIbNRCuwnOFgK/pghYmZQgrU3EwgJDtQrMaJAHb8RBNPrEwiVCtJB1QQnR5PYdUg7jEIdf6fQ1kGR0rAseX6/jW4y/7WTOXjElWg/8vc+xlKKKBsK8bULggAhHOxrPK81/WV+N6cD7rP72Pdfip3CaKDJDZ3rn8/9frn/u1vu7HdZa/93Xk95es/XoKsxDaVQYeXbLOrJYYwGRmEJWwUD9tNIP2lzewid0wI1wQ5AHS2hpUx9Y7WHXciWuap+Yf5/17jKAZITmDhAACBCJGo2afWYMCjDjZhae6Warw4nFhgzcjHVM74AHVs1pMKgCY8egQHZg3d8AYAgrijEwaS7S2EQ1OpLwwsMSJxjoHTiLipaM+MUgmRl7EFTB4AIAGotMvG4EmgCCU9CQ0hwJdZ8pGoVFrph8GFwo/2pIWARp7pmWMM7GK5d6sgxntwHmnt95QQnjY72TVLVrWpmLPGqOk7Mf//vn/rXf3zfe/XgA7cnZakBWyHTqQizrLDL1oZsuDWUIqtW1brnD1LLOUfzdpJWPNiJgxAC1BLg/MUjUegWhzlUOSCJP2Y0DRg8LAUGtdMEhR02xjgORHXoVQGLCCEGBwEhQYtHaWAsABEHzAQCZaKB4DJdbtlVz8OKZNA0NqhMBhQ6SoTBK6NIgoUAbD0KgoVMaTGfseHRGJnChCCFP6CIfrQenFmv0ykGFgiHZTAN16G7BCOtKXTtqTN5K6taGYLr2X9Vg4VROQY3IGo+a+pWyXzv3Rt9/XMIJiOnjjOH5f3X///z/3//X+Vtu5Xf3XfWn837naGL0mG0LD0zoghmUzQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeZSLkDHNrw5ckHMGd8XBwc/OYMb4uDO59dAZ1xcGHtfYoLhKriy8gXc7qftIvi5DDY2vvw2wqNjEo4MMAUeRAIBZk9mDwHRwLzmWgiw1yAccGljJFcUxoMmkE2pMABAXFhggHGHnwGB5RxK5CagSMiyI2MBkBRdEAGYUjJjBHB0LAoFUBHgZTZK4xYEYSVBQws1OiQwCBMkadI3RS8UNYcnsZQeJxvzD8Xh6s3IQFqwMqo5RNPvT0ULkjc6PUcCAW4hXGrEDMm3j9y+99xdF7bC89Zc39O6Fye+9v+8/fP1zX7y1+Fj59IlVnZGcQJqIeqnUN+gUrHAtYBlNPiwfDQtaIlSLbmDRSdAKy8XVXkhtlnUOHUadk5NE5DktZjTc7kBwNL29btBAjCwIVmCB5j48pikBPkICIAozQAfJlQCDWWCo6MBZUODDkBa4QAA8ELokNINPSV79F5XLEIFM+gotuSgQLFkzlPBR1GHw0+gsAh4IlAThxjCsJhsAEARNTBJcjePlHq8ofhtUezAoJdVxmmvjFmBygw8Z2Hw5flUMLWsbmpQ+FH9lecSAACa7avxrv6+SauLKy5G5P3PlzrG5BQR+S/+////9c1+8u/9hwvHqZqUHRj+Mt0YE6i7OTeolCpu4Nj2lWZVM0TQYWQF8zQrMNQsGsGIxn0heBtFTQxANp2olEn5hpskDtuFQgy4rMTDjCxlDw5SJaw4QyTmWh8UUMMbFWdGICACAjDSEwgsOGDQq6ABLEQADl8OJEThCAAgDSRMts01oCyIDNMAITOZrQwqzAhDRUoASwiwKK5g8Fl/y3JKHQiTlACZAt6AJTImuPaiEZRAK9pXIp+rHKUFDh+uSyt1OSil0/Vd6QSmoVgOG0FXyzemc5+f3IXcZ33JYDLP/xpnYj+d2U4o0EJJwegKWZZ6Xo1Wf6m/YTGqQy0sOLNS8BowDSg6yxrbXpGPocp/GdOEKgmFAJHvSzp43DfWy0WLUE1LZMVSJrFgsXBxQrAEQl12Qkgc2gVy1fhyt0AMMZEZxOIKQOjiNAYA+xAEtliqotfYnoLhkHUMHBph5gAmHKHiOGwWOC6GtCwDMAA9h5fNOsv6YPFJlkop5cYNZZ3gzt8W6mEAux+HrVPblDSTAg6XtKYvSVH9+YkecPVJVTsOqIbQ9fguB+67hWh/JbP7ikn///sy4k/dpzXU5ahO5Bqb7lb7rU//ToUcWWirRW86zlGdD0dzl1oKP9IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHUEo5AxzS8OQI9zBjfVwbORzmDG+Lg5wjnIGd8XCLt8HMBsxJIDwi2rS1yVUTiUtx84m3CFu2DRQJCkxmGm7m3zIX6ZYkSEH9TPIKhJfAJGzchGMjAwkInYYVExxEJgIfmEzuHBdsBdiMhYCkFTMvAd2hIFAIQnkgYY2khdZsKF7XREAIQJiijIxgaFRYXvJUwRC2DU65WdrKXMc46VkZts7ZnDuJ7h25+4ZnJTKS98MYT0eHgNuGLxbyKDoS9faRIda/dBawYZl7L7Pe6uUjWm0y3M3+//9/9b//13v2f/O19iw9oHWdvq0O641KjGF49BWfcwWF8gRh5h5yhYOtesUOqY2JgotfThNiEQArQFAbiuhTdrllxX5c1n7qP9JioNmLmphAUPHqIoCSnih8kHTbyNFpRcwQSaaYWBMZNbOjCTQHT4wIHLioYHCNbfBBkRgcgZUYWFoZwhIhwSQMHQBOCwiMIR8MhgIGAKSvgBPYvcEAQwNGcwkBgxELhTh9ofjFCuhpUuVtBoNMqaY3OZn6ZkZguCKLNqX4SlpcN0UdpWuUUvnFLbwUA15cJY/nP3lVYtbT27t0p7/3huzKblzO3+//ev1jrf6/n2aapfln19///QUS4UL3z3e9jRSlK3IYHReXQdSjrcmWNANIgW1IEvAySGWc8uPGsK4+UTn+joOYkTmCAoQkAYIPsB1m1lgjIiZ9VkGIBLUzCSUiBTBB8ZFAyJALCc2gKDmoPjyuEkzA6zTGkRMkiFUctAI2NjqUZpgKfhVAwkF0oguBZsGhOPL+C4dM0B8MCEai70r6dWYh5gplFCEwEhb5Yv3PUSeMgnql6fWZC6OJQQUAKP1IgvPJD+kqQ28/f7upCOMPve7lju8cd4S+1yt3///////3v9V3IetCD36v+r331nXt+HBh9ZdphS0uij5jJsO482jLrXheCBSxkCXxNWu01GWBnXwZ7EX0vNjgRKkxpAHgADRaGgKYHVmTBgIwZSVVhkADamI4Sx8pESE4HtcCqZrplKjMopWNsbI2PgkEGLtcPNdTxCCDBhdPiRYdJwReAQEEViIGAgFQ8omDACXjMDg41Qw2BqDyt4XpTKcuBHnEjqt1345EX7myECmDBOpvE5dGLT8N/2ki6VeO6cmA0SFAo781cd3X5/ucpWQ/lDGu9/t6CUz6OSVLf/rn////47/O64APWgoaoUvV1b/rvMa746EzUwphNiyRF9ta3lBcIJU5ijkjQwXSSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3BHOQM84uDn6OcgP3xcHTU05Azza8O4H5xBrfFwQpesQJHG4LfGxDLhYKIL/m2EQO1qldqQTaS5iUiCEBGHASwg4CVy1y5B0EmXB2rc4gOWTlmBBGFwGCRQPA4DIAwYZTYwwDBYYrMIsDHpCwHZco8YkEZqUAA0CqbDglMgvQxzDDgAYCgkMHgBLFFSGBgDKvgULic2KES0rMnQfd1JC2zglUJmJ2ugHYNGXAq0AoAzAwLk05bjeKg1i7KpwuxZidtNLpfzGXP7EsNZ9ut77sW7qw9n8+VsHBfilrVufr//99//7/8vyLAtJpo9P//a5bxHawA2ANh5N0RKfnS95NaySRcAizGXtKmCywG1GlzHYBfOUTVPqESQnRBHQztZutZCgQZOJjImYeRBAQY6JteWQGAZuwisWdEi5BMAAxVA2sbEIAJk5iRCdoWF3DHZlhyPBMBJphcFGM9cZ8DQQOUPRQ6GGrqYVKJswGjAIWYRAMiE6PpACJMgKlJrElA4XTDQpyWvVBE22hiMDKkXs7kfcKRggCmCxYsarypJ07ncfZ2KNsmM1Mq8jIBAbrZUkK/n5SWK6btzSypB38sJlfb/Z36TL9f/Nb/XP7+8LVkWi9fR/s/v7nHzrFKaAXPCh98Yw05rohQl7SJBbUG3pYlL0iygjvAIIydEaSRxHx42lP9A0PRmIVIaaXBsySjEiBQcigYETYikQCt1AwVM3hZYwiAIGIiRgAGiaRjoPjArAR1MCBY2kKQQEAwuIHqaoZjwDHAcYGWxiMOAICDQXMABI30jxUzE4xEYWRKakoonYCAMICELwSAHoNTDWxMEjk3IWGs6SpN8rjFwR4YHk1ynXGTGbHu36llpr7P5apUM5XVwRF4nXEqWaeXWu83I+0+GTZs8uf23Ab5W7fef//////3//Lv/l//z/+z/6P/T9a70tTNihmqWAQVER9o27NIEqwGEbRaaa1FRCMHgBbddJuaIgDgkeQgU8GOsihiMurRORAUNw+WBo0A8KAM3YBMWAjKjIvmsgQG5mJGgOHAkxIUTkMBAi3JqiIDE0bUjBlo85ZLMBZwFhcYBk5mIhUBGG4Eb+AQKD4OBhgchn6ZMYxcIOnBCCp0rCBgIYqAgQMjwlCAOYbMwRhEvmJxR2GXtkkU45JgITgoAwE7tLKpgSBzPVwR9+Kt2Nymfr3GByirWYfPhwNeW9akXO/2dheTKc9t3ezv/yle0iAnY/QcV56WvuuT+q/19eip5BIoEQC06dE4hi0sRjzs+LnazE5qU82UUp0LCcQEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAa3PzkDO+Lg5of3EGd9XBsk/OQM74uDY5/cgZ3xcH+fwOIIKQuQSKvJmqm9UDr5m3ddiFPi0sEDxk5sXXBA4OCxjeqgKwGSQ2AkVwnoUPkUAIElyEYQVZRJZFWYKlYqGG1hSvlqyp905DG6MMOB0WAK4zAoAB5fMPkIBnAYFErg+2mjD0NszMFjUQpNEJacSiTqLYRueUYAJRHxoaKMztWHZ1fQOBEVsT/eqVYxCtiwyflFxZ8vLgvluOuvrut0EOXZVv3nt/zeM3EGo3Pl/70rrql6qP/a/+3pQSrFEANS4qIiJu22xwPGDUgq8SpbqDLEOGOQqs9Rco1VTlDIClOWevMx+hag5LWZM9jGKYgFjEyEwEKMlHTDAIzchUcc9Qg0sCYMwUxIPZSBBEHBRmaeOwpR1GFpB+KWTARmK2HBRUAmjFxXyMJwsB0KhAftOMEAZOOAkMUilAQgolI+LFEARMHAQVLzLJmAwIGTAbiwMS2VPPQU7yM9WeFAb69kqhmVv+9wjAevZlv7eOJy2KTa7rVJBKw0FBUDnm5EbmsvybovSo6GWdWdzx39Oo8/Px2avf7rbLdP7e1ez3IGtyw/OnEmzxcedfFQ+hCgK9zCJptJ/FBA60+fUXKtHckQiDBgqccAyjqsUAMowjsKj8CQmH2JjB4YaKs+DnUcGzh8Zaa1BCGmQIcsYUZmGu+Mlbkm0AQhiSikEJIdWGgYSDIBM9x33Q4oymJxupWW4bAMBk14cjBqBB6NHBYW8R9S1W2XtYyOhkwQDzR5OMHgGNQS+y5oATdYCh1M6GEMALJ4nm2duTngYI5427HRwAw7BEcpGV2aadYJLCUERutYiWev+CpnBxfxe3L/3uw9T90+rfUd2c/T/7P/60LXm4aYUQOaqEjUspk6QEKbmLedFyK2TrSxF9nbQ9BOQCyGhGGKIt0h6NwU6cdjjqYMiKgUaoXFsyh6HggxYaf2KGDgxhggyRYYuEw0ECTOSFQMDaQEvEBec+cKdGRKyay2A4EiLaGFzyLdweHQgAJgcsHCYSZFV5gkDuGkAUAJAEmQYAArWzAQDMHksxCGyYFr8n3trwNjF1KDBQ4iK33Hf2fZk7QVAz/XsfmVs01JRx1RjnzazZSOguYvXN/3LT1Pr7U+ZwX3/3V0xhUf4z17D2X/r/7P//kwmbYgpHSx+cKqaWXoW2LGVGw4fGHTSVpScQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHbT84Axzi4OsNpxBjlG5bzPTiDPOLgzKfXIGd8XBMZhatxtQD6LVTkXygLW6oJRRF0M4lEEsyoZBARCoAAhBp0HHGCJBhAOBgIadAg0EkjzCQaLxAQKg4DhkzBixKJaYBH5scPBgnMVlKJpGhcG1FbzKAaMaiswMAwwGgQlGNF+Yn3ILRoFFAOBia6v1XJvusXkAwCEvwmAqFtGJyJUyJkDN0MlkASB7ArNy0r2RmIww+0ppKWCyEDUEuiskWral8qXniAQO61mH3lywy3lnWhVrTjW//m6VnxMC6apu+t32n2+Atf/sX+kzUIkBF4D1iBZ2EmFBcbFDiVgIUNtCCGBKHAATWQAjROJyqc1xKQjSQnQkOoVjeaLs9ZQ0edfqBVFl1FgGA4OommUgAEBwxqNaFugVBJlYCsOdAugywMDxMATGhpMLo0BE4RFk1cOAaAzKJFFgKgsUAhVFgxDWTgANV8lwDTSb7lRgyVmlweXNWyNBAQAGHw4NNAYuoMcxCCgTtM7KgkA4hmDoXSA5KcOaLKGbJwjjpYBtUgZgRMwKwW4E7FwhHDf1kedC3s3AIBEFRI9LdjARcpjMsxMOihTRG4F3l44Xzyv6+3//U3///7//a1lUNnV2rqeo3/CZ+/0pse2eyxz5sZ461+eSTyrtm+zH3IoW/KPhwFmwkXYgRcjTaNkjYGnRiNQ2yJe5CThkHoqigQWDOLjJs72Do+MlCBkKBAwgB3SMDEJwANNAsjzTQEAhnMyEIHBwwAaXbV4nk0AKggquIwKAFTIskQLNrh4sZU0oGRwCBAVbUGAB7VvwA5xh0EnATWRA9P+hnrUMIbwIpUZGCokClOWVSiAKzIgUPaSmvX6cRgGFTTAK0A2rEja1RoUvl8Oz2/w3ST+dNhnFcef+eGTKg+Gf579H/r9H3uKpORUTEltE4eeE7FoiQ5oFHpA71CsPkGCFibTQ1KU12uo/HemZFoquy2Cp9ZlHUbx1X2fSMStpQ9AkoQYMYiwiYYUNPgEEi5p5mkUjwCANfhAJqBmqnQUqQUGGIFR2QSJChpACxJuiXk2sMYfkpkoVkgIccwkEj4RtMtAsMvYVDKuW5KlcMmEL0F5SEaG3C8PD1YzjPRG26wTGW+ARIV/cbPUcqU0bkT1/K5dUymJd9LBFBYiLPMEm8sKSi//3Wfq8zC98rz//x02NxreM2j/////R+58y16hGNOvbkiL5e0WUx6HpDrWctfIgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABoA+uQMb4uDmZ/cAY31cGvEc5Axvi4OiwJxBrlG4ZvD49cQOMdBycwgasMy932uuw0GVZRmNkiEBkhhoYGF6T5jQsyu9AGYcO9SLDo+VGGhxMEnEkohPzfAUwgcPWDXwMDMEYlNl/uy3YwKghqOCQpjAMB5n4kCtfUEZMNBxC1EpuJd1SxCWIhgY6RAQE2bTlNEFFlmS9kBikwCwMdafl0AxRPdPtz8dVdIJOTcY006MxrBTiwMgSR5X8v//mq2NJRcdqz//h8Bvbfq4fyv93//v+jada5hNBKKqYJSDWIcTFCJ7iQIWPWRc5ByMFlN5EaQhk1XBrokXbYrJGSqXunHXZiL0S6Gx6ALpG3i5QImAm8jUrEBUdKpDwW0oycGmwgEMDDjum0xaXGwExVQODXzBwY1cIZgtNsK1Y2YYNWYlgS2heEwZFY4DN8xPGYeZIQgulSJAUMgUvJWNAOCABMEQ5MjzXXwomsM1l6YzBMSBgBAUBELXHt9XPBkZMGwGb3n4ypszULeLkJEySaolbcC2Lq6o43+t7jcO2UM53rsd5rn5R9fm69Df9v///+muuvUrWVEIs0hCBMUQcPAmTPDwdKBAJJGvKiqXHAoGVBSWHWDhzAoAMHSMRkEbkM9RQbDHopWUDp43EHod4QkgQNyZCeMgB38WkM1VJ0SUmJl7TNhRpYjS7JwCQYULBG6IlIZN01jADQSCAuAIoSwCAAweKDOAXLUl8RULBQ8gHTmZQmFQSGBxu5f1NsaBbrJVmBQGY6SaaDkx+RuFDzlPsnaID2rltotF34n6QwCAoRKuW6RDexainWsyivaafQiMAxrkf5/f3qdxdPHUE3v13WVlemOGu/////////9//////fUTn+o4cYlcRGVD2qY56X12G1QoBg+59Ksuv9TQyws4D4UvJiteTyaWuNrz1TDsVYg4EAEIFIkSIQCAi4RAwkF0oUyIRsaqFBMAEh05IZFBYyc2WLBQBGYAGX3NajJGoxcESIAqol2X8VOKOkDZcLgdQ4KmkyZRjBBIDKEKAtEciBgoAKQICNcwCETAwDNAq4ue40PjrGRImOUPQeMDFqSOFGJwho6RqiEwGiOlEvk6ibiCZCG6BcE7E0iQMLuOAhALSLpFrLOkqKmcDmGyiJGi2ZFMuCGIJT6////////////39rtV3rotXRUrZFbrrV3ut2U31LpVnVGUy1Is0UhBkWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAalPziDO+LgzmfnIGd8XBrk/OIM74uDNB+cgY3xcEHkyA4s41wwVC9R2HWPOI3eXNDZfDkCda0OgxREyUtkFCE2bWAgDAyLhjAUs0gAjHBlphkgQJGRzbWFmo1QLMPHgmnHhswR7UvcpWBmK6DH7JAydRyf9P81SPjFWHOPhELicFC1JBMJQcmCq1QuFQcJDgIYTDi6onfhUrUpqLKMXGqJv+zatJow/5gYCzuONvxoARaxS1KeXUnX8htSEVxpafP8ebheb8Wuxzn/v7PHjtaqd/nP0//7O1icczWCFd8tUbS6K9ChyT8YPeJyh4codw8MS40rBJhpRoHGwInMki4Erc2ITMJf2vWwFREOVSqEGVEokAmDmK0XJApCZgfqdQeEEjOTDRsuidwCAlAEjEcQzFBpjQYV0yDaH77NuZKDBr0GKiQFmFhgcuZZiRJE0qCoFYktcVCKwo8D4ESsMFg030eRICtFd+GG6QWvtzWZiEEhwPlsqdnOEtFMAhSVT2Xy9BC+c9Yqx21lmzTNedNz5D/6z5KMFvWd0OOP/32eOz25Nd//////i+3TvkdoDNte+4UCD7iYvRLni1R9d6ELXO4wcqdDAC3c1MNsSp12zECtYjDXqRjDtMiMXAFkDxAYIPGpbKaUvQBmMCLpluCs7W0YapEwKb9HCKIQklVBNTKFrmFykpLlxWkozFjfMShUtInMOAY2QAzIihB7PBo1DgC9ynDLzAIHWOpoYJFhuY4F5WdQl2uPA+zPXVBSzKBC89qL2JW1kwaE5POSukjhfqWVZmOQJPRuy+9hMaXYzco3zu7Nzkq5VdPHf7ualTOuasc/nf///0u+wNyqnQKlLXOpajGscgWFSDkqWRYMCwlErgAdadU7z6DITicVSIhsnfWNVJU276dkkMQxBw6RwhKo0sZTNMiOFINLHhUPPnPfABD8vMCDVznQnJhZQnGn+bQAtqBA1v1MS46zhCDDCjwM9ghzlekQOF5eOwoDC5W1Dm/YQEISPAxaAiApgoFgsvkxHbC78OO/eo2lNwMDDxkz5z1mu7MFEgBqUmM5mn5CsKKhf6jrTrjyt0Yp/bH8//iu10/8zf3/44MKkXdUGX////+vTdOignLl1VPIGlqiAQ3KWssLsQXcok4VEk2hq3tLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaqRziDO+Lg0QfnEGN8XB2k/N4Mc4uDv8UcAY5RuZuXBWICxDEZb9AHGnFn3Brv1yAM6d4ofMsFYHMdDxgFPVsEk6QhFRoNdafCDRKcw9PGgwzmRMFfhYvKhicIPAoFMTdxIJa6VgD5l0hkOmzQCGB4eACg5wkejooI1sOC9QdTZC6JoKJatsBg2YCU6CB+YRbbhBbixFKcxQV2pTsBQqnwlgMEEH0u8acublRWYlGqsf7Gs1KeZYtW5l/7peQz/IE7+W8qTPLGrvn/////////f/9H/9/+ou0cxoYiFwlIPaMRJqcRC55TKUkiaBgLOdlEBNMdqJYaCMgCoGk7cOuypTDtJWbyCIvJ1wFQvDAkZBwICIiCqHBrxAwwN8QmgrBDIU7ZCGAIbOMXkUiIaMGGjLANvRGpSBlYsDQESgQwLXCgfJRJLAQzm/HgBYIZ0CQWAAcGnMBIEc0DDdoQIAIoWjXy6BwVwluDsyd1pMtsxmJxIKy97sLcCsbGgzD07W5UmpmWSygYpU1Vdrihkv+IRX+63vfrmx+tP//99RyTcyqc//////QkwMUPeQh5Lk67ww55MSNbDjH4jcIWQ4pij6Tq2VYIwF/Du0+MTdjSvk+nqYeoVDtiLMgTaEYDMWhpN8woJiYEnXD2JABe5CAw53Vm4AEDuuY2E5h0BiNsCqEEmeYIDRnobkIINFMBGgGAF51xKmMGF41WGlnMuBADOaRAx1VCejEI/LJjwNgVKgQhEcApeUx0EDSbMBAZZAq57pUtiCndhZAiGgy5k7zTlJTgwGuJT0sO+rc92oVEWPy23bj9cgAVi+2Brf//zjQ6B0OXHu/Wu1PqCQEnc7f6eKnP+z3v79aY5Np8Y10QsKoSLhUcFULCYCCINjzgiFHvAKhgfOAq0wGAfMqJsFJ9ChqbhQw/YMTxkL1hgIira7LGXNhDSKaClaCoQwwXKYGOhqLBUwaOrTgGDxiaWL7WloCwZagKgIhCBkM9mERKJBMwWGjJIHVhIDivKEFYDWGRkGbMZ0ECODdQIUjdkZFGgPZklCwQBi34oB0AJgYGI1GAgEYvHZsJUhwIjLXjQXIVBnxkR8gFUAswSYlMcwcsiJFQMqIEECKpIFIRAghPkmUgUDoLL46UAtmLEak8Le/NjBYbK6yYNtVhEk0jjnv/9u3/X//////16b/bd0rO1NTnHupe6l1rRrVqVtUvUtWy2anRdZ5Sez1KsdoEIfMAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHRz84Azzi4O5wtwBnlG5aLPbiDO+Lg5+2HAGeUblbEGClwBpGZxwtPdIkuAvF3WKy+jgaekTMiAGmAgO4hhoRqGD4yQOUpGQcYmCSYqi5EN1TEB2MBggx8yzB4iDEcYRBRk0HqXmtziXZfZlSdRIAjArkMHgZTBLgdGBneSmDtYb5CwXDIYHyIJKPwQDAMmmEAAxOBjdRTDhLA7SpU+0LnoqOgEw2aVmzrbQ+1yjgkwqD0z6a1jacyT0lqoNACalXuNiKgGc5Tsm7r9R6Y9Xffndb/9XmqKC41K+f87+ln++n/SNUpl6Xi7T54REUhpgkLPMGVYoCIqweCRcYKiWDBskSB5BUKpKQoYgCMRBgY5lpTNiTU51qcbglwqz7rMKo9AgRQnGMwumIYwG7BI4DA+bhCIGBS7DFYFcoYBYiCJgFFGHVOGBoCAMx+AlxEBATqLKP3ACDBVnxxAMKHhQCGFwie5IhhdBCW8BAaLXqCO404EhklAgjAJiIVm2RILBthajIyAdQaYigxwYRAlaC0UWeWEj5OlABBMWasmDpZDoyqsixfDcHjxDxSyYWQl2YlLeoiMQiNmI426ShSQmaCltV/+//+3////bqr+ylf3Wqt1sglQWg29nsvWqpdKzstG6CaK1tugyKnrUtZ/JIhtjQQTcf5+XRNaYlXHrHqd1TqLMYgbKxewlk0raYuAN1CFpG08xkRxfwcBTUgFrmgEqQSPG5WBGtzgNRTEQAtKZaIJhnLHzDhgAQahiKmPR2EBgwSA10DIdM1vQC5Ix6FILJhU0wLAJkQwBZemCIR6ajL6jUUfqljUhcF/krjGxYai8cFROksPAYQHUj5nywplYnZh9F3z12o2uKxKusYE5/N1pu7AHdSrn8xucuQN4RH/p////6ZRhVYy9T2Ejho5aXSHYmFVHzYhTl3CQ4+I4VigTUoLPPD7SCOM5ckMFMEBjZpVMvSqRyXqdSs4ooLTDoCSHDAUqoYzEiAyLAgQGKycu10AuJGPLuU6MzF8cWJjwDCMLhgsAgBMHhhjY6BlPiQDUJMmqg7MJkK0OhggdnbmsYCKRvYFGAAoocrSooyYRARWx+hgZGFhBBDeQ+UBlxOgeuaiEoHAagSBmROHiDFMV8PkEPOlQ6RcUiP5SNiGA2OloyJkiJYAqGPqZdlsXi2mOugXENTGhYFLO5r/sv//7//f//t/+9TV299BXmSl2oEEGHb+BEO9LcBKMabHmjGiwGxgJizxWaMeCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABmM+OIMb4uDt7ibwZ5RuWhj04gxvi4ONt5wBnk25ZmwMDGEYRQIBUocxB92LReA2QUTkRWC4TMF6BgBDAEcADlZkIAoKVRM5CWoOgYWIuqFFOsbs8mAMYkEIFgaoLgG8hT2s/U9tJUURoMAY8M1dhYKG8FiI8EZWAAwACINKie5MlDIu9AggBxiRPA4Gr0isCYN0YxNo4mVQePBF5pNdiLuKXofqQt1LWaDNPTY3JZKsaRv81/Rbkemf13c1LN0N7cz//jnj9PeyDf//////3WIQJgueSaLE6RYzDcSqte3GqOQMDg2OEUXA7qFtSFIoKIbTEADlVNXuYdA7xwK4j8uV15BwVgkIxoxUKS1oWB7+qGGGwEaiBazWwmCAmxZUsCGlRkIUSJSgWAA0eUGDNQlbkFwIspUBgAEmbX+GwhfRgADmAzYI7OZZVpGYRUWFwAwPoptcEQbUBYsX7M3E1MVrq0yGjGkTIsiMYBq4gbWOSblEyLpEAMKIWoqGzkwMIvoEXBxYoHyGkuiEIc0YplSy3QJ5x2mzE8VKlJpHRsIonu3/a3/+7a1f9Vf21V91317tpbLR01JLqTpoqQQQZaJ7DWEN0673XQLan0rm/LjsxwlO0y0pthqrrmJaFgBAAPogo3Rp+JFK3rjENxSgdAZBUZ4wCiggAzQLBkd6AEk4y1wZAl7mFCQsPnHnwgWzWgQcJDDCFrhpR+oXJVZYhfMTAwCgAYAKlAVBJ1EzGLaIbMCAiCw8G3SaLAZdlO5zTAYRMqItpTowLjx2183kJ5kQ2hAPtP/VqxtioOF7a0mdukVQq5Z3Hdl0YpWuXU5ZDnnIu//K0txw/4Mw/f8xs2DIZ//0///3TR29S2FGyAaYaKD0pccWk0JaTCki45CIHCJ1haQYUA4nQ+h4VFNRw0tTbdZyl+4SzYEh+DHBs4W3KFAaYPBDOjB4JUwEAYbxvBCGzJYdZlBYKHasa2IiBnSYGF4tOASABCIVDTNZCS9HQADhApaMAMVuoKxKK7PAKRTsL0MO3E1YDSwBh4ACQFS9ekLhRQNaY6BzOIRJgPG2/IIgMYZixiuhXILBJMcQ5JFioSQbARErGJuZC0IokUIaHGGCI/kucC/hOplAp3qUqMtkaipHUUho0DlX+/vX/////7f/t6tNfQUpS9Gyq3dSjqnkhEPAI9Vc6/efdkxOqGNSUepLZRwlAFzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcfcTgDHKty9O8G8Ge0bl3d+N4M8q3Lo8bcAa5RuBABpAJCWSNygIpzJZK3cjbBXTa02J83gZwQjMwEBGhmKxKIw8ZcZrMFF2uAIbN/HjAQNggwiIF0GoA+YWIYKmoBBJrMBrWMjhIWGzIR4Dq+RSECsMCAIWBidZgYAHvDIMvY6EBBQUFmlMRQEpXo/BUBCIAggcmfzcAg27EXJAqFkVAfAWTAOXAfwZUlymU0A/ICw5HJK6BibBxZElkXJoVw6cSGqYB3kTdZhfMWURFlFlu6yUIegdu/v///q3///6//3+tv9S1q0b9G2o6tjFHGyj9v2q5X48+zwD/Tey7+07jKLJVhAgIuBAZ0VGWADCUfIHThifV6MegOGGeprhYFCEFZseCFhg6Kq0KcwCA4wpAp7BEAJgEEjD1oIwgJEgUEosvKGRguCgjAMxAF0SCIvePAjdUNMIlzAQ+iwZIHmEgDHEwNmLS2mBAFvWPBpMCAAEjzAIF2FjQBGCgJGK42IEVevONQbgxwgMTgr4GtLiCpJkPHNJkfJICdRykkS4sQmIAswHUPs3WTZBEQ6cyRNyJPzFGK1SpIa0kRqFdajA9/7dS+v6//7V79at1f/Upm+7O9aqlalM6TpXahWktmdK55bVHEhSff4doykyPzXZGPCVawl4RpK4ugItSgRKpEdIhC6URNe7lxKCXGpn+W4SlEAB0VA4qLAKAzgqkIhmsA7RExWAKXjxeYMIRSXMNYiMsAI3AEAuXTHZCUHMlBSHqcAgJ1mZGNVgliNABbZgkYHn5SY9LQfVBQhO0NAoYDy+0wYsPAZEY2QREAMBTgxo5hGhf4lgAAKBlVXgYMAIxUTcipfHNDexZBAkDcvhZwiRoVyaGbMSKxnimF/ziy8SO8ppmBfZyAGnZZeKDrS///6kG1f/+v7b6q6k/b3rps1GnrqagzrTuylrpLSUgrZqklq0bLpMs6hKLPZ26ISW9RzxniDdEgFGMwYY45YdBGQFtZVsf5fK54daBDExesLDgwZGExEo4DA7TmCSErRSGAwkBhg2HIIJrUTAIXRwKJwYQIg1FVMTAwHcwwmilaVNl0uw65gBMhCSAxWIQOYNIx21ymB4OCjG9YsHRIBKxKtMHgKjXgRAIy0U0ZoJj4/DrIoH6k4gBsCYjsnScKajMmgDjY4zY3OojOl08eJ4pJqKgy7iDSikRppWpRZTSHUtiVX0GLBWps1T//b/Vv//1f///vqda1qW3uz3U1qKq1JJUXWydEz23S3anXdb3WpVNO1S2epbLZTskjQcygIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHRoY4AxyjcvBxZvBrlG4ZaPjiDG+Lgy8fnAGd8XAlbA4h2c/lC0DlwzbYldUKt71N0huHoiuEKDscBjODIAPLOHBAuLABuYJBJmMMu8MgUDBhNUEAFBszoOjAiQAV1MCAs24AhIGGKxqpNf0CLEZgYFHpiQHKAovCg9MvUox6tQl0FQcF/CYErXCAQicztQcLgcx2dQKAGTyAWEgREwviXgvcB/IwXeK7LJibEMAJEkqbImRgIJlU+RdEZ44iaC4TUUQ1PlEk/KJXVdhz0Uq00UiPUgbf//V///+////6v69V7JXWjUmhUpNq3dFLXWm+mz0VrrXZ7tvdSmmDu5ntHus5e+JMOUNcJ7ThBTJm1QsWaEyZmrtQOmo0x7X6f11yQiGIBGwkoMZbYxcP3/h1mgcdUkk5jEoFVcYKA4sJzYorMCooOhidw8Ao+KHNiIjAbNWoJNmIDiVj9siMwjMZhepGA6iaRAINAo8AQwKlQHwwYKAbBAIAAEEDc4MVEwFyzEiZREJhxkcBrSwoIliNMUjMQUAzwYhizZA3NigXSqXRki6slRORMCAx9RSLTaRGuskzyR4/1ubCjsUzrav9ruv9f9/6/1/+r199NPb1U1OhXdGkydmQuyDKVq1rQd11ovRUy0mek6FSDLWozX1IuhpIGaKyVTk8OyTSguaX7htUsWfp3Za0/dNKn3c0QCIqEo7GUgYjCjwStB6CSyBgpkzlrRhAO4QoALuM/UTAOADfpInGmHYCAA5UDAp/m7beMCiciIKtzGREQDfT9HayEeUhCgYEEryQFqUtWtrHEQYMklKtYfmQyWWJ3Pk7ACZRfl5pBM44xQwQAqTtrubqUmNHxW2LXOz2DKqPuFBv/3yj+m58t/+/zUfgbO4j7f///s/G7IDdNgcy08NcRQEhRQ80+BXmHidjh16wAYaNtF2xsEKXgIQUgN28aHXeqZNyH78MSmIu5CoYkRAXGJFCxTMgRY5q5RL05AqHjoi1pNEcEImKFTQjoGAkLAVArcJhyPAwuTPlsUd5E8SAwsp3aXyYIDBzhsmNmSAtuBQ2r1PJDRS8IDS5VSEA+M9GAWGtFBNNG3oeGWOMTExcErls/UwnxIPKel2eOMpn7GMw9tjDJ8qVmOXN2d8/XJBnH891+///jNxjO7X/q/3//+7tT3Vxp3HvesoIjACIFHNKmjREQqU140Y6vPpUZLNIgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABjY9OIMb4uDp8ObwZ5RuXjIa3gxyrcOfPFvBnlG5oUlyAzsJFDop6SxeNS6NstidNG7MJIAkxMASfBIMgRNyXlWxAIBzcAFyXxBRUwYGgSKJijUIPgokQqaHLi8DB0W6bHXckC0wuJU7S7g8FUIzxJUME3c0oBxgFDQRasiwhtNLncAwEJjHg/gdSx35mM0qjsnjxlgpsphucqbqxYwKDcamH2GT1r1PaZVP9tQjbG8Ma8C///MWMe81P3//9YVXsLHf/9P///90VQJ1ztYUNreE2niKwM8cYUE1LrcAAC0PgU2KKQ8Z0Z4J4ugR8PTSGWOiQsIidArsVGAP0/lCIwsZAJYXBA4L2HmUBSrxnZMEANXp+DDDgPh0wWAS2hn1SqZFA4TmMfgcqgAACNVrmV2uNkMSGAxSBgwAJsI5HuwMYWCBSDgaF0EqhghASoRYUr1T1C4GMUK8s7TxAaxDydF0TgW4A1IoFEBFDIZ0tEmMoAY5GXJB0DgzjmaChH9RQHGoWigUCf8oGKIvlMRiXSUURbVIO9d//d///X//6r//9XrVU9FetmbQZlougizpbLQTet0VJUWqZNGmtBC10HSWpdFSSrOeVip5vPYV04j7mXAaAt2byjhGWp+v84kfgppsYsyGWkAVRfgwHJAgBRkNWqjgYgDJi0IuytUaEDimBQmraYXMYjmiVpgscmqRckGDnwJBNSstavdD8QrEMNQ0EUkQYKz1CGMPd0wIDWEg4mEwEBoomcWRtaMEjYOkxWB3FdsVQngiYN1BnhyAMroQEQBN0SePkqN4EQQDnE6imoSUvGJPlwLmWMzQspjKE6kXBpq5YJ1YzKSy0f3QUOgiq0zyezf9a7f/q/9Xq1fVV/+qjXWrqQayrqUpNBaSSbH1rZa1pMknXWpbWdalNe6lqZbVumkfZ1mj+QFUkxDCmaCOU0QzumFwiYpKtNFrUELkZZfaVEVoOYoGY8HwJAZmkJEQXAxuTVpwoMjOBeYWoOCicsYGBEhBpi5VCIICRZMDBcCBBTUxCPEAMiTqZ0XmMGoAAAwUAKXgwPzmi+JEUPaICA2DC+KPMIJgmqZ0E+RVCF+3JewvE+M2PkR+NADLIQJBRyCaIuUyTFrAAdEkXSsgiRhQJw0LpDEz6I7lHXRNzLdRGHFCEqM39SzIWycMn9ttv///9W2r////b1KbWkicOrQVWgitzjLe7JoKZ3rWnQTPBTAgU88YE6TP6S6uEXY0g03gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaKPjgDG+Lg75Hm8Gt0blpA+OAMb4uDSrgcAZ5NuSUSCUVcfVmGo8xfisjyuvL3PaZEZQ4z5QWqUEhiDRiYqm+YjOLSnVwAACli0BQBf8wQZVeYw5GN5Q8tmDI5shMtEFTUReNENIZ9h46lCaIgagjGCcZneoxyzU4ZEYVKBq14EgFFV2IOYSQhgwMCE3WFPbyXRt/5BAJiQyoO3nosxedg8Rga33DHNl2pZG7isWVerMVXa3lfoP//uXNRz/lV//3lyOQq1dTZ+3////zrnxetgVEYxqR4aJ0CINGYQNXkgK8UHOCrjYsfAkuLhQ6HFkvMYwqFAoJvGaNJjJJszYMuyApNEopLH2ZoIyk1A3EQWaQVISww5a2pgYmMm7MKoExww0b8LCwWBjQJUsBhMeqcnCAwkAGiL7aNcQFJzQsw+MHqAMQlOxw6BHyFyoFpQwHprEwWX3TTJgyC1VgqAnTEo0COVOD4E3CvCUhcgrYAKEIDDuKRTNxlifAGDh9SfME1EWJ0zLpsJxMi+mOximeRNTu7kciYDHILNVL2MygYscV///r//+///97d7919dCloMpaalvdqmRey0E9JkFMfWhVZFFBaDrRWmpJkDBFdNSSDrou61JOya31o6zKR/oum60881X0j8sZpbsRZrLxUL708BRGBAoHioGZOMDgUbdDowOgCQwv7RPqEGS/gsNISjAFMwNcATUWYO6Bx4ANGI2TNYUHTmQ5GBkQY3ATiqkMChk26rDEldAY/EIlCASgaIAehswNv1yoxpohAKeBrMmjq8WawtohgchMTxmLssmadfOdezhdZbawt2V+71ajOT02N3ZT//+WOs+ahjn/+/moPxuhn+ylv+r//oOPGMA4ZFmjz4VcMEQJDiAsMHLOuuFQGGtx90y5AcOmhRiBRLeHWZGhULjDYCq0ulj8PXlHtQe4sqa4Qh0xMGhgDGIBGnUlNFFzggGmkwGlnDIcKWJGAQGukz2TjBIdDjSFBcVRy4xispTy6nbZe2EYBw8bTBIEX8YDE5wVCGEEwNNJHdHt8kvXnd9PFTcQCMxeA2iObbKAuYwFZODGAeinx8EWLpwZsmwDZil2Uccm2MzRA3UdOEPkERdzKhWm8a7OZauod9TN/+//r+r//r/V/+r9+tXrUtlIobroqMlr8nJf5+5k9DonZ5It+Bfxnf2XmxFpkYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHRYE3gxyjcsrnpwBnfFwc6hzeDPKNyxwfXAGN7XBMtgBLUzABChZ7EWTKwPHNyidZVqWPBJhGBTBQOW2ZMBRACTcpWDAWvBMQeSKgDVg4aLyMCgZHkxiTBoFmNQGBC0YEGtozePkrmlue0yCDGYKMdBxiCYYQDDpQZMqEETZ4JF4YAYeMCAhPNQRqzQzDAfMOkYuhWfslzw7RJhzBogYbCLWTw5A/jqOEaHxF9lnyaDoiIEcXTAcRikgNJIjEUjhC25xRkyyJHl1NYizrSS//3/b/+r/9TffVq6+pW+mtlJrU603MaKCS13dBTUUrKoLZal1Lugk9FFdC1zQn3tgH/e11OwtuAwV+hAmcMYzyrcpg1+gaq0ONObQSp2o0vwsFYwPsjB18LCRhg2/i7wYNGEHiOrYAULzYEEXeOSPRwhHo0wMNF0ZbxhCu5D+QQzp+ACEyYqLxRaMABM6MOjBEOIQJGkin6CgUl0AsEYc6JhsGDwDX7L7E67DhR1hIOOTOqB369m28pgIMNOzwzyiOe+ac7O58q3A2X4zvP/O73ce/ufP/n8ibZx53//20e2v626l62TaSyrWSgssMCFpNxKNHsHCAqFQOfGnUDZ/MpLlViI5L6AxJpYGKTDUff5GeIPXIKdnkCtgnBkRmIgeKAodCaEkDegoCEQMDiMxqGWLEIAAoRZmIwyqExISQAB1ggaFjXoFLnGiCujHbtKsXOLAkOFqZTrhUXG+zyYJHxObyoLZSpIEhxtENVNnBMFjMzYVXNa1D6Q1C+KFJIEIIDFaiYFFOIJsWQbEGp82PrDqlUkTyQuFE4iNhEcZkmWSgvnSRkPyItZ1psiqrS/b/1///6///6/V/XXs6mZJVNI47OszUtSKCCXVRWmpaCDLooJpJqRUpJbM6SS1TqlLpPL9UpFWSGp4lgTRFUQWNOlmbuo9V2oPs4y7pfudrMUJSUy4iHA8w4seExcYlcCItG7A8UYIChiWgQeU2DxMdGCaMIC8wxEaiAFZPh6GUOQwoRn4lCIwP+Omxy9qZzHEzogwrEpMw0Nfm01ZpaghgYgupjl/eoCXPcf40QLRyiMWp7Muk4KF7HeX+4U9PWyVxl3UZ2vG9vV/v6+7nuJ/rn///8G1N3d6P//V/s7OwUrgF7AiFWCQICUUIkh6XEGiky8WD4mcCCiEwafHJF1LeTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABnA9OAMb4uDq8Ybwa3RuWtIQ4AxyjctROZwBjlG5c9jINqKRHTMAXMhJbrDDutkgh+cZEviTDJSHDys4OkgKDHRqIsBvqhSZmLYtLMNApwCB6fxgpQIARLghNzexpi5sbAtxzHKQMXUjIPAEaAK8BQLmD0gYAFg2ChwPq1p4g0GuqoswNToLCUHRp3HUf6S5RJaVK6hisJqRkFnueU2TA5vMs8dVJ/sV051/WUb3DtX8JDz//GR7qZ6nv///C/KBZn+3//2fQvuTQetKhA8bAsWCDzgbFwqwLhRZoLG6jIsawgDZ0CFgEJHLDBiMtwQdDthVhKYGACJmQaRA6B4ncllPTQEwwqF4FLwsCG2CIoBGbDcgYsDR0xUfkSMgIDapjYcNBJyQ8MHhNWA4EAdKX4MZSRYAdOEMwVuFD8yYJEhVO4Gop0uUIDgemAoADQOrSYkGq1oiNDaYODhUR3bYzLycGeD/BgAjRmQObgC0wbRoViWGuISAEFw8RcRWgTBsUy8gHzlJFZEmDBhnUe7sclBcpN6Q+SWZbvVf/r/X3Vt//7/9VdXq732U/tRVVUeepN1n1IOk1JqOipFJ6KS0EtVFq3QUbpup0GRUmySK0qC6mZM0qtsuVAsxE0GuqG6CzDURZVVh2HWfQ1nTx97RgUmEAOiaY0EAyCTGxydluC3QgKPLLSIERIKA5nRg4WmAggYKAA6QzLgeQmmPDKrDxMdkCwwUAgcIE3FvCADGnC+ZGhw1xhUKoB2LAQJqFIKxpCaj6AAENA1oT8mBAGFNJgXMBoA4fcmyUIsmblQAwS9NBA6Rc1NI5i0S6SjDPG0yHelzhgjyde1aaI8oX///2/t//f///v+vX7de7LTe7M73RUgytOp1VWZOtFGe2Z9TJVPSNEIoK5Bqz1Kl7W/agoUYkUjSTIfdij0smYdNSiclTp2I4VRGYWDSHwGVYqAAcdnAa2kQRKZ+kqTEoEaGIhqvIzSURARAgMkhCMBjFlBhwdJmMnjEaUeBApCDgmIxcBAg50ETCyIFk60RrTFxGFnJVXaU75g4TGRwUUANmrQTQgxgK+TId0DacRukALRbOlAioGIdEENUzRQ/IIFKKwgYRvKEFzZln6rKRUTL0W6nRKroO////////b///f6/6qd6N6lqZ0VPdlmzUZcw8GwtobRs4ld/ImqSqYJZnO6U0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAZZPTgDO+Lg6hC28GOUbl4mLtwMco3DM7ecAY3RuYSk0YLIjgBhZjIt0kK+2g0Eqh2C7sk5LBklBUUKBBjA2wwcZYddIsmjS1F0TCQOGTAQhvTBxIqExQQmBBAHMUVDC0hvE9msPetAwKWgUwGFp7JfAbHGEbQaHBSqIsE36JA8oEl1AzOFmmOgK/rz4TmUtdSH3IMKi5MyMyyXUduunZJ+37OTRKXWNal1lk4vIb79DJP//yq8vfuGv1/8/kwMPf//+j/9OaQPWQFiwANPPBNgaaRNrWoMnRUJhxrAgZigRhskPWBw+uoJOKucueeRFTaX6XKz2DxhQB+4XIHIeKCnJCwhMEgkcBYNFT5GKAu87zhQTGKiFcaWPFF7zBAESzMsHgUOiWIYBjVYDSyMHl0WBjd442RQ4AiEwCEUaWQmBRMclUZksmC0YGAU6zforqsVQfFPQwSLDOwSm4ZVCSpRIKMErCdgMf0EBkBzlGhgOcBo04LASeRUmNQkWZhCVnNxk0xBpdUiVL2SKyhzk1l9tJS5pUp/b6u/r9f9X/V1fr3/W/q0KKa6DvTospTvRejTsp0UlukpJd1MpJq1KSRouauhTepKgiyZggYfzUIu1hGgFQT4gyxoGpsM8RSZErRGV7N2d2jdx8lG4oIBaYFAskGm0GAcyGfG5uQFguSA96CAAgwPREKi+HDBwjJEUCiKIzIVR+WgABzJgi9Q4AlmLFMdt8DXFrzgEoPNWGQw3ihgJMdGhM/jTygAkwBZSluXUNDgQWCzWb5uQMwIoO0V0DHzwt4THgiQ9lUuBhc1Pqc6IDkFL504RY3WXg7TmJrQFtbTWVlJtJ3dK7k6o4qrr+91L3/Vt//9X7/W36qkaKNlJG7OgqfU6V1LTSdFZoe0TdFaSmZkU0HWiyKLTVzBl1OzINToOtBNBBJS0m1KWdAA+mfe9lwcwxLDJyVUubhP4xqGoGkUGu/LCQFBQ4yUWnVQGaiTH3EVrM4LWsNsBh9lQJEEJhkLmCXoOLwCemTkjETDmBjkEpVt+mMYgdGDAysLGCU/BuoYu+kUamgsETALirmR1ZwjeECZiJul5E31H8rEMJ8oisgAPRWhJkSRJ4vkwBlh4g88faMeaqM45R06iOiI6LdzFWyRaWVcsv1TQqa///+v///////Vr9lqe9epaFbrSuo/NOqE3i8clzMZ+yWV6qimkTry9/LSSHmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAbib7eDHJty5FEG8GeUbl5CONwM8o3Likebwa5RuV3ggYYcFSRJM40ODOo0u2Fxhbj9utDkWjqVIKXwoBzCAqe8ygW4FYSW4Fme66qhhYF1wgQoLGCQcFEcykFAomw6lZg8xMEiSyX6tmGFSYEE4kDWCjAYMBm8wNKghKEAEJhG0MQg+DkD21VAIxYZmFwiALL5gfxzRQYs0rD2B8oKWIqRI1ImiWAcUkiotKOw8dPJDKnUC6J8YoJpHCf7qIgpsvepZKF7Zrf7fX//ar//9W1/Wza1bVV6VSS6pmy0V6KbzYYlWNrb2WlaL1gWQ4EWoPSXtMQtMipUyNaaRGRoU/mQhRHRsTWWBLMel5I1DbKMJQ9BABTDYJJAIVh0GAAzEDYEiYoBx5xvM3cAgSNg0OlUCmA0gYVJgKQRhwQmkAgraY3QIsAUeHsQeS2GU0AlCEAtqpgYWHNl2YsUoAA7X1eLiZ264NAjmjgDIhSYzEDJPammXB+FFJobgJwhUyHE8eIuQhMgUfDGG7puRVRxy8LldZoLlh/VUEn885tqPtqlIeWWj/+/6+3/1N77bf+j+tdd6rOyta13ukm+tbLMy9VRvM1qMFOktnbRb7UXNGUi2i63MVJ1MbBTIC3KKFxVmrkODYDdmiGAmF4tccVdkjjCljv0F5YOLggLF40EhlIM0pnUkP+7wyLDJA8U1cYME7rFQaO4KAsVVAsQwaUTLIyRDMCEkmGifb6M+ZEYaD5h8KkQ1FgIFwWaVLBguwG1AAFgoUBaWmCADD6ikEM8AgPMoA2IOO/J4gB4XxFxOoGzVBwI2zAixMlUWaAKIJ1JkTcTuT6ZhFnF1JAWeo3dTkGtUokZbx0up2RWgRN1rb16n9l9/+r/9vv+3QZa+quupBnp0vVZFM5WkgmgktFJFBCpN/ZajFZ9JE+5mm9nN1skpNaCGz0k01Xmy1XoHZ1FIicpW4VNGGTGWuBwx6Wsu+4eCu6Z5smxwHZGQyDggpmYZACpQiLuVHgoHDBQgXyX2DiDeAQcFQYZuQoACA0UhUPGYBO1YyoVHDTuTIaiiKZDGICcI0RhoIjwOPHicAjdx2wrFh4UADtIiydNJJ0HBkeAru7IuNwiI4yuMcCS0kydMTA8Q4hQMmtD6ukYuYmyJsXh3JnEhUkhCA87vstRutGyz/rKBi67/dlfd/f1/f///er/+rfs71pLtSszHboLVXSOs7IJopWTrWpT6aTPRWi6Nlosq6lIupFBGqyC0HXuyzCnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHjJA3AzyjcO+RluBnlG5eCjTcDHKNy1vEm8GtzblQZIg06BCaOYigKqsJfaXPE1Je848/Io1cUIBl8AJbBC7aUCpLAbkAkWmXByqxJ8wICH5BwrKBCYICQNTACS5gYVmvBMzhFNCWMAN+GHJbM3Jj+RBV5FATVgKMVtw4kAAIHi2ztDIggxHVtm2BwsMvgMiBdeuQheK4y48A1AgLaQ1MumhQIkw5QWTkRNS0qKgbGqCxOqCZbGOcqumYEI1dR9NBpSSXoGRNkCZjH+//VV2bq32Xqb/v/V6131vq12WpmRUtb6TKPIoNSQTRUmktBJChZbOyabLN1JnlLTTe6SFZmkgknRoqd1Oy0U1Lerc2dwXhVSMOE7egyhLsv41uHVi0jc6zRKZlCvSQPhAPfEx0EAMDTSQ0ayoAUAMzIM4HEIAMfgFMMwSIAAATapoCoNDDuFCEZTCrxGeQG7qxluMFRBEURMVCdrCgBgIonLHoYFLJhMBrrWQRAlIt1QcBnzVyhGPB9jlVvCLj4KhLE4LQCawWIjyyTZIjXJACzUN7QTTTF4T6BdSJBaKhciA4y9MTb0C857Ix9lscLzqSf+v9/6urdduz/bp3/77WV7PazMiky01OvW6CbJVLOILRW7ImySlOgkzJro7WWzHntRWy3ScyQUtOgis2dbtPLP3HS1ZAzZ5ARUU42q0064kp5fD2z7cLjcWblQlAooioHAAixM/i16nTFQua9AqvmIiAEqojBHSrIhECUENNcsDo0QRS8BhgNSlo6ZKmTwGEkAZDBjqK5GQ8Y9OZjspi4AHA4gKeFSTahgCW0XkFBYakFjPl6z5VIaYCskXIEBuLQbcxFTJidRD3RxJomZwOSJw3TPCgmUTAsk0JJ1mxF+gkktFcjU1UHcjyRZaLqb99f9Tf+v+rVs+33er12ftU6Ta0kEkVKQUgyKKTIOo3Z9R96KBomtj6S30Ukq1KNaSCbrZSkUFMyjrIU0Xa69M2cHRi27KrkogcAGXrkSxMmCaR3rE5HJbGYBlbZhUhLSp7Jzg4EM9S1EWJprgqvRjbiQAUoHSVYp7QaQD5hoABQMm/0SjXAB2YFT5YFQGQW5qYSHEispYQjdPkwaVBVujPFECaRLMUaFVRGAoIwNENmf68TZ8kESOgbaqIseTMCYFpAjYjDNSjxNEgipBM1WYEPSHbZJq+asTTKSbWupCcMn/7f/r+3/V/2/+/+m9qbOhVr0Vuq7LRZ2ZF1LonkkEa1qe9Fan0E66CSS9SDmjJImVSTzJbGOA1u4EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB0+NNwMbo3Docgbga5RuHJI43AzujcupSBuBrlG4W0rEnKIqIGGW7lpcK6muQcu1pcfrtgYOKnBmIEjICqAOCTWkyGIfMCFjLlJSmPA4OggxooGhpiANTjZwECnh1Iyr4zsxlTRnSYc9Zi4sIQhGxqBKNm1qAAnTrgEYDlcrpJROlEhFmyCIwUFMhaVN3RgcdpkWQwwyoygHNBgSKm47UlJOThCsbuYieTQwROi0l03WLdHSi5dItXXN5caUj/ZRMnq1v1f7V/++puyul9/XV/dXfrQpqW7VWdHrQWmkmtFFA8jeXUGWtajrJHVMZpoMrWpBTKRdkVu6SbIXdB0VqrdbKZSkTaMVDLOAgCZASK7zGl0hCsKr0tlPRZqLfS2Ws4YqQDExGEGRmDwMJAUwcUnmcQgExgkYQG2iHsFIioAjd4vMBkuHxEPTBYgg0BOqWwW3q7IMCgRDoUCgRIDBobPCpowcDh6BCEBo2q8YlCmlO48ZgIKgEAp+UkkI8iZFSNMyGAagsNMmS2dPFEnwMijIKeRZiNNTNJiLuiYEGURYw0b5mV5T0G2VMC/SQ9X7/X7tS/1bf///f1NdVtrtZWpBRqo/RSZCqmtTHHpLY0NEEj7u13ZbU1Nc0NU0r0rmaSK0Kk1JprWYMuixqmjNjNwIFKpZmxp1DRjApQNBqsljjs+uvBOSl3hkUBS6SARopSvAx9XjEEGCg5vRu4jSQUYLsMFRh4YHAowEeGvYEmZyJcXXNGNqqlDLnHT3GQAFHiUEbS9Fx0wZnIxVRJjkWQCJZjwHAiwZhQMYScMTeyAx8lJYXTIoJzA5kcLWxmCVLxiaGIWHFRKeTWuaHxXkjNMbChaDdSRa0FqOOU2s7bqWm6KT7f3776v979VT//Ver9W111L6k3oorSPLZdbdnTWgzMhW1GgmiipSSCCTJprdqNTumpF3QrUtDVuzIKRdFaOfFkRwIgFAoQveIog8accuNJ4faCwC04TpuG76/SAXmIge2FSwSAgEHNJEgaIgcmYEZAg2/YVEgcCTYBkAgPCAkYCBppgLNQMwCEaB7NW4w42AwYAwhXhwNVuMGC87kWjBxmBSaUVaU6q1XXghtWSgQOg0GLiZa/BTSKwrh4doA18kSbRPHkRwgHIBUjFA3YgdNNFlMZEixFS7V6zpej4QWZt1LSN3WzddSt//a97/Xu3+v+yvf1tddC6rVIrqNpup0WVTdbUVaFk0EjLSrc47OpSk1LWgavroJsmtBMwZaaJ5Fa3QYzdlVrQZE6sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAddkDcDG6Nw3ZDW4Gt0blyeKNwMbo3Li0gbgY3RuGnFgIrU4GHkAgyAxQFgiZ1t4F6u4ziTN0hpcyZRABgVCCwWYWhQtuIIFyLLIgdQQtuz0xlBCAlTYwESN/BjADE5w0S5MzIXxZ9YgBpKrwE0g0EUiu41EfMhnxK1UOUAcAQgETAwhI1FiwCDS6UBsUlpdE8jlCCBQGMA2eYYBBVsZFYdAW+l1TKWU5RUbCkS+8ZtAVuksxLTutSBVSJ0/I5Dsx4l1M/trevr/9fX1K6v/9Xv3dXSr+zLc9qWYV3OHVIGR9NFFNTLpLU6DHU00FKQUymUpJc+6OZ0NNbumdQN6C3oKTdFF0EGZ0jyMzKUjTllgAKLysSVO1ls7aPZuRsKtOw4pYLTNRKHBwADgQYEKeHkcgoH7Z6jZLAuNoeHEx4oXIpiMuNYKwcIGMwAYALxh15lAgqcE2ERCyOpURjY80ZLBoOi7nqFhUAYQ87wNbU2HiO7MOYXRjCZHySYwgNEjFGLJSKDoHQMWQFsWtFyKn0FyKucMifSJ5Jar9ZVke1D1JJOpa/+1SNv329l6r+rV6/Z+i7ddmarvotQ1pWVuipOtbnb60FpJpn6kloLmyK0jBNSlGaT0DVkziKMySUmZ7rEUx4+o4Y1libjk5Q8pqOiqW2VUQJtitLZhm9TQ5HBCChB6yQzoZIiQ0gjYgzcQAxoyE11fTfJxmKE5QLGJBAqNhneIjA6YzSRMwA1PuxHW4JSiIXQTjRavlrxjwUKbpaVy1mxlDnAgGC1zo9DIOEU4YCPPDZfLg5Yo5YF+Bkr4uEih8yJuOkBYMOBakUh0JooJDnU0R8KHCaoGC9Ts6RFnmJp3sXpx/2/16/q6v1bdT21f/Zun/XUpkrpXRdG61KSQWmYTqCakUloLr1KP003RRUtTqUozU6FBJBBkUlpJomCSCqzdAE03tOilaVjM1iAWq0yoNQJ42cuXOMBhiWQe9LmChSYcUwxBY0CgETYveQkmTDD8tLCoHLCYQBoOY5MEJkZmAgQuNZB1jjMigq59l+G6gBINNEU40RAKZn31BIuBxgnUtNjiwbIFEIK8ACxkYAz+RSEmB1EaRY8NEDTpBnB5LpiXD5DgTPlMvIugL5OdZjdI4RRAgKdZtd83USy5n20y9bV93X6Xtqr/727e3rrr762q3VVrqXdlMkddkF2ZaaC1omCVB0rMzrdSjBVNJSKKS0kjJ0TOeXY8mmZqegzJ0E2ZnbUtpxnMUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHHo03AzujcOcyBuBjlG4cdhTcDG6Ny3S+m4GN0bl4llKwmvgHHFsVdtFXC2GGYcdxiUqht+pYFyMaImFEzWyUOmoPY4heZcUrMjbtv4AEZB4x0DFUkHWwBNjlz1Nky0CTGgFWNjj6lU0MyCkiRoGKgSbahmROY8ZtVRVlyIKogABN2XkoYZSAJWq4d8lBjiCDERH8DI5BRB5QUkTRSACFicUTiaRXWZzFZkZnCAxGR9ndNVSjRy6qZN0Vomikvfr9a3e236ur+/f9bf+/7rZt1LtbNGQd0GWyD1HWSZajJtVSkWLhjVNkU3sitN0FukmktnZ3N0mPoJKNVqRoUFGUeA00KcgKMDKjX6W1LlfwK2dbTqS5okodycJRKZRCyUyBokADAwSbSJNJMdBOD2UrLkQBDhCADGiDMACIMPRhsQmfwMwMwQWigHQU466lVgQWi6TnMqLonTg0YYUAcnHQVNVTUX+15pNAIQsTEWkl0YNE0RzyNFpA0RUjSLlUupF8nAMAYGSKM8cLZMH2Oj2XjMsD/H1qPdyggogzOj7pFknG9X/a9v/r/tb331/976v30kUE6nqQM6CVa0zQyWaInzBbmqkWRM0jrWMDZR51o001qTWtOyKDJppqnWRUqi6kluylprUkvzjOEjDaoyzcgU4kSUDfyGm0Zm5kbj2crfIcHwUVoESEEAAKYYOJ9qDhASZyAUK9W3ZIBh4aEDIgwGIocpCE9OdKmRjTAnKo/IncfwwwgBTSztlyepy0UXmCCpTEiBGmCgk3Yue7bljAsKhDIZ11TMd4zwkxdEohHiNEmFKYvmgN4RioIHzInDRE+xFGQQGksUmgyKe2X1k8nH961OnNE0mqrX/+pXfq1221/3sr6n9N7tVrVXoqoOpJJabGDLa5gYmVzNaVaKnWZJUFLUpJ2d1qdFBWldkmTUktbGUNheu34QhQNdYEwWiDVPupSsxY7hvs+NRUtBIZe6chHCcxEnZmUFY0AGLi8jnAIQjgNJYdKBScRneE2lgKp8EW5hBWa4TBgKYOFoGM8dthjrhXGA0CDhpdYVKj2cEyNaGwARAzzpxI1R12GSZp9GBkafUgpiyUybHwO4VIDPpDcsEsYokYaha0JoTzILKhaM00BlFJpEGOkqtajy+WGWQ1e/1kt31dP/q2/9SO/dXW39tfTV2qbos9kbNU666kVH1lpa0kVJLUyVSLJmqLMbIpKWm51I4kY7eMFAJ8ZaZ5UxmQJv0fUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABv2PNwMbo3LiUcbga3RuW45A3AzujcOGxpuBnk25FSOoUFJQHWwMym++Csr2txisehyGc4nQvkEG0EEQoPABhRKmBODA0Y6JxdpJVBm/C5zBxiIiFgkrKxg1OYOlaCJffZ0VqMRVILC7C3vWyCR4x2zMbd0D3LjDHkW1NCQAnJSSh5IKsBhiGS+OkvjMnyuBosxEzVMqmRWWGuPmtzEc9kz5sWUseI2SrdWuovLJ25cTVrZI0SV9b99W1X0V//7d9bf9b1bbWoLRrrWx5O6KSq6SaFJjCmhZSkk6C002TWdSdjR00kFLQZbpoKSZMxVdBBJJJHcyQVXWgm+brQqHqxjgkHkzdFAUvEhSW1lerxK8cmJsyqNxmwsHmxgSqJhgcpoYwHRZsQoQhwqtSImBgaoVquQb8ajpwNdyDRtA+10dE1SsOVfMSwwEsOGACgKRmC6CbbtA0ZJwwRAkLKAAv7qG3IC4CFBQ3EmYk5vJgTY9jgE2gYBmZFwZlMnBzx9BImdUiyI6yygxkOayRwb0dD0F9zJNZDrI9VCXa/+tVX7r9X6q+r7dm/9X1sv11uiuqgpSNNF7nVn61qQMULrRRsijZJkVMyakkTZa2SXNVppOe07Ogzps1S06TzqRofs2lukYM+A2sVlDuaN7HrcO0/j9tMlkZgtuZIJBj2uoxEdUfCGJdcMoCDDAyOuSDhVxigNRKIhguYUQ5gRQdQZo2gggUQaUo9alYhdysDBwugOEJCdPNGCSYOr19vCqAcDWjpT1ZYVAMM1nDn8S+RAlBCxBRXQN3FFgIYbpuanxUkXakQFJI2cc5SaRB4ubTLVVKzlDMz9Sq5W27q+rW/9d/1Mr1utD9X9//dnt3qbOVOpa7JoVoovRZbrXZ0Fst6LMqkYIrumzn00KDJOitCtSjdBBbMdZN6KlqoIHpxkLLy2JqOgzw0JrCar+OM0OmbG2z8vOzORoqGPQamgYWA6cJjUM2m4CEMmcxKuJVEthECqAFYjSYGMEg4WZQ6IAgxw0LERH4QgSA4u8Bh0XmlgaIQA9ZgARHSjqYYCpWZmVKkd5CdD66WniwIGA4aoEACAs5ovGBOl4yOgQsOcTRPLNUyRBuQNJkkTYnTY+8iTrMiLrHPSpH+tJKRrun62Wk6/1fXsv6/76Pf/2160f+k++pk67UmUzuuigYpJ2PLWyF3aitJS1IWQnElNSdk7vZG6l0XrWtJk06t1WqMU9QCoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAauiLcDPKNy3NFm4GeSblsuENwMco3LY0abga3NuSqGgOBihCcZbJ0kIiNARGj7cXVZHL5LL2wumVAsYDAijpYFAEAIkKHkg9PcwyFXXfoWIbOiUXMMIgshmEJswCRjRY/SKCw7YvVZjGo+VhZ5miNDMBAI5EPTIBUFlci+xV51QLDoZUbiwyRGB820kBBh+Ph7KRmBuigfdjZNEroCedsfRWM0pAUKyGR85gb+tOm0mL9kjDuv+nav7f/2/3r/73Vf7t2bvpr9V7U02QNkULLTVOJMk6l0Vpp2dlIskyaKZqpbJKUnSRZNNF2MlHzaS+UrzZIcbshyCXDJlCeEMrKIyYq6FDGK1q9xwWhCggMrg5YAaGSdBkAaOg1MAA4wWSnXXkNCmeEILh40MEiqIx5rOCNJqACYhEQEbompf4KKEOkLbM5MFhI6+XzFZJDlyIAIwVzkt34ZvL2JGBRWYGLqFUpuGBDiOHtMZoAjSQIUkjG6RJk6o+8dSlLkQRW5YRJBq0tlrPKHR17abWf//X7f/v+rqb1dfsl+r1MtHupF3WktFSTl1Z1BkK1KUbKWtF2ekitFTK1z61uk6ZuigtmdGtBJbrTMKKC1OkesBrowtKxext4b1Tp3uyJ+GkOOpcwdyovT08ha2QiASFathjQNooGAgS30RawZLAzQ4bBwUf8wKB1GF0gUcjTyAIfNYiJBYwEVoYtPs50rIRsEAZ+IQmEcxLZkEpDweXA4zlCoUnGI0MAjIJEk8ps9kgIwmyqLohpBwNaNNyBGDmpiSoopNMtFRDDheOIEGMDBRDZGPTP/NqObt3eaMv/r6m/1ftd6/93/2dtlN3+1XqdTqRRQWXEmWtBFlpLNUKD60Fra70VKZkFd3W6lGqSi7Y4pE+xDUlUWkWzBliKjjQQ5UY2YYnGky0GhbFHXFgCdbrN00FsnFDIx8DSpAwsmgZajuOjYiUCzlPBqRjYLK0uaM3MrEKWBrIRjJCJF9QIPrHiSTL8PsYJLi3is9XQUSThNowWpDmFShPhKF9aZdEmTvMGBTg061APCqRpeIcOocgE4DyVDhqiiUw3JbZ0Z0xQTMiBpIIFWOU9Sq86ax9vT+yzap2///1f9af229d+/9favVqWugqupGzVKSZkNRiipaKbHV0FI3Qagsv2pI1nTrJ0k2ZBaSKzRB9kLIMy0mQWfpGBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAG+I03Azujct9xZuBndG5bikDcDO6Nw6PGm4GuUbkQgNq3hkGI3HCI6zfwHLY8zmBWMPRD0Qb8ZGjFAJ9gc1v2DgqYbK2cxgsTNWsYSGq+EAyytNIxlzFuIRIZnhgnaZ6ftli6tvxAAMQqBMnUeChOdZpBddHldUrKkaRkFgRWKJyMt6YUPNLhEHE8RrDLmhNAi2hQEUDY1MjIuBdc1dKolyqykhwso6OJyPQoq9Jp+56rUowJat//1X9e9f9Xe6796/2Z+vWr+mjTvrVupFk0lMghWtNB0qCboM62UkyKSZgpA3dTHjBFaDOiqtE2TZkUGQW6kUaCLVTY9iQla+nQWDwCipWD43IVBdemH36XTXgarGWbjiQZiDOaYwDIAQYlSNxAqTmxorFmFmDDydBKBNjNkWBG5hyMYUAhkohaYEWIwtcVBBk6CZs1gFZYFQMAGh72KYRpgYvYGogvZDo/6cbYFtEICcEMkQ5LogYGKRFi6LlAw683TNUDFRqEAY+m59yOZlLJ42OGB9EfbM57rW7kYksxdvWmyXvV/W7//q+/U9a///uy9K9foOnZSd6z6S1L1vRQRopHqFbJMgzKrps6KmW1c86SjZNI2QUZJ2TSZ1IOtlGDShOggmwtpYVNCsqggYOQBJrtFeKVNylT115C1p2xUIVVGAEKCCWqfbmNoFxsYOaVDiYOGM2AAQn0YUCiOJJvsWBBs9VgNWNmmR19YqjyYSUFuVAlOxAUGecZMyAqvQnu6TA6SrOoYwgsCkZhBP1zIENiNIYQwiw5AGdhBgg3IkXzpdKQDQEnzZ3THSgowYgylokJJhOkWvWjNM39cpJ1v//+r+9f/vetS+ySm/1/utlLt1KdN1IoIOyZqpSmporrqd5xK9kkHSugyCkloILSppqQsmgaqdb3bo3ansmtJzFQ6BogwCawKOyhYku1kmKlrnulDb8Pa2d/17kpGLrsAAoLSoMWEGKo9ggHGNSIpuhwMOBtXkFJKGNTKIjSnkYBAgMCKthgciq7cFqEhJAOYFbJhULsTlxMAzoYmBiJElmh6sWGGHPYrY4TSAIHTRYnFgvEbhaMB+G6O4XgGoSDqQIeYqMEgvWRU+itIjy0giw8VqNkyoaqUb+caTezrey1m9Ta+q+39a/1/ZVm9e/7OrutWmvq6tkq0K1JLRWtdN0lpmrrTRWy2d1skpnOIJLMlzVVA8ozc9ZPN6mWt2VXZC6Kkkz6ZqyMUgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABtKJNwM8o3LWkKbgZ3RuW0423AxyjctYQ5uBjdG5h2JASM1ClLC8TEK0E5u5CIfbDQTMAPWwMwsAFDDHQJRYDBI78YGASYbCk+twSPq9ACCG0FjmFU+JKIlHQED7gGbRa/K28IBU1EQVJi2lirYCQ6cFTxgE5DRqgl6VNEQFXMQgJ9QQFRGJpuf0SZuTx8eRIwa4xn3TMyigdHcRI+pJRwrLNWJFsg6y29lvas3c3eivrUYJIq+r/Zb7fp//3+u9f6+6m93pWS6l070rnlqUtJFTm6TUzRT0lIIssyQZbIKZCdUmg9Jk1psgkzJuikjpIOfRntQuP8FUxgsKggrkEwF2U056kSUgJmVLIIKnoZZeQoSAp4wEfPeZyYNOUFRGOQA29ZcENUVS9SnBLcKF6XKzSZbYwAD5MJaJf2URsziBDstYqRRgBSexCCBTDPtAi8rql5YMVvkcWMAECVIiFWWE2bkWF0aEMA34EN9LyZD0y6WRSo9KamgbJMZE/ZRqodTqWba1Ky5UYP7HVVs23/R//9Blf+3+r7Omg/st1qdb6k1PSQqepNF0zZWtM+x1SSaalpHq2m9BaaRxkLKdJnXMUF7MeS4FvNGz+tOJyRvWACTkLgRMHfkV9MXsgmY0x6JwDyWkIPMGAFCcYrCJAAFYXIfYYAwQLaZHgwqDWtDoLRoDkASJsFEsVBAY/1Lgc4H2WFbePv0YeExEenNhKWIDSIOAQ8P2js6lpeJarQ442IYAZkwZwVSyw0LSJDS8PwGiVBwY5pWY6XSsH7F+vZ0TzETdSyGSKtUbegXJpmz7LpldDX/raptv/b/r9XV/9W3de9dbJqZ93daC1Mky1JLoIrWjTda3UpJaSbZmaJLfdBS0klmNDRSWtnTZSd1ppIJHFGyKzCGCtbTWZWIcFoQ1ssdmWSyEwqTV3ykU20MgPCsGWFMCAE+THAVmLYxCUmun7KkeTIg5grDmYGdNqQLngIDLNMbElJNVkbT1pF3jBkQmpysMYmOGBllyYMXk4WKhLLVnOkxNCZtlLbmiIrLZzh0lSKivrLoIrpDyIGxZUXCYASGaeW6KalpE8tSlxn1VmvqX6TVM6zqlL9+uv///9XVofv/+upbr/RZbuzIqdBSR1dFJBFRupBBNBSKFSFBSCa0N1vMUUFnjGkyTKTMUVdFl0DhulXQ3yAp8iIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAbQhLcDHJtyz1IG4Gd0bhqiQNwM7m3DX8Sbga3RuW9S+MlQzaEkdcshgi+JyBritUDvZKo45AqHX8GQKYZDkDAIZzbqRoDASXLBmEQY+oUBKrzJ4VIEWLCIKiMyeEFiGTxUlw4jrMna0FjcDhs3iioNChxNLgYAExXkqmbfjAHWYipKGdBQFgYbPzD9Y+SpUGWImYAeTB7hZWdOGxKB8BaauUDyNZBEKQ5qjI/We6pdpvMbeWXRVZttrK/9e/6v+r3/bXqfqf7VW92dJNGtFSLU0XdSSCClGiaKClz6KTLXPorMlUVLMlG6aLoLXdjZTQFNQslHRNWaZYvd7jXwMZFAGsdjiYDjRuNMvfxrUddCFipQ9MgCwal4OAF9u5fw2E2ZOKghiA29thpZs6gm0lEzQSUGKGbGY8JsUgaHkbBHGDgNG2kAEDPnahoCJvocA4+xBFynaS+rxJIm6kTN4zs0SJoihioDWgDiZxM3WOUCQlBBaqLMtMlqzJCSCKra6nRP6Depaq/9dt/6vv/2X69X91Orq6nXRr3W9VKm1A5ZzRdjirqQZNJWmikmgtO7IJpU9XRUzWSV0LrRVspJlKTmSaFa1JHUxQh5BkEeeAMioo4oQsZuWLmT7mSl/ZqcLA6mrsepUrTICBMGCFByhJXw0oHGMQEAdFjQiAEMbUhATmkChc0yhDSBTIZRJ6YwVcMQBmpvESmpm2oYJKBBMz9v1aWauMle+y+UxQ6gnpVJnIqRyJOrAAiHZPpVMT5FzykVsV1PjloIONJRmkzJ/Lbq0NtaLstH31bd/V+///+yq+/q9mXtUnXXQr32QTRLinTZNkmQWyLLRTSQU6KS1ubKUkp6GguyKkziadNSLoHlGyVSbrTprUi6abmC0yoaIS5poJeUeJpmtLb5uL5TEF5v5A0YjQjAjHgiIiwW+IJE3njo6HGzADNXnAz9gsufN+IS7icYqCGBC6Sxg6wjc3CJU6JhhK0VjCSVICAM/wOMmdB7CQRs7usXaisFZT+AA4Y0DPLPzRcMS8QNFEDWCzrnFnlmgNASTJoyk7JmBmtZgigMsfWz17Gk1029FFGqv/1/9r/6fbqbsr6kXUv9fs3UrdVFkXUpBa6SDGq1KNnZ0UzVNS3dk0WfdBB00zruyDIKTSd3SdTLOzNJ1pplyqDDUrZJgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAagjTcDO5tyz9GW4GN0bhq6MNwMbo3LP8YbgZ3NuVJ4hSEBUAUkAB4Mnd5p0rYMle7EnhyclpUD3aJQoxMfHBIyAvY88bQTWwty1BjEwlf4jDl+Ggn4AN2NkoAGaLNTD0RpkGORdaAYmygopLbKlCgoc1YkFwHKDYH+TyIARpAKCJl0UNyAVadunNysRhWMhygTqHBjyZroGghcxtcgLutYyiMxHjbS9RgtKqvu6i0j9f6X79Vl/1fX9fpr6vv9D2qTecXVovVdSFNSabWRWigmkp0k0ma7upbqXQYys6abHaK0E3WnZz6aSKGs+gaTV+tblMEGaQhaccKBV3qgrbY6aVZx2WwFcVXMOCWMigIlYZQVN6rYnuYoNs8f0yIEY4tCeGworASZPXUGQzZTFSlfr0VXpjANCwcoIHtzFRw49zMDsg5Sbm/atY4FxN242/wXEgg5U0sTRqmakcUyDAassN41NDU0LhKC4x2ufZKyRs5F3dSo3bKaqhTn8xZ+yaNXUv7a6Ht79f//V39b92ZX+r113Uutk2WtlIOpS0FIuplU2WpFJNSTIsiZpLou83SQR1or9F7IKZCmico0j7H4QGAyV4CH55KX4SqWm1p8LN6Zn6XCXyFW1KUuGaSINfNxFmdwWVQACmC/WYmOjD8ioGsUxxICgGRAQMLAQJraBB+LAEnZbdlpgDyEBT1S0u2f6lGMohswEMAzHoOQBtqWffBsggCASMSHGXG5uRQgpWKQACYmjFzrF9MZEl03VHUhM1j7dGTblBO57WtRqyKKlfTOG/7ettSvv///////91v2spJFbqWtTsZPTWy0XSM3QZmU6klIsbrWt0Kq7pGK1JspS0lUXmqnNWTWkpNJa3WznQSaIVniIgw3iEo5zAeA7LXGexJrcbo4avUduWDIWAjxoxkAegwYeY9bIXdDmaD0ZCwHwKX/SpDOQLh4svBYNAQQpSZUPK7ppXPQAFhgz4CTObkIxsyWOEcgpk9ieTeI8KZMYl9E2AwADYtQ5JGB0hpOj7A8HENLR0xOpoA3VM+fNkEEFmGo846Get+tKhnfrTQq9f//V+pf//1ddv19XdJJetaTKtZJ3ZJmrn3vZ0VGbnk1U3nXqQZa0HMVJrTU6lOtSK06Rmk6aDpVprRUvaeQegggAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGg4k3AxubcsmRBuBncm4akijcDG5ty1BHG4Gd0blWxKlTwEYVIJ7MIbddcerU8klDlTlTjdBUUQQmiBScIDAGSuAq81wfgWAQU0yoRC6/jAUsuwCjcwsMNRBX+BoQwNaKcsAxsED6jMXYkIA09ImCg4RgKHSAnBEACucGAkGtyLdA6FYLIY04+Tg6i6aga/mZHqNzRRdFOMF2WR5umyxuaykxPpUE9Vb0tbPfr2//9teq/r2b/Xre3ftZ1KTV9mqVZm1bJnLrVUykD5utBBFZ13da7VIoKbZbpIOhWpGa80qqdzyToMicShxiUzh0qadOSmG/Yan6w9YmHd+BYXRsvnMLdNKBGQgYXWUGEcfMHOlPuMFgAIHoKixl4RH1qqbGol4jOx5SZANNDmGMirN2xSynVUIQAeqVCm+LUHWJJhFQGGEBKIv0oc6ij8tdhJwoKnX3gVSYSKCBOAB0VEz502Y6GjFZGi5RXZAndSai2/9NvZ23safZf91+v+r6v0m1f6vevvbau3rZlLUaoVsyk1qWtmPmSmrdBBVk65xjiDupNOkmdTe9a0D9kF3Y8kYooHnCDBQtGrKTAFVCxkTAvFIRnr8S2WPM98FTUExfQ6CAAbJAQw4ZSUNdNVRLnCgSbmIq1KAI/tXCggmGYWkF/CtRKguCqaBzGgRrjI4fjdcxQIHnJdD1hcMNnYQqID5YIAi8zZDhGiEHhm0iKEJ8soX+MiKJizTIpAeIEOOqOpTcZYhFrSkMekiRtlF1ZFT139TrXne61qetl9Xv/2qr/q///UtBV3636TN9nrfTQdB1s6DpKSWy013Zrso1N0kmsm1A6hXVTWpTutpqkpBNNVNTpUGNzNGqh0+UywqCwsAYyphelNbHGJStsUCtxlEphyaeGHCEjFAZAsw0IfkygrZxOLBDQ7AT7hh5wkCoBMoMAImg4GCgMOBrIDGhJWJhzCGusAMFGQVipFSEtseKJmOyA1QJSLjcdPdlqqE46DajxY/dPJlOXS+VxxgYhOLjNWrLEWsqu2oyegRJaSlLJlC+hc69PSf5w8r9X/XVW/Xqfq+3Z9Slv/rX6FVXrq0H1TVTJGaCCkK1JOmmgaLWupboLadptspJNG7oVKPLROGbJJUWWauknQooOyClzz4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABm+PNwMbm3DNUgbgZ1RuGqIy3Azujcs7x5uBndG5QRxARiLCzA5hRf94L1HAMzDTDYRMOxRK3CMmecomlBzOFZ+bIwKEJ9S30incBIc4hnBeShoZLDhiY0MLtMxBXMl8PwpwjAUgx8ILlsuIREx9eMbVx8hEQQ1hkqITUQqDPis8dBhGAPzHqZEixVGemgH0ZUN6zzohxLKVl80ZnIEtFzZIaz1mjJfbX71nm6v/v/3v3/+t///+ivT6mVS9FaCknWpFSaBx0Kk0lHU3aZummgpBO1BK51mR5qp010jzJ1OmYpZg9TOgpeyzBNSildSghhANARUzlm9ZTqncZ5cIm/8Py0gNgqO5JRhTFN6oc1hC23Ld5UwyBeAvmqQxsEkusURGExbXzam042uPUw9nIB1gKyxR6iBCdjUATRHER0WM8i6YUpjLYrOm/GvNPWCoTZBTxeIoAloOA8ktJZNiEJL0nQRd1onroGrlhnZ/qUrQ1cyO//r/vV7v711t9X6v/6S9XpqWrTVWpSS7JI03MElM6aSJ69JVlIJXUmpNluxxV3UiylLWpFJkklHHNFKXK7IOx90rWrSONxYkKFmYeAVCMNirwL8mpI9bLaV+7tG/C+zDikcCTIiJrBg6vAUBiEIN8EWKQWhJfkZG3LNJJCwfj0kqEnAGgGcFKNbKIHwpzAFhSCP0Wdk1I7Ga8e2VHFqPCIwu8gJZ+2jvgqFjU5bRJtx0ni4DoDGKCZks6LiSRUyicc4gxFUblSOtVJH1tf/rPIrV6Dq1/pqV9Xt/19Vt//9Sv2u9NSs5WYG60TBaCbrRNkV1JporZJ1smeSQdBkroKSW60jayBmgikimitaj6k3unTQUtBzYzqkiuUp2Y6aKpj+Dyq8FC5NFZXYjEYlTlQHeWiMgiDAyArNM8FbkKfciXp5YcFFzDwYMt1HTAKqoOKBEMmAii+TNCq1H6GXPSYJDgogGg2SjAkbc0gQLJrhN6HG+Rm0qtQQAiyCCipYpCoZkWIkakNAqlGRn0i8oohkxkinkY2kktSB+m6qfsy085+o+rsl/9/6P/f7e//936/qdtGtT0mVZPrSoKZSCk0UZsmya2WpRo7oPQdkE0VppJuiy0UzOnTZndNJNKdOGjI2UigiipjEPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZgjzcDG5NwyM/m4GNzblnaMNwMbi3LHsYbgY1JuXggpk5wopUIQqMLhiT9ujTtSjUqfm4/hVASqRKOGRCK0QapO3BQXAzGwtXzRS0zKyYEg80gPEDGHHRKUGEEssM3PK0SYRLYAMJQDKgBUMHLyEp8GWIKYWiLhqLtV+hOl0NNzHnuYidOdLJdIcXh9Ajs0J9I6gosDkHltcn9lk86CRPrJxHdXrWgp6dPnE/16tX//b//29a/vv6qNH11syCl92R1oKZaSb161u6lrQSVQdDM9FSSa3Uk2mgz13ZS0EKqOkgq5u6K0FpmiVg1gRQRKxJAgKy50G/a7chvr2T+T/303AMpqOmbgD8GXjkngkVBDAAKUyUBFkhEQsnMY8hkhyDpBBCDohapmpW3OFtmYC18GsrXnHso/g9yMRKyK4R0dnFgUJXS3KgTPEJS5Gp0wJhiHm5NgYLDJFEpMYKTFjJZNJaZ9FbJsuo0l2it6qlNQepvrSf+/+rur6//r/+1Ff/ZN1da1s13tqeZOtkZfTSZNFNFKnZTuyToI0jdNdbnF2e6kzbDBKeCFCJrbybIYpcqTUolQ5UTsJ8HSPLDKhruxaWN/CY1lF8EGwoStiHltwjKE9iW0QB6ekbaoWu0BSB7BqfGWuqFQwi41dmZJ6P7Eq0VkoJLwcar9d5J0BEhJMhwTECgBgAkCnKQS2WgBQEMiAHLk0oPmheNURjgZhVF9mRc2EtM0l0DVNaJ1uXECsqihqq9aq/UVlKsql2/upV7f/61uvV7e2t/fsy0d6qNmd16kVIIugxsimtJVmRU6nOVskeRU7tNJ56nU600EGstWdSRUmi61oInrnzdXgEo9DqPCaybrm7JcVMZnqdTR5bK3FnIlLILiY4SLaIemUHK0G0DtKZ4jcTdXllgNDvMBQD8nNVAQyPuRAQMoPgg3xZa0AvbC2YgSmPX2IyIQET+UgT3DwK+mGPIQAYux6NQprJqSVLCNmKiwQ5AkAN7TY0Uks6LldqpRPbF9dRjOVL6mU9LW36G3//2q/9am0f9f9ttX7MvZqS6rKVdrJHE1rqRWpnc+itBaFluyFtN11stZ1KkggtaTOk901Jsmgpnc5ZRqdT50xGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGh483Axubcs3xxuBrcm5ZFjrcDG5tywVEG4Gdwblqa9S+idpisgtuHGdyWA3jhqTTE9DFEk+IxwYASESW2ayZLfhoUEjIB5msMMLl4FF1GDSggqp4CNCAVMfGuGNr0NSCBaKGizK+oIpIIKoCYXigIveFPiAUD2Sq3RBuDIzAw1b9DLDyCRPG4zAHU49mjJmaSJsSVqjZJ6zJBajGTKNJfqPWqU1VSlJUNfr+2v6/dt6/7f1uq9Wr7/ug9HWpFB0613Wi6jq0WdSSFBEzTd2ZZjqQTW7J6NB0XSZSaCTvU63dkUamUp0EEEkjRTnVYLkZgCTJw15jE5MTWGW6z143Ootwiw89WAxQiARuxgHEq4DMwh+ZsRgphorF1MQEJQOSia6DZBUSCBKtUuB0W7Ak9tBbLBeHBESmagtI4Y4LGJO4MhRIptMchTOJtza682aBAy3tWXlYvnCydJ8C4ESRMWrUHxMtszNlvLjWNlnez7dtFqdVRqr//9X1f+rvZqv23/W9er11VMlU6S7oLWyKaTqWeQXSRZkEKaKnaigkyVVEyWploI0kk3SRdaLOaosmgx9BMwU9SK6Z1fQ94W1JPoSlko2rvSzSLuvG9jd5BS1HelCjo4MtcGjlYhswHEJpdZnQzIZtMKJgQRGgY0ctEBiPNiS4YwIamAK8rjMBQqGzAwF4kuHylqJZgGWBssQgbUbwgEXDgV9GcjAMYuKQdTWWSJgdJeHKA5AGKRqKbucEZHl2WXFLTSLq0ptI53Wf9dT79VkkO/r//9S/3V//Rv9/f/6u2y3VWyNbnE92dCtIzTOM61HXZTVm9KitlKc2a9Va2RWcpGik2Z12RSZdJaVU1QjpTP0F3THEFxG3cd3NQVBFiWUnKaZnh0kARgzoOYmUDzhCGjuKENWLLR4gfhOFS8DdxIZBzaIwUxMMXsZoRtSaTA0pnVGAyOc3BJc4M+FEtXbX2uvZDzoOu/rdHdByHFpuaQJUwIxMsAMxSRRoJoCzeueN0EpZ5VWeav+rWtavV16q+39dTfbfv9fR/d69r/utrW06CSknU60kVqslXTWfZnUkis6lQqXRZSqNSTrQZ7qrpMkk7pdSSkzZixTgWdCdOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABmCPNwMbm3LLMebga21uVRDI3gxrS4KuxBvBjUW5aKo2YhA4aTSGrtMnsurNv/DE/KrFiJUpg4ktgHG77G4g7n4kgmJTa7qAMKH6EBAyYzI2AgGLNqmhggK14RoiiOEeiMEr1UalDqPIJGhlCCEmYhB1SwEQAD1RKRtMUaM4BYZry0xMywOhQ+APbA+iaBuXLiEJ5Kko2apz+stLIfzT1aHb9H+rb/rWta99DX+t/77//X610bumugklTdBaNKyKqLGqNJSlLrTPoNsplnXUzXQpOtJNJkGSZRgmueZ1O6SKKGcZBa02WoybdbowLHFhm4CliPTTasYkMbe3KMw89UaKooUITCTABBvAErtTmyQCMmBJl4QcR8C4RQm4CBIuCwiKA4RALhM3LnodWWyJlRgxAPKRMAT6/DoAAwghDjeDXUsthpXcxe9AUZ4KNMk0sNDQvE91AAlKZdRSPpGguIsg0iVrTL2pNanqdut6X/vZa/7f/f+r/1WZX/Zl+urXdd1t9kU7qpIpLM1pLdFE3dFBFI8iqcvM/UtlstjdlobZ90aJw8mtaKKlsutJFSamSWtSzcc0h/wgTIzcEwCcZpTNqezKII+5JpdXUcBo1spKWWicJRFJexAGmFiqrGBGv0WiTMM21ZkTRFTJ1QEMlbUedi28JgVrdoo/MKM+RGTBH6IQMzDybzmR+mhx0AjG80ruY4xOO4vCKNYb/DDfMZda//+Z7hnvDn9p/sYzvaZT9P/q9Ht//wzrOh2p7hCKFAOLufFAEbJFrAEJxosJR4aFwQeFR4bJhcMlGCdDMWbLgA6UjR7M8/jyT0PYdlGOd2fQ+HmseKEi6TGCJdSoNmWDwAzEEAo+zFbRvTYXdJ1joQyQFxDQM3fjcCXICHKwcKYjKxUQdOOFSZM6empA0F3Y3Px1G4RBX4wvGlTS8BWGCaCT1EDfsfZaE1bQnf9evU93u3//////////bq3dm/VT1pWRn1M7Z/mqaaKCkEFoumjRpKoLXdChfdqSlsv6lJy6q0o3iGLDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAV+fLeDGqNyrbGm8GdNblY2NN4H6m3KfDabwY2puXaa6DIJzpvvi6sFvZOSOhgaxVpYpToEB0lSA4imQYeLBGFCbIS3rMzAio2SmXBMNAaIHNX4fh9DDBmnRN9KFeYiwky5imSlIgVDJApvod3nnEQ4EdyJMiT0MgQivLKCJiVUieAATCljXWyBDD27mTq09Ewk0+/9Wv9af/////q///7f/+kkjVZlu9S1LXZanZBbu9ZsmggpDUp1O7skqtBjFGht0zjL5aNV6nYtJtZnToINA8IR2pKV4djzW91ZRJoZhccvv8LNo0UJ4AQ5ymqmKJk224EAaldnZkmSJxQfQQCRtgBh2E5UoJyBSIEq2H4KJRZp6iAUihPTXhD6QE7lHfdwDFKG5ZZ3MHSALMSC1KdShKUkqE6vmyDoIzD6taFSqv1N///V////////qtZ1+ktPdnrW/Z6nddqKmWi6V11JpJJMpTKZI4kkzvVQppIJsm9NXSWggyByUJFc0g4gzQbokY63NOKDLDl/CztaWUIAsdAR5P0z8B27iW5Ezlz8hiGiTNSSGYLDh5Su5y4DEjUUf965c+5ogQ2LcmOqGGkRmS2D8pKdr8XTleZ8dwe95gBNml0mpiHEyOSAWchD6qDGYrp99aNk6StGU1XV63Z9/7//+r///6////V69X707qXWmktmWtboulUplPZa1ILqXooMtezoIdFCp1OiigiivRWjM2rZJaBqa0aarrfJRiOhK5vWs40k9TU0DRWewkuab40OqdjgdcXNUdokDiwMOC4REFP1YhwlIyQHQqTDFluVkBfbiUo47IjG1vzsvQmHFEpgQ8THbM/h99rjtwRMpvkoC5VJxCOVIjASLDQxj1YSjF5V89TM5TtP29G+j////9/3////9//f9EaizrMhkuz079fLVYUMQyhy7n/wi40FiISsRtm9+2XqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAFVX83gxubcqqQJvBnbW5UCaDeB+otynQZG8Gc0XChcAkIMlUVLhO9ZkEst1MbU/nqtNooPWXgTANUIXIh9DAoD67wBAPDRCGUxgaE9IcAvaRByi4IA7UpqxZhQjLAMXRWjWma6GCGqBydALbxJDyLwBLJe4gcbv9Z6mbsRqJNgHhKS0aloiynRso4pq3rc/Ljbf2+v////////rb/6/91+rs+g3SWcy+hWlbRdFnVZJnre6L7pMta00nY5B7kuXTJWq5oH9SNOJuoy9LwbYBLCypmHolSakUovcyoOJOhBVGB4tflOKH24KBBEy3sTT4htu6+zAxYVIw4AHAdE6bAAov7Glf2jAAypGQUqYxy42FTAWHrMvpmf8gCntL6MPCJH+K2TLyB0G+POeZ1OJOeSuzO1dWyzFtf/rb6n/+///6v///9262pL/V1u13vU1SaV0UkkHdCiuiys5q6F6lugitalrWpzjukRmlEIJN1Z1HU1aLFGjgnAxwkYyjLVsJwmXoNeXJUhzbVwEoJ0jjvnODgZWS3H09KBK9ZhmGMZZammX6gIwgKVSinoJEMOAxxBLzTp8DBg+yaj+K+su8/DcexpBgKDHJ7WQuUEjMCeZ9TFIZw1dqyzUmtDW0+lUn9qe/2VV3////+r/////1ru+1baFMxhTvRuGwefF0aLU5Iti91u18Hp0axxXFstqOGqOhkIDqmUMZVZbIiAeRpD0zMuvS+KbwfHbSTGDbkPR1BY3cSFSThHed/HdqMglRsBij4tgoqEmNNR+oH+nKaJ2IaQgpwJCQN5gBoaDfi0PQ2RKBeHSOsh4eQAZKi6LJmS1Jhag2S1LWJ0dHlj0euYb5bX////fd/v1X63qNoSbefGDzgZCQfIgQTgmPFJVwxaRVwqDIu8wgHA2J0liSCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABUSMN4H6k3KcpUbwYzpMFPHw3gxqTcqkwRvBjbW5Xz3DZCMCwl9b3ExkTHXDPvNJPVCQO+soGiTSTtIGgx5NImQ4PQXxiIwLiZoVCe8QUxDCkZFochaVR4SwAhijq3CKqrHPkjlAWcNEY/I0/bbMtQYkcVBdfXVorKa0gLiWHfWsPxZeowqadqpyja9v9v3f/X////+3///r1+3v1/ZmsvopUWMEGWtNmWySadSlL7JoJo1JrZ103d9a1Io1uy2Uj1MbrQAdRrbRDKAIUDWjQIlHm5u1Bk/a+btWsGQGyBKxgR1SY+jtNQM0yG6NUcSdZ1BboRGkZBICB0G4IRPYhWsSAlN4WIDFBRxrIgQW6subOuqUtyjeaBEedQNnjzWeWFVVei5j/4XXKs/S5T0h0P/aj/a//9Vf/+qXvUNi4sZAY0WJCooJBUIDBUMjGgAFBEEmC59IZGvNDQIDRVbg+80PCqWk2FljGDcJIpTVmzxS2UV6/4S2/ZLAdSTcUXG6G7dv1cQ4pDwNHhoPBReBixoCJAJexlBE1biLLZLflz+uiYmOUQYn0qByC8VaxFwWAgaEO5ImU5ypfCbT9dyOpmJQUgAWRdP7OiMsb9Zf9Xyx279X///23///9VX//+/96v1WVWm7ugjrV1O7o1vTd0kVpqWtFJBak6lGMkr7S3yNLoxU7UpnyoRoYzFdLIR5gWuCiwCxamn4xAEinJfqbqJKFpZCmq6pEKRWs2AShZ2qihC1HX9Bw4WcKFEVADJwFiQOCHPmaliGTAUtC+Pw4rs5MWMBIhIAhiN0TCex+X4OQn1LJ6ymmkmtEEkQZB60Ak6fWd3+itH/v/erS/61/////////9bft2qVSUjQU9TIooqUpdaautb0XXSWqZpLW9JBVbl1BIwTPHRORIGXuXoNEigAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAUsiTeDGoNyn0ZG8GM6XBgJ+N4H7e3Kl8UbwZ0puWJtZRrAU1hWvrhZFK3Gpa0hzpJy3YHAKg8sHjq+TFTKWMVwcit06wF4Rin8NOCEJdWklAJLygIDQibk0JgMwTsHE6aH0PDuRzCnh8wsh4ouo1iy65ILkO1rmDzczZwOziTLW6jzPz3uqyMzepf2r1////////////9W1urq1IU+tOpNemzVsky0zdlvRRVUlSRTZc4pBlOy0kl5lffVWYOBEfkfnFglc8IBSTQsaU2GN4OVfsv9coZ7O0WAAMNHIPnRpOzwVJMMdoVAtGu/OZjgjEBN6X3AaUNAY6T24ZitUxSkoruzcRlP8ibsNIHgj0miEWhq9SOkhvTU+OfNVvwWnjnv/5tYSe5//d1/9w//79zqOirk/7v//92xs82nUF0i5ggMGCINjUtPgmg/EAjLvLFTx0mBiIUBAVhoBirDIhgAmJxgiynAYw9hcS/rTkj15uVEtr3MUOocFSoiI24GFJcCe9Q8IWaRgNkGga/Q5BKg6UBlMRG1MIguL0tDIIWiwHIbV5A65wYIFxsWkVFJ7j92XFnb7PRoLn52tiTMDNAAV42Nb9zdn1/i3/zT//11/b//79P////9f////////6////////////////+f//////j/f//3r//H/zjPxr4t6a9M3ta98fG9b1j/G77zeuoVMfEHNo219g+jNBtPWUIZVVulhlyQAeY8wYO4kzG5mHYbjVyV1LdskCEoGmWGaAGKKsfb0HaoHtp1TbvSkwwggWERkUDgKI/oiAzrSceNkXYPLmrR8qDDIxxGRIlrxTkKoJQ/P0ssQGSKe88qcVY0Fi6JRQIiz73Wy6mSNtdPXf9X///f////9PX7f7fRnTayeds7IYjsaa5hiKc6oh7HJJFohqHVd3RkOUobUybV2R5tUKP4xuBOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAVQhTeB+otyqHGG8GNNblSeKt4Mam3Km8ebwY01uFo+BNhrAAkAgOR4sQ3GZcOC/hQ2VbUk2wjAJTs3MB56RP1uN6Oq/fsKA36Hl5ATJjhKBDC0jHR0SlMuyh4USDyZ55QsCepMDC5RpfCMS1VWVPN8amQYAgXumN2KbFEACkvS5iKSNr7b1st850fvT/9//t////9///XXr77U/evWqzOtJ3WkfWyt0WpMmpbMzoJoG10rorZO7oppVqdRyghNkS3avypFmJvweJ/Ucw1wB43Bg8Li0HX9ZYx3LG2WBA6AlSxWWAYvfp09C6k76/IlKYWYUSQsnBQ7A7DICoGe/GX08EEBwObNhlie5xWQ6dKDr+SmDp+xDVqKQ2DhdBywgp0kVDhNFHl6QUK6847rWl0Zoj/6v+tv//b/9/////9up1/6d6mZPdnWs/UmzLWylIpvT3sZdFFSk0aN1MktC1aka1JOdWkp2QUtjqTH7GRfU4sE0gLmYMt9rLauzDsng+Hc6S7VxnWRTBa1yDqI35quDBtaCVBIwKBpeJGCQCTJCQKPAMSAHEZymtTQwiT7b+IlUAZ+WBUo1NblAkWU6tOZdrQ+CQcTqWESyiYOTwC8EnQapI8etpaf0q/+3/1ft//////////v7qrs2u7s6lIKdkXSQ2VeldVB+y06CCqSCDr0UWujTN00mRUki1nQRrL52+UoE7GAMSJFDrQhrxSqadjOgf6vljTUZIIWTXIgcCg4BOUrtMBlsGP3Fm6TYiGDqhC8gEGLAy4hCtOvw9I4YGRyOTF9tqPxRhOqGtDFVpNPCIlbaQAhDy5WVmSFzIPxGSRW9ALYbel57upL/vX/7X6//////////6l/9VmSZOpNaLOktGi6nTZN6Ca61oqulczW10VKWtbI09dBJkkEk0lLXro3012SUeWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEr4k3gxqTcpqRRvBjLW5TkhDeB+mtyjyUm8GMZTCOPCIZAHZcNw6ann4fxsY8uzFTrMJDMEQq0JwmTaXI4U97wyhXTQA4HKCYzGSZ5Vdlf1iaqXh4EnBS0CO5q3gjsjQ2CpBCY9LKPtZ9UPK2eLouksog1snT7K1kf8x837W1///39v//////7/////Q1dbooUtFOta1om9Sb1Lv10dDZkO1Sa1oK1s61p2WtbH0VZuEsqS0qbykQSHIKETXqZ3L3LuFrGexkZAokJMg4BtC+9jc089iIMStxZyDAPHSisNa43VFwYhKZZWu0TWlcyenIQj1lIaWt08htNUuvnLok1syhbdb00lOtYSc1ST1OOdvXXp9qP+vV///+r//////////rU9qLNXQQUhXoquhSZN2ou2p3um6NFSDMu1mWp0aCKaSSk0VXSZzB86zyQnCiAJBHjGTZCnqXQqM2PNfGSZyhjsGu81k6hJxYilsiJZnl/O2lPeRQVSKwxICIjuKDWMur4QGFiaEuPQtyDtGzBRw4O5cC3W5y2WbyZCX1lF7jHHOqMgDcI6vUNS/V5p06XXv//////2///9f//X//b1KuylMcpnFqc8yup6Cn0lIukzuitkUmbSZFSKdG6kUkzEDofEvGYERDOwZSsdPLS3C33gi1Z/pZVs5W6WPRchs3WIEh4oqhN3GsO72w0m60W4axKVEzhwsdEkpgm9uTtPZSPEieRxF8z6CSkejdPGdnr0IvStVUDZX72t7/PWTELeffy/CzrvTs6LfT////2fvV2MWXicuOFBGBjgMjhxpyQ+g8TGA6YBI8E0Co4mDwJLBQ4kNGSaIQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABPmJt4H6a3KbEVbwY0puUwn83gflrcpixxvBjJ24FzfluBzCaGgeSSVDuGqljUfGaswShBHCgI4Bt18HzLYhITqVJAcbxti/ZKEXCMhjJgZGCRuVLXuUwMALqpr0DgeWSHyhXActrRXLVWdYyTFoXj6CaCDJAUYgLUlpFE89VfmfVX3/9f//////////+v1/7W91elUloJupJatOgyDIOiiizroPW6lOpmdbJ7WSQUmgy07IGaaBxDNXA1EELBuKzMbELCZ5J8ZBZlmNvnK1iLkowBJI6HEpS3G/TqrMuv+309KJwSQvAVi3BK2EUBQTsPTedQRAUhZyQsoOYFAgUmlvjZp4Jzfvs1FgyJAt/3MQiPKAfOde4XFfXrvr/p//T//////////f1mfrV+b5RHPZXdXRlQ44044u5jGqqoeZRTUU6i2Ooj3uyueeh6HGOhphGjc4pNQLiWNhBoBiEzPWOeTXiOyVtaysJPpQvgXzaSYHEdvWhYKGaBd8sT8vp0EgjHFzidTjCzj5zNHMTRK41axNJkn9YFASi945ZIH2pqfksj6Xl6xmpG7IglS6pVse/znnOv///r1f////t//////rpf6qS1KXdloINdBNBSCDKQUfpsq1FdmutbpprVc8oFq1lCNisbKSDGsN+ozGUycigIRpC3YEgXc3LLlu/ViUjJQAAHHQ5RtF+Sis/yWH8ZZUdrAOTZejEOCFoYYCB5ypRTdAXnikJflQ4+yU3ijZ6Zm/Mx9+PfZspnoxbDzTnH2gGG0fgv+d9l5n+m//////////3/9/v/re9LtZU1Pc05yNFPNRlc41WdjkY2xuaZVzTGc5Gs7HXRVVzjDzFXq5h81C6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAARgbTeB+TtyiW228D8NblNeKN4MZa3KYsObwYy1uQ+pgrwmAtAoD5bj3bKYWGpg5UhwhJUYgtTJmBmZ3KemWrzNM6Pv89jA1bn0HCxEFKiZ6koMN2hCYHCQqlTsLHtQergOzB+701qkUXLX1auLSpqIRDffBZ8frle/2//+v//2////////7NR0tdOi1qvSOHVScK1tfRYvyd1EU41jMzEpySn+8Aae98kXykQNw7AHydjOW1+oYTexWg26s+vIHYWUFBxkIfO8tl87magc+zGNg4BKl7ltBt4sPAxl9TVKSZdqL1kXRnyZRXl8bcghi1G8KVVQ00nrVus4ghFJHvWSh///v////////////////7a92UunSoNWe4eAcQzAqS2v1yAyhVNaZkKYC87GPHuc2ErulKjIUVYMiZMyhuMtucxq5d5epCQdXkpGjWinm5P4QWLFyKMkQE8sHLU3Gtuo10fsh0MBkNBawoVTlZ1BSr7POh0hqaO09mA+SXC47oqF2/jsko4EkVqe4729D1drf/6v7f/////////6vVX66G61Lraarupb0GQqOHEjZqaFFdSl0FLatSK002dknQqMF2ZBBDXulczWa9vxpLbtvKZViiVRxCNP29dntXO7VmMpWhrAw9XEwUhZickQ7WqF0s2qVkw2cwIquCppWHB5yuU3cBhNCN+ofZQewYWUKN3rn78WlEorzDhG4DO03qbdg8m7+snf+n9H///////9lf///+v6/9Xbdb3dT3ZTqWgko5Ru6SehWpFaS3SU61o011uqpmQQat1IqWtB0kZmEIVLlOuaIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAFBY43gxprcozv1vBjLW5S3greB+mtyj0Um8GcZTBfc6DQgi60kjW/d2ZlljsQt28NYoFtJghicCA8i9knjie2F5a8jWi2wqBQ7kwAsCDEAZSNBu5aswyFV7uwTI3RN0BChYoLyu/bnOyrOXQGJHYprddKiFmaupKudfQWmvr71d//////6//////9tP7bNXqr2XXXoKSSSQXOPQRQuqte1BFFTsyaCbspbOlTQupbre7ujQRdFk7pru6KlGswDNv4I0sRRADxS15YIwyitHlS8zqNVHjGfhQCTAUe3ZzDLbNpSNI/0IVAOARVD0WQmR5WL1bdDKkeFapJplQLnJMhobON07VcZv/eMSbda97oOzLCO9+ocf//oP/6////+r////////+21TdemtVSNb1o0Pd3ru7aR+ggml1aSB1Hw3CKpNT5TdNwTSZlcyYIJkAUBzHwhy5VkGtmiaJazsqyvhK1CpEcUK822fgoDTSlrGCHCVIuIvkyVJ4Opv0EHaOnnMI+ADK9qvxwmlipZqVijrZ2IZwuthTHt433QTTU4JyU1NaofH809L/t/////////////ar/avdVfrU1q0KzG69TbIoLoqOKSVUt1UlspJB3WizJstc0yzejAcEkPo6RGvedFkIgSBMSZnX8pJbSd+ezl9TTd6jcDYN3RglaaaqgDl2K759Ru2t8qS+oGEywtNIJvOjkgjAX+9s0o+YzQrQwSWRachyfpMqRfAQNZ7j//vmbZs////4w/2rv+z////s/f2962ESpMCiwFDSgUEQDYKlhM0PnQmDYlDRsTAANAoIRYRFBcibFBVAwuhBIoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABFEpN4H5wmCPkdbwYwduEg4k3gxlrcoyPlvBjKm5TyEAbi5AKQ/lYxvntucm7fN9+AXxul0HRO6RmuTdRaqeml+0ipm0IAaQi0QbDfRo4kfKZo6aeBgCLc5fgEDgVus42qv/D32mkKUUeXf1zWvS2/uv5+5nTuzvq/////6v9R4uWFxcILNh84FjRIICo4yCoYNhkoHhOgIse0MhATAY4NFkHDrmPioORuRMJLQJRlaGUwFL62Nipu9Kq/x9WF2hN9cUPCa7+JzVZlr2DOIHQGFWEDtineiiZzurFRVCMPZmwg5VIYEwJRJ6N0uR+/ko0ryirdtMUagHG78bN/zu1W//r////////////6WvN05lTzKzTnc8801DM9FWxWl2atnYy5x1Zmc50cmtNzjGSfmMplz0d5FUB0i3RLV1x3Ygqu3Kxq/b5lvrdIg8S21tAHOayUUQc3KmhysdHkqYw4IUaEgYOYfUwh6tufnokIuG23Io+ZoowFU1T5V9vzus+wKFw5vp0wKVkvYln9vfvV/////+v/////////X1WXqSrUvXTWzrTzydNFLU7NdVkU2Veq92UldBlsyDIprvW9Vj4AN08dIWaxuQCrRnrKZiZr2eRWb3+7FLVXcxlI6DRGB9SdEgcrCXNZlXEKyqkhG2JM++VBqlFar3xAE/kC1n/B9RUWImIAl+MF2ZiZpHbUfv4ejHn3AgNtugj/T2+n///////////////7K3XNPSl6u5yl3Vzpc6pzOk5VWzTUU0xGKLUkncjzH+/IA4OT+kLlKQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAASKjzeB+VNyi/BG8GMqblGh5N4H5a3KJLybwPwpuYrMogHkOMbS4YLuLe2TO8YXLbGn5l5fp0zHujeDtI+1L8m6nQ5yEkcaJoYwLcxQKjXNzVrAw0CYyeuPGYRhAwmxKMrNbJ7sLTcEB1zHq0sgDx76tGnzvLdq///////////////p2q866OlFNdL1VFZGYw5zpzKeu9WQ16MdWaac07NTNupEmrTWY2a+ehiqVOxX0+zzCqmSq3QK58zK69Xdur3tXB65wahnS6t6PKPtvIqVv+xOMl/BkomOj7Jrah8HVO96QnJmS+mhk9gh1Ie0gyVWZ2/Q1tRUvlrXoZMZwPt9goP//f////////////p/19//2bOVWNMZOyHWPc9mZEPR0MZTVQ8xlZ0NRXVXnZAlTgWuquiyfyFzRaRRbEBYEPLYvuDG6o+V2vh9psjeQDGGwHRDFM7EFT3IvHBUSHEciw8PKpKMJrCgtn6nwCKvq5qVaAQEsGKBJJq3VyezPBojezuXXQSd2Ctd9q3b0fP/bV///v///////////+9Nb7KqZFdboIpI6FNdNTJLrUzLQSXemeoke8lea4xK2MrgZtuPrpDMYSLISMMJSTA73a3pZhYvEjZ2OtkfRpRcd/nSqfJhp2ERv3ojDSOrSis8FyymXRUmO5caImxbur6OvV3lOXwwnoC+Pc5KyjsVrZvWpoEJP84Ltvb2+b///////9P/////9P6aqvzka56HHWdyepqS7mIyHzGZDVTI0KRRh4GzQBkXT/Keqy7H3TGjQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAETni3gflTcogu5vAzBW5ReizeB+mtyhk728D8qbl4mRpA6gvUawtapa4i5vqm+aoKGYTMk59jSOhvqMYR+Hqpfd+WmkLizX2Kz40KjXviPJkLFpxU3zYGOKoKUNNfvVMIfz3Hr87j6asgZLfxbb0Tmffv/////////////+9n+YanXLv2VyY1VRephhIxjmmobdKuaWyNRF6DDZ+VQiVrh46HY6EhDVBNDMgRBgJx6OL2swON0sXM1sSx4ww0DM9wzT8WEnbyTGDdK5eJR8rTOL82v/CpUwxGSrhl+DPwDgVqRhiGp2nsR3dKk+XLnv7U7TB4e3WAL9fv9P/t/7f////////+j/v+v1vZbWQhCGotESjjCFOUexmiYl0AtqCATFvggVNtTC4YrLLFJQh0NBoEhAcXpE6hq67VI/xvt3tpLCgQr0PgIOxpc/pWoZpet+8xVMTjGUkulzYOxu2rYiBK1xexKRIauxjmWv7jIPjDpPFO54OrUoK02fbLH9fv9H///////////////b7q+ySr6FFVaaClPZaDrTWtJ0k0UWWkzJLooXZSK1qdSlIVrze7vpKXmXR7P0REOKAIeDvFhU55LhsbmeLGf3amasiTMEjxk8yKdqP0RI4xJw7rh4F+SqCUBSR5Z9zcdXvukp9WB8YAOYkQFqttWLeNqVbsQyWq3jg6Is4RBn4YfN+vr///3///////////9tfZZ1eZdCJVqY7OfPc5KHMtOXnDrN/Ndk2nOxTWzDPCO4Up+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABECBN4H5a3KADubwYyduUUoE3gfhrcoCNZvA/Km5UZCBIzwFOGI0PW5q76C5XyqZzbnR1fD7HeTIsYDYpS5UOBYAl9EOmN+z1JjFYaxUuazKiUkznbitan1u1P7/w/nyJMzw76nWpzAGg8v59/V/vV///////////q///6+r162RotX0NLUy3rWp1p1tUhtUdSZB11JOpa3Rc4vmObr2p7HLHvKyp841KiYiqcTq5cqW7NW3d+5krMnBJIi8zMbnImivWrta+AZhJohHUKlSLeS0rNfHviiKr8JTGiNMLmxXU72a5O496Xpvd50OYANtOD9vR/7W////////////////3788+5iOeuam9THreaYcrZQhgte8ZHrueCU8+N4NlJwBIqs7IyoFEZgaQjLxyan8jY+v734NhZzVX68Jy1S80++FV+pY90JnyUDH5hSOms2K1JYpVhh4EvvR+mTJc3v83qkq4ytlF/XU1rdnAY61dmSb0/ftX//////////////rq/669dbM1SaK1qWqzrQSQqqTQvNLMapvTTrWgtLZdTmyPSALtZUKXVplaS5lXrINARwHQE+2ME8a1Nbh53KZow0rTpNOeptjXkhb7LJtZBAGkmSoO/zd2VdSl7Xs2soDKCod46JnCFSVV92xZzvX9ZzJWHPf/VIKH/C5f/p87///3///////////+muhy+0wy5ezZOgckFpSaF8yVKEzSaoWxZ6/fbYPl82BaovsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAROizeDGGtyihGG8GMKblC+DN4H4a3CEUebwYwpuYxLxQqh8jZTftdpc7sv5/MMIBQqpL7dCxuYwlEptxBcFVP2bffrfPg7+KmU5nS3qUqLJgU2V5NRYkIv48ytSutXlbXZ/H+tzgIQUvzH7f72////////////////11+m1KroOtFlPZJ2WtZi101smtVdSFalII1VIpGTJpJoJVs1aq00aaJs3vrj9p4DYQuwYlD0EU1mYp8+Z95KLUeXRJVAIHTp1ZgoWpS2nfwnrStais5SqMVFUOXa+W05CIcgzboKJCyyZ8TkPZvO9YvvUwyxh6LdUAvp6gx9P/X////////////+3T7/Zvm7MdZKWZ0NZlmJnnM7G2qx6noucqTWfNNZ6HKh5iHHvVUMfVCQ6eAMWVx2kECVALx0J5ybXUZqvV/yV8up67lUNmuU/UjT536BX99xIUwxeMY4oXmkTnX1ZqlRMC/q4nOgiVoms7+uXLVDNrip9/VOOgC8h+p//6FX////////////bv///XSd60Hu12ZRpdbpOm22yKnRZM7oN3RPHEtJBSVBlOx8iUb3AyZFYQANiEPAgnC5E6cJNVl9Wvjh9vWWhaNRzaNp1fFhaftNK3auvrkmpjfpqHJmf52u6JRKXRnCbBXm5lDqHHCk7v9PEsW9/0dUQNDvuINvX/0/////////////9v/VP++iGsYbPVDLtNPqxK7KelzVSeacpxu+doep9qzTnWc+qMikp27JVyaGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAQHhTeB+FNygM628GMKblCCFN4H4a3J/cSbwPepuXUYwwTxyGgpJta3Ctrf2LsAFttyjh2PSYOgyzOOvVTKHaXWzFQiJxColV+7OOKOrH62ElQnLTSwoK3K96rl/YIq993nyMACev0+n/r//6////////////9P+6XVTzGajHO9KPdU2Q085qLZjbubNSyI7qRs7IrpcqskFjenyC6mOO22WIP4MnY4/U7cszOdvfPqXJW/kae6B5TWrwge9P3m1xfDJScByzrfe3SvlayqFUz5Y/Sj3H1KxzfPpsOY7gBe1/Dr6UAab8s//////////////////+/VVatXVznRFMR2Qup5qHKayGsk+XSpzVSkFxdY+hyNiywldLIJnY0rSZzgD0DjN8GD5sb+X31jvbYEvcIcri+ovKI202tYWbeaXIGWLwRYwTx4m7nhVzvqYFAtXYgEVQ9XDUsdx79bB44B1z1upCoHU6Nf/f/S///////////////9W/WtetTK3WpKjSajzl0JoyDLUq6bI1I0mZ03TQQ3W9NqEyfaGJ6qG7CNMhpxnMB2BGVG+gv5N3+catEIGGjHJk7NDNRBACh6ukHpPRBCKyuANCpV6gx67JUVi1U7gJ9SAlm/x13q+cnsaFbbumwErV8Sv/b///////////////+n/p3MdUc90RnVDHMclNZuaqOtZiHdGmKq1Y1jZranHKt3sQlmEZxcjuQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEGIw3gfhrcnkwBvA9525QukDeB+FNwfC5G8GMHbkn8cyxZRYzChsru+39ouuVL71JDVp+UhsKTuh7dHcZPismjXWOGShbtEa68p/KmtVio5yt6myOaHdzNWdfu19fNq+HP3dE6GP+r7e/b/////////+3/////9akL+i3empq6FS3VZeg7ooospe9mpPrVdNbNVU7KQZlLeihdBbGam0Zm0kti2nMPgRpORo8bc8tqTUmD7MyKfjOT+dsfgfcagRSjoN89kuYRPbkyltrUOIRLnIiwBECEFVBvqlv4C2KS8t9LuC7+F2/7/////////////////6enaroeUdNfc/dzXdbuyI6nq3OOOZndR7Ytgbd4rk4NHM7lKu6Uw5FyEfIfSC8m1DhzX/vaygPZVNGstvFkBbid+DL7IIs4BA5is8k3L2U0eFzdQhUkBT8lJ2EWCyHKxZw1e+rqxjz0qbgOf1//3///////////////f6T/bbqcx6KYYbNOvRWuQmojmnIeiGGHUU09D1ujGpnKc17mmoc9EQ5JOpkmrUkKwQ/S1w8aUjcuw5Zmscc+Y/95P1QHUOStTruURb+tMSXUVn1HHiZvXIrz6OuWOGPo7uLf7YKQkiIGxy7cy3ztlSdrn9p4Q/zPp//////////////////boiMY5k1TkQ2zKqMa7oRnA38YC1Z0+sqD+XiAeaZdgi0ppT1U8YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABA2Ct4GYU3KAUabwPwduUAYo3gfhTcn3xRvA/BW5IA/ktGHo9k46hgfpea4VMbij1WJQaKIl8w74KTeqO7caVFHpJJV27s6vt2v8qWZSgnU9frt2BMSFMXzvX+/Pdxjrq58/RMB/+n2/9P//////////////9+3bs5p0xTT5xpx7XPcrQxdWUye7UPmGT0Q802lDJjJLqH06hMjMVfpfOujkGCFwGWfWa2c4kG8u+XrCibhZRrSgOWWdTKmpsoaqLlbmt5R9hG0XqL7F66VSv3W29QOOjNIMO91j394Ola/9uIP5Rv/////////////////X7deZZzzylXOs7nI512VmmnGLY91s5I86qKctEPaYqzGqq2j2e5qseYxNFoIK5MhyA1StXFn6l3rxL63ljdUpwbyYChaTNuot+e9oea+7MSIaNDpRollieedncyKDnb+TdzKwqtXHds0V35z/qtX1v79wFH//T////////////////v706LU99zmvRs89DVP/6GsTMacxiuyLQ6qmJ0Ps5piKs+p7GISm4JhgFNpuXavFhDSZ2vVJLwb2zzVhhLP6dnVxh2err22rcLvXeM6SdppCUQokt5Nne3kvl16SpBZc54oRcv3pvDuWrb6///UJt+F//+n///////////////0ZGS7JIrHLmIUiIVGLcpe6nStCkVHZ1d1a7ylU5ZmS6MjjD0xZR8f8pRoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAPmjDeBmDtyeE9G8D8Cbk/qNN4H4O3J5EYbwYwJuRpRAzACRxKD6nX++Ww5yJsKuNPrgJ1PnKEePm5JXcmRzhKxLNqiYN5fmWNfuTEHOnNxgH5QElB5u93HtvXazyfl/TAP/r//7f////////////6f/o39echlUY+Y63nGHaaopC9TT3Ra+aiI1Jps6ae71UyZMQyaqkWQlRSDCpQwDMOk5mZZt65nkvv+QSyK65GDObXYbhHa8OaqX4ZKgYq0ZuuTiZXuYX66/72MoFup6Nm1+VjL+4zcDc//wDfyP//z///////////////1e38j7mR2tZbIh3dUYinUhZJVcc1IRRUVM49LZOXxq15qqePibuAgbDrZD9DNFvzet/NPXP5cjrVZSyqiDK2MKMOLzb82lOr7Zx0SWbxC15c22XO90i9IaLcqD7v+VhoccrnJzmf7w5/XBj/p///////////////9v/+tdlM3z1N9Voi2VS+dd0ajmPOMRjXNPmsWNdFScikSmddaHGjp6vnGy6CAiSP+zsHHZo70Vq6xu3eY7/vOLT1GMV3d+DWb/y73uD9FULeQEUHtQu9j+OcyoznjKg0bDlaJjXY9zf5bfLDv/im/Bf/+3///////////////r/RL2eM7su86IchqnN2IdqKpkMsszS0odmOcIzqrEDqZtCo6GQJAepHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAD7nw3gfg7cnTONvBh4m5PPcjeB+CtydDGm8D8CbhjlL6iEkQCPArDi1zX/j2YbBtmtIRPp/bC9+WdHbh+WK8TeRiUfLpV47uth/Hab3O42UCCYyVlofndcl+u1J69znSga/p/7/X//////////////626Lf9r1ahhrsYe88giOTPLObc5WmHLdF1KNWD0wMpoYYBb4CpU+sLka8asuWSHFQTM1rz07Z1Xtc/63AGVI3QBYaQ10LFvKu021ehLRUHeLFKjJo993OwLL0PcA8DvMWFaK31prK7QvH/fK34P////////////////+1/9kJ3lZZ6Wyu5GmszDRpsrQhWMWTLS3EdBaVqVXX5rcHV2NqevU8OaC0qzM8LWoWNd/r0OHclUtL0f3Ni9vcUxfWnUm6REJuosicZRlW1jigjoaTcEAgbyE04/n2vqk/taBcdfrwKf8///////////////////3X22dmOqK6nYSOgg4xTZRWZIjfD2axGrrQFJUxUiQfZx1/PZNEAy0jERpAiZjFltT7vr6y12swvF9sFXd1KkSL3wnkFZSl2VGHxVBtgeON/XRwTHuZvAAmspp8/7Z73/zl2v/8V/Bf+/1///////////////6dqujFn1J1dWqRJXSUynMSxCg2UiUtc5701kaSVyaTPMtt7juRkQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA9aFN4H4O3JwzxbwPmVuTx4U3gfgrcnXvVvA+J25SFCjF8uC8/M96y6z+860ZpGcjlCVf9eB6MbkP1oAn1LHjULdAWTYbPY3zddD1e8m5bDLECCY1Dn97Vffcp/Pn/hF/b//////////////////vXoq+nMQxLtWivQwxVPOQ02a7UWlUc45mMOWYxjpQ9S6dXdDRMZx1RsZdOyMGICMru+Zok1a0tZNhQjDMGofRlC7EcpJF9ybPF4qB4SMDsw9A/daghMbmrFsHuJ91ZkpS5wnGf+Ar/n/9v///////////////2/XmNWru93et5URVKZWryEV7zixnv4qUucPIAu6VIk3OWuUR9YnEdwg52o5/B1/qubfW61SCaruUqq1u5TJA2PtX5dgmOo60JjSFfXdv47/ruJ581MizCwxcVW19btTf1op3/+oW37///////////////////6NZtnqy1cjEpRmVqKVEMhyvMPLK5SuQiuiSqndjUExvVT7Zzn4cjZ5hqMLsvBlNjnbFL1rpBJ1CbzArHhY0kyZB6PrLyyGpk2fE+j6FlpiP2pMoVsJ8NUhqgDgXb1MplvTJH/hE3///1////////////////tvm16IlGVzUOn3MU0pNJKOmqeYzIeahp4+tXja1XuuD8Nphe7AKcAIQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAOqfzeB+BNydNCG8GHnbk6CMN4H4K3JwUQbwMkJuT5bhFC3DfSunPc19Q6Z3/XiWpqW0SmuGcdYnfvYYx+ynIxu1BY0q+z7u+99Ds+dnlYu+Sotfb7vlf/3jv//L/X////////////////0/9/bqVms10POZXYr3SqoR3Z3QzOJlvDsSiwxgjEYdVf723sg5jbRLGUTr8DVFLJy7nUp8c8edrXdCedieqDNT8E0zHcdKTaKbjUnFFGEYj41rJmmrrJ6AMpgnnLrbf7fywd//UQt+d//////////////////7foqZirc5U3ImVqrWct1U1nehrIjzGRFNeUNVnZMdft50YNcs0DAfVIpkOLGQkrpX+sbvTev18eiuotgxbW7DOsuV/mdLBtFqM/Yhi9ePL/dkgIRZwkqLxIp5ML/Lu8v/s/r//CDfk////////////////3///q6V1Kl7qNMt0ZzH2d/MrVPUhEcrtXWzlISxDTq91a6iKqNteKyVllcNg0RRO9fq7Xmdzgz7EoalfJsLmWl9iLGgxozw2RnyBKDxPZ0Q0ceD7FMBkljadbHnZBShzv1wD+X//////////////////+t9PskpyuVXoj0mSDYilO53cU86NIxCM+jOT1I9EFlaE82x4qzBcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADhnU3gZgrcnIQpvA+Im5N8ijeBDytyae3m8D3ibldyUHioJPvuXyd2n6ytLc3fxbzvzTQbHaT5RbYxEaKcJi2HQwwrbxVSey19RACQkTwqWu4dz3y5Gv//qA/9///////////////////bVbN0ZJlrUz6s6LUqskhhYUmDT3vmwM8P38sMVWaIxj6p2+PHYdcGMlkpCc92telbragMwcLSJEXjpDtpHSxH9EQmNjxMiGIiNXTasLxIulJkEcGcHpNUpXzIYLf4H///////////////////9re9piMptgTkEOrstmQi1VlRHHerHdF1ZFYrMrKmdwTgyXODd1pK3JX7QXYKA4CoUhW19fjENU7gSHXjrk1deL1NYcqsZTCPXBd5rSZqSs2vrYFI6geDZb2+Pq8HX/4Y////////////////////+q0TmZGbOo4cqEJqjMqM2UpToYqUIdDGPRXzlOhqjzvQtCWV3FTmel8giFZXG4Pd7AibxbdP9Y8Nt6bqhW8th3Q9LHZYxCV24LxNYhBtZr+LKNvGV0EPUy3ne75+aSv9//gH//////////////////T//1es6mZzOtS3Bu230daU5vhbTH82eEBmmgvzkJ62H1L80uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAA0glN4GPalBwUebwNeJuTqo03gY87cmmw5vA14m5T2EBkKSCop//da63jrtAWgypjXbRS7WW3L54EmEMPMfgLZuTHZmWA+mKmRATgsQF0qQrZexff/HE7X/////////f0xUHSJ1B9oOniMyXQdDQgJhMLhlxcJJD63gJAsKPEwJhERHh4eSbc1IIJCCSlSnTQ7J5xprQiCpqn1mkYZsSBD7VkYyLWUwXu4uu619pht4w3hHj0n1vUX7+6oK//4H/b///////////////////73OxrkujIi3Z53KiEZikc06mpORWU13lMiMUqvhJGNvV3KtFqR0BwPaBWXVaRqK/deerj9rlxvZy+6kP6t2DrnYmJ7Fqi0O6s18+ygS2MyC3i7h2Sa3L8Y+2LX/4G/0//////////////////87WjMqOlFWc7KjGUPYxkNsrqzlHdlVz7HPnscXScaw4qnTzXU5Zp9jGQxzWLjiHuyMypYTsE+SNFVstfv0a23SBol90U65/fe+iIY0o3jOsVG/f2MAir/QHEZET/cnz8YaP/+I////////////////////9FazNnRuVBKG3Ud1epjMlnRSpWZllKtNEUpkrLRqA1VQCG6ggmpQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA4OGt4HvO3Jq0ObwMaJuTZHq3gfArcmzx5vA9pW5y8N0jDc4PrQcW3in/8rq61HKbeowdlcPcMEYl0Ya8EamlHrdr7Gk+tvJMAd5Eya1A3n7uof/+Bj///////////////////06bbVc5d3ZnqrtactC0889ndp76Z0xknGHM5uccq1PORpY+qzR6h0ATUl9WJgHiGweXr/z2rsTyUOGahOFOYg1vPMgoJcY4vDOOBETPTw+DcZUgGWIELyn71LHO/+L////////////////////9k7H9SkRiM5zUHPKdKhijO7ozHSvaiJNIpSzuY5DPqM8D3xxk9W9aeHGyllHo/3m24mevQSOkgdE+IrH8UGpEepDmGiR4gYsEVYllK4pxIviuhHKs9SalMSsl/gP////////////////////+xSLKjozHuh7ox0I0hTjlRkKVnGyGnij2WZ4DtpLSik664mjQakk61rdxjivqN9LS/x9UbKy1YnSxg6x8E+pH6RqHMJEWqIZUBkP4Gw+eUVhFFi0QdtqzgwX/BP7f/////////////////+mS+zzo6urVdzs6DknJYqraVlVaqzozETPo+WysikLKxzFi9nIi2sOYIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAM3hzeBbxNyZ/Gm8C3ibg1yKN4GNE3Jl0JbwPaJuStINQZXDzc27qqn+7ZNhhkO+mYhLt9KbSekGVZXyJux1f4zpPuFvzSBIreZtX//qya//AP7//////////////////9Gr6q97bpk1VH6pKiVZF5mciLfqHaxWLIVrCXJYdLsOyn9u+CDR2CQ1RL7/67+fmLBQip0fD4eOsyeHhFqQ1V024f/2/F2ZK+QelgQGPv/fxYrK//iv6f//////////////////+2tbGVT3fdy6TPUGdXRlMQ5XdiNNaj7NdCFOuyFIpjEJJKZnGxKRdPgDBWRxAdtl+tW01ONCbjcZhek5ULRFRnLHGQESIpZScLqfd6w+m+wlIJUPZ1qLq1k3/i////////////////////t736GuyXRdLqhznc5jGZNlJe6zqaYupCOjEMZmU8zVeWiINdPcFPDIWkUQ9Ofc2ae+/RtikYD1YYd5WFm89QTEmEMQVCu6G64/CIdnB+HuIlWq2ZjDv/if///////////////////r933pyWuh3ey61dFRbs0qMqoRyMelXdXc5GMcpiArwReinIcG5YPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADNo83gW0rcmjSBvAtom4MtjjeBbRNwWqSm8CVtSgRGjECwIJSlX1DPqciDwOmCIrIKMx259AakBgwgykm6grldyVHXUOo0hHOoznoj2/4Z////////////////////9NJ13aqtuWOZnlbW6LuisrMiIy3qyzZnJQ6DkFUTW1h87ua5hWgxJBLcClpvqnR+z1ppDdHZWSAc5NRvOICMibOTydXvUTA4M6G4H8gqsunsO5v8V/b//////////////////9PV0bR6FKiIY55SqhHLq4MQ8hGRLnNZWOJVx+5CEIqMtCzqzmRLLojKdxx6UFwfUyEtkxWhytTmRKqKJwOe6MhOiaLJM1HoKpsi0QtfGgbtiUYI531LqLv/Av7///////////////////3/dHk6UVtZzshjkGarIlFu6IcrsRjIsqEXKR2Z75GdRnZkacpwcqH1EACHCnlGHUf8MUlDK6yoIU5SmiHOGotRGyXmVx7iJSWcGKH1Gz7bjAt/mvT/////////6suwBnjpAskiJigYNpWElHAy8aoYSCInEBhz2PLB9rACEHiUPBEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAqwlN4DHalBisPbwMaJuS54Y3gQ0TcltuFvA1Qm5FkSY4ytjzmp5UYOG8CD0bpjtccY01Ixce9Qgh/UaiSBrOrr65Cf/Jv/////////7MVRURULnRwJDjoTHWFQsUnR4hMhUPAgVJDkFzgqD6QuJWLUVSWQ7oQCQrNL27+39nnCiolZORpl3RmLiUlRacJWSNTVi6WMzh6F1NaNVPWOr/4r///////////////////+9fstKu6UuJj0mqqVD0dUqyHRlQ6nSaxDnWWzNmQqx1PWU6gUAEZLg3AeHqXen/8rZY9o+53rUTHGIXVzeM9XHsQEmkcD4LZb0fQNP+C////////////////////7fatnORnSdK3s25bFPsRjKqkd1qzscxiKy0a5odzAkk2jbYOaDqyYkUQsgxmi07f7jjiHPHuaT5eQOER5coFtxK9QRq00CAPR1fTQef8v//////////////////T/9WestTwk7Nqhbuw2fMKxuXUnJqhLT+lUjR6iQyZI7ZocvMFrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAL6gbeBTRNyX7AW8CFCbktOCN4ENE3JcUXbwLUJuD4MiyIsW0Ws9vkU8xAYftZbVk5h/Jh9NKSD9YhyCzLHoCiNr1fMf+D////////////////////t6tZLFRiFNZzudjKoyHfWVHs5z2VWcpzSyhFaqDUF9Qlz/Vk4ShGJQwUAOaEIEquHmr/YZiYpBLaDZ1aTMBwYyotRevUQI6ZKBLD0UrrXce/83///////////////////2T5aupalKz91RYp2ehkdnqxnK8umOxCIxjNGTr8O9JAL2/G5A6GIacKhR7R47/+RU1F9IcLVq3k9EiE4tYjT/xivqHqKhQU9/m3/Cf///////////////////7EIrZ92puS9cuYxDHWrmvV0ZWaRqqDZRbERDAmVW73SvoK3SAEvLoeQ8hgbU7v642EcciJUdagseQoBfMUaWTxUHdQKTClbJTkz/5f///////////////////7Vl+liu0p5zZDu7IOCQ50VS3KarkUW7GbkKV3ZVO6rO2y7HnSDIojwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAC6Y83gK0Tcl5RJvAtQm5LWhTeA7RNyWG7W8B1CbkKDg8wQAIbt/lZtLyYlSdzVrOYuPqimcMWR17G7VjKFQbFPXbmv/f///////////////////2/fRd0sZ0Ijn2cyMitY5FaRcvdFkIVGdkMz1M0p3nsY+6ufI5oOPWmw1GkTrTW7/9hHJY3cKRp4s51FBsKEphLIvQShtdAOjAUrpXnf9P////////////////////2aidLKpGQlSQ6uW6qjlmdxBaOzPoUyHUeQ+zRalUrspUccrKYxbRHo+oXisRfa3zF2PRWbN3rkxySMy1RDnvUMyC8TgWQtFP/f/l////////////////////1nd70WrnU5JURTkupandUS7KYZRRSMRFLd7OyK+87o0RYSflJ01+l4YrUWgSCEiZ39rCO6kEGt1ND97aBXFxpzxf8MC+cB8ZDvWnLf9f////////////////////+1jRBnLsyrK4udkJnkqZxiUIP8iIXDPJYE4yof1ZpmFDR3JRwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAArdyt4CqE3JYkWbwFOJuS2oQ3gKoTcllyBvAg4m4KoFAADiBUb/sKUY4CN6DzOnMIkZjpUfSbTLjj0C7LgkmnzP+n////////////////////tY76KjH3QiJokjHmiR6cbNLmLrmtwIQt/uYr24awK0vUdPIUeAyAmazfsIScWqEGUFG7qoRCbLxzfA4hlQECgv29T/+T///////////////////2/pQpGahqmqhTZjMi1MUE+jmKqyI9CN856KZrFYhzKQyHWXigIn0xAEFEQsIyW6fTLngsGzxZ2UrEUI5MaJikvw9N1EEI4cT+7f8/////////////////////p7OrtWxjIVKohyWI6o7mQZTUBKwZjudVZWORmVaIpodIKO9zmS/oEygxkCUGjwvf/1YTk5OEO4FW7QciBzzJ/x4YagDQMfp6D3/f//////////////////9v+nKq3s9DyIdrojbGo89wTvRERJW37HMjO7lVjAkO5WVDIqknZnc24cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAJuGzeA4jnAVTGm8B1Cbkpd/N4DnE3JVUcbwHOJuR5gsLx9dr/46gCAbqLtbOJIhZAyg98UktADRCHM6fR//////////VbJHzAdEwqkmJiAhSSOip0oEkhaARQsQMLCqRocMFHhsqAC4WE0XmBYJSJjv/5UbKUiK1J36OIYiL2mv7FuCoZN/xZ/7f///////////////////T/RXq0zuVkI50dpFVEkKtpXO9Fn0Y7mGhCTu9EVmV2u5Klk3SDNDSSmqEwsY+n/mIaoDtEzpSLhCWKDeJ/sX4NA8Y/5D/p///////////////////1fpv7WUxvYdj1lVVW86tUuaWcoE6I7WKJUVu6oEZF3LaTFYjPSjSQAcMhlKf9RfIxrsNvWLTi96fOM1CQcLf6l/////////////////////3/6mcv0dmU0x6iqGVioysiHZz2eyoSU2pZGdSnIe7zqZlHMxDnOY8p4PKkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAACThs3gMJRwEyRJvAUom5JxhDeApxNyUHIG8BSibj2IRgxrv/xcVClbXaexKLxw8TpT4uJtRYDFvE/r//////////7XFUlhc0ASUaEir2gIkC7RgoZFHH1EikMlwifPgEqLFSCR7AgOeHgQB3Rv/i14epBdqweG3t9hzUCxg7p8n/X////////////////////6Vs1OZcuCZUqhHd8zI1UXJVFesyHa9Korts1VRg+YiF03J9mgK43f/0mQb29ZdRgqZX4gM0E4pf/nf9P//////////////////9dG/tuRq2cFKZkUt1W7OyIiasz7I9KHR1IrKh0MyD4OVf0sWUobGSMowIhY8n/0B6S6g+tIpHyX+rcDHb/r/0////////////////////X2nUjasdiuUcyXK5iimMpHuQjzyKmstTXw6rRxYfuTQyEvMYznu9ywpgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAAomON4BHE3JLcHbwHOJuSDhu3gEIpwEivVvAcQm5WGaZf/q9lCTn6UlkLKHW+cW42Kl/+W/////////////////////97abOhJjI6mRamUrkVnHUjMtkrnszMQ6nVVBHU+6MzMVHSqWQ1FXIoNmdojicLEv/yh1p2g9+epe0z/w4q3/O//////////////////////fSz6GyEkNcpiEBpUy3ZUY53ZpGelzkUtNbPac4Xz1QSbD0TLkSdDiQQQf//joH9Da9xjIW/xMdwVR/3///////////Qhqxh9xmMLrJDTAgSpYVU4iLBsuJJEJExdIeKjxpJZq4eGlj7DojBY23/ghd5dBO3Ir9/r0Awf/t/////////////////////bppXVV2dM5kR5N5UPdituiUdqA4AcF2j6z1dFgXWpHa3thEEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAlGMN4ClE3JFDUbwBEJuSNIa3gCITckMOJvAEQm5sgWj//zKiiXHb8iMg+X4R8fH/8n/////////////////////09/v20MU/S9Wkd0TMh9jnORWUqOzVd0ORi5AZzExiI5HPA2+iUfY0Ff/gjUvqf9Ve8v16hl///////////////////////99bNoy2OQdrgrTtKzjkgB3psK2xRU9QfjIFIw0hjX/iYhClmNjYmX/+0B1P+qZv6vyI//L/////////////////////0X8q25atUyMgY7Ozpfompdqqqut3ZEIhjXMyucp2VBIGfGMztphARhYf/6Ht9PzX5v/E//f/////////////////////7o/61JVKPU7TsQjCmZ1OGsY2jxyCvhEYNNxYhSkA26heQQhHqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAHBDLeAIBEwQ/Hm8AgibkbgAN4ABAABB0ebwBCJuMhfTeKz2q3qxb///////////0JYpB9zlmzDwRFzISIMaSFywoeURJkQTe4wFwEsWNKYRcUKwGBFVh7//lv61w/D/4///////////////////////9v7fsrKdFVEqd0RGRnI5jnKiqrspCHOZ4tilRfsUiM52p3ZFMVvhZGlP+Vo+7slv///////////yA5w2YB8LraikGwcek2CjCodIgEeIgQD+ATQknSSgTD8QkCJY6FP7/////F//5f///////////////////////+zp2Z0chD9FUhnLIpHQzOqrItCvdjSgmsx0stkdkGMVjNKpHl7XHKkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABeAA3gAAAAD/yBvAAIm4G5hjeAABNyNm5G8AACbn/6f/////////////9HVURSfAMGlBlIdBlRkIhQ7So4SUGlDRCdQWaHXl3CUXJD//////1///////////////////////03ZdmexJ0o1HMy1KflIjKZ1VjmI0l9kZUlSVOpV3VqMeQjHQEKDPqRwX/////////////////////vfZKVkczGQi3WzlVzKdT6K5Huqmmo9Hd4kstGU12YOildus2uZcF/////////////////////7yJIjy1ZzsUtTIxprFZxITEDdeVd1t2BBwaRXElGUiNRbdQ0VdfYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAaWDN4AAE3I2L4bwAAJuRpgA3gAAAADINxvAAAm5/////////////////////t6m9/1mOQ5jkmK89DDNu1FMxSNuhUUqusOiwWbs+ku1p36hi+f////////////////////l6a7oyo9z0OxXe07qa5aIhWoRNlkOgNYJ2VvLwYO0QAcn0VbyRJ////////////////+prhEGR5ZInBw+ZPRVZ8ebCQlICQSGi4UCSgyfGjgIYFzDxcksgVJAf/////////////////////0da99LmVVkQLn4bA8GAdaa/dBPOXRQjZqxbqZBE8p7HKGwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAHLhTeAABNyOHB28AACbkc6NN4AAE3I5EYbwAAJuf///////////////////+n0nsbZNqgnXV2QxqEM7uVlczupFQwNnnZKnRVUxTFZ7xzLkBlXilSLv3//////////////////////ujMyUus7HQczsYrUdCuqEK6IzETQlVI5DO7OSpEQS5r/Kh8YFBt6n/////////////////////7bpvv7VZmucQRFMyndGZkVXKdzHlutns7pcqulCEMcNIhUViq5FYGRkl/////////////////////77Kq11fdSyFVllsSUIpWOrqxboVSsQ60sRzWR2czrUhna1jkQxB2NOxAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABSAC3gAAAACrgBvAAAAAAAADeAAAAAAAAG8AAAAD////////////////keSKu2kj0JB2dKrdnioSeFALDp0iWJYFFSOoqGv////////////////9QFFXEirGEH0B1Z1IaamAg6xgKgqx56uROtJnWh1YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAAAAN4AAAAAAAAbwAAAAAAAA3gAAAAAAABvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==";

var ExerciseFinished9 = "data:audio/mpeg;base64,SUQzAgAAAAAfdlRTUwAAEwBMb2dpYyBQcm8gWCAxMC40LjhDT00AAGgAZW5naVR1bk5PUk0AIDAwMDAwMzlEIDAwMDAwMzcyIDAwMDA0ODE4IDAwMDAyMjk2IDAwMDAwMDRFIDAwMDAwMDRFIDAwMDA2QjFEIDAwMDA3NTM5IDAwMDAwMDM0IDAwMDAwMDM0AENPTQAAggBlbmdpVHVuU01QQgAgMDAwMDAwMDAgMDAwMDAyMTAgMDAwMDA3RUMgMDAwMDAwMDAwMDAyRDM4NCAwMDAwMDAwMCAwMDAyNzhBOCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMCAwMDAwMDAwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZ4cbmDDGNy8W5nMGXvbl6RzP4H4e3L9DsgQYw9uAjBe9e7/2m5snhizYqWY3G5pQS2gnCu7xgyvJaoSy4aP1JaY0Xudeyyt23j+b5CuEA5J9HJOAaHpWCgJw8K6ovh+VDyEzMBIUg3VOYSCqBglx0becKhooViQJBMbtzZYbu2/izioA8vAcUr7BIHh26SzcQC6O/EtGdvObe/zNOyp28eJ1frG2jxtf/a/lKTRt4zeYpP5TabfW7daizl/7em/eb/Sm2qsr9IT8uExDESKAwitTOpsz/NvOLJET2X74ie+a3meWEPzz+++nlnCAeAYpa32VxJQ9PtrE7SRiUuXD8cWTTbCDjjQ9yOiCxl/WjTSCUjOBzqZZQ+Jl/Z5NeHHfw59J9iNCK/RZloguBoLk7h0CTjwL+tGeScviyr1ehhbEAQdaZNl8P0Og/2ZklnmOwxFlHlsLYZDHbTejFftvZ7MEQ/AkaHCaJRXvhXCaIe9L+eZBDNJPUt7kh7lEve/98axVXvlQp1vbxjbkIb2ePhjc2Cbfu/hGmzyMlb4zH1neWO1bRGCK/nhs8DN73vv7h7qrK3gNajOwsCLJY6hHI63nEzzO637HCmeZxEyknDKjJOvHmf+Z///iOP4jgALplsx2hzm+QI8TTdEgQFVe5wEABLcf1Y7rwBM5zbW4CXe5SpEfF5w1GMbEsxzrQxRXMY478bhujj8XnoEvP5dlE27aw7RJakI7SsEec1XMDo3CSGhMyEEEkL6JuCbANxcUGuyXqNiX1pSq0dhdTiTUBvOc03US8BkP9PHQuEu7Z19aipcthiIQ2rbmbKD2qHd6Xqr7Vj5iemosaHLGfofuFRWJxDIlD8cH+/isK8al/mP/TUOOu0fK+iR2+zBpgls8xnen9pZK0rJFhwG56f6oVjJI0M8NuVHvSHij2NNeR5LHA+B4fvwPX4GUXXQeAZ5v/70gBKk5E3VDeA0lGSpFvY0h5c3/fuGgAZOB+VTwPWZXI5lncBMTf5TBFBecBORIeSyksXIxelF6AHHdt+8pLB+FJKVNJyXUTpu+vB9VAHCQ0mnlR0jiiEAThwcBbBCCeiHgmwAOFaY7GQtD2JdrSZUI5CMl6PqinL+abQrLwGQ/08hC4R7mhaRSzo8x6CaGQ2uTOVZr7UDnHgZy/xm+YmaarGlzZ+r/C0rE4dEShuLDHbTY4T+SBnUsfV9UzHXaFw30SOxxmCrBBs8xnelfClkrAiyRX8BuVp/oxOKizizw15CKZpDxSrubMjJLZ5mlNw3tfeMKHNToIHAuJ6nCoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAKEHLG63nLcLJqaO1h714rih8ttZyAKjyzo4KYkADbbbbbbbbbYnSrpiIUo4wOLiQ+reBhFeRn6OHDSm1VazMEwAqcJuGUUiKTDCIJzEV3GjSbwUcLsMrBxhECme18xBk4Vpo9usmA5cMppqriwTEkUAgROpMVsif4kMNGERrXFcQcBAE6QMENiBWM4NAdAZFgK4AspMe6qValQGiAUBfB22HhAwgdAb48YEuGOEaQKqRsqwsOTMRhg5nHGYQX2Gj1dCA4xigsOBEjTJAQaYcSDgVB1tAAADBiwiQSgowkHMmOyFUDMAYMRLpkkrAcoOhhybrP2lQ05gD9rTiT+OzJ47LXLpIOQCKQSpaK7UvYq3RdcBtSaOxhFjOMNo8GXxCs5bmSaHbsrkEYjc5+896www3+Uot409qpupS518u/zPLnb30kY7lfxz1vCr+N7Pv597rtjlvARmXJ/p+LvWjpttttttttttALYyWOVZpvJe0LiCR7H9q9euaEiNxrqiNHcHupT3UbnRyivSFxouILlrUkjRJct7i0w4xZmMRZzg2waafud48z0DjK9FuQ7EZfEFQoXHrZhKoRgvY80qonp0XdF/0h5zrt1FSafTBfy4KCJVVQIKfZGlZYirNYnh2ljdIx8ZpxrxYHHCvdMfxXdolPrOH8e0mvi+sVw3rWLx4NM5rAjxpKBACHfo/6T6NV/TbbbbbZJG0kx7qIM4ZIra38TMwRahyPGAEz1sz3uGust+iGYwgGIfgRglnzLNM8NB9h9Axsv2WTMs8zRzHBQPYAYZJjkmWWZp5nkmGGCg30CwBprmuyaJJliloy2881xAABRTJHCD1L1hlMEHJOkIx9aBkMBGg0AZa5wynGaFFj1vPW84VQVuPLKKr3QcX1BoXFBwaN+JedrS7W4gkExyUlQ4BkrSm3WCZYl2sdobjsGhtX7iJeIVy9Bde0QZCHFPKowuNfaI73QtJVoUCOU1tU6m7O3HfuvUfxh7E1324HbeGMKZ02VsTceLwW7dJKpW7cNx+G4fh+R1a9PK3/ryuX17e+45VZdPu/L30cSvLqkhZ21956SESh9IRVmoyztgDXGcSiQQQ9jA2Ho+IqSzDOnlcvt8/eeedvPP/z/PPPv7z7vPv///////+eef//8wzzz///DCnD3wAAPHhtBWMuKFgRuLzwQMZvCsfbI7eF1HPlc2VYeam+8rPBuKAozCZyIwQD8QRE2G+wuZOEBwjJLiuXeuySjQoVQhs/HZlLOFFBQ0BZ9NytR1W1aMau5swVRtAyiaQyMKxInNs34Zn//9fIb/Xhnqp3OVShkMlvrN////2Nw85wy9hDISy9974/57bgOSGFOVS7rAAAAAAAAAAAAAAAAAAAAAAA//viYAAACsiQTAZSoACSEglgxSgAJVpBWbh6AAKpyCnTBNAAHcF6BbQTDBtAFQYCjgLCQNeDDVAHLIBlgNlJYkh+HyLnAWCYOAAaCM8IwHeCQGDoQbwgVBBmMqCYAEGCgQMCgQNlHUAkDDIqHOGaGRWVSfIiAuAAtaLgGAQEWDhDBmxQYx5kOorFsMJgYVEAGBzuBhAyAYDBABQGEhEIgKCkDTAKAUA4bwak2DUPAZgF5PDpFGKQsobYWhEWIsIsOcOAgZNC4y4FsBxEgHtikRPhEyeIEOIQnFzFMipUFlEkTRUD8RGooMcggJOGRMDIidUBsD0OQMgZlIgRMi5hCgXMDrINKZ5lHyChfoMob0WTQZAbglw8DuLhqcJ4omhwuomBZMUUiiXUxmV9SZgaJ0DqZqUEzepbGxMJFQ2IoZ0hwlAG0RCwxpCEcUS6Q5M0Nly8cLyaRNGxGDnHzjyfJwfhmkkXPIIoUF1LrW1zZDm0rOiYJLQUvu6/UtmfNQmEcUjELQ8HgvDVR4UNNOFg1yxO6HEJiqeOFyB0uyPS5jFSAVkJiEfhUIB4PRBhdheklVPKuYYdJxcgwUjLnFyA4LkwmD81zCEWCMC8lJxAEQnklFmD4fF2NISdC4iB+KyqRj4WjR+OD8W0/mUX9OZ1zVdf6Ki2p9KmXTu3mnseaTmU7N///9D1////q5n///9AACgEAAQCAAAgQCAcBh1ShojBJCVQLmM5+c0uCMzMCAFTQxmAULIsBjnABJgNie0iBucNCdYcoSN1MpyABjQQAAxAAQYJuIkASvAzp8G2K5YK9JMMsCUDAcwXIFwJNCuhdEQsOUj3xwCCZNDgC4MQTNhqi8Bs8KWYLBACgnpsYPTRAwYELTyYAUBkWIgOMoFQMigJNAHRwMeAC5oZsWcLELT67eUBchUFkE4xoZuQcnxPQrcMinRmSIkyaDLMQKq9F2ahQZ3L5AyJjnkXN2TTIoaRmCcHUPgMuhcEkxAiiRVi6Q0ZkokF////+RQihoTiLkXJ8+LnFzkTDbyvIuQc3L5fN2TTZOQEpHRwmA2CacjBCyBAQFBQN3DSHUQ0igzR0nSHFEnT5Klw3IAAAAAAAAfSdqxYvz9MmJhBceAXA6BCgFUWPm/GUuh12M0yXclzUagsgJp/TTdNwuCIggcwe5O/0GTMEJKAnYjZKAr4BLjB/8uHpo1sDLAGmF4AArDjHg4wgwH/6bpv6E3LhgJeHPKYjYmZuPQ9//9TN/pzMLwJYNgK4F4IAyyo0DnkufDnj3//////0EGNP/8ebIO6CZKHTM6MOSZFL5uXDNNBBZopBRgaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgUjFQnM2ACz+8q5OLMAGEuPUwMbw3LJL0qEP1FuQQAAABe32w4H0PjzksZIMCQtXz35mHZluywyDQ8LndBZfGdlmE7fv4/utlbsal9HTU0qx1df1BVaIAVDFQRXTn0k5T3JRRRG3Hr9WHatFM1M9zNyxq3M01yULjbouySx9p9SGIDjMql8vqupKobd2B1NVjtddhsae0BXn5sy6cpsdyrGIxmaytzePd6137OGOvtaq1a1Wpr8K2vw+rrVqmyprVa0qGlpbMuluFzfL2cqxvY3a9Wz/MuZc1uxS8uWpTlhzLVrG9dq0vNd5Xs1KXBfby0HN4dxx/8u9139Ws7kpfVnLuyq13PHn5a1l+OOWvx/LXdczzvc3u9/dbwkgUTWmaQDJADM8qhC81TuZN1OpSRFwHHAXuVy86KlJaKK2SNqK0WMieNjc6Q4AIAbEmdRNk2MS8TyKJwvKcxLx9SReLzrQRRLpKE0bJomRMkVNThkpIpGQ4TyY+RmRygyMKMMaLOKJicIMXjcxNU0TIni8iii04XjavUis1nEkkjJExRmT2UitlsiarRmKspHRmUU0VJOsxZUyLxeSTZTopGyXSLyJkbLNUUjI2SSWiipJJNI2rRb9FFlJJLool01JoiUcV//0FcFPKgv4vFZPNvCbJZa7ctKVAmAn9WZ88rMxKljo4utcqxmjbK/kDS5YEwNFOtVysJlTvxT6Gk1TS29rf8huRVrE/IILd9j9EvcmYiYYbtXXfZe+Uxikzctq8Nz1Tl2N07+7l1yzUxg+VT7SFrt0GNK0pRhwnRpIZZW15wcs4bsw7BzAW+U4xmm7g9L+PXdh6Wxu5MySLUU5jN28bNzXbeeX6/t2rWy7njnS5Xv7ljnY3hnv8rUxqPp401mJ9kVPjfs09NnnOZalMN15fPVblvO/dpa3Pwzt6puf3vNYY1Pv3PqXLmTKZHh2p9/u8LnP/XOa7nleyp+3vw1zXce7/LLm//+45YY3+5Y87zL95b5M4Y9+7nEhAAAAGd4r3rKD8ga1jNYEus7/vNxekk0ArMPCkRqb2zn3f953f7ufe3Q8qYUmEw6ENmLMT664tcpMM87+fbLGqRbMTA4g6CZSTPHiZkomdIOVyIlQ8WifKhdRJgrDqI5Y54tAzQfYqjiLoI0TxcSWVigmUjUqKTWXFqmqS7LrZqkUmSUhPmzKWlXWldaLqMXagXjZKmtSqkVaGzUGqdTrRopItdFPopUUlWUZIOg67IPdqqmUiitjxqki2+1GVW/7KzGd7lsfjzSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAInpBSgzrDcLTPKpQ3LW6iHjFMjG8Nwv88qdD8rbicxy1nUZEcBQyq2adsamRCWXgcq7bncnYIjs8+CyzJKDy8Geo/ske+cxovllLyt/5UTdXdpbuMgutTEAF3hjGlHJ3MXC3FwHn7YzXPG3IhVmcrxCMSmIOtunc2HbkFs8Zep9hY7EFPaeRXKAv0+kPu3IoZeeHp60y13LkTVfKlbAVurOQLGoZ97HmiESgZrMsszs5aqRn7Vvt/W90la/y7ezwpN4Ule1jKq++f+e8OzT4NNk8MvtTTdNK7tvGrWis3Pz8dpov2pEL8/NWrdrLDlLRcxzwzzz1jzG3jnO6zy7WUUl2Gu/zPD8su91vGxvHHWG88f5nr8t83nz+Xeb3zLHOl7bravW6Kp+OP3o5zHLmt1MUQAAAAbsi2XwQtbpax8leOv7yheaHJyfQ6H8hAOF6k73/zy//yz+UWq2WN3KQyyNBd9a8qzodT35Xc8bB1ExTWkk5maJKTUzGxIFMmEwciiwhLPkw0YsQWXyTL48jhBEgZi6DsNy+ZLOKMzxuggbHU9FboM2t3ooUqWtlqW6KrdF7Gx5nTN2SMaCGqy3trZd2RpJLpq1qZemg7MtVS00E7XVVX/SWiZpIZf1WNLIMEnmXpKVFgQAAABT//eV1ljhzF65JLeG07QQICQhhjKKq2Ex0Aj+MEMJDjvAUiBZez4uw6ms98yuw/b+tHnCj2b8ZTroy1OVxzCEIvE8sca1RsBXw0lQSQuRDTtSV9Im/dJGYrGH+c1Y8NxHUolLAGVr2BqEDknVN2SOc8DhL2e/HGISqrMwy5blvXGpWpVDU7N6vUkfn3ztwDDUrgiX5z8/Vwxw/9dzp86m95Z45b+iy7yzlvP+Y7xnZbKIOzlPIjEMr2Fq/bjUzljLIzK4y70TypIvS5ynK7nLZflfr9r1t37/5/X1y7zGtzCT3t/zPDD/3/eby3hzPP7dbX1f7//+9/nz/w3l/cP3y7ldz/7tjDXMKtwYJIgAAACn1/hfBYR7wdWhw2lvP+WfY6ryG5WwIVDMuONOjZn7djv81jzHPH5uU83UtzW3qXAYky3olUjUuoJXL6evK6VZSF2rFx97SUaSl5QbCCgQyaQBoP47TEd5xY2pUmOEACeCQOgOWSgHMlzUDfQiDjDVA1ZrLc3Xcu23w2E3M2PbF7eJ3X2eg7ENIYrlrJqlUp3uqzrN9Mjf1LGHIqG9TPstzpdy9jYvuZr6q+ebqN5qw8xvqxSJHF2vKpjwyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACIiI0yM6w3LMjCpUPy9uYTovTIxrDcMZtumQ/T27BAAAAGua/fVDRHGBVVlNRmLe1DQCfAQGirX79ppTKlRN0HXJsYbToouwCgnFuZUud7bkOXd7EH/ik3ZqxeWxhfaZxpVQGWvLAjfwI1VSTA4KpZLL4w5Maf9vbVW/EJKnpALUJLDFxxG5l1FMzc1ZisqOqa8QYvFey6adN25DDzniiy3yQMMrDPowVpLXYhLZXk/8ajLcX/axAkopZyzYod7tXcK3Kv1sPz3+94ds18OZ29dx/nbt3jYIdtyqdeK9ctVd65U3HKuVf5XlK5djfu5U/xujz1qg/XLmeOs9a3Qa3lXpJZbeHuXMv/HuWOP73z9ZYY63vdXW/5rLet/ljZ1fx1zuHOZX7uedv+YMHWT6BAAAAGbZrTORIi2NWPS7IgQYNz8b3vuztqKxwAod/zp0zU2G3J/ut/bn8MsY/DEioJqfnYlRMgnjZFMYBb8niMxKIRhLbc9Xhx25/mkD42xtkd5mtSgMeATpVnMmFA/UDMw3jpyjlGOZNOZXHWqIJan8+c3bI/TmmLfj5za99yapXGM43uusfeayRtQsWzjHpvdNbxdqZNSzML6HaNTVJ8axrGd41B9vjGniBQnzSUiwC/CzUBnMJfaXwZ39HP99vak93jsIG7p1awCHwEAAAAS/ncPoZ1R1nSHYIfW5SNYMIqAROj1dwuRJFZXay1BT4qlB3xXEAiaoMqurtPTNnhjPlNRVK7rSGkp5tMtYIhjjgOgoIZtyp8YWhzd6IRypQNycJw7GdNHn2YE+jFLhdu6/SnaVawIIcstkbAnCeZiTKHspJqX9zfFlTMx4MMwddfxPN35ZhMU3Zh7H8gtUoHm/t2knLd7PHm8/1rPGsw/XNb1vHPP//KrG7W//d/Vh6oEvanLFjC/l3eNSWYUku7M24LmYZr030GUx9y1b5fuWq1bVXWXd197/vMrPxjvP7/f73fO87+/1+ssN8z7r9/vfcc98/Du8f5l3LmFze7O8f5vtTSRBAAAAFLW+rQSXk1mxW92IQg30vf9ulirTYEWQITAfUGgDPm0bSL//6/vOVr3L87SWZfK6V9o81gyysHBG9g2VdptWYaort6Z3mXLm45vmC3udcxJjOfSEraojC3trar8PYMrmywWdvVqGMrx8LRFlj18SVzf6atTf7k3W+8f7trHpi31m0+q+31jGc1+Nb0rou/GfOdsRa4+d2tB1SkDFvn3zfOvj6vmv9v//b6+dfMRV/qfxJ/YOMLWtP47z2viurkKO2x+QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAiMiVKDOstyyk26VEcvbiE6I0oMZw3Kv7cpkPytuH9l/c++SlA3ALgJ9C+8nwiS+jPpwgtPbsyqynKXAL1sJLrH8PBxGKNdBJ1g9Spq5anGmyjVvPN2tNpCKancVDFOw0QYMJtPqwA4TKomn8KBIFl71tzeSAmtsq3FYFoofS9VUbNTKsdORrdfocZC5rkIIgQKo+jTH4+50ZxkM1XcFbkmjr3ODLIu60ljUao4hnE4ZoHkKoIedAM1Ny2MY5YWsa2FjWWU1HM+dw1hj3mP4a5WeTD8NZU+TS7dfPKmjWfbNS9jKpXZrT+EXtwimjvOTfak/hGrdurOTOVuzqx852l5X/9Y55/LO57/9b/m+63rXN/zXc9f+t54d5+9ardyz3v+We41Nf+OOVfDY1Pz9cIAAAABeNKqhqgQonY69ExMgAAv3HWdWnaUu2BFFkizXxURYa/y8O59593sut43rFmI8lTz5VIBVujoNoLoMsjkM00N3oy/92xNLhfmUzC5T2vAYk+5WZm6QotmcbjmkT+bGlxeRXcB9HU5zsNb4QpJIg1YzDVlh2mtlnkdSZgWvb7puuMY1WjjvOa33vW/S+c53n39qRV/WqwYuLb+/bOt6mzqu64tmTd9eusb360tnP3jWfjWvnGIbDzmSqGsvdUjW4U4XcwpclmqAJFnvCwksPzCixEMLou6qK3gaxkOr92klKMyFiRTKxVEG7uNJELYAZteq/LJZB7Doa3hHJtx5TdvyN0JMDDC95qjU0jiM0vBgsWVMBnYjEpAwyXx95Vq14EgJu88vp3q8EtkbvA0+XRLspMp7sDDyKfXKw138flMXjFaAXttxtwXQc2BX3lc/H41KKWtK3dmCEZiBAkbls7vVPyznh+OOfKBzvz3b1nj93O3hhhYm8vx1qzlEc4GkEppq1e3dw+nvVYlm/1JXnsJl/IC7YmdXJ6ds/21vHVbPH8e87vLmv3+pf3f8x/X558/X75vv/+rv/+v/+7/+c1vPPmsPwr7/P6fVi6kSJW98VDAAAADfWTf3IDEOeHX/K4VjinPucp4yme4N4uIdsjJKd9r97+/9epZ7ju7TwxMRStetyKPIyFVFIlzezMRhzccfT8ZwrKjBM2Nl2qMRKWJFiEDuHcO4fjCAmWko2NJmzQ3ROSgieLi8qH40ZDHvphsiIg0IxF1s4uXfxRzZDa3XPz/HPy6Vi5p+FnMpj6Y6WsbcNntXfE9XcbWRtq//qebic9Nd9d7Ixv/U5BQnyelYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH9IjTAzmTct0RijA/b24erh9IDOqNw4JDaEGNvbiApPfv38nZAShdxmJGpCbUdHAWiqcW+dmJwOAZfHo2kyeoCETdX6bl27Wqy+zPS2pk8FlpsuwmsLbQmev06AElhb9R592WQ3DzMRYduVJAg7yYNjEqj0dHOIaSZoeIKeEAyGksOSGqgwOAIZEAbBAZeFzC0i5RDhPw/FY6XyKiAgqikPZESGBkcGw42SsUiKmZMFAlkhniPFyAQshCaPk6dMlJm70VIO8mU0zFRogqtkj6LJjuSZbzjEXIqTJE3QMTRBM0QRSRIEUjxLufLRNMfJykdSSPnXRTZJI1rRdBJmXs2mf++1VB6n1Orr7orZSroqdbOkylImyE0SwWXnX6xdfJfgBWYUzu/alE2jz0mrkddtGuXPG+CRQ2UAIllz0y7OY3lep6K1VqwHInaeOml03SSxk6+UdDGCKGXll8OTHLNZOmrF7bhDkmsrXlYURsfSaexXJ6XleOpnHGhr1FKY8WFX0fKZXH+i1pNIQJKR6mHqeVZtN8OejXBZE/Cvjdq1pNbWcX1WE40pa/pHv7eu8+Ln/Nvc+E2+iblat6iz53Wz2XMW2twcd/attZpatvutbbxbX+9/Ofv6ZZ/////n//f/petPjf///+v9f6/1m272rv7r7639SRWVKjlVSUXXqPIEebFTgQPTd6/zatAptZStsrTXvoE3BwUcYwlIwevWnakt95LsCYNanIYW27k1PV7NwLAtNZdYAUlnSlReW/H8cAQGTafmaKhibnSGDqJI1c+6hjhzgYALR0fIucBK0KFQbtFQFEI4X4ERY5hdMBxF8yKBkF1yLFZIzDPwMqIFnE6aJpLFzFVi4XhSQEow6iukaV0zRnvnlC5mqYvo1IIHSHlqXyIIzpk5iYlMiBdFgLx1SSnLzOmanSbGUFidBNigQw76JfMK1oqQMWugpyk6OpNB0Ce9/r/Zlbp/6jVkl1rQbRUgWUDiB200rXQvJze8U/zmx3/osOYNxQWge7nejDS2asVYyquYGcnHvMjeJyn5zs5cce1Vxk12hdCVzFyKQ1Ppbq+Yw4IKZwcAv04Np7YhLo6RB8rf6O2csOUNjOWBnTxyX4L9nZ2ZAgTBFGVDafAFkvHjuDknGVmO033RYTSLaQMjMLG4naNw9RX6rUrJm+66ibh5+fndFRLNnwN0z7XiWzaenkt4VbHVtVwZHH4rBvrz0iM6znf3LDxnHriku/7b9rf5+5aW/rr4vPn/43/9e2vr/7+bfWte3//x84/xv/NteBcTwzSK1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAABxGG0wM4i3DfUKoQY29uYOojSgxmjcLVLuiA/bG4pYCm8pZK2ECwZd2OD5bzWaBDWQynLKk9yHvuRlwCzYG60aJYRnPlqORXU7jS4QQ1Obp7kzTtknbLGGhiGiBJ25idppXNMzL+vfP1jEvVk8YLLhubmpNkVJsb58+UQx0cYs0niBHGEdhzCVRPMmTY9mouYnDUd5Oh+4Kk4Ow6aR8kabEmgYCuiIHEC+YGSKZqboGaRoUDUnzhMCUCQcvrTbcqOitROrSIYMwVHQTHGPJp3RTRa6ZDy4ZOTdZgbopVOous1mWcSvWxfRZGhTa6CNd//1/q/QS6qZ5l11mznLyi9GUO0HLdxDqLRcyphZylUEOG/WF3OtBL6v7LFbzBjY4M+VXShhm5javZy7L8qaZkrHYefylpsIZfZpbdV/GAOLDFeImNDlLcrMSSEg6zRyITeEsLc8Nxbl0uFdFYNVbx3Jxsgta7en4cbcjp6aTT08j+hrprJSJKPwujfEZukp7ahQ1aFwy6p62+6X1m+fXahh/bymdelbU367zS986rDOFyhwcb16b3qviT5i4/vN67zqto+c/dpa/4tmmL/7tTedWcP86///1X6/x9eutV///+f//rf1/iBFJ4+1T+xuu5rCx+jhu6o0T2IWCoyyVfrYJFEtcwvTDGI9jFGUkjIue6zq7lmp6zKsNPPahikZ4/Us/OKXZVTw9DzCTHFUJhu1ep7tpkIQU+VNYYvE6fHk4GAiWQIuZkPIsQgggONAXOMYOMLQBZo547hKAN6h8gs0dwn8dZIEDJ4lhCUgsnCHhjUEQsggl6ycKIrxASeFWDY4AaHAc+A+koApqChMG5gvxyR1DtJIiBFx0EaQIiRoQccwNaCjoh5AmNC+XFmS7oKOk0Zj4FwBa+MkSxEB/KpNlA6ShVMzdBNNMtkBJmo3HYfLhNOgyKZgkowQqcxPepJ7vUieRsUm1/1f/t/1Z1m62NmbXNX10QqzhJgqRabUga6nCusfhzdtueoIZunsMFB4AIxGB5XQWKW9M38KmNDbaXFZuU/IqKYhM7JX4MYHBonVau11KGVzVVhOMziW1tmi3Uwy9ThG+mN1FVjZWJ7xgvTi4o+PK7qQGC8uCU4OESAQywshfbZpaKi0G4QAYhfpHT5m96bu19CNPr3TPTSbfNevnLMm7j1Os39s+e27DU1n5fZlp8Sjxck+8XdYIjwlcn6On9Q7FTdh42AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACPOH0INZ43LAi4oQY09uI/W5PA1vbcL6ragBjWG4dYqDJMpY7L3iJAPgwqpUBH0jZqNKQmNQ/XpK2CqCh8MSuwuUKLuE2GekspnJ593qwj7fVJU3krrv5JobfxszUV+CwEZEgz4hWi8zvTcASuAGzhONFD8UoKF+bkNpTgkYl83WZzKJ+HZtoVqIuvpKlCSQAQWBU0jC5DpL4irYHdRlV9A7/JJ8sSdtklAACmNs6iWEXfyNPC/qhyB4IPB0Q7mBgAoCzVs9uJUNDMZx+1LaScbm0pK0yAMFQu/TT1FlzeHcO3Zl5KW+IREUHKWalkN103XZjU7U1nrcsac2WgkWpYydn879zLG13LHdZ98+c3jV/ef/+P//d83+tX+f//r/5/61//+v////5//+Osdf/67rX6/X6y/Xbt7663ZaLaoe2E3xqFW7Ux9R9rtm9n+Sj7vRuHHdQ+MCJMvBQBPawiesXdU89jztzOP0kXtUle3KnrkbYGtm1RNOcltZFEK2bXS7VWLWnrI7ZHiuJcywvCZ4bIjYKv6LRTMbJ4xHbdRD1e8c2SI+RzUk21pRhJCmWWNhfRIEjFBdo0nom5OZ37rVrbzvWcZpq7Kn4uvS1a0r5dW1r4VxaaxdfewrxYW7b+b3xmb7pCnWZKjCoUVZW3ewWPfu6OW/xckzktcQLzDRxQdmq1CWcGqjNGhAcNIrbhEh0AjFyWTc1cIQYOE4s8DIlgjCAM48YSMURceLN0lcCv5JnrWZFHksMth9/oZonXUFZbBYGDxgGJQc18kAwoXPd280x9YYGQM0UTZNao4hF4knrYkZnjQRA1mS0Evlz+JjwLLlzy9xTAAFeTsLRX6mTFZe3IGgLcRgWpbrLg4MhpzXSbEKgwlAocRYCwmsLNqS2ljDAmZD1HruIFBEErrZ35bq7SyjKWZWJ7BYEZHDIl1lEjsSulwxoad94foFh3ugmVzIoMCUNdp6mnrZ4mtBOuTWeFxnK1IYiUvlzwNTXhjzm69nuOW9ORvHXP/Hu947xy7/7/uOqC3k8RaA5vslsRVCPVdDTyqxXq7SvnBlSuShI04crY4qJ5ZZ3N9UTUsmYvFxgSHBDhpkr5VDsms1K0st/Q9t009FLE1nZa9Ui1132xGImgpu2dwpHEXelCyRYrJKsmkcxM1OzZVa/+GU9ytjTU09XsTsqnc68/CbmNW/Sczkk7K3hq2pS/ykHYq4cr7mPk868YJWDzx7CVfvLmsbW91a+GNqHIzhvmHamtc7+/ww/sYjPc+0GU3U7Xub1vv6wz/lbzFR6zPJdTLB2lj2/6q//+kBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjCYk6DeuNwvY3KAD9TbiJ1hzwM623DAi3nwM1luFurYHkwvaGFCbhh4kY+BGehBhYgcSAqxPKwpTKXUu5FFFFB4dZe+Gy0JgCgKphUAXzSboIjGHTeCSygiC13wX66kod5uUTYhHF6sJEI4tMxc4AMeyl1WLxNhz4wGFgRg1TX3fgmUQG6CyoJjZlECiwAgKee+GYzkEBB75fBMTg5Orc7DMiX1KKeiMFghVEwSGUSIDKgCEAFeq3QpILPL3oMjQAt5U1DWoaFTdFgwqAD34QEhePABM52ql2tena/aStuWROWL+Nkg4iA8CS+SymzO28Lcth1soYQlJX7AhCAsbs79ajpBkFPrnYxs6xj0DKRl0FT9pjTJlKbP444frL8LD/4AdzGMHrKveIge3uodZv9tnv+5OMjXIe3P28kIFGntfZGVDZ7/JljMZe2Ouq08KgiNaPJUvHdafSZTFSm7f7jWm5TZjtiFV4HtUSwKS5lmQGJQ87eElh60xsHJ8rPlEqFFReNQBJFssplA+kmLPMigRyJmOScJsi54cZdMymSxaIaSRsogg+DchBkhtDlkayJ5bnUSiQ4jgEHATYyJtysukmdovM1JrHJK5mgk6S3ZdlLNnqGeIR3nHRTWYpb2PKR0UnU+v7t7f61f0TFjF3///+qMqODJtosMsXFR0sDY1CkJ0vSuCG7NxszUxnelyn4ZeBI9yCY+L6B4SrhlklmYtg2KmZRYpaRUD/QHQKgbHAbiVKAyAVLUlBA8GUMFjLelDkYJyDgQySNIejXg4MKYYylx1gzICl41zxpmjvvoomkskww94m7UyfEN2nieRmM/OtyLwwUZITOnEpQJJ8iksibrEhYejZmAQkCXHTcS4Xm2JPYwwOMOJjGkUxWsMsAjBAwwIEVgaxMOBCJ+gkr/4e/jpu8SiZoBg4Mx9qktUlindBpr/pLmDBRjQwBhxuKE4WLobl0jlDupVr4il3CZqVJlWJ14JYOxeUMKjS1q1ivrDf6/XXcDBBt1VSnGG5/d1J///MwIYFrgktKp3m5e4WlrLHHmEAvpL2SxdYUEjw9ek+qu+FZ7+YVb9eT6j1HlapnbqU1yGbDZlGklQTAIkrAWctfh2CZ2QiINOX72E7yNOLSDQ7ZqPGmn7G2cblsGRmvLtTUE9f3OKzM/TvxDb0UlV/41Xh51C9TUYBm6tuxlWw6678Ae1FmFQVnN6+xXw12gr37tuTL0tZ6w5l+e89fzs/3OOQJY/8M5Jr8sK39yyz/mt3d1CeQrQLs/1ob3v/X1//QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAH/2JPg1rbcL6LefA/OG4flYk8DW9NwsAs6AGNZbh5mwAFA0BwQ5OVR76CBgOAwOoX488cadq5ukq0EOUsHN61oK0zX1UADtp0z0YjE3GpfpcU/WWa+s6/LQmcK8a5FYwLLiqAWENpDRHn4Dsv81ygLnGDOLWZbLJt6+tgdyGioQF+5HIH8nJ5cwYhtRgKGH/kaXzWIxalTjQ/AkQJguaAyGmFxhaEx12fK4nbhZRYIz0+RYl64ad74IfF0AqKGErh6TWYwEonll0I2cv3DsAWL9qHJDQOhNO2SABmQ22j/7jt/Usyp8oGhmkMOBjehlWmXSMoKre82YyGBGw1q0xasZULuOdpJWB8HqzbNj3uGt/zL6z94/9y+Y0f///U47BsuzBRnd3zmHAXM3Od722y+Bp2uxgELHHMEJuRZns57XbV2k59qUQqXchiasUklV+z4qgBbUMVUwWEfaw38Sd0BA5zVepOWMpfNiAN2M4zWc5VbHTyGOZZVdT9fOVXpdDMQoW73cqZyqe40OhljJIdYhGtT+PK8fZ+0YYAb2s1i0vw7j++87hnS/3r+P7PWPra1n/f3nfeF2rPs8eXmP1OyvPPmOv59+1qprd3VdpBLnKilPoyAcS9vv///XJJ0EzWJ04NKBAEWFmPUlRAbAiwyKuxI87OEx2JSNTpz3YWHDgE916Hip9nlnpM6DhNYi8Tac4D7tJib/v47TNisClLru+HIiHAMGTGpxlEKYZDsUktIwYIXXN1EKkGzbuPsvkAsWU0TWYlK5mNmyNt/OssdaBk7YRD2UWYG/sqnxYA0UzzkSE4uqUPGGQps9MoaQgUQDpbVcraMSJaC3KTQwv5q5VwGQHu6SJxUaRGondnbk19LDsxVxh7QqCE3bQozYszsVnpVdtN9k/hi0h0VKl0pZCUR94+0innm4YZZby7UWLTddFqenopIv9zmO+/z+ZPx1F39p20/Wi7WJVPxJYFyv9+7byoafDu96jtNx9mlp3N+L1VIv3lRWtZ9v7kNuIXMpZPz0/Ylt3SnUrRsADNiymMKnqleeelhU/jKccKlmrEGfS+V3cO81PWqLOHMnowu4bgSWS2rG8pbCKaMv5KrEmeChh+CEhqTWsM8aeWr0C4I+ErqKPBZy3f1j+X47+v+KcU/ze8+4bz1/NwWkBRYPVjzm98s73zH8f5+tZWFgYSgbX0/5EX6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB8diTwNb03DI64ngYzluI52HNg1rTcLhrKfBjGG4kOQWogr3TlQqYoUVgTMAiEIdUGj8og+D3SC9qX0s26EPssSlWmICoJAUUVsOy3CHYd46D/vGkzE4Lib/M7j7PGtp8xeQwEYiGl0gggByWEHMNN/gmnB76kgSCif31jct1PP7WlQQ9IicpkcqpqRo5lUjtPy0qLRa1lZlt1eFqIwEg/HBmsn3PIdAULtY50UFg48uo6spWqMGYeL0gG9ao5QDZhZRjZInMaAKC024dL2/Q1saurtNTCMOYclVsbnoxT160nqQJzEt+ek0vecjZNGyyoW3pZtue+5X8uVnHbypSOd16rEMcy5nrmN/veQ/7QFf9jj1r2LRb6X2E0e2K3LruH4SeZqW89/h1pdekQIQwK+nKym87DE5XjzLG1Ul9q1FKvIhAMGwRahu+pFikcLFAkmseeo6Bnz9N3RVvRu7hDfY3bi6GMisSjGmwiTQLNhu8Iwge9T7ze+pPbX9tiXwXTRV/JDFcpK6UZJQZLKm4QiN424KdIkrPkxmMeh6zrW8sMccdZ50tMuUIAkO72Gf4Y4a7jQtyRlnZl4pNlhzP45W3zv7/7Njc3e/HKl0CZomcMoII/izQehFxn/+//SiG1FgpjNC0VTQEm+RI2GpQAVGeU835IBlEWb6WRqYo9SxlaeZfIwQwzcM0ZU0YlUrKXaoG5wMzZxmfBAmU0y15bNsUrjJcFHJws8AgYXQEjkFSTFUQwQoGmnMKKQC5iqphTT2QBALi0bju1Az6Gh0MCrr8ht1XYXkZViqGNIeOPECUCy5T9CioIB6B6sCM6dUEmtwoBoqv8BOl0yBh8hkQQwRnNVTg1bRyQBFMfqtL4gxMsXgQbaIPEDnymRRx45/dJYlUuj+VLalSQpOxVbFoczmLkttx98XNnoaMglP0oUteIuYNaozZgtIWVtIYZ2xv8co+w5Zr1xJT9Z8HIeHdmx2nsfn3m3IW2QYNXzjRogHpSKHVSVv+7i6H7i1ihIAEcZyVNve5b5g+17HDPuPM5iw78Ag1IUyWBM5h51pvc12htZyLu6SjuS+ciL9z0EzS43+DiD1UCb1PLBU7Vv2Efo1P7qTUSp7NGqhGqmPa1jb9XsHRpbtFZxm6a9u3hCbzVcrEci9yvYoJHIMxgUuzZ3SzeNLUeARbF8KwQ9SVLGv7/43O/XvbfxgM5hvn7zw3/6oXYVqys1be+fj2nx7zuv/nebmUAI8XACEQn6fW9ulf///6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAh/Yk4DetNwpMpqAGH4XiRV0TYN623CsK3oAPzJuGTWxEDnhCsAXTCTQePDDEUwAXNQElSuijyknPvtF5BEadv31eYMAI1iqA47gmNRqD2dpuNYao7c0+hfN9Vb2mNq09az1DgV93YWsuozA0dIiUEG7GcIVNapU5YpLVVTOBVQSrKfvRemdCIDk1lsP7ciA4JdA3gxcVFT/EBQJPUc695lyDtyp+ShRFwNtDCvEQRopYpIcayjuhi00CwH+g0Smkyi/Sxh8V0hcgNjkhjEbDVphJI7lWvqzatXKKxKaaOEBAxJmCKKR7m61JN2JVC9v8VBh0kraS4qEB41rl1Iy+1t38bN/HeVCziJuxBj33ZVSLeyzys3vq6ww7L8DJNqA7KLOUCVyX5ejrp9NXqRZxX0AxyP4jL/xnMLbiZru/b30I8UuoQG8DuaKdUGWaDaD8vMRaQ4jhdwQ6r1OiGLKdEmaaprEZXE7/J5jtaYqz2coqXoilU9mVazfq4WaGgsW703yZzxaF23Zl8xGKfPCtOyufnaedtWaK2rTTYd3NOdKxOLaQQ1WX55f+WeGOP1/5x+qu9Z65n+OOsqkMtT5y3Y///dliDDTwrIBEcPa1RE0j9LiPqVBQ2HUNeEmyoZgUVHEgYDjaCMxIIaa6zsKvsWonTWZ6XMExW6KzDjVhYWn8hasaTxdFWLskbu5TE0BKJLirGQlz4UBPzjASXwO7iBylwWHKQizVtRpDlHuIER5e578St07cZfVdSixhgooW1muxDUYa2Z+IKwTbptbjD90VWWQyYQGyFwcAcXqpGKrg0DzxVAi6snhio3dHUSClkg1Dj8gMtHRYZu0c03z1mFiJRfK6MDjDAgEWQYadCGo1ZmsKacrXq0tQlmmgTQr1E67+1tRSQQND0RZiYKPGyg7QpMKhyQXbFh9oFbyBO/jz+3Hsc9xl4RbJ6qJUFa/nhYuXMq97Gk13+//9/+73+H/39f+e+a/Vz9a/u9X6F7/xRTP0Ij1bxERLzZUlO3S7mbb3f7hZ1D7O4BbuBDThTXs1t5qevvHX6nNX/7Oxiaei1nQe4sXaUKuwDLopJJfWx1bt17x0zMTrDpAp5NmZgcTRKQ5hokQItGZONM2FgNisZk4YDjNlEULp4srJ0mBtOUzxmFww8F5A6WSeDqEadMBVDTTUgmpGkkzskTpdRdIwsqtCkUiKhZg1WUW6alL3+mpSeo3JHFnT2ju+xttH/9YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIbGHOA3rTcMJrGeBjOW4jtcM2DetNwtut58GdRbiBdNnAgae4SRUcF0pzNxUEkBn4mMgYQSPYy+RP+88NOLTwRHnHigyaBwIxlld7wq4Yu4rlvRAUFMRY7CGsFgA2RIZarW1ZIajm0jTAChRutkEL0MmuqXscW2/U/BIQUeGCp2Xw5Gn2lrdDDokmHulb6x6y2ICJ4Bn517pS1yW3p+VCoJ/5hn5KAg0xsdgUOsjGj9znKNyGIJuG0LL2gMyEFpdNjEnCnTBKzJHkkTEkDZOVizzwU1Nap6tTK3LINg8UDgZ5Lae1BctimMhtSyDqPgiFm3FP3k0pT9beLGbzWpHlv//taH5E8LGpzs1KGvz27N2U2pzCvd7ShgOOUEH0++XcsUeu6rtW2h7NeYntygRyFx/nKpB+TMpf+r3MMb+pa9rqRryRIEfKcvHP0E12RfP1p+1HY7Hrt+aX0/EO0uaSTO5YZWQQMumWSS9LItEluUVWZtRHGrNPsBBnPszVqFSm0ozctSulyi167H8H6mqWIwTVg7LcqrRK/XzlCIm5HZ9CTAtjV6AIggRBe05PLkea3lq9rDl3dTtqknIOx7hrmeVv909S4youjY1SSbfe7z3rff/+cxv7PjAMMUDLxQAFzPdy9asO2o/5bT6rUx1ykMTAEI+5jRAFA0eDzMgEGCJs4QssQEaxKeHHNZU+j+Tqw8ai9Mqi/h90Bhxi9H/flhktd1YzIXdT5ZumGzFcrgrvWHSpfF0WXIcDTFws1Gn5p4wKQu/CGZonO5DxCDFuLpyuXyN3YHfRqzdzM7XHgtx37l7+svNAQaFg3KawUzrQDWuGAH3Y3JQEpbuBrIQdbsu0vBO4PRLHaEgLgA9UxV10ryZXYryN/Je5JzDMDAFqcB6NF3DbFO26l2nvV5bLZS1VGw0QF/JHSy+zDUWmLtns2yICEzgAHl6hgjFT1JqAZG0VzMud1ju7C7DoO89mMqhxolPju5Zy5jT4W4V3X91v973jz//v6/Xf/v7/WFoIKGR/qRue0/01JrwzkjrD67z0nLfdSpaUCc5ds528MJE/UvTsS0A0lmjlvtGpymnMc/gbVzlNEohSRuEU1aDVyPWu4CwCIJZg27cpYdkiOdJTy8oKMjI4aAfA0C+asV00g8JLMmcoqc6ZGs4dMCwLwxRPEmZG5F1lMhoywZZNzwhxogcUVjQMviyjKFriCnSQdOzpJKQPEegaIIJnVLSWqYiOgtbeQ48qxyYJ/0616lmLFh4OgikV1K/pi77///orVUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACP5lzYN703CvC3oAYxJuIjGTOA3nTcK1KCgBnOF4qwA2AkMD19414CEIAnUYWYGCEJnQ0zVhpihaED6Q+EfX85DtulYVNKgCEphGYjhKDrqUZghpUiY8oo/7Ymtv4XEL1TStz9ln0gFKgEFL0VeBnMEDIGOiGHDByA1sNiTpdyXIumfhbNlzQM3OnbMqmvZgRyHiNT0sHlsPTcPmfSJw2IarSJqFHJog8ZoxUNSJ4Sau0gw+AeJw+6wYRl89PUsRZO4JvF7Q5oIIkyavDcUoIdZGLRV0jEsMYk0d6ZFCL1N2/Z7yloWcoIgMH27s66j/Q9XhuBr+E/XQFGoDxioqklnhlKmASJ0IGwz5jnrkJk0nbvFaTCHGW3LFS1Wr4XdYXGOUtzPeG6+zpAswQRc+XUeyyyDGb03ir11spvUv9x5uYax7rN/GR571Az8VMLkxUy3GX2tNaFCmYafEWhU59q3nau4dgPHm6SUQW8shryh8Xxi4coSLYpbM7PVZU8Fql2blRNM0ICAtJmXTA8szJskmLpigmdZBMvi3pmpRHgwIG7GxSpF1BhUjoBxFo1C/JFziR0zJUV0ScXKLSPobxhTsyCbKpG5dL10VsaMmyDM5MhQj6C2ZV7oVfdlIK1HzDUpckeyKbbeU///brk0VTuGQEd6T0iYQhTNwSblQwBWCvRpEBoogKNy4RGUhYPe2CGGLEAJpDgbDbyhctBaC1Z6N/lpMPcOchtLueUi86kIyocpZTMnSVNghhILPNohExxWvvkr6kU+IjhiKSw78bqwA1SVQINmlYXUai4NNEmZABS2GYicujTjV7mMGi0GioFUQUQfUzdFVCBYSmfvN4p59FLoWaVxhGgSuSCm6GGoPrEAgiJP0IFZKSJi0pr0ti7hjKM7O60PJbgZE88Wjfvk7MsfqVNhlW42IQws7hVDCks9ztZYKQS6Hc/zyz5rGdiK2b9XOxIs5m/utvnO1eN/nby5jVeXCqCoeC0E2kSGAjJKcdu48wpKBjqGIcj8tLqEcz8XvsN1de/bxgGKazqW7FTKJtxa6KQmGY90MTlLS/SXb/MMoxco+X7MxKZZDF1TaXq3IWzdM8VPJ9y2Wvry/lrlWZwmhgkWiszQ4YXnrl+qXHspy3r2SZY51+yW9jlRXaal1HG8jJam9lFHvw7uznHUFKJusvezD8/y7rff5y9cs3v/LO1jZs1rOsGNq2Xe1vSsLn1OnBEAhAQDj6jzADNfVWzP//7/48AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAlZdM2DmtNwquu6EGMSbiShnTYN603KjCyoQP09uG1guNJBmGCSfABxhYSMcMGCgdEgOV5hoFTzqxKHgEra1jCW9ayuZTmC0JZipgGABxQaCixAtK0O4z9bF53luQCkwTB0yFgGexthrer/TtEAYxR8LEibOLMmBu2udqA8Fae5AXCHOHuJFF3wzUcZlNSHzoMXbhh+VB1lM9biHFB4NDrXoGe9oHYIh1hQkXrX6YwIl7gV8BQWNNOSui9MyrTwEQBeZio8foFuQ5br0MDNYU0ErDERERMSod6HIfoofqYRGpG4DrQbIIfEnD5SKVxGDK/HkfeLyzsBqyhlp7ogstC7DOlLzymUv9Sfax1nqXX7jYWL5V4q8tJjJYlG6bdPZqe2mNag1Y7jvusqmWucq95hz+f+tcw1+Xcd/e2QQKldtY5SCQDbRllUT29PqX2AY3n5u6/Ev12rDMOWamFSZj+cqUAHDs5VFJqXKxbr3cu47l+GGVy9TZ0XaFirC4VZlUWfWV6pNxx3qvNGKKklG4WzPlhM2JhTCtDY86lk0fMUzQdcwMS4omDVFS0DUuskQNEQmdAS4rIKkYUSABVRomghOVWXamktSVIzZFaDJM7pqrVLAaCaLWaOqgpSC7aupNq7rXNSCitB3Grc9l79Ptp/7Hsph5/5bDZghUfTsHiCCHEWKi+YKrjPhdCJGB/NoJUAUbgOKSpw1jI+uuOmjGiwcVBR8vcqkr1I8YCNKLvvS+C+28RFaDDyiqQxEcVlV24D4m9NCMcasAaLXIFa5pgy349lABSfbm4C7Jtw4wrNGlUjYykrF2xhss6/7gmXQL8jkqceMo3Rmk6zNKiM1m4mJFLINPaHjVlVVXmDRG+cR4XBYgCGzQogQrkmLMHTcOMQEZAhAwM+RlSg8E479a9AE9QRmKPFK3XdZHodA1nFmZluMSdp8ZrVWjeAQBzOBH5pmQp548uqAvnWdHv4/j2vTQqs3BodNN3p+Xy+1MzE5TX71TJt+3d8s/rDt7E1dYfQw3YGxC20pZgyzv/aO1F813f8gnJEf1aLrcr8HIKN5froMuefWOL8X617fMIW0Ra5GHc6blGdivNVf1vHlNr8J2fvRSf6yuUtCc5+Zyco56VTFZbu7mU+Mwd1C4feG33j6K91SV7p5S2KM1cP1nMbfo56iyXgEOuXnUdXav6v1aG0XWrw74ef/n+f13iLFW4098Yi+NmXfgnYZdtN+vn4/3/////K0woMFTBkXw7JG2fCBN90z/+p3bQPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJIG9OA5rTcLQr+gBjD24kecU4DmstwsquKAGMPbh75p6aEgAZh45nhiATBQwUFQIFTDAaBJGM9kcWAauX1WSWpAxN232VoZA3VStOgEmDnRlzK+EkRcxS8UCobKizT3ZG10vKkE9zVm4KCtaSHHATN1KzZEBAWDlZpFlC9CekTV4+TOEPDREmgVmjw/K6F+2uxgySt4UVGUSlJNdjJwYfdGXyt7Z1Mt0eWajWYpD8RBwFnornTAgV9lW07tuxGW4rOh4GkXkh0wIFAlKKG7fg5GoDI25I6CwoWCPBL5udwoH6h+jn4/blVOGCm3hqLUVduMPSh9s3+rSxsBmAeE+stV07WsEgK1nBXau94Y4WcrabVBWpcZZK/xoOSmSzHOfOcz7+eOe8cN81/avb/f3+HOauFhAdKC3RlVw44O71t5yasYcqR5DsEvv2f2h6hhZkdutJJJFJinmrzYFFRAIAMbBA8QiUt3M1cLmWUus3Le7+cy8NLefSSPmgY5MffaUSmfld117fJHnWGxteBGl56ztaumZhyv7vZtwomY2Pea7PZE5r54bdGYEk8hHnWOHwqN3za5AAGp5GY2m9fv5rSlN1iwaWi+P7PJc2mzZvDetTV97+frX//3n/wYec0z6+trRqvBxTmMY9YCMWVtcft3/oP2f1x6QSlJ0qgdCgyHQwchyEROkAjyWWEAeM4h8uMnM0F6Uwx4Q5UAtag9A0yAsEjzWVzDAmKp3oPmEDl241DQYDSeFQjK1fTymagY8XUuQmCggODDwBlBk0ZIaBys1IBFtrTYWkprtiZWysGoWbOS6bdlfsjZw6TgmyYqaBWRMRYgxFhZZhUVeNzdSUU0Ye93mDxufiJMnDx0eKCxZ9IEfrBhrsvC6znsAhdCpa5skoqaP1QQCBuoLQKVjUJsxnVJVhPbXZ2S06wkAqaSuD2zRiAonhHXajv3ZxVASri2k/1apjdVp8IrwTvC3+tZWZbpfT5bxpIrHp+v3VLWq/atwfvVn8+7xyzyx/eOH/n/Pxxy5njyzpBsLjVNeKrqXXUE1WCRuJ1Uv24vejQXs5mWsH9ESVqTeNuapHprU12tBDmMyAkW0nYYidF9NX5bxwpc5RUg6y3ODaKF6kLZG7F8F2P1A8otZXIw20/I/VrFWssoEzR8on7p/UkDNP4vX65o1KjGmtgopp7UdRYaWYpINC42sXdA2vulFEKXBlhNOf9YvjWr0pLc8IMS8O/1uaFrch8j8i6u738Zvi3z//jP1if61PUYEDTzrqKCFTdMcFHxit//vXz2IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACWB0TYN7y3KszCoQYxFuJc27Ng5rTcppqWiRHD14dWxQSpTF9TRno/cjBo6WBox8tcFqZgNQAjhHh9JCkgj0nMvRopdscDRARmOEZ4YeCQ1YRQe9Ki0RiYSjKyiwWwT8BQMOA6PKdLPUJYVFS+IkRSMYDTCSIhMGUAATJiteypW3dyAmNjAAYqQNee9ocPO6zDs+wk2I1hkIVxTD9suTlEhuSyVSCuoHEnVtM3U2fmhrpiN4H/A4KMN2s2H2d6MtzXA3Bc12eBotE60o3abkIQ3JZoQjMDX45Vy3QSCvfpJbE6d+YHcpR13pfKmXOXdc1T76v7WhcsYyCgo3LU72hWrsfQZx+MX7Pcct2LVWmizVspXFYIk0C1KWq/kTuZXZ5+bd2zjhnl27vl7n63r//8t7z/P94d3vm/roT+2YNdeu/z/7vdaelUEVtd3jKqElOlB36lNJSyrN8rdu7UkkxXl0BPEro4gVrk8E1ruUZz7ve7E1W7vWLzyDKm09TtrZJmTEGzcJs35Q0DGlvMdNUjBYzxDimUDYvOTYyVA0prTPrRJNnNS7IegZmRqXy+Yl8+gsWVPD+zuiyy+D+o0IcfbW+m6BopRoTZoxgySi+aJOigkZCNUJiW2epOv/0HZB1mxuimkmg2aHyIVQqb+qooyM7vZ/962D9dNTBOMLAQxiaDuotSUEYNFkW/tOSDAwSUxJG8DpPu4y/REJR7AoBWEwh4uYdpELEEBSgLR1AE11lhA0IGJyMDVKBRQjDBUgBAyi5fsEIwUnBAIYAtbEsoAfFxTSCBYk4j9OWxZ90pFsAMDIZS6DBK0VlD+u8ZGAiJDC+YKZiIgWIWBy1v3HeiA2cdl7lPCqzT5z6+3LM83VpqP2hesahcdg6jjvvujPQQ2W5eadqUb9S5fosMbEOkEJrmS+Mx3OktzMk1H5l+YrNOM+lZfjE36e5iE3GpHcicrlI0goptwXuqXL7sQu1L9Umssu59lVyC35q09mVYwfet2pXOyyzbpXe5K7NWrlWyw7vHPDVTGt3DfedwsQQhLABcALT7s0xSbHIS5P9i2tlira2DAAAAAQTUdlkPRBWHjilyijUlhrHLDKL75PUzwB7Gow1Ut0lefuW8/+7VktfliSU03Gr3IaiLLySv5NOfmRaF6zEg+2Pg4FZuG4NcS6t3Pneos+K1tut3LpzOWzDjvEBS32htcrmPnPgzF1Jd5GrGv/v/XpS/qcVcW8WkPOtVxhqVdMad6/k/2sUsCGgk8PIHPRb3rVL0//7f6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACR1wzYN603CmyzoQYw9uI+4LPA3vLcqQruiRh8m4RGpF4sMQSuiYEUmMfizCqEgZIaiXJXsYy8BgpirmtTZJA9dPoDEAgEm8YcGZaOYk8AkQGiF92loB01XSdUHKGasw2tVaJAMMiFTNQVQiS8WGgoiRCEoDhg0yQHwHUZKyR9Ex0yzGjVjOJTvxVZ/KYEdQKTS8bjvu8qCdMa6YEA/T7r+rTblUUBOKzh7noX67zlNOAr6LPuwFVrhqbJYyqJNEnUEll7UynOv2YDh2EDABeNKOhgcFilFjLrcozi9qcjL8RB6IcTNxuXX7dh6bLbvw1WBIvL2eKKvlH4Bc7d+svqxVlv4477Vu6kV1n852nryuvjK5dykkstmsc5bvtbuu4a1lruP85+vw1ze8965c2GXA6SNaXjBZD5sTp54CJW0VTIfyvbhx9ioOeztfPYoTXfv38KSgnO4zUBoITWdtF1Syvv7H555Z45fMw5Knqp68R+y0Z1C/ESkUFblmMq2warP2qVgQNwRS7SODezp58zbeR6dJeLPDcIcd7M8j2w+bXqogzNdqnM2Tv3ePfcYbJCFTGREXe/T5p7/5vDPCl42oNr4ltDpTJjR8ZjZ9YecZ////34WlAByBODQSYgNfTn4pLDrP//1yyz78rTC4iZuDClmFBVHwINFaXPBwgKDxmIC40NTTFGIqViAFSCXmlIhiLgYkBQ4AA9UVhmjbxxmzJ1itLSzYAlasEomW6BRIXOijfP8WYTkIgVLbraOvB8ndR1YER+ddOtJOR2n8a4zhuhlTacuUzznRiMuc/qAdQdh79oJ011KFRswdhwL0dYrCRUmYpaBrr1bahK4VefxTOvUZ5L3/feMPTbm5fL2tooz8Tt2953c7n3I2/DbRyV1aC/Ow5nNSiAqSOWOcTio+Va0srxh45HP01JXl+VPlYuRicbm78vfiMOxAlV137lcvjFJZzp79fudipzve597hhz9//913/3+H8yw5vPf7zw/8/3vv59z///8Leff/+4WH1zgHPCGAAAABrurUw+iRJUJKM7t+65bdz0pSsZ48e4cnInoCgXM7C4rTPV/m9YFKXdw4TCazfHy/OJscBAyaotT1Vd56jacYm12RpBllR5BNZoxbMDJBBAyIgZmic6bGxsiOllGpfLpNE+VkUUxyVzQrIIOgZEVB8EQL5QLSCvZdaRmg5frSTTTMVstF5mYVLN060Wtt312YzWus1QCgu9Tv9P0///ql1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAm6iU+DedNyqSvqNGHvbiQeJ0INZw3K2a9ogRw9uMca0EyhJExIlOkOSh/ddGVubU1Eg43CDG7vxIEt2cqKCSQ0K4YEHScFKBUd1ljCEJQmQObNODKkGgM+3zKYoCg3hR6EIyckhZ0FmBYVma1dMQa8KjgpZQKXW6BZsNGYE3Z9p+DXWaWMgTJj1Iwc15qizmFrWUddF+IedEZVCYAwZQs2YkYpc5hb4BKGHMHglZjuzjO1/wNAMDUMaVSbMrTJ4syqBFA2kOq9r/O8iPASwqpZFIK3dSvKtlT4Sr8aaVTsusv9U7Fp/GU26K/Mu5n2Zd6KOTMsteBkaAhVizbbrfcgF+5XLW1faROehIljPXBlD9ULfzU7KZTV+QWJzlmWzs3vHXe7pKXmtY4Yf3u9d+xfo+3tfrmH8/HPe+6/+65/5Vqm7+GHa09LLXf7uVU9PvLWNMGCoQAAABIbXO6pmTC+maXO1rEZvGa7s3tl2xCYcNrJmHGTCHWJrUnfWguGsWOiA90/tMZ9k4qBB2OkdxktIux/7P+sXeIFoASZ5WHBvRxQnUfWD5K9SqhOxbuKXixMJLe6atHo/7bY3tYbo7yW1snYP10/26//+c/F6b/krq/xTWPb7/Suse+beFeAxx5/r5xrXvnUV/eSF64m0OHE009bN+hrtv/bofUSdRPcqWc9iggKsTth16kxqLR2IImjMSm8/EpbGCEpjxIMknQpHHYC6w8Q6SSJeiSOFEV3Rh3EeRY6SOg1Ve0JZPAEBukX0Hg1gWoMgZyzulFkEOyvGmVHRUHd9MG+/eoLqUqnkb2Fp51mjs2gCHrkDsYX4DVsjA+CiYKvIEJ6Y6ZjMXQrv9DFDDcqeZ2KR7nnpZFH4s4cckD4sBa001pCyVyTjGXRnaWpnnWrW8rPZnL8ZfO1qlSSymUUkrysWb9Z5dZ426KBXdZA/vZyNuG8kBRahl83L3em24W4DclfrVm2cO47c3a3OWLcsmohenseWsOZfzm/7bz/m///5rf5b5axw/mta7v/x/Lf/j3nKTWstazr/b/mOHc+Z3OcqY46u9UTfQTFPAWwOhJGpqUCAj8qi1flXdLak0Tb+DVIA40Ii0/JYxldzjOXZqdr51Ksvr2aay6aScFL9T1geMOgxOG6e3YbFQQZNQIEX6bQgLY4MEmUowsT3x7qRfK8+kIspGRVySyIu2IjXEa1PqTVUTNJjcJirGfmcXvMsebGf85pr2t8eb53XGKw8U+dSKv+9fazHJ7eBeusaxSLq+qPozuK83AwGwOCYnNP/7rLoG9vP9GUAh8DllAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI44hRA1jDcr8L6iRjD24jviVCDWcNwqEu6ME3vbikwuVZTKS84O1AsEgJWhy3GQIMK2gs0N7gyQtIKBv4Y2N4kmBjw8u9EVmKLraQqIOPOYsTTJU5b9lbWl2wy7jtOOvovwDhWWJO7RrwLKL+f2BYEd5PRCQneirGYpdd9oiGzEYYkUji8mfyfT2SKg9HYxOG8GcpLhNhTJWNubSHsnnViuMqfh5YadyUSeC3Eq0zg0leuwd73bdxiUpUtfVssNy+PyHG3lzv2NTc92cpKuUxXm7tPq/ellnk1T53Zuempt0WqRtlbK/hETk0Zu7rduu65UhcplUNX4aceBJp/pTS5V+T0DT+/39PN1bPN779nv/3D//H9b7vL8dY9z/8v/X46ud/+a7rfPwwzq0vN0/46tU3af7/LNKo3IiAAAAHvz3T66sgBJIkxqL56tJptBX5Uu4S50kuHzaxJl4DAqSHo1PTP5XeW+4RK9Yhjj/TcvpZQ/KaDdXFlbQ3yd2njXMofXjHX3mkKtmrVoJZGtHibvpteqXLaX8vRcCNrUF5I3zzMzhXUN88w36puRdPoedMk0COwswiTZM3xJN51nevH1uJJ97vBiY8DF73t5UtbNb1pIv0YGDx6T/G9fEauILDB9Yl8xZDzDBBRQRd/V8Z6+rLESlQkOHS0J5WmqskJgI+0N0aVGTGLFR/wCJQgCyav3/h6aUAQ2iz/hICAwRjMHBzS3W3YWTINCf6K0MGR+WLMLrqUoHNnUGh1p8JVKNIsnXBBktp2JiMdRKG6kqdRh0OpYLGocoi9b9JuxV7q1SOKassTlei3Hp83iDhGiwUSNNamwERJQtUwXXQU9Scxj/wDQWLEbxkLZ5M6dhubZ2ms2bWHlm14ae+Xx3WOEov3u5czvWbstrTWVe/lS5W78/P7ygat8lj89TM2b1y42w9toHdV3p69ORSJR9xHXeBhKnbOq7at8/ENUGVHOzFfV+3dm8O3tY/zu7tnHDf/3/3+X8/uquNqznzPL7/P/n9vY/vmtXdf+//ti3fyvc/HLDDL8P+oo/opMPQPsBIZVSyMD0ELduqQmcuzycwmRLAsYZqtcNrZPBj6zqDGREJDUayxmR+URd0s4n4l3Z/wHsXcx1YXUJ7um9RSZzVY4M7ld4/tnSGvS3pJVTNSKdsbzq7O/WEzVruvjuO2zUCaeaMymJM8b6W/+cfHzmu7Xzn6zr1+aaxLErjGPWLamHkWkbWsb3nEfUskKvjRbhMkPYYFCT+nq9A5H9bOadUTpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACQeI0INZy3ChK8owYetuI9YpQg1jLcrfryhBh724pebm7VIShASvMbDQCMDdZ2YILahB0BjW70zjMkZlfxyGxWFLI0CWJg4CLQ5L0ES5aGs+MeZTkyYGgJepRRtORpbcYCZ6AQYdWq+8kgFgA4Ay+ENPpVTr5SYCEIGd2HpTHXWXczm47c9EkemiSpv1NGzqYiCcOlNBYRAiSKES5VckxrOX+hNutk6TWqsxK92o6+SmD/xSPzU+zxZcudtpD7zsMxZ5pJQ8v1Mecx5hbyppFav3KlDljVrdvd+vOdwx98H0h5632cF/WQqfeeGYr2tWbu8blPvDlRrSfzmNAgCGY1LpuXX6XK7LcJR2jxuaz/7/fxs56/9b/9f/8xzr5Wt5f/cdf+u441sv/LuGNz97vZbr1sfx5rV3DHfMKfNLF2P1r+wCZBITJ+is3+LGLCbJiUq2q4rFlgJOrksxKeAxYs8jxbUtSLBSTjZ2wNz2QRI8qpBwjnITF3uA/Hgun7OWHzr3UA80zjnLIuYmxIKhMAOQQgia4nEdJFxJqUZlO1M2XIM4+GsVQZpDzRBElsxxN/b+5bwyWxV8815bHMPVlBrnKGS131oKNY/aRV13nmhIwwULo7uv7lNOv/9TdTUol9zC7K3QIAZyyhjnzK04ojD0EiooUIXdAyp6l2vIO81mPBwQPspe8KyyoN15PARbZtZ6BITchtf7gBhWdK2TU9IZY19JhbQkCNymAHjBNB0C9H1cpRZjMjV4gZDsKuw076eC9W5tPlsqZS+rztJU5ZeMDAimmNx0xgEDVUkQ0BTUE5lX0UPzdNGYYf6kp6SdhmU2GKPxDVK7b8x1pC8JhakTmoKlsokNJu/3LHfML/d6q3Kfdy3SbpqfLlb53mVinyZ9KEyKF7KG7EXVrtWlmfZVCJ5nUExN/5e3Sq6cRh6xTy2W1cZVOXrv0f28OZ/hvv/vut87v+Z95vWeMzj/c8+67/57z7l/77nnrHn9zr6s5fhvfddq1O7t95lleRXv1hqbUSNjRk7+SO1RUwwEv6vBEX24JwBpPtqE5KB/BMov0WsjXq0Kb7iKdCmhPq9x8JGAvDPYUqnEYeaJUc2WESdqXC7R7ukmHhjvnizAhuTdNVweKcPpdj6Lmol2vLmOpWjakkza+viDFjeZbveryNiGpzeFriXTrle2c6+t5xLekDW/T1xn5p8Vkc//rTXOp6R8SWjefevmfT3FImm/cC0UcDTA2ORufVSzS5SvmPxQtlyRFzqQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAkSgtADWctyrWuqJGXvbiOeIUAM6y3Krq7okYe9uI1nyrEbgjAnuJBdgDn7TqW9FAaJLPw2YiqLMRjaHABJLzY5EzLmMghEEoeTiZvBsXjpNY12VUEqr31MG/UXaTUfqCF9hcQaEDkU4VCHVmVhDBHZ7JJJTxVhI8UziCI1Hn3fhhjHmLtOkUWcVeUmr0rYX5TmMZ04SDRZAkK5i6zKxogeLa6pjHXRuQy2K1Oxn6kIlrzMqlzrU0GsKYKqpDj6aVzAEjkfLlTDC3vmFy7hPR2kkN+mjk1e1V/OlpqLWs9aksASxrb0TzWmRtIp0t27w9FKaU08AOw8respZeoAwSAaGZhmBbdenzr1bsYtdsYXuWda7vtXLWetfvv83vvMsc872Hcu9z1rXdczu75/55YXsMav83d/G5bRYpAoEF/+jQAAABf1ln38Cc5ZLHMNbm0qGDjjhSLyKFhQ6Uv5kEnwVp++BuPdz3esmD/Vh+OBnwZVw0AO8qvPZUJ6jYtRYMRIdKQ77z7x0ZFmge0HwLvtwTCISXAomthmS6xGbpJ58Q/bdNXxFb5nGDSDGb5/oUcOWLPm+86181t8W8fFL1/t/ut/8X3TfiQ6wWCH2yld1t7y2jQoj+PJiQOgA4WEddeQ/fTJO6um9TLrB7iz8WeTcVbuSiAHmYF73ctXIsXdX+y4kSMRvwyVQiZ7H5e8gimmSCvaBlEOteZPBsAFv1Ynqh9v32pWzqrjzZQ9+m8fZhqjpadlLmtLcSw5YEDIjxapKniZRMESheMr5ZlzyPPEGpL/mIOQtUWbZgruyVTARVBZk8FBEwkbLG9YkNHoBW52noqbkLxT1rLDbSKJULgz8amGxU6N+DQZxiNZkTRaWRUlzOrXscr6z/CpDdBUj3aPV2QflUrW+0mtZyrNNCdXBIInQJfJ+ucwyvhm0eUNPbk8kCzjdn3LAHWL0cxnHpLlS187E1Px2they7vff/nLn/v/5rmtd/Hd6P8ot71W1e3/93yx/613f8/+c12T581v/sfnv+W8U1myQAAABR93rdxnpoM6CiEhs9pVjLEUMUvHgRh4Zb4g8xSnppqbWtTMLLeNrNIq4K1iUK3BfGUSo+XRzKVyT5mu4fmNFvjOTVTd/HY9Vi1s5SxY2PHKs9A0y7sW9xUoronXN7bi7mpfUe7M+p6y9SYfKdRVesTlrP/x943ilMtVc/P8l/4d8fXznUR/t3vGXsk0P58l4kG9ty0XPiaJCyhRYQ/9dNll+v+7GEKEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJEYlQA1jLcrrsChRh724jvhlADWctyqIu6IGcPbiBcK+q8pAoU75gu2Ti1Ww5jIhCMLPy4kwXQf2UEACb0evwwDOs/eBfYgBJJBVgMkKA5x9yolROywkkCmGDrrBwBArd0d3nAKZbRvy+7rAGSJ8rguq2Fp1RBCup041HKWQK8qP+0qnjaLT1sWaezJnoqSLdF7TwbKCy4ZVEL+PKTDFtpLOthgS657jS+Z5NWnvl7YXaguNyhnjSttTeVnaXdZrrXaCWSm5rlrP6u97+hi0iiFWxS8pbcx+dvlTf59uO1B7dlqrXvTKtq5YWu+JzGEMyCAmlsseOWM8UGZm3FxnVkWqWI8tXZHjap41v5f/e97nnz97/W//LmGGe+fds1MdV/z1j/d/v7eff7+d2k5nn9vdadyw7n3tS3hvXe50qyxAAAAAl2f4/1LQ3LTIIgSO/qUjATkZEmIi+hn8E66y7GiXVHl6U8KDCjqdGb+fCXB7IYZBgQ3PL4GgXFwFdUc5dGFCpIDcY0CRSK36rh8hkkVtpAVEBx02yLg4YwapAqBJq98mkNgWbI+ojjAtFu8idSVkbbt8Hup20hkzExR72/+sb+//IqaTyXxveP8VzS//1BewYThvEJ9NA1f23LAjwNtbLAbosanxCwMcMOo/bd3pV/qfQt+JzK4yN6/KpCl0niEAwEbEAozAthnIhIo+tqwIpQiF8cIURajJGPLxO1JYUSmglvbbyNjZyADpRGLzQ4NYxAocE4o8HCIeT/QRwCqNt093ch9OgDMtQcq1NrqEQ4NLYpEHWpaB/lcF5ViuBBcYemGmWSBQXscbGaw4jzAtgOXHi4q4Q6YiemNL5DKL8bo5DDV2vdgt9JLSOFHbNC8SuG6LuhTotCgB7YdlNq996nu4czv4WK+dierdpJNMbwqzW8Ku8tbmX3utjVNM3my0zHGFwLErOMYuzjgsRaVAzVS8cyu1rrpRqVXqs3O4S7PPlyz2mysY//Pxz7V3vn/nr9Z5dz5nTdpecz/u///3h3/1hzHXf/PPHHuOF7u96xvVz3MP7Y/8c8IsUjP2iTy188mg42o+uu3yaeSxKXfYiULkLma3h3DdPevfvCJ1nFo38t40zgPq8c6yB95TCIf7jhJHIhqSU0ObePHS0KF89xumMe8hlDsHacCxu6RVjDrd90m3q9rYvIxwbYtV+1vZj8KWCzN1tb+/j5xr51RV/Wd7rvedfNqb/kraAy6xJqNJiLj3+4T6DqArMPo0GobKPGaE+zv9jfb+l2sYxIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACRaG0AM6y3Kyq+oQYe9uJGIZQA1nLcr7r2gBl724kX2dxJwBhI2rQJEdBDntDmIAMAooHJ8TZlwM1URcV6weJRpRQz0UwYlBMnK1qWX6aXDoJZr2SJ84EUUFBlO6AQbddv3XCg8iMAUS16UvZG1JApWyzlSRpqM4R4SaZJDeNJbjKWLQ4m/cYkiOLBYouR/Y20oZyAuxiFiU4QekYWgCxiEpk7gR+SRuVuS4srxnrmnedZlrXnUZ3DcErldZqzT+uZHpFejEQxy7NX+ZfUx3TUkhysUd2lt632zZpe1955ahmMtaZczRncrWiji5DjtcrblThVG8dpvWdwLCVdKn067kQ47UmlW6krqzNLPTHMP/Dmv1/McNfz9frXMud5jZtY37GtZXPw/eeFa9/91vmXP/vbe7fOX+YcsbuUnKXEQWd53W+qzhQyqbA5yc3K2PGIq3EKaLGT6sYm1DToeRiW2rGzfSoiZ1Nc7z3ZHpNJnjiEuNRMwTzV8MnYhFZ9YO1vKHMfXl7E0PNQdbWoyjgwtyjRDvN4rDgU7GXdhiZtn0s5Y73WLxUhFjvIUjFFc3BFB1301Xvv/NP/nfpVgzmlsU/3a1vub6xaNLFneYYmaHEj/1g5ngxnlp3rzxH93u2lFGm68f+TQwHTvKv0ZBj3IQTTLLGsZO6BdsNtAJGZpGySGbsFixYgRTBhAQSllEW6KAxuWrZaSYo4e+TOp1S6EvzbgNmARXA89bibrpkNq4aXKk4LeNGgIxZqmyv14GTqdByBd5qeTX1M13JaKrl/ZBG5p6HcRdYLDT3wFKGnvtHFTLvasCgQTak0ZxQt0FQCoG84WIXo6SmtHH4nOQ7chNm3OR93HgZA06RtwsQ3J4cTlfmmTUsVoYlMPUN6xhe73HeX2d17cFUGFWkpcp6Q2dZbwwlMTrx2KryY80yJv+/6k2VNefafo5uB41E2UsGbvNvHpxHaa3jKaSamNx2lsa3STl+j7+He77/LGO+8/72+cwzx5+FjXcf/Dv/zuWsO/rHHnLHdcytXKlXK3es73ztkN5wrvv9wm1KAGazQMCn7X1C9oymZ8D7Vq6O8nBWtpKFMpS3F7L7B3V8ulKfTv2iK0u9EY7WaMIswEMha7NNhWSEEbWPqIOpxXUJDpaUvHDVUvFrXVS2+BtXDkMlHkNOU9G8u7mwxqNUl3+p6eklpTTZaVvSadPXXgeTnm+K23nO9a9sas1KGkufit80396hfXp9ztqpdwIEBUQa1prESLRuZWrEDceK88IHWiKl4amHzemm1JI90XFpvFwspIuBSDqwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhWhlCDOMtyvevaBGMPbiGKDUKNYw3S7q+oEYe9uLutZXYkSlmw0wE7xnlotUxgDogP7MkFm2gF92m2Jc5quESwrIHVhE9zsqoGep4LjdmpKFU094dvJfEy56OBQAOq5jfND1p+BkaoYvLnZkiHpcNKGhgavOOlBCFMAwxcik+rG9Tht5aiCAoCOBLAm0ClXhp4Bewsg0eBJVGMKlJIqWrjauNLd5o8po6ODGQVFVZDDVZ+Y5InSxpsOZ2/x1/OV91c+3MLOP0lrHnb+WP5VsIZsr9dGURK4+7rLsZNHcq8N5QW4UKnZDBjAHvUGm6L4/E7dNveFm9Z/H8ML2+f/N57x7v//8sPx13WtT2P5Yc7jz//9Zf//+WW//vcu42P1f/LmH/RnMGn7KAAAAFbeeGrLCgP+HiZu6ardJQN3n8VDXPgpTubm71lsT4pWMelXe93MPBD2WVXr4QRDVG+rQKsGyoW+1uVrCNrB0OrupeXpp+I83TKjq16tY2YmoMHJ4LkmEf3YRzh6C5IU80mI5O4DTBXdc3aLW1TLx6nI1F6Cu7orb2GkpdPd1/x9/Xx/7LX1fdv/jETX1P/CgbV0KeDmBFU73GaU8kGaNGlY4itpbMChUUmy03xRGjkwla/mcr58ljHMJggAAACL9yypYm1w5g9N41AFf8/XaUITCrIhIyGEtlKHFcb635lkSPpkCstzoxU7YnHoT8KBx587DusRRHg6LJKQJLkrh8ky0JhMirKLFb4R8slUhdlFxK/vbNZ9FkqoQLYgvjww67FM3N9HhZkIzCOp7zD65pZFE3UUWYNpunppU6UPyOnwm8pW3R3Ls5OUjWnvTrtTObzuk7UGz2rGfK2fMf3yxly9+dSO4doscMKX//euZRKTrQa/Ga8NLSXs8qu5Fh8R1Dy6IrKKkEp0t0Vnafdn84lZppZhzkpqW7f713//n73+t7/9d/Wef/lWzqUn/vHmH9/Xcdc5+st8z5+8e7w5r6bmBCyw+0iQAAAAMN/z5hhZtJBJEOTWPiJfdmh3XIemoqU05QF2W0fILk4kbO8zOijtb0pmFtPLZeJ4pgudR6AiiwnmVSxc4gaCogWbx+6Ha8Yc7rHYjuW40DbZEa38DMjaepgCSTtt2NJKpT0siM1zWJA1iDZvzafVWWIoIr6YJxlYZNfePn7+f66z9fONWn+fvW76/zqKxxI1IKlZXJkm/t4LPGvuyib1w4YpSDsF2lhIz68lxqz6nt1vtv3tOwAmUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIyIdQA1nLcq1rahRnD24jQh0+DWNNyq6vaFGMPbitj2xPvqSEDqlVJmhPRp+38hoGl0N3dfMhCEg66XrR4Zib/MCAShV0Dml/SiUz1BE3Rh8miht+L7plrJKzmHZ9ekEiJYDKK3X497hKVjUKatiJR+mL6jwSpmXSOs+zxqVpK2Ynhebi4zJF7PXCnFpCt0PdNoMOOcyKoqkBib6j7axTkxfhDv2M7MpgJyJIxLu4ag1djhsVf3JsrYIu5EIvV+dq2tb33L8M/s63QRzCtas67Vv52cNXZbLmGUkovyxrzWUx2TL+ga3MxiSv2/UDyiRLuTAgR0ngysxqQVpyxjy3LMKXPnauWGtY7xv4Z//efzfcu4d/Gn3e1vWO8Mv/8LmOH95n+Hcda33PeruFer+u5X8Luj5tDwQAAAB38O8tQSPgQlLm/Y3QqaVMrMFs2tQ2rFlLNRYvVHnIlPP/GYlWT28u50jX41KrdBP1GZiy4i36s9E4rzvnLPzm3OjTkey41XDx/G1H0xQYyzfWLFKI0HUyx9qY71w2Ocdn3qNAzjdpWfMHGLQGOA7tKexkxLx94/+v/9Yz/r++f/v4treJsfFX8HddxYyscZov98UixL6es4Onyo98Blqm/+nm+T/rYzcxUJ1n2Vs8FSJtWC0jCTWmxWZixjCyN0FWoWU7o4EKFz0DwwOjJDojN2XEyPHk09aw1EcBTMYdlrpVA0CLRxn5QyHRhS224S7Cb3BBD9ucpzdauuQRZZ/jWtRhoqUqwFh2H5oH5YgkvAMQjF22YoAYeKYY2UGx4rFX0fRjpQSU/DcBV+XnGu3LGrkfQaYBCJa/sseqKFABmkIssUjLkOXF6mH40lLb1rC9cwl8nk+8LkUt1LmeP5a5LMP5VZU1BobvyXN4ke0KGeQZT8oHXZY9TpSSnsJzjoZsUOQmU232l0Vs0O90FeHru88uY7/vO8/mWX//54a1znJ6IU2HP/D73P/7mref/3PGvv+d7y7nnzWt9zzyyy7YBgnyMYAAAAefH8NUKshCWqX2ytfiq92bt6Otcxj1Tt+H2tMHWwnhy9jq3WfXCL4UGU1JbtLMx6D6y5yYzxOu+Vm86iw1nX2Xcrv1FM1/w1L2vLuNdeUmd7scY5CRLCWtDhvkrAwrZt976X1eyZb77g5lul537Uj429fP/+/r/fziXH/vT5+9a+L496Nt3CJjEFSKOXP+dT5rnV2BMwc7xqCZCkWO//xravdjuz6CyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgYAAACM6HUANZy3K3i9oAZw9uI2ofPgznLcqgLmhQ/D24r95apYaeEJsF6QIuYdGdwYDk40c8danLqS1QxbEkok0nhDyiVUO9dmNwVEpTBbQZYPBMVgaEOIIRYJfxTKHl00IWaBxBealcV5ptKkmjS6p38iDRkTy9itOVWPU6tqVLG5Zais9KFmuE6jOnHgNeA2OcAYABQ2Q4v6tIQnqYSa1Iq+32f23ZpJ2paXG7jx4UNyHmUsHeSHL9yRunchy3WvYZUmsu/+eOWFa9STdP2l3dsU1XmWWf0tBE5HBM4y6NvkqNpSXsfdGmoYhJn+ep0qOWstUrZO27lPtSwVLNav356Zo79WtZqZ4Y8/m9Z5Y/j/f3rfd8r7vauZduZ9y5z//DWssv1zvdfzef542s8vvdx1lrOtiDDYA/XO8yxesPSbYdHlus5KmC5tzcYVhmGeLXwrRV/AwiqyhNi53OxWfrKrfkvz7AMrdFg802lu0p/HzYPNtapUzXy7TwGxGAHR7TGcWYi73lnddLQz7dOGIZNBaifPV1CekgV87jRJeDG8nnzWZ+wfF6q5UR54G102fP+//nX+Mb9d7vamN4tnWNa8//pmBPBo7WHqHUffEPcWDBrZmUjqJFg+W6zALGBVZnjWelj2rUZ1t98sLOka1Enz/69mDRBEYkLNTROXA20mf4O9YZA0LgAKC+SAJW1I7AqdhwBIIRvmfgKpGbl9ON2x2XHGXI2CwlBKaFrhf6KkjidKYCpXSdaaApJeZLLLUGMFEgC2KSMF0kvsPKX8EgrkDXZXUU0UCrtmqTcSNSY7KwIgCjogzdmRdBENCmnmpqbjzEJFL98ybhDy5WacgKldtiSwr0u7Eb7rP7Dbi0uWO7k5njzX8v4YWc9XXcr75U7U5378W3SVI2yF6HVciNuexxsaFNSCMJTA9ZgUPULatzVw05Olcz9T2DuS6bh2zjqYit2W5dq3e/zXNZy/eW96//3j3LnKuEuu4/Uw/HX8/mWvxy/PXcstZ4fjjvOkqVv/mFf7OV7GMjE7BAAAAEX+nkD7AHlykWos9Qqqf+erXNPE+Fu5NRuB1sSG9j3lu69uL7dlG4Dd+3a1uHad4RZbxQp/a9dzm52dYVV7O2161A/9m8tl8Zg1Z1aoY99ZG+Qo50NvM1rbAzRqqf1jzYt83u1M/g3kivoULcNh+H2////9fON5t/i+Mf/Px80/1SFeNHpM50Wvn4pqDXEaBHiq6Do6DoiesKHvu/ol0f/l17nqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACPmKzyN5y3Kta+oEYw9uI3IjPAznTcrmxCfRjDW4IAAAAH8zw5iFwAFk6CwjTW4wFH30Jjew7z/SUAnTojZZrFIfcxQMFEtRM4d/IZopDGXwYc8IidHl5VBrdkU5O9jZWcjAMOgmvFmTFIvNTQIVIhmh3ojHF7EJBxjpn0V6VW8SoO1t8ItLY5DCulLHXpI9eUEFkjmYRooJPD8CGCsENqBt9bnt5PXR5390kQR5Ze6+t1KcKAsse+Q27UML6TrfvLPnNy3ufPy3Wscr7yzp5ZSfjj3Kn1eqY4QU1prj87q7dExBVL23keNS7HGvv/G6WtEwqAmSXHe+el9hhTpzlbHfzUOz+djv1b2+/393ta5j+WP81jzWV2xhU7vK3Y/H//dSxhz/rW8LH/9zPuH85NT39/+Yxmxz+/+V/ARSAAAAPw1v84wP5kJKKYz1NqP0tLjmry4tKK6sS6AFfJtP33Ov9Sbq4wZep60dhictzE0+3BgSCRWS+4EXiMCQqxvKsvR4WCXvXOKLxK66reO4M6Q+fDcBM1XfWsE9OB4sacK6k+sU/boDhrPsf16W1MonrJA//xv/4/1fes/OL7xv/OPnX+YMPetYhGkyPNf4vSlLfCdblBNqm22BvBZz79P8viQ/37n2prdqfoius8q8eKiZieQCBhSsNqPYmYlaa7E6eHQQjbC1KYEPTEwquLR8ULYdFIThNShaM8QJlAa+kxpaDSWPzTUY4qiv4GBgcRR5PBhHILjZOQqOWyy+0BsLDxpuns0luXKGlooOhG3agicEIFrDpwa/aGRfEENzjCGMqMw7MIKNFROitJDs/2kjEuq0u8I+sKt+P3qeFR9dpEPlseepfszSt5J7mHN1prfN5Xbk1XwpuV8pi3Ztasayvck31+6epIGWxKSxdu7WQwo0OUyyzdpUZWLQbSTzkNgcMeLQ7EKmV+mcaQWMrnZbDMh5nvnO8/D8d/v9/r9ZXtWNZTUSlN/P9/TWb///2r9jf5f/2Nd1+ONjXf7z9fqxr8t0nDN9KAAAAFHzWP1W5HE8uYfCaPmJAKUTHOp92HSY9d7Py4ipGCJUvrc+bmYYxfTlml9nGOMWuyqEqOJ0sYjLL5RKo0j/Vyx6yuUNFnFOmyi8BIIO5iTUhiBezBJiRMAegEekWGRqPcyJpfcpIKTPsk6k0x3IoJIIpD2FoZKWdPIF9vWvVtdNk1VpO1dF1L2RMSSc6pAwOBc2V3H41OOiZnSYJykZrss1d17pP7/q//1oq6Sr/RZ/3/df9fz4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAj7h08DeNNyo7A6FGHtbqQyJzgNZ03Cg0LoEYe1uLuWNukiwoGBpCswcPkfoNwg0FFzrO9ajQrCHkWVquI7kPswJvtOOyq0sp5qQxpIOsQVSIh2AFK0+GLy9hsZUSV8ZdzsWYovp+W4iOCdigVND8RZiLJEjRGnlktnUwGGsBdmWxxx1g1YHGkNuvTCgg4Zs1QcyR8FCYPROJQBmUrSVixmcj0fW1ZhyNY7oVtOtP3JbJZhORf7yw6/tDBjIWLRuml17e4pr+91hjncl1fd11J3ViZw1E8e5U1fUtb+neJiVl9UlV8PO9SmzToa46uH4xmUzqULAbd5dsVkKjs/R1aWd+CK97LLK5Mye3rv8uVdZ8y/dT//fNRvmsq1Naufzn4d/9473ztjWO8PzpM8uY5UEM0dXe9ZU/M73shCiAAAAArZ/ruCs4aKXpO0uHcWyyvfzV2OdVTw6neLO4n9E3bcKptdqc32WBLLFI1kSyCKA81MlTdRzGcFX2aULceazZTpJJk4Stk1omBuxRRsdBsBfhNhzIF0ngrBkbF5y6onrN73Jq6KSkyTNDZJKdJx5SK+v9Ou9Tpakan5+qpZdc4RCTQMTRFGlqSykZXMnc51PX+pv1fr/V+v////rOOw2mhzqfWdAvscwGiRt2AJpEhSVxooOmrliWOAVZeAd83LY008RlHMwKhmsq6kUynYApB4rAqCjcD+xNlYO0gWBHodklALZmawz5LVZqx32bkFkU5LsOSudZcO5Nned27WVIMDqd9GYTDYPX2UFXlYfTyOAjDrznrC0zB0E7pQYnODHihT6UHKWJlz4RKJyc+bcdrVJF5u+/wiADQqaimGEiBQt/NQZU7upE+Y7/8e5WJTLuWFFLljPfKdud/G7jJ7TpsuyjmE7HE9AE5Ybdi1qPTbNsqlJIOSwcKPbjap85cvtr1/HefIYfPG7vDK3CP1/6m3ay+9+69P3f/9uA8v7j/1LeP8/9c/X81jb5/9zoYvf7/6jjKIGtf/LbpxWxh3+VKXEoAAAAXsN4buFgbJMZNB879xMRmpipbpg74s0aRNC1JJfj0xiXaatY+6+wTd574SJ6GiLApjaJA3qUZKli+ZuJqXV9pSqzNxkma7k4eaY7kFLEEBaR2lAwWsuBJzyyisyUPTd0a1zRTIjHI1PPC8as3pfU27VlbVK0NS0KnrXWTwuRkyNdFq9Y1m2hYwR+me/f9f1K/Q/W3//+31mbepRtrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJMolOA3nTcqHwugRjDW7lBic4DedNyt7C54GHtbmpfrUVNMg08ORD1LjBSkOAWTLtHQIGAbXmgZ1DIIi5hhwLDzE5xEM5GWoh7TH2oUcMw4mmq6lQ8E5W8gtugZ7FWK1H5HQmFh/gs6Fw2Krwr0JqgNfcnKBoeiZi0x5nj7e7dMmsx5Q6E5zsoHQK/ZpuEIib7BSiHAErA4Y+fqcLwAaFkizorhAN5ED5fWp6KIoCZ18ZJVgKTDJKHHpjOVCz8tfGbk9rWe3z7h+Xfnfv4SbXWM2LuFWk3FL+X0sMVYq88FQ7Sv1IB0QRCG6s6giJTr0uRuRVo9IYKLW07PYblMaqqHcocO56aVUr4bm8262fv61Ymb2VP937uGru7uqsa//y/7/6/9/v9f2v9Bf/n8v1Z/G5q5jBUN9iGdXWMUwp728/m/lIAAAAFnn936+R6mKyJVev1Uo/p9bXzqQS+1Vqvoy+u+2PavMohB2VPCr+o+pLKez+Ab5RJLus6jr0k2hlGrX48hbRN3UVoMioZSD1kwpKHujRDsGcpEdCfMQRo+eKbpy+mylOoyRQJeibiFTU9AuDgQWh7fU/fJlX/RqrQouNJTUarW6k7LW6y8o4gkioxdXor+r9erq/U3+v/6//60Kfm0W0DLckh90AKPnXgCgxAWrTeT2Biz0z5mj91xo+HR4l3Mlbm5F/Q/YCoAbhiME/GpcQl5S0YaTFfS6torcdbTgz6swogaRqD46G01Z8ON0CPYS0PTOWwtwNhppTnwFMXpKMk4Um/XljeNaFRLVmqTT1RlrAq7GyJKIZAvK2g2KEDTgXDkFyfZ5HlU5mVV85iyhwf/B07M86rFlaGK2o5TPClq/LwVqutR+RZcy5rCvv7kroJtjFLU/eNl9t7xwinrwnoVEohGGmkBJcKir8wJRQ/pbsZ7LL0KaKHIoSrFGpx46BbcM2sdZ4uHS8/GbyevPDu9blc7SZd1zCd//+rUfnm9c/VndrL9//e6w3hMZZ/rOtK+1+Ybl0fZtLrPeV8J+vO2cccr27QzPf7wrrAEfZaz6HL+qUOAwz6bg7oRRZhxU6LsBIEhEQgVpeKRhU3X8aobIiThRqoiQ2xMhZifmoQVBqwBVYYmYy6OgT9tqipNZxEeqLJmonhuTRMTdJxmAxh2omKiQEnBMHjdBZdOkwwTe0d5SSHIkyiiWlrLWLgvoE9D22WtaTLuuSavodSdSSKK0zIO5sTr0FmyV7HBKXKKLmCyYpfmCXVV/p97/m/6qP++v61VdZgUUfUeYbyfQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB2+EzoM4o3MC0NngaxluXiohOoziTcO2QygRnEm7u/q5TzRDSBjpe6jV4pm1kWwnI3IdlqaZa8Mv9OUZKQapfKoZqxlTX3Zk1KnYTHylE+yWnw7ebIjo3pQghDDsQpk7BZ8MSOraxgcIG7siOmJomHqGovEkS4UBPpPEaRI2JYZ0BdaAwNDJR0DPRlgHBAJFjEwQRK5sLcdMFMbjoGRUVT8zWHqnisbJGJHDtRLKBojMX7vPoqWXnL5EUkHrUaoKqPmBE1sfPmRgKDPDnE+YnlkPNUj7mZMC2kSKRXMTE4OYRJaWspmSfNSHl50d3PWaq9WpMydXoOqrV9ZmulrTa+imXEkWZjcsYiY790+vqU8cGYZmwjvoYLigTFVUyQKxBtFVRZiztzsxUgFriei82U0FXGtdRlgSlSeJnyqIMqJm0d6rYbAIkEa0wobW8qrIl2KwPRnVo4w14DDaDIqG7YzUExbFZxpKBdM9HYnhJnhBuIOJLAboNK4yoKEB10pmJVnAfF/Xb2tU7dG9wisCfK4oXxk0no603BA8jzc7ex1Z7vn97Uyxy3av3351hr96kGv/WdSR7xo56VZJ1zjXofq3uxOzTX+zcML1eaPSOZmaByHWu5b/GP1s99+zE413H/yysfzn5ff5r96zmt6/f/Uy1l//r//Wsa//r+Y52P7/1fimVLh/PpMqWxknGZAgAAACR9xysygklDyIiMDRKKWEPEfbD6TlZGa2vvr8RdlDwJ8QIPahuf7Se2KdqtgJlQFKWjy3VaI0keLAlaEB6L8PWZaQCW80+plT1qym2UgSPoCeCGlQsmhUNyeFLFIjCkLWWxGYCgEUBtARgxBw9sDsBSQ5hMF5Y+R0FZNlqjHOmyKmFoJ4nzKgscg6bJpozA+6lrao2ZTFRyCmpx1KUYp7Jl8dReTNDAvl0OIE/E2YKJ8vitysfZMmDwngXERMuojmE4MYSZXSdBSKlIUEDMtM3qd3TrMH9RZR9bs3v9S/XTZDe5dNbNSKpdUgjY1WCAAAAKPW8uRAkxDQIiODRCBKRQwORnIhLOsmo2Z1rUvdx0w8rOE84JkesMpJIZl8CgU1MoNsVuVpnCfbEsMt29B9yMJ2FAH/uZU81DCor9IZOwzhATQf0C0fKwuIsEwXB9lsT2FlBFgs4JAYEHD2wOyFJEULiDFwdBWWyKUY5JaJE1IinF4nzKYMJAUT5sYpzA++une7Gkip5TpKUUTPablJJaBoXzwbIJ+JtBREy+K3LbnlkwWhPAyRPmqI5hOCzCXJ9J2UicUhQQMyo3rMlu6dZx9VRii/W7NoXb1Iv06aKDXpF1FTNSRRSnegoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjeiE4DWMtytGuZ0GMPbiIqGTIN6w3LCi+mQay9uIRnhOVcCW+T/JWRAy9GMhJEgkHfRKWTMqLSjJQkz3yuiRORBDLlwViOo/T/dkiPktsodhtchbmrA4L8T8ag1wQcVJhK5sqTcFqGMnU9CM4lJ4kkVC5TLZ6igB7oGeizUk7YUeoVH2ctHZ9BAGdasQ1A8sabPYN3iKhkamTObbQaFVbj6T9HukfWHKam+kjTlu7LrV3Ou1OGGL5Tdmkfq/lzeGscc+cneTc7jLtUt2e5lW3jhM3qmG60ANAUxgV5pXcbgpa/28sKs22y6WsulG3/YWnUymGYlPSa5Kp7Krep5mXV8O4z28LWXMr2Vezhlzu/td1lZwqXtXccuYfve9YcrZfhc1zLL8b+P8x+3NWsbWP2qlbv3N2sBpLG1/56zJNDe8GUP3lfSXSzp4KyqrDsgDERWVw7SiMQTyEtpN2cbdPA1+tXhF2OO882eFDcjzOlroSE7a8fSrBoGdUOv3N34dyx1uWSBdF18j17JGcXHaFRyMkMOEJVBK5TMMLWoSoq/1vWbbrfKOisCipXHo6jjw1Jus3/+f/bOPvdsZ+Prf1//r73mV8+y448Nyrr/4ivn0OlGxWwrCUeSUBCDE0Ft63V72RN9uINAlAssJcOKwy/CG5hdoBrQGuvIOGLPmrNnKiAYqCOdO49MuEEbNPZ/lRvFA4MBHfAEwUao7h50NSpUFqgGDg02ZFSq2P27MRfyKigZ6xYCySAkYiYMi8hk2r/ymtGZ4aHOJKsn1nneUubFNL4pHKZTIZ+OTTus4YGrlHERAX0w8LRADwcmie2AoexirC729VJqNT2fKnw07TnQRbltqZiUDRtUW4/SSKm/m/w7rHPDD60DXaHU1Vtd1bz1utViv2aW1PQDKpmchmSQNnjqrnYrcnr8hel41Ydu9nehuWRarhrdSnlt7LlNYzs//N56y7Z7vHLf/vncO833P+y29+Pfy//5jWwy//7hXs/j3tX8cf/98/dmzgXlrmeG6YRTCdVJ0Gn9hUwVT5QG+/2Cy2g5AZwtLDDouohPOxtcisMMV8M4qyW3dlbmUT1T8/Kq8zA77taDDhQsgDX+YyhADD0fl07ZxuN1gfHrlEep1dw0BmDtscpW0sVE4rk8b8Z+ZhvGkw4r2d8S59Gg19a0rHuLa9dK2J9fK5OwbuGptdf///VqfGJYntTP1rW8e+6Ux7d7StsWgwaU3j5/rrckBVarbcC8XD1gkVRfiUyo9iz8wHXS1LdIi2J2louAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIaGRKA5vDcr/p2WBrWF4i/XsiDe8Nyv+pZQGc4XgmAznyyVsMHQKY0kpw4Bl0DEwwAwqVLABg0fDw1fxW5S5L4BSphDSY4DFmXSZaPB5g6McYFGdGAY6o2NbgJ/mOLhY2soCQzU3vh9CoiAG9bK0wvaJEyAFJJQlJweIi+qNF9TW5Oy6VSAxgEVhlEjZHIGk0jMZUwNgLWWWsnf2AGlOA2s8w11DERY6tKAJPZ5k0pZD0ZgaQoJIdrw/Vv1qXKRLdpFlzdK7Uot2OS2KtoySMr5blcnM9/h3XcPxqTkrsRzVBUws198zv2MK9vXKucoocJTKtSifu7j1nCxTS63emscZRbm/rWd2f1nd5++2c7zkGRRNFJuh6KetWCpQWs3+BLvRBq3lvd9/hjGo3u2JW6Bg9ATaccQi102qUQGSaH14aTEKiQKkWGYOsLPLfBi8+oItsst2oRR2H2Ry3bTdkD9QYqFzq0ehhYZiDMYMNKEEYUMNiQZl7xw/B1FS2H3XEv6xqXS25NZStQuWUVbLCbmmw9vzt+OuxJ5NJZTLe8o2sU4iDZvUkguX7eOOsEyv64Uh59beKwROuaj0E491////+GGHdSGz+/3v/x3hnvlvMICMYBQGNGpQYHqHirrVY5uhqtdVrP/9X1gY+deXUzClFTIo885BGggyeKBwY5KPpYMh45XOnmxdiRuoWDFMDOKRMiCoaYAFA4vOyiTBHYxUJa6pe2iqEqCAVhyjpo7AGTgoGDwKAQNWqPDIGGBKfhFMBAQpIxEDBhMTF5hQ+YOHJepWtcifGoA4HFBVLN/aF3ZfKYDiTGGK8gFoKyrSXVGKZdV1pYARLSZemSDkwBD6Pr3yuo/NORDadDy8JAyyNy6NtlWXOp+T8AtZfm1DNZ9o6ncJ5g+UMmbSBLuHcLup+RVnhpYxD8roZ6Z5O1I5fpbV+7R2nOv/K60uktNalGdSn5a1es6tdpaXvKX47Ncu7ytHHzvTNmqxInUWp5skXpvW9zF/d/9I6/1tInqu6b/Fc2MefHALYdpT9lkXXvQMMHh5V59ONzAJiRQka/j9VS/pqHHmwHCDw0LiE3MrYXXhSLJha0Xeby9uHFKnnDh2ZrtJ5E1R78LLvq/Vncoxf5uqgE9bzr26azJY2GBsyi5Dk3jmsJU3SQDDrhyyYr1IbllLKGsxAYJMzsrhuhuUVSIwL6Ss5WSdkO8st1nrCDWajs38/x1rWPKmGWFftfLDuV/96uY9y5XrfzXccNXdip5r1qCqRIdUCgv///b///MgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACFZcSAN7w3DLqdkgZ3heIzl5HA3zLcLkJyTBjWF4FhxfdpuquokAgkx8HBIIZPklwVYwQHCAueB64YTUEQ2YCiCIdMiDREDs8UULAwBD848cBs8AnILgbIEPC7bBVUhGBEImZX2mKAz4CRUEGRioAmEhNslgSM3EwEBL/MDFjAGgOJxkNJgtY6VLUHZnpWrwycakThWnwiUgeh81Vk1nIhDyUa+U1HbIAL3stOaczJIpMJf0NO86zrWYLjUkMTXllEHr2gqC7L6wSX6mVly+XNDs0udJWe8gUDxyNPxr7ZpVduX5ThGMcZl9ZRLpx35RV7JIHjUvuztNY5yTXO38+8w5Q61a5vDuPf1jeufe52/iCQlBM2oXePoZu0JeP3i19bow5Ftl6FepV9ytWnKyYxFo6JDdAEQg0lASYLnHZf13A5haQXcX8hJc5BQGjhygqFgAeR272JA6q82/U9EiEIlaL0JYi3uUcQYZ+ggXiqoYmIpbAJLFgRiDAFApNA15/2/EY3JgychnGe7UkAVQ4nKCOROE9FjwmRS2rLWsTdjOhaJEaOkV1FS6caxxZVWp8LEFsHmoat4y7Lmr8scDAiTSthfmRV9d53HH+dr0uV2NY583reXfsY9/2rYqOgYqFijTSzYjSQComH6EIt/3dD6v/ZNESSx6+jugBRTCoEYmCRE6xcKGsGBpKDGMhAYGpzoHgkFiwsA1pAQNSSMAAUWA5g4AmKwsOCwzGGTBkSMNgBKpKgoBUNgoDrCvwBQEa6VgGJ4qAAMUQKDHrKBEKAMxMHBGDTLYqULe4yQEwShAMAQCIQgFgoEkoFShi8PMDQDDyBXDOvW27SYW+bkszHVVY4Q46xGltITjEAEMt/Inoe9XcNxKVQ0IA3EYQ2WIqVhe5V8HyR2Xhhqbiz+DxFlJCBsxwl+9bpn/c1q5mnTy2iQmGZ7CpVr0+crjNP2Vv07LLKGSS2biknk8L7Fd02oyx3861/6feOeP8ta3zvNZfve9Uu/yypvABITuIhNOtIfsHpmG6v25avyrkMUuO9nruLwstpjPNqEFTjZB4FLKzvJHAImy5JF6Vb2AMISeEy4NDIE5iP01lsj7NrAKAOlRDadMy69BSaSagsNbyUmNKEIgaZlUYpjtzHtk0RmGiGp1qlnZRYlmU1ASKvJfDU5PVYsX5l9+ctYT+93dtZs0s+lBTF+ZNc3LNUvdbdKq61yuobJ/yu0l9gQkyq6dNPc/ff/uWu3e1NyDuOesceWP7rn0EZkanNO9SjpAFTqIpd/7f//q9QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAh6XscDe8NwxKn5EGM5XiNRexoOby3C1SckgZzleFYmt2WjoKkgM64UCFrnM1hQgkIOYAIiIEUJhx14fBBwaWcuqgMEAUXsMEAiEQHRQ6wuBPcbIHKZqQJQUKhRfFig8EIsHoqpKECIXLppJDQisAlUQChlymBoQgDYZNVESogFBwEBZioAFAEsq05rDX2CxIzkRZc7U86reQ0o/FIYCmkAVaGX9VmhtVAlqy6FwtsDbq2MtjUPu2Xaklelqt3Bt1nR+WshhuLRD44qrou1PxARCc/WFqEMsTpDcwhkYWGteb1fp/rX69/sGQMymHmIQzHHvoqsDSmdlE3RZ2I1L8bEqkVmznjlW/eWf7/nMsdVsM8OY93lX4ChIOBGGxj12XoORcrfYlv7+2wd3VIn4hb1PxmGYdloHyx6Yd6Is3jsgaygLOkRVdljkPA+7emsoYWwjgIhoXD0t00lDpAkqB1F0thFqCFxOlQnCAR415P4J4gyojHCtquV/K3xhz719Bs2J5RXuQzZv0EzUKCpRrKxKrMgRmjVTmXw5dxoKzvdjE0l/KCqJa+7Xs3quFMvWonj/UOEH85d5SIMF6ZVDLNq3d71jzD7HKXKnwoaOrlnnUw5+WP41m/7jcBJRIBIPVgIAqFwIsKiEVM71////+uv1FvnjhlWMOAaFhgICL9MAg4xZORABxILgoLjQDL9R0u+BQUwcNPLAwwOGAILAZg4qYKEAATCk2EVhp6MJqhgYWyMgCCqArAAIcTQIgY/x0FhABICQqWiqZMrgwBRIMcPTgANBCSjpmhoBWQmZQEDBCmksFhZKp9UqJaIAQZQrym841m7E3fd9TwGyEmY+xtx2U1U/RQpi1R/FFoire+kNPK+xMrcwgVorCRJyHZ5rUMsurW6dYASenE4bcpSHh7PkaiUvBqwmrNFQFWdFqVzMsv2a8hhv4m+kvhbvJdQ+8EsbFHIy7u5Zfyll18LVvuV3mF/LG7v99w1zncMO2/w+59zHK3WMFCTUl3vY2eUtyjrzz97kdWR+vYcrVJrHasou/ViJhxSyQ0tPUp6R1CUEHSMFkjjxRKZCQqoLwBRZprkQ489RgxKBMwQCh42PB2rebTJEOgkAxMXTMaNkEq6LOHUCgKGYJlUhjr/Q6cpUvjmMjo5XEaXEaZwqxutT1MlzzuVvfX7pZTTxGVUM1AKypQobUsRiWwdbyqV3XrK6qdheFjlbOIOWLHVY45VjW7v71n97uN/e4Gv2a/N5f+f839LPPIyCtCcMhEPtKHanq9QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIH1DHA3vS8L5JyRBnWV4f4XEcDe9NwvqoZAGdaXhLiPNwfghAhohLiJaF4TTOYeHhoFMVDgKEMYWgt8wgBBqyZWNKUKDA0TAIgIAMQAYEYT4zU1ndDoFLZB9K6PgICEYMAiECjh1cqUD48IBwADhgwQAMAAWfGGkphKWaYCjgCBgYxA9MFHAUuongERMAIHGGBtzd4v0cw61N0G6NOjUxNNNaWMO1bXSn23hcrQXUkgrYgR9pxYR0MXEh9EugdN8IXKQSCY+6cOMtfyDMNKODwiWoVUWAMGY53MsI6hwMSFfdmJeZj1ueqbm8KTLc9AUFuxBEOVYvJLfYPnY1Fvwpasme6/ZoL/hMYeUlrmtKsQcctkRrPIJKtvxazzf/Ur+oTy3tevYtyqFw0S4xWA10vrJYnDFK6AddU4Zw+srT2L9A5+dZyYQuDhL6xDGZTwRcY/NoTMERXvl8NyK8xULBkRo0hiIyQhZIKGJCCRcNqrYtTisgC4QvzewmZ+XUsMX30NNhUEsfW/TzMWeHG5R7wf2fpqu3Ns6h1H3FclnK5G6HueVA522a0XsAnMtXPmiwGlZVeKex5zessN8qawvzstnN5f+vt46/LLV2BAGkGhRFtihowPBQ8v1Lb/9///QoDLqRsC01csRQGF8jlZcWBSIKIACFGDgg0FoKhwaDFU2AIDAFtVVjBgACh4gCDCF4zl+OEWzMQRtktwUCpWMtMIBGJEKieCwJoIPCg8BhJrZioEiqYIGmCu4QAqgWDNHDjARUmiDGwMeF2OqRrvrBimI4CjymlG4bJnnkNE6cBR8IWBAdWGVvuwdQtdwgNrO1MRiorufppdGy0EUvxq9RgUrSNzlUTb535VTtzWDlaE2X1BYG5mVBqTulB4+GhUULhSqxzDeX43YzuikdWAV6Q5A8/PTs/GqWxbr1qlPzDVz8f5/cP/vOf/8zxz/+9+6gMgU/FBPUQ67b9H6f//TKMLObdolNSt/TMoi0JgmRPzNP1IioOElLpN3bA0e+OhxgyflaIUJdt+HrcijVjWUoW8SAGVFomxuD1psSsEpRMB6VMDVBQQkjI1AUUjSqNRcD+uQ4Zmx8PXIbmpqUv/LY6DI7B4EgSzD/ZSjhaz7vGRU1qYpHjm7OCLUAttXwkjz2J7+3GWXUT5+oivRbyyll1MEDaHygq7reu9xyyrflzWUeq0NSY7vGxlj/cca0zz7l/83oYGEPMCBd9bf/pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAB1tORoNc2vDti4jwb5huHQFDGg1vS8NnLuQBrem4uXq0GNMSVZ6/DTT+ElvhgxI6B1wtnUqipewHOlMhtDBYBMLgItQpUYCIxsAcGIIMBgcglSGW9KE0BQAJ5jBZNPC5xR0NsoZIkgoOWAAYOBoJIaB78LxUkYCEREdAQYkEy/HpySThDVRAEABERldqUw9NSqWNOVMAIZmrKETWAUrltRBIU5NV/bM+qGmjkxSKHu3POolxJg4cdmiaAuuQQPhYaPclYIBJHGw4Vf25jMujMuMIglrC0olLcrm+Ul/HKvurGaexI5fFZDEqXtPO3dYYfWecKIQJ7laWCgaPCRgRdq3/v6u//992zQllhWfRpiirIXUTNOMRFJgIISqeuBGLsmX6Ig+LMx45QmuOBRjhhAPGJxKcIG4UPjCYy+D9Uq60bEYRghmlA5Ao0B00E4EfEE7MjDgKMLDEwmAXEaCZgARgInuoYkBqUZZhvHNdShbK84MAcD6eCJTFx3qr1mHKXMhU9GqKJwIBJV6CAb0viM/HHIfZQ9wL8APXRkgmgWXqdVuUvjUw9aB1Z+sMoIhP4azwIdnGVqIMSin7x/VDlqzS0uFPg3st5yjllaP3qtyprKnkF7XLP//91/73//j+PMN/cy5eDTWB1os61z9S6T1tP/9Xu9MM2H4acxeJpDPRPlPqUkQdqC6goAxOIt2Cx0LXpYASyoVAAcmmFg60TCTc+R3NluxoVZw0xSKcyoRgCZMkCd8Fv4IQwCAjrv0RATLwsIGAoUZclTIiEACRDzyZqKDSmbLPShCCHlcpJmugtOgONQfF+MKazFTU2wwyidEXquvNALM0rbNzk0IQDuU3IiSAqaHrRfNpghEJZPpcUsppXNVnRaHSqvbV6QUXefPliUszLyBn53X+gW7zLVXClxuZy+nr4QypzTT9nO3C92O6nv1BrJu7mr3LU8VOMAQQegyHtns/5Lr7vu/TR6jjlPfYUGgx7j+lYdQHsUb8vC49LBEoKLRQFrbrQC5aIgzHm9qJp7SgBVjbqwpkSKAiCFOE+DiAGPMbLKM7WGIgZVcYHDBlBezVS8xlJKMCrWxkecZzYepLb/zLwgUGqOpW7qkoYzaMgCl0veWgsxqqrGvXlurKIfpJROylh01PS2Vy1z5yckEomsKabjrqWVtOp2jg7HD6uSYI+AhmNPPZ5rK9y99+vjnlhcX/TUtnlSfp/t37/MsLuP95/Mv/f/+/13LHX853f7s52dAjMB57Xsd6+r///1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAAB8hNxoN8yvCqigkQY1leIVltGA5vLcLnqGQBnWV4Zu7fVnPunM6ZelJg+QEgctQmBbYY3NHZAGDA8TQFn6HF1TB4FMRAIwYFTGhNPdgc0QoDCILS4UARLVsFgeYDCBQHQIMDXABBodJhEBg6NAAwiCJUhzCoJMJnEDBFUyIZiURGBw+GEAxMLyEdwUe4IUPtukrOhFhHF9u7YdCA7eJnBriSsjrnsEbK6QNXe6tTQBE1y0Fh/aVI2Oy153EZaMWtc5OSiOQROSF0YvWBiMutGAHfxz3UgodINgWDHxgmT17WNvPlave1xuz7w63CVU1PTRqVfKbPMtfGxGNBUShFbzY0aBRcFQCUFC7Gi7duvb//7r3X3q1Kl/PnMOXLVGew2KWV2r1iMychEDxKkh16VRMPWDMWEPMXHmrXL8ldKcehWXJuqZ8FKG0kif3GKMRMWMf58mUCM69xEtBpWFz9PBz7xKZYgf4T9UlHnljHeZC5k/RQuasY4JTbwt9uuHOS7td269PdYlXX/KtUcRtbu36SCsFbOXFcPd/0G5klDEmqGDY5SYc/LXcf5njel16h53/7v8uY4/huEc+5fq0dV76R4LrWh1SwaAKfsZYWjqcPC8MEwhkanxwKpqJ2AAWMRDCkgY45hEMonIBA4mMOqDXtI2WjEg0aA1oFyh0ECABy0bRY+BbiYmMBg4QhpVFTBBcqhA0XGDGZjjIhiWxXCDtEEJpiQ6YwqGIgCUCq6droMoVOho9TXYqme78MUkJaoosDaokvBojNZU1VMwQLJFLmlcaml5QqIwbNEgE07EUTDqACZkN1QZGpp8egSjgWGJsw1JM/yJTUpJuzF7oqwbIrnUjtTW5TTZzU5LMojTRG3Dk8mbUv1qORymCaenjfe17r5cy/uH/3Xfz/9b3rXMOXctVWAAFwoAgwx94wm6mK2I6tjvrY6+NV8Cro6vKeerfqkOIbJ77VSGpn31ERRm0Th9ZKtkAt8jEHjRKuhcwSVu1LF8qozrPyIdEVVow4ENTr8EBIRg38kTAzNnFMyZwDkK6lkrTtNclanRVEDHG9rRSmoJ6CJi+dI1mGpyM6t0ohBpu1aPb+z9jl1nk/bmVwVV2yCzIGz2qmcqtureTHxjheak/LLK4VTwE5FXhh6cw7v+fnq13PC7KsLfe/rLLmGv7qpFf3cv/NJrUuUcDDA+QS4XUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjcjUcDe5tysioJEGM5XiHiQSRNae3TMTSlDQzBuVYsnAb9+VrSRDYqAR7BsxBEd32UsjW+osxELi4ZotCfRd6RoOIjEgIzk+N0jzCXACg6Si005V2KXKPmAApg82b8IpKlUUTYMIKYCTRRNAAsaYXoDWbo5Ghh5KMphGHiQYWMOVUm4jKrAwALLbrALmlohhTPj5DIQT2TY5oj0VwexQwxRxkiX3Ho3FJjmIE4SQkJiWSgJzGyCkxkhjTIihPlawzhZMwAFufC5kYrGxqRpYDG4UuJ/DFgphUSSNqJqZJIG5NmBBCkJOVx9IPJVzp4+kVk5fdJR5euhWl3Uz0VrstFrsi2q9a3s6kKmQZOyfug1mXdBbqWmpkFugt0EXTUy6C0kNNSCdCyamTUgmkbnGN0GN1HjBE3kLI6Or2ktY7xgM9rt3KSxesRxthhZ+rC5n+QRryZkTIGOuaAUJZRTwTGWBPS0BwEzr6NsuXljTQEKgBFUxdgQHsjJIsSnkPBYuxLnpmvSrMUWlsS2z3cdzpAimcf6Vxy5cmlAKOrdx52/S8wdGvR06tddZGF+U5zfbe4nC+t5nuDoR3/xvxUXxpLEN0WHOayy5//388pX2xrH+/9XmPN6l/frX3r1+5KaU887/6P///jSjVrQAABO5jVgFuVmAoZWWele05lbd1tvhSwE6gXdiyF7YtKFkiEhDyloOxAOaiQ40haswOOuJITDYRwCpelcOAF3uuqcdBjhYrVvE/7VRASeeODqOBYeoZDTTMPy544TOyCF4Mkc9gkjYlZVnCtiDnj2ltIpITdaGSKFGjOKrCOtuY6qZn1cKa0Ib17CLW3/FfBLy6OC6YHCbGdWxNTe7PI7/2gxKYhfVr5t42vbOsX3Wm6+1aOLU/Vrc7YWBVMUN0+c0NbJ1bBdMze4t0d63RHy5dK5tcWJvcmHVs6tnVcbri1cWteuN1xuua2vW2641bOrXrCvaDS0urZ1BpGg0jQdPoU72BGg0fSzvYEaDSNBgAAAAGooukauuTAGRigkkXd1KcZCZpdnKeGpy/Rn8Mpi8Tz4UWbk3YOVkdykaNKbHJRAVhZkd3aEpxk9HELBOXKmlcmuyuAAU1XuYrMDUoJuD4iJ0trQZEUsyashmyKjWmRQqEXSWoqqWg7GyJFkmIkSL6RmJ6D1VOU2ftfRQW7F5ktaN17US87KdFVS7rRzYxUbHTSZl01QPrQIsYok8cN0ThsUTRI65qUnNUjYxQNTK77f/2Z35zG/fu9Te7sYy1JtWJJZioMlkKoktIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAIUVdFg3vLcMiLiOBnWW4jGWcUDnMtwskoI8GNZXgaAYrLIUkgWqUyQqMUJj0uwOMQYLSgv8n8iIYGCgoMFLswsNaZLEBTQAYbmclJhLEZixG7tahiPKtpgAInuKgYWBEjjcPwBNxjAkQhZbkSMjAR4wIbMfBwYEnVghKRIRFUCNKVxACl4zPDBNZ5GUxluldf6VYhDYyueQRqH3llEXVUOOOiam1pSt74uywxtnHxgJ2r7W4aoXSigGRpWwQKyOQBVpcUvk6SdNELtR8IHmjAD1gghbNbwodS4cHEyY6oGra2s9QYSuniFSZuWYDfaHIIRx5Qy/OZtW7Xxilr14xIN7kmO/1rLe+93r/tChdR0cJRgcOELTVbu97Mi5EOkpV9eYQlqqLO9cHarxDHe6JQME2yJmMGv7uH1HKysZMBl9I45ZVOtqRLLOKvGubE2rRZeFgMDTCkVCxYDD6fsUhLssyXI9xFYVThSqpqkRgINsw49jTSRkG1FTuNShNoSqOS40t+/Myu27RvPr/n7LjzcSjhdWQ/heoIeitBqV3Yaq1mkw6wFzZ2UtTxxtYTT+XZde4QBwLruU7edg5Q2r0Dc7/f7nU5az3N2qlfTm8zyyw5+Gt567uBOa1R//7/v8///fP7n/7797G8NtdK9NLMY5nHrXyGCCRsTDgIYtHJiaSodCIMCMIGCAAvBlYgAaaJlgHAJnPiLAtDIv8KB0oGBi0uGyigdRDIjAiE8wWA0Fi6xUDRgoGAwAnDUuGAZBcwOADBQuMKAUOARdQHCcWFpqsBjAGdpS8BWoQBsweBTGoWBQ5LRqYsnW/GnjXAaHBTQyz8qa9Ak7G31lhxANHgJOadUcRQL5gUUrAkTt5UTOH0eF82jJrP3PNOYAyUCutIZqxx4oxOdzpnOtGKE/8oKpUIqyWkeOJl6AuPHywGVAZXG7NikpbdakpmfOXL4RFlJ0N+jzjOM7jOXaXVyUP3r6DPX9w5W5v+7/ncf1V2JARg0hjDraSxtrHbFMQSS4oxXpQYYvYrXqN00atZU+dSnYgd9SeB6sbn6bcACFKqGjgdyFa1Ki6pkgQmyDFVxwmt1ZKhavCEoGQ3k0R64ClErdUEnR5znDajQiTjKOLgggqBXTWZ5c0ujyc4VBvRaK0e7NJL7ZrxNvykp5RSZocn4/nOR2WzW69BVt4L2tpKXc3hgS9lW1HJLkx3OngOf5vKPyovOAxnviEtkf/nvPDWeFLnq/WlfcP7v96/Lv40Ep59y/MAWhhJm253QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACN9cxQOcy3C0KfjwZ1heI619FA5zDcLjpyOBnWV4uMyghQ8ukYFBaCQFBMxQCjqbGFheHDaXl82LMBjAyDzCLWEACiDNgSFBQHGHgOYcAZi8emuqOb7HQCBK7BkDqVpyCAJgEFIWHLjspkYDDghA4GQxgETmIAcYFCBgsOGGmkJNIaDcMEgFNOEYcDAkLjA55AwdHgchIdZuypVlImGQgUnwsJUjVJTZyqQnqchA/6tksk6vVHQCfflrtPpbZPSxmCmd1+thYEl62MyBkuMXieu9HZVBslk1lNGCul91w3NzU24BKAAs1PtJR7eabtakf2M9WZW+kSjcTaRMSmU0sNyKKV6uFfK7G225qYpMOY75n//3HWe8/5vLK3zWVgaGwACDBosqwadcfFJ+x1lzRavYTrWulPeoc5MXrW8rEcu0jrBOr5Q5fjVBhE6RA1Jp+X9dJWCIwansUxBYxCn7lsNw8iWn8648OaHKWcs1gp95SyEqRU4XcljwmxGFU+NBxCYYbAiTmDEafiBERij87Yl3c4HpIBMnYnWmLdNST6M8C5a5g9dPembEUkP1YhkqvTdgqV97YtQY06kWNeybrJ+5bq4JohkI+8T8UeeO9fvX/lVzrUku5vv5Yflr+8+5Iu/cPWPWmpl0Vmv7P+l+1oKYNYKAKCACiehwMIkQ8oIDFABDgw0ZW5ZK1SUFKFmXy6AjKIgMztsJgoBjoOC4XCh3Okyk0SDhAAAYCi5o0D0XAgJjouBJKNTr1CeYWDoAHhh4CGBA6WhMIjEVBxmc6DxYCBCDgaSBQKFsKARCwLAkvmVgmUMwWBaSzoRgkx+I1KFK3cnIYgtokYGCiI4CB8gbnA6majwEk/EEutX2xR06d32xqYQzH5UicuUBamIDgZmzlUlJfZ3Ad1r8DU7AYrYzmI7M5iNSvhgSps/xgK3hnP1cqSacJ6XIfm9aiderO5yyW3LVe7Xrczmp3ncavf3vnccP5hjjzWPfxxw7vHV9BlhsyeOGWLflxxkgsQECby9tSXu0WnB4rmFRrWcjn7ViqgRPU1p0dlMF2qeHa5CkijsxWWJpQEOCDBkTzExaq197Hvh6uW8ReW+JEIk/zNq77ZqoZmOFiRp/pc7JF8CgUDHxALgVmjztNa9VhpHcNpddqc9hcrSaVPoIbHynKafqQ/eXLC+dvXZNP1rliRXIhGLsNpi2ezcD2t09i49lRKmdrOg+fM7n5l5BbV2HmcSj5lZ1/67y9hq/e5/5fvDXO7336sDWdSC40nUlQUWMIv//coAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgHT8WDfMrwzUnIwGd6XiTRbxIOcy3CwicjgazleK0VcRVBdym02OARjLGa7VmFgw8EGCA4AQEmQ/it7uGWCiXrUwDgMq51RAFQSQzIhUM0q80KIQMERIOFyC80EAADBwRMUk04GXDAoEk5iMTmCA8kWDQegLTdMtL8wEFy06cxdszyHDCYJMGBwwOGIqrXAbws2eF2WUGvMukWCfh7ZlrMPOC6IKAUvZw9rbq3yJ6Rk95JmrHKrToo+juP2pTDbNIFKwroiTfKOMtZ9G6TK66KtU2wjXUO8XvXspt9mCAfykJBlZLNLQffu5VNbsx16I7dl8xKJJatXofxwv3Lmd6TY8qGMadabCxYBgZcTFzTKo6Sb2Ud3oWzu1IvqFvTI6uuUNW+8YMINOalfpbfxufhqJGJkMENxV8wh/BkDSWGXU0e5ARKm667XmnVQqAjIAEBSCVZtcEArI4ZeCiaUY6cBCNHIZTcMzFUyzEQdbSANapAD4p6H2mjIs1YVsMAR6H57cqlLwiOa8VRw5fBe54YES6zTWsmHV683LGouRDdEv6oWAUP35mGpVjWyfF37RfLmL/RbHPWo0FRRgxciVnfi13l/DmFX+z9ucnt1Ma9W9rdS5vDf6ib2DDg9YDYq0nINYZWIKHJZo9NtKlzPWoJCmAw2FQaVQAAQ6YyCx6lDFAXDAq45gINMdWk9wEBJmVTN2CAgW3BAOMNCcxeLgUgTH5yOaLE3OBAIHV+GBQawEZBrNDAAiIXGaMNQGGJhMKgwAmFASo4WAkQgIRkU1q2gKAzAwaHgEBAibaGQINIBDxi8KmBgkXiTpf1GFS1MwwCCzVglHAO38SpmfuLEYYoxUlbUoYcVAXqbOnG2BymxMQl8rUjhHLz/P5Pw+6QhDYsYjTtOE7Q0LGIYgetQs0ZgirFrbcmP38Z52WHkLh1KsIEZiCjNaCO2pulu3/uxqXx/UBOJbiFynjPYneisjmPzzpd4Z3M/73//ty/vL9f+/x7q9oLCgJIcA2i6RABb4oFKjKrkPsErxkW0JOjOVIXmFvLVwn5RGMYgsMLlYObZ9rs9ORB9AiDGG5Y+CIblAwEhTNnzFOZbzzy+SpuQsIKUZeyGCwJAUreOKsIEwR4JSt/H/CqTVRJ5OpYNtWsP069WTuiYAS+4FpNalcZxgwxqKSWwt8ZDbl4VDfvf4XqSkv2adi9StS01IhPsVp6BJZd7yhh6IwTO5Nwz3nrOhhoS2ddmNu1+XP/PDWvw7uks67lhnv+Z63+9SGVmEKspYoi1YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI7FDEg5zS8rspyNBjOF4kbV8SDnMtwuGnI0Gs4Xh31/rZQnEwwDgYJBVH8cVhyxMAIcmCwCYlC5EBU4RwAjwJFQSY2Vqo0KgMKAoAzEYcMJAAKAlAKZenxpEDGAgcloMAQiDLUkIwcCDF7fDv4MBYdC5gkFmFQUXxLSmGxGYIEh0ASgIkCQFRtBIYM2mkwQWzEITMNCsw5t+y1DwOM3BTcCLROW/yNcKbhlFm2g5LUQCBoC5bOn9Ys+z+qKQuIyB1pc6Urkc7A7M2nr5slrJAPF1nPrB7lthwnp+CXxmTDgJZyHWz0V2XT7GUExow6hThJ8tmnKl3n40fO0MZj9yMOjJK9BHJU8/as33DdaFPfrtu314L3iXvw30AVFgzNvj+TWv4r5+neutfnNdspRVb1vdmr7676F+bm/e5NNzEtgf5fKBWZlq4UUWEi0WkmpONdMAhqKPvTP4Migk08L1bU71zQzBM0KBofoHEVSgeAXHabTxZWzM9UkklRwexA8CUGA8YKppaOcqaxVgOO1jkVVe3LrdNLnixpjGlZtqMR+324g42en1ljFpRydmVCZitUjMIXBK8pyUz16v/0leK75D1FllvKXIghYE9SOta+vr+bwx52vnnbefHvLO9c13n63hJ3EYou146qmm1hDr6WM9Xf///VK1+w4BAYmuLCUkCIEFxjMinfDaFhqAgqMAgRApHBEhlKMJj89JajgOQnIAiYIGIBKNDowiBDRL8MtAQFBOJOWztUgGARiQGGYY6aaCpg0XmHQYYDDQOEZckMDJhcPGCF4YCOKCAIGi/AKGTJ6EMEkkwuEzC4GBgSTYZu2qmDEF5GAAGYKExCBJd2NP9IIKU1Z6bdb8wMo/AD9xFnZmJyy02F74u6ssh2BILUAhx+I2BBWFmUyy1+HAbozOeiF6PNel4KFxjyUznYU1uVxQdNNsROMqiggXKvQaqyjPO9PxaMSJ5p5SVumpK0hywoqSxdmco7c53PPDmf61jnjrmtcqh5TzYoDYKPSzhh71jHE5wDiOo8VY0WUlO5t7UExoenQwjFoHztxtwovNPWrkTPJVRFmM3D8jppYLWsJjETYk6qt6mo6eDxs1Ss7ltJEy9xVHWsUJrqlqZl/rXlSkK5s0NBc9/3wGyx1ITCB1imdZ43tlMvli0g6zuYTGcxbsyudikDwmP6u35WubHKxUpWE5yuV1I3br1m+ehCc80pzl1uix5M392u2Z2Qf3V6so8LRwbE6XO8/uPcN4VOY9oZjut/nvD+frLWd8Plr3DnvSp6msp3fu/7f/7f7kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACRhcxIN8y3KvacjgYzheIz1pEg5zLcLzp6NBnWl4ThXCtJAcRAgjChwMQVFc08tvLLg0gFRZCeMjCFSAUFAM0ALzAQCbkBQAYBBJgEIGAAQY5JQUIBjnGqUAwCCAChwKBIODgCOicxYEjHtlMSjcxUAzBA1DBOVBaJEYwGDTAYSADeEpGSgUoALWQAEDXxPMDD0rLZMChQBqbqJsmZui8l0FwaZQCLgwzBE7IYFaLA9k/ARp9XrqRiNO+0sWaWdJ4jFaWNP3DDxTbW6ZqlMok/4WaWm9ToLpnqfCVtkfylL/Va7AI1bvYS6PCNs5kIZJRV4wPlS3PprNWtjjH9wNbV5N3/nnem7stq7q7sUTUMu7kXP7vX73yrnjz+d/eHLWfbmN175q/4ZCv3ylfwhVxpv3mf36RuX653btd38tE638b7VWUT92rTjEB0VdrsTcalklNHQ5eHo06zc32kbKRCAfyzoSiFPs/0YLgkgZIAx9dEBS90oFkjslh91Eo41C1H0BBA4gTCqjNL6jtetuo3RdLb5dzwmZfk/RC1SU7WsYZ9Q/n+/e7arSuvKc8ruUp6jvrHKlx5nambemc3+QHZ3rWERReDHy99oI5h/9w/P8/z39R+ceXN/lhl/7/7tINOV0k7UCi3OPTj///////QkA6i01ZVroZrTIQCYgEp5kCBBWLSiELLrFQCgBR9EADB0nDgW3iqqnRgEDGChKAR8YMAhwiKEQ3Hg+jgAgSFAaxcAikwUAzTg6NKhAwoCFMgaFQIHEfTCwMCwFMSTAOPQgBr+IjBweNtiEtKPJ8wELDE4BX49Cn1hHXWWFgyNNsSGz/QNSP23eMSFD443GDLDs0jLRWWNgKxlYpcuJ/Ze+s1AlC9rApTbjw8DFTLDQqgd4FXyOMS6YeJyYikLXsJPOJV3GpY3MUKA9rUFg3ebPTyue5XnMpjGWx5/6O/E6etO3+V5LncrX6mVA+/7r0eev5+PLVzf8/LLf48qPE4OH2vOn18qEzsckNv11Zp7ojihShIFiuLpWmuR0E1QdwraGShvxisSfWRx6XQ25CCCRxiNyVWRiZckURmbriwGHmgOLD8ElokC0EUeU1qNIeOCmlw8KtwoYYlJJ1hhMMES5DZBsWCwwtCphNOi4SApyJ23VmsIczggcoKsp5VTx+HLIiEUHcMMaWL1KONyyWXeNTuIJJTTVov3Gxej8nmm7XPiOtawty2AiZ1FrM7Ofc1vu94d3Z7ZpoH3h3DnNYY465jhCb3g09FDW6ngBS0ff0r/7P/2VdQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAgoXcUDe8NwysnYwGt6XiCxixQN8y3DRCciwZ5peB4EZs77G1gGjKwDgCYtRHboiwbYU5AwTMFB0VqcLDBmBw5681BwKMIzhAQYEKgJ+Mb5QESA0HIjNVpfBZ4ACQIJnP/AUFDBQkHBIkmFlEuUvEcTI8YzQRWBQGMQCgicIxGKLRnIOSAwGMpY7rX1Y8nTR4MsEOQVF4fiksp2quKDRqwwY/cjdmPPqQ0isPRaN0STlqZlj/urCX1f5qcyGNdSmbHGs7E7FZIpKDFKJ2afF5c7m4ahwdYAzwRLEQq1nDCxLt2puzu9D8UmoIr2uS2Yot3bGsbOWTfY933m8Mv5zvd/+t7/m/3v+819cwprySLTjkmI+62HJJ05VSncKJe0TC0zkH41Oyh+d08kC4UJCwJI2l5QxB1I7ZhwOwyCYwsIlWt0kAx4APjFENn/aRTuy/wOGZaWA1/ko4uxOJxKNtfMEDTATQaEInAaqyIYjNBIIAIa01+ljQLAcVayMggxqRCbV6tIPd6dayaHil7DNvKN2IsVgVOKOxcuMapKudJDMqiVeYrJZVuS53MNdr438kb7eMGy/nK1agXmEBpdE3ps3v+vrP8u3N6lsZt7w7nvPmG+6y5cl/6j0pikUedMCxAOLRFHXup9P2jev/Yh+HTqCABaVAz2KfHdI4ggMEAzCwIwUQWmsxAOpYYJApmwIgYI5sgBoFUFMHAIxACzEwQM9pQSFqCQUAAQDJepBOQGgczBFU5SIpRUSCQKKwQIWZEoAMswkx0DxoPK2iwLJQsYANoNMw8FwwJJqjwKd+ErIis0tsxgQ4en4FsXI0z2OPKax6z2MWnff9740inLKGKy20y+W5vrpyJZAU4sS2F1GzzO2mzkgpMKeWYKD2bLjQd+XJqaWkRhNXYwqtFeVcbnK3Zi1S3bMbhNJj2zqes2scq+8eUNJ/f/mf/zDHf/h3fOc/v933n87veOssO8+76uUKE0rfOU4s031D3bzliphG1iWI08si0zfp5YM5goWNMFZy77ouhNrZCBuxdmrTVlq3LAKmCwQOODIcAbSpZKl4Ug0MkGAEDHfWdRwl1XmeJmYgJwKCQ0PW3eRKcOLwJChWDjEAGfthq24jci88+QKNq5rSXVXrAbzHjhRBodCaW/uXRwQC4nzk91pdLepqrFrdjBw54tjJtzC/bGOsohA1MnRJ8Iai17VyvDUCiSilp24yfvcLGsPs4b+7NWZBnre8L+H/3+/bgZqINpPOp54LPURXVG1Eveyml/S7Ru65t7K4HAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAIdVfEg5zDcs6J2LBnWl4huVcSDnNLyycnYsGt6XhrLLYswxJpOprLIzCqeDTKIgKWkFQIvJAMjSX8Ko5MWgFzYzLC1QwJjFINDBSYdDZzYQjAjMBABTIHDASDSVo0DzEAWOItJKgoDAYQSQSvGIQOYAFZhIDG2FMKAUIDKCFSocAJo0qGASoKgYDCRhS6JZXT/vQOvwzWBGTOHLMcqWdeFkBvsEChmEyNiLclooDOyWWu5H3FcNrNE1WMwa7LW2W1RXcevuFG38qxvCC3nygCzLCoOM0GF2nlgNiB1NSUcpm8rYapdzmdmkp6eejMfgStS8u/Pa5nftW+WW9w7XvZ63jnrXMd//3txBaKSAQOPiaKU257r813TPlPx6f+0hbBTt1PrQe/mttfffE7zxuZoYxU7MDmYuvBUAwJDlFD7hsgIjTnxBLNQBUAQGU8Z3mYd2CBC02MsFh5tSJoVQyXbM0uJGopGncUOYmZdyKsygzMNrDB3CUiHpoKdqVyCH7eEnlMNgbBGblBI7kYY1MtxAaNbrvQDqUzclCwpzqLnMX5p7t+PL0k8d9p0QJQV/CGHvp78eymLW0KpBfs1+fhecgUBBxm4+tiFb/d/VnV/8MdWblDrLHDH8M8ef/3YpwbYLHWxYUEaEBsuFz9b01IUK12dTdH/101+40oAw1TpHIdCohBbI3mMFgYFolCkoDwIDIWDKj6AJM4EAMSh92ctv2l+Bg2yIwipzMpVMFiQiEiFxgYDoZuyAhQYHER3YRmHANCAADhYPDgRDhCABMYZIpllchgUCgNIga+AiA4tQTBR8uGCwU3kZcBh6szwNdCiA5jBlrCmauxbhlreCepggcelsvg59JdDSA5gkQjFLB0eg2hf99VTN0jD6O/D5hATXZfdf6LYYYQG/lOtaTW5M+djCijtAICpsAE46TSZbNTlTOrV7y1ZmK8tqQ3hVz5QaxpO2Kbn4SvW8+Y7/8uas5/f76iVn7lZEu+UNzM9WvKX2tAjPnc73BDDuP735GX7v/zbrp/Vcy39ROZgak/AcNkZejcRTZ9qW9YKoErBCploMXUKlC8jIhM8MCLYr7ikaVlkQkXkIQLDzZBYRiL0vBC2NhYAEJcQIpEBvc00ZBjMz9qpQiCg+8ymy+r70wXsRkwIPa8/lBPSiaZni3M5guB5baxsTlOxd7aarlNQP3WVG4d2kh1zbCX/8/KVZWbGcOVUVe6j1J3+V5QMglTyiJvVLvz/+/38MaXLHGNa7/87lv8cP1yTeeeKsPHjFgWQpwH+u529H3dCd3R2VhKj2CgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAHpE5FA3vK8MFo6MBnelwiHVkQDnNNyyKvYsGtUbiLq7kAhBCYKacgmR2MDUQ/hKoCo0XeJAEaHmPKQEBUJYygLtorUyL5gIwWB0yofPdHAMythKoKqyCoCQOMdkTTE0xUYQ2UYDAcOGUhBQjMYJj8SQQiydSiuIoFGZkoy0ETKZcIqDO6yi6o+5TblBZoYwFBlWVyaAWuYycwXHMhicW/ach/0G3jsUMrsRK3Eoxmp6czh1dkmMUSGtxGpXqzszH6W6ibL6R9Itz9149LAeDMvWu2jrf2rW/O1nvDK7SvnKZjLOau63hzHmWcieE6ntFlAVJkcAxgNijCpOH9aVJalxEKdqlKe/U0iniVairXtYQauHIxXcmKyGWzaqpT9Gn9cFw3yhyVoECsOfuUQ6umMqYg0OMGMDgEJIV3HYoncngUGEoBIpYgPnqjrQG8UDh3kCCSIVHqQhAmThBUWHRQqSfNZlFKY1GGlrCm5BOvJq1fdx3Kd9DRrFmUdFJ6lefWBl+WNN7q35TPyuAM6kiYPm1CQ4Ush7KNdj8rssC1Vid7WesqSCB5W/9V2sMMu/Z3+H5Y593OeYIHgqbcFSJPceWtJQqxFyXp+Z+Tu162t/Zu09VtFZeCkXPMDAlfSoQqrx8WriMBAYsAowGFFMWIvAVCoLKuGFF0RCAEiAOpymDAQBBwbNB5gMRoSBoGpDEIFc0GAgRw8i1ZiEDsEMEBQOQBjcBr4BxPMNPIwmCDAhYMIA5BaAy85isfGAy4AmqYLMhfJ038jy6p5kZcUwiNl8r1pXWmYq28FF4TCdUD3+ag/7+tjfqBFNmrPpK4jHKKLXIk2/Yi0Rrr+AwvLb2Czp97ZVVjuFAh5fuFUBB2WONt8V5GBAyiGXlk9LXtUOWFfva8dpoPmG0x3V+ZpJBYmscuZ7w53f/v8/1fy/+WwIGeaYzJHNlWIXU7nJ/8/1DEMy9/473Z4ttY81Tp+5etPDbyiW69jGB6SVWdvoTk4YhmCXJjdbBQ4oSv1LGlP4nMpWiuNFhF9LiPUji9DKooYEKypQhsY0af91m0j7NBVKPHUbBJ+0GBkJh7G4iLiSAMBFYBqbI7UA2YdUwHileGoqUC4bDfI0aoGKnj2NwxQOmJMhlwtuZrieizTYXpdOlEQmUKSLyRgMFIvpLH844YRQUPlSaaRmbGAaqMycGWLVddOtrnjhgYqUp3rTY/SqK1lq3UimvWpqut6N1Juo48K97E3SyFfT/rZ39G/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACGRXRAN803KzKOjAZ3pcIBk/Eg3zK8L3pyLBnWV4Xu+lMVAIvyXJVMXkENmN7IWCR5JbrBKRTS0HREaho3s4glbssFghSAkKGGkQeXCJQNwgJmFwhDbvOKJGUwPOzUoMC4pMUAwuqZIE7pAQEGHgYBJQIxKFQEDj4YDBWKMocsVUDOQVMdgpNyglTysFhiFQEYkBqcrrwNB9eC4Dh5tDPZkknBcPj+t2i4KPQPcldNDD/u7IIGZy3sw/lC1KmFCUofpkLBIi/Vi9EI3aKgWX133aBrtSvVUACEUrk7uP3YyysVpf3u525S1XEna0tz3Td1NWKt/uF6EZb/WP/Vr3MO4d7lezE2CDXD7/bswX3TPgT8N5fyfch1qleLNdZ3uw3LO3kidACY+AOXit+zQw9avW24EdTdnvnpHXvzzsFARJZfAsWeVTpF0QEhz5c0xQCagR94JCgA3dZiyXEqL4pIbWuOlpdAYHCRJ3bbzje8LjwcEBI9Cl/2AQ1fpbic9DCuUnzVp7bUECjiLdn7l+flyOdHvDeMlsT0mtPBRY9cW++M7cl7b26TOnguH6BHSr+7fM/x1EFYJXTX6LLfN45b5/458zv6P2JQkJW4hfYhAuC5omxDvpN+rq/+j8i0poK0wSGBxIDQRO5R8wSHI6hgLaK3iw3QnJyIRAQeGNwGxZStX/BoBKKGAQYYjMhtsbA4El80gVDGGkgAGASYFrJhARAYQBQGhgjIAcDhQMgMWDBg1zAZTmAzOChqCANHi7xhcDiMFmZBaBAGjGzhuzWGhuE19BU4wcspZR2ra8mAQydcsOr2mXafl12t2ozqTZ1my7tUr+tzhmSP44lQww3+qtwik3VwrR6mrFUCLXXjeXDu6siZgJOVG5wxYr2r+Na1hjexpLVbrr28Mr9qrhn2xvmWFXC559gjF0DScPmzwmKA4yAnBEk8yxGtBPy4soWYwN2G3NZwubsWLJaJVOzH6SWs3hnO5DxT9GovNssg6Jugncng2KUKENomNMLMMNmNEaVncRQmTwzaQ4wLCZURIG1LLu3HnzCiEiMlRsl1BdcgBngaECEs4jQ8z8sOsxW1dVlabOUs5reMKs2THzkNWUwx3eRbyHrOdJyphbmcnDpqSSqcxtu1NbiMFZWNcgl2PRv19Jnlrkfh1DorDTUERs5a13f71vX91lhrnPwucy1v//7I0WahjwypLC6IiAzbq9TqWV//1/RRr6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfjTkSDfMrwrgn4wGc4XiPZhQ4N8y3KoqdjRYzReJW+sFgkMTeV2hcxMwoxE5ktcgkaQtlvasXFQEGHqIwGtSN1CzZeczfETMQ4IACUBIaDahyVJUBxgwCmeEyaOCYGEwYOzBAHMHgkhB4FBpEKTQa/MZhYw8PwEF0X0UmimEwgYNIIOhBgYYJuQauyyxSRvKFyDQefuCZyUyp2INbPQEbL0yiLvU7D5uYsWDaS3jZa458WeCMuJD7ttalsEJAtZlDvS27299NS06Y+HEX5HvOvSyIgOIpJanfqk/LL7W6+vs1KtevDVnLurte9X3vLW8pEOi4UBVLhwHU1CCCVKYAiZBDrkBxFuQUSuplLHjT63EYUWAGpfFScXRLpfRwmR2LGCCMjWkMbgul/KSFgRpsT9/3mVxi1gC0GWW0iUu9G309aSikRXgnLPFqI5AD3GNQy0dQa5BUVSUHPxhUEioAleP+vl/Z7J+0FEf+1LlqxuE5Uhk0/dibjHw9QpjQLU/eMN36XLBumFay+kth/VnUp3e3n2GaZcn87a7X7hQvEPPr8lPecqbw/v9/Wff/fNf3X5a7//9v/uj6RCxOGkpN7L1amd/93/Q0tfb/p0qwkxEOgKhBlDcfUBuOYAHOyYiBp5phwYYNLIKMSNDMgwCl9QsITBQbMHgkztzzE5jMOggFAkwAEnCGQcLCYdBhiTcDAPMKAEZBAVAYGAAXBpikTioGOPGEw4ETAhZARHEhGudZoGVoBXYkTTDYKDDBCG6rLht42XGBAWSBtdUbhiJuk8TtRVlgu/GXebC02LJ/NNQuaHBNmgvqHQ5hQww3OQy1gEMvYASovyBb8cyxldqOR1DC1djLQ+dmYkz0VYRBf5I1j1yphLd2Kl+tlP16ly4/NLLKkxXu/SWPx1ulpt87nnb5h3H6vP5Zwy5rfMuZVL+vv83zDvb91zDSLON4U27ze/pwPtpbF2gxyhpllyzU1f6OE4pN5AFqNUEur2KTEVuNepInD+rGFIShOtKLsxDLJm6rMAN5lmDUK2YLi9rFUqp6Z9iZeaXnKH0uj267hUYiAltImmfcAyuqYGjkyOwjjciKZEg6IPVHSXysfMESLHi+Bg0YoyBmYuYE0HJmrKRY1P00BnUzFActMclBBMkjRaSZQHcmJ3QcdDeoZ8XIXjM1eknrrUk68wVs7a/WXo8enaFUSZq1Y77f///9fqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI42fDg5zLcqUp2NFnVF4iPaMQDnNNyvmuYsGc0bhZaeizZeAQKsCXVaOYghxoQNiEDpJIJgcJkG3iLAFMEH8mDk4qcteucAhcwWCzBYENtYIBioDF9JkwYA2uDQTBofJiqbpnJi0IGEQAkGYXDpicWEoYAgOEI9OwjQZCgCKw8R3OQII7GQw6QtUxoBjDw3IhqsOqCmhD9wkFAcv2iNHXSsQ9CVF10wQeSqk4cc/tMxJ2ESZdAsecHOUS2MunUYY4EC14w85VPex3ZG093YtEqWG2u0zd8MrzUr+Pe1m+G87rAFY88I527L627/blymj8nys4zEruZz28d5YY1Xyz1Xy1nqv3+crfhhjlzX1reqTuH2M8tXv5jrf6/vf/nf+9sIm5vOGeXCHZYPxb84Q9abhjDErTkf97jKAT2T3LGpXryGdg1TGZe36W427bRmSQdHHBdh/hYwYAqiyvhs0AWoyu5DGQs9YlhIY/K3qGpkRBgRLCKTbESMqIBosjHQ4WzHKJo3G2x0NmD5CccyRN3ICeGeAyi4c48fRcvGwdlNry2YGxw6K2WVo4kyGJHzhYW6KxuHDEZBNMixUdlpm5mJoVDqDooJVKdqN3QR9dBT/PNoYA5VNoss8Vlfq//pVjfh3UGRwAGCQcxMgAghgRi8EvWChsEAAMCLXH+aIYsHBMIUbVKUfGfgABFxGdHHxacKUBkgCgUGJkpRqLpAmFReacViRZgMICADsKAgAMJAEtOFCWbcOixhgHJKLpWUFgCAAwYAPJakwGCgMAVwMGYdF7zgJrGFwVDbwxyG7TcL0ghZk5Ti2Yg+9tjUPpcPdSSKmf9usgzvQ6tN+ovflEcLaOLTN3iNmXXr8Awq29nepKRavqpy2SARYM36skWrfP2cN/vVyxWtyeZnrdrWedNjex1lzLKl/mfcblfWt5b3ln/P53DHeu47/d3+/3WfOf+/1zu+cy//tLPa3uxaY2MhmiVMd/7v/XKWbO7K3W/fqu7PYSeI3qSAxFeNKSVvJ+L0OErLCLmv5DlqNwqQtPNMoT3Gm4eX/GoNuBwKk2gKOjSEOqbwNGCQI1T4mXuInYjES+x4yp2k85gFlDUXjeLeRGJlgIaMfKvs3OlgUMUyqBs0IhhPFVM1OD7Dpim90CYNlppjKsQ4uColUUGUkTMvGLJOQ4pokKeokip5ialAWCTJfWyVp5SLMqqyqC2ZJ7MpGn77KUpVVt1XVqrNnsbU8ew67HV9WvU/+m2hqHKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACOx8w4N8o3K6K4ixYzRuH/VXEA3zK8q3qeMFnU14UAaOzusUF4AEUfAADGaxQ+bNLIBIAA44HQc7SThi0tFAWToQYAwdRzEYFIQEOAo7EWTTy5X6WaAwKGQ4kcFw0YiRxtJ0iovIQIXrV8JJMwMG0fDExwOuDMt0YxCTqJclzVVDAwXCxJCEWjmRBSNOTV1xHQdARhYEx9g0XWJ6NxyzELhQT3kVSG6soC7J8BQEYGJidHAKFJ8c4dhHhiBjFQs8bwEQAoxMDoHCThg7jPkIXBqFBMc48pI3MysEIEBoATom4gDk2apnjznnNEy6RE3L5FEimyCB88lNTNNEmh6UsxRZkVuip0E0DVNI5M3qPLW6KKTvRs6Z5HrpoLTWg9d9SKkEmoopLtQR2sgnUuurWbo9Ao363XMdE9cTsAmJTtuQwxa5K08R9vGssmmZ/GsWodlsssc+ytCkWwa0KnTwRhj1HYb4WHQ0gRqg0rKCYlwtqZhvTdSQkeVddlRKObsgwEUvEhw8HDD6yN34nDr+hUeNTkjNDAvjOoEPAUqiTlorF1I+WA9YlmQSYc4qObSaOk+TAxS8N5GxVRTM03FuYQabuUyqpbqRIOFrZck87Hrp01VOuo36a0KSutB1J70VM+vfWyrU6jxop62q+78T3u1fcp/qS9r9MGRtZTG0gkEpldWaKEF0RYKRWLfsvbZpYMK7RHJUMEYHaSQAcoAapTnKdOEgABEIUASEppKXxgYOmEQQc5E5hQTsYAgEHAOCgyGBJKQw8yDYgBMADYFCtJeQMeg0wmADBJHBy3HBqtSNrnkkzZS+XIENxeAY5JYtDsAyNkhrdS59pfTTLlyp1HVi3JmXRmLVKS0tGCoVVaxHyQ2OZxafmpyPYSWQYutN3YAkGes4li3AmNwp7l6P3sfv633mNrVfUM/L8csb9fLmXPyu65rPve/3V653+1ys47QhpBu5qTIESCcTdPVNvNaE9Qg1lpPT6l///ulv2akl/6Dv9gAmazv013HOYEVC6Z6lqx6pjNIVXYA12GGnq6fY2KQlBExR4JZPPBLS3jexlW5MOCEAUhzGR48yTfIUrZoc46hSVCxgWPJFE0Q8dCQzBmSBUA5sH2aHD5SOkUWkB1EPTOgsvnAxCYpIJIjpQdTEBQUkMoXhZRPOXiuk6DkNKhkNJAzFdXd0EB9kSMyMXo7Okh9al1KdlX6luq2teZreUSgVtvd6y9K+j9f9ZC9n9QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAfcXcQDfMtyponIwWMyXqO9vQwN8y3KiCNjBYzlcnAXUztdNGiSh4hmYtlhDgyhbzW0JbaPQxowUSFuoiOFSsPUrVYCCyaCaBlw5ERMAoOZauUlBo0GjCpXOIiYEDsvSnqKANWlD4QAAxegBq6gkaAwEsYbdS5D0FDkw4GR5/jAdDgW7ygEFuc0pCSKAAvY+sN5TEOzDoM9Yyc4I0DXl8CPHFnLV7lT3bcyzCXSvc1NT8seBub/IJIJl1PMVcLfIBgfT22KbcC83zcxBS37lLK6Sk/t3uXca+sq8eynt2v3y7ar67j/dSCx93X4/+H5fr+6/DXNf/N/3D6+v2gFXe58ne/YHbsFJL/O99zXA21XXvM1vq8/wLfpUAn/rUlfPteUA3BQeZvZ4Ut26hJely6Z26JMCHV5ieBeVZLpOHJZLPr3aFbhQ8VaL6082hJJpmQlWsWPaZDqZR4siNpWJVQqG5PnSLsUSUA6EmT5eOGJmZlMogXknCkxcL6zEnieY9QdSRgYjaMkz4xp4UKyKJg9zhHmqRTRQMj+mmohonBzIxTatNte1patTqQS1JTNCgNOA4Zc5dKYd6bf9/+j/+lTFozSVdBwVKh0AcY2CANUEYYUmrIRBbhNEeIxKVU5lN15PaFgYIQWLCoxAZj1yLMfEswMDwgNlAlMAgIwACRIOGEI6UhIxQOa4OGjMDEYihkwIETP9pM1BMxEGRQnDQNL6uUQAUWIZgxaC0yMBAwaBzUkimIOY/yUYFBBkQKxGHovjelUGuY/B5YqncV0J1/bbOTXTpY9VhyqwJvcJZkrHhKY8tJzS3zcpbKqHVBav2JqUp5SmzD8hwxpJVXW2mf2YgOjot4Uluxc5yzYh29Yo6L7fN3bPN/lZ5cmcO1cf/VXK/nve8vw7rWsfsd/Luevxz/LD9d3z95b5z9a3/O97r9ZYc1rdwsGl5i0ntqiUNGv8IMIQjbjCzTRowgoAUq5YrxTLeIJmrFQ4Us5jlihK+goZPSK7ZSMiOQv55X1WtKG6z6RjNppR9i0rUWt0YEoWczYGBk4eMUSfBMwiccZmLiww+tuMZ24eRLeeplrKxU5ooOs3sdTNSkYxhzDdSU36mG3UqW8WvW2iVfoLPObuUMj1Yy3Jbf/3DBsChE7bxzz/XP/+45fnzVuVOiU4tg1bDgWcVDtknJXf+qz0f/SAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJI4PDA3zLcq3I2LFjOlwjWcUMDfMtyv2rooWdSbgaGywBwEiKw1liPYwJGb9xMxCEULqGGAK73GjrGzBhShSwisyYwYEhYNBYFgiLAFGmVwuRHIgBqfCaoEBAkFTCxZBXDEIUdguMDRSgjFAAYjExxoEiQWEiuIQUYcABQBF9swMWBIw0hgcxiAJpUTLCbTD4aVcDAUYxA16GYYlDJpI7jbMgM+ZiUBTNl/sHcBRr/bvU9uC3trSB430p5ZDyxXjCg7uUr9y2rP1aSo+uIQTasL5orH3Kd4hkdECNTUelV/PVFl+XP1hr68ov553p6pdn8+5/vkLwx3vHWt5Z/zncua1S4bw1rX53t49yx5jj3HXM8f/X61vWu/rPfOYdy/mXcMc/3+89Z6/v5b13v83ljrLvf1+G8v/X81V0JD9VHtExQBRWQVLsus1IDAnVCYBl8KsXq1wt7ZkdW9YaI10RCHueD8SIV/msw6+kYcGBXvY2PCRRCbmykbDdRegwUEmVu6wA5hcQrFml3/k7PMo/UpqYuZKKnMa2EfsVQMZdaUW7tSpk3ec7vXICyxt1HDpMJS1Djp2s+2uVMt5S67Fs/fS1v+5VWMMvsYzGH/r8P139f//cPJckpn2gVqhQkhFrTwAO1nd/6vcj/7F3/W7Lq+f+KCAFTEDhkMA0yTX70xMSDAEOX16IiU8VHAQYmIrK3/jLLhADRYUGGQaYJhRwsHGvSeVjUdAC0C/SBAxIEjQUuM+iAwMPwsAQuCi1ZgEBCILBQDgdjAUCMwAoUGjyq1hjwhAeMMo4SJ46BS771Oo9z7OKhsOgQzcAFPXG1j0DuxD7TZcYV8JsVcpTFYfGDJVCbdayn/B9O/GKVvJyHlJUQoRI56MMEvUVz26Q9KCzU5yC6fnaW1DQiLHrG9rOhFcq8/Yvb3VtYyurvb5azxr2e2Ms+1P1XpuY6/D98z5W5ercrXua3vP+1/3rHmP65nnX5+sP/9/zn5bzw/Hv4/ru9713697fFACWMCC+kbwwEFO2/iTQ79f/5AEyScf9/tX7McMChwXXfyfmdyuVjRJ6JVQ3ILT1fprpu0oXBhASeXXEotAiDxKBk7SBY67Cb0biRFhoZYFICeVd0WhHtDhVMCkAACOrqRxR4Ls23EwYPsxeNSfOkAc6AeQuItl5NE8oG9RvnkmkDMXRcfVM+LnWOA1MzQiKSLJGA8moqCKxvpKWxwmCPB3orMrOp07LZNS8q9S3M1o7udPqSXoOyls9FSz8oiwHDrjM5qUu+UO4p1Lclnt9iKWawAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACAReQ4Ncw3K66dihYzheHymDDg3x7cquJOLFnMl6clPaCEsyJDD7rJlnonhF0OFFmmRpTv8gsoGCl01FUj3o0M6IgGxcRNo4qUjLB8XM5KcoYEpATBU2CShooDAsQaGg6MA8ZAYqCzCwnOMHot4HBgVGJgwCsqf8WAxgYQGDVMHAgWCqI632AS5wWRR8IA5iUKwK4M3CqBnUMS1MoL2ikCTd2o9FoCril/luehy1jKYgt/CYqKsnC5cNTUGRvKiv2I8/G0dccoZo7uuXpG2N4YpdmqLLdi5zetbuY/Xxkev/Xf19/+/nyQczw3u9vm/t/nrues+Za7jz+ZZ53Pvh5VGD3O5HS7Ei+hsmPfVpa/0tf0M4BiDfHdfzvJMTXcAJYW7ZhiH9XZQGeTOcmBaaRTNJBqVjYIHlEplSfT2DBpt1n2iuFcsNWW71QQGWCZ9N5U8uRDiSaRxiwHmAbCYiH6YQBn5YMNE0pjkW3semlu2JlMQGIvTtS1v432PHQNTCXVL1JQiAkir3Mrj+Y9qbgHlfN4s3PtdpoXW+5vtP1s+Hu5e/uu5qNsilM3f7+F795/lrW+a1P9/8fx13DPf/nY9kmotEjDoTDZUmFDrqbFWodku+nQT7//1pe0sArCjgMrxUYiBDF8ZC4qghME3i2SOTXCqFTDgcdtOlucIXiRAUumYgoRNdzexlAQDDg0rfkyZaprJMhYFgIwgUHobLHMOCRIQwoiDehhBAaEgIISyq9OBU8MCgSMEpIx8Ai9ymzRKV8XabHAaUBh8HPDIZAsPFE9jneBtR6PlPdzZ2QASK6M4Q2Qd0jHVWjcTrW3ErVQXKlorzqjxa2Y60L47uvfWcyP12BzgPUmsxb1zuNmmaVxqPPn+tsZhV3i3gRdff393xJi2MUj23TF6axn7rb6/3nMyisVTa+fv3Fv5u8+AP6bk+hCcmmdnks0DVLtK2t5kwBNtPakUV7YgMKQvLKY3K4rep4IRpeKd+xD7mTzolB5wiMRYZFakgoBUBJdvLRE/klpNjIIHCbHBaCcmQkchSUMjsdKEuCA8d4ybHSCF+KMAKpGnkEzhNDkJkUA9obx84ZuyQbGPBso4iOfOmDk0bKPEBYlkJmYJWUYGxkLanIMeqqTKohpIHSfdB2f6qlLOdTHTRRIaOggiZEyg06LZYwXyL6n/R/V/029fKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAjRgUKDfJtywEjokGc6XCOKJQoN8m3KlqpixY1RekKEsKdPRHUMGHeWFNf7R0GfMwgGCBtQXNewWAxnIGoxI0UiwxIFg4Nq4FeMZuLZsUcmIw4jySgVYMLB0Chs4+fgKQwcGRoCKPIPgoxAwPmEqQHCkEi5p4CEIcdlbSEHu4QhYCk4aigYBUS5UmW6t9NlX7kmDA64D9UhiTY+yGkQGGCwwt6Iwui8IuRYZYNuMDciZKFZY8E+OYQUQVMDpBwwEZAGwE1KhVKKCSmIaLeRhwwccKbTZikNAA6Q6TJMyYkS6ZGLsiYol9FE3KhocMzVaKnZnScyJNlmyd0TqBfWikkZnHomzMmjOIoUqdnVnVu610brNKDsgpF2PoOYILrcyd0alNQW72qWu+ktadbJsovi9LCwJ3ffrSJczNyWCs+TQAwguPOXAF3OyxpC9uk1MW4eXWwowMjZWPRhusnYfLGdSDBmKUCT6K0wMHteHa2pMxtp8hh2FsgTLPawMWBJppgjClz5L4jDxyyiUcMeOmZHutjQw/XrmIlqfwo4puN5ggLF8Obtupa5ldm5dvrne6VbH529vucqgSYY99VuuPcN9zXwzSimJdvdX/z5//3PLuE7s6TPOakybIYxM8NBkmEBIfQKEUi/UwihrOp+8U2aaU9QSJU5HQs+49SO4UAodXg3h0zoYUMlkgaJt6sM1NdogHBgAIqKtPmmuJ6BcKA4Qmw0GbAAZmVHO0ChKoaq4GAYOAoDThhQihAoMAAtIowQH1EAUewTgjLgSMSide5gYBAY/R9dqixhIViEMGcgAHARCuNoiTKmsTcUYCIGUUONpHi8aFRx8EWA5QHQQcgxATQd5wCixZaJsUCZImSKJwh5BiDDiTC1kogVqQhdKYqZqmtRQG0ZiP2SE3GB5SJeImMcFrBEC+WT5YnVmRlRMUXNETxfc+ik6Rim7pLdEvTVbHEmYuKOpup0jlZrdCW0HSLqJ1lstO51lKrMKS0dnUutA8i6Jk5913qQ1VPSSQrdS7KUtarPegpBTqZSqFCtRoolMAUuwymMcs8zWd9ozD0zZy1KyYFceWpWmGRLCAVIiAngp502mX5LMvPi1Z2SIxcLACiJD7J2kYNKWbFqd1RNwDBY8lS2HMLpXNCgThRGfAxQU8YGKJ1RFT4tQDnw+C25fSRLoNAiSpkgOJAzUgQxI1SJBEf01LQRU7GRNrKFjB31GY1hmzxGFhnS2pUFdRvuimvsirQWtX688Hlij1sEVX3/+3Z/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BgAAAIDmLDA3zDcr0J2JFjWl4jpfUKDfMtyrkjYoWM6XJpzbvC2RRwu8t90gWdFyhgMKoNLWIKjgMqCgOMa2VZlSsEXPLCyJoi7hAfNPENaaD0vX0YHB4EQxiw5jgxEhYXOeFB4rCYcDjSZAJqQFAInyOjYwaFIEQ7MDMhgYSAZWZDBAUbefQ5SlY8HsMEIVHjA21FJ84jA8CYPqJ7ZrRwBfhzUpFGNTwo5feWTarRDOvery1WOYLkP7PzNi3RWOR6euuZZm2y45440FyNNBkNl6p+XXtV735/rDlazeqY9r5393/5Y3+Ficz1jey13LW8ufn//qrhZ/PP+/c1+N7u8Mecqfa1/lr0sPonjJHHjUk/Xc/0hVTJ9FRIu4hd9g0xnXQCj2s5TndqdF8PrH4jR44XEl1JUEAT0Vo16oCTFtQEkHySRkMr1o2w1hYQ4DQVGgcJjKwcCiREmJNznm4IG7cFDkct6SiyZSCQ48Jl7R41Syh8U5Qxk16ry3nMOlKZSaOGnDa5B+Fu+WzkNvHuT+8p5/CG7Fi5F9TF/W5/WOt6b7c7huI97vdaUypX2EepOXO81+v3/NfvO/3n/hnzuWe+fqzsaKpuDxgXExssx6FNfmNsc1hXd+7+A6NPT6W9VvaAOg0Gg4FZTBp2BiFAEwULDBRNxkKvHwC4cHlkyFeb/IAi64FCQ4HDKWgEYJBoRMIApAMnssKYCBwNSht8EDg7CDiAQWiQLDEdBZh8QmPtGNBUuO3xh0XFp+pokIFGjqDSeBmaYHDTENpVwwPAC2scKBseVbFn5ltZl0remnfQfdYnOtCf6LRaVCiCvaavV03SB6tykk8M1XTXJLRoZ2u3HNrbzqS6N6iecVZR/d3q2bY1z0WDIpRJpntDjZ+x+FetlTUt7P9373cLGPb9qtjjrfP19zufe491rOtllj3Hf81e5f7l3LPDDX44/+esd4YV8+fnzf6/PD7fO3McOa3vusfx1rf44c5zmP44Y8vOiMkFq08FxidY6nQBPzZ3E5/uWg10NN0t5Vt1Un8twjj3Oy0JsgRwKoGsQXhvu9LVkMKUxZ5Ss+Gn55UkOCG6UZ0oXFkQyXvEh3AsIRpxoSwV1ZNGJHnNV2FpoS3eP1pe+tNGjQCmpzkqtWqGiSRbPzmvj1THOvD2P5XMo5X7yWc7rGv+5Pe29H//6woX4sW7POd/uu4f/9537yoqoHjcLhosQWPFQlaGQ4ATdotzzt33YtR2Mp9in/UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAJDYbCg3yjcq6pyKFjVF6kxgEIDfNNyp4jYpWM6XBhqVmSKxgoIx1hCsJ2Z4IQ4wwFZypAiBarRCUMDSWZTF21aaVAYYOD5gwBGobiUGU2uBzDYQmEe6RBKYASAKxZgoNGLgKGARoRhICAIEGCwMY2ow8SwUNl2mKxCCAGz9NYVApisRmAzmRJ1D9tYcYC45QC5S15FUxAGGMy+fNiXJ8S4io2QRaw28i5GkRGgTRBgMOhJA6bFohg3CccmSwJoOoyI8a54AwOSJsxBzBE1Y2DglnEkhc5raUhyggAg2PE6QAbg0DQwWkgtNSExOKkk5itJyupaCbomCSdj6Js6rJpJl6rPqQeaomiClGjoOxhMq0UaSSrO9FTIopopsgtkVMpNNOtFXWkmyT2QQRRUqyZqo+61KWp6NJklMo8k6dkeAUJmdS2Q0274HTDMPVotP62i7OxOa3SOQr1uJRKAoIaKs4XPFrNtVRW6JS5n6A6Non0ohOtBeWCQInU/HIZS0O0jAh2pNiSEKTxdSLxiKHEjJ1lmbnB1F0pAtDNCmX6CRRAeIME6BiNdrmYyqKkiq5bMqBdutEjzFY2WKw5baVxqAwIREjSNXZbXU76Ga9GjUqeSrPtDag2SDJFqFizR6FJYv9CmY68b7dP6KvQmstQ2J/QIGv/CWNuaegYjgSCi9djLFPq0aBA2HkE98lXGtlASDiWYBGJhiyAAhGZy8YeAqIGAXAgYIjC0GNXjgxKJiggFUAmGwUAgoYnFxgo1Gzn6YWDocDyYAg4aAoljIFYgVRWIBQBE2HDFHSC2tDgGd8WAEywBHcMHrlPjPvpVwZXQvOdAehtSrrf6ZhxtTGEH0hMri+otFZBdgZg9as0lDasMkovKoBd7Ote+IMMpGsQxMLQ1rPLssUbpYdlUzO4Yfrdm/as59ncbeeOGHKlrmr3c7WrNqt+OHNZW6beW7FXLuGscMtXPzwu56+1zL89/a5hyrnn3XL2P81reeGsuY67h9nLdjfeZ6z13Vb9X8/7rmq3cN5c/HHf/VnXyLam5NwYg2IAAnflmUkiVvfAeKmjGM9Wr9Rfp5mZvWc0z3EOBAteDG1JMEg6WOGzxHGJy90RoiZSIZ+ARnenIHTlJg7+SFQIPbiot+xUDfnI/Uimd+AUMpfuz+GMG1qwsxu3Zdcz5BSZbe4b/lS/jrUetflPdjN7Hsnz735mxm+e84x//9yqtpkdy7V7rPn5d/mXf/9UeLFEqLlWhkvKFRLtvUu1swuf//41H/Z/0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACLuHwoN8o3KzCdiYY1NeI13LCA3zTcrio6JFjOVwoGHRaPkAMx1mUaG26KCMAdVQd42GN8MEYFBpVRu8ictiZiABGDCocsUJKDDeQgBIFTXTlU5AQCMUuYeUJEDQwKiw2Fg1GTCw/BRKPGgsw+FS4YcEjAAuFh+VAOwwwMFjFATJTKperGnRTK3K4cGfb9J1OqXxvEiY5pkMYShHAbeEGmkTFBlshpFBpA3EFyB3IIGI+TUnzcdIhMWifLocaYgREmRcIOLAS7uZlgfyMDV58vkXMFXTJ4ZgNgKp0UKQiaKJfUbJrZjB6jVa1tZdB00EpozqmymWpBTGSVM+gkk7pJLbNXdSnZI5UgylpoPOqWpE4pJ3QZN1skyrrsi/c+ukzIqWkyd1LWtToOmtBk2rp20TkNdTYEAAAFD0fr9oZ+3sbbTw7lUqVbabrzzMPTkDyQeINaMmjTQO6SXW7UPWJY09l0lhTIAwDLE63VJqjuSSIBYgUAqCkKos2iQUFyQQAFkFNS8LjHWSotAByxbGOmC0RuTIAuyBMlk1TOl8AgI9miKJkWT6DLI8vIKKiA3HqPKUtaRqiRFSiTrZkjgzwcc6CnpoutS7+iYd6qVlorQPVHQXOdEN9JRps6hO/11XT/dV6VfYqr0LCyIaB4DSeiDUEpTvjQDAbOR0LSQU0la2gKQBYANGVDK6AZAJgMBmJzMezD5i9PmHFSHDt2GVQcUAMzmtxoClYfV6YVAYAAbomABwCXicxJBCBAMLggGAEPGEgGFBCpaBh+NOcQI8WNYiEK5XlEIDqFAAeKYCAIYKAcvaXIHksQ+zfTuGs5rXcRq8Yhxk0cBL2UzktyqwxOzd2oqWfjsvFg/oBJTjYkNJjdydhynuXZOZrklnaa7yZT8LAF+qFhN+zE8cM7m7Wvt/y/T6rbwtb3f7/dcwpf1nzLm957sbxy7zLPCx3uf53t/vm/zv3+Yc/H9b5nvf5Y54b/88O9z3zu97yx/+XNNmbHFxTdKed2Y/COfhJIKDHKrJwCc+MxqVW6bK0Jnhz41du9xhxq9t/6eGqYumIxSdIgSAQg8I7SfFI6TSUuVH6Z6h4estAgKDsX7kMiJXpIwiuIgDAnKorro5M1kT4QVBEplTwBjjs2b9nmcG4XDMJo39ypKfdKOnVM/z0+GP1Kr7XMKl75Xax7vuf5VJBNRfHshy/V3eUlga7QUH7/m+b3//3XPs+sNjREtoNlDiUHjMRuLpFZR5wu5ZalMVFFf2PRUpSrKnWKrd3TYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAhFYcKDXNNyuSnIgGNTXiReIwgNco3K8SsiBY1BuEB7sL9S8QHwzNCMgdnCgJRAQmLDsEgeCTAoLIgaxhiF9IFRwwAEjDKdORkIwgYzjIQCAEHCBRxSgWCRNTB4ChgMDAQGA4MHgXARhAcgSFjWOKgcbUIB6HMBAErBkBgoQGaBUYcK40qxwFrg06qEubYTFUtR4UvhNTj2zF9tZE9Bk7jQ2pySUzETbgYIsrXlYwwcOZoa0TVizqSlLybWdA1Wkgepz+TLBa6G+ftPkGGeq22pBxaX6feFWZzV/H+5Y4au1dy7HKrnu/3uOuc/+8qY4bx3veGOH81a1lnyzd/X56w5+9Y7yx/78JF856rME19ShpSWoT+UxBubqj0slNObhSQt99tM0LNwiUimYxawg0yEjUZm5qv3JDpPXZFdV5SiIAOmzKAgqPG8qljXn5nI2hMGg4yLjDZUcqdFcqmigo4daBAqQJhD0xBlZtyANIrqTfGTMCVHUOWS8gwGc4qRFTYvomJYnwOKmIYigmfIsAa0aJs59ZTMGM0BcJw1ZBSJoti9PtLxRKpOIsOcrZ0iKh2C0bsaqRWf2paeb1LS9lVqWfvS0uhrECixidYOtTFkI6BuxKFso7+xcpcx2LH0rToWmugvOpCBEqBU+b/gkyXNbVnTXqaXAQetSQzShfJPp2iECmBZqY5HiahiQyGGAejQX5JAgAQyNbIxSDwgUmAgkIQIYjBKbhikCCTVNrgQwkGUVigDAEHgIOiMBGAgMECgyKYTCACInGYPAiTLpDoGU0oHOZ8swRBt5rDoEFLDBziAjhAF3irG8MwmQIZQfInImC/NFjIHzMrjrDSFFwlAwakIQl0uESIYbGqzgz4r5Pg2OOWhzSceYSVEKi4jAoFwekSdQNzCgmyR0vLRKqBkmtJClUZH0ZWRTSLqCRsYHj6lrnZ08imtBE4gpPY8maol+pdnPbLMXSemik01Uta0zZal1pdFFbLoLQVc2QQrNqjVlIKUpJSaSTUmRRpbTd5IiATFZmzHLO7rZAsWff6/evcvN89nKakct3ioLCwcigjBk4bdWx1Hzl11aYkAJCazHRFhF0tIk2TEG5SF+VsjxR+ZescOmEg8mBIkQNGZiPvBMwCOBAuMh/HReTWsuj+AJoEVPOZHSKhUFuM2ZZIqOF04V3PSqmx1ayqp1LSHeibqcnU1LSoMKVY6TZpPrSO1qXsqhWknf110NS0bLoLSY1OKGgBDRMdHDjbim+zTNqbTZhQEPGii017ebakwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI1H7CA3zTcrzLKHBjU24ilgcIDXKNysCf4gGN6XBgL4KPyZaLsMmL6HZE7TxwEXUneul03YMFCRb/VGIi6zPzAoAMD1czkBAwfmgCmNBNElHEIARggCmnCoYSDA8EUjEfXsVyYpDBUzhhMCCwjEQOEIBHSjZKCiYECwoFzIpsEYyCFUkiwGgTLaGvNsFwtQYlFDHpTF4rELLIY1LjTXlJN7QRl1MXcSXktik+lgaSzFHQr/yltCGArTGK+E7EZzlJQYr2uONSW3Dlc/h+FeKhxSiuPVbt9zlWX2q+XPyt4y/LWNqmqZfhvLC/ycwy+xvLPPdStrHGmvc+32ky7jqve/vPx5/2NWO93zWdr7GO9aw/8q2vt6xvd5vLDLWX5673WGO8Od5rmvw///8/t/CbhhxFpwZf1Ee4Eu34zKO3obCbYx35rPCnQ97ALnVWlTJgQxVBmoAhiQ+7ZDWDErJdAKGQKDjAsiAtELozoVCkLmBW0fF/BUKnCn00tG4Rh2Eiw4EirlJKnWm5lqDzAMq+V6PJGLmJwpgJsLIUiZF04WQMdCWY8ixbqOlMiSSKSKY6CaSMkkVOeUXECotIdS3RVMlFxayHulOs73rd9H2b+otNepqSmapZqmgeqM0TYoxSzhcTmnqRdPPcgtFUaZFmxFBNgyabZCU1qQIOQWsQLnD8s4DZ8LBWVvO3z5Ew6asulfkNLldwHCUL28KC0LCMSo5hUHDgAXUFgWFioaYHZgIImDgiYaCaOxeECCgdCps+XgoUhw4HAMLAswYNTC4CQVEYWMEAA10MwQKgw5AgAO1G09UYocZMsRmBlwEsc2xQqEygKSG0RgG1Uh8JuQ0nSQJguBZweiqXk48HEjFFFE0I0LWDot7mCA6jp1BaloidTVIWErJumovheANouUxylmpibLU5opCbugUEFIM503Qm5lSdI1WpFFM8cQRYxQYwSOrT6qkWSdbIJzyzRJmepBlMpnWtTVuk1N2ZbooIIpoKQUl6Smdk6nWmep01qfQWegpUVhT0s6UlD7+TcjjfLrdQ5lB8jvWeaYBT08t21CXhACKhoQWAUSAYioK7T/xOGEuVNE3UsIaFguA0rDCBiFP3VnWWp1vNDqpxZ0+6URVKvnRQHIIeqSleYLBr2rV85Re+wvELj4pjytrtQqD6LW+7pM9fm4tbKkosXD/8rffzyxmcrmvku+/vWEGwJrVW30SMwohgayOo+cIRZJ4ktyCTFkVMlR6knX9TSNqoXU1s+1qK6vd76BUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACK6KQgNcm3DDKuhwP1NuIgYhCA3ubcrcKmIFjdF4SDvJpJTMSkanIhQnfgKwIKLDOishk7HTDwRpk/4pCVLiEBGGwmYwlJqELmJA0YdKBg4MqHhwALxFg1GZQaLBsMAJgoAEgEQ6mAxwYFDps59K7KCIBQSXSJBUCQkTA4Ch9DkbBEJIXAcQiEGxVaWnujzRI+qiBkW9cUj5MF9QoUWQWAFeEqRIejAwIqZB7ZOFxM640iYJgsoE4maqDFZfFIjsMkyWTMCwT5sQpeJdRmMsW0TjpFkO8C8isUSJF1A8tB1myFJaKFFBE8pS3Zb6RkbpLR0TYuLTZFNjFRkenFoI3W6J5NOyNI8mkipKtG9VkU70zVSaCdVVcyZO7d0KaCNVFTLstJBFNaa1etlmS3Qd01HGNaUmhb26nhwSAACF20w25lbrau7Ndm0oopgoLA16RABCXJJYQKnmhUCjScKBcFpQrzEhT6o3GPLxFz26VBgAoO4iMjITXCBgSUA0JjFoFdnGW8mQoONosWbNSc1TKJTLpRAuQQTMTJI2LJOh0A2jV1KLZq6nGEkzpxcBdc3LFjqRMDuQPooDqU7rUxDQ3gwMjArqWk6nVV3vfTWlupS0T/36FFB0prBHPjiAIsYOSgVSBitqAo2VWtjdTZFwhQxDdHWm1lLchoFhlTImE4cW8IhE4oKV82srYM2szDpjpBLUEakYzD60RCYHAZRyYQYGUHWCphgem26YcGgBqFv4yIRLlAZ5KoAAAAw9HMkjD2JkOKAEGmGAbKQYrGMFj0AY8IRE0ZwJXhHAUC2p0S5NSaJMqVQERA/D3N+TxQJUhxARrgcxECNyJjNkwbC0BhYgZRN1mYypUJ0c9x3IkymJuUH8J0wHQRFTFhIiJisZNzUeSXSRpmgYvBFpAjDEuGBVosZppImzuXE1Gq1LUo3NWaeSUk1Rip1J2Mzx5N1pIprUzJVKWo8tz9NFk3QOVO90lqVRrUhWo+tNJaTo9Tzla0Z1VLZSN1JJ0qq2s1VVqCSZ5Qw35QCc/GVcpdXoMHr0Vq3el/5MUuWbNRoVRbpgQuGA4OBDlSKCoYY5ZUawVSbA9q+VQPoFxMwEChbvP1AQ4HMlqqVsaGBdiJQNqzHSubJlYvEED3wMovJxMrymgYGSQGFIHx3mjJl4yDZiRUuoiqRsYLIIixsaIDJGyDGqlVGZOMNVzyKF6lGQtp5IoPSUlqdTqey+uuutBSNBta6k1TBM2QBZ5CXKSiKR6G6idJ0Xct1XTd1tzuxfkgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74mAAAAipb8GDXMtyvynYcD9aXiDCEQgNck3K3B/hwYzpcEBzPC6lGiOu2MiBwehiyMrHoHPMkVFGnGNA+1BCe7801x0UkzSOCMdAgdJ4JDpcwBAhaQOA5ghkGUwkYrCiSRgICkAgARMMUBQwuzDmopMAhVmIQGnEGgUBiAtAxGByAHGQj2YLGxWMGFs3aG40hdeLO0WYAA3T4Uwh6Mx5/2ey1dJkXsnl9R+YZygYDMQJXzqzTxRqIU+crvU1xdthl/aWGnfp/mY9KLEy6su2mlY7cuXvQLYFCHwq9y73O/+WOtXMKvxWthO3dVM8+V8csOZcyrcwxr5b7hSbrVscuZ/zur2N7PmfcsO9zy7e5h/dY/lyrzL8MsNfnretZ4/nf1au8L86J2ukhzNKd8HrJIR6GAIBt30pm1sSbxa40wEaZNOPeZ6VH2GHOqsAiI0DMA6XMOJDjFC4LiqI0ZAGiCQqyJNcKBE+HCRpQzCNPZBg6WSYdtlCi5syCCYaVJgvlCJ2iqv5JUfTjiG+paOtVr09mKggrDtNO3q+qYqDZzDWeMFV7mOEE53MMdrA2O1pP379yXx/TPssqC9l3Wuxxm97cAa5lrvN/+v1r8LOHf/XOf//3+2ehlbRwheSiZgoBlRekJEZk1vHbdM2zruauNZq3pxVWpcCUTdVmPy/8OiNUeESu1HxOqbct6GvhB6k5YALmxx6WjhAaMs2kw8AQoHzJ4pgFCUnqYFAhgNYAYeCw5CgYSyLtPMYlBpgpTAs7AAApjiQ5dkZNIUEqDYOCwVApqMSOyTFBXD9v4XVd+UUqpooYfDyrZqQHTcxIYSo1QQIGVOmSDHBWoANmRobFsyFIlY8aGY3y4fRDtE2KFJFJIvGRw+Xyw6Is5GREnE0nOmJAQdBECaKqlouddJS9qKaaK2rQU7spRspq0lLXWbLdO7uzu61GB9dBaFronVF6tnUo6gmyW2lUitqOmybXSdJnWp2UYH2RQSU9aa2TWletGpkDk0RjV8raaoU4hGpfbz4wkihLonO18t1VNLbwclUJurEA46JhrhidCFT9SfIvs3qOUup1ZFhX4MUMeph6afP0rlmQterKQ8YX8GlayHX2wPGJ1YuhODqDauhfrxzCxVyJQVrDeGeoqo52zv7sTwwr4w1rDtJkwi7rGpexyrcl3W64Z3bHcvypK7Nr261jQjHrE5qHRUuGVOeLB8+RFHjnhAmfQGyIYOLcg6aC7FsOUNHdpxinedZTlWspdPMoaUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JgAAAI/YZBg3ybcrjp2HBjM14k7icEDXMtwtgfocT85XBiqAR6EWlGwUAJQmBh5yYI1wMAleOFD1RW0yAEHIU7WGij5q5MOAM3pNDCIQMEAoySLCIBgoCiMFhcAmaTSBkKYtAZVFg0PhYEmGwyEGYx5VDbYyIikKhImFCHxg4pgoxEoRR8L6mphYYGEQ8TSgIQO/iK0NprtvGyzwgArjyGKGBZNjMT2QUB3BShkTRmQQiRqHCIsi7FsSAnD5sQ0SWXiPEAEQ4pA2PCimpNGJ5AljUMurUOUVWTTPKC/ALFJ0fyCGKaaBs5odTXM1IJm6aKjqdF1JoJrSTU6TqUYoIGRQSYzMTijZB2TetFSCaRsnQSST1POMtJk3Up72em6SmWyyZZBJFzNln3Q3SdBCtPd1tY9RWmupFFB1KmC9r5KTPHBcFwRJMZe3AajnZrzmOEeZ7g3ST3GbW0GToHawI1zPHe9yXdpxkWBEoXjnnCHm39EUKQLqvXC4Ziq927SlWQ1WyxAVqlnkxlxQjkwXDYTaBzeRY6V6JosrECCy0gp9Cbl4hwnokEmNDw6Dxw6bF1dIunRz6ikZzRRqseUxjrLQWpTIFkTgjc86C0kKSt1tSXUut1W6zZyZIKi4lSg65YCsJrOLt52/h4q3S1x6h3gFr7CbKKCh2yhSKkGSLnBQVdjBxWqbEYIAAOOOG6KsKwpICAIIWCJ6p+uU8q2jKoiN9ydWoQhAxkFkKk2REBRoBmnDyYBB5gIMBcFA4rMSMUi0AgIzDwDHQgCgBEQSYiYTC7whwzEYvZiIhIYZNZiMWCyZDgkwhZ40ImmJWLFmmUgoIUkXdifn6eYdiATNhf2MwJuw1iZSYeWD8Ldl34ZxqzTL8ty9Y9Zr8Kl9dy7kt3OzL/0yjndsJosvv280Pi5daDZmvN55T9LlrnMdW6arIOY53rueHN95+VS/jnYx33lLd1lTa/VnC5372P5fjy1fy3rWq2GsLXM+YduYY2Mu/n/8/LWWXd6w/WX3P39PrfN454973nPwuVMuVMsta7VxrY9z5j+O+9sZVceasbvSIBDOSTGqGJm0KYnW9Vufb/adM6nbFAmM1SiwQHWvMpFt5uqyeRoAXvKB3rtqyhBUrHTXz7E6zMBRBey+oYTvNFgg0ImkQXLlM1Dkpl8jWIY6kvyt9jtWpS6X9B9NM4fUpkQa/48rQHlWs/GsbuqnxXvc4X+etYUu3Bw5JbfOZ57gpLCxyh4aahmKHUAMAGQfKCyRMERYDiiwkSGiNZoeAHiGA3Ja4F2mdqqXduTDjm03pfP9PTGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viYAAACQ+CQQNcw3KiR+iBPzlcJCYnBA3zTcqMqiIY/LV4Q6qrkw0gDFBMaGrQEVM6QJaQGCF9ks7TCkfx5VucvlTJkCD4WDhjIxmLYwDQyYRBhmoOsdhJgYDoDzUaQQniILkIzIg+nKYcEYNGpsm0mPgC1QLgYrAxhIKBYTCQ6MMBdM4dDZoEqGBSqPHlFRINmgqA36SThPgABquf6Rz8obxnsPuHHj1sIXFnBoYm06CzGmHsIe5ffyMX9bntSqOs+o2Y01m66VBzfaJ1rjp53M7eOWs8oMItdnZXUvV5dWys59/LmdLWzw/PL8K2OdTGp2rq7vdTK3h9JSdyw3vLuFrv5dz/W+Z2eWd2r13uf5d1vueuZ6539a3V33WFy5zDmf/vLLDDPdzmO+b73eW72GfN81yvhrn45c1WCuqdJwp0xzIBMizHSbZPkgQb9XNrqfuOuJjBUhxfiGBYk4AHdQ4CqEasTkHpDSMaEgG0rKXYlACIc+9O23THTmcPdewDVSCqw/kPMzxpYVK5U2ISFf23u5dzzpsUrJ+9lqv2lXlPY/vCUZ2cduzz+TtSGu/Vw/PPlBJ9UHd7v4/vDOPP/e+r96a6ntFCzmTBCkwJ0CI4w42g+xLHoaKUlPrS79Seqztvd/QWeWNJk9FJDwi44WHw0gUWHgxbD5MqrDIhMFgZh7I0mW40pf8UIh7g0ixoKorMbi8OD5ZJDwLgo24IQEDQIHjEAQDhUp4xsM0DjoDiGgcNB8CiFEEGgMwCNC9QFFjNmWhmQMLB8eABUCC7B0CIgR1ECbZgtNKYvFKoxOQzL4dpHgMXKVxDc9T2YrISqYrahO7rK6LGzefyX15asWcY1T5SWKz26e/dfK4zCvTx2ev59r0FRYTOCOVO25+nz+kzytfew7Yysb5r97zlWGuc3nar6xs41NY7w3+GH93rXcafvNc33HLu//DWPNXMrve4449yvZY1Mc983hvDX91zWOP6xz3+9d/DDdrOtl25zeG+95vK9vLPeee8K/Oc7l2lzv5EBAAABDjRvlYH2moEvifNerqkXDhNPJKr0bRqHBZ1Q4iJX47euKaWUB70yx9CZ2TDT1mwzyxQIBx4RlNK8QKzFZhIhmxoaiHMxarIYYwWZs62Mi8cLpmABULUxZKoyJjOkzFOktQwybOboE9bSMgmhKjjO1A/zqjIIZ0a/60vvWp1KUm16zBGmitnZk0jJYJ0YwtCsJN7GGe+G7Wb929vu97/fQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdWfkIDO6Ny2Kw4UGtPblmJBQoM7yuLJqBhgZ3lcY6q5q6/qzrVm4EdrxQ28ONH6UpEWYy1sTgtkVtAkcdKhhUAAQmX/WjLhYWJBI10xbmGDoQLqxgUWJAkGkBn8Kn8mGnBmlkFB8ODGBvYtIHOYFLiaEzZqvccALqRcMvISAJWHS+LUJeLhUJcbw5oGEbjdLxDSLliM+A4WbnGWkOxzpmYDMl0srHcgUK0y+VSytRfOsNM9F8VlKY1lUmzU5UgaJqRamy3dk01LamqzrWg7pKpspSSSCTO6K1oLd3U7dalIKoMu9BBbupmo3VetSNq2etBbPU7rTqdBWy7aqSp3YiLTjNV3N/gJ+2DNCbdk8ifqGkdBsy0RsKwsbceoWBo0Iry2GmUq8XiVbxmXaMimgzGQ2ed5iUMcMPCxEXKw5EKQHFYYGojn70QkNx4RJwwkMsFbiyr+jow2LcgPjyNaWCj7E4FZ7elSdYsZgblir1gYlQriTIFij2u1QlUgbza7DesWqCpCfk3s3yTZ3AvGhVz0Kp5InteSckA8YjdE/kvPr6/1e3+aV1jX+s3r7a1//97+Matuvr8W3vHxb1+7fftn2vFoQhQvs9DuXuTrxvV/W94+3KpTRaLqj7u37L1f/9zE7GYJicomRgApJbtFpO7MhiUQKxSMt3nLNdshi5Gf6GIHFuAclphuClSDRE10ATHHgoODZChsZ6GGGlp3JIJB0whc1SFBc1DcWKlDPzGQMOknoaa/zqMTirDI5cJAQgOfvRuzldpPnRDIzbs33CrLUQq1/OfzgfPneQfuzt8qsvt5V41lZ/8YXTzmWMQw/D/3Eoxzl7uvpeb1O7gyp9HsVcmdUm4qM77fPK49m27+tkYCdexlG7E7iPu09OBW+6Wye7/ve/bPiKPtzDUgabLW6z0PTIwcUwMydaLuzOw0omUFE7EWrvyveOmBjxGvtyMRCzOA9sz+JUioSAnpeYFDggNXuw4GhBhJieKJBgNNCQkrM1MvkzUmugJJc3ahDGPXz7utOYbLp6c28JwgyjGzKbkxBt6WLVfu7q/ldyUNv/vPVzmd/c7r7scxr2e9xvVvvRyxXcG/q/ez/8M3SV33cs7j9kdjTozJZp2up9aFcX1x9X26I+zfNf1B9V7d/1HcgzNO9++vtH3ea99zX+2ud/H0nRnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAGjkdCAzvS4ukruEBncW5dtakGDO5tyzEgIUGd6XF/HUT4gqHWuTRIcTkUTAH4mrEVUMHiW60WUTMEMFMNbTywRJtHADBiQbOUGhGnmThyzAgUGQlOgZD1jDNCYeKKVOOlAthz0kQ4fLntTIM8dBlkWgrBSN5EC9LHylCRJcKnoZ+tdlUrmYbCh1++yevT0z6Lue2zuXYvJhe/GEU9/GT5yWpvOQbntd7b+zn1/qLl3PmcOPDdz5lbxw7+ud7n++6s4+8Oja/V1HC4q1FqGzs1zkP8+7VtVW+6SzXNnoP3z/x8bpjyerAhJhz/lx9z5GmGUjJYU+DSIsOUFOLmKGOpGpM3rASZJvy2Co+qJ3SqZnlhiw5CLnCo4GL1KS2QjRyYTYoBjklC0uldhUJEOGYyMFpl5iwgi4TARggMFgcOJpenQboFmCD41BkAesuVNihURfy0FgYGiyub0mNCMKRcLxgA+CDCfLk3RLgYMHcWjFbmjHTqA70lSGniaM6RNoGqpkYl4RB1jOtUy0Bqhzi+USgepmyS1qQZklLTqZklJLaeZlT/Zb0Voqd2PKTSM2WipjyaZ4wmJLpU1nntfitVZOTuVFRY4W1b76zMNR+5zQZ6Chd6NW6P9T6x3hnGrPLWKqhOgjsvNmcUkUqHAIoJZxuqn4YbSuYtnnggyW40FmPg6J71l6Sq4g4/dgDCZQdF2EOYGWBXPAzKDAOAAgFURdIQBwFBXVpFphlMKFZdB2G6wlYRtkjKB2GWoEXFl8UKBcImWCZKYAvCmZEtqNQBClRReWkN8xPmhsfQNzEcBeFYL5sbk6xsbIl0aLEGRMBXTSgtRmTYdMbnUWKq2ZNbs60Ki4X2UyaR1JkWUk6CVE/siy0a2UhXRWjTpUUEUFH6nQTWhdT01LqRUmhP9oZ+MrgPYntkk/Db0PNdoTYUic5hGBGW6Lb5+2Y0jaNrUKjxSgMgJ2qL1K/YqVi0ommbUr+OyMnIDKrIiADYzwmBmcLClQ/Zs+wYdDw+mEpWhsDb8FHooBt0DhFEdbSAMwxlA+A2BHXMiIoTVn+SPuR6WxLGymMZQO/M/S2NTXbNVAOv2NWL/7qtGimu1+S7lrHsUy/kPT0vtZZ1KmruNNPaZHe1Uv/z8tMbjnbtbHC7XoVrV2X7Vtvk+JBvc1gmytBEw6nz9pp9S7YnF8t23kHu6EngWSd/9Z7YpJql/Zt93vVDs5QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHZ3PBgzujcuhtqEBncm5dQXEGDG6Ny1cp4UGdxXlo1K5TU5SwSWjpRSS4UKkMZ3aZETEscetk09bTrBquUtSDpCBtCLXZqVmBLZnIWowDgEHEQ0MiACMqAwpgmRgaYDXBoJIAFsYJMgsIxSkWBNaGB1HVpXC4MMITnMS3tTj9lYrHZRSm5QHSN8+OWAsvDY1DfMTQV8mQLByFJ2ZrFwlOcNSw7okPRIEVjNR8sLOHSNJdMlXN0j7Ox0vj7Flkys3TTMzQ0TSNEEq3plZNOtBa0klKQpugkrZFq0kGXrtRqrd6JrRRZTUGZ0VLpKVSpo6FF3TQUpjruvrPN+CTQMZp+xL5Gt8p9d76zyTD7zBmbpgwJoRtE8rhSqlpatOMgYsY00TdKClirfByIJjy+SAUMyEXJqoAwobkx2rQCkUIH1Y10kxQCNEOa12JyExADANRUwUVMcESYPXYVA8gRhUmDkJaylsUYHZeN96RN1i0rn6UnVGBFzxLABCT6kzFkz4TkZsnXeP5qovsUM6aqKq1Jl8vrN2Pm6AhIbLI03TTRSNxaRGhOGhmdXZC6SCL1JrTWtFFVS01NegyFBaCFJJIyQZWtSLIuy1rPOpA3spnQRZa0GUzKQXZaSlVu59VJtf27dsS+v8SXrO1RTFyyitj+ffe3bllO3jYG6wlW4n64CsUJmojUEYCNCN2098KdNVA3C0N1CkrEiDOypC5BlIYx5EMjBE8zBRUwkWEiEqhBMFmwLxmYwNGLGkIEESjoFCDEB5vobUSMbQxlvEhN1FwS9Q9oKW0Ou8ygw4OX7fxmBTIqXCBAYaMMseNVlwgBYBsGE+qtxxGZ+iaqPmJBkBXyoyaBOlFE0LhYNB8JpD5N1rWpY6RZhskbus2TTdbXUs67FpJjd1+q7GrOhdmUgmk6Dp1Mii1TrRY5EnSLmFL6vyAAgGsjLiCwZok8yO7De/0fDon0pzQa/nwlkfpU1KWOyN7IBexGYpMbgqJ5J6BchkXHgGlkrZ3vXWtowyWMxAmQobCEMeJZaGxhgkTE7vGJh4YB11ZBokNYWA5bJhFbQ8EBUCUbHSkwYkh6A1bDRiERBhMPpehlwhRcpAiSNSOD2wqSqXkDEvldErkOAfiJHSstki6GBDdBzqBdTMEECmqoxLAxxbebHlppNURdpQP1pzc8N1ZxcwZrmKafqZbqsqtFFVNmZmqppoIOdR/FJKo/V5p1Puet2Ovjs2Y+bPmdVvWo/JzXuq8X3Bo56++Z++j1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3pswYMco3LsLggwZ3FuXTF7BAzujctjKmEBneF5vpIsNXe3Z9JEKnI4zDuNMlkeiZCHXFwaok07kQJAYZLhxiAFBACC4OIkSg6kqpgYrLxeSCAMJAKHkoWDAoNGhSsKAlPsLgFyBIEpOgEYmBwi4GkGTDo2BhLHie6kbhK8XvYjKadfZggTtdpap8sksKSIiNcDLrRwk0eKx8hCTEE3RTMjMZkkknWTRsYmA7YrQipvKyR5zUfiESHNQOi8Ky1pOpAONNCwZLMEjBNI8ZpMm9FZmii6tq3RRrZBJabMp7op2W1nWzUGY9bRVZWggfd3SPbPZJaT6R9vt21bsPHOZOfz/5WJ4h/WW5X8dGYDA1IsNXezJiE8ITx+mSO4rBDjhNzGC1a/IDoGmQwkoZfgGeARd9wDGgktA4avTGURJiBzEgxNd5hGHJXnTvAVICYfBIanwHFqBYXNTKSuKXlGgd/hU+KBJKku/KiAAfZcs1ExkHBynNXbhRWYKIiKeBHkBJ86bScJIRuNg+k5iTxeQeOVMUysdDizCmasy2IeeUSCBgXnOoXSHLEDnziCjY6bGia0XQQXU61rQQQTNU2TQqe6ulZBNrscZaB5nVQSN1I1JMiYooKQPOlSS1rpJuulq6EwqY41cZwrDkLrbWqiCXaMQ6nZy9Ubiq3aGneQdsxa2M3jxspfWhvvLD4MCUo4wqhD+LuCgeb/TmnA5eIcCTIx1oijaX4IhyqFkwAAgYdNFwtzMgDjpnUREQcBhASu4vm5IENwSEKaSNNw3AfMAJxqbEYGkBCkGJtQKHY+iAZSLLjnaii6NMZ1InQN0CFLkykcGeKpIibDqlF0shqRqX5WNTM2SIVIQmIkmxeU6mQMTYc5JIfak0FqLQfgOQiZqrOmpgtBeg7rUXlIpbspdJJSrnHdmVdkEEkH60kVVu1mSTOyX8B8O2aj7ptXE91NzNFFT/Rk8+86Qf/PNdIwV1frusshb3KR+VSMR4jzs60mCbz5S9QgoA5BQs3n3tQ9NDpwwxbORAhkICqFPdmw4gw4yx+l4W22EYQcoxmCAIcDiQStpHNoAjPTARJfzvCoGZoXECEgSSOGjPyu93V7VIm2hgZAta9EZqvS2X9UwbaI/cz5KUVaLmGeUc3V1hAtnmNJ7DLv5V8Obxs2uVsOwRez13/jrib+xudx3lzmHd833vOZ/rmt471//++97nvuPf3num2RHtJYkpmSl+o5VdLUXZc5yWhBq28Xf1derhH23WYSK9dzisc77UgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcPXcGDO6Ny6M+4MGtvblzNhwQMbo3LRSvhAY29uadYdr8B3X1uikqu25s1g2PSuCAoLMGyWCa11IpK47BvHjeMpEGZhjPSQDjIjWKWEtIGSRiYqAgYdO5Bkw1/hwNIhoGRmMINFjwLOvAbGBipCRTYoDqwyxdUzGY1DA6ACzg1GxGCusigpxdFqA0IQW01NCuT6YzQoQeC2jRFrKhfScn1JycWH9PImI8mDrOFImki6ggMYp0l0R9CdywdUWbITBVNSZmZMyFZ91poumuzpn3WzUDR112XZNbtUptqR5fjyotUNyD3GeeCPVtxxd+htb/T4/A/36do68uIQTlb/yDitbc6RxOK3hSCresGxVsbpQW9Q4XO1Vlc7HHCYMc0DDxmoo6QADmbIYs7FDqFt4WWRmbYVFRoBPjAgCTFAEHET0CQ0MgAwbgoJg6bCgIY0mg00FjCH9PMoDL2gRFujlkILZpsIL5ibIaOFWqYD3wfHAhRI9J3yuWGXMptxX0NjeFc+1ilsutVSlVfPrb37zqjKGRdj1LB+s+ku/uvxWb5vm1a6l38fFM7x9a98z41rE9L/Go0euLTUzX+nzvVs/5rvfxjP/+95zT1vil86znP/9dbvX+tMZ+fvdc7+I+b9kEk8j9dEYn30kZCk8F0OjEIwXFKPR+ktU1DFAcFKgvrKZzdR4gM8/If9roAGC46/EBIMDDTD8KCitAgARkSUkGAhgbGYYYGGFydgsWL4KwFeIhckfIQ3RN00wuMACSjKFA1p7epS07lVHlaoYOG16esRiJgJvSJADPMRG5EjAsDMHSXDvlowUtIZw2PnpLGySjpWDkDUvGSepApGpw+6iBoOpZiaEmIJHTV0UHXdIzTepIxQOqRuyq9NFaCd5u70q1KZTqRp3TXSRqUiijoIqc/IqbqOR+rfkuM6/xVat2hUILfxodgjkgyWRhP6SXzdl/2oWXJnsgQEm/BsogKfpaIIC1aLdZNanjDgnFmTXV9RIEBbG4q3IyAZWAagYMBt2VrQsMOVTADhAQtAoJFDCsBLcmEFSNasDZFsmsjDFxY8HQNs78MajTf6eKkBQRA9NbwxxHtG0FL4FPakIuNMY+V/F3/WKVgsUcts1fW+bfL3Kc/ZYl41sRjsF7Vv/zrVdwt197YzndvbUlMaxndN/Vs5z/7RNWtrfrSWrqccAclk2VVljoMvl7km3vml9//efN1gCOxh1D2PjwMkdmt7UyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHNoDBAxujcu3QGCBnb25ahXMGDG6Ny1grIMGdvblgLLYq3JpcbriDySVVecPSqkgsRD9X5IzKROIKAB9EmTEMoCo8FAZpCbiFxW+iQOTBCmSHzHgEHGHopOQGRkKqS8SUIiKQQNSisuYfBSbwBRTAEQey5yfb6BY1EXolQIAiQoZnjcJYfJkTA5QtABMxM+ZDqGRUXBeEimXS4oVubnTZiLGjMcMhbz6pxRspIySM2QTIotGktxdh7h5aKT0mUbKdjvPpMkk6SrqR2o2dK7a666ns1FCo1Uu7sgtK7Xsku2lWqhTU6SlqezVO6jVJ0l1M11pKUpLW6ndq1HF2fidFGdBkPkmRtcayoIu/7YWuEhsU33Gh7r1mGEbly2WPTWnHcPCOwUKwyuQyMST7aMCg4St1L1OAwyiZMNmGkAXcxN1LNjoAWpIRaGRIeHXhrUMryLwm/BhgAIVnQkCEwFALxP64ligaeYcDt9zJ09hsSQbxrIU5M0jg3Oxb8zRbbl895EXPqqpsMrdsuVt28N9pF6lc609bWIEP+kG2s0jabM0z63v8xbU1a29fdNUzqPjX/+8a1hxrN7b3A162v5t0ib1nGtw6017+S+dfedfWt6+M41j4tb1/trOqbznHpj7r/rN6V9qfda43KdxRa/HLnomJS6q13ecmA5UFYL0nGxV52NxgKCUuuUagNi2kOC9saI1wI/jzbAjfjJOZmAFQZhlW+Fq3AYhFEMDZJkAAVQAmDlxrobwxtDBwzFoKYWY+aCBsGm4uHG5QnZawmoyXKBA7Ho/Ei4aImRDDMAF2LNdAag8FZQfuQhw/RHY7GyiIGh5y04oEkXPIsktjEnz5eWeImp1prZEhDxmrd1ts9CtaNa01Luk1dRmhZBVdakHa6q2rba0/ToVsTRz82Yvy3//7+v2qwS5bzd95cwhuXhvssXmIzNlAzxrXfaOQHBgJkQoliaUps0MMDJJUyf5LPBubQjqxNEpiCsgsiTTYQQNg46IQOhGgFDmHBxiQCZiqm+A6eJCGExOGBaKksMZDGWtwxKgIY6bprDyiYCDPNCnfpHb9wWsAY6c6muxWqGxrSnBAGBAg+JDoqnKBukSLuTcqurja1y/tWr0zitnlOhmdqW+cfF24VUaBPjdNxsZvX//XpfFcRq71b/OLb1rWq+u8/Ocbg6Pfrgb7K2MMwtgTYAQf/k9Njvjt+a77fbon+q8YH6w6rqxedTyIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABzFcQQMby3LqLcggY29uXfmdAgxujctkLyDBncW5L0KxqBT8lbJBYJarTcqRTCVTJg4jUsXlKmqsiChqeE6J3vIi6bWBpZKhGFFCAwACb8UAJeo8EAZBVmPBIcfjAckENBLMntMiZUD3hd+BDRB0QwgsVBgKt+H3LgWJ3ZTIDHxqL2spyC46+sfeo1LCYKEW3botVm709a/25D1zWVR++Zat4LKkWUqp/z1XvyLspzxd21+GetTELs7y1jTc1l3n5dsZ8wz/L8O5Y5b/v5b73eescNY4//48q4dxw1hzm8cdW60gV+IB8GdOvM/wqw2QVTzZe2J+mK3zjtXc+SfvnJXrOdKgHRLSKgRnkod0z5HmxDb8WItKQuVy3bMINzZwOFZpi8nvDygRpYKz9iAXO0NAoASlGoRi4QPGHjZguCZYIp3DgwLBxMElUAVwZsKJvK2r7KoGaKdGDnY8YiwLYkyxYu7D8s4XkTNE7p0VnMdOOLiDymiNa7mhOY6Lwr52iH0aD1b54rBRkZaRWXdo22KNIf+9tjnvXks2nViNr439P9XzvFdX3fUCNvVvbfpq0/tNnfnvNvc0ua53iHXWPrdKWpeat9a3jH9MfOs6/1qBXf3i2P/i0h9Ds4oh3KwYZyn3E7ZCU6jWTJ53q57Yy3VoDl3HjfkCZWvRwBuM6jphwpL8Y8kq7hekwhUO0byYJXeBhQxAyurWMHd3MBQVFTHgWMLCgY+M+WQU3l4BCOQkaAxgCbCPK4cjuRCHbBV8SRBEGCEOW/CGRvq3Sdd9WQyAFf+KQ6YGLjNE0TQGnAjBSTEADMkS6KIRM+paQ4ECOSWPgzWZFRg/cwRI0rrY6ZmJQLA/GhkOUbMdRRQH4Q81RPuYmhqtA3Uit0kXSNJeUiXEkEWrWgukjda9Nl3RSMFmOgddFBNTpIJLsmkj7IIWWlN6NVf1Skik/t6lQ06SajfO/EyqZjmw7XNw8ydg1yBH7huERUGQq7tPBSzuEpCw9dstGS6nGXgwQOCHyYAVTHAgHGCvlThczeVON0QxAIRlS8mGjaksDJ40DCo06hQJiAGXiaOeF6JTDDyGyAJgh2o+nzKJxbUGsrvyJ3gKAyOpSnSJEyRdMmgA6WioRMmDdjUejctskbplUyScuJpmROnVOgkb3mCRuZEUSQPJsijORoUUEFUFqqez3Wp0moLT2XQa6DporR1oummgtV2NWqZGtbqNZCLwaehv+IRvCuo7WzHYvPMVOkkTk2+feE5m6T1arcwkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeHhkCDO5ty0erYMGNybl42DQIMbm3LpTiggY3NuUw2yMjlD3Ur6AyKF1qtiVZwUARepTzSwzhFwxHBCXGSATP0gjXgFpayQAwhh+pa5IsDAwMAAKXGMzqi35fgwULUpQHKBPOaYBFBU4DJ39NgFgZPEzAnVL7MQnlp1MB0LMXCVdu7CkIzxMlMlgOACIqI4kSHsQchVIFxUbRoUkjAXK5kYEHNhgM5xBAzmSZGpkXWXicPWSc4iLEigZmTHOmuapLQMFFpkzdOmgip3QRTNHWkpNZslZrOy07si60Fa1ukrRTW6VFt03TZNS0TVSNlPSUizumyLrQUpN9Vl+2tbrWtSTPWtklILMmWZZLoE+bQF6StyFV4rEAJxocYhmHLU3BAgGcplbDWZ9a5IkEAi1yBC7Smiu2umBGZEDsVjBgoKKCIoBgkOMNikqx4gMDDWGg4Cacws0IaFiVkzRU9jVRshCy27JmIz7B7MBYO6o0EBTk1qe5XIYfPgewTBukWmSLw6XNEFKLp6g5ZSmxJqNisuVlJufUVkyDnplXemPgbDGJxRgkymSQoVskpFk07tZ09kWaipeuk6daj9yEb08qaF43af7k733yY13yN/4cQwZVfdxFfJ8Vb0rmixHe9A+l1K2qXVmQsulAKknA2SPR3Ow0UwEQleEFKH0L/A1EPFF1Y3lGQUwsNYlABmQQHIQMA0E4sejA0MBKbJijigBEhQiLUOsZGQMYHDGE5SxxX2ozRTEw98FtFPiHnnWlDiyIZcpI0wkKfuNzRobEgZFc2A39HGSAtRwkES2HpjbQSQUK6ZpFwyIkXD5ZOFwQmNnMCqpkCdLBNKLii6Q4tJKZFMyJxA4iZpGGpFnWbus3c3o7Oui9J3SUp0UqKCddaKFBBFb00HWg71LrNb5spqHWy07MnRVTUiyCalrrUpa0LoMylL1UWdaqa2vUred3HXU9ywsFlqVzX20U/KDWRPBskxDPKVu5j4dF8FDl1bRJFUgFea3m4F7BozfaGgMKDQ0yFDMwQKFA8GBIJBBHCpip0ESCSg8cJQ0KEQGbRYhf9fxYATEkQlHTCQUqgsPSxaMnbrLWJLyBxLLL2R8xQK5cJwDdk4SBSNFJE2FoBkg8wL6ZeNEyBHTA0HAmKzWmgmozUZk4mK0RNEkEmRcyF8NNbmyKk0EanTRQ0VLdnd07UqVz7qRdTJ0KBitJI+s8ihezmKzzKZBSaSmn9Fmujouqls6l0aN6RjT4dc75o6FzWYaN4oY3xC+m6rZfoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHR11AgzvDctBsCDBnc25Z2SkEDGsLy6Yv4EGd0bkeGrrVgSQZv+IJe0NJcq3H8DE2DrTcG7W0zBEJHgjTdqJuxNDNiQKMbXGIIAk9QgzJSaADBQ82ksMBAQEKlCGVQVyF4CIuMFEgg4bdkidpiSgUBRR6BYOWM5rI5CjbGXZdMBHsxSybV6djMSgY6eX9DrzVIOpNF/IG5S1MolR1sM8vu2ojdZ/U3yjz1b5ehPK1zUTnct65dwatLdZXcuXrW8uf/be/x5jjl2zhZzq6w1hlnrf6/DfMtd7rLmP973DeXO56+zgrpwQMG03mzIKccTMbhBZvExKZlnTnQ3RICa0GAjvN50nD+INW4Bg+GqV/xSPkdiFN9SHR5MhPXwVhrMDHCwz0Cxc8ucChB2IIMBLGWL+dFDm9JEMGDi5wZoYKBhA6UIZVCX4SeFDYHCKNDwx0cADKC8QCaXTiwdNLKsQrF2F4jwtf1kyLHHMABfEEMSPNTUyNw2oiBoySJdTTRULhTOLKKQriSmWgx1jEruMegxhstki8Kmko6yCKFTuim1dTooJ9nZe1aq10Wrdz+eUy63dBtFFLZ1MfwWMJ+zovWZNtCn650rmPmd/TpdaWj/X5r/r02PbvPPNvG+ktiwAg30My3WVlfQOL0FtjDhySRAB0Tg40/RIcNM4TVdsC0VgUflMBJYKIDGkBQydgAFg8AoqFQGvpTUVMBRORFWmvqQADYNwYDG2C8oxA8tzZFTWkMxL8AUuedPhEJXGB87UbT2zF2nruFO4YZY3eZY5yjOxdte7F2pvWfaWgt5/Lc917H/+HOP79i1jc73feYfzn49/mHf3fr6JP2BFJM6vNbfb9pwuTDT5XccOevb7Z91v8S/VtTaJYFFtsv6va9vX5a/tevlsMJbSZUVye17jMgaEylxd5YkogND4Iwh5VSNpdCJcCJ9oScohADThdHJm4AP1gWLK2IyI6BYWBiKcgMGACosHmEAAoKpLBgCAS4xQXEgVJWULnOHGkbxZGTKnc1zvoxFuEndgaBoajErmcixRHPAfBIKaEgaGhFyGAQBmZgidRI5BM3OCpm7G5Fi4LGcQRLVSnJ04bjIGZk6KM6s+iOB0Syk62VSS0E1O6RgitbJpOpb00EKvRWqgcTN00k2NFpzRBJBlHVqZRmuM+DR7yquzJJL6FG7jHGogERq7YDswdkYbV8AhFPYjVdbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABzpjwIMbm3LtjEgQY3luWSD5BAxrS4udtmBBjUW5dB3km4dd5xYwUegWatTNSgTvBxtbyVSZRHy7wIkBqyXS0geCzPD99IfMQTFb051LwMRkIwZKFpiBGyCAgOByI5BgA15CIxMdMSExoHTFji7zdyABA5N2L0dWHFHK6JsJZQkIYeAPLBFKVSZYfaJPAejnzAi5FjEvICC5kZMasNQsFNI0QPG5mTpwey8ixqpTqQJNRFio5Km82NFGI+yJGqCZqmdZVF003U7JKSZaDnkVqUtOuzOs+jVvdmszLVeyklrQTTprZmWxsbMD8WNKTFlHzO25NV38GNYdn/mIWAX1gA+/VXo5CYrtL/bR7nRlA3ZisSk8M18WtiztJ6SFp0u6HAAgdDCQ5gKeyhgKLlhnTJChYOPLXQdKgEAQcvQC2kwQQBAKNLIUFFbhYOMbSwAjjQMy1ZyOpvBIYYGMwCoO4fuDBLXoKtteEmhcNbPUMTUZj0oMaRtqlntePTaAR1uZXt1daxpYIu1bDy7cWlxufzlnHCQ1IHyzocq2es/qN7OYyvPePcMed/HHDHnOb1rmrnccd71ruW+a5nhX1jrmGfMe3sbN/72eO+577e/XO8w5rG+9RSb5y3hIMm5mvEZt3oFLRvpwpAxRWi+TcowDpINV7mVys0h+BbjtmIsDz0p5TZlQCgM5WfR2aFEwxuA0gyLy10Q+8uJJQwDFiLY10GKCJ+GNBQsOyjwcwQgmQBwObVrBzUlJA4tEL6tp3AQFui6kKAHYir3Uq6pI/mYcxkF768jvWJVARhxFLEIGvS3eLNJfd7lXgO9fvalOdi7I+NJvYaz5U3O9y6+vL9i/zf3cJnedadpEWhUjM9DIS1cBHSrn2o6sc79pXjj5PCbbE+tuqWM/Q/7frDb//3HTr745E79eU/y15eHeJXstmQsvLqwliZwy/cWjOc1wdmgixmGet0gxQUx7gzQGWtcAg4yo59EPDEF4Ze5QRE5hBdQQmD4Cx5EOkCaIZUCzlCMTGiJeNL07G7lUUZuWKsCYarhV1HQTcHdawMkzCjYlCNF1MihDi+OYASRUCgalAol81CrJ1GyZYMjimFhUbMRMyEJkjZNSCRipA1kybIFpSSmSSIwrqQY3SamyzBJd1JnU2TY1oPUy0klJou6CFjiSSlorNUzR6TMmtS0GSugy1JtZbJ17upSzi3Wna5yH7hS+lHHZpGqPKQMU4rIT77SALZf0CgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAcaWkADG5Ny6Q5YAGdPbl2NsP4Mbe3LuENgAZ3BuWeNylrqLUgGEAG0qwud/2AlCbLb8FJAN2L6mYt5jwmqaCjAhglHnYQbA2kwoZBoZMDCWfmPg5iauLSoGCAUJkw4Dgxrizw5mMBLkaJ90yQEMpRxBcgZZFQJJhz2Q0aA3J5WZgY7kcNYmJePnCIjOg11hfJlYmUCiRhOGyTGJMpuTxgRxmqThcDrFeXyss+XEC4XFDPHWNjY8g6nLJEy4lNmUozbd60nUhZG1Bk3dJV0FLSdd1ouktJNSLupaSJhgjReKEVc3H/wlGJt/PNApTvsxdpNoHWbg1PPIvgeNLpU7pWKmjIDn3dBkEPxgxZrMFR6br3BQ0awUuS2VSygaHmLypqNPRFMOIG6KCV6wjkxKbk6xE/xkaZ+WaAaCgha8meg44vwWBhrd4x8GwNyx0Oc+EFSwkMIRCTUCLI44z0wYIgJnTkzK53Ee6/FV4+E1HaIl8swBy/jb1pjewdQjW3PBUEEqXu4k1INIsJzuksQrYvv6l25Zbo0fFI8Ge+dZvSNfc+r/FN2xn0xitNb1fO6Pvu8kanjZtufGt3pLTyy18T4pu/pvdK0vX6rr33vePS27X3qfeMa+YwyMSAu7LGMTM/x3mb2LQa2E7lWow9LOD3Ge2wMdqxufl93McANIsoz4zmlDAY14vBx8wJp5goQa0OsFLB2VQxIZryXZhAgKAY9RmMP4RCAIBEZKkQLApIEDoQYUDK1jRQoW8Y6AmUphgkmj+CQFFmMMwfNGN0o05xhQMw53ppJxsP1YpR3FeYLE+fX4EuhsODNRXqqLiRf1tzTMo56xLsmcXgZV74/aZYJaa3SJqJiLvcDUOXze3gUvBrN8YxDtfO/r/4+Pmeud+uK3zrz5/pvEmdavr5vmDTdvT1/1untf4+M4tvUPfJSNSAY+8hDydQ1kVgtcmA8xh1w0pmN8NO066Z7I27RSlIJ6tPC6GrPw4PNOGaqL7M9LoBDglWviMjoCYUCvuMioQHK3L4RbLzigaTI5hUqAQYsiQH5cgHBpIECIUBAoVQYodneh9vAV2gA4Gg1m1JiueCXlklouuZQCuRGszQ3IcRMiiIC+iQUuF1NMnAhC6ouscNVGaBfKCCKQ6S4LQVFGyaB81RJgyYclSZGUWbNRgniUMD6dBzdadSbLRWeSqUydmo1HkqrqqsgfSUyc+f00FLc+vmJ5mZI7QorpJTiSTqZ1KSTXdJlLSZKgq11KVWgklWmgg67IXfpoqdTVUXTqPxy5txYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAHQXI/gxt7ctWLSBBjU25abXsADGntyzku4EGMzbl4ayQkvWhQ4jlrlLIa8bjJJAeIaS7H0SMUwDR3YoHWYv/HTKQNGYhNxp0IQEqhKNQNGWRhDEY1AN1STAQoMgw0HsvUWDm0wk/AwSwCwmQbYTgmNDkNHl5M2HOInzBFMxYysHiEj1I2xUW3uCkWjinb0YrT8Jy/18SE8pNPQmVtuzmyPzGqMMG1IWG6RaveFiF8S1uhkB/uDmk9s1rreazwK2vPj0j7rA3633S2INqazrcX/3rbef7fO9apLqbG63/xXH1q1M0x6XtXOay/X9cb1/rO94nrS1IHLfVawXGlB0Ws1Is3v4TGrrWowx4HWg6kEGK0tlE/uiQ6FD2xdaO+7dC6JqyixnuelJUBIGVEB0HIG5vfDyAxDqEDjPTjBAlvmIGDogaFl2yUUUeRQsHN2gPUIwhuUZiRhQshivL2424XLLIwBDEcDznlguFQ1TJkBEBlCTKqKJcLwWFkibXpnHPl0iKLKIMkON0WUg5wzRsTC1Hz1Gs1LBEUHQmrHXRRQZFBV02ZF2NLvZFFlLZtaFVNdbOyZkizpoH5RNlPYt/BPx7kb63wXhH2AWe1/eO1Xnm3pf63K79j4TtevXjyrHMe6LxgdbSVqOnmsiw4oC1rtDAtSgNhTYnF2spkGHHJfiqsjCqqOSq8hIREaTGpWgq0RDyIOKCBoMhZGQ5yCG4hCwI7cBHvAhTuLh3OajMp79U/GGXMMCgh4bmTnaRcL7WPWXdnxIsRn5CIWYE1UvEpZ4X2LbKVeEmtXLumcQYSVf3x4ta5k/dElzq2MYvrOL7g4zm2t0x97r91xquLf3zr1xj63nXxS9Pm+vv+utffhJyTeums8U6xwy8+n94fn/f9z/Omgy51sY2UTrdIfRx+7DQXKX3EdCGd6m5borZUITW4zLY4s+xMOdiaetxQ8cBAQ9CQKh2sMFQGjDA1FXSO28IYJhw8sQFDwSUCbg+yS7Bj7TY2ShnDU9JWojs7j8qJUD2y2fa4Ooc7dTNJAkRjQMsTBJEzZxlAxiKMZOeSNU1pKL6UwHlxyUUEk02Y8YltZPs5dRYxWgmUCTugi1nZ3XR6KW7M61J0kEFPdakVOtR5m0kDyK6dJBlrRSOWxnPgJd8RWXgTuyff922ZXrctbX8O0SbW9KAap1e//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGYUTAAxrS4sxruBBjUW5Y6RcADGtLi67BIAGNSbl53IdZUkPzORIzGkimFeoQiigZaq9XDUYecd5k4LqA0AGXVmiGOCisFsaeYECWoAIOFShmyzTy4gwQfZOcKDA4CW0Fkb+vUracJoZBOLxxkG7MtYLDbi2YfWuW1m43ypWqSmpTq0MSx7T0lnSv8Oa5VdHXd6h771NJ8Wk2cbs5O45X6tfKdzyo736y52VSetld5nv9Zb3leq6SPdiyZijxtzklKph06WTqFD5DE63UIvVmPmbJLGivLZaTZLS1P0lc66j2FQVYWHY63g0k08TM26SFzpQQQnrsmuUlRMooS36V8WLQTKgFqavZgx0liP2KpWGw25LbgAAgyCAZAyAwpoY1IITDpKXghIHERG0XzDK6k9AW9MEbHht95b75u5A+MDtSFvsO2p4kllwipMGYA4GWWfRYqJggxQqNUyMVRNS9nCTQI5OXT77MYOVVy+yClJ4h5w6iaajBmQUhdNCi6V0E1KrWimm6NakbKRQVTZ7Nat0rMtM2RWSsfvV5fpoxkvrPpvw26VnNn+RsOaEboFuUCv9rfvCk+FN05m/n3alwUPypT3pqsrcTENXYIYpg4h1BqdtWLI7lqWkgSSVgWDT04DQCt6ZR0hppgQiBBC1PJ3SIEFUSzhg0lc7b8lUEIHIjbC78cBvu7ydkke+3C1sBF7P8J2n1OWpaSmHlywqd/T5VbGGOsu/re6uXJrjYM+au97Md7axlWHxH9d3rda1b33l7ur/cOa1ru78r4FAuQibtmTHE/1L+1SfSRARMmFJUvZVrmLfg1jyqdQZ5gwz8ra7ZBLeT6FcOsn+lkYuwdnjOXloJgQTqZS+zELZc8mU09l9YejAOIh2RZciZslvAkuBiNKJpydjhBceIzoCSHYDhA4kFBAxJtcIsWMO0QuJTwsUfVmqE48Z0yIseAvhOQOonxakWjqGZkx7UrMiWRU3JQ6NUK2LJKxOUzA8Da5CGiC2L54yM0DQ67lQxGXOubGp1MyROHkCLJGZDTYwWtNhfjnJll0TBajNbOk7oz6FVaCk3VRqSdmZKcNXSMEVpoLoordJziDqRUpCk6CaknU6SN0EzqaKDKoarMpbqUt3vuhTei1aW6mPrtSZPZTLTOOcQG6FgNnVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABpSDwAMao3LOa7gQYzJuXcIK/AzujcO/RV/BnUm4clfyvYZfR04bM4L8XpLPKohSiTbpZItWbHBBkR4oInXDVXGgSsRkjSn4S8flkS9hKiHghniYoKGiwMFtbYuBTrSgtIREctxFtnPPGJeBoaCWbyF1nNnINxYMRXa1WVnTyZwqivgYFiSBEFNdyKldN2TMUWRWWmQlFMj2WxspEvoOWkjzKMkzV10zg2kUEVpXQQdlGKamUk1Vlu7oU1oqtSa62Vs703pK1u1OkvSU1TXfY8zNQoIXVXRZaK0nuY1O9HVZTrftV7KdNe73WftY7tdZd+o40BVit1LKTGSep73cKEV+mblh7Q40g8FgU9HaZGxEDnq1mAoxOiZs/IqIgJNaYwA0QSAwGigQ9kazhHjBCXw0w6q/BwcU6MnF8mySFxXcl7D6SZL+G+1KZ+6fLpfI9IlgD1GkpAqolk2C+pE01pUUEWUXTijhEUyIGiZ1S0TGpJRFXmhbQ01jpGws6bUdKtAyut3TQqstzujoqdkVetSakVqWzLTSXUzJKSSNHv1yq003skO+8tQICwDuUrlt21Fhc/TuB3njZvfKJe3Qwd2XHj9SBYqHi0mnJjlR6yS9nccy6hpYRzNVAAuDwQzFNBBxZ5noM2F5WWNeCBYKnhg6MYGNDR+QjRb8w0IXir8UIFADIwgWfVL3shk5ACCzURRbhsXzJAnjWpiBCEDFk9z4zkVFEeSpoUgNcsG2TqE6kbCMiwfQsQInjVApEkdLBmOJZBTxqTBEHRSMi4ONIvmiZRTTRUmovj2alhlpmi90ETF0UTZ0akEEU6SdJJzyKWp0jilIJWUtSnZdWmm5o1azNkFM7p3SZ6kHW86itmZlM1bJMtlraaeuzoIO7UqF7rZbUmomoUbEAgMP0I4qRjbQ34dVxAeLIbEHRydgMKYiwe9pujHnpLvFGYEg4y86DBhkErInysWaGMSMINEaYzkYeNGGADhgxYgyYxNsu+CWSVClJRtSXhkUDH2PiC2HI3jc181VoqxiNt0QyPEBY5DXC8mThMGqgOyIEVaBeQI0E6IIigxqPsrsXy+RJzcwHphljZTHjVy2myCRel0oG6akpwxDzJJG6LpLPIFOigktk0Fsg6CC3UpN1KrU6SCK0kEzBTI1OYMykkHnlJnFXWitFBGjZNPqSUiut0T2zaWpSKS10EHWg9Zh6amup13RWy1U3RqRRpI6tnnGSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAd0gj8DG6Ny6Q6n8GdyblzNvvwM7m3LSzHgAZ1FuW5t0gqLvhLHKA86OJQfa3JxZBMDyyegsOAZQWCciKgcNP+7DPCIdVrNAIcIELdSwMLBALGPoyZoY9EpM0IePUDEnjOgFs4qwmMAb+txHQ40cjEU0LFVlg7zo2PehTlLFrl4H3n4GNS+UCHGRBAFKwKADObnygkMaeMDRaB8qmyjIkkKBdSH0bukUbTUhgzSzDHQ6K0DQ2JguTIuGCKKropIF5SR9lqda1LNVMmmbIvVam1Negy1GrJJILd1Mk6lKdaTJ2UiiylqSdNlJV3ZBlPWnfU9SS9qKa0ELVup1oLd2uzLWzJscVBUKbhg+p/U9G0hxhisslaUCw5fNReVVH6MZQeDqKXp2LO2DAMiOlpSlVBi5qwergyYDbWTKpNuYKHCggYYkCACQSkBMIwUeWQcCFQCNSA17A0DHkBy4BV8dSAihuJL7R3Jnlpzjw3WypHmilaMVe2zl4i6JMgaWVT56kZF8BLjZUgmomEiklJBmMBoOJGeqpGCOaoposSjpJMoxQICkRxfSrWZmKCnUtz55OdQRnHN1Ju9Z5tJzCg9S1IMpFlskZMmtkkbpGLpoupFFRgpbUk9aKkkntdaDo0Go1IXZSmMUrRScb1X2teWZZWfE5NFhcZsxNwXzg1vGNkhT/0sCTkregVwcjVK2NESgHSsIBA44kD6P8NAyvzVQZR17RAAy0mEzFQoMnjFA0CABMBigwiqX2FB5sK2xQ5Q3blLEdzJSYq0AOFGCK15qzOiv6lzLzhxLTR+eQNybICZk2B02RVIxNzcvpk2VE0UkSmXUzyRQMD5gQqQ+1oIlZErGTFI0cp0yfUyJxZwfhkWMyKGszmKDIpuzOpNaKSnb2ZFJrG76KSlJ0FJposmjUtPZSnXZ1opaCCDorWmtVNVKgtSlWUpmc27Q43smZpAOonfMZV5V7WDfNqtUL9quqzlYtOo2ODXYy/li7BgBiXpX2m478eFSKFRdmWzohIgkK35FGXPSQ7DpEJMOaQlEwwiXkwMxA5aIqAFExd1hJIVDBKSUiJBJ0HSAUrVthvTq0X7dqPPqIBhpVj501ovFMzQL5GAV0tkhMjUqB9D6aajBJI3QOFtJjIfZeEJGPon6a1pprMTZZw8iq6kiTSMEUXZ1psjReyq1Irs77KRfdKy6mU7Ogkpqa2QZ7IUEmTouupBnzru3u90i6nNPk/2beQFVPO18tWCbnfimr5e/9gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHi4g+gzuTcvGQF+BrUm5a2Tb8DGsLy588H4Gd0bmFqxI9ptVn3YAC1YEkkim8oiZ86oZVYT/UFlhYRSYcMPA6NvUnC2goBmpBSC7dknWJjwAEARm6uXpDlkwIVGAcmDgoCihsLBSmRhRMldDkdZATZoVjAiwTkZNNopw4mrLVFxgLDiqIPDUJkwHWTSCQPoNCLpXUiUSGC5iqzrkybmJNmA+VHEx2HB2k6gkWjNR0wLtRSPmZOM6d1DUJdRTSNUDRS6KKkVG6C3ps61put0Ek9JB0GRoMpRuquiZrUgkiylqRSqu62VZ3NaetmQTeh3Wp7tVRd0VLZ1poNdqCN16VT00tzFBkndMxbZ1pG3k9LW1Nn2kMFNOYQAqr+TEWj9R8TCw2S6jRVARLMQnVCh4U5TyiIKNf0vzSBoPgJYN4Q42AVhDXEQct8YIuYFEiUFA4ErIRK3GDUkRQeEvCQFDXYRAIIu6Sr8MmSU7ALvMoVqO8dS5szhi6RFyiRwBkkSJhE8tiiDdxBCigpMjjVjzFY2Lix9IDTLy0E3NjQ6s2WOU6jjVsgcI0gznConWkarMGY4yaCTspCgiuarZVlJtZjR0mdAzOoOifNDZFBMtsnTRSoOYpqTZJ3dBF2dJmTatSbK3QUpS70lVrbc4i61JIOuhZ2ujTdKfaqVrJvw4749KuXUUqj8gbgosB7wFutVnL4k1all62XUiYjWqUoInjlTTgIBKhQ0gkvRCh0IyoQizAAzKsktgSDMOIBEBOItcKumaImBW8hQvaWJpHDVmTTEbVDhCptCa2yWUrhl5APyBZfP1Ji7K590DpZ+p6jgbG1aYLbt8q6mK1XdSHrlzJ/7jcresKLHdrtWcy3vc/lhX/tbO7qb+zrf1u5Zb13X/jv88P1//9/d2zrt+ayzkwVAs+oYVniwddAQiMcwmjvSLnfe/RtZIv0/ZGN476rtwzvapza6W63PS1dTjJzN4vIBnv1Q9hF2SHQUq7VOh2izxhQVJgNoMNwESgxAHJGAI5WZfVWiwYMhQSMGPGFjQqYaFAwITzAwsI1YSEEaBCZpWxV2AaCnYjwXIh5aYisPLGnTDWrMbEIaDqd7u2z8tEw5AgEoDMyKxuggXwkBPm7LTJ80NC8mXDpgXBkUA9EdpobnkUk1HDY3FaqWdNTqmdzpFUUSg7nkVLTop2ZOfWs+Z0U2oUanUhaeZVkU0HQTSQrpPTvWXK0mUmtSCFa0GalRReynZ3Z92ZS0Ua0Wd7p00zdv3bvH5ag4F8NN9ec0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABm9/P4Mam3DpDMfQZ3RuWm1S/AzrC8uZwF9BnVG5x4wV3azvJ/gZU/Vr2bVw4upO2I7uOhQ2t8SOw7DbiD0cQmg42+sRR+fmuOnTQnV9hC4WKkRJWlJgFG1Iw6JHxoq0N+CUKIWEMlJxokgiiBVpVtdlQXBmCCuq7HCosmCwUScBWYeEyMUDizEMhEQrrNzjpnDQ+pZHJDXQnB7Ui6Bis8XVORFloqpnUGMXWYIupN0E0UEXZ3daNnWjWvZa0L11LZFbdaTqq7J3Unfr7Jq/rW6+ta32XayVaFa+jTWqt3oVotQY7snzyXDVlRifMXZIjIkbARIGZpkLtQbOx6Un2I8l+VJTK0UZd0eCoCqvchKByaMDRb9mMXb+lMNC0vwKbwGukrIiVQKBAOFTKTMFDMAkqWRG73SsQEJ0xwYg2FCk8bTqRD2IUlFAKWhiBo0Bxr49EqbkKWSYCFWQMnnLBkblEGgQtueM0B/NzVblU+aoEKbiJG8wWkXDZJM1QE3JJJoIKVPF8aaJRMFHzzn03SZ1vnXRa6lqUmdVUtK9N1Tt3U13rOGyTMidUXV00klKRe910ED049YZHhaMP1WCsUkT3QS/ArlAOoDI3U0jA4YYFUm1Sw9Aq5ldRd1XZFzIrHrUhzyMkd7jXwg+aSIHhwkTrxdLQIKEpQmvNOhkQi4SKAxhic8crKFBDSygQj4owaIGzF0xBLh2CMbBykYFSialQyGK7DnMSjqU5CcTHBMRlM5NxOC8YPPV2/i1mzb5WTnfnDmePNct9ebeOTu3nYs9m5VjUyxxsYX+/J9X/1lrCrvDfK+PN7w3n+7+XceZ81hvnOa/XOcx1v/73W9b1d3+p7CufzO3ORRghyfSX+cK0qNdlO966QqkGO3eFXN3nH5qUiLRPeJTolCRSfbo06covg6r0U+EFUB9N09NTt2WfEiqOULWjg3dWcsuBTQ8zh6AWdvKiKXVOCUbMZUAWrMy9LeFA05hVENT4kRDsTN6xfQ3esG+lvPTJXmhifgqLR4BBzNM0gIrYKxiSBBS2S4GCVKNjQsIlwpBkc1LyCDkwWzpoiVkkTMtMI7LzGRuyS7GbCkVpllkmOJIlkdx9NM0LqLHlrWk7JpIqSTWgt1si+1E1tQqSrm6TKUq5syCSaLrpuipb2rSugh63qZ7srpPqVoJqRWg7qW1aS7JNTdlqdJSKmzivoXGrZRKj9gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeAc74DO6Ny7s+XwGtUbl2OGPgM7o3Lg7zfQa3RuVQob00nm5cMEGYTAFaRz1iDznknq+cAJ5TAyQOMAAiH408wQokhgNOVS+nwq9p4qggwAWACBQrDR0RUSZCCo5L9l5hBeZaAOvEkOBGRGGzolUlQAhh3RCFslIgRrnSIBMeFm6v1OoFw4RAkiKAZWEPoyIbLZRPBbEdxuanlESNDd2GQOGShJjw9FhJhwlQ1TQTTWm6Q4U1oprNhuERQRRLpk7uzObGiSnTPJmaqlOqtlo3Y/ZTJmy2si1E6bJujVSRWy1IroouZO6TGSeyk1ujWtkUbOm7opO2mgpbzr7hbcBd7JVNU5z/WFmVqjhb9C660482FUDRxgcZQO4liHpfKobOaYtVL8pQo4XexLxYNDL+GXOCJMNJkNZZE74XDiEUDsDkDhoIXm0PBQAhqA9wFAtOMQ+NGGQrXxgeHwCdAKKNwam0G1enGvQGQFTiiFf16xcLBGDNGpsBo3IxpcpIl+G5HtB6BSLZdMjAnJ6TqIqB1IxPSoxgYoKFbHzUlXOuykh8kYzmbVGhxqaaC0FmZoZonWRQN2Z1MtBJA1W1aB5U1rXQNE0XTUik6Bu5ofOLTY8tJBBdTK1u2kmipGyb1IKWpOqut1nnZFrIsyDnEqkHM3P0qW8eiivRT3k7pZ0kUsWFdWRIhDbb5yXPKs8B6GwivxTqZumAgsIGQ14ZGwMMKyVEEgZpaqQjFqiOhYQyhsUNBwMEASHwcHAgJMyAGcpkA4IMzBH+iS6zgCgwSdLMsvU9NrdamiPEZ1d4EF2dVLrEMLxuTo1QMA3FAqKBqZm6AZCQMETGOk8ieIcQ1IvF0TgwuVkjItpOs2MCXRGoauOUknZTjHEebmJiVF6DKSSWii6NzFSGmyTVvqdJ3spbumiqplrnWc4umjd0qepJ0lLQTMVUKVnWm6nuqhrWhUyla02Otsns1ans6lp7rU6z2gpM2fHsg8O0/qgjIHHWU1AZAB1OT5378qlgaNhE9YkrW4ZEYLtQGZtsqEoUUImvLjbAz6VjgggiEnFUoCHAMDGLk40FAAJM2EkwVkAFCUAdyD1bzjh0gWhpcfCGnfzZy/VDK2QA5UkcawcplgZkmi4BokQssxc4k4+gQAmUkmXiONUUjZKhPsLOKylIJsnlplsbMbKatM8VWMDrIqNaFNBS2TZlKdCcrUYJMpkHTU7akzVlIOkeTQUlWkitVJa6zHd1undV2dK7Ke6SWmg1aK0VrWii7q9qTJpInmSRgE+pQvw75E+kQQ+kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHW2u9g1qjcu/PB8BrdG5eGf72DGqNyzCkn0GNZXlKOQsTZamlsZCgqk0POHYlWeYXFt9LOrYSCnyYA2ExZJ+nGQwMiIMeaIjDNobBo1bhCBCykPCsCEKAvuakEQCwQGN0HKgJBEBdRlwETbuDCh29YUjjSNMtEVpxYJQYj5GXMkJiyyF0UpidRGdJlEfAAkQUQnRmSAE85PiEZaKxmYMThWLRoZCjJMfGXSEIj6C0CmiyZYLiZGnlF00dJTmSZw2p1MmbIM6Vy4gmk7VGzq3oOy1qVdCZtZalqpoJKS0VMtaCKLpK1o6CdtqTVpHKlppHWuhRMaavRuFn4QZg5MTPJnJKzreX+2S8yYyvVM4AZA1gQhQys4b6trhTsCOGLgaU1nZV5QF6HXBwM7z7hcRCoKBhooAbFLEbQqIiAeDGkRiAjCFzjKAOhoIBDWAcYAGNDIQBg1zmehcSOPETBzIWqF8PPFnbnV+tBf1VcyoHhUnmi8Zk6LpAkQNWTIKS6k1EkVw+cdj0kRjzRy85ieO0jEP6aqWSJdOrNC+XUSbcyI42Wmg8lCucSOvMjIzRc8qo4gpN1mtTIMylqTOIUErsi6CjVTO5mi9jdJG6aTOfZ1rTWy2QpI6qdFdTJIOiySlKouyGqglsp2UzJmfBzEjuDb8sLHnBeGNupYwy19ScaZgVYloJLTUUVsJuniUE2K7cmoz48CgA0AuOWi9xN9JYKdBMIUBAg1S8vsFgQ9hAQUEAlej7VOgYXEyhW9kAh6IJGIsKLKjnoA1SZnOPa9qtbeMDkLJBGGN8MlsOUxNEyToxxASNA0qcPqNQqm5sV2BuiO44gcNyYcuGpoNA+k4zyAhGccoFk5UaGZZc1ZiHGi1uyhnSqmYOmtzqUyopGFJZ4/STRrRYzZSS00V3qpopqWtmTP3s+mtBkUXQWtZ5aKLpLRQZlpLSss6mjsiqzWddLRWyKmdGgnRbZJJVboqn1WteS09iulpMewzC7awqx5AQPR4ltWKvzASHURFpvVrJT8SR7n0RYaoV2hEolM0jQYzLK4JFDjgSEl4QdKbUxx1CgcWD0FO+SCFcklL5cYYeYx4osNjElIasvK98NQdJ1pj6br2IlXuTMRuRYXFgbH8cKeVOLS/rVuZt2O/J+Z6nMWQWcd8y5jlYo8IY3rmGe+87NP3le/+bw1hl/4YYc3zDX43O0o//KNtIHjAEZJeFetEkO7CrgULfNjGMNkvwy1V9yXOZ/4mJxWLvJ/3J8HM0KgFxegAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB3l0vYM6o3Lrr3ewa1RuXene9Azujcscod8BnWlxd9MNdMMv3SKAk6MHQFGMJeOAHATFMrMNv1JCIZfGuTL4BSPKo0yx5dSAdgwUNNnCBoyQGkC5jHFUbENy9YJLDSxSS+DAwBq7GmyBYIcreYCqEi1U3lhYqRdOGKZ7E0jSI4q7MtZAjxa0h8AMZBYiIoJGRMkVAqEJc8hSHUREukyYEHQRMRcJQEoGMvldN1OXjZRupEmTzJIMZlMbJYKSNE8XE5bOInTinMVKSUuybqVQSXWtnQrdklVLpoaSKl01opMitNBJ111LSRZak1Juk60VIJL0WU7poKr1ukgbJa+Q/FLsLVLi3+vPR9tezovG11slcoKC6EQBR7JORCGJ2RpyHIBscr2lkL9kqsUeBw6DY6ooXsMEWf5wXuaNIQEpMDAQlCoMMGvUbgIDg5iThRlIiTSgqQUxd51jFAjwRRQyTwV8QY86W0tjDdn7ERQYXOO+2iLGRTMCkYgbMgOEc0oIpm5iGeDwyB9NSyqaojBSMFJmQsZeRQMDZOkWEWGq6BXPWRaTYsVixpJMyK60VI7opLRRTTataq3ZdBk1KWZqQRZzVS0ropVoJqZ6aalJJqs65iu1To0XQUkpJS3U62Uta2TSs6kEFO7OpNAzmt1o95Rg9AwoY3KxAUYcZhLRoIT/QmDZscnqCXUiCINri2OSy0hWlBAHTmfAjTHSWiY+BGWg9tEJxAUHIUDwWl4TAqPxiYExMOJGgGFmoYKuanqZCSlCq3jtKJnLqgcAkVemXEXYLONswOEOwYAKAJulmEdSKxIDkECD8ANKiGUGieSRNyOH2QUyUsoik1l0olYtHKhU0hQRCm5RMFnVuUkECILQPpIoG5xA6QUvqNS9QNq0k3SLqlpOtalOugtJqqmppKWmnTRRdNZxRkkmrqdBbO97Tya1aFB1XROKSSWyk2oPbtWgfWktJqtRhd2ia3W8ZhYX25wLpcqQadBCt60lwwOsALkyjVHaoSEQZkHGrsvIACdUZZbYTBf6ApGWZMGBgychx13+Dhy2GnQMDnC8wCRT4MTFAwl0FHYyX0nlzygJ1Al6JeWNRXFOdtotAc6OgjfJ5i7R2cZbEfjJnA8TopDvl3IKjbtzmGdS3upajXca1mu4N7DeWXe1O76+GuynuOtYbjsOb/Wu85q53f2nemG68av0o5op9CiYH/xklNUnHp5TOHdVTct+aq9uf/iImP7cy9cRwY6s01X+dIfVbgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdNeT0DO6Ny529HoGtTbl1NqvIMbk3LPbHewY1NuJAqB4W5wc3QYUEjaSpa7FB0UFjRuxYJQUFCUBlnmHGVkspmUXigJMOBpUNEK6SqNtdFgAVNkUmkJehcREASgaBlVRdOF5As2qax8VAV6HWA4hEBaLUdfzMRhDLH3bg94XMAMqs4vUsonRzzUrAYRGJiQYwKSRMFkMYj3RTjMpsal8ezQ4mLIRDHTBlFVFSzJZaUX0pMs65xZDCQSL6K5gk7Ti0ZkbOglZlJpps7oLZbzM4tqKSS0FXtTSWlUt1KtdaKTXdak2upnamgg7roroJUFLfSepK9S0rLTU52qn+uaVZvClNo6uMq0XJc2dTNC5JOIsFhIy0qAICr0qJ4SOfuq844WLkw9OYhwa/LXRFgQgDZv1FYRURZIaBMaIRRiC4XMnGCEwgbEl70mUOBKQDiMMlQGMEzZOCr1BWluy1GmLEe5W2B3VawPtmDwLfICUyZIYXDAAvwxTxobomqgbIE1OJFNIoFJzcniColE0N1B3CugkaK0yiSSxa6KRuijnzAYDKMULILQu+nUgynUyJ90kHSWmu660900XfZnUiumZl1A6aM6bImj3UeUZIprZ9F021rpIbJ0dkUWRa13W10KlOaKS+qD6Xy9hergxNJ/KZZsnVvi7SSryJ4Rqel0eJMgolLK7JKFpvxQeLWRmCGkodpF4w4GMSDfIhdvyYBRiJhZwisnZgCiMmAAsbI0hEEIwOBWmFY4JH7wJiMqPFKTBQkig3DicEIT1CY+9U+CRAw8jVfIacgZFSDkVNBygo4XGJw6ShFiwkBnBfK9FxZyZmWkhJEEjAWeXg4gxUdn0FokqVkzimJ5Je6x1CP3KLuo3UkmYKNkLqQSQRVmqdBBVmetS0VVpLTQ3sldNaqKSJ6ihdJG11LdS6rO6202PNM8uupJEiSVmortJEkvk2MXlKYITMPtRfIN3YjcPJZs2sENnbpLup+oQ5L/VcJGQkBUJHUD5aNEX2faqGLAcRoqSXw1GERhRAJTlKha8lyEhkaTigEQ35UgMEEBjopGEAI1DMc2iQWmcx32pMlkbsu0KgDdCGk00oZEvjHlYiwHzYyR5RfLpBDYG0hoLMj592WbG433RUaJiO0kVlSijWXFjkJzErotdxqEVaYqU2ilSVoZ7RQvQVWigikt1ItUnRWgitVS6Sp6ilTWj2Ts6LOcllKeQa1q10FtTUEzheyAgWfY1bCpMOI3EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++BAAAAGPT09AxnS4usrJ5Bnem5c9YTwDO5ty6mrngGt6bmebVsr6PO3hVcTCn6LlaKkAZOJS5WCwKHhM+a+zoKTwifXWs0o/clSiXlUiJEyBFmTvOCXiGhjVVDhQnBW1lbdhHkau5jX1hT+WjJFCa+8dpxREFediNt2iU4a0hJ8LHI9jK777GGGM6v6ppjkwqnLbdN3kM577MMnqXrrtWYHo+Z5dx/7v7t9zpfw7vPlRxg0YJqGbFq5cvw+9D1MP69fVBEGfyf/MY96/IzoWoOyWulfy0uo612ed41rmBU2rBdHYZa/WdPtKRD044GqovFsRLETPyKA5uJyocjF0IrLoHLAkYcCrZLYYlYzLZYiehNFid8IlFmYyQmCDKyIOgxgJMDBCInNKFy7prwcX9RDhagxQso4jgC4xyoEQQpEbs9Zq/LDYYpILlkPGFoLzRSjylU67FM9BoaTaQJFYnSTcwMqaHPGzuCa9mxxT1matRX2OxXCzzuG/j87g6d7KAJ69nnyyz5v/oaW/3f7q2Pz73Xfz73HP8/1dw/v1+Y61rmO93qm72Gd7Xbu9dq5ymgKG3wCzzxpmq3SF3eBQZuTWiDHYS5MDniTTmMo4O5yKb9xT8llpRrucZoa7yVImqltm68FFKROmpH4ynqiPHUckvzOzR/eKQNLGwhOYQPCsYXG0wwMHBpuPGxewHLgOHDOBgwAiMiBREDKNsQMtCyhUS1b8dEDR50qrQQ3N3iarhwEV+4zLlrEAsUNK6ZTcJodRTNCqOsD/ILkEmTRIpGBTBZB8tJIHxGRMHEnE6GiZsJxMBCqK0iEQps5RQHhah1bJJmReImt3QOUjF0K3pnkFpT6OlVvQU+ybJppKbqTZFqzVBJJSCqRggnbY/7N8OMYSjSLAdgMOhON/vkJfjUp57O/z50nZyIj5fjOUv9wmDo8NZHURRKsQ7FICi44PIxNFYhZVEgQGSkaEFeAZAh1wltj0MPHVZOKKte2YqAqBiTEhIJnQIMDPz4wYwM8DxwMGQV/27go9TvJg4sAZwRkYoegazRvhEHT8niVqaJRIyFEVbEXnnrFtp8ZjJgs7qxCTTdqQTphjjNsZjDkBVqkZpGJ/+T/zCVVvdqBrX/8pt6hzPUBVN8/+ypcU9M1O58z5nrGpv+fvmOHf121lhzWVzn95vde5+ssu5c3e325sooNvWOdcsax9QqFQ8yZOQPc8MsrMpyEvYFJTPmpvU3/dH+IU14kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHcW87gzujcs9H15BjWlxc8RDsDG+Li1ysXgGNUbl/VAliDoqaMjIEiLt559lq3owqsNoxf7QwBD0NGQUINKNwHWmM/BAsDAZEpR4HD8PioTDAWDQZBopAgmMICXzNTJTBjQeRoDQxZCM0KgqvXOJRcz/EMJNh4nkDQ1mNnb0FBrYVgkNgNbPxHofIAPkmxkh5FkgYy2J5H0fJ0+QQUiAMCHMP0B8iJmqSZSFnkopASc+IyUmgRNJ1JHCobjJusgKE8tFExFyJHDNkakkX1vVWynQc63UiymP6k0LvTqZt1XVaimitXW963vOLXTW7q1Ju7u6LIoHkfYdShZFBOWnY/RcbbiTmmQS9lRfeuRKoooCyKCCVg2uG3nh1l76IdyKbuCJ4ZCGMAwBAbkGZDy6BEyE1FxRStSsbumOBgQyNLhEOGAajplqIIbBitLVsstQVEmiGsiEQAxMtW8bVKpvIzZMh1XBfaMqxmuPq0xKRSuSxyMypshBEdKU0+5mISQAgGKUeNvGv+8JfLqGrVlmCd9zd3fcNX6lTku+tTUWf8y3Tt9lUvmXLezZKp0Q5H5umxD4T3gk2chNvCD/xyHEKrtz1kpvv9t9+zncnSi/+ufLfN5m6Q83Qf3pXS9mmqn1FSK4wof9PQzdkkHNEJjGJNhkZATA4DSOMGB04jmwdVzepXGzIqLS6zCQp/wUEq1GHioMnxKcEI4GX4QLlGiSoQ0RJnwRRmHgqNLcBAVk44FjgSZMJCAaAciehIND26RC9qQyBWhICUDX5lcrd2bdt1mnGDiYJApmMTxhVRuQFAKnGPJPYdChkneulco5awzbv03KkSz/7NarnRZ4tyva/m+0cl5hVw5SVrnO/fv4707Wy7mjEzw7ujYgDyMVq/h1+T5nybIcgneBiR4vYAUfGtN9mzPFC97eZweaD8bwe3gJH0Mkd1AoUarNJiGBHapMW4XpVEjrqWRdO4xgriaTumOKPfitIlBtXfhkkHKqv2aEaVCq9hGUEsQcKBtQZiFB5AEuBQEyZEtSYAHaC4U8sRuY/DQ5vc6iV7gw+80FCM2cktiyWlKo+TMZohC6Bn7IxCCEyTZgbk0CSsiZkzHS4bmxSULhemSJSD5CZTSSZmUXhvOR7SVKlFN0h/IsxKIIJq1XWmrXdJlLSVV0KqWp2RW2tlpLVdZ8kRvqRDrKT4HfR905+4lu8//w19+/TVt3N8V1nb9CrIM/lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABpE9u4Ma4uLyChdQZ5peWkz67Axri4OjIN0BnPFxcZ/kjF6SZrAjUTWd6xK7sMxMoEawd8kQGlDSQelKBnsgMVescEhoMrCs7QAtgKo5pRM8AmUbchdOHpk4zYoBhAmKqu1pwjCCYHk2vhyUfg0FA4XiwLo2pt2dWXDwMglKFxhYNJQTUf7BEBVpG9Bg0IEwBd+G7UzjDoQEXz5V+s7f0uGElrS243O24M7qmeXDLX3KnwZzrdbP95rcRsdCQtR5ulLNrwHHmTKG/u7/xt+ntHa7F3/JTL+duVei2IhymcvnWd/WVPhd36embh2v+X+ZMla+DUHMKP05CpIVtvC1+P2XBJQONDXBwqq8jDgjawYUBDiGBw6tR6W0BoIJgG/okL5EDAxQGQAgARXKhGJQcMkmyoMwuQkHVQthbqYGQZkkGIIlpmAgscSC5iIxBlHFAOtbAAFVY1qPKulJE5w9fkUch/aaVrpoqM3DweDNrDj73oi/pkISNXM924VjqphFsO07F6AuFCsZqBe73yvL9PpazePnd6/b0wLZuTuN3PDHD/1jlz/1lz7n91rLXP5vHWt7rejHpb4HTMY0hMR8ptjkFdmn4jSikUnZpf4iru+A4aewgjMtit+/R4O0WLkJ321NP8KnBi0wC1QjIRDgqRw5jFQuBRhl03CyVIY4iomXIFQRr97Jn/RsMIqZO3djzzIHoWGbGirMP0FRebJRDZgMIJJtWdl7GYCOBGEgQt5gQwGzbh2MDBsoQ6b7UlNWYPEChPG3eRxBwCUdeKZg2ITkcj7MCAep8v1B1uBrVswSCJRdv2M30ppPykdjOpmsNgsBn8MQP3+4Vp3CC72T4Za/VWej7n2K2BAqnmw2WZRNqNrCbBzUrihrMoMteoXU089o/DIyYU2xkQurnVujL2Ko1zKHTftnJhyGBel6MvEwztRKIPlHSF8iFlkJgKBzyaVuBp7XTJUdtkZIYXCcAsBiUDuGKEhQdO6dKoAoqYQTCCR8w9wVCpGLum8pksDLOT5MBhY6SoTAq4NIgwYAat6IwMFDClBnDRNIAmaFBSMq2IIi+UWSCqrhMUgoSAkZmYBlj0OERD5GmtS53G8huzMRGA6+n9VgrFgIyzdh7t55ZYVqy+e8dG/l3X3oBjOUTpdZZ6v+yE8LHUVa3x7v31z/naFXVC4hjDLg11fzWeAxbuOPpU1Gw/rNaNS6wCzPr65H8dXvlNKsnXKVfsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAc9PzmDG9ri7MfnMGd8XBsA/OYMb4uDrp+cQa3xcFo0cYImlhBZ8kAldAqicHKoP0MBKgMbhhthksMdLFiEzYDAU0GuQPToLzmiAK5ZAHLjZR05dUyYqkBS0AgEB/IAAgwh0VsbE4TMVEDOfw6oCX0gqCFYg8TKHoS4waArCoXLGUuMSAHhMOCDBSs4w3LPNMcafhlNBhLlLBGPGitdLK4fuRJwgoCt3jU9yVQ3nZp6Bu9qxMF8aiScqvQ9D28fuWoXWZZe2z/P//HKndDP+XlIsgsYcNtTv+PNXd/+h8w7//eTctmLMP/s0v/WK/N9/pJ12vR/+6546XqmqldL9Oo37O9bQyJXsGeg6izslJpiqg77EYafFpTJyQRgtqzSoIEYWBC1L8yMeVtSAjZCAiAKMuAnVcowQBZIKj4wEiM8MOPFRjwAcICIAQCwEQqXzYomS/4VApn0FIIyEBCAtmbp8KO4w6Gn0FgMNBErBMUWQs1Q4cCJqgJLsaZAkSzeh+HVTTMCgWEtOaa2WVOHWMRElM+MX6aGFrTlPUlD4T168vOAgAAnFnrVJvv8kmtLBa5G4P/f3OsbkF+CY76TkbIzR0Azyiwj2tdClYaQ1CHN0PdFZ5YBJj4USIGNWsFq3FHnliMIYnGhpYiafSIjwuWqbUja0UQhPpkAjqInR5wbTtPtASxY08EDueFQgzApIAIwcXSUOUiWUNKFSUykVagloY2JsSMSEAMDGFkZhBQcMEgV2ACSm4YeorCMyL7AoBS5Mts01oCSIHMEAITOZrQwqzAhDRlGJdiwKK5g8FrfHACQh0Ik5QAmYLefSdi7XHtQnGUQGr6bn4/VklwFBCVYxj+pyUVNT3XekEZqFYDiaCr5Zx2Dv/Pdx79M77WWAyz/e6zgR+9dmfQxfU7//9NXv+w7PPWKsCREtOsUha46peafW1G5LnC2g3QIJkvguLMlABzeG0FlgVh140i2ZUy6IO63hVJTUFJBCZECFA6NFK909SoMmuDK80DwctsgMaCk5jPEsEQgChwChGGHLQQSKhYBEAatNobsAEYm/QGYlASpzBR8PhXEQK4MYCCimQQIzCAjS/AQTLjFgFmIyOaRQo8Es0roqsd+VTtHVRMSDFGN3q8ExuGGQjBmU2gGLyakZzyIQu216URKNo9RAHBJxr8fbfuXaSVOPkQAHt11Hz/+1rUdWpuhjd8r/VHb0o2Xq35FG6l4tv0FyIesYLEAOAwE6LPWRriIVFHQC0wnMnqQQi4cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHoj84Azzq4OBn5yBjfVwbFPrkDHOLg6kjXEGt9XBcjQwhwAxizp2DEw6TCllNRL0pZI1OG18Ou1swKRCEBmTRco2cpRQcCl0F4TLoBLx4AERL4MBlBaQVJRhAbD1EMSjo7SJQgvmAxSJEtogOBjZQICIo35kECLKg4IjB4BThIGjFBhgSAijo0B6xQoBQ6BJgoEhCABKC4FBcEkIFgBbI86a08sCqdD5TIxqC0oD+G2PQhh+Tlg4fn3fWin31BoDuxKos8Q0CNO4E4CgQigyB1ifdCBcNd3JKbBTDXqbzufeUEoWGZJe3Hb7Xff+jQ//6PYimPFLXkQWOtDUFxVJA8xKVoqJtGyILDgkefYyC4eKllUKNmQiECeAJDAVNFB2IWWWtNcxfbqOVApUIzITscBh5NDgEy0CfCHyQlODLSIKTfMIGGImIgysptaMYegAa/GBY68dAw0Yspl+hEBiMJnVzGHBpGg4XDABIiGEoCnLIWGFZJGTwHDAHIbwAjMW6AwIIfFtzCwHjFI1lCWtO/DmK7GVRZKkAhEwJkjI5XPT0WMDwZHgNno3TSlgbt0kEy1nFFL5YmrYBgJt7hg/nP3qqt62kd3bhT3/d1uzEbExnfX9R3////8ldiEZUYpchIs46JULUUZmYqMcp4wfLM55UvbQ0mB+RoJZhkj+rtlmEBpesvvyuftjoLMLDsuaDiwAggcQBazaZPYxYMF0p2GFgex8wWLyIGmCBOKhoIUpgM4mtSYn2ZAMiiDSkLXjX6ZAnZlkUpNyEwGQjc7BFb8ApQVAYJB9FoKguVgUMoSl/BUSmehOGByHou8KbzqzDvLVMwpwmCD3uZt35ckYLBWDp7l6fTMgejfZ6CgFQHUfRVe0QgOWfD7b9/9zECcWHsba5Yz3zHdJK57lZ/6v////fe27WEYtpS1F5gY1gj1IOqUJlKmhy2rpF3CuAYqWIAFTh2mnZKOAXmbfBZMAuBYaO8iCUyBGSqNVAS6AGdHVjphQIYUxI8wyYERpeihbHyugHUQe+zAWM288cIwCaSDXyrey8wBA4w6eweP9WgdA4wUG04IUIZF4FNwAAWQDEQKAAEH6SdiJcMwNBQzCOFW9IuNvDAKCJncCN8HEaqF34IjrlzbomDgaphxOehi04jb/SQ+gLx3TlAHPsIgaa/lQOTl+/uxSqsDys/mu95neglJOfgypR//8//////+3+t13///VYYGGAC1h2QFJZKxcPm6nig9YjRHWDQUCh4SB5wBFRcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB1CBOQM8q3DTJ9cgP3xcGrD45Azvi4OlH1xBrfFwbHmIkDjcEvjYhnkDqBZ82wiB3Csu1IKdN8xGOBQCGHASxg4CVy1zABkEmXBypk/gQsnLMBCMLgMEigiBwGQBgwzmxhgGCEyOR0IHpCwFXUsEYkEZqUAA0Bq6IBKZBehjmGHAAwFBIYPACWKKkMDAIZ68oXE5sUIltWROgOsXASIn4VqCYTAxO1wsjE7F0YwxMA9sDBAJKpOJEXRDEx46TRUBuYakPTDknBuoibDkkOZS5mLbGUN1h8Zq62MlDkjgLpkZN//t//v2//////q+p/etfVZujbr3r3sundG7V3rcwW2QfKvHNW3qJmhI/xZAL5yiEp9DRJC5EEdDtrb9YBQIMlIyAPMPIggIMdE2XMIDAM3YRWLiJFyCYABiqBtY2IQATJzEiM7QuWaY3Is6SoHgJL8LggxjrjPgaDByh1GDsYauphMomzAaMAZZg8AyITo+jgKCACkdKTV5KBQuoGhTlLBT4TbuGJQMpovZyI+4UbYSYLFi6qtipIk7n4fZ2KNsmM1VUhGQKA3Wu1IV3H8pLFcm7cuLKkHfywmWZw1n2kPfq////93mqqiqFqZi+nLUCKt40AvRG2FHzSmD/AYYx9EaSRxHyA2BP9Az9RmIVIabnJapVOZcJRQMETxKRAK3UDCpt4snUIgEDIiRgENk0jOh8YKwE6mCCx6ROngDphAesVEMiCxQHGBlsYjDgCAg0FzAASN9I8ZMxOMRGFkSmpKKKoFsUHELwSADaBqYa2JlkcoZCylhyPJnxXGFwI3WB5Dcp6pQM2PZZ1LLTX2fy1SoZyurxJHidcS3NPL+u83I+0+GTZu5f+d963yt5o/v/V///6dTqCLRpNsO7BaeSbiqQdeZe9FKliSkVjSBQBMsLrrtNzREQcEjx0CqBzWROxGXVnXIiUfi5YGjQC6qbwBmLARlRkgPWwIjczEjL1DASYkKKUGAghc01REBiaLqRgy0ecslACZA3CQmMBC0ndC4AMNwI38AgMHwcDDBJDP0yYxe4QdOCEFTpQITAQxUBAgTRZDAOYbMwOwiczE5x2GvtkhUsa6YCE4KAMSd2llVI7zRVwTb8Vdxuln69xgcoq1mJz4cDXV1ak+P/2de/JlOe2fvZl//SvKRAjsfmHM+V/v/9P/cE2Kcea0gQcsml6C8cHHh9BpDypadXJl1qGB8EQ4aYJRgOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaXPzkDO+Lg08fnIGN8XB2w/OAM84uDuB/cAa3xcGdOQGEEE4XIIFXk6st6oWvmbd12IVBLSwYPGTlyHEEDg4LGN6qN2AySGwEi6EyCh4kABAkzQjCCrKJLIqzBUtamauCL2WbGnTSoMboww4HRICrjMCgAHl8w+QjnAAGBRK4PtposKaGzMwWNxCk0jlpxKJOoo4jc9ooASiPjQ0VrltWK3mYA4ESGkn+9UqxiFbFlE/KLiz5eXBe3OOuv3PDdBDlWVb089v+b5XiDUbny/+nv/R/7f/RfvUcRiyFizFreXFF0JFQ89615dihVYpnnjCiwUAIBje8B/IDKfbDAzZ7rZnZdmTQhnlogEDDSUdBDHRUBCBloy0R71wAJ+ac00wwJZSDAsIAjKUMhcStjMHPD0T8umYeniQESADdkAsIMPiQI5oYL3WMFBM/gHDIiNBQxTiToYiIg008waAlNy5ZgIFGghaNAyWzULoKd5HhX+Fgr2DpVEaeB50VAOdmz+3rj8tllCzrKkgld0eC4Kg/czr//J4GSVH0y3Vnf5v77Gn51Ha17+///1/1emizIraA1lEtHOkjjmEbnM59XFBZhxjhQowldoXOETAhaPRBKdJJ4FbKSDW+et1HNf9Y4iKxhsbqABCpGBaa3hSN6SAVDZjQvxRRYyWGWJipBYiaQBgNXZQ6AqODc4bMGgUMXg0A11uGOAcRAUx2UUMwICGMCgpN+JwwyrwHYRghAYIBABEQDSfRNUTFRSYSDpsM2GGwW/zwuEnM3QcAKepABzUCHBQVVjffNT9poZhIB25TR2OigJd16IIlClc7TSFNSHCEKP3KpY+2eu4vVEcF07xc21+s8aJozby+5T20d2c/T///tdxQa1UNtQ0iqARzzs0MWgmEXD3tUBBxsTFIncKUMDL6NLHBZg5RqQwsUUAKAzCHef9uzI4NeBmlIqsSChuxgDQcmshocMmKnJfgxEQMYIE+EhjAQRW0wIgVKOuBhciaODECOeynEoCZ86F0klAgYgFahidThp4Fi8DAWYRPh2GvmYXWYVCK5xYEFAWAwGFAEYGAapzBgNMNmkxmLSINpmS9vZt1qV+0MDCxSfVKNg7WZH10gCEGvTtn46krLoxJ4JQJc3NpAxEZC8korlXHuWDPnB9cd6nbHln+6vqyIX7xnqLBn/63U/sb/3xuNMkVp0ARYuJmKjyq3kgoQJJCyhUWGEhQSD1MAoiBVSgCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHSoQ4gxyjcugQ5xBjlG5dRPzgDPOLg2yfXEGd9XBhDP2BGcgShlq5G4pVsVWJeiL6dlUoVrKhUCwqT+DDWpob2UosDEVy1hocADQKVXMGBRIoEA8umHQcKJkogIFGZqsMF+jE5Gj6qojA9IwMyEEjFYjAQFDgKDB4YqUph/AhI5BoeCAItde6/kOsPJGFxhbaKaL9eQWWSQgsGXCSGcA3rYCwMUkyifJYkwM2QIEYmhdI8GoA4XiIkoJxNi+ZCvogEgxxGpEx20ElpJmRJGyhmk+oui+CgMvILP//6//7P//////v9rrXVVUtKuy7pOtVHtsyGu2+tBfTXUnqSVPTL81e/P3fCpRrSUhGkdOiY6hQZ5ouz1hjR5a/UCqLLqKoMMJAtG0ykAAgOGNRrJW6BUEmVgGw50C6DLAwPEwBMaGkwujQEThEWTVw6RfMqkMWAqCxEDFUWDENZOAA1XyXANNJvuVGDJWaXB5c1R0aCAgAMXIgkxRi6gxzEIKBO01siAlg4hmCyF0gOSnDmjNDNlQvC3FIG1SBmBEzArBegTsXCEcN/WR50LezcAgEQViPS3Y4IuUxmWYmHquiNwLvNjIvnv////t//////oan/bRrWrSq0bM1aNbaqK1KsrqUjvWjqqrR3d521bue/rbkbuoKHQicDAKAeRTBgtGvRojJoch591pK/HS4WAejyIAsnudDHzUmzDpMMsCpeJVARhYFtyMGFBrACtAUU5rQFGADyZ0KAcBDAh7dtPhKJigNBhLBjBYETGJgKRBM3uKCp0TVwfGAQDhCyUCARzEW3gaEYlB5yk/jwbSnks9ahgvm/CVRlQNhwSUZYFKLFMvIBE2MS6iv2xCBXuiStlaAZ6xI2HScvS5vIdkW9YblE/nGsK8C2ed+3hkubPLC/Z89Z5L9V3nq+rM0Vi7LnNBQUBRecKngkQYgInBYydNKel5g88RuJCcCCUBNbYiXyPlkztxC6ul6pepCT1GgNq6ToRiVsCIqAVDjCj0SGTEjJk76gEfNdPUHi9gAB1eEAyhLNlRgZhgIUMWNDzg8MADVgViTYEElCpkYTqiYtBqQAYycwYBo4EIExsBEIbcGhCpazJMVrZMELZAsAZCIBn8OA0JqYzXngf9nr0v6zYwuAJM+41eo80lk7OJFatXLqPUcjX0sETFiAV8YEwB1sKSi//3NP1ZXhY+J5//700dr0/jNo//3//q+z1F1GRoovWdVmxdp1xRzUrhQ81RMWtngkwYBRd6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABuY+OIMc4uDH5+cgY3xcHbmw4gzyrcubH5wBrfFwiLvj4wtYz8GMxwSKoExNx2ctYYrEq0Vh8kKBioFLChAUDAKcKHxgIAqnLjmFhLfQfCFXEjCIUJgqahF4hJppAFmDBIb4C6jRgcdFAGR+We1lnxglMC1MDhrDAECppQsCPJpEKxCwoHgKRAZpJcFNQtmIB4ZGUAOD6/pBLoATKUhG14GMzgJBRp0jlz+w4jOjWx/GtV0Wo5H4YyYNDL/YKMTgyCJHlR5f//NTWNJRccKz//h7xubR1Tn87+j///fmJeAVH1gMMqHXTCVyzT0P3PCREOtao8PQXkSLz64BkRaMv20IStNJht7QOqy+A5mGZTBFqVhyglcaeFlACDSWjZGKDRvJwk2+wCMq6GgJBDiE0wpvHrkwk2NfRQqAGegDwNLglpsvMPUMBGeBFBTBo8PDqUxuSCKTCoLYCjUOgBuS90x0EpgcSmZ0+3BqrOnZjtLHZUgkLrKhh/P4bj0tAQehPP5TQc+WfH8WLQVrzKcEhYF1fp//9yuW4q32ewx39Ydym20/O73//////Xn46lB1VAqLNuRaRy7CdTnpRLoALhAkevB4DGlIsjKGNQxhKABosBRSskPTxuINgcoLiwwiAYSIQCKgQ26oUAynZIAQ4zLHLUmQA0yMQluyaWKxg4PAqCiAxCpFZcYEIAcEAaBC7EUMAAQwqMjQgfAgDLWiMPAxHmA/KZ5DYNB4QKGflqU2xoJtsXvMFgcyMq0bGcwaO8UkM0KCGWDRQFkiF1InIdxJjgK5OAYFAw2CLHjcuA2LKhWIIfEKkAL5sJzJUB4FIEw+2vWcJ1EV9E4NUtVOcMjUPcMUFP//n////////q//bZTpK1LWe7GTP5z8ecfPRAQW8t9v/LnaudUcBy5P8rJUwDOETnTBTghJZciUytQtlz1TDWKsMNIeAhCQypEIKZwBEQoQHUoS+IUI8YyJggv+hg/oobLXPrOBQINyBxCBnonyZxnQuPBKdpa1/ExxFDzdYBCoNRmBJ7MtXgwcWAi7CgREgGPBgRAR4AcGa5gULmCgOaXZgVAbLnfgNpsPuk9yWZg8Zx5i0siLwthYEYqEsdlctxn064Ot0kYXVEsXbHgFQCoE3apYa/m68GsXuJAWtRaxvH8c4wnBhl99v/+z+jZ/X36Row4wKitIupRUOhcafWZYUcfNBpBZC1FTYfNDAJNmSwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAeObrgDPKNy7qfnAGd8XBr0+uIM74uDnZ+cAY31cE0kGAxM63wg0eLT9f1WppjP4sxdg78PJmyodBREpILAoABgrM8PgwABXWKgCMQA5UI4BjEghZIYuBwcQjWp/Ch8MyBEwqJgN6x4NmCEijmzpPheKmhkt0mXACXqctF82KTDGnBOlhkGjEDDkvwikiuTCFS0Kh0FDA5SIEF4HSCFljaIGGymAakBuvg6xmxBxSJYcwc8DGCSRMUTeCIQOI0LpQJsgxcPjKEDC5BEUS6T6dFFMbaYuA2SIYzVrLrCvmyRcf//Q//3//1//1f9Sv01PSUzbVMyloHfKsTk1vx0Q0l8cmW1yY7A84ybN+43VhwyORMw2Di3DjjoOLrBwrDImuF4I69rk081UEI+HPpKJGgHIYKmJpKRq7TAzM0ZbTafMDIixTGS0HBp/AcYGuByiML5kRYm4DkuVCMHHQdpS/zNQoN+hoeAQVApiQjHkoiY2YxNkgSD1BkkxCH0TRoTtoXQMLhk6YpwwMqosvcBfDY1D2OrBhUKhAjh2GnJo3tWyYLEUqkWWUbEAHbPFrEzBNqtTq8zS3jVjJ7efhXswxglFO7kuOP/31kNZ7QTV9v/T0fq/01UULc56w0RAoCNrChsHBCYHCzFieGAdKFQcNw4YMtDJwEwaKmxgfBJgq1Vxg5U6mAFu5qRbYlTrtmIFaxGGvUjGHaZEAipZA8QGCDxqWymlLy7ZjAi6ZbgodltGGqRMCm/RwiiEJJVQTUyZiZhcpDJcuHaSeMWN8xKFS0icw4BjZADMiKEHs8GjUOAL3KcMHMAgdY6mhgkWG5jgXlZ1CXa48D7M9dUFLMoELzz0D0krayYLCcnnJXSRwv1LKszHIEno3ZfewmNLsZuUb/u7NzlNjVdPHf7ualTOuasO/K///+376HKQXWKAYiPINijROJBqyqx6Lyy1vaMe8pS56b1j4IcARrP8RDMLNVjbjDUohpX7gdgp9HYc0ZNWglzjaSkaATNFJCBaY0WhNcx9qhjoPD5hgyj2eypmLng8DkoCccFqRMEGWLl/TBQFM4GgwYSKEZUgkxZGkiCIPC8VWIwlAJHkVAlxwMFEHCwSI2BYDzBYFTZMASYb2Mtfdxr96TqVLwMEBWVic+exrs5eogAmUSyzOZlQAHuqSGSuVR1p1l8TaTAn9nMeb/4Fup05/Hb+P/jUTehWdaSZf0f9n3ej0ihOcJqOiUmMkpEeDiDINkBpUzFmizyDguNAJw+ZDinARzTJ4LHhEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdDbbgDPKNy6c1nAGeUblo8+OIMc4uDUh6cQY3xcH9h4E2GDYKVg4ctvGmmz7Sa7jYOhnTt2d8xoG3nMShUUBJvdnF+5QQh0WDLrSMHEQqgEwuXRYKGRVSYLSgkPyoPTTgmAwRMMosOCLXSsDOeEAYZEpu0Cg4VDQMSLOYkkdGA/Hhgcopo/DQGfct4ghZsYTAJgZgigCdWBDcTYOsUqQEJgQNlnEyKo6h6L6BOACKhvk6s1L4CAaRaNSBDnGJHpjnJhgU8kYiaMlZEusQGgMg9JFIuJpImKLf/5///b/+v///1anX9XopqVZN2n+CwBU4w6r7D/6gb6bS0csSxsaDoMvMIdiNpzsVLCYAhMJ0zwGtw67KaLu0lZmj0QPJ1aCoOQgIioLMAAgvwIyi+LdgQOjSRQW6ocKhBrY6EjCYDNRG5AEPCYwYIjHAJaCITFCFziQOfYhBBgnIExSJgEQgAwAeTkkUMAy40QGAoBAwRNQAIIaiYhAK3gIBxEajbjWAwhqRUwFmkKMkQgY+Bv2IDR0iY2kDccIiYFkI5xVMmKBHFEnCIFgOwUDhRGWPBfgi8gBEboLRXDLyLmRX0Hh1CERSKDf////v//9/r//9t9vUupRvuzyRsC2QJC161kJj7kZh0Jt21qG789FX2idDAWlaFADWM4CYTKmbL2gpy2PRnCedBTpGcw2DltmCgslCcGK6XDbp3iyqygAtW/ZiILgYPjKgHS8LJMwADjKwjQ7GZEYsxE2LtSZ0YCIRn0HNCd5BKbmZRiaAE56JRSgHSZkK5BUDpKpomJgMZrSwWBroNChVM0SPQ7JyQxPLTOvCrGFOIAG/FPjLfZVItSKZc+W526G6nZY7Bj////Ye+5AHNQr9f3X4JITuZ/9Zz////9rDIRiosIEuYsKFki8pFVEWGwuKqHqcpAwOOe0Tz08pVVZBQQ7SACUd4LQGSlgMMtFe2QOhWgxcBUNw4iXIZgVjQaYSYWn0MLKTgE9ymQDQi5iCIhCjN2kwsdFgcwUSM9A16kDCyKDkCbDkyB2cGYgwmo8IMIhsx5iiyHq6ShAvUgPGAGiiYCAyfRZAxOLzVCREgBGXKwdicgOBYJCCAjRPtfhyA52UmDwEyyU5YTTGIcl8jrIX8+ngHBK95rMuefv/9qptaPdyi1/6/jGswoa/u////XUmL2OfQVINJkSTSTnjQ8E30TLHKYJl0qFzhlAWdYXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHQT84Azzi4OoOJwBnlG5eVhzgDPKNy6NAHAGeUbhYCDBS4C0jM44WnukSXAXi7rFZfRwNPSJmRADTAQHcQw0I1DB8ZIHKUjIOMTBJMVRciG6piA7GAwQY+ZZg8RBiOMIgoyaEVLzW5xLsvsypOokARgVyGDwMsIlwOjAzvJTB2sN8hYLhkMD5EElH4IBgGTTCAAYnAxuophwlgdpUqfaFz0VHQCYbNKzZ1vofa5RwSYVB6Z9NaxtOZJ6S1UGgBNSrbjYioBnOU7Ju6/UemPV3353W//V5qiguNSvn/O/p/76dbFcidV0BBBRhdAXHBIclYkEIhUp4hILUgwAHlZU+gKiNpFL0o6QoYgCMRBgY5lMpmxJqc61ONwS4VZ91mFUegQIoTjGYXTEMYDdgkcBgfNwhEDApdhisCuUMAsRBEwCijDqnDA0BAGY/AS4iAgJ1FlH7gBBgqz44gGFDwoBDC4RPckQwughLeAgNFr1BHcacCQySgQRgExEKzbIkFg2wtRkZAOoNMRQY4MIgStBaKLPLCR8nSgAgmLNWUDpZDoyqsixfDcHjxDxSyYWQl2YlLeoiMQiNmI4/0lCkhM0FLar/9//9v///9f/61K3XUkpXoPugy1aTTe6maAMMNgBm8GW8rfPpmXS0ePA/TvG1O04rcTewJXRrh6ndVmiyjjzZWLOEYiSVJh0CMxBxuLym7DsgNcgcBJmICs4uGNAE9I8RysDGa1sBSmYXAxgAAmNwsguawJiwwoBBkBQw/JksjgoQGDwOrgVEpn2NGAecZJDTxkw2YIFAQvIUBMXQAhclmvTirNDjrF0gxIikRzgtkBwtAmIz46hyy4aC0AZaMSbJnioF/i4VSMGUDV5WOmAn1EMsF1RdGg1FZSKZmMY6iBNZE4xwaToGLr/+ql/////+r+r/6urQsqpNlMzs+zrpKXWpklsgy1KXWnZSSJvZakGZ1Ju7IshdRsvDkDKazfAl537aQRxnLkjwpggMbNKpl6VSOS9TyVnFFBaYdASQ4YClVDGYkQGRYECAxWTl2ugFxIx5dynRmYvjixMeAYRhcMFgEAJg8MMbHQMp8SAahJk1UHZhMhWh0MEDs7c1jARSN7AowAFFDlaVFGTCICK2P0MDIwsIIIbyHygMuJ0D1zUQlA4DUCQMyJw8QYpivh8gh50qHSLikR/KRsQwGx0tGRMkRLAFQx9TLsti8W0x10C4hqY0LApZ3Nf9l///f/7//9qn/1f762rZTKQpMz6a03T0l6luyq2apHRXVZnVP1QukB4osakzKpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB2+HOAMco3LHB6cQY1xcHX4E4Azyjcs7H5xBnfFwX2reZwCE4iKY3JlLodtZz9umqpJmuQ69byxAMAgoBQgEjAENWrMHAqAknTIoNY40gwiF3FBBhmjRSNMCHUOChYAJmQAAgAGjQg5rC1GMUPREpQIBxofqXgwNHFGaId4ZmAgwBCITJBOcjKXOLPQIFgoYuXAGCqvIFGQQE8CIFMLKQPKVBEZFuIQzIaLkC6sGoMMKF8oGxmBQKXyLGpkRQhyJMCjm4c4gzEcUU1OspEUMSyeMyj0U0ZFzySL////9/+v///+vepTfb2qS01s7VLRXXor3SRSVp0bLajpoVqXqrU7sg7T6wj6ebcLFZxRIklQlkS9LaCxWIwp2ovE5C/EOv98UIDIXCxozRlMERBYyvgFHj7A2gwSAA7nM5ih7UArjG6ifA9RUMOUVeJCcz5oAIAJk9fiZIbsWpApMGYeY9P5NyR0NJeCQLU3dwYB7DXOUvMnDVdrutLmYBl9NjABhsXMXlN+ZrUssAoA/Vi12pCqfCnKAFMX5TR4ov2OXZz/3+E92Q2uU17/1+V2QDXf3f/7P6e3QhTcBNKFWOVMiokYsNzyLY4PDRRScAJWKkZIyKCqjrTzGRGhDDEMKcUBQFQ87kKibxv4+78UDgDIJFQC/gCHA4CTJjOXnRQAhXDLOBkDK/MIBoSFZqclBY1magQOCwwgKWIGWialnJUpYAtmMAkAQMKAVIwGg88GeDG90N3BYRB4aE7SmMumDgCh80EwOFzMijZE0l5TFhZ4fiVAsTA6X8Ao2Vhc5dKJAxDQCn4nEuJm5cDcFFI3OCySLEELooA6F/SRTTJJ12MiIomGNxBBbsiVTRnQf////6f////V/q9dlrdS3X6KmdNJFtlMhSQQrWi++gjtpIJ1KdmSY+iltHDCBdaqUFZMj6TuiwyCZyhmVmqq5Kmb7L9ikXkj644W3+GAcwkEa8YSCsMEQk8jyCMVM/FW7QWDi9a7CJSDsUwInGwgt0IxlYE1s2WFR2CBRgqDIzRQdUVA2wA0cnM2kYXoJpQElgBJMIGrCwSIQcsOyMdAJl8Foxxt54cwfSu87dSgWpQyOHoBl1ieVBOz1W3WeDmMslK/Km5LJ9JyTudSv//rWvhr/mcdf/6moF/C5/97f//9DboxWqp6IOnxdAhB8wRUtB1GsAFbgyoVA5thlAlLi8WfYoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAZuPjiDG+LgysenEGN8XBzKDOAM8q3LKZ7cQZ3xcEJjoF1y2xoIDCPZLK7+S9pr7u09UHwA5BCUgAAb8yEdFRY06xbottyAMVPPHgAEwQYWNMsOKFzEDcJCQKBgMzYMZ2GDRU0lC9myYQiSgCAA0BFdgYCHgioMtQ4sABgQFxlyjAFV2nUXORBBgtM1l4FA92JHRTl1zI4jcIk8xiGZPXm8F9DQtfW3hVyWDl25XTOhvWT03FHse7qf//jzUV59Dz//v0Erwupf/////foR2jQ+YCLTwSY1ynnRbCLiKCiAyNWSeccIhLYxYnxRaaGgW8XtPGgcYuauiLsVlfW0c6Jyh4V7iIIJQmbIg1yCE7aRXBAIYyAQhPUECjttIUYB2MGBo2Kq3GFhCR5liCNByc5EA7XyYSi4OKo0GlJgIWHoAeY+iYAAMFkQcmE0F5gQFt3UkYIBBjsmKJtrA8GQY+zWqSAzDYLcmflcZmY7OO7Etbw27Uo3hHo/n9PLMWT1vznu//4892dflh/71jBFsWDH9n//t//am1onsC7Ao4+VGjQqcSogwOCyDjCSoELh9Aoh4vUuwWV0hoIq0YFKk+1SJBSiJsnduagl+soaY4SkMEBUZAIyJC1ZuFGEwnXw/xEpWUK7IiU04RiFDA0uHUCBsIFCEnmLxsscx4DpdXLPP03YxWllCUaGfmAxMdpgJjMmCboGBtDQ0AhgMM/U1iyJSXRqwcIoxKwOkgBZDGxaAIAIGR0uAMDRvopkVNxzQ7YsggSBuZhiArGhXLxBzpMx1GYZfOLLxV3lNMwL7OQw07LNig60v///b////7/3u23e2tdbsuimyKal2Up7LPvZOquqykkEFrQuplpp1LrsykDRy2t7axqrOlJ0cSdULAIB9oIfGUK7LAH+ZiyuWt5DExywu8LFBho0xgKC9swM2U4pACGAokbLkHHrmgURToKQwwo4Gu1cpgQG9hhrsuFdTEX0fsCIMMPQOIRKAzA46OesUwG4wcT4LGgqgctZboCCVGyBJoyYRVDoJj8kguMMBlmBigGtLlssm9ZzQQD4vazu4vDS85PTW/oob6yWZ7M2P/WqHPKAv5Q7//w5QWvNOT9H0///7VazOouuAFhwRoJjWEHOnFIKB5wCLsU8lUAIq1ShA4eAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHPYE4Axyjcu9w1vBrlG5dQjDgDHKNy75HG8GeUbklbA4h2c/lC0DlwzbYldUKt71N0huHoiuEKDscBjODIAPLOHBAuLABuYJBJmMMu8MgUDBhNUEAFBszoOjAiQAV1MCAs24AhIGGKxqpNf0CLEZgYFHpiQHKAovCg9MvUox6tQl0FQcF/CYErXCAQicztQcLgcx2dQKAGTyYWEgREwviXgvcB/IwZsV2WTE2IYASJJU2RMjAQTKp8i6IzxxE0FwmoohqfKJJ2yiV1XYc81SrTRSI9SBt//9X/////13//tV31vZt7ftdKy1mFNakk70K3Za2Z3drKSus2lcFTXVUC/7YhZnihrhPacIKZM2qFizQmTM1dqB01GmPa/T+uuSEQxAI2ElBjLbGLh+/8Os0DjqkknMYlAqrjBQHFhObFFZgVFB0MTuHgFHxQ5sREYDZq1BJsxAcSsftkRmEZjML1IwHUTSIBBoFHgCGBUqA+GDBQDYIBAAAggbnBiomAuWYkTKIhMOMjgNaWFBEsRpikZiCgGeDEMWbIG5sUC6VS6MkXVkqJyJgQGPqKRabSKLrJM8keP9bmwo7FM62r++7r//9////qr9d/1daq1WSdM6yabIKTWkplptqQ6C0FvoJml1pUlbM61JL02SW87XMrO6cVeRrvD802uBgw477piw86zixVk+5dEnbc0LBkRg8ZABjMDhcIG3xqXieEwEAjBY+XazowcDWVCICKmMll8wJAjSgBJC8ZcI5gQCBhoCAs/zCttzAIxIiipUrKICccgkozjQeMSENBAcQ3JAilSp62mGIA8ZXMVakdUkR/JwM6G8LMA+4ABoKLcPBGoojsAxgYijmzpiwE4iWzwY1IkcckkA9ItuaFheti3Is0gr3soh47kzBTf+v//1/////q6/9TfUq9dqKa0FoJppLqTep12dJkXXW6162rQUi13WtF00mptd2ey0kKBxZkrx6ErzIAFKDl5Fj1TpjIeO/PvpKYi4j3QxCiAdGGhkoKY8BSg5mcZS9HgGhUZC7OkbRgLRMRDRixro5Eg2ASZVATCiJAQcIXw7FGvFww4JCTDcJYEwcIDtD7MgOk36AwCI0uUSi7COYKEymKRA4TDSBwFiLRPSXiLi8FpJwUsDsAcAQMgpEy4gVwJKhFieTNTUhpXNESYGCXEEhiF0PZSZZVWzqYkEyPTRKZ/0SbIImWTPX9Bfq/96/9XX6+v6rWr+v17/Wy63RSTTRUpFJ1KWi9Vq00UbqrTfa1NSEyW6cwRQS0XZbqTWySaqDoZxwQGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABy6LOAMco3LTZ7cAZ3xcHe4c3gxyrculQpvBnlG5oSEI4xyEAQyaLSWB4ah5/10xONQ3Ze0gBphkCIdwKDCwAzQxwShgAHA80IBWctlAQ6V0CQMgBMOH4KR4mVoNIBrEOvMGKdua4XEiiq4VF6HpaQeEI0Bz4pkMH681cDRQICwdU8TAQulNKZsoMDDAyQTXnSsd8okVJkMlJcfQHoxiORzyQMFmJEgMSTMTBCaCAZePF82D0ifTNhsIiJoImY0fKBOIuyiuffUgYjApGK/6///f3/v/3+r/77s7dWt+pT0E16lIJalLZJTpLWtt0q9Sdl00U1unWk6KvUm9dB6Kj/C97EknHKAyZzrghkTDUCYmnAwxQKKvpgyh+oxQiogZofiEEICVrZoRCvRr5QCAsun5IYoFxUBBaAQ2mNXMUFCtxmYGlMCBtjr2V3IbIYcKBiEBF6FGE1jwICMHAoo4wXCKXqwBfZZosHWSrAiEAGIEuX9p4g9UTpXwpE9DD4GHgpGLkA3pG+gUF77zncLkAdr4e0/9VH708H4VJf//8xjt6tcmO//5amXl0Ze36fT1/81/6z1B0OOcVJD1mAEasGGEHYdJlSZo4wi4DickFQUaBygsaYAEuI+5lwGgLdm8o4Rlqfr/OJH4KabGLMhlpAFUX4MByQIAUZDVqo4GIAyYtCLgrVGhA4pgUJq2mFzGI5olaYLHJqkXJBg58CQTUrLWr3Q/EKxDDUNBFJEGCs9QhjD3dMCA1hIOJhQBAaKJnFkbWjBI2DpMVgdxXbFUJ4ImDdQZ4cgDK6EBEATdEnjYlRvAiCAc4nUU1CSl4xJ8uBcyxmaHUxlCdSLg01csE6sZlJZaP7oKHQRVaZ5PZv+vb/9X/qt19vdn/vsvSXq1qQUiuySnqdJ9BlupmdlKS2T1rummmt9Bl+ySKKT2nn3KoQG8CHloUzQRymiGd0wuETFJVpotaghcjLL7SoitBzFAzHg+BIDM0hIiC4GNyatOFBkZwLzC1BwUTljAwIkINMXKoRBASLJgYLgQIKamIR4gBkSdTOi8xg1AAAGCgBS8GB+c0XxIih7RAQGwYXxR5g4mCapnQT5FUIX7cl7C8T4zY+RH40AMshAkFHIJoi5TJMWsAB0SRdKyCJGFAnDQukMTPojuUddE+ZbqIw4oQlRm/qWZC2Thk/ttW3///+r6v//3v+1mrut03u88hWte82XQUgpkXSRfpoq0qF000EGoPQunRnYj0QiuNAPxDmQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAbdgjgDHKNy6hDG8Gt0bl3eAN4Mco3LoEcbwZ5RuSUSCUVcfVmGo8xfisjyuvL3PaZEZQ4z5QWqUEgxBowmFU3zCKcWlOrgAAClitgoAX/MCBlV5hg5GG2UPFswMRzMgmWiCk1EXjRDSGfYeOpQmiIGoIxgnGZ3qMcs1OGRGFSgateBIBRVdiDmEkIYMDAhN1hT2sTxFxzyQHSBpMoWinhqGpEyqQoEQxu6CKYnZROEXOB0yRmYlAxGWWkfLHnDiiMyaP60mIwejY63V//X/9v///////+zLUyVNJ1On1umu1r2dl3QVZF6C1b3QZSB21e1MrbH2lqNNFrJeYxhUKBQTeM0aTGSTZmwZdkBSaJRSKPszQRlJqBuIgs0gqQlhhy1tTAxMZN2YVQJjhho34WFgsDGgSpYDCY9U5OEBhIANEX20a4gKTmhZh8YPUAYhKdjh0CPkLlQLShgPTWKAsvummTBkFqrBUBOmJRoEcqcHwJuFeEpC5BWwAUIQGHcUimbjLE+AMHD6k+YJqIsTpmXTYTiZF9MdjFM8iandNyORQGOQWaqXsmUDFjiv//9e//+///9/vdXXq2qdTItYzW1JSS9TIOqyVaC11rqWtTV201VNdNBaTKZSU6EIojKENgUqLu9A6OrBz/tYJBZQZkbWIeYa3ahdOXvFEXkBgVEYJMYiAYCBoJOlAEdAChItTROCDh8r4GCItkYEMZgc2GPwEYCABtgGjQIMqC1azDEi0ehkBGCk8ZBBDTUiDBIhN/sgxdkTpYDC4tBwVEgKFgqXyVXZupiUAdEEHBJuDDSEI0OJEajTEsAxtAQXRKBZIoRpfDUUzM1QLIgiXkDc1D6nVGxAUhemizpM9zIuqM2UOQ3XI4hUTqD/996trr///V9X+/r7/0FLUh9Na6tbnXaqpFklpugkmzrQSN00UalIILdak7z6Mft55dn9EtR/ZU1tBG7q8jY0E1hdBI6XSxxGx5QVUfNxYkxAhEpjARCgMMUCtHIlAECKZgAJmqwOUAN/QwcrGMCgdXJo8vGDxKGH0GDoqkVrxjUxS5TZw1rtFGAoNIUweClfGBxictTRhhZCz2HQCXvbMia37X0WU6wsLTHIHYw1GXlAUEYCVmApADRCz41CBF0yGbIuAKZEfscMnIexmVEDdRZMh1xzEXcyoVpvF+zmWrQUNOpm//d/b1/V//svs7//vqpXuymsnugpBTJpKSrZeikizWd00GQXdHfWhRUttFTrU7rom7oJpXQpXdVFEwaCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHYIM3gxyjcucxZvBrlG5dQj7eDPKNw7PDm4GN0blN9gBLUzABCBZ7EWTKwPHNyidZVqWPBJhGBTBQOW2ZMBRACTcpWDAWvBMQeSKgDVg4aMiMCgZHkxiTBoFmNQGBC0YEGtozePkrmlue4kEGMwUY6DjEEwwgGHSgyZUIImzwSLwwAw8YEBCeagjVmhmGA+YdIxdCs/ZLnh2iTDmDRAw2EWsnhyB/HUcI0PiL7LPk0HREQI4umA4i6kgNJIjEUjhC25goyZZEjy6msRZ1pJdf/v///q//U33/apbvQVe91VOmybVqUzJpLTd1JJ87UpmumgbqZ6B1bKRZVSKCkFrY1Eee2v9uRWDnxVcusFjJqVYrFTmS8YnMKNr/h5qNBDTtRpZhYGowJ1VwM4hINGEhG7iw4IERg4lDABZ4BhHKzAAZco1USRwVjypMEhMSvyojBhnZw5DwLudQwKGSY0J6kwGMCBs7wRjBk4HQQ/yAJ3gYGpc6K1Fhm4mIwkPAtSMPmhERZghMPkNRALFCCxQFxmZqXxogYZAI+M0E0iGma2UKkmckCWNI2olVtMsusfV02a1AdYqTpo2///V/91+23XX61/6v31+9lpbIIKUglTUlNmZmTuqzIOp+iy67LTXZNTJoZn961seZBFlmE0nl3ixEkl9AYk0sDFJhqPv8jPEHxkFOzyBWwTgyIzEQPFAUOhNCSBvQUBCIGBxGY1DLFiEAAUIszEYZVCYkJIAA6wQNCxr0ClzjRBXRjt2lWLnFgSHC1Mp1wqLjfZ5MEj4nN5UFspUkCQ42iGqmzgmCxmZsKrmtah9IahfFCkkCEEBitRMCinEE2LINiDU+bH1h1SqSJ5IXCicRGwiOMyTLJQXzpIyH5BWs602RVVpft/6///9f1f7/V9r6l61a16Na1WUitTLWaGCSWk1lUUFKUgtlrQai6klKRRQMkXdT1qQZaLGRihe66bKomilS2EOp9CXxUXa6W6latDSmDJFQ/dkM0qAhOTRDYYHTHEJuJk5RE28Jg46ITeRNQxgAipghcgsEu4qUE2IOI5jTEq0wZ4QMbArYuxN4LrYZeEwY18VUDy/M1HAJqgRAyFSEZjIy02XKMLTQcMNHkwlaKM6YDHBiM4KCA8BcBgMM6O4myqRIhQMuBLjsfPoEXJspF4LmDI+cIKsMglpajZ1KWdL6x10jz7IRumCzNdStqv6////q3+v66l16FTK3fq/vZI5QUpFJlLqTZFa9q0Tdbo6mTUxo6a01IpKqdNazqbs5i1jJAq9OjGniJgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAB2qPN4Mco3LpMIbwa3RuXPIg3gxyjcu8xpvBjlW5amrKBeiK4yxWxTItiz19HFU6eB3cYUsiDhUYhgmT/AyuMAgw16XxIFvqGAEx6HMWBmEwNLDAAVQ7GCxkFgQiIOkE0iIFvmdTkqxqDOhYCKbDAAHgSLAlVQUD5hVUGBBsLl4YFKeaJIFCbaplK3qJAwXgajOQ2jvEqXiBByRMilANmbDYR2GrpmRHg4sKIkmiowK5uQVQox9SQ56xwmLoDy2yJJrME1FZOqyB8mE0Ff/7a//9v1+r9Wv/1duza1vrZSklqoaKakkkUzzTjIKumtZ6mtJdVFBFaSa0HTSRTRpoLrdrWUmig+ut1nkmYy3BB0O2FWEpgYAImZBpEDoHidyWU9NATDCoXgUvCwIbYIigEZsNyBiwNHTFR+RIyAgNqmNhw0EnJDwweE1YDgQB0pfgxlJFgB04QzBW4UPzJgkSFU7gainS5QgOB6YCgANA6tJiQarWiI0Npg4OFRHdtjMvJwZ4P8GACNGZA5uALTBtGhWJYa4hIAQXDzlxFaBMGxTLyAfOUkVkSYMcM3Ue7sclBcpNVpD5JZlu9X/1/+6ur//9d/VXV++rXrvUzWfdSJ5N1OpVSalGS3WpNlVJLpPVufWgizMghpIppmg9XpNL6UGGV6RFQq8Q2hv2XzLXLCl+YlVd13WFQ1bjcfc0UGZhYFl/TIAoFQaZCQzWW4KhBwgb2KkQQiQICjOjCg3MDBYwgBBkombhMIACZIO6fPEJaqiXwMBAYLEOCrgsDDWxxMqTYbBwqGy26zjAAZSiLsxoRAEviYCBA0GVvOKTBAGEhIALKA1QsOPIePoc5MrkgAIPemaIFki5dKkXIiYl0fmFeNpkNNJVRwwRqkFP2rTRHahf///b+3V7e9/+tf+/a9SOurRSZlI61NWtJHUs6pdS21aTMk2i61ouzqUyNdJMzSouppms48YG7Xr666RIMkgCGgk1H3W42Feyw01EJyVOHYgAqisw8IB0BGZQCKgQDI5lDD0HB5jOshiYtBTFxAP1DjPZhCxQBwlJCcYHHq5DEhGQsWvDj/J3AAYgpEIBFvmCAEdqC5h5QCS9Yww5b4hDzWUj2BNfMKC4yqECYFr9YqaEGMBXyAhrQMgIUXY5BaLZ0jCKgYOIw5hqmaKH5A0KUSpAwjeUGrysyz9TskXVEBeie6kkSRdB3/uv7ff///9l/sh/XevqZq1LZXWgld2ZTIIpIpJtZZgki6Tso4gpkEkqDLdJ7UjJF1Mzo3YwdlLZtlMiyziXY6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAdYkDeDPKNw5NHm8GOUbl0WGNwMco3LNb+cAY3RuXtHgjFfENAERMxlnkCrBsVkkqf2C7sk5GBUXgJTCIHGHhCuQcO8OtyMBgEaAK4XRMGgeGTAoMaCYLDBILigWmBgcayAJdwweVmaJbMoc9SgwWagE5FF0jkTjcoAML5406EEnRIPuMQCZIZA55l2KRMjAt/W3wKiRERSg54sgDNuAtYHNIgRItm5mGiEufPmqQlhdUiZE6cSNhSrDlvLJKVaRix6sgVWzsUEFJf//+/+rr/9v97f9f3RUknQRrWk7IKZ2UiqmiplrWktdjJktdboUKlnVHWdF0kzdOtB0KSqqS2ezOtaDsgxw1dxVzlzzyIqbS/S5WeuuMKAQPC5A5DxQU5IWEJgkEjgLBoqfIxQF3necKCYxUQrjSx4oveYIAiWZlg8Ch0SxDAMarAaWRg8uiwMbvHGyKHAEQmAQijSyEwKJjkqjMlkwWjAwCnGb9FdViqD4p6GCRYZ2CU3DKzSVKJBRglYTsBj+ggMgOco0MBzgNGnBYCTyKkxqEizMIStNxk0xBpdUiVL2SKyhzk1l9tJSM0qU//+/r//V///9/v/0Nd2rSUq1Gki7TFT0UFOpCrVUylWqbUpaqSCk6aklLda0ap/ZS1Ziy3ZSz6AqCfEGWNAVNhniKTIlaIyvZuzu0buPko3FBALTAoFkg02gwDmQz43NyAsFyQHvgQAEGB6IhUXw4YOEZIigURRGZCqPy0AAOZMEXqHAEsxYpjtvga4tecAlB5qwyGGcUMBJjo0Jn8aeUAEmALKUty6hocCCwWazfNyBmBFB2iugY+eFvCY8ESHsqlwMLmp9TnRAcgpfOnCLG6y8HacxNaAtrOpayspNpO9K7k7OKq6/vdS9/1e+v/9X/VWtv/ajsy6bUHs9lounOOzULsg9aaep2U6qp52tUgtjiE8kdPspBzuMNKlBneIo1Pve04OYYlhk5KqXNwn8Y1DUDSKDXflhICgocZKLTqoDNRJj7iKvM4LWsNsBh9hwJEEJhkLmCXoOLwCemTkjETDmBjkEpVt+mMYgdGDAysLGCU/BuoYu+kUamgsETALirmR1ZwjeECZiJul5E31H8rEMJ8oisgAPRWhJk8iTxfJgDLDxB5qfaMeaqM45R06iOiI6P3MVaKRVWVcsv1TQqa///+v////V//61f/urUjdforZbovUg/Wp/qpVI3dlUZ+BKC/qTUQDyvKfzU6YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAeXhTcDHKNy1FFHAGeUbl5GJNwM8o3LFB6cAa1xcFTgA4OeAvERTWcYEu6NKCvfDioHXdZ+IGglASBnEIgWYWGjnmYDXAq2QYAhJ5tPSMMPBGuChaXGMGhQGKZcoGCxNw0jzCp0VxDSirrT5h5imCBeHBVaooIDA6BMFVgHLAgBBML2LhUKvkJAdtUgBCNjPA4EAHXXKBujKiC4pEiQ0wNIaE5EBIkXR3olgHESSKi0oyB4snkhWp1AuiDECMTNjhP91DsUhk16lkoTzWZbbq9quv/+1VfW/0P/fqXbXWvbU6nutj6ZipaqJiit1KRTWYrSRqW7H3UtTKSQpprSQouu6JkgybpoMYDZcMaTaUr95uhGULTyRDCFFHqdllS/HxgSNRtlGFJBCHphMCkgAKwqXUMpAeQRMUAZEv4U8YJAEbC4XKoBAJ8MHj4INRhQNmegUuUxab0aU5IQmMsEOoQDIUMAbZTAQkOHKExEjQQA3fZox5y37CoAc1DiRB0xSGG09z1lwlBgk0PwNWwwyaNjxPksTIFGg6E3TcmVHHLw5rrNBzYkOyXz021H+qUiRrR//f/V//t/////Z76tTJ1KqquiY1VosiyaS910Hak6qVJqlKRZVGrVUyd7ekpj6B1/J77FrNXIcGwG7NEMBMLxa44qwkjjCljv0FlYOLggLF40EhlIM0pnUkP+7wyLDJA8U1cYME7rFQaO4KAsVVAsQwaUTLIyRDMCEkmGifb6M+ZEYaD5h8KkQ1FgIFwWaVLBguwG1AAFgoUBqWmCADD6ikEM8AgPMoA2IOO/J4gB4XxFxOoGzVBwI2zAixMlUWaAKIJ1JkTcTuT6Zgws4upICz1G7qcg1qlEjLeOl1Oy1oETda29b1fZff9a6v7f+/r+1et7LutVruyaqCaa9OyqKaSzp5F6qTvdFq1rZ02TpLQZNqSC1LbQTTdZ9NSTqRNIk58wMunf5cwySMEeMhMEgD0uC/774MHrPNk9cTsjJMICLnAyZdobrf6PBYoYQwz1I4SY8AxQZEHc5ggUPQhksdA+2Y40Z21ZlgHNTVMbikDMEaGw8CR4DHWw+BRa670rtjSIDtJ8ydaSqIQEUSYd3L4MlsPz7pEAjn5bVwvSqTmDRGv3vavatrG1TRbPWTnZMwvd73/5+re+f++///uYqj06Vf//9rf7KIEHOa9xXUKHQgeePF0BILIMPAB0ksra00KpFgMAmG4EBEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHWos3AzyjcseNhwBnc25dnjDcDHKNy7PHG4GuTblTZIg06BCaOYigKqsJfaXPE1Je848/Io1cUIBl8AJbBC7aUCpLAbkAkWmXByqxJ8wICH5BwrKBCYICQNTACS5gYVmvBMzhFNCWMAN+GHJbM3Jj+RBV5FATVgKMVtw4kAAIHi2ztDoggxHVtm2BwsMvgMiBdeuQheK4y48A1AgLaQ1MumhQIkw5QWTkRNS0pQqBsaoLE6oJlsY5yq6ZgQjdR9NBpSSXoGRNkCZjH+/6/9m/fZerr27//pte1vU+iqyTWrRRNkGMEa3XdkVJKVoJutqbKoK6jFFaCdmVpsgktToMbspFZtMSG5M8YZgFjQJTN2YSQXupg/8ta7UePJ6KZ2G1KgiXrkpkwMW9NqIn9YYrWaMQxdI4FKbEzARIu6c6lCEDEk8QFhnITHgVXw615oDiqqjGWY0Lv4wwEG58FsBT8FCbjs8ShWPDqG0nZapMiC3M3CC+RhULRoPgGvBpFMsmZVH2VARZEnQTTTGoX2LqRUXUOYgRNKil6jJ2yg+y6i86kv/+////b9uv//b9VerXsvpsmYtNb0S/l5xhCzydV5LOtYmyvUtHILnGH+YkDGktWQM2eQEVFONqtNOuJKeXw9s+3DTcWblQlAooioHAAixM/i16n3FQua9AqvmIiAEqojBHSrIhECUENNcsDo0QRS8BhgNSlo6ZKmTwGEEAZDBjqK5GQ8Y9OZjspi4AHA4gKeFSTahgCW0XkFBYakFjPlez5VIaYCskXIEBuLQbcxFTJidRD3RxJomZwOSJw3TPCgmUTAsk0JJ1mxF+gkktFcjU1UHcjyRZaL29V9f//9dvq27+36u+2ta6D1LbdbUmTpJMtdlIMipBBNNa0klprdBBNNFa6SaaNbuj2c0acSSMEdlHKkHWxugEpdNyT3IRw4EM/nInCDLwyx3rEgjkVhl0Y21ERiswAAUQkMwUDDJJZRiWOhWBmeUAdmJACIwMi9ME38EyATmEwIAQOTSsiAxmwCOC8qNKt0kMVNUzCDwgaJOlgoGiI+YKV4Ga4qAYEKwCgBXygYlqIQKIwGZQADVneoibPjwXR9QOfTIgR5MuEUFCgP8PgzUo8RYeEVGBuaplwctIdtkmrqc1QIcykm1rZA0Y4ZP637f29f2/7dVu16XbQXr+tTL19KmtqDJUXrdBNaCKaTrYwQSXZaTtoIrUpGm5rspa1pK0TlNSCek7LdaDLZA9OmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAByeFNwMbo3LoUcbga5RuXQo83AzujcOqSBuBrlG4W0rElSIqIGGW7tpcK6muQcu1pcfrtgYOKnBmIEjICqAOCTWkyGIfMCFjLlJSmPA4OggxooGhpiANTjZwECnh1Iyr4zsxlTRnSYc9Zi4sIQhIxqBKNm1qAAnTrgEYDlcrpJROlEhFmyCIwUFMhaVN3RgcdpkWQwwyoygHNBgSKnx2pKScnCFY3c6J5NCgidFpLpusW6OlnLpPV1zeXGlI/2UTJ6tN+rb7Vr/76m7f+/ddX9/+roLUpmZSkrIoUpsmpp9VzhvSdFBBFqkXL1BBIzUk6CKC0OmmfdaTzi4jljM+gGmn0QyzgIAmQEiu8xpdIQrCq9LZT0Wai50tnWcMVIBiYjCDIzB4GDgKYOKTzOIQCYwSMIDbRD2CkRUARu8XmAyXD4iHpgsQQaAnVLYLb1dkGBQIh0KBQIkBg0NnhU0YOBw9AhCA0bVeMShTSnceMwEFQCAU/KkkI8iZFSNMyGAagsNMmS2dPFEnwMijIKeRZiNNTNJiLuiYEGSIsYWRvnSvKeg2ypgX1JIdlfvX1+7Uv11fv/v//a/U72vrRstnSdRmtJNrqSmi1p6KRxFaq6kaKVlLdSjdnZVlKOpuba0zSmpBemtjVFRouYu4EClUszY06hoxgUoGg1WSxx2fXXgnJS7wyKApdJAI0UpXgY+rxiCDBQc3o3cRpIKMF2GCow8MDgUYCPDXsCTM5EuLrmjG1VShlzjp7jIACjxKCNpei46YMzkYqokxyLIBEsx4DgRYMwoGMJOGJvZAY+SksLpkUE5gcyOCgMZglS8YmhRCw4qJTya1zQ+K8kZpjYULQbqSLWgtRxybaztupabopPt/fvvq//9T//Vel91bMla7qqRWyDLTZ1KWtS1mqNOdspaCJkxqcZ6ak0kbskyKaC6KDOpabUXpn6S70mQrWtCmbo51I4EQCgkIXvEUQeNOOXGk8Pr9YBacJ03Dd9fpALzEQPbqpYJAQCDmURIGiIHJmBGQINv2FRIHAk2AZAIDwgJGAgaaYCzUDMAhGgezVuMONgMGAMIV4cDVbjBgvO5FowcZgUnlFWlOqtV14IbVkoEDoNBi4mWvwU0isK4eHaANfJEm0Tx5EcIByQVIxQTYgdNNFlMZEjIqXavWdL0fCCzNupaRu62brqVv1fte9/r3/2X+r7dX0X6r0mpummtM3QemX0FpsdroMkYooPMUU02Teku502WtTGlbKpVVnUEDR1rW7IsitO61n2VOIgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAdNiDcDG6Ny3RIG4Gt0bhxSINwMbo3LgUWbgY3RuWnFgIrU4GHkAgyAxQFgiZ1t4F6u4ziTN0hpYZMogAwKhBYLMLQoW3EEC5FlkQOoIW3Z6YyghASpsYCJG/gxgBic4aJImZkL4s+sQA0lV4CaQaCKRXcaiPmQz4laqHKAOAIQCJgYQkahxYBBpdKA2KS0uieRyg9QoDGAbPMMAgq2MisOgLfS6plLKcoqNhSJfeM2gK3SWYlp3XQKqRdPyOQ6LHiXUz9ba3r6//9fV6v/9Xv1Or696nVrTZFHWtN00GRNta0ETd2ZJkEFIprmRukgs4pz7OhQQQWg7LdSK3M0U1miURuoKotSwiEylI05ZYACi8rElTtZc5tHs3I2FWnYcUsFpmolDg4ABwIMCFPDyOQUD9s9RslgXG0PDiY8ULkUxGXGsFYOEDGYAMAF4w68ygQVOCbCIhZHUqIxseaMlg0HRdz1CwqAMIed4GtqbDxHdmHMLoxhMj5JMYQGiRijFkpFB0DoGLIC2LWi5FT6C2Iq5wyJ9Inkqr9ZVke1D1JJOpa//qa1fuu3svVf1frX7dV+36aVm0UHZkWQsyanZB6FSHXqRWya2Ui6qbVGRommpbumbNQorVoLdbrUtOupU3QS0FGDWWJtfJyh5TUdFUtsqogTbFaWzDN6mhyOCEFCD1khnQyREhpBGxBm4gBjRkJrq+m+TjMUJygWMSCBUbDO8RGB0xmkiZgBqfdiOtwSlEQugnGi1fLXjHgoU3S0rlrNjKHOBAMFrnR6GQcIpwwEgeGy+XByxRywL8DJXxcJFD5kTcdICwYcC1IpDoTRQSHOpoj4UOE1QMF6nZ0iLPMTTdN2L04/7f69f1V1fq/v/X13s3Z9bNWuy7qW/Wnc4mtRx2oKdkaaaTqSebG1TqTnVqSRWs3rQZBCdSPqS3ZKdiUPEsT09crSsZmsQC1WmVBqBPGxFy5xgMMSyD3pcwUKTDimGILGgUAibF7yEkyYYflpYVA5YTCANBzHJghMjMwECFxrIOscZkUFXPsvw3UAJBpoinGiIBTM++oJFwOME6lpscWDZAohBXgAWMjAGfyKQkwOojSLHhogadIM4PJdMS4fIcCZ8pl5F1C+TnWY3SOEAQICnWbXfN1EsuZ9tMvW1fd/pf1f/e3b29/pXvQq/rpWuzoUHTUi6FI+tqZcROVmxg62dJBJS6kFnFrZ0jM+kzpnUkUGZNNa0roMySnU7mDEZYS7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAHSZA3AzujcN2wZuBjlG5cXjzcDG6Ny5PIG4GN0bh4llKwmvgHHFsVdtFXC2GGYcdxiUqht+pYFyMaImFEzWyUOmoPY4heZcUrMjbtv4AEZB4x0DFUkHWwBNjlz1Nky0CTGgFWNjj6lU0MyCkiRoGKgSbahmROY8ZtVRVlyIKogABN2XkoYZSAJWq4d8lBjiCDERH8DI5BRB5QUkTRSACFicUTiaRXWZzFZkZnCAxGR9ndNVSjRy6qZN0Vomikvfrr1rd7bf9f+l3/W2v6qav1ruitlLZNbIKdKnTUgnd02NklKQMzNE3UimYtTSSpKUkms12UvZmZFBz6j6CTbqUcUzKSRdlrmKaFOQFGBlR79Lalyv4FbOwp1Jc0SUO5OEolMohZKZA0SABgYJNpEmkmOgnB7KVlyIAhwhABjRBmABEGHow2ITP4GYGYILRQDoKcddSqwILRdJzmVF0TqAaMMKAOTjoKmqpqL/a80mgEIWJiLSS6MGiaI55Gi0gaIqRpFyqXUi+TgGALDJFGeOFsmD7HR7NjMsD/H1qPdyggogzOj7pFknG9X/a//9f/be+/vtX3V92ZS1+itbboppzyTpoUGSZM6rNJ1VJadV0FMymppOkmk81dC6JpXTfbctejghgXCYgkYbVGWbkCnEiSgb+Q06jM3Mjcezlb5Dg+CitAiQggABTDBxPtQcICTOQChXq27JAMPDQgZEGAxFDlIQnpzpUyMaYE5VH5E7j+GFEAKaWdsuT1OWii8wQVKYkQI0wUEm7Fz3bcsYFhUIZDOuqZjvGeEmLolEI8RokwpTF80BvCMVBA2MicNFn2IoyCA0lik0GRT0cvrJ5OP76nTmiaTP1//qVe/Vrts3/f/U/rfZqtndqLUqkVO65xaDsp1JMmhOG7JnXuk+s+rWmyn1UT7JKqWlQZG7oG6NNJGykXOoo2NzrbAmC0Qap91KVmLHcN9nxqKlmorL3TkI4TmIk7MygrGgAxcXkc4BCEcBpK/pQKTiM7wm0sBVPgi3MIKzXCYMBTBwtAxnjtsMdcK4wGgQcNLrCpUezgmRrQ2ACIGedOJGqOuwyTNPowMjT6kFMWSmTY+B3CpAZ9IblgljqJGGoWtCaE8yCyoWjNNAZRSaRBjpKrWo8vlhlkNT3+slu+krX/1bf+pG791WV/+vWmqr6613ZdFlIsjU6aSlOix6kyzrKSUabUTGypggy6DmCnZJPoGqKmWpFa0zBB2dS1uzMs3OomKCRmsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABwWONwMbo3Llcgbga3RuG4IE3AzujcuSRBuBnk25FSOoUFJQHWwMym++Csr2txisehyGc4nQvkEG0EEQoPABhRKmBODA0Y6JxdpJVBm/C5zBxiIiFgkrKxg1OYOlaCJffZ0VqMRVILC7C3vWyCR4x2zMbd0D3LjDHkW1NCQAnJSSh5IKsBhiGS+OkvjMnyuBosxEzVMqmRWWGuPmtzEc9kz5sWUseI2SrdWuovLJ1Tlx+tkjR1fW/fVtV9Fd//2/W367Xqr0q2oLRSTatC6L06RikpFOl1GboKUfTWxs6S03PKWmzpOhc1mbPWlorrSRdJlLRUbppJMm6kD5xBjqh6sY4JB5M3RQFLxIUmVZXq8SvHJibMqjcZsLB5sYEqiYYHKaGMB0WbEKEIcKrUiJgYGqFarsG/Go6cDXcg0bQPtdHRNUrDlXzEsMBLDhgAoCkZgugm27QNGScMEQJCygAL+6htyAuAhQUNxJmJObyYE2PY4BNoGAZmRcGZTJwc8fQSJnVIsiOssoMZDmskcG9HQ9BfcyTWQ5TI/Ql11/6lqq/dfq/VX1fZWyOu/+v16q7e6SlNTZNJKmg7OqlOoKSdJ0GUki1Tu1bIpoqrWkeTdN2pJrUpmRPJM1SLKPoKNHSMUTJkt0jBnwG1isodzRvY9bh2n8fttIxGYLbmVBIMe11GIjqj4QxLrhlAQYYGR1yQcKuMUBqJREMFzCiHMCKDqDNG0EECiDSlHrUrELuVgYOF0BwhITp5owSTB1evt4VQDga0dKerLCoBhms4c/iXyIEoIWIKK6Bu4osBDDdNzU+Kki7VEBSSNnHOUmkQeLm0y1VSs5QzM/VrYrbd1fVrf71/6mV63R99W377qvWmp27KQQZl61MnWx1akUTqa0DipnZSdk2orPJLc4YOlWklqNXUaAtxf2wSGwJqJppA9kLLy2JqPgzw0JpxNV/HGaHTNjbZ+XnZnI0VDHoNTQMLAdOExqGbTcBCGTOYlXEqiWwiBVACsRpMDGCQcLModEAQY4aFiIj8IQJAcXeAw6LzSwNEIAeswAIjpR1MMBUrMzKlSO8hOh9dLTxYEDAcNUCABAWc0XjAnS8ZHQIWHOJonlmqZIg3IGkySJsTpsfeRJ1mRF1jnpUj/WklI13T9bLSdf6vr2X9f99Hv/7dW3X+7vVUy1rX1ooVspSjxqiqmqpb1JqQQZJaCU6tlLpzXpmaC2ep1IHqClsko6mZpj5CkjTG8wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAb4jTcDPKNy4bIG4GeSbhwCKNwMco3Lcsebga3NuSqGgOBihCcZbJ0kIiNARGj7cXVZHL5LL2wumVAsYDAijpYFAEAIkKHkg9PcwyFXXfoWIbOiUXMMIgshmEJswCRjRY/SKCw7YvVZjGo+VhZ5miNDMBAI5EPTIBUFlci+xV51QLDoZUbiwyRGB820kBFh+Ph7KRmBuigfdjZNEroCedrj6KxmlIChWQyPnMDf1p02kxfskYd1/0+v7f/2/e9H1e991WVXpaloUak2nqSa6psgyJldFNNNaaDpuigdRZnSpOjUeqW6K3TTUkgzmpo9S0kWdSZ1aF0lmyz5uQqHG7IcglwyZQnhDKyiMmKuhQxitavccFoQoIDK4OWAGhknQZAGjoNTAAOMFkp115DQpnhCC4eNDBIqiMeazgjSagAmIREBG6JqX+CihDpC2zOTBYSOvl8xWSRJciACMFc5Ld+Gby9iRgUVmBi6hVKbhgQ4jh7TGaAI0kCFJIxukSZOqPvHUpS5EEVuUESQatJ7LWejo0F7abWf//X//V+qurqb/XtpP/1Kuipk01rWpaa00zFJFJBaLqYydTpKSQdadJJll9B2M6k5+pTIqUpk1JrVW5xk7JIIJs6S2dNSl0T6Vi9jbw3qnTvdkT8NIcdS5g7lRenlcma2SiASFathjQNooGAgS30RawZLAzQ4bBwUf8wKB1GF0gUcjTyAIfNYiJBYwEVoxafZzpWQjYIAz8QhMI5iWzIJSHg8uBxnKFQpOMRoYBGQSJJ5TZ7JARhNlUXRDSDga0abkCMHNTElRRSaZaKBDDheOIEGMDBRDZGPTP/NqObt3eaMv/r6m++r9rvX/U7/7a9VW+rWpWk13dqDLZFdB1GqK3UjPKRdBI4ma01JTjMibJIoOpS3ZNaTut1GKaKkHRUersexkkImCtqONBDlRjZhicaTLQaFsUdcWAJ1us3TQWycUMjHwNKkDCyaBlqO46VCJQLOU8GpGNgsrS5ozcysQpYGshGMkIkX1Ag+seJJMvw+xgkuLeKz1dBRJOE2jBakOYVKE+EoX1pl0SZO8wYFODTrUA8KpRLxDh1DkAnAeSocNUUSmG5LbOjOmKCZkQNJBAqxynqV1nTWPt6f2WbVO3/9uvV/1p/7fv/2tW7VrqXatFBa1vZGttbspmZFTIutlsyK0Fps5j00rVIouyK1InEDidaBgmkkkrZ0XTdJA0QUtI9DQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAG+os3Azujctzx5uBndG5biijcDO6Ny4dGm4GuUbkQgNq3hkFI3HCI6zfwHLY8zmBWMPRD0Qb8ZGjFAJ9gc1v2DgqYbK2cxgsTNWsYSGq+EAyytNIxlzFuIRIZnhgnaZ6ftli6tvxAAMQqBMnUeChOdZpBddHldUrKkaRkFgRWKJyMt6YUPNLhEHE8RrDLmhNAi2hQEUDY1MjIuBpxq6VRLlVlJDhZR0cTkehRVbUen89V1GBLVv/+q+3pV/1Wvdd+6l/22rZqu1lJrVvtWpBZmy1omlbpon1WdbooUVIoLRRUmmmkktbuo8kglM6aKKlrstSqSDqZ3MX0kQKl2vp0Fg8AoqVg+NyFQXXph9+l014Gqxlm44kGYgzmmMAyAEGJUjcQKk5saKxZhZgw8nQSgTYzZFgRuYcjGFAIZKIWmBFiMLXFQQZOgmbNYBWWBUDABoe9imEaYGL2BqIL2Q6P+nG2BbRCAnBDJEOS6IFwxSIsXRcoGHXm6ZqgYqKoQBj6bn3I5mUsnjY4YH0R9sznutbuRiSzF/rTpfqb9bu//1f11a1/9v9etL3qrpu6V0kWU1S1U90UVM9VkZspdSDU3pMleizUHOUF1IIKopKTdZktRq93RayZgnmwtpYVNCsqggYGQBJrtFeKVNymnrrwlrTtioQqqMAIUEEtU+3MbQLjYwc0qHEwcMZsAAhPowoFEcSTfYsCDZ6rAasbNMjr6xVHkwkoLcqBKdiAoM84yZkBVehPd0mB0lWdQxhBYFIzCCfrmQIbEaQwhhFhyAM/CDBBuRIvnS6UgGgJPmzumOlBRgxBlLRISTCaki160Zpm/UuUl1v///////q9nVqr7LvrVfa1dak1JaNSLqUmmmqigy0kjRa0EmpII6CCdS1qTQd01sZNQTWi9a89MFpoGzrD4B5uA6BogwCawKOyhYku1kmKarntyht+HtbO/69yUjF12AAUFpUGLCDFUewQDjGpEU3Q4GHA2vSCklDGplERpTyMBgQGBFWwwORVduC1CdJAOYFbJhULsTlxMAzoYmBCJElmh6sWGGHPYrY4TSAIHTRYnFgvEbhaMB+G6O4XgGoSDqQIeYqMEgvWRU+itIjy0giw8VqNkyoapKN/ONJvZ1vZazeptfVfb/X/+yrN62/2q2dfT++p9JTVdnes+mpmUtE8pakbtWtNKo+263NUmMlJLXXZ3a5su6060klVJLNKCzvhi4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABuiMNwM8o3LX8SbgZ3RuWw403AxyjctpRhuBjdG5h2PASM1ClLC8TEK0E5u5B0PthoJmAHrYGYWAChhjoEosBgkd+MDAJMNhSfW4JH1egBBDaCxzCqfElESjoCB9wDNotflbeEAqaiIKkxbSxVsBIdOCp4wCcho1QS9KmiICrmcQE+oICojE03P6JM3Lx8eRIwa4xn3TMyigdHcRI+pJRwrLNWJFDIOstpWW/WbpG70V9ajBJH9X+y32/X9n/fv3a31+puje9l0tJa63dTpOqpI+eWtI8gmlQNUqCZxNSSaSTG7rZ1mK0HRUipBbUqK1Oyl1VLqdzztFMgBTGCwqCCuQTAXZTTnqRJSAmZUsUgqehll5ChICnjAR895nJg05QVEY5ADb1lwQ1RVL1KcEtwoXpcrNJltjAAPkwlooJZRKzOIEOy1ipFGAFJ7EIIFMM+0X3ldUvLBit8jixgAgSpEQqywmzciwujQhgG/AhvpeTIemXSyKVHpTU2NkmMifso1UOp1LNtalZcqMH9jqq2bb/o//+gyv1/+uq7tamyqK6r71rUlVagnXTZBJ2rZBnsk6aCbGBgiivZdKlepFJi8iqiipaabqRdVS0TU1v/twqRCN6wASchcCJg78ivpi9kEzGmPROAeS0hB5gwAoTjFYRIAArC5D7DAGCBbTI8GFQa1odBaNAcgCRNgolioIDH+pcDnA+ywrbx9+jDwmIj05sJSxAaRBwCHh+0dnUtLxLVaHHGxDADMmDOCqWWGhaRIaXh+A0SoODHNNmOl0th+xfr2dE8xE3UshkiqNRt6BcmmbPsumV0Nf+tttv//9fq6u2v/9dv1s6lXXVRUpUzKtaBxBA+6BdQ0U1IKpMbboK2U1S02RWgpZ84pFNE3UigdWimu6DozXokFa2msysQ4LQhrZY4MslkJhUmrvlIptoZAeFYMsKYEAJ8mOArMWxiEpNdP2VI8mRBzBWHMwM6bUgXPAQGWaY2JKSarI2nrSLvGDIhNTlYYxMcMDLLkwYvJwsVCWWrOdJiaEzbKW3NERWWznDpKkVFfWXQRXSHkgbFlRcJgBIZp5bopqWkTy1KXGfVWa+pe1JqrrOqUvu/XX6v///q0Ovf7+9tbuvoMikjoMhTqpqWpToIu5w+pzJk1oIoJOzopqW9kGQQSdF0mZ1LamhN0kkUmqNUjFI6m6j7qVOnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAbYkDcDHJtw0vHW4Gd0blnGJNwM7m3LUUgbga3RuGgpfGSoZtCSOuWQwRfE5A1xWqFvZKo45AqHX8GQKYZDkKAQzlbqRoDASXLBmEQY+oUBKrzJ4VIEWLCIKiMyeEFiGTxUlw4jrMna0FjcChs3iioNChxNLgYAExXkqmbfjAHWYipKGdBQFgYbPzD9Y+SpUGWImYAeTB7hZWdOGxKB8BaauUDzVkEQpDmqMj9Z5tUu03mL/LLoq222Zld/uvf9X/Q///e9Tr72egpBN2WndOYUjJ1WdFqDKQW7LO70VrfWkzJue0kXTpMk+mtaqa1qSU61nWSTU00oH2WL3eY18DGRQBrvY4mA40bjTL38a1HXQhYqUPTIAsGpeDgBfeMv4bCbMnFQQxAbe2w0s2dQTaSiZoJKDFDNjMeE2KQNDyNgjjBwGjbSACBnztQ0BE30OAcfYgi5TtJfV4kkTdSJm8Z2aJE0RQxUBrQBxM4mbrHKBISggtVFmWmS1ZkhJBFVtdTovoN6lqr/9t7/V9//X/V/fVr31rZfXWpFKp3rpJqUgy3UikZKQZJp5klnk0UUl1VJpLNDqkFIILqugYMtSkK1pKu6kHWswqoVG04oQ8gyCPPAGRUUcUIWM3LFzJ9zJS/s1OFgdTV2PUqVpkBAmDBCg5Qkr4aUDjGICAOlxoRACGNqQgJzSBQuaZQhpApkMoo6YwVcMQBmpvESmpm2oYJKBBMz9v1aWauMle+y+UxQ6gnpVJnIqRyJOrAAiHZPpVMT5FzykVsV1PjloIONJRmkzJ/Lbq1ba0bLb31bd/V////6vv+2zf7qXUlSUyloLQVeijU6WbpoI6zU+bma1qUkhTUt2eo6fQRUyNabpLZJbOg6B0Kc8LoDZE3oaIS5poJeUeJpmsjb5uL5TEF5v5A0YjQjAjHgiIiwW+IJE3njo6HGzADNXnAz9gsufN+IS7icYqCGBC6Sxg6wjc3CJU6JhhK0VjCSVICAM/wOMmdB7CQRs7usXaisFZT+AA4Y0DPLPzRcMS8QNFEDWCzqZxZ5ZoDQEkyaMpOyZgZorMEUByj9nruxpNdNtqKKNVf/o9/t/3X/t6v2q//ZrdknUzWVZFJnUjddBVFbug5gtaajNBFk7ImKVj0yRQWktc8rM3pHU3VPJJUtNB91KOonAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAayijcDO5ty07Hm4GN0blqqPtwMbo3DQkcbgZ3NuVJ4hSEBUAUkAB4Mnd5p0rYMle7EnhyclpUD3aJQoxMfHBIyAvY88bQTWwty1BjEwlf4jDl+Ggn4AN2NkoAGaLNTD0RpkGORdaAYmygopLbKlCgoc1YkFwHKDYH+TyIARpAKCJl0UNyAVadunNysRhWMhygTqHBjyZroGghcxtcgLutY5CMxHipqkvUYVVP7uotI//pfv1WX/V9f17X/+tb30F1Mqu7UEEWevUgtDZaR1kkEE1nmdNF1uhWyR80Sd2e6NzNJFBZogvWtSKSlqSPLJoTAQiVlMEGaAhaccKBW3qgrbY6aVZwTLYCuKrmHBLGRQESsMoKm9VsT3MUG2eP6ZECMcWhPDYUVgJMnrqDIZspipSv16Kr0xgGhYOUED25io4ce5mB2QcpNzftWscC4m7cbf4LiQQcqaWJo1TNSOKZBgNWWG8amhqaFwlBZY7XdnUyRs5F3dSo3bKaqhTn8xZ+yaNXUv/Rof9+v//1el79qVde9qlXWtJOmkzo06K01JIPUmtBJ6DIprSdNB2sySkF3ZSSDsjUaqWukztTnaKlIqQZNG6poFjAZK8BD88lL8JVLTa0+GN6Zn6XCXyFW1KUuGaSINfNxFmdwWVQACmC/WYmOjD8ioGsUxxICgGRAQMLAQJraBB+LAEnZbdlpgDyEBT1S0u2f6lGMohswEMAzHoOQBtqWffBsggCASMSHGXG5uRQgpWKQACYmjFzrF9MZEl001R1ITqx90ZNuUE7ntdRVrZSvucN/2/1K+///+pT//XV/9bKVqZVNaT2UtBFFlKRdPRWmgg609SDIJoo2QW600WTRMkEUzR6mprmibJULXTcwTRoMo4tkDk8REGG8QlHOYDwHZa4z2JNbjdHDV6jtywZCwEeNGMgD0GDDzHrZC7oczQejIWA+BS/6VIZyBcPFl4LBoCCFKTKh5XdNK56AAsMGfASZzchGNmSxwjkFMnsTybxHhTJjEvomwGAAbFqHJIwOkNJ0fYHg4hpaWYnU0AbqmfPmyCCCzDUecdDPX2WlQzr+tNCr/v/6v1L/7//2/+/VX2nlrUiiy0EGnDZ0HbZKyLOicWmzqutKybJorSm6mRc4bmqFJdJaLM10EUUEZ1TIKMUJ1Lq4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGqI03Axubcs0RpuBncm5adijcDG5ty1DGG4Gd0blWxKlTwEYVIJ7M8bddcerU8klDlTlTjdBUUQQmiBScIDAGSuAq81wfgWAQU0yoRC6/jAUsuwCjcwsMNRBX+BoQwNaKcsAxsED6jMXYkIA09ImCg4RgKHSAnBEACucGAkGtyLdA6FXTIY04+Tg6i6aga/mZHqNzRRdFOMF2kefTZY3NZSYn0qCeqt6S6bPd9dTf7/211qv/b/r1vb/3V1PXZqnZkKC2dT0WSWnPqRUaLUfVVWmitF2SUnQSQamt0E0VrXutnRdabrSTU6SKLVvWjMTzk5ZSunJTDfsNT9YesTDu/AsLo2XzmFumlAjIQMLrKDCOPmDnSn3GCwEED0FRYy8Ij61VNjUS8RnY8pMgGmhzDGRVm7YpZTqqEIAPVKhTfFqDrEkwioDDCAlEX6UOdRR+Wuwk4UFTr7wKpMJFBAnAA6JBM+dNmOhoxWRouUV2QJ3Umotv/W3s7b2NP1+2/1/1fV+k2r/9nv9ut62+yk6KmWyJimtNSFBa3STQRQTQrWpBlKZT7OtT0UmUdTTMnQWpmdJKyJogyaSLJLc4jLGUWUmAKqFjImBeKQjPX4lsseZ74KmoNi+h0EAA2SAhhwykoa6aqiYeFAk3MRVqUAR/auFBBMMwtIL+FaiVBcFU0DmNAjXGRw/G65igQPOS6HrC4YbOwhUQHywQBF5myHCNEIPDOSIoQnyyhf4yIomLNMikB4gQ46o6lNxliEWtKQx6SJDbKLqyKnrv6nWvO91rU9bL/Wv/2qr/q//bqqbd/a6qkbVbd3Z11OyrqY2SrZaKlooveyaKkrJJrTUgxnWovKf9FA2RdVBSlKQQQQTOfY8PoGrCoAhYAxlTC9Ka2OMSjbYoFbjKJTDk08MOEJGKAyBZhoQ/JlBWzicWCFh2An3DDzhIFQCZQYARNBwMFAYcDWQGNCSsTDmENdYAYKMgrFSKkJbY8UTMdkBqgSkXG46e7LVUJx0G1Hix+6eTKcul8rjjAxCcXGatWWItZVtqMnoESWkpBZMml9DOvT0n9zh7+r/rqr3r1P1N/t1Vv/rXt7pdqN7bqdaBimmXGSZLWrZjRbKSOpJOpFjiaOmqymTdFaK0Vs9SboqRQOpJpLZ1IKWdQp84HAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABnyNNwMbm3LQ8WbgZ1RuWb4k3Azujcs1xJuBndG5QRxARiKizA5hRf94L1HAMzDTDYRMOxRK3CMmecomlNzOFZ+bIwKEJ9S30incBIc4hnBeShoZLDhiY0MLtMxBXMl79wpwjAUgx8ILlsuIREx9eMbVx8hEQQ4DJUQmohUGfFZ46DCMAfmPUyJFiqM9NAPoyob1nnRDiWUrL5ozOQJaLmyQ1k6zRkvtr/We9X/3f/f7/96+r3q2b7UetL1VVqTRRMHTNU60LXWtAyUZXW7rZB3TRotqddbKZTqUtbsyakUlq00TBJBNrOkyJyfOtRSupQQwgGgIqZyzesxqncZ5cIm/8Py0gNgqO5JRhTFN6oc1hC23Ld5UwyBeAvmqQxsEkurcRGExbXzam042uPUw9nIB1gKyxR6iBCdjUATRHER0WM8i6YUpjLYrOm/GvNPWCoTZBTxeIoAloOA8ktJZNiEJL0nQRd1onroGrlhn/qUpqHbMjv/66//3f9dbfv/9W2u611aClvZ9ddBSSkTjJoMYO6KS0FomKDIMyrKUktCmk7GqC0lGiaLOfNFqN0l0jcyQZ1O51ziCJu+soLitxYkKFmYeAVCMNoL0L0mpI9bLaV+7tG/C+zDCkcCTIiJrBg6vAUBiEIN8EWKQWhJfkZG3LNJJCwfj0kqEnAGgGcFKNbKIHwpzAFhSCP0Wdk1I7Ga8e2VHFqPCIwu8gJZ+2jvgqFjU5bRJtx0ni4DoDGKCZks6LiSRUyicc4gxFUblSOtVSPra//WeWtXoOr/rV+qrbX+vWhb//1bXWqii/tU/dOpTWTdSSKbpJIoJquyJ9mTSSZBJdGpbPQZbHq1n1ppLdJChN1ijmtgE0RylOzHTRVMfweVXgojJorN2IxGJU5UB3l4jIIgwMgKzTPBW5Cn3Il6eWHBRcw8GDLdR0wCqqDigRDJgIovkzQqtR+hlz0mCQ4KIBoNkowJG3NIECya4TehxvkZtKrUEAIsggoqWKQqGZFiJGpDQKpRkZ9IvKKIZMZIp5GNpJLUgfpvp+zLTzi/qPq7Jf/fp9H299tve3/3suvrtZVdaCr3WpKtkT9BSaZ9S2UpSbOigk7oMiykjh1ziTVsktSa9a1LZlqmaSruemChp0rhgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAaijzcDG5Nyz7IG4GNzbhjdzNwMbi3LJkgbgY1JuHggJk5wopUIQqMLhiT9ujTtSjUqfm4/hVASqRKOGRCK0QapO3BQXAzGwtXzRS0zKyYIg80gPEDGHHRKUGEEssM3PK0SYRLYAMJQDKgBUMHLyEp8GWIKYWiLhqLtV+hOl0NNzHnuYidOdLJdIcXh9Ajs0J9I6gosDkHltTJ/ZZPOgkT6JEEd1etFBT06dVSf69Wr//t9X/t1uv1++rvZevotZNtBaK1oHTFkpxF3ZRnW7MlQR3UtJbpGiaNaC1mtSbKPufd1IppJmSCL01rUgx1brecBFg1DRQRKxJAgKy50G/a7chvr2UeT/303AMpqOmbgD8GXjkngkVBDAAKUyUBFkhEQsnMY8hkhyDpBBCDohapmpW3OFtmYC18GsrXnHso/g9yMRKyK4R0dnFgUJXS3KgTPEJS5Gp0wJhiHm5NgYLDJFEpMYKTFjJZNJaZ9FbJsuo0l2it6qlNQepvppP/f/Vs6vr/+v377V7XXv0ttf9FrIIqqRda6mRN3XSWkyTILtopOmlZJaaDIOzLRYwXTRWi7JoGK01vU9BJN1LWgZprQOqUSocqJ2E+DpHlhlQ13YtLG/hMarRfBBsKErYh5bcIyhPYltEAenpO2qFrtAUgewanxlrqhUMIuNXZmSej+xKtFZKCS8HGq/XeSdARISTIcExAoAYAJApykEtloAUBDIgBy5NKD5oXjVEY4GYVRfZkXNhLTNJdA1TWidQ5cQKyqKHqb1V+orKVZVXb+9V7f/2WuvV7KVq/919JSupdBVSC1JoOtGykmN00FLUpNSB+pCuThI62IXWCkNuqpIHZy4AORN4FDgikOo8JrJuubslxUxmep1NHlsra7ORKcguJjhItoh6ZQcrQbQO0pniNxN1eWWA0O8wFAPyc1UBDI+5EBAyg+CDfFlrQC9sLZiBKY9fYjIhARP5SBPcPAr6YY8hABi7Ho1CmsmpJUsI2YqLBDkCQA3tNi4pJZ0XK7VSie2L66jGcqX1MpdLW35pt////+u2v//ur9f7J+zslRZ066DJMswUt0Kk0kT9mZNG7HrKueSp01IrdSKSCC2epVS3SRXmEwPG7n02cwRRRMnY2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAGS4Y3Axubcsbw5uBrcm5ZKjzcDG5tyxJG24Gdwbloa9S+idpisgtjDjO4/Abxw1JpiehiiSfEY4MAJCJLbNZMlvw0KCRkA8zWGGFy8Ci6jBpQQVU8BGhAKmPjXDG16GpBAtFDRZlfUEUkEFUBMLxQEXvCnxAKB7JVbog3BkZgYat+hlh5BInjcZgDqcezRkzNJFIkrVGyTrWZILUYyZRpL9R61SmqqUpKrX///X7tvX/b+t1Nqqt71392WtkF1W9PboXQTd1H0FulWeWjTW6KCZ1RspZk63QUreii63dZ/wl0dWtIUXHrkZgCTJw15jE5MTWGW6z143Ootwiw89WAxQiARup0DiVcBmYQ/M2IwUw0Vi6mICEoHJRNdBsgqJBAlWqXA6LdgSe2gtlgvDgiJTNQWkcMcFjEncGQokU2mOQpnE25tdebNAgZb2rLysXzhZOk+BcCJImLVqD4mWy5mbJvLjWNlnez/totTWqo1V/////9X21fsr3767q0PXQU/RqStRUumivQdKdZZjZBndkknSQTautBamoKWbposxqitZxlmrYL4kA1ACHDYBbUk+hKXyjau9KNIu68b2N3kFLUd6UKOjgy1waOViGzAcQlS6zOhmQzaYUTAgiNAxo5aIDEebElwxgQ1MAV5XGYChUNmBgLxJcPlLUSzAMsDZYhA2o3hAIuHAr6MNGAYxcUg6XWWSJgdJeHKA5AGKRq00nOCMjy7LLikU0i6tKbSOes/66n36tJDv6///Uv/X//6+/q/oOt1LU9ndWq7LdOo1UvQR56tJSaKHOs+tGtNRm9alOi9BkkaaB90KSeyad1Oo2SQQnwtKZ+gu6Y4guI27ju5qCoIsSyk+mmZ4dJAEYM6DmJlA84Qho7ihDViy0eIH4ThUvA3cSGQc2iMFMTDF7GaEbUmkwNKZ1RgMjmzYJLnBnwolq7a+117IedB139bo7oOQ4tNzSBKmBGJlgBmKTI0E0BZvXPJoJSzyqs9rr/6/VV16q+3/V1bb9/+j6///rQskvvUt3QWs+kjZJ1oH1KTatqDILWkikmjVOGaa0WWZmCDszsfRSQsu5kqbOkipJA2Ugp2SSmNUIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABl+QNwMbm3DC8Sbga21uWOY83AxujcsKxpuBjUm5aKo2YhA4aTSGrtMnsurNv/DE/KrFiJUpg4ktgHG77G4g7n4kgmJTa7qAMKH6EBAyYzI2AgGLNqmhggK14RoiiOEeiMEr1UalDyPIJGhlCCEmYhB1SwEQAD1RKRtMUaM4BYZry0xMzg6FD4A9sD6JoG5cuIQnkqSjZlKc/rLSyH809Wh21dH+rb/rWta/t/11e/b/19n1ujW7/pLSWjM0qLpJ3dSKdJbaC0XQQTSWtNaJ+aWdNZurYuMpkk3WitdSCTJppoJG1ajJHdE663RgWOLDNwFLEemm1YxIY29uUph56o0VRQoQmEmACDeAJXanNkgEZMCVXhBxHwLhFCbgIEi4LCIoDhEAuEzcueh1ZbJ2VGCEA8pEwBPr8OgADCCEON4NdSy2GldzF70BRngo0yTSw0NC8T3UACUpmKKR9I0FxFkGkStaZe1JrU9T+vS/97LX/b/7++r/rVar/tX/6670a/agm96KezOt0VOo3WsxQZFFaF3bZlIVUKCSaKaFUydLTooO1EwRKEkkAV3BkD/gpSwZ0KZDNeYEvaXzsYeD6kml1dWQCibVSUcUpNOMoEl66AKQKCppGCib9AYGSAMjQV5ESwmMj86QqNz0FOBPtxMFN2ZPw6r3GTjIqQEZMOgspf5HZqEF0z8OgDnt5oncMTEh5GoiugQfjlpIILZEixe6yGugms0a5fmiN0X/Osz3t/e///19Wz+pv9df3/9eh79VaKnrTPrdFSLJUXM1KTZOtqM+kkkqk9CktNlsnSrQUkugmyqc0UYUkF2T7JJJnEWOLr5X8rQA8oIRssidx1JdD1JflFWvdnyEEPQYKKGClpkhkuloqDM8LeBfIEDR9fKqRy0YVjI/jIozQdlhqHrvv+/Fx4hjMGElixMVHHjqg0yRSmw1Hmeuhh+Xx0vMIhbqWKIqKQPS8BGDBNA2eoZd+x9loTVl0J3/Xda6nu92/6v/////9X99X9tT6S2qW6kdq3WpSKjhsamjzqaSNN0bsiy03RM2OHFpmBikiimta1KoonGL9bzFZxaabTya7JJomXAaQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAYiircDG6NyrpGG8GdNbhT5st4H6m3Kl74bwY2puXCZaCLIZoc2wtNetvJZI5K81irSxSnLAEOjUoAw6hwMNU3owmTPA9oK+zBQ6GyUfayYUnMIDEVxHUfQwoMZdE3Qj6h4gcyY6VZkjaFjQZFikHJQNt5wRgLyNchpaSIBiwtFeWUDExJ1IngMEuE5E6tjrGA5B7dyk6tPRMJNPv/U9fdq0////9f9X//srtf/+ynRqoutFBk1Gy0U2WyFVJ2TTsdWx9JkaCSak0lpKZSTsgp6LKQSbQZJC6Lna1n0jilhjta06CDQPCEdqSleHY81vdWUSaIwuOX3+Fm0aKE8AIc5TVTFEybbYBAGpXZ2ZJkicUH0EAkbYAYdhOVKCcgUiDKth+CiUWaeogFIoT014Q+kBO5R33cAxShuWWdzB0gCzEgtSnUoSlJKhOr5sg6kZh9WtCgqr9Tf//1f1///////69tS0nXd1oINdFlUmUtNBdT160mZmQpso6igYLVehumgitGyl0VuyF2U1JEwYA5rmkHEGaDdEjHWzpxWZYcv4WdrSyhAFjoCPJ+mfgO3cS3ImcufkMQ0SZqSQzBYcPKV3OXAYkaij/vXLn3NECGxbkx1Qw0iMyWwflJTtfi6crzPjuD3vMAJs0txNTEOJkckAs5CH1UGMxXT760bLpK0ZTVdXrdn379///V///q1///+rX/fWqvpqVQZGjN6vRrNEtoR8mm9EEGKHoRvXlEfh5MqtJHgJSfa63yUYjoSub1rONJPU1NA0VnsJLmm+NDqnY4HXFzTDtEgcWBhwXCIgp+rEOEpGSA6FSYYstysgL7cSlHHZEY2t+dp0JhxRKYEPEx2zP4ffa47cETKb5KAuVScQjYqRGAkWGhjHqwlGeVfPUzOnaft6N9H/////9/////fo2/rRnqphx7aIzM6HytZxjTHRUOPMdD1NpcudyuG4KsMPSL4O1H1e82iIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAFJTG3gxra4K2RhvBnbW5VtjjeB+otyp/Gm8GdNbmZcAkIMlUVLhO9ekEst1MbU/nqtNooPWXgTAOohciH0MCgfXeAIDw0QjKYwcJ6Q4C9pEOUXBAO1KasWYUIywDF0Vo1pmuhgXqgcnQC0+JIeReAJZL3EDjd/rPc7fI7jKwcQzW8f1vFr3cf5q5rn77++3/pHI6Nf//Z0eu7/pjijWZlYVEaQQOhYAiQaguqXDA6aCBYGg+DySA8CG0seBgyNUlQBMOoy9LwbYBLCypmHolSakUovctUHEnQgqjA8UvynFD7cFAgiZb2Jp8Q23dfZgYsKkYcADgOidNgAUX9jSv7RgAZUjIKVMY5cbCpgLD1mX0zP+QBT2l9GHhEj/FbJl5A6DfHnPM6nEnPJXZnbqsyzFte39bfU//6v/b9X//+v7//999H9SlIaqDKWplJLXWzsizovpMbOz0FILU6dFNBFbMySbmaSdFd52yp9dtpIyLFGjgnAxwkYyjLVsJwmXoNeVpUhzbVpCUE6Rx3vnBwMrJbj6elAleswzDGMstTTL9QEYQFKpRT0EiGHAY4gl5p0+BgwfZNR/FfWXefhuPY0gwFBjk9rIXKCRmBPM+pikM4au1ZZqTWhrafSqT+1Pf7Kq1v////////9e/f/fo6K1pdmdTrSVea3agynUjdV3RZNB7uyV2MUklqUmtN0kDq1OyjdK9ak2TW6z3MAIQG1MoYyqy2REA8jSHpmZdel8U3g+O2kmGBtyHkdQWG7iQqJNCHed/HdqMglRmAYofFmCioRMaaj9QP9OU3suiMHNGHBJvMBAaT6ooU9rEKaAYDiajQGS454smZLUmAXDZLUtYVR0eVPej1zDv6vr/////////r///7f3VWlU62c+z0VOza3d0FoKd3XqqSu7UHordBmWmyqlupB3Tq1p1MinTdA5hQoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABVWON4H6k3Kj8ObwY01uVaI63gxqTcp/lJvBjW0wXz3DZCsFhL63uJjImOuGe+aSeqEgeAZQNEmknaQNBjyaRMhwggvjERgXEzQqE94gpiGFIyLQ5M0qjwlgBDFHVuEVVWOfJHKAs4aIx+Rp+22ZfBiRxUF19dWisprSAuJYd9aw/Fl6jCpp2qnKNr/+39/9f//////+3/qXVoXVVtVf0ta2QRUugqtFklXMKCq1Urqo1rZ3sy22Z0WQdS1rSTei6STrdOo6mDhrW2iGUAQoGtGgRKPOm7UGT9r5u1awZAZkBKxgI6pMPo7TUDGjIbo1RxJ1nUFnQiGkUgkBA6DcEInsQrWJASm8LEBigo41kQILdWXNnXVKW5RvNF8edQNniyk0kDEE/LGR0DojRr7tqfpOm//r2//9f//6//6/////ayLPan6r6KboIpOmz+nQZNNJCbstmSsnQopqU1Gt0bPU2zInWOZBen8nqWS0mwssYwbhJFKas2eKKyivX/CW2rJVDqSbii43Q3bt+riHFIeBo8NB4KLwMWNARIBL2MoImrcRZbJaOXP66JiY5RBifSoHILxVrEXBYCBoQ7kiZTnKl8JtP1fyOpmJQUgAWRdP7OiMsb9Zf9Xyx277K///+3///36v//9/a2r2fZtOpSToIO9F1JUElpqTU6nQo6VaKFBn1IubLd9nQW61stbJ02spNNN6qDHgFmK6WQjzAtkFFgFi1NPxiAJFOS/U3cSULSyFNV1SIpFazYBMLO1UUIWo6/oOOFnCiiKgBk4CxIHBDnzNSxDJgKWhfH4cV2cmLGAkQkAQxG6JhPY/L8HIT6lk9Zzzyz3iphhzD/zwXmfi9+NO07+9hZXW3//ivb893uW7CYjQcMKBNgeGGgOCBIqNEhoaPaEhZj4USIgOfADXnzrwmGAOVUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAAUEbzeDGoNyrNDG8GNNblZuDNwH7i3KhsGbwZ0puWJtZRrAU1hWvrhZFK3Gq1pDnSTk/YGAKg8sHjq+TFTKWMVwcit06wF4Rin8NOCEJdWklAJLygIDQibk0JgMwTsHE6aH0PDuRzCnh8wsh4ouo1iy65ILkO1tYPNzNnA7OJMtbqPM/Pe6rI03qX9q9f/////////6//9/ZXQve9TKWpdS1vSUaUYeYpefWbMXjgsSkbXr1mTAj7jMBJYMRheoJVvhAKSaFjSmwxvByr9l/rlDPZ2iwAAwaOQfOjROzwVEmDDtCoFo13VzMOBGEBM9L7gKlDQGHSe3DMVqmKUlFd2biMp/kTdhpA8Eek0Qi0NXqR0kN6anxTZRlQB1opr2WCsFJudVZ0K7zj2/t/63//2///+39S/2/6+l9S3sqpSTMuntPprSPbIqTQmC3dSJ5aNbIOtFut2OOpakloqZ0VJpIGqVAFLbHBSxDEM0P0vBTDSENJ+tMyFrzcjJYV7HEgAQgShoeL2QGILbye2IaGLMsVtnQSDqhDFEqE5QKSoiRpcIBGB4zJZBCyYEDFdT8CNPOZCgqRi1akpIrzrzrTYrRsJFheLztZRw6UFoAdU2UzumKRPtqNm1ofRbS+9D/qb//12////+zPX6v1Xulak/be6DUEnopOzmqnTWlSZk1upI8t1s6aV3QRTPTqaRtWmu6nM3ZWTlJET5EAM9LSwy5IEPMeYMHdSZjczDsNxq5K6lu2SBCUDTLDNADFFWPt6DtUD206pt3pSYYQQLCIyKBwFEf0RAZ1pOPGyLsHlzVo+VBhkY4jIkS14pyFUEofn6WWIDJFPeeVOKsSgsXRKKBEWfe666mSNtf67/r///f/////0X7f7VTNZ6pal2Z1Mc9bI62RjGMc5WRFStDH0u29DtmmErs2qmE5ibwvPewAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAU1ezeB+otypbAm8GNNblSeJN4Mam3KexebwYzpMGk+BChrAAkAgOR4sQ3GZcOC/hQ2VbUk2wjAJTs3MB56RP1uN6Oq/d8KA36Hl5ATJjhKBDC0jHR0SlMuyh4USDyZ55QsCepMDC5RpfCMS1VWVPN8amQYAgXumN2KbFEACkvS1mIpI2vtvWy3znR+9PV/f/7f//////+uvWr/7/Sp10Vutb0EkFPc6ymRQqTUp01sk9lrOhckRI+QktKPOEAD8DaxdOSzxP6jmGuAPG4MHhcWg6/rLGO5Y2ywIHQEqWKywDF79OnoXUnfX5EpTCzCiSFk4KHYHYZAVAz34y+ngggOBzZsMsT3OKyHTpQdfyUwdP2IatRSGwcLoOWEEHSRQHCaKPL0goV15x3Ws26M0R/bq/62//9v///////rqv9u66mWkhutk3WpZ5lut2ZaKbsgtbK03Znp3dBlqtdzZ/SxdEVI3A++aPRJJxYJpAXMwZb7OW1dmHZPB8O50l2rjLWRTBa1yDqI35qtZg2tBKgkYFA0vEjBIBJkhIFHgGJADiM5TWpoYRJ9t/ESqAM/LAqUamtygSLKdWnMu1ofBIOJ1LCJZRMHJ4BeCToNUkePelp/Sr+v//q/b/////////9TOv1ejXRuy09l1rTWkqztVdnWbKdTr0FzC9dRotC6kVqSUja7KZNZ1dzV6mGuJ2MAYkSKHWhDXilU07GdA/1fLGmoyQhZNciDgUHATlK7TAZbBjrxZuk2IjB2hC8gEGLAy4hCtOvw9I4YGRyOTF9tqPxRhOqGtDFVpNPCIlbaQAhDy5Wd1sP7WaNJu477+DSLX//5f//e+OPfb6E1//9f9X1W231ECQuRCofCYZDorAAqxoVHDhOIkgwoLnAqBxyBYAHw8UCcKgQBCAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAE3oI3gxqTcp6x9vBjLW4TAfzeB+mtyl/GG8GMqbmOPCIZAHZcNw6ann4fxsY8uzFTrMJDMEQq0JwmTaXI4U97wyhXTQA4HKCYzGSZ5Vdlf1iaqXh4EnBS0CO5q3gjsjQ2CpBCY9LKPtZ9UPK2eLouksog1snT7K1kf8x837W1///qfu3//////////+pa2dtlKZ7oUkUlM7qU5joUUlstaLopIVIuyDoU0Hu6dBNI+nYD81/WrJPoEkJU3lIgkOQUImvUzuXuXcLWM9jIyBRISZBwDaF97GM089iIMStxZyDAPHSisNa43VLwYhKZZWu0TWlcyenIQj1lIaWt08htNUuvnLok1syhbdbqaSnWsJOapPqcc7euvT2aj/r1f////////////12311tRWtraCSJsmo+gg511IoOgntPbMzUEz2tk13ujorsqupnTUpJBkDt1UlWWxoJwogCQR4xk2Qp6l0KjNjzXxkmcoY7BrvNZOoScWIpbIiXp5fztpT3kUFUigaSAiI7ig1jLq+EBhYmhLj0jcg7RswUcODuXAt1uctlm8mQl9ZRe4xxzqjIA3COr1DUv1eh06XX//////+3///////1q9nrXskqvWne04yK1OparrQTZ7ou77o3XSUdz5l92oDqJ6cR1+R10EGS1jp5aW4W+8EWrP9LKtmtbpY9FyFZusQJB4oqhN3GsO72w0m60W4ZYSlRMcOFjoklME3tydp7KR4kTyOIvmfQSUj0bp4zs9ehF6VqqgbK/e0qz0OAEE57zphL9dd/T/bX/3//////////7fV/bzERHXXeYdOOOs81rmT2dkPNV3aZOOzaqc05ZY5WVnPRUoimmXQsFOJdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABNd9N4H6a3Kg0ebwY01uU0ow3gflrcpKuZvBjJ25FzfluBzCaGgeSSVDuGqljV8ZqzBKEEcKAjgG3XwfMtiEhOpUkBg3jbF+yUIuEZDGTAz4JG5Ute5TAwAuqmvQOB5ZIfKFcBy2tFctVaJjJMWhePoJoIMkBRiAtSWkUTz1V+Z9Vff/1/f/////v//1///9fq2Unda+gtG6nUt0H01s7Jae66nW6K1IVzzq6hR42MdnCePfHrIihvqwbiszGxCwmeSfGQWZZjb5ytYi5KMASSOhxKUtxv06qzLr+m+nohOCSF4CsW4JWwigKCdh6bzqCICkLOSFlBzAoECk0t8bNPBOb99mosGRIFv+6CjJM4HtJ17OOCvsvr31/6v/6v+v/////////+9VfoLRZl2RWugjWik9JE3WvRQUtzlNq0HZ0HUld12SUtbILUg9BaCmTszqdbpLo1GgAOEsbCDQDEJmesc8mvEdkra1lYSfShfAvm0kwOI7etCwUM0C75Yn5fToJBGOLnE6nGFnHzmaOYmiVxq1iaTJP6wKAlF7xyyQPtTU/JZH0vL1jNSN2RBKl1SrY9/nPOdf///Xq///////////q3U1SuplrtZaC1OtlrSSUxijTZ0kFTzUafRWuy7KoUUGdOiydFFM12b3TziJ7ozMZTJyKAhGkLdgSBdzcsuW79WJSMlAAAcdElG0X5KKz/JYfxllR2sA5Nl6MQ4IWhhgIHnKlFN0BeeKQl+VDj7JTeKNnpmb8zH3499mymejFsPNOcfaAYaqPwX/O+3mf6b////////////+6f1poqObWcqaKep56mKi2QpUw1CvgDkRBRp8Sc49tDNSAIMZyolYSWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAS4jzeB+TtymFHm8D8NblO2Lt4MZa3KKpSbwYxlMA+pgrwmAtAoD5bj3bKYWGpg5UhwhJUYgtTJmBmZ3KemWrzNM6Pv89jA1bn0HCxEFGiZ6koMN2hCYHCQqlTsLHtQergOzCt3prVIouWvmauLSpqIRDej4LPj9cr3+3/////2////1//pbt/ScZ+zO9UQ09lWaljEmqYOoyms6oxxish09dqoa6z0VzzGRpu5pnspuaexNwvKRA3DsAfJ2M5bX6hhN7FaDbqz68gdhZQUHGQh87y2XzuZqBz7MY2DgEqXuW0G3iw8DGX1NUpJl2ovWRdGfJlFeXxtyCGLUbwpVVDTSetW6ziCEUke9ZKH//+////////////////XofU6kWapBa32W6EwpoTVepkkUVLUz2Vd03QpoUlI2TM0FqQSs6bIO6Lu602ai6lHAp0pUZCiqhkTJmUNxltTmNXLvL1ISDq8lI0a0U83J/CCxYuRRkiAnlg5am41t1Guj9kOhgMhoLWFCqcrOoKVfZ50OkNTR2nswHyS4XHdFQu38dklHAmCtT3HG3oertb/6tX9v////////t1eqvV+v+i6rrSWxykihdkEkakFIIumqitF3SRopJ1ukyqJu7IXrQQWix5V1JUGRWxrLXB3t23lMqxRKo4hGn7euz2rndqzGUrQ1gYbXEwVCzE5Ih2tULpZtUrJhs5gRVcFTSsODzlcpu4DCaEb9Q+yg9gwsoUbvXP34tKJRXmHCNwGdpv1z/7xoNvv//7mvn87///9DP//+sZUWkJqGkmjphCDh4AtDL5MaD7gvEI4kDoKioPkAgGhVoMkEJJicAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAE94w3gxprcpBw5vBjLW5SvhjeB+mtwkJEG8Gcqblfc6DQgi60kjW/d2Zlli/ELedjWKBbgwQxOBAeReyTxxPbC8teRrRbYVAodyYAWBBiAMpGg3ctWYZCq93YJkbom6AhQsUF5XftznZVnLoDEjsU1uulRCzNXUlXOvqWmvr71d/+3////X//////9f+3pbpNupkVqWnQZOu6nQVUZuy1uy01s91PWmmil3skgpFFWp1OgnpIoKupBjN0Hss2/gjSxFEAPFLXlgjDKK0eVLzOo1UeMZ+FAJMBR7dnMMts2lI0j/QhUA4BFUPRZCZHlYvVt3ZUjwrVJNMqBc5JkNDZxunarjN/7xiTbrXvdB2ZYR3v1Cf//+g//r//////////////9bUlrupta12pLSQqqU6qfp2RQ0qKFSmuzLdd1oOtqK13PcJA48OkHdYMmCCZAFAcx8IcuWSDXbRNEyzsqyvhK1CpEcUK622fgoDTSlrGCHCVIuIvkyVJ4Opv0EHaOnnMI+ADK9qvxwmlipZqVijrZ2IZwuthTHt433QTTU4JyU1Mpqh8fz3pf9v//////////1////V/RQ10L1ruiqzGCSrrshRSd0aCdlVLslRW9A8g7rVSorZ0TAaCk+iAGRDedFkIgSBMSZnYYlEtpO/PZy+ppu9RuBmBu6MCVppqqAOXYrvn1G7a3yol9QMJlhaaQTedHJBGAv97ZpR8xmhWhgksi05Dk/SZUi+Agaz3Hqx4JH/iIf/rrv/9P////////6f/1/+/m9ncy7urFVfVTzkVHRLojHn9UQ66GJU46k12SzOcinrN3OJtk8FI26UYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABJGKN4H5a3CWUfbwYwduElYu3gxlrcovxhvBjKm5TygA3FyAUh/KxjfPY7g3x9b78RfG6XQdE7pGa5N1Fqp6aX7SKmbQgBpCLRBsM+jRoiPlQ0dNPAwAibnL8AgaBW6zVtVf+HvtNIUoo8u1MpUCVXVasm/f2+j//////////t//7f/91UlMgpJa7qPbNat0lMeWplLeyFBbam3QdaLrW3oGKCDpq1oVKpJOzOenWAxG5EwktAlGVoZTAUvrY2Kmd6VV+R9WF2hN9cUPCa7+JzVY617BnEDoDCrCB2xTvRRM53VioqhGHszYQcqkMCYEok9G6XI/fyUaV5RVu2mKNQDjd+Nm/53arf/1/////////////t71MRKoc1iDIYeaymMhqltDjnPmqinueddD1k90NQ5TjT7FkYpRmeyoxE5UNZzHMKmQHSLdEtXXHdiCq7crGr9vmW+t0iDxLbW0Ac5rqiiDm5U0OVjo8lTGHBCjQkDBzD6mEPVtz89EhFw225FHzNFGAqmqfKvt+d1n2BQuHN9OmBSsl7Es/t796v/////1////////f/9StvWt1LQSrZDZdlIu6aCalrWpZ1BVC1aa3RU1BNGjZSmRs6qTrRVs9jbA1DprG5AKtGespmJmvZ5LZvf7sUtVdzGUjoNEYH1J0SBysJc5Mq4hWVUkI2xJn2ioNUvWq98QBP5Caz/g+oqLETEAS/GC7MxM0jtqP0eHox59wIDbboI/09vp/////////f//////223vpZEnq1Zyrc5CzIlzJjO6NUycSN6WaprPNc/SaqI9jj6GFa5a+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAASSjDeB+VNyjVCm8GMqblIF/N4H5a3KJsMbwPwpuYrMogHkOMbS4YLuLe2TO8YXLbGn5l5fp0zHujeDtJW1L8m6nQ5yEkcaJoYwLcxQKjXNzVrAw0CYyeuPGYRhAwmxKMrNbJ7sLTcEB1zHq0sgDx76tGnzvLdq/2////////////1/9Nnv8xFmTlNnHozI7pPVNXNWio5ipR7mq5E5h6HnI6HGzzaump01T6EqAW9FV9Ps8wqpkqt0Vc+Zlderu3d72rg9c4NQzpdW9ElH23kVK3/YnGS/gyUTHR9k1tQ+Dqne9ITkzJfTQyewQ6kPaQZKrM7foa2oqXyy16GTGcD7b7BQf/+//////////////9ff+zHG1N5i3RTnVWZtHPYlTOSYaqmIapnNczNR1WqKyH5YubC2FHNk468iVIpNiAsCHlsX3BjdUfK7Xw/JsjeQDGGwHRDFM7EFT3IvHBUSHEciw8PKpKMJrCgs79T4BFX1c1KtAICWDFAkk1bq5PZng0RvZ3LroJJOwVrvtW7ej5/7av////////////9X/7/ZNT3bWpTpLZqSTa00WSZ3MTy0moJnkkq1M7qU6ZhXBIL7YHHPhm3AB5qEaiyEjDCUkwO92t6WYWLxI2djrZH0aUXHf50qnyYadhEbV6Iw0jq0orPBcspl0VJjuXGiJsW7q+jr1d5Tl8MJ6Avj3OSso7Fcs3rU0CEn+cF23/b5v////////6/////fr1pa9N01ZJljTVOQxzDkVjZ9TJxkxHWiFKvo26qlGqmczltXYYEVFky/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAEXIk3gflTcoWPxvAzBW5Q8hzeB+mtyi5CG8D8qbl4mRpA6gvUJYWtUtcRc31TfNUFDMJmSc+xpHQ31GMI/D1Uvu/LTSFxZr7FZ8uFRr3xHkyFi04qb5sDHFUFKGmv3rmEP57j1+dx9NWQMlV/FtvROZ9+///////////////7dr85TuacinkavVj3Q9HmnohpjnOZspyJnWZFc65z3Q+bdM1lOI7Ix+3/wTQzIEQYCceji9rMDjdLFzNbEseMMNAzPcM0/FhJ28kxg3SuXiUfK0zi/Nr/wqVMMRkq4Zfgz8A4FakYYh87T2I7ulSfLlz39qdpg8PbrAF/T3+M/+3/t////////t////37K7Ouj0QpLtaUkrLVDMw9dyFrMPIJpbxmpgURpTrscMVoy8IaDQJCA4vSJ1DV12qR/jfbvbShFAhXofAQdjS5/StQzS9b95iqYnGMpJdLmwdjdtWxECVri9iUiQ1djHMtf3cg+MOk8U7ng6tJQVps+2WP6//R////////////////1b0r0a3TU6lJbabJVOzstq1oqqSXQWtJddabMtClZb3spA2f3RUl11pIiHFAEPB3iwsZ5LhgbmeLGf3amasiTMEjxk8yKdqP0RI4xJw7rh1C/JVBKApI8s+5uOr33SU2rA+MAHMSIC1Q2rFvG/Kt4QyWq3jg6Is4RBn4YfX6+v////////////7f//P5tdWMqYael2OnmOfSzT/NdzznnuqHKi0V3U45ZhzWL/jnliiCuiUnWgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABGOHN4H5a3KGsgbwYyduD4SU3gfh6UIqxpvA/Km5UZCBIzwFOGI0PW5q76C5XyqZzbnR1fD7HeTIsYDYpS5UOBYAl9EOmN+z1JjFYaxUuazKiUktztxWtT63an9/4fz5EmZ4d9T1OYA0Hl/Pv6v96v//////////9X//r//7Ku9rOpVU+zVJtWihdNJJF6mqQSQukqpa0Wn1LUZHWQUm6mZ0zZ59dwtkA0s5xqVExFU4nVy5Ut2atu79zJWZOCSRF5mY3ORNFetXZ18AzCTRCOoVKkW8lpWa+PfFEVX4SmNEaYXNiup3s1ydx70vTe7zojABm6cH7ej/9v/////////t//////Z+jtu5l0vpd3NOMNlJ2xzGeY+qWmKY5yoaaque6oppq0KsrmO63R0sxcwjKgURmBpCMvHJqf3Jimz+9+DYWc1V+vCctUvNPvhVfpkQSVcwQxFwBGcFtiQnkR6LcBwZ5l2+DFNXf1mjyDVjJRPj3znetg+xagBOl99zf///////0lztx4sgsLiMEBGOUwDqAYAaGgwEAygVAIwMvIhgTEgIPKAMuerGvWQZAjgOgJ9sYJ41qa2353KZow0rTpNOeptjXkhb7LJtZBAGSTJUHf5u7KupS9r42soDKCod46JnCFSVV92xZzvX9ZzJWHPf/XBQ/4XL//87///3//////////+l/ss7q+1jz6P3PnqaY6tqceVVXNZqTjEPNU6qaqae5h9UPkBAechRTW0axLBJ9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74EAAAARHi7eDGGtwhPDm8GMKblFKQN4H4a3CAbybwYwpuYxLxQqh8jazftdpc7sv53nMIBQqpL7dCxuYwlEptxBcFVP2bffrfPg7+KmU5nS3qUqLJgU2V5NRYkIv48ytSutXlbXZ/H+tzgIQUu+Y/b/e3///////////////v9LU+tBdTqMjy2QdaLUTlNlstkGqWeUtb56p790FtUZJs1NqFSlUmRQmDJ8tTwGwhdgxKHoIprMxT58z7yUWo8uiSqAQOnTqzBQtSltO/hPWla1FZylUYqKocu18tpyEQ5Bm3QUSFlkz4nIb83nesX3qYZYw9N1QC/9QY+n/r/////////////9P6V26G92Shz2Ma2js9kVHOU6xyHv155iTJynVOo9VZKSb7OyBgsqVWVx2kECVALx0J5ybXGM1Xq/5K+XU9dyqGzXKfqRp879Ar++4kKYYvGMcULzSJzr6s1SomBf1cTnQRK0TWd/XLlqhm1xU+/qnHQBeQ/U//9Cr//////////////9V7a/vTo6dVNFSaKbqZd0fc8qtBdTM9NSDU1LUktRy6kGoPqqtZJrJKWgkg61JnsIQ8CCcLkTp5Jqsvq18cPt6y0LRqObRtOr4sLT9ppW7V19ck1Mb9NQ5Mz+3a7olEpdGcJsFebmUOoccKTu/08Sxb3/R1RA0OT3EG3r/6f//////////////+m/s+jGsajO+bcnR5yoefdmZmehuR50FdRzv4TOAWCIqYJhckEa/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAP+kDeB+FNwc+U28GMSTBEqLN4H4a3KDcWbwPepuXUYwwTxyGgpJtavCtrf2LsAFttyjh2PSYOgyzOOvVTKHaXWzFQiJxColV+7OOKOrH62ElQnLTSwoK3K96rl/wRj/u8+RgAT1+n0//////////////////9/WZY0+jLc1Wn0eZSzKlWoct1fOYw5zT5p6Ztj3fY84+xyoh6sdSXZ22wxB/Bk7HH6nblmZzt759S5K38jT3QPKa1eED3p+82uL4ZKTgOWOLdFoM0jZIwCLDeRl0FcGVBhlNpeQZFY6BBx9B31VCykPzz/////////HfmTE+WUDg40VCrkRGGR7CcyhK1CN4aeSEBp1YgMAu8k0CGc4A9A4zfBg+bG/l99Y722BL3CHK4vqLyiNtNrXlm3mlyBli8EWME8eJu54Vc76mBQLV2IBFUPVw1LHce/WweOAdc9boIVA6nRr/7/6X////////////////9Sq6Kq3Ut61u6S0FKQU9t0WSWta0WTrTep6anpMynTRW7MkmhRRslSWgYQAImiioacZzAdgRlRvoL+Td/nGrRCBhoxyZOzQzUQQAoerpB6T0QQisrgDQqVeoMeuyVFYtVO4CfUgJZv8dd6vnJ7GhW27pVgJWr4lf9m////////////////mbvX6o7a3ZT56oaahzV2erNV1IEsrrNOc8555qkJhjVdFZ1R3SZNc8orZPDDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAD/He3gfhrcoGQtvA9525P7fzeB+FNyhZIG8GMHbgn8cyxZRYzChsru+39ouuUnXqTGrT8pDYUndD26O4yfFZNGuscMlC3aI115T+VNarFRzlb1Nkc0O7mas6/dr6+bV8Ofu6J0Mf9X/v2//////////////9v/WpfbatNCplLS1pqWtnTWivR32NDeDsSeMdHH4UUevp00QCmDGow5JLYtpzD4EaTkaPG3PLak1Jg+zMin4zk/nbH4H3GoEUo6DfPZLmET25Mpba1DiES5yIsARAhBVQb6pb+AtikvLfS7gu/hdv+/f////////////////36XOQ5DTmOV2PZXdT1mOxjT0PMOdLmGMcx93POZzn5yuj2cfWkTawSjIMRp3SmHIuQj5D4EF5NqHDmv/e1lAeyqaNZbeLIC3E78GW2QRZwCBzFZ5JuXsNo8Lm6hCpIC3yUnYRYLIcrFnDV76urGPPSpuA5/X//f///////////////stf22U6c1VcmMak5zlmFZ6mmNQ4xjtzKXmGMzl4xMyc3J/MASRvPu7YwBAy1w8aUjcuvxZmt458x/7yfqgOoclanXcoi39aYkuorPqOPEzeuRXn0dcscMfR3cW/2wUhJEQNjl25lvnbKk7XP7Twh/Yz/////////////////v0rZ0d7P3Q12RTDiprHJUyl0QxzT2RZ1rmq9jb7PRph0dOmIaaqKe841TVORlSeOHgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAABAN9N4GYU3J+kMbwPwduTxG43gfhTcnpQxvA/BW5IA/ktGHo9k46hgfpea4VMbij1WJQaKIl8w74KTeqO7caVFHpJJV27s6vt2v8qWZSgnatfrt2BMSFMXzvWu/Pdxjrq58/RMB/+n2/9P////////////////Rks2+hh5jZs5UNPNMMQxkQ5lZkzjjnu5xhaDvbnHsWDNatqcLWgPHLo5BghcBln1mtnOJBvLvl6wom4WUa0oDrLOplTU3YaqLlbmt5R9hG0XqL7F66VSv3W29QOOjNIMO9yx7+8HStf+3EH8o3/////////////////q2ze1edRpizsfcxdkMMU5WNR7Vc01T58+hym3uYea02h7GDrEX8UXCM2YIQ5MhyA1StXFn6l3rxL63ljdUpwbyYChaTNuot+e9oea+7MSIaNDpRollieedndUUHO38m7mVhVauO7eorvzn/Vavrf/cBR//0////////////////9k6a9a59SU2k098r3Q1NTQT6XkKfXbKD/fE73Uvmui82xx2eLcu1eLCGkzteqQLwd2zzVhhLP6dnVxh2err22rcLs3eM6SdppCUQokt5Nne3kvl16SpBZc54oRcv3pvDuWrb6///UJt+E///T////////////////312RydHOd0ZyuQqmdrlOrU21ybodqTMhHMiKUjCLUjiS0WdDfs4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAPogjeBmDtycuSm8D3ySg6wlN4H4mlB5kYbwYwJuRpRAzACRxKD5zr/fLYc5E2FXGn1wE6nzlCPHzckruTI5wlYlm1RMG8vzLGv3JiDnTm4wD8oCSg83e7jft6zrPJ+X9MA/+v//t////////////////1ps7utKzxxXol0NV0Kz3WatbpNccMc13VGRUNRCrdbp+wKq6ZlEeiVwqUMAzDpL8zLNvXM8l8/SRJFKaGCcxtp9KbhqBRgfICEhIiKcLSkLgSPMgfMxG55EmAL6GQBiKpGiV0SmO5v8uXyj/5////////tu6lk2IFENLAwHQsDAVDwCJhAQGUhFQkaJQ2BSCjI0PDwyosTARhLVth1sh+hmi35vBv96/jv8uR1qspZVRBlbGFGHF5t+TYRQ+MUExBp4zwFrk8LEkzuoM+JEtLJoBu454MCWUUjjFRk6KDevIR+r///////6P5mhyyDA9QWfBYIgnLny6iwOBAALMgu0RslAqRUSQB1gVBRx4kCYtH/Z2Djs0d6K1dcu3eY7/vOLT1GMV3d+DWb/y73uD9FULeQEUHtQu9j+OcyoznjKg0bDlaJjXY9e3+W3yw7/4pvwX//t////////////////at9NbnMuxhLoxyqQ7boRIU11ItVzoZtHeQpEOzmMHKpX2ciERwUa86CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADvW03gfg7cnUFJvBh70wPsh7eB+CtydxDm8D8CbljlL6iEkRiPArDe1zX/j2YbBtmtIRPp/bC9+WdHbh+WK8TeRiUfLpV47u5h/Hab3O42UCCYyVlofndcl+u1J69znSga/p/7/X////////////////u3ZpvdzrHqVjBhJ6Z9SGSHqZeIPz7EqI+8soINK8bMTT9iSVZcskOKgmZrXnp2ziHG1/rcAZUjdAFhpDXQsW8q7TbV6EtFQd4sUqMmj33c7AsvQ9wDwO8xYVorfWmsrtC8f//f9df//y////////7O3o2OSLAYuSGLCyAM8mKG1igsFTguYKjAeMFS5txVAMh4FjigiCh4MvXqeHNBaVZmeF/Cxrv9ehw7kqlpej+5sXt7imL606k3SIhN1FkTjKMq2scUEdDSbggEDeQmnH8+19Un9rQLjr9eBT/n//////////////////066dcr1IojkcWEiqyiabGeUhEczud3uqyq6OcSQiUOeNjikeMKhQEegpzEkjEQI+hMxiy2p9319Za7WW3i+2Crr+pUiRe5CeQVlKXZUYfFUG2B4429dHBMe5m8ACaymnz/tnvf/OXa//xX8F/7/X////////////////zrZHbJdqFZGqcpTnaWZ53e5DGKZyuRHHY7bupKurnaXHKh1RnNI71gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA8d+N4H4O3JxLfbwPmVuTmyW3ge+SUHHtZvA+J25SFCjF8uC8/M96y6/7zrRmkZyOUJV/14HoxuQ/WgCfUseNQt0BZNhs9jfN10PV7yHlsMsQIJjTef2dV99yn8+f+EX9v/////////////////6de1etUQxD7Ip56mJZ2MVzj2mm0d2rMRT2pHazGPRUt5ds8oIVb+OGLp2RgxARld3zNEmrWltNhQjDMGohjKF2I5SSL7k2eLxUDwkYHZh6B+61BCY3NWLYPcT9WZKUucJxn/gK/5//////////////////9bb5q0d0S7PRBcrGKokeOied2etWnL2wNWan+GZgOoJBmgDqPabYnEdwg52o5/B1/rWbeFsskjBQx6J9HkfBExPGPk8gGKxERRhLgtPcZk+iu4zAb2yiiBbAjggYxNpk5guZEQf+sst3/////////1iFjFOeZihwYlwIkCYxYcDCg6oPHwIeEBwIPBYKAABBsm4MhxZIXHAMdmGowuy8GU2OcLFL1rpBJ1CbzArHhY0kyZB6PrLyyGpk2fE+j6FlpiP2pMoVsJ8NUhqgDgXb1MplvTJH/hE3///1//////////////1/rVM43mX0oPHHTgMvsLfN6jdJ4XHb39VoyYEZFZ5MehWbwQgSUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAPQjzeB+BNyda9m8GHnbk04lN4HvklBu0EbwMkJuT5bhFC3DfSunPc29Q6a3/W7LU1LaJTXDOOsTv3sMY/ZTkY3agsaVfZ93fe+h2fOzysXfJUWvt93yv/7s7//y/1////////////////9P7v9voV0fc6SmszCzbspgFzOjlGdUQrSGspJNCrc8pDmPZ2ecrMruZSorIEplE6/A1RSycoc6lPjnjZ7Wu6E87E9UGan4JpmO46Um0U3GpOKKMIxH+tZM01dZPQBlME85dbb/b+WDv/6iFvzv//////////////////mWTeru5t0mtzj2eqWZpx5rMrK6JOVye7bZUCA6wGsHigaSRy4+PsrOpFMhxYyEldK/1jd6b1vHXSpwqqEOxmITq2ocoqD2xTTAU8SgiNdFj7rCAB4NUCVDPggoaCB9jq0tyur/KDsp/////////8Oz6TotLpBQYgH0nAwNI2Oe5YGD5BBpB0YWALFKDAudFzTAirLK4bBoiid6/V2vM7nBn2JQ1K+TYXMtL7EWNBjRnhsjPkCOB4ns6IaOPB9imAySxtOtjzsgpQ5364B/X////////////////+n06+vK992OR0OctK0oYYzlUqVWyXq52klRLKweOp1vyVMFo07SwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADtYk3gZgrcm6xBvA+Im5NShTeBDytyaVDW8D3ibldyUHioJPvuXmd2n6ytLc3fxbzvzTQbHaT5RbYxEaKcJi2HQwwrbxVSey19RACQkTwqWu4dz3y5Gv//qA/9///////////////////oq0RnsqlyEPYhrTLdXzkdiMNoSxSEnMfQrsSp1PLVcoqOQrKICxhCkMM4w64MZLJSE57ta9K3W1AZg4WkSIvHSHbSOliP6IhMbHiZEMREaum1YXiRdKTII4M4PSapSvmQwf+B/////////////////////9SNuQ5H1ZGZnW1vOmZGQhGRGahFZHGIqKQ51cqaKYCN9CCviH5EF2CgOAqFIVtY1+MQ1TeBIdeOuTV14vU2ByqxlMI9cF3mtAzUlZtemwKR1A8Gy3t8fV4Ov/wx////////////////////0/n1ttcynW50UjOQikaZUupXahrGyxqpoSdS2jgxifFTVt2tEhWVxuD3ewIm8W3T/WPDbem6oVvLYYUOix2WMQlduC8TWIQbXr+LKNvGV0EPUy3ne75/pK/3/+Af/////////////////9//6aL5UdCd7o6qjMlFJRMzwtS+tMykrIt2YyGcJcF16R2FPQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAA1NsN4GPO3JrjkbwPeJuThI03gY87cmlxpvA14m4T2HBkKSCop/z9a9vHXaAxBlTGu2il2st7fzCTGcq10FvHbN6+shLYONVBqHqDxaqfOs/6f7//Bc36///////////////////76VXWY7rHWBoxFMfVy8oLqLpyuDKrPNTeTb6QcqcDretpL4qyHSJK1Y3enz9XzjTWhEFTVPrNIwzYkCH2rIxkWspgvdxdd1r7TDbxhvBtHpPreov391QV//wP////////////////////pqmiJKSznZlsp6NSK/FOfmsJUnbNPXgN04R6YEFM8QtWRMJqQ0Csuq0jUV+689uP2uDjezl91If1bsHXOxMT2LVFod1Zr59lAlsZkFvF3Dsk1uX/H2xa//A3+n///////////////////sn2oznsrnsxJ1NllPzXSq2dDEdkqe02e8dXLHqbmnmKjF1RDkZTmLKbMCGZUmE7BPkjTWy1+90a23SBol90U65/fe+iIY0o3jOsVG/f2MAir/QHEZET/cnz8YaPv/iP///////////////////vLS1NW7mIrSZD0KQrzdXmoqno5UoglGp0KRLHcqUc8yWMV7hHVBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAA3CFN4HvO3JjRKbwMa1KC9CU3ge+CUGZNRvA9pW5y8L6RhucH1oOLbxT/+V1dajlNvUYOyuHuGCMS6MNeCNTSj1u17DSfW3kmAO8iZNagbz93UP//Ax////////////////////b/1m3WhztY5aMhxpltTbTMxlU5Fex7GrQxJinJqUewPB5+NZ4bdtL6sTAPENg8vV3stdieShwzUJwpzEGt56goJcY4vDOOBETPTw+DcZUgGWIELynrvUsc7/5v/////////6an2oPKEilF3IOLWgUPCjxg4QDFB4UJgKDhU2lQVOAig2RCoDCpQV08QtxLKPSHvNtxM+v9LSrEpNK5TJO8VS0hzDRI8QMWCKsSylcU4kXxXQjlWepNSmJWS/yb/////////+3MpfvFniEDGA+bEwERAkcAiIAkHMFg6J2EUjRWxEKqjQ+Ta1u4xxX1G+baX9t6o2VlqxOljB1j4MakfpGocwkRaohlYZD+BsPnlFYRRYtEHbas4MF/wR/2/////////////////+te+nROfUYVQk1PiaxYmhCsAXfZ7qvwRFAd/lTfBaPC8LZiQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAM+bTeBjxNyZJDW8C3ibk0t2N4GNE3JehKbwPa1KE64PRbGJMezbu7t/22TYYZDvpmIS7fSm0npBlWV8ibsdX+M6T7hb80gSK3mbV/n+rJr/8A/v//////////////////69rWeez2e7RRdTKPqFDmQns9boxI12LDSBiYKYkxRK4jRh1g5Bo7BIdRL7/679/mLBQip0fD4eOsyeHhFqQ1V024f/2/F2ZK+QelgQGPv/fxYrK//iv6f/////////////////9f+WiKV+dK35AUQm6lzFJbR2eczmLIhy5yKcxuCXeUvZ21YpZ0+AkFZHEB22X63WmpxoTcbjML0nKhaIqL8ouMgIkRSyk4XU/esPpvsJSCVD2dai6tZN/4v///////////////////+9H9KPR3UGyDzOYiLQWiZ2Iw37MY6nxQIy9FaRQXbNGjirrHXI4QtH8Q9ObvNmlN6DbFIwHqww7ysLN56gmJMIYgqFd0N1x+EQ7OD8PcRKtVszGHf/Nf/////////7a2OSaETBUWKkBZt4JB8IPIuBcMHhU2BBVRBZ84UNBhwVeFxCDKUgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAADFm43gW0rcmORVvAtom5MrhTeBbRNyWcSm8CVtSgRGjECwIJSlX0xnVTkQeB0wRFZBRmO3PoDUgMGEGUk3UFcruSo66h1GkNZ1Gc9Y9v+Gf////////////////////a7kVFLrvS0aSuE/l1Jmz3dfeLSV7nC1VU7KpeFd/2LLQDEkEtwKW99U6P21rSG6OyskA5yajecQEZE2cnk6veomBwZ0NwP5BVZdPYdzf4r+3///////////////////vfVCqx9lkZkQ1nPq1TySbqhKEUySOZqqSy2VWoJQ1nIoqCkMuNHpQXCKmQlnJitnK1OZEqoonA573ITomiyTNR6CqbItELXxoG5diUYI531LqLv/Av7///////////////////6JV0ntmrKZWcinVZNGvW+UxpEd1cqXIrMVSIpUaFiJ4XXLiKdmtDaiABDhTyjDqP+GKSaZjWVBCnKU0Q5w1FqI2TZlce4iUlnBih9Rs+24wLf5r0//////////ii6xaViyjoMRwfEIsJzDyhg2IaRM8iIUB0gGhQEC4fKAkSFQIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAqwlN4DHalBhrubwMaJuS6oQ3gQ0TclrQJvA1om5FkSY4ytzzmp5UYOG7gQejdMdrjjGmpGLj3qEEP6jUSQNZ1OvrkJ/8m/////////9WamQrJpQ5gHWJHEDDypY0poI0ABQKhKJmpSowJWgikLgm0gxoSQ7pgEhWaXt39v7POFFRKrJyKky7ozFxKSotOErJGpqxdLGZw9DOmtGqnrHV/8V///////////////////+9fkT2S86odigqqR/O6XZzAoKP0yrYStOtFQEUeqHVN94PmPgkuDcB4epd6f/UxWyx7R9zvWomOMQurm8Z6uPYgJNI4HwWy3o+gaf8F//////////////////9/69dM6zbsVnVTlYrUO5DqiWTYp5Nc7OizIiqTMEMy1Ixyg2TTUHhIOUQsgxmi07f7ljjzTMdE3z8wcRSZ84N7j96xVW1EL4M5av1ai5/y////////////////////69NtjKn0kR0SVN0TWiJoZLulCijoIqdA7V3FU13bBzwCmvUwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAALifDeBbRNyX1GG8CFCbku+HN4ENE3JXz2bwLUJuXwKyaO8nxPO+v5FPMQGH7WW1ZOYfyYfTSkg/WIcgsyx6Aoja9XzH/g///////////////////+/7+1NrkMRTlIimcsuszLMU+qOqmR4z6BlDlMjtB7l5oWl6G7JgwUAOaEIEquHmr/YZiYpBLaDZ1aTMBwYyotRevUQI6ZKBLD0UrrXPHv/N////////////////////tp0aTfOZ5GozqZnVqHPvZGMq2CJdEVWMe6LVLbIrGyOhY7k1ZMTThUKPaPHf/yKmovpDhatW8nokQnFrEaf+MV9Q9RUKCn/m3/Cf///////////////////ra6NmKncqOQ7OiodkdlPRVNctXRzrc7rmRVnOVCleVFBssJTHwWRF4ukFtHkPIYG1X39cbCOOIIlR3QWPIUAvso0trioO6gUmFK2SnJn/1////////////////////+70onTStkW7OnqqsRDucpXVHMCRTvJDnIgeiTxgfpuZ9MC+YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAAC2oQ3gK0TclsNxvAtQm5K2fDeA7RNyV49G8B1CbkKDg8wQAIbdv8rNpeTEqTuatZzFx9UUzhiyOvY3asZQqDYp67c1/7////////////////////9ttkXeQlSIpULjubJVWNSRyMzEIiVNunMwN5UBLY9QsMNFHGw1WGo0idaa3f/sI5LG7hSNPFnOooNhQlMJZF6CUNroB0YClfXnf9P////////////////////1ViqiHY6lc5nnCitmtOdJiFuBFrNVbU7SgbSswDqIrHLDZeg8EfULxWIvtb5i7HorM83euTHJIzLVEOe9QzILxOBZC0U/9/+X////////////////////6u/kWtD3Kcw1rmdFzqCTTWqs5zA2T4+M4vcusObM6czT4UiDRWpECQQkUzn9rCO6kEGupofvbQK4uNOeL/hgXzgPjId605b/r////////////////////+nRG3QxDERTlI6KqmRi0RFSa5EjVUcf1vN2xZ91Py76ykQ0MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAApobN4DHWcBX0ebwFOJuShRu3gMJZwFQwJvAc4m5lwkABZks3/h6GuA3fBp7t1DtKzNUnSXfHrmV8DeuFmKynq/////////+0+hapooJQiggAgYcDY0ubEQrLIEjQZDKgkYNEjRmFwTFAwKCooXUJ1KERYBmBMys37CEnFqhBlBRvVQiE2Xjm+BxDKgIFBft6n/8n////////////////////s2ZUq317uQtsh3U8yqz9Ki2IiaHdEcsZmVmLFOVboxCGTUxLAlVEOaBifHbp9Md4IDd5N+pVx3EU80hJO/+Ibb5HoihyOl3n//////////tNKYhQ97AzP2hgVSHgyoqQFRpAWBkAJFDLw00QHxOUDZw6JVly6zZQ5AqDw9Db7dYnJycIdwKt2g5EDnmT/jww1AGgY/T0Hv+/////////////////////+Wump7myKVn0PSyuxzkQz/QxdTGZXcOjIz08YfhoZriw25EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAK6jjeA5xNwUC6m8B1CbkriAN4DnE3JWUObwHOJuTmCwvH12v/l1GiAbqLtZjiSIWQMoPfFJLQA0Qhyf7/9v///////////////////+8rKqLZWXFM65WJrZ6HVWVbmZCGu5aIYxEOZT1ns6nK7l5EnloSKWigWCUiY7/+VGylIisqTv0cQxEXtNf2LcFQyb/iz/2////////////////////6W29WZkUiM+10d1W1aigTBeIsYrwoUtv1n4egewJoCsToFY+aoTCxj6f+YhqgO0TOlIuEJYoN4n+xfg0DxhP8h/0////////////////////+To0qpZXmMQhFmPRWMmrGWqkRFcEwORLMUgYUFQoyhwhQKxRDDYRKjqSABQyGUov+ovkY12G3rFqF70+cZqBQcLf6l/////////////////////vf9UKlnVkz3iTFMhDlQ5civRmciEoZSKrreayKjKjIOrocx4JErwMQQUTM4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAACjXM3gKoTckqtxvAUom5JYbLeApxNyS9DG8BTibmcICpBBD3/5PJoUra7T2JReOHidKfFxNqLAYt/qf/1/////////////////////syfZbKRDmdCnYEqwFB3Fw7bD+kLGKo2VYOZFmu4bYljjm/rw8CAO6N/8WvD3BdqweG3t9hzUCxg7p8n/X/////////////////////6WtKiTzDKSgvWpJIaXSiNblUoAYsP2a+B1K3hSKVCB6rmgK43f/0UyDeZ6y6jBUyvxAZoJxSX/53/T////////////////////r997o5NxZaTmx1hTcgliuIcnT8UzETIrO0aepmEjQRvMOXaMCIWPJ/9BfSbqL/SQl5l/q3CY9v+v/T///////////////////+3meytSR/1sUs6FmWQrOqEkPQ1mR2dZndi5djKgN18J9DLY47rAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//vgQAAAAmWHN4BHE3JOUabwHOJuCYno3gEUTckGjZvAkQjgWYkV//dGUJOfpSWQsodb5xbjYqX/5b/////////////////////9f2Sy0PmuRCcqboRyKIahrF2sY5iVel0Yol3mQqsCIIAZtQme9JojicLEjf/lDrTtB789S9pn/hxVv+d/////////////////////+td3c1nOhWI52crg2QFbVXzWsCMVlOdERrJZUkr3K8qFY1nRbHqHTAk4kMEH//49A/obXuMZC3+JjuCqP/7/////////////////////t/Y2z2IirU5t3FESdUMdWoshSkI6kwToZSilc8ahP4Z93N4UCuvh/FSIaj8/8ELvLoJ25Ffv9egGD+j///////////qagPEARBc48GxYQrLBEG2DQVNmHOigqGHsPiw4LEnLaBRU9E5MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAkRzN4ClE3JGr2bwBEJuSJnc3gCITckMQJvAEQm5qgWj//zKiiXHb9EZB8vwj4+P/5P/////////////////////dvelHpypOQpEjmR9iqKgFyPzN5LIofh7jUEK3xF0CMsaLf4jKxoK//BGpfU/6q95fr1DL///////////////////////7otGtdnNfRWIzEseiuQjkqYhVRzUXhvkdS40CSddEynWXc4mXl1jYn//2gOp/1TN/V+RH/6/////////////////////r/tyWSS8dFYqw7dkIbYgJnMEtjgHh+pXLaEiksOLGDCnVC1nhipGFhX/6Ht9PzX5v/Er/7/////////////////////Xb12/VKiVW7WqVtnZqbnuibSpU7sipZByQg2FU7yC1y3Dx41MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAIbjzeAIhNyQs8m8AgibkguNN4AhE3I+r3bwBCJucn//94rm/TVv6eqf///////////////////////un1sxZKOQisRkIrnMR0sqUc7orvkW4Kp0dtmTaWlzZIU9WztcWEVh2f/8t/WuH4f/H///////////////////////+iO22qOz0YpDnYY8zXRrIZUQolnbHuVa5J3utnrtS+Miy6pORZS/f//w9f+v5eL///////////////////////1/WlM00xrDETqQ5mR0nOlKHpqS5nV6sVUZbklOCKqtmWoMEhB6ueu/////xf/+X//////////////////////v67fs5NLrmVlMWhpEI6tMznY6yJlI4SwIIK08VHIQ/XVm/P1RJiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABxG43gAETcj9R5vAAIm4GwjLeAABNyObHm8AACbn/f///////////////////////////+3r62vujIuHv8ZWDv4ESNX6raViovvqEARRB50wVShW2zF//////X///////////////////////93dSrWjts7GU8rISeapTnTlRKFo0miszkK762KzqznZnYrnNcpjPEiv/////////////////////X++jO1JGuhHVpZCIpirykoV4cljORLHVtDNKZiPZnOxZGIg2j8f////////////////////7duxkdyHZlQyXq63McrpOREVHmKiZLa3OoYisRVQGhlVFLak7kcrdWFSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAYAAN4AAAAA0babwAAVuRo4g3gAATcjMN1vAAAm5////////////////9cDUGJcpGOOmyriI0DG0qCIbNwuFVAYDpFEFQikMEggLBMLo////////////////////+/7UPO7WMUtWIULobz7RLRr+iqEeqAt87xsaEYUTy9Tp++qLfX/////////////////////+szSdzEqpC5Kq6uZtJl2tTMZFKicz6HyqpVOQpyRZGRQ15NDv///////////////////9K/29Uu6mKyy3daClf2Tp+VYasa5fHZk287xDcN9iQyLHVQ3IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/74kAAAAGveDeAABNyN7GG8AACbkbqLN4AAE3I08abwAAJuf///////////////////9f+3cmimojGc9TGKqlcyIHQj2c8TqfUN8lqR702ymwzz54AXCph5f//////////////////////et2rRqs4tEYZxcxR6SscdaOY0rqdgaulmYjvaRHPo5N0VyD9aKRP/////////////////////+5ZqTqR5Fe7qLNOznZCytWrI5m6ozkIp2IkilRFrOZm1V4I90weN/////////////////////+jpTmR5mmvYgplR02RkpZDbO8pT7WedlVV1lXeeKqiKiMwVvLoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/++JAAAABOwC3gAAAACdgBvAAAAAAAADeAAAAAAAAG8AAAAD////////////////2j+SvyxoNAqd5EJA1OnZYjEqiwFBpZA9POqH////////////////9Kqxrg6dVWddK3qLFpImqy9YCAoBBXX5UjLAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//viQAAAAAAAN4AAAAAAAAbwAAAAAAAA3gAAAAAAABvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==";

var ExerciseFinished10 = "data:audio/mpeg;base64,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";

var TRACKS = [
    { name: 'achievement', url: [Achievement] },
    { name: 'circular-progress-end', url: [CircularProgressEnd] },
    { name: 'circular-progress-loading', url: [CircularProgressLoading] },
    { name: 'correct', url: [Correct] },
    { name: 'incorrect', url: [Incorrect] },
    {
        name: 'exercise-finished',
        url: [
            ExerciseFinished0,
            ExerciseFinished1,
            ExerciseFinished2,
            ExerciseFinished3,
            ExerciseFinished4,
            ExerciseFinished5,
            ExerciseFinished6,
            ExerciseFinished7,
            ExerciseFinished8,
            ExerciseFinished9,
            ExerciseFinished10
        ]
    },
    { name: 'star-progress', url: [StarProgress] },
    { name: 'transition', url: [Transition] },
    { name: 'intro', url: [IntroSound] }
];
var invisibleStyle = {
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
    opacity: 0,
    position: 'absolute',
    border: 'none'
};
var SoundEffectsContext = React__default["default"].createContext({});
// @ts-ignore
var AudioContext = window.AudioContext || window.webkitAudioContext;
var SoundEffectsProvider = /** @class */ (function (_super) {
    __extends(SoundEffectsProvider, _super);
    function SoundEffectsProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            tracks: {}
        };
        _this.tryGetAudioContext = function () {
            try {
                if (!_this.baseAudioContext) {
                    if (AudioContext) {
                        _this.baseAudioContext = new AudioContext();
                    }
                }
            }
            catch (err) {
                console.warn('Audio context not available');
            }
            return _this.baseAudioContext;
        };
        _this.loadAllSounds = function () {
            try {
                var audioContext = _this.tryGetAudioContext();
                if (!audioContext)
                    return;
                TRACKS.forEach(function (_a) {
                    var name = _a.name, url = _a.url;
                    url.forEach(function (u) { return _this.loadAudio(name, u); });
                });
            }
            catch (err) {
                console.warn('AudioContext not supported - audio disabled');
            }
        };
        _this.loadAudio = function (name, url) { return __awaiter(_this, void 0, void 0, function () {
            var audioContext, rawData, arrayBuffer, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        audioContext = this.tryGetAudioContext();
                        if (!audioContext) {
                            console.warn('No audio context detected!');
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(url)];
                    case 2:
                        rawData = _a.sent();
                        return [4 /*yield*/, rawData.arrayBuffer()];
                    case 3:
                        arrayBuffer = _a.sent();
                        audioContext.decodeAudioData(arrayBuffer, function (audioFile) {
                            _this.addAudio(name, audioFile);
                        }, function (e) { return console.warn("Loading \"".concat(name, "\" track failed."), e); });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.warn("Loading \"".concat(name, "\" track failed."), error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.addAudio = function (name, audioFile) {
            _this.setState(function (state) {
                var _a;
                return (__assign$1(__assign$1({}, state), { tracks: __assign$1(__assign$1({}, state.tracks), (_a = {}, _a[name] = __spreadArray$1(__spreadArray$1([], (state.tracks[name] || []), true), [audioFile], false), _a)) }));
            });
        };
        _this.playSound = function (name, onEnded) {
            try {
                var audioContext = _this.tryGetAudioContext();
                if (!audioContext)
                    throw Error('missing audio context');
                var tracks = _this.state.tracks;
                if (!tracks[name]) {
                    console.warn("No audio buffer \"".concat(name, "\""));
                    return;
                }
                var startOffset = name === 'transition' ? 0.65 : 0;
                var duration = name === 'exercise-finished' ? 3.1 : undefined;
                var source = audioContext.createBufferSource();
                source.connect(audioContext.destination);
                source.buffer = tracks[name][Math.floor(Math.random() * tracks[name].length)];
                source.addEventListener('ended', function () {
                    if (onEnded)
                        onEnded();
                });
                source.start(0, startOffset, duration);
            }
            catch (err) {
                console.warn('playSound error', err);
            }
        };
        return _this;
    }
    SoundEffectsProvider.prototype.componentDidMount = function () {
        this.loadAllSounds();
    };
    SoundEffectsProvider.prototype.render = function () {
        return (React__default["default"].createElement(SoundEffectsContext.Provider, { value: {
                playSound: this.playSound
            } },
            this.props.children,
            React__default["default"].createElement("button", { style: invisibleStyle, id: "sound-effects-helper", "aria-hidden": true, tabIndex: -1 })));
    };
    return SoundEffectsProvider;
}(React__default["default"].Component));
var SoundEffectsConsumer = SoundEffectsContext.Consumer;

var withSoundEffectsContext = function (Component) { return function (props) { return (React__default["default"].createElement(SoundEffectsConsumer, null, function (_a) {
    var playSound = _a.playSound;
    return React__default["default"].createElement(Component, __assign$1({}, props, { playSound: playSound }));
})); }; };

var css_248z$o = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.building-exercise, .building-exercise--sentence, .building-exercise--word {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  flex: 1 0 auto;\n  min-height: 100%;\n  padding: 0px 20px 0;\n}\n@media (max-width: 600px) {\n  .building-exercise, .building-exercise--sentence, .building-exercise--word {\n    padding: 24px 8px 16px;\n  }\n}\n.building-exercise--word {\n  background-color: #d5f6ff;\n}\n.building-exercise--sentence {\n  background-color: #fff3c0;\n}\n.building-exercise__construction {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.building-exercise__word-spacing {\n  margin: 0 5px;\n}\n.building-exercise__character {\n  width: 350px;\n  height: 350px;\n  margin-top: 40px;\n  z-index: 1;\n}\n@media (max-width: 600px) {\n  .building-exercise__character {\n    width: 300px;\n    height: 300px;\n    margin-top: 16px;\n  }\n}\n.building-exercise__correctly-placed {\n  border-radius: 20px;\n  background-color: white;\n  margin: 2px 5px;\n  padding: 18px 22px;\n  animation: correct-placement 600ms 1 ease;\n}\n@media (max-width: 600px) {\n  .building-exercise__correctly-placed {\n    padding: 10px 14px;\n    margin: 2px 3px;\n  }\n}\n.building-exercise__candidate-pool {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  position: relative;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: -125px;\n  min-height: 68px;\n  z-index: 2;\n}\n.building-exercise__candidate {\n  background-color: white;\n  padding: 16px 24px;\n  border-radius: 24px;\n  margin: 4px 8px 6px;\n  border: 2px solid #ececec;\n  box-shadow: 0 4px #ececec;\n  cursor: grab;\n  z-index: 3;\n  touch-action: none;\n  -webkit-user-select: none;\n}\n.building-exercise__candidate p {\n  margin: 0;\n}\n.building-exercise__candidate--incorrect {\n  background-color: #ab082d;\n  box-shadow: none;\n  border: 2px solid #800622;\n  box-shadow: inset 0 -4px 0 0 rgba(0, 0, 0, 0.25);\n  animation: shake-horizontal 330ms normal;\n}\n.building-exercise__candidate--selected {\n  outline: 5px auto #015fcc;\n  outline-color: Highlight;\n  outline-color: -webkit-focus-ring-color;\n}\n@media (max-width: 600px) {\n  .building-exercise__candidate {\n    padding: 8px 16px;\n    margin: 2px 6px 4px;\n    border-radius: 20px;\n  }\n}\n.building-exercise__dropzone, .building-exercise__dropzone--char, .building-exercise__dropzone--word {\n  background-color: rgba(255, 255, 255, 0.5);\n  border-radius: 24px;\n  border: 2px dashed rgba(10, 10, 10, 0.76);\n  height: 56px;\n  width: 80px;\n  margin: 2px 5px;\n}\n.building-exercise__dropzone--word {\n  height: 68px;\n  width: 118px;\n}\n@media (max-width: 600px) {\n  .building-exercise__dropzone--word {\n    height: 52px;\n    width: 102px;\n    border-radius: 24px;\n  }\n}\n.building-exercise__dropzone--char {\n  height: 68px;\n  width: 78px;\n}\n@media (max-width: 600px) {\n  .building-exercise__dropzone--char {\n    height: 52px;\n    width: 62px;\n    border-radius: 24px;\n  }\n}\n@keyframes correct-placement {\n  0% {\n    box-shadow: 0 0 0 0 rgba(111, 226, 220, 0.7);\n    z-index: 5;\n  }\n  99% {\n    box-shadow: 0 0 3px 40px rgba(111, 226, 220, 0.05);\n    z-index: 5;\n  }\n  100% {\n    box-shadow: none;\n    z-index: unset;\n  }\n}";
styleInject(css_248z$o);

function shuffleArray(array) {
    var arrayClone = __spreadArray$1([], array, true);
    for (var i = arrayClone.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * i);
        var temp = arrayClone[i];
        arrayClone[i] = arrayClone[j];
        arrayClone[j] = temp;
    }
    return arrayClone;
}
var isTouchDevice = function () { return 'ontouchstart' in window || navigator.maxTouchPoints > 0; };
var BuildingExercise = /** @class */ (function (_super) {
    __extends(BuildingExercise, _super);
    function BuildingExercise() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            missing: [],
            wrongIndexes: [],
            totalAnswers: 0,
            missingIndexesCount: 0,
            splittedWordOrSentence: [],
            characterMood: 'idle',
            selectedId: null
        };
        _this.loadExerciseData = function () {
            var missingIndexes = _this.props.exercise.data.missingIndexes;
            _this.setState({
                missing: shuffleArray(missingIndexes),
                missingIndexesCount: missingIndexes.length,
                totalAnswers: 0,
                wrongIndexes: [],
                splittedWordOrSentence: _this.splitWordOrSentence(_this.props.exercise),
                characterMood: 'idle',
                selectedId: null
            });
        };
        _this.handleCorrect = function (draggableId) {
            _this.props.playSound('correct');
            _this.setState(function (state) { return ({
                missing: state.missing.filter(function (missingIndex) { return missingIndex !== parseInt(draggableId); }),
                wrongIndexes: state.wrongIndexes.filter(function (wrongIndex) { return wrongIndex !== parseInt(draggableId); }),
                totalAnswers: state.totalAnswers + 1,
                characterMood: 'correct'
            }); });
        };
        _this.handleIncorrect = function (draggableId) {
            _this.props.playSound('incorrect');
            if (_this.state.wrongIndexes.includes(parseInt(draggableId)))
                return;
            _this.setState(function (state) { return ({
                wrongIndexes: __spreadArray$1(__spreadArray$1([], state.wrongIndexes, true), [parseInt(draggableId)], false),
                totalAnswers: state.totalAnswers + 1,
                characterMood: 'wrong'
            }); });
        };
        _this.onDragEnd = function (result) {
            var destination = result.destination, draggableId = result.draggableId;
            if (!destination || destination.droppableId === 'candidate-pool')
                return;
            if (destination.droppableId === draggableId) {
                _this.handleCorrect(draggableId);
            }
            else {
                _this.handleIncorrect(draggableId);
            }
        };
        _this.handleDropWithClick = function (destinationId) {
            if (_this.state.selectedId !== null) {
                if (destinationId === _this.state.selectedId) {
                    _this.handleCorrect(_this.state.selectedId);
                }
                else {
                    _this.handleIncorrect(_this.state.selectedId);
                }
            }
        };
        _this.changeCharacterMood = function (mood) {
            _this.setState({
                characterMood: mood
            });
        };
        _this.isMissing = function (index) { return _this.state.missing.includes(index); };
        _this.wasMissing = function (index) {
            return _this.props.exercise.data.missingIndexes.includes(index) && !_this.isMissing(index);
        };
        _this.splitWordOrSentence = function (exercise) {
            var wordOrSentence = exercise.data.wordOrSentence;
            switch (exercise.type) {
                case exports.ExerciseType.SentenceBuilder:
                    return wordOrSentence.split(' ');
                case exports.ExerciseType.WordBuilder:
                    return wordOrSentence.split('');
                default:
                    return null;
            }
        };
        return _this;
    }
    BuildingExercise.prototype.componentDidMount = function () {
        this.loadExerciseData();
    };
    BuildingExercise.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        if (prevProps.exercise._id !== this.props.exercise._id) {
            this.loadExerciseData();
        }
        if (this.state.missing.length === 0 && prevState.missing.length !== 0) {
            this.changeCharacterMood('excited');
            this.props.playSound('exercise-finished', function () { return _this.changeCharacterMood('idle'); });
            var _a = this.state, missingIndexesCount = _a.missingIndexesCount, totalAnswers = _a.totalAnswers;
            var percentageScore_1 = (missingIndexesCount / totalAnswers) * 100;
            setTimeout(function () { return _this.props.onCurrentExerciseCompleted(~~percentageScore_1); }, 4000);
        }
    };
    BuildingExercise.prototype.render = function () {
        var _this = this;
        var exercise = this.props.exercise;
        var _a = this.state, missing = _a.missing, wrongIndexes = _a.wrongIndexes, splittedWordOrSentence = _a.splittedWordOrSentence;
        return (React__default["default"].createElement("div", { className: "building-exercise--".concat(exercise.type === exports.ExerciseType.SentenceBuilder ? 'sentence' : 'word') },
            React__default["default"].createElement(DragDropContext, { onDragEnd: this.onDragEnd },
                React__default["default"].createElement("div", { className: "building-exercise__construction" }, splittedWordOrSentence === null || splittedWordOrSentence === void 0 ? void 0 : splittedWordOrSentence.map(function (wordOrSentence, index) {
                    return _this.isMissing(index) ? (React__default["default"].createElement(DropZone, { key: "dropzone".concat(index), exerciseType: exercise.type, missingIndex: index, onClick: function () { return _this.handleDropWithClick(index.toString()); } })) : (React__default["default"].createElement(Typography, { key: "word".concat(index), variant: window.innerWidth <= 600 ? 'body' : 'exerciseS', className: "building-exercise__".concat(_this.wasMissing(index) ? 'correctly-placed' : 'word-spacing') }, wordOrSentence));
                })),
                React__default["default"].createElement(LottieCharacter, { mood: this.state.characterMood, changeCharacterMood: this.changeCharacterMood, characterName: exercise.type === exports.ExerciseType.WordBuilder ? 'Abbe' : 'Alfred', className: "building-exercise__character" }),
                React__default["default"].createElement(ConnectedDroppable, { droppableId: "candidate-pool", direction: "horizontal" }, function (provided) { return (React__default["default"].createElement("div", __assign$1({ className: "building-exercise__candidate-pool", ref: provided.innerRef }, provided.droppableProps),
                    splittedWordOrSentence &&
                        missing.map(function (missingIndex, index) { return (React__default["default"].createElement(Candidate, { key: "candidate".concat(missingIndex), missingIndex: missingIndex, isSelected: _this.state.selectedId === missingIndex.toString(), onSelect: function () {
                                return _this.setState({
                                    selectedId: _this.state.selectedId === missingIndex.toString() ? null : missingIndex.toString()
                                });
                            }, index: index, incorrect: wrongIndexes.includes(missingIndex) },
                            React__default["default"].createElement(Typography, { variant: window.innerWidth <= 600 ? 'body' : 'exerciseS' }, splittedWordOrSentence[missingIndex]))); }),
                    provided.placeholder)); }))));
    };
    return BuildingExercise;
}(React__default["default"].Component));
var Candidate = function (_a) {
    var index = _a.index, incorrect = _a.incorrect, missingIndex = _a.missingIndex, isSelected = _a.isSelected, onSelect = _a.onSelect, children = _a.children;
    var portal = document.getElementById('draggable');
    if (!portal) {
        console.error('No element with ID "draggable" found! Please add it to the DOM.');
        return null;
    }
    var optionalPortal = function (isDragging, element) {
        if (isDragging) {
            return require$$1.createPortal(element, portal);
        }
        return element;
    };
    return (React__default["default"].createElement(PublicDraggable, { draggableId: "".concat(missingIndex), index: index }, function (provided, snapshot) {
        var isDragging = snapshot.isDragging;
        var classNames = cx('building-exercise__candidate', {
            'building-exercise__candidate--dragging': isDragging,
            'building-exercise__candidate--selected': isSelected,
            'building-exercise__candidate--incorrect': incorrect && !isDragging
        });
        return optionalPortal(isDragging && !isTouchDevice(), React__default["default"].createElement("div", __assign$1({ onClick: onSelect, className: classNames, ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps), children));
    }));
};
var DropZone = function (_a) {
    var missingIndex = _a.missingIndex, exerciseType = _a.exerciseType, onClick = _a.onClick, children = _a.children;
    var classNames = cx({
        'building-exercise__dropzone--word': exerciseType === exports.ExerciseType.SentenceBuilder,
        'building-exercise__dropzone--char': exerciseType === exports.ExerciseType.WordBuilder
    });
    return (React__default["default"].createElement(ConnectedDroppable, { droppableId: "".concat(missingIndex) }, function (provided) { return (React__default["default"].createElement("div", __assign$1({ tabIndex: 0, role: "button", onClick: onClick, className: classNames, ref: provided.innerRef }, provided.droppableProps),
        children,
        provided.placeholder)); }));
};
var BuildingExercise$1 = withSoundEffectsContext(BuildingExercise);

var _path$p;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
var SvgReplay = function SvgReplay(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$p || (_path$p = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,5V1L7,6L12,11V7A6,6 0 0,1 18,13A6,6 0 0,1 12,19A6,6 0 0,1 6,13H4A8,8 0 0,0 12,21A8,8 0 0,0 20,13A8,8 0 0,0 12,5Z"
  })));
};

var css_248z$n = ".replay-sentence, .replay-sentence--playing {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  font-size: 20px;\n  cursor: pointer;\n  background: transparent;\n  transition: 230ms all;\n}\n.replay-sentence svg, .replay-sentence--playing svg {\n  width: 26px;\n  height: 26px;\n  margin-right: 4px;\n}\n.replay-sentence:hover, .replay-sentence--playing:hover {\n  opacity: 0.7;\n}\n.replay-sentence--playing svg {\n  animation: spin 1s infinite linear;\n}\n.replay-sentence--playing:hover {\n  opacity: 1;\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}";
styleInject(css_248z$n);

var ReplaySentence = function (_a) {
    var recording = _a.recording, className = _a.className;
    var _b = React.useState(false), playing = _b[0], setPlaying = _b[1];
    if (!recording)
        return null;
    var audio = new Audio(URL.createObjectURL(recording));
    audio.onplay = function () {
        setPlaying(true);
    };
    audio.onended = function () {
        setPlaying(false);
    };
    var playAudio = function () {
        if (playing)
            return;
        audio.play();
    };
    return (React__default["default"].createElement("button", { onClick: playAudio, className: "replay-sentence".concat(playing ? '--playing' : '', " ").concat(className ? className : '') },
        React__default["default"].createElement(SvgReplay, null),
        "Replay recording"));
};

var css_248z$m = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.reading-score-display {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: 22px;\n}\n.reading-score-display__layout {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: row;\n  margin: 10px;\n  border-radius: 14px;\n  padding: 16px 20px;\n  background-color: white;\n  animation: grow 600ms 1 normal;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);\n}\n.reading-score-display__description {\n  margin-left: 20px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: column;\n}\n.reading-score-display__description p {\n  margin: 0 0 10px;\n}\n.reading-score-display__description span {\n  color: rgba(10, 10, 10, 0.76);\n}";
styleInject(css_248z$m);

var ReadingScoreDisplay = function (_a) {
    var sanaRate = _a.sanaRate;
    if (!sanaRate)
        return null;
    var _b = sanaRate.assessment, content = _b.content, fluency = _b.fluency, pronunciation = _b.pronunciation;
    var getScoreColor = function (score) {
        if (score < 50) {
            return 'orangered';
        }
        else if (score < 80) {
            return '#FFAC1F';
        }
        else {
            return '#43c942';
        }
    };
    return (React__default["default"].createElement("section", { className: "reading-score-display" },
        React__default["default"].createElement("div", { className: "reading-score-display__layout" },
            React__default["default"].createElement(CircularProgressBar, { justForShow: true, percentage: pronunciation.score, size: 58, progressColor: getScoreColor(pronunciation.score), backgroundColor: "#EDEDF0", strokeWidth: 4 }, pronunciation.score),
            React__default["default"].createElement("div", { className: "reading-score-display__description" },
                React__default["default"].createElement(Typography, { variant: "body" }, "Pronunciation"),
                pronunciation.explanation.map(function (_a, i) {
                    var description = _a.description;
                    return (React__default["default"].createElement(Typography, { variant: "button", key: i }, description));
                }))),
        React__default["default"].createElement("div", { className: "reading-score-display__layout" },
            React__default["default"].createElement(CircularProgressBar, { justForShow: true, percentage: content.score, size: 58, progressColor: getScoreColor(content.score), backgroundColor: "#EDEDF0", strokeWidth: 4 }, content.score),
            React__default["default"].createElement("div", { className: "reading-score-display__description" },
                React__default["default"].createElement(Typography, { variant: "body" }, "Content"),
                content.explanation.map(function (_a, i) {
                    var description = _a.description;
                    return (React__default["default"].createElement(Typography, { variant: "button", key: i }, description));
                }))),
        React__default["default"].createElement("div", { className: "reading-score-display__layout" },
            React__default["default"].createElement(CircularProgressBar, { justForShow: true, percentage: fluency.score, size: 58, progressColor: getScoreColor(fluency.score), backgroundColor: "#EDEDF0", strokeWidth: 4 }, fluency.score),
            React__default["default"].createElement("div", { className: "reading-score-display__description" },
                React__default["default"].createElement(Typography, { variant: "body" },
                    "Fluency - ",
                    fluency.words_per_minute,
                    " words per minute"),
                fluency.explanation.map(function (_a, i) {
                    var description = _a.description;
                    return (React__default["default"].createElement(Typography, { variant: "button", key: i }, description));
                })))));
};

var css_248z$l = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.word-score {\n  position: relative;\n}\n.word-score__word, .word-score__word--great, .word-score__word--ok, .word-score__word--wrong {\n  padding: 0px 4px;\n  margin: 0;\n  cursor: pointer;\n  transition: 200ms all;\n}\n.word-score__word--wrong {\n  color: #e80f62 !important;\n  animation: shake-horizontal 330ms normal;\n}\n.word-score__word--ok {\n  color: #d3ab05;\n}\n.word-score__word--great {\n  color: #5cb57b !important;\n}\n.word-score__sounded-like {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: -8px;\n  left: 50%;\n  transform: translate(-50%);\n}\n.word-score__popup, .word-score__popup--open {\n  position: absolute;\n  display: none;\n  background-color: white;\n  z-index: 10;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  transform-origin: left;\n  padding: 8px;\n  white-space: nowrap;\n  border-radius: 10px;\n  border-spacing: 0px;\n  border-collapse: collapse;\n}\n.word-score__popup td, .word-score__popup--open td,\n.word-score__popup th,\n.word-score__popup--open th {\n  border: 1px solid lightgray;\n  padding: 4px 8px;\n}\n.word-score__popup th, .word-score__popup--open th {\n  background-color: #001593;\n  border-color: #001593;\n  color: white !important;\n}\n.word-score__popup--open {\n  display: block;\n  animation: custom-grow 200ms 1 linear;\n}\n.word-score__phoneme, .word-score__phoneme--great, .word-score__phoneme--ok, .word-score__phoneme--wrong {\n  color: rgba(10, 10, 10, 0.76);\n}\n.word-score__phoneme--wrong {\n  color: #e80f62 !important;\n}\n.word-score__phoneme--ok {\n  color: #d3ab05;\n}\n.word-score__phoneme--great {\n  color: #5cb57b !important;\n}\n@keyframes custom-grow {\n  0% {\n    transform: scale(0) translateX(-50%);\n  }\n  80% {\n    transform: scale(1.05) translateX(-50%);\n  }\n  100% {\n    transform: scale(1) translateX(-50%);\n  }\n}";
styleInject(css_248z$l);

var WordWithScore = function (_a) {
    var score = _a.score, demo = _a.demo;
    var _b = React.useState(false), popupOpen = _b[0], setPopupOpen = _b[1];
    var tableRef = React.useRef(null);
    var subjectiveScore = score.score < 40 ? 'wrong' : score.score < 75 ? 'ok' : 'great';
    React.useEffect(function () {
        document.addEventListener('mousedown', handleOutsideClick);
        return function () {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);
    var handleOutsideClick = function (event) {
        var _a;
        if (!((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            setPopupOpen(false);
        }
    };
    return (React__default["default"].createElement("div", { className: "word-score" },
        React__default["default"].createElement("table", { className: "word-score__popup".concat(popupOpen ? '--open' : ''), ref: tableRef },
            React__default["default"].createElement("thead", null,
                React__default["default"].createElement("tr", null,
                    React__default["default"].createElement("th", null, "Score"),
                    React__default["default"].createElement("th", null, "IPA"),
                    React__default["default"].createElement("th", null, "Sounded like"))),
            React__default["default"].createElement("tbody", null, score.phoneme_scores.map(function (_a, i) {
                var score = _a.score, phoneme_ipa = _a.phoneme_ipa, sounds_like_ipa = _a.sounds_like_ipa;
                return (React__default["default"].createElement("tr", { key: "".concat(phoneme_ipa).concat(i), className: "word-score__phoneme--".concat(score < 40 ? 'wrong' : score < 75 ? 'ok' : 'great') },
                    React__default["default"].createElement("td", null, score),
                    React__default["default"].createElement("td", null, phoneme_ipa),
                    React__default["default"].createElement("td", null, sounds_like_ipa)));
            }))),
        React__default["default"].createElement(Typography, { variant: "exerciseM", onBlur: function () { return setPopupOpen(false); }, onClick: function () { return setPopupOpen(function (state) { return !state; }); }, className: "word-score__word--".concat(subjectiveScore), style: { backgroundColor: popupOpen ? 'rgba(0,0,0,0.07)' : 'transparent' } }, score.word),
        demo && score.score < 80 && (React__default["default"].createElement("div", { className: "word-score__sounded-like" }, score.phoneme_scores.map(function (_a, i) {
            var sounds_like = _a.sounds_like;
            return (React__default["default"].createElement(Typography, { variant: "label", key: "".concat(sounds_like).concat(i) }, sounds_like));
        })))));
};

var AbbeWithBook = "data:image/png;base64,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";

var AlfredWithPencil = "data:image/png;base64,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";

var AbbeAndAlva = "data:image/png;base64,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";

var _path$o;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$o || (_path$o = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
  })));
};

var css_248z$k = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.reading-exercise, .reading-exercise--detailed {\n  display: flex;\n  position: relative;\n  width: 100%;\n  min-height: 100%;\n  flex: 1 0 auto;\n  flex-direction: column;\n  padding-top: 50px;\n  align-items: center;\n  justify-content: center;\n  background-color: #f3f7ff;\n}\n@media (max-width: 600px) {\n  .reading-exercise, .reading-exercise--detailed {\n    padding: 4px 4px 16px;\n  }\n}\n.reading-exercise--detailed {\n  justify-content: flex-start;\n}\n@media (max-width: 600px) {\n  .reading-exercise--detailed {\n    padding-top: 80px;\n    padding-bottom: 64px;\n  }\n}\n.reading-exercise__content {\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: center;\n}\n.reading-exercise__content img {\n  max-height: 330px;\n  border-radius: 10px;\n  margin-bottom: 32px;\n  box-shadow: inset 0 -4px 0 0 rgba(0, 0, 0, 0.25);\n}\n@media (max-width: 600px) {\n  .reading-exercise__content img {\n    width: calc(100% - 1rem);\n    max-width: 330px;\n    margin-bottom: 0;\n  }\n}\n.reading-exercise__listen-button {\n  position: absolute;\n  top: 28px;\n  right: 80px;\n}\n@media (max-width: 600px) {\n  .reading-exercise__listen-button {\n    top: 16px;\n    right: 10px;\n  }\n}\n.reading-exercise__controls {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n.reading-exercise__controls-progress {\n  position: absolute;\n  left: -90px;\n}\n.reading-exercise__controls-button {\n  position: absolute;\n  right: -100px;\n  padding: 0.75rem 1.25rem;\n}\n.reading-exercise__controls-button svg {\n  width: 30px;\n  height: 30px;\n}\n.reading-exercise__continue-button {\n  position: absolute;\n  bottom: 28px;\n  right: 80px;\n}\n.reading-exercise__continue-button svg {\n  width: 0px;\n  height: 20px;\n  transition: all 250ms;\n}\n.reading-exercise__continue-button:hover svg {\n  width: 20px;\n  margin-left: 5px;\n}\n@media (max-width: 600px) {\n  .reading-exercise__continue-button {\n    bottom: 16px;\n    right: 10px;\n  }\n}\n.reading-exercise__sentence-container, .reading-exercise__sentence-container--success {\n  max-width: 1440px;\n  text-align: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  margin: 24px 0 36px;\n}\n.reading-exercise__sentence-container--success {\n  animation: success 700ms;\n}\n.reading-exercise__word, .reading-exercise__word--success, .reading-exercise__word--ok, .reading-exercise__word--wrong {\n  padding: 0px 4px;\n  margin: 0;\n}\n.reading-exercise__word--wrong {\n  color: #e80f62 !important;\n  animation: shake-horizontal 330ms normal;\n}\n.reading-exercise__word--ok {\n  color: #d3ab05;\n}\n.reading-exercise__word--success {\n  color: #5cb57b;\n}\n.reading-exercise__character {\n  width: 350px;\n  height: 350px;\n}\n.reading-exercise__replay {\n  position: absolute;\n  top: 24px;\n  left: 16px;\n}\n@media (max-width: 600px) {\n  .reading-exercise__replay {\n    left: 8px;\n  }\n}\n@keyframes success {\n  50% {\n    opacity: 0.7;\n    transform: scale(1.1);\n  }\n}";
styleInject(css_248z$k);

function getRandomExerciseImage() {
    var images = [AbbeWithBook, AlfredWithPencil, AbbeAndAlva];
    return images[Math.floor(Math.random() * images.length)];
}
var ReadingExercise = function (_a) {
    var _b, _c, _d;
    var exercise = _a.exercise, country = _a.country, sanaApiUrl = _a.sanaApiUrl, onCurrentExerciseCompleted = _a.onCurrentExerciseCompleted, getSanaScore = _a.getSanaScore, displayDetailedScore = _a.displayDetailedScore, demo = _a.demo, playSound = _a.playSound;
    var _e = React.useState({
        mistakeCount: 0,
        recording: null,
        sanaRate: null,
        imgLoaded: false,
        continueDisabled: false,
        success: false
    }), state = _e[0], setState = _e[1];
    var listenSentenceRef = React.useRef(null);
    var isSuccess = ((_b = state.sanaRate) === null || _b === void 0 ? void 0 : _b.overall_score) && state.sanaRate.overall_score >= 60;
    var sentence = exercise.data.sentence;
    var handleRecording = function (recording) { return __awaiter(void 0, void 0, void 0, function () {
        var data_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getSanaScore({ audio: recording, phrase: sentence, withoutAuth: demo })];
                case 1:
                    data_1 = (_a.sent()).data;
                    setState(function (state) { return (__assign$1(__assign$1({}, state), { sanaRate: data_1, recording: recording, success: state.success || data_1.overall_score >= 75 })); });
                    rate(data_1);
                    return [3 /*break*/, 3];
                case 2:
                    _a.sent();
                    setState(function (state) { return (__assign$1(__assign$1({}, state), { recording: recording })); });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var rate = function (data) {
        var overall_score = data.overall_score;
        if (overall_score >= 75) {
            playSound('exercise-finished');
        }
        else {
            playSound('incorrect');
            setState(function (state) { return (__assign$1(__assign$1({}, state), { mistakeCount: state.mistakeCount + 1 })); });
        }
    };
    var renderWords = function () {
        var sanaRate = state.sanaRate;
        if (sanaRate && sanaRate.word_scores && sanaRate.word_scores.length > 0) {
            if (displayDetailedScore) {
                return sanaRate.word_scores.map(function (wordScore, i) { return (React__default["default"].createElement(WordWithScore, { demo: demo, key: "".concat(wordScore.word).concat(i), score: wordScore })); });
            }
            else {
                return sanaRate.word_scores.map(function (word, i) {
                    var colour = word.score < 40 ? '--wrong' : word.score < 75 ? '--ok' : '--success';
                    return (React__default["default"].createElement(Typography, { key: "".concat(word).concat(i), variant: sanaRate.word_scores.length < 25 ? 'exerciseM' : 'exerciseS', className: "reading-exercise__word".concat(colour) }, word.word));
                });
            }
        }
        var words = sentence.split(' ');
        return words.map(function (word, i) { return (React__default["default"].createElement(Typography, { key: "".concat(word).concat(i), variant: words.length < 25 ? 'exerciseM' : 'exerciseS', className: "reading-exercise__word" }, word)); });
    };
    var onStartRecording = React.useCallback(function () {
        var _a;
        (_a = listenSentenceRef.current) === null || _a === void 0 ? void 0 : _a.stopPlaying();
        setState(function (state) { return (__assign$1(__assign$1({}, state), { recording: null, sanaRate: null })); });
    }, []);
    var pickScoreColor = function (score) {
        return score < 40 ? '#e80f62' : score < 75 ? '#ffdc4a' : '#5cb57b';
    };
    React.useEffect(function () {
        setState({
            mistakeCount: 0,
            recording: null,
            sanaRate: null,
            imgLoaded: false,
            continueDisabled: false,
            success: false
        });
        if (demo) {
            exercise.imageUrl = getRandomExerciseImage();
        }
    }, [exercise._id]);
    return (React__default["default"].createElement("div", { className: "reading-exercise".concat(displayDetailedScore ? '--detailed' : '') },
        React__default["default"].createElement("div", { className: "reading-exercise__listen-button" },
            React__default["default"].createElement(ListenSentence, { recordingUrl: exercise.recordingUrl, ref: listenSentenceRef, sentence: sentence, country: country, sanaApiUrl: sanaApiUrl, jump: state.mistakeCount !== 0 && state.mistakeCount % 3 === 0 })),
        React__default["default"].createElement("div", { className: "reading-exercise__content" },
            React__default["default"].createElement("img", { src: exercise.imageUrl, alt: "Illustration" }),
            React__default["default"].createElement("div", { className: "reading-exercise__sentence-container".concat(isSuccess ? '--success' : '') }, renderWords()),
            React__default["default"].createElement("div", { className: "reading-exercise__controls" },
                ((_c = state.sanaRate) === null || _c === void 0 ? void 0 : _c.overall_score) !== undefined && (React__default["default"].createElement("div", { className: "reading-exercise__controls-progress" },
                    React__default["default"].createElement(CircularProgressBar, { percentage: state.sanaRate.overall_score, size: 60, strokeWidth: 6, progressColor: pickScoreColor(state.sanaRate.overall_score) },
                        React__default["default"].createElement("span", { style: { margin: 0, padding: 0, color: pickScoreColor(state.sanaRate.overall_score), fontSize: 18 } }, ((_d = state.sanaRate) === null || _d === void 0 ? void 0 : _d.overall_score) || 0)))),
                React__default["default"].createElement(AudioRecorder, { onStopRecording: handleRecording, onStartRecording: onStartRecording }),
                demo && (React__default["default"].createElement(Typography, { variant: "button", color: "secondary", style: { marginTop: 4 } }, "Press and hold")),
                (state.success || state.mistakeCount > 4) && (React__default["default"].createElement(Button, { className: "reading-exercise__controls-button", color: "light-blue", onClick: function () { return onCurrentExerciseCompleted(undefined, true); } },
                    React__default["default"].createElement(SvgArrowRight, null)))),
            displayDetailedScore && React__default["default"].createElement(ReadingScoreDisplay, { sanaRate: state.sanaRate })),
        displayDetailedScore && React__default["default"].createElement(ReplaySentence, { recording: state.recording, className: "reading-exercise__replay" })));
};
var ReadingExercise$1 = withSoundEffectsContext(ReadingExercise);

var _path$n;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$n || (_path$n = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
  })));
};

var css_248z$j = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.word-race-exercise {\n  display: flex;\n  align-items: center;\n  position: relative;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100%;\n  flex: 1 0 auto;\n  background-color: #fff2ee;\n}\n.word-race-exercise__content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 30px;\n  min-height: 120px;\n  flex-wrap: wrap;\n  transition: 500ms height;\n}\n.word-race-exercise__content > p {\n  margin: 0;\n}\n.word-race-exercise__character {\n  width: 350px;\n  height: 350px;\n}\n@media (max-width: 600px) {\n  .word-race-exercise__character {\n    width: 270px;\n    height: 270px;\n  }\n}\n.word-race-exercise__word, .word-race-exercise__word--wrong, .word-race-exercise__word--success {\n  background-color: transparent;\n  margin: 10px;\n  padding: 10px 26px;\n  border-radius: 12px;\n  position: relative;\n}\n.word-race-exercise__word svg, .word-race-exercise__word--wrong svg, .word-race-exercise__word--success svg {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  top: -8px;\n  right: -8px;\n  border-radius: 100px;\n  padding: 4px;\n  background-color: #5cb57b;\n  border: 3px solid #fff2ee;\n  fill: white;\n}\n.word-race-exercise__word p, .word-race-exercise__word--wrong p, .word-race-exercise__word--success p {\n  margin: 0;\n}\n.word-race-exercise__word--success {\n  background-color: #5cb57b;\n  animation: grow 500ms 1;\n}\n.word-race-exercise__word--success p {\n  color: white !important;\n}\n.word-race-exercise__word--wrong {\n  animation: grow 500ms 1, shake-horizontal 330ms 500ms 1 normal;\n}\n.word-race-exercise__word--wrong p {\n  color: #e80f62 !important;\n}\n@keyframes grow {\n  0% {\n    opacity: 0;\n    transform: scale(0);\n  }\n  80% {\n    opacity: 1;\n    transform: scale(1.05);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}";
styleInject(css_248z$j);

var WORD_RACE_CONFIG = {
    MIN_SUCCESS_SCORE: 50,
    AUTO_RECORD_COUNTDOWN: 3 // [s]
};
var Word = function (_a) {
    var word = _a.word, score = _a.score;
    var isSuccess = score >= WORD_RACE_CONFIG.MIN_SUCCESS_SCORE;
    var className = "word-race-exercise__word".concat(isSuccess ? '--success' : '--wrong');
    return (React__default["default"].createElement("span", { className: className },
        isSuccess && React__default["default"].createElement(SvgCheck, null),
        React__default["default"].createElement(Typography, { variant: "exerciseM" }, word)));
};
var WordRaceExercise = /** @class */ (function (_super) {
    __extends(WordRaceExercise, _super);
    function WordRaceExercise() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            wordIndex: 0,
            wordScores: [],
            displayWords: true,
            displayResults: false,
            characterMood: 'idle'
        };
        _this.changeCharacterMood = function (mood) {
            _this.setState({
                characterMood: mood
            });
        };
        _this.handleRateWord = function (recording, word) { return __awaiter(_this, void 0, void 0, function () {
            var exercise, words, overall_score_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        exercise = this.props.exercise;
                        words = exercise.data.words;
                        this.setState(function (_a) {
                            var wordIndex = _a.wordIndex;
                            var nextIndex = wordIndex + 1;
                            return {
                                wordIndex: nextIndex,
                                displayWords: nextIndex < words.length
                            };
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.getSanaScore({ audio: recording, phrase: word })];
                    case 2:
                        overall_score_1 = (_a.sent()).data.overall_score;
                        this.setState(function (_a) {
                            var wordScores = _a.wordScores;
                            var updatedWordScores = __spreadArray$1(__spreadArray$1([], wordScores, true), [{ word: word, score: overall_score_1 ? overall_score_1 : 0 }], false);
                            return {
                                wordScores: updatedWordScores,
                                displayResults: words.length === updatedWordScores.length
                            };
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        _a.sent();
                        this.setState(function (_a) {
                            var wordScores = _a.wordScores;
                            var updatedWordScores = __spreadArray$1(__spreadArray$1([], wordScores, true), [{ word: word, score: 0 }], false);
                            return {
                                wordScores: updatedWordScores,
                                displayResults: words.length === updatedWordScores.length
                            };
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    WordRaceExercise.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        if (prevProps.exercise._id !== this.props.exercise._id) {
            this.setState({
                displayWords: true,
                displayResults: false,
                wordIndex: 0,
                wordScores: [],
                characterMood: 'idle'
            });
        }
        if (this.state.displayResults && this.state.displayResults !== prevState.displayResults) {
            var _a = this.props, playSound = _a.playSound, onCurrentExerciseCompleted_1 = _a.onCurrentExerciseCompleted;
            var correctAnswers_1 = 0;
            var wordScores = this.state.wordScores;
            wordScores.forEach(function (score) {
                if (score.score >= WORD_RACE_CONFIG.MIN_SUCCESS_SCORE)
                    correctAnswers_1 += 1;
            });
            var percentageScore_1 = (correctAnswers_1 / wordScores.length) * 100;
            if (~~percentageScore_1 >= 60) {
                this.changeCharacterMood('excited');
                playSound('exercise-finished', function () { return _this.changeCharacterMood('idle'); });
            }
            else {
                this.changeCharacterMood('wrong');
                playSound('incorrect');
            }
            setTimeout(function () {
                _this.changeCharacterMood('idle');
                onCurrentExerciseCompleted_1(~~percentageScore_1);
            }, 4000);
        }
    };
    WordRaceExercise.prototype.render = function () {
        var _a = this.state, wordIndex = _a.wordIndex, wordScores = _a.wordScores, displayWords = _a.displayWords, displayResults = _a.displayResults, characterMood = _a.characterMood;
        var exercise = this.props.exercise;
        var words = exercise.data.words;
        return (React__default["default"].createElement("div", { className: "word-race-exercise" },
            React__default["default"].createElement("div", { className: "word-race-exercise__content" },
                React__default["default"].createElement(Countdown, { delayCountdown: 800, className: "word-race-exercise__content", seconds: 3, restartCountdown: exercise._id },
                    displayWords && React__default["default"].createElement(Typography, { variant: "exerciseXL" }, words[wordIndex]),
                    displayResults &&
                        wordScores.map(function (_a, index) {
                            var score = _a.score, word = _a.word;
                            return React__default["default"].createElement(Word, { key: "".concat(word).concat(index), score: score, word: word });
                        }),
                    React__default["default"].createElement(AudioRecorder, { autoRecorder: true, wordsToRecord: words, onStopWordRecording: this.handleRateWord }))),
            React__default["default"].createElement(LottieCharacter, { neverBored: true, characterName: "Alva", mood: characterMood, changeCharacterMood: this.changeCharacterMood, className: "word-race-exercise__character" })));
    };
    return WordRaceExercise;
}(React__default["default"].Component));
var WordRaceExercise$1 = withSoundEffectsContext(WordRaceExercise);

var css_248z$i = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.comprehension-exercise {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 100%;\n  flex: 1 0 auto;\n  background-color: #f3f7ff;\n  padding: 56px 24px 0px;\n  text-align: center;\n}\n@media (max-width: 600px) {\n  .comprehension-exercise {\n    padding: 0 8px 16px;\n  }\n}\n.comprehension-exercise__answers {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.comprehension-exercise__answer, .comprehension-exercise__answer--correct, .comprehension-exercise__answer--wrong {\n  background-color: white;\n  border-radius: 24px;\n  box-shadow: inset 0 -4px 0 0 #ececec;\n  border: solid 2px #ececec;\n  padding: 12px 22px;\n  margin: 2px 8px;\n  transition: background-color 230ms cubic-bezier(0, 0.68, 1, 0.79);\n  cursor: pointer;\n}\n.comprehension-exercise__answer p, .comprehension-exercise__answer--correct p, .comprehension-exercise__answer--wrong p {\n  margin: 0;\n}\n.comprehension-exercise__answer--wrong {\n  box-shadow: inset 0 -4px 0 0 rgba(0, 0, 0, 0.25);\n  background-color: #ab082d;\n  animation: wrong-pulse 1s normal;\n}\n.comprehension-exercise__answer--correct {\n  box-shadow: inset 0 -4px 0 0 rgba(0, 0, 0, 0.25);\n  background-color: #6fe2dc;\n  animation: correct-pulse 1s normal;\n}\n@media (max-width: 600px) {\n  .comprehension-exercise__answer, .comprehension-exercise__answer--correct, .comprehension-exercise__answer--wrong {\n    padding: 8px 16px 12px;\n  }\n}\n.comprehension-exercise__character {\n  width: 350px;\n  height: 350px;\n  margin-top: 32px;\n}\n@media (max-width: 600px) {\n  .comprehension-exercise__character {\n    width: 250px;\n    height: 250px;\n  }\n}\n@keyframes correct-pulse {\n  0% {\n    border-color: transparent;\n    box-shadow: none;\n  }\n  50% {\n    transform: scale(1.05);\n    border-color: transparent;\n    box-shadow: 0 0 0 20px rgba(111, 226, 220, 0.5);\n  }\n  100% {\n    border-color: transparent;\n    box-shadow: none;\n  }\n}\n@keyframes wrong-pulse {\n  0% {\n    border-color: transparent;\n    box-shadow: none;\n  }\n  50% {\n    border-color: transparent;\n    transform: rotate(2deg);\n    box-shadow: 0 0 0 20px rgba(247, 105, 136, 0.5);\n  }\n  100% {\n    border-color: transparent;\n    box-shadow: none;\n  }\n}";
styleInject(css_248z$i);

var Answer = function (_a) {
    var option = _a.option, answer = _a.answer, index = _a.index, onGoodAnswer = _a.onGoodAnswer, onWrongAnswer = _a.onWrongAnswer, disable = _a.disable;
    var _b = React.useState(''), state = _b[0], setState = _b[1];
    var checkAnswer = React.useCallback(function (option) {
        if (option === answer) {
            setState('--correct');
            onGoodAnswer();
        }
        else {
            setState('--wrong');
            onWrongAnswer();
        }
    }, 
    // eslint-disable-next-line
    [option, answer, onWrongAnswer]);
    var finishAnimation = React.useCallback(function () {
        setState(function (prevState) { return (prevState === '--correct' ? prevState : ''); });
    }, []);
    var className = "comprehension-exercise__answer".concat(state);
    return (React__default["default"].createElement("button", { disabled: disable, className: className, onClick: function () { return checkAnswer(index); }, onAnimationEnd: finishAnimation },
        React__default["default"].createElement(Typography, { variant: window.innerWidth < 600 ? 'exerciseS' : 'exerciseM' }, option)));
};
var ComprehensionExercise = function (_a) {
    var exercise = _a.exercise, onCurrentExerciseCompleted = _a.onCurrentExerciseCompleted, playSound = _a.playSound;
    var _b = exercise.data, answer = _b.answer, options = _b.options, question = _b.question;
    var _c = React.useState({
        answersCount: 0,
        characterMood: 'idle',
        answeredCorrectly: false
    }), state = _c[0], setState = _c[1];
    var changeCharacterMood = function (mood) {
        setState(function (state) { return (__assign$1(__assign$1({}, state), { characterMood: mood })); });
    };
    var delayedNextExerciseTransition = React.useCallback(function () {
        setState(function (s) { return (__assign$1(__assign$1({}, s), { characterMood: 'excited', answeredCorrectly: true })); });
        playSound('correct');
        playSound('exercise-finished', function () { return changeCharacterMood('idle'); });
        var score = (1 / (state.answersCount + 1)) * 100;
        setTimeout(function () { return onCurrentExerciseCompleted(~~score); }, 2000);
        // eslint-disable-next-line
    }, [state.answersCount]);
    React.useEffect(function () {
        setState({
            answersCount: 0,
            characterMood: 'idle',
            answeredCorrectly: false
        });
    }, [exercise]);
    return (React__default["default"].createElement("div", { className: "comprehension-exercise" },
        React__default["default"].createElement(Typography, { variant: window.innerWidth < 600 ? 'exerciseM' : 'exerciseL' }, question),
        React__default["default"].createElement("div", { className: "comprehension-exercise__answers" }, options.map(function (option, index) { return (React__default["default"].createElement(Answer, { key: option, answer: answer, index: index, option: option, disable: state.answeredCorrectly, onWrongAnswer: function () {
                playSound('incorrect');
                setState(function (state) { return (__assign$1(__assign$1({}, state), { characterMood: 'wrong', answersCount: state.answersCount + 1 })); });
            }, onGoodAnswer: delayedNextExerciseTransition })); })),
        React__default["default"].createElement(LottieCharacter, { mood: state.characterMood, changeCharacterMood: changeCharacterMood, characterName: "Abbe", className: "comprehension-exercise__character" })));
};
var ComprehensionExercise$1 = withSoundEffectsContext(ComprehensionExercise);

var _path$m;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$u({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$m || (_path$m = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8,5.14V19.14L19,12.14L8,5.14Z"
  })));
};

var _path$l;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$t({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$l || (_path$l = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14,19H18V5H14M6,19H10V5H6V19Z"
  })));
};

var css_248z$h = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.recording-player {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 92px;\n}\n.recording-player__progress {\n  height: 12px;\n  width: 100%;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  background-color: lightgray;\n  min-width: 450px;\n}\n@media (max-width: 600px) {\n  .recording-player__progress {\n    min-width: 270px;\n  }\n}\n.recording-player__progress-indicator {\n  height: 100%;\n  border-radius: 10px;\n  margin: 0;\n  padding: 0;\n  background-color: #ffdc4a;\n  transition: 250ms all linear;\n}\n.recording-player__button, .recording-player__button--playing {\n  border-radius: 100%;\n  padding: 10px;\n  background-color: #ffdc4a;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: 500ms all;\n}\n.recording-player__button svg, .recording-player__button--playing svg {\n  width: 40px;\n  height: 40px;\n  transition: 500ms all;\n}\n.recording-player__button--playing {\n  background-color: lightgray;\n  padding: 8px;\n}\n.recording-player__button--playing svg {\n  width: 30px;\n  height: 30px;\n  fill: grey;\n}";
styleInject(css_248z$h);

var RecordingPlayer = /** @class */ (function (_super) {
    __extends(RecordingPlayer, _super);
    function RecordingPlayer(props) {
        var _this = _super.call(this, props) || this;
        _this.audio = new Audio();
        _this.state = {
            playing: false,
            ended: false,
            currentTime: 0
        };
        _this.createAudio = function () {
            if (_this.props.recordingUrl) {
                _this.audio = new Audio(_this.props.recordingUrl);
            }
            else {
                _this.audio = new Audio(buildSanaVoiceSentenceURL({
                    sanaApiUrl: _this.props.sanaApiUrl,
                    sentence: _this.props.sentence,
                    country: _this.props.country
                }));
            }
        };
        _this.onClick = function () {
            if (_this.state.playing) {
                _this.audio.pause();
            }
            else {
                _this.audio.play();
            }
        };
        _this.stopPlaying = function () {
            if (_this.state.playing) {
                _this.audio.pause();
            }
        };
        _this.createAudio();
        _this.audio.onplay = function () { return _this.setState({ playing: true }); };
        _this.audio.onended = function () {
            _this.setState({ playing: false, ended: true });
            _this.props.onEnded && _this.props.onEnded();
        };
        _this.audio.onpause = function () { return _this.setState({ playing: false }); };
        _this.audio.ontimeupdate = function () { return _this.setState({ currentTime: _this.audio.currentTime }); };
        return _this;
    }
    RecordingPlayer.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.sentence !== this.props.sentence || prevProps.recordingUrl !== this.props.recordingUrl) {
            this.audio.pause();
            this.createAudio();
        }
    };
    RecordingPlayer.prototype.componentWillUnmount = function () {
        this.audio.pause();
    };
    RecordingPlayer.prototype.render = function () {
        var duration = this.audio.duration;
        var _a = this.state, currentTime = _a.currentTime, playing = _a.playing, ended = _a.ended;
        return (React__default["default"].createElement("div", { className: "recording-player ".concat(this.props.className ? this.props.className : ''), style: this.props.style },
            React__default["default"].createElement("div", { className: "recording-player__progress" },
                React__default["default"].createElement("div", { className: "recording-player__progress-indicator", style: { width: "".concat((currentTime / (isNaN(duration) ? 1 : duration)) * 100, "%") } })),
            React__default["default"].createElement("button", { className: "recording-player__button".concat(playing ? '--playing' : ''), onClick: this.onClick, disabled: ended }, playing ? React__default["default"].createElement(SvgPause, null) : React__default["default"].createElement(SvgPlay, null))));
    };
    return RecordingPlayer;
}(React.Component));

var css_248z$g = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.listening-exercise {\n  display: flex;\n  position: relative;\n  width: 100%;\n  min-height: 100%;\n  flex: 1 0 auto;\n  flex-direction: column;\n  padding-top: 50px;\n  align-items: center;\n  justify-content: center;\n  background-color: #f3f7ff;\n}\n@media (max-width: 600px) {\n  .listening-exercise {\n    padding: 4px 4px 16px;\n  }\n}\n.listening-exercise__content {\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: center;\n}\n.listening-exercise__content img {\n  max-height: 450px;\n  border-radius: 10px;\n  margin-bottom: 32px;\n  box-shadow: inset 0 -4px 0 0 rgba(0, 0, 0, 0.25);\n}\n@media (max-width: 600px) {\n  .listening-exercise__content img {\n    width: calc(100% - 1rem);\n    max-width: 330px;\n  }\n}";
styleInject(css_248z$g);

var ListeningExercise = function (_a) {
    var exercise = _a.exercise, sanaApiUrl = _a.sanaApiUrl, onCurrentExerciseCompleted = _a.onCurrentExerciseCompleted;
    var recordingUrl = exercise.recordingUrl, imageUrl = exercise.imageUrl;
    var sentence = exercise.data.sentence;
    return (React__default["default"].createElement("div", { className: "listening-exercise" },
        React__default["default"].createElement("div", { className: "listening-exercise__content" },
            React__default["default"].createElement("img", { src: imageUrl, alt: "Illustration" }),
            React__default["default"].createElement(RecordingPlayer, { sanaApiUrl: sanaApiUrl, sentence: sentence, recordingUrl: recordingUrl, onEnded: onCurrentExerciseCompleted }))));
};

var css_248z$f = ".exercise-transition, .exercise-transition--animate {\n  width: 100%;\n  display: flex;\n  min-height: 100%;\n  flex: 1 0 auto;\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.exercise-transition--animate {\n  transform-origin: right;\n  animation: touchscreen-transition 500ms 1 ease;\n}\n.exercise-transition__item {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-height: 100%;\n  will-change: opacity, transform;\n  display: flex;\n  justify-content: stretch;\n  align-items: stretch;\n}\n.exercise-transition__overlay {\n  position: absolute;\n  width: 100%;\n  min-height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  animation: overlay-anim 660ms 1 ease;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 2;\n}\n@keyframes overlay-anim {\n  from {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n  to {\n    background-color: rgba(0, 0, 0, 0.7);\n  }\n}\n@keyframes touchscreen-transition {\n  from {\n    opacity: 0;\n    transform: scaleX(0);\n  }\n  to {\n    opacity: 1;\n    transform: scaleX(1);\n  }\n}";
styleInject(css_248z$f);

exports.BookContext = void 0;
(function (BookContext) {
    BookContext["reading"] = "reading";
    BookContext["listening"] = "listening";
})(exports.BookContext || (exports.BookContext = {}));
var getExerciseComponent = function (type, bookContext) {
    if (bookContext === void 0) { bookContext = exports.BookContext.reading; }
    switch (type) {
        case exports.ExerciseType.ReadSentence: {
            if (bookContext === exports.BookContext.listening)
                return ListeningExercise;
            return ReadingExercise$1;
        }
        case exports.ExerciseType.MultiChoiseQuestion:
            return ComprehensionExercise$1;
        case exports.ExerciseType.ReadWordRace:
            return WordRaceExercise$1;
        case exports.ExerciseType.SentenceBuilder:
        case exports.ExerciseType.WordBuilder:
            return BuildingExercise$1;
        default:
            throw new Error("No exercise type ".concat(type));
    }
};
var ExerciseTransition = function (_a) {
    var exercises = _a.exercises, currentIndex = _a.currentIndex, onCurrentExerciseCompleted = _a.onCurrentExerciseCompleted, getSanaScore = _a.getSanaScore, trackExerciseActivity = _a.trackExerciseActivity, _b = _a.displayDetailedScore, displayDetailedScore = _b === void 0 ? false : _b, bookId = _a.bookId, playSound = _a.playSound, country = _a.country, bookContext = _a.bookContext, sanaApiUrl = _a.sanaApiUrl, demo = _a.demo;
    var _c = React.useState(false), animate = _c[0], setAnimate = _c[1];
    var transitions = useTransition(exercises[currentIndex], function (exercise) { return exercise._id; }, {
        from: { opacity: 1, transform: 'translateX(100%)' },
        enter: { opacity: 1, transform: 'translateX(0)' },
        leave: { opacity: 0.9, transform: 'translateX(0)' },
        config: {
            duration: 660,
            easing: quadInOut
        }
    });
    React.useEffect(function () {
        var exercise = exercises[currentIndex];
        setAnimate(true);
        if (exercise) {
            playSound('transition');
            try {
                trackExerciseActivity(exercise._id, exercise.type, bookId);
            }
            catch (e) { }
        }
        // eslint-disable-next-line
    }, [currentIndex, exercises]);
    if (isTouchDevice()) {
        var ExerciseComponent = getExerciseComponent(exercises[currentIndex].type, bookContext);
        var exerciseProps = {
            exercise: exercises[currentIndex],
            country: country,
            demo: demo,
            getSanaScore: getSanaScore,
            onCurrentExerciseCompleted: onCurrentExerciseCompleted,
            displayDetailedScore: displayDetailedScore
        };
        return (React__default["default"].createElement("div", { className: "exercise-transition".concat(animate ? '--animate' : ''), onAnimationEnd: function () { return setAnimate(false); } },
            React__default["default"].createElement(ExerciseComponent, __assign$1({}, exerciseProps))));
    }
    return (React__default["default"].createElement("div", { className: "exercise-transition" }, transitions.map(function (_a) {
        var item = _a.item, props = _a.props, key = _a.key, state = _a.state;
        var ExerciseComponent = getExerciseComponent(item.type, bookContext);
        var exerciseProps = {
            exercise: item,
            country: country,
            demo: demo,
            sanaApiUrl: sanaApiUrl,
            getSanaScore: getSanaScore,
            onCurrentExerciseCompleted: onCurrentExerciseCompleted,
            displayDetailedScore: displayDetailedScore
        };
        return (React__default["default"].createElement(extendedAnimated.div, { key: key, style: __assign$1({}, props), className: "exercise-transition__item" },
            state === 'leave' && React__default["default"].createElement("div", { className: "exercise-transition__overlay" }),
            React__default["default"].createElement(ExerciseComponent, __assign$1({}, exerciseProps))));
    })));
};
var ExerciseTransition$1 = withSoundEffectsContext(ExerciseTransition);

var css_248z$e = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.book-cover {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1 0 auto;\n  width: 100%;\n  background-color: #f3f7ff;\n}\n.book-cover__title {\n  text-align: center;\n}\n@media (max-width: 960px) {\n  .book-cover {\n    justify-content: flex-start;\n    padding-bottom: 16px;\n  }\n}\n.book-cover__content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin: 40px 0 130px;\n}\n@media (max-width: 960px) {\n  .book-cover__content {\n    flex-direction: column;\n    margin: 0 0 1rem;\n  }\n}\n@media (max-width: 600px) {\n  .book-cover__content {\n    width: 100%;\n  }\n}\n.book-cover__img-loader {\n  height: 240px !important;\n  width: 400px !important;\n  margin-right: 32px;\n  border-radius: 10px;\n  flex: 1 0 auto;\n}\n@media (max-width: 960px) {\n  .book-cover__img-loader {\n    margin-right: 0;\n    margin-bottom: 1rem;\n  }\n}\n@media (max-width: 600px) {\n  .book-cover__img-loader {\n    width: calc(100% - 1rem);\n    height: 200px;\n    max-width: 400px;\n  }\n}\n.book-cover img {\n  object-fit: cover;\n  height: 240px;\n  width: 400px;\n  margin-right: 32px;\n  border-radius: 10px;\n  box-shadow: 0px 3px 4px lightgrey;\n}\n@media (max-width: 960px) {\n  .book-cover img {\n    margin-right: 0;\n    margin-bottom: 1rem;\n  }\n}\n@media (max-width: 600px) {\n  .book-cover img {\n    width: calc(100% - 1rem);\n    height: 200px;\n    max-width: 400px;\n  }\n}\n.book-cover__info {\n  list-style: none;\n  flex: 1 0 auto;\n  margin: 0;\n  padding: 0;\n  border-radius: 10px;\n  background-color: white;\n  border: 2px solid lightgrey;\n  height: 240px;\n  width: 400px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 3px 4px lightgrey;\n}\n@media (max-width: 600px) {\n  .book-cover__info {\n    width: calc(100% - 1rem);\n    height: 200px;\n    max-width: 400px;\n  }\n}\n.book-cover__info li {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1;\n  padding: 0 32px;\n  border-bottom: 1px solid lightgrey;\n  font-size: 18px;\n}\n.book-cover__info li:last-child {\n  border: none;\n}\n.book-cover__info li span {\n  color: lightgrey;\n  font-size: 14px;\n  margin-bottom: 3px;\n}";
styleInject(css_248z$e);

var BookCover = function (_a) {
    var book = _a.book, bookContext = _a.bookContext, onStart = _a.onStart, disableContinue = _a.disableContinue;
    var _b = React.useState(false), imgLoaded = _b[0], setImgLoaded = _b[1];
    return (React__default["default"].createElement("div", { className: "book-cover" },
        React__default["default"].createElement(Typography, { variant: "h2", className: "book-cover__title" }, book.title),
        React__default["default"].createElement("div", { className: "book-cover__content" },
            React__default["default"].createElement(SkeletonLoader, { display: !imgLoaded, className: "book-cover__img-loader" }),
            React__default["default"].createElement("img", { hidden: !imgLoaded, src: book.imageUrl, alt: "Book Cover", onLoad: function () { return setImgLoaded(true); } }),
            React__default["default"].createElement("ul", { className: "book-cover__info" },
                React__default["default"].createElement("li", null,
                    React__default["default"].createElement("span", null, "Author"),
                    book.author),
                React__default["default"].createElement("li", null,
                    React__default["default"].createElement("span", null, "Illustrator"),
                    book.illustrator),
                React__default["default"].createElement("li", null,
                    React__default["default"].createElement("span", null, "Publisher"),
                    book.publisher))),
        React__default["default"].createElement(Button, { disabled: disableContinue, label: bookContext === exports.BookContext.listening ? 'Listen' : 'Start reading', onClick: onStart })));
};

var css_248z$d = ".tilting-card {\n  width: fit-content;\n  height: fit-content;\n}";
styleInject(css_248z$d);

function isTouch(event) {
    return event.type === 'touchmove';
}
var calculateAngles = function (event) {
    var SENSITIVITY = isTouch(event) ? 4 : 8; // lower value => more sensitive
    var w = event.currentTarget.offsetWidth;
    var h = event.currentTarget.offsetHeight;
    var rect = event.currentTarget.getBoundingClientRect();
    var pointer_w = isTouch(event) ? event.touches[0].clientX - rect.left : event.clientX - rect.left;
    var pointer_h = isTouch(event) ? event.touches[0].clientY - rect.top : event.clientY - rect.top;
    var mouse_inclanation_percent_Y = ((pointer_w - w / 2) / w) * 100;
    var mouse_inclanation_percent_X = ((pointer_h - h / 2) / h) * 100;
    var angleX = mouse_inclanation_percent_X / SENSITIVITY;
    var angleY = -mouse_inclanation_percent_Y / SENSITIVITY;
    return [angleX, angleY];
};
var makeTransform = function (x, y) {
    return "perspective(600px) rotateX(".concat(x, "deg) rotateY(").concat(y, "deg)");
};
var TiltingCard = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style, rest = __rest(_a, ["children", "className", "style"]);
    var _b = useSpring(function () { return ({
        xyAngles: [0, 0],
        config: { mass: 1, tension: 600, friction: 40 }
    }); }), props = _b[0], set = _b[1];
    return (React__default["default"].createElement(extendedAnimated.div, __assign$1({ className: "".concat(className ? className : '', " tilting-card"), onMouseMove: function (e) { return set({ xyAngles: calculateAngles(e) }); }, onTouchMove: function (e) { return set({ xyAngles: calculateAngles(e) }); }, onMouseLeave: function () { return set({ xyAngles: [0, 0] }); }, onTouchEnd: function () { return set({ xyAngles: [0, 0] }); }, onTouchCancel: function () { return set({ xyAngles: [0, 0] }); }, style: __assign$1({ 
            // @ts-ignore
            transform: props.xyAngles.interpolate(makeTransform) }, style) }, rest), children));
};

var css_248z$c = ".headline {\n  display: flex;\n  flex-direction: row;\n}\n.headline img {\n  width: 60px;\n  height: 60px;\n  margin-right: 20px;\n  border-radius: 100%;\n  object-fit: cover;\n}\n.headline h2,\n.headline p {\n  margin: 0;\n}";
styleInject(css_248z$c);

var Headline = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, imgSrc = _a.imgSrc, className = _a.className, style = _a.style;
    return (React__default["default"].createElement("div", { className: "headline ".concat(className ? className : ''), style: style },
        imgSrc && React__default["default"].createElement("img", { src: imgSrc, alt: "" }),
        React__default["default"].createElement("div", null,
            typeof title === 'string' ? React__default["default"].createElement(Typography, { variant: 'h2' }, title) : title,
            typeof subtitle === 'string' ? (React__default["default"].createElement(Typography, { variant: 'body', color: 'secondary' }, subtitle)) : (subtitle))));
};

var css_248z$b = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.chip {\n  padding: 0 16px;\n  line-height: 56px;\n  border-radius: 20px;\n  background-color: #f8f8f8;\n  display: flex;\n  align-items: center;\n}\n.chip__avatar {\n  width: 24px;\n  height: 24px;\n  display: inline-block;\n  border-radius: 8px;\n  font-family: \"Lexend\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  color: white;\n  margin-right: 8px;\n}\n.chips-factory {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.chips-factory > span {\n  margin: 4px 8px;\n}";
styleInject(css_248z$b);

var Chip = function (_a) {
    var children = _a.children, _b = _a.avatar, avatar = _b === void 0 ? '' : _b;
    return (React__default["default"].createElement("div", { className: "chip" },
        avatar,
        children));
};
var ChipAvatar = function (_a) {
    var children = _a.children, style = _a.style;
    return (React__default["default"].createElement("span", { className: "chip__avatar", style: style }, children));
};
var ChipsFactory = function (_a) {
    var data = _a.data, sortKey = _a.sortKey, textKey = _a.textKey, bgColor = _a.bgColor, avatar = _a.avatar, textModifier = _a.textModifier, className = _a.className, style = _a.style;
    var dataToDisplay = sortKey ? __spreadArray$1([], data, true).sort(function (a, b) { return a[sortKey] - b[sortKey]; }) : data;
    var textToDisplay = React.useCallback(function (item) {
        if (textKey in item) {
            return textModifier ? textModifier(item[textKey]) : item[textKey];
        }
        console.error('ChipFactory: Provided textKey is invalid.', 'Item:', item, 'textKey:', textKey);
    }, [textKey, data, textModifier]);
    return (React__default["default"].createElement("div", { className: "chips-factory ".concat(className ? className : ''), style: style }, dataToDisplay.map(function (item, i) { return (React__default["default"].createElement("span", { key: "customChip".concat(i) },
        React__default["default"].createElement(Chip, { avatar: avatar ? React__default["default"].createElement(ChipAvatar, { style: { backgroundColor: bgColor } }, i + 1) : undefined }, textToDisplay(item)))); })));
};

var _path$k;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$s({
    width: 54,
    height: 47,
    viewBox: "0 0 54 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$k || (_path$k = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0137 37.1321C25.4086 37.1321 24.1063 35.8642 24.1063 34.2641C24.1063 32.6642 25.4086 31.366 27.0137 31.366C28.6189 31.366 29.8909 32.6642 29.8909 34.2641C29.8909 35.8642 28.6189 37.1321 27.0137 37.1321ZM52.9689 33.9321L35.403 5.28302C34.4338 3.86415 33.3435 2.59623 32.0109 1.63019C30.5875 0.603774 28.952 0 27.0137 0C25.0754 0 23.44 0.603774 21.9862 1.63019C20.684 2.59623 19.5937 3.86415 18.6245 5.28302L0.967742 34.083C-0.364844 36.8302 -0.364844 39.9698 1.24032 42.5962C2.66376 44.9208 5.1775 46.4 7.90324 46.4H46.0939C48.85 46.4 51.3334 44.9208 52.7569 42.5962C54.362 40 54.4226 36.6189 52.9689 33.9321ZM27.0137 28.4981C25.9537 28.4981 25.1966 27.6226 25.0754 26.566L24.1063 17.9019C23.9548 16.4226 25.5297 15.034 27.0137 15.034C28.4977 15.034 30.0726 16.4226 29.8909 17.9019L28.9217 26.566C28.8309 27.6226 28.0737 28.4981 27.0137 28.4981Z",
    fill: "#E91868"
  })));
};

var css_248z$a = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.alert-wrapper, .alert-wrapper--closed, .alert-wrapper--open {\n  position: fixed;\n  bottom: -70px;\n  left: 50%;\n  transform: translateX(-50%);\n  transition: 0.2s;\n  border: 2px solid #e80f62;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n  border-radius: 10px;\n  background-color: white;\n  max-width: 400px;\n  max-height: 64px;\n  overflow: hidden;\n}\n.alert-wrapper svg, .alert-wrapper--closed svg, .alert-wrapper--open svg {\n  width: 20px;\n  height: 20px;\n  margin: 0 10px 0 0;\n}\n.alert-wrapper p, .alert-wrapper--closed p, .alert-wrapper--open p {\n  width: calc(100% - 18px);\n  overflow: hidden;\n  max-height: 40px;\n  line-height: 20px;\n  font-size: 18px;\n  margin: 0;\n}\n.alert-wrapper--open {\n  bottom: 20px;\n  z-index: 10000;\n}\n.alert-wrapper--closed {\n  bottom: -70px;\n}";
styleInject(css_248z$a);

var AlertContext = React__default["default"].createContext({
    opened: false,
    type: 'error',
    text: '',
    showAlert: function () { },
    close: function () { }
});
var HIDE_DURATION = 4000;
var AlertContextProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState({ opened: false, type: 'error', text: '' }), alertState = _b[0], setAlertState = _b[1];
    var hideTimeout = React.useRef(null);
    var clearTextTimeout = React.useRef(null);
    var show = React.useCallback(function (text, type) {
        if (type === void 0) { type = 'error'; }
        setAlertState({ opened: true, type: type, text: text });
        hideTimeout.current = setTimeout(close, HIDE_DURATION);
        //eslint-disable-next-line
    }, []);
    var close = React.useCallback(function () {
        setAlertState(function (state) { return (__assign$1(__assign$1({}, state), { opened: false })); });
        clearTextTimeout.current = setTimeout(function () {
            setAlertState(function (state) { return (__assign$1(__assign$1({}, state), { text: '' })); });
        }, 500);
    }, []);
    React.useEffect(function () {
        return function () {
            if (hideTimeout.current)
                clearTimeout(hideTimeout.current);
            if (clearTextTimeout.current)
                clearTimeout(clearTextTimeout.current);
            hideTimeout.current = null;
            clearTextTimeout.current = null;
        };
    }, []);
    return (React__default["default"].createElement(AlertContext.Provider, { value: __assign$1(__assign$1({}, alertState), { showAlert: show, close: close }) }, children));
};
var AlertContextConsumer = function () {
    var _a = React.useContext(AlertContext), opened = _a.opened, text = _a.text;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: "alert-wrapper--".concat(opened ? 'open' : 'closed') },
            React__default["default"].createElement(SvgError, null),
            React__default["default"].createElement("p", null, text))));
};
var AlertProvider = function (_a) {
    var children = _a.children;
    return (React__default["default"].createElement(AlertContextProvider, null,
        children,
        React__default["default"].createElement(AlertContextConsumer, null)));
};

var css_248z$9 = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.astrid-card {\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: inset 0 -4px 0 0 #ececec;\n  border: solid 2px #ececec;\n}\n.astrid-card__header {\n  padding: 32px;\n  border-bottom: solid 1px #ececec;\n}\n.astrid-card__header h4,\n.astrid-card__header p {\n  margin: 0;\n}\n.astrid-card__note {\n  color: rgba(10, 10, 10, 0.7);\n}\n.astrid-card__content {\n  padding: 32px;\n}";
styleInject(css_248z$9);

var Card = function (_a) {
    var title = _a.title, titleNote = _a.titleNote, subtitle = _a.subtitle, children = _a.children, className = _a.className;
    var showHeader = !!(title || subtitle);
    return (React__default["default"].createElement("div", { className: "astrid-card ".concat(className ? className : '') },
        showHeader && (React__default["default"].createElement("div", { className: "astrid-card__header" },
            React__default["default"].createElement(Typography, { variant: "h4" }, title),
            titleNote ? React__default["default"].createElement("span", { className: "astrid-card__note" }, titleNote) : null,
            React__default["default"].createElement(Typography, { variant: "body" }, subtitle))),
        React__default["default"].createElement("div", { className: "astrid-card__content" }, children)));
};

var onboardingExercises = [
    {
        _id: '5ee098d48be050001fc9892d',
        type: exports.ExerciseType.MultiChoiseQuestion,
        points: 10,
        data: {
            question: 'When you read to Astrid you should...',
            options: ['Clap your hands', 'Press and hold the yellow button', 'Type your answer'],
            answer: 1
        }
    },
    {
        _id: '5ed8ef957dadae00203946f2',
        type: exports.ExerciseType.ReadSentence,
        points: 20,
        data: {
            sentence: 'Astrid is a magical schoolbook.'
        },
        imageUrl: AbbeWithBook
    },
    {
        _id: '5ed8efe87dadae00203946f3',
        type: exports.ExerciseType.SentenceBuilder,
        points: 20,
        data: {
            wordOrSentence: 'Astrid listens as you speak.',
            missingIndexes: [1, 3]
        },
        imageUrl: AlfredWithPencil
    },
    {
        _id: '5edf878b8be050001fc98845',
        type: exports.ExerciseType.ReadWordRace,
        points: 10,
        data: {
            words: ['Read', 'along', 'with', 'Astrid']
        }
    }
];

var css_248z$8 = ".onboarding-book {\n  display: flex;\n  flex: 1 0 auto;\n  position: relative;\n  width: 100%;\n  min-height: 100%;\n}\n.onboarding-book img {\n  box-shadow: none;\n}\n.onboarding-book__navigation {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n  pointer-events: none;\n}\n.onboarding-book__navigation svg {\n  width: 80px;\n  height: 100%;\n  padding: 0 15px;\n  cursor: pointer;\n  transition: 300ms all;\n  pointer-events: all;\n}\n.onboarding-book__navigation svg:hover {\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));\n}\n.onboarding-book__navigation svg:first-of-type {\n  transform: rotate(180deg);\n}\n.onboarding-book__tip {\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  background-color: rgba(0, 0, 0, 0.4);\n  padding: 10px 20px;\n  border-radius: 10px;\n  transform: translate(-50%);\n}\n.onboarding-book__tip p {\n  margin: 0;\n  color: white;\n}";
styleInject(css_248z$8);

var OnboardingBook = /** @class */ (function (_super) {
    __extends(OnboardingBook, _super);
    function OnboardingBook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            index: 0
        };
        _this.next = function () {
            _this.setState(function (_a) {
                var index = _a.index;
                if (index + 1 > onboardingExercises.length - 1) {
                    _this.props.onFinish();
                    return { index: index };
                }
                else {
                    return { index: index + 1 };
                }
            });
        };
        _this.prev = function () {
            _this.setState(function (_a) {
                var index = _a.index;
                if (index > 0) {
                    return { index: index - 1 };
                }
            });
        };
        _this.bindKeyboardArrows = function () {
            return onRightOrLeftKeyboardArrows(function () {
                // right
                _this.next();
            }, function () {
                // left
                _this.prev();
            });
        };
        return _this;
    }
    OnboardingBook.prototype.componentDidMount = function () {
        if (this.props.withDetailedScore) {
            this.keyBindings = this.bindKeyboardArrows();
        }
        if (this.props.onMount)
            this.props.onMount();
    };
    OnboardingBook.prototype.componentWillUnmount = function () {
        document.removeEventListener('keyup', this.keyBindings);
    };
    OnboardingBook.prototype.render = function () {
        var _a = this.props, getSanaScore = _a.getSanaScore, withDetailedScore = _a.withDetailedScore, country = _a.country;
        return (React__default["default"].createElement("div", { className: "onboarding-book" },
            React__default["default"].createElement(ExerciseTransition$1, { currentIndex: this.state.index, country: country, trackExerciseActivity: function () { }, onCurrentExerciseCompleted: this.props.withDetailedScore ? function () { } : this.next, exercises: onboardingExercises, getSanaScore: getSanaScore, displayDetailedScore: withDetailedScore }),
            withDetailedScore && (React__default["default"].createElement("div", { className: "onboarding-book__tip" },
                React__default["default"].createElement(Typography, { variant: "body" }, '⇦ Navigate between exercises with arrows ⇨'))),
            React__default["default"].createElement("div", { className: "onboarding-book__navigation" },
                React__default["default"].createElement(SvgArrowRight, { onClick: this.prev }),
                React__default["default"].createElement(SvgArrowRight, { onClick: this.next }))));
    };
    return OnboardingBook;
}(React__default["default"].Component));

var css_248z$7 = ".astrid-modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3000;\n}\n.astrid-modal > button {\n  margin-top: 24px;\n}\n.astrid-modal__content {\n  position: relative;\n  padding: 32px 40px;\n  background-color: white;\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 800px;\n  max-height: 80vh;\n}\n.astrid-modal__close-icon {\n  position: absolute;\n  right: 18px;\n  top: 18px;\n  cursor: pointer;\n  border-radius: 100%;\n  transition: 230ms all;\n  padding: 2px;\n  width: 32px;\n  height: 32px;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.astrid-modal__close-icon:hover {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.astrid-modal__close-icon:active {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.astrid-modal__scrollable {\n  overflow: auto;\n}";
styleInject(css_248z$7);

var InvitationModal = function (_a) {
    var open = _a.open, closeModal = _a.closeModal, _b = _a.variant, variant = _b === void 0 ? 'student' : _b, hideCloseButton = _a.hideCloseButton, children = _a.children;
    var modalRef = React.useRef(null);
    var contentRef = React.useRef(null);
    React.useEffect(function () {
        var _a;
        // focus on element (so that using keyboard works correctly)
        if (open) {
            (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [open]);
    React.useEffect(function () {
        // Outside click handler
        var handleClickOutside = function (event) {
            var _a;
            if (!((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                closeModal && closeModal();
            }
        };
        var handleEscapeClick = function (event) {
            if (event.keyCode === 27) {
                closeModal && closeModal();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscapeClick);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscapeClick);
        };
    }, [contentRef]);
    if (!open)
        return null;
    if (!hideCloseButton && !closeModal)
        console.error('Modal: No closing function provided. The default close button will not work.');
    return (React__default["default"].createElement("div", { className: "astrid-modal", role: "dialog", tabIndex: -1, ref: modalRef },
        React__default["default"].createElement("div", { className: "astrid-modal__content", ref: contentRef },
            React__default["default"].createElement("div", { className: "astrid-modal__scrollable" },
                children,
                !hideCloseButton && (React__default["default"].createElement(Button, { onClick: closeModal, variant: variant === 'teacher' ? 'flat' : 'filled', color: variant === 'teacher' ? 'action' : 'primary' }, "Close"))),
            React__default["default"].createElement("button", { className: "astrid-modal__close-icon", onClick: closeModal, "aria-label": "Close" },
                React__default["default"].createElement(SvgClose, null)))));
};

var v = "5.5.10";
var fr = 60;
var ip = 0;
var op = 331;
var w = 900;
var h = 900;
var nm = "Astrid logo animation final";
var ddd = 0;
var assets = [
	{
		id: "comp_0",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 0,
				nm: "Boll I",
				refId: "comp_1",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 59,
								s: [
									0
								]
							},
							{
								t: 60,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.724,
									y: 0.814
								},
								o: {
									x: 0.442,
									y: 0
								},
								t: 36,
								s: [
									829,
									-1078.507,
									0
								],
								to: [
									0,
									279.333,
									0
								],
								ti: [
									0,
									-102,
									0
								]
							},
							{
								i: {
									x: 0.376,
									y: 1
								},
								o: {
									x: 0.001,
									y: 0
								},
								t: 63.527,
								s: [
									829,
									597.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									-36.602,
									2.182,
									0
								]
							},
							{
								i: {
									x: 0.927,
									y: 0.865
								},
								o: {
									x: 0.516,
									y: 0
								},
								t: 78.598,
								s: [
									889,
									442.493,
									0
								],
								to: [
									25.167,
									-1.5,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.667,
									y: 1
								},
								o: {
									x: 0.38,
									y: 0.581
								},
								t: 93.559,
								s: [
									929,
									597.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									-13.083,
									0.5,
									0
								]
							},
							{
								i: {
									x: 0.923,
									y: 0.968
								},
								o: {
									x: 0.526,
									y: 0
								},
								t: 100.598,
								s: [
									951,
									557.493,
									0
								],
								to: [
									6.583,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.824,
									y: 1
								},
								o: {
									x: 0.127,
									y: 0
								},
								t: 110,
								s: [
									968.5,
									597.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.22,
									y: 0.22
								},
								o: {
									x: 0.296,
									y: 0.296
								},
								t: 156,
								s: [
									1100,
									598.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.22,
									y: 1
								},
								o: {
									x: 0.78,
									y: 0
								},
								t: 163,
								s: [
									1100,
									598.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 1,
									y: 1
								},
								o: {
									x: 0.78,
									y: 0
								},
								t: 175,
								s: [
									1099,
									369.993,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 1,
									y: 1
								},
								o: {
									x: 0.167,
									y: 0
								},
								t: 191,
								s: [
									1099,
									459.993,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 1,
									y: 1
								},
								o: {
									x: 0.167,
									y: 0
								},
								t: 201,
								s: [
									1099,
									467.993,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 215,
								s: [
									1099,
									459.993,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							27.007,
							27.007,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Squash & Stretch Bezier Warp",
						np: 15,
						mn: "ADBE BEZMESH",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 3,
								nm: "Top Left Vertex",
								mn: "ADBE BEZMESH-0001",
								ix: 1,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												0,
												0
											],
											to: [
												-0.333,
												-5.833
											],
											ti: [
												0.321,
												-1.384
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.025,
											s: [
												-0.44,
												-7.7
											],
											to: [
												-0.321,
												1.384
											],
											ti: [
												-0.33,
												-0.843
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												-1.925,
												8.305
											],
											to: [
												0.33,
												0.843
											],
											ti: [
												-0.577,
												1.824
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												1.54,
												-2.64
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												1.54,
												-2.64
											],
											to: [
												-0.44,
												1.247
											],
											ti: [
												0.257,
												-0.44
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												-1.1,
												4.84
											],
											to: [
												-0.257,
												0.44
											],
											ti: [
												-0.018,
												-0.018
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												0,
												0
											],
											to: [
												0.018,
												0.018
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												-0.99,
												4.95
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												0,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 112.115,
											s: [
												-0.33,
												1.54
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 117.121,
											s: [
												0,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 127.130859375,
											s: [
												0,
												0
											]
										}
									],
									ix: 1
								}
							},
							{
								ty: 3,
								nm: "Top Left Tangent",
								mn: "ADBE BEZMESH-0002",
								ix: 2,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												18.333,
												0
											],
											to: [
												-0.5,
												-5.667
											],
											ti: [
												0.403,
												-0.926
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.025,
											s: [
												17.673,
												-7.48
											],
											to: [
												-0.403,
												0.926
											],
											ti: [
												-0.183,
												-0.293
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												15.913,
												5.555
											],
											to: [
												0.183,
												0.293
											],
											ti: [
												-0.477,
												1.879
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												18.773,
												-5.72
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												18.773,
												-5.72
											],
											to: [
												-0.11,
												1.21
											],
											ti: [
												0.073,
												-0.953
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												18.113,
												1.54
											],
											to: [
												-0.073,
												0.953
											],
											ti: [
												-0.037,
												0.257
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												18.333,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												18.333,
												0
											],
											to: [
												-0.018,
												-0.293
											],
											ti: [
												-0.183,
												-0.458
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												18.223,
												-1.76
											],
											to: [
												0.183,
												0.458
											],
											ti: [
												-0.018,
												0.055
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 112.115,
											s: [
												19.433,
												2.75
											],
											to: [
												0.018,
												-0.055
											],
											ti: [
												0.183,
												0.458
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 117.121,
											s: [
												18.333,
												-2.09
											],
											to: [
												-0.183,
												-0.458
											],
											ti: [
												0,
												-1.583
											]
										},
										{
											t: 127.130859375,
											s: [
												18.333,
												0
											]
										}
									],
									ix: 2
								}
							},
							{
								ty: 3,
								nm: "Top Right Tangent",
								mn: "ADBE BEZMESH-0003",
								ix: 3,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												36.665,
												0
											],
											to: [
												-0.333,
												-4.833
											],
											ti: [
												-0.266,
												-0.77
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.025,
											s: [
												36.225,
												-6.38
											],
											to: [
												0.266,
												0.77
											],
											ti: [
												-0.367,
												-0.367
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												38.26,
												4.62
											],
											to: [
												0.367,
												0.367
											],
											ti: [
												-0.028,
												1.467
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												38.425,
												-4.18
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												38.425,
												-4.18
											],
											to: [
												-0.367,
												0.843
											],
											ti: [
												0.293,
												-0.697
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												36.225,
												0.88
											],
											to: [
												-0.293,
												0.697
											],
											ti: [
												-0.11,
												0.202
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												36.665,
												0
											],
											to: [
												0.11,
												-0.202
											],
											ti: [
												0,
												0.275
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												36.885,
												-0.33
											],
											to: [
												0,
												-0.275
											],
											ti: [
												0.183,
												-0.495
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												36.665,
												-1.65
											],
											to: [
												-0.183,
												0.495
											],
											ti: [
												-0.018,
												0.055
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 112.115,
											s: [
												35.785,
												2.64
											],
											to: [
												0.018,
												-0.055
											],
											ti: [
												-0.147,
												0.44
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 117.121,
											s: [
												36.775,
												-1.98
											],
											to: [
												0.147,
												-0.44
											],
											ti: [
												0.083,
												-1.5
											]
										},
										{
											t: 127.130859375,
											s: [
												36.665,
												0
											]
										}
									],
									ix: 3
								}
							},
							{
								ty: 3,
								nm: "Right Top Vertex",
								mn: "ADBE BEZMESH-0004",
								ix: 4,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												55,
												0
											],
											to: [
												0,
												-6.833
											],
											ti: [
												-0.119,
												-1.311
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.025,
											s: [
												55,
												-9.02
											],
											to: [
												0.119,
												1.311
											],
											ti: [
												0.22,
												-1.32
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												55.715,
												7.865
											],
											to: [
												-0.22,
												1.32
											],
											ti: [
												0.339,
												1.494
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												53.68,
												-1.1
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												53.68,
												-1.1
											],
											to: [
												0.11,
												0.697
											],
											ti: [
												-0.22,
												-0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												54.34,
												3.08
											],
											to: [
												0.22,
												0.183
											],
											ti: [
												-0.11,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												55,
												0
											],
											to: [
												0.11,
												0.11
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												55,
												3.74
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												55,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 112.115,
											s: [
												54.56,
												1.65
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 117.121,
											s: [
												55,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 127.130859375,
											s: [
												55,
												0
											]
										}
									],
									ix: 4
								}
							},
							{
								ty: 3,
								nm: "Right Top Tangent",
								mn: "ADBE BEZMESH-0005",
								ix: 5,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												55,
												18.333
											],
											to: [
												-0.833,
												-2.667
											],
											ti: [
												-0.733,
												-0.559
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.025,
											s: [
												53.9,
												14.813
											],
											to: [
												0.733,
												0.559
											],
											ti: [
												-0.183,
												-0.587
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												59.4,
												21.688
											],
											to: [
												0.183,
												0.587
											],
											ti: [
												0.733,
												0.559
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												55,
												18.333
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												55,
												18.333
											],
											to: [
												0.037,
												0.293
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												55.22,
												20.093
											],
											to: [
												0,
												0
											],
											ti: [
												-0.312,
												-0.073
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												55,
												18.333
											],
											to: [
												0.312,
												0.073
											],
											ti: [
												0.037,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												57.09,
												20.533
											],
											to: [
												-0.037,
												0.11
											],
											ti: [
												0.11,
												0.275
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												54.78,
												18.993
											],
											to: [
												-0.11,
												-0.275
											],
											ti: [
												0.128,
												0.073
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 112.115,
											s: [
												56.43,
												18.883
											],
											to: [
												-0.128,
												-0.073
											],
											ti: [
												0.238,
												0.092
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 117.121,
											s: [
												54.01,
												18.553
											],
											to: [
												-0.238,
												-0.092
											],
											ti: [
												-0.75,
												0.167
											]
										},
										{
											t: 127.130859375,
											s: [
												55,
												18.333
											]
										}
									],
									ix: 5
								}
							},
							{
								ty: 3,
								nm: "Right Bottom Tangent",
								mn: "ADBE BEZMESH-0006",
								ix: 6,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												55,
												36.665
											],
											to: [
												-1.167,
												-0.5
											],
											ti: [
												-1.256,
												-0.578
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.025,
											s: [
												53.46,
												36.005
											],
											to: [
												1.256,
												0.578
											],
											ti: [
												-0.257,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												62.535,
												40.13
											],
											to: [
												0.257,
												0.11
											],
											ti: [
												1.256,
												0.578
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												55,
												36.665
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												55,
												36.665
											],
											to: [
												0.147,
												0.33
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												55.88,
												38.645
											],
											to: [
												0,
												0
											],
											ti: [
												-0.092,
												0.165
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												55,
												36.665
											],
											to: [
												0.092,
												-0.165
											],
											ti: [
												0.037,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												56.43,
												37.655
											],
											to: [
												-0.037,
												0
											],
											ti: [
												0.037,
												0.165
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												54.78,
												36.665
											],
											to: [
												-0.037,
												-0.165
											],
											ti: [
												0.147,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 112.115,
											s: [
												56.21,
												36.665
											],
											to: [
												-0.147,
												0
											],
											ti: [
												0.202,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 117.121,
											s: [
												53.9,
												36.665
											],
											to: [
												-0.202,
												0
											],
											ti: [
												-0.833,
												0
											]
										},
										{
											t: 127.130859375,
											s: [
												55,
												36.665
											]
										}
									],
									ix: 6
								}
							},
							{
								ty: 3,
								nm: "Bottom Right Vertex",
								mn: "ADBE BEZMESH-0007",
								ix: 7,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												55,
												55
											],
											to: [
												3.003,
												0
											],
											ti: [
												-6.425,
												-0.07
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.025,
											s: [
												57.072,
												54.887
											],
											to: [
												2.668,
												0.029
											],
											ti: [
												0.293,
												-0.342
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												59.29,
												54.78
											],
											to: [
												-1,
												1.167
											],
											ti: [
												0.935,
												-0.293
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												53.68,
												56.54
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												53.68,
												56.54
											],
											to: [
												0.22,
												-0.257
											],
											ti: [
												-0.22,
												0.257
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 117.121,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 127.130859375,
											s: [
												55,
												55
											]
										}
									],
									ix: 7
								}
							},
							{
								ty: 3,
								nm: "Bottom Right Tangent",
								mn: "ADBE BEZMESH-0008",
								ix: 8,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												36.665,
												55
											],
											to: [
												3.542,
												-0.167
											],
											ti: [
												0.11,
												-0.513
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												41.34,
												54.78
											],
											to: [
												-0.11,
												0.513
											],
											ti: [
												0.889,
												-0.55
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												36.005,
												58.08
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												36.005,
												58.08
											],
											to: [
												0.11,
												-0.513
											],
											ti: [
												-0.11,
												0.513
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												36.665,
												55
											],
											to: [
												-0.055,
												0.147
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												36.335,
												55.88
											],
											to: [
												0,
												0
											],
											ti: [
												-0.055,
												0.147
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 117.121,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 127.130859375,
											s: [
												36.665,
												55
											]
										}
									],
									ix: 8
								}
							},
							{
								ty: 3,
								nm: "Bottom Left Tangent",
								mn: "ADBE BEZMESH-0009",
								ix: 9,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												18.333,
												55
											],
											to: [
												-2.833,
												-0.042
											],
											ti: [
												-0.11,
												-0.403
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												14.593,
												54.945
											],
											to: [
												0.11,
												0.403
											],
											ti: [
												-0.733,
												-0.412
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												18.993,
												57.42
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												18.993,
												57.42
											],
											to: [
												-0.11,
												-0.403
											],
											ti: [
												0.11,
												0.403
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												18.333,
												55
											],
											to: [
												0.018,
												0.128
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												18.443,
												55.77
											],
											to: [
												0,
												0
											],
											ti: [
												0.018,
												0.128
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 117.121,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 127.130859375,
											s: [
												18.333,
												55
											]
										}
									],
									ix: 9
								}
							},
							{
								ty: 3,
								nm: "Left Bottom Vertex",
								mn: "ADBE BEZMESH-0010",
								ix: 10,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												0,
												55
											],
											to: [
												-2.279,
												0
											],
											ti: [
												5.003,
												-0.031
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.025,
											s: [
												-1.485,
												54.479
											],
											to: [
												-2.224,
												0.014
											],
											ti: [
												-0.564,
												-0.256
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												-2.805,
												55
											],
											to: [
												1.833,
												0.833
											],
											ti: [
												-0.871,
												-0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												2.42,
												56.1
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												2.42,
												56.1
											],
											to: [
												-0.403,
												-0.183
											],
											ti: [
												0.403,
												0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 117.121,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 127.130859375,
											s: [
												0,
												55
											]
										}
									],
									ix: 10
								}
							},
							{
								ty: 3,
								nm: "Left Bottom Tangent",
								mn: "ADBE BEZMESH-0011",
								ix: 11,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												0,
												36.665
											],
											to: [
												0.667,
												-2.5
											],
											ti: [
												0.99,
												-0.733
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.025,
											s: [
												0.88,
												33.365
											],
											to: [
												-0.99,
												0.733
											],
											ti: [
												0.293,
												-0.66
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												-5.94,
												41.065
											],
											to: [
												-0.293,
												0.66
											],
											ti: [
												-0.843,
												0.623
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												-0.88,
												37.325
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												-0.88,
												37.325
											],
											to: [
												-0.183,
												0.403
											],
											ti: [
												-0.147,
												0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												-1.98,
												39.745
											],
											to: [
												0.147,
												-0.11
											],
											ti: [
												0,
												0.367
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												0,
												36.665
											],
											to: [
												0,
												-0.367
											],
											ti: [
												-0.092,
												0.018
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												-1.98,
												37.545
											],
											to: [
												0.092,
												-0.018
											],
											ti: [
												-0.073,
												0.22
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												0.55,
												36.555
											],
											to: [
												0.073,
												-0.22
											],
											ti: [
												-0.092,
												-0.018
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 112.115,
											s: [
												-1.54,
												36.225
											],
											to: [
												0.092,
												0.018
											],
											ti: [
												-0.257,
												-0.073
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 117.121,
											s: [
												1.1,
												36.665
											],
											to: [
												0.257,
												0.073
											],
											ti: [
												0.833,
												0
											]
										},
										{
											t: 127.130859375,
											s: [
												0,
												36.665
											]
										}
									],
									ix: 11
								}
							},
							{
								ty: 3,
								nm: "Left Top Tangent",
								mn: "ADBE BEZMESH-0012",
								ix: 12,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 30,
											s: [
												0,
												18.333
											],
											to: [
												0.5,
												-2
											],
											ti: [
												1.027,
												-1.192
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.025,
											s: [
												0.66,
												15.693
											],
											to: [
												-1.027,
												1.192
											],
											ti: [
												0,
												-0.44
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.527,
											s: [
												-6.16,
												25.483
											],
											to: [
												0,
												0.44
											],
											ti: [
												-1.137,
												1.192
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.537,
											s: [
												0.66,
												18.333
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 85.055,
											s: [
												0.66,
												18.333
											],
											to: [
												-0.44,
												0.55
											],
											ti: [
												0.11,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.559,
											s: [
												-1.98,
												21.633
											],
											to: [
												-0.11,
												0
											],
											ti: [
												0.092,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 94.598,
											s: [
												0,
												18.333
											],
											to: [
												-0.092,
												0
											],
											ti: [
												-0.073,
												-0.037
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.105,
											s: [
												-2.53,
												21.633
											],
											to: [
												0.073,
												0.037
											],
											ti: [
												-0.22,
												0.385
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 107.111,
											s: [
												0.44,
												18.553
											],
											to: [
												0.22,
												-0.385
											],
											ti: [
												-0.11,
												0.037
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 112.115,
											s: [
												-1.21,
												19.323
											],
											to: [
												0.11,
												-0.037
											],
											ti: [
												-0.202,
												0.165
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 117.121,
											s: [
												1.1,
												18.333
											],
											to: [
												0.202,
												-0.165
											],
											ti: [
												0.833,
												0
											]
										},
										{
											t: 127.130859375,
											s: [
												0,
												18.333
											]
										}
									],
									ix: 12
								}
							},
							{
								ty: 0,
								nm: "Quality",
								mn: "ADBE BEZMESH-0014",
								ix: 13,
								v: {
									a: 0,
									k: 8,
									ix: 13
								}
							}
						]
					}
				],
				w: 55,
				h: 55,
				ip: 30,
				op: 3630,
				st: 30,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 0,
				nm: "Boll punkt",
				refId: "comp_1",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 43,
								s: [
									0
								]
							},
							{
								t: 44,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.724,
									y: 0.814
								},
								o: {
									x: 0.442,
									y: 0
								},
								t: 20,
								s: [
									1060,
									-1078.507,
									0
								],
								to: [
									0,
									279.333,
									0
								],
								ti: [
									0,
									-102,
									0
								]
							},
							{
								i: {
									x: 0.376,
									y: 1
								},
								o: {
									x: 0.001,
									y: 0
								},
								t: 47.527,
								s: [
									1060,
									597.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									-36.602,
									2.182,
									0
								]
							},
							{
								i: {
									x: 0.927,
									y: 0.865
								},
								o: {
									x: 0.516,
									y: 0
								},
								t: 62.598,
								s: [
									1120,
									442.493,
									0
								],
								to: [
									25.167,
									-1.5,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.667,
									y: 1
								},
								o: {
									x: 0.38,
									y: 0.581
								},
								t: 77.559,
								s: [
									1160,
									597.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									-13.083,
									0.5,
									0
								]
							},
							{
								i: {
									x: 0.966,
									y: 0.942
								},
								o: {
									x: 0.526,
									y: 0
								},
								t: 84.598,
								s: [
									1182,
									557.493,
									0
								],
								to: [
									6.583,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.001,
									y: 0.002
								},
								t: 92.105,
								s: [
									1199.5,
									597.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 0.5
								},
								o: {
									x: 0.5,
									y: 0.5
								},
								t: 152,
								s: [
									1331,
									598.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.22,
									y: 1
								},
								o: {
									x: 0.5,
									y: 0
								},
								t: 176,
								s: [
									1331,
									598.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.22,
									y: 1
								},
								o: {
									x: 0.78,
									y: 0
								},
								t: 185,
								s: [
									1382,
									598.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 216,
								s: [
									1331,
									598.493,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							27.007,
							27.007,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Squash & Stretch Bezier Warp",
						np: 15,
						mn: "ADBE BEZMESH",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 3,
								nm: "Top Left Vertex",
								mn: "ADBE BEZMESH-0001",
								ix: 1,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												0,
												0
											],
											to: [
												-0.333,
												-5.833
											],
											ti: [
												0.321,
												-1.384
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 45.025,
											s: [
												-0.44,
												-7.7
											],
											to: [
												-0.321,
												1.384
											],
											ti: [
												-0.33,
												-0.843
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												-1.925,
												8.305
											],
											to: [
												0.33,
												0.843
											],
											ti: [
												-0.577,
												1.824
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												1.54,
												-2.64
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												1.54,
												-2.64
											],
											to: [
												-0.44,
												1.247
											],
											ti: [
												0.257,
												-0.44
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												-1.1,
												4.84
											],
											to: [
												-0.257,
												0.44
											],
											ti: [
												-0.018,
												-0.018
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												0,
												0
											],
											to: [
												0.018,
												0.018
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												-0.99,
												4.95
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												0,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.115,
											s: [
												-0.33,
												1.54
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 107.121,
											s: [
												0,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 117.130859375,
											s: [
												0,
												0
											]
										}
									],
									ix: 1
								}
							},
							{
								ty: 3,
								nm: "Top Left Tangent",
								mn: "ADBE BEZMESH-0002",
								ix: 2,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												18.333,
												0
											],
											to: [
												-0.5,
												-5.667
											],
											ti: [
												0.403,
												-0.926
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 45.025,
											s: [
												17.673,
												-7.48
											],
											to: [
												-0.403,
												0.926
											],
											ti: [
												-0.183,
												-0.293
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												15.913,
												5.555
											],
											to: [
												0.183,
												0.293
											],
											ti: [
												-0.477,
												1.879
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												18.773,
												-5.72
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												18.773,
												-5.72
											],
											to: [
												-0.11,
												1.21
											],
											ti: [
												0.073,
												-0.953
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												18.113,
												1.54
											],
											to: [
												-0.073,
												0.953
											],
											ti: [
												-0.037,
												0.257
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												18.333,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												18.333,
												0
											],
											to: [
												-0.018,
												-0.293
											],
											ti: [
												-0.183,
												-0.458
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												18.223,
												-1.76
											],
											to: [
												0.183,
												0.458
											],
											ti: [
												-0.018,
												0.055
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.115,
											s: [
												19.433,
												2.75
											],
											to: [
												0.018,
												-0.055
											],
											ti: [
												0.183,
												0.458
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 107.121,
											s: [
												18.333,
												-2.09
											],
											to: [
												-0.183,
												-0.458
											],
											ti: [
												0,
												-1.583
											]
										},
										{
											t: 117.130859375,
											s: [
												18.333,
												0
											]
										}
									],
									ix: 2
								}
							},
							{
								ty: 3,
								nm: "Top Right Tangent",
								mn: "ADBE BEZMESH-0003",
								ix: 3,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												36.665,
												0
											],
											to: [
												-0.333,
												-4.833
											],
											ti: [
												-0.266,
												-0.77
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 45.025,
											s: [
												36.225,
												-6.38
											],
											to: [
												0.266,
												0.77
											],
											ti: [
												-0.367,
												-0.367
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												38.26,
												4.62
											],
											to: [
												0.367,
												0.367
											],
											ti: [
												-0.028,
												1.467
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												38.425,
												-4.18
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												38.425,
												-4.18
											],
											to: [
												-0.367,
												0.843
											],
											ti: [
												0.293,
												-0.697
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												36.225,
												0.88
											],
											to: [
												-0.293,
												0.697
											],
											ti: [
												-0.11,
												0.202
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												36.665,
												0
											],
											to: [
												0.11,
												-0.202
											],
											ti: [
												0,
												0.275
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												36.885,
												-0.33
											],
											to: [
												0,
												-0.275
											],
											ti: [
												0.183,
												-0.495
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												36.665,
												-1.65
											],
											to: [
												-0.183,
												0.495
											],
											ti: [
												-0.018,
												0.055
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.115,
											s: [
												35.785,
												2.64
											],
											to: [
												0.018,
												-0.055
											],
											ti: [
												-0.147,
												0.44
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 107.121,
											s: [
												36.775,
												-1.98
											],
											to: [
												0.147,
												-0.44
											],
											ti: [
												0.083,
												-1.5
											]
										},
										{
											t: 117.130859375,
											s: [
												36.665,
												0
											]
										}
									],
									ix: 3
								}
							},
							{
								ty: 3,
								nm: "Right Top Vertex",
								mn: "ADBE BEZMESH-0004",
								ix: 4,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												55,
												0
											],
											to: [
												0,
												-6.833
											],
											ti: [
												-0.119,
												-1.311
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 45.025,
											s: [
												55,
												-9.02
											],
											to: [
												0.119,
												1.311
											],
											ti: [
												0.22,
												-1.32
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												55.715,
												7.865
											],
											to: [
												-0.22,
												1.32
											],
											ti: [
												0.339,
												1.494
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												53.68,
												-1.1
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												53.68,
												-1.1
											],
											to: [
												0.11,
												0.697
											],
											ti: [
												-0.22,
												-0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												54.34,
												3.08
											],
											to: [
												0.22,
												0.183
											],
											ti: [
												-0.11,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												55,
												0
											],
											to: [
												0.11,
												0.11
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												55,
												3.74
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												55,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.115,
											s: [
												54.56,
												1.65
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 107.121,
											s: [
												55,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 117.130859375,
											s: [
												55,
												0
											]
										}
									],
									ix: 4
								}
							},
							{
								ty: 3,
								nm: "Right Top Tangent",
								mn: "ADBE BEZMESH-0005",
								ix: 5,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												55,
												18.333
											],
											to: [
												-0.833,
												-2.667
											],
											ti: [
												-0.733,
												-0.559
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 45.025,
											s: [
												53.9,
												14.813
											],
											to: [
												0.733,
												0.559
											],
											ti: [
												-0.183,
												-0.587
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												59.4,
												21.688
											],
											to: [
												0.183,
												0.587
											],
											ti: [
												0.733,
												0.559
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												55,
												18.333
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												55,
												18.333
											],
											to: [
												0.037,
												0.293
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												55.22,
												20.093
											],
											to: [
												0,
												0
											],
											ti: [
												-0.312,
												-0.073
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												55,
												18.333
											],
											to: [
												0.312,
												0.073
											],
											ti: [
												0.037,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												57.09,
												20.533
											],
											to: [
												-0.037,
												0.11
											],
											ti: [
												0.11,
												0.275
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												54.78,
												18.993
											],
											to: [
												-0.11,
												-0.275
											],
											ti: [
												0.128,
												0.073
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.115,
											s: [
												56.43,
												18.883
											],
											to: [
												-0.128,
												-0.073
											],
											ti: [
												0.238,
												0.092
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 107.121,
											s: [
												54.01,
												18.553
											],
											to: [
												-0.238,
												-0.092
											],
											ti: [
												-0.75,
												0.167
											]
										},
										{
											t: 117.130859375,
											s: [
												55,
												18.333
											]
										}
									],
									ix: 5
								}
							},
							{
								ty: 3,
								nm: "Right Bottom Tangent",
								mn: "ADBE BEZMESH-0006",
								ix: 6,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												55,
												36.665
											],
											to: [
												-1.167,
												-0.5
											],
											ti: [
												-1.256,
												-0.578
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 45.025,
											s: [
												53.46,
												36.005
											],
											to: [
												1.256,
												0.578
											],
											ti: [
												-0.257,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												62.535,
												40.13
											],
											to: [
												0.257,
												0.11
											],
											ti: [
												1.256,
												0.578
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												55,
												36.665
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												55,
												36.665
											],
											to: [
												0.147,
												0.33
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												55.88,
												38.645
											],
											to: [
												0,
												0
											],
											ti: [
												-0.092,
												0.165
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												55,
												36.665
											],
											to: [
												0.092,
												-0.165
											],
											ti: [
												0.037,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												56.43,
												37.655
											],
											to: [
												-0.037,
												0
											],
											ti: [
												0.037,
												0.165
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												54.78,
												36.665
											],
											to: [
												-0.037,
												-0.165
											],
											ti: [
												0.147,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.115,
											s: [
												56.21,
												36.665
											],
											to: [
												-0.147,
												0
											],
											ti: [
												0.202,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 107.121,
											s: [
												53.9,
												36.665
											],
											to: [
												-0.202,
												0
											],
											ti: [
												-0.833,
												0
											]
										},
										{
											t: 117.130859375,
											s: [
												55,
												36.665
											]
										}
									],
									ix: 6
								}
							},
							{
								ty: 3,
								nm: "Bottom Right Vertex",
								mn: "ADBE BEZMESH-0007",
								ix: 7,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												55,
												55
											],
											to: [
												3.003,
												0
											],
											ti: [
												-6.425,
												-0.07
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 45.025,
											s: [
												57.072,
												54.887
											],
											to: [
												2.668,
												0.029
											],
											ti: [
												0.293,
												-0.342
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												59.29,
												54.78
											],
											to: [
												-1,
												1.167
											],
											ti: [
												0.935,
												-0.293
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												53.68,
												56.54
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												53.68,
												56.54
											],
											to: [
												0.22,
												-0.257
											],
											ti: [
												-0.22,
												0.257
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 107.121,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 117.130859375,
											s: [
												55,
												55
											]
										}
									],
									ix: 7
								}
							},
							{
								ty: 3,
								nm: "Bottom Right Tangent",
								mn: "ADBE BEZMESH-0008",
								ix: 8,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												36.665,
												55
											],
											to: [
												3.542,
												-0.167
											],
											ti: [
												0.11,
												-0.513
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												41.34,
												54.78
											],
											to: [
												-0.11,
												0.513
											],
											ti: [
												0.889,
												-0.55
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												36.005,
												58.08
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												36.005,
												58.08
											],
											to: [
												0.11,
												-0.513
											],
											ti: [
												-0.11,
												0.513
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												36.665,
												55
											],
											to: [
												-0.055,
												0.147
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												36.335,
												55.88
											],
											to: [
												0,
												0
											],
											ti: [
												-0.055,
												0.147
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 107.121,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 117.130859375,
											s: [
												36.665,
												55
											]
										}
									],
									ix: 8
								}
							},
							{
								ty: 3,
								nm: "Bottom Left Tangent",
								mn: "ADBE BEZMESH-0009",
								ix: 9,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												18.333,
												55
											],
											to: [
												-2.833,
												-0.042
											],
											ti: [
												-0.11,
												-0.403
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												14.593,
												54.945
											],
											to: [
												0.11,
												0.403
											],
											ti: [
												-0.733,
												-0.412
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												18.993,
												57.42
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												18.993,
												57.42
											],
											to: [
												-0.11,
												-0.403
											],
											ti: [
												0.11,
												0.403
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												18.333,
												55
											],
											to: [
												0.018,
												0.128
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												18.443,
												55.77
											],
											to: [
												0,
												0
											],
											ti: [
												0.018,
												0.128
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 107.121,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 117.130859375,
											s: [
												18.333,
												55
											]
										}
									],
									ix: 9
								}
							},
							{
								ty: 3,
								nm: "Left Bottom Vertex",
								mn: "ADBE BEZMESH-0010",
								ix: 10,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												0,
												55
											],
											to: [
												-2.279,
												0
											],
											ti: [
												5.003,
												-0.031
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 45.025,
											s: [
												-1.485,
												54.479
											],
											to: [
												-2.224,
												0.014
											],
											ti: [
												-0.564,
												-0.256
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												-2.805,
												55
											],
											to: [
												1.833,
												0.833
											],
											ti: [
												-0.871,
												-0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												2.42,
												56.1
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												2.42,
												56.1
											],
											to: [
												-0.403,
												-0.183
											],
											ti: [
												0.403,
												0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 107.121,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 117.130859375,
											s: [
												0,
												55
											]
										}
									],
									ix: 10
								}
							},
							{
								ty: 3,
								nm: "Left Bottom Tangent",
								mn: "ADBE BEZMESH-0011",
								ix: 11,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												0,
												36.665
											],
											to: [
												0.667,
												-2.5
											],
											ti: [
												0.99,
												-0.733
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 45.025,
											s: [
												0.88,
												33.365
											],
											to: [
												-0.99,
												0.733
											],
											ti: [
												0.293,
												-0.66
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												-5.94,
												41.065
											],
											to: [
												-0.293,
												0.66
											],
											ti: [
												-0.843,
												0.623
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												-0.88,
												37.325
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												-0.88,
												37.325
											],
											to: [
												-0.183,
												0.403
											],
											ti: [
												-0.147,
												0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												-1.98,
												39.745
											],
											to: [
												0.147,
												-0.11
											],
											ti: [
												0,
												0.367
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												0,
												36.665
											],
											to: [
												0,
												-0.367
											],
											ti: [
												-0.092,
												0.018
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												-1.98,
												37.545
											],
											to: [
												0.092,
												-0.018
											],
											ti: [
												-0.073,
												0.22
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												0.55,
												36.555
											],
											to: [
												0.073,
												-0.22
											],
											ti: [
												-0.092,
												-0.018
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.115,
											s: [
												-1.54,
												36.225
											],
											to: [
												0.092,
												0.018
											],
											ti: [
												-0.257,
												-0.073
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 107.121,
											s: [
												1.1,
												36.665
											],
											to: [
												0.257,
												0.073
											],
											ti: [
												0.833,
												0
											]
										},
										{
											t: 117.130859375,
											s: [
												0,
												36.665
											]
										}
									],
									ix: 11
								}
							},
							{
								ty: 3,
								nm: "Left Top Tangent",
								mn: "ADBE BEZMESH-0012",
								ix: 12,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 20,
											s: [
												0,
												18.333
											],
											to: [
												0.5,
												-2
											],
											ti: [
												1.027,
												-1.192
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 45.025,
											s: [
												0.66,
												15.693
											],
											to: [
												-1.027,
												1.192
											],
											ti: [
												0,
												-0.44
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.527,
											s: [
												-6.16,
												25.483
											],
											to: [
												0,
												0.44
											],
											ti: [
												-1.137,
												1.192
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 57.537,
											s: [
												0.66,
												18.333
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 75.055,
											s: [
												0.66,
												18.333
											],
											to: [
												-0.44,
												0.55
											],
											ti: [
												0.11,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.559,
											s: [
												-1.98,
												21.633
											],
											to: [
												-0.11,
												0
											],
											ti: [
												0.092,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 84.598,
											s: [
												0,
												18.333
											],
											to: [
												-0.092,
												0
											],
											ti: [
												-0.073,
												-0.037
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.105,
											s: [
												-2.53,
												21.633
											],
											to: [
												0.073,
												0.037
											],
											ti: [
												-0.22,
												0.385
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 97.111,
											s: [
												0.44,
												18.553
											],
											to: [
												0.22,
												-0.385
											],
											ti: [
												-0.11,
												0.037
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 102.115,
											s: [
												-1.21,
												19.323
											],
											to: [
												0.11,
												-0.037
											],
											ti: [
												-0.202,
												0.165
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 107.121,
											s: [
												1.1,
												18.333
											],
											to: [
												0.202,
												-0.165
											],
											ti: [
												0.833,
												0
											]
										},
										{
											t: 117.130859375,
											s: [
												0,
												18.333
											]
										}
									],
									ix: 12
								}
							},
							{
								ty: 0,
								nm: "Quality",
								mn: "ADBE BEZMESH-0014",
								ix: 13,
								v: {
									a: 0,
									k: 8,
									ix: 13
								}
							}
						]
					}
				],
				w: 55,
				h: 55,
				ip: 20,
				op: 3620,
				st: 20,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 0,
				nm: "Boll D",
				refId: "comp_1",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 33,
								s: [
									0
								]
							},
							{
								t: 34,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.724,
									y: 0.814
								},
								o: {
									x: 0.442,
									y: 0
								},
								t: 10,
								s: [
									940,
									-1078.507,
									0
								],
								to: [
									0,
									279.333,
									0
								],
								ti: [
									0,
									-102,
									0
								]
							},
							{
								i: {
									x: 0.376,
									y: 1
								},
								o: {
									x: 0.001,
									y: 0
								},
								t: 37.527,
								s: [
									940,
									597.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									-36.602,
									2.182,
									0
								]
							},
							{
								i: {
									x: 0.927,
									y: 0.865
								},
								o: {
									x: 0.516,
									y: 0
								},
								t: 52.598,
								s: [
									1000,
									442.493,
									0
								],
								to: [
									25.167,
									-1.5,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.667,
									y: 1
								},
								o: {
									x: 0.38,
									y: 0.581
								},
								t: 67.559,
								s: [
									1040,
									597.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									-13.083,
									0.5,
									0
								]
							},
							{
								i: {
									x: 0.966,
									y: 0.942
								},
								o: {
									x: 0.526,
									y: 0
								},
								t: 74.598,
								s: [
									1062,
									557.493,
									0
								],
								to: [
									6.583,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.001,
									y: 0.003
								},
								t: 82.105,
								s: [
									1079.5,
									597.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 161,
								s: [
									1211,
									598.493,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							27.007,
							27.007,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Squash & Stretch Bezier Warp",
						np: 15,
						mn: "ADBE BEZMESH",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 3,
								nm: "Top Left Vertex",
								mn: "ADBE BEZMESH-0001",
								ix: 1,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												0,
												0
											],
											to: [
												-0.333,
												-5.833
											],
											ti: [
												0.321,
												-1.384
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 35.025,
											s: [
												-0.44,
												-7.7
											],
											to: [
												-0.321,
												1.384
											],
											ti: [
												-0.33,
												-0.843
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												-1.925,
												8.305
											],
											to: [
												0.33,
												0.843
											],
											ti: [
												-0.577,
												1.824
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												1.54,
												-2.64
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												1.54,
												-2.64
											],
											to: [
												-0.44,
												1.247
											],
											ti: [
												0.257,
												-0.44
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												-1.1,
												4.84
											],
											to: [
												-0.257,
												0.44
											],
											ti: [
												-0.018,
												-0.018
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												0,
												0
											],
											to: [
												0.018,
												0.018
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												-0.99,
												4.95
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												0,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.115,
											s: [
												-0.33,
												1.54
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 97.121,
											s: [
												0,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 107.130859375,
											s: [
												0,
												0
											]
										}
									],
									ix: 1
								}
							},
							{
								ty: 3,
								nm: "Top Left Tangent",
								mn: "ADBE BEZMESH-0002",
								ix: 2,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												18.333,
												0
											],
											to: [
												-0.5,
												-5.667
											],
											ti: [
												0.403,
												-0.926
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 35.025,
											s: [
												17.673,
												-7.48
											],
											to: [
												-0.403,
												0.926
											],
											ti: [
												-0.183,
												-0.293
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												15.913,
												5.555
											],
											to: [
												0.183,
												0.293
											],
											ti: [
												-0.477,
												1.879
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												18.773,
												-5.72
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												18.773,
												-5.72
											],
											to: [
												-0.11,
												1.21
											],
											ti: [
												0.073,
												-0.953
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												18.113,
												1.54
											],
											to: [
												-0.073,
												0.953
											],
											ti: [
												-0.037,
												0.257
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												18.333,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												18.333,
												0
											],
											to: [
												-0.018,
												-0.293
											],
											ti: [
												-0.183,
												-0.458
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												18.223,
												-1.76
											],
											to: [
												0.183,
												0.458
											],
											ti: [
												-0.018,
												0.055
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.115,
											s: [
												19.433,
												2.75
											],
											to: [
												0.018,
												-0.055
											],
											ti: [
												0.183,
												0.458
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 97.121,
											s: [
												18.333,
												-2.09
											],
											to: [
												-0.183,
												-0.458
											],
											ti: [
												0,
												-1.583
											]
										},
										{
											t: 107.130859375,
											s: [
												18.333,
												0
											]
										}
									],
									ix: 2
								}
							},
							{
								ty: 3,
								nm: "Top Right Tangent",
								mn: "ADBE BEZMESH-0003",
								ix: 3,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												36.665,
												0
											],
											to: [
												-0.333,
												-4.833
											],
											ti: [
												-0.266,
												-0.77
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 35.025,
											s: [
												36.225,
												-6.38
											],
											to: [
												0.266,
												0.77
											],
											ti: [
												-0.367,
												-0.367
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												38.26,
												4.62
											],
											to: [
												0.367,
												0.367
											],
											ti: [
												-0.028,
												1.467
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												38.425,
												-4.18
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												38.425,
												-4.18
											],
											to: [
												-0.367,
												0.843
											],
											ti: [
												0.293,
												-0.697
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												36.225,
												0.88
											],
											to: [
												-0.293,
												0.697
											],
											ti: [
												-0.11,
												0.202
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												36.665,
												0
											],
											to: [
												0.11,
												-0.202
											],
											ti: [
												0,
												0.275
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												36.885,
												-0.33
											],
											to: [
												0,
												-0.275
											],
											ti: [
												0.183,
												-0.495
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												36.665,
												-1.65
											],
											to: [
												-0.183,
												0.495
											],
											ti: [
												-0.018,
												0.055
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.115,
											s: [
												35.785,
												2.64
											],
											to: [
												0.018,
												-0.055
											],
											ti: [
												-0.147,
												0.44
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 97.121,
											s: [
												36.775,
												-1.98
											],
											to: [
												0.147,
												-0.44
											],
											ti: [
												0.083,
												-1.5
											]
										},
										{
											t: 107.130859375,
											s: [
												36.665,
												0
											]
										}
									],
									ix: 3
								}
							},
							{
								ty: 3,
								nm: "Right Top Vertex",
								mn: "ADBE BEZMESH-0004",
								ix: 4,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												55,
												0
											],
											to: [
												0,
												-6.833
											],
											ti: [
												-0.119,
												-1.311
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 35.025,
											s: [
												55,
												-9.02
											],
											to: [
												0.119,
												1.311
											],
											ti: [
												0.22,
												-1.32
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												55.715,
												7.865
											],
											to: [
												-0.22,
												1.32
											],
											ti: [
												0.339,
												1.494
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												53.68,
												-1.1
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												53.68,
												-1.1
											],
											to: [
												0.11,
												0.697
											],
											ti: [
												-0.22,
												-0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												54.34,
												3.08
											],
											to: [
												0.22,
												0.183
											],
											ti: [
												-0.11,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												55,
												0
											],
											to: [
												0.11,
												0.11
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												55,
												3.74
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												55,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.115,
											s: [
												54.56,
												1.65
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 97.121,
											s: [
												55,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 107.130859375,
											s: [
												55,
												0
											]
										}
									],
									ix: 4
								}
							},
							{
								ty: 3,
								nm: "Right Top Tangent",
								mn: "ADBE BEZMESH-0005",
								ix: 5,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												55,
												18.333
											],
											to: [
												-0.833,
												-2.667
											],
											ti: [
												-0.733,
												-0.559
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 35.025,
											s: [
												53.9,
												14.813
											],
											to: [
												0.733,
												0.559
											],
											ti: [
												-0.183,
												-0.587
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												59.4,
												21.688
											],
											to: [
												0.183,
												0.587
											],
											ti: [
												0.733,
												0.559
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												55,
												18.333
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												55,
												18.333
											],
											to: [
												0.037,
												0.293
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												55.22,
												20.093
											],
											to: [
												0,
												0
											],
											ti: [
												-0.312,
												-0.073
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												55,
												18.333
											],
											to: [
												0.312,
												0.073
											],
											ti: [
												0.037,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												57.09,
												20.533
											],
											to: [
												-0.037,
												0.11
											],
											ti: [
												0.11,
												0.275
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												54.78,
												18.993
											],
											to: [
												-0.11,
												-0.275
											],
											ti: [
												0.128,
												0.073
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.115,
											s: [
												56.43,
												18.883
											],
											to: [
												-0.128,
												-0.073
											],
											ti: [
												0.238,
												0.092
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 97.121,
											s: [
												54.01,
												18.553
											],
											to: [
												-0.238,
												-0.092
											],
											ti: [
												-0.75,
												0.167
											]
										},
										{
											t: 107.130859375,
											s: [
												55,
												18.333
											]
										}
									],
									ix: 5
								}
							},
							{
								ty: 3,
								nm: "Right Bottom Tangent",
								mn: "ADBE BEZMESH-0006",
								ix: 6,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												55,
												36.665
											],
											to: [
												-1.167,
												-0.5
											],
											ti: [
												-1.256,
												-0.578
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 35.025,
											s: [
												53.46,
												36.005
											],
											to: [
												1.256,
												0.578
											],
											ti: [
												-0.257,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												62.535,
												40.13
											],
											to: [
												0.257,
												0.11
											],
											ti: [
												1.256,
												0.578
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												55,
												36.665
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												55,
												36.665
											],
											to: [
												0.147,
												0.33
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												55.88,
												38.645
											],
											to: [
												0,
												0
											],
											ti: [
												-0.092,
												0.165
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												55,
												36.665
											],
											to: [
												0.092,
												-0.165
											],
											ti: [
												0.037,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												56.43,
												37.655
											],
											to: [
												-0.037,
												0
											],
											ti: [
												0.037,
												0.165
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												54.78,
												36.665
											],
											to: [
												-0.037,
												-0.165
											],
											ti: [
												0.147,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.115,
											s: [
												56.21,
												36.665
											],
											to: [
												-0.147,
												0
											],
											ti: [
												0.202,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 97.121,
											s: [
												53.9,
												36.665
											],
											to: [
												-0.202,
												0
											],
											ti: [
												-0.833,
												0
											]
										},
										{
											t: 107.130859375,
											s: [
												55,
												36.665
											]
										}
									],
									ix: 6
								}
							},
							{
								ty: 3,
								nm: "Bottom Right Vertex",
								mn: "ADBE BEZMESH-0007",
								ix: 7,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												55,
												55
											],
											to: [
												3.003,
												0
											],
											ti: [
												-6.425,
												-0.07
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 35.025,
											s: [
												57.072,
												54.887
											],
											to: [
												2.668,
												0.029
											],
											ti: [
												0.293,
												-0.342
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												59.29,
												54.78
											],
											to: [
												-1,
												1.167
											],
											ti: [
												0.935,
												-0.293
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												53.68,
												56.54
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												53.68,
												56.54
											],
											to: [
												0.22,
												-0.257
											],
											ti: [
												-0.22,
												0.257
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 97.121,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 107.130859375,
											s: [
												55,
												55
											]
										}
									],
									ix: 7
								}
							},
							{
								ty: 3,
								nm: "Bottom Right Tangent",
								mn: "ADBE BEZMESH-0008",
								ix: 8,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												36.665,
												55
											],
											to: [
												3.542,
												-0.167
											],
											ti: [
												0.11,
												-0.513
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												41.34,
												54.78
											],
											to: [
												-0.11,
												0.513
											],
											ti: [
												0.889,
												-0.55
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												36.005,
												58.08
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												36.005,
												58.08
											],
											to: [
												0.11,
												-0.513
											],
											ti: [
												-0.11,
												0.513
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												36.665,
												55
											],
											to: [
												-0.055,
												0.147
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												36.335,
												55.88
											],
											to: [
												0,
												0
											],
											ti: [
												-0.055,
												0.147
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 97.121,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 107.130859375,
											s: [
												36.665,
												55
											]
										}
									],
									ix: 8
								}
							},
							{
								ty: 3,
								nm: "Bottom Left Tangent",
								mn: "ADBE BEZMESH-0009",
								ix: 9,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												18.333,
												55
											],
											to: [
												-2.833,
												-0.042
											],
											ti: [
												-0.11,
												-0.403
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												14.593,
												54.945
											],
											to: [
												0.11,
												0.403
											],
											ti: [
												-0.733,
												-0.412
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												18.993,
												57.42
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												18.993,
												57.42
											],
											to: [
												-0.11,
												-0.403
											],
											ti: [
												0.11,
												0.403
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												18.333,
												55
											],
											to: [
												0.018,
												0.128
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												18.443,
												55.77
											],
											to: [
												0,
												0
											],
											ti: [
												0.018,
												0.128
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 97.121,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 107.130859375,
											s: [
												18.333,
												55
											]
										}
									],
									ix: 9
								}
							},
							{
								ty: 3,
								nm: "Left Bottom Vertex",
								mn: "ADBE BEZMESH-0010",
								ix: 10,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												0,
												55
											],
											to: [
												-2.279,
												0
											],
											ti: [
												5.003,
												-0.031
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 35.025,
											s: [
												-1.485,
												54.479
											],
											to: [
												-2.224,
												0.014
											],
											ti: [
												-0.564,
												-0.256
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												-2.805,
												55
											],
											to: [
												1.833,
												0.833
											],
											ti: [
												-0.871,
												-0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												2.42,
												56.1
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												2.42,
												56.1
											],
											to: [
												-0.403,
												-0.183
											],
											ti: [
												0.403,
												0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 97.121,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 107.130859375,
											s: [
												0,
												55
											]
										}
									],
									ix: 10
								}
							},
							{
								ty: 3,
								nm: "Left Bottom Tangent",
								mn: "ADBE BEZMESH-0011",
								ix: 11,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												0,
												36.665
											],
											to: [
												0.667,
												-2.5
											],
											ti: [
												0.99,
												-0.733
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 35.025,
											s: [
												0.88,
												33.365
											],
											to: [
												-0.99,
												0.733
											],
											ti: [
												0.293,
												-0.66
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												-5.94,
												41.065
											],
											to: [
												-0.293,
												0.66
											],
											ti: [
												-0.843,
												0.623
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												-0.88,
												37.325
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												-0.88,
												37.325
											],
											to: [
												-0.183,
												0.403
											],
											ti: [
												-0.147,
												0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												-1.98,
												39.745
											],
											to: [
												0.147,
												-0.11
											],
											ti: [
												0,
												0.367
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												0,
												36.665
											],
											to: [
												0,
												-0.367
											],
											ti: [
												-0.092,
												0.018
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												-1.98,
												37.545
											],
											to: [
												0.092,
												-0.018
											],
											ti: [
												-0.073,
												0.22
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												0.55,
												36.555
											],
											to: [
												0.073,
												-0.22
											],
											ti: [
												-0.092,
												-0.018
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.115,
											s: [
												-1.54,
												36.225
											],
											to: [
												0.092,
												0.018
											],
											ti: [
												-0.257,
												-0.073
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 97.121,
											s: [
												1.1,
												36.665
											],
											to: [
												0.257,
												0.073
											],
											ti: [
												0.833,
												0
											]
										},
										{
											t: 107.130859375,
											s: [
												0,
												36.665
											]
										}
									],
									ix: 11
								}
							},
							{
								ty: 3,
								nm: "Left Top Tangent",
								mn: "ADBE BEZMESH-0012",
								ix: 12,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 10,
											s: [
												0,
												18.333
											],
											to: [
												0.5,
												-2
											],
											ti: [
												1.027,
												-1.192
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 35.025,
											s: [
												0.66,
												15.693
											],
											to: [
												-1.027,
												1.192
											],
											ti: [
												0,
												-0.44
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 37.527,
											s: [
												-6.16,
												25.483
											],
											to: [
												0,
												0.44
											],
											ti: [
												-1.137,
												1.192
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 47.537,
											s: [
												0.66,
												18.333
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.055,
											s: [
												0.66,
												18.333
											],
											to: [
												-0.44,
												0.55
											],
											ti: [
												0.11,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 67.559,
											s: [
												-1.98,
												21.633
											],
											to: [
												-0.11,
												0
											],
											ti: [
												0.092,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 74.598,
											s: [
												0,
												18.333
											],
											to: [
												-0.092,
												0
											],
											ti: [
												-0.073,
												-0.037
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.105,
											s: [
												-2.53,
												21.633
											],
											to: [
												0.073,
												0.037
											],
											ti: [
												-0.22,
												0.385
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 87.111,
											s: [
												0.44,
												18.553
											],
											to: [
												0.22,
												-0.385
											],
											ti: [
												-0.11,
												0.037
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 92.115,
											s: [
												-1.21,
												19.323
											],
											to: [
												0.11,
												-0.037
											],
											ti: [
												-0.202,
												0.165
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 97.121,
											s: [
												1.1,
												18.333
											],
											to: [
												0.202,
												-0.165
											],
											ti: [
												0.833,
												0
											]
										},
										{
											t: 107.130859375,
											s: [
												0,
												18.333
											]
										}
									],
									ix: 12
								}
							},
							{
								ty: 0,
								nm: "Quality",
								mn: "ADBE BEZMESH-0014",
								ix: 13,
								v: {
									a: 0,
									k: 8,
									ix: 13
								}
							}
						]
					}
				],
				w: 55,
				h: 55,
				ip: 10,
				op: 173,
				st: 10,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 0,
				nm: "Boll A",
				refId: "comp_1",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 23,
								s: [
									0
								]
							},
							{
								t: 24,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.724,
									y: 0.811
								},
								o: {
									x: 0.442,
									y: 0
								},
								t: 0,
								s: [
									860,
									-1078.507,
									0
								],
								to: [
									0,
									279.333,
									0
								],
								ti: [
									0,
									-102,
									0
								]
							},
							{
								i: {
									x: 0.376,
									y: 1
								},
								o: {
									x: 0.001,
									y: 0
								},
								t: 28,
								s: [
									860,
									597.493,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									36.647,
									-1.199,
									0
								]
							},
							{
								i: {
									x: 0.735,
									y: 0.481
								},
								o: {
									x: 0.387,
									y: 0
								},
								t: 43.07,
								s: [
									809,
									442.493,
									0
								],
								to: [
									-19.6,
									0.641,
									0
								],
								ti: [
									5.514,
									-32.138,
									0
								]
							},
							{
								i: {
									x: 0.891,
									y: 0.881
								},
								o: {
									x: 0.529,
									y: 0.424
								},
								t: 53,
								s: [
									773.46,
									503.53,
									0
								],
								to: [
									-7.38,
									43.014,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.667,
									y: 1
								},
								o: {
									x: 0.38,
									y: 0.521
								},
								t: 58.031,
								s: [
									767.5,
									596.507,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									19.917,
									0.5,
									0
								]
							},
							{
								i: {
									x: 0.966,
									y: 0.952
								},
								o: {
									x: 0.526,
									y: 0
								},
								t: 65.07,
								s: [
									739,
									555.507,
									0
								],
								to: [
									-13.417,
									-0.5,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.5,
									y: 1
								},
								o: {
									x: 0.001,
									y: 0.006
								},
								t: 72.578,
								s: [
									707,
									596.507,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 135,
								s: [
									658.25,
									596.507,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							27.007,
							27.007,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Squash & Stretch Bezier Warp",
						np: 15,
						mn: "ADBE BEZMESH",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 3,
								nm: "Top Left Vertex",
								mn: "ADBE BEZMESH-0001",
								ix: 1,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												0,
												0
											],
											to: [
												-0.333,
												-5.833
											],
											ti: [
												0.321,
												-1.384
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 25.498,
											s: [
												-0.44,
												-7.7
											],
											to: [
												-0.321,
												1.384
											],
											ti: [
												-0.33,
												-0.843
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												-1.925,
												8.305
											],
											to: [
												0.33,
												0.843
											],
											ti: [
												-0.577,
												1.824
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												1.54,
												-2.64
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												1.54,
												-2.64
											],
											to: [
												-0.44,
												1.247
											],
											ti: [
												0.257,
												-0.44
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												-1.1,
												4.84
											],
											to: [
												-0.257,
												0.44
											],
											ti: [
												-0.018,
												-0.018
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												0,
												0
											],
											to: [
												0.018,
												0.018
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												-0.99,
												4.95
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												0,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.588,
											s: [
												-0.33,
												1.54
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 87.594,
											s: [
												0,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 97.603515625,
											s: [
												0,
												0
											]
										}
									],
									ix: 1
								}
							},
							{
								ty: 3,
								nm: "Top Left Tangent",
								mn: "ADBE BEZMESH-0002",
								ix: 2,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												18.333,
												0
											],
											to: [
												-0.5,
												-5.667
											],
											ti: [
												0.403,
												-0.926
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 25.498,
											s: [
												17.673,
												-7.48
											],
											to: [
												-0.403,
												0.926
											],
											ti: [
												-0.183,
												-0.293
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												15.913,
												5.555
											],
											to: [
												0.183,
												0.293
											],
											ti: [
												-0.477,
												1.879
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												18.773,
												-5.72
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												18.773,
												-5.72
											],
											to: [
												-0.11,
												1.21
											],
											ti: [
												0.073,
												-0.953
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												18.113,
												1.54
											],
											to: [
												-0.073,
												0.953
											],
											ti: [
												-0.037,
												0.257
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												18.333,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												18.333,
												0
											],
											to: [
												-0.018,
												-0.293
											],
											ti: [
												-0.183,
												-0.458
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												18.223,
												-1.76
											],
											to: [
												0.183,
												0.458
											],
											ti: [
												-0.018,
												0.055
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.588,
											s: [
												19.433,
												2.75
											],
											to: [
												0.018,
												-0.055
											],
											ti: [
												0.183,
												0.458
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 87.594,
											s: [
												18.333,
												-2.09
											],
											to: [
												-0.183,
												-0.458
											],
											ti: [
												0,
												-1.583
											]
										},
										{
											t: 97.603515625,
											s: [
												18.333,
												0
											]
										}
									],
									ix: 2
								}
							},
							{
								ty: 3,
								nm: "Top Right Tangent",
								mn: "ADBE BEZMESH-0003",
								ix: 3,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												36.665,
												0
											],
											to: [
												-0.333,
												-4.833
											],
											ti: [
												-0.266,
												-0.77
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 25.498,
											s: [
												36.225,
												-6.38
											],
											to: [
												0.266,
												0.77
											],
											ti: [
												-0.367,
												-0.367
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												38.26,
												4.62
											],
											to: [
												0.367,
												0.367
											],
											ti: [
												-0.028,
												1.467
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												38.425,
												-4.18
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												38.425,
												-4.18
											],
											to: [
												-0.367,
												0.843
											],
											ti: [
												0.293,
												-0.697
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												36.225,
												0.88
											],
											to: [
												-0.293,
												0.697
											],
											ti: [
												-0.11,
												0.202
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												36.665,
												0
											],
											to: [
												0.11,
												-0.202
											],
											ti: [
												0,
												0.275
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												36.885,
												-0.33
											],
											to: [
												0,
												-0.275
											],
											ti: [
												0.183,
												-0.495
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												36.665,
												-1.65
											],
											to: [
												-0.183,
												0.495
											],
											ti: [
												-0.018,
												0.055
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.588,
											s: [
												35.785,
												2.64
											],
											to: [
												0.018,
												-0.055
											],
											ti: [
												-0.147,
												0.44
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 87.594,
											s: [
												36.775,
												-1.98
											],
											to: [
												0.147,
												-0.44
											],
											ti: [
												0.083,
												-1.5
											]
										},
										{
											t: 97.603515625,
											s: [
												36.665,
												0
											]
										}
									],
									ix: 3
								}
							},
							{
								ty: 3,
								nm: "Right Top Vertex",
								mn: "ADBE BEZMESH-0004",
								ix: 4,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												55,
												0
											],
											to: [
												0,
												-6.833
											],
											ti: [
												-0.119,
												-1.311
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 25.498,
											s: [
												55,
												-9.02
											],
											to: [
												0.119,
												1.311
											],
											ti: [
												0.22,
												-1.32
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												55.715,
												7.865
											],
											to: [
												-0.22,
												1.32
											],
											ti: [
												0.339,
												1.494
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												53.68,
												-1.1
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												53.68,
												-1.1
											],
											to: [
												0.11,
												0.697
											],
											ti: [
												-0.22,
												-0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												54.34,
												3.08
											],
											to: [
												0.22,
												0.183
											],
											ti: [
												-0.11,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												55,
												0
											],
											to: [
												0.11,
												0.11
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												55,
												3.74
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												55,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.588,
											s: [
												54.56,
												1.65
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 87.594,
											s: [
												55,
												0
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 97.603515625,
											s: [
												55,
												0
											]
										}
									],
									ix: 4
								}
							},
							{
								ty: 3,
								nm: "Right Top Tangent",
								mn: "ADBE BEZMESH-0005",
								ix: 5,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												55,
												18.333
											],
											to: [
												-0.833,
												-2.667
											],
											ti: [
												-0.733,
												-0.559
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 25.498,
											s: [
												53.9,
												14.813
											],
											to: [
												0.733,
												0.559
											],
											ti: [
												-0.183,
												-0.587
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												59.4,
												21.688
											],
											to: [
												0.183,
												0.587
											],
											ti: [
												0.733,
												0.559
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												55,
												18.333
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												55,
												18.333
											],
											to: [
												0.037,
												0.293
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												55.22,
												20.093
											],
											to: [
												0,
												0
											],
											ti: [
												-0.312,
												-0.073
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												55,
												18.333
											],
											to: [
												0.312,
												0.073
											],
											ti: [
												0.037,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												57.09,
												20.533
											],
											to: [
												-0.037,
												0.11
											],
											ti: [
												0.11,
												0.275
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												54.78,
												18.993
											],
											to: [
												-0.11,
												-0.275
											],
											ti: [
												0.128,
												0.073
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.588,
											s: [
												56.43,
												18.883
											],
											to: [
												-0.128,
												-0.073
											],
											ti: [
												0.238,
												0.092
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 87.594,
											s: [
												54.01,
												18.553
											],
											to: [
												-0.238,
												-0.092
											],
											ti: [
												-0.75,
												0.167
											]
										},
										{
											t: 97.603515625,
											s: [
												55,
												18.333
											]
										}
									],
									ix: 5
								}
							},
							{
								ty: 3,
								nm: "Right Bottom Tangent",
								mn: "ADBE BEZMESH-0006",
								ix: 6,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												55,
												36.665
											],
											to: [
												-1.167,
												-0.5
											],
											ti: [
												-1.256,
												-0.578
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 25.498,
											s: [
												53.46,
												36.005
											],
											to: [
												1.256,
												0.578
											],
											ti: [
												-0.257,
												-0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												62.535,
												40.13
											],
											to: [
												0.257,
												0.11
											],
											ti: [
												1.256,
												0.578
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												55,
												36.665
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												55,
												36.665
											],
											to: [
												0.147,
												0.33
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												55.88,
												38.645
											],
											to: [
												0,
												0
											],
											ti: [
												-0.092,
												0.165
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												55,
												36.665
											],
											to: [
												0.092,
												-0.165
											],
											ti: [
												0.037,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												56.43,
												37.655
											],
											to: [
												-0.037,
												0
											],
											ti: [
												0.037,
												0.165
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												54.78,
												36.665
											],
											to: [
												-0.037,
												-0.165
											],
											ti: [
												0.147,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.588,
											s: [
												56.21,
												36.665
											],
											to: [
												-0.147,
												0
											],
											ti: [
												0.202,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 87.594,
											s: [
												53.9,
												36.665
											],
											to: [
												-0.202,
												0
											],
											ti: [
												-0.833,
												0
											]
										},
										{
											t: 97.603515625,
											s: [
												55,
												36.665
											]
										}
									],
									ix: 6
								}
							},
							{
								ty: 3,
								nm: "Bottom Right Vertex",
								mn: "ADBE BEZMESH-0007",
								ix: 7,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												55,
												55
											],
											to: [
												3.003,
												0
											],
											ti: [
												-6.425,
												-0.07
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 25.498,
											s: [
												57.072,
												54.887
											],
											to: [
												2.668,
												0.029
											],
											ti: [
												0.293,
												-0.342
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												59.29,
												54.78
											],
											to: [
												-1,
												1.167
											],
											ti: [
												0.935,
												-0.293
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												53.68,
												56.54
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												53.68,
												56.54
											],
											to: [
												0.22,
												-0.257
											],
											ti: [
												-0.22,
												0.257
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 87.594,
											s: [
												55,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 97.603515625,
											s: [
												55,
												55
											]
										}
									],
									ix: 7
								}
							},
							{
								ty: 3,
								nm: "Bottom Right Tangent",
								mn: "ADBE BEZMESH-0008",
								ix: 8,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												36.665,
												55
											],
											to: [
												3.542,
												-0.167
											],
											ti: [
												0.11,
												-0.513
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												41.34,
												54.78
											],
											to: [
												-0.11,
												0.513
											],
											ti: [
												0.889,
												-0.55
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												36.005,
												58.08
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												36.005,
												58.08
											],
											to: [
												0.11,
												-0.513
											],
											ti: [
												-0.11,
												0.513
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												36.665,
												55
											],
											to: [
												-0.055,
												0.147
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												36.335,
												55.88
											],
											to: [
												0,
												0
											],
											ti: [
												-0.055,
												0.147
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 87.594,
											s: [
												36.665,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 97.603515625,
											s: [
												36.665,
												55
											]
										}
									],
									ix: 8
								}
							},
							{
								ty: 3,
								nm: "Bottom Left Tangent",
								mn: "ADBE BEZMESH-0009",
								ix: 9,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												18.333,
												55
											],
											to: [
												-2.833,
												-0.042
											],
											ti: [
												-0.11,
												-0.403
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												14.593,
												54.945
											],
											to: [
												0.11,
												0.403
											],
											ti: [
												-0.733,
												-0.412
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												18.993,
												57.42
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												18.993,
												57.42
											],
											to: [
												-0.11,
												-0.403
											],
											ti: [
												0.11,
												0.403
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												18.333,
												55
											],
											to: [
												0.018,
												0.128
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												18.443,
												55.77
											],
											to: [
												0,
												0
											],
											ti: [
												0.018,
												0.128
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 87.594,
											s: [
												18.333,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 97.603515625,
											s: [
												18.333,
												55
											]
										}
									],
									ix: 9
								}
							},
							{
								ty: 3,
								nm: "Left Bottom Vertex",
								mn: "ADBE BEZMESH-0010",
								ix: 10,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												0,
												55
											],
											to: [
												-2.279,
												0
											],
											ti: [
												5.003,
												-0.031
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 25.498,
											s: [
												-1.485,
												54.479
											],
											to: [
												-2.224,
												0.014
											],
											ti: [
												-0.564,
												-0.256
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												-2.805,
												55
											],
											to: [
												1.833,
												0.833
											],
											ti: [
												-0.871,
												-0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												2.42,
												56.1
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												2.42,
												56.1
											],
											to: [
												-0.403,
												-0.183
											],
											ti: [
												0.403,
												0.183
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.667,
												y: 0.667
											},
											o: {
												x: 0.333,
												y: 0.333
											},
											t: 87.594,
											s: [
												0,
												55
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											t: 97.603515625,
											s: [
												0,
												55
											]
										}
									],
									ix: 10
								}
							},
							{
								ty: 3,
								nm: "Left Bottom Tangent",
								mn: "ADBE BEZMESH-0011",
								ix: 11,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												0,
												36.665
											],
											to: [
												0.667,
												-2.5
											],
											ti: [
												0.99,
												-0.733
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 25.498,
											s: [
												0.88,
												33.365
											],
											to: [
												-0.99,
												0.733
											],
											ti: [
												0.293,
												-0.66
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												-5.94,
												41.065
											],
											to: [
												-0.293,
												0.66
											],
											ti: [
												-0.843,
												0.623
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												-0.88,
												37.325
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												-0.88,
												37.325
											],
											to: [
												-0.183,
												0.403
											],
											ti: [
												-0.147,
												0.11
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												-1.98,
												39.745
											],
											to: [
												0.147,
												-0.11
											],
											ti: [
												0,
												0.367
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												0,
												36.665
											],
											to: [
												0,
												-0.367
											],
											ti: [
												-0.092,
												0.018
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												-1.98,
												37.545
											],
											to: [
												0.092,
												-0.018
											],
											ti: [
												-0.073,
												0.22
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												0.55,
												36.555
											],
											to: [
												0.073,
												-0.22
											],
											ti: [
												-0.092,
												-0.018
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.588,
											s: [
												-1.54,
												36.225
											],
											to: [
												0.092,
												0.018
											],
											ti: [
												-0.257,
												-0.073
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 87.594,
											s: [
												1.1,
												36.665
											],
											to: [
												0.257,
												0.073
											],
											ti: [
												0.833,
												0
											]
										},
										{
											t: 97.603515625,
											s: [
												0,
												36.665
											]
										}
									],
									ix: 11
								}
							},
							{
								ty: 3,
								nm: "Left Top Tangent",
								mn: "ADBE BEZMESH-0012",
								ix: 12,
								v: {
									a: 1,
									k: [
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 0,
											s: [
												0,
												18.333
											],
											to: [
												0.5,
												-2
											],
											ti: [
												1.027,
												-1.192
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 25.498,
											s: [
												0.66,
												15.693
											],
											to: [
												-1.027,
												1.192
											],
											ti: [
												0,
												-0.44
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 28,
											s: [
												-6.16,
												25.483
											],
											to: [
												0,
												0.44
											],
											ti: [
												-1.137,
												1.192
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 38.01,
											s: [
												0.66,
												18.333
											],
											to: [
												0,
												0
											],
											ti: [
												0,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 55.527,
											s: [
												0.66,
												18.333
											],
											to: [
												-0.44,
												0.55
											],
											ti: [
												0.11,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 58.031,
											s: [
												-1.98,
												21.633
											],
											to: [
												-0.11,
												0
											],
											ti: [
												0.092,
												0
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 65.07,
											s: [
												0,
												18.333
											],
											to: [
												-0.092,
												0
											],
											ti: [
												-0.073,
												-0.037
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 72.578,
											s: [
												-2.53,
												21.633
											],
											to: [
												0.073,
												0.037
											],
											ti: [
												-0.22,
												0.385
											]
										},
										{
											i: {
												x: 0.833,
												y: 0.833
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 77.584,
											s: [
												0.44,
												18.553
											],
											to: [
												0.22,
												-0.385
											],
											ti: [
												-0.11,
												0.037
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.167,
												y: 0.167
											},
											t: 82.588,
											s: [
												-1.21,
												19.323
											],
											to: [
												0.11,
												-0.037
											],
											ti: [
												-0.202,
												0.165
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 87.594,
											s: [
												1.1,
												18.333
											],
											to: [
												0.202,
												-0.165
											],
											ti: [
												0.833,
												0
											]
										},
										{
											t: 97.603515625,
											s: [
												0,
												18.333
											]
										}
									],
									ix: 12
								}
							},
							{
								ty: 0,
								nm: "Quality",
								mn: "ADBE BEZMESH-0014",
								ix: 13,
								v: {
									a: 0,
									k: 8,
									ix: 13
								}
							}
						]
					}
				],
				w: 55,
				h: 55,
				ip: 0,
				op: 166,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "d 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							1210.86,
							626.207,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							1210.86,
							626.207,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 166,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 178,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 10,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 9",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 17,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1233.5,
																						580.5
																					],
																					to: [
																						0.167,
																						-11.417
																					],
																					ti: [
																						-0.167,
																						11.417
																					]
																				},
																				{
																					t: null,
																					s: [
																						1234.5,
																						512
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 8",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 18,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1245,
																						550
																					],
																					to: [
																						6.5,
																						-9.583
																					],
																					ti: [
																						-6.5,
																						9.583
																					]
																				},
																				{
																					t: null,
																					s: [
																						1284,
																						492.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 7",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 19,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1231,
																						557.5
																					],
																					to: [
																						9,
																						-0.667
																					],
																					ti: [
																						-9,
																						0.667
																					]
																				},
																				{
																					t: null,
																					s: [
																						1285,
																						553.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 6",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 20,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1185,
																						579.5
																					],
																					to: [
																						-5.917,
																						-9.5
																					],
																					ti: [
																						5.917,
																						9.5
																					]
																				},
																				{
																					t: null,
																					s: [
																						1149.5,
																						522.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 21,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1193,
																						558.5
																					],
																					to: [
																						-0.417,
																						-9.75
																					],
																					ti: [
																						0.417,
																						9.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						1190.5,
																						500
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 6,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 22,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1192,
																						593.5
																					],
																					to: [
																						-9.083,
																						-3.167
																					],
																					ti: [
																						9.083,
																						3.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						1137.5,
																						574.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 7,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 23,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 0,
																			k: [
																				1197,
																				626.5
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 8,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 24,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1244.5,
																						607
																					],
																					to: [
																						3.25,
																						2.75
																					],
																					ti: [
																						-3.25,
																						-2.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						1264,
																						623.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 9,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 25,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1226,
																						525.5
																					],
																					to: [
																						5.667,
																						-15.083
																					],
																					ti: [
																						-5.667,
																						15.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						1260,
																						435
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														11.202,
														0
													],
													[
														0,
														13.374
													],
													[
														-13.373,
														0
													],
													[
														-2.764,
														-10.332
													],
													[
														0,
														0
													]
												],
												o: [
													[
														-13.373,
														0
													],
													[
														0,
														-13.374
													],
													[
														11.202,
														0
													],
													[
														0,
														0
													],
													[
														-2.764,
														10.332
													]
												],
												v: [
													[
														251.509,
														46.122
													],
													[
														227.296,
														21.905
													],
													[
														251.509,
														-2.311
													],
													[
														274.897,
														15.631
													],
													[
														274.897,
														28.179
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ind: 1,
										ty: "sh",
										ix: 2,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														14.555,
														0
													],
													[
														0,
														-35.513
													],
													[
														-33.174,
														0
													],
													[
														-10.396,
														9.22
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														-10.396,
														-9.22
													],
													[
														-33.174,
														0
													],
													[
														0,
														35.513
													],
													[
														14.555,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														274.897,
														-107.126
													],
													[
														274.897,
														-27.632
													],
													[
														236.601,
														-42.397
													],
													[
														176.534,
														21.905
													],
													[
														236.601,
														86.207
													],
													[
														274.897,
														71.443
													],
													[
														274.897,
														84.008
													],
													[
														325.186,
														84.008
													],
													[
														325.186,
														-107.126
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 2",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 3,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										960,
										540
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 7",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 240,
				op: 3766,
				st: 166,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "i 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							1098.99,
							624.001,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							1098.99,
							624.001,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 161,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 173,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 7,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 6",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 4,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1104,
																						602
																					],
																					to: [
																						3.083,
																						-7.167
																					],
																					ti: [
																						-3.083,
																						7.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						1122.5,
																						559
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 5,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1091.5,
																						594.5
																					],
																					to: [
																						-2.75,
																						-5.917
																					],
																					ti: [
																						2.75,
																						5.917
																					]
																				},
																				{
																					t: null,
																					s: [
																						1075,
																						559
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 6,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 0,
																			k: [
																				1099.5,
																				624
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 7,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1101.5,
																						614
																					],
																					to: [
																						3.417,
																						-18
																					],
																					ti: [
																						-3.417,
																						18
																					]
																				},
																				{
																					t: null,
																					s: [
																						1122,
																						506
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 8,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1083,
																						597.5
																					],
																					to: [
																						-1.25,
																						-15.333
																					],
																					ti: [
																						1.25,
																						15.333
																					]
																				},
																				{
																					t: null,
																					s: [
																						1075.5,
																						505.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 6,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 9,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1093.5,
																						580.5
																					],
																					to: [
																						0.833,
																						-12.583
																					],
																					ti: [
																						-0.833,
																						12.583
																					]
																				},
																				{
																					t: null,
																					s: [
																						1098.5,
																						505
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														-25.144,
														62.103
													],
													[
														-25.144,
														-62.103
													],
													[
														25.144,
														-62.103
													],
													[
														25.144,
														62.103
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										1098.99,
										561.898
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 1",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 240,
				op: 3761,
				st: 161,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "r 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							1013.066,
							624.001,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							1013.066,
							624.001,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 163,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 175,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 9,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 8",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 9,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0.833,
																						y: 0.833
																					},
																					o: {
																						x: 0.167,
																						y: 0.167
																					},
																					t: 0,
																					s: [
																						992.5,
																						623.25
																					],
																					to: [
																						0,
																						0
																					],
																					ti: [
																						0,
																						0
																					]
																				},
																				{
																					t: null,
																					s: [
																						992.5,
																						623.25
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 7",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 10,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1009.565,
																						576.749
																					],
																					to: [
																						4.934,
																						-6.295
																					],
																					ti: [
																						-4.934,
																						6.295
																					]
																				},
																				{
																					t: null,
																					s: [
																						1039.168,
																						538.979
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 6",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 11,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						990.003,
																						606.852
																					],
																					to: [
																						3.771,
																						-2.295
																					],
																					ti: [
																						-3.771,
																						2.295
																					]
																				},
																				{
																					t: null,
																					s: [
																						1012.628,
																						593.081
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 12,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						977.921,
																						606.352
																					],
																					to: [
																						-1.191,
																						-0.34
																					],
																					ti: [
																						1.191,
																						0.34
																					]
																				},
																				{
																					t: null,
																					s: [
																						970.775,
																						604.31
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 13,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						992.212,
																						588.998
																					],
																					to: [
																						-3.743,
																						-6.635
																					],
																					ti: [
																						3.743,
																						6.635
																					]
																				},
																				{
																					t: null,
																					s: [
																						969.754,
																						549.187
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 6,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 14,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						996.295,
																						573.686
																					],
																					to: [
																						-4.083,
																						-10.888
																					],
																					ti: [
																						4.083,
																						10.888
																					]
																				},
																				{
																					t: null,
																					s: [
																						971.796,
																						508.355
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 7,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 15,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1002.357,
																						619.353
																					],
																					to: [
																						0.181,
																						-18.84
																					],
																					ti: [
																						-0.181,
																						18.84
																					]
																				},
																				{
																					t: null,
																					s: [
																						1003.44,
																						506.314
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 8,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 16,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1024.877,
																						566.541
																					],
																					to: [
																						4.253,
																						-10.208
																					],
																					ti: [
																						-4.253,
																						10.208
																					]
																				},
																				{
																					t: null,
																					s: [
																						1050.397,
																						505.293
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														-13.022,
														0
													],
													[
														-4.721,
														-4.545
													],
													[
														0,
														0
													],
													[
														6.611,
														0
													],
													[
														5.797,
														-15.774
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														6.843,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-17.909,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														-15.428
													]
												],
												v: [
													[
														27.855,
														-18.269
													],
													[
														46.013,
														-10.876
													],
													[
														46.013,
														-61.868
													],
													[
														36.094,
														-63.405
													],
													[
														-0.38,
														-38.401
													],
													[
														-0.38,
														-60.801
													],
													[
														-46.013,
														-60.801
													],
													[
														-46.013,
														63.405
													],
													[
														4.276,
														63.405
													],
													[
														4.276,
														7.144
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										1013.066,
										560.596
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 8",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 240,
				op: 3763,
				st: 163,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "t 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							903.861,
							624.001,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							903.861,
							624.001,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 165,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 177,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 6,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 12,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 0,
																			k: [
																				904.5,
																				624
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 13,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						918,
																						609.5
																					],
																					to: [
																						5.417,
																						-14.75
																					],
																					ti: [
																						-5.417,
																						14.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						950.5,
																						521
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 14,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						891.5,
																						591.5
																					],
																					to: [
																						-5.417,
																						-12
																					],
																					ti: [
																						5.417,
																						12
																					]
																				},
																				{
																					t: null,
																					s: [
																						859,
																						519.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 15,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						916.5,
																						546.5
																					],
																					to: [
																						1.5,
																						-12.75
																					],
																					ti: [
																						-1.5,
																						12.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						925.5,
																						470
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 16,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						912.5,
																						588.5
																					],
																					to: [
																						-4.833,
																						-19.75
																					],
																					ti: [
																						4.833,
																						19.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						883.5,
																						470
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														48.426,
														-45.04
													],
													[
														25.144,
														-45.04
													],
													[
														25.144,
														-79.158
													],
													[
														-25.145,
														-79.158
													],
													[
														-25.145,
														-45.04
													],
													[
														-48.426,
														-45.04
													],
													[
														-48.426,
														-5.926
													],
													[
														-25.145,
														-5.926
													],
													[
														-25.145,
														79.158
													],
													[
														25.144,
														79.158
													],
													[
														25.144,
														-5.926
													],
													[
														48.426,
														-5.926
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										903.861,
										544.842
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 2",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 240,
				op: 3765,
				st: 165,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 4,
				nm: "s 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							796.787,
							627.126,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							796.787,
							627.126,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 165,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 177,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 14,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 13",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 23,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						815.5,
																						587
																					],
																					to: [
																						3.917,
																						-8.167
																					],
																					ti: [
																						-3.917,
																						8.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						839,
																						538
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 12",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 24,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						797.5,
																						548.5
																					],
																					to: [
																						-0.083,
																						-2.083
																					],
																					ti: [
																						0.083,
																						2.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						797,
																						536
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 11",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 25,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						815.5,
																						595.5
																					],
																					to: [
																						4.583,
																						-4.583
																					],
																					ti: [
																						-4.583,
																						4.583
																					]
																				},
																				{
																					t: null,
																					s: [
																						843,
																						568
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 10",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 26,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						819.5,
																						607
																					],
																					to: [
																						3.917,
																						-1.167
																					],
																					ti: [
																						-3.917,
																						1.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						843,
																						600
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 9",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 27,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 0,
																			k: [
																				798,
																				625
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 8",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 6,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 28,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						769.5,
																						622.5
																					],
																					to: [
																						-3.417,
																						-0.25
																					],
																					ti: [
																						3.417,
																						0.25
																					]
																				},
																				{
																					t: null,
																					s: [
																						749,
																						621
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 7",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 7,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 29,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						772,
																						599.5
																					],
																					to: [
																						-3.833,
																						-2.917
																					],
																					ti: [
																						3.833,
																						2.917
																					]
																				},
																				{
																					t: null,
																					s: [
																						749,
																						582
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 6",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 8,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 30,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						798.5,
																						602.5
																					],
																					to: [
																						-0.083,
																						-2.083
																					],
																					ti: [
																						0.083,
																						2.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						798,
																						590
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 9,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 31,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						780.5,
																						586.5
																					],
																					to: [
																						-0.083,
																						-2.083
																					],
																					ti: [
																						0.083,
																						2.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						780,
																						574
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 10,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 32,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						785.5,
																						593.5
																					],
																					to: [
																						-5.75,
																						-9.25
																					],
																					ti: [
																						5.75,
																						9.25
																					]
																				},
																				{
																					t: null,
																					s: [
																						751,
																						538
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 11,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 33,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						790,
																						579
																					],
																					to: [
																						-5.5,
																						-11
																					],
																					ti: [
																						5.5,
																						11
																					]
																				},
																				{
																					t: null,
																					s: [
																						757,
																						513
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 12,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 34,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						793,
																						576.5
																					],
																					to: [
																						0.667,
																						-12.75
																					],
																					ti: [
																						-0.667,
																						12.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						797,
																						500
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 13,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 35,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						811.5,
																						581.5
																					],
																					to: [
																						4.583,
																						-13.083
																					],
																					ti: [
																						-4.583,
																						13.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						839,
																						503
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														9.114
													],
													[
														-6.613,
														0
													],
													[
														-7.671,
														-2.782
													],
													[
														0,
														0
													],
													[
														-0.244,
														-0.094
													],
													[
														-1.317,
														-0.614
													],
													[
														-2.999,
														-2.211
													],
													[
														-0.102,
														-0.087
													],
													[
														0,
														0
													],
													[
														15.981,
														0
													],
													[
														0,
														-26.82
													],
													[
														0,
														-9.374
													],
													[
														5.509,
														0
													],
													[
														10.522,
														4.87
													],
													[
														3.444,
														2.438
													],
													[
														0,
														0
													],
													[
														-17.082,
														0
													],
													[
														0,
														24.216
													]
												],
												o: [
													[
														0,
														-2.083
													],
													[
														3.91,
														0
													],
													[
														0,
														0
													],
													[
														0.255,
														0.095
													],
													[
														1.38,
														0.519
													],
													[
														4.222,
														1.941
													],
													[
														0.118,
														0.086
													],
													[
														0,
														0
													],
													[
														-7.164,
														-0.26
													],
													[
														-36.094,
														0
													],
													[
														0,
														38.538
													],
													[
														0,
														2.083
													],
													[
														-6.918,
														0
													],
													[
														-6.946,
														-2.852
													],
													[
														0,
														0
													],
													[
														7.439,
														0
													],
													[
														37.472,
														0
													],
													[
														0,
														-38.538
													]
												],
												v: [
													[
														1.102,
														-27.732
													],
													[
														9.644,
														-32.939
													],
													[
														29.309,
														-28.813
													],
													[
														29.297,
														-28.828
													],
													[
														30.033,
														-28.545
													],
													[
														34.093,
														-26.849
													],
													[
														43.759,
														-20.921
													],
													[
														44.084,
														-20.661
													],
													[
														44.084,
														-60.02
													],
													[
														7.715,
														-64.967
													],
													[
														-48.768,
														-23.565
													],
													[
														-0.001,
														26.429
													],
													[
														-6.887,
														31.116
													],
													[
														-37.256,
														22.722
													],
													[
														-50.421,
														15.594
													],
													[
														-50.421,
														57.936
													],
													[
														-4.96,
														64.967
													],
													[
														50.421,
														23.045
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										796.787,
										562.158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 5",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 240,
				op: 3765,
				st: 165,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "a 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							657.326,
							626.207,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							657.326,
							626.207,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 158,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 170,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale 2')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale 2')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale 2')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale 2",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 10,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 9",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 18,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						679,
																						561
																					],
																					to: [
																						4.417,
																						-10
																					],
																					ti: [
																						-4.417,
																						10
																					]
																				},
																				{
																					t: null,
																					s: [
																						705.5,
																						501
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 8",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 19,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						691.5,
																						573
																					],
																					to: [
																						6.583,
																						-7.083
																					],
																					ti: [
																						-6.583,
																						7.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						731,
																						530.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 7",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 20,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						689,
																						593.5
																					],
																					to: [
																						7,
																						0.167
																					],
																					ti: [
																						-7,
																						-0.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						731,
																						594.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 6",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 21,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						680,
																						602
																					],
																					to: [
																						4.333,
																						3.583
																					],
																					ti: [
																						-4.333,
																						-3.583
																					]
																				},
																				{
																					t: null,
																					s: [
																						706,
																						623.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 22,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						670.5,
																						609.5
																					],
																					to: [
																						0.417,
																						1.25
																					],
																					ti: [
																						-0.417,
																						-1.25
																					]
																				},
																				{
																					t: null,
																					s: [
																						673,
																						617
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 6,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 23,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						640,
																						606
																					],
																					to: [
																						-1.417,
																						3
																					],
																					ti: [
																						1.417,
																						-3
																					]
																				},
																				{
																					t: null,
																					s: [
																						631.5,
																						624
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 7,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 24,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						626.5,
																						599
																					],
																					to: [
																						-4.917,
																						0.25
																					],
																					ti: [
																						4.917,
																						-0.25
																					]
																				},
																				{
																					t: null,
																					s: [
																						597,
																						600.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 8,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 25,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						632,
																						578
																					],
																					to: [
																						-6.833,
																						-8.167
																					],
																					ti: [
																						6.833,
																						8.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						591,
																						529
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 9,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 26,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						652,
																						566
																					],
																					to: [
																						-4.75,
																						-10.75
																					],
																					ti: [
																						4.75,
																						10.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						623.5,
																						501.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														11.202,
														0
													],
													[
														0,
														13.374
													],
													[
														-13.373,
														0
													],
													[
														-2.764,
														-10.332
													],
													[
														0,
														0
													]
												],
												o: [
													[
														-13.373,
														0
													],
													[
														0,
														-13.374
													],
													[
														11.202,
														0
													],
													[
														0,
														0
													],
													[
														-2.764,
														10.332
													]
												],
												v: [
													[
														-301.912,
														46.122
													],
													[
														-326.125,
														21.905
													],
													[
														-301.912,
														-2.311
													],
													[
														-278.524,
														15.631
													],
													[
														-278.524,
														28.179
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ind: 1,
										ty: "sh",
										ix: 2,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														14.555,
														0
													],
													[
														0,
														-35.513
													],
													[
														-33.174,
														0
													],
													[
														-10.396,
														9.22
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														-10.396,
														-9.22
													],
													[
														-33.174,
														0
													],
													[
														0,
														35.513
													],
													[
														14.555,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														-278.637,
														-40.198
													],
													[
														-278.637,
														-27.632
													],
													[
														-316.933,
														-42.397
													],
													[
														-377,
														21.905
													],
													[
														-316.933,
														86.207
													],
													[
														-278.637,
														71.443
													],
													[
														-278.637,
														84.008
													],
													[
														-228.348,
														84.008
													],
													[
														-228.348,
														-40.198
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 2",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 3,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										960,
										540
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 6",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 240,
				op: 3758,
				st: 158,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "d",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							1210.86,
							626.207,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							1210.86,
							626.207,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 166,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 178,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 10,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 9",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 17,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1233.5,
																						580.5
																					],
																					to: [
																						0.167,
																						-11.417
																					],
																					ti: [
																						-0.167,
																						11.417
																					]
																				},
																				{
																					t: null,
																					s: [
																						1234.5,
																						512
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 8",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 18,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1245,
																						550
																					],
																					to: [
																						6.5,
																						-9.583
																					],
																					ti: [
																						-6.5,
																						9.583
																					]
																				},
																				{
																					t: null,
																					s: [
																						1284,
																						492.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 7",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 19,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1231,
																						557.5
																					],
																					to: [
																						9,
																						-0.667
																					],
																					ti: [
																						-9,
																						0.667
																					]
																				},
																				{
																					t: null,
																					s: [
																						1285,
																						553.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 6",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 20,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1185,
																						579.5
																					],
																					to: [
																						-5.917,
																						-9.5
																					],
																					ti: [
																						5.917,
																						9.5
																					]
																				},
																				{
																					t: null,
																					s: [
																						1149.5,
																						522.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 21,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1193,
																						558.5
																					],
																					to: [
																						-0.417,
																						-9.75
																					],
																					ti: [
																						0.417,
																						9.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						1190.5,
																						500
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 6,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 22,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1192,
																						593.5
																					],
																					to: [
																						-9.083,
																						-3.167
																					],
																					ti: [
																						9.083,
																						3.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						1137.5,
																						574.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 7,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 23,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 0,
																			k: [
																				1197,
																				626.5
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 8,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 24,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1244.5,
																						607
																					],
																					to: [
																						3.25,
																						2.75
																					],
																					ti: [
																						-3.25,
																						-2.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						1264,
																						623.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 9,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 25,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1226,
																						525.5
																					],
																					to: [
																						5.667,
																						-15.083
																					],
																					ti: [
																						-5.667,
																						15.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						1260,
																						435
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														11.202,
														0
													],
													[
														0,
														13.374
													],
													[
														-13.373,
														0
													],
													[
														-2.764,
														-10.332
													],
													[
														0,
														0
													]
												],
												o: [
													[
														-13.373,
														0
													],
													[
														0,
														-13.374
													],
													[
														11.202,
														0
													],
													[
														0,
														0
													],
													[
														-2.764,
														10.332
													]
												],
												v: [
													[
														251.509,
														46.122
													],
													[
														227.296,
														21.905
													],
													[
														251.509,
														-2.311
													],
													[
														274.897,
														15.631
													],
													[
														274.897,
														28.179
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ind: 1,
										ty: "sh",
										ix: 2,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														14.555,
														0
													],
													[
														0,
														-35.513
													],
													[
														-33.174,
														0
													],
													[
														-10.396,
														9.22
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														-10.396,
														-9.22
													],
													[
														-33.174,
														0
													],
													[
														0,
														35.513
													],
													[
														14.555,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														274.897,
														-107.126
													],
													[
														274.897,
														-27.632
													],
													[
														236.601,
														-42.397
													],
													[
														176.534,
														21.905
													],
													[
														236.601,
														86.207
													],
													[
														274.897,
														71.443
													],
													[
														274.897,
														84.008
													],
													[
														325.186,
														84.008
													],
													[
														325.186,
														-107.126
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 2",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 3,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										960,
										540
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 7",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 166,
				op: 240,
				st: 166,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "i",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							1098.99,
							624.001,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							1098.99,
							624.001,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 161,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 173,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 7,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 6",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 4,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1104,
																						602
																					],
																					to: [
																						3.083,
																						-7.167
																					],
																					ti: [
																						-3.083,
																						7.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						1122.5,
																						559
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 5,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1091.5,
																						594.5
																					],
																					to: [
																						-2.75,
																						-5.917
																					],
																					ti: [
																						2.75,
																						5.917
																					]
																				},
																				{
																					t: null,
																					s: [
																						1075,
																						559
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 6,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 0,
																			k: [
																				1099.5,
																				624
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 7,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1101.5,
																						614
																					],
																					to: [
																						3.417,
																						-18
																					],
																					ti: [
																						-3.417,
																						18
																					]
																				},
																				{
																					t: null,
																					s: [
																						1122,
																						506
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 8,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1083,
																						597.5
																					],
																					to: [
																						-1.25,
																						-15.333
																					],
																					ti: [
																						1.25,
																						15.333
																					]
																				},
																				{
																					t: null,
																					s: [
																						1075.5,
																						505.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 6,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 9,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1093.5,
																						580.5
																					],
																					to: [
																						0.833,
																						-12.583
																					],
																					ti: [
																						-0.833,
																						12.583
																					]
																				},
																				{
																					t: null,
																					s: [
																						1098.5,
																						505
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														-25.144,
														62.103
													],
													[
														-25.144,
														-62.103
													],
													[
														25.144,
														-62.103
													],
													[
														25.144,
														62.103
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										1098.99,
										561.898
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 1",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 161,
				op: 240,
				st: 161,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "r",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							1013.066,
							624.001,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							1013.066,
							624.001,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 163,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 175,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 9,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 8",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 9,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0.833,
																						y: 0.833
																					},
																					o: {
																						x: 0.167,
																						y: 0.167
																					},
																					t: 0,
																					s: [
																						992.5,
																						623.25
																					],
																					to: [
																						0,
																						0
																					],
																					ti: [
																						0,
																						0
																					]
																				},
																				{
																					t: null,
																					s: [
																						992.5,
																						623.25
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 7",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 10,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1009.565,
																						576.749
																					],
																					to: [
																						4.934,
																						-6.295
																					],
																					ti: [
																						-4.934,
																						6.295
																					]
																				},
																				{
																					t: null,
																					s: [
																						1039.168,
																						538.979
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 6",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 11,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						990.003,
																						606.852
																					],
																					to: [
																						3.771,
																						-2.295
																					],
																					ti: [
																						-3.771,
																						2.295
																					]
																				},
																				{
																					t: null,
																					s: [
																						1012.628,
																						593.081
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 12,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						977.921,
																						606.352
																					],
																					to: [
																						-1.191,
																						-0.34
																					],
																					ti: [
																						1.191,
																						0.34
																					]
																				},
																				{
																					t: null,
																					s: [
																						970.775,
																						604.31
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 13,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						992.212,
																						588.998
																					],
																					to: [
																						-3.743,
																						-6.635
																					],
																					ti: [
																						3.743,
																						6.635
																					]
																				},
																				{
																					t: null,
																					s: [
																						969.754,
																						549.187
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 6,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 14,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						996.295,
																						573.686
																					],
																					to: [
																						-4.083,
																						-10.888
																					],
																					ti: [
																						4.083,
																						10.888
																					]
																				},
																				{
																					t: null,
																					s: [
																						971.796,
																						508.355
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 7,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 15,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1002.357,
																						619.353
																					],
																					to: [
																						0.181,
																						-18.84
																					],
																					ti: [
																						-0.181,
																						18.84
																					]
																				},
																				{
																					t: null,
																					s: [
																						1003.44,
																						506.314
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 8,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 16,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						1024.877,
																						566.541
																					],
																					to: [
																						4.253,
																						-10.208
																					],
																					ti: [
																						-4.253,
																						10.208
																					]
																				},
																				{
																					t: null,
																					s: [
																						1050.397,
																						505.293
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														-13.022,
														0
													],
													[
														-4.721,
														-4.545
													],
													[
														0,
														0
													],
													[
														6.611,
														0
													],
													[
														5.797,
														-15.774
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														6.843,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-17.909,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														-15.428
													]
												],
												v: [
													[
														27.855,
														-18.269
													],
													[
														46.013,
														-10.876
													],
													[
														46.013,
														-61.868
													],
													[
														36.094,
														-63.405
													],
													[
														-0.38,
														-38.401
													],
													[
														-0.38,
														-60.801
													],
													[
														-46.013,
														-60.801
													],
													[
														-46.013,
														63.405
													],
													[
														4.276,
														63.405
													],
													[
														4.276,
														7.144
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										1013.066,
										560.596
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 8",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 163,
				op: 240,
				st: 163,
				bm: 0
			},
			{
				ddd: 0,
				ind: 14,
				ty: 4,
				nm: "t",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							903.861,
							624.001,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							903.861,
							624.001,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 165,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 177,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 6,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 12,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 0,
																			k: [
																				904.5,
																				624
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 13,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						918,
																						609.5
																					],
																					to: [
																						5.417,
																						-14.75
																					],
																					ti: [
																						-5.417,
																						14.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						950.5,
																						521
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 14,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						891.5,
																						591.5
																					],
																					to: [
																						-5.417,
																						-12
																					],
																					ti: [
																						5.417,
																						12
																					]
																				},
																				{
																					t: null,
																					s: [
																						859,
																						519.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 15,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						916.5,
																						546.5
																					],
																					to: [
																						1.5,
																						-12.75
																					],
																					ti: [
																						-1.5,
																						12.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						925.5,
																						470
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 16,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						912.5,
																						588.5
																					],
																					to: [
																						-4.833,
																						-19.75
																					],
																					ti: [
																						4.833,
																						19.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						883.5,
																						470
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														48.426,
														-45.04
													],
													[
														25.144,
														-45.04
													],
													[
														25.144,
														-79.158
													],
													[
														-25.145,
														-79.158
													],
													[
														-25.145,
														-45.04
													],
													[
														-48.426,
														-45.04
													],
													[
														-48.426,
														-5.926
													],
													[
														-25.145,
														-5.926
													],
													[
														-25.145,
														79.158
													],
													[
														25.144,
														79.158
													],
													[
														25.144,
														-5.926
													],
													[
														48.426,
														-5.926
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										903.861,
										544.842
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 2",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 165,
				op: 240,
				st: 165,
				bm: 0
			},
			{
				ddd: 0,
				ind: 15,
				ty: 4,
				nm: "s",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							796.787,
							627.126,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							796.787,
							627.126,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 165,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 177,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 14,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 13",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 23,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						815.5,
																						587
																					],
																					to: [
																						3.917,
																						-8.167
																					],
																					ti: [
																						-3.917,
																						8.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						839,
																						538
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 12",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 24,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						797.5,
																						548.5
																					],
																					to: [
																						-0.083,
																						-2.083
																					],
																					ti: [
																						0.083,
																						2.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						797,
																						536
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 11",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 25,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						815.5,
																						595.5
																					],
																					to: [
																						4.583,
																						-4.583
																					],
																					ti: [
																						-4.583,
																						4.583
																					]
																				},
																				{
																					t: null,
																					s: [
																						843,
																						568
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 10",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 26,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						819.5,
																						607
																					],
																					to: [
																						3.917,
																						-1.167
																					],
																					ti: [
																						-3.917,
																						1.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						843,
																						600
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 9",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 27,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 0,
																			k: [
																				798,
																				625
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 8",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 6,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 28,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						769.5,
																						622.5
																					],
																					to: [
																						-3.417,
																						-0.25
																					],
																					ti: [
																						3.417,
																						0.25
																					]
																				},
																				{
																					t: null,
																					s: [
																						749,
																						621
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 7",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 7,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 29,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						772,
																						599.5
																					],
																					to: [
																						-3.833,
																						-2.917
																					],
																					ti: [
																						3.833,
																						2.917
																					]
																				},
																				{
																					t: null,
																					s: [
																						749,
																						582
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 6",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 8,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 30,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						798.5,
																						602.5
																					],
																					to: [
																						-0.083,
																						-2.083
																					],
																					ti: [
																						0.083,
																						2.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						798,
																						590
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 9,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 31,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						780.5,
																						586.5
																					],
																					to: [
																						-0.083,
																						-2.083
																					],
																					ti: [
																						0.083,
																						2.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						780,
																						574
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 10,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 32,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						785.5,
																						593.5
																					],
																					to: [
																						-5.75,
																						-9.25
																					],
																					ti: [
																						5.75,
																						9.25
																					]
																				},
																				{
																					t: null,
																					s: [
																						751,
																						538
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 11,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 33,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						790,
																						579
																					],
																					to: [
																						-5.5,
																						-11
																					],
																					ti: [
																						5.5,
																						11
																					]
																				},
																				{
																					t: null,
																					s: [
																						757,
																						513
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 12,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 34,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						793,
																						576.5
																					],
																					to: [
																						0.667,
																						-12.75
																					],
																					ti: [
																						-0.667,
																						12.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						797,
																						500
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 13,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 35,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						811.5,
																						581.5
																					],
																					to: [
																						4.583,
																						-13.083
																					],
																					ti: [
																						-4.583,
																						13.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						839,
																						503
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														9.114
													],
													[
														-6.613,
														0
													],
													[
														-7.671,
														-2.782
													],
													[
														0,
														0
													],
													[
														-0.244,
														-0.094
													],
													[
														-1.317,
														-0.614
													],
													[
														-2.999,
														-2.211
													],
													[
														-0.102,
														-0.087
													],
													[
														0,
														0
													],
													[
														15.981,
														0
													],
													[
														0,
														-26.82
													],
													[
														0,
														-9.374
													],
													[
														5.509,
														0
													],
													[
														10.522,
														4.87
													],
													[
														3.444,
														2.438
													],
													[
														0,
														0
													],
													[
														-17.082,
														0
													],
													[
														0,
														24.216
													]
												],
												o: [
													[
														0,
														-2.083
													],
													[
														3.91,
														0
													],
													[
														0,
														0
													],
													[
														0.255,
														0.095
													],
													[
														1.38,
														0.519
													],
													[
														4.222,
														1.941
													],
													[
														0.118,
														0.086
													],
													[
														0,
														0
													],
													[
														-7.164,
														-0.26
													],
													[
														-36.094,
														0
													],
													[
														0,
														38.538
													],
													[
														0,
														2.083
													],
													[
														-6.918,
														0
													],
													[
														-6.946,
														-2.852
													],
													[
														0,
														0
													],
													[
														7.439,
														0
													],
													[
														37.472,
														0
													],
													[
														0,
														-38.538
													]
												],
												v: [
													[
														1.102,
														-27.732
													],
													[
														9.644,
														-32.939
													],
													[
														29.309,
														-28.813
													],
													[
														29.297,
														-28.828
													],
													[
														30.033,
														-28.545
													],
													[
														34.093,
														-26.849
													],
													[
														43.759,
														-20.921
													],
													[
														44.084,
														-20.661
													],
													[
														44.084,
														-60.02
													],
													[
														7.715,
														-64.967
													],
													[
														-48.768,
														-23.565
													],
													[
														-0.001,
														26.429
													],
													[
														-6.887,
														31.116
													],
													[
														-37.256,
														22.722
													],
													[
														-50.421,
														15.594
													],
													[
														-50.421,
														57.936
													],
													[
														-4.96,
														64.967
													],
													[
														50.421,
														23.045
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										796.787,
										562.158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 5",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 165,
				op: 240,
				st: 165,
				bm: 0
			},
			{
				ddd: 0,
				ind: 16,
				ty: 4,
				nm: "a",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							657.326,
							626.207,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							657.326,
							626.207,
							0
						],
						ix: 1
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										0.833,
										0.833,
										0.833
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0.167,
										0.167,
										0.167
									]
								},
								t: 158,
								s: [
									0,
									0,
									100
								]
							},
							{
								t: 170,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						x: "var $bm_rt;\nvar amp, freq, decay, n, n, t, t, v;\ntry {\n    amp = $bm_div(effect('Elastic: Scale 2')(1), 200);\n    freq = $bm_div(effect('Elastic: Scale 2')(2), 30);\n    decay = $bm_div(effect('Elastic: Scale 2')(3), 10);\n    $bm_rt = n = 0;\n    if (numKeys > 0) {\n        $bm_rt = n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    if (n == 0) {\n        $bm_rt = t = 0;\n    } else {\n        $bm_rt = t = $bm_sub(time, key(n).time);\n    }\n    if (n > 0) {\n        v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n        $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n    } else {\n        $bm_rt = value;\n    }\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
					}
				},
				ao: 0,
				ef: [
					{
						ty: 5,
						nm: "Elastic: Scale 2",
						np: 5,
						mn: "Pseudo/MDS Elastic Controller",
						ix: 1,
						en: 1,
						ef: [
							{
								ty: 0,
								nm: "Amplitude",
								mn: "Pseudo/MDS Elastic Controller-0001",
								ix: 1,
								v: {
									a: 0,
									k: 10,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Frequency",
								mn: "Pseudo/MDS Elastic Controller-0002",
								ix: 2,
								v: {
									a: 0,
									k: 40,
									ix: 2
								}
							},
							{
								ty: 0,
								nm: "Decay",
								mn: "Pseudo/MDS Elastic Controller-0003",
								ix: 3,
								v: {
									a: 0,
									k: 40,
									ix: 3
								}
							}
						]
					},
					{
						ty: 34,
						nm: "Puppet",
						np: 6,
						mn: "ADBE FreePin3",
						ix: 2,
						en: 1,
						ef: [
							{
								ty: 7,
								nm: "Puppet Engine",
								mn: "ADBE FreePin3 Puppet Engine",
								ix: 1,
								v: {
									a: 0,
									k: 2,
									ix: 1
								}
							},
							{
								ty: 0,
								nm: "Mesh Rotation Refinement",
								mn: "ADBE FreePin3 Auto Rotate Pins",
								ix: 2,
								v: {
									a: 0,
									k: 20,
									ix: 2
								}
							},
							{
								ty: 7,
								nm: "On Transparent",
								mn: "ADBE FreePin3 On Transparent",
								ix: 3,
								v: {
									a: 0,
									k: 0,
									ix: 3
								}
							},
							{
								ty: 60,
								nm: "arap",
								np: 3,
								mn: "ADBE FreePin3 ARAP Group",
								ix: 4,
								en: 1,
								ef: [
									{
										ty: 6,
										nm: "Auto-traced Shapes",
										mn: "ADBE FreePin3 Outlines",
										ix: 1,
										v: 0
									},
									{
										ty: 1,
										nm: "Mesh",
										np: 2,
										mn: "ADBE FreePin3 Mesh Group",
										ix: 2,
										en: 1,
										ef: [
											{
												nm: "Mesh 1",
												np: 8,
												mn: "ADBE FreePin3 Mesh Atom",
												ix: 1,
												en: 1,
												ef: [
													{
														ty: 6,
														nm: "Mesh",
														mn: "ADBE FreePin3 Mesh",
														ix: 1,
														v: 0
													},
													{
														ty: 0,
														nm: "Triangles",
														mn: "ADBE FreePin3 Mesh Tri Count",
														ix: 2,
														v: {
															a: 0,
															k: 50,
															ix: 2
														}
													},
													{
														ty: 0,
														nm: "Density",
														mn: "ADBE FreePin3 Mesh Tri Density",
														ix: 3,
														v: {
															a: 0,
															k: 12,
															ix: 3
														}
													},
													{
														ty: 0,
														nm: "Expansion",
														mn: "ADBE FreePin3 Mesh Expansion",
														ix: 4,
														v: {
															a: 0,
															k: 20,
															ix: 4
														}
													},
													{
														nm: "Deform",
														np: 10,
														mn: "ADBE FreePin3 PosPins",
														ix: 5,
														en: 1,
														ef: [
															{
																nm: "Puppet Pin 9",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 1,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 18,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						679,
																						561
																					],
																					to: [
																						4.417,
																						-10
																					],
																					ti: [
																						-4.417,
																						10
																					]
																				},
																				{
																					t: null,
																					s: [
																						705.5,
																						501
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 8",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 2,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 19,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						691.5,
																						573
																					],
																					to: [
																						6.583,
																						-7.083
																					],
																					ti: [
																						-6.583,
																						7.083
																					]
																				},
																				{
																					t: null,
																					s: [
																						731,
																						530.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 7",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 3,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 20,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						689,
																						593.5
																					],
																					to: [
																						7,
																						0.167
																					],
																					ti: [
																						-7,
																						-0.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						731,
																						594.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 6",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 4,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 21,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						680,
																						602
																					],
																					to: [
																						4.333,
																						3.583
																					],
																					ti: [
																						-4.333,
																						-3.583
																					]
																				},
																				{
																					t: null,
																					s: [
																						706,
																						623.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 5",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 5,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 22,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						670.5,
																						609.5
																					],
																					to: [
																						0.417,
																						1.25
																					],
																					ti: [
																						-0.417,
																						-1.25
																					]
																				},
																				{
																					t: null,
																					s: [
																						673,
																						617
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 4",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 6,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 23,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						640,
																						606
																					],
																					to: [
																						-1.417,
																						3
																					],
																					ti: [
																						1.417,
																						-3
																					]
																				},
																				{
																					t: null,
																					s: [
																						631.5,
																						624
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 3",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 7,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 24,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						626.5,
																						599
																					],
																					to: [
																						-4.917,
																						0.25
																					],
																					ti: [
																						4.917,
																						-0.25
																					]
																				},
																				{
																					t: null,
																					s: [
																						597,
																						600.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 2",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 8,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 25,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						632,
																						578
																					],
																					to: [
																						-6.833,
																						-8.167
																					],
																					ti: [
																						6.833,
																						8.167
																					]
																				},
																				{
																					t: null,
																					s: [
																						591,
																						529
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															},
															{
																nm: "Puppet Pin 1",
																np: 7,
																mn: "ADBE FreePin3 PosPin Atom",
																ix: 9,
																en: 1,
																ef: [
																	{
																		ty: 3,
																		nm: "Vertex Offset",
																		mn: "ADBE FreePin3 PosPin Vtx Offset",
																		ix: 1,
																		v: {
																			a: 0,
																			k: [
																				0,
																				0
																			],
																			ix: 1
																		}
																	},
																	{
																		ty: 0,
																		nm: "Vertex Index",
																		mn: "ADBE FreePin3 PosPin Vtx Index",
																		ix: 2,
																		v: {
																			a: 0,
																			k: 26,
																			ix: 2
																		}
																	},
																	{
																		ty: 7,
																		nm: "Pin Type",
																		mn: "ADBE FreePin3 PosPin Type",
																		ix: 3,
																		v: {
																			a: 0,
																			k: 1,
																			ix: 3
																		}
																	},
																	{
																		ty: 3,
																		nm: "Position",
																		mn: "ADBE FreePin3 PosPin Position",
																		ix: 4,
																		v: {
																			a: 1,
																			k: [
																				{
																					i: {
																						x: 0,
																						y: 0
																					},
																					o: {
																						x: 0,
																						y: 0
																					},
																					t: 0,
																					s: [
																						652,
																						566
																					],
																					to: [
																						-4.75,
																						-10.75
																					],
																					ti: [
																						4.75,
																						10.75
																					]
																				},
																				{
																					t: null,
																					s: [
																						623.5,
																						501.5
																					]
																				}
																			],
																			ix: 4
																		}
																	},
																	{
																		ty: 0,
																		nm: "Scale",
																		mn: "ADBE FreePin3 PosPin Scale",
																		ix: 5,
																		v: {
																			a: 0,
																			k: 100,
																			ix: 5
																		}
																	},
																	{
																		ty: 0,
																		nm: "Rotation",
																		mn: "ADBE FreePin3 PosPin Rotation",
																		ix: 6,
																		v: {
																			a: 0,
																			k: 0,
																			ix: 6
																		}
																	}
																]
															}
														]
													},
													{
														nm: "Overlap",
														np: 1,
														mn: "ADBE FreePin3 HghtPins",
														ix: 6,
														en: 1,
														ef: [
														]
													},
													{
														nm: "Stiffness",
														np: 1,
														mn: "ADBE FreePin3 StarchPins",
														ix: 7,
														en: 1,
														ef: [
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														11.202,
														0
													],
													[
														0,
														13.374
													],
													[
														-13.373,
														0
													],
													[
														-2.764,
														-10.332
													],
													[
														0,
														0
													]
												],
												o: [
													[
														-13.373,
														0
													],
													[
														0,
														-13.374
													],
													[
														11.202,
														0
													],
													[
														0,
														0
													],
													[
														-2.764,
														10.332
													]
												],
												v: [
													[
														-301.912,
														46.122
													],
													[
														-326.125,
														21.905
													],
													[
														-301.912,
														-2.311
													],
													[
														-278.524,
														15.631
													],
													[
														-278.524,
														28.179
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ind: 1,
										ty: "sh",
										ix: 2,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														14.555,
														0
													],
													[
														0,
														-35.513
													],
													[
														-33.174,
														0
													],
													[
														-10.396,
														9.22
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														-10.396,
														-9.22
													],
													[
														-33.174,
														0
													],
													[
														0,
														35.513
													],
													[
														14.555,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														-278.637,
														-40.198
													],
													[
														-278.637,
														-27.632
													],
													[
														-316.933,
														-42.397
													],
													[
														-377,
														21.905
													],
													[
														-316.933,
														86.207
													],
													[
														-278.637,
														71.443
													],
													[
														-278.637,
														84.008
													],
													[
														-228.348,
														84.008
													],
													[
														-228.348,
														-40.198
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 2",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												1,
												1,
												1,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 1",
								np: 3,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										960,
										540
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Lager 6",
						np: 1,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 158,
				op: 240,
				st: 158,
				bm: 0
			}
		]
	},
	{
		id: "comp_1",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Boll 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							27.007,
							27.007,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												-14.916
											],
											[
												14.916,
												0
											],
											[
												0,
												14.916
											],
											[
												-14.916,
												0
											]
										],
										o: [
											[
												0,
												14.916
											],
											[
												-14.916,
												0
											],
											[
												0,
												-14.916
											],
											[
												14.916,
												0
											]
										],
										v: [
											[
												27.007,
												0
											],
											[
												0,
												27.007
											],
											[
												-27.007,
												0
											],
											[
												0,
												-27.007
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 3600,
				st: 0,
				bm: 0
			}
		]
	}
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 0,
		nm: "Astrid logo animation REAL FINAL THIS",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					442,
					450,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					960,
					540,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 1920,
		h: 1080,
		ip: 0,
		op: 3600,
		st: 0,
		bm: 0
	}
];
var markers = [
];
var AnimationNoScale = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

var css_248z$6 = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.welcome-animation {\n  width: 100%;\n  height: 100%;\n  flex: 1 0 auto;\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background-color: #ffbea8;\n}\n.welcome-animation__background {\n  animation-name: welcome-anim-bg;\n  animation-duration: 6s;\n  animation-iteration-count: 1;\n  animation-direction: normal;\n  animation-timing-function: step-start;\n  animation-fill-mode: forwards;\n}\n.welcome-animation__fade {\n  animation-name: welcome-anim-fade;\n  animation-duration: 400ms;\n  animation-iteration-count: 1;\n  animation-direction: normal;\n  animation-timing-function: ease;\n  animation-fill-mode: forwards;\n}\n@keyframes welcome-anim-fade {\n  from {\n    background-color: #ffbea8;\n  }\n  to {\n    background-color: white;\n  }\n}\n@keyframes welcome-anim-bg {\n  2% {\n    background-color: white;\n  }\n  9% {\n    background-color: #5bcfff;\n  }\n  15% {\n    background-color: #e80f62;\n  }\n  21% {\n    background-color: #edcd11;\n  }\n  100% {\n    background-color: #ffbea8;\n  }\n}";
styleInject(css_248z$6);

var WelcomeAnimation = function (_a) {
    var onAnimationStart = _a.onAnimationStart, onAnimationEnd = _a.onAnimationEnd;
    var animRef = React.useRef(null);
    var audioRef = React.useRef(null);
    var _b = React.useState(false), fadeOut = _b[0], setFadeOut = _b[1];
    var _c = React.useState(false), audioPlaying = _c[0], setAudioPlaying = _c[1];
    React.useEffect(function () {
        var animation = lottie.loadAnimation({
            container: animRef.current,
            animationData: AnimationNoScale,
            autoplay: false,
            loop: false,
            name: 'Welcome animation',
            renderer: 'svg'
        });
        if (onAnimationStart)
            onAnimationStart();
        animation.addEventListener('enterFrame', function () {
            setAudioPlaying(true);
        });
        animation.addEventListener('complete', function () {
            setFadeOut(true);
            audioRef.current.pause();
        });
        animation.play();
    }, []);
    var onFinish = function () {
        if (fadeOut && onAnimationEnd) {
            onAnimationEnd();
        }
    };
    React.useEffect(function () {
        if (audioPlaying && audioRef.current.paused) {
            audioRef
                .current.play()
                .then(function () { })
                .catch(function () { });
        }
    }, [audioPlaying]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { ref: animRef, onAnimationEnd: onFinish, className: "welcome-animation welcome-animation__".concat(fadeOut ? 'fade' : 'background') }),
        React__default["default"].createElement("audio", { ref: audioRef, loop: false },
            React__default["default"].createElement("source", { src: IntroSound, type: "audio/mpeg" }))));
};

var demoBookExercises = [
    {
        _id: 'demo0',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'Second star to the right.'
        }
    },
    {
        _id: 'demo1',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'Never is an awfully long time.'
        }
    },
    {
        _id: 'demo2',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'You’re braver than you believe.'
        }
    },
    {
        _id: 'demo3',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'One sees clearly only with the heart.'
        }
    },
    {
        _id: 'demo4',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'All you need is confidence in yourself.'
        }
    },
    {
        _id: 'demo5',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'This is a fierce bad rabbit.'
        }
    },
    {
        _id: 'demo6',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'I am the strongest girl in the world.'
        }
    },
    {
        _id: 'demo7',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'You are a dreamer.'
        }
    },
    {
        _id: 'demo8',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: "You're mad, bonkers, completely off your head."
        }
    },
    {
        _id: 'demo9',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'She was a real princess.'
        }
    },
    {
        _id: 'demo10',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'I knew who I was this morning.'
        }
    },
    {
        _id: 'demo11',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'Never do anything by halves.'
        }
    },
    {
        _id: 'demo12',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: 'With opportunity the world is very interesting.'
        }
    },
    {
        _id: 'demo13',
        type: exports.ExerciseType.ReadSentence,
        points: 0,
        data: {
            sentence: "I'm not young enough to know everything."
        }
    }
];

var css_248z$5 = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.demo-book {\n  display: flex;\n  flex: 1 0 auto;\n  position: relative;\n  width: 100%;\n  min-height: 100%;\n}\n.demo-book img {\n  box-shadow: none;\n}\n.demo-book__next-btn {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  background-color: transparent;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.demo-book__next-btn svg {\n  margin-left: 6px;\n  width: 20px;\n  height: 20px;\n}\n.demo-book__next-btn:hover {\n  color: #001593;\n}\n.demo-book__next-btn:hover svg {\n  fill: #001593;\n}";
styleInject(css_248z$5);

var DemoBook = /** @class */ (function (_super) {
    __extends(DemoBook, _super);
    function DemoBook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            index: 0
        };
        _this.next = function () {
            _this.setState(function (_a) {
                var index = _a.index;
                if (index + 1 > demoBookExercises.length - 1) {
                    return { index: 0 };
                }
                else {
                    return { index: index + 1 };
                }
            });
        };
        _this.prev = function () {
            _this.setState(function (_a) {
                var index = _a.index;
                if (index > 0) {
                    return { index: index - 1 };
                }
            });
        };
        _this.bindKeyboardArrows = function () {
            return onRightOrLeftKeyboardArrows(function () {
                // right
                _this.next();
            }, function () {
                // left
                _this.prev();
            });
        };
        return _this;
    }
    DemoBook.prototype.componentDidMount = function () {
        this.keyBindings = this.bindKeyboardArrows();
    };
    DemoBook.prototype.componentWillUnmount = function () {
        document.removeEventListener('keyup', this.keyBindings);
    };
    DemoBook.prototype.render = function () {
        var getSanaScore = this.props.getSanaScore;
        return (React__default["default"].createElement("div", { className: "demo-book" },
            React__default["default"].createElement(ExerciseTransition$1, { currentIndex: this.state.index, country: "US", demo: true, trackExerciseActivity: function () { }, onCurrentExerciseCompleted: function () { }, exercises: demoBookExercises, getSanaScore: getSanaScore, displayDetailedScore: true }),
            React__default["default"].createElement("button", { onClick: this.next, className: "demo-book__next-btn" }, this.state.index === demoBookExercises.length - 1 ? (React__default["default"].createElement(React__default["default"].Fragment, null,
                "Repeat all sentences ",
                React__default["default"].createElement(SvgReplay, null))) : (React__default["default"].createElement(React__default["default"].Fragment, null,
                "Next phrase ",
                React__default["default"].createElement(SvgArrowRight, null))))));
    };
    return DemoBook;
}(React__default["default"].Component));

function warn(s) {
  console.warn('[react-ga]', s);
}

function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$1(self); }

function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink$1 = /*#__PURE__*/function (_Component) {
  _inherits(OutboundLink, _Component);

  var _super = _createSuper(OutboundLink);

  function OutboundLink() {
    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$2(_assertThisInitialized$1(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          target = _this$props2.target,
          oldProps = _objectWithoutProperties$1(_this$props2, ["to", "target"]);

      var props = _objectSpread$2(_objectSpread$2({}, oldProps), {}, {
        target: target,
        href: href,
        onClick: this.handleClick
      });

      if (target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return /*#__PURE__*/React__default["default"].createElement('a', props);
    }
  }]);

  return OutboundLink;
}(React.Component);

_defineProperty$2(OutboundLink$1, "trackLink", function () {
  warn('ga tracking not enabled');
});
OutboundLink$1.propTypes = {
  eventLabel: propTypes.exports.string.isRequired,
  target: propTypes.exports.string,
  to: propTypes.exports.string,
  onClick: propTypes.exports.func,
  trackerNames: propTypes.exports.arrayOf(propTypes.exports.string)
};
OutboundLink$1.defaultProps = {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
};

// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}

var redacted = 'REDACTED (Potential Email Address)';
function redactEmail(string) {
  if (mightBeEmail(string)) {
    warn('This arg looks like an email address, redacting.');
    return redacted;
  }

  return string;
}

// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s && s.toString().replace(/^\s+|\s+$/g, '');
}

/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */
var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; // test

function toTitleCase(string) {
  return trim(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

function format() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var titleCase = arguments.length > 1 ? arguments[1] : undefined;
  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _str = s || '';

  if (titleCase) {
    _str = toTitleCase(s);
  }

  if (redactingEmail) {
    _str = redactEmail(_str);
  }

  return _str;
}

function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

function loadGA (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  }

  var onerror = options && options.onerror; // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */

  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    a.onerror = onerror;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

}

function log(s) {
  console.info('[react-ga]', s);
}

var gaCalls = [];
var TestModeAPI = {
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
};

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;
var _redactEmail = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return TestModeAPI.ga.apply(TestModeAPI, arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return warn('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return format(s, _titleCase, _redactEmail);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      warn('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    warn('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.redactEmail === false) {
      _redactEmail = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function addTrackers(configsOrTrackingId, options) {
  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        warn('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
function initialize$1(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return;
    }

    if (!options || options.standardImplementation !== true) loadGA(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
  addTrackers(configsOrTrackingId, options);
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      log("called ga('arguments');");
      log("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set$1(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    warn('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    warn('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    warn('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    log("called ga('set', fieldsObject);");
    log("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    log("called ga('send', fieldObject);");
    log("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    log("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview$1(rawPath, trackerNames, title) {
  if (!rawPath) {
    warn('path is required in .pageview()');
    return;
  }

  var path = trim(rawPath);

  if (path === '') {
    warn('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread$1({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      log("called ga('send', 'pageview', path);");
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      log("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    warn('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = removeLeadingSlash(trim(rawModalName));

  if (modalName === '') {
    warn('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      log("called ga('send', 'pageview', path);");
      log("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || typeof value !== 'number') {
      warn('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {{action: string, category: string}} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event$1() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      warn('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        warn('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        warn('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        warn('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          warn('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        warn('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        warn('`name` is required in .require()');
        return;
      }

      var name = trim(rawName);

      if (name === '') {
        warn('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (_typeof(options) !== 'object') {
          warn('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          warn('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          log("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          log("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }

    if (args.length === 1) {
      payload = args[0];
    } else {
      actionType = args[0];
      payload = args[1];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        warn('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        warn('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            log("called ga('".concat(command, "');"));
            log("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            log("called ga('".concat(command, "');"));
            log("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            log("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    warn('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      warn('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = TestModeAPI;
var core = {
  initialize: initialize$1,
  ga: ga,
  set: set$1,
  send: send,
  pageview: pageview$1,
  modalview: modalview,
  timing: timing,
  event: event$1,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: TestModeAPI
};

var Defaults = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addTrackers: addTrackers,
  initialize: initialize$1,
  ga: ga,
  set: set$1,
  send: send,
  pageview: pageview$1,
  modalview: modalview,
  timing: timing,
  event: event$1,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: testModeAPI,
  'default': core
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var initialize = initialize$1;
var set = set$1;
var pageview = pageview$1;
var event = event$1;
OutboundLink$1.origTrackLink = OutboundLink$1.trackLink;
OutboundLink$1.trackLink = outboundLink;
var OutboundLink = OutboundLink$1;
_objectSpread(_objectSpread({}, Defaults), {}, {
  OutboundLink: OutboundLink
});

var DEVELOPMENT_TRACKING_CODE = 'UA-172769777-1';
var GA_init = function (trackingCode) {
    if (typeof trackingCode !== 'string') {
        console.error('No or invalid analytics ID provided.');
    }
    if (process.env.NODE_ENV === 'production' && typeof trackingCode === 'string') {
        initialize(trackingCode);
    }
    else {
        initialize(DEVELOPMENT_TRACKING_CODE, { testMode: process.env.NODE_ENV === 'test' });
    }
};
var GA_customDimensions = function (bookTitle, timeSpentInBook, viewCount, finishCount) {
    if (bookTitle === void 0) { bookTitle = null; }
    if (timeSpentInBook === void 0) { timeSpentInBook = null; }
    if (viewCount === void 0) { viewCount = null; }
    if (finishCount === void 0) { finishCount = null; }
    return set({
        dimension1: bookTitle,
        metric1: timeSpentInBook,
        metric2: viewCount,
        metric3: finishCount
    });
};

var _path$j;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var SvgThumbDown = function SvgThumbDown(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$j || (_path$j = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,15H23V3H19M15,3H6C5.17,3 4.46,3.5 4.16,4.22L1.14,11.27C1.05,11.5 1,11.74 1,12V14A2,2 0 0,0 3,16H9.31L8.36,20.57C8.34,20.67 8.33,20.77 8.33,20.88C8.33,21.3 8.5,21.67 8.77,21.94L9.83,23L16.41,16.41C16.78,16.05 17,15.55 17,15V5C17,3.89 16.1,3 15,3Z"
  })));
};

var _path$i;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var SvgThumbUp = function SvgThumbUp(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$i || (_path$i = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23,10C23,8.89 22.1,8 21,8H14.68L15.64,3.43C15.66,3.33 15.67,3.22 15.67,3.11C15.67,2.7 15.5,2.32 15.23,2.05L14.17,1L7.59,7.58C7.22,7.95 7,8.45 7,9V19A2,2 0 0,0 9,21H18C18.83,21 19.54,20.5 19.84,19.78L22.86,12.73C22.95,12.5 23,12.26 23,12V10M1,21H5V9H1V21Z"
  })));
};

var css_248z$4 = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.rate {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.rate__good {\n  color: #5cb57b;\n}\n.rate__good svg {\n  fill: #5cb57b;\n  background-color: rgba(92, 181, 123, 0.2);\n}\n.rate__bad {\n  color: #e80f62;\n}\n.rate__bad svg {\n  fill: #e80f62;\n  background-color: rgba(232, 15, 98, 0.2);\n}\n.rate p {\n  font-size: 22px;\n  margin: 0 0 16px;\n}\n.rate > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n}\n.rate > div span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  font-size: 12px;\n  transition: 230ms all;\n}\n.rate > div span:active {\n  transform: scale(1.1);\n}\n.rate > div span svg {\n  width: 70px;\n  height: 70px;\n  padding: 18px;\n  border-radius: 100%;\n  cursor: pointer;\n  margin: 0 10px;\n}";
styleInject(css_248z$4);

var Rate = function (_a) {
    var text = _a.text, onGood = _a.onGood, onBad = _a.onBad, className = _a.className;
    return (React__default["default"].createElement("div", { className: "rate ".concat(className ? className : '') },
        text && React__default["default"].createElement(Typography, { variant: "body" }, text),
        React__default["default"].createElement("div", null,
            React__default["default"].createElement("span", { className: "rate__bad" },
                React__default["default"].createElement(SvgThumbDown, { onClick: onBad }),
                "Bad"),
            React__default["default"].createElement("span", { className: "rate__good" },
                React__default["default"].createElement(SvgThumbUp, { onClick: onGood }),
                "Good"))));
};

function useWindowSize() {
    var isClient = typeof window === 'object';
    function getSize() {
        return {
            width: isClient ? window.innerWidth : undefined,
            height: isClient ? window.innerHeight : undefined
        };
    }
    var _a = React.useState(getSize), windowSize = _a[0], setWindowSize = _a[1];
    React.useEffect(function () {
        if (!isClient) {
            return;
        }
        function handleResize() {
            setWindowSize(getSize());
        }
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
        // eslint-disable-next-line
    }, []);
    return windowSize;
}

var css_248z$3 = ".cancel-confirm-buttons {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n.cancel-confirm-buttons button:first-of-type {\n  margin-right: 16px;\n}";
styleInject(css_248z$3);

var CancelConfirmButtons = function (_a) {
    var onCancel = _a.onCancel, onConfirm = _a.onConfirm, className = _a.className, cancelText = _a.cancelText, confirmText = _a.confirmText, disableConfirm = _a.disableConfirm;
    return (React__default["default"].createElement("div", { className: "cancel-confirm-buttons ".concat(className ? className : '') },
        React__default["default"].createElement(Button, { color: "black", variant: "flat", disabled: disableConfirm, onClick: onConfirm }, confirmText ? confirmText : 'Confirm'),
        React__default["default"].createElement(Button, { variant: "flat", onClick: onCancel }, cancelText ? cancelText : 'Cancel')));
};

var css_248z$2 = ".delete-account-confirmation {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.delete-account-confirmation p {\n  text-align: center;\n}\n.delete-account-confirmation h4 {\n  margin: 4px 0;\n  color: red;\n}\n.delete-account-confirmation__buttons {\n  margin-top: 24px;\n}";
styleInject(css_248z$2);

var DeleteAccountConfirmation = function (_a) {
    var onDelete = _a.onDelete, onCancel = _a.onCancel;
    var _b = React.useState(''), keyword = _b[0], setKeyword = _b[1];
    return (React__default["default"].createElement("div", { className: "delete-account-confirmation" },
        React__default["default"].createElement(Typography, { variant: "h3" }, "DELETE ACCOUNT"),
        React__default["default"].createElement(Typography, { variant: "body" }, "You are about to remove your account."),
        React__default["default"].createElement(Typography, { variant: "h4" }, "This action cannot be undone."),
        React__default["default"].createElement(Typography, { variant: "body" }, "In order to proceed, please type \"delete\" in the input below and click DELETE button."),
        React__default["default"].createElement(TextInput, { name: "keyword", value: keyword, onChange: function (e) { return setKeyword(e.target.value); } }),
        React__default["default"].createElement(CancelConfirmButtons, { className: "delete-account-confirmation__buttons", onCancel: onCancel, onConfirm: onDelete, confirmText: "DELETE", disableConfirm: keyword !== 'delete' })));
};

var isArray$1 = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray$1(a)
      , arrB = isArray$1(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$d.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$c.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$b = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$9.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$a = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$8).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root, 'Map');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty$6.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache),
    'string': new Hash
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1 = moduleExports$2 ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] =
typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative(root, 'DataView');

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root, 'Promise');

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root, 'Set');

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root, 'WeakMap');

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2) ||
    (Map$1 && getTag(new Map$1) != mapTag$3) ||
    (Promise$1 && getTag(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag(new Set$1) != setTag$3) ||
    (WeakMap$1 && getTag(new WeakMap$1) != weakMapTag$1)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$3;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$3;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var getTag$1 = getTag;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/** Built-in value references. */
var Uint8Array$1 = root.Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$2:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$1;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$2 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$2;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG$1);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

var scheduler = {exports: {}};

var scheduler_production_min = {};

/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredScheduler_production_min;

function requireScheduler_production_min () {
	if (hasRequiredScheduler_production_min) return scheduler_production_min;
	hasRequiredScheduler_production_min = 1;
	(function (exports) {
Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
		if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null;}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0));};g=function(a,b){q=setTimeout(a,b);};h=function(){clearTimeout(q);};k=function(){return !1};l=exports.unstable_forceFrameRate=function(){};}else {var w=window.performance,x=window.Date,
		y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");}if("object"===
		typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else {var B=x.now();exports.unstable_now=function(){return x.now()-B};}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5;};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
		function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null);}catch(b){throw I.postMessage(null),b;}}else C=!1;};f=function(a){D=a;C||(C=!0,I.postMessage(null));};g=function(a,b){E=y(function(){a(exports.unstable_now());},b);};h=function(){z(E);E=-1;};}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
		function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
		function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O);}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else {var b=L(O);null!==b&&g(W,b.startTime-a);}}
		function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b);}else M(N);Q=L(N);}if(null!==Q)var m=!0;else {var n=L(O);null!==n&&g(W,n.startTime-b);m=!1;}return m}finally{Q=null,R=c,S=!1;}}
		function Y(a){switch(a){case 1:return -1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3;}var c=R;R=a;try{return b()}finally{R=c;}};
		exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R;}var c=R;R=b;try{return a()}finally{R=c;}};
		exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a);}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null;};
		exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c;}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X));};
		exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;
} (scheduler_production_min));
	return scheduler_production_min;
}

var scheduler_development = {};

/** @license React v0.18.0
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredScheduler_development;

function requireScheduler_development () {
	if (hasRequiredScheduler_development) return scheduler_development;
	hasRequiredScheduler_development = 1;
	(function (exports) {



		if (process.env.NODE_ENV !== "production") {
		  (function() {

		Object.defineProperty(exports, '__esModule', { value: true });

		var enableSchedulerDebugging = false;
		var enableProfiling = true;

		var requestHostCallback;

		var requestHostTimeout;
		var cancelHostTimeout;
		var shouldYieldToHost;
		var requestPaint;



		if ( // If Scheduler runs in a non-DOM environment, it falls back to a naive
		// implementation using setTimeout.
		typeof window === 'undefined' || // Check if MessageChannel is supported, too.
		typeof MessageChannel !== 'function') {
		  // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
		  // fallback to a naive implementation.
		  var _callback = null;
		  var _timeoutID = null;

		  var _flushCallback = function () {
		    if (_callback !== null) {
		      try {
		        var currentTime = exports.unstable_now();
		        var hasRemainingTime = true;

		        _callback(hasRemainingTime, currentTime);

		        _callback = null;
		      } catch (e) {
		        setTimeout(_flushCallback, 0);
		        throw e;
		      }
		    }
		  };

		  var initialTime = Date.now();

		  exports.unstable_now = function () {
		    return Date.now() - initialTime;
		  };

		  requestHostCallback = function (cb) {
		    if (_callback !== null) {
		      // Protect against re-entrancy.
		      setTimeout(requestHostCallback, 0, cb);
		    } else {
		      _callback = cb;
		      setTimeout(_flushCallback, 0);
		    }
		  };

		  requestHostTimeout = function (cb, ms) {
		    _timeoutID = setTimeout(cb, ms);
		  };

		  cancelHostTimeout = function () {
		    clearTimeout(_timeoutID);
		  };

		  shouldYieldToHost = function () {
		    return false;
		  };

		  requestPaint = exports.unstable_forceFrameRate = function () {};
		} else {
		  // Capture local references to native APIs, in case a polyfill overrides them.
		  var performance = window.performance;
		  var _Date = window.Date;
		  var _setTimeout = window.setTimeout;
		  var _clearTimeout = window.clearTimeout;

		  if (typeof console !== 'undefined') {
		    // TODO: Scheduler no longer requires these methods to be polyfilled. But
		    // maybe we want to continue warning if they don't exist, to preserve the
		    // option to rely on it in the future?
		    var requestAnimationFrame = window.requestAnimationFrame;
		    var cancelAnimationFrame = window.cancelAnimationFrame; // TODO: Remove fb.me link

		    if (typeof requestAnimationFrame !== 'function') {
		      console.error("This browser doesn't support requestAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
		    }

		    if (typeof cancelAnimationFrame !== 'function') {
		      console.error("This browser doesn't support cancelAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
		    }
		  }

		  if (typeof performance === 'object' && typeof performance.now === 'function') {
		    exports.unstable_now = function () {
		      return performance.now();
		    };
		  } else {
		    var _initialTime = _Date.now();

		    exports.unstable_now = function () {
		      return _Date.now() - _initialTime;
		    };
		  }

		  var isMessageLoopRunning = false;
		  var scheduledHostCallback = null;
		  var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
		  // thread, like user events. By default, it yields multiple times per frame.
		  // It does not attempt to align with frame boundaries, since most tasks don't
		  // need to be frame aligned; for those that do, use requestAnimationFrame.

		  var yieldInterval = 5;
		  var deadline = 0; // TODO: Make this configurable

		  {
		    // `isInputPending` is not available. Since we have no way of knowing if
		    // there's pending input, always yield at the end of the frame.
		    shouldYieldToHost = function () {
		      return exports.unstable_now() >= deadline;
		    }; // Since we yield every frame regardless, `requestPaint` has no effect.


		    requestPaint = function () {};
		  }

		  exports.unstable_forceFrameRate = function (fps) {
		    if (fps < 0 || fps > 125) {
		      console.error('forceFrameRate takes a positive int between 0 and 125, ' + 'forcing framerates higher than 125 fps is not unsupported');
		      return;
		    }

		    if (fps > 0) {
		      yieldInterval = Math.floor(1000 / fps);
		    } else {
		      // reset the framerate
		      yieldInterval = 5;
		    }
		  };

		  var performWorkUntilDeadline = function () {
		    if (scheduledHostCallback !== null) {
		      var currentTime = exports.unstable_now(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
		      // cycle. This means there's always time remaining at the beginning of
		      // the message event.

		      deadline = currentTime + yieldInterval;
		      var hasTimeRemaining = true;

		      try {
		        var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);

		        if (!hasMoreWork) {
		          isMessageLoopRunning = false;
		          scheduledHostCallback = null;
		        } else {
		          // If there's more work, schedule the next message event at the end
		          // of the preceding one.
		          port.postMessage(null);
		        }
		      } catch (error) {
		        // If a scheduler task throws, exit the current browser task so the
		        // error can be observed.
		        port.postMessage(null);
		        throw error;
		      }
		    } else {
		      isMessageLoopRunning = false;
		    } // Yielding to the browser will give it a chance to paint, so we can
		  };

		  var channel = new MessageChannel();
		  var port = channel.port2;
		  channel.port1.onmessage = performWorkUntilDeadline;

		  requestHostCallback = function (callback) {
		    scheduledHostCallback = callback;

		    if (!isMessageLoopRunning) {
		      isMessageLoopRunning = true;
		      port.postMessage(null);
		    }
		  };

		  requestHostTimeout = function (callback, ms) {
		    taskTimeoutID = _setTimeout(function () {
		      callback(exports.unstable_now());
		    }, ms);
		  };

		  cancelHostTimeout = function () {
		    _clearTimeout(taskTimeoutID);

		    taskTimeoutID = -1;
		  };
		}

		function push(heap, node) {
		  var index = heap.length;
		  heap.push(node);
		  siftUp(heap, node, index);
		}
		function peek(heap) {
		  var first = heap[0];
		  return first === undefined ? null : first;
		}
		function pop(heap) {
		  var first = heap[0];

		  if (first !== undefined) {
		    var last = heap.pop();

		    if (last !== first) {
		      heap[0] = last;
		      siftDown(heap, last, 0);
		    }

		    return first;
		  } else {
		    return null;
		  }
		}

		function siftUp(heap, node, i) {
		  var index = i;

		  while (true) {
		    var parentIndex = Math.floor((index - 1) / 2);
		    var parent = heap[parentIndex];

		    if (parent !== undefined && compare(parent, node) > 0) {
		      // The parent is larger. Swap positions.
		      heap[parentIndex] = node;
		      heap[index] = parent;
		      index = parentIndex;
		    } else {
		      // The parent is smaller. Exit.
		      return;
		    }
		  }
		}

		function siftDown(heap, node, i) {
		  var index = i;
		  var length = heap.length;

		  while (index < length) {
		    var leftIndex = (index + 1) * 2 - 1;
		    var left = heap[leftIndex];
		    var rightIndex = leftIndex + 1;
		    var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.

		    if (left !== undefined && compare(left, node) < 0) {
		      if (right !== undefined && compare(right, left) < 0) {
		        heap[index] = right;
		        heap[rightIndex] = node;
		        index = rightIndex;
		      } else {
		        heap[index] = left;
		        heap[leftIndex] = node;
		        index = leftIndex;
		      }
		    } else if (right !== undefined && compare(right, node) < 0) {
		      heap[index] = right;
		      heap[rightIndex] = node;
		      index = rightIndex;
		    } else {
		      // Neither child is smaller. Exit.
		      return;
		    }
		  }
		}

		function compare(a, b) {
		  // Compare sort index first, then task id.
		  var diff = a.sortIndex - b.sortIndex;
		  return diff !== 0 ? diff : a.id - b.id;
		}

		// TODO: Use symbols?
		var NoPriority = 0;
		var ImmediatePriority = 1;
		var UserBlockingPriority = 2;
		var NormalPriority = 3;
		var LowPriority = 4;
		var IdlePriority = 5;

		var runIdCounter = 0;
		var mainThreadIdCounter = 0;
		var profilingStateSize = 4;
		var sharedProfilingBuffer = // $FlowFixMe Flow doesn't know about SharedArrayBuffer
		typeof SharedArrayBuffer === 'function' ? new SharedArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : // $FlowFixMe Flow doesn't know about ArrayBuffer
		typeof ArrayBuffer === 'function' ? new ArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : null // Don't crash the init path on IE9
		;
		var profilingState = sharedProfilingBuffer !== null ? new Int32Array(sharedProfilingBuffer) : []; // We can't read this but it helps save bytes for null checks

		var PRIORITY = 0;
		var CURRENT_TASK_ID = 1;
		var CURRENT_RUN_ID = 2;
		var QUEUE_SIZE = 3;

		{
		  profilingState[PRIORITY] = NoPriority; // This is maintained with a counter, because the size of the priority queue
		  // array might include canceled tasks.

		  profilingState[QUEUE_SIZE] = 0;
		  profilingState[CURRENT_TASK_ID] = 0;
		} // Bytes per element is 4


		var INITIAL_EVENT_LOG_SIZE = 131072;
		var MAX_EVENT_LOG_SIZE = 524288; // Equivalent to 2 megabytes

		var eventLogSize = 0;
		var eventLogBuffer = null;
		var eventLog = null;
		var eventLogIndex = 0;
		var TaskStartEvent = 1;
		var TaskCompleteEvent = 2;
		var TaskErrorEvent = 3;
		var TaskCancelEvent = 4;
		var TaskRunEvent = 5;
		var TaskYieldEvent = 6;
		var SchedulerSuspendEvent = 7;
		var SchedulerResumeEvent = 8;

		function logEvent(entries) {
		  if (eventLog !== null) {
		    var offset = eventLogIndex;
		    eventLogIndex += entries.length;

		    if (eventLogIndex + 1 > eventLogSize) {
		      eventLogSize *= 2;

		      if (eventLogSize > MAX_EVENT_LOG_SIZE) {
		        console.error("Scheduler Profiling: Event log exceeded maximum size. Don't " + 'forget to call `stopLoggingProfilingEvents()`.');
		        stopLoggingProfilingEvents();
		        return;
		      }

		      var newEventLog = new Int32Array(eventLogSize * 4);
		      newEventLog.set(eventLog);
		      eventLogBuffer = newEventLog.buffer;
		      eventLog = newEventLog;
		    }

		    eventLog.set(entries, offset);
		  }
		}

		function startLoggingProfilingEvents() {
		  eventLogSize = INITIAL_EVENT_LOG_SIZE;
		  eventLogBuffer = new ArrayBuffer(eventLogSize * 4);
		  eventLog = new Int32Array(eventLogBuffer);
		  eventLogIndex = 0;
		}
		function stopLoggingProfilingEvents() {
		  var buffer = eventLogBuffer;
		  eventLogSize = 0;
		  eventLogBuffer = null;
		  eventLog = null;
		  eventLogIndex = 0;
		  return buffer;
		}
		function markTaskStart(task, ms) {
		  {
		    profilingState[QUEUE_SIZE]++;

		    if (eventLog !== null) {
		      // performance.now returns a float, representing milliseconds. When the
		      // event is logged, it's coerced to an int. Convert to microseconds to
		      // maintain extra degrees of precision.
		      logEvent([TaskStartEvent, ms * 1000, task.id, task.priorityLevel]);
		    }
		  }
		}
		function markTaskCompleted(task, ms) {
		  {
		    profilingState[PRIORITY] = NoPriority;
		    profilingState[CURRENT_TASK_ID] = 0;
		    profilingState[QUEUE_SIZE]--;

		    if (eventLog !== null) {
		      logEvent([TaskCompleteEvent, ms * 1000, task.id]);
		    }
		  }
		}
		function markTaskCanceled(task, ms) {
		  {
		    profilingState[QUEUE_SIZE]--;

		    if (eventLog !== null) {
		      logEvent([TaskCancelEvent, ms * 1000, task.id]);
		    }
		  }
		}
		function markTaskErrored(task, ms) {
		  {
		    profilingState[PRIORITY] = NoPriority;
		    profilingState[CURRENT_TASK_ID] = 0;
		    profilingState[QUEUE_SIZE]--;

		    if (eventLog !== null) {
		      logEvent([TaskErrorEvent, ms * 1000, task.id]);
		    }
		  }
		}
		function markTaskRun(task, ms) {
		  {
		    runIdCounter++;
		    profilingState[PRIORITY] = task.priorityLevel;
		    profilingState[CURRENT_TASK_ID] = task.id;
		    profilingState[CURRENT_RUN_ID] = runIdCounter;

		    if (eventLog !== null) {
		      logEvent([TaskRunEvent, ms * 1000, task.id, runIdCounter]);
		    }
		  }
		}
		function markTaskYield(task, ms) {
		  {
		    profilingState[PRIORITY] = NoPriority;
		    profilingState[CURRENT_TASK_ID] = 0;
		    profilingState[CURRENT_RUN_ID] = 0;

		    if (eventLog !== null) {
		      logEvent([TaskYieldEvent, ms * 1000, task.id, runIdCounter]);
		    }
		  }
		}
		function markSchedulerSuspended(ms) {
		  {
		    mainThreadIdCounter++;

		    if (eventLog !== null) {
		      logEvent([SchedulerSuspendEvent, ms * 1000, mainThreadIdCounter]);
		    }
		  }
		}
		function markSchedulerUnsuspended(ms) {
		  {
		    if (eventLog !== null) {
		      logEvent([SchedulerResumeEvent, ms * 1000, mainThreadIdCounter]);
		    }
		  }
		}

		/* eslint-disable no-var */
		// Math.pow(2, 30) - 1
		// 0b111111111111111111111111111111

		var maxSigned31BitInt = 1073741823; // Times out immediately

		var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out

		var USER_BLOCKING_PRIORITY = 250;
		var NORMAL_PRIORITY_TIMEOUT = 5000;
		var LOW_PRIORITY_TIMEOUT = 10000; // Never times out

		var IDLE_PRIORITY = maxSigned31BitInt; // Tasks are stored on a min heap

		var taskQueue = [];
		var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.

		var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
		var currentTask = null;
		var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.

		var isPerformingWork = false;
		var isHostCallbackScheduled = false;
		var isHostTimeoutScheduled = false;

		function advanceTimers(currentTime) {
		  // Check for tasks that are no longer delayed and add them to the queue.
		  var timer = peek(timerQueue);

		  while (timer !== null) {
		    if (timer.callback === null) {
		      // Timer was cancelled.
		      pop(timerQueue);
		    } else if (timer.startTime <= currentTime) {
		      // Timer fired. Transfer to the task queue.
		      pop(timerQueue);
		      timer.sortIndex = timer.expirationTime;
		      push(taskQueue, timer);

		      {
		        markTaskStart(timer, currentTime);
		        timer.isQueued = true;
		      }
		    } else {
		      // Remaining timers are pending.
		      return;
		    }

		    timer = peek(timerQueue);
		  }
		}

		function handleTimeout(currentTime) {
		  isHostTimeoutScheduled = false;
		  advanceTimers(currentTime);

		  if (!isHostCallbackScheduled) {
		    if (peek(taskQueue) !== null) {
		      isHostCallbackScheduled = true;
		      requestHostCallback(flushWork);
		    } else {
		      var firstTimer = peek(timerQueue);

		      if (firstTimer !== null) {
		        requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
		      }
		    }
		  }
		}

		function flushWork(hasTimeRemaining, initialTime) {
		  {
		    markSchedulerUnsuspended(initialTime);
		  } // We'll need a host callback the next time work is scheduled.


		  isHostCallbackScheduled = false;

		  if (isHostTimeoutScheduled) {
		    // We scheduled a timeout but it's no longer needed. Cancel it.
		    isHostTimeoutScheduled = false;
		    cancelHostTimeout();
		  }

		  isPerformingWork = true;
		  var previousPriorityLevel = currentPriorityLevel;

		  try {
		    if (enableProfiling) {
		      try {
		        return workLoop(hasTimeRemaining, initialTime);
		      } catch (error) {
		        if (currentTask !== null) {
		          var currentTime = exports.unstable_now();
		          markTaskErrored(currentTask, currentTime);
		          currentTask.isQueued = false;
		        }

		        throw error;
		      }
		    }
		  } finally {
		    currentTask = null;
		    currentPriorityLevel = previousPriorityLevel;
		    isPerformingWork = false;

		    {
		      var _currentTime = exports.unstable_now();

		      markSchedulerSuspended(_currentTime);
		    }
		  }
		}

		function workLoop(hasTimeRemaining, initialTime) {
		  var currentTime = initialTime;
		  advanceTimers(currentTime);
		  currentTask = peek(taskQueue);

		  while (currentTask !== null && !(enableSchedulerDebugging )) {
		    if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) {
		      // This currentTask hasn't expired, and we've reached the deadline.
		      break;
		    }

		    var callback = currentTask.callback;

		    if (callback !== null) {
		      currentTask.callback = null;
		      currentPriorityLevel = currentTask.priorityLevel;
		      var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
		      markTaskRun(currentTask, currentTime);
		      var continuationCallback = callback(didUserCallbackTimeout);
		      currentTime = exports.unstable_now();

		      if (typeof continuationCallback === 'function') {
		        currentTask.callback = continuationCallback;
		        markTaskYield(currentTask, currentTime);
		      } else {
		        {
		          markTaskCompleted(currentTask, currentTime);
		          currentTask.isQueued = false;
		        }

		        if (currentTask === peek(taskQueue)) {
		          pop(taskQueue);
		        }
		      }

		      advanceTimers(currentTime);
		    } else {
		      pop(taskQueue);
		    }

		    currentTask = peek(taskQueue);
		  } // Return whether there's additional work


		  if (currentTask !== null) {
		    return true;
		  } else {
		    var firstTimer = peek(timerQueue);

		    if (firstTimer !== null) {
		      requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
		    }

		    return false;
		  }
		}

		function unstable_runWithPriority(priorityLevel, eventHandler) {
		  switch (priorityLevel) {
		    case ImmediatePriority:
		    case UserBlockingPriority:
		    case NormalPriority:
		    case LowPriority:
		    case IdlePriority:
		      break;

		    default:
		      priorityLevel = NormalPriority;
		  }

		  var previousPriorityLevel = currentPriorityLevel;
		  currentPriorityLevel = priorityLevel;

		  try {
		    return eventHandler();
		  } finally {
		    currentPriorityLevel = previousPriorityLevel;
		  }
		}

		function unstable_next(eventHandler) {
		  var priorityLevel;

		  switch (currentPriorityLevel) {
		    case ImmediatePriority:
		    case UserBlockingPriority:
		    case NormalPriority:
		      // Shift down to normal priority
		      priorityLevel = NormalPriority;
		      break;

		    default:
		      // Anything lower than normal priority should remain at the current level.
		      priorityLevel = currentPriorityLevel;
		      break;
		  }

		  var previousPriorityLevel = currentPriorityLevel;
		  currentPriorityLevel = priorityLevel;

		  try {
		    return eventHandler();
		  } finally {
		    currentPriorityLevel = previousPriorityLevel;
		  }
		}

		function unstable_wrapCallback(callback) {
		  var parentPriorityLevel = currentPriorityLevel;
		  return function () {
		    // This is a fork of runWithPriority, inlined for performance.
		    var previousPriorityLevel = currentPriorityLevel;
		    currentPriorityLevel = parentPriorityLevel;

		    try {
		      return callback.apply(this, arguments);
		    } finally {
		      currentPriorityLevel = previousPriorityLevel;
		    }
		  };
		}

		function timeoutForPriorityLevel(priorityLevel) {
		  switch (priorityLevel) {
		    case ImmediatePriority:
		      return IMMEDIATE_PRIORITY_TIMEOUT;

		    case UserBlockingPriority:
		      return USER_BLOCKING_PRIORITY;

		    case IdlePriority:
		      return IDLE_PRIORITY;

		    case LowPriority:
		      return LOW_PRIORITY_TIMEOUT;

		    case NormalPriority:
		    default:
		      return NORMAL_PRIORITY_TIMEOUT;
		  }
		}

		function unstable_scheduleCallback(priorityLevel, callback, options) {
		  var currentTime = exports.unstable_now();
		  var startTime;
		  var timeout;

		  if (typeof options === 'object' && options !== null) {
		    var delay = options.delay;

		    if (typeof delay === 'number' && delay > 0) {
		      startTime = currentTime + delay;
		    } else {
		      startTime = currentTime;
		    }

		    timeout = typeof options.timeout === 'number' ? options.timeout : timeoutForPriorityLevel(priorityLevel);
		  } else {
		    timeout = timeoutForPriorityLevel(priorityLevel);
		    startTime = currentTime;
		  }

		  var expirationTime = startTime + timeout;
		  var newTask = {
		    id: taskIdCounter++,
		    callback: callback,
		    priorityLevel: priorityLevel,
		    startTime: startTime,
		    expirationTime: expirationTime,
		    sortIndex: -1
		  };

		  {
		    newTask.isQueued = false;
		  }

		  if (startTime > currentTime) {
		    // This is a delayed task.
		    newTask.sortIndex = startTime;
		    push(timerQueue, newTask);

		    if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
		      // All tasks are delayed, and this is the task with the earliest delay.
		      if (isHostTimeoutScheduled) {
		        // Cancel an existing timeout.
		        cancelHostTimeout();
		      } else {
		        isHostTimeoutScheduled = true;
		      } // Schedule a timeout.


		      requestHostTimeout(handleTimeout, startTime - currentTime);
		    }
		  } else {
		    newTask.sortIndex = expirationTime;
		    push(taskQueue, newTask);

		    {
		      markTaskStart(newTask, currentTime);
		      newTask.isQueued = true;
		    } // Schedule a host callback, if needed. If we're already performing work,
		    // wait until the next time we yield.


		    if (!isHostCallbackScheduled && !isPerformingWork) {
		      isHostCallbackScheduled = true;
		      requestHostCallback(flushWork);
		    }
		  }

		  return newTask;
		}

		function unstable_pauseExecution() {
		}

		function unstable_continueExecution() {

		  if (!isHostCallbackScheduled && !isPerformingWork) {
		    isHostCallbackScheduled = true;
		    requestHostCallback(flushWork);
		  }
		}

		function unstable_getFirstCallbackNode() {
		  return peek(taskQueue);
		}

		function unstable_cancelCallback(task) {
		  {
		    if (task.isQueued) {
		      var currentTime = exports.unstable_now();
		      markTaskCanceled(task, currentTime);
		      task.isQueued = false;
		    }
		  } // Null out the callback to indicate the task has been canceled. (Can't
		  // remove from the queue because you can't remove arbitrary nodes from an
		  // array based heap, only the first one.)


		  task.callback = null;
		}

		function unstable_getCurrentPriorityLevel() {
		  return currentPriorityLevel;
		}

		function unstable_shouldYield() {
		  var currentTime = exports.unstable_now();
		  advanceTimers(currentTime);
		  var firstTask = peek(taskQueue);
		  return firstTask !== currentTask && currentTask !== null && firstTask !== null && firstTask.callback !== null && firstTask.startTime <= currentTime && firstTask.expirationTime < currentTask.expirationTime || shouldYieldToHost();
		}

		var unstable_requestPaint = requestPaint;
		var unstable_Profiling = {
		  startLoggingProfilingEvents: startLoggingProfilingEvents,
		  stopLoggingProfilingEvents: stopLoggingProfilingEvents,
		  sharedProfilingBuffer: sharedProfilingBuffer
		} ;

		exports.unstable_ImmediatePriority = ImmediatePriority;
		exports.unstable_UserBlockingPriority = UserBlockingPriority;
		exports.unstable_NormalPriority = NormalPriority;
		exports.unstable_IdlePriority = IdlePriority;
		exports.unstable_LowPriority = LowPriority;
		exports.unstable_runWithPriority = unstable_runWithPriority;
		exports.unstable_next = unstable_next;
		exports.unstable_scheduleCallback = unstable_scheduleCallback;
		exports.unstable_cancelCallback = unstable_cancelCallback;
		exports.unstable_wrapCallback = unstable_wrapCallback;
		exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
		exports.unstable_shouldYield = unstable_shouldYield;
		exports.unstable_requestPaint = unstable_requestPaint;
		exports.unstable_continueExecution = unstable_continueExecution;
		exports.unstable_pauseExecution = unstable_pauseExecution;
		exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
		exports.unstable_Profiling = unstable_Profiling;
		  })();
		}
} (scheduler_development));
	return scheduler_development;
}

(function (module) {

	if (process.env.NODE_ENV === 'production') {
	  module.exports = requireScheduler_production_min();
	} else {
	  module.exports = requireScheduler_development();
	}
} (scheduler));

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

function _extends$p() {
  _extends$p = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$p.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/** @private is the value an empty array? */

var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private Does a React component have exactly 0 children? */

var isEmptyChildren = function isEmptyChildren(children) {
  return React.Children.count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return isObject(value) && isFunction(value.then);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = toPath(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = clone(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = toPath(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var FormikContext =
/*#__PURE__*/
React.createContext(undefined);
var FormikProvider = FormikContext.Provider;
FormikContext.Consumer;
function useFormikContext() {
  var formik = React.useContext(FormikContext);
  !!!formik ? process.env.NODE_ENV !== "production" ? warning(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : warning(false) : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends$p({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends$p({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (reactFastCompare(state.errors, msg.payload)) {
        return state;
      }

      return _extends$p({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends$p({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends$p({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends$p({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends$p({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends$p({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends$p({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends$p({}, state, {}, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends$p({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends$p({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends$p({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends$p({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = React.useRef(props.initialValues);
  var initialErrors = React.useRef(props.initialErrors || emptyErrors);
  var initialTouched = React.useRef(props.initialTouched || emptyTouched);
  var initialStatus = React.useRef(props.initialStatus);
  var isMounted = React.useRef(false);
  var fieldRegistry = React.useRef({});

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      !(typeof isInitialValid === 'undefined') ? process.env.NODE_ENV !== "production" ? warning(false, 'isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.') : warning(false) : void 0; // eslint-disable-next-line
    }, []);
  }

  React.useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = React.useReducer(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = React.useCallback(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = React.useCallback(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = React.useCallback(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = React.useCallback(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = React.useCallback(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = deepmerge_1.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run validations and dispatching the result as low-priority via rAF.
  //
  // The thinking is that validation as a result of onChange and onBlur
  // should never block user input. Note: This method should never be called
  // during the submission phase because validation prior to submission
  // is actaully high-priority since we absolutely need to guarantee the
  // form is valid before executing props.onSubmit.

  var validateFormWithLowPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    return scheduler.exports.unstable_runWithPriority(scheduler.exports.unstable_LowPriority, function () {
      return runAllValidations(values).then(function (combinedErrors) {
        if (!!isMounted.current) {
          dispatch({
            type: 'SET_ERRORS',
            payload: combinedErrors
          });
        }

        return combinedErrors;
      })["catch"](function (actualException) {
        if (process.env.NODE_ENV !== 'production') {
          // Users can throw during validate, however they have no way of handling their error on touch / blur. In low priority, we need to handle it
          console.warn("Warning: An unhandled error was caught during low priority validation in <Formik validate />", actualException);
        }
      });
    });
  }); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });

        if (!reactFastCompare(state.errors, combinedErrors)) {
          dispatch({
            type: 'SET_ERRORS',
            payload: combinedErrors
          });
        }
      }

      return combinedErrors;
    });
  });
  var resetForm = React.useCallback(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  React.useEffect(function () {
    if (isMounted.current === true && !reactFastCompare(initialValues.current, props.initialValues)) {
      initialValues.current = props.initialValues;

      if (enableReinitialize) {
        resetForm();
      }

      if (validateOnMount) {
        validateFormWithLowPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithLowPriority]);
  React.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  React.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  React.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = React.useCallback(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = React.useCallback(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithLowPriority(state.values) : Promise.resolve();
  });
  var setErrors = React.useCallback(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    dispatch({
      type: 'SET_VALUES',
      payload: values
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithLowPriority(values) : Promise.resolve();
  });
  var setFieldError = React.useCallback(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithLowPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = React.useCallback(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && process.env.NODE_ENV !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : !!multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithLowPriority(state.values) : Promise.resolve();
  });
  var executeBlur = React.useCallback(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && process.env.NODE_ENV !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = React.useCallback(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = React.useCallback(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = React.useCallback(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.


    if (process.env.NODE_ENV !== "production" && typeof document !== 'undefined') {
      // Safely get the active element (works with IE)
      var activeElement = getActiveElement();

      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem('type')) ? process.env.NODE_ENV !== "production" ? warning(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : warning(false) : void 0;
      }
    }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = React.useCallback(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = React.useCallback(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = React.useCallback(function (nameOrOptions) {
    var isAnObject = isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = React.useMemo(function () {
    return !reactFastCompare(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = React.useMemo(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends$p({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  React.useImperativeHandle(innerRef, function () {
    return formikbag;
  });

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      !!props.render ? process.env.NODE_ENV !== "production" ? warning(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : warning(false) : void 0; // eslint-disable-next-line
    }, []);
  }

  return React.createElement(FormikProvider, {
    value: formikbag
  }, component ? React.createElement(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? React.Children.only(children) : null : null);
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function (e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? deepmerge_1(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = deepmerge_1(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;

function useEventCallback(fn) {
  var ref = React.useRef(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

var Form =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose(props, ["action"]);

  var _action = action || '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return React.createElement("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';

/**
 * Some array helpers!
 */

var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};
var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};

var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends$p({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};

var FieldArrayInner =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FieldArrayInner, _React$Component);

  function FieldArrayInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
          name = _this$props.name,
          setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
        var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
        // otherwise it causes an error with unshift.

        var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;

        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }

        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }

        return _extends$p({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [cloneDeep(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      });

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    }; // We need TypeScript generics on these, so we'll bind them in the constructor
    // @todo Fix TS 3.2.1


    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FieldArrayInner.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!reactFastCompare(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name)) && this.props.formik.validateOnChange) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };

  _proto.remove = function remove(index) {
    // We need to make sure we also remove relevant pieces of `touched` and `errors`
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var copy = array ? copyArrayLike(array) : [];

      if (!result) {
        result = copy[index];
      }

      if (isFunction(copy.splice)) {
        copy.splice(index, 1);
      }

      return copy;
    }, true, true);
    return result;
  };

  _proto.pop = function pop() {
    // Remove relevant pieces of `touched` and `errors` too!
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var tmp = array;

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _this$props2 = this.props,
        component = _this$props2.component,
        render = _this$props2.render,
        children = _this$props2.children,
        name = _this$props2.name,
        _this$props2$formik = _this$props2.formik,
        restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, ["validate", "validationSchema"]);

    var props = _extends$p({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? React.createElement(component, props) : render ? render(props) : children // children come last, always called
    ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? React.Children.only(children) : null : null;
  };

  return FieldArrayInner;
}(React.Component);

FieldArrayInner.defaultProps = {
  validateOnChange: true
};

var css_248z$1 = ".password-change-form {\n  width: 440px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.password-change-form__buttons {\n  margin-top: 24px;\n}";
styleInject(css_248z$1);

var validationSchema = create$1().shape({
    currentPass: ValidationRules.required,
    newPass: ValidationRules.password,
    newPassRepeat: create$3()
        .oneOf([create$4('newPass'), ''], "Passwords don't match")
        .required('Required')
});
var PasswordChangeForm = function (_a) {
    var onSubmit = _a.onSubmit, onCancel = _a.onCancel, className = _a.className;
    return (React__default["default"].createElement(Formik, { initialValues: {
            currentPass: '',
            newPass: '',
            newPassRepeat: ''
        }, validationSchema: validationSchema, onSubmit: function (values) {
            onSubmit(values.newPass);
        } }, function (_a) {
        var values = _a.values, handleSubmit = _a.handleSubmit, touched = _a.touched, errors = _a.errors, handleChange = _a.handleChange, setFieldTouched = _a.setFieldTouched;
        return (React__default["default"].createElement("form", { className: "password-change-form ".concat(className !== null && className !== void 0 ? className : '') },
            React__default["default"].createElement(Typography, { variant: "h3" }, "Change Password"),
            React__default["default"].createElement(TextInput, { type: "password", value: values.currentPass, name: "currentPass", label: "Current password", error: touched.currentPass && !!errors.currentPass, helperText: (touched.currentPass && errors.currentPass) || '', onChange: handleChange('currentPass'), onBlur: function () { return setFieldTouched('currentPass'); } }),
            React__default["default"].createElement(TextInput, { type: "password", value: values.newPass, name: "newPass", label: "New password", error: touched.newPass && !!errors.newPass, helperText: (touched.newPass && errors.newPass) || '', onChange: handleChange('newPass'), onBlur: function () { return setFieldTouched('newPass'); } }),
            React__default["default"].createElement(TextInput, { type: "password", value: values.newPassRepeat, name: "newPassRepeat", label: "New password repeat", error: touched.newPassRepeat && !!errors.newPassRepeat, helperText: (touched.newPassRepeat && errors.newPassRepeat) || '', onChange: handleChange('newPassRepeat'), onBlur: function () { return setFieldTouched('newPassRepeat'); } }),
            React__default["default"].createElement(CancelConfirmButtons, { className: "password-change-form__buttons", onCancel: onCancel, onConfirm: handleSubmit, confirmText: "Change password" })));
    }));
};

var css_248z = "/* WebKit and Opera browsers */\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -webkit-transform: perspective(400px) rotateY(-360deg);\n  }\n}\n/* all other browsers */\n@keyframes spinner {\n  from {\n    -moz-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n  }\n  to {\n    -moz-transform: perspective(400px) rotateY(-360deg);\n    -ms-transform: perspective(400px) rotateY(-360deg);\n    transform: perspective(400px) rotateY(-360deg);\n  }\n}\n@keyframes shake-horizontal {\n  2% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  4% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  6% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  8% {\n    transform: translate(-2px, 0) rotate(0);\n  }\n  10% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  12% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  14% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  16% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  18% {\n    transform: translate(9px, 0) rotate(0);\n  }\n  20% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  22% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  24% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  26% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  28% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  30% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  32% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  34% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  36% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  38% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  40% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  42% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  44% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  46% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  48% {\n    transform: translate(8px, 0) rotate(0);\n  }\n  50% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  52% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  54% {\n    transform: translate(3px, 0) rotate(0);\n  }\n  56% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  58% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  60% {\n    transform: translate(-9px, 0) rotate(0);\n  }\n  62% {\n    transform: translate(-4px, 0) rotate(0);\n  }\n  64% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  66% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  68% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  70% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  72% {\n    transform: translate(5px, 0) rotate(0);\n  }\n  74% {\n    transform: translate(-7px, 0) rotate(0);\n  }\n  76% {\n    transform: translate(6px, 0) rotate(0);\n  }\n  78% {\n    transform: translate(-6px, 0) rotate(0);\n  }\n  80% {\n    transform: translate(4px, 0) rotate(0);\n  }\n  82% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  84% {\n    transform: translate(-3px, 0) rotate(0);\n  }\n  86% {\n    transform: translate(2px, 0) rotate(0);\n  }\n  88% {\n    transform: translate(-1px, 0) rotate(0);\n  }\n  90% {\n    transform: translate(1px, 0) rotate(0);\n  }\n  92% {\n    transform: translate(-5px, 0) rotate(0);\n  }\n  94% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  96% {\n    transform: translate(0px, 0) rotate(0);\n  }\n  98% {\n    transform: translate(-8px, 0) rotate(0);\n  }\n  0%, 100% {\n    transform: translate(0, 0) rotate(0);\n  }\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.01);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.difficult-words {\n  display: flex;\n  position: relative;\n  width: 100%;\n  flex: 1 0 auto;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #f3f7ff;\n}\n@media (max-width: 600px) {\n  .difficult-words {\n    padding: 4px 4px 16px;\n  }\n}\n.difficult-words__content {\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: center;\n}\n.difficult-words__words {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin-bottom: 80px;\n}\n.difficult-words__words p {\n  margin: 4px 0;\n}\n.difficult-words__score-color--wrong {\n  color: #e80f62 !important;\n  animation: shake-horizontal 330ms normal;\n}\n.difficult-words__score-color--ok {\n  color: #d3ab05 !important;\n}\n.difficult-words__score-color--great {\n  color: #5cb57b !important;\n}\n.difficult-words__listen-button {\n  position: absolute;\n  top: 28px;\n  right: 80px;\n}\n@media (max-width: 600px) {\n  .difficult-words__listen-button {\n    top: 16px;\n    right: 10px;\n  }\n}\n.difficult-words__finish {\n  position: absolute;\n  bottom: 28px;\n  right: 80px;\n}\n.difficult-words__finish svg {\n  width: 20px;\n  height: 20px;\n  margin-left: 4px;\n}\n@media (max-width: 600px) {\n  .difficult-words__finish {\n    bottom: 16px;\n    right: 10px;\n  }\n}";
styleInject(css_248z);

var DifficultWords = function (_a) {
    var country = _a.country, sanaApiUrl = _a.sanaApiUrl, getSanaScore = _a.getSanaScore, difficultWords = _a.difficultWords, onFinish = _a.onFinish;
    var _b = React.useState({
        mistakeCount: 0,
        recording: null,
        sanaRate: null
    }), state = _b[0], setState = _b[1];
    var listenSentenceRef = React.useRef(null);
    var wordsJoinedWithDots = React.useMemo(function () {
        return __spreadArray$1([], difficultWords, true).sort(function (a, b) { return b.score - a.score; })
            .map(function (v) { return v.word; })
            .join('. ');
    }, [difficultWords]);
    var handleRecording = React.useCallback(function (recording) { return __awaiter(void 0, void 0, void 0, function () {
        var data_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getSanaScore({ audio: recording, phrase: wordsJoinedWithDots })];
                case 1:
                    data_1 = (_a.sent()).data;
                    setState(function (state) { return (__assign$1(__assign$1({}, state), { sanaRate: data_1, recording: recording })); });
                    rate(data_1);
                    return [3 /*break*/, 3];
                case 2:
                    _a.sent();
                    setState(function (state) { return (__assign$1(__assign$1({}, state), { recording: recording })); });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [wordsJoinedWithDots]);
    var onStartRecording = React.useCallback(function () {
        var _a;
        (_a = listenSentenceRef.current) === null || _a === void 0 ? void 0 : _a.stopPlaying();
        setState(function (state) { return (__assign$1(__assign$1({}, state), { recording: null, sanaRate: null })); });
    }, []);
    var rate = React.useCallback(function (data) {
        var word_scores = data.word_scores;
        if (word_scores.every(function (score) { return score.score > 75; })) {
            onFinish();
        }
        else {
            setState(function (state) { return (__assign$1(__assign$1({}, state), { mistakeCount: state.mistakeCount + 1 })); });
        }
    }, [onFinish]);
    var renderWords = function () {
        var sanaRate = state.sanaRate;
        if (sanaRate && sanaRate.word_scores && sanaRate.word_scores.length > 0) {
            return sanaRate.word_scores.map(function (word, i) {
                var color = word.score > 75 ? 'great' : word.score < 60 ? 'wrong' : 'ok';
                return (React__default["default"].createElement(Typography, { key: "".concat(word.word).concat(i), variant: "exerciseL", className: "difficult-words__score-color--".concat(color) }, word.word.replace('.', '')));
            });
        }
        return wordsJoinedWithDots.split('. ').map(function (word, i) { return (React__default["default"].createElement(Typography, { key: "".concat(word).concat(i), variant: "exerciseL" }, word)); });
    };
    React.useEffect(function () {
        setState({
            mistakeCount: 0,
            recording: null,
            sanaRate: null
        });
    }, [difficultWords]);
    return (React__default["default"].createElement("div", { className: "difficult-words" },
        React__default["default"].createElement("div", { className: "difficult-words__listen-button" },
            React__default["default"].createElement(ListenSentence, { ref: listenSentenceRef, sentence: wordsJoinedWithDots, country: country, sanaApiUrl: sanaApiUrl, jump: state.mistakeCount !== 0 && state.mistakeCount % 3 === 0 })),
        React__default["default"].createElement("div", { className: "difficult-words__content" },
            React__default["default"].createElement("div", { className: "difficult-words__words" }, renderWords()),
            React__default["default"].createElement(AudioRecorder, { onStopRecording: handleRecording, onStartRecording: onStartRecording })),
        state.mistakeCount > 2 && (React__default["default"].createElement(Button, { onClick: onFinish, className: "difficult-words__finish" },
            "Finish ",
            React__default["default"].createElement(SvgArrowRight, null)))));
};

var _g$3;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var SvgAstridLogoBlue = function SvgAstridLogoBlue(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$o({
    width: "300px",
    height: "76px",
    viewBox: "0 0 300 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React__namespace.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    id: "logo/blue",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-1",
    fill: "#001593",
    points: "189.758735 75.5753149 209.199895 75.5753149 209.199895 27.5576074 189.758735 27.5576074"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-2",
    fill: "#001593",
    points: "114.323057 75.5753149 133.764216 75.5753149 133.764216 14.371415 114.323057 14.371415"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-3",
    fill: "#001593",
    points: "105.322582 42.6815072 142.76469 42.6815072 142.76469 27.5609802 105.322582 27.5609802"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 0.893470)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M209.866709,11.2338129 C209.866709,16.9997154 205.191926,21.674498 199.426024,21.674498 C193.660121,21.674498 188.985339,16.9997154 188.985339,11.2338129 C188.985339,5.46791041 193.660121,0.7931278 199.426024,0.7931278 C205.191926,0.7931278 209.866709,5.46791041 209.866709,11.2338129",
    id: "Fill-4",
    fill: "#001593"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M299.224369,65.0933123 C299.224369,70.8592148 294.549586,75.5339974 288.783684,75.5339974 C283.017781,75.5339974 278.342999,70.8592148 278.342999,65.0933123 C278.342999,59.3274097 283.017781,54.6526271 288.783684,54.6526271 C294.549586,54.6526271 299.224369,59.3274097 299.224369,65.0933123",
    id: "Fill-6",
    fill: "#001593"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M83.0746983,40.052195 C83.0746983,39.2460817 83.8201001,38.0402846 86.3767273,38.0402846 C87.8877681,38.0402846 91.0144084,38.5597049 93.9791515,39.6339605 L93.9740922,39.6289012 C94.0735916,39.6660026 94.1646588,39.7014177 94.2590988,39.7368327 C94.793697,39.9392042 95.319863,40.1567536 95.8291647,40.3945402 C97.4616285,41.1433149 98.406029,41.8313781 99.5662925,42.6863979 C99.6118261,42.7184401 99.6523004,42.7521686 99.6910883,42.7858972 L99.6910883,27.5709302 C96.921971,27.4697444 91.8087167,25.6568327 85.6313254,25.6568327 C71.6778076,25.6568327 63.7954361,31.2945665 63.7954361,41.6627352 C63.7954361,56.5623399 82.6480316,57.3667668 82.6480316,60.9909038 C82.6480316,61.7970171 82.1168063,62.8021291 79.9851594,62.8021291 C77.3121686,62.8021291 72.3135916,61.4411805 68.2459236,59.5574387 C65.5611278,58.4545138 64.4885586,57.744527 63.1562793,56.8018129 L63.1562793,73.1719842 C66.0333281,73.1719842 74.1281897,75.8888221 80.7305613,75.8888221 C95.2169908,75.8888221 102.14147,69.0436047 102.14147,59.6822345 C102.14147,44.7843162 83.0746983,43.5751462 83.0746983,40.052195",
    id: "Fill-8",
    fill: "#001593"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-10",
    fill: "#001593",
    points: "38.0272991 74.683531 57.4684585 74.683531 57.4684585 26.6658235 38.0272991 26.6658235"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M28.984664,41.3136443 C23.8157576,41.3136443 19.6249802,45.5044216 19.6249802,50.6750145 C19.6249802,55.8456074 23.8157576,60.0380711 28.984664,60.0380711 C34.1552569,60.0380711 38.3460343,55.8456074 38.3460343,50.6750145 C38.3460343,45.5044216 34.1552569,41.3136443 28.984664,41.3136443 M46.4442688,50.6750145 C46.4442688,64.4042372 36.0457444,75.5346719 23.2221344,75.5346719 C10.3968379,75.5346719 0,64.4042372 0,50.6750145 C0,36.9457918 10.3968379,25.8170435 23.2221344,25.8170435 C36.0457444,25.8170435 46.4442688,36.9457918 46.4442688,50.6750145",
    id: "Fill-12",
    fill: "#001593"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-13",
    fill: "#001593",
    points: "252.020026 74.683531 271.461186 74.683531 271.461186 0.792621871 252.020026 0.792621871"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M242.978403,41.3136443 C237.809497,41.3136443 233.617033,45.5044216 233.617033,50.6750145 C233.617033,55.8456074 237.809497,60.0380711 242.978403,60.0380711 C248.14731,60.0380711 252.338087,55.8456074 252.338087,50.6750145 C252.338087,45.5044216 248.14731,41.3136443 242.978403,41.3136443 M260.436321,50.6750145 C260.436321,64.4042372 250.039484,75.5346719 237.215874,75.5346719 C224.390577,75.5346719 213.993739,64.4042372 213.993739,50.6750145 C213.993739,36.9457918 224.390577,25.8170435 237.215874,25.8170435 C250.039484,25.8170435 260.436321,36.9457918 260.436321,50.6750145",
    id: "Fill-14",
    fill: "#001593"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M177.029903,43.1063188 C179.67591,43.1063188 182.225792,44.2075573 184.050509,45.9648169 L184.050509,26.2521423 C184.050509,26.2521423 182.770509,25.6568327 180.215568,25.6568327 C173.291088,25.6568327 168.354909,29.2253175 166.113644,35.3234466 L166.113644,26.6636311 L148.473592,26.6636311 L148.473592,74.6813386 L167.914751,74.6813386 L167.914751,52.9314572 C167.914751,46.966556 171.99591,43.1063188 177.029903,43.1063188",
    id: "Fill-15",
    fill: "#001593"
  })))))));
};

var _defs$2, _g$2;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var SvgAstridLogoWhite = function SvgAstridLogoWhite(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$n({
    width: "300px",
    height: "76px",
    viewBox: "0 0 300 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs$2 || (_defs$2 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "path-1",
    points: "0 75.8893281 299.224875 75.8893281 299.224875 0.792621871 0 0.792621871"
  }))), _g$2 || (_g$2 = /*#__PURE__*/React__namespace.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    id: "logo/white",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "189.758735 75.5753149 209.199895 75.5753149 209.199895 27.5576074 189.758735 27.5576074"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-2",
    fill: "#FFFFFF",
    points: "114.323057 75.5753149 133.764216 75.5753149 133.764216 14.371415 114.323057 14.371415"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-3",
    fill: "#FFFFFF",
    points: "105.322582 42.6815072 142.76469 42.6815072 142.76469 27.5609802 105.322582 27.5609802"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 0.893470)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M209.866709,11.2338129 C209.866709,16.9997154 205.191926,21.674498 199.426024,21.674498 C193.660121,21.674498 188.985339,16.9997154 188.985339,11.2338129 C188.985339,5.46791041 193.660121,0.7931278 199.426024,0.7931278 C205.191926,0.7931278 209.866709,5.46791041 209.866709,11.2338129",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M299.224369,65.0933123 C299.224369,70.8592148 294.549586,75.5339974 288.783684,75.5339974 C283.017781,75.5339974 278.342999,70.8592148 278.342999,65.0933123 C278.342999,59.3274097 283.017781,54.6526271 288.783684,54.6526271 C294.549586,54.6526271 299.224369,59.3274097 299.224369,65.0933123",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M83.0746983,40.052195 C83.0746983,39.2460817 83.8201001,38.0402846 86.3767273,38.0402846 C87.8877681,38.0402846 91.0144084,38.5597049 93.9791515,39.6339605 L93.9740922,39.6289012 C94.0735916,39.6660026 94.1646588,39.7014177 94.2590988,39.7368327 C94.793697,39.9392042 95.319863,40.1567536 95.8291647,40.3945402 C97.4616285,41.1433149 98.406029,41.8313781 99.5662925,42.6863979 C99.6118261,42.7184401 99.6523004,42.7521686 99.6910883,42.7858972 L99.6910883,27.5709302 C96.921971,27.4697444 91.8087167,25.6568327 85.6313254,25.6568327 C71.6778076,25.6568327 63.7954361,31.2945665 63.7954361,41.6627352 C63.7954361,56.5623399 82.6480316,57.3667668 82.6480316,60.9909038 C82.6480316,61.7970171 82.1168063,62.8021291 79.9851594,62.8021291 C77.3121686,62.8021291 72.3135916,61.4411805 68.2459236,59.5574387 C65.5611278,58.4545138 64.4885586,57.744527 63.1562793,56.8018129 L63.1562793,73.1719842 C66.0333281,73.1719842 74.1281897,75.8888221 80.7305613,75.8888221 C95.2169908,75.8888221 102.14147,69.0436047 102.14147,59.6822345 C102.14147,44.7843162 83.0746983,43.5751462 83.0746983,40.052195",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFFFFF",
    points: "38.0272991 74.683531 57.4684585 74.683531 57.4684585 26.6658235 38.0272991 26.6658235"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M28.984664,41.3136443 C23.8157576,41.3136443 19.6249802,45.5044216 19.6249802,50.6750145 C19.6249802,55.8456074 23.8157576,60.0380711 28.984664,60.0380711 C34.1552569,60.0380711 38.3460343,55.8456074 38.3460343,50.6750145 C38.3460343,45.5044216 34.1552569,41.3136443 28.984664,41.3136443 M46.4442688,50.6750145 C46.4442688,64.4042372 36.0457444,75.5346719 23.2221344,75.5346719 C10.3968379,75.5346719 0,64.4042372 0,50.6750145 C0,36.9457918 10.3968379,25.8170435 23.2221344,25.8170435 C36.0457444,25.8170435 46.4442688,36.9457918 46.4442688,50.6750145",
    id: "Fill-12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-13",
    fill: "#FFFFFF",
    points: "252.020026 74.683531 271.461186 74.683531 271.461186 0.792621871 252.020026 0.792621871"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M242.978403,41.3136443 C237.809497,41.3136443 233.617033,45.5044216 233.617033,50.6750145 C233.617033,55.8456074 237.809497,60.0380711 242.978403,60.0380711 C248.14731,60.0380711 252.338087,55.8456074 252.338087,50.6750145 C252.338087,45.5044216 248.14731,41.3136443 242.978403,41.3136443 M260.436321,50.6750145 C260.436321,64.4042372 250.039484,75.5346719 237.215874,75.5346719 C224.390577,75.5346719 213.993739,64.4042372 213.993739,50.6750145 C213.993739,36.9457918 224.390577,25.8170435 237.215874,25.8170435 C250.039484,25.8170435 260.436321,36.9457918 260.436321,50.6750145",
    id: "Fill-14",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M177.029903,43.1063188 C179.67591,43.1063188 182.225792,44.2075573 184.050509,45.9648169 L184.050509,26.2521423 C184.050509,26.2521423 182.770509,25.6568327 180.215568,25.6568327 C173.291088,25.6568327 168.354909,29.2253175 166.113644,35.3234466 L166.113644,26.6636311 L148.473592,26.6636311 L148.473592,74.6813386 L167.914751,74.6813386 L167.914751,52.9314572 C167.914751,46.966556 171.99591,43.1063188 177.029903,43.1063188",
    id: "Fill-15",
    fill: "#FFFFFF"
  })))))));
};

var _defs$1, _g$1;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var SvgAstridLogoBlack = function SvgAstridLogoBlack(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$m({
    width: "300px",
    height: "76px",
    viewBox: "0 0 300 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs$1 || (_defs$1 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "path-1",
    points: "0 75.8893281 299.224875 75.8893281 299.224875 0.792621871 0 0.792621871"
  }))), _g$1 || (_g$1 = /*#__PURE__*/React__namespace.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    id: "logo/black",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-1",
    fill: "#0A0A0A",
    points: "189.758735 75.5753149 209.199895 75.5753149 209.199895 27.5576074 189.758735 27.5576074"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-2",
    fill: "#0A0A0A",
    points: "114.323057 75.5753149 133.764216 75.5753149 133.764216 14.371415 114.323057 14.371415"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-3",
    fill: "#0A0A0A",
    points: "105.322582 42.6815072 142.76469 42.6815072 142.76469 27.5609802 105.322582 27.5609802"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 0.893470)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M209.866709,11.2338129 C209.866709,16.9997154 205.191926,21.674498 199.426024,21.674498 C193.660121,21.674498 188.985339,16.9997154 188.985339,11.2338129 C188.985339,5.46791041 193.660121,0.7931278 199.426024,0.7931278 C205.191926,0.7931278 209.866709,5.46791041 209.866709,11.2338129",
    id: "Fill-4",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M299.224369,65.0933123 C299.224369,70.8592148 294.549586,75.5339974 288.783684,75.5339974 C283.017781,75.5339974 278.342999,70.8592148 278.342999,65.0933123 C278.342999,59.3274097 283.017781,54.6526271 288.783684,54.6526271 C294.549586,54.6526271 299.224369,59.3274097 299.224369,65.0933123",
    id: "Fill-6",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M83.0746983,40.052195 C83.0746983,39.2460817 83.8201001,38.0402846 86.3767273,38.0402846 C87.8877681,38.0402846 91.0144084,38.5597049 93.9791515,39.6339605 L93.9740922,39.6289012 C94.0735916,39.6660026 94.1646588,39.7014177 94.2590988,39.7368327 C94.793697,39.9392042 95.319863,40.1567536 95.8291647,40.3945402 C97.4616285,41.1433149 98.406029,41.8313781 99.5662925,42.6863979 C99.6118261,42.7184401 99.6523004,42.7521686 99.6910883,42.7858972 L99.6910883,27.5709302 C96.921971,27.4697444 91.8087167,25.6568327 85.6313254,25.6568327 C71.6778076,25.6568327 63.7954361,31.2945665 63.7954361,41.6627352 C63.7954361,56.5623399 82.6480316,57.3667668 82.6480316,60.9909038 C82.6480316,61.7970171 82.1168063,62.8021291 79.9851594,62.8021291 C77.3121686,62.8021291 72.3135916,61.4411805 68.2459236,59.5574387 C65.5611278,58.4545138 64.4885586,57.744527 63.1562793,56.8018129 L63.1562793,73.1719842 C66.0333281,73.1719842 74.1281897,75.8888221 80.7305613,75.8888221 C95.2169908,75.8888221 102.14147,69.0436047 102.14147,59.6822345 C102.14147,44.7843162 83.0746983,43.5751462 83.0746983,40.052195",
    id: "Fill-8",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React__namespace.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-10",
    fill: "#0A0A0A",
    mask: "url(#mask-2)",
    points: "38.0272991 74.683531 57.4684585 74.683531 57.4684585 26.6658235 38.0272991 26.6658235"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M28.984664,41.3136443 C23.8157576,41.3136443 19.6249802,45.5044216 19.6249802,50.6750145 C19.6249802,55.8456074 23.8157576,60.0380711 28.984664,60.0380711 C34.1552569,60.0380711 38.3460343,55.8456074 38.3460343,50.6750145 C38.3460343,45.5044216 34.1552569,41.3136443 28.984664,41.3136443 M46.4442688,50.6750145 C46.4442688,64.4042372 36.0457444,75.5346719 23.2221344,75.5346719 C10.3968379,75.5346719 0,64.4042372 0,50.6750145 C0,36.9457918 10.3968379,25.8170435 23.2221344,25.8170435 C36.0457444,25.8170435 46.4442688,36.9457918 46.4442688,50.6750145",
    id: "Fill-12",
    fill: "#0A0A0A",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React__namespace.createElement("polygon", {
    id: "Fill-13",
    fill: "#0A0A0A",
    mask: "url(#mask-2)",
    points: "252.020026 74.683531 271.461186 74.683531 271.461186 0.792621871 252.020026 0.792621871"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M242.978403,41.3136443 C237.809497,41.3136443 233.617033,45.5044216 233.617033,50.6750145 C233.617033,55.8456074 237.809497,60.0380711 242.978403,60.0380711 C248.14731,60.0380711 252.338087,55.8456074 252.338087,50.6750145 C252.338087,45.5044216 248.14731,41.3136443 242.978403,41.3136443 M260.436321,50.6750145 C260.436321,64.4042372 250.039484,75.5346719 237.215874,75.5346719 C224.390577,75.5346719 213.993739,64.4042372 213.993739,50.6750145 C213.993739,36.9457918 224.390577,25.8170435 237.215874,25.8170435 C250.039484,25.8170435 260.436321,36.9457918 260.436321,50.6750145",
    id: "Fill-14",
    fill: "#0A0A0A",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M177.029903,43.1063188 C179.67591,43.1063188 182.225792,44.2075573 184.050509,45.9648169 L184.050509,26.2521423 C184.050509,26.2521423 182.770509,25.6568327 180.215568,25.6568327 C173.291088,25.6568327 168.354909,29.2253175 166.113644,35.3234466 L166.113644,26.6636311 L148.473592,26.6636311 L148.473592,74.6813386 L167.914751,74.6813386 L167.914751,52.9314572 C167.914751,46.966556 171.99591,43.1063188 177.029903,43.1063188",
    id: "Fill-15",
    fill: "#0A0A0A",
    mask: "url(#mask-2)"
  })))))));
};

var _path$h;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$h || (_path$h = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"
  })));
};

var _path$g;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$g || (_path$g = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
  })));
};

var _g, _path$f, _path2$4, _path3$2, _defs;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var SvgEditCircle = function SvgEditCircle(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$j({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
    opacity: 0.96,
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#C6B0AA"
  }))), _path$f || (_path$f = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.2982 7.42292C19.7231 6.85903 18.7858 6.85903 18.2107 7.42292L17.9082 7.7142L20.5708 10.3208L20.821 10.0743C21.1123 9.79052 21.2729 9.41335 21.2729 9.0063C21.2729 8.59925 21.1123 8.22208 20.8248 7.93826L20.2982 7.42292Z",
    fill: "white"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.5713 9.01755L19.2339 11.6241L20.0368 10.8437L17.3742 8.23706L16.5713 9.01755Z",
    fill: "white"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.26222 17.1248L7 20.975L10.9323 19.7202L18.6998 12.1469L16.0372 9.54028L8.26222 17.1248Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("filter", {
    id: "filter0_i",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React__namespace.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React__namespace.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React__namespace.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React__namespace.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React__namespace.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React__namespace.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React__namespace.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
};

var _path$e;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$e || (_path$e = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"
  })));
};

var _path$d;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgFileSearch = function SvgFileSearch(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$d || (_path$d = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H13C12.59,21.75 12.2,21.44 11.86,21.1C11.53,20.77 11.25,20.4 11,20H6V4H13V9H18V10.18C18.71,10.34 19.39,10.61 20,11V8L14,2M20.31,18.9C21.64,16.79 21,14 18.91,12.68C16.8,11.35 14,12 12.69,14.08C11.35,16.19 12,18.97 14.09,20.3C15.55,21.23 17.41,21.23 18.88,20.32L22,23.39L23.39,22L20.31,18.9M16.5,19A2.5,2.5 0 0,1 14,16.5A2.5,2.5 0 0,1 16.5,14A2.5,2.5 0 0,1 19,16.5A2.5,2.5 0 0,1 16.5,19Z"
  })));
};

var _path$c;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$c || (_path$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z"
  })));
};

var _path$b;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$b || (_path$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21,12L14,5V9C7,10 4,15 3,20C5.5,16.5 9,14.9 14,14.9V19L21,12Z"
  })));
};

var _path$a;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$a || (_path$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"
  })));
};

var _path$9;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"
  })));
};

var _rect$3, _rect2$3, _rect3$3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgQrcodeAppStore = function SvgQrcodeAppStore(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27"
  }, props), /*#__PURE__*/React__namespace.createElement("g", null, /*#__PURE__*/React__namespace.createElement("rect", {
    style: {
      fill: "transparent"
    },
    width: 27,
    height: 27,
    x: 0,
    y: 0
  }), _rect$3 || (_rect$3 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 1
  })), _rect2$3 || (_rect2$3 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 2,
    y: 1
  })), _rect3$3 || (_rect3$3 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 6,
    y: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 1
  })), _rect18 || (_rect18 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 24,
    y: 1
  })), _rect19 || (_rect19 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 1
  })), _rect20 || (_rect20 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 2
  })), _rect21 || (_rect21 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 2
  })), _rect22 || (_rect22 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 2
  })), _rect23 || (_rect23 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 2
  })), _rect24 || (_rect24 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 2
  })), _rect25 || (_rect25 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 2
  })), _rect26 || (_rect26 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 2
  })), _rect27 || (_rect27 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 2
  })), _rect28 || (_rect28 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 2
  })), _rect29 || (_rect29 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 2
  })), _rect30 || (_rect30 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 3
  })), _rect31 || (_rect31 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 3
  })), _rect32 || (_rect32 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 3
  })), _rect33 || (_rect33 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 3
  })), _rect34 || (_rect34 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 3
  })), _rect35 || (_rect35 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 3
  })), _rect36 || (_rect36 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 3
  })), _rect37 || (_rect37 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 3
  })), _rect38 || (_rect38 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 3
  })), _rect39 || (_rect39 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 3
  })), _rect40 || (_rect40 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 3
  })), _rect41 || (_rect41 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 3
  })), _rect42 || (_rect42 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 3
  })), _rect43 || (_rect43 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 4
  })), _rect44 || (_rect44 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 4
  })), _rect45 || (_rect45 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 4
  })), _rect46 || (_rect46 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 4
  })), _rect47 || (_rect47 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 4
  })), _rect48 || (_rect48 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 4
  })), _rect49 || (_rect49 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 4
  })), _rect50 || (_rect50 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 4
  })), _rect51 || (_rect51 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 4
  })), _rect52 || (_rect52 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 4
  })), _rect53 || (_rect53 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 4
  })), _rect54 || (_rect54 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 4
  })), _rect55 || (_rect55 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 4
  })), _rect56 || (_rect56 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 5
  })), _rect57 || (_rect57 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 5
  })), _rect58 || (_rect58 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 5
  })), _rect59 || (_rect59 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 5
  })), _rect60 || (_rect60 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 5
  })), _rect61 || (_rect61 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 5
  })), _rect62 || (_rect62 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 5
  })), _rect63 || (_rect63 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 5
  })), _rect64 || (_rect64 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 5
  })), _rect65 || (_rect65 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 5
  })), _rect66 || (_rect66 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 5
  })), _rect67 || (_rect67 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 5
  })), _rect68 || (_rect68 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 5
  })), _rect69 || (_rect69 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 5
  })), _rect70 || (_rect70 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 5
  })), _rect71 || (_rect71 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 5
  })), _rect72 || (_rect72 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 5
  })), _rect73 || (_rect73 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 5
  })), _rect74 || (_rect74 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 6
  })), _rect75 || (_rect75 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 6
  })), _rect76 || (_rect76 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 6
  })), _rect77 || (_rect77 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 6
  })), _rect78 || (_rect78 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 6
  })), _rect79 || (_rect79 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 6
  })), _rect80 || (_rect80 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 6
  })), _rect81 || (_rect81 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 6
  })), _rect82 || (_rect82 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 7
  })), _rect83 || (_rect83 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 2,
    y: 7
  })), _rect84 || (_rect84 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 7
  })), _rect85 || (_rect85 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 7
  })), _rect86 || (_rect86 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 7
  })), _rect87 || (_rect87 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 6,
    y: 7
  })), _rect88 || (_rect88 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 7
  })), _rect89 || (_rect89 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 7
  })), _rect90 || (_rect90 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 7
  })), _rect91 || (_rect91 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 7
  })), _rect92 || (_rect92 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 7
  })), _rect93 || (_rect93 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 7
  })), _rect94 || (_rect94 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 7
  })), _rect95 || (_rect95 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 7
  })), _rect96 || (_rect96 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 7
  })), _rect97 || (_rect97 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 7
  })), _rect98 || (_rect98 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 7
  })), _rect99 || (_rect99 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 24,
    y: 7
  })), _rect100 || (_rect100 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 7
  })), _rect101 || (_rect101 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 8
  })), _rect102 || (_rect102 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 8
  })), _rect103 || (_rect103 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 8
  })), _rect104 || (_rect104 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 8
  })), _rect105 || (_rect105 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 9
  })), _rect106 || (_rect106 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 2,
    y: 9
  })), _rect107 || (_rect107 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 9
  })), _rect108 || (_rect108 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 9
  })), _rect109 || (_rect109 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 8,
    y: 9
  })), _rect110 || (_rect110 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 9
  })), _rect111 || (_rect111 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 9
  })), _rect112 || (_rect112 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 9
  })), _rect113 || (_rect113 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 9
  })), _rect114 || (_rect114 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 9
  })), _rect115 || (_rect115 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 9
  })), _rect116 || (_rect116 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 9
  })), _rect117 || (_rect117 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 9
  })), _rect118 || (_rect118 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 24,
    y: 9
  })), _rect119 || (_rect119 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 10
  })), _rect120 || (_rect120 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 10
  })), _rect121 || (_rect121 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 10
  })), _rect122 || (_rect122 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 8,
    y: 10
  })), _rect123 || (_rect123 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 10
  })), _rect124 || (_rect124 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 10
  })), _rect125 || (_rect125 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 10
  })), _rect126 || (_rect126 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 10
  })), _rect127 || (_rect127 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 10
  })), _rect128 || (_rect128 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 10
  })), _rect129 || (_rect129 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 18,
    y: 10
  })), _rect130 || (_rect130 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 10
  })), _rect131 || (_rect131 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 10
  })), _rect132 || (_rect132 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 11
  })), _rect133 || (_rect133 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 11
  })), _rect134 || (_rect134 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 11
  })), _rect135 || (_rect135 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 6,
    y: 11
  })), _rect136 || (_rect136 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 11
  })), _rect137 || (_rect137 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 8,
    y: 11
  })), _rect138 || (_rect138 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 11
  })), _rect139 || (_rect139 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 11
  })), _rect140 || (_rect140 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 11
  })), _rect141 || (_rect141 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 11
  })), _rect142 || (_rect142 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 11
  })), _rect143 || (_rect143 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 18,
    y: 11
  })), _rect144 || (_rect144 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 11
  })), _rect145 || (_rect145 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 11
  })), _rect146 || (_rect146 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 24,
    y: 11
  })), _rect147 || (_rect147 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 11
  })), _rect148 || (_rect148 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 12
  })), _rect149 || (_rect149 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 12
  })), _rect150 || (_rect150 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 12
  })), _rect151 || (_rect151 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 12
  })), _rect152 || (_rect152 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 12
  })), _rect153 || (_rect153 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 12
  })), _rect154 || (_rect154 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 12
  })), _rect155 || (_rect155 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 12
  })), _rect156 || (_rect156 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 12
  })), _rect157 || (_rect157 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 12
  })), _rect158 || (_rect158 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 12
  })), _rect159 || (_rect159 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 18,
    y: 12
  })), _rect160 || (_rect160 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 13
  })), _rect161 || (_rect161 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 2,
    y: 13
  })), _rect162 || (_rect162 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 13
  })), _rect163 || (_rect163 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 8,
    y: 13
  })), _rect164 || (_rect164 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 13
  })), _rect165 || (_rect165 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 13
  })), _rect166 || (_rect166 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 13
  })), _rect167 || (_rect167 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 13
  })), _rect168 || (_rect168 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 13
  })), _rect169 || (_rect169 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 13
  })), _rect170 || (_rect170 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 18,
    y: 13
  })), _rect171 || (_rect171 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 13
  })), _rect172 || (_rect172 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 13
  })), _rect173 || (_rect173 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 24,
    y: 13
  })), _rect174 || (_rect174 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 13
  })), _rect175 || (_rect175 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 14
  })), _rect176 || (_rect176 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 14
  })), _rect177 || (_rect177 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 6,
    y: 14
  })), _rect178 || (_rect178 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 8,
    y: 14
  })), _rect179 || (_rect179 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 14
  })), _rect180 || (_rect180 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 14
  })), _rect181 || (_rect181 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 14
  })), _rect182 || (_rect182 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 14
  })), _rect183 || (_rect183 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 14
  })), _rect184 || (_rect184 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 18,
    y: 14
  })), _rect185 || (_rect185 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 14
  })), _rect186 || (_rect186 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 14
  })), _rect187 || (_rect187 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 14
  })), _rect188 || (_rect188 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 14
  })), _rect189 || (_rect189 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 14
  })), _rect190 || (_rect190 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 15
  })), _rect191 || (_rect191 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 15
  })), _rect192 || (_rect192 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 15
  })), _rect193 || (_rect193 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 15
  })), _rect194 || (_rect194 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 15
  })), _rect195 || (_rect195 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 15
  })), _rect196 || (_rect196 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 15
  })), _rect197 || (_rect197 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 15
  })), _rect198 || (_rect198 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 15
  })), _rect199 || (_rect199 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 15
  })), _rect200 || (_rect200 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 2,
    y: 16
  })), _rect201 || (_rect201 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 16
  })), _rect202 || (_rect202 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 6,
    y: 16
  })), _rect203 || (_rect203 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 16
  })), _rect204 || (_rect204 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 16
  })), _rect205 || (_rect205 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 16
  })), _rect206 || (_rect206 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 16
  })), _rect207 || (_rect207 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 18,
    y: 16
  })), _rect208 || (_rect208 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 16
  })), _rect209 || (_rect209 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 16
  })), _rect210 || (_rect210 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 24,
    y: 16
  })), _rect211 || (_rect211 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 17
  })), _rect212 || (_rect212 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 2,
    y: 17
  })), _rect213 || (_rect213 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 17
  })), _rect214 || (_rect214 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 17
  })), _rect215 || (_rect215 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 17
  })), _rect216 || (_rect216 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 17
  })), _rect217 || (_rect217 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 17
  })), _rect218 || (_rect218 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 17
  })), _rect219 || (_rect219 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 17
  })), _rect220 || (_rect220 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 17
  })), _rect221 || (_rect221 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 18,
    y: 17
  })), _rect222 || (_rect222 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 17
  })), _rect223 || (_rect223 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 17
  })), _rect224 || (_rect224 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 17
  })), _rect225 || (_rect225 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 17
  })), _rect226 || (_rect226 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 17
  })), _rect227 || (_rect227 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 18
  })), _rect228 || (_rect228 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 18
  })), _rect229 || (_rect229 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 18
  })), _rect230 || (_rect230 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 18
  })), _rect231 || (_rect231 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 18
  })), _rect232 || (_rect232 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 18
  })), _rect233 || (_rect233 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 18
  })), _rect234 || (_rect234 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 18
  })), _rect235 || (_rect235 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 18
  })), _rect236 || (_rect236 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 18
  })), _rect237 || (_rect237 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 19
  })), _rect238 || (_rect238 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 2,
    y: 19
  })), _rect239 || (_rect239 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 19
  })), _rect240 || (_rect240 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 19
  })), _rect241 || (_rect241 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 19
  })), _rect242 || (_rect242 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 6,
    y: 19
  })), _rect243 || (_rect243 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 19
  })), _rect244 || (_rect244 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 19
  })), _rect245 || (_rect245 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 19
  })), _rect246 || (_rect246 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 19
  })), _rect247 || (_rect247 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 19
  })), _rect248 || (_rect248 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 19
  })), _rect249 || (_rect249 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 19
  })), _rect250 || (_rect250 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 19
  })), _rect251 || (_rect251 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 19
  })), _rect252 || (_rect252 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 19
  })), _rect253 || (_rect253 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 24,
    y: 19
  })), _rect254 || (_rect254 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 19
  })), _rect255 || (_rect255 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 20
  })), _rect256 || (_rect256 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 20
  })), _rect257 || (_rect257 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 20
  })), _rect258 || (_rect258 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 20
  })), _rect259 || (_rect259 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 20
  })), _rect260 || (_rect260 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 20
  })), _rect261 || (_rect261 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 20
  })), _rect262 || (_rect262 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 20
  })), _rect263 || (_rect263 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 24,
    y: 20
  })), _rect264 || (_rect264 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 21
  })), _rect265 || (_rect265 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 21
  })), _rect266 || (_rect266 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 21
  })), _rect267 || (_rect267 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 21
  })), _rect268 || (_rect268 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 21
  })), _rect269 || (_rect269 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 21
  })), _rect270 || (_rect270 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 21
  })), _rect271 || (_rect271 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 21
  })), _rect272 || (_rect272 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 21
  })), _rect273 || (_rect273 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 21
  })), _rect274 || (_rect274 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 18,
    y: 21
  })), _rect275 || (_rect275 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 21
  })), _rect276 || (_rect276 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 21
  })), _rect277 || (_rect277 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 21
  })), _rect278 || (_rect278 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 24,
    y: 21
  })), _rect279 || (_rect279 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 22
  })), _rect280 || (_rect280 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 22
  })), _rect281 || (_rect281 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 22
  })), _rect282 || (_rect282 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 22
  })), _rect283 || (_rect283 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 22
  })), _rect284 || (_rect284 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 22
  })), _rect285 || (_rect285 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 22
  })), _rect286 || (_rect286 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 22
  })), _rect287 || (_rect287 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 22
  })), _rect288 || (_rect288 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 22
  })), _rect289 || (_rect289 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 22
  })), _rect290 || (_rect290 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 22
  })), _rect291 || (_rect291 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 22
  })), _rect292 || (_rect292 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 22
  })), _rect293 || (_rect293 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 23
  })), _rect294 || (_rect294 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 23
  })), _rect295 || (_rect295 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 23
  })), _rect296 || (_rect296 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 23
  })), _rect297 || (_rect297 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 23
  })), _rect298 || (_rect298 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 23
  })), _rect299 || (_rect299 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 23
  })), _rect300 || (_rect300 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 23
  })), _rect301 || (_rect301 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 23
  })), _rect302 || (_rect302 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 23
  })), _rect303 || (_rect303 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 23
  })), _rect304 || (_rect304 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 23
  })), _rect305 || (_rect305 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 23
  })), _rect306 || (_rect306 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 23,
    y: 23
  })), _rect307 || (_rect307 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 23
  })), _rect308 || (_rect308 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 24
  })), _rect309 || (_rect309 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 24
  })), _rect310 || (_rect310 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 24
  })), _rect311 || (_rect311 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 24
  })), _rect312 || (_rect312 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 24
  })), _rect313 || (_rect313 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 24
  })), _rect314 || (_rect314 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 24
  })), _rect315 || (_rect315 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 24
  })), _rect316 || (_rect316 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 24
  })), _rect317 || (_rect317 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 24
  })), _rect318 || (_rect318 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 1,
    y: 25
  })), _rect319 || (_rect319 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 2,
    y: 25
  })), _rect320 || (_rect320 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 3,
    y: 25
  })), _rect321 || (_rect321 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 4,
    y: 25
  })), _rect322 || (_rect322 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 5,
    y: 25
  })), _rect323 || (_rect323 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 6,
    y: 25
  })), _rect324 || (_rect324 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 7,
    y: 25
  })), _rect325 || (_rect325 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 9,
    y: 25
  })), _rect326 || (_rect326 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 25
  })), _rect327 || (_rect327 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 14,
    y: 25
  })), _rect328 || (_rect328 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 16,
    y: 25
  })), _rect329 || (_rect329 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 25
  })), _rect330 || (_rect330 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 18,
    y: 25
  })), _rect331 || (_rect331 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 25
  })), _rect332 || (_rect332 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 25
  })), _rect333 || (_rect333 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 24,
    y: 25
  })), _rect334 || (_rect334 = /*#__PURE__*/React__namespace.createElement("rect", {
    width: 1,
    height: 1,
    x: 25,
    y: 25
  }))));
};

var _path$8;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgAppleStoreBadge = function SvgAppleStoreBadge(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$b({
    id: "livetype",
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.66407,
    height: 40,
    viewBox: "0 0 119.66407 40"
  }, props), /*#__PURE__*/React__namespace.createElement("g", null, /*#__PURE__*/React__namespace.createElement("g", null, /*#__PURE__*/React__namespace.createElement("g", null, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z",
    style: {
      fill: "#a6a6a6"
    }
  }), _path$8 || (_path$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z"
  }))), /*#__PURE__*/React__namespace.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M24.76888,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.31529,5.31529,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.962,10.962,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,24.76888,20.30068Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M22.03725,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63634,4.63634,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,22.03725,12.21089Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React__namespace.createElement("g", null, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M42.30227,27.13965h-4.7334l-1.13672,3.35645H34.42727l4.4834-12.418h2.083l4.4834,12.418H43.438ZM38.0591,25.59082h3.752l-1.84961-5.44727h-.05176Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M55.15969,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H48.4302v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.645,21.34766,55.15969,23.16406,55.15969,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30227,29.01563,53.24953,27.81934,53.24953,25.96973Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M65.12453,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418A3.21162,3.21162,0,0,1,61.312,21.34766C63.60988,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26711,29.01563,63.21438,27.81934,63.21438,25.96973Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M71.71047,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M86.065,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72609,30.6084,86.065,28.82617,86.065,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645S92.76027,27.93164,92.76027,25.96973Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M96.18606,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M109.3843,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10207,25.13477Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React__namespace.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, /*#__PURE__*/React__namespace.createElement("g", null, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M59.09377,8.437h.88867v6.26074h-.88867Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M79.23,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C82.12453,13.99463,82.563,13.42432,82.563,12.44434Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M84.66945,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915H87.605V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M93.51516,9.07373v1.1416h.97559v.74854h-.97559V13.2793c0,.47168.19434.67822.63672.67822a2.96657,2.96657,0,0,0,.33887-.02051v.74023a2.9155,2.9155,0,0,1-.4834.04541c-.98828,0-1.38184-.34766-1.38184-1.21582v-2.543h-.71484v-.74854h.71484V9.07373Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M95.70461,8.437h.88086v2.48145h.07031a1.3856,1.3856,0,0,1,1.373-.80664,1.48339,1.48339,0,0,1,1.55078,1.67871v2.90723H98.69v-2.688c0-.71924-.335-1.0835-.96289-1.0835a1.05194,1.05194,0,0,0-1.13379,1.1416v2.62988h-.88867Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M104.76125,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,100.73,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688h-3.17969v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,101.63527,12.03076Z",
    style: {
      fill: "#fff"
    }
  })))));
};

var _style, _metadata, _path$7, _path2$3, _path3$1, _path4$1, _path5$1, _path6$1, _path7$1, _path8, _path9, _path10, _path11;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgGooglePlayBadge = function SvgGooglePlayBadge(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$a({
    id: "Livello_1",
    xmlnsx: "&ns_extend;",
    xmlnsi: "&ns_ai;",
    xmlnsgraph: "&ns_graphs;",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5435.8 1604",
    style: {
      enableBackground: "new 0 0 5435.8 1604"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React__namespace.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#A6A6A6;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st8{opacity:0.2;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\n\t.st9{opacity:0.12;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\n\t.st10{opacity:0.25;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;enable-background:new    ;}\n")), _metadata || (_metadata = /*#__PURE__*/React__namespace.createElement("metadata", null, /*#__PURE__*/React__namespace.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React__namespace.createElement("slices", null), /*#__PURE__*/React__namespace.createElement("sliceSourceBounds", {
    bottomleftorigin: "true",
    height: 1604,
    width: 5435.8,
    x: -2656.9,
    y: -784
  })))), _path$7 || (_path$7 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "st0",
    d: "M5234.4,1604h-5033C90.4,1604,0,1513.6,0,1403.5v-1203C0,90,90.4,0,201.4,0h5033c110.9,0,201.4,90,201.4,200.5 v1203C5435.8,1513.6,5345.3,1604,5234.4,1604z"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "st1",
    d: "M5234.4,32.1c93.1,0,169.3,75.7,169.3,168.4v1203c0,92.7-75.7,168.4-169.3,168.4h-5033 c-93.1,0-169.3-75.7-169.3-168.4v-1203c0-92.7,75.7-168.4,169.3-168.4C201.4,32.1,5234.4,32.1,5234.4,32.1z M5234.4,0h-5033 C90.4,0,0,90.4,0,200.5v1203C0,1514,90.4,1604,201.4,1604h5033c110.9,0,201.4-90,201.4-200.5v-1203C5435.8,90.4,5345.3,0,5234.4,0z"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "st2",
    d: "M2863.6,530.6c-36.3,0-66.9-12.7-91.1-37.7c-24-24.3-37.4-57.8-36.8-92c0-36.5,12.4-67.4,36.8-91.9 c24.1-25,54.7-37.7,91-37.7c35.9,0,66.5,12.7,91.1,37.7c24.4,25.3,36.8,56.2,36.8,91.9c-0.4,36.6-12.8,67.5-36.8,91.9 C2930.5,518,2899.9,530.6,2863.6,530.6z M1783.5,530.6c-35.5,0-66.3-12.5-91.5-37.2c-25-24.6-37.7-55.7-37.7-92.4 s12.7-67.8,37.7-92.4c24.7-24.7,55.5-37.2,91.5-37.2c17.6,0,34.7,3.5,51.1,10.6c16.1,6.9,29.2,16.3,38.9,27.8l2.4,2.9l-27.1,26.6 l-2.8-3.3c-15.3-18.2-35.8-27.1-62.9-27.1c-24.2,0-45.3,8.6-62.7,25.6c-17.5,17.1-26.4,39.5-26.4,66.6s8.9,49.5,26.4,66.6 c17.4,17,38.5,25.6,62.7,25.6c25.8,0,47.5-8.6,64.4-25.6c10-10,16.2-24,18.4-41.7h-86.9v-37.4h124.2l0.5,3.4 c0.9,6.3,1.8,12.8,1.8,18.8c0,34.5-10.4,62.4-31,83C1851.1,518.2,1820.5,530.6,1783.5,530.6z M3219.6,525.3h-38.3L3064,337.6l1,33.8 v153.8h-38.3V276.7h43.7l1.2,1.9l110.3,176.8l-1-33.7V276.7h38.7V525.3z M2575.8,525.3H2537V314.1h-67.3v-37.4H2643v37.4h-67.3 V525.3z M2438.1,525.3h-38.7V276.7h38.7V525.3z M2220.6,525.3h-38.7V314.1h-67.3v-37.4h173.3v37.4h-67.3V525.3z M2090.1,524.9 h-148.4V276.7h148.4v37.4h-109.6v68.2h98.9v37h-98.9v68.2h109.6V524.9z M2800.9,467.2c17.3,17.3,38.3,26,62.7,26 c25.1,0,45.6-8.5,62.7-26c17-17,25.6-39.3,25.6-66.2s-8.6-49.3-25.5-66.2c-17.3-17.3-38.4-26-62.7-26c-25.1,0-45.6,8.5-62.6,26 c-17,17-25.6,39.3-25.6,66.2S2784,450.3,2800.9,467.2L2800.9,467.2z"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "st3",
    d: "M2732.1,872.4c-94.5,0-171.1,71.7-171.1,170.6c0,98,77.1,170.6,171.1,170.6c94.5,0,171.1-72.2,171.1-170.6 C2903.2,944.1,2826.6,872.4,2732.1,872.4z M2732.1,1146c-51.7,0-96.2-42.8-96.2-103.4c0-61.5,44.6-103.4,96.2-103.4 c51.7,0,96.2,41.9,96.2,103.4C2828.4,1103.6,2783.8,1146,2732.1,1146z M2358.8,872.4c-94.5,0-171.1,71.7-171.1,170.6 c0,98,77.1,170.6,171.1,170.6c94.5,0,171.1-72.2,171.1-170.6C2529.9,944.1,2453.2,872.4,2358.8,872.4z M2358.8,1146 c-51.7,0-96.2-42.8-96.2-103.4c0-61.5,44.6-103.4,96.2-103.4c51.7,0,96.2,41.9,96.2,103.4C2455,1103.6,2410.5,1146,2358.8,1146z  M1914.6,924.5v72.2h173.3c-5.3,40.5-18.7,70.4-39.2,90.9c-25.4,25.4-64.6,53-133.7,53c-106.5,0-189.8-86-189.8-192.5 s83.3-192.5,189.8-192.5c57.5,0,99.4,22.7,130.5,51.7l51.2-51.2c-43.2-41.4-100.7-73.1-181.3-73.1c-146.1,0-268.7,119-268.7,264.7 c0,146.1,122.5,264.7,268.7,264.7c78.9,0,138.1-25.8,184.9-74.4c47.7-47.7,62.8-115,62.8-169.3c0-16.9-1.3-32.1-4-45h-244.6 C1914.6,923.6,1914.6,924.5,1914.6,924.5z M3731.5,980.7c-14.3-38.3-57.5-108.7-146.1-108.7c-87.8,0-160.8,69.1-160.8,170.6 c0,95.8,72.2,170.6,169.3,170.6c78,0,123.4-47.7,142.1-75.7l-57.9-38.8c-19.2,28.5-45.9,47.2-83.8,47.2c-38.3,0-65.1-17.4-82.9-51.7 l228.1-94.5C3739.5,999.8,3731.5,980.7,3731.5,980.7z M3498.9,1037.7c-1.8-65.9,51.2-99.4,89.1-99.4c29.9,0,54.8,14.7,63.3,36.1 L3498.9,1037.7z M3313.6,1203h74.9V701.8h-74.9V1203z M3190.6,910.3h-2.7c-16.9-20.1-49-38.3-90-38.3 c-85.1,0-163.5,74.9-163.5,171.1c0,95.8,78,169.8,163.5,169.8c40.5,0,73.1-18.3,90-38.8h2.7v24.5c0,65.1-34.8,100.2-90.9,100.2 c-45.9,0-74.4-33-86-60.6l-65.1,27.2c18.7,45,68.6,100.7,151,100.7c87.8,0,162.2-51.7,162.2-177.8V882.2h-70.8v28.1 C3191.1,910.3,3190.6,910.3,3190.6,910.3z M3104.6,1146c-51.7,0-94.9-43.2-94.9-102.9c0-60.2,43.2-103.8,94.9-103.8 c51.2,0,90.9,44.1,90.9,103.8C3196,1102.8,3155.9,1146,3104.6,1146z M4082.2,701.8h-179.1V1203h74.9v-189.8h104.3 c82.9,0,164.4-60.1,164.4-155.5S4165.5,701.8,4082.2,701.8z M4084.4,943.2h-106.5v-172h106.5c56.1,0,87.8,46.3,87.8,86 C4172.2,896.5,4140.1,943.2,4084.4,943.2z M4546.9,871.5c-54.4,0-110.5,24.1-133.7,76.6l66.4,27.6c14.3-27.6,40.5-37,68.2-37 c38.8,0,78,23.2,78.9,64.6v5.3c-13.4-7.6-42.8-19.2-78-19.2c-71.7,0-144.4,39.2-144.4,112.7c0,67.3,58.8,110.5,124.3,110.5 c50.3,0,78-22.7,95.3-49h2.7v38.8h72.2v-192C4698.8,921,4632.4,871.5,4546.9,871.5z M4537.5,1146c-24.5,0-58.8-12-58.8-42.8 c0-38.8,42.8-53.5,79.3-53.5c33,0,48.6,7.1,68.2,16.9C4620.8,1111.6,4582.8,1145.6,4537.5,1146z M4962.2,882.2l-86,217.4h-2.7 l-89.1-217.4h-80.6l133.7,303.9l-76.2,168.9h78L5045,882.2C5045,882.2,4962.2,882.2,4962.2,882.2z M4288,1203h74.9V701.8H4288V1203z "
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1682.1077,
    y1: 1339.4783,
    x2: 1624.2924,
    y2: 1309.6345,
    gradientTransform: "matrix(11.64 0 0 -22.55 -18705.5957 30554.3691)"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0.006569999,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path5$1 || (_path5$1 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "st4",
    d: "M418.4,302.1c-11.6,12.5-18.3,31.6-18.3,56.6v886.7c0,25,6.7,44.1,18.7,56.1l3.1,2.7l496.8-496.8v-11.1 L421.5,299.4C421.5,299.4,418.4,302.1,418.4,302.1z"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1712.6624,
    y1: 1274.8376,
    x2: 1606.5613,
    y2: 1274.8376,
    gradientTransform: "matrix(9.145 0 0 -7.7 -14305.5381 10618.251)"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path6$1 || (_path6$1 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "st5",
    d: "M1084,973.5L918.3,807.8v-11.6L1084,630.5l3.6,2.2l196,111.4c56.1,31.6,56.1,83.8,0,115.8l-196,111.4 C1087.6,971.3,1084,973.5,1084,973.5z"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1707.4414,
    y1: 1290.0475,
    x2: 1646.682,
    y2: 1211.2225,
    gradientTransform: "matrix(15.02 0 0 -11.5775 -24650.2285 15829.6484)"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path7$1 || (_path7$1 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "st6",
    d: "M1087.6,971.3L918.3,802l-499.9,499.9c18.3,19.6,49,21.8,83.3,2.7L1087.6,971.3"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1660.6357,
    y1: 1365.6676,
    x2: 1687.767,
    y2: 1330.4501,
    gradientTransform: "matrix(15.02 0 0 -11.5715 -24650.2285 15809.9922)"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "st7",
    d: "M1087.6,632.7L501.7,299.9c-34.3-19.6-65.1-16.9-83.3,2.7L918.3,802L1087.6,632.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "st8",
    d: "M1084,967.7l-581.9,330.6c-32.5,18.7-61.5,17.4-80.2,0.4l-3.1,3.1l3.1,2.7c18.7,16.9,47.7,18.3,80.2-0.4 L1088,971.3C1088,971.3,1084,967.7,1084,967.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "st9",
    d: "M1283.6,854.1l-200.1,113.6l3.6,3.6l196-111.4c28.1-16,41.9-37,41.9-57.9C1323.3,821.2,1309,839.4,1283.6,854.1 z"
  })), _path11 || (_path11 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "st10",
    d: "M501.7,305.7l781.9,444.2c25.4,14.3,39.7,33,41.9,52.1c0-20.9-13.8-41.9-41.9-57.9L501.7,299.9 c-56.1-32.1-101.6-5.3-101.6,58.8v5.8C400.1,300.3,445.6,274,501.7,305.7z"
  })));
};

var _path$6;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgAppleLogo = function SvgAppleLogo(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$9({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "814px",
    height: "1000px",
    viewBox: "0 0 814 1000",
    enableBackground: "new 0 0 814 1000",
    xmlSpace: "preserve"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M788.1,340.9c-5.8,4.5-108.2,62.2-108.2,190.5c0,148.4,130.3,200.9,134.2,202.2c-0.6,3.2-20.7,71.9-68.7,141.9 c-42.8,61.6-87.5,123.1-155.5,123.1s-85.5-39.5-164-39.5c-76.5,0-103.7,40.8-165.9,40.8s-105.6-57-155.5-127 C46.7,790.7,0,663,0,541.8c0-194.4,126.4-297.5,250.8-297.5c66.1,0,121.2,43.4,162.7,43.4c39.5,0,101.1-46,176.3-46 C618.3,241.7,720.7,244.3,788.1,340.9z M554.1,159.4c31.1-36.9,53.1-88.1,53.1-139.3c0-7.1-0.6-14.3-1.9-20.1 c-50.6,1.9-110.8,33.7-147.1,75.8c-28.5,32.4-55.1,83.6-55.1,135.5c0,7.8,1.3,15.6,1.9,18.1c3.2,0.6,8.4,1.3,13.6,1.3 C464,230.7,521.1,200.3,554.1,159.4z"
  })));
};

var _circle$3, _path$5;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgFacebookLogo = function SvgFacebookLogo(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1365.12,
    height: 1365.12,
    viewBox: "0 0 14222 14222"
  }, props), _circle$3 || (_circle$3 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 7111,
    cy: 7112,
    r: 7111,
    fill: "#1977f3"
  })), _path$5 || (_path$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9879 9168l315-2056H8222V5778c0-562 275-1111 1159-1111h897V2917s-814-139-1592-139c-1624 0-2686 984-2686 2767v1567H4194v2056h1806v4969c362 57 733 86 1111 86s749-30 1111-86V9168z",
    fill: "#fff"
  })));
};

var _rect$2, _rect2$2, _rect3$2;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgLevelLow = function SvgLevelLow(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$7({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/React__namespace.createElement("rect", {
    y: 13,
    width: 10,
    height: 14,
    fill: "#5BCFFF"
  })), _rect2$2 || (_rect2$2 = /*#__PURE__*/React__namespace.createElement("rect", {
    x: 12,
    y: 7,
    width: 10,
    height: 20,
    fill: "#ECECEC"
  })), _rect3$2 || (_rect3$2 = /*#__PURE__*/React__namespace.createElement("rect", {
    x: 24,
    width: 10,
    height: 27,
    fill: "#ECECEC"
  })));
};

var _rect$1, _rect2$1, _rect3$1;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgLevelMedium = function SvgLevelMedium(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$6({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/React__namespace.createElement("rect", {
    y: 13,
    width: 10,
    height: 14,
    fill: "#5BCFFF"
  })), _rect2$1 || (_rect2$1 = /*#__PURE__*/React__namespace.createElement("rect", {
    x: 12,
    y: 7,
    width: 10,
    height: 20,
    fill: "#5BCFFF"
  })), _rect3$1 || (_rect3$1 = /*#__PURE__*/React__namespace.createElement("rect", {
    x: 24,
    width: 10,
    height: 27,
    fill: "#ECECEC"
  })));
};

var _rect, _rect2, _rect3;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgLevelHigh = function SvgLevelHigh(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$5({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React__namespace.createElement("rect", {
    y: 13,
    width: 10,
    height: 14,
    fill: "#5BCFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React__namespace.createElement("rect", {
    x: 12,
    y: 7,
    width: 10,
    height: 20,
    fill: "#5BCFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React__namespace.createElement("rect", {
    x: 24,
    width: 10,
    height: 27,
    fill: "#5BCFFF"
  })));
};

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$4({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM7.29 14.29L3.7 10.7C3.31 10.31 3.31 9.68 3.7 9.29C4.09 8.9 4.72 8.9 5.11 9.29L8 12.17L14.88 5.29C15.27 4.9 15.9 4.9 16.29 5.29C16.68 5.68 16.68 6.31 16.29 6.7L8.7 14.29C8.32 14.68 7.68 14.68 7.29 14.29Z",
    fill: "#5BCFFF"
  })));
};

var _path$3, _path2$2;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgGetReady = function SvgGetReady(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M34.3511 17.1756C34.3511 26.6614 26.6614 34.3511 17.1756 34.3511C7.68977 34.3511 0 26.6614 0 17.1756C0 7.68977 7.68977 0 17.1756 0C26.6614 0 34.3511 7.68977 34.3511 17.1756Z",
    fill: "#FFDC4A"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.4482 24.9045C13.9421 24.9045 14.3425 24.4974 14.3425 23.9953V19.1305H23.7161C24.7682 19.1398 25.2964 17.8991 24.5642 17.1687L21.6569 14.2886L24.5643 11.4084C25.2967 10.6774 24.7678 9.43724 23.7162 9.44659H13.1825C12.5419 9.44659 12.0225 9.96113 12.0225 10.5958V23.9953C12.0225 24.4974 12.4229 24.9045 12.9168 24.9045H13.4482Z",
    fill: "#AD8D07"
  })));
};

var _circle$2, _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgLearn = function SvgLearn(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 17.1756,
    cy: 17.1756,
    r: 17.1756,
    fill: "#FFDC4A"
  })), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.0627 17.9989C27.0593 17.9924 27.0577 17.9849 27.0543 17.9784C27.0533 17.9765 27.0505 17.9713 27.0486 17.9683C26.9253 17.6901 26.7789 17.4258 26.6097 17.1787C25.903 15.9138 24.5392 13.507 23.8755 12.5574C23.0577 11.3876 22.1046 10.3054 20.6809 10.3054C20.3669 10.3054 20.0381 10.3609 19.7044 10.47C18.6862 10.8041 17.6954 11.3418 17.3957 12.6479H16.9565C16.6568 11.3418 15.666 10.8041 14.6475 10.47C14.3141 10.3609 13.9854 10.3054 13.6713 10.3054C12.2473 10.3054 11.2945 11.3876 10.4764 12.5577C9.81271 13.5073 8.4492 15.9141 7.74216 17.1787C7.57297 17.4261 7.42656 17.6901 7.30326 17.9683C7.3017 17.9713 7.29889 17.9765 7.29764 17.9784C7.29421 17.9849 7.29265 17.992 7.28921 17.9989C7.02263 18.6125 6.87061 19.2911 6.87061 20.0073C6.87061 22.7076 8.98299 24.9047 11.5792 24.9047C13.0985 24.9047 14.4483 24.1491 15.3095 22.9836H19.0424C19.9039 24.1491 21.2534 24.9047 22.7727 24.9047C25.3689 24.9047 27.4813 22.7076 27.4813 20.0073C27.4813 19.2911 27.3293 18.6125 27.0627 17.9989ZM11.5792 23.2813C9.84331 23.2813 8.43141 21.8125 8.43141 20.0073C8.43141 18.2021 9.84331 16.7336 11.5792 16.7336C13.3148 16.7336 14.7267 18.2021 14.7267 20.0073C14.7267 21.8125 13.3148 23.2813 11.5792 23.2813ZM22.7727 23.2813C21.0371 23.2813 19.6252 21.8128 19.6252 20.0073C19.6252 18.2021 21.0371 16.7336 22.7727 16.7336C24.5086 16.7336 25.9205 18.2021 25.9205 20.0073C25.9205 21.8125 24.5086 23.2813 22.7727 23.2813Z",
    fill: "#AD8D07"
  })));
};

var _circle$1, _path$1, _path2$1, _path3, _path4, _path5, _path6, _path7;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgPractice = function SvgPractice(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#FFDC4A"
  })), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.32446 13.3044C9.32446 12.488 10.0881 11.8262 11.0301 11.8262H11.883C12.825 11.8262 13.5887 12.488 13.5887 13.3044V22.174C13.5887 22.9904 12.825 23.6523 11.883 23.6523H11.0301C10.0881 23.6523 9.32446 22.9904 9.32446 22.174V13.3044Z",
    fill: "#AD8D07"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.4114 13.3044C20.4114 12.488 21.1751 11.8262 22.1171 11.8262H22.9699C23.912 11.8262 24.6756 12.488 24.6756 13.3044V22.174C24.6756 22.9904 23.912 23.6523 22.9699 23.6523H22.1171C21.1751 23.6523 20.4114 22.9904 20.4114 22.174V13.3044Z",
    fill: "#AD8D07"
  })), _path3 || (_path3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.9699 15.5218C22.9699 14.7054 23.7336 14.0436 24.6756 14.0436H25.5285C26.4705 14.0436 27.2342 14.7054 27.2342 15.5218V19.9566C27.2342 20.773 26.4705 21.4349 25.5285 21.4349H24.6756C23.7336 21.4349 22.9699 20.773 22.9699 19.9566V15.5218Z",
    fill: "#AD8D07"
  })), _path4 || (_path4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6.76593 15.5218C6.76593 14.7054 7.52959 14.0436 8.47161 14.0436H9.32446C10.2665 14.0436 11.0301 14.7054 11.0301 15.5218V19.9566C11.0301 20.773 10.2665 21.4349 9.32446 21.4349H8.47161C7.52959 21.4349 6.76593 20.773 6.76593 19.9566V15.5218Z",
    fill: "#AD8D07"
  })), _path5 || (_path5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.91309 17.0001C5.91309 16.5919 6.29492 16.261 6.76593 16.261H10.1773C10.6483 16.261 11.0301 16.5919 11.0301 17.0001V18.4783C11.0301 18.8866 10.6483 19.2175 10.1773 19.2175H6.76593C6.29492 19.2175 5.91309 18.8866 5.91309 18.4783V17.0001Z",
    fill: "#AD8D07"
  })), _path6 || (_path6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.9699 17.0001C22.9699 16.5919 23.3518 16.261 23.8228 16.261H27.2342C27.7052 16.261 28.087 16.5919 28.087 17.0001V18.4783C28.087 18.8866 27.7052 19.2175 27.2342 19.2175H23.8228C23.3518 19.2175 22.9699 18.8866 22.9699 18.4783V17.0001Z",
    fill: "#AD8D07"
  })), _path7 || (_path7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.9699 16.261C23.912 16.261 24.6756 16.9228 24.6756 17.7392C24.6756 18.5556 23.912 19.2175 22.9699 19.2175L11.0301 19.2175C10.0881 19.2175 9.32446 18.5556 9.32446 17.7392C9.32446 16.9228 10.0881 16.261 11.0301 16.261H22.9699Z",
    fill: "#AD8D07"
  })));
};

var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgSpeakingChallenge = function SvgSpeakingChallenge(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 17.0149,
    cy: 17.0149,
    r: 17.0149,
    fill: "#FFDC4A"
  })), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17.4399 8.50708C16.0138 8.50644 14.6129 8.88334 13.3797 9.59948C12.1464 10.3156 11.1247 11.3455 10.4183 12.5844C9.71201 13.8233 9.34624 15.2271 9.35819 16.6532C9.37015 18.0793 9.75941 19.4768 10.4864 20.7037L9.40268 23.6852C9.3623 23.7962 9.34925 23.9152 9.36464 24.0323C9.38004 24.1494 9.42342 24.261 9.49111 24.3577C9.5588 24.4545 9.6488 24.5335 9.75351 24.5881C9.85821 24.6426 9.97452 24.6712 10.0926 24.6713C10.1783 24.671 10.2633 24.6561 10.3439 24.6272L13.3254 23.5427C14.3955 24.1766 15.5974 24.555 16.8376 24.6484C18.0778 24.7418 19.3228 24.5478 20.4758 24.0813C21.6287 23.6149 22.6585 22.8887 23.4848 21.9592C24.3112 21.0297 24.9119 19.922 25.2402 18.7224C25.5685 17.5228 25.6154 16.2636 25.3775 15.0429C25.1395 13.8221 24.6231 12.6728 23.8683 11.6843C23.1135 10.6958 22.1407 9.89481 21.0257 9.34373C19.9108 8.79266 18.6837 8.50635 17.4399 8.50708Z",
    fill: "#AD8D07"
  })), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.6609 18.7161C14.0252 18.7161 13.6345 19.3859 14.0766 19.8427C14.9273 20.7218 16.1196 21.2683 17.4395 21.2683C18.7593 21.2683 19.9516 20.7218 20.8023 19.8427C21.2444 19.3859 20.8538 18.7161 20.218 18.7161H14.6609Z",
    fill: "#FFDC4A"
  })));
};

var countries = [
	{
		name: "Afghanistan",
		code: "AF",
		callingCode: "+93",
		flagEmoji: "🇦🇫"
	},
	{
		name: "Åland Islands",
		code: "AX",
		callingCode: "+358",
		flagEmoji: "🇦🇽"
	},
	{
		name: "Albania",
		code: "AL",
		callingCode: "+355",
		flagEmoji: "🇦🇱"
	},
	{
		name: "Algeria",
		code: "DZ",
		callingCode: "+213",
		flagEmoji: "🇩🇿"
	},
	{
		name: "American Samoa",
		code: "AS",
		callingCode: "+1684",
		flagEmoji: "🇦🇸"
	},
	{
		name: "Andorra",
		code: "AD",
		callingCode: "+376",
		flagEmoji: "🇦🇩"
	},
	{
		name: "Angola",
		code: "AO",
		callingCode: "+244",
		flagEmoji: "🇦🇴"
	},
	{
		name: "Anguilla",
		code: "AI",
		callingCode: "+1264",
		flagEmoji: "🇦🇮"
	},
	{
		name: "Antigua and Barbuda",
		code: "AG",
		callingCode: "+1268",
		flagEmoji: "🇦🇬"
	},
	{
		name: "Argentina",
		code: "AR",
		callingCode: "+54",
		flagEmoji: "🇦🇷"
	},
	{
		name: "Armenia",
		code: "AM",
		callingCode: "+374",
		flagEmoji: "🇦🇲"
	},
	{
		name: "Aruba",
		code: "AW",
		callingCode: "+297",
		flagEmoji: "🇦🇼"
	},
	{
		name: "Australia",
		code: "AU",
		callingCode: "+61",
		flagEmoji: "🇦🇺"
	},
	{
		name: "Austria",
		code: "AT",
		callingCode: "+43",
		flagEmoji: "🇦🇹"
	},
	{
		name: "Azerbaijan",
		code: "AZ",
		callingCode: "+994",
		flagEmoji: "🇦🇿"
	},
	{
		name: "Bahamas",
		code: "BS",
		callingCode: "+1242",
		flagEmoji: "🇧🇸"
	},
	{
		name: "Bahrain",
		code: "BH",
		callingCode: "+973",
		flagEmoji: "🇧🇭"
	},
	{
		name: "Bangladesh",
		code: "BD",
		callingCode: "+880",
		flagEmoji: "🇧🇩"
	},
	{
		name: "Barbados",
		code: "BB",
		callingCode: "+1246",
		flagEmoji: "🇧🇧"
	},
	{
		name: "Belarus",
		code: "BY",
		callingCode: "+375",
		flagEmoji: "🇧🇾"
	},
	{
		name: "Belgium",
		code: "BE",
		callingCode: "+32",
		flagEmoji: "🇧🇪"
	},
	{
		name: "Belize",
		code: "BZ",
		callingCode: "+501",
		flagEmoji: "🇧🇿"
	},
	{
		name: "Benin",
		code: "BJ",
		callingCode: "+229",
		flagEmoji: "🇧🇯"
	},
	{
		name: "Bermuda",
		code: "BM",
		callingCode: "+1441",
		flagEmoji: "🇧🇲"
	},
	{
		name: "Bhutan",
		code: "BT",
		callingCode: "+975",
		flagEmoji: "🇧🇹"
	},
	{
		name: "Bolivia",
		code: "BO",
		callingCode: "+591",
		flagEmoji: "🇧🇴"
	},
	{
		name: "Bosnia and Herzegovina",
		code: "BA",
		callingCode: "+387",
		flagEmoji: "🇧🇦"
	},
	{
		name: "Botswana",
		code: "BW",
		callingCode: "+267",
		flagEmoji: "🇧🇼"
	},
	{
		name: "Brazil",
		code: "BR",
		callingCode: "+55",
		flagEmoji: "🇧🇷"
	},
	{
		name: "British Indian Ocean Territory",
		code: "IO",
		callingCode: "+246",
		flagEmoji: "🇮🇴"
	},
	{
		name: "British Virgin Islands",
		code: "VG",
		callingCode: "+1284",
		flagEmoji: "🇻🇬"
	},
	{
		name: "Brunei",
		code: "BN",
		callingCode: "+673",
		flagEmoji: "🇧🇳"
	},
	{
		name: "Bulgaria",
		code: "BG",
		callingCode: "+359",
		flagEmoji: "🇧🇬"
	},
	{
		name: "Burkina Faso",
		code: "BF",
		callingCode: "+226",
		flagEmoji: "🇧🇫"
	},
	{
		name: "Burundi",
		code: "BI",
		callingCode: "+257",
		flagEmoji: "🇧🇮"
	},
	{
		name: "Cambodia",
		code: "KH",
		callingCode: "+855",
		flagEmoji: "🇰🇭"
	},
	{
		name: "Cameroon",
		code: "CM",
		callingCode: "+237",
		flagEmoji: "🇨🇲"
	},
	{
		name: "Canada",
		code: "CA",
		callingCode: "+1",
		flagEmoji: "🇨🇦"
	},
	{
		name: "Cape Verde",
		code: "CV",
		callingCode: "+238",
		flagEmoji: "🇮🇨"
	},
	{
		name: "Cayman Islands",
		code: "KY",
		callingCode: "+1345",
		flagEmoji: "🇰🇾"
	},
	{
		name: "Central African Republic",
		code: "CF",
		callingCode: "+236",
		flagEmoji: "🇨🇫"
	},
	{
		name: "Chad",
		code: "TD",
		callingCode: "+235",
		flagEmoji: "🇹🇩"
	},
	{
		name: "Chile",
		code: "CL",
		callingCode: "+56",
		flagEmoji: "🇨🇱"
	},
	{
		name: "China",
		code: "CN",
		callingCode: "+86",
		flagEmoji: "🇨🇳"
	},
	{
		name: "Christmas Island",
		code: "CX",
		callingCode: "+61",
		flagEmoji: "🇨🇽"
	},
	{
		name: "Cocos (Kneeling) Islands",
		code: "CC",
		callingCode: "+61",
		flagEmoji: "🇨🇨"
	},
	{
		name: "Colombia",
		code: "CO",
		callingCode: "+57",
		flagEmoji: "🇨🇴"
	},
	{
		name: "Comoros",
		code: "KM",
		callingCode: "+269",
		flagEmoji: "🇰🇲"
	},
	{
		name: "Congo",
		code: "CG",
		callingCode: "+242",
		flagEmoji: "🇨🇬"
	},
	{
		name: "Congo (DRC)",
		code: "CD",
		callingCode: "+243",
		flagEmoji: "🇨🇩"
	},
	{
		name: "Cook Islands",
		code: "CK",
		callingCode: "+682",
		flagEmoji: "🇨🇰"
	},
	{
		name: "Costa Rica",
		code: "CR",
		callingCode: "+506",
		flagEmoji: "🇨🇷"
	},
	{
		name: "Côte d’Ivoire",
		code: "CI",
		callingCode: "+225",
		flagEmoji: "🇨🇮"
	},
	{
		name: "Croatia",
		code: "HR",
		callingCode: "+385",
		flagEmoji: "🇭🇷"
	},
	{
		name: "Cuba",
		code: "CU",
		callingCode: "+53",
		flagEmoji: "🇨🇺"
	},
	{
		name: "Cyprus",
		code: "CY",
		callingCode: "+357",
		flagEmoji: "🇨🇾"
	},
	{
		name: "Czech Republic",
		code: "CZ",
		callingCode: "+420",
		flagEmoji: "🇨🇿"
	},
	{
		name: "Denmark",
		code: "DK",
		callingCode: "+45",
		flagEmoji: "🇩🇰"
	},
	{
		name: "Djibouti",
		code: "DJ",
		callingCode: "+253",
		flagEmoji: "🇩🇯"
	},
	{
		name: "Dominica",
		code: "DM",
		callingCode: "+1767",
		flagEmoji: "🇩🇲"
	},
	{
		name: "Dominican Republic",
		code: "DO",
		callingCode: "+1",
		flagEmoji: "🇩🇴"
	},
	{
		name: "Ecuador",
		code: "EC",
		callingCode: "+593",
		flagEmoji: "🇪🇨"
	},
	{
		name: "Egypt",
		code: "EG",
		callingCode: "+20",
		flagEmoji: "🇪🇬"
	},
	{
		name: "El Salvador",
		code: "SV",
		callingCode: "+503",
		flagEmoji: "🇸🇻"
	},
	{
		name: "Equatorial Guinea",
		code: "GQ",
		callingCode: "+240",
		flagEmoji: "🇬🇶"
	},
	{
		name: "Eritrea",
		code: "ER",
		callingCode: "+291",
		flagEmoji: "🇪🇷"
	},
	{
		name: "Estonia",
		code: "EE",
		callingCode: "+372",
		flagEmoji: "🇪🇪"
	},
	{
		name: "Ethiopia",
		code: "ET",
		callingCode: "+251",
		flagEmoji: "🇪🇹"
	},
	{
		name: "Falkland Islands",
		code: "FK",
		callingCode: "+500",
		flagEmoji: "🇫🇰"
	},
	{
		name: "Faroe Islands",
		code: "FO",
		callingCode: "+298",
		flagEmoji: "🇫🇴"
	},
	{
		name: "Fiji",
		code: "FJ",
		callingCode: "+679",
		flagEmoji: "🇫🇯"
	},
	{
		name: "Finland",
		code: "FI",
		callingCode: "+358",
		flagEmoji: "🇫🇮"
	},
	{
		name: "France",
		code: "FR",
		callingCode: "+33",
		flagEmoji: "🇫🇷"
	},
	{
		name: "French Guiana",
		code: "GF",
		callingCode: "+594",
		flagEmoji: "🇬🇫"
	},
	{
		name: "French Polynesia",
		code: "PF",
		callingCode: "+689",
		flagEmoji: "🇵🇫"
	},
	{
		name: "Gabon",
		code: "GA",
		callingCode: "+241",
		flagEmoji: "🇬🇦"
	},
	{
		name: "Gambia",
		code: "GM",
		callingCode: "+220",
		flagEmoji: "🇬🇲"
	},
	{
		name: "Georgia",
		code: "GE",
		callingCode: "+995",
		flagEmoji: "🇬🇪"
	},
	{
		name: "Germany",
		code: "DE",
		callingCode: "+49",
		flagEmoji: "🇩🇪"
	},
	{
		name: "Ghana",
		code: "GH",
		callingCode: "+233",
		flagEmoji: "🇬🇭"
	},
	{
		name: "Gibraltar",
		code: "GI",
		callingCode: "+350",
		flagEmoji: "🇬🇮"
	},
	{
		name: "Greece",
		code: "GR",
		callingCode: "+30",
		flagEmoji: "🇬🇷"
	},
	{
		name: "Greenland",
		code: "GL",
		callingCode: "+299",
		flagEmoji: "🇬🇱"
	},
	{
		name: "Grenada",
		code: "GD",
		callingCode: "+1473",
		flagEmoji: "🇬🇩"
	},
	{
		name: "Guadeloupe",
		code: "GP",
		callingCode: "+590",
		flagEmoji: "🇬🇵"
	},
	{
		name: "Guam",
		code: "GU",
		callingCode: "+1671",
		flagEmoji: "🇬🇺"
	},
	{
		name: "Guatemala",
		code: "GT",
		callingCode: "+502",
		flagEmoji: "🇬🇹"
	},
	{
		name: "Guernsey",
		code: "GG",
		callingCode: "+44",
		flagEmoji: "🇬🇬"
	},
	{
		name: "Guinea",
		code: "GN",
		callingCode: "+224",
		flagEmoji: "🇬🇳"
	},
	{
		name: "Guinea-Bissau",
		code: "GW",
		callingCode: "+245",
		flagEmoji: "🇬🇼"
	},
	{
		name: "Guyana",
		code: "GY",
		callingCode: "+592",
		flagEmoji: "🇬🇾"
	},
	{
		name: "Haiti",
		code: "HT",
		callingCode: "+509",
		flagEmoji: "🇭🇹"
	},
	{
		name: "Honduras",
		code: "HN",
		callingCode: "+504",
		flagEmoji: "🇭🇳"
	},
	{
		name: "Hong Kong",
		code: "HK",
		callingCode: "+852",
		flagEmoji: "🇭🇰"
	},
	{
		name: "Hungary",
		code: "HU",
		callingCode: "+36",
		flagEmoji: "🇭🇺"
	},
	{
		name: "Iceland",
		code: "IS",
		callingCode: "+354",
		flagEmoji: "🇮🇸"
	},
	{
		name: "India",
		code: "IN",
		callingCode: "+91",
		flagEmoji: "🇮🇳"
	},
	{
		name: "Indonesia",
		code: "ID",
		callingCode: "+62",
		flagEmoji: "🇮🇩"
	},
	{
		name: "Iran",
		code: "IR",
		callingCode: "+98",
		flagEmoji: "🇮🇷"
	},
	{
		name: "Iraq",
		code: "IQ",
		callingCode: "+964",
		flagEmoji: "🇮🇶"
	},
	{
		name: "Ireland",
		code: "IE",
		callingCode: "+353",
		flagEmoji: "🇮🇪"
	},
	{
		name: "Isle of Man",
		code: "IM",
		callingCode: "+44",
		flagEmoji: "🇮🇲"
	},
	{
		name: "Israel",
		code: "IL",
		callingCode: "+972",
		flagEmoji: "🇮🇱"
	},
	{
		name: "Italy",
		code: "IT",
		callingCode: "+39",
		flagEmoji: "🇮🇹"
	},
	{
		name: "Jamaica",
		code: "JM",
		callingCode: "+1876",
		flagEmoji: "🇯🇲"
	},
	{
		name: "Japan",
		code: "JP",
		callingCode: "+81",
		flagEmoji: "🇯🇵"
	},
	{
		name: "Jersey",
		code: "JE",
		callingCode: "+44",
		flagEmoji: "🇯🇪"
	},
	{
		name: "Jordan",
		code: "JO",
		callingCode: "+962",
		flagEmoji: "🇯🇴"
	},
	{
		name: "Kazakhstan",
		code: "KZ",
		callingCode: "+7",
		flagEmoji: "🇰🇿"
	},
	{
		name: "Kenya",
		code: "KE",
		callingCode: "+254",
		flagEmoji: "🇰🇪"
	},
	{
		name: "Kiribati",
		code: "KI",
		callingCode: "+686",
		flagEmoji: "🇰🇮"
	},
	{
		name: "North Korea",
		code: "KP",
		callingCode: "+850",
		flagEmoji: "🇰🇵"
	},
	{
		name: "Kuwait",
		code: "KW",
		callingCode: "+965",
		flagEmoji: "🇰🇼"
	},
	{
		name: "Kyrgyzstan",
		code: "KG",
		callingCode: "+996",
		flagEmoji: "🇰🇬"
	},
	{
		name: "Laos",
		code: "LA",
		callingCode: "+856",
		flagEmoji: "🇱🇦"
	},
	{
		name: "Latvia",
		code: "LV",
		callingCode: "+371",
		flagEmoji: "🇱🇻"
	},
	{
		name: "Lebanon",
		code: "LB",
		callingCode: "+961",
		flagEmoji: "🇱🇧"
	},
	{
		name: "Lesotho",
		code: "LS",
		callingCode: "+266",
		flagEmoji: "🇱🇸"
	},
	{
		name: "Liberia",
		code: "LR",
		callingCode: "+231",
		flagEmoji: "🇱🇷"
	},
	{
		name: "Libya",
		code: "LY",
		callingCode: "+218",
		flagEmoji: "🇱🇾"
	},
	{
		name: "Liechtenstein",
		code: "LI",
		callingCode: "+423",
		flagEmoji: "🇱🇮"
	},
	{
		name: "Lithuania",
		code: "LT",
		callingCode: "+370",
		flagEmoji: "🇱🇹"
	},
	{
		name: "Luxembourg",
		code: "LU",
		callingCode: "+352",
		flagEmoji: "🇱🇺"
	},
	{
		name: "Macau",
		code: "MO",
		callingCode: "+853",
		flagEmoji: "🇲🇴"
	},
	{
		name: "Macedonia",
		code: "MK",
		callingCode: "+389",
		flagEmoji: "🇲🇰"
	},
	{
		name: "Madagascar",
		code: "MG",
		callingCode: "+261",
		flagEmoji: "🇲🇬"
	},
	{
		name: "Malawi",
		code: "MW",
		callingCode: "+265",
		flagEmoji: "🇲🇼"
	},
	{
		name: "Malaysia",
		code: "MY",
		callingCode: "+60",
		flagEmoji: "🇲🇾"
	},
	{
		name: "Maldives",
		code: "MV",
		callingCode: "+960",
		flagEmoji: "🇲🇻"
	},
	{
		name: "Mali",
		code: "ML",
		callingCode: "+223",
		flagEmoji: "🇲🇱"
	},
	{
		name: "Malta",
		code: "MT",
		callingCode: "+356",
		flagEmoji: "🇲🇹"
	},
	{
		name: "Marshall Islands",
		code: "MH",
		callingCode: "+692",
		flagEmoji: "🇲🇭"
	},
	{
		name: "Martinique",
		code: "MQ",
		callingCode: "+596",
		flagEmoji: "🇲🇶"
	},
	{
		name: "Mauritania",
		code: "MR",
		callingCode: "+222",
		flagEmoji: "🇲🇷"
	},
	{
		name: "Mauritius",
		code: "MU",
		callingCode: "+230",
		flagEmoji: "🇲🇺"
	},
	{
		name: "Mayotte",
		code: "YT",
		callingCode: "+262",
		flagEmoji: "🇾🇹"
	},
	{
		name: "Mexico",
		code: "MX",
		callingCode: "+52",
		flagEmoji: "🇲🇽"
	},
	{
		name: "Micronesia",
		code: "FM",
		callingCode: "+691",
		flagEmoji: "🇫🇲"
	},
	{
		name: "Moldova",
		code: "MD",
		callingCode: "+373",
		flagEmoji: "🇲🇩"
	},
	{
		name: "Monaco",
		code: "MC",
		callingCode: "+377",
		flagEmoji: "🇲🇨"
	},
	{
		name: "Mongolia",
		code: "MN",
		callingCode: "+976",
		flagEmoji: "🇲🇳"
	},
	{
		name: "Montenegro",
		code: "ME",
		callingCode: "+382",
		flagEmoji: "🇲🇪"
	},
	{
		name: "Montserrat",
		code: "MS",
		callingCode: "+1664",
		flagEmoji: "🇲🇸"
	},
	{
		name: "Morocco",
		code: "MA",
		callingCode: "+212",
		flagEmoji: "🇲🇦"
	},
	{
		name: "Mozambique",
		code: "MZ",
		callingCode: "+258",
		flagEmoji: "🇲🇿"
	},
	{
		name: "Myanmar",
		code: "MM",
		callingCode: "+95",
		flagEmoji: "🇲🇲"
	},
	{
		name: "Namibia",
		code: "NA",
		callingCode: "+264",
		flagEmoji: "🇳🇦"
	},
	{
		name: "Nauru",
		code: "NR",
		callingCode: "+674",
		flagEmoji: "🇳🇷"
	},
	{
		name: "Nepal",
		code: "NP",
		callingCode: "+977",
		flagEmoji: "🇳🇵"
	},
	{
		name: "Netherlands",
		code: "NL",
		callingCode: "+31",
		flagEmoji: "🇳🇱"
	},
	{
		name: "New Caledonia",
		code: "NC",
		callingCode: "+687",
		flagEmoji: "🇳🇨"
	},
	{
		name: "New Zealand",
		code: "NZ",
		callingCode: "+64",
		flagEmoji: "🇳🇿"
	},
	{
		name: "Nicaragua",
		code: "NI",
		callingCode: "+505",
		flagEmoji: "🇳🇮"
	},
	{
		name: "Niger",
		code: "NE",
		callingCode: "+227",
		flagEmoji: "🇳🇪"
	},
	{
		name: "Nigeria",
		code: "NG",
		callingCode: "+234",
		flagEmoji: "🇳🇬"
	},
	{
		name: "Niue",
		code: "NU",
		callingCode: "+683",
		flagEmoji: "🇳🇺"
	},
	{
		name: "Norfolk Island",
		code: "NF",
		callingCode: "+672",
		flagEmoji: "🇳🇫"
	},
	{
		name: "Northern Mariana Islands",
		code: "MP",
		callingCode: "+1670",
		flagEmoji: "🇲🇵"
	},
	{
		name: "Norway",
		code: "NO",
		callingCode: "+47",
		flagEmoji: "🇳🇴"
	},
	{
		name: "Oman",
		code: "OM",
		callingCode: "+968",
		flagEmoji: "🇴🇲"
	},
	{
		name: "Pakistan",
		code: "PK",
		callingCode: "+92",
		flagEmoji: "🇵🇰"
	},
	{
		name: "Palau",
		code: "PW",
		callingCode: "+680",
		flagEmoji: "🇵🇼"
	},
	{
		name: "Palestine",
		code: "PS",
		callingCode: "+970",
		flagEmoji: "🇵🇸"
	},
	{
		name: "Panama",
		code: "PA",
		callingCode: "+507",
		flagEmoji: "🇵🇦"
	},
	{
		name: "Papua New Guinea",
		code: "PG",
		callingCode: "+675",
		flagEmoji: "🇵🇬"
	},
	{
		name: "Paraguay",
		code: "PY",
		callingCode: "+595",
		flagEmoji: "🇵🇾"
	},
	{
		name: "Peru",
		code: "PE",
		callingCode: "+51",
		flagEmoji: "🇵🇪"
	},
	{
		name: "Philippines",
		code: "PH",
		callingCode: "+63",
		flagEmoji: "🇵🇭"
	},
	{
		name: "Poland",
		code: "PL",
		callingCode: "+48",
		flagEmoji: "🇵🇱"
	},
	{
		name: "Portugal",
		code: "PT",
		callingCode: "+351",
		flagEmoji: "🇵🇹"
	},
	{
		name: "Puerto Rico",
		code: "PR",
		callingCode: "+1",
		flagEmoji: "🇵🇷"
	},
	{
		name: "Qatar",
		code: "QA",
		callingCode: "+974",
		flagEmoji: "🇶🇦"
	},
	{
		name: "Réunion",
		code: "RE",
		callingCode: "+262",
		flagEmoji: "🇷🇪"
	},
	{
		name: "Romania",
		code: "RO",
		callingCode: "+40",
		flagEmoji: "🇷🇴"
	},
	{
		name: "Russia",
		code: "RU",
		callingCode: "+7",
		flagEmoji: "🇷🇺"
	},
	{
		name: "Rwanda",
		code: "RW",
		callingCode: "+250",
		flagEmoji: "🇷🇼"
	},
	{
		name: "Saint Helena",
		code: "SH",
		callingCode: "+290",
		flagEmoji: "🇸🇭"
	},
	{
		name: "Saint Kitts and Nevis",
		code: "KN",
		callingCode: "+1869",
		flagEmoji: "🇰🇳"
	},
	{
		name: "Saint Lucia",
		code: "LC",
		callingCode: "+1758",
		flagEmoji: "🇱🇨"
	},
	{
		name: "Saint Pierre and Miquelon",
		code: "PM",
		callingCode: "+508",
		flagEmoji: "🇵🇲"
	},
	{
		name: "Saint Vincent and the Grenadines",
		code: "VC",
		callingCode: "+1784",
		flagEmoji: "🇻🇨"
	},
	{
		name: "Samoa",
		code: "WS",
		callingCode: "+685",
		flagEmoji: "🇼🇸"
	},
	{
		name: "San Marino",
		code: "SM",
		callingCode: "+378",
		flagEmoji: "🇸🇲"
	},
	{
		name: "São Tomé and Príncipe",
		code: "ST",
		callingCode: "+239",
		flagEmoji: "🇸🇹"
	},
	{
		name: "Saudi Arabia",
		code: "SA",
		callingCode: "+966",
		flagEmoji: "🇸🇦"
	},
	{
		name: "Senegal",
		code: "SN",
		callingCode: "+221",
		flagEmoji: "🇸🇳"
	},
	{
		name: "Serbia",
		code: "RS",
		callingCode: "+381",
		flagEmoji: "🇷🇸"
	},
	{
		name: "Seychelles",
		code: "SC",
		callingCode: "+248",
		flagEmoji: "🇸🇨"
	},
	{
		name: "Sierra Leone",
		code: "SL",
		callingCode: "+232",
		flagEmoji: "🇸🇱"
	},
	{
		name: "Singapore",
		code: "SG",
		callingCode: "+65",
		flagEmoji: "🇸🇬"
	},
	{
		name: "Slovakia",
		code: "SK",
		callingCode: "+421",
		flagEmoji: "🇸🇰"
	},
	{
		name: "Slovenia",
		code: "SI",
		callingCode: "+386",
		flagEmoji: "🇸🇮"
	},
	{
		name: "Solomon Islands",
		code: "SB",
		callingCode: "+677",
		flagEmoji: "🇸🇧"
	},
	{
		name: "Somalia",
		code: "SO",
		callingCode: "+252",
		flagEmoji: "🇸🇴"
	},
	{
		name: "South Africa",
		code: "ZA",
		callingCode: "+27",
		flagEmoji: "🇿🇦"
	},
	{
		name: "South Korea",
		code: "KR",
		callingCode: "+82",
		flagEmoji: "🇰🇷"
	},
	{
		name: "Spain",
		code: "ES",
		callingCode: "+34",
		flagEmoji: "🇪🇸"
	},
	{
		name: "Sri Lanka",
		code: "LK",
		callingCode: "+94",
		flagEmoji: "🇱🇰"
	},
	{
		name: "Sudan",
		code: "SD",
		callingCode: "+249",
		flagEmoji: "🇸🇩"
	},
	{
		name: "Suriname",
		code: "SR",
		callingCode: "+597",
		flagEmoji: "🇸🇷"
	},
	{
		name: "Svalbard and Jan Mayen",
		code: "SJ",
		callingCode: "+47",
		flagEmoji: "🇸🇯"
	},
	{
		name: "Swaziland",
		code: "SZ",
		callingCode: "+268",
		flagEmoji: "🇸🇿"
	},
	{
		name: "Sweden",
		code: "SE",
		callingCode: "+46",
		flagEmoji: "🇸🇪"
	},
	{
		name: "Switzerland",
		code: "CH",
		callingCode: "+41",
		flagEmoji: "🇨🇭"
	},
	{
		name: "Syria",
		code: "SY",
		callingCode: "+963",
		flagEmoji: "🇸🇾"
	},
	{
		name: "Taiwan",
		code: "TW",
		callingCode: "+886",
		flagEmoji: "🇹🇼"
	},
	{
		name: "Tajikistan",
		code: "TJ",
		callingCode: "+992",
		flagEmoji: "🇹🇯 "
	},
	{
		name: "Tanzania",
		code: "TZ",
		callingCode: "+255",
		flagEmoji: "🇹🇿"
	},
	{
		name: "Thailand",
		code: "TH",
		callingCode: "+66",
		flagEmoji: "🇹🇭"
	},
	{
		name: "Timor-Leste",
		code: "TL",
		callingCode: "+670",
		flagEmoji: "🇹🇱"
	},
	{
		name: "Togo",
		code: "TG",
		callingCode: "+228",
		flagEmoji: "🇹🇬"
	},
	{
		name: "Tokelau",
		code: "TK",
		callingCode: "+690",
		flagEmoji: "🇹🇰"
	},
	{
		name: "Tonga",
		code: "TO",
		callingCode: "+676",
		flagEmoji: "🇹🇴"
	},
	{
		name: "Trinidad and Tobago",
		code: "TT",
		callingCode: "+1868",
		flagEmoji: "🇹🇹"
	},
	{
		name: "Tunisia",
		code: "TN",
		callingCode: "+216",
		flagEmoji: "🇹🇳"
	},
	{
		name: "Turkey",
		code: "TR",
		callingCode: "+90",
		flagEmoji: "🇹🇷"
	},
	{
		name: "Turkmenistan",
		code: "TM",
		callingCode: "+993",
		flagEmoji: "🇹🇲"
	},
	{
		name: "Turks and Caicos Islands",
		code: "TC",
		callingCode: "+1649",
		flagEmoji: "🇹🇨"
	},
	{
		name: "Tuvalu",
		code: "TV",
		callingCode: "+688",
		flagEmoji: "🇹🇻"
	},
	{
		name: "Uganda",
		code: "UG",
		callingCode: "+256",
		flagEmoji: "🇺🇬"
	},
	{
		name: "Ukraine",
		code: "UA",
		callingCode: "+380",
		flagEmoji: "🇺🇦"
	},
	{
		name: "United States",
		code: "US",
		callingCode: "+1",
		flagEmoji: "🇺🇸"
	},
	{
		name: "United Kingdom",
		code: "GB",
		callingCode: "+44",
		flagEmoji: "🇬🇧"
	},
	{
		name: "United Arab Emirates",
		code: "AE",
		callingCode: "+971",
		flagEmoji: "🇦🇪"
	},
	{
		name: "Uruguay",
		code: "UY",
		callingCode: "+598",
		flagEmoji: "🇺🇾"
	},
	{
		name: "Uzbekistan",
		code: "UZ",
		callingCode: "+998",
		flagEmoji: "🇺🇿"
	},
	{
		name: "Vanuatu",
		code: "VU",
		callingCode: "+678",
		flagEmoji: "🇻🇺"
	},
	{
		name: "Vatican City",
		code: "VA",
		callingCode: "+39",
		flagEmoji: "🇻🇦"
	},
	{
		name: "Venezuela",
		code: "VE",
		callingCode: "+58",
		flagEmoji: "🇻🇪"
	},
	{
		name: "Vietnam",
		code: "VN",
		callingCode: "+84",
		flagEmoji: "🇻🇳"
	},
	{
		name: "U.S. Virgin Islands",
		code: "VI",
		callingCode: "+1340",
		flagEmoji: "🇻🇮"
	},
	{
		name: "Wallis and Futuna",
		code: "WF",
		callingCode: "+681",
		flagEmoji: "🇼🇫"
	},
	{
		name: "Western Sahara",
		code: "EH",
		callingCode: "+212",
		flagEmoji: "🇪🇭"
	},
	{
		name: "Yemen",
		code: "YE",
		callingCode: "+967",
		flagEmoji: "🇾🇪"
	},
	{
		name: "Zambia",
		code: "ZM",
		callingCode: "+260",
		flagEmoji: "🇿🇲"
	},
	{
		name: "Zimbabwe",
		code: "ZW",
		callingCode: "+263",
		flagEmoji: "🇿🇼"
	}
];

function initHotjar(id) {
(function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
(h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: id, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

exports.A11CEFR = SvgA11;
exports.A12CEFR = SvgA12;
exports.A13CEFR = SvgA13;
exports.A21CEFR = SvgA21;
exports.A22CEFR = SvgA22;
exports.A23CEFR = SvgA23;
exports.AlertContext = AlertContext;
exports.AlertProvider = AlertProvider;
exports.AppStoreQRCode = SvgQrcodeAppStore;
exports.AppleLogo = SvgAppleLogo;
exports.AppleStoreBadge = SvgAppleStoreBadge;
exports.ArrowRight = SvgArrowRight;
exports.AstridLogo = SvgAstridLogoBlue;
exports.AstridLogoBlack = SvgAstridLogoBlack;
exports.AstridLogoWhite = SvgAstridLogoWhite;
exports.AudioRecorder = AudioRecorder;
exports.AvatarUpload = AvatarUpload;
exports.B11CEFR = SvgB11;
exports.B12CEFR = SvgB12;
exports.B13CEFR = SvgB13;
exports.B21CEFR = SvgB21;
exports.B22CEFR = SvgB22;
exports.B23CEFR = SvgB23;
exports.BookCarousel = BookCarousel;
exports.BookCover = BookCover;
exports.BuildingExercise = BuildingExercise$1;
exports.Button = Button;
exports.C1CEFR = SvgC1;
exports.CancelConfirmButtons = CancelConfirmButtons;
exports.Card = Card;
exports.CheckIcon = SvgCheckIcon;
exports.CheckmarkIcon = SvgCheck;
exports.ChevronDown = SvgChevronDown;
exports.ChevronRight = SvgChevronRight;
exports.Chip = Chip;
exports.ChipAvatar = ChipAvatar;
exports.ChipsFactory = ChipsFactory;
exports.CircularProgressBar = CircularProgressBar;
exports.CloseIcon = SvgClose;
exports.ComprehensionExercise = ComprehensionExercise$1;
exports.Countdown = Countdown;
exports.DeleteAccountConfirmation = DeleteAccountConfirmation;
exports.DemoBook = DemoBook;
exports.DifficultWords = DifficultWords;
exports.DownloadIcon = SvgDownload;
exports.EditCircleIcon = SvgEditCircle;
exports.EditIcon = SvgPencil;
exports.EmailIcon = SvgEmail;
exports.EmphasizedTypography = EmphasizedTypography;
exports.ErrorIcon = SvgError;
exports.ExerciseTransition = ExerciseTransition$1;
exports.FacebookLogo = SvgFacebookLogo;
exports.FileSearchIcon = SvgFileSearch;
exports.GA_customDimensions = GA_customDimensions;
exports.GA_event = event;
exports.GA_init = GA_init;
exports.GA_pageview = pageview;
exports.GetReadyIcon = SvgGetReady;
exports.GoogleButton = GoogleButton;
exports.GoogleLogo = SvgGoogleColor;
exports.GooglePlayBadge = SvgGooglePlayBadge;
exports.Headline = Headline;
exports.HelpIcon = SvgHelp;
exports.HelperText = HelperText;
exports.HighLevelIcon = SvgLevelHigh;
exports.LearnIcon = SvgLearn;
exports.ListenSentence = ListenSentence;
exports.ListeningExercise = ListeningExercise;
exports.ListeningIcon = SvgListeningExercise;
exports.LottieCharacter = LottieCharacter;
exports.LowLevelIcon = SvgLevelLow;
exports.MediumLevelIcon = SvgLevelMedium;
exports.MicrophoneIcon = SvgMicrophone;
exports.Modal = InvitationModal;
exports.OnboardingBook = OnboardingBook;
exports.PasswordChangeForm = PasswordChangeForm;
exports.PauseIcon = SvgPause;
exports.PermissionsPopup = PermissionsPopup;
exports.PlayIcon = SvgPlay;
exports.PracticeIcon = SvgPractice;
exports.ProfileIcon = SvgAccount;
exports.Rate = Rate;
exports.ReadingExercise = ReadingExercise$1;
exports.ReadingIcon = SvgReadingExercise;
exports.ReplayIcon = SvgReplay;
exports.Select = Select;
exports.ShareIcon = SvgShare;
exports.SkeletonLoader = SkeletonLoader;
exports.SoundEffectsConsumer = SoundEffectsConsumer;
exports.SoundEffectsContext = SoundEffectsContext;
exports.SoundEffectsProvider = SoundEffectsProvider;
exports.SpeakerIcon = SvgSpeaker;
exports.SpeakingChallengeIcon = SvgSpeakingChallenge;
exports.StarIcon = SvgStar;
exports.TextInput = TextInput;
exports.ThumbDown = SvgThumbDown;
exports.ThumbUp = SvgThumbUp;
exports.TiltingCard = TiltingCard;
exports.ToggleSwitch = ToggleSwitch;
exports.TwistedArrowIcon = SvgTwistedArrow;
exports.Typography = Typography;
exports.ValidationRules = ValidationRules;
exports.VerticalDotsIcon = SvgDotsVertical;
exports.WelcomeAnimation = WelcomeAnimation;
exports.WordRaceExercise = WordRaceExercise$1;
exports.countries = countries;
exports.initHotjar = initHotjar;
exports.sortBooksByCEFR = sortBooksByCEFR;
exports.useWindowSize = useWindowSize;
exports.withSoundEffectsContext = withSoundEffectsContext;
